//region block: polyfills
(function () {
  if (typeof globalThis === 'object')
    return;
  Object.defineProperty(Object.prototype, '__magic__', {get: function () {
    return this;
  }, configurable: true});
  __magic__.globalThis = __magic__;
  delete Object.prototype.__magic__;
}());
if (typeof Math.imul === 'undefined') {
  Math.imul = function imul(a, b) {
    return (a & 4.29490176E9) * (b & 65535) + (a & 65535) * (b | 0) | 0;
  };
}
if (typeof ArrayBuffer.isView === 'undefined') {
  ArrayBuffer.isView = function (a) {
    return a != null && a.__proto__ != null && a.__proto__.__proto__ === Int8Array.prototype.__proto__;
  };
}
if (typeof Array.prototype.fill === 'undefined') {
  // Polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/fill#Polyfill
  Object.defineProperty(Array.prototype, 'fill', {value: function (value) {
    // Steps 1-2.
    if (this == null) {
      throw new TypeError('this is null or not defined');
    }
    var O = Object(this); // Steps 3-5.
    var len = O.length >>> 0; // Steps 6-7.
    var start = arguments[1];
    var relativeStart = start >> 0; // Step 8.
    var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len); // Steps 9-10.
    var end = arguments[2];
    var relativeEnd = end === undefined ? len : end >> 0; // Step 11.
    var finalValue = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len); // Step 12.
    while (k < finalValue) {
      O[k] = value;
      k++;
    }
    ; // Step 13.
    return O;
  }});
}
[Int8Array, Int16Array, Uint16Array, Int32Array, Float32Array, Float64Array].forEach(function (TypedArray) {
  if (typeof TypedArray.prototype.fill === 'undefined') {
    Object.defineProperty(TypedArray.prototype, 'fill', {value: Array.prototype.fill});
  }
});
if (typeof Math.log10 === 'undefined') {
  Math.log10 = function (x) {
    return Math.log(x) * Math.LOG10E;
  };
}
if (typeof Math.clz32 === 'undefined') {
  Math.clz32 = function (log, LN2) {
    return function (x) {
      var asUint = x >>> 0;
      if (asUint === 0) {
        return 32;
      }
      return 31 - (log(asUint) / LN2 | 0) | 0; // the "| 0" acts like math.floor
    };
  }(Math.log, Math.LN2);
}
if (typeof Math.sign === 'undefined') {
  Math.sign = function (x) {
    x = +x; // convert to a number
    if (x === 0 || isNaN(x)) {
      return Number(x);
    }
    return x > 0 ? 1 : -1;
  };
}
if (typeof String.prototype.endsWith === 'undefined') {
  Object.defineProperty(String.prototype, 'endsWith', {value: function (searchString, position) {
    var subjectString = this.toString();
    if (position === undefined || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  }});
}
if (typeof String.prototype.startsWith === 'undefined') {
  Object.defineProperty(String.prototype, 'startsWith', {value: function (searchString, position) {
    position = position || 0;
    return this.lastIndexOf(searchString, position) === position;
  }});
}
//endregion
(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports'], factory);
  else if (typeof exports === 'object')
    factory(module.exports);
  else
    globalThis['org.jetbrains.biokb:editor-adapters'] = factory(typeof globalThis['org.jetbrains.biokb:editor-adapters'] === 'undefined' ? {} : globalThis['org.jetbrains.biokb:editor-adapters']);
}(function (_) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var isView = ArrayBuffer.isView;
  var clz32 = Math.clz32;
  var sign = Math.sign;
  var log10 = Math.log10;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(CharSequence, 'CharSequence');
  initMetadataForInterface(Comparable, 'Comparable');
  initMetadataForClass(Number_0, 'Number');
  initMetadataForInterface(Sequence, 'Sequence');
  initMetadataForClass(asSequence$$inlined$Sequence$1, VOID, VOID, VOID, [Sequence]);
  initMetadataForClass(asSequence$$inlined$Sequence$1_0, VOID, VOID, VOID, [Sequence]);
  initMetadataForClass(asIterable$$inlined$Iterable$1);
  initMetadataForClass(Exception, 'Exception', Exception_init_$Create$, Error);
  initMetadataForClass(RuntimeException, 'RuntimeException', RuntimeException_init_$Create$, Exception);
  initMetadataForClass(KotlinNothingValueException, 'KotlinNothingValueException', KotlinNothingValueException_init_$Create$, RuntimeException);
  initMetadataForCompanion(Companion);
  initMetadataForClass(Char, 'Char', VOID, VOID, [Comparable]);
  initMetadataForCompanion(Companion_0);
  initMetadataForInterface(Collection, 'Collection');
  function asJsReadonlyArrayView() {
    return createJsReadonlyArrayViewFrom(this);
  }
  initMetadataForInterface(KtList, 'List', VOID, VOID, [Collection]);
  initMetadataForInterface(KtSet, 'Set', VOID, VOID, [Collection]);
  initMetadataForInterface(MutableIterable, 'MutableIterable');
  initMetadataForInterface(MutableCollection, 'MutableCollection', VOID, VOID, [Collection, MutableIterable]);
  initMetadataForInterface(KtMutableSet, 'MutableSet', VOID, VOID, [KtSet, MutableCollection]);
  initMetadataForInterface(KtMutableList, 'MutableList', VOID, VOID, [KtList, MutableCollection]);
  initMetadataForInterface(Entry, 'Entry');
  initMetadataForInterface(MutableEntry, 'MutableEntry', VOID, VOID, [Entry]);
  initMetadataForInterface(KtMap, 'Map');
  initMetadataForInterface(KtMutableMap, 'MutableMap', VOID, VOID, [KtMap]);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(Enum, 'Enum', VOID, VOID, [Comparable]);
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(Long, 'Long', VOID, Number_0, [Number_0, Comparable]);
  initMetadataForInterface(FunctionAdapter, 'FunctionAdapter');
  initMetadataForClass(arrayIterator$1);
  initMetadataForClass(JsArrayView, 'JsArrayView', JsArrayView, Array);
  initMetadataForObject(ByteCompanionObject, 'ByteCompanionObject');
  initMetadataForObject(ShortCompanionObject, 'ShortCompanionObject');
  initMetadataForObject(IntCompanionObject, 'IntCompanionObject');
  initMetadataForObject(FloatCompanionObject, 'FloatCompanionObject');
  initMetadataForObject(DoubleCompanionObject, 'DoubleCompanionObject');
  initMetadataForObject(StringCompanionObject, 'StringCompanionObject');
  initMetadataForObject(BooleanCompanionObject, 'BooleanCompanionObject');
  initMetadataForObject(Digit, 'Digit');
  initMetadataForObject(Letter, 'Letter');
  initMetadataForObject(OtherLowercase, 'OtherLowercase');
  initMetadataForClass(AbstractCollection, 'AbstractCollection', VOID, VOID, [Collection]);
  initMetadataForClass(AbstractList, 'AbstractList', VOID, AbstractCollection, [AbstractCollection, KtList]);
  initMetadataForInterface(RandomAccess, 'RandomAccess');
  initMetadataForClass(asList$1, VOID, VOID, AbstractList, [AbstractList, RandomAccess]);
  initMetadataForInterface(Comparator, 'Comparator');
  initMetadataForObject(Unit, 'Unit');
  initMetadataForClass(AbstractMutableCollection, 'AbstractMutableCollection', VOID, AbstractCollection, [AbstractCollection, MutableCollection]);
  initMetadataForClass(IteratorImpl, 'IteratorImpl');
  initMetadataForClass(ListIteratorImpl, 'ListIteratorImpl', VOID, IteratorImpl);
  initMetadataForClass(AbstractMutableList, 'AbstractMutableList', VOID, AbstractMutableCollection, [AbstractMutableCollection, KtMutableList]);
  initMetadataForClass(SubList, 'SubList', VOID, AbstractMutableList, [AbstractMutableList, RandomAccess]);
  initMetadataForClass(AbstractMap, 'AbstractMap', VOID, VOID, [KtMap]);
  initMetadataForClass(AbstractMutableMap, 'AbstractMutableMap', VOID, AbstractMap, [AbstractMap, KtMutableMap]);
  initMetadataForClass(AbstractMutableSet, 'AbstractMutableSet', VOID, AbstractMutableCollection, [AbstractMutableCollection, KtMutableSet]);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(ArrayList, 'ArrayList', ArrayList_init_$Create$, AbstractMutableList, [AbstractMutableList, KtMutableList, RandomAccess]);
  initMetadataForClass(HashMap, 'HashMap', HashMap_init_$Create$, AbstractMutableMap, [AbstractMutableMap, KtMutableMap]);
  initMetadataForClass(HashMapKeys, 'HashMapKeys', VOID, AbstractMutableSet, [KtMutableSet, AbstractMutableSet]);
  initMetadataForClass(HashMapValues, 'HashMapValues', VOID, AbstractMutableCollection, [MutableCollection, AbstractMutableCollection]);
  initMetadataForClass(HashMapEntrySetBase, 'HashMapEntrySetBase', VOID, AbstractMutableSet, [KtMutableSet, AbstractMutableSet]);
  initMetadataForClass(HashMapEntrySet, 'HashMapEntrySet', VOID, HashMapEntrySetBase);
  initMetadataForClass(HashMapKeysDefault$iterator$1);
  initMetadataForClass(HashMapKeysDefault, 'HashMapKeysDefault', VOID, AbstractMutableSet);
  initMetadataForClass(HashMapValuesDefault$iterator$1);
  initMetadataForClass(HashMapValuesDefault, 'HashMapValuesDefault', VOID, AbstractMutableCollection);
  initMetadataForClass(HashSet, 'HashSet', HashSet_init_$Create$, AbstractMutableSet, [AbstractMutableSet, KtMutableSet]);
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(Itr, 'Itr');
  initMetadataForClass(KeysItr, 'KeysItr', VOID, Itr);
  initMetadataForClass(ValuesItr, 'ValuesItr', VOID, Itr);
  initMetadataForClass(EntriesItr, 'EntriesItr', VOID, Itr);
  initMetadataForClass(EntryRef, 'EntryRef', VOID, VOID, [MutableEntry]);
  function containsAllEntries(m) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(m, Collection)) {
        tmp = m.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = m.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlin.collections.InternalMap.containsAllEntries.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = element;
        var tmp_0;
        if (!(entry == null) ? isInterface(entry, Entry) : false) {
          tmp_0 = this.g9(entry);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  initMetadataForInterface(InternalMap, 'InternalMap');
  initMetadataForClass(InternalHashMap, 'InternalHashMap', InternalHashMap_init_$Create$, VOID, [InternalMap]);
  initMetadataForClass(LinkedHashMap, 'LinkedHashMap', LinkedHashMap_init_$Create$, HashMap, [HashMap, KtMutableMap]);
  initMetadataForObject(EmptyHolder, 'EmptyHolder');
  initMetadataForClass(LinkedHashSet, 'LinkedHashSet', LinkedHashSet_init_$Create$, HashSet, [HashSet, KtMutableSet]);
  initMetadataForClass(BaseOutput, 'BaseOutput');
  initMetadataForClass(NodeJsOutput, 'NodeJsOutput', VOID, BaseOutput);
  initMetadataForClass(BufferedOutput, 'BufferedOutput', BufferedOutput, BaseOutput);
  initMetadataForClass(BufferedOutputToConsoleLog, 'BufferedOutputToConsoleLog', BufferedOutputToConsoleLog, BufferedOutput);
  initMetadataForInterface(Continuation, 'Continuation');
  initMetadataForClass(InterceptedCoroutine, 'InterceptedCoroutine', VOID, VOID, [Continuation]);
  initMetadataForClass(CoroutineImpl, 'CoroutineImpl', VOID, InterceptedCoroutine, [InterceptedCoroutine, Continuation]);
  initMetadataForObject(CompletedContinuation, 'CompletedContinuation', VOID, VOID, [Continuation]);
  initMetadataForClass(IllegalStateException, 'IllegalStateException', IllegalStateException_init_$Create$, RuntimeException);
  initMetadataForClass(CancellationException, 'CancellationException', CancellationException_init_$Create$, IllegalStateException);
  initMetadataForClass(createCoroutineUnintercepted$$inlined$createCoroutineFromSuspendFunction$1, VOID, VOID, CoroutineImpl);
  initMetadataForClass(createSimpleCoroutineForSuspendFunction$1, VOID, VOID, CoroutineImpl);
  initMetadataForClass(IllegalArgumentException, 'IllegalArgumentException', IllegalArgumentException_init_$Create$, RuntimeException);
  initMetadataForClass(UnsupportedOperationException, 'UnsupportedOperationException', UnsupportedOperationException_init_$Create$, RuntimeException);
  initMetadataForClass(NoSuchElementException, 'NoSuchElementException', NoSuchElementException_init_$Create$, RuntimeException);
  initMetadataForClass(Error_0, 'Error', Error_init_$Create$, Error);
  initMetadataForClass(IndexOutOfBoundsException, 'IndexOutOfBoundsException', IndexOutOfBoundsException_init_$Create$, RuntimeException);
  initMetadataForClass(NumberFormatException, 'NumberFormatException', NumberFormatException_init_$Create$, IllegalArgumentException);
  initMetadataForClass(ArithmeticException, 'ArithmeticException', ArithmeticException_init_$Create$, RuntimeException);
  initMetadataForClass(NullPointerException, 'NullPointerException', NullPointerException_init_$Create$, RuntimeException);
  initMetadataForClass(AssertionError, 'AssertionError', AssertionError_init_$Create$, Error_0);
  initMetadataForClass(ConcurrentModificationException, 'ConcurrentModificationException', ConcurrentModificationException_init_$Create$, RuntimeException);
  initMetadataForClass(ClassCastException, 'ClassCastException', ClassCastException_init_$Create$, RuntimeException);
  initMetadataForClass(NoWhenBranchMatchedException, 'NoWhenBranchMatchedException', NoWhenBranchMatchedException_init_$Create$, RuntimeException);
  initMetadataForClass(UninitializedPropertyAccessException, 'UninitializedPropertyAccessException', UninitializedPropertyAccessException_init_$Create$, RuntimeException);
  initMetadataForInterface(KClass, 'KClass');
  initMetadataForClass(KClassImpl, 'KClassImpl', VOID, VOID, [KClass]);
  initMetadataForObject(NothingKClassImpl, 'NothingKClassImpl', VOID, KClassImpl);
  initMetadataForClass(ErrorKClass, 'ErrorKClass', ErrorKClass, VOID, [KClass]);
  initMetadataForClass(PrimitiveKClassImpl, 'PrimitiveKClassImpl', VOID, KClassImpl);
  initMetadataForClass(SimpleKClassImpl, 'SimpleKClassImpl', VOID, KClassImpl);
  initMetadataForInterface(KProperty1, 'KProperty1');
  initMetadataForInterface(KProperty0, 'KProperty0');
  initMetadataForInterface(KMutableProperty0, 'KMutableProperty0', VOID, VOID, [KProperty0]);
  initMetadataForClass(KTypeImpl, 'KTypeImpl');
  initMetadataForObject(PrimitiveClasses, 'PrimitiveClasses');
  initMetadataForClass(ConstrainedOnceSequence, 'ConstrainedOnceSequence', VOID, VOID, [Sequence]);
  initMetadataForClass(CharacterCodingException, 'CharacterCodingException', CharacterCodingException_init_$Create$, Exception);
  initMetadataForClass(StringBuilder, 'StringBuilder', StringBuilder_init_$Create$_1, VOID, [CharSequence]);
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(Regex, 'Regex');
  initMetadataForClass(MatchGroup, 'MatchGroup');
  initMetadataForInterface(MatchNamedGroupCollection, 'MatchNamedGroupCollection', VOID, VOID, [Collection]);
  initMetadataForClass(findNext$1$groups$1, VOID, VOID, AbstractCollection, [MatchNamedGroupCollection, AbstractCollection]);
  initMetadataForClass(findNext$1);
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(DurationUnit, 'DurationUnit', VOID, Enum);
  initMetadataForObject(MonotonicTimeSource, 'MonotonicTimeSource');
  initMetadataForClass(Reading, 'Reading');
  initMetadataForClass(HrTimeSource, 'HrTimeSource');
  initMetadataForClass(PerformanceTimeSource, 'PerformanceTimeSource');
  initMetadataForObject(DateNowTimeSource, 'DateNowTimeSource');
  initMetadataForClass(SubList_0, 'SubList', VOID, AbstractList, [AbstractList, RandomAccess]);
  initMetadataForClass(IteratorImpl_0, 'IteratorImpl');
  initMetadataForClass(ListIteratorImpl_0, 'ListIteratorImpl', VOID, IteratorImpl_0);
  initMetadataForCompanion(Companion_6);
  initMetadataForClass(AbstractMap$keys$1$iterator$1);
  initMetadataForClass(AbstractMap$values$1$iterator$1);
  initMetadataForCompanion(Companion_7);
  initMetadataForClass(AbstractSet, 'AbstractSet', VOID, AbstractCollection, [AbstractCollection, KtSet]);
  initMetadataForClass(AbstractMap$keys$1, VOID, VOID, AbstractSet);
  initMetadataForClass(AbstractMap$values$1, VOID, VOID, AbstractCollection);
  initMetadataForCompanion(Companion_8);
  initMetadataForCompanion(Companion_9);
  initMetadataForClass(ArrayDeque, 'ArrayDeque', ArrayDeque_init_$Create$, AbstractMutableList);
  initMetadataForObject(EmptyList, 'EmptyList', VOID, VOID, [KtList, RandomAccess]);
  initMetadataForClass(ArrayAsCollection, 'ArrayAsCollection', VOID, VOID, [Collection]);
  initMetadataForObject(EmptyIterator, 'EmptyIterator');
  initMetadataForClass(IndexedValue, 'IndexedValue');
  initMetadataForClass(IndexingIterable, 'IndexingIterable');
  initMetadataForClass(IndexingIterator, 'IndexingIterator');
  initMetadataForInterface(MapWithDefault, 'MapWithDefault', VOID, VOID, [KtMap]);
  initMetadataForObject(EmptyMap, 'EmptyMap', VOID, VOID, [KtMap]);
  initMetadataForClass(IntIterator, 'IntIterator');
  initMetadataForClass(CharIterator, 'CharIterator');
  initMetadataForClass(ReversedListReadOnly$listIterator$1);
  initMetadataForClass(ReversedListReadOnly, 'ReversedListReadOnly', VOID, AbstractList);
  initMetadataForClass(SequenceScope, 'SequenceScope', VOID, VOID, VOID, [1]);
  initMetadataForClass(SequenceBuilderIterator, 'SequenceBuilderIterator', SequenceBuilderIterator, SequenceScope, [SequenceScope, Continuation], [1]);
  initMetadataForClass(sequence$$inlined$Sequence$1, VOID, VOID, VOID, [Sequence]);
  initMetadataForClass(TransformingSequence$iterator$1);
  initMetadataForClass(TransformingSequence, 'TransformingSequence', VOID, VOID, [Sequence]);
  initMetadataForClass(FlatteningSequence$iterator$1);
  initMetadataForClass(FlatteningSequence, 'FlatteningSequence', VOID, VOID, [Sequence]);
  initMetadataForClass(FilteringSequence$iterator$1);
  initMetadataForClass(FilteringSequence, 'FilteringSequence', VOID, VOID, [Sequence]);
  initMetadataForInterface(DropTakeSequence, 'DropTakeSequence', VOID, VOID, [Sequence]);
  initMetadataForObject(EmptySequence, 'EmptySequence', VOID, VOID, [Sequence, DropTakeSequence]);
  initMetadataForClass(GeneratorSequence$iterator$1);
  initMetadataForClass(GeneratorSequence, 'GeneratorSequence', VOID, VOID, [Sequence]);
  initMetadataForClass(TakeSequence$iterator$1);
  initMetadataForClass(TakeSequence, 'TakeSequence', VOID, VOID, [Sequence, DropTakeSequence]);
  initMetadataForClass(asSequence$$inlined$Sequence$1_1, VOID, VOID, VOID, [Sequence]);
  initMetadataForObject(EmptySet, 'EmptySet', VOID, VOID, [KtSet]);
  initMetadataForObject(Key, 'Key');
  function plus(context) {
    var tmp;
    if (context === EmptyCoroutineContext_getInstance()) {
      tmp = this;
    } else {
      tmp = context.dj(this, CoroutineContext$plus$lambda);
    }
    return tmp;
  }
  initMetadataForInterface(CoroutineContext, 'CoroutineContext');
  function get(key) {
    var tmp;
    if (equals(this.x(), key)) {
      tmp = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  }
  function fold(initial, operation) {
    return operation(initial, this);
  }
  function minusKey(key) {
    return equals(this.x(), key) ? EmptyCoroutineContext_getInstance() : this;
  }
  initMetadataForInterface(Element_0, 'Element', VOID, VOID, [CoroutineContext]);
  function releaseInterceptedContinuation(continuation) {
  }
  function get_0(key) {
    if (key instanceof AbstractCoroutineContextKey) {
      var tmp;
      if (key.bj(this.x())) {
        var tmp_0 = key.aj(this);
        tmp = (!(tmp_0 == null) ? isInterface(tmp_0, Element_0) : false) ? tmp_0 : null;
      } else {
        tmp = null;
      }
      return tmp;
    }
    var tmp_1;
    if (Key_instance === key) {
      tmp_1 = isInterface(this, Element_0) ? this : THROW_CCE();
    } else {
      tmp_1 = null;
    }
    return tmp_1;
  }
  function minusKey_0(key) {
    if (key instanceof AbstractCoroutineContextKey) {
      return key.bj(this.x()) && !(key.aj(this) == null) ? EmptyCoroutineContext_getInstance() : this;
    }
    return Key_instance === key ? EmptyCoroutineContext_getInstance() : this;
  }
  initMetadataForInterface(ContinuationInterceptor, 'ContinuationInterceptor', VOID, VOID, [Element_0]);
  initMetadataForObject(EmptyCoroutineContext, 'EmptyCoroutineContext', VOID, VOID, [CoroutineContext]);
  initMetadataForClass(CombinedContext, 'CombinedContext', VOID, VOID, [CoroutineContext]);
  initMetadataForClass(AbstractCoroutineContextKey, 'AbstractCoroutineContextKey');
  initMetadataForClass(AbstractCoroutineContextElement, 'AbstractCoroutineContextElement', VOID, VOID, [Element_0]);
  initMetadataForClass(CoroutineSingletons, 'CoroutineSingletons', VOID, Enum);
  initMetadataForClass(EnumEntriesList, 'EnumEntriesList', VOID, AbstractList, [KtList, AbstractList]);
  initMetadataForClass(Random, 'Random');
  initMetadataForObject(Default, 'Default', VOID, Random);
  initMetadataForCompanion(Companion_10);
  initMetadataForClass(XorWowRandom, 'XorWowRandom', VOID, Random);
  initMetadataForCompanion(Companion_11);
  initMetadataForClass(IntProgression, 'IntProgression');
  initMetadataForClass(IntRange, 'IntRange', VOID, IntProgression);
  initMetadataForCompanion(Companion_12);
  initMetadataForClass(CharProgression, 'CharProgression');
  initMetadataForClass(CharRange, 'CharRange', VOID, CharProgression);
  initMetadataForClass(IntProgressionIterator, 'IntProgressionIterator', VOID, IntIterator);
  initMetadataForClass(CharProgressionIterator, 'CharProgressionIterator', VOID, CharIterator);
  initMetadataForCompanion(Companion_13);
  initMetadataForCompanion(Companion_14);
  initMetadataForInterface(KTypeParameter, 'KTypeParameter');
  initMetadataForCompanion(Companion_15);
  initMetadataForClass(KTypeProjection, 'KTypeProjection');
  initMetadataForClass(KVariance, 'KVariance', VOID, Enum);
  initMetadataForObject(State, 'State');
  initMetadataForClass(LinesIterator, 'LinesIterator');
  initMetadataForClass(DelimitedRangesSequence$iterator$1);
  initMetadataForClass(DelimitedRangesSequence, 'DelimitedRangesSequence', VOID, VOID, [Sequence]);
  initMetadataForClass(lineSequence$$inlined$Sequence$1, VOID, VOID, VOID, [Sequence]);
  initMetadataForCompanion(Companion_16);
  initMetadataForClass(Duration, 'Duration', VOID, VOID, [Comparable]);
  function compareTo(other) {
    return Duration__compareTo_impl_pchp0f(this.nl(other), Companion_getInstance_16().ff_1);
  }
  initMetadataForInterface(ComparableTimeMark, 'ComparableTimeMark', VOID, VOID, [Comparable]);
  initMetadataForClass(ValueTimeMark, 'ValueTimeMark', VOID, VOID, [ComparableTimeMark]);
  initMetadataForObject(Monotonic, 'Monotonic');
  initMetadataForClass(TimedValue, 'TimedValue');
  initMetadataForClass(DeepRecursiveScope, 'DeepRecursiveScope', VOID, VOID, VOID, [1]);
  initMetadataForClass(DeepRecursiveFunction, 'DeepRecursiveFunction');
  initMetadataForClass(DeepRecursiveScopeImpl, 'DeepRecursiveScopeImpl', VOID, DeepRecursiveScope, [DeepRecursiveScope, Continuation], [1]);
  initMetadataForClass(LazyThreadSafetyMode, 'LazyThreadSafetyMode', VOID, Enum);
  initMetadataForClass(UnsafeLazyImpl, 'UnsafeLazyImpl');
  initMetadataForObject(UNINITIALIZED_VALUE, 'UNINITIALIZED_VALUE');
  initMetadataForCompanion(Companion_17);
  initMetadataForClass(Failure, 'Failure');
  initMetadataForClass(Result, 'Result');
  initMetadataForClass(NotImplementedError, 'NotImplementedError', NotImplementedError, Error_0);
  initMetadataForClass(Pair, 'Pair');
  initMetadataForClass(Triple, 'Triple');
  initMetadataForCompanion(Companion_18);
  initMetadataForClass(UByte, 'UByte', VOID, VOID, [Comparable]);
  initMetadataForClass(Iterator, 'Iterator');
  initMetadataForClass(UByteArray, 'UByteArray', VOID, VOID, [Collection]);
  initMetadataForCompanion(Companion_19);
  initMetadataForClass(UInt, 'UInt', VOID, VOID, [Comparable]);
  initMetadataForClass(Iterator_0, 'Iterator');
  initMetadataForClass(UIntArray, 'UIntArray', VOID, VOID, [Collection]);
  initMetadataForCompanion(Companion_20);
  initMetadataForClass(ULong, 'ULong', VOID, VOID, [Comparable]);
  initMetadataForClass(Iterator_1, 'Iterator');
  initMetadataForClass(ULongArray, 'ULongArray', VOID, VOID, [Collection]);
  initMetadataForCompanion(Companion_21);
  initMetadataForClass(UShort, 'UShort', VOID, VOID, [Comparable]);
  initMetadataForClass(Iterator_2, 'Iterator');
  initMetadataForClass(UShortArray, 'UShortArray', VOID, VOID, [Collection]);
  function severe$default(msg, thrown, $super) {
    thrown = thrown === VOID ? null : thrown;
    var tmp;
    if ($super === VOID) {
      this.co(msg, thrown);
      tmp = Unit_instance;
    } else {
      tmp = $super.co.call(this, msg, thrown);
    }
    return tmp;
  }
  function warning$default(msg, thrown, $super) {
    thrown = thrown === VOID ? null : thrown;
    var tmp;
    if ($super === VOID) {
      this.eo(msg, thrown);
      tmp = Unit_instance;
    } else {
      tmp = $super.eo.call(this, msg, thrown);
    }
    return tmp;
  }
  initMetadataForInterface(Logger, 'Logger');
  initMetadataForObject(JSLogger, 'JSLogger', VOID, VOID, [Logger]);
  initMetadataForClass(SafeIterationList, 'SafeIterationList');
  initMetadataForClass(AddAtEndSafeIterationList, 'AddAtEndSafeIterationList', AddAtEndSafeIterationList, SafeIterationList);
  initMetadataForClass(ListMap$keySet$1$iterator$spec$1);
  initMetadataForClass(ListMap$values$1$iterator$spec$1);
  initMetadataForClass(ListMap$entrySet$1$iterator$spec$1);
  initMetadataForClass(Entry_0, 'Entry');
  initMetadataForCompanion(Companion_22);
  initMetadataForClass(ListMap$keySet$1, VOID, VOID, AbstractMutableSet);
  initMetadataForClass(ListMap$values$1, VOID, VOID, AbstractCollection);
  initMetadataForClass(ListMap$entrySet$1, VOID, VOID, AbstractSet);
  initMetadataForClass(ListMap$mapIterator$1);
  initMetadataForClass(ListMap, 'ListMap', ListMap);
  initMetadataForClass(Op, 'Op');
  initMetadataForCompanion(Companion_23);
  initMetadataForClass(ItemIterator, 'ItemIterator');
  initMetadataForClass(SafeIterationListIterable, 'SafeIterationListIterable');
  initMetadataForClass(SimpleCopyOnWriteList, 'SimpleCopyOnWriteList');
  initMetadataForClass(SimpleCopyOnWriteAddAtStartList, 'SimpleCopyOnWriteAddAtStartList', SimpleCopyOnWriteAddAtStartList, SimpleCopyOnWriteList);
  initMetadataForCompanion(Companion_24);
  initMetadataForClass(NaiveTreeMap$TailMapView$iterator$1);
  initMetadataForClass(Entry_1, 'Entry', VOID, VOID, [MutableEntry]);
  initMetadataForClass(TailMapView, 'TailMapView', VOID, AbstractMutableSet);
  initMetadataForClass(NaiveTreeMap$entries$1, VOID, VOID, TailMapView);
  initMetadataForClass(NaiveTreeMap$tailMap$entrySet$1, VOID, VOID, TailMapView);
  initMetadataForClass(NaiveTreeMap$tailMap$1, VOID, VOID, AbstractMap);
  initMetadataForClass(NaiveTreeMap, 'NaiveTreeMap', VOID, AbstractMutableMap, [AbstractMutableMap, KtMutableMap, KtMap]);
  initMetadataForObject(Present, 'Present');
  initMetadataForClass(NaiveTreeSet, 'NaiveTreeSet', VOID, AbstractMutableSet);
  function withLock(f) {
    this.ir();
    try {
      return f();
    }finally {
      this.jr();
    }
  }
  initMetadataForInterface(Lock, 'Lock');
  initMetadataForClass(emptyThreadSafeChecker$1);
  initMetadataForClass(AtomicBooleanJs, 'AtomicBooleanJs');
  initMetadataForClass(newLock$1, VOID, VOID, VOID, [Lock]);
  initMetadataForClass(SimpleThreadLocalJs, 'SimpleThreadLocalJs');
  function plus_0(disposable) {
    return toDisposable([this, disposable]);
  }
  initMetadataForInterface(Disposable, 'Disposable');
  initMetadataForClass(CompositeDisposable, 'CompositeDisposable', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_25);
  initMetadataForClass(toDisposable$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(DisposableMap, 'DisposableMap', DisposableMap);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(MyEventSource, 'MyEventSource', MyEventSource);
  initMetadataForCompanion(Companion_26);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_0, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(ThrowableHandler, 'ThrowableHandler');
  initMetadataForObject(ThrowableHandlers, 'ThrowableHandlers');
  initMetadataForClass(atomicfu$AtomicRefArray$ref, 'AtomicArray');
  initMetadataForClass(atomicfu$TraceBase, 'TraceBase');
  initMetadataForObject(None, 'None', VOID, atomicfu$TraceBase);
  initMetadataForClass(AtomicRef, 'AtomicRef');
  initMetadataForClass(AtomicBoolean, 'AtomicBoolean');
  initMetadataForClass(AtomicInt, 'AtomicInt');
  initMetadataForClass(AtomicLong, 'AtomicLong');
  function cancel$default(cause, $super) {
    cause = cause === VOID ? null : cause;
    var tmp;
    if ($super === VOID) {
      this.ou(cause);
      tmp = Unit_instance;
    } else {
      tmp = $super.ou.call(this, cause);
    }
    return tmp;
  }
  function invokeOnCompletion$default(onCancelling, invokeImmediately, handler, $super) {
    onCancelling = onCancelling === VOID ? false : onCancelling;
    invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
    return $super === VOID ? this.iu(onCancelling, invokeImmediately, handler) : $super.iu.call(this, onCancelling, invokeImmediately, handler);
  }
  initMetadataForInterface(Job, 'Job', VOID, VOID, [Element_0], [0]);
  initMetadataForInterface(ParentJob, 'ParentJob', VOID, VOID, [Job], [0]);
  initMetadataForClass(JobSupport, 'JobSupport', VOID, VOID, [Job, ParentJob], [0]);
  initMetadataForInterface(CoroutineScope, 'CoroutineScope');
  initMetadataForClass(AbstractCoroutine, 'AbstractCoroutine', VOID, JobSupport, [JobSupport, Job, Continuation, CoroutineScope], [0]);
  initMetadataForClass(StandaloneCoroutine, 'StandaloneCoroutine', VOID, AbstractCoroutine, VOID, [0]);
  initMetadataForClass(LazyStandaloneCoroutine, 'LazyStandaloneCoroutine', VOID, StandaloneCoroutine, VOID, [0]);
  initMetadataForCoroutine($awaitCOROUTINE$0, CoroutineImpl);
  initMetadataForClass(DeferredCoroutine, 'DeferredCoroutine', VOID, AbstractCoroutine, [AbstractCoroutine, Job], [0]);
  initMetadataForClass(LazyDeferredCoroutine, 'LazyDeferredCoroutine', VOID, DeferredCoroutine, VOID, [0]);
  initMetadataForClass(ScopeCoroutine, 'ScopeCoroutine', VOID, AbstractCoroutine, VOID, [0]);
  initMetadataForClass(DispatchedCoroutine, 'DispatchedCoroutine', VOID, ScopeCoroutine, VOID, [0]);
  initMetadataForInterface(CancellableContinuation, 'CancellableContinuation', VOID, VOID, [Continuation]);
  initMetadataForClass(CancelHandlerBase, 'CancelHandlerBase');
  initMetadataForInterface(NotCompleted, 'NotCompleted');
  initMetadataForClass(CancelHandler, 'CancelHandler', VOID, CancelHandlerBase, [CancelHandlerBase, NotCompleted]);
  initMetadataForClass(DisposeOnCancel, 'DisposeOnCancel', VOID, CancelHandler);
  initMetadataForInterface(Runnable, 'Runnable');
  initMetadataForClass(SchedulerTask, 'SchedulerTask', VOID, VOID, [Runnable]);
  initMetadataForClass(DispatchedTask, 'DispatchedTask', VOID, SchedulerTask);
  initMetadataForInterface(Waiter, 'Waiter');
  initMetadataForClass(CancellableContinuationImpl, 'CancellableContinuationImpl', VOID, DispatchedTask, [DispatchedTask, CancellableContinuation, Waiter]);
  initMetadataForObject(Active, 'Active', VOID, VOID, [NotCompleted]);
  initMetadataForClass(CompletedContinuation_0, 'CompletedContinuation');
  initMetadataForClass(InvokeOnCancel, 'InvokeOnCancel', VOID, CancelHandler);
  initMetadataForCoroutine($awaitCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(CompletableDeferredImpl, 'CompletableDeferredImpl', VOID, JobSupport, [JobSupport, Job], [0]);
  initMetadataForInterface(CompletableJob, 'CompletableJob', VOID, VOID, [Job], [0]);
  initMetadataForClass(CompletedExceptionally, 'CompletedExceptionally');
  initMetadataForClass(CancelledContinuation, 'CancelledContinuation', VOID, CompletedExceptionally);
  initMetadataForClass(CompletedWithCancellation, 'CompletedWithCancellation');
  initMetadataForObject(Key_0, 'Key', VOID, AbstractCoroutineContextKey);
  initMetadataForClass(CoroutineDispatcher, 'CoroutineDispatcher', VOID, AbstractCoroutineContextElement, [AbstractCoroutineContextElement, ContinuationInterceptor]);
  initMetadataForObject(Key_1, 'Key');
  initMetadataForObject(Key_2, 'Key');
  initMetadataForClass(CoroutineName, 'CoroutineName', VOID, AbstractCoroutineContextElement);
  initMetadataForObject(GlobalScope, 'GlobalScope', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(CoroutineStart, 'CoroutineStart', VOID, Enum);
  function invokeOnTimeout(timeMillis, block, context) {
    return get_DefaultDelay().a10(timeMillis, block, context);
  }
  initMetadataForInterface(Delay, 'Delay', VOID, VOID, VOID, [1]);
  initMetadataForInterface(DelayWithTimeoutDiagnostics, 'DelayWithTimeoutDiagnostics', VOID, VOID, [Delay], [1]);
  initMetadataForClass(EventLoop, 'EventLoop', VOID, CoroutineDispatcher);
  initMetadataForObject(ThreadLocalEventLoop, 'ThreadLocalEventLoop');
  initMetadataForClass(CompletionHandlerException, 'CompletionHandlerException', VOID, RuntimeException);
  initMetadataForClass(CoroutinesInternalError, 'CoroutinesInternalError', VOID, Error_0);
  initMetadataForInterface(DisposableHandle, 'DisposableHandle');
  initMetadataForObject(Key_3, 'Key');
  initMetadataForInterface(ChildHandle, 'ChildHandle', VOID, VOID, [DisposableHandle]);
  initMetadataForObject(NonDisposableHandle, 'NonDisposableHandle', VOID, VOID, [DisposableHandle, ChildHandle]);
  initMetadataForInterface(Incomplete, 'Incomplete');
  initMetadataForClass(Empty, 'Empty', VOID, VOID, [Incomplete]);
  initMetadataForClass(LinkedListNode, 'LinkedListNode', LinkedListNode, VOID, [DisposableHandle]);
  initMetadataForClass(LinkedListHead, 'LinkedListHead', LinkedListHead, LinkedListNode);
  initMetadataForClass(NodeList, 'NodeList', NodeList, LinkedListHead, [LinkedListHead, Incomplete]);
  initMetadataForClass(CompletionHandlerBase, 'CompletionHandlerBase', VOID, LinkedListNode);
  initMetadataForClass(JobNode, 'JobNode', VOID, CompletionHandlerBase, [CompletionHandlerBase, DisposableHandle, Incomplete]);
  initMetadataForClass(SelectOnJoinCompletionHandler, 'SelectOnJoinCompletionHandler', VOID, JobNode);
  initMetadataForClass(Finishing, 'Finishing', VOID, VOID, [Incomplete]);
  initMetadataForClass(ChildCompletion, 'ChildCompletion', VOID, JobNode);
  initMetadataForClass(AwaitContinuation, 'AwaitContinuation', VOID, CancellableContinuationImpl);
  initMetadataForClass(JobCancellingNode, 'JobCancellingNode', VOID, JobNode);
  initMetadataForClass(InactiveNodeList, 'InactiveNodeList', VOID, VOID, [Incomplete]);
  initMetadataForClass(ChildHandleNode, 'ChildHandleNode', VOID, JobCancellingNode, [JobCancellingNode, ChildHandle]);
  initMetadataForClass(InvokeOnCancelling, 'InvokeOnCancelling', VOID, JobCancellingNode);
  initMetadataForClass(InvokeOnCompletion, 'InvokeOnCompletion', VOID, JobNode);
  initMetadataForClass(ResumeOnCompletion, 'ResumeOnCompletion', VOID, JobNode);
  initMetadataForClass(ResumeAwaitOnCompletion, 'ResumeAwaitOnCompletion', VOID, JobNode);
  initMetadataForClass(IncompleteStateBox, 'IncompleteStateBox');
  initMetadataForClass(ChildContinuation, 'ChildContinuation', VOID, JobCancellingNode);
  initMetadataForClass(JobImpl, 'JobImpl', VOID, JobSupport, [JobSupport, CompletableJob], [0]);
  initMetadataForClass(DisposeOnCompletion, 'DisposeOnCompletion', VOID, JobNode);
  initMetadataForClass(MainCoroutineDispatcher, 'MainCoroutineDispatcher', VOID, CoroutineDispatcher);
  initMetadataForClass(SupervisorJobImpl, 'SupervisorJobImpl', VOID, JobImpl, VOID, [0]);
  initMetadataForClass(TimeoutCancellationException, 'TimeoutCancellationException', VOID, CancellationException);
  initMetadataForClass(TimeoutCoroutine, 'TimeoutCoroutine', VOID, ScopeCoroutine, [ScopeCoroutine, Runnable], [0]);
  initMetadataForCoroutine($withTimeoutOrNullCOROUTINE$2, CoroutineImpl);
  initMetadataForObject(Unconfined, 'Unconfined', VOID, CoroutineDispatcher);
  initMetadataForObject(Key_4, 'Key');
  initMetadataForClass(YieldContext, 'YieldContext', YieldContext, AbstractCoroutineContextElement);
  initMetadataForClass(BufferOverflow, 'BufferOverflow', VOID, Enum);
  initMetadataForClass(ConcurrentLinkedListNode, 'ConcurrentLinkedListNode');
  initMetadataForClass(Segment, 'Segment', VOID, ConcurrentLinkedListNode, [ConcurrentLinkedListNode, NotCompleted]);
  initMetadataForClass(ChannelSegment, 'ChannelSegment', VOID, Segment);
  initMetadataForCoroutine($hasNextCOROUTINE$6, CoroutineImpl);
  initMetadataForClass(SendBroadcast, 'SendBroadcast', VOID, VOID, [Waiter]);
  initMetadataForClass(BufferedChannelIterator, 'BufferedChannelIterator', VOID, VOID, [Waiter], [0, 3]);
  initMetadataForCoroutine($sendCOROUTINE$3, CoroutineImpl);
  initMetadataForCoroutine($receiveCOROUTINE$4, CoroutineImpl);
  function close$default(cause, $super) {
    cause = cause === VOID ? null : cause;
    return $super === VOID ? this.g1c(cause) : $super.g1c.call(this, cause);
  }
  initMetadataForInterface(SendChannel, 'SendChannel', VOID, VOID, VOID, [1]);
  function cancel$default_0(cause, $super) {
    cause = cause === VOID ? null : cause;
    var tmp;
    if ($super === VOID) {
      this.ou(cause);
      tmp = Unit_instance;
    } else {
      tmp = $super.ou.call(this, cause);
    }
    return tmp;
  }
  initMetadataForInterface(ReceiveChannel, 'ReceiveChannel', VOID, VOID, VOID, [0]);
  initMetadataForClass(BufferedChannel, 'BufferedChannel', VOID, VOID, [SendChannel, ReceiveChannel], [1, 4, 0, 3]);
  initMetadataForClass(WaiterEB, 'WaiterEB');
  initMetadataForClass(ReceiveCatching, 'ReceiveCatching', VOID, VOID, [Waiter]);
  initMetadataForObject(Factory, 'Factory');
  initMetadataForClass(Failed, 'Failed', Failed);
  initMetadataForClass(Closed, 'Closed', VOID, Failed);
  initMetadataForCompanion(Companion_27);
  initMetadataForClass(ChannelResult, 'ChannelResult');
  initMetadataForClass(ClosedSendChannelException, 'ClosedSendChannelException', VOID, IllegalStateException);
  initMetadataForClass(ClosedReceiveChannelException, 'ClosedReceiveChannelException', VOID, NoSuchElementException);
  initMetadataForClass(ChannelCoroutine, 'ChannelCoroutine', VOID, AbstractCoroutine, [AbstractCoroutine, SendChannel, ReceiveChannel], [0, 1]);
  initMetadataForClass(ConflatedBufferedChannel, 'ConflatedBufferedChannel', VOID, BufferedChannel, VOID, [1, 0]);
  initMetadataForInterface(ProducerScope, 'ProducerScope', VOID, VOID, [CoroutineScope, SendChannel], [1]);
  initMetadataForClass(ProducerCoroutine, 'ProducerCoroutine', VOID, ChannelCoroutine, [ChannelCoroutine, ProducerScope], [0, 1]);
  initMetadataForInterface(Flow, 'Flow', VOID, VOID, VOID, [1]);
  initMetadataForInterface(CancellableFlow, 'CancellableFlow', VOID, VOID, [Flow], [1]);
  initMetadataForClass(AbstractFlow, 'AbstractFlow', VOID, VOID, [Flow, CancellableFlow], [1]);
  initMetadataForClass(SafeFlow, 'SafeFlow', VOID, AbstractFlow, VOID, [1]);
  function fuse$default(context, capacity, onBufferOverflow, $super) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? -3 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    return $super === VOID ? this.f1e(context, capacity, onBufferOverflow) : $super.f1e.call(this, context, capacity, onBufferOverflow);
  }
  initMetadataForInterface(FusibleFlow, 'FusibleFlow', VOID, VOID, [Flow], [1]);
  initMetadataForClass(ChannelFlow, 'ChannelFlow', VOID, VOID, [FusibleFlow], [1]);
  initMetadataForClass(ChannelFlowBuilder, 'ChannelFlowBuilder', VOID, ChannelFlow, VOID, [1]);
  initMetadataForObject(EmptyFlow, 'EmptyFlow', VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$10, CoroutineImpl);
  initMetadataForClass(asFlow$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$11, CoroutineImpl);
  initMetadataForClass(asFlow$$inlined$unsafeFlow$2, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$13, CoroutineImpl);
  initMetadataForClass(ChannelAsFlow, 'ChannelAsFlow', VOID, ChannelFlow, VOID, [1]);
  initMetadataForCoroutine($emitAllImplCOROUTINE$12, CoroutineImpl);
  initMetadataForCoroutine($collectCOROUTINE$14, CoroutineImpl);
  initMetadataForInterface(FlowCollector, 'FlowCollector', VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$16, CoroutineImpl);
  initMetadataForClass(AbstractSharedFlow, 'AbstractSharedFlow');
  initMetadataForClass(StateFlowImpl, 'StateFlowImpl', VOID, AbstractSharedFlow, [AbstractSharedFlow, FlowCollector, Flow, CancellableFlow, FusibleFlow], [1]);
  initMetadataForClass(AbstractSharedFlowSlot, 'AbstractSharedFlowSlot');
  initMetadataForClass(StateFlowSlot, 'StateFlowSlot', StateFlowSlot, AbstractSharedFlowSlot, VOID, [0]);
  initMetadataForLambda(ChannelFlow$_get_collectToFun_$slambda_j53z2e, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ChannelFlow$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ChannelFlowOperator, 'ChannelFlowOperator', VOID, ChannelFlow, VOID, [1, 2]);
  initMetadataForClass(ChannelFlowOperatorImpl, 'ChannelFlowOperatorImpl', VOID, ChannelFlowOperator, VOID, [1]);
  initMetadataForLambda(ChannelFlowOperator$collectWithContextUndispatched$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$17, CoroutineImpl);
  initMetadataForLambda(UndispatchedContextCollector$emitRef$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(UndispatchedContextCollector, 'UndispatchedContextCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(StackFrameContinuation, 'StackFrameContinuation', VOID, VOID, [Continuation]);
  initMetadataForLambda(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ChannelFlowTransformLatest$flowCollect$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(ChannelFlowTransformLatest$flowCollect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ChannelFlowTransformLatest, 'ChannelFlowTransformLatest', VOID, ChannelFlowOperator, VOID, [1]);
  initMetadataForObject(NopCollector, 'NopCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(SendingCollector, 'SendingCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(CancellableFlowImpl$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CancellableFlowImpl, 'CancellableFlowImpl', VOID, VOID, [CancellableFlow], [1]);
  initMetadataForClass(ThrowingCollector, 'ThrowingCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForCoroutine($collectCOROUTINE$20, CoroutineImpl);
  initMetadataForClass(onCompletion$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($invokeSafelyCOROUTINE$18, CoroutineImpl);
  initMetadataForCoroutine($emitCOROUTINE$24, CoroutineImpl);
  initMetadataForClass(takeWhile$$inlined$unsafeFlow$1$collect$2, VOID, VOID, VOID, [FlowCollector], [1]);
  initMetadataForCoroutine($collectCOROUTINE$23, CoroutineImpl);
  initMetadataForClass(takeWhile$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($emitCOROUTINE$25, CoroutineImpl);
  initMetadataForClass(transformWhile$1$$inlined$collectWhile$1, VOID, VOID, VOID, [FlowCollector], [1]);
  initMetadataForLambda(transformWhile$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_1, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(flatMapConcat$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$26, CoroutineImpl);
  initMetadataForClass(flatMapConcat$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_2, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(flattenConcat$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$27, CoroutineImpl);
  initMetadataForClass(flattenConcat$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(mapLatest$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($onSubscriptionCOROUTINE$28, CoroutineImpl);
  initMetadataForClass(SubscribedFlowCollector, 'SubscribedFlowCollector', VOID, VOID, [FlowCollector], [1, 0]);
  initMetadataForClass(SharingConfig, 'SharingConfig');
  initMetadataForCoroutine($collectCOROUTINE$29, CoroutineImpl);
  initMetadataForClass(ReadonlyStateFlow, 'ReadonlyStateFlow', VOID, VOID, [Flow, CancellableFlow, FusibleFlow], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_3, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(launchSharingDeferred$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(launchSharingDeferred$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_4, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(toCollection$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($toCollectionCOROUTINE$32, CoroutineImpl);
  initMetadataForCoroutine($emitCOROUTINE$36, CoroutineImpl);
  initMetadataForClass(first$$inlined$collectWhile$1, VOID, VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(firstOrNull$$inlined$collectWhile$1, VOID, VOID, VOID, [FlowCollector], [1]);
  initMetadataForCoroutine($emitCOROUTINE$37, CoroutineImpl);
  initMetadataForClass(firstOrNull$$inlined$collectWhile$2, VOID, VOID, VOID, [FlowCollector], [1]);
  initMetadataForCoroutine($firstCOROUTINE$33, CoroutineImpl);
  initMetadataForCoroutine($firstOrNullCOROUTINE$34, CoroutineImpl);
  initMetadataForCoroutine($firstOrNullCOROUTINE$35, CoroutineImpl);
  initMetadataForClass(OpDescriptor, 'OpDescriptor');
  initMetadataForClass(SegmentOrClosed, 'SegmentOrClosed');
  initMetadataForObject(ExceptionSuccessfullyProcessed, 'ExceptionSuccessfullyProcessed', VOID, Exception);
  initMetadataForClass(DispatchedContinuation, 'DispatchedContinuation', VOID, DispatchedTask, [DispatchedTask, Continuation]);
  initMetadataForClass(UndeliveredElementException, 'UndeliveredElementException', VOID, RuntimeException);
  initMetadataForClass(ContextScope, 'ContextScope', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(Symbol_0, 'Symbol');
  initMetadataForClass(SelectClause0Impl, 'SelectClause0Impl');
  initMetadataForInterface(SelectInstance, 'SelectInstance');
  initMetadataForCoroutine($invokeBlockCOROUTINE$42, CoroutineImpl);
  initMetadataForClass(ClauseData, 'ClauseData', VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($doSelectCOROUTINE$38, CoroutineImpl);
  initMetadataForCoroutine($doSelectSuspendCOROUTINE$39, CoroutineImpl);
  initMetadataForCoroutine($completeCOROUTINE$40, CoroutineImpl);
  initMetadataForCoroutine($processResultAndInvokeBlockRecoveringExceptionCOROUTINE$41, CoroutineImpl);
  initMetadataForClass(SelectImplementation, 'SelectImplementation', VOID, CancelHandler, [CancelHandler, SelectInstance, Waiter], [0, 2]);
  initMetadataForClass(TrySelectDetailedResult, 'TrySelectDetailedResult', VOID, Enum);
  initMetadataForClass(UndispatchedCoroutine, 'UndispatchedCoroutine', VOID, ScopeCoroutine, VOID, [0]);
  initMetadataForObject(Dispatchers, 'Dispatchers');
  initMetadataForClass(JsMainDispatcher, 'JsMainDispatcher', VOID, MainCoroutineDispatcher);
  initMetadataForClass(UnconfinedEventLoop, 'UnconfinedEventLoop', UnconfinedEventLoop, EventLoop);
  initMetadataForClass(JobCancellationException, 'JobCancellationException', VOID, CancellationException);
  initMetadataForClass(SetTimeoutBasedDispatcher, 'SetTimeoutBasedDispatcher', VOID, CoroutineDispatcher, [CoroutineDispatcher, Delay], [1]);
  initMetadataForObject(NodeDispatcher, 'NodeDispatcher', VOID, SetTimeoutBasedDispatcher, VOID, [1]);
  initMetadataForObject(SetTimeoutDispatcher, 'SetTimeoutDispatcher', VOID, SetTimeoutBasedDispatcher, VOID, [1]);
  initMetadataForClass(MessageQueue, 'MessageQueue', VOID, VOID, [KtMutableList]);
  initMetadataForClass(ScheduledMessageQueue, 'ScheduledMessageQueue', VOID, MessageQueue);
  initMetadataForClass(ClearTimeout, 'ClearTimeout', VOID, CancelHandler, [CancelHandler, DisposableHandle]);
  initMetadataForClass(WindowClearTimeout, 'WindowClearTimeout', VOID, ClearTimeout);
  initMetadataForClass(WindowDispatcher, 'WindowDispatcher', VOID, CoroutineDispatcher, [CoroutineDispatcher, Delay], [1]);
  initMetadataForClass(WindowMessageQueue, 'WindowMessageQueue', VOID, MessageQueue);
  initMetadataForClass(AbortFlowException, 'AbortFlowException', VOID, CancellationException);
  initMetadataForClass(ChildCancelledException, 'ChildCancelledException', ChildCancelledException, CancellationException);
  initMetadataForClass(SafeCollector, 'SafeCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(DiagnosticCoroutineContextException, 'DiagnosticCoroutineContextException', VOID, RuntimeException);
  initMetadataForClass(CommonThreadLocal, 'CommonThreadLocal', CommonThreadLocal);
  initMetadataForInterface(CollectionListener, 'CollectionListener');
  initMetadataForClass(CollectionAdapter, 'CollectionAdapter', CollectionAdapter, VOID, [CollectionListener]);
  initMetadataForClass(CollectionIndexOutOfBoundsException, 'CollectionIndexOutOfBoundsException', CollectionIndexOutOfBoundsException_init_$Create$, RuntimeException);
  initMetadataForClass(EventType, 'EventType', VOID, Enum);
  initMetadataForClass(CollectionItemEvent, 'CollectionItemEvent');
  function addHandler(handler) {
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var tmp$ret$0 = new EventSource$addHandler$$inlined$eventHandler$1(handler);
    return this.o27(tmp$ret$0);
  }
  initMetadataForInterface(EventSource, 'EventSource');
  initMetadataForInterface(MutableObservableCollection, 'MutableObservableCollection', VOID, VOID, [Collection, EventSource, MutableCollection]);
  initMetadataForClass(Listeners, 'Listeners', Listeners);
  initMetadataForClass(CollectionListeners, 'CollectionListeners', VOID, Listeners);
  initMetadataForClass(AbstractObservableList$addHandler$listener$1, VOID, VOID, VOID, [CollectionListener]);
  initMetadataForInterface(ObservableList, 'ObservableList', VOID, VOID, [KtList, Collection, EventSource]);
  initMetadataForInterface(MutableObservableList, 'MutableObservableList', VOID, VOID, [ObservableList, KtMutableList, MutableObservableCollection]);
  initMetadataForClass(AbstractObservableList, 'AbstractObservableList', VOID, AbstractMutableList, [AbstractMutableList, MutableObservableList]);
  initMetadataForCompanion(Companion_28);
  initMetadataForClass(ConstantObservableListAdapter, 'ConstantObservableListAdapter', VOID, VOID, [ObservableList, KtList]);
  initMetadataForClass(ObservableArrayList, 'ObservableArrayList', ObservableArrayList, AbstractObservableList);
  initMetadataForClass(AbstractObservableSet$iterator$1);
  initMetadataForClass(AbstractObservableSet$addHandler$listener$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(AbstractObservableSet, 'AbstractObservableSet', VOID, AbstractMutableSet, [AbstractMutableSet, EventSource, MutableObservableCollection, KtMutableSet, Collection, KtSet]);
  initMetadataForCompanion(Companion_29);
  initMetadataForClass(ConstantObservableSetAdapter, 'ConstantObservableSetAdapter', VOID, VOID, [EventSource, Collection, KtSet]);
  initMetadataForClass(ObservableHashSet, 'ObservableHashSet', ObservableHashSet_init_$Create$, AbstractObservableSet);
  initMetadataForClass(ObservableListWrapper, 'ObservableListWrapper', VOID, AbstractMutableList, [AbstractMutableList, MutableObservableList]);
  initMetadataForClass(ObservableSetWrapper$iterator$1);
  initMetadataForClass(ObservableSetWrapper, 'ObservableSetWrapper', VOID, VOID, [EventSource, MutableObservableCollection, KtMutableSet, Collection, KtSet]);
  initMetadataForClass(RelayCollectionListener, 'RelayCollectionListener', VOID, VOID, [CollectionListener]);
  initMetadataForClass(EventHandlerListeners, 'EventHandlerListeners', EventHandlerListeners, Listeners);
  initMetadataForClass(EventSource$addHandler$$inlined$eventHandler$1);
  initMetadataForClass(EventListeners, 'EventListeners', EventListeners, Listeners);
  initMetadataForClass(CompositeEventSource$addHandler$1, VOID, VOID, EventHandlerListeners);
  initMetadataForClass(CompositeEventSource, 'CompositeEventSource', VOID, VOID, [EventSource]);
  initMetadataForObject(EventSources, 'EventSources');
  initMetadataForClass(Listeners$add$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(ListenersDelegate, 'ListenersDelegate', VOID, Listeners);
  initMetadataForClass(ListenersMap$add$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(ListenersMap, 'ListenersMap', ListenersMap);
  initMetadataForClass(BaseDerivedProperty$addHandler$1, VOID, VOID, EventHandlerListeners);
  function invoke() {
    return this.qr();
  }
  initMetadataForInterface(ReadableProperty, 'ReadableProperty', VOID, VOID, [EventSource]);
  initMetadataForClass(BaseReadableProperty, 'BaseReadableProperty', VOID, VOID, [ReadableProperty]);
  initMetadataForClass(BaseDerivedProperty, 'BaseDerivedProperty', VOID, BaseReadableProperty);
  initMetadataForClass(DelayedValueProperty$addHandler$1, VOID, VOID, EventHandlerListeners);
  function invoke_0(value) {
    return this.t2c(value);
  }
  initMetadataForInterface(WritableProperty, 'WritableProperty');
  initMetadataForInterface(Property, 'Property', VOID, VOID, [ReadableProperty, WritableProperty]);
  initMetadataForClass(DelayedValueProperty, 'DelayedValueProperty', DelayedValueProperty, BaseReadableProperty, [BaseReadableProperty, Property]);
  initMetadataForClass(DerivedProperty, 'DerivedProperty', VOID, BaseDerivedProperty);
  initMetadataForClass(toDerivedProperty$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(Properties$and$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(Properties$or$1, VOID, VOID, DerivedProperty);
  initMetadataForObject(Properties, 'Properties');
  initMetadataForClass(AbstractSelectProperty, 'AbstractSelectProperty', VOID, BaseDerivedProperty);
  initMetadataForClass(and$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(map$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(map$2, VOID, VOID, VOID, [Property]);
  initMetadataForClass(constantProp$1, VOID, VOID, BaseReadableProperty);
  initMetadataForClass(ifProp$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(select$1, VOID, VOID, AbstractSelectProperty);
  initMetadataForClass(isEqual$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(asValidatedProp$ValidatedProperty, 'ValidatedProperty', VOID, DerivedProperty, [DerivedProperty, Property]);
  initMetadataForClass(PropertyBinding$bindTwoWay$UpdatingEventHandler, 'UpdatingEventHandler');
  initMetadataForObject(PropertyBinding, 'PropertyBinding');
  initMetadataForClass(PropertyChangeEvent, 'PropertyChangeEvent');
  initMetadataForClass(UpdatableProperty, 'UpdatableProperty', VOID, BaseDerivedProperty);
  initMetadataForClass(ValueProperty$initializedHandlers$1, VOID, VOID, EventHandlerListeners);
  initMetadataForClass(ValueProperty, 'ValueProperty', VOID, BaseReadableProperty, [BaseReadableProperty, Property]);
  initMetadataForClass(toWritableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(SimpleCollectionProperty, 'SimpleCollectionProperty', VOID, BaseDerivedProperty);
  initMetadataForClass(isEmptyProp$1, VOID, VOID, SimpleCollectionProperty);
  initMetadataForClass(SimpleCollectionProperty$doAddListeners$listener$1, VOID, VOID, VOID, [CollectionListener]);
  initMetadataForClass(SingleItemCollectionProperty$addHandler$listener$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(SingleItemCollectionProperty, 'SingleItemCollectionProperty', VOID, VOID, [Property]);
  initMetadataForCoroutine($awaitValueCOROUTINE$0, CoroutineImpl);
  initMetadataForCoroutine($awaitMatchingCOROUTINE$1, CoroutineImpl);
  initMetadataForCoroutine($awaitNotNullCOROUTINE$2, CoroutineImpl);
  initMetadataForClass(BaseTransformer, 'BaseTransformer');
  initMetadataForClass(IdentityHashMap$entries$1$iterator$1$next$1, VOID, VOID, VOID, [MutableEntry]);
  initMetadataForClass(IdentityHashMap$entries$1$iterator$1);
  initMetadataForClass(IdentityHashMap$keys$1$iterator$1);
  initMetadataForClass(IdentityHashMap$entries$1, VOID, VOID, VOID, [KtMutableSet]);
  initMetadataForClass(IdentityHashMap$mapEntry$1, VOID, VOID, VOID, [MutableEntry]);
  initMetadataForClass(IdentityHashMap$keys$1, VOID, VOID, VOID, [KtMutableSet]);
  initMetadataForClass(IdentityHashMap, 'IdentityHashMap', IdentityHashMap, VOID, [KtMutableMap]);
  initMetadataForClass(Wrapper, 'Wrapper');
  initMetadataForClass(TerminalTransformation, 'TerminalTransformation', VOID, VOID, [Disposable]);
  initMetadataForClass(Transformation, 'Transformation', VOID, TerminalTransformation);
  initMetadataForClass(SimpleTransformation, 'SimpleTransformation', VOID, Transformation);
  initMetadataForClass(Transformers$fromFun$1$transform$1, VOID, VOID, Transformation);
  initMetadataForClass(Transformers$listMap$1$transform$listener$1, VOID, VOID, VOID, [CollectionListener]);
  initMetadataForClass(Transformers$listMap$1$transform$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(Transformers$flattenList$3$transform$sourceListener$1$watch$1, VOID, VOID, VOID, [CollectionListener]);
  initMetadataForClass(Transformers$flattenList$3$transform$sourceListener$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(Transformers$flattenList$3$transform$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(Transformers$withPlaceHoldersIfEmpty$1$transform$fromRegistration$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(Transformers$fromFun$1, VOID, VOID, BaseTransformer);
  initMetadataForClass(Transformers$listMap$1, VOID, VOID, BaseTransformer);
  initMetadataForClass(Transformers$flattenList$3, VOID, VOID, BaseTransformer);
  initMetadataForClass(Transformers$withPlaceHoldersIfEmpty$1, VOID, VOID, BaseTransformer);
  initMetadataForClass(Transformers$propertyToList$1, VOID, VOID, BaseTransformer);
  initMetadataForObject(Transformers, 'Transformers');
  initMetadataForClass(Asyncs$constant$1);
  initMetadataForClass(Asyncs$failure$1);
  initMetadataForObject(Asyncs, 'Asyncs');
  initMetadataForClass(SuccessItem, 'SuccessItem');
  initMetadataForClass(SimpleAsync$onResult$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(SimpleAsync, 'SimpleAsync', SimpleAsync);
  initMetadataForClass(ThrowableCollectionException, 'ThrowableCollectionException', VOID, RuntimeException);
  function workStarted() {
  }
  function workFinished() {
  }
  initMetadataForInterface(AsyncTracker, 'AsyncTracker');
  initMetadataForClass(AsyncTracker$Companion$EMPTY$1, VOID, VOID, VOID, [AsyncTracker]);
  initMetadataForCompanion(Companion_30);
  initMetadataForLambda(launchWith$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DefaultAsyncEdt, 'DefaultAsyncEdt');
  initMetadataForClass(EdtException, 'EdtException', VOID, RuntimeException);
  initMetadataForInterface(EdtTask, 'EdtTask');
  initMetadataForClass(NullEventDispatchThread, 'NullEventDispatchThread', NullEventDispatchThread, DefaultAsyncEdt);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_0, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_1, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
  initMetadataForClass(EdtCoroutineDispatcher, 'EdtCoroutineDispatcher', VOID, CoroutineDispatcher, [CoroutineDispatcher, Delay], [1]);
  initMetadataForClass(JsEventDispatchThread$timerDisposable$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(JsEventDispatchThread, 'JsEventDispatchThread', VOID, DefaultAsyncEdt);
  initMetadataForCompanion(Companion_31);
  initMetadataForClass(Task, 'Task');
  initMetadataForClass(Flusher, 'Flusher');
  initMetadataForClass(Rescuer, 'Rescuer');
  initMetadataForCompanion(Companion_32);
  initMetadataForClass(SchedulerImpl, 'SchedulerImpl', SchedulerImpl);
  initMetadataForClass(Timer, 'Timer');
  function get_default() {
    var message = 'No default service provided for ' + toString_1(this);
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  function invoke_1(container) {
    var tmp0_elvis_lhs = container.h2o(this);
    return tmp0_elvis_lhs == null ? this.g2o() : tmp0_elvis_lhs;
  }
  function invoke_2() {
    return new ServiceAdapter(Service$Key$invoke$lambda(this));
  }
  function optional(container) {
    return container.h2o(this);
  }
  initMetadataForInterface(Key_5, 'Key');
  initMetadataForCompanion(Companion_33);
  initMetadataForClass(AnonymousResourceServiceKey, 'AnonymousResourceServiceKey', AnonymousResourceServiceKey, VOID, [Key_5]);
  initMetadataForClass(Service, 'Service');
  initMetadataForClass(ServiceAdapter, 'ServiceAdapter');
  initMetadataForCompanion(Companion_34);
  initMetadataForClass(ServiceInstance$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(ServiceInstance, 'ServiceInstance', VOID, VOID, [Disposable]);
  initMetadataForClass(ServiceEntry, 'ServiceEntry');
  function getValue(_this__u8e3s4, thisRef, property) {
    return _this__u8e3s4.u2o(this);
  }
  initMetadataForInterface(ServicesScope, 'ServicesScope');
  initMetadataForClass(ServiceManager, 'ServiceManager', VOID, VOID, [ServicesScope, Disposable]);
  initMetadataForObject(CoroutineContextService, 'CoroutineContextService', VOID, VOID, [Key_5]);
  initMetadataForClass(Language, 'Language');
  initMetadataForInterface(LanguageAspect, 'LanguageAspect');
  initMetadataForClass(LanguageBuilderImpl, 'LanguageBuilderImpl', LanguageBuilderImpl);
  initMetadataForClass(LanguageConfigurationException, 'LanguageConfigurationException', LanguageConfigurationException_init_$Create$, Exception);
  initMetadataForObject(EnumInfoFactory, 'EnumInfoFactory');
  initMetadataForClass(EnumInfoImpl, 'EnumInfoImpl');
  initMetadataForObject(Enums, 'Enums');
  function isNullString(value) {
    return value == null;
  }
  function isNullValue(value) {
    return value == null;
  }
  initMetadataForInterface(NullPersister, 'NullPersister');
  initMetadataForClass(DefaultValueNullPersister, 'DefaultValueNullPersister', VOID, VOID, [NullPersister]);
  initMetadataForClass(EmptyStringNullPersister, 'EmptyStringNullPersister', EmptyStringNullPersister, VOID, [NullPersister]);
  initMetadataForClass(ExceptionNullPersister, 'ExceptionNullPersister', ExceptionNullPersister, VOID, [NullPersister]);
  initMetadataForInterface(NonNullPersister, 'NonNullPersister');
  initMetadataForClass(NonNullPersisters$STRING_PERSISTER$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(NonNullPersisters$INT_PERSISTER$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(NonNullPersisters$LONG_PERSISTER$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(NonNullPersisters$BOOLEAN_PERSISTER$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(NonNullPersisters$DOUBLE_PERSISTER$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(NonNullPersisters, 'NonNullPersisters');
  initMetadataForClass(NullPersisterForNullable, 'NullPersisterForNullable', NullPersisterForNullable, VOID, [NullPersister]);
  function deserialize(value) {
    var tmp;
    if (this.n2q().v2p(value)) {
      var tmp_0 = this.n2q().u2p();
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    } else {
      tmp = this.p2q(ensureNotNull(value));
    }
    return tmp;
  }
  function serialize(value) {
    var tmp;
    if (this.n2q().s2p(value)) {
      tmp = this.n2q().t2p();
    } else {
      tmp = this.o2q(ensureNotNull(value));
    }
    return tmp;
  }
  initMetadataForInterface(Persister, 'Persister');
  initMetadataForObject(Persisters, 'Persisters');
  initMetadataForClass(SimplePersister, 'SimplePersister', VOID, VOID, [Persister]);
  initMetadataForInterface(Composite, 'Composite');
  initMetadataForObject(Composites, 'Composites');
  initMetadataForCompanion(Companion_35);
  initMetadataForClass(BaseId, 'BaseId', BaseId);
  initMetadataForObject(IdGenerator, 'IdGenerator');
  initMetadataForClass(IdNames, 'IdNames', IdNames);
  initMetadataForClass(Interval$reverseIterable$1$iterator$1);
  initMetadataForCompanion(Companion_36);
  initMetadataForClass(Interval$iterable$1);
  initMetadataForClass(Interval$reverseIterable$1);
  initMetadataForClass(Interval$iterator$1);
  initMetadataForClass(Interval, 'Interval');
  initMetadataForClass(DefaultJsonSupport, 'DefaultJsonSupport', DefaultJsonSupport);
  initMetadataForClass(IndentBuilder, 'IndentBuilder');
  initMetadataForObject(Json, 'Json');
  initMetadataForCompanion(Companion_37);
  initMetadataForClass(JsonValue, 'JsonValue');
  initMetadataForClass(JsonArray, 'JsonArray', JsonArray, JsonValue);
  initMetadataForClass(JsonBoolean, 'JsonBoolean', VOID, JsonValue);
  initMetadataForClass(JsonLexer, 'JsonLexer');
  initMetadataForClass(JsonNull, 'JsonNull', JsonNull, JsonValue);
  initMetadataForClass(JsonNumber, 'JsonNumber', VOID, JsonValue);
  initMetadataForClass(JsonObject, 'JsonObject', JsonObject, JsonValue);
  initMetadataForClass(JsonParsingException, 'JsonParsingException', JsonParsingException_init_$Create$, RuntimeException);
  initMetadataForClass(JsonString, 'JsonString', VOID, JsonValue);
  initMetadataForClass(JsonTokenKind, 'JsonTokenKind', VOID, Enum);
  initMetadataForObject(JsonUtil, 'JsonUtil');
  initMetadataForClass(StringJsonLexer, 'StringJsonLexer', VOID, JsonLexer);
  initMetadataForObject(BaseJsonReaderSupport, 'BaseJsonReaderSupport');
  initMetadataForInterface(JsonArrayReader, 'JsonArrayReader');
  initMetadataForClass(JsonArrayReaderImpl, 'JsonArrayReaderImpl', VOID, VOID, [JsonArrayReader]);
  initMetadataForClass(JsonObjectReaderImpl, 'JsonObjectReaderImpl');
  initMetadataForClass(CommonApiJsonIterator, 'CommonApiJsonIterator');
  initMetadataForObject(CommonJsonIterSupport, 'CommonJsonIterSupport');
  initMetadataForClass(CommonJsonIteratorFactory, 'CommonJsonIteratorFactory', CommonJsonIteratorFactory);
  initMetadataForObject(Hex, 'Hex');
  initMetadataForClass(JsonException, 'JsonException', VOID, RuntimeException);
  initMetadataForCompanion(Companion_38);
  initMetadataForClass(JsonIterator, 'JsonIterator');
  initMetadataForClass(JsonIterArrayReader, 'JsonIterArrayReader', VOID, VOID, [JsonArrayReader]);
  initMetadataForClass(JsonIterObjectReader, 'JsonIterObjectReader');
  initMetadataForClass(JsonIterReader, 'JsonIterReader', VOID, VOID, [JsonArrayReader]);
  initMetadataForClass(JsonIterReaderFactory, 'JsonIterReaderFactory');
  initMetadataForObject(JsonStreamIterSupport, 'JsonStreamIterSupport');
  initMetadataForObject(CommonJsonStreamIterSupport, 'CommonJsonStreamIterSupport');
  initMetadataForClass(Configuration, 'Configuration', Configuration_init_$Create$);
  initMetadataForClass(ConfigurationPersistentContext, 'ConfigurationPersistentContext');
  initMetadataForClass(ConfigurationPersister, 'ConfigurationPersister');
  initMetadataForInterface(PersistentParameter, 'PersistentParameter');
  initMetadataForObject(LoggingUtils, 'LoggingUtils');
  initMetadataForClass(OtRejectionException, 'OtRejectionException', OtRejectionException, RuntimeException);
  initMetadataForClass(RejectionReason, 'RejectionReason', VOID, Enum);
  initMetadataForClass(ThreadSafeProperty, 'ThreadSafeProperty', VOID, ValueProperty);
  initMetadataForObject(Entities, 'Entities');
  initMetadataForClass(Entity$SafeObservableHashSet$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(ModelListenerData, 'ModelListenerData');
  initMetadataForClass(SafeObservableHashSet, 'SafeObservableHashSet', VOID, ObservableHashSet);
  initMetadataForClass(Entity$modelProperty$1, VOID, VOID, VOID, [Property]);
  initMetadataForClass(Entity$get$1, VOID, VOID, SafeObservableHashSet);
  initMetadataForInterface(EntitySet, 'EntitySet', VOID, VOID, [EventSource, MutableObservableCollection, KtMutableSet, Collection, KtSet]);
  initMetadataForClass(EntityHashSet, 'EntityHashSet', EntityHashSet, AbstractObservableSet, [AbstractObservableSet, EntitySet]);
  initMetadataForClass(SafeEntityHashSet, 'SafeEntityHashSet', VOID, EntityHashSet);
  initMetadataForClass(Entity$get$2, VOID, VOID, SafeEntityHashSet);
  initMetadataForClass(Entity$get$3, VOID, VOID, CollectionAdapter);
  initMetadataForClass(Entity, 'Entity');
  initMetadataForClass(MetaId, 'MetaId', VOID, BaseId);
  initMetadataForClass(RoleId, 'RoleId', VOID, MetaId);
  initMetadataForClass(EntityChildId, 'EntityChildId', VOID, RoleId);
  initMetadataForCompanion(Companion_39);
  initMetadataForClass(EntityConceptId, 'EntityConceptId', EntityConceptId_init_$Create$, MetaId);
  initMetadataForClass(EntityConceptIdFlag, 'EntityConceptIdFlag', VOID, Enum);
  initMetadataForClass(EntityContext$SafeEntityHashSet$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(EntityContext$rootEntities$1, VOID, VOID, SafeEntityHashSet);
  initMetadataForClass(EntityContext$1, VOID, VOID, CollectionAdapter);
  initMetadataForInterface(ModelListener, 'ModelListener');
  initMetadataForClass(ModelAdapter, 'ModelAdapter', VOID, VOID, [ModelListener]);
  initMetadataForClass(EntityContext$watchModelBlob$nodeFeatureChangedRegistration$1, VOID, VOID, ModelAdapter);
  initMetadataForClass(EntityContext, 'EntityContext', EntityContext);
  initMetadataForClass(EntityId, 'EntityId', EntityId_init_$Create$, BaseId);
  initMetadataForClass(EntityModelBlobId, 'EntityModelBlobId', EntityModelBlobId_init_$Create$, BaseId);
  initMetadataForClass(EntityPropertyId, 'EntityPropertyId', EntityPropertyId_init_$Create$, BaseId);
  initMetadataForCompanion(Companion_40);
  initMetadataForClass(EntityReference, 'EntityReference');
  initMetadataForClass(EntityReferenceId, 'EntityReferenceId', VOID, RoleId);
  initMetadataForClass(ReferenceStatus, 'ReferenceStatus', VOID, Enum);
  initMetadataForClass(EntityEvent, 'EntityEvent');
  initMetadataForClass(EntityChildEvent, 'EntityChildEvent', VOID, EntityEvent);
  initMetadataForClass(EntityChildAddedEvent, 'EntityChildAddedEvent', VOID, EntityChildEvent);
  initMetadataForClass(EntityChildRemovedEvent, 'EntityChildRemovedEvent', VOID, EntityChildEvent);
  function onRootAdded(event) {
    this.u35(event);
  }
  function onRootRemoved(event) {
    this.u35(event);
  }
  function onChildAdded(event) {
    this.u35(event);
  }
  function onChildRemoved(event) {
    this.u35(event);
  }
  function onChildMoved(event) {
    this.u35(event);
  }
  function onPropertyChanged(event) {
    this.u35(event);
  }
  function onReferenceAdded(event) {
    this.u35(event);
  }
  function onReferenceRemoved(event) {
    this.u35(event);
  }
  function onModelBlobChanged(event) {
    this.u35(event);
  }
  function onNodeEvent(event) {
    this.u35(event);
  }
  function onEntityFeatureChanged(event) {
  }
  initMetadataForInterface(EntityContextListener, 'EntityContextListener');
  initMetadataForClass(EntityModelBlobChangedEvent, 'EntityModelBlobChangedEvent', VOID, EntityEvent);
  initMetadataForClass(EntityMovedEvent, 'EntityMovedEvent', VOID, EntityEvent);
  initMetadataForClass(EntityNodeEvent, 'EntityNodeEvent', VOID, EntityEvent);
  initMetadataForClass(EntityPropertyChangedEvent, 'EntityPropertyChangedEvent', VOID, EntityEvent);
  initMetadataForClass(EntityReferenceEvent, 'EntityReferenceEvent', VOID, EntityEvent);
  initMetadataForClass(EntityReferenceAddedEvent, 'EntityReferenceAddedEvent', VOID, EntityReferenceEvent);
  initMetadataForClass(EntityReferenceRemovedEvent, 'EntityReferenceRemovedEvent', VOID, EntityReferenceEvent);
  initMetadataForClass(RootAddedEvent, 'RootAddedEvent', VOID, EntityEvent);
  initMetadataForClass(RootRemovedEvent, 'RootRemovedEvent', VOID, EntityEvent);
  initMetadataForClass(EventStateHolder, 'EventStateHolder', EventStateHolder);
  initMetadataForClass(NullEventStateHolder, 'NullEventStateHolder', NullEventStateHolder, EventStateHolder);
  initMetadataForClass(OtException, 'OtException', OtException_init_$Create$, RuntimeException);
  initMetadataForCompanion(Companion_41);
  initMetadataForClass(Json2EntityConverter, 'Json2EntityConverter', Json2EntityConverter);
  initMetadataForClass(Json2NodeConverter, 'Json2NodeConverter');
  initMetadataForCompanion(Companion_42);
  initMetadataForClass(Entity2JsonConverter, 'Entity2JsonConverter', Entity2JsonConverter);
  initMetadataForClass(Node2JsonConverter, 'Node2JsonConverter');
  initMetadataForObject(MessageBundle, 'MessageBundle');
  initMetadataForClass(BaseOtNodeProperty, 'BaseOtNodeProperty', VOID, BaseReadableProperty, [BaseReadableProperty, Property]);
  initMetadataForClass(BaseOtNodeTextProperty$addHandler$$inlined$eventHandler$1);
  initMetadataForClass(BaseOtNodeTextProperty, 'BaseOtNodeTextProperty', VOID, VOID, [ReadableProperty]);
  initMetadataForClass(MetaIdFactory, 'MetaIdFactory');
  initMetadataForClass(UnionNodeCollectionView, 'UnionNodeCollectionView', VOID, AbstractCollection);
  initMetadataForClass(Model, 'Model');
  initMetadataForClass(Node$getTextProperty$1, VOID, VOID, BaseOtNodeTextProperty);
  initMetadataForClass(OtNode, 'OtNode', VOID, VOID, [CollectionListener]);
  initMetadataForClass(Node_0, 'Node', VOID, OtNode);
  initMetadataForClass(NodeChildId, 'NodeChildId', VOID, RoleId);
  initMetadataForObject(NodeChildIdFactory, 'NodeChildIdFactory');
  initMetadataForClass(NodeConceptId, 'NodeConceptId', VOID, MetaId);
  initMetadataForObject(NodeConceptIdFactory, 'NodeConceptIdFactory');
  initMetadataForClass(NodeConceptIdFlag, 'NodeConceptIdFlag', VOID, Enum);
  initMetadataForClass(NodeCopier, 'NodeCopier');
  initMetadataForClass(NodeId, 'NodeId', NodeId, BaseId);
  initMetadataForClass(NodePropertyChangeEvent, 'NodePropertyChangeEvent');
  initMetadataForClass(NodePropertyId, 'NodePropertyId', VOID, BaseId);
  initMetadataForObject(NodePropertyIdFactory, 'NodePropertyIdFactory');
  initMetadataForClass(RemoveChildOperationData, 'RemoveChildOperationData');
  initMetadataForClass(MyProperty, 'MyProperty', VOID, BaseReadableProperty, [BaseReadableProperty, Property]);
  initMetadataForClass(ChildrenObservableList, 'ChildrenObservableList', VOID, ObservableArrayList);
  initMetadataForCompanion(Companion_43);
  initMetadataForClass(OtNode$deepChangeListeners$1, VOID, VOID, EventHandlerListeners);
  initMetadataForClass(OtNode$copy$nodeCopier$1, VOID, VOID, NodeCopier);
  initMetadataForLambda(OtNode$descendants$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(OtNode$allChildren$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(OtNode$addPropertyHandler$$inlined$eventHandler$1);
  function createNode$default(conceptId, nodeId, $super) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(conceptId) : nodeId;
    return $super === VOID ? this.z37(conceptId, nodeId) : $super.z37.call(this, conceptId, nodeId);
  }
  initMetadataForInterface(OtNodeFactory, 'OtNodeFactory');
  initMetadataForClass(PropertyEventHandlerWrapper, 'PropertyEventHandlerWrapper');
  initMetadataForObject(RawNodeFactory, 'RawNodeFactory', VOID, VOID, [OtNodeFactory]);
  initMetadataForClass(NodeEvent, 'NodeEvent');
  initMetadataForClass(NodeChildEvent, 'NodeChildEvent', VOID, NodeEvent);
  initMetadataForClass(NodeChildAddedChildCollectionSplitEvent, 'NodeChildAddedChildCollectionSplitEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodeChildAddedEvent, 'NodeChildAddedEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodeChildAddedPropertySplitEvent, 'NodeChildAddedPropertySplitEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodeChildCollectionMergedChildRemovedEvent, 'NodeChildCollectionMergedChildRemovedEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodeChildRemovedEvent, 'NodeChildRemovedEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodeChildSetEvent, 'NodeChildSetEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodePropertyChangedEvent, 'NodePropertyChangedEvent', VOID, NodeEvent);
  initMetadataForClass(NodeDeletedInPropertyEvent, 'NodeDeletedInPropertyEvent', VOID, NodePropertyChangedEvent);
  initMetadataForClass(NodeInsertedInPropertyEvent, 'NodeInsertedInPropertyEvent', VOID, NodePropertyChangedEvent);
  initMetadataForClass(NodePropertyMergedChildRemovedEvent, 'NodePropertyMergedChildRemovedEvent', VOID, NodeChildEvent);
  initMetadataForClass(NodePropertySetEvent, 'NodePropertySetEvent', VOID, NodeEvent);
  initMetadataForObject(NodeUtil, 'NodeUtil');
  initMetadataForObject(Nodes, 'Nodes');
  function validate(operationRootId, op) {
  }
  function reset() {
  }
  initMetadataForInterface(OperationValidator, 'OperationValidator');
  initMetadataForClass(AddRemoveConsistencyValidator, 'AddRemoveConsistencyValidator', AddRemoveConsistencyValidator, VOID, [OperationValidator]);
  initMetadataForCompanion(Companion_44);
  initMetadataForClass(ErrorAppender, 'ErrorAppender');
  initMetadataForClass(MyEventStateHolder, 'MyEventStateHolder', VOID, EventStateHolder);
  initMetadataForCompanion(Companion_45);
  initMetadataForClass(EntityContextOperationsTracker, 'EntityContextOperationsTracker', VOID, VOID, [Disposable]);
  initMetadataForClass(EntityContextCommandProcessor$1, VOID, VOID, EntityContextOperationsTracker);
  initMetadataForClass(EntityContextCommandProcessor$addOperationValidator$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(EntityContextCommandProcessor$appendToCurrentError$1, VOID, VOID, ErrorAppender);
  initMetadataForClass(EntityContextCommandProcessor$appendToGlobalError$1, VOID, VOID, ErrorAppender);
  initMetadataForClass(EntityContextCommandProcessor, 'EntityContextCommandProcessor', VOID, VOID, [Disposable]);
  initMetadataForClass(ModelOperationsTracker, 'ModelOperationsTracker', VOID, VOID, [ModelListener]);
  initMetadataForClass(MyModelOperationTracker, 'MyModelOperationTracker', MyModelOperationTracker, ModelOperationsTracker);
  initMetadataForCompanion(Companion_46);
  initMetadataForClass(EntityContextOperationsTracker$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(EntityContextOperationsTracker$2, VOID, VOID, VOID, [EntityContextListener]);
  initMetadataForCompanion(Companion_47);
  initMetadataForClass(MergeNavAndEmptyUndoGroupId, 'MergeNavAndEmptyUndoGroupId');
  initMetadataForClass(OtCommandEvent, 'OtCommandEvent');
  function onCommandStarted(event) {
  }
  function onOperationPerformed(op) {
  }
  function onCommandCommitted(op) {
  }
  function onExternalOperationStarted() {
  }
  function onExternalOperationPerformed(op) {
  }
  function onExternalOperationFailed() {
  }
  initMetadataForInterface(OtCommandListener, 'OtCommandListener');
  initMetadataForCompanion(Companion_48);
  initMetadataForClass(EntityAssemblyOperationBuilder, 'EntityAssemblyOperationBuilder');
  initMetadataForObject(EntityPrintOperationUtil, 'EntityPrintOperationUtil');
  initMetadataForClass(Descriptor, 'Descriptor', Descriptor);
  initMetadataForCompanion(Companion_49);
  initMetadataForClass(OperationCondition, 'OperationCondition');
  initMetadataForClass(LeafOperationsCollector, 'LeafOperationsCollector', VOID, OperationCondition);
  initMetadataForObject(OperationBuilder, 'OperationBuilder');
  initMetadataForObject(OperationConverter, 'OperationConverter');
  initMetadataForClass(OperationRootIdInfo, 'OperationRootIdInfo');
  initMetadataForInterface(RootOperation, 'RootOperation');
  function execute$default(model, nodeFactory, $super) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    return $super === VOID ? this.a3k(model, nodeFactory) : $super.a3k.call(this, model, nodeFactory);
  }
  initMetadataForInterface(Operation, 'Operation');
  initMetadataForClass(BaseOperation, 'BaseOperation', VOID, VOID, [Operation]);
  initMetadataForClass(ChildOperation, 'ChildOperation', VOID, BaseOperation);
  initMetadataForInterface(WithConsecutiveOperation, 'WithConsecutiveOperation');
  initMetadataForClass(AddChildOperation, 'AddChildOperation', VOID, ChildOperation, [ChildOperation, WithConsecutiveOperation]);
  initMetadataForInterface(HasOperationTargetData, 'HasOperationTargetData');
  initMetadataForClass(CustomExecuteOperation, 'CustomExecuteOperation', VOID, BaseOperation);
  initMetadataForInterface(OperationContainer, 'OperationContainer');
  initMetadataForClass(TargetedOperation, 'TargetedOperation', VOID, CustomExecuteOperation, [HasOperationTargetData, CustomExecuteOperation, OperationContainer]);
  initMetadataForClass(ChangeChildOperation, 'ChangeChildOperation', VOID, TargetedOperation, [TargetedOperation, WithConsecutiveOperation]);
  initMetadataForClass(ChildOperationUtil, 'ChildOperationUtil', ChildOperationUtil);
  initMetadataForClass(EntityChildOperationData, 'EntityChildOperationData');
  initMetadataForClass(RemoveChildOperation, 'RemoveChildOperation', VOID, ChildOperation);
  initMetadataForClass(RootEntityOperation, 'RootEntityOperation', VOID, BaseOperation, [BaseOperation, RootOperation]);
  initMetadataForClass(AddRootOperation, 'AddRootOperation', VOID, RootEntityOperation, [RootEntityOperation, WithConsecutiveOperation]);
  initMetadataForClass(RootOperationsExecutorChecker, 'RootOperationsExecutorChecker', VOID, VOID, [EntityContextListener]);
  initMetadataForClass(AddRootOperationExecutor$installChecker$1, VOID, VOID, RootOperationsExecutorChecker);
  initMetadataForClass(BaseOperationExecutor, 'BaseOperationExecutor');
  initMetadataForClass(BaseAddOperationExecutor, 'BaseAddOperationExecutor', VOID, BaseOperationExecutor);
  initMetadataForClass(AddRootOperationExecutor, 'AddRootOperationExecutor', AddRootOperationExecutor, BaseAddOperationExecutor);
  initMetadataForClass(BuildRootOperation, 'BuildRootOperation', VOID, BaseOperation, [BaseOperation, RootOperation]);
  initMetadataForClass(ChangeRootEntityOperation, 'ChangeRootEntityOperation', VOID, TargetedOperation, [TargetedOperation, RootOperation, WithConsecutiveOperation]);
  initMetadataForClass(ChangeRootOperationExecutor$installChecker$1, VOID, VOID, RootOperationsExecutorChecker);
  initMetadataForClass(BaseRemoveOperationExecutor, 'BaseRemoveOperationExecutor', VOID, BaseOperationExecutor);
  initMetadataForClass(ChangeRootOperationExecutor, 'ChangeRootOperationExecutor', ChangeRootOperationExecutor, BaseRemoveOperationExecutor);
  initMetadataForClass(RemoveRootOperation, 'RemoveRootOperation', VOID, RootEntityOperation);
  initMetadataForClass(RootOperationData, 'RootOperationData');
  initMetadataForClass(RootOperationUtil, 'RootOperationUtil', RootOperationUtil);
  initMetadataForObject(RootOperationsExecutorUtil, 'RootOperationsExecutorUtil');
  initMetadataForClass(SafeBuildRootOperation, 'SafeBuildRootOperation', VOID, BuildRootOperation);
  initMetadataForClass(UnsafeBuildRootOperation, 'UnsafeBuildRootOperation', VOID, BuildRootOperation);
  initMetadataForClass(EntityDiffBuilder, 'EntityDiffBuilder');
  initMetadataForObject(EntityMessages, 'EntityMessages');
  initMetadataForClass(ModelBlobOperation, 'ModelBlobOperation', VOID, BaseOperation);
  initMetadataForClass(AddModelBlobOperation, 'AddModelBlobOperation', VOID, ModelBlobOperation, [ModelBlobOperation, WithConsecutiveOperation]);
  initMetadataForClass(ModelOperationsExecutorChecker, 'ModelOperationsExecutorChecker', VOID, VOID, [EntityContextListener]);
  initMetadataForClass(AddModelOperationExecutor$installChecker$1, VOID, VOID, ModelOperationsExecutorChecker);
  initMetadataForClass(AddModelOperationExecutor, 'AddModelOperationExecutor', AddModelOperationExecutor, BaseAddOperationExecutor);
  initMetadataForClass(ChangeModelBlobOperation, 'ChangeModelBlobOperation', VOID, TargetedOperation, [TargetedOperation, WithConsecutiveOperation]);
  initMetadataForClass(ChangeModelOperationExecutor$installChecker$1, VOID, VOID, ModelOperationsExecutorChecker);
  initMetadataForClass(ChangeModelOperationExecutor, 'ChangeModelOperationExecutor', ChangeModelOperationExecutor, BaseRemoveOperationExecutor);
  initMetadataForObject(ModelBlobMessages, 'ModelBlobMessages');
  initMetadataForClass(ModelBlobOperationData, 'ModelBlobOperationData');
  initMetadataForClass(ModelBlobOperationUtil, 'ModelBlobOperationUtil', ModelBlobOperationUtil);
  initMetadataForObject(ModelOperationsExecutorUtil, 'ModelOperationsExecutorUtil');
  initMetadataForClass(RemoveModelBlobOperation, 'RemoveModelBlobOperation', VOID, ModelBlobOperation);
  initMetadataForObject(DestroyOperationTransformer, 'DestroyOperationTransformer');
  initMetadataForClass(PathItem, 'PathItem');
  initMetadataForClass(EntityPathItem, 'EntityPathItem', VOID, PathItem);
  initMetadataForCompanion(Companion_50);
  initMetadataForClass(MoveOperation$containsRemoveMovingOperation$1, VOID, VOID, OperationCondition);
  initMetadataForClass(MoveOperation$containsRemoveNewParentOperation$1, VOID, VOID, OperationCondition);
  initMetadataForClass(MoveOperation$containsAddMovingOperation$1, VOID, VOID, OperationCondition);
  initMetadataForClass(MoveOperation, 'MoveOperation', VOID, BaseOperation, [BaseOperation, RootOperation]);
  initMetadataForObject(PathItemUtil, 'PathItemUtil');
  initMetadataForCompanion(Companion_51);
  initMetadataForClass(RolePathItem, 'RolePathItem', VOID, PathItem);
  initMetadataForClass(OrderedOperation, 'OrderedOperation');
  initMetadataForClass(RootOperationTransformer, 'RootOperationTransformer');
  initMetadataForCompanion(Companion_52);
  initMetadataForClass(RootPathItem, 'RootPathItem', VOID, PathItem);
  initMetadataForClass(EntityOperationsExecutorChecker, 'EntityOperationsExecutorChecker', VOID, VOID, [EntityContextListener]);
  initMetadataForClass(AddChildOperationExecutor$installChecker$1, VOID, VOID, EntityOperationsExecutorChecker);
  initMetadataForClass(AddChildOperationExecutor, 'AddChildOperationExecutor', AddChildOperationExecutor, BaseAddOperationExecutor);
  initMetadataForClass(ChangeChildOperationExecutor$installChecker$1, VOID, VOID, EntityOperationsExecutorChecker);
  initMetadataForClass(ChangeChildOperationExecutor, 'ChangeChildOperationExecutor', ChangeChildOperationExecutor, BaseRemoveOperationExecutor);
  initMetadataForCompanion(Companion_53);
  initMetadataForClass(ChildSetOperation, 'ChildSetOperation', VOID, TargetedOperation);
  initMetadataForObject(EntityOperationsExecutorUtil, 'EntityOperationsExecutorUtil');
  initMetadataForClass(SetPropertyOperation, 'SetPropertyOperation', VOID, TargetedOperation);
  initMetadataForCompanion(Companion_54);
  initMetadataForClass(SetReferenceOperation, 'SetReferenceOperation', VOID, TargetedOperation);
  initMetadataForClass(MainOpPos, 'MainOpPos', VOID, Enum);
  initMetadataForInterface(IndexedOperation, 'IndexedOperation', VOID, VOID, [Operation]);
  initMetadataForInterface(IndexedAddOperation, 'IndexedAddOperation', VOID, VOID, [IndexedOperation]);
  initMetadataForClass(IndexedOperationTransformer, 'IndexedOperationTransformer', IndexedOperationTransformer);
  initMetadataForInterface(IndexedRemoveOperation, 'IndexedRemoveOperation', VOID, VOID, [IndexedOperation]);
  initMetadataForInterface(IndexedReplaceOperation, 'IndexedReplaceOperation', VOID, VOID, [IndexedOperation]);
  initMetadataForClass(Priority, 'Priority', VOID, Enum);
  initMetadataForInterface(Accumulator, 'Accumulator');
  initMetadataForClass(AnnotationData, 'AnnotationData', AnnotationData);
  initMetadataForClass(MergerBasedAccumulator, 'MergerBasedAccumulator', VOID, VOID, [Accumulator]);
  initMetadataForClass(AddChangeRemoveAccumulator, 'AddChangeRemoveAccumulator', VOID, MergerBasedAccumulator);
  initMetadataForClass(RootOperationsAccumulator, 'RootOperationsAccumulator', VOID, AddChangeRemoveAccumulator);
  initMetadataForClass(EntityChildAccumulator, 'EntityChildAccumulator', VOID, AddChangeRemoveAccumulator);
  initMetadataForClass(ModelAccumulator, 'ModelAccumulator', VOID, AddChangeRemoveAccumulator);
  initMetadataForCompanion(Companion_55);
  initMetadataForClass(AccumulatorBasedMerger, 'AccumulatorBasedMerger', AccumulatorBasedMerger);
  initMetadataForClass(AddChangeRemoveAccumulator$addOp$1);
  initMetadataForClass(ChangeModelAccumulator, 'ChangeModelAccumulator', ChangeModelAccumulator, MergerBasedAccumulator);
  initMetadataForClass(TargetedOperationAccumulator, 'TargetedOperationAccumulator', VOID, MergerBasedAccumulator);
  initMetadataForClass(EntityChildSetAccumulator, 'EntityChildSetAccumulator', VOID, TargetedOperationAccumulator);
  initMetadataForClass(ReferenceOperationUtil, 'ReferenceOperationUtil', ReferenceOperationUtil);
  initMetadataForClass(EntityReferenceData, 'EntityReferenceData');
  initMetadataForClass(EntityReferenceAccumulator, 'EntityReferenceAccumulator', EntityReferenceAccumulator, AddChangeRemoveAccumulator);
  initMetadataForClass(OperationsInfo, 'OperationsInfo');
  initMetadataForClass(SetPropertyAccumulator, 'SetPropertyAccumulator', VOID, TargetedOperationAccumulator);
  initMetadataForClass(SetReferenceAccumulator, 'SetReferenceAccumulator', VOID, TargetedOperationAccumulator);
  initMetadataForClass(SetValueAccumulator, 'SetValueAccumulator', SetValueAccumulator, VOID, [Accumulator]);
  initMetadataForClass(BaseMergeOperationsRule, 'BaseMergeOperationsRule');
  initMetadataForClass(BaseDataOperationRule, 'BaseDataOperationRule', VOID, BaseMergeOperationsRule);
  initMetadataForClass(BaseMutuallyInverseOperationRule, 'BaseMutuallyInverseOperationRule', VOID, BaseDataOperationRule);
  initMetadataForClass(EntityChildAddRemoveRule, 'EntityChildAddRemoveRule', EntityChildAddRemoveRule, BaseMutuallyInverseOperationRule);
  initMetadataForClass(MergeContainerOperationsRule, 'MergeContainerOperationsRule', VOID, BaseMergeOperationsRule);
  initMetadataForClass(MergeCompositeOperationsRule, 'MergeCompositeOperationsRule', VOID, MergeContainerOperationsRule);
  initMetadataForClass(MergeSetValueOperationsRule, 'MergeSetValueOperationsRule', MergeSetValueOperationsRule, BaseMergeOperationsRule);
  initMetadataForClass(MergeTargetedOperationsRule, 'MergeTargetedOperationsRule', VOID, MergeContainerOperationsRule);
  initMetadataForClass(ModelAddRemoveRule, 'ModelAddRemoveRule', ModelAddRemoveRule, BaseMutuallyInverseOperationRule);
  initMetadataForClass(NodeChildAddRemoveRule, 'NodeChildAddRemoveRule', NodeChildAddRemoveRule, BaseMutuallyInverseOperationRule);
  initMetadataForClass(NodeChildAddReplaceRule, 'NodeChildAddReplaceRule', NodeChildAddReplaceRule, BaseDataOperationRule);
  initMetadataForClass(NodeChildReplaceRemoveRule, 'NodeChildReplaceRemoveRule', NodeChildReplaceRemoveRule, BaseDataOperationRule);
  initMetadataForClass(NodeChildReplaceReplaceRule, 'NodeChildReplaceReplaceRule', NodeChildReplaceReplaceRule, BaseDataOperationRule);
  initMetadataForClass(NopOperationRule, 'NopOperationRule', NopOperationRule, BaseMergeOperationsRule);
  initMetadataForClass(RootAddRemoveRule, 'RootAddRemoveRule', RootAddRemoveRule, BaseMutuallyInverseOperationRule);
  initMetadataForCompanion(Companion_56);
  initMetadataForClass(SimpleAnnotatorPreservingOperationsMerger, 'SimpleAnnotatorPreservingOperationsMerger');
  initMetadataForClass(NodeAssemblyOperationBuilder, 'NodeAssemblyOperationBuilder');
  initMetadataForObject(OperationBuilder_0, 'OperationBuilder');
  initMetadataForClass(BaseListItemOperation, 'BaseListItemOperation', VOID, BaseOperation, [BaseOperation, IndexedOperation]);
  initMetadataForClass(ChildOperation_0, 'ChildOperation', VOID, BaseListItemOperation);
  initMetadataForClass(AddChildOperation_0, 'AddChildOperation', VOID, ChildOperation_0, [ChildOperation_0, IndexedAddOperation, WithConsecutiveOperation]);
  initMetadataForClass(ChangeChildOperation_0, 'ChangeChildOperation', VOID, TargetedOperation, [TargetedOperation, WithConsecutiveOperation]);
  initMetadataForObject(ChildOperationMessages, 'ChildOperationMessages');
  initMetadataForClass(NodeChildOperationData, 'NodeChildOperationData');
  initMetadataForClass(RemoveChildOperation_0, 'RemoveChildOperation', VOID, ChildOperation_0, [ChildOperation_0, IndexedRemoveOperation]);
  initMetadataForCompanion(Companion_57);
  initMetadataForClass(ReplaceChildOperation, 'ReplaceChildOperation', VOID, BaseListItemOperation, [BaseListItemOperation, IndexedReplaceOperation]);
  initMetadataForClass(NodeDiffBuilder, 'NodeDiffBuilder');
  initMetadataForClass(InPlaceNodeDiffBuilder, 'InPlaceNodeDiffBuilder', VOID, NodeDiffBuilder);
  initMetadataForClass(ModifiedSource$addChildAndSplitChildCollection$disposable$1, VOID, VOID, ModelAdapter);
  initMetadataForClass(ModifiedSource$mergeChildCollectionAndRemoveChild$disposable$1, VOID, VOID, ModelAdapter);
  initMetadataForClass(ModifiedSource, 'ModifiedSource');
  initMetadataForObject(NodeDiff, 'NodeDiff');
  initMetadataForClass(MyTask, 'MyTask');
  initMetadataForObject(NodeInspectionUtil, 'NodeInspectionUtil');
  initMetadataForClass(Element_1, 'Element');
  initMetadataForCompanion(Companion_58);
  initMetadataForClass(NodePath, 'NodePath');
  initMetadataForClass(NodeWithRegistry, 'NodeWithRegistry');
  initMetadataForClass(SplitMergeAwareNodeDiffBuilder$MoveToData$Companion$REVERSE_PARENT_ORDER_COMPARATOR$1, VOID, VOID, VOID, [Comparator]);
  initMetadataForCompanion(Companion_59);
  initMetadataForClass(MoveFromData, 'MoveFromData');
  initMetadataForClass(MoveToData, 'MoveToData');
  initMetadataForClass(MyAttachedNode, 'MyAttachedNode', VOID, NodeWithRegistry);
  initMetadataForClass(MyNotAttachedNode, 'MyNotAttachedNode', VOID, NodeWithRegistry);
  initMetadataForClass(SplitMergeAwareNodeDiffBuilder, 'SplitMergeAwareNodeDiffBuilder', VOID, NodeDiffBuilder);
  initMetadataForObject(ModelOperationConverter, 'ModelOperationConverter');
  initMetadataForClass(NodeOperationsExecutorChecker, 'NodeOperationsExecutorChecker', VOID, ModelAdapter);
  initMetadataForClass(NodeChildOperationsExecutorChecker, 'NodeChildOperationsExecutorChecker', VOID, NodeOperationsExecutorChecker);
  initMetadataForClass(AddChildOperationExecutor$installChecker$1_0, VOID, VOID, NodeChildOperationsExecutorChecker);
  initMetadataForClass(AddChildOperationExecutor_0, 'AddChildOperationExecutor', AddChildOperationExecutor_0, BaseAddOperationExecutor);
  initMetadataForClass(ChangeChildOperationExecutor_0, 'ChangeChildOperationExecutor', ChangeChildOperationExecutor_0);
  initMetadataForClass(ChangePropertyOperation, 'ChangePropertyOperation', VOID, TargetedOperation);
  initMetadataForClass(ChildListOperation, 'ChildListOperation', VOID, TargetedOperation);
  initMetadataForObject(NodeOperationsExecutorUtil, 'NodeOperationsExecutorUtil');
  initMetadataForClass(RemoveChildOperationExecutor$installChecker$1, VOID, VOID, NodeChildOperationsExecutorChecker);
  initMetadataForClass(RemoveChildOperationExecutor, 'RemoveChildOperationExecutor', RemoveChildOperationExecutor, BaseRemoveOperationExecutor);
  initMetadataForClass(ReplaceChildOperationExecutor$installChecker$1, VOID, VOID, NodeOperationsExecutorChecker);
  initMetadataForClass(ReplaceChildOperationExecutor, 'ReplaceChildOperationExecutor', ReplaceChildOperationExecutor, BaseOperationExecutor);
  initMetadataForCompanion(Companion_60);
  initMetadataForClass(SetModelOperation, 'SetModelOperation', VOID, TargetedOperation);
  initMetadataForClass(BaseAddChildSplitOperation, 'BaseAddChildSplitOperation', VOID, BaseOperation, [BaseOperation, IndexedAddOperation]);
  initMetadataForClass(AddChildSplitChildCollectionOperation, 'AddChildSplitChildCollectionOperation', VOID, BaseAddChildSplitOperation);
  initMetadataForCompanion(Companion_61);
  initMetadataForClass(AddChildSplitPropertyOperation, 'AddChildSplitPropertyOperation', VOID, BaseAddChildSplitOperation);
  initMetadataForObject(AssertionUtil, 'AssertionUtil');
  initMetadataForCompanion(Companion_62);
  initMetadataForCompanion(Companion_63);
  initMetadataForClass(BaseMergeRemoveChildOperation, 'BaseMergeRemoveChildOperation', VOID, BaseOperation, [BaseOperation, IndexedRemoveOperation]);
  initMetadataForClass(MergeChildCollectionRemoveChildOperation, 'MergeChildCollectionRemoveChildOperation', VOID, BaseMergeRemoveChildOperation);
  initMetadataForClass(MergePropertyRemoveChildOperation, 'MergePropertyRemoveChildOperation', VOID, BaseMergeRemoveChildOperation);
  initMetadataForClass(NodeOperation, 'NodeOperation');
  initMetadataForClass(SplitMergeOperationsUtil$getChildCollectionCompositeOperation$provider$1);
  initMetadataForClass(SplitMergeOperationsUtil$getPropertyCompositeOperation$provider$1);
  initMetadataForClass(SplitMergeOperationsUtil$findListOperation$nodeOperationCondition$1, VOID, VOID, OperationCondition);
  initMetadataForClass(SplitMergeOperationsUtil$findStringOperation$nodeOperationCondition$1, VOID, VOID, OperationCondition);
  initMetadataForObject(SplitMergeOperationsUtil, 'SplitMergeOperationsUtil');
  initMetadataForClass(AnnotatedOperation, 'AnnotatedOperation', VOID, BaseOperation, [BaseOperation, OperationContainer]);
  initMetadataForCompanion(Companion_64);
  initMetadataForClass(CompositeOperation, 'CompositeOperation', VOID, CustomExecuteOperation, [CustomExecuteOperation, OperationContainer]);
  initMetadataForCompanion(Companion_65);
  initMetadataForClass(ExecutionResult, 'ExecutionResult');
  initMetadataForClass(NoSubjectOperation, 'NoSubjectOperation', VOID, BaseOperation);
  initMetadataForClass(NopOperation, 'NopOperation', NopOperation, NoSubjectOperation);
  initMetadataForClass(OperationKind, 'OperationKind', VOID, Enum);
  initMetadataForObject(PrintOperationUtil, 'PrintOperationUtil');
  initMetadataForClass(AnnotatedOperationPersister, 'AnnotatedOperationPersister', AnnotatedOperationPersister);
  initMetadataForClass(CompositeOperationPersister, 'CompositeOperationPersister', CompositeOperationPersister);
  initMetadataForClass(NopOperationPersister, 'NopOperationPersister', NopOperationPersister);
  initMetadataForClass(PersisterNotFoundException, 'PersisterNotFoundException', VOID, RuntimeException);
  initMetadataForClass(OperationPersistenceContext, 'OperationPersistenceContext');
  initMetadataForClass(TargetedOperationPersister, 'TargetedOperationPersister');
  initMetadataForClass(DictionaryAwarePersister, 'DictionaryAwarePersister');
  initMetadataForClass(DictionaryAwareDeserializer, 'DictionaryAwareDeserializer', VOID, DictionaryAwarePersister);
  initMetadataForClass(DictionaryAwareSerializer, 'DictionaryAwareSerializer', VOID, DictionaryAwarePersister);
  initMetadataForClass(ChildOperationPersister, 'ChildOperationPersister');
  initMetadataForClass(AddChildOperationPersister, 'AddChildOperationPersister', AddChildOperationPersister, ChildOperationPersister);
  initMetadataForClass(ChangeChildOperationPersister, 'ChangeChildOperationPersister', ChangeChildOperationPersister);
  initMetadataForClass(RemoveChildOperationPersister, 'RemoveChildOperationPersister', RemoveChildOperationPersister, ChildOperationPersister);
  initMetadataForClass(AddRootOperationPersister, 'AddRootOperationPersister', AddRootOperationPersister);
  initMetadataForClass(Deserializer, 'Deserializer', VOID, DictionaryAwareDeserializer);
  initMetadataForClass(Serializer, 'Serializer', VOID, DictionaryAwareSerializer);
  initMetadataForClass(BuildRootOperationPersister, 'BuildRootOperationPersister', BuildRootOperationPersister);
  initMetadataForClass(ChangeRootEntityOperationPersister, 'ChangeRootEntityOperationPersister', ChangeRootEntityOperationPersister);
  initMetadataForClass(RemoveRootOperationPersister, 'RemoveRootOperationPersister', RemoveRootOperationPersister);
  initMetadataForClass(MetaIdPersister, 'MetaIdPersister', VOID, VOID, [Persister]);
  initMetadataForClass(EntityConceptIdPersister, 'EntityConceptIdPersister', EntityConceptIdPersister, MetaIdPersister);
  initMetadataForClass(BaseIdPersistenceContext, 'BaseIdPersistenceContext');
  initMetadataForClass(EntityIdPersistenceContext, 'EntityIdPersistenceContext', EntityIdPersistenceContext, BaseIdPersistenceContext);
  initMetadataForClass(RoleIdPersister, 'RoleIdPersister', VOID, MetaIdPersister);
  initMetadataForClass(EntityIdPersisters$childIdPersister$1, VOID, VOID, RoleIdPersister);
  initMetadataForClass(EntityIdPersisters$referenceIdPersister$1, VOID, VOID, RoleIdPersister);
  initMetadataForClass(EntityIdPersisters$entityReferencePersister$1, VOID, VOID, VOID, [Persister]);
  initMetadataForObject(EntityIdPersisters, 'EntityIdPersisters');
  initMetadataForClass(DefaultIdPersister, 'DefaultIdPersister', VOID, VOID, [Persister]);
  initMetadataForClass(PrivateEntityIdPersisters$idPersister$1, VOID, VOID, DefaultIdPersister);
  initMetadataForClass(PrivateEntityIdPersisters$propertyIdPersister$1, VOID, VOID, DefaultIdPersister);
  initMetadataForClass(PrivateEntityIdPersisters$modelBlobIdPersister$1, VOID, VOID, DefaultIdPersister);
  initMetadataForObject(PrivateEntityIdPersisters, 'PrivateEntityIdPersisters');
  initMetadataForClass(ModelBlobOperationPersister, 'ModelBlobOperationPersister');
  initMetadataForClass(AddModelBlobOperationPersister, 'AddModelBlobOperationPersister', AddModelBlobOperationPersister, ModelBlobOperationPersister);
  initMetadataForClass(ChangeModelBlobOperationPersister, 'ChangeModelBlobOperationPersister', VOID, TargetedOperationPersister);
  initMetadataForClass(RemoveModelBlobOperationPersister, 'RemoveModelBlobOperationPersister', RemoveModelBlobOperationPersister, ModelBlobOperationPersister);
  initMetadataForObject(EntityIdModelKinds, 'EntityIdModelKinds');
  initMetadataForObject(EntityModelKinds, 'EntityModelKinds');
  initMetadataForClass(MoveOperationPersister, 'MoveOperationPersister', MoveOperationPersister);
  initMetadataForCompanion(Companion_66);
  initMetadataForClass(EntityOperationPersistenceContext, 'EntityOperationPersistenceContext', EntityOperationPersistenceContext, OperationPersistenceContext);
  initMetadataForClass(ChildSetOperationPersister, 'ChildSetOperationPersister', ChildSetOperationPersister);
  initMetadataForClass(SetPropertyOperationPersister, 'SetPropertyOperationPersister', SetPropertyOperationPersister);
  initMetadataForClass(SetReferenceOperationPersister, 'SetReferenceOperationPersister', SetReferenceOperationPersister);
  initMetadataForClass(MyPersister, 'MyPersister');
  initMetadataForClass(IdCompressor, 'IdCompressor');
  initMetadataForClass(SelfUpdatingIdCompressor, 'SelfUpdatingIdCompressor', VOID, IdCompressor);
  initMetadataForClass(BulkUpdateIdCompressor, 'BulkUpdateIdCompressor', VOID, SelfUpdatingIdCompressor);
  initMetadataForClass(CompressingIdPersister, 'CompressingIdPersister', VOID, VOID, [Persister]);
  initMetadataForCompanion(Companion_67);
  initMetadataForClass(DefaultSelfUpdatingIdCompressor, 'DefaultSelfUpdatingIdCompressor', DefaultSelfUpdatingIdCompressor_init_$Create$, BulkUpdateIdCompressor);
  initMetadataForClass(NullableIdPersister, 'NullableIdPersister', VOID, VOID, [NonNullPersister]);
  initMetadataForClass(IdPersisters$ENTITY_ID_PERSISTER$1, VOID, VOID, NullableIdPersister);
  initMetadataForClass(IdPersisters$NODE_ID_PERSISTER$1, VOID, VOID, NullableIdPersister);
  initMetadataForObject(IdPersisters, 'IdPersisters');
  initMetadataForCompanion(Companion_68);
  initMetadataForClass(ShortcutConverter, 'ShortcutConverter', ShortcutConverter);
  initMetadataForClass(UpdatableIdCompressor, 'UpdatableIdCompressor', UpdatableIdCompressor, IdCompressor);
  initMetadataForClass(ModelKind, 'ModelKind');
  initMetadataForClass(ChildOperationPersister_0, 'ChildOperationPersister');
  initMetadataForClass(AddChildOperationPersister_0, 'AddChildOperationPersister', AddChildOperationPersister_0, ChildOperationPersister_0);
  initMetadataForClass(ChangeChildOperationPersister_0, 'ChangeChildOperationPersister', ChangeChildOperationPersister_0);
  initMetadataForClass(RemoveChildOperationPersister_0, 'RemoveChildOperationPersister', RemoveChildOperationPersister_0, ChildOperationPersister_0);
  initMetadataForClass(ReplaceChildOperationPersister, 'ReplaceChildOperationPersister', ReplaceChildOperationPersister);
  initMetadataForClass(NodeConceptIdPersister, 'NodeConceptIdPersister', NodeConceptIdPersister, MetaIdPersister);
  initMetadataForClass(NodeIdPersistenceContext, 'NodeIdPersistenceContext', NodeIdPersistenceContext, BaseIdPersistenceContext);
  initMetadataForClass(NodeIdPersisters$childIdPersister$1, VOID, VOID, RoleIdPersister);
  initMetadataForObject(NodeIdPersisters, 'NodeIdPersisters');
  initMetadataForClass(PrivateNodeIdPersisters$propertyIdPersister$basePersister$1, VOID, VOID, DefaultIdPersister);
  initMetadataForObject(PrivateNodeIdPersisters, 'PrivateNodeIdPersisters');
  initMetadataForObject(NodeIdModelKinds, 'NodeIdModelKinds');
  initMetadataForObject(NodeModelKinds, 'NodeModelKinds');
  initMetadataForClass(ChangePropertyOperationPersister, 'ChangePropertyOperationPersister', ChangePropertyOperationPersister);
  initMetadataForClass(ChildListOperationPersister, 'ChildListOperationPersister', VOID, TargetedOperationPersister);
  initMetadataForClass(NodeOperationsPersistenceContext, 'NodeOperationsPersistenceContext', VOID, OperationPersistenceContext);
  initMetadataForClass(SetModelOperationPersister, 'SetModelOperationPersister', SetModelOperationPersister, TargetedOperationPersister);
  initMetadataForClass(BaseAddChildSplitOperationPersister, 'BaseAddChildSplitOperationPersister');
  initMetadataForClass(AddChildSplitChildCollectionOperationPersister, 'AddChildSplitChildCollectionOperationPersister', AddChildSplitChildCollectionOperationPersister, BaseAddChildSplitOperationPersister);
  initMetadataForClass(AddChildSplitPropertyOperationPersister, 'AddChildSplitPropertyOperationPersister', AddChildSplitPropertyOperationPersister, BaseAddChildSplitOperationPersister);
  initMetadataForClass(BaseMergeRemoveChildOperationPersister, 'BaseMergeRemoveChildOperationPersister');
  initMetadataForClass(DeserializationData, 'DeserializationData');
  initMetadataForClass(MergeChildCollectionRemoveChildOperationPersister, 'MergeChildCollectionRemoveChildOperationPersister', MergeChildCollectionRemoveChildOperationPersister, BaseMergeRemoveChildOperationPersister);
  initMetadataForClass(MergePropertyRemoveChildOperationPersister, 'MergePropertyRemoveChildOperationPersister', MergePropertyRemoveChildOperationPersister, BaseMergeRemoveChildOperationPersister);
  initMetadataForClass(ChangeSetOperationPersister, 'ChangeSetOperationPersister');
  initMetadataForClass(AddToSetOperationPersister, 'AddToSetOperationPersister', VOID, ChangeSetOperationPersister);
  initMetadataForClass(RemoveFromSetOperationPersister, 'RemoveFromSetOperationPersister', VOID, ChangeSetOperationPersister);
  initMetadataForCompanion(Companion_69);
  initMetadataForClass(DeleteTextOperationPersister, 'DeleteTextOperationPersister', DeleteTextOperationPersister);
  initMetadataForClass(InsertTextOperationsPersister, 'InsertTextOperationsPersister', InsertTextOperationsPersister);
  initMetadataForClass(SetValueOperationPersister, 'SetValueOperationPersister');
  initMetadataForClass(ChangeSetOperation, 'ChangeSetOperation', VOID, BaseOperation);
  initMetadataForClass(AddToSetOperation, 'AddToSetOperation', VOID, ChangeSetOperation);
  initMetadataForClass(RemoveFromSetOperation, 'RemoveFromSetOperation', VOID, ChangeSetOperation);
  initMetadataForClass(TextOperation, 'TextOperation', VOID, BaseOperation, [BaseOperation, IndexedOperation]);
  initMetadataForClass(DeleteTextOperation, 'DeleteTextOperation', VOID, TextOperation, [TextOperation, IndexedRemoveOperation]);
  initMetadataForClass(InsertTextOperation, 'InsertTextOperation', VOID, TextOperation, [TextOperation, IndexedAddOperation]);
  initMetadataForObject(TextOperationUtil, 'TextOperationUtil');
  initMetadataForClass(SetValueOperation, 'SetValueOperation', VOID, BaseOperation);
  initMetadataForClass(OtTransactionState, 'OtTransactionState', VOID, Enum);
  initMetadataForClass(UndoStackImpl, 'UndoStackImpl');
  initMetadataForClass(UndoCommandListener, 'UndoCommandListener', VOID, VOID, [OtCommandListener]);
  initMetadataForClass(BaseUndoManager$addStateProvider$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(BaseUndoManager, 'BaseUndoManager', VOID, VOID, [Disposable]);
  initMetadataForInterface(OtAware, 'OtAware');
  initMetadataForClass(SimpleUndoStackId, 'SimpleUndoStackId');
  initMetadataForClass(Kind, 'Kind', VOID, Enum);
  initMetadataForClass(UndoRejectionInfo, 'UndoRejectionInfo');
  initMetadataForCompanion(Companion_70);
  initMetadataForClass(UndoState, 'UndoState');
  initMetadataForObject(UndoUtils, 'UndoUtils');
  initMetadataForClass(UndoableCommand, 'UndoableCommand');
  initMetadataForClass(UndoableCommandData, 'UndoableCommandData');
  initMetadataForClass(UndoableCommandDataBuilder, 'UndoableCommandDataBuilder');
  initMetadataForClass(Kind_0, 'Kind', VOID, Enum);
  initMetadataForClass(UndoableTransaction, 'UndoableTransaction');
  initMetadataForInterface(ViewStateProvider, 'ViewStateProvider');
  initMetadataForClass(UndoCommandType, 'UndoCommandType', VOID, Enum);
  initMetadataForClass(SingleStackUndoManager$simpleStateProperty$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(SingleStackUndoManager, 'SingleStackUndoManager', VOID, BaseUndoManager);
  initMetadataForClass(Command, 'Command');
  initMetadataForClass(CommandId, 'CommandId', CommandId_init_$Create$, BaseId);
  initMetadataForClass(LoadCommandId, 'LoadCommandId');
  initMetadataForCompanion(Companion_71);
  initMetadataForClass(OtOperationRecord, 'OtOperationRecord');
  initMetadataForClass(RootCommandId, 'RootCommandId');
  initMetadataForCompanion(Companion_72);
  initMetadataForClass(RoleIdFlag, 'RoleIdFlag', VOID, Enum);
  initMetadataForClass(AdditionalModelContext, 'AdditionalModelContext', AdditionalModelContext);
  initMetadataForClass(EntityWrapper$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(EntityWrapper, 'EntityWrapper');
  initMetadataForClass(NodeWrapper$parentProperty$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(NodeWrapper$propertyByStringProperty$1, VOID, VOID, BaseReadableProperty, [BaseReadableProperty, Property]);
  initMetadataForClass(NodeWrapper, 'NodeWrapper');
  initMetadataForClass(NodeWrapperFactory, 'NodeWrapperFactory');
  initMetadataForClass(DefaultLoadingPeer, 'DefaultLoadingPeer');
  initMetadataForCompanion(Companion_73);
  initMetadataForClass(WrapperContext$1);
  initMetadataForClass(WrapperContext$modelAttachListener$1);
  initMetadataForClass(WrapperContext$watchModel$disposable$1);
  initMetadataForClass(WrapperContext$put$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(WrapperContext, 'WrapperContext', VOID, VOID, [Disposable]);
  initMetadataForClass(WrapperContextKey, 'WrapperContextKey');
  initMetadataForObject(WrapperContextService, 'WrapperContextService', VOID, VOID, [Key_5]);
  function onReferencedEntityAdded() {
  }
  function onReferencedEntityRemoved() {
  }
  initMetadataForInterface(ReferenceListener, 'ReferenceListener');
  initMetadataForClass(AlreadyInvalidException, 'AlreadyInvalidException', VOID, Exception);
  initMetadataForClass(Invalidation$ALWAYS_INVALIDATE$1);
  initMetadataForObject(Invalidation, 'Invalidation');
  initMetadataForClass(ValueHolder, 'ValueHolder');
  initMetadataForClass(EagerInvalidatable$myListeners$1, VOID, VOID, EventHandlerListeners);
  initMetadataForClass(EagerInvalidatable$recompute$1);
  initMetadataForClass(EagerInvalidatable, 'EagerInvalidatable', VOID, VOID, [ReadableProperty]);
  initMetadataForClass(InvalidatableBase, 'InvalidatableBase');
  initMetadataForClass(InvalidationPointBase$addHandler$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(InvalidationPointBase, 'InvalidationPointBase', VOID, VOID, [EventSource]);
  initMetadataForClass(Dependencies, 'Dependencies', Dependencies);
  initMetadataForClass(SourceKey, 'SourceKey');
  initMetadataForClass(Invalidator$1, VOID, VOID, InvalidationPointBase);
  initMetadataForClass(Invalidator$createEventHandler$1);
  initMetadataForClass(Invalidator$createEventHandler$$inlined$eventHandler$1);
  initMetadataForClass(Invalidator$value$2, VOID, VOID, InvalidatableBase);
  initMetadataForClass(Invalidator$failure$2, VOID, VOID, InvalidatableBase);
  initMetadataForClass(Invalidator, 'Invalidator', Invalidator, VOID, [Disposable]);
  initMetadataForClass(NonTrackingInvalidationContext$Companion$INVALIDATION_POINT$1, VOID, VOID, InvalidationPointBase);
  initMetadataForCompanion(Companion_74);
  initMetadataForClass(NonTrackingInvalidationContext$value$1, VOID, VOID, InvalidatableBase);
  initMetadataForClass(NonTrackingInvalidationContext$failure$1, VOID, VOID, InvalidatableBase);
  initMetadataForClass(NonTrackingInvalidationContext, 'NonTrackingInvalidationContext', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_75);
  initMetadataForClass(InvalidateOnAttributeChanged, 'InvalidateOnAttributeChanged');
  function runSuspend(builder, $completion) {
    return this.d4x(builder);
  }
  initMetadataForInterface(Query, 'Query', VOID, VOID, VOID, [1]);
  initMetadataForClass(attributeQuery$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(Execution, 'Execution');
  initMetadataForClass(Result_0, 'Result');
  initMetadataForClass(Ready, 'Ready', VOID, Result_0);
  initMetadataForObject(NotReady, 'NotReady', VOID, Result_0);
  initMetadataForClass(Outcome, 'Outcome');
  initMetadataForClass(Success, 'Success', VOID, Outcome);
  initMetadataForClass(Failure_0, 'Failure', VOID, Outcome);
  initMetadataForLambda(LoopingQuery$_init_$slambda_vmyece, CoroutineImpl, VOID, [1]);
  initMetadataForClass(LoopingQuery$listeners$1, VOID, VOID, Listeners);
  initMetadataForLambda(LoopingQuery$launchComputingJob$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(LoopingQuery, 'LoopingQuery', VOID, VOID, [ReadableProperty]);
  function get_size() {
    var tmp = this.n4z();
    return attributeQuery(tmp, QCollectionBase$_get_size_$lambda_5cjhst);
  }
  function contains(element) {
    var tmp = this.n4z();
    return attributeQuery(tmp, QCollectionBase$contains$lambda(element));
  }
  initMetadataForInterface(QCollectionBase, 'QCollectionBase', VOID, VOID, [Query], [1]);
  function add(element) {
    return execute_0(this).e(element);
  }
  function addAll(elements) {
    return execute_0(this).o(elements);
  }
  function clear() {
    return execute_0(this).m2();
  }
  initMetadataForInterface(QMutableCollectionBase, 'QMutableCollectionBase', VOID, VOID, [QCollectionBase], [1]);
  function add_0(index, element) {
    return execute_0(this).p2(index, element);
  }
  initMetadataForInterface(QMutableListBase, 'QMutableListBase', VOID, VOID, [QMutableCollectionBase, QCollectionBase], [1]);
  initMetadataForInterface(QProperty, 'QProperty', VOID, VOID, [Query, WritableProperty], [1]);
  initMetadataForClass(toReified$1, VOID, VOID, VOID, [QProperty], [1]);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_1, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForObject(QueryInit, 'QueryInit');
  initMetadataForClass(constant$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_2, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForLambda(supervise$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($executeCOROUTINE$0, CoroutineImpl);
  initMetadataForCoroutine($superviseCOROUTINE$1, CoroutineImpl);
  initMetadataForCompanion(Companion_76);
  initMetadataForClass(QueryBuilder, 'QueryBuilder', VOID, VOID, VOID, [0]);
  initMetadataForCoroutine($runSuspendCOROUTINE$5, CoroutineImpl);
  initMetadataForClass(waitUntilNot$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(QPropertyAdapter, 'QPropertyAdapter', VOID, VOID, [QProperty], [1]);
  initMetadataForClass(QMutableListAdapter, 'QMutableListAdapter', VOID, VOID, [QMutableListBase], [1]);
  initMetadataForClass(QTextPropertyAdapter, 'QTextPropertyAdapter', VOID, VOID, [Query], [1]);
  initMetadataForClass(QReadablePropertyAdapter, 'QReadablePropertyAdapter', VOID, VOID, [Query], [1]);
  initMetadataForClass(QListAdapter, 'QListAdapter', VOID, VOID, [QCollectionBase], [1]);
  initMetadataForClass(QCollectionAdapter, 'QCollectionAdapter', VOID, VOID, [QCollectionBase], [1]);
  initMetadataForClass(QMutableCollectionAdapter, 'QMutableCollectionAdapter', VOID, VOID, [QMutableCollectionBase], [1]);
  initMetadataForClass(asProperty$1);
  function parseString$default(string, base, $super) {
    base = base === VOID ? 10 : base;
    return $super === VOID ? this.p52(string, base) : $super.p52.call(this, string, base);
  }
  function tryFromFloat$default(float, exactRequired, $super) {
    exactRequired = exactRequired === VOID ? false : exactRequired;
    return $super === VOID ? this.s52(float, exactRequired) : $super.s52.call(this, float, exactRequired);
  }
  function tryFromDouble$default(double, exactRequired, $super) {
    exactRequired = exactRequired === VOID ? false : exactRequired;
    return $super === VOID ? this.u52(double, exactRequired) : $super.u52.call(this, double, exactRequired);
  }
  initMetadataForInterface(Creator, 'Creator');
  function plus_1(other) {
    return this.x52().z52(other);
  }
  function minus(other) {
    return this.x52().b53(other);
  }
  function times(other) {
    return this.x52().d53(other);
  }
  function div(other) {
    return this.x52().f53(other);
  }
  function plus_2(int) {
    return this.x52().z52(this.w52().r52(int));
  }
  function times_0(int) {
    return this.x52().d53(this.w52().r52(int));
  }
  function minus_0(int) {
    return this.x52().b53(this.w52().r52(int));
  }
  function div_0(int) {
    return this.x52().f53(this.w52().r52(int));
  }
  function rem(int) {
    return this.x52().l53(this.w52().r52(int));
  }
  initMetadataForInterface(CommonBigNumberOperations, 'CommonBigNumberOperations');
  initMetadataForClass(SignificantDecider, 'SignificantDecider', VOID, Enum);
  initMetadataForCompanion(Companion_77, VOID, [Creator]);
  initMetadataForClass(ScaleOps, 'ScaleOps', VOID, Enum);
  initMetadataForClass(BigDecimal, 'BigDecimal', VOID, VOID, [CommonBigNumberOperations, Comparable]);
  initMetadataForCompanion(Companion_78);
  initMetadataForClass(DecimalMode, 'DecimalMode', DecimalMode);
  initMetadataForClass(RoundingMode, 'RoundingMode', VOID, Enum);
  initMetadataForCompanion(Companion_79, VOID, [Creator]);
  initMetadataForClass(QuotientAndRemainder, 'QuotientAndRemainder');
  initMetadataForClass(BigInteger, 'BigInteger', VOID, VOID, [CommonBigNumberOperations, Comparable]);
  initMetadataForClass(Sign, 'Sign', VOID, Enum);
  initMetadataForClass(Platform, 'Platform', VOID, Enum);
  initMetadataForClass(Sextuple, 'Sextuple');
  initMetadataForClass(Quadruple, 'Quadruple');
  initMetadataForClass(SignedUIntArray, 'SignedUIntArray');
  initMetadataForObject(BigInteger32Arithmetic, 'BigInteger32Arithmetic');
  initMetadataForClass(SignedULongArray, 'SignedULongArray');
  initMetadataForObject(BigInteger63Arithmetic, 'BigInteger63Arithmetic');
  initMetadataForObject(RuntimePlatform, 'RuntimePlatform');
  initMetadataForInterface(SerializationStrategy, 'SerializationStrategy');
  initMetadataForInterface(DeserializationStrategy, 'DeserializationStrategy');
  initMetadataForInterface(KSerializer, 'KSerializer', VOID, VOID, [SerializationStrategy, DeserializationStrategy]);
  initMetadataForClass(ContextualSerializer, 'ContextualSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PolymorphicSerializer, 'PolymorphicSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForClass(SealedClassSerializer$$inlined$groupingBy$1);
  initMetadataForClass(SealedClassSerializer, 'SealedClassSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForInterface(BinaryFormat, 'BinaryFormat');
  initMetadataForInterface(StringFormat, 'StringFormat');
  initMetadataForClass(SerializationException, 'SerializationException', SerializationException_init_$Create$, IllegalArgumentException);
  initMetadataForClass(UnknownFieldException, 'UnknownFieldException', VOID, SerializationException);
  initMetadataForClass(MissingFieldException, 'MissingFieldException', VOID, SerializationException);
  function get_isNullable() {
    return false;
  }
  function get_isInline() {
    return false;
  }
  function get_annotations() {
    return emptyList();
  }
  initMetadataForInterface(SerialDescriptor, 'SerialDescriptor');
  initMetadataForClass(ContextDescriptor, 'ContextDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(elementDescriptors$1);
  initMetadataForClass(elementDescriptors$$inlined$Iterable$1);
  initMetadataForClass(elementNames$1);
  initMetadataForClass(elementNames$$inlined$Iterable$1);
  initMetadataForClass(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder');
  initMetadataForInterface(CachedNames, 'CachedNames');
  initMetadataForClass(SerialDescriptorImpl, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(SerialKind, 'SerialKind');
  initMetadataForObject(ENUM, 'ENUM', VOID, SerialKind);
  initMetadataForObject(CONTEXTUAL, 'CONTEXTUAL', VOID, SerialKind);
  initMetadataForClass(PrimitiveKind, 'PrimitiveKind', VOID, SerialKind);
  initMetadataForObject(BOOLEAN, 'BOOLEAN', VOID, PrimitiveKind);
  initMetadataForObject(BYTE, 'BYTE', VOID, PrimitiveKind);
  initMetadataForObject(CHAR, 'CHAR', VOID, PrimitiveKind);
  initMetadataForObject(SHORT, 'SHORT', VOID, PrimitiveKind);
  initMetadataForObject(INT, 'INT', VOID, PrimitiveKind);
  initMetadataForObject(LONG, 'LONG', VOID, PrimitiveKind);
  initMetadataForObject(FLOAT, 'FLOAT', VOID, PrimitiveKind);
  initMetadataForObject(DOUBLE, 'DOUBLE', VOID, PrimitiveKind);
  initMetadataForObject(STRING, 'STRING', VOID, PrimitiveKind);
  initMetadataForClass(StructureKind, 'StructureKind', VOID, SerialKind);
  initMetadataForObject(CLASS, 'CLASS', VOID, StructureKind);
  initMetadataForObject(LIST, 'LIST', VOID, StructureKind);
  initMetadataForObject(MAP, 'MAP', VOID, StructureKind);
  initMetadataForObject(OBJECT, 'OBJECT', VOID, StructureKind);
  initMetadataForClass(PolymorphicKind, 'PolymorphicKind', VOID, SerialKind);
  initMetadataForObject(SEALED_0, 'SEALED', VOID, PolymorphicKind);
  initMetadataForObject(OPEN, 'OPEN', VOID, PolymorphicKind);
  function decodeSerializableValue(deserializer) {
    return deserializer.k5d(this);
  }
  initMetadataForInterface(Decoder, 'Decoder');
  function decodeSequentially() {
    return false;
  }
  function decodeCollectionSize(descriptor) {
    return -1;
  }
  function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
    previousValue = previousValue === VOID ? null : previousValue;
    return $super === VOID ? this.v5g(descriptor, index, deserializer, previousValue) : $super.v5g.call(this, descriptor, index, deserializer, previousValue);
  }
  initMetadataForInterface(CompositeDecoder, 'CompositeDecoder');
  initMetadataForClass(AbstractDecoder, 'AbstractDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  function encodeNotNullMark() {
  }
  function beginCollection(descriptor, collectionSize) {
    return this.j5g(descriptor);
  }
  function encodeSerializableValue(serializer, value) {
    serializer.j5d(this, value);
  }
  function encodeNullableSerializableValue(serializer, value) {
    var isNullabilitySupported = serializer.w5c().l5e();
    if (isNullabilitySupported) {
      return this.i5d(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
    }
    if (value == null) {
      this.d5h();
    } else {
      this.c5i();
      this.i5d(serializer, value);
    }
  }
  initMetadataForInterface(Encoder, 'Encoder');
  function shouldEncodeElementDefault(descriptor, index) {
    return true;
  }
  initMetadataForInterface(CompositeEncoder, 'CompositeEncoder');
  initMetadataForClass(AbstractEncoder, 'AbstractEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForObject(NothingSerializer_0, 'NothingSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DurationSerializer, 'DurationSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(ListLikeDescriptor, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(ArrayListClassDesc, 'ArrayListClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(HashSetClassDesc, 'HashSetClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(MapLikeDescriptor, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(HashMapClassDesc, 'HashMapClassDesc', VOID, MapLikeDescriptor);
  initMetadataForClass(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc', VOID, MapLikeDescriptor);
  initMetadataForClass(ArrayClassDesc, 'ArrayClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor', VOID, ListLikeDescriptor);
  initMetadataForClass(AbstractCollectionSerializer, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(CollectionLikeSerializer, 'CollectionLikeSerializer', VOID, AbstractCollectionSerializer);
  initMetadataForClass(CollectionSerializer, 'CollectionSerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(ArrayListSerializer, 'ArrayListSerializer', VOID, CollectionSerializer);
  initMetadataForClass(HashSetSerializer, 'HashSetSerializer', VOID, CollectionSerializer);
  initMetadataForClass(LinkedHashSetSerializer, 'LinkedHashSetSerializer', VOID, CollectionSerializer);
  initMetadataForClass(MapLikeSerializer, 'MapLikeSerializer', VOID, AbstractCollectionSerializer);
  initMetadataForClass(HashMapSerializer, 'HashMapSerializer', VOID, MapLikeSerializer);
  initMetadataForClass(LinkedHashMapSerializer, 'LinkedHashMapSerializer', VOID, MapLikeSerializer);
  initMetadataForClass(ReferenceArraySerializer, 'ReferenceArraySerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(PrimitiveArraySerializer, 'PrimitiveArraySerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder');
  initMetadataForCompanion(Companion_80);
  initMetadataForClass(ElementMarker, 'ElementMarker');
  initMetadataForClass(EnumSerializer, 'EnumSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(EnumDescriptor, 'EnumDescriptor', VOID, PluginGeneratedSerialDescriptor);
  initMetadataForClass(InlineClassDescriptor, 'InlineClassDescriptor', VOID, PluginGeneratedSerialDescriptor);
  function typeParametersSerializers() {
    return get_EMPTY_SERIALIZER_ARRAY();
  }
  initMetadataForInterface(GeneratedSerializer, 'GeneratedSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(InlinePrimitiveDescriptor$1, VOID, VOID, VOID, [GeneratedSerializer]);
  initMetadataForObject(NoOpEncoder, 'NoOpEncoder', VOID, AbstractEncoder);
  initMetadataForObject(NothingSerialDescriptor, 'NothingSerialDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(NullableSerializer, 'NullableSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(SerialDescriptorForNullable, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(ObjectSerializer, 'ObjectSerializer', VOID, VOID, [KSerializer]);
  initMetadataForInterface(SerializerFactory, 'SerializerFactory');
  initMetadataForObject(CharArraySerializer_0, 'CharArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(DoubleArraySerializer_0, 'DoubleArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(FloatArraySerializer_0, 'FloatArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(LongArraySerializer_0, 'LongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(ULongArraySerializer_0, 'ULongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(IntArraySerializer_0, 'IntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(UIntArraySerializer_0, 'UIntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(ShortArraySerializer_0, 'ShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(UShortArraySerializer_0, 'UShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(ByteArraySerializer_0, 'ByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(UByteArraySerializer_0, 'UByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(BooleanArraySerializer_0, 'BooleanArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForClass(CharArrayBuilder, 'CharArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(DoubleArrayBuilder, 'DoubleArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(FloatArrayBuilder, 'FloatArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(LongArrayBuilder, 'LongArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ULongArrayBuilder, 'ULongArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(IntArrayBuilder, 'IntArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UIntArrayBuilder, 'UIntArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ShortArrayBuilder, 'ShortArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UShortArrayBuilder, 'UShortArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UByteArrayBuilder, 'UByteArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(BooleanArrayBuilder, 'BooleanArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForObject(StringSerializer, 'StringSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(CharSerializer, 'CharSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DoubleSerializer, 'DoubleSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(FloatSerializer, 'FloatSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(LongSerializer, 'LongSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(IntSerializer, 'IntSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ShortSerializer, 'ShortSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ByteSerializer, 'ByteSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(BooleanSerializer, 'BooleanSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UnitSerializer, 'UnitSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PrimitiveSerialDescriptor_0, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(TaggedEncoder, 'TaggedEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForClass(NamedValueEncoder, 'NamedValueEncoder', VOID, TaggedEncoder);
  initMetadataForClass(TaggedDecoder, 'TaggedDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  initMetadataForClass(NamedValueDecoder, 'NamedValueDecoder', VOID, TaggedDecoder);
  initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
  initMetadataForClass(KeyValueSerializer, 'KeyValueSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(MapEntrySerializer_0, 'MapEntrySerializer', VOID, KeyValueSerializer);
  initMetadataForClass(PairSerializer_0, 'PairSerializer', VOID, KeyValueSerializer);
  initMetadataForClass(TripleSerializer_0, 'TripleSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ULongSerializer, 'ULongSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UIntSerializer, 'UIntSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UShortSerializer, 'UShortSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UByteSerializer, 'UByteSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(SerializersModule, 'SerializersModule');
  initMetadataForClass(SerialModuleImpl, 'SerialModuleImpl', VOID, SerializersModule);
  initMetadataForClass(ContextualProvider, 'ContextualProvider');
  initMetadataForClass(Argless, 'Argless', VOID, ContextualProvider);
  initMetadataForClass(WithTypeArguments, 'WithTypeArguments', VOID, ContextualProvider);
  function contextual(kClass, serializer) {
    return this.l5x(kClass, SerializersModuleCollector$contextual$lambda(serializer));
  }
  initMetadataForInterface(SerializersModuleCollector, 'SerializersModuleCollector');
  initMetadataForClass(SerializersModuleBuilder, 'SerializersModuleBuilder', VOID, VOID, [SerializersModuleCollector]);
  initMetadataForClass(SerializerAlreadyRegisteredException, 'SerializerAlreadyRegisteredException', VOID, IllegalArgumentException);
  initMetadataForClass(SerializableWith, 'SerializableWith', VOID, VOID, VOID, VOID, 0);
  initMetadataForClass(createCache$1);
  initMetadataForClass(createParametrizedCache$1);
  initMetadataForClass(ProtoBuf, 'ProtoBuf', VOID, VOID, [BinaryFormat]);
  initMetadataForObject(Default_0, 'Default', VOID, ProtoBuf);
  initMetadataForClass(ProtoBufBuilder, 'ProtoBufBuilder');
  initMetadataForClass(ProtoBufImpl, 'ProtoBufImpl', VOID, ProtoBuf);
  initMetadataForClass(ProtoIntegerType, 'ProtoIntegerType', VOID, Enum);
  initMetadataForClass(ProtoNumber, 'ProtoNumber');
  initMetadataForClass(ProtoType, 'ProtoType');
  initMetadataForClass(ProtoPacked, 'ProtoPacked');
  initMetadataForClass(ProtobufDecodingException, 'ProtobufDecodingException', VOID, SerializationException);
  initMetadataForClass(ProtobufTaggedBase, 'ProtobufTaggedBase');
  initMetadataForClass(ProtobufTaggedDecoder, 'ProtobufTaggedDecoder', VOID, ProtobufTaggedBase, [ProtobufTaggedBase, Decoder, CompositeDecoder]);
  initMetadataForClass(ProtobufDecoder, 'ProtobufDecoder', VOID, ProtobufTaggedDecoder);
  initMetadataForClass(PackedArrayDecoder, 'PackedArrayDecoder', VOID, ProtobufDecoder);
  initMetadataForClass(ProtobufTaggedEncoder, 'ProtobufTaggedEncoder', VOID, ProtobufTaggedBase, [ProtobufTaggedBase, Encoder, CompositeEncoder]);
  initMetadataForClass(ProtobufEncoder, 'ProtobufEncoder', VOID, ProtobufTaggedEncoder);
  initMetadataForClass(NestedRepeatedEncoder, 'NestedRepeatedEncoder', VOID, ProtobufEncoder);
  initMetadataForClass(PackedArrayEncoder, 'PackedArrayEncoder', VOID, NestedRepeatedEncoder);
  initMetadataForClass(RepeatedDecoder, 'RepeatedDecoder', VOID, ProtobufDecoder);
  initMetadataForClass(MapEntryReader, 'MapEntryReader', VOID, ProtobufDecoder);
  initMetadataForClass(RepeatedEncoder, 'RepeatedEncoder', VOID, ProtobufEncoder);
  initMetadataForClass(ObjectEncoder, 'ObjectEncoder', VOID, ProtobufEncoder);
  initMetadataForClass(MapRepeatedEncoder, 'MapRepeatedEncoder', VOID, ObjectEncoder);
  initMetadataForClass(ProtobufReader, 'ProtobufReader');
  initMetadataForClass(NullableMode, 'NullableMode', VOID, Enum);
  initMetadataForClass(ProtobufWriter, 'ProtobufWriter');
  initMetadataForCompanion(Companion_81);
  initMetadataForClass(ByteArrayOutput, 'ByteArrayOutput', ByteArrayOutput);
  initMetadataForClass(ByteArrayInput, 'ByteArrayInput');
  initMetadataForClass(Json_0, 'Json', VOID, VOID, [StringFormat]);
  initMetadataForObject(Default_1, 'Default', VOID, Json_0);
  initMetadataForClass(JsonBuilder, 'JsonBuilder');
  initMetadataForClass(JsonImpl, 'JsonImpl', VOID, Json_0);
  initMetadataForClass(JsonClassDiscriminator, 'JsonClassDiscriminator');
  initMetadataForClass(JsonNames, 'JsonNames');
  initMetadataForClass(JsonConfiguration, 'JsonConfiguration');
  initMetadataForInterface(JsonDecoder, 'JsonDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  initMetadataForCompanion(Companion_82);
  initMetadataForClass(JsonElement, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
  initMetadataForClass(JsonPrimitive, 'JsonPrimitive', VOID, JsonElement, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
  initMetadataForCompanion(Companion_83);
  initMetadataForCompanion(Companion_84);
  initMetadataForClass(JsonObject_0, 'JsonObject', VOID, JsonElement, [JsonElement, KtMap], VOID, VOID, {0: JsonObjectSerializer_getInstance});
  initMetadataForObject(JsonNull_0, 'JsonNull', VOID, JsonPrimitive, [JsonPrimitive, SerializerFactory], VOID, VOID, {0: JsonNull_getInstance});
  initMetadataForClass(JsonLiteral, 'JsonLiteral', VOID, JsonPrimitive);
  initMetadataForCompanion(Companion_85);
  initMetadataForClass(JsonArray_0, 'JsonArray', VOID, JsonElement, [JsonElement, KtList], VOID, VOID, {0: JsonArraySerializer_getInstance});
  initMetadataForClass(JsonObjectBuilder, 'JsonObjectBuilder');
  initMetadataForClass(JsonArrayBuilder, 'JsonArrayBuilder');
  initMetadataForObject(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonElementSerializer, 'JsonElementSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonObjectDescriptor, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(JsonObjectSerializer, 'JsonObjectSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonNullSerializer, 'JsonNullSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonLiteralSerializer, 'JsonLiteralSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonArrayDescriptor, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(JsonArraySerializer, 'JsonArraySerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(defer$1, VOID, VOID, VOID, [SerialDescriptor]);
  initMetadataForInterface(JsonEncoder, 'JsonEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForClass(Composer, 'Composer');
  initMetadataForClass(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers', VOID, Composer);
  initMetadataForClass(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals', VOID, Composer);
  initMetadataForClass(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint', VOID, Composer);
  initMetadataForClass(JsonElementMarker, 'JsonElementMarker');
  initMetadataForClass(JsonException_0, 'JsonException', VOID, SerializationException);
  initMetadataForClass(JsonDecodingException, 'JsonDecodingException', VOID, JsonException_0);
  initMetadataForClass(JsonEncodingException, 'JsonEncodingException', VOID, JsonException_0);
  initMetadataForObject(Tombstone, 'Tombstone');
  initMetadataForClass(JsonPath, 'JsonPath', JsonPath);
  initMetadataForLambda(JsonTreeReader$readDeepRecursive$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($readObjectCOROUTINE$0, CoroutineImpl);
  initMetadataForClass(JsonTreeReader, 'JsonTreeReader', VOID, VOID, VOID, [0]);
  initMetadataForClass(PolymorphismValidator, 'PolymorphismValidator', VOID, VOID, [SerializersModuleCollector]);
  initMetadataForClass(Key_6, 'Key', Key_6);
  initMetadataForClass(DescriptorSchemaCache, 'DescriptorSchemaCache', DescriptorSchemaCache);
  initMetadataForClass(DiscriminatorHolder, 'DiscriminatorHolder');
  initMetadataForClass(StreamingJsonDecoder, 'StreamingJsonDecoder', VOID, AbstractDecoder, [JsonDecoder, AbstractDecoder]);
  initMetadataForClass(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes', VOID, AbstractDecoder);
  initMetadataForClass(StreamingJsonEncoder, 'StreamingJsonEncoder', VOID, AbstractEncoder, [JsonEncoder, AbstractEncoder]);
  initMetadataForClass(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', VOID, NamedValueDecoder, [NamedValueDecoder, JsonDecoder]);
  initMetadataForClass(JsonTreeDecoder, 'JsonTreeDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonTreeListDecoder, 'JsonTreeListDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonTreeMapDecoder, 'JsonTreeMapDecoder', VOID, JsonTreeDecoder);
  initMetadataForClass(AbstractJsonTreeEncoder, 'AbstractJsonTreeEncoder', VOID, NamedValueEncoder, [NamedValueEncoder, JsonEncoder]);
  initMetadataForClass(JsonTreeEncoder, 'JsonTreeEncoder', VOID, AbstractJsonTreeEncoder);
  initMetadataForClass(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1, VOID, VOID, AbstractEncoder);
  initMetadataForClass(AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1, VOID, VOID, AbstractEncoder);
  initMetadataForClass(JsonPrimitiveEncoder, 'JsonPrimitiveEncoder', VOID, AbstractJsonTreeEncoder);
  initMetadataForClass(JsonTreeListEncoder, 'JsonTreeListEncoder', VOID, AbstractJsonTreeEncoder);
  initMetadataForClass(JsonTreeMapEncoder, 'JsonTreeMapEncoder', VOID, JsonTreeEncoder);
  initMetadataForClass(WriteMode, 'WriteMode', VOID, Enum);
  initMetadataForClass(AbstractJsonLexer, 'AbstractJsonLexer');
  initMetadataForObject(CharMappings, 'CharMappings');
  initMetadataForClass(StringJsonLexer_0, 'StringJsonLexer', VOID, AbstractJsonLexer);
  initMetadataForClass(DynamicInput, 'DynamicInput', VOID, NamedValueDecoder, [NamedValueDecoder, JsonDecoder]);
  initMetadataForClass(PrimitiveDynamicInput, 'PrimitiveDynamicInput', VOID, DynamicInput);
  initMetadataForClass(DynamicListInput, 'DynamicListInput', VOID, DynamicInput);
  initMetadataForClass(DynamicMapInput, 'DynamicMapInput', VOID, DynamicInput);
  initMetadataForClass(JsonToStringWriter, 'JsonToStringWriter', JsonToStringWriter);
  initMetadataForObject(DefaultNodeStorage, 'DefaultNodeStorage');
  initMetadataForClass(LocalNodePointerSupport$node$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(LocalNodePointerSupport, 'LocalNodePointerSupport', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_86);
  initMetadataForClass(NodePointer, 'NodePointer', VOID, VOID, VOID, VOID, VOID, {0: NodePointerSerializer_getInstance});
  initMetadataForObject(NodePointerSerializer, 'NodePointerSerializer', VOID, VOID, [KSerializer]);
  initMetadataForCompanion(Companion_87);
  initMetadataForClass(NodePointerFormatException, 'NodePointerFormatException', NodePointerFormatException_init_$Create$, IllegalArgumentException);
  initMetadataForCompanion(Companion_88, VOID, [Key_5]);
  initMetadataForClass(NodePointersService, 'NodePointersService');
  initMetadataForObject(EmptyNodeStorage, 'EmptyNodeStorage');
  initMetadataForCompanion(Companion_89, VOID, [Key_5]);
  initMetadataForClass(NodeStorageService, 'NodeStorageService');
  initMetadataForObject(OtNodeFactoryService, 'OtNodeFactoryService', VOID, VOID, [Key_5]);
  initMetadataForCompanion(Companion_90);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedNode, 'SerializedNode', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForInterface(NodePersister, 'NodePersister', VOID, VOID, [Persister]);
  initMetadataForClass(DomainNodePersister, 'DomainNodePersister', VOID, VOID, [NodePersister]);
  initMetadataForClass(FindNodeQueryProvider$createNodeRegisterListener$1);
  initMetadataForClass(FindNodeQueryProvider$activeNodeQueries$1, VOID, VOID, ListenersMap);
  initMetadataForClass(FindNodeQueryProvider$findNode$1, VOID, VOID, VOID, [EventSource]);
  initMetadataForClass(FindNodeQueryProvider$findNode$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(FindNodeQueryProvider, 'FindNodeQueryProvider', VOID, VOID, [Disposable]);
  initMetadataForObject(OTLinkPersister, 'OTLinkPersister');
  initMetadataForCompanion(Companion_91);
  initMetadataForClass(PersistableLink, 'PersistableLink');
  initMetadataForClass(OTNodePersister, 'OTNodePersister', VOID, VOID, [Persister]);
  initMetadataForCompanion(Companion_92, VOID, [Key_5]);
  initMetadataForClass(SameModelNodeFinder$find$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  function pointer(source, refContents) {
    return null;
  }
  initMetadataForInterface(NodeFinder, 'NodeFinder');
  initMetadataForClass(SameModelNodeFinder, 'SameModelNodeFinder', VOID, VOID, [NodeFinder, Disposable]);
  initMetadataForCompanion(Companion_93);
  initMetadataForClass(SingleRootNodePointerSupport$node$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(SingleRootNodePointerSupport, 'SingleRootNodePointerSupport', VOID, VOID, [Disposable]);
  function get_parent() {
    return this.m6m().qr();
  }
  initMetadataForInterface(DomainNode, 'DomainNode');
  initMetadataForInterface(TypedOtNode, 'TypedOtNode', VOID, VOID, [DomainNode]);
  initMetadataForClass(BaseNodeGen, 'BaseNodeGen', VOID, NodeWrapper, [NodeWrapper, TypedOtNode]);
  initMetadataForClass(OTChildLink, 'OTChildLink');
  initMetadataForInterface(ChildProperty, 'ChildProperty', VOID, VOID, [QProperty], [1]);
  initMetadataForInterface(OtChildProperty, 'OtChildProperty', VOID, VOID, [ChildProperty], [1]);
  initMetadataForClass(OTChildPropertyAdapter, 'OTChildPropertyAdapter', VOID, QPropertyAdapter, [OtChildProperty, QPropertyAdapter], [1]);
  initMetadataForClass(OTRoleData, 'OTRoleData');
  initMetadataForInterface(ChildrenList, 'ChildrenList', VOID, VOID, [QMutableListBase], [1]);
  initMetadataForInterface(OtChildrenList, 'OtChildrenList', VOID, VOID, [ChildrenList], [1]);
  initMetadataForClass(OTChildrenListAdapter, 'OTChildrenListAdapter', VOID, QMutableListAdapter, [OtChildrenList, QMutableListAdapter], [1]);
  initMetadataForClass(BaseTypedOtNode, 'BaseTypedOtNode', VOID, OtNode, [OtNode, TypedOtNode]);
  function getNodeFactory(referenceFactoryRegistry) {
    return RawNodeFactory_instance;
  }
  initMetadataForInterface(NodeWrapperConceptRegistry, 'NodeWrapperConceptRegistry');
  initMetadataForCompanion(Companion_94);
  initMetadataForClass(NodeSetupContext, 'NodeSetupContext');
  initMetadataForObject(NodeSetupContextService, 'NodeSetupContextService', VOID, VOID, [Key_5]);
  initMetadataForCompanion(Companion_95);
  initMetadataForClass(OTAbstractConceptDescriptor, 'OTAbstractConceptDescriptor');
  function createNode$default_0(nodeSetupContext, id, $super) {
    id = id === VOID ? new NodeId() : id;
    return $super === VOID ? this.n6q(nodeSetupContext, id) : $super.n6q.call(this, nodeSetupContext, id);
  }
  initMetadataForInterface(DomainNodeFactory, 'DomainNodeFactory');
  initMetadataForInterface(OTConcept, 'OTConcept', VOID, VOID, [DomainNodeFactory]);
  initMetadataForInterface(DomainNodeWrapperFactory, 'DomainNodeWrapperFactory', VOID, VOID, [DomainNodeFactory]);
  initMetadataForInterface(OTConceptWrapper, 'OTConceptWrapper', VOID, VOID, [OTConcept, DomainNodeWrapperFactory]);
  initMetadataForClass(OTConceptImpl, 'OTConceptImpl', VOID, VOID, [OTConcept, DomainNodeFactory]);
  initMetadataForClass(DomainNodeFactoryImpl, 'DomainNodeFactoryImpl', VOID, VOID, [DomainNodeFactory]);
  initMetadataForObject(ErrorNodeFactory, 'ErrorNodeFactory', VOID, VOID, [DomainNodeWrapperFactory]);
  initMetadataForClass(OTConceptWrapperImpl, 'OTConceptWrapperImpl', VOID, VOID, [OTConceptWrapper, DomainNodeWrapperFactory]);
  initMetadataForClass(DomainNodeWrapperFactoryImpl, 'DomainNodeWrapperFactoryImpl', VOID, VOID, [DomainNodeWrapperFactory]);
  initMetadataForClass(IdMapping, 'IdMapping');
  initMetadataForClass(plus$1);
  initMetadataForClass(OTSplitMergeSupportFactory, 'OTSplitMergeSupportFactory');
  initMetadataForClass(OTSplitMergeSupport, 'OTSplitMergeSupport');
  initMetadataForClass(OtConceptDescriptor, 'OtConceptDescriptor', VOID, OTAbstractConceptDescriptor);
  initMetadataForClass(TypedNodeContext, 'TypedNodeContext');
  initMetadataForObject(UseExperimentalNodeService, 'UseExperimentalNodeService', VOID, VOID, [Key_5]);
  initMetadataForClass(BaseDomainNodeProperty, 'BaseDomainNodeProperty', VOID, BaseOtNodeProperty, [BaseOtNodeProperty, QProperty], [1]);
  initMetadataForClass(DomainNodeChildProperty, 'DomainNodeChildProperty', VOID, SingleItemCollectionProperty, [SingleItemCollectionProperty, OtChildProperty], [1]);
  initMetadataForClass(DomainNodeChildrenProperty, 'DomainNodeChildrenProperty', VOID, QMutableListAdapter, [QMutableListAdapter, OtChildrenList], [1]);
  initMetadataForClass(DomainNodeInMemoryProperty, 'DomainNodeInMemoryProperty', VOID, ValueProperty, [ValueProperty, QProperty], [1]);
  initMetadataForClass(DomainNodeProperty, 'DomainNodeProperty', VOID, BaseDomainNodeProperty, VOID, [1]);
  initMetadataForClass(DomainNodeReferenceProperty, 'DomainNodeReferenceProperty', VOID, BaseDomainNodeProperty, [BaseDomainNodeProperty, QProperty], [1]);
  initMetadataForClass(DomainNodeTextProperty, 'DomainNodeTextProperty', VOID, BaseOtNodeTextProperty, [BaseOtNodeTextProperty, Query], [1]);
  initMetadataForClass(DomainNodeChildPropertyDescriptor, 'DomainNodeChildPropertyDescriptor');
  initMetadataForClass(DomainNodeChildrenPropertyDescriptor, 'DomainNodeChildrenPropertyDescriptor');
  initMetadataForClass(DomainNodePropertyDescriptor, 'DomainNodePropertyDescriptor');
  initMetadataForClass(DomainNodeReferencePropertyDescriptor, 'DomainNodeReferencePropertyDescriptor');
  initMetadataForClass(DomainNodeTextPropertyDescriptor, 'DomainNodeTextPropertyDescriptor');
  function get_regular() {
    return this.r6s().n4z();
  }
  function set(newValue) {
    return this.r6s().t2c(newValue);
  }
  function invoke_3(target) {
    return this.s6s(target);
  }
  function runSuspend_0(builder, $completion) {
    return this.o6s().h4x(builder, $completion);
  }
  initMetadataForInterface(Reference, 'Reference', VOID, VOID, [WritableProperty], [1]);
  initMetadataForClass(PropertyBasedReference, 'PropertyBasedReference', VOID, VOID, [Reference], [1]);
  initMetadataForClass(ConstantReference, 'ConstantReference', VOID, PropertyBasedReference, VOID, [1]);
  initMetadataForClass(ElementsContext, 'ElementsContext');
  initMetadataForClass(EnclosingNodeContext, 'EnclosingNodeContext', VOID, ElementsContext);
  initMetadataForClass(SourceNodeContext, 'SourceNodeContext', VOID, ElementsContext);
  initMetadataForCompanion(Companion_96, VOID, [Key_5]);
  initMetadataForClass(GlobalNodeFinder$find$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(GlobalNodeFinder, 'GlobalNodeFinder', VOID, VOID, [NodeFinder]);
  initMetadataForClass(RefTag, 'RefTag');
  initMetadataForInterface(ReferenceFactory, 'ReferenceFactory');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0, 'sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0', VOID, VOID, [ReferenceFactory, FunctionAdapter]);
  initMetadataForClass(PrecalculatedResolutionReference$Companion$throwIfMissing$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCompanion(Companion_97);
  initMetadataForClass(PrecalculatedResolutionReference$resolve$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(PrecalculatedResolutionReference$find$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(PrecalculatedResolutionReference, 'PrecalculatedResolutionReference', VOID, PropertyBasedReference, VOID, [1]);
  initMetadataForCompanion(Companion_98);
  initMetadataForClass(PrecalculatedResolutionReferenceValue, 'PrecalculatedResolutionReferenceValue');
  function find(source, refContent) {
    return this.a6u(source, refContent);
  }
  initMetadataForInterface(ReferenceResolver, 'ReferenceResolver');
  initMetadataForClass(ReferenceTargetItem, 'ReferenceTargetItem');
  initMetadataForInterface(ReferenceTargetsSupplier, 'ReferenceTargetsSupplier');
  initMetadataForObject(Empty_0, 'Empty', VOID, VOID, [ReferenceTargetsSupplier]);
  initMetadataForClass(ReferenceData, 'ReferenceData');
  initMetadataForClass(NodeLink, 'NodeLink');
  initMetadataForClass(ReferenceLink, 'ReferenceLink', VOID, NodeLink);
  initMetadataForClass(TargetInfo, 'TargetInfo', VOID, ReferenceTargetItem);
  initMetadataForInterface(TargetPresentationProvider, 'TargetPresentationProvider');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0, 'sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0', VOID, VOID, [TargetPresentationProvider, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0, 'sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0', VOID, VOID, [TargetPresentationProvider, FunctionAdapter]);
  initMetadataForCompanion(Companion_99);
  initMetadataForCompanion(Companion_100);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TextFilter, 'TextFilter', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  initMetadataForClass(TextFilterSettings$Companion$invoke$1);
  initMetadataForClass(TextFilterSettings$Companion$DEFAULT$1);
  initMetadataForCompanion(Companion_101);
  initMetadataForCompanion(Companion_102);
  initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TokenizedText, 'TokenizedText', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0, 'sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0', VOID, VOID, [ReferenceFactory, FunctionAdapter]);
  initMetadataForCoroutine($runSuspendCOROUTINE$0, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$1, CoroutineImpl);
  initMetadataForCompanion(Companion_103);
  initMetadataForClass(TrivialReference$resolve$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TrivialReference$find$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TrivialReference, 'TrivialReference', VOID, PropertyBasedReference, VOID, [1]);
  initMetadataForObject(ReferenceFactoryRegistryService, 'ReferenceFactoryRegistryService', VOID, VOID, [Key_5]);
  initMetadataForObject(ReferenceFactoryRegistryAspect, 'ReferenceFactoryRegistryAspect', VOID, VOID, [LanguageAspect]);
  initMetadataForClass(ReferenceFactoryRegistryDefinition, 'ReferenceFactoryRegistryDefinition');
  initMetadataForClass(ReferenceFactoryRegistryBuilderImpl, 'ReferenceFactoryRegistryBuilderImpl', VOID, VOID, [ServicesScope]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1, 'sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0', VOID, VOID, [ReferenceFactory, FunctionAdapter]);
  initMetadataForClass(ReferenceFactoryRegistryImpl, 'ReferenceFactoryRegistryImpl');
  initMetadataForObject(ReferenceTargetPresentationProvidersRegistryService, 'ReferenceTargetPresentationProvidersRegistryService', VOID, VOID, [Key_5]);
  initMetadataForObject(ReferenceTargetPresentationProvidersRegistryAspect, 'ReferenceTargetPresentationProvidersRegistryAspect', VOID, VOID, [LanguageAspect]);
  initMetadataForClass(ReferenceTargetPresentationProvidersRegistryDefinition, 'ReferenceTargetPresentationProvidersRegistryDefinition');
  function referenceTargetPresentation$default(tag, presentationProvider, $super) {
    presentationProvider = presentationProvider === VOID ? Companion_getInstance_99().r6u_1 : presentationProvider;
    var tmp;
    if ($super === VOID) {
      this.y6x(tag, presentationProvider);
      tmp = Unit_instance;
    } else {
      tmp = $super.y6x.call(this, tag, presentationProvider);
    }
    return tmp;
  }
  initMetadataForInterface(ReferenceTargetPresentationProvidersRegistryBuilder, 'ReferenceTargetPresentationProvidersRegistryBuilder', VOID, VOID, [ServicesScope]);
  initMetadataForClass(ReferenceTargetPresentationProvidersRegistryBuilderImpl, 'ReferenceTargetPresentationProvidersRegistryBuilderImpl', VOID, VOID, [ReferenceTargetPresentationProvidersRegistryBuilder, ServicesScope]);
  initMetadataForClass(ReferenceTargetPresentationProvidersRegistryImpl, 'ReferenceTargetPresentationProvidersRegistryImpl');
  initMetadataForObject(ReferenceTargetsSuppliersRegistryService, 'ReferenceTargetsSuppliersRegistryService', VOID, VOID, [Key_5]);
  initMetadataForObject(ReferenceTargetsSuppliersRegistryAspect, 'ReferenceTargetsSuppliersRegistryAspect', VOID, VOID, [LanguageAspect]);
  initMetadataForClass(ReferenceTargetsSuppliersRegistryDefinition, 'ReferenceTargetsSuppliersRegistryDefinition');
  initMetadataForClass(ReferenceTargetsSuppliersRegistryBuilderImpl, 'ReferenceTargetsSuppliersRegistryBuilderImpl', VOID, VOID, [ServicesScope]);
  initMetadataForClass(ReferenceTargetsSuppliersRegistryImpl, 'ReferenceTargetsSuppliersRegistryImpl');
  initMetadataForClass(ResolveConfigImpl, 'ResolveConfigImpl');
  initMetadataForObject(ResolveConfigService, 'ResolveConfigService', VOID, VOID, [Key_5]);
  initMetadataForCompanion(Companion_104, VOID, [SerializerFactory]);
  initMetadataForClass(ReferenceContent, 'ReferenceContent', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_104});
  initMetadataForCompanion(Companion_105);
  initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DynamicReferenceContent, 'DynamicReferenceContent', DynamicReferenceContent, ReferenceContent, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  initMetadataForCompanion(Companion_106);
  initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LocalReferenceContent, 'LocalReferenceContent', VOID, ReferenceContent, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  initMetadataForCompanion(Companion_107);
  initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(QualifiedReferenceContent, 'QualifiedReferenceContent', VOID, ReferenceContent, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  initMetadataForInterface(ContentFactory, 'ContentFactory');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0, 'sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0', VOID, VOID, [ContentFactory, FunctionAdapter]);
  initMetadataForObject(ReferenceContentFactories, 'ReferenceContentFactories');
  initMetadataForClass(DelegatePersister, 'DelegatePersister', VOID, VOID, [NonNullPersister]);
  initMetadataForObject(ReferenceContentPersisters, 'ReferenceContentPersisters');
  function provide(enclosingNode) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new DocumentContainerProvider$provide$$inlined$query$1(this);
  }
  initMetadataForInterface(DocumentContainerProvider, 'DocumentContainerProvider');
  initMetadataForClass(BaseDocumentRepository, 'BaseDocumentRepository', VOID, VOID, [DocumentContainerProvider, Disposable]);
  initMetadataForCompanion(Companion_108, VOID, [Key_5]);
  initMetadataForClass(LocalDocumentRepository, 'LocalDocumentRepository', VOID, BaseDocumentRepository);
  initMetadataForCompanion(Companion_109);
  initMetadataForClass(sam$jetbrains_ocelot_base_observable_event_EventSource$0, 'sam$jetbrains_ocelot_base_observable_event_EventSource$0', VOID, VOID, [EventSource, FunctionAdapter]);
  initMetadataForClass(BaseDocumentContainer$documents$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(BaseDocumentContainer$getDocumentQuery$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForInterface(DocumentContainer, 'DocumentContainer');
  initMetadataForClass(BaseDocumentContainer, 'BaseDocumentContainer', VOID, VOID, [DocumentContainer, Disposable]);
  initMetadataForCompanion(Companion_110, VOID, [Key_5]);
  initMetadataForClass(DocumentContainerProvider$provide$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(AttributePersisters$decimalPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(AttributePersisters, 'AttributePersisters');
  initMetadataForObject(NodeIdSerializer, 'NodeIdSerializer', VOID, VOID, [KSerializer]);
  initMetadataForCompanion(Companion_111, VOID, [Key_5]);
  initMetadataForClass(serialization$1$builder$1, VOID, VOID, VOID, [ServicesScope]);
  initMetadataForClass(serialization$1$1);
  initMetadataForObject(DocumentIdUtil, 'DocumentIdUtil');
  initMetadataForInterface(DocumentNode, 'DocumentNode', VOID, VOID, [DomainNode]);
  function get_id() {
    return new NodeId();
  }
  function get_conceptId() {
    return NodeConceptIdFactory_getInstance().q3c('non-concept');
  }
  function get_root() {
    return null;
  }
  function get_observableParent() {
    return new ValueProperty(null);
  }
  function get_roleInParent() {
    return null;
  }
  function replaceWith(new_0) {
    return Unit_instance;
  }
  function getDescendants(includeSelf) {
    return emptySequence();
  }
  function getAllChildren() {
    return emptySequence();
  }
  initMetadataForInterface(LightDomainNode, 'LightDomainNode', VOID, VOID, [DomainNode]);
  initMetadataForInterface(Named, 'Named', VOID, VOID, [DomainNode]);
  initMetadataForInterface(DirectlyNamed, 'DirectlyNamed', VOID, VOID, [Named]);
  initMetadataForClass(NodeFactory, 'NodeFactory');
  initMetadataForClass(ChildLink, 'ChildLink', VOID, NodeLink);
  initMetadataForClass(AttributeLink, 'AttributeLink', VOID, NodeLink);
  initMetadataForClass(SingleChildLink, 'SingleChildLink', VOID, ChildLink);
  initMetadataForClass(MultipleChildLink, 'MultipleChildLink', VOID, ChildLink);
  initMetadataForClass(ValueAttributeLink, 'ValueAttributeLink', VOID, AttributeLink);
  initMetadataForClass(TextAttributeLink, 'TextAttributeLink', VOID, AttributeLink);
  initMetadataForCompanion(Companion_112);
  initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedChildLink, 'SerializedChildLink', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  initMetadataForClass(ChildContext, 'ChildContext');
  initMetadataForCompanion(Companion_113);
  initMetadataForClass(BaseConceptRegistry, 'BaseConceptRegistry');
  initMetadataForClass(ConceptImplementationRegistryRecord, 'ConceptImplementationRegistryRecord');
  initMetadataForClass(ConceptRegistryBasedNodeFactory, 'ConceptRegistryBasedNodeFactory', VOID, NodeFactory);
  initMetadataForClass(ConceptRegistryBuilderImpl, 'ConceptRegistryBuilderImpl', VOID, VOID, [ServicesScope]);
  initMetadataForClass(ConceptRegistryRecord, 'ConceptRegistryRecord');
  initMetadataForClass(DomainNodeConceptRegistry$getNodeFactory$1, VOID, VOID, VOID, [OtNodeFactory]);
  initMetadataForClass(DomainNodeConceptRegistry, 'DomainNodeConceptRegistry', VOID, BaseConceptRegistry);
  initMetadataForClass(NodeWrapperConceptRegistryImpl$nodeWrapperFactory$1, VOID, VOID, NodeWrapperFactory);
  initMetadataForClass(NodeWrapperConceptRegistryImpl, 'NodeWrapperConceptRegistryImpl', VOID, BaseConceptRegistry, [BaseConceptRegistry, NodeWrapperConceptRegistry]);
  initMetadataForObject(StructureAspect, 'StructureAspect', VOID, VOID, [LanguageAspect]);
  initMetadataForObject(ConceptRegistryService, 'ConceptRegistryService', VOID, VOID, [Key_5]);
  initMetadataForClass(ConceptDefinitions, 'ConceptDefinitions');
  initMetadataForClass(BaseStructureModel, 'BaseStructureModel', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_114);
  initMetadataForClass(EntityNodeLayout, 'EntityNodeLayout');
  initMetadataForClass(SingleRootHolder$Companion$wrapperFactory$$inlined$entityWrapperFactory$1);
  initMetadataForCompanion(Companion_115, VOID, [Key_5]);
  initMetadataForClass(SingleRootEntityWrapper, 'SingleRootEntityWrapper', VOID, EntityWrapper);
  initMetadataForClass(SingleRootHolder, 'SingleRootHolder');
  initMetadataForClass(SingleRootStructureModel, 'SingleRootStructureModel', VOID, BaseStructureModel);
  initMetadataForClass(ancestorOrSelf$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCompanion(Companion_116);
  initMetadataForClass(DomainModel, 'DomainModel', VOID, VOID, [Disposable]);
  initMetadataForClass(ErrorBase, 'ErrorBase');
  initMetadataForClass(ErrorForAllNode, 'ErrorForAllNode', VOID, ErrorBase);
  initMetadataForClass(ErrorForDescendants, 'ErrorForDescendants', VOID, ErrorBase);
  initMetadataForCompanion(Companion_117, VOID, [Key_5]);
  initMetadataForInterface(ErrorCheckConfig, 'ErrorCheckConfig');
  initMetadataForObject(Empty_1, 'Empty', VOID, VOID, [ErrorCheckConfig]);
  initMetadataForObject(EmptyErrorCheckConfig, 'EmptyErrorCheckConfig', VOID, VOID, [ErrorCheckConfig]);
  initMetadataForClass(ErrorCheckConfigBuilder, 'ErrorCheckConfigBuilder', VOID, VOID, [ServicesScope]);
  initMetadataForClass(ErrorCheckConfigBuilderImpl$build$1, VOID, VOID, VOID, [ErrorCheckConfig]);
  initMetadataForClass(ErrorCheckConfigBuilderImpl, 'ErrorCheckConfigBuilderImpl', VOID, ErrorCheckConfigBuilder, [ErrorCheckConfigBuilder, ServicesScope]);
  initMetadataForClass(asChecker$1);
  initMetadataForCoroutine($runSuspendCOROUTINE$0_0, CoroutineImpl);
  initMetadataForClass(CompositeScopeFilter$apply$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForInterface(ScopeFilter, 'ScopeFilter');
  initMetadataForClass(CompositeScopeFilter, 'CompositeScopeFilter', VOID, VOID, [ScopeFilter]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0, 'sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0', VOID, VOID, [ScopeFilter, FunctionAdapter]);
  initMetadataForCoroutine($runSuspendCOROUTINE$1_0, CoroutineImpl);
  initMetadataForClass(anyOf$1$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_118);
  initMetadataForClass(NamingInfo, 'NamingInfo');
  initMetadataForObject(NoopScopeFilter, 'NoopScopeFilter', VOID, VOID, [ScopeFilter]);
  initMetadataForClass(Origin, 'Origin');
  initMetadataForClass(DefaultOrigin, 'DefaultOrigin', VOID, Origin);
  initMetadataForClass(ImportOrigin, 'ImportOrigin', VOID, Origin);
  initMetadataForClass(LexicalOrigin, 'LexicalOrigin', VOID, Origin);
  initMetadataForClass(ChildPlaceholderOrigin, 'ChildPlaceholderOrigin', VOID, LexicalOrigin);
  function find_0(pointer) {
    return Companion_getInstance_76().i51_1;
  }
  function applyFilter(filter) {
    var tmp;
    if (filter instanceof NoopScopeFilter) {
      tmp = this;
    } else {
      tmp = new FilteredScope(this, filter);
    }
    return tmp;
  }
  initMetadataForInterface(Scope, 'Scope');
  initMetadataForCoroutine($runSuspendCOROUTINE$2, CoroutineImpl);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0, 'sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0', VOID, VOID, [ScopeFilter, FunctionAdapter]);
  initMetadataForClass(ScopeFilter$Companion$query$1$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_119);
  initMetadataForClass(FallbackScopingRulesProvider$namespace$1);
  initMetadataForClass(FallbackScopingRulesProvider, 'FallbackScopingRulesProvider');
  initMetadataForObject(ScopeAspect, 'ScopeAspect', VOID, VOID, [LanguageAspect]);
  initMetadataForClass(ScopeDefinition, 'ScopeDefinition');
  initMetadataForClass(ScopeConstraintRuleSpec, 'ScopeConstraintRuleSpec');
  initMetadataForClass(ConstraintProviderSpec, 'ConstraintProviderSpec');
  function with_0(_this__u8e3s4, constraint) {
    return new ScopeConstraintRuleSpec(_this__u8e3s4.m77_1, constraint);
  }
  initMetadataForInterface(ScopeConfigBuilder, 'ScopeConfigBuilder', VOID, VOID, [ServicesScope]);
  initMetadataForClass(ScopingRuleSpec, 'ScopingRuleSpec');
  initMetadataForClass(ScopeConfigBuilder0, 'ScopeConfigBuilder0', VOID, VOID, [ServicesScope]);
  initMetadataForClass(ScopeConfigBuilder0Fallback, 'ScopeConfigBuilder0Fallback', VOID, ScopeConfigBuilder0, [ScopeConfigBuilder0, ScopeConfigBuilder]);
  initMetadataForCoroutine($runSuspendCOROUTINE$3, CoroutineImpl);
  initMetadataForInterface(ScopeConstraintProvider, 'ScopeConstraintProvider');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0, 'sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0', VOID, VOID, [ScopeConstraintProvider, FunctionAdapter]);
  initMetadataForClass(ScopeConfigBuilderImpl$by$2$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeConfigBuilderImpl, 'ScopeConfigBuilderImpl', VOID, VOID, [ScopeConfigBuilder, ServicesScope]);
  initMetadataForClass(CollectionScopeFactory$Companion$Default$1);
  initMetadataForClass(CollectionScopeFactory$Companion$Indexed$1);
  initMetadataForCompanion(Companion_120);
  initMetadataForCoroutine($runSuspendCOROUTINE$6, CoroutineImpl);
  initMetadataForClass(createIndexingScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OriginSelector, 'OriginSelector');
  initMetadataForObject(Any, 'Any', VOID, OriginSelector);
  initMetadataForObject(Lexical, 'Lexical', VOID, OriginSelector);
  initMetadataForObject(Import, 'Import', VOID, OriginSelector);
  initMetadataForClass(LexicalWithRole, 'LexicalWithRole', VOID, OriginSelector);
  initMetadataForCompanion(Companion_121);
  initMetadataForClass(RuleEvaluationScope, 'RuleEvaluationScope');
  initMetadataForClass(RuleEvaluationStrategy, 'RuleEvaluationStrategy', VOID, Enum);
  initMetadataForCoroutine($constrainedInAncestorsCOROUTINE$7, CoroutineImpl);
  initMetadataForClass(ScopeBuilder, 'ScopeBuilder', VOID, QueryBuilder, VOID, [1, 0]);
  initMetadataForClass(ScopeBuilderWithProvider, 'ScopeBuilderWithProvider', VOID, ScopeBuilder, VOID, [0, 1]);
  initMetadataForCoroutine($importScopeCOROUTINE$8, CoroutineImpl);
  initMetadataForObject(ScopeConfigService, 'ScopeConfigService', VOID, VOID, [Key_5]);
  initMetadataForClass(ScopeConstraintBuilder, 'ScopeConstraintBuilder', VOID, QueryBuilder, VOID, [0]);
  initMetadataForClass(ScopeConstraintId, 'ScopeConstraintId', ScopeConstraintId);
  initMetadataForInterface(ScopeProvidersRegistry, 'ScopeProvidersRegistry');
  initMetadataForClass(ScopingRuleDefinition, 'ScopingRuleDefinition');
  initMetadataForClass(ProvideScope, 'ProvideScope', VOID, ScopingRuleDefinition);
  initMetadataForClass(DefaultScope, 'DefaultScope', VOID, ScopingRuleDefinition);
  initMetadataForClass(ConstrainScope, 'ConstrainScope', VOID, ScopingRuleDefinition);
  initMetadataForClass(ProvideName, 'ProvideName', VOID, ScopingRuleDefinition);
  initMetadataForCoroutine($runSuspendCOROUTINE$10, CoroutineImpl);
  initMetadataForClass(ScopeKey, 'ScopeKey');
  initMetadataForCompanion(Companion_122, VOID, [Key_5]);
  initMetadataForClass(SharedScopesContainer$indexingScopeFor$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForObject(Empty_2, 'Empty');
  initMetadataForCompanion(Companion_123, VOID, [Key_5]);
  initMetadataForCoroutine($runSuspendCOROUTINE$11, CoroutineImpl);
  initMetadataForClass(DefaultScopesManager$getScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(DefaultScopesManager, 'DefaultScopesManager');
  initMetadataForClass(NameProvidersManager, 'NameProvidersManager');
  initMetadataForObject(NoScopeSpecificationContext, 'NoScopeSpecificationContext');
  initMetadataForCompanion(Companion_124);
  initMetadataForClass(NodeLocation, 'NodeLocation');
  initMetadataForCoroutine($runSuspendCOROUTINE$12, CoroutineImpl);
  initMetadataForClass(ParentChildScopes$nearestEnclosingOrDefaultScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ParentChildScopes, 'ParentChildScopes');
  initMetadataForCoroutine($runSuspendCOROUTINE$13, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$14, CoroutineImpl);
  initMetadataForClass(ParentScopeConstraints$collectConstraints$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ParentScopeConstraints$tryConstraintRule$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ParentScopeConstraints, 'ParentScopeConstraints');
  initMetadataForClass(ProviderSpec, 'ProviderSpec');
  initMetadataForClass(ProvideScopeRulesContainer, 'ProvideScopeRulesContainer');
  initMetadataForClass(ProvidedScopeSpec, 'ProvidedScopeSpec');
  initMetadataForCoroutine($runSuspendCOROUTINE$15, CoroutineImpl);
  initMetadataForClass(ConstraintSpec, 'ConstraintSpec');
  initMetadataForClass(ScopeConstraintsManager$getScopeConstraint$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeConstraintsManager, 'ScopeConstraintsManager');
  initMetadataForCoroutine($runSuspendCOROUTINE$16, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$17, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$18, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$19, CoroutineImpl);
  initMetadataForClass(ScopeContextImpl$parentScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeContextImpl$importScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeContextImpl$importScope$$inlined$suspendingQuery$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeContextImpl$defaultScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeContextImpl, 'ScopeContextImpl');
  initMetadataForCoroutine($runSuspendCOROUTINE$20, CoroutineImpl);
  initMetadataForClass(ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$21, CoroutineImpl);
  initMetadataForClass(ScopeProvidersManager$populateScopesFor$1$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$22, CoroutineImpl);
  initMetadataForClass(ProvidedScopesContainer, 'ProvidedScopesContainer', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_125);
  initMetadataForLambda(ScopeProvidersManager$populateScopesFor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ScopeProvidersManager$getScope$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopeProvidersManager, 'ScopeProvidersManager', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_126, VOID, [Key_5]);
  initMetadataForCoroutine($runSuspendCOROUTINE$23, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$24, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$25, CoroutineImpl);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0, 'sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0', VOID, VOID, [ScopeConstraintProvider, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_3, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0, 'sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0', VOID, VOID, [ScopeProvidersRegistry, FunctionAdapter]);
  initMetadataForClass(ScopingRulesEngine$getDefaultScope$$inlined$mapSuspending$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopingRulesEngine$getDocumentScope$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(ScopingRulesEngine$getDocumentScope$$inlined$map$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopingRulesEngine$getScopeConstraint$1$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopingRulesEngine, 'ScopingRulesEngine');
  initMetadataForClass(ScopingRulesEngineRemoteAdapter, 'ScopingRulesEngineRemoteAdapter');
  initMetadataForClass(AnnotatedDocumentsList, 'AnnotatedDocumentsList', VOID, VOID, [ObservableList]);
  initMetadataForLambda(CollectionScope$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CollectionScope, 'CollectionScope', VOID, VOID, [Scope]);
  initMetadataForCoroutine($runSuspendCOROUTINE$28, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$29, CoroutineImpl);
  initMetadataForClass(CompositeScope$find$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(CompositeScope$contains$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(CompositeScope$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CompositeScope, 'CompositeScope', VOID, VOID, [Scope]);
  initMetadataForClass(DelegatingScope, 'DelegatingScope', VOID, VOID, [Scope]);
  initMetadataForClass(EmptyScope, 'EmptyScope', EmptyScope, VOID, [Scope]);
  initMetadataForCoroutine($runSuspendCOROUTINE$31, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$32, CoroutineImpl);
  initMetadataForLambda(FilteredScope$getElements$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$33, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_5, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(FilteredScope$find$$inlined$flatMap$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(FilteredScope$contains$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(FilteredScope$getElements$$inlined$filter$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(FilteredScope, 'FilteredScope', VOID, DelegatingScope);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1, 'sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0', VOID, VOID, [ScopeFilter, FunctionAdapter]);
  initMetadataForCoroutine($runSuspendCOROUTINE$34, CoroutineImpl);
  initMetadataForClass(filter$1$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$35, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$37, CoroutineImpl);
  initMetadataForClass(ItemRecord, 'ItemRecord');
  initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  function onTargetAdded(target, name) {
    return this.b7y(target, EventType_ADD_getInstance(), name);
  }
  function onTargetRenamed(target, name) {
    return this.b7y(target, EventType_SET_getInstance(), name);
  }
  function onTargetRemoved(target) {
    return this.b7y(target, EventType_REMOVE_getInstance(), null);
  }
  initMetadataForInterface(ScopeListenerAdapter, 'ScopeListenerAdapter');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0, 'sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0', VOID, VOID, [ScopeListenerAdapter, FunctionAdapter]);
  initMetadataForClass(IndexingScope$depend$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(IndexingScope$contains$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(IndexingScope$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(IndexingScope, 'IndexingScope', VOID, VOID, [Scope]);
  initMetadataForLambda(IndexingCollectionScope$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($IndexingCollectionScopeCOROUTINE$38, CoroutineImpl);
  initMetadataForCoroutine($IndexingCollectionScope$insertItemCOROUTINE$39, CoroutineImpl);
  initMetadataForCoroutine($IndexingCollectionScope$populateScopeCOROUTINE$40, CoroutineImpl);
  initMetadataForClass(LocatableScope, 'LocatableScope', VOID, DelegatingScope);
  initMetadataForObject(Scopes, 'Scopes');
  initMetadataForCoroutine($runSuspendCOROUTINE$42, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$43, CoroutineImpl);
  initMetadataForClass(UniqueSumScope$find$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(UniqueSumScope$contains$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(UniqueSumScope$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(UniqueSumScope, 'UniqueSumScope', VOID, VOID, [Scope]);
  initMetadataForClass(AbstractScopedReferenceResolver, 'AbstractScopedReferenceResolver', VOID, VOID, [ReferenceResolver], [1]);
  initMetadataForLambda(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$44, CoroutineImpl);
  initMetadataForClass(AbstractScopedReferenceTargetsSupplier$getElements$1$$inlined$executeSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_6, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(AbstractScopedReferenceTargetsSupplier$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(AbstractScopedReferenceTargetsSupplier, 'AbstractScopedReferenceTargetsSupplier', VOID, VOID, [ReferenceTargetsSupplier]);
  initMetadataForClass(ScopedReferenceFactoryRegistryBuilder, 'ScopedReferenceFactoryRegistryBuilder');
  initMetadataForCoroutine($runSuspendCOROUTINE$46, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$47, CoroutineImpl);
  initMetadataForClass(ScopedReferenceResolver$resolve$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopedReferenceResolver$find$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($findByPointerCOROUTINE$45, CoroutineImpl);
  initMetadataForClass(ScopedReferenceResolver, 'ScopedReferenceResolver', VOID, AbstractScopedReferenceResolver, VOID, [2, 1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$48, CoroutineImpl);
  initMetadataForClass(ScopedReferenceTargetPresentationProvider$getPresentation$$inlined$flatMap$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopedReferenceTargetPresentationProvider, 'ScopedReferenceTargetPresentationProvider', VOID, VOID, [TargetPresentationProvider]);
  initMetadataForClass(ScopedReferenceTargetsSupplier$referenceContents$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ScopedReferenceTargetsSupplier, 'ScopedReferenceTargetsSupplier', VOID, AbstractScopedReferenceTargetsSupplier);
  initMetadataForInterface(TargetInfoStub, 'TargetInfoStub', VOID, VOID, [LightDomainNode]);
  initMetadataForObject(AbsentScopeOwner, 'AbsentScopeOwner');
  initMetadataForClass(ScopeContent, 'ScopeContent');
  initMetadataForClass(ScopeId, 'ScopeId');
  initMetadataForClass(Default_2, 'Default', VOID, ScopeId);
  initMetadataForClass(Exported, 'Exported', VOID, ScopeId);
  initMetadataForClass(Lexical_0, 'Lexical', VOID, ScopeId);
  initMetadataForClass(Children, 'Children', VOID, ScopeId);
  initMetadataForClass(Collection_0, 'Collection', Collection_0, ScopeId);
  initMetadataForCompanion(Companion_127);
  initMetadataForClass(ScopeSpecification, 'ScopeSpecification');
  initMetadataForCompanion(Companion_128);
  initMetadataForClass(ScopeTree, 'ScopeTree');
  initMetadataForObject(FindUsagesAspect, 'FindUsagesAspect', VOID, VOID, [LanguageAspect]);
  initMetadataForClass(FindUsagesDefinition, 'FindUsagesDefinition');
  initMetadataForObject(FindUsagesConfigService, 'FindUsagesConfigService', VOID, VOID, [Key_5]);
  initMetadataForClass(FindUsagesData, 'FindUsagesData');
  initMetadataForClass(ProperUsage, 'ProperUsage', VOID, FindUsagesData);
  initMetadataForObject(DontKnow, 'DontKnow', VOID, FindUsagesData);
  initMetadataForClass(ReferenceContext, 'ReferenceContext');
  initMetadataForClass(FindUsagesConfigBuilderImpl$build$1);
  initMetadataForClass(FindUsagesConfigBuilderImpl, 'FindUsagesConfigBuilderImpl');
  initMetadataForClass(UsageKind, 'UsageKind');
  initMetadataForClass(UsagePresentationData, 'UsagePresentationData', VOID, VOID, [LightDomainNode]);
  initMetadataForClass(Usage, 'Usage');
  initMetadataForObject(DefaultUsageKind, 'DefaultUsageKind', VOID, UsageKind);
  initMetadataForClass(DefaultUsagePresentation, 'DefaultUsagePresentation', VOID, UsagePresentationData);
  initMetadataForCoroutine($awaitAtLeastNBytesAvailableForWriteCOROUTINE$0, CoroutineImpl);
  initMetadataForCoroutine($awaitAtLeastNBytesAvailableForReadCOROUTINE$1, CoroutineImpl);
  initMetadataForCoroutine($writeFullyCOROUTINE$9, CoroutineImpl);
  initMetadataForCoroutine($writeFullyCOROUTINE$10, CoroutineImpl);
  initMetadataForCoroutine($readRemainingCOROUTINE$26, CoroutineImpl);
  initMetadataForCoroutine($readRemainingSuspendCOROUTINE$27, CoroutineImpl);
  initMetadataForCoroutine($readAvailableCOROUTINE$30, CoroutineImpl);
  initMetadataForCoroutine($readAvailableCOROUTINE$33, CoroutineImpl);
  initMetadataForCoroutine($awaitInternalAtLeast1COROUTINE$38, CoroutineImpl);
  initMetadataForCoroutine($awaitSuspendCOROUTINE$39, CoroutineImpl);
  function readRemaining$default(limit, $completion, $super) {
    limit = limit === VOID ? new Long(-1, 2147483647) : limit;
    return $super === VOID ? this.c8k(limit, $completion) : $super.c8k.call(this, limit, $completion);
  }
  initMetadataForInterface(ByteReadChannel_1, 'ByteReadChannel', VOID, VOID, VOID, [3, 1, 2, 0, 5]);
  initMetadataForClass(ByteChannelSequentialBase, 'ByteChannelSequentialBase', VOID, VOID, [ByteReadChannel_1], [1, 3, 0, 2, 5]);
  initMetadataForClass(ClosedWriteChannelException, 'ClosedWriteChannelException', VOID, CancellationException);
  initMetadataForClass(CloseElement, 'CloseElement');
  initMetadataForInterface(WriterScope, 'WriterScope', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(ChannelJob, 'ChannelJob', VOID, VOID, [Job], [0]);
  initMetadataForClass(ChannelScope, 'ChannelScope', VOID, VOID, [CoroutineScope, WriterScope]);
  initMetadataForLambda(launchChannel$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_129);
  initMetadataForClass(Buffer, 'Buffer');
  initMetadataForClass(InsufficientSpaceException, 'InsufficientSpaceException', InsufficientSpaceException, Exception);
  initMetadataForClass(DefaultPool, 'DefaultPool');
  initMetadataForClass(DefaultBufferPool, 'DefaultBufferPool', DefaultBufferPool, DefaultPool);
  initMetadataForClass(Output, 'Output');
  initMetadataForClass(BytePacketBuilder, 'BytePacketBuilder', BytePacketBuilder, Output);
  initMetadataForCompanion(Companion_130);
  initMetadataForClass(Input, 'Input');
  initMetadataForClass(ByteReadPacket, 'ByteReadPacket', VOID, Input);
  initMetadataForCompanion(Companion_131);
  initMetadataForClass(ChunkBuffer$Companion$EmptyPool$1);
  initMetadataForClass(NoPoolImpl, 'NoPoolImpl');
  initMetadataForClass(ChunkBuffer$Companion$NoPool$1, VOID, VOID, NoPoolImpl);
  initMetadataForClass(ChunkBuffer$Companion$NoPoolManuallyManaged$1, VOID, VOID, NoPoolImpl);
  initMetadataForCompanion(Companion_132);
  initMetadataForClass(ChunkBuffer, 'ChunkBuffer', VOID, Buffer);
  initMetadataForClass(MalformedUTF8InputException, 'MalformedUTF8InputException', VOID, Exception);
  initMetadataForCoroutine($sleepCOROUTINE$52, CoroutineImpl);
  initMetadataForCoroutine($trySuspendCOROUTINE$53, CoroutineImpl);
  initMetadataForClass(AwaitingSlot, 'AwaitingSlot', AwaitingSlot, VOID, VOID, [1]);
  initMetadataForCoroutine($copyToSequentialImplCOROUTINE$54, CoroutineImpl);
  initMetadataForCoroutine($copyToTailCOROUTINE$55, CoroutineImpl);
  initMetadataForClass(ByteArrayPool$1, VOID, VOID, DefaultPool);
  initMetadataForClass(ByteChannelJS, 'ByteChannelJS', VOID, ByteChannelSequentialBase, VOID, [3, 1, 0, 2, 5]);
  initMetadataForCompanion(Companion_133);
  initMetadataForObject(DefaultAllocator, 'DefaultAllocator');
  initMetadataForCompanion(Companion_134);
  initMetadataForClass(Memory, 'Memory');
  initMetadataForCompanion(Companion_135);
  initMetadataForClass(Charset, 'Charset');
  initMetadataForObject(Charsets, 'Charsets');
  initMetadataForClass(MalformedInputException, 'MalformedInputException', VOID, Error);
  initMetadataForClass(CharsetDecoder, 'CharsetDecoder');
  initMetadataForClass(CharsetEncoder, 'CharsetEncoder');
  initMetadataForClass(CharsetImpl, 'CharsetImpl', VOID, Charset);
  initMetadataForClass(CharsetEncoderImpl, 'CharsetEncoderImpl', VOID, CharsetEncoder);
  initMetadataForClass(CharsetDecoderImpl, 'CharsetDecoderImpl', VOID, CharsetDecoder);
  initMetadataForClass(DecodeBufferResult, 'DecodeBufferResult');
  initMetadataForClass(IOException, 'IOException', VOID, Exception);
  initMetadataForClass(EOFException, 'EOFException', VOID, IOException);
  initMetadataForClass(toKtor$1);
  initMetadataForClass(TextDecoderFallback, 'TextDecoderFallback');
  initMetadataForClass(AttributeKey, 'AttributeKey');
  function get_1(key) {
    var tmp0_elvis_lhs = this.l8s(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('No instance for key ' + key.toString());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  initMetadataForInterface(Attributes, 'Attributes');
  initMetadataForCoroutine($toByteArrayCOROUTINE$0, CoroutineImpl);
  initMetadataForClass(CaseInsensitiveMap, 'CaseInsensitiveMap', CaseInsensitiveMap, VOID, [KtMutableMap]);
  initMetadataForClass(Entry_2, 'Entry', VOID, VOID, [MutableEntry]);
  initMetadataForClass(SilentSupervisor$$inlined$CoroutineExceptionHandler$1, VOID, VOID, AbstractCoroutineContextElement, [AbstractCoroutineContextElement, Element_0]);
  initMetadataForClass(DelegatingMutableSet$iterator$1);
  initMetadataForClass(DelegatingMutableSet, 'DelegatingMutableSet', VOID, VOID, [KtMutableSet]);
  initMetadataForClass(Platform_0, 'Platform', VOID, Enum);
  initMetadataForObject(PlatformUtils, 'PlatformUtils');
  function get_2(name) {
    var tmp0_safe_receiver = this.g8u(name);
    return tmp0_safe_receiver == null ? null : firstOrNull_0(tmp0_safe_receiver);
  }
  function forEach(body) {
    var _iterator__ex2g4s = this.i8u().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.util.StringValues.forEach.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var k = element.x();
      // Inline function 'kotlin.collections.component2' call
      var v = element.y();
      body(k, v);
    }
    return Unit_instance;
  }
  initMetadataForInterface(StringValues, 'StringValues');
  initMetadataForClass(StringValuesBuilderImpl, 'StringValuesBuilderImpl', StringValuesBuilderImpl);
  initMetadataForClass(StringValuesImpl, 'StringValuesImpl', StringValuesImpl, VOID, [StringValues]);
  initMetadataForClass(CaseInsensitiveString, 'CaseInsensitiveString');
  initMetadataForClass(ChannelIOException, 'ChannelIOException', VOID, IOException);
  initMetadataForClass(CopyOnWriteHashMap, 'CopyOnWriteHashMap', CopyOnWriteHashMap);
  initMetadataForCompanion(Companion_136);
  initMetadataForClass(GMTDate, 'GMTDate', VOID, VOID, [Comparable]);
  initMetadataForCompanion(Companion_137);
  initMetadataForClass(WeekDay, 'WeekDay', VOID, Enum);
  initMetadataForCompanion(Companion_138);
  initMetadataForClass(Month, 'Month', VOID, Enum);
  initMetadataForClass(Symbol_1, 'Symbol');
  initMetadataForClass(LockFreeLinkedListNode, 'LockFreeLinkedListNode');
  initMetadataForClass(Removed, 'Removed');
  initMetadataForClass(OpDescriptor_0, 'OpDescriptor');
  initMetadataForCoroutine($proceedLoopCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(PipelineContext, 'PipelineContext', VOID, VOID, [CoroutineScope], [1, 0]);
  initMetadataForClass(DebugPipelineContext, 'DebugPipelineContext', VOID, PipelineContext, VOID, [1, 0]);
  initMetadataForCompanion(Companion_139);
  initMetadataForClass(PhaseContent, 'PhaseContent');
  initMetadataForClass(Pipeline, 'Pipeline', VOID, VOID, VOID, [2]);
  initMetadataForClass(PipelinePhase, 'PipelinePhase');
  initMetadataForClass(InvalidPhaseException, 'InvalidPhaseException', VOID, Error);
  initMetadataForClass(PipelinePhaseRelation, 'PipelinePhaseRelation');
  initMetadataForClass(After, 'After', VOID, PipelinePhaseRelation);
  initMetadataForClass(Before, 'Before', VOID, PipelinePhaseRelation);
  initMetadataForObject(Last, 'Last', VOID, PipelinePhaseRelation);
  initMetadataForClass(SuspendFunctionGun$continuation$1, VOID, VOID, VOID, [Continuation]);
  initMetadataForClass(SuspendFunctionGun, 'SuspendFunctionGun', VOID, PipelineContext, VOID, [0, 1]);
  initMetadataForClass(TypeInfo, 'TypeInfo');
  initMetadataForClass(AttributesJs, 'AttributesJs', AttributesJs, VOID, [Attributes]);
  initMetadataForClass(InvalidTimestampException, 'InvalidTimestampException', VOID, IllegalStateException);
  initMetadataForClass(KtorSimpleLogger$1);
  initMetadataForClass(LogLevel, 'LogLevel', VOID, Enum);
  initMetadataForObject(JsType, 'JsType');
  initMetadataForClass(URLDecodeException, 'URLDecodeException', VOID, Exception);
  initMetadataForCompanion(Companion_140);
  initMetadataForObject(Application, 'Application');
  initMetadataForObject(Text, 'Text');
  initMetadataForClass(HeaderValueWithParameters, 'HeaderValueWithParameters');
  initMetadataForClass(ContentType, 'ContentType', VOID, HeaderValueWithParameters);
  initMetadataForClass(BadContentTypeFormatException, 'BadContentTypeFormatException', VOID, Exception);
  initMetadataForCompanion(Companion_141);
  initMetadataForCompanion(Companion_142);
  initMetadataForClass(HeadersBuilder, 'HeadersBuilder', HeadersBuilder, StringValuesBuilderImpl);
  initMetadataForObject(EmptyHeaders, 'EmptyHeaders', VOID, VOID, [StringValues]);
  initMetadataForClass(HeadersImpl, 'HeadersImpl', HeadersImpl, StringValuesImpl, [StringValues, StringValuesImpl]);
  initMetadataForClass(HeaderValueParam, 'HeaderValueParam');
  initMetadataForClass(HeaderValue, 'HeaderValue');
  initMetadataForClass(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForObject(HttpHeaders, 'HttpHeaders');
  initMetadataForClass(IllegalHeaderNameException, 'IllegalHeaderNameException', VOID, IllegalArgumentException);
  initMetadataForClass(IllegalHeaderValueException, 'IllegalHeaderValueException', VOID, IllegalArgumentException);
  initMetadataForClass(UnsafeHeaderException, 'UnsafeHeaderException', VOID, IllegalArgumentException);
  initMetadataForCompanion(Companion_143);
  initMetadataForClass(HttpMethod, 'HttpMethod');
  initMetadataForCompanion(Companion_144);
  initMetadataForClass(HttpProtocolVersion, 'HttpProtocolVersion');
  initMetadataForCompanion(Companion_145);
  initMetadataForClass(HttpStatusCode, 'HttpStatusCode', VOID, VOID, [Comparable]);
  initMetadataForCompanion(Companion_146);
  initMetadataForInterface(Parameters, 'Parameters', VOID, VOID, [StringValues]);
  initMetadataForObject(EmptyParameters, 'EmptyParameters', VOID, VOID, [Parameters]);
  initMetadataForClass(ParametersBuilderImpl, 'ParametersBuilderImpl', ParametersBuilderImpl, StringValuesBuilderImpl);
  initMetadataForClass(ParametersImpl, 'ParametersImpl', ParametersImpl, StringValuesImpl, [Parameters, StringValuesImpl]);
  initMetadataForCompanion(Companion_147);
  initMetadataForClass(URLBuilder, 'URLBuilder', URLBuilder);
  initMetadataForClass(URLParserException, 'URLParserException', VOID, IllegalStateException);
  initMetadataForCompanion(Companion_148);
  initMetadataForClass(URLProtocol, 'URLProtocol');
  initMetadataForCompanion(Companion_149);
  initMetadataForClass(Url_0, 'Url');
  initMetadataForClass(UrlDecodedParametersBuilder, 'UrlDecodedParametersBuilder');
  initMetadataForClass(OutgoingContent, 'OutgoingContent');
  initMetadataForClass(ByteArrayContent_0, 'ByteArrayContent', VOID, OutgoingContent);
  initMetadataForClass(ByteArrayContent, 'ByteArrayContent', VOID, ByteArrayContent_0);
  initMetadataForClass(NoContent, 'NoContent', VOID, OutgoingContent);
  initMetadataForClass(ReadChannelContent, 'ReadChannelContent', VOID, OutgoingContent);
  initMetadataForClass(WriteChannelContent, 'WriteChannelContent', VOID, OutgoingContent, VOID, [1]);
  initMetadataForClass(ProtocolUpgrade, 'ProtocolUpgrade', VOID, OutgoingContent, VOID, [4]);
  initMetadataForObject(NullBody, 'NullBody');
  initMetadataForClass(TextContent, 'TextContent', VOID, ByteArrayContent_0);
  initMetadataForCompanion(Companion_150);
  initMetadataForClass(Codes, 'Codes', VOID, Enum);
  initMetadataForClass(CloseReason, 'CloseReason');
  function send(frame, $completion) {
    return this.j9a().z1b(frame, $completion);
  }
  initMetadataForInterface(WebSocketSession, 'WebSocketSession', VOID, VOID, [CoroutineScope], [1, 0]);
  initMetadataForInterface(DefaultWebSocketSession, 'DefaultWebSocketSession', VOID, VOID, [WebSocketSession], [1, 0]);
  initMetadataForCompanion(Companion_151);
  initMetadataForLambda(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($outgoingProcessorLoopCOROUTINE$0, CoroutineImpl);
  initMetadataForCoroutine($sendCloseSequenceCOROUTINE$1, CoroutineImpl);
  initMetadataForCoroutine($checkMaxFrameSizeCOROUTINE$2, CoroutineImpl);
  initMetadataForClass(DefaultWebSocketSessionImpl, 'DefaultWebSocketSessionImpl', VOID, VOID, [DefaultWebSocketSession, WebSocketSession], [1, 0, 2]);
  initMetadataForObject(NonDisposableHandle_0, 'NonDisposableHandle', VOID, VOID, [DisposableHandle]);
  initMetadataForClass(FrameTooBigException, 'FrameTooBigException', VOID, Exception);
  initMetadataForCompanion(Companion_152);
  initMetadataForClass(FrameType, 'FrameType', VOID, Enum);
  initMetadataForLambda(ponger$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(pinger$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(pinger$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(pinger$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(WebSocketExtensionsConfig, 'WebSocketExtensionsConfig', WebSocketExtensionsConfig);
  initMetadataForClass(WebSocketExtensionHeader, 'WebSocketExtensionHeader');
  initMetadataForCoroutine($closeCOROUTINE$3, CoroutineImpl);
  initMetadataForClass(Frame, 'Frame');
  initMetadataForClass(Binary, 'Binary', VOID, Frame);
  initMetadataForClass(Text_0, 'Text', VOID, Frame);
  initMetadataForClass(Close, 'Close', Close_init_$Create$_0, Frame);
  initMetadataForClass(Ping, 'Ping', VOID, Frame);
  initMetadataForClass(Pong, 'Pong', VOID, Frame);
  initMetadataForCompanion(Companion_153);
  initMetadataForCompanion(Companion_154);
  initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(InstanceId, 'InstanceId', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_157});
  initMetadataForClass(PublishedInstanceId, 'PublishedInstanceId', VOID, InstanceId, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  initMetadataForCompanion(Companion_155);
  initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RemoteInstanceId, 'RemoteInstanceId', VOID, InstanceId, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  initMetadataForCompanion(Companion_156);
  initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MethodId, 'MethodId', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
  initMetadataForCompanion(Companion_157, VOID, [SerializerFactory]);
  initMetadataForInterface(ImmediateMethodHandle, 'ImmediateMethodHandle');
  initMetadataForClass(InstanceDescriptor, 'InstanceDescriptor');
  initMetadataForInterface(InstancePublication, 'InstancePublication', VOID, VOID, [Disposable]);
  initMetadataForClass(LocalInstancePublication, 'LocalInstancePublication', VOID, VOID, [InstancePublication, Disposable]);
  initMetadataForClass(RemoteInstancePublication, 'RemoteInstancePublication', VOID, VOID, [InstancePublication]);
  initMetadataForObject(OppositeInstanceIdSerializer, 'OppositeInstanceIdSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(InstancePublicationSerializer, 'InstancePublicationSerializer', VOID, VOID, [KSerializer]);
  initMetadataForCompanion(Companion_158);
  initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(InstancePublicationTransfer, 'InstancePublicationTransfer', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
  initMetadataForClass(MethodDescriptorImpl, 'MethodDescriptorImpl', VOID, VOID, VOID, [2]);
  initMetadataForCoroutine($callCOROUTINE$0, CoroutineImpl);
  initMetadataForClass(mapResult$1, VOID, VOID, VOID, VOID, [2]);
  initMetadataForClass(RemoteInvocationException, 'RemoteInvocationException', VOID, RuntimeException);
  initMetadataForClass(RpcEndpointMethod, 'RpcEndpointMethod', VOID, VOID, [Job], [0]);
  initMetadataForClass(CallRemote, 'CallRemote', VOID, RpcEndpointMethod, VOID, [0]);
  initMetadataForClass(DisposeRemote, 'DisposeRemote', VOID, RpcEndpointMethod, VOID, [0]);
  function publishInstance$default(instance, instanceDescriptor, instanceDisposal, $completion, $super) {
    instanceDisposal = instanceDisposal === VOID ? Companion_getInstance_25().wr_1 : instanceDisposal;
    return $super === VOID ? this.l9l(instance, instanceDescriptor, instanceDisposal, $completion) : $super.l9l.call(this, instance, instanceDescriptor, instanceDisposal, $completion);
  }
  initMetadataForInterface(RpcFacade, 'RpcFacade', VOID, VOID, VOID, [3]);
  initMetadataForClass(RpcFacadeCancellationException, 'RpcFacadeCancellationException', RpcFacadeCancellationException, CancellationException);
  initMetadataForCoroutine($callRemoteCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(RpcEndpointImpl, 'RpcEndpointImpl', VOID, VOID, [Disposable], [4]);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_4, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_5, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(RpcFacadeImpl, 'RpcFacadeImpl', VOID, VOID, [RpcFacade], [3]);
  initMetadataForClass(BinaryFormatsImpl, 'BinaryFormatsImpl');
  initMetadataForLambda(rpcFacade$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(rpcIncomingMessagesProcessor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(rpcOutgoingCallsProcessor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(RpcFacadeStub, 'RpcFacadeStub', VOID, VOID, [SerializerFactory], VOID, VOID, {0: RpcFacadeStub_getInstance});
  initMetadataForClass(RpcFacadeIntrinsicSerializer, 'RpcFacadeIntrinsicSerializer', VOID, VOID, [KSerializer]);
  initMetadataForCompanion(Companion_159, VOID, [SerializerFactory]);
  initMetadataForClass($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RpcFacadeMixin, 'RpcFacadeMixin', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_159});
  initMetadataForClass(mixinFacade$1, VOID, VOID, VOID, VOID, [2]);
  initMetadataForLambda(RpcIncomingCalls$launchCall$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($processCallCOROUTINE$2, CoroutineImpl);
  initMetadataForClass(RpcIncomingCalls, 'RpcIncomingCalls', VOID, VOID, VOID, [4]);
  initMetadataForClass(RpcInstancesPublisher, 'RpcInstancesPublisher', VOID, VOID, [Disposable]);
  initMetadataForLambda(PublicationEntry$asHandle$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(PublicationEntry, 'PublicationEntry');
  initMetadataForClass(PublishedMethodHandle, 'PublishedMethodHandle', VOID, VOID, VOID, [1]);
  initMetadataForClass(MissingInstanceException, 'MissingInstanceException', VOID, RuntimeException);
  initMetadataForClass(MissingMethodException, 'MissingMethodException', VOID, RuntimeException);
  initMetadataForCompanion(Companion_160);
  initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_161);
  initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_162);
  initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_163);
  initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RpcMessage, 'RpcMessage', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_164});
  initMetadataForClass(Call, 'Call', VOID, RpcMessage, VOID, VOID, VOID, {0: $serializer_getInstance_10});
  initMetadataForClass(Dispose, 'Dispose', VOID, RpcMessage, VOID, VOID, VOID, {0: $serializer_getInstance_11});
  initMetadataForClass(Answer, 'Answer', VOID, RpcMessage, VOID, VOID, VOID, {0: $serializer_getInstance_12});
  initMetadataForClass(ErrorAnswer, 'ErrorAnswer', VOID, RpcMessage, VOID, VOID, VOID, {0: $serializer_getInstance_13});
  initMetadataForCompanion(Companion_164, VOID, [SerializerFactory]);
  initMetadataForCoroutine($startCallCOROUTINE$3, CoroutineImpl);
  initMetadataForCoroutine($completeCallCOROUTINE$4, CoroutineImpl);
  initMetadataForCoroutine($failCallCOROUTINE$5, CoroutineImpl);
  initMetadataForClass(RpcOutgoingCalls, 'RpcOutgoingCalls', VOID, VOID, VOID, [1, 2]);
  initMetadataForClass(RpcOutgoingCallsMessage, 'RpcOutgoingCallsMessage');
  initMetadataForClass(InitiateCall, 'InitiateCall', VOID, RpcOutgoingCallsMessage);
  initMetadataForClass(CompleteCall, 'CompleteCall', VOID, RpcOutgoingCallsMessage);
  initMetadataForClass(FailCall, 'FailCall', VOID, RpcOutgoingCallsMessage);
  initMetadataForClass(MissingOutgoingCallException, 'MissingOutgoingCallException', VOID, RuntimeException);
  initMetadataForLambda(rpcOutgoingCalls$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForInterface(Runnable_0, 'Runnable', VOID, VOID, VOID, [0]);
  initMetadataForObject(RunnableSerializer, 'RunnableSerializer', VOID, InstancePublicationSerializer);
  initMetadataForLambda(RemoteRunnable$Descriptor$run$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(Descriptor_0, 'Descriptor', VOID, InstanceDescriptor);
  initMetadataForClass(RemoteRunnable, 'RemoteRunnable', VOID, VOID, [Runnable_0], [0]);
  initMetadataForCompanion(Companion_165, VOID, [Key_5]);
  initMetadataForClass(RpcFacadeContainer, 'RpcFacadeContainer', RpcFacadeContainer);
  initMetadataForLambda(flowBasedMethod$slambda$slambda$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$6, CoroutineImpl);
  initMetadataForClass(flowBasedMethod$1$1$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_7, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(flowBasedMethod$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(flowBasedMethod$1$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForLambda(flowBasedMethod$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(flowBasedMethod$o$call$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(flowBasedMethod$o$call$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($callCOROUTINE$7, CoroutineImpl);
  initMetadataForClass(flowBasedMethod$1, VOID, VOID, VOID, VOID, [2]);
  initMetadataForClass(StopHandle, 'StopHandle', StopHandle, VOID, [Runnable_0], [0]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0, 'sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0', VOID, VOID, [ImmediateMethodHandle, FunctionAdapter]);
  initMetadataForLambda(flowMethod$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(flowMethod$slambda$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$8, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_8, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(flowMethod$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(flowMethod$1$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(flowMethod$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(flowMethod$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(flowMethod$lambda$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$9, CoroutineImpl);
  initMetadataForClass(flowMethod$1$$inlined$map$2, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(PublishedFlowCollectorSerializer, 'PublishedFlowCollectorSerializer', VOID, InstancePublicationSerializer);
  initMetadataForLambda(RemoteFlowCollector$Descriptor$emit$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Descriptor_1, 'Descriptor', VOID, InstanceDescriptor);
  initMetadataForClass(RemoteFlowCollector, 'RemoteFlowCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(FlowMessage, 'FlowMessage');
  initMetadataForClass(Element_2, 'Element', VOID, FlowMessage);
  initMetadataForClass(End, 'End', End, FlowMessage);
  initMetadataForClass(Error_1, 'Error', VOID, FlowMessage);
  initMetadataForCompanion(Companion_166, VOID, [SerializerFactory]);
  initMetadataForClass($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(FlowMessageData, 'FlowMessageData', FlowMessageData, VOID, VOID, VOID, VOID, {0: Companion_getInstance_166});
  initMetadataForObject(PublishedDisposableSerializer, 'PublishedDisposableSerializer', VOID, InstancePublicationSerializer);
  initMetadataForCompanion(Companion_167, InstanceDescriptor);
  initMetadataForClass(RemoteDisposable, 'RemoteDisposable', VOID, VOID, [Disposable]);
  initMetadataForClass(RpcClient, 'RpcClient', VOID, VOID, [CoroutineScope]);
  initMetadataForLambda(rpcClient$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(rpcClient$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(wsEntryPoints$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(wsEntryPoints$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sessionJob$$inlined$CoroutineExceptionHandler$1, VOID, VOID, AbstractCoroutineContextElement, [AbstractCoroutineContextElement, Element_0]);
  initMetadataForInterface(RpcInitiationHandler, 'RpcInitiationHandler');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0, 'sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0', VOID, VOID, [RpcInitiationHandler, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0, 'sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0', VOID, VOID, [RpcInitiationHandler, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1, 'sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0', VOID, VOID, [RpcInitiationHandler, FunctionAdapter]);
  initMetadataForLambda(ClientRpcInitiationHandler$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ServerRpcInitiationHandler$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(RpcSchema$connect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(RpcSchema, 'RpcSchema', VOID, VOID, VOID, [2]);
  initMetadataForCompanion(Companion_168);
  initMetadataForClass(RpcSessionCounter, 'RpcSessionCounter', RpcSessionCounter, AbstractCoroutineContextElement);
  initMetadataForClass(WsRpcSession, 'WsRpcSession');
  initMetadataForLambda(rpcSession$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(rpcSession$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(rpcSession$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(WsSession, 'WsSession');
  initMetadataForLambda(WsSessionScope$bind$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(WsSessionScope$bind$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(WsSessionScope$bind$slambda$slambda_3, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(WsSessionScope$bind$slambda$slambda_5, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(WsSessionScope$bind$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(WsSessionScope, 'WsSessionScope', VOID, VOID, VOID, [3]);
  initMetadataForLambda(WsSessionProvider$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(WsSession$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_169);
  initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(NodeResolveInfo, 'NodeResolveInfo', NodeResolveInfo, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
  initMetadataForObject($serializer_17, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedReference, 'SerializedReference', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
  initMetadataForCompanion(Companion_170);
  initMetadataForObject($serializer_18, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedReferenceLocation, 'SerializedReferenceLocation', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
  initMetadataForCompanion(Companion_171);
  initMetadataForObject($serializer_19, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedReferenceValue, 'SerializedReferenceValue', SerializedReferenceValue, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
  initMetadataForLambda(nodeResolutionMethod$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCompanion(Companion_172);
  initMetadataForClass(NodeResolutionProvider, 'NodeResolutionProvider');
  initMetadataForCompanion(Companion_173);
  initMetadataForObject($serializer_20, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_174);
  initMetadataForObject($serializer_21, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(NodeResolveInfoMessage, 'NodeResolveInfoMessage', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_175});
  initMetadataForClass(StateReceived, 'StateReceived', VOID, NodeResolveInfoMessage, VOID, VOID, VOID, {0: $serializer_getInstance_18});
  initMetadataForClass(UpdateReceived, 'UpdateReceived', VOID, NodeResolveInfoMessage, VOID, VOID, VOID, {0: $serializer_getInstance_19});
  initMetadataForCompanion(Companion_175, VOID, [SerializerFactory]);
  initMetadataForCompanion(Companion_176);
  initMetadataForObject($serializer_22, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(NodeResolveInfoUpdate, 'NodeResolveInfoUpdate', NodeResolveInfoUpdate, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_20});
  initMetadataForCompanion(Companion_177);
  initMetadataForObject($serializer_23, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Remote, 'Remote');
  initMetadataForCompanion(Companion_178, InstanceDescriptor);
  initMetadataForObject(Empty_3, 'Empty');
  initMetadataForClass(ElementsParameters, 'ElementsParameters', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_21});
  initMetadataForObject(Serializer_0, 'Serializer', VOID, InstancePublicationSerializer);
  initMetadataForCompanion(Companion_179);
  initMetadataForObject($serializer_24, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ReferenceTarget, 'ReferenceTarget', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_22});
  initMetadataForCompanion(Companion_180);
  initMetadataForObject($serializer_25, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SerializedResolvedNode, 'SerializedResolvedNode', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_23});
  initMetadataForClass(LiveResolutionClient, 'LiveResolutionClient');
  initMetadataForClass(sam$jetbrains_ocelot_base_observable_event_EventSource$0_0, 'sam$jetbrains_ocelot_base_observable_event_EventSource$0', VOID, VOID, [EventSource, FunctionAdapter]);
  initMetadataForClass(LiveResolutionClientState$findTarget$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(LiveResolutionClientState$findLocalTarget$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(LiveResolutionClientState, 'LiveResolutionClientState');
  initMetadataForLambda(LiveResolutionClient$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_9, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(LiveResolutionClient$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LiveResolutionClient$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(LiveResolutionClient$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForClass(createReferenceActivatorNodeListener$1);
  initMetadataForClass(LiveResolutionClientMessage, 'LiveResolutionClientMessage');
  initMetadataForClass(MessageReceived, 'MessageReceived', VOID, LiveResolutionClientMessage);
  initMetadataForClass(ReferenceActivated, 'ReferenceActivated', VOID, LiveResolutionClientMessage);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2, 'sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0', VOID, VOID, [ReferenceFactory, FunctionAdapter]);
  initMetadataForCoroutine($runSuspendCOROUTINE$0_1, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$1_1, CoroutineImpl);
  initMetadataForCompanion(Companion_181);
  initMetadataForClass(LiveResolutionReference$resolve$$inlined$flatMap$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(LiveResolutionReference$find$$inlined$flatMap$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(LiveResolutionReference, 'LiveResolutionReference', VOID, PropertyBasedReference, VOID, [1]);
  initMetadataForCompanion(Companion_182);
  initMetadataForClass(LiveResolutionReferenceValue, 'LiveResolutionReferenceValue');
  initMetadataForCompanion(Companion_183, VOID, [Key_5]);
  initMetadataForClass(State_0, 'State', VOID, Enum);
  initMetadataForClass(LiveResolutionService, 'LiveResolutionService');
  initMetadataForLambda(RemoteReferenceTargetsSupplier$getElements$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_10, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(RemoteReferenceTargetsSupplier$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(RemoteReferenceTargetsSupplier, 'RemoteReferenceTargetsSupplier', VOID, VOID, [ReferenceTargetsSupplier]);
  initMetadataForCompanion(Companion_184, VOID, [Key_5]);
  initMetadataForClass(PrecalculatedResolutionService, 'PrecalculatedResolutionService');
  initMetadataForClass(BioKbOtStructureRuntime, 'BioKbOtStructureRuntime', BioKbOtStructureRuntime);
  initMetadataForObject(GeneratedBioKbStuff, 'GeneratedBioKbStuff');
  initMetadataForObject(AbstractBindingDeclarationConcept, 'AbstractBindingDeclarationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractBindingEntryConcept, 'AbstractBindingEntryConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractBindingValueConcept, 'AbstractBindingValueConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractBindingValueQueryConcept, 'AbstractBindingValueQueryConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractLinkConcept, 'AbstractLinkConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractNotionConcept, 'AbstractNotionConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractOntologyRelationConcept, 'AbstractOntologyRelationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractProcessSpecificationConcept, 'AbstractProcessSpecificationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractPropertyConcept, 'AbstractPropertyConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AbstractValueConcept, 'AbstractValueConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AnonymousClassConcept, 'AnonymousClassConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(AuthorConcept, 'AuthorConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(AuthoredWorkConcept, 'AuthoredWorkConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(BTBDocumentConcept, 'BTBDocumentConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(BindingPropertyConcept, 'BindingPropertyConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(BindingValueMaskConcept, 'BindingValueMaskConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(BindingValuePlaceholderConcept, 'BindingValuePlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(BindingValuePlaceholderQueryConcept, 'BindingValuePlaceholderQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(BookConcept, 'BookConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CardinalityBoundConcept, 'CardinalityBoundConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CardinalityBoundConstantConcept, 'CardinalityBoundConstantConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CardinalityBoundNConcept, 'CardinalityBoundNConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CardinalityBoundPlaceholderConcept, 'CardinalityBoundPlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CardinalityConcept, 'CardinalityConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CardinalityCustomCellConcept, 'CardinalityCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CategoryConcept, 'CategoryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ClassDeclarationConcept, 'ClassDeclarationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ClassExpressionConcept, 'ClassExpressionConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ClassExpressionPlaceholderConcept, 'ClassExpressionPlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ClassExpressionTypeConcept, 'ClassExpressionTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CommandConcept, 'CommandConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ConstantCustomCellConcept, 'ConstantCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(ConstantPreconditionConcept, 'ConstantPreconditionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ContextConcept, 'ContextConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ContextQueryConcept, 'ContextQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(CustomCellConcept, 'CustomCellConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(CustomEditorConcept, 'CustomEditorConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(DeclarationNameCustomCellConcept, 'DeclarationNameCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(DeclarationValueQueryConcept, 'DeclarationValueQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(DirectlyNamedConcept, 'DirectlyNamedConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(DocumentNodeConcept, 'DocumentNodeConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(EmptyBindingEntryConcept, 'EmptyBindingEntryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(EmptyPropertyLibraryElementConcept, 'EmptyPropertyLibraryElementConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(EnumValueConcept, 'EnumValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(EnumerableNotionConcept, 'EnumerableNotionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(EnumerationConstantConcept, 'EnumerationConstantConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ExtensionDeclarationConcept, 'ExtensionDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ExtensionFieldReferenceConcept, 'ExtensionFieldReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ExtensionLibraryConcept, 'ExtensionLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ExternallyNamedConcept, 'ExternallyNamedConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(FactConcept, 'FactConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FactExpressionConcept, 'FactExpressionConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(FactExpressionPlaceholderConcept, 'FactExpressionPlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FactPreconditionConcept, 'FactPreconditionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FactReferenceConcept, 'FactReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FactSetConcept, 'FactSetConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FieldDeclarationConcept, 'FieldDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FindConnectionCommandConcept, 'FindConnectionCommandConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FunctionDeclarationConcept, 'FunctionDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(FunctionLibraryConcept, 'FunctionLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(FunctionTermConcept, 'FunctionTermConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(HasCommentsConcept, 'HasCommentsConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(HasFactExpressionConcept, 'HasFactExpressionConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(HasKnowledgeSourcesConcept, 'HasKnowledgeSourcesConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(HasPropertyConstraintsConcept, 'HasPropertyConstraintsConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(HasQueryLabelsConcept, 'HasQueryLabelsConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(HasVariablesConcept, 'HasVariablesConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ImportedLinkConcept, 'ImportedLinkConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ImportedPropertyConcept, 'ImportedPropertyConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(InstanceRelationDeclarationConcept, 'InstanceRelationDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(InstanceRelationValueConcept, 'InstanceRelationValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(InstanceRelationValuePlaceholderConcept, 'InstanceRelationValuePlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(IsExpressionConcept, 'IsExpressionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(KindCustomCellConcept, 'KindCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(KnowledgeSourceReferenceConcept, 'KnowledgeSourceReferenceConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(KnowledgeSourceReferencePlaceholderConcept, 'KnowledgeSourceReferencePlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(LibraryItemConcept, 'LibraryItemConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(LibraryItemPlaceholderConcept, 'LibraryItemPlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(LibraryProcessSpecificationConcept, 'LibraryProcessSpecificationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(LibraryProcessSpecificationQueryConcept, 'LibraryProcessSpecificationQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(LinkCustomCellConcept, 'LinkCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(LinkDeclarationConcept, 'LinkDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(LinkLibraryConcept, 'LinkLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(LocalOntologyElementReferenceConcept, 'LocalOntologyElementReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(MeasurableNotionConcept, 'MeasurableNotionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(MeasurableValueConcept, 'MeasurableValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(MeasurementUnitConcept, 'MeasurementUnitConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ModifierContainerConcept, 'ModifierContainerConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ModifierDeclarationConcept, 'ModifierDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ModifierFactExpressionConcept, 'ModifierFactExpressionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(MultilineTextConcept, 'MultilineTextConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(MultipleProcessPropertyValueRangeConcept, 'MultipleProcessPropertyValueRangeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(MultiplePropertyValueRangeConcept, 'MultiplePropertyValueRangeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NewFactConcept, 'NewFactConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NewFactReferenceConcept, 'NewFactReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NoValuesConcept, 'NoValuesConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NotionLibraryConcept, 'NotionLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NotionPlaceholderConcept, 'NotionPlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NotionTypeConcept, 'NotionTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ObjectPropertiesLibraryConcept, 'ObjectPropertiesLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ObjectPropertyDeclarationConcept, 'ObjectPropertyDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ObjectPropertyReferenceValueConcept, 'ObjectPropertyReferenceValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OldPublishedSourceConcept, 'OldPublishedSourceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OneOfConcept, 'OneOfConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyCardinalityRelationConcept, 'OntologyCardinalityRelationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementConcept, 'OntologyElementConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementDefinitionConcept, 'OntologyElementDefinitionConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(OntologyElementPropertyTypeConcept, 'OntologyElementPropertyTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementReferenceConcept, 'OntologyElementReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementReferenceProviderConcept, 'OntologyElementReferenceProviderConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(OntologyElementReferenceValueConcept, 'OntologyElementReferenceValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementReferenceValueLibraryConcept, 'OntologyElementReferenceValueLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementSynonymConcept, 'OntologyElementSynonymConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyElementTypeConcept, 'OntologyElementTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyImportConcept, 'OntologyImportConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyImportRootConcept, 'OntologyImportRootConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyImportRootReferenceConcept, 'OntologyImportRootReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyIsRelationConcept, 'OntologyIsRelationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyLibraryConcept, 'OntologyLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyLibraryReferenceConcept, 'OntologyLibraryReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyLinkConcept, 'OntologyLinkConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyLinkDeclarationValueQueryConcept, 'OntologyLinkDeclarationValueQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OntologyLinkValueConcept, 'OntologyLinkValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(OrValueQueryConcept, 'OrValueQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PageConcept, 'PageConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PageRangeConcept, 'PageRangeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PageSpecificationConcept, 'PageSpecificationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(PaperConcept, 'PaperConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PartReferenceOperationConcept, 'PartReferenceOperationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(PartValueConcept, 'PartValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PreconditionConcept, 'PreconditionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessDeclarationConcept, 'ProcessDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessEffectConcept, 'ProcessEffectConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessKindConcept, 'ProcessKindConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessKindContainerConcept, 'ProcessKindContainerConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessLibraryConcept, 'ProcessLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPrerequisiteConcept, 'ProcessPrerequisiteConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPropertyConcept, 'ProcessPropertyConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPropertyCustomCellConcept, 'ProcessPropertyCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPropertyDefaultConcept, 'ProcessPropertyDefaultConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPropertyReferenceConcept, 'ProcessPropertyReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPropertyTypeConcept, 'ProcessPropertyTypeConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ProcessPropertyValueConcept, 'ProcessPropertyValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessPropertyValueRangeConcept, 'ProcessPropertyValueRangeConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ProcessProviderConcept, 'ProcessProviderConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(ProcessReferenceConcept, 'ProcessReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(ProcessRelationDeclarationConcept, 'ProcessRelationDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ProcessTypeConcept, 'ProcessTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertiesCustomCellConcept, 'PropertiesCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForClass(PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForClass(PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1, VOID, VOID, VOID, [NonNullPersister]);
  initMetadataForObject(PropertyConstraintConcept, 'PropertyConstraintConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyCustomCellConcept, 'PropertyCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyDeclarationConcept, 'PropertyDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyDeclarationValueQueryConcept, 'PropertyDeclarationValueQueryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyLibraryConcept, 'PropertyLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyLibraryElementConcept, 'PropertyLibraryElementConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(PropertyReferenceOperationConcept, 'PropertyReferenceOperationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyValueConcept, 'PropertyValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyValueRangeConcept, 'PropertyValueRangeConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(PubMedSourceReferenceConcept, 'PubMedSourceReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PublishedSourceReferenceConcept, 'PublishedSourceReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PublishedSourcesLibraryConcept, 'PublishedSourcesLibraryConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PublishedWorkConcept, 'PublishedWorkConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(QualifiedOntologyElementReferenceConcept, 'QualifiedOntologyElementReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(QueryCommandsConcept, 'QueryCommandsConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(QueryLabelsFactExpressionContainerConcept, 'QueryLabelsFactExpressionContainerConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(QueryParametersBlackListConcept, 'QueryParametersBlackListConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(RelationContainerConcept, 'RelationContainerConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(RelationFactExpressionConcept, 'RelationFactExpressionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ReturnTypeCustomCellConcept, 'ReturnTypeCustomCellConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(SetExpressionConcept, 'SetExpressionConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(SetValuedPropertyParameterConcept, 'SetValuedPropertyParameterConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(SimplePropertyTypeConcept, 'SimplePropertyTypeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(SinglePropertyValueRangeConcept, 'SinglePropertyValueRangeConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(TextLineConcept, 'TextLineConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(TypeConcept, 'TypeConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(TypePlaceholderConcept, 'TypePlaceholderConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(UnionClassConcept, 'UnionClassConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(UrlKnowledgeSourceReferenceConcept, 'UrlKnowledgeSourceReferenceConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(ValueWithRelationsConcept, 'ValueWithRelationsConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(VariableDeclarationConcept, 'VariableDeclarationConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(VariableInitializerConcept, 'VariableInitializerConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(VariableReferenceValueConcept, 'VariableReferenceValueConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(VariableSpecificationConcept, 'VariableSpecificationConcept', VOID, OTAbstractConceptDescriptor);
  initMetadataForObject(XRefContainerConcept, 'XRefContainerConcept', VOID, OtConceptDescriptor);
  initMetadataForInterface(BTBNode, 'BTBNode', VOID, VOID, [DomainNode]);
  initMetadataForClass(BTBNodeImpl, 'BTBNodeImpl', VOID, BaseNodeGen, [BaseNodeGen, BTBNode]);
  initMetadataForInterface(HasComments, 'HasComments', VOID, VOID, [DomainNode]);
  initMetadataForInterface(AbstractBindingDeclaration, 'AbstractBindingDeclaration', VOID, VOID, [BTBNode, DirectlyNamed, HasComments]);
  initMetadataForClass(AbstractBindingDeclarationImpl, 'AbstractBindingDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, AbstractBindingDeclaration]);
  initMetadataForInterface(AbstractBindingEntry, 'AbstractBindingEntry', VOID, VOID, [BTBNode, Named]);
  initMetadataForClass(AbstractBindingEntryImpl, 'AbstractBindingEntryImpl', VOID, BTBNodeImpl, [BTBNodeImpl, AbstractBindingEntry]);
  initMetadataForInterface(BindingValuePlaceholder_1, 'BindingValuePlaceholder', VOID, VOID, [BTBNode]);
  initMetadataForClass(BindingValuePlaceholderImpl, 'BindingValuePlaceholderImpl', VOID, BTBNodeImpl, [BTBNodeImpl, BindingValuePlaceholder_1]);
  initMetadataForInterface(AbstractBindingValue, 'AbstractBindingValue', VOID, VOID, [BindingValuePlaceholder_1]);
  initMetadataForClass(AbstractBindingValueImpl, 'AbstractBindingValueImpl', VOID, BindingValuePlaceholderImpl, [BindingValuePlaceholderImpl, AbstractBindingValue]);
  initMetadataForInterface(BindingValuePlaceholderQuery_1, 'BindingValuePlaceholderQuery', VOID, VOID, [BTBNode]);
  initMetadataForClass(BindingValuePlaceholderQueryImpl, 'BindingValuePlaceholderQueryImpl', VOID, BTBNodeImpl, [BTBNodeImpl, BindingValuePlaceholderQuery_1]);
  initMetadataForInterface(AbstractBindingValueQuery, 'AbstractBindingValueQuery', VOID, VOID, [BindingValuePlaceholderQuery_1]);
  initMetadataForClass(AbstractBindingValueQueryImpl, 'AbstractBindingValueQueryImpl', VOID, BindingValuePlaceholderQueryImpl, [BindingValuePlaceholderQueryImpl, AbstractBindingValueQuery]);
  function get_defaultLibraryReference() {
    return constant(null);
  }
  initMetadataForInterface(AbstractLink, 'AbstractLink', VOID, VOID, [AbstractBindingEntry]);
  initMetadataForClass(AbstractLinkImpl, 'AbstractLinkImpl', VOID, AbstractBindingEntryImpl, [AbstractBindingEntryImpl, AbstractLink]);
  initMetadataForInterface(AbstractNotion, 'AbstractNotion', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(AbstractNotionImpl, 'AbstractNotionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, AbstractNotion]);
  initMetadataForInterface(AbstractOntologyRelation, 'AbstractOntologyRelation', VOID, VOID, [BTBNode]);
  initMetadataForClass(AbstractOntologyRelationImpl, 'AbstractOntologyRelationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, AbstractOntologyRelation]);
  initMetadataForInterface(AbstractProcessSpecification, 'AbstractProcessSpecification', VOID, VOID, [BTBNode]);
  initMetadataForClass(AbstractProcessSpecificationImpl, 'AbstractProcessSpecificationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, AbstractProcessSpecification]);
  initMetadataForInterface(AbstractProperty, 'AbstractProperty', VOID, VOID, [AbstractBindingEntry]);
  initMetadataForClass(AbstractPropertyImpl, 'AbstractPropertyImpl', VOID, AbstractBindingEntryImpl, [AbstractBindingEntryImpl, AbstractProperty]);
  initMetadataForInterface(Author_1, 'Author', VOID, VOID, [DirectlyNamed, BTBNode]);
  initMetadataForClass(AuthorImpl, 'AuthorImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Author_1]);
  initMetadataForInterface(AuthoredWork, 'AuthoredWork', VOID, VOID, [BTBNode]);
  initMetadataForClass(AuthoredWorkImpl, 'AuthoredWorkImpl', VOID, BTBNodeImpl, [BTBNodeImpl, AuthoredWork]);
  initMetadataForInterface(ExternallyNamed, 'ExternallyNamed', VOID, VOID, [DirectlyNamed]);
  initMetadataForInterface(DocumentNode_0, 'DocumentNode', VOID, VOID, [BTBNode, DocumentNode, ExternallyNamed]);
  initMetadataForClass(DocumentNodeImpl, 'DocumentNodeImpl', VOID, BTBNodeImpl, [BTBNodeImpl, DocumentNode_0]);
  function librariesForElement(element) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new BTBDocument$librariesForElement$$inlined$suspendingQuery$1(this, element);
  }
  initMetadataForInterface(BTBDocument_1, 'BTBDocument', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(BTBDocumentImpl, 'BTBDocumentImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, BTBDocument_1]);
  function get_name() {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new BindingProperty$name$$inlined$query$1(this);
  }
  function get_type() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new BindingProperty$type$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(BindingProperty_1, 'BindingProperty', VOID, VOID, [AbstractProperty]);
  initMetadataForClass(BindingPropertyImpl, 'BindingPropertyImpl', VOID, AbstractPropertyImpl, [AbstractPropertyImpl, BindingProperty_1]);
  initMetadataForInterface(BindingValueMask_1, 'BindingValueMask', VOID, VOID, [AbstractBindingValueQuery]);
  initMetadataForClass(BindingValueMaskImpl, 'BindingValueMaskImpl', VOID, AbstractBindingValueQueryImpl, [AbstractBindingValueQueryImpl, BindingValueMask_1]);
  function get_name_0() {
    return this.zat();
  }
  function citation() {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new PublishedWork$citation$$inlined$query$1(this);
  }
  initMetadataForInterface(PublishedWork, 'PublishedWork', VOID, VOID, [AuthoredWork, DirectlyNamed]);
  initMetadataForClass(PublishedWorkImpl, 'PublishedWorkImpl', VOID, AuthoredWorkImpl, [AuthoredWorkImpl, PublishedWork]);
  initMetadataForInterface(LibraryItem, 'LibraryItem', VOID, VOID, [BTBNode]);
  initMetadataForInterface(Book_1, 'Book', VOID, VOID, [PublishedWork, LibraryItem]);
  initMetadataForClass(BookImpl, 'BookImpl', VOID, PublishedWorkImpl, [PublishedWorkImpl, Book_1]);
  initMetadataForInterface(CardinalityBound, 'CardinalityBound', VOID, VOID, [BTBNode]);
  initMetadataForClass(CardinalityBoundImpl, 'CardinalityBoundImpl', VOID, BTBNodeImpl, [BTBNodeImpl, CardinalityBound]);
  initMetadataForInterface(CardinalityBoundConstant_1, 'CardinalityBoundConstant', VOID, VOID, [CardinalityBound, BTBNode]);
  initMetadataForClass(CardinalityBoundConstantImpl, 'CardinalityBoundConstantImpl', VOID, CardinalityBoundImpl, [CardinalityBoundImpl, CardinalityBoundConstant_1]);
  initMetadataForInterface(CardinalityBoundN_1, 'CardinalityBoundN', VOID, VOID, [CardinalityBound]);
  initMetadataForClass(CardinalityBoundNImpl, 'CardinalityBoundNImpl', VOID, CardinalityBoundImpl, [CardinalityBoundImpl, CardinalityBoundN_1]);
  initMetadataForInterface(CardinalityBoundPlaceholder_1, 'CardinalityBoundPlaceholder', VOID, VOID, [BTBNode]);
  initMetadataForClass(CardinalityBoundPlaceholderImpl, 'CardinalityBoundPlaceholderImpl', VOID, BTBNodeImpl, [BTBNodeImpl, CardinalityBoundPlaceholder_1]);
  initMetadataForInterface(CustomCell, 'CustomCell', VOID, VOID, [BTBNode]);
  initMetadataForClass(CustomCellImpl, 'CustomCellImpl', VOID, BTBNodeImpl, [BTBNodeImpl, CustomCell]);
  initMetadataForInterface(CardinalityCustomCell_1, 'CardinalityCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(CardinalityCustomCellImpl, 'CardinalityCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, CardinalityCustomCell_1]);
  initMetadataForInterface(Cardinality_1, 'Cardinality', VOID, VOID, [BTBNode]);
  initMetadataForClass(CardinalityImpl, 'CardinalityImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Cardinality_1]);
  initMetadataForInterface(Category_1, 'Category', VOID, VOID, [BTBNode]);
  initMetadataForClass(CategoryImpl, 'CategoryImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Category_1]);
  initMetadataForInterface(ClassExpressionPlaceholder_1, 'ClassExpressionPlaceholder', VOID, VOID, [BTBNode]);
  initMetadataForClass(ClassExpressionPlaceholderImpl, 'ClassExpressionPlaceholderImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ClassExpressionPlaceholder_1]);
  initMetadataForInterface(VariableSpecification, 'VariableSpecification', VOID, VOID, [BTBNode]);
  initMetadataForClass(VariableSpecificationImpl, 'VariableSpecificationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, VariableSpecification]);
  initMetadataForInterface(Type, 'Type', VOID, VOID, [VariableSpecification]);
  initMetadataForClass(TypeImpl, 'TypeImpl', VOID, VariableSpecificationImpl, [VariableSpecificationImpl, Type]);
  initMetadataForInterface(ProcessPropertyValueRange, 'ProcessPropertyValueRange', VOID, VOID, [BTBNode]);
  function get_type_0() {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new ProcessPropertyType$type$$inlined$query$1(this);
  }
  initMetadataForInterface(ProcessPropertyType, 'ProcessPropertyType', VOID, VOID, [ProcessPropertyValueRange]);
  initMetadataForInterface(ClassExpressionType_1, 'ClassExpressionType', VOID, VOID, [Type, ProcessPropertyType]);
  initMetadataForClass(ClassExpressionTypeImpl, 'ClassExpressionTypeImpl', VOID, TypeImpl, [TypeImpl, ClassExpressionType_1]);
  initMetadataForInterface(Command_0, 'Command', VOID, VOID, [BTBNode]);
  initMetadataForClass(CommandImpl, 'CommandImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Command_0]);
  initMetadataForInterface(ConstantCustomCell_1, 'ConstantCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(ConstantCustomCellImpl, 'ConstantCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, ConstantCustomCell_1]);
  initMetadataForInterface(Precondition, 'Precondition', VOID, VOID, [BTBNode]);
  initMetadataForClass(PreconditionImpl, 'PreconditionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Precondition]);
  initMetadataForInterface(ConstantPrecondition_0, 'ConstantPrecondition', VOID, VOID, [Precondition]);
  initMetadataForClass(ConstantPreconditionImpl, 'ConstantPreconditionImpl', VOID, PreconditionImpl, [PreconditionImpl, ConstantPrecondition_0]);
  initMetadataForInterface(Context_1, 'Context', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ContextImpl, 'ContextImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Context_1]);
  initMetadataForInterface(ContextQuery_1, 'ContextQuery', VOID, VOID, [BTBNode]);
  initMetadataForClass(ContextQueryImpl, 'ContextQueryImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ContextQuery_1]);
  initMetadataForInterface(CustomEditor, 'CustomEditor', VOID, VOID, [BTBNode]);
  initMetadataForClass(CustomEditorImpl, 'CustomEditorImpl', VOID, BTBNodeImpl, [BTBNodeImpl, CustomEditor]);
  initMetadataForInterface(DeclarationNameCustomCell_1, 'DeclarationNameCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(DeclarationNameCustomCellImpl, 'DeclarationNameCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, DeclarationNameCustomCell_1]);
  initMetadataForInterface(DeclarationValueQuery, 'DeclarationValueQuery', VOID, VOID, [AbstractBindingValueQuery]);
  initMetadataForClass(DeclarationValueQueryImpl, 'DeclarationValueQueryImpl', VOID, AbstractBindingValueQueryImpl, [AbstractBindingValueQueryImpl, DeclarationValueQuery]);
  function get_name_1() {
    return constant('');
  }
  initMetadataForInterface(EmptyBindingEntry_1, 'EmptyBindingEntry', VOID, VOID, [AbstractBindingEntry]);
  initMetadataForClass(EmptyBindingEntryImpl, 'EmptyBindingEntryImpl', VOID, AbstractBindingEntryImpl, [AbstractBindingEntryImpl, EmptyBindingEntry_1]);
  initMetadataForInterface(PropertyLibraryElement, 'PropertyLibraryElement', VOID, VOID, [BTBNode]);
  initMetadataForInterface(EmptyPropertyLibraryElement_1, 'EmptyPropertyLibraryElement', VOID, VOID, [PropertyLibraryElement]);
  initMetadataForClass(EmptyPropertyLibraryElementImpl, 'EmptyPropertyLibraryElementImpl', VOID, BTBNodeImpl, [BTBNodeImpl, EmptyPropertyLibraryElement_1]);
  function transformToPropertyReferenceValue(wrapperContext) {
    // Inline function 'kotlin.also' call
    var this_0 = propertyReferenceValue(this, wrapperContext);
    // Inline function 'jetbrains.biokb.lang.model.AbstractValue.transformToPropertyReferenceValue.<anonymous>' call
    this.s6m(this_0);
    return this_0;
  }
  initMetadataForInterface(AbstractValue, 'AbstractValue', VOID, VOID, [BTBNode]);
  initMetadataForInterface(FactExpressionPlaceholder, 'FactExpressionPlaceholder', VOID, VOID, [BTBNode]);
  initMetadataForInterface(FactExpression, 'FactExpression', VOID, VOID, [FactExpressionPlaceholder]);
  initMetadataForInterface(EnumValue_1, 'EnumValue', VOID, VOID, [AbstractValue, FactExpression]);
  initMetadataForClass(EnumValueImpl, 'EnumValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, EnumValue_1]);
  initMetadataForInterface(EnumerableNotion_1, 'EnumerableNotion', VOID, VOID, [AbstractNotion]);
  initMetadataForClass(EnumerableNotionImpl, 'EnumerableNotionImpl', VOID, AbstractNotionImpl, [AbstractNotionImpl, EnumerableNotion_1]);
  initMetadataForInterface(EnumerationConstant_1, 'EnumerationConstant', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(EnumerationConstantImpl, 'EnumerationConstantImpl', VOID, BTBNodeImpl, [BTBNodeImpl, EnumerationConstant_1]);
  initMetadataForInterface(ExtensionDeclaration_1, 'ExtensionDeclaration', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ExtensionDeclarationImpl, 'ExtensionDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ExtensionDeclaration_1]);
  initMetadataForInterface(PartReferenceOperation, 'PartReferenceOperation', VOID, VOID, [BTBNode]);
  initMetadataForClass(PartReferenceOperationImpl, 'PartReferenceOperationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PartReferenceOperation]);
  initMetadataForInterface(ExtensionFieldReference_1, 'ExtensionFieldReference', VOID, VOID, [PartReferenceOperation]);
  initMetadataForClass(ExtensionFieldReferenceImpl, 'ExtensionFieldReferenceImpl', VOID, PartReferenceOperationImpl, [PartReferenceOperationImpl, ExtensionFieldReference_1]);
  initMetadataForInterface(ExtensionLibrary_1, 'ExtensionLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(ExtensionLibraryImpl, 'ExtensionLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, ExtensionLibrary_1]);
  initMetadataForClass(FactExpressionPlaceholderImpl, 'FactExpressionPlaceholderImpl', VOID, BTBNodeImpl, [BTBNodeImpl, FactExpressionPlaceholder]);
  initMetadataForInterface(Fact_1, 'Fact', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(FactImpl, 'FactImpl', VOID, BTBNodeImpl, [BTBNodeImpl, Fact_1]);
  initMetadataForInterface(FactPrecondition_1, 'FactPrecondition', VOID, VOID, [Precondition]);
  initMetadataForClass(FactPreconditionImpl, 'FactPreconditionImpl', VOID, PreconditionImpl, [PreconditionImpl, FactPrecondition_1]);
  initMetadataForInterface(FactReference_1, 'FactReference', VOID, VOID, [BTBNode]);
  initMetadataForClass(FactReferenceImpl, 'FactReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, FactReference_1]);
  initMetadataForInterface(HasKnowledgeSources, 'HasKnowledgeSources', VOID, VOID, [BTBNode]);
  initMetadataForInterface(HasVariables, 'HasVariables', VOID, VOID, [BTBNode]);
  initMetadataForInterface(FactSet_1, 'FactSet', VOID, VOID, [BTBNode, DirectlyNamed, HasKnowledgeSources, HasComments, HasVariables]);
  initMetadataForClass(FactSetImpl, 'FactSetImpl', VOID, BTBNodeImpl, [BTBNodeImpl, FactSet_1]);
  initMetadataForInterface(FieldDeclaration_1, 'FieldDeclaration', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(FieldDeclarationImpl, 'FieldDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, FieldDeclaration_1]);
  initMetadataForInterface(FindConnectionCommand_1, 'FindConnectionCommand', VOID, VOID, [Command_0]);
  initMetadataForClass(FindConnectionCommandImpl, 'FindConnectionCommandImpl', VOID, CommandImpl, [CommandImpl, FindConnectionCommand_1]);
  initMetadataForInterface(FunctionDeclaration_1, 'FunctionDeclaration', VOID, VOID, [AbstractBindingDeclaration]);
  initMetadataForClass(FunctionDeclarationImpl, 'FunctionDeclarationImpl', VOID, AbstractBindingDeclarationImpl, [AbstractBindingDeclarationImpl, FunctionDeclaration_1]);
  initMetadataForInterface(FunctionLibrary_1, 'FunctionLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(FunctionLibraryImpl, 'FunctionLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, FunctionLibrary_1]);
  initMetadataForInterface(FunctionTerm_1, 'FunctionTerm', VOID, VOID, [AbstractValue]);
  initMetadataForClass(FunctionTermImpl, 'FunctionTermImpl', VOID, BTBNodeImpl, [BTBNodeImpl, FunctionTerm_1]);
  function get_name_2() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ImportedLink$name$$inlined$suspendingQuery$1(this);
  }
  function get_specificator() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ImportedLink$specificator$$inlined$suspendingQuery$1(this);
  }
  function get_element() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ImportedLink$element$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(ImportedLink_1, 'ImportedLink', VOID, VOID, [AbstractLink]);
  initMetadataForClass(ImportedLinkImpl, 'ImportedLinkImpl', VOID, AbstractLinkImpl, [AbstractLinkImpl, ImportedLink_1]);
  function get_name_3() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ImportedProperty$name$$inlined$suspendingQuery$1(this);
  }
  function get_type_1() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ImportedProperty$type$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(ImportedProperty_1, 'ImportedProperty', VOID, VOID, [AbstractProperty]);
  initMetadataForClass(ImportedPropertyImpl, 'ImportedPropertyImpl', VOID, AbstractPropertyImpl, [AbstractPropertyImpl, ImportedProperty_1]);
  initMetadataForInterface(InstanceRelationDeclaration, 'InstanceRelationDeclaration', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(InstanceRelationDeclarationImpl, 'InstanceRelationDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, InstanceRelationDeclaration]);
  initMetadataForInterface(InstanceRelationValuePlaceholder, 'InstanceRelationValuePlaceholder', VOID, VOID, [BTBNode]);
  initMetadataForClass(InstanceRelationValuePlaceholderImpl, 'InstanceRelationValuePlaceholderImpl', VOID, BTBNodeImpl, [BTBNodeImpl, InstanceRelationValuePlaceholder]);
  initMetadataForInterface(InstanceRelationValue, 'InstanceRelationValue', VOID, VOID, [InstanceRelationValuePlaceholder]);
  initMetadataForClass(InstanceRelationValueImpl, 'InstanceRelationValueImpl', VOID, InstanceRelationValuePlaceholderImpl, [InstanceRelationValuePlaceholderImpl, InstanceRelationValue]);
  initMetadataForInterface(IsExpression_1, 'IsExpression', VOID, VOID, [FactExpression]);
  initMetadataForClass(IsExpressionImpl, 'IsExpressionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, IsExpression_1]);
  initMetadataForInterface(KindCustomCell_1, 'KindCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(KindCustomCellImpl, 'KindCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, KindCustomCell_1]);
  initMetadataForInterface(KnowledgeSourceReference, 'KnowledgeSourceReference', VOID, VOID, [BTBNode]);
  initMetadataForClass(KnowledgeSourceReferenceImpl, 'KnowledgeSourceReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, KnowledgeSourceReference]);
  initMetadataForInterface(KnowledgeSourceReferencePlaceholder_1, 'KnowledgeSourceReferencePlaceholder', VOID, VOID, [KnowledgeSourceReference]);
  initMetadataForClass(KnowledgeSourceReferencePlaceholderImpl, 'KnowledgeSourceReferencePlaceholderImpl', VOID, KnowledgeSourceReferenceImpl, [KnowledgeSourceReferenceImpl, KnowledgeSourceReferencePlaceholder_1]);
  initMetadataForInterface(LibraryItemPlaceholder_1, 'LibraryItemPlaceholder', VOID, VOID, [LibraryItem]);
  initMetadataForClass(LibraryItemPlaceholderImpl, 'LibraryItemPlaceholderImpl', VOID, BTBNodeImpl, [BTBNodeImpl, LibraryItemPlaceholder_1]);
  initMetadataForInterface(LibraryProcessSpecification_1, 'LibraryProcessSpecification', VOID, VOID, [AbstractProcessSpecification, BTBNode, FactExpression]);
  initMetadataForClass(LibraryProcessSpecificationImpl, 'LibraryProcessSpecificationImpl', VOID, AbstractProcessSpecificationImpl, [AbstractProcessSpecificationImpl, LibraryProcessSpecification_1]);
  initMetadataForInterface(LibraryProcessSpecificationQuery_1, 'LibraryProcessSpecificationQuery', VOID, VOID, [BTBNode]);
  initMetadataForClass(LibraryProcessSpecificationQueryImpl, 'LibraryProcessSpecificationQueryImpl', VOID, BTBNodeImpl, [BTBNodeImpl, LibraryProcessSpecificationQuery_1]);
  initMetadataForInterface(LinkCustomCell_1, 'LinkCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(LinkCustomCellImpl, 'LinkCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, LinkCustomCell_1]);
  initMetadataForInterface(LinkDeclaration_1, 'LinkDeclaration', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(LinkDeclarationImpl, 'LinkDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, LinkDeclaration_1]);
  initMetadataForInterface(LinkLibrary_1, 'LinkLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(LinkLibraryImpl, 'LinkLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, LinkLibrary_1]);
  initMetadataForInterface(ClassExpression, 'ClassExpression', VOID, VOID, [ClassExpressionPlaceholder_1]);
  function get_getClassDeclaration() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyElementReferenceProvider$getClassDeclaration$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(OntologyElementReferenceProvider, 'OntologyElementReferenceProvider', VOID, VOID, [ClassExpression]);
  initMetadataForInterface(LocalOntologyElementReference_1, 'LocalOntologyElementReference', VOID, VOID, [BTBNode, OntologyElementReferenceProvider]);
  initMetadataForClass(LocalOntologyElementReferenceImpl, 'LocalOntologyElementReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, LocalOntologyElementReference_1]);
  initMetadataForInterface(MeasurableNotion_1, 'MeasurableNotion', VOID, VOID, [AbstractNotion]);
  initMetadataForClass(MeasurableNotionImpl, 'MeasurableNotionImpl', VOID, AbstractNotionImpl, [AbstractNotionImpl, MeasurableNotion_1]);
  function amount(intAmount) {
    return this.ibk().t2c(Companion_getInstance_77().r52(intAmount));
  }
  initMetadataForInterface(MeasurableValue_1, 'MeasurableValue', VOID, VOID, [AbstractValue, FactExpression]);
  initMetadataForClass(MeasurableValueImpl, 'MeasurableValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, MeasurableValue_1]);
  initMetadataForInterface(MeasurementUnit_1, 'MeasurementUnit', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(MeasurementUnitImpl, 'MeasurementUnitImpl', VOID, BTBNodeImpl, [BTBNodeImpl, MeasurementUnit_1]);
  initMetadataForInterface(ModifierContainer, 'ModifierContainer', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(ModifierContainerImpl, 'ModifierContainerImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, ModifierContainer]);
  initMetadataForInterface(ModifierDeclaration, 'ModifierDeclaration', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ModifierDeclarationImpl, 'ModifierDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ModifierDeclaration]);
  initMetadataForInterface(ModifierFactExpression_0, 'ModifierFactExpression', VOID, VOID, [FactExpression]);
  initMetadataForClass(ModifierFactExpressionImpl, 'ModifierFactExpressionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ModifierFactExpression_0]);
  initMetadataForInterface(MultilineText, 'MultilineText', VOID, VOID, [BTBNode]);
  initMetadataForClass(MultilineTextImpl, 'MultilineTextImpl', VOID, BTBNodeImpl, [BTBNodeImpl, MultilineText]);
  initMetadataForInterface(MultipleProcessPropertyValueRange_1, 'MultipleProcessPropertyValueRange', VOID, VOID, [ProcessPropertyValueRange]);
  initMetadataForClass(MultipleProcessPropertyValueRangeImpl, 'MultipleProcessPropertyValueRangeImpl', VOID, BTBNodeImpl, [BTBNodeImpl, MultipleProcessPropertyValueRange_1]);
  initMetadataForInterface(PropertyValueRange, 'PropertyValueRange', VOID, VOID, [BTBNode]);
  initMetadataForClass(PropertyValueRangeImpl, 'PropertyValueRangeImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PropertyValueRange]);
  initMetadataForInterface(MultiplePropertyValueRange_1, 'MultiplePropertyValueRange', VOID, VOID, [PropertyValueRange]);
  initMetadataForClass(MultiplePropertyValueRangeImpl, 'MultiplePropertyValueRangeImpl', VOID, PropertyValueRangeImpl, [PropertyValueRangeImpl, MultiplePropertyValueRange_1]);
  initMetadataForInterface(NewFact, 'NewFact', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(NewFactImpl, 'NewFactImpl', VOID, BTBNodeImpl, [BTBNodeImpl, NewFact]);
  initMetadataForInterface(NewFactReference_0, 'NewFactReference', VOID, VOID, [FactExpression]);
  initMetadataForClass(NewFactReferenceImpl, 'NewFactReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, NewFactReference_0]);
  function get_types() {
    return constant(emptyList());
  }
  initMetadataForInterface(NoValues_1, 'NoValues', VOID, VOID, [PropertyValueRange]);
  initMetadataForClass(NoValuesImpl, 'NoValuesImpl', VOID, PropertyValueRangeImpl, [PropertyValueRangeImpl, NoValues_1]);
  initMetadataForInterface(NotionLibrary_1, 'NotionLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(NotionLibraryImpl, 'NotionLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, NotionLibrary_1]);
  initMetadataForInterface(NotionPlaceholder_1, 'NotionPlaceholder', VOID, VOID, [AbstractNotion]);
  initMetadataForClass(NotionPlaceholderImpl, 'NotionPlaceholderImpl', VOID, AbstractNotionImpl, [AbstractNotionImpl, NotionPlaceholder_1]);
  initMetadataForInterface(NotionType_0, 'NotionType', VOID, VOID, [Type]);
  initMetadataForClass(NotionTypeImpl, 'NotionTypeImpl', VOID, TypeImpl, [TypeImpl, NotionType_0]);
  initMetadataForInterface(ObjectPropertiesLibrary, 'ObjectPropertiesLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(ObjectPropertiesLibraryImpl, 'ObjectPropertiesLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, ObjectPropertiesLibrary]);
  initMetadataForInterface(ObjectPropertyDeclaration_1, 'ObjectPropertyDeclaration', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ObjectPropertyDeclarationImpl, 'ObjectPropertyDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ObjectPropertyDeclaration_1]);
  function removePropertyReference() {
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new ObjectPropertyReferenceValue$removePropertyReference$$inlined$executeQuery$1(this);
    return execute_0(tmp$ret$0);
  }
  initMetadataForInterface(ObjectPropertyReferenceValue_1, 'ObjectPropertyReferenceValue', VOID, VOID, [AbstractValue, FactExpression]);
  initMetadataForClass(ObjectPropertyReferenceValueImpl, 'ObjectPropertyReferenceValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ObjectPropertyReferenceValue_1]);
  function get_name_4() {
    return this.ebs();
  }
  function citation_0() {
    return get_forQueries(this.ebs().n4z());
  }
  initMetadataForInterface(OldPublishedSource, 'OldPublishedSource', VOID, VOID, [LibraryItem, PublishedWork]);
  initMetadataForClass(OldPublishedSourceImpl, 'OldPublishedSourceImpl', VOID, PublishedWorkImpl, [PublishedWorkImpl, OldPublishedSource]);
  initMetadataForInterface(OneOf_1, 'OneOf', VOID, VOID, [Type]);
  initMetadataForClass(OneOfImpl, 'OneOfImpl', VOID, TypeImpl, [TypeImpl, OneOf_1]);
  initMetadataForInterface(OntologyCardinalityRelation_1, 'OntologyCardinalityRelation', VOID, VOID, [AbstractOntologyRelation]);
  initMetadataForClass(OntologyCardinalityRelationImpl, 'OntologyCardinalityRelationImpl', VOID, AbstractOntologyRelationImpl, [AbstractOntologyRelationImpl, OntologyCardinalityRelation_1]);
  initMetadataForInterface(HasPropertyConstraints, 'HasPropertyConstraints', VOID, VOID, [BTBNode]);
  initMetadataForInterface(OntologyElementDefinition_1, 'OntologyElementDefinition', VOID, VOID, [BTBNode, HasPropertyConstraints]);
  initMetadataForClass(OntologyElementDefinitionImpl, 'OntologyElementDefinitionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyElementDefinition_1]);
  function isSubtypeOf(other) {
    return isSubtypeOf_1(ontologyElementHierarchy(), this, other);
  }
  initMetadataForInterface(ClassDeclaration, 'ClassDeclaration', VOID, VOID, [BTBNode]);
  function get_temporaryUnionClassDefinition() {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new OntologyElement$temporaryUnionClassDefinition$$inlined$query$1(this);
  }
  function allTaxonElements() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyElement$allTaxonElements$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(OntologyElement_1, 'OntologyElement', VOID, VOID, [BTBNode, DirectlyNamed, ClassDeclaration, HasPropertyConstraints]);
  initMetadataForClass(OntologyElementImpl, 'OntologyElementImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyElement_1]);
  initMetadataForInterface(OntologyElementPropertyType_1, 'OntologyElementPropertyType', VOID, VOID, [ProcessPropertyType]);
  initMetadataForClass(OntologyElementPropertyTypeImpl, 'OntologyElementPropertyTypeImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyElementPropertyType_1]);
  initMetadataForInterface(OntologyElementReference_1, 'OntologyElementReference', VOID, VOID, [BTBNode, OntologyElementReferenceProvider]);
  initMetadataForClass(OntologyElementReferenceImpl, 'OntologyElementReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyElementReference_1]);
  initMetadataForInterface(OntologyElementReferenceValue_1, 'OntologyElementReferenceValue', VOID, VOID, [AbstractValue, FactExpression]);
  initMetadataForClass(OntologyElementReferenceValueImpl, 'OntologyElementReferenceValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyElementReferenceValue_1]);
  initMetadataForInterface(OntologyElementReferenceValueLibrary_1, 'OntologyElementReferenceValueLibrary', VOID, VOID, [OntologyElementReferenceValue_1]);
  initMetadataForClass(OntologyElementReferenceValueLibraryImpl, 'OntologyElementReferenceValueLibraryImpl', VOID, OntologyElementReferenceValueImpl, [OntologyElementReferenceValueImpl, OntologyElementReferenceValueLibrary_1]);
  initMetadataForInterface(OntologyElementSynonym_1, 'OntologyElementSynonym', VOID, VOID, [BTBNode]);
  initMetadataForClass(OntologyElementSynonymImpl, 'OntologyElementSynonymImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyElementSynonym_1]);
  initMetadataForInterface(OntologyElementType_1, 'OntologyElementType', VOID, VOID, [Type]);
  initMetadataForClass(OntologyElementTypeImpl, 'OntologyElementTypeImpl', VOID, TypeImpl, [TypeImpl, OntologyElementType_1]);
  initMetadataForInterface(OntologyImport_1, 'OntologyImport', VOID, VOID, [BTBNode]);
  initMetadataForClass(OntologyImportImpl, 'OntologyImportImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyImport_1]);
  initMetadataForInterface(OntologyImportRoot_1, 'OntologyImportRoot', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(OntologyImportRootImpl, 'OntologyImportRootImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, OntologyImportRoot_1]);
  initMetadataForInterface(OntologyImportRootReference_1, 'OntologyImportRootReference', VOID, VOID, [BTBNode]);
  initMetadataForClass(OntologyImportRootReferenceImpl, 'OntologyImportRootReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyImportRootReference_1]);
  function getElementReference() {
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new OntologyIsRelation$getElementReference$$inlined$executeQuery$1(this);
    return execute_0(tmp$ret$0);
  }
  initMetadataForInterface(OntologyIsRelation_1, 'OntologyIsRelation', VOID, VOID, [AbstractOntologyRelation]);
  initMetadataForClass(OntologyIsRelationImpl, 'OntologyIsRelationImpl', VOID, AbstractOntologyRelationImpl, [AbstractOntologyRelationImpl, OntologyIsRelation_1]);
  initMetadataForInterface(OntologyLibrary_1, 'OntologyLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(OntologyLibraryImpl, 'OntologyLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, OntologyLibrary_1]);
  initMetadataForInterface(OntologyLibraryReference_1, 'OntologyLibraryReference', VOID, VOID, [BTBNode]);
  initMetadataForClass(OntologyLibraryReferenceImpl, 'OntologyLibraryReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, OntologyLibraryReference_1]);
  initMetadataForInterface(OntologyLinkDeclarationValueQuery_1, 'OntologyLinkDeclarationValueQuery', VOID, VOID, [DeclarationValueQuery]);
  initMetadataForClass(OntologyLinkDeclarationValueQueryImpl, 'OntologyLinkDeclarationValueQueryImpl', VOID, DeclarationValueQueryImpl, [DeclarationValueQueryImpl, OntologyLinkDeclarationValueQuery_1]);
  function get_name_5() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyLink$name$$inlined$suspendingQuery$1(this);
  }
  function get_element_0() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyLink$element$$inlined$suspendingQuery$1(this);
  }
  function get_specificator_0() {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new OntologyLink$specificator$$inlined$query$1(this);
  }
  initMetadataForInterface(OntologyLink_1, 'OntologyLink', VOID, VOID, [AbstractLink]);
  initMetadataForClass(OntologyLinkImpl, 'OntologyLinkImpl', VOID, AbstractLinkImpl, [AbstractLinkImpl, OntologyLink_1]);
  function importedLibraries() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyLinkValue$importedLibraries$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(OntologyLinkValue_1, 'OntologyLinkValue', VOID, VOID, [AbstractBindingValue]);
  initMetadataForClass(OntologyLinkValueImpl, 'OntologyLinkValueImpl', VOID, AbstractBindingValueImpl, [AbstractBindingValueImpl, OntologyLinkValue_1]);
  initMetadataForInterface(OrValueQuery_1, 'OrValueQuery', VOID, VOID, [AbstractBindingValueQuery]);
  initMetadataForClass(OrValueQueryImpl, 'OrValueQueryImpl', VOID, AbstractBindingValueQueryImpl, [AbstractBindingValueQueryImpl, OrValueQuery_1]);
  initMetadataForInterface(PageSpecification, 'PageSpecification', VOID, VOID, [BTBNode]);
  initMetadataForClass(PageSpecificationImpl, 'PageSpecificationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PageSpecification]);
  initMetadataForInterface(Page_1, 'Page', VOID, VOID, [PageSpecification]);
  initMetadataForClass(PageImpl, 'PageImpl', VOID, PageSpecificationImpl, [PageSpecificationImpl, Page_1]);
  initMetadataForInterface(PageRange_1, 'PageRange', VOID, VOID, [PageSpecification]);
  initMetadataForClass(PageRangeImpl, 'PageRangeImpl', VOID, PageSpecificationImpl, [PageSpecificationImpl, PageRange_1]);
  initMetadataForInterface(Paper_1, 'Paper', VOID, VOID, [PublishedWork, LibraryItem]);
  initMetadataForClass(PaperImpl, 'PaperImpl', VOID, PublishedWorkImpl, [PublishedWorkImpl, Paper_1]);
  function transformToVariableReference() {
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new PartValue$transformToVariableReference$$inlined$executeQuery$1(this);
    return execute_0(tmp$ret$0);
  }
  initMetadataForInterface(PartValue, 'PartValue', VOID, VOID, [AbstractValue]);
  initMetadataForClass(PartValueImpl, 'PartValueImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PartValue]);
  function aliasedProperties() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ProcessDeclaration$aliasedProperties$$inlined$suspendingQuery$1(this);
  }
  function allEntries() {
    return allEntries_0(this, mutableListOf([this]));
  }
  function allProperties() {
    return allProperties_0(this, emptySet(), setOf(this));
  }
  function allSuperProperties() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ProcessDeclaration$allSuperProperties$$inlined$suspendingQuery$1(this);
  }
  function cycleInExtends() {
    return cycleInExtends_0(this, this, mutableListOf([this]));
  }
  initMetadataForInterface(ProcessDeclaration_1, 'ProcessDeclaration', VOID, VOID, [AbstractBindingDeclaration, HasVariables]);
  initMetadataForClass(ProcessDeclarationImpl, 'ProcessDeclarationImpl', VOID, AbstractBindingDeclarationImpl, [AbstractBindingDeclarationImpl, ProcessDeclaration_1]);
  initMetadataForInterface(HasQueryLabels, 'HasQueryLabels', VOID, VOID, [BTBNode]);
  initMetadataForInterface(HasFactExpression, 'HasFactExpression', VOID, VOID, [BTBNode]);
  initMetadataForInterface(ProcessEffect_0, 'ProcessEffect', VOID, VOID, [HasQueryLabels, HasFactExpression]);
  initMetadataForClass(ProcessEffectImpl, 'ProcessEffectImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessEffect_0]);
  initMetadataForInterface(ProcessKindContainer_1, 'ProcessKindContainer', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(ProcessKindContainerImpl, 'ProcessKindContainerImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, ProcessKindContainer_1]);
  initMetadataForInterface(ProcessKind_1, 'ProcessKind', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ProcessKindImpl, 'ProcessKindImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessKind_1]);
  initMetadataForInterface(ProcessLibrary_1, 'ProcessLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(ProcessLibraryImpl, 'ProcessLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, ProcessLibrary_1]);
  initMetadataForInterface(ProcessPrerequisite_0, 'ProcessPrerequisite', VOID, VOID, [HasQueryLabels, HasFactExpression]);
  initMetadataForClass(ProcessPrerequisiteImpl, 'ProcessPrerequisiteImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessPrerequisite_0]);
  initMetadataForInterface(ProcessPropertyCustomCell_1, 'ProcessPropertyCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(ProcessPropertyCustomCellImpl, 'ProcessPropertyCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, ProcessPropertyCustomCell_1]);
  initMetadataForInterface(ProcessPropertyDefault_1, 'ProcessPropertyDefault', VOID, VOID, [BTBNode]);
  initMetadataForClass(ProcessPropertyDefaultImpl, 'ProcessPropertyDefaultImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessPropertyDefault_1]);
  initMetadataForInterface(ProcessProperty_1, 'ProcessProperty', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ProcessPropertyImpl, 'ProcessPropertyImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessProperty_1]);
  initMetadataForInterface(VariableInitializer, 'VariableInitializer', VOID, VOID, [VariableSpecification]);
  initMetadataForClass(VariableInitializerImpl, 'VariableInitializerImpl', VOID, VariableSpecificationImpl, [VariableSpecificationImpl, VariableInitializer]);
  initMetadataForInterface(ProcessPropertyReference, 'ProcessPropertyReference', VOID, VOID, [FactExpression, AbstractValue, VariableInitializer]);
  initMetadataForClass(ProcessPropertyReferenceImpl, 'ProcessPropertyReferenceImpl', VOID, VariableInitializerImpl, [VariableInitializerImpl, ProcessPropertyReference]);
  initMetadataForInterface(ProcessPropertyValue_1, 'ProcessPropertyValue', VOID, VOID, [BindingValuePlaceholder_1, HasQueryLabels]);
  initMetadataForClass(ProcessPropertyValueImpl, 'ProcessPropertyValueImpl', VOID, BindingValuePlaceholderImpl, [BindingValuePlaceholderImpl, ProcessPropertyValue_1]);
  initMetadataForInterface(ProcessReference_1, 'ProcessReference', VOID, VOID, [BTBNode]);
  initMetadataForClass(ProcessReferenceImpl, 'ProcessReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessReference_1]);
  function isValid() {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new ProcessRelationDeclaration$isValid$$inlined$query$1(this);
  }
  initMetadataForInterface(ProcessRelationDeclaration_1, 'ProcessRelationDeclaration', VOID, VOID, [BTBNode, DirectlyNamed]);
  initMetadataForClass(ProcessRelationDeclarationImpl, 'ProcessRelationDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ProcessRelationDeclaration_1]);
  initMetadataForInterface(ProcessType_1, 'ProcessType', VOID, VOID, [Type]);
  initMetadataForClass(ProcessTypeImpl, 'ProcessTypeImpl', VOID, TypeImpl, [TypeImpl, ProcessType_1]);
  initMetadataForInterface(PropertiesCustomCell_1, 'PropertiesCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(PropertiesCustomCellImpl, 'PropertiesCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, PropertiesCustomCell_1]);
  initMetadataForInterface(PropertyConstraint_1, 'PropertyConstraint', VOID, VOID, [BTBNode, HasPropertyConstraints]);
  initMetadataForClass(PropertyConstraintImpl, 'PropertyConstraintImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PropertyConstraint_1]);
  initMetadataForInterface(PropertyCustomCell_1, 'PropertyCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(PropertyCustomCellImpl, 'PropertyCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, PropertyCustomCell_1]);
  initMetadataForInterface(PropertyDeclaration_1, 'PropertyDeclaration', VOID, VOID, [BTBNode, DirectlyNamed, PropertyLibraryElement]);
  initMetadataForClass(PropertyDeclarationImpl, 'PropertyDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PropertyDeclaration_1]);
  initMetadataForInterface(PropertyDeclarationValueQuery_1, 'PropertyDeclarationValueQuery', VOID, VOID, [DeclarationValueQuery]);
  initMetadataForClass(PropertyDeclarationValueQueryImpl, 'PropertyDeclarationValueQueryImpl', VOID, DeclarationValueQueryImpl, [DeclarationValueQueryImpl, PropertyDeclarationValueQuery_1]);
  function get_properties() {
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_0 = this.sc0();
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new PropertyLibrary$properties$$inlined$map$1(this_0);
  }
  initMetadataForInterface(PropertyLibrary_1, 'PropertyLibrary', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(PropertyLibraryImpl, 'PropertyLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, PropertyLibrary_1]);
  initMetadataForInterface(PropertyReferenceOperation_1, 'PropertyReferenceOperation', VOID, VOID, [BTBNode]);
  initMetadataForClass(PropertyReferenceOperationImpl, 'PropertyReferenceOperationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, PropertyReferenceOperation_1]);
  initMetadataForInterface(PropertyValue_1, 'PropertyValue', VOID, VOID, [AbstractBindingValue]);
  initMetadataForClass(PropertyValueImpl, 'PropertyValueImpl', VOID, AbstractBindingValueImpl, [AbstractBindingValueImpl, PropertyValue_1]);
  initMetadataForInterface(PubMedSourceReference_1, 'PubMedSourceReference', VOID, VOID, [KnowledgeSourceReference]);
  initMetadataForClass(PubMedSourceReferenceImpl, 'PubMedSourceReferenceImpl', VOID, KnowledgeSourceReferenceImpl, [KnowledgeSourceReferenceImpl, PubMedSourceReference_1]);
  initMetadataForInterface(PublishedSourceReference_1, 'PublishedSourceReference', VOID, VOID, [KnowledgeSourceReference]);
  initMetadataForClass(PublishedSourceReferenceImpl, 'PublishedSourceReferenceImpl', VOID, KnowledgeSourceReferenceImpl, [KnowledgeSourceReferenceImpl, PublishedSourceReference_1]);
  initMetadataForInterface(PublishedSourcesLibrary_1, 'PublishedSourcesLibrary', VOID, VOID, [BTBNode, DocumentNode_0]);
  initMetadataForClass(PublishedSourcesLibraryImpl, 'PublishedSourcesLibraryImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, PublishedSourcesLibrary_1]);
  function get_element_1() {
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new QualifiedOntologyElementReference$element$$inlined$executeQuery$1(this);
    return execute_0(tmp$ret$0);
  }
  initMetadataForInterface(QualifiedOntologyElementReference_1, 'QualifiedOntologyElementReference', VOID, VOID, [OntologyElementReferenceProvider]);
  initMetadataForClass(QualifiedOntologyElementReferenceImpl, 'QualifiedOntologyElementReferenceImpl', VOID, BTBNodeImpl, [BTBNodeImpl, QualifiedOntologyElementReference_1]);
  initMetadataForInterface(QueryCommands_1, 'QueryCommands', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(QueryCommandsImpl, 'QueryCommandsImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, QueryCommands_1]);
  initMetadataForInterface(QueryLabelsFactExpressionContainer_1, 'QueryLabelsFactExpressionContainer', VOID, VOID, [HasQueryLabels, HasFactExpression]);
  initMetadataForClass(QueryLabelsFactExpressionContainerImpl, 'QueryLabelsFactExpressionContainerImpl', VOID, BTBNodeImpl, [BTBNodeImpl, QueryLabelsFactExpressionContainer_1]);
  initMetadataForInterface(QueryParametersBlackList, 'QueryParametersBlackList', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(QueryParametersBlackListImpl, 'QueryParametersBlackListImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, QueryParametersBlackList]);
  initMetadataForInterface(RelationContainer_1, 'RelationContainer', VOID, VOID, [DocumentNode_0]);
  initMetadataForClass(RelationContainerImpl, 'RelationContainerImpl', VOID, DocumentNodeImpl, [DocumentNodeImpl, RelationContainer_1]);
  initMetadataForInterface(RelationFactExpression_1, 'RelationFactExpression', VOID, VOID, [FactExpression]);
  initMetadataForClass(RelationFactExpressionImpl, 'RelationFactExpressionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, RelationFactExpression_1]);
  initMetadataForInterface(ReturnTypeCustomCell_1, 'ReturnTypeCustomCell', VOID, VOID, [CustomCell]);
  initMetadataForClass(ReturnTypeCustomCellImpl, 'ReturnTypeCustomCellImpl', VOID, CustomCellImpl, [CustomCellImpl, ReturnTypeCustomCell_1]);
  initMetadataForInterface(SetExpression_1, 'SetExpression', VOID, VOID, [AbstractValue, FactExpression]);
  initMetadataForClass(SetExpressionImpl, 'SetExpressionImpl', VOID, BTBNodeImpl, [BTBNodeImpl, SetExpression_1]);
  initMetadataForInterface(SetValuedPropertyParameter_1, 'SetValuedPropertyParameter', VOID, VOID, [BTBNode]);
  initMetadataForClass(SetValuedPropertyParameterImpl, 'SetValuedPropertyParameterImpl', VOID, BTBNodeImpl, [BTBNodeImpl, SetValuedPropertyParameter_1]);
  initMetadataForInterface(SimplePropertyType, 'SimplePropertyType', VOID, VOID, [ProcessPropertyType]);
  initMetadataForClass(SimplePropertyTypeImpl, 'SimplePropertyTypeImpl', VOID, BTBNodeImpl, [BTBNodeImpl, SimplePropertyType]);
  initMetadataForInterface(SinglePropertyValueRange_1, 'SinglePropertyValueRange', VOID, VOID, [PropertyValueRange]);
  initMetadataForClass(SinglePropertyValueRangeImpl, 'SinglePropertyValueRangeImpl', VOID, PropertyValueRangeImpl, [PropertyValueRangeImpl, SinglePropertyValueRange_1]);
  initMetadataForInterface(TextLine, 'TextLine', VOID, VOID, [BTBNode]);
  initMetadataForClass(TextLineImpl, 'TextLineImpl', VOID, BTBNodeImpl, [BTBNodeImpl, TextLine]);
  initMetadataForInterface(TypePlaceholder_1, 'TypePlaceholder', VOID, VOID, [Type]);
  initMetadataForClass(TypePlaceholderImpl, 'TypePlaceholderImpl', VOID, TypeImpl, [TypeImpl, TypePlaceholder_1]);
  initMetadataForClass(TypedBTBNodeImpl, 'TypedBTBNodeImpl', VOID, BaseTypedOtNode, [BaseTypedOtNode, BTBNode]);
  initMetadataForClass(TypedAbstractBindingDeclarationImpl, 'TypedAbstractBindingDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, AbstractBindingDeclaration]);
  initMetadataForClass(TypedAbstractBindingEntryImpl, 'TypedAbstractBindingEntryImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, AbstractBindingEntry]);
  initMetadataForClass(TypedBindingValuePlaceholderImpl, 'TypedBindingValuePlaceholderImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, BindingValuePlaceholder_1]);
  initMetadataForClass(TypedAbstractBindingValueImpl, 'TypedAbstractBindingValueImpl', VOID, TypedBindingValuePlaceholderImpl, [TypedBindingValuePlaceholderImpl, AbstractBindingValue]);
  initMetadataForClass(TypedBindingValuePlaceholderQueryImpl, 'TypedBindingValuePlaceholderQueryImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, BindingValuePlaceholderQuery_1]);
  initMetadataForClass(TypedAbstractBindingValueQueryImpl, 'TypedAbstractBindingValueQueryImpl', VOID, TypedBindingValuePlaceholderQueryImpl, [TypedBindingValuePlaceholderQueryImpl, AbstractBindingValueQuery]);
  initMetadataForClass(TypedAbstractLinkImpl, 'TypedAbstractLinkImpl', VOID, TypedAbstractBindingEntryImpl, [TypedAbstractBindingEntryImpl, AbstractLink]);
  initMetadataForClass(TypedAbstractNotionImpl, 'TypedAbstractNotionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, AbstractNotion]);
  initMetadataForClass(TypedAbstractOntologyRelationImpl, 'TypedAbstractOntologyRelationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, AbstractOntologyRelation]);
  initMetadataForClass(TypedAbstractProcessSpecificationImpl, 'TypedAbstractProcessSpecificationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, AbstractProcessSpecification]);
  initMetadataForClass(TypedAbstractPropertyImpl, 'TypedAbstractPropertyImpl', VOID, TypedAbstractBindingEntryImpl, [TypedAbstractBindingEntryImpl, AbstractProperty]);
  initMetadataForClass(TypedAuthorImpl, 'TypedAuthorImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Author_1]);
  initMetadataForClass(TypedAuthoredWorkImpl, 'TypedAuthoredWorkImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, AuthoredWork]);
  initMetadataForClass(TypedDocumentNodeImpl, 'TypedDocumentNodeImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, DocumentNode_0]);
  initMetadataForClass(TypedBTBDocumentImpl, 'TypedBTBDocumentImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, BTBDocument_1]);
  initMetadataForClass(TypedBindingPropertyImpl, 'TypedBindingPropertyImpl', VOID, TypedAbstractPropertyImpl, [TypedAbstractPropertyImpl, BindingProperty_1]);
  initMetadataForClass(TypedBindingValueMaskImpl, 'TypedBindingValueMaskImpl', VOID, TypedAbstractBindingValueQueryImpl, [TypedAbstractBindingValueQueryImpl, BindingValueMask_1]);
  initMetadataForClass(TypedPublishedWorkImpl, 'TypedPublishedWorkImpl', VOID, TypedAuthoredWorkImpl, [TypedAuthoredWorkImpl, PublishedWork]);
  initMetadataForClass(TypedBookImpl, 'TypedBookImpl', VOID, TypedPublishedWorkImpl, [TypedPublishedWorkImpl, Book_1]);
  initMetadataForClass(TypedCardinalityBoundImpl, 'TypedCardinalityBoundImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, CardinalityBound]);
  initMetadataForClass(TypedCardinalityBoundConstantImpl, 'TypedCardinalityBoundConstantImpl', VOID, TypedCardinalityBoundImpl, [TypedCardinalityBoundImpl, CardinalityBoundConstant_1]);
  initMetadataForClass(TypedCardinalityBoundNImpl, 'TypedCardinalityBoundNImpl', VOID, TypedCardinalityBoundImpl, [TypedCardinalityBoundImpl, CardinalityBoundN_1]);
  initMetadataForClass(TypedCardinalityBoundPlaceholderImpl, 'TypedCardinalityBoundPlaceholderImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, CardinalityBoundPlaceholder_1]);
  initMetadataForClass(TypedCustomCellImpl, 'TypedCustomCellImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, CustomCell]);
  initMetadataForClass(TypedCardinalityCustomCellImpl, 'TypedCardinalityCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, CardinalityCustomCell_1]);
  initMetadataForClass(TypedCardinalityImpl, 'TypedCardinalityImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Cardinality_1]);
  initMetadataForClass(TypedCategoryImpl, 'TypedCategoryImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Category_1]);
  initMetadataForClass(TypedClassExpressionPlaceholderImpl, 'TypedClassExpressionPlaceholderImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ClassExpressionPlaceholder_1]);
  initMetadataForClass(TypedVariableSpecificationImpl, 'TypedVariableSpecificationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, VariableSpecification]);
  initMetadataForClass(TypedTypeImpl, 'TypedTypeImpl', VOID, TypedVariableSpecificationImpl, [TypedVariableSpecificationImpl, Type]);
  initMetadataForClass(TypedClassExpressionTypeImpl, 'TypedClassExpressionTypeImpl', VOID, TypedTypeImpl, [TypedTypeImpl, ClassExpressionType_1]);
  initMetadataForClass(TypedCommandImpl, 'TypedCommandImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Command_0]);
  initMetadataForClass(TypedConstantCustomCellImpl, 'TypedConstantCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, ConstantCustomCell_1]);
  initMetadataForClass(TypedPreconditionImpl, 'TypedPreconditionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Precondition]);
  initMetadataForClass(TypedConstantPreconditionImpl, 'TypedConstantPreconditionImpl', VOID, TypedPreconditionImpl, [TypedPreconditionImpl, ConstantPrecondition_0]);
  initMetadataForClass(TypedContextImpl, 'TypedContextImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Context_1]);
  initMetadataForClass(TypedContextQueryImpl, 'TypedContextQueryImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ContextQuery_1]);
  initMetadataForClass(TypedCustomEditorImpl, 'TypedCustomEditorImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, CustomEditor]);
  initMetadataForClass(TypedDeclarationNameCustomCellImpl, 'TypedDeclarationNameCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, DeclarationNameCustomCell_1]);
  initMetadataForClass(TypedDeclarationValueQueryImpl, 'TypedDeclarationValueQueryImpl', VOID, TypedAbstractBindingValueQueryImpl, [TypedAbstractBindingValueQueryImpl, DeclarationValueQuery]);
  initMetadataForClass(TypedEmptyBindingEntryImpl, 'TypedEmptyBindingEntryImpl', VOID, TypedAbstractBindingEntryImpl, [TypedAbstractBindingEntryImpl, EmptyBindingEntry_1]);
  initMetadataForClass(TypedEmptyPropertyLibraryElementImpl, 'TypedEmptyPropertyLibraryElementImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, EmptyPropertyLibraryElement_1]);
  initMetadataForClass(TypedEnumValueImpl, 'TypedEnumValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, EnumValue_1]);
  initMetadataForClass(TypedEnumerableNotionImpl, 'TypedEnumerableNotionImpl', VOID, TypedAbstractNotionImpl, [TypedAbstractNotionImpl, EnumerableNotion_1]);
  initMetadataForClass(TypedEnumerationConstantImpl, 'TypedEnumerationConstantImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, EnumerationConstant_1]);
  initMetadataForClass(TypedExtensionDeclarationImpl, 'TypedExtensionDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ExtensionDeclaration_1]);
  initMetadataForClass(TypedPartReferenceOperationImpl, 'TypedPartReferenceOperationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PartReferenceOperation]);
  initMetadataForClass(TypedExtensionFieldReferenceImpl, 'TypedExtensionFieldReferenceImpl', VOID, TypedPartReferenceOperationImpl, [TypedPartReferenceOperationImpl, ExtensionFieldReference_1]);
  initMetadataForClass(TypedExtensionLibraryImpl, 'TypedExtensionLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, ExtensionLibrary_1]);
  initMetadataForClass(TypedFactExpressionPlaceholderImpl, 'TypedFactExpressionPlaceholderImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, FactExpressionPlaceholder]);
  initMetadataForClass(TypedFactImpl, 'TypedFactImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, Fact_1]);
  initMetadataForClass(TypedFactPreconditionImpl, 'TypedFactPreconditionImpl', VOID, TypedPreconditionImpl, [TypedPreconditionImpl, FactPrecondition_1]);
  initMetadataForClass(TypedFactReferenceImpl, 'TypedFactReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, FactReference_1]);
  initMetadataForClass(TypedFactSetImpl, 'TypedFactSetImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, FactSet_1]);
  initMetadataForClass(TypedFieldDeclarationImpl, 'TypedFieldDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, FieldDeclaration_1]);
  initMetadataForClass(TypedFindConnectionCommandImpl, 'TypedFindConnectionCommandImpl', VOID, TypedCommandImpl, [TypedCommandImpl, FindConnectionCommand_1]);
  initMetadataForClass(TypedFunctionDeclarationImpl, 'TypedFunctionDeclarationImpl', VOID, TypedAbstractBindingDeclarationImpl, [TypedAbstractBindingDeclarationImpl, FunctionDeclaration_1]);
  initMetadataForClass(TypedFunctionLibraryImpl, 'TypedFunctionLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, FunctionLibrary_1]);
  initMetadataForClass(TypedFunctionTermImpl, 'TypedFunctionTermImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, FunctionTerm_1]);
  initMetadataForClass(TypedImportedLinkImpl, 'TypedImportedLinkImpl', VOID, TypedAbstractLinkImpl, [TypedAbstractLinkImpl, ImportedLink_1]);
  initMetadataForClass(TypedImportedPropertyImpl, 'TypedImportedPropertyImpl', VOID, TypedAbstractPropertyImpl, [TypedAbstractPropertyImpl, ImportedProperty_1]);
  initMetadataForClass(TypedInstanceRelationDeclarationImpl, 'TypedInstanceRelationDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, InstanceRelationDeclaration]);
  initMetadataForClass(TypedInstanceRelationValuePlaceholderImpl, 'TypedInstanceRelationValuePlaceholderImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, InstanceRelationValuePlaceholder]);
  initMetadataForClass(TypedInstanceRelationValueImpl, 'TypedInstanceRelationValueImpl', VOID, TypedInstanceRelationValuePlaceholderImpl, [TypedInstanceRelationValuePlaceholderImpl, InstanceRelationValue]);
  initMetadataForClass(TypedIsExpressionImpl, 'TypedIsExpressionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, IsExpression_1]);
  initMetadataForClass(TypedKindCustomCellImpl, 'TypedKindCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, KindCustomCell_1]);
  initMetadataForClass(TypedKnowledgeSourceReferenceImpl, 'TypedKnowledgeSourceReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, KnowledgeSourceReference]);
  initMetadataForClass(TypedKnowledgeSourceReferencePlaceholderImpl, 'TypedKnowledgeSourceReferencePlaceholderImpl', VOID, TypedKnowledgeSourceReferenceImpl, [TypedKnowledgeSourceReferenceImpl, KnowledgeSourceReferencePlaceholder_1]);
  initMetadataForClass(TypedLibraryItemPlaceholderImpl, 'TypedLibraryItemPlaceholderImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, LibraryItemPlaceholder_1]);
  initMetadataForClass(TypedLibraryProcessSpecificationImpl, 'TypedLibraryProcessSpecificationImpl', VOID, TypedAbstractProcessSpecificationImpl, [TypedAbstractProcessSpecificationImpl, LibraryProcessSpecification_1]);
  initMetadataForClass(TypedLibraryProcessSpecificationQueryImpl, 'TypedLibraryProcessSpecificationQueryImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, LibraryProcessSpecificationQuery_1]);
  initMetadataForClass(TypedLinkCustomCellImpl, 'TypedLinkCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, LinkCustomCell_1]);
  initMetadataForClass(TypedLinkDeclarationImpl, 'TypedLinkDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, LinkDeclaration_1]);
  initMetadataForClass(TypedLinkLibraryImpl, 'TypedLinkLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, LinkLibrary_1]);
  initMetadataForClass(TypedLocalOntologyElementReferenceImpl, 'TypedLocalOntologyElementReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, LocalOntologyElementReference_1]);
  initMetadataForClass(TypedMeasurableNotionImpl, 'TypedMeasurableNotionImpl', VOID, TypedAbstractNotionImpl, [TypedAbstractNotionImpl, MeasurableNotion_1]);
  initMetadataForClass(TypedMeasurableValueImpl, 'TypedMeasurableValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, MeasurableValue_1]);
  initMetadataForClass(TypedMeasurementUnitImpl, 'TypedMeasurementUnitImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, MeasurementUnit_1]);
  initMetadataForClass(TypedModifierContainerImpl, 'TypedModifierContainerImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, ModifierContainer]);
  initMetadataForClass(TypedModifierDeclarationImpl, 'TypedModifierDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ModifierDeclaration]);
  initMetadataForClass(TypedModifierFactExpressionImpl, 'TypedModifierFactExpressionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ModifierFactExpression_0]);
  initMetadataForClass(TypedMultilineTextImpl, 'TypedMultilineTextImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, MultilineText]);
  initMetadataForClass(TypedMultipleProcessPropertyValueRangeImpl, 'TypedMultipleProcessPropertyValueRangeImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, MultipleProcessPropertyValueRange_1]);
  initMetadataForClass(TypedPropertyValueRangeImpl, 'TypedPropertyValueRangeImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PropertyValueRange]);
  initMetadataForClass(TypedMultiplePropertyValueRangeImpl, 'TypedMultiplePropertyValueRangeImpl', VOID, TypedPropertyValueRangeImpl, [TypedPropertyValueRangeImpl, MultiplePropertyValueRange_1]);
  initMetadataForClass(TypedNewFactImpl, 'TypedNewFactImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, NewFact]);
  initMetadataForClass(TypedNewFactReferenceImpl, 'TypedNewFactReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, NewFactReference_0]);
  initMetadataForClass(TypedNoValuesImpl, 'TypedNoValuesImpl', VOID, TypedPropertyValueRangeImpl, [TypedPropertyValueRangeImpl, NoValues_1]);
  initMetadataForClass(TypedNotionLibraryImpl, 'TypedNotionLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, NotionLibrary_1]);
  initMetadataForClass(TypedNotionPlaceholderImpl, 'TypedNotionPlaceholderImpl', VOID, TypedAbstractNotionImpl, [TypedAbstractNotionImpl, NotionPlaceholder_1]);
  initMetadataForClass(TypedNotionTypeImpl, 'TypedNotionTypeImpl', VOID, TypedTypeImpl, [TypedTypeImpl, NotionType_0]);
  initMetadataForClass(TypedObjectPropertiesLibraryImpl, 'TypedObjectPropertiesLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, ObjectPropertiesLibrary]);
  initMetadataForClass(TypedObjectPropertyDeclarationImpl, 'TypedObjectPropertyDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ObjectPropertyDeclaration_1]);
  initMetadataForClass(TypedObjectPropertyReferenceValueImpl, 'TypedObjectPropertyReferenceValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ObjectPropertyReferenceValue_1]);
  initMetadataForClass(TypedOldPublishedSourceImpl, 'TypedOldPublishedSourceImpl', VOID, TypedPublishedWorkImpl, [TypedPublishedWorkImpl, OldPublishedSource]);
  initMetadataForClass(TypedOneOfImpl, 'TypedOneOfImpl', VOID, TypedTypeImpl, [TypedTypeImpl, OneOf_1]);
  initMetadataForClass(TypedOntologyCardinalityRelationImpl, 'TypedOntologyCardinalityRelationImpl', VOID, TypedAbstractOntologyRelationImpl, [TypedAbstractOntologyRelationImpl, OntologyCardinalityRelation_1]);
  initMetadataForClass(TypedOntologyElementDefinitionImpl, 'TypedOntologyElementDefinitionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyElementDefinition_1]);
  initMetadataForClass(TypedOntologyElementImpl, 'TypedOntologyElementImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyElement_1]);
  initMetadataForClass(TypedOntologyElementPropertyTypeImpl, 'TypedOntologyElementPropertyTypeImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyElementPropertyType_1]);
  initMetadataForClass(TypedOntologyElementReferenceImpl, 'TypedOntologyElementReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyElementReference_1]);
  initMetadataForClass(TypedOntologyElementReferenceValueImpl, 'TypedOntologyElementReferenceValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyElementReferenceValue_1]);
  initMetadataForClass(TypedOntologyElementReferenceValueLibraryImpl, 'TypedOntologyElementReferenceValueLibraryImpl', VOID, TypedOntologyElementReferenceValueImpl, [TypedOntologyElementReferenceValueImpl, OntologyElementReferenceValueLibrary_1]);
  initMetadataForClass(TypedOntologyElementSynonymImpl, 'TypedOntologyElementSynonymImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyElementSynonym_1]);
  initMetadataForClass(TypedOntologyElementTypeImpl, 'TypedOntologyElementTypeImpl', VOID, TypedTypeImpl, [TypedTypeImpl, OntologyElementType_1]);
  initMetadataForClass(TypedOntologyImportImpl, 'TypedOntologyImportImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyImport_1]);
  initMetadataForClass(TypedOntologyImportRootImpl, 'TypedOntologyImportRootImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, OntologyImportRoot_1]);
  initMetadataForClass(TypedOntologyImportRootReferenceImpl, 'TypedOntologyImportRootReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyImportRootReference_1]);
  initMetadataForClass(TypedOntologyIsRelationImpl, 'TypedOntologyIsRelationImpl', VOID, TypedAbstractOntologyRelationImpl, [TypedAbstractOntologyRelationImpl, OntologyIsRelation_1]);
  initMetadataForClass(TypedOntologyLibraryImpl, 'TypedOntologyLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, OntologyLibrary_1]);
  initMetadataForClass(TypedOntologyLibraryReferenceImpl, 'TypedOntologyLibraryReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, OntologyLibraryReference_1]);
  initMetadataForClass(TypedOntologyLinkDeclarationValueQueryImpl, 'TypedOntologyLinkDeclarationValueQueryImpl', VOID, TypedDeclarationValueQueryImpl, [TypedDeclarationValueQueryImpl, OntologyLinkDeclarationValueQuery_1]);
  initMetadataForClass(TypedOntologyLinkImpl, 'TypedOntologyLinkImpl', VOID, TypedAbstractLinkImpl, [TypedAbstractLinkImpl, OntologyLink_1]);
  initMetadataForClass(TypedOntologyLinkValueImpl, 'TypedOntologyLinkValueImpl', VOID, TypedAbstractBindingValueImpl, [TypedAbstractBindingValueImpl, OntologyLinkValue_1]);
  initMetadataForClass(TypedOrValueQueryImpl, 'TypedOrValueQueryImpl', VOID, TypedAbstractBindingValueQueryImpl, [TypedAbstractBindingValueQueryImpl, OrValueQuery_1]);
  initMetadataForClass(TypedPageSpecificationImpl, 'TypedPageSpecificationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PageSpecification]);
  initMetadataForClass(TypedPageImpl, 'TypedPageImpl', VOID, TypedPageSpecificationImpl, [TypedPageSpecificationImpl, Page_1]);
  initMetadataForClass(TypedPageRangeImpl, 'TypedPageRangeImpl', VOID, TypedPageSpecificationImpl, [TypedPageSpecificationImpl, PageRange_1]);
  initMetadataForClass(TypedPaperImpl, 'TypedPaperImpl', VOID, TypedPublishedWorkImpl, [TypedPublishedWorkImpl, Paper_1]);
  initMetadataForClass(TypedPartValueImpl, 'TypedPartValueImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PartValue]);
  initMetadataForClass(TypedProcessDeclarationImpl, 'TypedProcessDeclarationImpl', VOID, TypedAbstractBindingDeclarationImpl, [TypedAbstractBindingDeclarationImpl, ProcessDeclaration_1]);
  initMetadataForClass(TypedProcessEffectImpl, 'TypedProcessEffectImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessEffect_0]);
  initMetadataForClass(TypedProcessKindContainerImpl, 'TypedProcessKindContainerImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, ProcessKindContainer_1]);
  initMetadataForClass(TypedProcessKindImpl, 'TypedProcessKindImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessKind_1]);
  initMetadataForClass(TypedProcessLibraryImpl, 'TypedProcessLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, ProcessLibrary_1]);
  initMetadataForClass(TypedProcessPrerequisiteImpl, 'TypedProcessPrerequisiteImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessPrerequisite_0]);
  initMetadataForClass(TypedProcessPropertyCustomCellImpl, 'TypedProcessPropertyCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, ProcessPropertyCustomCell_1]);
  initMetadataForClass(TypedProcessPropertyDefaultImpl, 'TypedProcessPropertyDefaultImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessPropertyDefault_1]);
  initMetadataForClass(TypedProcessPropertyImpl, 'TypedProcessPropertyImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessProperty_1]);
  initMetadataForClass(TypedVariableInitializerImpl, 'TypedVariableInitializerImpl', VOID, TypedVariableSpecificationImpl, [TypedVariableSpecificationImpl, VariableInitializer]);
  initMetadataForClass(TypedProcessPropertyReferenceImpl, 'TypedProcessPropertyReferenceImpl', VOID, TypedVariableInitializerImpl, [TypedVariableInitializerImpl, ProcessPropertyReference]);
  initMetadataForClass(TypedProcessPropertyValueImpl, 'TypedProcessPropertyValueImpl', VOID, TypedBindingValuePlaceholderImpl, [TypedBindingValuePlaceholderImpl, ProcessPropertyValue_1]);
  initMetadataForClass(TypedProcessReferenceImpl, 'TypedProcessReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessReference_1]);
  initMetadataForClass(TypedProcessRelationDeclarationImpl, 'TypedProcessRelationDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ProcessRelationDeclaration_1]);
  initMetadataForClass(TypedProcessTypeImpl, 'TypedProcessTypeImpl', VOID, TypedTypeImpl, [TypedTypeImpl, ProcessType_1]);
  initMetadataForClass(TypedPropertiesCustomCellImpl, 'TypedPropertiesCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, PropertiesCustomCell_1]);
  initMetadataForClass(TypedPropertyConstraintImpl, 'TypedPropertyConstraintImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PropertyConstraint_1]);
  initMetadataForClass(TypedPropertyCustomCellImpl, 'TypedPropertyCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, PropertyCustomCell_1]);
  initMetadataForClass(TypedPropertyDeclarationImpl, 'TypedPropertyDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PropertyDeclaration_1]);
  initMetadataForClass(TypedPropertyDeclarationValueQueryImpl, 'TypedPropertyDeclarationValueQueryImpl', VOID, TypedDeclarationValueQueryImpl, [TypedDeclarationValueQueryImpl, PropertyDeclarationValueQuery_1]);
  initMetadataForClass(TypedPropertyLibraryImpl, 'TypedPropertyLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, PropertyLibrary_1]);
  initMetadataForClass(TypedPropertyReferenceOperationImpl, 'TypedPropertyReferenceOperationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, PropertyReferenceOperation_1]);
  initMetadataForClass(TypedPropertyValueImpl, 'TypedPropertyValueImpl', VOID, TypedAbstractBindingValueImpl, [TypedAbstractBindingValueImpl, PropertyValue_1]);
  initMetadataForClass(TypedPubMedSourceReferenceImpl, 'TypedPubMedSourceReferenceImpl', VOID, TypedKnowledgeSourceReferenceImpl, [TypedKnowledgeSourceReferenceImpl, PubMedSourceReference_1]);
  initMetadataForClass(TypedPublishedSourceReferenceImpl, 'TypedPublishedSourceReferenceImpl', VOID, TypedKnowledgeSourceReferenceImpl, [TypedKnowledgeSourceReferenceImpl, PublishedSourceReference_1]);
  initMetadataForClass(TypedPublishedSourcesLibraryImpl, 'TypedPublishedSourcesLibraryImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, PublishedSourcesLibrary_1]);
  initMetadataForClass(TypedQualifiedOntologyElementReferenceImpl, 'TypedQualifiedOntologyElementReferenceImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, QualifiedOntologyElementReference_1]);
  initMetadataForClass(TypedQueryCommandsImpl, 'TypedQueryCommandsImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, QueryCommands_1]);
  initMetadataForClass(TypedQueryLabelsFactExpressionContainerImpl, 'TypedQueryLabelsFactExpressionContainerImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, QueryLabelsFactExpressionContainer_1]);
  initMetadataForClass(TypedQueryParametersBlackListImpl, 'TypedQueryParametersBlackListImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, QueryParametersBlackList]);
  initMetadataForClass(TypedRelationContainerImpl, 'TypedRelationContainerImpl', VOID, TypedDocumentNodeImpl, [TypedDocumentNodeImpl, RelationContainer_1]);
  initMetadataForClass(TypedRelationFactExpressionImpl, 'TypedRelationFactExpressionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, RelationFactExpression_1]);
  initMetadataForClass(TypedReturnTypeCustomCellImpl, 'TypedReturnTypeCustomCellImpl', VOID, TypedCustomCellImpl, [TypedCustomCellImpl, ReturnTypeCustomCell_1]);
  initMetadataForClass(TypedSetExpressionImpl, 'TypedSetExpressionImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, SetExpression_1]);
  initMetadataForClass(TypedSetValuedPropertyParameterImpl, 'TypedSetValuedPropertyParameterImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, SetValuedPropertyParameter_1]);
  initMetadataForClass(TypedSimplePropertyTypeImpl, 'TypedSimplePropertyTypeImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, SimplePropertyType]);
  initMetadataForClass(TypedSinglePropertyValueRangeImpl, 'TypedSinglePropertyValueRangeImpl', VOID, TypedPropertyValueRangeImpl, [TypedPropertyValueRangeImpl, SinglePropertyValueRange_1]);
  initMetadataForClass(TypedTextLineImpl, 'TypedTextLineImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, TextLine]);
  initMetadataForClass(TypedTypePlaceholderImpl, 'TypedTypePlaceholderImpl', VOID, TypedTypeImpl, [TypedTypeImpl, TypePlaceholder_1]);
  function get_getClassDeclaration_0() {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new AnonymousClass$getClassDeclaration$$inlined$suspendingQuery$1(this);
  }
  initMetadataForInterface(AnonymousClass, 'AnonymousClass', VOID, VOID, [ClassExpression, ClassDeclaration, AbstractValue, FactExpression]);
  initMetadataForInterface(UnionClass_1, 'UnionClass', VOID, VOID, [AnonymousClass]);
  initMetadataForClass(TypedUnionClassImpl, 'TypedUnionClassImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, UnionClass_1]);
  initMetadataForInterface(UrlKnowledgeSourceReference_1, 'UrlKnowledgeSourceReference', VOID, VOID, [KnowledgeSourceReference]);
  initMetadataForClass(TypedUrlKnowledgeSourceReferenceImpl, 'TypedUrlKnowledgeSourceReferenceImpl', VOID, TypedKnowledgeSourceReferenceImpl, [TypedKnowledgeSourceReferenceImpl, UrlKnowledgeSourceReference_1]);
  initMetadataForInterface(ValueWithRelations_1, 'ValueWithRelations', VOID, VOID, [AbstractValue]);
  initMetadataForClass(TypedValueWithRelationsImpl, 'TypedValueWithRelationsImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, ValueWithRelations_1]);
  initMetadataForInterface(VariableDeclaration_1, 'VariableDeclaration', VOID, VOID, [BTBNode, DirectlyNamed, HasQueryLabels, HasPropertyConstraints]);
  initMetadataForClass(TypedVariableDeclarationImpl, 'TypedVariableDeclarationImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, VariableDeclaration_1]);
  initMetadataForInterface(VariableReferenceValue_1, 'VariableReferenceValue', VOID, VOID, [AbstractValue, FactExpression, VariableInitializer]);
  initMetadataForClass(TypedVariableReferenceValueImpl, 'TypedVariableReferenceValueImpl', VOID, TypedVariableInitializerImpl, [TypedVariableInitializerImpl, VariableReferenceValue_1]);
  initMetadataForInterface(XRefContainer, 'XRefContainer', VOID, VOID, [BTBNode]);
  initMetadataForClass(TypedXRefContainerImpl, 'TypedXRefContainerImpl', VOID, TypedBTBNodeImpl, [TypedBTBNodeImpl, XRefContainer]);
  initMetadataForClass(UnionClassImpl, 'UnionClassImpl', VOID, BTBNodeImpl, [BTBNodeImpl, UnionClass_1]);
  initMetadataForClass(UrlKnowledgeSourceReferenceImpl, 'UrlKnowledgeSourceReferenceImpl', VOID, KnowledgeSourceReferenceImpl, [KnowledgeSourceReferenceImpl, UrlKnowledgeSourceReference_1]);
  initMetadataForClass(ValueWithRelationsImpl, 'ValueWithRelationsImpl', VOID, BTBNodeImpl, [BTBNodeImpl, ValueWithRelations_1]);
  initMetadataForClass(VariableDeclarationImpl, 'VariableDeclarationImpl', VOID, BTBNodeImpl, [BTBNodeImpl, VariableDeclaration_1]);
  initMetadataForClass(VariableReferenceValueImpl, 'VariableReferenceValueImpl', VOID, VariableInitializerImpl, [VariableInitializerImpl, VariableReferenceValue_1]);
  initMetadataForClass(XRefContainerImpl, 'XRefContainerImpl', VOID, BTBNodeImpl, [BTBNodeImpl, XRefContainer]);
  initMetadataForObject(LinkStubConcept, 'LinkStubConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(NotionStubConcept, 'NotionStubConcept', VOID, OtConceptDescriptor);
  initMetadataForObject(PropertyStubConcept, 'PropertyStubConcept', VOID, OtConceptDescriptor);
  function get_specializes() {
    throw UnsupportedOperationException_init_$Create$();
  }
  function get_element_2() {
    throw UnsupportedOperationException_init_$Create$();
  }
  function get_specificator_1() {
    throw UnsupportedOperationException_init_$Create$();
  }
  initMetadataForInterface(LinkStub, 'LinkStub', VOID, VOID, [AbstractLink, ExternallyNamed]);
  initMetadataForClass(LinkStubImpl, 'LinkStubImpl', VOID, AbstractLinkImpl, [AbstractLinkImpl, LinkStub]);
  initMetadataForInterface(NotionStub, 'NotionStub', VOID, VOID, [AbstractNotion, DirectlyNamed]);
  initMetadataForClass(NotionStubImpl, 'NotionStubImpl', VOID, AbstractNotionImpl, [AbstractNotionImpl, NotionStub]);
  initMetadataForInterface(PropertyStub, 'PropertyStub', VOID, VOID, [AbstractProperty, ExternallyNamed]);
  initMetadataForClass(PropertyStubImpl, 'PropertyStubImpl', VOID, AbstractPropertyImpl, [AbstractPropertyImpl, PropertyStub]);
  initMetadataForClass(TypedLinkStubImpl, 'TypedLinkStubImpl', VOID, TypedAbstractLinkImpl, [TypedAbstractLinkImpl, LinkStub]);
  initMetadataForClass(TypedNotionStubImpl, 'TypedNotionStubImpl', VOID, TypedAbstractNotionImpl, [TypedAbstractNotionImpl, NotionStub]);
  initMetadataForClass(TypedPropertyStubImpl, 'TypedPropertyStubImpl', VOID, TypedAbstractPropertyImpl, [TypedAbstractPropertyImpl, PropertyStub]);
  initMetadataForCoroutine($runSuspendCOROUTINE$0_2, CoroutineImpl);
  initMetadataForClass(BTBDocument$librariesForElement$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_185);
  initMetadataForCompanion(Companion_186);
  initMetadataForCompanion(Companion_187);
  initMetadataForCompanion(Companion_188);
  initMetadataForCompanion(Companion_189);
  initMetadataForCompanion(Companion_190);
  initMetadataForCompanion(Companion_191);
  initMetadataForClass(When, 'When', VOID, Enum);
  initMetadataForClass(BTBNodePersister, 'BTBNodePersister', VOID, DomainNodePersister);
  initMetadataForClass(BtbOtNodePersister, 'BtbOtNodePersister', VOID, VOID, [Persister]);
  initMetadataForClass(NodeWithName, 'NodeWithName');
  initMetadataForCompanion(Companion_192);
  initMetadataForClass(AnonymousClass$getClassDeclaration$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_193);
  initMetadataForCompanion(Companion_194);
  initMetadataForCompanion(Companion_195);
  initMetadataForCompanion(Companion_196);
  initMetadataForCompanion(Companion_197);
  initMetadataForClass(CardinalitySpecificator, 'CardinalitySpecificator', VOID, Enum);
  initMetadataForCompanion(Companion_198);
  initMetadataForCompanion(Companion_199);
  initMetadataForCoroutine($runSuspendCOROUTINE$1_2, CoroutineImpl);
  initMetadataForCompanion(Companion_200);
  initMetadataForClass(OntologyLinkValue$importedLibraries$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_201);
  initMetadataForClass(LinkTypeSpecificator, 'LinkTypeSpecificator', VOID, Enum);
  initMetadataForCoroutine($runSuspendCOROUTINE$2_0, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$4, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$5_0, CoroutineImpl);
  initMetadataForCompanion(Companion_202);
  initMetadataForClass(ImportedLink$name$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ImportedLink$specificator$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ImportedLink$element$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$7, CoroutineImpl);
  initMetadataForClass(OntologyLink$name$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyLink$element$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyLink$specificator$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCompanion(Companion_203);
  initMetadataForCompanion(Companion_204);
  initMetadataForClass(ConstraintOperation, 'ConstraintOperation', VOID, Enum);
  initMetadataForCoroutine($runSuspendCOROUTINE$8, CoroutineImpl);
  initMetadataForClass(OntologyElement$temporaryUnionClassDefinition$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(OntologyElement$allTaxonElements$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_205);
  initMetadataForClass(OntologyIsRelation$getElementReference$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCompanion(Companion_206);
  initMetadataForClass(QualifiedOntologyElementReference$element$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$9, CoroutineImpl);
  initMetadataForClass(OntologyElementReferenceProvider$getClassDeclaration$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_207);
  initMetadataForCoroutine($runSuspendCOROUTINE$10_0, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$12_0, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$15_0, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$16_0, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$17_0, CoroutineImpl);
  initMetadataForCompanion(Companion_208);
  initMetadataForClass(ProcessDeclaration$aliasedProperties$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ProcessDeclaration$allSuperProperties$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ProcessDeclaration$cycleInExtends$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ProcessDeclaration$allEntries$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ProcessDeclaration$allProperties$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_209);
  initMetadataForClass(ProcessPropertyType$type$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCompanion(Companion_210);
  initMetadataForCompanion(Companion_211);
  initMetadataForCompanion(Companion_212);
  initMetadataForCompanion(Companion_213);
  initMetadataForClass(PropertyLibrary$properties$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$18_0, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$19_0, CoroutineImpl);
  initMetadataForCompanion(Companion_214);
  initMetadataForClass(ImportedProperty$name$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ImportedProperty$type$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(BindingProperty$name$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(BindingProperty$type$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(PublishedWork$citation$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(PublishedWork$authorsPart$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCompanion(Companion_215);
  initMetadataForCompanion(Companion_216);
  initMetadataForCompanion(Companion_217);
  initMetadataForCompanion(Companion_218);
  initMetadataForCompanion(Companion_219);
  initMetadataForClass(ProcessRelationDeclaration$isValid$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(RelationDirection, 'RelationDirection', VOID, Enum);
  initMetadataForClass(RelationEffect, 'RelationEffect', VOID, Enum);
  initMetadataForCompanion(Companion_220);
  initMetadataForClass(PartValue$transformToVariableReference$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCompanion(Companion_221);
  initMetadataForCompanion(Companion_222);
  initMetadataForClass(ObjectPropertyReferenceValue$removePropertyReference$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCompanion(Companion_223);
  initMetadataForCompanion(Companion_224);
  initMetadataForClass(BTBConfigurationBuilder, 'BTBConfigurationBuilder');
  initMetadataForClass(RemoteDocumentClient, 'RemoteDocumentClient');
  initMetadataForClass(btbErrorChecking$1$2$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$25_0, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$1$3$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbErrorChecking$1$4$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$26, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$1$5$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$27, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$1$6$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbErrorChecking$1$7$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$28_0, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$1$8$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$29_0, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$1$21$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbErrorChecking$1$22$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$30, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$1$23$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$31_0, CoroutineImpl);
  initMetadataForClass(btbErrorChecking$1$24$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbErrorChecking$1$25$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbErrorChecking$1$31$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$32_0, CoroutineImpl);
  initMetadataForClass(checkNewFact$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$33, CoroutineImpl);
  initMetadataForClass(checkOntologyElement$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(checkOntologyElementDefinition$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(checkProcessRelationDeclaration$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(duplicates$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($checkForCycleInVariableSpecsCOROUTINE$20, CoroutineImpl);
  initMetadataForCoroutine($checkForDuplicatePropertiesInConstraintsCOROUTINE$21, CoroutineImpl);
  initMetadataForCoroutine($checkForCycleInProcessDefaultsCOROUTINE$22, CoroutineImpl);
  initMetadataForCoroutine($isProcessExpressionCOROUTINE$23, CoroutineImpl);
  initMetadataForCoroutine($checkProcessRelationCOROUTINE$24, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$35_0, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$36, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$37_0, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$38, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$39, CoroutineImpl);
  initMetadataForClass(ExternalResolveResult, 'ExternalResolveResult');
  initMetadataForClass(OntologyProcessor$checkErrors$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyProcessor$process$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyProcessor$errors$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyProcessor$resolved$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyProcessor$resolve$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyProcessor$resolve$$inlined$suspendingQuery$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyProcessor, 'OntologyProcessor');
  initMetadataForObject(ReferenceAspects, 'ReferenceAspects');
  initMetadataForObject(SuperElementUsageKind, 'SuperElementUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyInSuperElementUsageKind, 'OntologyInSuperElementUsageKind', VOID, UsageKind);
  initMetadataForObject(PartOfElementUsageKind, 'PartOfElementUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyInPartOfElementUsageKind, 'OntologyInPartOfElementUsageKind', VOID, UsageKind);
  initMetadataForObject(ElementsTaxonUsageKind, 'ElementsTaxonUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyInElementsTaxonUsageKind, 'OntologyInElementsTaxonUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyInCategoryUsageKind, 'OntologyInCategoryUsageKind', VOID, UsageKind);
  initMetadataForObject(ElementInCategoryUsageKind, 'ElementInCategoryUsageKind', VOID, UsageKind);
  initMetadataForObject(ElementInFactSetContextUsageKind, 'ElementInFactSetContextUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyInFactSetContextUsageKind, 'OntologyInFactSetContextUsageKind', VOID, UsageKind);
  initMetadataForObject(AnythingInsideFactUsageKind, 'AnythingInsideFactUsageKind', VOID, UsageKind);
  initMetadataForObject(SomethingAsVariableSpecUsageKind, 'SomethingAsVariableSpecUsageKind', VOID, UsageKind);
  initMetadataForObject(ProcessKindUsageKind, 'ProcessKindUsageKind', VOID, UsageKind);
  initMetadataForObject(ExtendedProcessUsageKind, 'ExtendedProcessUsageKind', VOID, UsageKind);
  initMetadataForObject(InheritedProcessUsageKind, 'InheritedProcessUsageKind', VOID, UsageKind);
  initMetadataForObject(FunctionReturnTypeOntologyUsageKind, 'FunctionReturnTypeOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(FunctionReturnTypeOntologyElementUsageKind, 'FunctionReturnTypeOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(AnythingInsideCustomEditorUsageKind, 'AnythingInsideCustomEditorUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyElementInAbstractBindingElementsUsageKind, 'OntologyElementInAbstractBindingElementsUsageKind', VOID, UsageKind);
  initMetadataForObject(OntologyInAbstractBindingElementsUsageKind, 'OntologyInAbstractBindingElementsUsageKind', VOID, UsageKind);
  initMetadataForObject(AliasedPropertyUsageKind, 'AliasedPropertyUsageKind', VOID, UsageKind);
  initMetadataForObject(PropertyTypeOntologyUsageKind, 'PropertyTypeOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(PropertyTypeOntologyElementUsageKind, 'PropertyTypeOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(PropertyTypeNotionUsageKind, 'PropertyTypeNotionUsageKind', VOID, UsageKind);
  initMetadataForObject(OldPropertyTypeNotionUsageKind, 'OldPropertyTypeNotionUsageKind', VOID, UsageKind);
  initMetadataForObject(OldImportedPropertyUsageKind, 'OldImportedPropertyUsageKind', VOID, UsageKind);
  initMetadataForObject(OldLinkOntologyUsageKind, 'OldLinkOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(OldLinkOntologyElementUsageKind, 'OldLinkOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(OldImportedLinkUsageKind, 'OldImportedLinkUsageKind', VOID, UsageKind);
  initMetadataForObject(OldLinkSpecializesLinkUsageKind, 'OldLinkSpecializesLinkUsageKind', VOID, UsageKind);
  initMetadataForObject(InOntologyImportForOntologyUsageKind, 'InOntologyImportForOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(InOntologyImportForOntologyElementUsageKind, 'InOntologyImportForOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(InOntologyImportOntologyToUseUsageKind, 'InOntologyImportOntologyToUseUsageKind', VOID, UsageKind);
  initMetadataForObject(ExtensionTypeOntologyUsageKind, 'ExtensionTypeOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(ExtensionTypeOntologyElementUsageKind, 'ExtensionTypeOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(ExtensionFieldOntologyUsageKind, 'ExtensionFieldOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(ExtensionFieldOntologyElementUsageKind, 'ExtensionFieldOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(ImportOntologyImportRootUsageKind, 'ImportOntologyImportRootUsageKind', VOID, UsageKind);
  initMetadataForObject(TypeOfOldPropertyNotionUsageKind, 'TypeOfOldPropertyNotionUsageKind', VOID, UsageKind);
  initMetadataForObject(TypeOfOldLinkOntologyUsageKind, 'TypeOfOldLinkOntologyUsageKind', VOID, UsageKind);
  initMetadataForObject(TypeOfOldLinkOntologyElementUsageKind, 'TypeOfOldLinkOntologyElementUsageKind', VOID, UsageKind);
  initMetadataForObject(SuperPropertyUsageKind, 'SuperPropertyUsageKind', VOID, UsageKind);
  initMetadataForObject(InversePropertyUsageKind, 'InversePropertyUsageKind', VOID, UsageKind);
  initMetadataForClass(OntologyElementUsageByAnotherElement, 'OntologyElementUsageByAnotherElement', VOID, UsagePresentationData);
  initMetadataForClass(OntologyElementRelatedToAnotherElementUsage, 'OntologyElementRelatedToAnotherElementUsage', VOID, OntologyElementUsageByAnotherElement);
  initMetadataForClass(SuperElementUsage, 'SuperElementUsage', VOID, OntologyElementRelatedToAnotherElementUsage);
  initMetadataForClass(OntologyTargetKind, 'OntologyTargetKind', VOID, Enum);
  initMetadataForClass(PartOfElementUsage, 'PartOfElementUsage', VOID, OntologyElementRelatedToAnotherElementUsage);
  initMetadataForClass(ElementsTaxonUsage, 'ElementsTaxonUsage', VOID, OntologyElementUsageByAnotherElement);
  initMetadataForClass(CategoryOntologyUsage, 'CategoryOntologyUsage', VOID, UsagePresentationData);
  initMetadataForClass(FactSetContextOntologyUsage, 'FactSetContextOntologyUsage', VOID, UsagePresentationData);
  initMetadataForClass(SomethingAsVariableSpecUsage, 'SomethingAsVariableSpecUsage', VOID, UsagePresentationData);
  initMetadataForClass(AnyUsageInFact, 'AnyUsageInFact', VOID, UsagePresentationData);
  initMetadataForClass(UsageInProcess, 'UsageInProcess', VOID, UsagePresentationData);
  initMetadataForClass(ProcessKindUsage, 'ProcessKindUsage', VOID, UsageInProcess);
  initMetadataForClass(ExtendedProcessUsage, 'ExtendedProcessUsage', VOID, UsageInProcess);
  initMetadataForClass(InheritedProcessUsage, 'InheritedProcessUsage', VOID, UsageInProcess);
  initMetadataForClass(UsageInBindingDeclaration, 'UsageInBindingDeclaration', VOID, UsagePresentationData);
  initMetadataForClass(OntologyElementInBindingDeclarationUsage, 'OntologyElementInBindingDeclarationUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(AnythingInsideCustomEditorUsage, 'AnythingInsideCustomEditorUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(UsageInBindingProperty, 'UsageInBindingProperty', VOID, UsagePresentationData);
  initMetadataForClass(AliasedBindingPropertyUsage, 'AliasedBindingPropertyUsage', VOID, UsageInBindingProperty);
  initMetadataForClass(PropertyTypeUsage, 'PropertyTypeUsage', VOID, UsageInBindingProperty);
  initMetadataForClass(OldPropertyTypeNotionUsage, 'OldPropertyTypeNotionUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(OldImportedPropertyUsage, 'OldImportedPropertyUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(OldLinkOntologyUsage, 'OldLinkOntologyUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(OldImportedLinkUsage, 'OldImportedLinkUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(OldLinkSpecializesLinkUsage, 'OldLinkSpecializesLinkUsage', VOID, UsageInBindingDeclaration);
  initMetadataForClass(OntologyInFunctionReturnTypeUsage, 'OntologyInFunctionReturnTypeUsage', VOID, UsagePresentationData);
  initMetadataForClass(UsageInOntologyImport, 'UsageInOntologyImport', VOID, UsagePresentationData);
  initMetadataForClass(InOntologyImportForOntologyUsage, 'InOntologyImportForOntologyUsage', VOID, UsageInOntologyImport);
  initMetadataForClass(InOntologyImportOntologyToUseUsage, 'InOntologyImportOntologyToUseUsage', VOID, UsageInOntologyImport);
  initMetadataForClass(OntologyInExtensionTypeUsage, 'OntologyInExtensionTypeUsage', VOID, UsagePresentationData);
  initMetadataForClass(OntologyInExtensionFieldUsage, 'OntologyInExtensionFieldUsage', VOID, UsagePresentationData);
  initMetadataForClass(ImportOntologyImportRootUsage, 'ImportOntologyImportRootUsage', VOID, UsagePresentationData);
  initMetadataForObject(PublishedSourceUsageKind, 'PublishedSourceUsageKind', VOID, UsageKind);
  initMetadataForClass(PublishedSourceUsage, 'PublishedSourceUsage', VOID, UsagePresentationData);
  initMetadataForClass(TypeOfOldPropertyDeclarationUsage, 'TypeOfOldPropertyDeclarationUsage', VOID, UsagePresentationData);
  initMetadataForClass(TypeOfOldLinkDeclarationUsage, 'TypeOfOldLinkDeclarationUsage', VOID, UsagePresentationData);
  initMetadataForClass(ObjectPropertyUsageByAnotherProperty, 'ObjectPropertyUsageByAnotherProperty', VOID, UsagePresentationData);
  initMetadataForClass(ObjectPropertyUsageByAnotherPropertyKind, 'ObjectPropertyUsageByAnotherPropertyKind', VOID, Enum);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1, 'sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0', VOID, VOID, [TargetPresentationProvider, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2, 'sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0', VOID, VOID, [TargetPresentationProvider, FunctionAdapter]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_11, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(btbScopes$lambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_3, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_5, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_7, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_9, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_11, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_3, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_13, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_15, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_5, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_17, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_7, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_19, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_9, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_21, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_23, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_11, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_25, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_27, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_29, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_31, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_33, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_35, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_37, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_39, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_41, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_43, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_45, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_47, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_13, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_49, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$44, CoroutineImpl);
  initMetadataForClass(btbScopes$1$27$$inlined$filter$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_51, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_53, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_55, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_57, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_59, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_61, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_63, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_65, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_67, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_69, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_71, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_73, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_75, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_77, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_79, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_81, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_83, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_85, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_87, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_89, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_91, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_93, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_95, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_97, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_99, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_101, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_103, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_105, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_107, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_109, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_111, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_113, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_115, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_117, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_119, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_121, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_123, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_125, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_127, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_129, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_131, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_133, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_135, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_137, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_139, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_141, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_143, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_145, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_147, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_149, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_15, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_151, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_153, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_17, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_155, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_157, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_159, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_19, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_21, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_161, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_163, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_165, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_167, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_23, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_169, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_25, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_171, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_173, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_175, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_27, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_177, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_179, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_29, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_181, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_183, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_185, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_187, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_189, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_191, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_193, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_195, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_197, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_199, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_201, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_203, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_205, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_207, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_209, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_211, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_213, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_215, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_217, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_31, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_219, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_33, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_221, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_35, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_223, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_37, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_225, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_39, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_227, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_229, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_231, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_41, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_233, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_235, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_237, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_239, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_241, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_243, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_245, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda$slambda_43, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_247, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_249, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_251, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(btbScopes$lambda$slambda_253, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_255, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_257, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_259, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_261, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_263, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_265, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_267, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_269, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_271, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_273, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbScopes$lambda$slambda_275, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$46_0, CoroutineImpl);
  initMetadataForClass(btbScopes$1$150$$inlined$suspendingQuery$1$runSuspend$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$45, CoroutineImpl);
  initMetadataForClass(btbScopes$1$150$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(btbScopes$1$151$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$47_0, CoroutineImpl);
  initMetadataForClass(btbScopes$1$$inlined$name$1$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$48_0, CoroutineImpl);
  initMetadataForClass(propertyTypeElements$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$49, CoroutineImpl);
  initMetadataForClass(propertyTypeElements$$inlined$flatMap$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$50, CoroutineImpl);
  initMetadataForClass(typeElements$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(propertyFilterByDomainType$o$runSuspend$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($runSuspendCOROUTINE$51, CoroutineImpl);
  initMetadataForClass(propertyFilterByDomainType$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(filterObjectProperties$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(filterInstanceRelations$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(filterInstanceRelations$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(filterObjectProperties$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($importOntologyLibrariesCOROUTINE$40, CoroutineImpl);
  initMetadataForCoroutine($processPropertyElementsCOROUTINE$41, CoroutineImpl);
  initMetadataForCoroutine($getCustomEditorPropertiesScopeCOROUTINE$42, CoroutineImpl);
  initMetadataForCoroutine($libraryElementsScopeCOROUTINE$43, CoroutineImpl);
  initMetadataForClass(PublishedWorkReferenceResolver$resolve$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(PublishedWorkReferenceResolver, 'PublishedWorkReferenceResolver', VOID, VOID, [ReferenceResolver]);
  initMetadataForClass(PublishedWorkReferenceTargetPresentationProvider, 'PublishedWorkReferenceTargetPresentationProvider', PublishedWorkReferenceTargetPresentationProvider, VOID, [TargetPresentationProvider]);
  initMetadataForLambda(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$53, CoroutineImpl);
  initMetadataForLambda(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$54, CoroutineImpl);
  initMetadataForLambda(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1$runSuspend$3, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1$runSuspend$4, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$52, CoroutineImpl);
  initMetadataForClass(PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_12, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(PublishedWorkReferenceTargetsSupplier$getElements$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(PublishedWorkReferenceTargetsSupplier, 'PublishedWorkReferenceTargetsSupplier', VOID, VOID, [ReferenceTargetsSupplier]);
  initMetadataForClass(SubtypeScopeFilter, 'SubtypeScopeFilter', VOID, VOID, [ScopeFilter]);
  function provideFilterFor(element) {
    return this.fhm(setOf(element));
  }
  initMetadataForInterface(SubtypeScopeFilterService, 'SubtypeScopeFilterService');
  initMetadataForClass(SubtypeScopeFilterService$Companion$default$1, VOID, VOID, VOID, [SubtypeScopeFilterService]);
  initMetadataForCompanion(Companion_225, VOID, [Key_5]);
  initMetadataForCoroutine($runSuspendCOROUTINE$55, CoroutineImpl);
  initMetadataForClass(TaxonScopeFilter$apply$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(TaxonScopeFilter, 'TaxonScopeFilter', VOID, VOID, [ScopeFilter]);
  initMetadataForInterface(TaxonScopeFilterService, 'TaxonScopeFilterService');
  initMetadataForClass(sam$jetbrains_biokb_lang_model_resolve_TaxonScopeFilterService$0, 'sam$jetbrains_biokb_lang_model_resolve_TaxonScopeFilterService$0', VOID, VOID, [TaxonScopeFilterService, FunctionAdapter]);
  initMetadataForCompanion(Companion_226, VOID, [Key_5]);
  initMetadataForClass(TraversalContext$getFrames$1);
  initMetadataForClass(TraversalContext, 'TraversalContext');
  initMetadataForClass(Frame_0, 'Frame');
  initMetadataForClass(PostProcessChildNodeFrame, 'PostProcessChildNodeFrame', VOID, Frame_0);
  initMetadataForClass(PreProcessNodeFrame, 'PreProcessNodeFrame', VOID, Frame_0);
  initMetadataForClass(PostProcessNodeFrame, 'PostProcessNodeFrame', VOID, Frame_0);
  initMetadataForCoroutine($runSuspendCOROUTINE$62, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$63, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$64, CoroutineImpl);
  initMetadataForCoroutine($runSuspendCOROUTINE$65, CoroutineImpl);
  initMetadataForCompanion(Companion_227);
  initMetadataForClass(OntologyHierarchyImpl$isSubtypeOf$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyHierarchyImpl$isNatural$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyHierarchyImpl$getAssertedDefinitionElements$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyHierarchyImpl$getAllNaturalDefinitionElements$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($getAssertedDefinitionElementsCOROUTINE$56, CoroutineImpl);
  initMetadataForCoroutine($calculateElementsToAllNaturalDefinitionsCOROUTINE$57, CoroutineImpl);
  initMetadataForCoroutine($getAllNaturalDefinitionsCOROUTINE$58, CoroutineImpl);
  initMetadataForCoroutine($getAssertedSuperElementsCOROUTINE$59, CoroutineImpl);
  initMetadataForCoroutine($calculateElementToAllSuperElementsCOROUTINE$60, CoroutineImpl);
  initMetadataForCoroutine($getAllSuperElementsCOROUTINE$61, CoroutineImpl);
  initMetadataForClass(OntologyHierarchyImpl, 'OntologyHierarchyImpl', OntologyHierarchyImpl, VOID, VOID, [1]);
  initMetadataForInterface(AbstractOntologyElement, 'AbstractOntologyElement');
  initMetadataForInterface(AbstractUnion, 'AbstractUnion');
  function resolve($completion) {
    return execute_1(this.lay(), $completion);
  }
  initMetadataForInterface(AbstractClassReference, 'AbstractClassReference', VOID, VOID, VOID, [1, 0]);
  initMetadataForClass(ClassDeclarationAdapter$classes$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(ClassDeclarationAdapter, 'ClassDeclarationAdapter', VOID, VOID, [AbstractUnion]);
  initMetadataForClass(OntologyElementAdapter$superElements$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyElementAdapter$definition$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(OntologyElementAdapter, 'OntologyElementAdapter', VOID, VOID, [AbstractOntologyElement]);
  initMetadataForCoroutine($runSuspendCOROUTINE$68, CoroutineImpl);
  initMetadataForClass(UnionAdapter$classes$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(UnionAdapter, 'UnionAdapter', VOID, VOID, [AbstractUnion]);
  initMetadataForCoroutine($runSuspendCOROUTINE$69, CoroutineImpl);
  initMetadataForClass(OntologyElementReferenceAdapter$element$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(OntologyElementReferenceAdapter, 'OntologyElementReferenceAdapter', VOID, VOID, [AbstractClassReference], [1, 0]);
  initMetadataForClass(getAssertedDefinitionElements$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$70, CoroutineImpl);
  initMetadataForClass(getAssertedDefinitionElements$$inlined$map$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(getAllNaturalDefinitionElements$$inlined$map$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($runSuspendCOROUTINE$71, CoroutineImpl);
  initMetadataForClass(getAllNaturalDefinitionElements$$inlined$map$2, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_228);
  initMetadataForObject($serializer_26, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UsageDto, 'UsageDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_24});
  initMetadataForCompanion(Companion_229);
  initMetadataForObject($serializer_27, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PubMedPaperLoadResultDto, 'PubMedPaperLoadResultDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_25});
  initMetadataForClass(DocPersistence, 'DocPersistence');
  initMetadataForObject(RawDocPersistence, 'RawDocPersistence', VOID, DocPersistence);
  initMetadataForCompanion(Companion_230);
  initMetadataForClass(ClientId, 'ClientId', ClientId_init_$Create$, BaseId);
  initMetadataForCompanion(Companion_231);
  initMetadataForClass(ConnectionId, 'ConnectionId', ConnectionId_init_$Create$, BaseId);
  initMetadataForInterface(StringChannel, 'StringChannel');
  initMetadataForInterface(JsonChannel, 'JsonChannel');
  initMetadataForClass(JsonService$Companion$toStringPort$1$setOutput$$inlined$jsonChannel$1, VOID, VOID, VOID, [JsonChannel]);
  initMetadataForClass(JsonService$Companion$toStringPort$$inlined$stringChannel$1, VOID, VOID, VOID, [StringChannel]);
  initMetadataForClass(JsonService$Companion$toStringPort$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_232);
  initMetadataForClass(JsonServiceEndpoint, 'JsonServiceEndpoint', VOID, VOID, [Disposable]);
  initMetadataForClass(AsyncsListHandler, 'AsyncsListHandler', AsyncsListHandler);
  initMetadataForClass(LoadedEntitiesTree, 'LoadedEntitiesTree', LoadedEntitiesTree);
  initMetadataForCompanion(Companion_233);
  initMetadataForClass(LoadedEntitiesTreeElement, 'LoadedEntitiesTreeElement');
  initMetadataForClass(LoadedEntitiesTreeReconnectHelper, 'LoadedEntitiesTreeReconnectHelper');
  initMetadataForInterface(OtChannel, 'OtChannel');
  initMetadataForClass(OtChannelAdapter, 'OtChannelAdapter', OtChannelAdapter, VOID, [OtChannel]);
  initMetadataForClass(OtChannelDelegate, 'OtChannelDelegate', VOID, VOID, [OtChannel]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_2, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(PortExecutingDelegate, 'PortExecutingDelegate', VOID, VOID, [Disposable]);
  initMetadataForObject(RootOperationsUtil, 'RootOperationsUtil');
  initMetadataForClass(RootReconnectData, 'RootReconnectData');
  initMetadataForCompanion(Companion_234);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_3, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(ThrottlingJsonPort$createChannelDelegate$$inlined$jsonChannel$1, VOID, VOID, VOID, [JsonChannel]);
  initMetadataForClass(ThrottlingJsonPort, 'ThrottlingJsonPort', VOID, PortExecutingDelegate);
  initMetadataForClass(ProtocolPersistentParameter, 'ProtocolPersistentParameter', VOID, VOID, [PersistentParameter]);
  initMetadataForClass(BooleanPersistentParameter, 'BooleanPersistentParameter', VOID, ProtocolPersistentParameter);
  initMetadataForClass(LongPersistentParameter, 'LongPersistentParameter', VOID, ProtocolPersistentParameter);
  initMetadataForClass(StringPersistentParameter, 'StringPersistentParameter', VOID, ProtocolPersistentParameter);
  initMetadataForClass(ProtocolParameters$RECONNECT_ENABLED$1, VOID, VOID, BooleanPersistentParameter);
  initMetadataForClass(ProtocolParameters$PING_TIMEOUT_MS$1, VOID, VOID, LongPersistentParameter);
  initMetadataForClass(ProtocolParameters$ID_COMPRESSION_ENABLED$1, VOID, VOID, BooleanPersistentParameter);
  initMetadataForClass(ProtocolParameters$PARTIAL_LOADING_ENABLED$1, VOID, VOID, BooleanPersistentParameter);
  initMetadataForClass(ProtocolParameters$OT_VERSION$1, VOID, VOID, StringPersistentParameter);
  initMetadataForObject(ProtocolParameters, 'ProtocolParameters');
  initMetadataForClass(ProtocolPersistentContext, 'ProtocolPersistentContext', ProtocolPersistentContext, ConfigurationPersistentContext);
  initMetadataForCompanion(Companion_235);
  initMetadataForClass(CommandDeserializer, 'CommandDeserializer', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_236);
  initMetadataForClass(CommandSerializer, 'CommandSerializer');
  initMetadataForClass(DictionaryAwareOperationDeserializer, 'DictionaryAwareOperationDeserializer', VOID, DictionaryAwareDeserializer);
  initMetadataForClass(DictionaryAwareOperationSerializer, 'DictionaryAwareOperationSerializer', VOID, DictionaryAwareSerializer);
  initMetadataForClass(Json2OtChannelAdapter$Companion$getFullSerializerFactory$$inlined$commandSerializerFactory$1);
  initMetadataForCompanion(Companion_237);
  initMetadataForClass(Json2OtChannelAdapter$$inlined$entityOperationPersistenceContextFactory$1);
  initMetadataForClass(JsonReconnectHelper, 'JsonReconnectHelper');
  initMetadataForClass(Json2OtChannelAdapter$1, VOID, VOID, JsonReconnectHelper);
  initMetadataForClass(Json2OtChannelAdapter, 'Json2OtChannelAdapter', VOID, VOID, [OtChannel]);
  initMetadataForClass(Data, 'Data');
  initMetadataForClass(LoadedEntitiesTreeElementPersister, 'LoadedEntitiesTreeElementPersister', LoadedEntitiesTreeElementPersister);
  initMetadataForClass(MyRootCommandData, 'MyRootCommandData');
  initMetadataForClass(Ot2JsonChannelAdapter$persistenceContextFactory$$inlined$entityOperationPersistenceContextFactory$1);
  initMetadataForClass(Ot2JsonChannelAdapter$reconnectHelper$1, VOID, VOID, JsonReconnectHelper);
  initMetadataForClass(Ot2JsonChannelAdapter, 'Ot2JsonChannelAdapter', VOID, VOID, [JsonChannel]);
  initMetadataForClass(RootReconnectDataPersister, 'RootReconnectDataPersister', RootReconnectDataPersister);
  initMetadataForClass(EndpointMultiplexPort$ServiceEndpointPort$setOutput$$inlined$stringChannel$1, VOID, VOID, VOID, [StringChannel]);
  initMetadataForClass(ServiceEndpointPort, 'ServiceEndpointPort', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_238);
  initMetadataForInterface(ServiceContainerChannel, 'ServiceContainerChannel');
  initMetadataForClass(EndpointMultiplexPort$input$$inlined$serviceContainerChannel$1, VOID, VOID, VOID, [ServiceContainerChannel]);
  initMetadataForClass(EndpointMultiplexPort$outputChannel$$inlined$serviceContainerChannel$1, VOID, VOID, VOID, [ServiceContainerChannel]);
  initMetadataForClass(EndpointMultiplexPort, 'EndpointMultiplexPort', VOID, VOID, [Disposable]);
  initMetadataForClass(EndpointMultiplexPortState, 'EndpointMultiplexPortState', VOID, Enum);
  initMetadataForClass(FatalEndpointException, 'FatalEndpointException', FatalEndpointException_init_$Create$, RuntimeException);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_4, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(JsonChannelExecutingDelegate, 'JsonChannelExecutingDelegate', VOID, VOID, [JsonChannel]);
  initMetadataForClass(JsonPortExecutingDelegate$setOutput$$inlined$jsonChannel$1, VOID, VOID, VOID, [JsonChannel]);
  initMetadataForClass(JsonPortExecutingDelegate, 'JsonPortExecutingDelegate', VOID, PortExecutingDelegate);
  initMetadataForObject(PingPongServiceConstants, 'PingPongServiceConstants');
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_5, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(PingPongServiceEndpoint$MyPort$input$$inlined$jsonChannel$1, VOID, VOID, VOID, [JsonChannel]);
  initMetadataForClass(MyPort, 'MyPort', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_239);
  initMetadataForClass(PingPongServiceEndpoint, 'PingPongServiceEndpoint', VOID, JsonServiceEndpoint);
  initMetadataForObject(ServiceContainerConstants, 'ServiceContainerConstants');
  initMetadataForClass(ServiceContainerMessage, 'ServiceContainerMessage');
  initMetadataForClass(ServiceContainerMessagePersister, 'ServiceContainerMessagePersister', ServiceContainerMessagePersister, VOID, [NonNullPersister]);
  initMetadataForObject(ServiceContainerMessageUtil, 'ServiceContainerMessageUtil');
  initMetadataForClass(ServiceContainerSystemMessage, 'ServiceContainerSystemMessage');
  initMetadataForCompanion(Companion_240);
  initMetadataForClass(ServiceEndpointContainer$addConfigurableService$configurableService$1);
  initMetadataForClass(ServiceEndpointContainer, 'ServiceEndpointContainer', ServiceEndpointContainer, VOID, [Disposable]);
  initMetadataForClass(ServiceEndpointContainerState, 'ServiceEndpointContainerState', VOID, Enum);
  initMetadataForClass(SynchronizedAtomicReference, 'SynchronizedAtomicReference');
  initMetadataForClass(VersionMismatchException, 'VersionMismatchException', VersionMismatchException_init_$Create$, RuntimeException);
  initMetadataForCompanion(Companion_241);
  initMetadataForCompanion(Companion_242);
  initMetadataForClass(State_1, 'State', VOID, Enum);
  initMetadataForClass(EmptyListener, 'EmptyListener');
  initMetadataForClass(SocketHandler, 'SocketHandler');
  initMetadataForClass(SocketConnection$connect$socketHandler$1, VOID, VOID, SocketHandler);
  initMetadataForClass(SocketConnection$connect$3$$inlined$serviceContainerChannel$1, VOID, VOID, VOID, [ServiceContainerChannel]);
  initMetadataForClass(SocketConnection, 'SocketConnection', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_243);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_6, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(SocketManager$1);
  initMetadataForClass(SocketManager, 'SocketManager');
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_7, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(ReconnectStrategy, 'ReconnectStrategy', VOID, VOID, [Disposable]);
  initMetadataForClass(UniformDelays$delays$1);
  initMetadataForClass(UniformDelays, 'UniformDelays');
  initMetadataForClass(JsWebsocket, 'JsWebsocket');
  initMetadataForClass(JsWebsocketFactory, 'JsWebsocketFactory', JsWebsocketFactory);
  initMetadataForCompanion(Companion_244);
  initMetadataForClass(AsyncWithDisposable, 'AsyncWithDisposable');
  initMetadataForClass(Client$MyPort$1, VOID, VOID, OtChannelAdapter);
  initMetadataForClass(Client$MyPort$setOutput$1, VOID, VOID, OtChannelDelegate);
  initMetadataForClass(MyPort_0, 'MyPort', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_245);
  initMetadataForClass(Client$init$validator$1, VOID, VOID, VOID, [OperationValidator]);
  initMetadataForClass(Client$init$listener$1, VOID, VOID, VOID, [OtCommandListener]);
  initMetadataForClass(Client, 'Client', VOID, VOID, [Disposable]);
  initMetadataForClass(ClientBuilder, 'ClientBuilder', ClientBuilder);
  initMetadataForCompanion(Companion_246);
  initMetadataForClass(ClientLoadingPeer, 'ClientLoadingPeer');
  initMetadataForClass(State_2, 'State', VOID, Enum);
  initMetadataForClass(LoadHandler, 'LoadHandler');
  initMetadataForClass(ReconnectHandler, 'ReconnectHandler');
  initMetadataForClass(EventHandler, 'EventHandler');
  initMetadataForClass(CommandEventHandler, 'CommandEventHandler', VOID, EventHandler);
  initMetadataForClass(ClientRootImpl$load$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(ClientRootImpl, 'ClientRootImpl');
  initMetadataForClass(CommandQueue, 'CommandQueue');
  initMetadataForClass(LoadingRootData, 'LoadingRootData');
  initMetadataForClass(LoadingReferences, 'LoadingReferences', LoadingReferences);
  initMetadataForClass(Memento, 'Memento', Memento_init_$Create$);
  initMetadataForClass(OtServiceEndpoint$MyThrottlingJsonPort$1$wrappedClientPort$1$input$1, VOID, VOID, OtChannelDelegate);
  initMetadataForClass(OtServiceEndpoint$MyThrottlingJsonPort$1$wrappedClientPort$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(OtServiceEndpoint$CommonJsonPort$$inlined$jsonChannel$1, VOID, VOID, VOID, [JsonChannel]);
  initMetadataForClass(ExecutingJsonPort, 'ExecutingJsonPort', VOID, JsonPortExecutingDelegate);
  initMetadataForClass(MyThrottlingJsonPort, 'MyThrottlingJsonPort', VOID, ThrottlingJsonPort);
  initMetadataForClass(CommonJsonPort, 'CommonJsonPort', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_247);
  initMetadataForClass(OtServiceEndpoint, 'OtServiceEndpoint', VOID, JsonServiceEndpoint);
  function onCommandExecuted(command) {
  }
  function onCommandTransited(command) {
  }
  function onCommandReceived(command) {
  }
  function onAlreadyProcessed(command) {
  }
  function onReconnectRejected(id, reason) {
  }
  function onCommandAccepted(id) {
  }
  function onCommandRejected(id, reason) {
  }
  function onUnloadHandled(id, rootIds) {
  }
  function onConnectionEstablished() {
  }
  function onConnectionBroken() {
  }
  function onCommandUnprocessed(id) {
  }
  function onLoadRequested(reference) {
  }
  function onLoadAccepted(reference) {
  }
  function onLoadRejected(reference, reason) {
  }
  function onHistoryAccepted(id, history) {
  }
  function onHistoryRejected(id, reason) {
  }
  initMetadataForInterface(ProtocolListener, 'ProtocolListener');
  initMetadataForClass(IncomingAcceptance, 'IncomingAcceptance');
  initMetadataForClass(IncomingRejection, 'IncomingRejection');
  initMetadataForClass(IncomingRequest, 'IncomingRequest', IncomingRequest);
  initMetadataForClass(OutgoingRequest, 'OutgoingRequest', OutgoingRequest);
  initMetadataForCompanion(Companion_248);
  initMetadataForClass(DoubleRectangle, 'DoubleRectangle');
  initMetadataForClass(DoubleSegment, 'DoubleSegment');
  initMetadataForCompanion(Companion_249);
  initMetadataForClass(DoubleVector, 'DoubleVector');
  initMetadataForCompanion(Companion_250);
  initMetadataForClass(Rectangle, 'Rectangle');
  initMetadataForObject(Rectangles, 'Rectangles');
  initMetadataForCompanion(Companion_251);
  initMetadataForClass(Vector, 'Vector');
  initMetadataForClass(DomUtil$nodeChildren$1, VOID, VOID, AbstractMutableList);
  initMetadataForClass(DomUtil$timerBasedProperty$1, VOID, VOID, UpdatableProperty);
  initMetadataForObject(DomUtil, 'DomUtil');
  initMetadataForClass(CssUnit, 'CssUnit', VOID, Enum);
  initMetadataForClass(CssAlignItem, 'CssAlignItem', VOID, Enum);
  initMetadataForClass(CssBorderStyle, 'CssBorderStyle', VOID, Enum);
  initMetadataForClass(CssClear, 'CssClear', VOID, Enum);
  initMetadataForClass(CssDisplay, 'CssDisplay', VOID, Enum);
  initMetadataForClass(CssFloat, 'CssFloat', VOID, Enum);
  initMetadataForClass(CssFontStyle, 'CssFontStyle', VOID, Enum);
  initMetadataForClass(CssFontWeight, 'CssFontWeight', VOID, Enum);
  initMetadataForClass(CssOutlineStyle, 'CssOutlineStyle', VOID, Enum);
  initMetadataForCompanion(Companion_252);
  initMetadataForClass(CssOverflow, 'CssOverflow', VOID, Enum);
  initMetadataForCompanion(Companion_253);
  initMetadataForClass(CssPosition, 'CssPosition', VOID, Enum);
  initMetadataForClass(CssVerticalAlign, 'CssVerticalAlign', VOID, Enum);
  initMetadataForClass(CssVisibility, 'CssVisibility', VOID, Enum);
  initMetadataForClass(CssWhiteSpace, 'CssWhiteSpace', VOID, Enum);
  initMetadataForObject(DomApi, 'DomApi');
  initMetadataForClass(on$eventListener$1);
  initMetadataForClass(onEvent$eventListener$1);
  initMetadataForClass(onEvent$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_254);
  initMetadataForClass(DomEventType, 'DomEventType');
  initMetadataForObject(DomImmediatePolyfill, 'DomImmediatePolyfill');
  initMetadataForObject(StyleInjector, 'StyleInjector');
  function toText() {
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(this)));
  }
  initMetadataForInterface(ClipboardContent, 'ClipboardContent');
  initMetadataForClass(Event_0, 'Event', Event_0);
  initMetadataForClass(CompositionEvent, 'CompositionEvent', VOID, Event_0);
  initMetadataForClass(CopyCutEvent, 'CopyCutEvent', CopyCutEvent, Event_0);
  initMetadataForClass(DerivedEvent, 'DerivedEvent', VOID, Event_0);
  initMetadataForClass(DerivedCopyCutEvent, 'DerivedCopyCutEvent', VOID, DerivedEvent);
  initMetadataForObject(EmptyClipboardContent, 'EmptyClipboardContent', VOID, VOID, [ClipboardContent]);
  initMetadataForClass(Key_7, 'Key', VOID, Enum);
  initMetadataForClass(KeyEvent, 'KeyEvent', VOID, Event_0);
  initMetadataForCompanion(Companion_255);
  initMetadataForClass(KeyModifiers, 'KeyModifiers');
  initMetadataForClass(KeyStroke, 'KeyStroke');
  initMetadataForClass(KeyStrokeSpec, 'KeyStrokeSpec');
  initMetadataForObject(KeyStrokeSpecs, 'KeyStrokeSpecs');
  initMetadataForClass(ModifierKey, 'ModifierKey', VOID, Enum);
  initMetadataForClass(MouseButton, 'MouseButton', VOID, Enum);
  initMetadataForCompanion(Companion_256);
  initMetadataForClass(PointEvent, 'PointEvent', VOID, Event_0);
  initMetadataForClass(MouseEvent, 'MouseEvent', VOID, PointEvent);
  initMetadataForClass(PasteEvent, 'PasteEvent', VOID, Event_0);
  initMetadataForClass(TouchEvent, 'TouchEvent', VOID, PointEvent);
  initMetadataForClass(SimpleContentKind, 'SimpleContentKind');
  initMetadataForClass(ListContentKind, 'ListContentKind');
  initMetadataForClass(ReifiedContentKind, 'ReifiedContentKind');
  initMetadataForObject(ContentKinds, 'ContentKinds');
  initMetadataForClass(MultilineTextClipboardContent, 'MultilineTextClipboardContent', VOID, VOID, [ClipboardContent]);
  initMetadataForClass(SingleLineTextClipboardContent, 'SingleLineTextClipboardContent', VOID, VOID, [ClipboardContent]);
  initMetadataForClass(LinesIterator_0, 'LinesIterator');
  initMetadataForClass(TextContentHelper$splitByNewline$1);
  initMetadataForObject(TextContentHelper, 'TextContentHelper');
  initMetadataForCompanion(Companion_257);
  initMetadataForClass(DomClipboardSupport, 'DomClipboardSupport');
  initMetadataForObject(DomEventUtil, 'DomEventUtil');
  initMetadataForObject(DomKeyCodeMapper, 'DomKeyCodeMapper');
  initMetadataForObject(KeyEventUtil, 'KeyEventUtil');
  initMetadataForCompanion(Companion_258);
  initMetadataForClass(MouseTranslator, 'MouseTranslator');
  initMetadataForClass(SimpleKeyTranslator, 'SimpleKeyTranslator');
  initMetadataForClass(TextAreaKeyTranslator, 'TextAreaKeyTranslator');
  initMetadataForCompanion(Companion_259);
  initMetadataForInterface(ClipboardAdapter, 'ClipboardAdapter');
  initMetadataForClass(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0, 'sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0', VOID, VOID, [ClipboardAdapter, FunctionAdapter]);
  initMetadataForClass(ClipboardAdapterBuilder, 'ClipboardAdapterBuilder');
  initMetadataForClass(CompositeClipboardContentSerialization, 'CompositeClipboardContentSerialization');
  initMetadataForCoroutine($retrieveCOROUTINE$0, CoroutineImpl);
  initMetadataForClass(OnlyTextExternalClipboard, 'OnlyTextExternalClipboard', VOID, VOID, VOID, [0]);
  initMetadataForCoroutine($retrieveCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(RestoringExternalClipboard, 'RestoringExternalClipboard', VOID, VOID, VOID, [0]);
  initMetadataForCoroutine($retrieveCOROUTINE$2, CoroutineImpl);
  initMetadataForClass(SerializingExternalClipboard, 'SerializingExternalClipboard', VOID, VOID, VOID, [0]);
  initMetadataForObject(TextClipboardSerialization, 'TextClipboardSerialization');
  initMetadataForClass(MimeTypedData, 'MimeTypedData');
  initMetadataForClass(TrivialSystemClipboard, 'TrivialSystemClipboard', TrivialSystemClipboard, VOID, VOID, [0]);
  initMetadataForCoroutine($retrieveCOROUTINE$3, CoroutineImpl);
  initMetadataForObject(JsSystemClipboard, 'JsSystemClipboard', VOID, VOID, VOID, [0]);
  initMetadataForClass(MapperUpdater, 'MapperUpdater');
  function dispose() {
    return this.t6m();
  }
  initMetadataForInterface(Synchronizer, 'Synchronizer', VOID, VOID, [Disposable]);
  initMetadataForClass(BaseRoleSynchronizer, 'BaseRoleSynchronizer', VOID, VOID, [Synchronizer]);
  initMetadataForClass(BaseCollectionRoleSynchronizer, 'BaseCollectionRoleSynchronizer', VOID, BaseRoleSynchronizer);
  initMetadataForCompanion(Companion_260);
  initMetadataForClass(ByTargetIndex$1);
  initMetadataForClass(ByTargetIndex, 'ByTargetIndex', VOID, VOID, [Disposable]);
  initMetadataForClass(DifferenceItem, 'DifferenceItem');
  initMetadataForClass(DifferenceBuilder, 'DifferenceBuilder');
  initMetadataForClass(DisposableSynchronizer, 'DisposableSynchronizer', VOID, VOID, [Synchronizer]);
  initMetadataForClass(syncOneWay$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(syncTwoWay$1, VOID, VOID, VOID, [Synchronizer]);
  initMetadataForInterface(ChildContainer, 'ChildContainer');
  initMetadataForClass(ChildProperty_0, 'ChildProperty', VOID, ValueProperty, [ValueProperty, ChildContainer]);
  initMetadataForClass(ChildList, 'ChildList', VOID, ObservableArrayList, [ObservableArrayList, ChildContainer]);
  initMetadataForClass(ChildSet, 'ChildSet', VOID, ObservableHashSet, [ObservableHashSet, ChildContainer]);
  initMetadataForClass(State_3, 'State', VOID, Enum);
  initMetadataForCompanion(Companion_261);
  initMetadataForClass(Mapper$instantiateSynchronizers$1);
  initMetadataForClass(Mapper$attach$synchronizerContext$1);
  initMetadataForClass(Mapper, 'Mapper');
  initMetadataForClass(Mappers$attachRoot$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(Mappers$augment$1, VOID, VOID, Mapper);
  initMetadataForObject(Mappers, 'Mappers');
  initMetadataForClass(MappingContext, 'MappingContext', MappingContext);
  initMetadataForClass(MappingContextProperty, 'MappingContextProperty');
  initMetadataForClass(ObservableCollectionRoleSynchronizer$onAttach$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(ObservableCollectionRoleSynchronizer, 'ObservableCollectionRoleSynchronizer', VOID, BaseCollectionRoleSynchronizer);
  initMetadataForClass(SingleChildRoleSynchronizer, 'SingleChildRoleSynchronizer', VOID, BaseRoleSynchronizer);
  initMetadataForClass(Synchronizers$forProperty$$inlined$forEventSource$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(Synchronizers$forDisposables$1, VOID, VOID, VOID, [Synchronizer]);
  initMetadataForClass(Synchronizers$composite$1, VOID, VOID, VOID, [Synchronizer]);
  initMetadataForObject(Synchronizers, 'Synchronizers');
  initMetadataForClass(State_4, 'State', VOID, Enum);
  initMetadataForClass(ReloadableSynchronizer, 'ReloadableSynchronizer', ReloadableSynchronizer, VOID, [Synchronizer]);
  function subList(fromIndex, toIndex) {
    return new SubList_1(this, fromIndex, toIndex);
  }
  initMetadataForInterface(ImmutableList, 'ImmutableList', VOID, VOID, [KtList, Collection]);
  initMetadataForClass(SubList_1, 'SubList', VOID, AbstractList, [ImmutableList, AbstractList]);
  initMetadataForClass(AbstractListIterator, 'AbstractListIterator');
  initMetadataForClass(AbstractPersistentList, 'AbstractPersistentList', VOID, AbstractList, [Collection, ImmutableList, AbstractList]);
  initMetadataForClass(BufferIterator, 'BufferIterator', VOID, AbstractListIterator);
  initMetadataForClass(PersistentVector, 'PersistentVector', VOID, AbstractPersistentList, [Collection, ImmutableList, AbstractPersistentList]);
  initMetadataForClass(PersistentVectorIterator, 'PersistentVectorIterator', VOID, AbstractListIterator);
  initMetadataForCompanion(Companion_262);
  initMetadataForClass(SmallPersistentVector, 'SmallPersistentVector', VOID, AbstractPersistentList, [ImmutableList, AbstractPersistentList]);
  initMetadataForClass(TrieIterator, 'TrieIterator', VOID, AbstractListIterator);
  initMetadataForObject(ListImplementation, 'ListImplementation');
  initMetadataForClass(BoundsComposites, 'BoundsComposites');
  initMetadataForClass(NavCompositeBounds, 'NavCompositeBounds');
  initMetadataForClass(CompositeFocusables, 'CompositeFocusables');
  initMetadataForClass(NavCompositeFocusables, 'NavCompositeFocusables');
  initMetadataForClass(TextDecoration, 'TextDecoration');
  initMetadataForClass(BackgroundHighlightTextDecoration, 'BackgroundHighlightTextDecoration', VOID, TextDecoration);
  initMetadataForClass(RedUnderlineTextDecoration, 'RedUnderlineTextDecoration', VOID, TextDecoration);
  initMetadataForClass(sam$kotlin_Comparator$0_3, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForObject(TextDecorations, 'TextDecorations');
  initMetadataForClass(TreePath$Companion$sorted$comparator$1, VOID, VOID, VOID, [Comparator]);
  initMetadataForCompanion(Companion_263);
  initMetadataForClass(TreePath, 'TreePath', VOID, VOID, [Comparable]);
  initMetadataForObject(Validators, 'Validators');
  initMetadataForClass(Alignment, 'Alignment', VOID, Enum);
  initMetadataForClass(Kind_1, 'Kind', VOID, Enum);
  initMetadataForCompanion(Companion_264);
  initMetadataForClass(Border, 'Border');
  initMetadataForClass(Side, 'Side');
  initMetadataForClass(Block, 'Block');
  initMetadataForClass(CompoundBlock, 'CompoundBlock', VOID, Block);
  initMetadataForClass(HorizontalBlock, 'HorizontalBlock', VOID, CompoundBlock);
  initMetadataForClass(TextBlock, 'TextBlock', VOID, Block);
  initMetadataForClass(IndentationBlock, 'IndentationBlock', VOID, Block);
  initMetadataForClass(VerticalBlock, 'VerticalBlock', VOID, CompoundBlock);
  initMetadataForClass(BlockData, 'BlockData');
  initMetadataForClass(BlockBuilder, 'BlockBuilder', VOID, BlockData);
  initMetadataForClass(Orientation, 'Orientation', VOID, Enum);
  initMetadataForClass(ReadyBlock, 'ReadyBlock', VOID, BlockData);
  initMetadataForClass(IndentUpdater, 'IndentUpdater');
  initMetadataForClass(BlockIndentUpdater, 'BlockIndentUpdater', VOID, IndentUpdater);
  initMetadataForClass(BlockIndentUpdaterTarget, 'BlockIndentUpdaterTarget', BlockIndentUpdaterTarget);
  initMetadataForClass(StaticCellWrapper, 'StaticCellWrapper');
  function onPropertyChanged_0(prop, event) {
  }
  function onChildAdded_0(event) {
  }
  function onChildRemoved_0(event) {
  }
  function onParentChanged(event) {
  }
  function onAttach(container) {
  }
  function onDetach(container) {
  }
  initMetadataForInterface(CellListener, 'CellListener');
  initMetadataForClass(BaseCell$ExternalChildList$addListener$cellListener$1, VOID, VOID, VOID, [CellListener]);
  initMetadataForClass(BaseCell$ExternalChildList$addHandler$listener$1, VOID, VOID, VOID, [CollectionListener]);
  initMetadataForClass(BaseCell$cellContainer$1$addHandler$cellListener$1, VOID, VOID, VOID, [CellListener]);
  initMetadataForClass(BaseCell$getProp$MyProperty$addHandler$cellListener$1, VOID, VOID, VOID, [CellListener]);
  initMetadataForClass(ChildList_0, 'ChildList', VOID, ObservableArrayList);
  initMetadataForClass(ExternalChildList, 'ExternalChildList', VOID, AbstractMutableList, [AbstractMutableList, MutableObservableList]);
  initMetadataForCompanion(Companion_265);
  initMetadataForClass(BaseCell$addTrait$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(BaseCell$cellContainer$1, VOID, VOID, VOID, [ReadableProperty]);
  initMetadataForClass(BaseCell$set$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(BaseCell$getProp$MyProperty, 'MyProperty', VOID, BaseReadableProperty, [BaseReadableProperty, Property]);
  initMetadataForClass(CellTrait, 'CellTrait');
  initMetadataForClass(BaseCell$set$trait$1, VOID, VOID, CellTrait);
  initMetadataForInterface(Cell, 'Cell', VOID, VOID, [Composite]);
  initMetadataForInterface(BaseCellInternal, 'BaseCellInternal');
  initMetadataForClass(BaseCell, 'BaseCell', VOID, VOID, [Cell, BaseCellInternal]);
  initMetadataForInterface(CellContainerInternal, 'CellContainerInternal');
  function onBeforeCommand() {
  }
  function onAfterCommand() {
  }
  function onCellPropertyChanged(cell, prop, change) {
  }
  function onChildAdded_1(parent, change) {
  }
  function onChildRemoved_1(parent, change) {
  }
  initMetadataForInterface(CellContainerListener, 'CellContainerListener');
  function scrollTo(rectSupplier, cell) {
    this.tlp(rectSupplier, cell);
  }
  initMetadataForInterface(CellContainerPeer, 'CellContainerPeer', VOID, VOID, VOID, [2]);
  initMetadataForCompanion(Companion_266);
  initMetadataForClass(CellEventContext, 'CellEventContext');
  initMetadataForClass(CellPropertySpec, 'CellPropertySpec');
  initMetadataForObject(Hints, 'Hints');
  initMetadataForClass(LayoutCell, 'LayoutCell', LayoutCell, BaseCell);
  initMetadataForClass(HorizontalCell, 'HorizontalCell', HorizontalCell, LayoutCell);
  initMetadataForCompanion(Companion_267);
  initMetadataForCompanion(Companion_268);
  function get_isLowPriority() {
    return false;
  }
  initMetadataForInterface(PopupSpec, 'PopupSpec');
  initMetadataForCompanion(Companion_269);
  initMetadataForClass(ScrollTrait, 'ScrollTrait', ScrollTrait, CellTrait);
  initMetadataForClass(ScrollPopupSpec, 'ScrollPopupSpec', ScrollPopupSpec, VOID, [PopupSpec]);
  initMetadataForCompanion(Companion_270);
  initMetadataForClass(ScrollCell, 'ScrollCell', ScrollCell, BaseCell);
  initMetadataForClass(Selection, 'Selection');
  initMetadataForCompanion(Companion_271);
  initMetadataForClass(TextCell, 'TextCell', TextCell_init_$Create$, BaseCell);
  initMetadataForCompanion(Companion_272);
  initMetadataForClass(TextPlaceholderCell, 'TextPlaceholderCell', TextPlaceholderCell, BaseCell);
  initMetadataForCompanion(Companion_273);
  initMetadataForClass(VerticalCell, 'VerticalCell', VerticalCell, LayoutCell);
  initMetadataForObject(AmountOfWorkInProgress, 'AmountOfWorkInProgress');
  initMetadataForClass(OurListeners, 'OurListeners', VOID, Listeners);
  initMetadataForObject(AsyncWorkNotifier, 'AsyncWorkNotifier');
  initMetadataForClass(onAsyncWorkDone$1, VOID, VOID, VOID, [AsyncTracker]);
  initMetadataForClass(CellAsyncTracker, 'CellAsyncTracker', VOID, VOID, [AsyncTracker]);
  initMetadataForCompanion(Companion_274);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_8, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(WaitingMapper, 'WaitingMapper', VOID, Mapper);
  initMetadataForClass(TemporaryCell, 'TemporaryCell', TemporaryCell);
  initMetadataForCompanion(Companion_275);
  initMetadataForClass(BaseCellMapper, 'BaseCellMapper', VOID, Mapper);
  initMetadataForClass(CounterSpec, 'CounterSpec');
  initMetadataForObject(CounterUtil, 'CounterUtil');
  initMetadataForCompanion(Companion_276);
  initMetadataForClass(Counters, 'Counters', Counters);
  initMetadataForLambda(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AsyncCompletionSupport$whenCompletionReady$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(AsyncCompletionSupport$launchWithAsyncCompletion$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(AsyncCompletionSupport, 'AsyncCompletionSupport');
  initMetadataForClass(BaseCompletionConfig, 'BaseCompletionConfig', BaseCompletionConfig);
  initMetadataForCompanion(Companion_277);
  initMetadataForLambda(CellCompletionController$initCompletionResult$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(CellCompletionController, 'CellCompletionController');
  initMetadataForObject(Completion, 'Completion');
  initMetadataForCompanion(Companion_278);
  initMetadataForClass(CompletionContentCell, 'CompletionContentCell', VOID, VerticalCell);
  initMetadataForCompanion(Companion_279);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_9, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_10, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$forEventSource$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$eventHandler$1);
  initMetadataForClass(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$docCell$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(CompletionMenu$CompletionMenuModelMapper$initPlaceholders$1$1, VOID, VOID, CellTrait);
  initMetadataForCompanion(Companion_280);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_11, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(CompletionMenu$CompletionItemMapper$registerSynchronizers$1, VOID, VOID, CellTrait);
  initMetadataForClass(CompletionMenu$CompletionItemMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(CompletionMenuCell, 'CompletionMenuCell', VOID, HorizontalCell);
  initMetadataForClass(CompletionMenuSpec, 'CompletionMenuSpec', CompletionMenuSpec, VOID, [PopupSpec]);
  initMetadataForClass(CompletionMenuTrait, 'CompletionMenuTrait', CompletionMenuTrait, CellTrait);
  initMetadataForClass(CompletionMenuModelMapper, 'CompletionMenuModelMapper', VOID, Mapper);
  initMetadataForClass(CompletionItemMapper, 'CompletionItemMapper', VOID, Mapper);
  initMetadataForClass(ColorScheme, 'ColorScheme', ColorScheme);
  initMetadataForClass(ItemColors, 'ItemColors');
  initMetadataForClass(TextColors, 'TextColors');
  initMetadataForClass(CompletionMenu$createCell$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(CompletionMenu, 'CompletionMenu');
  initMetadataForClass(CompletionMode, 'CompletionMode', VOID, Enum);
  initMetadataForClass(CompletionSupport$showSideTransformPopup$1$get$$inlined$specMatcher$1$1);
  initMetadataForClass(BaseCompletionContext, 'BaseCompletionContext', BaseCompletionContext);
  initMetadataForClass(CompletionSupport$showSideTransformPopup$textEditingTrait$1$wrap$1, VOID, VOID, BaseCompletionContext);
  initMetadataForClass(Completer, 'Completer');
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_12, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(CompletionSupport$TRAIT$1, VOID, VOID, CellTrait);
  initMetadataForClass(CompletionSupport$showCompletion$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(CompletionSupport$showCompletion$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(CompletionSupport$showCompletion$$inlined$toDisposable$2, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(CompletionSupport$showCompletion$3, VOID, VOID, CellTrait);
  initMetadataForClass(CompletionSupport$showCompletion$$inlined$toDisposable$3, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(CompletionSupport$showCompletion$$inlined$toDisposable$4, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(CompletionSupport$prefixText$1, VOID, VOID, DerivedProperty);
  initMetadataForInterface(CompletionItem, 'CompletionItem');
  initMetadataForClass(WrapperCompletionItem, 'WrapperCompletionItem', VOID, VOID, [CompletionItem]);
  initMetadataForClass(CompletionSupport$showSideTransformPopup$wrap$1$1, VOID, VOID, WrapperCompletionItem);
  initMetadataForClass(CompositeCellTrait, 'CompositeCellTrait', VOID, CellTrait);
  initMetadataForClass(TextEditingTrait, 'TextEditingTrait', TextEditingTrait, CompositeCellTrait);
  initMetadataForClass(CompletionSupport$showSideTransformPopup$textEditingTrait$1, VOID, VOID, TextEditingTrait);
  initMetadataForObject(CompletionSupport, 'CompletionSupport');
  initMetadataForClass(DefaultCompletionConfig, 'DefaultCompletionConfig', DefaultCompletionConfig, BaseCompletionConfig);
  initMetadataForClass(PopupCompletionEditor$1, VOID, VOID, TextEditingTrait);
  initMetadataForClass(PopupCompletionEditor$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(PopupCompletionEditor, 'PopupCompletionEditor', VOID, VOID, [Disposable]);
  initMetadataForClass(Side_0, 'Side', VOID, Enum);
  initMetadataForClass(Side$LEFT, 'LEFT', VOID, Side_0);
  initMetadataForClass(Side$RIGHT, 'RIGHT', VOID, Side_0);
  initMetadataForClass(SimpleCompletionEditor, 'SimpleCompletionEditor', VOID, VOID, [Disposable]);
  initMetadataForClass(CompletionContext$Companion$MENU$1, VOID, VOID, BaseCompletionContext);
  initMetadataForClass(CompletionContext$Companion$BULK$1, VOID, VOID, BaseCompletionContext);
  initMetadataForClass(CompletionContext$Companion$TOKENIZATION$1, VOID, VOID, BaseCompletionContext);
  initMetadataForCompanion(Companion_281);
  initMetadataForObject(CompletionSupplement, 'CompletionSupplement');
  initMetadataForClass(EMPTY_COMPLETION_SUPPLIER$$inlined$completionSupplier$1);
  initMetadataForClass(toCompletionSupplier$$inlined$completionSupplier$1);
  initMetadataForCompanion(Companion_282);
  initMetadataForClass(CompletionItemSelectionMode, 'CompletionItemSelectionMode', VOID, Enum);
  initMetadataForClass(LoadDirection, 'LoadDirection', VOID, Enum);
  initMetadataForClass(CompletionMenuModel$LoadDirection$DOWN, 'DOWN', VOID, LoadDirection);
  initMetadataForClass(CompletionMenuModel$LoadDirection$UP, 'UP', VOID, LoadDirection);
  initMetadataForClass(CompletionMenuModel$Companion$ITEMS_COMPARATOR$1, VOID, VOID, VOID, [Comparator]);
  initMetadataForClass(MyVisibleItemsUpdater, 'MyVisibleItemsUpdater', VOID, VOID, [Disposable]);
  initMetadataForClass(Builder, 'Builder');
  initMetadataForCompanion(Companion_283);
  initMetadataForClass(CompletionMenuModel, 'CompletionMenuModel', VOID, VOID, [Disposable]);
  initMetadataForClass(Builder_0, 'Builder');
  initMetadataForCompanion(Companion_284);
  initMetadataForClass(CompletionParameters, 'CompletionParameters');
  initMetadataForClass(BaseCompletionItem, 'BaseCompletionItem', VOID, VOID, [CompletionItem]);
  initMetadataForClass(CompletionItemByTextMatcher, 'CompletionItemByTextMatcher', VOID, BaseCompletionItem);
  initMetadataForClass(CompletionItems, 'CompletionItems');
  initMetadataForCompanion(Companion_285);
  function get_items() {
    return emptyList();
  }
  function transform() {
    return new CompletionResultTransformer(this);
  }
  initMetadataForInterface(CompletionResult, 'CompletionResult', VOID, VOID, [EventSource, Disposable]);
  initMetadataForCoroutine($awaitCOROUTINE$0_0, CoroutineImpl);
  initMetadataForClass(CompletionResultChangeEvent, 'CompletionResultChangeEvent');
  initMetadataForObject(CompletionItemsAddedEvent, 'CompletionItemsAddedEvent', VOID, CompletionResultChangeEvent);
  initMetadataForClass(ErrorDuringCompletionItems, 'ErrorDuringCompletionItems', VOID, CompletionResultChangeEvent);
  initMetadataForClass(CompletionResultTransformer$add$1$addHandler$$inlined$eventHandler$1);
  initMetadataForClass(TransformedCompletionResult, 'TransformedCompletionResult', VOID, VOID, [CompletionResult]);
  initMetadataForCompanion(Companion_286);
  initMetadataForClass(CompletionResultTransformer$add$1, VOID, VOID, VOID, [CompletionResult]);
  initMetadataForClass(CompletionResultTransformer$map$transformedCompletionResult$1, VOID, VOID, TransformedCompletionResult);
  initMetadataForClass(CompletionResultTransformer, 'CompletionResultTransformer');
  initMetadataForClass(ReadyCompletionResult, 'ReadyCompletionResult', ReadyCompletionResult, VOID, [CompletionResult]);
  initMetadataForClass(EmptyCompletionResult, 'EmptyCompletionResult', EmptyCompletionResult, ReadyCompletionResult);
  initMetadataForLambda(FlowBasedCompletionResult$completionCollectorJob$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_13, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(FlowBasedCompletionResult$completionCollectorJob$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(FlowBasedCompletionResult, 'FlowBasedCompletionResult', VOID, VOID, [CompletionResult]);
  initMetadataForClass(SimpleCompletionItem, 'SimpleCompletionItem', VOID, BaseCompletionItem);
  initMetadataForClass(SimpleCompletionResult, 'SimpleCompletionResult', VOID, ReadyCompletionResult);
  initMetadataForClass(SimpleCaseSensitiveMatcher, 'SimpleCaseSensitiveMatcher');
  initMetadataForClass(SimpleIgnoreCaseMatcher, 'SimpleIgnoreCaseMatcher');
  initMetadataForClass(CellContainerPeerAdapter, 'CellContainerPeerAdapter', VOID, VOID, [CellContainerPeer], [2]);
  initMetadataForLambda(launch$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_287);
  initMetadataForClass(CellEventSpec, 'CellEventSpec');
  initMetadataForClass(CompletionEvent, 'CompletionEvent', CompletionEvent, Event_0);
  initMetadataForClass(EventPriority, 'EventPriority', VOID, Enum);
  initMetadataForClass(FocusEvent, 'FocusEvent', VOID, Event_0);
  initMetadataForCompanion(Companion_288);
  initMetadataForClass(ImageCell, 'ImageCell', ImageCell, BaseCell);
  initMetadataForClass(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0, 'sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0', VOID, VOID, [ClipboardAdapter, FunctionAdapter]);
  initMetadataForCompanion(Companion_289);
  initMetadataForClass(CellContainerImpl$createFocusedCellProp$1, VOID, VOID, ValueProperty);
  initMetadataForLambda(CellContainerImpl$pasteFromExternalClipboard$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CellContainerImpl, 'CellContainerImpl', CellContainerImpl, VOID, [CellContainerInternal]);
  initMetadataForClass(RootCell, 'RootCell', VOID, BaseCell);
  initMetadataForClass(IndentCell$addListener$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(IndentCell, 'IndentCell', IndentCell, BaseCell);
  initMetadataForClass(NewLineCell, 'NewLineCell', NewLineCell, IndentCell);
  initMetadataForClass(BaseIndentUpdatingListener, 'BaseIndentUpdatingListener');
  initMetadataForClass(IndentUpdater$toEnd$1);
  initMetadataForClass(IndentUpdater$range$1);
  initMetadataForClass(Position$nextLeaves$1$iterator$1);
  initMetadataForClass(Position$nextLeaves$1);
  initMetadataForClass(Position, 'Position');
  initMetadataForObject(AncestorUtil, 'AncestorUtil');
  initMetadataForClass(CellMapperContext, 'CellMapperContext');
  initMetadataForObject(CellMapperUtils, 'CellMapperUtils');
  initMetadataForObject(IndentUtil, 'IndentUtil');
  initMetadataForCompanion(Companion_290);
  function setFontStyle(textCell) {
    textCell.bln(Companion_getInstance_271().els_1, MessageController_getInstance().gmm_1);
    textCell.bln(Companion_getInstance_271().hls_1, 13);
  }
  initMetadataForInterface(MessageView, 'MessageView');
  initMetadataForClass(EmptyView, 'EmptyView', VOID, VOID, [MessageView]);
  initMetadataForClass(Message, 'Message', Message);
  initMetadataForClass(MessageCell$Companion$TRAIT$1, VOID, VOID, CellTrait);
  initMetadataForClass(MessagePopupSpec, 'MessagePopupSpec', MessagePopupSpec, VOID, [PopupSpec]);
  initMetadataForCompanion(Companion_291);
  initMetadataForClass(MessageCell, 'MessageCell', VOID, VerticalCell);
  initMetadataForObject(MessageController, 'MessageController');
  initMetadataForClass(setBackingToDefault$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_292);
  initMetadataForClass(MessagePopupSupport$$inlined$eventHandler$1);
  initMetadataForClass(MessagePopupSupport$$inlined$eventHandler$2);
  initMetadataForClass(MessagePopupSupport$$inlined$eventHandler$3);
  initMetadataForClass(MessagePopupSupport$doSubscribe$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(MessagePopupSupport, 'MessagePopupSupport', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_293);
  initMetadataForClass(MessageStyler$setProp$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(MessageStyler, 'MessageStyler', MessageStyler);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_13, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(MessageTrait$MyHoverController$schedule$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(HoverState, 'HoverState', VOID, Enum);
  initMetadataForClass(MyHoverController, 'MyHoverController');
  initMetadataForCompanion(Companion_294);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_14, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(MessageTrait, 'MessageTrait', VOID, CellTrait);
  initMetadataForClass(MessageViewWithLink, 'MessageViewWithLink', VOID, VOID, [MessageView]);
  initMetadataForClass(SimpleMessageView, 'SimpleMessageView', VOID, VOID, [MessageView]);
  initMetadataForCompanion(Companion_295);
  initMetadataForClass(StyleApplicator, 'StyleApplicator');
  initMetadataForClass(Metrics, 'Metrics', Metrics);
  initMetadataForClass(Line, 'Line');
  initMetadataForClass(WordWrapper$iterator$1);
  initMetadataForClass(WordWrapper, 'WordWrapper');
  initMetadataForClass(BasePopupManager, 'BasePopupManager', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_296);
  initMetadataForClass(ConsumeMouseButtonTrait, 'ConsumeMouseButtonTrait', VOID, CellTrait);
  initMetadataForClass(Context_2, 'Context');
  initMetadataForCompanion(Companion_297);
  initMetadataForClass(PopupPositionUpdater, 'PopupPositionUpdater');
  initMetadataForClass(DefaultPositionHandler, 'DefaultPositionHandler');
  initMetadataForClass(CellDefaultPositionHandler, 'CellDefaultPositionHandler', VOID, DefaultPositionHandler);
  initMetadataForClass(DefaultPositionHandler$caretOffset$1, VOID, VOID, VOID, [Property]);
  initMetadataForClass(NewLineCellPositionHandler, 'NewLineCellPositionHandler', VOID, DefaultPositionHandler);
  initMetadataForClass(SetPositionResult, 'SetPositionResult');
  initMetadataForCompanion(Companion_298);
  initMetadataForObject(Positions, 'Positions');
  initMetadataForClass(TextPositionHandler$caretOffset$derivedOffset$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(TextPositionHandler$caretOffset$1, VOID, VOID, VOID, [Property]);
  initMetadataForClass(TextPositionHandler, 'TextPositionHandler');
  initMetadataForClass(InputMethodEditorUtil$showComposite$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(InputMethodEditorUtil, 'InputMethodEditorUtil');
  initMetadataForInterface(CellStateHandler, 'CellStateHandler');
  initMetadataForClass(TextEditorStateHandler, 'TextEditorStateHandler', VOID, VOID, [CellStateHandler]);
  initMetadataForClass(STATE_HANDLER$1, VOID, VOID, TextEditorStateHandler);
  initMetadataForClass(STATE_HANDLER_WITH_VALID$1, VOID, VOID, TextEditorStateHandler);
  initMetadataForClass(TextCopyTrait, 'TextCopyTrait', TextCopyTrait, CellTrait);
  initMetadataForClass(TextCopyPasteTrait, 'TextCopyPasteTrait', VOID, TextCopyTrait);
  initMetadataForClass(DerivedCellTrait, 'DerivedCellTrait', VOID, CellTrait);
  initMetadataForClass(BaseDerivedCellTrait, 'BaseDerivedCellTrait', VOID, DerivedCellTrait);
  initMetadataForClass(TextEditing$TEXT_NAVIGATION_TRAIT$1, VOID, VOID, BaseDerivedCellTrait);
  initMetadataForClass(TextEditing$TEXT_EDITING_TRAIT$1, VOID, VOID, BaseDerivedCellTrait);
  initMetadataForClass(TextEditing$textNavigation$1, VOID, VOID, DerivedCellTrait);
  initMetadataForClass(TextEditing$textNavigation$2, VOID, VOID, DerivedCellTrait);
  initMetadataForClass(TextEditing$validTextEditing$2, VOID, VOID, DerivedCellTrait);
  initMetadataForClass(TextEditing$adaptMultilinePaste$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForObject(TextEditing, 'TextEditing');
  initMetadataForClass(CopyPasteTrait, 'CopyPasteTrait', VOID, TextCopyPasteTrait);
  initMetadataForClass(TextCellStateBeforeCompletion, 'TextCellStateBeforeCompletion');
  initMetadataForCompanion(Companion_299);
  initMetadataForLambda(TextEditingTrait$onComplete$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TextEditorCellState, 'TextEditorCellState');
  initMetadataForObject(TextEditorUtil, 'TextEditorUtil');
  initMetadataForClass(Selection_0, 'Selection');
  initMetadataForCompanion(Companion_300);
  initMetadataForClass(TextNavigationTrait, 'TextNavigationTrait', TextNavigationTrait, CellTrait);
  initMetadataForCompanion(Companion_301);
  initMetadataForClass(ValidTextEditingTrait$validate$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForLambda(ValidTextEditingTrait$onAfterTextAdded$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ValidTextEditingTrait, 'ValidTextEditingTrait', ValidTextEditingTrait, TextEditingTrait);
  initMetadataForObject(ValidTextEditingTraitSpecs, 'ValidTextEditingTraitSpecs');
  initMetadataForClass(CellTrait$Companion$EMPTY$1, VOID, VOID, CellTrait);
  initMetadataForCompanion(Companion_302);
  initMetadataForClass(CellTraitEventSpec, 'CellTraitEventSpec');
  initMetadataForClass(CellTraitPropertySpec, 'CellTraitPropertySpec');
  initMetadataForClass(CellTraits$captureTo$rootReg$1, VOID, VOID, CellTrait);
  initMetadataForClass(CellTraits$captureTo$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(CellTraits, 'CellTraits');
  initMetadataForClass(CompositeCellTraits$forConstant$1, VOID, VOID, CompositeCellTrait);
  initMetadataForObject(CompositeCellTraits, 'CompositeCellTraits');
  initMetadataForClass(SpecMatchResult, 'SpecMatchResult');
  initMetadataForClass(CellAttachWatcher, 'CellAttachWatcher', VOID, VOID, [CellContainerListener]);
  initMetadataForCompanion(Companion_303);
  initMetadataForClass(TraitController, 'TraitController', VOID, CellAttachWatcher, [CellAttachWatcher, Disposable]);
  initMetadataForObject(CellFactory, 'CellFactory');
  initMetadataForClass(CellVisibleTree, 'CellVisibleTree', VOID, VOID, [Composite]);
  initMetadataForObject(Cells, 'Cells');
  initMetadataForClass(whenAttached$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(SeparatedList, 'SeparatedList', VOID, AbstractMutableList);
  initMetadataForClass(SeparatedCellList, 'SeparatedCellList', VOID, SeparatedList);
  initMetadataForClass(CellLists$separated$$inlined$separated$1, VOID, VOID, SeparatedCellList);
  initMetadataForClass(CellLists$newLineSeparated$$inlined$separated$1, VOID, VOID, SeparatedCellList);
  initMetadataForClass(CellLists$verticallySpaced$$inlined$separated$1, VOID, VOID, SeparatedCellList);
  initMetadataForObject(CellLists, 'CellLists');
  initMetadataForCompanion(Companion_304);
  initMetadataForClass(CellStateDifference, 'CellStateDifference', VOID, Enum);
  initMetadataForCompanion(Companion_305);
  initMetadataForCompanion(Companion_306);
  initMetadataForClass(DerivedVisibilityEvent, 'DerivedVisibilityEvent', VOID, Event_0);
  initMetadataForClass(DisambiguationCellSupport, 'DisambiguationCellSupport', VOID, CellTrait);
  initMetadataForClass(DisambiguationCellSupport$Companion$invoke$1, VOID, VOID, DisambiguationCellSupport);
  initMetadataForClass(DisambiguationCell, 'DisambiguationCell', VOID, HorizontalCell);
  initMetadataForClass(OutermostLeafCellFocusListener, 'OutermostLeafCellFocusListener', OutermostLeafCellFocusListener);
  initMetadataForClass(MyFocusListener, 'MyFocusListener', VOID, OutermostLeafCellFocusListener);
  initMetadataForClass(DisambiguationCellTrait, 'DisambiguationCellTrait', VOID, CellTrait);
  initMetadataForCompanion(Companion_307);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_15, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_16, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForObject(EffectiveVisibilityTrackingTrait, 'EffectiveVisibilityTrackingTrait', VOID, CellTrait);
  initMetadataForClass(ExtraCell, 'ExtraCell', VOID, TextCell);
  initMetadataForClass(ExtraCellTrait, 'ExtraCellTrait', VOID, CompositeCellTrait);
  initMetadataForClass(FocusTrait, 'FocusTrait', VOID, CellTrait);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_17, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(LastCaretPositionSupport$onPropertyChanged$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(LastCaretPositionSupport, 'LastCaretPositionSupport', VOID, CompositeCellTrait);
  initMetadataForClass(Side_1, 'Side', VOID, Enum);
  initMetadataForClass(LeafCellTrackingTrait$Side$LEFT, 'LEFT', VOID, Side_1);
  initMetadataForClass(LeafCellTrackingTrait$Side$RIGHT, 'RIGHT', VOID, Side_1);
  initMetadataForObject(LeafCellTrackingTrait, 'LeafCellTrackingTrait', VOID, CellTrait);
  initMetadataForCompanion(Companion_308);
  initMetadataForCompanion(Companion_309);
  initMetadataForClass(OutermostLeafCellTracker, 'OutermostLeafCellTracker', VOID, CellTrait);
  initMetadataForClass(CellSides, 'CellSides', VOID, Enum);
  initMetadataForObject(OutermostLeafTrackers, 'OutermostLeafTrackers');
  initMetadataForClass(attachToPlaceholder$1, VOID, VOID, CellTrait);
  initMetadataForClass(attachToPlaceholder$2, VOID, VOID, CellTrait);
  initMetadataForClass(CellScope, 'CellScope');
  initMetadataForClass(FocusableCellScope, 'FocusableCellScope', VOID, CellScope);
  initMetadataForObject(CellScopes, 'CellScopes');
  initMetadataForClass(TargetBuilder, 'TargetBuilder');
  initMetadataForObject(CellScrolling, 'CellScrolling');
  initMetadataForClass(Builder_1, 'Builder');
  initMetadataForCompanion(Companion_310);
  initMetadataForClass(ScrollingParameters, 'ScrollingParameters');
  initMetadataForObject(ScrollingUtil, 'ScrollingUtil');
  initMetadataForObject(Snapping, 'Snapping');
  initMetadataForObject(SnappingHome, 'SnappingHome');
  initMetadataForClass(OneAxisSnapping, 'OneAxisSnapping');
  initMetadataForClass(Builder_2, 'Builder');
  initMetadataForCompanion(Companion_311);
  initMetadataForClass(SnappingParameters, 'SnappingParameters');
  initMetadataForCompanion(Companion_312);
  initMetadataForClass(URLCellTrait, 'URLCellTrait', VOID, CellTrait);
  initMetadataForClass(ValueEditors$getEnumValidatedProperty$1$matchers$$inlined$specMatcher$1$1, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(ValueEditors$booleanProperty$1$get$$inlined$specMatcher$1$1, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(ValueEditors$booleanProperty$1$get$$inlined$specMatcher$1$2, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(ValueEditors$getEnumValidatedProperty$trait$1, VOID, VOID, BaseDerivedCellTrait);
  initMetadataForClass(ValueEditors$booleanProperty$trait$1, VOID, VOID, BaseDerivedCellTrait);
  initMetadataForObject(ValueEditors, 'ValueEditors');
  initMetadataForClass(ViewCell, 'ViewCell', VOID, BaseCell);
  initMetadataForInterface(ToCellMapping, 'ToCellMapping');
  initMetadataForClass(getMapperCellFinder$1);
  initMetadataForCompanion(Companion_313);
  initMetadataForClass(MapperCellProvider, 'MapperCellProvider');
  initMetadataForClass(FocusedCellHandler, 'FocusedCellHandler', FocusedCellHandler, VOID, [Disposable]);
  initMetadataForClass(PageUpDown, 'PageUpDown');
  initMetadataForCompanion(Companion_314);
  initMetadataForClass(CellNavigationController$install$3, VOID, VOID, CellTrait);
  initMetadataForClass(CellNavigationController$handleKeyPress$pageUpDown$1, VOID, VOID, PageUpDown);
  initMetadataForClass(CellNavigationController$handleKeyPress$pageUpDown$2, VOID, VOID, PageUpDown);
  initMetadataForClass(UpDown, 'UpDown');
  initMetadataForClass(CellNavigationController$upperClosest$upDown$1, VOID, VOID, UpDown);
  initMetadataForClass(CellNavigationController$lowerClosest$upDown$1, VOID, VOID, UpDown);
  initMetadataForClass(CellNavigationController, 'CellNavigationController');
  initMetadataForClass(HighlightUtil$highlightFocused$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(HighlightUtil, 'HighlightUtil');
  initMetadataForObject(MatchingConstructs, 'MatchingConstructs');
  initMetadataForObject(PairUtil, 'PairUtil');
  initMetadataForCompanion(Companion_315);
  initMetadataForObject(RootController, 'RootController');
  initMetadataForClass(InstallRootResult, 'InstallRootResult');
  initMetadataForLambda(BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1$get$matchers$1);
  initMetadataForClass(BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1, VOID, VOID, BaseDerivedCellTrait);
  initMetadataForClass(RoleSynchronizerCopyTrait, 'RoleSynchronizerCopyTrait', VOID, CellTrait);
  initMetadataForClass(RoleSynchronizerCopyPasteTrait, 'RoleSynchronizerCopyPasteTrait', VOID, RoleSynchronizerCopyTrait);
  initMetadataForClass(CopyPasteTrait_0, 'CopyPasteTrait', VOID, RoleSynchronizerCopyPasteTrait);
  initMetadataForClass(TargetCellTrait, 'TargetCellTrait', VOID, BaseDerivedCellTrait);
  initMetadataForClass(TargetCellList, 'TargetCellList', VOID, AbstractMutableList);
  initMetadataForClass(SourceList, 'SourceList', VOID, AbstractList);
  initMetadataForClass(SelectionCaptureTrait, 'SelectionCaptureTrait', VOID, BaseDerivedCellTrait);
  initMetadataForClass(BaseProjectionalSynchronizer$attach$3);
  initMetadataForClass(BaseProjectionalSynchronizer, 'BaseProjectionalSynchronizer', VOID, VOID, [Synchronizer]);
  initMetadataForClass(CollectionEditor, 'CollectionEditor');
  initMetadataForClass(DefaultProjectionalItemHandler, 'DefaultProjectionalItemHandler');
  initMetadataForClass(NewItemOnly, 'NewItemOnly', VOID, DefaultProjectionalItemHandler);
  initMetadataForCompanion(Companion_316);
  initMetadataForClass(DeleteHandler$Companion$EMPTY$1);
  initMetadataForCompanion(Companion_317);
  initMetadataForObject(JoinChildrenEvent, 'JoinChildrenEvent');
  initMetadataForInterface(CreateNewElementHandle, 'CreateNewElementHandle');
  initMetadataForClass(ProjectionalSynchronizerSettings, 'ProjectionalSynchronizerSettings');
  initMetadataForClass(ProjectionalListSynchronizerSettings, 'ProjectionalListSynchronizerSettings', ProjectionalListSynchronizerSettings, ProjectionalSynchronizerSettings);
  initMetadataForClass(DefaultCreateNewItemCellTrait, 'DefaultCreateNewItemCellTrait', VOID, CellTrait);
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0, 'sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0', VOID, VOID, [CreateNewElementHandle, FunctionAdapter]);
  initMetadataForClass(ProjectionalObservableListSynchronizer$currentChildCompletion$role$1);
  initMetadataForClass(ProjectionalObservableListSynchronizer$doRegisterChild$trait$1, VOID, VOID, CompositeCellTrait);
  initMetadataForClass(ProjectionalObservableListSynchronizer$getCollectionEditor$1, VOID, VOID, CollectionEditor);
  initMetadataForClass(ProjectionalObservableListSynchronizer, 'ProjectionalObservableListSynchronizer', VOID, BaseProjectionalSynchronizer);
  initMetadataForClass(ProjectionalPropertySynchronizer$completion$1);
  initMetadataForClass(ProjectionalPropertySynchronizer$doRegisterChild$trait$1, VOID, VOID, DerivedCellTrait);
  initMetadataForClass(ProjectionalPropertySynchronizer, 'ProjectionalPropertySynchronizer', VOID, BaseProjectionalSynchronizer);
  initMetadataForClass(ProjectionalPropertySynchronizerSettings, 'ProjectionalPropertySynchronizerSettings', ProjectionalPropertySynchronizerSettings, ProjectionalSynchronizerSettings);
  initMetadataForObject(ProjectionalSynchronizers, 'ProjectionalSynchronizers');
  initMetadataForClass(ReadOnlyProjectionalSynchronizers$forSingleRole$target$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForObject(ReadOnlyProjectionalSynchronizers, 'ReadOnlyProjectionalSynchronizers');
  initMetadataForCompanion(Companion_318);
  initMetadataForClass(SplitChildEvent, 'SplitChildEvent', VOID, DerivedEvent);
  initMetadataForClass(ClipboardParameters, 'ClipboardParameters');
  function copy$default(sourceItem, preserveMode, $super) {
    preserveMode = preserveMode === VOID ? false : preserveMode;
    return $super === VOID ? this.qni(sourceItem, preserveMode) : $super.qni.call(this, sourceItem, preserveMode);
  }
  function copyList$default(sourceItems, preserveMode, $super) {
    preserveMode = preserveMode === VOID ? false : preserveMode;
    return $super === VOID ? this.rni(sourceItems, preserveMode) : $super.rni.call(this, sourceItems, preserveMode);
  }
  initMetadataForInterface(ClonerSupport, 'ClonerSupport');
  initMetadataForClass(ProjectionalClipboardContent, 'ProjectionalClipboardContent', VOID, VOID, [ClipboardContent]);
  initMetadataForCompanion(Companion_319);
  initMetadataForClass(ProjectionalClipboardContentSerializationAsHtml$deserialize$1, VOID, VOID, VOID, [ClipboardContent]);
  initMetadataForClass(ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1, VOID, VOID, VOID, [Persister]);
  initMetadataForClass(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1, VOID, VOID, VOID, [Persister]);
  initMetadataForClass(ProjectionalClipboardContentSerializationAsHtml, 'ProjectionalClipboardContentSerializationAsHtml');
  initMetadataForInterface(OurClipboardContent, 'OurClipboardContent');
  initMetadataForClass(ProjectionalClipboardHandler$createClipboardContent$1, VOID, VOID, ProjectionalClipboardContent, [ProjectionalClipboardContent, OurClipboardContent]);
  initMetadataForClass(ProjectionalClipboardHandler, 'ProjectionalClipboardHandler');
  initMetadataForInterface(RoleCompletion, 'RoleCompletion');
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0, 'sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0', VOID, VOID, [RoleCompletion, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0, 'sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0', VOID, VOID, [RoleCompletion, FunctionAdapter]);
  initMetadataForClass(NotSupported, 'NotSupported', NotSupported);
  initMetadataForClass(JoinDirection, 'JoinDirection', VOID, Enum);
  initMetadataForClass(BaseSelectionCaptureTrait, 'BaseSelectionCaptureTrait', VOID, CellTrait);
  initMetadataForClass(KeyDirection, 'KeyDirection', VOID, Enum);
  initMetadataForClass(BaseSelectionSpec$KeyDirection$FORWARD, 'FORWARD', VOID, KeyDirection);
  initMetadataForClass(BaseSelectionSpec$KeyDirection$BACKWARD, 'BACKWARD', VOID, KeyDirection);
  initMetadataForClass(KeyboardOperationContext, 'KeyboardOperationContext');
  initMetadataForClass(BaseSelectionSpec$createTargetTrait$1, VOID, VOID, BaseDerivedCellTrait);
  initMetadataForClass(BaseSelectionSpec, 'BaseSelectionSpec', BaseSelectionSpec);
  initMetadataForClass(SelectionCellScope, 'SelectionCellScope', VOID, CellScope);
  initMetadataForClass(BaseSelectionTargetTrait, 'BaseSelectionTargetTrait', VOID, CellTrait);
  initMetadataForClass(CellSelection, 'CellSelection');
  initMetadataForCompanion(Companion_320);
  initMetadataForClass(SelectionBound, 'SelectionBound');
  initMetadataForClass(EditorSelectionBound, 'EditorSelectionBound', VOID, SelectionBound);
  initMetadataForClass(MouseHandleResult, 'MouseHandleResult', VOID, Enum);
  initMetadataForClass(MouseChange, 'MouseChange');
  initMetadataForClass(MouseChangeKind, 'MouseChangeKind', VOID, Enum);
  initMetadataForClass(MouseSelectionHandler, 'MouseSelectionHandler');
  initMetadataForObject(ProjectionalSelection, 'ProjectionalSelection');
  initMetadataForClass(RoleSynchronizerSelectionSupport$1, VOID, VOID, CollectionAdapter);
  initMetadataForClass(RoleSynchronizerSelectionSupport, 'RoleSynchronizerSelectionSupport', VOID, VOID, [Disposable]);
  initMetadataForCompanion(Companion_321);
  initMetadataForClass(SelectionId, 'SelectionId', SelectionId, BaseId);
  initMetadataForCompanion(Companion_322);
  initMetadataForClass(TargetList, 'TargetList', VOID, AbstractList);
  initMetadataForCompanion(Companion_323);
  initMetadataForClass(SelectionSupport, 'SelectionSupport', VOID, VOID, [Disposable]);
  initMetadataForClass(SelectionSupports$selectionSupports$1$iterator$1);
  initMetadataForClass(SelectionSupports$selectionSupports$1);
  initMetadataForObject(SelectionSupports, 'SelectionSupports');
  initMetadataForObject(SelectionUtil, 'SelectionUtil');
  initMetadataForClass(SimpleCellSelection, 'SimpleCellSelection', VOID, CellSelection);
  initMetadataForCompanion(Companion_324);
  initMetadataForClass(SimpleSelectionBound, 'SimpleSelectionBound', VOID, SelectionBound);
  initMetadataForClass(SourceUpdateHandler, 'SourceUpdateHandler');
  initMetadataForCompanion(Companion_325);
  initMetadataForClass(Color, 'Color');
  initMetadataForClass(Font, 'Font');
  initMetadataForCompanion(Companion_326);
  initMetadataForClass(FontFamily, 'FontFamily');
  initMetadataForClass(ImageData, 'ImageData');
  initMetadataForClass(EmptyImageData, 'EmptyImageData', VOID, ImageData);
  initMetadataForCompanion(Companion_327);
  initMetadataForClass(UrlImageData, 'UrlImageData', VOID, ImageData);
  initMetadataForObject(AlignmentProperties, 'AlignmentProperties');
  initMetadataForClass(CustomViewFeatureSpec, 'CustomViewFeatureSpec');
  initMetadataForObject(ExternalPasteContent, 'ExternalPasteContent', VOID, VOID, [ClipboardContent]);
  initMetadataForClass(View, 'View', VOID, VOID, [Composite]);
  initMetadataForClass(GroupView, 'GroupView', GroupView, View);
  initMetadataForClass(HorizontalView, 'HorizontalView', HorizontalView, View);
  initMetadataForClass(ImageView, 'ImageView', VOID, View);
  initMetadataForCompanion(Companion_328);
  initMetadataForClass(LineView, 'LineView', VOID, View);
  initMetadataForCompanion(Companion_329);
  initMetadataForClass(MultiPointView, 'MultiPointView', VOID, View);
  initMetadataForClass(NullViewContainerPeer, 'NullViewContainerPeer', NullViewContainerPeer);
  initMetadataForClass(PolyLineView, 'PolyLineView', VOID, MultiPointView);
  initMetadataForCompanion(Companion_330);
  initMetadataForClass(ScrollView, 'ScrollView', VOID, View);
  initMetadataForCompanion(Companion_331);
  initMetadataForClass(TextView, 'TextView', VOID, View);
  initMetadataForCompanion(Companion_332);
  initMetadataForClass(VerticalView, 'VerticalView', VerticalView, View);
  initMetadataForClass(View$ChildList$1, VOID, VOID, CollectionAdapter);
  function onPropertySet(prop, event) {
  }
  function onViewValidated() {
  }
  function onViewInvalidated() {
  }
  function onViewAttached() {
  }
  function onViewDetached() {
  }
  function onBoundsChanged(change) {
  }
  function onToRootDeltaChanged(change) {
  }
  function onChildAdded_2(event) {
  }
  function onChildRemoved_2(event) {
  }
  function onParentChanged_0(event) {
  }
  initMetadataForInterface(ViewListener, 'ViewListener');
  initMetadataForClass(View$ExternalChildList$addListener$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(View$ExternalChildList$addHandler$1, VOID, VOID, VOID, [CollectionListener]);
  initMetadataForClass(View$getProp$1$addHandler$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(View$customFeatureChange$1$addHandler$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(View$valid$1$addHandler$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(View$toRootDelta$1$addHandler$reg$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(View$toRootDelta$1$addHandler$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(View$boundsProp$1$addHandler$2, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(View$attachEvents$1$addHandler$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(ValidationContext, 'ValidationContext');
  initMetadataForClass(ChildList_1, 'ChildList', VOID, ObservableArrayList);
  initMetadataForClass(ExternalChildList_0, 'ExternalChildList', VOID, AbstractMutableList, [AbstractMutableList, MutableObservableList]);
  initMetadataForClass(ToParentOffsetProperty, 'ToParentOffsetProperty', VOID, DerivedProperty, [DerivedProperty, Property]);
  initMetadataForCompanion(Companion_333);
  initMetadataForClass(View$getProp$1, VOID, VOID, VOID, [Property]);
  initMetadataForClass(View$addListener$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(View$customFeatureChange$1, VOID, VOID, VOID, [EventSource]);
  initMetadataForClass(View$valid$1, VOID, VOID, BaseReadableProperty);
  initMetadataForClass(View$toRootDelta$1, VOID, VOID, BaseReadableProperty);
  initMetadataForClass(View$boundsProp$1, VOID, VOID, BaseReadableProperty);
  initMetadataForClass(View$attachEvents$1, VOID, VOID, VOID, [EventSource]);
  initMetadataForClass(ViewContainer$RootView$1, VOID, VOID, VOID, [ViewListener]);
  initMetadataForClass(RootView, 'RootView', VOID, View);
  initMetadataForClass(FocusedViewProperty, 'FocusedViewProperty', VOID, ValueProperty);
  initMetadataForClass(ViewContainer, 'ViewContainer', ViewContainer);
  function onBeforeCommand_0() {
  }
  function onAfterCommand_0() {
  }
  function onPropertySet_0(view, prop, event) {
  }
  function onChildAdded_3(parent, change) {
  }
  function onChildRemoved_3(parent, change) {
  }
  function onViewAttached_0(view) {
  }
  function onViewDetached_0(view) {
  }
  initMetadataForInterface(ViewContainerListener, 'ViewContainerListener');
  initMetadataForClass(ViewEventSpec, 'ViewEventSpec');
  initMetadataForObject(ViewEvents, 'ViewEvents');
  initMetadataForClass(ViewPropertyKind, 'ViewPropertyKind', VOID, Enum);
  initMetadataForClass(ViewPropertyKind$NONE, 'NONE', VOID, ViewPropertyKind);
  initMetadataForClass(ViewPropertyKind$REPAINT, 'REPAINT', VOID, ViewPropertyKind);
  initMetadataForClass(ViewPropertyKind$RELAYOUT, 'RELAYOUT', VOID, ViewPropertyKind);
  initMetadataForClass(ViewPropertyKind$RELAYOUT_AND_REPAINT, 'RELAYOUT_AND_REPAINT', VOID, ViewPropertyKind);
  initMetadataForClass(ViewPropertyKind$RELAYOUT_PARENT, 'RELAYOUT_PARENT', VOID, ViewPropertyKind);
  initMetadataForClass(ViewPropertySpec, 'ViewPropertySpec');
  initMetadataForCompanion(Companion_334);
  initMetadataForClass(CellToDomCss, 'CellToDomCss', CellToDomCss);
  initMetadataForCompanion(Companion_335);
  initMetadataForClass(DomCell, 'DomCell', VOID, BaseCell);
  initMetadataForClass(AlignmentSynchronizers$bindStyle$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForObject(AlignmentSynchronizers, 'AlignmentSynchronizers');
  initMetadataForCompanion(Companion_336);
  initMetadataForClass(DomPopupManager, 'DomPopupManager', VOID, BasePopupManager);
  initMetadataForClass(BaseCellToDomMapper$createPopupManager$1, VOID, VOID, DomPopupManager);
  initMetadataForClass(BaseCellToDomMapper, 'BaseCellToDomMapper', VOID, BaseCellMapper);
  initMetadataForCompanion(Companion_337);
  initMetadataForClass(CellContainerToDomMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(CellContainerToDomMapper$registerSynchronizers$2, VOID, VOID, VOID, [CellContainerListener]);
  initMetadataForClass(CellContainerToDomMapper$createCellContainerPeer$1, VOID, VOID, VOID, [CellContainerPeer], [2]);
  initMetadataForClass(CellContainerToDomMapper$registerListeners$mouseTranslator$1, VOID, VOID, MouseTranslator);
  initMetadataForClass(CellContainerToDomMapper$registerListeners$1);
  initMetadataForClass(CellContainerToDomMapper, 'CellContainerToDomMapper', VOID, Mapper);
  initMetadataForCompanion(Companion_338);
  initMetadataForClass(CellMapperRefresher$registerHideable$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(CellMapperRefresher, 'CellMapperRefresher');
  initMetadataForObject(CellMappers, 'CellMappers');
  initMetadataForClass(CellToDomConfig, 'CellToDomConfig', CellToDomConfig);
  initMetadataForClass(CellToDomContext, 'CellToDomContext', VOID, CellMapperContext, [CellMapperContext, Disposable]);
  initMetadataForClass(DefaultCellMapper, 'DefaultCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(HighlightLayout, 'HighlightLayout');
  initMetadataForCompanion(Companion_339);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_18, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_19, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_20, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(DefaultLineHighlight, 'DefaultLineHighlight', VOID, VOID, [Disposable]);
  initMetadataForClass(DomCellMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(DomCellMapper$registerSynchronizers$2, VOID, VOID, CellTrait);
  initMetadataForClass(DomCellMapper, 'DomCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(UpdatePositionTask, 'UpdatePositionTask');
  initMetadataForCompanion(Companion_340);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_21, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(DomPopupManager$setPopupUpdate$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(DomProperties, 'DomProperties');
  initMetadataForClass(DomTextInput, 'DomTextInput', VOID, VOID, [Disposable]);
  initMetadataForClass(EmptyLineHighlight, 'EmptyLineHighlight', EmptyLineHighlight, VOID, [Disposable]);
  initMetadataForObject(HiddenTextAreaHelper, 'HiddenTextAreaHelper');
  initMetadataForClass(HorizontalCellMapper, 'HorizontalCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForCompanion(Companion_341);
  initMetadataForClass(ImageCellMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(ImageCellMapper, 'ImageCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(IndentRootCellMapper$2$wrap$1);
  initMetadataForClass(IndentRootCellMapper$2);
  initMetadataForClass(IndentRootCellMapper$1, VOID, VOID, IndentUpdater);
  initMetadataForClass(IndentRootCellMapper$onAttach$1, VOID, VOID, BaseIndentUpdatingListener);
  initMetadataForClass(IndentRootCellMapper$createPopupManager$1, VOID, VOID, DomPopupManager);
  initMetadataForClass(IndentRootCellMapper, 'IndentRootCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForCompanion(Companion_342);
  initMetadataForCompanion(Companion_343);
  initMetadataForClass(PopupPositioner, 'PopupPositioner', VOID, PopupPositionUpdater);
  initMetadataForClass(RootCellMapper, 'RootCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(ScrollCellMapper, 'ScrollCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForCompanion(Companion_344);
  initMetadataForClass(TextCellMapper$refreshProperties$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(TextCellMapper, 'TextCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextPlaceholderCellMapper, 'TextPlaceholderCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(Tooltip$injectCornerStyle$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(Tooltip, 'Tooltip');
  initMetadataForClass(VerticalCellMapper, 'VerticalCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForClass(ViewCellMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(ViewCellMapper, 'ViewCellMapper', VOID, BaseCellToDomMapper);
  initMetadataForCompanion(Companion_345);
  initMetadataForClass(DomTextEditor, 'DomTextEditor');
  initMetadataForClass(DomUtil$scheduleDeferred$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForObject(DomUtil_0, 'DomUtil');
  initMetadataForObject(Scrolling, 'Scrolling');
  initMetadataForClass(TextMetricsCalculator$calculateApprox$1);
  initMetadataForClass(TextMetricsCalculator$calculate$1);
  initMetadataForObject(TextMetricsCalculator, 'TextMetricsCalculator');
  initMetadataForClass(DomView, 'DomView', VOID, View);
  initMetadataForClass(BaseViewMapper$registerSynchronizers$$inlined$forEventSource$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(BaseViewMapper$registerSynchronizers$$inlined$forEventSource$2, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$3, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(BaseViewMapper, 'BaseViewMapper', VOID, Mapper);
  initMetadataForClass(CompositeViewMapper, 'CompositeViewMapper', VOID, BaseViewMapper);
  initMetadataForClass(DomViewMapper$registerSynchronizers$$inlined$forEventSource$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(DomViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(DomViewMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(DomViewMapper, 'DomViewMapper', VOID, BaseViewMapper);
  initMetadataForClass(DomViewSynchronizers$boundsSynchronizer$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForObject(DomViewSynchronizers, 'DomViewSynchronizers');
  initMetadataForClass(HorizontalViewMapper, 'HorizontalViewMapper', VOID, BaseViewMapper);
  initMetadataForClass(ImageViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(ImageViewMapper, 'ImageViewMapper', VOID, BaseViewMapper);
  initMetadataForClass(LineViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(LineViewMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(LineViewMapper$registerSynchronizers$$inlined$writableProperty$3, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(LineViewMapper$registerSynchronizers$$inlined$writableProperty$4, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(LineViewMapper, 'LineViewMapper', VOID, BaseViewMapper);
  initMetadataForCompanion(Companion_346);
  initMetadataForClass(MultiPointViewMapper$registerSynchronizers$1, VOID, VOID, VOID, [Synchronizer]);
  initMetadataForClass(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(MultiPointViewMapper, 'MultiPointViewMapper', VOID, BaseViewMapper);
  initMetadataForClass(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(ScrollViewMapper, 'ScrollViewMapper', VOID, CompositeViewMapper);
  initMetadataForObject(SvgUtil, 'SvgUtil');
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$2, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$3, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$4, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$5, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$6, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$7, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$8, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$9, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$10, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper$registerSynchronizers$$inlined$writableProperty$11, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(TextViewMapper, 'TextViewMapper', VOID, BaseViewMapper);
  initMetadataForClass(VerticalViewMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(VerticalViewMapper, 'VerticalViewMapper', VOID, CompositeViewMapper);
  initMetadataForClass(ViewContainerToElementMapper$viewToDomContext$1);
  initMetadataForClass(ViewContainerToElementMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(ViewContainerToElementMapper$registerListeners$mouseTranslator$1, VOID, VOID, MouseTranslator);
  initMetadataForClass(ViewContainerToElementMapper$onAttach$1);
  initMetadataForClass(ViewContainerToElementMapper, 'ViewContainerToElementMapper', VOID, Mapper);
  initMetadataForObject(ViewMapperFactory, 'ViewMapperFactory');
  initMetadataForObject(ViewToDom, 'ViewToDom');
  initMetadataForCompanion(Companion_347);
  initMetadataForClass(CellContainerState, 'CellContainerState', VOID, VOID, [OtAware]);
  initMetadataForClass(CellOperation, 'CellOperation', VOID, BaseOperation);
  initMetadataForCompanion(Companion_348);
  initMetadataForClass(CellPath, 'CellPath');
  initMetadataForClass(CellStateAfterExternalOpRestorer, 'CellStateAfterExternalOpRestorer', VOID, VOID, [OtCommandListener]);
  initMetadataForClass(CellStateManager$1, VOID, VOID, VOID, [CellContainerListener]);
  initMetadataForClass(CellStateManager, 'CellStateManager', VOID, VOID, [Disposable]);
  initMetadataForClass(CellStateOperation, 'CellStateOperation', VOID, CellOperation);
  initMetadataForClass(ModelOperationSupplier, 'ModelOperationSupplier');
  initMetadataForClass(DefaultOperationProvider, 'DefaultOperationProvider');
  initMetadataForClass(FocusOperation, 'FocusOperation', VOID, CellOperation);
  initMetadataForClass(MyStack, 'MyStack');
  initMetadataForClass(NavigationManager$1, VOID, VOID, CellTrait);
  initMetadataForClass(NavigationManager$2, VOID, VOID, VOID, [OtCommandListener]);
  initMetadataForClass(NavigationManager, 'NavigationManager', VOID, VOID, [Disposable]);
  initMetadataForClass(NodeCellState$restore$1, VOID, VOID, OperationCondition);
  initMetadataForClass(NodeCellState, 'NodeCellState');
  initMetadataForClass(NonChildNodeOperation, 'NonChildNodeOperation', VOID, CellOperation, [CellOperation, HasOperationTargetData]);
  initMetadataForClass(UndoTrait, 'UndoTrait', VOID, CellTrait);
  initMetadataForClass(CellContainerCommandWatcher, 'CellContainerCommandWatcher', VOID, VOID, [CellContainerListener, Disposable]);
  initMetadataForCompanion(Companion_349);
  initMetadataForClass(OtSupport, 'OtSupport', VOID, VOID, [Disposable]);
  initMetadataForClass(OtViewStateProvider, 'OtViewStateProvider', OtViewStateProvider, VOID, [ViewStateProvider]);
  initMetadataForClass(SimpleUndoStateHandler, 'SimpleUndoStateHandler', SimpleUndoStateHandler);
  initMetadataForInterface(TransformableCellState, 'TransformableCellState');
  initMetadataForClass(ActionKind, 'ActionKind', VOID, Enum);
  initMetadataForCompanion(Companion_350);
  function getNode$default(cell, predicate, $super) {
    var tmp;
    if (predicate === VOID) {
      tmp = NodeCellProvider$getNode$lambda;
    } else {
      tmp = predicate;
    }
    predicate = tmp;
    return $super === VOID ? this.zow(cell, predicate) : $super.zow.call(this, cell, predicate);
  }
  initMetadataForInterface(NodeCellProvider, 'NodeCellProvider');
  initMetadataForClass(NodeWrapperCellProvider$getCells$sourcePath$1);
  initMetadataForClass(NodeWrapperCellProvider, 'NodeWrapperCellProvider', VOID, VOID, [NodeCellProvider]);
  initMetadataForClass(OtNodeCellProvider$getCells$sourcePath$1);
  initMetadataForClass(OtNodeCellProvider, 'OtNodeCellProvider', VOID, VOID, [NodeCellProvider]);
  initMetadataForClass(OtSupportBuilder, 'OtSupportBuilder', OtSupportBuilder);
  initMetadataForClass(SingleNavigationManager, 'SingleNavigationManager', VOID, NavigationManager);
  initMetadataForClass(HighlightErrorsSynchronizer$trait$1, VOID, VOID, CellTrait);
  initMetadataForClass(HighlightErrorsSynchronizer, 'HighlightErrorsSynchronizer', VOID, VOID, [Synchronizer]);
  initMetadataForCompanion(Companion_351);
  initMetadataForClass(HighlightingMapper, 'HighlightingMapper', VOID, Mapper);
  initMetadataForClass(highlighted$1);
  initMetadataForCompanion(Companion_352);
  initMetadataForClass(ErrorHighlighterBase, 'ErrorHighlighterBase', VOID, Mapper);
  initMetadataForClass(ProjectionalHighlightMapper, 'ProjectionalHighlightMapper', VOID, ErrorHighlighterBase);
  initMetadataForObject(ErrorHighlighterTrait, 'ErrorHighlighterTrait', VOID, CellTrait);
  initMetadataForObject(ErrorHighlightingController, 'ErrorHighlightingController');
  initMetadataForCompanion(Companion_353);
  initMetadataForClass(ErrorSupport$addError$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(ErrorSupport, 'ErrorSupport');
  initMetadataForCompanion(Companion_354);
  initMetadataForClass(MouseTracker, 'MouseTracker', MouseTracker, CellTrait);
  initMetadataForObject(NumberOfMessages, 'NumberOfMessages');
  initMetadataForCompanion(Companion_355);
  initMetadataForClass(ShowCellGroupTrait, 'ShowCellGroupTrait', VOID, CellTrait);
  initMetadataForClass(CheckNodeMapper, 'CheckNodeMapper', VOID, Mapper);
  initMetadataForClass(CheckResultEntry, 'CheckResultEntry');
  initMetadataForCompanion(Companion_356);
  initMetadataForLambda(CheckNodeSynchronizer$prepare$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CheckNodeSynchronizer$run$$inlined$eventHandler$1);
  initMetadataForCoroutine($runCOROUTINE$0, CoroutineImpl);
  initMetadataForClass(CheckNodeSynchronizer, 'CheckNodeSynchronizer', VOID, VOID, [Synchronizer], [1]);
  initMetadataForCompanion(Companion_357);
  initMetadataForClass(ErrorHighlighterBase$registerSynchronizers$1, VOID, VOID, VOID, [Synchronizer]);
  initMetadataForClass(ErrorHighlighterBase$registerSynchronizers$$inlined$forEventSource$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1, 'sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0', VOID, VOID, [RoleCompletion, FunctionAdapter]);
  initMetadataForLambda(CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CellAwareCompletionSupplier$asSupplier$$inlined$completionSupplier$1);
  initMetadataForClass(CellAwareCompletionSupplier$invoke$$inlined$eventHandler$1);
  initMetadataForClass(CellAwareCompletionSupplier$createEventHandler$$inlined$eventHandler$1);
  initMetadataForClass(CellAwareCompletionSupplier, 'CellAwareCompletionSupplier');
  initMetadataForClass(CompletionItemKindProvider, 'CompletionItemKindProvider', CompletionItemKindProvider);
  initMetadataForClass(CompletionBuilder, 'CompletionBuilder', VOID, CompletionItemKindProvider);
  initMetadataForClass(CompletionBuilderBase$does$1$$inlined$simpleCompletionItem$1, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(CompletionBuilderBase, 'CompletionBuilderBase', VOID, CompletionBuilder);
  initMetadataForLambda(CompletionBuilderImpl$async$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CompletionBuilderImpl$async$1$$inlined$completionSupplier$1);
  initMetadataForClass(CompletionBuilderImpl, 'CompletionBuilderImpl', VOID, CompletionBuilderBase);
  initMetadataForLambda(CoroutineCompletionBuilder$item$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(CoroutineCompletionBuilder$async$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CoroutineCompletionBuilder, 'CoroutineCompletionBuilder', VOID, CompletionBuilderBase);
  initMetadataForClass(CompletionItemKind, 'CompletionItemKind');
  initMetadataForClass(ReferenceKind, 'ReferenceKind', VOID, CompletionItemKind);
  initMetadataForClass(CustomCompletionKind, 'CustomCompletionKind', VOID, CompletionItemKind);
  initMetadataForObject(NumberKind, 'NumberKind', VOID, CompletionItemKind);
  initMetadataForClass(OtherCompletionKind, 'OtherCompletionKind', VOID, CompletionItemKind);
  initMetadataForObject(StringKind, 'StringKind', VOID, CompletionItemKind);
  initMetadataForClass(CompletionOptions, 'CompletionOptions', CompletionOptions);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_14, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(completionResult$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(completionResult$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(NodeCompletionBuilder, 'NodeCompletionBuilder', VOID, CompletionItemKindProvider);
  initMetadataForClass(NodeProducerBuilder, 'NodeProducerBuilder');
  initMetadataForInterface(ActionOnCell, 'ActionOnCell');
  initMetadataForClass(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0, 'sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0', VOID, VOID, [ActionOnCell, FunctionAdapter]);
  initMetadataForClass(Builder_3, 'Builder', VOID, NodeProducerBuilder);
  initMetadataForClass(PrefixBasedCompletionSupplier, 'PrefixBasedCompletionSupplier', VOID, CellAwareCompletionSupplier);
  initMetadataForClass(ReferenceCompletionBase, 'ReferenceCompletionBase', VOID, PrefixBasedCompletionSupplier);
  initMetadataForClass(NodeCompletionBuilderBase$produces$4$referenceCompletion$1, VOID, VOID, ReferenceCompletionBase);
  initMetadataForClass(NodeCompletionBuilderBase, 'NodeCompletionBuilderBase', VOID, NodeCompletionBuilder);
  initMetadataForClass(NodeCompletionBuilderImpl$produces$transformRole$1);
  initMetadataForLambda(NodeCompletionBuilderImpl$async$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(NodeCompletionBuilderImpl, 'NodeCompletionBuilderImpl', VOID, NodeCompletionBuilderBase);
  initMetadataForClass(ReferenceCompletion, 'ReferenceCompletion', VOID, ReferenceCompletionBase);
  initMetadataForLambda(ReferenceCompletionBase$getSortedElements$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$2, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_15, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(ReferenceCompletionBase$getSortedElements$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCompanion(Companion_358);
  initMetadataForClass(SortPriorityRange, 'SortPriorityRange');
  initMetadataForClass(SortedReferenceTargetItem, 'SortedReferenceTargetItem');
  initMetadataForClass(TextMatcherByFilterSettings, 'TextMatcherByFilterSettings');
  initMetadataForClass(completes$$inlined$simpleCompletionItem$1, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(simpleCompletion$1$createRoleCompletion$completionItem$$inlined$simpleCompletionItem$1, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(simpleCompletion$1, VOID, VOID, VOID, [RoleCompletion]);
  initMetadataForClass(intRoleCompletion$1, VOID, VOID, VOID, [RoleCompletion]);
  initMetadataForClass(completionItemForNumber$1, VOID, VOID, BaseCompletionItem);
  initMetadataForClass(completionItemForValidator$1, VOID, VOID, BaseCompletionItem);
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2, 'sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0', VOID, VOID, [RoleCompletion, FunctionAdapter]);
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3, 'sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0', VOID, VOID, [RoleCompletion, FunctionAdapter]);
  initMetadataForClass(map$2_0);
  initMetadataForClass(plus$$inlined$completionSupplier$1);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0, 'sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0', VOID, VOID, [ActionOnCell, FunctionAdapter]);
  initMetadataForClass(editorString$1, VOID, VOID, CustomCompletionKind);
  initMetadataForClass(nodeRefCompletion$1$createRoleCompletion$completionBase$1, VOID, VOID, ReferenceCompletionBase);
  initMetadataForClass(nodeRefCompletion$1, VOID, VOID, VOID, [RoleCompletion]);
  initMetadataForClass(BaseCellBuilder, 'BaseCellBuilder');
  initMetadataForClass(CellBuildResult, 'CellBuildResult');
  function getCell(builder, id) {
    var contextKey = new ContextKey(builder, id);
    return this.ipe(contextKey);
  }
  initMetadataForInterface(CellBuilderContext, 'CellBuilderContext');
  initMetadataForClass(indentLabel$1);
  initMetadataForClass(indentLabel$$inlined$apply$1$3, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(CellBuilderId, 'CellBuilderId', VOID, BaseId);
  initMetadataForClass(rightTransform$1$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(trait$1$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(addTraitOnAttachGeneric$1$sync$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(completion$1$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(completion$2$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(CellCreationResult, 'CellCreationResult');
  initMetadataForClass(CompositeMapperBuilder, 'CompositeMapperBuilder');
  initMetadataForClass(ContextKey, 'ContextKey');
  initMetadataForClass(EditorScope, 'EditorScope', EditorScope);
  initMetadataForClass(LazyMapperBuilder, 'LazyMapperBuilder');
  initMetadataForClass(invalidMapperBuilder$1);
  initMetadataForClass(projectionalChild$2$1$target$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(NamedCellFactory, 'NamedCellFactory');
  function referenceTextProperty$default(placeholderText, validator, property, $super) {
    validator = validator === VOID ? null : validator;
    return $super === VOID ? this.kpg(placeholderText, validator, property) : $super.kpg.call(this, placeholderText, validator, property);
  }
  initMetadataForInterface(ReferenceCellBuilder, 'ReferenceCellBuilder');
  initMetadataForClass(SimpleCellBuilder, 'SimpleCellBuilder', VOID, BaseCellBuilder);
  initMetadataForClass(RootCellBuilderImpl, 'RootCellBuilderImpl');
  initMetadataForClass(SimpleMapperBuilder$build$builderContext$1, VOID, VOID, VOID, [CellBuilderContext]);
  initMetadataForClass(SimpleMapperBuilder$build$1, VOID, VOID, Mapper);
  initMetadataForClass(SimpleMapperBuilder, 'SimpleMapperBuilder');
  initMetadataForClass(SimpleProjectionalRoleSynchronizerBuilder, 'SimpleProjectionalRoleSynchronizerBuilder');
  initMetadataForClass(Mode, 'Mode');
  initMetadataForCompanion(Companion_359);
  initMetadataForClass(Mode_0, 'Mode');
  initMetadataForCompanion(Companion_360);
  initMetadataForClass(spaceDoesntCloseCompletion$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(Side_2, 'Side', VOID, Enum);
  initMetadataForClass(CompoundSideTransformTrait$Side$LEFT, 'LEFT', VOID, Side_2);
  initMetadataForClass(CompoundSideTransformTrait$Side$RIGHT, 'RIGHT', VOID, Side_2);
  initMetadataForObject(CompoundSideTransformTrait, 'CompoundSideTransformTrait', VOID, CellTrait);
  initMetadataForClass(LineMapper$registerSynchronizers$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(LineMapper, 'LineMapper', VOID, Mapper);
  initMetadataForCompanion(Companion_361);
  initMetadataForClass(MultilineSelection, 'MultilineSelection');
  initMetadataForCompanion(Companion_362);
  initMetadataForClass(MultilineTextCell, 'MultilineTextCell', VOID, VerticalCell);
  initMetadataForClass(MultilinePasteOnPlaceholder, 'MultilinePasteOnPlaceholder', VOID, CellTrait);
  initMetadataForClass(CopyCutOnWholeMultilineTextCell, 'CopyCutOnWholeMultilineTextCell', VOID, CellTrait);
  initMetadataForClass(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4, 'sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0', VOID, VOID, [RoleCompletion, FunctionAdapter]);
  initMetadataForClass(MultilineTextSynchronizerFactory$SynchronizerSetup$completion$1$1, VOID, VOID, BaseCompletionItem);
  initMetadataForClass(SynchronizerSetup, 'SynchronizerSetup');
  initMetadataForClass(MultilineTextSynchronizerFactory, 'MultilineTextSynchronizerFactory');
  initMetadataForCompanion(Companion_363);
  initMetadataForClass(Position_0, 'Position', VOID, VOID, [Comparable]);
  initMetadataForClass(PositionHandler, 'PositionHandler', VOID, VOID, [CellStateHandler]);
  initMetadataForClass(SimpleTextPositionHandler, 'SimpleTextPositionHandler', SimpleTextPositionHandler, PositionHandler);
  initMetadataForClass(TextPositionState, 'TextPositionState');
  initMetadataForClass(defaultTextPositionStateHandlerTrait$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForLambda(TextFormatter$breakLongString$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TextFormatter, 'TextFormatter');
  initMetadataForClass(TextCellTrait, 'TextCellTrait', VOID, CellTrait);
  initMetadataForClass(TextMapper, 'TextMapper', VOID, Mapper);
  initMetadataForClass(TextModel, 'TextModel');
  initMetadataForClass(TransformablePositionStateTrait, 'TransformablePositionStateTrait', VOID, CellTrait);
  initMetadataForClass(TransformableTextPositionState, 'TransformableTextPositionState', VOID, TextPositionState, [TextPositionState, TransformableCellState]);
  initMetadataForCompanion(Companion_364);
  initMetadataForClass(TransformableTextPositionStateHandler, 'TransformableTextPositionStateHandler', VOID, PositionHandler);
  initMetadataForClass(ChildBuilder, 'ChildBuilder');
  initMetadataForClass(indentLabel$1$prevIsPlaceholder$1);
  initMetadataForClass(indentLabel$1$$inlined$writableProperty$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(considerEmptyBy$1, VOID, VOID, CellTrait);
  initMetadataForClass(rightTransform$1$$inlined$propertyTrait$1_0, VOID, VOID, CellTrait);
  initMetadataForCompanion(Companion_365);
  initMetadataForClass(CellMark$trait$1, VOID, VOID, CellTrait);
  initMetadataForClass(CellMark, 'CellMark', CellMark);
  initMetadataForClass(Layout, 'Layout', VOID, Enum);
  initMetadataForClass(separatorSideTransform$1$$inlined$propertyFromCellTrait$1, VOID, VOID, CellTrait);
  function createMapper(source) {
    var rootSourceClass = getKClassFromExpression(source);
    return this.xpp(source, rootSourceClass);
  }
  initMetadataForInterface(EditorMapperFactory, 'EditorMapperFactory');
  initMetadataForClass(EditorMapperFactoryImpl, 'EditorMapperFactoryImpl', VOID, VOID, [EditorMapperFactory]);
  initMetadataForClass(attachCompletion$1$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(createOnAttachSynchronizer$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(TextSpecification, 'TextSpecification');
  initMetadataForClass(RoleDefaults, 'RoleDefaults');
  initMetadataForClass(ChildRoleDefaults, 'ChildRoleDefaults', VOID, RoleDefaults);
  initMetadataForClass(ChildrenRoleDefaults, 'ChildrenRoleDefaults', VOID, RoleDefaults);
  initMetadataForClass(RoleEditorDefinition, 'RoleEditorDefinition');
  initMetadataForClass(EditorDefinition, 'EditorDefinition', VOID, RoleEditorDefinition);
  initMetadataForClass(HierarchyEditorDefinition, 'HierarchyEditorDefinition', VOID, RoleEditorDefinition);
  initMetadataForClass(InvalidatingEditorBuilder, 'InvalidatingEditorBuilder', VOID, QueryBuilder, VOID, [0]);
  initMetadataForClass(CollectionSeparator, 'CollectionSeparator');
  initMetadataForClass(StringSeparator, 'StringSeparator', VOID, CollectionSeparator);
  initMetadataForClass(EmptyLinesSeparator, 'EmptyLinesSeparator', EmptyLinesSeparator, CollectionSeparator);
  initMetadataForObject(NewLineSeparator, 'NewLineSeparator', VOID, CollectionSeparator);
  initMetadataForInterface(InternalEditorBuilderConfig, 'InternalEditorBuilderConfig');
  initMetadataForClass(EditorBuilderConfigImpl, 'EditorBuilderConfigImpl', VOID, VOID, [InternalEditorBuilderConfig]);
  initMetadataForCompanion(Companion_366);
  initMetadataForClass(EditorRegistryImpl, 'EditorRegistryImpl');
  initMetadataForClass(BaseRoleSpec, 'BaseRoleSpec');
  initMetadataForClass(ChildRoleSpec, 'ChildRoleSpec', VOID, BaseRoleSpec);
  initMetadataForClass(ChildrenRoleSpec, 'ChildrenRoleSpec', VOID, BaseRoleSpec);
  initMetadataForInterface(InternalEditorBuilder, 'InternalEditorBuilder');
  initMetadataForClass(WaitingMapperFactory, 'WaitingMapperFactory');
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_22, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(BaseEditor$createMapper$triggerContentUpdateSynchronizer$1, VOID, VOID, VOID, [Synchronizer]);
  initMetadataForClass(BaseEditor$createMapperFactory$$inlined$mapperFactory$1);
  initMetadataForClass(RoleEditor, 'RoleEditor');
  initMetadataForClass(BaseEditor, 'BaseEditor', VOID, RoleEditor);
  initMetadataForClass(Editor$getDefaultCompletionSuppliers$$inlined$map$1$getCompletionItems$1, VOID, VOID, SimpleCompletionItem);
  initMetadataForClass(Editor$getDefaultCompletionSuppliers$$inlined$map$1);
  initMetadataForClass(Editor$getCompletionSuppliers$completionSupplier$1);
  initMetadataForClass(Editor, 'Editor', VOID, BaseEditor);
  initMetadataForClass(EditorBuilderMapper, 'EditorBuilderMapper', VOID, Mapper);
  initMetadataForClass(HierarchyRoleEditor$createMapperFactory$$inlined$mapperFactory$1);
  initMetadataForClass(HierarchyRoleEditor, 'HierarchyRoleEditor', VOID, RoleEditor);
  initMetadataForCoroutine($prepareCOROUTINE$3, CoroutineImpl);
  initMetadataForClass(Update, 'Update');
  initMetadataForClass(NodeWrapperReferenceAdapter$afterPaste$1, VOID, VOID, VOID, [Disposable], [0]);
  initMetadataForClass(NodeWrapperReferenceAdapter, 'NodeWrapperReferenceAdapter');
  initMetadataForClass(SimpleEditorBuilder$addKeyPressedHandler$$inlined$keyPressedCellTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(SimpleEditorBuilder$invalidating$1, VOID, VOID, InvalidatingEditorBuilder, [InvalidatingEditorBuilder, InternalEditorBuilder], [0]);
  initMetadataForLambda(SimpleEditorBuilder$buildAsync$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(SimpleEditorBuilder, 'SimpleEditorBuilder', VOID, VOID, [InternalEditorBuilder]);
  initMetadataForClass(BaseNodeCloneSupport$copyListNoPreservation$nodeCopier$1, VOID, VOID, NodeCopier);
  initMetadataForClass(BaseNodeCloneSupport, 'BaseNodeCloneSupport', VOID, VOID, [ClonerSupport]);
  initMetadataForCoroutine($runSuspendCOROUTINE$4_0, CoroutineImpl);
  initMetadataForClass(referenceTarget$1$$inlined$mapSuspending$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(referenceTarget$2$$inlined$propertyFromCellTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(referenceTarget$4$focusKeeper$1);
  initMetadataForClass(getReferenceRoleEditor$1$1$1$$inlined$propertyTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(getReferenceRoleEditor$1$2$1, VOID, VOID, VOID, [CellListener]);
  initMetadataForClass(getReferenceRoleEditor$1$2$textProp$1, VOID, VOID, DerivedProperty);
  initMetadataForClass(getCollectionPlaceholderCompletionSupplier$role$1);
  initMetadataForObject(ReferenceCells, 'ReferenceCells');
  initMetadataForCoroutine($runSuspendCOROUTINE$5_1, CoroutineImpl);
  initMetadataForClass(ReferenceTrait$get$1$$inlined$executeSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(ReferenceTrait$get$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(ReferenceTrait, 'ReferenceTrait', VOID, CellTrait);
  initMetadataForLambda(constantReferenceTrait$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(referenceTrait$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(focusGuarded$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(RefCompletionArgs, 'RefCompletionArgs');
  initMetadataForCompanion(Companion_367);
  initMetadataForClass(ReferenceData_0, 'ReferenceData');
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_6, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(connectWithRefSupport$1$1, VOID, VOID, CellTrait);
  initMetadataForLambda(ReferenceSynchronizers$forReferenceTarget$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(ReferenceSynchronizers, 'ReferenceSynchronizers');
  initMetadataForClass(ResolveKind, 'ResolveKind', VOID, Enum);
  initMetadataForClass(referenceOutOfScopeSynchronizer$outOfScopeMessage$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(referenceOutOfScopeSynchronizer$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(highlightReferenceTargetOutOfSync$visual$1, VOID, VOID, VOID, [WritableProperty]);
  initMetadataForClass(FindUsagesViewConfig, 'FindUsagesViewConfig');
  initMetadataForClass(FindUsagesViewConfigImpl, 'FindUsagesViewConfigImpl', VOID, FindUsagesViewConfig);
  initMetadataForClass(FindUsagesViewBuilderImpl, 'FindUsagesViewBuilderImpl', FindUsagesViewBuilderImpl);
  initMetadataForClass(HandlerRegistration, 'HandlerRegistration', VOID, LockFreeLinkedListNode, [LockFreeLinkedListNode, DisposableHandle]);
  initMetadataForClass(Events, 'Events', Events);
  initMetadataForClass(EventDefinition, 'EventDefinition', EventDefinition);
  initMetadataForClass(ContentConvertException, 'ContentConvertException', VOID, Exception);
  initMetadataForClass(JsonConvertException, 'JsonConvertException', VOID, ContentConvertException);
  function register$default(contentType, converter, configuration, $super) {
    var tmp;
    if (configuration === VOID) {
      tmp = Configuration$register$lambda;
    } else {
      tmp = configuration;
    }
    configuration = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.vq2(contentType, converter, configuration);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.vq2.call(this, contentType, converter, configuration);
    }
    return tmp_0;
  }
  initMetadataForInterface(Configuration_0, 'Configuration');
  function serialize_0(contentType, charset, typeInfo, value, $completion) {
    return this.yq2(contentType, charset, typeInfo, value, $completion);
  }
  function serializeNullable(contentType, charset, typeInfo, value, $completion) {
    return this.xq2(contentType, charset, typeInfo, ensureNotNull(value), $completion);
  }
  initMetadataForInterface(ContentConverter, 'ContentConverter', VOID, VOID, VOID, [4, 3]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_16, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(deserialize$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$1_0, CoroutineImpl);
  initMetadataForClass(deserialize$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(deserialize$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($deserializeCOROUTINE$0, CoroutineImpl);
  initMetadataForLambda(HttpClient$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpClient$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($executeCOROUTINE$0_0, CoroutineImpl);
  initMetadataForClass(HttpClient, 'HttpClient', VOID, VOID, [CoroutineScope], [1]);
  initMetadataForClass(HttpClientConfig, 'HttpClientConfig', HttpClientConfig);
  initMetadataForCompanion(Companion_368);
  initMetadataForCoroutine($bodyNullableCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(HttpClientCall, 'HttpClientCall', VOID, VOID, [CoroutineScope], [0, 1]);
  initMetadataForClass(DoubleReceiveException, 'DoubleReceiveException', VOID, IllegalStateException);
  initMetadataForClass(NoTransformationFoundException, 'NoTransformationFoundException', VOID, UnsupportedOperationException);
  initMetadataForClass(SavedHttpCall, 'SavedHttpCall', VOID, HttpClientCall, VOID, [0, 1]);
  function get_coroutineContext() {
    return this.uqa().et();
  }
  initMetadataForInterface(HttpRequest_0, 'HttpRequest', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(SavedHttpRequest, 'SavedHttpRequest', VOID, VOID, [HttpRequest_0]);
  initMetadataForClass(HttpResponse, 'HttpResponse', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(SavedHttpResponse, 'SavedHttpResponse', VOID, HttpResponse);
  initMetadataForCoroutine($saveCOROUTINE$3, CoroutineImpl);
  initMetadataForClass(UnsupportedContentTypeException, 'UnsupportedContentTypeException', VOID, IllegalStateException);
  initMetadataForLambda(ObservableContent$content$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ObservableContent, 'ObservableContent', VOID, ReadChannelContent);
  initMetadataForLambda(HttpClientEngine$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpClientEngine$executeWithinCallContext$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($executeWithinCallContextCOROUTINE$4, CoroutineImpl);
  function get_supportedCapabilities() {
    return emptySet();
  }
  function install(client) {
    var tmp = Phases_getInstance_0().gq8_1;
    client.qq5_1.m8x(tmp, HttpClientEngine$install$slambda_0(client, this, null));
  }
  initMetadataForInterface(HttpClientEngine, 'HttpClientEngine', VOID, VOID, [CoroutineScope], [1]);
  initMetadataForClass(ClientEngineClosedException, 'ClientEngineClosedException', ClientEngineClosedException, IllegalStateException);
  initMetadataForClass(HttpClientEngineBase, 'HttpClientEngineBase', VOID, VOID, [HttpClientEngine], [1]);
  initMetadataForClass(HttpClientEngineConfig, 'HttpClientEngineConfig', HttpClientEngineConfig);
  initMetadataForCompanion(Companion_369);
  initMetadataForClass(KtorCallContextElement, 'KtorCallContextElement', VOID, VOID, [Element_0]);
  initMetadataForInterface(HttpClientPlugin, 'HttpClientPlugin');
  initMetadataForObject(Plugin, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForLambda(BodyProgress$handle$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(BodyProgress$handle$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForClass(BodyProgress, 'BodyProgress');
  initMetadataForClass(ResponseException, 'ResponseException', VOID, IllegalStateException);
  initMetadataForClass(RedirectResponseException, 'RedirectResponseException', VOID, ResponseException);
  initMetadataForClass(ClientRequestException, 'ClientRequestException', VOID, ResponseException);
  initMetadataForClass(ServerResponseException, 'ServerResponseException', VOID, ResponseException);
  initMetadataForLambda(addDefaultResponseValidation$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(defaultTransformers$1$content$1, VOID, VOID, ByteArrayContent_0);
  initMetadataForClass(defaultTransformers$1$content$2, VOID, VOID, ReadChannelContent);
  initMetadataForLambda(defaultTransformers$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(defaultTransformers$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(defaultTransformers$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpCallValidator$Companion$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpCallValidator$Companion$install$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpCallValidator$Companion$install$slambda_3, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Config, 'Config', Config);
  initMetadataForCompanion(Companion_370, VOID, [HttpClientPlugin]);
  initMetadataForCoroutine($validateResponseCOROUTINE$5, CoroutineImpl);
  initMetadataForCoroutine($processExceptionCOROUTINE$6, CoroutineImpl);
  initMetadataForClass(HttpCallValidator, 'HttpCallValidator', VOID, VOID, VOID, [1, 2]);
  initMetadataForClass(ExceptionHandlerWrapper, 'ExceptionHandlerWrapper');
  initMetadataForClass(RequestExceptionHandlerWrapper, 'RequestExceptionHandlerWrapper');
  initMetadataForClass(HttpRequest$1, VOID, VOID, VOID, [HttpRequest_0]);
  initMetadataForLambda(HttpPlainText$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpPlainText$Plugin$install$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Config_0, 'Config', Config_0);
  initMetadataForObject(Plugin_0, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForClass(sam$kotlin_Comparator$0_4, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(HttpPlainText, 'HttpPlainText');
  initMetadataForLambda(HttpRedirect$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($handleCallCOROUTINE$7, CoroutineImpl);
  initMetadataForClass(Config_1, 'Config', Config_1);
  initMetadataForObject(Plugin_1, 'Plugin', VOID, VOID, [HttpClientPlugin], [4]);
  initMetadataForClass(HttpRedirect, 'HttpRedirect');
  initMetadataForLambda(HttpRequestLifecycle$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(Plugin_2, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForClass(HttpRequestLifecycle, 'HttpRequestLifecycle');
  initMetadataForLambda(HttpSend$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($executeCOROUTINE$8, CoroutineImpl);
  initMetadataForClass(Config_2, 'Config', Config_2);
  initMetadataForObject(Plugin_3, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForInterface(Sender, 'Sender', VOID, VOID, VOID, [1]);
  initMetadataForClass(InterceptedSender, 'InterceptedSender', VOID, VOID, [Sender], [1]);
  initMetadataForClass(DefaultSender, 'DefaultSender', VOID, VOID, [Sender], [1]);
  initMetadataForClass(HttpSend, 'HttpSend');
  initMetadataForClass(SendCountExceedException, 'SendCountExceedException', VOID, IllegalStateException);
  initMetadataForCompanion(Companion_371);
  initMetadataForLambda(HttpTimeout$Plugin$install$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(HttpTimeout$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForClass(HttpTimeoutCapabilityConfiguration, 'HttpTimeoutCapabilityConfiguration', HttpTimeoutCapabilityConfiguration_init_$Create$);
  initMetadataForObject(Plugin_4, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForClass(HttpTimeout, 'HttpTimeout');
  initMetadataForClass(HttpRequestTimeoutException, 'HttpRequestTimeoutException', VOID, IOException);
  initMetadataForClass(DelegatedCall, 'DelegatedCall', VOID, HttpClientCall, VOID, [0, 1]);
  initMetadataForClass(DelegatedRequest, 'DelegatedRequest', VOID, VOID, [HttpRequest_0]);
  initMetadataForClass(DelegatedResponse, 'DelegatedResponse', VOID, HttpResponse);
  initMetadataForClass(DefaultClientWebSocketSession, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession, DefaultWebSocketSession], [0, 1]);
  initMetadataForClass(DelegatingClientWebSocketSession, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession], [0, 1]);
  initMetadataForClass(ClientUpgradeContent, 'ClientUpgradeContent', VOID, NoContent, VOID, [1]);
  initMetadataForClass(WebSocketContent, 'WebSocketContent', WebSocketContent, ClientUpgradeContent, VOID, [1]);
  initMetadataForLambda(WebSockets$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(WebSockets$Plugin$install$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Config_3, 'Config', Config_3);
  initMetadataForObject(Plugin_5, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForClass(WebSockets, 'WebSockets');
  initMetadataForObject(WebSocketExtensionsCapability, 'WebSocketExtensionsCapability');
  initMetadataForObject(WebSocketCapability, 'WebSocketCapability');
  initMetadataForClass(WebSocketException, 'WebSocketException', VOID, IllegalStateException);
  initMetadataForCoroutine($webSocketCOROUTINE$9, CoroutineImpl);
  initMetadataForClass(DefaultHttpRequest, 'DefaultHttpRequest', VOID, VOID, [HttpRequest_0]);
  initMetadataForCompanion(Companion_372);
  initMetadataForClass(HttpRequestBuilder, 'HttpRequestBuilder', HttpRequestBuilder);
  initMetadataForClass(HttpRequestData, 'HttpRequestData');
  initMetadataForClass(HttpResponseData, 'HttpResponseData');
  initMetadataForObject(Phases, 'Phases');
  initMetadataForClass(HttpRequestPipeline, 'HttpRequestPipeline', HttpRequestPipeline, Pipeline, VOID, [2]);
  initMetadataForObject(Phases_0, 'Phases');
  initMetadataForClass(HttpSendPipeline, 'HttpSendPipeline', HttpSendPipeline, Pipeline, VOID, [2]);
  initMetadataForClass(DefaultHttpResponse, 'DefaultHttpResponse', VOID, HttpResponse);
  initMetadataForCoroutine($bodyAsTextCOROUTINE$19, CoroutineImpl);
  initMetadataForObject(Phases_1, 'Phases');
  initMetadataForClass(HttpResponsePipeline, 'HttpResponsePipeline', HttpResponsePipeline, Pipeline, VOID, [2]);
  initMetadataForObject(Phases_2, 'Phases');
  initMetadataForClass(HttpReceivePipeline, 'HttpReceivePipeline', HttpReceivePipeline, Pipeline, VOID, [2]);
  initMetadataForClass(HttpResponseContainer, 'HttpResponseContainer');
  initMetadataForLambda(HttpStatement$execute$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($executeCOROUTINE$20, CoroutineImpl);
  initMetadataForCoroutine($executeUnsafeCOROUTINE$21, CoroutineImpl);
  initMetadataForCoroutine($cleanupCOROUTINE$22, CoroutineImpl);
  initMetadataForClass(HttpStatement, 'HttpStatement', VOID, VOID, VOID, [1, 0]);
  initMetadataForLambda(observable$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(HttpResponseReceiveFail, 'HttpResponseReceiveFail');
  initMetadataForObject(EmptyContent, 'EmptyContent', VOID, NoContent);
  initMetadataForObject(Js, 'Js');
  initMetadataForClass(JsClientEngine$createWebSocket$headers_capturingHack$1);
  initMetadataForCoroutine($executeCOROUTINE$23, CoroutineImpl);
  initMetadataForCoroutine($executeWebSocketRequestCOROUTINE$24, CoroutineImpl);
  initMetadataForClass(JsClientEngine, 'JsClientEngine', VOID, HttpClientEngineBase, VOID, [1, 2]);
  initMetadataForClass(JsError, 'JsError', VOID, Error);
  initMetadataForLambda(toRaw$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($toRawCOROUTINE$25, CoroutineImpl);
  initMetadataForLambda(channelFromStream$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(readBodyNode$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(JsWebSocketSession$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(JsWebSocketSession, 'JsWebSocketSession', VOID, VOID, [DefaultWebSocketSession], [0, 1]);
  initMetadataForCompanion(Companion_373);
  initMetadataForObject($serializer_28, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UsageEntryDocumentDto, 'UsageEntryDocumentDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_26});
  initMetadataForCompanion(Companion_374);
  initMetadataForObject($serializer_29, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(FindUsageServiceRequest, 'FindUsageServiceRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_27});
  initMetadataForCompanion(Companion_375);
  initMetadataForObject($serializer_30, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(FindUsageDocumentInfo, 'FindUsageDocumentInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_28});
  initMetadataForClass(FindUsagePageEntry, 'FindUsagePageEntry');
  initMetadataForInterface(FindUsageRequestController, 'FindUsageRequestController', VOID, VOID, [Disposable], [0, 1]);
  initMetadataForCompanion(Companion_376);
  initMetadataForObject($serializer_31, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(FindUsageResultTotals, 'FindUsageResultTotals', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_29});
  initMetadataForClass(FindUsageResultsPaged, 'FindUsageResultsPaged', VOID, VOID, VOID, [0]);
  initMetadataForLambda(createFindUsageResultsPaged$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(createFindUsageResultsPaged$slambda_1, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(createFindUsageResultsPaged$slambda_3, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(createFindUsageResultsPaged$slambda_5, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(createFindUsageNodesPaged$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(createFindUsageNodesPaged$slambda_1, CoroutineImpl, VOID, [0]);
  initMetadataForCoroutine($createFindUsageResultsPagedCOROUTINE$0, CoroutineImpl);
  initMetadataForCompanion(Companion_377, VOID, [SerializerFactory]);
  initMetadataForClass($serializer_32, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Page_2, 'Page', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_377});
  initMetadataForCoroutine($toNextPageCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(Paged$Companion$invoke$1, VOID, VOID, VOID, VOID, [0]);
  initMetadataForCompanion(Companion_378);
  initMetadataForFunctionReference(Paged$total$ref, VOID, VOID, [0]);
  initMetadataForLambda(map$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForCoroutine($nextPageCOROUTINE$2, CoroutineImpl);
  initMetadataForObject(PublishedFindUsageRequestControllerSerializer, 'PublishedFindUsageRequestControllerSerializer', VOID, InstancePublicationSerializer);
  initMetadataForLambda(RemoteFindUsageRequestController$Companion$nextDocuments$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(RemoteFindUsageRequestController$Companion$totals$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCompanion(Companion_379, InstanceDescriptor);
  initMetadataForClass(RemoteFindUsageRequestController, 'RemoteFindUsageRequestController', VOID, VOID, [FindUsageRequestController], [0, 1]);
  initMetadataForLambda(PerformanceMonitoringClient$job$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(PerformanceMonitoringClient, 'PerformanceMonitoringClient');
  initMetadataForClass(MetricKind, 'MetricKind', VOID, Enum);
  initMetadataForCompanion(Companion_380);
  initMetadataForObject($serializer_33, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PerformanceMonitoringMetric, 'PerformanceMonitoringMetric', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_30});
  initMetadataForCompanion(Companion_381);
  initMetadataForObject($serializer_34, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AccessionDto, 'AccessionDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_31});
  initMetadataForCompanion(Companion_382);
  initMetadataForObject($serializer_35, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DraftQueryCoordinates, 'DraftQueryCoordinates', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_32});
  initMetadataForLambda(EditorService$Companion$openDocument$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(EditorService$Companion$findUsages$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(EditorService$Companion$openDraftQuery$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForInterface(EditorService, 'EditorService', VOID, VOID, [CoroutineScope], [1, 2]);
  initMetadataForClass(Remote_0, 'Remote', VOID, VOID, [EditorService, CoroutineScope], [1, 2]);
  initMetadataForCompanion(Companion_383, InstanceDescriptor);
  initMetadataForLambda(EditorServiceClient$openDocument$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$4, CoroutineImpl);
  initMetadataForLambda(EditorServiceClient$openDraftQuery$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$5, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_17, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_18, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(EditorServiceClient$openDocument$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(EditorServiceClient$openDraftQuery$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($findUsagesCOROUTINE$3, CoroutineImpl);
  initMetadataForClass(EditorServiceClient, 'EditorServiceClient', VOID, VOID, VOID, [1, 2]);
  initMetadataForLambda(editorServiceClient$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(createEditorServiceClient$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(WebsocketEditorServiceProvider$client$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(WebsocketEditorServiceProvider$client$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(WebsocketEditorServiceProvider, 'WebsocketEditorServiceProvider', VOID, VOID, [Disposable], [0]);
  initMetadataForCompanion(Companion_384);
  initMetadataForClass(KotlinxSerializer, 'KotlinxSerializer', KotlinxSerializer);
  initMetadataForObject(SerializerInitializer, 'SerializerInitializer');
  initMetadataForCoroutine($runSuspendCOROUTINE$0_3, CoroutineImpl);
  initMetadataForClass(ResolveResult, 'ResolveResult');
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_7, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(BTBCategoriesWatcher$watch$1$$inlined$suspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(BTBCategoriesWatcher, 'BTBCategoriesWatcher');
  initMetadataForInterface(CachingNodeEditor, 'CachingNodeEditor', VOID, VOID, [Disposable], [1]);
  initMetadataForClass(EditorCache, 'EditorCache');
  initMetadataForLambda(CachingNodeEditorImpl$open$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($openCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(NodeEditorBase, 'NodeEditorBase', VOID, VOID, [Disposable], [1]);
  initMetadataForClass(CachingNodeEditorImpl, 'CachingNodeEditorImpl', VOID, NodeEditorBase, [NodeEditorBase, CachingNodeEditor], [1]);
  initMetadataForClass(serializeProjectionalContentKind$1, VOID, VOID, ProjectionalClipboardContentSerializationAsHtml);
  initMetadataForCompanion(Companion_385);
  initMetadataForCoroutine($findUsagesOfCurrentNodeCOROUTINE$2, CoroutineImpl);
  initMetadataForCoroutine($navigateCOROUTINE$3, CoroutineImpl);
  initMetadataForClass(EditorComponent, 'EditorComponent', VOID, VOID, [Disposable], [0]);
  initMetadataForInterface(EditorOpeningMonitoring, 'EditorOpeningMonitoring');
  initMetadataForClass(sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0, 'sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0', VOID, VOID, [EditorOpeningMonitoring, FunctionAdapter]);
  initMetadataForCompanion(Companion_386);
  initMetadataForClass(ByEditorService, 'ByEditorService', VOID, VOID, [EditorOpeningMonitoring]);
  initMetadataForLambda(NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NodeEditorBase$navigate$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NodeEditorBase$singleOpenTask$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_387);
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_8, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForLambda(NodeEditorBase$findUsagesOfCurrentNode$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NodeEditorBase$navigate$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(NodeEditorBase$registerActions$1, VOID, VOID, CellTrait);
  initMetadataForLambda(NodeEditorBase$singleOpenTask$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(NodeEditorBase$doOpen$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($doOpenCOROUTINE$4, CoroutineImpl);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_23, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(NodeSelection, 'NodeSelection', VOID, Enum);
  initMetadataForClass(NodeSelection$CARET, 'CARET', VOID, NodeSelection);
  initMetadataForClass(NodeSelection$BACKGROUND, 'BACKGROUND', VOID, NodeSelection);
  initMetadataForLambda(NonCachingNodeEditor$open$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($doOpenCOROUTINE$5, CoroutineImpl);
  initMetadataForClass(NonCachingNodeEditor, 'NonCachingNodeEditor', VOID, NodeEditorBase, [NodeEditorBase, Disposable], [1]);
  initMetadataForLambda(OneJobRunner$run$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(OneJobRunner$run$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(OneJobRunner, 'OneJobRunner', OneJobRunner, VOID, VOID, [1]);
  initMetadataForObject(URLHandler, 'URLHandler', VOID, URLCellTrait);
  initMetadataForCoroutine($getDocumentContentCOROUTINE$6, CoroutineImpl);
  initMetadataForCoroutine($getReferenceToPaperCOROUTINE$7, CoroutineImpl);
  initMetadataForClass(EditorDocumentsApi, 'EditorDocumentsApi', VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($calculateResolversCOROUTINE$8, CoroutineImpl);
  initMetadataForCoroutine($measureMetricsCOROUTINE$9, CoroutineImpl);
  initMetadataForClass(EditorsApi, 'EditorsApi', VOID, VOID, VOID, [2, 1]);
  initMetadataForCoroutine($getDocumentResolvedCOROUTINE$10, CoroutineImpl);
  initMetadataForCoroutine($getDocumentResolvedCOROUTINE$11, CoroutineImpl);
  initMetadataForClass(ExplorerApi, 'ExplorerApi', VOID, VOID, VOID, [3]);
  initMetadataForCoroutine($getQueryResolvedCOROUTINE$12, CoroutineImpl);
  initMetadataForClass(QueriesApi, 'QueriesApi', VOID, VOID, VOID, [1]);
  initMetadataForClass(EventType_0, 'EventType', EventType_0);
  initMetadataForClass(Event_1, 'Event', Event_1);
  initMetadataForClass(NodePointerEvent, 'NodePointerEvent', VOID, Event_1);
  initMetadataForClass(FindUsagesEvent, 'FindUsagesEvent', VOID, NodePointerEvent);
  initMetadataForClass(CategoryInfo, 'CategoryInfo');
  initMetadataForClass(BTBCategoryEvent, 'BTBCategoryEvent', VOID, Event_1);
  initMetadataForClass(FactSelectionEvent, 'FactSelectionEvent', VOID, Event_1);
  initMetadataForClass(ErrorEvent, 'ErrorEvent', VOID, Event_1);
  initMetadataForClass(BTBCategoryEventKind, 'BTBCategoryEventKind', VOID, Enum);
  initMetadataForClass(NAVIGATE$1, VOID, VOID, EventType_0);
  initMetadataForClass(FIND_USAGES$1, VOID, VOID, EventType_0);
  initMetadataForClass(BTB_CATEGORY_EVENT$1, VOID, VOID, EventType_0);
  initMetadataForClass(FACT_SELECTION_EVENT$1, VOID, VOID, EventType_0);
  initMetadataForClass(ERROR_EVENT$1, VOID, VOID, EventType_0);
  initMetadataForClass(Notifier, 'Notifier', Notifier);
  initMetadataForClass(ExplorableNodeInfo, 'ExplorableNodeInfo', VOID, VOID, [Disposable]);
  initMetadataForClass(EditableNodeInfo, 'EditableNodeInfo', VOID, ExplorableNodeInfo);
  initMetadataForClass(OtDocumentInfo, 'OtDocumentInfo');
  initMetadataForClass(sam$jetbrains_ocelot_base_disposable_Disposable$0_9, 'sam$jetbrains_ocelot_base_disposable_Disposable$0', VOID, VOID, [Disposable, FunctionAdapter]);
  initMetadataForClass(ClientConnection, 'ClientConnection');
  initMetadataForCompanion(Companion_388);
  initMetadataForClass(OtEnvironment$clientConnectionLazy$1$1);
  initMetadataForClass(OtEnvironment, 'OtEnvironment', VOID, VOID, [Disposable], [1]);
  initMetadataForInterface(DocumentSource, 'DocumentSource');
  initMetadataForClass(DocumentSourceDescriptor, 'DocumentSourceDescriptor');
  initMetadataForLambda(DraftQuerySource$load$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DraftQuerySource$load$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DraftQuerySource, 'DraftQuerySource', VOID, VOID, [DocumentSource], [0]);
  initMetadataForLambda(EditedDocumentSource$load$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(EditedDocumentSource$load$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(EditedDocumentSource, 'EditedDocumentSource', VOID, VOID, [DocumentSource], [0]);
  initMetadataForCoroutine($loadSerializedResolvedNodeCOROUTINE$13, CoroutineImpl);
  initMetadataForClass(PrecalculatedResolversDocumentSource, 'PrecalculatedResolversDocumentSource', VOID, VOID, [DocumentSource], [0]);
  initMetadataForClass(EditedOntologyBrowserSource, 'EditedOntologyBrowserSource', VOID, PrecalculatedResolversDocumentSource, VOID, [0]);
  initMetadataForLambda(EditedWorkingCopySource$load$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(EditedWorkingCopySource$load$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(EditedWorkingCopySource, 'EditedWorkingCopySource', VOID, VOID, [DocumentSource], [0]);
  initMetadataForClass(ExploredDocumentSource, 'ExploredDocumentSource', VOID, PrecalculatedResolversDocumentSource, VOID, [0]);
  initMetadataForCoroutine($loadSerializedResolvedNodeCOROUTINE$14, CoroutineImpl);
  initMetadataForClass(ExploredOntologyBrowserSource, 'ExploredOntologyBrowserSource', VOID, PrecalculatedResolversDocumentSource, VOID, [0]);
  initMetadataForClass(HistoryPanelDocumentSource, 'HistoryPanelDocumentSource', VOID, PrecalculatedResolversDocumentSource, VOID, [0]);
  initMetadataForClass(PathEntrySource, 'PathEntrySource', VOID, PrecalculatedResolversDocumentSource, VOID, [0]);
  initMetadataForCoroutine($loadCOROUTINE$15, CoroutineImpl);
  initMetadataForClass(PublishedQuerySource, 'PublishedQuerySource', VOID, PrecalculatedResolversDocumentSource, VOID, [0]);
  initMetadataForClass(UsageEntrySource, 'UsageEntrySource', VOID, VOID, [DocumentSource], [0]);
  initMetadataForClass(BTBUsageDeserializerImpl, 'BTBUsageDeserializerImpl');
  initMetadataForObject(BTBEditor, 'BTBEditor', VOID, EditorScope);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$4$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$4$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$5$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$5$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$6$1$3$1, VOID, VOID, CellTrait);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$6$1$4$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$7$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$7$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$9$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$9$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$11$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$11$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$12$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$12$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$13$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(btbProgramBuilders$$inlined$editor$13$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(factBuilders$$inlined$editor$2$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(factBuilders$$inlined$editor$2$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(factBuilders$$inlined$editor$4$1$1$3$1, VOID, VOID, CellTrait);
  initMetadataForClass(factBuilders$$inlined$editor$4$1$1$4$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$2$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$2$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$2$1$12$1, VOID, VOID, CellTrait);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$2$1$13$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$4$1$4$1, VOID, VOID, CellTrait);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$4$1$5$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$5$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$5$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$6$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$6$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$6$1$11$1, VOID, VOID, CellTrait);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$6$1$12$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$9$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$9$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$10$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$10$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$11$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$11$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$15$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(processLibraryBuilders$$inlined$editor$15$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(queryCommandBuilders$$inlined$editor$4$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(queryCommandBuilders$$inlined$editor$4$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(queryCommandBuilders$$inlined$editor$6$1$3$1$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(queryCommandBuilders$$inlined$editor$7$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(queryCommandBuilders$$inlined$editor$7$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(queryCommandBuilders$$inlined$editor$8$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(queryCommandBuilders$$inlined$editor$8$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForClass(notionTypeBuilders$$inlined$editor$1$1$2$1, VOID, VOID, CellTrait);
  initMetadataForClass(notionTypeBuilders$$inlined$editor$1$1$3$1, VOID, VOID, VOID, [ReferenceCellBuilder]);
  initMetadataForInterface(BTBEditorBuilderConfig, 'BTBEditorBuilderConfig', VOID, VOID, [InternalEditorBuilderConfig]);
  initMetadataForClass(BTBEditorBuilderConfigImpl, 'BTBEditorBuilderConfigImpl', VOID, EditorBuilderConfigImpl, [EditorBuilderConfigImpl, BTBEditorBuilderConfig]);
  initMetadataForInterface(BTBEditorConfiguration, 'BTBEditorConfiguration', VOID, VOID, [CoroutineScope, ErrorCheckConfig]);
  initMetadataForClass(createBTBEditorConfiguration$1, VOID, VOID, VOID, [BTBEditorConfiguration, CoroutineScope, ErrorCheckConfig]);
  initMetadataForClass(BTBEditorUIConfig, 'BTBEditorUIConfig');
  initMetadataForClass(getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1, VOID, VOID, VOID, [CoroutineScope]);
  initMetadataForClass(getEditorBuildersRootMapperFactory$1);
  initMetadataForClass(btbProgramEditors$11$addTraitDeleteRelations$1$$inlined$createDeleteTransformTrait$1$doWork$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(DeleteTransformTrait, 'DeleteTransformTrait', VOID, CellTrait);
  initMetadataForClass(btbProgramEditors$11$addTraitDeleteRelations$1$$inlined$createDeleteTransformTrait$1, VOID, VOID, DeleteTransformTrait);
  initMetadataForLambda(btbProgramEditors$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(btbProgramEditors$lambda$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(btbProgramEditors$25$3$1$3$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(btbProgramEditors$27$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(btbProgramEditors$40$1$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(btbProgramEditors$40$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(setExpressionEditor$1$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(setExpressionEditor$1$$inlined$executeQuery$2, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(sam$jetbrains_ocelot_base_edt_EdtTask$0_24, 'sam$jetbrains_ocelot_base_edt_EdtTask$0', VOID, VOID, [EdtTask, FunctionAdapter]);
  initMetadataForClass(propertyReferenceValueEditor$1$3$doAttach$1$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(propertyReferenceValueEditor$1$3, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(variablesEditor$$inlined$keyPressedCellTrait$1, VOID, VOID, CellTrait);
  initMetadataForCoroutine($runSuspendCOROUTINE$16_1, CoroutineImpl);
  initMetadataForClass(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1, 'sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0', VOID, VOID, [ActionOnCell, FunctionAdapter]);
  initMetadataForClass(measurableValueWithDefaultUnitCompletion$1$$inlined$executeSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForClass(measurableValueWithDefaultUnitCompletion$1$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForLambda(measurableValueWithDefaultUnitCompletion$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(valueWithRelationsRightTransformCell$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForObject(BTBEditorParts, 'BTBEditorParts');
  initMetadataForClass(functionLibraryEditors$5$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(PrefixedURLTrait, 'PrefixedURLTrait', VOID, BaseDerivedCellTrait);
  initMetadataForLambda(addImportFromPubMedAction$lambda$o$onKeyPressed$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(addImportFromPubMedAction$1$1, VOID, VOID, CellTrait);
  initMetadataForClass(QueryLabelEnum, 'QueryLabelEnum', VOID, Enum);
  initMetadataForClass(QueryLabelDeleteTrait$onKeyPressed$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(QueryLabelDeleteTrait, 'QueryLabelDeleteTrait', VOID, CellTrait);
  initMetadataForClass(newFactEditors$7$1$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(newFactEditors$7$1$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$2, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(newFactEditors$7$1$ReplaceWithLeftTrait, 'ReplaceWithLeftTrait', VOID, CellTrait);
  initMetadataForClass(newFactEditors$11$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(queryLabelsCell$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(setQueryLabelRightTransform$1$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(notionLibraryEditors$8$1$1$1$1$$inlined$createDeleteTransformTrait$1, VOID, VOID, DeleteTransformTrait);
  initMetadataForClass(notionLibraryEditors$8$1$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(propertyConstraints$$inlined$apply$1, VOID, VOID, CellTrait);
  initMetadataForClass(propertyConstraints$1$1$$inlined$keyPressedCellTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(propertyConstraints$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(excludingClassExpressionCompletion$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(processLibraryEditors$7$1$2$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(processLibraryEditors$7$1$2$1$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(processLibraryEditors$12$BraceDeleteTrait$onKeyPressed$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(processLibraryEditors$12$BraceDeleteTrait, 'BraceDeleteTrait', VOID, CellTrait);
  initMetadataForLambda(libraryProcessSpecificationEditor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(libraryProcessSpecificationEditor$lambda$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(optionalSpecializedLink$$inlined$forDisposable$1, VOID, VOID, DisposableSynchronizer);
  initMetadataForClass(shouldShowSpecialized$$inlined$query$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(queryCommandEditors$10$3$1$1$$inlined$executeQuery$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForCoroutine($showCustomEditorCOROUTINE$17, CoroutineImpl);
  initMetadataForCoroutine($showCustomCellCOROUTINE$18, CoroutineImpl);
  initMetadataForClass(BTBEditorImplementation, 'BTBEditorImplementation', VOID, Enum);
  initMetadataForClass(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1, VOID, VOID, DeleteTransformTrait);
  initMetadataForCompanion(Companion_389);
  initMetadataForClass(FactSelectionToggle$imageCellTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(FactSelectionToggle$factCellTrait$1, VOID, VOID, CellTrait);
  initMetadataForClass(FactSelectionToggle, 'FactSelectionToggle');
  initMetadataForClass(FactToggleEvent, 'FactToggleEvent', VOID, Event_0);
  initMetadataForClass(NewSingleFactSelected, 'NewSingleFactSelected', VOID, Event_0);
  initMetadataForCompanion(Companion_390);
  initMetadataForClass(FactsClearEvent, 'FactsClearEvent', FactsClearEvent, Event_0);
  initMetadataForClass(FactsSelectionTrait, 'FactsSelectionTrait', VOID, CellTrait);
  initMetadataForClass(BTBDocumentFactSelectionTrait, 'BTBDocumentFactSelectionTrait', VOID, FactsSelectionTrait);
  initMetadataForClass(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1$doWork$1, VOID, VOID, VOID, [Query], [1]);
  initMetadataForClass(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1_0, VOID, VOID, DeleteTransformTrait);
  initMetadataForCoroutine($runSuspendCOROUTINE$19_1, CoroutineImpl);
  initMetadataForClass(targetName$1$$inlined$executeSuspendingQuery$1, VOID, VOID, VOID, VOID, [1]);
  initMetadataForLambda(targetName$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(FindUsagePageEntryAdapter, 'FindUsagePageEntryAdapter');
  initMetadataForLambda(FindUsagePagedAdapter$totalNodes$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(PagedAdapter, 'PagedAdapter');
  initMetadataForClass(FindUsagePagedAdapter, 'FindUsagePagedAdapter', VOID, PagedAdapter);
  initMetadataForClass(HtmlNodeEditorView$attach$$inlined$toDisposable$1, VOID, VOID, VOID, [Disposable]);
  initMetadataForClass(HtmlNodeEditorView, 'HtmlNodeEditorView');
  initMetadataForLambda(NodeEditorAdapter$open$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(NodeEditorAdapter, 'NodeEditorAdapter');
  initMetadataForClass(PageAdapter, 'PageAdapter');
  initMetadataForLambda(PagedAdapter$total$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(PagedAdapter$nextPage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(KotlinxSerializationConverter$serializeNullable$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$2_0, CoroutineImpl);
  initMetadataForLambda(KotlinxSerializationConverter$deserialize$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$3, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_19, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_20, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(KotlinxSerializationConverter$serializeNullable$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(KotlinxSerializationConverter$serializeNullable$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(KotlinxSerializationConverter$deserialize$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(KotlinxSerializationConverter$deserialize$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($serializeNullableCOROUTINE$0, CoroutineImpl);
  initMetadataForCoroutine($deserializeCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(KotlinxSerializationConverter, 'KotlinxSerializationConverter', VOID, VOID, [ContentConverter], [4, 3]);
  initMetadataForClass(ConverterRegistration, 'ConverterRegistration');
  initMetadataForClass(ContentNegotiation$Config$defaultMatcher$1);
  initMetadataForLambda(ContentNegotiation$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(ContentNegotiation$Plugin$install$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Config_4, 'Config', Config_4, VOID, [Configuration_0]);
  initMetadataForObject(Plugin_6, 'Plugin', VOID, VOID, [HttpClientPlugin]);
  initMetadataForCoroutine($convertRequestCOROUTINE$0, CoroutineImpl);
  initMetadataForCoroutine($convertResponseCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(ContentNegotiation, 'ContentNegotiation', VOID, VOID, VOID, [2, 5]);
  initMetadataForClass(ContentConverterException, 'ContentConverterException', VOID, Exception);
  initMetadataForObject(JsonContentTypeMatcher, 'JsonContentTypeMatcher');
  initMetadataForObject(ApiGateway, 'ApiGateway');
  initMetadataForClass(CapturingView, 'CapturingView', CapturingView);
  initMetadataForCoroutine($renderDocumentToDomCOROUTINE$0, CoroutineImpl);
  initMetadataForLambda(EditorEnvironment$monitoringClient$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(EditorEnvironment, 'EditorEnvironment');
  initMetadataForLambda(findUsages$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(EditorEvents, 'EditorEvents');
  initMetadataForClass(EntryPoint, 'EntryPoint', EntryPoint);
  initMetadataForLambda(getHtmlForUsage$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(getHtmlForResolvedNode$slambda, CoroutineImpl, VOID, [1]);
  //endregion
  function CharSequence() {
  }
  function Comparable() {
  }
  function Number_0() {
  }
  function toList(_this__u8e3s4) {
    switch (_this__u8e3s4.length) {
      case 0:
        return emptyList();
      case 1:
        return listOf(_this__u8e3s4[0]);
      default:
        return toMutableList(_this__u8e3s4);
    }
  }
  function withIndex(_this__u8e3s4) {
    return new IndexingIterable(withIndex$lambda(_this__u8e3s4));
  }
  function get_indices(_this__u8e3s4) {
    return new IntRange(0, get_lastIndex(_this__u8e3s4));
  }
  function get_indices_0(_this__u8e3s4) {
    return new IntRange(0, get_lastIndex_0(_this__u8e3s4));
  }
  function indexOf(_this__u8e3s4, element) {
    if (element == null) {
      var inductionVariable = 0;
      var last = _this__u8e3s4.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this__u8e3s4[index] == null) {
            return index;
          }
        }
         while (inductionVariable <= last);
    } else {
      var inductionVariable_0 = 0;
      var last_0 = _this__u8e3s4.length - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals(element, _this__u8e3s4[index_0])) {
            return index_0;
          }
        }
         while (inductionVariable_0 <= last_0);
    }
    return -1;
  }
  function asSequence(_this__u8e3s4) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (_this__u8e3s4.length === 0)
      return emptySequence();
    // Inline function 'kotlin.sequences.Sequence' call
    return new asSequence$$inlined$Sequence$1(_this__u8e3s4);
  }
  function firstOrNull(_this__u8e3s4) {
    var tmp;
    // Inline function 'kotlin.collections.isEmpty' call
    if (_this__u8e3s4.length === 0) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4[0];
    }
    return tmp;
  }
  function lastIndexOf(_this__u8e3s4, element) {
    if (element == null) {
      var inductionVariable = _this__u8e3s4.length - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          if (_this__u8e3s4[index] == null) {
            return index;
          }
        }
         while (0 <= inductionVariable);
    } else {
      var inductionVariable_0 = _this__u8e3s4.length - 1 | 0;
      if (0 <= inductionVariable_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          if (equals(element, _this__u8e3s4[index_0])) {
            return index_0;
          }
        }
         while (0 <= inductionVariable_0);
    }
    return -1;
  }
  function contains_0(_this__u8e3s4, element) {
    return indexOf(_this__u8e3s4, element) >= 0;
  }
  function toSet(_this__u8e3s4) {
    switch (_this__u8e3s4.length) {
      case 0:
        return emptySet();
      case 1:
        return setOf(_this__u8e3s4[0]);
      default:
        return toCollection(_this__u8e3s4, LinkedHashSet_init_$Create$_1(mapCapacity(_this__u8e3s4.length)));
    }
  }
  function toCollection(_this__u8e3s4, destination) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    while (inductionVariable < last) {
      var item = _this__u8e3s4[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      destination.e(item);
    }
    return destination;
  }
  function get_lastIndex(_this__u8e3s4) {
    return _this__u8e3s4.length - 1 | 0;
  }
  function single(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.length) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('Array is empty.');
      case 1:
        tmp = _this__u8e3s4[0];
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('Array has more than one element.');
    }
    return tmp;
  }
  function toMutableList(_this__u8e3s4) {
    return ArrayList_init_$Create$_1(asCollection(_this__u8e3s4));
  }
  function get_lastIndex_0(_this__u8e3s4) {
    return _this__u8e3s4.length - 1 | 0;
  }
  function contains_1(_this__u8e3s4, element) {
    return indexOf_0(_this__u8e3s4, element) >= 0;
  }
  function get_lastIndex_1(_this__u8e3s4) {
    return _this__u8e3s4.length - 1 | 0;
  }
  function contains_2(_this__u8e3s4, element) {
    return indexOf_1(_this__u8e3s4, element) >= 0;
  }
  function contains_3(_this__u8e3s4, element) {
    return indexOf_2(_this__u8e3s4, element) >= 0;
  }
  function contains_4(_this__u8e3s4, element) {
    return indexOf_3(_this__u8e3s4, element) >= 0;
  }
  function joinToString(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    return joinTo(_this__u8e3s4, StringBuilder_init_$Create$_1(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function indexOf_0(_this__u8e3s4, element) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element.equals(_this__u8e3s4[index])) {
          return index;
        }
      }
       while (inductionVariable <= last);
    return -1;
  }
  function indexOf_1(_this__u8e3s4, element) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this__u8e3s4[index]) {
          return index;
        }
      }
       while (inductionVariable <= last);
    return -1;
  }
  function indexOf_2(_this__u8e3s4, element) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this__u8e3s4[index]) {
          return index;
        }
      }
       while (inductionVariable <= last);
    return -1;
  }
  function indexOf_3(_this__u8e3s4, element) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this__u8e3s4[index]) {
          return index;
        }
      }
       while (inductionVariable <= last);
    return -1;
  }
  function joinTo(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    buffer.f(prefix);
    var count = 0;
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    $l$loop: while (inductionVariable < last) {
      var element = _this__u8e3s4[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      count = count + 1 | 0;
      if (count > 1) {
        buffer.f(separator);
      }
      if (limit < 0 || count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$loop;
    }
    if (limit >= 0 && count > limit) {
      buffer.f(truncated);
    }
    buffer.f(postfix);
    return buffer;
  }
  function indexOf_4(_this__u8e3s4, element) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (element === _this__u8e3s4[index]) {
          return index;
        }
      }
       while (inductionVariable <= last);
    return -1;
  }
  function lastIndexOf_0(_this__u8e3s4, element) {
    var inductionVariable = _this__u8e3s4.length - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        if (element.equals(_this__u8e3s4[index])) {
          return index;
        }
      }
       while (0 <= inductionVariable);
    return -1;
  }
  function zip(_this__u8e3s4, other) {
    // Inline function 'kotlin.collections.zip' call
    var tmp0 = _this__u8e3s4.length;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = other.length;
    var size = Math.min(tmp0, b);
    var list = ArrayList_init_$Create$_0(size);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp2 = _this__u8e3s4[i];
        // Inline function 'kotlin.collections.zip.<anonymous>' call
        var t2 = other[i];
        var tmp$ret$1 = to(tmp2, t2);
        list.e(tmp$ret$1);
      }
       while (inductionVariable < size);
    return list;
  }
  function getOrNull(_this__u8e3s4, index) {
    return (0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false) ? _this__u8e3s4[index] : null;
  }
  function withIndex$lambda($this_withIndex) {
    return function () {
      return arrayIterator($this_withIndex);
    };
  }
  function asSequence$$inlined$Sequence$1($this_asSequence) {
    this.j_1 = $this_asSequence;
  }
  protoOf(asSequence$$inlined$Sequence$1).k = function () {
    // Inline function 'kotlin.collections.asSequence.<anonymous>' call
    return arrayIterator(this.j_1);
  };
  function joinToString_0(_this__u8e3s4, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    return joinTo_0(_this__u8e3s4, StringBuilder_init_$Create$_1(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinTo_0(_this__u8e3s4, buffer, separator, prefix, postfix, limit, truncated, transform) {
    separator = separator === VOID ? ', ' : separator;
    prefix = prefix === VOID ? '' : prefix;
    postfix = postfix === VOID ? '' : postfix;
    limit = limit === VOID ? -1 : limit;
    truncated = truncated === VOID ? '...' : truncated;
    transform = transform === VOID ? null : transform;
    buffer.f(prefix);
    var count = 0;
    var _iterator__ex2g4s = _this__u8e3s4.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      count = count + 1 | 0;
      if (count > 1) {
        buffer.f(separator);
      }
      if (limit < 0 || count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$loop;
    }
    if (limit >= 0 && count > limit) {
      buffer.f(truncated);
    }
    buffer.f(postfix);
    return buffer;
  }
  function plus_3(_this__u8e3s4, element) {
    var result = ArrayList_init_$Create$_0(_this__u8e3s4.n() + 1 | 0);
    result.o(_this__u8e3s4);
    result.e(element);
    return result;
  }
  function asSequence_0(_this__u8e3s4) {
    // Inline function 'kotlin.sequences.Sequence' call
    return new asSequence$$inlined$Sequence$1_0(_this__u8e3s4);
  }
  function last(_this__u8e3s4) {
    if (_this__u8e3s4.p())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this__u8e3s4.q(get_lastIndex_2(_this__u8e3s4));
  }
  function first(_this__u8e3s4) {
    if (_this__u8e3s4.p())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this__u8e3s4.q(0);
  }
  function plus_4(_this__u8e3s4, elements) {
    if (isInterface(elements, Collection)) {
      var result = ArrayList_init_$Create$_0(_this__u8e3s4.n() + elements.n() | 0);
      result.o(_this__u8e3s4);
      result.o(elements);
      return result;
    } else {
      var result_0 = ArrayList_init_$Create$_1(_this__u8e3s4);
      addAll_1(result_0, elements);
      return result_0;
    }
  }
  function reversed(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, Collection)) {
      tmp = _this__u8e3s4.n() <= 1;
    } else {
      tmp = false;
    }
    if (tmp)
      return toList_0(_this__u8e3s4);
    var list = toMutableList_0(_this__u8e3s4);
    reverse(list);
    return list;
  }
  function toList_0(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, Collection)) {
      var tmp;
      switch (_this__u8e3s4.n()) {
        case 0:
          tmp = emptyList();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this__u8e3s4, KtList)) {
            tmp_0 = _this__u8e3s4.q(0);
          } else {
            tmp_0 = _this__u8e3s4.k().m();
          }

          tmp = listOf(tmp_0);
          break;
        default:
          tmp = toMutableList_1(_this__u8e3s4);
          break;
      }
      return tmp;
    }
    return optimizeReadOnlyList(toMutableList_0(_this__u8e3s4));
  }
  function drop(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      // Inline function 'kotlin.collections.drop.<anonymous>' call
      var message = 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (n === 0)
      return toList_0(_this__u8e3s4);
    var list;
    if (isInterface(_this__u8e3s4, Collection)) {
      var resultSize = _this__u8e3s4.n() - n | 0;
      if (resultSize <= 0)
        return emptyList();
      if (resultSize === 1)
        return listOf(last_0(_this__u8e3s4));
      list = ArrayList_init_$Create$_0(resultSize);
      if (isInterface(_this__u8e3s4, KtList)) {
        if (isInterface(_this__u8e3s4, RandomAccess)) {
          var inductionVariable = n;
          var last = _this__u8e3s4.n();
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              list.e(_this__u8e3s4.q(index));
            }
             while (inductionVariable < last);
        } else {
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s = _this__u8e3s4.r(n);
          while (_iterator__ex2g4s.l()) {
            var item = _iterator__ex2g4s.m();
            list.e(item);
          }
        }
        return list;
      }
    } else {
      list = ArrayList_init_$Create$();
    }
    var count = 0;
    var _iterator__ex2g4s_0 = _this__u8e3s4.k();
    while (_iterator__ex2g4s_0.l()) {
      var item_0 = _iterator__ex2g4s_0.m();
      if (count >= n)
        list.e(item_0);
      else {
        count = count + 1 | 0;
      }
    }
    return optimizeReadOnlyList(list);
  }
  function dropLast(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      // Inline function 'kotlin.collections.dropLast.<anonymous>' call
      var message = 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return take(_this__u8e3s4, coerceAtLeast(_this__u8e3s4.n() - n | 0, 0));
  }
  function toHashSet(_this__u8e3s4) {
    return toCollection_0(_this__u8e3s4, HashSet_init_$Create$_1(mapCapacity(collectionSizeOrDefault(_this__u8e3s4, 12))));
  }
  function toBooleanArray(_this__u8e3s4) {
    var result = booleanArray(_this__u8e3s4.n());
    var index = 0;
    var _iterator__ex2g4s = _this__u8e3s4.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      result[_unary__edvuaz] = element;
    }
    return result;
  }
  function toSet_0(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, Collection)) {
      var tmp;
      switch (_this__u8e3s4.n()) {
        case 0:
          tmp = emptySet();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this__u8e3s4, KtList)) {
            tmp_0 = _this__u8e3s4.q(0);
          } else {
            tmp_0 = _this__u8e3s4.k().m();
          }

          tmp = setOf(tmp_0);
          break;
        default:
          tmp = toCollection_0(_this__u8e3s4, LinkedHashSet_init_$Create$_1(mapCapacity(_this__u8e3s4.n())));
          break;
      }
      return tmp;
    }
    return optimizeReadOnlySet(toCollection_0(_this__u8e3s4, LinkedHashSet_init_$Create$()));
  }
  function plus_5(_this__u8e3s4, elements) {
    if (isInterface(_this__u8e3s4, Collection))
      return plus_4(_this__u8e3s4, elements);
    var result = ArrayList_init_$Create$();
    addAll_1(result, _this__u8e3s4);
    addAll_1(result, elements);
    return result;
  }
  function firstOrNull_0(_this__u8e3s4) {
    return _this__u8e3s4.p() ? null : _this__u8e3s4.q(0);
  }
  function minus_1(_this__u8e3s4, element) {
    var result = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this__u8e3s4, 10));
    var removed = false;
    // Inline function 'kotlin.collections.filterTo' call
    var _iterator__ex2g4s = _this__u8e3s4.k();
    while (_iterator__ex2g4s.l()) {
      var element_0 = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.minus.<anonymous>' call
      var tmp;
      if (!removed && equals(element_0, element)) {
        removed = true;
        tmp = false;
      } else {
        tmp = true;
      }
      if (tmp) {
        result.e(element_0);
      }
    }
    return result;
  }
  function first_0(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, KtList))
      return first(_this__u8e3s4);
    else {
      var iterator = _this__u8e3s4.k();
      if (!iterator.l())
        throw NoSuchElementException_init_$Create$_0('Collection is empty.');
      return iterator.m();
    }
  }
  function contains_5(_this__u8e3s4, element) {
    if (isInterface(_this__u8e3s4, Collection))
      return _this__u8e3s4.s(element);
    return indexOf_6(_this__u8e3s4, element) >= 0;
  }
  function take(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      // Inline function 'kotlin.collections.take.<anonymous>' call
      var message = 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (n === 0)
      return emptyList();
    if (isInterface(_this__u8e3s4, Collection)) {
      if (n >= _this__u8e3s4.n())
        return toList_0(_this__u8e3s4);
      if (n === 1)
        return listOf(first_0(_this__u8e3s4));
    }
    var count = 0;
    var list = ArrayList_init_$Create$_0(n);
    var _iterator__ex2g4s = _this__u8e3s4.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      list.e(item);
      count = count + 1 | 0;
      if (count === n)
        break $l$loop;
    }
    return optimizeReadOnlyList(list);
  }
  function subtract(_this__u8e3s4, other) {
    var set = toMutableSet(_this__u8e3s4);
    removeAll(set, other);
    return set;
  }
  function singleOrNull(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, KtList))
      return _this__u8e3s4.n() === 1 ? _this__u8e3s4.q(0) : null;
    else {
      var iterator = _this__u8e3s4.k();
      if (!iterator.l())
        return null;
      var single = iterator.m();
      if (iterator.l())
        return null;
      return single;
    }
  }
  function indexOf_5(_this__u8e3s4, element) {
    return _this__u8e3s4.t(element);
  }
  function lastIndexOf_1(_this__u8e3s4, element) {
    return _this__u8e3s4.u(element);
  }
  function sortedWith(_this__u8e3s4, comparator) {
    if (isInterface(_this__u8e3s4, Collection)) {
      if (_this__u8e3s4.n() <= 1)
        return toList_0(_this__u8e3s4);
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp = copyToArray(_this__u8e3s4);
      // Inline function 'kotlin.apply' call
      var this_0 = isArray(tmp) ? tmp : THROW_CCE();
      // Inline function 'kotlin.collections.sortedWith.<anonymous>' call
      sortWith(this_0, comparator);
      return asList(this_0);
    }
    // Inline function 'kotlin.apply' call
    var this_1 = toMutableList_0(_this__u8e3s4);
    // Inline function 'kotlin.collections.sortedWith.<anonymous>' call
    sortWith_0(this_1, comparator);
    return this_1;
  }
  function filterNotNull(_this__u8e3s4) {
    return filterNotNullTo(_this__u8e3s4, ArrayList_init_$Create$());
  }
  function singleOrNull_0(_this__u8e3s4) {
    return _this__u8e3s4.n() === 1 ? _this__u8e3s4.q(0) : null;
  }
  function firstOrNull_1(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, KtList)) {
      if (_this__u8e3s4.p())
        return null;
      else
        return _this__u8e3s4.q(0);
    } else {
      var iterator = _this__u8e3s4.k();
      if (!iterator.l())
        return null;
      return iterator.m();
    }
  }
  function withIndex_0(_this__u8e3s4) {
    return new IndexingIterable(withIndex$lambda_0(_this__u8e3s4));
  }
  function toMutableSet(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, Collection)) {
      tmp = LinkedHashSet_init_$Create$_0(_this__u8e3s4);
    } else {
      tmp = toCollection_0(_this__u8e3s4, LinkedHashSet_init_$Create$());
    }
    return tmp;
  }
  function toMutableList_0(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, Collection))
      return toMutableList_1(_this__u8e3s4);
    return toCollection_0(_this__u8e3s4, ArrayList_init_$Create$());
  }
  function toMutableList_1(_this__u8e3s4) {
    return ArrayList_init_$Create$_1(_this__u8e3s4);
  }
  function last_0(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, KtList))
      return last(_this__u8e3s4);
    else {
      var iterator = _this__u8e3s4.k();
      if (!iterator.l())
        throw NoSuchElementException_init_$Create$_0('Collection is empty.');
      var last_0 = iterator.m();
      while (iterator.l())
        last_0 = iterator.m();
      return last_0;
    }
  }
  function toCollection_0(_this__u8e3s4, destination) {
    var _iterator__ex2g4s = _this__u8e3s4.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      destination.e(item);
    }
    return destination;
  }
  function indexOf_6(_this__u8e3s4, element) {
    if (isInterface(_this__u8e3s4, KtList))
      return _this__u8e3s4.t(element);
    var index = 0;
    var _iterator__ex2g4s = _this__u8e3s4.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      checkIndexOverflow(index);
      if (equals(element, item))
        return index;
      index = index + 1 | 0;
    }
    return -1;
  }
  function filterNotNullTo(_this__u8e3s4, destination) {
    var _iterator__ex2g4s = _this__u8e3s4.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      if (!(element == null)) {
        destination.e(element);
      }
    }
    return destination;
  }
  function single_0(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, KtList))
      return single_1(_this__u8e3s4);
    else {
      var iterator = _this__u8e3s4.k();
      if (!iterator.l())
        throw NoSuchElementException_init_$Create$_0('Collection is empty.');
      var single = iterator.m();
      if (iterator.l())
        throw IllegalArgumentException_init_$Create$_0('Collection has more than one element.');
      return single;
    }
  }
  function minOrNull(_this__u8e3s4) {
    var iterator = _this__u8e3s4.k();
    if (!iterator.l())
      return null;
    var min = iterator.m();
    while (iterator.l()) {
      var e = iterator.m();
      if (compareTo_0(min, e) > 0)
        min = e;
    }
    return min;
  }
  function single_1(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.n()) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('List is empty.');
      case 1:
        tmp = _this__u8e3s4.q(0);
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('List has more than one element.');
    }
    return tmp;
  }
  function getOrNull_0(_this__u8e3s4, index) {
    return (0 <= index ? index < _this__u8e3s4.n() : false) ? _this__u8e3s4.q(index) : null;
  }
  function plus_6(_this__u8e3s4, elements) {
    var result = ArrayList_init_$Create$_0(_this__u8e3s4.n() + 10 | 0);
    result.o(_this__u8e3s4);
    addAll_2(result, elements);
    return result;
  }
  function intersect(_this__u8e3s4, other) {
    var set = toMutableSet(_this__u8e3s4);
    retainAll(set, other);
    return set;
  }
  function lastOrNull(_this__u8e3s4) {
    return _this__u8e3s4.p() ? null : _this__u8e3s4.q(_this__u8e3s4.n() - 1 | 0);
  }
  function asSequence$$inlined$Sequence$1_0($this_asSequence) {
    this.v_1 = $this_asSequence;
  }
  protoOf(asSequence$$inlined$Sequence$1_0).k = function () {
    // Inline function 'kotlin.collections.asSequence.<anonymous>' call
    return this.v_1.k();
  };
  function withIndex$lambda_0($this_withIndex) {
    return function () {
      return $this_withIndex.k();
    };
  }
  function toList_1(_this__u8e3s4) {
    if (_this__u8e3s4.n() === 0)
      return emptyList();
    var iterator = _this__u8e3s4.w().k();
    if (!iterator.l())
      return emptyList();
    var first = iterator.m();
    if (!iterator.l()) {
      // Inline function 'kotlin.collections.toPair' call
      var tmp$ret$0 = new Pair(first.x(), first.y());
      return listOf(tmp$ret$0);
    }
    var result = ArrayList_init_$Create$_0(_this__u8e3s4.n());
    // Inline function 'kotlin.collections.toPair' call
    var tmp$ret$1 = new Pair(first.x(), first.y());
    result.e(tmp$ret$1);
    do {
      // Inline function 'kotlin.collections.toPair' call
      var this_0 = iterator.m();
      var tmp$ret$2 = new Pair(this_0.x(), this_0.y());
      result.e(tmp$ret$2);
    }
     while (iterator.l());
    return result;
  }
  function asSequence_1(_this__u8e3s4) {
    return asSequence_0(_this__u8e3s4.w());
  }
  function titlecaseImpl(_this__u8e3s4) {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var uppercase = toString(_this__u8e3s4).toUpperCase();
    if (uppercase.length > 1) {
      var tmp;
      if (_this__u8e3s4 === _Char___init__impl__6a9atx(329)) {
        tmp = uppercase;
      } else {
        var tmp4 = charSequenceGet(uppercase, 0);
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.text.plus' call
        var other = uppercase.substring(1).toLowerCase();
        tmp = toString(tmp4) + other;
      }
      return tmp;
    }
    return toString(titlecaseChar(_this__u8e3s4));
  }
  function until(_this__u8e3s4, to) {
    if (to <= -2147483648)
      return Companion_getInstance_11().z_1;
    return numberRangeToNumber(_this__u8e3s4, to - 1 | 0);
  }
  function downTo(_this__u8e3s4, to) {
    return Companion_instance_13.a1(_this__u8e3s4, to, -1);
  }
  function coerceIn(_this__u8e3s4, minimumValue, maximumValue) {
    if (minimumValue.d1(maximumValue) > 0)
      throw IllegalArgumentException_init_$Create$_0('Cannot coerce value to an empty range: maximum ' + maximumValue.toString() + ' is less than minimum ' + minimumValue.toString() + '.');
    if (_this__u8e3s4.d1(minimumValue) < 0)
      return minimumValue;
    if (_this__u8e3s4.d1(maximumValue) > 0)
      return maximumValue;
    return _this__u8e3s4;
  }
  function step(_this__u8e3s4, step) {
    checkStepIsPositive(step > 0, step);
    return Companion_instance_13.a1(_this__u8e3s4.e1_1, _this__u8e3s4.f1_1, _this__u8e3s4.g1_1 > 0 ? step : -step | 0);
  }
  function coerceAtLeast(_this__u8e3s4, minimumValue) {
    return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
  }
  function coerceAtMost(_this__u8e3s4, maximumValue) {
    return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
  }
  function reversed_0(_this__u8e3s4) {
    return Companion_instance_13.a1(_this__u8e3s4.f1_1, _this__u8e3s4.e1_1, -_this__u8e3s4.g1_1 | 0);
  }
  function coerceIn_0(_this__u8e3s4, minimumValue, maximumValue) {
    if (minimumValue > maximumValue)
      throw IllegalArgumentException_init_$Create$_0('Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
    if (_this__u8e3s4 < minimumValue)
      return minimumValue;
    if (_this__u8e3s4 > maximumValue)
      return maximumValue;
    return _this__u8e3s4;
  }
  function coerceAtMost_0(_this__u8e3s4, maximumValue) {
    return _this__u8e3s4.d1(maximumValue) > 0 ? maximumValue : _this__u8e3s4;
  }
  function coerceAtLeast_0(_this__u8e3s4, minimumValue) {
    return _this__u8e3s4.d1(minimumValue) < 0 ? minimumValue : _this__u8e3s4;
  }
  function plus_7(_this__u8e3s4, elements) {
    return flatten_1(sequenceOf([_this__u8e3s4, elements]));
  }
  function map(_this__u8e3s4, transform) {
    return new TransformingSequence(_this__u8e3s4, transform);
  }
  function toList_2(_this__u8e3s4) {
    var it = _this__u8e3s4.k();
    if (!it.l())
      return emptyList();
    var element = it.m();
    if (!it.l())
      return listOf(element);
    var dst = ArrayList_init_$Create$();
    dst.e(element);
    while (it.l()) {
      dst.e(it.m());
    }
    return dst;
  }
  function flatMap(_this__u8e3s4, transform) {
    return new FlatteningSequence(_this__u8e3s4, transform, Iterable$iterator$ref());
  }
  function toSet_1(_this__u8e3s4) {
    var it = _this__u8e3s4.k();
    if (!it.l())
      return emptySet();
    var element = it.m();
    if (!it.l())
      return setOf(element);
    var dst = LinkedHashSet_init_$Create$();
    dst.e(element);
    while (it.l()) {
      dst.e(it.m());
    }
    return dst;
  }
  function firstOrNull_2(_this__u8e3s4) {
    var iterator = _this__u8e3s4.k();
    if (!iterator.l())
      return null;
    return iterator.m();
  }
  function filterNotNull_0(_this__u8e3s4) {
    var tmp = filterNot(_this__u8e3s4, filterNotNull$lambda);
    return isInterface(tmp, Sequence) ? tmp : THROW_CCE();
  }
  function filter(_this__u8e3s4, predicate) {
    return new FilteringSequence(_this__u8e3s4, true, predicate);
  }
  function filterNot(_this__u8e3s4, predicate) {
    return new FilteringSequence(_this__u8e3s4, false, predicate);
  }
  function asIterable(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new asIterable$$inlined$Iterable$1(_this__u8e3s4);
  }
  function take_0(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      // Inline function 'kotlin.sequences.take.<anonymous>' call
      var message = 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if (n === 0) {
      tmp = emptySequence();
    } else {
      if (isInterface(_this__u8e3s4, DropTakeSequence)) {
        tmp = _this__u8e3s4.i1(n);
      } else {
        tmp = new TakeSequence(_this__u8e3s4, n);
      }
    }
    return tmp;
  }
  function last_1(_this__u8e3s4) {
    var iterator = _this__u8e3s4.k();
    if (!iterator.l())
      throw NoSuchElementException_init_$Create$_0('Sequence is empty.');
    var last = iterator.m();
    while (iterator.l())
      last = iterator.m();
    return last;
  }
  function first_1(_this__u8e3s4) {
    var iterator = _this__u8e3s4.k();
    if (!iterator.l())
      throw NoSuchElementException_init_$Create$_0('Sequence is empty.');
    return iterator.m();
  }
  function contains_6(_this__u8e3s4, element) {
    return indexOf_7(_this__u8e3s4, element) >= 0;
  }
  function indexOf_7(_this__u8e3s4, element) {
    var index = 0;
    var _iterator__ex2g4s = _this__u8e3s4.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      checkIndexOverflow(index);
      if (equals(element, item))
        return index;
      index = index + 1 | 0;
    }
    return -1;
  }
  function Iterable$iterator$ref() {
    var l = function (p0) {
      return p0.k();
    };
    l.callableName = 'iterator';
    return l;
  }
  function filterNotNull$lambda(it) {
    return it == null;
  }
  function asIterable$$inlined$Iterable$1($this_asIterable) {
    this.j1_1 = $this_asIterable;
  }
  protoOf(asIterable$$inlined$Iterable$1).k = function () {
    // Inline function 'kotlin.sequences.asIterable.<anonymous>' call
    return this.j1_1.k();
  };
  function plus_8(_this__u8e3s4, elements) {
    var tmp0_safe_receiver = collectionSizeOrNull(elements);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.collections.plus.<anonymous>' call
      tmp = _this__u8e3s4.n() + tmp0_safe_receiver | 0;
    }
    var tmp1_elvis_lhs = tmp;
    var result = LinkedHashSet_init_$Create$_1(mapCapacity(tmp1_elvis_lhs == null ? imul(_this__u8e3s4.n(), 2) : tmp1_elvis_lhs));
    result.o(_this__u8e3s4);
    addAll_1(result, elements);
    return result;
  }
  function plus_9(_this__u8e3s4, element) {
    var result = LinkedHashSet_init_$Create$_1(mapCapacity(_this__u8e3s4.n() + 1 | 0));
    result.o(_this__u8e3s4);
    result.e(element);
    return result;
  }
  function minus_2(_this__u8e3s4, element) {
    var result = LinkedHashSet_init_$Create$_1(mapCapacity(_this__u8e3s4.n()));
    var removed = false;
    // Inline function 'kotlin.collections.filterTo' call
    var _iterator__ex2g4s = _this__u8e3s4.k();
    while (_iterator__ex2g4s.l()) {
      var element_0 = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.minus.<anonymous>' call
      var tmp;
      if (!removed && equals(element_0, element)) {
        removed = true;
        tmp = false;
      } else {
        tmp = true;
      }
      if (tmp) {
        result.e(element_0);
      }
    }
    return result;
  }
  function minus_3(_this__u8e3s4, elements) {
    var other = convertToListIfNotCollection(elements);
    if (other.p())
      return toSet_0(_this__u8e3s4);
    if (isInterface(other, KtSet)) {
      // Inline function 'kotlin.collections.filterNotTo' call
      var destination = LinkedHashSet_init_$Create$();
      var _iterator__ex2g4s = _this__u8e3s4.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlin.collections.minus.<anonymous>' call
        if (!other.s(element)) {
          destination.e(element);
        }
      }
      return destination;
    }
    var result = LinkedHashSet_init_$Create$_0(_this__u8e3s4);
    result.k1(other);
    return result;
  }
  function last_2(_this__u8e3s4) {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0)
      throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
    return charSequenceGet(_this__u8e3s4, get_lastIndex_3(_this__u8e3s4));
  }
  function take_1(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      // Inline function 'kotlin.text.take.<anonymous>' call
      var message = 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.text.substring' call
    var endIndex = coerceAtMost(n, _this__u8e3s4.length);
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.substring(0, endIndex);
  }
  function dropLast_0(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      // Inline function 'kotlin.text.dropLast.<anonymous>' call
      var message = 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return take_1(_this__u8e3s4, coerceAtLeast(_this__u8e3s4.length - n | 0, 0));
  }
  function first_2(_this__u8e3s4) {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0)
      throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
    return charSequenceGet(_this__u8e3s4, 0);
  }
  function reversed_1(_this__u8e3s4) {
    return StringBuilder_init_$Create$_0(_this__u8e3s4).m1();
  }
  function drop_0(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      // Inline function 'kotlin.text.drop.<anonymous>' call
      var message = 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.text.substring' call
    var startIndex = coerceAtMost(n, _this__u8e3s4.length);
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.substring(startIndex);
  }
  function single_2(_this__u8e3s4) {
    var tmp;
    switch (charSequenceLength(_this__u8e3s4)) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('Char sequence is empty.');
      case 1:
        tmp = charSequenceGet(_this__u8e3s4, 0);
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('Char sequence has more than one element.');
    }
    return tmp;
  }
  function slice(_this__u8e3s4, indices) {
    if (indices.p()) {
      // Inline function 'kotlin.collections.listOf' call
      return emptyList();
    }
    var tmp1 = indices.q1();
    // Inline function 'kotlin.collections.copyOfRange' call
    var toIndex = indices.r1() + 1 | 0;
    var tmp$ret$1 = _ULongArray___init__impl__twm1l3(copyOfRange(_ULongArray___get_storage__impl__28e64j(_this__u8e3s4), tmp1, toIndex));
    return asList_0(tmp$ret$1);
  }
  function toULongArray(_this__u8e3s4) {
    var result = _ULongArray___init__impl__twm1l3_0(_this__u8e3s4.n());
    var index = 0;
    var _iterator__ex2g4s = _this__u8e3s4.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m().s1_1;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      ULongArray__set_impl_z19mvh(result, _unary__edvuaz, element);
    }
    return result;
  }
  function KotlinNothingValueException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    KotlinNothingValueException.call($this);
    return $this;
  }
  function KotlinNothingValueException_init_$Create$() {
    var tmp = KotlinNothingValueException_init_$Init$(objectCreate(protoOf(KotlinNothingValueException)));
    captureStack(tmp, KotlinNothingValueException_init_$Create$);
    return tmp;
  }
  function KotlinNothingValueException() {
    captureStack(this, KotlinNothingValueException);
  }
  function _Char___init__impl__6a9atx(value) {
    return value;
  }
  function _get_value__a43j40($this) {
    return $this;
  }
  function _Char___init__impl__6a9atx_0(code) {
    // Inline function 'kotlin.UShort.toInt' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(code) & 65535;
    return _Char___init__impl__6a9atx(tmp$ret$0);
  }
  function Char__compareTo_impl_ypi4mb($this, other) {
    return _get_value__a43j40($this) - _get_value__a43j40(other) | 0;
  }
  function Char__compareTo_impl_ypi4mb_0($this, other) {
    return Char__compareTo_impl_ypi4mb($this.v1_1, other instanceof Char ? other.v1_1 : THROW_CCE());
  }
  function Char__plus_impl_qi7pgj($this, other) {
    return numberToChar(_get_value__a43j40($this) + other | 0);
  }
  function Char__minus_impl_a2frrh($this, other) {
    return _get_value__a43j40($this) - _get_value__a43j40(other) | 0;
  }
  function Char__minus_impl_a2frrh_0($this, other) {
    return numberToChar(_get_value__a43j40($this) - other | 0);
  }
  function Char__rangeTo_impl_tkncvp($this, other) {
    return new CharRange($this, other);
  }
  function Char__toInt_impl_vasixd($this) {
    return _get_value__a43j40($this);
  }
  function toString($this) {
    // Inline function 'kotlin.js.unsafeCast' call
    return String.fromCharCode(_get_value__a43j40($this));
  }
  function Char__equals_impl_x6719k($this, other) {
    if (!(other instanceof Char))
      return false;
    return _get_value__a43j40($this) === _get_value__a43j40(other.v1_1);
  }
  function Char__hashCode_impl_otmys($this) {
    return _get_value__a43j40($this);
  }
  function Companion() {
    Companion_instance = this;
    this.w1_1 = _Char___init__impl__6a9atx(0);
    this.x1_1 = _Char___init__impl__6a9atx(65535);
    this.y1_1 = _Char___init__impl__6a9atx(55296);
    this.z1_1 = _Char___init__impl__6a9atx(56319);
    this.a2_1 = _Char___init__impl__6a9atx(56320);
    this.b2_1 = _Char___init__impl__6a9atx(57343);
    this.c2_1 = _Char___init__impl__6a9atx(55296);
    this.d2_1 = _Char___init__impl__6a9atx(57343);
    this.e2_1 = 2;
    this.f2_1 = 16;
  }
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function Char(value) {
    Companion_getInstance();
    this.v1_1 = value;
  }
  protoOf(Char).g2 = function (other) {
    return Char__compareTo_impl_ypi4mb(this.v1_1, other);
  };
  protoOf(Char).d = function (other) {
    return Char__compareTo_impl_ypi4mb_0(this, other);
  };
  protoOf(Char).toString = function () {
    return toString(this.v1_1);
  };
  protoOf(Char).equals = function (other) {
    return Char__equals_impl_x6719k(this.v1_1, other);
  };
  protoOf(Char).hashCode = function () {
    return Char__hashCode_impl_otmys(this.v1_1);
  };
  protoOf(Companion_0).fromJsArray = function (array) {
    return createListFrom(array);
  };
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function KtList() {
  }
  function Collection() {
  }
  function KtMutableSet() {
  }
  function KtMutableList() {
  }
  function KtSet() {
  }
  function MutableEntry() {
  }
  function KtMutableMap() {
  }
  function MutableCollection() {
  }
  function Entry() {
  }
  function KtMap() {
  }
  function MutableIterable() {
  }
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function Enum(name, ordinal) {
    this.z2_1 = name;
    this.a3_1 = ordinal;
  }
  protoOf(Enum).b3 = function () {
    return this.z2_1;
  };
  protoOf(Enum).c3 = function () {
    return this.a3_1;
  };
  protoOf(Enum).d3 = function (other) {
    return compareTo_0(this.a3_1, other.a3_1);
  };
  protoOf(Enum).d = function (other) {
    return this.d3(other instanceof Enum ? other : THROW_CCE());
  };
  protoOf(Enum).equals = function (other) {
    return this === other;
  };
  protoOf(Enum).hashCode = function () {
    return identityHashCode(this);
  };
  protoOf(Enum).toString = function () {
    return this.z2_1;
  };
  function arrayOf(elements) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return elements;
  }
  function toString_0(_this__u8e3s4) {
    var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : toString_1(_this__u8e3s4);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function plus_10(_this__u8e3s4, other) {
    var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : toString_1(_this__u8e3s4);
    var tmp = tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = other == null ? null : toString_1(other);
    return tmp + (tmp3_elvis_lhs == null ? 'null' : tmp3_elvis_lhs);
  }
  function Companion_2() {
    Companion_instance_2 = this;
    this.e3_1 = new Long(0, -2147483648);
    this.f3_1 = new Long(-1, 2147483647);
    this.g3_1 = 8;
    this.h3_1 = 64;
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function Long(low, high) {
    Companion_getInstance_2();
    Number_0.call(this);
    this.b1_1 = low;
    this.c1_1 = high;
  }
  protoOf(Long).d1 = function (other) {
    return compare(this, other);
  };
  protoOf(Long).d = function (other) {
    return this.d1(other instanceof Long ? other : THROW_CCE());
  };
  protoOf(Long).i3 = function (other) {
    return add_1(this, other);
  };
  protoOf(Long).j3 = function (other) {
    return subtract_0(this, other);
  };
  protoOf(Long).k3 = function (other) {
    return multiply(this, other);
  };
  protoOf(Long).l3 = function (other) {
    return divide(this, other);
  };
  protoOf(Long).m3 = function (other) {
    return modulo(this, other);
  };
  protoOf(Long).n3 = function () {
    return this.i3(new Long(1, 0));
  };
  protoOf(Long).o3 = function () {
    return this.j3(new Long(1, 0));
  };
  protoOf(Long).p3 = function () {
    return this.q3().i3(new Long(1, 0));
  };
  protoOf(Long).r3 = function (bitCount) {
    return shiftLeft(this, bitCount);
  };
  protoOf(Long).s3 = function (bitCount) {
    return shiftRight(this, bitCount);
  };
  protoOf(Long).t3 = function (bitCount) {
    return shiftRightUnsigned(this, bitCount);
  };
  protoOf(Long).u3 = function (other) {
    return new Long(this.b1_1 & other.b1_1, this.c1_1 & other.c1_1);
  };
  protoOf(Long).v3 = function (other) {
    return new Long(this.b1_1 | other.b1_1, this.c1_1 | other.c1_1);
  };
  protoOf(Long).w3 = function (other) {
    return new Long(this.b1_1 ^ other.b1_1, this.c1_1 ^ other.c1_1);
  };
  protoOf(Long).q3 = function () {
    return new Long(~this.b1_1, ~this.c1_1);
  };
  protoOf(Long).x3 = function () {
    return toByte(this.b1_1);
  };
  protoOf(Long).y3 = function () {
    return toShort(this.b1_1);
  };
  protoOf(Long).z3 = function () {
    return this.b1_1;
  };
  protoOf(Long).a4 = function () {
    return toNumber(this);
  };
  protoOf(Long).toString = function () {
    return toStringImpl(this, 10);
  };
  protoOf(Long).equals = function (other) {
    var tmp;
    if (other instanceof Long) {
      tmp = equalsLong(this, other);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Long).hashCode = function () {
    return hashCode_0(this);
  };
  protoOf(Long).valueOf = function () {
    return this.a4();
  };
  function implement(interfaces) {
    var maxSize = 1;
    var masks = [];
    var inductionVariable = 0;
    var last = interfaces.length;
    while (inductionVariable < last) {
      var i = interfaces[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var currentSize = maxSize;
      var tmp0_elvis_lhs = i.prototype.$imask$;
      var imask = tmp0_elvis_lhs == null ? i.$imask$ : tmp0_elvis_lhs;
      if (!(imask == null)) {
        masks.push(imask);
        currentSize = imask.length;
      }
      var iid = i.$metadata$.iid;
      var tmp;
      if (iid == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.js.implement.<anonymous>' call
        tmp = bitMaskWith(iid);
      }
      var iidImask = tmp;
      if (!(iidImask == null)) {
        masks.push(iidImask);
        currentSize = Math.max(currentSize, iidImask.length);
      }
      if (currentSize > maxSize) {
        maxSize = currentSize;
      }
    }
    return compositeBitMask(maxSize, masks);
  }
  function bitMaskWith(activeBit) {
    var numberIndex = activeBit >> 5;
    var intArray = new Int32Array(numberIndex + 1 | 0);
    var positionInNumber = activeBit & 31;
    var numberWithSettledBit = 1 << positionInNumber;
    intArray[numberIndex] = intArray[numberIndex] | numberWithSettledBit;
    return intArray;
  }
  function compositeBitMask(capacity, masks) {
    var tmp = 0;
    var tmp_0 = new Int32Array(capacity);
    while (tmp < capacity) {
      var tmp_1 = tmp;
      var result = 0;
      var inductionVariable = 0;
      var last = masks.length;
      while (inductionVariable < last) {
        var mask = masks[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (tmp_1 < mask.length) {
          result = result | mask[tmp_1];
        }
      }
      tmp_0[tmp_1] = result;
      tmp = tmp + 1 | 0;
    }
    return tmp_0;
  }
  function isBitSet(_this__u8e3s4, possibleActiveBit) {
    var numberIndex = possibleActiveBit >> 5;
    if (numberIndex > _this__u8e3s4.length)
      return false;
    var positionInNumber = possibleActiveBit & 31;
    var numberWithSettledBit = 1 << positionInNumber;
    return !((_this__u8e3s4[numberIndex] & numberWithSettledBit) === 0);
  }
  function FunctionAdapter() {
  }
  function fillArrayVal(array, initValue) {
    var inductionVariable = 0;
    var last = array.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array[i] = initValue;
      }
       while (!(i === last));
    return array;
  }
  function arrayIterator(array) {
    return new arrayIterator$1(array);
  }
  function booleanArray(size) {
    var tmp0 = 'BooleanArray';
    // Inline function 'withType' call
    var array = fillArrayVal(Array(size), false);
    array.$type$ = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    return array;
  }
  function charArray(size) {
    var tmp0 = 'CharArray';
    // Inline function 'withType' call
    var array = new Uint16Array(size);
    array.$type$ = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    return array;
  }
  function longArray(size) {
    var tmp0 = 'LongArray';
    // Inline function 'withType' call
    var array = fillArrayVal(Array(size), new Long(0, 0));
    array.$type$ = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    return array;
  }
  function charArrayOf(arr) {
    var tmp0 = 'CharArray';
    // Inline function 'withType' call
    var array = new Uint16Array(arr);
    array.$type$ = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    return array;
  }
  function longArrayOf(arr) {
    var tmp1 = 'LongArray';
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'withType' call
    var array = arr.slice();
    array.$type$ = tmp1;
    // Inline function 'kotlin.js.unsafeCast' call
    return array;
  }
  function arrayIterator$1($array) {
    this.d4_1 = $array;
    this.c4_1 = 0;
  }
  protoOf(arrayIterator$1).l = function () {
    return !(this.c4_1 === this.d4_1.length);
  };
  protoOf(arrayIterator$1).m = function () {
    var tmp;
    if (!(this.c4_1 === this.d4_1.length)) {
      var _unary__edvuaz = this.c4_1;
      this.c4_1 = _unary__edvuaz + 1 | 0;
      tmp = this.d4_1[_unary__edvuaz];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this.c4_1);
    }
    return tmp;
  };
  function get_buf() {
    _init_properties_bitUtils_kt__nfcg4k();
    return buf;
  }
  var buf;
  function get_bufFloat64() {
    _init_properties_bitUtils_kt__nfcg4k();
    return bufFloat64;
  }
  var bufFloat64;
  function get_bufFloat32() {
    _init_properties_bitUtils_kt__nfcg4k();
    return bufFloat32;
  }
  var bufFloat32;
  function get_bufInt32() {
    _init_properties_bitUtils_kt__nfcg4k();
    return bufInt32;
  }
  var bufInt32;
  function get_lowIndex() {
    _init_properties_bitUtils_kt__nfcg4k();
    return lowIndex;
  }
  var lowIndex;
  function get_highIndex() {
    _init_properties_bitUtils_kt__nfcg4k();
    return highIndex;
  }
  var highIndex;
  function getNumberHashCode(obj) {
    _init_properties_bitUtils_kt__nfcg4k();
    // Inline function 'kotlin.js.jsBitwiseOr' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    if ((obj | 0) === obj) {
      return numberToInt(obj);
    }
    get_bufFloat64()[0] = obj;
    return imul(get_bufInt32()[get_highIndex()], 31) + get_bufInt32()[get_lowIndex()] | 0;
  }
  function doubleFromBits(value) {
    _init_properties_bitUtils_kt__nfcg4k();
    get_bufInt32()[get_lowIndex()] = value.b1_1;
    get_bufInt32()[get_highIndex()] = value.c1_1;
    return get_bufFloat64()[0];
  }
  function doubleToRawBits(value) {
    _init_properties_bitUtils_kt__nfcg4k();
    get_bufFloat64()[0] = value;
    return new Long(get_bufInt32()[get_lowIndex()], get_bufInt32()[get_highIndex()]);
  }
  function floatToRawBits(value) {
    _init_properties_bitUtils_kt__nfcg4k();
    get_bufFloat32()[0] = value;
    return get_bufInt32()[0];
  }
  function floatFromBits(value) {
    _init_properties_bitUtils_kt__nfcg4k();
    get_bufInt32()[0] = value;
    return get_bufFloat32()[0];
  }
  var properties_initialized_bitUtils_kt_i2bo3e;
  function _init_properties_bitUtils_kt__nfcg4k() {
    if (!properties_initialized_bitUtils_kt_i2bo3e) {
      properties_initialized_bitUtils_kt_i2bo3e = true;
      buf = new ArrayBuffer(8);
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      bufFloat64 = new Float64Array(get_buf());
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      bufFloat32 = new Float32Array(get_buf());
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      bufInt32 = new Int32Array(get_buf());
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.js.lowIndex.<anonymous>' call
      get_bufFloat64()[0] = -1.0;
      lowIndex = !(get_bufInt32()[0] === 0) ? 1 : 0;
      highIndex = 1 - get_lowIndex() | 0;
    }
  }
  function charSequenceGet(a, index) {
    var tmp;
    if (isString(a)) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.Char' call
      var code = a.charCodeAt(index);
      var tmp_0;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(0);
      if (code < Char__toInt_impl_vasixd(this_0)) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(65535);
        tmp_0 = code > Char__toInt_impl_vasixd(this_1);
      }
      if (tmp_0) {
        throw IllegalArgumentException_init_$Create$_0('Invalid Char code: ' + code);
      }
      tmp = numberToChar(code);
    } else {
      tmp = a.b(index);
    }
    return tmp;
  }
  function isString(a) {
    return typeof a === 'string';
  }
  function charSequenceLength(a) {
    var tmp;
    if (isString(a)) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = a.length;
    } else {
      tmp = a.a();
    }
    return tmp;
  }
  function charSequenceSubSequence(a, startIndex, endIndex) {
    var tmp;
    if (isString(a)) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = a.substring(startIndex, endIndex);
    } else {
      tmp = a.c(startIndex, endIndex);
    }
    return tmp;
  }
  function arrayToString(array) {
    return joinToString(array, ', ', '[', ']', VOID, VOID, arrayToString$lambda);
  }
  function contentEqualsInternal(_this__u8e3s4, other) {
    // Inline function 'kotlin.js.asDynamic' call
    var a = _this__u8e3s4;
    // Inline function 'kotlin.js.asDynamic' call
    var b = other;
    if (a === b)
      return true;
    if (a == null || b == null || !isArrayish(b) || a.length != b.length)
      return false;
    var inductionVariable = 0;
    var last = a.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(a[i], b[i])) {
          return false;
        }
      }
       while (inductionVariable < last);
    return true;
  }
  function contentHashCodeInternal(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var a = _this__u8e3s4;
    if (a == null)
      return 0;
    var result = 1;
    var inductionVariable = 0;
    var last = a.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = imul(result, 31) + hashCode(a[i]) | 0;
      }
       while (inductionVariable < last);
    return result;
  }
  function arrayToString$lambda(it) {
    return toString_1(it);
  }
  function createJsReadonlyArrayViewFrom(list) {
    var tmp = createJsReadonlyArrayViewFrom$lambda(list);
    var tmp_0 = createJsReadonlyArrayViewFrom$lambda_0(list);
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = UNSUPPORTED_OPERATION$ref();
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_2 = UNSUPPORTED_OPERATION$ref_0();
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = UNSUPPORTED_OPERATION$ref_1();
    return createJsArrayViewWith(tmp, tmp_0, tmp_1, tmp_2, tmp$ret$2);
  }
  function createJsArrayViewWith(listSize, listGet, listSet, listDecreaseSize, listIncreaseSize) {
    var arrayView = new Array();
    var tmp = Object;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = JsArrayView;
    tmp.setPrototypeOf(arrayView, tmp$ret$0.prototype);
    return new Proxy(arrayView, {get: function (target, prop, receiver) {
      if (prop === 'length')
        return listSize();
      var type = typeof prop;
      var index = type === 'string' || type === 'number' ? +prop : undefined;
      if (!isNaN(index))
        return listGet(index);
      return target[prop];
    }, has: function (target, key) {
      return !isNaN(key) && key < listSize();
    }, set: function (obj, prop, value) {
      if (prop === 'length') {
        var size = listSize();
        var newSize = type === 'string' || type === 'number' ? +prop : undefined;
        if (isNaN(newSize))
          throw new RangeError('invalid array length');
        if (newSize < size)
          listDecreaseSize(size - newSize);
        else
          listIncreaseSize(newSize - size);
        return true;
      }
      var type = typeof prop;
      var index = type === 'string' || type === 'number' ? +prop : undefined;
      if (isNaN(index))
        return false;
      listSet(index, value);
      return true;
    }});
  }
  function UNSUPPORTED_OPERATION() {
    throw UnsupportedOperationException_init_$Create$();
  }
  function JsArrayView() {
    Array.call(this);
  }
  function createListFrom(array) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$1 = array.slice();
    return (new ArrayList(tmp$ret$1)).e4();
  }
  function createJsReadonlyArrayViewFrom$lambda($list) {
    return function () {
      return $list.n();
    };
  }
  function createJsReadonlyArrayViewFrom$lambda_0($list) {
    return function (i) {
      return $list.q(i);
    };
  }
  function UNSUPPORTED_OPERATION$ref() {
    var l = function () {
      UNSUPPORTED_OPERATION();
      return Unit_instance;
    };
    l.callableName = 'UNSUPPORTED_OPERATION';
    return l;
  }
  function UNSUPPORTED_OPERATION$ref_0() {
    var l = function () {
      UNSUPPORTED_OPERATION();
      return Unit_instance;
    };
    l.callableName = 'UNSUPPORTED_OPERATION';
    return l;
  }
  function UNSUPPORTED_OPERATION$ref_1() {
    var l = function () {
      UNSUPPORTED_OPERATION();
      return Unit_instance;
    };
    l.callableName = 'UNSUPPORTED_OPERATION';
    return l;
  }
  function compareTo_0(a, b) {
    var tmp;
    switch (typeof a) {
      case 'number':
        var tmp_0;
        if (typeof b === 'number') {
          tmp_0 = doubleCompareTo(a, b);
        } else {
          if (b instanceof Long) {
            tmp_0 = doubleCompareTo(a, b.a4());
          } else {
            tmp_0 = primitiveCompareTo(a, b);
          }
        }

        tmp = tmp_0;
        break;
      case 'string':
      case 'boolean':
        tmp = primitiveCompareTo(a, b);
        break;
      default:
        tmp = compareToDoNotIntrinsicify(a, b);
        break;
    }
    return tmp;
  }
  function doubleCompareTo(a, b) {
    var tmp;
    if (a < b) {
      tmp = -1;
    } else if (a > b) {
      tmp = 1;
    } else if (a === b) {
      var tmp_0;
      if (a !== 0) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        var ia = 1 / a;
        var tmp_1;
        // Inline function 'kotlin.js.asDynamic' call
        if (ia === 1 / b) {
          tmp_1 = 0;
        } else {
          if (ia < 0) {
            tmp_1 = -1;
          } else {
            tmp_1 = 1;
          }
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (a !== a) {
      tmp = b !== b ? 0 : 1;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function primitiveCompareTo(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function compareToDoNotIntrinsicify(a, b) {
    return a.d(b);
  }
  function identityHashCode(obj) {
    return getObjectHashCode(obj);
  }
  function getObjectHashCode(obj) {
    // Inline function 'kotlin.js.jsIn' call
    if (!('kotlinHashCodeValue$' in obj)) {
      var hash = calculateRandomHash();
      var descriptor = new Object();
      descriptor.value = hash;
      descriptor.enumerable = false;
      Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
    }
    // Inline function 'kotlin.js.unsafeCast' call
    return obj['kotlinHashCodeValue$'];
  }
  function calculateRandomHash() {
    // Inline function 'kotlin.js.jsBitwiseOr' call
    return Math.random() * 4.294967296E9 | 0;
  }
  function defineProp(obj, name, getter, setter) {
    return Object.defineProperty(obj, name, {configurable: true, get: getter, set: setter});
  }
  function objectCreate(proto) {
    proto = proto === VOID ? null : proto;
    return Object.create(proto);
  }
  function toString_1(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else if (!(typeof o.toString === 'function')) {
      tmp = anyToString(o);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = o.toString();
    }
    return tmp;
  }
  function equals(obj1, obj2) {
    if (obj1 == null) {
      return obj2 == null;
    }
    if (obj2 == null) {
      return false;
    }
    if (typeof obj1 === 'object' && typeof obj1.equals === 'function') {
      return obj1.equals(obj2);
    }
    if (obj1 !== obj1) {
      return obj2 !== obj2;
    }
    if (typeof obj1 === 'number' && typeof obj2 === 'number') {
      var tmp;
      if (obj1 === obj2) {
        var tmp_0;
        if (obj1 !== 0) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_1 = 1 / obj1;
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = tmp_1 === 1 / obj2;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    }
    return obj1 === obj2;
  }
  function hashCode(obj) {
    if (obj == null)
      return 0;
    var typeOf = typeof obj;
    var tmp;
    switch (typeOf) {
      case 'object':
        tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
        break;
      case 'function':
        tmp = getObjectHashCode(obj);
        break;
      case 'number':
        tmp = getNumberHashCode(obj);
        break;
      case 'boolean':
        // Inline function 'kotlin.js.unsafeCast' call

        tmp = getBooleanHashCode(obj);
        break;
      case 'string':
        tmp = getStringHashCode(String(obj));
        break;
      case 'bigint':
        tmp = getBigIntHashCode(obj);
        break;
      case 'symbol':
        tmp = getSymbolHashCode(obj);
        break;
      default:
        tmp = function () {
          throw new Error('Unexpected typeof `' + typeOf + '`');
        }();
        break;
    }
    return tmp;
  }
  function anyToString(o) {
    return Object.prototype.toString.call(o);
  }
  function getBooleanHashCode(value) {
    return value ? 1231 : 1237;
  }
  function getStringHashCode(str) {
    var hash = 0;
    var length = str.length;
    var inductionVariable = 0;
    var last = length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        var code = str.charCodeAt(i);
        hash = imul(hash, 31) + code | 0;
      }
       while (!(i === last));
    return hash;
  }
  function getBigIntHashCode(value) {
    var shiftNumber = BigInt(32);
    var MASK = BigInt(4.294967295E9);
    var bigNumber = value < 0 ? -value : value;
    var hashCode = 0;
    var signum = value < 0 ? -1 : 1;
    while (bigNumber != 0) {
      // Inline function 'kotlin.js.unsafeCast' call
      var chunk = Number(bigNumber & MASK);
      hashCode = imul(31, hashCode) + chunk | 0;
      bigNumber = bigNumber >> shiftNumber;
    }
    return imul(hashCode, signum);
  }
  function getSymbolHashCode(value) {
    var hashCodeMap = symbolIsSharable(value) ? getSymbolMap() : getSymbolWeakMap();
    var cachedHashCode = hashCodeMap.get(value);
    if (cachedHashCode !== VOID)
      return cachedHashCode;
    var hash = calculateRandomHash();
    hashCodeMap.set(value, hash);
    return hash;
  }
  function symbolIsSharable(symbol) {
    return Symbol.keyFor(symbol) != VOID;
  }
  function getSymbolMap() {
    if (symbolMap === VOID) {
      symbolMap = new Map();
    }
    return symbolMap;
  }
  function getSymbolWeakMap() {
    if (symbolWeakMap === VOID) {
      symbolWeakMap = new WeakMap();
    }
    return symbolWeakMap;
  }
  var symbolMap;
  var symbolWeakMap;
  function boxIntrinsic(x) {
    var message = 'Should be lowered';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  function unboxIntrinsic(x) {
    var message = 'Should be lowered';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      instance.stack = (new Error()).stack;
    }
  }
  function protoOf(constructor) {
    return constructor.prototype;
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    var errorInfo = calculateErrorInfo(Object.getPrototypeOf(this_));
    if ((errorInfo & 1) === 0) {
      var tmp;
      if (message == null) {
        var tmp_0;
        if (!(message === null)) {
          var tmp1_elvis_lhs = cause == null ? null : cause.toString();
          tmp_0 = tmp1_elvis_lhs == null ? VOID : tmp1_elvis_lhs;
        } else {
          tmp_0 = VOID;
        }
        tmp = tmp_0;
      } else {
        tmp = message;
      }
      this_.message = tmp;
    }
    if ((errorInfo & 2) === 0) {
      this_.cause = cause;
    }
    this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function returnIfSuspended(argument, $completion) {
    return (argument == null ? true : !(argument == null)) ? argument : THROW_CCE();
  }
  function ensureNotNull(v) {
    var tmp;
    if (v == null) {
      THROW_NPE();
    } else {
      tmp = v;
    }
    return tmp;
  }
  function THROW_NPE() {
    throw NullPointerException_init_$Create$();
  }
  function noWhenBranchMatchedException() {
    throw NoWhenBranchMatchedException_init_$Create$();
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function throwUninitializedPropertyAccessException(name) {
    throw UninitializedPropertyAccessException_init_$Create$_0('lateinit property ' + name + ' has not been initialized');
  }
  function throwKotlinNothingValueException() {
    throw KotlinNothingValueException_init_$Create$();
  }
  function THROW_ISE() {
    throw IllegalStateException_init_$Create$();
  }
  function THROW_IAE(msg) {
    throw IllegalArgumentException_init_$Create$_0(msg);
  }
  function get_ZERO() {
    _init_properties_longJs_kt__elc2w5();
    return ZERO;
  }
  var ZERO;
  function get_ONE() {
    _init_properties_longJs_kt__elc2w5();
    return ONE;
  }
  var ONE;
  function get_NEG_ONE() {
    _init_properties_longJs_kt__elc2w5();
    return NEG_ONE;
  }
  var NEG_ONE;
  function get_MAX_VALUE() {
    _init_properties_longJs_kt__elc2w5();
    return MAX_VALUE;
  }
  var MAX_VALUE;
  function get_MIN_VALUE() {
    _init_properties_longJs_kt__elc2w5();
    return MIN_VALUE;
  }
  var MIN_VALUE;
  function get_TWO_PWR_24_() {
    _init_properties_longJs_kt__elc2w5();
    return TWO_PWR_24_;
  }
  var TWO_PWR_24_;
  function compare(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    if (equalsLong(_this__u8e3s4, other)) {
      return 0;
    }
    var thisNeg = isNegative(_this__u8e3s4);
    var otherNeg = isNegative(other);
    return thisNeg && !otherNeg ? -1 : !thisNeg && otherNeg ? 1 : isNegative(subtract_0(_this__u8e3s4, other)) ? -1 : 1;
  }
  function add_1(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    var a48 = _this__u8e3s4.c1_1 >>> 16 | 0;
    var a32 = _this__u8e3s4.c1_1 & 65535;
    var a16 = _this__u8e3s4.b1_1 >>> 16 | 0;
    var a00 = _this__u8e3s4.b1_1 & 65535;
    var b48 = other.c1_1 >>> 16 | 0;
    var b32 = other.c1_1 & 65535;
    var b16 = other.b1_1 >>> 16 | 0;
    var b00 = other.b1_1 & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16 | 0) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract_0(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    return add_1(_this__u8e3s4, other.p3());
  }
  function multiply(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    if (isZero(_this__u8e3s4)) {
      return get_ZERO();
    } else if (isZero(other)) {
      return get_ZERO();
    }
    if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
      return isOdd(other) ? get_MIN_VALUE() : get_ZERO();
    } else if (equalsLong(other, get_MIN_VALUE())) {
      return isOdd(_this__u8e3s4) ? get_MIN_VALUE() : get_ZERO();
    }
    if (isNegative(_this__u8e3s4)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this__u8e3s4), negate(other));
      } else {
        tmp = negate(multiply(negate(_this__u8e3s4), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this__u8e3s4, negate(other)));
    }
    if (lessThan(_this__u8e3s4, get_TWO_PWR_24_()) && lessThan(other, get_TWO_PWR_24_())) {
      return fromNumber(toNumber(_this__u8e3s4) * toNumber(other));
    }
    var a48 = _this__u8e3s4.c1_1 >>> 16 | 0;
    var a32 = _this__u8e3s4.c1_1 & 65535;
    var a16 = _this__u8e3s4.b1_1 >>> 16 | 0;
    var a00 = _this__u8e3s4.b1_1 & 65535;
    var b48 = other.c1_1 >>> 16 | 0;
    var b32 = other.c1_1 & 65535;
    var b16 = other.b1_1 >>> 16 | 0;
    var b00 = other.b1_1 & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16 | 0) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16 | 0) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16 | 0) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    if (isZero(other)) {
      throw Exception_init_$Create$_0('division by zero');
    } else if (isZero(_this__u8e3s4)) {
      return get_ZERO();
    }
    if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
      if (equalsLong(other, get_ONE()) || equalsLong(other, get_NEG_ONE())) {
        return get_MIN_VALUE();
      } else if (equalsLong(other, get_MIN_VALUE())) {
        return get_ONE();
      } else {
        var halfThis = shiftRight(_this__u8e3s4, 1);
        var approx = shiftLeft(halfThis.l3(other), 1);
        if (equalsLong(approx, get_ZERO())) {
          return isNegative(other) ? get_ONE() : get_NEG_ONE();
        } else {
          var rem = subtract_0(_this__u8e3s4, multiply(other, approx));
          return add_1(approx, rem.l3(other));
        }
      }
    } else if (equalsLong(other, get_MIN_VALUE())) {
      return get_ZERO();
    }
    if (isNegative(_this__u8e3s4)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this__u8e3s4).l3(negate(other));
      } else {
        tmp = negate(negate(_this__u8e3s4).l3(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this__u8e3s4.l3(negate(other)));
    }
    var res = get_ZERO();
    var rem_0 = _this__u8e3s4;
    while (greaterThanOrEqual(rem_0, other)) {
      var approxDouble = toNumber(rem_0) / toNumber(other);
      var approx2 = Math.max(1.0, Math.floor(approxDouble));
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta = log2 <= 48 ? 1.0 : Math.pow(2.0, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) || greaterThan(approxRem, rem_0)) {
        approx2 = approx2 - delta;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = get_ONE();
      }
      res = add_1(res, approxRes);
      rem_0 = subtract_0(rem_0, approxRem);
    }
    return res;
  }
  function modulo(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    return subtract_0(_this__u8e3s4, multiply(_this__u8e3s4.l3(other), other));
  }
  function shiftLeft(_this__u8e3s4, numBits) {
    _init_properties_longJs_kt__elc2w5();
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this__u8e3s4;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this__u8e3s4.b1_1 << numBits_0, _this__u8e3s4.c1_1 << numBits_0 | (_this__u8e3s4.b1_1 >>> (32 - numBits_0 | 0) | 0));
      } else {
        return new Long(0, _this__u8e3s4.b1_1 << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this__u8e3s4, numBits) {
    _init_properties_longJs_kt__elc2w5();
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this__u8e3s4;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this__u8e3s4.b1_1 >>> numBits_0 | 0 | _this__u8e3s4.c1_1 << (32 - numBits_0 | 0), _this__u8e3s4.c1_1 >> numBits_0);
      } else {
        return new Long(_this__u8e3s4.c1_1 >> (numBits_0 - 32 | 0), _this__u8e3s4.c1_1 >= 0 ? 0 : -1);
      }
    }
  }
  function shiftRightUnsigned(_this__u8e3s4, numBits) {
    _init_properties_longJs_kt__elc2w5();
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this__u8e3s4;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this__u8e3s4.b1_1 >>> numBits_0 | 0 | _this__u8e3s4.c1_1 << (32 - numBits_0 | 0), _this__u8e3s4.c1_1 >>> numBits_0 | 0);
      } else {
        var tmp;
        if (numBits_0 === 32) {
          tmp = new Long(_this__u8e3s4.c1_1, 0);
        } else {
          tmp = new Long(_this__u8e3s4.c1_1 >>> (numBits_0 - 32 | 0) | 0, 0);
        }
        return tmp;
      }
    }
  }
  function toNumber(_this__u8e3s4) {
    _init_properties_longJs_kt__elc2w5();
    return _this__u8e3s4.c1_1 * 4.294967296E9 + getLowBitsUnsigned(_this__u8e3s4);
  }
  function toStringImpl(_this__u8e3s4, radix) {
    _init_properties_longJs_kt__elc2w5();
    if (radix < 2 || 36 < radix) {
      throw Exception_init_$Create$_0('radix out of range: ' + radix);
    }
    if (isZero(_this__u8e3s4)) {
      return '0';
    }
    if (isNegative(_this__u8e3s4)) {
      if (equalsLong(_this__u8e3s4, get_MIN_VALUE())) {
        var radixLong = fromInt(radix);
        var div = _this__u8e3s4.l3(radixLong);
        var rem = subtract_0(multiply(div, radixLong), _this__u8e3s4).z3();
        var tmp = toStringImpl(div, radix);
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        return tmp + rem.toString(radix);
      } else {
        return '-' + toStringImpl(negate(_this__u8e3s4), radix);
      }
    }
    var digitsPerTime = radix === 2 ? 31 : radix <= 10 ? 9 : radix <= 21 ? 7 : radix <= 35 ? 6 : 5;
    var radixToPower = fromNumber(Math.pow(radix, digitsPerTime));
    var rem_0 = _this__u8e3s4;
    var result = '';
    while (true) {
      var remDiv = rem_0.l3(radixToPower);
      var intval = subtract_0(rem_0, multiply(remDiv, radixToPower)).z3();
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var digits = intval.toString(radix);
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits + result;
      } else {
        while (digits.length < digitsPerTime) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function equalsLong(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    return _this__u8e3s4.c1_1 === other.c1_1 && _this__u8e3s4.b1_1 === other.b1_1;
  }
  function hashCode_0(l) {
    _init_properties_longJs_kt__elc2w5();
    return l.b1_1 ^ l.c1_1;
  }
  function fromInt(value) {
    _init_properties_longJs_kt__elc2w5();
    return new Long(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this__u8e3s4) {
    _init_properties_longJs_kt__elc2w5();
    return _this__u8e3s4.c1_1 < 0;
  }
  function isZero(_this__u8e3s4) {
    _init_properties_longJs_kt__elc2w5();
    return _this__u8e3s4.c1_1 === 0 && _this__u8e3s4.b1_1 === 0;
  }
  function isOdd(_this__u8e3s4) {
    _init_properties_longJs_kt__elc2w5();
    return (_this__u8e3s4.b1_1 & 1) === 1;
  }
  function negate(_this__u8e3s4) {
    _init_properties_longJs_kt__elc2w5();
    return _this__u8e3s4.p3();
  }
  function lessThan(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    return compare(_this__u8e3s4, other) < 0;
  }
  function fromNumber(value) {
    _init_properties_longJs_kt__elc2w5();
    if (isNaN_0(value)) {
      return get_ZERO();
    } else if (value <= -9.223372036854776E18) {
      return get_MIN_VALUE();
    } else if (value + 1 >= 9.223372036854776E18) {
      return get_MAX_VALUE();
    } else if (value < 0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      // Inline function 'kotlin.js.jsBitwiseOr' call
      var tmp = value % twoPwr32 | 0;
      // Inline function 'kotlin.js.jsBitwiseOr' call
      var tmp$ret$1 = value / twoPwr32 | 0;
      return new Long(tmp, tmp$ret$1);
    }
  }
  function greaterThan(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    return compare(_this__u8e3s4, other) > 0;
  }
  function greaterThanOrEqual(_this__u8e3s4, other) {
    _init_properties_longJs_kt__elc2w5();
    return compare(_this__u8e3s4, other) >= 0;
  }
  function getLowBitsUnsigned(_this__u8e3s4) {
    _init_properties_longJs_kt__elc2w5();
    return _this__u8e3s4.b1_1 >= 0 ? _this__u8e3s4.b1_1 : 4.294967296E9 + _this__u8e3s4.b1_1;
  }
  var properties_initialized_longJs_kt_4syf89;
  function _init_properties_longJs_kt__elc2w5() {
    if (!properties_initialized_longJs_kt_4syf89) {
      properties_initialized_longJs_kt_4syf89 = true;
      ZERO = fromInt(0);
      ONE = fromInt(1);
      NEG_ONE = fromInt(-1);
      MAX_VALUE = new Long(-1, 2147483647);
      MIN_VALUE = new Long(0, -2147483648);
      TWO_PWR_24_ = fromInt(16777216);
    }
  }
  function createMetadata(kind, name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity) {
    var undef = VOID;
    var iid = kind === 'interface' ? generateInterfaceId() : VOID;
    return {kind: kind, simpleName: name, associatedObjectKey: associatedObjectKey, associatedObjects: associatedObjects, suspendArity: suspendArity, $kClass$: undef, defaultConstructor: defaultConstructor, iid: iid};
  }
  function generateInterfaceId() {
    if (globalInterfaceId === VOID) {
      globalInterfaceId = 0;
    }
    // Inline function 'kotlin.js.unsafeCast' call
    globalInterfaceId = globalInterfaceId + 1 | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    return globalInterfaceId;
  }
  var globalInterfaceId;
  function initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
    if (!(parent == null)) {
      ctor.prototype = Object.create(parent.prototype);
      ctor.prototype.constructor = ctor;
    }
    var metadata = createMetadata(kind, name, defaultConstructor, associatedObjectKey, associatedObjects, suspendArity);
    ctor.$metadata$ = metadata;
    if (!(interfaces == null)) {
      var receiver = !equals(metadata.iid, VOID) ? ctor : ctor.prototype;
      receiver.$imask$ = implement(interfaces);
    }
  }
  function initMetadataForClass(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
    var kind = 'class';
    initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
  }
  function initMetadataForObject(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
    var kind = 'object';
    initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
  }
  function initMetadataForInterface(ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects) {
    var kind = 'interface';
    initMetadataFor(kind, ctor, name, defaultConstructor, parent, interfaces, suspendArity, associatedObjectKey, associatedObjects);
  }
  function initMetadataForLambda(ctor, parent, interfaces, suspendArity) {
    initMetadataForClass(ctor, 'Lambda', VOID, parent, interfaces, suspendArity, VOID, VOID);
  }
  function initMetadataForCoroutine(ctor, parent, interfaces, suspendArity) {
    initMetadataForClass(ctor, 'Coroutine', VOID, parent, interfaces, suspendArity, VOID, VOID);
  }
  function initMetadataForFunctionReference(ctor, parent, interfaces, suspendArity) {
    initMetadataForClass(ctor, 'FunctionReference', VOID, parent, interfaces, suspendArity, VOID, VOID);
  }
  function initMetadataForCompanion(ctor, parent, interfaces, suspendArity) {
    initMetadataForObject(ctor, 'Companion', VOID, parent, interfaces, suspendArity, VOID, VOID);
  }
  function primitiveArrayConcat(args) {
    var size_local = 0;
    var inductionVariable = 0;
    var last = args.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = size_local;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        size_local = tmp + args[i].length | 0;
      }
       while (!(i === last));
    var a = args[0];
    // Inline function 'kotlin.js.unsafeCast' call
    var result = new a.constructor(size_local);
    // Inline function 'kotlin.js.asDynamic' call
    if (a.$type$ != null) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'withType' call
      result.$type$ = a.$type$;
    }
    size_local = 0;
    var inductionVariable_0 = 0;
    var last_0 = args.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var arr = args[i_0];
        var inductionVariable_1 = 0;
        var last_1 = arr.length - 1 | 0;
        if (inductionVariable_1 <= last_1)
          do {
            var j = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var _unary__edvuaz = size_local;
            size_local = _unary__edvuaz + 1 | 0;
            result[_unary__edvuaz] = arr[j];
          }
           while (!(j === last_1));
      }
       while (!(i_0 === last_0));
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return result;
  }
  function arrayConcat(args) {
    var len = args.length;
    // Inline function 'kotlin.js.unsafeCast' call
    var typed = Array(len);
    var inductionVariable = 0;
    var last = len - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var arr = args[i];
        if (!(!(arr == null) ? isArray(arr) : false)) {
          typed[i] = [].slice.call(arr);
        } else {
          typed[i] = arr;
        }
      }
       while (!(i === last));
    return [].concat.apply([], typed);
  }
  function toByte(a) {
    // Inline function 'kotlin.js.unsafeCast' call
    return a << 24 >> 24;
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.z3();
    } else {
      tmp = doubleToInt(a);
    }
    return tmp;
  }
  function doubleToInt(a) {
    var tmp;
    if (a > 2147483647) {
      tmp = 2147483647;
    } else if (a < -2147483648) {
      tmp = -2147483648;
    } else {
      // Inline function 'kotlin.js.jsBitwiseOr' call
      tmp = a | 0;
    }
    return tmp;
  }
  function numberToDouble(a) {
    // Inline function 'kotlin.js.unsafeCast' call
    return +a;
  }
  function toShort(a) {
    // Inline function 'kotlin.js.unsafeCast' call
    return a << 16 >> 16;
  }
  function numberToLong(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a;
    } else {
      tmp = fromNumber(a);
    }
    return tmp;
  }
  function numberToChar(a) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = numberToInt(a);
    var tmp$ret$0 = _UShort___init__impl__jigrne(toShort(this_0));
    return _Char___init__impl__6a9atx_0(tmp$ret$0);
  }
  function toLong(a) {
    return fromInt(a);
  }
  function ByteCompanionObject() {
    this.MIN_VALUE = -128;
    this.MAX_VALUE = 127;
    this.SIZE_BYTES = 1;
    this.SIZE_BITS = 8;
  }
  protoOf(ByteCompanionObject).f4 = function () {
    return this.MIN_VALUE;
  };
  protoOf(ByteCompanionObject).g4 = function () {
    return this.MAX_VALUE;
  };
  protoOf(ByteCompanionObject).h4 = function () {
    return this.SIZE_BYTES;
  };
  protoOf(ByteCompanionObject).i4 = function () {
    return this.SIZE_BITS;
  };
  var ByteCompanionObject_instance;
  function ByteCompanionObject_getInstance() {
    return ByteCompanionObject_instance;
  }
  function ShortCompanionObject() {
    this.MIN_VALUE = -32768;
    this.MAX_VALUE = 32767;
    this.SIZE_BYTES = 2;
    this.SIZE_BITS = 16;
  }
  protoOf(ShortCompanionObject).f4 = function () {
    return this.MIN_VALUE;
  };
  protoOf(ShortCompanionObject).g4 = function () {
    return this.MAX_VALUE;
  };
  protoOf(ShortCompanionObject).h4 = function () {
    return this.SIZE_BYTES;
  };
  protoOf(ShortCompanionObject).i4 = function () {
    return this.SIZE_BITS;
  };
  var ShortCompanionObject_instance;
  function ShortCompanionObject_getInstance() {
    return ShortCompanionObject_instance;
  }
  function IntCompanionObject() {
    this.MIN_VALUE = -2147483648;
    this.MAX_VALUE = 2147483647;
    this.SIZE_BYTES = 4;
    this.SIZE_BITS = 32;
  }
  protoOf(IntCompanionObject).f4 = function () {
    return this.MIN_VALUE;
  };
  protoOf(IntCompanionObject).g4 = function () {
    return this.MAX_VALUE;
  };
  protoOf(IntCompanionObject).h4 = function () {
    return this.SIZE_BYTES;
  };
  protoOf(IntCompanionObject).i4 = function () {
    return this.SIZE_BITS;
  };
  var IntCompanionObject_instance;
  function IntCompanionObject_getInstance() {
    return IntCompanionObject_instance;
  }
  function FloatCompanionObject() {
    this.MIN_VALUE = 1.4E-45;
    this.MAX_VALUE = 3.4028235E38;
    this.POSITIVE_INFINITY = Infinity;
    this.NEGATIVE_INFINITY = -Infinity;
    this.NaN = NaN;
    this.SIZE_BYTES = 4;
    this.SIZE_BITS = 32;
  }
  protoOf(FloatCompanionObject).f4 = function () {
    return this.MIN_VALUE;
  };
  protoOf(FloatCompanionObject).g4 = function () {
    return this.MAX_VALUE;
  };
  protoOf(FloatCompanionObject).j4 = function () {
    return this.POSITIVE_INFINITY;
  };
  protoOf(FloatCompanionObject).k4 = function () {
    return this.NEGATIVE_INFINITY;
  };
  protoOf(FloatCompanionObject).l4 = function () {
    return this.NaN;
  };
  protoOf(FloatCompanionObject).h4 = function () {
    return this.SIZE_BYTES;
  };
  protoOf(FloatCompanionObject).i4 = function () {
    return this.SIZE_BITS;
  };
  var FloatCompanionObject_instance;
  function FloatCompanionObject_getInstance() {
    return FloatCompanionObject_instance;
  }
  function DoubleCompanionObject() {
    this.MIN_VALUE = 4.9E-324;
    this.MAX_VALUE = 1.7976931348623157E308;
    this.POSITIVE_INFINITY = Infinity;
    this.NEGATIVE_INFINITY = -Infinity;
    this.NaN = NaN;
    this.SIZE_BYTES = 8;
    this.SIZE_BITS = 64;
  }
  protoOf(DoubleCompanionObject).f4 = function () {
    return this.MIN_VALUE;
  };
  protoOf(DoubleCompanionObject).g4 = function () {
    return this.MAX_VALUE;
  };
  protoOf(DoubleCompanionObject).j4 = function () {
    return this.POSITIVE_INFINITY;
  };
  protoOf(DoubleCompanionObject).k4 = function () {
    return this.NEGATIVE_INFINITY;
  };
  protoOf(DoubleCompanionObject).l4 = function () {
    return this.NaN;
  };
  protoOf(DoubleCompanionObject).h4 = function () {
    return this.SIZE_BYTES;
  };
  protoOf(DoubleCompanionObject).i4 = function () {
    return this.SIZE_BITS;
  };
  var DoubleCompanionObject_instance;
  function DoubleCompanionObject_getInstance() {
    return DoubleCompanionObject_instance;
  }
  function StringCompanionObject() {
  }
  var StringCompanionObject_instance;
  function StringCompanionObject_getInstance() {
    return StringCompanionObject_instance;
  }
  function BooleanCompanionObject() {
  }
  var BooleanCompanionObject_instance;
  function BooleanCompanionObject_getInstance() {
    return BooleanCompanionObject_instance;
  }
  function numberRangeToNumber(start, endInclusive) {
    return new IntRange(start, endInclusive);
  }
  function get_propertyRefClassMetadataCache() {
    _init_properties_reflectRuntime_kt__5r4uu3();
    return propertyRefClassMetadataCache;
  }
  var propertyRefClassMetadataCache;
  function metadataObject() {
    _init_properties_reflectRuntime_kt__5r4uu3();
    return createMetadata('class', VOID, VOID, VOID, VOID, VOID);
  }
  function getPropertyCallableRef(name, paramCount, superType, getter, setter) {
    _init_properties_reflectRuntime_kt__5r4uu3();
    getter.get = getter;
    getter.set = setter;
    getter.callableName = name;
    // Inline function 'kotlin.js.unsafeCast' call
    return getPropertyRefClass(getter, getKPropMetadata(paramCount, setter), getInterfaceMaskFor(getter, superType));
  }
  function getPropertyRefClass(obj, metadata, imask) {
    _init_properties_reflectRuntime_kt__5r4uu3();
    obj.$metadata$ = metadata;
    obj.constructor = obj;
    obj.$imask$ = imask;
    return obj;
  }
  function getKPropMetadata(paramCount, setter) {
    _init_properties_reflectRuntime_kt__5r4uu3();
    return get_propertyRefClassMetadataCache()[paramCount][setter == null ? 0 : 1];
  }
  function getInterfaceMaskFor(obj, superType) {
    _init_properties_reflectRuntime_kt__5r4uu3();
    var tmp0_elvis_lhs = obj.$imask$;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = [superType];
      tmp = implement(tmp$ret$2);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function getLocalDelegateReference(name, superType, mutable, lambda) {
    _init_properties_reflectRuntime_kt__5r4uu3();
    return getPropertyCallableRef(name, 0, superType, lambda, mutable ? lambda : null);
  }
  var properties_initialized_reflectRuntime_kt_inkhwd;
  function _init_properties_reflectRuntime_kt__5r4uu3() {
    if (!properties_initialized_reflectRuntime_kt_inkhwd) {
      properties_initialized_reflectRuntime_kt_inkhwd = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = [metadataObject(), metadataObject()];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_0 = [metadataObject(), metadataObject()];
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      propertyRefClassMetadataCache = [tmp, tmp_0, [metadataObject(), metadataObject()]];
    }
  }
  function isArrayish(o) {
    return isJsArray(o) || isView(o);
  }
  function isJsArray(obj) {
    // Inline function 'kotlin.js.unsafeCast' call
    return Array.isArray(obj);
  }
  function isInterface(obj, iface) {
    return isInterfaceImpl(obj, iface.$metadata$.iid);
  }
  function isInterfaceImpl(obj, iface) {
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_elvis_lhs = obj.$imask$;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var mask = tmp;
    return isBitSet(mask, iface);
  }
  function isArray(obj) {
    var tmp;
    if (isJsArray(obj)) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp = !obj.$type$;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isSuspendFunction(obj, arity) {
    var objTypeOf = typeof obj;
    if (objTypeOf === 'function') {
      // Inline function 'kotlin.js.unsafeCast' call
      return obj.$arity === arity;
    }
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp1_safe_receiver = obj == null ? null : obj.constructor;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.$metadata$;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.suspendArity;
    var tmp;
    if (tmp3_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp3_elvis_lhs;
    }
    var suspendArity = tmp;
    var result = false;
    var inductionVariable = 0;
    var last = suspendArity.length;
    $l$loop: while (inductionVariable < last) {
      var item = suspendArity[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (arity === item) {
        result = true;
        break $l$loop;
      }
    }
    return result;
  }
  function isNumber(a) {
    var tmp;
    if (typeof a === 'number') {
      tmp = true;
    } else {
      tmp = a instanceof Long;
    }
    return tmp;
  }
  function isComparable(value) {
    var type = typeof value;
    return type === 'string' || type === 'boolean' || isNumber(value) || isInterface(value, Comparable);
  }
  function isCharSequence(value) {
    return typeof value === 'string' || isInterface(value, CharSequence);
  }
  function isBooleanArray(a) {
    return isJsArray(a) && a.$type$ === 'BooleanArray';
  }
  function isByteArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Int8Array;
  }
  function isShortArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Int16Array;
  }
  function isCharArray(a) {
    var tmp;
    // Inline function 'kotlin.js.jsInstanceOf' call
    if (a instanceof Uint16Array) {
      tmp = a.$type$ === 'CharArray';
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isIntArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Int32Array;
  }
  function isFloatArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Float32Array;
  }
  function isLongArray(a) {
    return isJsArray(a) && a.$type$ === 'LongArray';
  }
  function isDoubleArray(a) {
    // Inline function 'kotlin.js.jsInstanceOf' call
    return a instanceof Float64Array;
  }
  function jsIsType(obj, jsClass) {
    if (jsClass === Object) {
      return obj != null;
    }
    var objType = typeof obj;
    var jsClassType = typeof jsClass;
    if (obj == null || jsClass == null || (!(objType === 'object') && !(objType === 'function'))) {
      return false;
    }
    var constructor = jsClassType === 'object' ? jsGetPrototypeOf(jsClass) : jsClass;
    var klassMetadata = constructor.$metadata$;
    if ((klassMetadata == null ? null : klassMetadata.kind) === 'interface') {
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp0_elvis_lhs = klassMetadata.iid;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var iid = tmp;
      return isInterfaceImpl(obj, iid);
    }
    // Inline function 'kotlin.js.jsInstanceOf' call
    return obj instanceof constructor;
  }
  function jsGetPrototypeOf(jsClass) {
    return Object.getPrototypeOf(jsClass);
  }
  function calculateErrorInfo(proto) {
    var tmp0_safe_receiver = proto.constructor;
    var metadata = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.$metadata$;
    var tmp2_safe_receiver = metadata == null ? null : metadata.errorInfo;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp2_safe_receiver;
    }
    var result = 0;
    if (hasProp(proto, 'message'))
      result = result | 1;
    if (hasProp(proto, 'cause'))
      result = result | 2;
    if (!(result === 3)) {
      var parentProto = getPrototypeOf(proto);
      if (parentProto != Error.prototype) {
        result = result | calculateErrorInfo(parentProto);
      }
    }
    if (!(metadata == null)) {
      metadata.errorInfo = result;
    }
    return result;
  }
  function hasProp(proto, propName) {
    return proto.hasOwnProperty(propName);
  }
  function getPrototypeOf(obj) {
    return Object.getPrototypeOf(obj);
  }
  function get_VOID() {
    _init_properties_void_kt__3zg9as();
    return VOID;
  }
  var VOID;
  var properties_initialized_void_kt_e4ret2;
  function _init_properties_void_kt__3zg9as() {
    if (!properties_initialized_void_kt_e4ret2) {
      properties_initialized_void_kt_e4ret2 = true;
      VOID = void 0;
    }
  }
  function asList(_this__u8e3s4) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return new ArrayList(_this__u8e3s4);
  }
  function copyOf(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp1 = 'CharArray';
    // Inline function 'withType' call
    var array = fillFrom(_this__u8e3s4, charArray(newSize));
    array.$type$ = tmp1;
    return array;
  }
  function copyOf_0(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return fillFrom(_this__u8e3s4, new Float64Array(newSize));
  }
  function copyOf_1(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return fillFrom(_this__u8e3s4, new Float32Array(newSize));
  }
  function copyOf_2(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp1 = 'LongArray';
    // Inline function 'withType' call
    var array = arrayCopyResize(_this__u8e3s4, newSize, new Long(0, 0));
    array.$type$ = tmp1;
    return array;
  }
  function copyOf_3(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return fillFrom(_this__u8e3s4, new Int32Array(newSize));
  }
  function copyOf_4(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return fillFrom(_this__u8e3s4, new Int16Array(newSize));
  }
  function copyOf_5(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return fillFrom(_this__u8e3s4, new Int8Array(newSize));
  }
  function copyOf_6(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp1 = 'BooleanArray';
    // Inline function 'withType' call
    var array = arrayCopyResize(_this__u8e3s4, newSize, false);
    array.$type$ = tmp1;
    return array;
  }
  function contentEquals(_this__u8e3s4, other) {
    return contentEqualsInternal(_this__u8e3s4, other);
  }
  function contentHashCode(_this__u8e3s4) {
    return contentHashCodeInternal(_this__u8e3s4);
  }
  function contentEquals_0(_this__u8e3s4, other) {
    return contentEqualsInternal(_this__u8e3s4, other);
  }
  function sortWith(_this__u8e3s4, comparator) {
    if (_this__u8e3s4.length > 1) {
      sortArrayWith(_this__u8e3s4, comparator);
    }
  }
  function fill(_this__u8e3s4, element, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? _this__u8e3s4.length : toIndex;
    Companion_instance_6.n4(fromIndex, toIndex, _this__u8e3s4.length);
    // Inline function 'kotlin.js.nativeFill' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.fill(element, fromIndex, toIndex);
  }
  function copyOfRange(_this__u8e3s4, fromIndex, toIndex) {
    Companion_instance_6.n4(fromIndex, toIndex, _this__u8e3s4.length);
    var tmp1 = 'LongArray';
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'withType' call
    var array = _this__u8e3s4.slice(fromIndex, toIndex);
    array.$type$ = tmp1;
    return array;
  }
  function copyOf_7(_this__u8e3s4) {
    var tmp1 = 'LongArray';
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'withType' call
    var array = _this__u8e3s4.slice();
    array.$type$ = tmp1;
    return array;
  }
  function copyOfRange_0(_this__u8e3s4, fromIndex, toIndex) {
    Companion_instance_6.n4(fromIndex, toIndex, _this__u8e3s4.length);
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.slice(fromIndex, toIndex);
  }
  function copyOf_8(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.require' call
    if (!(newSize >= 0)) {
      // Inline function 'kotlin.collections.copyOf.<anonymous>' call
      var message = 'Invalid new array size: ' + newSize + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return arrayCopyResize(_this__u8e3s4, newSize, null);
  }
  function contentToString(_this__u8e3s4) {
    var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : joinToString(_this__u8e3s4, ', ', '[', ']');
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function toTypedArray(_this__u8e3s4) {
    return [].slice.call(_this__u8e3s4);
  }
  function decodeVarLenBase64(base64, fromBase64, resultLength) {
    var result = new Int32Array(resultLength);
    var index = 0;
    var int = 0;
    var shift = 0;
    var inductionVariable = 0;
    var last = base64.length;
    while (inductionVariable < last) {
      var char = charSequenceGet(base64, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var sixBit = fromBase64[Char__toInt_impl_vasixd(char)];
      int = int | (sixBit & 31) << shift;
      if (sixBit < 32) {
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        result[_unary__edvuaz] = int;
        int = 0;
        shift = 0;
      } else {
        shift = shift + 5 | 0;
      }
    }
    return result;
  }
  function reverse(_this__u8e3s4) {
    var midPoint = (_this__u8e3s4.n() / 2 | 0) - 1 | 0;
    if (midPoint < 0)
      return Unit_instance;
    var reverseIndex = get_lastIndex_2(_this__u8e3s4);
    var inductionVariable = 0;
    if (inductionVariable <= midPoint)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = _this__u8e3s4.q(index);
        _this__u8e3s4.o2(index, _this__u8e3s4.q(reverseIndex));
        _this__u8e3s4.o2(reverseIndex, tmp);
        reverseIndex = reverseIndex - 1 | 0;
      }
       while (!(index === midPoint));
  }
  function digitToIntImpl(_this__u8e3s4) {
    // Inline function 'kotlin.code' call
    var ch = Char__toInt_impl_vasixd(_this__u8e3s4);
    var index = binarySearchRange(Digit_getInstance().o4_1, ch);
    var diff = ch - Digit_getInstance().o4_1[index] | 0;
    return diff < 10 ? diff : -1;
  }
  function binarySearchRange(array, needle) {
    var bottom = 0;
    var top = array.length - 1 | 0;
    var middle = -1;
    var value = 0;
    while (bottom <= top) {
      middle = (bottom + top | 0) / 2 | 0;
      value = array[middle];
      if (needle > value)
        bottom = middle + 1 | 0;
      else if (needle === value)
        return middle;
      else
        top = middle - 1 | 0;
    }
    return middle - (needle < value ? 1 : 0) | 0;
  }
  function Digit() {
    Digit_instance = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.o4_1 = new Int32Array([48, 1632, 1776, 1984, 2406, 2534, 2662, 2790, 2918, 3046, 3174, 3302, 3430, 3558, 3664, 3792, 3872, 4160, 4240, 6112, 6160, 6470, 6608, 6784, 6800, 6992, 7088, 7232, 7248, 42528, 43216, 43264, 43472, 43504, 43600, 44016, 65296]);
  }
  var Digit_instance;
  function Digit_getInstance() {
    if (Digit_instance == null)
      new Digit();
    return Digit_instance;
  }
  function isLowerCaseImpl(_this__u8e3s4) {
    var tmp;
    if (getLetterType(_this__u8e3s4) === 1) {
      tmp = true;
    } else {
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(_this__u8e3s4);
      tmp = isOtherLowercase(tmp$ret$0);
    }
    return tmp;
  }
  function getLetterType(_this__u8e3s4) {
    // Inline function 'kotlin.code' call
    var ch = Char__toInt_impl_vasixd(_this__u8e3s4);
    var index = binarySearchRange(Letter_getInstance().p4_1, ch);
    var rangeStart = Letter_getInstance().p4_1[index];
    var rangeEnd = (rangeStart + Letter_getInstance().q4_1[index] | 0) - 1 | 0;
    var code = Letter_getInstance().r4_1[index];
    if (ch > rangeEnd) {
      return 0;
    }
    var lastTwoBits = code & 3;
    if (lastTwoBits === 0) {
      var shift = 2;
      var threshold = rangeStart;
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          threshold = threshold + (code >> shift & 127) | 0;
          if (threshold > ch) {
            return 3;
          }
          shift = shift + 7 | 0;
          threshold = threshold + (code >> shift & 127) | 0;
          if (threshold > ch) {
            return 0;
          }
          shift = shift + 7 | 0;
        }
         while (inductionVariable <= 1);
      return 3;
    }
    if (code <= 7) {
      return lastTwoBits;
    }
    var distance = ch - rangeStart | 0;
    var shift_0 = code <= 31 ? distance % 2 | 0 : distance;
    return code >> imul(2, shift_0) & 3;
  }
  function Letter() {
    Letter_instance = this;
    var toBase64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var fromBase64 = new Int32Array(128);
    var inductionVariable = 0;
    var last = charSequenceLength(toBase64) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charSequenceGet(toBase64, i);
        fromBase64[Char__toInt_impl_vasixd(this_0)] = i;
      }
       while (inductionVariable <= last);
    var rangeStartDiff = 'hCgBpCQGYHZH5BRpBPPPPPPRMP5BPPlCPP6BkEPPPPcPXPzBvBrB3BOiDoBHwD+E3DauCnFmBmB2D6E1BlBTiBmBlBP5BhBiBrBvBjBqBnBPRtBiCmCtBlB0BmB5BiB7BmBgEmChBZgCoEoGVpBSfRhBPqKQ2BwBYoFgB4CJuTiEvBuCuDrF5DgEgFlJ1DgFmBQtBsBRGsB+BPiBlD1EIjDPRPPPQPPPPPGQSQS/DxENVNU+B9zCwBwBPPCkDPNnBPqDYY1R8B7FkFgTgwGgwUwmBgKwBuBScmEP/BPPPPPPrBP8B7F1B/ErBqC6B7BiBmBfQsBUwCw/KwqIwLwETPcPjQgJxFgBlBsD';
    var diff = decodeVarLenBase64(rangeStartDiff, fromBase64, 222);
    var start = new Int32Array(diff.length);
    var inductionVariable_0 = 0;
    var last_0 = diff.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (i_0 === 0) {
          start[i_0] = diff[i_0];
        } else {
          start[i_0] = start[i_0 - 1 | 0] + diff[i_0] | 0;
        }
      }
       while (inductionVariable_0 <= last_0);
    this.p4_1 = start;
    var rangeLength = 'aaMBXHYH5BRpBPPPPPPRMP5BPPlCPPzBDOOPPcPXPzBvBjB3BOhDmBBpB7DoDYxB+EiBP1DoExBkBQhBekBPmBgBhBctBiBMWOOXhCsBpBkBUV3Ba4BkB0DlCgBXgBtD4FSdBfPhBPpKP0BvBXjEQ2CGsT8DhBtCqDpFvD1D3E0IrD2EkBJrBDOBsB+BPiBlB1EIjDPPPPPPPPPPPGPPMNLsBNPNPKCvBvBPPCkDPBmBPhDXXgD4B6FzEgDguG9vUtkB9JcuBSckEP/BPPPPPPBPf4FrBjEhBpC3B5BKaWPrBOwCk/KsCuLqDHPbPxPsFtEaaqDL';
    this.q4_1 = decodeVarLenBase64(rangeLength, fromBase64, 222);
    var rangeCategory = 'GFjgggUHGGFFZZZmzpz5qB6s6020B60ptltB6smt2sB60mz22B1+vv+8BZZ5s2850BW5q1ymtB506smzBF3q1q1qB1q1q1+Bgii4wDTm74g3KiggxqM60q1q1Bq1o1q1BF1qlrqrBZ2q5wprBGFZWWZGHFsjiooLowgmOowjkwCkgoiIk7ligGogiioBkwkiYkzj2oNoi+sbkwj04DghhkQ8wgiYkgoioDsgnkwC4gikQ//v+85BkwvoIsgoyI4yguI0whiwEowri4CoghsJowgqYowgm4DkwgsY/nwnzPowhmYkg6wI8yggZswikwHgxgmIoxgqYkwgk4DkxgmIkgoioBsgssoBgzgyI8g9gL8g9kI0wgwJoxgkoC0wgioFkw/wI0w53iF4gioYowjmgBHGq1qkgwBF1q1q8qBHwghuIwghyKk0goQkwgoQk3goQHGFHkyg0pBgxj6IoinkxDswno7Ikwhz9Bo0gioB8z48Rwli0xN0mpjoX8w78pDwltoqKHFGGwwgsIHFH3q1q16BFHWFZ1q10q1B2qlwq1B1q10q1B2q1yq1B6q1gq1Biq1qhxBir1qp1Bqt1q1qB1g1q1+B//3q16B///q1qBH/qlqq9Bholqq9B1i00a1q10qD1op1HkwmigEigiy6Cptogq1Bixo1kDq7/j00B2qgoBWGFm1lz50B6s5q1+BGWhggzhwBFFhgk4//Bo2jigE8wguI8wguI8wgugUog1qoB4qjmIwwi2KgkYHHH4lBgiFWkgIWoghssMmz5smrBZ3q1y50B5sm7gzBtz1smzB5smz50BqzqtmzB5sgzqzBF2/9//5BowgoIwmnkzPkwgk4C8ys65BkgoqI0wgy6FghquZo2giY0ghiIsgh24B4ghsQ8QF/v1q1OFs0O8iCHHF1qggz/B8wg6Iznv+//B08QgohsjK0QGFk7hsQ4gB';
    this.r4_1 = decodeVarLenBase64(rangeCategory, fromBase64, 222);
  }
  var Letter_instance;
  function Letter_getInstance() {
    if (Letter_instance == null)
      new Letter();
    return Letter_instance;
  }
  function isOtherLowercase(_this__u8e3s4) {
    var index = binarySearchRange(OtherLowercase_getInstance().s4_1, _this__u8e3s4);
    return index >= 0 && _this__u8e3s4 < (OtherLowercase_getInstance().s4_1[index] + OtherLowercase_getInstance().t4_1[index] | 0);
  }
  function OtherLowercase() {
    OtherLowercase_instance = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.s4_1 = new Int32Array([170, 186, 688, 704, 736, 837, 890, 7468, 7544, 7579, 8305, 8319, 8336, 8560, 9424, 11388, 42652, 42864, 43000, 43868]);
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.t4_1 = new Int32Array([1, 1, 9, 2, 5, 1, 1, 63, 1, 37, 1, 1, 13, 16, 26, 2, 2, 1, 2, 4]);
  }
  var OtherLowercase_instance;
  function OtherLowercase_getInstance() {
    if (OtherLowercase_instance == null)
      new OtherLowercase();
    return OtherLowercase_instance;
  }
  function titlecaseCharImpl(_this__u8e3s4) {
    // Inline function 'kotlin.code' call
    var code = Char__toInt_impl_vasixd(_this__u8e3s4);
    if ((452 <= code ? code <= 460 : false) || (497 <= code ? code <= 499 : false)) {
      return numberToChar(imul(3, (code + 1 | 0) / 3 | 0));
    }
    if ((4304 <= code ? code <= 4346 : false) || (4349 <= code ? code <= 4351 : false)) {
      return _this__u8e3s4;
    }
    return uppercaseChar(_this__u8e3s4);
  }
  function asList_0(_this__u8e3s4) {
    return new asList$1(_this__u8e3s4);
  }
  function asList$1($this_asList) {
    this.u4_1 = $this_asList;
    AbstractList.call(this);
  }
  protoOf(asList$1).n = function () {
    return _ULongArray___get_size__impl__ju6dtr(this.u4_1);
  };
  protoOf(asList$1).p = function () {
    return ULongArray__isEmpty_impl_c3yngu(this.u4_1);
  };
  protoOf(asList$1).v4 = function (element) {
    return ULongArray__contains_impl_v9bgai(this.u4_1, element);
  };
  protoOf(asList$1).s = function (element) {
    if (!(element instanceof ULong))
      return false;
    return this.v4(element instanceof ULong ? element.s1_1 : THROW_CCE());
  };
  protoOf(asList$1).w4 = function (index) {
    Companion_instance_6.x4(index, this.n());
    return ULongArray__get_impl_pr71q9(this.u4_1, index);
  };
  protoOf(asList$1).q = function (index) {
    return new ULong(this.w4(index));
  };
  protoOf(asList$1).y4 = function (element) {
    var tmp = !(new ULong(element) == null) ? new ULong(element) : THROW_CCE();
    if (!(tmp instanceof ULong))
      return -1;
    // Inline function 'kotlin.collections.indexOf' call
    var this_0 = this.u4_1;
    var tmp_0 = _ULongArray___get_storage__impl__28e64j(this_0);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(element);
    return indexOf_0(tmp_0, tmp$ret$0);
  };
  protoOf(asList$1).t = function (element) {
    if (!(element instanceof ULong))
      return -1;
    return this.y4(element instanceof ULong ? element.s1_1 : THROW_CCE());
  };
  protoOf(asList$1).z4 = function (element) {
    var tmp = !(new ULong(element) == null) ? new ULong(element) : THROW_CCE();
    if (!(tmp instanceof ULong))
      return -1;
    // Inline function 'kotlin.collections.lastIndexOf' call
    var this_0 = this.u4_1;
    var tmp_0 = _ULongArray___get_storage__impl__28e64j(this_0);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(element);
    return lastIndexOf_0(tmp_0, tmp$ret$0);
  };
  protoOf(asList$1).u = function (element) {
    if (!(element instanceof ULong))
      return -1;
    return this.z4(element instanceof ULong ? element.s1_1 : THROW_CCE());
  };
  function isWhitespaceImpl(_this__u8e3s4) {
    // Inline function 'kotlin.code' call
    var ch = Char__toInt_impl_vasixd(_this__u8e3s4);
    return (9 <= ch ? ch <= 13 : false) || (28 <= ch ? ch <= 32 : false) || ch === 160 || (ch > 4096 && (ch === 5760 || (8192 <= ch ? ch <= 8202 : false) || ch === 8232 || ch === 8233 || ch === 8239 || ch === 8287 || ch === 12288));
  }
  function Comparator() {
  }
  function isNaN_0(_this__u8e3s4) {
    return !(_this__u8e3s4 === _this__u8e3s4);
  }
  function isInfinite(_this__u8e3s4) {
    return _this__u8e3s4 === Infinity || _this__u8e3s4 === -Infinity;
  }
  function isFinite(_this__u8e3s4) {
    return !isInfinite(_this__u8e3s4) && !isNaN_0(_this__u8e3s4);
  }
  function takeHighestOneBit(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === 0) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.countLeadingZeroBits' call
      tmp = 1 << (31 - clz32(_this__u8e3s4) | 0);
    }
    return tmp;
  }
  function toRawBits(_this__u8e3s4) {
    return doubleToRawBits(_this__u8e3s4);
  }
  function isFinite_0(_this__u8e3s4) {
    return !isInfinite_0(_this__u8e3s4) && !isNaN_1(_this__u8e3s4);
  }
  function toRawBits_0(_this__u8e3s4) {
    return floatToRawBits(_this__u8e3s4);
  }
  function countLeadingZeroBits(_this__u8e3s4) {
    var high = _this__u8e3s4.c1_1;
    var tmp;
    if (high === 0) {
      // Inline function 'kotlin.countLeadingZeroBits' call
      var this_0 = _this__u8e3s4.b1_1;
      tmp = 32 + clz32(this_0) | 0;
    } else {
      // Inline function 'kotlin.countLeadingZeroBits' call
      tmp = clz32(high);
    }
    return tmp;
  }
  function isInfinite_0(_this__u8e3s4) {
    return _this__u8e3s4 === Infinity || _this__u8e3s4 === -Infinity;
  }
  function isNaN_1(_this__u8e3s4) {
    return !(_this__u8e3s4 === _this__u8e3s4);
  }
  function countTrailingZeroBits(_this__u8e3s4) {
    var low = _this__u8e3s4.b1_1;
    return low === 0 ? 32 + countTrailingZeroBits_0(_this__u8e3s4.c1_1) | 0 : countTrailingZeroBits_0(low);
  }
  function countTrailingZeroBits_0(_this__u8e3s4) {
    // Inline function 'kotlin.countLeadingZeroBits' call
    var this_0 = ~(_this__u8e3s4 | (-_this__u8e3s4 | 0));
    return 32 - clz32(this_0) | 0;
  }
  function Unit() {
  }
  protoOf(Unit).toString = function () {
    return 'kotlin.Unit';
  };
  var Unit_instance;
  function Unit_getInstance() {
    return Unit_instance;
  }
  function uintCompare(v1, v2) {
    return compareTo_0(v1 ^ -2147483648, v2 ^ -2147483648);
  }
  function uintDivide(v1, v2) {
    // Inline function 'kotlin.UInt.toLong' call
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(v1);
    var tmp = toLong(value).u3(new Long(-1, 0));
    // Inline function 'kotlin.UInt.toLong' call
    // Inline function 'kotlin.uintToLong' call
    var value_0 = _UInt___get_data__impl__f0vqqw(v2);
    var tmp$ret$3 = toLong(value_0).u3(new Long(-1, 0));
    // Inline function 'kotlin.toUInt' call
    var this_0 = tmp.l3(tmp$ret$3);
    return _UInt___init__impl__l7qpdl(this_0.z3());
  }
  function uintRemainder(v1, v2) {
    // Inline function 'kotlin.UInt.toLong' call
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(v1);
    var tmp = toLong(value).u3(new Long(-1, 0));
    // Inline function 'kotlin.UInt.toLong' call
    // Inline function 'kotlin.uintToLong' call
    var value_0 = _UInt___get_data__impl__f0vqqw(v2);
    var tmp$ret$3 = toLong(value_0).u3(new Long(-1, 0));
    // Inline function 'kotlin.toUInt' call
    var this_0 = tmp.m3(tmp$ret$3);
    return _UInt___init__impl__l7qpdl(this_0.z3());
  }
  function ulongCompare(v1, v2) {
    return v1.w3(new Long(0, -2147483648)).d1(v2.w3(new Long(0, -2147483648)));
  }
  function ulongDivide(v1, v2) {
    // Inline function 'kotlin.ULong.toLong' call
    var dividend = _ULong___get_data__impl__fggpzb(v1);
    // Inline function 'kotlin.ULong.toLong' call
    var divisor = _ULong___get_data__impl__fggpzb(v2);
    if (divisor.d1(new Long(0, 0)) < 0) {
      var tmp;
      // Inline function 'kotlin.ULong.compareTo' call
      if (ulongCompare(_ULong___get_data__impl__fggpzb(v1), _ULong___get_data__impl__fggpzb(v2)) < 0) {
        tmp = _ULong___init__impl__c78o9k(new Long(0, 0));
      } else {
        tmp = _ULong___init__impl__c78o9k(new Long(1, 0));
      }
      return tmp;
    }
    if (dividend.d1(new Long(0, 0)) >= 0) {
      return _ULong___init__impl__c78o9k(dividend.l3(divisor));
    }
    var quotient = dividend.t3(1).l3(divisor).r3(1);
    var rem = dividend.j3(quotient.k3(divisor));
    var tmp_0;
    var tmp4 = _ULong___init__impl__c78o9k(rem);
    // Inline function 'kotlin.ULong.compareTo' call
    var other = _ULong___init__impl__c78o9k(divisor);
    if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp4), _ULong___get_data__impl__fggpzb(other)) >= 0) {
      tmp_0 = 1;
    } else {
      tmp_0 = 0;
    }
    // Inline function 'kotlin.Long.plus' call
    var other_0 = tmp_0;
    var tmp$ret$4 = quotient.i3(toLong(other_0));
    return _ULong___init__impl__c78o9k(tmp$ret$4);
  }
  function ulongRemainder(v1, v2) {
    // Inline function 'kotlin.ULong.toLong' call
    var dividend = _ULong___get_data__impl__fggpzb(v1);
    // Inline function 'kotlin.ULong.toLong' call
    var divisor = _ULong___get_data__impl__fggpzb(v2);
    if (divisor.d1(new Long(0, 0)) < 0) {
      var tmp;
      // Inline function 'kotlin.ULong.compareTo' call
      if (ulongCompare(_ULong___get_data__impl__fggpzb(v1), _ULong___get_data__impl__fggpzb(v2)) < 0) {
        tmp = v1;
      } else {
        // Inline function 'kotlin.ULong.minus' call
        tmp = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(v1).j3(_ULong___get_data__impl__fggpzb(v2)));
      }
      return tmp;
    }
    if (dividend.d1(new Long(0, 0)) >= 0) {
      return _ULong___init__impl__c78o9k(dividend.m3(divisor));
    }
    var quotient = dividend.t3(1).l3(divisor).r3(1);
    var rem = dividend.j3(quotient.k3(divisor));
    var tmp_0;
    var tmp6 = _ULong___init__impl__c78o9k(rem);
    // Inline function 'kotlin.ULong.compareTo' call
    var other = _ULong___init__impl__c78o9k(divisor);
    if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp6), _ULong___get_data__impl__fggpzb(other)) >= 0) {
      tmp_0 = divisor;
    } else {
      tmp_0 = new Long(0, 0);
    }
    return _ULong___init__impl__c78o9k(rem.j3(tmp_0));
  }
  function ulongToString(value, base) {
    if (value.d1(new Long(0, 0)) >= 0)
      return toString_2(value, base);
    // Inline function 'kotlin.Long.div' call
    var quotient = value.t3(1).l3(toLong(base)).r3(1);
    // Inline function 'kotlin.Long.times' call
    var tmp$ret$1 = quotient.k3(toLong(base));
    var rem = value.j3(tmp$ret$1);
    if (rem.d1(toLong(base)) >= 0) {
      // Inline function 'kotlin.Long.minus' call
      rem = rem.j3(toLong(base));
      // Inline function 'kotlin.Long.plus' call
      quotient = quotient.i3(toLong(1));
    }
    return toString_2(quotient, base) + toString_2(rem, base);
  }
  function collectionToArray(collection) {
    return collectionToArrayCommonImpl(collection);
  }
  function terminateCollectionToArray(collectionSize, array) {
    return array;
  }
  function arrayOfNulls(reference, size) {
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return fillArrayVal(Array(size), null);
  }
  function listOf(element) {
    return arrayListOf([element]);
  }
  function setOf(element) {
    return hashSetOf([element]);
  }
  function checkIndexOverflow(index) {
    if (index < 0) {
      throwIndexOverflow();
    }
    return index;
  }
  function mapCapacity(expectedSize) {
    return expectedSize;
  }
  function sortWith_0(_this__u8e3s4, comparator) {
    collectionsSort(_this__u8e3s4, comparator);
  }
  function copyToArray(collection) {
    var tmp;
    // Inline function 'kotlin.js.asDynamic' call
    if (collection.toArray !== undefined) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = collection.toArray();
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = collectionToArray(collection);
    }
    return tmp;
  }
  function collectionsSort(list, comparator) {
    if (list.n() <= 1)
      return Unit_instance;
    var array = copyToArray(list);
    sortArrayWith(array, comparator);
    var inductionVariable = 0;
    var last = array.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.o2(i, array[i]);
      }
       while (inductionVariable < last);
  }
  function mapOf(pair) {
    return hashMapOf([pair]);
  }
  function arrayCopy(source, destination, destinationOffset, startIndex, endIndex) {
    Companion_instance_6.n4(startIndex, endIndex, source.length);
    var rangeSize = endIndex - startIndex | 0;
    Companion_instance_6.n4(destinationOffset, destinationOffset + rangeSize | 0, destination.length);
    if (isView(destination) && isView(source)) {
      // Inline function 'kotlin.js.asDynamic' call
      var subrange = source.subarray(startIndex, endIndex);
      // Inline function 'kotlin.js.asDynamic' call
      destination.set(subrange, destinationOffset);
    } else {
      if (!(source === destination) || destinationOffset <= startIndex) {
        var inductionVariable = 0;
        if (inductionVariable < rangeSize)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            destination[destinationOffset + index | 0] = source[startIndex + index | 0];
          }
           while (inductionVariable < rangeSize);
      } else {
        var inductionVariable_0 = rangeSize - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            destination[destinationOffset + index_0 | 0] = source[startIndex + index_0 | 0];
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  function AbstractMutableCollection$removeAll$lambda($elements) {
    return function (it) {
      return $elements.s(it);
    };
  }
  function AbstractMutableCollection$retainAll$lambda($elements) {
    return function (it) {
      return !$elements.s(it);
    };
  }
  function AbstractMutableCollection() {
    AbstractCollection.call(this);
  }
  protoOf(AbstractMutableCollection).k2 = function (element) {
    this.a5();
    var iterator = this.k();
    while (iterator.l()) {
      if (equals(iterator.m(), element)) {
        iterator.b5();
        return true;
      }
    }
    return false;
  };
  protoOf(AbstractMutableCollection).o = function (elements) {
    this.a5();
    var modified = false;
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      if (this.e(element))
        modified = true;
    }
    return modified;
  };
  protoOf(AbstractMutableCollection).k1 = function (elements) {
    this.a5();
    var tmp = isInterface(this, MutableIterable) ? this : THROW_CCE();
    return removeAll_1(tmp, AbstractMutableCollection$removeAll$lambda(elements));
  };
  protoOf(AbstractMutableCollection).l2 = function (elements) {
    this.a5();
    var tmp = isInterface(this, MutableIterable) ? this : THROW_CCE();
    return removeAll_1(tmp, AbstractMutableCollection$retainAll$lambda(elements));
  };
  protoOf(AbstractMutableCollection).m2 = function () {
    this.a5();
    var iterator = this.k();
    while (iterator.l()) {
      iterator.m();
      iterator.b5();
    }
  };
  protoOf(AbstractMutableCollection).toJSON = function () {
    return this.toArray();
  };
  protoOf(AbstractMutableCollection).a5 = function () {
  };
  function IteratorImpl($outer) {
    this.e5_1 = $outer;
    this.c5_1 = 0;
    this.d5_1 = -1;
  }
  protoOf(IteratorImpl).l = function () {
    return this.c5_1 < this.e5_1.n();
  };
  protoOf(IteratorImpl).m = function () {
    if (!this.l())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.c5_1;
    this.c5_1 = _unary__edvuaz + 1 | 0;
    tmp.d5_1 = _unary__edvuaz;
    return this.e5_1.q(this.d5_1);
  };
  protoOf(IteratorImpl).b5 = function () {
    // Inline function 'kotlin.check' call
    if (!!(this.d5_1 === -1)) {
      // Inline function 'kotlin.collections.IteratorImpl.remove.<anonymous>' call
      var message = 'Call next() or previous() before removing element from the iterator.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.e5_1.q2(this.d5_1);
    this.c5_1 = this.d5_1;
    this.d5_1 = -1;
  };
  function ListIteratorImpl($outer, index) {
    this.j5_1 = $outer;
    IteratorImpl.call(this, $outer);
    Companion_instance_6.k5(index, this.j5_1.n());
    this.c5_1 = index;
  }
  protoOf(ListIteratorImpl).l5 = function () {
    return this.c5_1 > 0;
  };
  protoOf(ListIteratorImpl).m5 = function () {
    return this.c5_1;
  };
  protoOf(ListIteratorImpl).n5 = function () {
    if (!this.l5())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    this.c5_1 = this.c5_1 - 1 | 0;
    tmp.d5_1 = this.c5_1;
    return this.j5_1.q(this.d5_1);
  };
  protoOf(ListIteratorImpl).o5 = function () {
    return this.c5_1 - 1 | 0;
  };
  function SubList(list, fromIndex, toIndex) {
    AbstractMutableList.call(this);
    this.q5_1 = list;
    this.r5_1 = fromIndex;
    this.s5_1 = 0;
    Companion_instance_6.n4(this.r5_1, toIndex, this.q5_1.n());
    this.s5_1 = toIndex - this.r5_1 | 0;
  }
  protoOf(SubList).p2 = function (index, element) {
    Companion_instance_6.k5(index, this.s5_1);
    this.q5_1.p2(this.r5_1 + index | 0, element);
    this.s5_1 = this.s5_1 + 1 | 0;
  };
  protoOf(SubList).q = function (index) {
    Companion_instance_6.x4(index, this.s5_1);
    return this.q5_1.q(this.r5_1 + index | 0);
  };
  protoOf(SubList).q2 = function (index) {
    Companion_instance_6.x4(index, this.s5_1);
    var result = this.q5_1.q2(this.r5_1 + index | 0);
    this.s5_1 = this.s5_1 - 1 | 0;
    return result;
  };
  protoOf(SubList).o2 = function (index, element) {
    Companion_instance_6.x4(index, this.s5_1);
    return this.q5_1.o2(this.r5_1 + index | 0, element);
  };
  protoOf(SubList).t5 = function (fromIndex, toIndex) {
    this.q5_1.t5(this.r5_1 + fromIndex | 0, this.r5_1 + toIndex | 0);
    this.s5_1 = this.s5_1 - (toIndex - fromIndex | 0) | 0;
  };
  protoOf(SubList).n = function () {
    return this.s5_1;
  };
  protoOf(SubList).a5 = function () {
    return this.q5_1.a5();
  };
  function AbstractMutableList$removeAll$lambda($elements) {
    return function (it) {
      return $elements.s(it);
    };
  }
  function AbstractMutableList$retainAll$lambda($elements) {
    return function (it) {
      return !$elements.s(it);
    };
  }
  function AbstractMutableList() {
    AbstractMutableCollection.call(this);
    this.f5_1 = 0;
  }
  protoOf(AbstractMutableList).e = function (element) {
    this.a5();
    this.p2(this.n(), element);
    return true;
  };
  protoOf(AbstractMutableList).n2 = function (index, elements) {
    Companion_instance_6.k5(index, this.n());
    this.a5();
    var _index = index;
    var changed = false;
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var e = _iterator__ex2g4s.m();
      var _unary__edvuaz = _index;
      _index = _unary__edvuaz + 1 | 0;
      this.p2(_unary__edvuaz, e);
      changed = true;
    }
    return changed;
  };
  protoOf(AbstractMutableList).m2 = function () {
    this.a5();
    this.t5(0, this.n());
  };
  protoOf(AbstractMutableList).k1 = function (elements) {
    this.a5();
    return removeAll_0(this, AbstractMutableList$removeAll$lambda(elements));
  };
  protoOf(AbstractMutableList).l2 = function (elements) {
    this.a5();
    return removeAll_0(this, AbstractMutableList$retainAll$lambda(elements));
  };
  protoOf(AbstractMutableList).k = function () {
    return new IteratorImpl(this);
  };
  protoOf(AbstractMutableList).s = function (element) {
    return this.t(element) >= 0;
  };
  protoOf(AbstractMutableList).t = function (element) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var _iterator__ex2g4s = this.k();
      while (_iterator__ex2g4s.l()) {
        var item = _iterator__ex2g4s.m();
        // Inline function 'kotlin.collections.AbstractMutableList.indexOf.<anonymous>' call
        if (equals(item, element)) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  };
  protoOf(AbstractMutableList).u = function (element) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfLast' call
      var iterator = this.r(this.n());
      while (iterator.l5()) {
        // Inline function 'kotlin.collections.AbstractMutableList.lastIndexOf.<anonymous>' call
        var it = iterator.n5();
        if (equals(it, element)) {
          tmp$ret$1 = iterator.m5();
          break $l$block;
        }
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  };
  protoOf(AbstractMutableList).i2 = function () {
    return this.r(0);
  };
  protoOf(AbstractMutableList).r = function (index) {
    return new ListIteratorImpl(this, index);
  };
  protoOf(AbstractMutableList).j2 = function (fromIndex, toIndex) {
    return new SubList(this, fromIndex, toIndex);
  };
  protoOf(AbstractMutableList).t5 = function (fromIndex, toIndex) {
    var iterator = this.r(fromIndex);
    // Inline function 'kotlin.repeat' call
    var times = toIndex - fromIndex | 0;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.AbstractMutableList.removeRange.<anonymous>' call
        iterator.m();
        iterator.b5();
      }
       while (inductionVariable < times);
  };
  protoOf(AbstractMutableList).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtList) : false))
      return false;
    return Companion_instance_6.u5(this, other);
  };
  protoOf(AbstractMutableList).hashCode = function () {
    return Companion_instance_6.v5(this);
  };
  function AbstractMutableMap() {
    AbstractMap.call(this);
    this.y5_1 = null;
    this.z5_1 = null;
  }
  protoOf(AbstractMutableMap).a6 = function () {
    return new HashMapKeysDefault(this);
  };
  protoOf(AbstractMutableMap).b6 = function () {
    return new HashMapValuesDefault(this);
  };
  protoOf(AbstractMutableMap).u2 = function () {
    var tmp0_elvis_lhs = this.y5_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.a6();
      // Inline function 'kotlin.collections.AbstractMutableMap.<get-keys>.<anonymous>' call
      this.y5_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AbstractMutableMap).v2 = function () {
    var tmp0_elvis_lhs = this.z5_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.b6();
      // Inline function 'kotlin.collections.AbstractMutableMap.<get-values>.<anonymous>' call
      this.z5_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AbstractMutableMap).m2 = function () {
    this.w().m2();
  };
  protoOf(AbstractMutableMap).t2 = function (from) {
    this.a5();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = from.w().k();
    while (_iterator__ex2g4s.l()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.x();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.y();
      this.r2(key, value);
    }
  };
  protoOf(AbstractMutableMap).s2 = function (key) {
    this.a5();
    var iter = this.w().k();
    while (iter.l()) {
      var entry = iter.m();
      var k = entry.x();
      if (equals(key, k)) {
        var value = entry.y();
        iter.b5();
        return value;
      }
    }
    return null;
  };
  protoOf(AbstractMutableMap).a5 = function () {
  };
  function AbstractMutableSet() {
    AbstractMutableCollection.call(this);
  }
  protoOf(AbstractMutableSet).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtSet) : false))
      return false;
    return Companion_instance_8.f6(this, other);
  };
  protoOf(AbstractMutableSet).hashCode = function () {
    return Companion_instance_8.g6(this);
  };
  function arrayOfUninitializedElements(capacity) {
    // Inline function 'kotlin.require' call
    if (!(capacity >= 0)) {
      // Inline function 'kotlin.collections.arrayOfUninitializedElements.<anonymous>' call
      var message = 'capacity must be non-negative.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return fillArrayVal(Array(capacity), null);
  }
  function resetRange(_this__u8e3s4, fromIndex, toIndex) {
    // Inline function 'kotlin.js.nativeFill' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.fill(null, fromIndex, toIndex);
  }
  function copyOfUninitializedElements(_this__u8e3s4, newSize) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return copyOf_8(_this__u8e3s4, newSize);
  }
  function resetAt(_this__u8e3s4, index) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4[index] = null;
  }
  function Companion_3() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList_init_$Create$_0(0);
    // Inline function 'kotlin.collections.Companion.Empty.<anonymous>' call
    this_0.i_1 = true;
    tmp.h6_1 = this_0;
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function ArrayList_init_$Init$($this) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    ArrayList.call($this, tmp$ret$0);
    return $this;
  }
  function ArrayList_init_$Create$() {
    return ArrayList_init_$Init$(objectCreate(protoOf(ArrayList)));
  }
  function ArrayList_init_$Init$_0(initialCapacity, $this) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    ArrayList.call($this, tmp$ret$0);
    // Inline function 'kotlin.require' call
    if (!(initialCapacity >= 0)) {
      // Inline function 'kotlin.collections.ArrayList.<init>.<anonymous>' call
      var message = 'Negative initial capacity: ' + initialCapacity;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return $this;
  }
  function ArrayList_init_$Create$_0(initialCapacity) {
    return ArrayList_init_$Init$_0(initialCapacity, objectCreate(protoOf(ArrayList)));
  }
  function ArrayList_init_$Init$_1(elements, $this) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(elements);
    ArrayList.call($this, tmp$ret$0);
    return $this;
  }
  function ArrayList_init_$Create$_1(elements) {
    return ArrayList_init_$Init$_1(elements, objectCreate(protoOf(ArrayList)));
  }
  function increaseLength($this, amount) {
    var previous = $this.n();
    // Inline function 'kotlin.js.asDynamic' call
    $this.h_1.length = $this.n() + amount | 0;
    return previous;
  }
  function rangeCheck($this, index) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.collections.ArrayList.rangeCheck.<anonymous>' call
    Companion_instance_6.x4(index, $this.n());
    return index;
  }
  function insertionRangeCheck($this, index) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.collections.ArrayList.insertionRangeCheck.<anonymous>' call
    Companion_instance_6.k5(index, $this.n());
    return index;
  }
  function ArrayList(array) {
    Companion_getInstance_3();
    AbstractMutableList.call(this);
    this.h_1 = array;
    this.i_1 = false;
  }
  protoOf(ArrayList).e4 = function () {
    this.a5();
    this.i_1 = true;
    return this.n() > 0 ? this : Companion_getInstance_3().h6_1;
  };
  protoOf(ArrayList).i6 = function (minCapacity) {
  };
  protoOf(ArrayList).n = function () {
    return this.h_1.length;
  };
  protoOf(ArrayList).q = function (index) {
    var tmp = this.h_1[rangeCheck(this, index)];
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(ArrayList).o2 = function (index, element) {
    this.a5();
    rangeCheck(this, index);
    // Inline function 'kotlin.apply' call
    var this_0 = this.h_1[index];
    // Inline function 'kotlin.collections.ArrayList.set.<anonymous>' call
    this.h_1[index] = element;
    var tmp = this_0;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(ArrayList).e = function (element) {
    this.a5();
    // Inline function 'kotlin.js.asDynamic' call
    this.h_1.push(element);
    this.f5_1 = this.f5_1 + 1 | 0;
    return true;
  };
  protoOf(ArrayList).p2 = function (index, element) {
    this.a5();
    // Inline function 'kotlin.js.asDynamic' call
    this.h_1.splice(insertionRangeCheck(this, index), 0, element);
    this.f5_1 = this.f5_1 + 1 | 0;
  };
  protoOf(ArrayList).o = function (elements) {
    this.a5();
    if (elements.p())
      return false;
    var offset = increaseLength(this, elements.n());
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.collections.ArrayList.addAll.<anonymous>' call
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      this.h_1[offset + index_0 | 0] = item;
    }
    this.f5_1 = this.f5_1 + 1 | 0;
    return true;
  };
  protoOf(ArrayList).n2 = function (index, elements) {
    this.a5();
    insertionRangeCheck(this, index);
    if (index === this.n())
      return this.o(elements);
    if (elements.p())
      return false;
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tail = this.h_1.splice(index);
    this.o(elements);
    var offset = increaseLength(this, tail.length);
    // Inline function 'kotlin.repeat' call
    var times = tail.length;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.ArrayList.addAll.<anonymous>' call
        this.h_1[offset + index_0 | 0] = tail[index_0];
      }
       while (inductionVariable < times);
    this.f5_1 = this.f5_1 + 1 | 0;
    return true;
  };
  protoOf(ArrayList).q2 = function (index) {
    this.a5();
    rangeCheck(this, index);
    this.f5_1 = this.f5_1 + 1 | 0;
    var tmp;
    if (index === get_lastIndex_2(this)) {
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.h_1.pop();
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.h_1.splice(index, 1)[0];
    }
    return tmp;
  };
  protoOf(ArrayList).k2 = function (element) {
    this.a5();
    var inductionVariable = 0;
    var last = this.h_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.h_1[index], element)) {
          // Inline function 'kotlin.js.asDynamic' call
          this.h_1.splice(index, 1);
          this.f5_1 = this.f5_1 + 1 | 0;
          return true;
        }
      }
       while (inductionVariable <= last);
    return false;
  };
  protoOf(ArrayList).t5 = function (fromIndex, toIndex) {
    this.a5();
    this.f5_1 = this.f5_1 + 1 | 0;
    // Inline function 'kotlin.js.asDynamic' call
    this.h_1.splice(fromIndex, toIndex - fromIndex | 0);
  };
  protoOf(ArrayList).m2 = function () {
    this.a5();
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.h_1 = [];
    this.f5_1 = this.f5_1 + 1 | 0;
  };
  protoOf(ArrayList).t = function (element) {
    return indexOf(this.h_1, element);
  };
  protoOf(ArrayList).u = function (element) {
    return lastIndexOf(this.h_1, element);
  };
  protoOf(ArrayList).toString = function () {
    return arrayToString(this.h_1);
  };
  protoOf(ArrayList).j6 = function () {
    return [].slice.call(this.h_1);
  };
  protoOf(ArrayList).toArray = function () {
    return this.j6();
  };
  protoOf(ArrayList).a5 = function () {
    if (this.i_1)
      throw UnsupportedOperationException_init_$Create$();
  };
  var _stableSortingIsSupported;
  function sortArrayWith(array, comparator) {
    if (getStableSortingIsSupported()) {
      var comparison = sortArrayWith$lambda(comparator);
      // Inline function 'kotlin.js.asDynamic' call
      array.sort(comparison);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      mergeSort(array, 0, get_lastIndex(array), comparator);
    }
  }
  function getStableSortingIsSupported() {
    var tmp0_safe_receiver = _stableSortingIsSupported;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    _stableSortingIsSupported = false;
    // Inline function 'kotlin.js.unsafeCast' call
    var array = [];
    var inductionVariable = 0;
    if (inductionVariable < 600)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        array.push(index);
      }
       while (inductionVariable < 600);
    var comparison = getStableSortingIsSupported$lambda;
    // Inline function 'kotlin.js.asDynamic' call
    array.sort(comparison);
    var inductionVariable_0 = 1;
    var last = array.length;
    if (inductionVariable_0 < last)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var a = array[index_0 - 1 | 0];
        var b = array[index_0];
        if ((a & 3) === (b & 3) && a >= b)
          return false;
      }
       while (inductionVariable_0 < last);
    _stableSortingIsSupported = true;
    return true;
  }
  function mergeSort(array, start, endInclusive, comparator) {
    // Inline function 'kotlin.arrayOfNulls' call
    var size = array.length;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var buffer = fillArrayVal(Array(size), null);
    var result = mergeSort_0(array, buffer, start, endInclusive, comparator);
    if (!(result === array)) {
      var inductionVariable = start;
      if (inductionVariable <= endInclusive)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          array[i] = result[i];
        }
         while (!(i === endInclusive));
    }
  }
  function mergeSort_0(array, buffer, start, end, comparator) {
    if (start === end) {
      return array;
    }
    var median = (start + end | 0) / 2 | 0;
    var left = mergeSort_0(array, buffer, start, median, comparator);
    var right = mergeSort_0(array, buffer, median + 1 | 0, end, comparator);
    var target = left === buffer ? array : buffer;
    var leftIndex = start;
    var rightIndex = median + 1 | 0;
    var inductionVariable = start;
    if (inductionVariable <= end)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (leftIndex <= median && rightIndex <= end) {
          var leftValue = left[leftIndex];
          var rightValue = right[rightIndex];
          if (comparator.compare(leftValue, rightValue) <= 0) {
            target[i] = leftValue;
            leftIndex = leftIndex + 1 | 0;
          } else {
            target[i] = rightValue;
            rightIndex = rightIndex + 1 | 0;
          }
        } else if (leftIndex <= median) {
          target[i] = left[leftIndex];
          leftIndex = leftIndex + 1 | 0;
        } else {
          target[i] = right[rightIndex];
          rightIndex = rightIndex + 1 | 0;
        }
      }
       while (!(i === end));
    return target;
  }
  function sortArrayWith$lambda($comparator) {
    return function (a, b) {
      return $comparator.compare(a, b);
    };
  }
  function getStableSortingIsSupported$lambda(a, b) {
    return (a & 3) - (b & 3) | 0;
  }
  function HashMap_init_$Init$(internalMap, $this) {
    AbstractMutableMap.call($this);
    HashMap.call($this);
    $this.o6_1 = internalMap;
    return $this;
  }
  function HashMap_init_$Init$_0($this) {
    HashMap_init_$Init$(InternalHashMap_init_$Create$(), $this);
    return $this;
  }
  function HashMap_init_$Create$() {
    return HashMap_init_$Init$_0(objectCreate(protoOf(HashMap)));
  }
  function HashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$(InternalHashMap_init_$Create$_2(initialCapacity, loadFactor), $this);
    return $this;
  }
  function HashMap_init_$Init$_2(initialCapacity, $this) {
    HashMap_init_$Init$_1(initialCapacity, 1.0, $this);
    return $this;
  }
  function HashMap_init_$Create$_0(initialCapacity) {
    return HashMap_init_$Init$_2(initialCapacity, objectCreate(protoOf(HashMap)));
  }
  function HashMap_init_$Init$_3(original, $this) {
    HashMap_init_$Init$(InternalHashMap_init_$Create$_1(original), $this);
    return $this;
  }
  function HashMap_init_$Create$_1(original) {
    return HashMap_init_$Init$_3(original, objectCreate(protoOf(HashMap)));
  }
  protoOf(HashMap).m2 = function () {
    this.o6_1.m2();
  };
  protoOf(HashMap).w2 = function (key) {
    return this.o6_1.q6(key);
  };
  protoOf(HashMap).x2 = function (value) {
    return this.o6_1.x2(value);
  };
  protoOf(HashMap).a6 = function () {
    return new HashMapKeys(this.o6_1);
  };
  protoOf(HashMap).b6 = function () {
    return new HashMapValues(this.o6_1);
  };
  protoOf(HashMap).w = function () {
    var tmp0_elvis_lhs = this.p6_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new HashMapEntrySet(this.o6_1);
      // Inline function 'kotlin.collections.HashMap.<get-entries>.<anonymous>' call
      this.p6_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(HashMap).y2 = function (key) {
    return this.o6_1.y2(key);
  };
  protoOf(HashMap).r2 = function (key, value) {
    return this.o6_1.r2(key, value);
  };
  protoOf(HashMap).s2 = function (key) {
    return this.o6_1.s2(key);
  };
  protoOf(HashMap).n = function () {
    return this.o6_1.n();
  };
  protoOf(HashMap).t2 = function (from) {
    return this.o6_1.t2(from);
  };
  function HashMap() {
    this.p6_1 = null;
  }
  function HashMapKeys(backing) {
    AbstractMutableSet.call(this);
    this.r6_1 = backing;
  }
  protoOf(HashMapKeys).n = function () {
    return this.r6_1.n();
  };
  protoOf(HashMapKeys).p = function () {
    return this.r6_1.n() === 0;
  };
  protoOf(HashMapKeys).s = function (element) {
    return this.r6_1.q6(element);
  };
  protoOf(HashMapKeys).m2 = function () {
    return this.r6_1.m2();
  };
  protoOf(HashMapKeys).e = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(HashMapKeys).o = function (elements) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(HashMapKeys).k2 = function (element) {
    return this.r6_1.s6(element);
  };
  protoOf(HashMapKeys).k = function () {
    return this.r6_1.t6();
  };
  protoOf(HashMapKeys).a5 = function () {
    return this.r6_1.u6();
  };
  function HashMapValues(backing) {
    AbstractMutableCollection.call(this);
    this.v6_1 = backing;
  }
  protoOf(HashMapValues).n = function () {
    return this.v6_1.n();
  };
  protoOf(HashMapValues).p = function () {
    return this.v6_1.n() === 0;
  };
  protoOf(HashMapValues).w6 = function (element) {
    return this.v6_1.x2(element);
  };
  protoOf(HashMapValues).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.w6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapValues).x6 = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(HashMapValues).e = function (element) {
    return this.x6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapValues).y6 = function (elements) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(HashMapValues).o = function (elements) {
    return this.y6(elements);
  };
  protoOf(HashMapValues).m2 = function () {
    return this.v6_1.m2();
  };
  protoOf(HashMapValues).k = function () {
    return this.v6_1.z6();
  };
  protoOf(HashMapValues).a7 = function (element) {
    return this.v6_1.b7(element);
  };
  protoOf(HashMapValues).k2 = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.a7((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapValues).a5 = function () {
    return this.v6_1.u6();
  };
  function HashMapEntrySet(backing) {
    HashMapEntrySetBase.call(this, backing);
  }
  protoOf(HashMapEntrySet).k = function () {
    return this.d7_1.e7();
  };
  function HashMapEntrySetBase(backing) {
    AbstractMutableSet.call(this);
    this.d7_1 = backing;
  }
  protoOf(HashMapEntrySetBase).n = function () {
    return this.d7_1.n();
  };
  protoOf(HashMapEntrySetBase).p = function () {
    return this.d7_1.n() === 0;
  };
  protoOf(HashMapEntrySetBase).f7 = function (element) {
    return this.d7_1.i7(element);
  };
  protoOf(HashMapEntrySetBase).s = function (element) {
    if (!(!(element == null) ? isInterface(element, Entry) : false))
      return false;
    return this.f7((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  protoOf(HashMapEntrySetBase).m2 = function () {
    return this.d7_1.m2();
  };
  protoOf(HashMapEntrySetBase).g7 = function (element) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(HashMapEntrySetBase).e = function (element) {
    return this.g7((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  protoOf(HashMapEntrySetBase).o = function (elements) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(HashMapEntrySetBase).h7 = function (element) {
    return this.d7_1.j7(element);
  };
  protoOf(HashMapEntrySetBase).k2 = function (element) {
    if (!(!(element == null) ? isInterface(element, Entry) : false))
      return false;
    return this.h7((!(element == null) ? isInterface(element, Entry) : false) ? element : THROW_CCE());
  };
  protoOf(HashMapEntrySetBase).h2 = function (elements) {
    return this.d7_1.k7(elements);
  };
  protoOf(HashMapEntrySetBase).a5 = function () {
    return this.d7_1.u6();
  };
  function HashMapKeysDefault$iterator$1($entryIterator) {
    this.l7_1 = $entryIterator;
  }
  protoOf(HashMapKeysDefault$iterator$1).l = function () {
    return this.l7_1.l();
  };
  protoOf(HashMapKeysDefault$iterator$1).m = function () {
    return this.l7_1.m().x();
  };
  protoOf(HashMapKeysDefault$iterator$1).b5 = function () {
    return this.l7_1.b5();
  };
  function HashMapKeysDefault(backingMap) {
    AbstractMutableSet.call(this);
    this.m7_1 = backingMap;
  }
  protoOf(HashMapKeysDefault).n7 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on keys');
  };
  protoOf(HashMapKeysDefault).e = function (element) {
    return this.n7((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapKeysDefault).m2 = function () {
    return this.m7_1.m2();
  };
  protoOf(HashMapKeysDefault).q6 = function (element) {
    return this.m7_1.w2(element);
  };
  protoOf(HashMapKeysDefault).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.q6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapKeysDefault).k = function () {
    var entryIterator = this.m7_1.w().k();
    return new HashMapKeysDefault$iterator$1(entryIterator);
  };
  protoOf(HashMapKeysDefault).s2 = function (element) {
    this.a5();
    if (this.m7_1.w2(element)) {
      this.m7_1.s2(element);
      return true;
    }
    return false;
  };
  protoOf(HashMapKeysDefault).k2 = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.s2((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapKeysDefault).n = function () {
    return this.m7_1.n();
  };
  protoOf(HashMapKeysDefault).a5 = function () {
    return this.m7_1.a5();
  };
  function HashMapValuesDefault$iterator$1($entryIterator) {
    this.o7_1 = $entryIterator;
  }
  protoOf(HashMapValuesDefault$iterator$1).l = function () {
    return this.o7_1.l();
  };
  protoOf(HashMapValuesDefault$iterator$1).m = function () {
    return this.o7_1.m().y();
  };
  protoOf(HashMapValuesDefault$iterator$1).b5 = function () {
    return this.o7_1.b5();
  };
  function HashMapValuesDefault(backingMap) {
    AbstractMutableCollection.call(this);
    this.p7_1 = backingMap;
  }
  protoOf(HashMapValuesDefault).x6 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on values');
  };
  protoOf(HashMapValuesDefault).e = function (element) {
    return this.x6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapValuesDefault).m2 = function () {
    return this.p7_1.m2();
  };
  protoOf(HashMapValuesDefault).w6 = function (element) {
    return this.p7_1.x2(element);
  };
  protoOf(HashMapValuesDefault).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.w6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(HashMapValuesDefault).k = function () {
    var entryIterator = this.p7_1.w().k();
    return new HashMapValuesDefault$iterator$1(entryIterator);
  };
  protoOf(HashMapValuesDefault).n = function () {
    return this.p7_1.n();
  };
  protoOf(HashMapValuesDefault).a5 = function () {
    return this.p7_1.a5();
  };
  function HashSet_init_$Init$(map, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this.h1_1 = map;
    return $this;
  }
  function HashSet_init_$Init$_0($this) {
    HashSet_init_$Init$(InternalHashMap_init_$Create$(), $this);
    return $this;
  }
  function HashSet_init_$Create$() {
    return HashSet_init_$Init$_0(objectCreate(protoOf(HashSet)));
  }
  function HashSet_init_$Init$_1(elements, $this) {
    HashSet_init_$Init$(InternalHashMap_init_$Create$_0(elements.n()), $this);
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      $this.h1_1.r2(element, true);
    }
    return $this;
  }
  function HashSet_init_$Create$_0(elements) {
    return HashSet_init_$Init$_1(elements, objectCreate(protoOf(HashSet)));
  }
  function HashSet_init_$Init$_2(initialCapacity, loadFactor, $this) {
    HashSet_init_$Init$(InternalHashMap_init_$Create$_2(initialCapacity, loadFactor), $this);
    return $this;
  }
  function HashSet_init_$Init$_3(initialCapacity, $this) {
    HashSet_init_$Init$_2(initialCapacity, 1.0, $this);
    return $this;
  }
  function HashSet_init_$Create$_1(initialCapacity) {
    return HashSet_init_$Init$_3(initialCapacity, objectCreate(protoOf(HashSet)));
  }
  protoOf(HashSet).e = function (element) {
    return this.h1_1.r2(element, true) == null;
  };
  protoOf(HashSet).m2 = function () {
    this.h1_1.m2();
  };
  protoOf(HashSet).s = function (element) {
    return this.h1_1.q6(element);
  };
  protoOf(HashSet).p = function () {
    return this.h1_1.n() === 0;
  };
  protoOf(HashSet).k = function () {
    return this.h1_1.t6();
  };
  protoOf(HashSet).k2 = function (element) {
    return !(this.h1_1.s2(element) == null);
  };
  protoOf(HashSet).n = function () {
    return this.h1_1.n();
  };
  function HashSet() {
  }
  function computeHashSize($this, capacity) {
    return takeHighestOneBit(imul(coerceAtLeast(capacity, 1), 3));
  }
  function computeShift($this, hashSize) {
    // Inline function 'kotlin.countLeadingZeroBits' call
    return clz32(hashSize) + 1 | 0;
  }
  function checkForComodification($this) {
    if (!($this.a8_1.x7_1 === $this.c8_1))
      throw ConcurrentModificationException_init_$Create$_0('The backing map has been modified after this entry was obtained.');
  }
  function InternalHashMap_init_$Init$($this) {
    InternalHashMap_init_$Init$_0(8, $this);
    return $this;
  }
  function InternalHashMap_init_$Create$() {
    return InternalHashMap_init_$Init$(objectCreate(protoOf(InternalHashMap)));
  }
  function InternalHashMap_init_$Init$_0(initialCapacity, $this) {
    InternalHashMap.call($this, arrayOfUninitializedElements(initialCapacity), null, new Int32Array(initialCapacity), new Int32Array(computeHashSize(Companion_instance_4, initialCapacity)), 2, 0);
    return $this;
  }
  function InternalHashMap_init_$Create$_0(initialCapacity) {
    return InternalHashMap_init_$Init$_0(initialCapacity, objectCreate(protoOf(InternalHashMap)));
  }
  function InternalHashMap_init_$Init$_1(original, $this) {
    InternalHashMap_init_$Init$_0(original.n(), $this);
    $this.t2(original);
    return $this;
  }
  function InternalHashMap_init_$Create$_1(original) {
    return InternalHashMap_init_$Init$_1(original, objectCreate(protoOf(InternalHashMap)));
  }
  function InternalHashMap_init_$Init$_2(initialCapacity, loadFactor, $this) {
    InternalHashMap_init_$Init$_0(initialCapacity, $this);
    // Inline function 'kotlin.require' call
    if (!(loadFactor > 0)) {
      // Inline function 'kotlin.collections.InternalHashMap.<init>.<anonymous>' call
      var message = 'Non-positive load factor: ' + loadFactor;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return $this;
  }
  function InternalHashMap_init_$Create$_2(initialCapacity, loadFactor) {
    return InternalHashMap_init_$Init$_2(initialCapacity, loadFactor, objectCreate(protoOf(InternalHashMap)));
  }
  function _get_capacity__a9k9f3($this) {
    return $this.q7_1.length;
  }
  function _get_hashSize__tftcho($this) {
    return $this.t7_1.length;
  }
  function registerModification($this) {
    $this.x7_1 = $this.x7_1 + 1 | 0;
  }
  function ensureExtraCapacity($this, n) {
    if (shouldCompact($this, n)) {
      compact($this, true);
    } else {
      ensureCapacity($this, $this.v7_1 + n | 0);
    }
  }
  function shouldCompact($this, extraCapacity) {
    var spareCapacity = _get_capacity__a9k9f3($this) - $this.v7_1 | 0;
    var gaps = $this.v7_1 - $this.n() | 0;
    return spareCapacity < extraCapacity && (gaps + spareCapacity | 0) >= extraCapacity && gaps >= (_get_capacity__a9k9f3($this) / 4 | 0);
  }
  function ensureCapacity($this, minCapacity) {
    if (minCapacity < 0)
      throw RuntimeException_init_$Create$_0('too many elements');
    if (minCapacity > _get_capacity__a9k9f3($this)) {
      var newSize = Companion_instance_6.d8(_get_capacity__a9k9f3($this), minCapacity);
      $this.q7_1 = copyOfUninitializedElements($this.q7_1, newSize);
      var tmp = $this;
      var tmp0_safe_receiver = $this.r7_1;
      tmp.r7_1 = tmp0_safe_receiver == null ? null : copyOfUninitializedElements(tmp0_safe_receiver, newSize);
      $this.s7_1 = copyOf_3($this.s7_1, newSize);
      var newHashSize = computeHashSize(Companion_instance_4, newSize);
      if (newHashSize > _get_hashSize__tftcho($this)) {
        rehash($this, newHashSize);
      }
    }
  }
  function allocateValuesArray($this) {
    var curValuesArray = $this.r7_1;
    if (!(curValuesArray == null))
      return curValuesArray;
    var newValuesArray = arrayOfUninitializedElements(_get_capacity__a9k9f3($this));
    $this.r7_1 = newValuesArray;
    return newValuesArray;
  }
  function hash($this, key) {
    return key == null ? 0 : imul(hashCode(key), -1640531527) >>> $this.w7_1 | 0;
  }
  function compact($this, updateHashArray) {
    var i = 0;
    var j = 0;
    var valuesArray = $this.r7_1;
    while (i < $this.v7_1) {
      var hash = $this.s7_1[i];
      if (hash >= 0) {
        $this.q7_1[j] = $this.q7_1[i];
        if (!(valuesArray == null)) {
          valuesArray[j] = valuesArray[i];
        }
        if (updateHashArray) {
          $this.s7_1[j] = hash;
          $this.t7_1[hash] = j + 1 | 0;
        }
        j = j + 1 | 0;
      }
      i = i + 1 | 0;
    }
    resetRange($this.q7_1, j, $this.v7_1);
    if (valuesArray == null)
      null;
    else {
      resetRange(valuesArray, j, $this.v7_1);
    }
    $this.v7_1 = j;
  }
  function rehash($this, newHashSize) {
    registerModification($this);
    if ($this.v7_1 > $this.y7_1) {
      compact($this, false);
    }
    $this.t7_1 = new Int32Array(newHashSize);
    $this.w7_1 = computeShift(Companion_instance_4, newHashSize);
    var i = 0;
    while (i < $this.v7_1) {
      var _unary__edvuaz = i;
      i = _unary__edvuaz + 1 | 0;
      if (!putRehash($this, _unary__edvuaz)) {
        throw IllegalStateException_init_$Create$_0('This cannot happen with fixed magic multiplier and grow-only hash array. Have object hashCodes changed?');
      }
    }
  }
  function putRehash($this, i) {
    var hash_0 = hash($this, $this.q7_1[i]);
    var probesLeft = $this.u7_1;
    while (true) {
      var index = $this.t7_1[hash_0];
      if (index === 0) {
        $this.t7_1[hash_0] = i + 1 | 0;
        $this.s7_1[i] = hash_0;
        return true;
      }
      probesLeft = probesLeft - 1 | 0;
      if (probesLeft < 0)
        return false;
      var _unary__edvuaz = hash_0;
      hash_0 = _unary__edvuaz - 1 | 0;
      if (_unary__edvuaz === 0)
        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
    }
  }
  function findKey($this, key) {
    var hash_0 = hash($this, key);
    var probesLeft = $this.u7_1;
    while (true) {
      var index = $this.t7_1[hash_0];
      if (index === 0)
        return -1;
      if (index > 0 && equals($this.q7_1[index - 1 | 0], key))
        return index - 1 | 0;
      probesLeft = probesLeft - 1 | 0;
      if (probesLeft < 0)
        return -1;
      var _unary__edvuaz = hash_0;
      hash_0 = _unary__edvuaz - 1 | 0;
      if (_unary__edvuaz === 0)
        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
    }
  }
  function findValue($this, value) {
    var i = $this.v7_1;
    $l$loop: while (true) {
      i = i - 1 | 0;
      if (!(i >= 0)) {
        break $l$loop;
      }
      if ($this.s7_1[i] >= 0 && equals(ensureNotNull($this.r7_1)[i], value))
        return i;
    }
    return -1;
  }
  function addKey($this, key) {
    $this.u6();
    retry: while (true) {
      var hash_0 = hash($this, key);
      var tentativeMaxProbeDistance = coerceAtMost(imul($this.u7_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
      var probeDistance = 0;
      while (true) {
        var index = $this.t7_1[hash_0];
        if (index <= 0) {
          if ($this.v7_1 >= _get_capacity__a9k9f3($this)) {
            ensureExtraCapacity($this, 1);
            continue retry;
          }
          var _unary__edvuaz = $this.v7_1;
          $this.v7_1 = _unary__edvuaz + 1 | 0;
          var putIndex = _unary__edvuaz;
          $this.q7_1[putIndex] = key;
          $this.s7_1[putIndex] = hash_0;
          $this.t7_1[hash_0] = putIndex + 1 | 0;
          $this.y7_1 = $this.y7_1 + 1 | 0;
          registerModification($this);
          if (probeDistance > $this.u7_1)
            $this.u7_1 = probeDistance;
          return putIndex;
        }
        if (equals($this.q7_1[index - 1 | 0], key)) {
          return -index | 0;
        }
        probeDistance = probeDistance + 1 | 0;
        if (probeDistance > tentativeMaxProbeDistance) {
          rehash($this, imul(_get_hashSize__tftcho($this), 2));
          continue retry;
        }
        var _unary__edvuaz_0 = hash_0;
        hash_0 = _unary__edvuaz_0 - 1 | 0;
        if (_unary__edvuaz_0 === 0)
          hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
      }
    }
  }
  function removeEntryAt($this, index) {
    resetAt($this.q7_1, index);
    var tmp0_safe_receiver = $this.r7_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      resetAt(tmp0_safe_receiver, index);
    }
    removeHashAt($this, $this.s7_1[index]);
    $this.s7_1[index] = -1;
    $this.y7_1 = $this.y7_1 - 1 | 0;
    registerModification($this);
  }
  function removeHashAt($this, removedHash) {
    var hash_0 = removedHash;
    var hole = removedHash;
    var probeDistance = 0;
    var patchAttemptsLeft = coerceAtMost(imul($this.u7_1, 2), _get_hashSize__tftcho($this) / 2 | 0);
    while (true) {
      var _unary__edvuaz = hash_0;
      hash_0 = _unary__edvuaz - 1 | 0;
      if (_unary__edvuaz === 0)
        hash_0 = _get_hashSize__tftcho($this) - 1 | 0;
      probeDistance = probeDistance + 1 | 0;
      if (probeDistance > $this.u7_1) {
        $this.t7_1[hole] = 0;
        return Unit_instance;
      }
      var index = $this.t7_1[hash_0];
      if (index === 0) {
        $this.t7_1[hole] = 0;
        return Unit_instance;
      }
      if (index < 0) {
        $this.t7_1[hole] = -1;
        hole = hash_0;
        probeDistance = 0;
      } else {
        var otherHash = hash($this, $this.q7_1[index - 1 | 0]);
        if (((otherHash - hash_0 | 0) & (_get_hashSize__tftcho($this) - 1 | 0)) >= probeDistance) {
          $this.t7_1[hole] = index;
          $this.s7_1[index - 1 | 0] = hole;
          hole = hash_0;
          probeDistance = 0;
        }
      }
      patchAttemptsLeft = patchAttemptsLeft - 1 | 0;
      if (patchAttemptsLeft < 0) {
        $this.t7_1[hole] = -1;
        return Unit_instance;
      }
    }
  }
  function contentEquals_1($this, other) {
    return $this.y7_1 === other.n() && $this.k7(other.w());
  }
  function putEntry($this, entry) {
    var index = addKey($this, entry.x());
    var valuesArray = allocateValuesArray($this);
    if (index >= 0) {
      valuesArray[index] = entry.y();
      return true;
    }
    var oldValue = valuesArray[(-index | 0) - 1 | 0];
    if (!equals(entry.y(), oldValue)) {
      valuesArray[(-index | 0) - 1 | 0] = entry.y();
      return true;
    }
    return false;
  }
  function putAllEntries($this, from) {
    if (from.p())
      return false;
    ensureExtraCapacity($this, from.n());
    var it = from.k();
    var updated = false;
    while (it.l()) {
      if (putEntry($this, it.m()))
        updated = true;
    }
    return updated;
  }
  function Companion_4() {
    this.e8_1 = -1640531527;
    this.f8_1 = 8;
    this.g8_1 = 2;
    this.h8_1 = -1;
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function Itr(map) {
    this.i8_1 = map;
    this.j8_1 = 0;
    this.k8_1 = -1;
    this.l8_1 = this.i8_1.x7_1;
    this.m8();
  }
  protoOf(Itr).m8 = function () {
    while (this.j8_1 < this.i8_1.v7_1 && this.i8_1.s7_1[this.j8_1] < 0) {
      this.j8_1 = this.j8_1 + 1 | 0;
    }
  };
  protoOf(Itr).l = function () {
    return this.j8_1 < this.i8_1.v7_1;
  };
  protoOf(Itr).b5 = function () {
    this.n8();
    // Inline function 'kotlin.check' call
    if (!!(this.k8_1 === -1)) {
      // Inline function 'kotlin.collections.Itr.remove.<anonymous>' call
      var message = 'Call next() before removing element from the iterator.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.i8_1.u6();
    removeEntryAt(this.i8_1, this.k8_1);
    this.k8_1 = -1;
    this.l8_1 = this.i8_1.x7_1;
  };
  protoOf(Itr).n8 = function () {
    if (!(this.i8_1.x7_1 === this.l8_1))
      throw ConcurrentModificationException_init_$Create$();
  };
  function KeysItr(map) {
    Itr.call(this, map);
  }
  protoOf(KeysItr).m = function () {
    this.n8();
    if (this.j8_1 >= this.i8_1.v7_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.j8_1;
    this.j8_1 = _unary__edvuaz + 1 | 0;
    tmp.k8_1 = _unary__edvuaz;
    var result = this.i8_1.q7_1[this.k8_1];
    this.m8();
    return result;
  };
  function ValuesItr(map) {
    Itr.call(this, map);
  }
  protoOf(ValuesItr).m = function () {
    this.n8();
    if (this.j8_1 >= this.i8_1.v7_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.j8_1;
    this.j8_1 = _unary__edvuaz + 1 | 0;
    tmp.k8_1 = _unary__edvuaz;
    var result = ensureNotNull(this.i8_1.r7_1)[this.k8_1];
    this.m8();
    return result;
  };
  function EntriesItr(map) {
    Itr.call(this, map);
  }
  protoOf(EntriesItr).m = function () {
    this.n8();
    if (this.j8_1 >= this.i8_1.v7_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.j8_1;
    this.j8_1 = _unary__edvuaz + 1 | 0;
    tmp.k8_1 = _unary__edvuaz;
    var result = new EntryRef(this.i8_1, this.k8_1);
    this.m8();
    return result;
  };
  protoOf(EntriesItr).a9 = function () {
    if (this.j8_1 >= this.i8_1.v7_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.j8_1;
    this.j8_1 = _unary__edvuaz + 1 | 0;
    tmp.k8_1 = _unary__edvuaz;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.i8_1.q7_1[this.k8_1];
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = ensureNotNull(this.i8_1.r7_1)[this.k8_1];
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    var result = tmp_0 ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
    this.m8();
    return result;
  };
  protoOf(EntriesItr).b9 = function (sb) {
    if (this.j8_1 >= this.i8_1.v7_1)
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var _unary__edvuaz = this.j8_1;
    this.j8_1 = _unary__edvuaz + 1 | 0;
    tmp.k8_1 = _unary__edvuaz;
    var key = this.i8_1.q7_1[this.k8_1];
    if (equals(key, this.i8_1))
      sb.d9('(this Map)');
    else
      sb.c9(key);
    sb.e9(_Char___init__impl__6a9atx(61));
    var value = ensureNotNull(this.i8_1.r7_1)[this.k8_1];
    if (equals(value, this.i8_1))
      sb.d9('(this Map)');
    else
      sb.c9(value);
    this.m8();
  };
  function EntryRef(map, index) {
    this.a8_1 = map;
    this.b8_1 = index;
    this.c8_1 = this.a8_1.x7_1;
  }
  protoOf(EntryRef).x = function () {
    checkForComodification(this);
    return this.a8_1.q7_1[this.b8_1];
  };
  protoOf(EntryRef).y = function () {
    checkForComodification(this);
    return ensureNotNull(this.a8_1.r7_1)[this.b8_1];
  };
  protoOf(EntryRef).equals = function (other) {
    var tmp;
    var tmp_0;
    if (!(other == null) ? isInterface(other, Entry) : false) {
      tmp_0 = equals(other.x(), this.x());
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(other.y(), this.y());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EntryRef).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.x();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.y();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    return tmp ^ (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0);
  };
  protoOf(EntryRef).toString = function () {
    return toString_0(this.x()) + '=' + toString_0(this.y());
  };
  function InternalHashMap(keysArray, valuesArray, presenceArray, hashArray, maxProbeDistance, length) {
    this.q7_1 = keysArray;
    this.r7_1 = valuesArray;
    this.s7_1 = presenceArray;
    this.t7_1 = hashArray;
    this.u7_1 = maxProbeDistance;
    this.v7_1 = length;
    this.w7_1 = computeShift(Companion_instance_4, _get_hashSize__tftcho(this));
    this.x7_1 = 0;
    this.y7_1 = 0;
    this.z7_1 = false;
  }
  protoOf(InternalHashMap).n = function () {
    return this.y7_1;
  };
  protoOf(InternalHashMap).f9 = function () {
    this.u6();
    this.z7_1 = true;
  };
  protoOf(InternalHashMap).x2 = function (value) {
    return findValue(this, value) >= 0;
  };
  protoOf(InternalHashMap).y2 = function (key) {
    var index = findKey(this, key);
    if (index < 0)
      return null;
    return ensureNotNull(this.r7_1)[index];
  };
  protoOf(InternalHashMap).q6 = function (key) {
    return findKey(this, key) >= 0;
  };
  protoOf(InternalHashMap).r2 = function (key, value) {
    var index = addKey(this, key);
    var valuesArray = allocateValuesArray(this);
    if (index < 0) {
      var oldValue = valuesArray[(-index | 0) - 1 | 0];
      valuesArray[(-index | 0) - 1 | 0] = value;
      return oldValue;
    } else {
      valuesArray[index] = value;
      return null;
    }
  };
  protoOf(InternalHashMap).t2 = function (from) {
    this.u6();
    putAllEntries(this, from.w());
  };
  protoOf(InternalHashMap).s2 = function (key) {
    this.u6();
    var index = findKey(this, key);
    if (index < 0)
      return null;
    var oldValue = ensureNotNull(this.r7_1)[index];
    removeEntryAt(this, index);
    return oldValue;
  };
  protoOf(InternalHashMap).m2 = function () {
    this.u6();
    var inductionVariable = 0;
    var last = this.v7_1 - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var hash = this.s7_1[i];
        if (hash >= 0) {
          this.t7_1[hash] = 0;
          this.s7_1[i] = -1;
        }
      }
       while (!(i === last));
    resetRange(this.q7_1, 0, this.v7_1);
    var tmp0_safe_receiver = this.r7_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      resetRange(tmp0_safe_receiver, 0, this.v7_1);
    }
    this.y7_1 = 0;
    this.v7_1 = 0;
    registerModification(this);
  };
  protoOf(InternalHashMap).equals = function (other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      if (!(other == null) ? isInterface(other, KtMap) : false) {
        tmp_0 = contentEquals_1(this, other);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(InternalHashMap).hashCode = function () {
    var result = 0;
    var it = this.e7();
    while (it.l()) {
      result = result + it.a9() | 0;
    }
    return result;
  };
  protoOf(InternalHashMap).toString = function () {
    var sb = StringBuilder_init_$Create$(2 + imul(this.y7_1, 3) | 0);
    sb.d9('{');
    var i = 0;
    var it = this.e7();
    while (it.l()) {
      if (i > 0) {
        sb.d9(', ');
      }
      it.b9(sb);
      i = i + 1 | 0;
    }
    sb.d9('}');
    return sb.toString();
  };
  protoOf(InternalHashMap).u6 = function () {
    if (this.z7_1)
      throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(InternalHashMap).s6 = function (key) {
    this.u6();
    var index = findKey(this, key);
    if (index < 0)
      return false;
    removeEntryAt(this, index);
    return true;
  };
  protoOf(InternalHashMap).i7 = function (entry) {
    var index = findKey(this, entry.x());
    if (index < 0)
      return false;
    return equals(ensureNotNull(this.r7_1)[index], entry.y());
  };
  protoOf(InternalHashMap).g9 = function (entry) {
    return this.i7(isInterface(entry, Entry) ? entry : THROW_CCE());
  };
  protoOf(InternalHashMap).j7 = function (entry) {
    this.u6();
    var index = findKey(this, entry.x());
    if (index < 0)
      return false;
    if (!equals(ensureNotNull(this.r7_1)[index], entry.y()))
      return false;
    removeEntryAt(this, index);
    return true;
  };
  protoOf(InternalHashMap).b7 = function (value) {
    this.u6();
    var index = findValue(this, value);
    if (index < 0)
      return false;
    removeEntryAt(this, index);
    return true;
  };
  protoOf(InternalHashMap).t6 = function () {
    return new KeysItr(this);
  };
  protoOf(InternalHashMap).z6 = function () {
    return new ValuesItr(this);
  };
  protoOf(InternalHashMap).e7 = function () {
    return new EntriesItr(this);
  };
  function InternalMap() {
  }
  function LinkedHashMap_init_$Init$($this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    return $this;
  }
  function LinkedHashMap_init_$Create$() {
    return LinkedHashMap_init_$Init$(objectCreate(protoOf(LinkedHashMap)));
  }
  function LinkedHashMap_init_$Init$_0(initialCapacity, $this) {
    HashMap_init_$Init$_2(initialCapacity, $this);
    LinkedHashMap.call($this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_0(initialCapacity) {
    return LinkedHashMap_init_$Init$_0(initialCapacity, objectCreate(protoOf(LinkedHashMap)));
  }
  function LinkedHashMap_init_$Init$_1(original, $this) {
    HashMap_init_$Init$_3(original, $this);
    LinkedHashMap.call($this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_1(original) {
    return LinkedHashMap_init_$Init$_1(original, objectCreate(protoOf(LinkedHashMap)));
  }
  protoOf(LinkedHashMap).a5 = function () {
    return this.o6_1.u6();
  };
  function LinkedHashMap() {
  }
  function LinkedHashSet_init_$Init$($this) {
    HashSet_init_$Init$_0($this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Create$() {
    return LinkedHashSet_init_$Init$(objectCreate(protoOf(LinkedHashSet)));
  }
  function LinkedHashSet_init_$Init$_0(elements, $this) {
    HashSet_init_$Init$_1(elements, $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Create$_0(elements) {
    return LinkedHashSet_init_$Init$_0(elements, objectCreate(protoOf(LinkedHashSet)));
  }
  function LinkedHashSet_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashSet_init_$Init$_2(initialCapacity, loadFactor, $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Init$_2(initialCapacity, $this) {
    LinkedHashSet_init_$Init$_1(initialCapacity, 1.0, $this);
    return $this;
  }
  function LinkedHashSet_init_$Create$_1(initialCapacity) {
    return LinkedHashSet_init_$Init$_2(initialCapacity, objectCreate(protoOf(LinkedHashSet)));
  }
  function LinkedHashSet_init_$Init$_3(internalMap, $this) {
    HashSet_init_$Init$(internalMap, $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Create$_2(internalMap) {
    return LinkedHashSet_init_$Init$_3(internalMap, objectCreate(protoOf(LinkedHashSet)));
  }
  function EmptyHolder() {
    EmptyHolder_instance = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = InternalHashMap_init_$Create$_0(0);
    // Inline function 'kotlin.collections.EmptyHolder.value.<anonymous>' call
    this_0.f9();
    tmp.n9_1 = LinkedHashSet_init_$Create$_2(this_0);
  }
  var EmptyHolder_instance;
  function EmptyHolder_getInstance() {
    if (EmptyHolder_instance == null)
      new EmptyHolder();
    return EmptyHolder_instance;
  }
  protoOf(LinkedHashSet).e4 = function () {
    this.h1_1.f9();
    return this.n() > 0 ? this : EmptyHolder_getInstance().n9_1;
  };
  protoOf(LinkedHashSet).a5 = function () {
    return this.h1_1.u6();
  };
  function LinkedHashSet() {
  }
  function RandomAccess() {
  }
  function get_output() {
    _init_properties_console_kt__rfg7jv();
    return output;
  }
  var output;
  function BaseOutput() {
  }
  protoOf(BaseOutput).p9 = function () {
    this.q9('\n');
  };
  protoOf(BaseOutput).r9 = function (message) {
    this.q9(message);
    this.p9();
  };
  function NodeJsOutput(outputStream) {
    BaseOutput.call(this);
    this.s9_1 = outputStream;
  }
  protoOf(NodeJsOutput).q9 = function (message) {
    // Inline function 'kotlin.io.String' call
    var tmp1_elvis_lhs = message == null ? null : toString_1(message);
    var messageString = tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
    this.s9_1.write(messageString);
  };
  function BufferedOutputToConsoleLog() {
    BufferedOutput.call(this);
  }
  protoOf(BufferedOutputToConsoleLog).q9 = function (message) {
    // Inline function 'kotlin.io.String' call
    var tmp1_elvis_lhs = message == null ? null : toString_1(message);
    var s = tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
    // Inline function 'kotlin.text.nativeLastIndexOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var i = s.lastIndexOf('\n', 0);
    if (i >= 0) {
      var tmp = this;
      var tmp_0 = this.u9_1;
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp.u9_1 = tmp_0 + s.substring(0, i);
      this.v9();
      var tmp6 = s;
      // Inline function 'kotlin.text.substring' call
      var startIndex = i + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      s = tmp6.substring(startIndex);
    }
    this.u9_1 = this.u9_1 + s;
  };
  protoOf(BufferedOutputToConsoleLog).v9 = function () {
    console.log(this.u9_1);
    this.u9_1 = '';
  };
  function BufferedOutput() {
    BaseOutput.call(this);
    this.u9_1 = '';
  }
  protoOf(BufferedOutput).q9 = function (message) {
    var tmp = this;
    var tmp_0 = this.u9_1;
    // Inline function 'kotlin.io.String' call
    var tmp1_elvis_lhs = message == null ? null : toString_1(message);
    tmp.u9_1 = tmp_0 + (tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs);
  };
  function println(message) {
    _init_properties_console_kt__rfg7jv();
    get_output().r9(message);
  }
  var properties_initialized_console_kt_gll9dl;
  function _init_properties_console_kt__rfg7jv() {
    if (!properties_initialized_console_kt_gll9dl) {
      properties_initialized_console_kt_gll9dl = true;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.io.output.<anonymous>' call
      var isNode = typeof process !== 'undefined' && process.versions && !!process.versions.node;
      output = isNode ? new NodeJsOutput(process.stdout) : new BufferedOutputToConsoleLog();
    }
  }
  function CoroutineImpl(resultContinuation) {
    InterceptedCoroutine.call(this);
    this.x9_1 = resultContinuation;
    this.y9_1 = 0;
    this.z9_1 = 0;
    this.aa_1 = null;
    this.ba_1 = null;
    this.ca_1 = null;
    var tmp = this;
    var tmp0_safe_receiver = this.x9_1;
    tmp.da_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ea();
  }
  protoOf(CoroutineImpl).ea = function () {
    return ensureNotNull(this.da_1);
  };
  protoOf(CoroutineImpl).fa = function (result) {
    var current = this;
    // Inline function 'kotlin.Result.getOrNull' call
    var tmp;
    if (_Result___get_isFailure__impl__jpiriv(result)) {
      tmp = null;
    } else {
      var tmp_0 = _Result___get_value__impl__bjfvqg(result);
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    var currentResult = tmp;
    var currentException = Result__exceptionOrNull_impl_p6xea9(result);
    while (true) {
      // Inline function 'kotlin.with' call
      // Inline function 'kotlin.coroutines.CoroutineImpl.resumeWith.<anonymous>' call
      var $this$with = current;
      if (currentException == null) {
        $this$with.aa_1 = currentResult;
      } else {
        $this$with.y9_1 = $this$with.z9_1;
        $this$with.ba_1 = currentException;
      }
      try {
        var outcome = $this$with.ga();
        if (outcome === get_COROUTINE_SUSPENDED())
          return Unit_instance;
        currentResult = outcome;
        currentException = null;
      } catch ($p) {
        var exception = $p;
        currentResult = null;
        // Inline function 'kotlin.js.unsafeCast' call
        currentException = exception;
      }
      $this$with.ia();
      var completion = ensureNotNull($this$with.x9_1);
      if (completion instanceof CoroutineImpl) {
        current = completion;
      } else {
        if (!(currentException == null)) {
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var exception_0 = ensureNotNull(currentException);
          var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception_0));
          completion.ja(tmp$ret$2);
        } else {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = currentResult;
          var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
          completion.ja(tmp$ret$4);
        }
        return Unit_instance;
      }
    }
  };
  protoOf(CoroutineImpl).ja = function (result) {
    return this.fa(result);
  };
  function CompletedContinuation() {
  }
  protoOf(CompletedContinuation).ea = function () {
    var message = 'This continuation is already complete';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(CompletedContinuation).fa = function (result) {
    // Inline function 'kotlin.error' call
    var message = 'This continuation is already complete';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(CompletedContinuation).ja = function (result) {
    return this.fa(result);
  };
  protoOf(CompletedContinuation).toString = function () {
    return 'This continuation is already complete';
  };
  var CompletedContinuation_instance;
  function CompletedContinuation_getInstance() {
    return CompletedContinuation_instance;
  }
  function InterceptedCoroutine() {
    this.ha_1 = null;
  }
  protoOf(InterceptedCoroutine).ka = function () {
    var tmp0_elvis_lhs = this.ha_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = this.ea().la(Key_instance);
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ma(this);
      // Inline function 'kotlin.also' call
      var this_0 = tmp2_elvis_lhs == null ? this : tmp2_elvis_lhs;
      // Inline function 'kotlin.coroutines.InterceptedCoroutine.intercepted.<anonymous>' call
      this.ha_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(InterceptedCoroutine).ia = function () {
    var intercepted = this.ha_1;
    if (!(intercepted == null) && !(intercepted === this)) {
      ensureNotNull(this.ea().la(Key_instance)).na(intercepted);
    }
    this.ha_1 = CompletedContinuation_instance;
  };
  function CancellationException_init_$Init$($this) {
    IllegalStateException_init_$Init$($this);
    CancellationException.call($this);
    return $this;
  }
  function CancellationException_init_$Create$() {
    var tmp = CancellationException_init_$Init$(objectCreate(protoOf(CancellationException)));
    captureStack(tmp, CancellationException_init_$Create$);
    return tmp;
  }
  function CancellationException_init_$Init$_0(message, $this) {
    IllegalStateException_init_$Init$_0(message, $this);
    CancellationException.call($this);
    return $this;
  }
  function CancellationException_init_$Create$_0(message) {
    var tmp = CancellationException_init_$Init$_0(message, objectCreate(protoOf(CancellationException)));
    captureStack(tmp, CancellationException_init_$Create$_0);
    return tmp;
  }
  function CancellationException_init_$Init$_1(message, cause, $this) {
    IllegalStateException_init_$Init$_1(message, cause, $this);
    CancellationException.call($this);
    return $this;
  }
  function CancellationException_init_$Create$_1(message, cause) {
    var tmp = CancellationException_init_$Init$_1(message, cause, objectCreate(protoOf(CancellationException)));
    captureStack(tmp, CancellationException_init_$Create$_1);
    return tmp;
  }
  function CancellationException() {
    captureStack(this, CancellationException);
  }
  function intercepted(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4 instanceof InterceptedCoroutine ? _this__u8e3s4 : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ka();
    return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
  }
  function createCoroutineUnintercepted(_this__u8e3s4, receiver, completion) {
    // Inline function 'kotlin.coroutines.intrinsics.createCoroutineFromSuspendFunction' call
    return new createCoroutineUnintercepted$$inlined$createCoroutineFromSuspendFunction$1(completion, _this__u8e3s4, receiver, completion);
  }
  function invokeSuspendSuperTypeWithReceiver(_this__u8e3s4, receiver, completion) {
    throw new NotImplementedError('It is intrinsic method');
  }
  function startCoroutineUninterceptedOrReturnNonGeneratorVersion(_this__u8e3s4, receiver, completion) {
    var tmp;
    if (!(completion instanceof InterceptedCoroutine)) {
      tmp = createSimpleCoroutineForSuspendFunction(completion);
    } else {
      tmp = completion;
    }
    var wrappedCompletion = tmp;
    // Inline function 'kotlin.js.asDynamic' call
    var a = _this__u8e3s4;
    return typeof a === 'function' ? a(receiver, wrappedCompletion) : _this__u8e3s4.oa(receiver, wrappedCompletion);
  }
  function createSimpleCoroutineForSuspendFunction(completion) {
    return new createSimpleCoroutineForSuspendFunction$1(completion);
  }
  function startCoroutineUninterceptedOrReturnNonGeneratorVersion_0(_this__u8e3s4, receiver, param, completion) {
    var tmp;
    if (!(completion instanceof InterceptedCoroutine)) {
      tmp = createSimpleCoroutineForSuspendFunction(completion);
    } else {
      tmp = completion;
    }
    var wrappedCompletion = tmp;
    // Inline function 'kotlin.js.asDynamic' call
    var a = _this__u8e3s4;
    return typeof a === 'function' ? a(receiver, param, wrappedCompletion) : _this__u8e3s4.pa(receiver, param, wrappedCompletion);
  }
  function invokeSuspendSuperTypeWithReceiverAndParam(_this__u8e3s4, receiver, param, completion) {
    throw new NotImplementedError('It is intrinsic method');
  }
  function createCoroutineUnintercepted$$inlined$createCoroutineFromSuspendFunction$1($completion, $this_createCoroutineUnintercepted, $receiver, $completion$1) {
    this.ya_1 = $this_createCoroutineUnintercepted;
    this.za_1 = $receiver;
    this.ab_1 = $completion$1;
    CoroutineImpl.call(this, isInterface($completion, Continuation) ? $completion : THROW_CCE());
  }
  protoOf(createCoroutineUnintercepted$$inlined$createCoroutineFromSuspendFunction$1).ga = function () {
    if (this.ba_1 != null)
      throw this.ba_1;
    // Inline function 'kotlin.coroutines.intrinsics.createCoroutineUnintercepted.<anonymous>' call
    // Inline function 'kotlin.js.asDynamic' call
    var a = this.ya_1;
    return typeof a === 'function' ? a(this.za_1, this.ab_1) : this.ya_1.oa(this.za_1, this.ab_1);
  };
  function createSimpleCoroutineForSuspendFunction$1($completion) {
    CoroutineImpl.call(this, isInterface($completion, Continuation) ? $completion : THROW_CCE());
  }
  protoOf(createSimpleCoroutineForSuspendFunction$1).ga = function () {
    if (this.ba_1 != null)
      throw this.ba_1;
    return this.aa_1;
  };
  function Exception_init_$Init$($this) {
    extendThrowable($this);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$() {
    var tmp = Exception_init_$Init$(objectCreate(protoOf(Exception)));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$_0(message) {
    var tmp = Exception_init_$Init$_0(message, objectCreate(protoOf(Exception)));
    captureStack(tmp, Exception_init_$Create$_0);
    return tmp;
  }
  function Exception_init_$Init$_1(message, cause, $this) {
    extendThrowable($this, message, cause);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_2(cause, $this) {
    extendThrowable($this, VOID, cause);
    Exception.call($this);
    return $this;
  }
  function Exception() {
    captureStack(this, Exception);
  }
  function IllegalArgumentException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$() {
    var tmp = IllegalArgumentException_init_$Init$(objectCreate(protoOf(IllegalArgumentException)));
    captureStack(tmp, IllegalArgumentException_init_$Create$);
    return tmp;
  }
  function IllegalArgumentException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$_0(message) {
    var tmp = IllegalArgumentException_init_$Init$_0(message, objectCreate(protoOf(IllegalArgumentException)));
    captureStack(tmp, IllegalArgumentException_init_$Create$_0);
    return tmp;
  }
  function IllegalArgumentException_init_$Init$_1(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$_1(message, cause) {
    var tmp = IllegalArgumentException_init_$Init$_1(message, cause, objectCreate(protoOf(IllegalArgumentException)));
    captureStack(tmp, IllegalArgumentException_init_$Create$_1);
    return tmp;
  }
  function IllegalArgumentException_init_$Init$_2(cause, $this) {
    RuntimeException_init_$Init$_2(cause, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException() {
    captureStack(this, IllegalArgumentException);
  }
  function IllegalStateException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$() {
    var tmp = IllegalStateException_init_$Init$(objectCreate(protoOf(IllegalStateException)));
    captureStack(tmp, IllegalStateException_init_$Create$);
    return tmp;
  }
  function IllegalStateException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_0(message) {
    var tmp = IllegalStateException_init_$Init$_0(message, objectCreate(protoOf(IllegalStateException)));
    captureStack(tmp, IllegalStateException_init_$Create$_0);
    return tmp;
  }
  function IllegalStateException_init_$Init$_1(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$_1(message, cause) {
    var tmp = IllegalStateException_init_$Init$_1(message, cause, objectCreate(protoOf(IllegalStateException)));
    captureStack(tmp, IllegalStateException_init_$Create$_1);
    return tmp;
  }
  function IllegalStateException() {
    captureStack(this, IllegalStateException);
  }
  function UnsupportedOperationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$() {
    var tmp = UnsupportedOperationException_init_$Init$(objectCreate(protoOf(UnsupportedOperationException)));
    captureStack(tmp, UnsupportedOperationException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$_0(message) {
    var tmp = UnsupportedOperationException_init_$Init$_0(message, objectCreate(protoOf(UnsupportedOperationException)));
    captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
    return tmp;
  }
  function UnsupportedOperationException() {
    captureStack(this, UnsupportedOperationException);
  }
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$() {
    var tmp = RuntimeException_init_$Init$(objectCreate(protoOf(RuntimeException)));
    captureStack(tmp, RuntimeException_init_$Create$);
    return tmp;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$_0(message) {
    var tmp = RuntimeException_init_$Init$_0(message, objectCreate(protoOf(RuntimeException)));
    captureStack(tmp, RuntimeException_init_$Create$_0);
    return tmp;
  }
  function RuntimeException_init_$Init$_1(message, cause, $this) {
    Exception_init_$Init$_1(message, cause, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$_1(message, cause) {
    var tmp = RuntimeException_init_$Init$_1(message, cause, objectCreate(protoOf(RuntimeException)));
    captureStack(tmp, RuntimeException_init_$Create$_1);
    return tmp;
  }
  function RuntimeException_init_$Init$_2(cause, $this) {
    Exception_init_$Init$_2(cause, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Create$_2(cause) {
    var tmp = RuntimeException_init_$Init$_2(cause, objectCreate(protoOf(RuntimeException)));
    captureStack(tmp, RuntimeException_init_$Create$_2);
    return tmp;
  }
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  function NoSuchElementException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$() {
    var tmp = NoSuchElementException_init_$Init$(objectCreate(protoOf(NoSuchElementException)));
    captureStack(tmp, NoSuchElementException_init_$Create$);
    return tmp;
  }
  function NoSuchElementException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$_0(message) {
    var tmp = NoSuchElementException_init_$Init$_0(message, objectCreate(protoOf(NoSuchElementException)));
    captureStack(tmp, NoSuchElementException_init_$Create$_0);
    return tmp;
  }
  function NoSuchElementException() {
    captureStack(this, NoSuchElementException);
  }
  function Error_init_$Init$($this) {
    extendThrowable($this);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Create$() {
    var tmp = Error_init_$Init$(objectCreate(protoOf(Error_0)));
    captureStack(tmp, Error_init_$Create$);
    return tmp;
  }
  function Error_init_$Init$_0(message, $this) {
    extendThrowable($this, message);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Create$_0(message) {
    var tmp = Error_init_$Init$_0(message, objectCreate(protoOf(Error_0)));
    captureStack(tmp, Error_init_$Create$_0);
    return tmp;
  }
  function Error_init_$Init$_1(message, cause, $this) {
    extendThrowable($this, message, cause);
    Error_0.call($this);
    return $this;
  }
  function Error_init_$Create$_1(message, cause) {
    var tmp = Error_init_$Init$_1(message, cause, objectCreate(protoOf(Error_0)));
    captureStack(tmp, Error_init_$Create$_1);
    return tmp;
  }
  function Error_0() {
    captureStack(this, Error_0);
  }
  function IndexOutOfBoundsException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$() {
    var tmp = IndexOutOfBoundsException_init_$Init$(objectCreate(protoOf(IndexOutOfBoundsException)));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function IndexOutOfBoundsException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$_0(message) {
    var tmp = IndexOutOfBoundsException_init_$Init$_0(message, objectCreate(protoOf(IndexOutOfBoundsException)));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$_0);
    return tmp;
  }
  function IndexOutOfBoundsException() {
    captureStack(this, IndexOutOfBoundsException);
  }
  function NumberFormatException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    NumberFormatException.call($this);
    return $this;
  }
  function NumberFormatException_init_$Create$() {
    var tmp = NumberFormatException_init_$Init$(objectCreate(protoOf(NumberFormatException)));
    captureStack(tmp, NumberFormatException_init_$Create$);
    return tmp;
  }
  function NumberFormatException_init_$Init$_0(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    NumberFormatException.call($this);
    return $this;
  }
  function NumberFormatException_init_$Create$_0(message) {
    var tmp = NumberFormatException_init_$Init$_0(message, objectCreate(protoOf(NumberFormatException)));
    captureStack(tmp, NumberFormatException_init_$Create$_0);
    return tmp;
  }
  function NumberFormatException() {
    captureStack(this, NumberFormatException);
  }
  function ArithmeticException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ArithmeticException.call($this);
    return $this;
  }
  function ArithmeticException_init_$Create$() {
    var tmp = ArithmeticException_init_$Init$(objectCreate(protoOf(ArithmeticException)));
    captureStack(tmp, ArithmeticException_init_$Create$);
    return tmp;
  }
  function ArithmeticException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ArithmeticException.call($this);
    return $this;
  }
  function ArithmeticException_init_$Create$_0(message) {
    var tmp = ArithmeticException_init_$Init$_0(message, objectCreate(protoOf(ArithmeticException)));
    captureStack(tmp, ArithmeticException_init_$Create$_0);
    return tmp;
  }
  function ArithmeticException() {
    captureStack(this, ArithmeticException);
  }
  function NullPointerException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NullPointerException.call($this);
    return $this;
  }
  function NullPointerException_init_$Create$() {
    var tmp = NullPointerException_init_$Init$(objectCreate(protoOf(NullPointerException)));
    captureStack(tmp, NullPointerException_init_$Create$);
    return tmp;
  }
  function NullPointerException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NullPointerException.call($this);
    return $this;
  }
  function NullPointerException_init_$Create$_0(message) {
    var tmp = NullPointerException_init_$Init$_0(message, objectCreate(protoOf(NullPointerException)));
    captureStack(tmp, NullPointerException_init_$Create$_0);
    return tmp;
  }
  function NullPointerException() {
    captureStack(this, NullPointerException);
  }
  function AssertionError_init_$Init$($this) {
    Error_init_$Init$($this);
    AssertionError.call($this);
    return $this;
  }
  function AssertionError_init_$Create$() {
    var tmp = AssertionError_init_$Init$(objectCreate(protoOf(AssertionError)));
    captureStack(tmp, AssertionError_init_$Create$);
    return tmp;
  }
  function AssertionError_init_$Init$_0(message, $this) {
    Error_init_$Init$_0(message, $this);
    AssertionError.call($this);
    return $this;
  }
  function AssertionError_init_$Create$_0(message) {
    var tmp = AssertionError_init_$Init$_0(message, objectCreate(protoOf(AssertionError)));
    captureStack(tmp, AssertionError_init_$Create$_0);
    return tmp;
  }
  function AssertionError_init_$Init$_1(message, $this) {
    var tmp = message == null ? null : toString_1(message);
    Error_init_$Init$_1(tmp, message instanceof Error ? message : null, $this);
    AssertionError.call($this);
    return $this;
  }
  function AssertionError_init_$Create$_1(message) {
    var tmp = AssertionError_init_$Init$_1(message, objectCreate(protoOf(AssertionError)));
    captureStack(tmp, AssertionError_init_$Create$_1);
    return tmp;
  }
  function AssertionError() {
    captureStack(this, AssertionError);
  }
  function ConcurrentModificationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ConcurrentModificationException.call($this);
    return $this;
  }
  function ConcurrentModificationException_init_$Create$() {
    var tmp = ConcurrentModificationException_init_$Init$(objectCreate(protoOf(ConcurrentModificationException)));
    captureStack(tmp, ConcurrentModificationException_init_$Create$);
    return tmp;
  }
  function ConcurrentModificationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ConcurrentModificationException.call($this);
    return $this;
  }
  function ConcurrentModificationException_init_$Create$_0(message) {
    var tmp = ConcurrentModificationException_init_$Init$_0(message, objectCreate(protoOf(ConcurrentModificationException)));
    captureStack(tmp, ConcurrentModificationException_init_$Create$_0);
    return tmp;
  }
  function ConcurrentModificationException() {
    captureStack(this, ConcurrentModificationException);
  }
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(objectCreate(protoOf(ClassCastException)));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function ClassCastException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$_0(message) {
    var tmp = ClassCastException_init_$Init$_0(message, objectCreate(protoOf(ClassCastException)));
    captureStack(tmp, ClassCastException_init_$Create$_0);
    return tmp;
  }
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  function NoWhenBranchMatchedException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoWhenBranchMatchedException.call($this);
    return $this;
  }
  function NoWhenBranchMatchedException_init_$Create$() {
    var tmp = NoWhenBranchMatchedException_init_$Init$(objectCreate(protoOf(NoWhenBranchMatchedException)));
    captureStack(tmp, NoWhenBranchMatchedException_init_$Create$);
    return tmp;
  }
  function NoWhenBranchMatchedException() {
    captureStack(this, NoWhenBranchMatchedException);
  }
  function UninitializedPropertyAccessException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UninitializedPropertyAccessException.call($this);
    return $this;
  }
  function UninitializedPropertyAccessException_init_$Create$() {
    var tmp = UninitializedPropertyAccessException_init_$Init$(objectCreate(protoOf(UninitializedPropertyAccessException)));
    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$);
    return tmp;
  }
  function UninitializedPropertyAccessException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UninitializedPropertyAccessException.call($this);
    return $this;
  }
  function UninitializedPropertyAccessException_init_$Create$_0(message) {
    var tmp = UninitializedPropertyAccessException_init_$Init$_0(message, objectCreate(protoOf(UninitializedPropertyAccessException)));
    captureStack(tmp, UninitializedPropertyAccessException_init_$Create$_0);
    return tmp;
  }
  function UninitializedPropertyAccessException() {
    captureStack(this, UninitializedPropertyAccessException);
  }
  function lazy(mode, initializer) {
    return new UnsafeLazyImpl(initializer);
  }
  function lazy_0(initializer) {
    return new UnsafeLazyImpl(initializer);
  }
  function fillFrom(src, dst) {
    var srcLen = src.length;
    var dstLen = dst.length;
    var index = 0;
    // Inline function 'kotlin.js.unsafeCast' call
    var arr = dst;
    while (index < srcLen && index < dstLen) {
      var tmp = index;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      arr[tmp] = src[_unary__edvuaz];
    }
    return dst;
  }
  function arrayCopyResize(source, newSize, defaultValue) {
    // Inline function 'kotlin.js.unsafeCast' call
    var result = source.slice(0, newSize);
    // Inline function 'kotlin.copyArrayType' call
    if (source.$type$ !== undefined) {
      result.$type$ = source.$type$;
    }
    var index = source.length;
    if (newSize > index) {
      // Inline function 'kotlin.js.asDynamic' call
      result.length = newSize;
      while (index < newSize) {
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        result[_unary__edvuaz] = defaultValue;
      }
    }
    return result;
  }
  function abs(n) {
    return n < 0 ? -n | 0 | 0 : n;
  }
  function abs_0(n) {
    return n.d1(new Long(0, 0)) < 0 ? n.p3() : n;
  }
  function roundToInt(_this__u8e3s4) {
    var tmp;
    if (isNaN_0(_this__u8e3s4)) {
      throw IllegalArgumentException_init_$Create$_0('Cannot round NaN value.');
    } else if (_this__u8e3s4 > 2147483647) {
      tmp = 2147483647;
    } else if (_this__u8e3s4 < -2147483648) {
      tmp = -2147483648;
    } else {
      tmp = numberToInt(Math.round(_this__u8e3s4));
    }
    return tmp;
  }
  function roundToLong(_this__u8e3s4) {
    var tmp;
    if (isNaN_0(_this__u8e3s4)) {
      throw IllegalArgumentException_init_$Create$_0('Cannot round NaN value.');
    } else if (_this__u8e3s4 > (new Long(-1, 2147483647)).a4()) {
      tmp = new Long(-1, 2147483647);
    } else if (_this__u8e3s4 < (new Long(0, -2147483648)).a4()) {
      tmp = new Long(0, -2147483648);
    } else {
      tmp = numberToLong(Math.round(_this__u8e3s4));
    }
    return tmp;
  }
  function get_INV_2_26() {
    _init_properties_PlatformRandom_kt__6kjv62();
    return INV_2_26;
  }
  var INV_2_26;
  function get_INV_2_53() {
    _init_properties_PlatformRandom_kt__6kjv62();
    return INV_2_53;
  }
  var INV_2_53;
  function doubleFromParts(hi26, low27) {
    _init_properties_PlatformRandom_kt__6kjv62();
    return hi26 * get_INV_2_26() + low27 * get_INV_2_53();
  }
  function defaultPlatformRandom() {
    _init_properties_PlatformRandom_kt__6kjv62();
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$0 = Math.random() * Math.pow(2, 32) | 0;
    return Random_0(tmp$ret$0);
  }
  var properties_initialized_PlatformRandom_kt_uibhw8;
  function _init_properties_PlatformRandom_kt__6kjv62() {
    if (!properties_initialized_PlatformRandom_kt_uibhw8) {
      properties_initialized_PlatformRandom_kt_uibhw8 = true;
      // Inline function 'kotlin.math.pow' call
      INV_2_26 = Math.pow(2.0, -26);
      // Inline function 'kotlin.math.pow' call
      INV_2_53 = Math.pow(2.0, -53);
    }
  }
  function get_js(_this__u8e3s4) {
    return (_this__u8e3s4 instanceof KClassImpl ? _this__u8e3s4 : THROW_CCE()).kb();
  }
  function KClass() {
  }
  function KClassImpl(jClass) {
    this.jb_1 = jClass;
  }
  protoOf(KClassImpl).kb = function () {
    return this.jb_1;
  };
  protoOf(KClassImpl).equals = function (other) {
    var tmp;
    if (other instanceof NothingKClassImpl) {
      tmp = false;
    } else {
      if (other instanceof ErrorKClass) {
        tmp = false;
      } else {
        if (other instanceof KClassImpl) {
          tmp = equals(this.kb(), other.kb());
        } else {
          tmp = false;
        }
      }
    }
    return tmp;
  };
  protoOf(KClassImpl).hashCode = function () {
    var tmp0_safe_receiver = this.lb();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(KClassImpl).toString = function () {
    return 'class ' + this.lb();
  };
  function NothingKClassImpl() {
    NothingKClassImpl_instance = this;
    KClassImpl.call(this, Object);
    this.ob_1 = 'Nothing';
  }
  protoOf(NothingKClassImpl).lb = function () {
    return this.ob_1;
  };
  protoOf(NothingKClassImpl).mb = function (value) {
    return false;
  };
  protoOf(NothingKClassImpl).kb = function () {
    throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
  };
  protoOf(NothingKClassImpl).equals = function (other) {
    return other === this;
  };
  protoOf(NothingKClassImpl).hashCode = function () {
    return 0;
  };
  var NothingKClassImpl_instance;
  function NothingKClassImpl_getInstance() {
    if (NothingKClassImpl_instance == null)
      new NothingKClassImpl();
    return NothingKClassImpl_instance;
  }
  function ErrorKClass() {
  }
  protoOf(ErrorKClass).lb = function () {
    var message = 'Unknown simpleName for ErrorKClass';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(ErrorKClass).mb = function (value) {
    var message = "Can's check isInstance on ErrorKClass";
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(ErrorKClass).equals = function (other) {
    return other === this;
  };
  protoOf(ErrorKClass).hashCode = function () {
    return 0;
  };
  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
    KClassImpl.call(this, jClass);
    this.qb_1 = givenSimpleName;
    this.rb_1 = isInstanceFunction;
  }
  protoOf(PrimitiveKClassImpl).equals = function (other) {
    if (!(other instanceof PrimitiveKClassImpl))
      return false;
    return protoOf(KClassImpl).equals.call(this, other) && this.qb_1 === other.qb_1;
  };
  protoOf(PrimitiveKClassImpl).lb = function () {
    return this.qb_1;
  };
  protoOf(PrimitiveKClassImpl).mb = function (value) {
    return this.rb_1(value);
  };
  function SimpleKClassImpl(jClass) {
    KClassImpl.call(this, jClass);
    var tmp = this;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = jClass.$metadata$;
    // Inline function 'kotlin.js.unsafeCast' call
    tmp.tb_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
  }
  protoOf(SimpleKClassImpl).lb = function () {
    return this.tb_1;
  };
  protoOf(SimpleKClassImpl).mb = function (value) {
    return jsIsType(value, this.kb());
  };
  function KProperty1() {
  }
  function KProperty0() {
  }
  function KMutableProperty0() {
  }
  function createKType(classifier, arguments_0, isMarkedNullable) {
    return new KTypeImpl(classifier, asList(arguments_0), isMarkedNullable);
  }
  function createInvariantKTypeProjection(type) {
    return Companion_getInstance_15().wb(type);
  }
  function KTypeImpl(classifier, arguments_0, isMarkedNullable) {
    this.xb_1 = classifier;
    this.yb_1 = arguments_0;
    this.zb_1 = isMarkedNullable;
  }
  protoOf(KTypeImpl).ac = function () {
    return this.xb_1;
  };
  protoOf(KTypeImpl).bc = function () {
    return this.yb_1;
  };
  protoOf(KTypeImpl).cc = function () {
    return this.zb_1;
  };
  protoOf(KTypeImpl).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof KTypeImpl) {
      tmp_1 = equals(this.xb_1, other.xb_1);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals(this.yb_1, other.yb_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.zb_1 === other.zb_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(KTypeImpl).hashCode = function () {
    return imul(imul(hashCode(this.xb_1), 31) + hashCode(this.yb_1) | 0, 31) + getBooleanHashCode(this.zb_1) | 0;
  };
  protoOf(KTypeImpl).toString = function () {
    var tmp = this.xb_1;
    var kClass = isInterface(tmp, KClass) ? tmp : null;
    var classifierName = kClass == null ? toString_1(this.xb_1) : !(kClass.lb() == null) ? kClass.lb() : '(non-denotable type)';
    var args = this.yb_1.p() ? '' : joinToString_0(this.yb_1, ', ', '<', '>');
    var nullable = this.zb_1 ? '?' : '';
    return plus_10(classifierName, args) + nullable;
  };
  function get_functionClasses() {
    _init_properties_primitives_kt__3fums4();
    return functionClasses;
  }
  var functionClasses;
  function PrimitiveClasses$anyClass$lambda(it) {
    return !(it == null);
  }
  function PrimitiveClasses$numberClass$lambda(it) {
    return isNumber(it);
  }
  function PrimitiveClasses$booleanClass$lambda(it) {
    return !(it == null) ? typeof it === 'boolean' : false;
  }
  function PrimitiveClasses$byteClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$shortClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$intClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$floatClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$doubleClass$lambda(it) {
    return !(it == null) ? typeof it === 'number' : false;
  }
  function PrimitiveClasses$arrayClass$lambda(it) {
    return !(it == null) ? isArray(it) : false;
  }
  function PrimitiveClasses$stringClass$lambda(it) {
    return !(it == null) ? typeof it === 'string' : false;
  }
  function PrimitiveClasses$throwableClass$lambda(it) {
    return it instanceof Error;
  }
  function PrimitiveClasses$booleanArrayClass$lambda(it) {
    return !(it == null) ? isBooleanArray(it) : false;
  }
  function PrimitiveClasses$charArrayClass$lambda(it) {
    return !(it == null) ? isCharArray(it) : false;
  }
  function PrimitiveClasses$byteArrayClass$lambda(it) {
    return !(it == null) ? isByteArray(it) : false;
  }
  function PrimitiveClasses$shortArrayClass$lambda(it) {
    return !(it == null) ? isShortArray(it) : false;
  }
  function PrimitiveClasses$intArrayClass$lambda(it) {
    return !(it == null) ? isIntArray(it) : false;
  }
  function PrimitiveClasses$longArrayClass$lambda(it) {
    return !(it == null) ? isLongArray(it) : false;
  }
  function PrimitiveClasses$floatArrayClass$lambda(it) {
    return !(it == null) ? isFloatArray(it) : false;
  }
  function PrimitiveClasses$doubleArrayClass$lambda(it) {
    return !(it == null) ? isDoubleArray(it) : false;
  }
  function PrimitiveClasses$functionClass$lambda($arity) {
    return function (it) {
      var tmp;
      if (typeof it === 'function') {
        // Inline function 'kotlin.js.asDynamic' call
        tmp = it.length === $arity;
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function PrimitiveClasses() {
    PrimitiveClasses_instance = this;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0 = Object;
    tmp.anyClass = new PrimitiveKClassImpl(tmp_0, 'Any', PrimitiveClasses$anyClass$lambda);
    var tmp_1 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_2 = Number;
    tmp_1.numberClass = new PrimitiveKClassImpl(tmp_2, 'Number', PrimitiveClasses$numberClass$lambda);
    this.nothingClass = NothingKClassImpl_getInstance();
    var tmp_3 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_4 = Boolean;
    tmp_3.booleanClass = new PrimitiveKClassImpl(tmp_4, 'Boolean', PrimitiveClasses$booleanClass$lambda);
    var tmp_5 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_6 = Number;
    tmp_5.byteClass = new PrimitiveKClassImpl(tmp_6, 'Byte', PrimitiveClasses$byteClass$lambda);
    var tmp_7 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_8 = Number;
    tmp_7.shortClass = new PrimitiveKClassImpl(tmp_8, 'Short', PrimitiveClasses$shortClass$lambda);
    var tmp_9 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_10 = Number;
    tmp_9.intClass = new PrimitiveKClassImpl(tmp_10, 'Int', PrimitiveClasses$intClass$lambda);
    var tmp_11 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_12 = Number;
    tmp_11.floatClass = new PrimitiveKClassImpl(tmp_12, 'Float', PrimitiveClasses$floatClass$lambda);
    var tmp_13 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_14 = Number;
    tmp_13.doubleClass = new PrimitiveKClassImpl(tmp_14, 'Double', PrimitiveClasses$doubleClass$lambda);
    var tmp_15 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_16 = Array;
    tmp_15.arrayClass = new PrimitiveKClassImpl(tmp_16, 'Array', PrimitiveClasses$arrayClass$lambda);
    var tmp_17 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_18 = String;
    tmp_17.stringClass = new PrimitiveKClassImpl(tmp_18, 'String', PrimitiveClasses$stringClass$lambda);
    var tmp_19 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_20 = Error;
    tmp_19.throwableClass = new PrimitiveKClassImpl(tmp_20, 'Throwable', PrimitiveClasses$throwableClass$lambda);
    var tmp_21 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_22 = Array;
    tmp_21.booleanArrayClass = new PrimitiveKClassImpl(tmp_22, 'BooleanArray', PrimitiveClasses$booleanArrayClass$lambda);
    var tmp_23 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_24 = Uint16Array;
    tmp_23.charArrayClass = new PrimitiveKClassImpl(tmp_24, 'CharArray', PrimitiveClasses$charArrayClass$lambda);
    var tmp_25 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_26 = Int8Array;
    tmp_25.byteArrayClass = new PrimitiveKClassImpl(tmp_26, 'ByteArray', PrimitiveClasses$byteArrayClass$lambda);
    var tmp_27 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_28 = Int16Array;
    tmp_27.shortArrayClass = new PrimitiveKClassImpl(tmp_28, 'ShortArray', PrimitiveClasses$shortArrayClass$lambda);
    var tmp_29 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_30 = Int32Array;
    tmp_29.intArrayClass = new PrimitiveKClassImpl(tmp_30, 'IntArray', PrimitiveClasses$intArrayClass$lambda);
    var tmp_31 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_32 = Array;
    tmp_31.longArrayClass = new PrimitiveKClassImpl(tmp_32, 'LongArray', PrimitiveClasses$longArrayClass$lambda);
    var tmp_33 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_34 = Float32Array;
    tmp_33.floatArrayClass = new PrimitiveKClassImpl(tmp_34, 'FloatArray', PrimitiveClasses$floatArrayClass$lambda);
    var tmp_35 = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_36 = Float64Array;
    tmp_35.doubleArrayClass = new PrimitiveKClassImpl(tmp_36, 'DoubleArray', PrimitiveClasses$doubleArrayClass$lambda);
  }
  protoOf(PrimitiveClasses).dc = function () {
    return this.anyClass;
  };
  protoOf(PrimitiveClasses).ec = function () {
    return this.numberClass;
  };
  protoOf(PrimitiveClasses).fc = function () {
    return this.nothingClass;
  };
  protoOf(PrimitiveClasses).gc = function () {
    return this.booleanClass;
  };
  protoOf(PrimitiveClasses).hc = function () {
    return this.byteClass;
  };
  protoOf(PrimitiveClasses).ic = function () {
    return this.shortClass;
  };
  protoOf(PrimitiveClasses).jc = function () {
    return this.intClass;
  };
  protoOf(PrimitiveClasses).kc = function () {
    return this.floatClass;
  };
  protoOf(PrimitiveClasses).lc = function () {
    return this.doubleClass;
  };
  protoOf(PrimitiveClasses).mc = function () {
    return this.arrayClass;
  };
  protoOf(PrimitiveClasses).nc = function () {
    return this.stringClass;
  };
  protoOf(PrimitiveClasses).oc = function () {
    return this.throwableClass;
  };
  protoOf(PrimitiveClasses).pc = function () {
    return this.booleanArrayClass;
  };
  protoOf(PrimitiveClasses).qc = function () {
    return this.charArrayClass;
  };
  protoOf(PrimitiveClasses).rc = function () {
    return this.byteArrayClass;
  };
  protoOf(PrimitiveClasses).sc = function () {
    return this.shortArrayClass;
  };
  protoOf(PrimitiveClasses).tc = function () {
    return this.intArrayClass;
  };
  protoOf(PrimitiveClasses).uc = function () {
    return this.longArrayClass;
  };
  protoOf(PrimitiveClasses).vc = function () {
    return this.floatArrayClass;
  };
  protoOf(PrimitiveClasses).wc = function () {
    return this.doubleArrayClass;
  };
  protoOf(PrimitiveClasses).functionClass = function (arity) {
    var tmp0_elvis_lhs = get_functionClasses()[arity];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.reflect.js.internal.PrimitiveClasses.functionClass.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp_0 = Function;
      var tmp_1 = 'Function' + arity;
      var result = new PrimitiveKClassImpl(tmp_0, tmp_1, PrimitiveClasses$functionClass$lambda(arity));
      // Inline function 'kotlin.js.asDynamic' call
      get_functionClasses()[arity] = result;
      tmp = result;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var PrimitiveClasses_instance;
  function PrimitiveClasses_getInstance() {
    if (PrimitiveClasses_instance == null)
      new PrimitiveClasses();
    return PrimitiveClasses_instance;
  }
  var properties_initialized_primitives_kt_jle18u;
  function _init_properties_primitives_kt__3fums4() {
    if (!properties_initialized_primitives_kt_jle18u) {
      properties_initialized_primitives_kt_jle18u = true;
      // Inline function 'kotlin.arrayOfNulls' call
      functionClasses = fillArrayVal(Array(0), null);
    }
  }
  function getKClass(jClass) {
    var tmp;
    if (Array.isArray(jClass)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = getKClassM(jClass);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = getKClass1(jClass);
    }
    return tmp;
  }
  function getKClassM(jClasses) {
    var tmp;
    switch (jClasses.length) {
      case 1:
        tmp = getKClass1(jClasses[0]);
        break;
      case 0:
        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = NothingKClassImpl_getInstance();
        break;
      default:
        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = new ErrorKClass();
        break;
    }
    return tmp;
  }
  function getKClass1(jClass) {
    if (jClass === String) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      return PrimitiveClasses_getInstance().stringClass;
    }
    // Inline function 'kotlin.js.asDynamic' call
    var metadata = jClass.$metadata$;
    var tmp;
    if (metadata != null) {
      var tmp_0;
      if (metadata.$kClass$ == null) {
        var kClass = new SimpleKClassImpl(jClass);
        metadata.$kClass$ = kClass;
        tmp_0 = kClass;
      } else {
        tmp_0 = metadata.$kClass$;
      }
      tmp = tmp_0;
    } else {
      tmp = new SimpleKClassImpl(jClass);
    }
    return tmp;
  }
  function getKClassFromExpression(e) {
    var tmp;
    switch (typeof e) {
      case 'string':
        tmp = PrimitiveClasses_getInstance().stringClass;
        break;
      case 'number':
        var tmp_0;
        // Inline function 'kotlin.js.jsBitwiseOr' call

        // Inline function 'kotlin.js.asDynamic' call

        if ((e | 0) === e) {
          tmp_0 = PrimitiveClasses_getInstance().intClass;
        } else {
          tmp_0 = PrimitiveClasses_getInstance().doubleClass;
        }

        tmp = tmp_0;
        break;
      case 'boolean':
        tmp = PrimitiveClasses_getInstance().booleanClass;
        break;
      case 'function':
        var tmp_1 = PrimitiveClasses_getInstance();
        // Inline function 'kotlin.js.asDynamic' call

        tmp = tmp_1.functionClass(e.length);
        break;
      default:
        var tmp_2;
        if (isBooleanArray(e)) {
          tmp_2 = PrimitiveClasses_getInstance().booleanArrayClass;
        } else {
          if (isCharArray(e)) {
            tmp_2 = PrimitiveClasses_getInstance().charArrayClass;
          } else {
            if (isByteArray(e)) {
              tmp_2 = PrimitiveClasses_getInstance().byteArrayClass;
            } else {
              if (isShortArray(e)) {
                tmp_2 = PrimitiveClasses_getInstance().shortArrayClass;
              } else {
                if (isIntArray(e)) {
                  tmp_2 = PrimitiveClasses_getInstance().intArrayClass;
                } else {
                  if (isLongArray(e)) {
                    tmp_2 = PrimitiveClasses_getInstance().longArrayClass;
                  } else {
                    if (isFloatArray(e)) {
                      tmp_2 = PrimitiveClasses_getInstance().floatArrayClass;
                    } else {
                      if (isDoubleArray(e)) {
                        tmp_2 = PrimitiveClasses_getInstance().doubleArrayClass;
                      } else {
                        if (isInterface(e, KClass)) {
                          tmp_2 = getKClass(KClass);
                        } else {
                          if (isArray(e)) {
                            tmp_2 = PrimitiveClasses_getInstance().arrayClass;
                          } else {
                            var constructor = Object.getPrototypeOf(e).constructor;
                            var tmp_3;
                            if (constructor === Object) {
                              tmp_3 = PrimitiveClasses_getInstance().anyClass;
                            } else if (constructor === Error) {
                              tmp_3 = PrimitiveClasses_getInstance().throwableClass;
                            } else {
                              var jsClass = constructor;
                              tmp_3 = getKClass1(jsClass);
                            }
                            tmp_2 = tmp_3;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        tmp = tmp_2;
        break;
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return tmp;
  }
  function findAssociatedObject(_this__u8e3s4, annotationClass) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof KClassImpl) {
      tmp_0 = annotationClass instanceof KClassImpl;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_safe_receiver = annotationClass.kb().$metadata$;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.associatedObjectKey;
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.js.unsafeCast' call
        tmp_1 = tmp1_safe_receiver;
      }
      var tmp2_elvis_lhs = tmp_1;
      var tmp_2;
      if (tmp2_elvis_lhs == null) {
        return null;
      } else {
        tmp_2 = tmp2_elvis_lhs;
      }
      var key = tmp_2;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp3_safe_receiver = _this__u8e3s4.kb().$metadata$;
      var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.associatedObjects;
      var tmp_3;
      if (tmp4_elvis_lhs == null) {
        return null;
      } else {
        tmp_3 = tmp4_elvis_lhs;
      }
      var map = tmp_3;
      var tmp5_elvis_lhs = map[key];
      var tmp_4;
      if (tmp5_elvis_lhs == null) {
        return null;
      } else {
        tmp_4 = tmp5_elvis_lhs;
      }
      var factory = tmp_4;
      return factory();
    } else {
      tmp = null;
    }
    return tmp;
  }
  function reset_0(_this__u8e3s4) {
    _this__u8e3s4.lastIndex = 0;
  }
  function ConstrainedOnceSequence(sequence) {
    this.xc_1 = sequence;
  }
  protoOf(ConstrainedOnceSequence).k = function () {
    var tmp0_elvis_lhs = this.xc_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('This sequence can be consumed only once.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var sequence = tmp;
    this.xc_1 = null;
    return sequence.k();
  };
  function CharacterCodingException_init_$Init$($this) {
    CharacterCodingException.call($this, null);
    return $this;
  }
  function CharacterCodingException_init_$Create$() {
    var tmp = CharacterCodingException_init_$Init$(objectCreate(protoOf(CharacterCodingException)));
    captureStack(tmp, CharacterCodingException_init_$Create$);
    return tmp;
  }
  function CharacterCodingException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, CharacterCodingException);
  }
  function StringBuilder_init_$Init$(capacity, $this) {
    StringBuilder_init_$Init$_1($this);
    return $this;
  }
  function StringBuilder_init_$Create$(capacity) {
    return StringBuilder_init_$Init$(capacity, objectCreate(protoOf(StringBuilder)));
  }
  function StringBuilder_init_$Init$_0(content, $this) {
    StringBuilder.call($this, toString_1(content));
    return $this;
  }
  function StringBuilder_init_$Create$_0(content) {
    return StringBuilder_init_$Init$_0(content, objectCreate(protoOf(StringBuilder)));
  }
  function StringBuilder_init_$Init$_1($this) {
    StringBuilder.call($this, '');
    return $this;
  }
  function StringBuilder_init_$Create$_1() {
    return StringBuilder_init_$Init$_1(objectCreate(protoOf(StringBuilder)));
  }
  function StringBuilder(content) {
    this.l1_1 = content;
  }
  protoOf(StringBuilder).a = function () {
    // Inline function 'kotlin.js.asDynamic' call
    return this.l1_1.length;
  };
  protoOf(StringBuilder).b = function (index) {
    // Inline function 'kotlin.text.getOrElse' call
    var this_0 = this.l1_1;
    var tmp;
    if (0 <= index ? index <= (charSequenceLength(this_0) - 1 | 0) : false) {
      tmp = charSequenceGet(this_0, index);
    } else {
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', length: ' + this.a() + '}');
    }
    return tmp;
  };
  protoOf(StringBuilder).c = function (startIndex, endIndex) {
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.l1_1.substring(startIndex, endIndex);
  };
  protoOf(StringBuilder).e9 = function (value) {
    this.l1_1 = this.l1_1 + toString(value);
    return this;
  };
  protoOf(StringBuilder).f = function (value) {
    this.l1_1 = this.l1_1 + toString_0(value);
    return this;
  };
  protoOf(StringBuilder).yc = function (value, startIndex, endIndex) {
    return this.zc(value == null ? 'null' : value, startIndex, endIndex);
  };
  protoOf(StringBuilder).m1 = function () {
    var reversed = '';
    var index = this.l1_1.length - 1 | 0;
    while (index >= 0) {
      var tmp = this.l1_1;
      var _unary__edvuaz = index;
      index = _unary__edvuaz - 1 | 0;
      var low = charSequenceGet(tmp, _unary__edvuaz);
      if (isLowSurrogate(low) && index >= 0) {
        var tmp_0 = this.l1_1;
        var _unary__edvuaz_0 = index;
        index = _unary__edvuaz_0 - 1 | 0;
        var high = charSequenceGet(tmp_0, _unary__edvuaz_0);
        if (isHighSurrogate(high)) {
          reversed = reversed + new Char(high) + toString(low);
        } else {
          reversed = reversed + new Char(low) + toString(high);
        }
      } else {
        reversed = reversed + toString(low);
      }
    }
    this.l1_1 = reversed;
    return this;
  };
  protoOf(StringBuilder).c9 = function (value) {
    this.l1_1 = this.l1_1 + toString_0(value);
    return this;
  };
  protoOf(StringBuilder).ad = function (value) {
    return this.d9(value.toString());
  };
  protoOf(StringBuilder).bd = function (value) {
    return this.d9(value.toString());
  };
  protoOf(StringBuilder).d9 = function (value) {
    var tmp = this;
    var tmp_0 = this.l1_1;
    tmp.l1_1 = tmp_0 + (value == null ? 'null' : value);
    return this;
  };
  protoOf(StringBuilder).cd = function (index, value) {
    Companion_instance_6.k5(index, this.a());
    var tmp = this;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = this.l1_1.substring(0, index) + toString(value);
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l1_1 = tmp_0 + this.l1_1.substring(index);
    return this;
  };
  protoOf(StringBuilder).dd = function (index, value) {
    Companion_instance_6.k5(index, this.a());
    var toInsert = value == null ? 'null' : value;
    var tmp = this;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = this.l1_1.substring(0, index) + toInsert;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l1_1 = tmp_0 + this.l1_1.substring(index);
    return this;
  };
  protoOf(StringBuilder).ed = function (newLength) {
    if (newLength < 0) {
      throw IllegalArgumentException_init_$Create$_0('Negative new length: ' + newLength + '.');
    }
    if (newLength <= this.a()) {
      var tmp = this;
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp.l1_1 = this.l1_1.substring(0, newLength);
    } else {
      var inductionVariable = this.a();
      if (inductionVariable < newLength)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.l1_1 = this.l1_1 + toString(_Char___init__impl__6a9atx(0));
        }
         while (inductionVariable < newLength);
    }
  };
  protoOf(StringBuilder).fd = function (startIndex) {
    Companion_instance_6.k5(startIndex, this.a());
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.l1_1.substring(startIndex);
  };
  protoOf(StringBuilder).toString = function () {
    return this.l1_1;
  };
  protoOf(StringBuilder).gd = function () {
    this.l1_1 = '';
    return this;
  };
  protoOf(StringBuilder).hd = function (index) {
    Companion_instance_6.x4(index, this.a());
    var tmp = this;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = this.l1_1.substring(0, index);
    var tmp3 = this.l1_1;
    // Inline function 'kotlin.text.substring' call
    var startIndex = index + 1 | 0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l1_1 = tmp_0 + tmp3.substring(startIndex);
    return this;
  };
  protoOf(StringBuilder).zc = function (value, startIndex, endIndex) {
    var stringCsq = toString_1(value);
    Companion_instance_6.id(startIndex, endIndex, stringCsq.length);
    var tmp = this;
    var tmp_0 = this.l1_1;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l1_1 = tmp_0 + stringCsq.substring(startIndex, endIndex);
    return this;
  };
  function uppercaseChar(_this__u8e3s4) {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var uppercase = toString(_this__u8e3s4).toUpperCase();
    return uppercase.length > 1 ? _this__u8e3s4 : charSequenceGet(uppercase, 0);
  }
  function isLowSurrogate(_this__u8e3s4) {
    return _Char___init__impl__6a9atx(56320) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57343) : false;
  }
  function isHighSurrogate(_this__u8e3s4) {
    return _Char___init__impl__6a9atx(55296) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(56319) : false;
  }
  function isWhitespace(_this__u8e3s4) {
    return isWhitespaceImpl(_this__u8e3s4);
  }
  function isLowerCase(_this__u8e3s4) {
    if (_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) {
      return true;
    }
    if (Char__compareTo_impl_ypi4mb(_this__u8e3s4, _Char___init__impl__6a9atx(128)) < 0) {
      return false;
    }
    return isLowerCaseImpl(_this__u8e3s4);
  }
  function titlecaseChar(_this__u8e3s4) {
    return titlecaseCharImpl(_this__u8e3s4);
  }
  function toString_2(_this__u8e3s4, radix) {
    return toStringImpl(_this__u8e3s4, checkRadix(radix));
  }
  function checkRadix(radix) {
    if (!(2 <= radix ? radix <= 36 : false)) {
      throw IllegalArgumentException_init_$Create$_0('radix ' + radix + ' was not in valid range 2..36');
    }
    return radix;
  }
  function toString_3(_this__u8e3s4, radix) {
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.toString(checkRadix(radix));
  }
  function toDouble(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.also' call
    var this_0 = +_this__u8e3s4;
    // Inline function 'kotlin.text.toDouble.<anonymous>' call
    if (isNaN_0(this_0) && !isNaN_2(_this__u8e3s4) || (this_0 === 0.0 && isBlank(_this__u8e3s4))) {
      numberFormatError(_this__u8e3s4);
    }
    return this_0;
  }
  function toLong_0(_this__u8e3s4, radix) {
    var tmp0_elvis_lhs = toLongOrNull_0(_this__u8e3s4, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toDoubleOrNull(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.takeIf' call
    var this_0 = +_this__u8e3s4;
    var tmp;
    // Inline function 'kotlin.text.toDoubleOrNull.<anonymous>' call
    if (!(isNaN_0(this_0) && !isNaN_2(_this__u8e3s4) || (this_0 === 0.0 && isBlank(_this__u8e3s4)))) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function toInt(_this__u8e3s4) {
    var tmp0_elvis_lhs = toIntOrNull(_this__u8e3s4);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toInt_0(_this__u8e3s4, radix) {
    var tmp0_elvis_lhs = toIntOrNull_0(_this__u8e3s4, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toLong_1(_this__u8e3s4) {
    var tmp0_elvis_lhs = toLongOrNull(_this__u8e3s4);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function digitOf(char, radix) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.text.digitOf.<anonymous>' call
    var it = Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(48)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(57)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(48)) : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(90)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65)) + 10 | 0 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(97)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(122)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(97)) + 10 | 0 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(128)) < 0 ? -1 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65313)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65338)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65313)) + 10 | 0 : Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65345)) >= 0 && Char__compareTo_impl_ypi4mb(char, _Char___init__impl__6a9atx(65370)) <= 0 ? Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65345)) + 10 | 0 : digitToIntImpl(char);
    return it >= radix ? -1 : it;
  }
  function isNaN_2(_this__u8e3s4) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    switch (_this__u8e3s4.toLowerCase()) {
      case 'nan':
      case '+nan':
      case '-nan':
        return true;
      default:
        return false;
    }
  }
  function toBoolean(_this__u8e3s4) {
    var tmp;
    if (!(_this__u8e3s4 == null)) {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.toLowerCase() === 'true';
    } else {
      tmp = false;
    }
    return tmp;
  }
  function Regex_init_$Init$(pattern, $this) {
    Regex.call($this, pattern, emptySet());
    return $this;
  }
  function Regex_init_$Create$(pattern) {
    return Regex_init_$Init$(pattern, objectCreate(protoOf(Regex)));
  }
  function Companion_5() {
    Companion_instance_5 = this;
    this.jd_1 = new RegExp('[\\\\^$*+?.()|[\\]{}]', 'g');
    this.kd_1 = new RegExp('[\\\\$]', 'g');
    this.ld_1 = new RegExp('\\$', 'g');
  }
  protoOf(Companion_5).md = function (literal) {
    // Inline function 'kotlin.text.nativeReplace' call
    var pattern = this.jd_1;
    // Inline function 'kotlin.js.asDynamic' call
    return literal.replace(pattern, '\\$&');
  };
  protoOf(Companion_5).nd = function (literal) {
    // Inline function 'kotlin.text.nativeReplace' call
    var pattern = this.ld_1;
    // Inline function 'kotlin.js.asDynamic' call
    return literal.replace(pattern, '$$$$');
  };
  var Companion_instance_5;
  function Companion_getInstance_5() {
    if (Companion_instance_5 == null)
      new Companion_5();
    return Companion_instance_5;
  }
  function Regex$findAll$lambda(this$0, $input, $startIndex) {
    return function () {
      return this$0.td($input, $startIndex);
    };
  }
  function Regex$findAll$lambda_0(match) {
    return match.m();
  }
  function Regex$replace$lambda($replacement) {
    return function (it) {
      return substituteGroupRefs(it, $replacement);
    };
  }
  function Regex(pattern, options) {
    Companion_getInstance_5();
    this.od_1 = pattern;
    this.pd_1 = toSet_0(options);
    this.qd_1 = new RegExp(pattern, toFlags(options, 'gu'));
    this.rd_1 = null;
    this.sd_1 = null;
  }
  protoOf(Regex).ud = function (input) {
    reset_0(this.qd_1);
    var match = this.qd_1.exec(toString_1(input));
    return !(match == null) && match.index === 0 && this.qd_1.lastIndex === charSequenceLength(input);
  };
  protoOf(Regex).vd = function (input) {
    reset_0(this.qd_1);
    return this.qd_1.test(toString_1(input));
  };
  protoOf(Regex).td = function (input, startIndex) {
    if (startIndex < 0 || startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$_0('Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }
    return findNext(this.qd_1, toString_1(input), startIndex, this.qd_1);
  };
  protoOf(Regex).wd = function (input, startIndex, $super) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    return $super === VOID ? this.td(input, startIndex) : $super.td.call(this, input, startIndex);
  };
  protoOf(Regex).xd = function (input, startIndex) {
    if (startIndex < 0 || startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$_0('Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }
    var tmp = Regex$findAll$lambda(this, input, startIndex);
    return generateSequence(tmp, Regex$findAll$lambda_0);
  };
  protoOf(Regex).yd = function (input, startIndex, $super) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    return $super === VOID ? this.xd(input, startIndex) : $super.xd.call(this, input, startIndex);
  };
  protoOf(Regex).zd = function (input, replacement) {
    if (!contains_8(replacement, _Char___init__impl__6a9atx(92)) && !contains_8(replacement, _Char___init__impl__6a9atx(36))) {
      var tmp0 = toString_1(input);
      // Inline function 'kotlin.text.nativeReplace' call
      var pattern = this.qd_1;
      // Inline function 'kotlin.js.asDynamic' call
      return tmp0.replace(pattern, replacement);
    }
    return this.ae(input, Regex$replace$lambda(replacement));
  };
  protoOf(Regex).ae = function (input, transform) {
    var match = this.wd(input);
    if (match == null)
      return toString_1(input);
    var lastStart = 0;
    var length = charSequenceLength(input);
    var sb = StringBuilder_init_$Create$(length);
    do {
      var foundMatch = ensureNotNull(match);
      sb.yc(input, lastStart, foundMatch.be().q1());
      sb.f(transform(foundMatch));
      lastStart = foundMatch.be().r1() + 1 | 0;
      match = foundMatch.m();
    }
     while (lastStart < length && !(match == null));
    if (lastStart < length) {
      sb.yc(input, lastStart, length);
    }
    return sb.toString();
  };
  protoOf(Regex).ce = function (input, limit) {
    requireNonNegativeLimit(limit);
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.text.Regex.split.<anonymous>' call
    var it = this.yd(input);
    var matches = limit === 0 ? it : take_0(it, limit - 1 | 0);
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    var lastStart = 0;
    var _iterator__ex2g4s = matches.k();
    while (_iterator__ex2g4s.l()) {
      var match = _iterator__ex2g4s.m();
      result.e(toString_1(charSequenceSubSequence(input, lastStart, match.be().q1())));
      lastStart = match.be().r1() + 1 | 0;
    }
    result.e(toString_1(charSequenceSubSequence(input, lastStart, charSequenceLength(input))));
    return result;
  };
  protoOf(Regex).toString = function () {
    return this.qd_1.toString();
  };
  function MatchGroup(value) {
    this.de_1 = value;
  }
  protoOf(MatchGroup).toString = function () {
    return 'MatchGroup(value=' + this.de_1 + ')';
  };
  protoOf(MatchGroup).hashCode = function () {
    return getStringHashCode(this.de_1);
  };
  protoOf(MatchGroup).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MatchGroup))
      return false;
    var tmp0_other_with_cast = other instanceof MatchGroup ? other : THROW_CCE();
    if (!(this.de_1 === tmp0_other_with_cast.de_1))
      return false;
    return true;
  };
  function toFlags(_this__u8e3s4, prepend) {
    return joinToString_0(_this__u8e3s4, '', prepend, VOID, VOID, VOID, toFlags$lambda);
  }
  function findNext(_this__u8e3s4, input, from, nextPattern) {
    _this__u8e3s4.lastIndex = from;
    var match = _this__u8e3s4.exec(input);
    if (match == null)
      return null;
    var range = numberRangeToNumber(match.index, _this__u8e3s4.lastIndex - 1 | 0);
    return new findNext$1(range, match, nextPattern, input);
  }
  function substituteGroupRefs(match, replacement) {
    var index = 0;
    var result = StringBuilder_init_$Create$_1();
    while (index < replacement.length) {
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var char = charSequenceGet(replacement, _unary__edvuaz);
      if (char === _Char___init__impl__6a9atx(92)) {
        if (index === replacement.length)
          throw IllegalArgumentException_init_$Create$_0('The Char to be escaped is missing');
        var _unary__edvuaz_0 = index;
        index = _unary__edvuaz_0 + 1 | 0;
        result.e9(charSequenceGet(replacement, _unary__edvuaz_0));
      } else if (char === _Char___init__impl__6a9atx(36)) {
        if (index === replacement.length)
          throw IllegalArgumentException_init_$Create$_0('Capturing group index is missing');
        if (charSequenceGet(replacement, index) === _Char___init__impl__6a9atx(123)) {
          index = index + 1 | 0;
          var endIndex = readGroupName(replacement, index);
          if (index === endIndex)
            throw IllegalArgumentException_init_$Create$_0('Named capturing group reference should have a non-empty name');
          if (endIndex === replacement.length || !(charSequenceGet(replacement, endIndex) === _Char___init__impl__6a9atx(125)))
            throw IllegalArgumentException_init_$Create$_0("Named capturing group reference is missing trailing '}'");
          // Inline function 'kotlin.text.substring' call
          var startIndex = index;
          // Inline function 'kotlin.js.asDynamic' call
          var groupName = replacement.substring(startIndex, endIndex);
          var tmp0_safe_receiver = get_3(match.ee(), groupName);
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.de_1;
          result.d9(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
          index = endIndex + 1 | 0;
        } else {
          var containsArg = charSequenceGet(replacement, index);
          if (!(_Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false))
            throw IllegalArgumentException_init_$Create$_0('Invalid capturing group reference');
          var groups = match.ee();
          var endIndex_0 = readGroupIndex(replacement, index, groups.n());
          // Inline function 'kotlin.text.substring' call
          var startIndex_0 = index;
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$3 = replacement.substring(startIndex_0, endIndex_0);
          var groupIndex = toInt(tmp$ret$3);
          if (groupIndex >= groups.n())
            throw IndexOutOfBoundsException_init_$Create$_0('Group with index ' + groupIndex + ' does not exist');
          var tmp2_safe_receiver = groups.q(groupIndex);
          var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.de_1;
          result.d9(tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs);
          index = endIndex_0;
        }
      } else {
        result.e9(char);
      }
    }
    return result.toString();
  }
  function readGroupName(_this__u8e3s4, startIndex) {
    var index = startIndex;
    $l$loop: while (index < _this__u8e3s4.length) {
      if (charSequenceGet(_this__u8e3s4, index) === _Char___init__impl__6a9atx(125)) {
        break $l$loop;
      } else {
        index = index + 1 | 0;
      }
    }
    return index;
  }
  function get_3(_this__u8e3s4, name) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, MatchNamedGroupCollection) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw UnsupportedOperationException_init_$Create$_0('Retrieving groups by name is not supported on this platform.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var namedGroups = tmp;
    return namedGroups.fe(name);
  }
  function readGroupIndex(_this__u8e3s4, startIndex, groupCount) {
    var index = startIndex + 1 | 0;
    var groupIndex = Char__minus_impl_a2frrh(charSequenceGet(_this__u8e3s4, startIndex), _Char___init__impl__6a9atx(48));
    $l$loop_0: while (true) {
      var tmp;
      if (index < _this__u8e3s4.length) {
        var containsArg = charSequenceGet(_this__u8e3s4, index);
        tmp = _Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false;
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop_0;
      }
      var newGroupIndex = imul(groupIndex, 10) + Char__minus_impl_a2frrh(charSequenceGet(_this__u8e3s4, index), _Char___init__impl__6a9atx(48)) | 0;
      if (0 <= newGroupIndex ? newGroupIndex < groupCount : false) {
        groupIndex = newGroupIndex;
        index = index + 1 | 0;
      } else {
        break $l$loop_0;
      }
    }
    return index;
  }
  function toFlags$lambda(it) {
    return it.ie_1;
  }
  function findNext$o$groups$o$iterator$lambda(this$0) {
    return function (it) {
      return this$0.q(it);
    };
  }
  function hasOwnPrototypeProperty($this, o, name) {
    // Inline function 'kotlin.js.unsafeCast' call
    return Object.prototype.hasOwnProperty.call(o, name);
  }
  function advanceToNextCharacter($this, index) {
    if (index < get_lastIndex_3($this.re_1)) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var code1 = $this.re_1.charCodeAt(index);
      if (55296 <= code1 ? code1 <= 56319 : false) {
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        var code2 = $this.re_1.charCodeAt(index + 1 | 0);
        if (56320 <= code2 ? code2 <= 57343 : false) {
          return index + 2 | 0;
        }
      }
    }
    return index + 1 | 0;
  }
  function findNext$1$groups$1($match, this$0) {
    this.je_1 = $match;
    this.ke_1 = this$0;
    AbstractCollection.call(this);
  }
  protoOf(findNext$1$groups$1).n = function () {
    return this.je_1.length;
  };
  protoOf(findNext$1$groups$1).k = function () {
    var tmp = asSequence_0(get_indices_1(this));
    return map(tmp, findNext$o$groups$o$iterator$lambda(this)).k();
  };
  protoOf(findNext$1$groups$1).q = function (index) {
    // Inline function 'kotlin.js.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = this.je_1[index];
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.text.<no name provided>.get.<anonymous>' call
      tmp = new MatchGroup(tmp0_safe_receiver);
    }
    return tmp;
  };
  protoOf(findNext$1$groups$1).fe = function (name) {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = this.je_1.groups;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$_0('Capturing group with name {' + name + '} does not exist. No named capturing group was defined in Regex');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var groups = tmp;
    if (!hasOwnPrototypeProperty(this.ke_1, groups, name))
      throw IllegalArgumentException_init_$Create$_0('Capturing group with name {' + name + '} does not exist');
    var value = groups[name];
    var tmp_0;
    if (value == undefined) {
      tmp_0 = null;
    } else {
      tmp_0 = new MatchGroup((!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
    }
    return tmp_0;
  };
  function findNext$1($range, $match, $nextPattern, $input) {
    this.oe_1 = $range;
    this.pe_1 = $match;
    this.qe_1 = $nextPattern;
    this.re_1 = $input;
    this.le_1 = $range;
    var tmp = this;
    tmp.me_1 = new findNext$1$groups$1($match, this);
    this.ne_1 = null;
  }
  protoOf(findNext$1).be = function () {
    return this.le_1;
  };
  protoOf(findNext$1).y = function () {
    // Inline function 'kotlin.js.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.pe_1[0];
    return ensureNotNull(tmp$ret$1);
  };
  protoOf(findNext$1).ee = function () {
    return this.me_1;
  };
  protoOf(findNext$1).m = function () {
    return findNext(this.qe_1, this.re_1, this.oe_1.p() ? advanceToNextCharacter(this, this.oe_1.q1()) : this.oe_1.r1() + 1 | 0, this.qe_1);
  };
  var STRING_CASE_INSENSITIVE_ORDER;
  function compareTo_1(_this__u8e3s4, other, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    _init_properties_stringJs_kt__bg7zye();
    if (ignoreCase) {
      var n1 = _this__u8e3s4.length;
      var n2 = other.length;
      // Inline function 'kotlin.comparisons.minOf' call
      var min = Math.min(n1, n2);
      if (min === 0)
        return n1 - n2 | 0;
      var inductionVariable = 0;
      if (inductionVariable < min)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var thisChar = charSequenceGet(_this__u8e3s4, index);
          var otherChar = charSequenceGet(other, index);
          if (!(thisChar === otherChar)) {
            thisChar = uppercaseChar(thisChar);
            otherChar = uppercaseChar(otherChar);
            if (!(thisChar === otherChar)) {
              // Inline function 'kotlin.text.lowercaseChar' call
              // Inline function 'kotlin.text.lowercase' call
              var this_0 = thisChar;
              // Inline function 'kotlin.js.asDynamic' call
              // Inline function 'kotlin.js.unsafeCast' call
              var tmp$ret$3 = toString(this_0).toLowerCase();
              thisChar = charSequenceGet(tmp$ret$3, 0);
              // Inline function 'kotlin.text.lowercaseChar' call
              // Inline function 'kotlin.text.lowercase' call
              var this_1 = otherChar;
              // Inline function 'kotlin.js.asDynamic' call
              // Inline function 'kotlin.js.unsafeCast' call
              var tmp$ret$7 = toString(this_1).toLowerCase();
              otherChar = charSequenceGet(tmp$ret$7, 0);
              if (!(thisChar === otherChar)) {
                return Char__compareTo_impl_ypi4mb(thisChar, otherChar);
              }
            }
          }
        }
         while (inductionVariable < min);
      return n1 - n2 | 0;
    } else {
      return compareTo_0(_this__u8e3s4, other);
    }
  }
  function concatToString(_this__u8e3s4) {
    _init_properties_stringJs_kt__bg7zye();
    var result = '';
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    while (inductionVariable < last) {
      var char = _this__u8e3s4[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      result = result + toString(char);
    }
    return result;
  }
  function concatToString_0(_this__u8e3s4, startIndex, endIndex) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
    _init_properties_stringJs_kt__bg7zye();
    Companion_instance_6.id(startIndex, endIndex, _this__u8e3s4.length);
    var result = '';
    var inductionVariable = startIndex;
    if (inductionVariable < endIndex)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = result + toString(_this__u8e3s4[index]);
      }
       while (inductionVariable < endIndex);
    return result;
  }
  function encodeToByteArray(_this__u8e3s4) {
    _init_properties_stringJs_kt__bg7zye();
    return encodeUtf8(_this__u8e3s4, 0, _this__u8e3s4.length, false);
  }
  function decodeToString(_this__u8e3s4) {
    _init_properties_stringJs_kt__bg7zye();
    return decodeUtf8(_this__u8e3s4, 0, _this__u8e3s4.length, false);
  }
  function decodeToString_0(_this__u8e3s4, startIndex, endIndex, throwOnInvalidSequence) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
    throwOnInvalidSequence = throwOnInvalidSequence === VOID ? false : throwOnInvalidSequence;
    _init_properties_stringJs_kt__bg7zye();
    Companion_instance_6.id(startIndex, endIndex, _this__u8e3s4.length);
    return decodeUtf8(_this__u8e3s4, startIndex, endIndex, throwOnInvalidSequence);
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.se_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).te = function (a, b) {
    return this.se_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.te(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).b4 = function () {
    return this.se_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function STRING_CASE_INSENSITIVE_ORDER$lambda(a, b) {
    _init_properties_stringJs_kt__bg7zye();
    return compareTo_1(a, b, true);
  }
  var properties_initialized_stringJs_kt_nta8o4;
  function _init_properties_stringJs_kt__bg7zye() {
    if (!properties_initialized_stringJs_kt_nta8o4) {
      properties_initialized_stringJs_kt_nta8o4 = true;
      var tmp = STRING_CASE_INSENSITIVE_ORDER$lambda;
      STRING_CASE_INSENSITIVE_ORDER = new sam$kotlin_Comparator$0(tmp);
    }
  }
  function startsWith(_this__u8e3s4, prefix, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    if (!ignoreCase) {
      // Inline function 'kotlin.text.nativeStartsWith' call
      // Inline function 'kotlin.js.asDynamic' call
      return _this__u8e3s4.startsWith(prefix, 0);
    } else
      return regionMatches(_this__u8e3s4, 0, prefix, 0, prefix.length, ignoreCase);
  }
  function equals_0(_this__u8e3s4, other, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    if (_this__u8e3s4 == null)
      return other == null;
    if (other == null)
      return false;
    if (!ignoreCase)
      return _this__u8e3s4 == other;
    if (!(_this__u8e3s4.length === other.length))
      return false;
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var thisChar = charSequenceGet(_this__u8e3s4, index);
        var otherChar = charSequenceGet(other, index);
        if (!equals_1(thisChar, otherChar, ignoreCase)) {
          return false;
        }
      }
       while (inductionVariable < last);
    return true;
  }
  function endsWith(_this__u8e3s4, suffix, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    if (!ignoreCase) {
      // Inline function 'kotlin.text.nativeEndsWith' call
      // Inline function 'kotlin.js.asDynamic' call
      return _this__u8e3s4.endsWith(suffix);
    } else
      return regionMatches(_this__u8e3s4, _this__u8e3s4.length - suffix.length | 0, suffix, 0, suffix.length, ignoreCase);
  }
  function replace(_this__u8e3s4, oldValue, newValue, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp1 = new RegExp(Companion_getInstance_5().md(oldValue), ignoreCase ? 'gui' : 'gu');
    // Inline function 'kotlin.text.nativeReplace' call
    var replacement = Companion_getInstance_5().nd(newValue);
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.replace(tmp1, replacement);
  }
  function regionMatches(_this__u8e3s4, thisOffset, other, otherOffset, length, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    return regionMatchesImpl(_this__u8e3s4, thisOffset, other, otherOffset, length, ignoreCase);
  }
  function startsWith_0(_this__u8e3s4, prefix, startIndex, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    if (!ignoreCase) {
      // Inline function 'kotlin.text.nativeStartsWith' call
      // Inline function 'kotlin.js.asDynamic' call
      return _this__u8e3s4.startsWith(prefix, startIndex);
    } else
      return regionMatches(_this__u8e3s4, startIndex, prefix, 0, prefix.length, ignoreCase);
  }
  function replace_0(_this__u8e3s4, oldChar, newChar, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp1 = new RegExp(Companion_getInstance_5().md(toString(oldChar)), ignoreCase ? 'gui' : 'gu');
    // Inline function 'kotlin.text.nativeReplace' call
    var replacement = toString(newChar);
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.replace(tmp1, replacement);
  }
  function repeat(_this__u8e3s4, n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      // Inline function 'kotlin.text.repeat.<anonymous>' call
      var message = "Count 'n' must be non-negative, but was " + n + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    switch (n) {
      case 0:
        tmp = '';
        break;
      case 1:
        tmp = toString_1(_this__u8e3s4);
        break;
      default:
        var result = '';
        // Inline function 'kotlin.text.isEmpty' call

        if (!(charSequenceLength(_this__u8e3s4) === 0)) {
          var s = toString_1(_this__u8e3s4);
          var count = n;
          $l$loop: while (true) {
            if ((count & 1) === 1) {
              result = result + s;
            }
            count = count >>> 1 | 0;
            if (count === 0) {
              break $l$loop;
            }
            s = s + s;
          }
        }

        return result;
    }
    return tmp;
  }
  function get_REPLACEMENT_BYTE_SEQUENCE() {
    _init_properties_utf8Encoding_kt__9thjs4();
    return REPLACEMENT_BYTE_SEQUENCE;
  }
  var REPLACEMENT_BYTE_SEQUENCE;
  function encodeUtf8(string, startIndex, endIndex, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(startIndex >= 0 && endIndex <= string.length && startIndex <= endIndex)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var bytes = new Int8Array(imul(endIndex - startIndex | 0, 3));
    var byteIndex = 0;
    var charIndex = startIndex;
    while (charIndex < endIndex) {
      var _unary__edvuaz = charIndex;
      charIndex = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet(string, _unary__edvuaz);
      var code = Char__toInt_impl_vasixd(this_0);
      if (code < 128) {
        var _unary__edvuaz_0 = byteIndex;
        byteIndex = _unary__edvuaz_0 + 1 | 0;
        bytes[_unary__edvuaz_0] = toByte(code);
      } else if (code < 2048) {
        var _unary__edvuaz_1 = byteIndex;
        byteIndex = _unary__edvuaz_1 + 1 | 0;
        bytes[_unary__edvuaz_1] = toByte(code >> 6 | 192);
        var _unary__edvuaz_2 = byteIndex;
        byteIndex = _unary__edvuaz_2 + 1 | 0;
        bytes[_unary__edvuaz_2] = toByte(code & 63 | 128);
      } else if (code < 55296 || code >= 57344) {
        var _unary__edvuaz_3 = byteIndex;
        byteIndex = _unary__edvuaz_3 + 1 | 0;
        bytes[_unary__edvuaz_3] = toByte(code >> 12 | 224);
        var _unary__edvuaz_4 = byteIndex;
        byteIndex = _unary__edvuaz_4 + 1 | 0;
        bytes[_unary__edvuaz_4] = toByte(code >> 6 & 63 | 128);
        var _unary__edvuaz_5 = byteIndex;
        byteIndex = _unary__edvuaz_5 + 1 | 0;
        bytes[_unary__edvuaz_5] = toByte(code & 63 | 128);
      } else {
        var codePoint = codePointFromSurrogate(string, code, charIndex, endIndex, throwOnMalformed);
        if (codePoint <= 0) {
          var _unary__edvuaz_6 = byteIndex;
          byteIndex = _unary__edvuaz_6 + 1 | 0;
          bytes[_unary__edvuaz_6] = get_REPLACEMENT_BYTE_SEQUENCE()[0];
          var _unary__edvuaz_7 = byteIndex;
          byteIndex = _unary__edvuaz_7 + 1 | 0;
          bytes[_unary__edvuaz_7] = get_REPLACEMENT_BYTE_SEQUENCE()[1];
          var _unary__edvuaz_8 = byteIndex;
          byteIndex = _unary__edvuaz_8 + 1 | 0;
          bytes[_unary__edvuaz_8] = get_REPLACEMENT_BYTE_SEQUENCE()[2];
        } else {
          var _unary__edvuaz_9 = byteIndex;
          byteIndex = _unary__edvuaz_9 + 1 | 0;
          bytes[_unary__edvuaz_9] = toByte(codePoint >> 18 | 240);
          var _unary__edvuaz_10 = byteIndex;
          byteIndex = _unary__edvuaz_10 + 1 | 0;
          bytes[_unary__edvuaz_10] = toByte(codePoint >> 12 & 63 | 128);
          var _unary__edvuaz_11 = byteIndex;
          byteIndex = _unary__edvuaz_11 + 1 | 0;
          bytes[_unary__edvuaz_11] = toByte(codePoint >> 6 & 63 | 128);
          var _unary__edvuaz_12 = byteIndex;
          byteIndex = _unary__edvuaz_12 + 1 | 0;
          bytes[_unary__edvuaz_12] = toByte(codePoint & 63 | 128);
          charIndex = charIndex + 1 | 0;
        }
      }
    }
    return bytes.length === byteIndex ? bytes : copyOf_5(bytes, byteIndex);
  }
  function decodeUtf8(bytes, startIndex, endIndex, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(startIndex >= 0 && endIndex <= bytes.length && startIndex <= endIndex)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var byteIndex = startIndex;
    var stringBuilder = StringBuilder_init_$Create$_1();
    while (byteIndex < endIndex) {
      var _unary__edvuaz = byteIndex;
      byteIndex = _unary__edvuaz + 1 | 0;
      var byte = bytes[_unary__edvuaz];
      if (byte >= 0)
        stringBuilder.e9(numberToChar(byte));
      else if (byte >> 5 === -2) {
        var code = codePointFrom2(bytes, byte, byteIndex, endIndex, throwOnMalformed);
        if (code <= 0) {
          stringBuilder.e9(_Char___init__impl__6a9atx(65533));
          byteIndex = byteIndex + (-code | 0) | 0;
        } else {
          stringBuilder.e9(numberToChar(code));
          byteIndex = byteIndex + 1 | 0;
        }
      } else if (byte >> 4 === -2) {
        var code_0 = codePointFrom3(bytes, byte, byteIndex, endIndex, throwOnMalformed);
        if (code_0 <= 0) {
          stringBuilder.e9(_Char___init__impl__6a9atx(65533));
          byteIndex = byteIndex + (-code_0 | 0) | 0;
        } else {
          stringBuilder.e9(numberToChar(code_0));
          byteIndex = byteIndex + 2 | 0;
        }
      } else if (byte >> 3 === -2) {
        var code_1 = codePointFrom4(bytes, byte, byteIndex, endIndex, throwOnMalformed);
        if (code_1 <= 0) {
          stringBuilder.e9(_Char___init__impl__6a9atx(65533));
          byteIndex = byteIndex + (-code_1 | 0) | 0;
        } else {
          var high = (code_1 - 65536 | 0) >> 10 | 55296;
          var low = code_1 & 1023 | 56320;
          stringBuilder.e9(numberToChar(high));
          stringBuilder.e9(numberToChar(low));
          byteIndex = byteIndex + 3 | 0;
        }
      } else {
        malformed(0, byteIndex, throwOnMalformed);
        stringBuilder.e9(_Char___init__impl__6a9atx(65533));
      }
    }
    return stringBuilder.toString();
  }
  function codePointFromSurrogate(string, high, index, endIndex, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    if (!(55296 <= high ? high <= 56319 : false) || index >= endIndex) {
      return malformed(0, index, throwOnMalformed);
    }
    // Inline function 'kotlin.code' call
    var this_0 = charSequenceGet(string, index);
    var low = Char__toInt_impl_vasixd(this_0);
    if (!(56320 <= low ? low <= 57343 : false)) {
      return malformed(0, index, throwOnMalformed);
    }
    return 65536 + ((high & 1023) << 10) | 0 | low & 1023;
  }
  function codePointFrom2(bytes, byte1, index, endIndex, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    if ((byte1 & 30) === 0 || index >= endIndex) {
      return malformed(0, index, throwOnMalformed);
    }
    var byte2 = bytes[index];
    if (!((byte2 & 192) === 128)) {
      return malformed(0, index, throwOnMalformed);
    }
    return byte1 << 6 ^ byte2 ^ 3968;
  }
  function codePointFrom3(bytes, byte1, index, endIndex, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    if (index >= endIndex) {
      return malformed(0, index, throwOnMalformed);
    }
    var byte2 = bytes[index];
    if ((byte1 & 15) === 0) {
      if (!((byte2 & 224) === 160)) {
        return malformed(0, index, throwOnMalformed);
      }
    } else if ((byte1 & 15) === 13) {
      if (!((byte2 & 224) === 128)) {
        return malformed(0, index, throwOnMalformed);
      }
    } else if (!((byte2 & 192) === 128)) {
      return malformed(0, index, throwOnMalformed);
    }
    if ((index + 1 | 0) === endIndex) {
      return malformed(1, index, throwOnMalformed);
    }
    var byte3 = bytes[index + 1 | 0];
    if (!((byte3 & 192) === 128)) {
      return malformed(1, index, throwOnMalformed);
    }
    return byte1 << 12 ^ byte2 << 6 ^ byte3 ^ -123008;
  }
  function codePointFrom4(bytes, byte1, index, endIndex, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    if (index >= endIndex) {
      return malformed(0, index, throwOnMalformed);
    }
    var byte2 = bytes[index];
    if ((byte1 & 15) === 0) {
      if ((byte2 & 240) <= 128) {
        return malformed(0, index, throwOnMalformed);
      }
    } else if ((byte1 & 15) === 4) {
      if (!((byte2 & 240) === 128)) {
        return malformed(0, index, throwOnMalformed);
      }
    } else if ((byte1 & 15) > 4) {
      return malformed(0, index, throwOnMalformed);
    }
    if (!((byte2 & 192) === 128)) {
      return malformed(0, index, throwOnMalformed);
    }
    if ((index + 1 | 0) === endIndex) {
      return malformed(1, index, throwOnMalformed);
    }
    var byte3 = bytes[index + 1 | 0];
    if (!((byte3 & 192) === 128)) {
      return malformed(1, index, throwOnMalformed);
    }
    if ((index + 2 | 0) === endIndex) {
      return malformed(2, index, throwOnMalformed);
    }
    var byte4 = bytes[index + 2 | 0];
    if (!((byte4 & 192) === 128)) {
      return malformed(2, index, throwOnMalformed);
    }
    return byte1 << 18 ^ byte2 << 12 ^ byte3 << 6 ^ byte4 ^ 3678080;
  }
  function malformed(size, index, throwOnMalformed) {
    _init_properties_utf8Encoding_kt__9thjs4();
    if (throwOnMalformed)
      throw new CharacterCodingException('Malformed sequence starting at ' + (index - 1 | 0));
    return -size | 0;
  }
  var properties_initialized_utf8Encoding_kt_eee1vq;
  function _init_properties_utf8Encoding_kt__9thjs4() {
    if (!properties_initialized_utf8Encoding_kt_eee1vq) {
      properties_initialized_utf8Encoding_kt_eee1vq = true;
      // Inline function 'kotlin.byteArrayOf' call
      REPLACEMENT_BYTE_SEQUENCE = new Int8Array([-17, -65, -67]);
    }
  }
  function addSuppressed(_this__u8e3s4, exception) {
    if (!(_this__u8e3s4 === exception)) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var suppressed = _this__u8e3s4._suppressed;
      if (suppressed == null) {
        // Inline function 'kotlin.js.asDynamic' call
        _this__u8e3s4._suppressed = mutableListOf([exception]);
      } else {
        suppressed.e(exception);
      }
    }
  }
  function formatToExactDecimals(value, decimals) {
    var tmp;
    if (decimals === 0) {
      tmp = value;
    } else {
      // Inline function 'kotlin.math.pow' call
      var pow = Math.pow(10.0, decimals);
      var tmp_0 = Math;
      // Inline function 'kotlin.math.abs' call
      var tmp$ret$1 = Math.abs(value);
      var tmp_1 = tmp_0.round(tmp$ret$1 * pow) / pow;
      // Inline function 'kotlin.math.sign' call
      tmp = tmp_1 * sign(value);
    }
    var rounded = tmp;
    var tmp_2;
    // Inline function 'kotlin.math.abs' call
    if (Math.abs(rounded) < 1.0E21) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp_2 = rounded.toFixed(decimals);
    } else {
      // Inline function 'kotlin.math.abs' call
      var positive = Math.abs(rounded);
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.math.log10' call
      // Inline function 'kotlin.math.ceil' call
      var x = log10(positive);
      var tmp$ret$9 = Math.ceil(x);
      // Inline function 'kotlin.js.unsafeCast' call
      var positiveString = positive.toPrecision(tmp$ret$9 + decimals);
      tmp_2 = rounded < 0 ? '-' + positiveString : positiveString;
    }
    return tmp_2;
  }
  var DurationUnit_NANOSECONDS_instance;
  var DurationUnit_MICROSECONDS_instance;
  var DurationUnit_MILLISECONDS_instance;
  var DurationUnit_SECONDS_instance;
  var DurationUnit_MINUTES_instance;
  var DurationUnit_HOURS_instance;
  var DurationUnit_DAYS_instance;
  var DurationUnit_entriesInitialized;
  function DurationUnit_initEntries() {
    if (DurationUnit_entriesInitialized)
      return Unit_instance;
    DurationUnit_entriesInitialized = true;
    DurationUnit_NANOSECONDS_instance = new DurationUnit('NANOSECONDS', 0, 1.0);
    DurationUnit_MICROSECONDS_instance = new DurationUnit('MICROSECONDS', 1, 1000.0);
    DurationUnit_MILLISECONDS_instance = new DurationUnit('MILLISECONDS', 2, 1000000.0);
    DurationUnit_SECONDS_instance = new DurationUnit('SECONDS', 3, 1.0E9);
    DurationUnit_MINUTES_instance = new DurationUnit('MINUTES', 4, 6.0E10);
    DurationUnit_HOURS_instance = new DurationUnit('HOURS', 5, 3.6E12);
    DurationUnit_DAYS_instance = new DurationUnit('DAYS', 6, 8.64E13);
  }
  function DurationUnit(name, ordinal, scale) {
    Enum.call(this, name, ordinal);
    this.we_1 = scale;
  }
  function convertDurationUnit(value, sourceUnit, targetUnit) {
    var sourceCompareTarget = compareTo_0(sourceUnit.we_1, targetUnit.we_1);
    return sourceCompareTarget > 0 ? value * (sourceUnit.we_1 / targetUnit.we_1) : sourceCompareTarget < 0 ? value / (targetUnit.we_1 / sourceUnit.we_1) : value;
  }
  function convertDurationUnit_0(value, sourceUnit, targetUnit) {
    var sourceCompareTarget = compareTo_0(sourceUnit.we_1, targetUnit.we_1);
    var tmp;
    if (sourceCompareTarget > 0) {
      var scale = numberToLong(sourceUnit.we_1 / targetUnit.we_1);
      var result = value.k3(scale);
      tmp = result.l3(scale).equals(value) ? result : value.d1(new Long(0, 0)) > 0 ? new Long(-1, 2147483647) : new Long(0, -2147483648);
    } else if (sourceCompareTarget < 0) {
      tmp = value.l3(numberToLong(targetUnit.we_1 / sourceUnit.we_1));
    } else {
      tmp = value;
    }
    return tmp;
  }
  function convertDurationUnitOverflow(value, sourceUnit, targetUnit) {
    var sourceCompareTarget = compareTo_0(sourceUnit.we_1, targetUnit.we_1);
    return sourceCompareTarget > 0 ? value.k3(numberToLong(sourceUnit.we_1 / targetUnit.we_1)) : sourceCompareTarget < 0 ? value.l3(numberToLong(targetUnit.we_1 / sourceUnit.we_1)) : value;
  }
  function DurationUnit_NANOSECONDS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_NANOSECONDS_instance;
  }
  function DurationUnit_MICROSECONDS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_MICROSECONDS_instance;
  }
  function DurationUnit_MILLISECONDS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_MILLISECONDS_instance;
  }
  function DurationUnit_SECONDS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_SECONDS_instance;
  }
  function DurationUnit_MINUTES_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_MINUTES_instance;
  }
  function DurationUnit_HOURS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_HOURS_instance;
  }
  function DurationUnit_DAYS_getInstance() {
    DurationUnit_initEntries();
    return DurationUnit_DAYS_instance;
  }
  function MonotonicTimeSource() {
    MonotonicTimeSource_instance = this;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.time.MonotonicTimeSource.actualSource.<anonymous>' call
    var isNode = typeof process !== 'undefined' && process.versions && !!process.versions.node;
    var tmp_0;
    if (isNode) {
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$0 = process;
      tmp_0 = new HrTimeSource(tmp$ret$0);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp0_safe_receiver = typeof self !== 'undefined' ? self : globalThis;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.performance;
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.time.MonotonicTimeSource.actualSource.<anonymous>.stub_for_inlining' call
        tmp_1 = new PerformanceTimeSource(tmp1_safe_receiver);
      }
      var tmp2_elvis_lhs = tmp_1;
      tmp_0 = tmp2_elvis_lhs == null ? DateNowTimeSource_instance : tmp2_elvis_lhs;
    }
    tmp.xe_1 = tmp_0;
  }
  protoOf(MonotonicTimeSource).ye = function () {
    return this.xe_1.ye();
  };
  protoOf(MonotonicTimeSource).ze = function () {
    return new ValueTimeMark(this.ye());
  };
  protoOf(MonotonicTimeSource).af = function (timeMark) {
    return this.xe_1.af(timeMark);
  };
  protoOf(MonotonicTimeSource).bf = function (one, another) {
    return this.xe_1.bf(one, another);
  };
  var MonotonicTimeSource_instance;
  function MonotonicTimeSource_getInstance() {
    if (MonotonicTimeSource_instance == null)
      new MonotonicTimeSource();
    return MonotonicTimeSource_instance;
  }
  function Reading(components) {
    this.cf_1 = components;
  }
  protoOf(Reading).equals = function (other) {
    var tmp;
    if (other instanceof Reading) {
      tmp = contentEquals(this.cf_1, other.cf_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Reading).hashCode = function () {
    return contentHashCode(this.cf_1);
  };
  protoOf(Reading).toString = function () {
    return contentToString(this.cf_1);
  };
  function HrTimeSource(process) {
    this.df_1 = process;
  }
  protoOf(HrTimeSource).ye = function () {
    return _ValueTimeMark___init__impl__uyfl2m(new Reading(this.df_1.hrtime()));
  };
  protoOf(HrTimeSource).ze = function () {
    return new ValueTimeMark(this.ye());
  };
  protoOf(HrTimeSource).af = function (timeMark) {
    var tmp = _ValueTimeMark___get_reading__impl__5qz8rd(timeMark);
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.time.HrTimeSource.elapsedFrom.<anonymous>' call
    var destruct = this.df_1.hrtime((tmp instanceof Reading ? tmp : THROW_CCE()).cf_1);
    // Inline function 'kotlin.collections.component1' call
    var seconds = destruct[0];
    // Inline function 'kotlin.collections.component2' call
    var nanos = destruct[1];
    return Duration__plus_impl_yu9v8f(toDuration_1(seconds, DurationUnit_SECONDS_getInstance()), toDuration_1(nanos, DurationUnit_NANOSECONDS_getInstance()));
  };
  protoOf(HrTimeSource).bf = function (one, another) {
    var tmp = _ValueTimeMark___get_reading__impl__5qz8rd(one);
    var _destruct__k2r9zo = tmp instanceof Reading ? tmp : THROW_CCE();
    // Inline function 'kotlin.time.Reading.component1' call
    // Inline function 'kotlin.collections.component1' call
    var s1 = _destruct__k2r9zo.cf_1[0];
    // Inline function 'kotlin.time.Reading.component2' call
    // Inline function 'kotlin.collections.component2' call
    var n1 = _destruct__k2r9zo.cf_1[1];
    var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(another);
    var _destruct__k2r9zo_0 = tmp_0 instanceof Reading ? tmp_0 : THROW_CCE();
    // Inline function 'kotlin.time.Reading.component1' call
    // Inline function 'kotlin.collections.component1' call
    var s2 = _destruct__k2r9zo_0.cf_1[0];
    // Inline function 'kotlin.time.Reading.component2' call
    // Inline function 'kotlin.collections.component2' call
    var n2 = _destruct__k2r9zo_0.cf_1[1];
    return Duration__plus_impl_yu9v8f(s1 === s2 && n1 === n2 ? Companion_getInstance_16().ff_1 : toDuration_1(s1 - s2, DurationUnit_SECONDS_getInstance()), toDuration_1(n1 - n2, DurationUnit_NANOSECONDS_getInstance()));
  };
  protoOf(HrTimeSource).toString = function () {
    return 'TimeSource(process.hrtime())';
  };
  function read($this) {
    return $this.if_1.now();
  }
  function PerformanceTimeSource(performance) {
    this.if_1 = performance;
  }
  protoOf(PerformanceTimeSource).ye = function () {
    return _ValueTimeMark___init__impl__uyfl2m(read(this));
  };
  protoOf(PerformanceTimeSource).ze = function () {
    return new ValueTimeMark(this.ye());
  };
  protoOf(PerformanceTimeSource).af = function (timeMark) {
    Companion_getInstance_16();
    var tmp = read(this);
    var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(timeMark);
    // Inline function 'kotlin.time.Companion.milliseconds' call
    var this_0 = tmp - (typeof tmp_0 === 'number' ? tmp_0 : THROW_CCE());
    return toDuration_1(this_0, DurationUnit_MILLISECONDS_getInstance());
  };
  protoOf(PerformanceTimeSource).bf = function (one, another) {
    var tmp = _ValueTimeMark___get_reading__impl__5qz8rd(one);
    var ms1 = typeof tmp === 'number' ? tmp : THROW_CCE();
    var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(another);
    var ms2 = typeof tmp_0 === 'number' ? tmp_0 : THROW_CCE();
    var tmp_1;
    if (ms1 === ms2) {
      tmp_1 = Companion_getInstance_16().ff_1;
    } else {
      Companion_getInstance_16();
      // Inline function 'kotlin.time.Companion.milliseconds' call
      var this_0 = ms1 - ms2;
      tmp_1 = toDuration_1(this_0, DurationUnit_MILLISECONDS_getInstance());
    }
    return tmp_1;
  };
  protoOf(PerformanceTimeSource).toString = function () {
    return 'TimeSource(self.performance.now())';
  };
  function read_0($this) {
    return Date.now();
  }
  function DateNowTimeSource() {
  }
  protoOf(DateNowTimeSource).ye = function () {
    return _ValueTimeMark___init__impl__uyfl2m(read_0(this));
  };
  protoOf(DateNowTimeSource).ze = function () {
    return new ValueTimeMark(this.ye());
  };
  protoOf(DateNowTimeSource).af = function (timeMark) {
    Companion_getInstance_16();
    var tmp = read_0(this);
    var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(timeMark);
    // Inline function 'kotlin.time.Companion.milliseconds' call
    var this_0 = tmp - (typeof tmp_0 === 'number' ? tmp_0 : THROW_CCE());
    return toDuration_1(this_0, DurationUnit_MILLISECONDS_getInstance());
  };
  protoOf(DateNowTimeSource).bf = function (one, another) {
    var tmp = _ValueTimeMark___get_reading__impl__5qz8rd(one);
    var ms1 = typeof tmp === 'number' ? tmp : THROW_CCE();
    var tmp_0 = _ValueTimeMark___get_reading__impl__5qz8rd(another);
    var ms2 = typeof tmp_0 === 'number' ? tmp_0 : THROW_CCE();
    var tmp_1;
    if (ms1 === ms2) {
      tmp_1 = Companion_getInstance_16().ff_1;
    } else {
      Companion_getInstance_16();
      // Inline function 'kotlin.time.Companion.milliseconds' call
      var this_0 = ms1 - ms2;
      tmp_1 = toDuration_1(this_0, DurationUnit_MILLISECONDS_getInstance());
    }
    return tmp_1;
  };
  protoOf(DateNowTimeSource).toString = function () {
    return 'TimeSource(Date.now())';
  };
  var DateNowTimeSource_instance;
  function DateNowTimeSource_getInstance() {
    return DateNowTimeSource_instance;
  }
  function AbstractCollection$toString$lambda(this$0) {
    return function (it) {
      return it === this$0 ? '(this Collection)' : toString_0(it);
    };
  }
  function AbstractCollection() {
  }
  protoOf(AbstractCollection).s = function (element) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(this, Collection)) {
        tmp = this.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = this.k();
      while (_iterator__ex2g4s.l()) {
        var element_0 = _iterator__ex2g4s.m();
        // Inline function 'kotlin.collections.AbstractCollection.contains.<anonymous>' call
        if (equals(element_0, element)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractCollection).h2 = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlin.collections.AbstractCollection.containsAll.<anonymous>' call
        if (!this.s(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractCollection).p = function () {
    return this.n() === 0;
  };
  protoOf(AbstractCollection).toString = function () {
    return joinToString_0(this, ', ', '[', ']', VOID, VOID, AbstractCollection$toString$lambda(this));
  };
  protoOf(AbstractCollection).toArray = function () {
    return collectionToArray(this);
  };
  function SubList_0(list, fromIndex, toIndex) {
    AbstractList.call(this);
    this.jf_1 = list;
    this.kf_1 = fromIndex;
    this.lf_1 = 0;
    Companion_instance_6.n4(this.kf_1, toIndex, this.jf_1.n());
    this.lf_1 = toIndex - this.kf_1 | 0;
  }
  protoOf(SubList_0).q = function (index) {
    Companion_instance_6.x4(index, this.lf_1);
    return this.jf_1.q(this.kf_1 + index | 0);
  };
  protoOf(SubList_0).n = function () {
    return this.lf_1;
  };
  function IteratorImpl_0($outer) {
    this.nf_1 = $outer;
    this.mf_1 = 0;
  }
  protoOf(IteratorImpl_0).l = function () {
    return this.mf_1 < this.nf_1.n();
  };
  protoOf(IteratorImpl_0).m = function () {
    if (!this.l())
      throw NoSuchElementException_init_$Create$();
    var _unary__edvuaz = this.mf_1;
    this.mf_1 = _unary__edvuaz + 1 | 0;
    return this.nf_1.q(_unary__edvuaz);
  };
  function ListIteratorImpl_0($outer, index) {
    this.qf_1 = $outer;
    IteratorImpl_0.call(this, $outer);
    Companion_instance_6.k5(index, this.qf_1.n());
    this.mf_1 = index;
  }
  protoOf(ListIteratorImpl_0).l5 = function () {
    return this.mf_1 > 0;
  };
  protoOf(ListIteratorImpl_0).m5 = function () {
    return this.mf_1;
  };
  protoOf(ListIteratorImpl_0).n5 = function () {
    if (!this.l5())
      throw NoSuchElementException_init_$Create$();
    this.mf_1 = this.mf_1 - 1 | 0;
    return this.qf_1.q(this.mf_1);
  };
  protoOf(ListIteratorImpl_0).o5 = function () {
    return this.mf_1 - 1 | 0;
  };
  function Companion_6() {
    this.m4_1 = 2147483639;
  }
  protoOf(Companion_6).x4 = function (index, size) {
    if (index < 0 || index >= size) {
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
    }
  };
  protoOf(Companion_6).k5 = function (index, size) {
    if (index < 0 || index > size) {
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
    }
  };
  protoOf(Companion_6).n4 = function (fromIndex, toIndex, size) {
    if (fromIndex < 0 || toIndex > size) {
      throw IndexOutOfBoundsException_init_$Create$_0('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size);
    }
    if (fromIndex > toIndex) {
      throw IllegalArgumentException_init_$Create$_0('fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
    }
  };
  protoOf(Companion_6).id = function (startIndex, endIndex, size) {
    if (startIndex < 0 || endIndex > size) {
      throw IndexOutOfBoundsException_init_$Create$_0('startIndex: ' + startIndex + ', endIndex: ' + endIndex + ', size: ' + size);
    }
    if (startIndex > endIndex) {
      throw IllegalArgumentException_init_$Create$_0('startIndex: ' + startIndex + ' > endIndex: ' + endIndex);
    }
  };
  protoOf(Companion_6).d8 = function (oldCapacity, minCapacity) {
    var newCapacity = oldCapacity + (oldCapacity >> 1) | 0;
    if ((newCapacity - minCapacity | 0) < 0)
      newCapacity = minCapacity;
    if ((newCapacity - 2147483639 | 0) > 0)
      newCapacity = minCapacity > 2147483639 ? 2147483647 : 2147483639;
    return newCapacity;
  };
  protoOf(Companion_6).v5 = function (c) {
    var hashCode_0 = 1;
    var _iterator__ex2g4s = c.k();
    while (_iterator__ex2g4s.l()) {
      var e = _iterator__ex2g4s.m();
      var tmp = imul(31, hashCode_0);
      var tmp1_elvis_lhs = e == null ? null : hashCode(e);
      hashCode_0 = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    return hashCode_0;
  };
  protoOf(Companion_6).u5 = function (c, other) {
    if (!(c.n() === other.n()))
      return false;
    var otherIterator = other.k();
    var _iterator__ex2g4s = c.k();
    while (_iterator__ex2g4s.l()) {
      var elem = _iterator__ex2g4s.m();
      var elemOther = otherIterator.m();
      if (!equals(elem, elemOther)) {
        return false;
      }
    }
    return true;
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function AbstractList() {
    AbstractCollection.call(this);
  }
  protoOf(AbstractList).k = function () {
    return new IteratorImpl_0(this);
  };
  protoOf(AbstractList).t = function (element) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var _iterator__ex2g4s = this.k();
      while (_iterator__ex2g4s.l()) {
        var item = _iterator__ex2g4s.m();
        // Inline function 'kotlin.collections.AbstractList.indexOf.<anonymous>' call
        if (equals(item, element)) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  };
  protoOf(AbstractList).u = function (element) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfLast' call
      var iterator = this.r(this.n());
      while (iterator.l5()) {
        // Inline function 'kotlin.collections.AbstractList.lastIndexOf.<anonymous>' call
        var it = iterator.n5();
        if (equals(it, element)) {
          tmp$ret$1 = iterator.m5();
          break $l$block;
        }
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  };
  protoOf(AbstractList).i2 = function () {
    return new ListIteratorImpl_0(this, 0);
  };
  protoOf(AbstractList).r = function (index) {
    return new ListIteratorImpl_0(this, index);
  };
  protoOf(AbstractList).j2 = function (fromIndex, toIndex) {
    return new SubList_0(this, fromIndex, toIndex);
  };
  protoOf(AbstractList).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtList) : false))
      return false;
    return Companion_instance_6.u5(this, other);
  };
  protoOf(AbstractList).hashCode = function () {
    return Companion_instance_6.v5(this);
  };
  function AbstractMap$keys$1$iterator$1($entryIterator) {
    this.rf_1 = $entryIterator;
  }
  protoOf(AbstractMap$keys$1$iterator$1).l = function () {
    return this.rf_1.l();
  };
  protoOf(AbstractMap$keys$1$iterator$1).m = function () {
    return this.rf_1.m().x();
  };
  function AbstractMap$values$1$iterator$1($entryIterator) {
    this.sf_1 = $entryIterator;
  }
  protoOf(AbstractMap$values$1$iterator$1).l = function () {
    return this.sf_1.l();
  };
  protoOf(AbstractMap$values$1$iterator$1).m = function () {
    return this.sf_1.m().y();
  };
  function toString_4($this, entry) {
    return toString_5($this, entry.x()) + '=' + toString_5($this, entry.y());
  }
  function toString_5($this, o) {
    return o === $this ? '(this Map)' : toString_0(o);
  }
  function implFindEntry($this, key) {
    var tmp0 = $this.w();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlin.collections.AbstractMap.implFindEntry.<anonymous>' call
        if (equals(element.x(), key)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function Companion_7() {
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function AbstractMap$keys$1(this$0) {
    this.tf_1 = this$0;
    AbstractSet.call(this);
  }
  protoOf(AbstractMap$keys$1).q6 = function (element) {
    return this.tf_1.w2(element);
  };
  protoOf(AbstractMap$keys$1).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.q6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractMap$keys$1).k = function () {
    var entryIterator = this.tf_1.w().k();
    return new AbstractMap$keys$1$iterator$1(entryIterator);
  };
  protoOf(AbstractMap$keys$1).n = function () {
    return this.tf_1.n();
  };
  function AbstractMap$toString$lambda(this$0) {
    return function (it) {
      return toString_4(this$0, it);
    };
  }
  function AbstractMap$values$1(this$0) {
    this.uf_1 = this$0;
    AbstractCollection.call(this);
  }
  protoOf(AbstractMap$values$1).w6 = function (element) {
    return this.uf_1.x2(element);
  };
  protoOf(AbstractMap$values$1).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.w6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractMap$values$1).k = function () {
    var entryIterator = this.uf_1.w().k();
    return new AbstractMap$values$1$iterator$1(entryIterator);
  };
  protoOf(AbstractMap$values$1).n = function () {
    return this.uf_1.n();
  };
  function AbstractMap() {
    this.c6_1 = null;
    this.d6_1 = null;
  }
  protoOf(AbstractMap).w2 = function (key) {
    return !(implFindEntry(this, key) == null);
  };
  protoOf(AbstractMap).x2 = function (value) {
    var tmp0 = this.w();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlin.collections.AbstractMap.containsValue.<anonymous>' call
        if (equals(element.y(), value)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractMap).e6 = function (entry) {
    if (!(!(entry == null) ? isInterface(entry, Entry) : false))
      return false;
    var key = entry.x();
    var value = entry.y();
    // Inline function 'kotlin.collections.get' call
    var ourValue = (isInterface(this, KtMap) ? this : THROW_CCE()).y2(key);
    if (!equals(value, ourValue)) {
      return false;
    }
    var tmp;
    if (ourValue == null) {
      // Inline function 'kotlin.collections.containsKey' call
      tmp = !(isInterface(this, KtMap) ? this : THROW_CCE()).w2(key);
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    }
    return true;
  };
  protoOf(AbstractMap).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtMap) : false))
      return false;
    if (!(this.n() === other.n()))
      return false;
    var tmp0 = other.w();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlin.collections.AbstractMap.equals.<anonymous>' call
        if (!this.e6(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractMap).y2 = function (key) {
    var tmp0_safe_receiver = implFindEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y();
  };
  protoOf(AbstractMap).hashCode = function () {
    return hashCode(this.w());
  };
  protoOf(AbstractMap).p = function () {
    return this.n() === 0;
  };
  protoOf(AbstractMap).n = function () {
    return this.w().n();
  };
  protoOf(AbstractMap).u2 = function () {
    if (this.c6_1 == null) {
      var tmp = this;
      tmp.c6_1 = new AbstractMap$keys$1(this);
    }
    return ensureNotNull(this.c6_1);
  };
  protoOf(AbstractMap).toString = function () {
    var tmp = this.w();
    return joinToString_0(tmp, ', ', '{', '}', VOID, VOID, AbstractMap$toString$lambda(this));
  };
  protoOf(AbstractMap).v2 = function () {
    if (this.d6_1 == null) {
      var tmp = this;
      tmp.d6_1 = new AbstractMap$values$1(this);
    }
    return ensureNotNull(this.d6_1);
  };
  function Companion_8() {
  }
  protoOf(Companion_8).g6 = function (c) {
    var hashCode_0 = 0;
    var _iterator__ex2g4s = c.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      var tmp = hashCode_0;
      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
      hashCode_0 = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    return hashCode_0;
  };
  protoOf(Companion_8).f6 = function (c, other) {
    if (!(c.n() === other.n()))
      return false;
    return c.h2(other);
  };
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function AbstractSet() {
    AbstractCollection.call(this);
  }
  protoOf(AbstractSet).equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, KtSet) : false))
      return false;
    return Companion_instance_8.f6(this, other);
  };
  protoOf(AbstractSet).hashCode = function () {
    return Companion_instance_8.g6(this);
  };
  function ArrayDeque_init_$Init$($this) {
    AbstractMutableList.call($this);
    ArrayDeque.call($this);
    $this.xf_1 = Companion_getInstance_9().zf_1;
    return $this;
  }
  function ArrayDeque_init_$Create$() {
    return ArrayDeque_init_$Init$(objectCreate(protoOf(ArrayDeque)));
  }
  function ensureCapacity_0($this, minCapacity) {
    if (minCapacity < 0)
      throw IllegalStateException_init_$Create$_0('Deque is too big.');
    if (minCapacity <= $this.xf_1.length)
      return Unit_instance;
    if ($this.xf_1 === Companion_getInstance_9().zf_1) {
      var tmp = $this;
      // Inline function 'kotlin.arrayOfNulls' call
      var size = coerceAtLeast(minCapacity, 10);
      tmp.xf_1 = fillArrayVal(Array(size), null);
      return Unit_instance;
    }
    var newCapacity = Companion_instance_6.d8($this.xf_1.length, minCapacity);
    copyElements($this, newCapacity);
  }
  function copyElements($this, newCapacity) {
    // Inline function 'kotlin.arrayOfNulls' call
    var newElements = fillArrayVal(Array(newCapacity), null);
    var tmp1 = $this.xf_1;
    var tmp4 = $this.wf_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = $this.xf_1.length;
    arrayCopy(tmp1, newElements, 0, tmp4, endIndex);
    var tmp6 = $this.xf_1;
    var tmp8 = $this.xf_1.length - $this.wf_1 | 0;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex_0 = $this.wf_1;
    arrayCopy(tmp6, newElements, tmp8, 0, endIndex_0);
    $this.wf_1 = 0;
    $this.xf_1 = newElements;
  }
  function positiveMod($this, index) {
    return index >= $this.xf_1.length ? index - $this.xf_1.length | 0 : index;
  }
  function negativeMod($this, index) {
    return index < 0 ? index + $this.xf_1.length | 0 : index;
  }
  function incremented($this, index) {
    return index === get_lastIndex($this.xf_1) ? 0 : index + 1 | 0;
  }
  function decremented($this, index) {
    return index === 0 ? get_lastIndex($this.xf_1) : index - 1 | 0;
  }
  function copyCollectionElements($this, internalIndex, elements) {
    var iterator = elements.k();
    var inductionVariable = internalIndex;
    var last = $this.xf_1.length;
    if (inductionVariable < last)
      $l$loop: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!iterator.l())
          break $l$loop;
        $this.xf_1[index] = iterator.m();
      }
       while (inductionVariable < last);
    var inductionVariable_0 = 0;
    var last_0 = $this.wf_1;
    if (inductionVariable_0 < last_0)
      $l$loop_0: do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (!iterator.l())
          break $l$loop_0;
        $this.xf_1[index_0] = iterator.m();
      }
       while (inductionVariable_0 < last_0);
    $this.yf_1 = $this.yf_1 + elements.n() | 0;
  }
  function removeRangeShiftPreceding($this, fromIndex, toIndex) {
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = fromIndex - 1 | 0;
    var copyFromIndex = positiveMod($this, $this.wf_1 + index | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index_0 = toIndex - 1 | 0;
    var copyToIndex = positiveMod($this, $this.wf_1 + index_0 | 0);
    var copyCount = fromIndex;
    while (copyCount > 0) {
      var tmp0 = copyCount;
      var tmp1 = copyFromIndex + 1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var c = copyToIndex + 1 | 0;
      var segmentLength = Math.min(tmp0, tmp1, c);
      var tmp3 = $this.xf_1;
      var tmp4 = $this.xf_1;
      var tmp5 = (copyToIndex - segmentLength | 0) + 1 | 0;
      var tmp6 = (copyFromIndex - segmentLength | 0) + 1 | 0;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = copyFromIndex + 1 | 0;
      arrayCopy(tmp3, tmp4, tmp5, tmp6, endIndex);
      copyFromIndex = negativeMod($this, copyFromIndex - segmentLength | 0);
      copyToIndex = negativeMod($this, copyToIndex - segmentLength | 0);
      copyCount = copyCount - segmentLength | 0;
    }
  }
  function removeRangeShiftSucceeding($this, fromIndex, toIndex) {
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var copyFromIndex = positiveMod($this, $this.wf_1 + toIndex | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var copyToIndex = positiveMod($this, $this.wf_1 + fromIndex | 0);
    var copyCount = $this.yf_1 - toIndex | 0;
    while (copyCount > 0) {
      var tmp0 = copyCount;
      var tmp1 = $this.xf_1.length - copyFromIndex | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var c = $this.xf_1.length - copyToIndex | 0;
      var segmentLength = Math.min(tmp0, tmp1, c);
      var tmp3 = $this.xf_1;
      var tmp4 = $this.xf_1;
      var tmp5 = copyToIndex;
      var tmp6 = copyFromIndex;
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = copyFromIndex + segmentLength | 0;
      arrayCopy(tmp3, tmp4, tmp5, tmp6, endIndex);
      copyFromIndex = positiveMod($this, copyFromIndex + segmentLength | 0);
      copyToIndex = positiveMod($this, copyToIndex + segmentLength | 0);
      copyCount = copyCount - segmentLength | 0;
    }
  }
  function nullifyNonEmpty($this, internalFromIndex, internalToIndex) {
    if (internalFromIndex < internalToIndex) {
      fill($this.xf_1, null, internalFromIndex, internalToIndex);
    } else {
      fill($this.xf_1, null, internalFromIndex, $this.xf_1.length);
      fill($this.xf_1, null, 0, internalToIndex);
    }
  }
  function registerModification_0($this) {
    $this.f5_1 = $this.f5_1 + 1 | 0;
  }
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.zf_1 = [];
    this.ag_1 = 10;
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  protoOf(ArrayDeque).n = function () {
    return this.yf_1;
  };
  protoOf(ArrayDeque).p = function () {
    return this.yf_1 === 0;
  };
  protoOf(ArrayDeque).bg = function () {
    var tmp;
    if (this.p()) {
      throw NoSuchElementException_init_$Create$_0('ArrayDeque is empty.');
    } else {
      // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
      var internalIndex = this.wf_1;
      var tmp_0 = this.xf_1[internalIndex];
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(ArrayDeque).cg = function () {
    var tmp;
    if (this.p()) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
      var internalIndex = this.wf_1;
      var tmp_0 = this.xf_1[internalIndex];
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(ArrayDeque).dg = function (element) {
    registerModification_0(this);
    ensureCapacity_0(this, this.yf_1 + 1 | 0);
    this.wf_1 = decremented(this, this.wf_1);
    this.xf_1[this.wf_1] = element;
    this.yf_1 = this.yf_1 + 1 | 0;
  };
  protoOf(ArrayDeque).eg = function (element) {
    registerModification_0(this);
    ensureCapacity_0(this, this.yf_1 + 1 | 0);
    var tmp = this.xf_1;
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = this.yf_1;
    tmp[positiveMod(this, this.wf_1 + index | 0)] = element;
    this.yf_1 = this.yf_1 + 1 | 0;
  };
  protoOf(ArrayDeque).fg = function () {
    if (this.p())
      throw NoSuchElementException_init_$Create$_0('ArrayDeque is empty.');
    registerModification_0(this);
    // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
    var internalIndex = this.wf_1;
    var tmp = this.xf_1[internalIndex];
    var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    this.xf_1[this.wf_1] = null;
    this.wf_1 = incremented(this, this.wf_1);
    this.yf_1 = this.yf_1 - 1 | 0;
    return element;
  };
  protoOf(ArrayDeque).gg = function () {
    return this.p() ? null : this.fg();
  };
  protoOf(ArrayDeque).hg = function () {
    if (this.p())
      throw NoSuchElementException_init_$Create$_0('ArrayDeque is empty.');
    registerModification_0(this);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = get_lastIndex_2(this);
    var internalLastIndex = positiveMod(this, this.wf_1 + index | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
    var tmp = this.xf_1[internalLastIndex];
    var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    this.xf_1[internalLastIndex] = null;
    this.yf_1 = this.yf_1 - 1 | 0;
    return element;
  };
  protoOf(ArrayDeque).e = function (element) {
    this.eg(element);
    return true;
  };
  protoOf(ArrayDeque).p2 = function (index, element) {
    Companion_instance_6.k5(index, this.yf_1);
    if (index === this.yf_1) {
      this.eg(element);
      return Unit_instance;
    } else if (index === 0) {
      this.dg(element);
      return Unit_instance;
    }
    registerModification_0(this);
    ensureCapacity_0(this, this.yf_1 + 1 | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var internalIndex = positiveMod(this, this.wf_1 + index | 0);
    if (index < (this.yf_1 + 1 | 0) >> 1) {
      var decrementedInternalIndex = decremented(this, internalIndex);
      var decrementedHead = decremented(this, this.wf_1);
      if (decrementedInternalIndex >= this.wf_1) {
        this.xf_1[decrementedHead] = this.xf_1[this.wf_1];
        var tmp0 = this.xf_1;
        var tmp1 = this.xf_1;
        var tmp2 = this.wf_1;
        var tmp3 = this.wf_1 + 1 | 0;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = decrementedInternalIndex + 1 | 0;
        arrayCopy(tmp0, tmp1, tmp2, tmp3, endIndex);
      } else {
        var tmp5 = this.xf_1;
        var tmp6 = this.xf_1;
        var tmp7 = this.wf_1 - 1 | 0;
        var tmp8 = this.wf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.xf_1.length;
        arrayCopy(tmp5, tmp6, tmp7, tmp8, endIndex_0);
        this.xf_1[this.xf_1.length - 1 | 0] = this.xf_1[0];
        var tmp10 = this.xf_1;
        var tmp11 = this.xf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_1 = decrementedInternalIndex + 1 | 0;
        arrayCopy(tmp10, tmp11, 0, 1, endIndex_1);
      }
      this.xf_1[decrementedInternalIndex] = element;
      this.wf_1 = decrementedHead;
    } else {
      // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
      var index_0 = this.yf_1;
      var tail = positiveMod(this, this.wf_1 + index_0 | 0);
      if (internalIndex < tail) {
        var tmp15 = this.xf_1;
        var tmp16 = this.xf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destinationOffset = internalIndex + 1 | 0;
        arrayCopy(tmp15, tmp16, destinationOffset, internalIndex, tail);
      } else {
        var tmp20 = this.xf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destination = this.xf_1;
        arrayCopy(tmp20, destination, 1, 0, tail);
        this.xf_1[0] = this.xf_1[this.xf_1.length - 1 | 0];
        var tmp25 = this.xf_1;
        var tmp26 = this.xf_1;
        var tmp27 = internalIndex + 1 | 0;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_2 = this.xf_1.length - 1 | 0;
        arrayCopy(tmp25, tmp26, tmp27, internalIndex, endIndex_2);
      }
      this.xf_1[internalIndex] = element;
    }
    this.yf_1 = this.yf_1 + 1 | 0;
  };
  protoOf(ArrayDeque).o = function (elements) {
    if (elements.p())
      return false;
    registerModification_0(this);
    ensureCapacity_0(this, this.yf_1 + elements.n() | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = this.yf_1;
    var tmp$ret$0 = positiveMod(this, this.wf_1 + index | 0);
    copyCollectionElements(this, tmp$ret$0, elements);
    return true;
  };
  protoOf(ArrayDeque).n2 = function (index, elements) {
    Companion_instance_6.k5(index, this.yf_1);
    if (elements.p()) {
      return false;
    } else if (index === this.yf_1) {
      return this.o(elements);
    }
    registerModification_0(this);
    ensureCapacity_0(this, this.yf_1 + elements.n() | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index_0 = this.yf_1;
    var tail = positiveMod(this, this.wf_1 + index_0 | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var internalIndex = positiveMod(this, this.wf_1 + index | 0);
    var elementsSize = elements.n();
    if (index < (this.yf_1 + 1 | 0) >> 1) {
      var shiftedHead = this.wf_1 - elementsSize | 0;
      if (internalIndex >= this.wf_1) {
        if (shiftedHead >= 0) {
          var tmp0 = this.xf_1;
          var tmp1 = this.xf_1;
          var tmp2 = shiftedHead;
          // Inline function 'kotlin.collections.copyInto' call
          var startIndex = this.wf_1;
          arrayCopy(tmp0, tmp1, tmp2, startIndex, internalIndex);
        } else {
          shiftedHead = shiftedHead + this.xf_1.length | 0;
          var elementsToShift = internalIndex - this.wf_1 | 0;
          var shiftToBack = this.xf_1.length - shiftedHead | 0;
          if (shiftToBack >= elementsToShift) {
            var tmp5 = this.xf_1;
            var tmp6 = this.xf_1;
            var tmp7 = shiftedHead;
            // Inline function 'kotlin.collections.copyInto' call
            var startIndex_0 = this.wf_1;
            arrayCopy(tmp5, tmp6, tmp7, startIndex_0, internalIndex);
          } else {
            var tmp10 = this.xf_1;
            var tmp11 = this.xf_1;
            var tmp12 = shiftedHead;
            var tmp13 = this.wf_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex = this.wf_1 + shiftToBack | 0;
            arrayCopy(tmp10, tmp11, tmp12, tmp13, endIndex);
            var tmp15 = this.xf_1;
            var tmp16 = this.xf_1;
            // Inline function 'kotlin.collections.copyInto' call
            var startIndex_1 = this.wf_1 + shiftToBack | 0;
            arrayCopy(tmp15, tmp16, 0, startIndex_1, internalIndex);
          }
        }
      } else {
        var tmp20 = this.xf_1;
        var tmp21 = this.xf_1;
        var tmp22 = shiftedHead;
        var tmp23 = this.wf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.xf_1.length;
        arrayCopy(tmp20, tmp21, tmp22, tmp23, endIndex_0);
        if (elementsSize >= internalIndex) {
          var tmp25 = this.xf_1;
          var tmp26 = this.xf_1;
          // Inline function 'kotlin.collections.copyInto' call
          var destinationOffset = this.xf_1.length - elementsSize | 0;
          arrayCopy(tmp25, tmp26, destinationOffset, 0, internalIndex);
        } else {
          var tmp30 = this.xf_1;
          var tmp31 = this.xf_1;
          // Inline function 'kotlin.collections.copyInto' call
          var destinationOffset_0 = this.xf_1.length - elementsSize | 0;
          arrayCopy(tmp30, tmp31, destinationOffset_0, 0, elementsSize);
          var tmp35 = this.xf_1;
          // Inline function 'kotlin.collections.copyInto' call
          var destination = this.xf_1;
          arrayCopy(tmp35, destination, 0, elementsSize, internalIndex);
        }
      }
      this.wf_1 = shiftedHead;
      copyCollectionElements(this, negativeMod(this, internalIndex - elementsSize | 0), elements);
    } else {
      var shiftedInternalIndex = internalIndex + elementsSize | 0;
      if (internalIndex < tail) {
        if ((tail + elementsSize | 0) <= this.xf_1.length) {
          var tmp40 = this.xf_1;
          // Inline function 'kotlin.collections.copyInto' call
          var destination_0 = this.xf_1;
          arrayCopy(tmp40, destination_0, shiftedInternalIndex, internalIndex, tail);
        } else {
          if (shiftedInternalIndex >= this.xf_1.length) {
            var tmp45 = this.xf_1;
            var tmp46 = this.xf_1;
            // Inline function 'kotlin.collections.copyInto' call
            var destinationOffset_1 = shiftedInternalIndex - this.xf_1.length | 0;
            arrayCopy(tmp45, tmp46, destinationOffset_1, internalIndex, tail);
          } else {
            var shiftToFront = (tail + elementsSize | 0) - this.xf_1.length | 0;
            var tmp50 = this.xf_1;
            var tmp51 = this.xf_1;
            // Inline function 'kotlin.collections.copyInto' call
            var startIndex_2 = tail - shiftToFront | 0;
            arrayCopy(tmp50, tmp51, 0, startIndex_2, tail);
            var tmp55 = this.xf_1;
            var tmp56 = this.xf_1;
            // Inline function 'kotlin.collections.copyInto' call
            var endIndex_1 = tail - shiftToFront | 0;
            arrayCopy(tmp55, tmp56, shiftedInternalIndex, internalIndex, endIndex_1);
          }
        }
      } else {
        var tmp60 = this.xf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destination_1 = this.xf_1;
        arrayCopy(tmp60, destination_1, elementsSize, 0, tail);
        if (shiftedInternalIndex >= this.xf_1.length) {
          var tmp65 = this.xf_1;
          var tmp66 = this.xf_1;
          var tmp67 = shiftedInternalIndex - this.xf_1.length | 0;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex_2 = this.xf_1.length;
          arrayCopy(tmp65, tmp66, tmp67, internalIndex, endIndex_2);
        } else {
          var tmp70 = this.xf_1;
          var tmp71 = this.xf_1;
          var tmp73 = this.xf_1.length - elementsSize | 0;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex_3 = this.xf_1.length;
          arrayCopy(tmp70, tmp71, 0, tmp73, endIndex_3);
          var tmp75 = this.xf_1;
          var tmp76 = this.xf_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex_4 = this.xf_1.length - elementsSize | 0;
          arrayCopy(tmp75, tmp76, shiftedInternalIndex, internalIndex, endIndex_4);
        }
      }
      copyCollectionElements(this, internalIndex, elements);
    }
    return true;
  };
  protoOf(ArrayDeque).q = function (index) {
    Companion_instance_6.x4(index, this.yf_1);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
    var internalIndex = positiveMod(this, this.wf_1 + index | 0);
    var tmp = this.xf_1[internalIndex];
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(ArrayDeque).o2 = function (index, element) {
    Companion_instance_6.x4(index, this.yf_1);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var internalIndex = positiveMod(this, this.wf_1 + index | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
    var tmp = this.xf_1[internalIndex];
    var oldElement = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    this.xf_1[internalIndex] = element;
    return oldElement;
  };
  protoOf(ArrayDeque).s = function (element) {
    return !(this.t(element) === -1);
  };
  protoOf(ArrayDeque).t = function (element) {
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = this.yf_1;
    var tail = positiveMod(this, this.wf_1 + index | 0);
    if (this.wf_1 < tail) {
      var inductionVariable = this.wf_1;
      if (inductionVariable < tail)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (equals(element, this.xf_1[index_0]))
            return index_0 - this.wf_1 | 0;
        }
         while (inductionVariable < tail);
    } else if (this.wf_1 >= tail) {
      var inductionVariable_0 = this.wf_1;
      var last = this.xf_1.length;
      if (inductionVariable_0 < last)
        do {
          var index_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals(element, this.xf_1[index_1]))
            return index_1 - this.wf_1 | 0;
        }
         while (inductionVariable_0 < last);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 < tail)
        do {
          var index_2 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          if (equals(element, this.xf_1[index_2]))
            return (index_2 + this.xf_1.length | 0) - this.wf_1 | 0;
        }
         while (inductionVariable_1 < tail);
    }
    return -1;
  };
  protoOf(ArrayDeque).u = function (element) {
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = this.yf_1;
    var tail = positiveMod(this, this.wf_1 + index | 0);
    if (this.wf_1 < tail) {
      var inductionVariable = tail - 1 | 0;
      var last = this.wf_1;
      if (last <= inductionVariable)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          if (equals(element, this.xf_1[index_0]))
            return index_0 - this.wf_1 | 0;
        }
         while (!(index_0 === last));
    } else if (this.wf_1 > tail) {
      var inductionVariable_0 = tail - 1 | 0;
      if (0 <= inductionVariable_0)
        do {
          var index_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          if (equals(element, this.xf_1[index_1]))
            return (index_1 + this.xf_1.length | 0) - this.wf_1 | 0;
        }
         while (0 <= inductionVariable_0);
      var inductionVariable_1 = get_lastIndex(this.xf_1);
      var last_0 = this.wf_1;
      if (last_0 <= inductionVariable_1)
        do {
          var index_2 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + -1 | 0;
          if (equals(element, this.xf_1[index_2]))
            return index_2 - this.wf_1 | 0;
        }
         while (!(index_2 === last_0));
    }
    return -1;
  };
  protoOf(ArrayDeque).k2 = function (element) {
    var index = this.t(element);
    if (index === -1)
      return false;
    this.q2(index);
    return true;
  };
  protoOf(ArrayDeque).q2 = function (index) {
    Companion_instance_6.x4(index, this.yf_1);
    if (index === get_lastIndex_2(this)) {
      return this.hg();
    } else if (index === 0) {
      return this.fg();
    }
    registerModification_0(this);
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var internalIndex = positiveMod(this, this.wf_1 + index | 0);
    // Inline function 'kotlin.collections.ArrayDeque.internalGet' call
    var tmp = this.xf_1[internalIndex];
    var element = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    if (index < this.yf_1 >> 1) {
      if (internalIndex >= this.wf_1) {
        var tmp0 = this.xf_1;
        var tmp1 = this.xf_1;
        var tmp2 = this.wf_1 + 1 | 0;
        // Inline function 'kotlin.collections.copyInto' call
        var startIndex = this.wf_1;
        arrayCopy(tmp0, tmp1, tmp2, startIndex, internalIndex);
      } else {
        var tmp5 = this.xf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destination = this.xf_1;
        arrayCopy(tmp5, destination, 1, 0, internalIndex);
        this.xf_1[0] = this.xf_1[this.xf_1.length - 1 | 0];
        var tmp10 = this.xf_1;
        var tmp11 = this.xf_1;
        var tmp12 = this.wf_1 + 1 | 0;
        var tmp13 = this.wf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = this.xf_1.length - 1 | 0;
        arrayCopy(tmp10, tmp11, tmp12, tmp13, endIndex);
      }
      this.xf_1[this.wf_1] = null;
      this.wf_1 = incremented(this, this.wf_1);
    } else {
      // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
      var index_0 = get_lastIndex_2(this);
      var internalLastIndex = positiveMod(this, this.wf_1 + index_0 | 0);
      if (internalIndex <= internalLastIndex) {
        var tmp15 = this.xf_1;
        var tmp16 = this.xf_1;
        var tmp18 = internalIndex + 1 | 0;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = internalLastIndex + 1 | 0;
        arrayCopy(tmp15, tmp16, internalIndex, tmp18, endIndex_0);
      } else {
        var tmp20 = this.xf_1;
        var tmp21 = this.xf_1;
        var tmp23 = internalIndex + 1 | 0;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_1 = this.xf_1.length;
        arrayCopy(tmp20, tmp21, internalIndex, tmp23, endIndex_1);
        this.xf_1[this.xf_1.length - 1 | 0] = this.xf_1[0];
        var tmp25 = this.xf_1;
        var tmp26 = this.xf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_2 = internalLastIndex + 1 | 0;
        arrayCopy(tmp25, tmp26, 0, 1, endIndex_2);
      }
      this.xf_1[internalLastIndex] = null;
    }
    this.yf_1 = this.yf_1 - 1 | 0;
    return element;
  };
  protoOf(ArrayDeque).k1 = function (elements) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.ArrayDeque.filterInPlace' call
      var tmp;
      if (this.p()) {
        tmp = true;
      } else {
        // Inline function 'kotlin.collections.isEmpty' call
        tmp = this.xf_1.length === 0;
      }
      if (tmp) {
        tmp$ret$1 = false;
        break $l$block;
      }
      // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
      var index = this.yf_1;
      var tail = positiveMod(this, this.wf_1 + index | 0);
      var newTail = this.wf_1;
      var modified = false;
      if (this.wf_1 < tail) {
        var inductionVariable = this.wf_1;
        if (inductionVariable < tail)
          do {
            var index_0 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = this.xf_1[index_0];
            // Inline function 'kotlin.collections.ArrayDeque.removeAll.<anonymous>' call
            var it = (element == null ? true : !(element == null)) ? element : THROW_CCE();
            if (!elements.s(it)) {
              var tmp_0 = this.xf_1;
              var _unary__edvuaz = newTail;
              newTail = _unary__edvuaz + 1 | 0;
              tmp_0[_unary__edvuaz] = element;
            } else {
              modified = true;
            }
          }
           while (inductionVariable < tail);
        fill(this.xf_1, null, newTail, tail);
      } else {
        var inductionVariable_0 = this.wf_1;
        var last = this.xf_1.length;
        if (inductionVariable_0 < last)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var element_0 = this.xf_1[index_1];
            this.xf_1[index_1] = null;
            // Inline function 'kotlin.collections.ArrayDeque.removeAll.<anonymous>' call
            var it_0 = (element_0 == null ? true : !(element_0 == null)) ? element_0 : THROW_CCE();
            if (!elements.s(it_0)) {
              var tmp_1 = this.xf_1;
              var _unary__edvuaz_0 = newTail;
              newTail = _unary__edvuaz_0 + 1 | 0;
              tmp_1[_unary__edvuaz_0] = element_0;
            } else {
              modified = true;
            }
          }
           while (inductionVariable_0 < last);
        newTail = positiveMod(this, newTail);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < tail)
          do {
            var index_2 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var element_1 = this.xf_1[index_2];
            this.xf_1[index_2] = null;
            // Inline function 'kotlin.collections.ArrayDeque.removeAll.<anonymous>' call
            var it_1 = (element_1 == null ? true : !(element_1 == null)) ? element_1 : THROW_CCE();
            if (!elements.s(it_1)) {
              this.xf_1[newTail] = element_1;
              newTail = incremented(this, newTail);
            } else {
              modified = true;
            }
          }
           while (inductionVariable_1 < tail);
      }
      if (modified) {
        registerModification_0(this);
        this.yf_1 = negativeMod(this, newTail - this.wf_1 | 0);
      }
      tmp$ret$1 = modified;
    }
    return tmp$ret$1;
  };
  protoOf(ArrayDeque).l2 = function (elements) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.ArrayDeque.filterInPlace' call
      var tmp;
      if (this.p()) {
        tmp = true;
      } else {
        // Inline function 'kotlin.collections.isEmpty' call
        tmp = this.xf_1.length === 0;
      }
      if (tmp) {
        tmp$ret$1 = false;
        break $l$block;
      }
      // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
      var index = this.yf_1;
      var tail = positiveMod(this, this.wf_1 + index | 0);
      var newTail = this.wf_1;
      var modified = false;
      if (this.wf_1 < tail) {
        var inductionVariable = this.wf_1;
        if (inductionVariable < tail)
          do {
            var index_0 = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = this.xf_1[index_0];
            // Inline function 'kotlin.collections.ArrayDeque.retainAll.<anonymous>' call
            var it = (element == null ? true : !(element == null)) ? element : THROW_CCE();
            if (elements.s(it)) {
              var tmp_0 = this.xf_1;
              var _unary__edvuaz = newTail;
              newTail = _unary__edvuaz + 1 | 0;
              tmp_0[_unary__edvuaz] = element;
            } else {
              modified = true;
            }
          }
           while (inductionVariable < tail);
        fill(this.xf_1, null, newTail, tail);
      } else {
        var inductionVariable_0 = this.wf_1;
        var last = this.xf_1.length;
        if (inductionVariable_0 < last)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var element_0 = this.xf_1[index_1];
            this.xf_1[index_1] = null;
            // Inline function 'kotlin.collections.ArrayDeque.retainAll.<anonymous>' call
            var it_0 = (element_0 == null ? true : !(element_0 == null)) ? element_0 : THROW_CCE();
            if (elements.s(it_0)) {
              var tmp_1 = this.xf_1;
              var _unary__edvuaz_0 = newTail;
              newTail = _unary__edvuaz_0 + 1 | 0;
              tmp_1[_unary__edvuaz_0] = element_0;
            } else {
              modified = true;
            }
          }
           while (inductionVariable_0 < last);
        newTail = positiveMod(this, newTail);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < tail)
          do {
            var index_2 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var element_1 = this.xf_1[index_2];
            this.xf_1[index_2] = null;
            // Inline function 'kotlin.collections.ArrayDeque.retainAll.<anonymous>' call
            var it_1 = (element_1 == null ? true : !(element_1 == null)) ? element_1 : THROW_CCE();
            if (elements.s(it_1)) {
              this.xf_1[newTail] = element_1;
              newTail = incremented(this, newTail);
            } else {
              modified = true;
            }
          }
           while (inductionVariable_1 < tail);
      }
      if (modified) {
        registerModification_0(this);
        this.yf_1 = negativeMod(this, newTail - this.wf_1 | 0);
      }
      tmp$ret$1 = modified;
    }
    return tmp$ret$1;
  };
  protoOf(ArrayDeque).m2 = function () {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.p()) {
      registerModification_0(this);
      // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
      var index = this.yf_1;
      var tail = positiveMod(this, this.wf_1 + index | 0);
      nullifyNonEmpty(this, this.wf_1, tail);
    }
    this.wf_1 = 0;
    this.yf_1 = 0;
  };
  protoOf(ArrayDeque).ig = function (array) {
    var tmp = array.length >= this.yf_1 ? array : arrayOfNulls(array, this.yf_1);
    var dest = isArray(tmp) ? tmp : THROW_CCE();
    // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
    var index = this.yf_1;
    var tail = positiveMod(this, this.wf_1 + index | 0);
    if (this.wf_1 < tail) {
      var tmp0 = this.xf_1;
      // Inline function 'kotlin.collections.copyInto' call
      var startIndex = this.wf_1;
      arrayCopy(tmp0, dest, 0, startIndex, tail);
    } else {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.p()) {
        var tmp6 = this.xf_1;
        var tmp9 = this.wf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex = this.xf_1.length;
        arrayCopy(tmp6, dest, 0, tmp9, endIndex);
        var tmp11 = this.xf_1;
        // Inline function 'kotlin.collections.copyInto' call
        var destinationOffset = this.xf_1.length - this.wf_1 | 0;
        arrayCopy(tmp11, dest, destinationOffset, 0, tail);
      }
    }
    var tmp_0 = terminateCollectionToArray(this.yf_1, dest);
    return isArray(tmp_0) ? tmp_0 : THROW_CCE();
  };
  protoOf(ArrayDeque).j6 = function () {
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.yf_1;
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    return this.ig(tmp$ret$0);
  };
  protoOf(ArrayDeque).toArray = function () {
    return this.j6();
  };
  protoOf(ArrayDeque).t5 = function (fromIndex, toIndex) {
    Companion_instance_6.n4(fromIndex, toIndex, this.yf_1);
    var length = toIndex - fromIndex | 0;
    if (length === 0)
      return Unit_instance;
    else if (length === this.yf_1) {
      this.m2();
      return Unit_instance;
    } else if (length === 1) {
      this.q2(fromIndex);
      return Unit_instance;
    }
    registerModification_0(this);
    if (fromIndex < (this.yf_1 - toIndex | 0)) {
      removeRangeShiftPreceding(this, fromIndex, toIndex);
      var newHead = positiveMod(this, this.wf_1 + length | 0);
      nullifyNonEmpty(this, this.wf_1, newHead);
      this.wf_1 = newHead;
    } else {
      removeRangeShiftSucceeding(this, fromIndex, toIndex);
      // Inline function 'kotlin.collections.ArrayDeque.internalIndex' call
      var index = this.yf_1;
      var tail = positiveMod(this, this.wf_1 + index | 0);
      nullifyNonEmpty(this, negativeMod(this, tail - length | 0), tail);
    }
    this.yf_1 = this.yf_1 - length | 0;
  };
  function ArrayDeque() {
    Companion_getInstance_9();
    this.wf_1 = 0;
    this.yf_1 = 0;
  }
  function collectionToArrayCommonImpl(collection) {
    if (collection.p()) {
      // Inline function 'kotlin.emptyArray' call
      return [];
    }
    // Inline function 'kotlin.arrayOfNulls' call
    var size = collection.n();
    var destination = fillArrayVal(Array(size), null);
    var iterator = collection.k();
    var index = 0;
    while (iterator.l()) {
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      destination[_unary__edvuaz] = iterator.m();
    }
    return destination;
  }
  function listOf_0(elements) {
    return elements.length > 0 ? asList(elements) : emptyList();
  }
  function emptyList() {
    return EmptyList_getInstance();
  }
  function get_lastIndex_2(_this__u8e3s4) {
    return _this__u8e3s4.n() - 1 | 0;
  }
  function mutableListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function optimizeReadOnlyList(_this__u8e3s4) {
    switch (_this__u8e3s4.n()) {
      case 0:
        return emptyList();
      case 1:
        return listOf(_this__u8e3s4.q(0));
      default:
        return _this__u8e3s4;
    }
  }
  function EmptyList() {
    EmptyList_instance = this;
    this.jg_1 = new Long(-1478467534, -1720727600);
  }
  protoOf(EmptyList).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, KtList) : false) {
      tmp = other.p();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EmptyList).hashCode = function () {
    return 1;
  };
  protoOf(EmptyList).toString = function () {
    return '[]';
  };
  protoOf(EmptyList).n = function () {
    return 0;
  };
  protoOf(EmptyList).p = function () {
    return true;
  };
  protoOf(EmptyList).kg = function (element) {
    return false;
  };
  protoOf(EmptyList).s = function (element) {
    if (!false)
      return false;
    var tmp;
    if (false) {
      tmp = element;
    } else {
      tmp = THROW_CCE();
    }
    return this.kg(tmp);
  };
  protoOf(EmptyList).lg = function (elements) {
    return elements.p();
  };
  protoOf(EmptyList).h2 = function (elements) {
    return this.lg(elements);
  };
  protoOf(EmptyList).q = function (index) {
    throw IndexOutOfBoundsException_init_$Create$_0("Empty list doesn't contain element at index " + index + '.');
  };
  protoOf(EmptyList).mg = function (element) {
    return -1;
  };
  protoOf(EmptyList).t = function (element) {
    if (!false)
      return -1;
    var tmp;
    if (false) {
      tmp = element;
    } else {
      tmp = THROW_CCE();
    }
    return this.mg(tmp);
  };
  protoOf(EmptyList).ng = function (element) {
    return -1;
  };
  protoOf(EmptyList).u = function (element) {
    if (!false)
      return -1;
    var tmp;
    if (false) {
      tmp = element;
    } else {
      tmp = THROW_CCE();
    }
    return this.ng(tmp);
  };
  protoOf(EmptyList).k = function () {
    return EmptyIterator_instance;
  };
  protoOf(EmptyList).i2 = function () {
    return EmptyIterator_instance;
  };
  protoOf(EmptyList).r = function (index) {
    if (!(index === 0))
      throw IndexOutOfBoundsException_init_$Create$_0('Index: ' + index);
    return EmptyIterator_instance;
  };
  protoOf(EmptyList).j2 = function (fromIndex, toIndex) {
    if (fromIndex === 0 && toIndex === 0)
      return this;
    throw IndexOutOfBoundsException_init_$Create$_0('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex);
  };
  var EmptyList_instance;
  function EmptyList_getInstance() {
    if (EmptyList_instance == null)
      new EmptyList();
    return EmptyList_instance;
  }
  function ArrayAsCollection(values, isVarargs) {
    this.og_1 = values;
    this.pg_1 = isVarargs;
  }
  protoOf(ArrayAsCollection).n = function () {
    return this.og_1.length;
  };
  protoOf(ArrayAsCollection).p = function () {
    // Inline function 'kotlin.collections.isEmpty' call
    return this.og_1.length === 0;
  };
  protoOf(ArrayAsCollection).qg = function (element) {
    return contains_0(this.og_1, element);
  };
  protoOf(ArrayAsCollection).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.qg((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ArrayAsCollection).rg = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlin.collections.ArrayAsCollection.containsAll.<anonymous>' call
        if (!this.qg(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(ArrayAsCollection).h2 = function (elements) {
    return this.rg(elements);
  };
  protoOf(ArrayAsCollection).k = function () {
    return arrayIterator(this.og_1);
  };
  function EmptyIterator() {
  }
  protoOf(EmptyIterator).l = function () {
    return false;
  };
  protoOf(EmptyIterator).l5 = function () {
    return false;
  };
  protoOf(EmptyIterator).m5 = function () {
    return 0;
  };
  protoOf(EmptyIterator).o5 = function () {
    return -1;
  };
  protoOf(EmptyIterator).m = function () {
    throw NoSuchElementException_init_$Create$();
  };
  protoOf(EmptyIterator).n5 = function () {
    throw NoSuchElementException_init_$Create$();
  };
  var EmptyIterator_instance;
  function EmptyIterator_getInstance() {
    return EmptyIterator_instance;
  }
  function arrayListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function throwIndexOverflow() {
    throw ArithmeticException_init_$Create$_0('Index overflow has happened.');
  }
  function asCollection(_this__u8e3s4) {
    return new ArrayAsCollection(_this__u8e3s4, false);
  }
  function get_indices_1(_this__u8e3s4) {
    return numberRangeToNumber(0, _this__u8e3s4.n() - 1 | 0);
  }
  function binarySearch(_this__u8e3s4, element, comparator, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? _this__u8e3s4.n() : toIndex;
    rangeCheck_0(_this__u8e3s4.n(), fromIndex, toIndex);
    var low = fromIndex;
    var high = toIndex - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) >>> 1 | 0;
      var midVal = _this__u8e3s4.q(mid);
      var cmp = comparator.compare(midVal, element);
      if (cmp < 0)
        low = mid + 1 | 0;
      else if (cmp > 0)
        high = mid - 1 | 0;
      else
        return mid;
    }
    return -(low + 1 | 0) | 0;
  }
  function rangeCheck_0(size, fromIndex, toIndex) {
    if (fromIndex > toIndex)
      throw IllegalArgumentException_init_$Create$_0('fromIndex (' + fromIndex + ') is greater than toIndex (' + toIndex + ').');
    else if (fromIndex < 0)
      throw IndexOutOfBoundsException_init_$Create$_0('fromIndex (' + fromIndex + ') is less than zero.');
    else if (toIndex > size)
      throw IndexOutOfBoundsException_init_$Create$_0('toIndex (' + toIndex + ') is greater than size (' + size + ').');
  }
  function IndexedValue(index, value) {
    this.sg_1 = index;
    this.tg_1 = value;
  }
  protoOf(IndexedValue).ug = function () {
    return this.sg_1;
  };
  protoOf(IndexedValue).vg = function () {
    return this.tg_1;
  };
  protoOf(IndexedValue).toString = function () {
    return 'IndexedValue(index=' + this.sg_1 + ', value=' + toString_0(this.tg_1) + ')';
  };
  protoOf(IndexedValue).hashCode = function () {
    var result = this.sg_1;
    result = imul(result, 31) + (this.tg_1 == null ? 0 : hashCode(this.tg_1)) | 0;
    return result;
  };
  protoOf(IndexedValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IndexedValue))
      return false;
    var tmp0_other_with_cast = other instanceof IndexedValue ? other : THROW_CCE();
    if (!(this.sg_1 === tmp0_other_with_cast.sg_1))
      return false;
    if (!equals(this.tg_1, tmp0_other_with_cast.tg_1))
      return false;
    return true;
  };
  function flatten(_this__u8e3s4) {
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = _this__u8e3s4.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      addAll_1(result, element);
    }
    return result;
  }
  function collectionSizeOrDefault(_this__u8e3s4, default_0) {
    var tmp;
    if (isInterface(_this__u8e3s4, Collection)) {
      tmp = _this__u8e3s4.n();
    } else {
      tmp = default_0;
    }
    return tmp;
  }
  function IndexingIterable(iteratorFactory) {
    this.wg_1 = iteratorFactory;
  }
  protoOf(IndexingIterable).k = function () {
    return new IndexingIterator(this.wg_1());
  };
  function collectionSizeOrNull(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, Collection)) {
      tmp = _this__u8e3s4.n();
    } else {
      tmp = null;
    }
    return tmp;
  }
  function IndexingIterator(iterator) {
    this.xg_1 = iterator;
    this.yg_1 = 0;
  }
  protoOf(IndexingIterator).l = function () {
    return this.xg_1.l();
  };
  protoOf(IndexingIterator).m = function () {
    var _unary__edvuaz = this.yg_1;
    this.yg_1 = _unary__edvuaz + 1 | 0;
    return new IndexedValue(checkIndexOverflow(_unary__edvuaz), this.xg_1.m());
  };
  function getOrImplicitDefault(_this__u8e3s4, key) {
    if (isInterface(_this__u8e3s4, MapWithDefault))
      return _this__u8e3s4.zg(key);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.getOrElseNullable' call
      var value = _this__u8e3s4.y2(key);
      if (value == null && !_this__u8e3s4.w2(key)) {
        throw NoSuchElementException_init_$Create$_0('Key ' + toString_0(key) + ' is missing in the map.');
      } else {
        tmp$ret$0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
        break $l$block;
      }
    }
    return tmp$ret$0;
  }
  function MapWithDefault() {
  }
  function mapOf_0(pairs) {
    return pairs.length > 0 ? toMap_0(pairs, LinkedHashMap_init_$Create$_0(mapCapacity(pairs.length))) : emptyMap();
  }
  function emptyMap() {
    var tmp = EmptyMap_getInstance();
    return isInterface(tmp, KtMap) ? tmp : THROW_CCE();
  }
  function getValue_0(_this__u8e3s4, key) {
    return getOrImplicitDefault(_this__u8e3s4, key);
  }
  function toMap(_this__u8e3s4) {
    if (isInterface(_this__u8e3s4, Collection)) {
      var tmp;
      switch (_this__u8e3s4.n()) {
        case 0:
          tmp = emptyMap();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this__u8e3s4, KtList)) {
            tmp_0 = _this__u8e3s4.q(0);
          } else {
            tmp_0 = _this__u8e3s4.k().m();
          }

          tmp = mapOf(tmp_0);
          break;
        default:
          tmp = toMap_1(_this__u8e3s4, LinkedHashMap_init_$Create$_0(mapCapacity(_this__u8e3s4.n())));
          break;
      }
      return tmp;
    }
    return optimizeReadOnlyMap(toMap_1(_this__u8e3s4, LinkedHashMap_init_$Create$()));
  }
  function toMap_0(_this__u8e3s4, destination) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.collections.toMap.<anonymous>' call
    putAll(destination, _this__u8e3s4);
    return destination;
  }
  function EmptyMap() {
    EmptyMap_instance = this;
    this.ah_1 = new Long(-888910638, 1920087921);
  }
  protoOf(EmptyMap).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, KtMap) : false) {
      tmp = other.p();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EmptyMap).hashCode = function () {
    return 0;
  };
  protoOf(EmptyMap).toString = function () {
    return '{}';
  };
  protoOf(EmptyMap).n = function () {
    return 0;
  };
  protoOf(EmptyMap).p = function () {
    return true;
  };
  protoOf(EmptyMap).bh = function (key) {
    return false;
  };
  protoOf(EmptyMap).w2 = function (key) {
    if (!(key == null ? true : !(key == null)))
      return false;
    return this.bh((key == null ? true : !(key == null)) ? key : THROW_CCE());
  };
  protoOf(EmptyMap).ch = function (key) {
    return null;
  };
  protoOf(EmptyMap).y2 = function (key) {
    if (!(key == null ? true : !(key == null)))
      return null;
    return this.ch((key == null ? true : !(key == null)) ? key : THROW_CCE());
  };
  protoOf(EmptyMap).w = function () {
    return EmptySet_getInstance();
  };
  protoOf(EmptyMap).u2 = function () {
    return EmptySet_getInstance();
  };
  protoOf(EmptyMap).v2 = function () {
    return EmptyList_getInstance();
  };
  var EmptyMap_instance;
  function EmptyMap_getInstance() {
    if (EmptyMap_instance == null)
      new EmptyMap();
    return EmptyMap_instance;
  }
  function toMap_1(_this__u8e3s4, destination) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.collections.toMap.<anonymous>' call
    putAll_0(destination, _this__u8e3s4);
    return destination;
  }
  function optimizeReadOnlyMap(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.n()) {
      case 0:
        tmp = emptyMap();
        break;
      case 1:
        // Inline function 'kotlin.collections.toSingletonMapOrSelf' call

        tmp = _this__u8e3s4;
        break;
      default:
        tmp = _this__u8e3s4;
        break;
    }
    return tmp;
  }
  function putAll(_this__u8e3s4, pairs) {
    var inductionVariable = 0;
    var last = pairs.length;
    while (inductionVariable < last) {
      var _destruct__k2r9zo = pairs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var key = _destruct__k2r9zo.ug();
      var value = _destruct__k2r9zo.vg();
      _this__u8e3s4.r2(key, value);
    }
  }
  function putAll_0(_this__u8e3s4, pairs) {
    var _iterator__ex2g4s = pairs.k();
    while (_iterator__ex2g4s.l()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.m();
      var key = _destruct__k2r9zo.ug();
      var value = _destruct__k2r9zo.vg();
      _this__u8e3s4.r2(key, value);
    }
  }
  function hashMapOf(pairs) {
    // Inline function 'kotlin.apply' call
    var this_0 = HashMap_init_$Create$_0(mapCapacity(pairs.length));
    // Inline function 'kotlin.collections.hashMapOf.<anonymous>' call
    putAll(this_0, pairs);
    return this_0;
  }
  function toMap_2(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.n()) {
      case 0:
        tmp = emptyMap();
        break;
      case 1:
        // Inline function 'kotlin.collections.toSingletonMap' call

        tmp = toMutableMap(_this__u8e3s4);
        break;
      default:
        tmp = toMutableMap(_this__u8e3s4);
        break;
    }
    return tmp;
  }
  function toMutableMap(_this__u8e3s4) {
    return LinkedHashMap_init_$Create$_1(_this__u8e3s4);
  }
  function removeFirstOrNull(_this__u8e3s4) {
    return _this__u8e3s4.p() ? null : _this__u8e3s4.q2(0);
  }
  function addAll_0(_this__u8e3s4, elements) {
    return _this__u8e3s4.o(asList(elements));
  }
  function addAll_1(_this__u8e3s4, elements) {
    if (isInterface(elements, Collection))
      return _this__u8e3s4.o(elements);
    else {
      var result = false;
      var _iterator__ex2g4s = elements.k();
      while (_iterator__ex2g4s.l()) {
        var item = _iterator__ex2g4s.m();
        if (_this__u8e3s4.e(item))
          result = true;
      }
      return result;
    }
  }
  function removeAll(_this__u8e3s4, elements) {
    return _this__u8e3s4.k1(convertToListIfNotCollection(elements));
  }
  function convertToListIfNotCollection(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, Collection)) {
      tmp = _this__u8e3s4;
    } else {
      tmp = toList_0(_this__u8e3s4);
    }
    return tmp;
  }
  function removeAll_0(_this__u8e3s4, predicate) {
    return filterInPlace(_this__u8e3s4, predicate, true);
  }
  function filterInPlace(_this__u8e3s4, predicate, predicateResultToRemove) {
    if (!isInterface(_this__u8e3s4, RandomAccess)) {
      return filterInPlace_0(isInterface(_this__u8e3s4, MutableIterable) ? _this__u8e3s4 : THROW_CCE(), predicate, predicateResultToRemove);
    }
    var writeIndex = 0;
    var inductionVariable = 0;
    var last = get_lastIndex_2(_this__u8e3s4);
    if (inductionVariable <= last)
      $l$loop: do {
        var readIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var element = _this__u8e3s4.q(readIndex);
        if (predicate(element) === predicateResultToRemove)
          continue $l$loop;
        if (!(writeIndex === readIndex)) {
          _this__u8e3s4.o2(writeIndex, element);
        }
        writeIndex = writeIndex + 1 | 0;
      }
       while (!(readIndex === last));
    if (writeIndex < _this__u8e3s4.n()) {
      var inductionVariable_0 = get_lastIndex_2(_this__u8e3s4);
      var last_0 = writeIndex;
      if (last_0 <= inductionVariable_0)
        do {
          var removeIndex = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          _this__u8e3s4.q2(removeIndex);
        }
         while (!(removeIndex === last_0));
      return true;
    } else {
      return false;
    }
  }
  function filterInPlace_0(_this__u8e3s4, predicate, predicateResultToRemove) {
    var result = false;
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.collections.filterInPlace.<anonymous>' call
    var $this$with = _this__u8e3s4.k();
    while ($this$with.l())
      if (predicate($this$with.m()) === predicateResultToRemove) {
        $this$with.b5();
        result = true;
      }
    return result;
  }
  function removeAll_1(_this__u8e3s4, predicate) {
    return filterInPlace_0(_this__u8e3s4, predicate, true);
  }
  function removeLast(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.p()) {
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    } else {
      tmp = _this__u8e3s4.q2(get_lastIndex_2(_this__u8e3s4));
    }
    return tmp;
  }
  function addAll_2(_this__u8e3s4, elements) {
    var result = false;
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      if (_this__u8e3s4.e(item))
        result = true;
    }
    return result;
  }
  function retainAll(_this__u8e3s4, elements) {
    return _this__u8e3s4.l2(convertToListIfNotCollection(elements));
  }
  function IntIterator() {
  }
  protoOf(IntIterator).m = function () {
    return this.fh();
  };
  function CharIterator() {
  }
  protoOf(CharIterator).gh = function () {
    return this.hh();
  };
  protoOf(CharIterator).m = function () {
    return new Char(this.gh());
  };
  function asReversed(_this__u8e3s4) {
    return new ReversedListReadOnly(_this__u8e3s4);
  }
  function ReversedListReadOnly$listIterator$1(this$0, $index) {
    this.jh_1 = this$0;
    this.ih_1 = this$0.kh_1.r(reversePositionIndex(this$0, $index));
  }
  protoOf(ReversedListReadOnly$listIterator$1).l = function () {
    return this.ih_1.l5();
  };
  protoOf(ReversedListReadOnly$listIterator$1).l5 = function () {
    return this.ih_1.l();
  };
  protoOf(ReversedListReadOnly$listIterator$1).m = function () {
    return this.ih_1.n5();
  };
  protoOf(ReversedListReadOnly$listIterator$1).m5 = function () {
    return reverseIteratorIndex(this.jh_1, this.ih_1.o5());
  };
  protoOf(ReversedListReadOnly$listIterator$1).n5 = function () {
    return this.ih_1.m();
  };
  protoOf(ReversedListReadOnly$listIterator$1).o5 = function () {
    return reverseIteratorIndex(this.jh_1, this.ih_1.m5());
  };
  function ReversedListReadOnly(delegate) {
    AbstractList.call(this);
    this.kh_1 = delegate;
  }
  protoOf(ReversedListReadOnly).n = function () {
    return this.kh_1.n();
  };
  protoOf(ReversedListReadOnly).q = function (index) {
    return this.kh_1.q(reverseElementIndex(this, index));
  };
  protoOf(ReversedListReadOnly).k = function () {
    return this.r(0);
  };
  protoOf(ReversedListReadOnly).i2 = function () {
    return this.r(0);
  };
  protoOf(ReversedListReadOnly).r = function (index) {
    return new ReversedListReadOnly$listIterator$1(this, index);
  };
  function reverseElementIndex(_this__u8e3s4, index) {
    var tmp;
    if (0 <= index ? index <= get_lastIndex_2(_this__u8e3s4) : false) {
      tmp = get_lastIndex_2(_this__u8e3s4) - index | 0;
    } else {
      throw IndexOutOfBoundsException_init_$Create$_0('Element index ' + index + ' must be in range [' + numberRangeToNumber(0, get_lastIndex_2(_this__u8e3s4)).toString() + '].');
    }
    return tmp;
  }
  function reversePositionIndex(_this__u8e3s4, index) {
    var tmp;
    if (0 <= index ? index <= _this__u8e3s4.n() : false) {
      tmp = _this__u8e3s4.n() - index | 0;
    } else {
      throw IndexOutOfBoundsException_init_$Create$_0('Position index ' + index + ' must be in range [' + numberRangeToNumber(0, _this__u8e3s4.n()).toString() + '].');
    }
    return tmp;
  }
  function reverseIteratorIndex(_this__u8e3s4, index) {
    return get_lastIndex_2(_this__u8e3s4) - index | 0;
  }
  function Sequence() {
  }
  function sequence(block) {
    // Inline function 'kotlin.sequences.Sequence' call
    return new sequence$$inlined$Sequence$1(block);
  }
  function SequenceScope() {
  }
  protoOf(SequenceScope).nh = function (sequence, $completion) {
    return this.mh(sequence.k(), $completion);
  };
  function iterator(block) {
    var iterator = new SequenceBuilderIterator();
    iterator.rh_1 = createCoroutineUnintercepted(block, iterator, iterator);
    return iterator;
  }
  function nextNotReady($this) {
    if (!$this.l())
      throw NoSuchElementException_init_$Create$();
    else
      return $this.m();
  }
  function exceptionalState($this) {
    switch ($this.oh_1) {
      case 4:
        return NoSuchElementException_init_$Create$();
      case 5:
        return IllegalStateException_init_$Create$_0('Iterator has failed.');
      default:
        return IllegalStateException_init_$Create$_0('Unexpected state of the iterator: ' + $this.oh_1);
    }
  }
  function SequenceBuilderIterator() {
    SequenceScope.call(this);
    this.oh_1 = 0;
    this.ph_1 = null;
    this.qh_1 = null;
    this.rh_1 = null;
  }
  protoOf(SequenceBuilderIterator).l = function () {
    while (true) {
      switch (this.oh_1) {
        case 0:
          break;
        case 1:
          if (ensureNotNull(this.qh_1).l()) {
            this.oh_1 = 2;
            return true;
          } else {
            this.qh_1 = null;
          }

          break;
        case 4:
          return false;
        case 3:
        case 2:
          return true;
        default:
          throw exceptionalState(this);
      }
      this.oh_1 = 5;
      var step = ensureNotNull(this.rh_1);
      this.rh_1 = null;
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      step.ja(tmp$ret$0);
    }
  };
  protoOf(SequenceBuilderIterator).m = function () {
    switch (this.oh_1) {
      case 0:
      case 1:
        return nextNotReady(this);
      case 2:
        this.oh_1 = 1;
        return ensureNotNull(this.qh_1).m();
      case 3:
        this.oh_1 = 0;
        var tmp = this.ph_1;
        var result = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
        this.ph_1 = null;
        return result;
      default:
        throw exceptionalState(this);
    }
  };
  protoOf(SequenceBuilderIterator).lh = function (value, $completion) {
    this.ph_1 = value;
    this.oh_1 = 3;
    // Inline function 'kotlin.sequences.SequenceBuilderIterator.yield.<anonymous>' call
    this.rh_1 = $completion;
    return get_COROUTINE_SUSPENDED();
  };
  protoOf(SequenceBuilderIterator).mh = function (iterator, $completion) {
    if (!iterator.l())
      return Unit_instance;
    this.qh_1 = iterator;
    this.oh_1 = 2;
    // Inline function 'kotlin.sequences.SequenceBuilderIterator.yieldAll.<anonymous>' call
    this.rh_1 = $completion;
    return get_COROUTINE_SUSPENDED();
  };
  protoOf(SequenceBuilderIterator).sh = function (result) {
    // Inline function 'kotlin.getOrThrow' call
    throwOnFailure(result);
    var tmp = _Result___get_value__impl__bjfvqg(result);
    if (!(tmp == null ? true : !(tmp == null)))
      THROW_CCE();
    this.oh_1 = 4;
  };
  protoOf(SequenceBuilderIterator).ja = function (result) {
    return this.sh(result);
  };
  protoOf(SequenceBuilderIterator).ea = function () {
    return EmptyCoroutineContext_getInstance();
  };
  function sequence$$inlined$Sequence$1($block) {
    this.th_1 = $block;
  }
  protoOf(sequence$$inlined$Sequence$1).k = function () {
    // Inline function 'kotlin.sequences.sequence.<anonymous>' call
    return iterator(this.th_1);
  };
  function asSequence_2(_this__u8e3s4) {
    // Inline function 'kotlin.sequences.Sequence' call
    var tmp$ret$0 = new asSequence$$inlined$Sequence$1_1(_this__u8e3s4);
    return constrainOnce(tmp$ret$0);
  }
  function flatten_0(_this__u8e3s4) {
    return flatten_2(_this__u8e3s4, flatten$lambda);
  }
  function flatten_1(_this__u8e3s4) {
    return flatten_2(_this__u8e3s4, flatten$lambda_0);
  }
  function sequenceOf(elements) {
    return asSequence(elements);
  }
  function TransformingSequence$iterator$1(this$0) {
    this.vh_1 = this$0;
    this.uh_1 = this$0.wh_1.k();
  }
  protoOf(TransformingSequence$iterator$1).m = function () {
    return this.vh_1.xh_1(this.uh_1.m());
  };
  protoOf(TransformingSequence$iterator$1).l = function () {
    return this.uh_1.l();
  };
  function TransformingSequence(sequence, transformer) {
    this.wh_1 = sequence;
    this.xh_1 = transformer;
  }
  protoOf(TransformingSequence).k = function () {
    return new TransformingSequence$iterator$1(this);
  };
  protoOf(TransformingSequence).yh = function (iterator) {
    return new FlatteningSequence(this.wh_1, this.xh_1, iterator);
  };
  function ensureItemIterator($this) {
    var itemIterator = $this.ai_1;
    if (!(itemIterator == null) && itemIterator.l()) {
      $this.bi_1 = 1;
      return true;
    }
    while ($this.zh_1.l()) {
      var element = $this.zh_1.m();
      var nextItemIterator = $this.ci_1.fi_1($this.ci_1.ei_1(element));
      if (nextItemIterator.l()) {
        $this.ai_1 = nextItemIterator;
        $this.bi_1 = 1;
        return true;
      }
    }
    $this.bi_1 = 2;
    $this.ai_1 = null;
    return false;
  }
  function FlatteningSequence$iterator$1(this$0) {
    this.ci_1 = this$0;
    this.zh_1 = this$0.di_1.k();
    this.ai_1 = null;
    this.bi_1 = 0;
  }
  protoOf(FlatteningSequence$iterator$1).m = function () {
    if (this.bi_1 === 2)
      throw NoSuchElementException_init_$Create$();
    if (this.bi_1 === 0 && !ensureItemIterator(this)) {
      throw NoSuchElementException_init_$Create$();
    }
    this.bi_1 = 0;
    return ensureNotNull(this.ai_1).m();
  };
  protoOf(FlatteningSequence$iterator$1).l = function () {
    if (this.bi_1 === 1)
      return true;
    if (this.bi_1 === 2)
      return false;
    return ensureItemIterator(this);
  };
  function FlatteningSequence(sequence, transformer, iterator) {
    this.di_1 = sequence;
    this.ei_1 = transformer;
    this.fi_1 = iterator;
  }
  protoOf(FlatteningSequence).k = function () {
    return new FlatteningSequence$iterator$1(this);
  };
  function calcNext($this) {
    while ($this.gi_1.l()) {
      var item = $this.gi_1.m();
      if ($this.ji_1.mi_1(item) === $this.ji_1.li_1) {
        $this.ii_1 = item;
        $this.hi_1 = 1;
        return Unit_instance;
      }
    }
    $this.hi_1 = 0;
  }
  function FilteringSequence$iterator$1(this$0) {
    this.ji_1 = this$0;
    this.gi_1 = this$0.ki_1.k();
    this.hi_1 = -1;
    this.ii_1 = null;
  }
  protoOf(FilteringSequence$iterator$1).m = function () {
    if (this.hi_1 === -1) {
      calcNext(this);
    }
    if (this.hi_1 === 0)
      throw NoSuchElementException_init_$Create$();
    var result = this.ii_1;
    this.ii_1 = null;
    this.hi_1 = -1;
    return (result == null ? true : !(result == null)) ? result : THROW_CCE();
  };
  protoOf(FilteringSequence$iterator$1).l = function () {
    if (this.hi_1 === -1) {
      calcNext(this);
    }
    return this.hi_1 === 1;
  };
  function FilteringSequence(sequence, sendWhen, predicate) {
    sendWhen = sendWhen === VOID ? true : sendWhen;
    this.ki_1 = sequence;
    this.li_1 = sendWhen;
    this.mi_1 = predicate;
  }
  protoOf(FilteringSequence).k = function () {
    return new FilteringSequence$iterator$1(this);
  };
  function emptySequence() {
    return EmptySequence_instance;
  }
  function generateSequence(seedFunction, nextFunction) {
    return new GeneratorSequence(seedFunction, nextFunction);
  }
  function constrainOnce(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ConstrainedOnceSequence) {
      tmp = _this__u8e3s4;
    } else {
      tmp = new ConstrainedOnceSequence(_this__u8e3s4);
    }
    return tmp;
  }
  function flatten_2(_this__u8e3s4, iterator) {
    if (_this__u8e3s4 instanceof TransformingSequence) {
      return (_this__u8e3s4 instanceof TransformingSequence ? _this__u8e3s4 : THROW_CCE()).yh(iterator);
    }
    return new FlatteningSequence(_this__u8e3s4, flatten$lambda_1, iterator);
  }
  function EmptySequence() {
  }
  protoOf(EmptySequence).k = function () {
    return EmptyIterator_instance;
  };
  protoOf(EmptySequence).i1 = function (n) {
    return EmptySequence_instance;
  };
  var EmptySequence_instance;
  function EmptySequence_getInstance() {
    return EmptySequence_instance;
  }
  function calcNext_0($this) {
    $this.ni_1 = $this.oi_1 === -2 ? $this.pi_1.qi_1() : $this.pi_1.ri_1(ensureNotNull($this.ni_1));
    $this.oi_1 = $this.ni_1 == null ? 0 : 1;
  }
  function GeneratorSequence$iterator$1(this$0) {
    this.pi_1 = this$0;
    this.ni_1 = null;
    this.oi_1 = -2;
  }
  protoOf(GeneratorSequence$iterator$1).m = function () {
    if (this.oi_1 < 0) {
      calcNext_0(this);
    }
    if (this.oi_1 === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this.ni_1;
    var result = !(tmp == null) ? tmp : THROW_CCE();
    this.oi_1 = -1;
    return result;
  };
  protoOf(GeneratorSequence$iterator$1).l = function () {
    if (this.oi_1 < 0) {
      calcNext_0(this);
    }
    return this.oi_1 === 1;
  };
  function GeneratorSequence(getInitialValue, getNextValue) {
    this.qi_1 = getInitialValue;
    this.ri_1 = getNextValue;
  }
  protoOf(GeneratorSequence).k = function () {
    return new GeneratorSequence$iterator$1(this);
  };
  function DropTakeSequence() {
  }
  function TakeSequence$iterator$1(this$0) {
    this.si_1 = this$0.vi_1;
    this.ti_1 = this$0.ui_1.k();
  }
  protoOf(TakeSequence$iterator$1).m = function () {
    if (this.si_1 === 0)
      throw NoSuchElementException_init_$Create$();
    this.si_1 = this.si_1 - 1 | 0;
    return this.ti_1.m();
  };
  protoOf(TakeSequence$iterator$1).l = function () {
    return this.si_1 > 0 && this.ti_1.l();
  };
  function TakeSequence(sequence, count) {
    this.ui_1 = sequence;
    this.vi_1 = count;
    // Inline function 'kotlin.require' call
    if (!(this.vi_1 >= 0)) {
      // Inline function 'kotlin.sequences.TakeSequence.<anonymous>' call
      var message = 'count must be non-negative, but was ' + this.vi_1 + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(TakeSequence).i1 = function (n) {
    return n >= this.vi_1 ? this : new TakeSequence(this.ui_1, n);
  };
  protoOf(TakeSequence).k = function () {
    return new TakeSequence$iterator$1(this);
  };
  function generateSequence_0(seed, nextFunction) {
    var tmp;
    if (seed == null) {
      tmp = EmptySequence_instance;
    } else {
      tmp = new GeneratorSequence(generateSequence$lambda(seed), nextFunction);
    }
    return tmp;
  }
  function asSequence$$inlined$Sequence$1_1($this_asSequence) {
    this.wi_1 = $this_asSequence;
  }
  protoOf(asSequence$$inlined$Sequence$1_1).k = function () {
    // Inline function 'kotlin.sequences.asSequence.<anonymous>' call
    return this.wi_1;
  };
  function flatten$lambda(it) {
    return it.k();
  }
  function flatten$lambda_0(it) {
    return it.k();
  }
  function flatten$lambda_1(it) {
    return it;
  }
  function generateSequence$lambda($seed) {
    return function () {
      return $seed;
    };
  }
  function emptySet() {
    return EmptySet_getInstance();
  }
  function setOf_0(elements) {
    return toSet(elements);
  }
  function mutableSetOf(elements) {
    return toCollection(elements, LinkedHashSet_init_$Create$_1(mapCapacity(elements.length)));
  }
  function optimizeReadOnlySet(_this__u8e3s4) {
    switch (_this__u8e3s4.n()) {
      case 0:
        return emptySet();
      case 1:
        return setOf(_this__u8e3s4.k().m());
      default:
        return _this__u8e3s4;
    }
  }
  function hashSetOf(elements) {
    return toCollection(elements, HashSet_init_$Create$_1(mapCapacity(elements.length)));
  }
  function EmptySet() {
    EmptySet_instance = this;
    this.xi_1 = new Long(1993859828, 793161749);
  }
  protoOf(EmptySet).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, KtSet) : false) {
      tmp = other.p();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EmptySet).hashCode = function () {
    return 0;
  };
  protoOf(EmptySet).toString = function () {
    return '[]';
  };
  protoOf(EmptySet).n = function () {
    return 0;
  };
  protoOf(EmptySet).p = function () {
    return true;
  };
  protoOf(EmptySet).kg = function (element) {
    return false;
  };
  protoOf(EmptySet).s = function (element) {
    if (!false)
      return false;
    var tmp;
    if (false) {
      tmp = element;
    } else {
      tmp = THROW_CCE();
    }
    return this.kg(tmp);
  };
  protoOf(EmptySet).lg = function (elements) {
    return elements.p();
  };
  protoOf(EmptySet).h2 = function (elements) {
    return this.lg(elements);
  };
  protoOf(EmptySet).k = function () {
    return EmptyIterator_instance;
  };
  var EmptySet_instance;
  function EmptySet_getInstance() {
    if (EmptySet_instance == null)
      new EmptySet();
    return EmptySet_instance;
  }
  function compareValues(a, b) {
    if (a === b)
      return 0;
    if (a == null)
      return -1;
    if (b == null)
      return 1;
    return compareTo_0((!(a == null) ? isComparable(a) : false) ? a : THROW_CCE(), b);
  }
  function Continuation() {
  }
  function startCoroutine(_this__u8e3s4, receiver, completion) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = intercepted(createCoroutineUnintercepted(_this__u8e3s4, receiver, completion));
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    this_0.ja(tmp$ret$0);
  }
  function Key() {
  }
  var Key_instance;
  function Key_getInstance() {
    return Key_instance;
  }
  function ContinuationInterceptor() {
  }
  function Element_0() {
  }
  function CoroutineContext$plus$lambda(acc, element) {
    var removed = acc.cj(element.x());
    var tmp;
    if (removed === EmptyCoroutineContext_getInstance()) {
      tmp = element;
    } else {
      var interceptor = removed.la(Key_instance);
      var tmp_0;
      if (interceptor == null) {
        tmp_0 = new CombinedContext(removed, element);
      } else {
        var left = removed.cj(Key_instance);
        tmp_0 = left === EmptyCoroutineContext_getInstance() ? new CombinedContext(element, interceptor) : new CombinedContext(new CombinedContext(left, element), interceptor);
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function CoroutineContext() {
  }
  function EmptyCoroutineContext() {
    EmptyCoroutineContext_instance = this;
    this.fj_1 = new Long(0, 0);
  }
  protoOf(EmptyCoroutineContext).la = function (key) {
    return null;
  };
  protoOf(EmptyCoroutineContext).dj = function (initial, operation) {
    return initial;
  };
  protoOf(EmptyCoroutineContext).ej = function (context) {
    return context;
  };
  protoOf(EmptyCoroutineContext).cj = function (key) {
    return this;
  };
  protoOf(EmptyCoroutineContext).hashCode = function () {
    return 0;
  };
  protoOf(EmptyCoroutineContext).toString = function () {
    return 'EmptyCoroutineContext';
  };
  var EmptyCoroutineContext_instance;
  function EmptyCoroutineContext_getInstance() {
    if (EmptyCoroutineContext_instance == null)
      new EmptyCoroutineContext();
    return EmptyCoroutineContext_instance;
  }
  function size_0($this) {
    var cur = $this;
    var size = 2;
    while (true) {
      var tmp = cur.gj_1;
      var tmp0_elvis_lhs = tmp instanceof CombinedContext ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return size;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      cur = tmp_0;
      size = size + 1 | 0;
    }
  }
  function contains_7($this, element) {
    return equals($this.la(element.x()), element);
  }
  function containsAll($this, context) {
    var cur = context;
    while (true) {
      if (!contains_7($this, cur.hj_1))
        return false;
      var next = cur.gj_1;
      if (next instanceof CombinedContext) {
        cur = next;
      } else {
        return contains_7($this, isInterface(next, Element_0) ? next : THROW_CCE());
      }
    }
  }
  function CombinedContext$toString$lambda(acc, element) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(acc) === 0) {
      tmp = toString_1(element);
    } else {
      tmp = acc + ', ' + toString_1(element);
    }
    return tmp;
  }
  function CombinedContext(left, element) {
    this.gj_1 = left;
    this.hj_1 = element;
  }
  protoOf(CombinedContext).la = function (key) {
    var cur = this;
    while (true) {
      var tmp0_safe_receiver = cur.hj_1.la(key);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        return tmp0_safe_receiver;
      }
      var next = cur.gj_1;
      if (next instanceof CombinedContext) {
        cur = next;
      } else {
        return next.la(key);
      }
    }
  };
  protoOf(CombinedContext).dj = function (initial, operation) {
    return operation(this.gj_1.dj(initial, operation), this.hj_1);
  };
  protoOf(CombinedContext).cj = function (key) {
    if (this.hj_1.la(key) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return this.gj_1;
    }
    var newLeft = this.gj_1.cj(key);
    return newLeft === this.gj_1 ? this : newLeft === EmptyCoroutineContext_getInstance() ? this.hj_1 : new CombinedContext(newLeft, this.hj_1);
  };
  protoOf(CombinedContext).equals = function (other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof CombinedContext) {
        tmp_1 = size_0(other) === size_0(this);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = containsAll(other, this);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(CombinedContext).hashCode = function () {
    return hashCode(this.gj_1) + hashCode(this.hj_1) | 0;
  };
  protoOf(CombinedContext).toString = function () {
    return '[' + this.dj('', CombinedContext$toString$lambda) + ']';
  };
  function AbstractCoroutineContextKey(baseKey, safeCast) {
    this.yi_1 = safeCast;
    var tmp = this;
    var tmp_0;
    if (baseKey instanceof AbstractCoroutineContextKey) {
      tmp_0 = baseKey.zi_1;
    } else {
      tmp_0 = baseKey;
    }
    tmp.zi_1 = tmp_0;
  }
  protoOf(AbstractCoroutineContextKey).aj = function (element) {
    return this.yi_1(element);
  };
  protoOf(AbstractCoroutineContextKey).bj = function (key) {
    return key === this || this.zi_1 === key;
  };
  function AbstractCoroutineContextElement(key) {
    this.ij_1 = key;
  }
  protoOf(AbstractCoroutineContextElement).x = function () {
    return this.ij_1;
  };
  function get_COROUTINE_SUSPENDED() {
    return CoroutineSingletons_COROUTINE_SUSPENDED_getInstance();
  }
  var CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  var CoroutineSingletons_UNDECIDED_instance;
  var CoroutineSingletons_RESUMED_instance;
  var CoroutineSingletons_entriesInitialized;
  function CoroutineSingletons_initEntries() {
    if (CoroutineSingletons_entriesInitialized)
      return Unit_instance;
    CoroutineSingletons_entriesInitialized = true;
    CoroutineSingletons_COROUTINE_SUSPENDED_instance = new CoroutineSingletons('COROUTINE_SUSPENDED', 0);
    CoroutineSingletons_UNDECIDED_instance = new CoroutineSingletons('UNDECIDED', 1);
    CoroutineSingletons_RESUMED_instance = new CoroutineSingletons('RESUMED', 2);
  }
  function CoroutineSingletons(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CoroutineSingletons_COROUTINE_SUSPENDED_getInstance() {
    CoroutineSingletons_initEntries();
    return CoroutineSingletons_COROUTINE_SUSPENDED_instance;
  }
  function enumEntries(entries) {
    return new EnumEntriesList(entries);
  }
  function EnumEntriesList(entries) {
    AbstractList.call(this);
    this.jj_1 = entries;
  }
  protoOf(EnumEntriesList).n = function () {
    return this.jj_1.length;
  };
  protoOf(EnumEntriesList).q = function (index) {
    Companion_instance_6.x4(index, this.jj_1.length);
    return this.jj_1[index];
  };
  protoOf(EnumEntriesList).kj = function (element) {
    if (element === null)
      return false;
    var target = getOrNull(this.jj_1, element.a3_1);
    return target === element;
  };
  protoOf(EnumEntriesList).s = function (element) {
    if (!(element instanceof Enum))
      return false;
    return this.kj(element instanceof Enum ? element : THROW_CCE());
  };
  protoOf(EnumEntriesList).lj = function (element) {
    if (element === null)
      return -1;
    var ordinal = element.a3_1;
    var target = getOrNull(this.jj_1, ordinal);
    return target === element ? ordinal : -1;
  };
  protoOf(EnumEntriesList).t = function (element) {
    if (!(element instanceof Enum))
      return -1;
    return this.lj(element instanceof Enum ? element : THROW_CCE());
  };
  protoOf(EnumEntriesList).mj = function (element) {
    return this.lj(element);
  };
  protoOf(EnumEntriesList).u = function (element) {
    if (!(element instanceof Enum))
      return -1;
    return this.mj(element instanceof Enum ? element : THROW_CCE());
  };
  function getProgressionLastElement(start, end, step) {
    var tmp;
    if (step > 0) {
      tmp = start >= end ? end : end - differenceModulo(end, start, step) | 0;
    } else if (step < 0) {
      tmp = start <= end ? end : end + differenceModulo(start, end, -step | 0) | 0;
    } else {
      throw IllegalArgumentException_init_$Create$_0('Step is zero.');
    }
    return tmp;
  }
  function differenceModulo(a, b, c) {
    return mod(mod(a, c) - mod(b, c) | 0, c);
  }
  function mod(a, b) {
    var mod = a % b | 0;
    return mod >= 0 ? mod : mod + b | 0;
  }
  function Default() {
    Default_instance = this;
    Random.call(this);
    this.nj_1 = defaultPlatformRandom();
  }
  protoOf(Default).oj = function (bitCount) {
    return this.nj_1.oj(bitCount);
  };
  protoOf(Default).fh = function () {
    return this.nj_1.fh();
  };
  protoOf(Default).pj = function () {
    return this.nj_1.pj();
  };
  protoOf(Default).qj = function (array) {
    return this.nj_1.qj(array);
  };
  protoOf(Default).rj = function (array, fromIndex, toIndex) {
    return this.nj_1.rj(array, fromIndex, toIndex);
  };
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Random() {
    Default_getInstance();
  }
  protoOf(Random).fh = function () {
    return this.oj(32);
  };
  protoOf(Random).pj = function () {
    return doubleFromParts(this.oj(26), this.oj(27));
  };
  protoOf(Random).rj = function (array, fromIndex, toIndex) {
    // Inline function 'kotlin.require' call
    if (!((0 <= fromIndex ? fromIndex <= array.length : false) && (0 <= toIndex ? toIndex <= array.length : false))) {
      // Inline function 'kotlin.random.Random.nextBytes.<anonymous>' call
      var message = 'fromIndex (' + fromIndex + ') or toIndex (' + toIndex + ') are out of range: 0..' + array.length + '.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(fromIndex <= toIndex)) {
      // Inline function 'kotlin.random.Random.nextBytes.<anonymous>' call
      var message_0 = 'fromIndex (' + fromIndex + ') must be not greater than toIndex (' + toIndex + ').';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var steps = (toIndex - fromIndex | 0) / 4 | 0;
    var position = fromIndex;
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < steps)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.random.Random.nextBytes.<anonymous>' call
        var v = this.fh();
        array[position] = toByte(v);
        array[position + 1 | 0] = toByte(v >>> 8 | 0);
        array[position + 2 | 0] = toByte(v >>> 16 | 0);
        array[position + 3 | 0] = toByte(v >>> 24 | 0);
        position = position + 4 | 0;
      }
       while (inductionVariable < steps);
    var remainder = toIndex - position | 0;
    var vr = this.oj(imul(remainder, 8));
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < remainder)
      do {
        var i = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        array[position + i | 0] = toByte(vr >>> imul(i, 8) | 0);
      }
       while (inductionVariable_0 < remainder);
    return array;
  };
  protoOf(Random).qj = function (array) {
    return this.rj(array, 0, array.length);
  };
  function Random_0(seed) {
    return XorWowRandom_init_$Create$(seed, seed >> 31);
  }
  function takeUpperBits(_this__u8e3s4, bitCount) {
    return (_this__u8e3s4 >>> (32 - bitCount | 0) | 0) & (-bitCount | 0) >> 31;
  }
  function Random_1(seed) {
    return XorWowRandom_init_$Create$(seed.z3(), seed.s3(32).z3());
  }
  function XorWowRandom_init_$Init$(seed1, seed2, $this) {
    XorWowRandom.call($this, seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ (seed2 >>> 4 | 0));
    return $this;
  }
  function XorWowRandom_init_$Create$(seed1, seed2) {
    return XorWowRandom_init_$Init$(seed1, seed2, objectCreate(protoOf(XorWowRandom)));
  }
  function Companion_10() {
    Companion_instance_10 = this;
    this.sj_1 = new Long(0, 0);
  }
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_10();
    return Companion_instance_10;
  }
  function XorWowRandom(x, y, z, w, v, addend) {
    Companion_getInstance_10();
    Random.call(this);
    this.tj_1 = x;
    this.uj_1 = y;
    this.vj_1 = z;
    this.wj_1 = w;
    this.xj_1 = v;
    this.yj_1 = addend;
    // Inline function 'kotlin.require' call
    if (!!((this.tj_1 | this.uj_1 | this.vj_1 | this.wj_1 | this.xj_1) === 0)) {
      // Inline function 'kotlin.random.XorWowRandom.<anonymous>' call
      var message = 'Initial state must have at least one non-zero element.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < 64)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.random.XorWowRandom.<anonymous>' call
        this.fh();
      }
       while (inductionVariable < 64);
  }
  protoOf(XorWowRandom).fh = function () {
    var t = this.tj_1;
    t = t ^ (t >>> 2 | 0);
    this.tj_1 = this.uj_1;
    this.uj_1 = this.vj_1;
    this.vj_1 = this.wj_1;
    var v0 = this.xj_1;
    this.wj_1 = v0;
    t = t ^ t << 1 ^ v0 ^ v0 << 4;
    this.xj_1 = t;
    this.yj_1 = this.yj_1 + 362437 | 0;
    return t + this.yj_1 | 0;
  };
  protoOf(XorWowRandom).oj = function (bitCount) {
    return takeUpperBits(this.fh(), bitCount);
  };
  function Companion_11() {
    Companion_instance_11 = this;
    this.z_1 = new IntRange(1, 0);
  }
  var Companion_instance_11;
  function Companion_getInstance_11() {
    if (Companion_instance_11 == null)
      new Companion_11();
    return Companion_instance_11;
  }
  function IntRange(start, endInclusive) {
    Companion_getInstance_11();
    IntProgression.call(this, start, endInclusive, 1);
  }
  protoOf(IntRange).q1 = function () {
    return this.e1_1;
  };
  protoOf(IntRange).r1 = function () {
    return this.f1_1;
  };
  protoOf(IntRange).p = function () {
    return this.e1_1 > this.f1_1;
  };
  protoOf(IntRange).equals = function (other) {
    var tmp;
    if (other instanceof IntRange) {
      tmp = this.p() && other.p() || (this.e1_1 === other.e1_1 && this.f1_1 === other.f1_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IntRange).hashCode = function () {
    return this.p() ? -1 : imul(31, this.e1_1) + this.f1_1 | 0;
  };
  protoOf(IntRange).toString = function () {
    return '' + this.e1_1 + '..' + this.f1_1;
  };
  function Companion_12() {
    Companion_instance_12 = this;
    this.zj_1 = new CharRange(_Char___init__impl__6a9atx(1), _Char___init__impl__6a9atx(0));
  }
  var Companion_instance_12;
  function Companion_getInstance_12() {
    if (Companion_instance_12 == null)
      new Companion_12();
    return Companion_instance_12;
  }
  function CharRange(start, endInclusive) {
    Companion_getInstance_12();
    CharProgression.call(this, start, endInclusive, 1);
  }
  protoOf(CharRange).p = function () {
    return Char__compareTo_impl_ypi4mb(this.dk_1, this.ek_1) > 0;
  };
  protoOf(CharRange).equals = function (other) {
    var tmp;
    if (other instanceof CharRange) {
      tmp = this.p() && other.p() || (this.dk_1 === other.dk_1 && this.ek_1 === other.ek_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(CharRange).hashCode = function () {
    var tmp;
    if (this.p()) {
      tmp = -1;
    } else {
      // Inline function 'kotlin.code' call
      var this_0 = this.dk_1;
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      var tmp_0 = imul(31, tmp$ret$0);
      // Inline function 'kotlin.code' call
      var this_1 = this.ek_1;
      tmp = tmp_0 + Char__toInt_impl_vasixd(this_1) | 0;
    }
    return tmp;
  };
  protoOf(CharRange).toString = function () {
    return toString(this.dk_1) + '..' + toString(this.ek_1);
  };
  function IntProgressionIterator(first, last, step) {
    IntIterator.call(this);
    this.gk_1 = step;
    this.hk_1 = last;
    this.ik_1 = this.gk_1 > 0 ? first <= last : first >= last;
    this.jk_1 = this.ik_1 ? first : this.hk_1;
  }
  protoOf(IntProgressionIterator).l = function () {
    return this.ik_1;
  };
  protoOf(IntProgressionIterator).fh = function () {
    var value = this.jk_1;
    if (value === this.hk_1) {
      if (!this.ik_1)
        throw NoSuchElementException_init_$Create$();
      this.ik_1 = false;
    } else {
      this.jk_1 = this.jk_1 + this.gk_1 | 0;
    }
    return value;
  };
  function CharProgressionIterator(first, last, step) {
    CharIterator.call(this);
    this.kk_1 = step;
    var tmp = this;
    // Inline function 'kotlin.code' call
    tmp.lk_1 = Char__toInt_impl_vasixd(last);
    this.mk_1 = this.kk_1 > 0 ? Char__compareTo_impl_ypi4mb(first, last) <= 0 : Char__compareTo_impl_ypi4mb(first, last) >= 0;
    var tmp_0 = this;
    var tmp_1;
    if (this.mk_1) {
      // Inline function 'kotlin.code' call
      tmp_1 = Char__toInt_impl_vasixd(first);
    } else {
      tmp_1 = this.lk_1;
    }
    tmp_0.nk_1 = tmp_1;
  }
  protoOf(CharProgressionIterator).l = function () {
    return this.mk_1;
  };
  protoOf(CharProgressionIterator).hh = function () {
    var value = this.nk_1;
    if (value === this.lk_1) {
      if (!this.mk_1)
        throw NoSuchElementException_init_$Create$();
      this.mk_1 = false;
    } else {
      this.nk_1 = this.nk_1 + this.kk_1 | 0;
    }
    return numberToChar(value);
  };
  function Companion_13() {
  }
  protoOf(Companion_13).a1 = function (rangeStart, rangeEnd, step) {
    return new IntProgression(rangeStart, rangeEnd, step);
  };
  var Companion_instance_13;
  function Companion_getInstance_13() {
    return Companion_instance_13;
  }
  function IntProgression(start, endInclusive, step) {
    if (step === 0)
      throw IllegalArgumentException_init_$Create$_0('Step must be non-zero.');
    if (step === -2147483648)
      throw IllegalArgumentException_init_$Create$_0('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this.e1_1 = start;
    this.f1_1 = getProgressionLastElement(start, endInclusive, step);
    this.g1_1 = step;
  }
  protoOf(IntProgression).k = function () {
    return new IntProgressionIterator(this.e1_1, this.f1_1, this.g1_1);
  };
  protoOf(IntProgression).p = function () {
    return this.g1_1 > 0 ? this.e1_1 > this.f1_1 : this.e1_1 < this.f1_1;
  };
  protoOf(IntProgression).equals = function (other) {
    var tmp;
    if (other instanceof IntProgression) {
      tmp = this.p() && other.p() || (this.e1_1 === other.e1_1 && this.f1_1 === other.f1_1 && this.g1_1 === other.g1_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IntProgression).hashCode = function () {
    return this.p() ? -1 : imul(31, imul(31, this.e1_1) + this.f1_1 | 0) + this.g1_1 | 0;
  };
  protoOf(IntProgression).toString = function () {
    return this.g1_1 > 0 ? '' + this.e1_1 + '..' + this.f1_1 + ' step ' + this.g1_1 : '' + this.e1_1 + ' downTo ' + this.f1_1 + ' step ' + (-this.g1_1 | 0);
  };
  function Companion_14() {
  }
  var Companion_instance_14;
  function Companion_getInstance_14() {
    return Companion_instance_14;
  }
  function CharProgression(start, endInclusive, step) {
    if (step === 0)
      throw IllegalArgumentException_init_$Create$_0('Step must be non-zero.');
    if (step === -2147483648)
      throw IllegalArgumentException_init_$Create$_0('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this.dk_1 = start;
    var tmp = this;
    // Inline function 'kotlin.code' call
    var tmp_0 = Char__toInt_impl_vasixd(start);
    // Inline function 'kotlin.code' call
    var tmp$ret$1 = Char__toInt_impl_vasixd(endInclusive);
    tmp.ek_1 = numberToChar(getProgressionLastElement(tmp_0, tmp$ret$1, step));
    this.fk_1 = step;
  }
  protoOf(CharProgression).k = function () {
    return new CharProgressionIterator(this.dk_1, this.ek_1, this.fk_1);
  };
  protoOf(CharProgression).p = function () {
    return this.fk_1 > 0 ? Char__compareTo_impl_ypi4mb(this.dk_1, this.ek_1) > 0 : Char__compareTo_impl_ypi4mb(this.dk_1, this.ek_1) < 0;
  };
  protoOf(CharProgression).equals = function (other) {
    var tmp;
    if (other instanceof CharProgression) {
      tmp = this.p() && other.p() || (this.dk_1 === other.dk_1 && this.ek_1 === other.ek_1 && this.fk_1 === other.fk_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(CharProgression).hashCode = function () {
    var tmp;
    if (this.p()) {
      tmp = -1;
    } else {
      // Inline function 'kotlin.code' call
      var this_0 = this.dk_1;
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      var tmp_0 = imul(31, tmp$ret$0);
      // Inline function 'kotlin.code' call
      var this_1 = this.ek_1;
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      tmp = imul(31, tmp_0 + tmp$ret$1 | 0) + this.fk_1 | 0;
    }
    return tmp;
  };
  protoOf(CharProgression).toString = function () {
    return this.fk_1 > 0 ? toString(this.dk_1) + '..' + toString(this.ek_1) + ' step ' + this.fk_1 : toString(this.dk_1) + ' downTo ' + toString(this.ek_1) + ' step ' + (-this.fk_1 | 0);
  };
  function checkStepIsPositive(isPositive, step) {
    if (!isPositive)
      throw IllegalArgumentException_init_$Create$_0('Step must be positive, was: ' + toString_1(step) + '.');
  }
  function safeCast(_this__u8e3s4, value) {
    var tmp;
    if (_this__u8e3s4.mb(value)) {
      tmp = !(value == null) ? value : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  }
  function cast(_this__u8e3s4, value) {
    if (!_this__u8e3s4.mb(value)) {
      // Inline function 'kotlin.reflect.qualifiedOrSimpleName' call
      var tmp$ret$0 = _this__u8e3s4.lb();
      throw ClassCastException_init_$Create$_0('Value cannot be cast to ' + tmp$ret$0);
    }
    return !(value == null) ? value : THROW_CCE();
  }
  function KTypeParameter() {
  }
  function Companion_15() {
    Companion_instance_15 = this;
    this.vb_1 = new KTypeProjection(null, null);
  }
  protoOf(Companion_15).wb = function (type) {
    return new KTypeProjection(KVariance_INVARIANT_getInstance(), type);
  };
  var Companion_instance_15;
  function Companion_getInstance_15() {
    if (Companion_instance_15 == null)
      new Companion_15();
    return Companion_instance_15;
  }
  function KTypeProjection(variance, type) {
    Companion_getInstance_15();
    this.ok_1 = variance;
    this.pk_1 = type;
    // Inline function 'kotlin.require' call
    if (!(this.ok_1 == null === (this.pk_1 == null))) {
      // Inline function 'kotlin.reflect.KTypeProjection.<anonymous>' call
      var message = this.ok_1 == null ? 'Star projection must have no type specified.' : 'The projection variance ' + toString_0(this.ok_1) + ' requires type to be specified.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(KTypeProjection).toString = function () {
    var tmp0_subject = this.ok_1;
    var tmp;
    switch (tmp0_subject == null ? -1 : tmp0_subject.a3_1) {
      case -1:
        tmp = '*';
        break;
      case 0:
        tmp = toString_0(this.pk_1);
        break;
      case 1:
        tmp = 'in ' + toString_0(this.pk_1);
        break;
      case 2:
        tmp = 'out ' + toString_0(this.pk_1);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(KTypeProjection).hashCode = function () {
    var result = this.ok_1 == null ? 0 : this.ok_1.hashCode();
    result = imul(result, 31) + (this.pk_1 == null ? 0 : hashCode(this.pk_1)) | 0;
    return result;
  };
  protoOf(KTypeProjection).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KTypeProjection))
      return false;
    var tmp0_other_with_cast = other instanceof KTypeProjection ? other : THROW_CCE();
    if (!equals(this.ok_1, tmp0_other_with_cast.ok_1))
      return false;
    if (!equals(this.pk_1, tmp0_other_with_cast.pk_1))
      return false;
    return true;
  };
  var KVariance_INVARIANT_instance;
  var KVariance_IN_instance;
  var KVariance_OUT_instance;
  var KVariance_entriesInitialized;
  function KVariance_initEntries() {
    if (KVariance_entriesInitialized)
      return Unit_instance;
    KVariance_entriesInitialized = true;
    KVariance_INVARIANT_instance = new KVariance('INVARIANT', 0);
    KVariance_IN_instance = new KVariance('IN', 1);
    KVariance_OUT_instance = new KVariance('OUT', 2);
  }
  function KVariance(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function KVariance_INVARIANT_getInstance() {
    KVariance_initEntries();
    return KVariance_INVARIANT_instance;
  }
  function appendElement(_this__u8e3s4, element, transform) {
    if (!(transform == null))
      _this__u8e3s4.f(transform(element));
    else {
      if (element == null ? true : isCharSequence(element))
        _this__u8e3s4.f(element);
      else {
        if (element instanceof Char)
          _this__u8e3s4.e9(element.v1_1);
        else {
          _this__u8e3s4.f(toString_1(element));
        }
      }
    }
  }
  function equals_1(_this__u8e3s4, other, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    if (_this__u8e3s4 === other)
      return true;
    if (!ignoreCase)
      return false;
    var thisUpper = uppercaseChar(_this__u8e3s4);
    var otherUpper = uppercaseChar(other);
    var tmp;
    if (thisUpper === otherUpper) {
      tmp = true;
    } else {
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$2 = toString(thisUpper).toLowerCase();
      var tmp_0 = charSequenceGet(tmp$ret$2, 0);
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$6 = toString(otherUpper).toLowerCase();
      tmp = tmp_0 === charSequenceGet(tmp$ret$6, 0);
    }
    return tmp;
  }
  function titlecase(_this__u8e3s4) {
    return titlecaseImpl(_this__u8e3s4);
  }
  function isSurrogate(_this__u8e3s4) {
    return _Char___init__impl__6a9atx(55296) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57343) : false;
  }
  function trimMargin(_this__u8e3s4, marginPrefix) {
    marginPrefix = marginPrefix === VOID ? '|' : marginPrefix;
    return replaceIndentByMargin(_this__u8e3s4, '', marginPrefix);
  }
  function trimIndent(_this__u8e3s4) {
    return replaceIndent(_this__u8e3s4, '');
  }
  function replaceIndentByMargin(_this__u8e3s4, newIndent, marginPrefix) {
    newIndent = newIndent === VOID ? '' : newIndent;
    marginPrefix = marginPrefix === VOID ? '|' : marginPrefix;
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(marginPrefix)) {
      // Inline function 'kotlin.text.replaceIndentByMargin.<anonymous>' call
      var message = 'marginPrefix must be non-blank string.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var lines_0 = lines(_this__u8e3s4);
    var tmp1 = _this__u8e3s4.length + imul(newIndent.length, lines_0.n()) | 0;
    // Inline function 'kotlin.text.reindent' call
    var indentAddFunction = getIndentFunction(newIndent);
    var lastIndex = get_lastIndex_2(lines_0);
    // Inline function 'kotlin.collections.mapIndexedNotNull' call
    // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = lines_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.collections.mapIndexedNotNullTo.<anonymous>' call
      // Inline function 'kotlin.text.reindent.<anonymous>' call
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var tmp;
      if ((index_0 === 0 || index_0 === lastIndex) && isBlank(item)) {
        tmp = null;
      } else {
        // Inline function 'kotlin.text.replaceIndentByMargin.<anonymous>' call
        var tmp$ret$3;
        $l$block: {
          // Inline function 'kotlin.text.indexOfFirst' call
          var inductionVariable = 0;
          var last = charSequenceLength(item) - 1 | 0;
          if (inductionVariable <= last)
            do {
              var index_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'kotlin.text.replaceIndentByMargin.<anonymous>.<anonymous>' call
              var it = charSequenceGet(item, index_1);
              if (!isWhitespace(it)) {
                tmp$ret$3 = index_1;
                break $l$block;
              }
            }
             while (inductionVariable <= last);
          tmp$ret$3 = -1;
        }
        var firstNonWhitespaceIndex = tmp$ret$3;
        var tmp_0;
        if (firstNonWhitespaceIndex === -1) {
          tmp_0 = null;
        } else if (startsWith_0(item, marginPrefix, firstNonWhitespaceIndex)) {
          // Inline function 'kotlin.text.substring' call
          var startIndex = firstNonWhitespaceIndex + marginPrefix.length | 0;
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = item.substring(startIndex);
        } else {
          tmp_0 = null;
        }
        var tmp0_safe_receiver = tmp_0;
        var tmp_1;
        if (tmp0_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_1 = indentAddFunction(tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs = tmp_1;
        tmp = tmp1_elvis_lhs == null ? item : tmp1_elvis_lhs;
      }
      var tmp0_safe_receiver_0 = tmp;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.collections.mapIndexedNotNullTo.<anonymous>.<anonymous>' call
        destination.e(tmp0_safe_receiver_0);
      }
    }
    return joinTo_0(destination, StringBuilder_init_$Create$(tmp1), '\n').toString();
  }
  function replaceIndent(_this__u8e3s4, newIndent) {
    newIndent = newIndent === VOID ? '' : newIndent;
    var lines_0 = lines(_this__u8e3s4);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = lines_0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'kotlin.text.replaceIndent.stub_for_inlining' call
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element)) {
        destination.e(element);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var item = _iterator__ex2g4s_0.m();
      // Inline function 'kotlin.text.replaceIndent.stub_for_inlining' call
      var tmp$ret$4 = indentWidth(item);
      destination_0.e(tmp$ret$4);
    }
    var tmp0_elvis_lhs = minOrNull(destination_0);
    var minCommonIndent = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1 = _this__u8e3s4.length + imul(newIndent.length, lines_0.n()) | 0;
    // Inline function 'kotlin.text.reindent' call
    var indentAddFunction = getIndentFunction(newIndent);
    var lastIndex = get_lastIndex_2(lines_0);
    // Inline function 'kotlin.collections.mapIndexedNotNull' call
    // Inline function 'kotlin.collections.mapIndexedNotNullTo' call
    var destination_1 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s_1 = lines_0.k();
    while (_iterator__ex2g4s_1.l()) {
      var item_0 = _iterator__ex2g4s_1.m();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.collections.mapIndexedNotNullTo.<anonymous>' call
      // Inline function 'kotlin.text.reindent.<anonymous>' call
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var tmp;
      if ((index_0 === 0 || index_0 === lastIndex) && isBlank(item_0)) {
        tmp = null;
      } else {
        // Inline function 'kotlin.text.replaceIndent.<anonymous>' call
        var tmp0_safe_receiver = drop_0(item_0, minCommonIndent);
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = indentAddFunction(tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs = tmp_0;
        tmp = tmp1_elvis_lhs == null ? item_0 : tmp1_elvis_lhs;
      }
      var tmp0_safe_receiver_0 = tmp;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.collections.mapIndexedNotNullTo.<anonymous>.<anonymous>' call
        destination_1.e(tmp0_safe_receiver_0);
      }
    }
    return joinTo_0(destination_1, StringBuilder_init_$Create$(tmp1), '\n').toString();
  }
  function getIndentFunction(indent) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(indent) === 0) {
      tmp = getIndentFunction$lambda;
    } else {
      tmp = getIndentFunction$lambda_0(indent);
    }
    return tmp;
  }
  function indentWidth(_this__u8e3s4) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.indexOfFirst' call
      var inductionVariable = 0;
      var last = charSequenceLength(_this__u8e3s4) - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.text.indentWidth.<anonymous>' call
          var it = charSequenceGet(_this__u8e3s4, index);
          if (!isWhitespace(it)) {
            tmp$ret$1 = index;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$1 = -1;
    }
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.text.indentWidth.<anonymous>' call
    var it_0 = tmp$ret$1;
    return it_0 === -1 ? _this__u8e3s4.length : it_0;
  }
  function getIndentFunction$lambda(line) {
    return line;
  }
  function getIndentFunction$lambda_0($indent) {
    return function (line) {
      return $indent + line;
    };
  }
  function toLongOrNull(_this__u8e3s4) {
    return toLongOrNull_0(_this__u8e3s4, 10);
  }
  function toIntOrNull(_this__u8e3s4) {
    return toIntOrNull_0(_this__u8e3s4, 10);
  }
  function toLongOrNull_0(_this__u8e3s4, radix) {
    checkRadix(radix);
    var length = _this__u8e3s4.length;
    if (length === 0)
      return null;
    var start;
    var isNegative;
    var limit;
    var firstChar = charSequenceGet(_this__u8e3s4, 0);
    if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar === _Char___init__impl__6a9atx(45)) {
        isNegative = true;
        limit = new Long(0, -2147483648);
      } else if (firstChar === _Char___init__impl__6a9atx(43)) {
        isNegative = false;
        limit = new Long(1, -2147483648);
      } else
        return null;
    } else {
      start = 0;
      isNegative = false;
      limit = new Long(1, -2147483648);
    }
    // Inline function 'kotlin.Long.div' call
    var limitForMaxRadix = (new Long(1, -2147483648)).l3(toLong(36));
    var limitBeforeMul = limitForMaxRadix;
    var result = new Long(0, 0);
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this__u8e3s4, i), radix);
        if (digit < 0)
          return null;
        if (result.d1(limitBeforeMul) < 0) {
          if (limitBeforeMul.equals(limitForMaxRadix)) {
            // Inline function 'kotlin.Long.div' call
            limitBeforeMul = limit.l3(toLong(radix));
            if (result.d1(limitBeforeMul) < 0) {
              return null;
            }
          } else {
            return null;
          }
        }
        // Inline function 'kotlin.Long.times' call
        result = result.k3(toLong(radix));
        var tmp = result;
        // Inline function 'kotlin.Long.plus' call
        var tmp$ret$3 = limit.i3(toLong(digit));
        if (tmp.d1(tmp$ret$3) < 0)
          return null;
        // Inline function 'kotlin.Long.minus' call
        result = result.j3(toLong(digit));
      }
       while (inductionVariable < length);
    return isNegative ? result : result.p3();
  }
  function toIntOrNull_0(_this__u8e3s4, radix) {
    checkRadix(radix);
    var length = _this__u8e3s4.length;
    if (length === 0)
      return null;
    var start;
    var isNegative;
    var limit;
    var firstChar = charSequenceGet(_this__u8e3s4, 0);
    if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
      if (length === 1)
        return null;
      start = 1;
      if (firstChar === _Char___init__impl__6a9atx(45)) {
        isNegative = true;
        limit = -2147483648;
      } else if (firstChar === _Char___init__impl__6a9atx(43)) {
        isNegative = false;
        limit = -2147483647;
      } else
        return null;
    } else {
      start = 0;
      isNegative = false;
      limit = -2147483647;
    }
    var limitForMaxRadix = -59652323;
    var limitBeforeMul = limitForMaxRadix;
    var result = 0;
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this__u8e3s4, i), radix);
        if (digit < 0)
          return null;
        if (result < limitBeforeMul) {
          if (limitBeforeMul === limitForMaxRadix) {
            limitBeforeMul = limit / radix | 0;
            if (result < limitBeforeMul) {
              return null;
            }
          } else {
            return null;
          }
        }
        result = imul(result, radix);
        if (result < (limit + digit | 0))
          return null;
        result = result - digit | 0;
      }
       while (inductionVariable < length);
    return isNegative ? result : -result | 0;
  }
  function numberFormatError(input) {
    throw NumberFormatException_init_$Create$_0("Invalid number format: '" + input + "'");
  }
  function toByteOrNull(_this__u8e3s4) {
    return toByteOrNull_0(_this__u8e3s4, 10);
  }
  function toShortOrNull(_this__u8e3s4) {
    return toShortOrNull_0(_this__u8e3s4, 10);
  }
  function toByteOrNull_0(_this__u8e3s4, radix) {
    var tmp0_elvis_lhs = toIntOrNull_0(_this__u8e3s4, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var int = tmp;
    if (int < -128 || int > 127)
      return null;
    return toByte(int);
  }
  function toShortOrNull_0(_this__u8e3s4, radix) {
    var tmp0_elvis_lhs = toIntOrNull_0(_this__u8e3s4, radix);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var int = tmp;
    if (int < -32768 || int > 32767)
      return null;
    return toShort(int);
  }
  function isEmpty(_this__u8e3s4) {
    return charSequenceLength(_this__u8e3s4) === 0;
  }
  function lastIndexOf_2(_this__u8e3s4, char, startIndex, ignoreCase) {
    startIndex = startIndex === VOID ? get_lastIndex_3(_this__u8e3s4) : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this__u8e3s4 === 'string');
    }
    if (tmp_0) {
      // Inline function 'kotlin.charArrayOf' call
      var tmp$ret$0 = charArrayOf([char]);
      tmp = lastIndexOfAny(_this__u8e3s4, tmp$ret$0, startIndex, ignoreCase);
    } else {
      // Inline function 'kotlin.text.nativeLastIndexOf' call
      // Inline function 'kotlin.text.nativeLastIndexOf' call
      var str = toString(char);
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.lastIndexOf(str, startIndex);
    }
    return tmp;
  }
  function contains_8(_this__u8e3s4, char, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    return indexOf_8(_this__u8e3s4, char, VOID, ignoreCase) >= 0;
  }
  function split(_this__u8e3s4, delimiters, ignoreCase, limit) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    limit = limit === VOID ? 0 : limit;
    if (delimiters.length === 1) {
      return split_1(_this__u8e3s4, toString(delimiters[0]), ignoreCase, limit);
    }
    // Inline function 'kotlin.collections.map' call
    var this_0 = asIterable(rangesDelimitedBy(_this__u8e3s4, delimiters, VOID, ignoreCase, limit));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'kotlin.text.split.<anonymous>' call
      var tmp$ret$0 = substring_0(_this__u8e3s4, item);
      destination.e(tmp$ret$0);
    }
    return destination;
  }
  function split_0(_this__u8e3s4, delimiters, ignoreCase, limit) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    limit = limit === VOID ? 0 : limit;
    if (delimiters.length === 1) {
      var delimiter = delimiters[0];
      // Inline function 'kotlin.text.isEmpty' call
      if (!(charSequenceLength(delimiter) === 0)) {
        return split_1(_this__u8e3s4, delimiter, ignoreCase, limit);
      }
    }
    // Inline function 'kotlin.collections.map' call
    var this_0 = asIterable(rangesDelimitedBy_0(_this__u8e3s4, delimiters, VOID, ignoreCase, limit));
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'kotlin.text.split.<anonymous>' call
      var tmp$ret$1 = substring_0(_this__u8e3s4, item);
      destination.e(tmp$ret$1);
    }
    return destination;
  }
  function substring(_this__u8e3s4, range) {
    var tmp1 = range.q1();
    // Inline function 'kotlin.text.substring' call
    var endIndex = range.r1() + 1 | 0;
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.substring(tmp1, endIndex);
  }
  function isBlank(_this__u8e3s4) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.all' call
      var inductionVariable = 0;
      while (inductionVariable < charSequenceLength(_this__u8e3s4)) {
        var element = charSequenceGet(_this__u8e3s4, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.text.isBlank.<anonymous>' call
        if (!isWhitespace(element)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function indexOf_8(_this__u8e3s4, char, startIndex, ignoreCase) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this__u8e3s4 === 'string');
    }
    if (tmp_0) {
      // Inline function 'kotlin.charArrayOf' call
      var tmp$ret$0 = charArrayOf([char]);
      tmp = indexOfAny(_this__u8e3s4, tmp$ret$0, startIndex, ignoreCase);
    } else {
      // Inline function 'kotlin.text.nativeIndexOf' call
      // Inline function 'kotlin.text.nativeIndexOf' call
      var str = toString(char);
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.indexOf(str, startIndex);
    }
    return tmp;
  }
  function lastIndexOf_3(_this__u8e3s4, string, startIndex, ignoreCase) {
    startIndex = startIndex === VOID ? get_lastIndex_3(_this__u8e3s4) : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this__u8e3s4 === 'string');
    }
    if (tmp_0) {
      tmp = indexOf_10(_this__u8e3s4, string, startIndex, 0, ignoreCase, true);
    } else {
      // Inline function 'kotlin.text.nativeLastIndexOf' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.lastIndexOf(string, startIndex);
    }
    return tmp;
  }
  function lineSequence(_this__u8e3s4) {
    // Inline function 'kotlin.sequences.Sequence' call
    return new lineSequence$$inlined$Sequence$1(_this__u8e3s4);
  }
  function get_lastIndex_3(_this__u8e3s4) {
    return charSequenceLength(_this__u8e3s4) - 1 | 0;
  }
  function contains_9(_this__u8e3s4, other, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    if (typeof other === 'string') {
      tmp = indexOf_9(_this__u8e3s4, other, VOID, ignoreCase) >= 0;
    } else {
      tmp = indexOf_10(_this__u8e3s4, other, 0, charSequenceLength(_this__u8e3s4), ignoreCase) >= 0;
    }
    return tmp;
  }
  function indexOf_9(_this__u8e3s4, string, startIndex, ignoreCase) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this__u8e3s4 === 'string');
    }
    if (tmp_0) {
      tmp = indexOf_10(_this__u8e3s4, string, startIndex, charSequenceLength(_this__u8e3s4), ignoreCase);
    } else {
      // Inline function 'kotlin.text.nativeIndexOf' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.indexOf(string, startIndex);
    }
    return tmp;
  }
  function lastIndexOfAny(_this__u8e3s4, chars, startIndex, ignoreCase) {
    startIndex = startIndex === VOID ? get_lastIndex_3(_this__u8e3s4) : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    if (!ignoreCase && chars.length === 1) {
      tmp = typeof _this__u8e3s4 === 'string';
    } else {
      tmp = false;
    }
    if (tmp) {
      var char = single(chars);
      // Inline function 'kotlin.text.nativeLastIndexOf' call
      // Inline function 'kotlin.text.nativeLastIndexOf' call
      var str = toString(char);
      // Inline function 'kotlin.js.asDynamic' call
      return _this__u8e3s4.lastIndexOf(str, startIndex);
    }
    var inductionVariable = coerceAtMost(startIndex, get_lastIndex_3(_this__u8e3s4));
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var charAtIndex = charSequenceGet(_this__u8e3s4, index);
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlin.collections.any' call
          var inductionVariable_0 = 0;
          var last = chars.length;
          while (inductionVariable_0 < last) {
            var element = chars[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'kotlin.text.lastIndexOfAny.<anonymous>' call
            if (equals_1(element, charAtIndex, ignoreCase)) {
              tmp$ret$4 = true;
              break $l$block;
            }
          }
          tmp$ret$4 = false;
        }
        if (tmp$ret$4)
          return index;
      }
       while (0 <= inductionVariable);
    return -1;
  }
  function split_1(_this__u8e3s4, delimiter, ignoreCase, limit) {
    requireNonNegativeLimit(limit);
    var currentOffset = 0;
    var nextIndex = indexOf_9(_this__u8e3s4, delimiter, currentOffset, ignoreCase);
    if (nextIndex === -1 || limit === 1) {
      return listOf(toString_1(_this__u8e3s4));
    }
    var isLimited = limit > 0;
    var result = ArrayList_init_$Create$_0(isLimited ? coerceAtMost(limit, 10) : 10);
    $l$loop: do {
      var tmp1 = currentOffset;
      // Inline function 'kotlin.text.substring' call
      var endIndex = nextIndex;
      var tmp$ret$0 = toString_1(charSequenceSubSequence(_this__u8e3s4, tmp1, endIndex));
      result.e(tmp$ret$0);
      currentOffset = nextIndex + delimiter.length | 0;
      if (isLimited && result.n() === (limit - 1 | 0))
        break $l$loop;
      nextIndex = indexOf_9(_this__u8e3s4, delimiter, currentOffset, ignoreCase);
    }
     while (!(nextIndex === -1));
    var tmp4 = currentOffset;
    // Inline function 'kotlin.text.substring' call
    var endIndex_0 = charSequenceLength(_this__u8e3s4);
    var tmp$ret$1 = toString_1(charSequenceSubSequence(_this__u8e3s4, tmp4, endIndex_0));
    result.e(tmp$ret$1);
    return result;
  }
  function substring_0(_this__u8e3s4, range) {
    return toString_1(charSequenceSubSequence(_this__u8e3s4, range.q1(), range.r1() + 1 | 0));
  }
  function rangesDelimitedBy(_this__u8e3s4, delimiters, startIndex, ignoreCase, limit) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    limit = limit === VOID ? 0 : limit;
    requireNonNegativeLimit(limit);
    return new DelimitedRangesSequence(_this__u8e3s4, startIndex, limit, rangesDelimitedBy$lambda(delimiters, ignoreCase));
  }
  function rangesDelimitedBy_0(_this__u8e3s4, delimiters, startIndex, ignoreCase, limit) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    limit = limit === VOID ? 0 : limit;
    requireNonNegativeLimit(limit);
    var delimitersList = asList(delimiters);
    return new DelimitedRangesSequence(_this__u8e3s4, startIndex, limit, rangesDelimitedBy$lambda_0(delimitersList, ignoreCase));
  }
  function indexOfAny(_this__u8e3s4, chars, startIndex, ignoreCase) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    var tmp;
    if (!ignoreCase && chars.length === 1) {
      tmp = typeof _this__u8e3s4 === 'string';
    } else {
      tmp = false;
    }
    if (tmp) {
      var char = single(chars);
      // Inline function 'kotlin.text.nativeIndexOf' call
      // Inline function 'kotlin.text.nativeIndexOf' call
      var str = toString(char);
      // Inline function 'kotlin.js.asDynamic' call
      return _this__u8e3s4.indexOf(str, startIndex);
    }
    var inductionVariable = coerceAtLeast(startIndex, 0);
    var last = get_lastIndex_3(_this__u8e3s4);
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var charAtIndex = charSequenceGet(_this__u8e3s4, index);
        var tmp$ret$4;
        $l$block: {
          // Inline function 'kotlin.collections.any' call
          var inductionVariable_0 = 0;
          var last_0 = chars.length;
          while (inductionVariable_0 < last_0) {
            var element = chars[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'kotlin.text.indexOfAny.<anonymous>' call
            if (equals_1(element, charAtIndex, ignoreCase)) {
              tmp$ret$4 = true;
              break $l$block;
            }
          }
          tmp$ret$4 = false;
        }
        if (tmp$ret$4)
          return index;
      }
       while (!(index === last));
    return -1;
  }
  function indexOf_10(_this__u8e3s4, other, startIndex, endIndex, ignoreCase, last) {
    last = last === VOID ? false : last;
    var indices = !last ? numberRangeToNumber(coerceAtLeast(startIndex, 0), coerceAtMost(endIndex, charSequenceLength(_this__u8e3s4))) : downTo(coerceAtMost(startIndex, get_lastIndex_3(_this__u8e3s4)), coerceAtLeast(endIndex, 0));
    var tmp;
    if (typeof _this__u8e3s4 === 'string') {
      tmp = typeof other === 'string';
    } else {
      tmp = false;
    }
    if (tmp) {
      var inductionVariable = indices.e1_1;
      var last_0 = indices.f1_1;
      var step = indices.g1_1;
      if (step > 0 && inductionVariable <= last_0 || (step < 0 && last_0 <= inductionVariable))
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + step | 0;
          if (regionMatches(other, 0, _this__u8e3s4, index, other.length, ignoreCase))
            return index;
        }
         while (!(index === last_0));
    } else {
      var inductionVariable_0 = indices.e1_1;
      var last_1 = indices.f1_1;
      var step_0 = indices.g1_1;
      if (step_0 > 0 && inductionVariable_0 <= last_1 || (step_0 < 0 && last_1 <= inductionVariable_0))
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
          if (regionMatchesImpl(other, 0, _this__u8e3s4, index_0, charSequenceLength(other), ignoreCase))
            return index_0;
        }
         while (!(index_0 === last_1));
    }
    return -1;
  }
  function trim(_this__u8e3s4) {
    // Inline function 'kotlin.text.trim' call
    var startIndex = 0;
    var endIndex = charSequenceLength(_this__u8e3s4) - 1 | 0;
    var startFound = false;
    $l$loop: while (startIndex <= endIndex) {
      var index = !startFound ? startIndex : endIndex;
      // Inline function 'kotlin.text.trim.stub_for_inlining' call
      var p0 = charSequenceGet(_this__u8e3s4, index);
      var match = isWhitespace(p0);
      if (!startFound) {
        if (!match)
          startFound = true;
        else
          startIndex = startIndex + 1 | 0;
      } else {
        if (!match)
          break $l$loop;
        else
          endIndex = endIndex - 1 | 0;
      }
    }
    return charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex + 1 | 0);
  }
  function State() {
    this.qk_1 = 0;
    this.rk_1 = 1;
    this.sk_1 = 2;
  }
  var State_instance;
  function State_getInstance() {
    return State_instance;
  }
  function LinesIterator(string) {
    this.tk_1 = string;
    this.uk_1 = 0;
    this.vk_1 = 0;
    this.wk_1 = 0;
    this.xk_1 = 0;
  }
  protoOf(LinesIterator).l = function () {
    if (!(this.uk_1 === 0)) {
      return this.uk_1 === 1;
    }
    if (this.xk_1 < 0) {
      this.uk_1 = 2;
      return false;
    }
    var _delimiterLength = -1;
    var _delimiterStartIndex = charSequenceLength(this.tk_1);
    var inductionVariable = this.vk_1;
    var last = charSequenceLength(this.tk_1);
    if (inductionVariable < last)
      $l$loop: do {
        var idx = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(this.tk_1, idx);
        if (c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13)) {
          _delimiterLength = c === _Char___init__impl__6a9atx(13) && (idx + 1 | 0) < charSequenceLength(this.tk_1) && charSequenceGet(this.tk_1, idx + 1 | 0) === _Char___init__impl__6a9atx(10) ? 2 : 1;
          _delimiterStartIndex = idx;
          break $l$loop;
        }
      }
       while (inductionVariable < last);
    this.uk_1 = 1;
    this.xk_1 = _delimiterLength;
    this.wk_1 = _delimiterStartIndex;
    return true;
  };
  protoOf(LinesIterator).m = function () {
    if (!this.l()) {
      throw NoSuchElementException_init_$Create$();
    }
    this.uk_1 = 0;
    var lastIndex = this.wk_1;
    var firstIndex = this.vk_1;
    this.vk_1 = this.wk_1 + this.xk_1 | 0;
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.tk_1;
    return toString_1(charSequenceSubSequence(this_0, firstIndex, lastIndex));
  };
  function trimEnd(_this__u8e3s4) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.trimEnd' call
      var inductionVariable = charSequenceLength(_this__u8e3s4) - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          // Inline function 'kotlin.text.trimEnd.stub_for_inlining' call
          var p0 = charSequenceGet(_this__u8e3s4, index);
          if (!isWhitespace(p0)) {
            tmp$ret$1 = charSequenceSubSequence(_this__u8e3s4, 0, index + 1 | 0);
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$1 = '';
    }
    return tmp$ret$1;
  }
  function requireNonNegativeLimit(limit) {
    var tmp;
    if (!(limit >= 0)) {
      // Inline function 'kotlin.text.requireNonNegativeLimit.<anonymous>' call
      var message = 'Limit must be non-negative, but was ' + limit;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return tmp;
  }
  function calcNext_1($this) {
    if ($this.al_1 < 0) {
      $this.yk_1 = 0;
      $this.bl_1 = null;
    } else {
      var tmp;
      var tmp_0;
      if ($this.dl_1.gl_1 > 0) {
        $this.cl_1 = $this.cl_1 + 1 | 0;
        tmp_0 = $this.cl_1 >= $this.dl_1.gl_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = true;
      } else {
        tmp = $this.al_1 > charSequenceLength($this.dl_1.el_1);
      }
      if (tmp) {
        $this.bl_1 = numberRangeToNumber($this.zk_1, get_lastIndex_3($this.dl_1.el_1));
        $this.al_1 = -1;
      } else {
        var match = $this.dl_1.hl_1($this.dl_1.el_1, $this.al_1);
        if (match == null) {
          $this.bl_1 = numberRangeToNumber($this.zk_1, get_lastIndex_3($this.dl_1.el_1));
          $this.al_1 = -1;
        } else {
          var index = match.ug();
          var length = match.vg();
          $this.bl_1 = until($this.zk_1, index);
          $this.zk_1 = index + length | 0;
          $this.al_1 = $this.zk_1 + (length === 0 ? 1 : 0) | 0;
        }
      }
      $this.yk_1 = 1;
    }
  }
  function DelimitedRangesSequence$iterator$1(this$0) {
    this.dl_1 = this$0;
    this.yk_1 = -1;
    this.zk_1 = coerceIn_0(this$0.fl_1, 0, charSequenceLength(this$0.el_1));
    this.al_1 = this.zk_1;
    this.bl_1 = null;
    this.cl_1 = 0;
  }
  protoOf(DelimitedRangesSequence$iterator$1).m = function () {
    if (this.yk_1 === -1) {
      calcNext_1(this);
    }
    if (this.yk_1 === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this.bl_1;
    var result = tmp instanceof IntRange ? tmp : THROW_CCE();
    this.bl_1 = null;
    this.yk_1 = -1;
    return result;
  };
  protoOf(DelimitedRangesSequence$iterator$1).l = function () {
    if (this.yk_1 === -1) {
      calcNext_1(this);
    }
    return this.yk_1 === 1;
  };
  function DelimitedRangesSequence(input, startIndex, limit, getNextMatch) {
    this.el_1 = input;
    this.fl_1 = startIndex;
    this.gl_1 = limit;
    this.hl_1 = getNextMatch;
  }
  protoOf(DelimitedRangesSequence).k = function () {
    return new DelimitedRangesSequence$iterator$1(this);
  };
  function findAnyOf(_this__u8e3s4, strings, startIndex, ignoreCase, last) {
    if (!ignoreCase && strings.n() === 1) {
      var string = single_0(strings);
      var index = !last ? indexOf_9(_this__u8e3s4, string, startIndex) : lastIndexOf_3(_this__u8e3s4, string, startIndex);
      return index < 0 ? null : to(index, string);
    }
    var indices = !last ? numberRangeToNumber(coerceAtLeast(startIndex, 0), charSequenceLength(_this__u8e3s4)) : downTo(coerceAtMost(startIndex, get_lastIndex_3(_this__u8e3s4)), 0);
    if (typeof _this__u8e3s4 === 'string') {
      var inductionVariable = indices.e1_1;
      var last_0 = indices.f1_1;
      var step = indices.g1_1;
      if (step > 0 && inductionVariable <= last_0 || (step < 0 && last_0 <= inductionVariable))
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + step | 0;
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = strings.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              // Inline function 'kotlin.text.findAnyOf.<anonymous>' call
              if (regionMatches(element, 0, _this__u8e3s4, index_0, element.length, ignoreCase)) {
                tmp$ret$1 = element;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var matchingString = tmp$ret$1;
          if (!(matchingString == null))
            return to(index_0, matchingString);
        }
         while (!(index_0 === last_0));
    } else {
      var inductionVariable_0 = indices.e1_1;
      var last_1 = indices.f1_1;
      var step_0 = indices.g1_1;
      if (step_0 > 0 && inductionVariable_0 <= last_1 || (step_0 < 0 && last_1 <= inductionVariable_0))
        do {
          var index_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
          var tmp$ret$3;
          $l$block_0: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s_0 = strings.k();
            while (_iterator__ex2g4s_0.l()) {
              var element_0 = _iterator__ex2g4s_0.m();
              // Inline function 'kotlin.text.findAnyOf.<anonymous>' call
              if (regionMatchesImpl(element_0, 0, _this__u8e3s4, index_1, element_0.length, ignoreCase)) {
                tmp$ret$3 = element_0;
                break $l$block_0;
              }
            }
            tmp$ret$3 = null;
          }
          var matchingString_0 = tmp$ret$3;
          if (!(matchingString_0 == null))
            return to(index_1, matchingString_0);
        }
         while (!(index_1 === last_1));
    }
    return null;
  }
  function regionMatchesImpl(_this__u8e3s4, thisOffset, other, otherOffset, length, ignoreCase) {
    if (otherOffset < 0 || thisOffset < 0 || thisOffset > (charSequenceLength(_this__u8e3s4) - length | 0) || otherOffset > (charSequenceLength(other) - length | 0)) {
      return false;
    }
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals_1(charSequenceGet(_this__u8e3s4, thisOffset + index | 0), charSequenceGet(other, otherOffset + index | 0), ignoreCase))
          return false;
      }
       while (inductionVariable < length);
    return true;
  }
  function padStart(_this__u8e3s4, length, padChar) {
    padChar = padChar === VOID ? _Char___init__impl__6a9atx(32) : padChar;
    return toString_1(padStart_0(isCharSequence(_this__u8e3s4) ? _this__u8e3s4 : THROW_CCE(), length, padChar));
  }
  function startsWith_1(_this__u8e3s4, char, ignoreCase) {
    ignoreCase = ignoreCase === VOID ? false : ignoreCase;
    return charSequenceLength(_this__u8e3s4) > 0 && equals_1(charSequenceGet(_this__u8e3s4, 0), char, ignoreCase);
  }
  function lines(_this__u8e3s4) {
    return toList_2(lineSequence(_this__u8e3s4));
  }
  function padStart_0(_this__u8e3s4, length, padChar) {
    padChar = padChar === VOID ? _Char___init__impl__6a9atx(32) : padChar;
    if (length < 0)
      throw IllegalArgumentException_init_$Create$_0('Desired length ' + length + ' is less than zero.');
    if (length <= charSequenceLength(_this__u8e3s4))
      return charSequenceSubSequence(_this__u8e3s4, 0, charSequenceLength(_this__u8e3s4));
    var sb = StringBuilder_init_$Create$(length);
    var inductionVariable = 1;
    var last = length - charSequenceLength(_this__u8e3s4) | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.e9(padChar);
      }
       while (!(i === last));
    sb.f(_this__u8e3s4);
    return sb;
  }
  function substringAfter(_this__u8e3s4, delimiter, missingDelimiterValue) {
    missingDelimiterValue = missingDelimiterValue === VOID ? _this__u8e3s4 : missingDelimiterValue;
    var index = indexOf_9(_this__u8e3s4, delimiter);
    var tmp;
    if (index === -1) {
      tmp = missingDelimiterValue;
    } else {
      var tmp1 = index + delimiter.length | 0;
      // Inline function 'kotlin.text.substring' call
      var endIndex = _this__u8e3s4.length;
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.substring(tmp1, endIndex);
    }
    return tmp;
  }
  function substringBefore(_this__u8e3s4, delimiter, missingDelimiterValue) {
    missingDelimiterValue = missingDelimiterValue === VOID ? _this__u8e3s4 : missingDelimiterValue;
    var index = indexOf_9(_this__u8e3s4, delimiter);
    var tmp;
    if (index === -1) {
      tmp = missingDelimiterValue;
    } else {
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.substring(0, index);
    }
    return tmp;
  }
  function lineSequence$$inlined$Sequence$1($this_lineSequence) {
    this.il_1 = $this_lineSequence;
  }
  protoOf(lineSequence$$inlined$Sequence$1).k = function () {
    // Inline function 'kotlin.text.lineSequence.<anonymous>' call
    return new LinesIterator(this.il_1);
  };
  function rangesDelimitedBy$lambda($delimiters, $ignoreCase) {
    return function ($this$DelimitedRangesSequence, currentIndex) {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.text.rangesDelimitedBy.<anonymous>.<anonymous>' call
      var it = indexOfAny($this$DelimitedRangesSequence, $delimiters, currentIndex, $ignoreCase);
      return it < 0 ? null : to(it, 1);
    };
  }
  function rangesDelimitedBy$lambda_0($delimitersList, $ignoreCase) {
    return function ($this$DelimitedRangesSequence, currentIndex) {
      var tmp0_safe_receiver = findAnyOf($this$DelimitedRangesSequence, $delimitersList, currentIndex, $ignoreCase, false);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.text.rangesDelimitedBy.<anonymous>.<anonymous>' call
        tmp = to(tmp0_safe_receiver.dh_1, tmp0_safe_receiver.eh_1.length);
      }
      return tmp;
    };
  }
  function MatchNamedGroupCollection() {
  }
  function _Duration___init__impl__kdtzql(rawValue) {
    // Inline function 'kotlin.time.durationAssertionsEnabled' call
    if (true) {
      if (isInNanos(rawValue)) {
        var containsArg = _get_value__a43j40_0(rawValue);
        if (!((new Long(387905, -1073741824)).d1(containsArg) <= 0 ? containsArg.d1(new Long(-387905, 1073741823)) <= 0 : false))
          throw AssertionError_init_$Create$_1(_get_value__a43j40_0(rawValue).toString() + ' ns is out of nanoseconds range');
      } else {
        var containsArg_0 = _get_value__a43j40_0(rawValue);
        if (!((new Long(1, -1073741824)).d1(containsArg_0) <= 0 ? containsArg_0.d1(new Long(-1, 1073741823)) <= 0 : false))
          throw AssertionError_init_$Create$_1(_get_value__a43j40_0(rawValue).toString() + ' ms is out of milliseconds range');
        var containsArg_1 = _get_value__a43j40_0(rawValue);
        if ((new Long(1108857478, -1074)).d1(containsArg_1) <= 0 ? containsArg_1.d1(new Long(-1108857478, 1073)) <= 0 : false)
          throw AssertionError_init_$Create$_1(_get_value__a43j40_0(rawValue).toString() + ' ms is denormalized');
      }
    }
    return rawValue;
  }
  function _get_rawValue__5zfu4e($this) {
    return $this;
  }
  function _get_value__a43j40_0($this) {
    return _get_rawValue__5zfu4e($this).s3(1);
  }
  function isInNanos($this) {
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    return (_get_rawValue__5zfu4e($this).z3() & 1) === 0;
  }
  function isInMillis($this) {
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    return (_get_rawValue__5zfu4e($this).z3() & 1) === 1;
  }
  function _get_storageUnit__szjgha($this) {
    return isInNanos($this) ? DurationUnit_NANOSECONDS_getInstance() : DurationUnit_MILLISECONDS_getInstance();
  }
  function Companion_16() {
    Companion_instance_16 = this;
    this.ff_1 = _Duration___init__impl__kdtzql(new Long(0, 0));
    this.gf_1 = durationOfMillis(new Long(-1, 1073741823));
    this.hf_1 = durationOfMillis(new Long(1, -1073741824));
  }
  protoOf(Companion_16).jl = function (value) {
    var tmp;
    try {
      tmp = parseDuration(value, true);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throw IllegalArgumentException_init_$Create$_1("Invalid ISO duration string format: '" + value + "'.", e);
      } else {
        throw $p;
      }
    }
    return tmp;
  };
  var Companion_instance_16;
  function Companion_getInstance_16() {
    if (Companion_instance_16 == null)
      new Companion_16();
    return Companion_instance_16;
  }
  function Duration__unaryMinus_impl_x2k1y0($this) {
    var tmp = _get_value__a43j40_0($this).p3();
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    var tmp$ret$0 = _get_rawValue__5zfu4e($this).z3() & 1;
    return durationOf(tmp, tmp$ret$0);
  }
  function Duration__plus_impl_yu9v8f($this, other) {
    if (Duration__isInfinite_impl_tsn9y3($this)) {
      if (Duration__isFinite_impl_rzjsps(other) || _get_rawValue__5zfu4e($this).w3(_get_rawValue__5zfu4e(other)).d1(new Long(0, 0)) >= 0)
        return $this;
      else
        throw IllegalArgumentException_init_$Create$_0('Summing infinite durations of different signs yields an undefined result.');
    } else if (Duration__isInfinite_impl_tsn9y3(other))
      return other;
    var tmp;
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    var tmp_0 = _get_rawValue__5zfu4e($this).z3() & 1;
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    if (tmp_0 === (_get_rawValue__5zfu4e(other).z3() & 1)) {
      var result = _get_value__a43j40_0($this).i3(_get_value__a43j40_0(other));
      tmp = isInNanos($this) ? durationOfNanosNormalized(result) : durationOfMillisNormalized(result);
    } else {
      if (isInMillis($this)) {
        tmp = addValuesMixedRanges($this, _get_value__a43j40_0($this), _get_value__a43j40_0(other));
      } else {
        tmp = addValuesMixedRanges($this, _get_value__a43j40_0(other), _get_value__a43j40_0($this));
      }
    }
    return tmp;
  }
  function addValuesMixedRanges($this, thisMillis, otherNanos) {
    var otherMillis = nanosToMillis(otherNanos);
    var resultMillis = thisMillis.i3(otherMillis);
    var tmp;
    if ((new Long(1108857478, -1074)).d1(resultMillis) <= 0 ? resultMillis.d1(new Long(-1108857478, 1073)) <= 0 : false) {
      var otherNanoRemainder = otherNanos.j3(millisToNanos(otherMillis));
      tmp = durationOfNanos(millisToNanos(resultMillis).i3(otherNanoRemainder));
    } else {
      tmp = durationOfMillis(coerceIn(resultMillis, new Long(1, -1073741824), new Long(-1, 1073741823)));
    }
    return tmp;
  }
  function Duration__isNegative_impl_pbysfa($this) {
    return _get_rawValue__5zfu4e($this).d1(new Long(0, 0)) < 0;
  }
  function Duration__isInfinite_impl_tsn9y3($this) {
    return _get_rawValue__5zfu4e($this).equals(_get_rawValue__5zfu4e(Companion_getInstance_16().gf_1)) || _get_rawValue__5zfu4e($this).equals(_get_rawValue__5zfu4e(Companion_getInstance_16().hf_1));
  }
  function Duration__isFinite_impl_rzjsps($this) {
    return !Duration__isInfinite_impl_tsn9y3($this);
  }
  function _Duration___get_absoluteValue__impl__vr7i6w($this) {
    return Duration__isNegative_impl_pbysfa($this) ? Duration__unaryMinus_impl_x2k1y0($this) : $this;
  }
  function Duration__compareTo_impl_pchp0f($this, other) {
    var compareBits = _get_rawValue__5zfu4e($this).w3(_get_rawValue__5zfu4e(other));
    if (compareBits.d1(new Long(0, 0)) < 0 || (compareBits.z3() & 1) === 0)
      return _get_rawValue__5zfu4e($this).d1(_get_rawValue__5zfu4e(other));
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    var tmp = _get_rawValue__5zfu4e($this).z3() & 1;
    // Inline function 'kotlin.time.Duration.unitDiscriminator' call
    var r = tmp - (_get_rawValue__5zfu4e(other).z3() & 1) | 0;
    return Duration__isNegative_impl_pbysfa($this) ? -r | 0 : r;
  }
  function Duration__compareTo_impl_pchp0f_0($this, other) {
    return Duration__compareTo_impl_pchp0f($this.ef_1, other instanceof Duration ? other.ef_1 : THROW_CCE());
  }
  function _Duration___get_hoursComponent__impl__7hllxa($this) {
    var tmp;
    if (Duration__isInfinite_impl_tsn9y3($this)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.Long.rem' call
      tmp = _Duration___get_inWholeHours__impl__kb9f3j($this).m3(toLong(24)).z3();
    }
    return tmp;
  }
  function _Duration___get_minutesComponent__impl__ctvd8u($this) {
    var tmp;
    if (Duration__isInfinite_impl_tsn9y3($this)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.Long.rem' call
      tmp = _Duration___get_inWholeMinutes__impl__dognoh($this).m3(toLong(60)).z3();
    }
    return tmp;
  }
  function _Duration___get_secondsComponent__impl__if34a6($this) {
    var tmp;
    if (Duration__isInfinite_impl_tsn9y3($this)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.Long.rem' call
      tmp = _Duration___get_inWholeSeconds__impl__hpy7b3($this).m3(toLong(60)).z3();
    }
    return tmp;
  }
  function _Duration___get_nanosecondsComponent__impl__nh19kq($this) {
    var tmp;
    if (Duration__isInfinite_impl_tsn9y3($this)) {
      tmp = 0;
    } else if (isInMillis($this)) {
      // Inline function 'kotlin.Long.rem' call
      var tmp$ret$0 = _get_value__a43j40_0($this).m3(toLong(1000));
      tmp = millisToNanos(tmp$ret$0).z3();
    } else {
      var tmp2 = _get_value__a43j40_0($this);
      // Inline function 'kotlin.Long.rem' call
      var other = 1000000000;
      tmp = tmp2.m3(toLong(other)).z3();
    }
    return tmp;
  }
  function Duration__toDouble_impl_a56y2b($this, unit) {
    var tmp0_subject = _get_rawValue__5zfu4e($this);
    var tmp;
    if (tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_16().gf_1))) {
      tmp = Infinity;
    } else if (tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_16().hf_1))) {
      tmp = -Infinity;
    } else {
      tmp = convertDurationUnit(_get_value__a43j40_0($this).a4(), _get_storageUnit__szjgha($this), unit);
    }
    return tmp;
  }
  function Duration__toLong_impl_shr43i($this, unit) {
    var tmp0_subject = _get_rawValue__5zfu4e($this);
    return tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_16().gf_1)) ? new Long(-1, 2147483647) : tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_16().hf_1)) ? new Long(0, -2147483648) : convertDurationUnit_0(_get_value__a43j40_0($this), _get_storageUnit__szjgha($this), unit);
  }
  function _Duration___get_inWholeDays__impl__7bvpxz($this) {
    return Duration__toLong_impl_shr43i($this, DurationUnit_DAYS_getInstance());
  }
  function _Duration___get_inWholeHours__impl__kb9f3j($this) {
    return Duration__toLong_impl_shr43i($this, DurationUnit_HOURS_getInstance());
  }
  function _Duration___get_inWholeMinutes__impl__dognoh($this) {
    return Duration__toLong_impl_shr43i($this, DurationUnit_MINUTES_getInstance());
  }
  function _Duration___get_inWholeSeconds__impl__hpy7b3($this) {
    return Duration__toLong_impl_shr43i($this, DurationUnit_SECONDS_getInstance());
  }
  function _Duration___get_inWholeMilliseconds__impl__msfiry($this) {
    return isInMillis($this) && Duration__isFinite_impl_rzjsps($this) ? _get_value__a43j40_0($this) : Duration__toLong_impl_shr43i($this, DurationUnit_MILLISECONDS_getInstance());
  }
  function Duration__toString_impl_8d916b($this) {
    var tmp0_subject = _get_rawValue__5zfu4e($this);
    var tmp;
    if (tmp0_subject.equals(new Long(0, 0))) {
      tmp = '0s';
    } else if (tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_16().gf_1))) {
      tmp = 'Infinity';
    } else if (tmp0_subject.equals(_get_rawValue__5zfu4e(Companion_getInstance_16().hf_1))) {
      tmp = '-Infinity';
    } else {
      var isNegative = Duration__isNegative_impl_pbysfa($this);
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$_1();
      // Inline function 'kotlin.time.Duration.toString.<anonymous>' call
      if (isNegative) {
        this_0.e9(_Char___init__impl__6a9atx(45));
      }
      // Inline function 'kotlin.time.Duration.toComponents' call
      var this_1 = _Duration___get_absoluteValue__impl__vr7i6w($this);
      var tmp1 = _Duration___get_inWholeDays__impl__7bvpxz(this_1);
      var tmp2 = _Duration___get_hoursComponent__impl__7hllxa(this_1);
      var tmp3 = _Duration___get_minutesComponent__impl__ctvd8u(this_1);
      var tmp4 = _Duration___get_secondsComponent__impl__if34a6(this_1);
      // Inline function 'kotlin.time.Duration.toString.<anonymous>.<anonymous>' call
      var nanoseconds = _Duration___get_nanosecondsComponent__impl__nh19kq(this_1);
      var hasDays = !tmp1.equals(new Long(0, 0));
      var hasHours = !(tmp2 === 0);
      var hasMinutes = !(tmp3 === 0);
      var hasSeconds = !(tmp4 === 0) || !(nanoseconds === 0);
      var components = 0;
      if (hasDays) {
        this_0.bd(tmp1).e9(_Char___init__impl__6a9atx(100));
        components = components + 1 | 0;
      }
      if (hasHours || (hasDays && (hasMinutes || hasSeconds))) {
        var _unary__edvuaz = components;
        components = _unary__edvuaz + 1 | 0;
        if (_unary__edvuaz > 0) {
          this_0.e9(_Char___init__impl__6a9atx(32));
        }
        this_0.ad(tmp2).e9(_Char___init__impl__6a9atx(104));
      }
      if (hasMinutes || (hasSeconds && (hasHours || hasDays))) {
        var _unary__edvuaz_0 = components;
        components = _unary__edvuaz_0 + 1 | 0;
        if (_unary__edvuaz_0 > 0) {
          this_0.e9(_Char___init__impl__6a9atx(32));
        }
        this_0.ad(tmp3).e9(_Char___init__impl__6a9atx(109));
      }
      if (hasSeconds) {
        var _unary__edvuaz_1 = components;
        components = _unary__edvuaz_1 + 1 | 0;
        if (_unary__edvuaz_1 > 0) {
          this_0.e9(_Char___init__impl__6a9atx(32));
        }
        if (!(tmp4 === 0) || hasDays || hasHours || hasMinutes) {
          appendFractional(this_0, $this, tmp4, nanoseconds, 9, 's', false);
        } else if (nanoseconds >= 1000000) {
          appendFractional(this_0, $this, nanoseconds / 1000000 | 0, nanoseconds % 1000000 | 0, 6, 'ms', false);
        } else if (nanoseconds >= 1000) {
          appendFractional(this_0, $this, nanoseconds / 1000 | 0, nanoseconds % 1000 | 0, 3, 'us', false);
        } else
          this_0.ad(nanoseconds).d9('ns');
      }
      if (isNegative && components > 1) {
        this_0.cd(1, _Char___init__impl__6a9atx(40)).e9(_Char___init__impl__6a9atx(41));
      }
      tmp = this_0.toString();
    }
    return tmp;
  }
  function appendFractional(_this__u8e3s4, $this, whole, fractional, fractionalSize, unit, isoZeroes) {
    _this__u8e3s4.ad(whole);
    if (!(fractional === 0)) {
      _this__u8e3s4.e9(_Char___init__impl__6a9atx(46));
      var fracString = padStart(fractional.toString(), fractionalSize, _Char___init__impl__6a9atx(48));
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.text.indexOfLast' call
        var inductionVariable = charSequenceLength(fracString) - 1 | 0;
        if (0 <= inductionVariable)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            // Inline function 'kotlin.time.Duration.appendFractional.<anonymous>' call
            if (!(charSequenceGet(fracString, index) === _Char___init__impl__6a9atx(48))) {
              tmp$ret$1 = index;
              break $l$block;
            }
          }
           while (0 <= inductionVariable);
        tmp$ret$1 = -1;
      }
      var nonZeroDigits = tmp$ret$1 + 1 | 0;
      if (!isoZeroes && nonZeroDigits < 3) {
        // Inline function 'kotlin.text.appendRange' call
        _this__u8e3s4.zc(fracString, 0, nonZeroDigits);
      } else {
        // Inline function 'kotlin.text.appendRange' call
        var endIndex = imul((nonZeroDigits + 2 | 0) / 3 | 0, 3);
        _this__u8e3s4.zc(fracString, 0, endIndex);
      }
    }
    _this__u8e3s4.d9(unit);
  }
  function Duration__toString_impl_8d916b_0($this, unit, decimals) {
    // Inline function 'kotlin.require' call
    if (!(decimals >= 0)) {
      // Inline function 'kotlin.time.Duration.toString.<anonymous>' call
      var message = 'decimals must be not negative, but was ' + decimals;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var number = Duration__toDouble_impl_a56y2b($this, unit);
    if (isInfinite(number))
      return number.toString();
    return formatToExactDecimals(number, coerceAtMost(decimals, 12)) + shortName(unit);
  }
  function Duration__toIsoString_impl_9h6wsm($this) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'kotlin.time.Duration.toIsoString.<anonymous>' call
    if (Duration__isNegative_impl_pbysfa($this)) {
      this_0.e9(_Char___init__impl__6a9atx(45));
    }
    this_0.d9('PT');
    // Inline function 'kotlin.time.Duration.toComponents' call
    var this_1 = _Duration___get_absoluteValue__impl__vr7i6w($this);
    var tmp1 = _Duration___get_inWholeHours__impl__kb9f3j(this_1);
    var tmp2 = _Duration___get_minutesComponent__impl__ctvd8u(this_1);
    var tmp3 = _Duration___get_secondsComponent__impl__if34a6(this_1);
    // Inline function 'kotlin.time.Duration.toIsoString.<anonymous>.<anonymous>' call
    var nanoseconds = _Duration___get_nanosecondsComponent__impl__nh19kq(this_1);
    var hours = tmp1;
    if (Duration__isInfinite_impl_tsn9y3($this)) {
      hours = new Long(1316134911, 2328);
    }
    var hasHours = !hours.equals(new Long(0, 0));
    var hasSeconds = !(tmp3 === 0) || !(nanoseconds === 0);
    var hasMinutes = !(tmp2 === 0) || (hasSeconds && hasHours);
    if (hasHours) {
      this_0.bd(hours).e9(_Char___init__impl__6a9atx(72));
    }
    if (hasMinutes) {
      this_0.ad(tmp2).e9(_Char___init__impl__6a9atx(77));
    }
    if (hasSeconds || (!hasHours && !hasMinutes)) {
      appendFractional(this_0, $this, tmp3, nanoseconds, 9, 'S', true);
    }
    return this_0.toString();
  }
  function Duration__hashCode_impl_u4exz6($this) {
    return $this.hashCode();
  }
  function Duration__equals_impl_ygj6w6($this, other) {
    if (!(other instanceof Duration))
      return false;
    var tmp0_other_with_cast = other instanceof Duration ? other.ef_1 : THROW_CCE();
    if (!$this.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function Duration(rawValue) {
    Companion_getInstance_16();
    this.ef_1 = rawValue;
  }
  protoOf(Duration).kl = function (other) {
    return Duration__compareTo_impl_pchp0f(this.ef_1, other);
  };
  protoOf(Duration).d = function (other) {
    return Duration__compareTo_impl_pchp0f_0(this, other);
  };
  protoOf(Duration).toString = function () {
    return Duration__toString_impl_8d916b(this.ef_1);
  };
  protoOf(Duration).hashCode = function () {
    return Duration__hashCode_impl_u4exz6(this.ef_1);
  };
  protoOf(Duration).equals = function (other) {
    return Duration__equals_impl_ygj6w6(this.ef_1, other);
  };
  function durationOfMillis(normalMillis) {
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = normalMillis.r3(1).i3(toLong(1));
    return _Duration___init__impl__kdtzql(tmp$ret$0);
  }
  function toDuration(_this__u8e3s4, unit) {
    var tmp;
    if (unit.d3(DurationUnit_SECONDS_getInstance()) <= 0) {
      tmp = durationOfNanos(convertDurationUnitOverflow(toLong(_this__u8e3s4), unit, DurationUnit_NANOSECONDS_getInstance()));
    } else {
      tmp = toDuration_0(toLong(_this__u8e3s4), unit);
    }
    return tmp;
  }
  function toDuration_0(_this__u8e3s4, unit) {
    var maxNsInUnit = convertDurationUnitOverflow(new Long(-387905, 1073741823), DurationUnit_NANOSECONDS_getInstance(), unit);
    if (maxNsInUnit.p3().d1(_this__u8e3s4) <= 0 ? _this__u8e3s4.d1(maxNsInUnit) <= 0 : false) {
      return durationOfNanos(convertDurationUnitOverflow(_this__u8e3s4, unit, DurationUnit_NANOSECONDS_getInstance()));
    } else {
      var millis = convertDurationUnit_0(_this__u8e3s4, unit, DurationUnit_MILLISECONDS_getInstance());
      return durationOfMillis(coerceIn(millis, new Long(1, -1073741824), new Long(-1, 1073741823)));
    }
  }
  function toDuration_1(_this__u8e3s4, unit) {
    var valueInNs = convertDurationUnit(_this__u8e3s4, unit, DurationUnit_NANOSECONDS_getInstance());
    // Inline function 'kotlin.require' call
    if (!!isNaN_0(valueInNs)) {
      // Inline function 'kotlin.time.toDuration.<anonymous>' call
      var message = 'Duration value cannot be NaN.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var nanos = roundToLong(valueInNs);
    var tmp;
    if ((new Long(387905, -1073741824)).d1(nanos) <= 0 ? nanos.d1(new Long(-387905, 1073741823)) <= 0 : false) {
      tmp = durationOfNanos(nanos);
    } else {
      var millis = roundToLong(convertDurationUnit(_this__u8e3s4, unit, DurationUnit_MILLISECONDS_getInstance()));
      tmp = durationOfMillisNormalized(millis);
    }
    return tmp;
  }
  function parseDuration(value, strictIso) {
    var length = value.length;
    if (length === 0)
      throw IllegalArgumentException_init_$Create$_0('The string is empty');
    var index = 0;
    var result = Companion_getInstance_16().ff_1;
    var infinityString = 'Infinity';
    var tmp0_subject = charSequenceGet(value, index);
    if (tmp0_subject === _Char___init__impl__6a9atx(43) || tmp0_subject === _Char___init__impl__6a9atx(45)) {
      index = index + 1 | 0;
    }
    var hasSign = index > 0;
    var isNegative = hasSign && startsWith_1(value, _Char___init__impl__6a9atx(45));
    if (length <= index)
      throw IllegalArgumentException_init_$Create$_0('No components');
    else {
      if (charSequenceGet(value, index) === _Char___init__impl__6a9atx(80)) {
        index = index + 1 | 0;
        if (index === length)
          throw IllegalArgumentException_init_$Create$();
        var nonDigitSymbols = '+-.';
        var isTimeComponent = false;
        var prevUnit = null;
        $l$loop: while (index < length) {
          if (charSequenceGet(value, index) === _Char___init__impl__6a9atx(84)) {
            var tmp;
            if (isTimeComponent) {
              tmp = true;
            } else {
              index = index + 1 | 0;
              tmp = index === length;
            }
            if (tmp)
              throw IllegalArgumentException_init_$Create$();
            isTimeComponent = true;
            continue $l$loop;
          }
          // Inline function 'kotlin.time.substringWhile' call
          var startIndex = index;
          // Inline function 'kotlin.time.skipWhile' call
          var i = startIndex;
          $l$loop_0: while (true) {
            var tmp_0;
            if (i < value.length) {
              // Inline function 'kotlin.time.parseDuration.<anonymous>' call
              var it = charSequenceGet(value, i);
              tmp_0 = (_Char___init__impl__6a9atx(48) <= it ? it <= _Char___init__impl__6a9atx(57) : false) || contains_8(nonDigitSymbols, it);
            } else {
              tmp_0 = false;
            }
            if (!tmp_0) {
              break $l$loop_0;
            }
            i = i + 1 | 0;
          }
          // Inline function 'kotlin.text.substring' call
          var endIndex = i;
          // Inline function 'kotlin.js.asDynamic' call
          var component = value.substring(startIndex, endIndex);
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(component) === 0)
            throw IllegalArgumentException_init_$Create$();
          index = index + component.length | 0;
          // Inline function 'kotlin.text.getOrElse' call
          var index_0 = index;
          var tmp_1;
          if (0 <= index_0 ? index_0 <= (charSequenceLength(value) - 1 | 0) : false) {
            tmp_1 = charSequenceGet(value, index_0);
          } else {
            throw IllegalArgumentException_init_$Create$_0('Missing unit for value ' + component);
          }
          var unitChar = tmp_1;
          index = index + 1 | 0;
          var unit = durationUnitByIsoChar(unitChar, isTimeComponent);
          if (!(prevUnit == null) && prevUnit.d3(unit) <= 0)
            throw IllegalArgumentException_init_$Create$_0('Unexpected order of duration components');
          prevUnit = unit;
          var dotIndex = indexOf_8(component, _Char___init__impl__6a9atx(46));
          if (unit.equals(DurationUnit_SECONDS_getInstance()) && dotIndex > 0) {
            // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            var whole = component.substring(0, dotIndex);
            result = Duration__plus_impl_yu9v8f(result, toDuration_0(parseOverLongIsoComponent(whole), unit));
            var tmp_2 = result;
            // Inline function 'kotlin.text.substring' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$10 = component.substring(dotIndex);
            result = Duration__plus_impl_yu9v8f(tmp_2, toDuration_1(toDouble(tmp$ret$10), unit));
          } else {
            result = Duration__plus_impl_yu9v8f(result, toDuration_0(parseOverLongIsoComponent(component), unit));
          }
        }
      } else {
        if (strictIso)
          throw IllegalArgumentException_init_$Create$();
        else {
          var tmp_3 = index;
          var tmp12 = length - index | 0;
          // Inline function 'kotlin.comparisons.maxOf' call
          var b = infinityString.length;
          var tmp$ret$11 = Math.max(tmp12, b);
          if (regionMatches(value, tmp_3, infinityString, 0, tmp$ret$11, true)) {
            result = Companion_getInstance_16().gf_1;
          } else {
            var prevUnit_0 = null;
            var afterFirst = false;
            var allowSpaces = !hasSign;
            if (hasSign && charSequenceGet(value, index) === _Char___init__impl__6a9atx(40) && last_2(value) === _Char___init__impl__6a9atx(41)) {
              allowSpaces = true;
              index = index + 1 | 0;
              var tmp_4 = index;
              length = length - 1 | 0;
              if (tmp_4 === length)
                throw IllegalArgumentException_init_$Create$_0('No components');
            }
            while (index < length) {
              if (afterFirst && allowSpaces) {
                // Inline function 'kotlin.time.skipWhile' call
                var i_0 = index;
                $l$loop_1: while (true) {
                  var tmp_5;
                  if (i_0 < value.length) {
                    // Inline function 'kotlin.time.parseDuration.<anonymous>' call
                    tmp_5 = charSequenceGet(value, i_0) === _Char___init__impl__6a9atx(32);
                  } else {
                    tmp_5 = false;
                  }
                  if (!tmp_5) {
                    break $l$loop_1;
                  }
                  i_0 = i_0 + 1 | 0;
                }
                index = i_0;
              }
              afterFirst = true;
              // Inline function 'kotlin.time.substringWhile' call
              var startIndex_0 = index;
              // Inline function 'kotlin.time.skipWhile' call
              var i_1 = startIndex_0;
              $l$loop_2: while (true) {
                var tmp_6;
                if (i_1 < value.length) {
                  // Inline function 'kotlin.time.parseDuration.<anonymous>' call
                  var it_0 = charSequenceGet(value, i_1);
                  tmp_6 = (_Char___init__impl__6a9atx(48) <= it_0 ? it_0 <= _Char___init__impl__6a9atx(57) : false) || it_0 === _Char___init__impl__6a9atx(46);
                } else {
                  tmp_6 = false;
                }
                if (!tmp_6) {
                  break $l$loop_2;
                }
                i_1 = i_1 + 1 | 0;
              }
              // Inline function 'kotlin.text.substring' call
              var endIndex_0 = i_1;
              // Inline function 'kotlin.js.asDynamic' call
              var component_0 = value.substring(startIndex_0, endIndex_0);
              // Inline function 'kotlin.text.isEmpty' call
              if (charSequenceLength(component_0) === 0)
                throw IllegalArgumentException_init_$Create$();
              index = index + component_0.length | 0;
              // Inline function 'kotlin.time.substringWhile' call
              var startIndex_1 = index;
              // Inline function 'kotlin.time.skipWhile' call
              var i_2 = startIndex_1;
              $l$loop_3: while (true) {
                var tmp_7;
                if (i_2 < value.length) {
                  // Inline function 'kotlin.time.parseDuration.<anonymous>' call
                  var it_1 = charSequenceGet(value, i_2);
                  tmp_7 = _Char___init__impl__6a9atx(97) <= it_1 ? it_1 <= _Char___init__impl__6a9atx(122) : false;
                } else {
                  tmp_7 = false;
                }
                if (!tmp_7) {
                  break $l$loop_3;
                }
                i_2 = i_2 + 1 | 0;
              }
              // Inline function 'kotlin.text.substring' call
              var endIndex_1 = i_2;
              // Inline function 'kotlin.js.asDynamic' call
              var unitName = value.substring(startIndex_1, endIndex_1);
              index = index + unitName.length | 0;
              var unit_0 = durationUnitByShortName(unitName);
              if (!(prevUnit_0 == null) && prevUnit_0.d3(unit_0) <= 0)
                throw IllegalArgumentException_init_$Create$_0('Unexpected order of duration components');
              prevUnit_0 = unit_0;
              var dotIndex_0 = indexOf_8(component_0, _Char___init__impl__6a9atx(46));
              if (dotIndex_0 > 0) {
                // Inline function 'kotlin.text.substring' call
                // Inline function 'kotlin.js.asDynamic' call
                var whole_0 = component_0.substring(0, dotIndex_0);
                result = Duration__plus_impl_yu9v8f(result, toDuration_0(toLong_1(whole_0), unit_0));
                var tmp_8 = result;
                // Inline function 'kotlin.text.substring' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$28 = component_0.substring(dotIndex_0);
                result = Duration__plus_impl_yu9v8f(tmp_8, toDuration_1(toDouble(tmp$ret$28), unit_0));
                if (index < length)
                  throw IllegalArgumentException_init_$Create$_0('Fractional component must be last');
              } else {
                result = Duration__plus_impl_yu9v8f(result, toDuration_0(toLong_1(component_0), unit_0));
              }
            }
          }
        }
      }
    }
    return isNegative ? Duration__unaryMinus_impl_x2k1y0(result) : result;
  }
  function durationOf(normalValue, unitDiscriminator) {
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = normalValue.r3(1).i3(toLong(unitDiscriminator));
    return _Duration___init__impl__kdtzql(tmp$ret$0);
  }
  function durationOfNanosNormalized(nanos) {
    var tmp;
    if ((new Long(387905, -1073741824)).d1(nanos) <= 0 ? nanos.d1(new Long(-387905, 1073741823)) <= 0 : false) {
      tmp = durationOfNanos(nanos);
    } else {
      tmp = durationOfMillis(nanosToMillis(nanos));
    }
    return tmp;
  }
  function durationOfMillisNormalized(millis) {
    var tmp;
    if ((new Long(1108857478, -1074)).d1(millis) <= 0 ? millis.d1(new Long(-1108857478, 1073)) <= 0 : false) {
      tmp = durationOfNanos(millisToNanos(millis));
    } else {
      tmp = durationOfMillis(coerceIn(millis, new Long(1, -1073741824), new Long(-1, 1073741823)));
    }
    return tmp;
  }
  function nanosToMillis(nanos) {
    // Inline function 'kotlin.Long.div' call
    return nanos.l3(toLong(1000000));
  }
  function millisToNanos(millis) {
    // Inline function 'kotlin.Long.times' call
    return millis.k3(toLong(1000000));
  }
  function durationOfNanos(normalNanos) {
    return _Duration___init__impl__kdtzql(normalNanos.r3(1));
  }
  function parseOverLongIsoComponent(value) {
    var length = value.length;
    var startIndex = 0;
    if (length > 0 && contains_8('+-', charSequenceGet(value, 0))) {
      startIndex = startIndex + 1 | 0;
    }
    var tmp;
    if ((length - startIndex | 0) > 16) {
      var tmp0 = numberRangeToNumber(startIndex, get_lastIndex_3(value));
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var tmp_0;
        if (isInterface(tmp0, Collection)) {
          tmp_0 = tmp0.p();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
        var inductionVariable = tmp0.e1_1;
        var last = tmp0.f1_1;
        if (inductionVariable <= last)
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.time.parseOverLongIsoComponent.<anonymous>' call
            var it = element;
            var containsArg = charSequenceGet(value, it);
            if (!(_Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
           while (!(element === last));
        tmp$ret$0 = true;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    if (tmp) {
      return charSequenceGet(value, 0) === _Char___init__impl__6a9atx(45) ? new Long(0, -2147483648) : new Long(-1, 2147483647);
    }
    return startsWith(value, '+') ? toLong_1(drop_0(value, 1)) : toLong_1(value);
  }
  function shortName(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.a3_1) {
      case 0:
        tmp = 'ns';
        break;
      case 1:
        tmp = 'us';
        break;
      case 2:
        tmp = 'ms';
        break;
      case 3:
        tmp = 's';
        break;
      case 4:
        tmp = 'm';
        break;
      case 5:
        tmp = 'h';
        break;
      case 6:
        tmp = 'd';
        break;
      default:
        var message = 'Unknown unit: ' + _this__u8e3s4.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return tmp;
  }
  function durationUnitByIsoChar(isoChar, isTimeComponent) {
    var tmp;
    if (!isTimeComponent) {
      var tmp_0;
      if (isoChar === _Char___init__impl__6a9atx(68)) {
        tmp_0 = DurationUnit_DAYS_getInstance();
      } else {
        throw IllegalArgumentException_init_$Create$_0('Invalid or unsupported duration ISO non-time unit: ' + toString(isoChar));
      }
      tmp = tmp_0;
    } else {
      var tmp_1;
      if (isoChar === _Char___init__impl__6a9atx(72)) {
        tmp_1 = DurationUnit_HOURS_getInstance();
      } else if (isoChar === _Char___init__impl__6a9atx(77)) {
        tmp_1 = DurationUnit_MINUTES_getInstance();
      } else if (isoChar === _Char___init__impl__6a9atx(83)) {
        tmp_1 = DurationUnit_SECONDS_getInstance();
      } else {
        throw IllegalArgumentException_init_$Create$_0('Invalid duration ISO time unit: ' + toString(isoChar));
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function durationUnitByShortName(shortName) {
    var tmp;
    switch (shortName) {
      case 'ns':
        tmp = DurationUnit_NANOSECONDS_getInstance();
        break;
      case 'us':
        tmp = DurationUnit_MICROSECONDS_getInstance();
        break;
      case 'ms':
        tmp = DurationUnit_MILLISECONDS_getInstance();
        break;
      case 's':
        tmp = DurationUnit_SECONDS_getInstance();
        break;
      case 'm':
        tmp = DurationUnit_MINUTES_getInstance();
        break;
      case 'h':
        tmp = DurationUnit_HOURS_getInstance();
        break;
      case 'd':
        tmp = DurationUnit_DAYS_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('Unknown duration unit short name: ' + shortName);
    }
    return tmp;
  }
  function _ValueTimeMark___init__impl__uyfl2m(reading) {
    return reading;
  }
  function _ValueTimeMark___get_reading__impl__5qz8rd($this) {
    return $this;
  }
  function ValueTimeMark__elapsedNow_impl_eonqvs($this) {
    return MonotonicTimeSource_getInstance().af($this);
  }
  function ValueTimeMark__minus_impl_f87sko($this, other) {
    if (!(other instanceof ValueTimeMark))
      throw IllegalArgumentException_init_$Create$_0('Subtracting or comparing time marks from different time sources is not possible: ' + ValueTimeMark__toString_impl_ow3ax6($this) + ' and ' + toString_1(other));
    return ValueTimeMark__minus_impl_f87sko_0($this, other.ll_1);
  }
  function ValueTimeMark__minus_impl_f87sko_0($this, other) {
    return MonotonicTimeSource_getInstance().bf($this, other);
  }
  function ValueTimeMark__toString_impl_ow3ax6($this) {
    return 'ValueTimeMark(reading=' + toString_1($this) + ')';
  }
  function ValueTimeMark__hashCode_impl_oduu93($this) {
    return hashCode($this);
  }
  function ValueTimeMark__equals_impl_uc54jh($this, other) {
    if (!(other instanceof ValueTimeMark))
      return false;
    var tmp0_other_with_cast = other instanceof ValueTimeMark ? other.ll_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ValueTimeMark__compareTo_impl_uoccns($this, other) {
    return $this.ml((!(other == null) ? isInterface(other, ComparableTimeMark) : false) ? other : THROW_CCE());
  }
  function ValueTimeMark(reading) {
    this.ll_1 = reading;
  }
  protoOf(ValueTimeMark).nl = function (other) {
    return ValueTimeMark__minus_impl_f87sko(this.ll_1, other);
  };
  protoOf(ValueTimeMark).toString = function () {
    return ValueTimeMark__toString_impl_ow3ax6(this.ll_1);
  };
  protoOf(ValueTimeMark).hashCode = function () {
    return ValueTimeMark__hashCode_impl_oduu93(this.ll_1);
  };
  protoOf(ValueTimeMark).equals = function (other) {
    return ValueTimeMark__equals_impl_uc54jh(this.ll_1, other);
  };
  protoOf(ValueTimeMark).d = function (other) {
    return ValueTimeMark__compareTo_impl_uoccns(this, other);
  };
  function Monotonic() {
  }
  protoOf(Monotonic).ye = function () {
    return MonotonicTimeSource_getInstance().ye();
  };
  protoOf(Monotonic).toString = function () {
    return toString_1(MonotonicTimeSource_getInstance());
  };
  var Monotonic_instance;
  function Monotonic_getInstance() {
    return Monotonic_instance;
  }
  function ComparableTimeMark() {
  }
  function TimedValue(value, duration) {
    this.ol_1 = value;
    this.pl_1 = duration;
  }
  protoOf(TimedValue).ug = function () {
    return this.ol_1;
  };
  protoOf(TimedValue).ql = function () {
    return this.pl_1;
  };
  protoOf(TimedValue).toString = function () {
    return 'TimedValue(value=' + toString_0(this.ol_1) + ', duration=' + Duration__toString_impl_8d916b(this.pl_1) + ')';
  };
  protoOf(TimedValue).hashCode = function () {
    var result = this.ol_1 == null ? 0 : hashCode(this.ol_1);
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.pl_1) | 0;
    return result;
  };
  protoOf(TimedValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TimedValue))
      return false;
    var tmp0_other_with_cast = other instanceof TimedValue ? other : THROW_CCE();
    if (!equals(this.ol_1, tmp0_other_with_cast.ol_1))
      return false;
    if (!equals(this.pl_1, tmp0_other_with_cast.pl_1))
      return false;
    return true;
  };
  function get_UNDEFINED_RESULT() {
    _init_properties_DeepRecursive_kt__zbwcac();
    return UNDEFINED_RESULT;
  }
  var UNDEFINED_RESULT;
  function DeepRecursiveScope() {
  }
  function invoke_4(_this__u8e3s4, value) {
    _init_properties_DeepRecursive_kt__zbwcac();
    return (new DeepRecursiveScopeImpl(_this__u8e3s4.sl_1, value)).xl();
  }
  function DeepRecursiveFunction(block) {
    this.sl_1 = block;
  }
  function DeepRecursiveScopeImpl(block, value) {
    DeepRecursiveScope.call(this);
    var tmp = this;
    tmp.tl_1 = isSuspendFunction(block, 2) ? block : THROW_CCE();
    this.ul_1 = value;
    var tmp_0 = this;
    tmp_0.vl_1 = isInterface(this, Continuation) ? this : THROW_CCE();
    this.wl_1 = get_UNDEFINED_RESULT();
  }
  protoOf(DeepRecursiveScopeImpl).ea = function () {
    return EmptyCoroutineContext_getInstance();
  };
  protoOf(DeepRecursiveScopeImpl).yl = function (result) {
    this.vl_1 = null;
    this.wl_1 = result;
  };
  protoOf(DeepRecursiveScopeImpl).ja = function (result) {
    return this.yl(result);
  };
  protoOf(DeepRecursiveScopeImpl).rl = function (value, $completion) {
    // Inline function 'kotlin.DeepRecursiveScopeImpl.callRecursive.<anonymous>' call
    var tmp = this;
    tmp.vl_1 = isInterface($completion, Continuation) ? $completion : THROW_CCE();
    this.ul_1 = value;
    return get_COROUTINE_SUSPENDED();
  };
  protoOf(DeepRecursiveScopeImpl).xl = function () {
    $l$loop: while (true) {
      var result = this.wl_1;
      var tmp0_elvis_lhs = this.vl_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.getOrThrow' call
        var this_0 = new Result(result) instanceof Result ? result : THROW_CCE();
        throwOnFailure(this_0);
        var tmp_0 = _Result___get_value__impl__bjfvqg(this_0);
        return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var cont = tmp;
      if (equals(get_UNDEFINED_RESULT(), result)) {
        var tmp_1;
        try {
          var tmp1 = this.tl_1;
          // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
          var param = this.ul_1;
          tmp_1 = startCoroutineUninterceptedOrReturnNonGeneratorVersion_0(tmp1, this, param, cont);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var e = $p;
            // Inline function 'kotlin.coroutines.resumeWithException' call
            // Inline function 'kotlin.Companion.failure' call
            var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(e));
            cont.ja(tmp$ret$2);
            continue $l$loop;
          } else {
            throw $p;
          }
        }
        var r = tmp_1;
        if (!(r === get_COROUTINE_SUSPENDED())) {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = (r == null ? true : !(r == null)) ? r : THROW_CCE();
          var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
          cont.ja(tmp$ret$4);
        }
      } else {
        this.wl_1 = get_UNDEFINED_RESULT();
        cont.ja(result);
      }
    }
  };
  var properties_initialized_DeepRecursive_kt_5z0al2;
  function _init_properties_DeepRecursive_kt__zbwcac() {
    if (!properties_initialized_DeepRecursive_kt_5z0al2) {
      properties_initialized_DeepRecursive_kt_5z0al2 = true;
      // Inline function 'kotlin.Companion.success' call
      var value = get_COROUTINE_SUSPENDED();
      UNDEFINED_RESULT = _Result___init__impl__xyqfz8(value);
    }
  }
  var LazyThreadSafetyMode_SYNCHRONIZED_instance;
  var LazyThreadSafetyMode_PUBLICATION_instance;
  var LazyThreadSafetyMode_NONE_instance;
  var LazyThreadSafetyMode_entriesInitialized;
  function LazyThreadSafetyMode_initEntries() {
    if (LazyThreadSafetyMode_entriesInitialized)
      return Unit_instance;
    LazyThreadSafetyMode_entriesInitialized = true;
    LazyThreadSafetyMode_SYNCHRONIZED_instance = new LazyThreadSafetyMode('SYNCHRONIZED', 0);
    LazyThreadSafetyMode_PUBLICATION_instance = new LazyThreadSafetyMode('PUBLICATION', 1);
    LazyThreadSafetyMode_NONE_instance = new LazyThreadSafetyMode('NONE', 2);
  }
  function LazyThreadSafetyMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function UnsafeLazyImpl(initializer) {
    this.zl_1 = initializer;
    this.am_1 = UNINITIALIZED_VALUE_instance;
  }
  protoOf(UnsafeLazyImpl).y = function () {
    if (this.am_1 === UNINITIALIZED_VALUE_instance) {
      this.am_1 = ensureNotNull(this.zl_1)();
      this.zl_1 = null;
    }
    var tmp = this.am_1;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(UnsafeLazyImpl).bm = function () {
    return !(this.am_1 === UNINITIALIZED_VALUE_instance);
  };
  protoOf(UnsafeLazyImpl).toString = function () {
    return this.bm() ? toString_0(this.y()) : 'Lazy value not initialized yet.';
  };
  function UNINITIALIZED_VALUE() {
  }
  var UNINITIALIZED_VALUE_instance;
  function UNINITIALIZED_VALUE_getInstance() {
    return UNINITIALIZED_VALUE_instance;
  }
  function LazyThreadSafetyMode_PUBLICATION_getInstance() {
    LazyThreadSafetyMode_initEntries();
    return LazyThreadSafetyMode_PUBLICATION_instance;
  }
  function LazyThreadSafetyMode_NONE_getInstance() {
    LazyThreadSafetyMode_initEntries();
    return LazyThreadSafetyMode_NONE_instance;
  }
  function _Result___init__impl__xyqfz8(value) {
    return value;
  }
  function _Result___get_value__impl__bjfvqg($this) {
    return $this;
  }
  function _Result___get_isSuccess__impl__sndoy8($this) {
    var tmp = _Result___get_value__impl__bjfvqg($this);
    return !(tmp instanceof Failure);
  }
  function _Result___get_isFailure__impl__jpiriv($this) {
    var tmp = _Result___get_value__impl__bjfvqg($this);
    return tmp instanceof Failure;
  }
  function Result__exceptionOrNull_impl_p6xea9($this) {
    var tmp;
    if (_Result___get_value__impl__bjfvqg($this) instanceof Failure) {
      tmp = _Result___get_value__impl__bjfvqg($this).cm_1;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function Result__toString_impl_yu5r8k($this) {
    var tmp;
    if (_Result___get_value__impl__bjfvqg($this) instanceof Failure) {
      tmp = _Result___get_value__impl__bjfvqg($this).toString();
    } else {
      tmp = 'Success(' + toString_0(_Result___get_value__impl__bjfvqg($this)) + ')';
    }
    return tmp;
  }
  function Companion_17() {
  }
  var Companion_instance_17;
  function Companion_getInstance_17() {
    return Companion_instance_17;
  }
  function Failure(exception) {
    this.cm_1 = exception;
  }
  protoOf(Failure).equals = function (other) {
    var tmp;
    if (other instanceof Failure) {
      tmp = equals(this.cm_1, other.cm_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Failure).hashCode = function () {
    return hashCode(this.cm_1);
  };
  protoOf(Failure).toString = function () {
    return 'Failure(' + this.cm_1.toString() + ')';
  };
  function Result__hashCode_impl_d2zufp($this) {
    return $this == null ? 0 : hashCode($this);
  }
  function Result__equals_impl_bxgmep($this, other) {
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other.dm_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function Result(value) {
    this.dm_1 = value;
  }
  protoOf(Result).toString = function () {
    return Result__toString_impl_yu5r8k(this.dm_1);
  };
  protoOf(Result).hashCode = function () {
    return Result__hashCode_impl_d2zufp(this.dm_1);
  };
  protoOf(Result).equals = function (other) {
    return Result__equals_impl_bxgmep(this.dm_1, other);
  };
  function createFailure(exception) {
    return new Failure(exception);
  }
  function throwOnFailure(_this__u8e3s4) {
    var tmp = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
    if (tmp instanceof Failure)
      throw _Result___get_value__impl__bjfvqg(_this__u8e3s4).cm_1;
  }
  function NotImplementedError(message) {
    message = message === VOID ? 'An operation is not implemented.' : message;
    Error_init_$Init$_0(message, this);
    captureStack(this, NotImplementedError);
  }
  function Pair(first, second) {
    this.dh_1 = first;
    this.eh_1 = second;
  }
  protoOf(Pair).toString = function () {
    return '(' + toString_0(this.dh_1) + ', ' + toString_0(this.eh_1) + ')';
  };
  protoOf(Pair).ug = function () {
    return this.dh_1;
  };
  protoOf(Pair).vg = function () {
    return this.eh_1;
  };
  protoOf(Pair).hashCode = function () {
    var result = this.dh_1 == null ? 0 : hashCode(this.dh_1);
    result = imul(result, 31) + (this.eh_1 == null ? 0 : hashCode(this.eh_1)) | 0;
    return result;
  };
  protoOf(Pair).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Pair))
      return false;
    var tmp0_other_with_cast = other instanceof Pair ? other : THROW_CCE();
    if (!equals(this.dh_1, tmp0_other_with_cast.dh_1))
      return false;
    if (!equals(this.eh_1, tmp0_other_with_cast.eh_1))
      return false;
    return true;
  };
  function Triple(first, second, third) {
    this.em_1 = first;
    this.fm_1 = second;
    this.gm_1 = third;
  }
  protoOf(Triple).toString = function () {
    return '(' + toString_0(this.em_1) + ', ' + toString_0(this.fm_1) + ', ' + toString_0(this.gm_1) + ')';
  };
  protoOf(Triple).ug = function () {
    return this.em_1;
  };
  protoOf(Triple).vg = function () {
    return this.fm_1;
  };
  protoOf(Triple).hm = function () {
    return this.gm_1;
  };
  protoOf(Triple).hashCode = function () {
    var result = this.em_1 == null ? 0 : hashCode(this.em_1);
    result = imul(result, 31) + (this.fm_1 == null ? 0 : hashCode(this.fm_1)) | 0;
    result = imul(result, 31) + (this.gm_1 == null ? 0 : hashCode(this.gm_1)) | 0;
    return result;
  };
  protoOf(Triple).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Triple))
      return false;
    var tmp0_other_with_cast = other instanceof Triple ? other : THROW_CCE();
    if (!equals(this.em_1, tmp0_other_with_cast.em_1))
      return false;
    if (!equals(this.fm_1, tmp0_other_with_cast.fm_1))
      return false;
    if (!equals(this.gm_1, tmp0_other_with_cast.gm_1))
      return false;
    return true;
  };
  function to(_this__u8e3s4, that) {
    return new Pair(_this__u8e3s4, that);
  }
  function _UByte___init__impl__g9hnc4(data) {
    return data;
  }
  function _UByte___get_data__impl__jof9qr($this) {
    return $this;
  }
  function Companion_18() {
    Companion_instance_18 = this;
    this.im_1 = _UByte___init__impl__g9hnc4(0);
    this.jm_1 = _UByte___init__impl__g9hnc4(-1);
    this.km_1 = 1;
    this.lm_1 = 8;
  }
  var Companion_instance_18;
  function Companion_getInstance_18() {
    if (Companion_instance_18 == null)
      new Companion_18();
    return Companion_instance_18;
  }
  function UByte__compareTo_impl_5w5192($this, other) {
    // Inline function 'kotlin.UByte.toInt' call
    var tmp = _UByte___get_data__impl__jof9qr($this) & 255;
    // Inline function 'kotlin.UByte.toInt' call
    var tmp$ret$1 = _UByte___get_data__impl__jof9qr(other) & 255;
    return compareTo_0(tmp, tmp$ret$1);
  }
  function UByte__compareTo_impl_5w5192_0($this, other) {
    return UByte__compareTo_impl_5w5192($this.mm_1, other instanceof UByte ? other.mm_1 : THROW_CCE());
  }
  function UByte__toString_impl_v72jg($this) {
    // Inline function 'kotlin.UByte.toInt' call
    return (_UByte___get_data__impl__jof9qr($this) & 255).toString();
  }
  function UByte__hashCode_impl_mmczcb($this) {
    return $this;
  }
  function UByte__equals_impl_nvqtsf($this, other) {
    if (!(other instanceof UByte))
      return false;
    if (!($this === (other instanceof UByte ? other.mm_1 : THROW_CCE())))
      return false;
    return true;
  }
  function UByte(data) {
    Companion_getInstance_18();
    this.mm_1 = data;
  }
  protoOf(UByte).nm = function (other) {
    return UByte__compareTo_impl_5w5192(this.mm_1, other);
  };
  protoOf(UByte).d = function (other) {
    return UByte__compareTo_impl_5w5192_0(this, other);
  };
  protoOf(UByte).toString = function () {
    return UByte__toString_impl_v72jg(this.mm_1);
  };
  protoOf(UByte).hashCode = function () {
    return UByte__hashCode_impl_mmczcb(this.mm_1);
  };
  protoOf(UByte).equals = function (other) {
    return UByte__equals_impl_nvqtsf(this.mm_1, other);
  };
  function _UByteArray___init__impl__ip4y9n(storage) {
    return storage;
  }
  function _UByteArray___get_storage__impl__d4kctt($this) {
    return $this;
  }
  function _UByteArray___init__impl__ip4y9n_0(size) {
    return _UByteArray___init__impl__ip4y9n(new Int8Array(size));
  }
  function UByteArray__get_impl_t5f3hv($this, index) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = _UByteArray___get_storage__impl__d4kctt($this)[index];
    return _UByte___init__impl__g9hnc4(this_0);
  }
  function UByteArray__set_impl_jvcicn($this, index, value) {
    var tmp = _UByteArray___get_storage__impl__d4kctt($this);
    // Inline function 'kotlin.UByte.toByte' call
    tmp[index] = _UByte___get_data__impl__jof9qr(value);
  }
  function _UByteArray___get_size__impl__h6pkdv($this) {
    return _UByteArray___get_storage__impl__d4kctt($this).length;
  }
  function UByteArray__iterator_impl_509y1p($this) {
    return new Iterator(_UByteArray___get_storage__impl__d4kctt($this));
  }
  function Iterator(array) {
    this.om_1 = array;
    this.pm_1 = 0;
  }
  protoOf(Iterator).l = function () {
    return this.pm_1 < this.om_1.length;
  };
  protoOf(Iterator).qm = function () {
    var tmp;
    if (this.pm_1 < this.om_1.length) {
      var _unary__edvuaz = this.pm_1;
      this.pm_1 = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.toUByte' call
      var this_0 = this.om_1[_unary__edvuaz];
      tmp = _UByte___init__impl__g9hnc4(this_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this.pm_1.toString());
    }
    return tmp;
  };
  protoOf(Iterator).m = function () {
    return new UByte(this.qm());
  };
  function UByteArray__contains_impl_njh19q($this, element) {
    var tmp = _UByteArray___get_storage__impl__d4kctt($this);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(element);
    return contains_3(tmp, tmp$ret$0);
  }
  function UByteArray__contains_impl_njh19q_0($this, element) {
    if (!(element instanceof UByte))
      return false;
    return UByteArray__contains_impl_njh19q($this.rm_1, element instanceof UByte ? element.mm_1 : THROW_CCE());
  }
  function UByteArray__containsAll_impl_v9s6dj($this, elements) {
    var tmp0 = isInterface(elements, Collection) ? elements : THROW_CCE();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlin.UByteArray.containsAll.<anonymous>' call
        var tmp_0;
        if (element instanceof UByte) {
          var tmp_1 = _UByteArray___get_storage__impl__d4kctt($this);
          // Inline function 'kotlin.UByte.toByte' call
          var this_0 = element.mm_1;
          var tmp$ret$1 = _UByte___get_data__impl__jof9qr(this_0);
          tmp_0 = contains_3(tmp_1, tmp$ret$1);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  function UByteArray__containsAll_impl_v9s6dj_0($this, elements) {
    return UByteArray__containsAll_impl_v9s6dj($this.rm_1, elements);
  }
  function UByteArray__isEmpty_impl_nbfqsa($this) {
    return _UByteArray___get_storage__impl__d4kctt($this).length === 0;
  }
  function UByteArray__toString_impl_ukpl97($this) {
    return 'UByteArray(storage=' + toString_1($this) + ')';
  }
  function UByteArray__hashCode_impl_ip8jx2($this) {
    return hashCode($this);
  }
  function UByteArray__equals_impl_roka4u($this, other) {
    if (!(other instanceof UByteArray))
      return false;
    var tmp0_other_with_cast = other instanceof UByteArray ? other.rm_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function UByteArray(storage) {
    this.rm_1 = storage;
  }
  protoOf(UByteArray).n = function () {
    return _UByteArray___get_size__impl__h6pkdv(this.rm_1);
  };
  protoOf(UByteArray).k = function () {
    return UByteArray__iterator_impl_509y1p(this.rm_1);
  };
  protoOf(UByteArray).sm = function (element) {
    return UByteArray__contains_impl_njh19q(this.rm_1, element);
  };
  protoOf(UByteArray).s = function (element) {
    return UByteArray__contains_impl_njh19q_0(this, element);
  };
  protoOf(UByteArray).tm = function (elements) {
    return UByteArray__containsAll_impl_v9s6dj(this.rm_1, elements);
  };
  protoOf(UByteArray).h2 = function (elements) {
    return UByteArray__containsAll_impl_v9s6dj_0(this, elements);
  };
  protoOf(UByteArray).p = function () {
    return UByteArray__isEmpty_impl_nbfqsa(this.rm_1);
  };
  protoOf(UByteArray).toString = function () {
    return UByteArray__toString_impl_ukpl97(this.rm_1);
  };
  protoOf(UByteArray).hashCode = function () {
    return UByteArray__hashCode_impl_ip8jx2(this.rm_1);
  };
  protoOf(UByteArray).equals = function (other) {
    return UByteArray__equals_impl_roka4u(this.rm_1, other);
  };
  function _UInt___init__impl__l7qpdl(data) {
    return data;
  }
  function _UInt___get_data__impl__f0vqqw($this) {
    return $this;
  }
  function Companion_19() {
    Companion_instance_19 = this;
    this.um_1 = _UInt___init__impl__l7qpdl(0);
    this.vm_1 = _UInt___init__impl__l7qpdl(-1);
    this.wm_1 = 4;
    this.xm_1 = 32;
  }
  var Companion_instance_19;
  function Companion_getInstance_19() {
    if (Companion_instance_19 == null)
      new Companion_19();
    return Companion_instance_19;
  }
  function UInt__compareTo_impl_yacclj($this, other) {
    return uintCompare(_UInt___get_data__impl__f0vqqw($this), _UInt___get_data__impl__f0vqqw(other));
  }
  function UInt__compareTo_impl_yacclj_0($this, other) {
    return UInt__compareTo_impl_yacclj($this.ym_1, other instanceof UInt ? other.ym_1 : THROW_CCE());
  }
  function UInt__toString_impl_dbgl21($this) {
    // Inline function 'kotlin.uintToString' call
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw($this);
    return toLong(value).u3(new Long(-1, 0)).toString();
  }
  function UInt__hashCode_impl_z2mhuw($this) {
    return $this;
  }
  function UInt__equals_impl_ffdoxg($this, other) {
    if (!(other instanceof UInt))
      return false;
    if (!($this === (other instanceof UInt ? other.ym_1 : THROW_CCE())))
      return false;
    return true;
  }
  function UInt(data) {
    Companion_getInstance_19();
    this.ym_1 = data;
  }
  protoOf(UInt).zm = function (other) {
    return UInt__compareTo_impl_yacclj(this.ym_1, other);
  };
  protoOf(UInt).d = function (other) {
    return UInt__compareTo_impl_yacclj_0(this, other);
  };
  protoOf(UInt).toString = function () {
    return UInt__toString_impl_dbgl21(this.ym_1);
  };
  protoOf(UInt).hashCode = function () {
    return UInt__hashCode_impl_z2mhuw(this.ym_1);
  };
  protoOf(UInt).equals = function (other) {
    return UInt__equals_impl_ffdoxg(this.ym_1, other);
  };
  function _UIntArray___init__impl__ghjpc6(storage) {
    return storage;
  }
  function _UIntArray___get_storage__impl__92a0v0($this) {
    return $this;
  }
  function _UIntArray___init__impl__ghjpc6_0(size) {
    return _UIntArray___init__impl__ghjpc6(new Int32Array(size));
  }
  function UIntArray__get_impl_gp5kza($this, index) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = _UIntArray___get_storage__impl__92a0v0($this)[index];
    return _UInt___init__impl__l7qpdl(this_0);
  }
  function UIntArray__set_impl_7f2zu2($this, index, value) {
    var tmp = _UIntArray___get_storage__impl__92a0v0($this);
    // Inline function 'kotlin.UInt.toInt' call
    tmp[index] = _UInt___get_data__impl__f0vqqw(value);
  }
  function _UIntArray___get_size__impl__r6l8ci($this) {
    return _UIntArray___get_storage__impl__92a0v0($this).length;
  }
  function UIntArray__iterator_impl_tkdv7k($this) {
    return new Iterator_0(_UIntArray___get_storage__impl__92a0v0($this));
  }
  function Iterator_0(array) {
    this.an_1 = array;
    this.bn_1 = 0;
  }
  protoOf(Iterator_0).l = function () {
    return this.bn_1 < this.an_1.length;
  };
  protoOf(Iterator_0).cn = function () {
    var tmp;
    if (this.bn_1 < this.an_1.length) {
      var _unary__edvuaz = this.bn_1;
      this.bn_1 = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.toUInt' call
      var this_0 = this.an_1[_unary__edvuaz];
      tmp = _UInt___init__impl__l7qpdl(this_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this.bn_1.toString());
    }
    return tmp;
  };
  protoOf(Iterator_0).m = function () {
    return new UInt(this.cn());
  };
  function UIntArray__contains_impl_b16rzj($this, element) {
    var tmp = _UIntArray___get_storage__impl__92a0v0($this);
    // Inline function 'kotlin.UInt.toInt' call
    var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(element);
    return contains_2(tmp, tmp$ret$0);
  }
  function UIntArray__contains_impl_b16rzj_0($this, element) {
    if (!(element instanceof UInt))
      return false;
    return UIntArray__contains_impl_b16rzj($this.dn_1, element instanceof UInt ? element.ym_1 : THROW_CCE());
  }
  function UIntArray__containsAll_impl_414g22($this, elements) {
    var tmp0 = isInterface(elements, Collection) ? elements : THROW_CCE();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlin.UIntArray.containsAll.<anonymous>' call
        var tmp_0;
        if (element instanceof UInt) {
          var tmp_1 = _UIntArray___get_storage__impl__92a0v0($this);
          // Inline function 'kotlin.UInt.toInt' call
          var this_0 = element.ym_1;
          var tmp$ret$1 = _UInt___get_data__impl__f0vqqw(this_0);
          tmp_0 = contains_2(tmp_1, tmp$ret$1);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  function UIntArray__containsAll_impl_414g22_0($this, elements) {
    return UIntArray__containsAll_impl_414g22($this.dn_1, elements);
  }
  function UIntArray__isEmpty_impl_vd8j4n($this) {
    return _UIntArray___get_storage__impl__92a0v0($this).length === 0;
  }
  function UIntArray__toString_impl_3zy802($this) {
    return 'UIntArray(storage=' + toString_1($this) + ')';
  }
  function UIntArray__hashCode_impl_hr7ost($this) {
    return hashCode($this);
  }
  function UIntArray__equals_impl_flcmof($this, other) {
    if (!(other instanceof UIntArray))
      return false;
    var tmp0_other_with_cast = other instanceof UIntArray ? other.dn_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function UIntArray(storage) {
    this.dn_1 = storage;
  }
  protoOf(UIntArray).n = function () {
    return _UIntArray___get_size__impl__r6l8ci(this.dn_1);
  };
  protoOf(UIntArray).k = function () {
    return UIntArray__iterator_impl_tkdv7k(this.dn_1);
  };
  protoOf(UIntArray).en = function (element) {
    return UIntArray__contains_impl_b16rzj(this.dn_1, element);
  };
  protoOf(UIntArray).s = function (element) {
    return UIntArray__contains_impl_b16rzj_0(this, element);
  };
  protoOf(UIntArray).fn = function (elements) {
    return UIntArray__containsAll_impl_414g22(this.dn_1, elements);
  };
  protoOf(UIntArray).h2 = function (elements) {
    return UIntArray__containsAll_impl_414g22_0(this, elements);
  };
  protoOf(UIntArray).p = function () {
    return UIntArray__isEmpty_impl_vd8j4n(this.dn_1);
  };
  protoOf(UIntArray).toString = function () {
    return UIntArray__toString_impl_3zy802(this.dn_1);
  };
  protoOf(UIntArray).hashCode = function () {
    return UIntArray__hashCode_impl_hr7ost(this.dn_1);
  };
  protoOf(UIntArray).equals = function (other) {
    return UIntArray__equals_impl_flcmof(this.dn_1, other);
  };
  function _ULong___init__impl__c78o9k(data) {
    return data;
  }
  function _ULong___get_data__impl__fggpzb($this) {
    return $this;
  }
  function Companion_20() {
    Companion_instance_20 = this;
    this.gn_1 = _ULong___init__impl__c78o9k(new Long(0, 0));
    this.hn_1 = _ULong___init__impl__c78o9k(new Long(-1, -1));
    this.in_1 = 8;
    this.jn_1 = 64;
  }
  var Companion_instance_20;
  function Companion_getInstance_20() {
    if (Companion_instance_20 == null)
      new Companion_20();
    return Companion_instance_20;
  }
  function ULong__compareTo_impl_38i7tu($this, other) {
    return ulongCompare(_ULong___get_data__impl__fggpzb($this), _ULong___get_data__impl__fggpzb(other));
  }
  function ULong__compareTo_impl_38i7tu_0($this, other) {
    return ULong__compareTo_impl_38i7tu($this.s1_1, other instanceof ULong ? other.s1_1 : THROW_CCE());
  }
  function ULong__toString_impl_f9au7k($this) {
    // Inline function 'kotlin.ulongToString' call
    var value = _ULong___get_data__impl__fggpzb($this);
    return ulongToString(value, 10);
  }
  function ULong__hashCode_impl_6hv2lb($this) {
    return $this.hashCode();
  }
  function ULong__equals_impl_o0gnyb($this, other) {
    if (!(other instanceof ULong))
      return false;
    var tmp0_other_with_cast = other instanceof ULong ? other.s1_1 : THROW_CCE();
    if (!$this.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function ULong(data) {
    Companion_getInstance_20();
    this.s1_1 = data;
  }
  protoOf(ULong).kn = function (other) {
    return ULong__compareTo_impl_38i7tu(this.s1_1, other);
  };
  protoOf(ULong).d = function (other) {
    return ULong__compareTo_impl_38i7tu_0(this, other);
  };
  protoOf(ULong).toString = function () {
    return ULong__toString_impl_f9au7k(this.s1_1);
  };
  protoOf(ULong).hashCode = function () {
    return ULong__hashCode_impl_6hv2lb(this.s1_1);
  };
  protoOf(ULong).equals = function (other) {
    return ULong__equals_impl_o0gnyb(this.s1_1, other);
  };
  function _ULongArray___init__impl__twm1l3(storage) {
    return storage;
  }
  function _ULongArray___get_storage__impl__28e64j($this) {
    return $this;
  }
  function _ULongArray___init__impl__twm1l3_0(size) {
    return _ULongArray___init__impl__twm1l3(longArray(size));
  }
  function ULongArray__get_impl_pr71q9($this, index) {
    // Inline function 'kotlin.toULong' call
    var this_0 = _ULongArray___get_storage__impl__28e64j($this)[index];
    return _ULong___init__impl__c78o9k(this_0);
  }
  function ULongArray__set_impl_z19mvh($this, index, value) {
    var tmp = _ULongArray___get_storage__impl__28e64j($this);
    // Inline function 'kotlin.ULong.toLong' call
    tmp[index] = _ULong___get_data__impl__fggpzb(value);
  }
  function _ULongArray___get_size__impl__ju6dtr($this) {
    return _ULongArray___get_storage__impl__28e64j($this).length;
  }
  function ULongArray__iterator_impl_cq4d2h($this) {
    return new Iterator_1(_ULongArray___get_storage__impl__28e64j($this));
  }
  function Iterator_1(array) {
    this.ln_1 = array;
    this.mn_1 = 0;
  }
  protoOf(Iterator_1).l = function () {
    return this.mn_1 < this.ln_1.length;
  };
  protoOf(Iterator_1).nn = function () {
    var tmp;
    if (this.mn_1 < this.ln_1.length) {
      var _unary__edvuaz = this.mn_1;
      this.mn_1 = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.toULong' call
      var this_0 = this.ln_1[_unary__edvuaz];
      tmp = _ULong___init__impl__c78o9k(this_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this.mn_1.toString());
    }
    return tmp;
  };
  protoOf(Iterator_1).m = function () {
    return new ULong(this.nn());
  };
  function ULongArray__contains_impl_v9bgai($this, element) {
    var tmp = _ULongArray___get_storage__impl__28e64j($this);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(element);
    return contains_1(tmp, tmp$ret$0);
  }
  function ULongArray__contains_impl_v9bgai_0($this, element) {
    if (!(element instanceof ULong))
      return false;
    return ULongArray__contains_impl_v9bgai($this.on_1, element instanceof ULong ? element.s1_1 : THROW_CCE());
  }
  function ULongArray__containsAll_impl_xx8ztf($this, elements) {
    var tmp0 = isInterface(elements, Collection) ? elements : THROW_CCE();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlin.ULongArray.containsAll.<anonymous>' call
        var tmp_0;
        if (element instanceof ULong) {
          var tmp_1 = _ULongArray___get_storage__impl__28e64j($this);
          // Inline function 'kotlin.ULong.toLong' call
          var this_0 = element.s1_1;
          var tmp$ret$1 = _ULong___get_data__impl__fggpzb(this_0);
          tmp_0 = contains_1(tmp_1, tmp$ret$1);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  function ULongArray__containsAll_impl_xx8ztf_0($this, elements) {
    return ULongArray__containsAll_impl_xx8ztf($this.on_1, elements);
  }
  function ULongArray__isEmpty_impl_c3yngu($this) {
    return _ULongArray___get_storage__impl__28e64j($this).length === 0;
  }
  function ULongArray__toString_impl_wqk1p5($this) {
    return 'ULongArray(storage=' + toString_1($this) + ')';
  }
  function ULongArray__hashCode_impl_aze4wa($this) {
    return hashCode($this);
  }
  function ULongArray__equals_impl_vwitwa($this, other) {
    if (!(other instanceof ULongArray))
      return false;
    var tmp0_other_with_cast = other instanceof ULongArray ? other.on_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ULongArray(storage) {
    this.on_1 = storage;
  }
  protoOf(ULongArray).n = function () {
    return _ULongArray___get_size__impl__ju6dtr(this.on_1);
  };
  protoOf(ULongArray).k = function () {
    return ULongArray__iterator_impl_cq4d2h(this.on_1);
  };
  protoOf(ULongArray).v4 = function (element) {
    return ULongArray__contains_impl_v9bgai(this.on_1, element);
  };
  protoOf(ULongArray).s = function (element) {
    return ULongArray__contains_impl_v9bgai_0(this, element);
  };
  protoOf(ULongArray).pn = function (elements) {
    return ULongArray__containsAll_impl_xx8ztf(this.on_1, elements);
  };
  protoOf(ULongArray).h2 = function (elements) {
    return ULongArray__containsAll_impl_xx8ztf_0(this, elements);
  };
  protoOf(ULongArray).p = function () {
    return ULongArray__isEmpty_impl_c3yngu(this.on_1);
  };
  protoOf(ULongArray).toString = function () {
    return ULongArray__toString_impl_wqk1p5(this.on_1);
  };
  protoOf(ULongArray).hashCode = function () {
    return ULongArray__hashCode_impl_aze4wa(this.on_1);
  };
  protoOf(ULongArray).equals = function (other) {
    return ULongArray__equals_impl_vwitwa(this.on_1, other);
  };
  function _UShort___init__impl__jigrne(data) {
    return data;
  }
  function _UShort___get_data__impl__g0245($this) {
    return $this;
  }
  function Companion_21() {
    Companion_instance_21 = this;
    this.qn_1 = _UShort___init__impl__jigrne(0);
    this.rn_1 = _UShort___init__impl__jigrne(-1);
    this.sn_1 = 2;
    this.tn_1 = 16;
  }
  var Companion_instance_21;
  function Companion_getInstance_21() {
    if (Companion_instance_21 == null)
      new Companion_21();
    return Companion_instance_21;
  }
  function UShort__compareTo_impl_1pfgyc($this, other) {
    // Inline function 'kotlin.UShort.toInt' call
    var tmp = _UShort___get_data__impl__g0245($this) & 65535;
    // Inline function 'kotlin.UShort.toInt' call
    var tmp$ret$1 = _UShort___get_data__impl__g0245(other) & 65535;
    return compareTo_0(tmp, tmp$ret$1);
  }
  function UShort__compareTo_impl_1pfgyc_0($this, other) {
    return UShort__compareTo_impl_1pfgyc($this.un_1, other instanceof UShort ? other.un_1 : THROW_CCE());
  }
  function UShort__toString_impl_edaoee($this) {
    // Inline function 'kotlin.UShort.toInt' call
    return (_UShort___get_data__impl__g0245($this) & 65535).toString();
  }
  function UShort__hashCode_impl_ywngrv($this) {
    return $this;
  }
  function UShort__equals_impl_7t9pdz($this, other) {
    if (!(other instanceof UShort))
      return false;
    if (!($this === (other instanceof UShort ? other.un_1 : THROW_CCE())))
      return false;
    return true;
  }
  function UShort(data) {
    Companion_getInstance_21();
    this.un_1 = data;
  }
  protoOf(UShort).vn = function (other) {
    return UShort__compareTo_impl_1pfgyc(this.un_1, other);
  };
  protoOf(UShort).d = function (other) {
    return UShort__compareTo_impl_1pfgyc_0(this, other);
  };
  protoOf(UShort).toString = function () {
    return UShort__toString_impl_edaoee(this.un_1);
  };
  protoOf(UShort).hashCode = function () {
    return UShort__hashCode_impl_ywngrv(this.un_1);
  };
  protoOf(UShort).equals = function (other) {
    return UShort__equals_impl_7t9pdz(this.un_1, other);
  };
  function _UShortArray___init__impl__9b26ef(storage) {
    return storage;
  }
  function _UShortArray___get_storage__impl__t2jpv5($this) {
    return $this;
  }
  function _UShortArray___init__impl__9b26ef_0(size) {
    return _UShortArray___init__impl__9b26ef(new Int16Array(size));
  }
  function UShortArray__get_impl_fnbhmx($this, index) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = _UShortArray___get_storage__impl__t2jpv5($this)[index];
    return _UShort___init__impl__jigrne(this_0);
  }
  function UShortArray__set_impl_6d8whp($this, index, value) {
    var tmp = _UShortArray___get_storage__impl__t2jpv5($this);
    // Inline function 'kotlin.UShort.toShort' call
    tmp[index] = _UShort___get_data__impl__g0245(value);
  }
  function _UShortArray___get_size__impl__jqto1b($this) {
    return _UShortArray___get_storage__impl__t2jpv5($this).length;
  }
  function UShortArray__iterator_impl_ktpenn($this) {
    return new Iterator_2(_UShortArray___get_storage__impl__t2jpv5($this));
  }
  function Iterator_2(array) {
    this.wn_1 = array;
    this.xn_1 = 0;
  }
  protoOf(Iterator_2).l = function () {
    return this.xn_1 < this.wn_1.length;
  };
  protoOf(Iterator_2).yn = function () {
    var tmp;
    if (this.xn_1 < this.wn_1.length) {
      var _unary__edvuaz = this.xn_1;
      this.xn_1 = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.toUShort' call
      var this_0 = this.wn_1[_unary__edvuaz];
      tmp = _UShort___init__impl__jigrne(this_0);
    } else {
      throw NoSuchElementException_init_$Create$_0(this.xn_1.toString());
    }
    return tmp;
  };
  protoOf(Iterator_2).m = function () {
    return new UShort(this.yn());
  };
  function UShortArray__contains_impl_vo7k3g($this, element) {
    var tmp = _UShortArray___get_storage__impl__t2jpv5($this);
    // Inline function 'kotlin.UShort.toShort' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(element);
    return contains_4(tmp, tmp$ret$0);
  }
  function UShortArray__contains_impl_vo7k3g_0($this, element) {
    if (!(element instanceof UShort))
      return false;
    return UShortArray__contains_impl_vo7k3g($this.zn_1, element instanceof UShort ? element.un_1 : THROW_CCE());
  }
  function UShortArray__containsAll_impl_vlaaxp($this, elements) {
    var tmp0 = isInterface(elements, Collection) ? elements : THROW_CCE();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlin.UShortArray.containsAll.<anonymous>' call
        var tmp_0;
        if (element instanceof UShort) {
          var tmp_1 = _UShortArray___get_storage__impl__t2jpv5($this);
          // Inline function 'kotlin.UShort.toShort' call
          var this_0 = element.un_1;
          var tmp$ret$1 = _UShort___get_data__impl__g0245(this_0);
          tmp_0 = contains_4(tmp_1, tmp$ret$1);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  function UShortArray__containsAll_impl_vlaaxp_0($this, elements) {
    return UShortArray__containsAll_impl_vlaaxp($this.zn_1, elements);
  }
  function UShortArray__isEmpty_impl_cdd9l0($this) {
    return _UShortArray___get_storage__impl__t2jpv5($this).length === 0;
  }
  function UShortArray__toString_impl_omz03z($this) {
    return 'UShortArray(storage=' + toString_1($this) + ')';
  }
  function UShortArray__hashCode_impl_2vt3b4($this) {
    return hashCode($this);
  }
  function UShortArray__equals_impl_tyc3mk($this, other) {
    if (!(other instanceof UShortArray))
      return false;
    var tmp0_other_with_cast = other instanceof UShortArray ? other.zn_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function UShortArray(storage) {
    this.zn_1 = storage;
  }
  protoOf(UShortArray).n = function () {
    return _UShortArray___get_size__impl__jqto1b(this.zn_1);
  };
  protoOf(UShortArray).k = function () {
    return UShortArray__iterator_impl_ktpenn(this.zn_1);
  };
  protoOf(UShortArray).ao = function (element) {
    return UShortArray__contains_impl_vo7k3g(this.zn_1, element);
  };
  protoOf(UShortArray).s = function (element) {
    return UShortArray__contains_impl_vo7k3g_0(this, element);
  };
  protoOf(UShortArray).bo = function (elements) {
    return UShortArray__containsAll_impl_vlaaxp(this.zn_1, elements);
  };
  protoOf(UShortArray).h2 = function (elements) {
    return UShortArray__containsAll_impl_vlaaxp_0(this, elements);
  };
  protoOf(UShortArray).p = function () {
    return UShortArray__isEmpty_impl_cdd9l0(this.zn_1);
  };
  protoOf(UShortArray).toString = function () {
    return UShortArray__toString_impl_omz03z(this.zn_1);
  };
  protoOf(UShortArray).hashCode = function () {
    return UShortArray__hashCode_impl_2vt3b4(this.zn_1);
  };
  protoOf(UShortArray).equals = function (other) {
    return UShortArray__equals_impl_tyc3mk(this.zn_1, other);
  };
  function toString_6(_this__u8e3s4, radix) {
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(_this__u8e3s4);
    return ulongToString(tmp$ret$0, checkRadix(radix));
  }
  function toULongOrNull(_this__u8e3s4) {
    return toULongOrNull_0(_this__u8e3s4, 10);
  }
  function toUInt(_this__u8e3s4) {
    var tmp0_elvis_lhs = toUIntOrNull(_this__u8e3s4);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toULong(_this__u8e3s4) {
    var tmp0_elvis_lhs = toULongOrNull(_this__u8e3s4);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new ULong(tmp_0)) == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toUByte(_this__u8e3s4) {
    var tmp0_elvis_lhs = toUByteOrNull(_this__u8e3s4);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UByte(tmp_0)) == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toUShort(_this__u8e3s4) {
    var tmp0_elvis_lhs = toUShortOrNull(_this__u8e3s4);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UShort(tmp_0)) == null) {
      numberFormatError(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function toULongOrNull_0(_this__u8e3s4, radix) {
    checkRadix(radix);
    var length = _this__u8e3s4.length;
    if (length === 0)
      return null;
    var limit = _ULong___init__impl__c78o9k(new Long(-1, -1));
    var start;
    var firstChar = charSequenceGet(_this__u8e3s4, 0);
    if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
      if (length === 1 || !(firstChar === _Char___init__impl__6a9atx(43)))
        return null;
      start = 1;
    } else {
      start = 0;
    }
    var limitForMaxRadix = _ULong___init__impl__c78o9k(new Long(477218588, 119304647));
    var limitBeforeMul = limitForMaxRadix;
    // Inline function 'kotlin.toULong' call
    var uradix = _ULong___init__impl__c78o9k(toLong(radix));
    var result = _ULong___init__impl__c78o9k(new Long(0, 0));
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this__u8e3s4, i), radix);
        if (digit < 0)
          return null;
        var tmp1 = result;
        // Inline function 'kotlin.ULong.compareTo' call
        var other = limitBeforeMul;
        if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp1), _ULong___get_data__impl__fggpzb(other)) > 0) {
          if (equals(limitBeforeMul, limitForMaxRadix)) {
            // Inline function 'kotlin.ULong.div' call
            limitBeforeMul = ulongDivide(limit, uradix);
            var tmp5 = result;
            // Inline function 'kotlin.ULong.compareTo' call
            var other_0 = limitBeforeMul;
            if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp5), _ULong___get_data__impl__fggpzb(other_0)) > 0) {
              return null;
            }
          } else {
            return null;
          }
        }
        // Inline function 'kotlin.ULong.times' call
        var this_0 = result;
        result = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_0).k3(_ULong___get_data__impl__fggpzb(uradix)));
        var beforeAdding = result;
        var tmp10 = result;
        // Inline function 'kotlin.toUInt' call
        // Inline function 'kotlin.ULong.plus' call
        // Inline function 'kotlin.UInt.toULong' call
        var this_1 = _UInt___init__impl__l7qpdl(digit);
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value = _UInt___get_data__impl__f0vqqw(this_1);
        var tmp$ret$6 = toLong(value).u3(new Long(-1, 0));
        // Inline function 'kotlin.ULong.plus' call
        var other_1 = _ULong___init__impl__c78o9k(tmp$ret$6);
        result = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp10).i3(_ULong___get_data__impl__fggpzb(other_1)));
        // Inline function 'kotlin.ULong.compareTo' call
        var this_2 = result;
        if (ulongCompare(_ULong___get_data__impl__fggpzb(this_2), _ULong___get_data__impl__fggpzb(beforeAdding)) < 0)
          return null;
      }
       while (inductionVariable < length);
    return result;
  }
  function toUIntOrNull(_this__u8e3s4) {
    return toUIntOrNull_0(_this__u8e3s4, 10);
  }
  function toUByteOrNull(_this__u8e3s4) {
    return toUByteOrNull_0(_this__u8e3s4, 10);
  }
  function toUShortOrNull(_this__u8e3s4) {
    return toUShortOrNull_0(_this__u8e3s4, 10);
  }
  function toUIntOrNull_0(_this__u8e3s4, radix) {
    checkRadix(radix);
    var length = _this__u8e3s4.length;
    if (length === 0)
      return null;
    var limit = _UInt___init__impl__l7qpdl(-1);
    var start;
    var firstChar = charSequenceGet(_this__u8e3s4, 0);
    if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
      if (length === 1 || !(firstChar === _Char___init__impl__6a9atx(43)))
        return null;
      start = 1;
    } else {
      start = 0;
    }
    var limitForMaxRadix = _UInt___init__impl__l7qpdl(119304647);
    var limitBeforeMul = limitForMaxRadix;
    // Inline function 'kotlin.toUInt' call
    var uradix = _UInt___init__impl__l7qpdl(radix);
    var result = _UInt___init__impl__l7qpdl(0);
    var inductionVariable = start;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var digit = digitOf(charSequenceGet(_this__u8e3s4, i), radix);
        if (digit < 0)
          return null;
        var tmp1 = result;
        // Inline function 'kotlin.UInt.compareTo' call
        var other = limitBeforeMul;
        if (uintCompare(_UInt___get_data__impl__f0vqqw(tmp1), _UInt___get_data__impl__f0vqqw(other)) > 0) {
          if (limitBeforeMul === limitForMaxRadix) {
            // Inline function 'kotlin.UInt.div' call
            limitBeforeMul = uintDivide(limit, uradix);
            var tmp5 = result;
            // Inline function 'kotlin.UInt.compareTo' call
            var other_0 = limitBeforeMul;
            if (uintCompare(_UInt___get_data__impl__f0vqqw(tmp5), _UInt___get_data__impl__f0vqqw(other_0)) > 0) {
              return null;
            }
          } else {
            return null;
          }
        }
        // Inline function 'kotlin.UInt.times' call
        var this_0 = result;
        result = _UInt___init__impl__l7qpdl(imul(_UInt___get_data__impl__f0vqqw(this_0), _UInt___get_data__impl__f0vqqw(uradix)));
        var beforeAdding = result;
        var tmp10 = result;
        // Inline function 'kotlin.toUInt' call
        // Inline function 'kotlin.UInt.plus' call
        var other_1 = _UInt___init__impl__l7qpdl(digit);
        result = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp10) + _UInt___get_data__impl__f0vqqw(other_1) | 0);
        // Inline function 'kotlin.UInt.compareTo' call
        var this_1 = result;
        if (uintCompare(_UInt___get_data__impl__f0vqqw(this_1), _UInt___get_data__impl__f0vqqw(beforeAdding)) < 0)
          return null;
      }
       while (inductionVariable < length);
    return result;
  }
  function toUByteOrNull_0(_this__u8e3s4, radix) {
    var tmp0_elvis_lhs = toUIntOrNull_0(_this__u8e3s4, radix);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var int = tmp;
    // Inline function 'kotlin.UInt.compareTo' call
    // Inline function 'kotlin.UByte.toUInt' call
    var this_0 = _UByte___init__impl__g9hnc4(-1);
    // Inline function 'kotlin.UInt.compareTo' call
    var other = _UInt___init__impl__l7qpdl(_UByte___get_data__impl__jof9qr(this_0) & 255);
    if (uintCompare(_UInt___get_data__impl__f0vqqw(int), _UInt___get_data__impl__f0vqqw(other)) > 0)
      return null;
    // Inline function 'kotlin.UInt.toUByte' call
    // Inline function 'kotlin.toUByte' call
    var this_1 = _UInt___get_data__impl__f0vqqw(int);
    return _UByte___init__impl__g9hnc4(toByte(this_1));
  }
  function toUShortOrNull_0(_this__u8e3s4, radix) {
    var tmp0_elvis_lhs = toUIntOrNull_0(_this__u8e3s4, radix);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new UInt(tmp_0)) == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var int = tmp;
    // Inline function 'kotlin.UInt.compareTo' call
    // Inline function 'kotlin.UShort.toUInt' call
    var this_0 = _UShort___init__impl__jigrne(-1);
    // Inline function 'kotlin.UInt.compareTo' call
    var other = _UInt___init__impl__l7qpdl(_UShort___get_data__impl__g0245(this_0) & 65535);
    if (uintCompare(_UInt___get_data__impl__f0vqqw(int), _UInt___get_data__impl__f0vqqw(other)) > 0)
      return null;
    // Inline function 'kotlin.UInt.toUShort' call
    // Inline function 'kotlin.toUShort' call
    var this_1 = _UInt___get_data__impl__f0vqqw(int);
    return _UShort___init__impl__jigrne(toShort(this_1));
  }
  function appendText(_this__u8e3s4, text) {
    _this__u8e3s4.appendChild(ensureNotNull(_this__u8e3s4.ownerDocument).createTextNode(text));
    return _this__u8e3s4;
  }
  function Logger() {
  }
  function JSLogger() {
  }
  protoOf(JSLogger).co = function (msg, thrown) {
    return console.error(msg, thrown);
  };
  protoOf(JSLogger).eo = function (msg, thrown) {
    return console.warn(msg, thrown);
  };
  protoOf(JSLogger).go = function (msg) {
    return console.info(msg);
  };
  protoOf(JSLogger).ho = function (msg) {
    return console.log(msg);
  };
  var JSLogger_instance;
  function JSLogger_getInstance() {
    return JSLogger_instance;
  }
  function getLogger(clazz) {
    return getLogger_0(ensureNotNull(clazz.lb()));
  }
  function getLogger_0(name) {
    return JSLogger_instance;
  }
  function subListTail(_this__u8e3s4, fromIndex) {
    return _this__u8e3s4.j2(fromIndex, _this__u8e3s4.n());
  }
  function subListTail_0(_this__u8e3s4, fromIndex) {
    return _this__u8e3s4.j2(fromIndex, _this__u8e3s4.n());
  }
  function isDigit(_this__u8e3s4) {
    return _Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false;
  }
  function isLetterOrDigit(_this__u8e3s4) {
    return isLetter(_this__u8e3s4) || isDigit(_this__u8e3s4);
  }
  function isLetter(_this__u8e3s4) {
    return (_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) || (_Char___init__impl__6a9atx(65) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(90) : false);
  }
  function isInt(_this__u8e3s4) {
    return !(toIntOrNull(_this__u8e3s4) == null);
  }
  function AddAtEndSafeIterationList() {
    SafeIterationList.call(this);
  }
  protoOf(AddAtEndSafeIterationList).lo = function (item) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.mo_1.e(item);
  };
  function ListMap$keySet$1$iterator$spec$1(this$0) {
    this.xo_1 = this$0;
  }
  protoOf(ListMap$keySet$1$iterator$spec$1).q = function (index) {
    return this.xo_1.yo_1[index];
  };
  function ListMap$values$1$iterator$spec$1(this$0) {
    this.zo_1 = this$0;
  }
  protoOf(ListMap$values$1$iterator$spec$1).q = function (index) {
    return this.zo_1.yo_1[index + 1 | 0];
  };
  function ListMap$entrySet$1$iterator$spec$1(this$0) {
    this.ap_1 = this$0;
  }
  protoOf(ListMap$entrySet$1$iterator$spec$1).q = function (index) {
    return new Entry_0(this.ap_1, index);
  };
  function mapIterator($this, spec) {
    return new ListMap$mapIterator$1($this, spec);
  }
  function findByKey($this, key) {
    var i = 0;
    while (i < $this.yo_1.length) {
      var k = $this.yo_1[i];
      if (equals(key, k)) {
        return i;
      }
      i = i + 2 | 0;
    }
    return -1;
  }
  function removeAt($this, index) {
    if ($this.yo_1.length === 2) {
      $this.yo_1 = Companion_getInstance_22().bp_1;
      return Unit_instance;
    }
    var tmp = 0;
    var tmp_0 = $this.yo_1.length - 2 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp_3;
      if (tmp_2 < index) {
        tmp_3 = $this.yo_1[tmp_2];
      } else {
        tmp_3 = $this.yo_1[tmp_2 + 2 | 0];
      }
      tmp_1[tmp_2] = tmp_3;
      tmp = tmp + 1 | 0;
    }
    var newArray = tmp_1;
    $this.yo_1 = newArray;
  }
  function Entry_0($outer, index) {
    this.dp_1 = $outer;
    this.cp_1 = index;
  }
  protoOf(Entry_0).ep = function () {
    var tmp = this.dp_1.yo_1[this.cp_1];
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(Entry_0).fp = function () {
    var tmp = this.dp_1.yo_1[this.cp_1 + 1 | 0];
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  function Companion_22() {
    Companion_instance_22 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.bp_1 = [];
  }
  var Companion_instance_22;
  function Companion_getInstance_22() {
    if (Companion_instance_22 == null)
      new Companion_22();
    return Companion_instance_22;
  }
  function ListMap$keySet$1(this$0) {
    this.gp_1 = this$0;
    AbstractMutableSet.call(this);
  }
  protoOf(ListMap$keySet$1).n = function () {
    return this.gp_1.wo();
  };
  protoOf(ListMap$keySet$1).n7 = function (element) {
    throw IllegalStateException_init_$Create$_0('Not available in keySet');
  };
  protoOf(ListMap$keySet$1).e = function (element) {
    return this.n7((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ListMap$keySet$1).k = function () {
    var spec = new ListMap$keySet$1$iterator$spec$1(this.gp_1);
    return mapIterator(this.gp_1, spec);
  };
  function ListMap$values$1(this$0) {
    this.hp_1 = this$0;
    AbstractCollection.call(this);
  }
  protoOf(ListMap$values$1).n = function () {
    return this.hp_1.wo();
  };
  protoOf(ListMap$values$1).k = function () {
    var spec = new ListMap$values$1$iterator$spec$1(this.hp_1);
    return mapIterator(this.hp_1, spec);
  };
  function ListMap$entrySet$1(this$0) {
    this.ip_1 = this$0;
    AbstractSet.call(this);
  }
  protoOf(ListMap$entrySet$1).n = function () {
    return this.ip_1.wo();
  };
  protoOf(ListMap$entrySet$1).k = function () {
    var spec = new ListMap$entrySet$1$iterator$spec$1(this.ip_1);
    return mapIterator(this.ip_1, spec);
  };
  function ListMap$mapIterator$1(this$0, $spec) {
    this.lp_1 = this$0;
    this.mp_1 = $spec;
    this.jp_1 = 0;
    this.kp_1 = false;
  }
  protoOf(ListMap$mapIterator$1).l = function () {
    return this.jp_1 < this.lp_1.yo_1.length;
  };
  protoOf(ListMap$mapIterator$1).m = function () {
    if (!this.l()) {
      throw NoSuchElementException_init_$Create$();
    }
    this.kp_1 = true;
    var tmp = this.mp_1.q(this.jp_1);
    var value = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    this.jp_1 = this.jp_1 + 2 | 0;
    return value;
  };
  protoOf(ListMap$mapIterator$1).b5 = function () {
    // Inline function 'kotlin.check' call
    if (!this.kp_1) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.jp_1 = this.jp_1 - 2 | 0;
    removeAt(this.lp_1, this.jp_1);
    this.kp_1 = false;
  };
  function ListMap() {
    Companion_getInstance_22();
    this.yo_1 = Companion_getInstance_22().bp_1;
  }
  protoOf(ListMap).np = function () {
    return this.wo() === 0;
  };
  protoOf(ListMap).w2 = function (key) {
    return findByKey(this, key) >= 0;
  };
  protoOf(ListMap).s2 = function (key) {
    var index = findByKey(this, key);
    var tmp;
    if (index >= 0) {
      var value = this.yo_1[index + 1 | 0];
      removeAt(this, index);
      tmp = (value == null ? true : !(value == null)) ? value : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(ListMap).op = function () {
    return new ListMap$keySet$1(this);
  };
  protoOf(ListMap).pp = function () {
    return new ListMap$values$1(this);
  };
  protoOf(ListMap).qp = function () {
    return new ListMap$entrySet$1(this);
  };
  protoOf(ListMap).wo = function () {
    return this.yo_1.length / 2 | 0;
  };
  protoOf(ListMap).r2 = function (key, value) {
    var index = findByKey(this, key);
    if (index >= 0) {
      var oldValue = this.yo_1[index + 1 | 0];
      this.yo_1[index + 1 | 0] = value;
      return (oldValue == null ? true : !(oldValue == null)) ? oldValue : THROW_CCE();
    }
    var size = this.yo_1.length;
    var tmp = 0;
    var tmp_0 = size + 2 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = tmp_2 < size ? this.yo_1[tmp_2] : null;
      tmp = tmp + 1 | 0;
    }
    var newArray = tmp_1;
    newArray[size] = key;
    newArray[size + 1 | 0] = value;
    this.yo_1 = newArray;
    return null;
  };
  protoOf(ListMap).y2 = function (key) {
    var index = findByKey(this, key);
    var tmp;
    if (index === -1) {
      tmp = null;
    } else {
      var tmp_0 = this.yo_1[index + 1 | 0];
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(ListMap).toString = function () {
    var builder = StringBuilder_init_$Create$_1();
    builder.d9('{');
    var i = 0;
    while (i < this.yo_1.length) {
      var k = this.yo_1[i];
      var v = this.yo_1[i + 1 | 0];
      if (!(i === 0)) {
        builder.d9(',');
      }
      builder.c9(k).d9('=').c9(v);
      i = i + 2 | 0;
    }
    builder.d9('}');
    return builder.toString();
  };
  protoOf(ListMap).m2 = function () {
    this.yo_1 = Companion_getInstance_22().bp_1;
  };
  function _get_closeableIterable__v2oelp($this) {
    return new SafeIterationListIterable($this);
  }
  function addOp($this, op) {
    if ($this.no_1 == null) {
      $this.no_1 = ArrayList_init_$Create$_0(1);
    }
    ensureNotNull($this.no_1).e(op);
  }
  function itemsRemove($this, item) {
    return $this.mo_1.k2(item);
  }
  function Op(item, isAdd) {
    this.rp_1 = item;
    this.sp_1 = isAdd;
  }
  function Companion_23() {
  }
  protoOf(Companion_23).tp = function () {
    return new AddAtEndSafeIterationList();
  };
  var Companion_instance_23;
  function Companion_getInstance_23() {
    return Companion_instance_23;
  }
  function SafeIterationList() {
    this.mo_1 = ArrayList_init_$Create$_0(1);
    this.no_1 = null;
    this.oo_1 = 0;
  }
  protoOf(SafeIterationList).po = function () {
    return this.oo_1 > 0;
  };
  protoOf(SafeIterationList).qo = function (f) {
    var iterable = _get_closeableIterable__v2oelp(this);
    try {
      return f(iterable);
    }finally {
      iterable.up();
    }
  };
  protoOf(SafeIterationList).ro = function (item) {
    if (this.po()) {
      var op = new Op(item, true);
      addOp(this, op);
    } else {
      this.lo(item);
    }
  };
  protoOf(SafeIterationList).so = function (item) {
    if (this.po()) {
      var op = new Op(item, false);
      addOp(this, op);
    } else {
      itemsRemove(this, item);
    }
  };
  protoOf(SafeIterationList).to = function (item) {
    if (!(this.no_1 == null)) {
      var _iterator__ex2g4s = ensureNotNull(this.no_1).k();
      while (_iterator__ex2g4s.l()) {
        var op = _iterator__ex2g4s.m();
        if (!op.sp_1 && op.rp_1 === item) {
          return true;
        }
      }
    }
    return false;
  };
  protoOf(SafeIterationList).uo = function () {
    this.oo_1 = this.oo_1 + 1 | 0;
  };
  protoOf(SafeIterationList).vo = function () {
    this.oo_1 = this.oo_1 - 1 | 0;
    if (!this.po()) {
      if (!(this.no_1 == null)) {
        var _iterator__ex2g4s = ensureNotNull(this.no_1).k();
        while (_iterator__ex2g4s.l()) {
          var op = _iterator__ex2g4s.m();
          var item = op.rp_1;
          if (op.sp_1) {
            this.lo(item);
          } else {
            itemsRemove(this, item);
          }
        }
        ensureNotNull(this.no_1).m2();
      }
    }
  };
  protoOf(SafeIterationList).wo = function () {
    var tmp = this.mo_1.n();
    var tmp0_safe_receiver = this.no_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n();
    return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  };
  protoOf(SafeIterationList).m2 = function () {
    this.mo_1.m2();
    var tmp0_safe_receiver = this.no_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.m2();
    }
    this.oo_1 = 0;
  };
  function ItemIterator(iterationList) {
    this.vp_1 = iterationList;
    this.xp_1 = null;
    this.wp_1 = this.vp_1.mo_1.k();
  }
  protoOf(ItemIterator).l = function () {
    var hasNext = false;
    $l$loop_0: while (this.wp_1.l()) {
      var item = this.wp_1.m();
      if (!this.vp_1.to(item)) {
        hasNext = true;
        this.xp_1 = item;
        break $l$loop_0;
      }
    }
    return hasNext;
  };
  protoOf(ItemIterator).m = function () {
    var tmp = this.xp_1;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  function SafeIterationListIterable(iterationList) {
    this.yp_1 = iterationList;
    this.yp_1.uo();
  }
  protoOf(SafeIterationListIterable).k = function () {
    return new ItemIterator(this.yp_1);
  };
  protoOf(SafeIterationListIterable).up = function () {
    return this.yp_1.vo();
  };
  function SimpleCopyOnWriteAddAtStartList() {
    SimpleCopyOnWriteList.call(this);
  }
  protoOf(SimpleCopyOnWriteAddAtStartList).aq = function (item) {
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$_0(this.cq().n() + 1 | 0);
    // Inline function 'jetbrains.ocelot.base.collect.SimpleCopyOnWriteAddAtStartList.addItem.<anonymous>' call
    this_0.e(item);
    this_0.o(this.cq());
    return this_0;
  };
  function checkItem($this, item) {
    var tmp;
    if (!!(item == null)) {
      // Inline function 'jetbrains.ocelot.base.collect.SimpleCopyOnWriteList.checkItem.<anonymous>' call
      var message = 'item is null';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return tmp;
  }
  function Companion_24() {
  }
  protoOf(Companion_24).dq = function () {
    return new SimpleCopyOnWriteAddAtStartList();
  };
  var Companion_instance_24;
  function Companion_getInstance_24() {
    return Companion_instance_24;
  }
  function SimpleCopyOnWriteList() {
    this.bq_1 = null;
    this.m2();
  }
  protoOf(SimpleCopyOnWriteList).cq = function () {
    return ensureNotNull(this.bq_1);
  };
  protoOf(SimpleCopyOnWriteList).ro = function (item) {
    checkItem(this, item);
    this.bq_1 = this.aq(item);
  };
  protoOf(SimpleCopyOnWriteList).so = function (item) {
    checkItem(this, item);
    var items = ensureNotNull(this.bq_1);
    var index = items.t(item);
    if (index >= 0) {
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList_init_$Create$_0(items.n() - 1 | 0);
      // Inline function 'jetbrains.ocelot.base.collect.SimpleCopyOnWriteList.remove.<anonymous>' call
      this_0.o(items.j2(0, index));
      this_0.o(subListTail(items, index + 1 | 0));
      var newItems = this_0;
      this.bq_1 = newItems;
    }
  };
  protoOf(SimpleCopyOnWriteList).k = function () {
    return ensureNotNull(this.bq_1).k();
  };
  protoOf(SimpleCopyOnWriteList).m2 = function () {
    this.bq_1 = ArrayList_init_$Create$_0(0);
  };
  function NaiveTreeMap$TailMapView$iterator$1($delegate, this$0) {
    this.eq_1 = $delegate;
    this.fq_1 = this$0;
  }
  protoOf(NaiveTreeMap$TailMapView$iterator$1).l = function () {
    return this.eq_1.l();
  };
  protoOf(NaiveTreeMap$TailMapView$iterator$1).m = function () {
    var key = this.eq_1.m();
    return new Entry_1(this.fq_1, key, getValue_0(this.fq_1.mq_1, key));
  };
  protoOf(NaiveTreeMap$TailMapView$iterator$1).b5 = function () {
    this.eq_1.b5();
  };
  function Entry_1($outer, key, value) {
    this.qq_1 = $outer;
    this.oq_1 = key;
    this.pq_1 = value;
  }
  protoOf(Entry_1).x = function () {
    return this.oq_1;
  };
  protoOf(Entry_1).y = function () {
    return this.pq_1;
  };
  function ceilingIndex($this, key) {
    var index = binarySearch($this.lq_1, key, $this.kq_1);
    if (index < 0) {
      return ~index;
    }
    return index;
  }
  function TailMapView($outer) {
    this.rq_1 = $outer;
    AbstractMutableSet.call(this);
  }
  protoOf(TailMapView).tq = function () {
    var tmp0_safe_receiver = this.sq();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.expects.collections.TailMapView.<get-startIndex>.<anonymous>' call
      tmp = ceilingIndex(this.rq_1, tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(TailMapView).n = function () {
    return this.rq_1.lq_1.n() - this.tq() | 0;
  };
  protoOf(TailMapView).uq = function (element) {
    return !(this.rq_1.r2(element.x(), element.y()) == null);
  };
  protoOf(TailMapView).e = function (element) {
    return this.uq((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(TailMapView).vq = function (element) {
    var tmp;
    var tmp_0;
    var tmp0 = this.rq_1.mq_1;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var key = element.x();
    if ((isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).w2(key)) {
      var tmp0_safe_receiver = this.sq();
      var tmp_1;
      if (tmp0_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'jetbrains.ocelot.expects.collections.TailMapView.contains.<anonymous>' call
        tmp_1 = this.rq_1.kq_1.compare(element.x(), tmp0_safe_receiver) >= 0;
      }
      tmp_0 = tmp_1 === true;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.rq_1.mq_1.y2(element.x()), element.y());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(TailMapView).s = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    return this.vq((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(TailMapView).k = function () {
    var delegate = this.rq_1.lq_1.r(this.tq());
    return new NaiveTreeMap$TailMapView$iterator$1(delegate, this.rq_1);
  };
  function NaiveTreeMap$entries$1(this$0) {
    TailMapView.call(this, this$0);
  }
  protoOf(NaiveTreeMap$entries$1).sq = function () {
    return null;
  };
  function NaiveTreeMap$tailMap$entrySet$1($ceilingKey, this$0) {
    TailMapView.call(this, this$0);
    this.yq_1 = $ceilingKey;
  }
  protoOf(NaiveTreeMap$tailMap$entrySet$1).sq = function () {
    return this.yq_1;
  };
  function NaiveTreeMap$tailMap$1($entrySet, this$0, $ceilingKey) {
    this.br_1 = $entrySet;
    this.cr_1 = this$0;
    this.dr_1 = $ceilingKey;
    AbstractMap.call(this);
  }
  protoOf(NaiveTreeMap$tailMap$1).w = function () {
    return this.br_1;
  };
  protoOf(NaiveTreeMap$tailMap$1).w2 = function (key) {
    return this.cr_1.w2(key) && this.cr_1.kq_1.compare(this.dr_1, key) <= 0;
  };
  protoOf(NaiveTreeMap$tailMap$1).y2 = function (key) {
    var tmp;
    if (this.cr_1.kq_1.compare(this.dr_1, key) <= 0) {
      tmp = this.cr_1.y2(key);
    } else {
      tmp = null;
    }
    return tmp;
  };
  function NaiveTreeMap(comparator) {
    AbstractMutableMap.call(this);
    this.kq_1 = comparator;
    this.lq_1 = ArrayList_init_$Create$();
    this.mq_1 = HashMap_init_$Create$();
    var tmp = this;
    tmp.nq_1 = new NaiveTreeMap$entries$1(this);
  }
  protoOf(NaiveTreeMap).w = function () {
    return this.nq_1;
  };
  protoOf(NaiveTreeMap).y2 = function (key) {
    return this.mq_1.y2(key);
  };
  protoOf(NaiveTreeMap).r2 = function (key, value) {
    var index = binarySearch(this.lq_1, key, this.kq_1);
    if (index < 0) {
      this.lq_1.p2(~index, key);
    } else {
      this.lq_1.o2(index, key);
    }
    return this.mq_1.r2(key, value);
  };
  protoOf(NaiveTreeMap).s2 = function (key) {
    var index = binarySearch(this.lq_1, key, this.kq_1);
    if (index >= 0) {
      this.lq_1.q2(index);
    }
    return this.mq_1.s2(key);
  };
  protoOf(NaiveTreeMap).w2 = function (key) {
    return this.mq_1.w2(key);
  };
  protoOf(NaiveTreeMap).x2 = function (value) {
    return this.mq_1.x2(value);
  };
  protoOf(NaiveTreeMap).er = function (key) {
    var ceilingKey = key;
    var entrySet = new NaiveTreeMap$tailMap$entrySet$1(ceilingKey, this);
    return new NaiveTreeMap$tailMap$1(entrySet, this, ceilingKey);
  };
  function Present() {
  }
  var Present_instance;
  function Present_getInstance() {
    return Present_instance;
  }
  function NaiveTreeSet(comparator) {
    AbstractMutableSet.call(this);
    this.fr_1 = new NaiveTreeMap(comparator);
  }
  protoOf(NaiveTreeSet).n = function () {
    return this.fr_1.n();
  };
  protoOf(NaiveTreeSet).gr = function (element) {
    return this.fr_1.r2(element, Present_instance) == null;
  };
  protoOf(NaiveTreeSet).e = function (element) {
    return this.gr((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(NaiveTreeSet).hr = function (element) {
    return equals(this.fr_1.s2(element), Present_instance);
  };
  protoOf(NaiveTreeSet).k2 = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.hr((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(NaiveTreeSet).k = function () {
    return this.fr_1.u2().k();
  };
  function newTreeMap(comparator) {
    return new NaiveTreeMap(comparator);
  }
  function newTreeSet(comparator) {
    return new NaiveTreeSet(comparator);
  }
  function Lock() {
  }
  function emptyThreadSafeChecker() {
    return new emptyThreadSafeChecker$1();
  }
  function emptyThreadSafeChecker$1() {
  }
  protoOf(emptyThreadSafeChecker$1).lr = function () {
  };
  function newAtomicBoolean(value) {
    return new AtomicBooleanJs(value);
  }
  function AtomicBooleanJs(value) {
    this.mr_1 = value;
  }
  protoOf(AtomicBooleanJs).nr = function (expect, update) {
    var tmp;
    if (this.mr_1 === expect) {
      this.mr_1 = update;
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(AtomicBooleanJs).or = function (newValue) {
    this.mr_1 = newValue;
  };
  function newConcurrentHashMap() {
    return HashMap_init_$Create$();
  }
  function newConcurrentHashSet() {
    return HashSet_init_$Create$();
  }
  function newLock() {
    return new newLock$1();
  }
  function newLock$1() {
  }
  protoOf(newLock$1).ir = function () {
  };
  protoOf(newLock$1).jr = function () {
  };
  function newSimpleThreadLocal(initialValueSupplier) {
    return new SimpleThreadLocalJs(initialValueSupplier);
  }
  function SimpleThreadLocalJs(initialValueSupplier) {
    this.pr_1 = initialValueSupplier();
  }
  protoOf(SimpleThreadLocalJs).qr = function () {
    return this.pr_1;
  };
  function newThreadSafeChecker() {
    return emptyThreadSafeChecker();
  }
  function CompositeDisposable(disposables) {
    this.rr_1 = toMutableList(disposables);
  }
  protoOf(CompositeDisposable).sr = function (disposable) {
    this.rr_1.e(disposable);
    return this;
  };
  protoOf(CompositeDisposable).tr = function (disposable) {
    this.sr(disposable);
  };
  protoOf(CompositeDisposable).ur = function (disposables) {
    var inductionVariable = 0;
    var last = disposables.length;
    while (inductionVariable < last) {
      var disposable = disposables[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.rr_1.e(disposable);
    }
    return this;
  };
  protoOf(CompositeDisposable).vr = function () {
    var _iterator__ex2g4s = reversed(this.rr_1).k();
    while (_iterator__ex2g4s.l()) {
      var disposable = _iterator__ex2g4s.m();
      disposable.vr();
    }
    this.rr_1.m2();
  };
  function Companion_25() {
    Companion_instance_25 = this;
    this.wr_1 = toDisposable([]);
  }
  var Companion_instance_25;
  function Companion_getInstance_25() {
    if (Companion_instance_25 == null)
      new Companion_25();
    return Companion_instance_25;
  }
  function Disposable() {
  }
  function toDisposable(disposables) {
    return toDisposable_0(toList(disposables));
  }
  function toDisposable_0(disposableIterable) {
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new toDisposable$$inlined$toDisposable$1(disposableIterable);
  }
  function toDisposable$$inlined$toDisposable$1($disposableIterable) {
    this.xr_1 = $disposableIterable;
  }
  protoOf(toDisposable$$inlined$toDisposable$1).vr = function () {
    var _iterator__ex2g4s = reversed(this.xr_1).k();
    while (_iterator__ex2g4s.l()) {
      var disposable = _iterator__ex2g4s.m();
      disposable.vr();
    }
    return Unit_instance;
  };
  function DisposableMap() {
    this.yr_1 = HashMap_init_$Create$();
  }
  protoOf(DisposableMap).zr = function (key, disposable) {
    var prev = this.yr_1.r2(key, disposable);
    if (!(prev == null)) {
      prev.vr();
      ensureNotNull(this.yr_1.s2(key)).vr();
      throw IllegalStateException_init_$Create$_0("Registration for the key '" + toString_0(key) + "' already exists.");
    }
  };
  protoOf(DisposableMap).as = function (key) {
    var prev = this.yr_1.s2(key);
    var tmp;
    if (prev == null) {
      tmp = false;
    } else {
      prev.vr();
      tmp = true;
    }
    return tmp;
  };
  protoOf(DisposableMap).bs = function () {
    return this.yr_1.u2();
  };
  protoOf(DisposableMap).m2 = function () {
    try {
      var _iterator__ex2g4s = this.yr_1.v2().k();
      while (_iterator__ex2g4s.l()) {
        var disposable = _iterator__ex2g4s.m();
        disposable.vr();
      }
    }finally {
      this.yr_1.m2();
    }
  };
  function isInUnitTests(_this__u8e3s4) {
    return false;
  }
  function currentTimeMillis() {
    return numberToLong((new Date()).getTime());
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0(function_0) {
    this.cs_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0).vr = function () {
    return this.cs_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0).b4 = function () {
    return this.cs_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function ThrowableHandler$MyEventSource$addHandler$lambda(this$0, $handler) {
    return function () {
      this$0.ds_1.k2($handler);
      return Unit_instance;
    };
  }
  function getError($this, throwable) {
    var tmp;
    if (throwable instanceof Error_0) {
      tmp = throwable;
    } else {
      tmp = null;
    }
    var error = tmp;
    if (error == null) {
      var cause = throwable.cause;
      if (!(cause == null)) {
        error = getError($this, cause);
      }
    }
    return error;
  }
  function isInUnitTests_0($this, throwable) {
    return $this.es_1.qr() ? false : isInUnitTests(throwable);
  }
  function MyEventSource() {
    this.ds_1 = ArrayList_init_$Create$();
  }
  protoOf(MyEventSource).is = function (throwable) {
    var _iterator__ex2g4s = ArrayList_init_$Create$_1(this.ds_1).k();
    while (_iterator__ex2g4s.l()) {
      var handler = _iterator__ex2g4s.m();
      handler(throwable);
    }
  };
  protoOf(MyEventSource).js = function (handler) {
    this.ds_1.e(handler);
    var tmp = ThrowableHandler$MyEventSource$addHandler$lambda(this, handler);
    return new sam$jetbrains_ocelot_base_disposable_Disposable$0(tmp);
  };
  function Companion_26() {
    Companion_instance_26 = this;
    this.ks_1 = getLogger(getKClass(ThrowableHandler));
    this.ls_1 = true;
  }
  protoOf(Companion_26).ms = function (t) {
    var error = getError(this, t);
    if (!(error == null)) {
      throw error;
    }
  };
  var Companion_instance_26;
  function Companion_getInstance_26() {
    if (Companion_instance_26 == null)
      new Companion_26();
    return Companion_instance_26;
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_0(function_0) {
    this.ns_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_0).vr = function () {
    return this.ns_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_0).b4 = function () {
    return this.ns_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_0).hashCode = function () {
    return hashCode(this.b4());
  };
  function ThrowableHandler$forceProduction$lambda() {
    return false;
  }
  function ThrowableHandler$MyEventSource$_init_$ref_j6mxqu() {
    var l = function () {
      return new MyEventSource();
    };
    l.callableName = '<init>';
    return l;
  }
  function ThrowableHandler$addHandler$lambda(this$0, $leakStacktrace) {
    return function () {
      return this$0.gs_1.e($leakStacktrace);
    };
  }
  function ThrowableHandler$addHandler$lambda$lambda(this$0, $leakStacktrace) {
    return function () {
      this$0.gs_1.k2($leakStacktrace);
      return Unit_instance;
    };
  }
  function ThrowableHandler$addHandler$lambda_0(this$0, $leakStacktrace) {
    return function () {
      this$0.hs_1.kr(ThrowableHandler$addHandler$lambda$lambda(this$0, $leakStacktrace));
      return Unit_instance;
    };
  }
  function ThrowableHandler$addHandler$lambda_1($handlerReg, $leakDisposable) {
    return function () {
      $handlerReg.vr();
      var tmp0_safe_receiver = $leakDisposable._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.vr();
      }
      return Unit_instance;
    };
  }
  function ThrowableHandler() {
    Companion_getInstance_26();
    var tmp = this;
    tmp.es_1 = newSimpleThreadLocal(ThrowableHandler$forceProduction$lambda);
    var tmp_0 = this;
    tmp_0.fs_1 = newSimpleThreadLocal(ThrowableHandler$MyEventSource$_init_$ref_j6mxqu());
    this.gs_1 = LinkedHashSet_init_$Create$();
    this.hs_1 = newLock();
  }
  protoOf(ThrowableHandler).os = function (throwable) {
    if (isInUnitTests_0(this, throwable)) {
      if (throwable instanceof RuntimeException)
        throw throwable;
      throw RuntimeException_init_$Create$_2(throwable);
    }
    if (!this.es_1.qr()) {
      Companion_getInstance_26().ks_1.co('Exception handled at ThrowableHandler', throwable);
    }
    Companion_getInstance_26().ms(throwable);
    this.fs_1.qr().is(throwable);
  };
  protoOf(ThrowableHandler).js = function (handler) {
    var handlerReg = this.fs_1.qr().js(handler);
    var leakDisposable = {_v: null};
    var leakStacktrace = RuntimeException_init_$Create$_0('Potential leak');
    this.hs_1.kr(ThrowableHandler$addHandler$lambda(this, leakStacktrace));
    var tmp = ThrowableHandler$addHandler$lambda_0(this, leakStacktrace);
    leakDisposable._v = new sam$jetbrains_ocelot_base_disposable_Disposable$0_0(tmp);
    var tmp_0 = ThrowableHandler$addHandler$lambda_1(handlerReg, leakDisposable);
    return new sam$jetbrains_ocelot_base_disposable_Disposable$0_0(tmp_0);
  };
  function ThrowableHandlers() {
    ThrowableHandlers_instance = this;
    this.ps_1 = new ThrowableHandler();
    this.qs_1 = this.ps_1;
  }
  var ThrowableHandlers_instance;
  function ThrowableHandlers_getInstance() {
    if (ThrowableHandlers_instance == null)
      new ThrowableHandlers();
    return ThrowableHandlers_instance;
  }
  function atomicfu$AtomicRefArray$ref(size) {
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(size), null);
    while (tmp_0 < size) {
      tmp_1[tmp_0] = atomic$ref$1(null);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.rs_1 = tmp_1;
  }
  protoOf(atomicfu$AtomicRefArray$ref).ss = function () {
    return this.rs_1.length;
  };
  protoOf(atomicfu$AtomicRefArray$ref).atomicfu$get = function (index) {
    return this.rs_1[index];
  };
  function atomicfu$AtomicRefArray$ofNulls(size) {
    return new atomicfu$AtomicRefArray$ref(size);
  }
  function None() {
    None_instance = this;
    atomicfu$TraceBase.call(this);
  }
  var None_instance;
  function None_getInstance() {
    if (None_instance == null)
      new None();
    return None_instance;
  }
  function atomicfu$TraceBase() {
  }
  protoOf(atomicfu$TraceBase).atomicfu$Trace$append$1 = function (event) {
  };
  protoOf(atomicfu$TraceBase).atomicfu$Trace$append$2 = function (event1, event2) {
  };
  protoOf(atomicfu$TraceBase).atomicfu$Trace$append$3 = function (event1, event2, event3) {
  };
  protoOf(atomicfu$TraceBase).atomicfu$Trace$append$4 = function (event1, event2, event3, event4) {
  };
  function AtomicRef(value) {
    this.kotlinx$atomicfu$value = value;
  }
  protoOf(AtomicRef).ts = function (_set____db54di) {
    this.kotlinx$atomicfu$value = _set____db54di;
  };
  protoOf(AtomicRef).us = function () {
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicRef).atomicfu$compareAndSet = function (expect, update) {
    if (!(this.kotlinx$atomicfu$value === expect))
      return false;
    this.kotlinx$atomicfu$value = update;
    return true;
  };
  protoOf(AtomicRef).atomicfu$getAndSet = function (value) {
    var oldValue = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = value;
    return oldValue;
  };
  protoOf(AtomicRef).toString = function () {
    return toString_0(this.kotlinx$atomicfu$value);
  };
  function atomic$ref$1(initial) {
    return atomic$ref$(initial, None_getInstance());
  }
  function AtomicBoolean(value) {
    this.kotlinx$atomicfu$value = value;
  }
  protoOf(AtomicBoolean).vs = function (_set____db54di) {
    this.kotlinx$atomicfu$value = _set____db54di;
  };
  protoOf(AtomicBoolean).us = function () {
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicBoolean).atomicfu$compareAndSet = function (expect, update) {
    if (!(this.kotlinx$atomicfu$value === expect))
      return false;
    this.kotlinx$atomicfu$value = update;
    return true;
  };
  protoOf(AtomicBoolean).atomicfu$getAndSet = function (value) {
    var oldValue = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = value;
    return oldValue;
  };
  protoOf(AtomicBoolean).toString = function () {
    return this.kotlinx$atomicfu$value.toString();
  };
  function atomic$boolean$1(initial) {
    return atomic$boolean$(initial, None_getInstance());
  }
  function AtomicInt(value) {
    this.kotlinx$atomicfu$value = value;
  }
  protoOf(AtomicInt).ws = function (_set____db54di) {
    this.kotlinx$atomicfu$value = _set____db54di;
  };
  protoOf(AtomicInt).us = function () {
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicInt).atomicfu$compareAndSet = function (expect, update) {
    if (!(this.kotlinx$atomicfu$value === expect))
      return false;
    this.kotlinx$atomicfu$value = update;
    return true;
  };
  protoOf(AtomicInt).atomicfu$getAndSet = function (value) {
    var oldValue = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = value;
    return oldValue;
  };
  protoOf(AtomicInt).atomicfu$getAndIncrement = function () {
    var tmp1 = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = tmp1 + 1 | 0;
    return tmp1;
  };
  protoOf(AtomicInt).atomicfu$getAndDecrement = function () {
    var tmp1 = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = tmp1 - 1 | 0;
    return tmp1;
  };
  protoOf(AtomicInt).atomicfu$getAndAdd = function (delta) {
    var oldValue = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value + delta | 0;
    return oldValue;
  };
  protoOf(AtomicInt).atomicfu$addAndGet = function (delta) {
    this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value + delta | 0;
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicInt).atomicfu$incrementAndGet = function () {
    this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value + 1 | 0;
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicInt).atomicfu$decrementAndGet = function () {
    this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value - 1 | 0;
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicInt).toString = function () {
    return this.kotlinx$atomicfu$value.toString();
  };
  function atomic$int$1(initial) {
    return atomic$int$(initial, None_getInstance());
  }
  function AtomicLong(value) {
    this.kotlinx$atomicfu$value = value;
  }
  protoOf(AtomicLong).xs = function (_set____db54di) {
    this.kotlinx$atomicfu$value = _set____db54di;
  };
  protoOf(AtomicLong).us = function () {
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicLong).atomicfu$compareAndSet = function (expect, update) {
    if (!this.kotlinx$atomicfu$value.equals(expect))
      return false;
    this.kotlinx$atomicfu$value = update;
    return true;
  };
  protoOf(AtomicLong).atomicfu$getAndSet = function (value) {
    var oldValue = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = value;
    return oldValue;
  };
  protoOf(AtomicLong).atomicfu$getAndIncrement$long = function () {
    var tmp1 = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = tmp1.n3();
    return tmp1;
  };
  protoOf(AtomicLong).atomicfu$getAndDecrement$long = function () {
    var tmp1 = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = tmp1.o3();
    return tmp1;
  };
  protoOf(AtomicLong).atomicfu$getAndAdd$long = function (delta) {
    var oldValue = this.kotlinx$atomicfu$value;
    this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value.i3(delta);
    return oldValue;
  };
  protoOf(AtomicLong).atomicfu$addAndGet$long = function (delta) {
    this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value.i3(delta);
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicLong).atomicfu$incrementAndGet$long = function () {
    this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value.n3();
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicLong).atomicfu$decrementAndGet$long = function () {
    this.kotlinx$atomicfu$value = this.kotlinx$atomicfu$value.o3();
    return this.kotlinx$atomicfu$value;
  };
  protoOf(AtomicLong).toString = function () {
    return this.kotlinx$atomicfu$value.toString();
  };
  function atomic$long$1(initial) {
    return atomic$long$(initial, None_getInstance());
  }
  function atomic$ref$(initial, trace) {
    trace = trace === VOID ? None_getInstance() : trace;
    return new AtomicRef(initial);
  }
  function atomic$boolean$(initial, trace) {
    trace = trace === VOID ? None_getInstance() : trace;
    return new AtomicBoolean(initial);
  }
  function atomic$int$(initial, trace) {
    trace = trace === VOID ? None_getInstance() : trace;
    return new AtomicInt(initial);
  }
  function atomic$long$(initial, trace) {
    trace = trace === VOID ? None_getInstance() : trace;
    return new AtomicLong(initial);
  }
  function AbstractCoroutine(parentContext, initParentJob, active) {
    JobSupport.call(this, active);
    if (initParentJob) {
      this.at(parentContext.la(Key_instance_3));
    }
    this.dt_1 = parentContext.ej(this);
  }
  protoOf(AbstractCoroutine).ea = function () {
    return this.dt_1;
  };
  protoOf(AbstractCoroutine).et = function () {
    return this.dt_1;
  };
  protoOf(AbstractCoroutine).ft = function () {
    return protoOf(JobSupport).ft.call(this);
  };
  protoOf(AbstractCoroutine).gt = function (value) {
  };
  protoOf(AbstractCoroutine).ht = function (cause, handled) {
  };
  protoOf(AbstractCoroutine).it = function () {
    return get_classSimpleName(this) + ' was cancelled';
  };
  protoOf(AbstractCoroutine).jt = function (state) {
    if (state instanceof CompletedExceptionally) {
      this.ht(state.kt_1, state.mt());
    } else {
      this.gt((state == null ? true : !(state == null)) ? state : THROW_CCE());
    }
  };
  protoOf(AbstractCoroutine).ja = function (result) {
    var state = this.nt(toState_0(result));
    if (state === get_COMPLETING_WAITING_CHILDREN())
      return Unit_instance;
    this.ot(state);
  };
  protoOf(AbstractCoroutine).ot = function (state) {
    return this.pt(state);
  };
  protoOf(AbstractCoroutine).qt = function (exception) {
    handleCoroutineException(this.dt_1, exception);
  };
  protoOf(AbstractCoroutine).rt = function () {
    var tmp0_elvis_lhs = get_coroutineName(this.dt_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return protoOf(JobSupport).rt.call(this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var coroutineName = tmp;
    return '"' + coroutineName + '":' + protoOf(JobSupport).rt.call(this);
  };
  protoOf(AbstractCoroutine).st = function (start, receiver, block) {
    start.vt(block, receiver, this);
  };
  function launch(_this__u8e3s4, context, start, block) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
    var newContext = newCoroutineContext(_this__u8e3s4, context);
    var coroutine = start.fv() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
    coroutine.st(start, coroutine, block);
    return coroutine;
  }
  function async(_this__u8e3s4, context, start, block) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
    var newContext = newCoroutineContext(_this__u8e3s4, context);
    var coroutine = start.fv() ? new LazyDeferredCoroutine(newContext, block) : new DeferredCoroutine(newContext, true);
    coroutine.st(start, coroutine, block);
    return coroutine;
  }
  function withContext(context, block, $completion) {
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.withContext.<anonymous>' call
      var oldContext = $completion.ea();
      var newContext = newCoroutineContext_0(oldContext, context);
      ensureActive(newContext);
      if (newContext === oldContext) {
        var coroutine = new ScopeCoroutine(newContext, $completion);
        tmp$ret$0 = startUndispatchedOrReturn(coroutine, coroutine, block);
        break $l$block_0;
      }
      if (equals(newContext.la(Key_instance), oldContext.la(Key_instance))) {
        var coroutine_0 = new UndispatchedCoroutine(newContext, $completion);
        // Inline function 'kotlinx.coroutines.withCoroutineContext' call
        coroutine_0.dt_1;
        tmp$ret$0 = startUndispatchedOrReturn(coroutine_0, coroutine_0, block);
        break $l$block_0;
      }
      var coroutine_1 = new DispatchedCoroutine(newContext, $completion);
      startCoroutineCancellable(block, coroutine_1, coroutine_1);
      tmp$ret$0 = coroutine_1.lv();
    }
    return tmp$ret$0;
  }
  function StandaloneCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, true, active);
  }
  protoOf(StandaloneCoroutine).av = function (exception) {
    handleCoroutineException(this.dt_1, exception);
    return true;
  };
  function LazyStandaloneCoroutine(parentContext, block) {
    StandaloneCoroutine.call(this, parentContext, false);
    this.sv_1 = createCoroutineUnintercepted(block, this, this);
  }
  protoOf(LazyStandaloneCoroutine).du = function () {
    startCoroutineCancellable_0(this.sv_1, this);
  };
  function $awaitCOROUTINE$0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bw_1 = _this__u8e3s4;
  }
  protoOf($awaitCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.bw_1.ev(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return (suspendResult == null ? true : !(suspendResult == null)) ? suspendResult : THROW_CCE();
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function DeferredCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, true, active);
  }
  protoOf(DeferredCoroutine).fw = function () {
    var tmp = this.dv();
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(DeferredCoroutine).gw = function ($completion) {
    var tmp = new $awaitCOROUTINE$0(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function LazyDeferredCoroutine(parentContext, block) {
    DeferredCoroutine.call(this, parentContext, false);
    this.kw_1 = createCoroutineUnintercepted(block, this, this);
  }
  protoOf(LazyDeferredCoroutine).du = function () {
    startCoroutineCancellable_0(this.kw_1, this);
  };
  function trySuspend($this) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.kv_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.DispatchedCoroutine.trySuspend.<anonymous>' call
      switch (this_0.kotlinx$atomicfu$value) {
        case 0:
          if ($this.kv_1.atomicfu$compareAndSet(0, 1))
            return true;
          break;
        case 2:
          return false;
        default:
          // Inline function 'kotlin.error' call

          var message = 'Already suspended';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function tryResume($this) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.kv_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.DispatchedCoroutine.tryResume.<anonymous>' call
      switch (this_0.kotlinx$atomicfu$value) {
        case 0:
          if ($this.kv_1.atomicfu$compareAndSet(0, 2))
            return true;
          break;
        case 1:
          return false;
        default:
          // Inline function 'kotlin.error' call

          var message = 'Already resumed';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function DispatchedCoroutine(context, uCont) {
    ScopeCoroutine.call(this, context, uCont);
    this.kv_1 = atomic$int$1(0);
  }
  protoOf(DispatchedCoroutine).pt = function (state) {
    this.ot(state);
  };
  protoOf(DispatchedCoroutine).ot = function (state) {
    if (tryResume(this))
      return Unit_instance;
    resumeCancellableWith(intercepted(this.ow_1), recoverResult(state, this.ow_1));
  };
  protoOf(DispatchedCoroutine).lv = function () {
    if (trySuspend(this))
      return get_COROUTINE_SUSPENDED();
    var state = unboxState(this.zt());
    if (state instanceof CompletedExceptionally)
      throw state.kt_1;
    return (state == null ? true : !(state == null)) ? state : THROW_CCE();
  };
  function CancellableContinuation() {
  }
  function disposeOnCancellation(_this__u8e3s4, handle) {
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new DisposeOnCancel(handle);
    return _this__u8e3s4.rw(tmp$ret$1);
  }
  function DisposeOnCancel(handle) {
    CancelHandler.call(this);
    this.uw_1 = handle;
  }
  protoOf(DisposeOnCancel).vw = function (cause) {
    return this.uw_1.vr();
  };
  protoOf(DisposeOnCancel).invoke = function (cause) {
    return this.vw(cause);
  };
  protoOf(DisposeOnCancel).toString = function () {
    return 'DisposeOnCancel[' + toString_1(this.uw_1) + ']';
  };
  function getOrCreateCancellableContinuation(delegate) {
    if (!(delegate instanceof DispatchedContinuation)) {
      return new CancellableContinuationImpl(delegate, 1);
    }
    var tmp0_safe_receiver = delegate.cx();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      // Inline function 'kotlinx.coroutines.getOrCreateCancellableContinuation.<anonymous>' call
      if (tmp0_safe_receiver.jx()) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return new CancellableContinuationImpl(delegate, 2);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  }
  function get_RESUME_TOKEN() {
    _init_properties_CancellableContinuationImpl_kt__6rrtdd();
    return RESUME_TOKEN;
  }
  var RESUME_TOKEN;
  function _get_parentHandle__f8dcex($this) {
    return $this.ix_1.kotlinx$atomicfu$value;
  }
  function _get_stateDebugRepresentation__bf18u4($this) {
    var tmp0_subject = $this.zt();
    var tmp;
    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, NotCompleted) : false) {
      tmp = 'Active';
    } else {
      if (tmp0_subject instanceof CancelledContinuation) {
        tmp = 'Cancelled';
      } else {
        tmp = 'Completed';
      }
    }
    return tmp;
  }
  function isReusable($this) {
    var tmp;
    if (get_isReusableMode($this.lx_1)) {
      var tmp_0 = $this.ex_1;
      tmp = (tmp_0 instanceof DispatchedContinuation ? tmp_0 : THROW_CCE()).kx();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function cancelLater($this, cause) {
    if (!isReusable($this))
      return false;
    var tmp = $this.ex_1;
    var dispatched = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
    return dispatched.mx(cause);
  }
  function callSegmentOnCancellation($this, segment, cause) {
    // Inline function 'kotlinx.coroutines.index' call
    var index = $this.gx_1.kotlinx$atomicfu$value & 536870911;
    // Inline function 'kotlin.check' call
    if (!!(index === 536870911)) {
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callSegmentOnCancellation.<anonymous>' call
      var message = 'The index for Segment.onCancellation(..) is broken';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
    try {
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callSegmentOnCancellation.<anonymous>' call
      segment.rx(index, cause, $this.ea());
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        handleCoroutineException($this.ea(), new CompletionHandlerException('Exception in invokeOnCancellation handler for ' + $this.toString(), ex));
      } else {
        throw $p;
      }
    }
  }
  function trySuspend_0($this) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.gx_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.trySuspend.<anonymous>' call
      var cur = this_0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.decision' call
      switch (cur >> 29) {
        case 0:
          // Inline function 'kotlinx.coroutines.index' call

          // Inline function 'kotlinx.coroutines.decisionAndIndex' call

          var tmp$ret$2 = (1 << 29) + (cur & 536870911) | 0;
          if ($this.gx_1.atomicfu$compareAndSet(cur, tmp$ret$2))
            return true;
          break;
        case 2:
          return false;
        default:
          // Inline function 'kotlin.error' call

          var message = 'Already suspended';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function tryResume_0($this) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.gx_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.tryResume.<anonymous>' call
      var cur = this_0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.decision' call
      switch (cur >> 29) {
        case 0:
          // Inline function 'kotlinx.coroutines.index' call

          // Inline function 'kotlinx.coroutines.decisionAndIndex' call

          var tmp$ret$2 = (2 << 29) + (cur & 536870911) | 0;
          if ($this.gx_1.atomicfu$compareAndSet(cur, tmp$ret$2))
            return true;
          break;
        case 1:
          return false;
        default:
          // Inline function 'kotlin.error' call

          var message = 'Already resumed';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function installParentHandle($this) {
    var tmp0_elvis_lhs = $this.ea().la(Key_instance_3);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new ChildContinuation($this);
    var handle = parent.ju(true, VOID, tmp$ret$1);
    $this.ix_1.atomicfu$compareAndSet(null, handle);
    return handle;
  }
  function invokeOnCancellationImpl($this, handler) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.hx_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.invokeOnCancellationImpl.<anonymous>' call
      var state = this_0.kotlinx$atomicfu$value;
      if (state instanceof Active) {
        if ($this.hx_1.atomicfu$compareAndSet(state, handler))
          return Unit_instance;
      } else {
        var tmp;
        if (state instanceof CancelHandler) {
          tmp = true;
        } else {
          tmp = state instanceof Segment;
        }
        if (tmp) {
          multipleHandlersError($this, handler, state);
        } else {
          if (state instanceof CompletedExceptionally) {
            if (!state.ay()) {
              multipleHandlersError($this, handler, state);
            }
            if (state instanceof CancelledContinuation) {
              var tmp1_safe_receiver = state instanceof CompletedExceptionally ? state : null;
              var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.kt_1;
              if (handler instanceof CancelHandler) {
                $this.xx(handler, cause);
              } else {
                var segment = handler instanceof Segment ? handler : THROW_CCE();
                callSegmentOnCancellation($this, segment, cause);
              }
            }
            return Unit_instance;
          } else {
            if (state instanceof CompletedContinuation_0) {
              if (!(state.tx_1 == null)) {
                multipleHandlersError($this, handler, state);
              }
              if (handler instanceof Segment)
                return Unit_instance;
              if (!(handler instanceof CancelHandler))
                THROW_CCE();
              if (state.yx()) {
                $this.xx(handler, state.wx_1);
                return Unit_instance;
              }
              var update = state.zx(VOID, handler);
              if ($this.hx_1.atomicfu$compareAndSet(state, update))
                return Unit_instance;
            } else {
              if (handler instanceof Segment)
                return Unit_instance;
              if (!(handler instanceof CancelHandler))
                THROW_CCE();
              var update_0 = new CompletedContinuation_0(state, handler);
              if ($this.hx_1.atomicfu$compareAndSet(state, update_0))
                return Unit_instance;
            }
          }
        }
      }
    }
  }
  function multipleHandlersError($this, handler, state) {
    // Inline function 'kotlin.error' call
    var message = "It's prohibited to register multiple handlers, tried to register " + toString_1(handler) + ', already has ' + toString_0(state);
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  function makeCancelHandler($this, handler) {
    var tmp;
    if (handler instanceof CancelHandler) {
      tmp = handler;
    } else {
      tmp = new InvokeOnCancel(handler);
    }
    return tmp;
  }
  function dispatchResume($this, mode) {
    if (tryResume_0($this))
      return Unit_instance;
    dispatch($this, mode);
  }
  function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
    var tmp;
    if (proposedUpdate instanceof CompletedExceptionally) {
      // Inline function 'kotlinx.coroutines.assert' call
      // Inline function 'kotlinx.coroutines.assert' call
      tmp = proposedUpdate;
    } else {
      if (!get_isCancellableMode(resumeMode) && idempotent == null) {
        tmp = proposedUpdate;
      } else {
        var tmp_0;
        var tmp_1;
        if (!(onCancellation == null)) {
          tmp_1 = true;
        } else {
          tmp_1 = state instanceof CancelHandler;
        }
        if (tmp_1) {
          tmp_0 = true;
        } else {
          tmp_0 = !(idempotent == null);
        }
        if (tmp_0) {
          tmp = new CompletedContinuation_0(proposedUpdate, state instanceof CancelHandler ? state : null, onCancellation, idempotent);
        } else {
          tmp = proposedUpdate;
        }
      }
    }
    return tmp;
  }
  function resumeImpl($this, proposedUpdate, resumeMode, onCancellation) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.hx_1;
    while (true) {
      var tmp1 = this_0.kotlinx$atomicfu$value;
      $l$block: {
        // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.resumeImpl.<anonymous>' call
        if (!(tmp1 == null) ? isInterface(tmp1, NotCompleted) : false) {
          var update = resumedState($this, tmp1, proposedUpdate, resumeMode, onCancellation, null);
          if (!$this.hx_1.atomicfu$compareAndSet(tmp1, update)) {
            break $l$block;
          }
          detachChildIfNonResuable($this);
          dispatchResume($this, resumeMode);
          return Unit_instance;
        } else {
          if (tmp1 instanceof CancelledContinuation) {
            if (tmp1.fy()) {
              if (onCancellation == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.resumeImpl.<anonymous>.<anonymous>' call
                $this.by(onCancellation, tmp1.kt_1);
              }
              return Unit_instance;
            }
          }
        }
        alreadyResumedError($this, proposedUpdate);
      }
    }
  }
  function resumeImpl$default($this, proposedUpdate, resumeMode, onCancellation, $super) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    return resumeImpl($this, proposedUpdate, resumeMode, onCancellation);
  }
  function tryResumeImpl($this, proposedUpdate, idempotent, onCancellation) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.hx_1;
    while (true) {
      var tmp1 = this_0.kotlinx$atomicfu$value;
      $l$block: {
        // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.tryResumeImpl.<anonymous>' call
        if (!(tmp1 == null) ? isInterface(tmp1, NotCompleted) : false) {
          var update = resumedState($this, tmp1, proposedUpdate, $this.lx_1, onCancellation, idempotent);
          if (!$this.hx_1.atomicfu$compareAndSet(tmp1, update)) {
            break $l$block;
          }
          detachChildIfNonResuable($this);
          return get_RESUME_TOKEN();
        } else {
          if (tmp1 instanceof CompletedContinuation_0) {
            var tmp;
            if (!(idempotent == null) && tmp1.vx_1 === idempotent) {
              // Inline function 'kotlinx.coroutines.assert' call
              tmp = get_RESUME_TOKEN();
            } else {
              tmp = null;
            }
            return tmp;
          } else {
            return null;
          }
        }
      }
    }
  }
  function alreadyResumedError($this, proposedUpdate) {
    // Inline function 'kotlin.error' call
    var message = 'Already resumed, but proposed with update ' + toString_0(proposedUpdate);
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  function detachChildIfNonResuable($this) {
    if (!isReusable($this)) {
      $this.gy();
    }
  }
  function CancellableContinuationImpl(delegate, resumeMode) {
    DispatchedTask.call(this, resumeMode);
    this.ex_1 = delegate;
    // Inline function 'kotlinx.coroutines.assert' call
    this.fx_1 = this.ex_1.ea();
    var tmp = this;
    // Inline function 'kotlinx.coroutines.decisionAndIndex' call
    var tmp$ret$0 = (0 << 29) + 536870911 | 0;
    tmp.gx_1 = atomic$int$1(tmp$ret$0);
    this.hx_1 = atomic$ref$1(Active_instance);
    this.ix_1 = atomic$ref$1(null);
  }
  protoOf(CancellableContinuationImpl).hy = function () {
    return this.ex_1;
  };
  protoOf(CancellableContinuationImpl).ea = function () {
    return this.fx_1;
  };
  protoOf(CancellableContinuationImpl).zt = function () {
    return this.hx_1.kotlinx$atomicfu$value;
  };
  protoOf(CancellableContinuationImpl).au = function () {
    var tmp = this.zt();
    return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
  };
  protoOf(CancellableContinuationImpl).bu = function () {
    var tmp = this.zt();
    return tmp instanceof CancelledContinuation;
  };
  protoOf(CancellableContinuationImpl).iy = function () {
    var tmp0_elvis_lhs = installParentHandle(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var handle = tmp;
    if (this.au()) {
      handle.vr();
      this.ix_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
    }
  };
  protoOf(CancellableContinuationImpl).jx = function () {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    var state = this.hx_1.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp;
    if (state instanceof CompletedContinuation_0) {
      tmp = !(state.vx_1 == null);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.gy();
      return false;
    }
    var tmp_0 = this.gx_1;
    // Inline function 'kotlinx.coroutines.decisionAndIndex' call
    tmp_0.kotlinx$atomicfu$value = (0 << 29) + 536870911 | 0;
    this.hx_1.kotlinx$atomicfu$value = Active_instance;
    return true;
  };
  protoOf(CancellableContinuationImpl).jy = function () {
    return this.zt();
  };
  protoOf(CancellableContinuationImpl).ky = function (takenState, cause) {
    var this_0 = this.hx_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.cancelCompletedResult.<anonymous>' call
      var state = this_0.kotlinx$atomicfu$value;
      if (!(state == null) ? isInterface(state, NotCompleted) : false) {
        // Inline function 'kotlin.error' call
        var message = 'Not completed';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        if (state instanceof CompletedExceptionally)
          return Unit_instance;
        else {
          if (state instanceof CompletedContinuation_0) {
            // Inline function 'kotlin.check' call
            if (!!state.yx()) {
              // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.cancelCompletedResult.<anonymous>.<anonymous>' call
              var message_0 = 'Must be called at most once';
              throw IllegalStateException_init_$Create$_0(toString_1(message_0));
            }
            var update = state.zx(VOID, VOID, VOID, VOID, cause);
            if (this.hx_1.atomicfu$compareAndSet(state, update)) {
              state.ly(this, cause);
              return Unit_instance;
            }
          } else {
            if (this.hx_1.atomicfu$compareAndSet(state, new CompletedContinuation_0(state, VOID, VOID, VOID, cause))) {
              return Unit_instance;
            }
          }
        }
      }
    }
    return Unit_instance;
  };
  protoOf(CancellableContinuationImpl).my = function (cause) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.hx_1;
    while (true) {
      var tmp1 = this_0.kotlinx$atomicfu$value;
      $l$block: {
        // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.cancel.<anonymous>' call
        if (!(!(tmp1 == null) ? isInterface(tmp1, NotCompleted) : false))
          return false;
        var tmp;
        if (tmp1 instanceof CancelHandler) {
          tmp = true;
        } else {
          tmp = tmp1 instanceof Segment;
        }
        var update = new CancelledContinuation(this, cause, tmp);
        if (!this.hx_1.atomicfu$compareAndSet(tmp1, update)) {
          break $l$block;
        }
        if (tmp1 instanceof CancelHandler) {
          this.xx(tmp1, cause);
        } else {
          if (tmp1 instanceof Segment) {
            callSegmentOnCancellation(this, tmp1, cause);
          }
        }
        detachChildIfNonResuable(this);
        dispatchResume(this, this.lx_1);
        return true;
      }
    }
  };
  protoOf(CancellableContinuationImpl).ny = function (cause) {
    if (cancelLater(this, cause))
      return Unit_instance;
    this.my(cause);
    detachChildIfNonResuable(this);
  };
  protoOf(CancellableContinuationImpl).xx = function (handler, cause) {
    var tmp;
    try {
      handler.invoke(cause);
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var ex = $p;
        handleCoroutineException(this.ea(), new CompletionHandlerException('Exception in invokeOnCancellation handler for ' + this.toString(), ex));
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(CancellableContinuationImpl).by = function (onCancellation, cause) {
    try {
      onCancellation(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        handleCoroutineException(this.ea(), new CompletionHandlerException('Exception in resume onCancellation handler for ' + this.toString(), ex));
      } else {
        throw $p;
      }
    }
  };
  protoOf(CancellableContinuationImpl).oy = function (parent) {
    return parent.eu();
  };
  protoOf(CancellableContinuationImpl).py = function () {
    var isReusable_0 = isReusable(this);
    if (trySuspend_0(this)) {
      if (_get_parentHandle__f8dcex(this) == null) {
        installParentHandle(this);
      }
      if (isReusable_0) {
        this.qy();
      }
      return get_COROUTINE_SUSPENDED();
    }
    if (isReusable_0) {
      this.qy();
    }
    var state = this.zt();
    if (state instanceof CompletedExceptionally)
      throw recoverStackTrace(state.kt_1, this);
    if (get_isCancellableMode(this.lx_1)) {
      var job = this.ea().la(Key_instance_3);
      if (!(job == null) && !job.ft()) {
        var cause = job.eu();
        this.ky(state, cause);
        throw recoverStackTrace(cause, this);
      }
    }
    return this.ry(state);
  };
  protoOf(CancellableContinuationImpl).qy = function () {
    var tmp = this.ex_1;
    var tmp0_safe_receiver = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sy(this);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var cancellationCause = tmp_0;
    this.gy();
    this.my(cancellationCause);
  };
  protoOf(CancellableContinuationImpl).ja = function (result) {
    return resumeImpl$default(this, toState(result, this), this.lx_1);
  };
  protoOf(CancellableContinuationImpl).tw = function (value, onCancellation) {
    return resumeImpl(this, value, this.lx_1, onCancellation);
  };
  protoOf(CancellableContinuationImpl).ty = function (segment, index) {
    var tmp0 = this.gx_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.invokeOnCancellation.<anonymous>' call
        // Inline function 'kotlinx.coroutines.index' call
        // Inline function 'kotlin.check' call
        if (!((cur & 536870911) === 536870911)) {
          // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.invokeOnCancellation.<anonymous>.<anonymous>' call
          var message = 'invokeOnCancellation should be called at most once';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        // Inline function 'kotlinx.coroutines.decision' call
        // Inline function 'kotlinx.coroutines.decisionAndIndex' call
        var upd = (cur >> 29 << 29) + index | 0;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    invokeOnCancellationImpl(this, segment);
  };
  protoOf(CancellableContinuationImpl).rw = function (handler) {
    var cancelHandler = makeCancelHandler(this, handler);
    invokeOnCancellationImpl(this, cancelHandler);
  };
  protoOf(CancellableContinuationImpl).gy = function () {
    var tmp0_elvis_lhs = _get_parentHandle__f8dcex(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var handle = tmp;
    handle.vr();
    this.ix_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
  };
  protoOf(CancellableContinuationImpl).pw = function (value, idempotent, onCancellation) {
    return tryResumeImpl(this, value, idempotent, onCancellation);
  };
  protoOf(CancellableContinuationImpl).qw = function (token) {
    // Inline function 'kotlinx.coroutines.assert' call
    dispatchResume(this, this.lx_1);
  };
  protoOf(CancellableContinuationImpl).sw = function (_this__u8e3s4, value) {
    var tmp = this.ex_1;
    var dc = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if ((dc == null ? null : dc.xw_1) === _this__u8e3s4) {
      tmp_0 = 4;
    } else {
      tmp_0 = this.lx_1;
    }
    resumeImpl$default(this, value, tmp_0);
  };
  protoOf(CancellableContinuationImpl).ry = function (state) {
    var tmp;
    if (state instanceof CompletedContinuation_0) {
      var tmp_0 = state.sx_1;
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    } else {
      tmp = (state == null ? true : !(state == null)) ? state : THROW_CCE();
    }
    return tmp;
  };
  protoOf(CancellableContinuationImpl).uy = function (state) {
    var tmp0_safe_receiver = protoOf(DispatchedTask).uy.call(this, state);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.getExceptionalResult.<anonymous>' call
      tmp = recoverStackTrace(tmp0_safe_receiver, this.ex_1);
    }
    return tmp;
  };
  protoOf(CancellableContinuationImpl).toString = function () {
    return this.vy() + '(' + toDebugString(this.ex_1) + '){' + _get_stateDebugRepresentation__bf18u4(this) + '}@' + get_hexAddress(this);
  };
  protoOf(CancellableContinuationImpl).vy = function () {
    return 'CancellableContinuation';
  };
  function NotCompleted() {
  }
  function CancelHandler() {
    CancelHandlerBase.call(this);
  }
  function Active() {
  }
  protoOf(Active).toString = function () {
    return 'Active';
  };
  var Active_instance;
  function Active_getInstance() {
    return Active_instance;
  }
  function CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    cancelHandler = cancelHandler === VOID ? null : cancelHandler;
    onCancellation = onCancellation === VOID ? null : onCancellation;
    idempotentResume = idempotentResume === VOID ? null : idempotentResume;
    cancelCause = cancelCause === VOID ? null : cancelCause;
    this.sx_1 = result;
    this.tx_1 = cancelHandler;
    this.ux_1 = onCancellation;
    this.vx_1 = idempotentResume;
    this.wx_1 = cancelCause;
  }
  protoOf(CompletedContinuation_0).yx = function () {
    return !(this.wx_1 == null);
  };
  protoOf(CompletedContinuation_0).ly = function (cont, cause) {
    var tmp0_safe_receiver = this.tx_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.CompletedContinuation.invokeHandlers.<anonymous>' call
      cont.xx(tmp0_safe_receiver, cause);
    }
    var tmp1_safe_receiver = this.ux_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.CompletedContinuation.invokeHandlers.<anonymous>' call
      cont.by(tmp1_safe_receiver, cause);
    }
  };
  protoOf(CompletedContinuation_0).yy = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    return new CompletedContinuation_0(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  protoOf(CompletedContinuation_0).zx = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause, $super) {
    result = result === VOID ? this.sx_1 : result;
    cancelHandler = cancelHandler === VOID ? this.tx_1 : cancelHandler;
    onCancellation = onCancellation === VOID ? this.ux_1 : onCancellation;
    idempotentResume = idempotentResume === VOID ? this.vx_1 : idempotentResume;
    cancelCause = cancelCause === VOID ? this.wx_1 : cancelCause;
    return $super === VOID ? this.yy(result, cancelHandler, onCancellation, idempotentResume, cancelCause) : $super.yy.call(this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  protoOf(CompletedContinuation_0).toString = function () {
    return 'CompletedContinuation(result=' + toString_0(this.sx_1) + ', cancelHandler=' + toString_0(this.tx_1) + ', onCancellation=' + toString_0(this.ux_1) + ', idempotentResume=' + toString_0(this.vx_1) + ', cancelCause=' + toString_0(this.wx_1) + ')';
  };
  protoOf(CompletedContinuation_0).hashCode = function () {
    var result = this.sx_1 == null ? 0 : hashCode(this.sx_1);
    result = imul(result, 31) + (this.tx_1 == null ? 0 : hashCode(this.tx_1)) | 0;
    result = imul(result, 31) + (this.ux_1 == null ? 0 : hashCode(this.ux_1)) | 0;
    result = imul(result, 31) + (this.vx_1 == null ? 0 : hashCode(this.vx_1)) | 0;
    result = imul(result, 31) + (this.wx_1 == null ? 0 : hashCode(this.wx_1)) | 0;
    return result;
  };
  protoOf(CompletedContinuation_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedContinuation_0))
      return false;
    var tmp0_other_with_cast = other instanceof CompletedContinuation_0 ? other : THROW_CCE();
    if (!equals(this.sx_1, tmp0_other_with_cast.sx_1))
      return false;
    if (!equals(this.tx_1, tmp0_other_with_cast.tx_1))
      return false;
    if (!equals(this.ux_1, tmp0_other_with_cast.ux_1))
      return false;
    if (!equals(this.vx_1, tmp0_other_with_cast.vx_1))
      return false;
    if (!equals(this.wx_1, tmp0_other_with_cast.wx_1))
      return false;
    return true;
  };
  function InvokeOnCancel(handler) {
    CancelHandler.call(this);
    this.zy_1 = handler;
  }
  protoOf(InvokeOnCancel).vw = function (cause) {
    this.zy_1(cause);
  };
  protoOf(InvokeOnCancel).invoke = function (cause) {
    return this.vw(cause);
  };
  protoOf(InvokeOnCancel).toString = function () {
    return 'InvokeOnCancel[' + get_classSimpleName(this.zy_1) + '@' + get_hexAddress(this) + ']';
  };
  var properties_initialized_CancellableContinuationImpl_kt_xtzb03;
  function _init_properties_CancellableContinuationImpl_kt__6rrtdd() {
    if (!properties_initialized_CancellableContinuationImpl_kt_xtzb03) {
      properties_initialized_CancellableContinuationImpl_kt_xtzb03 = true;
      RESUME_TOKEN = new Symbol_0('RESUME_TOKEN');
    }
  }
  function CompletableDeferred(parent) {
    parent = parent === VOID ? null : parent;
    return new CompletableDeferredImpl(parent);
  }
  function $awaitCOROUTINE$1(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.iz_1 = _this__u8e3s4;
  }
  protoOf($awaitCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.iz_1.ev(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return (suspendResult == null ? true : !(suspendResult == null)) ? suspendResult : THROW_CCE();
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function CompletableDeferredImpl(parent) {
    JobSupport.call(this, true);
    this.at(parent);
  }
  protoOf(CompletableDeferredImpl).nu = function () {
    return true;
  };
  protoOf(CompletableDeferredImpl).fw = function () {
    var tmp = this.dv();
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(CompletableDeferredImpl).gw = function ($completion) {
    var tmp = new $awaitCOROUTINE$1(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CompletableDeferredImpl).lz = function (value) {
    return this.mz(value);
  };
  protoOf(CompletableDeferredImpl).nz = function (exception) {
    return this.mz(new CompletedExceptionally(exception));
  };
  function CompletableJob() {
  }
  function CompletedExceptionally(cause, handled) {
    handled = handled === VOID ? false : handled;
    this.kt_1 = cause;
    this.lt_1 = atomic$boolean$1(handled);
  }
  protoOf(CompletedExceptionally).mt = function () {
    return this.lt_1.kotlinx$atomicfu$value;
  };
  protoOf(CompletedExceptionally).ay = function () {
    return this.lt_1.atomicfu$compareAndSet(false, true);
  };
  protoOf(CompletedExceptionally).toString = function () {
    return get_classSimpleName(this) + '[' + this.kt_1.toString() + ']';
  };
  function CancelledContinuation(continuation, cause, handled) {
    CompletedExceptionally.call(this, cause == null ? CancellationException_init_$Create$_0('Continuation ' + toString_1(continuation) + ' was cancelled normally') : cause, handled);
    this.ey_1 = atomic$boolean$1(false);
  }
  protoOf(CancelledContinuation).fy = function () {
    return this.ey_1.atomicfu$compareAndSet(false, true);
  };
  function toState(_this__u8e3s4, caller) {
    // Inline function 'kotlin.fold' call
    var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
    var tmp;
    if (exception == null) {
      var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
      // Inline function 'kotlinx.coroutines.toState.<anonymous>' call
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    } else {
      // Inline function 'kotlinx.coroutines.toState.<anonymous>' call
      tmp = new CompletedExceptionally(recoverStackTrace(exception, caller));
    }
    return tmp;
  }
  function toState_0(_this__u8e3s4, onCancellation) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    // Inline function 'kotlin.fold' call
    var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
    var tmp;
    if (exception == null) {
      var tmp_0 = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
      // Inline function 'kotlinx.coroutines.toState.<anonymous>' call
      var it = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
      tmp = !(onCancellation == null) ? new CompletedWithCancellation(it, onCancellation) : it;
    } else {
      // Inline function 'kotlinx.coroutines.toState.<anonymous>' call
      tmp = new CompletedExceptionally(exception);
    }
    return tmp;
  }
  function CompletedWithCancellation(result, onCancellation) {
    this.pz_1 = result;
    this.qz_1 = onCancellation;
  }
  protoOf(CompletedWithCancellation).toString = function () {
    return 'CompletedWithCancellation(result=' + toString_0(this.pz_1) + ', onCancellation=' + toString_1(this.qz_1) + ')';
  };
  protoOf(CompletedWithCancellation).hashCode = function () {
    var result = this.pz_1 == null ? 0 : hashCode(this.pz_1);
    result = imul(result, 31) + hashCode(this.qz_1) | 0;
    return result;
  };
  protoOf(CompletedWithCancellation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedWithCancellation))
      return false;
    var tmp0_other_with_cast = other instanceof CompletedWithCancellation ? other : THROW_CCE();
    if (!equals(this.pz_1, tmp0_other_with_cast.pz_1))
      return false;
    if (!equals(this.qz_1, tmp0_other_with_cast.qz_1))
      return false;
    return true;
  };
  function recoverResult(state, uCont) {
    var tmp;
    if (state instanceof CompletedExceptionally) {
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(state.kt_1, uCont);
      tmp = _Result___init__impl__xyqfz8(createFailure(exception));
    } else {
      // Inline function 'kotlin.Companion.success' call
      var value = (state == null ? true : !(state == null)) ? state : THROW_CCE();
      tmp = _Result___init__impl__xyqfz8(value);
    }
    return tmp;
  }
  function CoroutineDispatcher$Key$_init_$lambda_akl8b5(it) {
    return it instanceof CoroutineDispatcher ? it : null;
  }
  function Key_0() {
    Key_instance_0 = this;
    var tmp = Key_instance;
    AbstractCoroutineContextKey.call(this, tmp, CoroutineDispatcher$Key$_init_$lambda_akl8b5);
  }
  var Key_instance_0;
  function Key_getInstance_0() {
    if (Key_instance_0 == null)
      new Key_0();
    return Key_instance_0;
  }
  function CoroutineDispatcher() {
    Key_getInstance_0();
    AbstractCoroutineContextElement.call(this, Key_instance);
  }
  protoOf(CoroutineDispatcher).sz = function (context) {
    return true;
  };
  protoOf(CoroutineDispatcher).uz = function (context, block) {
    return this.tz(context, block);
  };
  protoOf(CoroutineDispatcher).ma = function (continuation) {
    return new DispatchedContinuation(this, continuation);
  };
  protoOf(CoroutineDispatcher).na = function (continuation) {
    var dispatched = continuation instanceof DispatchedContinuation ? continuation : THROW_CCE();
    dispatched.vz();
  };
  protoOf(CoroutineDispatcher).toString = function () {
    return get_classSimpleName(this) + '@' + get_hexAddress(this);
  };
  function handleCoroutineException(context, exception) {
    try {
      var tmp0_safe_receiver = context.la(Key_instance_1);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        tmp0_safe_receiver.wz(context, exception);
        return Unit_instance;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        handleUncaughtCoroutineException(context, handlerException(exception, t));
        return Unit_instance;
      } else {
        throw $p;
      }
    }
    handleUncaughtCoroutineException(context, exception);
  }
  function Key_1() {
  }
  var Key_instance_1;
  function Key_getInstance_1() {
    return Key_instance_1;
  }
  function handlerException(originalException, thrownException) {
    if (originalException === thrownException)
      return originalException;
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlinx.coroutines.handlerException.<anonymous>' call
    // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
    return RuntimeException_init_$Create$_1('Exception while trying to handle coroutine exception', thrownException);
  }
  function Key_2() {
  }
  var Key_instance_2;
  function Key_getInstance_2() {
    return Key_instance_2;
  }
  function CoroutineName(name) {
    AbstractCoroutineContextElement.call(this, Key_instance_2);
    this.yz_1 = name;
  }
  protoOf(CoroutineName).toString = function () {
    return 'CoroutineName(' + this.yz_1 + ')';
  };
  protoOf(CoroutineName).hashCode = function () {
    return getStringHashCode(this.yz_1);
  };
  protoOf(CoroutineName).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CoroutineName))
      return false;
    var tmp0_other_with_cast = other instanceof CoroutineName ? other : THROW_CCE();
    if (!(this.yz_1 === tmp0_other_with_cast.yz_1))
      return false;
    return true;
  };
  function CoroutineScope() {
  }
  function CoroutineScope_0(context) {
    return new ContextScope(!(context.la(Key_instance_3) == null) ? context : context.ej(Job_0()));
  }
  function cancel(_this__u8e3s4, cause) {
    cause = cause === VOID ? null : cause;
    var tmp0_elvis_lhs = _this__u8e3s4.et().la(Key_instance_3);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Scope cannot be cancelled because it does not have a job: ' + toString_1(_this__u8e3s4);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var job = tmp;
    job.ou(cause);
  }
  function cancel_0(_this__u8e3s4, message, cause) {
    cause = cause === VOID ? null : cause;
    return cancel(_this__u8e3s4, CancellationException_init_$Create$_1(message, cause));
  }
  function GlobalScope() {
  }
  protoOf(GlobalScope).et = function () {
    return EmptyCoroutineContext_getInstance();
  };
  var GlobalScope_instance;
  function GlobalScope_getInstance() {
    return GlobalScope_instance;
  }
  function coroutineScope(block, $completion) {
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.coroutineScope.<anonymous>' call
    var coroutine = new ScopeCoroutine($completion.ea(), $completion);
    return startUndispatchedOrReturn(coroutine, coroutine, block);
  }
  function get_isActive(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.et().la(Key_instance_3);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ft();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  }
  var CoroutineStart_DEFAULT_instance;
  var CoroutineStart_LAZY_instance;
  var CoroutineStart_ATOMIC_instance;
  var CoroutineStart_UNDISPATCHED_instance;
  var CoroutineStart_entriesInitialized;
  function CoroutineStart_initEntries() {
    if (CoroutineStart_entriesInitialized)
      return Unit_instance;
    CoroutineStart_entriesInitialized = true;
    CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
    CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
    CoroutineStart_ATOMIC_instance = new CoroutineStart('ATOMIC', 2);
    CoroutineStart_UNDISPATCHED_instance = new CoroutineStart('UNDISPATCHED', 3);
  }
  function CoroutineStart(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(CoroutineStart).vt = function (block, receiver, completion) {
    var tmp;
    switch (this.a3_1) {
      case 0:
        startCoroutineCancellable(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 2:
        startCoroutine(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 3:
        startCoroutineUndispatched(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 1:
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(CoroutineStart).fv = function () {
    return this === CoroutineStart_LAZY_getInstance();
  };
  function CoroutineStart_DEFAULT_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_DEFAULT_instance;
  }
  function CoroutineStart_LAZY_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_LAZY_instance;
  }
  function CoroutineStart_ATOMIC_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_ATOMIC_instance;
  }
  function CoroutineStart_UNDISPATCHED_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_UNDISPATCHED_instance;
  }
  function Delay() {
  }
  function get_delay(_this__u8e3s4) {
    var tmp = _this__u8e3s4.la(Key_instance);
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Delay) : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
  }
  function delay(timeMillis, $completion) {
    if (timeMillis.d1(new Long(0, 0)) <= 0)
      return Unit_instance;
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.iy();
    // Inline function 'kotlinx.coroutines.delay.<anonymous>' call
    if (timeMillis.d1(new Long(-1, 2147483647)) < 0) {
      get_delay(cancellable.ea()).zz(timeMillis, cancellable);
    }
    return cancellable.py();
  }
  function DelayWithTimeoutDiagnostics() {
  }
  function delay_0(duration, $completion) {
    return delay(toDelayMillis(duration), $completion);
  }
  function toDelayMillis(_this__u8e3s4) {
    return Duration__compareTo_impl_pchp0f(_this__u8e3s4, Companion_getInstance_16().ff_1) > 0 ? coerceAtLeast_0(_Duration___get_inWholeMilliseconds__impl__msfiry(_this__u8e3s4), new Long(1, 0)) : new Long(0, 0);
  }
  function delta($this, unconfined) {
    return unconfined ? new Long(0, 1) : new Long(1, 0);
  }
  function EventLoop() {
    CoroutineDispatcher.call(this);
    this.d10_1 = new Long(0, 0);
    this.e10_1 = false;
    this.f10_1 = null;
  }
  protoOf(EventLoop).g10 = function () {
    var tmp0_elvis_lhs = this.f10_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    var tmp1_elvis_lhs = queue.gg();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var task = tmp_0;
    task.wy();
    return true;
  };
  protoOf(EventLoop).h10 = function (task) {
    var tmp0_elvis_lhs = this.f10_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayDeque_init_$Create$();
      // Inline function 'kotlinx.coroutines.EventLoop.dispatchUnconfined.<anonymous>' call
      this.f10_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    queue.eg(task);
  };
  protoOf(EventLoop).i10 = function () {
    return this.d10_1.d1(delta(this, true)) >= 0;
  };
  protoOf(EventLoop).j10 = function () {
    var tmp0_safe_receiver = this.f10_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  };
  protoOf(EventLoop).k10 = function (unconfined) {
    this.d10_1 = this.d10_1.i3(delta(this, unconfined));
    if (!unconfined)
      this.e10_1 = true;
  };
  protoOf(EventLoop).l10 = function (unconfined) {
    this.d10_1 = this.d10_1.j3(delta(this, unconfined));
    if (this.d10_1.d1(new Long(0, 0)) > 0)
      return Unit_instance;
    // Inline function 'kotlinx.coroutines.assert' call
    if (this.e10_1) {
      this.m10();
    }
  };
  protoOf(EventLoop).m10 = function () {
  };
  function ThreadLocalEventLoop() {
    ThreadLocalEventLoop_instance = this;
    this.n10_1 = commonThreadLocal(new Symbol_0('ThreadLocalEventLoop'));
  }
  protoOf(ThreadLocalEventLoop).o10 = function () {
    var tmp0_elvis_lhs = this.n10_1.qr();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = createEventLoop();
      // Inline function 'kotlinx.coroutines.ThreadLocalEventLoop.<get-eventLoop>.<anonymous>' call
      ThreadLocalEventLoop_getInstance().n10_1.q10(this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var ThreadLocalEventLoop_instance;
  function ThreadLocalEventLoop_getInstance() {
    if (ThreadLocalEventLoop_instance == null)
      new ThreadLocalEventLoop();
    return ThreadLocalEventLoop_instance;
  }
  function CompletionHandlerException(message, cause) {
    RuntimeException_init_$Init$_1(message, cause, this);
    captureStack(this, CompletionHandlerException);
  }
  function CoroutinesInternalError(message, cause) {
    Error_init_$Init$_1(message, cause, this);
    captureStack(this, CoroutinesInternalError);
  }
  function DisposableHandle() {
  }
  function Key_3() {
  }
  var Key_instance_3;
  function Key_getInstance_3() {
    return Key_instance_3;
  }
  function Job() {
  }
  function ParentJob() {
  }
  function ChildHandle() {
  }
  function NonDisposableHandle() {
  }
  protoOf(NonDisposableHandle).yt = function () {
    return null;
  };
  protoOf(NonDisposableHandle).vr = function () {
  };
  protoOf(NonDisposableHandle).su = function (cause) {
    return false;
  };
  protoOf(NonDisposableHandle).toString = function () {
    return 'NonDisposableHandle';
  };
  var NonDisposableHandle_instance;
  function NonDisposableHandle_getInstance() {
    return NonDisposableHandle_instance;
  }
  function ensureActive(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.la(Key_instance_3);
    if (tmp0_safe_receiver == null)
      null;
    else {
      ensureActive_0(tmp0_safe_receiver);
    }
  }
  function ensureActive_0(_this__u8e3s4) {
    if (!_this__u8e3s4.ft())
      throw _this__u8e3s4.eu();
  }
  function Job_0(parent) {
    parent = parent === VOID ? null : parent;
    return new JobImpl(parent);
  }
  function cancel_1(_this__u8e3s4, message, cause) {
    cause = cause === VOID ? null : cause;
    return _this__u8e3s4.ou(CancellationException_init_$Create$_1(message, cause));
  }
  function get_job(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4.la(Key_instance_3);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = "Current context doesn't contain Job in it: " + toString_1(_this__u8e3s4);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function disposeOnCompletion(_this__u8e3s4, handle) {
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new DisposeOnCompletion(handle);
    return _this__u8e3s4.hu(tmp$ret$1);
  }
  function get_isActive_0(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.la(Key_instance_3);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ft();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  }
  function cancel_2(_this__u8e3s4, cause) {
    cause = cause === VOID ? null : cause;
    var tmp0_safe_receiver = _this__u8e3s4.la(Key_instance_3);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ou(cause);
    }
  }
  function get_COMPLETING_ALREADY() {
    _init_properties_JobSupport_kt__68f172();
    return COMPLETING_ALREADY;
  }
  var COMPLETING_ALREADY;
  function get_COMPLETING_WAITING_CHILDREN() {
    _init_properties_JobSupport_kt__68f172();
    return COMPLETING_WAITING_CHILDREN;
  }
  var COMPLETING_WAITING_CHILDREN;
  function get_COMPLETING_RETRY() {
    _init_properties_JobSupport_kt__68f172();
    return COMPLETING_RETRY;
  }
  var COMPLETING_RETRY;
  function get_TOO_LATE_TO_CANCEL() {
    _init_properties_JobSupport_kt__68f172();
    return TOO_LATE_TO_CANCEL;
  }
  var TOO_LATE_TO_CANCEL;
  function get_SEALED() {
    _init_properties_JobSupport_kt__68f172();
    return SEALED;
  }
  var SEALED;
  function get_EMPTY_NEW() {
    _init_properties_JobSupport_kt__68f172();
    return EMPTY_NEW;
  }
  var EMPTY_NEW;
  function get_EMPTY_ACTIVE() {
    _init_properties_JobSupport_kt__68f172();
    return EMPTY_ACTIVE;
  }
  var EMPTY_ACTIVE;
  function Empty(isActive) {
    this.r10_1 = isActive;
  }
  protoOf(Empty).ft = function () {
    return this.r10_1;
  };
  protoOf(Empty).s10 = function () {
    return null;
  };
  protoOf(Empty).toString = function () {
    return 'Empty{' + (this.r10_1 ? 'Active' : 'New') + '}';
  };
  function Incomplete() {
  }
  function NodeList() {
    LinkedListHead.call(this);
  }
  protoOf(NodeList).ft = function () {
    return true;
  };
  protoOf(NodeList).s10 = function () {
    return this;
  };
  protoOf(NodeList).w10 = function (state) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'kotlinx.coroutines.NodeList.getString.<anonymous>' call
    this_0.d9('List{');
    this_0.d9(state);
    this_0.d9('}[');
    var first = true;
    // Inline function 'kotlinx.coroutines.internal.LinkedListHead.forEach' call
    var cur = this.x10_1;
    while (!equals(cur, this)) {
      if (cur instanceof JobNode) {
        // Inline function 'kotlinx.coroutines.NodeList.getString.<anonymous>.<anonymous>' call
        var node = cur;
        if (first)
          first = false;
        else {
          this_0.d9(', ');
        }
        this_0.c9(node);
      }
      cur = cur.x10_1;
    }
    this_0.d9(']');
    return this_0.toString();
  };
  protoOf(NodeList).toString = function () {
    return get_DEBUG() ? this.w10('Active') : protoOf(LinkedListHead).toString.call(this);
  };
  function JobNode() {
    CompletionHandlerBase.call(this);
  }
  protoOf(JobNode).k11 = function () {
    var tmp = this.j11_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('job');
    }
  };
  protoOf(JobNode).ft = function () {
    return true;
  };
  protoOf(JobNode).s10 = function () {
    return null;
  };
  protoOf(JobNode).vr = function () {
    return this.k11().mu(this);
  };
  protoOf(JobNode).toString = function () {
    return get_classSimpleName(this) + '@' + get_hexAddress(this) + '[job@' + get_hexAddress(this.k11()) + ']';
  };
  function _set_exceptionsHolder__tqm22h($this, value) {
    $this.p11_1.kotlinx$atomicfu$value = value;
  }
  function _get_exceptionsHolder__nhszp($this) {
    return $this.p11_1.kotlinx$atomicfu$value;
  }
  function allocateList($this) {
    return ArrayList_init_$Create$_0(4);
  }
  function finalizeFinishingState($this, state, proposedUpdate) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kt_1;
    var wasCancelling;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    // Inline function 'kotlinx.coroutines.JobSupport.finalizeFinishingState.<anonymous>' call
    wasCancelling = state.q11();
    var exceptions = state.r11(proposedException);
    var finalCause = getFinalRootCause($this, state, exceptions);
    if (!(finalCause == null)) {
      addSuppressedExceptions($this, finalCause, exceptions);
    }
    var finalException = finalCause;
    var finalState = finalException == null ? proposedUpdate : finalException === proposedException ? proposedUpdate : new CompletedExceptionally(finalException);
    if (!(finalException == null)) {
      var handled = cancelParent($this, finalException) || $this.av(finalException);
      if (handled) {
        (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).ay();
      }
    }
    if (!wasCancelling) {
      $this.xu(finalException);
    }
    $this.jt(finalState);
    var casSuccess = $this.ys_1.atomicfu$compareAndSet(state, boxIncomplete(finalState));
    // Inline function 'kotlinx.coroutines.assert' call
    completeStateFinalization($this, state, finalState);
    return finalState;
  }
  function getFinalRootCause($this, state, exceptions) {
    if (exceptions.p()) {
      if (state.q11()) {
        // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
        return new JobCancellationException(null == null ? $this.it() : null, null, $this);
      }
      return null;
    }
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = exceptions.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlinx.coroutines.JobSupport.getFinalRootCause.<anonymous>' call
        if (!(element instanceof CancellationException)) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    var firstNonCancellation = tmp$ret$2;
    if (!(firstNonCancellation == null))
      return firstNonCancellation;
    var first = exceptions.q(0);
    if (first instanceof TimeoutCancellationException) {
      var tmp$ret$4;
      $l$block_0: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s_0 = exceptions.k();
        while (_iterator__ex2g4s_0.l()) {
          var element_0 = _iterator__ex2g4s_0.m();
          // Inline function 'kotlinx.coroutines.JobSupport.getFinalRootCause.<anonymous>' call
          var tmp;
          if (!(element_0 === first)) {
            tmp = element_0 instanceof TimeoutCancellationException;
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$4 = element_0;
            break $l$block_0;
          }
        }
        tmp$ret$4 = null;
      }
      var detailedTimeoutException = tmp$ret$4;
      if (!(detailedTimeoutException == null))
        return detailedTimeoutException;
    }
    return first;
  }
  function addSuppressedExceptions($this, rootCause, exceptions) {
    if (exceptions.n() <= 1)
      return Unit_instance;
    var seenExceptions = identitySet(exceptions.n());
    var unwrappedCause = unwrap(rootCause);
    var tmp0_iterator = exceptions.k();
    while (tmp0_iterator.l()) {
      var exception = tmp0_iterator.m();
      var unwrapped = unwrap(exception);
      var tmp;
      var tmp_0;
      if (!(unwrapped === rootCause) && !(unwrapped === unwrappedCause)) {
        tmp_0 = !(unwrapped instanceof CancellationException);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = seenExceptions.e(unwrapped);
      } else {
        tmp = false;
      }
      if (tmp) {
        // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
      }
    }
  }
  function tryFinalizeSimpleState($this, state, update) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    if (!$this.ys_1.atomicfu$compareAndSet(state, boxIncomplete(update)))
      return false;
    $this.xu(null);
    $this.jt(update);
    completeStateFinalization($this, state, update);
    return true;
  }
  function completeStateFinalization($this, state, update) {
    var tmp0_safe_receiver = $this.xt();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.JobSupport.completeStateFinalization.<anonymous>' call
      tmp0_safe_receiver.vr();
      $this.wt(NonDisposableHandle_instance);
    }
    var tmp1_safe_receiver = update instanceof CompletedExceptionally ? update : null;
    var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.kt_1;
    if (state instanceof JobNode) {
      try {
        state.invoke(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          $this.qt(new CompletionHandlerException('Exception in completion handler ' + toString_1(state) + ' for ' + $this.toString(), ex));
        } else {
          throw $p;
        }
      }
    } else {
      var tmp2_safe_receiver = state.s10();
      if (tmp2_safe_receiver == null)
        null;
      else {
        notifyCompletion(tmp2_safe_receiver, $this, cause);
      }
    }
  }
  function notifyCancelling($this, list, cause) {
    $this.xu(cause);
    // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
    var exception = null;
    // Inline function 'kotlinx.coroutines.internal.LinkedListHead.forEach' call
    var cur = list.x10_1;
    while (!equals(cur, list)) {
      if (cur instanceof JobCancellingNode) {
        // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>' call
        var node = cur;
        try {
          node.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var ex = $p;
            var tmp0_safe_receiver = exception;
            var tmp;
            if (tmp0_safe_receiver == null) {
              tmp = null;
            } else {
              // Inline function 'kotlin.apply' call
              // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>.<anonymous>' call
              // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
              tmp = tmp0_safe_receiver;
            }
            if (tmp == null) {
              // Inline function 'kotlin.run' call
              // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>.<anonymous>' call
              exception = new CompletionHandlerException('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
            }
          } else {
            throw $p;
          }
        }
      }
      cur = cur.x10_1;
    }
    var tmp0_safe_receiver_0 = exception;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>' call
      $this.qt(tmp0_safe_receiver_0);
    }
    cancelParent($this, cause);
  }
  function cancelParent($this, cause) {
    if ($this.yu())
      return true;
    var isCancellation = cause instanceof CancellationException;
    var parent = $this.xt();
    if (parent === null || parent === NonDisposableHandle_instance) {
      return isCancellation;
    }
    return parent.su(cause) || isCancellation;
  }
  function notifyCompletion(_this__u8e3s4, $this, cause) {
    var exception = null;
    // Inline function 'kotlinx.coroutines.internal.LinkedListHead.forEach' call
    var cur = _this__u8e3s4.x10_1;
    while (!equals(cur, _this__u8e3s4)) {
      if (cur instanceof JobNode) {
        // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>' call
        var node = cur;
        try {
          node.invoke(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var ex = $p;
            var tmp0_safe_receiver = exception;
            var tmp;
            if (tmp0_safe_receiver == null) {
              tmp = null;
            } else {
              // Inline function 'kotlin.apply' call
              // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>.<anonymous>' call
              // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
              tmp = tmp0_safe_receiver;
            }
            if (tmp == null) {
              // Inline function 'kotlin.run' call
              // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>.<anonymous>' call
              exception = new CompletionHandlerException('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
            }
          } else {
            throw $p;
          }
        }
      }
      cur = cur.x10_1;
    }
    var tmp0_safe_receiver_0 = exception;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers.<anonymous>' call
      $this.qt(tmp0_safe_receiver_0);
    }
    return Unit_instance;
  }
  function startInternal($this, state) {
    if (state instanceof Empty) {
      if (state.r10_1)
        return 0;
      if (!$this.ys_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
        return -1;
      $this.du();
      return 1;
    } else {
      if (state instanceof InactiveNodeList) {
        if (!$this.ys_1.atomicfu$compareAndSet(state, state.s11_1))
          return -1;
        $this.du();
        return 1;
      } else {
        return 0;
      }
    }
  }
  function makeNode($this, handler, onCancelling) {
    var tmp;
    if (onCancelling) {
      var tmp0_elvis_lhs = handler instanceof JobCancellingNode ? handler : null;
      tmp = tmp0_elvis_lhs == null ? new InvokeOnCancelling(handler) : tmp0_elvis_lhs;
    } else {
      var tmp1_safe_receiver = handler instanceof JobNode ? handler : null;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlinx.coroutines.JobSupport.makeNode.<anonymous>' call
        // Inline function 'kotlinx.coroutines.assert' call
        tmp_0 = tmp1_safe_receiver;
      }
      var tmp2_elvis_lhs = tmp_0;
      tmp = tmp2_elvis_lhs == null ? new InvokeOnCompletion(handler) : tmp2_elvis_lhs;
    }
    var node = tmp;
    node.j11_1 = $this;
    return node;
  }
  function addLastAtomic($this, expect, list, node) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.coroutines.internal.LinkedListNode.addLastIf' call
      // Inline function 'kotlinx.coroutines.JobSupport.addLastAtomic.<anonymous>' call
      if (!($this.zt() === expect)) {
        tmp$ret$1 = false;
        break $l$block;
      }
      list.e11(node);
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function promoteEmptyToNodeList($this, state) {
    var list = new NodeList();
    var update = state.r10_1 ? list : new InactiveNodeList(list);
    $this.ys_1.atomicfu$compareAndSet(state, update);
  }
  function promoteSingleToNodeList($this, state) {
    state.l11(new NodeList());
    // Inline function 'kotlinx.coroutines.internal.LinkedListNode.nextNode' call
    var list = state.x10_1;
    $this.ys_1.atomicfu$compareAndSet(state, list);
  }
  function joinInternal($this) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      // Inline function 'kotlinx.coroutines.JobSupport.joinInternal.<anonymous>' call
      var state = $this.zt();
      if (!(!(state == null) ? isInterface(state, Incomplete) : false))
        return false;
      if (startInternal($this, state) >= 0)
        return true;
    }
  }
  function joinSuspend($this, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.iy();
    // Inline function 'kotlinx.coroutines.JobSupport.joinSuspend.<anonymous>' call
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new ResumeOnCompletion(cancellable);
    disposeOnCancellation(cancellable, $this.hu(tmp$ret$1));
    return cancellable.py();
  }
  function registerSelectForOnJoin($this, select, ignoredParam) {
    if (!joinInternal($this)) {
      select.t11(Unit_instance);
      return Unit_instance;
    }
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new SelectOnJoinCompletionHandler($this, select);
    var disposableHandle = $this.hu(tmp$ret$1);
    select.u11(disposableHandle);
  }
  function SelectOnJoinCompletionHandler($outer, select) {
    this.a12_1 = $outer;
    JobNode.call(this);
    this.z11_1 = select;
  }
  protoOf(SelectOnJoinCompletionHandler).vw = function (cause) {
    this.z11_1.b12(this.a12_1, Unit_instance);
  };
  protoOf(SelectOnJoinCompletionHandler).invoke = function (cause) {
    return this.vw(cause);
  };
  function cancelMakeCompleting($this, cause) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      // Inline function 'kotlinx.coroutines.JobSupport.cancelMakeCompleting.<anonymous>' call
      var state = $this.zt();
      var tmp;
      if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
        tmp = true;
      } else {
        var tmp_0;
        if (state instanceof Finishing) {
          tmp_0 = state.c12();
        } else {
          tmp_0 = false;
        }
        tmp = tmp_0;
      }
      if (tmp) {
        return get_COMPLETING_ALREADY();
      }
      var proposedUpdate = new CompletedExceptionally(createCauseException($this, cause));
      var finalState = tryMakeCompleting($this, state, proposedUpdate);
      if (!(finalState === get_COMPLETING_RETRY()))
        return finalState;
    }
  }
  function createCauseException($this, cause) {
    var tmp;
    if (cause == null ? true : cause instanceof Error) {
      var tmp_0;
      if (cause == null) {
        // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
        tmp_0 = new JobCancellationException(null == null ? $this.it() : null, null, $this);
      } else {
        tmp_0 = cause;
      }
      tmp = tmp_0;
    } else {
      tmp = ((!(cause == null) ? isInterface(cause, ParentJob) : false) ? cause : THROW_CCE()).vu();
    }
    return tmp;
  }
  function makeCancelling($this, cause) {
    var causeExceptionCache = null;
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var tmp1 = $this.zt();
      $l$block: {
        // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>' call
        if (tmp1 instanceof Finishing) {
          // Inline function 'kotlinx.coroutines.internal.synchronized' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
          // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>' call
          if (tmp1.d12())
            return get_TOO_LATE_TO_CANCEL();
          var wasCancelling = tmp1.q11();
          if (!(cause == null) || !wasCancelling) {
            var tmp0_elvis_lhs = causeExceptionCache;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              // Inline function 'kotlin.also' call
              var this_0 = createCauseException($this, cause);
              // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>.<anonymous>' call
              causeExceptionCache = this_0;
              tmp = this_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var causeException = tmp;
            tmp1.e12(causeException);
          }
          // Inline function 'kotlin.takeIf' call
          var this_1 = tmp1.f12();
          var tmp_0;
          // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>.<anonymous>' call
          if (!wasCancelling) {
            tmp_0 = this_1;
          } else {
            tmp_0 = null;
          }
          var notifyRootCause = tmp_0;
          if (notifyRootCause == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>' call
            notifyCancelling($this, tmp1.m11_1, notifyRootCause);
          }
          return get_COMPLETING_ALREADY();
        } else {
          if (!(tmp1 == null) ? isInterface(tmp1, Incomplete) : false) {
            var tmp2_elvis_lhs = causeExceptionCache;
            var tmp_1;
            if (tmp2_elvis_lhs == null) {
              // Inline function 'kotlin.also' call
              var this_2 = createCauseException($this, cause);
              // Inline function 'kotlinx.coroutines.JobSupport.makeCancelling.<anonymous>.<anonymous>' call
              causeExceptionCache = this_2;
              tmp_1 = this_2;
            } else {
              tmp_1 = tmp2_elvis_lhs;
            }
            var causeException_0 = tmp_1;
            if (tmp1.ft()) {
              if (tryMakeCancelling($this, tmp1, causeException_0))
                return get_COMPLETING_ALREADY();
            } else {
              var finalState = tryMakeCompleting($this, tmp1, new CompletedExceptionally(causeException_0));
              if (finalState === get_COMPLETING_ALREADY()) {
                // Inline function 'kotlin.error' call
                var message = 'Cannot happen in ' + toString_0(tmp1);
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              } else if (finalState === get_COMPLETING_RETRY()) {
                break $l$block;
              } else
                return finalState;
            }
          } else {
            return get_TOO_LATE_TO_CANCEL();
          }
        }
      }
    }
  }
  function getOrPromoteCancellingList($this, state) {
    var tmp1_elvis_lhs = state.s10();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp_0;
      if (state instanceof Empty) {
        tmp_0 = new NodeList();
      } else {
        if (state instanceof JobNode) {
          promoteSingleToNodeList($this, state);
          tmp_0 = null;
        } else {
          var message = 'State should have list: ' + toString_1(state);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
      tmp = tmp_0;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryMakeCancelling($this, state, rootCause) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var cancelling = new Finishing(list, false, rootCause);
    if (!$this.ys_1.atomicfu$compareAndSet(state, cancelling))
      return false;
    notifyCancelling($this, list, rootCause);
    return true;
  }
  function tryMakeCompleting($this, state, proposedUpdate) {
    if (!(!(state == null) ? isInterface(state, Incomplete) : false))
      return get_COMPLETING_ALREADY();
    var tmp;
    var tmp_0;
    var tmp_1;
    if (state instanceof Empty) {
      tmp_1 = true;
    } else {
      tmp_1 = state instanceof JobNode;
    }
    if (tmp_1) {
      tmp_0 = !(state instanceof ChildHandleNode);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(proposedUpdate instanceof CompletedExceptionally);
    } else {
      tmp = false;
    }
    if (tmp) {
      if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
        return proposedUpdate;
      }
      return get_COMPLETING_RETRY();
    }
    return tryMakeCompletingSlowPath($this, state, proposedUpdate);
  }
  function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return get_COMPLETING_RETRY();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
    var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
    var notifyRootCause = null;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    if (finishing.c12())
      return get_COMPLETING_ALREADY();
    finishing.g12(true);
    if (!(finishing === state)) {
      if (!$this.ys_1.atomicfu$compareAndSet(state, finishing))
        return get_COMPLETING_RETRY();
    }
    // Inline function 'kotlinx.coroutines.assert' call
    var wasCancelling = finishing.q11();
    var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.JobSupport.tryMakeCompletingSlowPath.<anonymous>.<anonymous>' call
      finishing.e12(tmp0_safe_receiver.kt_1);
    }
    // Inline function 'kotlin.takeIf' call
    var this_0 = finishing.f12();
    var tmp_0;
    // Inline function 'kotlinx.coroutines.JobSupport.tryMakeCompletingSlowPath.<anonymous>.<anonymous>' call
    if (!wasCancelling) {
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    notifyRootCause = tmp_0;
    var tmp2_safe_receiver = notifyRootCause;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.JobSupport.tryMakeCompletingSlowPath.<anonymous>' call
      notifyCancelling($this, list, tmp2_safe_receiver);
    }
    var child = firstChild($this, state);
    if (!(child == null) && tryWaitForChild($this, finishing, child, proposedUpdate))
      return get_COMPLETING_WAITING_CHILDREN();
    return finalizeFinishingState($this, finishing, proposedUpdate);
  }
  function _get_exceptionOrNull__b3j7js(_this__u8e3s4, $this) {
    var tmp0_safe_receiver = _this__u8e3s4 instanceof CompletedExceptionally ? _this__u8e3s4 : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kt_1;
  }
  function firstChild($this, state) {
    var tmp1_elvis_lhs = state instanceof ChildHandleNode ? state : null;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp0_safe_receiver = state.s10();
      tmp = tmp0_safe_receiver == null ? null : nextChild(tmp0_safe_receiver, $this);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function tryWaitForChild($this, state, child, proposedUpdate) {
    var $this_0 = $this;
    var state_0 = state;
    var child_0 = child;
    var proposedUpdate_0 = proposedUpdate;
    $l$1: do {
      $l$0: do {
        var tmp = child_0.l12_1;
        // Inline function 'kotlinx.coroutines.asHandler' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = new ChildCompletion($this_0, state_0, child_0, proposedUpdate_0);
        var handle = tmp.ju(VOID, false, tmp$ret$1);
        if (!(handle === NonDisposableHandle_instance))
          return true;
        var tmp0_elvis_lhs = nextChild(child_0, $this_0);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var nextChild_0 = tmp_0;
        var tmp0 = $this_0;
        var tmp1 = state_0;
        var tmp3 = proposedUpdate_0;
        $this_0 = tmp0;
        state_0 = tmp1;
        child_0 = nextChild_0;
        proposedUpdate_0 = tmp3;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function continueCompleting($this, state, lastChild, proposedUpdate) {
    // Inline function 'kotlinx.coroutines.assert' call
    var waitChild = nextChild(lastChild, $this);
    if (!(waitChild == null) && tryWaitForChild($this, state, waitChild, proposedUpdate))
      return Unit_instance;
    var finalState = finalizeFinishingState($this, state, proposedUpdate);
    $this.pt(finalState);
  }
  function nextChild(_this__u8e3s4, $this) {
    var cur = _this__u8e3s4;
    $l$loop: while (true) {
      // Inline function 'kotlinx.coroutines.internal.LinkedListNode.isRemoved' call
      if (!cur.z10_1) {
        break $l$loop;
      }
      // Inline function 'kotlinx.coroutines.internal.LinkedListNode.prevNode' call
      cur = cur.y10_1;
    }
    $l$loop_0: while (true) {
      // Inline function 'kotlinx.coroutines.internal.LinkedListNode.nextNode' call
      cur = cur.x10_1;
      // Inline function 'kotlinx.coroutines.internal.LinkedListNode.isRemoved' call
      if (cur.z10_1)
        continue $l$loop_0;
      if (cur instanceof ChildHandleNode)
        return cur;
      if (cur instanceof NodeList)
        return null;
    }
  }
  function stateString($this, state) {
    var tmp;
    if (state instanceof Finishing) {
      tmp = state.q11() ? 'Cancelling' : state.c12() ? 'Completing' : 'Active';
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        tmp = state.ft() ? 'Active' : 'New';
      } else {
        if (state instanceof CompletedExceptionally) {
          tmp = 'Cancelled';
        } else {
          tmp = 'Completed';
        }
      }
    }
    return tmp;
  }
  function Finishing(list, isCompleting, rootCause) {
    this.m11_1 = list;
    this.n11_1 = atomic$boolean$1(isCompleting);
    this.o11_1 = atomic$ref$1(rootCause);
    this.p11_1 = atomic$ref$1(null);
  }
  protoOf(Finishing).s10 = function () {
    return this.m11_1;
  };
  protoOf(Finishing).g12 = function (value) {
    this.n11_1.kotlinx$atomicfu$value = value;
  };
  protoOf(Finishing).c12 = function () {
    return this.n11_1.kotlinx$atomicfu$value;
  };
  protoOf(Finishing).m12 = function (value) {
    this.o11_1.kotlinx$atomicfu$value = value;
  };
  protoOf(Finishing).f12 = function () {
    return this.o11_1.kotlinx$atomicfu$value;
  };
  protoOf(Finishing).d12 = function () {
    return _get_exceptionsHolder__nhszp(this) === get_SEALED();
  };
  protoOf(Finishing).q11 = function () {
    return !(this.f12() == null);
  };
  protoOf(Finishing).ft = function () {
    return this.f12() == null;
  };
  protoOf(Finishing).r11 = function (proposedException) {
    var eh = _get_exceptionsHolder__nhszp(this);
    var tmp;
    if (eh == null) {
      tmp = allocateList(this);
    } else {
      if (eh instanceof Error) {
        // Inline function 'kotlin.also' call
        var this_0 = allocateList(this);
        // Inline function 'kotlinx.coroutines.Finishing.sealLocked.<anonymous>' call
        this_0.e(eh);
        tmp = this_0;
      } else {
        if (eh instanceof ArrayList) {
          tmp = eh instanceof ArrayList ? eh : THROW_CCE();
        } else {
          var message = 'State is ' + toString_0(eh);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
    }
    var list = tmp;
    var rootCause = this.f12();
    if (rootCause == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.Finishing.sealLocked.<anonymous>' call
      list.p2(0, rootCause);
    }
    if (!(proposedException == null) && !equals(proposedException, rootCause)) {
      list.e(proposedException);
    }
    _set_exceptionsHolder__tqm22h(this, get_SEALED());
    return list;
  };
  protoOf(Finishing).e12 = function (exception) {
    var rootCause = this.f12();
    if (rootCause == null) {
      this.m12(exception);
      return Unit_instance;
    }
    if (exception === rootCause)
      return Unit_instance;
    var eh = _get_exceptionsHolder__nhszp(this);
    if (eh == null) {
      _set_exceptionsHolder__tqm22h(this, exception);
    } else {
      if (eh instanceof Error) {
        if (exception === eh)
          return Unit_instance;
        // Inline function 'kotlin.apply' call
        var this_0 = allocateList(this);
        // Inline function 'kotlinx.coroutines.Finishing.addExceptionLocked.<anonymous>' call
        this_0.e(eh);
        this_0.e(exception);
        _set_exceptionsHolder__tqm22h(this, this_0);
      } else {
        if (eh instanceof ArrayList) {
          (eh instanceof ArrayList ? eh : THROW_CCE()).e(exception);
        } else {
          // Inline function 'kotlin.error' call
          var message = 'State is ' + toString_0(eh);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
    }
  };
  protoOf(Finishing).toString = function () {
    return 'Finishing[cancelling=' + this.q11() + ', completing=' + this.c12() + ', rootCause=' + toString_0(this.f12()) + ', exceptions=' + toString_0(_get_exceptionsHolder__nhszp(this)) + ', list=' + this.m11_1.toString() + ']';
  };
  function ChildCompletion(parent, state, child, proposedUpdate) {
    JobNode.call(this);
    this.r12_1 = parent;
    this.s12_1 = state;
    this.t12_1 = child;
    this.u12_1 = proposedUpdate;
  }
  protoOf(ChildCompletion).vw = function (cause) {
    continueCompleting(this.r12_1, this.s12_1, this.t12_1, this.u12_1);
  };
  protoOf(ChildCompletion).invoke = function (cause) {
    return this.vw(cause);
  };
  function AwaitContinuation(delegate, job) {
    CancellableContinuationImpl.call(this, delegate, 1);
    this.b13_1 = job;
  }
  protoOf(AwaitContinuation).oy = function (parent) {
    var state = this.b13_1.zt();
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state.f12();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        return tmp0_safe_receiver;
      }
    }
    if (state instanceof CompletedExceptionally)
      return state.kt_1;
    return parent.eu();
  };
  protoOf(AwaitContinuation).vy = function () {
    return 'AwaitContinuation';
  };
  function awaitSuspend($this, $completion) {
    // Inline function 'kotlinx.coroutines.JobSupport.awaitSuspend.<anonymous>' call
    var cont = new AwaitContinuation(intercepted($completion), $this);
    cont.iy();
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new ResumeAwaitOnCompletion(cont);
    disposeOnCancellation(cont, $this.hu(tmp$ret$1));
    return cont.py();
  }
  function JobSupport$registerSelectForOnJoin$ref() {
    var l = function (p0, p1, p2) {
      registerSelectForOnJoin(p0, p1, p2);
      return Unit_instance;
    };
    l.callableName = 'registerSelectForOnJoin';
    return l;
  }
  function JobSupport(active) {
    this.ys_1 = atomic$ref$1(active ? get_EMPTY_ACTIVE() : get_EMPTY_NEW());
    this.zs_1 = atomic$ref$1(null);
  }
  protoOf(JobSupport).x = function () {
    return Key_instance_3;
  };
  protoOf(JobSupport).wt = function (value) {
    this.zs_1.kotlinx$atomicfu$value = value;
  };
  protoOf(JobSupport).xt = function () {
    return this.zs_1.kotlinx$atomicfu$value;
  };
  protoOf(JobSupport).yt = function () {
    var tmp0_safe_receiver = this.xt();
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.yt();
  };
  protoOf(JobSupport).at = function (parent) {
    // Inline function 'kotlinx.coroutines.assert' call
    if (parent == null) {
      this.wt(NonDisposableHandle_instance);
      return Unit_instance;
    }
    parent.cu();
    var handle = parent.wu(this);
    this.wt(handle);
    if (this.au()) {
      handle.vr();
      this.wt(NonDisposableHandle_instance);
    }
  };
  protoOf(JobSupport).zt = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.ys_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.JobSupport.<get-state>.<anonymous>' call
      var state = this_0.kotlinx$atomicfu$value;
      if (!(state instanceof OpDescriptor))
        return state;
      state.c13(this);
    }
  };
  protoOf(JobSupport).ft = function () {
    var state = this.zt();
    var tmp;
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state.ft();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(JobSupport).au = function () {
    var tmp = this.zt();
    return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
  };
  protoOf(JobSupport).bu = function () {
    var state = this.zt();
    var tmp;
    if (state instanceof CompletedExceptionally) {
      tmp = true;
    } else {
      var tmp_0;
      if (state instanceof Finishing) {
        tmp_0 = state.q11();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(JobSupport).cu = function () {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      // Inline function 'kotlinx.coroutines.JobSupport.start.<anonymous>' call
      var state = this.zt();
      var tmp0_subject = startInternal(this, state);
      if (tmp0_subject === 0)
        return false;
      else if (tmp0_subject === 1)
        return true;
    }
  };
  protoOf(JobSupport).du = function () {
  };
  protoOf(JobSupport).eu = function () {
    var state = this.zt();
    var tmp;
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state.f12();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.fu(tmp0_safe_receiver, get_classSimpleName(this) + ' is cancelling');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var message = 'Job is still new or active: ' + this.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        var message_0 = 'Job is still new or active: ' + this.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        if (state instanceof CompletedExceptionally) {
          tmp = this.gu(state.kt_1);
        } else {
          tmp = new JobCancellationException(get_classSimpleName(this) + ' has completed normally', null, this);
        }
      }
    }
    return tmp;
  };
  protoOf(JobSupport).fu = function (_this__u8e3s4, message) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof CancellationException ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = new JobCancellationException(message == null ? this.it() : message, _this__u8e3s4, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(JobSupport).gu = function (_this__u8e3s4, message, $super) {
    message = message === VOID ? null : message;
    return $super === VOID ? this.fu(_this__u8e3s4, message) : $super.fu.call(this, _this__u8e3s4, message);
  };
  protoOf(JobSupport).hu = function (handler) {
    return this.iu(false, true, handler);
  };
  protoOf(JobSupport).iu = function (onCancelling, invokeImmediately, handler) {
    var node = makeNode(this, handler, onCancelling);
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var tmp1 = this.zt();
      $l$block: {
        // Inline function 'kotlinx.coroutines.JobSupport.invokeOnCompletion.<anonymous>' call
        if (tmp1 instanceof Empty) {
          if (tmp1.r10_1) {
            if (this.ys_1.atomicfu$compareAndSet(tmp1, node))
              return node;
          } else {
            promoteEmptyToNodeList(this, tmp1);
          }
        } else {
          if (!(tmp1 == null) ? isInterface(tmp1, Incomplete) : false) {
            var list = tmp1.s10();
            if (list == null) {
              promoteSingleToNodeList(this, tmp1 instanceof JobNode ? tmp1 : THROW_CCE());
            } else {
              var rootCause = null;
              var handle = NonDisposableHandle_instance;
              var tmp;
              if (onCancelling) {
                tmp = tmp1 instanceof Finishing;
              } else {
                tmp = false;
              }
              if (tmp) {
                // Inline function 'kotlinx.coroutines.internal.synchronized' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
                rootCause = tmp1.f12();
                var tmp_0;
                if (rootCause == null) {
                  tmp_0 = true;
                } else {
                  var tmp_1;
                  // Inline function 'kotlinx.coroutines.isHandlerOf' call
                  if (handler instanceof ChildHandleNode) {
                    tmp_1 = !tmp1.c12();
                  } else {
                    tmp_1 = false;
                  }
                  tmp_0 = tmp_1;
                }
                if (tmp_0) {
                  if (!addLastAtomic(this, tmp1, list, node)) {
                    break $l$block;
                  }
                  if (rootCause == null)
                    return node;
                  handle = node;
                }
              }
              if (!(rootCause == null)) {
                if (invokeImmediately) {
                  invokeIt(handler, rootCause);
                }
                return handle;
              } else {
                if (addLastAtomic(this, tmp1, list, node))
                  return node;
              }
            }
          } else {
            if (invokeImmediately) {
              var tmp1_safe_receiver = tmp1 instanceof CompletedExceptionally ? tmp1 : null;
              invokeIt(handler, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.kt_1);
            }
            return NonDisposableHandle_instance;
          }
        }
      }
    }
  };
  protoOf(JobSupport).ku = function ($completion) {
    if (!joinInternal(this)) {
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp$ret$0 = $completion.ea();
      ensureActive(tmp$ret$0);
      return Unit_instance;
    }
    return joinSuspend(this, $completion);
  };
  protoOf(JobSupport).lu = function () {
    var tmp = JobSupport$registerSelectForOnJoin$ref();
    return new SelectClause0Impl(this, typeof tmp === 'function' ? tmp : THROW_CCE());
  };
  protoOf(JobSupport).mu = function (node) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      // Inline function 'kotlinx.coroutines.JobSupport.removeNode.<anonymous>' call
      var state = this.zt();
      if (state instanceof JobNode) {
        if (!(state === node))
          return Unit_instance;
        if (this.ys_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
          return Unit_instance;
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          if (!(state.s10() == null)) {
            node.d11();
          }
          return Unit_instance;
        } else {
          return Unit_instance;
        }
      }
    }
  };
  protoOf(JobSupport).nu = function () {
    return false;
  };
  protoOf(JobSupport).ou = function (cause) {
    var tmp;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = new JobCancellationException(null == null ? this.it() : null, null, this);
    } else {
      tmp = cause;
    }
    this.qu(tmp);
  };
  protoOf(JobSupport).it = function () {
    return 'Job was cancelled';
  };
  protoOf(JobSupport).qu = function (cause) {
    this.uu(cause);
  };
  protoOf(JobSupport).ru = function (parentJob) {
    this.uu(parentJob);
  };
  protoOf(JobSupport).su = function (cause) {
    if (cause instanceof CancellationException)
      return true;
    return this.uu(cause) && this.zu();
  };
  protoOf(JobSupport).tu = function (cause) {
    return this.uu(cause);
  };
  protoOf(JobSupport).uu = function (cause) {
    var finalState = get_COMPLETING_ALREADY();
    if (this.nu()) {
      finalState = cancelMakeCompleting(this, cause);
      if (finalState === get_COMPLETING_WAITING_CHILDREN())
        return true;
    }
    if (finalState === get_COMPLETING_ALREADY()) {
      finalState = makeCancelling(this, cause);
    }
    var tmp;
    if (finalState === get_COMPLETING_ALREADY()) {
      tmp = true;
    } else if (finalState === get_COMPLETING_WAITING_CHILDREN()) {
      tmp = true;
    } else if (finalState === get_TOO_LATE_TO_CANCEL()) {
      tmp = false;
    } else {
      this.pt(finalState);
      tmp = true;
    }
    return tmp;
  };
  protoOf(JobSupport).vu = function () {
    var state = this.zt();
    var tmp;
    if (state instanceof Finishing) {
      tmp = state.f12();
    } else {
      if (state instanceof CompletedExceptionally) {
        tmp = state.kt_1;
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          var message = 'Cannot be cancelling child in this state: ' + toString_0(state);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          tmp = null;
        }
      }
    }
    var rootCause = tmp;
    var tmp1_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
    return tmp1_elvis_lhs == null ? new JobCancellationException('Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
  };
  protoOf(JobSupport).mz = function (proposedUpdate) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var tmp1 = this.zt();
      $l$block: {
        // Inline function 'kotlinx.coroutines.JobSupport.makeCompleting.<anonymous>' call
        var finalState = tryMakeCompleting(this, tmp1, proposedUpdate);
        if (finalState === get_COMPLETING_ALREADY())
          return false;
        else if (finalState === get_COMPLETING_WAITING_CHILDREN())
          return true;
        else if (finalState === get_COMPLETING_RETRY()) {
          break $l$block;
        } else {
          this.pt(finalState);
          return true;
        }
      }
    }
  };
  protoOf(JobSupport).nt = function (proposedUpdate) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var tmp1 = this.zt();
      $l$block: {
        // Inline function 'kotlinx.coroutines.JobSupport.makeCompletingOnce.<anonymous>' call
        var finalState = tryMakeCompleting(this, tmp1, proposedUpdate);
        if (finalState === get_COMPLETING_ALREADY())
          throw IllegalStateException_init_$Create$_1('Job ' + this.toString() + ' is already complete or completing, ' + ('but is being completed with ' + toString_0(proposedUpdate)), _get_exceptionOrNull__b3j7js(proposedUpdate, this));
        else if (finalState === get_COMPLETING_RETRY()) {
          break $l$block;
        } else
          return finalState;
      }
    }
  };
  protoOf(JobSupport).wu = function (child) {
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new ChildHandleNode(child);
    var tmp = this.ju(true, VOID, tmp$ret$1);
    return isInterface(tmp, ChildHandle) ? tmp : THROW_CCE();
  };
  protoOf(JobSupport).qt = function (exception) {
    throw exception;
  };
  protoOf(JobSupport).xu = function (cause) {
  };
  protoOf(JobSupport).yu = function () {
    return false;
  };
  protoOf(JobSupport).zu = function () {
    return true;
  };
  protoOf(JobSupport).av = function (exception) {
    return false;
  };
  protoOf(JobSupport).jt = function (state) {
  };
  protoOf(JobSupport).pt = function (state) {
  };
  protoOf(JobSupport).toString = function () {
    return this.bv() + '@' + get_hexAddress(this);
  };
  protoOf(JobSupport).bv = function () {
    return this.rt() + '{' + stateString(this, this.zt()) + '}';
  };
  protoOf(JobSupport).rt = function () {
    return get_classSimpleName(this);
  };
  protoOf(JobSupport).cv = function () {
    var state = this.zt();
    // Inline function 'kotlin.check' call
    if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
      // Inline function 'kotlinx.coroutines.JobSupport.getCompletionExceptionOrNull.<anonymous>' call
      var message = 'This job has not completed yet';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return _get_exceptionOrNull__b3j7js(state, this);
  };
  protoOf(JobSupport).dv = function () {
    var state = this.zt();
    // Inline function 'kotlin.check' call
    if (!!(!(state == null) ? isInterface(state, Incomplete) : false)) {
      // Inline function 'kotlinx.coroutines.JobSupport.getCompletedInternal.<anonymous>' call
      var message = 'This job has not completed yet';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (state instanceof CompletedExceptionally)
      throw state.kt_1;
    return unboxState(state);
  };
  protoOf(JobSupport).ev = function ($completion) {
    $l$loop: while (true) {
      var state = this.zt();
      if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
        if (state instanceof CompletedExceptionally) {
          // Inline function 'kotlinx.coroutines.internal.recoverAndThrow' call
          throw state.kt_1;
        }
        return unboxState(state);
      }
      if (startInternal(this, state) >= 0)
        break $l$loop;
    }
    return awaitSuspend(this, $completion);
  };
  function boxIncomplete(_this__u8e3s4) {
    _init_properties_JobSupport_kt__68f172();
    var tmp;
    if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Incomplete) : false) {
      tmp = new IncompleteStateBox(_this__u8e3s4);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function JobCancellingNode() {
    JobNode.call(this);
  }
  function InactiveNodeList(list) {
    this.s11_1 = list;
  }
  protoOf(InactiveNodeList).s10 = function () {
    return this.s11_1;
  };
  protoOf(InactiveNodeList).ft = function () {
    return false;
  };
  protoOf(InactiveNodeList).toString = function () {
    return get_DEBUG() ? this.s11_1.w10('New') : anyToString(this);
  };
  function ChildHandleNode(childJob) {
    JobCancellingNode.call(this);
    this.l12_1 = childJob;
  }
  protoOf(ChildHandleNode).yt = function () {
    return this.k11();
  };
  protoOf(ChildHandleNode).vw = function (cause) {
    return this.l12_1.ru(this.k11());
  };
  protoOf(ChildHandleNode).invoke = function (cause) {
    return this.vw(cause);
  };
  protoOf(ChildHandleNode).su = function (cause) {
    return this.k11().su(cause);
  };
  function InvokeOnCancelling(handler) {
    JobCancellingNode.call(this);
    this.h13_1 = handler;
    this.i13_1 = atomic$int$1(0);
  }
  protoOf(InvokeOnCancelling).vw = function (cause) {
    if (this.i13_1.atomicfu$compareAndSet(0, 1))
      this.h13_1(cause);
  };
  protoOf(InvokeOnCancelling).invoke = function (cause) {
    return this.vw(cause);
  };
  function InvokeOnCompletion(handler) {
    JobNode.call(this);
    this.n13_1 = handler;
  }
  protoOf(InvokeOnCompletion).vw = function (cause) {
    return this.n13_1(cause);
  };
  protoOf(InvokeOnCompletion).invoke = function (cause) {
    return this.vw(cause);
  };
  function ResumeOnCompletion(continuation) {
    JobNode.call(this);
    this.s13_1 = continuation;
  }
  protoOf(ResumeOnCompletion).vw = function (cause) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = this.s13_1;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    this_0.ja(tmp$ret$0);
    return Unit_instance;
  };
  protoOf(ResumeOnCompletion).invoke = function (cause) {
    return this.vw(cause);
  };
  function unboxState(_this__u8e3s4) {
    _init_properties_JobSupport_kt__68f172();
    var tmp0_safe_receiver = _this__u8e3s4 instanceof IncompleteStateBox ? _this__u8e3s4 : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t13_1;
    return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
  }
  function ResumeAwaitOnCompletion(continuation) {
    JobNode.call(this);
    this.y13_1 = continuation;
  }
  protoOf(ResumeAwaitOnCompletion).vw = function (cause) {
    var state = this.k11().zt();
    // Inline function 'kotlinx.coroutines.assert' call
    if (state instanceof CompletedExceptionally) {
      var tmp0 = this.y13_1;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = state.kt_1;
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0.ja(tmp$ret$0);
    } else {
      var tmp2 = this.y13_1;
      var tmp = unboxState(state);
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
      tmp2.ja(tmp$ret$2);
    }
  };
  protoOf(ResumeAwaitOnCompletion).invoke = function (cause) {
    return this.vw(cause);
  };
  function IncompleteStateBox(state) {
    this.t13_1 = state;
  }
  function ChildContinuation(child) {
    JobCancellingNode.call(this);
    this.d14_1 = child;
  }
  protoOf(ChildContinuation).vw = function (cause) {
    this.d14_1.ny(this.d14_1.oy(this.k11()));
  };
  protoOf(ChildContinuation).invoke = function (cause) {
    return this.vw(cause);
  };
  function handlesExceptionF($this) {
    var tmp = $this.xt();
    var tmp0_safe_receiver = tmp instanceof ChildHandleNode ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k11();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var parentJob = tmp_0;
    while (true) {
      if (parentJob.zu())
        return true;
      var tmp_1 = parentJob.xt();
      var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode ? tmp_1 : null;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.k11();
      var tmp_2;
      if (tmp3_elvis_lhs == null) {
        return false;
      } else {
        tmp_2 = tmp3_elvis_lhs;
      }
      parentJob = tmp_2;
    }
  }
  function JobImpl(parent) {
    JobSupport.call(this, true);
    this.at(parent);
    this.g14_1 = handlesExceptionF(this);
  }
  protoOf(JobImpl).nu = function () {
    return true;
  };
  protoOf(JobImpl).zu = function () {
    return this.g14_1;
  };
  protoOf(JobImpl).oz = function () {
    return this.mz(Unit_instance);
  };
  protoOf(JobImpl).nz = function (exception) {
    return this.mz(new CompletedExceptionally(exception));
  };
  function DisposeOnCompletion(handle) {
    JobNode.call(this);
    this.l14_1 = handle;
  }
  protoOf(DisposeOnCompletion).vw = function (cause) {
    return this.l14_1.vr();
  };
  protoOf(DisposeOnCompletion).invoke = function (cause) {
    return this.vw(cause);
  };
  var properties_initialized_JobSupport_kt_5iq8a4;
  function _init_properties_JobSupport_kt__68f172() {
    if (!properties_initialized_JobSupport_kt_5iq8a4) {
      properties_initialized_JobSupport_kt_5iq8a4 = true;
      COMPLETING_ALREADY = new Symbol_0('COMPLETING_ALREADY');
      COMPLETING_WAITING_CHILDREN = new Symbol_0('COMPLETING_WAITING_CHILDREN');
      COMPLETING_RETRY = new Symbol_0('COMPLETING_RETRY');
      TOO_LATE_TO_CANCEL = new Symbol_0('TOO_LATE_TO_CANCEL');
      SEALED = new Symbol_0('SEALED');
      EMPTY_NEW = new Empty(false);
      EMPTY_ACTIVE = new Empty(true);
    }
  }
  function MainCoroutineDispatcher() {
    CoroutineDispatcher.call(this);
  }
  protoOf(MainCoroutineDispatcher).toString = function () {
    var tmp0_elvis_lhs = this.o14();
    return tmp0_elvis_lhs == null ? get_classSimpleName(this) + '@' + get_hexAddress(this) : tmp0_elvis_lhs;
  };
  protoOf(MainCoroutineDispatcher).o14 = function () {
    var main = Dispatchers_getInstance().t14();
    if (this === main)
      return 'Dispatchers.Main';
    var tmp;
    try {
      tmp = main.n14();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof UnsupportedOperationException) {
        var e = $p;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var immediate = tmp;
    if (this === immediate)
      return 'Dispatchers.Main.immediate';
    return null;
  };
  function SupervisorJob(parent) {
    parent = parent === VOID ? null : parent;
    return new SupervisorJobImpl(parent);
  }
  function SupervisorJobImpl(parent) {
    JobImpl.call(this, parent);
  }
  protoOf(SupervisorJobImpl).su = function (cause) {
    return false;
  };
  function TimeoutCancellationException(message, coroutine) {
    CancellationException_init_$Init$_0(message, this);
    captureStack(this, TimeoutCancellationException);
    this.x14_1 = coroutine;
  }
  function withTimeoutOrNull(timeMillis, block, $completion) {
    var tmp = new $withTimeoutOrNullCOROUTINE$2(timeMillis, block, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function TimeoutCoroutine(time, uCont) {
    ScopeCoroutine.call(this, uCont.ea(), uCont);
    this.n15_1 = time;
  }
  protoOf(TimeoutCoroutine).wy = function () {
    this.tu(TimeoutCancellationException_0(this.n15_1, get_delay(this.dt_1), this));
  };
  protoOf(TimeoutCoroutine).rt = function () {
    return protoOf(ScopeCoroutine).rt.call(this) + '(timeMillis=' + this.n15_1.toString() + ')';
  };
  function setupTimeout(coroutine, block) {
    var cont = coroutine.ow_1;
    var context = cont.ea();
    disposeOnCompletion(coroutine, get_delay(context).a10(coroutine.n15_1, coroutine, coroutine.dt_1));
    return startUndispatchedOrReturnIgnoreTimeout(coroutine, coroutine, block);
  }
  function TimeoutCancellationException_0(time, delay, coroutine) {
    var tmp0_safe_receiver = isInterface(delay, DelayWithTimeoutDiagnostics) ? delay : null;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance_16();
      var tmp$ret$0 = toDuration_0(time, DurationUnit_MILLISECONDS_getInstance());
      tmp = tmp0_safe_receiver.b10(tmp$ret$0);
    }
    var tmp1_elvis_lhs = tmp;
    var message = tmp1_elvis_lhs == null ? 'Timed out waiting for ' + time.toString() + ' ms' : tmp1_elvis_lhs;
    return new TimeoutCancellationException(message, coroutine);
  }
  function $withTimeoutOrNullCOROUTINE$2(timeMillis, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g15_1 = timeMillis;
    this.h15_1 = block;
  }
  protoOf($withTimeoutOrNullCOROUTINE$2).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            if (this.g15_1.d1(new Long(0, 0)) <= 0)
              return null;
            this.i15_1 = {_v: null};
            this.z9_1 = 2;
            this.y9_1 = 1;
            var timeoutCoroutine = new TimeoutCoroutine(this.g15_1, this);
            this.i15_1._v = timeoutCoroutine;
            suspendResult = returnIfSuspended(setupTimeout(timeoutCoroutine, this.h15_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            this.z9_1 = 3;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof TimeoutCancellationException) {
              var e = this.ba_1;
              if (e.x14_1 === this.i15_1._v) {
                return null;
              }
              throw e;
            } else {
              throw this.ba_1;
            }

          case 3:
            throw this.ba_1;
          case 4:
            this.z9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 3) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  function Unconfined() {
    Unconfined_instance = this;
    CoroutineDispatcher.call(this);
  }
  protoOf(Unconfined).sz = function (context) {
    return false;
  };
  protoOf(Unconfined).tz = function (context, block) {
    var yieldContext = context.la(Key_instance_4);
    if (!(yieldContext == null)) {
      yieldContext.q15_1 = true;
      return Unit_instance;
    }
    throw UnsupportedOperationException_init_$Create$_0('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
  };
  protoOf(Unconfined).toString = function () {
    return 'Dispatchers.Unconfined';
  };
  var Unconfined_instance;
  function Unconfined_getInstance() {
    if (Unconfined_instance == null)
      new Unconfined();
    return Unconfined_instance;
  }
  function Key_4() {
  }
  var Key_instance_4;
  function Key_getInstance_4() {
    return Key_instance_4;
  }
  function YieldContext() {
    AbstractCoroutineContextElement.call(this, Key_instance_4);
    this.q15_1 = false;
  }
  function Waiter() {
  }
  function yield_0($completion) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.yield.<anonymous>' call
      var context = $completion.ea();
      ensureActive(context);
      var tmp = intercepted($completion);
      var tmp0_elvis_lhs = tmp instanceof DispatchedContinuation ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var cont = tmp_0;
      if (cont.xw_1.sz(context)) {
        cont.r15(context, Unit_instance);
      } else {
        var yieldContext = new YieldContext();
        cont.r15(context.ej(yieldContext), Unit_instance);
        if (yieldContext.q15_1) {
          tmp$ret$0 = yieldUndispatched(cont) ? get_COROUTINE_SUSPENDED() : Unit_instance;
          break $l$block_0;
        }
      }
      tmp$ret$0 = get_COROUTINE_SUSPENDED();
    }
    return tmp$ret$0;
  }
  var BufferOverflow_SUSPEND_instance;
  var BufferOverflow_DROP_OLDEST_instance;
  var BufferOverflow_DROP_LATEST_instance;
  var BufferOverflow_entriesInitialized;
  function BufferOverflow_initEntries() {
    if (BufferOverflow_entriesInitialized)
      return Unit_instance;
    BufferOverflow_entriesInitialized = true;
    BufferOverflow_SUSPEND_instance = new BufferOverflow('SUSPEND', 0);
    BufferOverflow_DROP_OLDEST_instance = new BufferOverflow('DROP_OLDEST', 1);
    BufferOverflow_DROP_LATEST_instance = new BufferOverflow('DROP_LATEST', 2);
  }
  function BufferOverflow(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function BufferOverflow_SUSPEND_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_SUSPEND_instance;
  }
  function BufferOverflow_DROP_OLDEST_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_DROP_OLDEST_instance;
  }
  function BufferOverflow_DROP_LATEST_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_DROP_LATEST_instance;
  }
  function get_NULL_SEGMENT() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return NULL_SEGMENT;
  }
  var NULL_SEGMENT;
  function get_SEGMENT_SIZE() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return SEGMENT_SIZE;
  }
  var SEGMENT_SIZE;
  function get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
  }
  var EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
  function get_BUFFERED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return BUFFERED;
  }
  var BUFFERED;
  function get_IN_BUFFER() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return IN_BUFFER;
  }
  var IN_BUFFER;
  function get_RESUMING_BY_RCV() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return RESUMING_BY_RCV;
  }
  var RESUMING_BY_RCV;
  function get_RESUMING_BY_EB() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return RESUMING_BY_EB;
  }
  var RESUMING_BY_EB;
  function get_POISONED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return POISONED;
  }
  var POISONED;
  function get_DONE_RCV() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return DONE_RCV;
  }
  var DONE_RCV;
  function get_INTERRUPTED_SEND() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return INTERRUPTED_SEND;
  }
  var INTERRUPTED_SEND;
  function get_INTERRUPTED_RCV() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return INTERRUPTED_RCV;
  }
  var INTERRUPTED_RCV;
  function get_CHANNEL_CLOSED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return CHANNEL_CLOSED;
  }
  var CHANNEL_CLOSED;
  function get_SUSPEND() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return SUSPEND;
  }
  var SUSPEND;
  function get_SUSPEND_NO_WAITER() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return SUSPEND_NO_WAITER;
  }
  var SUSPEND_NO_WAITER;
  function get_FAILED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return FAILED;
  }
  var FAILED;
  function get_NO_RECEIVE_RESULT() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return NO_RECEIVE_RESULT;
  }
  var NO_RECEIVE_RESULT;
  function get_CLOSE_HANDLER_CLOSED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return CLOSE_HANDLER_CLOSED;
  }
  var CLOSE_HANDLER_CLOSED;
  function get_CLOSE_HANDLER_INVOKED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return CLOSE_HANDLER_INVOKED;
  }
  var CLOSE_HANDLER_INVOKED;
  function get_NO_CLOSE_CAUSE() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return NO_CLOSE_CAUSE;
  }
  var NO_CLOSE_CAUSE;
  function setElementLazy($this, index, value) {
    // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
    $this.x15_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value = value;
  }
  function ChannelSegment(id, prev, channel, pointers) {
    Segment.call(this, id, prev, pointers);
    this.w15_1 = channel;
    this.x15_1 = atomicfu$AtomicRefArray$ofNulls(imul(get_SEGMENT_SIZE(), 2));
  }
  protoOf(ChannelSegment).y15 = function () {
    return ensureNotNull(this.w15_1);
  };
  protoOf(ChannelSegment).z15 = function () {
    return get_SEGMENT_SIZE();
  };
  protoOf(ChannelSegment).a16 = function (index, element) {
    setElementLazy(this, index, element);
  };
  protoOf(ChannelSegment).b16 = function (index) {
    var tmp = this.x15_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(ChannelSegment).c16 = function (index) {
    // Inline function 'kotlin.also' call
    var this_0 = this.b16(index);
    // Inline function 'kotlinx.coroutines.channels.ChannelSegment.retrieveElement.<anonymous>' call
    this.d16(index);
    return this_0;
  };
  protoOf(ChannelSegment).d16 = function (index) {
    setElementLazy(this, index, null);
  };
  protoOf(ChannelSegment).e16 = function (index) {
    return this.x15_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value;
  };
  protoOf(ChannelSegment).f16 = function (index, value) {
    this.x15_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value = value;
  };
  protoOf(ChannelSegment).g16 = function (index, from, to) {
    return this.x15_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$compareAndSet(from, to);
  };
  protoOf(ChannelSegment).h16 = function (index, update) {
    return this.x15_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$getAndSet(update);
  };
  protoOf(ChannelSegment).rx = function (index, cause, context) {
    var isSender = index >= get_SEGMENT_SIZE();
    var index_0 = isSender ? index - get_SEGMENT_SIZE() | 0 : index;
    var element = this.b16(index_0);
    $l$loop: while (true) {
      var cur = this.e16(index_0);
      var tmp;
      if (!(cur == null) ? isInterface(cur, Waiter) : false) {
        tmp = true;
      } else {
        tmp = cur instanceof WaiterEB;
      }
      if (tmp) {
        var update = isSender ? get_INTERRUPTED_SEND() : get_INTERRUPTED_RCV();
        if (this.g16(index_0, cur, update)) {
          this.d16(index_0);
          this.u16(index_0, !isSender);
          if (isSender) {
            var tmp0_safe_receiver = this.y15().j16_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              callUndeliveredElement(tmp0_safe_receiver, element, context);
            }
          }
          return Unit_instance;
        }
      } else {
        if (cur === get_INTERRUPTED_SEND() || cur === get_INTERRUPTED_RCV()) {
          this.d16(index_0);
          if (isSender) {
            var tmp1_safe_receiver = this.y15().j16_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              callUndeliveredElement(tmp1_safe_receiver, element, context);
            }
          }
          return Unit_instance;
        } else {
          if (cur === get_RESUMING_BY_EB() || cur === get_RESUMING_BY_RCV())
            continue $l$loop;
          else {
            if (cur === get_DONE_RCV() || cur === get_BUFFERED())
              return Unit_instance;
            else {
              if (cur === get_CHANNEL_CLOSED())
                return Unit_instance;
              else {
                // Inline function 'kotlin.error' call
                var message = 'unexpected state: ' + toString_0(cur);
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              }
            }
          }
        }
      }
    }
  };
  protoOf(ChannelSegment).u16 = function (index, receiver) {
    if (receiver) {
      var tmp = this.y15();
      var tmp0 = this.px_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$1 = tmp0.k3(toLong(other)).i3(toLong(index));
      tmp.v16(tmp$ret$1);
    }
    this.w16();
  };
  function onClosedHasNext($this) {
    $this.i17_1 = get_CHANNEL_CLOSED();
    var tmp0_elvis_lhs = $this.k17_1.l17();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var cause = tmp;
    throw recoverStackTrace_0(cause);
  }
  function hasNextOnNoWaiterSuspend($this, segment, index, r, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable.<anonymous>' call
    var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
    try {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannelIterator.hasNextOnNoWaiterSuspend.<anonymous>' call
      $this.j17_1 = cancellable;
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var this_0 = $this.k17_1;
      var updCellResult = updateCellReceive(this_0, segment, index, r, $this);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension($this, this_0, segment, index);
      } else if (updCellResult === get_FAILED()) {
        if (r.d1(this_0.m17()) < 0) {
          segment.g17();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = this_0.p16_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if (this_0.n17()) {
              // Inline function 'kotlinx.coroutines.channels.BufferedChannelIterator.hasNextOnNoWaiterSuspend.<anonymous>.<anonymous>' call
              onClosedHasNextNoWaiterSuspend($this);
              break $l$block_0;
            }
            var r_0 = this_0.l16_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = r_0.l3(toLong(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var i = r_0.m3(toLong(other_0)).z3();
            if (!segment_0.px_1.equals(id)) {
              var tmp0_elvis_lhs = findSegmentReceive(this_0, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive(this_0, segment_0, i, r_0, $this);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!($this == null) ? isInterface($this, Waiter) : false) ? $this : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(tmp1_safe_receiver, this_0, segment_0, i);
              }
              // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter.<anonymous>' call
            } else if (updCellResult_0 === get_FAILED()) {
              if (r_0.d1(this_0.m17()) < 0) {
                segment_0.g17();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl.<anonymous>' call
              var message = 'unexpected';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else {
              segment_0.g17();
              // Inline function 'kotlinx.coroutines.channels.BufferedChannelIterator.hasNextOnNoWaiterSuspend.<anonymous>.<anonymous>' call
              var element = (updCellResult_0 == null ? true : !(updCellResult_0 == null)) ? updCellResult_0 : THROW_CCE();
              $this.i17_1 = element;
              $this.j17_1 = null;
              var tmp0_safe_receiver = $this.k17_1.j16_1;
              cancellable.tw(true, tmp0_safe_receiver == null ? null : bindCancellationFun(tmp0_safe_receiver, element, cancellable.ea()));
            }
            break $l$block_0;
          }
        }
      } else {
        segment.g17();
        // Inline function 'kotlinx.coroutines.channels.BufferedChannelIterator.hasNextOnNoWaiterSuspend.<anonymous>.<anonymous>' call
        var element_0 = (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
        $this.i17_1 = element_0;
        $this.j17_1 = null;
        var tmp0_safe_receiver_0 = $this.k17_1.j16_1;
        cancellable.tw(true, tmp0_safe_receiver_0 == null ? null : bindCancellationFun(tmp0_safe_receiver_0, element_0, cancellable.ea()));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.qy();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.py();
  }
  function onClosedHasNextNoWaiterSuspend($this) {
    var cont = ensureNotNull($this.j17_1);
    $this.j17_1 = null;
    $this.i17_1 = get_CHANNEL_CLOSED();
    var cause = $this.k17_1.l17();
    if (cause == null) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
      cont.ja(tmp$ret$0);
    } else {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(cause, cont);
      var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
      cont.ja(tmp$ret$2);
    }
  }
  function $hasNextCOROUTINE$6(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w17_1 = _this__u8e3s4;
  }
  protoOf($hasNextCOROUTINE$6).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 8;
            var tmp_0 = this;
            tmp_0.x17_1 = this.w17_1.k17_1;
            var tmp_1 = this;
            tmp_1.y17_1 = null;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.a18_1 = this.x17_1;
            this.b18_1 = this.y17_1;
            this.c18_1 = this.a18_1.p16_1.kotlinx$atomicfu$value;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.y9_1 = 9;
              continue $sm;
            }

            if (this.a18_1.n17()) {
              var tmp_2 = this;
              tmp_2.z17_1 = onClosedHasNext(this.w17_1);
              this.y9_1 = 10;
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            this.d18_1 = this.a18_1.l16_1.atomicfu$getAndIncrement$long();
            var tmp_3 = this;
            var tmp0 = this.d18_1;
            var other = get_SEGMENT_SIZE();
            tmp_3.e18_1 = tmp0.l3(toLong(other));
            var tmp_4 = this;
            var tmp2 = this.d18_1;
            var other_0 = get_SEGMENT_SIZE();
            tmp_4.f18_1 = tmp2.m3(toLong(other_0)).z3();
            if (!this.c18_1.px_1.equals(this.e18_1)) {
              this.g18_1 = findSegmentReceive(this.a18_1, this.e18_1, this.c18_1);
              if (this.g18_1 == null) {
                this.y9_1 = 2;
                var tmp_5 = this;
                continue $sm;
              } else {
                this.h18_1 = this.g18_1;
                this.y9_1 = 4;
                continue $sm;
              }
            } else {
              this.y9_1 = 5;
              continue $sm;
            }

          case 4:
            this.c18_1 = this.h18_1;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.i18_1 = updateCellReceive(this.a18_1, this.c18_1, this.f18_1, this.d18_1, this.b18_1);
            if (this.i18_1 === get_SUSPEND()) {
              var tmp_6 = this;
              var tmp_7 = this.b18_1;
              var tmp1_safe_receiver = (!(tmp_7 == null) ? isInterface(tmp_7, Waiter) : false) ? tmp_7 : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(tmp1_safe_receiver, this.a18_1, this.c18_1, this.f18_1);
              }
              this.c18_1;
              this.f18_1;
              this.d18_1;
              var message = 'unreachable';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else {
              if (this.i18_1 === get_FAILED()) {
                if (this.d18_1.d1(this.a18_1.m17()) < 0) {
                  this.c18_1.g17();
                }
                this.y9_1 = 2;
                var tmp_8 = this;
                continue $sm;
              } else {
                if (this.i18_1 === get_SUSPEND_NO_WAITER()) {
                  var tmp_9 = this;
                  tmp_9.k18_1 = this.c18_1;
                  var tmp_10 = this;
                  tmp_10.l18_1 = this.f18_1;
                  var tmp_11 = this;
                  tmp_11.m18_1 = this.d18_1;
                  this.n18_1 = this.k18_1;
                  this.o18_1 = this.l18_1;
                  this.p18_1 = this.m18_1;
                  this.y9_1 = 6;
                  suspendResult = hasNextOnNoWaiterSuspend(this.w17_1, this.n18_1, this.o18_1, this.p18_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_12 = this;
                  this.c18_1.g17();
                  var tmp_13 = this.i18_1;
                  var element = (tmp_13 == null ? true : !(tmp_13 == null)) ? tmp_13 : THROW_CCE();
                  this.w17_1.i17_1 = element;
                  tmp_12.j18_1 = true;
                  this.y9_1 = 7;
                  continue $sm;
                }
              }
            }

          case 6:
            var tmp_14 = this;
            return suspendResult;
          case 7:
            this.z17_1 = this.j18_1;
            this.y9_1 = 10;
            continue $sm;
          case 8:
            throw this.ba_1;
          case 9:
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 10;
            continue $sm;
          case 10:
            return this.z17_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 8) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function _get_bufferEndCounter__2d4hee($this) {
    return $this.m16_1.kotlinx$atomicfu$value;
  }
  function _get_isRendezvousOrUnlimited__3mdufi($this) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.<get-isRendezvousOrUnlimited>.<anonymous>' call
    var it = _get_bufferEndCounter__2d4hee($this);
    return it.equals(new Long(0, 0)) || it.equals(new Long(-1, 2147483647));
  }
  function onClosedSend($this, element, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.iy();
    $l$block: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.onClosedSend.<anonymous>' call
      var tmp0_safe_receiver = $this.j16_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        addSuppressed(tmp1_safe_receiver, $this.q18());
        // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = recoverStackTrace(tmp1_safe_receiver, cancellable);
        var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
        cancellable.ja(tmp$ret$0);
        break $l$block;
      }
      // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
      var exception_0 = $this.q18();
      // Inline function 'kotlin.Companion.failure' call
      var exception_1 = recoverStackTrace(exception_0, cancellable);
      var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception_1));
      cancellable.ja(tmp$ret$3);
    }
    return cancellable.py();
  }
  function sendOnNoWaiterSuspend($this, segment, index, element, s, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable.<anonymous>' call
    var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
    try {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendOnNoWaiterSuspend.<anonymous>' call
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImplOnNoWaiter' call
      switch (updateCellSend($this, segment, index, element, s, cancellable, false)) {
        case 0:
          segment.g17();
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendOnNoWaiterSuspend.<anonymous>.<anonymous>' call

          // Inline function 'kotlin.coroutines.resume' call

          // Inline function 'kotlin.Companion.success' call

          var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
          cancellable.ja(tmp$ret$0);
          break;
        case 1:
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendOnNoWaiterSuspend.<anonymous>.<anonymous>' call

          // Inline function 'kotlin.coroutines.resume' call

          // Inline function 'kotlin.Companion.success' call

          var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
          cancellable.ja(tmp$ret$2);
          break;
        case 2:
          prepareSenderForSuspension(cancellable, $this, segment, index);
          break;
        case 4:
          if (s.d1($this.r18()) < 0) {
            segment.g17();
          }

          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendOnNoWaiterSuspend.<anonymous>.<anonymous>' call

          onClosedSendOnNoWaiterSuspend($this, element, cancellable);
          break;
        case 5:
          segment.g17();
          $l$block_5: {
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
            var segment_0 = access$_get_sendSegment__111kgq($this).kotlinx$atomicfu$value;
            $l$loop_0: while (true) {
              var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s($this).atomicfu$getAndIncrement$long();
              // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
              var s_0 = sendersAndCloseStatusCur.u3(access$_get_SENDERS_COUNTER_MASK_$tBufferedChannelKt_6ll4te());
              var closed = access$_get_isClosedForSend0__sm8f7a($this, sendersAndCloseStatusCur);
              // Inline function 'kotlin.Long.div' call
              var other = get_SEGMENT_SIZE();
              var id = s_0.l3(toLong(other));
              // Inline function 'kotlin.Long.rem' call
              var other_0 = get_SEGMENT_SIZE();
              var i = s_0.m3(toLong(other_0)).z3();
              if (!segment_0.px_1.equals(id)) {
                var tmp0_elvis_lhs = access$findSegmentSend($this, id, segment_0);
                var tmp;
                if (tmp0_elvis_lhs == null) {
                  var tmp_0;
                  if (closed) {
                    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendOnNoWaiterSuspend.<anonymous>.<anonymous>' call
                    onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                    break $l$block_5;
                  } else {
                    continue $l$loop_0;
                  }
                } else {
                  tmp = tmp0_elvis_lhs;
                }
                segment_0 = tmp;
              }
              var tmp1_subject = access$updateCellSend($this, segment_0, i, element, s_0, cancellable, closed);
              if (tmp1_subject === access$_get_RESULT_RENDEZVOUS_$tBufferedChannelKt_ykevfn()) {
                segment_0.g17();
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendOnNoWaiterSuspend.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.coroutines.resume' call
                // Inline function 'kotlin.Companion.success' call
                var tmp$ret$8 = _Result___init__impl__xyqfz8(Unit_instance);
                cancellable.ja(tmp$ret$8);
                break $l$block_5;
              } else if (tmp1_subject === access$_get_RESULT_BUFFERED_$tBufferedChannelKt_tnykj7()) {
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendOnNoWaiterSuspend.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.coroutines.resume' call
                // Inline function 'kotlin.Companion.success' call
                var tmp$ret$10 = _Result___init__impl__xyqfz8(Unit_instance);
                cancellable.ja(tmp$ret$10);
                break $l$block_5;
              } else if (tmp1_subject === access$_get_RESULT_SUSPEND_$tBufferedChannelKt_vus6es()) {
                if (closed) {
                  segment_0.w16();
                  // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendOnNoWaiterSuspend.<anonymous>.<anonymous>' call
                  onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                  break $l$block_5;
                }
                var tmp2_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter) : false) ? cancellable : null;
                if (tmp2_safe_receiver == null)
                  null;
                else {
                  access$prepareSenderForSuspension($this, tmp2_safe_receiver, segment_0, i);
                }
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImplOnNoWaiter.<anonymous>' call
                break $l$block_5;
              } else if (tmp1_subject === access$_get_RESULT_CLOSED_$tBufferedChannelKt_3eqb16()) {
                if (s_0.d1($this.r18()) < 0) {
                  segment_0.g17();
                }
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendOnNoWaiterSuspend.<anonymous>.<anonymous>' call
                onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                break $l$block_5;
              } else if (tmp1_subject === access$_get_RESULT_FAILED_$tBufferedChannelKt_wacckr()) {
                segment_0.g17();
                continue $l$loop_0;
              } else if (tmp1_subject === access$_get_RESULT_SUSPEND_NO_WAITER_$tBufferedChannelKt_61h09f()) {
                // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl.<anonymous>' call
                var message = 'unexpected';
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              }
            }
          }

          break;
        default:
          // Inline function 'kotlin.error' call

          var message_0 = 'unexpected';
          throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.qy();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.py();
  }
  function prepareSenderForSuspension(_this__u8e3s4, $this, segment, index) {
    _this__u8e3s4.ty(segment, index + get_SEGMENT_SIZE() | 0);
  }
  function onClosedSendOnNoWaiterSuspend($this, element, cont) {
    var tmp0_safe_receiver = $this.j16_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      callUndeliveredElement(tmp0_safe_receiver, element, cont.ea());
    }
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace($this.q18(), cont);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    cont.ja(tmp$ret$0);
  }
  function SendBroadcast() {
  }
  function updateCellSend($this, segment, index, element, s, waiter, closed) {
    segment.a16(index, element);
    if (closed)
      return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
    var state = segment.e16(index);
    if (state === null) {
      if (bufferOrRendezvousSend($this, s)) {
        if (segment.g16(index, null, get_BUFFERED())) {
          return 1;
        }
      } else {
        if (waiter == null) {
          return 3;
        } else {
          if (segment.g16(index, null, waiter))
            return 2;
        }
      }
    } else {
      if (!(state == null) ? isInterface(state, Waiter) : false) {
        segment.d16(index);
        var tmp;
        if (tryResumeReceiver(state, $this, element)) {
          segment.f16(index, get_DONE_RCV());
          $this.s18();
          tmp = 0;
        } else {
          if (!(segment.h16(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
            segment.u16(index, true);
          }
          tmp = 5;
        }
        return tmp;
      }
    }
    return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
  }
  function updateCellSendSlow($this, segment, index, element, s, waiter, closed) {
    while (true) {
      var state = segment.e16(index);
      if (state === null) {
        if (bufferOrRendezvousSend($this, s) && !closed) {
          if (segment.g16(index, null, get_BUFFERED())) {
            return 1;
          }
        } else {
          if (closed) {
            if (segment.g16(index, null, get_INTERRUPTED_SEND())) {
              segment.u16(index, false);
              return 4;
            }
          } else if (waiter == null)
            return 3;
          else if (segment.g16(index, null, waiter))
            return 2;
        }
      } else if (state === get_IN_BUFFER()) {
        if (segment.g16(index, state, get_BUFFERED())) {
          return 1;
        }
      } else if (state === get_INTERRUPTED_RCV()) {
        segment.d16(index);
        return 5;
      } else if (state === get_POISONED()) {
        segment.d16(index);
        return 5;
      } else if (state === get_CHANNEL_CLOSED()) {
        segment.d16(index);
        completeCloseOrCancel($this);
        return 4;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        segment.d16(index);
        var tmp;
        if (state instanceof WaiterEB) {
          tmp = state.t18_1;
        } else {
          tmp = state;
        }
        var receiver = tmp;
        var tmp_0;
        if (tryResumeReceiver(receiver, $this, element)) {
          segment.f16(index, get_DONE_RCV());
          $this.s18();
          tmp_0 = 0;
        } else {
          if (!(segment.h16(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
            segment.u16(index, true);
          }
          tmp_0 = 5;
        }
        return tmp_0;
      }
    }
  }
  function shouldSendSuspend0($this, curSendersAndCloseStatus) {
    if (_get_isClosedForSend0__kxgf9m(curSendersAndCloseStatus, $this))
      return false;
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var tmp$ret$0 = curSendersAndCloseStatus.u3(new Long(-1, 268435455));
    return !bufferOrRendezvousSend($this, tmp$ret$0);
  }
  function bufferOrRendezvousSend($this, curSenders) {
    var tmp;
    if (curSenders.d1(_get_bufferEndCounter__2d4hee($this)) < 0) {
      tmp = true;
    } else {
      var tmp0 = $this.r18();
      // Inline function 'kotlin.Long.plus' call
      var other = $this.i16_1;
      var tmp$ret$0 = tmp0.i3(toLong(other));
      tmp = curSenders.d1(tmp$ret$0) < 0;
    }
    return tmp;
  }
  function tryResumeReceiver(_this__u8e3s4, $this, element) {
    var tmp;
    if (isInterface(_this__u8e3s4, SelectInstance)) {
      tmp = _this__u8e3s4.b12($this, element);
    } else {
      if (_this__u8e3s4 instanceof ReceiveCatching) {
        if (!(_this__u8e3s4 instanceof ReceiveCatching))
          THROW_CCE();
        var tmp_0 = Companion_getInstance_27().w18(element);
        var tmp1_safe_receiver = $this.j16_1;
        tmp = tryResume0(_this__u8e3s4.x18_1, new ChannelResult(tmp_0), tmp1_safe_receiver == null ? null : bindCancellationFun(tmp1_safe_receiver, element, _this__u8e3s4.x18_1.ea()));
      } else {
        if (_this__u8e3s4 instanceof BufferedChannelIterator) {
          if (!(_this__u8e3s4 instanceof BufferedChannelIterator))
            THROW_CCE();
          tmp = _this__u8e3s4.u18(element);
        } else {
          if (isInterface(_this__u8e3s4, CancellableContinuation)) {
            if (!isInterface(_this__u8e3s4, CancellableContinuation))
              THROW_CCE();
            var tmp2_safe_receiver = $this.j16_1;
            tmp = tryResume0(_this__u8e3s4, element, tmp2_safe_receiver == null ? null : bindCancellationFun(tmp2_safe_receiver, element, _this__u8e3s4.ea()));
          } else {
            var message = 'Unexpected receiver type: ' + toString_1(_this__u8e3s4);
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
        }
      }
    }
    return tmp;
  }
  function receiveOnNoWaiterSuspend($this, segment, index, r, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutineReusable.<anonymous>' call
    var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
    try {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveOnNoWaiterSuspend.<anonymous>' call
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var updCellResult = updateCellReceive($this, segment, index, r, cancellable);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension(cancellable, $this, segment, index);
      } else if (updCellResult === get_FAILED()) {
        if (r.d1($this.m17()) < 0) {
          segment.g17();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = $this.p16_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if ($this.n17()) {
              // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveOnNoWaiterSuspend.<anonymous>.<anonymous>' call
              onClosedReceiveOnNoWaiterSuspend($this, cancellable);
              break $l$block_0;
            }
            var r_0 = $this.l16_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = r_0.l3(toLong(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var i = r_0.m3(toLong(other_0)).z3();
            if (!segment_0.px_1.equals(id)) {
              var tmp0_elvis_lhs = findSegmentReceive($this, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive($this, segment_0, i, r_0, cancellable);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter) : false) ? cancellable : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(tmp1_safe_receiver, $this, segment_0, i);
              }
              // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter.<anonymous>' call
            } else if (updCellResult_0 === get_FAILED()) {
              if (r_0.d1($this.m17()) < 0) {
                segment_0.g17();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl.<anonymous>' call
              var message = 'unexpected';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else {
              segment_0.g17();
              // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveOnNoWaiterSuspend.<anonymous>.<anonymous>' call
              var element = (updCellResult_0 == null ? true : !(updCellResult_0 == null)) ? updCellResult_0 : THROW_CCE();
              var tmp0_safe_receiver = $this.j16_1;
              var onCancellation = tmp0_safe_receiver == null ? null : bindCancellationFun(tmp0_safe_receiver, element, cancellable.ea());
              cancellable.tw(element, onCancellation);
            }
            break $l$block_0;
          }
        }
      } else {
        segment.g17();
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveOnNoWaiterSuspend.<anonymous>.<anonymous>' call
        var element_0 = (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
        var tmp0_safe_receiver_0 = $this.j16_1;
        var onCancellation_0 = tmp0_safe_receiver_0 == null ? null : bindCancellationFun(tmp0_safe_receiver_0, element_0, cancellable.ea());
        cancellable.tw(element_0, onCancellation_0);
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.qy();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.py();
  }
  function prepareReceiverForSuspension(_this__u8e3s4, $this, segment, index) {
    $this.y18();
    _this__u8e3s4.ty(segment, index);
  }
  function onClosedReceiveOnNoWaiterSuspend($this, cont) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = _get_receiveException__foorc1($this);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    cont.ja(tmp$ret$0);
  }
  function updateCellReceive($this, segment, index, r, waiter) {
    var state = segment.e16(index);
    if (state === null) {
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var senders = $this.k16_1.kotlinx$atomicfu$value.u3(new Long(-1, 268435455));
      if (r.d1(senders) >= 0) {
        if (waiter === null) {
          return get_SUSPEND_NO_WAITER();
        }
        if (segment.g16(index, state, waiter)) {
          expandBuffer($this);
          return get_SUSPEND();
        }
      }
    } else if (state === get_BUFFERED())
      if (segment.g16(index, state, get_DONE_RCV())) {
        expandBuffer($this);
        return segment.c16(index);
      }
    return updateCellReceiveSlow($this, segment, index, r, waiter);
  }
  function updateCellReceiveSlow($this, segment, index, r, waiter) {
    $l$loop: while (true) {
      var state = segment.e16(index);
      if (state === null || state === get_IN_BUFFER()) {
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var senders = $this.k16_1.kotlinx$atomicfu$value.u3(new Long(-1, 268435455));
        if (r.d1(senders) < 0) {
          if (segment.g16(index, state, get_POISONED())) {
            expandBuffer($this);
            return get_FAILED();
          }
        } else {
          if (waiter === null) {
            return get_SUSPEND_NO_WAITER();
          }
          if (segment.g16(index, state, waiter)) {
            expandBuffer($this);
            return get_SUSPEND();
          }
        }
      } else if (state === get_BUFFERED()) {
        if (segment.g16(index, state, get_DONE_RCV())) {
          expandBuffer($this);
          return segment.c16(index);
        }
      } else if (state === get_INTERRUPTED_SEND())
        return get_FAILED();
      else if (state === get_POISONED())
        return get_FAILED();
      else if (state === get_CHANNEL_CLOSED()) {
        expandBuffer($this);
        return get_FAILED();
      } else if (state === get_RESUMING_BY_EB())
        continue $l$loop;
      else {
        if (segment.g16(index, state, get_RESUMING_BY_RCV())) {
          var helpExpandBuffer = state instanceof WaiterEB;
          var tmp;
          if (state instanceof WaiterEB) {
            tmp = state.t18_1;
          } else {
            tmp = state;
          }
          var sender = tmp;
          var tmp_0;
          if (tryResumeSender(sender, $this, segment, index)) {
            segment.f16(index, get_DONE_RCV());
            expandBuffer($this);
            tmp_0 = segment.c16(index);
          } else {
            segment.f16(index, get_INTERRUPTED_SEND());
            segment.u16(index, false);
            if (helpExpandBuffer) {
              expandBuffer($this);
            }
            tmp_0 = get_FAILED();
          }
          return tmp_0;
        }
      }
    }
  }
  function tryResumeSender(_this__u8e3s4, $this, segment, index) {
    var tmp;
    if (isInterface(_this__u8e3s4, CancellableContinuation)) {
      if (!isInterface(_this__u8e3s4, CancellableContinuation))
        THROW_CCE();
      tmp = tryResume0(_this__u8e3s4, Unit_instance);
    } else {
      if (isInterface(_this__u8e3s4, SelectInstance)) {
        if (!(_this__u8e3s4 instanceof SelectImplementation))
          THROW_CCE();
        var trySelectResult = _this__u8e3s4.g19($this, Unit_instance);
        if (trySelectResult === TrySelectDetailedResult_REREGISTER_getInstance()) {
          segment.d16(index);
        }
        tmp = trySelectResult === TrySelectDetailedResult_SUCCESSFUL_getInstance();
      } else {
        if (_this__u8e3s4 instanceof SendBroadcast) {
          tmp = tryResume0(_this__u8e3s4.z18_1, true);
        } else {
          var message = 'Unexpected waiter: ' + toString_1(_this__u8e3s4);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
    }
    return tmp;
  }
  function expandBuffer($this) {
    if (_get_isRendezvousOrUnlimited__3mdufi($this))
      return Unit_instance;
    var segment = $this.q16_1.kotlinx$atomicfu$value;
    try_again: while (true) {
      var b = $this.m16_1.atomicfu$getAndIncrement$long();
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = b.l3(toLong(other));
      var s = $this.m17();
      if (s.d1(b) <= 0) {
        if (segment.px_1.d1(id) < 0 && !(segment.c17() == null)) {
          moveSegmentBufferEndToSpecifiedOrLast($this, id, segment);
        }
        incCompletedExpandBufferAttempts$default($this);
        return Unit_instance;
      }
      if (!segment.px_1.equals(id)) {
        var tmp0_elvis_lhs = findSegmentBufferEnd($this, id, segment, b);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue try_again;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var i = b.m3(toLong(other_0)).z3();
      if (updateCellExpandBuffer($this, segment, i, b)) {
        incCompletedExpandBufferAttempts$default($this);
        return Unit_instance;
      } else {
        incCompletedExpandBufferAttempts$default($this);
        continue try_again;
      }
    }
  }
  function updateCellExpandBuffer($this, segment, index, b) {
    var state = segment.e16(index);
    if (!(state == null) ? isInterface(state, Waiter) : false) {
      if (b.d1($this.l16_1.kotlinx$atomicfu$value) >= 0) {
        if (segment.g16(index, state, get_RESUMING_BY_EB())) {
          var tmp;
          if (tryResumeSender(state, $this, segment, index)) {
            segment.f16(index, get_BUFFERED());
            tmp = true;
          } else {
            segment.f16(index, get_INTERRUPTED_SEND());
            segment.u16(index, false);
            tmp = false;
          }
          return tmp;
        }
      }
    }
    return updateCellExpandBufferSlow($this, segment, index, b);
  }
  function updateCellExpandBufferSlow($this, segment, index, b) {
    $l$loop: while (true) {
      var state = segment.e16(index);
      if (!(state == null) ? isInterface(state, Waiter) : false) {
        if (b.d1($this.l16_1.kotlinx$atomicfu$value) < 0) {
          if (segment.g16(index, state, new WaiterEB(state)))
            return true;
        } else {
          if (segment.g16(index, state, get_RESUMING_BY_EB())) {
            var tmp;
            if (tryResumeSender(state, $this, segment, index)) {
              segment.f16(index, get_BUFFERED());
              tmp = true;
            } else {
              segment.f16(index, get_INTERRUPTED_SEND());
              segment.u16(index, false);
              tmp = false;
            }
            return tmp;
          }
        }
      } else {
        if (state === get_INTERRUPTED_SEND())
          return false;
        else {
          if (state === null) {
            if (segment.g16(index, state, get_IN_BUFFER()))
              return true;
          } else {
            if (state === get_BUFFERED())
              return true;
            else {
              if (state === get_POISONED() || state === get_DONE_RCV() || state === get_INTERRUPTED_RCV())
                return true;
              else {
                if (state === get_CHANNEL_CLOSED())
                  return true;
                else {
                  if (state === get_RESUMING_BY_RCV())
                    continue $l$loop;
                  else {
                    // Inline function 'kotlin.error' call
                    var message = 'Unexpected cell state: ' + toString_0(state);
                    throw IllegalStateException_init_$Create$_0(toString_1(message));
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  function incCompletedExpandBufferAttempts($this, nAttempts) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.incCompletedExpandBufferAttempts.<anonymous>' call
    // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
    if (!$this.n16_1.atomicfu$addAndGet$long(nAttempts).u3(new Long(0, 1073741824)).equals(new Long(0, 0))) {
      $l$loop: while (true) {
        // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
        if (!!$this.n16_1.kotlinx$atomicfu$value.u3(new Long(0, 1073741824)).equals(new Long(0, 0))) {
          break $l$loop;
        }
      }
    }
  }
  function incCompletedExpandBufferAttempts$default($this, nAttempts, $super) {
    nAttempts = nAttempts === VOID ? new Long(1, 0) : nAttempts;
    return incCompletedExpandBufferAttempts($this, nAttempts);
  }
  function BufferedChannelIterator($outer) {
    this.k17_1 = $outer;
    this.i17_1 = get_NO_RECEIVE_RESULT();
    this.j17_1 = null;
  }
  protoOf(BufferedChannelIterator).h19 = function ($completion) {
    var tmp = new $hasNextCOROUTINE$6(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(BufferedChannelIterator).ty = function (segment, index) {
    var tmp0_safe_receiver = this.j17_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ty(segment, index);
    }
  };
  protoOf(BufferedChannelIterator).m = function () {
    var result = this.i17_1;
    // Inline function 'kotlin.check' call
    if (!!(result === get_NO_RECEIVE_RESULT())) {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannelIterator.next.<anonymous>' call
      var message = '`hasNext()` has not been invoked';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.i17_1 = get_NO_RECEIVE_RESULT();
    if (result === get_CHANNEL_CLOSED())
      throw recoverStackTrace_0(_get_receiveException__foorc1(this.k17_1));
    return (result == null ? true : !(result == null)) ? result : THROW_CCE();
  };
  protoOf(BufferedChannelIterator).u18 = function (element) {
    var cont = ensureNotNull(this.j17_1);
    this.j17_1 = null;
    this.i17_1 = element;
    var tmp0_safe_receiver = this.k17_1.j16_1;
    return tryResume0(cont, true, tmp0_safe_receiver == null ? null : bindCancellationFun(tmp0_safe_receiver, element, cont.ea()));
  };
  protoOf(BufferedChannelIterator).i19 = function () {
    var cont = ensureNotNull(this.j17_1);
    this.j17_1 = null;
    this.i17_1 = get_CHANNEL_CLOSED();
    var cause = this.k17_1.l17();
    if (cause == null) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
      cont.ja(tmp$ret$0);
    } else {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(cause, cont);
      var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
      cont.ja(tmp$ret$2);
    }
  };
  function _get_receiveException__foorc1($this) {
    var tmp0_elvis_lhs = $this.l17();
    return tmp0_elvis_lhs == null ? new ClosedReceiveChannelException('Channel was closed') : tmp0_elvis_lhs;
  }
  function invokeCloseHandler($this) {
    var tmp0 = $this.t16_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.getAndUpdate' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.invokeCloseHandler.<anonymous>' call
        var tmp;
        if (cur === null) {
          tmp = get_CLOSE_HANDLER_CLOSED();
        } else {
          tmp = get_CLOSE_HANDLER_INVOKED();
        }
        var upd = tmp;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$1 = cur;
          break $l$block;
        }
      }
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var closeHandler = tmp_0;
    if (typeof closeHandler !== 'function')
      THROW_CCE();
    closeHandler($this.l17());
  }
  function markClosed($this) {
    var tmp0 = $this.k16_1;
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.markClosed.<anonymous>' call
        // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
        var tmp;
        switch (cur.s3(60).z3()) {
          case 0:
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

            var tmp$ret$1 = cur.u3(new Long(-1, 268435455));
            tmp = constructSendersAndCloseStatus(tmp$ret$1, 2);
            break;
          case 1:
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

            var tmp$ret$2 = cur.u3(new Long(-1, 268435455));
            tmp = constructSendersAndCloseStatus(tmp$ret$2, 3);
            break;
          default:
            return Unit_instance;
        }
        var upd = tmp;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$4 = Unit_instance;
          break $l$block;
        }
      }
    }
    return tmp$ret$4;
  }
  function markCancelled($this) {
    var tmp0 = $this.k16_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.markCancelled.<anonymous>' call
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var tmp$ret$0 = cur.u3(new Long(-1, 268435455));
        var upd = constructSendersAndCloseStatus(tmp$ret$0, 3);
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$2 = Unit_instance;
          break $l$block;
        }
      }
    }
    return tmp$ret$2;
  }
  function markCancellationStarted($this) {
    var tmp0 = $this.k16_1;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.markCancellationStarted.<anonymous>' call
        var tmp;
        // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
        if (cur.s3(60).z3() === 0) {
          // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
          var tmp$ret$1 = cur.u3(new Long(-1, 268435455));
          tmp = constructSendersAndCloseStatus(tmp$ret$1, 1);
        } else {
          return Unit_instance;
        }
        var upd = tmp;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$3 = Unit_instance;
          break $l$block;
        }
      }
    }
    return tmp$ret$3;
  }
  function completeCloseOrCancel($this) {
    $this.j19();
  }
  function completeClose($this, sendersCur) {
    var lastSegment = closeLinkedList($this);
    if ($this.l19()) {
      var lastBufferedCellGlobalIndex = markAllEmptyCellsAsClosed($this, lastSegment);
      if (!lastBufferedCellGlobalIndex.equals(new Long(-1, -1))) {
        $this.k19(lastBufferedCellGlobalIndex);
      }
    }
    cancelSuspendedReceiveRequests($this, lastSegment, sendersCur);
    return lastSegment;
  }
  function completeCancel($this, sendersCur) {
    var lastSegment = completeClose($this, sendersCur);
    removeUnprocessedElements($this, lastSegment);
  }
  function closeLinkedList($this) {
    var lastSegment = $this.q16_1.kotlinx$atomicfu$value;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.closeLinkedList.<anonymous>' call
    var it = $this.o16_1.kotlinx$atomicfu$value;
    if (it.px_1.d1(lastSegment.px_1) > 0)
      lastSegment = it;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.closeLinkedList.<anonymous>' call
    var it_0 = $this.p16_1.kotlinx$atomicfu$value;
    if (it_0.px_1.d1(lastSegment.px_1) > 0)
      lastSegment = it_0;
    return close(lastSegment);
  }
  function markAllEmptyCellsAsClosed($this, lastSegment) {
    var segment = lastSegment;
    while (true) {
      var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp0 = segment.px_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var globalIndex = tmp0.k3(toLong(other)).i3(toLong(index));
          if (globalIndex.d1($this.r18()) < 0)
            return new Long(-1, -1);
          cell_update: while (true) {
            var state = segment.e16(index);
            if (state === null || state === get_IN_BUFFER()) {
              if (segment.g16(index, state, get_CHANNEL_CLOSED())) {
                segment.w16();
                break cell_update;
              }
            } else if (state === get_BUFFERED())
              return globalIndex;
            else
              break cell_update;
          }
        }
         while (0 <= inductionVariable);
      var tmp1_elvis_lhs = segment.f17();
      var tmp;
      if (tmp1_elvis_lhs == null) {
        return new Long(-1, -1);
      } else {
        tmp = tmp1_elvis_lhs;
      }
      segment = tmp;
    }
  }
  function removeUnprocessedElements($this, lastSegment) {
    var onUndeliveredElement = $this.j16_1;
    var undeliveredElementException = null;
    var suspendedSenders = _InlineList___init__impl__z8n56();
    var segment = lastSegment;
    process_segments: while (true) {
      var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp0 = segment.px_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var globalIndex = tmp0.k3(toLong(other)).i3(toLong(index));
          update_cell: while (true) {
            var state = segment.e16(index);
            if (state === get_DONE_RCV())
              break process_segments;
            else {
              if (state === get_BUFFERED()) {
                if (globalIndex.d1($this.r18()) < 0)
                  break process_segments;
                if (segment.g16(index, state, get_CHANNEL_CLOSED())) {
                  if (!(onUndeliveredElement == null)) {
                    var element = segment.b16(index);
                    undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element, undeliveredElementException);
                  }
                  segment.d16(index);
                  segment.w16();
                  break update_cell;
                }
              } else {
                if (state === get_IN_BUFFER() || state === null) {
                  if (segment.g16(index, state, get_CHANNEL_CLOSED())) {
                    segment.w16();
                    break update_cell;
                  }
                } else {
                  var tmp;
                  if (!(state == null) ? isInterface(state, Waiter) : false) {
                    tmp = true;
                  } else {
                    tmp = state instanceof WaiterEB;
                  }
                  if (tmp) {
                    if (globalIndex.d1($this.r18()) < 0)
                      break process_segments;
                    var tmp_0;
                    if (state instanceof WaiterEB) {
                      tmp_0 = state.t18_1;
                    } else {
                      tmp_0 = (!(state == null) ? isInterface(state, Waiter) : false) ? state : THROW_CCE();
                    }
                    var sender = tmp_0;
                    if (segment.g16(index, state, get_CHANNEL_CLOSED())) {
                      if (!(onUndeliveredElement == null)) {
                        var element_0 = segment.b16(index);
                        undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element_0, undeliveredElementException);
                      }
                      suspendedSenders = InlineList__plus_impl_nuetvo(suspendedSenders, sender);
                      segment.d16(index);
                      segment.w16();
                      break update_cell;
                    }
                  } else {
                    if (state === get_RESUMING_BY_EB() || state === get_RESUMING_BY_RCV())
                      break process_segments;
                    else {
                      if (state === get_RESUMING_BY_EB())
                        continue update_cell;
                      else {
                        break update_cell;
                      }
                    }
                  }
                }
              }
            }
          }
        }
         while (0 <= inductionVariable);
      var tmp1_elvis_lhs = segment.f17();
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        break process_segments;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      segment = tmp_1;
    }
    var tmp4 = suspendedSenders;
    $l$block: {
      // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
      var tmp0_subject = access$_get_holder__kkflen(tmp4);
      if (tmp0_subject == null) {
        break $l$block;
      } else {
        if (!(tmp0_subject instanceof ArrayList)) {
          var tmp_2 = access$_get_holder__kkflen(tmp4);
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.removeUnprocessedElements.<anonymous>' call
          var it = (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
          resumeSenderOnCancelledChannel(it, $this);
        } else {
          var tmp_3 = access$_get_holder__kkflen(tmp4);
          var list = tmp_3 instanceof ArrayList ? tmp_3 : THROW_CCE();
          var inductionVariable_0 = list.n() - 1 | 0;
          if (0 <= inductionVariable_0)
            do {
              var i = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              // Inline function 'kotlinx.coroutines.channels.BufferedChannel.removeUnprocessedElements.<anonymous>' call
              var it_0 = list.q(i);
              resumeSenderOnCancelledChannel(it_0, $this);
            }
             while (0 <= inductionVariable_0);
        }
      }
    }
    var tmp2_safe_receiver = undeliveredElementException;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp2_safe_receiver;
    }
  }
  function cancelSuspendedReceiveRequests($this, lastSegment, sendersCounter) {
    var suspendedReceivers = _InlineList___init__impl__z8n56();
    var segment = lastSegment;
    process_segments: while (!(segment == null)) {
      var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp0 = segment.px_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          if (tmp0.k3(toLong(other)).i3(toLong(index)).d1(sendersCounter) < 0)
            break process_segments;
          cell_update: while (true) {
            var state = segment.e16(index);
            if (state === null || state === get_IN_BUFFER()) {
              if (segment.g16(index, state, get_CHANNEL_CLOSED())) {
                segment.w16();
                break cell_update;
              }
            } else {
              if (state instanceof WaiterEB) {
                if (segment.g16(index, state, get_CHANNEL_CLOSED())) {
                  suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state.t18_1);
                  segment.u16(index, true);
                  break cell_update;
                }
              } else {
                if (!(state == null) ? isInterface(state, Waiter) : false) {
                  if (segment.g16(index, state, get_CHANNEL_CLOSED())) {
                    suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state);
                    segment.u16(index, true);
                    break cell_update;
                  }
                } else {
                  break cell_update;
                }
              }
            }
          }
        }
         while (0 <= inductionVariable);
      segment = segment.f17();
    }
    var tmp4 = suspendedReceivers;
    $l$block: {
      // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
      var tmp0_subject = access$_get_holder__kkflen(tmp4);
      if (tmp0_subject == null) {
        break $l$block;
      } else {
        if (!(tmp0_subject instanceof ArrayList)) {
          var tmp = access$_get_holder__kkflen(tmp4);
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.cancelSuspendedReceiveRequests.<anonymous>' call
          var it = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
          resumeReceiverOnClosedChannel(it, $this);
        } else {
          var tmp_0 = access$_get_holder__kkflen(tmp4);
          var list = tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE();
          var inductionVariable_0 = list.n() - 1 | 0;
          if (0 <= inductionVariable_0)
            do {
              var i = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              // Inline function 'kotlinx.coroutines.channels.BufferedChannel.cancelSuspendedReceiveRequests.<anonymous>' call
              var it_0 = list.q(i);
              resumeReceiverOnClosedChannel(it_0, $this);
            }
             while (0 <= inductionVariable_0);
        }
      }
    }
  }
  function resumeReceiverOnClosedChannel(_this__u8e3s4, $this) {
    return resumeWaiterOnClosedChannel(_this__u8e3s4, $this, true);
  }
  function resumeSenderOnCancelledChannel(_this__u8e3s4, $this) {
    return resumeWaiterOnClosedChannel(_this__u8e3s4, $this, false);
  }
  function resumeWaiterOnClosedChannel(_this__u8e3s4, $this, receiver) {
    if (_this__u8e3s4 instanceof SendBroadcast) {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = _this__u8e3s4.z18_1;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(false);
      this_0.ja(tmp$ret$0);
    } else {
      if (isInterface(_this__u8e3s4, CancellableContinuation)) {
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = receiver ? _get_receiveException__foorc1($this) : $this.q18();
        var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
        _this__u8e3s4.ja(tmp$ret$2);
      } else {
        if (_this__u8e3s4 instanceof ReceiveCatching) {
          var tmp4 = _this__u8e3s4.x18_1;
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = new ChannelResult(Companion_getInstance_27().m19($this.l17()));
          var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
          tmp4.ja(tmp$ret$4);
        } else {
          if (_this__u8e3s4 instanceof BufferedChannelIterator) {
            _this__u8e3s4.i19();
          } else {
            if (isInterface(_this__u8e3s4, SelectInstance)) {
              _this__u8e3s4.b12($this, get_CHANNEL_CLOSED());
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Unexpected waiter: ' + toString_1(_this__u8e3s4);
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }
          }
        }
      }
    }
  }
  function _get_isClosedForSend0__kxgf9m(_this__u8e3s4, $this) {
    return isClosed($this, _this__u8e3s4, false);
  }
  function _get_isClosedForReceive0__f7qknl(_this__u8e3s4, $this) {
    return isClosed($this, _this__u8e3s4, true);
  }
  function isClosed($this, sendersAndCloseStatusCur, isClosedForReceive) {
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var tmp;
    switch (sendersAndCloseStatusCur.s3(60).z3()) {
      case 0:
        tmp = false;
        break;
      case 1:
        tmp = false;
        break;
      case 2:
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

        var tmp$ret$1 = sendersAndCloseStatusCur.u3(new Long(-1, 268435455));
        completeClose($this, tmp$ret$1);
        tmp = isClosedForReceive ? !$this.n19() : true;
        break;
      case 3:
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

        var tmp$ret$2 = sendersAndCloseStatusCur.u3(new Long(-1, 268435455));
        completeCancel($this, tmp$ret$2);
        tmp = true;
        break;
      default:
        // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call

        var message = 'unexpected close status: ' + sendersAndCloseStatusCur.s3(60).z3();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return tmp;
  }
  function isCellNonEmpty($this, segment, index, globalIndex) {
    while (true) {
      var state = segment.e16(index);
      if (state === null || state === get_IN_BUFFER()) {
        if (segment.g16(index, state, get_POISONED())) {
          expandBuffer($this);
          return false;
        }
      } else if (state === get_BUFFERED())
        return true;
      else if (state === get_INTERRUPTED_SEND())
        return false;
      else if (state === get_CHANNEL_CLOSED())
        return false;
      else if (state === get_DONE_RCV())
        return false;
      else if (state === get_POISONED())
        return false;
      else if (state === get_RESUMING_BY_EB())
        return true;
      else if (state === get_RESUMING_BY_RCV())
        return false;
      else
        return globalIndex.equals($this.r18());
    }
  }
  function findSegmentSend($this, id, startFrom) {
    var tmp0 = $this.o16_1;
    var tmp3 = createSegmentFunction();
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
      while (true) {
        var s = findSegmentInternal(startFrom, id, tmp3);
        var tmp;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
          tmp = true;
        } else {
          var tmp1 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          var tmp$ret$0;
          $l$block_1: {
            // Inline function 'kotlinx.coroutines.internal.moveForward' call
            while (true) {
              // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
              var cur = tmp0.kotlinx$atomicfu$value;
              if (cur.px_1.d1(tmp1.px_1) >= 0) {
                tmp$ret$0 = true;
                break $l$block_1;
              }
              if (!tmp1.y16()) {
                tmp$ret$0 = false;
                break $l$block_1;
              }
              if (tmp0.atomicfu$compareAndSet(cur, tmp1)) {
                if (cur.z16()) {
                  cur.b5();
                }
                tmp$ret$0 = true;
                break $l$block_1;
              }
              if (tmp1.z16()) {
                tmp1.b5();
              }
            }
            tmp$ret$0 = Unit_instance;
          }
          tmp = tmp$ret$0;
        }
        if (tmp) {
          tmp$ret$1 = s;
          break $l$block_2;
        }
      }
    }
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.findSegmentSend.<anonymous>' call
    var it = tmp$ret$1;
    var tmp_0;
    if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
      completeCloseOrCancel($this);
      var tmp0_0 = startFrom.px_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      if (tmp0_0.k3(toLong(other)).d1($this.r18()) < 0) {
        startFrom.g17();
      }
      tmp_0 = null;
    } else {
      var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
      var tmp_1;
      if (segment.px_1.d1(id) > 0) {
        var tmp2 = segment.px_1;
        // Inline function 'kotlin.Long.times' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$3 = tmp2.k3(toLong(other_0));
        updateSendersCounterIfLower($this, tmp$ret$3);
        var tmp4 = segment.px_1;
        // Inline function 'kotlin.Long.times' call
        var other_1 = get_SEGMENT_SIZE();
        if (tmp4.k3(toLong(other_1)).d1($this.r18()) < 0) {
          segment.g17();
        }
        tmp_1 = null;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        tmp_1 = segment;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function findSegmentReceive($this, id, startFrom) {
    var tmp0 = $this.p16_1;
    var tmp3 = createSegmentFunction();
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
      while (true) {
        var s = findSegmentInternal(startFrom, id, tmp3);
        var tmp;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
          tmp = true;
        } else {
          var tmp1 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          var tmp$ret$0;
          $l$block_1: {
            // Inline function 'kotlinx.coroutines.internal.moveForward' call
            while (true) {
              // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
              var cur = tmp0.kotlinx$atomicfu$value;
              if (cur.px_1.d1(tmp1.px_1) >= 0) {
                tmp$ret$0 = true;
                break $l$block_1;
              }
              if (!tmp1.y16()) {
                tmp$ret$0 = false;
                break $l$block_1;
              }
              if (tmp0.atomicfu$compareAndSet(cur, tmp1)) {
                if (cur.z16()) {
                  cur.b5();
                }
                tmp$ret$0 = true;
                break $l$block_1;
              }
              if (tmp1.z16()) {
                tmp1.b5();
              }
            }
            tmp$ret$0 = Unit_instance;
          }
          tmp = tmp$ret$0;
        }
        if (tmp) {
          tmp$ret$1 = s;
          break $l$block_2;
        }
      }
    }
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.findSegmentReceive.<anonymous>' call
    var it = tmp$ret$1;
    var tmp_0;
    if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
      completeCloseOrCancel($this);
      var tmp0_0 = startFrom.px_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      if (tmp0_0.k3(toLong(other)).d1($this.m17()) < 0) {
        startFrom.g17();
      }
      tmp_0 = null;
    } else {
      var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
      var tmp_1;
      if (!_get_isRendezvousOrUnlimited__3mdufi($this)) {
        var tmp2 = _get_bufferEndCounter__2d4hee($this);
        // Inline function 'kotlin.Long.div' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$3 = tmp2.l3(toLong(other_0));
        tmp_1 = id.d1(tmp$ret$3) <= 0;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        var tmp4 = $this.q16_1;
        $l$block_5: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          while (true) {
            // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
            var cur_0 = tmp4.kotlinx$atomicfu$value;
            if (cur_0.px_1.d1(segment.px_1) >= 0) {
              break $l$block_5;
            }
            if (!segment.y16()) {
              break $l$block_5;
            }
            if (tmp4.atomicfu$compareAndSet(cur_0, segment)) {
              if (cur_0.z16()) {
                cur_0.b5();
              }
              break $l$block_5;
            }
            if (segment.z16()) {
              segment.b5();
            }
          }
        }
      }
      var tmp_2;
      if (segment.px_1.d1(id) > 0) {
        var tmp6 = segment.px_1;
        // Inline function 'kotlin.Long.times' call
        var other_1 = get_SEGMENT_SIZE();
        var tmp$ret$5 = tmp6.k3(toLong(other_1));
        updateReceiversCounterIfLower($this, tmp$ret$5);
        var tmp8 = segment.px_1;
        // Inline function 'kotlin.Long.times' call
        var other_2 = get_SEGMENT_SIZE();
        if (tmp8.k3(toLong(other_2)).d1($this.m17()) < 0) {
          segment.g17();
        }
        tmp_2 = null;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        tmp_2 = segment;
      }
      tmp_0 = tmp_2;
    }
    return tmp_0;
  }
  function findSegmentBufferEnd($this, id, startFrom, currentBufferEndCounter) {
    var tmp0 = $this.q16_1;
    var tmp3 = createSegmentFunction();
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
      while (true) {
        var s = findSegmentInternal(startFrom, id, tmp3);
        var tmp;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
          tmp = true;
        } else {
          var tmp1 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          var tmp$ret$0;
          $l$block_1: {
            // Inline function 'kotlinx.coroutines.internal.moveForward' call
            while (true) {
              // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
              var cur = tmp0.kotlinx$atomicfu$value;
              if (cur.px_1.d1(tmp1.px_1) >= 0) {
                tmp$ret$0 = true;
                break $l$block_1;
              }
              if (!tmp1.y16()) {
                tmp$ret$0 = false;
                break $l$block_1;
              }
              if (tmp0.atomicfu$compareAndSet(cur, tmp1)) {
                if (cur.z16()) {
                  cur.b5();
                }
                tmp$ret$0 = true;
                break $l$block_1;
              }
              if (tmp1.z16()) {
                tmp1.b5();
              }
            }
            tmp$ret$0 = Unit_instance;
          }
          tmp = tmp$ret$0;
        }
        if (tmp) {
          tmp$ret$1 = s;
          break $l$block_2;
        }
      }
    }
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.findSegmentBufferEnd.<anonymous>' call
    var it = tmp$ret$1;
    var tmp_0;
    if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
      completeCloseOrCancel($this);
      moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom);
      incCompletedExpandBufferAttempts$default($this);
      tmp_0 = null;
    } else {
      var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
      var tmp_1;
      if (segment.px_1.d1(id) > 0) {
        // Inline function 'kotlin.Long.plus' call
        var tmp_2 = currentBufferEndCounter.i3(toLong(1));
        var tmp2 = segment.px_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        var tmp$ret$3 = tmp2.k3(toLong(other));
        if ($this.m16_1.atomicfu$compareAndSet(tmp_2, tmp$ret$3)) {
          var tmp4 = segment.px_1;
          // Inline function 'kotlin.Long.times' call
          var other_0 = get_SEGMENT_SIZE();
          var tmp$ret$4 = tmp4.k3(toLong(other_0));
          incCompletedExpandBufferAttempts($this, tmp$ret$4.j3(currentBufferEndCounter));
        } else {
          incCompletedExpandBufferAttempts$default($this);
        }
        tmp_1 = null;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        tmp_1 = segment;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom) {
    var segment = startFrom;
    $l$loop: while (segment.px_1.d1(id) < 0) {
      var tmp0_elvis_lhs = segment.c17();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    while (true) {
      $l$loop_0: while (segment.x16()) {
        var tmp1_elvis_lhs = segment.c17();
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        segment = tmp_0;
      }
      var tmp0 = $this.q16_1;
      var tmp1 = segment;
      var tmp$ret$0;
      $l$block_1: {
        // Inline function 'kotlinx.coroutines.internal.moveForward' call
        while (true) {
          // Inline function 'kotlinx.coroutines.internal.moveForward.<anonymous>' call
          var cur = tmp0.kotlinx$atomicfu$value;
          if (cur.px_1.d1(tmp1.px_1) >= 0) {
            tmp$ret$0 = true;
            break $l$block_1;
          }
          if (!tmp1.y16()) {
            tmp$ret$0 = false;
            break $l$block_1;
          }
          if (tmp0.atomicfu$compareAndSet(cur, tmp1)) {
            if (cur.z16()) {
              cur.b5();
            }
            tmp$ret$0 = true;
            break $l$block_1;
          }
          if (tmp1.z16()) {
            tmp1.b5();
          }
        }
        tmp$ret$0 = Unit_instance;
      }
      if (tmp$ret$0)
        return Unit_instance;
    }
  }
  function updateSendersCounterIfLower($this, value) {
    var this_0 = $this.k16_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.updateSendersCounterIfLower.<anonymous>' call
      var cur = this_0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var curCounter = cur.u3(new Long(-1, 268435455));
      if (curCounter.d1(value) >= 0)
        return Unit_instance;
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
      var tmp$ret$1 = cur.s3(60).z3();
      var update = constructSendersAndCloseStatus(curCounter, tmp$ret$1);
      if ($this.k16_1.atomicfu$compareAndSet(cur, update))
        return Unit_instance;
    }
    return Unit_instance;
  }
  function updateReceiversCounterIfLower($this, value) {
    var this_0 = $this.l16_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.updateReceiversCounterIfLower.<anonymous>' call
      var cur = this_0.kotlinx$atomicfu$value;
      if (cur.d1(value) >= 0)
        return Unit_instance;
      if ($this.l16_1.atomicfu$compareAndSet(cur, value))
        return Unit_instance;
    }
    return Unit_instance;
  }
  function access$_get_sendersAndCloseStatus__tvw29s($this) {
    return $this.k16_1;
  }
  function access$_get_sendSegment__111kgq($this) {
    return $this.o16_1;
  }
  function access$prepareSenderForSuspension($this, $receiver, segment, index) {
    return prepareSenderForSuspension($receiver, $this, segment, index);
  }
  function access$updateCellSend($this, segment, index, element, s, waiter, closed) {
    return updateCellSend($this, segment, index, element, s, waiter, closed);
  }
  function access$_get_isClosedForSend0__sm8f7a($this, $receiver) {
    return _get_isClosedForSend0__kxgf9m($receiver, $this);
  }
  function access$findSegmentSend($this, id, startFrom) {
    return findSegmentSend($this, id, startFrom);
  }
  function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda($element, this$0, $select) {
    return function (it) {
      var tmp;
      if (!($element === get_CHANNEL_CLOSED())) {
        callUndeliveredElement(this$0.j16_1, ($element == null ? true : !($element == null)) ? $element : THROW_CCE(), $select.ea());
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this$0) {
    return function (select, _anonymous_parameter_1__qggqgd, element) {
      return BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda(element, this$0, select);
    };
  }
  function $sendCOROUTINE$3(_this__u8e3s4, element, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x19_1 = _this__u8e3s4;
    this.y19_1 = element;
  }
  protoOf($sendCOROUTINE$3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 11;
            var tmp_0 = this;
            tmp_0.z19_1 = this.x19_1;
            var tmp_1 = this;
            tmp_1.a1a_1 = this.y19_1;
            var tmp_2 = this;
            tmp_2.b1a_1 = null;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.d1a_1 = this.z19_1;
            this.e1a_1 = this.a1a_1;
            this.f1a_1 = this.b1a_1;
            this.g1a_1 = access$_get_sendSegment__111kgq(this.d1a_1).kotlinx$atomicfu$value;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.y9_1 = 12;
              continue $sm;
            }

            this.h1a_1 = access$_get_sendersAndCloseStatus__tvw29s(this.d1a_1).atomicfu$getAndIncrement$long();
            var tmp_3 = this;
            tmp_3.i1a_1 = this.h1a_1.u3(access$_get_SENDERS_COUNTER_MASK_$tBufferedChannelKt_6ll4te());
            this.j1a_1 = access$_get_isClosedForSend0__sm8f7a(this.d1a_1, this.h1a_1);
            var tmp_4 = this;
            var tmp0 = this.i1a_1;
            var other = get_SEGMENT_SIZE();
            tmp_4.k1a_1 = tmp0.l3(toLong(other));
            var tmp_5 = this;
            var tmp2 = this.i1a_1;
            var other_0 = get_SEGMENT_SIZE();
            tmp_5.l1a_1 = tmp2.m3(toLong(other_0)).z3();
            if (!this.g1a_1.px_1.equals(this.k1a_1)) {
              this.m1a_1 = access$findSegmentSend(this.d1a_1, this.k1a_1, this.g1a_1);
              if (this.m1a_1 == null) {
                if (this.j1a_1) {
                  this.y9_1 = 10;
                  suspendResult = onClosedSend(this.x19_1, this.y19_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.y9_1 = 2;
                  continue $sm;
                }
              } else {
                this.n1a_1 = this.m1a_1;
                this.y9_1 = 3;
                continue $sm;
              }
            } else {
              this.y9_1 = 4;
              continue $sm;
            }

          case 3:
            this.g1a_1 = this.n1a_1;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.o1a_1 = access$updateCellSend(this.d1a_1, this.g1a_1, this.l1a_1, this.e1a_1, this.i1a_1, this.f1a_1, this.j1a_1);
            if (this.o1a_1 === access$_get_RESULT_RENDEZVOUS_$tBufferedChannelKt_ykevfn()) {
              this.g1a_1.g17();
              var tmp_6 = this;
              tmp_6.c1a_1 = Unit_instance;
              this.y9_1 = 13;
              continue $sm;
            } else {
              if (this.o1a_1 === access$_get_RESULT_BUFFERED_$tBufferedChannelKt_tnykj7()) {
                var tmp_7 = this;
                tmp_7.c1a_1 = Unit_instance;
                this.y9_1 = 13;
                continue $sm;
              } else {
                if (this.o1a_1 === access$_get_RESULT_SUSPEND_$tBufferedChannelKt_vus6es()) {
                  if (this.j1a_1) {
                    this.g1a_1.w16();
                    this.y9_1 = 9;
                    suspendResult = onClosedSend(this.x19_1, this.y19_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.y9_1 = 8;
                    continue $sm;
                  }
                } else {
                  if (this.o1a_1 === access$_get_RESULT_CLOSED_$tBufferedChannelKt_3eqb16()) {
                    if (this.i1a_1.d1(this.d1a_1.r18()) < 0) {
                      this.g1a_1.g17();
                    }
                    this.y9_1 = 7;
                    suspendResult = onClosedSend(this.x19_1, this.y19_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (this.o1a_1 === access$_get_RESULT_FAILED_$tBufferedChannelKt_wacckr()) {
                      this.g1a_1.g17();
                      this.y9_1 = 2;
                      continue $sm;
                    } else {
                      if (this.o1a_1 === access$_get_RESULT_SUSPEND_NO_WAITER_$tBufferedChannelKt_61h09f()) {
                        var tmp_8 = this;
                        tmp_8.p1a_1 = this.g1a_1;
                        var tmp_9 = this;
                        tmp_9.q1a_1 = this.l1a_1;
                        var tmp_10 = this;
                        tmp_10.r1a_1 = this.e1a_1;
                        var tmp_11 = this;
                        tmp_11.s1a_1 = this.i1a_1;
                        this.t1a_1 = this.p1a_1;
                        this.u1a_1 = this.q1a_1;
                        this.v1a_1 = this.r1a_1;
                        this.w1a_1 = this.s1a_1;
                        this.y9_1 = 6;
                        suspendResult = sendOnNoWaiterSuspend(this.x19_1, this.t1a_1, this.u1a_1, this.v1a_1, this.w1a_1, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        this.y9_1 = 5;
                        continue $sm;
                      }
                    }
                  }
                }
              }
            }

          case 5:
            this.y9_1 = 2;
            continue $sm;
          case 6:
            var tmp_12 = this;
            tmp_12.c1a_1 = Unit_instance;
            this.y9_1 = 13;
            continue $sm;
          case 7:
            var tmp_13 = this;
            tmp_13.c1a_1 = Unit_instance;
            this.y9_1 = 13;
            continue $sm;
          case 8:
            var tmp_14 = this.f1a_1;
            var tmp2_safe_receiver = (!(tmp_14 == null) ? isInterface(tmp_14, Waiter) : false) ? tmp_14 : null;
            if (tmp2_safe_receiver == null)
              null;
            else {
              access$prepareSenderForSuspension(this.d1a_1, tmp2_safe_receiver, this.g1a_1, this.l1a_1);
            }

            var tmp_15 = this;
            this.g1a_1;
            this.l1a_1;
            tmp_15.c1a_1 = Unit_instance;
            this.y9_1 = 13;
            continue $sm;
          case 9:
            var tmp_16 = this;
            tmp_16.c1a_1 = Unit_instance;
            this.y9_1 = 13;
            continue $sm;
          case 10:
            var tmp_17 = this;
            tmp_17.c1a_1 = Unit_instance;
            this.y9_1 = 13;
            continue $sm;
          case 11:
            throw this.ba_1;
          case 12:
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 13;
            continue $sm;
          case 13:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 11) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $receiveCOROUTINE$4(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f1b_1 = _this__u8e3s4;
  }
  protoOf($receiveCOROUTINE$4).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 8;
            var tmp_0 = this;
            tmp_0.g1b_1 = this.f1b_1;
            var tmp_1 = this;
            tmp_1.h1b_1 = null;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.j1b_1 = this.g1b_1;
            this.k1b_1 = this.h1b_1;
            this.l1b_1 = this.j1b_1.p16_1.kotlinx$atomicfu$value;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.y9_1 = 9;
              continue $sm;
            }

            if (this.j1b_1.n17()) {
              var tmp_2 = this;
              throw recoverStackTrace_0(_get_receiveException__foorc1(this.f1b_1));
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            this.m1b_1 = this.j1b_1.l16_1.atomicfu$getAndIncrement$long();
            var tmp_3 = this;
            var tmp0 = this.m1b_1;
            var other = get_SEGMENT_SIZE();
            tmp_3.n1b_1 = tmp0.l3(toLong(other));
            var tmp_4 = this;
            var tmp2 = this.m1b_1;
            var other_0 = get_SEGMENT_SIZE();
            tmp_4.o1b_1 = tmp2.m3(toLong(other_0)).z3();
            if (!this.l1b_1.px_1.equals(this.n1b_1)) {
              this.p1b_1 = findSegmentReceive(this.j1b_1, this.n1b_1, this.l1b_1);
              if (this.p1b_1 == null) {
                this.y9_1 = 2;
                var tmp_5 = this;
                continue $sm;
              } else {
                this.q1b_1 = this.p1b_1;
                this.y9_1 = 4;
                continue $sm;
              }
            } else {
              this.y9_1 = 5;
              continue $sm;
            }

          case 4:
            this.l1b_1 = this.q1b_1;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.r1b_1 = updateCellReceive(this.j1b_1, this.l1b_1, this.o1b_1, this.m1b_1, this.k1b_1);
            if (this.r1b_1 === get_SUSPEND()) {
              var tmp_6 = this;
              var tmp_7 = this.k1b_1;
              var tmp1_safe_receiver = (!(tmp_7 == null) ? isInterface(tmp_7, Waiter) : false) ? tmp_7 : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(tmp1_safe_receiver, this.j1b_1, this.l1b_1, this.o1b_1);
              }
              this.l1b_1;
              this.o1b_1;
              this.m1b_1;
              var message = 'unexpected';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else {
              if (this.r1b_1 === get_FAILED()) {
                if (this.m1b_1.d1(this.j1b_1.m17()) < 0) {
                  this.l1b_1.g17();
                }
                this.y9_1 = 2;
                var tmp_8 = this;
                continue $sm;
              } else {
                if (this.r1b_1 === get_SUSPEND_NO_WAITER()) {
                  var tmp_9 = this;
                  tmp_9.t1b_1 = this.l1b_1;
                  var tmp_10 = this;
                  tmp_10.u1b_1 = this.o1b_1;
                  var tmp_11 = this;
                  tmp_11.v1b_1 = this.m1b_1;
                  this.w1b_1 = this.t1b_1;
                  this.x1b_1 = this.u1b_1;
                  this.y1b_1 = this.v1b_1;
                  this.y9_1 = 6;
                  suspendResult = receiveOnNoWaiterSuspend(this.f1b_1, this.w1b_1, this.x1b_1, this.y1b_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_12 = this;
                  this.l1b_1.g17();
                  var tmp_13 = this.r1b_1;
                  return (tmp_13 == null ? true : !(tmp_13 == null)) ? tmp_13 : THROW_CCE();
                }
              }
            }

          case 6:
            this.s1b_1 = suspendResult;
            this.y9_1 = 7;
            continue $sm;
          case 7:
            this.i1b_1 = this.s1b_1;
            this.y9_1 = 10;
            continue $sm;
          case 8:
            throw this.ba_1;
          case 9:
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 10;
            continue $sm;
          case 10:
            return this.i1b_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 8) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function BufferedChannel(capacity, onUndeliveredElement) {
    onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
    this.i16_1 = capacity;
    this.j16_1 = onUndeliveredElement;
    // Inline function 'kotlin.require' call
    if (!(this.i16_1 >= 0)) {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.<anonymous>' call
      var message = 'Invalid channel capacity: ' + this.i16_1 + ', should be >=0';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.k16_1 = atomic$long$1(new Long(0, 0));
    this.l16_1 = atomic$long$1(new Long(0, 0));
    this.m16_1 = atomic$long$1(initialBufferEnd(this.i16_1));
    this.n16_1 = atomic$long$1(_get_bufferEndCounter__2d4hee(this));
    var firstSegment = new ChannelSegment(new Long(0, 0), null, this, 3);
    this.o16_1 = atomic$ref$1(firstSegment);
    this.p16_1 = atomic$ref$1(firstSegment);
    var tmp = this;
    var tmp_0;
    if (_get_isRendezvousOrUnlimited__3mdufi(this)) {
      var tmp_1 = get_NULL_SEGMENT();
      tmp_0 = tmp_1 instanceof ChannelSegment ? tmp_1 : THROW_CCE();
    } else {
      tmp_0 = firstSegment;
    }
    tmp.q16_1 = atomic$ref$1(tmp_0);
    var tmp_2 = this;
    var tmp_3;
    if (this.j16_1 == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.onUndeliveredElementReceiveCancellationConstructor.<anonymous>' call
      tmp_3 = BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this);
    }
    tmp_2.r16_1 = tmp_3;
    this.s16_1 = atomic$ref$1(get_NO_CLOSE_CAUSE());
    this.t16_1 = atomic$ref$1(null);
  }
  protoOf(BufferedChannel).m17 = function () {
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    return this.k16_1.kotlinx$atomicfu$value.u3(new Long(-1, 268435455));
  };
  protoOf(BufferedChannel).r18 = function () {
    return this.l16_1.kotlinx$atomicfu$value;
  };
  protoOf(BufferedChannel).z1b = function (element, $completion) {
    var tmp = new $sendCOROUTINE$3(this, element, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(BufferedChannel).a1c = function (element) {
    if (shouldSendSuspend0(this, this.k16_1.kotlinx$atomicfu$value))
      return Companion_getInstance_27().b1c();
    var tmp2 = get_INTERRUPTED_SEND();
    var tmp$ret$4;
    $l$block_5: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
      var segment = access$_get_sendSegment__111kgq(this).kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s(this).atomicfu$getAndIncrement$long();
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var s = sendersAndCloseStatusCur.u3(access$_get_SENDERS_COUNTER_MASK_$tBufferedChannelKt_6ll4te());
        var closed = access$_get_isClosedForSend0__sm8f7a(this, sendersAndCloseStatusCur);
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = s.l3(toLong(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var i = s.m3(toLong(other_0)).z3();
        if (!segment.px_1.equals(id)) {
          var tmp0_elvis_lhs = access$findSegmentSend(this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0;
            if (closed) {
              // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
              tmp$ret$4 = Companion_getInstance_27().m19(this.q18());
              break $l$block_5;
            } else {
              continue $l$loop_0;
            }
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        var tmp1_subject = access$updateCellSend(this, segment, i, element, s, tmp2, closed);
        if (tmp1_subject === access$_get_RESULT_RENDEZVOUS_$tBufferedChannelKt_ykevfn()) {
          segment.g17();
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
          tmp$ret$4 = Companion_getInstance_27().w18(Unit_instance);
          break $l$block_5;
        } else if (tmp1_subject === access$_get_RESULT_BUFFERED_$tBufferedChannelKt_tnykj7()) {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
          tmp$ret$4 = Companion_getInstance_27().w18(Unit_instance);
          break $l$block_5;
        } else if (tmp1_subject === access$_get_RESULT_SUSPEND_$tBufferedChannelKt_vus6es()) {
          if (closed) {
            segment.w16();
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
            tmp$ret$4 = Companion_getInstance_27().m19(this.q18());
            break $l$block_5;
          }
          var tmp2_safe_receiver = (!(tmp2 == null) ? isInterface(tmp2, Waiter) : false) ? tmp2 : null;
          if (tmp2_safe_receiver == null)
            null;
          else {
            access$prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
          }
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
          segment.w16();
          tmp$ret$4 = Companion_getInstance_27().b1c();
          break $l$block_5;
        } else if (tmp1_subject === access$_get_RESULT_CLOSED_$tBufferedChannelKt_3eqb16()) {
          if (s.d1(this.r18()) < 0) {
            segment.g17();
          }
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.trySend.<anonymous>' call
          tmp$ret$4 = Companion_getInstance_27().m19(this.q18());
          break $l$block_5;
        } else if (tmp1_subject === access$_get_RESULT_FAILED_$tBufferedChannelKt_wacckr()) {
          segment.g17();
          continue $l$loop_0;
        } else if (tmp1_subject === access$_get_RESULT_SUSPEND_NO_WAITER_$tBufferedChannelKt_61h09f()) {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl.<anonymous>' call
          var message = 'unexpected';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
    }
    return tmp$ret$4;
  };
  protoOf(BufferedChannel).y18 = function () {
  };
  protoOf(BufferedChannel).s18 = function () {
  };
  protoOf(BufferedChannel).d1c = function ($completion) {
    var tmp = new $receiveCOROUTINE$4(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(BufferedChannel).e1c = function () {
    var r = this.l16_1.kotlinx$atomicfu$value;
    var sendersAndCloseStatusCur = this.k16_1.kotlinx$atomicfu$value;
    if (_get_isClosedForReceive0__f7qknl(sendersAndCloseStatusCur, this)) {
      return Companion_getInstance_27().m19(this.l17());
    }
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var s = sendersAndCloseStatusCur.u3(new Long(-1, 268435455));
    if (r.d1(s) >= 0)
      return Companion_getInstance_27().b1c();
    var tmp2 = get_INTERRUPTED_RCV();
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
      var segment = this.p16_1.kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        if (this.n17()) {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.tryReceive.<anonymous>' call
          tmp$ret$2 = Companion_getInstance_27().m19(this.l17());
          break $l$block_0;
        }
        var r_0 = this.l16_1.atomicfu$getAndIncrement$long();
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = r_0.l3(toLong(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var i = r_0.m3(toLong(other_0)).z3();
        if (!segment.px_1.equals(id)) {
          var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            continue $l$loop_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        var updCellResult = updateCellReceive(this, segment, i, r_0, tmp2);
        var tmp_0;
        if (updCellResult === get_SUSPEND()) {
          var tmp1_safe_receiver = (!(tmp2 == null) ? isInterface(tmp2, Waiter) : false) ? tmp2 : null;
          if (tmp1_safe_receiver == null)
            null;
          else {
            prepareReceiverForSuspension(tmp1_safe_receiver, this, segment, i);
          }
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.tryReceive.<anonymous>' call
          var segm = segment;
          this.v16(r_0);
          segm.w16();
          tmp_0 = new ChannelResult(Companion_getInstance_27().b1c());
        } else if (updCellResult === get_FAILED()) {
          if (r_0.d1(this.m17()) < 0) {
            segment.g17();
          }
          continue $l$loop_0;
        } else if (updCellResult === get_SUSPEND_NO_WAITER()) {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl.<anonymous>' call
          var message = 'unexpected';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          segment.g17();
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.tryReceive.<anonymous>' call
          var element = (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE();
          tmp_0 = new ChannelResult(Companion_getInstance_27().w18(element));
        }
        tmp$ret$2 = tmp_0.c1c_1;
        break $l$block_0;
      }
    }
    return tmp$ret$2;
  };
  protoOf(BufferedChannel).k19 = function (globalCellIndex) {
    // Inline function 'kotlinx.coroutines.assert' call
    var segment = this.p16_1.kotlinx$atomicfu$value;
    $l$loop_0: while (true) {
      var r = this.l16_1.kotlinx$atomicfu$value;
      // Inline function 'kotlin.Long.plus' call
      var other = this.i16_1;
      var tmp2 = r.i3(toLong(other));
      // Inline function 'kotlin.math.max' call
      var b = _get_bufferEndCounter__2d4hee(this);
      var tmp$ret$1 = tmp2.d1(b) >= 0 ? tmp2 : b;
      if (globalCellIndex.d1(tmp$ret$1) < 0)
        return Unit_instance;
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$2 = r.i3(toLong(1));
      if (!this.l16_1.atomicfu$compareAndSet(r, tmp$ret$2))
        continue $l$loop_0;
      // Inline function 'kotlin.Long.div' call
      var other_0 = get_SEGMENT_SIZE();
      var id = r.l3(toLong(other_0));
      // Inline function 'kotlin.Long.rem' call
      var other_1 = get_SEGMENT_SIZE();
      var i = r.m3(toLong(other_1)).z3();
      if (!segment.px_1.equals(id)) {
        var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      var updCellResult = updateCellReceive(this, segment, i, r, null);
      if (updCellResult === get_FAILED()) {
        if (r.d1(this.m17()) < 0) {
          segment.g17();
        }
      } else {
        segment.g17();
        var tmp1_safe_receiver = this.j16_1;
        var tmp_0;
        if (tmp1_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp_0 = callUndeliveredElementCatchingException(tmp1_safe_receiver, (updCellResult == null ? true : !(updCellResult == null)) ? updCellResult : THROW_CCE());
        }
        var tmp2_safe_receiver = tmp_0;
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          throw tmp2_safe_receiver;
        }
      }
    }
  };
  protoOf(BufferedChannel).v16 = function (globalIndex) {
    if (_get_isRendezvousOrUnlimited__3mdufi(this))
      return Unit_instance;
    while (_get_bufferEndCounter__2d4hee(this).d1(globalIndex) <= 0) {
    }
    // Inline function 'kotlin.repeat' call
    var times = get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS();
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.waitExpandBufferCompletion.<anonymous>' call
        var b = _get_bufferEndCounter__2d4hee(this);
        // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
        var ebCompleted = this.n16_1.kotlinx$atomicfu$value.u3(new Long(-1, 1073741823));
        if (b.equals(ebCompleted) && b.equals(_get_bufferEndCounter__2d4hee(this)))
          return Unit_instance;
      }
       while (inductionVariable < times);
    var tmp2 = this.n16_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp2.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.waitExpandBufferCompletion.<anonymous>' call
        // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
        var tmp$ret$1 = cur.u3(new Long(-1, 1073741823));
        var upd = constructEBCompletedAndPauseFlag(tmp$ret$1, true);
        if (tmp2.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    while (true) {
      var b_0 = _get_bufferEndCounter__2d4hee(this);
      var ebCompletedAndBit = this.n16_1.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
      var ebCompleted_0 = ebCompletedAndBit.u3(new Long(-1, 1073741823));
      // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
      var pauseExpandBuffers = !ebCompletedAndBit.u3(new Long(0, 1073741824)).equals(new Long(0, 0));
      if (b_0.equals(ebCompleted_0) && b_0.equals(_get_bufferEndCounter__2d4hee(this))) {
        var tmp4 = this.n16_1;
        $l$block_0: {
          // Inline function 'kotlinx.atomicfu.update' call
          while (true) {
            var cur_0 = tmp4.kotlinx$atomicfu$value;
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.waitExpandBufferCompletion.<anonymous>' call
            // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
            var tmp$ret$6 = cur_0.u3(new Long(-1, 1073741823));
            var upd_0 = constructEBCompletedAndPauseFlag(tmp$ret$6, false);
            if (tmp4.atomicfu$compareAndSet(cur_0, upd_0)) {
              break $l$block_0;
            }
          }
        }
        return Unit_instance;
      }
      if (!pauseExpandBuffers) {
        this.n16_1.atomicfu$compareAndSet(ebCompletedAndBit, constructEBCompletedAndPauseFlag(ebCompleted_0, true));
      }
    }
  };
  protoOf(BufferedChannel).k = function () {
    return new BufferedChannelIterator(this);
  };
  protoOf(BufferedChannel).l17 = function () {
    var tmp = this.s16_1.kotlinx$atomicfu$value;
    return (tmp == null ? true : tmp instanceof Error) ? tmp : THROW_CCE();
  };
  protoOf(BufferedChannel).q18 = function () {
    var tmp0_elvis_lhs = this.l17();
    return tmp0_elvis_lhs == null ? new ClosedSendChannelException('Channel was closed') : tmp0_elvis_lhs;
  };
  protoOf(BufferedChannel).f1c = function () {
  };
  protoOf(BufferedChannel).g1c = function (cause) {
    return this.h1c(cause, false);
  };
  protoOf(BufferedChannel).ou = function (cause) {
    this.j1c(cause);
  };
  protoOf(BufferedChannel).j1c = function (cause) {
    return this.h1c(cause == null ? CancellationException_init_$Create$_0('Channel was cancelled') : cause, true);
  };
  protoOf(BufferedChannel).h1c = function (cause, cancel) {
    if (cancel) {
      markCancellationStarted(this);
    }
    var closedByThisOperation = this.s16_1.atomicfu$compareAndSet(get_NO_CLOSE_CAUSE(), cause);
    if (cancel) {
      markCancelled(this);
    } else {
      markClosed(this);
    }
    completeCloseOrCancel(this);
    // Inline function 'kotlin.also' call
    // Inline function 'kotlinx.coroutines.channels.BufferedChannel.closeOrCancelImpl.<anonymous>' call
    this.f1c();
    if (closedByThisOperation) {
      invokeCloseHandler(this);
    }
    return closedByThisOperation;
  };
  protoOf(BufferedChannel).l19 = function () {
    return false;
  };
  protoOf(BufferedChannel).j19 = function () {
    return _get_isClosedForSend0__kxgf9m(this.k16_1.kotlinx$atomicfu$value, this);
  };
  protoOf(BufferedChannel).n17 = function () {
    return _get_isClosedForReceive0__f7qknl(this.k16_1.kotlinx$atomicfu$value, this);
  };
  protoOf(BufferedChannel).n19 = function () {
    $l$loop: while (true) {
      var segment = this.p16_1.kotlinx$atomicfu$value;
      var r = this.r18();
      var s = this.m17();
      if (s.d1(r) <= 0)
        return false;
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = r.l3(toLong(other));
      if (!segment.px_1.equals(id)) {
        var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp_0;
          if (this.p16_1.kotlinx$atomicfu$value.px_1.d1(id) < 0) {
            return false;
          } else {
            continue $l$loop;
          }
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      segment.g17();
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var i = r.m3(toLong(other_0)).z3();
      if (isCellNonEmpty(this, segment, i, r))
        return true;
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$2 = r.i3(toLong(1));
      this.l16_1.atomicfu$compareAndSet(r, tmp$ret$2);
    }
  };
  protoOf(BufferedChannel).toString = function () {
    var sb = StringBuilder_init_$Create$_1();
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var tmp0_subject = this.k16_1.kotlinx$atomicfu$value.s3(60).z3();
    if (tmp0_subject === 2) {
      sb.d9('closed,');
    } else if (tmp0_subject === 3) {
      sb.d9('cancelled,');
    }
    sb.d9('capacity=' + this.i16_1 + ',');
    sb.d9('data=[');
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = listOf_0([this.p16_1.kotlinx$atomicfu$value, this.o16_1.kotlinx$atomicfu$value, this.q16_1.kotlinx$atomicfu$value]);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.toString.<anonymous>' call
      if (!(element === get_NULL_SEGMENT())) {
        destination.e(element);
      }
    }
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      var iterator = destination.k();
      if (!iterator.l())
        throw NoSuchElementException_init_$Create$();
      var minElem = iterator.m();
      if (!iterator.l()) {
        tmp$ret$4 = minElem;
        break $l$block;
      }
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.toString.<anonymous>' call
      var minValue = minElem.px_1;
      do {
        var e = iterator.m();
        // Inline function 'kotlinx.coroutines.channels.BufferedChannel.toString.<anonymous>' call
        var v = e.px_1;
        if (compareTo_0(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.l());
      tmp$ret$4 = minElem;
    }
    var firstSegment = tmp$ret$4;
    var r = this.r18();
    var s = this.m17();
    var segment = firstSegment;
    append_elements: while (true) {
      var inductionVariable = 0;
      var last = get_SEGMENT_SIZE();
      if (inductionVariable < last)
        process_cell: do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp5 = segment.px_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var globalCellIndex = tmp5.k3(toLong(other)).i3(toLong(i));
          if (globalCellIndex.d1(s) >= 0 && globalCellIndex.d1(r) >= 0)
            break append_elements;
          var cellState = segment.e16(i);
          var element_0 = segment.b16(i);
          var tmp;
          if (!(cellState == null) ? isInterface(cellState, CancellableContinuation) : false) {
            tmp = globalCellIndex.d1(r) < 0 && globalCellIndex.d1(s) >= 0 ? 'receive' : globalCellIndex.d1(s) < 0 && globalCellIndex.d1(r) >= 0 ? 'send' : 'cont';
          } else {
            if (!(cellState == null) ? isInterface(cellState, SelectInstance) : false) {
              tmp = globalCellIndex.d1(r) < 0 && globalCellIndex.d1(s) >= 0 ? 'onReceive' : globalCellIndex.d1(s) < 0 && globalCellIndex.d1(r) >= 0 ? 'onSend' : 'select';
            } else {
              if (cellState instanceof ReceiveCatching) {
                tmp = 'receiveCatching';
              } else {
                if (cellState instanceof SendBroadcast) {
                  tmp = 'sendBroadcast';
                } else {
                  if (cellState instanceof WaiterEB) {
                    tmp = 'EB(' + toString_0(cellState) + ')';
                  } else {
                    if (equals(cellState, get_RESUMING_BY_RCV()) ? true : equals(cellState, get_RESUMING_BY_EB())) {
                      tmp = 'resuming_sender';
                    } else {
                      if ((((((cellState == null ? true : equals(cellState, get_IN_BUFFER())) ? true : equals(cellState, get_DONE_RCV())) ? true : equals(cellState, get_POISONED())) ? true : equals(cellState, get_INTERRUPTED_RCV())) ? true : equals(cellState, get_INTERRUPTED_SEND())) ? true : equals(cellState, get_CHANNEL_CLOSED())) {
                        continue process_cell;
                      } else {
                        tmp = toString_1(cellState);
                      }
                    }
                  }
                }
              }
            }
          }
          var cellStateString = tmp;
          if (!(element_0 == null)) {
            sb.d9('(' + cellStateString + ',' + toString_0(element_0) + '),');
          } else {
            sb.d9(cellStateString + ',');
          }
        }
         while (inductionVariable < last);
      var tmp3_elvis_lhs = segment.c17();
      var tmp_0;
      if (tmp3_elvis_lhs == null) {
        break append_elements;
      } else {
        tmp_0 = tmp3_elvis_lhs;
      }
      segment = tmp_0;
    }
    if (last_2(sb) === _Char___init__impl__6a9atx(44)) {
      sb.hd(sb.a() - 1 | 0);
    }
    sb.d9(']');
    return sb.toString();
  };
  function WaiterEB(waiter) {
    this.t18_1 = waiter;
  }
  protoOf(WaiterEB).toString = function () {
    return 'WaiterEB(' + toString_1(this.t18_1) + ')';
  };
  function initialBufferEnd(capacity) {
    _init_properties_BufferedChannel_kt__d6uc4y();
    switch (capacity) {
      case 0:
        return new Long(0, 0);
      case 2147483647:
        return new Long(-1, 2147483647);
      default:
        return toLong(capacity);
    }
  }
  function ReceiveCatching() {
  }
  function tryResume0(_this__u8e3s4, value, onCancellation) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    _init_properties_BufferedChannel_kt__d6uc4y();
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.channels.tryResume0.<anonymous>' call
    var token = _this__u8e3s4.pw(value, null, onCancellation);
    var tmp;
    if (!(token == null)) {
      _this__u8e3s4.qw(token);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function constructEBCompletedAndPauseFlag(counter, pauseEB) {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return (pauseEB ? new Long(0, 1073741824) : new Long(0, 0)).i3(counter);
  }
  function constructSendersAndCloseStatus(counter, closeStatus) {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return toLong(closeStatus).r3(60).i3(counter);
  }
  function createSegmentFunction() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return createSegment$ref();
  }
  function createSegment(id, prev) {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return new ChannelSegment(id, prev, prev.y15(), 0);
  }
  function access$_get_RESULT_RENDEZVOUS_$tBufferedChannelKt_ykevfn() {
    return 0;
  }
  function access$_get_RESULT_BUFFERED_$tBufferedChannelKt_tnykj7() {
    return 1;
  }
  function access$_get_RESULT_SUSPEND_$tBufferedChannelKt_vus6es() {
    return 2;
  }
  function access$_get_RESULT_CLOSED_$tBufferedChannelKt_3eqb16() {
    return 4;
  }
  function access$_get_RESULT_FAILED_$tBufferedChannelKt_wacckr() {
    return 5;
  }
  function access$_get_RESULT_SUSPEND_NO_WAITER_$tBufferedChannelKt_61h09f() {
    return 3;
  }
  function access$_get_SENDERS_COUNTER_MASK_$tBufferedChannelKt_6ll4te() {
    return new Long(-1, 268435455);
  }
  function createSegment$ref() {
    var l = function (p0, p1) {
      return createSegment(p0, p1);
    };
    l.callableName = 'createSegment';
    return l;
  }
  var properties_initialized_BufferedChannel_kt_58tjvw;
  function _init_properties_BufferedChannel_kt__d6uc4y() {
    if (!properties_initialized_BufferedChannel_kt_58tjvw) {
      properties_initialized_BufferedChannel_kt_58tjvw = true;
      NULL_SEGMENT = new ChannelSegment(new Long(-1, -1), null, null, 0);
      SEGMENT_SIZE = systemProp('kotlinx.coroutines.bufferedChannel.segmentSize', 32);
      EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS = systemProp('kotlinx.coroutines.bufferedChannel.expandBufferCompletionWaitIterations', 10000);
      BUFFERED = new Symbol_0('BUFFERED');
      IN_BUFFER = new Symbol_0('SHOULD_BUFFER');
      RESUMING_BY_RCV = new Symbol_0('S_RESUMING_BY_RCV');
      RESUMING_BY_EB = new Symbol_0('RESUMING_BY_EB');
      POISONED = new Symbol_0('POISONED');
      DONE_RCV = new Symbol_0('DONE_RCV');
      INTERRUPTED_SEND = new Symbol_0('INTERRUPTED_SEND');
      INTERRUPTED_RCV = new Symbol_0('INTERRUPTED_RCV');
      CHANNEL_CLOSED = new Symbol_0('CHANNEL_CLOSED');
      SUSPEND = new Symbol_0('SUSPEND');
      SUSPEND_NO_WAITER = new Symbol_0('SUSPEND_NO_WAITER');
      FAILED = new Symbol_0('FAILED');
      NO_RECEIVE_RESULT = new Symbol_0('NO_RECEIVE_RESULT');
      CLOSE_HANDLER_CLOSED = new Symbol_0('CLOSE_HANDLER_CLOSED');
      CLOSE_HANDLER_INVOKED = new Symbol_0('CLOSE_HANDLER_INVOKED');
      NO_CLOSE_CAUSE = new Symbol_0('NO_CLOSE_CAUSE');
    }
  }
  function Factory() {
    Factory_instance = this;
    this.l1c_1 = 2147483647;
    this.m1c_1 = 0;
    this.n1c_1 = -1;
    this.o1c_1 = -2;
    this.p1c_1 = -3;
    this.q1c_1 = 'kotlinx.coroutines.channels.defaultBuffer';
    this.r1c_1 = systemProp('kotlinx.coroutines.channels.defaultBuffer', 64, 1, 2147483646);
  }
  var Factory_instance;
  function Factory_getInstance() {
    if (Factory_instance == null)
      new Factory();
    return Factory_instance;
  }
  function _ChannelResult___init__impl__siwsuf(holder) {
    return holder;
  }
  function _ChannelResult___get_holder__impl__pm9gzw($this) {
    return $this;
  }
  function _ChannelResult___get_isSuccess__impl__odq1z9($this) {
    var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
    return !(tmp instanceof Failed);
  }
  function _ChannelResult___get_isClosed__impl__mg7kuu($this) {
    var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
    return tmp instanceof Closed;
  }
  function ChannelResult__getOrNull_impl_f5e07h($this) {
    var tmp;
    var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw($this);
    if (!(tmp_0 instanceof Failed)) {
      var tmp_1 = _ChannelResult___get_holder__impl__pm9gzw($this);
      tmp = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  }
  function ChannelResult__getOrThrow_impl_od1axs($this) {
    var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
    if (!(tmp instanceof Failed)) {
      var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw($this);
      return (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    var tmp_1;
    var tmp_2 = _ChannelResult___get_holder__impl__pm9gzw($this);
    if (tmp_2 instanceof Closed) {
      tmp_1 = !(_ChannelResult___get_holder__impl__pm9gzw($this).s1c_1 == null);
    } else {
      tmp_1 = false;
    }
    if (tmp_1)
      throw _ChannelResult___get_holder__impl__pm9gzw($this).s1c_1;
    // Inline function 'kotlin.error' call
    var message = "Trying to call 'getOrThrow' on a failed channel result: " + toString_0(_ChannelResult___get_holder__impl__pm9gzw($this));
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  }
  function ChannelResult__exceptionOrNull_impl_16ei30($this) {
    var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
    var tmp0_safe_receiver = tmp instanceof Closed ? tmp : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s1c_1;
  }
  function Failed() {
  }
  protoOf(Failed).toString = function () {
    return 'Failed';
  };
  function Closed(cause) {
    Failed.call(this);
    this.s1c_1 = cause;
  }
  protoOf(Closed).equals = function (other) {
    var tmp;
    if (other instanceof Closed) {
      tmp = equals(this.s1c_1, other.s1c_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Closed).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.s1c_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(Closed).toString = function () {
    return 'Closed(' + toString_0(this.s1c_1) + ')';
  };
  function Companion_27() {
    Companion_instance_27 = this;
    this.v18_1 = new Failed();
  }
  protoOf(Companion_27).w18 = function (value) {
    return _ChannelResult___init__impl__siwsuf(value);
  };
  protoOf(Companion_27).b1c = function () {
    return _ChannelResult___init__impl__siwsuf(this.v18_1);
  };
  protoOf(Companion_27).m19 = function (cause) {
    return _ChannelResult___init__impl__siwsuf(new Closed(cause));
  };
  var Companion_instance_27;
  function Companion_getInstance_27() {
    if (Companion_instance_27 == null)
      new Companion_27();
    return Companion_instance_27;
  }
  function ChannelResult__toString_impl_rrcqu7($this) {
    var tmp;
    if (_ChannelResult___get_holder__impl__pm9gzw($this) instanceof Closed) {
      tmp = toString_1(_ChannelResult___get_holder__impl__pm9gzw($this));
    } else {
      tmp = 'Value(' + toString_0(_ChannelResult___get_holder__impl__pm9gzw($this)) + ')';
    }
    return tmp;
  }
  function ChannelResult__hashCode_impl_lilec2($this) {
    return $this == null ? 0 : hashCode($this);
  }
  function ChannelResult__equals_impl_f471ri($this, other) {
    if (!(other instanceof ChannelResult))
      return false;
    var tmp0_other_with_cast = other instanceof ChannelResult ? other.c1c_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ChannelResult(holder) {
    Companion_getInstance_27();
    this.c1c_1 = holder;
  }
  protoOf(ChannelResult).toString = function () {
    return ChannelResult__toString_impl_rrcqu7(this.c1c_1);
  };
  protoOf(ChannelResult).hashCode = function () {
    return ChannelResult__hashCode_impl_lilec2(this.c1c_1);
  };
  protoOf(ChannelResult).equals = function (other) {
    return ChannelResult__equals_impl_f471ri(this.c1c_1, other);
  };
  function ClosedSendChannelException(message) {
    IllegalStateException_init_$Init$_0(message, this);
    captureStack(this, ClosedSendChannelException);
  }
  function ClosedReceiveChannelException(message) {
    NoSuchElementException_init_$Init$_0(message, this);
    captureStack(this, ClosedReceiveChannelException);
  }
  function SendChannel() {
  }
  function ReceiveChannel() {
  }
  function Channel(capacity, onBufferOverflow, onUndeliveredElement) {
    capacity = capacity === VOID ? 0 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
    var tmp;
    switch (capacity) {
      case 0:
        tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(0, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
        break;
      case -1:
        // Inline function 'kotlin.require' call

        if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
          // Inline function 'kotlinx.coroutines.channels.Channel.<anonymous>' call
          var message = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
          throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        }

        tmp = new ConflatedBufferedChannel(1, BufferOverflow_DROP_OLDEST_getInstance(), onUndeliveredElement);
        break;
      case 2147483647:
        tmp = new BufferedChannel(2147483647, onUndeliveredElement);
        break;
      case -2:
        tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(Factory_getInstance().r1c_1, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
        break;
      default:
        tmp = onBufferOverflow === BufferOverflow_SUSPEND_getInstance() ? new BufferedChannel(capacity, onUndeliveredElement) : new ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement);
        break;
    }
    return tmp;
  }
  function ChannelCoroutine(parentContext, _channel, initParentJob, active) {
    AbstractCoroutine.call(this, parentContext, initParentJob, active);
    this.w1c_1 = _channel;
  }
  protoOf(ChannelCoroutine).j19 = function () {
    return this.w1c_1.j19();
  };
  protoOf(ChannelCoroutine).g1c = function (cause) {
    return this.w1c_1.g1c(cause);
  };
  protoOf(ChannelCoroutine).k = function () {
    return this.w1c_1.k();
  };
  protoOf(ChannelCoroutine).d1c = function ($completion) {
    return this.w1c_1.d1c($completion);
  };
  protoOf(ChannelCoroutine).z1b = function (element, $completion) {
    return this.w1c_1.z1b(element, $completion);
  };
  protoOf(ChannelCoroutine).e1c = function () {
    return this.w1c_1.e1c();
  };
  protoOf(ChannelCoroutine).a1c = function (element) {
    return this.w1c_1.a1c(element);
  };
  protoOf(ChannelCoroutine).y15 = function () {
    return this;
  };
  protoOf(ChannelCoroutine).ou = function (cause) {
    if (this.bu())
      return Unit_instance;
    var tmp;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = new JobCancellationException(null == null ? this.it() : null, null, this);
    } else {
      tmp = cause;
    }
    this.qu(tmp);
  };
  protoOf(ChannelCoroutine).k1c = function (cause, $super) {
    return this.pu(cause, ($super == null ? true : $super instanceof ChannelCoroutine) ? $super : THROW_CCE());
  };
  protoOf(ChannelCoroutine).qu = function (cause) {
    var exception = this.gu(cause);
    this.w1c_1.ou(exception);
    this.tu(exception);
  };
  function cancelConsumed(_this__u8e3s4, cause) {
    var tmp;
    if (cause == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.channels.cancelConsumed.<anonymous>' call
      var tmp0_elvis_lhs = cause instanceof CancellationException ? cause : null;
      tmp = tmp0_elvis_lhs == null ? CancellationException_init_$Create$_1('Channel was consumed, consumer had failed', cause) : tmp0_elvis_lhs;
    }
    _this__u8e3s4.ou(tmp);
  }
  function trySendImpl($this, element, isSendOp) {
    return $this.k1d_1 === BufferOverflow_DROP_LATEST_getInstance() ? trySendDropLatest($this, element, isSendOp) : trySendDropOldest($this, element);
  }
  function trySendDropLatest($this, element, isSendOp) {
    var result = protoOf(BufferedChannel).a1c.call($this, element);
    if (_ChannelResult___get_isSuccess__impl__odq1z9(result) || _ChannelResult___get_isClosed__impl__mg7kuu(result))
      return result;
    if (isSendOp) {
      var tmp0_safe_receiver = $this.j16_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        throw tmp1_safe_receiver;
      }
    }
    return Companion_getInstance_27().w18(Unit_instance);
  }
  function trySendDropOldest($this, element) {
    var tmp2 = get_BUFFERED();
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
      var segment = access$_get_sendSegment__111kgq($this).kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s($this).atomicfu$getAndIncrement$long();
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var s = sendersAndCloseStatusCur.u3(access$_get_SENDERS_COUNTER_MASK_$tBufferedChannelKt_6ll4te());
        var closed = access$_get_isClosedForSend0__sm8f7a($this, sendersAndCloseStatusCur);
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = s.l3(toLong(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var i = s.m3(toLong(other_0)).z3();
        if (!segment.px_1.equals(id)) {
          var tmp0_elvis_lhs = access$findSegmentSend($this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0;
            if (closed) {
              return Companion_getInstance_27().m19($this.q18());
            } else {
              continue $l$loop_0;
            }
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        var tmp1_subject = access$updateCellSend($this, segment, i, element, s, tmp2, closed);
        if (tmp1_subject === access$_get_RESULT_RENDEZVOUS_$tBufferedChannelKt_ykevfn()) {
          segment.g17();
          return Companion_getInstance_27().w18(Unit_instance);
        } else if (tmp1_subject === access$_get_RESULT_BUFFERED_$tBufferedChannelKt_tnykj7()) {
          return Companion_getInstance_27().w18(Unit_instance);
        } else if (tmp1_subject === access$_get_RESULT_SUSPEND_$tBufferedChannelKt_vus6es()) {
          if (closed) {
            segment.w16();
            return Companion_getInstance_27().m19($this.q18());
          }
          var tmp2_safe_receiver = (!(tmp2 == null) ? isInterface(tmp2, Waiter) : false) ? tmp2 : null;
          if (tmp2_safe_receiver == null)
            null;
          else {
            access$prepareSenderForSuspension($this, tmp2_safe_receiver, segment, i);
          }
          var tmp0 = segment.px_1;
          // Inline function 'kotlin.Long.times' call
          var other_1 = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var tmp$ret$5 = tmp0.k3(toLong(other_1)).i3(toLong(i));
          $this.k19(tmp$ret$5);
          return Companion_getInstance_27().w18(Unit_instance);
        } else if (tmp1_subject === access$_get_RESULT_CLOSED_$tBufferedChannelKt_3eqb16()) {
          if (s.d1($this.r18()) < 0) {
            segment.g17();
          }
          return Companion_getInstance_27().m19($this.q18());
        } else if (tmp1_subject === access$_get_RESULT_FAILED_$tBufferedChannelKt_wacckr()) {
          segment.g17();
          continue $l$loop_0;
        } else if (tmp1_subject === access$_get_RESULT_SUSPEND_NO_WAITER_$tBufferedChannelKt_61h09f()) {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl.<anonymous>' call
          var message = 'unexpected';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
    }
    return tmp$ret$3;
  }
  function ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement) {
    onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
    BufferedChannel.call(this, capacity, onUndeliveredElement);
    this.j1d_1 = capacity;
    this.k1d_1 = onBufferOverflow;
    // Inline function 'kotlin.require' call
    if (!!(this.k1d_1 === BufferOverflow_SUSPEND_getInstance())) {
      // Inline function 'kotlinx.coroutines.channels.ConflatedBufferedChannel.<anonymous>' call
      var message = 'This implementation does not support suspension for senders, use ' + getKClass(BufferedChannel).lb() + ' instead';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.j1d_1 >= 1)) {
      // Inline function 'kotlinx.coroutines.channels.ConflatedBufferedChannel.<anonymous>' call
      var message_0 = 'Buffered channel capacity must be at least 1, but ' + this.j1d_1 + ' was specified';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
  }
  protoOf(ConflatedBufferedChannel).l19 = function () {
    return this.k1d_1.equals(BufferOverflow_DROP_OLDEST_getInstance());
  };
  protoOf(ConflatedBufferedChannel).z1b = function (element, $completion) {
    // Inline function 'kotlinx.coroutines.channels.onClosed' call
    var this_0 = trySendImpl(this, element, true);
    // Inline function 'kotlin.contracts.contract' call
    var tmp = _ChannelResult___get_holder__impl__pm9gzw(this_0);
    if (tmp instanceof Closed) {
      // Inline function 'kotlinx.coroutines.channels.ConflatedBufferedChannel.send.<anonymous>' call
      ChannelResult__exceptionOrNull_impl_16ei30(this_0);
      var tmp0_safe_receiver = this.j16_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        addSuppressed(tmp1_safe_receiver, this.q18());
        throw tmp1_safe_receiver;
      }
      throw this.q18();
    }
    return Unit_instance;
  };
  protoOf(ConflatedBufferedChannel).a1c = function (element) {
    return trySendImpl(this, element, false);
  };
  function ProducerScope() {
  }
  function produce(_this__u8e3s4, context, capacity, onBufferOverflow, start, onCompletion, block) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? 0 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
    onCompletion = onCompletion === VOID ? null : onCompletion;
    var channel = Channel(capacity, onBufferOverflow);
    var newContext = newCoroutineContext(_this__u8e3s4, context);
    var coroutine = new ProducerCoroutine(newContext, channel);
    if (!(onCompletion == null)) {
      coroutine.hu(onCompletion);
    }
    coroutine.st(start, coroutine, block);
    return coroutine;
  }
  function ProducerCoroutine(parentContext, channel) {
    ChannelCoroutine.call(this, parentContext, channel, true, true);
  }
  protoOf(ProducerCoroutine).ft = function () {
    return protoOf(ChannelCoroutine).ft.call(this);
  };
  protoOf(ProducerCoroutine).p1d = function (value) {
    this.w1c_1.i1c();
  };
  protoOf(ProducerCoroutine).gt = function (value) {
    return this.p1d(value instanceof Unit ? value : THROW_CCE());
  };
  protoOf(ProducerCoroutine).ht = function (cause, handled) {
    var processed = this.w1c_1.g1c(cause);
    if (!processed && !handled) {
      handleCoroutineException(this.dt_1, cause);
    }
  };
  protoOf(ProducerCoroutine).k1c = function (cause, $super) {
    return this.pu(cause, ($super == null ? true : $super instanceof ProducerCoroutine) ? $super : THROW_CCE());
  };
  function produce_0(_this__u8e3s4, context, capacity, block) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? 0 : capacity;
    return produce(_this__u8e3s4, context, capacity, BufferOverflow_SUSPEND_getInstance(), CoroutineStart_DEFAULT_getInstance(), null, block);
  }
  function flow(block) {
    return new SafeFlow(block);
  }
  function asFlow(_this__u8e3s4) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new asFlow$$inlined$unsafeFlow$1(_this__u8e3s4);
  }
  function asFlow_0(_this__u8e3s4) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new asFlow$$inlined$unsafeFlow$2(_this__u8e3s4);
  }
  function channelFlow(block) {
    return new ChannelFlowBuilder(block);
  }
  function SafeFlow(block) {
    AbstractFlow.call(this);
    this.q1d_1 = block;
  }
  protoOf(SafeFlow).r1d = function (collector, $completion) {
    return this.q1d_1(collector, $completion);
  };
  function ChannelFlowBuilder(block, context, capacity, onBufferOverflow) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? -2 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    ChannelFlow.call(this, context, capacity, onBufferOverflow);
    this.w1d_1 = block;
  }
  protoOf(ChannelFlowBuilder).x1d = function (context, capacity, onBufferOverflow) {
    return new ChannelFlowBuilder(this.w1d_1, context, capacity, onBufferOverflow);
  };
  protoOf(ChannelFlowBuilder).y1d = function (scope, $completion) {
    return this.w1d_1(scope, $completion);
  };
  protoOf(ChannelFlowBuilder).toString = function () {
    return 'block[' + toString_1(this.w1d_1) + '] -> ' + protoOf(ChannelFlow).toString.call(this);
  };
  function emptyFlow() {
    return EmptyFlow_instance;
  }
  function EmptyFlow() {
  }
  protoOf(EmptyFlow).j1e = function (collector, $completion) {
    return Unit_instance;
  };
  protoOf(EmptyFlow).s1d = function (collector, $completion) {
    return this.j1e(collector, $completion);
  };
  var EmptyFlow_instance;
  function EmptyFlow_getInstance() {
    return EmptyFlow_instance;
  }
  function $collectCOROUTINE$10(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s1e_1 = _this__u8e3s4;
    this.t1e_1 = collector;
  }
  protoOf($collectCOROUTINE$10).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.u1e_1 = this.t1e_1;
            this.v1e_1 = this.u1e_1;
            var tmp_1 = this;
            tmp_1.w1e_1 = this.s1e_1.c1f_1;
            this.x1e_1 = this.w1e_1;
            this.y1e_1 = this.x1e_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.y1e_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.z1e_1 = this.y1e_1.m();
            var tmp_2 = this;
            tmp_2.a1f_1 = this.z1e_1;
            this.b1f_1 = this.a1f_1;
            this.y9_1 = 2;
            suspendResult = this.v1e_1.d1f(this.b1f_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.y9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function asFlow$$inlined$unsafeFlow$1($this_asFlow) {
    this.c1f_1 = $this_asFlow;
  }
  protoOf(asFlow$$inlined$unsafeFlow$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$10(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(asFlow$$inlined$unsafeFlow$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function $collectCOROUTINE$11(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n1f_1 = _this__u8e3s4;
    this.o1f_1 = collector;
  }
  protoOf($collectCOROUTINE$11).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.p1f_1 = this.o1f_1;
            this.q1f_1 = this.p1f_1;
            var tmp_1 = this;
            tmp_1.r1f_1 = this.n1f_1.x1f_1;
            this.s1f_1 = this.r1f_1;
            this.t1f_1 = this.s1f_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.t1f_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.u1f_1 = this.t1f_1.m();
            var tmp_2 = this;
            tmp_2.v1f_1 = this.u1f_1;
            this.w1f_1 = this.v1f_1;
            this.y9_1 = 2;
            suspendResult = this.q1f_1.d1f(this.w1f_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.y9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function asFlow$$inlined$unsafeFlow$2($this_asFlow) {
    this.x1f_1 = $this_asFlow;
  }
  protoOf(asFlow$$inlined$unsafeFlow$2).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$11(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(asFlow$$inlined$unsafeFlow$2).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function emitAll(_this__u8e3s4, channel, $completion) {
    return emitAllImpl(_this__u8e3s4, channel, true, $completion);
  }
  function emitAllImpl(_this__u8e3s4, channel, consume, $completion) {
    var tmp = new $emitAllImplCOROUTINE$12(_this__u8e3s4, channel, consume, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function consumeAsFlow(_this__u8e3s4) {
    return new ChannelAsFlow(_this__u8e3s4, true);
  }
  function markConsumed($this) {
    if ($this.r1g_1) {
      // Inline function 'kotlin.check' call
      if (!!$this.s1g_1.atomicfu$getAndSet(true)) {
        // Inline function 'kotlinx.coroutines.flow.ChannelAsFlow.markConsumed.<anonymous>' call
        var message = 'ReceiveChannel.consumeAsFlow can be collected just once';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function $collectCOROUTINE$13(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.b1h_1 = _this__u8e3s4;
    this.c1h_1 = collector;
  }
  protoOf($collectCOROUTINE$13).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            if (this.b1h_1.a1e_1 === -3) {
              markConsumed(this.b1h_1);
              this.y9_1 = 2;
              suspendResult = emitAllImpl(this.c1h_1, this.b1h_1.q1g_1, this.b1h_1.r1g_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = protoOf(ChannelFlow).s1d.call(this.b1h_1, this.c1h_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.y9_1 = 3;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ChannelAsFlow(channel, consume, context, capacity, onBufferOverflow) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? -3 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    ChannelFlow.call(this, context, capacity, onBufferOverflow);
    this.q1g_1 = channel;
    this.r1g_1 = consume;
    this.s1g_1 = atomic$boolean$1(false);
  }
  protoOf(ChannelAsFlow).x1d = function (context, capacity, onBufferOverflow) {
    return new ChannelAsFlow(this.q1g_1, this.r1g_1, context, capacity, onBufferOverflow);
  };
  protoOf(ChannelAsFlow).e1e = function () {
    return new ChannelAsFlow(this.q1g_1, this.r1g_1);
  };
  protoOf(ChannelAsFlow).y1d = function (scope, $completion) {
    return emitAllImpl(new SendingCollector(scope), this.q1g_1, this.r1g_1, $completion);
  };
  protoOf(ChannelAsFlow).h1e = function (scope) {
    markConsumed(this);
    var tmp;
    if (this.a1e_1 === -3) {
      tmp = this.q1g_1;
    } else {
      tmp = protoOf(ChannelFlow).h1e.call(this, scope);
    }
    return tmp;
  };
  protoOf(ChannelAsFlow).s1d = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$13(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ChannelAsFlow).i1e = function () {
    return 'channel=' + toString_1(this.q1g_1);
  };
  function $emitAllImplCOROUTINE$12(_this__u8e3s4, channel, consume, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g1g_1 = _this__u8e3s4;
    this.h1g_1 = channel;
    this.i1g_1 = consume;
  }
  protoOf($emitAllImplCOROUTINE$12).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 9;
            ensureActive_1(this.g1g_1);
            this.j1g_1 = null;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 7;
            this.z9_1 = 6;
            this.l1g_1 = this.h1g_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            suspendResult = this.l1g_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (!suspendResult) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.m1g_1 = this.l1g_1.m();
            this.y9_1 = 4;
            suspendResult = this.g1g_1.d1f(this.m1g_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.y9_1 = 2;
            continue $sm;
          case 5:
            this.k1g_1 = Unit_instance;
            this.z9_1 = 9;
            this.y9_1 = 8;
            continue $sm;
          case 6:
            this.z9_1 = 7;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof Error) {
              var e = this.ba_1;
              var tmp_1 = this;
              this.j1g_1 = e;
              throw e;
            } else {
              throw this.ba_1;
            }

          case 7:
            this.z9_1 = 9;
            var t = this.ba_1;
            if (this.i1g_1) {
              cancelConsumed(this.h1g_1, this.j1g_1);
            }

            throw t;
          case 8:
            this.z9_1 = 9;
            if (this.i1g_1) {
              cancelConsumed(this.h1g_1, this.j1g_1);
            }

            return Unit_instance;
          case 9:
            throw this.ba_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 9) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  function Flow() {
  }
  function $collectCOROUTINE$14(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l1h_1 = _this__u8e3s4;
    this.m1h_1 = collector;
  }
  protoOf($collectCOROUTINE$14).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            var tmp_0 = this;
            tmp_0.n1h_1 = new SafeCollector(this.m1h_1, this.ea());
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 4;
            this.y9_1 = 2;
            suspendResult = this.l1h_1.r1d(this.n1h_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o1h_1 = suspendResult;
            this.z9_1 = 5;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 5;
            this.n1h_1.ia();
            return Unit_instance;
          case 4:
            this.z9_1 = 5;
            var t = this.ba_1;
            this.n1h_1.ia();
            throw t;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function AbstractFlow() {
  }
  protoOf(AbstractFlow).s1d = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$14(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function FlowCollector() {
  }
  var NO_VALUE;
  function fuseSharedFlow(_this__u8e3s4, context, capacity, onBufferOverflow) {
    _init_properties_SharedFlow_kt__umasnn();
    if ((capacity === 0 || capacity === -3) && onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
      return _this__u8e3s4;
    }
    return new ChannelFlowOperatorImpl(_this__u8e3s4, context, capacity, onBufferOverflow);
  }
  function _get_head__d7jo8b($this) {
    var tmp0 = $this.c1i_1;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = $this.b1i_1;
    return tmp0.d1(b) <= 0 ? tmp0 : b;
  }
  function _get_replaySize__dxgnb1($this) {
    var tmp0 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other = $this.d1i_1;
    return tmp0.i3(toLong(other)).j3($this.b1i_1).z3();
  }
  function _get_totalSize__xhdb3o($this) {
    return $this.d1i_1 + $this.e1i_1 | 0;
  }
  function _get_bufferEndIndex__d2rk18($this) {
    var tmp0 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other = $this.d1i_1;
    return tmp0.i3(toLong(other));
  }
  function _get_queueEndIndex__4m025l($this) {
    var tmp0 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other = $this.d1i_1;
    var tmp2 = tmp0.i3(toLong(other));
    // Inline function 'kotlin.Long.plus' call
    var other_0 = $this.e1i_1;
    return tmp2.i3(toLong(other_0));
  }
  function tryEmitLocked($this, value) {
    if ($this.g1i_1 === 0)
      return tryEmitNoCollectorsLocked($this, value);
    if ($this.d1i_1 >= $this.y1h_1 && $this.c1i_1.d1($this.b1i_1) <= 0) {
      switch ($this.z1h_1.a3_1) {
        case 0:
          return false;
        case 2:
          return true;
        case 1:
          break;
      }
    }
    enqueueLocked($this, value);
    $this.d1i_1 = $this.d1i_1 + 1 | 0;
    if ($this.d1i_1 > $this.y1h_1) {
      dropOldestLocked($this);
    }
    if (_get_replaySize__dxgnb1($this) > $this.x1h_1) {
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$0 = $this.b1i_1.i3(toLong(1));
      updateBufferLocked($this, tmp$ret$0, $this.c1i_1, _get_bufferEndIndex__d2rk18($this), _get_queueEndIndex__4m025l($this));
    }
    return true;
  }
  function tryEmitNoCollectorsLocked($this, value) {
    // Inline function 'kotlinx.coroutines.assert' call
    if ($this.x1h_1 === 0)
      return true;
    enqueueLocked($this, value);
    $this.d1i_1 = $this.d1i_1 + 1 | 0;
    if ($this.d1i_1 > $this.x1h_1) {
      dropOldestLocked($this);
    }
    var tmp = $this;
    var tmp0 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other = $this.d1i_1;
    tmp.c1i_1 = tmp0.i3(toLong(other));
    return true;
  }
  function dropOldestLocked($this) {
    setBufferAt(ensureNotNull($this.a1i_1), _get_head__d7jo8b($this), null);
    $this.d1i_1 = $this.d1i_1 - 1 | 0;
    // Inline function 'kotlin.Long.plus' call
    var newHead = _get_head__d7jo8b($this).i3(toLong(1));
    if ($this.b1i_1.d1(newHead) < 0)
      $this.b1i_1 = newHead;
    if ($this.c1i_1.d1(newHead) < 0) {
      correctCollectorIndexesOnDropOldest($this, newHead);
    }
    // Inline function 'kotlinx.coroutines.assert' call
  }
  function correctCollectorIndexesOnDropOldest($this, newHead) {
    $l$block: {
      // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked' call
      if ($this.g1i_1 === 0) {
        break $l$block;
      }
      var tmp0_safe_receiver = $this.f1i_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked.<anonymous>' call
          if (!(element == null)) {
            // Inline function 'kotlinx.coroutines.flow.SharedFlowImpl.correctCollectorIndexesOnDropOldest.<anonymous>' call
            if (element.j1i_1.d1(new Long(0, 0)) >= 0 && element.j1i_1.d1(newHead) < 0) {
              element.j1i_1 = newHead;
            }
          }
        }
      }
    }
    $this.c1i_1 = newHead;
  }
  function enqueueLocked($this, item) {
    var curSize = _get_totalSize__xhdb3o($this);
    var curBuffer = $this.a1i_1;
    var buffer = curBuffer == null ? growBuffer($this, null, 0, 2) : curSize >= curBuffer.length ? growBuffer($this, curBuffer, curSize, imul(curBuffer.length, 2)) : curBuffer;
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = _get_head__d7jo8b($this).i3(toLong(curSize));
    setBufferAt(buffer, tmp$ret$0, item);
  }
  function growBuffer($this, curBuffer, curSize, newSize) {
    // Inline function 'kotlin.check' call
    if (!(newSize > 0)) {
      // Inline function 'kotlinx.coroutines.flow.SharedFlowImpl.growBuffer.<anonymous>' call
      var message = 'Buffer size overflow';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.also' call
    var this_0 = fillArrayVal(Array(newSize), null);
    // Inline function 'kotlinx.coroutines.flow.SharedFlowImpl.growBuffer.<anonymous>' call
    $this.a1i_1 = this_0;
    var newBuffer = this_0;
    if (curBuffer == null)
      return newBuffer;
    var head = _get_head__d7jo8b($this);
    var inductionVariable = 0;
    if (inductionVariable < curSize)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.Long.plus' call
        var tmp = head.i3(toLong(i));
        // Inline function 'kotlin.Long.plus' call
        var tmp$ret$4 = head.i3(toLong(i));
        setBufferAt(newBuffer, tmp, getBufferAt(curBuffer, tmp$ret$4));
      }
       while (inductionVariable < curSize);
    return newBuffer;
  }
  function updateBufferLocked($this, newReplayIndex, newMinCollectorIndex, newBufferEndIndex, newQueueEndIndex) {
    // Inline function 'kotlin.comparisons.minOf' call
    var newHead = newMinCollectorIndex.d1(newReplayIndex) <= 0 ? newMinCollectorIndex : newReplayIndex;
    // Inline function 'kotlinx.coroutines.assert' call
    var inductionVariable = _get_head__d7jo8b($this);
    if (inductionVariable.d1(newHead) < 0)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable.i3(new Long(1, 0));
        setBufferAt(ensureNotNull($this.a1i_1), index, null);
      }
       while (inductionVariable.d1(newHead) < 0);
    $this.b1i_1 = newReplayIndex;
    $this.c1i_1 = newMinCollectorIndex;
    $this.d1i_1 = newBufferEndIndex.j3(newHead).z3();
    $this.e1i_1 = newQueueEndIndex.j3(newBufferEndIndex).z3();
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
  }
  function tryPeekLocked($this, slot) {
    var index = slot.j1i_1;
    if (index.d1(_get_bufferEndIndex__d2rk18($this)) < 0)
      return index;
    if ($this.y1h_1 > 0)
      return new Long(-1, -1);
    if (index.d1(_get_head__d7jo8b($this)) > 0)
      return new Long(-1, -1);
    if ($this.e1i_1 === 0)
      return new Long(-1, -1);
    return index;
  }
  function findSlotsToResumeLocked($this, resumesIn) {
    var resumes = resumesIn;
    var resumeCount = resumesIn.length;
    $l$block: {
      // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked' call
      if ($this.g1i_1 === 0) {
        break $l$block;
      }
      var tmp0_safe_receiver = $this.f1i_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked.<anonymous>' call
          if (!(element == null)) {
            $l$block_1: {
              // Inline function 'kotlinx.coroutines.flow.SharedFlowImpl.findSlotsToResumeLocked.<anonymous>' call
              var tmp0_elvis_lhs = element.k1i_1;
              var tmp;
              if (tmp0_elvis_lhs == null) {
                break $l$block_1;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var cont = tmp;
              if (tryPeekLocked($this, element).d1(new Long(0, 0)) < 0) {
                break $l$block_1;
              }
              if (resumeCount >= resumes.length) {
                var tmp_0 = resumes;
                // Inline function 'kotlin.comparisons.maxOf' call
                var b = imul(2, resumes.length);
                var tmp$ret$2 = Math.max(2, b);
                resumes = copyOf_8(tmp_0, tmp$ret$2);
              }
              var tmp_1 = resumes;
              var tmp1 = resumeCount;
              resumeCount = tmp1 + 1 | 0;
              tmp_1[tmp1] = cont;
              element.k1i_1 = null;
            }
          }
        }
      }
    }
    return resumes;
  }
  function getBufferAt(_this__u8e3s4, index) {
    _init_properties_SharedFlow_kt__umasnn();
    return _this__u8e3s4[index.z3() & (_this__u8e3s4.length - 1 | 0)];
  }
  function setBufferAt(_this__u8e3s4, index, item) {
    _init_properties_SharedFlow_kt__umasnn();
    return _this__u8e3s4[index.z3() & (_this__u8e3s4.length - 1 | 0)] = item;
  }
  var properties_initialized_SharedFlow_kt_tmefor;
  function _init_properties_SharedFlow_kt__umasnn() {
    if (!properties_initialized_SharedFlow_kt_tmefor) {
      properties_initialized_SharedFlow_kt_tmefor = true;
      NO_VALUE = new Symbol_0('NO_VALUE');
    }
  }
  function get_NONE() {
    _init_properties_StateFlow_kt__eu9yi5();
    return NONE;
  }
  var NONE;
  function get_PENDING() {
    _init_properties_StateFlow_kt__eu9yi5();
    return PENDING;
  }
  var PENDING;
  function MutableStateFlow(value) {
    _init_properties_StateFlow_kt__eu9yi5();
    return new StateFlowImpl(value == null ? get_NULL() : value);
  }
  function updateState($this, expectedState, newState) {
    var curSequence;
    var curSlots;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var oldState = $this.p1i_1.kotlinx$atomicfu$value;
    if (!(expectedState == null) && !equals(oldState, expectedState))
      return false;
    if (equals(oldState, newState))
      return true;
    $this.p1i_1.kotlinx$atomicfu$value = newState;
    curSequence = $this.q1i_1;
    if ((curSequence & 1) === 0) {
      curSequence = curSequence + 1 | 0;
      $this.q1i_1 = curSequence;
    } else {
      $this.q1i_1 = curSequence + 2 | 0;
      return true;
    }
    curSlots = $this.f1i_1;
    while (true) {
      var tmp0_safe_receiver = curSlots;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.coroutines.flow.StateFlowImpl.updateState.<anonymous>' call
          if (element == null)
            null;
          else {
            element.s1i();
          }
        }
      }
      // Inline function 'kotlinx.coroutines.internal.synchronized' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
      if ($this.q1i_1 === curSequence) {
        $this.q1i_1 = curSequence + 1 | 0;
        return true;
      }
      curSequence = $this.q1i_1;
      curSlots = $this.f1i_1;
    }
  }
  function $collectCOROUTINE$16(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.b1j_1 = _this__u8e3s4;
    this.c1j_1 = collector;
  }
  protoOf($collectCOROUTINE$16).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 12;
            this.d1j_1 = this.b1j_1.i1j();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 11;
            var tmp_0 = this.c1j_1;
            if (tmp_0 instanceof SubscribedFlowCollector) {
              this.y9_1 = 2;
              suspendResult = this.c1j_1.l1j(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            var tmp_1 = this;
            tmp_1.f1j_1 = this.ea().la(Key_instance_3);
            this.g1j_1 = null;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            if (!true) {
              this.y9_1 = 9;
              continue $sm;
            }

            this.h1j_1 = this.b1j_1.p1i_1.kotlinx$atomicfu$value;
            var tmp0_safe_receiver = this.f1j_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              ensureActive_0(tmp0_safe_receiver);
            }

            if (this.g1j_1 == null || !equals(this.g1j_1, this.h1j_1)) {
              this.y9_1 = 5;
              var tmp0 = get_NULL();
              var value = this.h1j_1;
              var tmp_2;
              if (value === tmp0) {
                tmp_2 = (null == null ? true : !(null == null)) ? null : THROW_CCE();
              } else {
                tmp_2 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
              }
              suspendResult = this.c1j_1.d1f(tmp_2, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 6;
              continue $sm;
            }

          case 5:
            this.g1j_1 = this.h1j_1;
            this.y9_1 = 6;
            continue $sm;
          case 6:
            if (!this.d1j_1.n1j()) {
              this.y9_1 = 7;
              suspendResult = this.d1j_1.m1j(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 8;
              continue $sm;
            }

          case 7:
            this.y9_1 = 8;
            continue $sm;
          case 8:
            this.y9_1 = 4;
            continue $sm;
          case 9:
            this.e1j_1 = Unit_instance;
            this.z9_1 = 12;
            this.y9_1 = 10;
            continue $sm;
          case 10:
            this.z9_1 = 12;
            this.b1j_1.o1j(this.d1j_1);
            return Unit_instance;
          case 11:
            this.z9_1 = 12;
            var t = this.ba_1;
            this.b1j_1.o1j(this.d1j_1);
            throw t;
          case 12:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 12) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function StateFlowImpl(initialState) {
    AbstractSharedFlow.call(this);
    this.p1i_1 = atomic$ref$1(initialState);
    this.q1i_1 = 0;
  }
  protoOf(StateFlowImpl).p1j = function (value) {
    updateState(this, null, value == null ? get_NULL() : value);
  };
  protoOf(StateFlowImpl).y = function () {
    var tmp0 = get_NULL();
    // Inline function 'kotlinx.coroutines.internal.Symbol.unbox' call
    var value = this.p1i_1.kotlinx$atomicfu$value;
    var tmp;
    if (value === tmp0) {
      tmp = (null == null ? true : !(null == null)) ? null : THROW_CCE();
    } else {
      tmp = (value == null ? true : !(value == null)) ? value : THROW_CCE();
    }
    return tmp;
  };
  protoOf(StateFlowImpl).d1f = function (value, $completion) {
    this.p1j(value);
    return Unit_instance;
  };
  protoOf(StateFlowImpl).q1j = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$16(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(StateFlowImpl).s1d = function (collector, $completion) {
    return this.q1j(collector, $completion);
  };
  protoOf(StateFlowImpl).r1j = function () {
    return new StateFlowSlot();
  };
  protoOf(StateFlowImpl).s1j = function (size) {
    // Inline function 'kotlin.arrayOfNulls' call
    return fillArrayVal(Array(size), null);
  };
  protoOf(StateFlowImpl).f1e = function (context, capacity, onBufferOverflow) {
    return fuseStateFlow(this, context, capacity, onBufferOverflow);
  };
  function StateFlowSlot() {
    AbstractSharedFlowSlot.call(this);
    this.r1i_1 = atomic$ref$1(null);
  }
  protoOf(StateFlowSlot).t1j = function (flow) {
    if (!(this.r1i_1.kotlinx$atomicfu$value == null))
      return false;
    this.r1i_1.kotlinx$atomicfu$value = get_NONE();
    return true;
  };
  protoOf(StateFlowSlot).u1j = function (flow) {
    return this.t1j(flow instanceof StateFlowImpl ? flow : THROW_CCE());
  };
  protoOf(StateFlowSlot).v1j = function (flow) {
    this.r1i_1.kotlinx$atomicfu$value = null;
    return get_EMPTY_RESUMES();
  };
  protoOf(StateFlowSlot).w1j = function (flow) {
    return this.v1j(flow instanceof StateFlowImpl ? flow : THROW_CCE());
  };
  protoOf(StateFlowSlot).s1i = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.r1i_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.flow.StateFlowSlot.makePending.<anonymous>' call
      var state = this_0.kotlinx$atomicfu$value;
      if (state == null)
        return Unit_instance;
      else if (state === get_PENDING())
        return Unit_instance;
      else if (state === get_NONE()) {
        if (this.r1i_1.atomicfu$compareAndSet(state, get_PENDING()))
          return Unit_instance;
      } else {
        if (this.r1i_1.atomicfu$compareAndSet(state, get_NONE())) {
          // Inline function 'kotlin.coroutines.resume' call
          var this_1 = state instanceof CancellableContinuationImpl ? state : THROW_CCE();
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
          this_1.ja(tmp$ret$0);
          return Unit_instance;
        }
      }
    }
  };
  protoOf(StateFlowSlot).n1j = function () {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.assert' call
    return ensureNotNull(this.r1i_1.atomicfu$getAndSet(get_NONE())) === get_PENDING();
  };
  protoOf(StateFlowSlot).m1j = function ($completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.iy();
    $l$block: {
      // Inline function 'kotlinx.coroutines.flow.StateFlowSlot.awaitPending.<anonymous>' call
      // Inline function 'kotlinx.coroutines.assert' call
      if (this.r1i_1.atomicfu$compareAndSet(get_NONE(), cancellable)) {
        break $l$block;
      }
      // Inline function 'kotlinx.coroutines.assert' call
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$1 = _Result___init__impl__xyqfz8(Unit_instance);
      cancellable.ja(tmp$ret$1);
    }
    return cancellable.py();
  };
  function fuseStateFlow(_this__u8e3s4, context, capacity, onBufferOverflow) {
    _init_properties_StateFlow_kt__eu9yi5();
    // Inline function 'kotlinx.coroutines.assert' call
    if (((0 <= capacity ? capacity <= 1 : false) || capacity === -2) && onBufferOverflow.equals(BufferOverflow_DROP_OLDEST_getInstance())) {
      return _this__u8e3s4;
    }
    return fuseSharedFlow(_this__u8e3s4, context, capacity, onBufferOverflow);
  }
  var properties_initialized_StateFlow_kt_nsqikx;
  function _init_properties_StateFlow_kt__eu9yi5() {
    if (!properties_initialized_StateFlow_kt_nsqikx) {
      properties_initialized_StateFlow_kt_nsqikx = true;
      NONE = new Symbol_0('NONE');
      PENDING = new Symbol_0('PENDING');
    }
  }
  function get_EMPTY_RESUMES() {
    _init_properties_AbstractSharedFlow_kt__h2xygb();
    return EMPTY_RESUMES;
  }
  var EMPTY_RESUMES;
  function AbstractSharedFlow() {
    this.f1i_1 = null;
    this.g1i_1 = 0;
    this.h1i_1 = 0;
    this.i1i_1 = null;
  }
  protoOf(AbstractSharedFlow).i1j = function () {
    var subscriptionCount;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.allocateSlot.<anonymous>' call
    var curSlots = this.f1i_1;
    var tmp;
    if (curSlots == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.s1j(2);
      // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.allocateSlot.<anonymous>.<anonymous>' call
      this.f1i_1 = this_0;
      tmp = this_0;
    } else {
      var tmp_0;
      if (this.g1i_1 >= curSlots.length) {
        // Inline function 'kotlin.also' call
        var this_1 = copyOf_8(curSlots, imul(2, curSlots.length));
        // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.allocateSlot.<anonymous>.<anonymous>' call
        this.f1i_1 = this_1;
        tmp_0 = this_1;
      } else {
        tmp_0 = curSlots;
      }
      tmp = tmp_0;
    }
    var slots = tmp;
    var index = this.h1i_1;
    var slot;
    $l$loop: while (true) {
      var tmp0_elvis_lhs = slots[index];
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.also' call
        var this_2 = this.r1j();
        // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.allocateSlot.<anonymous>.<anonymous>' call
        slots[index] = this_2;
        tmp_1 = this_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      slot = tmp_1;
      index = index + 1 | 0;
      if (index >= slots.length)
        index = 0;
      if ((slot instanceof AbstractSharedFlowSlot ? slot : THROW_CCE()).u1j(this))
        break $l$loop;
    }
    this.h1i_1 = index;
    this.g1i_1 = this.g1i_1 + 1 | 0;
    subscriptionCount = this.i1i_1;
    var slot_0 = slot;
    if (subscriptionCount == null)
      null;
    else
      subscriptionCount.j1k(1);
    return slot_0;
  };
  protoOf(AbstractSharedFlow).o1j = function (slot) {
    var subscriptionCount;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.freeSlot.<anonymous>' call
    this.g1i_1 = this.g1i_1 - 1 | 0;
    subscriptionCount = this.i1i_1;
    if (this.g1i_1 === 0)
      this.h1i_1 = 0;
    var resumes = (slot instanceof AbstractSharedFlowSlot ? slot : THROW_CCE()).w1j(this);
    var inductionVariable = 0;
    var last = resumes.length;
    while (inductionVariable < last) {
      var cont = resumes[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (cont == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
        cont.ja(tmp$ret$3);
      }
    }
    if (subscriptionCount == null)
      null;
    else
      subscriptionCount.j1k(-1);
  };
  function AbstractSharedFlowSlot() {
  }
  var properties_initialized_AbstractSharedFlow_kt_2mpafr;
  function _init_properties_AbstractSharedFlow_kt__h2xygb() {
    if (!properties_initialized_AbstractSharedFlow_kt_2mpafr) {
      properties_initialized_AbstractSharedFlow_kt_2mpafr = true;
      // Inline function 'kotlin.arrayOfNulls' call
      EMPTY_RESUMES = fillArrayVal(Array(0), null);
    }
  }
  function ChannelFlow$_get_collectToFun_$slambda_j53z2e(this$0, resultContinuation) {
    this.s1k_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlow$_get_collectToFun_$slambda_j53z2e).u1k = function (it, $completion) {
    var tmp = this.v1k(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ChannelFlow$_get_collectToFun_$slambda_j53z2e).oa = function (p1, $completion) {
    return this.u1k((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlow$_get_collectToFun_$slambda_j53z2e).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.s1k_1.y1d(this.t1k_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlow$_get_collectToFun_$slambda_j53z2e).v1k = function (it, completion) {
    var i = new ChannelFlow$_get_collectToFun_$slambda_j53z2e(this.s1k_1, completion);
    i.t1k_1 = it;
    return i;
  };
  function ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this$0, resultContinuation) {
    var i = new ChannelFlow$_get_collectToFun_$slambda_j53z2e(this$0, resultContinuation);
    var l = function (it, $completion) {
      return i.u1k(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ChannelFlow$collect$slambda($collector, this$0, resultContinuation) {
    this.e1l_1 = $collector;
    this.f1l_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlow$collect$slambda).h1l = function ($this$coroutineScope, $completion) {
    var tmp = this.i1l($this$coroutineScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ChannelFlow$collect$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlow$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = emitAll(this.e1l_1, this.f1l_1.h1e(this.g1l_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlow$collect$slambda).i1l = function ($this$coroutineScope, completion) {
    var i = new ChannelFlow$collect$slambda(this.e1l_1, this.f1l_1, completion);
    i.g1l_1 = $this$coroutineScope;
    return i;
  };
  function ChannelFlow$collect$slambda_0($collector, this$0, resultContinuation) {
    var i = new ChannelFlow$collect$slambda($collector, this$0, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.h1l($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ChannelFlow(context, capacity, onBufferOverflow) {
    this.z1d_1 = context;
    this.a1e_1 = capacity;
    this.b1e_1 = onBufferOverflow;
    // Inline function 'kotlinx.coroutines.assert' call
  }
  protoOf(ChannelFlow).c1e = function () {
    return ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this, null);
  };
  protoOf(ChannelFlow).d1e = function () {
    return this.a1e_1 === -3 ? -2 : this.a1e_1;
  };
  protoOf(ChannelFlow).e1e = function () {
    return null;
  };
  protoOf(ChannelFlow).f1e = function (context, capacity, onBufferOverflow) {
    // Inline function 'kotlinx.coroutines.assert' call
    var newContext = context.ej(this.z1d_1);
    var newCapacity;
    var newOverflow;
    if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
      newCapacity = capacity;
      newOverflow = onBufferOverflow;
    } else {
      var tmp;
      if (this.a1e_1 === -3) {
        tmp = capacity;
      } else if (capacity === -3) {
        tmp = this.a1e_1;
      } else if (this.a1e_1 === -2) {
        tmp = capacity;
      } else if (capacity === -2) {
        tmp = this.a1e_1;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        // Inline function 'kotlinx.coroutines.assert' call
        var sum = this.a1e_1 + capacity | 0;
        tmp = sum >= 0 ? sum : 2147483647;
      }
      newCapacity = tmp;
      newOverflow = this.b1e_1;
    }
    if (equals(newContext, this.z1d_1) && newCapacity === this.a1e_1 && newOverflow.equals(this.b1e_1))
      return this;
    return this.x1d(newContext, newCapacity, newOverflow);
  };
  protoOf(ChannelFlow).h1e = function (scope) {
    return produce(scope, this.z1d_1, this.d1e(), this.b1e_1, CoroutineStart_ATOMIC_getInstance(), VOID, this.c1e());
  };
  protoOf(ChannelFlow).s1d = function (collector, $completion) {
    return coroutineScope(ChannelFlow$collect$slambda_0(collector, this, null), $completion);
  };
  protoOf(ChannelFlow).i1e = function () {
    return null;
  };
  protoOf(ChannelFlow).toString = function () {
    var props = ArrayList_init_$Create$_0(4);
    var tmp0_safe_receiver = this.i1e();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.flow.internal.ChannelFlow.toString.<anonymous>' call
      props.e(tmp0_safe_receiver);
    }
    if (!(this.z1d_1 === EmptyCoroutineContext_getInstance())) {
      props.e('context=' + toString_1(this.z1d_1));
    }
    if (!(this.a1e_1 === -3)) {
      props.e('capacity=' + this.a1e_1);
    }
    if (!this.b1e_1.equals(BufferOverflow_SUSPEND_getInstance())) {
      props.e('onBufferOverflow=' + this.b1e_1.toString());
    }
    return get_classSimpleName(this) + '[' + joinToString_0(props, ', ') + ']';
  };
  function FusibleFlow() {
  }
  function ChannelFlowOperatorImpl(flow, context, capacity, onBufferOverflow) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? -3 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    ChannelFlowOperator.call(this, flow, context, capacity, onBufferOverflow);
  }
  protoOf(ChannelFlowOperatorImpl).x1d = function (context, capacity, onBufferOverflow) {
    return new ChannelFlowOperatorImpl(this.q1l_1, context, capacity, onBufferOverflow);
  };
  protoOf(ChannelFlowOperatorImpl).e1e = function () {
    return this.q1l_1;
  };
  protoOf(ChannelFlowOperatorImpl).r1l = function (collector, $completion) {
    return this.q1l_1.s1d(collector, $completion);
  };
  function collectWithContextUndispatched($this, collector, newContext, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.ea();
    var originalContextCollector = withUndispatchedContextCollector(collector, tmp$ret$0);
    return withContextUndispatched(newContext, originalContextCollector, VOID, ChannelFlowOperator$collectWithContextUndispatched$slambda_0($this, null), $completion);
  }
  function ChannelFlowOperator$collectWithContextUndispatched$slambda(this$0, resultContinuation) {
    this.a1m_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlowOperator$collectWithContextUndispatched$slambda).c1m = function (it, $completion) {
    var tmp = this.d1m(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ChannelFlowOperator$collectWithContextUndispatched$slambda).oa = function (p1, $completion) {
    return this.c1m((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlowOperator$collectWithContextUndispatched$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.a1m_1.r1l(this.b1m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlowOperator$collectWithContextUndispatched$slambda).d1m = function (it, completion) {
    var i = new ChannelFlowOperator$collectWithContextUndispatched$slambda(this.a1m_1, completion);
    i.b1m_1 = it;
    return i;
  };
  function ChannelFlowOperator$collectWithContextUndispatched$slambda_0(this$0, resultContinuation) {
    var i = new ChannelFlowOperator$collectWithContextUndispatched$slambda(this$0, resultContinuation);
    var l = function (it, $completion) {
      return i.c1m(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$17(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m1m_1 = _this__u8e3s4;
    this.n1m_1 = collector;
  }
  protoOf($collectCOROUTINE$17).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            if (this.m1m_1.a1e_1 === -3) {
              var tmp_0 = this;
              tmp_0.o1m_1 = this.ea();
              this.p1m_1 = this.o1m_1.ej(this.m1m_1.z1d_1);
              if (equals(this.p1m_1, this.o1m_1)) {
                this.y9_1 = 6;
                suspendResult = this.m1m_1.r1l(this.n1m_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.y9_1 = 1;
                continue $sm;
              }
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 1:
            if (equals(this.p1m_1.la(Key_instance), this.o1m_1.la(Key_instance))) {
              this.y9_1 = 5;
              suspendResult = collectWithContextUndispatched(this.m1m_1, this.n1m_1, this.p1m_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.y9_1 = 4;
            suspendResult = protoOf(ChannelFlow).s1d.call(this.m1m_1, this.n1m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            return Unit_instance;
          case 6:
            return Unit_instance;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ChannelFlowOperator(flow, context, capacity, onBufferOverflow) {
    ChannelFlow.call(this, context, capacity, onBufferOverflow);
    this.q1l_1 = flow;
  }
  protoOf(ChannelFlowOperator).y1d = function (scope, $completion) {
    return this.r1l(new SendingCollector(scope), $completion);
  };
  protoOf(ChannelFlowOperator).s1d = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$17(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ChannelFlowOperator).toString = function () {
    return toString_1(this.q1l_1) + ' -> ' + protoOf(ChannelFlow).toString.call(this);
  };
  function withUndispatchedContextCollector(_this__u8e3s4, emitContext) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof SendingCollector) {
      tmp_0 = true;
    } else {
      tmp_0 = _this__u8e3s4 instanceof NopCollector;
    }
    if (tmp_0) {
      tmp = _this__u8e3s4;
    } else {
      tmp = new UndispatchedContextCollector(_this__u8e3s4, emitContext);
    }
    return tmp;
  }
  function withContextUndispatched(newContext, value, countOrElement, block, $completion) {
    countOrElement = countOrElement === VOID ? threadContextElements(newContext) : countOrElement;
    // Inline function 'kotlinx.coroutines.flow.internal.withContextUndispatched.<anonymous>' call
    // Inline function 'kotlinx.coroutines.withCoroutineContext' call
    // Inline function 'kotlinx.coroutines.flow.internal.withContextUndispatched.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
    var completion = new StackFrameContinuation($completion, newContext);
    return startCoroutineUninterceptedOrReturnNonGeneratorVersion(block, value, completion);
  }
  function UndispatchedContextCollector$emitRef$slambda($downstream, resultContinuation) {
    this.y1m_1 = $downstream;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(UndispatchedContextCollector$emitRef$slambda).a1n = function (it, $completion) {
    var tmp = this.b1n(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(UndispatchedContextCollector$emitRef$slambda).oa = function (p1, $completion) {
    return this.a1n((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(UndispatchedContextCollector$emitRef$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.y1m_1.d1f(this.z1m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(UndispatchedContextCollector$emitRef$slambda).b1n = function (it, completion) {
    var i = new UndispatchedContextCollector$emitRef$slambda(this.y1m_1, completion);
    i.z1m_1 = it;
    return i;
  };
  function UndispatchedContextCollector$emitRef$slambda_0($downstream, resultContinuation) {
    var i = new UndispatchedContextCollector$emitRef$slambda($downstream, resultContinuation);
    var l = function (it, $completion) {
      return i.a1n(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function UndispatchedContextCollector(downstream, emitContext) {
    this.c1n_1 = emitContext;
    this.d1n_1 = threadContextElements(this.c1n_1);
    var tmp = this;
    tmp.e1n_1 = UndispatchedContextCollector$emitRef$slambda_0(downstream, null);
  }
  protoOf(UndispatchedContextCollector).d1f = function (value, $completion) {
    return withContextUndispatched(this.c1n_1, value, this.d1n_1, this.e1n_1, $completion);
  };
  function StackFrameContinuation(uCont, context) {
    this.f1n_1 = uCont;
    this.g1n_1 = context;
  }
  protoOf(StackFrameContinuation).ea = function () {
    return this.g1n_1;
  };
  protoOf(StackFrameContinuation).ja = function (result) {
    this.f1n_1.ja(result);
  };
  function checkOwnership(_this__u8e3s4, owner) {
    if (!(_this__u8e3s4.h1n_1 === owner))
      throw _this__u8e3s4;
  }
  function ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda(this$0, $collector, $value, resultContinuation) {
    this.q1n_1 = this$0;
    this.r1n_1 = $collector;
    this.s1n_1 = $value;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.q1n_1.y1n_1(this.r1n_1, this.s1n_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda).i1l = function ($this$launch, completion) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda(this.q1n_1, this.r1n_1, this.s1n_1, completion);
    i.t1n_1 = $this$launch;
    return i;
  };
  function ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda_0(this$0, $collector, $value, resultContinuation) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda(this$0, $collector, $value, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ChannelFlowTransformLatest$flowCollect$slambda$slambda($previousFlow, $this_coroutineScope, this$0, $collector, resultContinuation) {
    this.h1o_1 = $previousFlow;
    this.i1o_1 = $this_coroutineScope;
    this.j1o_1 = this$0;
    this.k1o_1 = $collector;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda).a1n = function (value, $completion) {
    var tmp = this.b1n(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda).oa = function (p1, $completion) {
    return this.a1n((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.m1o_1 = this.h1o_1._v;
            if (this.m1o_1 == null) {
              this.n1o_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              var tmp_0 = this;
              tmp_0.o1o_1 = this.m1o_1;
              this.p1o_1 = this.o1o_1;
              var tmp_1 = this;
              tmp_1.q1o_1 = this.p1o_1;
              this.r1o_1 = this.q1o_1;
              this.r1o_1.ou(new ChildCancelledException());
              this.y9_1 = 1;
              suspendResult = this.r1o_1.ku(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.n1o_1 = this.p1o_1;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            var tmp_2 = CoroutineStart_UNDISPATCHED_getInstance();
            this.h1o_1._v = launch(this.i1o_1, VOID, tmp_2, ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda_0(this.j1o_1, this.k1o_1, this.l1o_1, null));
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda).b1n = function (value, completion) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda$slambda(this.h1o_1, this.i1o_1, this.j1o_1, this.k1o_1, completion);
    i.l1o_1 = value;
    return i;
  };
  function ChannelFlowTransformLatest$flowCollect$slambda$slambda_0($previousFlow, $this_coroutineScope, this$0, $collector, resultContinuation) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda$slambda($previousFlow, $this_coroutineScope, this$0, $collector, resultContinuation);
    var l = function (value, $completion) {
      return i.a1n(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.s1o_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).d1f = function (value, $completion) {
    return this.s1o_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).b4 = function () {
    return this.s1o_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function ChannelFlowTransformLatest$flowCollect$slambda(this$0, $collector, resultContinuation) {
    this.b1p_1 = this$0;
    this.c1p_1 = $collector;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda).h1l = function ($this$coroutineScope, $completion) {
    var tmp = this.i1l($this$coroutineScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.e1p_1 = {_v: null};
            this.y9_1 = 1;
            var tmp_0 = ChannelFlowTransformLatest$flowCollect$slambda$slambda_0(this.e1p_1, this.d1p_1, this.b1p_1, this.c1p_1, null);
            suspendResult = this.b1p_1.q1l_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda).i1l = function ($this$coroutineScope, completion) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda(this.b1p_1, this.c1p_1, completion);
    i.d1p_1 = $this$coroutineScope;
    return i;
  };
  function ChannelFlowTransformLatest$flowCollect$slambda_0(this$0, $collector, resultContinuation) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda(this$0, $collector, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.h1l($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ChannelFlowTransformLatest(transform, flow, context, capacity, onBufferOverflow) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? -2 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    ChannelFlowOperator.call(this, flow, context, capacity, onBufferOverflow);
    this.y1n_1 = transform;
  }
  protoOf(ChannelFlowTransformLatest).x1d = function (context, capacity, onBufferOverflow) {
    return new ChannelFlowTransformLatest(this.y1n_1, this.q1l_1, context, capacity, onBufferOverflow);
  };
  protoOf(ChannelFlowTransformLatest).f1p = function (collector, $completion) {
    // Inline function 'kotlinx.coroutines.assert' call
    return coroutineScope(ChannelFlowTransformLatest$flowCollect$slambda_0(this, collector, null), $completion);
  };
  protoOf(ChannelFlowTransformLatest).r1l = function (collector, $completion) {
    return this.f1p(collector, $completion);
  };
  function NopCollector() {
  }
  protoOf(NopCollector).g1p = function (value, $completion) {
    return Unit_instance;
  };
  protoOf(NopCollector).d1f = function (value, $completion) {
    return this.g1p((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  var NopCollector_instance;
  function NopCollector_getInstance() {
    return NopCollector_instance;
  }
  function get_NULL() {
    _init_properties_NullSurrogate_kt__n2yti9();
    return NULL;
  }
  var NULL;
  var UNINITIALIZED;
  var DONE;
  var properties_initialized_NullSurrogate_kt_39v8bl;
  function _init_properties_NullSurrogate_kt__n2yti9() {
    if (!properties_initialized_NullSurrogate_kt_39v8bl) {
      properties_initialized_NullSurrogate_kt_39v8bl = true;
      NULL = new Symbol_0('NULL');
      UNINITIALIZED = new Symbol_0('UNINITIALIZED');
      DONE = new Symbol_0('DONE');
    }
  }
  function checkContext(_this__u8e3s4, currentContext) {
    var result = currentContext.dj(0, checkContext$lambda(_this__u8e3s4));
    if (!(result === _this__u8e3s4.r1h_1)) {
      // Inline function 'kotlin.error' call
      var message = 'Flow invariant is violated:\n' + ('\t\tFlow was collected in ' + toString_1(_this__u8e3s4.q1h_1) + ',\n') + ('\t\tbut emission happened in ' + toString_1(currentContext) + '.\n') + "\t\tPlease refer to 'flow' documentation or use 'flowOn' instead";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function transitiveCoroutineParent(_this__u8e3s4, collectJob) {
    var $this = _this__u8e3s4;
    var collectJob_0 = collectJob;
    $l$1: do {
      $l$0: do {
        if ($this === null)
          return null;
        if ($this === collectJob_0)
          return $this;
        if (!($this instanceof ScopeCoroutine))
          return $this;
        var tmp0 = $this.yt();
        var tmp1 = collectJob_0;
        $this = tmp0;
        collectJob_0 = tmp1;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function checkContext$lambda($this_checkContext) {
    return function (count, element) {
      var key = element.x();
      var collectElement = $this_checkContext.q1h_1.la(key);
      var tmp;
      if (!(key === Key_instance_3)) {
        return !(element === collectElement) ? -2147483648 : count + 1 | 0;
      }
      var collectJob = (collectElement == null ? true : isInterface(collectElement, Job)) ? collectElement : THROW_CCE();
      var emissionParentJob = transitiveCoroutineParent(isInterface(element, Job) ? element : THROW_CCE(), collectJob);
      var tmp_0;
      if (!(emissionParentJob === collectJob)) {
        var message = 'Flow invariant is violated:\n\t\tEmission from another coroutine is detected.\n' + ('\t\tChild of ' + toString_0(emissionParentJob) + ', expected child of ' + toString_0(collectJob) + '.\n') + '\t\tFlowCollector is not thread-safe and concurrent emissions are prohibited.\n' + "\t\tTo mitigate this restriction please use 'channelFlow' builder instead of 'flow'";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      return collectJob == null ? count : count + 1 | 0;
    };
  }
  function SendingCollector(channel) {
    this.h1p_1 = channel;
  }
  protoOf(SendingCollector).d1f = function (value, $completion) {
    return this.h1p_1.z1b(value, $completion);
  };
  function CancellableFlow() {
  }
  function buffer(_this__u8e3s4, capacity, onBufferOverflow) {
    capacity = capacity === VOID ? -2 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    // Inline function 'kotlin.require' call
    if (!(capacity >= 0 || capacity === -2 || capacity === -1)) {
      // Inline function 'kotlinx.coroutines.flow.buffer.<anonymous>' call
      var message = 'Buffer size should be non-negative, BUFFERED, or CONFLATED, but was ' + capacity;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(!(capacity === -1) || onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()))) {
      // Inline function 'kotlinx.coroutines.flow.buffer.<anonymous>' call
      var message_0 = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var capacity_0 = capacity;
    var onBufferOverflow_0 = onBufferOverflow;
    if (capacity_0 === -1) {
      capacity_0 = 0;
      onBufferOverflow_0 = BufferOverflow_DROP_OLDEST_getInstance();
    }
    var tmp;
    if (isInterface(_this__u8e3s4, FusibleFlow)) {
      tmp = _this__u8e3s4.g1e(VOID, capacity_0, onBufferOverflow_0);
    } else {
      tmp = new ChannelFlowOperatorImpl(_this__u8e3s4, VOID, capacity_0, onBufferOverflow_0);
    }
    return tmp;
  }
  function cancellable(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, CancellableFlow)) {
      tmp = _this__u8e3s4;
    } else {
      tmp = new CancellableFlowImpl(_this__u8e3s4);
    }
    return tmp;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_0(function_0) {
    this.i1p_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).d1f = function (value, $completion) {
    return this.i1p_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).b4 = function () {
    return this.i1p_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).hashCode = function () {
    return hashCode(this.b4());
  };
  function CancellableFlowImpl$collect$slambda($collector, resultContinuation) {
    this.r1p_1 = $collector;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CancellableFlowImpl$collect$slambda).a1n = function (it, $completion) {
    var tmp = this.b1n(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CancellableFlowImpl$collect$slambda).oa = function (p1, $completion) {
    return this.a1n((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CancellableFlowImpl$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            ensureActive(this.ea());
            this.y9_1 = 1;
            suspendResult = this.r1p_1.d1f(this.s1p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(CancellableFlowImpl$collect$slambda).b1n = function (it, completion) {
    var i = new CancellableFlowImpl$collect$slambda(this.r1p_1, completion);
    i.s1p_1 = it;
    return i;
  };
  function CancellableFlowImpl$collect$slambda_0($collector, resultContinuation) {
    var i = new CancellableFlowImpl$collect$slambda($collector, resultContinuation);
    var l = function (it, $completion) {
      return i.a1n(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CancellableFlowImpl(flow) {
    this.t1p_1 = flow;
  }
  protoOf(CancellableFlowImpl).s1d = function (collector, $completion) {
    var tmp = CancellableFlowImpl$collect$slambda_0(collector, null);
    return this.t1p_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp), $completion);
  };
  function ensureActive_1(_this__u8e3s4) {
    if (_this__u8e3s4 instanceof ThrowingCollector)
      throw _this__u8e3s4.u1p_1;
  }
  function ThrowingCollector(e) {
    this.u1p_1 = e;
  }
  protoOf(ThrowingCollector).g1p = function (value, $completion) {
    throw this.u1p_1;
  };
  protoOf(ThrowingCollector).d1f = function (value, $completion) {
    return this.g1p((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  function onCompletion(_this__u8e3s4, action) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new onCompletion$$inlined$unsafeFlow$1(_this__u8e3s4, action);
  }
  function invokeSafely(_this__u8e3s4, action, cause, $completion) {
    var tmp = new $invokeSafelyCOROUTINE$18(_this__u8e3s4, action, cause, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function $collectCOROUTINE$20(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o1q_1 = _this__u8e3s4;
    this.p1q_1 = collector;
  }
  protoOf($collectCOROUTINE$20).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 9;
            var tmp_0 = this;
            tmp_0.q1q_1 = this.p1q_1;
            this.r1q_1 = this.q1q_1;
            this.z9_1 = 7;
            this.y9_1 = 1;
            suspendResult = this.o1q_1.w1q_1.s1d(this.r1q_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z9_1 = 9;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.z9_1 = 9;
            var tmp_1 = this;
            tmp_1.s1q_1 = new SafeCollector(this.r1q_1, this.ea());
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 6;
            this.y9_1 = 4;
            suspendResult = this.o1q_1.x1q_1(this.s1q_1, null, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.t1q_1 = suspendResult;
            this.z9_1 = 9;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.z9_1 = 9;
            this.s1q_1.ia();
            return Unit_instance;
          case 6:
            this.z9_1 = 9;
            this.u1q_1 = this.ba_1;
            this.s1q_1.ia();
            throw this.u1q_1;
          case 7:
            this.z9_1 = 9;
            var tmp_2 = this.ba_1;
            if (tmp_2 instanceof Error) {
              this.v1q_1 = this.ba_1;
              this.y9_1 = 8;
              suspendResult = invokeSafely(new ThrowingCollector(this.v1q_1), this.o1q_1.x1q_1, this.v1q_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 8:
            throw this.v1q_1;
          case 9:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 9) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function onCompletion$$inlined$unsafeFlow$1($this_onCompletion, $action) {
    this.w1q_1 = $this_onCompletion;
    this.x1q_1 = $action;
  }
  protoOf(onCompletion$$inlined$unsafeFlow$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$20(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(onCompletion$$inlined$unsafeFlow$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function $invokeSafelyCOROUTINE$18(_this__u8e3s4, action, cause, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d1q_1 = _this__u8e3s4;
    this.e1q_1 = action;
    this.f1q_1 = cause;
  }
  protoOf($invokeSafelyCOROUTINE$18).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.e1q_1(this.d1q_1, this.f1q_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z9_1 = 3;
            this.y9_1 = 4;
            continue $sm;
          case 2:
            this.z9_1 = 3;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof Error) {
              var e = this.ba_1;
              if (!(this.f1q_1 === null) && !(this.f1q_1 === e)) {
                this.f1q_1;
              }
              throw e;
            } else {
              throw this.ba_1;
            }

          case 3:
            throw this.ba_1;
          case 4:
            this.z9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 3) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  function takeWhile(_this__u8e3s4, predicate) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new takeWhile$$inlined$unsafeFlow$1(_this__u8e3s4, predicate);
  }
  function transformWhile(_this__u8e3s4, transform) {
    return flow(transformWhile$slambda_0(_this__u8e3s4, transform, null));
  }
  function $emitCOROUTINE$24(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g1r_1 = _this__u8e3s4;
    this.h1r_1 = value;
  }
  protoOf($emitCOROUTINE$24).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            var tmp_0 = this;
            tmp_0.i1r_1 = this.h1r_1;
            this.j1r_1 = this.i1r_1;
            this.y9_1 = 1;
            suspendResult = this.g1r_1.l1r_1(this.j1r_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              this.y9_1 = 2;
              suspendResult = this.g1r_1.m1r_1.d1f(this.j1r_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.k1r_1 = false;
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            this.k1r_1 = true;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            var ARGUMENT = this.k1r_1;
            if (!ARGUMENT) {
              throw new AbortFlowException(this.g1r_1);
            } else {
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            return Unit_instance;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function takeWhile$$inlined$unsafeFlow$1$collect$2($predicate, $$this$unsafeFlow) {
    this.l1r_1 = $predicate;
    this.m1r_1 = $$this$unsafeFlow;
  }
  protoOf(takeWhile$$inlined$unsafeFlow$1$collect$2).g1p = function (value, $completion) {
    var tmp = new $emitCOROUTINE$24(this, value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(takeWhile$$inlined$unsafeFlow$1$collect$2).d1f = function (value, $completion) {
    return this.g1p((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  function $collectCOROUTINE$23(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v1r_1 = _this__u8e3s4;
    this.w1r_1 = collector;
  }
  protoOf($collectCOROUTINE$23).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.x1r_1 = this.w1r_1;
            this.y1r_1 = this.x1r_1;
            var tmp_1 = this;
            tmp_1.z1r_1 = this.v1r_1.c1s_1;
            this.a1s_1 = this.z1r_1;
            var tmp_2 = this;
            tmp_2.b1s_1 = new takeWhile$$inlined$unsafeFlow$1$collect$2(this.v1r_1.d1s_1, this.y1r_1);
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.a1s_1.s1d(this.b1s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z9_1 = 3;
            this.y9_1 = 4;
            continue $sm;
          case 2:
            this.z9_1 = 3;
            var tmp_3 = this.ba_1;
            if (tmp_3 instanceof AbortFlowException) {
              var e = this.ba_1;
              checkOwnership(e, this.b1s_1);
              this.y9_1 = 4;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 3:
            throw this.ba_1;
          case 4:
            this.z9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 3) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  function takeWhile$$inlined$unsafeFlow$1($this_takeWhile, $predicate) {
    this.c1s_1 = $this_takeWhile;
    this.d1s_1 = $predicate;
  }
  protoOf(takeWhile$$inlined$unsafeFlow$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$23(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(takeWhile$$inlined$unsafeFlow$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function $emitCOROUTINE$25(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m1s_1 = _this__u8e3s4;
    this.n1s_1 = value;
  }
  protoOf($emitCOROUTINE$25).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.o1s_1 = this.n1s_1;
            this.p1s_1 = this.o1s_1;
            this.y9_1 = 1;
            suspendResult = this.m1s_1.q1s_1(this.m1s_1.r1s_1, this.p1s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            if (!ARGUMENT) {
              throw new AbortFlowException(this.m1s_1);
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function transformWhile$1$$inlined$collectWhile$1($transform, $this_flow) {
    this.q1s_1 = $transform;
    this.r1s_1 = $this_flow;
  }
  protoOf(transformWhile$1$$inlined$collectWhile$1).g1p = function (value, $completion) {
    var tmp = new $emitCOROUTINE$25(this, value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(transformWhile$1$$inlined$collectWhile$1).d1f = function (value, $completion) {
    return this.g1p((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  function transformWhile$slambda($this_transformWhile, $transform, resultContinuation) {
    this.a1t_1 = $this_transformWhile;
    this.b1t_1 = $transform;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(transformWhile$slambda).g1t = function ($this$flow, $completion) {
    var tmp = this.h1t($this$flow, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(transformWhile$slambda).oa = function (p1, $completion) {
    return this.g1t((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(transformWhile$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.d1t_1 = this.a1t_1;
            this.e1t_1 = this.d1t_1;
            var tmp_1 = this;
            tmp_1.f1t_1 = new transformWhile$1$$inlined$collectWhile$1(this.b1t_1, this.c1t_1);
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.e1t_1.s1d(this.f1t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z9_1 = 3;
            this.y9_1 = 4;
            continue $sm;
          case 2:
            this.z9_1 = 3;
            var tmp_2 = this.ba_1;
            if (tmp_2 instanceof AbortFlowException) {
              var e = this.ba_1;
              checkOwnership(e, this.f1t_1);
              this.y9_1 = 4;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 3:
            throw this.ba_1;
          case 4:
            this.z9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 3) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(transformWhile$slambda).h1t = function ($this$flow, completion) {
    var i = new transformWhile$slambda(this.a1t_1, this.b1t_1, completion);
    i.c1t_1 = $this$flow;
    return i;
  };
  function transformWhile$slambda_0($this_transformWhile, $transform, resultContinuation) {
    var i = new transformWhile$slambda($this_transformWhile, $transform, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.g1t($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var DEFAULT_CONCURRENCY;
  function flatMapConcat(_this__u8e3s4, transform) {
    _init_properties_Merge_kt__cbpr96();
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    var tmp$ret$2 = new flatMapConcat$$inlined$map$1(_this__u8e3s4, transform);
    return flattenConcat(tmp$ret$2);
  }
  function flattenConcat(_this__u8e3s4) {
    _init_properties_Merge_kt__cbpr96();
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new flattenConcat$$inlined$unsafeFlow$1(_this__u8e3s4);
  }
  function mapLatest(_this__u8e3s4, transform) {
    _init_properties_Merge_kt__cbpr96();
    return transformLatest(_this__u8e3s4, mapLatest$slambda_0(transform, null));
  }
  function transformLatest(_this__u8e3s4, transform) {
    _init_properties_Merge_kt__cbpr96();
    return new ChannelFlowTransformLatest(transform, _this__u8e3s4);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_1(function_0) {
    this.i1t_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).d1f = function (value, $completion) {
    return this.i1t_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).b4 = function () {
    return this.i1t_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).hashCode = function () {
    return hashCode(this.b4());
  };
  function flatMapConcat$o$collect$slambda($$this$unsafeFlow, $transform, resultContinuation) {
    this.r1t_1 = $$this$unsafeFlow;
    this.s1t_1 = $transform;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flatMapConcat$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flatMapConcat$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flatMapConcat$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.u1t_1 = this.r1t_1;
            var tmp_1 = this;
            tmp_1.v1t_1 = this.t1t_1;
            this.w1t_1 = this.u1t_1;
            this.x1t_1 = this.v1t_1;
            this.y9_1 = 1;
            suspendResult = this.s1t_1(this.x1t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y1t_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.w1t_1.d1f(this.y1t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(flatMapConcat$o$collect$slambda).a1u = function (value, completion) {
    var i = new flatMapConcat$o$collect$slambda(this.r1t_1, this.s1t_1, completion);
    i.t1t_1 = value;
    return i;
  };
  function flatMapConcat$o$collect$slambda_0($$this$unsafeFlow, $transform, resultContinuation) {
    var i = new flatMapConcat$o$collect$slambda($$this$unsafeFlow, $transform, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$26(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j1u_1 = _this__u8e3s4;
    this.k1u_1 = collector;
  }
  protoOf($collectCOROUTINE$26).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.l1u_1 = this.k1u_1;
            this.m1u_1 = this.l1u_1;
            this.y9_1 = 1;
            var tmp_1 = flatMapConcat$o$collect$slambda_0(this.m1u_1, this.j1u_1.o1u_1, null);
            suspendResult = this.j1u_1.n1u_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_1(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function flatMapConcat$$inlined$map$1($this, $transform) {
    this.n1u_1 = $this;
    this.o1u_1 = $transform;
  }
  protoOf(flatMapConcat$$inlined$map$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$26(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flatMapConcat$$inlined$map$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_2(function_0) {
    this.p1u_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).d1f = function (value, $completion) {
    return this.p1u_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).b4 = function () {
    return this.p1u_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).hashCode = function () {
    return hashCode(this.b4());
  };
  function flattenConcat$o$collect$slambda($$this$unsafeFlow, resultContinuation) {
    this.y1u_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flattenConcat$o$collect$slambda).a1v = function (value, $completion) {
    var tmp = this.b1v(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flattenConcat$o$collect$slambda).oa = function (p1, $completion) {
    return this.a1v((!(p1 == null) ? isInterface(p1, Flow) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flattenConcat$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = emitAll_0(this.y1u_1, this.z1u_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(flattenConcat$o$collect$slambda).b1v = function (value, completion) {
    var i = new flattenConcat$o$collect$slambda(this.y1u_1, completion);
    i.z1u_1 = value;
    return i;
  };
  function flattenConcat$o$collect$slambda_0($$this$unsafeFlow, resultContinuation) {
    var i = new flattenConcat$o$collect$slambda($$this$unsafeFlow, resultContinuation);
    var l = function (value, $completion) {
      return i.a1v(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$27(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k1v_1 = _this__u8e3s4;
    this.l1v_1 = collector;
  }
  protoOf($collectCOROUTINE$27).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.m1v_1 = this.l1v_1;
            this.n1v_1 = this.m1v_1;
            this.y9_1 = 1;
            var tmp_1 = flattenConcat$o$collect$slambda_0(this.n1v_1, null);
            suspendResult = this.k1v_1.o1v_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_2(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function flattenConcat$$inlined$unsafeFlow$1($this_flattenConcat) {
    this.o1v_1 = $this_flattenConcat;
  }
  protoOf(flattenConcat$$inlined$unsafeFlow$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$27(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flattenConcat$$inlined$unsafeFlow$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function mapLatest$slambda($transform, resultContinuation) {
    this.x1v_1 = $transform;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(mapLatest$slambda).b1w = function ($this$transformLatest, it, $completion) {
    var tmp = this.c1w($this$transformLatest, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(mapLatest$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE();
    return this.b1w(tmp, (p2 == null ? true : !(p2 == null)) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(mapLatest$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.x1v_1(this.z1v_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.a1w_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.y1v_1.d1f(this.a1w_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(mapLatest$slambda).c1w = function ($this$transformLatest, it, completion) {
    var i = new mapLatest$slambda(this.x1v_1, completion);
    i.y1v_1 = $this$transformLatest;
    i.z1v_1 = it;
    return i;
  };
  function mapLatest$slambda_0($transform, resultContinuation) {
    var i = new mapLatest$slambda($transform, resultContinuation);
    var l = function ($this$transformLatest, it, $completion) {
      return i.b1w($this$transformLatest, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  var properties_initialized_Merge_kt_dhn6vs;
  function _init_properties_Merge_kt__cbpr96() {
    if (!properties_initialized_Merge_kt_dhn6vs) {
      properties_initialized_Merge_kt_dhn6vs = true;
      DEFAULT_CONCURRENCY = systemProp('kotlinx.coroutines.flow.defaultConcurrency', 16, 1, 2147483647);
    }
  }
  function stateIn(_this__u8e3s4, scope, $completion) {
    var config = configureSharing(_this__u8e3s4, 1);
    var result = CompletableDeferred();
    launchSharingDeferred(scope, config.g1w_1, config.d1w_1, result);
    return result.gw($completion);
  }
  function $onSubscriptionCOROUTINE$28(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.p1w_1 = _this__u8e3s4;
  }
  protoOf($onSubscriptionCOROUTINE$28).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            var tmp_0 = this;
            tmp_0.q1w_1 = new SafeCollector(this.p1w_1.j1j_1, this.ea());
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 6;
            this.y9_1 = 2;
            suspendResult = this.p1w_1.k1j_1(this.q1w_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.r1w_1 = suspendResult;
            this.z9_1 = 7;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 7;
            this.q1w_1.ia();
            var tmp_1 = this.p1w_1.j1j_1;
            if (tmp_1 instanceof SubscribedFlowCollector) {
              this.y9_1 = 4;
              suspendResult = this.p1w_1.j1j_1.l1j(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 5;
              continue $sm;
            }

          case 4:
            this.y9_1 = 5;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            this.z9_1 = 7;
            var t = this.ba_1;
            this.q1w_1.ia();
            throw t;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function SubscribedFlowCollector() {
  }
  protoOf(SubscribedFlowCollector).l1j = function ($completion) {
    var tmp = new $onSubscriptionCOROUTINE$28(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function SharingConfig(upstream, extraBufferCapacity, onBufferOverflow, context) {
    this.d1w_1 = upstream;
    this.e1w_1 = extraBufferCapacity;
    this.f1w_1 = onBufferOverflow;
    this.g1w_1 = context;
  }
  function configureSharing(_this__u8e3s4, replay) {
    // Inline function 'kotlinx.coroutines.assert' call
    var defaultExtraCapacity = coerceAtLeast(replay, Factory_getInstance().r1c_1) - replay | 0;
    if (_this__u8e3s4 instanceof ChannelFlow) {
      var upstream = _this__u8e3s4.e1e();
      if (!(upstream == null)) {
        var tmp0_subject = _this__u8e3s4.a1e_1;
        return new SharingConfig(upstream, ((tmp0_subject === -3 ? true : tmp0_subject === -2) ? true : tmp0_subject === 0) ? _this__u8e3s4.b1e_1.equals(BufferOverflow_SUSPEND_getInstance()) ? _this__u8e3s4.a1e_1 === 0 ? 0 : defaultExtraCapacity : replay === 0 ? 1 : 0 : _this__u8e3s4.a1e_1, _this__u8e3s4.b1e_1, _this__u8e3s4.z1d_1);
      }
    }
    return new SharingConfig(_this__u8e3s4, defaultExtraCapacity, BufferOverflow_SUSPEND_getInstance(), EmptyCoroutineContext_getInstance());
  }
  function launchSharingDeferred(_this__u8e3s4, context, upstream, result) {
    launch(_this__u8e3s4, context, VOID, launchSharingDeferred$slambda_0(upstream, result, null));
  }
  function $collectCOROUTINE$29(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a1x_1 = _this__u8e3s4;
    this.b1x_1 = collector;
  }
  protoOf($collectCOROUTINE$29).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.a1x_1.d1x_1.q1j(this.b1x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ReadonlyStateFlow(flow, job) {
    this.c1x_1 = job;
    this.d1x_1 = flow;
  }
  protoOf(ReadonlyStateFlow).y = function () {
    return this.d1x_1.y();
  };
  protoOf(ReadonlyStateFlow).q1j = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$29(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ReadonlyStateFlow).s1d = function (collector, $completion) {
    return this.q1j(collector, $completion);
  };
  protoOf(ReadonlyStateFlow).f1e = function (context, capacity, onBufferOverflow) {
    return fuseStateFlow(this, context, capacity, onBufferOverflow);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_3(function_0) {
    this.e1x_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).d1f = function (value, $completion) {
    return this.e1x_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).b4 = function () {
    return this.e1x_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).hashCode = function () {
    return hashCode(this.b4());
  };
  function launchSharingDeferred$slambda$slambda($state, $this_launch, $result, resultContinuation) {
    this.n1x_1 = $state;
    this.o1x_1 = $this_launch;
    this.p1x_1 = $result;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchSharingDeferred$slambda$slambda).a1n = function (value, $completion) {
    var tmp = this.b1n(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(launchSharingDeferred$slambda$slambda).oa = function (p1, $completion) {
    return this.a1n((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchSharingDeferred$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var tmp0_safe_receiver = this.n1x_1._v;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            tmp0_safe_receiver.p1j(this.q1x_1);
            tmp_0 = Unit_instance;
          }
          if (tmp_0 == null) {
            var $this$run = this.o1x_1;
            var this_0 = MutableStateFlow(this.q1x_1);
            this.p1x_1.lz(new ReadonlyStateFlow(this_0, get_job($this$run.et())));
            this.n1x_1._v = this_0;
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(launchSharingDeferred$slambda$slambda).b1n = function (value, completion) {
    var i = new launchSharingDeferred$slambda$slambda(this.n1x_1, this.o1x_1, this.p1x_1, completion);
    i.q1x_1 = value;
    return i;
  };
  function launchSharingDeferred$slambda$slambda_0($state, $this_launch, $result, resultContinuation) {
    var i = new launchSharingDeferred$slambda$slambda($state, $this_launch, $result, resultContinuation);
    var l = function (value, $completion) {
      return i.a1n(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function launchSharingDeferred$slambda($upstream, $result, resultContinuation) {
    this.z1x_1 = $upstream;
    this.a1y_1 = $result;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchSharingDeferred$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(launchSharingDeferred$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchSharingDeferred$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.z9_1 = 2;
            this.c1y_1 = {_v: null};
            this.y9_1 = 1;
            var tmp_0 = launchSharingDeferred$slambda$slambda_0(this.c1y_1, this.b1y_1, this.a1y_1, null);
            suspendResult = this.z1x_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_3(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z9_1 = 3;
            this.y9_1 = 4;
            continue $sm;
          case 2:
            this.z9_1 = 3;
            var tmp_1 = this.ba_1;
            if (tmp_1 instanceof Error) {
              var e = this.ba_1;
              this.a1y_1.nz(e);
              throw e;
            } else {
              throw this.ba_1;
            }

          case 3:
            throw this.ba_1;
          case 4:
            this.z9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 3) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(launchSharingDeferred$slambda).i1l = function ($this$launch, completion) {
    var i = new launchSharingDeferred$slambda(this.z1x_1, this.a1y_1, completion);
    i.b1y_1 = $this$launch;
    return i;
  };
  function launchSharingDeferred$slambda_0($upstream, $result, resultContinuation) {
    var i = new launchSharingDeferred$slambda($upstream, $result, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function emitAll_0(_this__u8e3s4, flow, $completion) {
    ensureActive_1(_this__u8e3s4);
    return flow.s1d(_this__u8e3s4, $completion);
  }
  function collectLatest(_this__u8e3s4, action, $completion) {
    return collect(buffer(mapLatest(_this__u8e3s4, action), 0), $completion);
  }
  function collect(_this__u8e3s4, $completion) {
    return _this__u8e3s4.s1d(NopCollector_instance, $completion);
  }
  function toList_3(_this__u8e3s4, destination, $completion) {
    destination = destination === VOID ? ArrayList_init_$Create$() : destination;
    return toCollection_1(_this__u8e3s4, destination, $completion);
  }
  function toCollection_1(_this__u8e3s4, destination, $completion) {
    var tmp = new $toCollectionCOROUTINE$32(_this__u8e3s4, destination, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_4(function_0) {
    this.n1y_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).d1f = function (value, $completion) {
    return this.n1y_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).b4 = function () {
    return this.n1y_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).hashCode = function () {
    return hashCode(this.b4());
  };
  function toCollection$slambda($destination, resultContinuation) {
    this.w1y_1 = $destination;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(toCollection$slambda).a1n = function (value, $completion) {
    var tmp = this.b1n(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(toCollection$slambda).oa = function (p1, $completion) {
    return this.a1n((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(toCollection$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          this.w1y_1.e(this.x1y_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(toCollection$slambda).b1n = function (value, completion) {
    var i = new toCollection$slambda(this.w1y_1, completion);
    i.x1y_1 = value;
    return i;
  };
  function toCollection$slambda_0($destination, resultContinuation) {
    var i = new toCollection$slambda($destination, resultContinuation);
    var l = function (value, $completion) {
      return i.a1n(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $toCollectionCOROUTINE$32(_this__u8e3s4, destination, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l1y_1 = _this__u8e3s4;
    this.m1y_1 = destination;
  }
  protoOf($toCollectionCOROUTINE$32).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            var tmp_0 = toCollection$slambda_0(this.m1y_1, null);
            suspendResult = this.l1y_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_4(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.m1y_1;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function first_3(_this__u8e3s4, predicate, $completion) {
    var tmp = new $firstCOROUTINE$33(_this__u8e3s4, predicate, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function firstOrNull_3(_this__u8e3s4, $completion) {
    var tmp = new $firstOrNullCOROUTINE$34(_this__u8e3s4, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function firstOrNull_4(_this__u8e3s4, predicate, $completion) {
    var tmp = new $firstOrNullCOROUTINE$35(_this__u8e3s4, predicate, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function $emitCOROUTINE$36(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v20_1 = _this__u8e3s4;
    this.w20_1 = value;
  }
  protoOf($emitCOROUTINE$36).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.x20_1 = this.w20_1;
            this.y20_1 = this.x20_1;
            this.y9_1 = 1;
            suspendResult = this.v20_1.a21_1(this.y20_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              var tmp_1 = this;
              this.v20_1.b21_1._v = this.y20_1;
              tmp_1.z20_1 = false;
              this.y9_1 = 2;
              continue $sm;
            } else {
              var tmp_2 = this;
              tmp_2.z20_1 = true;
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            var ARGUMENT = this.z20_1;
            if (!ARGUMENT) {
              throw new AbortFlowException(this.v20_1);
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            return Unit_instance;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function first$$inlined$collectWhile$1($predicate, $result) {
    this.a21_1 = $predicate;
    this.b21_1 = $result;
  }
  protoOf(first$$inlined$collectWhile$1).g1p = function (value, $completion) {
    var tmp = new $emitCOROUTINE$36(this, value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(first$$inlined$collectWhile$1).d1f = function (value, $completion) {
    return this.g1p((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  function firstOrNull$$inlined$collectWhile$1($result) {
    this.c21_1 = $result;
  }
  protoOf(firstOrNull$$inlined$collectWhile$1).g1p = function (value, $completion) {
    // Inline function 'kotlinx.coroutines.flow.firstOrNull.<anonymous>' call
    this.c21_1._v = value;
    if (!false) {
      throw new AbortFlowException(this);
    }
    return Unit_instance;
  };
  protoOf(firstOrNull$$inlined$collectWhile$1).d1f = function (value, $completion) {
    return this.g1p((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  function $emitCOROUTINE$37(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l21_1 = _this__u8e3s4;
    this.m21_1 = value;
  }
  protoOf($emitCOROUTINE$37).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.n21_1 = this.m21_1;
            this.o21_1 = this.n21_1;
            this.y9_1 = 1;
            suspendResult = this.l21_1.q21_1(this.o21_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              var tmp_1 = this;
              this.l21_1.r21_1._v = this.o21_1;
              tmp_1.p21_1 = false;
              this.y9_1 = 2;
              continue $sm;
            } else {
              var tmp_2 = this;
              tmp_2.p21_1 = true;
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            var ARGUMENT = this.p21_1;
            if (!ARGUMENT) {
              throw new AbortFlowException(this.l21_1);
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            return Unit_instance;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function firstOrNull$$inlined$collectWhile$2($predicate, $result) {
    this.q21_1 = $predicate;
    this.r21_1 = $result;
  }
  protoOf(firstOrNull$$inlined$collectWhile$2).g1p = function (value, $completion) {
    var tmp = new $emitCOROUTINE$37(this, value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(firstOrNull$$inlined$collectWhile$2).d1f = function (value, $completion) {
    return this.g1p((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
  };
  function $firstCOROUTINE$33(_this__u8e3s4, predicate, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g1z_1 = _this__u8e3s4;
    this.h1z_1 = predicate;
  }
  protoOf($firstCOROUTINE$33).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.i1z_1 = {_v: get_NULL()};
            var tmp_0 = this;
            tmp_0.j1z_1 = this.g1z_1;
            this.k1z_1 = this.j1z_1;
            var tmp_1 = this;
            tmp_1.l1z_1 = new first$$inlined$collectWhile$1(this.h1z_1, this.i1z_1);
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.k1z_1.s1d(this.l1z_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z9_1 = 3;
            this.y9_1 = 4;
            continue $sm;
          case 2:
            this.z9_1 = 3;
            var tmp_2 = this.ba_1;
            if (tmp_2 instanceof AbortFlowException) {
              var e = this.ba_1;
              checkOwnership(e, this.l1z_1);
              this.y9_1 = 4;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 3:
            throw this.ba_1;
          case 4:
            this.z9_1 = 3;
            if (this.i1z_1._v === get_NULL())
              throw NoSuchElementException_init_$Create$_0('Expected at least one element matching the predicate ' + toString_1(this.h1z_1));
            var tmp_3 = this.i1z_1._v;
            return (tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE();
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 3) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  function $firstOrNullCOROUTINE$34(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u1z_1 = _this__u8e3s4;
  }
  protoOf($firstOrNullCOROUTINE$34).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.v1z_1 = {_v: null};
            var tmp_0 = this;
            tmp_0.w1z_1 = this.u1z_1;
            this.x1z_1 = this.w1z_1;
            var tmp_1 = this;
            tmp_1.y1z_1 = new firstOrNull$$inlined$collectWhile$1(this.v1z_1);
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.x1z_1.s1d(this.y1z_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z9_1 = 4;
            this.y9_1 = 3;
            continue $sm;
          case 2:
            this.z9_1 = 4;
            var tmp_2 = this.ba_1;
            if (tmp_2 instanceof AbortFlowException) {
              var e = this.ba_1;
              checkOwnership(e, this.y1z_1);
              this.y9_1 = 3;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 3:
            this.z9_1 = 4;
            return this.v1z_1._v;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 4) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  function $firstOrNullCOROUTINE$35(_this__u8e3s4, predicate, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h20_1 = _this__u8e3s4;
    this.i20_1 = predicate;
  }
  protoOf($firstOrNullCOROUTINE$35).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.j20_1 = {_v: null};
            var tmp_0 = this;
            tmp_0.k20_1 = this.h20_1;
            this.l20_1 = this.k20_1;
            var tmp_1 = this;
            tmp_1.m20_1 = new firstOrNull$$inlined$collectWhile$2(this.i20_1, this.j20_1);
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.l20_1.s1d(this.m20_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z9_1 = 4;
            this.y9_1 = 3;
            continue $sm;
          case 2:
            this.z9_1 = 4;
            var tmp_2 = this.ba_1;
            if (tmp_2 instanceof AbortFlowException) {
              var e = this.ba_1;
              checkOwnership(e, this.m20_1);
              this.y9_1 = 3;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 3:
            this.z9_1 = 4;
            return this.j20_1._v;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 4) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  function OpDescriptor() {
  }
  function get_CLOSED() {
    _init_properties_ConcurrentLinkedList_kt__5gcgzy();
    return CLOSED;
  }
  var CLOSED;
  function Segment(id, prev, pointers) {
    ConcurrentLinkedListNode.call(this, prev);
    this.px_1 = id;
    this.qx_1 = atomic$int$1(pointers << 16);
  }
  protoOf(Segment).x16 = function () {
    return this.qx_1.kotlinx$atomicfu$value === this.z15() && !this.e17();
  };
  protoOf(Segment).y16 = function () {
    var tmp0 = this.qx_1;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.internal.addConditionally' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.internal.Segment.tryIncPointers.<anonymous>' call
        if (!(!(cur === this.z15()) || this.e17())) {
          tmp$ret$1 = false;
          break $l$block_0;
        }
        if (tmp0.atomicfu$compareAndSet(cur, cur + 65536 | 0)) {
          tmp$ret$1 = true;
          break $l$block_0;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(Segment).z16 = function () {
    return this.qx_1.atomicfu$addAndGet(-65536) === this.z15() && !this.e17();
  };
  protoOf(Segment).w16 = function () {
    if (this.qx_1.atomicfu$incrementAndGet() === this.z15()) {
      this.b5();
    }
  };
  function close(_this__u8e3s4) {
    _init_properties_ConcurrentLinkedList_kt__5gcgzy();
    var cur = _this__u8e3s4;
    while (true) {
      // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
      var this_0 = cur;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed.<anonymous>' call
      var it = access$_get_nextOrClosed__ywzond(this_0);
      var tmp;
      if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
        return cur;
      } else {
        tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
      }
      var next = tmp;
      if (next === null) {
        if (cur.h17())
          return cur;
      } else {
        cur = next;
      }
    }
  }
  function _SegmentOrClosed___init__impl__jnexvb(value) {
    return value;
  }
  function _get_value__a43j40_1($this) {
    return $this;
  }
  function _SegmentOrClosed___get_isClosed__impl__qmxmlo($this) {
    return _get_value__a43j40_1($this) === get_CLOSED();
  }
  function _SegmentOrClosed___get_segment__impl__jvcr9l($this) {
    var tmp;
    if (_get_value__a43j40_1($this) === get_CLOSED()) {
      var message = 'Does not contain segment';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      var tmp_0 = _get_value__a43j40_1($this);
      tmp = tmp_0 instanceof Segment ? tmp_0 : THROW_CCE();
    }
    return tmp;
  }
  function SegmentOrClosed__toString_impl_pzb2an($this) {
    return 'SegmentOrClosed(value=' + toString_0($this) + ')';
  }
  function SegmentOrClosed__hashCode_impl_4855hs($this) {
    return $this == null ? 0 : hashCode($this);
  }
  function SegmentOrClosed__equals_impl_6erq1g($this, other) {
    if (!(other instanceof SegmentOrClosed))
      return false;
    var tmp0_other_with_cast = other instanceof SegmentOrClosed ? other.o19_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function SegmentOrClosed(value) {
    this.o19_1 = value;
  }
  protoOf(SegmentOrClosed).toString = function () {
    return SegmentOrClosed__toString_impl_pzb2an(this.o19_1);
  };
  protoOf(SegmentOrClosed).hashCode = function () {
    return SegmentOrClosed__hashCode_impl_4855hs(this.o19_1);
  };
  protoOf(SegmentOrClosed).equals = function (other) {
    return SegmentOrClosed__equals_impl_6erq1g(this.o19_1, other);
  };
  function _get_nextOrClosed__w0gmuv($this) {
    return $this.a17_1.kotlinx$atomicfu$value;
  }
  function _get_aliveSegmentLeft__mr4ndu($this) {
    var cur = $this.f17();
    while (!(cur === null) && cur.x16())
      cur = cur.b17_1.kotlinx$atomicfu$value;
    return cur;
  }
  function _get_aliveSegmentRight__7ulr0b($this) {
    // Inline function 'kotlinx.coroutines.assert' call
    var cur = ensureNotNull($this.c17());
    while (cur.x16()) {
      var tmp0_elvis_lhs = cur.c17();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return cur;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      cur = tmp;
    }
    return cur;
  }
  function access$_get_nextOrClosed__ywzond($this) {
    return _get_nextOrClosed__w0gmuv($this);
  }
  function ConcurrentLinkedListNode(prev) {
    this.a17_1 = atomic$ref$1(null);
    this.b17_1 = atomic$ref$1(prev);
  }
  protoOf(ConcurrentLinkedListNode).c17 = function () {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed.<anonymous>' call
    var it = access$_get_nextOrClosed__ywzond(this);
    var tmp;
    if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
      return null;
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    return tmp;
  };
  protoOf(ConcurrentLinkedListNode).d17 = function (value) {
    return this.a17_1.atomicfu$compareAndSet(null, value);
  };
  protoOf(ConcurrentLinkedListNode).e17 = function () {
    return this.c17() == null;
  };
  protoOf(ConcurrentLinkedListNode).f17 = function () {
    return this.b17_1.kotlinx$atomicfu$value;
  };
  protoOf(ConcurrentLinkedListNode).g17 = function () {
    // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
    this.b17_1.kotlinx$atomicfu$value = null;
  };
  protoOf(ConcurrentLinkedListNode).h17 = function () {
    return this.a17_1.atomicfu$compareAndSet(null, get_CLOSED());
  };
  protoOf(ConcurrentLinkedListNode).b5 = function () {
    // Inline function 'kotlinx.coroutines.assert' call
    if (this.e17())
      return Unit_instance;
    $l$loop_0: while (true) {
      var prev = _get_aliveSegmentLeft__mr4ndu(this);
      var next = _get_aliveSegmentRight__7ulr0b(this);
      var tmp0 = next.b17_1;
      $l$block: {
        // Inline function 'kotlinx.atomicfu.update' call
        while (true) {
          var cur = tmp0.kotlinx$atomicfu$value;
          // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.remove.<anonymous>' call
          var upd = cur === null ? null : prev;
          if (tmp0.atomicfu$compareAndSet(cur, upd)) {
            break $l$block;
          }
        }
      }
      if (!(prev === null))
        prev.a17_1.kotlinx$atomicfu$value = next;
      if (next.x16() && !next.e17())
        continue $l$loop_0;
      if (!(prev === null) && prev.x16())
        continue $l$loop_0;
      return Unit_instance;
    }
  };
  function findSegmentInternal(_this__u8e3s4, id, createNewSegment) {
    _init_properties_ConcurrentLinkedList_kt__5gcgzy();
    var cur = _this__u8e3s4;
    $l$loop: while (cur.px_1.d1(id) < 0 || cur.x16()) {
      // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
      var this_0 = cur;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed.<anonymous>' call
      var it = access$_get_nextOrClosed__ywzond(this_0);
      var tmp;
      if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
        return _SegmentOrClosed___init__impl__jnexvb(get_CLOSED());
      } else {
        tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
      }
      var next = tmp;
      if (!(next == null)) {
        cur = next;
        continue $l$loop;
      }
      // Inline function 'kotlin.Long.plus' call
      var newTail = createNewSegment(cur.px_1.i3(toLong(1)), cur);
      if (cur.d17(newTail)) {
        if (cur.x16()) {
          cur.b5();
        }
        cur = newTail;
      }
    }
    return _SegmentOrClosed___init__impl__jnexvb(cur);
  }
  function access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy() {
    return get_CLOSED();
  }
  var properties_initialized_ConcurrentLinkedList_kt_kwt434;
  function _init_properties_ConcurrentLinkedList_kt__5gcgzy() {
    if (!properties_initialized_ConcurrentLinkedList_kt_kwt434) {
      properties_initialized_ConcurrentLinkedList_kt_kwt434 = true;
      CLOSED = new Symbol_0('CLOSED');
    }
  }
  function handleUncaughtCoroutineException(context, exception) {
    var tmp0_iterator = get_platformExceptionHandlers().k();
    while (tmp0_iterator.l()) {
      var handler = tmp0_iterator.m();
      try {
        handler.wz(context, exception);
      } catch ($p) {
        if ($p instanceof ExceptionSuccessfullyProcessed) {
          var _ = $p;
          return Unit_instance;
        } else {
          if ($p instanceof Error) {
            var t = $p;
            propagateExceptionFinalResort(handlerException(exception, t));
          } else {
            throw $p;
          }
        }
      }
    }
    try {
      addSuppressed(exception, new DiagnosticCoroutineContextException(context));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
      } else {
        throw $p;
      }
    }
    propagateExceptionFinalResort(exception);
  }
  function ExceptionSuccessfullyProcessed() {
  }
  function get_UNDEFINED() {
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    return UNDEFINED;
  }
  var UNDEFINED;
  function get_REUSABLE_CLAIMED() {
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    return REUSABLE_CLAIMED;
  }
  var REUSABLE_CLAIMED;
  function _get_reusableCancellableContinuation__9qex09($this) {
    var tmp = $this.bx_1.kotlinx$atomicfu$value;
    return tmp instanceof CancellableContinuationImpl ? tmp : null;
  }
  function DispatchedContinuation(dispatcher, continuation) {
    DispatchedTask.call(this, -1);
    this.xw_1 = dispatcher;
    this.yw_1 = continuation;
    this.zw_1 = get_UNDEFINED();
    this.ax_1 = threadContextElements(this.ea());
    this.bx_1 = atomic$ref$1(null);
  }
  protoOf(DispatchedContinuation).ea = function () {
    return this.yw_1.ea();
  };
  protoOf(DispatchedContinuation).kx = function () {
    return !(this.bx_1.kotlinx$atomicfu$value == null);
  };
  protoOf(DispatchedContinuation).s21 = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.bx_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.awaitReusability.<anonymous>' call
      if (!(this_0.kotlinx$atomicfu$value === get_REUSABLE_CLAIMED()))
        return Unit_instance;
    }
  };
  protoOf(DispatchedContinuation).vz = function () {
    this.s21();
    var tmp0_safe_receiver = _get_reusableCancellableContinuation__9qex09(this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.gy();
    }
  };
  protoOf(DispatchedContinuation).cx = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.bx_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.claimReusableCancellableContinuation.<anonymous>' call
      var state = this_0.kotlinx$atomicfu$value;
      if (state === null) {
        this.bx_1.kotlinx$atomicfu$value = get_REUSABLE_CLAIMED();
        return null;
      } else {
        if (state instanceof CancellableContinuationImpl) {
          if (this.bx_1.atomicfu$compareAndSet(state, get_REUSABLE_CLAIMED())) {
            return state instanceof CancellableContinuationImpl ? state : THROW_CCE();
          }
        } else {
          if (state !== get_REUSABLE_CLAIMED()) {
            if (!(state instanceof Error)) {
              // Inline function 'kotlin.error' call
              var message = 'Inconsistent state ' + toString_0(state);
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }
          }
        }
      }
    }
  };
  protoOf(DispatchedContinuation).sy = function (continuation) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.bx_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.tryReleaseClaimedContinuation.<anonymous>' call
      var state = this_0.kotlinx$atomicfu$value;
      if (state === get_REUSABLE_CLAIMED()) {
        if (this.bx_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), continuation))
          return null;
      } else {
        if (state instanceof Error) {
          // Inline function 'kotlin.require' call
          // Inline function 'kotlin.require' call
          if (!this.bx_1.atomicfu$compareAndSet(state, null)) {
            // Inline function 'kotlin.require.<anonymous>' call
            var message = 'Failed requirement.';
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
          }
          return state;
        } else {
          // Inline function 'kotlin.error' call
          var message_0 = 'Inconsistent state ' + toString_0(state);
          throw IllegalStateException_init_$Create$_0(toString_1(message_0));
        }
      }
    }
  };
  protoOf(DispatchedContinuation).mx = function (cause) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.bx_1;
    while (true) {
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.postponeCancellation.<anonymous>' call
      var state = this_0.kotlinx$atomicfu$value;
      if (equals(state, get_REUSABLE_CLAIMED())) {
        if (this.bx_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), cause))
          return true;
      } else {
        if (state instanceof Error)
          return true;
        else {
          if (this.bx_1.atomicfu$compareAndSet(state, null))
            return false;
        }
      }
    }
  };
  protoOf(DispatchedContinuation).jy = function () {
    var state = this.zw_1;
    // Inline function 'kotlinx.coroutines.assert' call
    this.zw_1 = get_UNDEFINED();
    return state;
  };
  protoOf(DispatchedContinuation).hy = function () {
    return this;
  };
  protoOf(DispatchedContinuation).ja = function (result) {
    var context = this.yw_1.ea();
    var state = toState_0(result);
    if (this.xw_1.sz(context)) {
      this.zw_1 = state;
      this.lx_1 = 0;
      this.xw_1.tz(context, this);
    } else {
      $l$block: {
        // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
        // Inline function 'kotlinx.coroutines.assert' call
        var eventLoop = ThreadLocalEventLoop_getInstance().o10();
        if (false && eventLoop.j10()) {
          break $l$block;
        }
        var tmp;
        if (eventLoop.i10()) {
          this.zw_1 = state;
          this.lx_1 = 0;
          eventLoop.h10(this);
          tmp = true;
        } else {
          // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
          eventLoop.k10(true);
          try {
            // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeWith.<anonymous>' call
            this.ea();
            // Inline function 'kotlinx.coroutines.withCoroutineContext' call
            this.ax_1;
            // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeWith.<anonymous>.<anonymous>' call
            this.yw_1.ja(result);
            $l$loop: while (eventLoop.g10()) {
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              this.xy(e, null);
            } else {
              throw $p;
            }
          }
          finally {
            eventLoop.l10(true);
          }
          tmp = false;
        }
      }
    }
  };
  protoOf(DispatchedContinuation).ky = function (takenState, cause) {
    if (takenState instanceof CompletedWithCancellation) {
      takenState.qz_1(cause);
    }
  };
  protoOf(DispatchedContinuation).r15 = function (context, value) {
    this.zw_1 = value;
    this.lx_1 = 1;
    this.xw_1.uz(context, this);
  };
  protoOf(DispatchedContinuation).toString = function () {
    return 'DispatchedContinuation[' + this.xw_1.toString() + ', ' + toDebugString(this.yw_1) + ']';
  };
  function resumeCancellableWith(_this__u8e3s4, result, onCancellation) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    var tmp;
    if (_this__u8e3s4 instanceof DispatchedContinuation) {
      var state = toState_0(result, onCancellation);
      var tmp_0;
      if (_this__u8e3s4.xw_1.sz(_this__u8e3s4.ea())) {
        _this__u8e3s4.zw_1 = state;
        _this__u8e3s4.lx_1 = 1;
        _this__u8e3s4.xw_1.tz(_this__u8e3s4.ea(), _this__u8e3s4);
        tmp_0 = Unit_instance;
      } else {
        $l$block: {
          // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
          // Inline function 'kotlinx.coroutines.assert' call
          var eventLoop = ThreadLocalEventLoop_getInstance().o10();
          if (false && eventLoop.j10()) {
            break $l$block;
          }
          var tmp_1;
          if (eventLoop.i10()) {
            _this__u8e3s4.zw_1 = state;
            _this__u8e3s4.lx_1 = 1;
            eventLoop.h10(_this__u8e3s4);
            tmp_1 = true;
          } else {
            // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
            eventLoop.k10(true);
            try {
              // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancellableWith.<anonymous>' call
              var tmp$ret$3;
              $l$block_0: {
                // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancelled' call
                var job = _this__u8e3s4.ea().la(Key_instance_3);
                if (!(job == null) && !job.ft()) {
                  var cause = job.eu();
                  _this__u8e3s4.ky(state, cause);
                  // Inline function 'kotlin.coroutines.resumeWithException' call
                  // Inline function 'kotlin.Companion.failure' call
                  var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
                  _this__u8e3s4.ja(tmp$ret$1);
                  tmp$ret$3 = true;
                  break $l$block_0;
                }
                tmp$ret$3 = false;
              }
              if (!tmp$ret$3) {
                // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
                _this__u8e3s4.yw_1;
                // Inline function 'kotlinx.coroutines.withContinuationContext' call
                _this__u8e3s4.ax_1;
                // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith.<anonymous>' call
                _this__u8e3s4.yw_1.ja(result);
              }
              $l$loop: while (eventLoop.g10()) {
              }
            } catch ($p) {
              if ($p instanceof Error) {
                var e = $p;
                _this__u8e3s4.xy(e, null);
              } else {
                throw $p;
              }
            }
            finally {
              eventLoop.l10(true);
            }
            tmp_1 = false;
          }
        }
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    } else {
      _this__u8e3s4.ja(result);
      tmp = Unit_instance;
    }
    return tmp;
  }
  function yieldUndispatched(_this__u8e3s4) {
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
      // Inline function 'kotlinx.coroutines.assert' call
      var eventLoop = ThreadLocalEventLoop_getInstance().o10();
      if (true && eventLoop.j10()) {
        tmp$ret$0 = false;
        break $l$block;
      }
      var tmp;
      if (eventLoop.i10()) {
        _this__u8e3s4.zw_1 = Unit_instance;
        _this__u8e3s4.lx_1 = 1;
        eventLoop.h10(_this__u8e3s4);
        tmp = true;
      } else {
        // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
        eventLoop.k10(true);
        try {
          // Inline function 'kotlinx.coroutines.internal.yieldUndispatched.<anonymous>' call
          _this__u8e3s4.wy();
          $l$loop: while (eventLoop.g10()) {
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            _this__u8e3s4.xy(e, null);
          } else {
            throw $p;
          }
        }
        finally {
          eventLoop.l10(true);
        }
        tmp = false;
      }
      tmp$ret$0 = tmp;
    }
    return tmp$ret$0;
  }
  var properties_initialized_DispatchedContinuation_kt_2siadq;
  function _init_properties_DispatchedContinuation_kt__tnmqc0() {
    if (!properties_initialized_DispatchedContinuation_kt_2siadq) {
      properties_initialized_DispatchedContinuation_kt_2siadq = true;
      UNDEFINED = new Symbol_0('UNDEFINED');
      REUSABLE_CLAIMED = new Symbol_0('REUSABLE_CLAIMED');
    }
  }
  function DispatchedTask(resumeMode) {
    SchedulerTask.call(this);
    this.lx_1 = resumeMode;
  }
  protoOf(DispatchedTask).ky = function (takenState, cause) {
  };
  protoOf(DispatchedTask).ry = function (state) {
    return (state == null ? true : !(state == null)) ? state : THROW_CCE();
  };
  protoOf(DispatchedTask).uy = function (state) {
    var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kt_1;
  };
  protoOf(DispatchedTask).wy = function () {
    // Inline function 'kotlinx.coroutines.assert' call
    get_taskContext(this);
    var taskContext = Unit_instance;
    var fatalException = null;
    try {
      var tmp = this.hy();
      var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
      var continuation = delegate.yw_1;
      // Inline function 'kotlinx.coroutines.withContinuationContext' call
      delegate.ax_1;
      // Inline function 'kotlinx.coroutines.DispatchedTask.run.<anonymous>' call
      var context = continuation.ea();
      var state = this.jy();
      var exception = this.uy(state);
      var job = exception == null && get_isCancellableMode(this.lx_1) ? context.la(Key_instance_3) : null;
      if (!(job == null) && !job.ft()) {
        var cause = job.eu();
        this.ky(state, cause);
        // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
        // Inline function 'kotlin.Companion.failure' call
        var exception_0 = recoverStackTrace(cause, continuation);
        var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception_0));
        continuation.ja(tmp$ret$0);
      } else {
        if (!(exception == null)) {
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
          continuation.ja(tmp$ret$1);
        } else {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = this.ry(state);
          var tmp$ret$3 = _Result___init__impl__xyqfz8(value);
          continuation.ja(tmp$ret$3);
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        fatalException = e;
      } else {
        throw $p;
      }
    }
    finally {
      // Inline function 'kotlin.runCatching' call
      var tmp_0;
      try {
        // Inline function 'kotlinx.coroutines.afterTask' call
        // Inline function 'kotlin.Companion.success' call
        tmp_0 = _Result___init__impl__xyqfz8(Unit_instance);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e_0 = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_1 = _Result___init__impl__xyqfz8(createFailure(e_0));
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var result = tmp_0;
      this.xy(fatalException, Result__exceptionOrNull_impl_p6xea9(result));
    }
  };
  protoOf(DispatchedTask).xy = function (exception, finallyException) {
    if (exception === null && finallyException === null)
      return Unit_instance;
    if (!(exception === null) && !(finallyException === null)) {
      // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
    }
    var cause = exception == null ? finallyException : exception;
    var reason = new CoroutinesInternalError('Fatal exception in coroutines machinery for ' + toString_1(this) + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", ensureNotNull(cause));
    handleCoroutineException(this.hy().ea(), reason);
  };
  function get_isReusableMode(_this__u8e3s4) {
    return _this__u8e3s4 === 2;
  }
  function get_isCancellableMode(_this__u8e3s4) {
    return _this__u8e3s4 === 1 || _this__u8e3s4 === 2;
  }
  function dispatch(_this__u8e3s4, mode) {
    // Inline function 'kotlinx.coroutines.assert' call
    var delegate = _this__u8e3s4.hy();
    var undispatched = mode === 4;
    var tmp;
    var tmp_0;
    if (!undispatched) {
      tmp_0 = delegate instanceof DispatchedContinuation;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = get_isCancellableMode(mode) === get_isCancellableMode(_this__u8e3s4.lx_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      var dispatcher = delegate.xw_1;
      var context = delegate.ea();
      if (dispatcher.sz(context)) {
        dispatcher.tz(context, _this__u8e3s4);
      } else {
        resumeUnconfined(_this__u8e3s4);
      }
    } else {
      resume(_this__u8e3s4, delegate, undispatched);
    }
  }
  function resumeUnconfined(_this__u8e3s4) {
    var eventLoop = ThreadLocalEventLoop_getInstance().o10();
    if (eventLoop.i10()) {
      eventLoop.h10(_this__u8e3s4);
    } else {
      // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
      eventLoop.k10(true);
      try {
        // Inline function 'kotlinx.coroutines.resumeUnconfined.<anonymous>' call
        resume(_this__u8e3s4, _this__u8e3s4.hy(), true);
        $l$loop: while (eventLoop.g10()) {
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          _this__u8e3s4.xy(e, null);
        } else {
          throw $p;
        }
      }
      finally {
        eventLoop.l10(true);
      }
    }
  }
  function resume(_this__u8e3s4, delegate, undispatched) {
    var state = _this__u8e3s4.jy();
    var exception = _this__u8e3s4.uy(state);
    var tmp;
    if (!(exception == null)) {
      // Inline function 'kotlin.Companion.failure' call
      tmp = _Result___init__impl__xyqfz8(createFailure(exception));
    } else {
      // Inline function 'kotlin.Companion.success' call
      var value = _this__u8e3s4.ry(state);
      tmp = _Result___init__impl__xyqfz8(value);
    }
    var result = tmp;
    if (undispatched) {
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
      var this_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
      this_0.yw_1;
      // Inline function 'kotlinx.coroutines.withContinuationContext' call
      this_0.ax_1;
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith.<anonymous>' call
      this_0.yw_1.ja(result);
    } else {
      delegate.ja(result);
    }
  }
  function _InlineList___init__impl__z8n56(holder) {
    holder = holder === VOID ? null : holder;
    return holder;
  }
  function _get_holder__f6h5pd($this) {
    return $this;
  }
  function InlineList__plus_impl_nuetvo($this, element) {
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp0_subject = _get_holder__f6h5pd($this);
    var tmp;
    if (tmp0_subject == null) {
      tmp = _InlineList___init__impl__z8n56(element);
    } else {
      if (tmp0_subject instanceof ArrayList) {
        var tmp_0 = _get_holder__f6h5pd($this);
        (tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE()).e(element);
        tmp = _InlineList___init__impl__z8n56(_get_holder__f6h5pd($this));
      } else {
        var list = ArrayList_init_$Create$_0(4);
        var tmp_1 = _get_holder__f6h5pd($this);
        list.e((tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE());
        list.e(element);
        tmp = _InlineList___init__impl__z8n56(list);
      }
    }
    return tmp;
  }
  function access$_get_holder__kkflen($this) {
    return _get_holder__f6h5pd($this);
  }
  function callUndeliveredElement(_this__u8e3s4, element, context) {
    var tmp0_safe_receiver = callUndeliveredElementCatchingException(_this__u8e3s4, element, null);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.coroutines.internal.callUndeliveredElement.<anonymous>' call
      handleCoroutineException(context, tmp0_safe_receiver);
    }
  }
  function UndeliveredElementException(message, cause) {
    RuntimeException_init_$Init$_1(message, cause, this);
    captureStack(this, UndeliveredElementException);
  }
  function callUndeliveredElementCatchingException(_this__u8e3s4, element, undeliveredElementException) {
    undeliveredElementException = undeliveredElementException === VOID ? null : undeliveredElementException;
    try {
      _this__u8e3s4(element);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        if (!(undeliveredElementException == null) && !(undeliveredElementException.cause === ex)) {
          // Inline function 'kotlinx.coroutines.addSuppressedThrowable' call
        } else {
          return new UndeliveredElementException('Exception in undelivered element handler for ' + toString_0(element), ex);
        }
      } else {
        throw $p;
      }
    }
    return undeliveredElementException;
  }
  function bindCancellationFun(_this__u8e3s4, element, context) {
    return bindCancellationFun$lambda(_this__u8e3s4, element, context);
  }
  function bindCancellationFun$lambda($this_bindCancellationFun, $element, $context) {
    return function (_anonymous_parameter_0__qggqh8) {
      callUndeliveredElement($this_bindCancellationFun, $element, $context);
      return Unit_instance;
    };
  }
  function ContextScope(context) {
    this.t21_1 = context;
  }
  protoOf(ContextScope).et = function () {
    return this.t21_1;
  };
  protoOf(ContextScope).toString = function () {
    return 'CoroutineScope(coroutineContext=' + toString_1(this.t21_1) + ')';
  };
  function ScopeCoroutine(context, uCont) {
    AbstractCoroutine.call(this, context, true, true);
    this.ow_1 = uCont;
  }
  protoOf(ScopeCoroutine).yu = function () {
    return true;
  };
  protoOf(ScopeCoroutine).pt = function (state) {
    resumeCancellableWith(intercepted(this.ow_1), recoverResult(state, this.ow_1));
  };
  protoOf(ScopeCoroutine).ot = function (state) {
    this.ow_1.ja(recoverResult(state, this.ow_1));
  };
  function Symbol_0(symbol) {
    this.u21_1 = symbol;
  }
  protoOf(Symbol_0).toString = function () {
    return '<' + this.u21_1 + '>';
  };
  function systemProp(propertyName, defaultValue, minValue, maxValue) {
    minValue = minValue === VOID ? 1 : minValue;
    maxValue = maxValue === VOID ? 2147483647 : maxValue;
    return systemProp_0(propertyName, toLong(defaultValue), toLong(minValue), toLong(maxValue)).z3();
  }
  function systemProp_0(propertyName, defaultValue, minValue, maxValue) {
    minValue = minValue === VOID ? new Long(1, 0) : minValue;
    maxValue = maxValue === VOID ? new Long(-1, 2147483647) : maxValue;
    var tmp0_elvis_lhs = systemProp_1(propertyName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return defaultValue;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp1_elvis_lhs = toLongOrNull(value);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var message = "System property '" + propertyName + "' has unrecognized value '" + value + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var parsed = tmp_0;
    if (!(minValue.d1(parsed) <= 0 ? parsed.d1(maxValue) <= 0 : false)) {
      // Inline function 'kotlin.error' call
      var message_0 = "System property '" + propertyName + "' should be in range " + minValue.toString() + '..' + maxValue.toString() + ", but is '" + parsed.toString() + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    return parsed;
  }
  function startCoroutineCancellable(_this__u8e3s4, receiver, completion, onCancellation) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    var tmp;
    try {
      var tmp_0 = intercepted(createCoroutineUnintercepted(_this__u8e3s4, receiver, completion));
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      resumeCancellableWith(tmp_0, tmp$ret$0, onCancellation);
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        dispatcherFailure(completion, e);
        tmp_1 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function startCoroutineCancellable_0(_this__u8e3s4, fatalCompletion) {
    var tmp;
    try {
      var tmp_0 = intercepted(_this__u8e3s4);
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
      resumeCancellableWith(tmp_0, tmp$ret$0);
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        dispatcherFailure(fatalCompletion, e);
        tmp_1 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function dispatcherFailure(completion, e) {
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(e));
    completion.ja(tmp$ret$0);
    throw e;
  }
  function startUndispatchedOrReturn(_this__u8e3s4, receiver, block) {
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.intrinsics.undispatchedResult' call
      var tmp;
      try {
        // Inline function 'kotlinx.coroutines.intrinsics.startUndispatchedOrReturn.<anonymous>' call
        // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
        tmp = startCoroutineUninterceptedOrReturnNonGeneratorVersion(block, receiver, _this__u8e3s4);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var e = $p;
          tmp_0 = new CompletedExceptionally(e);
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      var result = tmp;
      if (result === get_COROUTINE_SUSPENDED()) {
        tmp$ret$2 = get_COROUTINE_SUSPENDED();
        break $l$block_0;
      }
      var state = _this__u8e3s4.nt(result);
      if (state === get_COMPLETING_WAITING_CHILDREN()) {
        tmp$ret$2 = get_COROUTINE_SUSPENDED();
        break $l$block_0;
      }
      var tmp_1;
      if (state instanceof CompletedExceptionally) {
        var tmp_2;
        // Inline function 'kotlinx.coroutines.intrinsics.startUndispatchedOrReturn.<anonymous>' call
        state.kt_1;
        if (true) {
          throw recoverStackTrace(state.kt_1, _this__u8e3s4.ow_1);
        } else {
          if (result instanceof CompletedExceptionally) {
            throw recoverStackTrace(result.kt_1, _this__u8e3s4.ow_1);
          } else {
            tmp_2 = result;
          }
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = unboxState(state);
      }
      tmp$ret$2 = tmp_1;
    }
    return tmp$ret$2;
  }
  function startUndispatchedOrReturnIgnoreTimeout(_this__u8e3s4, receiver, block) {
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.intrinsics.undispatchedResult' call
      var tmp;
      try {
        // Inline function 'kotlinx.coroutines.intrinsics.startUndispatchedOrReturnIgnoreTimeout.<anonymous>' call
        // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
        tmp = startCoroutineUninterceptedOrReturnNonGeneratorVersion(block, receiver, _this__u8e3s4);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var e = $p;
          tmp_0 = new CompletedExceptionally(e);
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      var result = tmp;
      if (result === get_COROUTINE_SUSPENDED()) {
        tmp$ret$2 = get_COROUTINE_SUSPENDED();
        break $l$block_0;
      }
      var state = _this__u8e3s4.nt(result);
      if (state === get_COMPLETING_WAITING_CHILDREN()) {
        tmp$ret$2 = get_COROUTINE_SUSPENDED();
        break $l$block_0;
      }
      var tmp_1;
      if (state instanceof CompletedExceptionally) {
        var tmp_2;
        // Inline function 'kotlinx.coroutines.intrinsics.startUndispatchedOrReturnIgnoreTimeout.<anonymous>' call
        var e_0 = state.kt_1;
        var tmp_3;
        if (e_0 instanceof TimeoutCancellationException) {
          tmp_3 = e_0.x14_1 === _this__u8e3s4;
        } else {
          tmp_3 = false;
        }
        if (!tmp_3) {
          throw recoverStackTrace(state.kt_1, _this__u8e3s4.ow_1);
        } else {
          if (result instanceof CompletedExceptionally) {
            throw recoverStackTrace(result.kt_1, _this__u8e3s4.ow_1);
          } else {
            tmp_2 = result;
          }
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = unboxState(state);
      }
      tmp$ret$2 = tmp_1;
    }
    return tmp$ret$2;
  }
  function startCoroutineUndispatched(_this__u8e3s4, receiver, completion) {
    $l$block: {
      // Inline function 'kotlinx.coroutines.intrinsics.startDirect' call
      // Inline function 'kotlinx.coroutines.internal.probeCoroutineCreated' call
      var actualCompletion = completion;
      var tmp;
      try {
        // Inline function 'kotlinx.coroutines.intrinsics.startCoroutineUndispatched.<anonymous>' call
        // Inline function 'kotlinx.coroutines.withCoroutineContext' call
        completion.ea();
        // Inline function 'kotlinx.coroutines.intrinsics.startCoroutineUndispatched.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
        tmp = startCoroutineUninterceptedOrReturnNonGeneratorVersion(_this__u8e3s4, receiver, actualCompletion);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var tmp$ret$5 = _Result___init__impl__xyqfz8(createFailure(e));
          actualCompletion.ja(tmp$ret$5);
          break $l$block;
        } else {
          throw $p;
        }
      }
      var value = tmp;
      if (!(value === get_COROUTINE_SUSPENDED())) {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value_0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
        var tmp$ret$8 = _Result___init__impl__xyqfz8(value_0);
        actualCompletion.ja(tmp$ret$8);
      }
    }
  }
  function get_DUMMY_PROCESS_RESULT_FUNCTION() {
    _init_properties_Select_kt__zhm2jg();
    return DUMMY_PROCESS_RESULT_FUNCTION;
  }
  var DUMMY_PROCESS_RESULT_FUNCTION;
  function get_STATE_REG() {
    _init_properties_Select_kt__zhm2jg();
    return STATE_REG;
  }
  var STATE_REG;
  function get_STATE_COMPLETED() {
    _init_properties_Select_kt__zhm2jg();
    return STATE_COMPLETED;
  }
  var STATE_COMPLETED;
  function get_STATE_CANCELLED() {
    _init_properties_Select_kt__zhm2jg();
    return STATE_CANCELLED;
  }
  var STATE_CANCELLED;
  function get_NO_RESULT() {
    _init_properties_Select_kt__zhm2jg();
    return NO_RESULT;
  }
  var NO_RESULT;
  function get_PARAM_CLAUSE_0() {
    _init_properties_Select_kt__zhm2jg();
    return PARAM_CLAUSE_0;
  }
  var PARAM_CLAUSE_0;
  function SelectClause0Impl(clauseObject, regFunc, onCancellationConstructor) {
    onCancellationConstructor = onCancellationConstructor === VOID ? null : onCancellationConstructor;
    this.v21_1 = clauseObject;
    this.w21_1 = regFunc;
    this.x21_1 = onCancellationConstructor;
    this.y21_1 = get_DUMMY_PROCESS_RESULT_FUNCTION();
  }
  protoOf(SelectClause0Impl).z21 = function () {
    return this.v21_1;
  };
  protoOf(SelectClause0Impl).a22 = function () {
    return this.w21_1;
  };
  protoOf(SelectClause0Impl).b22 = function () {
    return this.x21_1;
  };
  protoOf(SelectClause0Impl).c22 = function () {
    return this.y21_1;
  };
  function SelectInstance() {
  }
  function $invokeBlockCOROUTINE$42(_this__u8e3s4, argument, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l22_1 = _this__u8e3s4;
    this.m22_1 = argument;
  }
  protoOf($invokeBlockCOROUTINE$42).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.n22_1 = this.l22_1.t22_1;
            if (this.l22_1.s22_1 === get_PARAM_CLAUSE_0()) {
              var tmp_0 = this.n22_1;
              if (!isSuspendFunction(tmp_0, 0))
                THROW_CCE();
              this.y9_1 = 2;
              suspendResult = this.n22_1(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this.n22_1;
              if (!isSuspendFunction(tmp_1, 1))
                THROW_CCE();
              this.y9_1 = 1;
              suspendResult = this.n22_1(this.m22_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.o22_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 2:
            this.o22_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.o22_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function _get_isSelected__uy0hmu($this) {
    var tmp = $this.b19_1.kotlinx$atomicfu$value;
    return tmp instanceof ClauseData;
  }
  function doSelectSuspend($this, $completion) {
    var tmp = new $doSelectSuspendCOROUTINE$39($this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function checkClauseObject($this, clauseObject) {
    var clauses = ensureNotNull($this.c19_1);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp;
      if (isInterface(clauses, Collection)) {
        tmp = clauses.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = clauses.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlinx.coroutines.selects.SelectImplementation.checkClauseObject.<anonymous>' call
        if (element.p22_1 === clauseObject) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    // Inline function 'kotlin.check' call
    if (!tmp$ret$0) {
      // Inline function 'kotlinx.coroutines.selects.SelectImplementation.checkClauseObject.<anonymous>' call
      var message = 'Cannot use select clauses on the same object: ' + toString_1(clauseObject);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function waitUntilSelected($this, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.iy();
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.selects.SelectImplementation.waitUntilSelected.<anonymous>' call
      // Inline function 'kotlinx.atomicfu.loop' call
      var this_0 = $this.b19_1;
      while (true) {
        // Inline function 'kotlinx.coroutines.selects.SelectImplementation.waitUntilSelected.<anonymous>.<anonymous>' call
        var curState = this_0.kotlinx$atomicfu$value;
        if (curState === get_STATE_REG()) {
          if ($this.b19_1.atomicfu$compareAndSet(curState, cancellable)) {
            // Inline function 'kotlinx.coroutines.asHandler' call
            // Inline function 'kotlin.js.asDynamic' call
            cancellable.rw($this);
            break $l$block_0;
          }
        } else {
          if (isInterface(curState, KtList)) {
            if ($this.b19_1.atomicfu$compareAndSet(curState, get_STATE_REG())) {
              if (!isInterface(curState, KtList))
                THROW_CCE();
              // Inline function 'kotlin.collections.forEach' call
              var _iterator__ex2g4s = curState.k();
              while (_iterator__ex2g4s.l()) {
                var element = _iterator__ex2g4s.m();
                // Inline function 'kotlinx.coroutines.selects.SelectImplementation.waitUntilSelected.<anonymous>.<anonymous>.<anonymous>' call
                reregisterClause($this, element);
              }
            }
          } else {
            if (curState instanceof ClauseData) {
              cancellable.tw(Unit_instance, curState.h23($this, $this.f19_1));
              break $l$block_0;
            } else {
              // Inline function 'kotlin.error' call
              var message = 'unexpected state: ' + toString_1(curState);
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }
          }
        }
      }
    }
    return cancellable.py();
  }
  function reregisterClause($this, clauseObject) {
    var clause = ensureNotNull(findClause($this, clauseObject));
    clause.v22_1 = null;
    clause.w22_1 = -1;
    $this.i23(clause, true);
  }
  function trySelectInternal($this, clauseObject, internalResult) {
    $l$loop: while (true) {
      var curState = $this.b19_1.kotlinx$atomicfu$value;
      if (isInterface(curState, CancellableContinuation)) {
        var tmp0_elvis_lhs = findClause($this, clauseObject);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var clause = tmp;
        var onCancellation = clause.h23($this, internalResult);
        if ($this.b19_1.atomicfu$compareAndSet(curState, clause)) {
          var cont = isInterface(curState, CancellableContinuation) ? curState : THROW_CCE();
          $this.f19_1 = internalResult;
          if (tryResume_1(cont, onCancellation))
            return 0;
          $this.f19_1 = null;
          return 2;
        }
      } else {
        var tmp_0;
        if (equals(curState, get_STATE_COMPLETED())) {
          tmp_0 = true;
        } else {
          tmp_0 = curState instanceof ClauseData;
        }
        if (tmp_0)
          return 3;
        else {
          if (equals(curState, get_STATE_CANCELLED()))
            return 2;
          else {
            if (equals(curState, get_STATE_REG())) {
              if ($this.b19_1.atomicfu$compareAndSet(curState, listOf(clauseObject)))
                return 1;
            } else {
              if (isInterface(curState, KtList)) {
                if ($this.b19_1.atomicfu$compareAndSet(curState, plus_3(curState, clauseObject)))
                  return 1;
              } else {
                // Inline function 'kotlin.error' call
                var message = 'Unexpected state: ' + toString_1(curState);
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              }
            }
          }
        }
      }
    }
  }
  function findClause($this, clauseObject) {
    var tmp0_elvis_lhs = $this.c19_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var clauses = tmp;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = clauses.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlinx.coroutines.selects.SelectImplementation.findClause.<anonymous>' call
        if (element.p22_1 === clauseObject) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp1_elvis_lhs = tmp$ret$1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var message = 'Clause with object ' + toString_1(clauseObject) + ' is not found';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  }
  function complete($this, $completion) {
    var tmp = new $completeCOROUTINE$40($this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function processResultAndInvokeBlockRecoveringException($this, clause, internalResult, $completion) {
    var tmp = new $processResultAndInvokeBlockRecoveringExceptionCOROUTINE$41($this, clause, internalResult, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function cleanup($this, selectedClause) {
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp0_elvis_lhs = $this.c19_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var clauses = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = clauses.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'kotlinx.coroutines.selects.SelectImplementation.cleanup.<anonymous>' call
      if (!(element === selectedClause)) {
        element.vr();
      }
    }
    $this.b19_1.kotlinx$atomicfu$value = get_STATE_COMPLETED();
    $this.f19_1 = get_NO_RESULT();
    $this.c19_1 = null;
  }
  function ClauseData($outer, clauseObject, regFunc, processResFunc, param, block, onCancellationConstructor) {
    this.x22_1 = $outer;
    this.p22_1 = clauseObject;
    this.q22_1 = regFunc;
    this.r22_1 = processResFunc;
    this.s22_1 = param;
    this.t22_1 = block;
    this.u22_1 = onCancellationConstructor;
    this.v22_1 = null;
    this.w22_1 = -1;
  }
  protoOf(ClauseData).j24 = function (select) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    this.q22_1(this.p22_1, select, this.s22_1);
    return select.f19_1 === get_NO_RESULT();
  };
  protoOf(ClauseData).k24 = function (result) {
    return this.r22_1(this.p22_1, this.s22_1, result);
  };
  protoOf(ClauseData).l24 = function (argument, $completion) {
    var tmp = new $invokeBlockCOROUTINE$42(this, argument, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ClauseData).vr = function () {
    // Inline function 'kotlin.with' call
    // Inline function 'kotlinx.coroutines.selects.ClauseData.dispose.<anonymous>' call
    var $this$with = this.v22_1;
    var tmp;
    if ($this$with instanceof Segment) {
      $this$with.rx(this.w22_1, null, this.x22_1.ea());
      tmp = Unit_instance;
    } else {
      var tmp0_safe_receiver = (!($this$with == null) ? isInterface($this$with, DisposableHandle) : false) ? $this$with : null;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp0_safe_receiver.vr();
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
  };
  protoOf(ClauseData).h23 = function (select, internalResult) {
    var tmp0_safe_receiver = this.u22_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver(select, this.s22_1, internalResult);
  };
  function $doSelectCOROUTINE$38(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u24_1 = _this__u8e3s4;
  }
  protoOf($doSelectCOROUTINE$38).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            if (_get_isSelected__uy0hmu(this.u24_1)) {
              this.y9_1 = 2;
              suspendResult = complete(this.u24_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = doSelectSuspend(this.u24_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.v24_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 2:
            this.v24_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.v24_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $doSelectSuspendCOROUTINE$39(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g23_1 = _this__u8e3s4;
  }
  protoOf($doSelectSuspendCOROUTINE$39).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = waitUntilSelected(this.g23_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y9_1 = 2;
            suspendResult = complete(this.g23_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $completeCOROUTINE$40(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r23_1 = _this__u8e3s4;
  }
  protoOf($completeCOROUTINE$40).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            var tmp_1 = this.r23_1.b19_1.kotlinx$atomicfu$value;
            tmp_0.s23_1 = tmp_1 instanceof ClauseData ? tmp_1 : THROW_CCE();
            this.t23_1 = this.r23_1.f19_1;
            cleanup(this.r23_1, this.s23_1);
            if (!get_RECOVER_STACK_TRACES()) {
              this.v23_1 = this.s23_1.k24(this.t23_1);
              this.y9_1 = 2;
              suspendResult = this.s23_1.l24(this.v23_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = processResultAndInvokeBlockRecoveringException(this.r23_1, this.s23_1, this.t23_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.u23_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 2:
            this.u23_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.u23_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $processResultAndInvokeBlockRecoveringExceptionCOROUTINE$41(_this__u8e3s4, clause, internalResult, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e24_1 = _this__u8e3s4;
    this.f24_1 = clause;
    this.g24_1 = internalResult;
  }
  protoOf($processResultAndInvokeBlockRecoveringExceptionCOROUTINE$41).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.z9_1 = 2;
            this.i24_1 = this.f24_1.k24(this.g24_1);
            this.y9_1 = 1;
            suspendResult = this.f24_1.l24(this.i24_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.h24_1 = suspendResult;
            this.z9_1 = 3;
            this.y9_1 = 4;
            continue $sm;
          case 2:
            this.z9_1 = 3;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof Error) {
              var e = this.ba_1;
              var tmp_1 = this;
              throw e;
            } else {
              throw this.ba_1;
            }

          case 3:
            throw this.ba_1;
          case 4:
            this.z9_1 = 3;
            return this.h24_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 3) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  function SelectImplementation(context) {
    CancelHandler.call(this);
    this.a19_1 = context;
    this.b19_1 = atomic$ref$1(get_STATE_REG());
    this.c19_1 = ArrayList_init_$Create$_0(2);
    this.d19_1 = null;
    this.e19_1 = -1;
    this.f19_1 = get_NO_RESULT();
  }
  protoOf(SelectImplementation).ea = function () {
    return this.a19_1;
  };
  protoOf(SelectImplementation).w24 = function ($completion) {
    var tmp = new $doSelectCOROUTINE$38(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(SelectImplementation).x24 = function (_this__u8e3s4, block) {
    return this.y24(new ClauseData(this, _this__u8e3s4.z21(), _this__u8e3s4.a22(), _this__u8e3s4.c22(), get_PARAM_CLAUSE_0(), block, _this__u8e3s4.b22()));
  };
  protoOf(SelectImplementation).i23 = function (_this__u8e3s4, reregister) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.selects.SelectImplementation.register.<anonymous>' call
    if (this.b19_1.kotlinx$atomicfu$value instanceof ClauseData)
      return Unit_instance;
    if (!reregister) {
      checkClauseObject(this, _this__u8e3s4.p22_1);
    }
    if (_this__u8e3s4.j24(this)) {
      if (!reregister) {
        // Inline function 'kotlin.collections.plusAssign' call
        ensureNotNull(this.c19_1).e(_this__u8e3s4);
      }
      _this__u8e3s4.v22_1 = this.d19_1;
      _this__u8e3s4.w22_1 = this.e19_1;
      this.d19_1 = null;
      this.e19_1 = -1;
    } else {
      this.b19_1.kotlinx$atomicfu$value = _this__u8e3s4;
    }
  };
  protoOf(SelectImplementation).y24 = function (_this__u8e3s4, reregister, $super) {
    reregister = reregister === VOID ? false : reregister;
    var tmp;
    if ($super === VOID) {
      this.i23(_this__u8e3s4, reregister);
      tmp = Unit_instance;
    } else {
      tmp = $super.i23.call(this, _this__u8e3s4, reregister);
    }
    return tmp;
  };
  protoOf(SelectImplementation).u11 = function (disposableHandle) {
    this.d19_1 = disposableHandle;
  };
  protoOf(SelectImplementation).ty = function (segment, index) {
    this.d19_1 = segment;
    this.e19_1 = index;
  };
  protoOf(SelectImplementation).t11 = function (internalResult) {
    this.f19_1 = internalResult;
  };
  protoOf(SelectImplementation).b12 = function (clauseObject, result) {
    return trySelectInternal(this, clauseObject, result) === 0;
  };
  protoOf(SelectImplementation).g19 = function (clauseObject, result) {
    return TrySelectDetailedResult_0(trySelectInternal(this, clauseObject, result));
  };
  protoOf(SelectImplementation).vw = function (cause) {
    var tmp0 = this.b19_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.selects.SelectImplementation.invoke.<anonymous>' call
        if (cur === get_STATE_COMPLETED())
          return Unit_instance;
        var upd = get_STATE_CANCELLED();
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    var tmp0_elvis_lhs = this.c19_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var clauses = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = clauses.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'kotlinx.coroutines.selects.SelectImplementation.invoke.<anonymous>' call
      element.vr();
    }
    this.f19_1 = get_NO_RESULT();
    this.c19_1 = null;
  };
  protoOf(SelectImplementation).invoke = function (cause) {
    return this.vw(cause);
  };
  var TrySelectDetailedResult_SUCCESSFUL_instance;
  var TrySelectDetailedResult_REREGISTER_instance;
  var TrySelectDetailedResult_CANCELLED_instance;
  var TrySelectDetailedResult_ALREADY_SELECTED_instance;
  var TrySelectDetailedResult_entriesInitialized;
  function TrySelectDetailedResult_initEntries() {
    if (TrySelectDetailedResult_entriesInitialized)
      return Unit_instance;
    TrySelectDetailedResult_entriesInitialized = true;
    TrySelectDetailedResult_SUCCESSFUL_instance = new TrySelectDetailedResult('SUCCESSFUL', 0);
    TrySelectDetailedResult_REREGISTER_instance = new TrySelectDetailedResult('REREGISTER', 1);
    TrySelectDetailedResult_CANCELLED_instance = new TrySelectDetailedResult('CANCELLED', 2);
    TrySelectDetailedResult_ALREADY_SELECTED_instance = new TrySelectDetailedResult('ALREADY_SELECTED', 3);
  }
  function TrySelectDetailedResult(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function TrySelectDetailedResult_0(trySelectInternalResult) {
    _init_properties_Select_kt__zhm2jg();
    var tmp;
    switch (trySelectInternalResult) {
      case 0:
        tmp = TrySelectDetailedResult_SUCCESSFUL_getInstance();
        break;
      case 1:
        tmp = TrySelectDetailedResult_REREGISTER_getInstance();
        break;
      case 2:
        tmp = TrySelectDetailedResult_CANCELLED_getInstance();
        break;
      case 3:
        tmp = TrySelectDetailedResult_ALREADY_SELECTED_getInstance();
        break;
      default:
        var message = 'Unexpected internal result: ' + trySelectInternalResult;
        throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return tmp;
  }
  function tryResume_1(_this__u8e3s4, onCancellation) {
    _init_properties_Select_kt__zhm2jg();
    var tmp0_elvis_lhs = _this__u8e3s4.pw(Unit_instance, null, onCancellation);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var token = tmp;
    _this__u8e3s4.qw(token);
    return true;
  }
  function DUMMY_PROCESS_RESULT_FUNCTION$lambda(_anonymous_parameter_0__qggqh8, _anonymous_parameter_1__qggqgd, _anonymous_parameter_2__qggqfi) {
    _init_properties_Select_kt__zhm2jg();
    return null;
  }
  function TrySelectDetailedResult_SUCCESSFUL_getInstance() {
    TrySelectDetailedResult_initEntries();
    return TrySelectDetailedResult_SUCCESSFUL_instance;
  }
  function TrySelectDetailedResult_REREGISTER_getInstance() {
    TrySelectDetailedResult_initEntries();
    return TrySelectDetailedResult_REREGISTER_instance;
  }
  function TrySelectDetailedResult_CANCELLED_getInstance() {
    TrySelectDetailedResult_initEntries();
    return TrySelectDetailedResult_CANCELLED_instance;
  }
  function TrySelectDetailedResult_ALREADY_SELECTED_getInstance() {
    TrySelectDetailedResult_initEntries();
    return TrySelectDetailedResult_ALREADY_SELECTED_instance;
  }
  var properties_initialized_Select_kt_7rpl36;
  function _init_properties_Select_kt__zhm2jg() {
    if (!properties_initialized_Select_kt_7rpl36) {
      properties_initialized_Select_kt_7rpl36 = true;
      DUMMY_PROCESS_RESULT_FUNCTION = DUMMY_PROCESS_RESULT_FUNCTION$lambda;
      STATE_REG = new Symbol_0('STATE_REG');
      STATE_COMPLETED = new Symbol_0('STATE_COMPLETED');
      STATE_CANCELLED = new Symbol_0('STATE_CANCELLED');
      NO_RESULT = new Symbol_0('NO_RESULT');
      PARAM_CLAUSE_0 = new Symbol_0('PARAM_CLAUSE_0');
    }
  }
  function CompletionHandlerBase() {
    LinkedListNode.call(this);
  }
  function invokeIt(_this__u8e3s4, cause) {
    if (typeof _this__u8e3s4 === 'function')
      _this__u8e3s4(cause);
    else {
      // Inline function 'kotlin.js.asDynamic' call
      _this__u8e3s4.invoke(cause);
    }
  }
  function CancelHandlerBase() {
  }
  function toDebugString(_this__u8e3s4) {
    return toString_1(_this__u8e3s4);
  }
  function get_DefaultDelay() {
    var tmp = Dispatchers_getInstance().p14_1;
    return isInterface(tmp, Delay) ? tmp : THROW_CCE();
  }
  function createDefaultDispatcher() {
    var tmp;
    if (isJsdom()) {
      tmp = NodeDispatcher_getInstance();
    } else {
      var tmp_0;
      var tmp_1;
      if (!(typeof window === 'undefined')) {
        // Inline function 'kotlin.js.asDynamic' call
        tmp_1 = window != null;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = !(typeof window.addEventListener === 'undefined');
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = asCoroutineDispatcher(window);
      } else {
        if (typeof process === 'undefined' || typeof process.nextTick === 'undefined') {
          tmp = SetTimeoutDispatcher_getInstance();
        } else {
          tmp = NodeDispatcher_getInstance();
        }
      }
    }
    return tmp;
  }
  function isJsdom() {
    return !(typeof navigator === 'undefined') && navigator != null && navigator.userAgent != null && !(typeof navigator.userAgent === 'undefined') && !(typeof navigator.userAgent.match === 'undefined') && navigator.userAgent.match('\\bjsdom\\b');
  }
  function newCoroutineContext(_this__u8e3s4, context) {
    var combined = _this__u8e3s4.et().ej(context);
    return !(combined === Dispatchers_getInstance().p14_1) && combined.la(Key_instance) == null ? combined.ej(Dispatchers_getInstance().p14_1) : combined;
  }
  function newCoroutineContext_0(_this__u8e3s4, addedContext) {
    return _this__u8e3s4.ej(addedContext);
  }
  function UndispatchedCoroutine(context, uCont) {
    ScopeCoroutine.call(this, context, uCont);
  }
  protoOf(UndispatchedCoroutine).ot = function (state) {
    return this.ow_1.ja(recoverResult(state, this.ow_1));
  };
  function get_coroutineName(_this__u8e3s4) {
    return null;
  }
  var counter;
  function get_DEBUG() {
    return DEBUG;
  }
  var DEBUG;
  function get_classSimpleName(_this__u8e3s4) {
    var tmp0_elvis_lhs = getKClassFromExpression(_this__u8e3s4).lb();
    return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
  }
  function get_hexAddress(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var result = _this__u8e3s4.__debug_counter;
    if (!(typeof result === 'number')) {
      counter = counter + 1 | 0;
      result = counter;
      // Inline function 'kotlin.js.asDynamic' call
      _this__u8e3s4.__debug_counter = result;
    }
    return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
  }
  function Dispatchers() {
    Dispatchers_instance = this;
    this.p14_1 = createDefaultDispatcher();
    this.q14_1 = Unconfined_getInstance();
    this.r14_1 = new JsMainDispatcher(this.p14_1, false);
    this.s14_1 = null;
  }
  protoOf(Dispatchers).t14 = function () {
    var tmp0_elvis_lhs = this.s14_1;
    return tmp0_elvis_lhs == null ? this.r14_1 : tmp0_elvis_lhs;
  };
  var Dispatchers_instance;
  function Dispatchers_getInstance() {
    if (Dispatchers_instance == null)
      new Dispatchers();
    return Dispatchers_instance;
  }
  function JsMainDispatcher(delegate, invokeImmediately) {
    MainCoroutineDispatcher.call(this);
    this.e25_1 = delegate;
    this.f25_1 = invokeImmediately;
    this.g25_1 = this.f25_1 ? this : new JsMainDispatcher(this.e25_1, true);
  }
  protoOf(JsMainDispatcher).n14 = function () {
    return this.g25_1;
  };
  protoOf(JsMainDispatcher).sz = function (context) {
    return !this.f25_1;
  };
  protoOf(JsMainDispatcher).tz = function (context, block) {
    return this.e25_1.tz(context, block);
  };
  protoOf(JsMainDispatcher).uz = function (context, block) {
    return this.e25_1.uz(context, block);
  };
  protoOf(JsMainDispatcher).toString = function () {
    var tmp0_elvis_lhs = this.o14();
    return tmp0_elvis_lhs == null ? this.e25_1.toString() : tmp0_elvis_lhs;
  };
  function createEventLoop() {
    return new UnconfinedEventLoop();
  }
  function UnconfinedEventLoop() {
    EventLoop.call(this);
  }
  protoOf(UnconfinedEventLoop).tz = function (context, block) {
    unsupported();
  };
  function unsupported() {
    throw UnsupportedOperationException_init_$Create$_0('runBlocking event loop is not supported');
  }
  function get_RECOVER_STACK_TRACES() {
    return RECOVER_STACK_TRACES;
  }
  var RECOVER_STACK_TRACES;
  function JobCancellationException(message, cause, job) {
    CancellationException_init_$Init$_1(message, cause, this);
    captureStack(this, JobCancellationException);
    this.l25_1 = job;
  }
  protoOf(JobCancellationException).toString = function () {
    return protoOf(CancellationException).toString.call(this) + '; job=' + toString_1(this.l25_1);
  };
  protoOf(JobCancellationException).equals = function (other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof JobCancellationException) {
        tmp_2 = other.message == this.message;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(other.l25_1, this.l25_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(other.cause, this.cause);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(JobCancellationException).hashCode = function () {
    var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this.l25_1) | 0, 31);
    var tmp0_safe_receiver = this.cause;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  };
  function NodeDispatcher() {
    NodeDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  protoOf(NodeDispatcher).o25 = function () {
    process.nextTick(this.v25_1.s25_1);
  };
  var NodeDispatcher_instance;
  function NodeDispatcher_getInstance() {
    if (NodeDispatcher_instance == null)
      new NodeDispatcher();
    return NodeDispatcher_instance;
  }
  function SetTimeoutDispatcher() {
    SetTimeoutDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  protoOf(SetTimeoutDispatcher).o25 = function () {
    setTimeout(this.v25_1.s25_1, 0);
  };
  var SetTimeoutDispatcher_instance;
  function SetTimeoutDispatcher_getInstance() {
    if (SetTimeoutDispatcher_instance == null)
      new SetTimeoutDispatcher();
    return SetTimeoutDispatcher_instance;
  }
  function SetTimeoutBasedDispatcher$ScheduledMessageQueue$processQueue$lambda(this$0) {
    return function () {
      this$0.b26();
      return Unit_instance;
    };
  }
  function ScheduledMessageQueue($outer) {
    this.t25_1 = $outer;
    MessageQueue.call(this);
    var tmp = this;
    tmp.s25_1 = SetTimeoutBasedDispatcher$ScheduledMessageQueue$processQueue$lambda(this);
  }
  protoOf(ScheduledMessageQueue).c26 = function () {
    this.t25_1.o25();
  };
  protoOf(ScheduledMessageQueue).d26 = function () {
    setTimeout(this.s25_1, 0);
  };
  function SetTimeoutBasedDispatcher$invokeOnTimeout$lambda($block) {
    return function () {
      $block.wy();
      return Unit_instance;
    };
  }
  function SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
    return function () {
      // Inline function 'kotlin.with' call
      // Inline function 'kotlinx.coroutines.SetTimeoutBasedDispatcher.scheduleResumeAfterDelay.<anonymous>.<anonymous>' call
      $continuation.sw(this$0, Unit_instance);
      return Unit_instance;
    };
  }
  function SetTimeoutBasedDispatcher() {
    CoroutineDispatcher.call(this);
    this.v25_1 = new ScheduledMessageQueue(this);
  }
  protoOf(SetTimeoutBasedDispatcher).tz = function (context, block) {
    this.v25_1.q26(block);
  };
  protoOf(SetTimeoutBasedDispatcher).a10 = function (timeMillis, block, context) {
    var handle = setTimeout(SetTimeoutBasedDispatcher$invokeOnTimeout$lambda(block), delayToInt(timeMillis));
    return new ClearTimeout(handle);
  };
  protoOf(SetTimeoutBasedDispatcher).zz = function (timeMillis, continuation) {
    var handle = setTimeout(SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new ClearTimeout(handle);
    continuation.rw(tmp$ret$1);
  };
  function MessageQueue() {
    this.y25_1 = ArrayDeque_init_$Create$();
    this.z25_1 = 16;
    this.a26_1 = false;
  }
  protoOf(MessageQueue).n = function () {
    return this.y25_1.yf_1;
  };
  protoOf(MessageQueue).e26 = function (index, element) {
    this.y25_1.p2(index, element);
  };
  protoOf(MessageQueue).p2 = function (index, element) {
    return this.e26(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).f26 = function (element) {
    return this.y25_1.e(element);
  };
  protoOf(MessageQueue).e = function (element) {
    return this.f26((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).g26 = function (index, elements) {
    return this.y25_1.n2(index, elements);
  };
  protoOf(MessageQueue).n2 = function (index, elements) {
    return this.g26(index, elements);
  };
  protoOf(MessageQueue).h26 = function (elements) {
    return this.y25_1.o(elements);
  };
  protoOf(MessageQueue).o = function (elements) {
    return this.h26(elements);
  };
  protoOf(MessageQueue).m2 = function () {
    this.y25_1.m2();
  };
  protoOf(MessageQueue).i26 = function (element) {
    return this.y25_1.s(element);
  };
  protoOf(MessageQueue).s = function (element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return false;
    return this.i26((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).j26 = function (elements) {
    return this.y25_1.h2(elements);
  };
  protoOf(MessageQueue).h2 = function (elements) {
    return this.j26(elements);
  };
  protoOf(MessageQueue).q = function (index) {
    return this.y25_1.q(index);
  };
  protoOf(MessageQueue).k26 = function (element) {
    return this.y25_1.t(element);
  };
  protoOf(MessageQueue).t = function (element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return -1;
    return this.k26((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).p = function () {
    return this.y25_1.p();
  };
  protoOf(MessageQueue).k = function () {
    return this.y25_1.k();
  };
  protoOf(MessageQueue).l26 = function (element) {
    return this.y25_1.u(element);
  };
  protoOf(MessageQueue).u = function (element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return -1;
    return this.l26((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).i2 = function () {
    return this.y25_1.i2();
  };
  protoOf(MessageQueue).r = function (index) {
    return this.y25_1.r(index);
  };
  protoOf(MessageQueue).m26 = function (element) {
    return this.y25_1.k2(element);
  };
  protoOf(MessageQueue).k2 = function (element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return false;
    return this.m26((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).n26 = function (elements) {
    return this.y25_1.k1(elements);
  };
  protoOf(MessageQueue).k1 = function (elements) {
    return this.n26(elements);
  };
  protoOf(MessageQueue).q2 = function (index) {
    return this.y25_1.q2(index);
  };
  protoOf(MessageQueue).o26 = function (elements) {
    return this.y25_1.l2(elements);
  };
  protoOf(MessageQueue).l2 = function (elements) {
    return this.o26(elements);
  };
  protoOf(MessageQueue).p26 = function (index, element) {
    return this.y25_1.o2(index, element);
  };
  protoOf(MessageQueue).o2 = function (index, element) {
    return this.p26(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).j2 = function (fromIndex, toIndex) {
    return this.y25_1.j2(fromIndex, toIndex);
  };
  protoOf(MessageQueue).q26 = function (element) {
    this.f26(element);
    if (!this.a26_1) {
      this.a26_1 = true;
      this.c26();
    }
  };
  protoOf(MessageQueue).b26 = function () {
    try {
      // Inline function 'kotlin.repeat' call
      var times = this.z25_1;
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.coroutines.MessageQueue.process.<anonymous>' call
          var tmp0_elvis_lhs = removeFirstOrNull(this);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var element = tmp;
          element.wy();
        }
         while (inductionVariable < times);
    }finally {
      if (this.p()) {
        this.a26_1 = false;
      } else {
        this.d26();
      }
    }
  };
  function delayToInt(timeMillis) {
    return coerceIn(timeMillis, new Long(0, 0), new Long(2147483647, 0)).z3();
  }
  function ClearTimeout(handle) {
    CancelHandler.call(this);
    this.r26_1 = handle;
  }
  protoOf(ClearTimeout).vr = function () {
    clearTimeout(this.r26_1);
  };
  protoOf(ClearTimeout).vw = function (cause) {
    this.vr();
  };
  protoOf(ClearTimeout).invoke = function (cause) {
    return this.vw(cause);
  };
  protoOf(ClearTimeout).toString = function () {
    return 'ClearTimeout[' + this.r26_1 + ']';
  };
  function WindowClearTimeout($outer, handle) {
    this.t26_1 = $outer;
    ClearTimeout.call(this, handle);
  }
  protoOf(WindowClearTimeout).vr = function () {
    this.t26_1.v26_1.clearTimeout(this.r26_1);
  };
  function WindowDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
    return function () {
      // Inline function 'kotlin.with' call
      // Inline function 'kotlinx.coroutines.WindowDispatcher.scheduleResumeAfterDelay.<anonymous>.<anonymous>' call
      $continuation.sw(this$0, Unit_instance);
      return Unit_instance;
    };
  }
  function WindowDispatcher$invokeOnTimeout$lambda($block) {
    return function () {
      $block.wy();
      return Unit_instance;
    };
  }
  function WindowDispatcher(window_0) {
    CoroutineDispatcher.call(this);
    this.v26_1 = window_0;
    this.w26_1 = new WindowMessageQueue(this.v26_1);
  }
  protoOf(WindowDispatcher).tz = function (context, block) {
    return this.w26_1.q26(block);
  };
  protoOf(WindowDispatcher).zz = function (timeMillis, continuation) {
    var handle = this.v26_1.setTimeout(WindowDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
    // Inline function 'kotlinx.coroutines.asHandler' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = new WindowClearTimeout(this, handle);
    continuation.rw(tmp$ret$1);
  };
  protoOf(WindowDispatcher).a10 = function (timeMillis, block, context) {
    var handle = this.v26_1.setTimeout(WindowDispatcher$invokeOnTimeout$lambda(block), delayToInt(timeMillis));
    return new WindowClearTimeout(this, handle);
  };
  function WindowMessageQueue$lambda(this$0) {
    return function (event) {
      var tmp;
      if (event.source == this$0.a27_1 && event.data == this$0.b27_1) {
        event.stopPropagation();
        this$0.b26();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function WindowMessageQueue$schedule$lambda(this$0) {
    return function (it) {
      this$0.b26();
      return Unit_instance;
    };
  }
  function WindowMessageQueue(window_0) {
    MessageQueue.call(this);
    this.a27_1 = window_0;
    this.b27_1 = 'dispatchCoroutine';
    this.a27_1.addEventListener('message', WindowMessageQueue$lambda(this), true);
  }
  protoOf(WindowMessageQueue).c26 = function () {
    var tmp = Promise.resolve(Unit_instance);
    tmp.then(WindowMessageQueue$schedule$lambda(this));
  };
  protoOf(WindowMessageQueue).d26 = function () {
    this.a27_1.postMessage(this.b27_1, '*');
  };
  function promise(_this__u8e3s4, context, start, block) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
    return asPromise(async(_this__u8e3s4, context, start, block));
  }
  function asPromise(_this__u8e3s4) {
    var promise = new Promise(asPromise$lambda(_this__u8e3s4));
    // Inline function 'kotlin.js.asDynamic' call
    promise.deferred = _this__u8e3s4;
    return promise;
  }
  function await_0(_this__u8e3s4, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.iy();
    // Inline function 'kotlinx.coroutines.await.<anonymous>' call
    var tmp = await$lambda(cancellable);
    _this__u8e3s4.then(tmp, await$lambda_0(cancellable));
    return cancellable.py();
  }
  function asPromise$lambda$lambda($this_asPromise, $reject, $resolve) {
    return function (it) {
      var e = $this_asPromise.cv();
      var tmp;
      if (!(e == null)) {
        tmp = $reject(e);
      } else {
        tmp = $resolve($this_asPromise.fw());
      }
      return Unit_instance;
    };
  }
  function asPromise$lambda($this_asPromise) {
    return function (resolve, reject) {
      $this_asPromise.hu(asPromise$lambda$lambda($this_asPromise, reject, resolve));
      return Unit_instance;
    };
  }
  function await$lambda($cont) {
    return function (it) {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = $cont;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
      this_0.ja(tmp$ret$0);
      return Unit_instance;
    };
  }
  function await$lambda_0($cont) {
    return function (it) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $cont;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(it));
      this_0.ja(tmp$ret$0);
      return Unit_instance;
    };
  }
  function Runnable() {
  }
  function SchedulerTask() {
  }
  function get_taskContext(_this__u8e3s4) {
    return Unit_instance;
  }
  function asCoroutineDispatcher(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = _this__u8e3s4.coroutineDispatcher;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new WindowDispatcher(_this__u8e3s4);
      // Inline function 'kotlinx.coroutines.asCoroutineDispatcher.<anonymous>' call
      // Inline function 'kotlin.js.asDynamic' call
      _this__u8e3s4.coroutineDispatcher = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function AbortFlowException(owner) {
    CancellationException_init_$Init$_0('Flow was aborted, no more elements needed', this);
    captureStack(this, AbortFlowException);
    this.h1n_1 = owner;
  }
  function ChildCancelledException() {
    CancellationException_init_$Init$_0('Child of the scoped flow was cancelled', this);
    captureStack(this, ChildCancelledException);
  }
  function SafeCollector$collectContextSize$lambda(count, _anonymous_parameter_1__qggqgd) {
    return count + 1 | 0;
  }
  function SafeCollector(collector, collectContext) {
    this.p1h_1 = collector;
    this.q1h_1 = collectContext;
    var tmp = this;
    tmp.r1h_1 = this.q1h_1.dj(0, SafeCollector$collectContextSize$lambda);
    this.s1h_1 = null;
  }
  protoOf(SafeCollector).d1f = function (value, $completion) {
    // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
    // Inline function 'kotlin.js.getCoroutineContext' call
    var currentContext = $completion.ea();
    ensureActive(currentContext);
    if (!(this.s1h_1 === currentContext)) {
      checkContext(this, currentContext);
      this.s1h_1 = currentContext;
    }
    return this.p1h_1.d1f(value, $completion);
  };
  protoOf(SafeCollector).ia = function () {
  };
  function identitySet(expectedSize) {
    return HashSet_init_$Create$_1(expectedSize);
  }
  function get_platformExceptionHandlers_() {
    _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
    return platformExceptionHandlers_;
  }
  var platformExceptionHandlers_;
  function get_platformExceptionHandlers() {
    _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
    return get_platformExceptionHandlers_();
  }
  function propagateExceptionFinalResort(exception) {
    _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
    console.error(exception);
  }
  function DiagnosticCoroutineContextException(context) {
    RuntimeException_init_$Init$_0(toString_1(context), this);
    captureStack(this, DiagnosticCoroutineContextException);
  }
  var properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx;
  function _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf() {
    if (!properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx) {
      properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx = true;
      // Inline function 'kotlin.collections.mutableSetOf' call
      platformExceptionHandlers_ = LinkedHashSet_init_$Create$();
    }
  }
  function LinkedListHead() {
    LinkedListNode.call(this);
  }
  protoOf(LinkedListHead).d11 = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  function LinkedListNode() {
    this.x10_1 = this;
    this.y10_1 = this;
    this.z10_1 = false;
  }
  protoOf(LinkedListNode).e11 = function (node) {
    var prev = this.y10_1;
    node.x10_1 = this;
    node.y10_1 = prev;
    prev.x10_1 = node;
    this.y10_1 = node;
  };
  protoOf(LinkedListNode).d11 = function () {
    return this.f11();
  };
  protoOf(LinkedListNode).vr = function () {
    this.d11();
  };
  protoOf(LinkedListNode).f11 = function () {
    if (this.z10_1)
      return false;
    var prev = this.y10_1;
    var next = this.x10_1;
    prev.x10_1 = next;
    next.y10_1 = prev;
    this.z10_1 = true;
    return true;
  };
  protoOf(LinkedListNode).l11 = function (node) {
    if (!(this.x10_1 === this))
      return false;
    this.e11(node);
    return true;
  };
  function unwrap(exception) {
    return exception;
  }
  function recoverStackTrace(exception, continuation) {
    return exception;
  }
  function recoverStackTrace_0(exception) {
    return exception;
  }
  function systemProp_1(propertyName) {
    return null;
  }
  function threadContextElements(context) {
    return 0;
  }
  function CommonThreadLocal() {
    this.p10_1 = null;
  }
  protoOf(CommonThreadLocal).qr = function () {
    var tmp = this.p10_1;
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(CommonThreadLocal).q10 = function (value) {
    this.p10_1 = value;
  };
  function commonThreadLocal(name) {
    return new CommonThreadLocal();
  }
  function CollectionAdapter() {
  }
  protoOf(CollectionAdapter).c27 = function (event) {
  };
  protoOf(CollectionAdapter).d27 = function (event) {
    var index = event.g27_1;
    var removeEvent = new CollectionItemEvent(event.i27(), null, index, EventType_REMOVE_getInstance());
    this.j27(removeEvent);
    var addEvent = new CollectionItemEvent(null, event.k27(), index, EventType_ADD_getInstance());
    this.c27(addEvent);
  };
  protoOf(CollectionAdapter).j27 = function (event) {
  };
  function CollectionIndexOutOfBoundsException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    CollectionIndexOutOfBoundsException.call($this);
    return $this;
  }
  function CollectionIndexOutOfBoundsException_init_$Create$() {
    var tmp = CollectionIndexOutOfBoundsException_init_$Init$(objectCreate(protoOf(CollectionIndexOutOfBoundsException)));
    captureStack(tmp, CollectionIndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function CollectionIndexOutOfBoundsException_init_$Init$_0(index, $this) {
    RuntimeException_init_$Init$_0(index.toString(), $this);
    CollectionIndexOutOfBoundsException.call($this);
    return $this;
  }
  function CollectionIndexOutOfBoundsException_init_$Create$_0(index) {
    var tmp = CollectionIndexOutOfBoundsException_init_$Init$_0(index, objectCreate(protoOf(CollectionIndexOutOfBoundsException)));
    captureStack(tmp, CollectionIndexOutOfBoundsException_init_$Create$_0);
    return tmp;
  }
  function CollectionIndexOutOfBoundsException_init_$Init$_1(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    CollectionIndexOutOfBoundsException.call($this);
    return $this;
  }
  function CollectionIndexOutOfBoundsException_init_$Create$_1(message) {
    var tmp = CollectionIndexOutOfBoundsException_init_$Init$_1(message, objectCreate(protoOf(CollectionIndexOutOfBoundsException)));
    captureStack(tmp, CollectionIndexOutOfBoundsException_init_$Create$_1);
    return tmp;
  }
  function CollectionIndexOutOfBoundsException() {
    captureStack(this, CollectionIndexOutOfBoundsException);
  }
  var EventType_ADD_instance;
  var EventType_SET_instance;
  var EventType_REMOVE_instance;
  var EventType_entriesInitialized;
  function EventType_initEntries() {
    if (EventType_entriesInitialized)
      return Unit_instance;
    EventType_entriesInitialized = true;
    EventType_ADD_instance = new EventType('ADD', 0);
    EventType_SET_instance = new EventType('SET', 1);
    EventType_REMOVE_instance = new EventType('REMOVE', 2);
  }
  function EventType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function EventType_ADD_getInstance() {
    EventType_initEntries();
    return EventType_ADD_instance;
  }
  function EventType_SET_getInstance() {
    EventType_initEntries();
    return EventType_SET_instance;
  }
  function EventType_REMOVE_getInstance() {
    EventType_initEntries();
    return EventType_REMOVE_instance;
  }
  function CollectionItemEvent(_oldItem, _newItem, index, type) {
    this.e27_1 = _oldItem;
    this.f27_1 = _newItem;
    this.g27_1 = index;
    this.h27_1 = type;
    // Inline function 'kotlin.check' call
    if (!((!this.h27_1.equals(EventType_ADD_getInstance()) || this.e27_1 == null) && (!this.h27_1.equals(EventType_REMOVE_getInstance()) || this.f27_1 == null))) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
  }
  protoOf(CollectionItemEvent).i27 = function () {
    if (this.h27_1.equals(EventType_ADD_getInstance())) {
      throw UnsupportedOperationException_init_$Create$_0("There's no oldItem on add event");
    }
    return ensureNotNull(this.e27_1);
  };
  protoOf(CollectionItemEvent).k27 = function () {
    if (this.h27_1.equals(EventType_REMOVE_getInstance())) {
      throw UnsupportedOperationException_init_$Create$_0("There's no newItem on remove event");
    }
    return ensureNotNull(this.f27_1);
  };
  protoOf(CollectionItemEvent).l27 = function (listener) {
    var tmp;
    switch (this.h27_1.a3_1) {
      case 0:
        listener.c27(this);
        tmp = Unit_instance;
        break;
      case 1:
        listener.d27(this);
        tmp = Unit_instance;
        break;
      default:
        listener.j27(this);
        tmp = Unit_instance;
        break;
    }
    return tmp;
  };
  protoOf(CollectionItemEvent).m27 = function (listener) {
    return this.l27((!(listener == null) ? isInterface(listener, CollectionListener) : false) ? listener : THROW_CCE());
  };
  protoOf(CollectionItemEvent).toString = function () {
    switch (this.h27_1.a3_1) {
      case 0:
        return toString_0(this.f27_1) + ' added at ' + this.g27_1;
      case 1:
        return toString_0(this.e27_1) + ' replaced with ' + toString_0(this.f27_1) + ' at ' + this.g27_1;
      default:
        return toString_0(this.e27_1) + ' removed at ' + this.g27_1;
    }
  };
  protoOf(CollectionItemEvent).hashCode = function () {
    var result = this.e27_1 == null ? 0 : hashCode(this.e27_1);
    result = imul(result, 31) + (this.f27_1 == null ? 0 : hashCode(this.f27_1)) | 0;
    result = imul(result, 31) + this.g27_1 | 0;
    result = imul(result, 31) + this.h27_1.hashCode() | 0;
    return result;
  };
  protoOf(CollectionItemEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CollectionItemEvent))
      return false;
    var tmp0_other_with_cast = other instanceof CollectionItemEvent ? other : THROW_CCE();
    if (!equals(this.e27_1, tmp0_other_with_cast.e27_1))
      return false;
    if (!equals(this.f27_1, tmp0_other_with_cast.f27_1))
      return false;
    if (!(this.g27_1 === tmp0_other_with_cast.g27_1))
      return false;
    if (!this.h27_1.equals(tmp0_other_with_cast.h27_1))
      return false;
    return true;
  };
  function CollectionListener() {
  }
  function MutableObservableCollection() {
  }
  function CollectionListeners($outer) {
    this.r27_1 = $outer;
    Listeners.call(this);
  }
  protoOf(CollectionListeners).s27 = function () {
    return this.r27_1.v27();
  };
  protoOf(CollectionListeners).w27 = function () {
    this.r27_1.u27_1 = null;
    this.r27_1.x27();
  };
  function AbstractObservableList$add$lambda($event) {
    return function (listener) {
      listener.c27($event);
      return Unit_instance;
    };
  }
  function AbstractObservableList$set$lambda($event) {
    return function (listener) {
      listener.d27($event);
      return Unit_instance;
    };
  }
  function AbstractObservableList$removeAt$lambda($event) {
    return function (listener) {
      listener.j27($event);
      return Unit_instance;
    };
  }
  function AbstractObservableList$addHandler$listener$1($handler) {
    this.c28_1 = $handler;
  }
  protoOf(AbstractObservableList$addHandler$listener$1).c27 = function (event) {
    return this.c28_1.d28(event);
  };
  protoOf(AbstractObservableList$addHandler$listener$1).d27 = function (event) {
    return this.c28_1.d28(event);
  };
  protoOf(AbstractObservableList$addHandler$listener$1).j27 = function (event) {
    return this.c28_1.d28(event);
  };
  function AbstractObservableList() {
    AbstractMutableList.call(this);
    this.u27_1 = null;
  }
  protoOf(AbstractObservableList).e28 = function (index, item) {
    if (index < 0 || index > this.n()) {
      throw CollectionIndexOutOfBoundsException_init_$Create$_1('Add: index=' + index + ', size=' + this.n());
    }
  };
  protoOf(AbstractObservableList).f28 = function (index, oldItem, newItem) {
    if (index < 0 || index >= this.n()) {
      throw CollectionIndexOutOfBoundsException_init_$Create$_1('Set: index=' + index + ', size=' + this.n());
    }
  };
  protoOf(AbstractObservableList).g28 = function (index, item) {
    if (index < 0 || index >= this.n()) {
      throw CollectionIndexOutOfBoundsException_init_$Create$_1('Remove: index=' + index + ', size=' + this.n());
    }
  };
  protoOf(AbstractObservableList).h28 = function (index, element) {
    this.e28(index, element);
    this.i28(index, element);
    var success = false;
    try {
      this.j28(index, element);
      success = true;
      this.k28(index, element);
      var listeners = this.u27_1;
      if (!(listeners == null)) {
        var event = new CollectionItemEvent(null, element, index, EventType_ADD_getInstance());
        listeners.a28(AbstractObservableList$add$lambda(event));
      }
    }finally {
      this.l28(index, element, success);
    }
  };
  protoOf(AbstractObservableList).p2 = function (index, element) {
    return this.h28(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractObservableList).i28 = function (index, item) {
  };
  protoOf(AbstractObservableList).k28 = function (index, item) {
  };
  protoOf(AbstractObservableList).l28 = function (index, item, success) {
  };
  protoOf(AbstractObservableList).m28 = function (index, element) {
    var old = this.q(index);
    this.f28(index, old, element);
    this.n28(index, old, element);
    var success = false;
    try {
      this.o28(index, element);
      success = true;
      this.p28(index, old, element);
      var listeners = this.u27_1;
      if (!(listeners == null)) {
        var event = new CollectionItemEvent(old, element, index, EventType_SET_getInstance());
        listeners.a28(AbstractObservableList$set$lambda(event));
      }
    }finally {
      this.q28(index, old, element, success);
    }
    return old;
  };
  protoOf(AbstractObservableList).o2 = function (index, element) {
    return this.m28(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractObservableList).o28 = function (index, item) {
    this.r28(index);
    this.j28(index, item);
  };
  protoOf(AbstractObservableList).n28 = function (index, oldItem, newItem) {
  };
  protoOf(AbstractObservableList).p28 = function (index, oldItem, newItem) {
  };
  protoOf(AbstractObservableList).q28 = function (index, oldItem, newItem, success) {
  };
  protoOf(AbstractObservableList).q2 = function (index) {
    var item = this.q(index);
    this.g28(index, item);
    this.s28(index, item);
    var success = false;
    try {
      this.r28(index);
      success = true;
      this.t28(index, item);
      var listeners = this.u27_1;
      if (!(listeners == null)) {
        var event = new CollectionItemEvent(item, null, index, EventType_REMOVE_getInstance());
        listeners.a28(AbstractObservableList$removeAt$lambda(event));
      }
    }finally {
      this.u28(index, item, success);
    }
    return item;
  };
  protoOf(AbstractObservableList).s28 = function (index, item) {
  };
  protoOf(AbstractObservableList).t28 = function (index, item) {
  };
  protoOf(AbstractObservableList).u28 = function (index, item, success) {
  };
  protoOf(AbstractObservableList).n27 = function (listener) {
    var listeners = this.u27_1;
    if (listeners == null) {
      listeners = new CollectionListeners(this);
      this.u27_1 = listeners;
    }
    return listeners.z27(listener);
  };
  protoOf(AbstractObservableList).v28 = function (handler) {
    var listener = new AbstractObservableList$addHandler$listener$1(handler);
    return this.n27(listener);
  };
  protoOf(AbstractObservableList).o27 = function (handler) {
    return this.v28(handler);
  };
  protoOf(AbstractObservableList).v27 = function () {
  };
  protoOf(AbstractObservableList).x27 = function () {
  };
  function Companion_28() {
  }
  protoOf(Companion_28).w28 = function (list) {
    return new ConstantObservableListAdapter(toList_0(list));
  };
  var Companion_instance_28;
  function Companion_getInstance_28() {
    return Companion_instance_28;
  }
  function ConstantObservableListAdapter(delegate) {
    this.x28_1 = delegate;
  }
  protoOf(ConstantObservableListAdapter).n27 = function (listener) {
    return Companion_getInstance_25().wr_1;
  };
  protoOf(ConstantObservableListAdapter).v28 = function (handler) {
    return Companion_getInstance_25().wr_1;
  };
  protoOf(ConstantObservableListAdapter).o27 = function (handler) {
    return this.v28(handler);
  };
  protoOf(ConstantObservableListAdapter).p = function () {
    return this.x28_1.p();
  };
  protoOf(ConstantObservableListAdapter).y28 = function (element) {
    return this.x28_1.s(element);
  };
  protoOf(ConstantObservableListAdapter).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.y28((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ConstantObservableListAdapter).k = function () {
    return this.x28_1.k();
  };
  protoOf(ConstantObservableListAdapter).z28 = function (elements) {
    return this.x28_1.h2(elements);
  };
  protoOf(ConstantObservableListAdapter).h2 = function (elements) {
    return this.z28(elements);
  };
  protoOf(ConstantObservableListAdapter).q = function (index) {
    return this.x28_1.q(index);
  };
  protoOf(ConstantObservableListAdapter).a29 = function (element) {
    return this.x28_1.t(element);
  };
  protoOf(ConstantObservableListAdapter).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return -1;
    return this.a29((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ConstantObservableListAdapter).b29 = function (element) {
    return this.x28_1.u(element);
  };
  protoOf(ConstantObservableListAdapter).u = function (element) {
    if (!(element == null ? true : !(element == null)))
      return -1;
    return this.b29((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ConstantObservableListAdapter).i2 = function () {
    return this.x28_1.i2();
  };
  protoOf(ConstantObservableListAdapter).r = function (index) {
    return this.x28_1.r(index);
  };
  protoOf(ConstantObservableListAdapter).j2 = function (fromIndex, toIndex) {
    return this.x28_1.j2(fromIndex, toIndex);
  };
  protoOf(ConstantObservableListAdapter).asJsReadonlyArrayView = function () {
    return this.x28_1.asJsReadonlyArrayView();
  };
  protoOf(ConstantObservableListAdapter).n = function () {
    return this.x28_1.n();
  };
  function MutableObservableList() {
  }
  function ensureContainerInitialized($this) {
    if ($this.e29_1 == null) {
      $this.e29_1 = ArrayList_init_$Create$_0(1);
    }
  }
  function ObservableArrayList() {
    AbstractObservableList.call(this);
    this.e29_1 = null;
  }
  protoOf(ObservableArrayList).n = function () {
    var tmp0_safe_receiver = this.e29_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ObservableArrayList).q = function (index) {
    var tmp0_elvis_lhs = this.e29_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw CollectionIndexOutOfBoundsException_init_$Create$_0(index);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var container = tmp;
    return container.q(index);
  };
  protoOf(ObservableArrayList).j28 = function (index, item) {
    ensureContainerInitialized(this);
    ensureNotNull(this.e29_1).p2(index, item);
  };
  protoOf(ObservableArrayList).o28 = function (index, item) {
    ensureNotNull(this.e29_1).o2(index, item);
  };
  protoOf(ObservableArrayList).r28 = function (index) {
    var container = ensureNotNull(this.e29_1);
    container.q2(index);
    if (container.p()) {
      this.e29_1 = null;
    }
  };
  function ObservableList() {
  }
  function doBeforeAdd($this, item) {
    $this.g29(item);
    $this.h29(item);
  }
  function doAfterAdd($this, item, success) {
    try {
      if (success && !($this.f29_1 == null)) {
        var tmp = ensureNotNull($this.f29_1);
        tmp.a28(AbstractObservableSet$doAfterAdd$lambda(item));
      }
    }finally {
      $this.i29(item, success);
    }
  }
  function doBeforeRemove($this, item) {
    $this.j29(item);
    $this.k29(item);
  }
  function doAfterRemove($this, item, success) {
    try {
      if (success && !($this.f29_1 == null)) {
        var tmp = ensureNotNull($this.f29_1);
        tmp.a28(AbstractObservableSet$doAfterRemove$lambda(item));
      }
    }finally {
      $this.l29(item, success);
    }
  }
  function AbstractObservableSet$doAfterAdd$lambda($item) {
    return function (collectionListener) {
      var event = new CollectionItemEvent(null, $item, -1, EventType_ADD_getInstance());
      collectionListener.c27(event);
      return Unit_instance;
    };
  }
  function AbstractObservableSet$iterator$1($iterator, this$0) {
    this.o29_1 = $iterator;
    this.p29_1 = this$0;
    this.m29_1 = false;
    this.n29_1 = null;
  }
  protoOf(AbstractObservableSet$iterator$1).l = function () {
    return this.o29_1.l();
  };
  protoOf(AbstractObservableSet$iterator$1).m = function () {
    this.n29_1 = this.o29_1.m();
    this.m29_1 = true;
    return ensureNotNull(this.n29_1);
  };
  protoOf(AbstractObservableSet$iterator$1).b5 = function () {
    // Inline function 'kotlin.check' call
    if (!this.m29_1) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.m29_1 = false;
    doBeforeRemove(this.p29_1, ensureNotNull(this.n29_1));
    var success = false;
    try {
      this.o29_1.b5();
      success = true;
    }finally {
      doAfterRemove(this.p29_1, ensureNotNull(this.n29_1), success);
    }
  };
  function AbstractObservableSet$doAfterRemove$lambda($item) {
    return function (collectionListener) {
      collectionListener.j27(new CollectionItemEvent($item, null, -1, EventType_REMOVE_getInstance()));
      return Unit_instance;
    };
  }
  function AbstractObservableSet$addHandler$listener$1($handler) {
    this.q29_1 = $handler;
    CollectionAdapter.call(this);
  }
  protoOf(AbstractObservableSet$addHandler$listener$1).c27 = function (event) {
    return this.q29_1.d28(event);
  };
  protoOf(AbstractObservableSet$addHandler$listener$1).j27 = function (event) {
    return this.q29_1.d28(event);
  };
  function AbstractObservableSet() {
    AbstractMutableSet.call(this);
    this.f29_1 = null;
  }
  protoOf(AbstractObservableSet).n27 = function (listener) {
    if (this.f29_1 == null) {
      this.f29_1 = new Listeners();
    }
    return ensureNotNull(this.f29_1).z27(listener);
  };
  protoOf(AbstractObservableSet).s29 = function (element) {
    if (this.s(element))
      return false;
    doBeforeAdd(this, element);
    var success = false;
    try {
      this.t29(element);
      success = this.u29(element);
    }finally {
      doAfterAdd(this, element, success);
    }
    return success;
  };
  protoOf(AbstractObservableSet).e = function (element) {
    return this.s29((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractObservableSet).v29 = function (element) {
    if (!this.s(element)) {
      return false;
    }
    doBeforeRemove(this, element);
    var success = false;
    try {
      this.w29(element);
      success = this.x29(element);
    }finally {
      doAfterRemove(this, element, success);
    }
    return success;
  };
  protoOf(AbstractObservableSet).k2 = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.v29((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AbstractObservableSet).k = function () {
    if (this.n() === 0) {
      // Inline function 'kotlin.collections.mutableSetOf' call
      return LinkedHashSet_init_$Create$().k();
    }
    var iterator = this.r29();
    return new AbstractObservableSet$iterator$1(iterator, this);
  };
  protoOf(AbstractObservableSet).g29 = function (item) {
  };
  protoOf(AbstractObservableSet).j29 = function (item) {
  };
  protoOf(AbstractObservableSet).h29 = function (item) {
  };
  protoOf(AbstractObservableSet).t29 = function (item) {
  };
  protoOf(AbstractObservableSet).i29 = function (item, success) {
  };
  protoOf(AbstractObservableSet).k29 = function (item) {
  };
  protoOf(AbstractObservableSet).w29 = function (item) {
  };
  protoOf(AbstractObservableSet).l29 = function (item, success) {
  };
  protoOf(AbstractObservableSet).v28 = function (handler) {
    var listener = new AbstractObservableSet$addHandler$listener$1(handler);
    return this.n27(listener);
  };
  protoOf(AbstractObservableSet).o27 = function (handler) {
    return this.v28(handler);
  };
  function Companion_29() {
  }
  protoOf(Companion_29).y29 = function (set) {
    return new ConstantObservableSetAdapter(toSet_0(set));
  };
  var Companion_instance_29;
  function Companion_getInstance_29() {
    return Companion_instance_29;
  }
  function ConstantObservableSetAdapter(delegate) {
    this.z29_1 = delegate;
  }
  protoOf(ConstantObservableSetAdapter).n27 = function (listener) {
    return Companion_getInstance_25().wr_1;
  };
  protoOf(ConstantObservableSetAdapter).v28 = function (handler) {
    return Companion_getInstance_25().wr_1;
  };
  protoOf(ConstantObservableSetAdapter).o27 = function (handler) {
    return this.v28(handler);
  };
  protoOf(ConstantObservableSetAdapter).p = function () {
    return this.z29_1.p();
  };
  protoOf(ConstantObservableSetAdapter).y28 = function (element) {
    return this.z29_1.s(element);
  };
  protoOf(ConstantObservableSetAdapter).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.y28((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ConstantObservableSetAdapter).k = function () {
    return this.z29_1.k();
  };
  protoOf(ConstantObservableSetAdapter).z28 = function (elements) {
    return this.z29_1.h2(elements);
  };
  protoOf(ConstantObservableSetAdapter).h2 = function (elements) {
    return this.z28(elements);
  };
  protoOf(ConstantObservableSetAdapter).n = function () {
    return this.z29_1.n();
  };
  function ObservableHashSet_init_$Init$($this) {
    AbstractObservableSet.call($this);
    ObservableHashSet.call($this);
    return $this;
  }
  function ObservableHashSet_init_$Create$() {
    return ObservableHashSet_init_$Init$(objectCreate(protoOf(ObservableHashSet)));
  }
  function ensureSetInitialized($this) {
    if ($this.b2a_1 == null) {
      $this.b2a_1 = HashSet_init_$Create$_1(1);
    }
  }
  protoOf(ObservableHashSet).n = function () {
    var tmp0_safe_receiver = this.b2a_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ObservableHashSet).r29 = function () {
    return ensureNotNull(this.b2a_1).k();
  };
  protoOf(ObservableHashSet).y28 = function (element) {
    var tmp0_safe_receiver = this.b2a_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s(element);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(ObservableHashSet).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.y28((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ObservableHashSet).u29 = function (item) {
    ensureSetInitialized(this);
    return ensureNotNull(this.b2a_1).e(item);
  };
  protoOf(ObservableHashSet).x29 = function (item) {
    return ensureNotNull(this.b2a_1).k2(item);
  };
  function ObservableHashSet() {
    this.b2a_1 = null;
  }
  function wrapEvent(event, f) {
    var eventType = event.h27_1;
    var tmp;
    if (!eventType.equals(EventType_ADD_getInstance()) && !(event.i27() == null)) {
      tmp = f(event.i27());
    } else {
      tmp = null;
    }
    var oldItem = tmp;
    var tmp_0;
    if (!eventType.equals(EventType_REMOVE_getInstance()) && !(event.k27() == null)) {
      tmp_0 = f(event.k27());
    } else {
      tmp_0 = null;
    }
    var newItem = tmp_0;
    return new CollectionItemEvent(oldItem, newItem, event.g27_1, eventType);
  }
  function ObservableListWrapper$addListener$lambda(this$0) {
    return function (it) {
      return wrapEvent(it, this$0.e2a_1);
    };
  }
  function ObservableListWrapper$addHandler$lambda($handler, this$0) {
    return function (event) {
      $handler.d28(wrapEvent(event, this$0.e2a_1));
      return Unit_instance;
    };
  }
  function ObservableListWrapper(source, sToT, tToS) {
    AbstractMutableList.call(this);
    this.d2a_1 = source;
    this.e2a_1 = sToT;
    this.f2a_1 = tToS;
  }
  protoOf(ObservableListWrapper).n = function () {
    return this.d2a_1.n();
  };
  protoOf(ObservableListWrapper).g2a = function (listener) {
    return this.d2a_1.n27(new RelayCollectionListener(listener, ObservableListWrapper$addListener$lambda(this)));
  };
  protoOf(ObservableListWrapper).n27 = function (listener) {
    return this.g2a(listener);
  };
  protoOf(ObservableListWrapper).h2a = function (handler) {
    return this.d2a_1.p27(ObservableListWrapper$addHandler$lambda(handler, this));
  };
  protoOf(ObservableListWrapper).o27 = function (handler) {
    return this.h2a(handler);
  };
  protoOf(ObservableListWrapper).i2a = function (index, element) {
    this.d2a_1.p2(index, this.f2a_1(element));
  };
  protoOf(ObservableListWrapper).p2 = function (index, element) {
    return this.i2a(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ObservableListWrapper).j2a = function (index, element) {
    var old = this.d2a_1.o2(index, this.f2a_1(element));
    return this.e2a_1(old);
  };
  protoOf(ObservableListWrapper).o2 = function (index, element) {
    return this.j2a(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ObservableListWrapper).q = function (index) {
    return this.e2a_1(this.d2a_1.q(index));
  };
  protoOf(ObservableListWrapper).q2 = function (index) {
    var old = this.d2a_1.q2(index);
    return this.e2a_1(old);
  };
  function ObservableSetWrapper$addListener$lambda(this$0) {
    return function (it) {
      return wrapEvent(it, this$0.l2a_1);
    };
  }
  function ObservableSetWrapper$addHandler$lambda($handler, this$0) {
    return function (event) {
      $handler.d28(wrapEvent(event, this$0.l2a_1));
      return Unit_instance;
    };
  }
  function ObservableSetWrapper$iterator$1(this$0) {
    this.o2a_1 = this$0;
    this.n2a_1 = this$0.k2a_1.k();
  }
  protoOf(ObservableSetWrapper$iterator$1).l = function () {
    return this.n2a_1.l();
  };
  protoOf(ObservableSetWrapper$iterator$1).m = function () {
    return this.o2a_1.l2a_1(this.n2a_1.m());
  };
  protoOf(ObservableSetWrapper$iterator$1).b5 = function () {
    return this.n2a_1.b5();
  };
  function ObservableSetWrapper(source, sToT, tToS) {
    this.k2a_1 = source;
    this.l2a_1 = sToT;
    this.m2a_1 = tToS;
  }
  protoOf(ObservableSetWrapper).n = function () {
    return this.k2a_1.n();
  };
  protoOf(ObservableSetWrapper).g2a = function (listener) {
    return this.k2a_1.n27(new RelayCollectionListener(listener, ObservableSetWrapper$addListener$lambda(this)));
  };
  protoOf(ObservableSetWrapper).n27 = function (listener) {
    return this.g2a(listener);
  };
  protoOf(ObservableSetWrapper).h2a = function (handler) {
    return this.k2a_1.p27(ObservableSetWrapper$addHandler$lambda(handler, this));
  };
  protoOf(ObservableSetWrapper).o27 = function (handler) {
    return this.h2a(handler);
  };
  protoOf(ObservableSetWrapper).p = function () {
    return this.k2a_1.p();
  };
  protoOf(ObservableSetWrapper).p2a = function (element) {
    if (element == null)
      return false;
    return this.k2a_1.s(this.m2a_1(element));
  };
  protoOf(ObservableSetWrapper).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.p2a((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ObservableSetWrapper).k = function () {
    return new ObservableSetWrapper$iterator$1(this);
  };
  protoOf(ObservableSetWrapper).q2a = function (element) {
    return this.k2a_1.e(this.m2a_1(element));
  };
  protoOf(ObservableSetWrapper).e = function (element) {
    return this.q2a((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ObservableSetWrapper).r2a = function (element) {
    return this.k2a_1.k2(this.m2a_1(element));
  };
  protoOf(ObservableSetWrapper).k2 = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.r2a((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(ObservableSetWrapper).s2a = function (elements) {
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      if (!this.k2a_1.s(this.m2a_1(element))) {
        return false;
      }
    }
    return true;
  };
  protoOf(ObservableSetWrapper).h2 = function (elements) {
    return this.s2a(elements);
  };
  protoOf(ObservableSetWrapper).t2a = function (elements) {
    var changed = false;
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      if (this.q2a(element)) {
        changed = true;
      }
    }
    return changed;
  };
  protoOf(ObservableSetWrapper).o = function (elements) {
    return this.t2a(elements);
  };
  protoOf(ObservableSetWrapper).u2a = function (elements) {
    var iter = this.k();
    while (iter.l()) {
      var current = iter.m();
      if (!elements.s(current)) {
        iter.b5();
      }
    }
    return false;
  };
  protoOf(ObservableSetWrapper).l2 = function (elements) {
    return this.u2a(elements);
  };
  protoOf(ObservableSetWrapper).v2a = function (elements) {
    var changed = false;
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      if (this.k2a_1.k2(this.m2a_1(element))) {
        changed = true;
      }
    }
    return changed;
  };
  protoOf(ObservableSetWrapper).k1 = function (elements) {
    return this.v2a(elements);
  };
  protoOf(ObservableSetWrapper).m2 = function () {
    return this.k2a_1.m2();
  };
  function RelayCollectionListener(relayTo, transform) {
    this.w2a_1 = relayTo;
    this.x2a_1 = transform;
  }
  protoOf(RelayCollectionListener).y2a = function (event) {
    this.w2a_1.c27(this.x2a_1(event));
  };
  protoOf(RelayCollectionListener).c27 = function (event) {
    return this.y2a(event);
  };
  protoOf(RelayCollectionListener).z2a = function (event) {
    this.w2a_1.d27(this.x2a_1(event));
  };
  protoOf(RelayCollectionListener).d27 = function (event) {
    return this.z2a(event);
  };
  protoOf(RelayCollectionListener).a2b = function (event) {
    this.w2a_1.j27(this.x2a_1(event));
  };
  protoOf(RelayCollectionListener).j27 = function (event) {
    return this.a2b(event);
  };
  function get_asObservable(_this__u8e3s4) {
    return Companion_instance_28.w28(_this__u8e3s4);
  }
  function get_asObservable_0(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, KtList)) {
      tmp = get_asObservable(_this__u8e3s4);
    } else {
      if (isInterface(_this__u8e3s4, KtSet)) {
        tmp = get_asObservable_1(_this__u8e3s4);
      } else {
        throw IllegalStateException_init_$Create$_0('Unknown collection ' + toString_1(_this__u8e3s4));
      }
    }
    return tmp;
  }
  function get_asObservable_1(_this__u8e3s4) {
    return Companion_instance_29.y29(_this__u8e3s4);
  }
  function EventHandlerListeners$fire$lambda($event) {
    return function (handler) {
      handler.d28($event);
      return Unit_instance;
    };
  }
  function EventHandlerListeners() {
    Listeners.call(this);
  }
  protoOf(EventHandlerListeners).c2b = function (event) {
    return this.a28(EventHandlerListeners$fire$lambda(event));
  };
  function EventSource$addHandler$$inlined$eventHandler$1($handler) {
    this.d2b_1 = $handler;
  }
  protoOf(EventSource$addHandler$$inlined$eventHandler$1).e2b = function (event) {
    return this.d2b_1(event);
  };
  protoOf(EventSource$addHandler$$inlined$eventHandler$1).d28 = function (event) {
    return this.e2b((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function EventSource() {
  }
  function ListenerEvent$dispatch$ref($boundThis) {
    var l = function (p0) {
      $boundThis.m27(p0);
      return Unit_instance;
    };
    l.callableName = 'dispatch';
    return l;
  }
  function EventListeners() {
    Listeners.call(this);
  }
  protoOf(EventListeners).g2b = function (event) {
    return this.a28(ListenerEvent$dispatch$ref(event));
  };
  function addHandlerTo($this, src) {
    var handler = src.p27(CompositeEventSource$addHandlerTo$lambda($this));
    $this.j2b_1.e(handler);
  }
  function CompositeEventSource$addHandler$1(this$0) {
    this.l2b_1 = this$0;
    EventHandlerListeners.call(this);
  }
  protoOf(CompositeEventSource$addHandler$1).s27 = function () {
    var _iterator__ex2g4s = this.l2b_1.i2b_1.k();
    while (_iterator__ex2g4s.l()) {
      var eventSource = _iterator__ex2g4s.m();
      addHandlerTo(this.l2b_1, eventSource);
    }
  };
  protoOf(CompositeEventSource$addHandler$1).w27 = function () {
    var _iterator__ex2g4s = this.l2b_1.j2b_1.k();
    while (_iterator__ex2g4s.l()) {
      var disposable = _iterator__ex2g4s.m();
      disposable.vr();
    }
    this.l2b_1.j2b_1.m2();
    this.l2b_1.h2b_1 = null;
  };
  function CompositeEventSource$addHandlerTo$lambda(this$0) {
    return function (event) {
      ensureNotNull(this$0.h2b_1).c2b(event);
      return Unit_instance;
    };
  }
  function CompositeEventSource(sources) {
    this.h2b_1 = null;
    this.i2b_1 = ArrayList_init_$Create$();
    this.j2b_1 = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = sources.length;
    while (inductionVariable < last) {
      var source = sources[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.m2b(source);
    }
  }
  protoOf(CompositeEventSource).m2b = function (source) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.i2b_1.e(source);
  };
  protoOf(CompositeEventSource).o27 = function (handler) {
    if (this.h2b_1 == null) {
      var tmp = this;
      tmp.h2b_1 = new CompositeEventSource$addHandler$1(this);
    }
    return ensureNotNull(this.h2b_1).z27(handler);
  };
  function EventSources() {
  }
  protoOf(EventSources).n2b = function (sources) {
    return new CompositeEventSource(sources.slice());
  };
  var EventSources_instance;
  function EventSources_getInstance() {
    return EventSources_instance;
  }
  function Listeners$add$$inlined$toDisposable$1(this$0, $listener) {
    this.o2b_1 = this$0;
    this.p2b_1 = $listener;
  }
  protoOf(Listeners$add$$inlined$toDisposable$1).vr = function () {
    this.o2b_1.y27_1.so(this.p2b_1);
    var tmp;
    if (this.o2b_1.np()) {
      this.o2b_1.w27();
      tmp = Unit_instance;
    }
    return tmp;
  };
  function Listeners$fire$lambda($h) {
    return function (iterable) {
      var _iterator__ex2g4s = iterable.k();
      while (_iterator__ex2g4s.l()) {
        var listener = _iterator__ex2g4s.m();
        try {
          $h(listener);
        } catch ($p) {
          if ($p instanceof Error) {
            var t = $p;
            ThrowableHandlers_getInstance().ps_1.os(t);
          } else {
            throw $p;
          }
        }
      }
      return Unit_instance;
    };
  }
  function Listeners() {
    this.y27_1 = Companion_instance_23.tp();
  }
  protoOf(Listeners).np = function () {
    return this.b28() === 0;
  };
  protoOf(Listeners).z27 = function (listener) {
    if (this.np()) {
      this.s27();
    }
    this.y27_1.ro(listener);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new Listeners$add$$inlined$toDisposable$1(this, listener);
  };
  protoOf(Listeners).a28 = function (h) {
    if (this.np()) {
      return Unit_instance;
    }
    try {
      this.y27_1.qo(Listeners$fire$lambda(h));
    }finally {
      if (!this.y27_1.po() && this.np()) {
        this.w27();
      }
    }
  };
  protoOf(Listeners).m2 = function () {
    return this.y27_1.m2();
  };
  protoOf(Listeners).s27 = function () {
  };
  protoOf(Listeners).w27 = function () {
  };
  protoOf(Listeners).b28 = function () {
    return this.y27_1.wo();
  };
  function ListenersDelegate($outer, element) {
    this.s2b_1 = $outer;
    Listeners.call(this);
    this.r2b_1 = element;
  }
  protoOf(ListenersDelegate).s27 = function () {
    this.s2b_1.u2b(this.r2b_1);
  };
  protoOf(ListenersDelegate).w27 = function () {
    this.s2b_1.v2b(this.r2b_1);
  };
  function ListenersMap$add$$inlined$toDisposable$1($disposable, $listeners, this$0, $element) {
    this.w2b_1 = $disposable;
    this.x2b_1 = $listeners;
    this.y2b_1 = this$0;
    this.z2b_1 = $element;
  }
  protoOf(ListenersMap$add$$inlined$toDisposable$1).vr = function () {
    this.w2b_1.vr();
    var tmp;
    if (this.x2b_1.np()) {
      this.y2b_1.t2b_1.s2(this.z2b_1);
      tmp = Unit_instance;
    }
    return tmp;
  };
  function ListenersMap() {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.t2b_1 = HashMap_init_$Create$();
  }
  protoOf(ListenersMap).a2c = function (element, listener) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.t2b_1;
    var value = this_0.y2(element);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.base.observable.listeners.ListenersMap.add.<anonymous>' call
      var answer = new ListenersDelegate(this, element);
      this_0.r2(element, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var listeners = tmp;
    var disposable = listeners.z27(listener);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new ListenersMap$add$$inlined$toDisposable$1(disposable, listeners, this, element);
  };
  protoOf(ListenersMap).b2c = function (element, action) {
    var tmp0_safe_receiver = this.t2b_1.y2(element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a28(action);
    }
  };
  protoOf(ListenersMap).m2 = function () {
    var _iterator__ex2g4s = this.t2b_1.v2().k();
    while (_iterator__ex2g4s.l()) {
      var listeners = _iterator__ex2g4s.m();
      listeners.m2();
    }
    this.t2b_1.m2();
  };
  protoOf(ListenersMap).u2b = function (element) {
  };
  protoOf(ListenersMap).v2b = function (element) {
  };
  function BaseDerivedProperty$addHandler$1(this$0) {
    this.d2c_1 = this$0;
    EventHandlerListeners.call(this);
  }
  protoOf(BaseDerivedProperty$addHandler$1).s27 = function () {
    this.d2c_1.e2c_1 = this.d2c_1.g2c();
    this.d2c_1.h2c();
  };
  protoOf(BaseDerivedProperty$addHandler$1).w27 = function () {
    this.d2c_1.i2c();
    this.d2c_1.f2c_1 = null;
  };
  function BaseDerivedProperty() {
    BaseReadableProperty.call(this);
    this.e2c_1 = null;
    this.f2c_1 = null;
  }
  protoOf(BaseDerivedProperty).qr = function () {
    var tmp;
    if (this.f2c_1 == null) {
      tmp = this.g2c();
    } else {
      var tmp_0 = this.e2c_1;
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(BaseDerivedProperty).j2c = function () {
    var newValue = this.g2c();
    var oldValue = this.e2c_1;
    if (equals(oldValue, newValue)) {
      return Unit_instance;
    }
    this.e2c_1 = newValue;
    if (!(this.f2c_1 == null)) {
      var castOldValue = (oldValue == null ? true : !(oldValue == null)) ? oldValue : THROW_CCE();
      var event = new PropertyChangeEvent(castOldValue, newValue);
      ensureNotNull(this.f2c_1).c2b(event);
    }
  };
  protoOf(BaseDerivedProperty).k2c = function (handler) {
    if (this.f2c_1 == null) {
      var tmp = this;
      tmp.f2c_1 = new BaseDerivedProperty$addHandler$1(this);
    }
    return ensureNotNull(this.f2c_1).z27(handler);
  };
  protoOf(BaseDerivedProperty).o27 = function (handler) {
    return this.k2c(handler);
  };
  function BaseReadableProperty() {
  }
  protoOf(BaseReadableProperty).l2c = function () {
    var tmp0_elvis_lhs = getKClassFromExpression(this).lb();
    return tmp0_elvis_lhs == null ? '<Name not available, inherits BaseReadableProperty>' : tmp0_elvis_lhs;
  };
  protoOf(BaseReadableProperty).toString = function () {
    return this.l2c();
  };
  function DelayedValueProperty$addHandler$1(this$0) {
    this.o2c_1 = this$0;
    EventHandlerListeners.call(this);
  }
  protoOf(DelayedValueProperty$addHandler$1).w27 = function () {
    this.o2c_1.q2c_1 = null;
  };
  function DelayedValueProperty() {
    BaseReadableProperty.call(this);
    this.p2c_1 = null;
    this.q2c_1 = null;
    this.r2c_1 = null;
  }
  protoOf(DelayedValueProperty).l2c = function () {
    return 'delayedProperty()';
  };
  protoOf(DelayedValueProperty).qr = function () {
    return this.p2c_1;
  };
  protoOf(DelayedValueProperty).s2c = function (newValue) {
    if (equals(newValue, this.p2c_1)) {
      return Unit_instance;
    }
    var oldValue = this.p2c_1;
    this.p2c_1 = newValue;
    // Inline function 'kotlin.check' call
    if (!(this.r2c_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.r2c_1 = new PropertyChangeEvent(oldValue, this.p2c_1);
  };
  protoOf(DelayedValueProperty).t2c = function (newValue) {
    return this.s2c((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  protoOf(DelayedValueProperty).v9 = function () {
    var tmp0_safe_receiver = this.q2c_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.c2b(ensureNotNull(this.r2c_1));
    }
    this.r2c_1 = null;
  };
  protoOf(DelayedValueProperty).u2c = function (handler) {
    if (this.q2c_1 == null) {
      var tmp = this;
      tmp.q2c_1 = new DelayedValueProperty$addHandler$1(this);
    }
    return ensureNotNull(this.q2c_1).z27(handler);
  };
  protoOf(DelayedValueProperty).o27 = function (handler) {
    return this.u2c(handler);
  };
  function DerivedProperty$doAddListeners$lambda(this$0) {
    return function (it) {
      this$0.j2c();
      return Unit_instance;
    };
  }
  function DerivedProperty(deps) {
    BaseDerivedProperty.call(this);
    this.y2c_1 = toList(deps);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.z2c_1 = ArrayList_init_$Create$();
  }
  protoOf(DerivedProperty).h2c = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.y2c_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.base.observable.property.DerivedProperty.doAddListeners.<anonymous>' call
      var tmp$ret$0 = item.p27(DerivedProperty$doAddListeners$lambda(this));
      destination.e(tmp$ret$0);
    }
    var list = destination;
    this.z2c_1.o(list);
  };
  protoOf(DerivedProperty).i2c = function () {
    var _iterator__ex2g4s = this.z2c_1.k();
    while (_iterator__ex2g4s.l()) {
      var r = _iterator__ex2g4s.m();
      r.vr();
    }
    this.z2c_1.m2();
  };
  function toDerivedProperty(_this__u8e3s4, deps) {
    var r = _this__u8e3s4;
    return new toDerivedProperty$1(deps, r);
  }
  function toDerivedProperty$1($deps, $r) {
    this.e2d_1 = $r;
    DerivedProperty.call(this, $deps.slice());
  }
  protoOf(toDerivedProperty$1).g2c = function () {
    return this.e2d_1();
  };
  function and(_this__u8e3s4, op2) {
    var op1 = _this__u8e3s4;
    return new and$1(op1, op2);
  }
  function Properties$and$1($props) {
    this.j2d_1 = $props;
    DerivedProperty.call(this, $props.slice());
  }
  protoOf(Properties$and$1).l2c = function () {
    var propExpr = new StringBuilder('(');
    propExpr.d9(this.j2d_1[0].l2c());
    var inductionVariable = 1;
    var last = this.j2d_1.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        propExpr.d9(' && ').d9(this.j2d_1[i].l2c());
      }
       while (inductionVariable < last);
    return propExpr.d9(')').toString();
  };
  protoOf(Properties$and$1).g2c = function () {
    var res = true;
    var indexedObject = this.j2d_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var prop = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      res = (res && prop.m2c());
    }
    return res;
  };
  function Properties$or$1($props) {
    this.o2d_1 = $props;
    DerivedProperty.call(this, $props.slice());
  }
  protoOf(Properties$or$1).l2c = function () {
    var propExpr = new StringBuilder('(');
    propExpr.d9(this.o2d_1[0].l2c());
    var inductionVariable = 1;
    var last = this.o2d_1.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        propExpr.d9(' || ').d9(this.o2d_1[i].l2c());
      }
       while (inductionVariable < last);
    return propExpr.d9(')').toString();
  };
  protoOf(Properties$or$1).g2c = function () {
    var res = false;
    var indexedObject = this.o2d_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var prop = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      res = res || prop.m2c();
    }
    return res;
  };
  function Properties() {
    Properties_instance = this;
    this.p2d_1 = constantProp(true);
    this.q2d_1 = constantProp(false);
  }
  protoOf(Properties).r2d = function (props) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    // Inline function 'kotlin.require' call
    if (!!(props.length === 0)) {
      // Inline function 'jetbrains.ocelot.base.observable.property.Properties.and.<anonymous>' call
      var message = 'No arguments';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new Properties$and$1(props);
  };
  protoOf(Properties).s2d = function (props) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    // Inline function 'kotlin.require' call
    if (!!(props.length === 0)) {
      // Inline function 'jetbrains.ocelot.base.observable.property.Properties.or.<anonymous>' call
      var message = 'No arguments';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new Properties$or$1(props);
  };
  var Properties_instance;
  function Properties_getInstance() {
    if (Properties_instance == null)
      new Properties();
    return Properties_instance;
  }
  function notNull(_this__u8e3s4) {
    return map_0(_this__u8e3s4, notNull$lambda);
  }
  function map_0(_this__u8e3s4, f) {
    var prop = _this__u8e3s4;
    return new map$1(_this__u8e3s4, prop, f);
  }
  function isSame(_this__u8e3s4, v) {
    return map_0(_this__u8e3s4, isSame$lambda(v));
  }
  function not(_this__u8e3s4) {
    return map_0(_this__u8e3s4, not$lambda);
  }
  function isNull(_this__u8e3s4) {
    return map_0(_this__u8e3s4, isNull$lambda);
  }
  function ifProp(_this__u8e3s4, ifTrue, ifFalse) {
    return ifProp_0(_this__u8e3s4, constantProp(ifTrue), constantProp(ifFalse));
  }
  function map_1(_this__u8e3s4, sourceToTarget, targetToSource) {
    var property = _this__u8e3s4;
    return new map$2(property, sourceToTarget, targetToSource);
  }
  function constantProp(_this__u8e3s4) {
    var value = _this__u8e3s4;
    return new constantProp$1(value);
  }
  function ifProp_0(_this__u8e3s4, ifTrue, ifFalse) {
    var conditionProp = _this__u8e3s4;
    return new ifProp$1(conditionProp, ifTrue, ifFalse);
  }
  function select(_this__u8e3s4, nullValue, selector) {
    var source = _this__u8e3s4;
    return new select$1(selector, source, nullValue);
  }
  function notEqual(_this__u8e3s4, p2) {
    return not(isEqual(_this__u8e3s4, p2));
  }
  function AbstractSelectProperty(selector) {
    BaseDerivedProperty.call(this);
    this.v2d_1 = selector;
    this.w2d_1 = Companion_getInstance_25().wr_1;
    this.x2d_1 = Companion_getInstance_25().wr_1;
  }
  protoOf(AbstractSelectProperty).h2c = function () {
    this.w2d_1 = this.y2d();
    this.x2d_1 = this.z2d();
  };
  protoOf(AbstractSelectProperty).i2c = function () {
    this.a2e();
    this.b2e();
  };
  protoOf(AbstractSelectProperty).a2e = function () {
    this.w2d_1.vr();
    this.w2d_1 = Companion_getInstance_25().wr_1;
  };
  protoOf(AbstractSelectProperty).b2e = function () {
    this.x2d_1.vr();
    this.x2d_1 = Companion_getInstance_25().wr_1;
  };
  function isEqual(_this__u8e3s4, p2) {
    var p1 = _this__u8e3s4;
    return new isEqual$1(p1, p2);
  }
  function asValidatedProp(_this__u8e3s4, initialValue, validator) {
    var source = _this__u8e3s4;
    return new asValidatedProp$ValidatedProperty(initialValue, source, validator);
  }
  function and$1($op1, $op2) {
    this.g2e_1 = $op1;
    this.h2e_1 = $op2;
    DerivedProperty.call(this, [$op1, $op2]);
  }
  protoOf(and$1).l2c = function () {
    return '(' + this.g2e_1.l2c() + ' && ' + this.h2e_1.l2c() + ')';
  };
  protoOf(and$1).g2c = function () {
    return this.g2e_1.m2c() && this.h2e_1.m2c();
  };
  function notNull$lambda(value) {
    return !(value == null);
  }
  function map$1($this_map, $prop, $f) {
    this.m2e_1 = $prop;
    this.n2e_1 = $f;
    DerivedProperty.call(this, [$this_map]);
  }
  protoOf(map$1).l2c = function () {
    return 'transform(' + this.m2e_1.l2c() + ', ' + toString_1(this.n2e_1) + ')';
  };
  protoOf(map$1).g2c = function () {
    return this.n2e_1(this.m2e_1.m2c());
  };
  function isSame$lambda($v) {
    return function (value) {
      return value === $v;
    };
  }
  function not$lambda(value) {
    return !value;
  }
  function isNull$lambda(value) {
    return value == null;
  }
  function map$o$addHandler$lambda($sourceToTarget, $handler) {
    return function (event) {
      var oldValue = $sourceToTarget(event.o2e_1);
      var newValue = $sourceToTarget(event.p2e_1);
      var tmp;
      if (!equals(oldValue, newValue)) {
        $handler.d28(new PropertyChangeEvent(oldValue, newValue));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function map$2($property, $sourceToTarget, $targetToSource) {
    this.q2e_1 = $property;
    this.r2e_1 = $sourceToTarget;
    this.s2e_1 = $targetToSource;
  }
  protoOf(map$2).l2c = function () {
    return 'transform(' + this.q2e_1.l2c() + ', ' + toString_1(this.r2e_1) + ', ' + toString_1(this.s2e_1) + ')';
  };
  protoOf(map$2).qr = function () {
    var source = this.q2e_1.qr();
    return this.r2e_1(source);
  };
  protoOf(map$2).t2e = function (handler) {
    return this.q2e_1.p27(map$o$addHandler$lambda(this.r2e_1, handler));
  };
  protoOf(map$2).o27 = function (handler) {
    return this.t2e(handler);
  };
  protoOf(map$2).u2e = function (newValue) {
    var source = this.s2e_1(newValue);
    this.q2e_1.t2c(source);
  };
  protoOf(map$2).t2c = function (newValue) {
    return this.u2e((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function constantProp$1($value) {
    this.v2e_1 = $value;
    BaseReadableProperty.call(this);
  }
  protoOf(constantProp$1).l2c = function () {
    return 'constantProp(' + toString_0(this.v2e_1) + ')';
  };
  protoOf(constantProp$1).qr = function () {
    return this.v2e_1;
  };
  protoOf(constantProp$1).k2c = function (handler) {
    return Companion_getInstance_25().wr_1;
  };
  protoOf(constantProp$1).o27 = function (handler) {
    return this.k2c(handler);
  };
  function ifProp$1($conditionProp, $ifTrue, $ifFalse) {
    this.a2f_1 = $conditionProp;
    this.b2f_1 = $ifTrue;
    this.c2f_1 = $ifFalse;
    DerivedProperty.call(this, [$conditionProp, $ifTrue, $ifFalse]);
  }
  protoOf(ifProp$1).l2c = function () {
    var conditionExpr = this.a2f_1.l2c();
    var ifTrueExpr = this.b2f_1.l2c();
    var ifFalseExpr = this.c2f_1.l2c();
    return 'if(' + conditionExpr + ', ' + ifTrueExpr + ', ' + ifFalseExpr + ')';
  };
  protoOf(ifProp$1).g2c = function () {
    return this.a2f_1.m2c() ? this.b2f_1.m2c() : this.c2f_1.m2c();
  };
  function select$o$addSourceListener$lambda(this$0) {
    return function (it) {
      this$0.b2e();
      this$0.z2d();
      this$0.j2c();
      return Unit_instance;
    };
  }
  function select$o$addTargetListener$lambda(this$0) {
    return function (it) {
      this$0.j2c();
      return Unit_instance;
    };
  }
  function select$1($selector, $source, $nullValue) {
    this.i2f_1 = $selector;
    this.j2f_1 = $source;
    this.k2f_1 = $nullValue;
    AbstractSelectProperty.call(this, $selector);
  }
  protoOf(select$1).l2c = function () {
    return this.j2f_1.l2c() + '.select(' + toString_0(this.k2f_1) + ', ' + toString_1(this.i2f_1) + ')';
  };
  protoOf(select$1).y2d = function () {
    return this.j2f_1.p27(select$o$addSourceListener$lambda(this));
  };
  protoOf(select$1).z2d = function () {
    var tmp0_safe_receiver = this.j2f_1.m2c();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.base.observable.property.<no name provided>.addTargetListener.<anonymous>' call
      tmp = this.i2f_1(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.run' call
      // Inline function 'jetbrains.ocelot.base.observable.property.<no name provided>.addTargetListener.<anonymous>' call
      tmp_0 = tmp1_safe_receiver.p27(select$o$addTargetListener$lambda(this));
    }
    var tmp2_elvis_lhs = tmp_0;
    return tmp2_elvis_lhs == null ? Companion_getInstance_25().wr_1 : tmp2_elvis_lhs;
  };
  protoOf(select$1).g2c = function () {
    var value = this.j2f_1.m2c();
    return value == null ? this.k2f_1 : this.i2f_1(value).qr();
  };
  function isEqual$1($p1, $p2) {
    this.p2f_1 = $p1;
    this.q2f_1 = $p2;
    DerivedProperty.call(this, [$p1, $p2]);
  }
  protoOf(isEqual$1).l2c = function () {
    return 'equals(' + this.p2f_1.l2c() + ', ' + this.q2f_1.l2c() + ')';
  };
  protoOf(isEqual$1).g2c = function () {
    return equals(this.p2f_1.m2c(), this.q2f_1.m2c());
  };
  function asValidatedProp$ValidatedProperty($initialValue, $source, $validator) {
    this.w2f_1 = $source;
    this.x2f_1 = $validator;
    DerivedProperty.call(this, [$source]);
    this.v2f_1 = $initialValue;
  }
  protoOf(asValidatedProp$ValidatedProperty).l2c = function () {
    return 'validated(' + this.w2f_1.l2c() + ', ' + toString_1(this.x2f_1) + ')';
  };
  protoOf(asValidatedProp$ValidatedProperty).g2c = function () {
    var sourceValue = this.w2f_1.m2c();
    if (this.x2f_1(sourceValue)) {
      this.v2f_1 = sourceValue;
    }
    return this.v2f_1;
  };
  protoOf(asValidatedProp$ValidatedProperty).t2c = function (newValue) {
    if (!this.x2f_1(newValue)) {
      return Unit_instance;
    }
    this.w2f_1.v2c(newValue);
  };
  function Property() {
  }
  function PropertyBinding$bindOneWay$lambda($target) {
    return function (it) {
      $target.v2c(it.p2e_1);
      return Unit_instance;
    };
  }
  function PropertyBinding$bindTwoWay$UpdatingEventHandler($syncing, $target, $source, forward) {
    this.z2f_1 = $syncing;
    this.a2g_1 = $target;
    this.b2g_1 = $source;
    this.y2f_1 = forward;
  }
  protoOf(PropertyBinding$bindTwoWay$UpdatingEventHandler).c2g = function (event) {
    if (this.z2f_1.m2c())
      return Unit_instance;
    this.z2f_1.v2c(true);
    try {
      if (this.y2f_1) {
        this.a2g_1.v2c(this.b2g_1.m2c());
      } else {
        this.b2g_1.v2c(this.a2g_1.m2c());
      }
    }finally {
      this.z2f_1.v2c(false);
    }
  };
  protoOf(PropertyBinding$bindTwoWay$UpdatingEventHandler).d28 = function (event) {
    return this.c2g(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  function PropertyBinding() {
  }
  protoOf(PropertyBinding).d2g = function (source, target) {
    target.v2c(source.m2c());
    return source.p27(PropertyBinding$bindOneWay$lambda(target));
  };
  protoOf(PropertyBinding).e2g = function (source, target) {
    var syncing = new ValueProperty(false);
    target.v2c(source.m2c());
    return source.o27(new PropertyBinding$bindTwoWay$UpdatingEventHandler(syncing, target, source, true)).sr(target.o27(new PropertyBinding$bindTwoWay$UpdatingEventHandler(syncing, target, source, false)));
  };
  var PropertyBinding_instance;
  function PropertyBinding_getInstance() {
    return PropertyBinding_instance;
  }
  function PropertyChangeEvent(oldValue, newValue) {
    this.o2e_1 = oldValue;
    this.p2e_1 = newValue;
  }
  protoOf(PropertyChangeEvent).toString = function () {
    return toString_0(this.o2e_1) + ' -> ' + toString_0(this.p2e_1);
  };
  protoOf(PropertyChangeEvent).hashCode = function () {
    var result = this.o2e_1 == null ? 0 : hashCode(this.o2e_1);
    result = imul(result, 31) + (this.p2e_1 == null ? 0 : hashCode(this.p2e_1)) | 0;
    return result;
  };
  protoOf(PropertyChangeEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PropertyChangeEvent))
      return false;
    var tmp0_other_with_cast = other instanceof PropertyChangeEvent ? other : THROW_CCE();
    if (!equals(this.o2e_1, tmp0_other_with_cast.o2e_1))
      return false;
    if (!equals(this.p2e_1, tmp0_other_with_cast.p2e_1))
      return false;
    return true;
  };
  function ReadableProperty() {
  }
  function UpdatableProperty() {
    BaseDerivedProperty.call(this);
  }
  protoOf(UpdatableProperty).l2c = function () {
    return 'updatable property';
  };
  protoOf(UpdatableProperty).h2g = function () {
    return this.j2c();
  };
  function _get_initializedHandlers__py2qj8($this) {
    var tmp0_elvis_lhs = $this.j2g_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'jetbrains.ocelot.base.observable.property.ValueProperty.<get-initializedHandlers>.<anonymous>' call
      var initHandlers = new ValueProperty$initializedHandlers$1($this);
      $this.j2g_1 = initHandlers;
      tmp = initHandlers;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function fireEvents($this, oldValue, newValue) {
    var tmp0_safe_receiver = $this.j2g_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      // Inline function 'jetbrains.ocelot.base.observable.property.ValueProperty.fireEvents.<anonymous>' call
      var event = new PropertyChangeEvent(oldValue, newValue);
      tmp0_safe_receiver.c2b(event);
    }
  }
  function ValueProperty$initializedHandlers$1($this_run) {
    this.l2g_1 = $this_run;
    EventHandlerListeners.call(this);
  }
  protoOf(ValueProperty$initializedHandlers$1).w27 = function () {
    this.l2g_1.j2g_1 = null;
  };
  function ValueProperty(value) {
    BaseReadableProperty.call(this);
    this.i2g_1 = value;
    this.j2g_1 = null;
  }
  protoOf(ValueProperty).l2c = function () {
    return 'valueProperty()';
  };
  protoOf(ValueProperty).qr = function () {
    return this.i2g_1;
  };
  protoOf(ValueProperty).t2c = function (newValue) {
    if (equals(newValue, this.i2g_1)) {
      return Unit_instance;
    }
    var oldValue = this.i2g_1;
    this.i2g_1 = newValue;
    fireEvents(this, oldValue, this.i2g_1);
  };
  protoOf(ValueProperty).k2c = function (handler) {
    return _get_initializedHandlers__py2qj8(this).z27(handler);
  };
  protoOf(ValueProperty).o27 = function (handler) {
    return this.k2c(handler);
  };
  function WritableProperty() {
  }
  function toWritableProperty(_this__u8e3s4) {
    return new toWritableProperty$1(_this__u8e3s4);
  }
  function toWritableProperty$1($this_toWritableProperty) {
    this.m2g_1 = $this_toWritableProperty;
  }
  protoOf(toWritableProperty$1).n2g = function (newValue) {
    this.m2g_1.m2();
    if (!(newValue == null)) {
      this.m2g_1.e(newValue);
    }
  };
  protoOf(toWritableProperty$1).t2c = function (newValue) {
    return this.n2g((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function asSingleItemCollectionProp(_this__u8e3s4) {
    var collection = _this__u8e3s4;
    // Inline function 'kotlin.check' call
    if (!(collection.n() <= 1)) {
      // Inline function 'jetbrains.ocelot.base.observable.property.collection.asSingleItemCollectionProp.<anonymous>' call
      var message = 'Collection ' + toString_1(collection) + ' has more than one item';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return new SingleItemCollectionProperty(collection);
  }
  function notEmptyProp(_this__u8e3s4) {
    return not(isEmptyProp(_this__u8e3s4));
  }
  function isEmptyProp(_this__u8e3s4) {
    return new isEmptyProp$1(_this__u8e3s4);
  }
  function isEmptyProp$1($this_isEmptyProp) {
    this.s2g_1 = $this_isEmptyProp;
    SimpleCollectionProperty.call(this, $this_isEmptyProp);
  }
  protoOf(isEmptyProp$1).l2c = function () {
    return 'isEmpty(' + toString_1(this.s2g_1) + ')';
  };
  protoOf(isEmptyProp$1).g2c = function () {
    return this.s2g_1.p();
  };
  function _get_disposable__lofx05($this) {
    var tmp = $this.w2g_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('disposable');
    }
  }
  function SimpleCollectionProperty$doAddListeners$listener$1(this$0) {
    this.x2g_1 = this$0;
  }
  protoOf(SimpleCollectionProperty$doAddListeners$listener$1).c27 = function (event) {
    return this.x2g_1.j2c();
  };
  protoOf(SimpleCollectionProperty$doAddListeners$listener$1).d27 = function (event) {
    return this.x2g_1.j2c();
  };
  protoOf(SimpleCollectionProperty$doAddListeners$listener$1).j27 = function (event) {
    return this.x2g_1.j2c();
  };
  function SimpleCollectionProperty(collection) {
    BaseDerivedProperty.call(this);
    this.v2g_1 = collection;
  }
  protoOf(SimpleCollectionProperty).h2c = function () {
    var listener = new SimpleCollectionProperty$doAddListeners$listener$1(this);
    this.w2g_1 = this.v2g_1.n27(listener);
  };
  protoOf(SimpleCollectionProperty).i2c = function () {
    return _get_disposable__lofx05(this).vr();
  };
  function SingleItemCollectionProperty$addHandler$listener$1(this$0, $handler) {
    this.y2g_1 = this$0;
    this.z2g_1 = $handler;
    CollectionAdapter.call(this);
  }
  protoOf(SingleItemCollectionProperty$addHandler$listener$1).c27 = function (event) {
    // Inline function 'kotlin.check' call
    if (!(this.y2g_1.a2h_1.n() === 1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.z2g_1.d28(new PropertyChangeEvent(null, event.k27()));
  };
  protoOf(SingleItemCollectionProperty$addHandler$listener$1).d27 = function (event) {
    // Inline function 'kotlin.check' call
    if (!(event.g27_1 === 0)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.z2g_1.d28(new PropertyChangeEvent(event.i27(), event.k27()));
  };
  protoOf(SingleItemCollectionProperty$addHandler$listener$1).j27 = function (event) {
    // Inline function 'kotlin.check' call
    if (!this.y2g_1.a2h_1.p()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.z2g_1.d28(new PropertyChangeEvent(event.i27(), null));
  };
  function SingleItemCollectionProperty(collection) {
    this.a2h_1 = collection;
  }
  protoOf(SingleItemCollectionProperty).l2c = function () {
    return 'SingleItemCollectionProperty(' + toString_1(this.a2h_1) + ')';
  };
  protoOf(SingleItemCollectionProperty).qr = function () {
    return firstOrNull_1(this.a2h_1);
  };
  protoOf(SingleItemCollectionProperty).b2h = function (newValue) {
    var current = this.qr();
    if (equals(current, newValue))
      return Unit_instance;
    this.a2h_1.m2();
    if (!(newValue == null)) {
      this.a2h_1.e(newValue);
    }
  };
  protoOf(SingleItemCollectionProperty).t2c = function (newValue) {
    return this.b2h((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  protoOf(SingleItemCollectionProperty).c2h = function (handler) {
    var listener = new SingleItemCollectionProperty$addHandler$listener$1(this, handler);
    return this.a2h_1.n27(listener);
  };
  protoOf(SingleItemCollectionProperty).o27 = function (handler) {
    return this.c2h(handler);
  };
  function awaitValue(_this__u8e3s4, value, $completion) {
    var tmp = new $awaitValueCOROUTINE$0(_this__u8e3s4, value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function awaitMatching(_this__u8e3s4, predicate, $completion) {
    var tmp = new $awaitMatchingCOROUTINE$1(_this__u8e3s4, predicate, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function awaitNotNull(_this__u8e3s4, $completion) {
    var tmp = new $awaitNotNullCOROUTINE$2(_this__u8e3s4, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function awaitValue$lambda($value) {
    return function (it) {
      return equals(it, $value);
    };
  }
  function awaitMatching$lambda($predicate, $deferred) {
    return function (it) {
      var tmp;
      if ($predicate(it.p2e_1)) {
        $deferred.lz(it.p2e_1);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function awaitNotNull$lambda(it) {
    return !(it == null);
  }
  function $awaitValueCOROUTINE$0(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l2h_1 = _this__u8e3s4;
    this.m2h_1 = value;
  }
  protoOf($awaitValueCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = awaitMatching(this.l2h_1, awaitValue$lambda(this.m2h_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $awaitMatchingCOROUTINE$1(_this__u8e3s4, predicate, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v2h_1 = _this__u8e3s4;
    this.w2h_1 = predicate;
  }
  protoOf($awaitMatchingCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 8;
            this.x2h_1 = this.v2h_1.qr();
            if (this.w2h_1(this.x2h_1)) {
              return this.x2h_1;
            }

            this.y2h_1 = CompletableDeferred();
            var tmp_0 = this;
            tmp_0.z2h_1 = this.v2h_1.p27(awaitMatching$lambda(this.w2h_1, this.y2h_1));
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.z9_1 = 7;
            this.b2i_1 = this.v2h_1.qr();
            if (this.w2h_1(this.b2i_1)) {
              this.a2i_1 = this.b2i_1;
              this.z9_1 = 8;
              this.y9_1 = 5;
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            this.y9_1 = 4;
            suspendResult = this.y2h_1.gw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.a2i_1 = suspendResult;
            this.z9_1 = 8;
            this.y9_1 = 5;
            var tmp_1 = this;
            continue $sm;
          case 5:
            var tmp_2 = this.a2i_1;
            this.z9_1 = 8;
            this.z2h_1.vr();
            return tmp_2;
          case 6:
            this.z9_1 = 8;
            this.z2h_1.vr();
            return Unit_instance;
          case 7:
            this.z9_1 = 8;
            var t = this.ba_1;
            this.z2h_1.vr();
            throw t;
          case 8:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 8) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $awaitNotNullCOROUTINE$2(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k2i_1 = _this__u8e3s4;
  }
  protoOf($awaitNotNullCOROUTINE$2).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = awaitMatching(this.k2i_1, awaitNotNull$lambda, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ensureNotNull(ARGUMENT);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function BaseTransformer() {
  }
  function IdentityHashMap$entries$1$iterator$1$next$1($entry) {
    this.n2i_1 = $entry;
  }
  protoOf(IdentityHashMap$entries$1$iterator$1$next$1).x = function () {
    return this.n2i_1.x().o2i_1;
  };
  protoOf(IdentityHashMap$entries$1$iterator$1$next$1).y = function () {
    return this.n2i_1.y();
  };
  function IdentityHashMap$entries$1$iterator$1(this$0) {
    this.p2i_1 = this$0.q2i_1.w().k();
  }
  protoOf(IdentityHashMap$entries$1$iterator$1).l = function () {
    return this.p2i_1.l();
  };
  protoOf(IdentityHashMap$entries$1$iterator$1).m = function () {
    var entry = this.p2i_1.m();
    return new IdentityHashMap$entries$1$iterator$1$next$1(entry);
  };
  protoOf(IdentityHashMap$entries$1$iterator$1).b5 = function () {
    return this.p2i_1.b5();
  };
  function IdentityHashMap$keys$1$iterator$1(this$0) {
    this.r2i_1 = this$0.q2i_1.u2().k();
  }
  protoOf(IdentityHashMap$keys$1$iterator$1).l = function () {
    return this.r2i_1.l();
  };
  protoOf(IdentityHashMap$keys$1$iterator$1).m = function () {
    return this.r2i_1.m().o2i_1;
  };
  protoOf(IdentityHashMap$keys$1$iterator$1).b5 = function () {
    return this.r2i_1.b5();
  };
  function mapEntry($this, element) {
    return new IdentityHashMap$mapEntry$1(element);
  }
  function IdentityHashMap$entries$1(this$0) {
    this.s2i_1 = this$0;
  }
  protoOf(IdentityHashMap$entries$1).n = function () {
    return this.s2i_1.q2i_1.w().n();
  };
  protoOf(IdentityHashMap$entries$1).uq = function (element) {
    return this.s2i_1.q2i_1.r2(new Wrapper(element.x()), element.y()) == null;
  };
  protoOf(IdentityHashMap$entries$1).e = function (element) {
    return this.uq((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(IdentityHashMap$entries$1).t2i = function (elements) {
    var result = false;
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var e = _iterator__ex2g4s.m();
      result = result || this.uq(e);
    }
    return result;
  };
  protoOf(IdentityHashMap$entries$1).o = function (elements) {
    return this.t2i(elements);
  };
  protoOf(IdentityHashMap$entries$1).m2 = function () {
    return this.s2i_1.q2i_1.m2();
  };
  protoOf(IdentityHashMap$entries$1).vq = function (element) {
    return this.s2i_1.q2i_1.w().s(mapEntry(this.s2i_1, element));
  };
  protoOf(IdentityHashMap$entries$1).s = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    return this.vq((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(IdentityHashMap$entries$1).u2i = function (elements) {
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var e = _iterator__ex2g4s.m();
      if (!this.vq(e)) {
        return false;
      }
    }
    return true;
  };
  protoOf(IdentityHashMap$entries$1).h2 = function (elements) {
    return this.u2i(elements);
  };
  protoOf(IdentityHashMap$entries$1).p = function () {
    return this.s2i_1.q2i_1.p();
  };
  protoOf(IdentityHashMap$entries$1).k = function () {
    return new IdentityHashMap$entries$1$iterator$1(this.s2i_1);
  };
  protoOf(IdentityHashMap$entries$1).v2i = function (element) {
    return this.s2i_1.q2i_1.w().k2(mapEntry(this.s2i_1, element));
  };
  protoOf(IdentityHashMap$entries$1).k2 = function (element) {
    if (!(!(element == null) ? isInterface(element, MutableEntry) : false))
      return false;
    return this.v2i((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  protoOf(IdentityHashMap$entries$1).w2i = function (elements) {
    var tmp = this.s2i_1.q2i_1.w();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.base.observable.transform.<no name provided>.removeAll.<anonymous>' call
      var tmp$ret$0 = mapEntry(this.s2i_1, item);
      destination.e(tmp$ret$0);
    }
    return tmp.k1(destination);
  };
  protoOf(IdentityHashMap$entries$1).k1 = function (elements) {
    return this.w2i(elements);
  };
  protoOf(IdentityHashMap$entries$1).x2i = function (elements) {
    var tmp = this.s2i_1.q2i_1.w();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.base.observable.transform.<no name provided>.retainAll.<anonymous>' call
      var tmp$ret$0 = mapEntry(this.s2i_1, item);
      destination.e(tmp$ret$0);
    }
    return tmp.l2(destination);
  };
  protoOf(IdentityHashMap$entries$1).l2 = function (elements) {
    return this.x2i(elements);
  };
  function IdentityHashMap$mapEntry$1($element) {
    this.y2i_1 = $element;
  }
  protoOf(IdentityHashMap$mapEntry$1).x = function () {
    return new Wrapper(this.y2i_1.x());
  };
  protoOf(IdentityHashMap$mapEntry$1).y = function () {
    return this.y2i_1.y();
  };
  function IdentityHashMap$keys$1(this$0) {
    this.z2i_1 = this$0;
  }
  protoOf(IdentityHashMap$keys$1).n = function () {
    return this.z2i_1.q2i_1.u2().n();
  };
  protoOf(IdentityHashMap$keys$1).n7 = function (element) {
    return this.z2i_1.q2i_1.u2().e(new Wrapper(element));
  };
  protoOf(IdentityHashMap$keys$1).e = function (element) {
    return this.n7((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(IdentityHashMap$keys$1).a2j = function (elements) {
    var tmp = this.z2i_1.q2i_1.u2();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.base.observable.transform.<no name provided>.addAll.<anonymous>' call
      var tmp$ret$0 = new Wrapper(item);
      destination.e(tmp$ret$0);
    }
    return tmp.o(destination);
  };
  protoOf(IdentityHashMap$keys$1).o = function (elements) {
    return this.a2j(elements);
  };
  protoOf(IdentityHashMap$keys$1).m2 = function () {
    return this.z2i_1.q2i_1.u2().m2();
  };
  protoOf(IdentityHashMap$keys$1).q6 = function (element) {
    return this.z2i_1.q2i_1.u2().s(new Wrapper(element));
  };
  protoOf(IdentityHashMap$keys$1).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.q6((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(IdentityHashMap$keys$1).b2j = function (elements) {
    var tmp = this.z2i_1.q2i_1.u2();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.base.observable.transform.<no name provided>.containsAll.<anonymous>' call
      var tmp$ret$0 = new Wrapper(item);
      destination.e(tmp$ret$0);
    }
    return tmp.h2(destination);
  };
  protoOf(IdentityHashMap$keys$1).h2 = function (elements) {
    return this.b2j(elements);
  };
  protoOf(IdentityHashMap$keys$1).p = function () {
    return this.z2i_1.q2i_1.u2().p();
  };
  protoOf(IdentityHashMap$keys$1).k = function () {
    return new IdentityHashMap$keys$1$iterator$1(this.z2i_1);
  };
  protoOf(IdentityHashMap$keys$1).s2 = function (element) {
    return this.z2i_1.q2i_1.u2().k2(new Wrapper(element));
  };
  protoOf(IdentityHashMap$keys$1).k2 = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.s2((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(IdentityHashMap$keys$1).c2j = function (elements) {
    var tmp = this.z2i_1.q2i_1.u2();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.base.observable.transform.<no name provided>.removeAll.<anonymous>' call
      var tmp$ret$0 = new Wrapper(item);
      destination.e(tmp$ret$0);
    }
    return tmp.k1(destination);
  };
  protoOf(IdentityHashMap$keys$1).k1 = function (elements) {
    return this.c2j(elements);
  };
  protoOf(IdentityHashMap$keys$1).d2j = function (elements) {
    var tmp = this.z2i_1.q2i_1.u2();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.base.observable.transform.<no name provided>.retainAll.<anonymous>' call
      var tmp$ret$0 = new Wrapper(item);
      destination.e(tmp$ret$0);
    }
    return tmp.l2(destination);
  };
  protoOf(IdentityHashMap$keys$1).l2 = function (elements) {
    return this.d2j(elements);
  };
  function IdentityHashMap() {
    this.q2i_1 = HashMap_init_$Create$();
  }
  protoOf(IdentityHashMap).n = function () {
    return this.q2i_1.n();
  };
  protoOf(IdentityHashMap).w2 = function (key) {
    return this.q2i_1.w2(new Wrapper(key));
  };
  protoOf(IdentityHashMap).x2 = function (value) {
    return this.q2i_1.x2(value);
  };
  protoOf(IdentityHashMap).y2 = function (key) {
    return this.q2i_1.y2(new Wrapper(key));
  };
  protoOf(IdentityHashMap).p = function () {
    return this.q2i_1.p();
  };
  protoOf(IdentityHashMap).w = function () {
    return new IdentityHashMap$entries$1(this);
  };
  protoOf(IdentityHashMap).u2 = function () {
    return new IdentityHashMap$keys$1(this);
  };
  protoOf(IdentityHashMap).v2 = function () {
    return this.q2i_1.v2();
  };
  protoOf(IdentityHashMap).m2 = function () {
    this.q2i_1.m2();
  };
  protoOf(IdentityHashMap).r2 = function (key, value) {
    return this.q2i_1.r2(new Wrapper(key), value);
  };
  protoOf(IdentityHashMap).t2 = function (from) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(IdentityHashMap).s2 = function (key) {
    return this.q2i_1.s2(new Wrapper(key));
  };
  function Wrapper(value) {
    this.o2i_1 = value;
  }
  protoOf(Wrapper).equals = function (other) {
    if (other instanceof Wrapper) {
      return other.o2i_1 === this.o2i_1;
    }
    return false;
  };
  protoOf(Wrapper).hashCode = function () {
    return 0;
  };
  function SimpleTransformation(source, target, disposable) {
    Transformation.call(this);
    this.f2j_1 = source;
    this.g2j_1 = target;
    this.h2j_1 = disposable;
  }
  protoOf(SimpleTransformation).i2j = function () {
    return this.g2j_1;
  };
  protoOf(SimpleTransformation).j2j = function () {
    return this.h2j_1.vr();
  };
  function TerminalTransformation() {
    this.k2j_1 = false;
  }
  protoOf(TerminalTransformation).vr = function () {
    // Inline function 'kotlin.check' call
    if (!!this.k2j_1) {
      // Inline function 'jetbrains.ocelot.base.observable.transform.TerminalTransformation.dispose.<anonymous>' call
      var message = 'Already disposed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.k2j_1 = true;
    this.j2j();
  };
  protoOf(TerminalTransformation).j2j = function () {
  };
  function Transformation() {
    TerminalTransformation.call(this);
  }
  function Transformers$fromFun$1$transform$1($from, $target) {
    this.m2j_1 = $from;
    this.n2j_1 = $target;
    Transformation.call(this);
  }
  protoOf(Transformers$fromFun$1$transform$1).i2j = function () {
    return this.n2j_1;
  };
  function Transformers$listMap$1$transform$listener$1($transformer, $to, $itemRegistrations) {
    this.o2j_1 = $transformer;
    this.p2j_1 = $to;
    this.q2j_1 = $itemRegistrations;
  }
  protoOf(Transformers$listMap$1$transform$listener$1).r2j = function (event) {
    var transformation = this.o2j_1.l2i(event.k27());
    this.p2j_1.p2(event.g27_1, transformation.i2j());
    this.q2j_1.p2(event.g27_1, transformation);
  };
  protoOf(Transformers$listMap$1$transform$listener$1).c27 = function (event) {
    return this.r2j(event);
  };
  protoOf(Transformers$listMap$1$transform$listener$1).s2j = function (event) {
    var transformation = this.o2j_1.l2i(event.k27());
    this.p2j_1.o2(event.g27_1, transformation.i2j());
    this.q2j_1.o2(event.g27_1, transformation).vr();
  };
  protoOf(Transformers$listMap$1$transform$listener$1).d27 = function (event) {
    return this.s2j(event);
  };
  protoOf(Transformers$listMap$1$transform$listener$1).t2j = function (event) {
    this.p2j_1.q2(event.g27_1);
    this.q2j_1.q2(event.g27_1).vr();
  };
  protoOf(Transformers$listMap$1$transform$listener$1).j27 = function (event) {
    return this.t2j(event);
  };
  function Transformers$listMap$1$transform$$inlined$toDisposable$1($itemRegistrations, $reg) {
    this.u2j_1 = $itemRegistrations;
    this.v2j_1 = $reg;
  }
  protoOf(Transformers$listMap$1$transform$$inlined$toDisposable$1).vr = function () {
    var _iterator__ex2g4s = this.u2j_1.k();
    while (_iterator__ex2g4s.l()) {
      var r = _iterator__ex2g4s.m();
      r.vr();
    }
    this.v2j_1.vr();
    return Unit_instance;
  };
  function watch($this, container, list) {
    return list.n27(new Transformers$flattenList$3$transform$sourceListener$1$watch$1($this.y2j_1, container, $this.z2j_1, $this.a2k_1, $this.c2k_1));
  }
  function Transformers$flattenList$3$transform$sourceListener$1$watch$1(this$0, $container, $from, $sizes, $to) {
    this.d2k_1 = this$0;
    this.e2k_1 = $container;
    this.f2k_1 = $from;
    this.g2k_1 = $sizes;
    this.h2k_1 = $to;
  }
  protoOf(Transformers$flattenList$3$transform$sourceListener$1$watch$1).c27 = function (event) {
    var startIndex = getStartResultIndex(this.d2k_1, this.e2k_1, this.f2k_1, this.g2k_1);
    var tmp0 = this.g2k_1;
    var tmp1 = this.e2k_1;
    // Inline function 'kotlin.collections.set' call
    var value = ensureNotNull(this.g2k_1.y2(this.e2k_1)) + 1 | 0;
    tmp0.r2(tmp1, value);
    this.h2k_1.p2(startIndex + event.g27_1 | 0, event.k27());
  };
  protoOf(Transformers$flattenList$3$transform$sourceListener$1$watch$1).d27 = function (event) {
    var startIndex = getStartResultIndex(this.d2k_1, this.e2k_1, this.f2k_1, this.g2k_1);
    this.h2k_1.o2(startIndex + event.g27_1 | 0, event.k27());
  };
  protoOf(Transformers$flattenList$3$transform$sourceListener$1$watch$1).j27 = function (event) {
    var tmp0 = this.g2k_1;
    var tmp1 = this.e2k_1;
    // Inline function 'kotlin.collections.set' call
    var value = ensureNotNull(this.g2k_1.y2(this.e2k_1)) - 1 | 0;
    tmp0.r2(tmp1, value);
    this.h2k_1.k2(event.i27());
  };
  function getStartResultIndex($this, event, sourceList, sizes) {
    var resultIndex = 0;
    var iterator = sourceList.k();
    var current = iterator.m();
    while (!(current === event)) {
      resultIndex = resultIndex + getValue_0(sizes, current) | 0;
      current = iterator.m();
    }
    return resultIndex;
  }
  function Transformers$flattenList$3$transform$sourceListener$1($f, $t, this$0, $from, $sizes, $registrations, $to) {
    this.w2j_1 = $f;
    this.x2j_1 = $t;
    this.y2j_1 = this$0;
    this.z2j_1 = $from;
    this.a2k_1 = $sizes;
    this.b2k_1 = $registrations;
    this.c2k_1 = $to;
    CollectionAdapter.call(this);
  }
  protoOf(Transformers$flattenList$3$transform$sourceListener$1).r2j = function (event) {
    var selected = this.w2j_1(event.k27());
    var transform = this.x2j_1.l2i(selected);
    var target = transform.i2j();
    var startIndex = getStartResultIndex(this.y2j_1, event.k27(), this.z2j_1, this.a2k_1);
    var tmp0 = this.a2k_1;
    var tmp1 = event.k27();
    // Inline function 'kotlin.collections.set' call
    var value = target.n();
    tmp0.r2(tmp1, value);
    var reg = watch(this, event.k27(), target);
    var tmp3 = this.b2k_1;
    var tmp4 = event.k27();
    // Inline function 'kotlin.collections.set' call
    var value_0 = reg.sr(transform);
    tmp3.r2(tmp4, value_0);
    var _iterator__ex2g4s = target.k();
    while (_iterator__ex2g4s.l()) {
      var r = _iterator__ex2g4s.m();
      var _unary__edvuaz = startIndex;
      startIndex = _unary__edvuaz + 1 | 0;
      this.c2k_1.p2(_unary__edvuaz, r);
    }
  };
  protoOf(Transformers$flattenList$3$transform$sourceListener$1).c27 = function (event) {
    return this.r2j(event);
  };
  protoOf(Transformers$flattenList$3$transform$sourceListener$1).t2j = function (event) {
    var selected = this.w2j_1(event.i27());
    var transformation = this.x2j_1.l2i(selected);
    this.a2k_1.s2(event.i27());
    ensureNotNull(this.b2k_1.s2(event.i27())).vr();
    this.c2k_1.k1(transformation.i2j());
    transformation.vr();
  };
  protoOf(Transformers$flattenList$3$transform$sourceListener$1).j27 = function (event) {
    return this.t2j(event);
  };
  function Transformers$flattenList$3$transform$$inlined$toDisposable$1($from, $registrations, $sourceRegistration) {
    this.i2k_1 = $from;
    this.j2k_1 = $registrations;
    this.k2k_1 = $sourceRegistration;
  }
  protoOf(Transformers$flattenList$3$transform$$inlined$toDisposable$1).vr = function () {
    var _iterator__ex2g4s = this.i2k_1.k();
    while (_iterator__ex2g4s.l()) {
      var s = _iterator__ex2g4s.m();
      ensureNotNull(this.j2k_1.s2(s)).vr();
    }
    this.k2k_1.vr();
    return Unit_instance;
  };
  function Transformers$withPlaceHoldersIfEmpty$1$transform$fromRegistration$1($from, $placeholder, $to) {
    this.m2k_1 = $placeholder;
    this.n2k_1 = $to;
    CollectionAdapter.call(this);
    this.l2k_1 = null;
    if ($from.p()) {
      this.l2k_1 = $placeholder();
      $to.e(ensureNotNull(this.l2k_1));
    }
  }
  protoOf(Transformers$withPlaceHoldersIfEmpty$1$transform$fromRegistration$1).c27 = function (event) {
    if (!(this.l2k_1 == null)) {
      this.n2k_1.k2(ensureNotNull(this.l2k_1));
      this.l2k_1 = null;
    }
    this.n2k_1.p2(event.g27_1, event.k27());
  };
  protoOf(Transformers$withPlaceHoldersIfEmpty$1$transform$fromRegistration$1).d27 = function (event) {
    // Inline function 'kotlin.check' call
    if (!(this.l2k_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.n2k_1.o2(event.g27_1, event.k27());
  };
  protoOf(Transformers$withPlaceHoldersIfEmpty$1$transform$fromRegistration$1).j27 = function (event) {
    this.n2k_1.q2(event.g27_1);
    if (this.n2k_1.p()) {
      // Inline function 'kotlin.check' call
      if (!(this.l2k_1 == null)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      this.l2k_1 = this.m2k_1();
      this.n2k_1.e(ensureNotNull(this.l2k_1));
    }
  };
  function Transformers$propertyToList$o$transform$o($to, $from) {
    return function () {
      var tmp;
      if (!$to.p() && $from.qr() === $to.q(0)) {
        return Unit_instance;
      }
      $to.m2();
      var tmp_0;
      if (!($from.qr() == null)) {
        $to.e(ensureNotNull($from.qr()));
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Transformers$propertyToList$o$transform$lambda($sync) {
    return function (it) {
      $sync();
      return Unit_instance;
    };
  }
  function flattenList($this, f, t) {
    return new Transformers$flattenList$3(f, t);
  }
  function Transformers$fromFun$1($f) {
    this.o2k_1 = $f;
    BaseTransformer.call(this);
  }
  protoOf(Transformers$fromFun$1).l2i = function (from) {
    var target = this.o2k_1(from);
    return new Transformers$fromFun$1$transform$1(from, target);
  };
  protoOf(Transformers$fromFun$1).m2i = function (from, to) {
    throw UnsupportedOperationException_init_$Create$();
  };
  function Transformers$listMap$1($transformer) {
    this.p2k_1 = $transformer;
    BaseTransformer.call(this);
  }
  protoOf(Transformers$listMap$1).q2k = function (from) {
    return this.r2k(from, new ObservableArrayList());
  };
  protoOf(Transformers$listMap$1).l2i = function (from) {
    return this.q2k((!(from == null) ? isInterface(from, ObservableList) : false) ? from : THROW_CCE());
  };
  protoOf(Transformers$listMap$1).r2k = function (from, to) {
    var itemRegistrations = ArrayList_init_$Create$();
    var listener = new Transformers$listMap$1$transform$listener$1(this.p2k_1, to, itemRegistrations);
    var inductionVariable = 0;
    var last = from.n() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        listener.r2j(new CollectionItemEvent(null, from.q(i), i, EventType_ADD_getInstance()));
      }
       while (inductionVariable <= last);
    var reg = from.n27(listener);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$0 = new Transformers$listMap$1$transform$$inlined$toDisposable$1(itemRegistrations, reg);
    return new SimpleTransformation(from, to, tmp$ret$0);
  };
  protoOf(Transformers$listMap$1).m2i = function (from, to) {
    var tmp = (!(from == null) ? isInterface(from, ObservableList) : false) ? from : THROW_CCE();
    return this.r2k(tmp, (!(to == null) ? isInterface(to, MutableObservableList) : false) ? to : THROW_CCE());
  };
  function Transformers$flattenList$lambda(it) {
    return it;
  }
  function Transformers$flattenList$3($f, $t) {
    this.s2k_1 = $f;
    this.t2k_1 = $t;
    BaseTransformer.call(this);
  }
  protoOf(Transformers$flattenList$3).q2k = function (from) {
    return this.u2k(from, new ObservableArrayList());
  };
  protoOf(Transformers$flattenList$3).l2i = function (from) {
    return this.q2k((!(from == null) ? isInterface(from, ObservableList) : false) ? from : THROW_CCE());
  };
  protoOf(Transformers$flattenList$3).u2k = function (from, to) {
    var registrations = new IdentityHashMap();
    var sizes = new IdentityHashMap();
    var sourceListener = new Transformers$flattenList$3$transform$sourceListener$1(this.s2k_1, this.t2k_1, this, from, sizes, registrations, to);
    var sourceRegistration = from.n27(sourceListener);
    var iterator = from.k();
    var index = 0;
    while (iterator.l()) {
      var index_0 = index;
      index = index + 1 | 0;
      var s = iterator.m();
      var event = new CollectionItemEvent(null, s, index_0, EventType_ADD_getInstance());
      sourceListener.r2j(event);
    }
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$0 = new Transformers$flattenList$3$transform$$inlined$toDisposable$1(from, registrations, sourceRegistration);
    return new SimpleTransformation(from, to, tmp$ret$0);
  };
  protoOf(Transformers$flattenList$3).m2i = function (from, to) {
    var tmp = (!(from == null) ? isInterface(from, ObservableList) : false) ? from : THROW_CCE();
    return this.u2k(tmp, (!(to == null) ? isInterface(to, MutableObservableList) : false) ? to : THROW_CCE());
  };
  function Transformers$withPlaceHoldersIfEmpty$1($placeholder) {
    this.v2k_1 = $placeholder;
    BaseTransformer.call(this);
  }
  protoOf(Transformers$withPlaceHoldersIfEmpty$1).w2k = function (from) {
    return this.x2k(from, ArrayList_init_$Create$());
  };
  protoOf(Transformers$withPlaceHoldersIfEmpty$1).l2i = function (from) {
    return this.w2k((!(from == null) ? isInterface(from, ObservableList) : false) ? from : THROW_CCE());
  };
  protoOf(Transformers$withPlaceHoldersIfEmpty$1).x2k = function (from, to) {
    var fromRegistration = from.n27(new Transformers$withPlaceHoldersIfEmpty$1$transform$fromRegistration$1(from, this.v2k_1, to));
    return new SimpleTransformation(from, to, fromRegistration);
  };
  protoOf(Transformers$withPlaceHoldersIfEmpty$1).m2i = function (from, to) {
    var tmp = (!(from == null) ? isInterface(from, ObservableList) : false) ? from : THROW_CCE();
    return this.x2k(tmp, (!(to == null) ? isInterface(to, KtMutableList) : false) ? to : THROW_CCE());
  };
  function Transformers$propertyToList$1() {
    BaseTransformer.call(this);
  }
  protoOf(Transformers$propertyToList$1).y2k = function (from) {
    return this.z2k(from, new ObservableArrayList());
  };
  protoOf(Transformers$propertyToList$1).l2i = function (from) {
    return this.y2k((!(from == null) ? isInterface(from, ReadableProperty) : false) ? from : THROW_CCE());
  };
  protoOf(Transformers$propertyToList$1).z2k = function (from, to) {
    // Inline function 'kotlin.check' call
    if (!to.p()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var sync = Transformers$propertyToList$o$transform$o(to, from);
    sync();
    return new SimpleTransformation(from, to, from.p27(Transformers$propertyToList$o$transform$lambda(sync)));
  };
  protoOf(Transformers$propertyToList$1).m2i = function (from, to) {
    var tmp = (!(from == null) ? isInterface(from, ReadableProperty) : false) ? from : THROW_CCE();
    return this.z2k(tmp, (!(to == null) ? isInterface(to, MutableObservableList) : false) ? to : THROW_CCE());
  };
  function Transformers() {
  }
  protoOf(Transformers).a2l = function (f) {
    return new Transformers$fromFun$1(f);
  };
  protoOf(Transformers).b2l = function (transformer) {
    return new Transformers$listMap$1(transformer);
  };
  protoOf(Transformers).c2l = function (f) {
    return this.b2l(this.a2l(f));
  };
  protoOf(Transformers).d2l = function (t) {
    return flattenList(this, Transformers$flattenList$lambda, t);
  };
  protoOf(Transformers).e2l = function (placeholder) {
    return new Transformers$withPlaceHoldersIfEmpty$1(placeholder);
  };
  protoOf(Transformers).f2l = function () {
    return new Transformers$propertyToList$1();
  };
  var Transformers_instance;
  function Transformers_getInstance() {
    return Transformers_instance;
  }
  function Asyncs$constant$1($value) {
    this.g2l_1 = $value;
  }
  protoOf(Asyncs$constant$1).h2l = function (successHandler) {
    successHandler(this.g2l_1);
    return Companion_getInstance_25().wr_1;
  };
  protoOf(Asyncs$constant$1).i2l = function (successHandler) {
    return this.h2l(successHandler);
  };
  protoOf(Asyncs$constant$1).j2l = function (successHandler, failureHandler) {
    return this.h2l(successHandler);
  };
  protoOf(Asyncs$constant$1).k2l = function (successHandler, failureHandler) {
    return this.j2l(successHandler, failureHandler);
  };
  function Asyncs$failure$1($t) {
    this.l2l_1 = $t;
  }
  protoOf(Asyncs$failure$1).h2l = function (successHandler) {
    return Companion_getInstance_25().wr_1;
  };
  protoOf(Asyncs$failure$1).i2l = function (successHandler) {
    return this.h2l(successHandler);
  };
  protoOf(Asyncs$failure$1).j2l = function (successHandler, failureHandler) {
    return this.m2l(failureHandler);
  };
  protoOf(Asyncs$failure$1).k2l = function (successHandler, failureHandler) {
    return this.j2l(successHandler, failureHandler);
  };
  protoOf(Asyncs$failure$1).m2l = function (failureHandler) {
    failureHandler(this.l2l_1);
    return Companion_getInstance_25().wr_1;
  };
  function AsyncResolver$success$ref($boundThis) {
    var l = function (p0) {
      $boundThis.n2l(p0);
      return Unit_instance;
    };
    l.callableName = 'success';
    return l;
  }
  function AsyncResolver$failure$ref($boundThis) {
    var l = function (p0) {
      $boundThis.o2l(p0);
      return Unit_instance;
    };
    l.callableName = 'failure';
    return l;
  }
  function Asyncs() {
  }
  protoOf(Asyncs).p2l = function (value) {
    return new Asyncs$constant$1(value);
  };
  protoOf(Asyncs).q2l = function (t) {
    return new Asyncs$failure$1(t);
  };
  protoOf(Asyncs).r2l = function () {
    return this.p2l(Unit_instance);
  };
  protoOf(Asyncs).s2l = function (from, to) {
    var tmp = AsyncResolver$success$ref(to);
    return from.k2l(tmp, AsyncResolver$failure$ref(to));
  };
  var Asyncs_instance;
  function Asyncs_getInstance() {
    return Asyncs_instance;
  }
  function clearHandlers($this) {
    $this.x2l_1.m2();
    $this.y2l_1.m2();
  }
  function alreadyHandled($this) {
    return $this.u2l_1 || $this.w2l_1;
  }
  function SuccessItem(value) {
    this.z2l_1 = value;
  }
  protoOf(SuccessItem).qr = function () {
    return this.z2l_1;
  };
  function SimpleAsync$onResult$$inlined$toDisposable$1($successRegistration, $failureRegistration) {
    this.a2m_1 = $successRegistration;
    this.b2m_1 = $failureRegistration;
  }
  protoOf(SimpleAsync$onResult$$inlined$toDisposable$1).vr = function () {
    this.a2m_1.vr();
    this.b2m_1.vr();
    return Unit_instance;
  };
  function SimpleAsync$success$lambda(this$0) {
    return function (handler) {
      handler(ensureNotNull(this$0.t2l_1).qr());
      return Unit_instance;
    };
  }
  function SimpleAsync$failure$lambda(this$0) {
    return function (handler) {
      handler(ensureNotNull(this$0.v2l_1));
      return Unit_instance;
    };
  }
  function SimpleAsync() {
    this.t2l_1 = null;
    this.u2l_1 = false;
    this.v2l_1 = null;
    this.w2l_1 = false;
    this.x2l_1 = new Listeners();
    this.y2l_1 = new Listeners();
  }
  protoOf(SimpleAsync).i2l = function (successHandler) {
    var tmp;
    if (alreadyHandled(this)) {
      if (this.u2l_1) {
        successHandler(ensureNotNull(this.t2l_1).qr());
      }
      tmp = Companion_getInstance_25().wr_1;
    } else {
      tmp = this.x2l_1.z27(successHandler);
    }
    return tmp;
  };
  protoOf(SimpleAsync).k2l = function (successHandler, failureHandler) {
    var successRegistration = this.i2l(successHandler);
    var failureRegistration = this.m2l(failureHandler);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new SimpleAsync$onResult$$inlined$toDisposable$1(successRegistration, failureRegistration);
  };
  protoOf(SimpleAsync).m2l = function (failureHandler) {
    var tmp;
    if (alreadyHandled(this)) {
      if (this.w2l_1) {
        failureHandler(ensureNotNull(this.v2l_1));
      }
      tmp = Companion_getInstance_25().wr_1;
    } else {
      tmp = this.y2l_1.z27(failureHandler);
    }
    return tmp;
  };
  protoOf(SimpleAsync).n2l = function (result) {
    // Inline function 'kotlin.check' call
    if (!!alreadyHandled(this)) {
      // Inline function 'jetbrains.ocelot.base.async.SimpleAsync.success.<anonymous>' call
      var message = 'Async already completed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.t2l_1 = new SuccessItem(result);
    this.u2l_1 = true;
    var tmp = this.x2l_1;
    tmp.a28(SimpleAsync$success$lambda(this));
    clearHandlers(this);
  };
  protoOf(SimpleAsync).o2l = function (throwable) {
    // Inline function 'kotlin.check' call
    if (!!alreadyHandled(this)) {
      // Inline function 'jetbrains.ocelot.base.async.SimpleAsync.failure.<anonymous>' call
      var message = 'Async already completed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.v2l_1 = throwable;
    this.w2l_1 = true;
    var tmp = this.y2l_1;
    tmp.a28(SimpleAsync$failure$lambda(this));
    clearHandlers(this);
  };
  function ThrowableCollectionException_init_$Init$(throwables, $this) {
    RuntimeException_init_$Init$_1('size=' + throwables.n(), throwables.q(0), $this);
    ThrowableCollectionException.call($this);
    $this.c2m_1.o(throwables);
    return $this;
  }
  function ThrowableCollectionException_init_$Create$(throwables) {
    var tmp = ThrowableCollectionException_init_$Init$(throwables, objectCreate(protoOf(ThrowableCollectionException)));
    captureStack(tmp, ThrowableCollectionException_init_$Create$);
    return tmp;
  }
  protoOf(ThrowableCollectionException).d2m = function () {
    return this.c2m_1;
  };
  function ThrowableCollectionException() {
    captureStack(this, ThrowableCollectionException);
    this.c2m_1 = ArrayList_init_$Create$();
  }
  function await_1(_this__u8e3s4, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.iy();
    // Inline function 'jetbrains.ocelot.base.async.coroutines.await.<anonymous>' call
    var successHandler = await$lambda_1(cancellable);
    var failureHandler = await$lambda_2(cancellable);
    _this__u8e3s4.k2l(successHandler, failureHandler);
    return cancellable.py();
  }
  function await$lambda_1($continuation) {
    return function (result) {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(result);
      this_0.ja(tmp$ret$0);
      return Unit_instance;
    };
  }
  function await$lambda_2($continuation) {
    return function (exception) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      this_0.ja(tmp$ret$0);
      return Unit_instance;
    };
  }
  function launchWith(_this__u8e3s4, asyncTracker, block) {
    asyncTracker.e2m();
    return launch(_this__u8e3s4, VOID, VOID, launchWith$slambda_0(block, asyncTracker, null));
  }
  function AsyncTracker$Companion$EMPTY$1() {
  }
  function Companion_30() {
    Companion_instance_30 = this;
    var tmp = this;
    tmp.g2m_1 = new AsyncTracker$Companion$EMPTY$1();
  }
  var Companion_instance_30;
  function Companion_getInstance_30() {
    if (Companion_instance_30 == null)
      new Companion_30();
    return Companion_instance_30;
  }
  function AsyncTracker() {
  }
  function launchWith$slambda($block, $asyncTracker, resultContinuation) {
    this.p2m_1 = $block;
    this.q2m_1 = $asyncTracker;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchWith$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(launchWith$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchWith$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 4;
            this.y9_1 = 2;
            suspendResult = this.p2m_1(this.r2m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.s2m_1 = suspendResult;
            this.z9_1 = 5;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 5;
            this.q2m_1.f2m();
            return Unit_instance;
          case 4:
            this.z9_1 = 5;
            var t = this.ba_1;
            this.q2m_1.f2m();
            throw t;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(launchWith$slambda).i1l = function ($this$launch, completion) {
    var i = new launchWith$slambda(this.p2m_1, this.q2m_1, completion);
    i.r2m_1 = $this$launch;
    return i;
  };
  function launchWith$slambda_0($block, $asyncTracker, resultContinuation) {
    var i = new launchWith$slambda($block, $asyncTracker, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function DefaultAsyncEdt() {
  }
  function EdtException() {
  }
  function EdtTask() {
  }
  function NullEventDispatchThread() {
    DefaultAsyncEdt.call(this);
  }
  protoOf(NullEventDispatchThread).t2m = function () {
    return new Long(0, 0);
  };
  protoOf(NullEventDispatchThread).u2m = function (task) {
  };
  protoOf(NullEventDispatchThread).v2m = function (delay, task) {
    return Companion_getInstance_25().wr_1;
  };
  protoOf(NullEventDispatchThread).w2m = function (period, task) {
    return Companion_getInstance_25().wr_1;
  };
  function get_asCoroutineDispatcher(_this__u8e3s4) {
    return new EdtCoroutineDispatcher(_this__u8e3s4);
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0(function_0) {
    this.x2m_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0).wy = function () {
    return this.x2m_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0).b4 = function () {
    return this.x2m_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_0(function_0) {
    this.y2m_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_0).wy = function () {
    return this.y2m_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_0).b4 = function () {
    return this.y2m_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_0).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_1(function_0) {
    this.z2m_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_1).wy = function () {
    return this.z2m_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_1).b4 = function () {
    return this.z2m_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_1).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$kotlinx_coroutines_DisposableHandle$0(function_0) {
    this.a2n_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).vr = function () {
    return this.a2n_1();
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).b4 = function () {
    return this.a2n_1;
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function Runnable$run$ref($boundThis) {
    var l = function () {
      $boundThis.wy();
      return Unit_instance;
    };
    l.callableName = 'run';
    return l;
  }
  function EdtCoroutineDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
    return function () {
      // Inline function 'kotlin.with' call
      // Inline function 'jetbrains.ocelot.base.edt.coroutines.EdtCoroutineDispatcher.scheduleResumeAfterDelay.<anonymous>.<anonymous>' call
      $continuation.sw(this$0, Unit_instance);
      return Unit_instance;
    };
  }
  function EdtCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0($disposable) {
    return function (it) {
      $disposable.vr();
      return Unit_instance;
    };
  }
  function EdtCoroutineDispatcher$invokeOnTimeout$lambda($block) {
    return function () {
      $block.wy();
      return Unit_instance;
    };
  }
  function EdtCoroutineDispatcher$invokeOnTimeout$lambda_0($disposable) {
    return function () {
      $disposable.vr();
      return Unit_instance;
    };
  }
  function EdtCoroutineDispatcher(edt) {
    CoroutineDispatcher.call(this);
    this.c2n_1 = edt;
  }
  protoOf(EdtCoroutineDispatcher).tz = function (context, block) {
    var tmp = Runnable$run$ref(block);
    return this.c2n_1.u2m(new sam$jetbrains_ocelot_base_edt_EdtTask$0(tmp));
  };
  protoOf(EdtCoroutineDispatcher).zz = function (timeMillis, continuation) {
    var tmp = EdtCoroutineDispatcher$scheduleResumeAfterDelay$lambda(continuation, this);
    var task = new sam$jetbrains_ocelot_base_edt_EdtTask$0_0(tmp);
    var disposable = this.c2n_1.v2m(timeMillis.z3(), task);
    continuation.rw(EdtCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0(disposable));
  };
  protoOf(EdtCoroutineDispatcher).a10 = function (timeMillis, block, context) {
    var tmp = EdtCoroutineDispatcher$invokeOnTimeout$lambda(block);
    var task = new sam$jetbrains_ocelot_base_edt_EdtTask$0_1(tmp);
    var disposable = this.c2n_1.v2m(timeMillis.z3(), task);
    var tmp_0 = EdtCoroutineDispatcher$invokeOnTimeout$lambda_0(disposable);
    return new sam$kotlinx_coroutines_DisposableHandle$0(tmp_0);
  };
  function doExecute($this, task) {
    var tmp;
    try {
      task.wy();
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().ps_1.os(t);
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function timerDisposable($this, timer) {
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new JsEventDispatchThread$timerDisposable$$inlined$toDisposable$1(timer);
  }
  function EdtTask$run$ref($boundThis) {
    var l = function () {
      $boundThis.wy();
      return Unit_instance;
    };
    l.callableName = 'run';
    return l;
  }
  function JsEventDispatchThread$schedule$lambda($task) {
    return function () {
      doExecute(JsEventDispatchThread_getInstance(), $task);
      return Unit_instance;
    };
  }
  function JsEventDispatchThread$scheduleRepeating$lambda($lastInvocation, $period, $task) {
    return function () {
      var current = JsEventDispatchThread_getInstance().t2m();
      var tmp;
      if (current.j3($lastInvocation._v).d1(toLong($period)) >= 0) {
        $lastInvocation._v = current;
        doExecute(JsEventDispatchThread_getInstance(), $task);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function JsEventDispatchThread$timerDisposable$$inlined$toDisposable$1($timer) {
    this.d2n_1 = $timer;
  }
  protoOf(JsEventDispatchThread$timerDisposable$$inlined$toDisposable$1).vr = function () {
    var tmp;
    if (this.d2n_1.j2n()) {
      this.d2n_1.i2n();
      tmp = Unit_instance;
    }
    return tmp;
  };
  function JsEventDispatchThread() {
    JsEventDispatchThread_instance = this;
    DefaultAsyncEdt.call(this);
  }
  protoOf(JsEventDispatchThread).t2m = function () {
    return currentTimeMillis();
  };
  protoOf(JsEventDispatchThread).u2m = function (task) {
    var tmp = Companion_getInstance_31().k2n_1;
    return tmp.l2n(EdtTask$run$ref(task));
  };
  protoOf(JsEventDispatchThread).v2m = function (delay, task) {
    var timer = new Timer(JsEventDispatchThread$schedule$lambda(task));
    timer.m2n(delay);
    return timerDisposable(this, timer);
  };
  protoOf(JsEventDispatchThread).w2m = function (period, task) {
    var lastInvocation = {_v: new Long(0, 0)};
    var timer = new Timer(JsEventDispatchThread$scheduleRepeating$lambda(lastInvocation, period, task));
    timer.n2n(period);
    return timerDisposable(this, timer);
  };
  var JsEventDispatchThread_instance;
  function JsEventDispatchThread_getInstance() {
    if (JsEventDispatchThread_instance == null)
      new JsEventDispatchThread();
    return JsEventDispatchThread_instance;
  }
  function Companion_31() {
    Companion_instance_31 = this;
    this.k2n_1 = new SchedulerImpl();
  }
  var Companion_instance_31;
  function Companion_getInstance_31() {
    if (Companion_instance_31 == null)
      new Companion_31();
    return Companion_instance_31;
  }
  function SchedulerImpl$Rescuer$execute$lambda(this$0) {
    return function () {
      return ensureNotNull(this$0.o2n_1).u2n();
    };
  }
  function push($this, queue, task) {
    var result = queue;
    if (result == null) {
      result = ArrayList_init_$Create$();
    }
    result.e(task);
    return result;
  }
  function scheduleFixedDelayImpl($this, delayMs, cmd) {
    var handler = SchedulerImpl$Companion$scheduleFixedDelayImpl$lambda(cmd, delayMs);
    window.setTimeout(handler, delayMs);
  }
  function scheduleFixedPeriodImpl($this, delayMs, cmd) {
    var intervalId = {_v: null};
    var handler = SchedulerImpl$Companion$scheduleFixedPeriodImpl$lambda(cmd, intervalId);
    intervalId._v = window.setInterval(handler, delayMs);
  }
  function SchedulerImpl$Companion$scheduleFixedDelayImpl$lambda($cmd, $delayMs) {
    return function () {
      var result = false;
      var tmp;
      try {
        result = $cmd();
        tmp = Unit_instance;
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var t = $p;
          ThrowableHandlers_getInstance().ps_1.os(t);
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      var tmp_1;
      if (result) {
        scheduleFixedDelayImpl(Companion_instance_32, $delayMs, $cmd);
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SchedulerImpl$Companion$scheduleFixedPeriodImpl$lambda($cmd, $intervalId) {
    return function () {
      var result = false;
      var tmp;
      try {
        result = $cmd();
        tmp = Unit_instance;
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var t = $p;
          ThrowableHandlers_getInstance().ps_1.os(t);
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      var tmp_1;
      if (!result) {
        window.clearInterval(ensureNotNull($intervalId._v));
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Task(scheduled) {
    this.v2n_1 = scheduled;
  }
  protoOf(Task).w2n = function () {
    this.v2n_1();
  };
  function Flusher($outer) {
    this.t2n_1 = $outer;
  }
  protoOf(Flusher).u2n = function () {
    this.t2n_1.r2n_1 = true;
    this.t2n_1.x2n();
    this.t2n_1.r2n_1 = false;
    this.t2n_1.s2n_1 = this.t2n_1.y2n();
    return this.t2n_1.s2n_1;
  };
  function Rescuer($outer) {
    this.z2n_1 = $outer;
  }
  protoOf(Rescuer).u2n = function () {
    if (this.z2n_1.r2n_1) {
      this.z2n_1.a2o(1, SchedulerImpl$Rescuer$execute$lambda(this.z2n_1));
    }
    return this.z2n_1.s2n_1;
  };
  function maybeSchedulePostEventPumpCommands($this) {
    if (!$this.s2n_1) {
      $this.s2n_1 = true;
      if ($this.o2n_1 == null) {
        $this.o2n_1 = new Flusher($this);
      }
      var tmp = Companion_instance_32;
      scheduleFixedDelayImpl(tmp, 1, SchedulerImpl$maybeSchedulePostEventPumpCommands$lambda($this));
      if ($this.p2n_1 == null) {
        $this.p2n_1 = new Rescuer($this);
      }
      var tmp_0 = Companion_instance_32;
      scheduleFixedDelayImpl(tmp_0, 50, SchedulerImpl$maybeSchedulePostEventPumpCommands$lambda_0($this));
    }
  }
  function Companion_32() {
    this.b2o_1 = 1;
    this.c2o_1 = 50;
  }
  var Companion_instance_32;
  function Companion_getInstance_32() {
    return Companion_instance_32;
  }
  function SchedulerImpl$maybeSchedulePostEventPumpCommands$lambda(this$0) {
    return function () {
      return ensureNotNull(this$0.o2n_1).u2n();
    };
  }
  function SchedulerImpl$maybeSchedulePostEventPumpCommands$lambda_0(this$0) {
    return function () {
      return ensureNotNull(this$0.p2n_1).u2n();
    };
  }
  function SchedulerImpl() {
    this.o2n_1 = null;
    this.p2n_1 = null;
    this.q2n_1 = null;
    this.r2n_1 = false;
    this.s2n_1 = false;
  }
  protoOf(SchedulerImpl).y2n = function () {
    return !(this.q2n_1 == null);
  };
  protoOf(SchedulerImpl).l2n = function (command) {
    this.q2n_1 = push(Companion_instance_32, this.q2n_1, new Task(command));
    maybeSchedulePostEventPumpCommands(this);
  };
  protoOf(SchedulerImpl).a2o = function (delayMs, command) {
    scheduleFixedDelayImpl(Companion_instance_32, delayMs, command);
  };
  protoOf(SchedulerImpl).d2o = function (delayMs, command) {
    scheduleFixedPeriodImpl(Companion_instance_32, delayMs, command);
  };
  protoOf(SchedulerImpl).x2n = function () {
    if (!(this.q2n_1 == null)) {
      var oldDeferred = this.q2n_1;
      this.q2n_1 = null;
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = ensureNotNull(oldDeferred).k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.base.scheduler.SchedulerImpl.flushPostEventPumpCommands.<anonymous>' call
        element.w2n();
      }
    }
  };
  function fire($this, scheduleCancelCounter) {
    if (!(scheduleCancelCounter === $this.h2n_1)) {
      return Unit_instance;
    }
    if (!$this.f2n_1) {
      $this.g2n_1 = null;
    }
    $this.e2n_1();
  }
  function createCallback($this, cancelCounter) {
    return Timer$createCallback$lambda($this, cancelCounter);
  }
  function Timer$createCallback$lambda(this$0, $cancelCounter) {
    return function () {
      var tmp;
      try {
        fire(this$0, $cancelCounter);
        tmp = Unit_instance;
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var t = $p;
          ThrowableHandlers_getInstance().ps_1.os(t);
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function Timer(task) {
    this.e2n_1 = task;
    this.f2n_1 = false;
    this.g2n_1 = null;
    this.h2n_1 = 0;
  }
  protoOf(Timer).j2n = function () {
    return !(this.g2n_1 == null);
  };
  protoOf(Timer).i2n = function () {
    if (!this.j2n()) {
      return Unit_instance;
    }
    this.h2n_1 = this.h2n_1 + 1 | 0;
    if (this.f2n_1) {
      window.clearInterval(ensureNotNull(this.g2n_1));
    } else {
      window.clearTimeout(ensureNotNull(this.g2n_1));
    }
    this.g2n_1 = null;
  };
  protoOf(Timer).m2n = function (delayMillis) {
    // Inline function 'kotlin.require' call
    if (!(delayMillis >= 0)) {
      // Inline function 'jetbrains.ocelot.base.timer.Timer.schedule.<anonymous>' call
      var message = 'must be non-negative';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (this.j2n()) {
      this.i2n();
    }
    this.f2n_1 = false;
    this.g2n_1 = window.setTimeout(createCallback(this, this.h2n_1), delayMillis);
  };
  protoOf(Timer).n2n = function (periodMillis) {
    // Inline function 'kotlin.require' call
    if (!(periodMillis > 0)) {
      // Inline function 'jetbrains.ocelot.base.timer.Timer.scheduleRepeating.<anonymous>' call
      var message = 'must be positive';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (this.j2n()) {
      this.i2n();
    }
    this.f2n_1 = true;
    this.g2n_1 = window.setInterval(createCallback(this, this.h2n_1), periodMillis);
  };
  function get_platformEdt() {
    _init_properties_JsEdt_kt__w9ydkq();
    return platformEdt;
  }
  var platformEdt;
  var properties_initialized_JsEdt_kt_uwb5uk;
  function _init_properties_JsEdt_kt__w9ydkq() {
    if (!properties_initialized_JsEdt_kt_uwb5uk) {
      properties_initialized_JsEdt_kt_uwb5uk = true;
      platformEdt = JsEventDispatchThread_getInstance();
    }
  }
  function Service$Key$invoke$lambda(this$0) {
    return function (it) {
      return this$0.e2o(it);
    };
  }
  function Service$Companion$instance$lambda($instance, $disposable) {
    return function (service, _unused_var__etf5q3) {
      return new ServiceInstance(service, $instance, $disposable);
    };
  }
  function Service$Companion$byFactory$lambda(it) {
    return Companion_getInstance_25().wr_1;
  }
  function Service$Companion$byFactory$lambda_0($factory, $disposable) {
    return function (service, container) {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.base.services.Companion.byFactory.<anonymous>.<anonymous>' call
      var it = $factory(container);
      return new ServiceInstance(service, it, $disposable(it));
    };
  }
  function Service$Companion$disposableInstance$lambda($instance) {
    return function (service, _unused_var__etf5q3) {
      return Companion_instance_34.f2o(service, $instance);
    };
  }
  function Key_5() {
  }
  function Companion_33() {
  }
  protoOf(Companion_33).j2o = function (instance, keys, disposable) {
    var tmp = toSet(keys);
    return new Service(tmp, Service$Companion$instance$lambda(instance, disposable));
  };
  protoOf(Companion_33).k2o = function (instance, keys, disposable, $super) {
    disposable = disposable === VOID ? Companion_getInstance_25().wr_1 : disposable;
    return $super === VOID ? this.j2o(instance, keys, disposable) : $super.j2o.call(this, instance, keys, disposable);
  };
  protoOf(Companion_33).l2o = function (keys, disposable, factory) {
    var tmp = toSet(keys);
    return new Service(tmp, Service$Companion$byFactory$lambda_0(factory, disposable));
  };
  protoOf(Companion_33).m2o = function (keys, disposable, factory, $super) {
    var tmp;
    if (disposable === VOID) {
      tmp = Service$Companion$byFactory$lambda;
    } else {
      tmp = disposable;
    }
    disposable = tmp;
    return $super === VOID ? this.l2o(keys, disposable, factory) : $super.l2o.call(this, keys, disposable, factory);
  };
  protoOf(Companion_33).n2o = function (instance, keys) {
    var tmp = toSet(keys);
    return new Service(tmp, Service$Companion$disposableInstance$lambda(instance));
  };
  protoOf(Companion_33).o2o = function (disposable) {
    return this.j2o(Unit_instance, [new AnonymousResourceServiceKey()], disposable);
  };
  var Companion_instance_33;
  function Companion_getInstance_33() {
    return Companion_instance_33;
  }
  function AnonymousResourceServiceKey() {
  }
  function Service(keys, factory) {
    this.p2o_1 = factory;
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.check' call
    if (!!keys.p()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.q2o_1 = keys;
  }
  protoOf(Service).r2o = function (container) {
    return this.p2o_1(this, container);
  };
  function ServiceAdapter(adapterFunction) {
    this.s2o_1 = adapterFunction;
    this.t2o_1 = null;
  }
  protoOf(ServiceAdapter).u2o = function (scope) {
    var tmp0_elvis_lhs = this.t2o_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'jetbrains.ocelot.base.services.ServiceAdapter.getValue.<anonymous>' call
      var res = this.s2o_1(scope);
      this.t2o_1 = res;
      tmp = res;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  function serviceContainer(services, parent) {
    parent = parent === VOID ? null : parent;
    return new ServiceManager(toSet(services), parent);
  }
  function Companion_34() {
  }
  protoOf(Companion_34).f2o = function (service, value) {
    return new ServiceInstance(service, value, value);
  };
  var Companion_instance_34;
  function Companion_getInstance_34() {
    return Companion_instance_34;
  }
  function ServiceInstance$$inlined$toDisposable$1() {
  }
  protoOf(ServiceInstance$$inlined$toDisposable$1).vr = function () {
    // Inline function 'jetbrains.ocelot.base.services.ServiceInstance.<init>.<anonymous>' call
    return Unit_instance;
  };
  function ServiceInstance(service, value, disposable) {
    var tmp;
    if (disposable === VOID) {
      // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
      tmp = new ServiceInstance$$inlined$toDisposable$1();
    } else {
      tmp = disposable;
    }
    disposable = tmp;
    this.v2o_1 = disposable;
    this.w2o_1 = service;
    this.x2o_1 = value;
  }
  protoOf(ServiceInstance).vr = function () {
    this.v2o_1.vr();
  };
  protoOf(ServiceInstance).sr = function (disposable) {
    return this.v2o_1.sr(disposable);
  };
  function ServiceManager$ServiceEntry$instance$delegate$lambda(this$0, this$1) {
    return function () {
      return this$0.y2o_1.r2o(this$1);
    };
  }
  function ServiceEntry($outer, service) {
    this.a2p_1 = $outer;
    this.y2o_1 = service;
    var tmp = this;
    tmp.z2o_1 = lazy_0(ServiceManager$ServiceEntry$instance$delegate$lambda(this, this.a2p_1));
  }
  protoOf(ServiceEntry).b2p = function () {
    var tmp0 = this.z2o_1;
    // Inline function 'kotlin.getValue' call
    instance$factory();
    return tmp0.y();
  };
  function ServiceManager(serviceSet, parentContainer) {
    this.c2p_1 = parentContainer;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.d2p_1 = HashMap_init_$Create$();
    var _iterator__ex2g4s = serviceSet.k();
    while (_iterator__ex2g4s.l()) {
      var service = _iterator__ex2g4s.m();
      var tmp0 = service.q2o_1;
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection)) {
          tmp_0 = tmp0.p();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$1 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s_0 = tmp0.k();
        while (_iterator__ex2g4s_0.l()) {
          var element = _iterator__ex2g4s_0.m();
          // Inline function 'jetbrains.ocelot.base.services.ServiceManager.<anonymous>' call
          // Inline function 'kotlin.collections.contains' call
          // Inline function 'kotlin.collections.containsKey' call
          var this_0 = this.d2p_1;
          if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w2(element)) {
            tmp$ret$1 = true;
            break $l$block_0;
          }
        }
        tmp$ret$1 = false;
      }
      if (tmp$ret$1) {
        throw IllegalArgumentException_init_$Create$_0('Duplicate services');
      }
      var entry = new ServiceEntry(this, service);
      var _iterator__ex2g4s_1 = service.q2o_1.k();
      while (_iterator__ex2g4s_1.l()) {
        var key = _iterator__ex2g4s_1.m();
        // Inline function 'kotlin.collections.set' call
        this.d2p_1.r2(key, entry);
      }
    }
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_2 = this.d2p_1.w().k();
    while (_iterator__ex2g4s_2.l()) {
      var service_0 = _iterator__ex2g4s_2.m();
      service_0.y().b2p();
    }
  }
  protoOf(ServiceManager).vr = function () {
    var _iterator__ex2g4s = this.d2p_1.v2().k();
    while (_iterator__ex2g4s.l()) {
      var service = _iterator__ex2g4s.m();
      service.b2p().vr();
    }
  };
  protoOf(ServiceManager).h2o = function (key) {
    var tmp0_elvis_lhs = this.d2p_1.y2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = this.c2p_1;
      return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h2o(key);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var service = tmp;
    var tmp_0 = service.b2p().x2o_1;
    return !(tmp_0 == null) ? tmp_0 : THROW_CCE();
  };
  function instance$factory() {
    return getPropertyCallableRef('instance', 1, KProperty1, function (receiver) {
      return receiver.b2p();
    }, null);
  }
  function ServicesScope() {
  }
  function CoroutineContextService() {
    CoroutineContextService_instance = this;
    this.f2p_1 = EmptyCoroutineContext_getInstance();
  }
  protoOf(CoroutineContextService).g2o = function () {
    return this.f2p_1;
  };
  var CoroutineContextService_instance;
  function CoroutineContextService_getInstance() {
    if (CoroutineContextService_instance == null)
      new CoroutineContextService();
    return CoroutineContextService_instance;
  }
  function Language(definitions) {
    this.g2p_1 = definitions;
  }
  protoOf(Language).h2p = function (aspect) {
    if (!isInterface(aspect, LanguageAspect))
      THROW_CCE();
    var tmp0_elvis_lhs = this.g2p_1.y2(aspect);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var aspectDefinitions = tmp;
    return aspect.i2p(aspectDefinitions);
  };
  function LanguageAspect() {
  }
  function language(body) {
    var builder = new LanguageBuilderImpl();
    body(builder);
    return builder.k2p();
  }
  function LanguageBuilderImpl() {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.j2p_1 = HashMap_init_$Create$();
  }
  protoOf(LanguageBuilderImpl).l2p = function (aspect, definition) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.j2p_1;
    var value = this_0.y2(aspect);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.langDef.language.LanguageBuilderImpl.addAspectDefinition.<anonymous>' call
      // Inline function 'kotlin.collections.arrayListOf' call
      var answer = ArrayList_init_$Create$();
      this_0.r2(aspect, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    tmp.e(definition);
  };
  protoOf(LanguageBuilderImpl).k2p = function () {
    return new Language(this.j2p_1);
  };
  function LanguageConfigurationException_init_$Init$($this) {
    Exception_init_$Init$($this);
    LanguageConfigurationException.call($this);
    return $this;
  }
  function LanguageConfigurationException_init_$Create$() {
    var tmp = LanguageConfigurationException_init_$Init$(objectCreate(protoOf(LanguageConfigurationException)));
    captureStack(tmp, LanguageConfigurationException_init_$Create$);
    return tmp;
  }
  function LanguageConfigurationException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    LanguageConfigurationException.call($this);
    return $this;
  }
  function LanguageConfigurationException_init_$Create$_0(message) {
    var tmp = LanguageConfigurationException_init_$Init$_0(message, objectCreate(protoOf(LanguageConfigurationException)));
    captureStack(tmp, LanguageConfigurationException_init_$Create$_0);
    return tmp;
  }
  function LanguageConfigurationException() {
    captureStack(this, LanguageConfigurationException);
  }
  function EnumInfoFactory() {
  }
  var EnumInfoFactory_instance;
  function EnumInfoFactory_getInstance() {
    return EnumInfoFactory_instance;
  }
  function toNormalizedName($this, name) {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    return name.toUpperCase();
  }
  function EnumInfoImpl(enumConstants) {
    var numConstants = enumConstants.length;
    var valueMap = HashMap_init_$Create$_0(numConstants);
    var originalNames = ArrayList_init_$Create$_0(numConstants);
    var inductionVariable = 0;
    var last = enumConstants.length;
    while (inductionVariable < last) {
      var value = enumConstants[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var originalName = value.toString();
      originalNames.e(originalName);
      var normalizedName = toNormalizedName(this, originalName);
      var oldValue = valueMap.r2(normalizedName, value);
      // Inline function 'kotlin.require' call
      if (!(oldValue == null)) {
        // Inline function 'jetbrains.ocelot.base.enums.EnumInfoImpl.<anonymous>' call
        var message = "duplicate values: '" + toString_1(value) + "', '" + toString_0(oldValue) + "'";
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
    }
    this.n2p_1 = originalNames;
    this.m2p_1 = valueMap;
  }
  protoOf(EnumInfoImpl).o2p = function () {
    return this.n2p_1;
  };
  protoOf(EnumInfoImpl).p2p = function (name) {
    var tmp;
    if (this.q2p(name)) {
      tmp = this.m2p_1.y2(toNormalizedName(this, name));
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(EnumInfoImpl).q2p = function (name) {
    return this.m2p_1.w2(toNormalizedName(this, name));
  };
  function Enums() {
  }
  var Enums_instance;
  function Enums_getInstance() {
    return Enums_instance;
  }
  function DefaultValueNullPersister(defaultValue) {
    this.r2p_1 = defaultValue;
  }
  protoOf(DefaultValueNullPersister).s2p = function (value) {
    return value == null || equals(value, this.r2p_1);
  };
  protoOf(DefaultValueNullPersister).t2p = function () {
    return null;
  };
  protoOf(DefaultValueNullPersister).u2p = function () {
    return this.r2p_1;
  };
  function EmptyStringNullPersister() {
  }
  protoOf(EmptyStringNullPersister).t2p = function () {
    return '';
  };
  protoOf(EmptyStringNullPersister).v2p = function (value) {
    // Inline function 'kotlin.text.isNullOrEmpty' call
    return value == null || charSequenceLength(value) === 0;
  };
  protoOf(EmptyStringNullPersister).u2p = function () {
    return null;
  };
  function ExceptionNullPersister() {
  }
  protoOf(ExceptionNullPersister).t2p = function () {
    throw NullPointerException_init_$Create$();
  };
  protoOf(ExceptionNullPersister).u2p = function () {
    throw NullPointerException_init_$Create$();
  };
  function toNullablePersister(_this__u8e3s4, nullPersister) {
    nullPersister = nullPersister === VOID ? new NullPersisterForNullable() : nullPersister;
    var nonNullPersister = isInterface(_this__u8e3s4, NonNullPersister) ? _this__u8e3s4 : THROW_CCE();
    return new SimplePersister(nonNullPersister, nullPersister);
  }
  function NonNullPersister() {
  }
  function toNonNullPersister(_this__u8e3s4, nullPersister) {
    nullPersister = nullPersister === VOID ? new ExceptionNullPersister() : nullPersister;
    return new SimplePersister(_this__u8e3s4, nullPersister);
  }
  function NonNullPersisters$STRING_PERSISTER$1() {
  }
  protoOf(NonNullPersisters$STRING_PERSISTER$1).w2p = function (value) {
    return value;
  };
  protoOf(NonNullPersisters$STRING_PERSISTER$1).y2p = function (value) {
    return value;
  };
  protoOf(NonNullPersisters$STRING_PERSISTER$1).x2p = function (value) {
    return this.y2p((!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(NonNullPersisters$STRING_PERSISTER$1).toString = function () {
    return 'stringPersister';
  };
  function NonNullPersisters$INT_PERSISTER$1() {
  }
  protoOf(NonNullPersisters$INT_PERSISTER$1).w2p = function (value) {
    return toInt(value);
  };
  protoOf(NonNullPersisters$INT_PERSISTER$1).z2p = function (value) {
    return value.toString();
  };
  protoOf(NonNullPersisters$INT_PERSISTER$1).x2p = function (value) {
    return this.z2p((!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(NonNullPersisters$INT_PERSISTER$1).toString = function () {
    return 'intPersister';
  };
  function NonNullPersisters$LONG_PERSISTER$1() {
  }
  protoOf(NonNullPersisters$LONG_PERSISTER$1).w2p = function (value) {
    return toLong_1(value);
  };
  protoOf(NonNullPersisters$LONG_PERSISTER$1).a2q = function (value) {
    return value.toString();
  };
  protoOf(NonNullPersisters$LONG_PERSISTER$1).x2p = function (value) {
    return this.a2q(value instanceof Long ? value : THROW_CCE());
  };
  protoOf(NonNullPersisters$LONG_PERSISTER$1).toString = function () {
    return 'longPersister';
  };
  function NonNullPersisters$BOOLEAN_PERSISTER$1() {
  }
  protoOf(NonNullPersisters$BOOLEAN_PERSISTER$1).w2p = function (value) {
    return toBoolean(value);
  };
  protoOf(NonNullPersisters$BOOLEAN_PERSISTER$1).b2q = function (value) {
    return value.toString();
  };
  protoOf(NonNullPersisters$BOOLEAN_PERSISTER$1).x2p = function (value) {
    return this.b2q((!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  protoOf(NonNullPersisters$BOOLEAN_PERSISTER$1).toString = function () {
    return 'booleanPersister';
  };
  function NonNullPersisters$DOUBLE_PERSISTER$1() {
  }
  protoOf(NonNullPersisters$DOUBLE_PERSISTER$1).w2p = function (value) {
    return toDouble(value);
  };
  protoOf(NonNullPersisters$DOUBLE_PERSISTER$1).c2q = function (value) {
    return value.toString();
  };
  protoOf(NonNullPersisters$DOUBLE_PERSISTER$1).x2p = function (value) {
    return this.c2q((!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(NonNullPersisters$DOUBLE_PERSISTER$1).toString = function () {
    return 'doublePersister';
  };
  function NonNullPersisters() {
    NonNullPersisters_instance = this;
    var tmp = this;
    tmp.d2q_1 = new NonNullPersisters$STRING_PERSISTER$1();
    var tmp_0 = this;
    tmp_0.e2q_1 = new NonNullPersisters$INT_PERSISTER$1();
    var tmp_1 = this;
    tmp_1.f2q_1 = new NonNullPersisters$LONG_PERSISTER$1();
    var tmp_2 = this;
    tmp_2.g2q_1 = new NonNullPersisters$BOOLEAN_PERSISTER$1();
    var tmp_3 = this;
    tmp_3.h2q_1 = new NonNullPersisters$DOUBLE_PERSISTER$1();
  }
  protoOf(NonNullPersisters).i2q = function () {
    return this.d2q_1;
  };
  protoOf(NonNullPersisters).j2q = function () {
    return this.e2q_1;
  };
  protoOf(NonNullPersisters).k2q = function () {
    return this.f2q_1;
  };
  protoOf(NonNullPersisters).l2q = function () {
    return this.g2q_1;
  };
  protoOf(NonNullPersisters).m2q = function () {
    return this.h2q_1;
  };
  var NonNullPersisters_instance;
  function NonNullPersisters_getInstance() {
    if (NonNullPersisters_instance == null)
      new NonNullPersisters();
    return NonNullPersisters_instance;
  }
  function NullPersister() {
  }
  function NullPersisterForNullable() {
  }
  protoOf(NullPersisterForNullable).t2p = function () {
    return null;
  };
  protoOf(NullPersisterForNullable).u2p = function () {
    return null;
  };
  function Persister() {
  }
  function Persisters() {
    Persisters_instance = this;
    this.r2q_1 = NonNullPersisters_getInstance().i2q();
    this.s2q_1 = toNullablePersister(this.r2q_1);
    this.t2q_1 = toNonNullPersister(NonNullPersisters_getInstance().j2q());
    this.u2q_1 = toNonNullPersister(NonNullPersisters_getInstance().k2q());
    this.v2q_1 = toNonNullPersister(NonNullPersisters_getInstance().m2q());
    this.w2q_1 = NonNullPersisters_getInstance().l2q();
    this.x2q_1 = toNonNullPersister(this.w2q_1);
  }
  protoOf(Persisters).y2q = function (defaultValue) {
    var nullPersister = this.z2q(defaultValue);
    return toNonNullPersister(this.r2q_1, nullPersister);
  };
  protoOf(Persisters).a2r = function (defaultValue, $super) {
    defaultValue = defaultValue === VOID ? null : defaultValue;
    return $super === VOID ? this.y2q(defaultValue) : $super.y2q.call(this, defaultValue);
  };
  protoOf(Persisters).b2r = function () {
    return this.s2q_1;
  };
  protoOf(Persisters).j2q = function () {
    return this.t2q_1;
  };
  protoOf(Persisters).k2q = function () {
    return this.u2q_1;
  };
  protoOf(Persisters).l2q = function () {
    return this.x2q_1;
  };
  protoOf(Persisters).c2r = function (defaultValue) {
    var nullPersister = this.z2q(defaultValue);
    return toNonNullPersister(this.w2q_1, nullPersister);
  };
  protoOf(Persisters).d2r = function (defaultValue, $super) {
    defaultValue = defaultValue === VOID ? false : defaultValue;
    return $super === VOID ? this.c2r(defaultValue) : $super.c2r.call(this, defaultValue);
  };
  protoOf(Persisters).z2q = function (defaultValue) {
    var tmp;
    if (defaultValue == null) {
      tmp = new ExceptionNullPersister();
    } else {
      tmp = new DefaultValueNullPersister(defaultValue);
    }
    return tmp;
  };
  var Persisters_instance;
  function Persisters_getInstance() {
    if (Persisters_instance == null)
      new Persisters();
    return Persisters_instance;
  }
  function SimplePersister(nonNullPersister, nullPersister) {
    this.e2r_1 = nonNullPersister;
    this.f2r_1 = nullPersister;
  }
  protoOf(SimplePersister).n2q = function () {
    return this.f2r_1;
  };
  protoOf(SimplePersister).o2q = function (value) {
    return this.e2r_1.x2p(value);
  };
  protoOf(SimplePersister).p2q = function (value) {
    return this.e2r_1.w2p(value);
  };
  function root(_this__u8e3s4) {
    return last_1(ancestorsFrom(_this__u8e3s4));
  }
  function ancestorsFrom(_this__u8e3s4) {
    return generateSequence_0(_this__u8e3s4, ancestorsFrom$lambda);
  }
  function isDescendant(_this__u8e3s4, current) {
    var tmp0 = ancestorsFrom(current);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.base.composite.isDescendant.<anonymous>' call
        if (equals(element, _this__u8e3s4)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function ancestors(_this__u8e3s4) {
    return generateSequenceFromNext(_this__u8e3s4, VOID, ancestors$lambda);
  }
  function reverseAncestors(_this__u8e3s4) {
    return asReversed(toList_2(ancestorsFrom(_this__u8e3s4)));
  }
  function ancestorsFrom$lambda(node) {
    return node.yt();
  }
  function ancestors$lambda(node) {
    return node.yt();
  }
  function Composite() {
  }
  function nextNavOrder($this, start, current) {
    var $this_0 = $this;
    var start_0 = start;
    var current_0 = current;
    $l$1: do {
      $l$0: do {
        var nextSibling = current_0.h2r();
        if (!(nextSibling == null)) {
          return $this_0.i2r(nextSibling);
        }
        if ($this_0.j2r(current_0))
          return null;
        var parent = current_0.yt();
        var tmp;
        if (isDescendant(parent, start_0)) {
          var tmp0 = $this_0;
          var tmp1 = start_0;
          var tmp2 = ensureNotNull(parent);
          $this_0 = tmp0;
          start_0 = tmp1;
          current_0 = tmp2;
          continue $l$0;
        } else {
          tmp = parent;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function prevNavOrder($this, start, current) {
    var $this_0 = $this;
    var start_0 = start;
    var current_0 = current;
    $l$1: do {
      $l$0: do {
        var prevSibling = current_0.k2r();
        if (!(prevSibling == null)) {
          return $this_0.l2r(prevSibling);
        }
        if ($this_0.j2r(current_0))
          return null;
        var parent = current_0.yt();
        var tmp;
        if (isDescendant(parent, start_0)) {
          var tmp0 = $this_0;
          var tmp1 = start_0;
          var tmp2 = ensureNotNull(parent);
          $this_0 = tmp0;
          start_0 = tmp1;
          current_0 = tmp2;
          continue $l$0;
        } else {
          tmp = parent;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function Composites$nextLeaves$lambda(composite) {
    return Composites_instance.m2r(composite);
  }
  function Composites$prevLeaves$lambda(composite) {
    return Composites_instance.n2r(composite);
  }
  function Composites$nextNavOrder$lambda($current) {
    return function (composite) {
      return nextNavOrder(Composites_instance, $current, composite);
    };
  }
  function Composites$prevNavOrder$lambda($current) {
    return function (composite) {
      return prevNavOrder(Composites_instance, $current, composite);
    };
  }
  function Composites() {
  }
  protoOf(Composites).j2r = function (composite) {
    var parent = composite.yt();
    var tmp;
    if (parent == null || !(composite.h2r() == null) || !(composite.k2r() == null)) {
      tmp = false;
    } else {
      var children = parent.g2r();
      tmp = !(children.n() === 1) || !equals(children.q(0), composite);
    }
    return tmp;
  };
  protoOf(Composites).o2r = function (composite) {
    var parent = composite.yt();
    var tmp;
    if (parent == null) {
      tmp = null;
    } else {
      var children = parent.g2r();
      var index = children.t(composite);
      tmp = getOrNull_0(children, index + 1 | 0);
    }
    return tmp;
  };
  protoOf(Composites).p2r = function (composite) {
    var parent = composite.yt();
    var tmp;
    if (parent == null) {
      tmp = null;
    } else {
      var children = parent.g2r();
      var index = children.t(composite);
      tmp = getOrNull_0(children, index - 1 | 0);
    }
    return tmp;
  };
  protoOf(Composites).i2r = function (composite) {
    var $this = this;
    var composite_0 = composite;
    $l$1: do {
      $l$0: do {
        var first = composite_0.q2r();
        var tmp;
        if (first == null) {
          tmp = composite_0;
        } else {
          $this = $this;
          composite_0 = first;
          continue $l$0;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  };
  protoOf(Composites).l2r = function (composite) {
    var $this = this;
    var composite_0 = composite;
    $l$1: do {
      $l$0: do {
        var last = composite_0.r2r();
        var tmp;
        if (last == null) {
          tmp = composite_0;
        } else {
          $this = $this;
          composite_0 = last;
          continue $l$0;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  };
  protoOf(Composites).m2r = function (composite) {
    return this.s2r(composite, null);
  };
  protoOf(Composites).s2r = function (composite, within) {
    var current = composite;
    while (true) {
      var nextSibling = current.h2r();
      if (!(nextSibling == null)) {
        return this.i2r(nextSibling);
      }
      if (this.j2r(current))
        return null;
      var parent = current.yt();
      if (equals(parent, within))
        return null;
      current = ensureNotNull(parent);
    }
  };
  protoOf(Composites).n2r = function (composite) {
    return this.t2r(composite, null);
  };
  protoOf(Composites).t2r = function (composite, within) {
    var current = composite;
    while (true) {
      var prevSibling = current.k2r();
      if (!(prevSibling == null)) {
        return this.l2r(prevSibling);
      }
      if (this.j2r(current))
        return null;
      var parent = current.yt();
      if (equals(parent, within))
        return null;
      current = ensureNotNull(parent);
    }
  };
  protoOf(Composites).u2r = function (current) {
    return generateSequenceFromNext(current, VOID, Composites$nextLeaves$lambda);
  };
  protoOf(Composites).v2r = function (current) {
    return generateSequenceFromNext(current, VOID, Composites$prevLeaves$lambda);
  };
  protoOf(Composites).w2r = function (current, fromNext) {
    return generateSequenceFromNext(current, fromNext, Composites$nextNavOrder$lambda(current));
  };
  protoOf(Composites).x2r = function (current, fromNext, $super) {
    fromNext = fromNext === VOID ? true : fromNext;
    return $super === VOID ? this.w2r(current, fromNext) : $super.w2r.call(this, current, fromNext);
  };
  protoOf(Composites).y2r = function (current) {
    return generateSequenceFromNext(current, VOID, Composites$prevNavOrder$lambda(current));
  };
  protoOf(Composites).z2r = function (c1, c2) {
    if (equals(c1, c2))
      return false;
    var c1a = reverseAncestors(c1);
    var c2a = reverseAncestors(c2);
    // Inline function 'kotlin.require' call
    if (!equals(c1a.q(0), c2a.q(0))) {
      // Inline function 'jetbrains.ocelot.base.composite.Composites.isBefore.<anonymous>' call
      var message = 'Items are in different trees';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp1 = c1a.n();
    // Inline function 'kotlin.math.min' call
    var b = c2a.n();
    var commonLength = Math.min(tmp1, b);
    var inductionVariable = 1;
    if (inductionVariable < commonLength)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var first = c1a.q(i);
        var second = c2a.q(i);
        if (!equals(first, second)) {
          return this.a2s(first, second) > 0;
        }
      }
       while (inductionVariable < commonLength);
    throw IllegalArgumentException_init_$Create$_0('One parameter is an ancestor of the other');
  };
  protoOf(Composites).a2s = function (c1, c2) {
    var left = c1;
    var right = c1;
    var delta = 0;
    while (true) {
      if (equals(left, c2)) {
        return -delta | 0;
      }
      if (equals(right, c2)) {
        return delta;
      }
      delta = delta + 1 | 0;
      // Inline function 'kotlin.check' call
      if (!(!(left == null) || !(right == null))) {
        // Inline function 'jetbrains.ocelot.base.composite.Composites.deltaBetween.<anonymous>' call
        var message = 'Both left and right are null';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      if (!(left == null)) {
        left = left.k2r();
      }
      if (!(right == null)) {
        right = right.h2r();
      }
    }
  };
  var Composites_instance;
  function Composites_getInstance() {
    return Composites_instance;
  }
  function get_descendants(_this__u8e3s4) {
    var tmp = _this__u8e3s4.g2r();
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = _this__u8e3s4.g2r();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.base.composite.<get-descendants>.<anonymous>' call
      var list = get_descendants(element);
      addAll_1(destination, list);
    }
    return plus_4(tmp, destination);
  }
  function get_descendantsFrom(_this__u8e3s4) {
    return plus_7(sequenceOf([_this__u8e3s4]), asSequence_0(get_descendants(_this__u8e3s4)));
  }
  function generateSequenceFromNext(initial, fromNext, nextFunction) {
    fromNext = fromNext === VOID ? true : fromNext;
    var seed = fromNext ? nextFunction(initial) : initial;
    return generateSequence_0(seed, nextFunction);
  }
  function Companion_35() {
    Companion_instance_35 = this;
    this.b2s_1 = new IdNames();
  }
  protoOf(Companion_35).c2s = function () {
    return IdGenerator_getInstance().h2s();
  };
  var Companion_instance_35;
  function Companion_getInstance_35() {
    if (Companion_instance_35 == null)
      new Companion_35();
    return Companion_instance_35;
  }
  function BaseId(id, name) {
    Companion_getInstance_35();
    id = id === VOID ? Companion_getInstance_35().c2s() : id;
    name = name === VOID ? null : name;
    this.i2s_1 = id;
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = this.i2s_1;
    // Inline function 'kotlin.require' call
    if (!(charSequenceLength(this_0) > 0)) {
      // Inline function 'jetbrains.ocelot.base.id.BaseId.<anonymous>' call
      var message = "id='" + this.i2s_1 + "'";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (!(name == null)) {
      Companion_getInstance_35().b2s_1.k2s(this.i2s_1, name);
    }
  }
  protoOf(BaseId).b3 = function () {
    return Companion_getInstance_35().b2s_1.fe(this.i2s_1);
  };
  protoOf(BaseId).equals = function (other) {
    if (other == null)
      return false;
    if (!getKClassFromExpression(other).equals(getKClassFromExpression(this)))
      return false;
    var otherId = (other == null ? true : other instanceof BaseId) ? other : THROW_CCE();
    return this.i2s_1 === ensureNotNull(otherId).i2s_1;
  };
  protoOf(BaseId).hashCode = function () {
    return getStringHashCode(this.i2s_1);
  };
  protoOf(BaseId).toString = function () {
    return this.b3() == null ? this.i2s_1 : '' + this.b3() + ' [' + this.i2s_1 + ']';
  };
  function nextBase62RandomId($this, length) {
    var chars = charArray(length);
    var nBits = 0;
    var bits = 0;
    var i = 0;
    while (i < chars.length) {
      if (nBits < 6) {
        nBits = 32;
        bits = $this.g2s_1.fh();
      }
      var idx = bits & 63;
      bits = bits >> 6;
      nBits = nBits - 6 | 0;
      if (idx < 62) {
        var _unary__edvuaz = i;
        i = _unary__edvuaz + 1 | 0;
        chars[_unary__edvuaz] = toChar($this, idx);
      }
    }
    return concatToString(chars);
  }
  function toChar($this, x) {
    var k = x + getShift($this, x) | 0;
    return numberToChar(k);
  }
  function getShift($this, x) {
    return x < 10 ? 48 : x < 36 ? 87 : 29;
  }
  function IdGenerator() {
    IdGenerator_instance = this;
    this.d2s_1 = 48;
    this.e2s_1 = 87;
    this.f2s_1 = 29;
    this.g2s_1 = Default_getInstance();
  }
  protoOf(IdGenerator).h2s = function () {
    return nextBase62RandomId(this, 22);
  };
  var IdGenerator_instance;
  function IdGenerator_getInstance() {
    if (IdGenerator_instance == null)
      new IdGenerator();
    return IdGenerator_instance;
  }
  function IdNames() {
    this.j2s_1 = newConcurrentHashMap();
  }
  protoOf(IdNames).k2s = function (id, name) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.j2s_1;
    var value = this_0.y2(id);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.base.id.IdNames.save.<anonymous>' call
      var answer = name;
      this_0.r2(id, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var oldName = tmp;
    // Inline function 'kotlin.check' call
    if (!(oldName === name)) {
      // Inline function 'jetbrains.ocelot.base.id.IdNames.save.<anonymous>' call
      var message = 'Different name for known id ' + id + ', first name = ' + oldName + ', name = ' + name + ']';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(IdNames).fe = function (id) {
    return this.j2s_1.y2(id);
  };
  function areBoundsGood($this, lowerBound, upperBound) {
    return (lowerBound - 1 | 0) <= upperBound;
  }
  function Interval$reverseIterable$1$iterator$1(this$0) {
    this.m2s_1 = this$0;
    this.l2s_1 = this$0.o2s_1;
  }
  protoOf(Interval$reverseIterable$1$iterator$1).l = function () {
    return this.m2s_1.n2s_1 <= this.l2s_1;
  };
  protoOf(Interval$reverseIterable$1$iterator$1).m = function () {
    var _unary__edvuaz = this.l2s_1;
    this.l2s_1 = _unary__edvuaz - 1 | 0;
    return _unary__edvuaz;
  };
  function createIntervalForIntersection($this, lowerBound, upperBound, other) {
    // Inline function 'kotlin.require' call
    if (!areBoundsGood(Companion_instance_36, lowerBound, upperBound)) {
      // Inline function 'jetbrains.ocelot.base.interval.Interval.createIntervalForIntersection.<anonymous>' call
      var message = 'Ranges are not connected: this=' + $this.toString() + ' other=' + other.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new Interval(lowerBound, upperBound);
  }
  function Companion_36() {
  }
  protoOf(Companion_36).p2s = function (lowerBound, length) {
    return new Interval(lowerBound, lowerBound + length | 0);
  };
  protoOf(Companion_36).q2s = function (lowerBound, upperExclusive) {
    return new Interval(lowerBound, upperExclusive - 1 | 0);
  };
  protoOf(Companion_36).r2s = function (lowerBound, length) {
    return this.q2s(lowerBound, lowerBound + length | 0);
  };
  protoOf(Companion_36).s2s = function (bound) {
    return new Interval(bound, bound);
  };
  var Companion_instance_36;
  function Companion_getInstance_36() {
    return Companion_instance_36;
  }
  function Interval$iterable$1(this$0) {
    this.t2s_1 = this$0;
  }
  protoOf(Interval$iterable$1).k = function () {
    return this.t2s_1.k();
  };
  function Interval$reverseIterable$1(this$0) {
    this.u2s_1 = this$0;
  }
  protoOf(Interval$reverseIterable$1).k = function () {
    return new Interval$reverseIterable$1$iterator$1(this.u2s_1);
  };
  function Interval$iterator$1(this$0) {
    this.w2s_1 = this$0;
    this.v2s_1 = this$0.n2s_1;
  }
  protoOf(Interval$iterator$1).l = function () {
    return this.v2s_1 < this.w2s_1.x2s();
  };
  protoOf(Interval$iterator$1).m = function () {
    var _unary__edvuaz = this.v2s_1;
    this.v2s_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  };
  function Interval(lowerBound, upperBound) {
    this.n2s_1 = lowerBound;
    this.o2s_1 = upperBound;
    // Inline function 'kotlin.require' call
    if (!areBoundsGood(Companion_instance_36, this.n2s_1, this.o2s_1)) {
      // Inline function 'jetbrains.ocelot.base.interval.Interval.<anonymous>' call
      var message = 'Lower bound is greater than the upperExclusive: ' + this.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(Interval).x2s = function () {
    return this.o2s_1 + 1 | 0;
  };
  protoOf(Interval).a = function () {
    return this.o2s_1 - this.n2s_1 | 0;
  };
  protoOf(Interval).y2s = function () {
    return new Interval$iterable$1(this);
  };
  protoOf(Interval).z2s = function () {
    return new Interval$reverseIterable$1(this);
  };
  protoOf(Interval).k = function () {
    return new Interval$iterator$1(this);
  };
  protoOf(Interval).p = function () {
    return this.n2s_1 > this.o2s_1;
  };
  protoOf(Interval).a2t = function (point) {
    return this.n2s_1 <= point && point <= this.o2s_1;
  };
  protoOf(Interval).b2t = function (other) {
    return this.a2t(other.n2s_1) && this.a2t(other.o2s_1);
  };
  protoOf(Interval).c2t = function (other) {
    return this.a2t(other.n2s_1) || other.a2t(this.n2s_1);
  };
  protoOf(Interval).d2t = function (other) {
    return this.n2s_1 <= other.o2s_1 && other.n2s_1 <= this.o2s_1;
  };
  protoOf(Interval).e2t = function (other) {
    var tmp;
    if (this.n2s_1 <= other.n2s_1) {
      var tmp_0;
      if (this.o2s_1 >= other.o2s_1) {
        tmp_0 = other;
      } else {
        tmp_0 = createIntervalForIntersection(this, other.n2s_1, this.o2s_1, other);
      }
      tmp = tmp_0;
    } else if (this.o2s_1 <= other.o2s_1) {
      tmp = this;
    } else {
      tmp = createIntervalForIntersection(this, this.n2s_1, other.o2s_1, other);
    }
    return tmp;
  };
  protoOf(Interval).f2t = function (other) {
    var tmp;
    if (this.b2t(other)) {
      tmp = this;
    } else if (other.b2t(this)) {
      tmp = other;
    } else {
      var tmp0 = this.n2s_1;
      // Inline function 'kotlin.math.min' call
      var b = other.n2s_1;
      var lower = Math.min(tmp0, b);
      var tmp2 = this.o2s_1;
      // Inline function 'kotlin.math.max' call
      var b_0 = other.o2s_1;
      var upper = Math.max(tmp2, b_0);
      tmp = new Interval(lower, upper);
    }
    return tmp;
  };
  protoOf(Interval).g2t = function (list) {
    return list.j2(this.n2s_1, this.x2s());
  };
  protoOf(Interval).toString = function () {
    return '[' + this.n2s_1 + ', ' + this.o2s_1 + ']';
  };
  protoOf(Interval).hashCode = function () {
    var result = this.n2s_1;
    result = imul(result, 31) + this.o2s_1 | 0;
    return result;
  };
  protoOf(Interval).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Interval))
      return false;
    var tmp0_other_with_cast = other instanceof Interval ? other : THROW_CCE();
    if (!(this.n2s_1 === tmp0_other_with_cast.n2s_1))
      return false;
    if (!(this.o2s_1 === tmp0_other_with_cast.o2s_1))
      return false;
    return true;
  };
  function parseValue($this, lexer) {
    var tmp0_subject = lexer.k2t();
    switch (tmp0_subject == null ? -1 : tmp0_subject.a3_1) {
      case 9:
        var sv = lexer.l2t();
        lexer.m2t();
        return new JsonString(sv);
      case 2:
        return parseArray($this, lexer);
      case 8:
        var dv = toDouble(lexer.n2t());
        lexer.m2t();
        return new JsonNumber(dv);
      case 0:
        return parseObject($this, lexer);
      case 4:
        lexer.m2t();
        return new JsonNull();
      case 5:
        lexer.m2t();
        return new JsonBoolean(true);
      case 6:
        lexer.m2t();
        return new JsonBoolean(false);
      default:
        throw JsonParsingException_init_$Create$();
    }
  }
  function parseObject($this, lexer) {
    var result = new JsonObject();
    lexer.o2t(JsonTokenKind_LEFT_BRACE_getInstance());
    while (!equals(lexer.k2t(), JsonTokenKind_RIGHT_BRACE_getInstance())) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!result.u2().p()) {
        lexer.o2t(JsonTokenKind_COMMA_getInstance());
      }
      if (!equals(lexer.k2t(), JsonTokenKind_STRING_getInstance())) {
        throw JsonParsingException_init_$Create$();
      }
      var key = lexer.l2t();
      lexer.m2t();
      lexer.o2t(JsonTokenKind_COLON_getInstance());
      result.q2t(key, parseValue($this, lexer));
    }
    lexer.o2t(JsonTokenKind_RIGHT_BRACE_getInstance());
    return result;
  }
  function parseArray($this, lexer) {
    var result = new JsonArray();
    lexer.o2t(JsonTokenKind_LEFT_BRACKET_getInstance());
    while (!equals(lexer.k2t(), JsonTokenKind_RIGHT_BRACKET_getInstance())) {
      if (result.wo() > 0) {
        lexer.o2t(JsonTokenKind_COMMA_getInstance());
      }
      result.s2t(parseValue($this, lexer));
    }
    lexer.o2t(JsonTokenKind_RIGHT_BRACKET_getInstance());
    return result;
  }
  function DefaultJsonSupport() {
  }
  protoOf(DefaultJsonSupport).t2t = function (input) {
    try {
      var lexer = new StringJsonLexer(input);
      var result = parseValue(this, lexer);
      var tokenKind = lexer.k2t();
      if (!(tokenKind == null)) {
        throw JsonParsingException_init_$Create$_0('tokenKind: ' + toString_0(tokenKind));
      }
      return result;
    } catch ($p) {
      if ($p instanceof RuntimeException) {
        var e = $p;
        throw JsonParsingException_init_$Create$_1("Failed to parse json='" + input + "'", e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(DefaultJsonSupport).u2t = function (value) {
    return value.v2t(0);
  };
  function nSpaces($this, n) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        $this.x2t_1.e9(_Char___init__impl__6a9atx(32));
      }
       while (inductionVariable < n);
  }
  function IndentBuilder(myIndentSize) {
    this.w2t_1 = myIndentSize;
    this.x2t_1 = StringBuilder_init_$Create$_1();
    this.y2t_1 = 0;
  }
  protoOf(IndentBuilder).z2t = function (o) {
    this.x2t_1.c9(o);
    return this;
  };
  protoOf(IndentBuilder).a2u = function () {
    if (this.w2t_1 > 0) {
      this.x2t_1.d9('\n');
      nSpaces(this, imul(this.y2t_1, this.w2t_1));
    }
  };
  protoOf(IndentBuilder).b2u = function () {
    this.y2t_1 = this.y2t_1 + 1 | 0;
  };
  protoOf(IndentBuilder).c2u = function () {
    this.y2t_1 = this.y2t_1 - 1 | 0;
  };
  protoOf(IndentBuilder).toString = function () {
    return this.x2t_1.toString();
  };
  function Json() {
    Json_instance = this;
    this.d2u_1 = new DefaultJsonSupport();
  }
  protoOf(Json).t2t = function (input) {
    return this.d2u_1.t2t(input);
  };
  protoOf(Json).u2t = function (value) {
    return this.d2u_1.u2t(value);
  };
  var Json_instance;
  function Json_getInstance() {
    if (Json_instance == null)
      new Json();
    return Json_instance;
  }
  function Companion_37() {
    Companion_instance_37 = this;
    this.e2u_1 = emptyList();
  }
  var Companion_instance_37;
  function Companion_getInstance_37() {
    if (Companion_instance_37 == null)
      new Companion_37();
    return Companion_instance_37;
  }
  function JsonArray() {
    Companion_getInstance_37();
    JsonValue.call(this);
    this.r2t_1 = null;
  }
  protoOf(JsonArray).k = function () {
    var tmp;
    if (this.r2t_1 == null) {
      tmp = Companion_getInstance_37().e2u_1.k();
    } else {
      tmp = ensureNotNull(this.r2t_1).k();
    }
    return tmp;
  };
  protoOf(JsonArray).wo = function () {
    var tmp;
    if (this.r2t_1 == null) {
      tmp = 0;
    } else {
      tmp = ensureNotNull(this.r2t_1).n();
    }
    return tmp;
  };
  protoOf(JsonArray).f2u = function (pos, value) {
    if (this.r2t_1 == null) {
      this.r2t_1 = ArrayList_init_$Create$_0(1);
    }
    ensureNotNull(this.r2t_1).p2(pos, value);
  };
  protoOf(JsonArray).g2u = function (pos) {
    ensureNotNull(this.r2t_1).q2(pos);
  };
  protoOf(JsonArray).s2t = function (value) {
    this.f2u(this.wo(), value);
  };
  protoOf(JsonArray).q = function (index) {
    return ensureNotNull(this.r2t_1).q(index);
  };
  protoOf(JsonArray).h2u = function (s) {
    this.s2t(new JsonString(s));
  };
  protoOf(JsonArray).i2u = function (d) {
    this.s2t(new JsonNumber(d));
  };
  protoOf(JsonArray).j2u = function (d) {
    this.i2u(d);
  };
  protoOf(JsonArray).k2u = function (index) {
    var tmp = this.q(index);
    return tmp instanceof JsonObject ? tmp : THROW_CCE();
  };
  protoOf(JsonArray).l2u = function (index) {
    var tmp = this.q(index);
    return tmp instanceof JsonArray ? tmp : THROW_CCE();
  };
  protoOf(JsonArray).m2u = function (index) {
    var tmp = this.q(index);
    return (tmp instanceof JsonString ? tmp : THROW_CCE()).n2u_1;
  };
  protoOf(JsonArray).o2u = function (index) {
    var tmp = this.q(index);
    return (tmp instanceof JsonNumber ? tmp : THROW_CCE()).p2u_1;
  };
  protoOf(JsonArray).q2u = function (index) {
    return numberToInt(this.o2u(index));
  };
  protoOf(JsonArray).r2u = function (builder) {
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.base.json.JsonArray.toString.<anonymous>' call
    builder.z2t('[');
    builder.b2u();
    builder.a2u();
    var size = this.wo();
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.q(i).r2u(builder);
        if (!(i === (size - 1 | 0))) {
          builder.z2t(',');
          builder.a2u();
        }
      }
       while (inductionVariable < size);
    builder.c2u();
    builder.a2u();
    builder.z2t(']');
  };
  function JsonBoolean(booleanValue) {
    JsonValue.call(this);
    this.s2u_1 = booleanValue;
  }
  protoOf(JsonBoolean).r2u = function (builder) {
    builder.z2t(this.s2u_1);
  };
  function readNumber($this) {
    var tmp = $this.t2u();
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(45);
    if (tmp === Char__toInt_impl_vasixd(this_0)) {
      $this.u2u();
    }
    while (isDigit_0($this, $this.t2u())) {
      $this.u2u();
    }
    var tmp_0 = $this.t2u();
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(46);
    if (tmp_0 === Char__toInt_impl_vasixd(this_1)) {
      $this.u2u();
      if (!isDigit_0($this, $this.t2u())) {
        throw JsonParsingException_init_$Create$();
      }
      while (isDigit_0($this, $this.t2u())) {
        $this.u2u();
      }
    }
    if (readExponent($this)) {
      if (!isDigit_0($this, $this.t2u())) {
        throw JsonParsingException_init_$Create$();
      }
      $this.u2u();
      while (isDigit_0($this, $this.t2u())) {
        $this.u2u();
      }
    }
  }
  function readExponent($this) {
    var tmp;
    var tmp_0 = $this.t2u();
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(69);
    if (tmp_0 === Char__toInt_impl_vasixd(this_0)) {
      tmp = true;
    } else {
      var tmp_1 = $this.t2u();
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(101);
      tmp = tmp_1 === Char__toInt_impl_vasixd(this_1);
    }
    if (tmp) {
      $this.u2u();
      var tmp_2;
      var tmp_3 = $this.t2u();
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(43);
      if (tmp_3 === Char__toInt_impl_vasixd(this_2)) {
        tmp_2 = true;
      } else {
        var tmp_4 = $this.t2u();
        // Inline function 'kotlin.code' call
        var this_3 = _Char___init__impl__6a9atx(45);
        tmp_2 = tmp_4 === Char__toInt_impl_vasixd(this_3);
      }
      if (tmp_2) {
        $this.u2u();
      }
      return true;
    }
    return false;
  }
  function readString($this) {
    if (!$this.v2u('"')) {
      throw JsonParsingException_init_$Create$();
    }
    $l$loop: while (true) {
      var tmp;
      var tmp_0 = $this.t2u();
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(34);
      if (!(tmp_0 === Char__toInt_impl_vasixd(this_0))) {
        tmp = !($this.t2u() === -1);
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      var tmp_1 = $this.t2u();
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(92);
      if (tmp_1 === Char__toInt_impl_vasixd(this_1)) {
        $this.u2u();
        if (JsonUtil_getInstance().b2v(numberToChar($this.t2u()))) {
          $this.u2u();
        } else {
          var tmp_2 = $this.t2u();
          // Inline function 'kotlin.code' call
          var this_2 = _Char___init__impl__6a9atx(117);
          if (tmp_2 === Char__toInt_impl_vasixd(this_2)) {
            $this.u2u();
            var inductionVariable = 0;
            if (inductionVariable <= 3)
              do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                if (!isHexDigit($this, $this.t2u())) {
                  throw JsonParsingException_init_$Create$();
                }
                $this.u2u();
              }
               while (inductionVariable <= 3);
          } else {
            throw RuntimeException_init_$Create$();
          }
        }
      } else {
        if (JsonUtil_getInstance().a2v(numberToChar($this.t2u()))) {
          throw JsonParsingException_init_$Create$();
        } else {
          $this.u2u();
        }
      }
    }
    if (!$this.v2u('"')) {
      throw JsonParsingException_init_$Create$();
    }
  }
  function skipSpaces($this) {
    while (!($this.t2u() === -1) && isWhiteSpace($this, $this.t2u())) {
      $this.u2u();
    }
  }
  function isWhiteSpace($this, ch) {
    var char = numberToChar(ch);
    return char === _Char___init__impl__6a9atx(32) || char === _Char___init__impl__6a9atx(9) || char === _Char___init__impl__6a9atx(10) || char === _Char___init__impl__6a9atx(13);
  }
  function isDigit_0($this, ch) {
    return isDigit(numberToChar(ch));
  }
  function isHexDigit($this, ch) {
    var char = numberToChar(ch);
    return isDigit(char) || (_Char___init__impl__6a9atx(97) <= char ? char <= _Char___init__impl__6a9atx(102) : false) || (_Char___init__impl__6a9atx(65) <= char ? char <= _Char___init__impl__6a9atx(70) : false);
  }
  function JsonLexer(isExhaustive) {
    this.h2t_1 = isExhaustive;
    this.i2t_1 = null;
    this.j2t_1 = !this.h2t_1;
  }
  protoOf(JsonLexer).k2t = function () {
    if (this.j2t_1) {
      this.j2t_1 = false;
      this.m2t();
    }
    return this.i2t_1;
  };
  protoOf(JsonLexer).m2t = function () {
    skipSpaces(this);
    if (this.t2u() === -1) {
      this.i2t_1 = null;
      return Unit_instance;
    }
    this.c2v();
    var tmp = this.t2u();
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(34);
    if (tmp === Char__toInt_impl_vasixd(this_0)) {
      readString(this);
      this.i2t_1 = JsonTokenKind_STRING_getInstance();
      return Unit_instance;
    }
    var tmp_0 = this.t2u();
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(44);
    if (tmp_0 === Char__toInt_impl_vasixd(this_1)) {
      this.i2t_1 = JsonTokenKind_COMMA_getInstance();
      this.u2u();
      return Unit_instance;
    }
    var tmp_1 = this.t2u();
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(91);
    if (tmp_1 === Char__toInt_impl_vasixd(this_2)) {
      this.i2t_1 = JsonTokenKind_LEFT_BRACKET_getInstance();
      this.u2u();
      return Unit_instance;
    }
    var tmp_2 = this.t2u();
    // Inline function 'kotlin.code' call
    var this_3 = _Char___init__impl__6a9atx(93);
    if (tmp_2 === Char__toInt_impl_vasixd(this_3)) {
      this.i2t_1 = JsonTokenKind_RIGHT_BRACKET_getInstance();
      this.u2u();
      return Unit_instance;
    }
    var tmp_3;
    if (isDigit_0(this, this.t2u())) {
      tmp_3 = true;
    } else {
      var tmp_4 = this.t2u();
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(45);
      tmp_3 = tmp_4 === Char__toInt_impl_vasixd(this_4);
    }
    if (tmp_3) {
      readNumber(this);
      this.i2t_1 = JsonTokenKind_NUMBER_getInstance();
      return Unit_instance;
    }
    var tmp_5 = this.t2u();
    // Inline function 'kotlin.code' call
    var this_5 = _Char___init__impl__6a9atx(123);
    if (tmp_5 === Char__toInt_impl_vasixd(this_5)) {
      this.i2t_1 = JsonTokenKind_LEFT_BRACE_getInstance();
      this.u2u();
      return Unit_instance;
    }
    var tmp_6 = this.t2u();
    // Inline function 'kotlin.code' call
    var this_6 = _Char___init__impl__6a9atx(125);
    if (tmp_6 === Char__toInt_impl_vasixd(this_6)) {
      this.i2t_1 = JsonTokenKind_RIGHT_BRACE_getInstance();
      this.u2u();
      return Unit_instance;
    }
    var tmp_7 = this.t2u();
    // Inline function 'kotlin.code' call
    var this_7 = _Char___init__impl__6a9atx(58);
    if (tmp_7 === Char__toInt_impl_vasixd(this_7)) {
      this.i2t_1 = JsonTokenKind_COLON_getInstance();
      this.u2u();
      return Unit_instance;
    }
    if (this.v2u('null')) {
      this.i2t_1 = JsonTokenKind_NULL_getInstance();
      return Unit_instance;
    }
    if (this.v2u('true')) {
      this.i2t_1 = JsonTokenKind_TRUE_getInstance();
      return Unit_instance;
    }
    if (this.v2u('false')) {
      this.i2t_1 = JsonTokenKind_FALSE_getInstance();
      return Unit_instance;
    }
    throw JsonParsingException_init_$Create$();
  };
  protoOf(JsonLexer).o2t = function (kind) {
    if (this.j2t_1) {
      this.j2t_1 = false;
      this.m2t();
    }
    if (!equals(this.i2t_1, kind)) {
      throw JsonParsingException_init_$Create$();
    }
    if (this.h2t_1) {
      this.m2t();
    } else {
      this.j2t_1 = true;
    }
  };
  function JsonNull() {
    JsonValue.call(this);
  }
  protoOf(JsonNull).r2u = function (builder) {
    builder.z2t('null');
  };
  function JsonNumber(doubleValue) {
    JsonValue.call(this);
    this.p2u_1 = doubleValue;
  }
  protoOf(JsonNumber).r2u = function (builder) {
    // Inline function 'kotlin.math.floor' call
    var x = this.p2u_1;
    if (Math.floor(x) === this.p2u_1) {
      builder.z2t(numberToLong(this.p2u_1));
    } else {
      builder.z2t(this.p2u_1);
    }
  };
  function JsonObject() {
    JsonValue.call(this);
    this.p2t_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(JsonObject).u2 = function () {
    return this.p2t_1.u2();
  };
  protoOf(JsonObject).q2t = function (key, value) {
    // Inline function 'kotlin.collections.set' call
    this.p2t_1.r2(key, value);
  };
  protoOf(JsonObject).d2v = function (key, value) {
    if (!(value == null)) {
      this.q2t(key, new JsonString(value));
    }
  };
  protoOf(JsonObject).fe = function (key) {
    return this.p2t_1.y2(key);
  };
  protoOf(JsonObject).w10 = function (key) {
    var tmp = this.fe(key);
    var tmp0_elvis_lhs = (tmp == null ? true : tmp instanceof JsonString) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var value = tmp_0;
    return value.n2u_1;
  };
  protoOf(JsonObject).e2v = function (key) {
    var tmp = this.fe(key);
    return (tmp == null ? true : tmp instanceof JsonArray) ? tmp : THROW_CCE();
  };
  protoOf(JsonObject).r2u = function (builder) {
    builder.z2t('{');
    builder.b2u();
    builder.a2u();
    var keys = ArrayList_init_$Create$_1(this.p2t_1.u2());
    var inductionVariable = 0;
    var last = keys.n();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        builder.z2t('"').z2t(JsonUtil_getInstance().md(keys.q(i))).z2t('":');
        ensureNotNull(this.p2t_1.y2(keys.q(i))).r2u(builder);
        if (!(i === (keys.n() - 1 | 0))) {
          builder.z2t(',');
          builder.a2u();
        }
      }
       while (inductionVariable < last);
    builder.c2u();
    builder.a2u();
    builder.z2t('}');
  };
  function JsonParsingException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    JsonParsingException.call($this);
    return $this;
  }
  function JsonParsingException_init_$Create$() {
    var tmp = JsonParsingException_init_$Init$(objectCreate(protoOf(JsonParsingException)));
    captureStack(tmp, JsonParsingException_init_$Create$);
    return tmp;
  }
  function JsonParsingException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    JsonParsingException.call($this);
    return $this;
  }
  function JsonParsingException_init_$Create$_0(message) {
    var tmp = JsonParsingException_init_$Init$_0(message, objectCreate(protoOf(JsonParsingException)));
    captureStack(tmp, JsonParsingException_init_$Create$_0);
    return tmp;
  }
  function JsonParsingException_init_$Init$_1(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    JsonParsingException.call($this);
    return $this;
  }
  function JsonParsingException_init_$Create$_1(message, cause) {
    var tmp = JsonParsingException_init_$Init$_1(message, cause, objectCreate(protoOf(JsonParsingException)));
    captureStack(tmp, JsonParsingException_init_$Create$_1);
    return tmp;
  }
  function JsonParsingException() {
    captureStack(this, JsonParsingException);
  }
  function JsonString(stringValue) {
    JsonValue.call(this);
    this.n2u_1 = stringValue;
  }
  protoOf(JsonString).r2u = function (builder) {
    builder.z2t('"');
    builder.z2t(JsonUtil_getInstance().md(this.n2u_1));
    builder.z2t('"');
  };
  var JsonTokenKind_LEFT_BRACE_instance;
  var JsonTokenKind_RIGHT_BRACE_instance;
  var JsonTokenKind_LEFT_BRACKET_instance;
  var JsonTokenKind_RIGHT_BRACKET_instance;
  var JsonTokenKind_NULL_instance;
  var JsonTokenKind_TRUE_instance;
  var JsonTokenKind_FALSE_instance;
  var JsonTokenKind_COMMA_instance;
  var JsonTokenKind_NUMBER_instance;
  var JsonTokenKind_STRING_instance;
  var JsonTokenKind_COLON_instance;
  var JsonTokenKind_entriesInitialized;
  function JsonTokenKind_initEntries() {
    if (JsonTokenKind_entriesInitialized)
      return Unit_instance;
    JsonTokenKind_entriesInitialized = true;
    JsonTokenKind_LEFT_BRACE_instance = new JsonTokenKind('LEFT_BRACE', 0);
    JsonTokenKind_RIGHT_BRACE_instance = new JsonTokenKind('RIGHT_BRACE', 1);
    JsonTokenKind_LEFT_BRACKET_instance = new JsonTokenKind('LEFT_BRACKET', 2);
    JsonTokenKind_RIGHT_BRACKET_instance = new JsonTokenKind('RIGHT_BRACKET', 3);
    JsonTokenKind_NULL_instance = new JsonTokenKind('NULL', 4);
    JsonTokenKind_TRUE_instance = new JsonTokenKind('TRUE', 5);
    JsonTokenKind_FALSE_instance = new JsonTokenKind('FALSE', 6);
    JsonTokenKind_COMMA_instance = new JsonTokenKind('COMMA', 7);
    JsonTokenKind_NUMBER_instance = new JsonTokenKind('NUMBER', 8);
    JsonTokenKind_STRING_instance = new JsonTokenKind('STRING', 9);
    JsonTokenKind_COLON_instance = new JsonTokenKind('COLON', 10);
  }
  function JsonTokenKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function JsonTokenKind_LEFT_BRACE_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_LEFT_BRACE_instance;
  }
  function JsonTokenKind_RIGHT_BRACE_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_RIGHT_BRACE_instance;
  }
  function JsonTokenKind_LEFT_BRACKET_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_LEFT_BRACKET_instance;
  }
  function JsonTokenKind_RIGHT_BRACKET_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_RIGHT_BRACKET_instance;
  }
  function JsonTokenKind_NULL_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_NULL_instance;
  }
  function JsonTokenKind_TRUE_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_TRUE_instance;
  }
  function JsonTokenKind_FALSE_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_FALSE_instance;
  }
  function JsonTokenKind_COMMA_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_COMMA_instance;
  }
  function JsonTokenKind_NUMBER_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_NUMBER_instance;
  }
  function JsonTokenKind_STRING_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_STRING_instance;
  }
  function JsonTokenKind_COLON_getInstance() {
    JsonTokenKind_initEntries();
    return JsonTokenKind_COLON_instance;
  }
  function JsonUtil() {
    JsonUtil_instance = this;
    var tmp = this;
    // Inline function 'kotlin.charArrayOf' call
    tmp.w2u_1 = charArrayOf([_Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(8), _Char___init__impl__6a9atx(12), _Char___init__impl__6a9atx(10), _Char___init__impl__6a9atx(13), _Char___init__impl__6a9atx(9)]);
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.x2u_1 = ['\\"', '\\\\', '\\/', '\\b', '\\f', '\\n', '\\r', '\\t'];
    var tmp_1 = this;
    // Inline function 'kotlin.charArrayOf' call
    tmp_1.y2u_1 = charArrayOf([_Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(98), _Char___init__impl__6a9atx(102), _Char___init__impl__6a9atx(110), _Char___init__impl__6a9atx(114), _Char___init__impl__6a9atx(116)]);
    var table = new Int32Array(255);
    var inductionVariable = 0;
    var last = table.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        table[i] = -1;
      }
       while (inductionVariable <= last);
    var inductionVariable_0 = 0;
    var last_0 = this.y2u_1.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = this.y2u_1[i_0];
        var tmp_2 = Char__toInt_impl_vasixd(this_0);
        // Inline function 'kotlin.code' call
        var this_1 = this.w2u_1[i_0];
        table[tmp_2] = Char__toInt_impl_vasixd(this_1);
      }
       while (inductionVariable_0 <= last_0);
    this.z2u_1 = table;
  }
  protoOf(JsonUtil).a2v = function (ch) {
    // Inline function 'kotlin.code' call
    var chValue = Char__toInt_impl_vasixd(ch);
    return chValue < 32 || chValue === 34 || chValue === 92;
  };
  protoOf(JsonUtil).b2v = function (ch) {
    return !(indexOf_4(this.y2u_1, ch) === -1);
  };
  protoOf(JsonUtil).md = function (s) {
    var builder = StringBuilder_init_$Create$_1();
    var len = s.length;
    var inductionVariable = 0;
    if (inductionVariable < len)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = charSequenceGet(s, i);
        var index = indexOf_4(this.w2u_1, c);
        if (!(index === -1)) {
          builder.d9(this.x2u_1[index]);
        } else if (this.a2v(c)) {
          // Inline function 'kotlin.code' call
          var tmp$ret$0 = Char__toInt_impl_vasixd(c);
          var hex = toString_3(tmp$ret$0, 16);
          builder.d9('\\u');
          var inductionVariable_0 = 4;
          var last = hex.length + 1 | 0;
          if (last <= inductionVariable_0)
            do {
              var j = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              builder.e9(_Char___init__impl__6a9atx(48));
            }
             while (!(j === last));
          builder.d9(hex);
        } else {
          builder.e9(c);
        }
      }
       while (inductionVariable < len);
    return builder.toString();
  };
  protoOf(JsonUtil).f2v = function (s, start, end) {
    var result = null;
    var i = start;
    while (i < end) {
      var ch = charSequenceGet(s, i);
      if (ch === _Char___init__impl__6a9atx(92) && i < (end - 1 | 0)) {
        if (result == null) {
          result = StringBuilder_init_$Create$_1();
          result.yc(s, start, i);
        }
        i = i + 1 | 0;
        ch = charSequenceGet(s, i);
        var specialChar = -1;
        // Inline function 'kotlin.code' call
        var this_0 = ch;
        if (Char__toInt_impl_vasixd(this_0) < this.z2u_1.length) {
          // Inline function 'kotlin.code' call
          var this_1 = ch;
          var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
          specialChar = this.z2u_1[tmp$ret$1];
        }
        if (!(specialChar === -1)) {
          result.e9(numberToChar(specialChar));
        } else if (ch === _Char___init__impl__6a9atx(117)) {
          if (i >= (end - 4 | 0)) {
            throw RuntimeException_init_$Create$();
          }
          var tmp3 = i + 1 | 0;
          // Inline function 'kotlin.text.substring' call
          var endIndex = i + 5 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          var hexNumber = s.substring(tmp3, endIndex);
          result.e9(numberToChar(toInt_0(hexNumber, 16)));
          i = i + 4 | 0;
        } else {
          throw RuntimeException_init_$Create$();
        }
      } else {
        var tmp0_safe_receiver = result;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver.e9(ch);
      }
      i = i + 1 | 0;
    }
    var tmp1_safe_receiver = result;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.toString();
    var tmp;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = s.substring(start, end);
    } else {
      tmp = tmp2_elvis_lhs;
    }
    return tmp;
  };
  var JsonUtil_instance;
  function JsonUtil_getInstance() {
    if (JsonUtil_instance == null)
      new JsonUtil();
    return JsonUtil_instance;
  }
  function JsonValue() {
  }
  protoOf(JsonValue).v2t = function (indent) {
    var builder = new IndentBuilder(indent);
    this.r2u(builder);
    return builder.toString();
  };
  protoOf(JsonValue).toString = function () {
    return Json_getInstance().u2t(this);
  };
  function readCurrent($this) {
    var tmp;
    if ($this.k2v_1 < $this.j2v_1.length) {
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet($this.j2v_1, $this.k2v_1);
      tmp = Char__toInt_impl_vasixd(this_0);
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function StringJsonLexer(input) {
    JsonLexer.call(this, true);
    this.j2v_1 = input;
    this.k2v_1 = 0;
    this.l2v_1 = 0;
    this.m2v_1 = 0;
    this.n2v_1 = false;
    this.k2v_1 = 0;
    this.n2v_1 = false;
    this.m2t();
  }
  protoOf(StringJsonLexer).t2u = function () {
    if (!this.n2v_1) {
      this.n2v_1 = true;
      this.m2v_1 = readCurrent(this);
    }
    return this.m2v_1;
  };
  protoOf(StringJsonLexer).n2t = function () {
    var tmp0 = this.j2v_1;
    var tmp1 = this.l2v_1;
    // Inline function 'kotlin.text.substring' call
    var endIndex = this.k2v_1;
    // Inline function 'kotlin.js.asDynamic' call
    return tmp0.substring(tmp1, endIndex);
  };
  protoOf(StringJsonLexer).l2t = function () {
    return JsonUtil_getInstance().f2v(this.j2v_1, this.l2v_1 + 1 | 0, this.k2v_1 - 1 | 0);
  };
  protoOf(StringJsonLexer).c2v = function () {
    this.l2v_1 = this.k2v_1;
  };
  protoOf(StringJsonLexer).u2u = function () {
    this.k2v_1 = this.k2v_1 + 1 | 0;
    this.n2v_1 = false;
  };
  protoOf(StringJsonLexer).v2u = function (s) {
    if (this.t2u() === -1) {
      return false;
    }
    if (startsWith_0(this.j2v_1, s, this.k2v_1)) {
      this.k2v_1 = this.k2v_1 + s.length | 0;
      this.n2v_1 = false;
      return true;
    }
    return false;
  };
  function BaseJsonReaderSupport() {
  }
  protoOf(BaseJsonReaderSupport).o2v = function (jsonValue) {
    var tmp;
    if (jsonValue instanceof JsonArray) {
      tmp = new JsonArrayReaderImpl(jsonValue);
    } else {
      if (jsonValue instanceof JsonObject) {
        tmp = new JsonObjectReaderImpl(jsonValue);
      } else {
        throw UnsupportedOperationException_init_$Create$_0('unknown json value: ' + toString_1(getKClassFromExpression(jsonValue)));
      }
    }
    return tmp;
  };
  var BaseJsonReaderSupport_instance;
  function BaseJsonReaderSupport_getInstance() {
    return BaseJsonReaderSupport_instance;
  }
  function JsonArrayReaderImpl(jsonArray) {
    this.p2v_1 = jsonArray;
    this.q2v_1 = 0;
  }
  protoOf(JsonArrayReaderImpl).r2v = function (block) {
    return block(this);
  };
  protoOf(JsonArrayReaderImpl).s2v = function () {
    var tmp;
    if (this.q2v_1 < this.p2v_1.wo()) {
      var _unary__edvuaz = this.q2v_1;
      this.q2v_1 = _unary__edvuaz + 1 | 0;
      tmp = this.p2v_1.m2u(_unary__edvuaz);
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(JsonArrayReaderImpl).t2v = function () {
    var tmp;
    if (this.q2v_1 < this.p2v_1.wo()) {
      var _unary__edvuaz = this.q2v_1;
      this.q2v_1 = _unary__edvuaz + 1 | 0;
      var nextJsonArray = this.p2v_1.l2u(_unary__edvuaz);
      tmp = new JsonArrayReaderImpl(nextJsonArray);
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(JsonArrayReaderImpl).u2v = function () {
    var _unary__edvuaz = this.q2v_1;
    this.q2v_1 = _unary__edvuaz + 1 | 0;
    var jsonObject = this.p2v_1.k2u(_unary__edvuaz);
    return new JsonObjectReaderImpl(jsonObject);
  };
  function JsonObjectReaderImpl(jsonObject) {
    this.v2v_1 = jsonObject;
    this.w2v_1 = this.v2v_1.u2().k();
    this.x2v_1 = null;
  }
  protoOf(JsonObjectReaderImpl).y2v = function (block) {
    return block(this);
  };
  protoOf(JsonObjectReaderImpl).z2v = function () {
    var tmp = this;
    var tmp_0;
    if (this.w2v_1.l()) {
      tmp_0 = this.w2v_1.m();
    } else {
      tmp_0 = null;
    }
    tmp.x2v_1 = tmp_0;
    return this.x2v_1;
  };
  protoOf(JsonObjectReaderImpl).a2w = function () {
    return ensureNotNull(this.v2v_1.w10(ensureNotNull(this.x2v_1)));
  };
  protoOf(JsonObjectReaderImpl).t2v = function () {
    var jsonArray = ensureNotNull(this.v2v_1.e2v(ensureNotNull(this.x2v_1)));
    return new JsonArrayReaderImpl(jsonArray);
  };
  function JsonArrayReader() {
  }
  function CommonApiJsonIterator(jsonIterator) {
    this.b2w_1 = jsonIterator;
  }
  protoOf(CommonApiJsonIterator).c2w = function () {
    return this.b2w_1.c2w();
  };
  protoOf(CommonApiJsonIterator).i2w = function () {
    return this.b2w_1.i2w();
  };
  protoOf(CommonApiJsonIterator).j2w = function () {
    return this.b2w_1.j2w();
  };
  function CommonJsonIterSupport() {
  }
  protoOf(CommonJsonIterSupport).k2w = function () {
    return new CommonJsonIteratorFactory();
  };
  var CommonJsonIterSupport_instance;
  function CommonJsonIterSupport_getInstance() {
    return CommonJsonIterSupport_instance;
  }
  function CommonJsonIteratorFactory() {
  }
  protoOf(CommonJsonIteratorFactory).l2w = function (buf) {
    var jsonIterator = Companion_instance_38.l2w(buf);
    return new CommonApiJsonIterator(jsonIterator);
  };
  protoOf(CommonJsonIteratorFactory).toString = function () {
    return 'CommonJsonIteratorFactory';
  };
  function Hex() {
    Hex_instance = this;
    var tmp = this;
    var tmp_0 = 0;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(102);
    var tmp_1 = Char__toInt_impl_vasixd(this_0) + 1 | 0;
    var tmp_2 = new Int32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = -1;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.n2x_1 = tmp_2;
    var inductionVariable = _Char___init__impl__6a9atx(48);
    if (inductionVariable <= _Char___init__impl__6a9atx(57))
      do {
        var ch = inductionVariable;
        inductionVariable = Char__plus_impl_qi7pgj(inductionVariable, 1);
        // Inline function 'kotlin.code' call
        var i = Char__toInt_impl_vasixd(ch);
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(48);
        var tmp$ret$3 = Char__toInt_impl_vasixd(this_1);
        this.n2x_1[i] = i - tmp$ret$3 | 0;
      }
       while (inductionVariable <= _Char___init__impl__6a9atx(57));
    var inductionVariable_0 = _Char___init__impl__6a9atx(97);
    if (inductionVariable_0 <= _Char___init__impl__6a9atx(102))
      do {
        var ch_0 = inductionVariable_0;
        inductionVariable_0 = Char__plus_impl_qi7pgj(inductionVariable_0, 1);
        // Inline function 'kotlin.code' call
        var i_0 = Char__toInt_impl_vasixd(ch_0);
        // Inline function 'kotlin.code' call
        var this_2 = _Char___init__impl__6a9atx(97);
        var tmp$ret$5 = Char__toInt_impl_vasixd(this_2);
        this.n2x_1[i_0] = (i_0 - tmp$ret$5 | 0) + 10 | 0;
      }
       while (inductionVariable_0 <= _Char___init__impl__6a9atx(102));
    var inductionVariable_1 = _Char___init__impl__6a9atx(65);
    if (inductionVariable_1 <= _Char___init__impl__6a9atx(70))
      do {
        var ch_1 = inductionVariable_1;
        inductionVariable_1 = Char__plus_impl_qi7pgj(inductionVariable_1, 1);
        // Inline function 'kotlin.code' call
        var i_1 = Char__toInt_impl_vasixd(ch_1);
        // Inline function 'kotlin.code' call
        var this_3 = _Char___init__impl__6a9atx(65);
        var tmp$ret$7 = Char__toInt_impl_vasixd(this_3);
        this.n2x_1[i_1] = (i_1 - tmp$ret$7 | 0) + 10 | 0;
      }
       while (inductionVariable_1 <= _Char___init__impl__6a9atx(70));
  }
  protoOf(Hex).o2x = function (b) {
    var value = this.n2x_1[b];
    // Inline function 'kotlin.require' call
    if (!!(value === -1)) {
      // Inline function 'jetbrains.ocelot.base.jsoniter.impl.Hex.translateHex.<anonymous>' call
      var message = '' + b + ' is not valid hex digit';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return value;
  };
  var Hex_instance;
  function Hex_getInstance() {
    if (Hex_instance == null)
      new Hex();
    return Hex_instance;
  }
  function JsonException(message) {
    RuntimeException_init_$Init$_0(message, this);
    captureStack(this, JsonException);
  }
  function nextToken($this) {
    var i = $this.e2w_1;
    loop: while (true) {
      var tmp = $this.d2w_1;
      var _unary__edvuaz = i;
      i = _unary__edvuaz + 1 | 0;
      var c = tmp[_unary__edvuaz];
      var tmp_0;
      if (c === 32 || c === 10 || (c === 13 || c === 9)) {
        continue loop;
      } else {
        $this.e2w_1 = i;
        tmp_0 = c;
      }
      return tmp_0;
    }
  }
  function unreadByte($this) {
    if ($this.e2w_1 === 0) {
      throw reportError($this, 'unreadByte', 'unread too many bytes');
    }
    $this.e2w_1 = $this.e2w_1 - 1 | 0;
  }
  function skipFixedBytes($this, n) {
    $this.e2w_1 = $this.e2w_1 + n | 0;
  }
  function reportError($this, op, msg) {
    // Inline function 'kotlin.math.max' call
    var a = $this.e2w_1 - 10 | 0;
    var peekStart = Math.max(a, 0);
    var tmp2 = $this.e2w_1;
    // Inline function 'kotlin.math.min' call
    var b = $this.f2w_1;
    var peekSize = Math.min(tmp2, b) - peekStart | 0;
    var peek = decodeToString_0($this.d2w_1, peekStart, peekSize);
    var bufString = decodeToString($this.d2w_1);
    throw new JsonException(op + ': ' + msg + ', head: ' + $this.e2w_1 + ', peek: ' + peek + ', buf: ' + bufString);
  }
  function parse($this) {
    var c;
    var i = $this.e2w_1;
    var bound = $this.h2w_1.length;
    var inductionVariable = 0;
    if (inductionVariable < bound)
      $l$loop: do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = $this.d2w_1;
        var _unary__edvuaz = i;
        i = _unary__edvuaz + 1 | 0;
        c = tmp[_unary__edvuaz];
        if (c === 34) {
          $this.e2w_1 = i;
          return j;
        }
        // Inline function 'kotlin.experimental.xor' call
        if (toByte(c ^ 92) < 1) {
          break $l$loop;
        }
        $this.h2w_1[j] = numberToChar(c);
      }
       while (inductionVariable < bound);
    var alreadyCopied = 0;
    if (i > $this.e2w_1) {
      alreadyCopied = (i - $this.e2w_1 | 0) - 1 | 0;
      $this.e2w_1 = i - 1 | 0;
    }
    return readStringSlowPath($this, alreadyCopied);
  }
  function readStringSlowPath($this, j) {
    var currentJ = j;
    try {
      var isExpectingLowSurrogate = false;
      var i = $this.e2w_1;
      $l$loop: while (i < $this.f2w_1) {
        var tmp = $this.d2w_1;
        var _unary__edvuaz = i;
        i = _unary__edvuaz + 1 | 0;
        var bc = tmp[_unary__edvuaz];
        if (bc === 34) {
          $this.e2w_1 = i;
          return currentJ;
        }
        if (bc === 92) {
          var tmp_0 = $this.d2w_1;
          var _unary__edvuaz_0 = i;
          i = _unary__edvuaz_0 + 1 | 0;
          bc = tmp_0[_unary__edvuaz_0];
          switch (bc) {
            case 98:
              bc = 8;
              break;
            case 116:
              bc = 9;
              break;
            case 110:
              bc = 10;
              break;
            case 102:
              bc = 12;
              break;
            case 114:
              bc = 13;
              break;
            case 34:
            case 47:
            case 92:
              break;
            case 117:
              var tmp_1 = Hex_getInstance();
              var tmp_2 = $this.d2w_1;
              var _unary__edvuaz_1 = i;
              i = _unary__edvuaz_1 + 1 | 0;
              var tmp_3 = tmp_1.o2x(tmp_2[_unary__edvuaz_1]) << 12;
              var tmp_4 = Hex_getInstance();
              var tmp_5 = $this.d2w_1;
              var _unary__edvuaz_2 = i;
              i = _unary__edvuaz_2 + 1 | 0;
              var tmp_6 = tmp_3 + (tmp_4.o2x(tmp_5[_unary__edvuaz_2]) << 8) | 0;
              var tmp_7 = Hex_getInstance();
              var tmp_8 = $this.d2w_1;
              var _unary__edvuaz_3 = i;
              i = _unary__edvuaz_3 + 1 | 0;
              var tmp_9 = tmp_6 + (tmp_7.o2x(tmp_8[_unary__edvuaz_3]) << 4) | 0;
              var tmp_10 = Hex_getInstance();
              var tmp_11 = $this.d2w_1;
              var _unary__edvuaz_4 = i;
              i = _unary__edvuaz_4 + 1 | 0;
              bc = tmp_9 + tmp_10.o2x(tmp_11[_unary__edvuaz_4]) | 0;
              var bcChar = numberToChar(bc);
              if (isHighSurrogate(bcChar)) {
                var tmp_12;
                if (isExpectingLowSurrogate) {
                  throw new JsonException('invalid surrogate');
                } else {
                  tmp_12 = true;
                }
                isExpectingLowSurrogate = tmp_12;
              } else if (isLowSurrogate(bcChar)) {
                var tmp_13;
                if (isExpectingLowSurrogate) {
                  tmp_13 = false;
                } else {
                  throw new JsonException('invalid surrogate');
                }
                isExpectingLowSurrogate = tmp_13;
              } else if (isExpectingLowSurrogate) {
                throw new JsonException('invalid surrogate');
              }

              break;
            default:
              throw reportError($this, 'readStringSlowPath', 'invalid escape character: ' + bc);
          }
        } else if (!((bc & 128) === 0)) {
          var tmp_14 = $this.d2w_1;
          var _unary__edvuaz_5 = i;
          i = _unary__edvuaz_5 + 1 | 0;
          var u2 = tmp_14[_unary__edvuaz_5];
          if ((bc & 224) === 192) {
            bc = ((bc & 31) << 6) + (u2 & 63) | 0;
          } else {
            var tmp_15 = $this.d2w_1;
            var _unary__edvuaz_6 = i;
            i = _unary__edvuaz_6 + 1 | 0;
            var u3 = tmp_15[_unary__edvuaz_6];
            if ((bc & 240) === 224) {
              bc = (((bc & 15) << 12) + ((u2 & 63) << 6) | 0) + (u3 & 63) | 0;
            } else {
              var tmp_16 = $this.d2w_1;
              var _unary__edvuaz_7 = i;
              i = _unary__edvuaz_7 + 1 | 0;
              var u4 = tmp_16[_unary__edvuaz_7];
              var tmp_17;
              if ((bc & 248) === 240) {
                tmp_17 = ((((bc & 7) << 18) + ((u2 & 63) << 12) | 0) + ((u3 & 63) << 6) | 0) + (u4 & 63) | 0;
              } else {
                throw reportError($this, 'readStringSlowPath', 'invalid unicode character');
              }
              bc = tmp_17;
              if (bc >= 65536) {
                if (bc >= 1114112) {
                  throw reportError($this, 'readStringSlowPath', 'invalid unicode character');
                }
                var sup = bc - 65536 | 0;
                if ($this.h2w_1.length === currentJ) {
                  var newBuf = charArray(imul($this.h2w_1.length, 2));
                  var tmp0 = $this.h2w_1;
                  // Inline function 'kotlin.collections.copyInto' call
                  var endIndex = tmp0.length;
                  // Inline function 'kotlin.js.unsafeCast' call
                  // Inline function 'kotlin.js.asDynamic' call
                  var tmp_18 = tmp0;
                  // Inline function 'kotlin.js.unsafeCast' call
                  // Inline function 'kotlin.js.asDynamic' call
                  arrayCopy(tmp_18, newBuf, 0, 0, endIndex);
                  $this.h2w_1 = newBuf;
                }
                var tmp_19 = $this.h2w_1;
                var _unary__edvuaz_8 = currentJ;
                currentJ = _unary__edvuaz_8 + 1 | 0;
                tmp_19[_unary__edvuaz_8] = numberToChar((sup >>> 10 | 0) + 55296 | 0);
                if ($this.h2w_1.length === currentJ) {
                  var newBuf_0 = charArray(imul($this.h2w_1.length, 2));
                  var tmp5 = $this.h2w_1;
                  // Inline function 'kotlin.collections.copyInto' call
                  var endIndex_0 = tmp5.length;
                  // Inline function 'kotlin.js.unsafeCast' call
                  // Inline function 'kotlin.js.asDynamic' call
                  var tmp_20 = tmp5;
                  // Inline function 'kotlin.js.unsafeCast' call
                  // Inline function 'kotlin.js.asDynamic' call
                  arrayCopy(tmp_20, newBuf_0, 0, 0, endIndex_0);
                  $this.h2w_1 = newBuf_0;
                }
                var tmp_21 = $this.h2w_1;
                var _unary__edvuaz_9 = currentJ;
                currentJ = _unary__edvuaz_9 + 1 | 0;
                tmp_21[_unary__edvuaz_9] = numberToChar((sup & 1023) + 56320 | 0);
                continue $l$loop;
              }
            }
          }
        }
        if ($this.h2w_1.length === currentJ) {
          var newBuf_1 = charArray(imul($this.h2w_1.length, 2));
          var tmp10 = $this.h2w_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex_1 = tmp10.length;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_22 = tmp10;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp_22, newBuf_1, 0, 0, endIndex_1);
          $this.h2w_1 = newBuf_1;
        }
        var tmp_23 = $this.h2w_1;
        var _unary__edvuaz_10 = currentJ;
        currentJ = _unary__edvuaz_10 + 1 | 0;
        tmp_23[_unary__edvuaz_10] = numberToChar(bc);
      }
      throw reportError($this, 'readStringSlowPath', 'incomplete string');
    } catch ($p) {
      if ($p instanceof IndexOutOfBoundsException) {
        var e = $p;
        throw reportError($this, 'readString', 'incomplete string');
      } else {
        throw $p;
      }
    }
  }
  function Companion_38() {
    this.m2w_1 = 9;
    this.n2w_1 = 10;
    this.o2w_1 = 13;
    this.p2w_1 = 32;
    this.q2w_1 = 34;
    this.r2w_1 = 44;
    this.s2w_1 = 58;
    this.t2w_1 = 92;
    this.u2w_1 = 91;
    this.v2w_1 = 93;
    this.w2w_1 = 123;
    this.x2w_1 = 125;
    this.y2w_1 = 110;
    this.z2w_1 = 34;
    this.a2x_1 = 92;
    this.b2x_1 = 47;
    this.c2x_1 = 98;
    this.d2x_1 = 116;
    this.e2x_1 = 110;
    this.f2x_1 = 102;
    this.g2x_1 = 114;
    this.h2x_1 = 117;
    this.i2x_1 = 8;
    this.j2x_1 = 9;
    this.k2x_1 = 10;
    this.l2x_1 = 12;
    this.m2x_1 = 13;
  }
  protoOf(Companion_38).l2w = function (buf) {
    return new JsonIterator(buf, 0, buf.length);
  };
  var Companion_instance_38;
  function Companion_getInstance_38() {
    return Companion_instance_38;
  }
  function JsonIterator(buf, head, tail) {
    this.d2w_1 = buf;
    this.e2w_1 = head;
    this.f2w_1 = tail;
    this.g2w_1 = HashMap_init_$Create$();
    this.h2w_1 = charArray(32);
  }
  protoOf(JsonIterator).c2w = function () {
    var c = nextToken(this);
    var tmp0_subject = c;
    var tmp;
    if (tmp0_subject === 91) {
      c = nextToken(this);
      var tmp_0;
      if (c === 93) {
        tmp_0 = false;
      } else {
        unreadByte(this);
        tmp_0 = true;
      }
      tmp = tmp_0;
    } else if (tmp0_subject === 93) {
      tmp = false;
    } else if (tmp0_subject === 44) {
      tmp = true;
    } else if (tmp0_subject === 110) {
      tmp = false;
    } else {
      throw reportError(this, 'readArray', 'expect [ or , or n or ], but found: ' + c);
    }
    return tmp;
  };
  protoOf(JsonIterator).j2w = function () {
    var c = nextToken(this);
    var tmp0_subject = c;
    var tmp;
    if (tmp0_subject === 110) {
      skipFixedBytes(this, 3);
      tmp = null;
    } else if (tmp0_subject === 123) {
      c = nextToken(this);
      var tmp1_subject = c;
      var tmp_0;
      if (tmp1_subject === 34) {
        unreadByte(this);
        var field = this.i2w();
        if (!(nextToken(this) === 58)) {
          throw reportError(this, 'readObject', 'expect :');
        }
        tmp_0 = field;
      } else if (tmp1_subject === 125) {
        tmp_0 = null;
      } else {
        throw reportError(this, 'readObject', 'expect " after {');
      }
      tmp = tmp_0;
    } else if (tmp0_subject === 44) {
      var field_0 = this.i2w();
      if (!(nextToken(this) === 58)) {
        throw reportError(this, 'readObject', 'expect :');
      }
      tmp = field_0;
    } else if (tmp0_subject === 125) {
      tmp = null;
    } else {
      throw reportError(this, 'readObject', 'expect { or , or } or n, but found: ' + c);
    }
    return tmp;
  };
  protoOf(JsonIterator).i2w = function () {
    var c = nextToken(this);
    if (!(c === 34)) {
      if (c === 110) {
        skipFixedBytes(this, 3);
        return null;
      }
      throw reportError(this, 'readString', 'expect string or null, but ' + c);
    }
    var j = parse(this);
    var string = concatToString_0(this.h2w_1, 0, 0 + j | 0);
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.g2w_1;
    var value = this_0.y2(string);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.base.jsoniter.impl.JsonIterator.readString.<anonymous>' call
      var answer = string;
      this_0.r2(string, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  };
  function readArrayToken($this) {
    var hasMore = $this.p2x_1.c2w();
    if (!hasMore) {
      $this.s2x_1 = true;
    }
    return hasMore;
  }
  function createJsonIterReaderInArray($this) {
    var readFun = JsonIterArrayReader$createJsonIterReaderInArray$lambda($this);
    return readNext($this, readFun);
  }
  function readNext($this, readFun) {
    var tmp;
    if ($this.q2x_1) {
      var tmp_0;
      if ($this.r2x_1) {
        $this.r2x_1 = false;
        tmp_0 = readFun();
      } else {
        var hasMore = readArrayToken($this);
        var tmp_1;
        if (hasMore) {
          tmp_1 = readFun();
        } else {
          tmp_1 = null;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function ApiJsonIterator$readString$ref($boundThis) {
    var l = function () {
      return $boundThis.i2w();
    };
    l.callableName = 'readString';
    return l;
  }
  function JsonIterArrayReader$createJsonIterReaderInArray$lambda(this$0) {
    return function () {
      return new JsonIterReader(this$0.p2x_1);
    };
  }
  function JsonIterArrayReader(jsonIterator, hasMore) {
    this.p2x_1 = jsonIterator;
    this.q2x_1 = hasMore;
    this.r2x_1 = true;
    this.s2x_1 = !this.q2x_1;
  }
  protoOf(JsonIterArrayReader).r2v = function (block) {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(JsonIterArrayReader).s2v = function () {
    return readNext(this, ApiJsonIterator$readString$ref(this.p2x_1));
  };
  protoOf(JsonIterArrayReader).t2v = function () {
    return createJsonIterReaderInArray(this);
  };
  protoOf(JsonIterArrayReader).u2v = function () {
    return createJsonIterReaderInArray(this);
  };
  protoOf(JsonIterArrayReader).t2x = function () {
    if (!this.s2x_1) {
      var hasMore = readArrayToken(this);
      // Inline function 'kotlin.check' call
      if (!!hasMore) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
    }
  };
  function JsonIterObjectReader(jsonIterator) {
    this.u2x_1 = jsonIterator;
  }
  protoOf(JsonIterObjectReader).y2v = function (block) {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(JsonIterObjectReader).z2v = function () {
    return this.u2x_1.j2w();
  };
  protoOf(JsonIterObjectReader).a2w = function () {
    return this.u2x_1.i2w();
  };
  protoOf(JsonIterObjectReader).t2v = function () {
    return new JsonIterReader(this.u2x_1);
  };
  function readArrayToken_0($this) {
    return $this.v2x_1.c2w();
  }
  function JsonIterReader(jsonIterator) {
    this.v2x_1 = jsonIterator;
  }
  protoOf(JsonIterReader).r2v = function (block) {
    var hasMoreAtStart = readArrayToken_0(this);
    var arrayReader = new JsonIterArrayReader(this.v2x_1, hasMoreAtStart);
    var result = block(arrayReader);
    arrayReader.t2x();
    return result;
  };
  protoOf(JsonIterReader).y2v = function (block) {
    var objectReader = new JsonIterObjectReader(this.v2x_1);
    return block(objectReader);
  };
  protoOf(JsonIterReader).s2v = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(JsonIterReader).t2v = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(JsonIterReader).u2v = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(JsonIterReader).z2v = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(JsonIterReader).a2w = function () {
    throw IllegalStateException_init_$Create$();
  };
  function JsonIterReaderFactory(jsonIteratorFactory) {
    this.w2x_1 = jsonIteratorFactory;
  }
  protoOf(JsonIterReaderFactory).x2x = function (jsonBytes) {
    var jsonIterator = this.w2x_1.l2w(jsonBytes);
    return new JsonIterReader(jsonIterator);
  };
  protoOf(JsonIterReaderFactory).toString = function () {
    return toString_1(this.w2x_1);
  };
  function JsonStreamIterSupport() {
  }
  protoOf(JsonStreamIterSupport).y2x = function (jsonIteratorFactory) {
    return new JsonIterReaderFactory(jsonIteratorFactory);
  };
  var JsonStreamIterSupport_instance;
  function JsonStreamIterSupport_getInstance() {
    return JsonStreamIterSupport_instance;
  }
  function CommonJsonStreamIterSupport() {
  }
  protoOf(CommonJsonStreamIterSupport).z2x = function () {
    var jsonIteratorFactory = CommonJsonIterSupport_instance.k2w();
    return JsonStreamIterSupport_instance.y2x(jsonIteratorFactory);
  };
  protoOf(CommonJsonStreamIterSupport).a2y = function (jsonString) {
    var jsonBytes = encodeToByteArray(jsonString);
    return this.b2y(jsonBytes);
  };
  protoOf(CommonJsonStreamIterSupport).b2y = function (jsonBytes) {
    var jsonReaderFactory = this.z2x();
    return jsonReaderFactory.x2x(jsonBytes);
  };
  var CommonJsonStreamIterSupport_instance;
  function CommonJsonStreamIterSupport_getInstance() {
    return CommonJsonStreamIterSupport_instance;
  }
  function Configuration_init_$Init$($this) {
    Configuration.call($this);
    return $this;
  }
  function Configuration_init_$Create$() {
    return Configuration_init_$Init$(objectCreate(protoOf(Configuration)));
  }
  protoOf(Configuration).d2y = function () {
    return this.c2y_1.u2();
  };
  protoOf(Configuration).e2y = function (key, value) {
    var tmp0 = this.c2y_1;
    // Inline function 'kotlin.collections.set' call
    var value_0 = !(value == null) ? value : THROW_CCE();
    tmp0.r2(key, value_0);
    return this;
  };
  protoOf(Configuration).f2y = function (key) {
    var tmp;
    if (!this.h2y(key) && key.i2y()) {
      tmp = key.g2y();
    } else {
      var tmp_0 = this.c2y_1.y2(key);
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(Configuration).h2y = function (key) {
    return this.c2y_1.w2(key);
  };
  protoOf(Configuration).j2y = function (other) {
    var parameters = HashSet_init_$Create$();
    parameters.o(this.d2y());
    parameters.o(other.d2y());
    var _iterator__ex2g4s = parameters.k();
    while (_iterator__ex2g4s.l()) {
      var parameter = _iterator__ex2g4s.m();
      if (!equals(this.f2y(parameter), other.f2y(parameter))) {
        return parameter;
      }
    }
    return null;
  };
  function Configuration() {
    this.c2y_1 = HashMap_init_$Create$();
  }
  function getPersister($this, tag) {
    return $this.l2y(tag).m2y();
  }
  function ConfigurationPersistentContext() {
    this.k2y_1 = HashMap_init_$Create$();
  }
  protoOf(ConfigurationPersistentContext).n2y = function () {
    return this.k2y_1.u2();
  };
  protoOf(ConfigurationPersistentContext).o2y = function (parameter) {
    // Inline function 'kotlin.check' call
    if (!!this.k2y_1.w2(parameter.p2y())) {
      // Inline function 'jetbrains.ocelot.ot.commons.configuration.ConfigurationPersistentContext.add.<anonymous>' call
      var message = "Parameter with tag '" + parameter.p2y() + "' is already registered";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp1 = this.k2y_1;
    // Inline function 'kotlin.collections.set' call
    var key = parameter.p2y();
    tmp1.r2(key, parameter);
  };
  protoOf(ConfigurationPersistentContext).l2y = function (tag) {
    // Inline function 'kotlin.check' call
    if (!this.k2y_1.w2(tag)) {
      // Inline function 'jetbrains.ocelot.ot.commons.configuration.ConfigurationPersistentContext.getConfigurationParameter.<anonymous>' call
      var message = 'Unknown tag: ' + tag;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp = ensureNotNull(this.k2y_1.y2(tag));
    return isInterface(tmp, PersistentParameter) ? tmp : THROW_CCE();
  };
  protoOf(ConfigurationPersistentContext).q2y = function (tag, value) {
    return getPersister(this, tag).q2q(value);
  };
  function addToConfiguration($this, configuration, tag, jsonValue) {
    var parameter = $this.r2y_1.l2y(tag);
    configuration.e2y(parameter, ensureNotNull($this.r2y_1.q2y(tag, jsonValue)));
  }
  function ConfigurationPersister(persistentContext) {
    this.r2y_1 = persistentContext;
  }
  protoOf(ConfigurationPersister).s2y = function (jsonObject) {
    var configuration = Configuration_init_$Create$();
    var _iterator__ex2g4s = this.r2y_1.n2y().k();
    while (_iterator__ex2g4s.l()) {
      var tag = _iterator__ex2g4s.m();
      var value = jsonObject.w10(tag);
      if (!(value == null)) {
        addToConfiguration(this, configuration, tag, value);
      }
    }
    return configuration;
  };
  function PersistentParameter() {
  }
  function LoggingUtils() {
    this.t2y_1 = 500;
  }
  protoOf(LoggingUtils).u2y = function (o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else {
      tmp = this.v2y(toString_1(o));
    }
    return tmp;
  };
  protoOf(LoggingUtils).v2y = function (string) {
    if (string == null) {
      return 'null';
    }
    var tmp;
    if (string.length > 500) {
      tmp = take_1(string, 500) + '...';
    } else {
      tmp = string;
    }
    return tmp;
  };
  var LoggingUtils_instance;
  function LoggingUtils_getInstance() {
    return LoggingUtils_instance;
  }
  function OtRejectionException(reason) {
    reason = reason === VOID ? RejectionReason_INTERNAL_ERROR_getInstance() : reason;
    RuntimeException_init_$Init$_0(reason.y2y_1, this);
    captureStack(this, OtRejectionException);
    this.z2y_1 = reason;
  }
  var RejectionReason_NOT_FOUND_instance;
  var RejectionReason_ACCESS_DENIED_instance;
  var RejectionReason_INVALID_OPERATION_instance;
  var RejectionReason_INTERNAL_ERROR_instance;
  var RejectionReason_TIMEOUT_instance;
  var RejectionReason_DISCONNECTED_instance;
  function values() {
    return [RejectionReason_NOT_FOUND_getInstance(), RejectionReason_ACCESS_DENIED_getInstance(), RejectionReason_INVALID_OPERATION_getInstance(), RejectionReason_INTERNAL_ERROR_getInstance(), RejectionReason_TIMEOUT_getInstance(), RejectionReason_DISCONNECTED_getInstance()];
  }
  var RejectionReason_entriesInitialized;
  function RejectionReason_initEntries() {
    if (RejectionReason_entriesInitialized)
      return Unit_instance;
    RejectionReason_entriesInitialized = true;
    RejectionReason_NOT_FOUND_instance = new RejectionReason('NOT_FOUND', 0, 'entity was not found');
    RejectionReason_ACCESS_DENIED_instance = new RejectionReason('ACCESS_DENIED', 1, 'access denied');
    RejectionReason_INVALID_OPERATION_instance = new RejectionReason('INVALID_OPERATION', 2, 'invalid operation');
    RejectionReason_INTERNAL_ERROR_instance = new RejectionReason('INTERNAL_ERROR', 3, 'internal error');
    RejectionReason_TIMEOUT_instance = new RejectionReason('TIMEOUT', 4, 'timeout');
    RejectionReason_DISCONNECTED_instance = new RejectionReason('DISCONNECTED', 5, 'disconnected');
  }
  function RejectionReason(name, ordinal, reason) {
    Enum.call(this, name, ordinal);
    this.y2y_1 = reason;
  }
  function RejectionReason_NOT_FOUND_getInstance() {
    RejectionReason_initEntries();
    return RejectionReason_NOT_FOUND_instance;
  }
  function RejectionReason_ACCESS_DENIED_getInstance() {
    RejectionReason_initEntries();
    return RejectionReason_ACCESS_DENIED_instance;
  }
  function RejectionReason_INVALID_OPERATION_getInstance() {
    RejectionReason_initEntries();
    return RejectionReason_INVALID_OPERATION_instance;
  }
  function RejectionReason_INTERNAL_ERROR_getInstance() {
    RejectionReason_initEntries();
    return RejectionReason_INTERNAL_ERROR_instance;
  }
  function RejectionReason_TIMEOUT_getInstance() {
    RejectionReason_initEntries();
    return RejectionReason_TIMEOUT_instance;
  }
  function RejectionReason_DISCONNECTED_getInstance() {
    RejectionReason_initEntries();
    return RejectionReason_DISCONNECTED_instance;
  }
  function ThreadSafeProperty$get$lambda(this$0) {
    return function () {
      return protoOf(ValueProperty).qr.call(this$0);
    };
  }
  function ThreadSafeProperty$set$lambda(this$0, $newValue) {
    return function () {
      protoOf(ValueProperty).t2c.call(this$0, $newValue);
      return Unit_instance;
    };
  }
  function ThreadSafeProperty$addHandler$lambda(this$0, $handler) {
    return function () {
      return protoOf(ValueProperty).k2c.call(this$0, $handler);
    };
  }
  function ThreadSafeProperty(initialValue) {
    ValueProperty.call(this, initialValue);
    this.c2z_1 = newLock();
  }
  protoOf(ThreadSafeProperty).qr = function () {
    return this.c2z_1.kr(ThreadSafeProperty$get$lambda(this));
  };
  protoOf(ThreadSafeProperty).t2c = function (newValue) {
    this.c2z_1.kr(ThreadSafeProperty$set$lambda(this, newValue));
  };
  protoOf(ThreadSafeProperty).k2c = function (handler) {
    return this.c2z_1.kr(ThreadSafeProperty$addHandler$lambda(this, handler));
  };
  protoOf(ThreadSafeProperty).o27 = function (handler) {
    return this.k2c(handler);
  };
  function entityWithTheSameId($this) {
    return Entities$entityWithTheSameId$lambda;
  }
  function copyContent($this, entity, copy, entityFactory, childFilter) {
    $this.f2z(entity, copy);
    $this.g2z(entity, copy);
    $this.h2z(entity, copy);
    var _iterator__ex2g4s = entity.v2z().k();
    while (_iterator__ex2g4s.l()) {
      var childId = _iterator__ex2g4s.m();
      var children = entity.w2z(childId);
      var _iterator__ex2g4s_0 = children.k();
      while (_iterator__ex2g4s_0.l()) {
        var child = _iterator__ex2g4s_0.m();
        if (childFilter(child)) {
          var childCopy = entityFactory(child);
          copyContent($this, child, childCopy, entityFactory, childFilter);
          copy.w2z(childId).e(childCopy);
        }
      }
    }
  }
  function copyContent_0($this, entity, copy) {
    var tmp = entityWithTheSameId($this);
    copyContent($this, entity, copy, tmp, Entities$copyContent$lambda);
  }
  function Entities$entityWithTheSameId$lambda(entity) {
    return new Entity(entity.i2z_1, entity.j2z_1);
  }
  function Entities$ENTITY_WITH_NEW_ID$lambda(value) {
    return new Entity(value.i2z_1);
  }
  function Entities$copyContent$lambda(it) {
    return true;
  }
  function Entities() {
    Entities_instance = this;
    this.d2z_1 = '  ';
    var tmp = this;
    tmp.e2z_1 = Entities$ENTITY_WITH_NEW_ID$lambda;
  }
  protoOf(Entities).x2z = function (entity) {
    var copy = entityWithTheSameId(this)(entity);
    copyContent_0(this, entity, copy);
    return copy;
  };
  protoOf(Entities).f2z = function (from, to) {
    var _iterator__ex2g4s = from.y2z().k();
    while (_iterator__ex2g4s.l()) {
      var propId = _iterator__ex2g4s.m();
      to.a30(propId, from.z2z(propId));
    }
  };
  protoOf(Entities).g2z = function (from, to) {
    var _iterator__ex2g4s = from.b30().k();
    while (_iterator__ex2g4s.l()) {
      var refId = _iterator__ex2g4s.m();
      var targets = from.c30(refId);
      to.c30(refId).o(targets);
    }
  };
  protoOf(Entities).h2z = function (from, to) {
    var _iterator__ex2g4s = from.d30().k();
    while (_iterator__ex2g4s.l()) {
      var blobId = _iterator__ex2g4s.m();
      var model = from.e30(blobId);
      if (model == null) {
        to.f30(blobId, null);
      }
      to.f30(blobId, ensureNotNull(model).o30());
    }
  };
  protoOf(Entities).p30 = function (entity) {
    return entity.m2z_1 == null ? null : root(entity);
  };
  protoOf(Entities).q30 = function (ancestorId, entity) {
    var tmp0 = ancestorsFrom(entity);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.ot.model.entity.Entities.hasAncestorWithId.<anonymous>' call
        if (element.j2z_1.equals(ancestorId)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  var Entities_instance;
  function Entities_getInstance() {
    if (Entities_instance == null)
      new Entities();
    return Entities_instance;
  }
  function Entity$SafeObservableHashSet$1(this$0) {
    this.r30_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(Entity$SafeObservableHashSet$1).c27 = function (event) {
    setEventInProgress(this.r30_1, true);
  };
  protoOf(Entity$SafeObservableHashSet$1).j27 = function (event) {
    setEventInProgress(this.r30_1, true);
  };
  function getCantAddMessage($this, entity) {
    return 'Cannot add entity with id=' + entity.j2z_1 + ' to role=' + $this.v30_1 + ' in context=' + toString_0($this.u30_1.m2z_1);
  }
  function getCantRemoveMessage($this, entity) {
    return 'Cannot remove entity with id=' + entity.j2z_1 + ' from role=' + $this.v30_1 + ' in context=' + toString_0($this.u30_1.m2z_1);
  }
  function decNonEmptyFeatures($this) {
    $this.t2z_1 = $this.t2z_1 - 1 | 0;
  }
  function incNonEmptyFeatures($this) {
    $this.t2z_1 = $this.t2z_1 + 1 | 0;
  }
  function contextEvent($this, changedChild) {
    return !($this.m2z_1 == null) && !changedChild.u2z_1;
  }
  function setEventInProgress($this, inProgress) {
    var entityContext = $this.m2z_1;
    if (!(entityContext == null)) {
      entityContext.d31(inProgress);
    }
  }
  function checkCanModify($this) {
    var tmp0_safe_receiver = $this.m2z_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.e31();
    }
  }
  function ModelListenerData(propertyId, handler) {
    this.f31_1 = propertyId;
    this.g31_1 = handler;
  }
  function SafeObservableHashSet($outer) {
    this.j31_1 = $outer;
    ObservableHashSet_init_$Init$(this);
    this.n27(new Entity$SafeObservableHashSet$1(this.j31_1));
  }
  protoOf(SafeObservableHashSet).g29 = function (item) {
    return checkCanModify(this.j31_1);
  };
  protoOf(SafeObservableHashSet).j29 = function (item) {
    return checkCanModify(this.j31_1);
  };
  protoOf(SafeObservableHashSet).i29 = function (item, success) {
    if (!success)
      return Unit_instance;
    try {
      if (this.n() === 1) {
        incNonEmptyFeatures(this.j31_1);
      }
      if (!(this.j31_1.m2z_1 == null)) {
        this.k31(item);
      }
    }finally {
      setEventInProgress(this.j31_1, false);
    }
  };
  protoOf(SafeObservableHashSet).l29 = function (item, success) {
    if (!success)
      return Unit_instance;
    try {
      if (this.p()) {
        decNonEmptyFeatures(this.j31_1);
      }
      if (!(this.j31_1.m2z_1 == null)) {
        this.l31(item);
      }
    }finally {
      setEventInProgress(this.j31_1, false);
    }
  };
  function Entity$set$lambda($propId, $event) {
    return function (data) {
      var tmp;
      if (data.m31_1.equals($propId)) {
        data.n31_1.d28($event);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Entity$set$lambda_0($modelId, $event) {
    return function (listenerData) {
      var tmp;
      if (listenerData.f31_1.equals($modelId)) {
        listenerData.g31_1.d28($event);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Entity$modelProperty$1($blobId, this$0) {
    this.o31_1 = $blobId;
    this.p31_1 = this$0;
  }
  protoOf(Entity$modelProperty$1).l2c = function () {
    return toString_1(this) + '.' + this.o31_1.toString();
  };
  protoOf(Entity$modelProperty$1).qr = function () {
    return this.p31_1.e30(this.o31_1);
  };
  protoOf(Entity$modelProperty$1).q31 = function (newValue) {
    this.p31_1.f30(this.o31_1, newValue);
  };
  protoOf(Entity$modelProperty$1).t2c = function (newValue) {
    return this.q31((newValue == null ? true : newValue instanceof Model) ? newValue : THROW_CCE());
  };
  protoOf(Entity$modelProperty$1).r31 = function (handler) {
    return this.p31_1.s31(this.o31_1, handler);
  };
  protoOf(Entity$modelProperty$1).o27 = function (handler) {
    return this.r31(handler);
  };
  function Entity$get$1(this$0, $refId) {
    this.w31_1 = this$0;
    this.x31_1 = $refId;
    SafeObservableHashSet.call(this, this$0);
  }
  protoOf(Entity$get$1).y31 = function (item) {
    protoOf(SafeObservableHashSet).g29.call(this, item);
    // Inline function 'kotlin.check' call
    if (!(!this.x31_1.b32() || this.p())) {
      // Inline function 'jetbrains.ocelot.ot.model.entity.<no name provided>.checkAdd.<anonymous>' call
      var message = 'Adding second item to single reference role ' + this.x31_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(Entity$get$1).g29 = function (item) {
    return this.y31((item == null ? true : item instanceof EntityReference) ? item : THROW_CCE());
  };
  protoOf(Entity$get$1).c32 = function (item) {
    ensureNotNull(this.w31_1.m2z_1).d32(this.w31_1, this.x31_1, new CollectionItemEvent(null, item, -1, EventType_ADD_getInstance()));
  };
  protoOf(Entity$get$1).k31 = function (item) {
    return this.c32((item == null ? true : item instanceof EntityReference) ? item : THROW_CCE());
  };
  protoOf(Entity$get$1).e32 = function (item) {
    ensureNotNull(this.w31_1.m2z_1).d32(this.w31_1, this.x31_1, new CollectionItemEvent(item, null, -1, EventType_REMOVE_getInstance()));
  };
  protoOf(Entity$get$1).l31 = function (item) {
    return this.e32((item == null ? true : item instanceof EntityReference) ? item : THROW_CCE());
  };
  function Entity$get$2(this$0, $childId) {
    this.u30_1 = this$0;
    this.v30_1 = $childId;
    SafeEntityHashSet.call(this);
  }
  protoOf(Entity$get$2).f32 = function (item) {
    checkCanModify(this.u30_1);
    // Inline function 'kotlin.require' call
    if (!(ensureNotNull(item).yt() == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.entity.<no name provided>.checkAdd.<anonymous>' call
      var message = getCantAddMessage(this, item) + ': entity has parent ' + ensureNotNull(item.yt()).j2z_1.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(!this.v30_1.b32() || this.p())) {
      // Inline function 'jetbrains.ocelot.ot.model.entity.<no name provided>.checkAdd.<anonymous>' call
      var message_0 = getCantAddMessage(this, item) + ': adding second item to single child role ' + this.v30_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var addNewEntity = item.m2z_1 == null && (this.u30_1.m2z_1 == null || ensureNotNull(this.u30_1.m2z_1).g32(item));
    var moving = item.u2z_1 && equals(item.m2z_1, this.u30_1.m2z_1);
    // Inline function 'kotlin.require' call
    if (!(addNewEntity || moving)) {
      // Inline function 'jetbrains.ocelot.ot.model.entity.<no name provided>.checkAdd.<anonymous>' call
      var message_1 = getCantAddMessage(this, item) + ": entity's context=" + toString_0(item.m2z_1) + ', entity is moving=' + item.u2z_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }
  };
  protoOf(Entity$get$2).g29 = function (item) {
    return this.f32((item == null ? true : item instanceof Entity) ? item : THROW_CCE());
  };
  protoOf(Entity$get$2).h32 = function (item) {
    checkCanModify(this.u30_1);
    // Inline function 'kotlin.require' call
    if (!equals(ensureNotNull(item).yt(), this.u30_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.entity.<no name provided>.checkRemove.<anonymous>' call
      var message = getCantRemoveMessage(this, item) + ": entity's parent=" + item.yt() + ', try to remove from ' + this.u30_1.j2z_1.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.u30_1.m2z_1 == null || ensureNotNull(this.u30_1.m2z_1).i32(item))) {
      // Inline function 'jetbrains.ocelot.ot.model.entity.<no name provided>.checkRemove.<anonymous>' call
      var message_0 = getCantRemoveMessage(this, item) + ": entity's context=" + toString_0(item.m2z_1);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
  };
  protoOf(Entity$get$2).j29 = function (item) {
    return this.h32((item == null ? true : item instanceof Entity) ? item : THROW_CCE());
  };
  protoOf(Entity$get$2).j32 = function (item) {
    ensureNotNull(item).k2z_1.s2c(this.u30_1);
    item.l2z_1 = this.v30_1;
  };
  protoOf(Entity$get$2).h29 = function (item) {
    return this.j32((item == null ? true : item instanceof Entity) ? item : THROW_CCE());
  };
  protoOf(Entity$get$2).k32 = function (item) {
    item.k2z_1.v9();
    if (this.n() === 1) {
      incNonEmptyFeatures(this.u30_1);
    }
    if (contextEvent(this.u30_1, item)) {
      ensureNotNull(this.u30_1.m2z_1).n32(this.u30_1, this.v30_1, new CollectionItemEvent(null, item, -1, EventType_ADD_getInstance()));
    }
  };
  protoOf(Entity$get$2).o32 = function (item) {
    ensureNotNull(item).k2z_1.s2c(null);
    item.l2z_1 = null;
  };
  protoOf(Entity$get$2).k29 = function (item) {
    return this.o32((item == null ? true : item instanceof Entity) ? item : THROW_CCE());
  };
  protoOf(Entity$get$2).p32 = function (item) {
    item.k2z_1.v9();
    if (this.p()) {
      decNonEmptyFeatures(this.u30_1);
    }
    if (contextEvent(this.u30_1, item)) {
      ensureNotNull(this.u30_1.m2z_1).n32(this.u30_1, this.v30_1, new CollectionItemEvent(item, null, -1, EventType_REMOVE_getInstance()));
    }
  };
  protoOf(Entity$get$2).q32 = function () {
    setEventInProgress(this.u30_1, true);
  };
  protoOf(Entity$get$2).r32 = function () {
    setEventInProgress(this.u30_1, false);
  };
  function Entity$get$3(this$0) {
    this.a33_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(Entity$get$3).b33 = function (event) {
    if (contextEvent(this.a33_1, event.k27())) {
      ensureNotNull(this.a33_1.m2z_1).c33(event.k27());
    }
  };
  protoOf(Entity$get$3).c27 = function (event) {
    return this.b33(event);
  };
  protoOf(Entity$get$3).d33 = function (event) {
    if (contextEvent(this.a33_1, event.i27())) {
      ensureNotNull(this.a33_1.m2z_1).e33(event.i27());
    }
  };
  protoOf(Entity$get$3).j27 = function (event) {
    return this.d33(event);
  };
  function Entity(conceptId, id) {
    id = id === VOID ? EntityId_init_$Create$() : id;
    this.i2z_1 = conceptId;
    this.j2z_1 = id;
    this.k2z_1 = new DelayedValueProperty();
    this.l2z_1 = null;
    this.m2z_1 = null;
    this.n2z_1 = null;
    this.o2z_1 = new Listeners();
    this.p2z_1 = null;
    this.q2z_1 = new Listeners();
    this.r2z_1 = null;
    this.s2z_1 = null;
    this.t2z_1 = 0;
    this.u2z_1 = false;
  }
  protoOf(Entity).yt = function () {
    return this.k2z_1.qr();
  };
  protoOf(Entity).y2z = function () {
    return this.n2z_1 == null ? emptySet() : ensureNotNull(this.n2z_1).op();
  };
  protoOf(Entity).d30 = function () {
    return this.p2z_1 == null ? emptySet() : ensureNotNull(this.p2z_1).op();
  };
  protoOf(Entity).b30 = function () {
    return this.r2z_1 == null ? emptySet() : ensureNotNull(this.r2z_1).op();
  };
  protoOf(Entity).v2z = function () {
    return this.s2z_1 == null ? emptySet() : ensureNotNull(this.s2z_1).op();
  };
  protoOf(Entity).np = function () {
    return this.t2z_1 === 0;
  };
  protoOf(Entity).f33 = function () {
    return this.k2z_1;
  };
  protoOf(Entity).g33 = function (ctx) {
    if (!(this.m2z_1 == null)) {
      throw OtException_init_$Create$();
    }
    this.m2z_1 = ctx;
  };
  protoOf(Entity).h33 = function () {
    if (this.m2z_1 == null) {
      throw OtException_init_$Create$();
    }
    this.m2z_1 = null;
  };
  protoOf(Entity).i33 = function () {
    checkCanModify(this);
    var tmp0 = this.yt();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'jetbrains.ocelot.ot.model.entity.Entity.delete.<anonymous>' call
        var message = 'Delete root is inapplicable';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    ensureNotNull(this.yt()).w2z(ensureNotNull(this.l2z_1)).k2(this);
  };
  protoOf(Entity).j33 = function (newParent) {
    if (this.yt() == null)
      return false;
    if (equals(newParent, this.yt()))
      return false;
    var p = newParent;
    while (!(p == null)) {
      if (equals(p, this))
        return false;
      p = p.yt();
    }
    return Entities_getInstance().p30(this) === Entities_getInstance().p30(newParent);
  };
  protoOf(Entity).k33 = function (newParent) {
    checkCanModify(this);
    // Inline function 'kotlin.check' call
    if (!this.j33(newParent)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var role = ensureNotNull(this.l2z_1);
    var oldParent = this.yt();
    this.u2z_1 = true;
    try {
      ensureNotNull(oldParent).w2z(role).k2(this);
      newParent.w2z(role).e(this);
    }finally {
      this.u2z_1 = false;
    }
    if (!(this.m2z_1 == null)) {
      ensureNotNull(this.m2z_1).d31(true);
      try {
        ensureNotNull(this.m2z_1).l33(this, oldParent);
      }finally {
        ensureNotNull(this.m2z_1).d31(false);
      }
    }
  };
  protoOf(Entity).z2z = function (propId) {
    return this.n2z_1 == null ? null : ensureNotNull(this.n2z_1).y2(propId);
  };
  protoOf(Entity).a30 = function (propId, newValue) {
    checkCanModify(this);
    var oldValue = this.z2z(propId);
    if (oldValue == newValue)
      return Unit_instance;
    if (newValue == null) {
      ensureNotNull(this.n2z_1).s2(propId);
      if (ensureNotNull(this.n2z_1).np()) {
        this.n2z_1 = null;
        decNonEmptyFeatures(this);
      }
    } else {
      if (this.n2z_1 == null) {
        this.n2z_1 = new ListMap();
        incNonEmptyFeatures(this);
      }
      ensureNotNull(this.n2z_1).r2(propId, newValue);
    }
    setEventInProgress(this, true);
    try {
      var event = new PropertyChangeEvent(oldValue, newValue);
      var tmp0_safe_receiver = this.m2z_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.m33(this, propId, event);
      }
      this.o2z_1.a28(Entity$set$lambda(propId, event));
    }finally {
      setEventInProgress(this, false);
    }
  };
  protoOf(Entity).e30 = function (modelId) {
    return this.p2z_1 == null ? null : ensureNotNull(this.p2z_1).y2(modelId);
  };
  protoOf(Entity).f30 = function (modelId, model) {
    checkCanModify(this);
    var oldValue = this.e30(modelId);
    if (equals(oldValue, model))
      return Unit_instance;
    if (oldValue == null)
      null;
    else {
      oldValue.n33(new NullEventStateHolder());
    }
    if (model == null) {
      ensureNotNull(this.p2z_1).s2(modelId);
      if (ensureNotNull(this.p2z_1).np()) {
        this.p2z_1 = null;
        decNonEmptyFeatures(this);
      }
    } else {
      if (this.p2z_1 == null) {
        this.p2z_1 = new ListMap();
        incNonEmptyFeatures(this);
      }
      ensureNotNull(this.p2z_1).r2(modelId, model);
    }
    setEventInProgress(this, true);
    try {
      var event = new PropertyChangeEvent(oldValue, model);
      var tmp1_safe_receiver = this.m2z_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.o33(this, modelId, event);
      }
      this.q2z_1.a28(Entity$set$lambda_0(modelId, event));
    }finally {
      setEventInProgress(this, false);
    }
  };
  protoOf(Entity).s31 = function (modelId, handler) {
    return this.q2z_1.z27(new ModelListenerData(modelId, handler));
  };
  protoOf(Entity).p33 = function (blobId) {
    return new Entity$modelProperty$1(blobId, this);
  };
  protoOf(Entity).c30 = function (refId) {
    var entityReferences = this.r2z_1;
    if (entityReferences == null) {
      entityReferences = new ListMap();
      this.r2z_1 = entityReferences;
    }
    var result = entityReferences.y2(refId);
    if (result == null) {
      result = new Entity$get$1(this, refId);
      entityReferences.r2(refId, result);
    }
    return result;
  };
  protoOf(Entity).w2z = function (childId) {
    var children = this.s2z_1;
    if (children == null) {
      children = new ListMap();
      this.s2z_1 = children;
    }
    var result = children.y2(childId);
    if (result == null) {
      result = new Entity$get$2(this, childId);
      var tmp = result;
      tmp.n27(new Entity$get$3(this));
      children.r2(childId, result);
    }
    return result;
  };
  protoOf(Entity).toString = function () {
    return this.j2z_1.toString() + '(' + this.i2z_1.toString() + ')';
  };
  function EntityChildId_init_$Init$(flags, $this) {
    RoleId_init_$Init$(flags, $this);
    EntityChildId.call($this);
    return $this;
  }
  function EntityChildId_init_$Create$(flags) {
    return EntityChildId_init_$Init$(flags, objectCreate(protoOf(EntityChildId)));
  }
  function EntityChildId_init_$Init$_0(id, flags, $this) {
    RoleId_init_$Init$_0(id, flags, $this);
    EntityChildId.call($this);
    return $this;
  }
  function EntityChildId_init_$Create$_0(id, flags) {
    return EntityChildId_init_$Init$_0(id, flags, objectCreate(protoOf(EntityChildId)));
  }
  function EntityChildId() {
  }
  function EntityConceptId_init_$Init$($this) {
    MetaId_init_$Init$(Companion_getInstance_39().t33_1, $this);
    EntityConceptId.call($this);
    return $this;
  }
  function EntityConceptId_init_$Create$() {
    return EntityConceptId_init_$Init$(objectCreate(protoOf(EntityConceptId)));
  }
  function EntityConceptId_init_$Init$_0(id, $this) {
    MetaId_init_$Init$_0(id, Companion_getInstance_39().t33_1, $this);
    EntityConceptId.call($this);
    return $this;
  }
  function EntityConceptId_init_$Create$_0(id) {
    return EntityConceptId_init_$Init$_0(id, objectCreate(protoOf(EntityConceptId)));
  }
  function Companion_39() {
    Companion_instance_39 = this;
    this.t33_1 = emptySet();
  }
  var Companion_instance_39;
  function Companion_getInstance_39() {
    if (Companion_instance_39 == null)
      new Companion_39();
    return Companion_instance_39;
  }
  function EntityConceptId() {
    Companion_getInstance_39();
  }
  var EntityConceptIdFlag_TRANSIENT_instance;
  var EntityConceptIdFlag_NOTIFY_instance;
  function values_0() {
    return [EntityConceptIdFlag_TRANSIENT_getInstance(), EntityConceptIdFlag_NOTIFY_getInstance()];
  }
  var EntityConceptIdFlag_entriesInitialized;
  function EntityConceptIdFlag_initEntries() {
    if (EntityConceptIdFlag_entriesInitialized)
      return Unit_instance;
    EntityConceptIdFlag_entriesInitialized = true;
    EntityConceptIdFlag_TRANSIENT_instance = new EntityConceptIdFlag('TRANSIENT', 0);
    EntityConceptIdFlag_NOTIFY_instance = new EntityConceptIdFlag('NOTIFY', 1);
  }
  function EntityConceptIdFlag(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function EntityConceptIdFlag_TRANSIENT_getInstance() {
    EntityConceptIdFlag_initEntries();
    return EntityConceptIdFlag_TRANSIENT_instance;
  }
  function EntityConceptIdFlag_NOTIFY_getInstance() {
    EntityConceptIdFlag_initEntries();
    return EntityConceptIdFlag_NOTIFY_instance;
  }
  function EntityContext$SafeEntityHashSet$1(this$0) {
    this.u33_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(EntityContext$SafeEntityHashSet$1).b33 = function (event) {
    return this.u33_1.q32();
  };
  protoOf(EntityContext$SafeEntityHashSet$1).c27 = function (event) {
    return this.b33(event);
  };
  protoOf(EntityContext$SafeEntityHashSet$1).d33 = function (event) {
    return this.u33_1.q32();
  };
  protoOf(EntityContext$SafeEntityHashSet$1).j27 = function (event) {
    return this.d33(event);
  };
  function watchModelBlob($this, entity, modelBlobId) {
    var tmp0_elvis_lhs = entity.e30(modelBlobId);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw OtException_init_$Create$();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var model = tmp;
    model.n33($this.b31_1);
    var nodeFeatureChangedRegistration = model.v33(new EntityContext$watchModelBlob$nodeFeatureChangedRegistration$1($this, entity, modelBlobId));
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.a31_1;
    var value = this_0.y2(entity);
    var tmp_0;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.ot.model.entity.EntityContext.watchModelBlob.<anonymous>' call
      var answer = new ListMap();
      this_0.r2(entity, answer);
      tmp_0 = answer;
    } else {
      tmp_0 = value;
    }
    var registrations = tmp_0;
    registrations.r2(modelBlobId, nodeFeatureChangedRegistration);
    $this.z30_1.a28(EntityContext$watchModelBlob$lambda(model));
  }
  function unwatchModelBlob($this, entity, modelBlobId, model) {
    var registrations = $this.a31_1.y2(entity);
    ensureNotNull(ensureNotNull(registrations).s2(modelBlobId)).vr();
    if (registrations.np()) {
      $this.a31_1.s2(entity);
    }
    $this.z30_1.a28(EntityContext$unwatchModelBlob$lambda(model));
  }
  function fire_0($this, event) {
    var tmp = $this.b31_1;
    tmp.x33(EntityContext$fire$lambda($this, event));
  }
  function SafeEntityHashSet() {
    EntityHashSet.call(this);
    this.n27(new EntityContext$SafeEntityHashSet$1(this));
  }
  protoOf(SafeEntityHashSet).u32 = function (item, success) {
    if (!success)
      return Unit_instance;
    try {
      this.k32(ensureNotNull(item));
    }finally {
      this.r32();
    }
  };
  protoOf(SafeEntityHashSet).i29 = function (item, success) {
    return this.u32((item == null ? true : item instanceof Entity) ? item : THROW_CCE(), success);
  };
  protoOf(SafeEntityHashSet).v32 = function (item, success) {
    if (!success)
      return Unit_instance;
    try {
      this.p32(ensureNotNull(item));
    }finally {
      this.r32();
    }
  };
  protoOf(SafeEntityHashSet).l29 = function (item, success) {
    return this.v32((item == null ? true : item instanceof Entity) ? item : THROW_CCE(), success);
  };
  function EntityContext$rootEntities$1(this$0) {
    this.a34_1 = this$0;
    SafeEntityHashSet.call(this);
  }
  protoOf(EntityContext$rootEntities$1).f32 = function (item) {
    this.a34_1.e31();
    // Inline function 'kotlin.check' call
    if (!(ensureNotNull(item).yt() == null && this.a34_1.g32(item))) {
      // Inline function 'jetbrains.ocelot.ot.model.entity.<no name provided>.checkAdd.<anonymous>' call
      var message = "Can't add root " + toString_0(item) + ', parent=' + toString_0(item.yt()) + ', context=' + toString_0(item.m2z_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(EntityContext$rootEntities$1).g29 = function (item) {
    return this.f32((item == null ? true : item instanceof Entity) ? item : THROW_CCE());
  };
  protoOf(EntityContext$rootEntities$1).k32 = function (item) {
    var event = new RootAddedEvent(item);
    fire_0(this.a34_1, event);
  };
  protoOf(EntityContext$rootEntities$1).h32 = function (item) {
    this.a34_1.e31();
    // Inline function 'kotlin.check' call
    if (!this.a34_1.i32(ensureNotNull(item))) {
      // Inline function 'jetbrains.ocelot.ot.model.entity.<no name provided>.checkRemove.<anonymous>' call
      var message = "Can't remove root " + item + ', context=' + toString_0(item.m2z_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(EntityContext$rootEntities$1).j29 = function (item) {
    return this.h32((item == null ? true : item instanceof Entity) ? item : THROW_CCE());
  };
  protoOf(EntityContext$rootEntities$1).p32 = function (item) {
    fire_0(this.a34_1, new RootRemovedEvent(item));
  };
  protoOf(EntityContext$rootEntities$1).q32 = function () {
    this.a34_1.d31(true);
  };
  protoOf(EntityContext$rootEntities$1).r32 = function () {
    this.a34_1.d31(false);
  };
  function EntityContext$1(this$0) {
    this.b34_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(EntityContext$1).b33 = function (event) {
    return this.b34_1.c33(event.k27());
  };
  protoOf(EntityContext$1).c27 = function (event) {
    return this.b33(event);
  };
  protoOf(EntityContext$1).d33 = function (event) {
    return this.b34_1.e33(event.i27());
  };
  protoOf(EntityContext$1).j27 = function (event) {
    return this.d33(event);
  };
  function EntityContext$attach$lambda($entity) {
    return function (listener) {
      listener.c34($entity);
      return Unit_instance;
    };
  }
  function EntityContext$detach$lambda($entity) {
    return function (listener) {
      listener.d34($entity);
      return Unit_instance;
    };
  }
  function EntityContext$watchModelBlob$nodeFeatureChangedRegistration$1(this$0, $entity, $modelBlobId) {
    this.e34_1 = this$0;
    this.f34_1 = $entity;
    this.g34_1 = $modelBlobId;
    ModelAdapter.call(this);
  }
  protoOf(EntityContext$watchModelBlob$nodeFeatureChangedRegistration$1).h34 = function (event) {
    fire_0(this.e34_1, new EntityNodeEvent(this.f34_1, this.g34_1, event));
  };
  function EntityContext$watchModelBlob$lambda($model) {
    return function (listener) {
      listener.s34($model);
      return Unit_instance;
    };
  }
  function EntityContext$unwatchModelBlob$lambda($model) {
    return function (listener) {
      listener.t34($model);
      return Unit_instance;
    };
  }
  function EntityEvent$dispatch$ref($boundThis) {
    var l = function (p0) {
      $boundThis.v34(p0);
      return Unit_instance;
    };
    l.callableName = 'dispatch';
    return l;
  }
  function EntityContext$fire$lambda(this$0, $event) {
    return function () {
      this$0.x30_1.a28(EntityEvent$dispatch$ref($event));
      return Unit_instance;
    };
  }
  function EntityContext() {
    this.w30_1 = new EntityHashSet();
    this.x30_1 = new Listeners();
    this.y30_1 = new Listeners();
    this.z30_1 = new Listeners();
    this.a31_1 = HashMap_init_$Create$();
    this.b31_1 = new EventStateHolder();
    var tmp = this;
    tmp.c31_1 = new EntityContext$rootEntities$1(this);
    this.c31_1.n27(new EntityContext$1(this));
  }
  protoOf(EntityContext).w34 = function () {
    return this.w30_1;
  };
  protoOf(EntityContext).d31 = function (inProgress) {
    this.b31_1.x34(inProgress);
  };
  protoOf(EntityContext).n33 = function (eventStateHolder) {
    this.b31_1.y34(eventStateHolder);
    this.b31_1 = eventStateHolder;
    var _iterator__ex2g4s = this.a31_1.u2().k();
    while (_iterator__ex2g4s.l()) {
      var modelHolder = _iterator__ex2g4s.m();
      var _iterator__ex2g4s_0 = ensureNotNull(this.a31_1.y2(modelHolder)).op().k();
      while (_iterator__ex2g4s_0.l()) {
        var id = _iterator__ex2g4s_0.m();
        ensureNotNull(modelHolder.e30(id)).n33(eventStateHolder);
      }
    }
  };
  protoOf(EntityContext).z34 = function (rootId) {
    return this.c31_1.w32(rootId);
  };
  protoOf(EntityContext).g32 = function (entity) {
    return !this.w30_1.x32(entity) && entity.m2z_1 == null;
  };
  protoOf(EntityContext).c33 = function (entity) {
    if (!this.g32(entity)) {
      throw OtException_init_$Create$();
    }
    entity.g33(this);
    var _iterator__ex2g4s = entity.v2z().k();
    while (_iterator__ex2g4s.l()) {
      var childId = _iterator__ex2g4s.m();
      var _iterator__ex2g4s_0 = entity.w2z(childId).k();
      while (_iterator__ex2g4s_0.l()) {
        var child = _iterator__ex2g4s_0.m();
        this.c33(child);
      }
    }
    this.w30_1.s29(entity);
    var _iterator__ex2g4s_1 = entity.d30().k();
    while (_iterator__ex2g4s_1.l()) {
      var modelBlobId = _iterator__ex2g4s_1.m();
      watchModelBlob(this, entity, modelBlobId);
    }
    this.y30_1.a28(EntityContext$attach$lambda(entity));
  };
  protoOf(EntityContext).m33 = function (entity, propertyId, event) {
    fire_0(this, new EntityPropertyChangedEvent(entity, propertyId, event.o2e_1, event.p2e_1));
  };
  protoOf(EntityContext).d32 = function (entity, referenceId, itemEvent) {
    var tmp;
    switch (itemEvent.h27_1.a3_1) {
      case 0:
        tmp = new EntityReferenceAddedEvent(entity, referenceId, itemEvent.k27());
        break;
      case 2:
        tmp = new EntityReferenceRemovedEvent(entity, referenceId, itemEvent.i27());
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('Unsupported event type');
    }
    var event = tmp;
    fire_0(this, event);
  };
  protoOf(EntityContext).l33 = function (entity, oldParent) {
    var event = new EntityMovedEvent(entity, oldParent);
    fire_0(this, event);
  };
  protoOf(EntityContext).n32 = function (entity, childId, itemEvent) {
    var tmp;
    switch (itemEvent.h27_1.a3_1) {
      case 0:
        tmp = new EntityChildAddedEvent(entity, childId, itemEvent.k27());
        break;
      case 2:
        tmp = new EntityChildRemovedEvent(entity, childId, itemEvent.i27());
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('Unsupported event type');
    }
    var event = tmp;
    fire_0(this, event);
  };
  protoOf(EntityContext).o33 = function (entity, blobId, event) {
    var oldValue = event.o2e_1;
    if (!(oldValue == null)) {
      unwatchModelBlob(this, entity, blobId, oldValue);
    }
    var newValue = event.p2e_1;
    if (!(newValue == null)) {
      watchModelBlob(this, entity, blobId);
    }
    fire_0(this, new EntityModelBlobChangedEvent(entity, blobId, oldValue, newValue));
  };
  protoOf(EntityContext).i32 = function (entity) {
    return this.w30_1.x32(entity) && equals(entity.m2z_1, this);
  };
  protoOf(EntityContext).e33 = function (entity) {
    if (!this.i32(entity)) {
      throw OtException_init_$Create$();
    }
    this.w30_1.v29(entity);
    var _iterator__ex2g4s = entity.d30().k();
    while (_iterator__ex2g4s.l()) {
      var modelBlobId = _iterator__ex2g4s.m();
      unwatchModelBlob(this, entity, modelBlobId, ensureNotNull(entity.e30(modelBlobId)));
    }
    var _iterator__ex2g4s_0 = entity.v2z().k();
    while (_iterator__ex2g4s_0.l()) {
      var childId = _iterator__ex2g4s_0.m();
      var _iterator__ex2g4s_1 = entity.w2z(childId).k();
      while (_iterator__ex2g4s_1.l()) {
        var child = _iterator__ex2g4s_1.m();
        this.e33(child);
      }
    }
    var registrations = this.a31_1.s2(entity);
    if (!(registrations == null)) {
      var _iterator__ex2g4s_2 = registrations.pp().k();
      while (_iterator__ex2g4s_2.l()) {
        var r = _iterator__ex2g4s_2.m();
        r.vr();
      }
    }
    entity.h33();
    this.y30_1.a28(EntityContext$detach$lambda(entity));
  };
  protoOf(EntityContext).e31 = function () {
    return this.b31_1.a35();
  };
  protoOf(EntityContext).b35 = function (listener) {
    return this.x30_1.z27(listener);
  };
  protoOf(EntityContext).c35 = function (listener) {
    return this.y30_1.z27(listener);
  };
  protoOf(EntityContext).d35 = function (listener) {
    return this.z30_1.z27(listener);
  };
  protoOf(EntityContext).e35 = function (id) {
    return !(this.w30_1.w32(id) == null);
  };
  function ensureEntitiesInitialized($this) {
    if ($this.m32_1 == null) {
      $this.m32_1 = HashMap_init_$Create$_0(1);
    }
  }
  function EntityHashSet() {
    AbstractObservableSet.call(this);
    this.m32_1 = null;
  }
  protoOf(EntityHashSet).w32 = function (id) {
    var map = this.m32_1;
    return map == null ? null : map.y2(id);
  };
  protoOf(EntityHashSet).n = function () {
    return this.m32_1 == null ? 0 : ensureNotNull(this.m32_1).n();
  };
  protoOf(EntityHashSet).x32 = function (element) {
    if (this.m32_1 == null)
      return false;
    return ensureNotNull(this.m32_1).u2().s(element.j2z_1);
  };
  protoOf(EntityHashSet).s = function (element) {
    if (!(element instanceof Entity))
      return false;
    return this.x32(element instanceof Entity ? element : THROW_CCE());
  };
  protoOf(EntityHashSet).y32 = function (item) {
    ensureEntitiesInitialized(this);
    var tmp0 = ensureNotNull(this.m32_1);
    // Inline function 'kotlin.collections.set' call
    var key = item.j2z_1;
    tmp0.r2(key, item);
    return true;
  };
  protoOf(EntityHashSet).u29 = function (item) {
    return this.y32(item instanceof Entity ? item : THROW_CCE());
  };
  protoOf(EntityHashSet).z32 = function (item) {
    return !(ensureNotNull(this.m32_1).s2(item.j2z_1) == null);
  };
  protoOf(EntityHashSet).x29 = function (item) {
    return this.z32(item instanceof Entity ? item : THROW_CCE());
  };
  protoOf(EntityHashSet).r29 = function () {
    return ensureNotNull(this.m32_1).v2().k();
  };
  function EntityId_init_$Init$($this) {
    BaseId.call($this);
    EntityId.call($this);
    return $this;
  }
  function EntityId_init_$Create$() {
    return EntityId_init_$Init$(objectCreate(protoOf(EntityId)));
  }
  function EntityId_init_$Init$_0(id, $this) {
    BaseId.call($this, id);
    EntityId.call($this);
    return $this;
  }
  function EntityId_init_$Create$_0(id) {
    return EntityId_init_$Init$_0(id, objectCreate(protoOf(EntityId)));
  }
  function EntityId() {
  }
  function EntityModelBlobId_init_$Init$($this) {
    BaseId.call($this);
    EntityModelBlobId.call($this);
    return $this;
  }
  function EntityModelBlobId_init_$Create$() {
    return EntityModelBlobId_init_$Init$(objectCreate(protoOf(EntityModelBlobId)));
  }
  function EntityModelBlobId_init_$Init$_0(id, $this) {
    BaseId.call($this, id);
    EntityModelBlobId.call($this);
    return $this;
  }
  function EntityModelBlobId_init_$Create$_0(id) {
    return EntityModelBlobId_init_$Init$_0(id, objectCreate(protoOf(EntityModelBlobId)));
  }
  function EntityModelBlobId() {
  }
  function EntityPropertyId_init_$Init$($this) {
    BaseId.call($this);
    EntityPropertyId.call($this);
    return $this;
  }
  function EntityPropertyId_init_$Create$() {
    return EntityPropertyId_init_$Init$(objectCreate(protoOf(EntityPropertyId)));
  }
  function EntityPropertyId_init_$Init$_0(id, $this) {
    BaseId.call($this, id);
    EntityPropertyId.call($this);
    return $this;
  }
  function EntityPropertyId_init_$Create$_0(id) {
    return EntityPropertyId_init_$Init$_0(id, objectCreate(protoOf(EntityPropertyId)));
  }
  function EntityPropertyId() {
  }
  function Companion_40() {
  }
  var Companion_instance_40;
  function Companion_getInstance_40() {
    return Companion_instance_40;
  }
  function EntityReference(rootId, entityId) {
    entityId = entityId === VOID ? rootId : entityId;
    this.f35_1 = rootId;
    this.g35_1 = entityId;
  }
  protoOf(EntityReference).h35 = function () {
    return this.f35_1.equals(this.g35_1);
  };
  protoOf(EntityReference).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    var reference = other instanceof EntityReference ? other : THROW_CCE();
    if (!this.g35_1.equals(reference.g35_1))
      return false;
    return this.f35_1.equals(reference.f35_1);
  };
  protoOf(EntityReference).hashCode = function () {
    var result = this.f35_1.hashCode();
    result = imul(31, result) + this.g35_1.hashCode() | 0;
    return result;
  };
  protoOf(EntityReference).toString = function () {
    return '(' + this.f35_1.toString() + ', ' + this.g35_1.toString() + ')';
  };
  function EntityReferenceId_init_$Init$(id, flags, $this) {
    RoleId_init_$Init$_0(id, flags, $this);
    EntityReferenceId.call($this);
    return $this;
  }
  function EntityReferenceId_init_$Create$(id, flags) {
    return EntityReferenceId_init_$Init$(id, flags, objectCreate(protoOf(EntityReferenceId)));
  }
  function EntityReferenceId() {
  }
  function EntitySet() {
  }
  var ReferenceStatus_NOT_LOADED_instance;
  var ReferenceStatus_LOADED_instance;
  var ReferenceStatus_ERROR_instance;
  var ReferenceStatus_entriesInitialized;
  function ReferenceStatus_initEntries() {
    if (ReferenceStatus_entriesInitialized)
      return Unit_instance;
    ReferenceStatus_entriesInitialized = true;
    ReferenceStatus_NOT_LOADED_instance = new ReferenceStatus('NOT_LOADED', 0);
    ReferenceStatus_LOADED_instance = new ReferenceStatus('LOADED', 1);
    ReferenceStatus_ERROR_instance = new ReferenceStatus('ERROR', 2);
  }
  function ReferenceStatus(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ReferenceStatus_NOT_LOADED_getInstance() {
    ReferenceStatus_initEntries();
    return ReferenceStatus_NOT_LOADED_instance;
  }
  function ReferenceStatus_LOADED_getInstance() {
    ReferenceStatus_initEntries();
    return ReferenceStatus_LOADED_instance;
  }
  function ReferenceStatus_ERROR_getInstance() {
    ReferenceStatus_initEntries();
    return ReferenceStatus_ERROR_instance;
  }
  function EntityChildAddedEvent(parent, childRole, child) {
    EntityChildEvent.call(this, parent, childRole, child);
  }
  protoOf(EntityChildAddedEvent).v34 = function (listener) {
    listener.l35(this);
  };
  protoOf(EntityChildAddedEvent).toString = function () {
    return 'child added to ' + protoOf(EntityChildEvent).toString.call(this);
  };
  function EntityChildEvent(parent, childRole, child) {
    EntityEvent.call(this, parent);
    this.n35_1 = childRole;
    this.o35_1 = child;
  }
  protoOf(EntityChildEvent).toString = function () {
    return 'parent=' + this.u34_1.toString() + ', role=' + this.n35_1.toString() + ', child=' + this.o35_1.toString();
  };
  function EntityChildRemovedEvent(parent, childRole, child) {
    EntityChildEvent.call(this, parent, childRole, child);
  }
  protoOf(EntityChildRemovedEvent).v34 = function (listener) {
    listener.s35(this);
  };
  protoOf(EntityChildRemovedEvent).toString = function () {
    return 'child removed from ' + protoOf(EntityChildEvent).toString.call(this);
  };
  function EntityContextListener() {
  }
  function EntityEvent(entity) {
    this.u34_1 = entity;
  }
  function EntityModelBlobChangedEvent(entity, modelBlobId, oldModel, newModel) {
    EntityEvent.call(this, entity);
    this.d36_1 = modelBlobId;
    this.e36_1 = oldModel;
    this.f36_1 = newModel;
  }
  protoOf(EntityModelBlobChangedEvent).v34 = function (listener) {
    listener.a36(this);
  };
  protoOf(EntityModelBlobChangedEvent).toString = function () {
    return 'model blob changed: entity=' + this.u34_1.toString() + ', blobId=' + this.d36_1.toString() + ', ' + toString_0(this.e36_1) + ' -> ' + toString_0(this.f36_1);
  };
  function EntityMovedEvent(entity, oldParent) {
    EntityEvent.call(this, entity);
    this.h36_1 = oldParent;
  }
  protoOf(EntityMovedEvent).v34 = function (listener) {
    listener.w35(this);
  };
  protoOf(EntityMovedEvent).toString = function () {
    return 'moved entity=' + this.u34_1 + ' from ' + this.h36_1 + ' to ' + toString_0(this.u34_1.yt());
  };
  function EntityNodeEvent(entity, modelBlobId, nodeEvent) {
    EntityEvent.call(this, entity);
    this.j36_1 = modelBlobId;
    this.k36_1 = nodeEvent;
  }
  protoOf(EntityNodeEvent).v34 = function (listener) {
    listener.b36(this);
  };
  protoOf(EntityNodeEvent).toString = function () {
    return 'node changed at entity=' + this.u34_1.toString() + ', blobId=' + this.j36_1.toString() + ' : ' + this.k36_1.toString();
  };
  function EntityPropertyChangedEvent(entity, propertyId, oldValue, newValue) {
    EntityEvent.call(this, entity);
    this.m36_1 = propertyId;
    this.n36_1 = oldValue;
    this.o36_1 = newValue;
  }
  protoOf(EntityPropertyChangedEvent).v34 = function (listener) {
    listener.x35(this);
  };
  protoOf(EntityPropertyChangedEvent).toString = function () {
    return 'property changed: entity=' + this.u34_1.toString() + ', propId=' + this.m36_1.toString() + ', ' + this.n36_1 + ' -> ' + this.o36_1;
  };
  function EntityReferenceAddedEvent(entity, reference, value) {
    EntityReferenceEvent.call(this, entity, reference, value);
  }
  protoOf(EntityReferenceAddedEvent).v34 = function (listener) {
    listener.y35(this);
  };
  protoOf(EntityReferenceAddedEvent).toString = function () {
    return 'reference added to ' + protoOf(EntityReferenceEvent).toString.call(this);
  };
  function EntityReferenceEvent(entity, referenceId, value) {
    EntityEvent.call(this, entity);
    this.t36_1 = referenceId;
    this.u36_1 = value;
  }
  protoOf(EntityReferenceEvent).toString = function () {
    return 'entity=' + this.u34_1.toString() + ', refId=' + this.t36_1.toString() + ', ref=' + this.u36_1.toString();
  };
  function EntityReferenceRemovedEvent(entity, reference, value) {
    EntityReferenceEvent.call(this, entity, reference, value);
  }
  protoOf(EntityReferenceRemovedEvent).v34 = function (listener) {
    listener.z35(this);
  };
  protoOf(EntityReferenceRemovedEvent).toString = function () {
    return 'reference removed from ' + protoOf(EntityReferenceEvent).toString.call(this);
  };
  function RootAddedEvent(entity) {
    EntityEvent.call(this, entity);
  }
  protoOf(RootAddedEvent).v34 = function (listener) {
    listener.t35(this);
  };
  protoOf(RootAddedEvent).toString = function () {
    return 'root added : ' + this.u34_1.toString();
  };
  function RootRemovedEvent(entity) {
    EntityEvent.call(this, entity);
  }
  protoOf(RootRemovedEvent).v34 = function (listener) {
    listener.v35(this);
  };
  protoOf(RootRemovedEvent).toString = function () {
    return 'root removed : ' + this.u34_1.toString();
  };
  function EventStateHolder() {
    this.w33_1 = false;
  }
  protoOf(EventStateHolder).x34 = function (inProgress) {
    if (this.a37() === inProgress) {
      throw OtException_init_$Create$_0("The 'event-in-progress' flag is already " + this.a37());
    }
    this.w33_1 = inProgress;
  };
  protoOf(EventStateHolder).a37 = function () {
    return this.w33_1;
  };
  protoOf(EventStateHolder).a35 = function () {
    if (this.a37()) {
      throw OtException_init_$Create$_0('Changing model inside event');
    }
  };
  protoOf(EventStateHolder).y34 = function (substitute) {
    if (this.a37()) {
      throw OtException_init_$Create$_0(plus_10(getKClassFromExpression(this).lb(), ' cannot be reset while event is in progress'));
    }
  };
  protoOf(EventStateHolder).b37 = function (f) {
    this.x34(true);
    try {
      f();
    }finally {
      this.x34(false);
    }
  };
  protoOf(EventStateHolder).x33 = function (f) {
    if (!this.a37()) {
      throw OtException_init_$Create$_0('Fire when event is not in progress');
    }
    f();
  };
  function NullEventStateHolder() {
    EventStateHolder.call(this);
  }
  protoOf(NullEventStateHolder).x34 = function (inProgress) {
  };
  protoOf(NullEventStateHolder).a37 = function () {
    return false;
  };
  protoOf(NullEventStateHolder).a35 = function () {
  };
  protoOf(NullEventStateHolder).y34 = function (substitute) {
  };
  protoOf(NullEventStateHolder).b37 = function (f) {
    return f();
  };
  protoOf(NullEventStateHolder).x33 = function (f) {
    return f();
  };
  function OtException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    OtException.call($this);
    return $this;
  }
  function OtException_init_$Create$() {
    var tmp = OtException_init_$Init$(objectCreate(protoOf(OtException)));
    captureStack(tmp, OtException_init_$Create$);
    return tmp;
  }
  function OtException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    OtException.call($this);
    return $this;
  }
  function OtException_init_$Create$_0(message) {
    var tmp = OtException_init_$Init$_0(message, objectCreate(protoOf(OtException)));
    captureStack(tmp, OtException_init_$Create$_0);
    return tmp;
  }
  function OtException_init_$Init$_1(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    OtException.call($this);
    return $this;
  }
  function OtException_init_$Create$_1(message, cause) {
    var tmp = OtException_init_$Init$_1(message, cause, objectCreate(protoOf(OtException)));
    captureStack(tmp, OtException_init_$Create$_1);
    return tmp;
  }
  function OtException() {
    captureStack(this, OtException);
  }
  function readEntityReferenceIdList($this, arrayReader) {
    return arrayReader.r2v(Json2EntityConverter$readEntityReferenceIdList$lambda);
  }
  function readChildArray($this, arrayReader, entity) {
    return arrayReader.r2v(Json2EntityConverter$readChildArray$lambda($this, entity));
  }
  function Companion_41() {
  }
  var Companion_instance_41;
  function Companion_getInstance_41() {
    return Companion_instance_41;
  }
  function Json2EntityConverter$entityFromJson$lambda(this$0) {
    return function ($this$readArray) {
      var serializedEntityId = $this$readArray.s2v();
      // Inline function 'kotlin.checkNotNull' call
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (serializedEntityId == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      var serializedConceptId = $this$readArray.s2v();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_0: {
        // Inline function 'kotlin.checkNotNull' call
        if (serializedConceptId == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message_0 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_0));
        } else {
          break $l$block_0;
        }
      }
      var conceptIdPersister = this$0.d37_1.m37(EntityIdModelKinds_getInstance().g37_1);
      var conceptId = conceptIdPersister.q2q(serializedConceptId);
      var entityIdPersister = this$0.d37_1.m37(EntityIdModelKinds_getInstance().f37_1);
      var entityId = entityIdPersister.q2q(serializedEntityId);
      var entity = new Entity(conceptId, entityId);
      var propertiesArrayReader = $this$readArray.t2v();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_1: {
        // Inline function 'kotlin.checkNotNull' call
        if (propertiesArrayReader == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message_1 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_1));
        } else {
          break $l$block_1;
        }
      }
      this$0.n37(propertiesArrayReader, entity);
      var referencesArrayReader = $this$readArray.t2v();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_2: {
        // Inline function 'kotlin.checkNotNull' call
        if (referencesArrayReader == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message_2 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2));
        } else {
          break $l$block_2;
        }
      }
      this$0.o37(referencesArrayReader, entity);
      var modelObjectReader = $this$readArray.u2v();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_3: {
        // Inline function 'kotlin.checkNotNull' call
        if (modelObjectReader == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message_3 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_3));
        } else {
          break $l$block_3;
        }
      }
      this$0.p37(modelObjectReader, entity);
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readArray.t2v();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var childArrayReader = tmp;
        readChildArray(this$0, childArrayReader, entity);
      }
      return entity;
    };
  }
  function Json2EntityConverter$jsonToProperties$lambda(this$0, $entity) {
    return function ($this$readArray) {
      var propertyIdPersister = this$0.d37_1.m37(EntityIdModelKinds_getInstance().h37_1);
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readArray.s2v();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var serializedId = tmp;
        var value = $this$readArray.s2v();
        // Inline function 'kotlin.checkNotNull' call
        $l$block: {
          // Inline function 'kotlin.checkNotNull' call
          if (value == null) {
            // Inline function 'kotlin.checkNotNull.<anonymous>' call
            var message = 'Required value was null.';
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          } else {
            break $l$block;
          }
        }
        var propertyId = propertyIdPersister.q2q(serializedId);
        $entity.a30(propertyId, value);
      }
      return Unit_instance;
    };
  }
  function Json2EntityConverter$jsonToReferences$lambda(this$0, $entity) {
    return function ($this$readArray) {
      var referenceIdPersister = this$0.d37_1.m37(EntityIdModelKinds_getInstance().i37_1);
      var entityReferencePersister = this$0.d37_1.m37(EntityIdModelKinds_getInstance().l37_1);
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readArray.s2v();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var serializedId = tmp;
        var entityReferenceId = referenceIdPersister.q2q(serializedId);
        var refs = $entity.c30(entityReferenceId);
        var idListArrayReader = $this$readArray.t2v();
        // Inline function 'kotlin.checkNotNull' call
        $l$block: {
          // Inline function 'kotlin.checkNotNull' call
          if (idListArrayReader == null) {
            // Inline function 'kotlin.checkNotNull.<anonymous>' call
            var message = 'Required value was null.';
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          } else {
            break $l$block;
          }
        }
        var valueList = readEntityReferenceIdList(this$0, idListArrayReader);
        var _iterator__ex2g4s = valueList.k();
        while (_iterator__ex2g4s.l()) {
          var value = _iterator__ex2g4s.m();
          refs.e(entityReferencePersister.q2q(value));
        }
      }
      return Unit_instance;
    };
  }
  function Json2EntityConverter$readEntityReferenceIdList$lambda($this$readArray) {
    var valueList = ArrayList_init_$Create$();
    $l$loop: while (true) {
      var tmp0_elvis_lhs = $this$readArray.s2v();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var value = tmp;
      valueList.e(value);
    }
    return valueList;
  }
  function Json2EntityConverter$jsonToModel$lambda(this$0, $entity) {
    return function ($this$readObject) {
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readObject.z2v();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var blobId = tmp;
        var arrayReader = $this$readObject.t2v();
        var rootNode = this$0.e37_1.s37(arrayReader);
        var model = new Model(rootNode);
        $entity.f30(this$0.d37_1.m37(EntityIdModelKinds_getInstance().j37_1).q2q(blobId), model);
      }
      return Unit_instance;
    };
  }
  function Json2EntityConverter$readChildArray$lambda(this$0, $entity) {
    return function ($this$readArray) {
      var serializedChildId = $this$readArray.s2v();
      var childIdPersister = this$0.d37_1.m37(EntityIdModelKinds_getInstance().k37_1);
      var entityChildId = childIdPersister.q2q(serializedChildId);
      var childSet = $entity.w2z(entityChildId);
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readArray.t2v();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var childArrayReader = tmp;
        var childEntity = this$0.t37(childArrayReader);
        childSet.e(childEntity);
      }
      return Unit_instance;
    };
  }
  function Json2EntityConverter(idContext, nodeFactory) {
    idContext = idContext === VOID ? new EntityIdPersistenceContext() : idContext;
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.d37_1 = idContext;
    this.e37_1 = new Json2NodeConverter(this.d37_1, nodeFactory);
  }
  protoOf(Json2EntityConverter).t37 = function (arrayReader) {
    return arrayReader.r2v(Json2EntityConverter$entityFromJson$lambda(this));
  };
  protoOf(Json2EntityConverter).n37 = function (arrayReader, entity) {
    return arrayReader.r2v(Json2EntityConverter$jsonToProperties$lambda(this, entity));
  };
  protoOf(Json2EntityConverter).o37 = function (arrayReader, entity) {
    return arrayReader.r2v(Json2EntityConverter$jsonToReferences$lambda(this, entity));
  };
  protoOf(Json2EntityConverter).p37 = function (objectReader, entity) {
    return objectReader.y2v(Json2EntityConverter$jsonToModel$lambda(this, entity));
  };
  function readProperties($this, objectReader, node) {
    return objectReader.y2v(Json2NodeConverter$readProperties$lambda($this, node));
  }
  function readChildren($this, objectReader, node) {
    return objectReader.y2v(Json2NodeConverter$readChildren$lambda($this, node));
  }
  function Json2NodeConverter$fromJson$lambda(this$0) {
    return function ($this$readArray) {
      var serializedId = $this$readArray.s2v();
      // Inline function 'kotlin.checkNotNull' call
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (serializedId == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      var id = this$0.q37_1.m37(NodeIdModelKinds_getInstance().v37_1).q2q(serializedId);
      var serializedConceptId = $this$readArray.s2v();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_0: {
        // Inline function 'kotlin.checkNotNull' call
        if (serializedConceptId == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message_0 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_0));
        } else {
          break $l$block_0;
        }
      }
      var conceptId = this$0.q37_1.m37(NodeIdModelKinds_getInstance().w37_1).q2q(serializedConceptId);
      var node = this$0.r37_1.z37(conceptId, id);
      var propertiesObjectReader = $this$readArray.u2v();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_1: {
        // Inline function 'kotlin.checkNotNull' call
        if (propertiesObjectReader == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message_1 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_1));
        } else {
          break $l$block_1;
        }
      }
      readProperties(this$0, propertiesObjectReader, node);
      var childrenObjectReader = $this$readArray.u2v();
      // Inline function 'kotlin.checkNotNull' call
      $l$block_2: {
        // Inline function 'kotlin.checkNotNull' call
        if (childrenObjectReader == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message_2 = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message_2));
        } else {
          break $l$block_2;
        }
      }
      readChildren(this$0, childrenObjectReader, node);
      return node;
    };
  }
  function Json2NodeConverter$readProperties$lambda(this$0, $node) {
    return function ($this$readObject) {
      var propertyIdPersister = this$0.q37_1.m37(NodeIdModelKinds_getInstance().x37_1);
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readObject.z2v();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var propertyId = tmp;
        var nodePropertyId = propertyIdPersister.q2q(propertyId);
        var value = $this$readObject.a2w();
        // Inline function 'kotlin.checkNotNull' call
        $l$block: {
          // Inline function 'kotlin.checkNotNull' call
          if (value == null) {
            // Inline function 'kotlin.checkNotNull.<anonymous>' call
            var message = 'Required value was null.';
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          } else {
            break $l$block;
          }
        }
        $node.k38(nodePropertyId, value);
      }
      return Unit_instance;
    };
  }
  function Json2NodeConverter$readChildren$lambda$lambda($children, this$0) {
    return function ($this$readArray) {
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readArray.t2v();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var childArrayReader = tmp;
        $children.e(this$0.s37(childArrayReader));
      }
      return Unit_instance;
    };
  }
  function Json2NodeConverter$readChildren$lambda(this$0, $node) {
    return function ($this$readObject) {
      var childIdPersister = this$0.q37_1.m37(NodeIdModelKinds_getInstance().y37_1);
      $l$loop: while (true) {
        var tmp0_elvis_lhs = $this$readObject.z2v();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var childId = tmp;
        var nodeChildId = childIdPersister.q2q(childId);
        var children = $node.l38(nodeChildId);
        var arrayReader = $this$readObject.t2v();
        arrayReader.r2v(Json2NodeConverter$readChildren$lambda$lambda(children, this$0));
      }
      return Unit_instance;
    };
  }
  function Json2NodeConverter(idContext, nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.q37_1 = idContext;
    this.r37_1 = nodeFactory;
  }
  protoOf(Json2NodeConverter).s37 = function (arrayReader) {
    return arrayReader.r2v(Json2NodeConverter$fromJson$lambda(this));
  };
  function Companion_42() {
  }
  var Companion_instance_42;
  function Companion_getInstance_42() {
    return Companion_instance_42;
  }
  function Entity2JsonConverter(idContext, filter) {
    idContext = idContext === VOID ? new EntityIdPersistenceContext() : idContext;
    filter = filter === VOID ? null : filter;
    this.m38_1 = idContext;
    this.n38_1 = filter;
    this.o38_1 = new Node2JsonConverter(this.m38_1);
  }
  protoOf(Entity2JsonConverter).p38 = function (entity) {
    var result = new JsonArray();
    result.h2u(ensureNotNull(this.m38_1.m37(EntityIdModelKinds_getInstance().f37_1).x2p(entity.j2z_1)));
    result.h2u(ensureNotNull(this.m38_1.m37(EntityIdModelKinds_getInstance().g37_1).x2p(entity.i2z_1)));
    result.s2t(this.t38(entity, entity.y2z()));
    result.s2t(this.u38(entity, entity.b30()));
    result.s2t(this.v38(entity, entity.d30()));
    var _iterator__ex2g4s = entity.v2z().k();
    while (_iterator__ex2g4s.l()) {
      var cid = _iterator__ex2g4s.m();
      var child = new JsonArray();
      child.h2u(ensureNotNull(this.m38_1.m37(EntityIdModelKinds_getInstance().k37_1).x2p(cid)));
      var notEmpty = false;
      var _iterator__ex2g4s_0 = entity.w2z(cid).k();
      $l$loop: while (_iterator__ex2g4s_0.l()) {
        var cEntity = _iterator__ex2g4s_0.m();
        if (!(this.n38_1 == null) && !this.n38_1(cEntity)) {
          continue $l$loop;
        }
        notEmpty = true;
        child.s2t(this.p38(cEntity));
      }
      if (notEmpty) {
        result.s2t(child);
      }
    }
    return result;
  };
  protoOf(Entity2JsonConverter).t38 = function (entity, ids) {
    var result = new JsonArray();
    var _iterator__ex2g4s = ids.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var id = _iterator__ex2g4s.m();
      var tmp0_elvis_lhs = entity.z2z(id);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var value = tmp;
      result.h2u(ensureNotNull(this.m38_1.m37(EntityIdModelKinds_getInstance().h37_1).x2p(id)));
      result.h2u(value);
    }
    return result;
  };
  protoOf(Entity2JsonConverter).u38 = function (entity, ids) {
    var result = new JsonArray();
    var _iterator__ex2g4s = ids.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var refId = _iterator__ex2g4s.m();
      var refSet = entity.c30(refId);
      if (refSet.p())
        continue $l$loop;
      result.h2u(ensureNotNull(this.m38_1.m37(EntityIdModelKinds_getInstance().i37_1).x2p(refId)));
      var refs = new JsonArray();
      var _iterator__ex2g4s_0 = refSet.k();
      while (_iterator__ex2g4s_0.l()) {
        var ref = _iterator__ex2g4s_0.m();
        refs.h2u(ensureNotNull(this.m38_1.m37(EntityIdModelKinds_getInstance().l37_1).x2p(ref)));
      }
      result.s2t(refs);
    }
    return result;
  };
  protoOf(Entity2JsonConverter).v38 = function (entity, ids) {
    var result = new JsonObject();
    var _iterator__ex2g4s = ids.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var blobId = _iterator__ex2g4s.m();
      var tmp0_elvis_lhs = entity.e30(blobId);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var model = tmp;
      result.q2t(ensureNotNull(this.m38_1.m37(EntityIdModelKinds_getInstance().j37_1).x2p(blobId)), this.o38_1.x38(model.g30_1));
    }
    return result;
  };
  function Node2JsonConverter(idContext) {
    this.w38_1 = idContext;
  }
  protoOf(Node2JsonConverter).x38 = function (node) {
    var result = new JsonArray();
    result.h2u(ensureNotNull(this.w38_1.m37(NodeIdModelKinds_getInstance().v37_1).x2p(NodeUtil_instance.y38(node))));
    result.h2u(ensureNotNull(this.w38_1.m37(NodeIdModelKinds_getInstance().w37_1).x2p(node.a38_1)));
    var properties = new JsonObject();
    var _iterator__ex2g4s = node.y2z().k();
    while (_iterator__ex2g4s.l()) {
      var propertyId = _iterator__ex2g4s.m();
      properties.d2v(ensureNotNull(this.w38_1.m37(NodeIdModelKinds_getInstance().x37_1).x2p(propertyId)), node.z38(propertyId).qr());
    }
    result.s2t(properties);
    var allChildren = new JsonObject();
    var _iterator__ex2g4s_0 = node.v2z().k();
    $l$loop: while (_iterator__ex2g4s_0.l()) {
      var childId = _iterator__ex2g4s_0.m();
      var childNodes = node.l38(childId);
      if (childNodes.p()) {
        continue $l$loop;
      }
      var children = new JsonArray();
      var _iterator__ex2g4s_1 = childNodes.k();
      while (_iterator__ex2g4s_1.l()) {
        var child = _iterator__ex2g4s_1.m();
        children.s2t(this.x38(child));
      }
      allChildren.q2t(ensureNotNull(this.w38_1.m37(NodeIdModelKinds_getInstance().y37_1).x2p(childId)), children);
    }
    result.s2t(allChildren);
    return result;
  };
  function getUnequalConceptsMessage($this, expected, actual) {
    return "Unequal concept ids: expected='" + expected + "', actual='" + actual + "'";
  }
  function MessageBundle() {
  }
  protoOf(MessageBundle).a39 = function (expected, actual) {
    return getUnequalConceptsMessage(this, expected.i2s_1, actual.i2s_1);
  };
  protoOf(MessageBundle).b39 = function (id1, id2) {
    return "Unequal role ids: id1='" + id1.i2s_1 + "', id2='" + id2.i2s_1 + "'";
  };
  protoOf(MessageBundle).c39 = function (id) {
    return "Cannot remove when not empty, id='" + (id == null ? null : id.i2s_1) + "'";
  };
  protoOf(MessageBundle).d39 = function (id1, id2) {
    var tmp = id1 == null ? null : id1.i2s_1;
    return "Unequal ids: id1='" + tmp + "', id2='" + (id2 == null ? null : id2.i2s_1) + "'";
  };
  var MessageBundle_instance;
  function MessageBundle_getInstance() {
    return MessageBundle_instance;
  }
  function trySerializeCatching($this, value) {
    var tmp;
    try {
      tmp = $this.m2y().x2p(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        throw IllegalArgumentException_init_$Create$_1('Property ' + $this.e39().toString() + '.' + $this.f39().b3() + ' has assigned to non-serializable value: ' + toString_0(value), e);
      } else {
        throw $p;
      }
    }
    return tmp;
  }
  function tryDeserializeCatching($this, value) {
    var tmp;
    try {
      tmp = $this.m2y().q2q(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        throw IllegalStateException_init_$Create$_1('Property ' + $this.e39().toString() + '.' + $this.f39().b3() + ' contains non-deserializable value: ' + value, e);
      } else {
        throw $p;
      }
    }
    return tmp;
  }
  function BaseOtNodeProperty() {
    BaseReadableProperty.call(this);
  }
  protoOf(BaseOtNodeProperty).l2c = function () {
    return '' + getKClassFromExpression(this).lb() + '(' + this.e39().toString() + '.' + this.f39().b3() + ', ' + toString_1(this.m2y()) + ')';
  };
  protoOf(BaseOtNodeProperty).qr = function () {
    return tryDeserializeCatching(this, this.e39().g39(this.f39()));
  };
  protoOf(BaseOtNodeProperty).t2c = function (newValue) {
    var value = trySerializeCatching(this, newValue);
    this.e39().h39(this.f39(), value);
  };
  protoOf(BaseOtNodeProperty).k2c = function (handler) {
    return this.e39().i39(this.f39(), new PropertyEventHandlerWrapper(handler, this.m2y()));
  };
  protoOf(BaseOtNodeProperty).o27 = function (handler) {
    return this.k2c(handler);
  };
  function BaseOtNodeTextProperty$addHandler$$inlined$eventHandler$1($handler) {
    this.j39_1 = $handler;
  }
  protoOf(BaseOtNodeTextProperty$addHandler$$inlined$eventHandler$1).e2b = function (event) {
    var oldValue = event.o2e_1;
    var tmp;
    if (oldValue == null) {
      var newValue = ensureNotNull(event.p2e_1);
      var tmp_0;
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(newValue) > 0) {
        this.j39_1.d28(new PropertyChangeEvent('', newValue));
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    } else if (event.p2e_1 == null) {
      var tmp_1;
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(oldValue) > 0) {
        this.j39_1.d28(new PropertyChangeEvent(oldValue, ''));
        tmp_1 = Unit_instance;
      }
      tmp = tmp_1;
    } else {
      var changeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      this.j39_1.d28(changeEvent);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(BaseOtNodeTextProperty$addHandler$$inlined$eventHandler$1).d28 = function (event) {
    return this.e2b((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function BaseOtNodeTextProperty() {
  }
  protoOf(BaseOtNodeTextProperty).l2c = function () {
    return 'text property [' + this.e39().toString() + '.' + this.f39().b3() + ']';
  };
  protoOf(BaseOtNodeTextProperty).k39 = function (index, text) {
    var s = this.e39().g39(this.f39());
    var indexParam = s == null ? -1 : index;
    this.e39().l39(this.f39(), indexParam, text);
  };
  protoOf(BaseOtNodeTextProperty).m39 = function (index, length) {
    var s = this.e39().g39(this.f39());
    if (s == null) {
      // Inline function 'kotlin.require' call
      if (!(index === 0 && length === 0)) {
        // Inline function 'jetbrains.ocelot.ot.model.node.BaseOtNodeTextProperty.delete.<anonymous>' call
        var message = 'Incorrect deletion';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      return Unit_instance;
    }
    var indexParam = s.length === length ? -1 : index;
    this.e39().n39(this.f39(), indexParam, length);
  };
  protoOf(BaseOtNodeTextProperty).qr = function () {
    var tmp0_elvis_lhs = this.e39().g39(this.f39());
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  protoOf(BaseOtNodeTextProperty).o39 = function (handler) {
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var wrapper = new BaseOtNodeTextProperty$addHandler$$inlined$eventHandler$1(handler);
    return this.e39().i39(this.f39(), wrapper);
  };
  protoOf(BaseOtNodeTextProperty).o27 = function (handler) {
    return this.o39(handler);
  };
  function checkField($this, metaId, fieldName, value1, value2) {
    // Inline function 'kotlin.check' call
    if (!equals(value1, value2)) {
      // Inline function 'jetbrains.ocelot.ot.model.node.MetaIdFactory.checkField.<anonymous>' call
      var message = "for '" + $this.p39_1 + "' instance: '" + toString_1(metaId) + "', field: '" + fieldName + "' values do not match: '" + toString_0(value1) + "', '" + toString_0(value2) + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function MetaIdFactory(idClassName, defaultValue) {
    this.p39_1 = idClassName;
    this.q39_1 = defaultValue;
    this.r39_1 = HashMap_init_$Create$();
  }
  protoOf(MetaIdFactory).s39 = function (id, name, flags) {
    var conceptId = this.r39_1.y2(id);
    var tmp;
    if (conceptId == null) {
      // Inline function 'kotlin.collections.getOrPut' call
      var this_0 = this.r39_1;
      var value = this_0.y2(id);
      var tmp_0;
      if (value == null) {
        // Inline function 'jetbrains.ocelot.ot.model.node.MetaIdFactory.create.<anonymous>' call
        var answer = this.q39_1(id, name, flags);
        this_0.r2(id, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      tmp = tmp_0;
    } else {
      checkField(this, conceptId, 'flags', flags, conceptId.s33());
      tmp = conceptId;
    }
    return tmp;
  };
  function startChanges($this) {
    // Inline function 'kotlin.check' call
    if (!!$this.l30_1) {
      // Inline function 'jetbrains.ocelot.ot.model.node.Model.startChanges.<anonymous>' call
      var message = 'Start new command while other command is in progress';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    $this.l30_1 = true;
  }
  function endChanges($this) {
    // Inline function 'kotlin.check' call
    if (!$this.l30_1) {
      // Inline function 'jetbrains.ocelot.ot.model.node.Model.endChanges.<anonymous>' call
      var message = 'No command in progress';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    $this.l30_1 = false;
  }
  function UnionNodeCollectionView($outer) {
    this.t39_1 = $outer;
    AbstractCollection.call(this);
  }
  protoOf(UnionNodeCollectionView).n = function () {
    return this.t39_1.h30_1.n() + this.t39_1.i30_1.n() | 0;
  };
  protoOf(UnionNodeCollectionView).k = function () {
    var sequence = plus_7(asSequence_0(this.t39_1.h30_1.v2()), asSequence_0(this.t39_1.i30_1));
    return sequence.k();
  };
  protoOf(UnionNodeCollectionView).u39 = function (element) {
    var tmp;
    if (element.w39()) {
      tmp = this.t39_1.h30_1.w2(element.v39());
    } else {
      tmp = this.t39_1.i30_1.s(element);
    }
    return tmp;
  };
  protoOf(UnionNodeCollectionView).s = function (element) {
    if (!(element instanceof OtNode))
      return false;
    return this.u39(element instanceof OtNode ? element : THROW_CCE());
  };
  function Model$register$lambda($node) {
    return function (listener) {
      listener.x39($node);
      return Unit_instance;
    };
  }
  function Model$unregister$lambda($node) {
    return function (listener) {
      listener.y39($node);
      return Unit_instance;
    };
  }
  function Model$onNodeChanged$lambda(this$0, $event) {
    return function () {
      this$0.j30_1.g2b($event);
      return Unit_instance;
    };
  }
  function Model$fire$lambda(this$0, $event) {
    return function () {
      this$0.j30_1.g2b($event);
      return Unit_instance;
    };
  }
  function Model(rootNode) {
    this.g30_1 = rootNode;
    this.h30_1 = HashMap_init_$Create$();
    this.i30_1 = HashSet_init_$Create$();
    this.j30_1 = new EventListeners();
    this.k30_1 = new Listeners();
    this.l30_1 = false;
    this.m30_1 = new NullEventStateHolder();
    this.n30_1 = false;
    if (!(this.g30_1.z39() == null)) {
      throw OtException_init_$Create$_0('Root node has parent');
    }
    this.a3a(this.g30_1);
  }
  protoOf(Model).b3a = function () {
    return new UnionNodeCollectionView(this);
  };
  protoOf(Model).x34 = function (inProgress) {
    this.m30_1.x34(inProgress);
  };
  protoOf(Model).n33 = function (eventStateHolder) {
    this.m30_1 = eventStateHolder;
  };
  protoOf(Model).c3a = function (id) {
    return this.h30_1.y2(id);
  };
  protoOf(Model).o30 = function () {
    var rootNode = this.g30_1.d3a();
    return new Model(rootNode);
  };
  protoOf(Model).v33 = function (listener) {
    return this.j30_1.z27(listener);
  };
  protoOf(Model).e3a = function (listener) {
    return this.k30_1.z27(listener);
  };
  protoOf(Model).f3a = function (node) {
    return !(this.b3a().s(node) || (node.w39() && this.h30_1.w2(node.v39())));
  };
  protoOf(Model).g3a = function (node) {
    return this.b3a().s(node) && (!node.w39() || this.h30_1.w2(node.v39()));
  };
  protoOf(Model).a3a = function (node) {
    if (!this.f3a(node)) {
      if (this.b3a().s(node))
        throw OtException_init_$Create$_0('Node is already registered');
      else if (node.w39())
        throw OtException_init_$Create$_0("Duplicate node id='" + node.h3a() + "'");
      else
        throw OtException_init_$Create$_0("Can't register node=" + node.toString());
    }
    node.i3a(this);
    var _iterator__ex2g4s = node.v2z().k();
    while (_iterator__ex2g4s.l()) {
      var childId = _iterator__ex2g4s.m();
      var _iterator__ex2g4s_0 = node.l38(childId).k();
      while (_iterator__ex2g4s_0.l()) {
        var child = _iterator__ex2g4s_0.m();
        try {
          this.a3a(child);
        } catch ($p) {
          if ($p instanceof OtException) {
            var e = $p;
            var nodeId = node.w39() ? node.v39() : null;
            var message = "Failed to register child. NodeId='" + toString_0(nodeId) + "', childId='" + childId.toString() + "'";
            throw OtException_init_$Create$_1(message, e);
          } else {
            throw $p;
          }
        }
      }
    }
    if (node.w39()) {
      var tmp0 = this.h30_1;
      // Inline function 'kotlin.collections.set' call
      var key = node.v39();
      tmp0.r2(key, node);
    } else {
      this.i30_1.e(node);
    }
    this.k30_1.a28(Model$register$lambda(node));
  };
  protoOf(Model).j3a = function (node) {
    if (!this.g3a(node)) {
      throw OtException_init_$Create$_0('Unregistered node id=' + node.v39().toString());
    }
    if (node.w39()) {
      this.h30_1.s2(node.v39());
    } else {
      this.i30_1.k2(node);
    }
    var _iterator__ex2g4s = node.v2z().k();
    while (_iterator__ex2g4s.l()) {
      var childId = _iterator__ex2g4s.m();
      var _iterator__ex2g4s_0 = node.l38(childId).k();
      while (_iterator__ex2g4s_0.l()) {
        var child = _iterator__ex2g4s_0.m();
        this.j3a(child);
      }
    }
    node.i3a(null);
    this.k30_1.a28(Model$unregister$lambda(node));
  };
  protoOf(Model).k3a = function (f) {
    startChanges(this);
    try {
      f();
    }finally {
      endChanges(this);
    }
  };
  protoOf(Model).l3a = function (event) {
    if (!this.l30_1) {
      var tmp = this.m30_1;
      tmp.x33(Model$onNodeChanged$lambda(this, event));
    }
  };
  protoOf(Model).m3a = function (event) {
    var tmp = this.m30_1;
    tmp.b37(Model$fire$lambda(this, event));
  };
  protoOf(Model).e31 = function () {
    this.m30_1.a35();
  };
  function Node$getTextProperty$1(this$0, $propertyId) {
    BaseOtNodeTextProperty.call(this);
    this.n3a_1 = this$0;
    this.o3a_1 = $propertyId;
  }
  protoOf(Node$getTextProperty$1).e39 = function () {
    return this.n3a_1;
  };
  protoOf(Node$getTextProperty$1).f39 = function () {
    return this.o3a_1;
  };
  function Node_0(conceptId, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(conceptId) : nodeId;
    OtNode.call(this, conceptId, nodeId);
    this.a3b_1 = null;
    this.b3b_1 = null;
  }
  protoOf(Node_0).y2z = function () {
    var tmp0_safe_receiver = this.a3b_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.op();
    return tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  };
  protoOf(Node_0).v2z = function () {
    var tmp0_safe_receiver = this.b3b_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.op();
    return tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  };
  protoOf(Node_0).np = function () {
    var tmp;
    var tmp_0;
    if (this.b3b_1 == null) {
      tmp_0 = true;
    } else {
      var tmp0 = ensureNotNull(this.b3b_1).pp();
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var tmp_1;
        if (isInterface(tmp0, Collection)) {
          tmp_1 = tmp0.p();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.k();
        while (_iterator__ex2g4s.l()) {
          var element = _iterator__ex2g4s.m();
          // Inline function 'jetbrains.ocelot.ot.model.node.Node.<get-isEmpty>.<anonymous>' call
          if (!element.p()) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
        }
        tmp$ret$0 = true;
      }
      tmp_0 = tmp$ret$0;
    }
    if (tmp_0) {
      tmp = this.a3b_1 == null || ensureNotNull(this.a3b_1).np();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Node_0).c3b = function (nodeId) {
    return new Node_0(this.a38_1, nodeId);
  };
  protoOf(Node_0).g39 = function (propertyId) {
    var tmp0_safe_receiver = this.a3b_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y2(propertyId);
  };
  protoOf(Node_0).e3b = function (propertyId, value, oldValue) {
    if (oldValue == value)
      return true;
    if (value == null) {
      ensureNotNull(this.a3b_1).s2(propertyId);
      if (ensureNotNull(this.a3b_1).np()) {
        this.a3b_1 = null;
      }
    } else {
      if (this.a3b_1 == null) {
        this.a3b_1 = new ListMap();
      }
      ensureNotNull(this.a3b_1).r2(propertyId, value);
    }
    return false;
  };
  protoOf(Node_0).l38 = function (childId) {
    if (this.b3b_1 == null) {
      this.b3b_1 = new ListMap();
    }
    var list = ensureNotNull(this.b3b_1).y2(childId);
    if (list == null) {
      list = new ChildrenObservableList(this, childId);
      list.n27(this);
      ensureNotNull(this.b3b_1).r2(childId, list);
    }
    return list;
  };
  protoOf(Node_0).f3b = function (propertyId) {
    return new Node$getTextProperty$1(this, propertyId);
  };
  function NodeChildId(id, name, flags) {
    RoleId_init_$Init$_1(id, name, flags, this);
  }
  function createDefaultId($this) {
    return Companion_getInstance_35().c2s();
  }
  function NodeChildId$_init_$ref_694iog() {
    var l = function (p0, p1, p2) {
      return new NodeChildId(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function NodeChildIdFactory() {
    NodeChildIdFactory_instance = this;
    var tmp = this;
    tmp.z3b_1 = new MetaIdFactory('NodeChildId', NodeChildId$_init_$ref_694iog());
  }
  protoOf(NodeChildIdFactory).a3c = function (id, name) {
    return this.d3c(id, name, Companion_getInstance_72().c3c_1);
  };
  protoOf(NodeChildIdFactory).e3c = function (id, name, $super) {
    id = id === VOID ? createDefaultId(this) : id;
    name = name === VOID ? null : name;
    return $super === VOID ? this.a3c(id, name) : $super.a3c.call(this, id, name);
  };
  protoOf(NodeChildIdFactory).f3c = function (id, name) {
    return this.d3c(id, name, Companion_getInstance_72().b3c_1);
  };
  protoOf(NodeChildIdFactory).d3c = function (id, name, flags) {
    return this.z3b_1.s39(id, name, flags);
  };
  var NodeChildIdFactory_instance;
  function NodeChildIdFactory_getInstance() {
    if (NodeChildIdFactory_instance == null)
      new NodeChildIdFactory();
    return NodeChildIdFactory_instance;
  }
  function NodeConceptId(id, name, flags) {
    MetaId_init_$Init$_1(id, name, flags, this);
  }
  protoOf(NodeConceptId).i3c = function () {
    return !this.s33().s(NodeConceptIdFlag_NO_ID_getInstance());
  };
  protoOf(NodeConceptId).toString = function () {
    var string = protoOf(MetaId).toString.call(this);
    var tmp;
    if (this.i3c()) {
      tmp = string;
    } else {
      tmp = string + '(without id)';
    }
    return tmp;
  };
  function createDefaultId_0($this) {
    return Companion_getInstance_35().c2s();
  }
  function NodeConceptId$_init_$ref_joxnlo() {
    var l = function (p0, p1, p2) {
      return new NodeConceptId(p0, p1, p2);
    };
    l.callableName = '<init>';
    return l;
  }
  function NodeConceptIdFactory() {
    NodeConceptIdFactory_instance = this;
    this.j3c_1 = emptySet();
    this.k3c_1 = setOf(NodeConceptIdFlag_NO_ID_getInstance());
    var tmp = this;
    tmp.l3c_1 = new MetaIdFactory('NodeConceptId', NodeConceptId$_init_$ref_joxnlo());
  }
  protoOf(NodeConceptIdFactory).m3c = function (id, name) {
    return this.n3c(id, name, this.j3c_1);
  };
  protoOf(NodeConceptIdFactory).o3c = function (id, name, $super) {
    id = id === VOID ? createDefaultId_0(this) : id;
    name = name === VOID ? null : name;
    return $super === VOID ? this.m3c(id, name) : $super.m3c.call(this, id, name);
  };
  protoOf(NodeConceptIdFactory).p3c = function (id, name) {
    return this.n3c(id, name, this.k3c_1);
  };
  protoOf(NodeConceptIdFactory).q3c = function (id, name, $super) {
    id = id === VOID ? createDefaultId_0(this) : id;
    name = name === VOID ? null : name;
    return $super === VOID ? this.p3c(id, name) : $super.p3c.call(this, id, name);
  };
  protoOf(NodeConceptIdFactory).n3c = function (id, name, flags) {
    return this.l3c_1.s39(id, name, flags);
  };
  var NodeConceptIdFactory_instance;
  function NodeConceptIdFactory_getInstance() {
    if (NodeConceptIdFactory_instance == null)
      new NodeConceptIdFactory();
    return NodeConceptIdFactory_instance;
  }
  var NodeConceptIdFlag_NO_ID_instance;
  function values_1() {
    return [NodeConceptIdFlag_NO_ID_getInstance()];
  }
  var NodeConceptIdFlag_entriesInitialized;
  function NodeConceptIdFlag_initEntries() {
    if (NodeConceptIdFlag_entriesInitialized)
      return Unit_instance;
    NodeConceptIdFlag_entriesInitialized = true;
    NodeConceptIdFlag_NO_ID_instance = new NodeConceptIdFlag('NO_ID', 0);
  }
  function NodeConceptIdFlag(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function NodeConceptIdFlag_NO_ID_getInstance() {
    NodeConceptIdFlag_initEntries();
    return NodeConceptIdFlag_NO_ID_instance;
  }
  function NodeCopier() {
  }
  protoOf(NodeCopier).s3c = function (node) {
    var result = this.r3c(node);
    var _iterator__ex2g4s = node.y2z().k();
    while (_iterator__ex2g4s.l()) {
      var propertyId = _iterator__ex2g4s.m();
      result.z38(propertyId).t2c(node.z38(propertyId).qr());
    }
    var _iterator__ex2g4s_0 = node.v2z().k();
    $l$loop: while (_iterator__ex2g4s_0.l()) {
      var childId = _iterator__ex2g4s_0.m();
      var childNodes = node.l38(childId);
      if (childNodes.p()) {
        continue $l$loop;
      }
      var resultChildren = result.l38(childId);
      var _iterator__ex2g4s_1 = childNodes.k();
      while (_iterator__ex2g4s_1.l()) {
        var childNode = _iterator__ex2g4s_1.m();
        resultChildren.e(this.s3c(childNode));
      }
    }
    return result;
  };
  function NodeId(id) {
    id = id === VOID ? Companion_getInstance_35().c2s() : id;
    BaseId.call(this, id);
  }
  function NodePropertyChangeEvent(propertyId, changeEvent) {
    this.t3c_1 = propertyId;
    this.u3c_1 = changeEvent;
  }
  function NodePropertyId(id, name) {
    BaseId.call(this, id, name);
  }
  function NodePropertyIdFactory() {
    NodePropertyIdFactory_instance = this;
    this.v3c_1 = HashMap_init_$Create$();
  }
  protoOf(NodePropertyIdFactory).w3c = function (id, name) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.v3c_1;
    var value = this_0.y2(id);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.ot.model.node.NodePropertyIdFactory.create.<anonymous>' call
      var answer = new NodePropertyId(id, name);
      this_0.r2(id, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  };
  protoOf(NodePropertyIdFactory).x3c = function (id, name, $super) {
    id = id === VOID ? Companion_getInstance_35().c2s() : id;
    name = name === VOID ? null : name;
    return $super === VOID ? this.w3c(id, name) : $super.w3c.call(this, id, name);
  };
  var NodePropertyIdFactory_instance;
  function NodePropertyIdFactory_getInstance() {
    if (NodePropertyIdFactory_instance == null)
      new NodePropertyIdFactory();
    return NodePropertyIdFactory_instance;
  }
  function checkStructureOnAdd($this, item) {
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (item == null) {
        // Inline function 'jetbrains.ocelot.ot.model.node.ChildrenObservableList.checkStructureOnAdd.<anonymous>' call
        var message = 'Null children not allowed';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    // Inline function 'kotlin.require' call
    if (!(item.z39() == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.node.ChildrenObservableList.checkStructureOnAdd.<anonymous>' call
      var message_0 = "Can't add node attached to another parent";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!($this.c3d_1.c38_1 == null || ensureNotNull($this.c3d_1.c38_1).f3a(item) || $this.c3d_1.j38_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.node.ChildrenObservableList.checkStructureOnAdd.<anonymous>' call
      var message_1 = "Can't register node " + toString_0(item) + ' in model ' + toString_0($this.c3d_1.c38_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
  }
  function checkStructureOnRemove($this, item) {
    // Inline function 'kotlin.require' call
    if (!equals(item.z39(), $this.c3d_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.node.ChildrenObservableList.checkStructureOnRemove.<anonymous>' call
      var message = 'Removing from the wrong parent';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!($this.c3d_1.c38_1 == null || ensureNotNull($this.c3d_1.c38_1).g3a(item))) {
      // Inline function 'jetbrains.ocelot.ot.model.node.ChildrenObservableList.checkStructureOnRemove.<anonymous>' call
      var message_0 = "Can't unregister node " + item.toString() + ' in model ' + toString_0($this.c3d_1.c38_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  function attachItemStart($this, item, prevIndex, nextIndex) {
    item.d38_1.s2c($this.c3d_1);
    item.e38_1 = $this.b3d_1;
    if (0 <= prevIndex ? prevIndex < $this.n() : false) {
      var prev = $this.q(prevIndex);
      prev.g38_1 = item;
      item.f38_1 = prev;
    }
    if (0 <= nextIndex ? nextIndex < $this.n() : false) {
      var next = $this.q(nextIndex);
      next.f38_1 = item;
      item.g38_1 = next;
    }
  }
  function attachItemFinish($this, item, index) {
    item.d38_1.v9();
    if ($this.c3d_1.g3b()) {
      var nodeEvent = new NodeChildAddedEvent($this.c3d_1, $this.b3d_1, index, item);
      onNodeChanged($this.c3d_1, nodeEvent);
    }
  }
  function detachItemStart($this, item) {
    item.d38_1.s2c(null);
    item.e38_1 = null;
    var prev = item.j3b();
    var next = item.k3b();
    if (!(prev == null)) {
      prev.g38_1 = next;
    }
    if (!(next == null)) {
      next.f38_1 = prev;
    }
    item.f38_1 = null;
    item.g38_1 = null;
  }
  function detachItemFinish($this, item, index) {
    item.d38_1.v9();
    if ($this.c3d_1.g3b()) {
      var nodeEvent = new NodeChildRemovedEvent($this.c3d_1, $this.b3d_1, index, item);
      onNodeChanged($this.c3d_1, nodeEvent);
    }
  }
  function detachAndAttachItemsFinish($this, oldItem, newItem, index) {
    newItem.d38_1.v9();
    if ($this.c3d_1.g3b()) {
      var nodeEvent = new NodeChildSetEvent($this.c3d_1, $this.b3d_1, index, oldItem, newItem);
      onNodeChanged($this.c3d_1, nodeEvent);
    }
  }
  function validateNodeId($this, nodeId, conceptId) {
    if (!(nodeId == null)) {
      // Inline function 'kotlin.require' call
      if (!conceptId.i3c()) {
        // Inline function 'jetbrains.ocelot.ot.model.node.Companion.validateNodeId.<anonymous>' call
        var message = expectedNoIdMessage(Companion_instance_43, conceptId, nodeId);
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
    } else {
      // Inline function 'kotlin.require' call
      if (!!conceptId.i3c()) {
        // Inline function 'jetbrains.ocelot.ot.model.node.Companion.validateNodeId.<anonymous>' call
        var message_0 = expectedNodeIdMessage(Companion_instance_43, conceptId);
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      }
    }
  }
  function expectedNoIdMessage($this, conceptId, nodeId) {
    return "Expected node with conceptId='" + conceptId.toString() + "' and nodeId='" + toString_0(nodeId) + "' to have no id";
  }
  function expectedNodeIdMessage($this, conceptId) {
    return "Expected node with conceptId='" + conceptId.toString() + "' to have an id";
  }
  function nodeCannotHaveIdMessage($this, conceptId) {
    return "OtNode with conceptId='" + conceptId.toString() + "' cannot have an id";
  }
  function indexOutOfBoundsMessage($this, indexDescription, index, interval) {
    return indexDescription + ' index is out of bounds: index=' + index + ', bounds=' + interval.toString();
  }
  function _get_propertyListeners__yg2t9j($this) {
    if (!_get_arePropertyListenersInitialized__tb7xlf($this)) {
      $this.h38_1 = new EventHandlerListeners();
    }
    return ensureNotNull($this.h38_1);
  }
  function _get_arePropertyListenersInitialized__tb7xlf($this) {
    return !($this.h38_1 == null);
  }
  function _get_deepChangeListeners__s6vj7y($this) {
    if (!_get_deepChangeListenersInitialized__6113uu($this)) {
      var tmp = $this;
      tmp.i38_1 = new OtNode$deepChangeListeners$1($this);
    }
    return ensureNotNull($this.i38_1);
  }
  function _get_deepChangeListenersInitialized__6113uu($this) {
    return !($this.i38_1 == null);
  }
  function _get_hasListeners__lk7hnq($this) {
    return $this.g3b() || _get_arePropertyListenersInitialized__tb7xlf($this);
  }
  function checkCanModify_0($this) {
    if ($this.g3b()) {
      ensureNotNull($this.c38_1).e31();
    }
  }
  function getChildNodeToSplit($this, toAdd, index, list) {
    checkCanModify_0($this);
    checkIndex($this, index, list);
    var source = list.q(index - 1 | 0);
    // Inline function 'kotlin.require' call
    if (!source.a38_1.equals(toAdd.a38_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.getChildNodeToSplit.<anonymous>' call
      var message = MessageBundle_instance.a39(source.a38_1, toAdd.a38_1);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return source;
  }
  function checkIndex($this, index, list) {
    // Inline function 'kotlin.require' call
    if (!(0 < index && index <= list.n())) {
      // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.checkIndex.<anonymous>' call
      var interval = new Interval(1, list.n());
      var message = indexOutOfBoundsMessage(Companion_instance_43, 'Add', index, interval);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function setEventInProgress_0($this, inProgress) {
    var tmp0_safe_receiver = $this.c38_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.x34(inProgress);
    }
  }
  function executeAtomicChanges($this, f) {
    if ($this.g3b()) {
      ensureNotNull($this.c38_1).k3a(f);
    } else {
      f();
    }
  }
  function onNodeChanged($this, event) {
    ensureNotNull($this.c38_1).l3a(event);
    if (ensureNotNull($this.c38_1).n30_1) {
      fireDescendantEvent($this, event);
    }
  }
  function fire_1($this, event) {
    if ($this.g3b()) {
      ensureNotNull($this.c38_1).m3a(event);
    }
  }
  function fireDescendantEvent($this, event) {
    if (_get_deepChangeListenersInitialized__6113uu($this)) {
      _get_deepChangeListeners__s6vj7y($this).c2b(event);
    }
    var tmp0_safe_receiver = $this.z39();
    if (tmp0_safe_receiver == null)
      null;
    else {
      fireDescendantEvent(tmp0_safe_receiver, event);
    }
  }
  function RemoveChildOperationData($outer, child) {
    this.h3d_1 = $outer;
    this.d3d_1 = ensureNotNull(child.h3b());
    this.e3d_1 = this.h3d_1.l38(this.d3d_1);
    this.f3d_1 = this.e3d_1.u(child);
    // Inline function 'kotlin.check' call
    if (!(this.f3d_1 > 0)) {
      // Inline function 'jetbrains.ocelot.ot.model.node.RemoveChildOperationData.<anonymous>' call
      var message = 'Child index=' + this.f3d_1;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.g3d_1 = this.e3d_1.q(this.f3d_1 - 1 | 0);
    // Inline function 'kotlin.check' call
    if (!this.g3d_1.a38_1.equals(child.a38_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.node.RemoveChildOperationData.<anonymous>' call
      var message_0 = MessageBundle_instance.a39(this.g3d_1.a38_1, child.a38_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  function MyProperty($outer, propertyId) {
    this.j3d_1 = $outer;
    BaseReadableProperty.call(this);
    this.i3d_1 = propertyId;
  }
  protoOf(MyProperty).l2c = function () {
    return this.j3d_1.toString() + '.' + this.i3d_1.b3();
  };
  protoOf(MyProperty).qr = function () {
    return this.j3d_1.g39(this.i3d_1);
  };
  protoOf(MyProperty).k3d = function (newValue) {
    return this.j3d_1.h39(this.i3d_1, newValue);
  };
  protoOf(MyProperty).t2c = function (newValue) {
    return this.k3d((newValue == null ? true : typeof newValue === 'string') ? newValue : THROW_CCE());
  };
  protoOf(MyProperty).l3d = function (handler) {
    return this.j3d_1.i39(this.i3d_1, handler);
  };
  protoOf(MyProperty).o27 = function (handler) {
    return this.l3d(handler);
  };
  function ChildrenObservableList($outer, childId) {
    this.c3d_1 = $outer;
    ObservableArrayList.call(this);
    this.b3d_1 = childId;
  }
  protoOf(ChildrenObservableList).yt = function () {
    return this.c3d_1;
  };
  protoOf(ChildrenObservableList).m3d = function (index, item) {
    checkCanModify_0(this.c3d_1);
    protoOf(ObservableArrayList).e28.call(this, index, item);
    // Inline function 'kotlin.check' call
    if (!(!this.b3d_1.b32() || this.p())) {
      // Inline function 'jetbrains.ocelot.ot.model.node.ChildrenObservableList.checkAdd.<anonymous>' call
      var message = "Can't add second item to a single role " + this.b3d_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    checkStructureOnAdd(this, item);
  };
  protoOf(ChildrenObservableList).e28 = function (index, item) {
    return this.m3d(index, item instanceof OtNode ? item : THROW_CCE());
  };
  protoOf(ChildrenObservableList).n3d = function (index, oldItem, newItem) {
    checkCanModify_0(this.c3d_1);
    protoOf(ObservableArrayList).f28.call(this, index, oldItem, newItem);
    checkStructureOnRemove(this, oldItem);
    checkStructureOnAdd(this, newItem);
  };
  protoOf(ChildrenObservableList).f28 = function (index, oldItem, newItem) {
    var tmp = oldItem instanceof OtNode ? oldItem : THROW_CCE();
    return this.n3d(index, tmp, newItem instanceof OtNode ? newItem : THROW_CCE());
  };
  protoOf(ChildrenObservableList).o3d = function (index, item) {
    checkCanModify_0(this.c3d_1);
    protoOf(ObservableArrayList).g28.call(this, index, item);
    checkStructureOnRemove(this, item);
  };
  protoOf(ChildrenObservableList).g28 = function (index, item) {
    return this.o3d(index, item instanceof OtNode ? item : THROW_CCE());
  };
  protoOf(ChildrenObservableList).p3d = function (index, item) {
    attachItemStart(this, item, index - 1 | 0, index);
  };
  protoOf(ChildrenObservableList).i28 = function (index, item) {
    return this.p3d(index, item instanceof OtNode ? item : THROW_CCE());
  };
  protoOf(ChildrenObservableList).q3d = function (index, item, success) {
    if (!success)
      return Unit_instance;
    try {
      attachItemFinish(this, item, index);
    }finally {
      setEventInProgress_0(this.c3d_1, false);
    }
  };
  protoOf(ChildrenObservableList).l28 = function (index, item, success) {
    return this.q3d(index, item instanceof OtNode ? item : THROW_CCE(), success);
  };
  protoOf(ChildrenObservableList).r3d = function (index, oldItem, newItem) {
    detachItemStart(this, oldItem);
    attachItemStart(this, newItem, index - 1 | 0, index + 1 | 0);
  };
  protoOf(ChildrenObservableList).n28 = function (index, oldItem, newItem) {
    var tmp = oldItem instanceof OtNode ? oldItem : THROW_CCE();
    return this.r3d(index, tmp, newItem instanceof OtNode ? newItem : THROW_CCE());
  };
  protoOf(ChildrenObservableList).s3d = function (index, oldItem, newItem, success) {
    if (!success)
      return Unit_instance;
    try {
      detachAndAttachItemsFinish(this, oldItem, newItem, index);
    }finally {
      setEventInProgress_0(this.c3d_1, false);
    }
  };
  protoOf(ChildrenObservableList).q28 = function (index, oldItem, newItem, success) {
    var tmp = oldItem instanceof OtNode ? oldItem : THROW_CCE();
    return this.s3d(index, tmp, newItem instanceof OtNode ? newItem : THROW_CCE(), success);
  };
  protoOf(ChildrenObservableList).t3d = function (index, item) {
    return detachItemStart(this, item);
  };
  protoOf(ChildrenObservableList).s28 = function (index, item) {
    return this.t3d(index, item instanceof OtNode ? item : THROW_CCE());
  };
  protoOf(ChildrenObservableList).u3d = function (index, item, success) {
    if (!success)
      return Unit_instance;
    try {
      detachItemFinish(this, item, index);
    }finally {
      setEventInProgress_0(this.c3d_1, false);
    }
  };
  protoOf(ChildrenObservableList).u28 = function (index, item, success) {
    return this.u3d(index, item instanceof OtNode ? item : THROW_CCE(), success);
  };
  function Companion_43() {
  }
  protoOf(Companion_43).p3a = function (conceptId) {
    return conceptId.i3c() ? new NodeId() : null;
  };
  var Companion_instance_43;
  function Companion_getInstance_43() {
    return Companion_instance_43;
  }
  function OtNode$deepChangeListeners$1(this$0) {
    this.w3d_1 = this$0;
    EventHandlerListeners.call(this);
  }
  protoOf(OtNode$deepChangeListeners$1).w27 = function () {
    this.w3d_1.i38_1 = null;
  };
  function OtNode$copy$nodeCopier$1($preserveIds) {
    this.x3d_1 = $preserveIds;
    NodeCopier.call(this);
  }
  protoOf(OtNode$copy$nodeCopier$1).r3c = function (node) {
    var newNode = this.x3d_1 && node.w39() ? node.c3b(node.v39()) : this.x3d_1 && !node.w39() ? node.c3b(null) : node.d3b();
    return newNode;
  };
  function OtNode$descendants$slambda($includeSelf, this$0, resultContinuation) {
    this.g3e_1 = $includeSelf;
    this.h3e_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OtNode$descendants$slambda).o3e = function ($this$sequence, $completion) {
    var tmp = this.p3e($this$sequence, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OtNode$descendants$slambda).oa = function (p1, $completion) {
    return this.o3e(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OtNode$descendants$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 8;
            if (this.g3e_1) {
              this.y9_1 = 1;
              suspendResult = this.i3e_1.lh(this.h3e_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 1:
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.j3e_1 = this.h3e_1.v2z().k();
            this.y9_1 = 3;
            continue $sm;
          case 3:
            if (!this.j3e_1.l()) {
              this.y9_1 = 7;
              continue $sm;
            }

            this.k3e_1 = this.j3e_1.m();
            this.l3e_1 = this.h3e_1.l38(this.k3e_1);
            this.m3e_1 = this.l3e_1.k();
            this.y9_1 = 4;
            continue $sm;
          case 4:
            if (!this.m3e_1.l()) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.n3e_1 = this.m3e_1.m();
            this.y9_1 = 5;
            suspendResult = this.i3e_1.nh(this.n3e_1.o3b(true), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.y9_1 = 4;
            continue $sm;
          case 6:
            this.y9_1 = 3;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 8) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(OtNode$descendants$slambda).p3e = function ($this$sequence, completion) {
    var i = new OtNode$descendants$slambda(this.g3e_1, this.h3e_1, completion);
    i.i3e_1 = $this$sequence;
    return i;
  };
  function OtNode$descendants$slambda_0($includeSelf, this$0, resultContinuation) {
    var i = new OtNode$descendants$slambda($includeSelf, this$0, resultContinuation);
    var l = function ($this$sequence, $completion) {
      return i.o3e($this$sequence, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function OtNode$allChildren$slambda(this$0, resultContinuation) {
    this.y3e_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OtNode$allChildren$slambda).o3e = function ($this$sequence, $completion) {
    var tmp = this.p3e($this$sequence, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OtNode$allChildren$slambda).oa = function (p1, $completion) {
    return this.o3e(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OtNode$allChildren$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            this.a3f_1 = this.y3e_1.v2z().k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.a3f_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.b3f_1 = this.a3f_1.m();
            this.c3f_1 = this.y3e_1.l38(this.b3f_1);
            this.d3f_1 = this.c3f_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.d3f_1.l()) {
              this.y9_1 = 4;
              continue $sm;
            }

            this.e3f_1 = this.d3f_1.m();
            this.y9_1 = 3;
            suspendResult = this.z3e_1.lh(this.e3f_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.y9_1 = 2;
            continue $sm;
          case 4:
            this.y9_1 = 1;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(OtNode$allChildren$slambda).p3e = function ($this$sequence, completion) {
    var i = new OtNode$allChildren$slambda(this.y3e_1, completion);
    i.z3e_1 = $this$sequence;
    return i;
  };
  function OtNode$allChildren$slambda_0(this$0, resultContinuation) {
    var i = new OtNode$allChildren$slambda(this$0, resultContinuation);
    var l = function ($this$sequence, $completion) {
      return i.o3e($this$sequence, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function OtNode$insertInProperty$lambda(this$0, $propertyId, $newProperty) {
    return function () {
      this$0.h39($propertyId, $newProperty);
      return Unit_instance;
    };
  }
  function OtNode$deleteInProperty$lambda(this$0, $propertyId, $newProperty) {
    return function () {
      this$0.h39($propertyId, $newProperty);
      return Unit_instance;
    };
  }
  function OtNode$addChildAndSplitProperty$lambda($source, $propertyId, $newValue, $child, $movedText, $list, $index) {
    return function () {
      $source.h39($propertyId, $newValue);
      $child.h39($propertyId, $movedText);
      $list.p2($index, $child);
      return Unit_instance;
    };
  }
  function OtNode$addChildAndSplitChildCollection$lambda($list, $index, $child, $collectionId, $sourceChildren, $splitIndex) {
    return function () {
      $list.p2($index, $child);
      var newChildren = $child.l38($collectionId);
      var iterator = $sourceChildren.i2();
      var inductionVariable = 0;
      var tmp;
      if (inductionVariable < $splitIndex) {
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          iterator.m();
        }
         while (inductionVariable < $splitIndex);
        tmp = Unit_instance;
      }
      $child.j38_1 = true;
      var tmp_0;
      try {
        while (iterator.l()) {
          var node = iterator.m();
          iterator.b5();
          newChildren.e(node);
        }
        tmp_0 = Unit_instance;
      }finally {
        $child.j38_1 = false;
      }
      return Unit_instance;
    };
  }
  function OtNode$mergePropertyAndRemoveChild$lambda($data, $propertyId, $resultProperty) {
    return function () {
      $data.e3d_1.q2($data.f3d_1);
      $data.g3d_1.h39($propertyId, $resultProperty);
      return Unit_instance;
    };
  }
  function OtNode$mergeChildCollectionAndRemoveChild$lambda($childCollection, $data, $targetCollection) {
    return function () {
      var copy = ArrayList_init_$Create$_1($childCollection);
      $childCollection.m2();
      $data.g3d_1.j38_1 = true;
      var tmp;
      try {
        var _iterator__ex2g4s = copy.k();
        while (_iterator__ex2g4s.l()) {
          var node = _iterator__ex2g4s.m();
          $targetCollection.e(node);
        }
        tmp = Unit_instance;
      }finally {
        $data.g3d_1.j38_1 = false;
      }
      $data.e3d_1.q2($data.f3d_1);
      return Unit_instance;
    };
  }
  function OtNode$addPropertyHandler$$inlined$eventHandler$1($propertyId, $handler) {
    this.f3f_1 = $propertyId;
    this.g3f_1 = $handler;
  }
  protoOf(OtNode$addPropertyHandler$$inlined$eventHandler$1).e2b = function (event) {
    var tmp;
    if (event.t3c_1.equals(this.f3f_1)) {
      this.g3f_1.d28(event.u3c_1);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(OtNode$addPropertyHandler$$inlined$eventHandler$1).d28 = function (event) {
    return this.e2b((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function OtNode(conceptId, nodeId) {
    this.a38_1 = conceptId;
    this.c38_1 = null;
    this.d38_1 = new DelayedValueProperty();
    this.e38_1 = null;
    this.f38_1 = null;
    this.g38_1 = null;
    this.h38_1 = null;
    this.i38_1 = null;
    this.j38_1 = false;
    validateNodeId(Companion_instance_43, nodeId, this.a38_1);
    this.b38_1 = nodeId;
  }
  protoOf(OtNode).h3f = function () {
    return this.a38_1;
  };
  protoOf(OtNode).w39 = function () {
    return this.a38_1.i3c();
  };
  protoOf(OtNode).v39 = function () {
    if (!this.w39()) {
      throw UnsupportedOperationException_init_$Create$_0(nodeCannotHaveIdMessage(Companion_instance_43, this.a38_1));
    }
    var tmp0 = this.b38_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.<get-id>.<anonymous>' call
        var message = expectedNodeIdMessage(Companion_instance_43, this.a38_1);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    return tmp$ret$1;
  };
  protoOf(OtNode).h3a = function () {
    return this.v39().i2s_1;
  };
  protoOf(OtNode).i3a = function (model) {
    // Inline function 'kotlin.check' call
    if (!(!this.g3b() || model == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.<set-model>.<anonymous>' call
      var message = 'Attempt to register node though it already has a model';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.c38_1 = model;
  };
  protoOf(OtNode).i3f = function () {
    return this.c38_1;
  };
  protoOf(OtNode).g3b = function () {
    return !(this.c38_1 == null);
  };
  protoOf(OtNode).f33 = function () {
    return this.d38_1;
  };
  protoOf(OtNode).z39 = function () {
    return this.d38_1.qr();
  };
  protoOf(OtNode).h3b = function () {
    return this.e38_1;
  };
  protoOf(OtNode).i3b = function () {
    var tmp0_safe_receiver = this.z39();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l38(ensureNotNull(this.h3b()));
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.t(this);
    return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
  };
  protoOf(OtNode).j3b = function () {
    return this.f38_1;
  };
  protoOf(OtNode).k3b = function () {
    return this.g38_1;
  };
  protoOf(OtNode).d3b = function (nodeId, $super) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(this.a38_1) : nodeId;
    return $super === VOID ? this.c3b(nodeId) : $super.c3b.call(this, nodeId);
  };
  protoOf(OtNode).l3b = function (preserveIds) {
    var nodeCopier = new OtNode$copy$nodeCopier$1(preserveIds);
    return nodeCopier.s3c(this);
  };
  protoOf(OtNode).m3b = function (preserveIds, $super) {
    preserveIds = preserveIds === VOID ? false : preserveIds;
    return $super === VOID ? this.l3b(preserveIds) : $super.l3b.call(this, preserveIds);
  };
  protoOf(OtNode).d3a = function () {
    return this.l3b(true);
  };
  protoOf(OtNode).n3b = function () {
    checkCanModify_0(this);
    var tmp0_elvis_lhs = this.z39();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'OtNode has no parent';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    var siblings = parent.l38(ensureNotNull(this.h3b()));
    siblings.k2(this);
  };
  protoOf(OtNode).o3b = function (includeSelf) {
    return sequence(OtNode$descendants$slambda_0(includeSelf, this, null));
  };
  protoOf(OtNode).p3b = function () {
    return sequence(OtNode$allChildren$slambda_0(this, null));
  };
  protoOf(OtNode).z38 = function (propertyId) {
    return new MyProperty(this, propertyId);
  };
  protoOf(OtNode).k38 = function (propertyId, value) {
    // Inline function 'kotlin.check' call
    if (!!_get_hasListeners__lk7hnq(this)) {
      // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.setValue.<anonymous>' call
      var message = "calling setValue is allowed only when there are no listeners since it doesn't produce events";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.e3b(propertyId, value, this.g39(propertyId));
  };
  protoOf(OtNode).l39 = function (propertyId, index, text) {
    checkCanModify_0(this);
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (text == null) {
        // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.insertInProperty.<anonymous>' call
        var message = "text shouldn't be null";
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0) {
      tmp = !(index === -1);
    } else {
      tmp = false;
    }
    if (tmp) {
      return Unit_instance;
    }
    var property = this.g39(propertyId);
    var stringIndex = index;
    if (property == null) {
      // Inline function 'kotlin.require' call
      if (!(index === -1)) {
        // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.insertInProperty.<anonymous>' call
        var message_0 = 'Use index=-1 to insert into null property';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      }
      property = '';
      stringIndex = 0;
    }
    // Inline function 'kotlin.require' call
    if (!(stringIndex >= 0)) {
      // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.insertInProperty.<anonymous>' call
      var message_1 = 'Negative index, value=' + stringIndex;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.require' call
    if (!(property.length >= stringIndex)) {
      // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.insertInProperty.<anonymous>' call
      var message_2 = 'Insert index=' + stringIndex + ", property value='" + property + "', length=" + property.length;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
    }
    var tmp_0 = take_1(property, stringIndex) + text;
    var tmp5 = property;
    // Inline function 'kotlin.text.substring' call
    var startIndex = stringIndex;
    // Inline function 'kotlin.js.asDynamic' call
    var newProperty = tmp_0 + tmp5.substring(startIndex);
    executeAtomicChanges(this, OtNode$insertInProperty$lambda(this, propertyId, newProperty));
    fire_1(this, new NodeInsertedInPropertyEvent(this, propertyId, index, text));
  };
  protoOf(OtNode).n39 = function (propertyId, index, length) {
    checkCanModify_0(this);
    if (length === 0 && !(index === -1)) {
      return Unit_instance;
    }
    var property = this.g39(propertyId);
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (property == null) {
        // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.deleteInProperty.<anonymous>' call
        var message = "Null property value: id='" + propertyId.toString() + "'";
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var stringIndex = index;
    if (index === -1) {
      // Inline function 'kotlin.require' call
      if (!(property.length === length)) {
        // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.deleteInProperty.<anonymous>' call
        var message_0 = 'Incorrect delete to null';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      }
      stringIndex = 0;
    } else {
      // Inline function 'kotlin.require' call
      if (!(stringIndex >= 0)) {
        // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.deleteInProperty.<anonymous>' call
        var message_1 = 'Negative index, value=' + stringIndex;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
      }
      // Inline function 'kotlin.require' call
      if (!(length >= 0)) {
        // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.deleteInProperty.<anonymous>' call
        var message_2 = 'Negative length, value=' + length;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_2));
      }
    }
    // Inline function 'kotlin.require' call
    if (!(property.length >= (stringIndex + length | 0))) {
      // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.deleteInProperty.<anonymous>' call
      var message_3 = "Delete range is out of bounds: property value='" + property + "', delete at " + stringIndex + ', length=' + length;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_3));
    }
    var tmp;
    if (index === -1) {
      tmp = null;
    } else {
      var tmp_0 = take_1(property, stringIndex);
      // Inline function 'kotlin.text.substring' call
      var startIndex = stringIndex + length | 0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp = tmp_0 + property.substring(startIndex);
    }
    var newProperty = tmp;
    executeAtomicChanges(this, OtNode$deleteInProperty$lambda(this, propertyId, newProperty));
    var tmp8 = stringIndex;
    // Inline function 'kotlin.text.substring' call
    var endIndex = stringIndex + length | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = property.substring(tmp8, endIndex);
    var event = new NodeDeletedInPropertyEvent(this, propertyId, index, tmp$ret$9);
    fire_1(this, event);
  };
  protoOf(OtNode).q3b = function (with_0) {
    checkCanModify_0(this);
    var parent = this.z39();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (parent == null) {
        // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.replace.<anonymous>' call
        var message = 'Replace root node is inapplicable';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var siblings = parent.l38(ensureNotNull(this.h3b()));
    var index = siblings.t(this);
    siblings.o2(index, with_0);
  };
  protoOf(OtNode).r3b = function (role, index, propertyId, splitIndex) {
    var list = this.l38(role);
    checkIndex(this, index, list);
    var sourceNode = list.q(index - 1 | 0);
    var node = sourceNode.d3b();
    var splitIndexParam = sourceNode.z38(propertyId).qr() == null && splitIndex === 0 ? -1 : splitIndex;
    this.s3b(node, role, index, propertyId, splitIndexParam);
    return node;
  };
  protoOf(OtNode).s3b = function (child, role, index, propertyId, splitIndex) {
    var list = this.l38(role);
    var source = getChildNodeToSplit(this, child, index, list);
    var property = source.g39(propertyId);
    var nullProperty = property == null;
    var stringSplitIndex = splitIndex;
    if (nullProperty) {
      // Inline function 'kotlin.require' call
      if (!(splitIndex === -1)) {
        // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.addChildAndSplitProperty.<anonymous>' call
        var message = 'Use splitIndex=-1 to split null property';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      property = '';
    }
    if (splitIndex === -1) {
      stringSplitIndex = 0;
    }
    if (stringSplitIndex < 0 || ensureNotNull(property).length < stringSplitIndex) {
      throw IllegalArgumentException_init_$Create$_0('Split index=' + stringSplitIndex + ", property value='" + property + "', length=" + ensureNotNull(property).length);
    }
    var newValue = splitIndex === -1 ? null : take_1(property, stringSplitIndex);
    var tmp1 = property;
    // Inline function 'kotlin.text.substring' call
    var startIndex = stringSplitIndex;
    // Inline function 'kotlin.js.asDynamic' call
    var movedText = tmp1.substring(startIndex);
    executeAtomicChanges(this, OtNode$addChildAndSplitProperty$lambda(source, propertyId, newValue, child, movedText, list, index));
    var tmp;
    if (nullProperty) {
      tmp = new NodeChildAddedEvent(this, role, index, child);
    } else {
      tmp = new NodeChildAddedPropertySplitEvent(this, role, index, child, source, splitIndex, propertyId, movedText);
    }
    var nodeEvent = tmp;
    fire_1(this, nodeEvent);
  };
  protoOf(OtNode).t3b = function (child, role, index, collectionId, splitIndex) {
    var list = this.l38(role);
    var source = getChildNodeToSplit(this, child, index, list);
    var sourceChildren = source.l38(collectionId);
    // Inline function 'kotlin.require' call
    if (!(0 <= splitIndex && splitIndex <= sourceChildren.n())) {
      // Inline function 'jetbrains.ocelot.ot.model.node.OtNode.addChildAndSplitChildCollection.<anonymous>' call
      var interval = new Interval(0, sourceChildren.n());
      var message = indexOutOfBoundsMessage(Companion_instance_43, 'Split', splitIndex, interval);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var splitSize = sourceChildren.n() - splitIndex | 0;
    executeAtomicChanges(this, OtNode$addChildAndSplitChildCollection$lambda(list, index, child, collectionId, sourceChildren, splitIndex));
    var event = new NodeChildAddedChildCollectionSplitEvent(this, role, index, child, source, splitIndex, collectionId, splitSize);
    fire_1(this, event);
  };
  protoOf(OtNode).u3b = function (child, propertyId) {
    var mergeNull = false;
    checkCanModify_0(this);
    var data = new RemoveChildOperationData(this, child);
    var mergedProperty = child.z38(propertyId).qr();
    if (mergedProperty == null) {
      mergeNull = true;
      mergedProperty = '';
    }
    var targetProperty = data.g3d_1.z38(propertyId).qr();
    var nullTarget = targetProperty == null;
    if (nullTarget) {
      targetProperty = '';
    }
    var resultProperty = mergeNull && nullTarget ? null : ensureNotNull(targetProperty) + mergedProperty;
    executeAtomicChanges(this, OtNode$mergePropertyAndRemoveChild$lambda(data, propertyId, resultProperty));
    var tmp;
    if (mergeNull) {
      tmp = new NodeChildRemovedEvent(this, data.d3d_1, data.f3d_1, child);
    } else {
      var targetLength = nullTarget ? -1 : ensureNotNull(targetProperty).length;
      tmp = new NodePropertyMergedChildRemovedEvent(this, data.d3d_1, data.f3d_1, child, data.g3d_1, targetLength, propertyId, mergedProperty);
    }
    var event = tmp;
    fire_1(this, event);
  };
  protoOf(OtNode).v3b = function (child, collectionId) {
    checkCanModify_0(this);
    var data = new RemoveChildOperationData(this, child);
    var childCollection = child.l38(collectionId);
    var targetCollection = data.g3d_1.l38(collectionId);
    var childLength = childCollection.n();
    var targetLength = targetCollection.n();
    executeAtomicChanges(this, OtNode$mergeChildCollectionAndRemoveChild$lambda(childCollection, data, targetCollection));
    var event = new NodeChildCollectionMergedChildRemovedEvent(this, data.d3d_1, data.f3d_1, child, data.g3d_1, targetLength, collectionId, childLength);
    fire_1(this, event);
  };
  protoOf(OtNode).w3b = function (event) {
    setEventInProgress_0(this, true);
    if (this.g3b()) {
      ensureNotNull(this.c38_1).a3a(event.k27());
    }
  };
  protoOf(OtNode).c27 = function (event) {
    return this.w3b(event);
  };
  protoOf(OtNode).x3b = function (event) {
    setEventInProgress_0(this, true);
    if (this.g3b()) {
      ensureNotNull(this.c38_1).j3a(event.i27());
      ensureNotNull(this.c38_1).a3a(event.k27());
    }
  };
  protoOf(OtNode).d27 = function (event) {
    return this.x3b(event);
  };
  protoOf(OtNode).y3b = function (event) {
    setEventInProgress_0(this, true);
    if (this.g3b()) {
      ensureNotNull(this.c38_1).j3a(event.i27());
    }
  };
  protoOf(OtNode).j27 = function (event) {
    return this.y3b(event);
  };
  protoOf(OtNode).toString = function () {
    var className = getKClassFromExpression(this).lb();
    var tmp;
    if (className == null) {
      tmp = '<anonymous concept>';
    } else {
      var dotIndex = lastIndexOf_2(className, _Char___init__impl__6a9atx(46));
      var tmp_0;
      if (dotIndex === -1) {
        tmp_0 = className;
      } else {
        // Inline function 'kotlin.text.substring' call
        var startIndex = dotIndex + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = className.substring(startIndex);
      }
      tmp = tmp_0;
    }
    var prettyClassName = tmp;
    var hashCode_0 = toString_3(hashCode(this), 16);
    return prettyClassName + '@' + hashCode_0 + '[conceptId=' + this.a38_1.toString() + ', id=' + toString_0(this.b38_1) + ']';
  };
  protoOf(OtNode).h39 = function (propertyId, value) {
    checkCanModify_0(this);
    var oldValue = this.g39(propertyId);
    if (this.e3b(propertyId, value, oldValue)) {
      return Unit_instance;
    }
    setEventInProgress_0(this, true);
    try {
      if (this.g3b()) {
        var nodeEvent = new NodePropertySetEvent(this, propertyId, oldValue, value);
        onNodeChanged(this, nodeEvent);
      }
      if (_get_arePropertyListenersInitialized__tb7xlf(this)) {
        var propertyChangeEvent = new PropertyChangeEvent(oldValue, value);
        var event = new NodePropertyChangeEvent(propertyId, propertyChangeEvent);
        _get_propertyListeners__yg2t9j(this).c2b(event);
      }
    }finally {
      setEventInProgress_0(this, false);
    }
  };
  protoOf(OtNode).i39 = function (propertyId, handler) {
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var listener = new OtNode$addPropertyHandler$$inlined$eventHandler$1(propertyId, handler);
    return _get_propertyListeners__yg2t9j(this).z27(listener);
  };
  function OtNodeFactory() {
  }
  function PropertyEventHandlerWrapper(handler, persister) {
    this.k3f_1 = handler;
    this.l3f_1 = persister;
  }
  protoOf(PropertyEventHandlerWrapper).m3f = function (event) {
    var oldValue = this.l3f_1.q2q(event.o2e_1);
    var newValue = this.l3f_1.q2q(event.p2e_1);
    if (!equals(oldValue, newValue)) {
      this.k3f_1.d28(new PropertyChangeEvent(oldValue, newValue));
    }
  };
  protoOf(PropertyEventHandlerWrapper).d28 = function (event) {
    return this.m3f(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  function RawNodeFactory() {
  }
  protoOf(RawNodeFactory).z37 = function (conceptId, nodeId) {
    return new Node_0(conceptId, nodeId);
  };
  var RawNodeFactory_instance;
  function RawNodeFactory_getInstance() {
    return RawNodeFactory_instance;
  }
  function ModelAdapter() {
  }
  protoOf(ModelAdapter).h34 = function (event) {
  };
  protoOf(ModelAdapter).i34 = function (event) {
    return this.h34(event);
  };
  protoOf(ModelAdapter).j34 = function (event) {
    return this.h34(event);
  };
  protoOf(ModelAdapter).k34 = function (event) {
    return this.h34(event);
  };
  protoOf(ModelAdapter).l34 = function (event) {
    return this.h34(event);
  };
  protoOf(ModelAdapter).m34 = function (event) {
    return this.h34(event);
  };
  protoOf(ModelAdapter).n34 = function (event) {
    return this.h34(event);
  };
  protoOf(ModelAdapter).o34 = function (event) {
    return this.h34(event);
  };
  protoOf(ModelAdapter).p34 = function (event) {
    return this.h34(event);
  };
  protoOf(ModelAdapter).q34 = function (event) {
    return this.h34(event);
  };
  protoOf(ModelAdapter).r34 = function (event) {
    return this.h34(event);
  };
  function ModelListener() {
  }
  function NodeChildAddedChildCollectionSplitEvent(node, role, index, child, sourceNode, splitIndex, childId, splitSize) {
    NodeChildEvent.call(this, node, role, index, child);
    this.r3f_1 = sourceNode;
    this.s3f_1 = splitIndex;
    this.t3f_1 = childId;
    this.u3f_1 = splitSize;
  }
  protoOf(NodeChildAddedChildCollectionSplitEvent).v3f = function (listener) {
    listener.o34(this);
  };
  protoOf(NodeChildAddedChildCollectionSplitEvent).m27 = function (listener) {
    return this.v3f((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeChildAddedEvent(node, role, index, child) {
    NodeChildEvent.call(this, node, role, index, child);
  }
  protoOf(NodeChildAddedEvent).v3f = function (listener) {
    return listener.j34(this);
  };
  protoOf(NodeChildAddedEvent).m27 = function (listener) {
    return this.v3f((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeChildAddedPropertySplitEvent(node, role, index, child, sourceNode, splitIndex, propertyId, movedText) {
    NodeChildEvent.call(this, node, role, index, child);
    this.e3g_1 = sourceNode;
    this.f3g_1 = splitIndex;
    this.g3g_1 = propertyId;
    this.h3g_1 = movedText;
  }
  protoOf(NodeChildAddedPropertySplitEvent).v3f = function (listener) {
    listener.m34(this);
  };
  protoOf(NodeChildAddedPropertySplitEvent).m27 = function (listener) {
    return this.v3f((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeChildCollectionMergedChildRemovedEvent(node, role, index, child, targetNode, targetLength, childId, removedLength) {
    NodeChildEvent.call(this, node, role, index, child);
    this.m3g_1 = targetNode;
    this.n3g_1 = targetLength;
    this.o3g_1 = childId;
    this.p3g_1 = removedLength;
  }
  protoOf(NodeChildCollectionMergedChildRemovedEvent).v3f = function (listener) {
    listener.p34(this);
  };
  protoOf(NodeChildCollectionMergedChildRemovedEvent).m27 = function (listener) {
    return this.v3f((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeChildEvent(node, role, index, child) {
    NodeEvent.call(this, node);
    this.r3g_1 = role;
    this.s3g_1 = index;
    this.t3g_1 = child;
  }
  function NodeChildRemovedEvent(node, role, index, child) {
    NodeChildEvent.call(this, node, role, index, child);
  }
  protoOf(NodeChildRemovedEvent).v3f = function (listener) {
    listener.k34(this);
  };
  protoOf(NodeChildRemovedEvent).m27 = function (listener) {
    return this.v3f((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeChildSetEvent(node, role, index, oldChild, newChild) {
    NodeChildEvent.call(this, node, role, index, newChild);
    this.c3h_1 = oldChild;
  }
  protoOf(NodeChildSetEvent).d3h = function () {
    return this.t3g_1;
  };
  protoOf(NodeChildSetEvent).v3f = function (listener) {
    listener.l34(this);
  };
  protoOf(NodeChildSetEvent).m27 = function (listener) {
    return this.v3f((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeDeletedInPropertyEvent(node, propertyId, index, text) {
    NodePropertyChangedEvent.call(this, node, propertyId, index, text);
  }
  protoOf(NodeDeletedInPropertyEvent).v3f = function (listener) {
    listener.r34(this);
  };
  protoOf(NodeDeletedInPropertyEvent).m27 = function (listener) {
    return this.v3f((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeEvent(node) {
    this.i3h_1 = node;
  }
  protoOf(NodeEvent).toString = function () {
    return 'node=' + this.i3h_1.toString();
  };
  function NodeInsertedInPropertyEvent(node, propertyId, index, text) {
    NodePropertyChangedEvent.call(this, node, propertyId, index, text);
  }
  protoOf(NodeInsertedInPropertyEvent).v3f = function (listener) {
    listener.q34(this);
  };
  protoOf(NodeInsertedInPropertyEvent).m27 = function (listener) {
    return this.v3f((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodePropertyChangedEvent(node, propertyId, index, text) {
    NodeEvent.call(this, node);
    this.o3h_1 = propertyId;
    this.p3h_1 = index;
    this.q3h_1 = text;
  }
  function NodePropertyMergedChildRemovedEvent(node, role, index, child, targetNode, targetLength, propertyId, mergedText) {
    NodeChildEvent.call(this, node, role, index, child);
    this.v3h_1 = targetNode;
    this.w3h_1 = targetLength;
    this.x3h_1 = propertyId;
    this.y3h_1 = mergedText;
  }
  protoOf(NodePropertyMergedChildRemovedEvent).v3f = function (listener) {
    listener.n34(this);
  };
  protoOf(NodePropertyMergedChildRemovedEvent).m27 = function (listener) {
    return this.v3f((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodePropertySetEvent(node, propertyId, oldValue, newValue) {
    NodeEvent.call(this, node);
    this.a3i_1 = propertyId;
    this.b3i_1 = oldValue;
    this.c3i_1 = newValue;
  }
  protoOf(NodePropertySetEvent).v3f = function (listener) {
    return listener.i34(this);
  };
  protoOf(NodePropertySetEvent).m27 = function (listener) {
    return this.v3f((!(listener == null) ? isInterface(listener, ModelListener) : false) ? listener : THROW_CCE());
  };
  function NodeUtil() {
  }
  protoOf(NodeUtil).d3i = function (conceptId, id) {
    var hasId = !(id == null);
    return conceptId.i3c() === hasId;
  };
  protoOf(NodeUtil).e3i = function (node, id) {
    var tmp;
    if (node.w39()) {
      tmp = node.v39();
    } else {
      tmp = null;
    }
    var nodeId = tmp;
    return equals(id, nodeId);
  };
  protoOf(NodeUtil).f3i = function (node1, node2) {
    var tmp;
    if (!(node1.w39() === node2.w39())) {
      tmp = false;
    } else if (node1.w39()) {
      tmp = node1.v39().equals(node2.v39());
    } else {
      tmp = true;
    }
    return tmp;
  };
  protoOf(NodeUtil).g3i = function (lhs, rhs) {
    return lhs === rhs || this.h3i(lhs, rhs);
  };
  protoOf(NodeUtil).h3i = function (lhs, rhs) {
    return !(lhs == null) && equals(lhs, rhs);
  };
  protoOf(NodeUtil).y38 = function (node) {
    return node.w39() ? node.v39() : null;
  };
  var NodeUtil_instance;
  function NodeUtil_getInstance() {
    return NodeUtil_instance;
  }
  function index_0($this, node, registry) {
    if (node.w39()) {
      // Inline function 'kotlin.collections.set' call
      var key = node.v39();
      registry.r2(key, node);
      var _iterator__ex2g4s = node.v2z().k();
      while (_iterator__ex2g4s.l()) {
        var role = _iterator__ex2g4s.m();
        var _iterator__ex2g4s_0 = node.l38(role).k();
        while (_iterator__ex2g4s_0.l()) {
          var child = _iterator__ex2g4s_0.m();
          index_0($this, child, registry);
        }
      }
    }
  }
  function Nodes() {
    this.i3i_1 = '  ';
  }
  protoOf(Nodes).j3i = function (subtreeRoot) {
    var tmp;
    if (subtreeRoot.w39()) {
      tmp = this.k3i(subtreeRoot).u2();
    } else {
      tmp = emptySet();
    }
    return tmp;
  };
  protoOf(Nodes).k3i = function (subtreeRoot) {
    var registry = HashMap_init_$Create$();
    index_0(this, subtreeRoot, registry);
    return registry;
  };
  var Nodes_instance;
  function Nodes_getInstance() {
    return Nodes_instance;
  }
  function findAddRemoveOperations($this, op) {
    if (isInterface(op, OperationContainer)) {
      var _iterator__ex2g4s = (isInterface(op, OperationContainer) ? op : THROW_CCE()).l3i().k();
      while (_iterator__ex2g4s.l()) {
        var childOp = _iterator__ex2g4s.m();
        findAddRemoveOperations($this, childOp);
      }
      return Unit_instance;
    }
    checkRemoveOperation($this, op);
    checkAddOperation($this, op);
  }
  function checkRemoveOperation($this, op) {
    var id = null;
    if (op instanceof RemoveRootOperation) {
      id = op.o3i();
    }
    if (op instanceof RemoveChildOperation) {
      id = op.r3i();
    }
    if (op instanceof RemoveChildOperation_0) {
      id = op.x3i();
    }
    if (!(id == null)) {
      $this.y3i_1.e(id);
    }
  }
  function checkAddOperation($this, op) {
    var id = null;
    var conceptId = null;
    if (op instanceof AddRootOperation) {
      id = op.o3i();
      conceptId = op.h3f();
    }
    if (op instanceof AddChildOperation) {
      id = op.r3i();
      conceptId = op.h3f();
    }
    if (op instanceof AddChildOperation_0) {
      id = op.x3i();
      conceptId = op.h3f();
    }
    if (!(id == null) && $this.y3i_1.s(id)) {
      throw IllegalStateException_init_$Create$_0('Multiple add/remove inside command: id=' + toString_0(id) + ', conceptId=' + toString_0(conceptId));
    }
  }
  function AddRemoveConsistencyValidator() {
    this.y3i_1 = HashSet_init_$Create$();
  }
  protoOf(AddRemoveConsistencyValidator).z3i = function (operationRootId, op) {
    findAddRemoveOperations(this, op);
  };
  protoOf(AddRemoveConsistencyValidator).a3j = function () {
    this.y3i_1.m2();
  };
  function Companion_44() {
    Companion_instance_44 = this;
    this.b3j_1 = Companion_getInstance_47().c3j_1;
  }
  var Companion_instance_44;
  function Companion_getInstance_44() {
    if (Companion_instance_44 == null)
      new Companion_44();
    return Companion_instance_44;
  }
  function EntityContextCommandProcessor$o$_init_$lambda_6ce6sz(this$0) {
    return function () {
      return !this$0.o3j_1;
    };
  }
  function _get_resultOp__5l2s0j($this) {
    if ($this.q3j_1 == null || ensureNotNull($this.r3j_1).p()) {
      return null;
    }
    var meaningfulOps = ArrayList_init_$Create$();
    var _iterator__ex2g4s = ensureNotNull($this.r3j_1).k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      if (!op.t3j()) {
        meaningfulOps.e(op);
      }
    }
    var size = meaningfulOps.n();
    if (size === 0)
      return null;
    if (size === 1)
      return meaningfulOps.q(0);
    var operation = $this.e3j_1.u3j(meaningfulOps);
    return operation.t3j() ? null : operation;
  }
  function isFatal($this, t) {
    if (t instanceof OtException) {
      return true;
    }
    if (t instanceof ThrowableCollectionException) {
      var _iterator__ex2g4s = t.d2m().k();
      while (_iterator__ex2g4s.l()) {
        var childT = _iterator__ex2g4s.m();
        if (isFatal($this, childT)) {
          return true;
        }
      }
    }
    return !(t.cause == null) && isFatal($this, ensureNotNull(t.cause));
  }
  function addThrowableHandler($this) {
    if ($this.m3j_1 == null) {
      var tmp = $this;
      var tmp_0 = ThrowableHandlers_getInstance().ps_1;
      tmp.m3j_1 = tmp_0.js(EntityContextCommandProcessor$addThrowableHandler$lambda($this));
    }
  }
  function operationHappened($this, op) {
    if (!$this.n3j_1) {
      throw OtException_init_$Create$_0('Each operation must be performed inside command, op=' + toString_1(op));
    }
    var operationRootId;
    try {
      operationRootId = validate_0($this, op);
    } catch ($p) {
      if ($p instanceof Exception) {
        var e = $p;
        ensureNotNull($this.r3j_1).e(op);
        throw OtException_init_$Create$_1('Validation failed, op=' + EntityPrintOperationUtil_instance.v3j(op), e);
      } else {
        throw $p;
      }
    }
    if ($this.q3j_1 == null) {
      $this.q3j_1 = operationRootId;
    }
    if (!($this.q3j_1 == null)) {
      ensureNotNull($this.r3j_1).e(op);
    }
    $this.k3j_1.a28(EntityContextCommandProcessor$operationHappened$lambda(op));
  }
  function validate_0($this, op) {
    var info = OperationRootIdInfo_init_$Create$_0(op);
    if (!info.z3j()) {
      throw IllegalStateException_init_$Create$_0(info.y3j_1);
    }
    var operationRootId = info.x3j_1;
    if (!($this.q3j_1 == null) && !equals($this.q3j_1, operationRootId)) {
      var rootEntities = $this.d3j_1.c31_1;
      var r1 = rootEntities.w32(ensureNotNull($this.q3j_1));
      var r2 = rootEntities.w32(ensureNotNull(operationRootId));
      throw IllegalStateException_init_$Create$_0('[transaction must change only one root: root1=' + toString_0(r1) + ', root2=' + toString_0(r2) + ']');
    }
    fire_2($this, EntityContextCommandProcessor$validate$lambda(operationRootId, op));
    return ensureNotNull(operationRootId);
  }
  function fire_2($this, caller) {
    if ($this.s3j_1 == null)
      return Unit_instance;
    var _iterator__ex2g4s = ensureNotNull($this.s3j_1).k();
    while (_iterator__ex2g4s.l()) {
      var validator = _iterator__ex2g4s.m();
      caller(validator);
    }
  }
  function checkCanFinishCommand($this) {
    if (!$this.n3j_1) {
      throw OtException_init_$Create$_0('No command in progress');
    }
  }
  function finishCommand($this) {
    $this.n3j_1 = false;
    $this.q3j_1 = null;
    $this.r3j_1 = null;
    resetOperationValidators($this);
  }
  function resetOperationValidators($this) {
    try {
      fire_2($this, OperationValidator$reset$ref());
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().ps_1.os(t);
      } else {
        throw $p;
      }
    }
  }
  function executeOperation($this, op) {
    $this.p3j_1 = op;
    op.a3k($this.d3j_1, $this.g3j_1);
    $this.p3j_1 = null;
  }
  function transformThroughCurrentOperations($this, operation) {
    if ($this.r3j_1 == null)
      return operation;
    var newOp = operation;
    var rootId = OperationRootIdInfo_init_$Create$_0(operation).x3j_1;
    if (!(rootId == null) && equals(rootId, $this.q3j_1)) {
      newOp = transformOp($this, operation);
      $this.r3j_1 = transformCurrentOps($this, operation);
    }
    return newOp;
  }
  function transformOp($this, operation) {
    var currentOperation = operation;
    var _iterator__ex2g4s = ensureNotNull($this.r3j_1).k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      currentOperation = op.b3k(currentOperation, false);
    }
    return currentOperation;
  }
  function transformCurrentOps($this, operation) {
    var currentOperation = operation;
    var newOps = ArrayDeque_init_$Create$();
    var _iterator__ex2g4s = ensureNotNull($this.r3j_1).k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      var newOp = op.b3k(currentOperation, false);
      newOps.e(currentOperation.b3k(op, true));
      currentOperation = newOp;
    }
    return newOps;
  }
  function safeExecute($this, command) {
    $this.p3j_1 = null;
    try {
      command();
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        var tmp;
        if ($this.p3j_1 == null) {
          tmp = t;
        } else {
          var tmp_0 = LoggingUtils_instance;
          var tmp_1 = $this.p3j_1;
          var opString = tmp_0.u2y((tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE());
          tmp = RuntimeException_init_$Create$_1('Exception while executing operation\nop=' + opString, t);
        }
        var throwable = tmp;
        appendToCurrentError($this, throwable);
        ThrowableHandlers_getInstance().ps_1.os(throwable);
      } else {
        throw $p;
      }
    }
    finally {
      $this.p3j_1 = null;
    }
  }
  function handleCurrentThrowable($this, recoverable) {
    if ($this.c3k()) {
      if (!recoverable) {
        appendToGlobalError($this, ensureNotNull($this.j3j_1));
        $this.j3j_1 = null;
      }
      return false;
    }
    return true;
  }
  function checkNotInError($this) {
    if (!($this.j3j_1 == null)) {
      throw IllegalStateException_init_$Create$_1('Working with command in error, stored is cause', $this.j3j_1);
    }
  }
  function appendToCurrentError($this, t) {
    (new EntityContextCommandProcessor$appendToCurrentError$1($this)).d3k(t);
  }
  function appendToGlobalError($this, t) {
    if (!$this.f3j_1)
      return Unit_instance;
    (new EntityContextCommandProcessor$appendToGlobalError$1($this)).d3k(t);
  }
  function ErrorAppender() {
  }
  protoOf(ErrorAppender).d3k = function (t) {
    var v = this.y();
    if (v === t)
      return Unit_instance;
    if (v == null) {
      this.e3k(t);
    } else {
      if (v instanceof ThrowableCollectionException) {
        var throwables = v.d2m();
        if (!throwables.s(t)) {
          this.e3k(ThrowableCollectionException_init_$Create$(throwables));
        }
      } else {
        this.e3k(ThrowableCollectionException_init_$Create$(listOf_0([v, t])));
      }
    }
  };
  function MyEventStateHolder($outer) {
    this.h3k_1 = $outer;
    EventStateHolder.call(this);
    this.g3k_1 = false;
  }
  protoOf(MyEventStateHolder).a35 = function () {
    protoOf(EventStateHolder).a35.call(this);
    if (!this.h3k_1.n3j_1 && !this.h3k_1.o3j_1) {
      throw OtException_init_$Create$_0('Each operation must be performed inside command');
    }
  };
  protoOf(MyEventStateHolder).y34 = function (substitute) {
    // Inline function 'kotlin.check' call
    if (!this.g3k_1) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.command.MyEventStateHolder.checkCanBeReset.<anonymous>' call
      var message = 'Current context is already managed by some command processor. If you are serious, dispose the previous one first';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  function Companion_45() {
    Companion_instance_45 = this;
    this.i3k_1 = getLogger(getKClass(EntityContextCommandProcessor));
  }
  var Companion_instance_45;
  function Companion_getInstance_45() {
    if (Companion_instance_45 == null)
      new Companion_45();
    return Companion_instance_45;
  }
  function EntityContextCommandProcessor$1(this$0) {
    this.n3k_1 = this$0;
    EntityContextOperationsTracker.call(this, this$0.d3j_1, EntityContextCommandProcessor$o$_init_$lambda_6ce6sz(this$0));
  }
  protoOf(EntityContextCommandProcessor$1).o3k = function (op) {
    operationHappened(this.n3k_1, op);
  };
  function EntityContextCommandProcessor$addThrowableHandler$lambda(this$0) {
    return function (throwable) {
      var tmp;
      if ((this$0.n3j_1 || this$0.o3j_1) && isFatal(this$0, throwable)) {
        appendToCurrentError(this$0, throwable);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function EntityContextCommandProcessor$operationHappened$lambda($op) {
    return function (listener) {
      listener.t3k($op);
      return Unit_instance;
    };
  }
  function EntityContextCommandProcessor$validate$lambda($operationRootId, $op) {
    return function (validator) {
      validator.z3i(ensureNotNull($operationRootId), $op);
      return Unit_instance;
    };
  }
  function EntityContextCommandProcessor$addOperationValidator$$inlined$toDisposable$1(this$0, $validator) {
    this.u3k_1 = this$0;
    this.v3k_1 = $validator;
  }
  protoOf(EntityContextCommandProcessor$addOperationValidator$$inlined$toDisposable$1).vr = function () {
    ensureNotNull(this.u3k_1.s3j_1).k2(this.v3k_1);
    var tmp;
    if (ensureNotNull(this.u3k_1.s3j_1).p()) {
      this.u3k_1.s3j_1 = null;
      tmp = Unit_instance;
    }
    return tmp;
  };
  function EntityContextCommandProcessor$startCommand$lambda($event) {
    return function (listener) {
      listener.w3k($event);
      return Unit_instance;
    };
  }
  function EntityContextCommandProcessor$commitCommand$lambda($resultOp) {
    return function (listener) {
      listener.x3k($resultOp);
      return Unit_instance;
    };
  }
  function OperationValidator$reset$ref() {
    var l = function (p0) {
      p0.a3j();
      return Unit_instance;
    };
    l.callableName = 'reset';
    return l;
  }
  function OtCommandListener$onExternalOperationStarted$ref() {
    var l = function (p0) {
      p0.y3k();
      return Unit_instance;
    };
    l.callableName = 'onExternalOperationStarted';
    return l;
  }
  function EntityContextCommandProcessor$executeExternal$lambda(this$0, $op) {
    return function () {
      var transformedOp = transformThroughCurrentOperations(this$0, $op);
      executeOperation(this$0, transformedOp);
      return Unit_instance;
    };
  }
  function EntityContextCommandProcessor$executeExternal$lambda_0($op) {
    return function (listener) {
      listener.z3k($op);
      return Unit_instance;
    };
  }
  function OtCommandListener$onExternalOperationFailed$ref() {
    var l = function (p0) {
      p0.a3l();
      return Unit_instance;
    };
    l.callableName = 'onExternalOperationFailed';
    return l;
  }
  function EntityContextCommandProcessor$appendToCurrentError$1(this$0) {
    this.b3l_1 = this$0;
    ErrorAppender.call(this);
  }
  protoOf(EntityContextCommandProcessor$appendToCurrentError$1).e3k = function (t) {
    this.b3l_1.j3j_1 = t;
  };
  protoOf(EntityContextCommandProcessor$appendToCurrentError$1).y = function () {
    return this.b3l_1.j3j_1;
  };
  function EntityContextCommandProcessor$appendToGlobalError$1(this$0) {
    this.c3l_1 = this$0;
    ErrorAppender.call(this);
  }
  protoOf(EntityContextCommandProcessor$appendToGlobalError$1).e3k = function (t) {
    return this.c3l_1.h3j_1.t2c(t);
  };
  protoOf(EntityContextCommandProcessor$appendToGlobalError$1).y = function () {
    return this.c3l_1.h3j_1.qr();
  };
  function EntityContextCommandProcessor(model, merger, isErrorCollectingEnabled, enableAddRemoveValidator, nodeFactory) {
    Companion_getInstance_45();
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.d3j_1 = model;
    this.e3j_1 = merger;
    this.f3j_1 = isErrorCollectingEnabled;
    this.g3j_1 = nodeFactory;
    this.h3j_1 = new ValueProperty(null);
    this.j3j_1 = null;
    this.k3j_1 = new Listeners();
    this.m3j_1 = null;
    this.n3j_1 = false;
    this.o3j_1 = false;
    this.p3j_1 = null;
    this.q3j_1 = null;
    this.r3j_1 = null;
    this.s3j_1 = null;
    this.i3j_1 = new MyEventStateHolder(this);
    var tmp = this;
    tmp.l3j_1 = new EntityContextCommandProcessor$1(this);
    if (enableAddRemoveValidator) {
      this.d3l(new AddRemoveConsistencyValidator());
    }
  }
  protoOf(EntityContextCommandProcessor).e3l = function () {
    this.d3j_1.n33(this.i3j_1);
  };
  protoOf(EntityContextCommandProcessor).c3k = function () {
    return !(this.j3j_1 == null);
  };
  protoOf(EntityContextCommandProcessor).f3l = function (listener) {
    return this.k3j_1.z27(listener);
  };
  protoOf(EntityContextCommandProcessor).g3l = function (listener) {
    return this.f3l(listener);
  };
  protoOf(EntityContextCommandProcessor).d3l = function (validator) {
    if (this.s3j_1 == null) {
      this.s3j_1 = ArrayList_init_$Create$_0(1);
    }
    ensureNotNull(this.s3j_1).e(validator);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new EntityContextCommandProcessor$addOperationValidator$$inlined$toDisposable$1(this, validator);
  };
  protoOf(EntityContextCommandProcessor).vr = function () {
    if (!(this.m3j_1 == null)) {
      ensureNotNull(this.m3j_1).vr();
    }
    this.i3j_1.g3k_1 = true;
    this.d3j_1.n33(new EventStateHolder());
    this.l3j_1.vr();
    if (this.o3j_1 || this.n3j_1) {
      Companion_getInstance_45().i3k_1.eo('Dispose ' + toString_1(this) + ' in invalid state: commandInProgress=' + this.n3j_1 + ', ' + ('inExternalCommand=' + this.o3j_1), RuntimeException_init_$Create$());
    }
  };
  protoOf(EntityContextCommandProcessor).h3l = function (undoGroupId) {
    addThrowableHandler(this);
    if (this.o3j_1) {
      throw OtException_init_$Create$_0('Execute changes while external command is in progress');
    }
    if (this.n3j_1) {
      throw OtException_init_$Create$_0('Start new command during command execution');
    }
    checkNotInError(this);
    this.n3j_1 = true;
    this.r3j_1 = ArrayDeque_init_$Create$();
    var event = new OtCommandEvent(undoGroupId);
    this.k3j_1.a28(EntityContextCommandProcessor$startCommand$lambda(event));
  };
  protoOf(EntityContextCommandProcessor).i3l = function () {
    checkCanFinishCommand(this);
    if (this.c3k()) {
      finishCommand(this);
      handleCurrentThrowable(this, false);
      throw IllegalStateException_init_$Create$_1('Cannot commit failed command, throwable is cause and it is stored at processor.error', this.h3j_1.qr());
    }
    var resultOp = _get_resultOp__5l2s0j(this);
    finishCommand(this);
    this.k3j_1.a28(EntityContextCommandProcessor$commitCommand$lambda(resultOp));
  };
  protoOf(EntityContextCommandProcessor).j3l = function (op) {
    addThrowableHandler(this);
    if (this.o3j_1) {
      throw OtException_init_$Create$_0('Execute external changes while external command is already in progress');
    }
    checkNotInError(this);
    this.k3j_1.a28(OtCommandListener$onExternalOperationStarted$ref());
    this.o3j_1 = true;
    safeExecute(this, EntityContextCommandProcessor$executeExternal$lambda(this, op));
    var success = handleCurrentThrowable(this, false);
    this.o3j_1 = false;
    if (success) {
      this.k3j_1.a28(EntityContextCommandProcessor$executeExternal$lambda_0(op));
    } else {
      this.k3j_1.a28(OtCommandListener$onExternalOperationFailed$ref());
    }
  };
  protoOf(EntityContextCommandProcessor).k3l = function (reloadedRootId) {
    if (reloadedRootId.equals(this.q3j_1) && !(this.r3j_1 == null)) {
      ensureNotNull(this.r3j_1).m2();
    }
  };
  function EntityContextOperationsTracker$Companion$TRUE$lambda() {
    return true;
  }
  function EntityContextOperationsTracker$o$onItemAdded$lambda($event) {
    return function () {
      return OperationBuilder_instance.l3l($event.k27());
    };
  }
  function EntityContextOperationsTracker$o$onItemRemoved$lambda($event) {
    return function () {
      return OperationBuilder_instance.m3l($event.i27());
    };
  }
  function EntityContextOperationsTracker$o$onChildAdded$lambda($event) {
    return function () {
      return OperationConverter_instance.o3l($event.u34_1, OperationBuilder_instance.n3l($event.o35_1, $event.n35_1));
    };
  }
  function EntityContextOperationsTracker$o$onChildRemoved$lambda($event) {
    return function () {
      return OperationConverter_instance.o3l($event.u34_1, OperationBuilder_instance.p3l($event.o35_1, $event.n35_1));
    };
  }
  function EntityContextOperationsTracker$o$onChildMoved$lambda($event) {
    return function () {
      return Companion_instance_50.q3l($event.u34_1, $event.h36_1);
    };
  }
  function EntityContextOperationsTracker$o$onPropertyChanged$lambda($event) {
    return function () {
      return OperationConverter_instance.o3l($event.u34_1, new SetPropertyOperation($event.m36_1, new SetValueOperation($event.n36_1, $event.o36_1)));
    };
  }
  function EntityContextOperationsTracker$o$onReferenceAdded$lambda($event) {
    return function () {
      var addOperation = new AddToSetOperation($event.u36_1, $event.t36_1.b32());
      var setReferenceOperation = new SetReferenceOperation($event.t36_1, addOperation);
      return OperationConverter_instance.o3l($event.u34_1, setReferenceOperation);
    };
  }
  function EntityContextOperationsTracker$o$onReferenceRemoved$lambda($event) {
    return function () {
      var removeOperation = new RemoveFromSetOperation($event.u36_1, $event.t36_1.b32());
      var setReferenceOperation = new SetReferenceOperation($event.t36_1, removeOperation);
      return OperationConverter_instance.o3l($event.u34_1, setReferenceOperation);
    };
  }
  function EntityContextOperationsTracker$o$onModelBlobChanged$lambda($event, $oldModel) {
    return function () {
      return OperationConverter_instance.o3l($event.u34_1, Companion_instance_48.r3l($event.d36_1, $oldModel).s3l());
    };
  }
  function EntityContextOperationsTracker$o$onModelBlobChanged$lambda_0($event, $newModel) {
    return function () {
      return OperationConverter_instance.o3l($event.u34_1, Companion_instance_48.r3l($event.d36_1, $newModel));
    };
  }
  function EntityContextOperationsTracker$o$onNodeEvent$lambda($event, this$0) {
    return function () {
      $event.k36_1.m27(this$0.q3k_1);
      var operation = this$0.q3k_1.u3l();
      var changeModelBlobOperation = new ChangeModelBlobOperation($event.j36_1, ensureNotNull(operation));
      return OperationConverter_instance.o3l($event.u34_1, changeModelBlobOperation);
    };
  }
  function notifyAboutOperation($this, operationSupplier) {
    if ($this.p3k_1()) {
      $this.o3k(operationSupplier());
    }
  }
  function MyModelOperationTracker() {
    ModelOperationsTracker.call(this);
    this.t3l_1 = null;
  }
  protoOf(MyModelOperationTracker).u3l = function () {
    var op = this.t3l_1;
    this.t3l_1 = null;
    return op;
  };
  protoOf(MyModelOperationTracker).v3l = function (operation) {
    // Inline function 'kotlin.check' call
    if (!(this.t3l_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.t3l_1 = operation;
  };
  function Companion_46() {
    Companion_instance_46 = this;
    var tmp = this;
    tmp.w3l_1 = EntityContextOperationsTracker$Companion$TRUE$lambda;
  }
  var Companion_instance_46;
  function Companion_getInstance_46() {
    if (Companion_instance_46 == null)
      new Companion_46();
    return Companion_instance_46;
  }
  function EntityContextOperationsTracker$1(this$0) {
    this.x3l_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(EntityContextOperationsTracker$1).b33 = function (event) {
    notifyAboutOperation(this.x3l_1, EntityContextOperationsTracker$o$onItemAdded$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$1).c27 = function (event) {
    return this.b33(event);
  };
  protoOf(EntityContextOperationsTracker$1).d33 = function (event) {
    notifyAboutOperation(this.x3l_1, EntityContextOperationsTracker$o$onItemRemoved$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$1).j27 = function (event) {
    return this.d33(event);
  };
  function EntityContextOperationsTracker$2(this$0) {
    this.y3l_1 = this$0;
  }
  protoOf(EntityContextOperationsTracker$2).l35 = function (event) {
    notifyAboutOperation(this.y3l_1, EntityContextOperationsTracker$o$onChildAdded$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$2).s35 = function (event) {
    notifyAboutOperation(this.y3l_1, EntityContextOperationsTracker$o$onChildRemoved$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$2).w35 = function (event) {
    notifyAboutOperation(this.y3l_1, EntityContextOperationsTracker$o$onChildMoved$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$2).x35 = function (event) {
    notifyAboutOperation(this.y3l_1, EntityContextOperationsTracker$o$onPropertyChanged$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$2).y35 = function (event) {
    notifyAboutOperation(this.y3l_1, EntityContextOperationsTracker$o$onReferenceAdded$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$2).z35 = function (event) {
    notifyAboutOperation(this.y3l_1, EntityContextOperationsTracker$o$onReferenceRemoved$lambda(event));
  };
  protoOf(EntityContextOperationsTracker$2).a36 = function (event) {
    var oldModel = event.e36_1;
    if (!(oldModel == null)) {
      notifyAboutOperation(this.y3l_1, EntityContextOperationsTracker$o$onModelBlobChanged$lambda(event, oldModel));
    }
    var newModel = event.f36_1;
    if (!(newModel == null)) {
      notifyAboutOperation(this.y3l_1, EntityContextOperationsTracker$o$onModelBlobChanged$lambda_0(event, newModel));
    }
  };
  protoOf(EntityContextOperationsTracker$2).b36 = function (event) {
    notifyAboutOperation(this.y3l_1, EntityContextOperationsTracker$o$onNodeEvent$lambda(event, this.y3l_1));
  };
  function EntityContextOperationsTracker(entityContext, notificationSupplier) {
    Companion_getInstance_46();
    this.p3k_1 = notificationSupplier;
    this.q3k_1 = new MyModelOperationTracker();
    var tmp = this;
    tmp.r3k_1 = entityContext.c31_1.n27(new EntityContextOperationsTracker$1(this));
    var tmp_0 = this;
    tmp_0.s3k_1 = entityContext.b35(new EntityContextOperationsTracker$2(this));
  }
  protoOf(EntityContextOperationsTracker).vr = function () {
    this.r3k_1.vr();
    this.s3k_1.vr();
  };
  function Companion_47() {
    Companion_instance_47 = this;
    this.c3j_1 = new MergeNavAndEmptyUndoGroupId();
  }
  var Companion_instance_47;
  function Companion_getInstance_47() {
    if (Companion_instance_47 == null)
      new Companion_47();
    return Companion_instance_47;
  }
  function MergeNavAndEmptyUndoGroupId() {
    Companion_getInstance_47();
  }
  protoOf(MergeNavAndEmptyUndoGroupId).z3l = function (nextGroupId, nextType, currentType) {
    return nextGroupId === Companion_getInstance_47().c3j_1 && (currentType === UndoCommandType_EMPTY_getInstance() || (currentType === UndoCommandType_NAVIGATION_getInstance() && !(nextType === UndoCommandType_EDITING_getInstance())));
  };
  protoOf(MergeNavAndEmptyUndoGroupId).toString = function () {
    return 'default';
  };
  function newCommandProcessor(entityContext, merger, errorCollectingEnabled, enableAddRemoveValidator, nodeFactory) {
    errorCollectingEnabled = errorCollectingEnabled === VOID ? true : errorCollectingEnabled;
    enableAddRemoveValidator = enableAddRemoveValidator === VOID ? true : enableAddRemoveValidator;
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    var processor = new EntityContextCommandProcessor(entityContext, merger, errorCollectingEnabled, enableAddRemoveValidator, nodeFactory);
    processor.e3l();
    return processor;
  }
  function OperationValidator() {
  }
  function OtCommandEvent(undoGroupId) {
    this.a3m_1 = undoGroupId;
  }
  protoOf(OtCommandEvent).toString = function () {
    return 'OtCommandEvent(undoGroupId=' + toString_1(this.a3m_1) + ')';
  };
  protoOf(OtCommandEvent).hashCode = function () {
    return hashCode(this.a3m_1);
  };
  protoOf(OtCommandEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OtCommandEvent))
      return false;
    var tmp0_other_with_cast = other instanceof OtCommandEvent ? other : THROW_CCE();
    if (!equals(this.a3m_1, tmp0_other_with_cast.a3m_1))
      return false;
    return true;
  };
  function OtCommandListener() {
  }
  function get_COMMAND_PROCESSOR_KEY() {
    _init_properties_InstallCommandProcessor_kt__w3apc();
    return COMMAND_PROCESSOR_KEY;
  }
  var COMMAND_PROCESSOR_KEY;
  var properties_initialized_InstallCommandProcessor_kt_ir07oy;
  function _init_properties_InstallCommandProcessor_kt__w3apc() {
    if (!properties_initialized_InstallCommandProcessor_kt_ir07oy) {
      properties_initialized_InstallCommandProcessor_kt_ir07oy = true;
      COMMAND_PROCESSOR_KEY = new WrapperContextKey('entityContextCommandProcessor');
    }
  }
  function buildAssemblyOperations($this) {
    var seq = ArrayList_init_$Create$();
    createEntityContentOperations($this, $this.b3m_1, seq);
    var _iterator__ex2g4s = $this.b3m_1.v2z().k();
    while (_iterator__ex2g4s.l()) {
      var childId = _iterator__ex2g4s.m();
      var children = $this.b3m_1.w2z(childId);
      var _iterator__ex2g4s_0 = children.k();
      while (_iterator__ex2g4s_0.l()) {
        var e = _iterator__ex2g4s_0.m();
        $this.c3m(e, seq);
      }
    }
    return Companion_instance_64.d3m(seq);
  }
  function createEntityContentOperations($this, entity, ops) {
    var _iterator__ex2g4s = entity.y2z().k();
    while (_iterator__ex2g4s.l()) {
      var propId = _iterator__ex2g4s.m();
      var property = entity.z2z(propId);
      if (!(property == null)) {
        ops.e(new SetPropertyOperation(propId, new SetValueOperation(null, property)));
      }
    }
    var _iterator__ex2g4s_0 = entity.b30().k();
    while (_iterator__ex2g4s_0.l()) {
      var refId = _iterator__ex2g4s_0.m();
      var targets = entity.c30(refId);
      var _iterator__ex2g4s_1 = targets.k();
      while (_iterator__ex2g4s_1.l()) {
        var ref = _iterator__ex2g4s_1.m();
        ops.e(new SetReferenceOperation(refId, new AddToSetOperation(ref, refId.b32())));
      }
    }
    var _iterator__ex2g4s_2 = entity.d30().k();
    while (_iterator__ex2g4s_2.l()) {
      var modelBlobId = _iterator__ex2g4s_2.m();
      var model = entity.e30(modelBlobId);
      if (!(model == null)) {
        var operation = Companion_instance_48.r3l(modelBlobId, model);
        ops.e(operation);
      }
    }
  }
  function Companion_48() {
  }
  protoOf(Companion_48).r3l = function (modelBlobId, model) {
    var root = model.g30_1;
    var modelOp = AddModelBlobOperation_init_$Create$(modelBlobId, root.a38_1, NodeUtil_instance.y38(root));
    var nodeAssemblyOperationBuilder = new NodeAssemblyOperationBuilder(root);
    var assemblyOp = new ChangeModelBlobOperation(modelBlobId, new SetModelOperation(nodeAssemblyOperationBuilder.k2p()));
    return CompositeOperation_init_$Create$([modelOp, assemblyOp]);
  };
  var Companion_instance_48;
  function Companion_getInstance_48() {
    return Companion_instance_48;
  }
  function EntityAssemblyOperationBuilder(entity) {
    this.b3m_1 = entity;
  }
  protoOf(EntityAssemblyOperationBuilder).k2p = function () {
    return buildAssemblyOperations(this);
  };
  protoOf(EntityAssemblyOperationBuilder).c3m = function (child, ops) {
    var addAssembleOps = ArrayList_init_$Create$();
    var addOp = AddChildOperation_init_$Create$(child.i2z_1, child.j2z_1, ensureNotNull(child.l2z_1).b32());
    addAssembleOps.e(addOp);
    var op = buildAssemblyOperations(new EntityAssemblyOperationBuilder(child));
    if (!op.t3j()) {
      addAssembleOps.e(new ChangeChildOperation(child.j2z_1, op));
    }
    ops.e(new ChildSetOperation(ensureNotNull(child.l2z_1), Companion_instance_64.d3m(addAssembleOps)));
  };
  function EntityPrintOperationUtil() {
  }
  protoOf(EntityPrintOperationUtil).v3j = function (operation) {
    var res = PrintOperationUtil_instance.h3m(operation);
    if (!(operation == null)) {
      res = res + ('\n' + Companion_instance_49.i3m(operation).toString());
    }
    return res;
  };
  var EntityPrintOperationUtil_instance;
  function EntityPrintOperationUtil_getInstance() {
    return EntityPrintOperationUtil_instance;
  }
  function Descriptor() {
    this.j3m_1 = HashSet_init_$Create$();
    this.k3m_1 = HashSet_init_$Create$();
    this.l3m_1 = HashSet_init_$Create$();
    this.m3m_1 = HashSet_init_$Create$();
    this.n3m_1 = HashSet_init_$Create$();
    this.o3m_1 = HashSet_init_$Create$();
  }
  protoOf(Descriptor).toString = function () {
    return 'Descriptor{addedEntityConcepts=' + this.j3m_1 + ', removedEntityConcepts=' + this.k3m_1 + ', modifiedEntityProperties=' + this.l3m_1 + ', addedNodeConcepts=' + this.m3m_1 + ', removeNodeConcepts=' + this.n3m_1 + ', modifiedNodeProperties=' + toString_1(this.o3m_1) + '}';
  };
  function Companion_49() {
  }
  protoOf(Companion_49).i3m = function (operation) {
    var collector = new LeafOperationsCollector();
    collector.q3m(operation);
    return collector.p3m_1;
  };
  var Companion_instance_49;
  function Companion_getInstance_49() {
    return Companion_instance_49;
  }
  function LeafOperationsCollector() {
    OperationCondition.call(this);
    this.p3m_1 = new Descriptor();
  }
  protoOf(LeafOperationsCollector).r3m = function (op) {
    if (op instanceof BuildRootOperation) {
      this.p3m_1.j3m_1.e(op.u3o().i2z_1);
    } else {
      if (op instanceof AddRootOperation) {
        this.p3m_1.j3m_1.e(op.h3f());
      } else {
        if (op instanceof AddChildOperation) {
          this.p3m_1.j3m_1.e(op.h3f());
        } else {
          if (op instanceof RemoveRootOperation) {
            this.p3m_1.k3m_1.e(op.h3f());
          } else {
            if (op instanceof RemoveChildOperation) {
              this.p3m_1.k3m_1.e(op.h3f());
            } else {
              if (op instanceof AddModelBlobOperation) {
                this.p3m_1.m3m_1.e(op.r3o());
              } else {
                if (op instanceof AddChildOperation_0) {
                  this.p3m_1.m3m_1.e(op.h3f());
                } else {
                  if (op instanceof RemoveModelBlobOperation) {
                    this.p3m_1.n3m_1.e(op.r3o());
                  } else {
                    if (op instanceof RemoveChildOperation_0) {
                      this.p3m_1.m3m_1.e(op.h3f());
                    } else {
                      if (op instanceof ReplaceChildOperation) {
                        this.p3m_1.n3m_1.e(op.n3o());
                        this.p3m_1.m3m_1.e(op.o3o());
                      } else {
                        if (op instanceof AddChildSplitPropertyOperation) {
                          this.p3m_1.m3m_1.e(op.m3n_1);
                          this.p3m_1.o3m_1.e(op.d3o_1);
                        } else {
                          if (op instanceof AddChildSplitChildCollectionOperation) {
                            this.p3m_1.m3m_1.e(op.m3n_1);
                          } else {
                            if (op instanceof MergePropertyRemoveChildOperation) {
                              this.p3m_1.n3m_1.e(op.t3m_1);
                              this.p3m_1.o3m_1.e(op.i3n_1);
                            } else {
                              if (op instanceof MergeChildCollectionRemoveChildOperation) {
                                this.p3m_1.n3m_1.e(op.t3m_1);
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return false;
  };
  protoOf(LeafOperationsCollector).q3m = function (op) {
    if (op instanceof SetPropertyOperation) {
      this.p3m_1.l3m_1.e(op.h3b());
      return Unit_instance;
    }
    if (op instanceof ChangePropertyOperation) {
      this.p3m_1.o3m_1.e(op.h3b());
      return Unit_instance;
    }
    protoOf(OperationCondition).q3m.call(this, op);
  };
  function checkRoot($this, root) {
    // Inline function 'kotlin.require' call
    if (!(root.yt() == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.OperationBuilder.checkRoot.<anonymous>' call
      var message = 'Entity ' + root.toString() + ' is not root';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function OperationBuilder() {
  }
  protoOf(OperationBuilder).a3p = function (entity) {
    return (new EntityAssemblyOperationBuilder(entity)).k2p();
  };
  protoOf(OperationBuilder).b3p = function (entity) {
    return this.a3p(entity).s3l();
  };
  protoOf(OperationBuilder).p3l = function (entity, role) {
    var entityId = entity.j2z_1;
    var disassembleOp = this.b3p(entity);
    return new ChildSetOperation(role, CompositeOperation_init_$Create$([new ChangeChildOperation(entityId, disassembleOp), RemoveChildOperation_init_$Create$(entity.i2z_1, entityId, role.b32())]));
  };
  protoOf(OperationBuilder).n3l = function (entity, role) {
    var entityId = entity.j2z_1;
    var assembleOp = this.a3p(entity);
    return new ChildSetOperation(role, CompositeOperation_init_$Create$([AddChildOperation_init_$Create$(entity.i2z_1, entityId, role.b32()), new ChangeChildOperation(entityId, assembleOp)]));
  };
  protoOf(OperationBuilder).l3l = function (root) {
    checkRoot(this, root);
    var rootId = root.j2z_1;
    var addRootOperation = AddRootOperation_init_$Create$(rootId, root.i2z_1);
    var assembleOp = this.a3p(root);
    return CompositeOperation_init_$Create$([addRootOperation, new ChangeRootEntityOperation(rootId, assembleOp)]);
  };
  protoOf(OperationBuilder).m3l = function (root) {
    checkRoot(this, root);
    var rootId = root.j2z_1;
    var disassembleOp = this.b3p(root);
    return CompositeOperation_init_$Create$([new ChangeRootEntityOperation(rootId, disassembleOp), RemoveRootOperation_init_$Create$(rootId, root.i2z_1)]);
  };
  var OperationBuilder_instance;
  function OperationBuilder_getInstance() {
    return OperationBuilder_instance;
  }
  function OperationConverter() {
  }
  protoOf(OperationConverter).o3l = function (entity, op) {
    var parent = entity.yt();
    var tmp;
    if (parent == null) {
      tmp = new ChangeRootEntityOperation(entity.j2z_1, op);
    } else {
      tmp = this.o3l(parent, new ChildSetOperation(ensureNotNull(entity.l2z_1), new ChangeChildOperation(entity.j2z_1, op)));
    }
    return tmp;
  };
  var OperationConverter_instance;
  function OperationConverter_getInstance() {
    return OperationConverter_instance;
  }
  function OperationRootIdInfo_init_$Init$($this) {
    OperationRootIdInfo.call($this);
    return $this;
  }
  function OperationRootIdInfo_init_$Create$() {
    return OperationRootIdInfo_init_$Init$(objectCreate(protoOf(OperationRootIdInfo)));
  }
  function OperationRootIdInfo_init_$Init$_0(op, $this) {
    OperationRootIdInfo.call($this);
    init_1($this, op);
    return $this;
  }
  function OperationRootIdInfo_init_$Create$_0(op) {
    return OperationRootIdInfo_init_$Init$_0(op, objectCreate(protoOf(OperationRootIdInfo)));
  }
  function init($this, operations) {
    var result = OperationRootIdInfo_init_$Create$();
    var _iterator__ex2g4s = operations.k();
    while (_iterator__ex2g4s.l()) {
      var childOp = _iterator__ex2g4s.m();
      var found = OperationRootIdInfo_init_$Create$();
      init_1(found, childOp);
      if (!(result.x3j_1 == null) && !(found.x3j_1 == null) && !equals(result.x3j_1, found.x3j_1)) {
        appendErrorMessage(result, '[transaction must change only one root]');
        init_0($this, result);
        return Unit_instance;
      }
      if (result.x3j_1 == null) {
        result.x3j_1 = found.x3j_1;
        result.w3j_1 = found.w3j_1;
      } else {
        if (found.w3j_1 === OperationKind_REMOVE_getInstance()) {
          result.w3j_1 = OperationKind_REMOVE_getInstance();
        }
      }
    }
    init_0($this, result);
  }
  function init_0($this, other) {
    $this.y3j_1 = other.y3j_1;
    $this.x3j_1 = other.x3j_1;
    $this.w3j_1 = other.w3j_1;
  }
  function init_1($this, op) {
    if (isInterface(op, RootOperation)) {
      var tmp = $this;
      tmp.x3j_1 = (isInterface(op, RootOperation) ? op : THROW_CCE()).o3i();
      var tmp_0 = $this;
      var tmp_1;
      var tmp_2;
      if (op instanceof ChangeRootEntityOperation) {
        tmp_2 = true;
      } else {
        tmp_2 = op instanceof MoveOperation;
      }
      if (tmp_2) {
        tmp_1 = OperationKind_CHANGE_getInstance();
      } else {
        var tmp_3;
        if (op instanceof AddRootOperation) {
          tmp_3 = true;
        } else {
          tmp_3 = op instanceof BuildRootOperation;
        }
        if (tmp_3) {
          tmp_1 = OperationKind_ADD_getInstance();
        } else {
          if (op instanceof RemoveRootOperation) {
            tmp_1 = OperationKind_REMOVE_getInstance();
          } else {
            throw IllegalStateException_init_$Create$_0('Unexpected root operation type: ' + toString_1(getKClassFromExpression(op)));
          }
        }
      }
      tmp_0.w3j_1 = tmp_1;
    } else {
      if (isInterface(op, OperationContainer)) {
        init($this, (isInterface(op, OperationContainer) ? op : THROW_CCE()).l3i());
      } else {
        if (op instanceof NoSubjectOperation) {
          $this.x3j_1 = null;
          $this.w3j_1 = null;
        } else {
          $this.y3j_1 = getImproperOpErrorMsg($this, op);
        }
      }
    }
  }
  function getImproperOpErrorMsg($this, op) {
    var s = op == null ? 'NULL' : getKClassFromExpression(op).lb();
    return '[unknown operation ' + s + ']';
  }
  function appendErrorMessage($this, extra) {
    if ($this.y3j_1 == null) {
      $this.y3j_1 = extra;
    } else {
      $this.y3j_1 = plus_10($this.y3j_1, extra);
    }
  }
  protoOf(OperationRootIdInfo).z3j = function () {
    return this.y3j_1 == null;
  };
  function OperationRootIdInfo() {
    this.w3j_1 = null;
    this.x3j_1 = null;
    this.y3j_1 = null;
  }
  function RootOperation() {
  }
  function AddChildOperation_init_$Init$(conceptId, entityId, singleRole, $this) {
    ChildOperation_init_$Init$(conceptId, entityId, singleRole, $this);
    AddChildOperation.call($this);
    return $this;
  }
  function AddChildOperation_init_$Create$(conceptId, entityId, singleRole) {
    return AddChildOperation_init_$Init$(conceptId, entityId, singleRole, objectCreate(protoOf(AddChildOperation)));
  }
  function AddChildOperation_init_$Init$_0(data, $this) {
    ChildOperation.call($this, data);
    AddChildOperation.call($this);
    return $this;
  }
  function AddChildOperation_init_$Create$_0(data) {
    return AddChildOperation_init_$Init$_0(data, objectCreate(protoOf(AddChildOperation)));
  }
  protoOf(AddChildOperation).b3 = function () {
    return 'addChild';
  };
  protoOf(AddChildOperation).e3p = function (otherOp, server) {
    var tmp;
    if (otherOp instanceof AddChildOperation) {
      this.h3p(otherOp);
      var tmp_0;
      if (this.r3i().equals(otherOp.r3i())) {
        tmp_0 = new NopOperation();
      } else if (this.b32()) {
        tmp_0 = server ? new NopOperation() : CompositeOperation_init_$Create$([this.s3l(), otherOp]);
      } else {
        tmp_0 = otherOp;
      }
      tmp = tmp_0;
    } else {
      tmp = protoOf(ChildOperation).g3p.call(this, otherOp, server);
    }
    return tmp;
  };
  protoOf(AddChildOperation).g3p = function (otherOp, server) {
    return this.e3p(otherOp, server);
  };
  protoOf(AddChildOperation).i3p = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!(!this.b32() || model.p())) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.childSet.AddChildOperation.execute.<anonymous>' call
      var message = 'Add into not empty single-item child set';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(model.w32(this.r3i()) == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.childSet.AddChildOperation.execute.<anonymous>' call
      var message_0 = 'Entity with id=' + this.r3i().toString() + ' already exists';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    model.e(new Entity(this.h3f(), this.r3i()));
    return model;
  };
  protoOf(AddChildOperation).a3k = function (model, nodeFactory) {
    return this.i3p((!(model == null) ? isInterface(model, EntitySet) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddChildOperation).s3l = function () {
    return RemoveChildOperation_init_$Create$_0(this.q3i_1);
  };
  protoOf(AddChildOperation).k3p = function (model, ops, nodeFactory) {
    return (new AddChildOperationExecutor(nodeFactory)).p3p(model, ops);
  };
  protoOf(AddChildOperation).q3p = function (model, ops, nodeFactory) {
    return this.k3p((!(model == null) ? isInterface(model, EntitySet) : false) ? model : THROW_CCE(), ops, nodeFactory);
  };
  function AddChildOperation() {
  }
  function ChangeChildOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(ChangeChildOperation).b3 = function () {
    return 'changeChild';
  };
  protoOf(ChangeChildOperation).x3p = function (op) {
    return new ChangeChildOperation(this.h3b(), op);
  };
  protoOf(ChangeChildOperation).y3p = function (op) {
    return this.x3p(op);
  };
  protoOf(ChangeChildOperation).e3p = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation) {
      if (otherOp.r3i().equals(this.h3b())) {
        var fake = new Entity(otherOp.h3f(), otherOp.r3i());
        fake = this.u3l().a3k(fake, RawNodeFactory_instance);
        var disassemble = OperationBuilder_instance.b3p(fake);
        var changeChildOperation = new ChangeChildOperation(this.h3b(), disassemble);
        return CompositeOperation_init_$Create$([changeChildOperation, otherOp]);
      }
    }
    return protoOf(TargetedOperation).z3p.call(this, otherOp, server);
  };
  protoOf(ChangeChildOperation).g3p = function (otherOp, server) {
    return this.e3p(otherOp, server);
  };
  protoOf(ChangeChildOperation).z3p = function (otherOp, server) {
    return this.e3p(otherOp, server);
  };
  protoOf(ChangeChildOperation).a3q = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation) {
      if (otherOp.r3i().equals(this.h3b())) {
        return new NopOperation();
      }
    }
    return protoOf(TargetedOperation).r3p.call(this, otherOp, server);
  };
  protoOf(ChangeChildOperation).r3p = function (otherOp, server) {
    return this.a3q(otherOp, server);
  };
  protoOf(ChangeChildOperation).b3q = function (source) {
    return source.w32(this.h3b());
  };
  protoOf(ChangeChildOperation).c3q = function (source) {
    return this.b3q((!(source == null) ? isInterface(source, EntitySet) : false) ? source : THROW_CCE());
  };
  protoOf(ChangeChildOperation).k3p = function (model, ops, nodeFactory) {
    return (new ChangeChildOperationExecutor(nodeFactory)).p3p(model, ops);
  };
  protoOf(ChangeChildOperation).q3p = function (model, ops, nodeFactory) {
    return this.k3p((!(model == null) ? isInterface(model, EntitySet) : false) ? model : THROW_CCE(), ops, nodeFactory);
  };
  function ChildOperation_init_$Init$(conceptId, entityId, singleRole, $this) {
    ChildOperation.call($this, new EntityChildOperationData(conceptId, entityId, singleRole));
    return $this;
  }
  function ChildOperation(operationData) {
    BaseOperation.call(this);
    this.q3i_1 = operationData;
  }
  protoOf(ChildOperation).h3f = function () {
    return this.q3i_1.g3q_1;
  };
  protoOf(ChildOperation).r3i = function () {
    return this.q3i_1.h3q_1;
  };
  protoOf(ChildOperation).b32 = function () {
    return this.q3i_1.i3q_1;
  };
  protoOf(ChildOperation).h3p = function (otherOp) {
    // Inline function 'kotlin.check' call
    if (!(this.b32() === otherOp.b32())) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.childSet.ChildOperation.checkSingleRole.<anonymous>' call
      var message = "Mismatching 'single role' flag";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(ChildOperation).toString = function () {
    return this.b3() + '[id = ' + this.r3i().toString() + ';c = ' + this.h3f().toString() + ']';
  };
  function ChildOperationUtil() {
  }
  protoOf(ChildOperationUtil).j3q = function (op) {
    return op instanceof AddChildOperation;
  };
  protoOf(ChildOperationUtil).k3q = function (op) {
    return op instanceof RemoveChildOperation;
  };
  protoOf(ChildOperationUtil).l3q = function (op) {
    return op instanceof ChangeChildOperation;
  };
  protoOf(ChildOperationUtil).m3q = function (op) {
    var tmp;
    if (op instanceof ChildOperation) {
      tmp = op.r3i();
    } else {
      if (op instanceof ChangeChildOperation) {
        tmp = op.h3b();
      } else {
        throw IllegalArgumentException_init_$Create$_0('Unknown operation to get role from: ' + PrintOperationUtil_instance.h3m(op));
      }
    }
    return tmp;
  };
  protoOf(ChildOperationUtil).n3q = function (op) {
    return this.m3q(op);
  };
  protoOf(ChildOperationUtil).o3q = function (op) {
    return (op instanceof ChildOperation ? op : THROW_CCE()).q3i_1;
  };
  protoOf(ChildOperationUtil).p3q = function (op) {
    return this.o3q(op);
  };
  protoOf(ChildOperationUtil).q3q = function (role, data) {
    return AddChildOperation_init_$Create$_0(data);
  };
  protoOf(ChildOperationUtil).r3q = function (role, data) {
    var tmp = role instanceof EntityId ? role : THROW_CCE();
    return this.q3q(tmp, data instanceof EntityChildOperationData ? data : THROW_CCE());
  };
  protoOf(ChildOperationUtil).s3q = function (role, data) {
    return RemoveChildOperation_init_$Create$_0(data);
  };
  protoOf(ChildOperationUtil).t3q = function (role, data) {
    var tmp = role instanceof EntityId ? role : THROW_CCE();
    return this.s3q(tmp, data instanceof EntityChildOperationData ? data : THROW_CCE());
  };
  protoOf(ChildOperationUtil).u3q = function (role, innerOp) {
    return new ChangeChildOperation(role, innerOp);
  };
  protoOf(ChildOperationUtil).v3q = function (role, innerOp) {
    return this.u3q(role instanceof EntityId ? role : THROW_CCE(), innerOp);
  };
  function EntityChildOperationData(conceptId, entityId, isSingleRole) {
    this.g3q_1 = conceptId;
    this.h3q_1 = entityId;
    this.i3q_1 = isSingleRole;
  }
  protoOf(EntityChildOperationData).toString = function () {
    return 'EntityChildOperationData(conceptId=' + this.g3q_1.toString() + ', entityId=' + this.h3q_1.toString() + ', isSingleRole=' + this.i3q_1 + ')';
  };
  protoOf(EntityChildOperationData).hashCode = function () {
    var result = this.g3q_1.hashCode();
    result = imul(result, 31) + this.h3q_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i3q_1) | 0;
    return result;
  };
  protoOf(EntityChildOperationData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityChildOperationData))
      return false;
    var tmp0_other_with_cast = other instanceof EntityChildOperationData ? other : THROW_CCE();
    if (!this.g3q_1.equals(tmp0_other_with_cast.g3q_1))
      return false;
    if (!this.h3q_1.equals(tmp0_other_with_cast.h3q_1))
      return false;
    if (!(this.i3q_1 === tmp0_other_with_cast.i3q_1))
      return false;
    return true;
  };
  function RemoveChildOperation_init_$Init$(conceptId, entityId, singleRole, $this) {
    ChildOperation_init_$Init$(conceptId, entityId, singleRole, $this);
    RemoveChildOperation.call($this);
    return $this;
  }
  function RemoveChildOperation_init_$Create$(conceptId, entityId, singleRole) {
    return RemoveChildOperation_init_$Init$(conceptId, entityId, singleRole, objectCreate(protoOf(RemoveChildOperation)));
  }
  function RemoveChildOperation_init_$Init$_0(data, $this) {
    ChildOperation.call($this, data);
    RemoveChildOperation.call($this);
    return $this;
  }
  function RemoveChildOperation_init_$Create$_0(data) {
    return RemoveChildOperation_init_$Init$_0(data, objectCreate(protoOf(RemoveChildOperation)));
  }
  protoOf(RemoveChildOperation).b3 = function () {
    return 'removeChild';
  };
  protoOf(RemoveChildOperation).e3p = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation) {
      this.h3p(otherOp instanceof ChildOperation ? otherOp : THROW_CCE());
    }
    var tmp;
    if (otherOp instanceof RemoveChildOperation) {
      tmp = this.r3i().equals(otherOp.r3i()) ? new NopOperation() : otherOp;
    } else {
      if (otherOp instanceof AddChildOperation) {
        tmp = this.r3i().equals(otherOp.r3i()) ? new NopOperation() : otherOp;
      } else {
        tmp = protoOf(ChildOperation).g3p.call(this, otherOp, server);
      }
    }
    return tmp;
  };
  protoOf(RemoveChildOperation).g3p = function (otherOp, server) {
    return this.e3p(otherOp, server);
  };
  protoOf(RemoveChildOperation).i3p = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!(!this.b32() || model.n() === 1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.childSet.RemoveChildOperation.execute.<anonymous>' call
      var message = "'Single role' set size=" + model.n();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp0_elvis_lhs = model.w32(this.r3i());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0(EntityMessages_instance.y3q(this.r3i()));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var entity = tmp;
    // Inline function 'kotlin.check' call
    if (!this.h3f().equals(entity.i2z_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.childSet.RemoveChildOperation.execute.<anonymous>' call
      var message_0 = MessageBundle_instance.a39(this.h3f(), entity.i2z_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!entity.np()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.childSet.RemoveChildOperation.execute.<anonymous>' call
      var message_1 = MessageBundle_instance.c39(this.r3i());
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    model.k2(entity);
    return model;
  };
  protoOf(RemoveChildOperation).a3k = function (model, nodeFactory) {
    return this.i3p((!(model == null) ? isInterface(model, EntitySet) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(RemoveChildOperation).s3l = function () {
    return AddChildOperation_init_$Create$_0(this.q3i_1);
  };
  function RemoveChildOperation() {
  }
  function AddRootOperation_init_$Init$(entityId, conceptId, $this) {
    RootEntityOperation_init_$Init$(entityId, conceptId, $this);
    AddRootOperation.call($this);
    return $this;
  }
  function AddRootOperation_init_$Create$(entityId, conceptId) {
    return AddRootOperation_init_$Init$(entityId, conceptId, objectCreate(protoOf(AddRootOperation)));
  }
  function AddRootOperation_init_$Init$_0(operationData, $this) {
    RootEntityOperation.call($this, operationData);
    AddRootOperation.call($this);
    return $this;
  }
  function AddRootOperation_init_$Create$_0(operationData) {
    return AddRootOperation_init_$Init$_0(operationData, objectCreate(protoOf(AddRootOperation)));
  }
  function assertRootIsNotExist($this, model) {
    // Inline function 'kotlin.check' call
    if (!(model.c31_1.w32($this.o3i()) == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.context.AddRootOperation.assertRootIsNotExist.<anonymous>' call
      var message = "Duplicate root id='" + $this.o3i().toString() + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(AddRootOperation).b3r = function (otherOp, server) {
    if (otherOp instanceof AddRootOperation) {
      if (otherOp.o3i().equals(this.o3i())) {
        return new NopOperation();
      }
    }
    return protoOf(RootEntityOperation).g3p.call(this, otherOp, server);
  };
  protoOf(AddRootOperation).g3p = function (otherOp, server) {
    return this.b3r(otherOp, server);
  };
  protoOf(AddRootOperation).c3r = function (model, nodeFactory) {
    assertRootIsNotExist(this, model);
    var entity = new Entity(this.h3f(), this.o3i());
    model.c31_1.e(entity);
    return model;
  };
  protoOf(AddRootOperation).a3k = function (model, nodeFactory) {
    return this.c3r(model instanceof EntityContext ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddRootOperation).s3l = function () {
    return RemoveRootOperation_init_$Create$_0(this.n3i_1);
  };
  protoOf(AddRootOperation).toString = function () {
    return 'addRoot[c = ' + this.o3i().toString() + ';id = ' + this.h3f().toString() + ']';
  };
  protoOf(AddRootOperation).d3r = function (model, ops, nodeFactory) {
    assertRootIsNotExist(this, model);
    return (new AddRootOperationExecutor(nodeFactory)).p3p(model, ops);
  };
  protoOf(AddRootOperation).q3p = function (model, ops, nodeFactory) {
    return this.d3r(model instanceof EntityContext ? model : THROW_CCE(), ops, nodeFactory);
  };
  function AddRootOperation() {
  }
  function AddRootOperationExecutor$installChecker$1(this$0) {
    this.g3r_1 = this$0;
    RootOperationsExecutorChecker.call(this, ensureNotNull(this$0.m3p_1).o3i(), this$0.h3r());
  }
  protoOf(AddRootOperationExecutor$installChecker$1).t35 = function (event) {
    return this.k3r(event);
  };
  protoOf(AddRootOperationExecutor$installChecker$1).v35 = function (event) {
    return this.g3r_1.i2n();
  };
  function AddRootOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseAddOperationExecutor.call(this, nodeFactory);
  }
  protoOf(AddRootOperationExecutor).p3r = function (op) {
    return op instanceof AddRootOperation;
  };
  protoOf(AddRootOperationExecutor).q3r = function (op) {
    return this.p3r(op);
  };
  protoOf(AddRootOperationExecutor).r3r = function (op) {
    return RootOperationsExecutorUtil_instance.s3r(ensureNotNull(this.m3p_1).o3i(), op);
  };
  protoOf(AddRootOperationExecutor).t3r = function (op) {
    return this.r3r(op);
  };
  protoOf(AddRootOperationExecutor).u3r = function (source) {
    return new EntityContext();
  };
  protoOf(AddRootOperationExecutor).v3r = function (source) {
    return this.u3r(source instanceof EntityContext ? source : THROW_CCE());
  };
  protoOf(AddRootOperationExecutor).w3r = function (tempContainer) {
    return tempContainer;
  };
  protoOf(AddRootOperationExecutor).x3r = function (tempContainer) {
    return this.w3r(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  protoOf(AddRootOperationExecutor).y3r = function (source, temp) {
    var root = temp.c31_1.w32(ensureNotNull(this.m3p_1).o3i());
    // Inline function 'kotlin.collections.remove' call
    var this_0 = temp.c31_1;
    (isInterface(this_0, MutableCollection) ? this_0 : THROW_CCE()).k2(root);
    source.c31_1.e(ensureNotNull(root));
  };
  protoOf(AddRootOperationExecutor).z3r = function (source, temp) {
    var tmp = source instanceof EntityContext ? source : THROW_CCE();
    return this.y3r(tmp, temp instanceof EntityContext ? temp : THROW_CCE());
  };
  protoOf(AddRootOperationExecutor).a3s = function (tempContainer) {
    return tempContainer.b35(new AddRootOperationExecutor$installChecker$1(this));
  };
  protoOf(AddRootOperationExecutor).b3s = function (tempContainer) {
    return this.a3s(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  function BuildRootOperation(filter) {
    filter = filter === VOID ? null : filter;
    BaseOperation.call(this);
    this.t3o_1 = filter;
  }
  protoOf(BuildRootOperation).o3i = function () {
    return this.k3s().j2z_1;
  };
  protoOf(BuildRootOperation).b3r = function (otherOp, server) {
    var tmp;
    if (!isInterface(otherOp, RootOperation)) {
      tmp = true;
    } else {
      var tmp_0 = this.k3s().j2z_1;
      tmp = !tmp_0.equals((isInterface(otherOp, RootOperation) ? otherOp : THROW_CCE()).o3i());
    }
    // Inline function 'kotlin.check' call
    if (!tmp) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return protoOf(BaseOperation).g3p.call(this, otherOp, server);
  };
  protoOf(BuildRootOperation).g3p = function (otherOp, server) {
    return this.b3r(otherOp, server);
  };
  protoOf(BuildRootOperation).l3s = function (otherOp, server) {
    var tmp;
    if (!isInterface(otherOp, RootOperation)) {
      tmp = true;
    } else {
      var tmp_0 = this.k3s().j2z_1;
      tmp = !tmp_0.equals((isInterface(otherOp, RootOperation) ? otherOp : THROW_CCE()).o3i());
    }
    // Inline function 'kotlin.check' call
    if (!tmp) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return protoOf(BaseOperation).r3p.call(this, otherOp, server);
  };
  protoOf(BuildRootOperation).r3p = function (otherOp, server) {
    return this.l3s(otherOp, server);
  };
  protoOf(BuildRootOperation).c3r = function (model, nodeFactory) {
    model.c31_1.e(this.u3o());
    return model;
  };
  protoOf(BuildRootOperation).a3k = function (model, nodeFactory) {
    return this.c3r(model instanceof EntityContext ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(BuildRootOperation).s3l = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(BuildRootOperation).toString = function () {
    return 'buildRoot[' + this.k3s().toString() + ']';
  };
  function ChangeRootEntityOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(ChangeRootEntityOperation).b3 = function () {
    return 'changeRoot';
  };
  protoOf(ChangeRootEntityOperation).o3i = function () {
    return this.h3b();
  };
  protoOf(ChangeRootEntityOperation).b3r = function (otherOp, server) {
    if (otherOp instanceof RemoveRootOperation) {
      if (this.h3b().equals(otherOp.o3i())) {
        return CompositeOperation_init_$Create$([this.s3l(), otherOp]);
      }
    }
    return protoOf(TargetedOperation).z3p.call(this, otherOp, server);
  };
  protoOf(ChangeRootEntityOperation).g3p = function (otherOp, server) {
    return this.b3r(otherOp, server);
  };
  protoOf(ChangeRootEntityOperation).z3p = function (otherOp, server) {
    return this.b3r(otherOp, server);
  };
  protoOf(ChangeRootEntityOperation).l3s = function (otherOp, server) {
    if (otherOp instanceof RemoveRootOperation) {
      if (this.h3b().equals(otherOp.o3i())) {
        return new NopOperation();
      }
    }
    return protoOf(TargetedOperation).r3p.call(this, otherOp, server);
  };
  protoOf(ChangeRootEntityOperation).r3p = function (otherOp, server) {
    return this.l3s(otherOp, server);
  };
  protoOf(ChangeRootEntityOperation).x3p = function (op) {
    return new ChangeRootEntityOperation(this.h3b(), op);
  };
  protoOf(ChangeRootEntityOperation).y3p = function (op) {
    return this.x3p(op);
  };
  protoOf(ChangeRootEntityOperation).p3s = function (source) {
    return source.c31_1.w32(this.h3b());
  };
  protoOf(ChangeRootEntityOperation).c3q = function (source) {
    return this.p3s(source instanceof EntityContext ? source : THROW_CCE());
  };
  protoOf(ChangeRootEntityOperation).d3r = function (model, ops, nodeFactory) {
    return (new ChangeRootOperationExecutor(nodeFactory)).p3p(model, ops);
  };
  protoOf(ChangeRootEntityOperation).q3p = function (model, ops, nodeFactory) {
    return this.d3r(model instanceof EntityContext ? model : THROW_CCE(), ops, nodeFactory);
  };
  function ChangeRootOperationExecutor$installChecker$1(this$0) {
    this.s3s_1 = this$0;
    RootOperationsExecutorChecker.call(this, ensureNotNull(this$0.m3p_1).o3i(), this$0.h3r());
  }
  protoOf(ChangeRootOperationExecutor$installChecker$1).t35 = function (event) {
    this.s3s_1.i2n();
  };
  protoOf(ChangeRootOperationExecutor$installChecker$1).v35 = function (event) {
    this.k3r(event);
  };
  function ChangeRootOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseRemoveOperationExecutor.call(this, nodeFactory);
  }
  protoOf(ChangeRootOperationExecutor).p3r = function (op) {
    return op instanceof RemoveRootOperation;
  };
  protoOf(ChangeRootOperationExecutor).q3r = function (op) {
    return this.p3r(op);
  };
  protoOf(ChangeRootOperationExecutor).x3s = function (source) {
    return !(source.z34(ensureNotNull(this.m3p_1).o3i()) == null);
  };
  protoOf(ChangeRootOperationExecutor).i3s = function (source) {
    return this.x3s(source instanceof EntityContext ? source : THROW_CCE());
  };
  protoOf(ChangeRootOperationExecutor).y3s = function (op) {
    return RootOperationsExecutorUtil_instance.s3r(ensureNotNull(this.m3p_1).o3i(), op);
  };
  protoOf(ChangeRootOperationExecutor).j3s = function (op) {
    return this.y3s(op);
  };
  protoOf(ChangeRootOperationExecutor).u3r = function (source) {
    var context = new EntityContext();
    var root = source.c31_1.w32(ensureNotNull(this.m3p_1).o3i());
    context.c31_1.e(Entities_getInstance().x2z(ensureNotNull(root)));
    return context;
  };
  protoOf(ChangeRootOperationExecutor).v3r = function (source) {
    return this.u3r(source instanceof EntityContext ? source : THROW_CCE());
  };
  protoOf(ChangeRootOperationExecutor).w3r = function (tempContainer) {
    return tempContainer;
  };
  protoOf(ChangeRootOperationExecutor).x3r = function (tempContainer) {
    return this.w3r(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  protoOf(ChangeRootOperationExecutor).y3r = function (source, temp) {
    var rootEntities = source.c31_1;
    var root = rootEntities.w32(ensureNotNull(this.m3p_1).o3i());
    // Inline function 'kotlin.collections.remove' call
    (isInterface(rootEntities, MutableCollection) ? rootEntities : THROW_CCE()).k2(root);
  };
  protoOf(ChangeRootOperationExecutor).z3r = function (source, temp) {
    var tmp = source instanceof EntityContext ? source : THROW_CCE();
    return this.y3r(tmp, temp instanceof EntityContext ? temp : THROW_CCE());
  };
  protoOf(ChangeRootOperationExecutor).a3s = function (tempContainer) {
    return tempContainer.b35(new ChangeRootOperationExecutor$installChecker$1(this));
  };
  protoOf(ChangeRootOperationExecutor).b3s = function (tempContainer) {
    return this.a3s(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  function RemoveRootOperation_init_$Init$(entityId, conceptId, $this) {
    RootEntityOperation_init_$Init$(entityId, conceptId, $this);
    RemoveRootOperation.call($this);
    return $this;
  }
  function RemoveRootOperation_init_$Create$(entityId, conceptId) {
    return RemoveRootOperation_init_$Init$(entityId, conceptId, objectCreate(protoOf(RemoveRootOperation)));
  }
  function RemoveRootOperation_init_$Init$_0(operationData, $this) {
    RootEntityOperation.call($this, operationData);
    RemoveRootOperation.call($this);
    return $this;
  }
  function RemoveRootOperation_init_$Create$_0(operationData) {
    return RemoveRootOperation_init_$Init$_0(operationData, objectCreate(protoOf(RemoveRootOperation)));
  }
  protoOf(RemoveRootOperation).c3r = function (model, nodeFactory) {
    var rootEntities = model.c31_1;
    var root = rootEntities.w32(this.o3i());
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (root == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.entity.context.RemoveRootOperation.execute.<anonymous>' call
        var message = "No root with id='" + this.o3i().toString() + "'";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    // Inline function 'kotlin.check' call
    if (!root.np()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.context.RemoveRootOperation.execute.<anonymous>' call
      var message_0 = MessageBundle_instance.c39(this.o3i());
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    rootEntities.k2(root);
    return model;
  };
  protoOf(RemoveRootOperation).a3k = function (model, nodeFactory) {
    return this.c3r(model instanceof EntityContext ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(RemoveRootOperation).s3l = function () {
    return AddRootOperation_init_$Create$_0(this.n3i_1);
  };
  protoOf(RemoveRootOperation).b3r = function (otherOp, server) {
    if (otherOp instanceof RemoveRootOperation) {
      if (otherOp.o3i().equals(this.o3i())) {
        return new NopOperation();
      }
    }
    return protoOf(RootEntityOperation).g3p.call(this, otherOp, server);
  };
  protoOf(RemoveRootOperation).g3p = function (otherOp, server) {
    return this.b3r(otherOp, server);
  };
  protoOf(RemoveRootOperation).toString = function () {
    return 'removeRoot[c = ' + this.h3f().toString() + ';id = ' + this.o3i().toString() + ']';
  };
  function RemoveRootOperation() {
  }
  function RootEntityOperation_init_$Init$(entityId, conceptId, $this) {
    RootEntityOperation.call($this, new RootOperationData(entityId, conceptId));
    return $this;
  }
  function RootEntityOperation(operationData) {
    BaseOperation.call(this);
    this.n3i_1 = operationData;
  }
  protoOf(RootEntityOperation).o3i = function () {
    return this.n3i_1.f3t_1;
  };
  protoOf(RootEntityOperation).h3f = function () {
    return this.n3i_1.g3t_1;
  };
  function RootOperationData(entityId, conceptId) {
    this.f3t_1 = entityId;
    this.g3t_1 = conceptId;
  }
  protoOf(RootOperationData).toString = function () {
    return 'RootOperationData(entityId=' + this.f3t_1.toString() + ', conceptId=' + this.g3t_1.toString() + ')';
  };
  protoOf(RootOperationData).hashCode = function () {
    var result = this.f3t_1.hashCode();
    result = imul(result, 31) + this.g3t_1.hashCode() | 0;
    return result;
  };
  protoOf(RootOperationData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RootOperationData))
      return false;
    var tmp0_other_with_cast = other instanceof RootOperationData ? other : THROW_CCE();
    if (!this.f3t_1.equals(tmp0_other_with_cast.f3t_1))
      return false;
    if (!this.g3t_1.equals(tmp0_other_with_cast.g3t_1))
      return false;
    return true;
  };
  function RootOperationUtil() {
  }
  protoOf(RootOperationUtil).j3q = function (op) {
    return op instanceof AddRootOperation;
  };
  protoOf(RootOperationUtil).k3q = function (op) {
    return op instanceof RemoveRootOperation;
  };
  protoOf(RootOperationUtil).l3q = function (op) {
    return op instanceof ChangeRootEntityOperation;
  };
  protoOf(RootOperationUtil).h3t = function (op) {
    var tmp;
    if (op instanceof RootEntityOperation) {
      tmp = op.o3i();
    } else {
      if (op instanceof ChangeRootEntityOperation) {
        tmp = op.h3b();
      } else {
        throw IllegalArgumentException_init_$Create$_0('Unknown operation to get role from: ' + PrintOperationUtil_instance.h3m(op));
      }
    }
    return tmp;
  };
  protoOf(RootOperationUtil).n3q = function (op) {
    return this.h3t(op);
  };
  protoOf(RootOperationUtil).i3t = function (op) {
    return (op instanceof RootEntityOperation ? op : THROW_CCE()).n3i_1;
  };
  protoOf(RootOperationUtil).p3q = function (op) {
    return this.i3t(op);
  };
  protoOf(RootOperationUtil).j3t = function (role, data) {
    return AddRootOperation_init_$Create$_0(data);
  };
  protoOf(RootOperationUtil).r3q = function (role, data) {
    var tmp = role instanceof EntityId ? role : THROW_CCE();
    return this.j3t(tmp, data instanceof RootOperationData ? data : THROW_CCE());
  };
  protoOf(RootOperationUtil).k3t = function (role, data) {
    return RemoveRootOperation_init_$Create$_0(data);
  };
  protoOf(RootOperationUtil).t3q = function (role, data) {
    var tmp = role instanceof EntityId ? role : THROW_CCE();
    return this.k3t(tmp, data instanceof RootOperationData ? data : THROW_CCE());
  };
  protoOf(RootOperationUtil).u3q = function (role, innerOp) {
    return new ChangeRootEntityOperation(role, innerOp);
  };
  protoOf(RootOperationUtil).v3q = function (role, innerOp) {
    return this.u3q(role instanceof EntityId ? role : THROW_CCE(), innerOp);
  };
  function RootOperationsExecutorChecker(allowedRootId, canceller) {
    this.i3r_1 = allowedRootId;
    this.j3r_1 = canceller;
  }
  protoOf(RootOperationsExecutorChecker).u35 = function (event) {
    if (!Entities_getInstance().q30(this.i3r_1, event.u34_1)) {
      this.j3r_1();
    }
  };
  protoOf(RootOperationsExecutorChecker).k3r = function (e) {
    if (!this.i3r_1.equals(e.u34_1.j2z_1)) {
      this.j3r_1();
    }
  };
  function RootOperationsExecutorUtil() {
  }
  protoOf(RootOperationsExecutorUtil).s3r = function (expectedRootId, op) {
    var tmp;
    if (op instanceof ChangeRootEntityOperation) {
      tmp = expectedRootId.equals(op.o3i());
    } else {
      tmp = false;
    }
    return tmp;
  };
  var RootOperationsExecutorUtil_instance;
  function RootOperationsExecutorUtil_getInstance() {
    return RootOperationsExecutorUtil_instance;
  }
  function SafeBuildRootOperation(root, filter) {
    filter = filter === VOID ? null : filter;
    BuildRootOperation.call(this, filter);
    this.n3t_1 = Entities_getInstance().x2z(root);
  }
  protoOf(SafeBuildRootOperation).u3o = function () {
    return Entities_getInstance().x2z(this.n3t_1);
  };
  protoOf(SafeBuildRootOperation).k3s = function () {
    return this.n3t_1;
  };
  function UnsafeBuildRootOperation(root) {
    BuildRootOperation.call(this);
    this.q3t_1 = root;
  }
  protoOf(UnsafeBuildRootOperation).u3o = function () {
    return this.q3t_1;
  };
  protoOf(UnsafeBuildRootOperation).k3s = function () {
    return this.q3t_1;
  };
  function entityDiff($this) {
    var contentDiff = ArrayList_init_$Create$();
    contentDiff.o(propertiesDiff($this));
    contentDiff.o(blobsDiff($this));
    contentDiff.o(childrenDiff($this));
    contentDiff.o(referencesDiff($this));
    return Companion_instance_64.d3m(contentDiff);
  }
  function propertiesDiff($this) {
    var diff = ArrayList_init_$Create$();
    var _iterator__ex2g4s = $this.r3t_1.y2z().k();
    while (_iterator__ex2g4s.l()) {
      var propertyId = _iterator__ex2g4s.m();
      diff.e(propertyDiff($this, propertyId));
    }
    var _iterator__ex2g4s_0 = $this.s3t_1.y2z().k();
    while (_iterator__ex2g4s_0.l()) {
      var propertyId_0 = _iterator__ex2g4s_0.m();
      if (!$this.r3t_1.y2z().s(propertyId_0)) {
        diff.e(new SetPropertyOperation(propertyId_0, new SetValueOperation(null, $this.s3t_1.z2z(propertyId_0))));
      }
    }
    return diff;
  }
  function propertyDiff($this, propertyId) {
    var srcValue = $this.r3t_1.z2z(propertyId);
    var trgValue = $this.s3t_1.z2z(propertyId);
    var tmp;
    if (srcValue == trgValue) {
      tmp = new NopOperation();
    } else {
      tmp = new SetPropertyOperation(propertyId, new SetValueOperation(srcValue, trgValue));
    }
    return tmp;
  }
  function blobsDiff($this) {
    var diff = ArrayList_init_$Create$();
    var _iterator__ex2g4s = $this.r3t_1.d30().k();
    while (_iterator__ex2g4s.l()) {
      var blobId = _iterator__ex2g4s.m();
      diff.e(blobDiff($this, blobId));
    }
    var _iterator__ex2g4s_0 = $this.s3t_1.d30().k();
    while (_iterator__ex2g4s_0.l()) {
      var blobId_0 = _iterator__ex2g4s_0.m();
      if (!$this.r3t_1.d30().s(blobId_0)) {
        var modelAssemblyOperation = createModelAssemblyOperation($this, blobId_0, ensureNotNull($this.s3t_1.e30(blobId_0)));
        diff.e(modelAssemblyOperation);
      }
    }
    return diff;
  }
  function blobDiff($this, blobId) {
    var trgModel = $this.s3t_1.e30(blobId);
    var srcModel = $this.r3t_1.e30(blobId);
    if (trgModel == null) {
      return createModelAssemblyOperation($this, blobId, ensureNotNull(srcModel)).s3l();
    }
    var tmp;
    if (NodeUtil_instance.f3i(ensureNotNull(srcModel).g30_1, trgModel.g30_1)) {
      var op = NodeDiff_instance.u3t(srcModel, trgModel);
      tmp = new ChangeModelBlobOperation(blobId, op);
    } else {
      tmp = Companion_instance_64.t3t([createModelAssemblyOperation($this, blobId, srcModel).s3l(), createModelAssemblyOperation($this, blobId, trgModel)]);
    }
    return tmp;
  }
  function createModelAssemblyOperation($this, blobId, model) {
    return Companion_instance_48.r3l(blobId, model);
  }
  function referencesDiff($this) {
    var diff = ArrayList_init_$Create$();
    var _iterator__ex2g4s = $this.r3t_1.b30().k();
    while (_iterator__ex2g4s.l()) {
      var referenceId = _iterator__ex2g4s.m();
      if ($this.s3t_1.b30().s(referenceId)) {
        diff.o(referenceDiff($this, referenceId));
      } else {
        var _iterator__ex2g4s_0 = $this.r3t_1.c30(referenceId).k();
        while (_iterator__ex2g4s_0.l()) {
          var s = _iterator__ex2g4s_0.m();
          diff.e(new SetReferenceOperation(referenceId, new RemoveFromSetOperation(s, referenceId.b32())));
        }
      }
    }
    var _iterator__ex2g4s_1 = $this.s3t_1.b30().k();
    while (_iterator__ex2g4s_1.l()) {
      var referenceId_0 = _iterator__ex2g4s_1.m();
      if (!$this.r3t_1.b30().s(referenceId_0)) {
        var _iterator__ex2g4s_2 = $this.s3t_1.c30(referenceId_0).k();
        while (_iterator__ex2g4s_2.l()) {
          var t = _iterator__ex2g4s_2.m();
          diff.e(new SetReferenceOperation(referenceId_0, new AddToSetOperation(t, referenceId_0.b32())));
        }
      }
    }
    return diff;
  }
  function referenceDiff($this, referenceId) {
    var srcRefs = $this.r3t_1.c30(referenceId);
    var trgRefs = $this.s3t_1.c30(referenceId);
    var diff = ArrayList_init_$Create$();
    if (srcRefs.p() && trgRefs.p()) {
      return diff;
    }
    var _iterator__ex2g4s = srcRefs.k();
    while (_iterator__ex2g4s.l()) {
      var s = _iterator__ex2g4s.m();
      if (!trgRefs.s(s)) {
        diff.e(new SetReferenceOperation(referenceId, new RemoveFromSetOperation(s, referenceId.b32())));
      }
    }
    var _iterator__ex2g4s_0 = trgRefs.k();
    while (_iterator__ex2g4s_0.l()) {
      var t = _iterator__ex2g4s_0.m();
      if (!srcRefs.s(t)) {
        diff.e(new SetReferenceOperation(referenceId, new AddToSetOperation(t, referenceId.b32())));
      }
    }
    return diff;
  }
  function childrenDiff($this) {
    var diff = ArrayList_init_$Create$();
    var _iterator__ex2g4s = $this.r3t_1.v2z().k();
    while (_iterator__ex2g4s.l()) {
      var childId = _iterator__ex2g4s.m();
      if ($this.s3t_1.v2z().s(childId)) {
        diff.o(childDiff($this, childId));
      } else {
        var _iterator__ex2g4s_0 = $this.r3t_1.w2z(childId).k();
        while (_iterator__ex2g4s_0.l()) {
          var s = _iterator__ex2g4s_0.m();
          diff.e(OperationBuilder_instance.p3l(s, childId));
        }
      }
    }
    var _iterator__ex2g4s_1 = $this.s3t_1.v2z().k();
    while (_iterator__ex2g4s_1.l()) {
      var childId_0 = _iterator__ex2g4s_1.m();
      if (!$this.r3t_1.v2z().s(childId_0)) {
        var _iterator__ex2g4s_2 = $this.s3t_1.w2z(childId_0).k();
        while (_iterator__ex2g4s_2.l()) {
          var t = _iterator__ex2g4s_2.m();
          diff.e(OperationBuilder_instance.n3l(t, childId_0));
        }
      }
    }
    return diff;
  }
  function childDiff($this, childId) {
    var srcChildren = $this.r3t_1.w2z(childId);
    var trgChildren = $this.s3t_1.w2z(childId);
    var diff = ArrayList_init_$Create$();
    if (srcChildren.p() && trgChildren.p()) {
      return diff;
    }
    var _iterator__ex2g4s = srcChildren.k();
    while (_iterator__ex2g4s.l()) {
      var s = _iterator__ex2g4s.m();
      var t = trgChildren.w32(s.j2z_1);
      if (!(t == null)) {
        if (t.i2z_1.equals(s.i2z_1)) {
          var entityDiffBuilder = new EntityDiffBuilder(s, t);
          var d = entityDiff(entityDiffBuilder);
          if (!d.t3j()) {
            var changeChildOperation = new ChangeChildOperation(s.j2z_1, d);
            diff.e(new ChildSetOperation(childId, changeChildOperation));
          }
        } else {
          diff.e(OperationBuilder_instance.p3l(s, childId));
          diff.e(OperationBuilder_instance.n3l(t, childId));
        }
      } else {
        diff.e(OperationBuilder_instance.p3l(s, childId));
      }
    }
    var _iterator__ex2g4s_0 = trgChildren.k();
    while (_iterator__ex2g4s_0.l()) {
      var t_0 = _iterator__ex2g4s_0.m();
      if (srcChildren.w32(t_0.j2z_1) == null) {
        diff.e(OperationBuilder_instance.n3l(t_0, childId));
      }
    }
    return diff;
  }
  function EntityDiffBuilder(source, target) {
    this.r3t_1 = source;
    this.s3t_1 = target;
    // Inline function 'kotlin.check' call
    if (!this.r3t_1.i2z_1.equals(this.s3t_1.i2z_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.diffBuilder.EntityDiffBuilder.<anonymous>' call
      var message = MessageBundle_instance.a39(this.r3t_1.i2z_1, this.s3t_1.i2z_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!this.r3t_1.j2z_1.equals(this.s3t_1.j2z_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.diffBuilder.EntityDiffBuilder.<anonymous>' call
      var message_0 = MessageBundle_instance.d39(this.r3t_1.j2z_1, this.s3t_1.j2z_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  protoOf(EntityDiffBuilder).v3t = function () {
    return new ChangeRootEntityOperation(this.r3t_1.j2z_1, entityDiff(this));
  };
  function EntityMessages() {
  }
  protoOf(EntityMessages).y3q = function (entityId) {
    return "No entity with id='" + entityId.toString() + "'";
  };
  var EntityMessages_instance;
  function EntityMessages_getInstance() {
    return EntityMessages_instance;
  }
  function AddModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, $this) {
    ModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, $this);
    AddModelBlobOperation.call($this);
    return $this;
  }
  function AddModelBlobOperation_init_$Create$(modelBlobId, conceptId, nodeId) {
    return AddModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, objectCreate(protoOf(AddModelBlobOperation)));
  }
  function AddModelBlobOperation_init_$Init$_0(data, $this) {
    ModelBlobOperation.call($this, data);
    AddModelBlobOperation.call($this);
    return $this;
  }
  function AddModelBlobOperation_init_$Create$_0(data) {
    return AddModelBlobOperation_init_$Init$_0(data, objectCreate(protoOf(AddModelBlobOperation)));
  }
  protoOf(AddModelBlobOperation).b3 = function () {
    return 'addModel';
  };
  protoOf(AddModelBlobOperation).y3t = function (otherOp, server) {
    if (otherOp instanceof AddModelBlobOperation) {
      if (otherOp.z3t().equals(this.z3t())) {
        var rootId = otherOp.o3i();
        var tmp;
        if (otherOp.r3o().equals(this.r3o()) && !(rootId == null) && equals(rootId, this.o3i())) {
          tmp = new NopOperation();
        } else {
          var tmp_0;
          if (server) {
            tmp_0 = new NopOperation();
          } else {
            tmp_0 = CompositeOperation_init_$Create$([this.s3l(), otherOp]);
          }
          tmp = tmp_0;
        }
        return tmp;
      }
    }
    return protoOf(ModelBlobOperation).g3p.call(this, otherOp, server);
  };
  protoOf(AddModelBlobOperation).g3p = function (otherOp, server) {
    return this.y3t(otherOp, server);
  };
  protoOf(AddModelBlobOperation).a3u = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!(model.e30(this.z3t()) == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.modelBlob.AddModelBlobOperation.execute.<anonymous>' call
      var message = "Model blob with id='" + this.z3t().toString() + "' is already registered";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var root = nodeFactory.z37(this.r3o(), this.o3i());
    var rootModel = new Model(root);
    model.f30(this.z3t(), rootModel);
    return model;
  };
  protoOf(AddModelBlobOperation).a3k = function (model, nodeFactory) {
    return this.a3u(model instanceof Entity ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddModelBlobOperation).s3l = function () {
    return RemoveModelBlobOperation_init_$Create$_0(this.q3o_1);
  };
  protoOf(AddModelBlobOperation).b3u = function (model, ops, nodeFactory) {
    return (new AddModelOperationExecutor(nodeFactory)).p3p(model, ops);
  };
  protoOf(AddModelBlobOperation).q3p = function (model, ops, nodeFactory) {
    return this.b3u(model instanceof Entity ? model : THROW_CCE(), ops, nodeFactory);
  };
  function AddModelBlobOperation() {
  }
  function AddModelOperationExecutor$installChecker$1(this$0) {
    this.f3u_1 = this$0;
    ModelOperationsExecutorChecker.call(this, ensureNotNull(this$0.m3p_1).z3t(), ensureNotNull(this$0.m3p_1).o3i(), this$0.h3r());
  }
  protoOf(AddModelOperationExecutor$installChecker$1).a36 = function (event) {
    if (event.e36_1 == null && !(event.f36_1 == null)) {
      this.j3u(event);
    } else {
      this.f3u_1.i2n();
    }
  };
  function AddModelOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseAddOperationExecutor.call(this, nodeFactory);
    this.o3u_1 = EntityId_init_$Create$();
  }
  protoOf(AddModelOperationExecutor).p3u = function (op) {
    return op instanceof AddModelBlobOperation;
  };
  protoOf(AddModelOperationExecutor).q3r = function (op) {
    return this.p3u(op);
  };
  protoOf(AddModelOperationExecutor).q3u = function (op) {
    return ModelOperationsExecutorUtil_instance.r3u(ensureNotNull(this.m3p_1).z3t(), op);
  };
  protoOf(AddModelOperationExecutor).t3r = function (op) {
    return this.q3u(op);
  };
  protoOf(AddModelOperationExecutor).s3u = function (source) {
    var context = new EntityContext();
    var entity = new Entity(source.i2z_1, this.o3u_1);
    context.c31_1.e(entity);
    return context;
  };
  protoOf(AddModelOperationExecutor).v3r = function (source) {
    return this.s3u(source instanceof Entity ? source : THROW_CCE());
  };
  protoOf(AddModelOperationExecutor).w3r = function (tempContainer) {
    return ensureNotNull(ModelOperationsExecutorUtil_instance.t3u(tempContainer, this.o3u_1));
  };
  protoOf(AddModelOperationExecutor).x3r = function (tempContainer) {
    return this.w3r(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  protoOf(AddModelOperationExecutor).u3u = function (source, temp) {
    var blobId = ensureNotNull(this.m3p_1).z3t();
    var model = temp.e30(blobId);
    temp.f30(blobId, null);
    source.f30(blobId, model);
  };
  protoOf(AddModelOperationExecutor).z3r = function (source, temp) {
    var tmp = source instanceof Entity ? source : THROW_CCE();
    return this.u3u(tmp, temp instanceof Entity ? temp : THROW_CCE());
  };
  protoOf(AddModelOperationExecutor).a3s = function (tempContainer) {
    return tempContainer.b35(new AddModelOperationExecutor$installChecker$1(this));
  };
  protoOf(AddModelOperationExecutor).b3s = function (tempContainer) {
    return this.a3s(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  function ChangeModelBlobOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(ChangeModelBlobOperation).b3 = function () {
    return 'changeBlob';
  };
  protoOf(ChangeModelBlobOperation).y3t = function (otherOp, server) {
    if (otherOp instanceof RemoveModelBlobOperation) {
      if (otherOp.z3t().equals(this.h3b())) {
        return CompositeOperation_init_$Create$([this.s3l(), otherOp]);
      }
    }
    return protoOf(TargetedOperation).z3p.call(this, otherOp, server);
  };
  protoOf(ChangeModelBlobOperation).g3p = function (otherOp, server) {
    return this.y3t(otherOp, server);
  };
  protoOf(ChangeModelBlobOperation).z3p = function (otherOp, server) {
    return this.y3t(otherOp, server);
  };
  protoOf(ChangeModelBlobOperation).y3u = function (otherOp, server) {
    if (otherOp instanceof RemoveModelBlobOperation) {
      if (otherOp.z3t().equals(this.h3b())) {
        return new NopOperation();
      }
    }
    return protoOf(TargetedOperation).r3p.call(this, otherOp, server);
  };
  protoOf(ChangeModelBlobOperation).r3p = function (otherOp, server) {
    return this.y3u(otherOp, server);
  };
  protoOf(ChangeModelBlobOperation).z3u = function (op) {
    return new ChangeModelBlobOperation(this.h3b(), op);
  };
  protoOf(ChangeModelBlobOperation).y3p = function (op) {
    return this.z3u(op);
  };
  protoOf(ChangeModelBlobOperation).a3v = function (source) {
    return source.e30(this.h3b());
  };
  protoOf(ChangeModelBlobOperation).c3q = function (source) {
    return this.a3v(source instanceof Entity ? source : THROW_CCE());
  };
  protoOf(ChangeModelBlobOperation).b3v = function (model, customExecute, nodeFactory) {
    var tmp0 = model.e30(this.h3b());
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.entity.modelBlob.ChangeModelBlobOperation.execute.<anonymous>' call
        var message = ModelBlobMessages_instance.c3v(this.h3b());
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    this.f3q(ensureNotNull(this.a3v(model)), customExecute, nodeFactory);
    return model;
  };
  protoOf(ChangeModelBlobOperation).d3v = function (model, customExecute, nodeFactory) {
    return this.b3v(model instanceof Entity ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(ChangeModelBlobOperation).d3q = function (model, customExecute, nodeFactory) {
    return this.b3v(model instanceof Entity ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(ChangeModelBlobOperation).b3u = function (model, ops, nodeFactory) {
    return (new ChangeModelOperationExecutor(nodeFactory)).p3p(model, ops);
  };
  protoOf(ChangeModelBlobOperation).q3p = function (model, ops, nodeFactory) {
    return this.b3u(model instanceof Entity ? model : THROW_CCE(), ops, nodeFactory);
  };
  function ChangeModelOperationExecutor$installChecker$1(this$0) {
    this.h3v_1 = this$0;
    ModelOperationsExecutorChecker.call(this, ensureNotNull(this$0.m3p_1).z3t(), ensureNotNull(this$0.m3p_1).o3i(), this$0.h3r());
  }
  protoOf(ChangeModelOperationExecutor$installChecker$1).a36 = function (event) {
    if (!(event.e36_1 == null) && event.f36_1 == null) {
      this.j3u(event);
    } else {
      this.h3v_1.i2n();
    }
  };
  function ChangeModelOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseRemoveOperationExecutor.call(this, nodeFactory);
    this.m3v_1 = EntityId_init_$Create$();
  }
  protoOf(ChangeModelOperationExecutor).p3u = function (op) {
    return op instanceof RemoveModelBlobOperation;
  };
  protoOf(ChangeModelOperationExecutor).q3r = function (op) {
    return this.p3u(op);
  };
  protoOf(ChangeModelOperationExecutor).n3v = function (source) {
    return !(source.e30(ensureNotNull(this.m3p_1).z3t()) == null);
  };
  protoOf(ChangeModelOperationExecutor).i3s = function (source) {
    return this.n3v(source instanceof Entity ? source : THROW_CCE());
  };
  protoOf(ChangeModelOperationExecutor).o3v = function (op) {
    return ModelOperationsExecutorUtil_instance.r3u(ensureNotNull(this.m3p_1).z3t(), op);
  };
  protoOf(ChangeModelOperationExecutor).j3s = function (op) {
    return this.o3v(op);
  };
  protoOf(ChangeModelOperationExecutor).s3u = function (source) {
    var entity = new Entity(source.i2z_1, this.m3v_1);
    var model = source.e30(ensureNotNull(this.m3p_1).z3t());
    entity.f30(ensureNotNull(this.m3p_1).z3t(), ensureNotNull(model).o30());
    var context = new EntityContext();
    context.c31_1.e(entity);
    return context;
  };
  protoOf(ChangeModelOperationExecutor).v3r = function (source) {
    return this.s3u(source instanceof Entity ? source : THROW_CCE());
  };
  protoOf(ChangeModelOperationExecutor).w3r = function (tempContainer) {
    return ensureNotNull(ModelOperationsExecutorUtil_instance.t3u(tempContainer, this.m3v_1));
  };
  protoOf(ChangeModelOperationExecutor).x3r = function (tempContainer) {
    return this.w3r(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  protoOf(ChangeModelOperationExecutor).u3u = function (source, temp) {
    source.f30(ensureNotNull(this.m3p_1).z3t(), null);
  };
  protoOf(ChangeModelOperationExecutor).z3r = function (source, temp) {
    var tmp = source instanceof Entity ? source : THROW_CCE();
    return this.u3u(tmp, temp instanceof Entity ? temp : THROW_CCE());
  };
  protoOf(ChangeModelOperationExecutor).a3s = function (tempContainer) {
    return tempContainer.b35(new ChangeModelOperationExecutor$installChecker$1(this));
  };
  protoOf(ChangeModelOperationExecutor).b3s = function (tempContainer) {
    return this.a3s(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  function ModelBlobMessages() {
  }
  protoOf(ModelBlobMessages).c3v = function (blobId) {
    return "No model blob with id='" + blobId.toString() + "'";
  };
  var ModelBlobMessages_instance;
  function ModelBlobMessages_getInstance() {
    return ModelBlobMessages_instance;
  }
  function ModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, $this) {
    ModelBlobOperation.call($this, new ModelBlobOperationData(modelBlobId, conceptId, nodeId));
    return $this;
  }
  function ModelBlobOperation(operationData) {
    BaseOperation.call(this);
    this.q3o_1 = operationData;
  }
  protoOf(ModelBlobOperation).z3t = function () {
    return this.q3o_1.p3v_1;
  };
  protoOf(ModelBlobOperation).r3o = function () {
    return this.q3o_1.q3v_1;
  };
  protoOf(ModelBlobOperation).o3i = function () {
    return this.q3o_1.r3v_1;
  };
  protoOf(ModelBlobOperation).b3 = function () {
    return 'modelBlob';
  };
  protoOf(ModelBlobOperation).toString = function () {
    return this.b3() + '[modelId = ' + this.z3t() + ';c = ' + this.r3o() + ';nodeId = ' + toString_0(this.o3i()) + ']';
  };
  function ModelBlobOperationData(modelBlobId, rootConceptId, rootId) {
    this.p3v_1 = modelBlobId;
    this.q3v_1 = rootConceptId;
    this.r3v_1 = rootId;
  }
  protoOf(ModelBlobOperationData).toString = function () {
    return 'ModelBlobOperationData(modelBlobId=' + this.p3v_1.toString() + ', rootConceptId=' + this.q3v_1.toString() + ', rootId=' + toString_0(this.r3v_1) + ')';
  };
  protoOf(ModelBlobOperationData).hashCode = function () {
    var result = this.p3v_1.hashCode();
    result = imul(result, 31) + this.q3v_1.hashCode() | 0;
    result = imul(result, 31) + (this.r3v_1 == null ? 0 : this.r3v_1.hashCode()) | 0;
    return result;
  };
  protoOf(ModelBlobOperationData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ModelBlobOperationData))
      return false;
    var tmp0_other_with_cast = other instanceof ModelBlobOperationData ? other : THROW_CCE();
    if (!this.p3v_1.equals(tmp0_other_with_cast.p3v_1))
      return false;
    if (!this.q3v_1.equals(tmp0_other_with_cast.q3v_1))
      return false;
    if (!equals(this.r3v_1, tmp0_other_with_cast.r3v_1))
      return false;
    return true;
  };
  function ModelBlobOperationUtil() {
  }
  protoOf(ModelBlobOperationUtil).j3q = function (op) {
    return op instanceof AddModelBlobOperation;
  };
  protoOf(ModelBlobOperationUtil).k3q = function (op) {
    return op instanceof RemoveModelBlobOperation;
  };
  protoOf(ModelBlobOperationUtil).l3q = function (op) {
    return op instanceof ChangeModelBlobOperation;
  };
  protoOf(ModelBlobOperationUtil).s3v = function (op) {
    var tmp;
    if (op instanceof ModelBlobOperation) {
      tmp = op.z3t();
    } else {
      if (op instanceof ChangeModelBlobOperation) {
        tmp = op.h3b();
      } else {
        throw IllegalArgumentException_init_$Create$_0('Unknown operation to get role from: ' + PrintOperationUtil_instance.h3m(op));
      }
    }
    return tmp;
  };
  protoOf(ModelBlobOperationUtil).n3q = function (op) {
    return this.s3v(op);
  };
  protoOf(ModelBlobOperationUtil).t3v = function (op) {
    return (op instanceof ModelBlobOperation ? op : THROW_CCE()).q3o_1;
  };
  protoOf(ModelBlobOperationUtil).p3q = function (op) {
    return this.t3v(op);
  };
  protoOf(ModelBlobOperationUtil).u3v = function (role, data) {
    return AddModelBlobOperation_init_$Create$_0(data);
  };
  protoOf(ModelBlobOperationUtil).r3q = function (role, data) {
    var tmp = role instanceof EntityModelBlobId ? role : THROW_CCE();
    return this.u3v(tmp, data instanceof ModelBlobOperationData ? data : THROW_CCE());
  };
  protoOf(ModelBlobOperationUtil).v3v = function (role, data) {
    return RemoveModelBlobOperation_init_$Create$_0(data);
  };
  protoOf(ModelBlobOperationUtil).t3q = function (role, data) {
    var tmp = role instanceof EntityModelBlobId ? role : THROW_CCE();
    return this.v3v(tmp, data instanceof ModelBlobOperationData ? data : THROW_CCE());
  };
  protoOf(ModelBlobOperationUtil).w3v = function (role, innerOp) {
    return new ChangeModelBlobOperation(role, innerOp);
  };
  protoOf(ModelBlobOperationUtil).v3q = function (role, innerOp) {
    return this.w3v(role instanceof EntityModelBlobId ? role : THROW_CCE(), innerOp);
  };
  function ModelOperationsExecutorChecker(myAllowedModelId, myAllowedRootId, myCanceller) {
    this.g3u_1 = myAllowedModelId;
    this.h3u_1 = myAllowedRootId;
    this.i3u_1 = myCanceller;
  }
  protoOf(ModelOperationsExecutorChecker).u35 = function (event) {
    this.i3u_1();
  };
  protoOf(ModelOperationsExecutorChecker).b36 = function (event) {
    if (!this.g3u_1.equals(event.j36_1)) {
      this.i3u_1();
      return Unit_instance;
    }
    var rootNode = ensureNotNull(event.k36_1.i3h_1.c38_1).g30_1;
    if (!NodeUtil_instance.e3i(rootNode, this.h3u_1)) {
      this.i3u_1();
    }
  };
  protoOf(ModelOperationsExecutorChecker).j3u = function (e) {
    if (!this.g3u_1.equals(e.d36_1)) {
      this.i3u_1();
    }
  };
  function ModelOperationsExecutorUtil() {
  }
  protoOf(ModelOperationsExecutorUtil).r3u = function (expectedId, op) {
    var tmp;
    if (op instanceof ChangeModelBlobOperation) {
      tmp = expectedId.equals(op.h3b());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ModelOperationsExecutorUtil).t3u = function (container, entityId) {
    return container.c31_1.w32(entityId);
  };
  var ModelOperationsExecutorUtil_instance;
  function ModelOperationsExecutorUtil_getInstance() {
    return ModelOperationsExecutorUtil_instance;
  }
  function RemoveModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, $this) {
    ModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, $this);
    RemoveModelBlobOperation.call($this);
    return $this;
  }
  function RemoveModelBlobOperation_init_$Create$(modelBlobId, conceptId, nodeId) {
    return RemoveModelBlobOperation_init_$Init$(modelBlobId, conceptId, nodeId, objectCreate(protoOf(RemoveModelBlobOperation)));
  }
  function RemoveModelBlobOperation_init_$Init$_0(data, $this) {
    ModelBlobOperation.call($this, data);
    RemoveModelBlobOperation.call($this);
    return $this;
  }
  function RemoveModelBlobOperation_init_$Create$_0(data) {
    return RemoveModelBlobOperation_init_$Init$_0(data, objectCreate(protoOf(RemoveModelBlobOperation)));
  }
  protoOf(RemoveModelBlobOperation).b3 = function () {
    return 'removeModel';
  };
  protoOf(RemoveModelBlobOperation).y3t = function (otherOp, server) {
    if (otherOp instanceof RemoveModelBlobOperation) {
      if (otherOp.z3t().equals(this.z3t())) {
        return new NopOperation();
      }
    }
    return protoOf(ModelBlobOperation).g3p.call(this, otherOp, server);
  };
  protoOf(RemoveModelBlobOperation).g3p = function (otherOp, server) {
    return this.y3t(otherOp, server);
  };
  protoOf(RemoveModelBlobOperation).a3u = function (model, nodeFactory) {
    var tmp0 = model.e30(this.z3t());
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.entity.modelBlob.RemoveModelBlobOperation.execute.<anonymous>' call
        var message = ModelBlobMessages_instance.c3v(this.z3t());
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var root = ensureNotNull(model.e30(this.z3t())).g30_1;
    // Inline function 'kotlin.check' call
    if (!this.r3o().equals(root.a38_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.modelBlob.RemoveModelBlobOperation.execute.<anonymous>' call
      var message_0 = MessageBundle_instance.a39(this.r3o(), root.a38_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.e3i(root, this.o3i())) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.modelBlob.RemoveModelBlobOperation.execute.<anonymous>' call
      var message_1 = MessageBundle_instance.d39(root.v39(), ensureNotNull(this.o3i()));
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.check' call
    if (!root.np()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.modelBlob.RemoveModelBlobOperation.execute.<anonymous>' call
      var message_2 = MessageBundle_instance.c39(this.z3t());
      throw IllegalStateException_init_$Create$_0(toString_1(message_2));
    }
    model.f30(this.z3t(), null);
    return model;
  };
  protoOf(RemoveModelBlobOperation).a3k = function (model, nodeFactory) {
    return this.a3u(model instanceof Entity ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(RemoveModelBlobOperation).s3l = function () {
    return AddModelBlobOperation_init_$Create$_0(this.q3o_1);
  };
  function RemoveModelBlobOperation() {
  }
  function removeFromTargeted($this, targeted, item) {
    var role = targeted.h3b();
    if (equals(role, item.z3v_1)) {
      if (!item.l()) {
        return null;
      }
      var result = $this.a3w(targeted.u3l(), ensureNotNull(item.c17()));
      return result == null ? null : targeted.y3p(result);
    }
    return targeted;
  }
  function DestroyOperationTransformer() {
  }
  protoOf(DestroyOperationTransformer).b3w = function (to, what, diff) {
    return CompositeOperation_init_$Create$([diff.e3w(what), to]);
  };
  protoOf(DestroyOperationTransformer).a3w = function (from, item) {
    if (from instanceof CompositeOperation) {
      var ops = ArrayList_init_$Create$();
      var _iterator__ex2g4s = (from instanceof CompositeOperation ? from : THROW_CCE()).l3i().k();
      while (_iterator__ex2g4s.l()) {
        var op = _iterator__ex2g4s.m();
        var disassemblyOp = this.a3w(op, item);
        if (!(disassemblyOp == null)) {
          ops.e(disassemblyOp);
        }
      }
      return ops.p() ? null : Companion_instance_64.d3m(ops);
    }
    if (from instanceof TargetedOperation) {
      return removeFromTargeted(this, from instanceof TargetedOperation ? from : THROW_CCE(), item);
    }
    var tmp;
    var tmp_0;
    if (from instanceof RemoveChildOperation) {
      tmp_0 = (from instanceof RemoveChildOperation ? from : THROW_CCE()).r3i().equals(item.i3w(0));
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = null;
    } else {
      tmp = from;
    }
    return tmp;
  };
  var DestroyOperationTransformer_instance;
  function DestroyOperationTransformer_getInstance() {
    return DestroyOperationTransformer_instance;
  }
  function EntityPathItem(item, next) {
    PathItem.call(this, item);
    this.k3w_1 = next;
  }
  protoOf(EntityPathItem).l3w = function (newValue) {
    var tmp = this;
    tmp.k3w_1 = (newValue == null ? true : newValue instanceof RolePathItem) ? newValue : THROW_CCE();
  };
  protoOf(EntityPathItem).m3w = function (_set____db54di) {
    return this.l3w(_set____db54di);
  };
  protoOf(EntityPathItem).c17 = function () {
    return this.k3w_1;
  };
  protoOf(EntityPathItem).n3w = function () {
    return new EntityPathItem(this.z3v_1, this.l() ? ensureNotNull(this.k3w_1).n3w() : null);
  };
  protoOf(EntityPathItem).e3w = function (op) {
    var tmp;
    if (op.t3j()) {
      tmp = new NopOperation();
    } else {
      var tmp_0;
      if (this.l()) {
        tmp_0 = ensureNotNull(this.c17()).e3w(op);
      } else {
        tmp_0 = isInterface(op, Operation) ? op : THROW_CCE();
      }
      var operation = tmp_0;
      tmp = new ChangeChildOperation(this.z3v_1, operation);
    }
    return tmp;
  };
  function _get_pathToOldParent__me5jxc($this) {
    return $this.s3w_1.n3w().a3x();
  }
  function checkRole($this, op) {
    if (!(op instanceof NopOperation)) {
      if (op instanceof ChildSetOperation) {
        var role = op.h3b();
        if (!role.equals($this.w3w_1)) {
          throw OtException_init_$Create$_0("Transformed destroy operation doesn't change the desired subtree: " + ("role='" + $this.w3w_1.toString() + "', SetChild role='" + role.toString() + "'"));
        }
      } else {
        if (op instanceof CompositeOperation) {
          var _iterator__ex2g4s = op.l3i().k();
          while (_iterator__ex2g4s.l()) {
            var o = _iterator__ex2g4s.m();
            checkRole($this, o);
          }
        } else {
          throw OtException_init_$Create$_0("Transformed destroy operation doesn't change the desired subtree");
        }
      }
    }
  }
  function checkContainsAddRmMoving($this, op) {
    if (containsRemoveMovingOperation($this, op) && containsAddMovingOperation($this, op)) {
      throw OtException_init_$Create$_0('Multiple add/remove of moving entity may be transformed in wrong way');
    }
  }
  function to2From($this) {
    var from = $this.t3w_1.n3w();
    from.p3w(new RolePathItem($this.w3w_1, new EntityPathItem($this.v3w_1, null)));
    return from;
  }
  function containsRemoveMovingOperation($this, operation) {
    return (new MoveOperation$containsRemoveMovingOperation$1($this)).z3o(operation);
  }
  function containsRemoveNewParentOperation($this, operation) {
    return (new MoveOperation$containsRemoveNewParentOperation$1($this)).z3o(operation);
  }
  function containsAddMovingOperation($this, operation) {
    return (new MoveOperation$containsAddMovingOperation$1($this)).z3o(operation);
  }
  function Companion_50() {
  }
  protoOf(Companion_50).q3l = function (moved, oldParent) {
    var to = Companion_instance_52.b3x(moved);
    to.a3x();
    var from = Companion_instance_52.b3x(ensureNotNull(oldParent));
    from.c3x(ensureNotNull(moved.l2z_1), moved.j2z_1);
    return new MoveOperation(from, to, OperationBuilder_instance.p3l(moved, ensureNotNull(moved.l2z_1)));
  };
  var Companion_instance_50;
  function Companion_getInstance_50() {
    return Companion_instance_50;
  }
  function MoveOperation$containsRemoveMovingOperation$1(this$0) {
    this.d3x_1 = this$0;
    OperationCondition.call(this);
  }
  protoOf(MoveOperation$containsRemoveMovingOperation$1).r3m = function (op) {
    var tmp;
    if (op instanceof RemoveChildOperation) {
      tmp = op.r3i().equals(this.d3x_1.v3w_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function MoveOperation$containsRemoveNewParentOperation$1(this$0) {
    this.e3x_1 = this$0;
    OperationCondition.call(this);
  }
  protoOf(MoveOperation$containsRemoveNewParentOperation$1).r3m = function (op) {
    var tmp;
    if (op instanceof RemoveChildOperation) {
      tmp = op.r3i().equals(this.e3x_1.x3w_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function MoveOperation$containsAddMovingOperation$1(this$0) {
    this.f3x_1 = this$0;
    OperationCondition.call(this);
  }
  protoOf(MoveOperation$containsAddMovingOperation$1).r3m = function (op) {
    var tmp;
    if (op instanceof AddChildOperation) {
      tmp = op.r3i().equals(this.f3x_1.v3w_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function MoveOperation(_from, _to, destroyOperation) {
    BaseOperation.call(this);
    this.s3w_1 = _from;
    this.t3w_1 = _to;
    this.u3w_1 = destroyOperation;
    // Inline function 'kotlin.check' call
    if (!this.s3w_1.z3v_1.equals(this.t3w_1.z3v_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.move.MoveOperation.<anonymous>' call
      var message = 'Move between different roots: ' + this.s3w_1.z3v_1.toString() + ', ' + this.t3w_1.z3v_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp = this;
    var tmp_0 = this.t3w_1.i3w(0);
    tmp.x3w_1 = tmp_0 instanceof EntityId ? tmp_0 : THROW_CCE();
    var tmp_1 = this;
    var tmp_2 = this.s3w_1.i3w(1);
    tmp_1.w3w_1 = tmp_2 instanceof EntityChildId ? tmp_2 : THROW_CCE();
    var tmp_3 = this;
    var tmp_4 = this.s3w_1.i3w(0);
    tmp_3.v3w_1 = tmp_4 instanceof EntityId ? tmp_4 : THROW_CCE();
  }
  protoOf(MoveOperation).g3x = function () {
    return this.s3w_1.n3w();
  };
  protoOf(MoveOperation).h3x = function () {
    return this.t3w_1.n3w();
  };
  protoOf(MoveOperation).o3i = function () {
    return this.s3w_1.z3v_1;
  };
  protoOf(MoveOperation).b3r = function (otherOp, server) {
    if (otherOp instanceof MoveOperation) {
      if (otherOp.s3w_1.equals(this.s3w_1)) {
        var tmp;
        if (otherOp.t3w_1.equals(this.t3w_1)) {
          tmp = new NopOperation();
        } else {
          tmp = server ? new NopOperation() : new MoveOperation(to2From(this), otherOp.t3w_1.n3w(), this.u3w_1);
        }
        return tmp;
      }
      if (otherOp.s3w_1.j3x(this.s3w_1)) {
        var from = PathItemUtil_instance.i3x(otherOp.s3w_1, this.s3w_1, this.t3w_1);
        var tmp_0;
        if (otherOp.t3w_1.j3x(this.s3w_1)) {
          tmp_0 = PathItemUtil_instance.i3x(otherOp.t3w_1, this.s3w_1, this.t3w_1);
        } else {
          tmp_0 = otherOp.t3w_1.n3w();
        }
        var to = tmp_0;
        return new MoveOperation(from, to, otherOp.u3w_1);
      }
      if (this.s3w_1.j3x(otherOp.s3w_1)) {
        var destroy = DestroyOperationTransformer_instance.a3w(otherOp.u3w_1, PathItemUtil_instance.k3x(this.s3w_1, otherOp.s3w_1));
        if (this.t3w_1.j3x(otherOp.s3w_1)) {
          destroy = DestroyOperationTransformer_instance.b3w(ensureNotNull(destroy), this.u3w_1, PathItemUtil_instance.k3x(this.t3w_1, otherOp.s3w_1));
        }
        return new MoveOperation(otherOp.s3w_1.n3w(), otherOp.t3w_1.n3w(), ensureNotNull(destroy));
      }
      if (this.t3w_1.j3x(otherOp.s3w_1)) {
        var tmp_1;
        if (otherOp.t3w_1.j3x(this.s3w_1)) {
          tmp_1 = server ? new NopOperation() : CompositeOperation_init_$Create$([this.s3l(), otherOp]);
        } else {
          tmp_1 = new MoveOperation(otherOp.s3w_1.n3w(), otherOp.t3w_1.n3w(), DestroyOperationTransformer_instance.b3w(otherOp.u3w_1, this.u3w_1, PathItemUtil_instance.k3x(this.t3w_1, otherOp.s3w_1)));
        }
        return tmp_1;
      }
      var tmp_2;
      if (otherOp.t3w_1.j3x(this.s3w_1)) {
        tmp_2 = new MoveOperation(otherOp.s3w_1.n3w(), PathItemUtil_instance.i3x(otherOp.t3w_1, this.s3w_1, this.t3w_1), otherOp.u3w_1);
      } else {
        tmp_2 = otherOp;
      }
      return tmp_2;
    }
    if (otherOp instanceof ChangeRootEntityOperation) {
      checkContainsAddRmMoving(this, otherOp);
      if (containsRemoveNewParentOperation(this, otherOp)) {
        var otherWithoutOpsInMovingSubtree = DestroyOperationTransformer_instance.a3w(otherOp, this.s3w_1);
        return CompositeOperation_init_$Create$([this.t3w_1.e3w(this.u3w_1), ensureNotNull(otherWithoutOpsInMovingSubtree)]);
      }
      return (new RootOperationTransformer(this.s3w_1, this.t3w_1)).p3x(otherOp);
    }
    return protoOf(BaseOperation).g3p.call(this, otherOp, server);
  };
  protoOf(MoveOperation).g3p = function (otherOp, server) {
    return this.b3r(otherOp, server);
  };
  protoOf(MoveOperation).l3s = function (otherOp, server) {
    if (otherOp instanceof ChangeRootEntityOperation) {
      checkContainsAddRmMoving(this, otherOp);
      if (containsRemoveMovingOperation(this, otherOp)) {
        return new NopOperation();
      }
      var tmp = otherOp.b3k(_get_pathToOldParent__me5jxc(this).e3w(this.u3w_1), !server);
      var op = tmp instanceof ChangeRootEntityOperation ? tmp : THROW_CCE();
      var destroy = _get_pathToOldParent__me5jxc(this).q3x(op);
      checkRole(this, destroy);
      var tmp_0;
      if (containsRemoveNewParentOperation(this, otherOp)) {
        tmp_0 = op;
      } else {
        tmp_0 = new MoveOperation(this.s3w_1.n3w(), this.t3w_1.n3w(), destroy);
      }
      return tmp_0;
    }
    return protoOf(BaseOperation).r3p.call(this, otherOp, server);
  };
  protoOf(MoveOperation).r3p = function (otherOp, server) {
    return this.l3s(otherOp, server);
  };
  protoOf(MoveOperation).c3r = function (model, nodeFactory) {
    var tmp0_elvis_lhs = model.w34().w32(this.v3w_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Moving: ' + EntityMessages_instance.y3q(this.v3w_1));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var moving = tmp;
    // Inline function 'kotlin.check' call
    if (!this.w3w_1.equals(moving.l2z_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.move.MoveOperation.execute.<anonymous>' call
      var message = MessageBundle_instance.b39(this.w3w_1, ensureNotNull(moving.l2z_1));
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!this.s3w_1.i3w(2).equals(ensureNotNull(moving.yt()).j2z_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.move.MoveOperation.execute.<anonymous>' call
      var message_0 = 'Unequal parents: stored=' + this.s3w_1.i3w(2).i2s_1 + ', actual=' + ensureNotNull(moving.yt()).j2z_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var tmp1_elvis_lhs = model.w34().w32(this.x3w_1);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('New parent: ' + EntityMessages_instance.y3q(this.x3w_1));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var newParent = tmp_0;
    // Inline function 'kotlin.check' call
    if (!this.s3w_1.equals(Companion_instance_52.b3x(moving))) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.move.MoveOperation.execute.<anonymous>' call
      var message_1 = 'Source paths are unequal';
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.check' call
    if (!this.t3w_1.equals(Companion_instance_52.b3x(newParent))) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.entity.move.MoveOperation.execute.<anonymous>' call
      var message_2 = 'Target paths are unequal';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2));
    }
    moving.k33(newParent);
    return model;
  };
  protoOf(MoveOperation).a3k = function (model, nodeFactory) {
    return this.c3r(model instanceof EntityContext ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(MoveOperation).s3l = function () {
    return new MoveOperation(to2From(this), _get_pathToOldParent__me5jxc(this), this.u3w_1);
  };
  protoOf(MoveOperation).toString = function () {
    return 'move[' + this.s3w_1.toString() + ' -> ' + this.t3w_1.toString() + ';destroy=' + toString_1(this.u3w_1) + ']';
  };
  function get_4($this, i) {
    if (i === 0) {
      return $this.z3v_1;
    }
    // Inline function 'kotlin.check' call
    if (!$this.l()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return get_4(ensureNotNull($this.c17()), i - 1 | 0);
  }
  function delegateUnwrap($this, op) {
    var tmp = $this.c17();
    var next = (tmp == null ? true : tmp instanceof PathItem) ? tmp : THROW_CCE();
    return ensureNotNull(next).q3w(op);
  }
  function PathItem(value) {
    this.z3v_1 = value;
  }
  protoOf(PathItem).l = function () {
    return !(this.c17() == null);
  };
  protoOf(PathItem).j3x = function (path) {
    var i2 = path;
    var i1 = this;
    while (!(i1 == null) && !(i2 == null)) {
      if (!i1.z3v_1.equals(i2.z3v_1)) {
        return false;
      }
      i1 = i1.c17();
      i2 = i2.c17();
    }
    return i2 == null;
  };
  protoOf(PathItem).i3w = function (index) {
    return get_4(this, (this.wo() - index | 0) - 1 | 0);
  };
  protoOf(PathItem).p3w = function (tail) {
    if (!this.l()) {
      this.m3w(tail instanceof PathItem ? tail : THROW_CCE());
      return Unit_instance;
    }
    ensureNotNull(this.c17()).p3w(tail);
  };
  protoOf(PathItem).wo = function () {
    return 1 + (this.l() ? ensureNotNull(this.c17()).wo() : 0) | 0;
  };
  protoOf(PathItem).o3w = function (fromIndex) {
    if (fromIndex === 0) {
      return this.n3w();
    }
    if (!this.l()) {
      // Inline function 'kotlin.check' call
      if (!(fromIndex <= 1)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      return null;
    }
    return ensureNotNull(this.c17()).o3w(fromIndex - 1 | 0);
  };
  protoOf(PathItem).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    var that = (other == null ? true : other instanceof PathItem) ? other : THROW_CCE();
    if (!equals(this.z3v_1, ensureNotNull(that).z3v_1))
      return false;
    return !(!(this.c17() == null) ? !equals(this.c17(), that.c17()) : !(that.c17() == null));
  };
  protoOf(PathItem).hashCode = function () {
    var result = this.z3v_1.hashCode();
    result = imul(31, result) + (!(this.c17() == null) ? ensureNotNull(this.c17()).hashCode() : 0) | 0;
    return result;
  };
  protoOf(PathItem).q3w = function (op) {
    // Inline function 'kotlin.check' call
    if (!equals(op.h3b(), this.z3v_1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var operation = op.u3l();
    var tmp;
    if (operation instanceof NopOperation) {
      tmp = operation;
    } else {
      if (!this.l()) {
        tmp = operation;
      } else {
        tmp = delegateUnwrap(this, operation instanceof TargetedOperation ? operation : THROW_CCE());
      }
    }
    return tmp;
  };
  protoOf(PathItem).toString = function () {
    return this.z3v_1.i2s_1 + (this.l() ? ensureNotNull(this.c17()).toString() : '');
  };
  function PathItemUtil() {
  }
  protoOf(PathItemUtil).k3x = function (longer, shorter) {
    // Inline function 'kotlin.check' call
    if (!longer.j3x(shorter)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp = longer.o3w(shorter.wo() - 2 | 0);
    return tmp instanceof RolePathItem ? tmp : THROW_CCE();
  };
  protoOf(PathItemUtil).i3x = function (path, oldPrefix, newPrefix) {
    var changed = newPrefix.n3w();
    var copy = path.o3w(oldPrefix.wo() - 2 | 0);
    if (!(copy == null)) {
      changed.p3w(copy);
    }
    return changed;
  };
  var PathItemUtil_instance;
  function PathItemUtil_getInstance() {
    return PathItemUtil_instance;
  }
  function Companion_51() {
  }
  protoOf(Companion_51).r3x = function () {
    return '-(';
  };
  protoOf(Companion_51).s3x = function () {
    return ')-';
  };
  var Companion_instance_51;
  function Companion_getInstance_51() {
    return Companion_instance_51;
  }
  function RolePathItem(item, next) {
    PathItem.call(this, item);
    this.d3w_1 = null;
    this.d3w_1 = next;
  }
  protoOf(RolePathItem).t3x = function (newValue) {
    var tmp = this;
    tmp.d3w_1 = (newValue == null ? true : newValue instanceof EntityPathItem) ? newValue : THROW_CCE();
  };
  protoOf(RolePathItem).m3w = function (_set____db54di) {
    return this.t3x(_set____db54di);
  };
  protoOf(RolePathItem).c17 = function () {
    return this.d3w_1;
  };
  protoOf(RolePathItem).toString = function () {
    return Companion_instance_51.r3x() + this.z3v_1.i2s_1 + Companion_instance_51.s3x() + (this.l() ? ensureNotNull(this.c17()).toString() : '');
  };
  protoOf(RolePathItem).e3w = function (op) {
    if (op.t3j()) {
      return new NopOperation();
    }
    // Inline function 'kotlin.check' call
    if (!this.l()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return new ChildSetOperation(this.z3v_1, ensureNotNull(this.d3w_1).e3w(op));
  };
  protoOf(RolePathItem).n3w = function () {
    return new RolePathItem(this.z3v_1, this.l() ? ensureNotNull(this.d3w_1).n3w() : null);
  };
  function doTransform($this, item, otherOp, result) {
    if (isDirectOperationOnSubtree($this, otherOp)) {
      result.e(newOrderedOp($this, otherOp, true));
    } else {
      if (otherOp instanceof TargetedOperation) {
        onTargetedOperation($this, item, otherOp instanceof TargetedOperation ? otherOp : THROW_CCE(), result);
      } else {
        if (otherOp instanceof CompositeOperation) {
          onCompositeOperation($this, item, otherOp instanceof CompositeOperation ? otherOp : THROW_CCE(), result);
        } else {
          result.e(newOrderedOp($this, otherOp, false));
        }
      }
    }
  }
  function newOrderedOp($this, op, changePath) {
    var _unary__edvuaz = $this.o3x_1;
    $this.o3x_1 = _unary__edvuaz + 1 | 0;
    return new OrderedOperation(op, changePath, _unary__edvuaz);
  }
  function onTargetedOperation($this, item, otherOp, result) {
    if (isOnPath($this, item, otherOp)) {
      if (item.l()) {
        diveInto($this, item, otherOp, result);
      } else {
        result.e(newOrderedOp($this, otherOp, true));
      }
    } else {
      result.e(newOrderedOp($this, otherOp, false));
    }
  }
  function isOnPath($this, item, op) {
    return equals(op.h3b(), item.z3v_1);
  }
  function diveInto($this, item, op, result) {
    var tmp = op.u3l();
    var targetOperation = isInterface(tmp, Operation) ? tmp : THROW_CCE();
    doTransform($this, ensureNotNull(item.c17()), targetOperation, result);
    restore($this, op, result);
  }
  function restore($this, wrapperOp, ops) {
    var _iterator__ex2g4s = ops.k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      if (!op.v3x_1) {
        var tmp = op.u3x_1;
        var operation = isInterface(tmp, Operation) ? tmp : THROW_CCE();
        op.u3x_1 = wrapperOp.y3p(operation);
      }
    }
  }
  function onCompositeOperation($this, item, otherOp, result) {
    var _iterator__ex2g4s = otherOp.l3i().k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      var childOps = ArrayList_init_$Create$();
      doTransform($this, item, op, childOps);
      append($this, result, childOps);
    }
  }
  function append($this, ops, other) {
    var _iterator__ex2g4s = other.k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      checkOrder($this, ops, op);
      ops.e(op);
    }
  }
  function checkOrder($this, ops, next) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!ops.p()) {
      var last_0 = last(ops);
      // Inline function 'kotlin.check' call
      if (!(last_0.x3x_1 === next.w3x_1)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
    }
  }
  function isDirectOperationOnSubtree($this, op) {
    var tmp;
    if (op instanceof ChildOperation) {
      tmp = op.r3i().equals($this.n3x_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function OrderedOperation(operation, toChangePath, start) {
    this.u3x_1 = operation;
    this.v3x_1 = toChangePath;
    this.w3x_1 = start;
    this.x3x_1 = this.w3x_1 + 1 | 0;
  }
  function RootOperationTransformer(from, to) {
    this.l3x_1 = from;
    this.m3x_1 = to;
    var tmp = this;
    var tmp_0 = this.l3x_1.i3w(0);
    tmp.n3x_1 = tmp_0 instanceof EntityId ? tmp_0 : THROW_CCE();
    this.o3x_1 = 0;
  }
  protoOf(RootOperationTransformer).p3x = function (otherOp) {
    var result = ArrayList_init_$Create$();
    doTransform(this, this.l3x_1, otherOp, result);
    var tmp;
    if (result.p()) {
      tmp = new NopOperation();
    } else {
      var tmp_0 = this.l3x_1.i3w(1);
      var role = tmp_0 instanceof EntityChildId ? tmp_0 : THROW_CCE();
      var ops = ArrayList_init_$Create$();
      var _iterator__ex2g4s = result.k();
      while (_iterator__ex2g4s.l()) {
        var op = _iterator__ex2g4s.m();
        var operation = op.u3x_1;
        var tmp_1;
        if (op.v3x_1) {
          var entitySetOperation = isInterface(operation, Operation) ? operation : THROW_CCE();
          tmp_1 = this.m3x_1.e3w(new ChildSetOperation(role, entitySetOperation));
        } else {
          tmp_1 = isInterface(operation, Operation) ? operation : THROW_CCE();
        }
        var opToAdd = tmp_1;
        ops.e(opToAdd);
      }
      tmp = Companion_instance_64.d3m(ops);
    }
    return tmp;
  };
  function create($this, entity, lower) {
    var $this_0 = $this;
    var entity_0 = entity;
    var lower_0 = lower;
    $l$1: do {
      $l$0: do {
        var parent = entity_0.yt();
        var tmp;
        if (parent == null) {
          tmp = new RootPathItem(entity_0.j2z_1, lower_0);
        } else {
          var tmp0 = $this_0;
          var tmp2 = new RolePathItem(ensureNotNull(entity_0.l2z_1), new EntityPathItem(entity_0.j2z_1, lower_0));
          $this_0 = tmp0;
          entity_0 = parent;
          lower_0 = tmp2;
          continue $l$0;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function removeLastEntityNode($this, pathItem) {
    if (ensureNotNull(ensureNotNull(pathItem.c17()).c17()).l()) {
      removeLastEntityNode($this, ensureNotNull(ensureNotNull(pathItem.k3w_1).d3w_1));
    } else {
      pathItem.l3w(null);
    }
  }
  function appendEntityNode($this, pathItem, toAppend) {
    if (pathItem.l() && ensureNotNull(pathItem.c17()).l()) {
      appendEntityNode($this, ensureNotNull(ensureNotNull(pathItem.k3w_1).d3w_1), toAppend);
    } else {
      pathItem.l3w(toAppend);
    }
  }
  function Companion_52() {
  }
  protoOf(Companion_52).b3x = function (entity) {
    return create(this, entity, null);
  };
  var Companion_instance_52;
  function Companion_getInstance_52() {
    return Companion_instance_52;
  }
  function RootPathItem(item, next) {
    PathItem.call(this, item);
    this.z3w_1 = next;
  }
  protoOf(RootPathItem).l3w = function (newValue) {
    var tmp = this;
    tmp.z3w_1 = (newValue == null ? true : newValue instanceof RolePathItem) ? newValue : THROW_CCE();
  };
  protoOf(RootPathItem).m3w = function (_set____db54di) {
    return this.l3w(_set____db54di);
  };
  protoOf(RootPathItem).c17 = function () {
    return this.z3w_1;
  };
  protoOf(RootPathItem).n3w = function () {
    return new RootPathItem(this.z3v_1, this.l() ? ensureNotNull(this.z3w_1).n3w() : null);
  };
  protoOf(RootPathItem).a3x = function () {
    if (ensureNotNull(ensureNotNull(this.z3w_1).c17()).l()) {
      removeLastEntityNode(this, ensureNotNull(ensureNotNull(this.z3w_1).d3w_1));
    } else {
      this.z3w_1 = null;
    }
    return this;
  };
  protoOf(RootPathItem).c3x = function (role, entityId) {
    var toAppend = new RolePathItem(role, new EntityPathItem(entityId, null));
    if (this.l() && ensureNotNull(this.z3w_1).l()) {
      appendEntityNode(this, ensureNotNull(ensureNotNull(this.z3w_1).d3w_1), toAppend);
    } else {
      this.z3w_1 = toAppend;
    }
    return this;
  };
  protoOf(RootPathItem).e3w = function (op) {
    var tmp;
    if (op.t3j()) {
      tmp = new NopOperation();
    } else {
      var tmp_0;
      if (this.l()) {
        tmp_0 = ensureNotNull(this.z3w_1).e3w(op);
      } else {
        tmp_0 = isInterface(op, Operation) ? op : THROW_CCE();
      }
      var operation = tmp_0;
      tmp = new ChangeRootEntityOperation(this.z3v_1, operation);
    }
    return tmp;
  };
  protoOf(RootPathItem).q3x = function (op) {
    var tmp = protoOf(PathItem).q3w.call(this, op);
    return isInterface(tmp, Operation) ? tmp : THROW_CCE();
  };
  protoOf(RootPathItem).q3w = function (op) {
    return this.q3x(op);
  };
  function AddChildOperationExecutor$installChecker$1(this$0) {
    EntityOperationsExecutorChecker.call(this, this$0.c3y_1, ensureNotNull(this$0.m3p_1).r3i(), this$0.h3r());
  }
  protoOf(AddChildOperationExecutor$installChecker$1).l35 = function (event) {
    this.k3y(event);
  };
  function AddChildOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseAddOperationExecutor.call(this, nodeFactory);
    this.c3y_1 = EntityId_init_$Create$();
    this.d3y_1 = EntityChildId_init_$Create$(Companion_getInstance_72().c3c_1);
  }
  protoOf(AddChildOperationExecutor).l3y = function (op) {
    return op instanceof AddChildOperation;
  };
  protoOf(AddChildOperationExecutor).q3r = function (op) {
    return this.l3y(op);
  };
  protoOf(AddChildOperationExecutor).m3y = function (op) {
    return EntityOperationsExecutorUtil_instance.n3y(ensureNotNull(this.m3p_1).r3i(), op);
  };
  protoOf(AddChildOperationExecutor).t3r = function (op) {
    return this.m3y(op);
  };
  protoOf(AddChildOperationExecutor).o3y = function (source) {
    var context = new EntityContext();
    var root = new Entity(EntityConceptId_init_$Create$(), this.c3y_1);
    context.c31_1.e(root);
    return context;
  };
  protoOf(AddChildOperationExecutor).v3r = function (source) {
    return this.o3y((!(source == null) ? isInterface(source, EntitySet) : false) ? source : THROW_CCE());
  };
  protoOf(AddChildOperationExecutor).w3r = function (tempContainer) {
    return EntityOperationsExecutorUtil_instance.p3y(tempContainer, this.c3y_1, this.d3y_1);
  };
  protoOf(AddChildOperationExecutor).x3r = function (tempContainer) {
    return this.w3r(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  protoOf(AddChildOperationExecutor).q3y = function (source, temp) {
    var entity = temp.w32(ensureNotNull(this.m3p_1).r3i());
    ensureNotNull(entity).i33();
    source.e(entity);
  };
  protoOf(AddChildOperationExecutor).z3r = function (source, temp) {
    var tmp = (!(source == null) ? isInterface(source, EntitySet) : false) ? source : THROW_CCE();
    return this.q3y(tmp, (!(temp == null) ? isInterface(temp, EntitySet) : false) ? temp : THROW_CCE());
  };
  protoOf(AddChildOperationExecutor).a3s = function (tempContainer) {
    return tempContainer.b35(new AddChildOperationExecutor$installChecker$1(this));
  };
  protoOf(AddChildOperationExecutor).b3s = function (tempContainer) {
    return this.a3s(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  function ChangeChildOperationExecutor$installChecker$1(this$0) {
    EntityOperationsExecutorChecker.call(this, this$0.v3y_1, ensureNotNull(this$0.m3p_1).r3i(), this$0.h3r());
  }
  protoOf(ChangeChildOperationExecutor$installChecker$1).s35 = function (event) {
    this.k3y(event);
  };
  function ChangeChildOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseRemoveOperationExecutor.call(this, nodeFactory);
    this.v3y_1 = EntityId_init_$Create$();
    this.w3y_1 = EntityChildId_init_$Create$(Companion_getInstance_72().c3c_1);
  }
  protoOf(ChangeChildOperationExecutor).l3y = function (op) {
    return op instanceof RemoveChildOperation;
  };
  protoOf(ChangeChildOperationExecutor).q3r = function (op) {
    return this.l3y(op);
  };
  protoOf(ChangeChildOperationExecutor).a3z = function (source) {
    return !(source.w32(ensureNotNull(this.m3p_1).r3i()) == null);
  };
  protoOf(ChangeChildOperationExecutor).i3s = function (source) {
    return this.a3z((!(source == null) ? isInterface(source, EntitySet) : false) ? source : THROW_CCE());
  };
  protoOf(ChangeChildOperationExecutor).b3z = function (op) {
    return EntityOperationsExecutorUtil_instance.n3y(ensureNotNull(this.m3p_1).r3i(), op);
  };
  protoOf(ChangeChildOperationExecutor).j3s = function (op) {
    return this.b3z(op);
  };
  protoOf(ChangeChildOperationExecutor).o3y = function (source) {
    var context = new EntityContext();
    var root = new Entity(EntityConceptId_init_$Create$(), this.v3y_1);
    context.c31_1.e(root);
    var entity = source.w32(ensureNotNull(this.m3p_1).r3i());
    root.w2z(this.w3y_1).e(Entities_getInstance().x2z(ensureNotNull(entity)));
    return context;
  };
  protoOf(ChangeChildOperationExecutor).v3r = function (source) {
    return this.o3y((!(source == null) ? isInterface(source, EntitySet) : false) ? source : THROW_CCE());
  };
  protoOf(ChangeChildOperationExecutor).w3r = function (tempContainer) {
    return EntityOperationsExecutorUtil_instance.p3y(tempContainer, this.v3y_1, this.w3y_1);
  };
  protoOf(ChangeChildOperationExecutor).x3r = function (tempContainer) {
    return this.w3r(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  protoOf(ChangeChildOperationExecutor).q3y = function (source, temp) {
    var entity = source.w32(ensureNotNull(this.m3p_1).r3i());
    // Inline function 'kotlin.collections.remove' call
    (isInterface(source, MutableCollection) ? source : THROW_CCE()).k2(entity);
  };
  protoOf(ChangeChildOperationExecutor).z3r = function (source, temp) {
    var tmp = (!(source == null) ? isInterface(source, EntitySet) : false) ? source : THROW_CCE();
    return this.q3y(tmp, (!(temp == null) ? isInterface(temp, EntitySet) : false) ? temp : THROW_CCE());
  };
  protoOf(ChangeChildOperationExecutor).a3s = function (tempContainer) {
    return tempContainer.b35(new ChangeChildOperationExecutor$installChecker$1(this));
  };
  protoOf(ChangeChildOperationExecutor).b3s = function (tempContainer) {
    return this.a3s(tempContainer instanceof EntityContext ? tempContainer : THROW_CCE());
  };
  function Companion_53() {
  }
  var Companion_instance_53;
  function Companion_getInstance_53() {
    return Companion_instance_53;
  }
  function ChildSetOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(ChildSetOperation).f3z = function (op) {
    return new ChildSetOperation(this.h3b(), op);
  };
  protoOf(ChildSetOperation).y3p = function (op) {
    return this.f3z(op);
  };
  protoOf(ChildSetOperation).a3v = function (source) {
    return source.w2z(this.h3b());
  };
  protoOf(ChildSetOperation).c3q = function (source) {
    return this.a3v(source instanceof Entity ? source : THROW_CCE());
  };
  protoOf(ChildSetOperation).b3 = function () {
    return 'setChild';
  };
  function handleMainEvent($this, e) {
    if (!$this.i3y_1.equals(e.o35_1.j2z_1)) {
      $this.j3y_1();
    }
  }
  function EntityOperationsExecutorChecker(myAllowedRootId, myAllowedChildId, myCanceller) {
    this.h3y_1 = myAllowedRootId;
    this.i3y_1 = myAllowedChildId;
    this.j3y_1 = myCanceller;
  }
  protoOf(EntityOperationsExecutorChecker).u35 = function (event) {
    if (!Entities_getInstance().q30(this.i3y_1, event.u34_1)) {
      this.j3y_1();
    }
  };
  protoOf(EntityOperationsExecutorChecker).k3y = function (e) {
    if (this.h3y_1.equals(e.u34_1.j2z_1)) {
      handleMainEvent(this, e);
    } else {
      this.u35(e);
    }
  };
  function EntityOperationsExecutorUtil() {
  }
  protoOf(EntityOperationsExecutorUtil).n3y = function (expectedId, op) {
    var tmp;
    if (op instanceof ChangeChildOperation) {
      tmp = expectedId.equals(op.h3b());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(EntityOperationsExecutorUtil).p3y = function (container, roodId, role) {
    return ensureNotNull(container.c31_1.w32(roodId)).w2z(role);
  };
  var EntityOperationsExecutorUtil_instance;
  function EntityOperationsExecutorUtil_getInstance() {
    return EntityOperationsExecutorUtil_instance;
  }
  function SetPropertyOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(SetPropertyOperation).b3 = function () {
    return 'setProperty';
  };
  protoOf(SetPropertyOperation).j3z = function (op) {
    return new SetPropertyOperation(this.h3b(), op);
  };
  protoOf(SetPropertyOperation).y3p = function (op) {
    return this.j3z(op);
  };
  protoOf(SetPropertyOperation).a3v = function (source) {
    return source.z2z(this.h3b());
  };
  protoOf(SetPropertyOperation).c3q = function (source) {
    return this.a3v(source instanceof Entity ? source : THROW_CCE());
  };
  protoOf(SetPropertyOperation).b3v = function (model, customExecute, nodeFactory) {
    var oldValue = this.a3v(model);
    var newValue = this.u3l().a3k(oldValue, nodeFactory);
    model.a30(this.h3b(), newValue);
    return model;
  };
  protoOf(SetPropertyOperation).d3v = function (model, customExecute, nodeFactory) {
    return this.b3v(model instanceof Entity ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(SetPropertyOperation).d3q = function (model, customExecute, nodeFactory) {
    return this.b3v(model instanceof Entity ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  function Companion_54() {
  }
  var Companion_instance_54;
  function Companion_getInstance_54() {
    return Companion_instance_54;
  }
  function SetReferenceOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(SetReferenceOperation).b3 = function () {
    return 'setEntityReference';
  };
  protoOf(SetReferenceOperation).n3z = function (op) {
    return new SetReferenceOperation(this.h3b(), op);
  };
  protoOf(SetReferenceOperation).y3p = function (op) {
    return this.n3z(op);
  };
  protoOf(SetReferenceOperation).a3v = function (source) {
    return source.c30(this.h3b());
  };
  protoOf(SetReferenceOperation).c3q = function (source) {
    return this.a3v(source instanceof Entity ? source : THROW_CCE());
  };
  function BaseAddOperationExecutor(nodeFactory) {
    BaseOperationExecutor.call(this, nodeFactory);
  }
  protoOf(BaseAddOperationExecutor).g3s = function () {
    return 2;
  };
  protoOf(BaseAddOperationExecutor).h3s = function () {
    return MainOpPos_FIRST_getInstance();
  };
  protoOf(BaseAddOperationExecutor).i3s = function (source) {
    return true;
  };
  protoOf(BaseAddOperationExecutor).j3s = function (op) {
    throw IllegalStateException_init_$Create$();
  };
  var MainOpPos_FIRST_instance;
  var MainOpPos_LAST_instance;
  var MainOpPos_ANY_instance;
  var MainOpPos_entriesInitialized;
  function MainOpPos_initEntries() {
    if (MainOpPos_entriesInitialized)
      return Unit_instance;
    MainOpPos_entriesInitialized = true;
    MainOpPos_FIRST_instance = new MainOpPos('FIRST', 0);
    MainOpPos_LAST_instance = new MainOpPos('LAST', 1);
    MainOpPos_ANY_instance = new MainOpPos('ANY', 2);
  }
  function canExecute($this, model, ops) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    if (!(model == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_3 = !ops.p();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = findAndSetMainOp($this, ops);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = $this.i3s(model);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = areNonMainOpsValid($this, ops);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      executeOnTemp($this, model, ops);
      tmp = !$this.o3p_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function findAndSetMainOp($this, ops) {
    $this.m3p_1 = findMainOp($this, ops);
    return !($this.m3p_1 == null);
  }
  function operationsToApplyCount($this, ops) {
    var tmp0 = $this.g3s();
    // Inline function 'kotlin.math.min' call
    var b = ops.n();
    return Math.min(tmp0, b);
  }
  function findMainOp($this, ops) {
    var mainOp = null;
    if (MainOpPos_FIRST_getInstance().equals($this.h3s()) && $this.q3r(first(ops))) {
      mainOp = first(ops);
    } else if (MainOpPos_LAST_getInstance().equals($this.h3s()) && $this.q3r(last(ops))) {
      mainOp = last(ops);
    } else if (MainOpPos_ANY_getInstance().equals($this.h3s())) {
      var _iterator__ex2g4s = ops.k();
      $l$loop: while (_iterator__ex2g4s.l()) {
        var op = _iterator__ex2g4s.m();
        if ($this.q3r(op)) {
          mainOp = op;
          break $l$loop;
        }
      }
    }
    return (mainOp == null ? true : isInterface(mainOp, Operation)) ? mainOp : THROW_CCE();
  }
  function areNonMainOpsValid($this, ops) {
    var mainOpPassed = false;
    var _iterator__ex2g4s = ops.k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      if (op === $this.m3p_1) {
        mainOpPassed = true;
      } else if (!mainOpPassed && !$this.j3s(op)) {
        return false;
      } else if (mainOpPassed && !$this.t3r(op)) {
        return false;
      }
    }
    return true;
  }
  function executeOnTemp($this, model, ops) {
    $this.n3p_1 = $this.v3r(model);
    var checkerReg = $this.b3s(ensureNotNull($this.n3p_1));
    var tempItem = $this.x3r(ensureNotNull($this.n3p_1));
    var i = ops.k();
    while (i.l() && !$this.o3p_1) {
      var operation = i.m();
      if (operation instanceof CustomExecuteOperation) {
        (operation instanceof CustomExecuteOperation ? operation : THROW_CCE()).d3v(tempItem, false, $this.l3p_1);
      } else {
        operation.a3k(tempItem, $this.l3p_1);
      }
    }
    checkerReg.vr();
  }
  function execute($this, model) {
    // Inline function 'kotlin.check' call
    if (!!$this.o3p_1) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.executor.BaseOperationExecutor.execute.<anonymous>' call
      var message = 'Execution was cancelled';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    $this.z3r(model, $this.x3r(ensureNotNull($this.n3p_1)));
  }
  function MainOpPos(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function BaseOperationExecutor$cancel$ref($boundThis) {
    var l = function () {
      $boundThis.i2n();
      return Unit_instance;
    };
    l.callableName = 'cancel';
    return l;
  }
  function MainOpPos_FIRST_getInstance() {
    MainOpPos_initEntries();
    return MainOpPos_FIRST_instance;
  }
  function MainOpPos_LAST_getInstance() {
    MainOpPos_initEntries();
    return MainOpPos_LAST_instance;
  }
  function MainOpPos_ANY_getInstance() {
    MainOpPos_initEntries();
    return MainOpPos_ANY_instance;
  }
  function BaseOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.l3p_1 = nodeFactory;
    this.m3p_1 = null;
    this.n3p_1 = null;
    this.o3p_1 = false;
  }
  protoOf(BaseOperationExecutor).p3p = function (model, ops) {
    var trimmedOps = ops.j2(0, operationsToApplyCount(this, ops));
    if (canExecute(this, model, trimmedOps)) {
      execute(this, model);
      return ExecutionResult_init_$Create$(trimmedOps.n());
    }
    return Companion_getInstance_65().o3z_1;
  };
  protoOf(BaseOperationExecutor).i2n = function () {
    this.o3p_1 = true;
  };
  protoOf(BaseOperationExecutor).h3r = function () {
    return BaseOperationExecutor$cancel$ref(this);
  };
  function BaseRemoveOperationExecutor(nodeFactory) {
    BaseOperationExecutor.call(this, nodeFactory);
  }
  protoOf(BaseRemoveOperationExecutor).g3s = function () {
    return 2;
  };
  protoOf(BaseRemoveOperationExecutor).h3s = function () {
    return MainOpPos_LAST_getInstance();
  };
  protoOf(BaseRemoveOperationExecutor).t3r = function (op) {
    throw IllegalStateException_init_$Create$();
  };
  function OperationCondition() {
  }
  protoOf(OperationCondition).y3o = function (op) {
    return this.r3m(op);
  };
  protoOf(OperationCondition).z3o = function (op) {
    if (this.r3m(op))
      return true;
    if (isInterface(op, OperationContainer)) {
      var _iterator__ex2g4s = (isInterface(op, OperationContainer) ? op : THROW_CCE()).l3i().k();
      while (_iterator__ex2g4s.l()) {
        var operation = _iterator__ex2g4s.m();
        if (this.z3o(operation)) {
          return true;
        }
      }
    }
    return false;
  };
  protoOf(OperationCondition).q3m = function (op) {
    if (this.r3m(op))
      return Unit_instance;
    if (isInterface(op, OperationContainer)) {
      var _iterator__ex2g4s = (isInterface(op, OperationContainer) ? op : THROW_CCE()).l3i().k();
      while (_iterator__ex2g4s.l()) {
        var operation = _iterator__ex2g4s.m();
        this.q3m(operation);
      }
    }
  };
  function IndexedAddOperation() {
  }
  function IndexedOperation() {
  }
  function open($this, s, e) {
    return Companion_instance_36.q2s(s, e);
  }
  function checkOperationsHaveLength($this, expectedLength, ops) {
    var inductionVariable = 0;
    var last = ops.length;
    while (inductionVariable < last) {
      var op = ops[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (!(op.a() === expectedLength)) {
        return false;
      }
    }
    return true;
  }
  function IndexedOperationTransformer() {
  }
  protoOf(IndexedOperationTransformer).s3z = function (op1, op2, server) {
    var r1 = open(this, op1.i3b(), op1.i3b() + op1.a() | 0);
    var r2 = open(this, op2.i3b(), op2.i3b() + op2.a() | 0);
    var tmp;
    if (isInterface(op1, IndexedAddOperation)) {
      tmp = isInterface(op2, IndexedAddOperation);
    } else {
      tmp = false;
    }
    if (tmp) {
      var iao1 = isInterface(op1, IndexedAddOperation) ? op1 : THROW_CCE();
      var iao2 = isInterface(op2, IndexedAddOperation) ? op2 : THROW_CCE();
      var tmp_0;
      if (iao1.i3b() > iao2.i3b()) {
        tmp_0 = 0;
      } else if (iao1.i3b() < iao2.i3b()) {
        tmp_0 = iao1.a();
      } else if (iao1.p3z().d3(iao2.p3z()) > 0 || (iao1.p3z().equals(iao2.p3z()) && server)) {
        tmp_0 = iao1.a();
      } else {
        tmp_0 = 0;
      }
      var delta = tmp_0;
      return iao2.q3z(iao2.i3b() + delta | 0);
    }
    var tmp_1;
    if (isInterface(op1, IndexedRemoveOperation)) {
      tmp_1 = isInterface(op2, IndexedRemoveOperation);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var iro1 = isInterface(op1, IndexedRemoveOperation) ? op1 : THROW_CCE();
      var iro2 = isInterface(op2, IndexedRemoveOperation) ? op2 : THROW_CCE();
      var intersection = r1.d2t(r2) ? r1.e2t(r2) : null;
      var tmp_2;
      if (intersection == null || intersection.p()) {
        var tmp_3;
        if (iro1.i3b() > iro2.i3b()) {
          tmp_3 = iro2;
        } else {
          tmp_3 = iro2.q3z(iro2.i3b() - iro1.a() | 0);
        }
        tmp_2 = tmp_3;
      } else {
        var message = 'Intersection of remove operations should be resolved outside of transformer';
        throw IllegalStateException_init_$Create$_0(message);
      }
      return tmp_2;
    }
    var tmp_4;
    if (isInterface(op1, IndexedRemoveOperation)) {
      tmp_4 = isInterface(op2, IndexedAddOperation);
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      var iro = isInterface(op1, IndexedRemoveOperation) ? op1 : THROW_CCE();
      var iao = isInterface(op2, IndexedAddOperation) ? op2 : THROW_CCE();
      var tmp_5;
      if (iro.i3b() >= iao.i3b()) {
        tmp_5 = iao;
      } else if (r1.a2t(iao.i3b())) {
        tmp_5 = new NopOperation();
      } else {
        tmp_5 = iao.q3z(iao.i3b() - iro.a() | 0);
      }
      return tmp_5;
    }
    var tmp_6;
    if (isInterface(op1, IndexedAddOperation)) {
      tmp_6 = isInterface(op2, IndexedRemoveOperation);
    } else {
      tmp_6 = false;
    }
    if (tmp_6) {
      var iao_0 = isInterface(op1, IndexedAddOperation) ? op1 : THROW_CCE();
      var iro_0 = isInterface(op2, IndexedRemoveOperation) ? op2 : THROW_CCE();
      var tmp_7;
      if (iro_0.i3b() >= iao_0.i3b()) {
        tmp_7 = iro_0.q3z(iro_0.i3b() + iao_0.a() | 0);
      } else if (r2.a2t(iao_0.i3b())) {
        tmp_7 = iro_0.t3z(iao_0);
      } else {
        tmp_7 = iro_0;
      }
      return tmp_7;
    }
    var tmp_8;
    var tmp_9;
    if (isInterface(op1, IndexedReplaceOperation)) {
      tmp_9 = isInterface(op2, IndexedRemoveOperation);
    } else {
      tmp_9 = false;
    }
    if (tmp_9) {
      tmp_8 = checkOperationsHaveLength(this, 1, [op1, op2]);
    } else {
      tmp_8 = false;
    }
    if (tmp_8) {
      var iRepO = isInterface(op1, IndexedReplaceOperation) ? op1 : THROW_CCE();
      var iRemO = isInterface(op2, IndexedRemoveOperation) ? op2 : THROW_CCE();
      var tmp_10;
      if (iRepO.i3b() === iRemO.i3b()) {
        tmp_10 = iRemO.u3z(iRepO);
      } else {
        tmp_10 = iRemO;
      }
      return tmp_10;
    }
    var tmp_11;
    var tmp_12;
    if (isInterface(op1, IndexedRemoveOperation)) {
      tmp_12 = isInterface(op2, IndexedReplaceOperation);
    } else {
      tmp_12 = false;
    }
    if (tmp_12) {
      tmp_11 = checkOperationsHaveLength(this, 1, [op1, op2]);
    } else {
      tmp_11 = false;
    }
    if (tmp_11) {
      var iRemO_0 = isInterface(op1, IndexedRemoveOperation) ? op1 : THROW_CCE();
      var iRepO_0 = isInterface(op2, IndexedReplaceOperation) ? op2 : THROW_CCE();
      var tmp_13;
      if (iRepO_0.i3b() > iRemO_0.i3b()) {
        tmp_13 = iRepO_0.q3z(iRepO_0.i3b() - iRemO_0.a() | 0);
      } else if (iRepO_0.i3b() === iRemO_0.i3b()) {
        tmp_13 = new NopOperation();
      } else {
        tmp_13 = iRepO_0;
      }
      return tmp_13;
    }
    var tmp_14;
    var tmp_15;
    if (isInterface(op1, IndexedAddOperation)) {
      tmp_15 = isInterface(op2, IndexedReplaceOperation);
    } else {
      tmp_15 = false;
    }
    if (tmp_15) {
      tmp_14 = checkOperationsHaveLength(this, 1, [op1, op2]);
    } else {
      tmp_14 = false;
    }
    if (tmp_14) {
      var iao_1 = isInterface(op1, IndexedAddOperation) ? op1 : THROW_CCE();
      var iRepO_1 = isInterface(op2, IndexedReplaceOperation) ? op2 : THROW_CCE();
      var tmp_16;
      if (iRepO_1.i3b() >= iao_1.i3b()) {
        tmp_16 = iRepO_1.q3z(iRepO_1.i3b() + iao_1.a() | 0);
      } else {
        tmp_16 = iRepO_1;
      }
      return tmp_16;
    }
    var tmp_17;
    var tmp_18;
    if (isInterface(op1, IndexedReplaceOperation)) {
      tmp_18 = isInterface(op2, IndexedAddOperation);
    } else {
      tmp_18 = false;
    }
    if (tmp_18) {
      tmp_17 = checkOperationsHaveLength(this, 1, [op1, op2]);
    } else {
      tmp_17 = false;
    }
    if (tmp_17) {
      return op2;
    }
    var tmp_19;
    var tmp_20;
    if (isInterface(op1, IndexedReplaceOperation)) {
      tmp_20 = isInterface(op2, IndexedReplaceOperation);
    } else {
      tmp_20 = false;
    }
    if (tmp_20) {
      tmp_19 = checkOperationsHaveLength(this, 1, [op1, op2]);
    } else {
      tmp_19 = false;
    }
    if (tmp_19) {
      var iRepO1 = isInterface(op1, IndexedReplaceOperation) ? op1 : THROW_CCE();
      var iRepO2 = isInterface(op2, IndexedReplaceOperation) ? op2 : THROW_CCE();
      var tmp_21;
      if (iRepO1.i3b() === iRepO2.i3b()) {
        var tmp_22;
        if (server) {
          tmp_22 = new NopOperation();
        } else {
          tmp_22 = iRepO2.u3z(iRepO1);
        }
        tmp_21 = tmp_22;
      } else {
        tmp_21 = iRepO2;
      }
      return tmp_21;
    }
    throw IllegalArgumentException_init_$Create$_0(toString_1(op1) + '; ' + toString_1(op2));
  };
  function IndexedRemoveOperation() {
  }
  function IndexedReplaceOperation() {
  }
  var Priority_NORMAL_instance;
  var Priority_HIGH_instance;
  var Priority_entriesInitialized;
  function Priority_initEntries() {
    if (Priority_entriesInitialized)
      return Unit_instance;
    Priority_entriesInitialized = true;
    Priority_NORMAL_instance = new Priority('NORMAL', 0);
    Priority_HIGH_instance = new Priority('HIGH', 1);
  }
  function Priority(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Priority_NORMAL_getInstance() {
    Priority_initEntries();
    return Priority_NORMAL_instance;
  }
  function Priority_HIGH_getInstance() {
    Priority_initEntries();
    return Priority_HIGH_instance;
  }
  function Accumulator() {
  }
  function _get_accumulators__7t2b7i($this) {
    var accumulators = ArrayList_init_$Create$();
    accumulators.e(new SetValueAccumulator());
    accumulators.e(new EntityReferenceAccumulator());
    accumulators.e(new ModelAccumulator($this));
    accumulators.e(new RootOperationsAccumulator($this));
    accumulators.e(new SetPropertyAccumulator($this));
    accumulators.e(new EntityChildAccumulator($this));
    accumulators.e(new EntityChildSetAccumulator($this));
    accumulators.e(new SetReferenceAccumulator($this));
    accumulators.e(new ChangeModelAccumulator());
    return accumulators;
  }
  function collectFromAccumulators($this, accumulators, result) {
    var _iterator__ex2g4s = accumulators.k();
    while (_iterator__ex2g4s.l()) {
      var accumulator = _iterator__ex2g4s.m();
      var ops = accumulator.x3z();
      result.o(isInterface(ops, Collection) ? ops : THROW_CCE());
    }
  }
  function accumulate($this, accumulators, operation) {
    var _iterator__ex2g4s = accumulators.k();
    while (_iterator__ex2g4s.l()) {
      var accumulator = _iterator__ex2g4s.m();
      if (accumulator.v3z(operation)) {
        var opAccumulator = isInterface(accumulator, Accumulator) ? accumulator : THROW_CCE();
        opAccumulator.w3z(operation);
        return true;
      }
    }
    return false;
  }
  function unwrapAndRemoveNops($this, op, annotationData) {
    var tmp;
    if (op instanceof AnnotatedOperation) {
      annotationData.b40(op);
      tmp = unwrapAndRemoveNops($this, op.f40_1, annotationData);
    } else {
      if (op instanceof CompositeOperation) {
        var result = ArrayList_init_$Create$();
        var _iterator__ex2g4s = op.l3i().k();
        while (_iterator__ex2g4s.l()) {
          var innerOp = _iterator__ex2g4s.m();
          result.o(unwrapAndRemoveNops($this, innerOp, annotationData));
        }
        tmp = result;
      } else {
        if (op.t3j()) {
          tmp = emptyList();
        } else {
          tmp = listOf(op);
        }
      }
    }
    return tmp;
  }
  function AnnotationData() {
    this.y3z_1 = null;
    this.z3z_1 = new Long(0, 0);
    this.a40_1 = false;
  }
  protoOf(AnnotationData).b40 = function (op) {
    var opAuthor = op.d40_1;
    if (this.a40_1) {
      if (!(this.y3z_1 == opAuthor)) {
        this.y3z_1 = 'Various authors';
      }
    } else {
      this.a40_1 = true;
      this.y3z_1 = opAuthor;
      this.z3z_1 = op.e40_1;
    }
  };
  protoOf(AnnotationData).g40 = function (op) {
    var tmp;
    if (this.a40_1) {
      tmp = new AnnotatedOperation(this.y3z_1, this.z3z_1, op);
    } else {
      tmp = op;
    }
    return tmp;
  };
  function RootOperationsAccumulator(merger) {
    AddChangeRemoveAccumulator.call(this, merger, new RootOperationUtil());
  }
  function EntityChildAccumulator(merger) {
    AddChangeRemoveAccumulator.call(this, merger, new ChildOperationUtil());
  }
  function ModelAccumulator(merger) {
    AddChangeRemoveAccumulator.call(this, merger, new ModelBlobOperationUtil());
  }
  function Companion_55() {
    this.n40_1 = 'Various authors';
  }
  var Companion_instance_55;
  function Companion_getInstance_55() {
    return Companion_instance_55;
  }
  function AccumulatorBasedMerger() {
  }
  protoOf(AccumulatorBasedMerger).u3j = function (operations) {
    var annotationData = new AnnotationData();
    var accumulatorList = _get_accumulators__7t2b7i(this);
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = operations.k();
    while (_iterator__ex2g4s.l()) {
      var operation = _iterator__ex2g4s.m();
      var unwrapped = unwrapAndRemoveNops(this, operation, annotationData);
      var _iterator__ex2g4s_0 = unwrapped.k();
      while (_iterator__ex2g4s_0.l()) {
        var innerOp = _iterator__ex2g4s_0.m();
        var accumulatorFound = accumulate(this, accumulatorList, innerOp);
        if (!accumulatorFound) {
          ThrowableHandlers_getInstance().ps_1.os(RuntimeException_init_$Create$_0('Operation unsupported by merger found: ' + getKClassFromExpression(innerOp).lb()));
          collectFromAccumulators(this, accumulatorList, result);
          result.o(unwrapped);
          accumulatorList = _get_accumulators__7t2b7i(this);
        }
      }
    }
    collectFromAccumulators(this, accumulatorList, result);
    var composed = Companion_instance_64.d3m(result);
    return annotationData.g40(composed);
  };
  function AddChangeRemoveAccumulator$addOp$1(this$0) {
    this.o40_1 = this$0;
  }
  protoOf(AddChangeRemoveAccumulator$addOp$1).u3j = function (operations) {
    return this.o40_1.m40(operations);
  };
  function AddChangeRemoveAccumulator(merger, util) {
    MergerBasedAccumulator.call(this, merger);
    this.i40_1 = util;
    this.j40_1 = new ListMap();
  }
  protoOf(AddChangeRemoveAccumulator).v3z = function (op) {
    return this.i40_1.j3q(op) || this.i40_1.k3q(op) || this.i40_1.l3q(op);
  };
  protoOf(AddChangeRemoveAccumulator).k40 = function (op) {
    var role = this.i40_1.n3q(op);
    if (!this.j40_1.w2(role)) {
      this.j40_1.r2(role, new OperationsInfo(this.i40_1, new AddChangeRemoveAccumulator$addOp$1(this)));
    }
    var info = this.j40_1.y2(role);
    if (this.i40_1.j3q(op)) {
      ensureNotNull(info).z40(op);
    } else if (this.i40_1.k3q(op)) {
      ensureNotNull(info).y40(op);
    } else if (this.i40_1.l3q(op)) {
      ensureNotNull(info).x40(op);
    }
  };
  protoOf(AddChangeRemoveAccumulator).w3z = function (op) {
    return this.k40(isInterface(op, Operation) ? op : THROW_CCE());
  };
  protoOf(AddChangeRemoveAccumulator).x3z = function () {
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = this.j40_1.qp().k();
    while (_iterator__ex2g4s.l()) {
      var roleInfoEntry = _iterator__ex2g4s.m();
      var info = roleInfoEntry.fp();
      var role = roleInfoEntry.ep();
      result.o(info.a41(role));
    }
    return result;
  };
  function ChangeModelAccumulator() {
    MergerBasedAccumulator.call(this, Companion_instance_56.b2p());
    this.c41_1 = ArrayList_init_$Create$();
  }
  protoOf(ChangeModelAccumulator).v3z = function (op) {
    return op instanceof SetModelOperation;
  };
  protoOf(ChangeModelAccumulator).d41 = function (op) {
    this.c41_1.e(op);
  };
  protoOf(ChangeModelAccumulator).w3z = function (op) {
    return this.d41(isInterface(op, Operation) ? op : THROW_CCE());
  };
  protoOf(ChangeModelAccumulator).x3z = function () {
    var mergeResult = this.m40(this.c41_1);
    return mergeResult.t3j() ? emptyList() : listOf(mergeResult);
  };
  function EntityChildSetAccumulator(merger) {
    TargetedOperationAccumulator.call(this, merger);
  }
  protoOf(EntityChildSetAccumulator).v3z = function (op) {
    return op instanceof ChildSetOperation;
  };
  function ReferenceOperationUtil() {
  }
  protoOf(ReferenceOperationUtil).j3q = function (op) {
    return op instanceof AddToSetOperation;
  };
  protoOf(ReferenceOperationUtil).k3q = function (op) {
    return op instanceof RemoveFromSetOperation;
  };
  protoOf(ReferenceOperationUtil).l3q = function (op) {
    return false;
  };
  protoOf(ReferenceOperationUtil).l41 = function (op) {
    return (op instanceof ChangeSetOperation ? op : THROW_CCE()).n41_1;
  };
  protoOf(ReferenceOperationUtil).n3q = function (op) {
    return this.l41(op);
  };
  protoOf(ReferenceOperationUtil).p41 = function (op) {
    var changeSetOp = op instanceof ChangeSetOperation ? op : THROW_CCE();
    return new EntityReferenceData(changeSetOp.n41_1, changeSetOp.o41_1);
  };
  protoOf(ReferenceOperationUtil).p3q = function (op) {
    return this.p41(op);
  };
  protoOf(ReferenceOperationUtil).q41 = function (role, data) {
    return new AddToSetOperation(data.r41_1, data.s41_1);
  };
  protoOf(ReferenceOperationUtil).r3q = function (role, data) {
    var tmp = role instanceof EntityReference ? role : THROW_CCE();
    return this.q41(tmp, data instanceof EntityReferenceData ? data : THROW_CCE());
  };
  protoOf(ReferenceOperationUtil).t41 = function (role, data) {
    return new RemoveFromSetOperation(data.r41_1, data.s41_1);
  };
  protoOf(ReferenceOperationUtil).t3q = function (role, data) {
    var tmp = role instanceof EntityReference ? role : THROW_CCE();
    return this.t41(tmp, data instanceof EntityReferenceData ? data : THROW_CCE());
  };
  protoOf(ReferenceOperationUtil).u41 = function (role, innerOp) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(ReferenceOperationUtil).v3q = function (role, innerOp) {
    return this.u41(role instanceof EntityReference ? role : THROW_CCE(), innerOp);
  };
  function EntityReferenceData(ref, singleRole) {
    this.r41_1 = ref;
    this.s41_1 = singleRole;
  }
  protoOf(EntityReferenceData).toString = function () {
    return 'EntityReferenceData(ref=' + this.r41_1.toString() + ', singleRole=' + this.s41_1 + ')';
  };
  protoOf(EntityReferenceData).hashCode = function () {
    var result = this.r41_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.s41_1) | 0;
    return result;
  };
  protoOf(EntityReferenceData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityReferenceData))
      return false;
    var tmp0_other_with_cast = other instanceof EntityReferenceData ? other : THROW_CCE();
    if (!this.r41_1.equals(tmp0_other_with_cast.r41_1))
      return false;
    if (!(this.s41_1 === tmp0_other_with_cast.s41_1))
      return false;
    return true;
  };
  function EntityReferenceAccumulator() {
    AddChangeRemoveAccumulator.call(this, null, new ReferenceOperationUtil());
  }
  function MergerBasedAccumulator(merger) {
    this.l40_1 = merger;
  }
  protoOf(MergerBasedAccumulator).m40 = function (ops) {
    return ensureNotNull(this.l40_1).u3j(ops);
  };
  function assertNoChangesBeforeAdd($this) {
    if (!$this.s40_1.p()) {
      var builder = new StringBuilder('Got operations changing item before adding item itself:\n');
      builder.d9('Changing ops:\n');
      var _iterator__ex2g4s = $this.s40_1.k();
      while (_iterator__ex2g4s.l()) {
        var existingOp = _iterator__ex2g4s.m();
        builder.d9(existingOp.s3p()).d9('\n');
      }
      throw IllegalStateException_init_$Create$_0(builder.toString());
    }
  }
  function mergeAndAddToResult($this, ops, result, role) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!ops.p()) {
      var mergedOp = $this.q40_1.u3j(ops);
      if (!mergedOp.t3j()) {
        result.e($this.p40_1.v3q(role, mergedOp));
      }
    }
  }
  function collectAddChangeOps($this, ops, role) {
    var result = ArrayList_init_$Create$();
    if ($this.t40_1) {
      result.e($this.p40_1.r3q(role, ensureNotNull($this.u40_1)));
    }
    mergeAndAddToResult($this, ops, result, role);
    return result;
  }
  function OperationsInfo(util, merger) {
    this.p40_1 = util;
    this.q40_1 = merger;
    this.r40_1 = false;
    this.s40_1 = ArrayList_init_$Create$();
    this.t40_1 = false;
    this.u40_1 = null;
    this.v40_1 = null;
    this.w40_1 = null;
  }
  protoOf(OperationsInfo).z40 = function (op) {
    this.r40_1 = true;
    // Inline function 'kotlin.check' call
    if (!!this.t40_1) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.merger.accumulator.OperationsInfo.registerAdd.<anonymous>' call
      var message = 'Unexpected add operation: object with this role was added already';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    assertNoChangesBeforeAdd(this);
    this.u40_1 = this.p40_1.p3q(op);
    this.t40_1 = true;
  };
  protoOf(OperationsInfo).y40 = function (op) {
    if (this.r40_1) {
      if (this.t40_1) {
        var curData = this.p40_1.p3q(op);
        // Inline function 'kotlin.check' call
        if (!equals(this.u40_1, curData)) {
          // Inline function 'jetbrains.ocelot.ot.model.ot.merger.accumulator.OperationsInfo.registerRemove.<anonymous>' call
          var message = 'Unequal data for add and remove operations';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        this.s40_1.m2();
        this.t40_1 = false;
      } else {
        throw IllegalStateException_init_$Create$_0('Unexpected remove operation: remove without corresponding add');
      }
    } else {
      this.r40_1 = true;
      this.v40_1 = this.p40_1.p3q(op);
      this.w40_1 = ArrayList_init_$Create$_1(this.s40_1);
      this.s40_1.m2();
    }
  };
  protoOf(OperationsInfo).x40 = function (op) {
    var targetedOperation = op instanceof TargetedOperation ? op : THROW_CCE();
    this.s40_1.e(targetedOperation.u3l());
  };
  protoOf(OperationsInfo).a41 = function (role) {
    if (!(this.v40_1 == null)) {
      var result = ArrayList_init_$Create$();
      if (equals(this.v40_1, this.u40_1)) {
        if (!this.t40_1) {
          // Inline function 'kotlin.check' call
          if (!this.s40_1.p()) {
            // Inline function 'jetbrains.ocelot.ot.model.ot.merger.accumulator.OperationsInfo.collectOps.<anonymous>' call
            var message = 'Non-empty inner operations though no add happened after remove';
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
          mergeAndAddToResult(this, ensureNotNull(this.w40_1), result, role);
          result.e(this.p40_1.t3q(role, ensureNotNull(this.v40_1)));
        } else {
          var allOps = ArrayList_init_$Create$_1(ensureNotNull(this.w40_1));
          allOps.o(this.s40_1);
          mergeAndAddToResult(this, allOps, result, role);
        }
      } else {
        mergeAndAddToResult(this, ensureNotNull(this.w40_1), result, role);
        result.e(this.p40_1.t3q(role, ensureNotNull(this.v40_1)));
        result.o(collectAddChangeOps(this, this.s40_1, role));
      }
      return result;
    }
    return collectAddChangeOps(this, this.s40_1, role);
  };
  function SetPropertyAccumulator(merger) {
    TargetedOperationAccumulator.call(this, merger);
  }
  protoOf(SetPropertyAccumulator).v3z = function (op) {
    return op instanceof SetPropertyOperation;
  };
  function SetReferenceAccumulator(merger) {
    TargetedOperationAccumulator.call(this, merger);
  }
  protoOf(SetReferenceAccumulator).v3z = function (op) {
    return op instanceof SetReferenceOperation;
  };
  function nullOrString($this, o) {
    var tmp;
    if (o == null) {
      tmp = true;
    } else {
      tmp = !(o == null) ? typeof o === 'string' : false;
    }
    return tmp;
  }
  function SetValueAccumulator() {
    this.b42_1 = false;
    this.c42_1 = null;
    this.d42_1 = null;
  }
  protoOf(SetValueAccumulator).v3z = function (op) {
    var tmp;
    if (!(op instanceof SetValueOperation)) {
      tmp = false;
    } else {
      tmp = (nullOrString(this, op.f42_1) && nullOrString(this, op.g42_1));
    }
    return tmp;
  };
  protoOf(SetValueAccumulator).h42 = function (op) {
    var setValueOp = op instanceof SetValueOperation ? op : THROW_CCE();
    if (!this.b42_1) {
      this.c42_1 = setValueOp.f42_1;
      this.b42_1 = true;
    }
    this.d42_1 = setValueOp.g42_1;
  };
  protoOf(SetValueAccumulator).w3z = function (op) {
    return this.h42(isInterface(op, Operation) ? op : THROW_CCE());
  };
  protoOf(SetValueAccumulator).x3z = function () {
    var tmp;
    if (this.b42_1 && !(this.c42_1 == this.d42_1)) {
      tmp = listOf(new SetValueOperation(this.c42_1, this.d42_1));
    } else {
      tmp = emptyList();
    }
    return tmp;
  };
  function TargetedOperationAccumulator$addOp$lambda($op) {
    return function (value) {
      var tmp = $op.y3p(value);
      return tmp instanceof TargetedOperation ? tmp : THROW_CCE();
    };
  }
  function TargetedOperationAccumulator(merger) {
    MergerBasedAccumulator.call(this, merger);
    this.i41_1 = HashMap_init_$Create$();
    this.j41_1 = HashMap_init_$Create$();
  }
  protoOf(TargetedOperationAccumulator).k41 = function (op) {
    var role = op.h3b();
    if (!this.i41_1.w2(role)) {
      var tmp0 = this.i41_1;
      // Inline function 'kotlin.collections.set' call
      var value = ArrayList_init_$Create$();
      tmp0.r2(role, value);
      var tmp3 = this.j41_1;
      // Inline function 'kotlin.collections.set' call
      var value_0 = TargetedOperationAccumulator$addOp$lambda(op);
      tmp3.r2(role, value_0);
    }
    getValue_0(this.i41_1, role).e(op.u3l());
  };
  protoOf(TargetedOperationAccumulator).w3z = function (op) {
    return this.k41(op instanceof TargetedOperation ? op : THROW_CCE());
  };
  protoOf(TargetedOperationAccumulator).x3z = function () {
    var result = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.i41_1.w().k();
    while (_iterator__ex2g4s.l()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.x();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.y();
      var merge = this.m40(value);
      if (!merge.t3j()) {
        result.e(getValue_0(this.j41_1, key)(merge));
      }
    }
    return result;
  };
  function BaseDataOperationRule() {
    BaseMergeOperationsRule.call(this);
  }
  protoOf(BaseDataOperationRule).k42 = function (op1, op2) {
    var tmp;
    if (!this.i42(op1) || !this.j42(op2)) {
      tmp = false;
    } else {
      tmp = equals(this.l42(op1), this.m42(op2));
    }
    return tmp;
  };
  function BaseMergeOperationsRule() {
  }
  protoOf(BaseMergeOperationsRule).n42 = function (op1, op2) {
    if (this.k42(op1, op2)) {
      return this.o42(op1, op2);
    }
    throw IllegalArgumentException_init_$Create$_0('Operations are not same: ' + toString_1(op1) + ' ' + toString_1(op2));
  };
  function BaseMutuallyInverseOperationRule() {
    BaseDataOperationRule.call(this);
  }
  protoOf(BaseMutuallyInverseOperationRule).o42 = function (op1, op2) {
    return new NopOperation();
  };
  protoOf(BaseMutuallyInverseOperationRule).l42 = function (op) {
    return this.p42(op);
  };
  protoOf(BaseMutuallyInverseOperationRule).m42 = function (op) {
    return this.p42(op);
  };
  function EntityChildAddRemoveRule() {
    BaseMutuallyInverseOperationRule.call(this);
  }
  protoOf(EntityChildAddRemoveRule).i42 = function (op) {
    return op instanceof AddChildOperation;
  };
  protoOf(EntityChildAddRemoveRule).j42 = function (op) {
    return op instanceof RemoveChildOperation;
  };
  protoOf(EntityChildAddRemoveRule).p42 = function (op) {
    return (op instanceof ChildOperation ? op : THROW_CCE()).q3i_1;
  };
  function getOperationsList($this, op) {
    var tmp;
    if (op instanceof CompositeOperation) {
      tmp = (op instanceof CompositeOperation ? op : THROW_CCE()).l3i();
    } else {
      tmp = listOf(op);
    }
    return tmp;
  }
  function tryMergeInner($this, op1, op2) {
    var merged = $this.r42(op1, op2);
    var tmp;
    if (merged instanceof CompositeOperation) {
      tmp = null;
    } else {
      tmp = merged;
    }
    return tmp;
  }
  function MergeCompositeOperationsRule(innerOperationsMerger) {
    MergeContainerOperationsRule.call(this, innerOperationsMerger);
  }
  protoOf(MergeCompositeOperationsRule).o42 = function (op1, op2) {
    var ops1 = getOperationsList(this, op1);
    var ops2 = getOperationsList(this, op2);
    if (ops1.p()) {
      return Companion_instance_64.d3m(ops2);
    }
    if (ops2.p()) {
      return Companion_instance_64.d3m(ops1);
    }
    var index1 = ops1.n() - 1 | 0;
    var index2 = 0;
    var merged = tryMergeInner(this, ops1.q(index1), ops2.q(index2));
    if (merged == null) {
      var operations = ArrayList_init_$Create$();
      operations.o(ops1);
      operations.o(ops2);
      return Companion_instance_64.d3m(operations);
    }
    index1 = index1 - 1 | 0;
    index2 = index2 + 1 | 0;
    while (index1 >= 0 || index2 < ops2.n()) {
      var mergedAny = false;
      if (index1 >= 0) {
        var result = tryMergeInner(this, ops1.q(index1), ensureNotNull(merged));
        if (!(result == null)) {
          merged = result;
          index1 = index1 - 1 | 0;
          mergedAny = true;
        }
      }
      if (index2 < ops2.n()) {
        var result_0 = tryMergeInner(this, ensureNotNull(merged), ops2.q(index2));
        if (!(result_0 == null)) {
          merged = result_0;
          index2 = index2 + 1 | 0;
          mergedAny = true;
        }
      }
      if (!mergedAny) {
        var operations_0 = ArrayList_init_$Create$_1(ops1.j2(0, index1 + 1 | 0));
        operations_0.e(ensureNotNull(merged));
        operations_0.o(subListTail(ops2, index2));
        return Companion_instance_64.d3m(operations_0);
      }
    }
    return ensureNotNull(merged);
  };
  protoOf(MergeCompositeOperationsRule).k42 = function (op1, op2) {
    var tmp;
    if (op1 instanceof CompositeOperation) {
      tmp = true;
    } else {
      tmp = op2 instanceof CompositeOperation;
    }
    return tmp;
  };
  function MergeContainerOperationsRule(innerOperationsMerger) {
    BaseMergeOperationsRule.call(this);
    this.q42_1 = innerOperationsMerger;
  }
  protoOf(MergeContainerOperationsRule).r42 = function (op1, op2) {
    return this.q42_1.u3j(listOf_0([op1, op2]));
  };
  function MergeSetValueOperationsRule() {
    BaseMergeOperationsRule.call(this);
  }
  protoOf(MergeSetValueOperationsRule).o42 = function (op1, op2) {
    var setValue1 = op1 instanceof SetValueOperation ? op1 : THROW_CCE();
    var setValue2 = op2 instanceof SetValueOperation ? op2 : THROW_CCE();
    var oldValue = setValue1.f42_1;
    var newValue = setValue2.g42_1;
    return equals(oldValue, newValue) ? new NopOperation() : new SetValueOperation(oldValue, newValue);
  };
  protoOf(MergeSetValueOperationsRule).k42 = function (op1, op2) {
    var tmp;
    var tmp_0;
    if (op1 instanceof SetValueOperation) {
      tmp_0 = op2 instanceof SetValueOperation;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp_1 = (op1 instanceof SetValueOperation ? op1 : THROW_CCE()).g42_1;
      tmp = equals(tmp_1, (op2 instanceof SetValueOperation ? op2 : THROW_CCE()).f42_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function MergeTargetedOperationsRule(innerOperationsMerger) {
    MergeContainerOperationsRule.call(this, innerOperationsMerger);
  }
  protoOf(MergeTargetedOperationsRule).o42 = function (op1, op2) {
    var targeted1 = op1 instanceof TargetedOperation ? op1 : THROW_CCE();
    var targeted2 = op2 instanceof TargetedOperation ? op2 : THROW_CCE();
    var innerMergeResult = this.r42(targeted1.u3l(), targeted2.u3l());
    return innerMergeResult.t3j() ? new NopOperation() : targeted1.y3p(innerMergeResult);
  };
  protoOf(MergeTargetedOperationsRule).k42 = function (op1, op2) {
    var tmp;
    var tmp_0;
    if (op1 instanceof TargetedOperation) {
      tmp_0 = op2 instanceof TargetedOperation;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp_1 = (op1 instanceof TargetedOperation ? op1 : THROW_CCE()).h3b();
      tmp = equals(tmp_1, (op2 instanceof TargetedOperation ? op2 : THROW_CCE()).h3b());
    } else {
      tmp = false;
    }
    return tmp;
  };
  function ModelAddRemoveRule() {
    BaseMutuallyInverseOperationRule.call(this);
  }
  protoOf(ModelAddRemoveRule).i42 = function (op) {
    return op instanceof AddModelBlobOperation;
  };
  protoOf(ModelAddRemoveRule).j42 = function (op) {
    return op instanceof RemoveModelBlobOperation;
  };
  protoOf(ModelAddRemoveRule).p42 = function (op) {
    return (op instanceof ModelBlobOperation ? op : THROW_CCE()).q3o_1;
  };
  function NodeChildAddRemoveRule() {
    BaseMutuallyInverseOperationRule.call(this);
  }
  protoOf(NodeChildAddRemoveRule).i42 = function (op) {
    return op instanceof AddChildOperation_0;
  };
  protoOf(NodeChildAddRemoveRule).j42 = function (op) {
    return op instanceof RemoveChildOperation_0;
  };
  protoOf(NodeChildAddRemoveRule).p42 = function (op) {
    return (op instanceof ChildOperation_0 ? op : THROW_CCE()).v3i_1;
  };
  function NodeChildAddReplaceRule() {
    BaseDataOperationRule.call(this);
  }
  protoOf(NodeChildAddReplaceRule).i42 = function (op) {
    return op instanceof AddChildOperation_0;
  };
  protoOf(NodeChildAddReplaceRule).j42 = function (op) {
    return op instanceof ReplaceChildOperation;
  };
  protoOf(NodeChildAddReplaceRule).l42 = function (op) {
    var childOperation = op instanceof ChildOperation_0 ? op : THROW_CCE();
    return childOperation.v3i_1;
  };
  protoOf(NodeChildAddReplaceRule).m42 = function (op) {
    var replaceChildOperation = op instanceof ReplaceChildOperation ? op : THROW_CCE();
    return replaceChildOperation.j3o_1;
  };
  protoOf(NodeChildAddReplaceRule).o42 = function (op1, op2) {
    var replaceChildOperation = op2 instanceof ReplaceChildOperation ? op2 : THROW_CCE();
    var addChildOperation = AddChildOperation_init_$Create$_2(replaceChildOperation.k3o_1);
    return isInterface(addChildOperation, Operation) ? addChildOperation : THROW_CCE();
  };
  function NodeChildReplaceRemoveRule() {
    BaseDataOperationRule.call(this);
  }
  protoOf(NodeChildReplaceRemoveRule).i42 = function (op) {
    return op instanceof ReplaceChildOperation;
  };
  protoOf(NodeChildReplaceRemoveRule).j42 = function (op) {
    return op instanceof RemoveChildOperation_0;
  };
  protoOf(NodeChildReplaceRemoveRule).l42 = function (op) {
    var replaceChildOperation = op instanceof ReplaceChildOperation ? op : THROW_CCE();
    return replaceChildOperation.k3o_1;
  };
  protoOf(NodeChildReplaceRemoveRule).m42 = function (op) {
    var childOperation = op instanceof ChildOperation_0 ? op : THROW_CCE();
    return childOperation.v3i_1;
  };
  protoOf(NodeChildReplaceRemoveRule).o42 = function (op1, op2) {
    var replaceChildOperation = op1 instanceof ReplaceChildOperation ? op1 : THROW_CCE();
    var removeChildOperation = RemoveChildOperation_init_$Create$_2(replaceChildOperation.j3o_1);
    return isInterface(removeChildOperation, Operation) ? removeChildOperation : THROW_CCE();
  };
  function NodeChildReplaceReplaceRule() {
    BaseDataOperationRule.call(this);
  }
  protoOf(NodeChildReplaceReplaceRule).i42 = function (op) {
    return op instanceof ReplaceChildOperation;
  };
  protoOf(NodeChildReplaceReplaceRule).j42 = function (op) {
    return op instanceof ReplaceChildOperation;
  };
  protoOf(NodeChildReplaceReplaceRule).l42 = function (op) {
    var replaceChildOperation = op instanceof ReplaceChildOperation ? op : THROW_CCE();
    return replaceChildOperation.k3o_1;
  };
  protoOf(NodeChildReplaceReplaceRule).m42 = function (op) {
    var replaceChildOperation = op instanceof ReplaceChildOperation ? op : THROW_CCE();
    return replaceChildOperation.j3o_1;
  };
  protoOf(NodeChildReplaceReplaceRule).o42 = function (op1, op2) {
    var replace1 = op1 instanceof ReplaceChildOperation ? op1 : THROW_CCE();
    var replace2 = op2 instanceof ReplaceChildOperation ? op2 : THROW_CCE();
    var oldData = replace1.j3o_1;
    var newData = replace2.k3o_1;
    var tmp;
    if (oldData.equals(newData)) {
      tmp = new NopOperation();
    } else {
      var replaceChildOperation = new ReplaceChildOperation(oldData, newData);
      tmp = isInterface(replaceChildOperation, Operation) ? replaceChildOperation : THROW_CCE();
    }
    return tmp;
  };
  function NopOperationRule() {
    BaseMergeOperationsRule.call(this);
  }
  protoOf(NopOperationRule).o42 = function (op1, op2) {
    var tmp;
    if (op1 instanceof NopOperation) {
      tmp = op2;
    } else {
      tmp = op1;
    }
    return tmp;
  };
  protoOf(NopOperationRule).k42 = function (op1, op2) {
    var tmp;
    if (op1 instanceof NopOperation) {
      tmp = true;
    } else {
      tmp = op2 instanceof NopOperation;
    }
    return tmp;
  };
  function RootAddRemoveRule() {
    BaseMutuallyInverseOperationRule.call(this);
  }
  protoOf(RootAddRemoveRule).i42 = function (op) {
    return op instanceof AddRootOperation;
  };
  protoOf(RootAddRemoveRule).j42 = function (op) {
    return op instanceof RemoveRootOperation;
  };
  protoOf(RootAddRemoveRule).p42 = function (op) {
    return (op instanceof RootEntityOperation ? op : THROW_CCE()).n3i_1;
  };
  function init_2($this, rules) {
    $this.u42_1.o(rules);
  }
  function merge($this, op1, op2) {
    if (bothAnnotated($this, op1, op2)) {
      var annotatedOp1 = op1 instanceof AnnotatedOperation ? op1 : THROW_CCE();
      var annotatedOp2 = op2 instanceof AnnotatedOperation ? op2 : THROW_CCE();
      if (sameAnnotator($this, annotatedOp1, annotatedOp2)) {
        return annotatedOp1.v42(merge($this, annotatedOp1.f40_1, annotatedOp2.f40_1));
      }
    }
    return tryMergeSame($this, op1, op2);
  }
  function tryMergeSame($this, op1, op2) {
    var _iterator__ex2g4s = $this.u42_1.k();
    while (_iterator__ex2g4s.l()) {
      var mergeRule = _iterator__ex2g4s.m();
      if (mergeRule.k42(op1, op2)) {
        return mergeRule.n42(op1, op2);
      }
    }
    return CompositeOperation_init_$Create$([op1, op2]);
  }
  function bothAnnotated($this, op1, op2) {
    var tmp;
    if (op1 instanceof AnnotatedOperation) {
      tmp = op2 instanceof AnnotatedOperation;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function sameAnnotator($this, op1, op2) {
    return op1.d40_1 == op2.d40_1;
  }
  function Companion_56() {
  }
  protoOf(Companion_56).b2p = function () {
    var merger = new SimpleAnnotatorPreservingOperationsMerger();
    var mergeRules = ArrayList_init_$Create$();
    mergeRules.e(new MergeTargetedOperationsRule(merger));
    mergeRules.e(new MergeSetValueOperationsRule());
    mergeRules.e(new NopOperationRule());
    mergeRules.e(new NodeChildAddRemoveRule());
    mergeRules.e(new NodeChildAddReplaceRule());
    mergeRules.e(new NodeChildReplaceRemoveRule());
    mergeRules.e(new NodeChildReplaceReplaceRule());
    mergeRules.e(new EntityChildAddRemoveRule());
    mergeRules.e(new RootAddRemoveRule());
    mergeRules.e(new ModelAddRemoveRule());
    mergeRules.e(new MergeCompositeOperationsRule(merger));
    init_2(merger, mergeRules);
    return merger;
  };
  var Companion_instance_56;
  function Companion_getInstance_56() {
    return Companion_instance_56;
  }
  function SimpleAnnotatorPreservingOperationsMerger() {
    this.u42_1 = ArrayList_init_$Create$();
  }
  protoOf(SimpleAnnotatorPreservingOperationsMerger).w42 = function (operations) {
    if (operations.p()) {
      return new NopOperation();
    }
    var resultingOp = null;
    var _iterator__ex2g4s = operations.k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      var tmp;
      if (resultingOp == null) {
        tmp = op;
      } else {
        tmp = merge(this, resultingOp, op);
      }
      resultingOp = tmp;
    }
    return ensureNotNull(resultingOp);
  };
  protoOf(SimpleAnnotatorPreservingOperationsMerger).u3j = function (operations) {
    return this.w42(operations);
  };
  function NodeAssemblyOperationBuilder(node) {
    this.e3m_1 = node;
    this.f3m_1 = null;
    this.g3m_1 = null;
  }
  protoOf(NodeAssemblyOperationBuilder).k2p = function () {
    var operations = ArrayList_init_$Create$();
    var _iterator__ex2g4s = this.e3m_1.y2z().k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var propId = _iterator__ex2g4s.m();
      if (!(this.f3m_1 == null) && equals(this.f3m_1, propId)) {
        continue $l$loop;
      }
      var property = this.e3m_1.z38(propId).qr();
      if (!(property == null)) {
        operations.e(new ChangePropertyOperation(propId, new SetValueOperation(null, property)));
      }
    }
    var _iterator__ex2g4s_0 = this.e3m_1.v2z().k();
    while (_iterator__ex2g4s_0.l()) {
      var childId = _iterator__ex2g4s_0.m();
      var curIndex = 0;
      var _iterator__ex2g4s_1 = this.e3m_1.l38(childId).k();
      $l$loop_0: while (_iterator__ex2g4s_1.l()) {
        var child = _iterator__ex2g4s_1.m();
        if (!(this.g3m_1 == null) && equals(this.g3m_1, childId)) {
          continue $l$loop_0;
        }
        var id = NodeUtil_instance.y38(child);
        var addOperation = AddChildOperation_init_$Create$_1(child.a38_1, id, curIndex, childId.b32());
        var childAssemblyOperation = (new NodeAssemblyOperationBuilder(child)).k2p();
        var _unary__edvuaz = curIndex;
        curIndex = _unary__edvuaz + 1 | 0;
        operations.e(new ChildListOperation(childId, CompositeOperation_init_$Create$([addOperation, new ChangeChildOperation_0(id, _unary__edvuaz, childAssemblyOperation)])));
      }
    }
    return Companion_instance_64.d3m(operations);
  };
  protoOf(NodeAssemblyOperationBuilder).x42 = function (propertyId) {
    this.f3m_1 = propertyId;
  };
  protoOf(NodeAssemblyOperationBuilder).y42 = function (outerModifiedChildId) {
    this.g3m_1 = outerModifiedChildId;
  };
  function OperationBuilder_0() {
  }
  protoOf(OperationBuilder_0).z42 = function (childId, node, index) {
    var id = NodeUtil_instance.y38(node);
    var addOp = AddChildOperation_init_$Create$_1(node.a38_1, id, index, childId.b32());
    var assembleOp = new ChangeChildOperation_0(id, index, (new NodeAssemblyOperationBuilder(node)).k2p());
    var tmp;
    if (assembleOp.t3j()) {
      tmp = addOp;
    } else {
      tmp = CompositeOperation_init_$Create$([addOp, assembleOp]);
    }
    return tmp;
  };
  protoOf(OperationBuilder_0).a43 = function (childId, node, index) {
    var id = NodeUtil_instance.y38(node);
    var disassembleOp = new ChangeChildOperation_0(id, index, (new NodeAssemblyOperationBuilder(node)).k2p().s3l());
    var removeOp = RemoveChildOperation_init_$Create$_1(node.a38_1, id, index, childId.b32());
    var tmp;
    if (disassembleOp.t3j()) {
      tmp = removeOp;
    } else {
      tmp = CompositeOperation_init_$Create$([disassembleOp, removeOp]);
    }
    return tmp;
  };
  protoOf(OperationBuilder_0).b43 = function (childId, node, index) {
    var op = this.z42(childId, node, index);
    return new ChildListOperation(childId, op);
  };
  protoOf(OperationBuilder_0).c43 = function (childId, node, index) {
    var op = this.a43(childId, node, index);
    return new ChildListOperation(childId, op);
  };
  protoOf(OperationBuilder_0).d43 = function (oldNode, newNode, id, index) {
    var oldNodeId = NodeUtil_instance.y38(oldNode);
    var newNodeId = NodeUtil_instance.y38(newNode);
    return CompositeOperation_init_$Create$([new ChangeChildOperation_0(oldNodeId, index, (new NodeAssemblyOperationBuilder(oldNode)).k2p().s3l()), ReplaceChildOperation_init_$Create$(oldNode.a38_1, oldNodeId, newNode.a38_1, newNodeId, index, id.b32()), new ChangeChildOperation_0(newNodeId, index, (new NodeAssemblyOperationBuilder(newNode)).k2p())]);
  };
  protoOf(OperationBuilder_0).e43 = function (id, oldNode, newNode, index) {
    return new ChildListOperation(id, this.d43(oldNode, newNode, id, index));
  };
  protoOf(OperationBuilder_0).f43 = function (event) {
    var child = event.t3g_1;
    return new AddChildSplitChildCollectionOperation(child.a38_1, event.r3f_1.v39(), child.v39(), event.s3g_1, event.t3f_1, event.s3f_1, event.u3f_1);
  };
  protoOf(OperationBuilder_0).g43 = function (event) {
    var child = event.t3g_1;
    return new MergeChildCollectionRemoveChildOperation(child.a38_1, child.v39(), event.m3g_1.v39(), event.s3g_1, event.o3g_1, event.p3g_1, event.n3g_1);
  };
  var OperationBuilder_instance_0;
  function OperationBuilder_getInstance_0() {
    return OperationBuilder_instance_0;
  }
  function AddChildOperation_init_$Init$_1(conceptId, nodeId, index, isSingleRole, $this) {
    ChildOperation_init_$Init$_0(conceptId, nodeId, index, isSingleRole, $this);
    AddChildOperation_0.call($this);
    return $this;
  }
  function AddChildOperation_init_$Create$_1(conceptId, nodeId, index, isSingleRole) {
    return AddChildOperation_init_$Init$_1(conceptId, nodeId, index, isSingleRole, objectCreate(protoOf(AddChildOperation_0)));
  }
  function AddChildOperation_init_$Init$_2(data, $this) {
    ChildOperation_0.call($this, data);
    AddChildOperation_0.call($this);
    return $this;
  }
  function AddChildOperation_init_$Create$_2(data) {
    return AddChildOperation_init_$Init$_2(data, objectCreate(protoOf(AddChildOperation_0)));
  }
  protoOf(AddChildOperation_0).p3z = function () {
    return this.m43_1;
  };
  protoOf(AddChildOperation_0).r3z = function () {
    return this.n43_1;
  };
  protoOf(AddChildOperation_0).b3 = function () {
    return 'addChild';
  };
  protoOf(AddChildOperation_0).o43 = function (otherOp, server) {
    if (otherOp instanceof AddChildOperation_0) {
      if (NodeUtil_instance.h3i(this.x3i(), otherOp.x3i())) {
        this.q43(otherOp);
        return new NopOperation();
      } else if (this.t43_1) {
        this.d44(otherOp);
        return server ? new NopOperation() : CompositeOperation_init_$Create$([this.s3l(), otherOp]);
      }
    } else {
      if (otherOp instanceof ReplaceChildOperation) {
        if (NodeUtil_instance.h3i(this.x3i(), otherOp.c44())) {
          this.q43(otherOp.p43());
          // Inline function 'kotlin.check' call
          if (!!this.t43_1) {
            // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.AddChildOperation.doTransform.<anonymous>' call
            var message = ChildOperationMessages_instance.u43(this, otherOp);
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
          return otherOp.v43().q3z(this.i3b() + 1 | 0);
        }
      }
    }
    return protoOf(ChildOperation_0).o43.call(this, otherOp, server);
  };
  protoOf(AddChildOperation_0).g3p = function (otherOp, server) {
    return this.o43(otherOp, server);
  };
  protoOf(AddChildOperation_0).e44 = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!(!this.t43_1 || model.p())) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.AddChildOperation.execute.<anonymous>' call
      var message = 'Add into not empty single-item child list';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var node = nodeFactory.z37(this.h3f(), this.x3i());
    model.p2(this.i3b(), node);
    return model;
  };
  protoOf(AddChildOperation_0).a3k = function (model, nodeFactory) {
    return this.e44((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddChildOperation_0).s3l = function () {
    return RemoveChildOperation_init_$Create$_2(this.v3i_1);
  };
  protoOf(AddChildOperation_0).q3z = function (newIndex) {
    return AddChildOperation_init_$Create$_1(this.h3f(), this.x3i(), newIndex, this.t43_1);
  };
  protoOf(AddChildOperation_0).f44 = function (model, ops, nodeFactory) {
    return (new AddChildOperationExecutor_0(nodeFactory)).p3p(model, ops);
  };
  protoOf(AddChildOperation_0).q3p = function (model, ops, nodeFactory) {
    return this.f44((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), ops, nodeFactory);
  };
  function AddChildOperation_0() {
    this.m43_1 = Priority_NORMAL_getInstance();
    this.n43_1 = 1;
  }
  function BaseListItemOperation(index, isSingleRole) {
    BaseOperation.call(this);
    this.s43_1 = index;
    this.t43_1 = isSingleRole;
  }
  protoOf(BaseListItemOperation).i3b = function () {
    return this.s43_1;
  };
  protoOf(BaseListItemOperation).o43 = function (otherOp, server) {
    if (otherOp instanceof BaseListItemOperation) {
      if (!(this.t43_1 === otherOp.t43_1)) {
        throw IllegalStateException_init_$Create$_0("Mismatching 'single role' flag");
      }
      var tmp = new IndexedOperationTransformer();
      return tmp.s3z(this, isInterface(otherOp, IndexedOperation) ? otherOp : THROW_CCE(), server);
    }
    return protoOf(BaseOperation).g3p.call(this, otherOp, server);
  };
  protoOf(BaseListItemOperation).g3p = function (otherOp, server) {
    return this.o43(otherOp, server);
  };
  protoOf(BaseListItemOperation).i44 = function (op) {
    if (!(this.i3b() === op.i3b())) {
      throw IllegalStateException_init_$Create$_0('Unequal indices: current index=' + this.i3b() + ', other index=' + op.i3b());
    }
  };
  protoOf(BaseListItemOperation).d44 = function (op) {
    if (!(this.t43_1 === op.t43_1)) {
      throw IllegalStateException_init_$Create$_0("Mismatching 'single role' flags");
    }
  };
  function rollbackCurrentThenOtherOp($this, conceptId, otherOp) {
    var temp = RawNodeFactory_instance.z37(conceptId, $this.m44_1);
    temp = $this.u3l().a3k(temp, RawNodeFactory_instance);
    var disassemble = (new NodeAssemblyOperationBuilder(temp)).k2p().s3l();
    var changeChildOperation = new ChangeChildOperation_0($this.m44_1, $this.h3b(), disassemble);
    return CompositeOperation_init_$Create$([changeChildOperation, otherOp]);
  }
  function assertEqualsCurrentId($this, otherId) {
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.g3i($this.m44_1, otherId)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.ChangeChildOperation.assertEqualsCurrentId.<anonymous>' call
      var message = 'Unequal ids: ' + toString_0($this.m44_1) + ', ' + toString_0(otherId);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function ChangeChildOperation_0(nodeId, childIndex, op) {
    TargetedOperation.call(this, childIndex, op);
    this.m44_1 = nodeId;
  }
  protoOf(ChangeChildOperation_0).b3 = function () {
    return 'changeChild';
  };
  protoOf(ChangeChildOperation_0).n44 = function (source) {
    return source.q(this.h3b());
  };
  protoOf(ChangeChildOperation_0).c3q = function (source) {
    return this.n44((!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE());
  };
  protoOf(ChangeChildOperation_0).o44 = function (newIndex) {
    return new ChangeChildOperation_0(this.m44_1, newIndex, this.u3l());
  };
  protoOf(ChangeChildOperation_0).o43 = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation_0) {
      if (otherOp.i3b() === this.h3b()) {
        assertEqualsCurrentId(this, otherOp.x3i());
        return rollbackCurrentThenOtherOp(this, otherOp.h3f(), otherOp);
      }
    }
    if (otherOp instanceof ReplaceChildOperation) {
      if (otherOp.i3b() === this.h3b()) {
        assertEqualsCurrentId(this, otherOp.p44());
        return rollbackCurrentThenOtherOp(this, otherOp.n3o(), otherOp);
      }
    }
    return protoOf(TargetedOperation).z3p.call(this, otherOp, server);
  };
  protoOf(ChangeChildOperation_0).g3p = function (otherOp, server) {
    return this.o43(otherOp, server);
  };
  protoOf(ChangeChildOperation_0).z3p = function (otherOp, server) {
    return this.o43(otherOp, server);
  };
  protoOf(ChangeChildOperation_0).q44 = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation_0) {
      if (otherOp.i3b() === this.h3b()) {
        assertEqualsCurrentId(this, otherOp.x3i());
        return new NopOperation();
      }
      if (otherOp.i3b() < this.h3b()) {
        return new ChangeChildOperation_0(this.m44_1, this.h3b() - 1 | 0, this.u3l());
      }
    }
    if (otherOp instanceof AddChildOperation_0) {
      if (otherOp.i3b() <= this.h3b()) {
        return new ChangeChildOperation_0(this.m44_1, this.h3b() + 1 | 0, this.u3l());
      }
    }
    if (otherOp instanceof ReplaceChildOperation) {
      if (otherOp.i3b() === this.h3b()) {
        assertEqualsCurrentId(this, otherOp.p44());
        return new NopOperation();
      }
    }
    return protoOf(TargetedOperation).r3p.call(this, otherOp, server);
  };
  protoOf(ChangeChildOperation_0).r3p = function (otherOp, server) {
    return this.q44(otherOp, server);
  };
  protoOf(ChangeChildOperation_0).r44 = function (op) {
    return new ChangeChildOperation_0(this.m44_1, this.h3b(), op);
  };
  protoOf(ChangeChildOperation_0).y3p = function (op) {
    return this.r44(op);
  };
  protoOf(ChangeChildOperation_0).s44 = function (model, customExecute, nodeFactory) {
    var node = this.n44(model);
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.e3i(ensureNotNull(node), this.m44_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.ChangeChildOperation.execute.<anonymous>' call
      var message = MessageBundle_instance.d39(this.m44_1, NodeUtil_instance.y38(node));
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.f3q(node, customExecute, nodeFactory);
    return model;
  };
  protoOf(ChangeChildOperation_0).d3v = function (model, customExecute, nodeFactory) {
    return this.s44((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(ChangeChildOperation_0).d3q = function (model, customExecute, nodeFactory) {
    return this.s44((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(ChangeChildOperation_0).f44 = function (model, ops, nodeFactory) {
    return (new ChangeChildOperationExecutor_0(nodeFactory)).u44(model, ops);
  };
  protoOf(ChangeChildOperation_0).q3p = function (model, ops, nodeFactory) {
    return this.f44((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), ops, nodeFactory);
  };
  protoOf(ChangeChildOperation_0).toString = function () {
    return protoOf(TargetedOperation).toString.call(this) + '; id = ' + toString_0(this.m44_1);
  };
  protoOf(ChangeChildOperation_0).t3p = function (indent) {
    return indent + this.b3() + '[id = ' + toString_0(this.m44_1) + ';r = ' + this.h3b() + ';o =\n' + this.u3l().t3p(indent + '  ') + indent + ']\n';
  };
  function ChildOperation_init_$Init$_0(conceptId, nodeId, index, isSingleRole, $this) {
    ChildOperation_0.call($this, new NodeChildOperationData(isSingleRole, index, conceptId, nodeId));
    return $this;
  }
  function ChildOperation_0(operationData) {
    BaseListItemOperation.call(this, operationData.w44_1, operationData.v44_1);
    this.v3i_1 = operationData;
    this.w3i_1 = 1;
    // Inline function 'kotlin.require' call
    if (!NodeUtil_instance.d3i(this.v3i_1.x44_1, this.v3i_1.y44_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.ChildOperation.<anonymous>' call
      var message = 'concept id ' + this.v3i_1.x44_1.toString() + " doesn't permit " + toString_0(this.v3i_1.y44_1) + ' node id';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(ChildOperation_0).x3i = function () {
    return this.v3i_1.y44_1;
  };
  protoOf(ChildOperation_0).h3f = function () {
    return this.v3i_1.x44_1;
  };
  protoOf(ChildOperation_0).a = function () {
    return this.w3i_1;
  };
  protoOf(ChildOperation_0).o43 = function (otherOp, server) {
    if (otherOp instanceof ChildOperation_0) {
      // Inline function 'kotlin.check' call
      if (!!NodeUtil_instance.h3i(this.x3i(), otherOp.x3i())) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.ChildOperation.doTransform.<anonymous>' call
        var tmp0_safe_receiver = this.x3i();
        var message = "Equal ids: '" + (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i2s_1) + "', expected: different";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    return protoOf(BaseListItemOperation).o43.call(this, otherOp, server);
  };
  protoOf(ChildOperation_0).g3p = function (otherOp, server) {
    return this.o43(otherOp, server);
  };
  protoOf(ChildOperation_0).toString = function () {
    return this.b3() + '[n = ' + toString_0(this.x3i()) + ';i = ' + this.i3b() + ']';
  };
  protoOf(ChildOperation_0).g44 = function (op) {
    // Inline function 'kotlin.check' call
    if (!this.h3f().equals(op.h3f())) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.ChildOperation.assertConceptIdsEqual.<anonymous>' call
      var message = MessageBundle_instance.a39(this.h3f(), op.h3f());
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(ChildOperation_0).h44 = function (op) {
    // Inline function 'kotlin.check' call
    if (!(this.x3i() == null || equals(this.x3i(), op.x3i()))) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.ChildOperation.assertNodeIdsEqual.<anonymous>' call
      var message = 'Unequal nodeIds: current nodeId=' + toString_0(this.x3i()) + ', other nodeId=' + toString_0(op.x3i());
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(ChildOperation_0).q43 = function (op) {
    this.i44(op);
    this.d44(op);
    this.g44(op);
  };
  protoOf(ChildOperation_0).z44 = function (op) {
    this.h44(op);
    this.d44(op);
    this.g44(op);
  };
  protoOf(ChildOperation_0).a45 = function (op) {
    this.h44(op);
    this.i44(op);
    this.d44(op);
    this.g44(op);
  };
  function ChildOperationMessages() {
  }
  protoOf(ChildOperationMessages).u43 = function (addOp, replaceOp) {
    return 'Simultaneous addition and replacement of singleRole=true list item: ' + addOp.toString() + ', ' + replaceOp.toString();
  };
  var ChildOperationMessages_instance;
  function ChildOperationMessages_getInstance() {
    return ChildOperationMessages_instance;
  }
  function NodeChildOperationData(isSingle, index, conceptId, nodeId) {
    this.v44_1 = isSingle;
    this.w44_1 = index;
    this.x44_1 = conceptId;
    this.y44_1 = nodeId;
  }
  protoOf(NodeChildOperationData).toString = function () {
    return 'NodeChildOperationData(isSingle=' + this.v44_1 + ', index=' + this.w44_1 + ', conceptId=' + this.x44_1.toString() + ', nodeId=' + toString_0(this.y44_1) + ')';
  };
  protoOf(NodeChildOperationData).hashCode = function () {
    var result = getBooleanHashCode(this.v44_1);
    result = imul(result, 31) + this.w44_1 | 0;
    result = imul(result, 31) + this.x44_1.hashCode() | 0;
    result = imul(result, 31) + (this.y44_1 == null ? 0 : this.y44_1.hashCode()) | 0;
    return result;
  };
  protoOf(NodeChildOperationData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeChildOperationData))
      return false;
    var tmp0_other_with_cast = other instanceof NodeChildOperationData ? other : THROW_CCE();
    if (!(this.v44_1 === tmp0_other_with_cast.v44_1))
      return false;
    if (!(this.w44_1 === tmp0_other_with_cast.w44_1))
      return false;
    if (!this.x44_1.equals(tmp0_other_with_cast.x44_1))
      return false;
    if (!equals(this.y44_1, tmp0_other_with_cast.y44_1))
      return false;
    return true;
  };
  function RemoveChildOperation_init_$Init$_1(conceptId, nodeId, removeIndex, isSingleRole, $this) {
    ChildOperation_init_$Init$_0(conceptId, nodeId, removeIndex, isSingleRole, $this);
    RemoveChildOperation_0.call($this);
    return $this;
  }
  function RemoveChildOperation_init_$Create$_1(conceptId, nodeId, removeIndex, isSingleRole) {
    return RemoveChildOperation_init_$Init$_1(conceptId, nodeId, removeIndex, isSingleRole, objectCreate(protoOf(RemoveChildOperation_0)));
  }
  function RemoveChildOperation_init_$Init$_2(data, $this) {
    ChildOperation_0.call($this, data);
    RemoveChildOperation_0.call($this);
    return $this;
  }
  function RemoveChildOperation_init_$Create$_2(data) {
    return RemoveChildOperation_init_$Init$_2(data, objectCreate(protoOf(RemoveChildOperation_0)));
  }
  protoOf(RemoveChildOperation_0).r3z = function () {
    return this.b44_1;
  };
  protoOf(RemoveChildOperation_0).b3 = function () {
    return 'removeChild';
  };
  protoOf(RemoveChildOperation_0).o43 = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation_0) {
      if (this.i3b() === otherOp.i3b()) {
        this.z44(otherOp);
        return new NopOperation();
      }
      // Inline function 'kotlin.check' call
      if (!!NodeUtil_instance.h3i(this.x3i(), otherOp.x3i())) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.RemoveChildOperation.doTransform.<anonymous>' call
        var message = 'Unequal indexes: ' + this.i3b() + ' and ' + otherOp.i3b();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    return protoOf(ChildOperation_0).o43.call(this, otherOp, server);
  };
  protoOf(RemoveChildOperation_0).g3p = function (otherOp, server) {
    return this.o43(otherOp, server);
  };
  protoOf(RemoveChildOperation_0).s3l = function () {
    return AddChildOperation_init_$Create$_2(this.v3i_1);
  };
  protoOf(RemoveChildOperation_0).e44 = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!(!this.t43_1 || model.n() === 1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.RemoveChildOperation.execute.<anonymous>' call
      var message = "'Single role' list size=" + model.n();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var node = model.q(this.i3b());
    // Inline function 'kotlin.check' call
    if (!this.h3f().equals(node.a38_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.RemoveChildOperation.execute.<anonymous>' call
      var message_0 = MessageBundle_instance.a39(this.h3f(), node.a38_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.e3i(node, this.x3i())) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.RemoveChildOperation.execute.<anonymous>' call
      var message_1 = MessageBundle_instance.d39(this.x3i(), node.v39());
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.check' call
    if (!node.np()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.RemoveChildOperation.execute.<anonymous>' call
      var message_2 = MessageBundle_instance.c39(this.x3i());
      throw IllegalStateException_init_$Create$_0(toString_1(message_2));
    }
    model.q2(this.i3b());
    return model;
  };
  protoOf(RemoveChildOperation_0).a3k = function (model, nodeFactory) {
    return this.e44((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(RemoveChildOperation_0).q3z = function (newIndex) {
    return RemoveChildOperation_init_$Create$_1(this.h3f(), this.x3i(), newIndex, this.t43_1);
  };
  protoOf(RemoveChildOperation_0).b45 = function (op) {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(RemoveChildOperation_0).t3z = function (op) {
    return this.b45(op);
  };
  protoOf(RemoveChildOperation_0).c45 = function (replaceRemovedItem) {
    if (replaceRemovedItem instanceof ReplaceChildOperation) {
      this.a45(replaceRemovedItem.v43());
      return RemoveChildOperation_init_$Create$_1(replaceRemovedItem.o3o(), replaceRemovedItem.c44(), this.i3b(), this.t43_1);
    }
    throw IllegalArgumentException_init_$Create$();
  };
  protoOf(RemoveChildOperation_0).u3z = function (replaceRemovedItem) {
    return this.c45(replaceRemovedItem);
  };
  function RemoveChildOperation_0() {
    this.b44_1 = -1;
  }
  function ensureSameIndex($this, oldData, newData) {
    // Inline function 'kotlin.check' call
    if (!(oldData.w44_1 === newData.w44_1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return oldData.w44_1;
  }
  function ensureSameSingleRole($this, oldData, newData) {
    // Inline function 'kotlin.check' call
    if (!(oldData.v44_1 === newData.v44_1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return oldData.v44_1;
  }
  function ReplaceChildOperation_init_$Init$(oldConceptId, oldNodeId, newConceptId, newNodeId, index, isSingleRole, $this) {
    ReplaceChildOperation.call($this, new NodeChildOperationData(isSingleRole, index, oldConceptId, oldNodeId), new NodeChildOperationData(isSingleRole, index, newConceptId, newNodeId));
    return $this;
  }
  function ReplaceChildOperation_init_$Create$(oldConceptId, oldNodeId, newConceptId, newNodeId, index, isSingleRole) {
    return ReplaceChildOperation_init_$Init$(oldConceptId, oldNodeId, newConceptId, newNodeId, index, isSingleRole, objectCreate(protoOf(ReplaceChildOperation)));
  }
  function Companion_57() {
  }
  var Companion_instance_57;
  function Companion_getInstance_57() {
    return Companion_instance_57;
  }
  function ReplaceChildOperation(oldOperationData, newOperationData) {
    BaseListItemOperation.call(this, ensureSameIndex(Companion_instance_57, oldOperationData, newOperationData), ensureSameSingleRole(Companion_instance_57, oldOperationData, newOperationData));
    this.j3o_1 = oldOperationData;
    this.k3o_1 = newOperationData;
    this.l3o_1 = 1;
    this.m3o_1 = 0;
  }
  protoOf(ReplaceChildOperation).n3o = function () {
    return this.j3o_1.x44_1;
  };
  protoOf(ReplaceChildOperation).p44 = function () {
    return this.j3o_1.y44_1;
  };
  protoOf(ReplaceChildOperation).o3o = function () {
    return this.k3o_1.x44_1;
  };
  protoOf(ReplaceChildOperation).c44 = function () {
    return this.k3o_1.y44_1;
  };
  protoOf(ReplaceChildOperation).a = function () {
    return this.l3o_1;
  };
  protoOf(ReplaceChildOperation).r3z = function () {
    return this.m3o_1;
  };
  protoOf(ReplaceChildOperation).v43 = function () {
    return RemoveChildOperation_init_$Create$_2(this.j3o_1);
  };
  protoOf(ReplaceChildOperation).p43 = function () {
    return AddChildOperation_init_$Create$_2(this.k3o_1);
  };
  protoOf(ReplaceChildOperation).o43 = function (otherOp, server) {
    if (otherOp instanceof ReplaceChildOperation) {
      if (this.i3b() === otherOp.i3b() && NodeUtil_instance.h3i(this.c44(), otherOp.c44())) {
        this.v43().z44(otherOp.v43());
        this.p43().g44(otherOp.p43());
        return new NopOperation();
      }
    } else {
      if (otherOp instanceof AddChildOperation_0) {
        if (NodeUtil_instance.h3i(this.c44(), otherOp.x3i())) {
          this.p43().q43(otherOp);
          // Inline function 'kotlin.check' call
          if (!!this.t43_1) {
            // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.ReplaceChildOperation.doTransform.<anonymous>' call
            var message = ChildOperationMessages_instance.u43(otherOp, this);
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
          return new NopOperation();
        }
      }
    }
    return protoOf(BaseListItemOperation).o43.call(this, otherOp, server);
  };
  protoOf(ReplaceChildOperation).g3p = function (otherOp, server) {
    return this.o43(otherOp, server);
  };
  protoOf(ReplaceChildOperation).q3z = function (newIndex) {
    return ReplaceChildOperation_init_$Create$(this.j3o_1.x44_1, this.j3o_1.y44_1, this.k3o_1.x44_1, this.k3o_1.y44_1, newIndex, this.t43_1);
  };
  protoOf(ReplaceChildOperation).c45 = function (replaceOldItem) {
    if (replaceOldItem instanceof ReplaceChildOperation) {
      this.v43().a45(replaceOldItem.v43());
      return new ReplaceChildOperation(replaceOldItem.k3o_1, this.k3o_1);
    }
    throw IllegalArgumentException_init_$Create$_0(toString_1(replaceOldItem));
  };
  protoOf(ReplaceChildOperation).u3z = function (replaceOldItem) {
    return this.c45(replaceOldItem);
  };
  protoOf(ReplaceChildOperation).e44 = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!(!this.t43_1 || model.n() === 1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.ReplaceChildOperation.execute.<anonymous>' call
      var message = "'Single role' list size=" + model.n();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(model.n() > this.i3b())) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.ReplaceChildOperation.execute.<anonymous>' call
      var message_0 = 'Child list does not contain element ' + this.i3b();
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var oldNode = model.q(this.i3b());
    var oldConceptId = this.j3o_1.x44_1;
    // Inline function 'kotlin.check' call
    if (!oldConceptId.equals(oldNode.a38_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.ReplaceChildOperation.execute.<anonymous>' call
      var message_1 = MessageBundle_instance.a39(oldConceptId, oldNode.a38_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    var oldNodeId = this.j3o_1.y44_1;
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.e3i(oldNode, oldNodeId)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.ReplaceChildOperation.execute.<anonymous>' call
      var message_2 = MessageBundle_instance.d39(oldNodeId, oldNode.v39());
      throw IllegalStateException_init_$Create$_0(toString_1(message_2));
    }
    // Inline function 'kotlin.check' call
    if (!oldNode.np()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.childOperations.ReplaceChildOperation.execute.<anonymous>' call
      var message_3 = "Cannot replace when not empty, id='" + ensureNotNull(oldNodeId).i2s_1 + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message_3));
    }
    model.o2(this.i3b(), nodeFactory.z37(this.k3o_1.x44_1, this.k3o_1.y44_1));
    return model;
  };
  protoOf(ReplaceChildOperation).a3k = function (model, nodeFactory) {
    return this.e44((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(ReplaceChildOperation).s3l = function () {
    return new ReplaceChildOperation(this.k3o_1, this.j3o_1);
  };
  protoOf(ReplaceChildOperation).toString = function () {
    return 'replaceChild[oldN = ' + toString_0(this.j3o_1.y44_1) + ';newN = ' + toString_0(this.k3o_1.y44_1) + ';i = ' + this.i3b() + ']';
  };
  function InPlaceNodeDiffBuilder(source, target) {
    NodeDiffBuilder.call(this, source, target);
  }
  protoOf(InPlaceNodeDiffBuilder).g45 = function (source) {
    return source.v2z();
  };
  protoOf(InPlaceNodeDiffBuilder).h45 = function (source) {
    return source.y2z();
  };
  function exists($this, nodeId) {
    return !($this.q45_1.c3a(nodeId) == null);
  }
  function neverExisted($this, nodeId) {
    return !$this.r45_1.s(nodeId) && $this.q45_1.c3a(nodeId) == null;
  }
  function getInsertionPoint($this, toInsert) {
    var parent = toInsert.z39();
    return getModified($this, ensureNotNull(parent));
  }
  function getModified($this, node) {
    if (node.w39()) {
      return safeGet($this, node.v39());
    }
    var root = $this.q45_1.g30_1;
    return Companion_instance_58.s45(node, root);
  }
  function safeGet($this, nodeId) {
    var tmp0_elvis_lhs = $this.q45_1.c3a(nodeId);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('No node for id=' + nodeId.toString());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function ModifiedSource$addChildAndSplitChildCollection$disposable$1($outerEvent) {
    this.t45_1 = $outerEvent;
    ModelAdapter.call(this);
  }
  protoOf(ModifiedSource$addChildAndSplitChildCollection$disposable$1).o34 = function (event) {
    this.t45_1._v = event;
  };
  function ModifiedSource$mergeChildCollectionAndRemoveChild$disposable$1($outerEvent) {
    this.u45_1 = $outerEvent;
    ModelAdapter.call(this);
  }
  protoOf(ModifiedSource$mergeChildCollectionAndRemoveChild$disposable$1).p34 = function (event) {
    this.u45_1._v = event;
  };
  function ModifiedSource(origin) {
    this.r45_1 = HashSet_init_$Create$();
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!origin.w39()) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.q45_1 = new Model(origin.d3a());
  }
  protoOf(ModifiedSource).v45 = function (node) {
    return node.w39() && exists(this, node.v39());
  };
  protoOf(ModifiedSource).w45 = function (node) {
    return node.w39() && neverExisted(this, node.v39());
  };
  protoOf(ModifiedSource).x45 = function (node, index) {
    var tmp0_elvis_lhs = getInsertionPoint(this, node);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Parent for ' + node.toString() + ' not found in modified source');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    parent.l38(ensureNotNull(node.h3b())).p2(index, node.d3a());
  };
  protoOf(ModifiedSource).y45 = function (node) {
    var modifiedNode = getModified(this, node);
    if (node.w39()) {
      var subtreeIds = Nodes_instance.j3i(modifiedNode);
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!intersect(subtreeIds, this.r45_1).p()) {
        var intersection = HashSet_init_$Create$_0(this.r45_1);
        intersection.l2(subtreeIds);
        throw IllegalStateException_init_$Create$_0('Duplicate removal of nodes with ids: ' + intersection.toString());
      }
    }
    modifiedNode.n3b();
  };
  protoOf(ModifiedSource).z45 = function (parentId, childRole, childIndex, newChildId, conceptId, splitRole, splitIndex) {
    var parent = safeGet(this, parentId);
    var outerEvent = {_v: null};
    var disposable = this.q45_1.v33(new ModifiedSource$addChildAndSplitChildCollection$disposable$1(outerEvent));
    parent.t3b(RawNodeFactory_instance.z37(conceptId, newChildId), childRole, childIndex, splitRole, splitIndex);
    disposable.vr();
    return OperationBuilder_instance_0.f43(ensureNotNull(outerEvent._v));
  };
  protoOf(ModifiedSource).a46 = function (toRemove, mergeRole) {
    var parent = toRemove.z39();
    var outerEvent = {_v: null};
    var disposable = this.q45_1.v33(new ModifiedSource$mergeChildCollectionAndRemoveChild$disposable$1(outerEvent));
    ensureNotNull(parent).v3b(toRemove, mergeRole);
    disposable.vr();
    return OperationBuilder_instance_0.g43(ensureNotNull(outerEvent._v));
  };
  protoOf(ModifiedSource).b46 = function (source, role) {
    var modifiedSrc = getModified(this, source);
    return modifiedSrc.l38(role);
  };
  protoOf(ModifiedSource).g45 = function (source) {
    return getModified(this, source).v2z();
  };
  protoOf(ModifiedSource).h45 = function (source) {
    return getModified(this, source).y2z();
  };
  function NodeDiff() {
  }
  protoOf(NodeDiff).u3t = function (source, target) {
    var op = this.c46(source.g30_1, target.g30_1);
    return new SetModelOperation(op);
  };
  protoOf(NodeDiff).c46 = function (source, target) {
    if (!(NodeUtil_instance.y38(source) == null)) {
      try {
        return (new SplitMergeAwareNodeDiffBuilder(source, target)).k2p();
      } catch ($p) {
        if ($p instanceof Exception) {
          var e = $p;
          ThrowableHandlers_getInstance().ps_1.os(e);
        } else {
          throw $p;
        }
      }
    }
    return (new InPlaceNodeDiffBuilder(source, target)).k2p();
  };
  var NodeDiff_instance;
  function NodeDiff_getInstance() {
    return NodeDiff_instance;
  }
  function _get_queue__c6g84g($this) {
    var tmp = $this.k45_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('queue');
    }
  }
  function enqueue($this, source, target) {
    var task = new MyTask(source, target);
    _get_queue__c6g84g($this).e(task);
    return task;
  }
  function buildNodeDiff($this, source, target) {
    var diff = ArrayList_init_$Create$();
    diff.o(propertiesDiff_0($this, source, target));
    diff.o(childrenDiff_0($this, source, target));
    return compose($this, diff);
  }
  function propertiesDiff_0($this, source, target) {
    var diff = ArrayList_init_$Create$();
    var srcPropertyIds = $this.h45(source);
    var trgPropertyIds = target.y2z();
    var _iterator__ex2g4s = srcPropertyIds.k();
    while (_iterator__ex2g4s.l()) {
      var propertyId = _iterator__ex2g4s.m();
      var srcValue = source.z38(propertyId).qr();
      if (trgPropertyIds.s(propertyId)) {
        var trgValue = target.z38(propertyId).qr();
        if (!(srcValue == trgValue)) {
          diff.e(toSupplier($this, changePropertyOp($this, propertyId, srcValue, trgValue)));
        }
      } else {
        diff.e(toSupplier($this, changePropertyOp($this, propertyId, srcValue, null)));
      }
    }
    var _iterator__ex2g4s_0 = trgPropertyIds.k();
    while (_iterator__ex2g4s_0.l()) {
      var propertyId_0 = _iterator__ex2g4s_0.m();
      if (!srcPropertyIds.s(propertyId_0)) {
        diff.e(toSupplier($this, changePropertyOp($this, propertyId_0, null, target.z38(propertyId_0).qr())));
      }
    }
    return diff;
  }
  function changePropertyOp($this, propertyId, srcValue, trgValue) {
    return new ChangePropertyOperation(propertyId, new SetValueOperation(srcValue, trgValue));
  }
  function childrenDiff_0($this, source, target) {
    var diff = ArrayList_init_$Create$();
    var srcChildIds = $this.g45(source);
    var trgChildIds = target.v2z();
    var _iterator__ex2g4s = srcChildIds.k();
    while (_iterator__ex2g4s.l()) {
      var childId = _iterator__ex2g4s.m();
      var targetChildren = trgChildIds.s(childId) ? target.l38(childId) : emptyList();
      diff.e(roleDiff($this, source, childId, targetChildren));
    }
    var _iterator__ex2g4s_0 = trgChildIds.k();
    while (_iterator__ex2g4s_0.l()) {
      var childId_0 = _iterator__ex2g4s_0.m();
      if (!srcChildIds.s(childId_0)) {
        var iterator = target.l38(childId_0).k();
        var index = 0;
        while (iterator.l()) {
          var index_0 = index;
          index = index + 1 | 0;
          var n = iterator.m();
          diff.e(buildOperationSupplier($this, n, index_0));
        }
      }
    }
    return diff;
  }
  function destroyOperationSupplier($this, node, index) {
    return toSupplier($this, $this.m45(ensureNotNull(node.h3b()), node, index));
  }
  function buildOperationSupplier($this, node, index) {
    return toSupplier($this, $this.n45(node, index));
  }
  function roleDiff($this, sourceParent, role, target) {
    var p = $this.p45(sourceParent, role, target);
    var modifiedSource = p.dh_1;
    // Inline function 'kotlin.check' call
    if (!(modifiedSource.n() === target.n())) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.NodeDiffBuilder.roleDiff.<anonymous>' call
      var message = 'Different length in role=' + role.toString() + ': source ' + modifiedSource.n() + ', target ' + target.n();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var diff = ArrayList_init_$Create$();
    diff.e(toSupplier($this, Companion_instance_64.d3m(p.eh_1)));
    diff.o(childrenContentDiff($this, modifiedSource, target));
    return compose($this, diff);
  }
  function childrenContentDiff($this, modifiedSource, target) {
    var diff_0 = ArrayList_init_$Create$();
    var targetIndex = 0;
    var sourceIndex = 0;
    var _iterator__ex2g4s = modifiedSource.k();
    while (_iterator__ex2g4s.l()) {
      var s = _iterator__ex2g4s.m();
      var t = target.q(targetIndex);
      if (NodeUtil_instance.f3i(s, t)) {
        diff_0.e(diff($this, s, t, targetIndex));
        targetIndex = targetIndex + 1 | 0;
        sourceIndex = sourceIndex + 1 | 0;
      } else {
        diff_0.e(destroyOperationSupplier($this, s, sourceIndex));
      }
    }
    while (targetIndex < target.n()) {
      diff_0.e(buildOperationSupplier($this, target.q(targetIndex), targetIndex));
      targetIndex = targetIndex + 1 | 0;
    }
    return diff_0;
  }
  function diff($this, s, t, index) {
    var tmp;
    if (t.a38_1.equals(s.a38_1)) {
      var task = enqueue($this, s, t);
      return NodeDiffBuilder$diff$lambda(s, index, task);
    } else {
      tmp = toSupplier($this, CompositeOperation_init_$Create$([$this.l45(s, index), $this.n45(t, index)]));
    }
    return tmp;
  }
  function compose($this, suppliers) {
    return NodeDiffBuilder$compose$lambda(suppliers);
  }
  function toSupplier($this, op) {
    return NodeDiffBuilder$toSupplier$lambda(op);
  }
  function MyTask(source, target) {
    this.d46_1 = source;
    this.e46_1 = target;
    this.f46_1 = null;
  }
  protoOf(MyTask).g46 = function () {
    var tmp0 = this.f46_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.MyTask.<get-operation>.<anonymous>' call
        var message = 'Task was not executed yet';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return ensureNotNull(this.f46_1)();
  };
  protoOf(MyTask).h46 = function (supplier) {
    // Inline function 'kotlin.check' call
    if (!(this.f46_1 == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.MyTask.setSupplier.<anonymous>' call
      var message = 'Supplier has been set already';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.f46_1 = supplier;
  };
  function NodeDiffBuilder$diff$lambda($s, $index, $task) {
    return function () {
      return new ChildListOperation(ensureNotNull($s.h3b()), new ChangeChildOperation_0(NodeUtil_instance.y38($s), $index, $task.g46()));
    };
  }
  function NodeDiffBuilder$compose$lambda($suppliers) {
    return function () {
      var ops = ArrayList_init_$Create$();
      var _iterator__ex2g4s = $suppliers.k();
      while (_iterator__ex2g4s.l()) {
        var supplier = _iterator__ex2g4s.m();
        ops.e(supplier());
      }
      return Companion_instance_64.d3m(ops);
    };
  }
  function NodeDiffBuilder$toSupplier$lambda($op) {
    return function () {
      return $op;
    };
  }
  function NodeDiffBuilder(source, target) {
    this.i45_1 = source;
    this.j45_1 = target;
    // Inline function 'kotlin.check' call
    if (!this.i45_1.a38_1.equals(this.j45_1.a38_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.NodeDiffBuilder.<anonymous>' call
      var message = MessageBundle_instance.a39(this.i45_1.a38_1, this.j45_1.a38_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.f3i(this.i45_1, this.j45_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.NodeDiffBuilder.<anonymous>' call
      var message_0 = MessageBundle_instance.d39(this.i45_1.v39(), this.j45_1.v39());
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  protoOf(NodeDiffBuilder).k2p = function () {
    this.k45_1 = ArrayDeque_init_$Create$();
    var firstTask = enqueue(this, this.i45_1, this.j45_1);
    while (!_get_queue__c6g84g(this).p()) {
      var task = _get_queue__c6g84g(this).fg();
      task.h46(buildNodeDiff(this, task.d46_1, task.e46_1));
    }
    return firstTask.g46();
  };
  protoOf(NodeDiffBuilder).l45 = function (node, index) {
    return this.m45(ensureNotNull(node.h3b()), node, index);
  };
  protoOf(NodeDiffBuilder).m45 = function (role, node, index) {
    return OperationBuilder_instance_0.c43(role, node, index);
  };
  protoOf(NodeDiffBuilder).n45 = function (node, index) {
    return this.o45(ensureNotNull(node.h3b()), node, index);
  };
  protoOf(NodeDiffBuilder).o45 = function (role, node, index) {
    return OperationBuilder_instance_0.b43(role, node, index);
  };
  protoOf(NodeDiffBuilder).p45 = function (sourceParent, role, target) {
    var source = sourceParent.l38(role);
    var srcIndex = 0;
    var modifiedSource = ArrayList_init_$Create$_0(target.n());
    var operations = ArrayList_init_$Create$();
    var _iterator__ex2g4s = source.k();
    while (_iterator__ex2g4s.l()) {
      var s = _iterator__ex2g4s.m();
      if (!NodeInspectionUtil_getInstance().j46(target, s)) {
        operations.e(this.l45(s, srcIndex));
      } else {
        modifiedSource.e(s);
        srcIndex = srcIndex + 1 | 0;
      }
    }
    var iterator = target.k();
    var index = 0;
    while (iterator.l()) {
      var trgIndex = index;
      index = index + 1 | 0;
      var t = iterator.m();
      if (!NodeInspectionUtil_getInstance().j46(source, t)) {
        var i = trgIndex < modifiedSource.n() ? trgIndex : modifiedSource.n();
        operations.e(this.n45(t, i));
        modifiedSource.p2(i, t);
      }
    }
    return new Pair(modifiedSource, operations);
  };
  function isOfNodesWithIds($this, nodes) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!nodes.p()) {
      tmp = nodes.q(0).w39();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function contains_10($this, container, nodeId, idGetter) {
    return !(indexOf_11($this, container, nodeId, idGetter) === -1);
  }
  function indexOf_11($this, withNodeId, nodeId, idGetter) {
    var iterator = withNodeId.k();
    var index = 0;
    while (iterator.l()) {
      var index_0 = index;
      index = index + 1 | 0;
      var n = iterator.m();
      if (nodeId.equals(idGetter(n))) {
        return index_0;
      }
    }
    return -1;
  }
  function NodeInspectionUtil$NODE_ID_GETTER$lambda(node) {
    return NodeUtil_instance.y38(node);
  }
  function NodeInspectionUtil() {
    NodeInspectionUtil_instance = this;
    var tmp = this;
    tmp.i46_1 = NodeInspectionUtil$NODE_ID_GETTER$lambda;
  }
  protoOf(NodeInspectionUtil).k46 = function (source, target) {
    return isOfNodesWithIds(this, source) || isOfNodesWithIds(this, target);
  };
  protoOf(NodeInspectionUtil).j46 = function (container, node) {
    return this.l46(container, node, this.i46_1);
  };
  protoOf(NodeInspectionUtil).l46 = function (container, node, idGetter) {
    return node.w39() && contains_10(this, container, node.v39(), idGetter);
  };
  protoOf(NodeInspectionUtil).m46 = function (nodes, nodeId) {
    return indexOf_11(this, nodes, nodeId, this.i46_1);
  };
  var NodeInspectionUtil_instance;
  function NodeInspectionUtil_getInstance() {
    if (NodeInspectionUtil_instance == null)
      new NodeInspectionUtil();
    return NodeInspectionUtil_instance;
  }
  function fromNode($this, node, root) {
    var current = node;
    var path = ArrayList_init_$Create$();
    while (!(current == null) && !isRoot($this, current, root)) {
      path.e(new Element_1(current.h3b(), current.i3b()));
      current = current.z39();
      var tmp0 = current;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.Companion.fromNode.<anonymous>' call
          var message = 'Root was not reached, node=' + node.toString();
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
    }
    reverse(path);
    return new NodePath(path);
  }
  function isRoot($this, node, root) {
    return node.w39() && node.v39().equals(root.v39());
  }
  function getNode($this, root) {
    if ($this.n46_1.p()) {
      return root;
    }
    var current = root;
    var _iterator__ex2g4s = $this.n46_1.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'kotlin.check' call
      if (!contains_5(current.v2z(), element.o46_1)) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.NodePath.getNode.<anonymous>' call
        var message = 'Failed to locate descendant by path=' + toString_1($this.n46_1);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      var children = current.l38(ensureNotNull(element.o46_1));
      // Inline function 'kotlin.check' call
      if (!(children.n() > element.p46_1)) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.NodePath.getNode.<anonymous>' call
        var message_0 = 'Failed to locate descendant by path=' + toString_1($this.n46_1);
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      }
      current = children.q(element.p46_1);
    }
    return current;
  }
  function Element_1(role, index) {
    this.o46_1 = role;
    this.p46_1 = index;
  }
  protoOf(Element_1).toString = function () {
    return '(role=' + toString_0(this.o46_1) + ', index=' + this.p46_1 + ')';
  };
  protoOf(Element_1).hashCode = function () {
    var result = this.o46_1 == null ? 0 : this.o46_1.hashCode();
    result = imul(result, 31) + this.p46_1 | 0;
    return result;
  };
  protoOf(Element_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Element_1))
      return false;
    var tmp0_other_with_cast = other instanceof Element_1 ? other : THROW_CCE();
    if (!equals(this.o46_1, tmp0_other_with_cast.o46_1))
      return false;
    if (!(this.p46_1 === tmp0_other_with_cast.p46_1))
      return false;
    return true;
  };
  function Companion_58() {
  }
  protoOf(Companion_58).s45 = function (node, root) {
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (node == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.Companion.getNodeInRoot.<anonymous>' call
        var message = 'Null target node';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    $l$block_0: {
      // Inline function 'kotlin.requireNotNull' call
      if (root == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.Companion.getNodeInRoot.<anonymous>' call
        var message_0 = 'No root to build path to';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      } else {
        break $l$block_0;
      }
    }
    // Inline function 'kotlin.require' call
    if (!root.w39()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.Companion.getNodeInRoot.<anonymous>' call
      var message_1 = 'Root without id';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }
    return getNode(fromNode(this, node, root), root);
  };
  var Companion_instance_58;
  function Companion_getInstance_58() {
    return Companion_instance_58;
  }
  function NodePath(path) {
    this.n46_1 = path;
  }
  function NodeWithRegistry(node) {
    this.q46_1 = node;
  }
  function SplitMergeAwareNodeDiffBuilder$MoveToData$Companion$REVERSE_PARENT_ORDER_COMPARATOR$1() {
  }
  protoOf(SplitMergeAwareNodeDiffBuilder$MoveToData$Companion$REVERSE_PARENT_ORDER_COMPARATOR$1).s46 = function (a, b) {
    return b.t46_1.i3b() - a.t46_1.i3b() | 0;
  };
  protoOf(SplitMergeAwareNodeDiffBuilder$MoveToData$Companion$REVERSE_PARENT_ORDER_COMPARATOR$1).compare = function (a, b) {
    var tmp = a instanceof MoveToData ? a : THROW_CCE();
    return this.s46(tmp, b instanceof MoveToData ? b : THROW_CCE());
  };
  function Companion_59() {
    Companion_instance_59 = this;
    var tmp = this;
    tmp.w46_1 = new SplitMergeAwareNodeDiffBuilder$MoveToData$Companion$REVERSE_PARENT_ORDER_COMPARATOR$1();
  }
  var Companion_instance_59;
  function Companion_getInstance_59() {
    if (Companion_instance_59 == null)
      new Companion_59();
    return Companion_instance_59;
  }
  function wrap($this, node) {
    return node.c38_1 == null ? new MyNotAttachedNode(node) : new MyAttachedNode(node);
  }
  function getMovedChildren($this, parent, target) {
    if (!parent.w39()) {
      return emptyList();
    }
    var result = null;
    var _iterator__ex2g4s = parent.v2z().k();
    while (_iterator__ex2g4s.l()) {
      var role = _iterator__ex2g4s.m();
      var _iterator__ex2g4s_0 = parent.l38(role).k();
      while (_iterator__ex2g4s_0.l()) {
        var child = _iterator__ex2g4s_0.m();
        if (child.w39()) {
          var existent = target.r46(child.v39());
          if (!(existent == null)) {
            // Inline function 'kotlin.check' call
            if (!role.equals(existent.h3b())) {
              // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.SplitMergeAwareNodeDiffBuilder.getMovedChildren.<anonymous>' call
              var message = MessageBundle_instance.b39(role, ensureNotNull(existent.h3b())) + ', node=' + toString_0(existent);
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }
            var existentParent = existent.z39();
            $l$block: {
              // Inline function 'kotlin.checkNotNull' call
              if (existentParent == null) {
                // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.SplitMergeAwareNodeDiffBuilder.getMovedChildren.<anonymous>' call
                var message_0 = 'Root or detached node: ' + toString_0(existent);
                throw IllegalStateException_init_$Create$_0(toString_1(message_0));
              } else {
                break $l$block;
              }
            }
            if (!parent.v39().equals(existentParent.v39())) {
              if (result == null) {
                result = ArrayList_init_$Create$();
              }
              result.e(existent);
            }
          }
        }
      }
    }
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = result;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  }
  function getMoveIterable($this, movedChildren) {
    var byTargetParent = HashMap_init_$Create$();
    var _iterator__ex2g4s = movedChildren.k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      var parent = child.z39();
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (parent == null) {
          // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.SplitMergeAwareNodeDiffBuilder.getMoveIterable.<anonymous>' call
          var message = 'No parent for ' + child.toString();
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      var location = new Pair(parent, ensureNotNull(child.h3b()));
      // Inline function 'kotlin.collections.getOrPut' call
      var value = byTargetParent.y2(location);
      var tmp;
      if (value == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.SplitMergeAwareNodeDiffBuilder.getMoveIterable.<anonymous>' call
        var answer = ArrayList_init_$Create$();
        byTargetParent.r2(location, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      var list = tmp;
      list.e(child);
    }
    var data = ArrayList_init_$Create$_0(byTargetParent.n());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = byTargetParent.w().k();
    while (_iterator__ex2g4s_0.l()) {
      var _destruct__k2r9zo = _iterator__ex2g4s_0.m();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.x();
      // Inline function 'kotlin.collections.component2' call
      var value_0 = _destruct__k2r9zo.y();
      data.e(new MoveToData(key.dh_1, key.eh_1, value_0));
    }
    var result = toList_0(data);
    return sortedWith(result, Companion_getInstance_59().w46_1);
  }
  function checkReordering($this, source, target) {
    if (NodeInspectionUtil_getInstance().k46(source, target)) {
      var inductionVariable = source.n() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          // Inline function 'kotlin.check' call
          if (!source.q(i).v39().equals(target.q(i).v39())) {
            // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.SplitMergeAwareNodeDiffBuilder.checkReordering.<anonymous>' call
            var message = 'Expected ' + target.q(i).v39().toString() + ', got ' + source.q(i).v39().toString() + ' at position ' + i;
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
        }
         while (0 <= inductionVariable);
    }
  }
  function getFromSource($this, parent, role) {
    return $this.b47_1.b46(parent, role);
  }
  function doArrange($this, sourceParent, role, target) {
    var result = ArrayList_init_$Create$();
    var moveData = null;
    var sourceIndex = 0;
    while (sourceIndex < getFromSource($this, sourceParent, role).n()) {
      var s = getFromSource($this, sourceParent, role).q(sourceIndex);
      var movedChildren = s.w39() ? getMovedChildren($this, s, $this.a47_1) : emptyList();
      if (movedChildren.p()) {
        if (!NodeInspectionUtil_getInstance().j46(target, s)) {
          result.e($this.l45(s, sourceIndex));
        } else {
          sourceIndex = sourceIndex + 1 | 0;
        }
      } else {
        if (moveData == null) {
          moveData = ArrayList_init_$Create$();
        }
        var tmp = moveData;
        var tmp_0 = new MoveFromData(s, movedChildren);
        var _unary__edvuaz = sourceIndex;
        sourceIndex = _unary__edvuaz + 1 | 0;
        tmp.e(new Pair(tmp_0, _unary__edvuaz));
      }
    }
    if (!(moveData == null)) {
      processMoves($this, moveData, sourceParent, role, result);
    }
    var source = getFromSource($this, sourceParent, role);
    var iterator = target.k();
    var index = 0;
    while (iterator.l()) {
      var targetIndex = index;
      index = index + 1 | 0;
      var t = iterator.m();
      if (!NodeInspectionUtil_getInstance().j46(source, t)) {
        result.e($this.n45(t, targetIndex));
      }
    }
    return result;
  }
  function processMoves($this, moveData, sourceParent, role, result) {
    var initSize = getFromSource($this, sourceParent, role).n();
    var _iterator__ex2g4s = moveData.k();
    while (_iterator__ex2g4s.l()) {
      var p = _iterator__ex2g4s.m();
      var curSize = getFromSource($this, sourceParent, role).n();
      var index = (p.eh_1 + curSize | 0) - initSize | 0;
      result.o(arrangeWithSplitsAndMerges($this, p.dh_1, index));
    }
    var sourceCollection = getFromSource($this, sourceParent, role);
    var removedNum = 0;
    var _iterator__ex2g4s_0 = moveData.k();
    while (_iterator__ex2g4s_0.l()) {
      var p_0 = _iterator__ex2g4s_0.m();
      var source = p_0.dh_1.c47_1;
      if ($this.b47_1.v45(source) && getFrom($this, $this.a47_1, source) == null) {
        result.e($this.m45(ensureNotNull(source.h3b()), source, NodeInspectionUtil_getInstance().m46(sourceCollection, source.v39()) - removedNum | 0));
        removedNum = removedNum + 1 | 0;
      }
    }
  }
  function arrangeWithSplitsAndMerges($this, from, sourceIndex) {
    var to = getMoveIterable($this, from.d47_1);
    var result = ArrayList_init_$Create$();
    var iterator = to.k();
    while (iterator.l()) {
      var md = iterator.m();
      if ($this.b47_1.v45(md.t46_1)) {
        // Inline function 'kotlin.check' call
        if (!!iterator.l()) {
          // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.SplitMergeAwareNodeDiffBuilder.arrangeWithSplitsAndMerges.<anonymous>' call
          var message = 'Cannot merge and remove, because there are more pending moves: ' + md.toString();
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        result.e(doMerge($this, from.c47_1, md));
        return result;
      }
      if ($this.b47_1.w45(md.t46_1)) {
        result.e(doSplit($this, from.c47_1, sourceIndex, md));
      } else {
        throw IllegalStateException_init_$Create$_0('No split or merge can be performed: ' + md.toString());
      }
    }
    return result;
  }
  function doMerge($this, toRemove, md) {
    // Inline function 'kotlin.check' call
    if (!(toRemove.y2z().p() && !hasChildWithoutIdInMajorRole($this, toRemove))) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.diff.SplitMergeAwareNodeDiffBuilder.doMerge.<anonymous>' call
      var message = 'Cannot merge and remove because of non-null properties and/or other children: source=' + toRemove.toString() + ', ' + md.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var majorRole = toRemove.h3b();
    var op = $this.b47_1.a46(toRemove, md.u46_1);
    return new ChildListOperation(ensureNotNull(majorRole), op);
  }
  function doSplit($this, source, sourceIndex, md) {
    var firstMoved = md.v46_1.q(0);
    var splitCollection = getFromSource($this, source, md.u46_1);
    var splitIndex = NodeInspectionUtil_getInstance().m46(splitCollection, firstMoved.v39());
    var addChildId = md.t46_1.v39();
    var addChildConceptId = md.t46_1.a38_1;
    var addIndex = sourceIndex + 1 | 0;
    var majorRole = source.h3b();
    var op = $this.b47_1.z45(ensureNotNull(source.z39()).v39(), ensureNotNull(majorRole), addIndex, addChildId, addChildConceptId, md.u46_1, splitIndex);
    return new ChildListOperation(majorRole, op);
  }
  function hasChildWithoutIdInMajorRole($this, node) {
    var _iterator__ex2g4s = node.v2z().k();
    while (_iterator__ex2g4s.l()) {
      var id = _iterator__ex2g4s.m();
      var _iterator__ex2g4s_0 = node.l38(id).k();
      while (_iterator__ex2g4s_0.l()) {
        var child = _iterator__ex2g4s_0.m();
        if (!child.w39()) {
          return true;
        }
      }
    }
    return false;
  }
  function getFrom($this, target, item) {
    return item.w39() ? target.r46(item.v39()) : null;
  }
  function MoveFromData(source, movedChildren) {
    this.c47_1 = source;
    this.d47_1 = movedChildren;
  }
  function MoveToData(newParent, role, children) {
    Companion_getInstance_59();
    this.t46_1 = newParent;
    this.u46_1 = role;
    this.v46_1 = children;
  }
  protoOf(MoveToData).toString = function () {
    return 'newParent=' + this.t46_1.toString() + ', role=' + this.u46_1.toString() + ', children=' + toString_1(this.v46_1);
  };
  function MyAttachedNode(node) {
    NodeWithRegistry.call(this, node);
  }
  protoOf(MyAttachedNode).r46 = function (id) {
    return ensureNotNull(this.q46_1.c38_1).c3a(id);
  };
  function MyNotAttachedNode(node) {
    NodeWithRegistry.call(this, node);
    this.g47_1 = Nodes_instance.k3i(node);
  }
  protoOf(MyNotAttachedNode).r46 = function (id) {
    return this.g47_1.y2(id);
  };
  function SplitMergeAwareNodeDiffBuilder(source, target) {
    NodeDiffBuilder.call(this, source, target);
    this.a47_1 = wrap(this, target);
    this.b47_1 = new ModifiedSource(source);
  }
  protoOf(SplitMergeAwareNodeDiffBuilder).h45 = function (source) {
    return this.b47_1.h45(source);
  };
  protoOf(SplitMergeAwareNodeDiffBuilder).g45 = function (source) {
    return this.b47_1.g45(source);
  };
  protoOf(SplitMergeAwareNodeDiffBuilder).m45 = function (role, node, index) {
    this.b47_1.y45(node);
    return protoOf(NodeDiffBuilder).m45.call(this, role, node, index);
  };
  protoOf(SplitMergeAwareNodeDiffBuilder).o45 = function (role, node, index) {
    this.b47_1.x45(node, index);
    return protoOf(NodeDiffBuilder).o45.call(this, role, node, index);
  };
  protoOf(SplitMergeAwareNodeDiffBuilder).p45 = function (sourceParent, role, target) {
    var result = doArrange(this, sourceParent, role, target);
    var modifiedSource = getFromSource(this, sourceParent, role);
    checkReordering(this, modifiedSource, target);
    return new Pair(modifiedSource, result);
  };
  function ModelOperationConverter$toModelOperation$lambda(currNode, operation) {
    return currNode.z39() == null ? new SetModelOperation(operation) : null;
  }
  function ModelOperationConverter() {
  }
  protoOf(ModelOperationConverter).h47 = function (node, op) {
    return this.i47(node, op, ModelOperationConverter$toModelOperation$lambda);
  };
  protoOf(ModelOperationConverter).i47 = function (node, op, finalOp) {
    var tmp0_elvis_lhs = finalOp(node, op);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.modelOperationConverter.ModelOperationConverter.toModelOperation.<anonymous>' call
      // Inline function 'kotlin.checkNotNull' call
      var tmp0 = node.z39();
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          tmp$ret$1 = tmp0;
          break $l$block;
        }
      }
      var nodeParent = tmp$ret$1;
      var role = ensureNotNull(node.h3b());
      var index = nodeParent.l38(role).t(node);
      var changeChildOperation = new ChangeChildOperation_0(NodeUtil_instance.y38(node), index, op);
      tmp = this.i47(nodeParent, new ChildListOperation(role, changeChildOperation), finalOp);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var ModelOperationConverter_instance;
  function ModelOperationConverter_getInstance() {
    return ModelOperationConverter_instance;
  }
  function ModelOperationsTracker() {
  }
  protoOf(ModelOperationsTracker).j34 = function (event) {
    this.v3l(ModelOperationConverter_instance.h47(event.i3h_1, OperationBuilder_instance_0.b43(event.r3g_1, event.t3g_1, event.s3g_1)));
  };
  protoOf(ModelOperationsTracker).k34 = function (event) {
    this.v3l(ModelOperationConverter_instance.h47(event.i3h_1, OperationBuilder_instance_0.c43(event.r3g_1, event.t3g_1, event.s3g_1)));
  };
  protoOf(ModelOperationsTracker).l34 = function (event) {
    this.v3l(ModelOperationConverter_instance.h47(event.i3h_1, OperationBuilder_instance_0.e43(event.r3g_1, event.c3h_1, event.d3h(), event.s3g_1)));
  };
  protoOf(ModelOperationsTracker).m34 = function (event) {
    var addOperation = new AddChildSplitPropertyOperation(event.t3g_1.a38_1, event.e3g_1.v39(), event.t3g_1.v39(), event.s3g_1, event.g3g_1, event.f3g_1, event.h3g_1);
    var builder = new NodeAssemblyOperationBuilder(event.t3g_1);
    builder.x42(event.g3g_1);
    var buildOperation = new ChangeChildOperation_0(event.t3g_1.v39(), event.s3g_1, builder.k2p());
    this.v3l(ModelOperationConverter_instance.h47(event.i3h_1, new ChildListOperation(event.r3g_1, CompositeOperation_init_$Create$([addOperation, buildOperation]))));
  };
  protoOf(ModelOperationsTracker).n34 = function (event) {
    var removeOperation = new MergePropertyRemoveChildOperation(event.t3g_1.a38_1, event.t3g_1.v39(), event.v3h_1.v39(), event.s3g_1, event.x3h_1, event.y3h_1, event.w3h_1);
    var builder = new NodeAssemblyOperationBuilder(event.t3g_1);
    builder.x42(event.x3h_1);
    var buildOperation = new ChangeChildOperation_0(event.t3g_1.v39(), event.s3g_1, builder.k2p().s3l());
    this.v3l(ModelOperationConverter_instance.h47(event.i3h_1, new ChildListOperation(event.r3g_1, CompositeOperation_init_$Create$([buildOperation, removeOperation]))));
  };
  protoOf(ModelOperationsTracker).o34 = function (event) {
    var addOperation = OperationBuilder_instance_0.f43(event);
    var builder = new NodeAssemblyOperationBuilder(event.t3g_1);
    builder.y42(event.t3f_1);
    var buildOperation = new ChangeChildOperation_0(event.t3g_1.v39(), event.s3g_1, builder.k2p());
    this.v3l(ModelOperationConverter_instance.h47(event.i3h_1, new ChildListOperation(event.r3g_1, CompositeOperation_init_$Create$([addOperation, buildOperation]))));
  };
  protoOf(ModelOperationsTracker).p34 = function (event) {
    var removeOperation = OperationBuilder_instance_0.g43(event);
    var builder = new NodeAssemblyOperationBuilder(event.t3g_1);
    builder.y42(event.o3g_1);
    var buildOperation = new ChangeChildOperation_0(event.t3g_1.v39(), event.s3g_1, builder.k2p().s3l());
    this.v3l(ModelOperationConverter_instance.h47(event.i3h_1, new ChildListOperation(event.r3g_1, CompositeOperation_init_$Create$([buildOperation, removeOperation]))));
  };
  protoOf(ModelOperationsTracker).i34 = function (event) {
    var propertyOperation = new ChangePropertyOperation(event.a3i_1, new SetValueOperation(event.b3i_1, event.c3i_1));
    this.v3l(ModelOperationConverter_instance.h47(event.i3h_1, propertyOperation));
  };
  protoOf(ModelOperationsTracker).q34 = function (event) {
    var propertyOperation = new ChangePropertyOperation(event.o3h_1, new InsertTextOperation(event.p3h_1, event.q3h_1));
    this.v3l(ModelOperationConverter_instance.h47(event.i3h_1, propertyOperation));
  };
  protoOf(ModelOperationsTracker).r34 = function (event) {
    var propertyOperation = new ChangePropertyOperation(event.o3h_1, new DeleteTextOperation(event.p3h_1, event.q3h_1));
    this.v3l(ModelOperationConverter_instance.h47(event.i3h_1, propertyOperation));
  };
  function AddChildOperationExecutor$installChecker$1_0($tempContainer, this$0) {
    NodeChildOperationsExecutorChecker.call(this, $tempContainer.g30_1, ensureNotNull(this$0.m3p_1).i3b(), ensureNotNull(this$0.m3p_1).x3i(), this$0.h3r());
  }
  protoOf(AddChildOperationExecutor$installChecker$1_0).j34 = function (event) {
    this.r47(event);
  };
  function AddChildOperationExecutor_0(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseAddOperationExecutor.call(this, nodeFactory);
    this.a48_1 = NodeChildIdFactory_getInstance().e3c();
  }
  protoOf(AddChildOperationExecutor_0).b48 = function (op) {
    return op instanceof AddChildOperation_0;
  };
  protoOf(AddChildOperationExecutor_0).q3r = function (op) {
    return this.b48(op);
  };
  protoOf(AddChildOperationExecutor_0).c48 = function (op) {
    return NodeOperationsExecutorUtil_instance.d48(ensureNotNull(this.m3p_1).x3i(), ensureNotNull(this.m3p_1).i3b(), op);
  };
  protoOf(AddChildOperationExecutor_0).t3r = function (op) {
    return this.c48(op);
  };
  protoOf(AddChildOperationExecutor_0).e48 = function (source) {
    var conceptId = NodeConceptIdFactory_getInstance().o3c();
    var parentCopy = RawNodeFactory_instance.j3f(conceptId);
    var _iterator__ex2g4s = source.k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      var childCopy = this.l3p_1.z37(child.a38_1, NodeUtil_instance.y38(child));
      parentCopy.l38(this.a48_1).e(childCopy);
    }
    return new Model(parentCopy);
  };
  protoOf(AddChildOperationExecutor_0).v3r = function (source) {
    return this.e48((!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE());
  };
  protoOf(AddChildOperationExecutor_0).f48 = function (tempContainer) {
    return NodeOperationsExecutorUtil_instance.g48(tempContainer, this.a48_1);
  };
  protoOf(AddChildOperationExecutor_0).x3r = function (tempContainer) {
    return this.f48(tempContainer instanceof Model ? tempContainer : THROW_CCE());
  };
  protoOf(AddChildOperationExecutor_0).h48 = function (source, temp) {
    var added = temp.q(ensureNotNull(this.m3p_1).i3b());
    added.n3b();
    source.p2(ensureNotNull(this.m3p_1).i3b(), added);
  };
  protoOf(AddChildOperationExecutor_0).z3r = function (source, temp) {
    var tmp = (!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE();
    return this.h48(tmp, (!(temp == null) ? isInterface(temp, KtMutableList) : false) ? temp : THROW_CCE());
  };
  protoOf(AddChildOperationExecutor_0).i48 = function (tempContainer) {
    return tempContainer.v33(new AddChildOperationExecutor$installChecker$1_0(tempContainer, this));
  };
  protoOf(AddChildOperationExecutor_0).b3s = function (tempContainer) {
    return this.i48(tempContainer instanceof Model ? tempContainer : THROW_CCE());
  };
  function ChangeChildOperationExecutor_0(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.t44_1 = nodeFactory;
  }
  protoOf(ChangeChildOperationExecutor_0).u44 = function (model, ops) {
    var executionResult = (new RemoveChildOperationExecutor(this.t44_1)).p3p(model, ops);
    if (!executionResult.j48_1) {
      executionResult = (new ReplaceChildOperationExecutor(this.t44_1)).p3p(model, ops);
    }
    return executionResult;
  };
  function applyOperation($this, node, operation, nodeFactory) {
    if (isInterface(operation, OperationContainer)) {
      var operationContainer = isInterface(operation, OperationContainer) ? operation : THROW_CCE();
      applyContainer($this, node, operationContainer, nodeFactory);
    } else {
      if (operation instanceof InsertTextOperation) {
        node.l39($this.h3b(), TextOperationUtil_instance.q48(operation), operation.t48_1);
      } else {
        if (operation instanceof DeleteTextOperation) {
          node.n39($this.h3b(), TextOperationUtil_instance.q48(operation), operation.a());
        } else {
          var oldValue = $this.p48(node);
          node.z38($this.h3b()).t2c(operation.a3k(oldValue, nodeFactory));
        }
      }
    }
    return node;
  }
  function applyContainer($this, node, operation, nodeFactory) {
    var _iterator__ex2g4s = operation.l3i().k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      applyOperation($this, node, op, nodeFactory);
    }
  }
  function ChangePropertyOperation(role, op) {
    TargetedOperation.call(this, role, op);
    this.o48_1 = 'changeProperty';
  }
  protoOf(ChangePropertyOperation).b3 = function () {
    return this.o48_1;
  };
  protoOf(ChangePropertyOperation).j3z = function (op) {
    return new ChangePropertyOperation(this.h3b(), op);
  };
  protoOf(ChangePropertyOperation).y3p = function (op) {
    return this.j3z(op);
  };
  protoOf(ChangePropertyOperation).p48 = function (source) {
    return source.z38(this.h3b()).qr();
  };
  protoOf(ChangePropertyOperation).c3q = function (source) {
    return this.p48(source instanceof OtNode ? source : THROW_CCE());
  };
  protoOf(ChangePropertyOperation).u48 = function (model, customExecute, nodeFactory) {
    return applyOperation(this, model, this.u3l(), nodeFactory);
  };
  protoOf(ChangePropertyOperation).d3v = function (model, customExecute, nodeFactory) {
    return this.u48(model instanceof OtNode ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(ChangePropertyOperation).d3q = function (model, customExecute, nodeFactory) {
    return this.u48(model instanceof OtNode ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  function ChildListOperation(role, op) {
    TargetedOperation.call(this, role, op);
  }
  protoOf(ChildListOperation).b3 = function () {
    return 'setChild';
  };
  protoOf(ChildListOperation).y48 = function (op) {
    return new ChildListOperation(this.h3b(), op);
  };
  protoOf(ChildListOperation).y3p = function (op) {
    return this.y48(op);
  };
  protoOf(ChildListOperation).p48 = function (source) {
    return source.l38(this.h3b());
  };
  protoOf(ChildListOperation).c3q = function (source) {
    return this.p48(source instanceof OtNode ? source : THROW_CCE());
  };
  function handleMainEvent_0($this, event) {
    if (!($this.t47_1 === event.s3g_1) || !NodeUtil_instance.e3i(event.t3g_1, $this.u47_1)) {
      $this.v47_1();
    }
  }
  function NodeChildOperationsExecutorChecker(allowedParent, allowedChildIndex, allowedChildId, canceller) {
    NodeOperationsExecutorChecker.call(this, allowedParent, allowedChildIndex, allowedChildId, canceller);
  }
  protoOf(NodeChildOperationsExecutorChecker).r47 = function (event) {
    if (equals(event.i3h_1, this.s47_1)) {
      handleMainEvent_0(this, event);
    } else {
      this.h34(event);
    }
  };
  function NodeOperationsExecutorChecker(allowedParent, allowedChildIndex, allowedChildId, canceller) {
    ModelAdapter.call(this);
    this.s47_1 = allowedParent;
    this.t47_1 = allowedChildIndex;
    this.u47_1 = allowedChildId;
    this.v47_1 = canceller;
  }
  protoOf(NodeOperationsExecutorChecker).h34 = function (event) {
    var node = event.i3h_1;
    while (!(node == null) && !equals(node.z39(), this.s47_1)) {
      node = node.z39();
    }
    if (node == null || !(this.t47_1 === node.i3b()) || !NodeUtil_instance.e3i(node, this.u47_1)) {
      this.v47_1();
    }
  };
  function NodeOperationsExecutorUtil() {
  }
  protoOf(NodeOperationsExecutorUtil).d48 = function (expectedId, expectedIndex, op) {
    var tmp;
    var tmp_0;
    if (op instanceof ChangeChildOperation_0) {
      tmp_0 = NodeUtil_instance.g3i(expectedId, op.m44_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = expectedIndex === op.h3b();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(NodeOperationsExecutorUtil).z48 = function (source, role, fullCopiedItemIndex, nodeFactory) {
    var conceptId = NodeConceptIdFactory_getInstance().o3c();
    var root = RawNodeFactory_instance.j3f(conceptId);
    var listCopy = root.l38(role);
    var iterator = source.i2();
    while (iterator.l()) {
      var srcChild = iterator.m();
      if (iterator.o5() === fullCopiedItemIndex) {
        listCopy.e(srcChild.d3a());
      } else {
        var node = nodeFactory.z37(srcChild.a38_1, NodeUtil_instance.y38(srcChild));
        listCopy.e(node);
      }
    }
    return new Model(root);
  };
  protoOf(NodeOperationsExecutorUtil).g48 = function (container, role) {
    return container.g30_1.l38(role);
  };
  var NodeOperationsExecutorUtil_instance;
  function NodeOperationsExecutorUtil_getInstance() {
    return NodeOperationsExecutorUtil_instance;
  }
  function RemoveChildOperationExecutor$installChecker$1($tempContainer, this$0) {
    NodeChildOperationsExecutorChecker.call(this, $tempContainer.g30_1, ensureNotNull(this$0.m3p_1).i3b(), ensureNotNull(this$0.m3p_1).x3i(), this$0.h3r());
  }
  protoOf(RemoveChildOperationExecutor$installChecker$1).k34 = function (event) {
    this.r47(event);
  };
  function RemoveChildOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseRemoveOperationExecutor.call(this, nodeFactory);
    this.i49_1 = NodeChildIdFactory_getInstance().e3c();
  }
  protoOf(RemoveChildOperationExecutor).b48 = function (op) {
    return op instanceof RemoveChildOperation_0;
  };
  protoOf(RemoveChildOperationExecutor).q3r = function (op) {
    return this.b48(op);
  };
  protoOf(RemoveChildOperationExecutor).j49 = function (source) {
    var index = ensureNotNull(this.m3p_1).i3b();
    var expectedId = ensureNotNull(this.m3p_1).x3i();
    return index < source.n() && NodeUtil_instance.e3i(source.q(index), expectedId);
  };
  protoOf(RemoveChildOperationExecutor).i3s = function (source) {
    return this.j49((!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE());
  };
  protoOf(RemoveChildOperationExecutor).k49 = function (op) {
    return NodeOperationsExecutorUtil_instance.d48(ensureNotNull(this.m3p_1).x3i(), ensureNotNull(this.m3p_1).i3b(), op);
  };
  protoOf(RemoveChildOperationExecutor).j3s = function (op) {
    return this.k49(op);
  };
  protoOf(RemoveChildOperationExecutor).e48 = function (source) {
    return NodeOperationsExecutorUtil_instance.z48(source, this.i49_1, ensureNotNull(this.m3p_1).i3b(), this.l3p_1);
  };
  protoOf(RemoveChildOperationExecutor).v3r = function (source) {
    return this.e48((!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE());
  };
  protoOf(RemoveChildOperationExecutor).f48 = function (tempContainer) {
    return NodeOperationsExecutorUtil_instance.g48(tempContainer, this.i49_1);
  };
  protoOf(RemoveChildOperationExecutor).x3r = function (tempContainer) {
    return this.f48(tempContainer instanceof Model ? tempContainer : THROW_CCE());
  };
  protoOf(RemoveChildOperationExecutor).h48 = function (source, temp) {
    source.q2(ensureNotNull(this.m3p_1).i3b());
  };
  protoOf(RemoveChildOperationExecutor).z3r = function (source, temp) {
    var tmp = (!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE();
    return this.h48(tmp, (!(temp == null) ? isInterface(temp, KtMutableList) : false) ? temp : THROW_CCE());
  };
  protoOf(RemoveChildOperationExecutor).i48 = function (tempContainer) {
    return tempContainer.v33(new RemoveChildOperationExecutor$installChecker$1(tempContainer, this));
  };
  protoOf(RemoveChildOperationExecutor).b3s = function (tempContainer) {
    return this.i48(tempContainer instanceof Model ? tempContainer : THROW_CCE());
  };
  function ReplaceChildOperationExecutor$installChecker$1($tempContainer, this$0) {
    this.p49_1 = this$0;
    NodeOperationsExecutorChecker.call(this, $tempContainer.g30_1, ensureNotNull(this$0.m3p_1).i3b(), ensureNotNull(this$0.m3p_1).p44(), this$0.h3r());
  }
  protoOf(ReplaceChildOperationExecutor$installChecker$1).l34 = function (event) {
    if (!(ensureNotNull(this.p49_1.m3p_1).i3b() === event.s3g_1) || !NodeUtil_instance.e3i(event.c3h_1, ensureNotNull(this.p49_1.m3p_1).p44()) || !NodeUtil_instance.e3i(event.d3h(), ensureNotNull(this.p49_1.m3p_1).c44())) {
      this.p49_1.i2n();
    } else {
      this.u47_1 = NodeUtil_instance.y38(event.d3h());
    }
  };
  function ReplaceChildOperationExecutor(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    BaseOperationExecutor.call(this, nodeFactory);
    this.u49_1 = NodeChildIdFactory_getInstance().e3c();
    this.v49_1 = 3;
    this.w49_1 = MainOpPos_ANY_getInstance();
  }
  protoOf(ReplaceChildOperationExecutor).g3s = function () {
    return this.v49_1;
  };
  protoOf(ReplaceChildOperationExecutor).h3s = function () {
    return this.w49_1;
  };
  protoOf(ReplaceChildOperationExecutor).b48 = function (op) {
    return op instanceof ReplaceChildOperation;
  };
  protoOf(ReplaceChildOperationExecutor).q3r = function (op) {
    return this.b48(op);
  };
  protoOf(ReplaceChildOperationExecutor).j49 = function (source) {
    var index = ensureNotNull(this.m3p_1).i3b();
    var expectedId = ensureNotNull(this.m3p_1).p44();
    return index < source.n() && NodeUtil_instance.e3i(source.q(index), expectedId);
  };
  protoOf(ReplaceChildOperationExecutor).i3s = function (source) {
    return this.j49((!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE());
  };
  protoOf(ReplaceChildOperationExecutor).k49 = function (op) {
    return NodeOperationsExecutorUtil_instance.d48(ensureNotNull(this.m3p_1).p44(), ensureNotNull(this.m3p_1).i3b(), op);
  };
  protoOf(ReplaceChildOperationExecutor).j3s = function (op) {
    return this.k49(op);
  };
  protoOf(ReplaceChildOperationExecutor).c48 = function (op) {
    return NodeOperationsExecutorUtil_instance.d48(ensureNotNull(this.m3p_1).c44(), ensureNotNull(this.m3p_1).i3b(), op);
  };
  protoOf(ReplaceChildOperationExecutor).t3r = function (op) {
    return this.c48(op);
  };
  protoOf(ReplaceChildOperationExecutor).e48 = function (source) {
    return NodeOperationsExecutorUtil_instance.z48(source, this.u49_1, ensureNotNull(this.m3p_1).i3b(), this.l3p_1);
  };
  protoOf(ReplaceChildOperationExecutor).v3r = function (source) {
    return this.e48((!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE());
  };
  protoOf(ReplaceChildOperationExecutor).f48 = function (tempContainer) {
    return NodeOperationsExecutorUtil_instance.g48(tempContainer, this.u49_1);
  };
  protoOf(ReplaceChildOperationExecutor).x3r = function (tempContainer) {
    return this.f48(tempContainer instanceof Model ? tempContainer : THROW_CCE());
  };
  protoOf(ReplaceChildOperationExecutor).h48 = function (source, temp) {
    var replacement = temp.q(ensureNotNull(this.m3p_1).i3b());
    replacement.n3b();
    source.o2(ensureNotNull(this.m3p_1).i3b(), replacement);
  };
  protoOf(ReplaceChildOperationExecutor).z3r = function (source, temp) {
    var tmp = (!(source == null) ? isInterface(source, KtMutableList) : false) ? source : THROW_CCE();
    return this.h48(tmp, (!(temp == null) ? isInterface(temp, KtMutableList) : false) ? temp : THROW_CCE());
  };
  protoOf(ReplaceChildOperationExecutor).i48 = function (tempContainer) {
    return tempContainer.v33(new ReplaceChildOperationExecutor$installChecker$1(tempContainer, this));
  };
  protoOf(ReplaceChildOperationExecutor).b3s = function (tempContainer) {
    return this.i48(tempContainer instanceof Model ? tempContainer : THROW_CCE());
  };
  function Companion_60() {
    this.x49_1 = 'root';
  }
  var Companion_instance_60;
  function Companion_getInstance_60() {
    return Companion_instance_60;
  }
  function SetModelOperation(op) {
    TargetedOperation.call(this, 'root', op);
  }
  protoOf(SetModelOperation).b3 = function () {
    return 'setModel';
  };
  protoOf(SetModelOperation).r44 = function (op) {
    return new SetModelOperation(op);
  };
  protoOf(SetModelOperation).y3p = function (op) {
    return this.r44(op);
  };
  protoOf(SetModelOperation).b4a = function (source) {
    return source.g30_1;
  };
  protoOf(SetModelOperation).c3q = function (source) {
    return this.b4a(source instanceof Model ? source : THROW_CCE());
  };
  function findListOperation($this, op) {
    var tmp0_safe_receiver = SplitMergeOperationsUtil_instance.o4a(op, $this.l4a_1, new Int32Array([$this.n4a()]));
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p4a_1;
  }
  function AddChildSplitChildCollectionOperation(conceptId, sourceId, addedId, addIndex, childId, splitIndex, splitSize) {
    BaseAddChildSplitOperation.call(this, conceptId, sourceId, addedId, addIndex, splitIndex);
    this.l4a_1 = childId;
    this.m4a_1 = splitSize;
  }
  protoOf(AddChildSplitChildCollectionOperation).r4a = function () {
    return this.l4a_1;
  };
  protoOf(AddChildSplitChildCollectionOperation).o43 = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.s4a(otherOp, new Int32Array([this.n4a()]));
    if (!(compositeOp == null))
      return this.b3k(compositeOp, server);
    var listOp = findListOperation(this, otherOp);
    if (!(listOp == null)) {
      if (listOp instanceof ChangeChildOperation_0) {
        var changeOp = listOp instanceof ChangeChildOperation_0 ? listOp : THROW_CCE();
        if (ensureNotNull(changeOp).h3b() >= this.q3n_1) {
          var newOp = changeOp.o44(changeOp.h3b() - this.q3n_1 | 0);
          return new ChangeChildOperation_0(this.o3n_1, this.p3n_1, new ChildListOperation(this.l4a_1, newOp));
        }
      }
      if (listOp instanceof BaseAddChildSplitOperation) {
        var splitOp = listOp instanceof BaseAddChildSplitOperation ? listOp : THROW_CCE();
        if (ensureNotNull(splitOp).i3b() === this.q3n_1) {
          return otherOp;
        }
      }
      if (listOp instanceof BaseMergeRemoveChildOperation) {
        var mergeOp = listOp instanceof BaseMergeRemoveChildOperation ? listOp : THROW_CCE();
        if (ensureNotNull(mergeOp).i3b() === this.q3n_1) {
          return CompositeOperation_init_$Create$([this.s3l(), otherOp]);
        }
      }
      if (!(listOp == null) ? isInterface(listOp, IndexedOperation) : false) {
        var indexOp = isInterface(listOp, IndexedOperation) ? listOp : THROW_CCE();
        if (ensureNotNull(indexOp).i3b() >= this.q3n_1) {
          var newOp_0 = indexOp.q3z(indexOp.i3b() - this.q3n_1 | 0);
          return new ChangeChildOperation_0(this.o3n_1, this.p3n_1, new ChildListOperation(this.l4a_1, newOp_0));
        }
      }
    }
    return protoOf(BaseAddChildSplitOperation).o43.call(this, otherOp, server);
  };
  protoOf(AddChildSplitChildCollectionOperation).g3p = function (otherOp, server) {
    return this.o43(otherOp, server);
  };
  protoOf(AddChildSplitChildCollectionOperation).q44 = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.s4a(otherOp, new Int32Array([this.n4a()]));
    if (!(compositeOp == null))
      return compositeOp.b3k(this, !server);
    var listOp = findListOperation(this, otherOp);
    if (!(listOp == null)) {
      if (listOp instanceof BaseAddChildSplitOperation) {
        var splitOp = listOp instanceof BaseAddChildSplitOperation ? listOp : THROW_CCE();
        if (ensureNotNull(splitOp).p3n_1 === this.q3n_1) {
          return this.t4a(this.q3n_1 + splitOp.r3z() | 0);
        }
      }
      if (listOp instanceof BaseMergeRemoveChildOperation) {
        var mergeOp = listOp instanceof BaseMergeRemoveChildOperation ? listOp : THROW_CCE();
        if (ensureNotNull(mergeOp).i3b() === this.q3n_1) {
          return new NopOperation();
        }
      }
      if (!(listOp == null) ? isInterface(listOp, IndexedOperation) : false) {
        var indexOp = isInterface(listOp, IndexedOperation) ? listOp : THROW_CCE();
        var tmp;
        if (ensureNotNull(indexOp).i3b() < this.q3n_1) {
          tmp = this.t4a(this.q3n_1 + indexOp.r3z() | 0);
        } else {
          tmp = this.u4a(this.m4a_1 + indexOp.r3z() | 0);
        }
        return tmp;
      }
    }
    return protoOf(BaseAddChildSplitOperation).q44.call(this, otherOp, server);
  };
  protoOf(AddChildSplitChildCollectionOperation).r3p = function (otherOp, server) {
    return this.q44(otherOp, server);
  };
  protoOf(AddChildSplitChildCollectionOperation).e44 = function (model, nodeFactory) {
    var source = model.q(this.p3n_1 - 1 | 0);
    this.v4a(source);
    // Inline function 'kotlin.check' call
    if (!(source.l38(this.l4a_1).n() === (this.q3n_1 + this.m4a_1 | 0))) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.AddChildSplitChildCollectionOperation.execute.<anonymous>' call
      var message = 'Source children size=' + source.l38(this.l4a_1).n() + ', split index=' + this.q3n_1 + ', split size=' + this.m4a_1;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var parent = source.z39();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (parent == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.AddChildSplitChildCollectionOperation.execute.<anonymous>' call
        var message_0 = 'Null parent';
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        break $l$block;
      }
    }
    var newNode = nodeFactory.z37(this.m3n_1, this.o3n_1);
    parent.t3b(newNode, ensureNotNull(source.h3b()), this.p3n_1, this.l4a_1, this.q3n_1);
    return model;
  };
  protoOf(AddChildSplitChildCollectionOperation).a3k = function (model, nodeFactory) {
    return this.e44((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddChildSplitChildCollectionOperation).s3l = function () {
    return new MergeChildCollectionRemoveChildOperation(this.m3n_1, this.o3n_1, this.n3n_1, this.p3n_1, this.l4a_1, this.m4a_1, this.q3n_1);
  };
  protoOf(AddChildSplitChildCollectionOperation).q3z = function (newIndex) {
    return new AddChildSplitChildCollectionOperation(this.m3n_1, this.n3n_1, this.o3n_1, newIndex, this.l4a_1, this.q3n_1, this.m4a_1);
  };
  protoOf(AddChildSplitChildCollectionOperation).t4a = function (newSplitIndex) {
    return new AddChildSplitChildCollectionOperation(this.m3n_1, this.n3n_1, this.o3n_1, this.p3n_1, this.l4a_1, newSplitIndex, this.m4a_1);
  };
  protoOf(AddChildSplitChildCollectionOperation).u4a = function (newSplitSize) {
    return new AddChildSplitChildCollectionOperation(this.m3n_1, this.n3n_1, this.o3n_1, this.p3n_1, this.l4a_1, this.q3n_1, newSplitSize);
  };
  protoOf(AddChildSplitChildCollectionOperation).w4a = function (newSourceNodeId) {
    return new AddChildSplitChildCollectionOperation(this.m3n_1, newSourceNodeId, this.o3n_1, this.p3n_1, this.l4a_1, this.q3n_1, this.m4a_1);
  };
  protoOf(AddChildSplitChildCollectionOperation).x4a = function (newMoveSize) {
    return this.u4a(newMoveSize);
  };
  protoOf(AddChildSplitChildCollectionOperation).toString = function () {
    return 'AddChildSplitChildren[' + this.y4a() + '; role = ' + this.l4a_1.toString() + '; size = ' + this.m4a_1 + ']';
  };
  function constructorIndex($this, splitIndex) {
    return splitIndex === -1 ? 0 : splitIndex;
  }
  function splitThroughThis($this, splitOp, server) {
    if (splitOp.i3b() === $this.i3b()) {
      var otherSplitToNull = splitOp.z4a();
      if ($this.z4a()) {
        var tmp;
        if (otherSplitToNull) {
          var tmp_0;
          if (server) {
            tmp_0 = splitOp.q3z(splitOp.i3b() + 1 | 0).w4a($this.o3n_1);
          } else {
            tmp_0 = AddChildOperation_init_$Create$_1($this.m3n_1, splitOp.o3n_1, $this.p3n_1, false);
          }
          tmp = tmp_0;
        } else {
          tmp = splitOp.w4a($this.o3n_1).q3z($this.p3n_1 + 1 | 0);
        }
        return tmp;
      }
      if (otherSplitToNull) {
        return splitOp.a4b(take_1(splitOp.f3o_1, $this.q3n_1));
      }
    }
    return null;
  }
  function setValueThroughThis($this, setOp) {
    // Inline function 'kotlin.check' call
    if (!(setOp.g42_1 == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.AddChildSplitPropertyOperation.setValueThroughThis.<anonymous>' call
      var message = 'Transform ' + setOp.toString() + ' through ' + $this.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if ($this.z4a()) {
      tmp = new NopOperation();
    } else {
      var opOldValue = ensureNotNull(setOp.f42_1);
      var oldValue = dropLast_0(opOldValue, $this.f3o_1.length);
      var setValueOperation = new SetValueOperation(oldValue, null);
      var changePropertyOperation = new ChangePropertyOperation($this.d3o_1, setValueOperation);
      tmp = new ChangeChildOperation_0($this.n3n_1, $this.p3n_1 - 1 | 0, changePropertyOperation);
    }
    return tmp;
  }
  function insertThroughThis($this, insertOp) {
    if ($this.z4a()) {
      // Inline function 'kotlin.check' call
      if (!!insertOp.b4b()) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.AddChildSplitPropertyOperation.insertThroughThis.<anonymous>' call
        var message = 'Insert into null while splitting this node';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      var changePropertyOperation = new ChangePropertyOperation($this.d3o_1, insertOp);
      return new ChangeChildOperation_0($this.o3n_1, $this.p3n_1, changePropertyOperation);
    }
    // Inline function 'kotlin.check' call
    if (!!insertOp.b4b()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.AddChildSplitPropertyOperation.insertThroughThis.<anonymous>' call
      var message_0 = 'Insert into null while splitting this node';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    return null;
  }
  function deleteThroughThis($this, deleteOp) {
    if ($this.z4a()) {
      var changePropertyOperation = new ChangePropertyOperation($this.d3o_1, deleteOp);
      return new ChangeChildOperation_0($this.o3n_1, $this.p3n_1, changePropertyOperation);
    }
    if (deleteOp.b4b()) {
      var deleteOpText = deleteOp.t48_1;
      var d1 = new DeleteTextOperation(-1, take_1(deleteOpText, $this.q3n_1));
      // Inline function 'kotlin.text.substring' call
      var startIndex = $this.q3n_1;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = deleteOpText.substring(startIndex);
      var d2 = new DeleteTextOperation(-1, tmp$ret$1);
      var op1 = new ChangeChildOperation_0($this.n3n_1, $this.p3n_1 - 1 | 0, new ChangePropertyOperation($this.d3o_1, d1));
      var op2 = new ChangeChildOperation_0($this.o3n_1, $this.p3n_1, new ChangePropertyOperation($this.d3o_1, d2));
      return CompositeOperation_init_$Create$([op1, op2]);
    }
    var deleteIndex = deleteOp.i3b();
    if (deleteIndex < $this.q3n_1 && (deleteIndex + deleteOp.a() | 0) > $this.q3n_1) {
      var deleteOpText_0 = deleteOp.t48_1;
      var delete1 = new DeleteTextOperation(deleteIndex, take_1(deleteOpText_0, $this.q3n_1 - deleteIndex | 0));
      // Inline function 'kotlin.text.substring' call
      var startIndex_0 = $this.q3n_1 - deleteIndex | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = deleteOpText_0.substring(startIndex_0);
      var delete2 = new DeleteTextOperation(0, tmp$ret$3);
      var op1_0 = new ChangeChildOperation_0($this.n3n_1, $this.p3n_1 - 1 | 0, new ChangePropertyOperation($this.d3o_1, delete1));
      var op2_0 = new ChangeChildOperation_0($this.o3n_1, $this.p3n_1, new ChangePropertyOperation($this.d3o_1, delete2));
      return CompositeOperation_init_$Create$([op1_0, op2_0]);
    }
    return null;
  }
  function thisThroughDelete($this, deleteOp) {
    var tmp;
    if (deleteOp.b4b()) {
      tmp = AddChildOperation_init_$Create$_1($this.m3n_1, $this.o3n_1, $this.p3n_1, false);
    } else if ($this.z4a()) {
      var deleteIndex = deleteOp.i3b();
      var tmp_0 = take_1($this.f3o_1, deleteIndex);
      var tmp0 = $this.f3o_1;
      // Inline function 'kotlin.text.substring' call
      var startIndex = deleteIndex + deleteOp.a() | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = tmp0.substring(startIndex);
      tmp = $this.a4b(tmp_0 + tmp$ret$1);
    } else if (deleteOp.i3b() >= $this.q3n_1) {
      var index = deleteOp.i3b() - $this.q3n_1 | 0;
      var tmp_1 = take_1($this.f3o_1, index);
      var tmp2 = $this.f3o_1;
      // Inline function 'kotlin.text.substring' call
      var startIndex_0 = index + deleteOp.a() | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = tmp2.substring(startIndex_0);
      tmp = $this.a4b(tmp_1 + tmp$ret$3);
    } else {
      var tmp_2;
      if ((deleteOp.i3b() + deleteOp.a() | 0) > $this.q3n_1) {
        var tmp_3 = $this.t4a(deleteOp.i3b());
        var tmp4 = $this.f3o_1;
        // Inline function 'kotlin.text.substring' call
        var startIndex_1 = (deleteOp.i3b() + deleteOp.a() | 0) - $this.q3n_1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = tmp4.substring(startIndex_1);
        tmp_2 = tmp_3.a4b(tmp$ret$5);
      } else {
        tmp_2 = $this.t4a($this.q3n_1 - deleteOp.a() | 0);
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function thisThroughInsert($this, insertOp) {
    // Inline function 'kotlin.check' call
    if (!!insertOp.b4b()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.AddChildSplitPropertyOperation.thisThroughInsert.<anonymous>' call
      var message = 'Insert into null while splitting this node';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if ($this.z4a()) {
      var index = insertOp.i3b();
      tmp = changeInsertOpMovedText($this, insertOp, index);
    } else if (insertOp.i3b() >= $this.q3n_1) {
      var index_0 = insertOp.i3b() - $this.q3n_1 | 0;
      tmp = changeInsertOpMovedText($this, insertOp, index_0);
    } else {
      tmp = $this.t4a($this.q3n_1 + insertOp.a() | 0);
    }
    return tmp;
  }
  function changeInsertOpMovedText($this, insertOp, index) {
    var tmp = take_1($this.f3o_1, index) + insertOp.t48_1;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = $this.f3o_1.substring(index);
    return $this.a4b(tmp + tmp$ret$1);
  }
  function thisThroughSetValue($this, setOp) {
    if (setOp.g42_1 == null) {
      var addOp = AddChildOperation_init_$Create$_1($this.m3n_1, $this.o3n_1, $this.p3n_1, false);
      var setValueOperation = new SetValueOperation(null, $this.f3o_1);
      var changePropertyOperation = new ChangePropertyOperation($this.d3o_1, setValueOperation);
      var childOp = new ChangeChildOperation_0($this.o3n_1, $this.p3n_1, changePropertyOperation);
      return CompositeOperation_init_$Create$([addOp, childOp]);
    }
    throw RuntimeException_init_$Create$_0('Transform ' + $this.toString() + ' through ' + setOp.toString());
  }
  function findStringOperation($this, op) {
    var tmp0_safe_receiver = SplitMergeOperationsUtil_instance.c4b(op, $this.d3o_1, new Int32Array([$this.n4a()]));
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p4a_1;
  }
  function Companion_61() {
  }
  var Companion_instance_61;
  function Companion_getInstance_61() {
    return Companion_instance_61;
  }
  function AddChildSplitPropertyOperation(conceptId, sourceId, addedId, addIndex, propertyId, _splitIndex, movedText) {
    BaseAddChildSplitOperation.call(this, conceptId, sourceId, addedId, addIndex, constructorIndex(Companion_instance_61, _splitIndex));
    this.d3o_1 = propertyId;
    this.e3o_1 = _splitIndex;
    this.f3o_1 = movedText;
  }
  protoOf(AddChildSplitPropertyOperation).z4a = function () {
    return this.e3o_1 === -1;
  };
  protoOf(AddChildSplitPropertyOperation).r4a = function () {
    return this.d3o_1;
  };
  protoOf(AddChildSplitPropertyOperation).o43 = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.d4b(otherOp, new Int32Array([this.n4a()]));
    if (!(compositeOp == null))
      return this.b3k(compositeOp, server);
    var stringOp = findStringOperation(this, otherOp);
    if (!(stringOp == null)) {
      if (stringOp instanceof SetValueOperation) {
        return setValueThroughThis(this, stringOp instanceof SetValueOperation ? stringOp : THROW_CCE());
      }
      if (stringOp instanceof InsertTextOperation) {
        var result = insertThroughThis(this, stringOp);
        if (!(result == null)) {
          return result;
        }
      }
      if (stringOp instanceof DeleteTextOperation) {
        var result_0 = deleteThroughThis(this, stringOp);
        if (!(result_0 == null)) {
          return result_0;
        }
      }
      if (stringOp instanceof TextOperation) {
        var tmp;
        if (stringOp.i3b() >= this.q3n_1) {
          var newOp = stringOp.q3z(stringOp.i3b() - this.q3n_1 | 0);
          var changePropertyOperation = new ChangePropertyOperation(this.d3o_1, newOp);
          tmp = new ChangeChildOperation_0(this.o3n_1, this.p3n_1, changePropertyOperation);
        } else {
          tmp = otherOp;
        }
        return tmp;
      }
    }
    if (otherOp instanceof AddChildSplitPropertyOperation) {
      var result_1 = splitThroughThis(this, otherOp, server);
      if (!(result_1 == null)) {
        return result_1;
      }
    }
    return protoOf(BaseAddChildSplitOperation).o43.call(this, otherOp, server);
  };
  protoOf(AddChildSplitPropertyOperation).g3p = function (otherOp, server) {
    return this.o43(otherOp, server);
  };
  protoOf(AddChildSplitPropertyOperation).q44 = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.d4b(otherOp, new Int32Array([this.n4a()]));
    if (!(compositeOp == null))
      return compositeOp.b3k(this, !server);
    var stringOp = findStringOperation(this, otherOp);
    if (!(stringOp == null)) {
      if (stringOp instanceof SetValueOperation) {
        var setValueOperation = stringOp instanceof SetValueOperation ? stringOp : THROW_CCE();
        return thisThroughSetValue(this, ensureNotNull(setValueOperation));
      }
      if (stringOp instanceof InsertTextOperation) {
        return thisThroughInsert(this, stringOp);
      }
      if (stringOp instanceof DeleteTextOperation) {
        return thisThroughDelete(this, stringOp);
      }
    }
    return protoOf(BaseAddChildSplitOperation).q44.call(this, otherOp, server);
  };
  protoOf(AddChildSplitPropertyOperation).r3p = function (otherOp, server) {
    return this.q44(otherOp, server);
  };
  protoOf(AddChildSplitPropertyOperation).q3z = function (newIndex) {
    return new AddChildSplitPropertyOperation(this.m3n_1, this.n3n_1, this.o3n_1, newIndex, this.d3o_1, this.e3o_1, this.f3o_1);
  };
  protoOf(AddChildSplitPropertyOperation).w4a = function (newSourceNodeId) {
    return new AddChildSplitPropertyOperation(this.m3n_1, newSourceNodeId, this.o3n_1, this.p3n_1, this.d3o_1, this.e3o_1, this.f3o_1);
  };
  protoOf(AddChildSplitPropertyOperation).t4a = function (newSplitIndex) {
    return new AddChildSplitPropertyOperation(this.m3n_1, this.n3n_1, this.o3n_1, this.p3n_1, this.d3o_1, newSplitIndex, this.f3o_1);
  };
  protoOf(AddChildSplitPropertyOperation).a4b = function (newMovedText) {
    return new AddChildSplitPropertyOperation(this.m3n_1, this.n3n_1, this.o3n_1, this.p3n_1, this.d3o_1, this.e3o_1, newMovedText);
  };
  protoOf(AddChildSplitPropertyOperation).x4a = function (newMoveSize) {
    return this.a4b(take_1(this.f3o_1, newMoveSize));
  };
  protoOf(AddChildSplitPropertyOperation).e44 = function (model, nodeFactory) {
    var source = model.q(this.p3n_1 - 1 | 0);
    this.v4a(source);
    var property = source.z38(this.d3o_1).qr();
    if (property == null) {
      // Inline function 'kotlin.check' call
      if (!this.z4a()) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.AddChildSplitPropertyOperation.execute.<anonymous>' call
        var message = 'Use splitIndex=-1 to split null property';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      property = '';
    }
    var movedText = this.f3o_1;
    // Inline function 'kotlin.check' call
    if (!(property.length === (this.q3n_1 + movedText.length | 0))) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.AddChildSplitPropertyOperation.execute.<anonymous>' call
      var message_0 = "Property value='" + property + "', split index=" + this.q3n_1 + ", moved text='" + movedText + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var tmp2 = property;
    // Inline function 'kotlin.text.substring' call
    var startIndex = this.q3n_1;
    // Inline function 'kotlin.js.asDynamic' call
    var textToMove = tmp2.substring(startIndex);
    // Inline function 'kotlin.check' call
    if (!(textToMove === movedText)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.AddChildSplitPropertyOperation.execute.<anonymous>' call
      var message_1 = "Stored text to move='" + movedText + "', actual='" + textToMove + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    var parent = source.z39();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (parent == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.AddChildSplitPropertyOperation.execute.<anonymous>' call
        var message_2 = 'Null parent';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2));
      } else {
        break $l$block;
      }
    }
    var newNode = nodeFactory.z37(this.m3n_1, this.o3n_1);
    parent.s3b(newNode, ensureNotNull(source.h3b()), this.p3n_1, this.d3o_1, this.e3o_1);
    return model;
  };
  protoOf(AddChildSplitPropertyOperation).a3k = function (model, nodeFactory) {
    return this.e44((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddChildSplitPropertyOperation).s3l = function () {
    return new MergePropertyRemoveChildOperation(this.m3n_1, this.o3n_1, this.n3n_1, this.p3n_1, this.d3o_1, this.f3o_1, this.e3o_1);
  };
  protoOf(AddChildSplitPropertyOperation).toString = function () {
    return 'AddChildSplitProperty[' + this.y4a() + '; prop=' + this.d3o_1.toString() + '; text=' + this.f3o_1 + ']';
  };
  function AssertionUtil() {
  }
  protoOf(AssertionUtil).e4b = function (lhs, rhs) {
    // Inline function 'kotlin.check' call
    if (!!NodeUtil_instance.h3i(lhs, rhs)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.AssertionUtil.assertIdsNullOrDifferent.<anonymous>' call
      var message = 'IDs equal: ' + toString_0(lhs);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(AssertionUtil).f4b = function (lhs, rhs) {
    // Inline function 'kotlin.check' call
    if (!NodeUtil_instance.g3i(lhs, rhs)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.AssertionUtil.assertIdsEqual.<anonymous>' call
      var message = 'IDs not equal: ' + toString_0(lhs) + ', ' + toString_0(rhs);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  var AssertionUtil_instance;
  function AssertionUtil_getInstance() {
    return AssertionUtil_instance;
  }
  function getReplacingSourceMessage($this, addChildSplitOp, replaceOp) {
    return 'Detected replacing source item of ' + toString_1(addChildSplitOp) + ' with ' + replaceOp.toString();
  }
  function Companion_62() {
  }
  var Companion_instance_62;
  function Companion_getInstance_62() {
    return Companion_instance_62;
  }
  function BaseAddChildSplitOperation(conceptId, sourceNodeId, addedNodeId, addIndex, splitIndex) {
    BaseOperation.call(this);
    this.m3n_1 = conceptId;
    this.n3n_1 = sourceNodeId;
    this.o3n_1 = addedNodeId;
    this.p3n_1 = addIndex;
    this.q3n_1 = splitIndex;
    this.r3n_1 = Priority_HIGH_getInstance();
    this.s3n_1 = 1;
    this.t3n_1 = 1;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.m3n_1.i3c()) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(BaseAddChildSplitOperation).p3z = function () {
    return this.r3n_1;
  };
  protoOf(BaseAddChildSplitOperation).i3b = function () {
    return this.p3n_1;
  };
  protoOf(BaseAddChildSplitOperation).a = function () {
    return this.s3n_1;
  };
  protoOf(BaseAddChildSplitOperation).r3z = function () {
    return this.t3n_1;
  };
  protoOf(BaseAddChildSplitOperation).n4a = function () {
    return this.p3n_1 - 1 | 0;
  };
  protoOf(BaseAddChildSplitOperation).y4a = function () {
    return 'cid = ' + this.m3n_1.toString() + '; srcId = ' + this.n3n_1.toString() + '; addId = ' + this.o3n_1.toString() + '; addIndex = ' + this.p3n_1 + ('; splitIndex = ' + this.q3n_1);
  };
  protoOf(BaseAddChildSplitOperation).o43 = function (otherOp, server) {
    if (otherOp instanceof BaseAddChildSplitOperation) {
      if (otherOp.o3n_1.equals(this.o3n_1) || otherOp.o3n_1.equals(this.n3n_1) || otherOp.n3n_1.equals(this.o3n_1)) {
        throw RuntimeException_init_$Create$();
      }
      if (otherOp.n3n_1.equals(this.n3n_1)) {
        if (!equals(this.r4a(), otherOp.r4a())) {
          throw RuntimeException_init_$Create$();
        }
        var tmp;
        if (this.q3n_1 < otherOp.q3n_1 || (this.q3n_1 === otherOp.q3n_1 && server)) {
          tmp = otherOp.w4a(this.o3n_1).t4a(otherOp.q3n_1 - this.q3n_1 | 0).q3z(this.p3n_1 + 1 | 0);
        } else {
          tmp = otherOp.x4a(this.q3n_1 - otherOp.q3n_1 | 0);
        }
        return tmp;
      }
      return (new IndexedOperationTransformer()).s3z(this, otherOp, server);
    }
    if (otherOp instanceof ChangeChildOperation_0) {
      if (otherOp.h3b() >= this.p3n_1) {
        return otherOp.o44(otherOp.h3b() + 1 | 0);
      }
    }
    if (otherOp instanceof RemoveChildOperation_0) {
      AssertionUtil_instance.e4b(this.o3n_1, otherOp.x3i());
      if ((this.p3n_1 - 1 | 0) === otherOp.i3b()) {
        AssertionUtil_instance.f4b(this.n3n_1, otherOp.x3i());
        return RemoveChildOperation_init_$Create$_1(this.m3n_1, this.n3n_1, this.p3n_1 - 1 | 0, false);
      }
    }
    if (otherOp instanceof ReplaceChildOperation) {
      // Inline function 'kotlin.check' call
      if (!!((this.p3n_1 - 1 | 0) === otherOp.i3b())) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.BaseAddChildSplitOperation.doTransform.<anonymous>' call
        var message = getReplacingSourceMessage(Companion_instance_62, this, otherOp);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    var tmp_0;
    if (otherOp instanceof BaseListItemOperation) {
      tmp_0 = (new IndexedOperationTransformer()).s3z(this, otherOp, server);
    } else {
      tmp_0 = protoOf(BaseOperation).g3p.call(this, otherOp, server);
    }
    return tmp_0;
  };
  protoOf(BaseAddChildSplitOperation).g3p = function (otherOp, server) {
    return this.o43(otherOp, server);
  };
  protoOf(BaseAddChildSplitOperation).q44 = function (otherOp, server) {
    if (otherOp instanceof RemoveChildOperation_0) {
      AssertionUtil_instance.e4b(this.o3n_1, otherOp.x3i());
      if ((this.p3n_1 - 1 | 0) === otherOp.i3b()) {
        AssertionUtil_instance.f4b(this.n3n_1, otherOp.x3i());
        return AddChildOperation_init_$Create$_1(this.m3n_1, this.o3n_1, this.p3n_1 - 1 | 0, false);
      }
    }
    if (otherOp instanceof ReplaceChildOperation) {
      // Inline function 'kotlin.check' call
      if (!!((this.p3n_1 - 1 | 0) === otherOp.i3b())) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.BaseAddChildSplitOperation.doTransformThrough.<anonymous>' call
        var message = getReplacingSourceMessage(Companion_instance_62, this, otherOp);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    var tmp;
    if (otherOp instanceof BaseListItemOperation) {
      tmp = (new IndexedOperationTransformer()).s3z(otherOp, this, !server);
    } else {
      tmp = protoOf(BaseOperation).r3p.call(this, otherOp, server);
    }
    return tmp;
  };
  protoOf(BaseAddChildSplitOperation).r3p = function (otherOp, server) {
    return this.q44(otherOp, server);
  };
  protoOf(BaseAddChildSplitOperation).v4a = function (source) {
    // Inline function 'kotlin.check' call
    if (!this.m3n_1.equals(source.a38_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.BaseAddChildSplitOperation.verifyIds.<anonymous>' call
      var message = MessageBundle_instance.a39(this.m3n_1, source.a38_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!this.n3n_1.equals(source.v39())) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.BaseAddChildSplitOperation.verifyIds.<anonymous>' call
      var message_0 = MessageBundle_instance.d39(this.n3n_1, source.v39());
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  };
  function notNull_0($this, id) {
    var tmp;
    if (id == null) {
      throw IllegalArgumentException_init_$Create$_0('nodeId cannot be null');
    } else {
      tmp = id;
    }
    return tmp;
  }
  function getReplacingRemovedMessage($this, mergeRmChildOp, replaceOp) {
    return 'Detected replacing removed item of ' + toString_1(mergeRmChildOp) + ' with ' + replaceOp.toString();
  }
  function getReplacingTargetMessage($this, mergeRmChildOp, replaceOp) {
    return 'Detected replacing target item of ' + toString_1(mergeRmChildOp) + ' with ' + replaceOp.toString();
  }
  function Companion_63() {
  }
  var Companion_instance_63;
  function Companion_getInstance_63() {
    return Companion_instance_63;
  }
  function BaseMergeRemoveChildOperation(conceptId, removedNodeId, targetNodeId, removeIndex, targetLength) {
    BaseOperation.call(this);
    this.t3m_1 = conceptId;
    this.u3m_1 = removedNodeId;
    this.v3m_1 = targetNodeId;
    this.w3m_1 = removeIndex;
    this.x3m_1 = targetLength;
    this.y3m_1 = 1;
    this.z3m_1 = -1;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.t3m_1.i3c()) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(BaseMergeRemoveChildOperation).i3b = function () {
    return this.w3m_1;
  };
  protoOf(BaseMergeRemoveChildOperation).a = function () {
    return this.y3m_1;
  };
  protoOf(BaseMergeRemoveChildOperation).r3z = function () {
    return this.z3m_1;
  };
  protoOf(BaseMergeRemoveChildOperation).y4a = function () {
    return 'cid = ' + this.t3m_1.toString() + '; rmId = ' + this.u3m_1.toString() + '; trgId = ' + this.v3m_1.toString() + '; rmIndex = ' + this.w3m_1 + ('; trgLen = ' + this.x3m_1);
  };
  protoOf(BaseMergeRemoveChildOperation).o43 = function (otherOp, server) {
    if (otherOp instanceof ChangeChildOperation_0) {
      if (otherOp.h3b() === this.w3m_1) {
        return new NopOperation();
      }
      if (otherOp.h3b() > this.w3m_1) {
        return otherOp.o44(otherOp.h3b() - 1 | 0);
      }
    }
    if (otherOp instanceof RemoveChildOperation_0) {
      var tmp;
      if (this.w3m_1 === otherOp.i3b()) {
        AssertionUtil_instance.f4b(this.u3m_1, otherOp.x3i());
        tmp = new NopOperation();
      } else if ((this.w3m_1 - 1 | 0) === otherOp.i3b()) {
        AssertionUtil_instance.f4b(this.v3m_1, otherOp.x3i());
        tmp = CompositeOperation_init_$Create$([this.s3l(), otherOp]);
      } else {
        tmp = (new IndexedOperationTransformer()).s3z(this, otherOp, server);
      }
      return tmp;
    }
    if (otherOp instanceof ReplaceChildOperation) {
      var tmp_0;
      if (this.w3m_1 === otherOp.i3b()) {
        throw IllegalStateException_init_$Create$_0(getReplacingRemovedMessage(Companion_instance_63, this, otherOp));
      } else if ((this.w3m_1 - 1 | 0) === otherOp.i3b()) {
        throw IllegalStateException_init_$Create$_0(getReplacingTargetMessage(Companion_instance_63, this, otherOp));
      } else {
        tmp_0 = (new IndexedOperationTransformer()).s3z(this, otherOp, server);
      }
      return tmp_0;
    }
    if (otherOp instanceof AddChildOperation_0) {
      var tmp_1;
      if (otherOp.i3b() === this.w3m_1) {
        var tmp_2;
        if (otherOp.h3f().equals(this.t3m_1)) {
          tmp_2 = this.h4b(notNull_0(Companion_instance_63, otherOp.x3i()));
        } else {
          tmp_2 = new NopOperation();
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = (new IndexedOperationTransformer()).s3z(this, otherOp, server);
      }
      return tmp_1;
    }
    if (otherOp instanceof BaseMergeRemoveChildOperation) {
      // Inline function 'kotlin.check' call
      if (!equals(this.r4a(), otherOp.r4a())) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      if (otherOp.u3m_1.equals(this.u3m_1)) {
        if (!otherOp.v3m_1.equals(this.v3m_1)) {
          throw RuntimeException_init_$Create$();
        }
        return new NopOperation();
      }
      if (otherOp.v3m_1.equals(this.v3m_1)) {
        throw RuntimeException_init_$Create$();
      }
      if (otherOp.v3m_1.equals(this.u3m_1)) {
        return otherOp.i4b(this.v3m_1).j4b(this.x3m_1 + otherOp.x3m_1 | 0).q3z(this.w3m_1);
      }
      var tmp_3;
      if (otherOp.u3m_1.equals(this.v3m_1)) {
        tmp_3 = otherOp.k4b(this);
      } else {
        tmp_3 = (new IndexedOperationTransformer()).s3z(this, otherOp, server);
      }
      return tmp_3;
    }
    return protoOf(BaseOperation).g3p.call(this, otherOp, server);
  };
  protoOf(BaseMergeRemoveChildOperation).g3p = function (otherOp, server) {
    return this.o43(otherOp, server);
  };
  protoOf(BaseMergeRemoveChildOperation).q44 = function (otherOp, server) {
    if (otherOp instanceof ChangeChildOperation_0) {
      if (otherOp.h3b() === this.w3m_1) {
        return CompositeOperation_init_$Create$([otherOp.s3l(), this]);
      }
    }
    if (otherOp instanceof RemoveChildOperation_0) {
      var tmp;
      if (this.w3m_1 === otherOp.i3b()) {
        AssertionUtil_instance.f4b(this.u3m_1, otherOp.x3i());
        tmp = new NopOperation();
      } else if ((this.w3m_1 - 1 | 0) === otherOp.i3b()) {
        AssertionUtil_instance.f4b(this.v3m_1, otherOp.x3i());
        tmp = new NopOperation();
      } else {
        tmp = (new IndexedOperationTransformer()).s3z(otherOp, this, !server);
      }
      return tmp;
    }
    if (otherOp instanceof ReplaceChildOperation) {
      var tmp_0;
      if (this.w3m_1 === otherOp.i3b()) {
        throw IllegalStateException_init_$Create$_0(getReplacingRemovedMessage(Companion_instance_63, this, otherOp));
      } else if ((this.w3m_1 - 1 | 0) === otherOp.i3b()) {
        throw IllegalStateException_init_$Create$_0(getReplacingTargetMessage(Companion_instance_63, this, otherOp));
      } else {
        tmp_0 = (new IndexedOperationTransformer()).s3z(otherOp, this, !server);
      }
      return tmp_0;
    }
    if (otherOp instanceof AddChildOperation_0) {
      var tmp_1;
      if (otherOp.i3b() === this.w3m_1) {
        var tmp_2;
        if (otherOp.h3f().equals(this.t3m_1)) {
          tmp_2 = this.i4b(notNull_0(Companion_instance_63, otherOp.x3i())).j4b(this.g4b()).q3z(this.w3m_1 + 1 | 0);
        } else {
          tmp_2 = CompositeOperation_init_$Create$([otherOp.s3l(), this]);
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = (new IndexedOperationTransformer()).s3z(otherOp, this, !server);
      }
      return tmp_1;
    }
    return protoOf(BaseOperation).r3p.call(this, otherOp, server);
  };
  protoOf(BaseMergeRemoveChildOperation).r3p = function (otherOp, server) {
    return this.q44(otherOp, server);
  };
  protoOf(BaseMergeRemoveChildOperation).c45 = function (replaceRemovedItem) {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(BaseMergeRemoveChildOperation).u3z = function (replaceRemovedItem) {
    return this.c45(replaceRemovedItem);
  };
  protoOf(BaseMergeRemoveChildOperation).b45 = function (op) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(BaseMergeRemoveChildOperation).t3z = function (op) {
    return this.b45(op);
  };
  protoOf(BaseMergeRemoveChildOperation).l4b = function (toRemove, target) {
    // Inline function 'kotlin.check' call
    if (!toRemove.v39().equals(this.u3m_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.BaseMergeRemoveChildOperation.verifyIds.<anonymous>' call
      var message = 'To remove node: ' + MessageBundle_instance.d39(this.u3m_1, toRemove.v39());
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!target.v39().equals(this.v3m_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.BaseMergeRemoveChildOperation.verifyIds.<anonymous>' call
      var message_0 = 'Target node: ' + MessageBundle_instance.d39(this.v3m_1, target.v39());
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!this.t3m_1.equals(toRemove.a38_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.BaseMergeRemoveChildOperation.verifyIds.<anonymous>' call
      var message_1 = 'To remove node: ' + MessageBundle_instance.a39(this.t3m_1, toRemove.a38_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.check' call
    if (!this.t3m_1.equals(target.a38_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.BaseMergeRemoveChildOperation.verifyIds.<anonymous>' call
      var message_2 = 'Target node: ' + MessageBundle_instance.a39(this.t3m_1, target.a38_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_2));
    }
  };
  function assertAddChildSplitChildCollectionIsValid($this, splitOp) {
    if (!splitOp.l4a_1.equals($this.u4b_1)) {
      throw RuntimeException_init_$Create$();
    }
    if (splitOp.o3n_1.equals($this.v3m_1) || splitOp.o3n_1.equals($this.u3m_1)) {
      throw RuntimeException_init_$Create$();
    }
  }
  function changeRemovedLength($this, newRemovedLength) {
    return new MergeChildCollectionRemoveChildOperation($this.t3m_1, $this.u3m_1, $this.v3m_1, $this.w3m_1, $this.u4b_1, newRemovedLength, $this.x3m_1);
  }
  function findListOperation_0($this, op) {
    return SplitMergeOperationsUtil_instance.o4a(op, $this.u4b_1, new Int32Array([$this.i3b(), $this.i3b() - 1 | 0]));
  }
  function MergeChildCollectionRemoveChildOperation(conceptId, removedNodeId, targetNodeId, removeIndex, childId, removedLength, targetLength) {
    BaseMergeRemoveChildOperation.call(this, conceptId, removedNodeId, targetNodeId, removeIndex, targetLength);
    this.u4b_1 = childId;
    this.v4b_1 = removedLength;
  }
  protoOf(MergeChildCollectionRemoveChildOperation).g4b = function () {
    return 0;
  };
  protoOf(MergeChildCollectionRemoveChildOperation).r4a = function () {
    return this.u4b_1;
  };
  protoOf(MergeChildCollectionRemoveChildOperation).o43 = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.s4a(otherOp, new Int32Array([this.i3b(), this.i3b() - 1 | 0]));
    if (!(compositeOp == null))
      return this.b3k(compositeOp, server);
    var listOp = findListOperation_0(this, otherOp);
    if (!(listOp == null)) {
      var newOp = null;
      var tmp;
      var tmp_0 = listOp.p4a_1;
      if (tmp_0 instanceof ChangeChildOperation_0) {
        tmp = listOp.q4a_1 === this.i3b();
      } else {
        tmp = false;
      }
      if (tmp) {
        var changeOp = listOp.p4a_1;
        newOp = changeOp.o44(changeOp.h3b() + this.x3m_1 | 0);
      }
      var tmp_1;
      var tmp_2 = listOp.p4a_1;
      if (isInterface(tmp_2, IndexedOperation)) {
        tmp_1 = listOp.q4a_1 === this.i3b();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        var tmp_3 = listOp.p4a_1;
        var indexOp = isInterface(tmp_3, IndexedOperation) ? tmp_3 : THROW_CCE();
        newOp = indexOp.q3z(indexOp.i3b() + this.x3m_1 | 0);
      }
      if (!(newOp == null)) {
        return new ChangeChildOperation_0(this.v3m_1, this.w3m_1 - 1 | 0, new ChildListOperation(this.u4b_1, newOp));
      }
    }
    if (otherOp instanceof AddChildSplitChildCollectionOperation) {
      assertAddChildSplitChildCollectionIsValid(this, otherOp);
      if (otherOp.n3n_1.equals(this.u3m_1)) {
        return otherOp.w4a(this.v3m_1).q3z(this.w3m_1).t4a(this.x3m_1 + otherOp.q3n_1 | 0);
      }
      var tmp_4;
      if (otherOp.n3n_1.equals(this.v3m_1)) {
        tmp_4 = otherOp.u4a(otherOp.m4a_1 + this.v4b_1 | 0);
      } else {
        tmp_4 = (new IndexedOperationTransformer()).s3z(this, otherOp, server);
      }
      return tmp_4;
    }
    return protoOf(BaseMergeRemoveChildOperation).o43.call(this, otherOp, server);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).g3p = function (otherOp, server) {
    return this.o43(otherOp, server);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).q44 = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.s4a(otherOp, new Int32Array([this.i3b(), this.i3b() - 1 | 0]));
    if (!(compositeOp == null))
      return compositeOp.b3k(this, !server);
    var listOp = findListOperation_0(this, otherOp);
    if (!(listOp == null)) {
      var tmp = listOp.p4a_1;
      if (tmp instanceof ChangeChildOperation_0) {
        return this;
      }
      var tmp_0 = listOp.p4a_1;
      if (isInterface(tmp_0, IndexedOperation)) {
        var tmp_1;
        if (listOp.q4a_1 === this.i3b()) {
          var tmp_2 = listOp.p4a_1;
          tmp_1 = changeRemovedLength(this, this.v4b_1 + (isInterface(tmp_2, IndexedOperation) ? tmp_2 : THROW_CCE()).r3z() | 0);
        } else {
          var tmp_3 = listOp.p4a_1;
          tmp_1 = this.j4b(this.x3m_1 + (isInterface(tmp_3, IndexedOperation) ? tmp_3 : THROW_CCE()).r3z() | 0);
        }
        return tmp_1;
      }
    }
    if (otherOp instanceof AddChildSplitChildCollectionOperation) {
      assertAddChildSplitChildCollectionIsValid(this, otherOp);
      if (otherOp.n3n_1.equals(this.u3m_1)) {
        return changeRemovedLength(this, otherOp.q3n_1);
      }
      var tmp_4;
      if (otherOp.n3n_1.equals(this.v3m_1)) {
        tmp_4 = this.i4b(otherOp.o3n_1).j4b(otherOp.m4a_1).q3z(this.w3m_1 + 1 | 0);
      } else {
        tmp_4 = (new IndexedOperationTransformer()).s3z(otherOp, this, !server);
      }
      return tmp_4;
    }
    return protoOf(BaseMergeRemoveChildOperation).q44.call(this, otherOp, server);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).r3p = function (otherOp, server) {
    return this.q44(otherOp, server);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).e44 = function (model, nodeFactory) {
    var toRemove = model.q(this.w3m_1);
    var target = model.q(this.w3m_1 - 1 | 0);
    this.l4b(toRemove, target);
    var removedChildren = toRemove.l38(this.u4b_1);
    // Inline function 'kotlin.check' call
    if (!(removedChildren.n() === this.v4b_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergeChildCollectionRemoveChildOperation.execute.<anonymous>' call
      var message = "To remove node's children length: stored=" + this.v4b_1 + ', actual=' + removedChildren.n();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var targetChildren = target.l38(this.u4b_1);
    // Inline function 'kotlin.check' call
    if (!(targetChildren.n() === this.x3m_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergeChildCollectionRemoveChildOperation.execute.<anonymous>' call
      var message_0 = "Target node's children length: stored=" + this.x3m_1 + ', actual=' + targetChildren.n();
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var parent = toRemove.z39();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (parent == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergeChildCollectionRemoveChildOperation.execute.<anonymous>' call
        var message_1 = 'Null parent';
        throw IllegalStateException_init_$Create$_0(toString_1(message_1));
      } else {
        break $l$block;
      }
    }
    parent.v3b(toRemove, this.u4b_1);
    return model;
  };
  protoOf(MergeChildCollectionRemoveChildOperation).a3k = function (model, nodeFactory) {
    return this.e44((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).s3l = function () {
    return new AddChildSplitChildCollectionOperation(this.t3m_1, this.v3m_1, this.u3m_1, this.w3m_1, this.u4b_1, this.x3m_1, this.v4b_1);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).h4b = function (addedNodeId) {
    return new AddChildSplitChildCollectionOperation(this.t3m_1, this.v3m_1, addedNodeId, this.w3m_1, this.u4b_1, this.x3m_1, this.v4b_1);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).q3z = function (newIndex) {
    return new MergeChildCollectionRemoveChildOperation(this.t3m_1, this.u3m_1, this.v3m_1, newIndex, this.u4b_1, this.v4b_1, this.x3m_1);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).i4b = function (newTargetNodeId) {
    return new MergeChildCollectionRemoveChildOperation(this.t3m_1, this.u3m_1, newTargetNodeId, this.w3m_1, this.u4b_1, this.v4b_1, this.x3m_1);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).j4b = function (newTargetLength) {
    return new MergeChildCollectionRemoveChildOperation(this.t3m_1, this.u3m_1, this.v3m_1, this.w3m_1, this.u4b_1, this.v4b_1, newTargetLength);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).k4b = function (mergeOp) {
    var operation = mergeOp instanceof MergeChildCollectionRemoveChildOperation ? mergeOp : THROW_CCE();
    return changeRemovedLength(this, this.v4b_1 + operation.v4b_1 | 0);
  };
  protoOf(MergeChildCollectionRemoveChildOperation).toString = function () {
    return 'MergeChildCollectionRemoveChild[' + this.y4a() + '; role=' + this.u4b_1.toString() + '; rmLen=' + this.v4b_1 + ']';
  };
  function _get_isMergeToNull__zf4w4f($this) {
    return $this.x3m_1 === -1;
  }
  function setValueThroughThis_0($this, setOp) {
    var tmp;
    if (setOp.g42_1 == null) {
      tmp = createChangeSourceProperty($this, new DeleteTextOperation($this.x3m_1, $this.j3n_1));
    } else {
      throw RuntimeException_init_$Create$_0('Transform ' + setOp.toString() + ' through ' + $this.toString());
    }
    return tmp;
  }
  function mergeThroughThis($this, otherOp) {
    var myMergeToNull = _get_isMergeToNull__zf4w4f($this);
    var theirMergeToNull = _get_isMergeToNull__zf4w4f(otherOp);
    if (($this.i3b() + 1 | 0) === otherOp.i3b()) {
      // Inline function 'kotlin.check' call
      if (!!theirMergeToNull) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.mergeThroughThis.<anonymous>' call
        var message = 'Merging empty node is prohibited';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      if (myMergeToNull) {
        return otherOp.q3z(otherOp.w3m_1 - 1 | 0).i4b($this.v3m_1);
      }
    }
    if ($this.i3b() === (otherOp.i3b() + 1 | 0)) {
      // Inline function 'kotlin.check' call
      if (!!myMergeToNull) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.mergeThroughThis.<anonymous>' call
        var message_0 = 'Merging empty node is prohibited';
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      }
      if (theirMergeToNull) {
        return otherOp.k4b($this);
      }
    }
    return null;
  }
  function splitThroughThis_0($this, otherOp, server) {
    if (otherOp.o3n_1.equals($this.v3m_1) || otherOp.o3n_1.equals($this.u3m_1)) {
      throw RuntimeException_init_$Create$();
    }
    if (otherOp.n3n_1.equals($this.u3m_1)) {
      if (_get_isMergeToNull__zf4w4f($this)) {
        return otherOp.w4a($this.v3m_1).q3z(otherOp.i3b() - 1 | 0);
      }
      var tmp;
      if (otherOp.z4a()) {
        tmp = otherOp.w4a($this.v3m_1).q3z(otherOp.i3b() - 1 | 0).t4a($this.x3m_1);
      } else {
        tmp = otherOp.w4a($this.v3m_1).q3z($this.w3m_1).t4a($this.x3m_1 + otherOp.q3n_1 | 0);
      }
      return tmp;
    }
    if (otherOp.n3n_1.equals($this.v3m_1)) {
      // Inline function 'kotlin.check' call
      if (!!_get_isMergeToNull__zf4w4f($this)) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.splitThroughThis.<anonymous>' call
        var message = 'Split node that should have null property according to merge to null op';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      return otherOp.a4b(otherOp.f3o_1 + $this.j3n_1);
    }
    return (new IndexedOperationTransformer()).s3z($this, otherOp, server);
  }
  function insertThroughThis_0($this, insertOp, index) {
    if (_get_isMergeToNull__zf4w4f($this)) {
      if (isOperationOnMergeTarget($this, index)) {
        if (insertOp.b4b()) {
          return createChangeSourceProperty($this, insertOp.q3z(0));
        }
        throw IllegalStateException_init_$Create$_0('Merge into null but insert into not null target');
      }
      if (isOperationOnMergeSource_0($this, index)) {
        // Inline function 'kotlin.check' call
        if (!!insertOp.b4b()) {
          // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.insertThroughThis.<anonymous>' call
          var message = 'Merge node and insert into null source';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        return createChangeSourceProperty($this, insertOp);
      }
    }
    // Inline function 'kotlin.check' call
    if (!!insertOp.b4b()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.insertThroughThis.<anonymous>' call
      var message_0 = 'Impossible merge + insert transform';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    return null;
  }
  function deleteThroughThis_0($this, deleteOp, index) {
    if (_get_isMergeToNull__zf4w4f($this)) {
      // Inline function 'kotlin.check' call
      if (!!isOperationOnMergeTarget($this, index)) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.deleteThroughThis.<anonymous>' call
        var message = 'Merge to null but delete from target';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      if (isOperationOnMergeSource_0($this, index)) {
        return createChangeSourceProperty($this, deleteOp);
      }
    }
    if (deleteOp.b4b()) {
      if (isOperationOnMergeTarget($this, index)) {
        return createChangeSourceProperty($this, deleteOp.q3z(0));
      }
      if (isOperationOnMergeSource_0($this, index)) {
        return createChangeSourceProperty($this, deleteOp.q3z($this.x3m_1));
      }
    }
    return null;
  }
  function createChangeSourceProperty($this, innerOp) {
    var changePropertyOperation = new ChangePropertyOperation($this.i3n_1, innerOp);
    return new ChangeChildOperation_0($this.v3m_1, $this.w3m_1 - 1 | 0, changePropertyOperation);
  }
  function thisThroughSetValue_0($this, setOp) {
    var tmp;
    if (setOp.g42_1 == null) {
      tmp = RemoveChildOperation_init_$Create$_1($this.t3m_1, $this.u3m_1, $this.w3m_1, false);
    } else {
      throw RuntimeException_init_$Create$_0('Transform ' + setOp.toString() + ' through ' + $this.toString());
    }
    return tmp;
  }
  function thisThroughSplit($this, splitOp, server) {
    if (splitOp.o3n_1.equals($this.v3m_1) || splitOp.o3n_1.equals($this.u3m_1)) {
      throw RuntimeException_init_$Create$();
    }
    var mergeToNull = _get_isMergeToNull__zf4w4f($this);
    var splitLeavingNull = splitOp.z4a();
    if (splitOp.n3n_1.equals($this.u3m_1)) {
      if (mergeToNull) {
        var tmp;
        if (splitLeavingNull) {
          tmp = RemoveChildOperation_init_$Create$_1($this.t3m_1, $this.u3m_1, $this.w3m_1, false);
        } else {
          tmp = changeMergedProperty($this, take_1($this.j3n_1, splitOp.q3n_1));
        }
        return tmp;
      }
      var tmp_0;
      if (splitLeavingNull) {
        tmp_0 = RemoveChildOperation_init_$Create$_1($this.t3m_1, $this.u3m_1, $this.w3m_1, false);
      } else {
        tmp_0 = changeMergedProperty($this, take_1($this.j3n_1, splitOp.q3n_1));
      }
      return tmp_0;
    }
    if (splitOp.n3n_1.equals($this.v3m_1)) {
      // Inline function 'kotlin.check' call
      if (!!mergeToNull) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.thisThroughSplit.<anonymous>' call
        var message = 'Split node that should have null property according to merge to null op';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      var tmp_1;
      if (splitLeavingNull) {
        tmp_1 = $this.q3z($this.w3m_1 + 1 | 0).i4b(splitOp.o3n_1);
      } else {
        tmp_1 = $this.i4b(splitOp.o3n_1).j4b(splitOp.f3o_1.length).q3z($this.w3m_1 + 1 | 0);
      }
      return tmp_1;
    }
    return (new IndexedOperationTransformer()).s3z(splitOp, $this, !server);
  }
  function thisThroughInsert_0($this, insertOp, index, nodeFactory) {
    if (_get_isMergeToNull__zf4w4f($this)) {
      if (isOperationOnMergeTarget($this, index)) {
        if (insertOp.b4b()) {
          return $this.j4b(insertOp.a());
        }
        throw IllegalStateException_init_$Create$_0('Merging into null but inserting into non-null target');
      }
      if (isOperationOnMergeSource_0($this, index)) {
        // Inline function 'kotlin.check' call
        if (!!insertOp.b4b()) {
          // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.thisThroughInsert.<anonymous>' call
          var message = 'Merging and inserting into null source';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        return changeMergedProperty($this, ensureNotNull(insertOp.d4c($this.j3n_1, nodeFactory)));
      }
    }
    // Inline function 'kotlin.check' call
    if (!!insertOp.b4b()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.thisThroughInsert.<anonymous>' call
      var message_0 = 'Impossible merge + insert transform';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var tmp;
    if (isOperationOnMergeTarget($this, index)) {
      tmp = $this.j4b($this.x3m_1 + insertOp.a() | 0);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function thisThroughDelete_0($this, deleteOp, index, nodeFactory) {
    if (_get_isMergeToNull__zf4w4f($this)) {
      // Inline function 'kotlin.check' call
      if (!!isOperationOnMergeTarget($this, index)) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.thisThroughDelete.<anonymous>' call
        var message = 'Merge to null but delete in target';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      if (isOperationOnMergeSource_0($this, index)) {
        var tmp;
        if (deleteOp.b4b()) {
          tmp = RemoveChildOperation_init_$Create$_1($this.t3m_1, $this.u3m_1, $this.w3m_1, false);
        } else {
          tmp = changeMergedProperty($this, ensureNotNull(deleteOp.d4c($this.j3n_1, nodeFactory)));
        }
        return tmp;
      }
    }
    if (deleteOp.b4b()) {
      if (isOperationOnMergeTarget($this, index)) {
        return $this.j4b(-1);
      }
      if (isOperationOnMergeSource_0($this, index)) {
        return RemoveChildOperation_init_$Create$_1($this.t3m_1, $this.u3m_1, $this.w3m_1, false);
      }
    }
    var tmp_0;
    if (isOperationOnMergeTarget($this, index)) {
      tmp_0 = $this.j4b($this.x3m_1 - deleteOp.a() | 0);
    } else {
      tmp_0 = null;
    }
    return tmp_0;
  }
  function isOperationOnMergeTarget($this, index) {
    return index === ($this.i3b() - 1 | 0);
  }
  function isOperationOnMergeSource($this, op) {
    return isOperationOnMergeSource_0($this, op.q4a_1);
  }
  function isOperationOnMergeSource_0($this, index) {
    return index === $this.i3b();
  }
  function changeMergedProperty($this, newMergedProperty) {
    return new MergePropertyRemoveChildOperation($this.t3m_1, $this.u3m_1, $this.v3m_1, $this.w3m_1, $this.i3n_1, newMergedProperty, $this.x3m_1);
  }
  function findStringOperation_0($this, op) {
    return SplitMergeOperationsUtil_instance.c4b(op, $this.i3n_1, new Int32Array([$this.i3b(), $this.i3b() - 1 | 0]));
  }
  function MergePropertyRemoveChildOperation(conceptId, removedId, targetId, removeIndex, propertyId, mergedProperty, targetPropertyLength) {
    BaseMergeRemoveChildOperation.call(this, conceptId, removedId, targetId, removeIndex, targetPropertyLength);
    this.i3n_1 = propertyId;
    this.j3n_1 = mergedProperty;
    this.k3n_1 = -1;
  }
  protoOf(MergePropertyRemoveChildOperation).g4b = function () {
    return this.k3n_1;
  };
  protoOf(MergePropertyRemoveChildOperation).r4a = function () {
    return this.i3n_1;
  };
  protoOf(MergePropertyRemoveChildOperation).o43 = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.d4b(otherOp, new Int32Array([this.i3b(), this.i3b() - 1 | 0]));
    if (!(compositeOp == null))
      return this.b3k(compositeOp, server);
    var op = findStringOperation_0(this, otherOp);
    if (!(op == null)) {
      var stringOp = op.p4a_1;
      if (stringOp instanceof SetValueOperation) {
        var setOp = stringOp instanceof SetValueOperation ? stringOp : THROW_CCE();
        return setValueThroughThis_0(this, setOp);
      }
      if (stringOp instanceof InsertTextOperation) {
        var result = insertThroughThis_0(this, stringOp, op.q4a_1);
        if (!(result == null)) {
          return result;
        }
      }
      if (stringOp instanceof DeleteTextOperation) {
        var result_0 = deleteThroughThis_0(this, stringOp, op.q4a_1);
        if (!(result_0 == null)) {
          return result_0;
        }
      }
      var tmp;
      if (isOperationOnMergeSource(this, op)) {
        tmp = stringOp instanceof TextOperation;
      } else {
        tmp = false;
      }
      if (tmp) {
        var newOp = stringOp.q3z(stringOp.i3b() + this.x3m_1 | 0);
        return createChangeSourceProperty(this, newOp);
      }
    }
    if (otherOp instanceof AddChildSplitPropertyOperation) {
      return splitThroughThis_0(this, otherOp, server);
    }
    if (otherOp instanceof MergePropertyRemoveChildOperation) {
      var mergeOp = mergeThroughThis(this, otherOp);
      if (!(mergeOp == null))
        return mergeOp;
    }
    return protoOf(BaseMergeRemoveChildOperation).o43.call(this, otherOp, server);
  };
  protoOf(MergePropertyRemoveChildOperation).g3p = function (otherOp, server) {
    return this.o43(otherOp, server);
  };
  protoOf(MergePropertyRemoveChildOperation).q44 = function (otherOp, server) {
    var compositeOp = SplitMergeOperationsUtil_instance.d4b(otherOp, new Int32Array([this.i3b(), this.i3b() - 1 | 0]));
    if (!(compositeOp == null))
      return compositeOp.b3k(this, !server);
    var op = findStringOperation_0(this, otherOp);
    if (!(op == null)) {
      var stringOp = op.p4a_1;
      if (stringOp instanceof SetValueOperation) {
        var setOp = stringOp instanceof SetValueOperation ? stringOp : THROW_CCE();
        return thisThroughSetValue_0(this, setOp);
      }
      if (stringOp instanceof InsertTextOperation) {
        var result = thisThroughInsert_0(this, stringOp, op.q4a_1, RawNodeFactory_instance);
        if (!(result == null)) {
          return result;
        }
      }
      if (stringOp instanceof DeleteTextOperation) {
        var result_0 = thisThroughDelete_0(this, stringOp, op.q4a_1, RawNodeFactory_instance);
        if (!(result_0 == null)) {
          return result_0;
        }
      }
      if (isOperationOnMergeSource(this, op)) {
        if (stringOp instanceof TextOperation) {
          return changeMergedProperty(this, ensureNotNull(stringOp.d4c(this.j3n_1, RawNodeFactory_instance)));
        }
      }
    }
    var tmp;
    if (otherOp instanceof AddChildSplitPropertyOperation) {
      tmp = thisThroughSplit(this, otherOp, server);
    } else {
      tmp = protoOf(BaseMergeRemoveChildOperation).q44.call(this, otherOp, server);
    }
    return tmp;
  };
  protoOf(MergePropertyRemoveChildOperation).r3p = function (otherOp, server) {
    return this.q44(otherOp, server);
  };
  protoOf(MergePropertyRemoveChildOperation).h4b = function (addedNodeId) {
    return new AddChildSplitPropertyOperation(this.t3m_1, this.v3m_1, addedNodeId, this.w3m_1, this.i3n_1, this.x3m_1, this.j3n_1);
  };
  protoOf(MergePropertyRemoveChildOperation).j4b = function (newTargetLength) {
    return new MergePropertyRemoveChildOperation(this.t3m_1, this.u3m_1, this.v3m_1, this.w3m_1, this.i3n_1, this.j3n_1, newTargetLength);
  };
  protoOf(MergePropertyRemoveChildOperation).i4b = function (newTargetNodeId) {
    return new MergePropertyRemoveChildOperation(this.t3m_1, this.u3m_1, newTargetNodeId, this.w3m_1, this.i3n_1, this.j3n_1, this.x3m_1);
  };
  protoOf(MergePropertyRemoveChildOperation).q3z = function (newIndex) {
    return new MergePropertyRemoveChildOperation(this.t3m_1, this.u3m_1, this.v3m_1, newIndex, this.i3n_1, this.j3n_1, this.x3m_1);
  };
  protoOf(MergePropertyRemoveChildOperation).k4b = function (mergeOp) {
    var mergePropertyRemoveChildOperation = mergeOp instanceof MergePropertyRemoveChildOperation ? mergeOp : THROW_CCE();
    return changeMergedProperty(this, this.j3n_1 + mergePropertyRemoveChildOperation.j3n_1);
  };
  protoOf(MergePropertyRemoveChildOperation).e44 = function (model, nodeFactory) {
    var toRemove = model.q(this.w3m_1);
    var target = model.q(this.w3m_1 - 1 | 0);
    this.l4b(toRemove, target);
    var targetProperty = target.z38(this.i3n_1).qr();
    var targetLength = this.x3m_1;
    if (targetProperty == null) {
      // Inline function 'kotlin.check' call
      if (!(targetLength === -1)) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.execute.<anonymous>' call
        var message = 'Use targetLength=-1 to merge into null';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      targetProperty = '';
      targetLength = 0;
    }
    // Inline function 'kotlin.check' call
    if (!(targetProperty.length === targetLength)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.execute.<anonymous>' call
      var message_0 = 'Target property length: stored=' + targetLength + ', actual=' + targetProperty.length;
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var mergedProperty = toRemove.z38(this.i3n_1).qr();
    // Inline function 'kotlin.check' call
    if (!(mergedProperty === this.j3n_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.execute.<anonymous>' call
      var message_1 = "Stored merged property value='" + this.j3n_1 + "', actual='" + mergedProperty + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    var parent = target.z39();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (parent == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.node.splitMergeOperations.MergePropertyRemoveChildOperation.execute.<anonymous>' call
        var message_2 = 'Null parent';
        throw IllegalStateException_init_$Create$_0(toString_1(message_2));
      } else {
        break $l$block;
      }
    }
    parent.u3b(toRemove, this.i3n_1);
    return model;
  };
  protoOf(MergePropertyRemoveChildOperation).a3k = function (model, nodeFactory) {
    return this.e44((!(model == null) ? isInterface(model, KtMutableList) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(MergePropertyRemoveChildOperation).s3l = function () {
    return new AddChildSplitPropertyOperation(this.t3m_1, this.v3m_1, this.u3m_1, this.w3m_1, this.i3n_1, this.x3m_1, this.j3n_1);
  };
  protoOf(MergePropertyRemoveChildOperation).toString = function () {
    return 'MergePropertyRemoveChild[' + this.y4a() + '; prop=' + this.i3n_1.toString() + '; text=' + this.j3n_1 + ']';
  };
  function getCompositeOperation($this, op, provider, indexes) {
    var tmp0_elvis_lhs = getChangeChildOperation($this, op, indexes.slice());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var changeOp = tmp;
    var changeOpOperation = changeOp.u3l();
    if (changeOpOperation instanceof CompositeOperation) {
      var compositeOp = changeOpOperation instanceof CompositeOperation ? changeOpOperation : THROW_CCE();
      var operations = ArrayList_init_$Create$_0(compositeOp.l3i().n());
      var _iterator__ex2g4s = compositeOp.l3i().k();
      while (_iterator__ex2g4s.l()) {
        var nodeOp = _iterator__ex2g4s.m();
        operations.e(new ChangeChildOperation_0(changeOp.m44_1, changeOp.h3b(), nodeOp));
      }
      return Companion_instance_64.d3m(operations);
    }
    if (provider.f4c(changeOpOperation)) {
      var nodeOp_0 = changeOpOperation instanceof TargetedOperation ? changeOpOperation : THROW_CCE();
      var tmp_0 = nodeOp_0.u3l();
      if (tmp_0 instanceof CompositeOperation) {
        var tmp_1 = nodeOp_0.u3l();
        var compositeOp_0 = tmp_1 instanceof CompositeOperation ? tmp_1 : THROW_CCE();
        var operations_0 = ArrayList_init_$Create$_0(compositeOp_0.l3i().n());
        var _iterator__ex2g4s_0 = compositeOp_0.l3i().k();
        while (_iterator__ex2g4s_0.l()) {
          var listOp = _iterator__ex2g4s_0.m();
          operations_0.e(new ChangeChildOperation_0(changeOp.m44_1, changeOp.h3b(), provider.e4c(nodeOp_0.h3b(), listOp)));
        }
        return Companion_instance_64.d3m(operations_0);
      }
    }
    if (changeOpOperation instanceof ChildListOperation) {
      var operation = changeOpOperation.u3l();
      if (operation instanceof CompositeOperation) {
        var compositeOp_1 = operation instanceof CompositeOperation ? operation : THROW_CCE();
        var compositeOpOperations = compositeOp_1.l3i();
        var operations_1 = ArrayList_init_$Create$_0(compositeOpOperations.n());
        var _iterator__ex2g4s_1 = compositeOpOperations.k();
        while (_iterator__ex2g4s_1.l()) {
          var listOp_0 = _iterator__ex2g4s_1.m();
          operations_1.e(new ChangeChildOperation_0(changeOp.m44_1, changeOp.h3b(), new ChildListOperation(changeOpOperation.h3b(), listOp_0)));
        }
        return Companion_instance_64.d3m(operations_1);
      }
    }
    return null;
  }
  function getNodeOperation($this, op, nodeOperationCondition, role, indexes) {
    var tmp0_elvis_lhs = getChangeChildOperation($this, op, indexes.slice());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var changeOp = tmp;
    var changeOpOperation = changeOp.u3l();
    if (!nodeOperationCondition.y3o(changeOpOperation))
      return null;
    var targetedOp = changeOpOperation instanceof TargetedOperation ? changeOpOperation : THROW_CCE();
    return !equals(targetedOp.h3b(), role) ? null : new NodeOperation(targetedOp.u3l(), changeOp.h3b());
  }
  function getChangeChildOperation($this, op, indexes) {
    if (!(op instanceof ChangeChildOperation_0))
      return null;
    var found = false;
    var inductionVariable = 0;
    var last = indexes.length;
    while (inductionVariable < last) {
      var index = indexes[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (index === op.h3b())
        found = true;
    }
    return !found ? null : op;
  }
  function NodeOperation(op, index) {
    this.p4a_1 = op;
    this.q4a_1 = index;
  }
  protoOf(NodeOperation).toString = function () {
    return 'NodeOperation(op=' + toString_1(this.p4a_1) + ', index=' + this.q4a_1 + ')';
  };
  protoOf(NodeOperation).hashCode = function () {
    var result = hashCode(this.p4a_1);
    result = imul(result, 31) + this.q4a_1 | 0;
    return result;
  };
  protoOf(NodeOperation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeOperation))
      return false;
    var tmp0_other_with_cast = other instanceof NodeOperation ? other : THROW_CCE();
    if (!equals(this.p4a_1, tmp0_other_with_cast.p4a_1))
      return false;
    if (!(this.q4a_1 === tmp0_other_with_cast.q4a_1))
      return false;
    return true;
  };
  function SplitMergeOperationsUtil$getChildCollectionCompositeOperation$provider$1() {
  }
  protoOf(SplitMergeOperationsUtil$getChildCollectionCompositeOperation$provider$1).f4c = function (nodeOp) {
    return nodeOp instanceof ChildListOperation;
  };
  protoOf(SplitMergeOperationsUtil$getChildCollectionCompositeOperation$provider$1).g4c = function (role, op) {
    return new ChildListOperation(role, op);
  };
  protoOf(SplitMergeOperationsUtil$getChildCollectionCompositeOperation$provider$1).e4c = function (role, op) {
    return this.g4c(role instanceof NodeChildId ? role : THROW_CCE(), op);
  };
  function SplitMergeOperationsUtil$getPropertyCompositeOperation$provider$1() {
  }
  protoOf(SplitMergeOperationsUtil$getPropertyCompositeOperation$provider$1).f4c = function (nodeOp) {
    return nodeOp instanceof ChangePropertyOperation;
  };
  protoOf(SplitMergeOperationsUtil$getPropertyCompositeOperation$provider$1).h4c = function (role, op) {
    return new ChangePropertyOperation(role, op);
  };
  protoOf(SplitMergeOperationsUtil$getPropertyCompositeOperation$provider$1).e4c = function (role, op) {
    return this.h4c(role instanceof NodePropertyId ? role : THROW_CCE(), op);
  };
  function SplitMergeOperationsUtil$findListOperation$nodeOperationCondition$1() {
    OperationCondition.call(this);
  }
  protoOf(SplitMergeOperationsUtil$findListOperation$nodeOperationCondition$1).r3m = function (op) {
    return op instanceof ChildListOperation;
  };
  function SplitMergeOperationsUtil$findStringOperation$nodeOperationCondition$1() {
    OperationCondition.call(this);
  }
  protoOf(SplitMergeOperationsUtil$findStringOperation$nodeOperationCondition$1).r3m = function (op) {
    return op instanceof ChangePropertyOperation;
  };
  function SplitMergeOperationsUtil() {
  }
  protoOf(SplitMergeOperationsUtil).s4a = function (op, indexes) {
    var provider = new SplitMergeOperationsUtil$getChildCollectionCompositeOperation$provider$1();
    return getCompositeOperation(this, op, provider, indexes.slice());
  };
  protoOf(SplitMergeOperationsUtil).d4b = function (op, indexes) {
    var provider = new SplitMergeOperationsUtil$getPropertyCompositeOperation$provider$1();
    return getCompositeOperation(this, op, provider, indexes.slice());
  };
  protoOf(SplitMergeOperationsUtil).o4a = function (op, childId, nodeIds) {
    var nodeOperationCondition = new SplitMergeOperationsUtil$findListOperation$nodeOperationCondition$1();
    return getNodeOperation(this, op, nodeOperationCondition, childId, nodeIds.slice());
  };
  protoOf(SplitMergeOperationsUtil).c4b = function (op, propertyId, nodeIds) {
    var nodeOperationCondition = new SplitMergeOperationsUtil$findStringOperation$nodeOperationCondition$1();
    return getNodeOperation(this, op, nodeOperationCondition, propertyId, nodeIds.slice());
  };
  var SplitMergeOperationsUtil_instance;
  function SplitMergeOperationsUtil_getInstance() {
    return SplitMergeOperationsUtil_instance;
  }
  function AnnotatedOperation(author, changeTime, operation) {
    BaseOperation.call(this);
    this.d40_1 = author;
    this.e40_1 = changeTime;
    this.f40_1 = operation;
  }
  protoOf(AnnotatedOperation).t3j = function () {
    return this.f40_1.t3j();
  };
  protoOf(AnnotatedOperation).l3i = function () {
    return listOf(this.f40_1);
  };
  protoOf(AnnotatedOperation).a3k = function (model, nodeFactory) {
    return this.f40_1.a3k(model, nodeFactory);
  };
  protoOf(AnnotatedOperation).s3l = function () {
    return this.v42(this.f40_1.s3l());
  };
  protoOf(AnnotatedOperation).g3p = function (otherOp, server) {
    return this.f40_1.b3k(otherOp, server);
  };
  protoOf(AnnotatedOperation).r3p = function (otherOp, server) {
    return this.v42(otherOp.b3k(this.f40_1, server));
  };
  protoOf(AnnotatedOperation).toString = function () {
    return 'Annotated[a = ' + this.d40_1 + ';t = ' + this.e40_1.toString() + ';o = ' + toString_1(this.f40_1) + ']';
  };
  protoOf(AnnotatedOperation).t3p = function (indent) {
    return indent + 'Annotated[a = ' + this.d40_1 + ';t = ' + this.e40_1.toString() + ';o = \n' + this.f40_1.t3p(indent + '  ') + indent + ']\n';
  };
  protoOf(AnnotatedOperation).v42 = function (operation) {
    return new AnnotatedOperation(this.d40_1, this.e40_1, operation);
  };
  function BaseOperation() {
    this.f3p_1 = false;
  }
  protoOf(BaseOperation).t3j = function () {
    return this.f3p_1;
  };
  protoOf(BaseOperation).b3k = function (otherOp, server) {
    var tmp;
    if (this.t3j()) {
      tmp = otherOp;
    } else {
      tmp = this.g3p(otherOp, server);
    }
    return tmp;
  };
  protoOf(BaseOperation).g3p = function (otherOp, server) {
    var tmp;
    if (otherOp instanceof BaseOperation) {
      var baseOperation = otherOp instanceof BaseOperation ? otherOp : THROW_CCE();
      tmp = baseOperation.r3p(this, server);
    } else {
      tmp = otherOp;
    }
    return tmp;
  };
  protoOf(BaseOperation).r3p = function (otherOp, server) {
    return this;
  };
  protoOf(BaseOperation).s3p = function () {
    return this.t3p('');
  };
  protoOf(BaseOperation).t3p = function (indent) {
    return indent + toString_1(this) + '\n';
  };
  function expandCompositesAndRemoveNops($this, ops) {
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = ops.k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      if (op instanceof CompositeOperation) {
        var composite = op instanceof CompositeOperation ? op : THROW_CCE();
        var expanded = expandCompositesAndRemoveNops($this, composite.l3i());
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!expanded.p()) {
          result.o(expanded);
        }
      } else {
        if (!(op instanceof NopOperation)) {
          result.e(op);
        }
      }
    }
    return result;
  }
  function CompositeOperation_init_$Init$(ops, $this) {
    CompositeOperation.call($this, toList(ops));
    return $this;
  }
  function CompositeOperation_init_$Create$(ops) {
    return CompositeOperation_init_$Init$(ops, objectCreate(protoOf(CompositeOperation)));
  }
  function executeWithConsecutive($this, model, nodeFactory) {
    var result = model;
    var i = 0;
    while (i < $this.g3w_1.n()) {
      var operation = $this.g3w_1.q(i);
      var executionResult = Companion_getInstance_65().o3z_1;
      if (isInterface(operation, WithConsecutiveOperation)) {
        var restOps = subListTail_0($this.g3w_1, i);
        var withConsecutiveOperation = isInterface(operation, WithConsecutiveOperation) ? operation : THROW_CCE();
        executionResult = withConsecutiveOperation.q3p(model, restOps, nodeFactory);
      }
      if (!executionResult.j48_1) {
        result = operation.a3k(result, nodeFactory);
        i = i + 1 | 0;
      } else {
        i = i + executionResult.k48_1 | 0;
      }
    }
    return result;
  }
  function Companion_64() {
  }
  protoOf(Companion_64).d3m = function (ops) {
    var opsList = ops;
    opsList = expandCompositesAndRemoveNops(this, opsList);
    var size = opsList.n();
    if (size === 0) {
      return new NopOperation();
    } else if (size === 1) {
      return opsList.q(0);
    }
    return new CompositeOperation(opsList, false);
  };
  protoOf(Companion_64).t3t = function (ops) {
    return this.d3m(toList(ops));
  };
  var Companion_instance_64;
  function Companion_getInstance_64() {
    return Companion_instance_64;
  }
  function CompositeOperation(ops, expand) {
    expand = expand === VOID ? true : expand;
    CustomExecuteOperation.call(this);
    this.g3w_1 = ArrayList_init_$Create$();
    this.h3w_1 = false;
    this.g3w_1.o(expand ? expandCompositesAndRemoveNops(Companion_instance_64, ops) : ops);
    this.h3w_1 = true;
    var _iterator__ex2g4s = this.g3w_1.k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      if (!op.t3j()) {
        this.h3w_1 = false;
      }
    }
  }
  protoOf(CompositeOperation).t3j = function () {
    return this.h3w_1;
  };
  protoOf(CompositeOperation).l3i = function () {
    return this.g3w_1;
  };
  protoOf(CompositeOperation).s3l = function () {
    var inverseOps = ArrayList_init_$Create$();
    var _iterator__ex2g4s = this.g3w_1.k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      inverseOps.e(op.s3l());
    }
    reverse(inverseOps);
    return Companion_instance_64.d3m(inverseOps);
  };
  protoOf(CompositeOperation).d3v = function (model, customExecute, nodeFactory) {
    var tmp;
    if (customExecute) {
      tmp = executeWithConsecutive(this, model, nodeFactory);
    } else {
      var result = model;
      var _iterator__ex2g4s = this.g3w_1.k();
      while (_iterator__ex2g4s.l()) {
        var operation = _iterator__ex2g4s.m();
        var tmp_0;
        if (operation instanceof CustomExecuteOperation) {
          tmp_0 = operation.d3v(result, false, nodeFactory);
        } else {
          tmp_0 = operation.a3k(result, nodeFactory);
        }
        result = tmp_0;
      }
      tmp = result;
    }
    return tmp;
  };
  protoOf(CompositeOperation).g3p = function (otherOp, server) {
    var result = otherOp;
    var _iterator__ex2g4s = this.g3w_1.k();
    while (_iterator__ex2g4s.l()) {
      var operation = _iterator__ex2g4s.m();
      result = operation.b3k(result, server);
    }
    return result;
  };
  protoOf(CompositeOperation).r3p = function (otherOp, server) {
    var currentOp = otherOp;
    var newOps = ArrayList_init_$Create$();
    var _iterator__ex2g4s = this.g3w_1.k();
    while (_iterator__ex2g4s.l()) {
      var operation = _iterator__ex2g4s.m();
      newOps.e(currentOp.b3k(operation, server));
      currentOp = operation.b3k(currentOp, !server);
    }
    return Companion_instance_64.d3m(newOps);
  };
  protoOf(CompositeOperation).toString = function () {
    return 'Composite' + this.g3w_1.toString();
  };
  protoOf(CompositeOperation).t3p = function (indent) {
    var builder = (new StringBuilder(indent)).d9('Composite[\n');
    var _iterator__ex2g4s = this.g3w_1.k();
    while (_iterator__ex2g4s.l()) {
      var operation = _iterator__ex2g4s.m();
      builder.d9(operation.t3p(indent + '  '));
    }
    builder.d9(indent).d9(']\n');
    return builder.toString();
  };
  function CustomExecuteOperation() {
    BaseOperation.call(this);
  }
  protoOf(CustomExecuteOperation).a3k = function (model, nodeFactory) {
    return this.d3v(model, true, nodeFactory);
  };
  function ExecutionResult_init_$Init$(appliedCommandsCount, $this) {
    ExecutionResult.call($this, true, appliedCommandsCount);
    return $this;
  }
  function ExecutionResult_init_$Create$(appliedCommandsCount) {
    return ExecutionResult_init_$Init$(appliedCommandsCount, objectCreate(protoOf(ExecutionResult)));
  }
  function Companion_65() {
    Companion_instance_65 = this;
    this.o3z_1 = new ExecutionResult(false, 0);
  }
  var Companion_instance_65;
  function Companion_getInstance_65() {
    if (Companion_instance_65 == null)
      new Companion_65();
    return Companion_instance_65;
  }
  function ExecutionResult(applied, appliedOperationsCount) {
    Companion_getInstance_65();
    this.j48_1 = applied;
    this.k48_1 = appliedOperationsCount;
  }
  function HasOperationTargetData() {
  }
  function NoSubjectOperation() {
    BaseOperation.call(this);
  }
  function NopOperation() {
    NoSubjectOperation.call(this);
    this.j4c_1 = true;
  }
  protoOf(NopOperation).t3j = function () {
    return this.j4c_1;
  };
  protoOf(NopOperation).a3k = function (model, nodeFactory) {
    return model;
  };
  protoOf(NopOperation).s3l = function () {
    return new NopOperation();
  };
  protoOf(NopOperation).toString = function () {
    return 'Nop';
  };
  function Operation() {
  }
  function OperationContainer() {
  }
  var OperationKind_ADD_instance;
  var OperationKind_REMOVE_instance;
  var OperationKind_CHANGE_instance;
  var OperationKind_entriesInitialized;
  function OperationKind_initEntries() {
    if (OperationKind_entriesInitialized)
      return Unit_instance;
    OperationKind_entriesInitialized = true;
    OperationKind_ADD_instance = new OperationKind('ADD', 0);
    OperationKind_REMOVE_instance = new OperationKind('REMOVE', 1);
    OperationKind_CHANGE_instance = new OperationKind('CHANGE', 2);
  }
  function OperationKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function OperationKind_ADD_getInstance() {
    OperationKind_initEntries();
    return OperationKind_ADD_instance;
  }
  function OperationKind_REMOVE_getInstance() {
    OperationKind_initEntries();
    return OperationKind_REMOVE_instance;
  }
  function OperationKind_CHANGE_getInstance() {
    OperationKind_initEntries();
    return OperationKind_CHANGE_instance;
  }
  function TargetedOperation(role, operation) {
    CustomExecuteOperation.call(this);
    this.w3o_1 = role;
    this.x3o_1 = operation;
  }
  protoOf(TargetedOperation).h3b = function () {
    return this.w3o_1;
  };
  protoOf(TargetedOperation).u3l = function () {
    return this.x3o_1;
  };
  protoOf(TargetedOperation).t3j = function () {
    return this.u3l().t3j();
  };
  protoOf(TargetedOperation).b3 = function () {
    return 'targeted';
  };
  protoOf(TargetedOperation).l3i = function () {
    return listOf(this.u3l());
  };
  protoOf(TargetedOperation).z3p = function (otherOp, server) {
    if (otherOp instanceof TargetedOperation) {
      var otherTargeted = otherOp instanceof TargetedOperation ? otherOp : THROW_CCE();
      if (equals(this.h3b(), otherTargeted.h3b())) {
        var tmp = otherTargeted.u3l();
        var otherOperation = isInterface(tmp, Operation) ? tmp : THROW_CCE();
        return this.y3p(this.u3l().b3k(otherOperation, server));
      }
    }
    return protoOf(CustomExecuteOperation).g3p.call(this, otherOp, server);
  };
  protoOf(TargetedOperation).g3p = function (otherOp, server) {
    return this.z3p(otherOp, server);
  };
  protoOf(TargetedOperation).s3l = function () {
    return this.y3p(this.u3l().s3l());
  };
  protoOf(TargetedOperation).d3q = function (model, customExecute, nodeFactory) {
    var tmp0_elvis_lhs = this.c3q(model);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('src=' + toString_0(model) + '; role=' + toString_0(this.h3b()));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var target = tmp;
    this.f3q(target, customExecute, nodeFactory);
    return model;
  };
  protoOf(TargetedOperation).d3v = function (model, customExecute, nodeFactory) {
    return this.d3q((model == null ? true : !(model == null)) ? model : THROW_CCE(), customExecute, nodeFactory);
  };
  protoOf(TargetedOperation).f3q = function (target, customExecute, nodeFactory) {
    var operation = this.u3l();
    if (operation instanceof CustomExecuteOperation) {
      operation.d3v(target, customExecute, nodeFactory);
    } else {
      operation.a3k(target, nodeFactory);
    }
  };
  protoOf(TargetedOperation).toString = function () {
    return this.b3() + '[r = ' + toString_0(this.h3b()) + ';o = ' + toString_1(this.u3l()) + ']';
  };
  protoOf(TargetedOperation).t3p = function (indent) {
    return indent + this.b3() + '[r = ' + toString_0(this.h3b()) + ';o =\n' + this.u3l().t3p(indent + '  ') + indent + ']\n';
  };
  function WithConsecutiveOperation() {
  }
  function prettyPrint($this, op) {
    var tmp1_elvis_lhs = op == null ? null : op.s3p();
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function PrintOperationUtil() {
  }
  protoOf(PrintOperationUtil).h3m = function (operation) {
    return LoggingUtils_instance.v2y(prettyPrint(this, operation));
  };
  var PrintOperationUtil_instance;
  function PrintOperationUtil_getInstance() {
    return PrintOperationUtil_instance;
  }
  function AnnotatedOperationPersister() {
  }
  protoOf(AnnotatedOperationPersister).p2y = function () {
    return 'ao';
  };
  protoOf(AnnotatedOperationPersister).k4c = function () {
    return getKClass(AnnotatedOperation);
  };
  protoOf(AnnotatedOperationPersister).l4c = function (modelCtx, ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof AnnotatedOperation)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var ao = op instanceof AnnotatedOperation ? op : THROW_CCE();
    var result = new JsonArray();
    var author = ao.d40_1;
    if (author == null) {
      result.s2t(new JsonNull());
    } else {
      result.h2u(author);
    }
    result.h2u(ao.e40_1.toString());
    result.s2t(ctx.s4c(modelCtx, ao.f40_1));
    return result;
  };
  protoOf(AnnotatedOperationPersister).t4c = function (modelCtx, ctx, json) {
    var tmp;
    var tmp_0 = json.q(0);
    if (tmp_0 instanceof JsonNull) {
      tmp = null;
    } else {
      tmp = json.m2u(0);
    }
    var author = tmp;
    var time = toLong_1(json.m2u(1));
    var op = ctx.u4c(modelCtx, json.l2u(2));
    return new AnnotatedOperation(author, time, op);
  };
  function CompositeOperationPersister() {
  }
  protoOf(CompositeOperationPersister).p2y = function () {
    return 'c';
  };
  protoOf(CompositeOperationPersister).k4c = function () {
    return getKClass(CompositeOperation);
  };
  protoOf(CompositeOperationPersister).l4c = function (modelCtx, ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof CompositeOperation)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var composite = op instanceof CompositeOperation ? op : THROW_CCE();
    var container = new JsonArray();
    var _iterator__ex2g4s = composite.l3i().k();
    while (_iterator__ex2g4s.l()) {
      var childOp = _iterator__ex2g4s.m();
      container.s2t(ctx.s4c(modelCtx, childOp));
    }
    var result = new JsonArray();
    result.s2t(container);
    return result;
  };
  protoOf(CompositeOperationPersister).t4c = function (modelCtx, ctx, json) {
    var ops = ArrayList_init_$Create$();
    var itemsArrays = json.l2u(0);
    var _iterator__ex2g4s = itemsArrays.k();
    while (_iterator__ex2g4s.l()) {
      var v = _iterator__ex2g4s.m();
      ops.e(ctx.u4c(modelCtx, v instanceof JsonArray ? v : THROW_CCE()));
    }
    return Companion_instance_64.d3m(ops);
  };
  function NopOperationPersister() {
  }
  protoOf(NopOperationPersister).p2y = function () {
    return 'n';
  };
  protoOf(NopOperationPersister).k4c = function () {
    return getKClass(NopOperation);
  };
  protoOf(NopOperationPersister).l4c = function (modelCtx, ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof NopOperation)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new JsonArray();
  };
  protoOf(NopOperationPersister).t4c = function (modelCtx, ctx, json) {
    return new NopOperation();
  };
  function PersisterNotFoundException_init_$Init$($outer, kind, json, $this) {
    $this.v4c_1 = $outer;
    RuntimeException_init_$Init$_0(toString_1($outer) + ', delegates=' + $outer.r4c_1 + ', kind=' + kind + '; unknown tag ' + json.m2u(0) + ', json=' + json.toString(), $this);
    PersisterNotFoundException.call($this);
    return $this;
  }
  function PersisterNotFoundException_init_$Create$($outer, kind, json) {
    var tmp = PersisterNotFoundException_init_$Init$($outer, kind, json, objectCreate(protoOf(PersisterNotFoundException)));
    captureStack(tmp, PersisterNotFoundException_init_$Create$);
    return tmp;
  }
  function PersisterNotFoundException_init_$Init$_0($outer, kind, op, $this) {
    $this.v4c_1 = $outer;
    RuntimeException_init_$Init$_0(toString_1($outer) + ', delegates=' + $outer.r4c_1 + ', kind=' + kind + "; can't serialize op=" + toString_1(op), $this);
    PersisterNotFoundException.call($this);
    return $this;
  }
  function PersisterNotFoundException_init_$Create$_0($outer, kind, op) {
    var tmp = PersisterNotFoundException_init_$Init$_0($outer, kind, op, objectCreate(protoOf(PersisterNotFoundException)));
    captureStack(tmp, PersisterNotFoundException_init_$Create$_0);
    return tmp;
  }
  function getTagPersistersMap($this, ctx) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.p4c_1;
    var value = this_0.y2(ctx);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.OperationPersistenceContext.getTagPersistersMap.<anonymous>' call
      var answer = HashMap_init_$Create$();
      this_0.r2(ctx, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var map = tmp;
    return isInterface(map, KtMutableMap) ? map : THROW_CCE();
  }
  function getClassPersistersMap($this, ctx) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.q4c_1;
    var value = this_0.y2(ctx);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.OperationPersistenceContext.getClassPersistersMap.<anonymous>' call
      var answer = HashMap_init_$Create$();
      this_0.r2(ctx, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var map = tmp;
    return isInterface(map, KtMutableMap) ? map : THROW_CCE();
  }
  function checkGlobalTag($this, tag) {
    if ($this.n4c_1.w2(tag)) {
      throw RuntimeException_init_$Create$_0(tag + ' in global');
    }
    var _iterator__ex2g4s = $this.p4c_1.u2().k();
    while (_iterator__ex2g4s.l()) {
      var ctx = _iterator__ex2g4s.m();
      if (getTagPersistersMap($this, ctx).w2(tag)) {
        throw RuntimeException_init_$Create$_0(tag);
      }
    }
  }
  function checkLocalTag($this, ctx, tag) {
    if ($this.n4c_1.w2(tag)) {
      throw RuntimeException_init_$Create$_0(tag + ' in global');
    }
    if (getTagPersistersMap($this, ctx).w2(tag)) {
      throw RuntimeException_init_$Create$_0(tag);
    }
  }
  function silentSerialize($this, ctx, op) {
    var result = doSerialize($this, ctx, op);
    var _iterator__ex2g4s = $this.r4c_1.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var context = _iterator__ex2g4s.m();
      if (!(result == null)) {
        break $l$loop;
      }
      result = silentSerialize(context, ctx, op);
    }
    return result;
  }
  function doSerialize($this, ctx, op) {
    var tagMap = getClassPersistersMap($this, ctx);
    var persister = tagMap.y2(getKClassFromExpression(op));
    if (!(persister == null)) {
      var result = persister.w4c($this, op);
      result.f2u(0, new JsonString(persister.p2y()));
      return result;
    }
    var globPersister = $this.o4c_1.y2(getKClassFromExpression(op));
    if (!(globPersister == null)) {
      var result_0 = globPersister.l4c(ctx, $this, op);
      result_0.f2u(0, new JsonString(globPersister.p2y()));
      return result_0;
    }
    return null;
  }
  function silentDeserialize($this, ctx, json) {
    var operation = doDeserialize($this, ctx, json);
    var _iterator__ex2g4s = $this.r4c_1.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var context = _iterator__ex2g4s.m();
      if (!(operation == null)) {
        break $l$loop;
      }
      operation = silentDeserialize(context, ctx, json);
    }
    return operation;
  }
  function doDeserialize($this, ctx, json) {
    var tag = json.m2u(0);
    var persisters = getTagPersistersMap($this, ctx);
    var persister = persisters.y2(tag);
    if (!(persister == null)) {
      json.g2u(0);
      return persister.x4c($this, json);
    }
    var globalPersister = $this.n4c_1.y2(tag);
    if (!(globalPersister == null)) {
      json.g2u(0);
      return globalPersister.t4c(ctx, $this, json);
    }
    return null;
  }
  function PersisterNotFoundException() {
    captureStack(this, PersisterNotFoundException);
  }
  function OperationPersistenceContext(idPersistenceContext) {
    this.m4c_1 = idPersistenceContext;
    this.n4c_1 = HashMap_init_$Create$();
    this.o4c_1 = HashMap_init_$Create$();
    this.p4c_1 = HashMap_init_$Create$();
    this.q4c_1 = HashMap_init_$Create$();
    this.r4c_1 = ArrayList_init_$Create$();
    this.y4c(new NopOperationPersister());
    this.y4c(new CompositeOperationPersister());
    this.y4c(new AnnotatedOperationPersister());
  }
  protoOf(OperationPersistenceContext).y4c = function (persister) {
    checkGlobalTag(this, persister.p2y());
    var tmp0 = this.n4c_1;
    // Inline function 'kotlin.collections.set' call
    var key = persister.p2y();
    tmp0.r2(key, persister);
    var tmp3 = this.o4c_1;
    // Inline function 'kotlin.collections.set' call
    var key_0 = persister.k4c();
    tmp3.r2(key_0, persister);
  };
  protoOf(OperationPersistenceContext).z4c = function (ctx, persisters) {
    var inductionVariable = 0;
    var last = persisters.length;
    while (inductionVariable < last) {
      var persister = persisters[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      checkLocalTag(this, ctx, persister.p2y());
      var tmp0 = getTagPersistersMap(this, ctx);
      // Inline function 'kotlin.collections.set' call
      var key = persister.p2y();
      tmp0.r2(key, persister);
      var tmp3 = getClassPersistersMap(this, ctx);
      // Inline function 'kotlin.collections.set' call
      var key_0 = persister.k4c();
      tmp3.r2(key_0, persister);
    }
  };
  protoOf(OperationPersistenceContext).s4c = function (ctx, op) {
    var tmp0_elvis_lhs = silentSerialize(this, ctx, op);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw PersisterNotFoundException_init_$Create$_0(this, ctx, op);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(OperationPersistenceContext).u4c = function (ctx, json) {
    var tmp0_elvis_lhs = silentDeserialize(this, ctx, json);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw PersisterNotFoundException_init_$Create$(this, ctx, json);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(OperationPersistenceContext).a4d = function (context) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.r4c_1.e(context);
  };
  protoOf(OperationPersistenceContext).b4d = function (kind, id) {
    return this.m4c_1.m37(kind).x2p(id);
  };
  protoOf(OperationPersistenceContext).c4d = function (kind, value) {
    return this.m4c_1.m37(kind).q2q(value);
  };
  function TargetedOperationPersister(rolePersister) {
    this.d4d_1 = rolePersister;
  }
  protoOf(TargetedOperationPersister).h4d = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.f4d(op)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var targetedOp = op instanceof TargetedOperation ? op : THROW_CCE();
    var result = new JsonArray();
    result.h2u(ensureNotNull(this.d4d_1.x2p(targetedOp.h3b())));
    result.s2t(ctx.s4c(this.e4d(), targetedOp.u3l()));
    return result;
  };
  protoOf(TargetedOperationPersister).w4c = function (ctx, op) {
    return this.h4d(ctx, op);
  };
  protoOf(TargetedOperationPersister).x4c = function (ctx, json) {
    var role = this.d4d_1.q2q(json.m2u(0));
    var op = ctx.u4c(this.e4d(), json.l2u(1));
    return this.g4d(role, op);
  };
  function doUpdateIdCompressor($this, idCompressor, update) {
    var patch = HashMap_init_$Create$();
    var i = 0;
    while (i < update.wo()) {
      var tmp1 = update.m2u(i);
      // Inline function 'kotlin.collections.set' call
      var value = update.m2u(i + 1 | 0);
      patch.r2(tmp1, value);
      i = i + 2 | 0;
    }
    idCompressor.k4d(patch);
  }
  function DictionaryAwareDeserializer(idCompressor) {
    DictionaryAwarePersister.call(this, idCompressor);
  }
  protoOf(DictionaryAwareDeserializer).o4d = function (json) {
    var valueIndex = 0;
    if (json.wo() === 2) {
      doUpdateIdCompressor(this, ensureNotNull(this.p4d_1), json.l2u(0));
      valueIndex = 1;
    }
    return this.n4d(json.q(valueIndex));
  };
  function DictionaryAwarePersister(idCompressor) {
    this.p4d_1 = idCompressor;
    var tmp = this;
    var tmp_0;
    var tmp_1;
    if (this.p4d_1 == null) {
      tmp_1 = true;
    } else {
      var tmp_2 = this.p4d_1;
      tmp_1 = tmp_2 instanceof UpdatableIdCompressor;
    }
    if (tmp_1) {
      tmp_0 = false;
    } else {
      var tmp_3 = this.p4d_1;
      if (tmp_3 instanceof DefaultSelfUpdatingIdCompressor) {
        tmp_0 = true;
      } else {
        throw IllegalArgumentException_init_$Create$_0('Unknown id compressor: ' + toString_0(this.p4d_1));
      }
    }
    tmp.q4d_1 = tmp_0;
  }
  function compressorUpdateToJson($this, data) {
    var array = new JsonArray();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = data.w().k();
    while (_iterator__ex2g4s.l()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.x();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.y();
      array.h2u(key);
      array.h2u(value);
    }
    return array;
  }
  function DictionaryAwareSerializer(idCompressor) {
    DictionaryAwarePersister.call(this, idCompressor);
  }
  protoOf(DictionaryAwareSerializer).u4d = function (value) {
    var result = new JsonArray();
    if (this.q4d_1) {
      var tmp = this.p4d_1;
      (tmp instanceof DefaultSelfUpdatingIdCompressor ? tmp : THROW_CCE()).c4e();
      var jsonValue = this.t4d(value);
      var updateResult = this.p4d_1.l4e();
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!updateResult.p()) {
        result.s2t(compressorUpdateToJson(this, updateResult));
      }
      result.s2t(jsonValue);
    } else {
      result.s2t(this.t4d(value));
    }
    return result;
  };
  function AddChildOperationPersister() {
    ChildOperationPersister.call(this);
  }
  protoOf(AddChildOperationPersister).p2y = function () {
    return 'a';
  };
  protoOf(AddChildOperationPersister).k4c = function () {
    return getKClass(AddChildOperation);
  };
  protoOf(AddChildOperationPersister).m4e = function (op) {
    return op instanceof AddChildOperation;
  };
  protoOf(AddChildOperationPersister).n4e = function (conceptId, entityId, singleRole) {
    return AddChildOperation_init_$Create$(conceptId, entityId, singleRole);
  };
  function ChangeChildOperationPersister() {
    this.p4e_1 = 'cc';
    this.q4e_1 = getKClass(ChangeChildOperation);
  }
  protoOf(ChangeChildOperationPersister).p2y = function () {
    return this.p4e_1;
  };
  protoOf(ChangeChildOperationPersister).k4c = function () {
    return this.q4e_1;
  };
  protoOf(ChangeChildOperationPersister).o4e = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof ChangeChildOperation)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    result.h2u(ensureNotNull(ctx.b4d(EntityIdModelKinds_getInstance().f37_1, op.h3b())));
    result.s2t(ctx.s4c(EntityModelKinds_getInstance().r4e_1, op.u3l()));
    return result;
  };
  protoOf(ChangeChildOperationPersister).w4c = function (ctx, op) {
    return this.o4e(ctx, op);
  };
  protoOf(ChangeChildOperationPersister).x4c = function (ctx, json) {
    var id = ctx.c4d(EntityIdModelKinds_getInstance().f37_1, json.m2u(0));
    var op = ctx.u4c(EntityModelKinds_getInstance().r4e_1, json.l2u(1));
    return new ChangeChildOperation(id, op);
  };
  function ChildOperationPersister() {
  }
  protoOf(ChildOperationPersister).o4e = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.m4e(op)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var childOp = op instanceof ChildOperation ? op : THROW_CCE();
    var result = new JsonArray();
    result.h2u(ensureNotNull(ctx.b4d(EntityIdModelKinds_getInstance().g37_1, childOp.h3f())));
    result.h2u(ensureNotNull(ctx.b4d(EntityIdModelKinds_getInstance().f37_1, childOp.r3i())));
    if (childOp.b32()) {
      result.i2u(0.0);
    }
    return result;
  };
  protoOf(ChildOperationPersister).w4c = function (ctx, op) {
    return this.o4e(ctx, op);
  };
  protoOf(ChildOperationPersister).x4c = function (ctx, json) {
    var conceptId = ctx.c4d(EntityIdModelKinds_getInstance().g37_1, json.m2u(0));
    var entityId = ctx.c4d(EntityIdModelKinds_getInstance().f37_1, json.m2u(1));
    var isSingleRole = json.wo() === 3;
    return this.n4e(conceptId, entityId, isSingleRole);
  };
  function RemoveChildOperationPersister() {
    ChildOperationPersister.call(this);
    this.v4e_1 = 'r';
    this.w4e_1 = getKClass(RemoveChildOperation);
  }
  protoOf(RemoveChildOperationPersister).p2y = function () {
    return this.v4e_1;
  };
  protoOf(RemoveChildOperationPersister).k4c = function () {
    return this.w4e_1;
  };
  protoOf(RemoveChildOperationPersister).m4e = function (op) {
    return op instanceof RemoveChildOperation;
  };
  protoOf(RemoveChildOperationPersister).n4e = function (conceptId, entityId, singleRole) {
    return RemoveChildOperation_init_$Create$(conceptId, entityId, singleRole);
  };
  function AddRootOperationPersister() {
    this.x4e_1 = 'a';
    this.y4e_1 = getKClass(AddRootOperation);
  }
  protoOf(AddRootOperationPersister).p2y = function () {
    return this.x4e_1;
  };
  protoOf(AddRootOperationPersister).k4c = function () {
    return this.y4e_1;
  };
  protoOf(AddRootOperationPersister).z4e = function (ctx, op) {
    // Inline function 'kotlin.check' call
    if (!(op instanceof AddRootOperation)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var result = new JsonArray();
    result.h2u(ensureNotNull(ctx.b4d(EntityIdModelKinds_getInstance().f37_1, op.o3i())));
    result.h2u(ensureNotNull(ctx.b4d(EntityIdModelKinds_getInstance().g37_1, op.h3f())));
    return result;
  };
  protoOf(AddRootOperationPersister).w4c = function (ctx, op) {
    return this.z4e(ctx, op);
  };
  protoOf(AddRootOperationPersister).x4c = function (ctx, json) {
    var entityId = ctx.c4d(EntityIdModelKinds_getInstance().f37_1, json.m2u(0));
    var conceptId = ctx.c4d(EntityIdModelKinds_getInstance().g37_1, json.m2u(1));
    return AddRootOperation_init_$Create$(entityId, conceptId);
  };
  function Deserializer(idCompressor, nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    DictionaryAwareDeserializer.call(this, idCompressor);
    this.c4f_1 = nodeFactory;
    this.d4f_1 = new EntityIdPersistenceContext(idCompressor);
  }
  protoOf(Deserializer).n4d = function (json) {
    var converter = new Json2EntityConverter(this.d4f_1, this.c4f_1);
    var tmp = BaseJsonReaderSupport_instance.o2v(json);
    var jsonArrayReader = isInterface(tmp, JsonArrayReader) ? tmp : THROW_CCE();
    var root = converter.t37(jsonArrayReader);
    return new UnsafeBuildRootOperation(root);
  };
  function Serializer(idCompressor) {
    DictionaryAwareSerializer.call(this, idCompressor);
    this.g4f_1 = new EntityIdPersistenceContext(idCompressor);
  }
  protoOf(Serializer).h4f = function (value) {
    return (new Entity2JsonConverter(this.g4f_1, value.t3o_1)).p38(value.u3o());
  };
  protoOf(Serializer).t4d = function (value) {
    return this.h4f(value instanceof BuildRootOperation ? value : THROW_CCE());
  };
  function BuildRootOperationPersister(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.i4f_1 = nodeFactory;
    this.j4f_1 = 'b';
    this.k4f_1 = getKClass(SafeBuildRootOperation);
  }
  protoOf(BuildRootOperationPersister).p2y = function () {
    return this.j4f_1;
  };
  protoOf(BuildRootOperationPersister).k4c = function () {
    return this.k4f_1;
  };
  protoOf(BuildRootOperationPersister).z4e = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof BuildRootOperation)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var idCompressor = DefaultSelfUpdatingIdCompressor_init_$Create$();
    var serializer = new Serializer(idCompressor);
    return serializer.u4d(op);
  };
  protoOf(BuildRootOperationPersister).w4c = function (ctx, op) {
    return this.z4e(ctx, op);
  };
  protoOf(BuildRootOperationPersister).x4c = function (ctx, json) {
    var deserializer = new Deserializer(new UpdatableIdCompressor(), this.i4f_1);
    return deserializer.o4d(json);
  };
  function ChangeRootEntityOperationPersister() {
    this.l4f_1 = 'e';
    this.m4f_1 = getKClass(ChangeRootEntityOperation);
  }
  protoOf(ChangeRootEntityOperationPersister).p2y = function () {
    return this.l4f_1;
  };
  protoOf(ChangeRootEntityOperationPersister).k4c = function () {
    return this.m4f_1;
  };
  protoOf(ChangeRootEntityOperationPersister).z4e = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof ChangeRootEntityOperation)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    result.h2u(ensureNotNull(ctx.b4d(EntityIdModelKinds_getInstance().f37_1, op.h3b())));
    result.s2t(ctx.s4c(EntityModelKinds_getInstance().r4e_1, op.u3l()));
    return result;
  };
  protoOf(ChangeRootEntityOperationPersister).w4c = function (ctx, op) {
    return this.z4e(ctx, op);
  };
  protoOf(ChangeRootEntityOperationPersister).x4c = function (ctx, json) {
    var entityId = ctx.c4d(EntityIdModelKinds_getInstance().f37_1, json.m2u(0));
    var op = ctx.u4c(EntityModelKinds_getInstance().r4e_1, json.l2u(1));
    return new ChangeRootEntityOperation(entityId, op);
  };
  function RemoveRootOperationPersister() {
    this.n4f_1 = 'r';
    this.o4f_1 = getKClass(RemoveRootOperation);
  }
  protoOf(RemoveRootOperationPersister).p2y = function () {
    return this.n4f_1;
  };
  protoOf(RemoveRootOperationPersister).k4c = function () {
    return this.o4f_1;
  };
  protoOf(RemoveRootOperationPersister).z4e = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof RemoveRootOperation)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    result.h2u(ensureNotNull(ctx.b4d(EntityIdModelKinds_getInstance().f37_1, op.o3i())));
    result.h2u(ensureNotNull(ctx.b4d(EntityIdModelKinds_getInstance().g37_1, op.h3f())));
    return result;
  };
  protoOf(RemoveRootOperationPersister).w4c = function (ctx, op) {
    return this.z4e(ctx, op);
  };
  protoOf(RemoveRootOperationPersister).x4c = function (ctx, json) {
    var entityId = ctx.c4d(EntityIdModelKinds_getInstance().f37_1, json.m2u(0));
    var conceptId = ctx.c4d(EntityIdModelKinds_getInstance().g37_1, json.m2u(1));
    return RemoveRootOperation_init_$Create$(entityId, conceptId);
  };
  function EntityConceptIdPersister() {
    MetaIdPersister.call(this);
    this.q4f_1 = values_0();
  }
  protoOf(EntityConceptIdPersister).r4f = function (id, flags) {
    return EntityConceptId_init_$Create$_0(id);
  };
  protoOf(EntityConceptIdPersister).s4f = function (id, flags) {
    return this.r4f(id, flags);
  };
  protoOf(EntityConceptIdPersister).t4f = function () {
    return this.q4f_1;
  };
  function EntityIdPersistenceContext(idCompressor) {
    idCompressor = idCompressor === VOID ? null : idCompressor;
    BaseIdPersistenceContext.call(this, idCompressor);
    var idPersister = PrivateEntityIdPersisters_instance.w4f();
    this.x4f(EntityIdModelKinds_getInstance().f37_1, idPersister);
    this.x4f(EntityIdModelKinds_getInstance().g37_1, PrivateEntityIdPersisters_instance.y4f());
    this.x4f(EntityIdModelKinds_getInstance().h37_1, PrivateEntityIdPersisters_instance.z4f());
    this.x4f(EntityIdModelKinds_getInstance().i37_1, PrivateEntityIdPersisters_instance.a4g());
    this.x4f(EntityIdModelKinds_getInstance().j37_1, PrivateEntityIdPersisters_instance.b4g());
    this.x4f(EntityIdModelKinds_getInstance().k37_1, PrivateEntityIdPersisters_instance.c4g());
    this.x4f(EntityIdModelKinds_getInstance().l37_1, EntityIdPersisters_instance.d4g());
    this.e4g(new NodeIdPersistenceContext(idCompressor));
  }
  protoOf(EntityIdPersistenceContext).i4g = function () {
    var tmp = this.j4g().q(0);
    return tmp instanceof NodeIdPersistenceContext ? tmp : THROW_CCE();
  };
  function EntityIdPersisters$childIdPersister$1() {
    RoleIdPersister.call(this);
  }
  protoOf(EntityIdPersisters$childIdPersister$1).n4g = function (id, flags) {
    return EntityChildId_init_$Create$_0(id, flags);
  };
  protoOf(EntityIdPersisters$childIdPersister$1).s4f = function (id, flags) {
    return this.n4g(id, flags);
  };
  function EntityIdPersisters$referenceIdPersister$1() {
    RoleIdPersister.call(this);
  }
  protoOf(EntityIdPersisters$referenceIdPersister$1).n4g = function (id, flags) {
    return EntityReferenceId_init_$Create$(id, flags);
  };
  protoOf(EntityIdPersisters$referenceIdPersister$1).s4f = function (id, flags) {
    return this.n4g(id, flags);
  };
  function EntityIdPersisters$entityReferencePersister$1() {
    this.s4g_1 = _Char___init__impl__6a9atx(44);
    this.t4g_1 = PrivateEntityIdPersisters_instance.w4f();
    this.u4g_1 = new ExceptionNullPersister();
  }
  protoOf(EntityIdPersisters$entityReferencePersister$1).p2q = function (value) {
    var separatorIndex = -1;
    var inductionVariable = 0;
    var last = charSequenceLength(value) - 1 | 0;
    if (inductionVariable <= last)
      $l$loop: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charSequenceGet(value, index) === this.s4g_1) {
          separatorIndex = index;
          break $l$loop;
        }
      }
       while (inductionVariable <= last);
    var tmp;
    if (separatorIndex < 0) {
      tmp = new EntityReference(this.t4g_1.q2q(value));
    } else {
      var serializedRootId = take_1(value, separatorIndex);
      // Inline function 'kotlin.text.substring' call
      var startIndex = separatorIndex + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var serializedEntityId = value.substring(startIndex);
      tmp = new EntityReference(this.t4g_1.q2q(serializedRootId), this.t4g_1.q2q(serializedEntityId));
    }
    return tmp;
  };
  protoOf(EntityIdPersisters$entityReferencePersister$1).v4g = function (value) {
    var tmp;
    if (value.f35_1.equals(value.g35_1)) {
      tmp = this.t4g_1.o2q(value.f35_1);
    } else {
      var rootString = this.t4g_1.x2p(value.f35_1);
      var entityString = this.t4g_1.x2p(value.g35_1);
      // Inline function 'kotlin.check' call
      if (!(!contains_9(ensureNotNull(rootString), '' + toString(this.s4g_1)) && !contains_9(ensureNotNull(entityString), '' + toString(this.s4g_1)))) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      tmp = rootString + toString(this.s4g_1) + entityString;
    }
    return tmp;
  };
  protoOf(EntityIdPersisters$entityReferencePersister$1).o2q = function (value) {
    return this.v4g(value instanceof EntityReference ? value : THROW_CCE());
  };
  protoOf(EntityIdPersisters$entityReferencePersister$1).n2q = function () {
    return this.u4g_1;
  };
  function EntityIdPersisters() {
  }
  protoOf(EntityIdPersisters).w4g = function () {
    return new EntityIdPersisters$childIdPersister$1();
  };
  protoOf(EntityIdPersisters).x4g = function () {
    return new EntityIdPersisters$referenceIdPersister$1();
  };
  protoOf(EntityIdPersisters).y4f = function () {
    return new EntityConceptIdPersister();
  };
  protoOf(EntityIdPersisters).d4g = function () {
    return new EntityIdPersisters$entityReferencePersister$1();
  };
  var EntityIdPersisters_instance;
  function EntityIdPersisters_getInstance() {
    return EntityIdPersisters_instance;
  }
  function PrivateEntityIdPersisters$idPersister$1() {
    DefaultIdPersister.call(this);
  }
  protoOf(PrivateEntityIdPersisters$idPersister$1).z4g = function (id) {
    return EntityId_init_$Create$_0(id);
  };
  function PrivateEntityIdPersisters$propertyIdPersister$1() {
    DefaultIdPersister.call(this);
  }
  protoOf(PrivateEntityIdPersisters$propertyIdPersister$1).z4g = function (id) {
    return EntityPropertyId_init_$Create$_0(id);
  };
  function PrivateEntityIdPersisters$modelBlobIdPersister$1() {
    DefaultIdPersister.call(this);
  }
  protoOf(PrivateEntityIdPersisters$modelBlobIdPersister$1).z4g = function (id) {
    return EntityModelBlobId_init_$Create$_0(id);
  };
  function PrivateEntityIdPersisters() {
  }
  protoOf(PrivateEntityIdPersisters).w4f = function () {
    return new PrivateEntityIdPersisters$idPersister$1();
  };
  protoOf(PrivateEntityIdPersisters).c4g = function () {
    return new CompressingIdPersister(EntityIdPersisters_instance.w4g());
  };
  protoOf(PrivateEntityIdPersisters).z4f = function () {
    return new CompressingIdPersister(new PrivateEntityIdPersisters$propertyIdPersister$1());
  };
  protoOf(PrivateEntityIdPersisters).a4g = function () {
    return new CompressingIdPersister(EntityIdPersisters_instance.x4g());
  };
  protoOf(PrivateEntityIdPersisters).b4g = function () {
    return new CompressingIdPersister(new PrivateEntityIdPersisters$modelBlobIdPersister$1());
  };
  protoOf(PrivateEntityIdPersisters).y4f = function () {
    return new CompressingIdPersister(EntityIdPersisters_instance.y4f());
  };
  var PrivateEntityIdPersisters_instance;
  function PrivateEntityIdPersisters_getInstance() {
    return PrivateEntityIdPersisters_instance;
  }
  function AddModelBlobOperationPersister() {
    ModelBlobOperationPersister.call(this);
    this.e4h_1 = 'am';
    this.f4h_1 = getKClass(AddModelBlobOperation);
  }
  protoOf(AddModelBlobOperationPersister).p2y = function () {
    return this.e4h_1;
  };
  protoOf(AddModelBlobOperationPersister).k4c = function () {
    return this.f4h_1;
  };
  protoOf(AddModelBlobOperationPersister).g4h = function (op) {
    return op instanceof AddModelBlobOperation;
  };
  protoOf(AddModelBlobOperationPersister).h4h = function (modelBlobId, conceptId, nodeId) {
    return AddModelBlobOperation_init_$Create$(modelBlobId, conceptId, nodeId);
  };
  function ChangeModelBlobOperationPersister(rolePersister) {
    TargetedOperationPersister.call(this, rolePersister);
    this.k4h_1 = NodeModelKinds_getInstance().n4h_1;
    this.l4h_1 = 'cm';
    this.m4h_1 = getKClass(ChangeModelBlobOperation);
  }
  protoOf(ChangeModelBlobOperationPersister).e4d = function () {
    return this.k4h_1;
  };
  protoOf(ChangeModelBlobOperationPersister).p2y = function () {
    return this.l4h_1;
  };
  protoOf(ChangeModelBlobOperationPersister).k4c = function () {
    return this.m4h_1;
  };
  protoOf(ChangeModelBlobOperationPersister).g4h = function (op) {
    return op instanceof ChangeModelBlobOperation;
  };
  protoOf(ChangeModelBlobOperationPersister).f4d = function (op) {
    return this.g4h(op);
  };
  protoOf(ChangeModelBlobOperationPersister).r4h = function (role, op) {
    return new ChangeModelBlobOperation(ensureNotNull(role), op);
  };
  protoOf(ChangeModelBlobOperationPersister).g4d = function (role, op) {
    return this.r4h((role == null ? true : role instanceof EntityModelBlobId) ? role : THROW_CCE(), op);
  };
  function ModelBlobOperationPersister() {
  }
  protoOf(ModelBlobOperationPersister).i4h = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.g4h(op)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var modelOp = op instanceof ModelBlobOperation ? op : THROW_CCE();
    var result = new JsonArray();
    result.h2u(ensureNotNull(ctx.b4d(EntityIdModelKinds_getInstance().j37_1, modelOp.z3t())));
    result.h2u(serializeConceptId(ctx, modelOp.r3o()));
    result.h2u(serializeNodeId(ctx, ensureNotNull(modelOp.o3i())));
    return result;
  };
  protoOf(ModelBlobOperationPersister).w4c = function (ctx, op) {
    return this.i4h(ctx, op);
  };
  protoOf(ModelBlobOperationPersister).x4c = function (ctx, json) {
    var modelBlobId = ctx.c4d(EntityIdModelKinds_getInstance().j37_1, json.m2u(0));
    var conceptId = deserializeConceptId(ctx, json.m2u(1));
    var nodeId = deserializeNodeId(ctx, json.m2u(2));
    return this.h4h(modelBlobId, conceptId, nodeId);
  };
  function RemoveModelBlobOperationPersister() {
    ModelBlobOperationPersister.call(this);
    this.s4h_1 = 'rm';
    this.t4h_1 = getKClass(RemoveModelBlobOperation);
  }
  protoOf(RemoveModelBlobOperationPersister).p2y = function () {
    return this.s4h_1;
  };
  protoOf(RemoveModelBlobOperationPersister).k4c = function () {
    return this.t4h_1;
  };
  protoOf(RemoveModelBlobOperationPersister).g4h = function (op) {
    return op instanceof RemoveModelBlobOperation;
  };
  protoOf(RemoveModelBlobOperationPersister).h4h = function (modelBlobId, conceptId, nodeId) {
    return RemoveModelBlobOperation_init_$Create$(modelBlobId, conceptId, nodeId);
  };
  function EntityIdModelKinds() {
    EntityIdModelKinds_instance = this;
    this.f37_1 = new ModelKind('entityId');
    this.g37_1 = new ModelKind('entityConcept');
    this.h37_1 = new ModelKind('entityProperty');
    this.i37_1 = new ModelKind('entityReferenceId');
    this.j37_1 = new ModelKind('modelBlob');
    this.k37_1 = new ModelKind('entityChild');
    this.l37_1 = new ModelKind('entityReference');
  }
  var EntityIdModelKinds_instance;
  function EntityIdModelKinds_getInstance() {
    if (EntityIdModelKinds_instance == null)
      new EntityIdModelKinds();
    return EntityIdModelKinds_instance;
  }
  function EntityModelKinds() {
    EntityModelKinds_instance = this;
    this.r4e_1 = new ModelKind('entity');
    this.s4e_1 = new ModelKind('property');
    this.t4e_1 = new ModelKind('entityReference');
    this.u4e_1 = new ModelKind('children');
  }
  var EntityModelKinds_instance;
  function EntityModelKinds_getInstance() {
    if (EntityModelKinds_instance == null)
      new EntityModelKinds();
    return EntityModelKinds_instance;
  }
  function serializePath($this, rootPathItem, ctx) {
    var result = new JsonArray();
    var item = rootPathItem;
    while (!(item == null)) {
      var value = item.z3v_1;
      if (value instanceof EntityId) {
        result.h2u(ensureNotNull(ctx.m37(EntityIdModelKinds_getInstance().f37_1).x2p(value)));
      } else {
        if (value instanceof EntityChildId) {
          result.h2u(ensureNotNull(ctx.m37(EntityIdModelKinds_getInstance().k37_1).x2p(value)));
        } else {
          throw IllegalStateException_init_$Create$();
        }
      }
      item = item.c17();
    }
    return result;
  }
  function deserializePath($this, array, ctx) {
    // Inline function 'kotlin.check' call
    if (!!(array.wo() === 0)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var entityId = ctx.m37(EntityIdModelKinds_getInstance().f37_1).q2q(array.m2u(0));
    var rolePathItem = deserializeRole($this, array, 1, ctx);
    return new RootPathItem(entityId, rolePathItem);
  }
  function deserializeRole($this, array, index, ctx) {
    var tmp;
    if (index === array.wo()) {
      tmp = null;
    } else {
      var entityChildId = ctx.m37(EntityIdModelKinds_getInstance().k37_1).q2q(array.m2u(index));
      var entityPathItem = deserializeEntity($this, array, index + 1 | 0, ctx);
      tmp = new RolePathItem(entityChildId, entityPathItem);
    }
    return tmp;
  }
  function deserializeEntity($this, array, index, ctx) {
    var tmp;
    if (index === array.wo()) {
      tmp = null;
    } else {
      var entityId = ctx.m37(EntityIdModelKinds_getInstance().f37_1).q2q(array.m2u(index));
      var rolePathItem = deserializeRole($this, array, index + 1 | 0, ctx);
      tmp = new EntityPathItem(entityId, rolePathItem);
    }
    return tmp;
  }
  function MoveOperationPersister() {
    this.u4h_1 = 'm';
    this.v4h_1 = getKClass(MoveOperation);
  }
  protoOf(MoveOperationPersister).p2y = function () {
    return this.u4h_1;
  };
  protoOf(MoveOperationPersister).k4c = function () {
    return this.v4h_1;
  };
  protoOf(MoveOperationPersister).z4e = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof MoveOperation)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    var idPersistenceContext = ctx.m4c_1;
    result.s2t(serializePath(this, op.g3x(), idPersistenceContext));
    result.s2t(serializePath(this, op.h3x(), idPersistenceContext));
    result.s2t(ctx.s4c(EntityModelKinds_getInstance().r4e_1, op.u3w_1));
    return result;
  };
  protoOf(MoveOperationPersister).w4c = function (ctx, op) {
    return this.z4e(ctx, op);
  };
  protoOf(MoveOperationPersister).x4c = function (ctx, json) {
    var destroy = ctx.u4c(EntityModelKinds_getInstance().r4e_1, json.l2u(2));
    var idPersistenceContext = ctx.m4c_1;
    return new MoveOperation(deserializePath(this, json.l2u(0), idPersistenceContext), deserializePath(this, json.l2u(1), idPersistenceContext), destroy);
  };
  function EntityOperationPersistenceContext_init_$Init$(compressor, nodeFactory, $this) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    EntityOperationPersistenceContext.call($this, new EntityIdPersistenceContext(compressor), nodeFactory);
    return $this;
  }
  function EntityOperationPersistenceContext_init_$Create$(compressor, nodeFactory) {
    return EntityOperationPersistenceContext_init_$Init$(compressor, nodeFactory, objectCreate(protoOf(EntityOperationPersistenceContext)));
  }
  function Companion_66() {
    Companion_instance_66 = this;
    this.w4h_1 = new ModelKind('entityContext');
  }
  var Companion_instance_66;
  function Companion_getInstance_66() {
    if (Companion_instance_66 == null)
      new Companion_66();
    return Companion_instance_66;
  }
  function EntityOperationPersistenceContext(idPersistenceContext, nodeFactory) {
    Companion_getInstance_66();
    idPersistenceContext = idPersistenceContext === VOID ? new EntityIdPersistenceContext() : idPersistenceContext;
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    OperationPersistenceContext.call(this, idPersistenceContext);
    this.z4c(Companion_getInstance_66().w4h_1, [new AddRootOperationPersister(), new RemoveRootOperationPersister(), new ChangeRootEntityOperationPersister(), new MoveOperationPersister(), new BuildRootOperationPersister(nodeFactory)]);
    this.z4c(EntityModelKinds_getInstance().r4e_1, [new ChildSetOperationPersister(), new SetReferenceOperationPersister(), new SetPropertyOperationPersister(), new AddModelBlobOperationPersister(), new RemoveModelBlobOperationPersister(), new ChangeModelBlobOperationPersister(idPersistenceContext.m37(EntityIdModelKinds_getInstance().j37_1))]);
    this.z4c(EntityModelKinds_getInstance().s4e_1, [new SetValueOperationPersister(Persisters_getInstance().b2r())]);
    this.z4c(EntityModelKinds_getInstance().t4e_1, [new AddToSetOperationPersister(idPersistenceContext.m37(EntityIdModelKinds_getInstance().l37_1)), new RemoveFromSetOperationPersister(idPersistenceContext.m37(EntityIdModelKinds_getInstance().l37_1))]);
    this.z4c(EntityModelKinds_getInstance().u4e_1, [new AddChildOperationPersister(), new RemoveChildOperationPersister(), new ChangeChildOperationPersister()]);
    this.a4d(new NodeOperationsPersistenceContext(idPersistenceContext.i4g()));
  }
  protoOf(EntityOperationPersistenceContext).d4i = function (operation) {
    return this.s4c(Companion_getInstance_66().w4h_1, operation);
  };
  protoOf(EntityOperationPersistenceContext).e4i = function (array) {
    return this.u4c(Companion_getInstance_66().w4h_1, array);
  };
  function ChildSetOperationPersister() {
    this.f4i_1 = 's';
    this.g4i_1 = getKClass(ChildSetOperation);
  }
  protoOf(ChildSetOperationPersister).p2y = function () {
    return this.f4i_1;
  };
  protoOf(ChildSetOperationPersister).k4c = function () {
    return this.g4i_1;
  };
  protoOf(ChildSetOperationPersister).i4h = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof ChildSetOperation)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    result.h2u(ensureNotNull(ctx.b4d(EntityIdModelKinds_getInstance().k37_1, op.h3b())));
    result.s2t(ctx.s4c(EntityModelKinds_getInstance().u4e_1, op.u3l()));
    return result;
  };
  protoOf(ChildSetOperationPersister).w4c = function (ctx, op) {
    return this.i4h(ctx, op);
  };
  protoOf(ChildSetOperationPersister).x4c = function (ctx, json) {
    var childId = ctx.c4d(EntityIdModelKinds_getInstance().k37_1, json.m2u(0));
    var entitySetOp = ctx.u4c(EntityModelKinds_getInstance().u4e_1, json.l2u(1));
    return new ChildSetOperation(childId, entitySetOp);
  };
  function SetPropertyOperationPersister() {
    this.h4i_1 = 'p';
    this.i4i_1 = getKClass(SetPropertyOperation);
  }
  protoOf(SetPropertyOperationPersister).p2y = function () {
    return this.h4i_1;
  };
  protoOf(SetPropertyOperationPersister).k4c = function () {
    return this.i4i_1;
  };
  protoOf(SetPropertyOperationPersister).i4h = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof SetPropertyOperation)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    result.h2u(ensureNotNull(ctx.b4d(EntityIdModelKinds_getInstance().h37_1, op.h3b())));
    result.s2t(ctx.s4c(EntityModelKinds_getInstance().s4e_1, op.u3l()));
    return result;
  };
  protoOf(SetPropertyOperationPersister).w4c = function (ctx, op) {
    return this.i4h(ctx, op);
  };
  protoOf(SetPropertyOperationPersister).x4c = function (ctx, json) {
    var propertyId = ctx.c4d(EntityIdModelKinds_getInstance().h37_1, json.m2u(0));
    var propOp = ctx.u4c(EntityModelKinds_getInstance().s4e_1, json.l2u(1));
    return new SetPropertyOperation(propertyId, propOp);
  };
  function SetReferenceOperationPersister() {
    this.j4i_1 = 'er';
    this.k4i_1 = getKClass(SetReferenceOperation);
  }
  protoOf(SetReferenceOperationPersister).p2y = function () {
    return this.j4i_1;
  };
  protoOf(SetReferenceOperationPersister).k4c = function () {
    return this.k4i_1;
  };
  protoOf(SetReferenceOperationPersister).i4h = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(op instanceof SetReferenceOperation)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var result = new JsonArray();
    result.h2u(ensureNotNull(ctx.b4d(EntityIdModelKinds_getInstance().i37_1, op.h3b())));
    result.s2t(ctx.s4c(EntityModelKinds_getInstance().t4e_1, op.u3l()));
    return result;
  };
  protoOf(SetReferenceOperationPersister).w4c = function (ctx, op) {
    return this.i4h(ctx, op);
  };
  protoOf(SetReferenceOperationPersister).x4c = function (ctx, json) {
    var referenceId = ctx.c4d(EntityIdModelKinds_getInstance().i37_1, json.m2u(0));
    var refSetOp = ctx.u4c(EntityModelKinds_getInstance().t4e_1, json.l2u(1));
    return new SetReferenceOperation(referenceId, refSetOp);
  };
  function BaseIdPersistenceContext(idCompressor) {
    this.q38_1 = idCompressor;
    this.r38_1 = HashMap_init_$Create$();
    this.s38_1 = ArrayList_init_$Create$();
  }
  protoOf(BaseIdPersistenceContext).k4g = function () {
    return this.q38_1;
  };
  protoOf(BaseIdPersistenceContext).j4g = function () {
    return this.s38_1;
  };
  protoOf(BaseIdPersistenceContext).x4f = function (kind, persister) {
    // Inline function 'kotlin.check' call
    if (!!this.r38_1.w2(kind)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.BaseIdPersistenceContext.add.<anonymous>' call
      var message = kind.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (persister instanceof CompressingIdPersister) {
      (persister instanceof CompressingIdPersister ? persister : THROW_CCE()).o4i(this.k4g());
    }
    // Inline function 'kotlin.collections.set' call
    this.r38_1.r2(kind, persister);
  };
  protoOf(BaseIdPersistenceContext).e4g = function (delegate) {
    this.s38_1.e(delegate);
  };
  protoOf(BaseIdPersistenceContext).m37 = function (kind) {
    var persister = this.r38_1.y2(kind);
    var _iterator__ex2g4s = this.s38_1.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var delegate = _iterator__ex2g4s.m();
      if (!(persister == null)) {
        break $l$loop;
      }
      persister = delegate.m37(kind);
    }
    var tmp0 = persister;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.BaseIdPersistenceContext.get.<anonymous>' call
        var message = 'Unknown id persister kind ' + kind.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return (!(persister == null) ? isInterface(persister, Persister) : false) ? persister : THROW_CCE();
  };
  function BulkUpdateIdCompressor_init_$Init$(initialIdToShortcutMap, shortcutsPersister, $this) {
    BulkUpdateIdCompressor_init_$Init$_0(initialIdToShortcutMap, shortcutsPersister, HashMap_init_$Create$(), $this);
    return $this;
  }
  function BulkUpdateIdCompressor_init_$Init$_0(initialIdToShortcutMap, shortcutsPersister, updateMap, $this) {
    SelfUpdatingIdCompressor_init_$Init$(initialIdToShortcutMap, new MyPersister(updateMap), $this);
    BulkUpdateIdCompressor.call($this);
    $this.z4d_1 = updateMap;
    $this.a4e_1 = shortcutsPersister;
    return $this;
  }
  function rollbackUpdate($this, updateData) {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = updateData.w().k();
    while (_iterator__ex2g4s.l()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.x();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.y();
      $this.p4i(key, value);
    }
  }
  function MyPersister(map) {
    this.q4i_1 = map;
  }
  protoOf(MyPersister).r4i = function (id, shortcut) {
    // Inline function 'kotlin.collections.set' call
    this.q4i_1.r2(id, shortcut);
    return true;
  };
  protoOf(BulkUpdateIdCompressor).s4i = function () {
    return this.b4e_1;
  };
  protoOf(BulkUpdateIdCompressor).c4e = function () {
    // Inline function 'kotlin.check' call
    if (!!this.s4i()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.BulkUpdateIdCompressor.startUpdate.<anonymous>' call
      var message = 'Multiple updates are not allowed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.b4e_1 = true;
    this.z4d_1.m2();
  };
  protoOf(BulkUpdateIdCompressor).t4i = function (commit) {
    // Inline function 'kotlin.check' call
    if (!this.s4i()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.BulkUpdateIdCompressor.finishUpdate.<anonymous>' call
      var message = 'IdCompressor is not updating';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.b4e_1 = false;
    try {
      if (commit) {
        this.a4e_1(HashMap_init_$Create$_1(this.z4d_1));
      } else {
        rollbackUpdate(this, this.z4d_1);
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        rollbackUpdate(this, this.z4d_1);
        throw t;
      } else {
        throw $p;
      }
    }
    finally {
      this.z4d_1.m2();
    }
  };
  function BulkUpdateIdCompressor() {
    this.b4e_1 = false;
  }
  function baseSerialize($this, value) {
    return $this.l4i_1.o2q(value);
  }
  function pack($this, value) {
    return ensureNotNull($this.m4i_1).b4j(ensureNotNull(value));
  }
  function canBePacked($this, id) {
    return !($this.m4i_1 == null) && ensureNotNull($this.m4i_1).a4j(baseSerialize($this, id));
  }
  function CompressingIdPersister(basePersister) {
    this.l4i_1 = basePersister;
    this.m4i_1 = null;
    this.n4i_1 = new ExceptionNullPersister();
  }
  protoOf(CompressingIdPersister).n2q = function () {
    return this.n4i_1;
  };
  protoOf(CompressingIdPersister).o4i = function (context) {
    this.m4i_1 = context;
  };
  protoOf(CompressingIdPersister).p2q = function (value) {
    var valueStr = value;
    if (!(this.m4i_1 == null)) {
      valueStr = ensureNotNull(this.m4i_1).d4j(ensureNotNull(valueStr));
    }
    return this.l4i_1.q2q(valueStr);
  };
  protoOf(CompressingIdPersister).b4h = function (value) {
    var serialized = baseSerialize(this, value);
    return canBePacked(this, value) ? pack(this, serialized) : serialized;
  };
  protoOf(CompressingIdPersister).o2q = function (value) {
    return this.b4h(value instanceof BaseId ? value : THROW_CCE());
  };
  function DefaultIdPersister() {
    this.a4h_1 = new NullPersisterForNullable();
  }
  protoOf(DefaultIdPersister).p2q = function (value) {
    return this.z4g(value);
  };
  protoOf(DefaultIdPersister).b4h = function (value) {
    return value.i2s_1;
  };
  protoOf(DefaultIdPersister).o2q = function (value) {
    return this.b4h(value instanceof BaseId ? value : THROW_CCE());
  };
  protoOf(DefaultIdPersister).n2q = function () {
    return this.a4h_1;
  };
  function DefaultSelfUpdatingIdCompressor$Companion$consumer$o($map) {
    return function (value) {
      $map.t2(value);
      return Unit_instance;
    };
  }
  function DefaultSelfUpdatingIdCompressor_init_$Init$(initialIdToShortcutMap, $this) {
    initialIdToShortcutMap = initialIdToShortcutMap === VOID ? emptyMap() : initialIdToShortcutMap;
    DefaultSelfUpdatingIdCompressor.call($this, HashMap_init_$Create$(), initialIdToShortcutMap);
    return $this;
  }
  function DefaultSelfUpdatingIdCompressor_init_$Create$(initialIdToShortcutMap) {
    return DefaultSelfUpdatingIdCompressor_init_$Init$(initialIdToShortcutMap, objectCreate(protoOf(DefaultSelfUpdatingIdCompressor)));
  }
  function Companion_67() {
  }
  protoOf(Companion_67).f4j = function (map) {
    return DefaultSelfUpdatingIdCompressor$Companion$consumer$o(map);
  };
  var Companion_instance_67;
  function Companion_getInstance_67() {
    return Companion_instance_67;
  }
  function DefaultSelfUpdatingIdCompressor(idToShortcutUpdate, initialIdToShortcutMap) {
    BulkUpdateIdCompressor_init_$Init$(initialIdToShortcutMap, Companion_instance_67.f4j(idToShortcutUpdate), this);
    this.k4e_1 = idToShortcutUpdate;
  }
  protoOf(DefaultSelfUpdatingIdCompressor).l4e = function () {
    // Inline function 'kotlin.check' call
    if (!this.s4i()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.DefaultSelfUpdatingIdCompressor.finishUpdateAndPopResult.<anonymous>' call
      var message = 'Attempt to get update from non-updating compressor';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.t4i(true);
    var changes = HashMap_init_$Create$_1(this.k4e_1);
    this.k4e_1.m2();
    return changes;
  };
  function IdCompressor_init_$Init$($this) {
    IdCompressor.call($this);
    return $this;
  }
  function IdCompressor_init_$Init$_0(initialIdToShortcutMap, $this) {
    IdCompressor.call($this);
    var _iterator__ex2g4s = initialIdToShortcutMap.u2().k();
    while (_iterator__ex2g4s.l()) {
      var id = _iterator__ex2g4s.m();
      $this.e4j(id, getValue_0(initialIdToShortcutMap, id));
    }
    return $this;
  }
  protoOf(IdCompressor).b4j = function (id) {
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = this.i4d_1.y2(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.IdCompressor.pack.<anonymous>' call
      tmp = this.y4i(id);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(IdCompressor).c4j = function (id) {
    return this.i4d_1.y2(id);
  };
  protoOf(IdCompressor).d4j = function (shortcut) {
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = this.j4d_1.y2(shortcut);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.IdCompressor.unpack.<anonymous>' call
      tmp = this.z4i(shortcut);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(IdCompressor).e4j = function (id, shortcut) {
    // Inline function 'kotlin.check' call
    if (!!this.i4d_1.w2(id)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.IdCompressor.put.<anonymous>' call
      var message = 'Id is already registered: ' + id;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!!this.j4d_1.w2(shortcut)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.IdCompressor.put.<anonymous>' call
      var message_0 = 'Shortcut already used: ' + shortcut;
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.collections.set' call
    this.i4d_1.r2(id, shortcut);
    // Inline function 'kotlin.collections.set' call
    this.j4d_1.r2(shortcut, id);
  };
  protoOf(IdCompressor).p4i = function (id, shortcut) {
    // Inline function 'kotlin.check' call
    if (!this.i4d_1.w2(id)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.IdCompressor.remove.<anonymous>' call
      var message = 'Id is not registered: ' + id;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!this.j4d_1.w2(shortcut)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.IdCompressor.remove.<anonymous>' call
      var message_0 = 'Shortcut was not assigned: ' + shortcut;
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    this.i4d_1.s2(id);
    this.j4d_1.s2(shortcut);
  };
  protoOf(IdCompressor).wo = function () {
    return this.i4d_1.n();
  };
  protoOf(IdCompressor).m2 = function () {
    this.i4d_1.m2();
    this.j4d_1.m2();
  };
  protoOf(IdCompressor).a4j = function (id) {
    return this.i4d_1.w2(id);
  };
  function IdCompressor() {
    this.i4d_1 = HashMap_init_$Create$();
    this.j4d_1 = HashMap_init_$Create$();
  }
  function NullableIdPersister() {
  }
  protoOf(NullableIdPersister).w2p = function (value) {
    return this.g4j(value);
  };
  protoOf(NullableIdPersister).h4j = function (value) {
    return value.i2s_1;
  };
  protoOf(NullableIdPersister).x2p = function (value) {
    return this.h4j(value instanceof BaseId ? value : THROW_CCE());
  };
  function IdPersisters$ENTITY_ID_PERSISTER$1() {
    NullableIdPersister.call(this);
  }
  protoOf(IdPersisters$ENTITY_ID_PERSISTER$1).g4j = function (id) {
    return EntityId_init_$Create$_0(id);
  };
  function IdPersisters$NODE_ID_PERSISTER$1() {
    NullableIdPersister.call(this);
  }
  protoOf(IdPersisters$NODE_ID_PERSISTER$1).g4j = function (id) {
    return new NodeId(id);
  };
  function IdPersisters() {
    IdPersisters_instance = this;
    var tmp = this;
    tmp.i4j_1 = new IdPersisters$ENTITY_ID_PERSISTER$1();
    var tmp_0 = this;
    tmp_0.j4j_1 = new IdPersisters$NODE_ID_PERSISTER$1();
  }
  protoOf(IdPersisters).k4j = function () {
    return toNonNullPersister(this.j4j_1);
  };
  protoOf(IdPersisters).l4j = function () {
    return toNullablePersister(this.j4j_1, new EmptyStringNullPersister());
  };
  var IdPersisters_instance;
  function IdPersisters_getInstance() {
    if (IdPersisters_instance == null)
      new IdPersisters();
    return IdPersisters_instance;
  }
  function flagsToPrefix($this, flags) {
    if (flags.p())
      return '';
    var allFlags = $this.t4f();
    var r = StringBuilder_init_$Create$(allFlags.length);
    var inductionVariable = 0;
    var last = allFlags.length;
    while (inductionVariable < last) {
      var f = allFlags[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (flags.s(f)) {
        r.e9(_Char___init__impl__6a9atx(42));
      } else {
        r.e9(_Char___init__impl__6a9atx(126));
      }
    }
    r.m1();
    var i = 0;
    $l$loop: while (i < r.a() && r.b(i) !== _Char___init__impl__6a9atx(42)) {
      i = i + 1 | 0;
    }
    return r.fd(i);
  }
  function prefixToFlags($this, prefix) {
    var flags = HashSet_init_$Create$();
    var allFlags = $this.t4f();
    // Inline function 'kotlin.require' call
    if (!(prefix.length <= allFlags.length)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.MetaIdPersister.prefixToFlags.<anonymous>' call
      var message = 'Prefix has more positions than flag values: ' + prefix;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var inductionVariable = 0;
    var last = charSequenceLength(prefix) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charSequenceGet(prefix, (prefix.length - i | 0) - 1 | 0) === _Char___init__impl__6a9atx(42)) {
          flags.e(allFlags[i]);
        }
      }
       while (inductionVariable <= last);
    return flags;
  }
  function Companion_68() {
    Companion_instance_68 = this;
    this.m4j_1 = _Char___init__impl__6a9atx(42);
    this.n4j_1 = _Char___init__impl__6a9atx(126);
  }
  var Companion_instance_68;
  function Companion_getInstance_68() {
    if (Companion_instance_68 == null)
      new Companion_68();
    return Companion_instance_68;
  }
  function MetaIdPersister() {
    Companion_getInstance_68();
    this.u4f_1 = new ExceptionNullPersister();
  }
  protoOf(MetaIdPersister).p2q = function (value) {
    var tmp0 = lastIndexOf_2(value, _Char___init__impl__6a9atx(42));
    // Inline function 'kotlin.math.max' call
    var b = lastIndexOf_2(value, _Char___init__impl__6a9atx(126));
    var i = Math.max(tmp0, b);
    var id;
    var flags;
    if (i < 0) {
      id = value;
      flags = emptySet();
    } else {
      // Inline function 'kotlin.text.substring' call
      var startIndex = i + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      id = value.substring(startIndex);
      flags = prefixToFlags(this, take_1(value, i + 1 | 0));
    }
    return this.s4f(id, flags);
  };
  protoOf(MetaIdPersister).v4f = function (value) {
    var id = value.i2s_1;
    // Inline function 'kotlin.require' call
    if (!(indexOf_8(id, _Char___init__impl__6a9atx(42)) < 0 && indexOf_8(id, _Char___init__impl__6a9atx(126)) < 0)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.MetaIdPersister.serializeNonNull.<anonymous>' call
      var message = "Meta id cannot contain '*' or '~': " + toString_1(value);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return flagsToPrefix(this, value.s33()) + id;
  };
  protoOf(MetaIdPersister).o2q = function (value) {
    return this.v4f(value instanceof MetaId ? value : THROW_CCE());
  };
  protoOf(MetaIdPersister).n2q = function () {
    return this.u4f_1;
  };
  function nullIdCompressorSupplier() {
    return nullIdCompressorSupplier$lambda;
  }
  function nullIdCompressorSupplier$lambda() {
    return null;
  }
  function RoleIdPersister() {
    MetaIdPersister.call(this);
    this.p4g_1 = values_2();
  }
  protoOf(RoleIdPersister).t4f = function () {
    return this.p4g_1;
  };
  function SelfUpdatingIdCompressor_init_$Init$(initialIdToShortcutMap, callback, $this) {
    IdCompressor_init_$Init$_0(initialIdToShortcutMap, $this);
    SelfUpdatingIdCompressor.call($this);
    $this.x4i_1 = callback;
    return $this;
  }
  protoOf(SelfUpdatingIdCompressor).y4i = function (id) {
    var shortcut = this.c4j(id);
    if (!(shortcut == null)) {
      return shortcut;
    }
    // Inline function 'kotlin.check' call
    if (!this.s4i()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.id.SelfUpdatingIdCompressor.packNew.<anonymous>' call
      var message = 'Attempt to modify id dictionary without collecting changes';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    shortcut = this.w4i_1.q4j(this.wo());
    var result = this.x4i_1.r4i(id, shortcut);
    if (!result) {
      return id;
    }
    this.e4j(id, shortcut);
    return shortcut;
  };
  protoOf(SelfUpdatingIdCompressor).z4i = function (shortcut) {
    return shortcut;
  };
  protoOf(SelfUpdatingIdCompressor).k4d = function (patch) {
    throw IllegalStateException_init_$Create$_0('Attempt to update non-updatable id compressor');
  };
  protoOf(SelfUpdatingIdCompressor).a4j = function (id) {
    return this.s4i() || protoOf(IdCompressor).a4j.call(this, id);
  };
  function SelfUpdatingIdCompressor() {
    this.w4i_1 = new ShortcutConverter();
  }
  function addChars($this, from, to) {
    var inductionVariable = from;
    if (inductionVariable < to)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        $this.p4j_1.e(new Char(numberToChar(i)));
      }
       while (inductionVariable < to);
  }
  function ShortcutConverter() {
    this.p4j_1 = ArrayList_init_$Create$();
    addChars(this, 48, 58);
    addChars(this, 65, 91);
    addChars(this, 97, 123);
    this.o4j_1 = this.p4j_1.n();
  }
  protoOf(ShortcutConverter).q4j = function (i) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(i >= 0)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var sb = StringBuilder_init_$Create$_1();
    var current = i;
    do {
      sb.e9(this.p4j_1.q(current % this.o4j_1 | 0).v1_1);
      current = current / this.o4j_1 | 0;
    }
     while (!(current === 0));
    // Inline function 'kotlin.text.reversed' call
    var this_0 = sb.toString();
    return toString_1(reversed_1(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  };
  function UpdatableIdCompressor() {
    IdCompressor_init_$Init$(this);
  }
  protoOf(UpdatableIdCompressor).y4i = function (id) {
    return id;
  };
  protoOf(UpdatableIdCompressor).z4i = function (shortcut) {
    throw IllegalStateException_init_$Create$_0('Unregistered shortcut ' + shortcut);
  };
  protoOf(UpdatableIdCompressor).k4d = function (patch) {
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = patch.w().k();
    while (_iterator__ex2g4s.l()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.x();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.y();
      this.e4j(key, value);
    }
  };
  protoOf(UpdatableIdCompressor).a4j = function (id) {
    return true;
  };
  function ModelKind(name) {
    this.t4j_1 = name;
  }
  protoOf(ModelKind).toString = function () {
    return this.t4j_1;
  };
  function AddChildOperationPersister_0() {
    ChildOperationPersister_0.call(this);
    this.u4j_1 = 'a';
    this.v4j_1 = getKClass(AddChildOperation_0);
  }
  protoOf(AddChildOperationPersister_0).p2y = function () {
    return this.u4j_1;
  };
  protoOf(AddChildOperationPersister_0).k4c = function () {
    return this.v4j_1;
  };
  protoOf(AddChildOperationPersister_0).w4j = function (op) {
    return op instanceof AddChildOperation_0;
  };
  protoOf(AddChildOperationPersister_0).x4j = function (conceptId, nodeId, index, isSingleRole) {
    return AddChildOperation_init_$Create$_1(conceptId, nodeId, index, isSingleRole);
  };
  function ChangeChildOperationPersister_0() {
    this.z4j_1 = 'cc';
    this.a4k_1 = getKClass(ChangeChildOperation_0);
  }
  protoOf(ChangeChildOperationPersister_0).p2y = function () {
    return this.z4j_1;
  };
  protoOf(ChangeChildOperationPersister_0).k4c = function () {
    return this.a4k_1;
  };
  protoOf(ChangeChildOperationPersister_0).y4j = function (ctx, op) {
    if (op instanceof ChangeChildOperation_0) {
      var result = new JsonArray();
      result.h2u(serializeNodeId(ctx, ensureNotNull(op.m44_1)));
      result.h2u(ensureNotNull(Persisters_getInstance().j2q().x2p(op.h3b())));
      result.s2t(ctx.s4c(NodeModelKinds_getInstance().o4h_1, op.u3l()));
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(ChangeChildOperationPersister_0).w4c = function (ctx, op) {
    return this.y4j(ctx, op);
  };
  protoOf(ChangeChildOperationPersister_0).x4c = function (ctx, json) {
    var nodeId = deserializeNodeId(ctx, json.m2u(0));
    var childIndex = Persisters_getInstance().j2q().q2q(json.m2u(1));
    var nodeOp = ctx.u4c(NodeModelKinds_getInstance().o4h_1, json.l2u(2));
    return new ChangeChildOperation_0(nodeId, childIndex, nodeOp);
  };
  function ChildOperationPersister_0() {
  }
  protoOf(ChildOperationPersister_0).y4j = function (ctx, op) {
    if (this.w4j(op)) {
      var chOp = op instanceof ChildOperation_0 ? op : THROW_CCE();
      var result = new JsonArray();
      // Inline function 'kotlin.with' call
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.node.childOperations.ChildOperationPersister.serialize.<anonymous>' call
      result.h2u(serializeConceptId(ctx, chOp.h3f()));
      result.h2u(serializeNodeId(ctx, ensureNotNull(chOp.x3i())));
      result.h2u(ensureNotNull(Persisters_getInstance().j2q().x2p(chOp.i3b())));
      if (chOp.t43_1) {
        result.i2u(0.0);
      }
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(ChildOperationPersister_0).w4c = function (ctx, op) {
    return this.y4j(ctx, op);
  };
  protoOf(ChildOperationPersister_0).x4c = function (ctx, json) {
    var conceptId = deserializeConceptId(ctx, json.m2u(0));
    var nodeId = deserializeNodeId(ctx, json.m2u(1));
    var index = Persisters_getInstance().j2q().q2q(json.m2u(2));
    var isSingleRole = json.wo() === 4;
    return this.x4j(conceptId, nodeId, index, isSingleRole);
  };
  function RemoveChildOperationPersister_0() {
    ChildOperationPersister_0.call(this);
    this.b4k_1 = 'r';
    this.c4k_1 = getKClass(RemoveChildOperation_0);
  }
  protoOf(RemoveChildOperationPersister_0).p2y = function () {
    return this.b4k_1;
  };
  protoOf(RemoveChildOperationPersister_0).k4c = function () {
    return this.c4k_1;
  };
  protoOf(RemoveChildOperationPersister_0).w4j = function (op) {
    return op instanceof RemoveChildOperation_0;
  };
  protoOf(RemoveChildOperationPersister_0).x4j = function (conceptId, nodeId, index, isSingleRole) {
    return RemoveChildOperation_init_$Create$_1(conceptId, nodeId, index, isSingleRole);
  };
  function getConceptIdPersister($this, ctx) {
    return ctx.m4c_1.m37(NodeIdModelKinds_getInstance().w37_1);
  }
  function getNodeIdPersister($this, ctx) {
    return ctx.m4c_1.m37(NodeIdModelKinds_getInstance().u37_1);
  }
  function ReplaceChildOperationPersister() {
    this.d4k_1 = 'rep';
    this.e4k_1 = getKClass(ReplaceChildOperation);
  }
  protoOf(ReplaceChildOperationPersister).p2y = function () {
    return this.d4k_1;
  };
  protoOf(ReplaceChildOperationPersister).k4c = function () {
    return this.e4k_1;
  };
  protoOf(ReplaceChildOperationPersister).y4j = function (ctx, op) {
    if (op instanceof ReplaceChildOperation) {
      var conceptIdPersister = getConceptIdPersister(this, ctx);
      var nodeIdPersister = getNodeIdPersister(this, ctx);
      var result = new JsonArray();
      result.h2u(ensureNotNull(conceptIdPersister.x2p(op.n3o())));
      result.h2u(ensureNotNull(nodeIdPersister.x2p(ensureNotNull(op.p44()))));
      result.h2u(ensureNotNull(conceptIdPersister.x2p(op.o3o())));
      result.h2u(ensureNotNull(nodeIdPersister.x2p(ensureNotNull(op.c44()))));
      result.h2u(ensureNotNull(Persisters_getInstance().j2q().x2p(op.i3b())));
      if (op.t43_1) {
        result.i2u(0.0);
      }
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(ReplaceChildOperationPersister).w4c = function (ctx, op) {
    return this.y4j(ctx, op);
  };
  protoOf(ReplaceChildOperationPersister).x4c = function (ctx, json) {
    var conceptIdPersister = getConceptIdPersister(this, ctx);
    var nodeIdPersister = getNodeIdPersister(this, ctx);
    var oldConceptId = conceptIdPersister.q2q(json.m2u(0));
    var oldId = nodeIdPersister.q2q(json.m2u(1));
    var newConceptId = conceptIdPersister.q2q(json.m2u(2));
    var newId = nodeIdPersister.q2q(json.m2u(3));
    var index = Persisters_getInstance().j2q().q2q(json.m2u(4));
    var isSingleRole = json.wo() === 6;
    return ReplaceChildOperation_init_$Create$(oldConceptId, oldId, newConceptId, newId, index, isSingleRole);
  };
  function serializeConceptId(_this__u8e3s4, nodeConceptId) {
    return ensureNotNull(_this__u8e3s4.b4d(NodeIdModelKinds_getInstance().w37_1, nodeConceptId));
  }
  function serializeNodeId(_this__u8e3s4, nodeId) {
    return ensureNotNull(_this__u8e3s4.b4d(NodeIdModelKinds_getInstance().u37_1, nodeId));
  }
  function deserializeConceptId(_this__u8e3s4, value) {
    return _this__u8e3s4.c4d(NodeIdModelKinds_getInstance().w37_1, value);
  }
  function deserializeNodeId(_this__u8e3s4, value) {
    return _this__u8e3s4.c4d(NodeIdModelKinds_getInstance().u37_1, value);
  }
  function NodeConceptIdPersister() {
    MetaIdPersister.call(this);
    this.g4k_1 = values_1();
  }
  protoOf(NodeConceptIdPersister).t4f = function () {
    return this.g4k_1;
  };
  protoOf(NodeConceptIdPersister).h4k = function (id, flags) {
    return NodeConceptIdFactory_getInstance().n3c(id, null, flags);
  };
  protoOf(NodeConceptIdPersister).s4f = function (id, flags) {
    return this.h4k(id, flags);
  };
  function NodeIdPersistenceContext(idCompressor) {
    idCompressor = idCompressor === VOID ? null : idCompressor;
    BaseIdPersistenceContext.call(this, idCompressor);
    this.x4f(NodeIdModelKinds_getInstance().u37_1, IdPersisters_getInstance().k4j());
    this.x4f(NodeIdModelKinds_getInstance().v37_1, IdPersisters_getInstance().l4j());
    this.x4f(NodeIdModelKinds_getInstance().w37_1, PrivateNodeIdPersisters_instance.y4f());
    this.x4f(NodeIdModelKinds_getInstance().x37_1, PrivateNodeIdPersisters_instance.z4f());
    this.x4f(NodeIdModelKinds_getInstance().y37_1, PrivateNodeIdPersisters_instance.c4g());
  }
  function NodeIdPersisters$childIdPersister$1() {
    RoleIdPersister.call(this);
  }
  protoOf(NodeIdPersisters$childIdPersister$1).n4g = function (id, flags) {
    return NodeChildIdFactory_getInstance().d3c(id, null, flags);
  };
  protoOf(NodeIdPersisters$childIdPersister$1).s4f = function (id, flags) {
    return this.n4g(id, flags);
  };
  function NodeIdPersisters() {
  }
  protoOf(NodeIdPersisters).y4f = function () {
    return new NodeConceptIdPersister();
  };
  protoOf(NodeIdPersisters).c4g = function () {
    return new NodeIdPersisters$childIdPersister$1();
  };
  var NodeIdPersisters_instance;
  function NodeIdPersisters_getInstance() {
    return NodeIdPersisters_instance;
  }
  function PrivateNodeIdPersisters$propertyIdPersister$basePersister$1() {
    DefaultIdPersister.call(this);
  }
  protoOf(PrivateNodeIdPersisters$propertyIdPersister$basePersister$1).z4g = function (id) {
    return NodePropertyIdFactory_getInstance().x3c(id);
  };
  function PrivateNodeIdPersisters() {
  }
  protoOf(PrivateNodeIdPersisters).y4f = function () {
    return new CompressingIdPersister(NodeIdPersisters_instance.y4f());
  };
  protoOf(PrivateNodeIdPersisters).z4f = function () {
    var basePersister = new PrivateNodeIdPersisters$propertyIdPersister$basePersister$1();
    return new CompressingIdPersister(basePersister);
  };
  protoOf(PrivateNodeIdPersisters).c4g = function () {
    return new CompressingIdPersister(NodeIdPersisters_instance.c4g());
  };
  var PrivateNodeIdPersisters_instance;
  function PrivateNodeIdPersisters_getInstance() {
    return PrivateNodeIdPersisters_instance;
  }
  function NodeIdModelKinds() {
    NodeIdModelKinds_instance = this;
    this.u37_1 = new ModelKind('nodeId');
    this.v37_1 = new ModelKind('nullableNodeId');
    this.w37_1 = new ModelKind('nodeConceptId');
    this.x37_1 = new ModelKind('nodePropertyId');
    this.y37_1 = new ModelKind('nodeChildId');
  }
  var NodeIdModelKinds_instance;
  function NodeIdModelKinds_getInstance() {
    if (NodeIdModelKinds_instance == null)
      new NodeIdModelKinds();
    return NodeIdModelKinds_instance;
  }
  function NodeModelKinds() {
    NodeModelKinds_instance = this;
    this.n4h_1 = new ModelKind('model');
    this.o4h_1 = new ModelKind('node');
    this.p4h_1 = new ModelKind('nodeChildren');
    this.q4h_1 = new ModelKind('nodeProperty');
  }
  var NodeModelKinds_instance;
  function NodeModelKinds_getInstance() {
    if (NodeModelKinds_instance == null)
      new NodeModelKinds();
    return NodeModelKinds_instance;
  }
  function ChangePropertyOperationPersister() {
    this.l4k_1 = 'cp';
    this.m4k_1 = getKClass(ChangePropertyOperation);
  }
  protoOf(ChangePropertyOperationPersister).p2y = function () {
    return this.l4k_1;
  };
  protoOf(ChangePropertyOperationPersister).k4c = function () {
    return this.m4k_1;
  };
  protoOf(ChangePropertyOperationPersister).n4k = function (ctx, op) {
    if (op instanceof ChangePropertyOperation) {
      var result = new JsonArray();
      result.h2u(ensureNotNull(ctx.b4d(NodeIdModelKinds_getInstance().x37_1, op.h3b())));
      result.s2t(ctx.s4c(NodeModelKinds_getInstance().q4h_1, op.u3l()));
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(ChangePropertyOperationPersister).w4c = function (ctx, op) {
    return this.n4k(ctx, op);
  };
  protoOf(ChangePropertyOperationPersister).x4c = function (ctx, json) {
    var propertyId = ctx.c4d(NodeIdModelKinds_getInstance().x37_1, json.m2u(0));
    var op = ctx.u4c(NodeModelKinds_getInstance().q4h_1, json.l2u(1));
    return new ChangePropertyOperation(propertyId, op);
  };
  function ChildListOperationPersister(rolePersister) {
    TargetedOperationPersister.call(this, rolePersister);
    this.p4k_1 = 'sc';
    this.q4k_1 = getKClass(ChildListOperation);
    this.r4k_1 = NodeModelKinds_getInstance().p4h_1;
  }
  protoOf(ChildListOperationPersister).p2y = function () {
    return this.p4k_1;
  };
  protoOf(ChildListOperationPersister).k4c = function () {
    return this.q4k_1;
  };
  protoOf(ChildListOperationPersister).s4k = function (op) {
    return op instanceof ChildListOperation;
  };
  protoOf(ChildListOperationPersister).f4d = function (op) {
    return this.s4k(op);
  };
  protoOf(ChildListOperationPersister).e4d = function () {
    return this.r4k_1;
  };
  protoOf(ChildListOperationPersister).t4k = function (role, op) {
    return new ChildListOperation(ensureNotNull(role), op);
  };
  protoOf(ChildListOperationPersister).g4d = function (role, op) {
    return this.t4k((role == null ? true : role instanceof NodeChildId) ? role : THROW_CCE(), op);
  };
  function NodeOperationsPersistenceContext(idPersistenceContext) {
    OperationPersistenceContext.call(this, idPersistenceContext);
    this.z4c(NodeModelKinds_getInstance().n4h_1, [new SetModelOperationPersister()]);
    this.z4c(NodeModelKinds_getInstance().o4h_1, [new ChildListOperationPersister(idPersistenceContext.m37(NodeIdModelKinds_getInstance().y37_1)), new ChangePropertyOperationPersister()]);
    this.z4c(NodeModelKinds_getInstance().p4h_1, [new AddChildOperationPersister_0(), new RemoveChildOperationPersister_0(), new ChangeChildOperationPersister_0(), new ReplaceChildOperationPersister(), new AddChildSplitPropertyOperationPersister(), new AddChildSplitChildCollectionOperationPersister(), new MergePropertyRemoveChildOperationPersister(), new MergeChildCollectionRemoveChildOperationPersister()]);
    this.z4c(NodeModelKinds_getInstance().q4h_1, [new SetValueOperationPersister(Persisters_getInstance().b2r()), new InsertTextOperationsPersister(), new DeleteTextOperationPersister()]);
  }
  function SetModelOperationPersister() {
    TargetedOperationPersister.call(this, Persisters_getInstance().a2r());
    this.v4k_1 = NodeModelKinds_getInstance().o4h_1;
    this.w4k_1 = 'sm';
    this.x4k_1 = getKClass(SetModelOperation);
  }
  protoOf(SetModelOperationPersister).e4d = function () {
    return this.v4k_1;
  };
  protoOf(SetModelOperationPersister).p2y = function () {
    return this.w4k_1;
  };
  protoOf(SetModelOperationPersister).k4c = function () {
    return this.x4k_1;
  };
  protoOf(SetModelOperationPersister).y4k = function (op) {
    return op instanceof SetModelOperation;
  };
  protoOf(SetModelOperationPersister).f4d = function (op) {
    return this.y4k(op);
  };
  protoOf(SetModelOperationPersister).z4k = function (role, op) {
    return new SetModelOperation(op);
  };
  protoOf(SetModelOperationPersister).g4d = function (role, op) {
    return this.z4k((role == null ? true : typeof role === 'string') ? role : THROW_CCE(), op);
  };
  function AddChildSplitChildCollectionOperationPersister() {
    BaseAddChildSplitOperationPersister.call(this);
    this.a4l_1 = 'acscc';
    this.b4l_1 = getKClass(AddChildSplitChildCollectionOperation);
  }
  protoOf(AddChildSplitChildCollectionOperationPersister).c4l = function (op) {
    return (op instanceof AddChildSplitChildCollectionOperation ? op : THROW_CCE()).q3n_1;
  };
  protoOf(AddChildSplitChildCollectionOperationPersister).d4l = function (op) {
    return op instanceof AddChildSplitChildCollectionOperation;
  };
  protoOf(AddChildSplitChildCollectionOperationPersister).e4l = function (ctx, op) {
    var splitOp = op instanceof AddChildSplitChildCollectionOperation ? op : THROW_CCE();
    var res = new JsonArray();
    res.h2u(ensureNotNull(Persisters_getInstance().j2q().x2p(splitOp.m4a_1)));
    res.h2u(ensureNotNull(ctx.b4d(NodeIdModelKinds_getInstance().y37_1, splitOp.l4a_1)));
    return res;
  };
  protoOf(AddChildSplitChildCollectionOperationPersister).f4l = function (data, ctx) {
    var additionalData = data.l4l_1;
    var splitSize = Persisters_getInstance().j2q().q2q(additionalData.m2u(0));
    var childId = ctx.m37(NodeIdModelKinds_getInstance().y37_1).q2q(additionalData.m2u(1));
    return new AddChildSplitChildCollectionOperation(data.g4l_1, data.h4l_1, data.i4l_1, data.j4l_1, childId, data.k4l_1, splitSize);
  };
  protoOf(AddChildSplitChildCollectionOperationPersister).p2y = function () {
    return this.a4l_1;
  };
  protoOf(AddChildSplitChildCollectionOperationPersister).k4c = function () {
    return this.b4l_1;
  };
  function AddChildSplitPropertyOperationPersister() {
    BaseAddChildSplitOperationPersister.call(this);
    this.m4l_1 = 'acsp';
    this.n4l_1 = getKClass(AddChildSplitPropertyOperation);
  }
  protoOf(AddChildSplitPropertyOperationPersister).c4l = function (op) {
    var splitOp = op instanceof AddChildSplitPropertyOperation ? op : THROW_CCE();
    return splitOp.z4a() ? -1 : splitOp.q3n_1;
  };
  protoOf(AddChildSplitPropertyOperationPersister).d4l = function (op) {
    return op instanceof AddChildSplitPropertyOperation;
  };
  protoOf(AddChildSplitPropertyOperationPersister).e4l = function (ctx, op) {
    var splitOp = op instanceof AddChildSplitPropertyOperation ? op : THROW_CCE();
    var res = new JsonArray();
    res.h2u(ensureNotNull(ctx.b4d(NodeIdModelKinds_getInstance().x37_1, splitOp.d3o_1)));
    res.h2u(ensureNotNull(Persisters_getInstance().a2r().x2p(splitOp.f3o_1)));
    return res;
  };
  protoOf(AddChildSplitPropertyOperationPersister).f4l = function (data, ctx) {
    var additionalData = data.l4l_1;
    var propertyId = ctx.m37(NodeIdModelKinds_getInstance().x37_1).q2q(additionalData.m2u(0));
    var movedText = Persisters_getInstance().a2r().q2q(additionalData.m2u(1));
    return new AddChildSplitPropertyOperation(data.g4l_1, data.h4l_1, data.i4l_1, data.j4l_1, propertyId, data.k4l_1, movedText);
  };
  protoOf(AddChildSplitPropertyOperationPersister).p2y = function () {
    return this.m4l_1;
  };
  protoOf(AddChildSplitPropertyOperationPersister).k4c = function () {
    return this.n4l_1;
  };
  function BaseAddChildSplitOperationPersister() {
  }
  protoOf(BaseAddChildSplitOperationPersister).y4j = function (ctx, op) {
    if (this.d4l(op)) {
      var splitOp = op instanceof BaseAddChildSplitOperation ? op : THROW_CCE();
      var result = new JsonArray();
      // Inline function 'kotlin.with' call
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.node.splitMergeOperations.BaseAddChildSplitOperationPersister.serialize.<anonymous>' call
      result.h2u(serializeConceptId(ctx, splitOp.m3n_1));
      result.h2u(serializeNodeId(ctx, splitOp.n3n_1));
      result.h2u(serializeNodeId(ctx, splitOp.o3n_1));
      result.h2u(ensureNotNull(Persisters_getInstance().j2q().x2p(splitOp.p3n_1)));
      result.h2u(ensureNotNull(Persisters_getInstance().j2q().x2p(this.c4l(op))));
      result.s2t(this.e4l(ctx, op));
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(BaseAddChildSplitOperationPersister).w4c = function (ctx, op) {
    return this.y4j(ctx, op);
  };
  protoOf(BaseAddChildSplitOperationPersister).x4c = function (ctx, json) {
    return this.f4l(new DeserializationData(ctx, json), ctx.m4c_1);
  };
  function BaseMergeRemoveChildOperationPersister() {
  }
  protoOf(BaseMergeRemoveChildOperationPersister).y4j = function (ctx, op) {
    if (this.d4l(op)) {
      var mergeOp = op instanceof BaseMergeRemoveChildOperation ? op : THROW_CCE();
      var result = new JsonArray();
      // Inline function 'kotlin.with' call
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.node.splitMergeOperations.BaseMergeRemoveChildOperationPersister.serialize.<anonymous>' call
      result.h2u(serializeConceptId(ctx, mergeOp.t3m_1));
      result.h2u(serializeNodeId(ctx, mergeOp.u3m_1));
      result.h2u(serializeNodeId(ctx, mergeOp.v3m_1));
      result.h2u(ensureNotNull(Persisters_getInstance().j2q().x2p(mergeOp.w3m_1)));
      result.h2u(ensureNotNull(Persisters_getInstance().j2q().x2p(mergeOp.x3m_1)));
      result.s2t(this.e4l(ctx, op));
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(BaseMergeRemoveChildOperationPersister).w4c = function (ctx, op) {
    return this.y4j(ctx, op);
  };
  protoOf(BaseMergeRemoveChildOperationPersister).x4c = function (ctx, json) {
    return this.f4l(new DeserializationData(ctx, json), ctx.m4c_1);
  };
  function DeserializationData(ctx, json) {
    this.g4l_1 = deserializeConceptId(ctx, json.m2u(0));
    this.h4l_1 = deserializeNodeId(ctx, json.m2u(1));
    this.i4l_1 = deserializeNodeId(ctx, json.m2u(2));
    this.j4l_1 = Persisters_getInstance().j2q().q2q(json.m2u(3));
    this.k4l_1 = Persisters_getInstance().j2q().q2q(json.m2u(4));
    this.l4l_1 = json.l2u(5);
  }
  function MergeChildCollectionRemoveChildOperationPersister() {
    BaseMergeRemoveChildOperationPersister.call(this);
    this.o4l_1 = 'mccrc';
    this.p4l_1 = getKClass(MergeChildCollectionRemoveChildOperation);
  }
  protoOf(MergeChildCollectionRemoveChildOperationPersister).d4l = function (op) {
    return op instanceof MergeChildCollectionRemoveChildOperation;
  };
  protoOf(MergeChildCollectionRemoveChildOperationPersister).e4l = function (ctx, op) {
    var mergeOp = op instanceof MergeChildCollectionRemoveChildOperation ? op : THROW_CCE();
    var res = new JsonArray();
    res.h2u(ensureNotNull(Persisters_getInstance().j2q().x2p(mergeOp.v4b_1)));
    res.h2u(ensureNotNull(ctx.b4d(NodeIdModelKinds_getInstance().y37_1, mergeOp.u4b_1)));
    return res;
  };
  protoOf(MergeChildCollectionRemoveChildOperationPersister).f4l = function (data, ctx) {
    var additionalData = data.l4l_1;
    var removedLength = Persisters_getInstance().j2q().q2q(additionalData.m2u(0));
    var childId = ctx.m37(NodeIdModelKinds_getInstance().y37_1).q2q(additionalData.m2u(1));
    return new MergeChildCollectionRemoveChildOperation(data.g4l_1, data.h4l_1, data.i4l_1, data.j4l_1, childId, removedLength, data.k4l_1);
  };
  protoOf(MergeChildCollectionRemoveChildOperationPersister).p2y = function () {
    return this.o4l_1;
  };
  protoOf(MergeChildCollectionRemoveChildOperationPersister).k4c = function () {
    return this.p4l_1;
  };
  function MergePropertyRemoveChildOperationPersister() {
    BaseMergeRemoveChildOperationPersister.call(this);
    this.q4l_1 = 'mprc';
    this.r4l_1 = getKClass(MergePropertyRemoveChildOperation);
  }
  protoOf(MergePropertyRemoveChildOperationPersister).d4l = function (op) {
    return op instanceof MergePropertyRemoveChildOperation;
  };
  protoOf(MergePropertyRemoveChildOperationPersister).e4l = function (ctx, op) {
    var mergeOp = op instanceof MergePropertyRemoveChildOperation ? op : THROW_CCE();
    var res = new JsonArray();
    res.h2u(ensureNotNull(ctx.b4d(NodeIdModelKinds_getInstance().x37_1, mergeOp.i3n_1)));
    res.h2u(ensureNotNull(Persisters_getInstance().a2r().x2p(mergeOp.j3n_1)));
    return res;
  };
  protoOf(MergePropertyRemoveChildOperationPersister).f4l = function (data, ctx) {
    var additionalData = data.l4l_1;
    var propertyId = ctx.m37(NodeIdModelKinds_getInstance().x37_1).q2q(additionalData.m2u(0));
    var mergedProperty = Persisters_getInstance().a2r().q2q(additionalData.m2u(1));
    return new MergePropertyRemoveChildOperation(data.g4l_1, data.h4l_1, data.i4l_1, data.j4l_1, propertyId, mergedProperty, data.k4l_1);
  };
  protoOf(MergePropertyRemoveChildOperationPersister).p2y = function () {
    return this.q4l_1;
  };
  protoOf(MergePropertyRemoveChildOperationPersister).k4c = function () {
    return this.r4l_1;
  };
  function AddToSetOperationPersister(itemPersister) {
    ChangeSetOperationPersister.call(this, itemPersister);
    this.t4l_1 = 'a';
    this.u4l_1 = getKClass(AddToSetOperation);
  }
  protoOf(AddToSetOperationPersister).p2y = function () {
    return this.t4l_1;
  };
  protoOf(AddToSetOperationPersister).k4c = function () {
    return this.u4l_1;
  };
  protoOf(AddToSetOperationPersister).v4l = function (op) {
    return op instanceof AddToSetOperation;
  };
  protoOf(AddToSetOperationPersister).w4l = function (item, singleRole) {
    return new AddToSetOperation(item, singleRole);
  };
  function ChangeSetOperationPersister(itemPersister) {
    this.x4l_1 = itemPersister;
  }
  protoOf(ChangeSetOperationPersister).y4l = function (ctx, op) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.v4l(op)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var changeOp = op instanceof ChangeSetOperation ? op : THROW_CCE();
    var result = new JsonArray();
    result.h2u(ensureNotNull(this.x4l_1.x2p(changeOp.n41_1)));
    if (changeOp.o41_1) {
      result.i2u(0.0);
    }
    return result;
  };
  protoOf(ChangeSetOperationPersister).w4c = function (ctx, op) {
    return this.y4l(ctx, op);
  };
  protoOf(ChangeSetOperationPersister).x4c = function (ctx, json) {
    var item = ensureNotNull(this.x4l_1.q2q(json.m2u(0)));
    var isSingleRole = json.wo() === 2;
    return this.w4l(item, isSingleRole);
  };
  function RemoveFromSetOperationPersister(itemPersister) {
    ChangeSetOperationPersister.call(this, itemPersister);
    this.a4m_1 = 'r';
    this.b4m_1 = getKClass(RemoveFromSetOperation);
  }
  protoOf(RemoveFromSetOperationPersister).p2y = function () {
    return this.a4m_1;
  };
  protoOf(RemoveFromSetOperationPersister).k4c = function () {
    return this.b4m_1;
  };
  protoOf(RemoveFromSetOperationPersister).v4l = function (op) {
    return op instanceof RemoveFromSetOperation;
  };
  protoOf(RemoveFromSetOperationPersister).w4l = function (item, singleRole) {
    return new RemoveFromSetOperation(item, singleRole);
  };
  function Companion_69() {
    this.c4m_1 = -2;
  }
  var Companion_instance_69;
  function Companion_getInstance_69() {
    return Companion_instance_69;
  }
  function DeleteTextOperationPersister() {
    this.d4m_1 = 'd';
    this.e4m_1 = getKClass(DeleteTextOperation);
  }
  protoOf(DeleteTextOperationPersister).p2y = function () {
    return this.d4m_1;
  };
  protoOf(DeleteTextOperationPersister).k4c = function () {
    return this.e4m_1;
  };
  protoOf(DeleteTextOperationPersister).f4m = function (ctx, op) {
    if (op instanceof DeleteTextOperation) {
      var result = new JsonArray();
      result.h2u(ensureNotNull(Persisters_getInstance().j2q().x2p(TextOperationUtil_instance.q48(op))));
      result.h2u(ensureNotNull(Persisters_getInstance().a2r().x2p(op.t48_1)));
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(DeleteTextOperationPersister).w4c = function (ctx, op) {
    return this.f4m(ctx, op);
  };
  protoOf(DeleteTextOperationPersister).x4c = function (ctx, json) {
    var deleteIndex = Persisters_getInstance().j2q().q2q(json.m2u(0));
    var text = Persisters_getInstance().a2r().q2q(json.m2u(1));
    return new DeleteTextOperation(deleteIndex, text);
  };
  function InsertTextOperationsPersister() {
    this.g4m_1 = 'i';
    this.h4m_1 = getKClass(InsertTextOperation);
  }
  protoOf(InsertTextOperationsPersister).p2y = function () {
    return this.g4m_1;
  };
  protoOf(InsertTextOperationsPersister).k4c = function () {
    return this.h4m_1;
  };
  protoOf(InsertTextOperationsPersister).f4m = function (ctx, op) {
    if (op instanceof InsertTextOperation) {
      var result = new JsonArray();
      result.h2u(ensureNotNull(Persisters_getInstance().j2q().x2p(TextOperationUtil_instance.q48(op))));
      result.h2u(ensureNotNull(Persisters_getInstance().a2r().x2p(op.t48_1)));
      return result;
    }
    throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
  };
  protoOf(InsertTextOperationsPersister).w4c = function (ctx, op) {
    return this.f4m(ctx, op);
  };
  protoOf(InsertTextOperationsPersister).x4c = function (ctx, json) {
    var insertIndex = Persisters_getInstance().j2q().q2q(json.m2u(0));
    var text = Persisters_getInstance().a2r().q2q(json.m2u(1));
    return new InsertTextOperation(insertIndex, text);
  };
  function toJsonValue($this, value) {
    var tmp;
    if (value == null) {
      tmp = new JsonNull();
    } else {
      tmp = new JsonString(value);
    }
    return tmp;
  }
  function fromJsonValue($this, value) {
    var tmp;
    if (value instanceof JsonNull) {
      tmp = null;
    } else {
      var string = value instanceof JsonString ? value : THROW_CCE();
      tmp = string.n2u_1;
    }
    return tmp;
  }
  function SetValueOperationPersister(persister) {
    this.i4m_1 = persister;
    this.j4m_1 = 'sv';
    this.k4m_1 = getKClass(SetValueOperation);
  }
  protoOf(SetValueOperationPersister).p2y = function () {
    return this.j4m_1;
  };
  protoOf(SetValueOperationPersister).k4c = function () {
    return this.k4m_1;
  };
  protoOf(SetValueOperationPersister).l4m = function (ctx, op) {
    var tmp;
    if (op instanceof SetValueOperation) {
      var setValueOp = op instanceof SetValueOperation ? op : THROW_CCE();
      var result = new JsonArray();
      result.s2t(toJsonValue(this, this.i4m_1.x2p(setValueOp.f42_1)));
      result.s2t(toJsonValue(this, this.i4m_1.x2p(setValueOp.g42_1)));
      tmp = result;
    } else {
      throw UnsupportedOperationException_init_$Create$_0(toString_1(getKClassFromExpression(op)));
    }
    return tmp;
  };
  protoOf(SetValueOperationPersister).w4c = function (ctx, op) {
    return this.l4m(ctx, op);
  };
  protoOf(SetValueOperationPersister).x4c = function (ctx, json) {
    var oldValue = this.i4m_1.q2q(fromJsonValue(this, json.q(0)));
    var newValue = this.i4m_1.q2q(fromJsonValue(this, json.q(1)));
    return new SetValueOperation(oldValue, newValue);
  };
  function AddToSetOperation(item, singleRole) {
    ChangeSetOperation.call(this, item, singleRole);
  }
  protoOf(AddToSetOperation).p4m = function (otherOp, server) {
    if (otherOp instanceof AddToSetOperation) {
      var otherAdd = otherOp instanceof AddToSetOperation ? otherOp : THROW_CCE();
      this.q4m(otherAdd);
      if (equals(otherAdd.n41_1, this.n41_1)) {
        return new NopOperation();
      }
      if (this.o41_1) {
        var tmp;
        if (server) {
          tmp = new NopOperation();
        } else {
          tmp = CompositeOperation_init_$Create$([this.s3l(), otherOp]);
        }
        return tmp;
      }
    }
    return protoOf(ChangeSetOperation).g3p.call(this, otherOp, server);
  };
  protoOf(AddToSetOperation).g3p = function (otherOp, server) {
    return this.p4m(otherOp, server);
  };
  protoOf(AddToSetOperation).r4m = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!!model.s(this.n41_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.primitives.set.AddToSetOperation.execute.<anonymous>' call
      var message = 'Model already contains ' + toString_0(this.n41_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(!this.o41_1 || model.p())) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.primitives.set.AddToSetOperation.execute.<anonymous>' call
      var message_0 = 'Add to not empty single-item collection';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    model.e(this.n41_1);
    return model;
  };
  protoOf(AddToSetOperation).a3k = function (model, nodeFactory) {
    return this.r4m((!(model == null) ? isInterface(model, KtMutableSet) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(AddToSetOperation).s3l = function () {
    return new RemoveFromSetOperation(this.n41_1, this.o41_1);
  };
  protoOf(AddToSetOperation).toString = function () {
    return 'addToSet[' + toString_0(this.n41_1) + ']';
  };
  function ChangeSetOperation(item, isSingleRole) {
    BaseOperation.call(this);
    this.n41_1 = item;
    this.o41_1 = isSingleRole;
  }
  protoOf(ChangeSetOperation).q4m = function (otherOp) {
    // Inline function 'kotlin.check' call
    if (!(this.o41_1 === otherOp.o41_1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
  };
  function RemoveFromSetOperation(item, singleRole) {
    ChangeSetOperation.call(this, item, singleRole);
  }
  protoOf(RemoveFromSetOperation).p4m = function (otherOp, server) {
    if (otherOp instanceof RemoveFromSetOperation) {
      var otherRemove = otherOp instanceof RemoveFromSetOperation ? otherOp : THROW_CCE();
      this.q4m(otherRemove);
      if (equals(otherRemove.n41_1, this.n41_1)) {
        return new NopOperation();
      }
    }
    return protoOf(ChangeSetOperation).g3p.call(this, otherOp, server);
  };
  protoOf(RemoveFromSetOperation).g3p = function (otherOp, server) {
    return this.p4m(otherOp, server);
  };
  protoOf(RemoveFromSetOperation).r4m = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!model.s(this.n41_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.primitives.set.RemoveFromSetOperation.execute.<anonymous>' call
      var message = "Model doesn't contain " + toString_0(this.n41_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(!this.o41_1 || model.n() === 1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.primitives.set.RemoveFromSetOperation.execute.<anonymous>' call
      var message_0 = 'Remove from single-item set which size is > 1';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    model.k2(this.n41_1);
    return model;
  };
  protoOf(RemoveFromSetOperation).a3k = function (model, nodeFactory) {
    return this.r4m((!(model == null) ? isInterface(model, KtMutableSet) : false) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(RemoveFromSetOperation).s3l = function () {
    return new AddToSetOperation(this.n41_1, this.o41_1);
  };
  protoOf(RemoveFromSetOperation).toString = function () {
    return 'removeFromSet[' + toString_0(this.n41_1) + ']';
  };
  function deleteOperation($this, index, text) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0) {
      tmp = new NopOperation();
    } else {
      tmp = new DeleteTextOperation(index, text);
    }
    return tmp;
  }
  function deleteThroughDelete($this, deleteOp, server) {
    if ($this.b4b()) {
      return new NopOperation();
    }
    if (deleteOp.b4b()) {
      var text = deleteOp.t48_1;
      var tmp = take_1(text, $this.i3b());
      // Inline function 'kotlin.text.substring' call
      var startIndex = $this.i3b() + $this.a() | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = text.substring(startIndex);
      return new DeleteTextOperation(-1, tmp + tmp$ret$1);
    }
    var index = $this.i3b();
    var endIndex = index + $this.a() | 0;
    var theirIndex = deleteOp.i3b();
    var theirEndIndex = theirIndex + deleteOp.a() | 0;
    if (index <= theirIndex && endIndex >= theirEndIndex) {
      return new NopOperation();
    }
    var theirText = deleteOp.t48_1;
    if (index >= theirIndex && endIndex <= theirEndIndex) {
      var tmp_0 = take_1(theirText, index - theirIndex | 0);
      // Inline function 'kotlin.text.substring' call
      var startIndex_0 = endIndex - theirIndex | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = theirText.substring(startIndex_0);
      return deleteOperation($this, theirIndex, tmp_0 + tmp$ret$3);
    }
    if (theirIndex <= index ? index <= theirEndIndex : false) {
      return deleteOperation($this, theirIndex, take_1(theirText, index - theirIndex | 0));
    }
    var tmp_1;
    if (index <= theirIndex ? theirIndex <= endIndex : false) {
      // Inline function 'kotlin.text.substring' call
      var startIndex_1 = endIndex - theirIndex | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$5 = theirText.substring(startIndex_1);
      tmp_1 = deleteOperation($this, index, tmp$ret$5);
    } else {
      tmp_1 = protoOf(TextOperation).v4m.call($this, deleteOp, server);
    }
    return tmp_1;
  }
  function insertThroughDelete($this, op, server) {
    // Inline function 'kotlin.check' call
    if (!!op.b4b()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.primitives.text.DeleteTextOperation.insertThroughDelete.<anonymous>' call
      var message = 'Insert to null op transformed through delete';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return $this.b4b() ? new NopOperation() : protoOf(TextOperation).v4m.call($this, op, server);
  }
  function DeleteTextOperation(deleteIndex, text) {
    TextOperation.call(this, deleteIndex, text);
  }
  protoOf(DeleteTextOperation).r3z = function () {
    return -this.a() | 0;
  };
  protoOf(DeleteTextOperation).q3z = function (newIndex) {
    var tmp;
    if (this.a() === 0 && !(newIndex === -1)) {
      tmp = new NopOperation();
    } else {
      tmp = new DeleteTextOperation(newIndex, this.t48_1);
    }
    return tmp;
  };
  protoOf(DeleteTextOperation).w4m = function (op) {
    var insertOp = op instanceof InsertTextOperation ? op : THROW_CCE();
    var offset = insertOp.i3b() - this.i3b() | 0;
    var tmp = take_1(this.t48_1, offset) + insertOp.t48_1;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.t48_1.substring(offset);
    return new DeleteTextOperation(this.s48_1, tmp + tmp$ret$1);
  };
  protoOf(DeleteTextOperation).t3z = function (op) {
    return this.w4m(op);
  };
  protoOf(DeleteTextOperation).x4m = function (replaceRemovedItem) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(DeleteTextOperation).u3z = function (replaceRemovedItem) {
    return this.x4m(replaceRemovedItem);
  };
  protoOf(DeleteTextOperation).y4m = function (model) {
    if (this.b4b()) {
      // Inline function 'kotlin.check' call
      if (!(this.t48_1 === model)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      return null;
    }
    var tmp1 = ensureNotNull(model);
    var tmp2 = this.i3b();
    // Inline function 'kotlin.text.substring' call
    var endIndex = this.i3b() + this.a() | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var modelText = tmp1.substring(tmp2, endIndex);
    // Inline function 'kotlin.check' call
    if (!(this.t48_1 === modelText)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp = take_1(model, this.i3b());
    // Inline function 'kotlin.text.substring' call
    var startIndex = this.i3b() + this.a() | 0;
    // Inline function 'kotlin.js.asDynamic' call
    return tmp + model.substring(startIndex);
  };
  protoOf(DeleteTextOperation).v4m = function (otherOp, server) {
    var tmp;
    if (!(otherOp instanceof TextOperation)) {
      tmp = protoOf(TextOperation).v4m.call(this, otherOp, server);
    } else {
      if (otherOp instanceof InsertTextOperation) {
        tmp = insertThroughDelete(this, otherOp, server);
      } else {
        if (otherOp instanceof DeleteTextOperation) {
          tmp = deleteThroughDelete(this, otherOp, server);
        } else {
          throw IllegalStateException_init_$Create$_0('Unknown text op');
        }
      }
    }
    return tmp;
  };
  protoOf(DeleteTextOperation).g3p = function (otherOp, server) {
    return this.v4m(otherOp, server);
  };
  protoOf(DeleteTextOperation).s3l = function () {
    return new InsertTextOperation(this.s48_1, this.t48_1);
  };
  protoOf(DeleteTextOperation).toString = function () {
    return "Delete '" + this.t48_1 + "' at " + this.s48_1;
  };
  function insertThroughInsert($this, insertOp, server) {
    var insertToNull = $this.b4b();
    var opInsertToNul = insertOp.b4b();
    if (!insertToNull && !opInsertToNul) {
      return protoOf(TextOperation).v4m.call($this, insertOp, server);
    }
    if (insertToNull && opInsertToNul) {
      var newIndex = server ? $this.t48_1.length : 0;
      return insertOp.q3z(newIndex);
    }
    throw IllegalStateException_init_$Create$_0('Transforming insert into null and insert into not null');
  }
  function deleteThroughInsert($this, op, server) {
    // Inline function 'kotlin.check' call
    if (!!$this.b4b()) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.primitives.text.InsertTextOperation.deleteThroughInsert.<anonymous>' call
      var message = 'Delete op is transformed through insert to null';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if (op.b4b()) {
      tmp = op.w4m($this);
    } else {
      tmp = protoOf(TextOperation).v4m.call($this, op, server);
    }
    return tmp;
  }
  function InsertTextOperation(insertIndex, text) {
    TextOperation.call(this, insertIndex, text);
    this.z4b_1 = Priority_NORMAL_getInstance();
  }
  protoOf(InsertTextOperation).r3z = function () {
    return this.a();
  };
  protoOf(InsertTextOperation).p3z = function () {
    return this.z4b_1;
  };
  protoOf(InsertTextOperation).v4m = function (otherOp, server) {
    if (otherOp instanceof TextOperation) {
      var tmp;
      if (otherOp instanceof InsertTextOperation) {
        tmp = insertThroughInsert(this, otherOp, server);
      } else {
        if (otherOp instanceof DeleteTextOperation) {
          tmp = deleteThroughInsert(this, otherOp, server);
        } else {
          throw IllegalStateException_init_$Create$_0('Unknown text operation');
        }
      }
      return tmp;
    }
    return protoOf(TextOperation).v4m.call(this, otherOp, server);
  };
  protoOf(InsertTextOperation).g3p = function (otherOp, server) {
    return this.v4m(otherOp, server);
  };
  protoOf(InsertTextOperation).q3z = function (newIndex) {
    return new InsertTextOperation(newIndex, this.t48_1);
  };
  protoOf(InsertTextOperation).s3l = function () {
    return new DeleteTextOperation(this.s48_1, this.t48_1);
  };
  protoOf(InsertTextOperation).y4m = function (model) {
    if (model == null) {
      // Inline function 'kotlin.require' call
      if (!this.b4b()) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.primitives.text.InsertTextOperation.doExecute.<anonymous>' call
        var message = 'Cannot insert into null string';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      return this.t48_1;
    }
    var tmp = take_1(model, this.i3b()) + this.t48_1;
    // Inline function 'kotlin.text.substring' call
    var startIndex = this.i3b();
    // Inline function 'kotlin.js.asDynamic' call
    return tmp + model.substring(startIndex);
  };
  protoOf(InsertTextOperation).toString = function () {
    return 'Insert ' + this.t48_1 + ' at ' + this.s48_1;
  };
  function TextOperation(transformationIndex, text) {
    BaseOperation.call(this);
    this.s48_1 = transformationIndex;
    this.t48_1 = text;
  }
  protoOf(TextOperation).i3b = function () {
    return this.s48_1 === -1 ? 0 : this.s48_1;
  };
  protoOf(TextOperation).a = function () {
    return this.t48_1.length;
  };
  protoOf(TextOperation).b4b = function () {
    return this.s48_1 === -1;
  };
  protoOf(TextOperation).v4m = function (otherOp, server) {
    var tmp;
    if (otherOp instanceof TextOperation) {
      tmp = (new IndexedOperationTransformer()).s3z(this, otherOp, server);
    } else {
      if (otherOp instanceof SetValueOperation) {
        var setValue = otherOp instanceof SetValueOperation ? otherOp : THROW_CCE();
        var result = this.d4c(setValue.f42_1, RawNodeFactory_instance);
        var newValue = setValue.g42_1;
        var tmp_0;
        if (result === newValue) {
          tmp_0 = new NopOperation();
        } else {
          tmp_0 = new SetValueOperation(result, newValue);
        }
        tmp = tmp_0;
      } else {
        tmp = protoOf(BaseOperation).g3p.call(this, otherOp, server);
      }
    }
    return tmp;
  };
  protoOf(TextOperation).g3p = function (otherOp, server) {
    return this.v4m(otherOp, server);
  };
  protoOf(TextOperation).z4m = function (otherOp, server) {
    var tmp;
    if (otherOp instanceof SetValueOperation) {
      tmp = new NopOperation();
    } else {
      tmp = protoOf(BaseOperation).r3p.call(this, otherOp, server);
    }
    return tmp;
  };
  protoOf(TextOperation).r3p = function (otherOp, server) {
    return this.z4m(otherOp, server);
  };
  protoOf(TextOperation).d4c = function (model, nodeFactory) {
    return this.y4m(model);
  };
  protoOf(TextOperation).a3k = function (model, nodeFactory) {
    return this.d4c((model == null ? true : typeof model === 'string') ? model : THROW_CCE(), nodeFactory);
  };
  function TextOperationUtil() {
  }
  protoOf(TextOperationUtil).q48 = function (op) {
    return op.b4b() ? -1 : op.i3b();
  };
  var TextOperationUtil_instance;
  function TextOperationUtil_getInstance() {
    return TextOperationUtil_instance;
  }
  function SetValueOperation(oldValue, newValue) {
    BaseOperation.call(this);
    this.f42_1 = oldValue;
    this.g42_1 = newValue;
    // Inline function 'kotlin.check' call
    if (!!equals(this.f42_1, this.g42_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.primitives.value.SetValueOperation.<anonymous>' call
      var message = 'equal old and new values: ' + toString_0(this.f42_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(SetValueOperation).s3l = function () {
    return new SetValueOperation(this.g42_1, this.f42_1);
  };
  protoOf(SetValueOperation).a4n = function (otherOp, server) {
    if (otherOp instanceof SetValueOperation) {
      var otherSet = otherOp instanceof SetValueOperation ? otherOp : THROW_CCE();
      var tmp;
      if (equals(this.g42_1, otherSet.g42_1) || server) {
        tmp = new NopOperation();
      } else {
        tmp = new SetValueOperation(this.g42_1, otherSet.g42_1);
      }
      return tmp;
    }
    return protoOf(BaseOperation).g3p.call(this, otherOp, server);
  };
  protoOf(SetValueOperation).g3p = function (otherOp, server) {
    return this.a4n(otherOp, server);
  };
  protoOf(SetValueOperation).b4n = function (model, nodeFactory) {
    // Inline function 'kotlin.check' call
    if (!equals(model, this.f42_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.primitives.value.SetValueOperation.execute.<anonymous>' call
      var message = "different current values: in operation = '" + toString_0(this.f42_1) + "', in model = '" + toString_0(model) + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return this.g42_1;
  };
  protoOf(SetValueOperation).a3k = function (model, nodeFactory) {
    return this.b4n((model == null ? true : !(model == null)) ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(SetValueOperation).toString = function () {
    return 'SetValue[' + toString_0(this.f42_1) + '->' + toString_0(this.g42_1) + ']';
  };
  protoOf(SetValueOperation).hashCode = function () {
    var result = this.f42_1 == null ? 0 : hashCode(this.f42_1);
    result = imul(result, 31) + (this.g42_1 == null ? 0 : hashCode(this.g42_1)) | 0;
    return result;
  };
  protoOf(SetValueOperation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetValueOperation))
      return false;
    var tmp0_other_with_cast = other instanceof SetValueOperation ? other : THROW_CCE();
    if (!equals(this.f42_1, tmp0_other_with_cast.f42_1))
      return false;
    if (!equals(this.g42_1, tmp0_other_with_cast.g42_1))
      return false;
    return true;
  };
  var OtTransactionState_STARTED_instance;
  var OtTransactionState_FINISHED_instance;
  var OtTransactionState_entriesInitialized;
  function OtTransactionState_initEntries() {
    if (OtTransactionState_entriesInitialized)
      return Unit_instance;
    OtTransactionState_entriesInitialized = true;
    OtTransactionState_STARTED_instance = new OtTransactionState('STARTED', 0);
    OtTransactionState_FINISHED_instance = new OtTransactionState('FINISHED', 1);
  }
  function updateProperty($this) {
    $this.e4n_1.t2c($this.d4n_1.yf_1);
  }
  function onOtCommandFinished($this) {
    $this.o4n_1.l4n_1 = OtTransactionState_FINISHED_getInstance();
    if (!($this.o4n_1.n4n_1 == null)) {
      var transaction = $this.o4n_1.n4n_1;
      $this.o4n_1.n4n_1 = null;
      try {
        ensureNotNull(transaction).s4n();
      } catch ($p) {
        if ($p instanceof Exception) {
          var e = $p;
          clear_0($this.o4n_1);
          throw e;
        } else {
          throw $p;
        }
      }
    }
  }
  function restore_0($this, provider, savedState) {
    try {
      var state = savedState.y2(provider);
      if (!(state == null)) {
        provider.t4n((!(state == null) ? isInterface(state, OtAware) : false) ? state : THROW_CCE());
      }
    } catch ($p) {
      if ($p instanceof Exception) {
        var e = $p;
        ThrowableHandlers_getInstance().ps_1.os(e);
      } else {
        throw $p;
      }
    }
  }
  function removeStateProvider($this, provider) {
    $this.j4n_1.k2(provider);
    var _iterator__ex2g4s = $this.u4n().k();
    while (_iterator__ex2g4s.l()) {
      var undoStack = _iterator__ex2g4s.m();
      var _iterator__ex2g4s_0 = undoStack.v4n().k();
      while (_iterator__ex2g4s_0.l()) {
        var command = _iterator__ex2g4s_0.m();
        command.c4o(provider);
      }
    }
    var _iterator__ex2g4s_1 = $this.d4o().k();
    while (_iterator__ex2g4s_1.l()) {
      var redoStack = _iterator__ex2g4s_1.m();
      var _iterator__ex2g4s_2 = redoStack.v4n().k();
      while (_iterator__ex2g4s_2.l()) {
        var command_0 = _iterator__ex2g4s_2.m();
        command_0.c4o(provider);
      }
    }
  }
  function verifyCanUndo($this) {
    var transaction = $this.n4n_1;
    // Inline function 'kotlin.check' call
    if (!!(transaction == null || !transaction.q4n_1.equals(Kind_COMMON_getInstance()) || !transaction.t3j())) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.undo.BaseUndoManager.verifyCanUndo.<anonymous>' call
      var message = "Undo/redo is forbidden during transparent commands, other undo/redo commands and user's operations";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    verifyOtTransactionState($this, OtTransactionState_STARTED_getInstance());
  }
  function verifyOtTransactionState($this, state) {
    // Inline function 'kotlin.check' call
    if (!$this.l4n_1.equals(state)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.undo.BaseUndoManager.verifyOtTransactionState.<anonymous>' call
      var message = 'OT transaction state is ' + $this.l4n_1.toString() + ', expected ' + state.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function ensureNotStateRestoring($this) {
    // Inline function 'kotlin.check' call
    if (!!$this.k4n_1) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.undo.BaseUndoManager.ensureNotStateRestoring.<anonymous>' call
      var message = 'Changing model during view state recovering';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function clear_0($this) {
    var _iterator__ex2g4s = $this.u4n().k();
    while (_iterator__ex2g4s.l()) {
      var stack = _iterator__ex2g4s.m();
      stack.m2();
    }
    var _iterator__ex2g4s_0 = $this.d4o().k();
    while (_iterator__ex2g4s_0.l()) {
      var stack_0 = _iterator__ex2g4s_0.m();
      stack_0.m2();
    }
  }
  function OtTransactionState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function UndoStackImpl(maxSize) {
    this.c4n_1 = maxSize;
    this.d4n_1 = ArrayDeque_init_$Create$();
    this.e4n_1 = new ValueProperty(0);
  }
  protoOf(UndoStackImpl).v4n = function () {
    return this.d4n_1;
  };
  protoOf(UndoStackImpl).np = function () {
    return this.wo().qr() === 0;
  };
  protoOf(UndoStackImpl).bg = function () {
    return this.d4n_1.bg();
  };
  protoOf(UndoStackImpl).e4o = function () {
    return this.d4n_1.yf_1 >= 2 ? this.d4n_1.q(1) : null;
  };
  protoOf(UndoStackImpl).f4o = function () {
    var command = this.d4n_1.fg();
    updateProperty(this);
    return command;
  };
  protoOf(UndoStackImpl).wo = function () {
    return this.e4n_1;
  };
  protoOf(UndoStackImpl).m2 = function () {
    this.d4n_1.m2();
    updateProperty(this);
  };
  protoOf(UndoStackImpl).g4o = function (command) {
    while ((this.d4n_1.yf_1 + 1 | 0) > this.c4n_1 && !(this.c4n_1 === 0)) {
      this.d4n_1.hg();
    }
    this.d4n_1.dg(command);
    updateProperty(this);
  };
  protoOf(UndoStackImpl).toString = function () {
    return this.d4n_1.toString();
  };
  function UndoCommandListener($outer) {
    this.o4n_1 = $outer;
  }
  protoOf(UndoCommandListener).t3k = function (op) {
    ensureNotStateRestoring(this.o4n_1);
    ensureNotNull(this.o4n_1.n4n_1).h4o(op);
  };
  protoOf(UndoCommandListener).z3k = function (op) {
    var transaction = this.o4n_1.n4n_1;
    if (transaction == null) {
      UndoUtils_instance.j4o(this.o4n_1, op);
    } else {
      ensureNotStateRestoring(this.o4n_1);
      transaction.i4o(op);
    }
  };
  protoOf(UndoCommandListener).w3k = function (event) {
    this.o4n_1.l4n_1 = OtTransactionState_STARTED_getInstance();
    var transaction = this.o4n_1.n4n_1;
    if (transaction == null) {
      transaction = new UndoableTransaction(this.o4n_1, Kind_COMMON_getInstance());
      this.o4n_1.n4n_1 = transaction;
    }
    transaction.k4o(event.a3m_1);
  };
  protoOf(UndoCommandListener).x3k = function (op) {
    return onOtCommandFinished(this);
  };
  function BaseUndoManager$addStateProvider$$inlined$toDisposable$1(this$0, $provider) {
    this.l4o_1 = this$0;
    this.m4o_1 = $provider;
  }
  protoOf(BaseUndoManager$addStateProvider$$inlined$toDisposable$1).vr = function () {
    removeStateProvider(this.l4o_1, this.m4o_1);
    return Unit_instance;
  };
  function OtTransactionState_STARTED_getInstance() {
    OtTransactionState_initEntries();
    return OtTransactionState_STARTED_instance;
  }
  function OtTransactionState_FINISHED_getInstance() {
    OtTransactionState_initEntries();
    return OtTransactionState_FINISHED_instance;
  }
  function BaseUndoManager(model, commandNotifier, allowUndo, nodeFactory) {
    allowUndo = allowUndo === VOID ? true : allowUndo;
    this.f4n_1 = model;
    this.g4n_1 = commandNotifier;
    this.h4n_1 = nodeFactory;
    this.i4n_1 = allowUndo ? this.g4n_1.g3l(new UndoCommandListener(this)) : null;
    this.j4n_1 = ArrayList_init_$Create$();
    this.k4n_1 = false;
    this.l4n_1 = OtTransactionState_FINISHED_getInstance();
    this.m4n_1 = null;
    this.n4n_1 = null;
  }
  protoOf(BaseUndoManager).n4o = function () {
    var states = HashMap_init_$Create$();
    var _iterator__ex2g4s = this.j4n_1.k();
    while (_iterator__ex2g4s.l()) {
      var provider = _iterator__ex2g4s.m();
      try {
        var state = provider.o4o();
        if (!(state == null)) {
          // Inline function 'kotlin.collections.set' call
          states.r2(provider, state);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          ThrowableHandlers_getInstance().ps_1.os(t);
        } else {
          throw $p;
        }
      }
    }
    return states;
  };
  protoOf(BaseUndoManager).p4o = function () {
    return this.m4n_1;
  };
  protoOf(BaseUndoManager).q4o = function (stackId) {
    if (equals(this.m4n_1, stackId))
      return Unit_instance;
    var transaction = this.n4n_1;
    if (!(transaction == null) && !transaction.t3j()) {
      throw OtException_init_$Create$_0('Cannot change current undo/redo stack inside undoable transaction');
    }
    this.m4n_1 = stackId;
  };
  protoOf(BaseUndoManager).vr = function () {
    var tmp0_safe_receiver = this.i4n_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.vr();
    }
  };
  protoOf(BaseUndoManager).t4o = function (groupId) {
    var transaction = this.n4n_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (transaction == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.undo.BaseUndoManager.setUndoGroupId.<anonymous>' call
        var message = 'No transaction is running at the moment';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    transaction.u4o(groupId);
  };
  protoOf(BaseUndoManager).v4o = function (savedState) {
    this.k4n_1 = true;
    try {
      var reversedProviders = ArrayList_init_$Create$_1(this.j4n_1);
      reverse(reversedProviders);
      var _iterator__ex2g4s = reversedProviders.k();
      while (_iterator__ex2g4s.l()) {
        var p = _iterator__ex2g4s.m();
        restore_0(this, p, savedState);
      }
    }finally {
      this.k4n_1 = false;
    }
  };
  protoOf(BaseUndoManager).w4o = function (provider) {
    this.j4n_1.e(provider);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new BaseUndoManager$addStateProvider$$inlined$toDisposable$1(this, provider);
  };
  protoOf(BaseUndoManager).x4o = function (op) {
    op.a3k(this.f4n_1, this.h4n_1);
  };
  protoOf(BaseUndoManager).a4p = function () {
    if (this.b4p().qr().f4p()) {
      verifyCanUndo(this);
      var transaction = ensureNotNull(this.n4n_1);
      transaction.a4p();
      try {
        var groupId = this.y4o();
        transaction.u4o(groupId);
      } catch ($p) {
        if ($p instanceof Exception) {
          var e = $p;
          clear_0(this);
          throw e;
        } else {
          throw $p;
        }
      }
    }
  };
  protoOf(BaseUndoManager).g4p = function () {
    if (this.h4p().qr().f4p()) {
      verifyCanUndo(this);
      var transaction = ensureNotNull(this.n4n_1);
      transaction.g4p();
      try {
        var groupId = this.z4o();
        transaction.u4o(groupId);
      } catch ($p) {
        if ($p instanceof Exception) {
          var e = $p;
          clear_0(this);
          throw e;
        } else {
          throw $p;
        }
      }
    }
  };
  function OtAware() {
  }
  function SimpleUndoStackId(id) {
    this.j4p_1 = id;
  }
  protoOf(SimpleUndoStackId).toString = function () {
    return 'SimpleUndoStackId(id=' + toString_1(this.j4p_1) + ')';
  };
  protoOf(SimpleUndoStackId).hashCode = function () {
    return hashCode(this.j4p_1);
  };
  protoOf(SimpleUndoStackId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SimpleUndoStackId))
      return false;
    var tmp0_other_with_cast = other instanceof SimpleUndoStackId ? other : THROW_CCE();
    if (!equals(this.j4p_1, tmp0_other_with_cast.j4p_1))
      return false;
    return true;
  };
  var Kind_NO_STACK_SELECTED_instance;
  var Kind_EMPTY_STACK_instance;
  var Kind_DEPENDENT_STACK_CHANGED_instance;
  var Kind_entriesInitialized;
  function Kind_initEntries() {
    if (Kind_entriesInitialized)
      return Unit_instance;
    Kind_entriesInitialized = true;
    Kind_NO_STACK_SELECTED_instance = new Kind('NO_STACK_SELECTED', 0);
    Kind_EMPTY_STACK_instance = new Kind('EMPTY_STACK', 1);
    Kind_DEPENDENT_STACK_CHANGED_instance = new Kind('DEPENDENT_STACK_CHANGED', 2);
  }
  function Kind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Kind_EMPTY_STACK_getInstance() {
    Kind_initEntries();
    return Kind_EMPTY_STACK_instance;
  }
  function UndoRejectionInfo(kind, problemStackIds) {
    this.k4p_1 = kind;
    this.l4p_1 = problemStackIds;
  }
  protoOf(UndoRejectionInfo).toString = function () {
    return 'UndoRejectionInfo[' + this.k4p_1.toString() + ', problemStackIds=' + toString_1(this.l4p_1) + ']';
  };
  function Companion_70() {
  }
  protoOf(Companion_70).m4p = function (groupId) {
    return new UndoState(true, groupId, null);
  };
  protoOf(Companion_70).n4p = function (groupId, info) {
    return new UndoState(false, groupId, info);
  };
  var Companion_instance_70;
  function Companion_getInstance_70() {
    return Companion_instance_70;
  }
  function UndoState(canUndo, groupId, _rejectionInfo) {
    this.c4p_1 = canUndo;
    this.d4p_1 = groupId;
    this.e4p_1 = _rejectionInfo;
  }
  protoOf(UndoState).o4p = function () {
    // Inline function 'kotlin.check' call
    if (!!this.c4p_1) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.undo.UndoState.<get-rejectionInfo>.<anonymous>' call
      var message = "No rejection info available for 'can undo' state";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return this.e4p_1;
  };
  protoOf(UndoState).f4p = function () {
    return this.c4p_1;
  };
  protoOf(UndoState).toString = function () {
    return 'groupId=' + toString_0(this.d4p_1) + ', canUndo=' + this.c4p_1 + ', rejectionInfo=' + toString_0(this.e4p_1);
  };
  protoOf(UndoState).hashCode = function () {
    var result = getBooleanHashCode(this.c4p_1);
    result = imul(result, 31) + (this.d4p_1 == null ? 0 : hashCode(this.d4p_1)) | 0;
    result = imul(result, 31) + (this.e4p_1 == null ? 0 : hashCode(this.e4p_1)) | 0;
    return result;
  };
  protoOf(UndoState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UndoState))
      return false;
    var tmp0_other_with_cast = other instanceof UndoState ? other : THROW_CCE();
    if (!(this.c4p_1 === tmp0_other_with_cast.c4p_1))
      return false;
    if (!equals(this.d4p_1, tmp0_other_with_cast.d4p_1))
      return false;
    if (!equals(this.e4p_1, tmp0_other_with_cast.e4p_1))
      return false;
    return true;
  };
  function addExternalOperation($this, op, stack, currentState) {
    if (!stack.np()) {
      stack.bg().p4p(op);
      $this.q4p(stack, currentState);
    }
  }
  function tryMergeTwoLastCommands($this, stack, currentState) {
    if (stack.wo().qr() > 1 && ensureNotNull(stack.e4o()).r4p(stack.bg(), currentState)) {
      stack.f4o();
      removeEmptyCommands($this, stack, currentState);
    }
  }
  function removeEmptyCommands($this, stack, currentState) {
    while (!stack.np() && stack.bg().s4p(currentState) === UndoCommandType_EMPTY_getInstance()) {
      var nopCommand = stack.f4o();
      if (!stack.np()) {
        stack.bg().u4p(nopCommand.t4p());
      }
    }
  }
  function UndoUtils() {
  }
  protoOf(UndoUtils).v4p = function (operations) {
    var _iterator__ex2g4s = operations.k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      if (!op.t3j())
        return false;
    }
    return true;
  };
  protoOf(UndoUtils).j4o = function (manager, op) {
    var currentState = manager.n4o();
    var _iterator__ex2g4s = manager.u4n().k();
    while (_iterator__ex2g4s.l()) {
      var stack = _iterator__ex2g4s.m();
      addExternalOperation(this, op, stack, currentState);
    }
    var _iterator__ex2g4s_0 = manager.d4o().k();
    while (_iterator__ex2g4s_0.l()) {
      var stack_0 = _iterator__ex2g4s_0.m();
      addExternalOperation(this, op, stack_0, currentState);
    }
  };
  protoOf(UndoUtils).q4p = function (stack, currentState) {
    removeEmptyCommands(this, stack, currentState);
    tryMergeTwoLastCommands(this, stack, currentState);
  };
  var UndoUtils_instance;
  function UndoUtils_getInstance() {
    return UndoUtils_instance;
  }
  function _get_classAndHash__24311e($this) {
    var tmp0_elvis_lhs = getKClassFromExpression($this).lb();
    var className = tmp0_elvis_lhs == null ? '<anonymous command>' : tmp0_elvis_lhs;
    return className + '@' + toString_3(hashCode($this), 16);
  }
  function computeUndoType($this, currentStates) {
    var providers = HashSet_init_$Create$();
    providers.o($this.z4n_1.u2());
    providers.o(currentStates.u2());
    var type = UndoCommandType_EMPTY_getInstance();
    var _iterator__ex2g4s = providers.k();
    while (_iterator__ex2g4s.l()) {
      var provider = _iterator__ex2g4s.m();
      var viewStateProvider = isInterface(provider, ViewStateProvider) ? provider : THROW_CCE();
      var providerType = computeUndoType_0($this, viewStateProvider, $this.z4n_1.y2(provider), currentStates.y2(provider));
      if (providerType === UndoCommandType_EDITING_getInstance()) {
        return UndoCommandType_EDITING_getInstance();
      }
      if (providerType === UndoCommandType_NAVIGATION_getInstance()) {
        type = UndoCommandType_NAVIGATION_getInstance();
      }
    }
    return type;
  }
  function computeUndoType_0($this, provider, savedState, currentState) {
    if (savedState === currentState) {
      return UndoCommandType_EMPTY_getInstance();
    }
    var tmp;
    if (savedState == null || currentState == null) {
      tmp = UndoCommandType_NAVIGATION_getInstance();
    } else {
      tmp = provider.w4p(savedState, currentState);
    }
    return tmp;
  }
  function UndoableCommand(data, affectedStackIds) {
    this.w4n_1 = data.x4p_1;
    this.b4o_1 = false;
    this.z4n_1 = HashMap_init_$Create$_1(data.y4p_1);
    this.a4o_1 = HashSet_init_$Create$_0(affectedStackIds);
    this.x4n_1 = ArrayList_init_$Create$_0(data.z4p_1.n());
    var _iterator__ex2g4s = data.z4p_1.k();
    while (_iterator__ex2g4s.l()) {
      var op = _iterator__ex2g4s.m();
      this.x4n_1.e(op.s3l());
    }
    this.y4n_1 = ArrayList_init_$Create$_0(data.a4q_1.n());
    this.u4p(data.a4q_1);
  }
  protoOf(UndoableCommand).t4p = function () {
    return this.y4n_1;
  };
  protoOf(UndoableCommand).p4p = function (externalOp) {
    var operation = externalOp;
    var inductionVariable = this.x4n_1.n() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var undoOp = this.x4n_1.q(i);
        var newOp = operation.b3k(undoOp, true);
        operation = undoOp.b3k(operation, false);
        this.x4n_1.o2(i, newOp);
      }
       while (0 <= inductionVariable);
    this.y4n_1.e(operation);
    var _iterator__ex2g4s = this.z4n_1.u2().k();
    while (_iterator__ex2g4s.l()) {
      var provider = _iterator__ex2g4s.m();
      var tmp0 = this.z4n_1;
      // Inline function 'kotlin.collections.set' call
      var value = ensureNotNull(this.z4n_1.y2(provider)).i4p(operation);
      tmp0.r2(provider, value);
    }
  };
  protoOf(UndoableCommand).u4p = function (externalOperations) {
    var _iterator__ex2g4s = externalOperations.k();
    while (_iterator__ex2g4s.l()) {
      var externalOp = _iterator__ex2g4s.m();
      this.p4p(externalOp);
    }
  };
  protoOf(UndoableCommand).b4q = function (manager) {
    // Inline function 'kotlin.check' call
    if (!!this.b4o_1) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.undo.UndoableCommand.undo.<anonymous>' call
      var message = 'The command has already been reverted';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.b4o_1 = true;
    var inductionVariable = this.x4n_1.n() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        manager.x4o(this.x4n_1.q(i));
      }
       while (0 <= inductionVariable);
    var i_0 = this.y4n_1.i2();
    while (i_0.l()) {
      var op = i_0.m();
      if (op.t3j()) {
        i_0.b5();
      }
    }
    manager.v4o(this.z4n_1);
  };
  protoOf(UndoableCommand).c4o = function (provider) {
    this.z4n_1.s2(provider);
  };
  protoOf(UndoableCommand).s4p = function (currentState) {
    var tmp;
    if (!UndoUtils_instance.v4p(this.x4n_1)) {
      tmp = UndoCommandType_EDITING_getInstance();
    } else {
      tmp = computeUndoType(this, currentState);
    }
    return tmp;
  };
  protoOf(UndoableCommand).r4p = function (next, currentState) {
    var thisCmdType = this.s4p(next.z4n_1);
    var nextCmdType = next.s4p(currentState);
    if (this.w4n_1.z3l(next.w4n_1, nextCmdType, thisCmdType)) {
      this.u4p(next.y4n_1);
      this.x4n_1.o(next.x4n_1);
      return true;
    }
    return false;
  };
  protoOf(UndoableCommand).toString = function () {
    return _get_classAndHash__24311e(this) + '[groupId=' + toString_1(this.w4n_1) + ', undoOps=' + this.x4n_1.n() + ', extOps=' + this.y4n_1.n() + ', states=' + this.z4n_1.n() + ']';
  };
  function UndoableCommandData(groupId, undoOperations, externalOperations, savedState) {
    this.x4p_1 = groupId;
    this.y4p_1 = savedState;
    var tmp = this;
    // Inline function 'kotlin.collections.orEmpty' call
    tmp.z4p_1 = undoOperations == null ? emptyList() : undoOperations;
    var tmp_0 = this;
    tmp_0.a4q_1 = externalOperations == null ? ArrayList_init_$Create$() : externalOperations;
  }
  protoOf(UndoableCommandData).t3j = function () {
    return UndoUtils_instance.v4p(this.z4p_1);
  };
  protoOf(UndoableCommandData).toString = function () {
    return 'groupId=' + toString_1(this.x4p_1) + ', undoOps=' + this.z4p_1.n() + ', externalOps=' + this.a4q_1.n() + ', states=' + this.y4p_1.n();
  };
  function noExternalOps($this) {
    return $this.f4q_1 == null || ensureNotNull($this.f4q_1).p();
  }
  function checkNonNullGroupId($this, groupId) {
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (groupId == null) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.undo.UndoableCommandDataBuilder.checkNonNullGroupId.<anonymous>' call
        var message = 'Unexpected null CommandsUndoGroupId';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
  }
  var Kind_UNDO_instance;
  var Kind_REDO_instance;
  var Kind_COMMON_instance;
  var Kind_entriesInitialized_0;
  function Kind_initEntries_0() {
    if (Kind_entriesInitialized_0)
      return Unit_instance;
    Kind_entriesInitialized_0 = true;
    Kind_UNDO_instance = new Kind_0('UNDO', 0);
    Kind_REDO_instance = new Kind_0('REDO', 1);
    Kind_COMMON_instance = new Kind_0('COMMON', 2);
  }
  function UndoableCommandDataBuilder(groupId, savedState) {
    this.c4q_1 = groupId;
    this.d4q_1 = savedState;
    this.e4q_1 = null;
    this.f4q_1 = null;
    this.g4q_1 = false;
    checkNonNullGroupId(this, this.c4q_1);
  }
  protoOf(UndoableCommandDataBuilder).np = function () {
    return this.d4q_1.p() && noExternalOps(this) && this.t3j();
  };
  protoOf(UndoableCommandDataBuilder).t3j = function () {
    return this.e4q_1 == null || UndoUtils_instance.v4p(ensureNotNull(this.e4q_1));
  };
  protoOf(UndoableCommandDataBuilder).k2p = function () {
    return new UndoableCommandData(this.c4q_1, this.e4q_1, this.f4q_1, this.d4q_1);
  };
  protoOf(UndoableCommandDataBuilder).u4o = function (groupId) {
    checkNonNullGroupId(this, groupId);
    if (!equals(groupId, this.c4q_1)) {
      // Inline function 'kotlin.check' call
      if (!!this.g4q_1) {
        // Inline function 'jetbrains.ocelot.ot.model.ot.undo.UndoableCommandDataBuilder.setGroupId.<anonymous>' call
        var message = 'Multiple undo group updates in one command';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      this.g4q_1 = true;
      this.c4q_1 = groupId;
    }
  };
  protoOf(UndoableCommandDataBuilder).h4q = function (op) {
    // Inline function 'kotlin.check' call
    if (!(this.f4q_1 == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.undo.UndoableCommandDataBuilder.add.<anonymous>' call
      var message = 'Undo operations cannot interchange with external operations because of possible revert ambiguity';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (this.e4q_1 == null) {
      this.e4q_1 = ArrayList_init_$Create$();
    }
    ensureNotNull(this.e4q_1).e(op);
  };
  protoOf(UndoableCommandDataBuilder).i4q = function (op) {
    if (this.f4q_1 == null) {
      this.f4q_1 = ArrayList_init_$Create$();
    }
    ensureNotNull(this.f4q_1).e(op);
  };
  function Kind_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Kind_UNDO_getInstance() {
    Kind_initEntries_0();
    return Kind_UNDO_instance;
  }
  function Kind_REDO_getInstance() {
    Kind_initEntries_0();
    return Kind_REDO_instance;
  }
  function Kind_COMMON_getInstance() {
    Kind_initEntries_0();
    return Kind_COMMON_instance;
  }
  function UndoableTransaction(manager, kind) {
    this.p4n_1 = manager;
    this.r4n_1 = null;
    this.q4n_1 = kind;
  }
  protoOf(UndoableTransaction).t3j = function () {
    return this.r4n_1 == null || ensureNotNull(this.r4n_1).t3j();
  };
  protoOf(UndoableTransaction).a4p = function () {
    this.q4n_1 = Kind_UNDO_getInstance();
  };
  protoOf(UndoableTransaction).g4p = function () {
    this.q4n_1 = Kind_REDO_getInstance();
  };
  protoOf(UndoableTransaction).u4o = function (groupId) {
    ensureNotNull(this.r4n_1).u4o(groupId);
  };
  protoOf(UndoableTransaction).s4n = function () {
    if (ensureNotNull(this.r4n_1).np())
      return Unit_instance;
    var data = ensureNotNull(this.r4n_1).k2p();
    switch (this.q4n_1.a3_1) {
      case 2:
        this.p4n_1.r4o(data, true);
        break;
      case 0:
        this.p4n_1.s4o(data);
        break;
      case 1:
        this.p4n_1.r4o(data, false);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  };
  protoOf(UndoableTransaction).k4o = function (groupId) {
    // Inline function 'kotlin.check' call
    if (!(this.r4n_1 == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.undo.UndoableTransaction.start.<anonymous>' call
      var message = 'Transaction has already started';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.r4n_1 = new UndoableCommandDataBuilder(groupId, this.p4n_1.n4o());
  };
  protoOf(UndoableTransaction).i4o = function (op) {
    // Inline function 'kotlin.check' call
    if (!(!this.q4n_1.equals(Kind_UNDO_getInstance()) && !this.q4n_1.equals(Kind_REDO_getInstance()))) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.undo.UndoableTransaction.onExternalOperation.<anonymous>' call
      var message = 'External operation while ' + this.q4n_1.toString() + ' is in progress';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (!op.t3j()) {
      ensureNotNull(this.r4n_1).i4q(op);
    }
  };
  protoOf(UndoableTransaction).h4o = function (op) {
    if (!op.t3j()) {
      ensureNotNull(this.r4n_1).h4q(op);
    }
  };
  function ViewStateProvider() {
  }
  var UndoCommandType_EMPTY_instance;
  var UndoCommandType_NAVIGATION_instance;
  var UndoCommandType_EDITING_instance;
  var UndoCommandType_entriesInitialized;
  function UndoCommandType_initEntries() {
    if (UndoCommandType_entriesInitialized)
      return Unit_instance;
    UndoCommandType_entriesInitialized = true;
    UndoCommandType_EMPTY_instance = new UndoCommandType('EMPTY', 0);
    UndoCommandType_NAVIGATION_instance = new UndoCommandType('NAVIGATION', 1);
    UndoCommandType_EDITING_instance = new UndoCommandType('EDITING', 2);
  }
  function UndoCommandType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function UndoCommandType_EMPTY_getInstance() {
    UndoCommandType_initEntries();
    return UndoCommandType_EMPTY_instance;
  }
  function UndoCommandType_NAVIGATION_getInstance() {
    UndoCommandType_initEntries();
    return UndoCommandType_NAVIGATION_instance;
  }
  function UndoCommandType_EDITING_getInstance() {
    UndoCommandType_initEntries();
    return UndoCommandType_EDITING_instance;
  }
  function simpleStateProperty($this, stackId, stack) {
    return new SingleStackUndoManager$simpleStateProperty$1(stackId, stack);
  }
  function revert($this, stack) {
    var command = stack.f4o();
    command.b4q($this);
    var extOps = command.t4p();
    if (!stack.np()) {
      stack.bg().u4p(extOps);
    }
    UndoUtils_instance.q4p(stack, $this.n4o());
    return command.w4n_1;
  }
  function push_0($this, stack, data) {
    stack.g4o(new UndoableCommand(data, setOf(ensureNotNull($this.p4o()))));
    UndoUtils_instance.q4p(stack, $this.n4o());
  }
  function SingleStackUndoManager$simpleStateProperty$1($stackId, $stack) {
    this.o4q_1 = $stack;
    DerivedProperty.call(this, [$stack.wo()]);
    this.n4q_1 = Companion_instance_70.n4p(null, new UndoRejectionInfo(Kind_EMPTY_STACK_getInstance(), setOf($stackId)));
  }
  protoOf(SingleStackUndoManager$simpleStateProperty$1).g2c = function () {
    var tmp;
    if (this.o4q_1.np()) {
      tmp = this.n4q_1;
    } else {
      tmp = Companion_instance_70.m4p(this.o4q_1.bg().w4n_1);
    }
    return tmp;
  };
  function SingleStackUndoManager(model, commandNotifier, maxStackSize, allowUndo, nodeFactory) {
    allowUndo = allowUndo === VOID ? true : allowUndo;
    BaseUndoManager.call(this, model, commandNotifier, allowUndo, nodeFactory);
    var stackId = new SimpleUndoStackId(new Object());
    this.y4q_1 = new UndoStackImpl(maxStackSize);
    this.a4r_1 = simpleStateProperty(this, stackId, this.y4q_1);
    this.z4q_1 = new UndoStackImpl(maxStackSize);
    this.b4r_1 = simpleStateProperty(this, stackId, this.z4q_1);
    protoOf(BaseUndoManager).q4o.call(this, stackId);
  }
  protoOf(SingleStackUndoManager).b4p = function () {
    return this.a4r_1;
  };
  protoOf(SingleStackUndoManager).h4p = function () {
    return this.b4r_1;
  };
  protoOf(SingleStackUndoManager).u4n = function () {
    return listOf(this.y4q_1);
  };
  protoOf(SingleStackUndoManager).d4o = function () {
    return listOf(this.z4q_1);
  };
  protoOf(SingleStackUndoManager).q4o = function (stackId) {
    throw UnsupportedOperationException_init_$Create$_0('Cannot change stack for single-stack manager');
  };
  protoOf(SingleStackUndoManager).y4o = function () {
    return revert(this, this.y4q_1);
  };
  protoOf(SingleStackUndoManager).z4o = function () {
    return revert(this, this.z4q_1);
  };
  protoOf(SingleStackUndoManager).r4o = function (data, isCommonOp) {
    if (!data.t3j() && isCommonOp) {
      this.z4q_1.m2();
    }
    push_0(this, this.y4q_1, data);
  };
  protoOf(SingleStackUndoManager).s4o = function (data) {
    return push_0(this, this.z4q_1, data);
  };
  function singleStackUndoManager(processor, maxStackSize, allowUndo) {
    maxStackSize = maxStackSize === VOID ? 0 : maxStackSize;
    allowUndo = allowUndo === VOID ? true : allowUndo;
    return new SingleStackUndoManager(processor.d3j_1, processor, maxStackSize, allowUndo, processor.g3j_1);
  }
  function Command_init_$Init$(commandId, baseVersion, operation, $this) {
    Command.call($this, commandId, baseVersion, baseVersion + 1 | 0, operation);
    return $this;
  }
  function Command_init_$Create$(commandId, baseVersion, operation) {
    return Command_init_$Init$(commandId, baseVersion, operation, objectCreate(protoOf(Command)));
  }
  function toString_7($this, short) {
    var operationString = short ? LoggingUtils_instance.u2y($this.f4r_1) : toString_1($this.f4r_1);
    return 'Command(' + $this.c4r_1.g4r_1.toString() + ', root id = ' + $this.c4r_1.h4r_1.toString() + ', ' + $this.d4r_1 + '->' + $this.e4r_1 + ', ' + operationString + ')';
  }
  function Command(commandId, baseVersion, resultVersion, operation) {
    this.c4r_1 = commandId;
    this.d4r_1 = baseVersion;
    this.e4r_1 = resultVersion;
    this.f4r_1 = operation;
    // Inline function 'kotlin.require' call
    if (!(this.d4r_1 <= this.e4r_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.command.Command.<anonymous>' call
      var message = 'Invalid versions range: ' + this.d4r_1 + ' -> ' + this.e4r_1 + ', op=\n' + EntityPrintOperationUtil_instance.v3j(this.f4r_1);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(Command).i4r = function (cmd, server) {
    var delta = server ? this.e4r_1 - this.d4r_1 | 0 : 0;
    var op = this.f4r_1.b3k(cmd.f4r_1, server);
    return new Command(cmd.c4r_1, cmd.d4r_1 + delta | 0, cmd.e4r_1 + delta | 0, op);
  };
  protoOf(Command).toString = function () {
    return toString_7(this, false);
  };
  protoOf(Command).hashCode = function () {
    var result = this.c4r_1.hashCode();
    result = imul(result, 31) + this.d4r_1 | 0;
    result = imul(result, 31) + this.e4r_1 | 0;
    result = imul(result, 31) + hashCode(this.f4r_1) | 0;
    return result;
  };
  protoOf(Command).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Command))
      return false;
    var tmp0_other_with_cast = other instanceof Command ? other : THROW_CCE();
    if (!this.c4r_1.equals(tmp0_other_with_cast.c4r_1))
      return false;
    if (!(this.d4r_1 === tmp0_other_with_cast.d4r_1))
      return false;
    if (!(this.e4r_1 === tmp0_other_with_cast.e4r_1))
      return false;
    if (!equals(this.f4r_1, tmp0_other_with_cast.f4r_1))
      return false;
    return true;
  };
  function CommandId_init_$Init$($this) {
    BaseId.call($this);
    CommandId.call($this);
    return $this;
  }
  function CommandId_init_$Create$() {
    return CommandId_init_$Init$(objectCreate(protoOf(CommandId)));
  }
  function CommandId_init_$Init$_0(id, $this) {
    BaseId.call($this, id);
    CommandId.call($this);
    return $this;
  }
  function CommandId_init_$Create$_0(id) {
    return CommandId_init_$Init$_0(id, objectCreate(protoOf(CommandId)));
  }
  function CommandId() {
  }
  function LoadCommandId_init_$Init$(rootId, entityId, $this) {
    entityId = entityId === VOID ? rootId : entityId;
    LoadCommandId_init_$Init$_0(CommandId_init_$Create$(), rootId, entityId, $this);
    return $this;
  }
  function LoadCommandId_init_$Create$(rootId, entityId) {
    return LoadCommandId_init_$Init$(rootId, entityId, objectCreate(protoOf(LoadCommandId)));
  }
  function LoadCommandId_init_$Init$_0(commandId, rootId, entityId, $this) {
    entityId = entityId === VOID ? rootId : entityId;
    LoadCommandId.call($this, commandId, new EntityReference(rootId, entityId == null ? rootId : entityId));
    return $this;
  }
  function LoadCommandId_init_$Create$_0(commandId, rootId, entityId) {
    return LoadCommandId_init_$Init$_0(commandId, rootId, entityId, objectCreate(protoOf(LoadCommandId)));
  }
  function LoadCommandId(commandId, reference) {
    this.j4r_1 = commandId;
    this.k4r_1 = reference;
  }
  protoOf(LoadCommandId).l4r = function () {
    return this.k4r_1.h35();
  };
  protoOf(LoadCommandId).o3i = function () {
    return this.k4r_1.f35_1;
  };
  protoOf(LoadCommandId).r3i = function () {
    return this.k4r_1.g35_1;
  };
  protoOf(LoadCommandId).toString = function () {
    return '[c = ' + this.j4r_1.toString() + ', r = ' + this.k4r_1.toString() + ']';
  };
  protoOf(LoadCommandId).hashCode = function () {
    var result = this.j4r_1.hashCode();
    result = imul(result, 31) + this.k4r_1.hashCode() | 0;
    return result;
  };
  protoOf(LoadCommandId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoadCommandId))
      return false;
    var tmp0_other_with_cast = other instanceof LoadCommandId ? other : THROW_CCE();
    if (!this.j4r_1.equals(tmp0_other_with_cast.j4r_1))
      return false;
    if (!this.k4r_1.equals(tmp0_other_with_cast.k4r_1))
      return false;
    return true;
  };
  function getTimestampFromOperation($this, op) {
    var tmp;
    if (op instanceof AnnotatedOperation) {
      tmp = (op instanceof AnnotatedOperation ? op : THROW_CCE()).e40_1;
    } else {
      tmp = currentTimeMillis();
    }
    return tmp;
  }
  function OtOperationRecord_init_$Init$(commandId, operation, baseVersion, resultVersion, timestamp, $this) {
    resultVersion = resultVersion === VOID ? Companion_instance_71.m4r(baseVersion) : resultVersion;
    timestamp = timestamp === VOID ? getTimestampFromOperation(Companion_instance_71, operation) : timestamp;
    OtOperationRecord.call($this);
    $this.n4r_1 = commandId;
    $this.o4r_1 = operation;
    $this.p4r_1 = baseVersion;
    $this.q4r_1 = resultVersion;
    $this.r4r_1 = timestamp;
    return $this;
  }
  function OtOperationRecord_init_$Init$_0(command, $this) {
    OtOperationRecord_init_$Init$(command.c4r_1, command.f4r_1, command.d4r_1, command.e4r_1, getTimestampFromOperation(Companion_instance_71, command.f4r_1), $this);
    return $this;
  }
  function OtOperationRecord_init_$Create$(command) {
    return OtOperationRecord_init_$Init$_0(command, objectCreate(protoOf(OtOperationRecord)));
  }
  function Companion_71() {
  }
  protoOf(Companion_71).m4r = function (baseVersion) {
    return baseVersion + 1 | 0;
  };
  var Companion_instance_71;
  function Companion_getInstance_71() {
    return Companion_instance_71;
  }
  protoOf(OtOperationRecord).o3i = function () {
    return this.n4r_1.h4r_1;
  };
  protoOf(OtOperationRecord).equals = function (other) {
    if (!(other instanceof OtOperationRecord))
      return false;
    return this.n4r_1.equals(other.n4r_1) && this.p4r_1 === other.p4r_1 && toString_1(this.o4r_1) === toString_1(other.o4r_1);
  };
  protoOf(OtOperationRecord).hashCode = function () {
    var result = this.n4r_1.hashCode();
    result = imul(31, result) + hashCode(this.o4r_1) | 0;
    result = imul(31, result) + this.p4r_1 | 0;
    result = imul(31, result) + this.q4r_1 | 0;
    result = imul(31, result) + this.r4r_1.w3(this.r4r_1.t3(32)).z3() | 0;
    return result;
  };
  protoOf(OtOperationRecord).toString = function () {
    return 'OtOperationRecord: rootId=' + this.o3i().i2s_1 + '; commandId=' + this.n4r_1.g4r_1.i2s_1 + '; baseVersion=' + this.p4r_1 + '; resultVersion=' + this.q4r_1 + '; ts=' + this.r4r_1.toString() + '; operation=' + toString_1(this.o4r_1);
  };
  function OtOperationRecord() {
    this.p4r_1 = 0;
    this.q4r_1 = 0;
    this.r4r_1 = new Long(0, 0);
  }
  function RootCommandId_init_$Init$(rootId, $this) {
    RootCommandId.call($this, CommandId_init_$Create$(), rootId);
    return $this;
  }
  function RootCommandId_init_$Create$(rootId) {
    return RootCommandId_init_$Init$(rootId, objectCreate(protoOf(RootCommandId)));
  }
  function RootCommandId(commandId, rootId) {
    this.g4r_1 = commandId;
    this.h4r_1 = rootId;
  }
  protoOf(RootCommandId).toString = function () {
    return 'RootCommandId(commandId=' + this.g4r_1.toString() + ', rootId=' + this.h4r_1.toString() + ')';
  };
  protoOf(RootCommandId).hashCode = function () {
    var result = this.g4r_1.hashCode();
    result = imul(result, 31) + this.h4r_1.hashCode() | 0;
    return result;
  };
  protoOf(RootCommandId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RootCommandId))
      return false;
    var tmp0_other_with_cast = other instanceof RootCommandId ? other : THROW_CCE();
    if (!this.g4r_1.equals(tmp0_other_with_cast.g4r_1))
      return false;
    if (!this.h4r_1.equals(tmp0_other_with_cast.h4r_1))
      return false;
    return true;
  };
  function MetaId_init_$Init$(flags, $this) {
    BaseId.call($this);
    MetaId.call($this);
    $this.r33_1 = flags;
    return $this;
  }
  function MetaId_init_$Init$_0(id, flags, $this) {
    BaseId.call($this, id);
    MetaId.call($this);
    $this.r33_1 = flags;
    return $this;
  }
  function MetaId_init_$Init$_1(id, name, flags, $this) {
    BaseId.call($this, id, name);
    MetaId.call($this);
    $this.r33_1 = flags;
    return $this;
  }
  protoOf(MetaId).s33 = function () {
    return this.r33_1;
  };
  protoOf(MetaId).toString = function () {
    return protoOf(BaseId).toString.call(this) + '(' + toString_1(this.r33_1) + ')';
  };
  function MetaId() {
  }
  function RoleId_init_$Init$(flags, $this) {
    MetaId_init_$Init$(flags, $this);
    RoleId.call($this);
    return $this;
  }
  function RoleId_init_$Init$_0(id, flags, $this) {
    MetaId_init_$Init$_0(id, flags, $this);
    RoleId.call($this);
    return $this;
  }
  function RoleId_init_$Init$_1(id, name, flags, $this) {
    MetaId_init_$Init$_1(id, name, flags, $this);
    RoleId.call($this);
    return $this;
  }
  function Companion_72() {
    Companion_instance_72 = this;
    this.b3c_1 = setOf(RoleIdFlag_SINGLE_getInstance());
    this.c3c_1 = emptySet();
  }
  var Companion_instance_72;
  function Companion_getInstance_72() {
    if (Companion_instance_72 == null)
      new Companion_72();
    return Companion_instance_72;
  }
  protoOf(RoleId).b32 = function () {
    return this.s33().s(RoleIdFlag_SINGLE_getInstance());
  };
  protoOf(RoleId).toString = function () {
    return protoOf(MetaId).toString.call(this) + (this.b32() ? ' (single)' : '');
  };
  function RoleId() {
    Companion_getInstance_72();
  }
  var RoleIdFlag_SINGLE_instance;
  function values_2() {
    return [RoleIdFlag_SINGLE_getInstance()];
  }
  var RoleIdFlag_entriesInitialized;
  function RoleIdFlag_initEntries() {
    if (RoleIdFlag_entriesInitialized)
      return Unit_instance;
    RoleIdFlag_entriesInitialized = true;
    RoleIdFlag_SINGLE_instance = new RoleIdFlag('SINGLE', 0);
  }
  function RoleIdFlag(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function RoleIdFlag_SINGLE_getInstance() {
    RoleIdFlag_initEntries();
    return RoleIdFlag_SINGLE_instance;
  }
  function AdditionalModelContext() {
    this.s4r_1 = HashSet_init_$Create$();
    this.t4r_1 = new Listeners();
  }
  protoOf(AdditionalModelContext).u4r = function () {
    return this.s4r_1;
  };
  protoOf(AdditionalModelContext).d35 = function (listener) {
    return this.t4r_1.z27(listener);
  };
  function EntityWrapper$1(this$0) {
    this.z4r_1 = this$0;
    DerivedProperty.call(this, [this$0.b4s_1.f33()]);
  }
  protoOf(EntityWrapper$1).l2c = function () {
    return 'parent(' + this.z4r_1.b4s_1.toString() + ')';
  };
  protoOf(EntityWrapper$1).g2c = function () {
    return this.z4r_1.yt();
  };
  function EntityWrapper$getModelRootNodeProperty$lambda(it) {
    return it == null ? null : it.g30_1;
  }
  function EntityWrapper$getModelRootNodeProperty$lambda_0(it) {
    var tmp;
    if (it == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.ot.model.wrapper.EntityWrapper.getModelRootNodeProperty.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver = it.c38_1;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.apply' call
        // Inline function 'jetbrains.ocelot.ot.model.wrapper.EntityWrapper.getModelRootNodeProperty.<anonymous>.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.check' call
        if (!equals(tmp0_safe_receiver.g30_1, it)) {
          // Inline function 'jetbrains.ocelot.ot.model.wrapper.EntityWrapper.getModelRootNodeProperty.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          var message = 'Node is not root';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        tmp_0 = tmp0_safe_receiver;
      }
      var tmp1_elvis_lhs = tmp_0;
      tmp = tmp1_elvis_lhs == null ? new Model(it) : tmp1_elvis_lhs;
    }
    return tmp;
  }
  function EntityWrapper(context, entity) {
    this.a4s_1 = context;
    this.b4s_1 = entity;
    var tmp = this;
    tmp.c4s_1 = new EntityWrapper$1(this);
    this.a4s_1.w4s(this);
  }
  protoOf(EntityWrapper).yt = function () {
    var parent = this.b4s_1.yt();
    var tmp;
    if (parent == null) {
      tmp = null;
    } else {
      tmp = this.a4s_1.x4s(parent);
    }
    return tmp;
  };
  protoOf(EntityWrapper).y4s = function (blobId) {
    var modelProp = this.b4s_1.p33(blobId);
    return this.a4s_1.z4s(modelProp);
  };
  protoOf(EntityWrapper).a4t = function (blobId) {
    var modelProperty = this.b4s_1.p33(blobId);
    var tmp = EntityWrapper$getModelRootNodeProperty$lambda;
    return map_1(modelProperty, tmp, EntityWrapper$getModelRootNodeProperty$lambda_0);
  };
  protoOf(EntityWrapper).toString = function () {
    var tmp0_elvis_lhs = getKClassFromExpression(this).lb();
    var className = tmp0_elvis_lhs == null ? '<anonymous entity concept>' : tmp0_elvis_lhs;
    return className + '@' + toString_3(hashCode(this), 16) + '[' + this.b4s_1.toString() + ']';
  };
  function getWrapperFor($this, node) {
    return $this.b4t_1.d4t(node);
  }
  function doGetChildren($this, childId, requestedClass) {
    var tmp = $this.c4t_1.l38(childId);
    var source = isInterface(tmp, MutableObservableList) ? tmp : THROW_CCE();
    var toTarget = NodeWrapper$doGetChildren$lambda($this, requestedClass);
    var toSource = NodeWrapper$doGetChildren$lambda_0;
    return new ObservableListWrapper(source, toTarget, toSource);
  }
  function propertyByStringProperty($this, prop, persister) {
    return new NodeWrapper$propertyByStringProperty$1(prop, persister);
  }
  function NodeWrapper$parentProperty$1(this$0) {
    this.i4t_1 = this$0;
    DerivedProperty.call(this, [this$0.c4t_1.f33()]);
  }
  protoOf(NodeWrapper$parentProperty$1).l2c = function () {
    return 'parent(' + this.i4t_1.c4t_1.toString() + ')';
  };
  protoOf(NodeWrapper$parentProperty$1).g2c = function () {
    return this.i4t_1.z39();
  };
  function NodeWrapper$doGetChildren$lambda(this$0, $requestedClass) {
    return function (sourceNode) {
      return this$0.b4t_1.j4t(sourceNode, $requestedClass);
    };
  }
  function NodeWrapper$doGetChildren$lambda_0(target) {
    return target.c4t_1;
  }
  function NodeWrapper$descendants$lambda(this$0) {
    return function (it) {
      return this$0.b4t_1.j4t(it instanceof Node_0 ? it : THROW_CCE(), getKClass(NodeWrapper));
    };
  }
  function NodeWrapper$allChildren$lambda(this$0) {
    return function (it) {
      return this$0.b4t_1.j4t(it instanceof Node_0 ? it : THROW_CCE(), getKClass(NodeWrapper));
    };
  }
  function NodeWrapper$propertyByStringProperty$1($prop, $persister) {
    this.k4t_1 = $prop;
    this.l4t_1 = $persister;
    BaseReadableProperty.call(this);
  }
  protoOf(NodeWrapper$propertyByStringProperty$1).l2c = function () {
    return 'fromStringProp(' + this.k4t_1.l2c() + ', ' + toString_1(this.l4t_1) + ')';
  };
  protoOf(NodeWrapper$propertyByStringProperty$1).qr = function () {
    var value = this.k4t_1.qr();
    try {
      return this.l4t_1.q2q(value);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        throw IllegalStateException_init_$Create$_1('Property ' + toString_1(this.k4t_1) + ' contains non-deserializable value: ' + value, e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(NodeWrapper$propertyByStringProperty$1).t2c = function (newValue) {
    var value;
    try {
      value = this.l4t_1.x2p(newValue);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        throw IllegalArgumentException_init_$Create$_1('Property ' + toString_1(this.k4t_1) + ' has assigned to non-serializable value: ' + toString_0(newValue), e);
      } else {
        throw $p;
      }
    }
    this.k4t_1.t2c(value);
  };
  protoOf(NodeWrapper$propertyByStringProperty$1).k2c = function (handler) {
    return this.k4t_1.o27(new PropertyEventHandlerWrapper(handler, this.l4t_1));
  };
  protoOf(NodeWrapper$propertyByStringProperty$1).o27 = function (handler) {
    return this.k2c(handler);
  };
  function NodeWrapper(context, node) {
    this.b4t_1 = context;
    this.c4t_1 = node;
    this.b4t_1.m4t(this);
  }
  protoOf(NodeWrapper).v39 = function () {
    return this.c4t_1.v39();
  };
  protoOf(NodeWrapper).z39 = function () {
    var tmp0_safe_receiver = this.c4t_1.z39();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.ot.model.wrapper.NodeWrapper.<get-parentNode>.<anonymous>' call
      tmp = getWrapperFor(this, tmp0_safe_receiver instanceof Node_0 ? tmp0_safe_receiver : THROW_CCE());
    }
    return tmp;
  };
  protoOf(NodeWrapper).i3f = function () {
    return this.c4t_1.c38_1;
  };
  protoOf(NodeWrapper).f33 = function () {
    return new NodeWrapper$parentProperty$1(this);
  };
  protoOf(NodeWrapper).f3b = function (propertyId) {
    return this.c4t_1.f3b(propertyId);
  };
  protoOf(NodeWrapper).n4t = function (propertyId) {
    return this.o4t(propertyId, Persisters_getInstance().j2q());
  };
  protoOf(NodeWrapper).p4t = function (propertyId) {
    return this.o4t(propertyId, Persisters_getInstance().d2r());
  };
  protoOf(NodeWrapper).o4t = function (propertyId, persister) {
    return propertyByStringProperty(this, this.c4t_1.z38(propertyId), persister);
  };
  protoOf(NodeWrapper).q4t = function (childId) {
    // Inline function 'kotlin.require' call
    if (!childId.b32()) {
      // Inline function 'jetbrains.ocelot.ot.model.wrapper.NodeWrapper.getChild.<anonymous>' call
      var message = 'child property is supported only for single role node child id ' + childId.i2s_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return asSingleItemCollectionProp(doGetChildren(this, childId, null));
  };
  protoOf(NodeWrapper).r4t = function (childId) {
    return this.s4t(childId, null);
  };
  protoOf(NodeWrapper).s4t = function (childId, requestedClass) {
    // Inline function 'kotlin.require' call
    if (!!childId.b32()) {
      // Inline function 'jetbrains.ocelot.ot.model.wrapper.NodeWrapper.getChildren.<anonymous>' call
      var message = 'observable list of children is supported only for multi role node child id ' + childId.i2s_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return doGetChildren(this, childId, requestedClass);
  };
  protoOf(NodeWrapper).t4t = function (with_0) {
    return this.c4t_1.q3b(with_0.c4t_1);
  };
  protoOf(NodeWrapper).n3b = function () {
    return this.c4t_1.n3b();
  };
  protoOf(NodeWrapper).u4t = function () {
    var copy = this.c4t_1.m3b();
    return getWrapperFor(this, copy instanceof Node_0 ? copy : THROW_CCE());
  };
  protoOf(NodeWrapper).o3b = function (includeSelf) {
    var tmp = this.c4t_1.o3b(includeSelf);
    return map(tmp, NodeWrapper$descendants$lambda(this));
  };
  protoOf(NodeWrapper).p3b = function () {
    var tmp = this.c4t_1.p3b();
    return map(tmp, NodeWrapper$allChildren$lambda(this));
  };
  protoOf(NodeWrapper).toString = function () {
    var tmp0_elvis_lhs = getKClassFromExpression(this).lb();
    var className = tmp0_elvis_lhs == null ? '<anonymous concept>' : tmp0_elvis_lhs;
    var hashCode_0 = toString_3(hashCode(this), 16);
    return className + '@' + hashCode_0 + '[' + this.c4t_1.toString() + ']';
  };
  function NodeWrapperFactory() {
  }
  protoOf(NodeWrapperFactory).w4t = function (context, node, requestedClass, errorMessage) {
    return null;
  };
  function ReferenceListener$onReferencedEntityAdded$ref() {
    var l = function (p0) {
      p0.x4t();
      return Unit_instance;
    };
    l.callableName = 'onReferencedEntityAdded';
    return l;
  }
  function ReferenceListener$onReferencedEntityRemoved$ref() {
    var l = function (p0) {
      p0.y4t();
      return Unit_instance;
    };
    l.callableName = 'onReferencedEntityRemoved';
    return l;
  }
  function WrapperContext_init_$Init$(entityContext, $this) {
    entityContext = entityContext === VOID ? new EntityContext() : entityContext;
    WrapperContext.call($this, entityContext, new AdditionalModelContext());
    return $this;
  }
  function WrapperContext_init_$Create$(entityContext) {
    return WrapperContext_init_$Init$(entityContext, objectCreate(protoOf(WrapperContext)));
  }
  function watchModel($this, model) {
    $this.u4s_1.k1(model.b3a());
    var disposable = model.e3a(new WrapperContext$watchModel$disposable$1($this));
    // Inline function 'kotlin.collections.set' call
    $this.n4s_1.r2(model, disposable);
  }
  function createWrapperFor($this, entity) {
    $this.j4s_1.qr().e(entity);
    try {
      var wrapper;
      var _iterator__ex2g4s = $this.i4s_1.k();
      while (_iterator__ex2g4s.l()) {
        var factory = _iterator__ex2g4s.m();
        wrapper = factory.z4t($this, entity);
        if (!(wrapper == null)) {
          checkDetached($this, entity);
          return wrapper instanceof EntityWrapper ? wrapper : THROW_CCE();
        }
      }
      throw IllegalArgumentException_init_$Create$_0('Cannot create wrapper for entity ' + entity.toString());
    }finally {
      $this.j4s_1.qr().k2(entity);
    }
  }
  function checkDetached($this, entity) {
    if (!(entity.m2z_1 === $this.d4s_1)) {
      $this.t4s_1.e(entity);
    }
  }
  function createWrapperFor_0($this, node, requestedClass) {
    var result = null;
    $this.j4s_1.qr().e(node);
    try {
      var _iterator__ex2g4s = $this.p4s_1.k();
      $l$loop: while (_iterator__ex2g4s.l()) {
        var factory = _iterator__ex2g4s.m();
        var wrapper = factory.v4t($this, node);
        if (!(wrapper == null)) {
          // Inline function 'kotlin.check' call
          if (!(wrapper.c4t_1 === node)) {
            // Inline function 'jetbrains.ocelot.ot.model.wrapper.WrapperContext.createWrapperFor.<anonymous>' call
            var message = 'Factory ' + toString_1(factory) + ' provided a wrapper for a node different to ' + node.toString();
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
          var wrapperResult = wrapper instanceof NodeWrapper ? wrapper : THROW_CCE();
          result = wrapperResult;
          break $l$loop;
        }
      }
      var errorMessage = 'Cannot create wrapper for node: ' + node.toString() + ', requestedClass: ' + toString_0(requestedClass);
      if (result == null) {
        var _iterator__ex2g4s_0 = $this.p4s_1.k();
        $l$loop_0: while (_iterator__ex2g4s_0.l()) {
          var factory_0 = _iterator__ex2g4s_0.m();
          var errorWrapper = factory_0.w4t($this, node, requestedClass, errorMessage);
          if (!(errorWrapper == null)) {
            // Inline function 'kotlin.check' call
            if (!(errorWrapper.c4t_1 === node)) {
              // Inline function 'jetbrains.ocelot.ot.model.wrapper.WrapperContext.createWrapperFor.<anonymous>' call
              var message_0 = 'Factory ' + toString_1(factory_0) + ' provided error a wrapper for a node different to ' + node.toString();
              throw IllegalStateException_init_$Create$_0(toString_1(message_0));
            }
            result = errorWrapper;
            Companion_getInstance_73().a4u_1.do(errorMessage);
            break $l$loop_0;
          }
        }
      }
      var tmp2 = result;
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp2 == null) {
          // Inline function 'jetbrains.ocelot.ot.model.wrapper.WrapperContext.createWrapperFor.<anonymous>' call
          var message_1 = errorMessage;
          throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
        } else {
          break $l$block;
        }
      }
      checkDetached_0($this, node);
      return result;
    }finally {
      $this.j4s_1.qr().k2(node);
    }
  }
  function checkDetached_0($this, node) {
    var model = node.c38_1;
    if (model == null || !$this.n4s_1.w2(model)) {
      $this.u4s_1.e(node);
    }
  }
  function DefaultLoadingPeer($outer) {
    this.c4u_1 = $outer;
  }
  function Companion_73() {
    Companion_instance_73 = this;
    this.a4u_1 = getLogger(getKClass(WrapperContext));
    this.b4u_1 = 60000;
  }
  var Companion_instance_73;
  function Companion_getInstance_73() {
    if (Companion_instance_73 == null)
      new Companion_73();
    return Companion_instance_73;
  }
  function WrapperContext$creatingWrapperFor$lambda() {
    return HashSet_init_$Create$();
  }
  function WrapperContext$1(this$0) {
    this.d4u_1 = this$0;
  }
  protoOf(WrapperContext$1).c34 = function (entity) {
    var id = entity.j2z_1;
    var tmp0_safe_receiver = this.d4u_1.s4s_1.y2(id);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a28(ReferenceListener$onReferencedEntityAdded$ref());
    }
    this.d4u_1.t4s_1.k2(entity);
  };
  protoOf(WrapperContext$1).d34 = function (entity) {
    var id = entity.j2z_1;
    var tmp0_safe_receiver = this.d4u_1.s4s_1.y2(id);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a28(ReferenceListener$onReferencedEntityRemoved$ref());
    }
    this.d4u_1.t4s_1.e(entity);
  };
  function WrapperContext$modelAttachListener$1(this$0) {
    this.e4u_1 = this$0;
  }
  protoOf(WrapperContext$modelAttachListener$1).s34 = function (model) {
    return watchModel(this.e4u_1, model);
  };
  protoOf(WrapperContext$modelAttachListener$1).t34 = function (model) {
    this.e4u_1.u4s_1.o(model.b3a());
    ensureNotNull(this.e4u_1.n4s_1.s2(model)).vr();
  };
  function WrapperContext$watchModel$disposable$1(this$0) {
    this.f4u_1 = this$0;
  }
  protoOf(WrapperContext$watchModel$disposable$1).x39 = function (node) {
    this.f4u_1.u4s_1.k2(node);
  };
  protoOf(WrapperContext$watchModel$disposable$1).y39 = function (node) {
    this.f4u_1.u4s_1.e(node);
  };
  function WrapperContext$wrap$lambda(this$0) {
    return function (input) {
      var tmp;
      if (input == null) {
        tmp = null;
      } else {
        tmp = this$0.g4u(input.g30_1);
      }
      return tmp;
    };
  }
  function WrapperContext$wrap$lambda_0(input) {
    var tmp;
    if (input == null) {
      tmp = null;
    } else {
      var model = input.i3f();
      var tmp_0;
      if (model == null) {
        tmp_0 = new Model(input.c4t_1);
      } else {
        // Inline function 'kotlin.check' call
        if (!equals(model.g30_1, input.c4t_1)) {
          // Inline function 'jetbrains.ocelot.ot.model.wrapper.WrapperContext.wrap.<anonymous>.<anonymous>' call
          var message = 'Wrapped node is not root';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        tmp_0 = model;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function WrapperContext$wrapEntitySet$lambda(this$0) {
    return function (item) {
      return this$0.x4s(item);
    };
  }
  function WrapperContext$wrapEntitySet$lambda_0(wrapper) {
    return wrapper.b4s_1;
  }
  function WrapperContext$put$$inlined$toDisposable$1(this$0, $key) {
    this.h4u_1 = this$0;
    this.i4u_1 = $key;
  }
  protoOf(WrapperContext$put$$inlined$toDisposable$1).vr = function () {
    this.h4u_1.k4s_1.s2(this.i4u_1);
    return Unit_instance;
  };
  function WrapperContext(entityContext, additionalModelContext) {
    Companion_getInstance_73();
    entityContext = entityContext === VOID ? new EntityContext() : entityContext;
    additionalModelContext = additionalModelContext === VOID ? new AdditionalModelContext() : additionalModelContext;
    this.d4s_1 = entityContext;
    this.e4s_1 = additionalModelContext;
    this.h4s_1 = HashMap_init_$Create$();
    this.i4s_1 = ArrayList_init_$Create$();
    var tmp = this;
    tmp.j4s_1 = newSimpleThreadLocal(WrapperContext$creatingWrapperFor$lambda);
    this.k4s_1 = HashMap_init_$Create$();
    this.n4s_1 = HashMap_init_$Create$();
    this.o4s_1 = HashMap_init_$Create$();
    this.p4s_1 = ArrayList_init_$Create$();
    this.q4s_1 = true;
    this.s4s_1 = HashMap_init_$Create$();
    this.t4s_1 = HashSet_init_$Create$();
    this.u4s_1 = HashSet_init_$Create$();
    this.v4s_1 = new DefaultLoadingPeer(this);
    this.f4s_1 = this.j4u(this.d4s_1.c31_1);
    this.g4s_1 = this.j4u(this.d4s_1.w34());
    var _iterator__ex2g4s = this.d4s_1.w34().k();
    while (_iterator__ex2g4s.l()) {
      var entity = _iterator__ex2g4s.m();
      var _iterator__ex2g4s_0 = entity.d30().k();
      while (_iterator__ex2g4s_0.l()) {
        var blobId = _iterator__ex2g4s_0.m();
        watchModel(this, ensureNotNull(entity.e30(blobId)));
      }
    }
    var tmp_0 = this;
    tmp_0.r4s_1 = this.d4s_1.c35(new WrapperContext$1(this));
    var modelAttachListener = new WrapperContext$modelAttachListener$1(this);
    this.l4s_1 = this.d4s_1.d35(modelAttachListener);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_1 = this.e4s_1.u4r().k();
    while (_iterator__ex2g4s_1.l()) {
      var element = _iterator__ex2g4s_1.m();
      // Inline function 'jetbrains.ocelot.ot.model.wrapper.WrapperContext.stub_for_inlining' call
      watchModel(this, element);
    }
    this.m4s_1 = this.e4s_1.d35(modelAttachListener);
  }
  protoOf(WrapperContext).vr = function () {
    var _iterator__ex2g4s = this.n4s_1.v2().k();
    while (_iterator__ex2g4s.l()) {
      var disposable = _iterator__ex2g4s.m();
      disposable.vr();
    }
    this.m4s_1.vr();
    this.l4s_1.vr();
    this.r4s_1.vr();
  };
  protoOf(WrapperContext).k4u = function (factory) {
    this.p4s_1.e(factory);
  };
  protoOf(WrapperContext).l4u = function (factory) {
    this.i4s_1.e(factory);
  };
  protoOf(WrapperContext).z4s = function (modelProp) {
    var sourceToTarget = WrapperContext$wrap$lambda(this);
    var targetToSource = WrapperContext$wrap$lambda_0;
    return map_1(modelProp, sourceToTarget, targetToSource);
  };
  protoOf(WrapperContext).j4u = function (set) {
    var tmp = WrapperContext$wrapEntitySet$lambda(this);
    return new ObservableSetWrapper(set, tmp, WrapperContext$wrapEntitySet$lambda_0);
  };
  protoOf(WrapperContext).w4s = function (entityWrapper) {
    var entity = entityWrapper.b4s_1;
    // Inline function 'kotlin.collections.set' call
    this.h4s_1.r2(entity, entityWrapper);
    checkDetached(this, entity);
  };
  protoOf(WrapperContext).m4t = function (nodeWrapper) {
    var node = nodeWrapper.c4t_1;
    // Inline function 'kotlin.collections.set' call
    this.o4s_1.r2(node, nodeWrapper);
    checkDetached_0(this, node);
  };
  protoOf(WrapperContext).m4u = function (node, requestedClass) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(node instanceof Node_0)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return this.j4t(node, requestedClass);
  };
  protoOf(WrapperContext).g4u = function (node, requestedClass, $super) {
    requestedClass = requestedClass === VOID ? null : requestedClass;
    return $super === VOID ? this.m4u(node, requestedClass) : $super.m4u.call(this, node, requestedClass);
  };
  protoOf(WrapperContext).j4t = function (node, requestedClass) {
    // Inline function 'kotlin.check' call
    if (!!this.j4s_1.qr().s(node)) {
      // Inline function 'jetbrains.ocelot.ot.model.wrapper.WrapperContext.getWrapperFor.<anonymous>' call
      var message = 'Create wrapper for node ' + node.toString() + ' is still in progress';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if (this.o4s_1.w2(node)) {
      var tmp_0 = this.o4s_1.y2(node);
      tmp = tmp_0 instanceof NodeWrapper ? tmp_0 : THROW_CCE();
    } else {
      tmp = createWrapperFor_0(this, node, requestedClass);
    }
    return tmp;
  };
  protoOf(WrapperContext).d4t = function (node, requestedClass, $super) {
    requestedClass = requestedClass === VOID ? null : requestedClass;
    return $super === VOID ? this.j4t(node, requestedClass) : $super.j4t.call(this, node, requestedClass);
  };
  protoOf(WrapperContext).x4s = function (entity) {
    // Inline function 'kotlin.check' call
    if (!!this.j4s_1.qr().s(entity)) {
      // Inline function 'jetbrains.ocelot.ot.model.wrapper.WrapperContext.getWrapperFor.<anonymous>' call
      var message = 'Create wrapper for entity ' + entity.toString() + ' is still in progress';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if (this.h4s_1.w2(entity)) {
      var tmp_0 = this.h4s_1.y2(entity);
      tmp = tmp_0 instanceof EntityWrapper ? tmp_0 : THROW_CCE();
    } else {
      tmp = createWrapperFor(this, entity);
    }
    return tmp;
  };
  protoOf(WrapperContext).n4u = function (key) {
    var tmp0_elvis_lhs = this.k4s_1.y2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Missing wrapper context element: ' + key.toString());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var result = tmp;
    return !(result == null) ? result : THROW_CCE();
  };
  protoOf(WrapperContext).o4u = function (key) {
    var result = this.k4s_1.y2(key);
    return (result == null ? true : !(result == null)) ? result : THROW_CCE();
  };
  protoOf(WrapperContext).p4u = function (key, value) {
    // Inline function 'kotlin.check' call
    if (!!this.k4s_1.w2(key)) {
      // Inline function 'jetbrains.ocelot.ot.model.wrapper.WrapperContext.put.<anonymous>' call
      var message = 'Wrapper context already contains value for the key: ' + key.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp1 = this.k4s_1;
    // Inline function 'kotlin.collections.set' call
    var value_0 = !(value == null) ? value : THROW_CCE();
    tmp1.r2(key, value_0);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new WrapperContext$put$$inlined$toDisposable$1(this, key);
  };
  function WrapperContextKey(name) {
    this.q4u_1 = name;
  }
  protoOf(WrapperContextKey).toString = function () {
    return this.q4u_1;
  };
  function WrapperContextService() {
  }
  var WrapperContextService_instance;
  function WrapperContextService_getInstance() {
    return WrapperContextService_instance;
  }
  function ReferenceListener() {
  }
  function AlreadyInvalidException(invalidationContext, message) {
    Exception_init_$Init$_0('Invalidation context is already invalid: ' + message + '; inv.context: ' + toString_1(invalidationContext == null ? 'not defined' : invalidationContext), this);
    captureStack(this, AlreadyInvalidException);
  }
  function Invalidation$ALWAYS_INVALIDATE$1() {
  }
  protoOf(Invalidation$ALWAYS_INVALIDATE$1).r4u = function (event, actions) {
    actions.s4u();
  };
  protoOf(Invalidation$ALWAYS_INVALIDATE$1).t4u = function (event, actions) {
    return this.r4u(!(event == null) ? event : THROW_CCE(), actions);
  };
  function Invalidation() {
    Invalidation_instance = this;
    this.u4u_1 = Invalidation_getInstance();
    var tmp = this;
    tmp.v4u_1 = new Invalidation$ALWAYS_INVALIDATE$1();
  }
  var Invalidation_instance;
  function Invalidation_getInstance() {
    if (Invalidation_instance == null)
      new Invalidation();
    return Invalidation_instance;
  }
  function assertValid(_this__u8e3s4, message) {
    if (!_this__u8e3s4.w4u()) {
      throw new AlreadyInvalidException(_this__u8e3s4, message());
    }
  }
  function _get_isActive__4an5s5($this) {
    return !($this.z4u_1 == null);
  }
  function recompute($this) {
    var inv = $this.x4u_1.b4v(fresh($this));
    var currentValue = inv.c4v();
    var tmp = inv.d4v();
    tmp.o27(new EagerInvalidatable$recompute$1($this, currentValue));
    return inv.c4v();
  }
  function fresh($this) {
    $this.y4u_1 = new Invalidator();
    return ensureNotNull($this.y4u_1);
  }
  function ValueHolder(value) {
    this.e4v_1 = value;
  }
  protoOf(ValueHolder).qr = function () {
    return this.e4v_1;
  };
  protoOf(ValueHolder).t2c = function (newValue) {
    this.e4v_1 = newValue;
  };
  function EagerInvalidatable$myListeners$1(this$0) {
    this.g4v_1 = this$0;
    EventHandlerListeners.call(this);
  }
  protoOf(EagerInvalidatable$myListeners$1).s27 = function () {
    this.g4v_1.z4u_1 = new ValueHolder(recompute(this.g4v_1));
  };
  protoOf(EagerInvalidatable$myListeners$1).w27 = function () {
    ensureNotNull(this.g4v_1.y4u_1).vr();
    this.g4v_1.y4u_1 = null;
    this.g4v_1.z4u_1 = null;
  };
  function EagerInvalidatable$recompute$1(this$0, $currentValue) {
    this.h4v_1 = this$0;
    this.i4v_1 = $currentValue;
  }
  protoOf(EagerInvalidatable$recompute$1).j4v = function (event) {
    if (!_get_isActive__4an5s5(this.h4v_1)) {
      return Unit_instance;
    }
    var newValue = recompute(this.h4v_1);
    if (equals(this.i4v_1, newValue)) {
      return Unit_instance;
    }
    ensureNotNull(this.h4v_1.z4u_1).t2c(newValue);
    var propertyChangeEvent = new PropertyChangeEvent(this.i4v_1, newValue);
    this.h4v_1.a4v_1.c2b(propertyChangeEvent);
  };
  protoOf(EagerInvalidatable$recompute$1).d28 = function (event) {
    return this.j4v(event instanceof Invalidation ? event : THROW_CCE());
  };
  function EagerInvalidatable(myComputation) {
    this.x4u_1 = myComputation;
    this.y4u_1 = null;
    this.z4u_1 = null;
    var tmp = this;
    tmp.a4v_1 = new EagerInvalidatable$myListeners$1(this);
  }
  protoOf(EagerInvalidatable).l2c = function () {
    return 'Eagerly recomputed invalidatable value';
  };
  protoOf(EagerInvalidatable).qr = function () {
    var tmp;
    if (!_get_isActive__4an5s5(this)) {
      tmp = this.x4u_1.b4v(Companion_getInstance_74().k4v_1).c4v();
    } else {
      tmp = ensureNotNull(this.z4u_1).qr();
    }
    return tmp;
  };
  protoOf(EagerInvalidatable).m4v = function (handler) {
    return this.a4v_1.z27(handler);
  };
  protoOf(EagerInvalidatable).o27 = function (handler) {
    return this.m4v(handler);
  };
  function depend(_this__u8e3s4, property) {
    _this__u8e3s4.n4v(property, Invalidation_getInstance().v4u_1);
    return property.qr();
  }
  function depend_0(_this__u8e3s4, collection) {
    _this__u8e3s4.n4v(collection, Invalidation_getInstance().v4u_1);
    return collection;
  }
  function affects(_this__u8e3s4, ctx) {
    ctx.n4v(_this__u8e3s4.d4v(), Invalidation_getInstance().v4u_1);
    return _this__u8e3s4.c4v();
  }
  function depend_1(_this__u8e3s4, inv) {
    return _this__u8e3s4.n4v(inv.d4v(), Invalidation_getInstance().v4u_1);
  }
  function InvalidatableBase() {
  }
  protoOf(InvalidatableBase).c4v = function () {
    if (!this.d4v().w4u()) {
      throw IllegalStateException_init_$Create$_0('Value is already invalid, must not be retrieved');
    }
    return this.o4v();
  };
  function release($this) {
    assertValid_0($this, InvalidationPointBase$release$lambda);
    $this.q4v_1 = false;
    $this.r4v();
  }
  function assertValid_0($this, message) {
    if (!$this.w4u()) {
      throw new AlreadyInvalidException(null, message());
    }
  }
  function InvalidationPointBase$addHandler$$inlined$toDisposable$1(this$0, $handler) {
    this.s4v_1 = this$0;
    this.t4v_1 = $handler;
  }
  protoOf(InvalidationPointBase$addHandler$$inlined$toDisposable$1).vr = function () {
    this.s4v_1.p4v_1.k2(this.t4v_1);
    return Unit_instance;
  };
  function InvalidationPointBase$release$lambda() {
    return "can't release: already invalid";
  }
  function InvalidationPointBase() {
    this.p4v_1 = ArrayDeque_init_$Create$();
    this.q4v_1 = true;
  }
  protoOf(InvalidationPointBase).w4u = function () {
    return this.q4v_1;
  };
  protoOf(InvalidationPointBase).u4v = function (handler) {
    if (!this.q4v_1) {
      handler.d28(Invalidation_getInstance());
      return Companion_getInstance_25().wr_1;
    }
    this.p4v_1.e(handler);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new InvalidationPointBase$addHandler$$inlined$toDisposable$1(this, handler);
  };
  protoOf(InvalidationPointBase).o27 = function (handler) {
    return this.u4v(handler);
  };
  protoOf(InvalidationPointBase).s4u = function () {
    release(this);
    var _iterator__ex2g4s = ArrayList_init_$Create$_1(this.p4v_1).k();
    while (_iterator__ex2g4s.l()) {
      var handler = _iterator__ex2g4s.m();
      handler.d28(Invalidation_getInstance().u4u_1);
    }
    this.p4v_1.m2();
  };
  protoOf(InvalidationPointBase).vr = function () {
    release(this);
    this.p4v_1.m2();
  };
  function Dependencies() {
    this.v4v_1 = HashMap_init_$Create$();
    this.w4v_1 = ArrayList_init_$Create$();
  }
  protoOf(Dependencies).x4v = function (disposable) {
    this.w4v_1.e(disposable);
  };
  protoOf(Dependencies).y4v = function (key) {
    return this.v4v_1.w2(key);
  };
  protoOf(Dependencies).z4v = function (key, value) {
    // Inline function 'kotlin.collections.set' call
    this.v4v_1.r2(key, value);
  };
  protoOf(Dependencies).vr = function () {
    var _iterator__ex2g4s = plus_4(this.v4v_1.v2(), this.w4v_1).k();
    while (_iterator__ex2g4s.l()) {
      var disposable = _iterator__ex2g4s.m();
      disposable.vr();
    }
    this.v4v_1.m2();
    this.w4v_1.m2();
  };
  function addEventHandler($this, eventSource, reaction) {
    var key = new SourceKey(eventSource, reaction);
    if ($this.b4w_1.y4v(key))
      return Unit_instance;
    $this.b4w_1.z4v(key, createEventHandler($this, eventSource, reaction));
  }
  function createEventHandler($this, eventSource, reaction) {
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var tmp$ret$0 = new Invalidator$createEventHandler$$inlined$eventHandler$1(reaction, $this);
    return eventSource.o27(tmp$ret$0);
  }
  function SourceKey(eventSource, reaction) {
    this.c4w_1 = eventSource;
    this.d4w_1 = reaction;
  }
  protoOf(SourceKey).equals = function (other) {
    var tmp;
    if (other instanceof SourceKey) {
      tmp = (this.c4w_1 === other.c4w_1 && this.d4w_1 === other.d4w_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SourceKey).hashCode = function () {
    return hashCode(this.c4w_1) + imul(31, hashCode(this.d4w_1)) | 0;
  };
  function Invalidator$1(this$0) {
    this.g4w_1 = this$0;
    InvalidationPointBase.call(this);
  }
  protoOf(Invalidator$1).r4v = function () {
    return this.g4w_1.b4w_1.vr();
  };
  function Invalidator$addEventSource$lambda() {
    return "Can't add EventSource";
  }
  function Invalidator$addDisposable$lambda() {
    return "Can't add Disposable";
  }
  function Invalidator$createEventHandler$1(this$0) {
    this.h4w_1 = this$0;
  }
  protoOf(Invalidator$createEventHandler$1).s4u = function () {
    this.h4w_1.a4w_1.s4u();
  };
  function Invalidator$createEventHandler$$inlined$eventHandler$1($reaction, this$0) {
    this.i4w_1 = $reaction;
    this.j4w_1 = this$0;
  }
  protoOf(Invalidator$createEventHandler$$inlined$eventHandler$1).e2b = function (event) {
    this.i4w_1.t4u(event, new Invalidator$createEventHandler$1(this.j4w_1));
    return Unit_instance;
  };
  protoOf(Invalidator$createEventHandler$$inlined$eventHandler$1).d28 = function (event) {
    return this.e2b((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function Invalidator$value$lambda() {
    return 'No reason to make value';
  }
  function Invalidator$value$2(this$0, $value) {
    this.k4w_1 = this$0;
    this.l4w_1 = $value;
    InvalidatableBase.call(this);
  }
  protoOf(Invalidator$value$2).d4v = function () {
    return this.k4w_1.a4w_1;
  };
  protoOf(Invalidator$value$2).o4v = function () {
    return this.l4w_1;
  };
  function Invalidator$failure$lambda() {
    return 'No reason to make failure';
  }
  function Invalidator$failure$2(this$0, $throwable) {
    this.m4w_1 = this$0;
    this.n4w_1 = $throwable;
    InvalidatableBase.call(this);
  }
  protoOf(Invalidator$failure$2).d4v = function () {
    return this.m4w_1.a4w_1;
  };
  protoOf(Invalidator$failure$2).o4v = function () {
    throw this.n4w_1;
  };
  function Invalidator() {
    this.b4w_1 = new Dependencies();
    var tmp = this;
    tmp.a4w_1 = new Invalidator$1(this);
  }
  protoOf(Invalidator).n4v = function (eventSource, reaction) {
    assertValid(this, Invalidator$addEventSource$lambda);
    addEventHandler(this, eventSource, reaction);
  };
  protoOf(Invalidator).o4w = function (disposable) {
    assertValid(this, Invalidator$addDisposable$lambda);
    this.b4w_1.x4v(disposable);
  };
  protoOf(Invalidator).w4u = function () {
    return this.a4w_1.w4u();
  };
  protoOf(Invalidator).vr = function () {
    this.a4w_1.vr();
  };
  protoOf(Invalidator).p4w = function (value) {
    assertValid(this, Invalidator$value$lambda);
    return new Invalidator$value$2(this, value);
  };
  protoOf(Invalidator).q4w = function (throwable) {
    assertValid(this, Invalidator$failure$lambda);
    return new Invalidator$failure$2(this, throwable);
  };
  function NonTrackingInvalidationContext$Companion$INVALIDATION_POINT$1() {
    InvalidationPointBase.call(this);
  }
  protoOf(NonTrackingInvalidationContext$Companion$INVALIDATION_POINT$1).r4v = function () {
  };
  function Companion_74() {
    Companion_instance_74 = this;
    this.k4v_1 = new NonTrackingInvalidationContext();
    var tmp = this;
    tmp.l4v_1 = new NonTrackingInvalidationContext$Companion$INVALIDATION_POINT$1();
  }
  var Companion_instance_74;
  function Companion_getInstance_74() {
    if (Companion_instance_74 == null)
      new Companion_74();
    return Companion_instance_74;
  }
  function NonTrackingInvalidationContext$value$1($value) {
    this.t4w_1 = $value;
    InvalidatableBase.call(this);
  }
  protoOf(NonTrackingInvalidationContext$value$1).d4v = function () {
    return Companion_getInstance_74().l4v_1;
  };
  protoOf(NonTrackingInvalidationContext$value$1).o4v = function () {
    return this.t4w_1;
  };
  function NonTrackingInvalidationContext$failure$1($throwable) {
    this.u4w_1 = $throwable;
    InvalidatableBase.call(this);
  }
  protoOf(NonTrackingInvalidationContext$failure$1).d4v = function () {
    return Companion_getInstance_74().l4v_1;
  };
  protoOf(NonTrackingInvalidationContext$failure$1).o4v = function () {
    throw this.u4w_1;
  };
  function NonTrackingInvalidationContext() {
    Companion_getInstance_74();
  }
  protoOf(NonTrackingInvalidationContext).w4u = function () {
    return true;
  };
  protoOf(NonTrackingInvalidationContext).n4v = function (eventSource, reaction) {
  };
  protoOf(NonTrackingInvalidationContext).o4w = function (disposable) {
    disposable.vr();
  };
  protoOf(NonTrackingInvalidationContext).vr = function () {
  };
  protoOf(NonTrackingInvalidationContext).p4w = function (value) {
    return new NonTrackingInvalidationContext$value$1(value);
  };
  protoOf(NonTrackingInvalidationContext).q4w = function (throwable) {
    return new NonTrackingInvalidationContext$failure$1(throwable);
  };
  function attributeQuery(value, attributeFunction) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new attributeQuery$$inlined$query$1(value, attributeFunction);
  }
  function InvalidateOnAttributeChanged$Companion$compareByIdentity$lambda(a, b) {
    return a === b;
  }
  function InvalidateOnAttributeChanged$Companion$compareByEquality$lambda(a, b) {
    return equals(a, b);
  }
  function Companion_75() {
    Companion_instance_75 = this;
    var tmp = this;
    tmp.v4w_1 = InvalidateOnAttributeChanged$Companion$compareByIdentity$lambda;
    var tmp_0 = this;
    tmp_0.w4w_1 = InvalidateOnAttributeChanged$Companion$compareByEquality$lambda;
  }
  var Companion_instance_75;
  function Companion_getInstance_75() {
    if (Companion_instance_75 == null)
      new Companion_75();
    return Companion_instance_75;
  }
  function InvalidateOnAttributeChanged(value, attributeFunction, compare) {
    Companion_getInstance_75();
    this.x4w_1 = value;
    this.y4w_1 = attributeFunction;
    this.z4w_1 = compare;
    this.a4x_1 = this.y4w_1(this.x4w_1);
  }
  protoOf(InvalidateOnAttributeChanged).r4u = function (event, actions) {
    var newValue = this.y4w_1(this.x4w_1);
    if (!this.z4w_1(newValue, this.a4x_1)) {
      this.a4x_1 = newValue;
      actions.s4u();
    }
  };
  protoOf(InvalidateOnAttributeChanged).t4u = function (event, actions) {
    return this.r4u(!(event == null) ? event : THROW_CCE(), actions);
  };
  function attributeQuery$$inlined$query$1($value, $attributeFunction) {
    this.b4x_1 = $value;
    this.c4x_1 = $attributeFunction;
  }
  protoOf(attributeQuery$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.query.attributeQuery.<anonymous>' call
    var reaction = new InvalidateOnAttributeChanged(this.b4x_1, this.c4x_1, Companion_getInstance_75().w4w_1);
    builder.g4x_1.e4x_1.n4v(this.b4x_1, reaction);
    return reaction.a4x_1;
  };
  function Execution(dependencies, observationContext) {
    this.e4x_1 = dependencies;
    this.f4x_1 = CoroutineScope_0(observationContext);
  }
  protoOf(Execution).i4x = function () {
    return get_isActive(this.f4x_1);
  };
  function asNullableProperty(_this__u8e3s4) {
    return withDefault(_this__u8e3s4, null);
  }
  function Ready(outcome) {
    Result_0.call(this);
    this.j4x_1 = outcome;
  }
  protoOf(Ready).toString = function () {
    return 'Ready(outcome=' + toString_1(this.j4x_1) + ')';
  };
  protoOf(Ready).hashCode = function () {
    return hashCode(this.j4x_1);
  };
  protoOf(Ready).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Ready))
      return false;
    var tmp0_other_with_cast = other instanceof Ready ? other : THROW_CCE();
    if (!equals(this.j4x_1, tmp0_other_with_cast.j4x_1))
      return false;
    return true;
  };
  function NotReady() {
    NotReady_instance = this;
    Result_0.call(this);
  }
  var NotReady_instance;
  function NotReady_getInstance() {
    if (NotReady_instance == null)
      new NotReady();
    return NotReady_instance;
  }
  function Success(value) {
    Outcome.call(this);
    this.k4x_1 = value;
  }
  protoOf(Success).toString = function () {
    return 'Success(value=' + toString_0(this.k4x_1) + ')';
  };
  protoOf(Success).hashCode = function () {
    return this.k4x_1 == null ? 0 : hashCode(this.k4x_1);
  };
  protoOf(Success).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Success))
      return false;
    var tmp0_other_with_cast = other instanceof Success ? other : THROW_CCE();
    if (!equals(this.k4x_1, tmp0_other_with_cast.k4x_1))
      return false;
    return true;
  };
  function Failure_0(throwable) {
    Outcome.call(this);
    this.l4x_1 = throwable;
  }
  protoOf(Failure_0).toString = function () {
    return 'Failure(throwable=' + this.l4x_1.toString() + ')';
  };
  protoOf(Failure_0).hashCode = function () {
    return hashCode(this.l4x_1);
  };
  protoOf(Failure_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Failure_0))
      return false;
    var tmp0_other_with_cast = other instanceof Failure_0 ? other : THROW_CCE();
    if (!equals(this.l4x_1, tmp0_other_with_cast.l4x_1))
      return false;
    return true;
  };
  function LoopingQuery$listeners$o$beforeFirstAdded$lambda(this$0) {
    return function (it) {
      var tmp;
      if (it instanceof CancellationException) {
        this$0.r4x_1 = NotReady_getInstance();
        tmp = Unit_instance;
      } else {
        if (it instanceof Error) {
          ThrowableHandlers_getInstance().ps_1.os(it);
          this$0.r4x_1 = NotReady_getInstance();
          tmp = Unit_instance;
        }
      }
      return Unit_instance;
    };
  }
  function LoopingQuery$launchComputingJob$slambda$lambda($event) {
    return function (it) {
      it.d28($event);
      return Unit_instance;
    };
  }
  function LoopingQuery$launchComputingJob$slambda$lambda_0($awaitInvalidation) {
    return function (it) {
      $awaitInvalidation.oz();
      return Unit_instance;
    };
  }
  function launchComputingJob($this) {
    var tmp = CoroutineStart_UNDISPATCHED_getInstance();
    return launch($this.p4x_1, VOID, tmp, LoopingQuery$launchComputingJob$slambda_0($this, null));
  }
  function Result_0() {
  }
  function Outcome() {
  }
  function LoopingQuery$_init_$slambda_vmyece(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LoopingQuery$_init_$slambda_vmyece).c4y = function (it, $completion) {
    var tmp = this.d4y(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(LoopingQuery$_init_$slambda_vmyece).oa = function (p1, $completion) {
    return this.c4y(p1 instanceof Outcome ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LoopingQuery$_init_$slambda_vmyece).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return true;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(LoopingQuery$_init_$slambda_vmyece).d4y = function (it, completion) {
    var i = new LoopingQuery$_init_$slambda_vmyece(completion);
    i.b4y_1 = it;
    return i;
  };
  function LoopingQuery$_init_$slambda_vmyece_0(resultContinuation) {
    var i = new LoopingQuery$_init_$slambda_vmyece(resultContinuation);
    var l = function (it, $completion) {
      return i.c4y(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function LoopingQuery$listeners$1(this$0) {
    this.f4y_1 = this$0;
    Listeners.call(this);
  }
  protoOf(LoopingQuery$listeners$1).s27 = function () {
    var tmp0_safe_receiver = this.f4y_1.q4x_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.pu();
    }
    var newComputingJob = launchComputingJob(this.f4y_1);
    newComputingJob.hu(LoopingQuery$listeners$o$beforeFirstAdded$lambda(this.f4y_1));
    this.f4y_1.q4x_1 = newComputingJob;
  };
  protoOf(LoopingQuery$listeners$1).w27 = function () {
    var tmp0_safe_receiver = this.f4y_1.q4x_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.pu();
    }
  };
  function LoopingQuery$launchComputingJob$slambda(this$0, resultContinuation) {
    this.o4y_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LoopingQuery$launchComputingJob$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(LoopingQuery$launchComputingJob$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LoopingQuery$launchComputingJob$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 31;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!get_isActive_0(this.p4y_1.et())) {
              this.y9_1 = 30;
              continue $sm;
            }

            this.o4y_1.o4x_1.e2m();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.u4y_1 = new Invalidator();
            this.z9_1 = 4;
            this.y9_1 = 3;
            suspendResult = supervise_0(this.o4y_1.m4x_1, this.u4y_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.v4y_1 = suspendResult;
            this.z9_1 = 31;
            this.y9_1 = 5;
            continue $sm;
          case 4:
            this.z9_1 = 31;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof AlreadyInvalidException) {
              this.w4y_1 = this.ba_1;
              this.y9_1 = 2;
              var tmp_1 = this;
              continue $sm;
            } else {
              var tmp_2 = this.ba_1;
              if (tmp_2 instanceof Error) {
                this.x4y_1 = this.ba_1;
                var tmp_3 = this;
                this.o4y_1.o4x_1.f2m();
                if (this.u4y_1.w4u()) {
                  this.u4y_1.vr();
                }
                throw this.x4y_1;
              } else {
                throw this.ba_1;
              }
            }

          case 5:
            this.z9_1 = 31;
            this.r4y_1 = this.v4y_1;
            this.q4y_1 = this.u4y_1;
            this.y9_1 = 6;
            continue $sm;
          case 6:
            this.y9_1 = 7;
            continue $sm;
          case 7:
            this.y9_1 = 8;
            continue $sm;
          case 8:
            this.z9_1 = 29;
            this.y9_1 = 9;
            continue $sm;
          case 9:
            this.z9_1 = 28;
            this.b4z_1 = this.o4y_1.r4x_1;
            var tmp_4 = this;
            this.p4y_1;
            var tmp_5;
            try {
              var value = this.r4y_1.c4v();
              tmp_5 = _Result___init__impl__xyqfz8(value);
            } catch ($p) {
              var tmp_6;
              if ($p instanceof Error) {
                var e = $p;
                tmp_6 = _Result___init__impl__xyqfz8(createFailure(e));
              } else {
                throw $p;
              }
              tmp_5 = tmp_6;
            }

            var this_0 = tmp_5;
            var exception = Result__exceptionOrNull_impl_p6xea9(this_0);
            var tmp_7;
            if (exception == null) {
              var tmp_8 = _Result___get_value__impl__bjfvqg(this_0);
              var it = (tmp_8 == null ? true : !(tmp_8 == null)) ? tmp_8 : THROW_CCE();
              tmp_7 = new Success(it);
            } else {
              tmp_7 = new Failure_0(exception);
            }

            tmp_4.t4y_1 = tmp_7;
            this.o4y_1.r4x_1 = new Ready(this.t4y_1);
            this.s4y_1 = !equals(this.b4z_1, this.o4y_1.r4x_1);
            if (this.s4y_1) {
              this.y9_1 = 10;
              suspendResult = yield_0(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 12;
              continue $sm;
            }

          case 10:
            this.c4z_1 = new PropertyChangeEvent(this.b4z_1, this.o4y_1.r4x_1);
            this.o4y_1.s4x_1.a28(LoopingQuery$launchComputingJob$slambda$lambda(this.c4z_1));
            this.y9_1 = 11;
            suspendResult = yield_0(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            this.y9_1 = 12;
            continue $sm;
          case 12:
            this.a4z_1 = Unit_instance;
            this.y9_1 = 13;
            continue $sm;
          case 13:
            this.z9_1 = 29;
            this.o4y_1.o4x_1.f2m();
            if (this.r4y_1.d4v().w4u()) {
              this.d4z_1 = Job_0();
              var tmp_9 = this;
              var tmp_10 = this.r4y_1.d4v();
              tmp_9.e4z_1 = tmp_10.p27(LoopingQuery$launchComputingJob$slambda$lambda_0(this.d4z_1));
              var tmp_11 = this;
              tmp_11.f4z_1 = this.e4z_1;
              this.y9_1 = 14;
              continue $sm;
            } else {
              this.y9_1 = 21;
              continue $sm;
            }

          case 14:
            this.h4z_1 = this.f4z_1;
            this.y9_1 = 15;
            continue $sm;
          case 15:
            this.y9_1 = 16;
            continue $sm;
          case 16:
            this.z9_1 = 27;
            var tmp_12 = this;
            tmp_12.j4z_1 = this.h4z_1;
            this.k4z_1 = this.j4z_1;
            this.y9_1 = 17;
            suspendResult = this.d4z_1.ku(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 17:
            var tmp_13 = this;
            tmp_13.i4z_1 = Unit_instance;
            this.y9_1 = 18;
            var tmp_14 = this;
            continue $sm;
          case 18:
            this.z9_1 = 29;
            var tmp_15 = this;
            this.h4z_1.vr();
            tmp_15.g4z_1 = Unit_instance;
            this.y9_1 = 20;
            continue $sm;
          case 19:
            this.z9_1 = 29;
            this.h4z_1.vr();
            if (false) {
              this.y9_1 = 14;
              continue $sm;
            }

            this.y9_1 = 20;
            continue $sm;
          case 20:
            this.y9_1 = 21;
            continue $sm;
          case 21:
            if (this.s4y_1) {
              this.y9_1 = 22;
              suspendResult = this.o4y_1.n4x_1(this.t4y_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.l4z_1 = false;
              this.y9_1 = 23;
              continue $sm;
            }

          case 22:
            var ARGUMENT = suspendResult;
            this.l4z_1 = !ARGUMENT;
            this.y9_1 = 23;
            continue $sm;
          case 23:
            if (this.l4z_1) {
              this.z4y_1 = Unit_instance;
              this.z9_1 = 31;
              this.y9_1 = 25;
              continue $sm;
            } else {
              this.y9_1 = 24;
              continue $sm;
            }

          case 24:
            this.y4y_1 = Unit_instance;
            this.z9_1 = 31;
            this.y9_1 = 26;
            continue $sm;
          case 25:
            this.z9_1 = 31;
            if (this.q4y_1.w4u()) {
              this.q4y_1.vr();
            }

            this.y9_1 = 30;
            continue $sm;
          case 26:
            this.z9_1 = 31;
            if (this.q4y_1.w4u()) {
              this.q4y_1.vr();
            }

            this.y9_1 = 1;
            continue $sm;
          case 27:
            this.z9_1 = 29;
            var t = this.ba_1;
            this.h4z_1.vr();
            throw t;
          case 28:
            this.z9_1 = 29;
            var t_0 = this.ba_1;
            this.o4y_1.o4x_1.f2m();
            throw t_0;
          case 29:
            this.z9_1 = 31;
            var t_1 = this.ba_1;
            if (this.q4y_1.w4u()) {
              this.q4y_1.vr();
            }

            throw t_1;
          case 30:
            return Unit_instance;
          case 31:
            throw this.ba_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 31) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(LoopingQuery$launchComputingJob$slambda).i1l = function ($this$launch, completion) {
    var i = new LoopingQuery$launchComputingJob$slambda(this.o4y_1, completion);
    i.p4y_1 = $this$launch;
    return i;
  };
  function LoopingQuery$launchComputingJob$slambda_0(this$0, resultContinuation) {
    var i = new LoopingQuery$launchComputingJob$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function LoopingQuery(parentCoroutineContext, query, recomputeCallback, asyncTracker) {
    var tmp;
    if (recomputeCallback === VOID) {
      tmp = LoopingQuery$_init_$slambda_vmyece_0(null);
    } else {
      tmp = recomputeCallback;
    }
    recomputeCallback = tmp;
    asyncTracker = asyncTracker === VOID ? Companion_getInstance_30().g2m_1 : asyncTracker;
    this.m4x_1 = query;
    this.n4x_1 = recomputeCallback;
    this.o4x_1 = asyncTracker;
    this.p4x_1 = CoroutineScope_0(parentCoroutineContext);
    this.q4x_1 = null;
    this.r4x_1 = NotReady_getInstance();
    var tmp_0 = this;
    tmp_0.s4x_1 = new LoopingQuery$listeners$1(this);
  }
  protoOf(LoopingQuery).l2c = function () {
    return 'LoopingQuery@' + toString_3(hashCode(this), 16) + '[' + toString_1(this.m4x_1) + ']';
  };
  protoOf(LoopingQuery).qr = function () {
    return this.r4x_1;
  };
  protoOf(LoopingQuery).m4z = function (handler) {
    return this.s4x_1.z27(handler);
  };
  protoOf(LoopingQuery).o27 = function (handler) {
    return this.m4z(handler);
  };
  function withDefault(_this__u8e3s4, default_0) {
    return map_0(_this__u8e3s4, withDefault$lambda(default_0));
  }
  function withDefault$lambda($default) {
    return function (value) {
      var tmp;
      if (equals(value, NotReady_getInstance())) {
        tmp = $default;
      } else {
        if (value instanceof Ready) {
          var outcome = value.j4x_1;
          var tmp_0;
          if (outcome instanceof Failure_0) {
            ThrowableHandlers_getInstance().ps_1.os(outcome.l4x_1);
            tmp_0 = $default;
          } else {
            if (outcome instanceof Success) {
              tmp_0 = outcome.k4x_1;
            } else {
              noWhenBranchMatchedException();
            }
          }
          tmp = tmp_0;
        } else {
          noWhenBranchMatchedException();
        }
      }
      return tmp;
    };
  }
  function QCollectionBase$_get_size_$lambda_5cjhst(it) {
    return it.n();
  }
  function QCollectionBase$contains$lambda($element) {
    return function (it) {
      return it.s($element);
    };
  }
  function QCollectionBase() {
  }
  function QMutableCollectionBase() {
  }
  function QMutableListBase() {
  }
  function QProperty() {
  }
  function toReified(_this__u8e3s4, valueKClass) {
    return new toReified$1(_this__u8e3s4, valueKClass);
  }
  function toReified$1($this_toReified, $valueKClass) {
    this.o4z_1 = $this_toReified;
    this.p4z_1 = $valueKClass;
  }
  protoOf(toReified$1).q4z = function () {
    return this.p4z_1;
  };
  protoOf(toReified$1).n4z = function () {
    return this.o4z_1.n4z();
  };
  protoOf(toReified$1).d4x = function (builder) {
    return this.o4z_1.d4x(builder);
  };
  protoOf(toReified$1).r4z = function (builder, $completion) {
    return this.o4z_1.h4x(builder, $completion);
  };
  protoOf(toReified$1).h4x = function (builder, $completion) {
    return this.r4z(builder, $completion);
  };
  protoOf(toReified$1).n2g = function (newValue) {
    this.o4z_1.t2c(newValue);
  };
  protoOf(toReified$1).t2c = function (newValue) {
    return this.n2g((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  protoOf(toReified$1).s4z = function (value) {
    this.o4z_1.v2c(value);
  };
  protoOf(toReified$1).v2c = function (value) {
    return this.s4z((value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  function execute_0(_this__u8e3s4) {
    return supervise(_this__u8e3s4, Companion_getInstance_74().k4v_1).c4v();
  }
  function execute_1(_this__u8e3s4, $completion) {
    var tmp = new $executeCOROUTINE$0(_this__u8e3s4, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function constant(value) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new constant$$inlined$query$1(value);
  }
  function supervise(_this__u8e3s4, invalidationContext, observationContext) {
    observationContext = observationContext === VOID ? EmptyCoroutineContext_getInstance() : observationContext;
    var tmp;
    try {
      tmp = _this__u8e3s4.d4x(QueryInit_getInstance().d50(invalidationContext, observationContext));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof AlreadyInvalidException) {
        var t = $p;
        throw t;
      } else {
        if ($p instanceof Error) {
          var t_0 = $p;
          return invalidationContext.q4w(t_0);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp;
    return invalidationContext.p4w(result);
  }
  function supervise_0(_this__u8e3s4, invalidationContext, observationContext, $completion) {
    observationContext = observationContext === VOID ? EmptyCoroutineContext_getInstance() : observationContext;
    var tmp = new $superviseCOROUTINE$1(_this__u8e3s4, invalidationContext, observationContext, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_1(function_0) {
    this.s50_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_1).vr = function () {
    return this.s50_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_1).b4 = function () {
    return this.s50_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_1).hashCode = function () {
    return hashCode(this.b4());
  };
  function QueryInit$initBuilder$lambda($job) {
    return function () {
      $job.pu();
      return Unit_instance;
    };
  }
  function QueryInit() {
    QueryInit_instance = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_74().k4v_1;
    // Inline function 'kotlin.also' call
    var this_0 = Job_0();
    // Inline function 'jetbrains.ocelot.langDef.query.QueryInit.nonTrackingBuilder.<anonymous>' call
    this_0.pu();
    tmp.c50_1 = new QueryBuilder(new Execution(tmp_0, this_0));
  }
  protoOf(QueryInit).d50 = function (invalidationContext, observationContext) {
    if (invalidationContext instanceof NonTrackingInvalidationContext)
      return this.c50_1;
    var job = Job_0();
    var newObservationContext = observationContext.ej(job);
    var tmp = QueryInit$initBuilder$lambda(job);
    invalidationContext.o4w(new sam$jetbrains_ocelot_base_disposable_Disposable$0_1(tmp));
    var execution = new Execution(invalidationContext, newObservationContext);
    return new QueryBuilder(execution);
  };
  var QueryInit_instance;
  function QueryInit_getInstance() {
    if (QueryInit_instance == null)
      new QueryInit();
    return QueryInit_instance;
  }
  function constant$$inlined$query$1($value) {
    this.t50_1 = $value;
  }
  protoOf(constant$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.query.constant.<anonymous>' call
    return this.t50_1;
  };
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_2(function_0) {
    this.u50_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_2).vr = function () {
    return this.u50_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_2).b4 = function () {
    return this.u50_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_2).hashCode = function () {
    return hashCode(this.b4());
  };
  function supervise$slambda$lambda($invalidationContext, $this_coroutineScope) {
    return function () {
      var alreadyInvalidException = new AlreadyInvalidException($invalidationContext, 'Query execution no longer required');
      get_job($this_coroutineScope.et()).ou(CancellationException_init_$Create$_1('Already invalid', alreadyInvalidException));
      return Unit_instance;
    };
  }
  function supervise$slambda($invalidationContext, $this_supervise, $currentObservationContext, resultContinuation) {
    this.d51_1 = $invalidationContext;
    this.e51_1 = $this_supervise;
    this.f51_1 = $currentObservationContext;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(supervise$slambda).h51 = function ($this$coroutineScope, $completion) {
    var tmp = this.i1l($this$coroutineScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(supervise$slambda).oa = function (p1, $completion) {
    return this.h51((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(supervise$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = supervise$slambda$lambda(this.d51_1, this.g51_1);
            this.d51_1.o4w(new sam$jetbrains_ocelot_base_disposable_Disposable$0_2(tmp_0));
            this.y9_1 = 1;
            suspendResult = this.e51_1.h4x(QueryInit_getInstance().d50(this.d51_1, this.f51_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(supervise$slambda).i1l = function ($this$coroutineScope, completion) {
    var i = new supervise$slambda(this.d51_1, this.e51_1, this.f51_1, completion);
    i.g51_1 = $this$coroutineScope;
    return i;
  };
  function supervise$slambda_0($invalidationContext, $this_supervise, $currentObservationContext, resultContinuation) {
    var i = new supervise$slambda($invalidationContext, $this_supervise, $currentObservationContext, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.h51($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $executeCOROUTINE$0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.b50_1 = _this__u8e3s4;
  }
  protoOf($executeCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = supervise_0(this.b50_1, Companion_getInstance_74().k4v_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.c4v();
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $superviseCOROUTINE$1(_this__u8e3s4, invalidationContext, observationContext, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m50_1 = _this__u8e3s4;
    this.n50_1 = invalidationContext;
    this.o50_1 = observationContext;
  }
  protoOf($superviseCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            var tmp_0 = this;
            tmp_0.p50_1 = this.ea().ej(this.o50_1);
            var tmp_1 = this.m50_1;
            if (isInterface(tmp_1, Query)) {
              return supervise(this.m50_1, this.n50_1, this.p50_1);
            }

            this.z9_1 = 4;
            var tmp_2 = this.n50_1;
            if (tmp_2 instanceof NonTrackingInvalidationContext) {
              this.y9_1 = 2;
              suspendResult = this.m50_1.h4x(QueryInit_getInstance().d50(this.n50_1, this.p50_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = coroutineScope(supervise$slambda_0(this.n50_1, this.m50_1, this.p50_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.r50_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 2:
            this.r50_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            var value = this.r50_1;
            var tmp_3 = this;
            tmp_3.q50_1 = _Result___init__impl__xyqfz8(value);
            this.z9_1 = 5;
            this.y9_1 = 6;
            continue $sm;
          case 4:
            this.z9_1 = 5;
            var tmp_4 = this.ba_1;
            if (tmp_4 instanceof CancellationException) {
              var exception = this.ba_1;
              var tmp_5 = this;
              var cause = exception.cause;
              var tmp0_safe_receiver = cause instanceof CancellationException ? cause : null;
              var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cause;
              var actualCause = tmp1_elvis_lhs == null ? cause : tmp1_elvis_lhs;
              if (actualCause instanceof AlreadyInvalidException) {
                throw actualCause;
              }
              throw exception;
            } else {
              var tmp_6 = this.ba_1;
              if (tmp_6 instanceof AlreadyInvalidException) {
                var exception_0 = this.ba_1;
                var tmp_7 = this;
                throw exception_0;
              } else {
                var tmp_8 = this.ba_1;
                if (tmp_8 instanceof Error) {
                  var t = this.ba_1;
                  var tmp_9 = this;
                  tmp_9.q50_1 = _Result___init__impl__xyqfz8(createFailure(t));
                  this.y9_1 = 6;
                  continue $sm;
                } else {
                  throw this.ba_1;
                }
              }
            }

          case 5:
            throw this.ba_1;
          case 6:
            this.z9_1 = 5;
            var result = this.q50_1;
            if (!this.n50_1.w4u()) {
              throw new AlreadyInvalidException(this.n50_1, 'invalidated after being computed but before returning');
            }

            var exception_1 = Result__exceptionOrNull_impl_p6xea9(result);
            var tmp_10;
            if (exception_1 == null) {
              var tmp_11 = _Result___get_value__impl__bjfvqg(result);
              var it = (tmp_11 == null ? true : !(tmp_11 == null)) ? tmp_11 : THROW_CCE();
              tmp_10 = this.n50_1.p4w(it);
            } else {
              tmp_10 = this.n50_1.q4w(exception_1);
            }

            return tmp_10;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function Companion_76() {
    Companion_instance_76 = this;
    this.i51_1 = constant(null);
    this.j51_1 = constant(false);
    this.k51_1 = constant(true);
    this.l51_1 = constant('');
  }
  var Companion_instance_76;
  function Companion_getInstance_76() {
    if (Companion_instance_76 == null)
      new Companion_76();
    return Companion_instance_76;
  }
  function Query() {
  }
  function QueryBuilder(execution) {
    this.g4x_1 = execution;
  }
  protoOf(QueryBuilder).m51 = function (_this__u8e3s4, $completion) {
    return _this__u8e3s4.h4x(this, $completion);
  };
  protoOf(QueryBuilder).n51 = function (_this__u8e3s4) {
    return _this__u8e3s4.d4x(this);
  };
  function waitUntilNot(_this__u8e3s4, emptyValue) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new waitUntilNot$$inlined$suspendingQuery$1(_this__u8e3s4, emptyValue);
  }
  function waitUntilNot$o$runSuspend$lambda($d) {
    return function (it) {
      $d.lz(Unit_instance);
      return Unit_instance;
    };
  }
  function $runSuspendCOROUTINE$5(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w51_1 = _this__u8e3s4;
    this.x51_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$5).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            var tmp_0 = this;
            tmp_0.y51_1 = this.x51_1;
            this.z51_1 = Unit_instance;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.a52_1 = this.y51_1;
            this.b52_1 = this.w51_1.e52_1.qr();
            if (!equals(this.b52_1, this.w51_1.f52_1)) {
              this.z51_1 = this.a52_1.n51(get_forQueries_2(this.w51_1.e52_1));
              this.y9_1 = 5;
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.c52_1 = CompletableDeferred();
            var tmp_1 = this;
            tmp_1.d52_1 = this.w51_1.e52_1.p27(waitUntilNot$o$runSuspend$lambda(this.c52_1));
            this.a52_1.g4x_1.e4x_1.o4w(this.d52_1);
            this.y9_1 = 3;
            suspendResult = this.c52_1.gw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.y9_1 = 4;
            suspendResult = this.a52_1.m51(waitUntilNot(this.w51_1.e52_1, this.w51_1.f52_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.z51_1 = suspendResult;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 5;
            continue $sm;
          case 5:
            return this.z51_1;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function waitUntilNot$$inlined$suspendingQuery$1($this_waitUntilNot, $emptyValue) {
    this.e52_1 = $this_waitUntilNot;
    this.f52_1 = $emptyValue;
  }
  protoOf(waitUntilNot$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$5(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(waitUntilNot$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function get_forQueries(_this__u8e3s4) {
    return new QPropertyAdapter(_this__u8e3s4);
  }
  function get_forQueries_0(_this__u8e3s4) {
    return new QTextPropertyAdapter(_this__u8e3s4);
  }
  function get_forQueries_1(_this__u8e3s4) {
    return new QMutableListAdapter(_this__u8e3s4);
  }
  function QPropertyAdapter(observable) {
    this.h52_1 = observable;
  }
  protoOf(QPropertyAdapter).n4z = function () {
    return this.h52_1;
  };
  protoOf(QPropertyAdapter).d4x = function (builder) {
    depend(builder.g4x_1.e4x_1, this.n4z());
    return this.n4z().m2c();
  };
  protoOf(QPropertyAdapter).q10 = function (newValue) {
    this.n4z().t2c(newValue);
  };
  protoOf(QPropertyAdapter).t2c = function (newValue) {
    return this.q10((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  protoOf(QPropertyAdapter).equals = function (other) {
    if (!(other instanceof QPropertyAdapter))
      return false;
    return equals(this.n4z(), other.n4z());
  };
  protoOf(QPropertyAdapter).hashCode = function () {
    return hashCode(this.n4z());
  };
  function QMutableListAdapter(observable) {
    this.i52_1 = observable;
  }
  protoOf(QMutableListAdapter).n4z = function () {
    return this.i52_1;
  };
  protoOf(QMutableListAdapter).d4x = function (builder) {
    depend_0(builder.g4x_1.e4x_1, this.n4z());
    return this.n4z();
  };
  protoOf(QMutableListAdapter).equals = function (other) {
    if (!(other instanceof QMutableListAdapter))
      return false;
    return equals(this.n4z(), other.n4z());
  };
  protoOf(QMutableListAdapter).hashCode = function () {
    return hashCode(this.n4z());
  };
  function get_forQueries_2(_this__u8e3s4) {
    return new QReadablePropertyAdapter(_this__u8e3s4);
  }
  function get_forQueries_3(_this__u8e3s4) {
    return new QListAdapter(_this__u8e3s4);
  }
  function get_asProperty(_this__u8e3s4) {
    return new EagerInvalidatable(new asProperty$1(_this__u8e3s4));
  }
  function QTextPropertyAdapter(observable) {
    this.j52_1 = observable;
  }
  protoOf(QTextPropertyAdapter).n4z = function () {
    return this.j52_1;
  };
  protoOf(QTextPropertyAdapter).d4x = function (builder) {
    depend(builder.g4x_1.e4x_1, this.j52_1);
    return this.j52_1.m2c();
  };
  protoOf(QTextPropertyAdapter).equals = function (other) {
    if (!(other instanceof QTextPropertyAdapter))
      return false;
    return equals(this.j52_1, other.j52_1);
  };
  protoOf(QTextPropertyAdapter).hashCode = function () {
    return hashCode(this.j52_1);
  };
  function QReadablePropertyAdapter(observable) {
    this.k52_1 = observable;
  }
  protoOf(QReadablePropertyAdapter).d4x = function (builder) {
    depend(builder.g4x_1.e4x_1, this.k52_1);
    return this.k52_1.m2c();
  };
  protoOf(QReadablePropertyAdapter).equals = function (other) {
    if (!(other instanceof QReadablePropertyAdapter))
      return false;
    return equals(this.k52_1, other.k52_1);
  };
  protoOf(QReadablePropertyAdapter).hashCode = function () {
    return hashCode(this.k52_1);
  };
  function QListAdapter(observable) {
    this.l52_1 = observable;
  }
  protoOf(QListAdapter).n4z = function () {
    return this.l52_1;
  };
  protoOf(QListAdapter).d4x = function (builder) {
    depend_0(builder.g4x_1.e4x_1, this.l52_1);
    return this.l52_1;
  };
  protoOf(QListAdapter).equals = function (other) {
    if (!(other instanceof QListAdapter))
      return false;
    return equals(this.l52_1, other.l52_1);
  };
  protoOf(QListAdapter).hashCode = function () {
    return hashCode(this.l52_1);
  };
  function get_forQueries_4(_this__u8e3s4) {
    return new QCollectionAdapter(_this__u8e3s4);
  }
  function get_forQueries_5(_this__u8e3s4) {
    return new QMutableCollectionAdapter(_this__u8e3s4);
  }
  function QCollectionAdapter(observable) {
    this.m52_1 = observable;
  }
  protoOf(QCollectionAdapter).n4z = function () {
    return this.m52_1;
  };
  protoOf(QCollectionAdapter).d4x = function (builder) {
    depend_0(builder.g4x_1.e4x_1, this.m52_1);
    return this.m52_1;
  };
  protoOf(QCollectionAdapter).equals = function (other) {
    if (!(other instanceof QCollectionAdapter))
      return false;
    return equals(this.m52_1, other.m52_1);
  };
  protoOf(QCollectionAdapter).hashCode = function () {
    return hashCode(this.m52_1);
  };
  function QMutableCollectionAdapter(observable) {
    this.n52_1 = observable;
  }
  protoOf(QMutableCollectionAdapter).n4z = function () {
    return this.n52_1;
  };
  protoOf(QMutableCollectionAdapter).d4x = function (builder) {
    depend_0(builder.g4x_1.e4x_1, this.n52_1);
    return this.n52_1;
  };
  protoOf(QMutableCollectionAdapter).equals = function (other) {
    if (!(other instanceof QMutableCollectionAdapter))
      return false;
    return equals(this.n52_1, other.n52_1);
  };
  protoOf(QMutableCollectionAdapter).hashCode = function () {
    return hashCode(this.n52_1);
  };
  function asProperty$1($this_asProperty) {
    this.o52_1 = $this_asProperty;
  }
  protoOf(asProperty$1).b4v = function (context) {
    var execution = new Execution(context, EmptyCoroutineContext_getInstance());
    var builder = new QueryBuilder(execution);
    var result = this.o52_1.d4x(builder);
    return context.p4w(result);
  };
  function Creator() {
  }
  function CommonBigNumberOperations() {
  }
  var SignificantDecider_FIVE_instance;
  var SignificantDecider_LESS_THAN_FIVE_instance;
  var SignificantDecider_MORE_THAN_FIVE_instance;
  var SignificantDecider_entriesInitialized;
  function SignificantDecider_initEntries() {
    if (SignificantDecider_entriesInitialized)
      return Unit_instance;
    SignificantDecider_entriesInitialized = true;
    SignificantDecider_FIVE_instance = new SignificantDecider('FIVE', 0);
    SignificantDecider_LESS_THAN_FIVE_instance = new SignificantDecider('LESS_THAN_FIVE', 1);
    SignificantDecider_MORE_THAN_FIVE_instance = new SignificantDecider('MORE_THAN_FIVE', 2);
  }
  function roundOrDont($this, significand, exponent, decimalMode) {
    var tmp;
    if (decimalMode.p53_1) {
      tmp = new BigDecimal(significand, exponent);
    } else {
      tmp = roundSignificand($this, significand, exponent, decimalMode);
    }
    return tmp;
  }
  function SignificantDecider(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function determineDecider($this, discarded) {
    var tmp = Companion_getInstance_79().v53_1;
    // Inline function 'kotlin.Long.minus' call
    var tmp$ret$0 = discarded.b54().j3(toLong(1));
    var scale = tmp.c54(tmp$ret$0);
    var divrem = discarded.d54(scale);
    var significant = divrem.e54_1.g54().h54(true);
    var rest = divrem.f54_1.g54();
    var tmp_0;
    if (significant === 5) {
      var tmp_1;
      if (rest.equals(Companion_getInstance_79().s53_1)) {
        tmp_1 = SignificantDecider_FIVE_getInstance();
      } else {
        tmp_1 = SignificantDecider_MORE_THAN_FIVE_getInstance();
      }
      tmp_0 = tmp_1;
    } else if (significant > 5) {
      tmp_0 = SignificantDecider_MORE_THAN_FIVE_getInstance();
    } else if (significant < 5) {
      tmp_0 = SignificantDecider_LESS_THAN_FIVE_getInstance();
    } else {
      throw RuntimeException_init_$Create$_0("Couldn't determine decider");
    }
    return tmp_0;
  }
  function roundDiscarded($this, significand, discarded, decimalMode) {
    var toDiscard = significand.b54().j3(decimalMode.m53_1);
    var tmp;
    if (toDiscard.d1(new Long(0, 0)) > 0) {
      var additionallyDiscarded = significand.d54(Companion_getInstance_79().v53_1.c54(toDiscard));
      tmp = new Pair(additionallyDiscarded.e54_1, additionallyDiscarded.f54_1);
    } else {
      tmp = new Pair(significand, discarded);
    }
    var _destruct__k2r9zo = tmp;
    var result = _destruct__k2r9zo.ug();
    var remainder = _destruct__k2r9zo.vg();
    var tmp_0;
    if (significand.equals(Companion_getInstance_79().s53_1)) {
      tmp_0 = discarded.y53_1;
    } else {
      tmp_0 = significand.y53_1;
    }
    var sign = tmp_0;
    if (!decimalMode.n53_1.equals(RoundingMode_AWAY_FROM_ZERO_getInstance()) && !decimalMode.n53_1.equals(RoundingMode_TOWARDS_ZERO_getInstance())) {
      if (remainder.i54()) {
        return result;
      }
    } else {
      if (remainder.i54() && discarded.i54()) {
        return result;
      }
    }
    var decider = determineDecider($this, remainder);
    switch (decimalMode.n53_1.a3_1) {
      case 2:
        if (sign.equals(Sign_POSITIVE_getInstance())) {
          result = result.n3();
        } else {
          result = result.o3();
        }

        break;
      case 3:
        break;
      case 1:
        if (sign.equals(Sign_POSITIVE_getInstance())) {
          result = result.n3();
        }

        break;
      case 0:
        if (!sign.equals(Sign_POSITIVE_getInstance())) {
          result = result.o3();
        }

        break;
      case 5:
        switch (sign.a3_1) {
          case 0:
            if (!decider.equals(SignificantDecider_LESS_THAN_FIVE_getInstance())) {
              result = result.n3();
            }

            break;
          case 1:
            if (!decider.equals(SignificantDecider_LESS_THAN_FIVE_getInstance())) {
              result = result.o3();
            }

            break;
          case 2:
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }

        break;
      case 6:
        switch (sign.a3_1) {
          case 0:
            if (decider.equals(SignificantDecider_MORE_THAN_FIVE_getInstance())) {
              result = result.n3();
            }

            break;
          case 1:
            if (decider.equals(SignificantDecider_MORE_THAN_FIVE_getInstance())) {
              result = result.o3();
            }

            break;
          case 2:
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }

        break;
      case 7:
        switch (sign.a3_1) {
          case 0:
            if (!decider.equals(SignificantDecider_LESS_THAN_FIVE_getInstance())) {
              result = result.n3();
            }

            break;
          case 1:
            if (decider.equals(SignificantDecider_MORE_THAN_FIVE_getInstance())) {
              result = result.o3();
            }

            break;
          case 2:
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }

        break;
      case 8:
        switch (sign.a3_1) {
          case 0:
            if (decider.equals(SignificantDecider_MORE_THAN_FIVE_getInstance())) {
              result = result.n3();
            }

            break;
          case 1:
            if (!decider.equals(SignificantDecider_LESS_THAN_FIVE_getInstance())) {
              result = result.o3();
            }

            break;
          case 2:
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }

        break;
      case 9:
        if (decider.equals(SignificantDecider_FIVE_getInstance())) {
          if (significand.k53(2).g54().equals(Companion_getInstance_79().t53_1)) {
            switch (sign.a3_1) {
              case 0:
                result = result.n3();
                break;
              case 1:
                result = result.o3();
                break;
              case 2:
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
          }
        } else if (decider.equals(SignificantDecider_MORE_THAN_FIVE_getInstance())) {
          if (sign.equals(Sign_POSITIVE_getInstance())) {
            result = result.n3();
          }
          if (sign.equals(Sign_NEGATIVE_getInstance())) {
            result = result.o3();
          }
        }

        break;
      case 10:
        if (decider.equals(SignificantDecider_FIVE_getInstance())) {
          if (significand.k53(2).equals(Companion_getInstance_79().s53_1)) {
            switch (sign.a3_1) {
              case 0:
                result = result.n3();
                break;
              case 1:
                result = result.o3();
                break;
              case 2:
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
          }
        } else if (decider.equals(SignificantDecider_MORE_THAN_FIVE_getInstance())) {
          if (sign.equals(Sign_POSITIVE_getInstance())) {
            result = result.n3();
          }
          if (sign.equals(Sign_NEGATIVE_getInstance())) {
            result = result.o3();
          }
        }

        break;
      case 4:
        throw ArithmeticException_init_$Create$_0('Non-terminating result of division operation. Specify decimalPrecision');
      default:
        noWhenBranchMatchedException();
        break;
    }
    return result;
  }
  function roundSignificand($this, significand, exponent, decimalMode) {
    if (significand.i54()) {
      return new BigDecimal(Companion_getInstance_79().s53_1, exponent, decimalMode);
    }
    var significandDigits = significand.b54();
    var tmp;
    if (decimalMode.q53_1) {
      tmp = decimalMode.m53_1.i3(decimalMode.o53_1);
    } else {
      tmp = decimalMode.m53_1;
    }
    var desiredPrecision = tmp;
    var tmp_0;
    if (desiredPrecision.d1(significandDigits) > 0 && !decimalMode.q53_1) {
      var extendedSignificand = significand.c53(Companion_getInstance_79().v53_1.c54(desiredPrecision.j3(significandDigits)));
      tmp_0 = new BigDecimal(extendedSignificand, exponent, decimalMode);
    } else if (desiredPrecision.d1(significandDigits) < 0) {
      var divRem = significand.d54(Companion_getInstance_79().v53_1.c54(significandDigits.j3(desiredPrecision)));
      var resolvedRemainder = divRem.f54_1;
      if (divRem.f54_1.equals(Companion_getInstance_79().s53_1)) {
        return new BigDecimal(divRem.e54_1, exponent, decimalMode);
      }
      var tmp_1;
      if (significand.b54().equals(divRem.e54_1.b54().i3(divRem.f54_1.b54()))) {
        var newSignificand = roundDiscarded($this, divRem.e54_1, resolvedRemainder, decimalMode);
        var exponentModifier = newSignificand.b54().j3(divRem.e54_1.b54());
        tmp_1 = new BigDecimal(newSignificand, exponent.i3(exponentModifier), decimalMode);
      } else {
        tmp_1 = $this.u54(divRem.e54_1, exponent, decimalMode);
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = new BigDecimal(significand, exponent, decimalMode);
    }
    return tmp_0;
  }
  function applyScale($this, significand, exponent, decimalMode) {
    if (!decimalMode.q53_1) {
      return new BigDecimal(significand, exponent, decimalMode);
    }
    var tmp;
    if (exponent.d1(new Long(0, 0)) >= 0) {
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$0 = exponent.i3(decimalMode.o53_1).i3(toLong(1));
      tmp = new DecimalMode(tmp$ret$0, decimalMode.n53_1);
    } else if (exponent.d1(new Long(0, 0)) < 0) {
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$1 = decimalMode.o53_1.i3(toLong(1));
      tmp = new DecimalMode(tmp$ret$1, decimalMode.n53_1);
    } else {
      throw RuntimeException_init_$Create$_0('Unexpected state');
    }
    var workMode = tmp;
    var tmp_0;
    if (exponent.d1(new Long(0, 0)) >= 0) {
      tmp_0 = roundSignificand($this, significand, exponent, workMode);
    } else {
      var tmp_1;
      if (decimalMode.n53_1.equals(RoundingMode_ROUND_HALF_TO_EVEN_getInstance())) {
        var temp = (new BigDecimal(significand, exponent)).g53(imul(significand.v54(), 2));
        tmp_1 = roundSignificand($this, temp.x54_1, temp.y54_1, workMode).i53(imul(significand.v54(), 2));
      } else {
        var temp_0 = (new BigDecimal(significand, exponent)).g53(significand.v54());
        tmp_1 = roundSignificand($this, temp_0.x54_1, temp_0.y54_1, workMode).i53(significand.v54());
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function resolveDecimalMode($this, firstDecimalMode, secondDecimalMode, suppliedDecimalMode) {
    var tmp;
    if (!(suppliedDecimalMode == null)) {
      tmp = suppliedDecimalMode;
    } else {
      if (firstDecimalMode == null && secondDecimalMode == null) {
        return new DecimalMode();
      }
      if (firstDecimalMode == null && !(secondDecimalMode == null)) {
        return secondDecimalMode;
      }
      if (secondDecimalMode == null && !(firstDecimalMode == null)) {
        return firstDecimalMode;
      }
      if (!ensureNotNull(firstDecimalMode).n53_1.equals(ensureNotNull(secondDecimalMode).n53_1)) {
        throw ArithmeticException_init_$Create$_0('Different rounding modes! This: ' + firstDecimalMode.n53_1.toString() + ' Other: ' + secondDecimalMode.n53_1.toString());
      }
      var tmp_0;
      if (firstDecimalMode.m53_1.d1(secondDecimalMode.m53_1) >= 0) {
        tmp_0 = firstDecimalMode;
      } else {
        tmp_0 = secondDecimalMode;
      }
      var unifiedDecimalMode = tmp_0;
      tmp = unifiedDecimalMode;
    }
    return tmp;
  }
  function SignificantDecider_FIVE_getInstance() {
    SignificantDecider_initEntries();
    return SignificantDecider_FIVE_instance;
  }
  function SignificantDecider_LESS_THAN_FIVE_getInstance() {
    SignificantDecider_initEntries();
    return SignificantDecider_LESS_THAN_FIVE_instance;
  }
  function SignificantDecider_MORE_THAN_FIVE_getInstance() {
    SignificantDecider_initEntries();
    return SignificantDecider_MORE_THAN_FIVE_instance;
  }
  var ScaleOps_Max_instance;
  var ScaleOps_Min_instance;
  var ScaleOps_Add_instance;
  var ScaleOps_entriesInitialized;
  function ScaleOps_initEntries() {
    if (ScaleOps_entriesInitialized)
      return Unit_instance;
    ScaleOps_entriesInitialized = true;
    ScaleOps_Max_instance = new ScaleOps('Max', 0);
    ScaleOps_Min_instance = new ScaleOps('Min', 1);
    ScaleOps_Add_instance = new ScaleOps('Add', 2);
  }
  function Companion_77() {
    Companion_instance_77 = this;
    this.j54_1 = new BigDecimal(Companion_getInstance_79().s53_1);
    this.k54_1 = new BigDecimal(Companion_getInstance_79().t53_1);
    this.l54_1 = new BigDecimal(Companion_getInstance_79().u53_1);
    this.m54_1 = new BigDecimal(Companion_getInstance_79().v53_1, new Long(1, 0));
    this.n54_1 = false;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.o54_1 = new Float64Array([1.0, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, 1.0E7, 1.0E8, 1.0E9, 1.0E10, 1.0E11, 1.0E12, 1.0E13, 1.0E14, 1.0E15, 1.0E16, 1.0E17, 1.0E18, 1.0E19, 1.0E20, 1.0E21, 1.0E22]);
    this.p54_1 = this.e55(1.7976931348623157E308);
    this.q54_1 = this.e55(4.9E-324);
    var tmp_0 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_0.r54_1 = new Float32Array([1.0, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, 1.0E7, 1.0E8, 1.0E9, 1.0E10]);
    this.s54_1 = this.f55(3.4028235E38);
    this.t54_1 = this.f55(1.4E-45);
  }
  protoOf(Companion_77).u54 = function (significand, exponent, decimalMode) {
    var tmp;
    if (significand.y53_1.equals(Sign_POSITIVE_getInstance())) {
      var tmp_0;
      switch (decimalMode.n53_1.a3_1) {
        case 1:
        case 2:
          var increasedSignificand = significand.n3();
          var exponentModifier = increasedSignificand.b54().j3(significand.b54());
          tmp_0 = new BigDecimal(increasedSignificand, exponent.i3(exponentModifier), decimalMode);
          break;
        default:
          tmp_0 = new BigDecimal(significand, exponent, decimalMode);
          break;
      }
      tmp = tmp_0;
    } else if (significand.y53_1.equals(Sign_NEGATIVE_getInstance())) {
      var tmp_1;
      switch (decimalMode.n53_1.a3_1) {
        case 0:
        case 2:
          var increasedSignificand_0 = significand.o3();
          var exponentModifier_0 = increasedSignificand_0.b54().j3(significand.b54());
          tmp_1 = new BigDecimal(increasedSignificand_0, exponent.i3(exponentModifier_0), decimalMode);
          break;
        default:
          tmp_1 = new BigDecimal(significand, exponent, decimalMode);
          break;
      }
      tmp = tmp_1;
    } else {
      tmp = new BigDecimal(significand, exponent, decimalMode);
    }
    return tmp;
  };
  protoOf(Companion_77).g55 = function (long, decimalMode) {
    var bigint = Companion_getInstance_79().h55(long);
    // Inline function 'kotlin.Long.minus' call
    var tmp$ret$0 = bigint.b54().j3(toLong(1));
    return (new BigDecimal(bigint, tmp$ret$0, decimalMode)).i55(decimalMode);
  };
  protoOf(Companion_77).j55 = function (int, decimalMode) {
    var bigint = Companion_getInstance_79().r52(int);
    // Inline function 'kotlin.Long.minus' call
    var tmp$ret$0 = bigint.b54().j3(toLong(1));
    return (new BigDecimal(bigint, tmp$ret$0, decimalMode)).i55(decimalMode);
  };
  protoOf(Companion_77).k55 = function (short, decimalMode) {
    var bigint = Companion_getInstance_79().l55(short);
    // Inline function 'kotlin.Long.minus' call
    var tmp$ret$0 = bigint.b54().j3(toLong(1));
    return (new BigDecimal(bigint, tmp$ret$0, decimalMode)).i55(decimalMode);
  };
  protoOf(Companion_77).m55 = function (byte, decimalMode) {
    var bigint = Companion_getInstance_79().n55(byte);
    // Inline function 'kotlin.Long.minus' call
    var tmp$ret$0 = bigint.b54().j3(toLong(1));
    return (new BigDecimal(bigint, tmp$ret$0, decimalMode)).i55(decimalMode);
  };
  protoOf(Companion_77).o55 = function (float, decimalMode) {
    var floatString = float.toString();
    var tmp;
    if (contains_8(floatString, _Char___init__impl__6a9atx(46)) && !contains_8(floatString, _Char___init__impl__6a9atx(69), true)) {
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.text.dropLastWhile' call
        var inductionVariable = get_lastIndex_3(floatString);
        if (0 <= inductionVariable)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            // Inline function 'com.ionspin.kotlin.bignum.decimal.Companion.fromFloat.<anonymous>' call
            if (!(charSequenceGet(floatString, index) === _Char___init__impl__6a9atx(48))) {
              // Inline function 'kotlin.text.substring' call
              var endIndex = index + 1 | 0;
              // Inline function 'kotlin.js.asDynamic' call
              tmp$ret$3 = floatString.substring(0, endIndex);
              break $l$block;
            }
          }
           while (0 <= inductionVariable);
        tmp$ret$3 = '';
      }
      tmp = this.p55(tmp$ret$3, decimalMode).i55(decimalMode);
    } else {
      tmp = this.p55(floatString, decimalMode).i55(decimalMode);
    }
    return tmp;
  };
  protoOf(Companion_77).f55 = function (float, decimalMode, $super) {
    decimalMode = decimalMode === VOID ? null : decimalMode;
    return $super === VOID ? this.o55(float, decimalMode) : $super.o55.call(this, float, decimalMode);
  };
  protoOf(Companion_77).q55 = function (double, decimalMode) {
    var doubleString = double.toString();
    var tmp;
    if (contains_8(doubleString, _Char___init__impl__6a9atx(46)) && !contains_8(doubleString, _Char___init__impl__6a9atx(69), true)) {
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.text.dropLastWhile' call
        var inductionVariable = get_lastIndex_3(doubleString);
        if (0 <= inductionVariable)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            // Inline function 'com.ionspin.kotlin.bignum.decimal.Companion.fromDouble.<anonymous>' call
            if (!(charSequenceGet(doubleString, index) === _Char___init__impl__6a9atx(48))) {
              // Inline function 'kotlin.text.substring' call
              var endIndex = index + 1 | 0;
              // Inline function 'kotlin.js.asDynamic' call
              tmp$ret$3 = doubleString.substring(0, endIndex);
              break $l$block;
            }
          }
           while (0 <= inductionVariable);
        tmp$ret$3 = '';
      }
      tmp = this.p55(tmp$ret$3, decimalMode).i55(decimalMode);
    } else {
      tmp = this.p55(doubleString, decimalMode).i55(decimalMode).i55(decimalMode);
    }
    return tmp;
  };
  protoOf(Companion_77).e55 = function (double, decimalMode, $super) {
    decimalMode = decimalMode === VOID ? null : decimalMode;
    return $super === VOID ? this.q55(double, decimalMode) : $super.q55.call(this, double, decimalMode);
  };
  protoOf(Companion_77).h55 = function (long) {
    return this.g55(long, null);
  };
  protoOf(Companion_77).r52 = function (int) {
    return this.j55(int, null);
  };
  protoOf(Companion_77).l55 = function (short) {
    return this.k55(short, null);
  };
  protoOf(Companion_77).n55 = function (byte) {
    return this.m55(byte, null);
  };
  protoOf(Companion_77).s52 = function (float, exactRequired) {
    return this.o55(float, null);
  };
  protoOf(Companion_77).u52 = function (double, exactRequired) {
    return this.q55(double, null);
  };
  protoOf(Companion_77).p52 = function (string, base) {
    return this.p55(string, null);
  };
  protoOf(Companion_77).r55 = function (string) {
    return this.s55(string);
  };
  protoOf(Companion_77).p55 = function (floatingPointString, decimalMode) {
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(floatingPointString) === 0) {
      throw ArithmeticException_init_$Create$_0('Empty string is not a valid decimal number');
    }
    if (contains_8(floatingPointString, _Char___init__impl__6a9atx(69), true)) {
      var tmp;
      if (!contains_8(floatingPointString, _Char___init__impl__6a9atx(46))) {
        var splitAroundE = split(floatingPointString, charArrayOf([_Char___init__impl__6a9atx(69), _Char___init__impl__6a9atx(101)]));
        tmp = listOf_0([splitAroundE.q(0), '0E' + splitAroundE.q(1)]);
      } else {
        tmp = split(floatingPointString, charArrayOf([_Char___init__impl__6a9atx(46)]));
      }
      var split_0 = tmp;
      if (split_0.n() === 2) {
        var signPresent = charSequenceGet(floatingPointString, 0) === _Char___init__impl__6a9atx(45) || charSequenceGet(floatingPointString, 0) === _Char___init__impl__6a9atx(43);
        var tmp_0;
        if (signPresent) {
          tmp_0 = 1;
        } else {
          tmp_0 = 0;
        }
        var leftStart = tmp_0;
        var tmp_1;
        if (signPresent) {
          var tmp_2;
          if (charSequenceGet(floatingPointString, 0) === _Char___init__impl__6a9atx(45)) {
            tmp_2 = Sign_NEGATIVE_getInstance();
          } else {
            tmp_2 = Sign_POSITIVE_getInstance();
          }
          tmp_1 = tmp_2;
        } else {
          tmp_1 = Sign_POSITIVE_getInstance();
        }
        var sign = tmp_1;
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        var left = split_0.q(0).substring(leftStart);
        var rightSplit = split(split_0.q(1), charArrayOf([_Char___init__impl__6a9atx(69), _Char___init__impl__6a9atx(101)]));
        var right = rightSplit.q(0);
        var exponentSplit = rightSplit.q(1);
        var exponentSignPresent = charSequenceGet(exponentSplit, 0) === _Char___init__impl__6a9atx(45) || charSequenceGet(exponentSplit, 0) === _Char___init__impl__6a9atx(43);
        var tmp_3;
        if (charSequenceGet(exponentSplit, 0) === _Char___init__impl__6a9atx(45)) {
          tmp_3 = Sign_NEGATIVE_getInstance();
        } else {
          tmp_3 = Sign_POSITIVE_getInstance();
        }
        var exponentSign = tmp_3;
        var tmp_4;
        if (exponentSignPresent) {
          tmp_4 = 1;
        } else {
          tmp_4 = 0;
        }
        var skipSignIfPresent = tmp_4;
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        var exponentString = exponentSplit.substring(skipSignIfPresent);
        var tmp_5;
        if (exponentSign.equals(Sign_POSITIVE_getInstance())) {
          tmp_5 = toLong_0(exponentString, 10);
        } else {
          // Inline function 'kotlin.Long.times' call
          tmp_5 = toLong_0(exponentString, 10).k3(toLong(-1));
        }
        var exponent = tmp_5;
        var tmp$ret$7;
        $l$block: {
          // Inline function 'kotlin.text.indexOfFirst' call
          var inductionVariable = 0;
          var last = charSequenceLength(left) - 1 | 0;
          if (inductionVariable <= last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'com.ionspin.kotlin.bignum.decimal.Companion.parseStringWithMode.<anonymous>' call
              if (!(charSequenceGet(left, index) === _Char___init__impl__6a9atx(48))) {
                tmp$ret$7 = index;
                break $l$block;
              }
            }
             while (inductionVariable <= last);
          tmp$ret$7 = -1;
        }
        var leftFirstNonZero = tmp$ret$7;
        if (leftFirstNonZero === -1) {
          leftFirstNonZero = 0;
        }
        var tmp$ret$9;
        $l$block_0: {
          // Inline function 'kotlin.text.indexOfLast' call
          var inductionVariable_0 = charSequenceLength(right) - 1 | 0;
          if (0 <= inductionVariable_0)
            do {
              var index_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              // Inline function 'com.ionspin.kotlin.bignum.decimal.Companion.parseStringWithMode.<anonymous>' call
              if (!(charSequenceGet(right, index_0) === _Char___init__impl__6a9atx(48))) {
                tmp$ret$9 = index_0;
                break $l$block_0;
              }
            }
             while (0 <= inductionVariable_0);
          tmp$ret$9 = -1;
        }
        var rightLastNonZero = tmp$ret$9;
        if (rightLastNonZero === -1) {
          rightLastNonZero = right.length - 1 | 0;
        }
        var tmp12 = leftFirstNonZero;
        // Inline function 'kotlin.text.substring' call
        var endIndex = left.length;
        // Inline function 'kotlin.js.asDynamic' call
        var leftTruncated = left.substring(tmp12, endIndex);
        // Inline function 'kotlin.text.substring' call
        var endIndex_0 = rightLastNonZero + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        var rightTruncated = right.substring(0, endIndex_0);
        var significand = Companion_getInstance_79().p52(leftTruncated + rightTruncated, 10);
        if (significand.equals(Companion_getInstance_79().s53_1)) {
          sign = Sign_ZERO_getInstance();
        }
        if (sign.equals(Sign_NEGATIVE_getInstance())) {
          significand = significand.t55();
        }
        var tmp_6;
        if (!(leftTruncated === '0')) {
          // Inline function 'kotlin.Long.plus' call
          var other = leftTruncated.length;
          // Inline function 'kotlin.Long.minus' call
          tmp_6 = exponent.i3(toLong(other)).j3(toLong(1));
        } else {
          // Inline function 'kotlin.Long.minus' call
          tmp_6 = exponent.j3(numberToLong(rightTruncated.length).j3(significand.b54())).j3(toLong(1));
        }
        var exponentModifiedByFloatingPointPosition = tmp_6;
        return new BigDecimal(significand, exponentModifiedByFloatingPointPosition, decimalMode);
      } else
        throw ArithmeticException_init_$Create$_0('Invalid (or unsupported) floating point number format: ' + floatingPointString);
    } else {
      if (contains_8(floatingPointString, _Char___init__impl__6a9atx(46))) {
        var split_1 = split(floatingPointString, charArrayOf([_Char___init__impl__6a9atx(46)]));
        if (split_1.n() === 2) {
          var signPresent_0 = charSequenceGet(floatingPointString, 0) === _Char___init__impl__6a9atx(45) || charSequenceGet(floatingPointString, 0) === _Char___init__impl__6a9atx(43);
          var tmp_7;
          if (signPresent_0) {
            tmp_7 = 1;
          } else {
            tmp_7 = 0;
          }
          var leftStart_0 = tmp_7;
          var tmp_8;
          if (signPresent_0) {
            var tmp_9;
            if (charSequenceGet(floatingPointString, 0) === _Char___init__impl__6a9atx(45)) {
              tmp_9 = Sign_NEGATIVE_getInstance();
            } else {
              tmp_9 = Sign_POSITIVE_getInstance();
            }
            tmp_8 = tmp_9;
          } else {
            tmp_8 = Sign_POSITIVE_getInstance();
          }
          var sign_0 = tmp_8;
          // Inline function 'kotlin.text.substring' call
          // Inline function 'kotlin.js.asDynamic' call
          var left_0 = split_1.q(0).substring(leftStart_0);
          var right_0 = split_1.q(1);
          var tmp$ret$20;
          $l$block_1: {
            // Inline function 'kotlin.text.indexOfFirst' call
            var inductionVariable_1 = 0;
            var last_0 = charSequenceLength(left_0) - 1 | 0;
            if (inductionVariable_1 <= last_0)
              do {
                var index_1 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                // Inline function 'com.ionspin.kotlin.bignum.decimal.Companion.parseStringWithMode.<anonymous>' call
                if (!(charSequenceGet(left_0, index_1) === _Char___init__impl__6a9atx(48))) {
                  tmp$ret$20 = index_1;
                  break $l$block_1;
                }
              }
               while (inductionVariable_1 <= last_0);
            tmp$ret$20 = -1;
          }
          var leftFirstNonZero_0 = tmp$ret$20;
          if (leftFirstNonZero_0 === -1) {
            leftFirstNonZero_0 = 0;
          }
          var tmp$ret$22;
          $l$block_2: {
            // Inline function 'kotlin.text.indexOfLast' call
            var inductionVariable_2 = charSequenceLength(right_0) - 1 | 0;
            if (0 <= inductionVariable_2)
              do {
                var index_2 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + -1 | 0;
                // Inline function 'com.ionspin.kotlin.bignum.decimal.Companion.parseStringWithMode.<anonymous>' call
                if (!(charSequenceGet(right_0, index_2) === _Char___init__impl__6a9atx(48))) {
                  tmp$ret$22 = index_2;
                  break $l$block_2;
                }
              }
               while (0 <= inductionVariable_2);
            tmp$ret$22 = -1;
          }
          var rightLastNonZero_0 = tmp$ret$22;
          if (rightLastNonZero_0 === -1) {
            rightLastNonZero_0 = right_0.length - 1 | 0;
          }
          var tmp30 = leftFirstNonZero_0;
          // Inline function 'kotlin.text.substring' call
          var endIndex_1 = left_0.length;
          // Inline function 'kotlin.js.asDynamic' call
          var leftTruncated_0 = left_0.substring(tmp30, endIndex_1);
          // Inline function 'kotlin.text.substring' call
          var endIndex_2 = rightLastNonZero_0 + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          var rightTruncated_0 = right_0.substring(0, endIndex_2);
          var significand_0 = Companion_getInstance_79().p52(leftTruncated_0 + rightTruncated_0, 10);
          var tmp_10;
          var tmp_11;
          // Inline function 'kotlin.text.isNotEmpty' call
          if (charSequenceLength(leftTruncated_0) > 0) {
            tmp_11 = !(charSequenceGet(leftTruncated_0, 0) === _Char___init__impl__6a9atx(48));
          } else {
            tmp_11 = false;
          }
          if (tmp_11) {
            tmp_10 = leftTruncated_0.length - 1 | 0;
          } else {
            var tmp$ret$29;
            $l$block_3: {
              // Inline function 'kotlin.text.indexOfFirst' call
              var inductionVariable_3 = 0;
              var last_1 = charSequenceLength(rightTruncated_0) - 1 | 0;
              if (inductionVariable_3 <= last_1)
                do {
                  var index_3 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  // Inline function 'com.ionspin.kotlin.bignum.decimal.Companion.parseStringWithMode.<anonymous>' call
                  if (!(charSequenceGet(rightTruncated_0, index_3) === _Char___init__impl__6a9atx(48))) {
                    tmp$ret$29 = index_3;
                    break $l$block_3;
                  }
                }
                 while (inductionVariable_3 <= last_1);
              tmp$ret$29 = -1;
            }
            tmp_10 = imul(tmp$ret$29 + 1 | 0, -1);
          }
          var exponent_0 = tmp_10;
          if (significand_0.equals(Companion_getInstance_79().s53_1)) {
            sign_0 = Sign_ZERO_getInstance();
          }
          if (sign_0.equals(Sign_NEGATIVE_getInstance())) {
            significand_0 = significand_0.t55();
          }
          return new BigDecimal(significand_0, toLong(exponent_0), decimalMode);
        } else
          throw ArithmeticException_init_$Create$_0('Invalid (or unsupported) floating point number format: ' + floatingPointString);
      } else {
        var significand_1 = Companion_getInstance_79().p52(floatingPointString, 10);
        // Inline function 'kotlin.Long.minus' call
        var tmp$ret$30 = significand_1.b54().j3(toLong(1));
        return new BigDecimal(significand_1, tmp$ret$30, decimalMode);
      }
    }
  };
  protoOf(Companion_77).s55 = function (floatingPointString, decimalMode, $super) {
    decimalMode = decimalMode === VOID ? null : decimalMode;
    return $super === VOID ? this.p55(floatingPointString, decimalMode) : $super.p55.call(this, floatingPointString, decimalMode);
  };
  var Companion_instance_77;
  function Companion_getInstance_77() {
    if (Companion_instance_77 == null)
      new Companion_77();
    return Companion_instance_77;
  }
  function removeTrailingZeroes($this, bigDecimal) {
    if (bigDecimal.i54())
      return $this;
    var significand = bigDecimal.x54_1;
    var divisionResult = new QuotientAndRemainder(bigDecimal.x54_1, Companion_getInstance_79().s53_1);
    do {
      divisionResult = divisionResult.e54_1.d54(Companion_getInstance_79().v53_1);
      if (divisionResult.f54_1.equals(Companion_getInstance_79().s53_1)) {
        significand = divisionResult.e54_1;
      }
    }
     while (divisionResult.f54_1.equals(Companion_getInstance_79().s53_1));
    return new BigDecimal(significand, bigDecimal.y54_1);
  }
  function ScaleOps(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function computeMode($this, other, op) {
    var tmp;
    if ($this.z54_1 == null || $this.z54_1.p53_1 || other.z54_1 == null || other.z54_1.p53_1) {
      tmp = Companion_getInstance_78().u55_1;
    } else {
      var tmp0 = $this.z54_1.m53_1;
      // Inline function 'kotlin.math.max' call
      var b = other.z54_1.m53_1;
      var tmp_0 = tmp0.d1(b) >= 0 ? tmp0 : b;
      var tmp_1;
      if ($this.z54_1.q53_1 && other.z54_1.q53_1) {
        var tmp_2;
        switch (op.a3_1) {
          case 0:
            var tmp2 = $this.z54_1.o53_1;
            // Inline function 'kotlin.math.max' call

            var b_0 = other.z54_1.o53_1;
            tmp_2 = tmp2.d1(b_0) >= 0 ? tmp2 : b_0;
            break;
          case 1:
            var tmp4 = $this.z54_1.o53_1;
            // Inline function 'kotlin.math.min' call

            var b_1 = other.z54_1.o53_1;
            tmp_2 = tmp4.d1(b_1) <= 0 ? tmp4 : b_1;
            break;
          case 2:
            tmp_2 = $this.z54_1.o53_1.i3(other.z54_1.o53_1);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = new Long(-1, -1);
      }
      tmp = new DecimalMode(tmp_0, $this.z54_1.n53_1, tmp_1);
    }
    return tmp;
  }
  function getRidOfRadix($this, bigDecimal) {
    var precision = bigDecimal.x54_1.b54();
    // Inline function 'kotlin.Long.plus' call
    var newExponent = bigDecimal.y54_1.j3(precision).i3(toLong(1));
    return new BigDecimal(bigDecimal.x54_1, newExponent);
  }
  function bringSignificandToSameExponent($this, first, second) {
    var firstPrepared = getRidOfRadix($this, first);
    var secondPrepared = getRidOfRadix($this, second);
    var firstPreparedExponent = firstPrepared.y54_1;
    var secondPreparedExponent = secondPrepared.y54_1;
    var tmp;
    if (first.y54_1.d1(second.y54_1) > 0) {
      var moveFirstBy = firstPreparedExponent.j3(secondPreparedExponent);
      var tmp_0;
      if (moveFirstBy.d1(new Long(0, 0)) >= 0) {
        var movedFirst = firstPrepared.x54_1.c53(toBigInteger(10).c54(moveFirstBy));
        return new Triple(movedFirst, second.x54_1, secondPreparedExponent);
      } else {
        var tmp_1 = toBigInteger(10);
        // Inline function 'kotlin.Long.times' call
        var tmp$ret$0 = moveFirstBy.k3(toLong(-1));
        var movedSecond = secondPrepared.x54_1.c53(tmp_1.c54(tmp$ret$0));
        tmp_0 = new Triple(first.x54_1, movedSecond, firstPreparedExponent);
      }
      tmp = tmp_0;
    } else if (first.y54_1.d1(second.y54_1) < 0) {
      var moveSecondBy = secondPreparedExponent.j3(firstPreparedExponent);
      var tmp_2;
      if (moveSecondBy.d1(new Long(0, 0)) >= 0) {
        var movedSecond_0 = secondPrepared.x54_1.c53(toBigInteger(10).c54(moveSecondBy));
        tmp_2 = new Triple(first.x54_1, movedSecond_0, firstPreparedExponent);
      } else {
        var tmp_3 = toBigInteger(10);
        // Inline function 'kotlin.Long.times' call
        var tmp$ret$1 = moveSecondBy.k3(toLong(-1));
        var movedFirst_0 = firstPrepared.x54_1.c53(tmp_3.c54(tmp$ret$1));
        tmp_2 = new Triple(movedFirst_0, second.x54_1, firstPreparedExponent);
      }
      return tmp_2;
    } else if (first.y54_1.equals(second.y54_1)) {
      var delta = firstPreparedExponent.j3(secondPreparedExponent);
      var tmp_4;
      if (delta.d1(new Long(0, 0)) > 0) {
        var movedFirst_1 = first.x54_1.c53(toBigInteger(10).c54(delta));
        tmp_4 = new Triple(movedFirst_1, second.x54_1, firstPreparedExponent);
      } else {
        if (delta.d1(new Long(0, 0)) < 0) {
          var tmp_5 = toBigInteger(10);
          // Inline function 'kotlin.Long.times' call
          var tmp$ret$2 = delta.k3(toLong(-1));
          var movedSecond_1 = second.x54_1.c53(tmp_5.c54(tmp$ret$2));
          tmp_4 = new Triple(first.x54_1, movedSecond_1, firstPreparedExponent);
        } else {
          // Inline function 'kotlin.Long.compareTo' call
          if (delta.d1(toLong(0)) === 0) {
            tmp_4 = new Triple(first.x54_1, second.x54_1, firstPreparedExponent);
          } else {
            throw RuntimeException_init_$Create$_0('Invalid delta: ' + delta.toString());
          }
        }
      }
      return tmp_4;
    } else {
      throw RuntimeException_init_$Create$_0('Invalid comparison state BigInteger: ' + first.y54_1.toString() + ', ' + second.y54_1.toString());
    }
    return tmp;
  }
  function javascriptNumberComparison($this, number) {
    var double = numberToDouble(number);
    var tmp;
    if (double > (new Long(-1, 2147483647)).a4()) {
      tmp = $this.w55(Companion_getInstance_77().r55(double.toString()));
    } else if (double % 1 === 0.0) {
      tmp = $this.w55(Companion_getInstance_77().h55(numberToLong(number)));
    } else {
      tmp = $this.w55(toBigDecimal(numberToDouble(number)));
    }
    return tmp;
  }
  function placeADotInStringExpanded($this, input, position) {
    var prefix = substring(input, until(0, input.length - position | 0));
    var tmp0 = substring(input, until(input.length - position | 0, input.length));
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.text.dropLastWhile' call
      var inductionVariable = get_lastIndex_3(tmp0);
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          // Inline function 'com.ionspin.kotlin.bignum.decimal.BigDecimal.placeADotInStringExpanded.<anonymous>' call
          if (!(charSequenceGet(tmp0, index) === _Char___init__impl__6a9atx(48))) {
            // Inline function 'kotlin.text.substring' call
            var endIndex = index + 1 | 0;
            // Inline function 'kotlin.js.asDynamic' call
            tmp$ret$3 = tmp0.substring(0, endIndex);
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$3 = '';
    }
    var suffix = tmp$ret$3;
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(suffix) > 0) {
      tmp = prefix + '.' + suffix;
    } else {
      tmp = prefix;
    }
    return tmp;
  }
  function placeADotInString($this, input, position) {
    var prefix = substring(input, until(0, input.length - position | 0));
    var suffix = substring(input, until(input.length - position | 0, input.length));
    var prepared = prefix + '.' + suffix;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.text.dropLastWhile' call
      var inductionVariable = get_lastIndex_3(prepared);
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          // Inline function 'com.ionspin.kotlin.bignum.decimal.BigDecimal.placeADotInString.<anonymous>' call
          if (!(charSequenceGet(prepared, index) === _Char___init__impl__6a9atx(48))) {
            // Inline function 'kotlin.text.substring' call
            var endIndex = index + 1 | 0;
            // Inline function 'kotlin.js.asDynamic' call
            tmp$ret$3 = prepared.substring(0, endIndex);
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$3 = '';
    }
    return tmp$ret$3;
  }
  function ScaleOps_Max_getInstance() {
    ScaleOps_initEntries();
    return ScaleOps_Max_instance;
  }
  function BigDecimal(_significand, _exponent, _decimalMode) {
    Companion_getInstance_77();
    _exponent = _exponent === VOID ? new Long(0, 0) : _exponent;
    _decimalMode = _decimalMode === VOID ? null : _decimalMode;
    if (!(_decimalMode == null) && _decimalMode.q53_1) {
      var wrk = applyScale(Companion_getInstance_77(), _significand, _exponent, _decimalMode);
      if (!wrk.i54()) {
        this.x54_1 = wrk.x54_1;
        this.y54_1 = wrk.y54_1;
        var newPrecision = this.x54_1.b54();
        this.w54_1 = newPrecision;
        this.z54_1 = _decimalMode.x55(newPrecision);
      } else {
        this.x54_1 = wrk.x54_1;
        this.y54_1 = wrk.y54_1.k3(_decimalMode.m53_1.i3(_decimalMode.o53_1));
        this.w54_1 = _decimalMode.m53_1.i3(_decimalMode.o53_1);
        this.z54_1 = _decimalMode.x55(this.w54_1);
      }
    } else {
      this.x54_1 = _significand;
      this.w54_1 = _significand.b54();
      this.y54_1 = _exponent;
      this.z54_1 = _decimalMode;
    }
    var tmp = this;
    var tmp0_safe_receiver = this.z54_1;
    var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m53_1;
    tmp.a55_1 = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp1_safe_receiver = this.z54_1;
    var tmp0_elvis_lhs_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n53_1;
    tmp_0.b55_1 = tmp0_elvis_lhs_0 == null ? RoundingMode_NONE_getInstance() : tmp0_elvis_lhs_0;
    var tmp_1 = this;
    var tmp13_safe_receiver = this.z54_1;
    var tmp0_elvis_lhs_1 = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.o53_1;
    tmp_1.c55_1 = tmp0_elvis_lhs_1 == null ? new Long(-1, -1) : tmp0_elvis_lhs_1;
    this.d55_1 = this.c55_1.d1(new Long(0, 0)) >= 0;
  }
  protoOf(BigDecimal).w52 = function () {
    return Companion_getInstance_77();
  };
  protoOf(BigDecimal).x52 = function () {
    return this;
  };
  protoOf(BigDecimal).y55 = function (other) {
    return this.z55(other, computeMode(this, other, ScaleOps_Max_getInstance()));
  };
  protoOf(BigDecimal).z52 = function (other) {
    return this.y55(other instanceof BigDecimal ? other : THROW_CCE());
  };
  protoOf(BigDecimal).z55 = function (other, decimalMode) {
    var resolvedDecimalMode = resolveDecimalMode(Companion_getInstance_77(), this.z54_1, other.z54_1, decimalMode);
    if (this.i54()) {
      return roundOrDont(Companion_getInstance_77(), other.x54_1, other.y54_1, resolvedDecimalMode);
    }
    if (other.i54()) {
      return roundOrDont(Companion_getInstance_77(), this.x54_1, this.y54_1, resolvedDecimalMode);
    }
    var _destruct__k2r9zo = bringSignificandToSameExponent(this, this, other);
    var first = _destruct__k2r9zo.ug();
    var second = _destruct__k2r9zo.vg();
    var firstNumOfDigits = first.b54();
    var secondNumOfDigits = second.b54();
    var newSignificand = first.y52(second);
    var newSignificandNumOfDigit = newSignificand.b54();
    var tmp;
    if (firstNumOfDigits.d1(secondNumOfDigits) > 0) {
      tmp = firstNumOfDigits;
    } else {
      tmp = secondNumOfDigits;
    }
    var largerOperand = tmp;
    var carryDetected = newSignificandNumOfDigit.j3(largerOperand);
    var tmp0 = this.y54_1;
    // Inline function 'kotlin.math.max' call
    var b = other.y54_1;
    var newExponent = (tmp0.d1(b) >= 0 ? tmp0 : b).i3(carryDetected);
    var tmp_0;
    if (resolvedDecimalMode.q53_1) {
      tmp_0 = roundOrDont(Companion_getInstance_77(), newSignificand, newExponent, resolvedDecimalMode.x55(newSignificandNumOfDigit));
    } else {
      tmp_0 = roundOrDont(Companion_getInstance_77(), newSignificand, newExponent, resolvedDecimalMode);
    }
    return tmp_0;
  };
  protoOf(BigDecimal).a56 = function (other) {
    return this.b56(other, computeMode(this, other, ScaleOps_Max_getInstance()));
  };
  protoOf(BigDecimal).b53 = function (other) {
    return this.a56(other instanceof BigDecimal ? other : THROW_CCE());
  };
  protoOf(BigDecimal).b56 = function (other, decimalMode) {
    var resolvedDecimalMode = resolveDecimalMode(Companion_getInstance_77(), this.z54_1, other.z54_1, decimalMode);
    if (this.i54()) {
      return roundOrDont(Companion_getInstance_77(), other.x54_1.t55(), other.y54_1, resolvedDecimalMode);
    }
    if (other.i54()) {
      return roundOrDont(Companion_getInstance_77(), this.x54_1, this.y54_1, resolvedDecimalMode);
    }
    var _destruct__k2r9zo = bringSignificandToSameExponent(this, this, other);
    var first = _destruct__k2r9zo.ug();
    var second = _destruct__k2r9zo.vg();
    var firstNumOfDigits = first.b54();
    var secondNumOfDigits = second.b54();
    var newSignificand = first.a53(second);
    var newSignificandNumOfDigit = newSignificand.b54();
    var tmp;
    if (firstNumOfDigits.d1(secondNumOfDigits) > 0) {
      tmp = firstNumOfDigits;
    } else {
      tmp = secondNumOfDigits;
    }
    var largerOperand = tmp;
    var borrowDetected = newSignificandNumOfDigit.j3(largerOperand);
    var tmp0 = this.y54_1;
    // Inline function 'kotlin.math.max' call
    var b = other.y54_1;
    var newExponent = (tmp0.d1(b) >= 0 ? tmp0 : b).i3(borrowDetected);
    if (this.d55_1) {
      return roundOrDont(Companion_getInstance_77(), newSignificand, newExponent, resolvedDecimalMode.x55(newSignificandNumOfDigit));
    } else {
      return roundOrDont(Companion_getInstance_77(), newSignificand, newExponent, resolvedDecimalMode);
    }
  };
  protoOf(BigDecimal).c56 = function (other) {
    return this.d56(other, computeMode(this, other, ScaleOps_Max_getInstance()));
  };
  protoOf(BigDecimal).d53 = function (other) {
    return this.c56(other instanceof BigDecimal ? other : THROW_CCE());
  };
  protoOf(BigDecimal).d56 = function (other, decimalMode) {
    var resolvedDecimalMode = resolveDecimalMode(Companion_getInstance_77(), this.z54_1, other.z54_1, decimalMode);
    var firstNumOfDigits = this.x54_1.b54();
    var secondNumOfDigits = other.x54_1.b54();
    var newSignificand = this.x54_1.c53(other.x54_1);
    var newSignificandNumOfDigit = newSignificand.b54();
    var moveExponent = newSignificandNumOfDigit.j3(firstNumOfDigits.i3(secondNumOfDigits));
    // Inline function 'kotlin.Long.plus' call
    var newExponent = this.y54_1.i3(other.y54_1).i3(moveExponent).i3(toLong(1));
    var tmp;
    if (resolvedDecimalMode.q53_1) {
      tmp = roundOrDont(Companion_getInstance_77(), newSignificand, newExponent, resolvedDecimalMode.x55(newSignificandNumOfDigit));
    } else {
      tmp = roundOrDont(Companion_getInstance_77(), newSignificand, newExponent, resolvedDecimalMode);
    }
    return tmp;
  };
  protoOf(BigDecimal).e56 = function (other) {
    return this.f56(other, computeMode(this, other, ScaleOps_Max_getInstance()));
  };
  protoOf(BigDecimal).f53 = function (other) {
    return this.e56(other instanceof BigDecimal ? other : THROW_CCE());
  };
  protoOf(BigDecimal).f56 = function (other, decimalMode) {
    var resolvedDecimalMode = resolveDecimalMode(Companion_getInstance_77(), this.z54_1, other.z54_1, decimalMode);
    if (resolvedDecimalMode.p53_1 && !resolvedDecimalMode.q53_1) {
      var newExponent = this.y54_1.j3(other.y54_1);
      // Inline function 'kotlin.Long.times' call
      // Inline function 'kotlin.Long.plus' call
      var power = other.w54_1.k3(toLong(2)).i3(toLong(6));
      var thisPrepared = this.x54_1.c53(Companion_getInstance_79().v53_1.c54(power));
      var divRem = thisPrepared.d54(other.x54_1);
      var result = divRem.e54_1;
      // Inline function 'kotlin.Long.minus' call
      var expectedDiff = other.w54_1.j3(toLong(1));
      var exponentModifier = expectedDiff.i3(result.b54().j3(thisPrepared.b54()));
      if (!divRem.f54_1.equals(Companion_getInstance_79().s53_1)) {
        throw ArithmeticException_init_$Create$_0('Non-terminating result of division operation (i.e. 1/3 = 0.3333... library needs to know when to stop and how to round up at that point). Specify decimalPrecision inside your decimal mode.');
      }
      return new BigDecimal(result, newExponent.i3(exponentModifier), resolvedDecimalMode);
    } else {
      // Inline function 'kotlin.Long.minus' call
      var newExponent_0 = this.y54_1.j3(other.y54_1).j3(toLong(1));
      var desiredPrecision = resolvedDecimalMode.m53_1;
      var power_0 = desiredPrecision.j3(this.w54_1).i3(other.w54_1);
      var tmp;
      if (power_0.d1(new Long(0, 0)) > 0) {
        tmp = this.x54_1.c53(toBigInteger(10).c54(power_0));
      } else if (power_0.d1(new Long(0, 0)) < 0) {
        var tmp_0 = toBigInteger(10);
        // Inline function 'kotlin.math.absoluteValue' call
        var tmp$ret$4 = abs_0(power_0);
        tmp = this.x54_1.e53(tmp_0.c54(tmp$ret$4));
      } else {
        tmp = this.x54_1;
      }
      var thisPrepared_0 = tmp;
      var divRem_0 = thisPrepared_0.d54(other.x54_1);
      var result_0 = divRem_0.e54_1;
      if (result_0.equals(Companion_getInstance_79().s53_1)) {
        newExponent_0 = newExponent_0.o3();
      }
      var exponentModifier_0 = result_0.b54().j3(resolvedDecimalMode.m53_1);
      var tmp_1;
      if (this.d55_1) {
        tmp_1 = new BigDecimal(roundDiscarded(Companion_getInstance_77(), result_0, divRem_0.f54_1, resolvedDecimalMode), newExponent_0.i3(exponentModifier_0), resolvedDecimalMode.x55(result_0.b54()));
      } else {
        tmp_1 = new BigDecimal(roundDiscarded(Companion_getInstance_77(), result_0, divRem_0.f54_1, resolvedDecimalMode), newExponent_0.i3(exponentModifier_0), resolvedDecimalMode);
      }
      return tmp_1;
    }
  };
  protoOf(BigDecimal).g56 = function (other) {
    return this.h56(other).eh_1;
  };
  protoOf(BigDecimal).l53 = function (other) {
    return this.g56(other instanceof BigDecimal ? other : THROW_CCE());
  };
  protoOf(BigDecimal).h56 = function (other) {
    if (this.y54_1.d1(new Long(0, 0)) < 0) {
      return new Pair(Companion_getInstance_77().j54_1, this);
    }
    if (other.g54().i56(this.g54()) > 0) {
      return new Pair(Companion_getInstance_77().j54_1, this);
    }
    var tmp16_safe_receiver = this.z54_1;
    var tmp;
    if (tmp16_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$0 = this.y54_1.j3(other.y54_1).i3(toLong(1));
      tmp = tmp16_safe_receiver.x55(tmp$ret$0);
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$1 = this.y54_1.j3(other.y54_1).i3(toLong(1));
      tmp_0 = new DecimalMode(tmp$ret$1, RoundingMode_FLOOR_getInstance());
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var resolvedRoundingMode = tmp_0;
    var quotient = this.f56(other, resolvedRoundingMode);
    var quotientInfinitePrecision = quotient.j56(VOID, VOID, Companion_getInstance_78().u55_1);
    var remainder = this.l56(quotientInfinitePrecision.k56(other));
    return new Pair(quotient, remainder);
  };
  protoOf(BigDecimal).i54 = function () {
    return this.x54_1.i54();
  };
  protoOf(BigDecimal).m56 = function (significand, exponent, decimalMode) {
    return new BigDecimal(significand, exponent, decimalMode);
  };
  protoOf(BigDecimal).j56 = function (significand, exponent, decimalMode, $super) {
    significand = significand === VOID ? this.x54_1 : significand;
    exponent = exponent === VOID ? this.y54_1 : exponent;
    decimalMode = decimalMode === VOID ? this.z54_1 : decimalMode;
    return $super === VOID ? this.m56(significand, exponent, decimalMode) : $super.m56.call(this, significand, exponent, decimalMode);
  };
  protoOf(BigDecimal).n56 = function (places) {
    if (places.equals(new Long(0, 0))) {
      return this;
    }
    return this.j56(VOID, this.y54_1.i3(places));
  };
  protoOf(BigDecimal).o56 = function () {
    if (this.y54_1.d1(new Long(0, 0)) < 0) {
      var tmp;
      switch (this.x54_1.y53_1.a3_1) {
        case 0:
          tmp = Companion_getInstance_77().j54_1;
          break;
        case 1:
          tmp = Companion_getInstance_77().k54_1.t55();
          break;
        case 2:
          tmp = Companion_getInstance_77().j54_1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      return tmp;
    }
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = this.y54_1.i3(toLong(1));
    return this.i55(new DecimalMode(tmp$ret$0, RoundingMode_FLOOR_getInstance()));
  };
  protoOf(BigDecimal).p56 = function () {
    if (this.y54_1.d1(new Long(0, 0)) < 0) {
      return Companion_getInstance_79().s53_1;
    }
    var precisionExponentDiff = this.y54_1.j3(this.w54_1);
    var tmp;
    if (precisionExponentDiff.d1(new Long(0, 0)) > 0) {
      var tmp_0 = toBigInteger(10);
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$0 = precisionExponentDiff.i3(toLong(1));
      tmp = this.x54_1.c53(tmp_0.c54(tmp$ret$0));
    } else if (precisionExponentDiff.d1(new Long(0, 0)) < 0) {
      var tmp_1 = toBigInteger(10);
      // Inline function 'kotlin.math.absoluteValue' call
      // Inline function 'kotlin.Long.minus' call
      var tmp$ret$2 = abs_0(precisionExponentDiff).j3(toLong(1));
      tmp = this.x54_1.e53(tmp_1.c54(tmp$ret$2));
    } else {
      tmp = this.x54_1.h53(10);
    }
    return tmp;
  };
  protoOf(BigDecimal).l56 = function (other) {
    return this.b56(other, computeMode(this, other, ScaleOps_Max_getInstance()));
  };
  protoOf(BigDecimal).k56 = function (other) {
    return this.d56(other, computeMode(this, other, ScaleOps_Max_getInstance()));
  };
  protoOf(BigDecimal).g54 = function () {
    return new BigDecimal(this.x54_1.g54(), this.y54_1, this.z54_1);
  };
  protoOf(BigDecimal).t55 = function () {
    return new BigDecimal(this.x54_1.t55(), this.y54_1, this.z54_1);
  };
  protoOf(BigDecimal).i55 = function (decimalMode) {
    if (decimalMode == null) {
      return this;
    }
    return roundSignificand(Companion_getInstance_77(), this.x54_1, this.y54_1, decimalMode);
  };
  protoOf(BigDecimal).w55 = function (other) {
    var tmp;
    if (this.y54_1.equals(other.y54_1) && this.w54_1.equals(other.w54_1)) {
      tmp = this.x54_1.q56(other.x54_1);
    } else {
      var _destruct__k2r9zo = bringSignificandToSameExponent(this, this, other);
      var preparedFirst = _destruct__k2r9zo.ug();
      var preparedSecond = _destruct__k2r9zo.vg();
      tmp = preparedFirst.q56(preparedSecond);
    }
    return tmp;
  };
  protoOf(BigDecimal).i56 = function (other) {
    if (isNumber(other)) {
      if (RuntimePlatform_instance.r56().equals(Platform_JS_getInstance()) || RuntimePlatform_instance.r56().equals(Platform_WASMJS_getInstance())) {
        return javascriptNumberComparison(this, other);
      }
    }
    var tmp;
    if (other instanceof BigDecimal) {
      tmp = this.w55(other);
    } else {
      if (other instanceof Long) {
        tmp = this.w55(Companion_getInstance_77().h55(other));
      } else {
        if (typeof other === 'number') {
          tmp = this.w55(Companion_getInstance_77().r52(other));
        } else {
          if (typeof other === 'number') {
            tmp = this.w55(Companion_getInstance_77().l55(other));
          } else {
            if (typeof other === 'number') {
              tmp = this.w55(Companion_getInstance_77().n55(other));
            } else {
              if (typeof other === 'number') {
                tmp = this.w55(Companion_getInstance_77().e55(other));
              } else {
                if (typeof other === 'number') {
                  tmp = this.w55(Companion_getInstance_77().f55(other));
                } else {
                  throw RuntimeException_init_$Create$_0('Invalid comparison type for BigDecimal: ' + getKClassFromExpression(other).lb());
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  };
  protoOf(BigDecimal).d = function (other) {
    return this.i56(!(other == null) ? other : THROW_CCE());
  };
  protoOf(BigDecimal).equals = function (other) {
    var tmp;
    if (other instanceof BigDecimal) {
      tmp = this.w55(other);
    } else {
      if (other instanceof Long) {
        tmp = this.w55(Companion_getInstance_77().h55(other));
      } else {
        if (!(other == null) ? typeof other === 'number' : false) {
          tmp = this.w55(Companion_getInstance_77().r52(other));
        } else {
          if (!(other == null) ? typeof other === 'number' : false) {
            tmp = this.w55(Companion_getInstance_77().l55(other));
          } else {
            if (!(other == null) ? typeof other === 'number' : false) {
              tmp = this.w55(Companion_getInstance_77().n55(other));
            } else {
              if (!(other == null) ? typeof other === 'number' : false) {
                tmp = this.w55(Companion_getInstance_77().e55(other));
              } else {
                if (!(other == null) ? typeof other === 'number' : false) {
                  tmp = this.w55(Companion_getInstance_77().f55(other));
                } else {
                  tmp = -1;
                }
              }
            }
          }
        }
      }
    }
    var comparison = tmp;
    return comparison === 0;
  };
  protoOf(BigDecimal).hashCode = function () {
    if (this.i54()) {
      return 0;
    }
    return removeTrailingZeroes(this, this).x54_1.hashCode() + this.y54_1.hashCode() | 0;
  };
  protoOf(BigDecimal).toString = function () {
    if (Companion_getInstance_77().n54_1) {
      return this.s56();
    }
    var significandString = this.x54_1.v2t(10);
    var tmp;
    if (this.x54_1.i56(0) < 0) {
      tmp = 2;
    } else {
      tmp = 1;
    }
    var modifier = tmp;
    var tmp_0;
    var tmp0 = this.x54_1.toString();
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.text.dropLastWhile' call
      var inductionVariable = get_lastIndex_3(tmp0);
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          // Inline function 'com.ionspin.kotlin.bignum.decimal.BigDecimal.toString.<anonymous>' call
          if (!(charSequenceGet(tmp0, index) === _Char___init__impl__6a9atx(48))) {
            // Inline function 'kotlin.text.substring' call
            var endIndex = index + 1 | 0;
            // Inline function 'kotlin.js.asDynamic' call
            tmp$ret$3 = tmp0.substring(0, endIndex);
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$3 = '';
    }
    if (tmp$ret$3.length <= 1) {
      tmp_0 = '0';
    } else {
      tmp_0 = '';
    }
    var expand = tmp_0;
    var tmp_1;
    if (this.y54_1.d1(new Long(0, 0)) > 0) {
      tmp_1 = placeADotInString(this, significandString, significandString.length - modifier | 0) + expand + 'E+' + this.y54_1.toString();
    } else if (this.y54_1.d1(new Long(0, 0)) < 0) {
      tmp_1 = placeADotInString(this, significandString, significandString.length - modifier | 0) + expand + 'E' + this.y54_1.toString();
    } else if (this.y54_1.equals(new Long(0, 0))) {
      tmp_1 = placeADotInString(this, significandString, significandString.length - modifier | 0) + expand;
    } else {
      throw RuntimeException_init_$Create$_0('Invalid state, please report a bug (Integer compareTo invalid)');
    }
    return tmp_1;
  };
  protoOf(BigDecimal).s56 = function () {
    if (this.i54()) {
      return '0';
    }
    var digits = this.x54_1.b54();
    if (this.y54_1.d1(new Long(2147483647, 0)) > 0) {
      throw RuntimeException_init_$Create$_0('Invalid toStringExpanded request (exponent > Int.MAX_VALUE)');
    }
    var significandString = this.x54_1.t56(10);
    var tmp;
    if (this.x54_1.y53_1.equals(Sign_NEGATIVE_getInstance())) {
      tmp = '-';
    } else {
      tmp = '';
    }
    var sign = tmp;
    var tmp_0;
    if (this.y54_1.d1(new Long(0, 0)) > 0) {
      // Inline function 'kotlin.Long.plus' call
      var diffBigInt = this.y54_1.j3(digits).i3(toLong(1));
      var tmp_1;
      if (diffBigInt.d1(new Long(0, 0)) > 0) {
        var expandZeros = this.u56(diffBigInt, _Char___init__impl__6a9atx(48));
        tmp_1 = significandString + expandZeros;
      } else {
        tmp_1 = placeADotInStringExpanded(this, significandString, (significandString.length - this.y54_1.z3() | 0) - 1 | 0);
      }
      tmp_0 = tmp_1;
    } else if (this.y54_1.d1(new Long(0, 0)) < 0) {
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = this.y54_1.z3();
      var diffInt = abs(this_0);
      var tmp_2;
      if (diffInt > 0) {
        // Inline function 'kotlin.math.absoluteValue' call
        var this_1 = this.y54_1;
        var tmp$ret$2 = abs_0(this_1);
        var expandZeros_0 = this.u56(tmp$ret$2, _Char___init__impl__6a9atx(48));
        tmp_2 = placeADotInStringExpanded(this, expandZeros_0 + significandString, (diffInt + significandString.length | 0) - 1 | 0);
      } else {
        tmp_2 = placeADotInStringExpanded(this, significandString, significandString.length - 1 | 0);
      }
      tmp_0 = tmp_2;
    } else if (this.y54_1.equals(new Long(0, 0))) {
      if (digits.equals(new Long(1, 0))) {
        return sign + significandString;
      }
      tmp_0 = placeADotInStringExpanded(this, significandString, significandString.length - 1 | 0);
    } else {
      throw RuntimeException_init_$Create$_0('Invalid state, please report a bug (Integer compareTo invalid)');
    }
    var adjusted = tmp_0;
    return sign + adjusted;
  };
  protoOf(BigDecimal).u56 = function (_this__u8e3s4, char) {
    if (_this__u8e3s4.d1(new Long(0, 0)) < 0) {
      throw RuntimeException_init_$Create$_0('Char cannot be multiplied with negative number');
    }
    var counter = _this__u8e3s4;
    var stringBuilder = StringBuilder_init_$Create$_1();
    while (counter.d1(new Long(0, 0)) > 0) {
      stringBuilder.e9(char);
      counter = counter.o3();
    }
    return stringBuilder.toString();
  };
  function toBigDecimal(_this__u8e3s4, exponentModifier, decimalMode) {
    exponentModifier = exponentModifier === VOID ? null : exponentModifier;
    decimalMode = decimalMode === VOID ? null : decimalMode;
    var tmp = Companion_getInstance_77().q55(_this__u8e3s4, decimalMode);
    return tmp.n56(exponentModifier == null ? new Long(0, 0) : exponentModifier);
  }
  function Companion_78() {
    Companion_instance_78 = this;
    this.u55_1 = new DecimalMode();
    this.v55_1 = new DecimalMode(new Long(30, 0), RoundingMode_ROUND_HALF_AWAY_FROM_ZERO_getInstance(), new Long(2, 0));
  }
  var Companion_instance_78;
  function Companion_getInstance_78() {
    if (Companion_instance_78 == null)
      new Companion_78();
    return Companion_instance_78;
  }
  function DecimalMode(decimalPrecision, roundingMode, scale) {
    Companion_getInstance_78();
    decimalPrecision = decimalPrecision === VOID ? new Long(0, 0) : decimalPrecision;
    roundingMode = roundingMode === VOID ? RoundingMode_NONE_getInstance() : roundingMode;
    scale = scale === VOID ? new Long(-1, -1) : scale;
    this.m53_1 = decimalPrecision;
    this.n53_1 = roundingMode;
    this.o53_1 = scale;
    if (this.m53_1.d1(new Long(0, 0)) < 0) {
      throw ArithmeticException_init_$Create$_0('Negative decimal precision is not allowed.');
    }
    this.p53_1 = this.m53_1.equals(new Long(0, 0));
    this.q53_1 = this.o53_1.d1(new Long(0, 0)) >= 0;
    if (!this.q53_1 && this.m53_1.equals(new Long(0, 0)) && !this.n53_1.equals(RoundingMode_NONE_getInstance())) {
      throw ArithmeticException_init_$Create$_0('Rounding mode with 0 digits precision.');
    }
    if (this.o53_1.d1(new Long(-1, -1)) < 0) {
      throw ArithmeticException_init_$Create$_0('Negative Scale is unsupported.');
    }
    if (this.q53_1 && this.n53_1.equals(RoundingMode_NONE_getInstance())) {
      throw ArithmeticException_init_$Create$_0('Scale of ' + this.o53_1.toString() + ' digits to the right of the decimal requires a RoundingMode that is not NONE.');
    }
  }
  protoOf(DecimalMode).v56 = function (decimalPrecision, roundingMode, scale) {
    return new DecimalMode(decimalPrecision, roundingMode, scale);
  };
  protoOf(DecimalMode).x55 = function (decimalPrecision, roundingMode, scale, $super) {
    decimalPrecision = decimalPrecision === VOID ? this.m53_1 : decimalPrecision;
    roundingMode = roundingMode === VOID ? this.n53_1 : roundingMode;
    scale = scale === VOID ? this.o53_1 : scale;
    return $super === VOID ? this.v56(decimalPrecision, roundingMode, scale) : $super.v56.call(this, decimalPrecision, roundingMode, scale);
  };
  protoOf(DecimalMode).toString = function () {
    return 'DecimalMode(decimalPrecision=' + this.m53_1.toString() + ', roundingMode=' + this.n53_1.toString() + ', scale=' + this.o53_1.toString() + ')';
  };
  protoOf(DecimalMode).hashCode = function () {
    var result = this.m53_1.hashCode();
    result = imul(result, 31) + this.n53_1.hashCode() | 0;
    result = imul(result, 31) + this.o53_1.hashCode() | 0;
    return result;
  };
  protoOf(DecimalMode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DecimalMode))
      return false;
    var tmp0_other_with_cast = other instanceof DecimalMode ? other : THROW_CCE();
    if (!this.m53_1.equals(tmp0_other_with_cast.m53_1))
      return false;
    if (!this.n53_1.equals(tmp0_other_with_cast.n53_1))
      return false;
    if (!this.o53_1.equals(tmp0_other_with_cast.o53_1))
      return false;
    return true;
  };
  var RoundingMode_FLOOR_instance;
  var RoundingMode_CEILING_instance;
  var RoundingMode_AWAY_FROM_ZERO_instance;
  var RoundingMode_TOWARDS_ZERO_instance;
  var RoundingMode_NONE_instance;
  var RoundingMode_ROUND_HALF_AWAY_FROM_ZERO_instance;
  var RoundingMode_ROUND_HALF_TOWARDS_ZERO_instance;
  var RoundingMode_ROUND_HALF_CEILING_instance;
  var RoundingMode_ROUND_HALF_FLOOR_instance;
  var RoundingMode_ROUND_HALF_TO_EVEN_instance;
  var RoundingMode_ROUND_HALF_TO_ODD_instance;
  var RoundingMode_entriesInitialized;
  function RoundingMode_initEntries() {
    if (RoundingMode_entriesInitialized)
      return Unit_instance;
    RoundingMode_entriesInitialized = true;
    RoundingMode_FLOOR_instance = new RoundingMode('FLOOR', 0);
    RoundingMode_CEILING_instance = new RoundingMode('CEILING', 1);
    RoundingMode_AWAY_FROM_ZERO_instance = new RoundingMode('AWAY_FROM_ZERO', 2);
    RoundingMode_TOWARDS_ZERO_instance = new RoundingMode('TOWARDS_ZERO', 3);
    RoundingMode_NONE_instance = new RoundingMode('NONE', 4);
    RoundingMode_ROUND_HALF_AWAY_FROM_ZERO_instance = new RoundingMode('ROUND_HALF_AWAY_FROM_ZERO', 5);
    RoundingMode_ROUND_HALF_TOWARDS_ZERO_instance = new RoundingMode('ROUND_HALF_TOWARDS_ZERO', 6);
    RoundingMode_ROUND_HALF_CEILING_instance = new RoundingMode('ROUND_HALF_CEILING', 7);
    RoundingMode_ROUND_HALF_FLOOR_instance = new RoundingMode('ROUND_HALF_FLOOR', 8);
    RoundingMode_ROUND_HALF_TO_EVEN_instance = new RoundingMode('ROUND_HALF_TO_EVEN', 9);
    RoundingMode_ROUND_HALF_TO_ODD_instance = new RoundingMode('ROUND_HALF_TO_ODD', 10);
  }
  function RoundingMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function RoundingMode_FLOOR_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_FLOOR_instance;
  }
  function RoundingMode_AWAY_FROM_ZERO_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_AWAY_FROM_ZERO_instance;
  }
  function RoundingMode_TOWARDS_ZERO_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_TOWARDS_ZERO_instance;
  }
  function RoundingMode_NONE_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_NONE_instance;
  }
  function RoundingMode_ROUND_HALF_AWAY_FROM_ZERO_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_ROUND_HALF_AWAY_FROM_ZERO_instance;
  }
  function RoundingMode_ROUND_HALF_TO_EVEN_getInstance() {
    RoundingMode_initEntries();
    return RoundingMode_ROUND_HALF_TO_EVEN_instance;
  }
  function BigInteger_init_$Init$(long, $this) {
    var tmp = Companion_getInstance_79().r53_1.w56(long);
    // Inline function 'com.ionspin.kotlin.bignum.integer.Companion.determinSignFromNumber' call
    Companion_getInstance_79();
    var tmp22_subject = getKClass(Long);
    var tmp_0;
    if (tmp22_subject.equals(getKClass(Long))) {
      if (!(long instanceof Long))
        THROW_CCE();
      var tmp_1;
      // Inline function 'kotlin.Long.compareTo' call
      if (long.d1(toLong(0)) < 0) {
        tmp_1 = Sign_NEGATIVE_getInstance();
      } else {
        // Inline function 'kotlin.Long.compareTo' call
        if (long.d1(toLong(0)) > 0) {
          tmp_1 = Sign_POSITIVE_getInstance();
        } else {
          tmp_1 = Sign_ZERO_getInstance();
        }
      }
      tmp_0 = tmp_1;
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().jc())) {
      if (typeof long !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(long, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(long, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().ic())) {
      if (typeof long !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(long, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(long, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().hc())) {
      if (typeof long !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(long, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(long, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else {
      throw RuntimeException_init_$Create$_0('Unsupported type ' + toString_1(getKClass(Long)));
    }
    var tmp$ret$2 = tmp_0;
    BigInteger.call($this, tmp, tmp$ret$2);
    return $this;
  }
  function BigInteger_init_$Create$(long) {
    return BigInteger_init_$Init$(long, objectCreate(protoOf(BigInteger)));
  }
  function BigInteger_init_$Init$_0(int, $this) {
    var tmp = Companion_getInstance_79().r53_1.x56(int);
    // Inline function 'com.ionspin.kotlin.bignum.integer.Companion.determinSignFromNumber' call
    Companion_getInstance_79();
    var tmp22_subject = PrimitiveClasses_getInstance().jc();
    var tmp_0;
    if (tmp22_subject.equals(getKClass(Long))) {
      if (!(int instanceof Long))
        THROW_CCE();
      var tmp_1;
      // Inline function 'kotlin.Long.compareTo' call
      if (int.d1(toLong(0)) < 0) {
        tmp_1 = Sign_NEGATIVE_getInstance();
      } else {
        // Inline function 'kotlin.Long.compareTo' call
        if (int.d1(toLong(0)) > 0) {
          tmp_1 = Sign_POSITIVE_getInstance();
        } else {
          tmp_1 = Sign_ZERO_getInstance();
        }
      }
      tmp_0 = tmp_1;
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().jc())) {
      if (typeof int !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(int, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(int, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().ic())) {
      if (typeof int !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(int, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(int, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().hc())) {
      if (typeof int !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(int, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(int, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else {
      throw RuntimeException_init_$Create$_0('Unsupported type ' + toString_1(PrimitiveClasses_getInstance().jc()));
    }
    var tmp$ret$2 = tmp_0;
    BigInteger.call($this, tmp, tmp$ret$2);
    return $this;
  }
  function BigInteger_init_$Create$_0(int) {
    return BigInteger_init_$Init$_0(int, objectCreate(protoOf(BigInteger)));
  }
  function BigInteger_init_$Init$_1(short, $this) {
    var tmp = Companion_getInstance_79().r53_1.y56(short);
    // Inline function 'com.ionspin.kotlin.bignum.integer.Companion.determinSignFromNumber' call
    Companion_getInstance_79();
    var tmp22_subject = PrimitiveClasses_getInstance().ic();
    var tmp_0;
    if (tmp22_subject.equals(getKClass(Long))) {
      if (!(short instanceof Long))
        THROW_CCE();
      var tmp_1;
      // Inline function 'kotlin.Long.compareTo' call
      if (short.d1(toLong(0)) < 0) {
        tmp_1 = Sign_NEGATIVE_getInstance();
      } else {
        // Inline function 'kotlin.Long.compareTo' call
        if (short.d1(toLong(0)) > 0) {
          tmp_1 = Sign_POSITIVE_getInstance();
        } else {
          tmp_1 = Sign_ZERO_getInstance();
        }
      }
      tmp_0 = tmp_1;
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().jc())) {
      if (typeof short !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(short, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(short, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().ic())) {
      if (typeof short !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(short, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(short, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().hc())) {
      if (typeof short !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(short, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(short, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else {
      throw RuntimeException_init_$Create$_0('Unsupported type ' + toString_1(PrimitiveClasses_getInstance().ic()));
    }
    var tmp$ret$2 = tmp_0;
    BigInteger.call($this, tmp, tmp$ret$2);
    return $this;
  }
  function BigInteger_init_$Create$_1(short) {
    return BigInteger_init_$Init$_1(short, objectCreate(protoOf(BigInteger)));
  }
  function BigInteger_init_$Init$_2(byte, $this) {
    var tmp = Companion_getInstance_79().r53_1.z56(byte);
    // Inline function 'com.ionspin.kotlin.bignum.integer.Companion.determinSignFromNumber' call
    Companion_getInstance_79();
    var tmp22_subject = PrimitiveClasses_getInstance().hc();
    var tmp_0;
    if (tmp22_subject.equals(getKClass(Long))) {
      if (!(byte instanceof Long))
        THROW_CCE();
      var tmp_1;
      // Inline function 'kotlin.Long.compareTo' call
      if (byte.d1(toLong(0)) < 0) {
        tmp_1 = Sign_NEGATIVE_getInstance();
      } else {
        // Inline function 'kotlin.Long.compareTo' call
        if (byte.d1(toLong(0)) > 0) {
          tmp_1 = Sign_POSITIVE_getInstance();
        } else {
          tmp_1 = Sign_ZERO_getInstance();
        }
      }
      tmp_0 = tmp_1;
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().jc())) {
      if (typeof byte !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(byte, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(byte, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().ic())) {
      if (typeof byte !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(byte, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(byte, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else if (tmp22_subject.equals(PrimitiveClasses_getInstance().hc())) {
      if (typeof byte !== 'number')
        THROW_CCE();
      tmp_0 = compareTo_0(byte, 0) < 0 ? Sign_NEGATIVE_getInstance() : compareTo_0(byte, 0) > 0 ? Sign_POSITIVE_getInstance() : Sign_ZERO_getInstance();
    } else {
      throw RuntimeException_init_$Create$_0('Unsupported type ' + toString_1(PrimitiveClasses_getInstance().hc()));
    }
    var tmp$ret$2 = tmp_0;
    BigInteger.call($this, tmp, tmp$ret$2);
    return $this;
  }
  function BigInteger_init_$Create$_2(byte) {
    return BigInteger_init_$Init$_2(byte, objectCreate(protoOf(BigInteger)));
  }
  function Companion_79() {
    Companion_instance_79 = this;
    this.r53_1 = get_chosenArithmetic();
    this.s53_1 = new BigInteger(this.r53_1.a57(), Sign_ZERO_getInstance());
    this.t53_1 = new BigInteger(this.r53_1.b57(), Sign_POSITIVE_getInstance());
    this.u53_1 = new BigInteger(this.r53_1.c57(), Sign_POSITIVE_getInstance());
    this.v53_1 = new BigInteger(this.r53_1.d57(), Sign_POSITIVE_getInstance());
    var tmp = this;
    // Inline function 'kotlin.math.log10' call
    tmp.w53_1 = log10(2.0);
  }
  protoOf(Companion_79).p52 = function (string, base) {
    if (base < 2 || base > 36) {
      throw NumberFormatException_init_$Create$_0('Unsupported base: ' + base + '. Supported base range is from 2 to 36');
    }
    var decimal = contains_8(string, _Char___init__impl__6a9atx(46));
    if (decimal) {
      var bigDecimal = Companion_getInstance_77().r55(string);
      var isActuallyDecimal = bigDecimal.l56(bigDecimal.o56()).i56(0) > 0;
      if (isActuallyDecimal) {
        throw NumberFormatException_init_$Create$_0('Supplied string is decimal, which cannot be converted to BigInteger without precision loss.');
      }
      return bigDecimal.p56();
    }
    var signed = charSequenceGet(string, 0) === _Char___init__impl__6a9atx(45) || charSequenceGet(string, 0) === _Char___init__impl__6a9atx(43);
    var tmp;
    if (signed) {
      if (string.length === 1) {
        throw NumberFormatException_init_$Create$_0('Invalid big integer: ' + string);
      }
      var tmp_0;
      if (charSequenceGet(string, 0) === _Char___init__impl__6a9atx(45)) {
        tmp_0 = Sign_NEGATIVE_getInstance();
      } else {
        tmp_0 = Sign_POSITIVE_getInstance();
      }
      var isNegative = tmp_0;
      if (string.length === 2 && charSequenceGet(string, 1) === _Char___init__impl__6a9atx(48)) {
        return this.s53_1;
      }
      // Inline function 'kotlin.text.substring' call
      var endIndex = string.length;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = string.substring(1, endIndex);
      tmp = new BigInteger(this.r53_1.e57(tmp$ret$1, base), isNegative);
    } else {
      if (string.length === 1 && charSequenceGet(string, 0) === _Char___init__impl__6a9atx(48)) {
        return this.s53_1;
      }
      tmp = new BigInteger(this.r53_1.e57(string, base), Sign_POSITIVE_getInstance());
    }
    return tmp;
  };
  protoOf(Companion_79).f57 = function (uLong) {
    return new BigInteger(this.r53_1.g57(uLong), Sign_POSITIVE_getInstance());
  };
  protoOf(Companion_79).h57 = function (uInt) {
    return new BigInteger(this.r53_1.i57(uInt), Sign_POSITIVE_getInstance());
  };
  protoOf(Companion_79).j57 = function (uShort) {
    return new BigInteger(this.r53_1.k57(uShort), Sign_POSITIVE_getInstance());
  };
  protoOf(Companion_79).l57 = function (uByte) {
    return new BigInteger(this.r53_1.m57(uByte), Sign_POSITIVE_getInstance());
  };
  protoOf(Companion_79).h55 = function (long) {
    return BigInteger_init_$Create$(long);
  };
  protoOf(Companion_79).r52 = function (int) {
    return BigInteger_init_$Create$_0(int);
  };
  protoOf(Companion_79).l55 = function (short) {
    return BigInteger_init_$Create$_1(short);
  };
  protoOf(Companion_79).n55 = function (byte) {
    return BigInteger_init_$Create$_2(byte);
  };
  protoOf(Companion_79).s52 = function (float, exactRequired) {
    // Inline function 'kotlin.math.floor' call
    var floatDecimalPart = float - Math.floor(float);
    var tmp = Companion_getInstance_77();
    // Inline function 'kotlin.math.floor' call
    var tmp$ret$1 = Math.floor(float);
    var bigDecimal = tmp.o55(tmp$ret$1, null);
    if (exactRequired) {
      if (floatDecimalPart > 0) {
        throw ArithmeticException_init_$Create$_0('Cant create BigInteger without precision loss, and exact  value was required');
      }
    }
    return bigDecimal.p56();
  };
  protoOf(Companion_79).u52 = function (double, exactRequired) {
    // Inline function 'kotlin.math.floor' call
    var doubleDecimalPart = double - Math.floor(double);
    var tmp = Companion_getInstance_77();
    // Inline function 'kotlin.math.floor' call
    var tmp$ret$1 = Math.floor(double);
    var bigDecimal = tmp.q55(tmp$ret$1, null);
    if (exactRequired) {
      if (doubleDecimalPart > 0) {
        throw ArithmeticException_init_$Create$_0('Cant create BigInteger without precision loss, and exact  value was required');
      }
    }
    return bigDecimal.p56();
  };
  var Companion_instance_79;
  function Companion_getInstance_79() {
    if (Companion_instance_79 == null)
      new Companion_79();
    return Companion_instance_79;
  }
  function isResultZero($this, resultMagnitude) {
    return Companion_getInstance_79().r53_1.n57(resultMagnitude, Companion_getInstance_79().r53_1.a57()) === 0;
  }
  function javascriptNumberComparison_0($this, number) {
    var double = numberToDouble(number);
    var tmp;
    if (double > (new Long(-1, 2147483647)).a4()) {
      tmp = $this.q56(Companion_getInstance_79().q52(double.toString()));
    } else if (double % 1 === 0.0) {
      tmp = $this.q56(Companion_getInstance_79().h55(numberToLong(number)));
    } else {
      var tmp_0 = numberToDouble(number);
      tmp = $this.o57(tmp_0, BigInteger$javascriptNumberComparison$lambda($this));
    }
    return tmp;
  }
  function QuotientAndRemainder(quotient, remainder) {
    this.e54_1 = quotient;
    this.f54_1 = remainder;
  }
  protoOf(QuotientAndRemainder).toString = function () {
    return 'QuotientAndRemainder(quotient=' + this.e54_1.toString() + ', remainder=' + this.f54_1.toString() + ')';
  };
  protoOf(QuotientAndRemainder).hashCode = function () {
    var result = this.e54_1.hashCode();
    result = imul(result, 31) + this.f54_1.hashCode() | 0;
    return result;
  };
  protoOf(QuotientAndRemainder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof QuotientAndRemainder))
      return false;
    var tmp0_other_with_cast = other instanceof QuotientAndRemainder ? other : THROW_CCE();
    if (!this.e54_1.equals(tmp0_other_with_cast.e54_1))
      return false;
    if (!this.f54_1.equals(tmp0_other_with_cast.f54_1))
      return false;
    return true;
  };
  function BigInteger$compareTo$lambda(this$0) {
    return function (it) {
      return this$0.q56(it);
    };
  }
  function BigInteger$compareTo$lambda_0(this$0) {
    return function (it) {
      return this$0.q56(it);
    };
  }
  function BigInteger$javascriptNumberComparison$lambda(this$0) {
    return function (it) {
      return this$0.q56(it);
    };
  }
  function BigInteger(wordArray, requestedSign) {
    Companion_getInstance_79();
    if (requestedSign.equals(Sign_ZERO_getInstance())) {
      // Inline function 'kotlin.require' call
      if (!isResultZero(this, wordArray)) {
        // Inline function 'com.ionspin.kotlin.bignum.integer.BigInteger.<anonymous>' call
        var message = 'sign should be Sign.ZERO iff magnitude has a value of 0';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
    }
    this.x53_1 = BigInteger63Arithmetic_getInstance().h58(wordArray);
    var tmp = this;
    var tmp_0;
    if (isResultZero(this, this.x53_1)) {
      tmp_0 = Sign_ZERO_getInstance();
    } else {
      tmp_0 = requestedSign;
    }
    tmp.y53_1 = tmp_0;
    this.z53_1 = _ULongArray___get_size__impl__ju6dtr(this.x53_1);
    this.a54_1 = null;
  }
  protoOf(BigInteger).w52 = function () {
    return Companion_getInstance_79();
  };
  protoOf(BigInteger).x52 = function () {
    return this;
  };
  protoOf(BigInteger).i58 = function (other) {
    var comparison = Companion_getInstance_79().r53_1.n57(this.x53_1, other.x53_1);
    var tmp;
    if (other.y53_1.equals(this.y53_1)) {
      return new BigInteger(Companion_getInstance_79().r53_1.k58(this.x53_1, other.x53_1), this.y53_1);
    } else {
      var tmp_0;
      if (comparison > 0) {
        tmp_0 = new BigInteger(Companion_getInstance_79().r53_1.j58(this.x53_1, other.x53_1), this.y53_1);
      } else if (comparison < 0) {
        tmp_0 = new BigInteger(Companion_getInstance_79().r53_1.j58(other.x53_1, this.x53_1), other.y53_1);
      } else {
        tmp_0 = Companion_getInstance_79().s53_1;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(BigInteger).z52 = function (other) {
    return this.i58(other instanceof BigInteger ? other : THROW_CCE());
  };
  protoOf(BigInteger).l58 = function (other) {
    if (this.i54()) {
      return other.t55();
    }
    if (other.i54()) {
      return this;
    }
    var tmp;
    if (other.y53_1.equals(this.y53_1)) {
      var comparison = Companion_getInstance_79().r53_1.n57(this.x53_1, other.x53_1);
      var tmp_0;
      if (comparison > 0) {
        tmp_0 = new BigInteger(Companion_getInstance_79().r53_1.j58(this.x53_1, other.x53_1), this.y53_1);
      } else if (comparison < 0) {
        tmp_0 = new BigInteger(Companion_getInstance_79().r53_1.j58(other.x53_1, this.x53_1), this.y53_1.o58());
      } else {
        tmp_0 = Companion_getInstance_79().s53_1;
      }
      tmp = tmp_0;
    } else {
      return new BigInteger(Companion_getInstance_79().r53_1.k58(this.x53_1, other.x53_1), this.y53_1);
    }
    return tmp;
  };
  protoOf(BigInteger).b53 = function (other) {
    return this.l58(other instanceof BigInteger ? other : THROW_CCE());
  };
  protoOf(BigInteger).p58 = function (other) {
    if (this.i54() || other.i54()) {
      return Companion_getInstance_79().s53_1;
    }
    if (other.equals(Companion_getInstance_79().t53_1)) {
      return this;
    }
    var tmp;
    if (!this.y53_1.equals(other.y53_1)) {
      tmp = Sign_NEGATIVE_getInstance();
    } else {
      tmp = Sign_POSITIVE_getInstance();
    }
    var sign = tmp;
    var tmp_0;
    if (sign.equals(Sign_POSITIVE_getInstance())) {
      tmp_0 = new BigInteger(Companion_getInstance_79().r53_1.q58(this.x53_1, other.x53_1), sign);
    } else {
      tmp_0 = new BigInteger(Companion_getInstance_79().r53_1.q58(this.x53_1, other.x53_1), sign);
    }
    return tmp_0;
  };
  protoOf(BigInteger).d53 = function (other) {
    return this.p58(other instanceof BigInteger ? other : THROW_CCE());
  };
  protoOf(BigInteger).r58 = function (other) {
    if (other.i54()) {
      throw ArithmeticException_init_$Create$_0('Division by zero! ' + this.toString() + ' / ' + other.toString());
    }
    var result = Companion_getInstance_79().r53_1.s58(this.x53_1, other.x53_1).dh_1.on_1;
    var tmp;
    if (equals(result, Companion_getInstance_79().r53_1.a57())) {
      tmp = Companion_getInstance_79().s53_1;
    } else {
      var tmp_0;
      if (!this.y53_1.equals(other.y53_1)) {
        tmp_0 = Sign_NEGATIVE_getInstance();
      } else {
        tmp_0 = Sign_POSITIVE_getInstance();
      }
      var sign = tmp_0;
      tmp = new BigInteger(result, sign);
    }
    return tmp;
  };
  protoOf(BigInteger).f53 = function (other) {
    return this.r58(other instanceof BigInteger ? other : THROW_CCE());
  };
  protoOf(BigInteger).t58 = function (other) {
    if (other.i54()) {
      throw ArithmeticException_init_$Create$_0('Division by zero! ' + this.toString() + ' / ' + other.toString());
    }
    var tmp;
    if (!this.y53_1.equals(other.y53_1)) {
      tmp = Sign_NEGATIVE_getInstance();
    } else {
      tmp = Sign_POSITIVE_getInstance();
    }
    var sign = tmp;
    var result = Companion_getInstance_79().r53_1.s58(this.x53_1, other.x53_1).eh_1.on_1;
    if (equals(result, Companion_getInstance_79().r53_1.a57())) {
      sign = Sign_ZERO_getInstance();
    }
    return new BigInteger(result, sign);
  };
  protoOf(BigInteger).l53 = function (other) {
    return this.t58(other instanceof BigInteger ? other : THROW_CCE());
  };
  protoOf(BigInteger).u58 = function (other) {
    if (other.i54()) {
      throw ArithmeticException_init_$Create$_0('Division by zero! ' + this.toString() + ' / ' + other.toString());
    }
    var tmp;
    if (!this.y53_1.equals(other.y53_1)) {
      tmp = Sign_NEGATIVE_getInstance();
    } else {
      tmp = Sign_POSITIVE_getInstance();
    }
    var sign = tmp;
    var result = Companion_getInstance_79().r53_1.s58(this.x53_1, other.x53_1);
    var tmp_0;
    if (equals(result.dh_1, new ULongArray(Companion_getInstance_79().r53_1.a57()))) {
      tmp_0 = Companion_getInstance_79().s53_1;
    } else {
      tmp_0 = new BigInteger(result.dh_1.on_1, sign);
    }
    var quotient = tmp_0;
    var tmp_1;
    if (equals(result.eh_1, new ULongArray(Companion_getInstance_79().r53_1.a57()))) {
      tmp_1 = Companion_getInstance_79().s53_1;
    } else {
      tmp_1 = new BigInteger(result.eh_1.on_1, this.y53_1);
    }
    var remainder = tmp_1;
    return new Pair(quotient, remainder);
  };
  protoOf(BigInteger).q56 = function (other) {
    if (this.i54() && other.i54())
      return 0;
    if (other.i54() && this.y53_1.equals(Sign_POSITIVE_getInstance()))
      return 1;
    if (other.i54() && this.y53_1.equals(Sign_NEGATIVE_getInstance()))
      return -1;
    if (this.i54() && other.y53_1.equals(Sign_POSITIVE_getInstance()))
      return -1;
    if (this.i54() && other.y53_1.equals(Sign_NEGATIVE_getInstance()))
      return 1;
    if (!this.y53_1.equals(other.y53_1))
      return this.y53_1.equals(Sign_POSITIVE_getInstance()) ? 1 : -1;
    var result = Companion_getInstance_79().r53_1.n57(this.x53_1, other.x53_1);
    var tmp;
    if (this.y53_1.equals(Sign_NEGATIVE_getInstance()) && other.y53_1.equals(Sign_NEGATIVE_getInstance())) {
      tmp = imul(result, -1);
    } else {
      tmp = result;
    }
    return tmp;
  };
  protoOf(BigInteger).i54 = function () {
    return this.y53_1.equals(Sign_ZERO_getInstance()) || get_chosenArithmetic().n57(this.x53_1, get_chosenArithmetic().a57()) === 0;
  };
  protoOf(BigInteger).t55 = function () {
    return new BigInteger(this.x53_1, this.y53_1.o58());
  };
  protoOf(BigInteger).g54 = function () {
    return new BigInteger(this.x53_1, Sign_POSITIVE_getInstance());
  };
  protoOf(BigInteger).c54 = function (exponent) {
    if (exponent.d1(new Long(0, 0)) < 0) {
      throw ArithmeticException_init_$Create$_0('Negative exponent not supported with BigInteger');
    }
    var tmp;
    if (this.i54()) {
      tmp = Companion_getInstance_79().s53_1;
    } else if (this.equals(Companion_getInstance_79().t53_1)) {
      tmp = Companion_getInstance_79().t53_1;
    } else {
      var tmp_0;
      if (this.y53_1.equals(Sign_NEGATIVE_getInstance())) {
        var tmp_1;
        // Inline function 'kotlin.Long.rem' call
        if (exponent.m3(toLong(2)).equals(new Long(0, 0))) {
          tmp_1 = Sign_POSITIVE_getInstance();
        } else {
          tmp_1 = Sign_NEGATIVE_getInstance();
        }
        tmp_0 = tmp_1;
      } else {
        tmp_0 = Sign_POSITIVE_getInstance();
      }
      var sign = tmp_0;
      tmp = new BigInteger(Companion_getInstance_79().r53_1.v58(this.x53_1, exponent), sign);
    }
    return tmp;
  };
  protoOf(BigInteger).w58 = function (exponent) {
    return this.c54(toLong(exponent));
  };
  protoOf(BigInteger).v54 = function () {
    var tmp;
    switch (this.y53_1.a3_1) {
      case 0:
        tmp = 1;
        break;
      case 1:
        tmp = -1;
        break;
      case 2:
        tmp = 0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(BigInteger).b54 = function () {
    if (this.i54()) {
      return new Long(1, 0);
    }
    var powersOf10 = BigInteger63Arithmetic_getInstance().g58_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var inductionVariable = 0;
      var last = powersOf10.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ionspin.kotlin.bignum.integer.BigInteger.numberOfDecimalDigits.<anonymous>' call
          var it = powersOf10[index].on_1;
          if (BigInteger63Arithmetic_getInstance().x58(it, this.x53_1) > 0) {
            tmp$ret$1 = index;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$1 = -1;
    }
    var quickSearch = tmp$ret$1;
    if (!(quickSearch === -1)) {
      return toLong(quickSearch);
    }
    var tmp = this.e53(Companion_getInstance_79().v53_1.w58(powersOf10.length));
    var counter = new Long(0, 0);
    while (!tmp.i54()) {
      tmp = tmp.j53(10);
      counter = counter.n3();
    }
    var tmp2 = counter;
    // Inline function 'kotlin.Long.plus' call
    var other = powersOf10.length;
    return tmp2.i3(toLong(other));
  };
  protoOf(BigInteger).o3 = function () {
    return this.a53(Companion_getInstance_79().t53_1);
  };
  protoOf(BigInteger).n3 = function () {
    return this.y52(Companion_getInstance_79().t53_1);
  };
  protoOf(BigInteger).d54 = function (other) {
    var result = this.u58(other);
    return new QuotientAndRemainder(result.dh_1, result.eh_1);
  };
  protoOf(BigInteger).i56 = function (other) {
    if (isNumber(other)) {
      if (RuntimePlatform_instance.r56().equals(Platform_JS_getInstance())) {
        return javascriptNumberComparison_0(this, other);
      }
    }
    var tmp;
    if (other instanceof BigInteger) {
      tmp = this.q56(other);
    } else {
      if (other instanceof Long) {
        tmp = this.q56(Companion_getInstance_79().h55(other));
      } else {
        if (typeof other === 'number') {
          tmp = this.q56(Companion_getInstance_79().r52(other));
        } else {
          if (typeof other === 'number') {
            tmp = this.q56(Companion_getInstance_79().l55(other));
          } else {
            if (typeof other === 'number') {
              tmp = this.q56(Companion_getInstance_79().n55(other));
            } else {
              if (other instanceof ULong) {
                tmp = this.q56(Companion_getInstance_79().f57(other.s1_1));
              } else {
                if (other instanceof UInt) {
                  tmp = this.q56(Companion_getInstance_79().h57(other.ym_1));
                } else {
                  if (other instanceof UShort) {
                    tmp = this.q56(Companion_getInstance_79().j57(other.un_1));
                  } else {
                    if (other instanceof UByte) {
                      tmp = this.q56(Companion_getInstance_79().l57(other.mm_1));
                    } else {
                      if (typeof other === 'number') {
                        tmp = this.o57(other, BigInteger$compareTo$lambda(this));
                      } else {
                        if (typeof other === 'number') {
                          tmp = this.y58(other, BigInteger$compareTo$lambda_0(this));
                        } else {
                          throw RuntimeException_init_$Create$_0('Invalid comparison type for BigInteger: ' + toString_1(getKClassFromExpression(other)));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  };
  protoOf(BigInteger).d = function (other) {
    return this.i56(!(other == null) ? other : THROW_CCE());
  };
  protoOf(BigInteger).o57 = function (float, comparisonBlock) {
    // Inline function 'kotlin.math.floor' call
    var withoutDecimalPart = Math.floor(float);
    var hasDecimalPart = !(float % 1 === 0.0);
    var tmp;
    if (hasDecimalPart) {
      var comparisonResult = comparisonBlock(Companion_getInstance_79().t52(withoutDecimalPart + 1));
      var tmp_0;
      if (comparisonResult === 0) {
        tmp_0 = 1;
      } else {
        tmp_0 = comparisonResult;
      }
      tmp = tmp_0;
    } else {
      tmp = comparisonBlock(Companion_getInstance_79().t52(withoutDecimalPart));
    }
    return tmp;
  };
  protoOf(BigInteger).y58 = function (double, comparisonBlock) {
    // Inline function 'kotlin.math.floor' call
    var withoutDecimalPart = Math.floor(double);
    var hasDecimalPart = !(double % 1 === 0.0);
    var tmp;
    if (hasDecimalPart) {
      var comparisonResult = comparisonBlock(Companion_getInstance_79().v52(withoutDecimalPart + 1));
      var tmp_0;
      if (comparisonResult === 0) {
        tmp_0 = 1;
      } else {
        tmp_0 = comparisonResult;
      }
      tmp = tmp_0;
    } else {
      tmp = comparisonBlock(Companion_getInstance_79().v52(withoutDecimalPart));
    }
    return tmp;
  };
  protoOf(BigInteger).equals = function (other) {
    var tmp;
    if (other instanceof BigInteger) {
      tmp = this.q56(other);
    } else {
      if (other instanceof Long) {
        tmp = this.q56(Companion_getInstance_79().h55(other));
      } else {
        if (!(other == null) ? typeof other === 'number' : false) {
          tmp = this.q56(Companion_getInstance_79().r52(other));
        } else {
          if (!(other == null) ? typeof other === 'number' : false) {
            tmp = this.q56(Companion_getInstance_79().l55(other));
          } else {
            if (!(other == null) ? typeof other === 'number' : false) {
              tmp = this.q56(Companion_getInstance_79().n55(other));
            } else {
              if (other instanceof ULong) {
                tmp = this.q56(Companion_getInstance_79().f57(other.s1_1));
              } else {
                if (other instanceof UInt) {
                  tmp = this.q56(Companion_getInstance_79().h57(other.ym_1));
                } else {
                  if (other instanceof UShort) {
                    tmp = this.q56(Companion_getInstance_79().j57(other.un_1));
                  } else {
                    if (other instanceof UByte) {
                      tmp = this.q56(Companion_getInstance_79().l57(other.mm_1));
                    } else {
                      tmp = -1;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    var comparison = tmp;
    return comparison === 0;
  };
  protoOf(BigInteger).hashCode = function () {
    // Inline function 'kotlin.collections.fold' call
    var this_0 = this.x53_1;
    var accumulator = 0;
    var _iterator__ex2g4s = ULongArray__iterator_impl_cq4d2h(this_0);
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m().s1_1;
      // Inline function 'com.ionspin.kotlin.bignum.integer.BigInteger.hashCode.<anonymous>' call
      accumulator = accumulator + ULong__hashCode_impl_6hv2lb(element) | 0;
    }
    return accumulator + this.y53_1.hashCode() | 0;
  };
  protoOf(BigInteger).toString = function () {
    return this.v2t(10);
  };
  protoOf(BigInteger).v2t = function (base) {
    var tmp;
    if (this.y53_1.equals(Sign_NEGATIVE_getInstance())) {
      tmp = '-';
    } else {
      tmp = '';
    }
    var sign = tmp;
    return sign + this.t56(base);
  };
  protoOf(BigInteger).t56 = function (base) {
    return Companion_getInstance_79().r53_1.z58(this.x53_1, base);
  };
  protoOf(BigInteger).h54 = function (exactRequired) {
    if (exactRequired && (this.i56(2147483647) > 0 || this.i56(-2147483648) < 0)) {
      throw ArithmeticException_init_$Create$_0('Cannot convert to int and provide exact value');
    }
    // Inline function 'kotlin.ULong.toInt' call
    var this_0 = ULongArray__get_impl_pr71q9(this.x53_1, 0);
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0).z3();
    return imul(tmp$ret$0, this.v54());
  };
  var Sign_POSITIVE_instance;
  var Sign_NEGATIVE_instance;
  var Sign_ZERO_instance;
  var Sign_entriesInitialized;
  function Sign_initEntries() {
    if (Sign_entriesInitialized)
      return Unit_instance;
    Sign_entriesInitialized = true;
    Sign_POSITIVE_instance = new Sign('POSITIVE', 0);
    Sign_NEGATIVE_instance = new Sign('NEGATIVE', 1);
    Sign_ZERO_instance = new Sign('ZERO', 2);
  }
  function Sign(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(Sign).o58 = function () {
    var tmp;
    switch (this.a3_1) {
      case 0:
        tmp = Sign_NEGATIVE_getInstance();
        break;
      case 1:
        tmp = Sign_POSITIVE_getInstance();
        break;
      case 2:
        tmp = Sign_ZERO_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  function Sign_POSITIVE_getInstance() {
    Sign_initEntries();
    return Sign_POSITIVE_instance;
  }
  function Sign_NEGATIVE_getInstance() {
    Sign_initEntries();
    return Sign_NEGATIVE_instance;
  }
  function Sign_ZERO_getInstance() {
    Sign_initEntries();
    return Sign_ZERO_instance;
  }
  function toBigInteger(_this__u8e3s4) {
    return Companion_getInstance_79().r52(_this__u8e3s4);
  }
  function get_chosenArithmetic() {
    _init_properties_Configuration_kt__48zwcc();
    return chosenArithmetic;
  }
  var chosenArithmetic;
  var properties_initialized_Configuration_kt_gex7mu;
  function _init_properties_Configuration_kt__48zwcc() {
    if (!properties_initialized_Configuration_kt_gex7mu) {
      properties_initialized_Configuration_kt_gex7mu = true;
      chosenArithmetic = BigInteger63Arithmetic_getInstance();
    }
  }
  var Platform_JVM_instance;
  var Platform_NATIVE_instance;
  var Platform_JS_instance;
  var Platform_WASMJS_instance;
  var Platform_entriesInitialized;
  function Platform_initEntries() {
    if (Platform_entriesInitialized)
      return Unit_instance;
    Platform_entriesInitialized = true;
    Platform_JVM_instance = new Platform('JVM', 0);
    Platform_NATIVE_instance = new Platform('NATIVE', 1);
    Platform_JS_instance = new Platform('JS', 2);
    Platform_WASMJS_instance = new Platform('WASMJS', 3);
  }
  function Platform(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Platform_JS_getInstance() {
    Platform_initEntries();
    return Platform_JS_instance;
  }
  function Platform_WASMJS_getInstance() {
    Platform_initEntries();
    return Platform_WASMJS_instance;
  }
  function Sextuple(a, b, c, d, e, f) {
    this.a59_1 = a;
    this.b59_1 = b;
    this.c59_1 = c;
    this.d59_1 = d;
    this.e59_1 = e;
    this.f59_1 = f;
  }
  protoOf(Sextuple).ug = function () {
    return this.a59_1;
  };
  protoOf(Sextuple).vg = function () {
    return this.b59_1;
  };
  protoOf(Sextuple).hm = function () {
    return this.c59_1;
  };
  protoOf(Sextuple).g59 = function () {
    return this.d59_1;
  };
  protoOf(Sextuple).h59 = function () {
    return this.e59_1;
  };
  protoOf(Sextuple).i59 = function () {
    return this.f59_1;
  };
  protoOf(Sextuple).toString = function () {
    return 'Sextuple(a=' + toString_0(this.a59_1) + ', b=' + toString_0(this.b59_1) + ', c=' + toString_0(this.c59_1) + ', d=' + toString_0(this.d59_1) + ', e=' + toString_0(this.e59_1) + ', f=' + toString_0(this.f59_1) + ')';
  };
  protoOf(Sextuple).hashCode = function () {
    var result = this.a59_1 == null ? 0 : hashCode(this.a59_1);
    result = imul(result, 31) + (this.b59_1 == null ? 0 : hashCode(this.b59_1)) | 0;
    result = imul(result, 31) + (this.c59_1 == null ? 0 : hashCode(this.c59_1)) | 0;
    result = imul(result, 31) + (this.d59_1 == null ? 0 : hashCode(this.d59_1)) | 0;
    result = imul(result, 31) + (this.e59_1 == null ? 0 : hashCode(this.e59_1)) | 0;
    result = imul(result, 31) + (this.f59_1 == null ? 0 : hashCode(this.f59_1)) | 0;
    return result;
  };
  protoOf(Sextuple).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Sextuple))
      return false;
    var tmp0_other_with_cast = other instanceof Sextuple ? other : THROW_CCE();
    if (!equals(this.a59_1, tmp0_other_with_cast.a59_1))
      return false;
    if (!equals(this.b59_1, tmp0_other_with_cast.b59_1))
      return false;
    if (!equals(this.c59_1, tmp0_other_with_cast.c59_1))
      return false;
    if (!equals(this.d59_1, tmp0_other_with_cast.d59_1))
      return false;
    if (!equals(this.e59_1, tmp0_other_with_cast.e59_1))
      return false;
    if (!equals(this.f59_1, tmp0_other_with_cast.f59_1))
      return false;
    return true;
  };
  function Quadruple(a, b, c, d) {
    this.j59_1 = a;
    this.k59_1 = b;
    this.l59_1 = c;
    this.m59_1 = d;
  }
  protoOf(Quadruple).ug = function () {
    return this.j59_1;
  };
  protoOf(Quadruple).vg = function () {
    return this.k59_1;
  };
  protoOf(Quadruple).hm = function () {
    return this.l59_1;
  };
  protoOf(Quadruple).g59 = function () {
    return this.m59_1;
  };
  protoOf(Quadruple).toString = function () {
    return 'Quadruple(a=' + toString_0(this.j59_1) + ', b=' + toString_0(this.k59_1) + ', c=' + toString_0(this.l59_1) + ', d=' + toString_0(this.m59_1) + ')';
  };
  protoOf(Quadruple).hashCode = function () {
    var result = this.j59_1 == null ? 0 : hashCode(this.j59_1);
    result = imul(result, 31) + (this.k59_1 == null ? 0 : hashCode(this.k59_1)) | 0;
    result = imul(result, 31) + (this.l59_1 == null ? 0 : hashCode(this.l59_1)) | 0;
    result = imul(result, 31) + (this.m59_1 == null ? 0 : hashCode(this.m59_1)) | 0;
    return result;
  };
  protoOf(Quadruple).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Quadruple))
      return false;
    var tmp0_other_with_cast = other instanceof Quadruple ? other : THROW_CCE();
    if (!equals(this.j59_1, tmp0_other_with_cast.j59_1))
      return false;
    if (!equals(this.k59_1, tmp0_other_with_cast.k59_1))
      return false;
    if (!equals(this.l59_1, tmp0_other_with_cast.l59_1))
      return false;
    if (!equals(this.m59_1, tmp0_other_with_cast.m59_1))
      return false;
    return true;
  };
  function SignedUIntArray(unsignedValue, sign) {
    this.n59_1 = unsignedValue;
    this.o59_1 = sign;
  }
  protoOf(SignedUIntArray).toString = function () {
    return 'SignedUIntArray(unsignedValue=' + UIntArray__toString_impl_3zy802(this.n59_1) + ', sign=' + this.o59_1 + ')';
  };
  protoOf(SignedUIntArray).hashCode = function () {
    var result = UIntArray__hashCode_impl_hr7ost(this.n59_1);
    result = imul(result, 31) + getBooleanHashCode(this.o59_1) | 0;
    return result;
  };
  protoOf(SignedUIntArray).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SignedUIntArray))
      return false;
    var tmp0_other_with_cast = other instanceof SignedUIntArray ? other : THROW_CCE();
    if (!equals(this.n59_1, tmp0_other_with_cast.n59_1))
      return false;
    if (!(this.o59_1 === tmp0_other_with_cast.o59_1))
      return false;
    return true;
  };
  function BigInteger32Arithmetic() {
    BigInteger32Arithmetic_instance = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.p59_1 = new Int32Array([]);
    this.q59_1 = _ULong___init__impl__c78o9k(new Long(-1, 0));
    this.r59_1 = _UInt___init__impl__l7qpdl(-1);
    this.s59_1 = _ULong___init__impl__c78o9k(new Long(0, 1));
    this.t59_1 = _ULong___init__impl__c78o9k(new Long(65535, 0));
    this.u59_1 = _UInt___init__impl__l7qpdl(-1);
    this.v59_1 = 32;
    this.w59_1 = 32;
    this.x59_1 = _UIntArray___init__impl__ghjpc6_0(0);
    var tmp_0 = this;
    // Inline function 'kotlin.UIntArray' call
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(1);
    while (tmp_1 < 1) {
      var tmp_3 = tmp_1;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base32.BigInteger32Arithmetic.ONE.<anonymous>' call
      // Inline function 'kotlin.UInt.toInt' call
      var this_0 = _UInt___init__impl__l7qpdl(1);
      tmp_2[tmp_3] = _UInt___get_data__impl__f0vqqw(this_0);
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.y59_1 = _UIntArray___init__impl__ghjpc6(tmp_2);
    var tmp_4 = this;
    // Inline function 'kotlin.UIntArray' call
    var tmp_5 = 0;
    var tmp_6 = new Int32Array(1);
    while (tmp_5 < 1) {
      var tmp_7 = tmp_5;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base32.BigInteger32Arithmetic.TWO.<anonymous>' call
      // Inline function 'kotlin.UInt.toInt' call
      var this_1 = _UInt___init__impl__l7qpdl(2);
      tmp_6[tmp_7] = _UInt___get_data__impl__f0vqqw(this_1);
      tmp_5 = tmp_5 + 1 | 0;
    }
    tmp_4.z59_1 = _UIntArray___init__impl__ghjpc6(tmp_6);
    var tmp_8 = this;
    // Inline function 'kotlin.UIntArray' call
    var tmp_9 = 0;
    var tmp_10 = new Int32Array(1);
    while (tmp_9 < 1) {
      var tmp_11 = tmp_9;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base32.BigInteger32Arithmetic.TEN.<anonymous>' call
      // Inline function 'kotlin.UInt.toInt' call
      var this_2 = _UInt___init__impl__l7qpdl(10);
      tmp_10[tmp_11] = _UInt___get_data__impl__f0vqqw(this_2);
      tmp_9 = tmp_9 + 1 | 0;
    }
    tmp_8.a5a_1 = _UIntArray___init__impl__ghjpc6(tmp_10);
    this.b5a_1 = 60;
    this.c5a_1 = 15000;
    this.d5a_1 = new SignedUIntArray(this.z59_1, true);
  }
  protoOf(BigInteger32Arithmetic).e5a = function (value) {
    var x = value;
    var y;
    var n = this.v59_1;
    // Inline function 'kotlin.UInt.shr' call
    var this_0 = x;
    y = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_0) >>> 16 | 0);
    if (!(y === _UInt___init__impl__l7qpdl(0))) {
      n = n - 16 | 0;
      x = y;
    }
    // Inline function 'kotlin.UInt.shr' call
    var this_1 = x;
    y = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_1) >>> 8 | 0);
    if (!(y === _UInt___init__impl__l7qpdl(0))) {
      n = n - 8 | 0;
      x = y;
    }
    // Inline function 'kotlin.UInt.shr' call
    var this_2 = x;
    y = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_2) >>> 4 | 0);
    if (!(y === _UInt___init__impl__l7qpdl(0))) {
      n = n - 4 | 0;
      x = y;
    }
    // Inline function 'kotlin.UInt.shr' call
    var this_3 = x;
    y = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_3) >>> 2 | 0);
    if (!(y === _UInt___init__impl__l7qpdl(0))) {
      n = n - 2 | 0;
      x = y;
    }
    // Inline function 'kotlin.UInt.shr' call
    var this_4 = x;
    y = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_4) >>> 1 | 0);
    if (!(y === _UInt___init__impl__l7qpdl(0))) {
      return n - 2 | 0;
    }
    var tmp = n;
    // Inline function 'kotlin.UInt.toInt' call
    var this_5 = x;
    return tmp - _UInt___get_data__impl__f0vqqw(this_5) | 0;
  };
  protoOf(BigInteger32Arithmetic).f5a = function (value) {
    if (UIntArray__isEmpty_impl_vd8j4n(value)) {
      return 0;
    }
    var mostSignificant = UIntArray__get_impl_gp5kza(value, _UIntArray___get_size__impl__r6l8ci(value) - 1 | 0);
    return this.g5a(mostSignificant) + imul(_UIntArray___get_size__impl__r6l8ci(value) - 1 | 0, this.v59_1) | 0;
  };
  protoOf(BigInteger32Arithmetic).g5a = function (value) {
    return this.v59_1 - this.e5a(value) | 0;
  };
  protoOf(BigInteger32Arithmetic).h5a = function (bigInteger) {
    // Inline function 'kotlin.collections.indexOfLast' call
    var tmp0 = _UIntArray___get_storage__impl__92a0v0(bigInteger);
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfLast' call
      var inductionVariable = tmp0.length - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          // Inline function 'kotlin.collections.indexOfLast.<anonymous>' call
          // Inline function 'kotlin.toUInt' call
          var this_0 = tmp0[index];
          // Inline function 'com.ionspin.kotlin.bignum.integer.base32.BigInteger32Arithmetic.removeLeadingZeros.<anonymous>' call
          if (!(_UInt___init__impl__l7qpdl(this_0) === _UInt___init__impl__l7qpdl(0))) {
            tmp$ret$3 = index;
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$3 = -1;
    }
    var firstEmpty = tmp$ret$3 + 1 | 0;
    if (firstEmpty === -1 || firstEmpty === 0) {
      return this.x59_1;
    }
    // Inline function 'kotlin.collections.copyOfRange' call
    return _UIntArray___init__impl__ghjpc6(copyOfRange_0(_UIntArray___get_storage__impl__92a0v0(bigInteger), 0, firstEmpty));
  };
  protoOf(BigInteger32Arithmetic).i5a = function (bigInteger) {
    var lastNonEmptyIndex = _UIntArray___get_size__impl__r6l8ci(bigInteger) - 1 | 0;
    if (lastNonEmptyIndex <= 0) {
      return 0;
    }
    var element = UIntArray__get_impl_gp5kza(bigInteger, lastNonEmptyIndex);
    while (element === _UInt___init__impl__l7qpdl(0) && lastNonEmptyIndex > 0) {
      lastNonEmptyIndex = lastNonEmptyIndex - 1 | 0;
      element = UIntArray__get_impl_gp5kza(bigInteger, lastNonEmptyIndex);
    }
    if (UIntArray__get_impl_gp5kza(bigInteger, lastNonEmptyIndex) === _UInt___init__impl__l7qpdl(0)) {
      lastNonEmptyIndex = lastNonEmptyIndex - 1 | 0;
    }
    return (_UIntArray___get_size__impl__r6l8ci(bigInteger) - lastNonEmptyIndex | 0) - 1 | 0;
  };
  protoOf(BigInteger32Arithmetic).j5a = function (operand, places) {
    if (UIntArray__isEmpty_impl_vd8j4n(operand) || places === 0) {
      return operand;
    }
    var originalSize = _UIntArray___get_size__impl__r6l8ci(operand);
    var leadingZeros = this.e5a(UIntArray__get_impl_gp5kza(operand, _UIntArray___get_size__impl__r6l8ci(operand) - 1 | 0));
    var shiftWords = places / this.v59_1 | 0;
    var shiftBits = places % this.v59_1 | 0;
    var tmp;
    if (shiftBits > leadingZeros) {
      tmp = shiftWords + 1 | 0;
    } else {
      tmp = shiftWords;
    }
    var wordsNeeded = tmp;
    if (shiftBits === 0) {
      // Inline function 'kotlin.UIntArray' call
      var tmp_0 = 0;
      var tmp_1 = _UIntArray___get_size__impl__r6l8ci(operand) + wordsNeeded | 0;
      var tmp_2 = new Int32Array(tmp_1);
      while (tmp_0 < tmp_1) {
        var tmp_3 = tmp_0;
        // Inline function 'com.ionspin.kotlin.bignum.integer.base32.BigInteger32Arithmetic.shiftLeft.<anonymous>' call
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = (0 <= tmp_3 ? tmp_3 < shiftWords : false) ? _UInt___init__impl__l7qpdl(0) : UIntArray__get_impl_gp5kza(operand, tmp_3 - shiftWords | 0);
        tmp_2[tmp_3] = _UInt___get_data__impl__f0vqqw(this_0);
        tmp_0 = tmp_0 + 1 | 0;
      }
      return _UIntArray___init__impl__ghjpc6(tmp_2);
    }
    // Inline function 'kotlin.UIntArray' call
    var tmp_4 = 0;
    var tmp_5 = _UIntArray___get_size__impl__r6l8ci(operand) + wordsNeeded | 0;
    var tmp_6 = new Int32Array(tmp_5);
    while (tmp_4 < tmp_5) {
      var tmp_7 = tmp_4;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base32.BigInteger32Arithmetic.shiftLeft.<anonymous>' call
      var tmp_8;
      if (0 <= tmp_7 ? tmp_7 < shiftWords : false) {
        tmp_8 = _UInt___init__impl__l7qpdl(0);
      } else {
        if (tmp_7 === shiftWords) {
          // Inline function 'kotlin.UInt.shl' call
          var this_1 = UIntArray__get_impl_gp5kza(operand, tmp_7 - shiftWords | 0);
          tmp_8 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_1) << shiftBits);
        } else {
          var containsLower = shiftWords + 1 | 0;
          if (tmp_7 < (originalSize + shiftWords | 0) ? containsLower <= tmp_7 : false) {
            // Inline function 'kotlin.UInt.shl' call
            var this_2 = UIntArray__get_impl_gp5kza(operand, tmp_7 - shiftWords | 0);
            var tmp6 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_2) << shiftBits);
            var tmp4 = UIntArray__get_impl_gp5kza(operand, (tmp_7 - shiftWords | 0) - 1 | 0);
            // Inline function 'kotlin.UInt.shr' call
            var bitCount = BigInteger32Arithmetic_getInstance().v59_1 - shiftBits | 0;
            // Inline function 'kotlin.UInt.or' call
            var other = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp4) >>> bitCount | 0);
            tmp_8 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp6) | _UInt___get_data__impl__f0vqqw(other));
          } else {
            if (tmp_7 === ((originalSize + wordsNeeded | 0) - 1 | 0)) {
              var tmp8 = UIntArray__get_impl_gp5kza(operand, tmp_7 - wordsNeeded | 0);
              // Inline function 'kotlin.UInt.shr' call
              var bitCount_0 = BigInteger32Arithmetic_getInstance().v59_1 - shiftBits | 0;
              tmp_8 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp8) >>> bitCount_0 | 0);
            } else {
              throw RuntimeException_init_$Create$_0('Invalid case ' + tmp_7);
            }
          }
        }
      }
      // Inline function 'kotlin.UInt.toInt' call
      var this_3 = tmp_8;
      tmp_6[tmp_7] = _UInt___get_data__impl__f0vqqw(this_3);
      tmp_4 = tmp_4 + 1 | 0;
    }
    return _UIntArray___init__impl__ghjpc6(tmp_6);
  };
  protoOf(BigInteger32Arithmetic).k5a = function (operand, places) {
    if (UIntArray__isEmpty_impl_vd8j4n(operand) || places === 0) {
      return operand;
    }
    var shiftBits = places % this.v59_1 | 0;
    var wordsToDiscard = places / this.v59_1 | 0;
    if (wordsToDiscard >= _UIntArray___get_size__impl__r6l8ci(operand)) {
      return this.x59_1;
    }
    if (shiftBits === 0) {
      // Inline function 'kotlin.collections.copyOfRange' call
      var toIndex = _UIntArray___get_size__impl__r6l8ci(operand);
      return _UIntArray___init__impl__ghjpc6(copyOfRange_0(_UIntArray___get_storage__impl__92a0v0(operand), wordsToDiscard, toIndex));
    }
    if (_UIntArray___get_size__impl__r6l8ci(operand) > 1 && (_UIntArray___get_size__impl__r6l8ci(operand) - wordsToDiscard | 0) === 1) {
      // Inline function 'kotlin.UInt.shr' call
      var this_0 = UIntArray__get_impl_gp5kza(operand, _UIntArray___get_size__impl__r6l8ci(operand) - 1 | 0);
      var tmp$ret$1 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_0) >>> shiftBits | 0);
      // Inline function 'kotlin.uintArrayOf' call
      return _UIntArray___init__impl__ghjpc6(new Int32Array([tmp$ret$1]));
    }
    // Inline function 'kotlin.UIntArray' call
    var tmp = 0;
    var tmp_0 = _UIntArray___get_size__impl__r6l8ci(operand) - wordsToDiscard | 0;
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base32.BigInteger32Arithmetic.shiftRight.<anonymous>' call
      var tmp_3;
      if (0 <= tmp_2 ? tmp_2 < ((_UIntArray___get_size__impl__r6l8ci(operand) - 1 | 0) - wordsToDiscard | 0) : false) {
        // Inline function 'kotlin.UInt.shr' call
        var this_1 = UIntArray__get_impl_gp5kza(operand, tmp_2 + wordsToDiscard | 0);
        var tmp4 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_1) >>> shiftBits | 0);
        var tmp2 = UIntArray__get_impl_gp5kza(operand, (tmp_2 + wordsToDiscard | 0) + 1 | 0);
        // Inline function 'kotlin.UInt.shl' call
        var bitCount = BigInteger32Arithmetic_getInstance().v59_1 - shiftBits | 0;
        // Inline function 'kotlin.UInt.or' call
        var other = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp2) << bitCount);
        tmp_3 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp4) | _UInt___get_data__impl__f0vqqw(other));
      } else if (tmp_2 === ((_UIntArray___get_size__impl__r6l8ci(operand) - 1 | 0) - wordsToDiscard | 0)) {
        // Inline function 'kotlin.UInt.shr' call
        var this_2 = UIntArray__get_impl_gp5kza(operand, tmp_2 + wordsToDiscard | 0);
        tmp_3 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_2) >>> shiftBits | 0);
      } else {
        throw RuntimeException_init_$Create$_0('Invalid case ' + tmp_2);
      }
      // Inline function 'kotlin.UInt.toInt' call
      var this_3 = tmp_3;
      tmp_1[tmp_2] = _UInt___get_data__impl__f0vqqw(this_3);
      tmp = tmp + 1 | 0;
    }
    var result = _UIntArray___init__impl__ghjpc6(tmp_1);
    return this.h5a(result);
  };
  protoOf(BigInteger32Arithmetic).l5a = function (dividend, divisor) {
    var divisorSize = _UIntArray___get_size__impl__r6l8ci(divisor);
    var normalizationShift = this.e5a(UIntArray__get_impl_gp5kza(divisor, divisorSize - 1 | 0));
    var divisorNormalized = this.m5a(divisor, normalizationShift);
    var dividendNormalized = this.m5a(dividend, normalizationShift);
    return new Triple(new UIntArray(dividendNormalized), new UIntArray(divisorNormalized), normalizationShift);
  };
  protoOf(BigInteger32Arithmetic).n5a = function (remainderNormalized, normalizationShift) {
    var remainder = this.o5a(remainderNormalized, normalizationShift);
    return remainder;
  };
  protoOf(BigInteger32Arithmetic).p5a = function (first, second) {
    var firstStart = _UIntArray___get_size__impl__r6l8ci(first) - this.i5a(first) | 0;
    var secondStart = _UIntArray___get_size__impl__r6l8ci(second) - this.i5a(second) | 0;
    if (firstStart > secondStart) {
      return 1;
    }
    if (secondStart > firstStart) {
      return -1;
    }
    var counter = firstStart - 1 | 0;
    var firstIsLarger = false;
    var bothAreEqual = true;
    $l$loop_0: while (counter >= 0) {
      var tmp0 = UIntArray__get_impl_gp5kza(first, counter);
      // Inline function 'kotlin.UInt.compareTo' call
      var other = UIntArray__get_impl_gp5kza(second, counter);
      if (uintCompare(_UInt___get_data__impl__f0vqqw(tmp0), _UInt___get_data__impl__f0vqqw(other)) > 0) {
        firstIsLarger = true;
        bothAreEqual = false;
        break $l$loop_0;
      }
      var tmp2 = UIntArray__get_impl_gp5kza(first, counter);
      // Inline function 'kotlin.UInt.compareTo' call
      var other_0 = UIntArray__get_impl_gp5kza(second, counter);
      if (uintCompare(_UInt___get_data__impl__f0vqqw(tmp2), _UInt___get_data__impl__f0vqqw(other_0)) < 0) {
        firstIsLarger = false;
        bothAreEqual = false;
        break $l$loop_0;
      }
      counter = counter - 1 | 0;
    }
    if (bothAreEqual) {
      return 0;
    }
    if (firstIsLarger) {
      return 1;
    } else {
      return -1;
    }
  };
  protoOf(BigInteger32Arithmetic).q5a = function (first, second) {
    if (_UIntArray___get_size__impl__r6l8ci(first) === 1 && UIntArray__get_impl_gp5kza(first, 0) === _UInt___init__impl__l7qpdl(0))
      return second;
    if (_UIntArray___get_size__impl__r6l8ci(second) === 1 && UIntArray__get_impl_gp5kza(second, 0) === _UInt___init__impl__l7qpdl(0))
      return first;
    var tmp;
    if (_UIntArray___get_size__impl__r6l8ci(first) > _UIntArray___get_size__impl__r6l8ci(second)) {
      tmp = new Quadruple(_UIntArray___get_size__impl__r6l8ci(first), _UIntArray___get_size__impl__r6l8ci(second), new UIntArray(first), new UIntArray(second));
    } else {
      tmp = new Quadruple(_UIntArray___get_size__impl__r6l8ci(second), _UIntArray___get_size__impl__r6l8ci(first), new UIntArray(second), new UIntArray(first));
    }
    var _destruct__k2r9zo = tmp;
    var maxLength = _destruct__k2r9zo.ug();
    var minLength = _destruct__k2r9zo.vg();
    var largerData = _destruct__k2r9zo.hm().dn_1;
    var smallerData = _destruct__k2r9zo.g59().dn_1;
    // Inline function 'kotlin.UIntArray' call
    var tmp_0 = 0;
    var tmp_1 = maxLength + 1 | 0;
    var tmp_2 = new Int32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base32.BigInteger32Arithmetic.add.<anonymous>' call
      // Inline function 'kotlin.UInt.toInt' call
      var this_0 = _UInt___init__impl__l7qpdl(0);
      tmp_2[tmp_3] = _UInt___get_data__impl__f0vqqw(this_0);
      tmp_0 = tmp_0 + 1 | 0;
    }
    var result = _UIntArray___init__impl__ghjpc6(tmp_2);
    var i = 0;
    var sum = _ULong___init__impl__c78o9k(new Long(0, 0));
    while (i < minLength) {
      var tmp2 = sum;
      // Inline function 'kotlin.ULong.plus' call
      // Inline function 'kotlin.UInt.toULong' call
      var this_1 = UIntArray__get_impl_gp5kza(largerData, i);
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value = _UInt___get_data__impl__f0vqqw(this_1);
      var tmp$ret$4 = toLong(value).u3(new Long(-1, 0));
      // Inline function 'kotlin.ULong.plus' call
      var other = _ULong___init__impl__c78o9k(tmp$ret$4);
      var tmp4 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp2).i3(_ULong___get_data__impl__fggpzb(other)));
      // Inline function 'kotlin.ULong.plus' call
      // Inline function 'kotlin.UInt.toULong' call
      var this_2 = UIntArray__get_impl_gp5kza(smallerData, i);
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value_0 = _UInt___get_data__impl__f0vqqw(this_2);
      var tmp$ret$9 = toLong(value_0).u3(new Long(-1, 0));
      // Inline function 'kotlin.ULong.plus' call
      var other_0 = _ULong___init__impl__c78o9k(tmp$ret$9);
      sum = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp4).i3(_ULong___get_data__impl__fggpzb(other_0)));
      var tmp_4 = i;
      var tmp6 = sum;
      // Inline function 'kotlin.ULong.and' call
      var other_1 = this.q59_1;
      // Inline function 'kotlin.ULong.toUInt' call
      var this_3 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp6).u3(_ULong___get_data__impl__fggpzb(other_1)));
      // Inline function 'kotlin.toUInt' call
      var this_4 = _ULong___get_data__impl__fggpzb(this_3);
      var tmp$ret$16 = _UInt___init__impl__l7qpdl(this_4.z3());
      UIntArray__set_impl_7f2zu2(result, tmp_4, tmp$ret$16);
      var tmp9 = sum;
      // Inline function 'kotlin.ULong.shr' call
      var bitCount = this.v59_1;
      sum = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp9).t3(bitCount));
      i = i + 1 | 0;
    }
    while (true) {
      if (equals(sum, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
        while (i < maxLength) {
          UIntArray__set_impl_7f2zu2(result, i, UIntArray__get_impl_gp5kza(largerData, i));
          i = i + 1 | 0;
        }
        var tmp_5;
        if (UIntArray__get_impl_gp5kza(result, _UIntArray___get_size__impl__r6l8ci(result) - 1 | 0) === _UInt___init__impl__l7qpdl(0)) {
          // Inline function 'kotlin.collections.copyOfRange' call
          var toIndex = _UIntArray___get_size__impl__r6l8ci(result) - 1 | 0;
          tmp_5 = _UIntArray___init__impl__ghjpc6(copyOfRange_0(_UIntArray___get_storage__impl__92a0v0(result), 0, toIndex));
        } else {
          tmp_5 = result;
        }
        return tmp_5;
      }
      if (i === maxLength) {
        // Inline function 'kotlin.ULong.toUInt' call
        var this_5 = sum;
        // Inline function 'kotlin.toUInt' call
        var this_6 = _ULong___get_data__impl__fggpzb(this_5);
        var tmp$ret$20 = _UInt___init__impl__l7qpdl(this_6.z3());
        UIntArray__set_impl_7f2zu2(result, maxLength, tmp$ret$20);
        return result;
      }
      var tmp15 = sum;
      // Inline function 'kotlin.ULong.plus' call
      // Inline function 'kotlin.UInt.toULong' call
      var this_7 = UIntArray__get_impl_gp5kza(largerData, i);
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value_1 = _UInt___get_data__impl__f0vqqw(this_7);
      var tmp$ret$21 = toLong(value_1).u3(new Long(-1, 0));
      // Inline function 'kotlin.ULong.plus' call
      var other_2 = _ULong___init__impl__c78o9k(tmp$ret$21);
      sum = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp15).i3(_ULong___get_data__impl__fggpzb(other_2)));
      var tmp_6 = i;
      var tmp17 = sum;
      // Inline function 'kotlin.ULong.and' call
      var other_3 = this.q59_1;
      // Inline function 'kotlin.ULong.toUInt' call
      var this_8 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp17).u3(_ULong___get_data__impl__fggpzb(other_3)));
      // Inline function 'kotlin.toUInt' call
      var this_9 = _ULong___get_data__impl__fggpzb(this_8);
      var tmp$ret$28 = _UInt___init__impl__l7qpdl(this_9.z3());
      UIntArray__set_impl_7f2zu2(result, tmp_6, tmp$ret$28);
      var tmp20 = sum;
      // Inline function 'kotlin.ULong.shr' call
      var bitCount_0 = this.v59_1;
      sum = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp20).t3(bitCount_0));
      i = i + 1 | 0;
    }
  };
  protoOf(BigInteger32Arithmetic).r5a = function (first, second) {
    var firstWithoutLeadingZeroes = this.h5a(first);
    var secondWithoutLeadingZeroes = this.h5a(second);
    var firstIsLarger = this.p5a(firstWithoutLeadingZeroes, secondWithoutLeadingZeroes) === 1;
    var tmp;
    if (firstIsLarger) {
      tmp = new Quadruple(_UIntArray___get_size__impl__r6l8ci(firstWithoutLeadingZeroes), _UIntArray___get_size__impl__r6l8ci(secondWithoutLeadingZeroes), new UIntArray(firstWithoutLeadingZeroes), new UIntArray(secondWithoutLeadingZeroes));
    } else {
      tmp = new Quadruple(_UIntArray___get_size__impl__r6l8ci(secondWithoutLeadingZeroes), _UIntArray___get_size__impl__r6l8ci(firstWithoutLeadingZeroes), new UIntArray(secondWithoutLeadingZeroes), new UIntArray(firstWithoutLeadingZeroes));
    }
    var _destruct__k2r9zo = tmp;
    var largerLength = _destruct__k2r9zo.ug();
    var smallerLength = _destruct__k2r9zo.vg();
    var largerData = _destruct__k2r9zo.hm().dn_1;
    var smallerData = _destruct__k2r9zo.g59().dn_1;
    // Inline function 'kotlin.UIntArray' call
    var tmp_0 = 0;
    var tmp_1 = largerLength + 1 | 0;
    var tmp_2 = new Int32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base32.BigInteger32Arithmetic.subtract.<anonymous>' call
      // Inline function 'kotlin.UInt.toInt' call
      var this_0 = _UInt___init__impl__l7qpdl(0);
      tmp_2[tmp_3] = _UInt___get_data__impl__f0vqqw(this_0);
      tmp_0 = tmp_0 + 1 | 0;
    }
    var result = _UIntArray___init__impl__ghjpc6(tmp_2);
    var i = 0;
    var diff = _ULong___init__impl__c78o9k(new Long(0, 0));
    while (i < smallerLength) {
      if (i >= _UIntArray___get_size__impl__r6l8ci(largerData)) {
        println('Breakpoint');
      }
      if (i >= _UIntArray___get_size__impl__r6l8ci(smallerData)) {
        println('Breakpoint');
      }
      // Inline function 'kotlin.UInt.toULong' call
      var this_1 = UIntArray__get_impl_gp5kza(largerData, i);
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value = _UInt___get_data__impl__f0vqqw(this_1);
      var tmp$ret$4 = toLong(value).u3(new Long(-1, 0));
      var tmp3 = _ULong___init__impl__c78o9k(tmp$ret$4);
      // Inline function 'kotlin.ULong.minus' call
      // Inline function 'kotlin.UInt.toULong' call
      var this_2 = UIntArray__get_impl_gp5kza(smallerData, i);
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value_0 = _UInt___get_data__impl__f0vqqw(this_2);
      var tmp$ret$7 = toLong(value_0).u3(new Long(-1, 0));
      // Inline function 'kotlin.ULong.minus' call
      var other = _ULong___init__impl__c78o9k(tmp$ret$7);
      var tmp5 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp3).j3(_ULong___get_data__impl__fggpzb(other)));
      // Inline function 'kotlin.ULong.minus' call
      var other_0 = diff;
      diff = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp5).j3(_ULong___get_data__impl__fggpzb(other_0)));
      var tmp_4 = i;
      // Inline function 'kotlin.ULong.toUInt' call
      var this_3 = diff;
      // Inline function 'kotlin.toUInt' call
      var this_4 = _ULong___get_data__impl__fggpzb(this_3);
      var tmp$ret$14 = _UInt___init__impl__l7qpdl(this_4.z3());
      UIntArray__set_impl_7f2zu2(result, tmp_4, tmp$ret$14);
      var tmp8 = diff;
      // Inline function 'kotlin.ULong.and' call
      var other_1 = this.s59_1;
      var tmp10 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp8).u3(_ULong___get_data__impl__fggpzb(other_1)));
      // Inline function 'kotlin.ULong.shr' call
      var bitCount = this.w59_1;
      diff = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp10).t3(bitCount));
      i = i + 1 | 0;
    }
    while (!equals(diff, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      var tmp12 = UIntArray__get_impl_gp5kza(largerData, i);
      // Inline function 'kotlin.UInt.minus' call
      var other_2 = diff;
      // Inline function 'kotlin.UInt.toULong' call
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value_1 = _UInt___get_data__impl__f0vqqw(tmp12);
      var tmp$ret$17 = toLong(value_1).u3(new Long(-1, 0));
      // Inline function 'kotlin.ULong.minus' call
      var this_5 = _ULong___init__impl__c78o9k(tmp$ret$17);
      diff = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_5).j3(_ULong___get_data__impl__fggpzb(other_2)));
      var tmp_5 = i;
      // Inline function 'kotlin.ULong.toUInt' call
      var this_6 = diff;
      // Inline function 'kotlin.toUInt' call
      var this_7 = _ULong___get_data__impl__fggpzb(this_6);
      var tmp15 = _UInt___init__impl__l7qpdl(this_7.z3());
      // Inline function 'kotlin.UInt.and' call
      var other_3 = this.r59_1;
      var tmp$ret$24 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp15) & _UInt___get_data__impl__f0vqqw(other_3));
      UIntArray__set_impl_7f2zu2(result, tmp_5, tmp$ret$24);
      var tmp17 = diff;
      // Inline function 'kotlin.ULong.and' call
      var other_4 = this.s59_1;
      var tmp19 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp17).u3(_ULong___get_data__impl__fggpzb(other_4)));
      // Inline function 'kotlin.ULong.shr' call
      var bitCount_0 = this.w59_1;
      diff = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp19).t3(bitCount_0));
      i = i + 1 | 0;
    }
    while (i < largerLength) {
      UIntArray__set_impl_7f2zu2(result, i, UIntArray__get_impl_gp5kza(largerData, i));
      i = i + 1 | 0;
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = UIntArray__iterator_impl_tkdv7k(result);
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m().ym_1;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base32.BigInteger32Arithmetic.subtract.<anonymous>' call
      if (element === _UInt___init__impl__l7qpdl(0)) {
        destination.e(new UInt(element));
      }
    }
    if (destination.p()) {
      return this.x59_1;
    }
    // Inline function 'kotlin.collections.indexOfLast' call
    var tmp0 = _UIntArray___get_storage__impl__92a0v0(result);
    var tmp$ret$33;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfLast' call
      var inductionVariable = tmp0.length - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          // Inline function 'kotlin.collections.indexOfLast.<anonymous>' call
          // Inline function 'kotlin.toUInt' call
          var this_8 = tmp0[index];
          // Inline function 'com.ionspin.kotlin.bignum.integer.base32.BigInteger32Arithmetic.subtract.<anonymous>' call
          if (!(_UInt___init__impl__l7qpdl(this_8) === _UInt___init__impl__l7qpdl(0))) {
            tmp$ret$33 = index;
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$33 = -1;
    }
    var firstEmpty = tmp$ret$33 + 1 | 0;
    // Inline function 'kotlin.collections.copyOfRange' call
    return _UIntArray___init__impl__ghjpc6(copyOfRange_0(_UIntArray___get_storage__impl__92a0v0(result), 0, firstEmpty));
  };
  protoOf(BigInteger32Arithmetic).s5a = function (first, second) {
    var result = _UIntArray___init__impl__ghjpc6_0(_UIntArray___get_size__impl__r6l8ci(first) + 1 | 0);
    var product;
    var sum;
    var inductionVariable = 0;
    var last = _UIntArray___get_size__impl__r6l8ci(first);
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.UInt.toULong' call
        var this_0 = UIntArray__get_impl_gp5kza(first, i);
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value = _UInt___get_data__impl__f0vqqw(this_0);
        var tmp$ret$0 = toLong(value).u3(new Long(-1, 0));
        // Inline function 'kotlin.ULong.times' call
        var tmp1 = _ULong___init__impl__c78o9k(tmp$ret$0);
        // Inline function 'kotlin.UInt.toULong' call
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value_0 = _UInt___get_data__impl__f0vqqw(second);
        var tmp$ret$3 = toLong(value_0).u3(new Long(-1, 0));
        // Inline function 'kotlin.ULong.times' call
        var other = _ULong___init__impl__c78o9k(tmp$ret$3);
        product = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp1).k3(_ULong___get_data__impl__fggpzb(other)));
        // Inline function 'kotlin.UInt.toULong' call
        var this_1 = UIntArray__get_impl_gp5kza(result, i);
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value_1 = _UInt___get_data__impl__f0vqqw(this_1);
        var tmp$ret$8 = toLong(value_1).u3(new Long(-1, 0));
        var tmp7 = _ULong___init__impl__c78o9k(tmp$ret$8);
        // Inline function 'kotlin.ULong.and' call
        var other_0 = this.q59_1;
        // Inline function 'kotlin.ULong.toUInt' call
        var this_2 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(product).u3(_ULong___get_data__impl__fggpzb(other_0)));
        // Inline function 'kotlin.toUInt' call
        var this_3 = _ULong___get_data__impl__fggpzb(this_2);
        // Inline function 'kotlin.ULong.plus' call
        // Inline function 'kotlin.UInt.toULong' call
        var this_4 = _UInt___init__impl__l7qpdl(this_3.z3());
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value_2 = _UInt___get_data__impl__f0vqqw(this_4);
        var tmp$ret$14 = toLong(value_2).u3(new Long(-1, 0));
        // Inline function 'kotlin.ULong.plus' call
        var other_1 = _ULong___init__impl__c78o9k(tmp$ret$14);
        sum = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp7).i3(_ULong___get_data__impl__fggpzb(other_1)));
        var tmp9 = sum;
        // Inline function 'kotlin.ULong.and' call
        var other_2 = this.q59_1;
        // Inline function 'kotlin.ULong.toUInt' call
        var this_5 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp9).u3(_ULong___get_data__impl__fggpzb(other_2)));
        // Inline function 'kotlin.toUInt' call
        var this_6 = _ULong___get_data__impl__fggpzb(this_5);
        var tmp$ret$21 = _UInt___init__impl__l7qpdl(this_6.z3());
        UIntArray__set_impl_7f2zu2(result, i, tmp$ret$21);
        var tmp12 = sum;
        // Inline function 'kotlin.ULong.shr' call
        var bitCount = this.v59_1;
        sum = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp12).t3(bitCount));
        var tmp = i + 1 | 0;
        // Inline function 'kotlin.ULong.shr' call
        var bitCount_0 = this.v59_1;
        // Inline function 'kotlin.ULong.toUInt' call
        var this_7 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(product).t3(bitCount_0));
        // Inline function 'kotlin.toUInt' call
        var this_8 = _ULong___get_data__impl__fggpzb(this_7);
        var tmp18 = _UInt___init__impl__l7qpdl(this_8.z3());
        // Inline function 'kotlin.ULong.toUInt' call
        var this_9 = sum;
        // Inline function 'kotlin.toUInt' call
        var this_10 = _ULong___get_data__impl__fggpzb(this_9);
        // Inline function 'kotlin.UInt.plus' call
        var other_3 = _UInt___init__impl__l7qpdl(this_10.z3());
        var tmp$ret$28 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp18) + _UInt___get_data__impl__f0vqqw(other_3) | 0);
        UIntArray__set_impl_7f2zu2(result, tmp, tmp$ret$28);
      }
       while (inductionVariable < last);
    return this.h5a(result);
  };
  protoOf(BigInteger32Arithmetic).t5a = function (first, second) {
    return this.u5a(first, second);
  };
  protoOf(BigInteger32Arithmetic).u5a = function (unnormalizedDividend, unnormalizedDivisor) {
    if (this.v5a(unnormalizedDivisor, unnormalizedDividend) > 0) {
      return new Pair(new UIntArray(this.x59_1), new UIntArray(unnormalizedDividend));
    }
    if (_UIntArray___get_size__impl__r6l8ci(unnormalizedDivisor) === 1 && _UIntArray___get_size__impl__r6l8ci(unnormalizedDividend) === 1) {
      var tmp0 = UIntArray__get_impl_gp5kza(unnormalizedDividend, 0);
      // Inline function 'kotlin.UInt.div' call
      var other = UIntArray__get_impl_gp5kza(unnormalizedDivisor, 0);
      var tmp$ret$0 = uintDivide(tmp0, other);
      // Inline function 'kotlin.uintArrayOf' call
      var tmp$ret$1 = _UIntArray___init__impl__ghjpc6(new Int32Array([tmp$ret$0]));
      var tmp = this.h5a(tmp$ret$1);
      var tmp3 = UIntArray__get_impl_gp5kza(unnormalizedDividend, 0);
      // Inline function 'kotlin.UInt.rem' call
      var other_0 = UIntArray__get_impl_gp5kza(unnormalizedDivisor, 0);
      var tmp$ret$2 = uintRemainder(tmp3, other_0);
      // Inline function 'kotlin.uintArrayOf' call
      var tmp$ret$3 = _UIntArray___init__impl__ghjpc6(new Int32Array([tmp$ret$2]));
      return new Pair(new UIntArray(tmp), new UIntArray(this.h5a(tmp$ret$3)));
    }
    var bitPrecision = this.f5a(unnormalizedDividend) - this.f5a(unnormalizedDivisor) | 0;
    if (bitPrecision === 0) {
      // Inline function 'kotlin.uintArrayOf' call
      var tmp$ret$4 = _UIntArray___init__impl__ghjpc6(new Int32Array([_UInt___init__impl__l7qpdl(1)]));
      return new Pair(new UIntArray(tmp$ret$4), new UIntArray(this.w5a(unnormalizedDividend, unnormalizedDivisor)));
    }
    var _destruct__k2r9zo = this.l5a(unnormalizedDividend, unnormalizedDivisor);
    var dividend = _destruct__k2r9zo.ug().dn_1;
    var divisor = _destruct__k2r9zo.vg().dn_1;
    var normalizationShift = _destruct__k2r9zo.hm();
    var dividendSize = _UIntArray___get_size__impl__r6l8ci(dividend);
    var divisorSize = _UIntArray___get_size__impl__r6l8ci(divisor);
    var wordPrecision = dividendSize - divisorSize | 0;
    var qjhat;
    var reconstructedQuotient;
    var quotient = _UIntArray___init__impl__ghjpc6_0(wordPrecision);
    var divisorTimesBaseToPowerOfM = this.m5a(divisor, imul(wordPrecision, this.v59_1));
    if (this.v5a(dividend, divisorTimesBaseToPowerOfM) >= 0) {
      quotient = _UIntArray___init__impl__ghjpc6_0(wordPrecision + 1 | 0);
      UIntArray__set_impl_7f2zu2(quotient, wordPrecision, _UInt___init__impl__l7qpdl(1));
      dividend = this.w5a(dividend, divisorTimesBaseToPowerOfM);
    }
    var inductionVariable = wordPrecision - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp_0;
        if ((divisorSize + j | 0) < _UIntArray___get_size__impl__r6l8ci(dividend)) {
          // Inline function 'kotlin.UInt.toULong' call
          var this_0 = UIntArray__get_impl_gp5kza(dividend, divisorSize + j | 0);
          // Inline function 'kotlin.uintToULong' call
          // Inline function 'kotlin.uintToLong' call
          var value = _UInt___get_data__impl__f0vqqw(this_0);
          var tmp$ret$5 = toLong(value).u3(new Long(-1, 0));
          var tmp8 = _ULong___init__impl__c78o9k(tmp$ret$5);
          // Inline function 'kotlin.ULong.shl' call
          var bitCount = this.v59_1;
          var tmp10 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp8).r3(bitCount));
          // Inline function 'kotlin.ULong.plus' call
          // Inline function 'kotlin.UInt.toULong' call
          var this_1 = UIntArray__get_impl_gp5kza(dividend, (divisorSize + j | 0) - 1 | 0);
          // Inline function 'kotlin.uintToULong' call
          // Inline function 'kotlin.uintToLong' call
          var value_0 = _UInt___get_data__impl__f0vqqw(this_1);
          var tmp$ret$9 = toLong(value_0).u3(new Long(-1, 0));
          // Inline function 'kotlin.ULong.plus' call
          var other_1 = _ULong___init__impl__c78o9k(tmp$ret$9);
          var tmp12 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp10).i3(_ULong___get_data__impl__fggpzb(other_1)));
          // Inline function 'kotlin.ULong.div' call
          // Inline function 'kotlin.UInt.toULong' call
          var this_2 = UIntArray__get_impl_gp5kza(divisor, divisorSize - 1 | 0);
          // Inline function 'kotlin.uintToULong' call
          // Inline function 'kotlin.uintToLong' call
          var value_1 = _UInt___get_data__impl__f0vqqw(this_2);
          var tmp$ret$14 = toLong(value_1).u3(new Long(-1, 0));
          // Inline function 'kotlin.ULong.div' call
          var other_2 = _ULong___init__impl__c78o9k(tmp$ret$14);
          tmp_0 = ulongDivide(tmp12, other_2);
        } else {
          var tmp_1;
          if ((divisorSize + j | 0) === _UIntArray___get_size__impl__r6l8ci(dividend)) {
            var tmp14 = UIntArray__get_impl_gp5kza(dividend, (divisorSize + j | 0) - 1 | 0);
            // Inline function 'kotlin.UInt.div' call
            var other_3 = UIntArray__get_impl_gp5kza(divisor, divisorSize - 1 | 0);
            // Inline function 'kotlin.UInt.toULong' call
            var this_3 = uintDivide(tmp14, other_3);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_2 = _UInt___get_data__impl__f0vqqw(this_3);
            var tmp$ret$20 = toLong(value_2).u3(new Long(-1, 0));
            tmp_1 = _ULong___init__impl__c78o9k(tmp$ret$20);
          } else {
            tmp_1 = _ULong___init__impl__c78o9k(new Long(0, 0));
          }
          tmp_0 = tmp_1;
        }
        qjhat = tmp_0;
        var tmp_2 = quotient;
        var tmp_3;
        var tmp17 = this.u59_1;
        // Inline function 'kotlin.UInt.minus' call
        var other_4 = _ULong___init__impl__c78o9k(new Long(1, 0));
        // Inline function 'kotlin.UInt.toULong' call
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value_3 = _UInt___get_data__impl__f0vqqw(tmp17);
        var tmp$ret$23 = toLong(value_3).u3(new Long(-1, 0));
        // Inline function 'kotlin.ULong.minus' call
        var this_4 = _ULong___init__impl__c78o9k(tmp$ret$23);
        // Inline function 'kotlin.ULong.compareTo' call
        var other_5 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_4).j3(_ULong___get_data__impl__fggpzb(other_4)));
        if (ulongCompare(_ULong___get_data__impl__fggpzb(qjhat), _ULong___get_data__impl__fggpzb(other_5)) < 0) {
          // Inline function 'kotlin.ULong.toUInt' call
          // Inline function 'kotlin.toUInt' call
          var this_5 = _ULong___get_data__impl__fggpzb(qjhat);
          tmp_3 = _UInt___init__impl__l7qpdl(this_5.z3());
        } else {
          var tmp22 = this.u59_1;
          // Inline function 'kotlin.UInt.minus' call
          var other_6 = _UInt___init__impl__l7qpdl(1);
          tmp_3 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp22) - _UInt___get_data__impl__f0vqqw(other_6) | 0);
        }
        UIntArray__set_impl_7f2zu2(tmp_2, j, tmp_3);
        reconstructedQuotient = this.m5a(this.x5a(divisor, UIntArray__get_impl_gp5kza(quotient, j)), imul(j, this.v59_1));
        while (this.v5a(reconstructedQuotient, dividend) > 0) {
          var tmp_4 = quotient;
          var tmp24 = UIntArray__get_impl_gp5kza(quotient, j);
          // Inline function 'kotlin.UInt.minus' call
          var other_7 = _UInt___init__impl__l7qpdl(1);
          var tmp$ret$32 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp24) - _UInt___get_data__impl__f0vqqw(other_7) | 0);
          UIntArray__set_impl_7f2zu2(tmp_4, j, tmp$ret$32);
          reconstructedQuotient = this.m5a(this.x5a(divisor, UIntArray__get_impl_gp5kza(quotient, j)), imul(j, this.v59_1));
        }
        dividend = this.w5a(dividend, reconstructedQuotient);
      }
       while (0 <= inductionVariable);
    while (this.v5a(dividend, divisor) >= 0) {
      quotient = this.y5a(quotient, _UInt___init__impl__l7qpdl(1));
      dividend = this.w5a(dividend, divisor);
    }
    var denormRemainder = this.n5a(dividend, normalizationShift);
    return new Pair(new UIntArray(this.h5a(quotient)), new UIntArray(denormRemainder));
  };
  protoOf(BigInteger32Arithmetic).m5a = function (_this__u8e3s4, places) {
    return this.j5a(_this__u8e3s4, places);
  };
  protoOf(BigInteger32Arithmetic).o5a = function (_this__u8e3s4, places) {
    return this.k5a(_this__u8e3s4, places);
  };
  protoOf(BigInteger32Arithmetic).w5a = function (_this__u8e3s4, other) {
    return this.r5a(_this__u8e3s4, other);
  };
  protoOf(BigInteger32Arithmetic).y5a = function (_this__u8e3s4, other) {
    // Inline function 'kotlin.uintArrayOf' call
    var tmp$ret$0 = _UIntArray___init__impl__ghjpc6(new Int32Array([other]));
    return this.q5a(_this__u8e3s4, tmp$ret$0);
  };
  protoOf(BigInteger32Arithmetic).x5a = function (_this__u8e3s4, other) {
    return this.s5a(_this__u8e3s4, other);
  };
  protoOf(BigInteger32Arithmetic).v5a = function (_this__u8e3s4, other) {
    return this.p5a(_this__u8e3s4, other);
  };
  var BigInteger32Arithmetic_instance;
  function BigInteger32Arithmetic_getInstance() {
    if (BigInteger32Arithmetic_instance == null)
      new BigInteger32Arithmetic();
    return BigInteger32Arithmetic_instance;
  }
  function multiplyWithCorrectedSize($this, first, second, firstCorrectedSize, secondCorrectedSize) {
    if (isZero_0(first, $this) || isZero_0(second, $this)) {
      return $this.q57_1;
    }
    if ((firstCorrectedSize >= 120 || secondCorrectedSize >= 120) && (firstCorrectedSize <= 15000 || secondCorrectedSize < 15000)) {
      return karatsubaMultiplyWithCorrectedSizes($this, first, second, firstCorrectedSize, secondCorrectedSize);
    }
    if (firstCorrectedSize >= 15000 && secondCorrectedSize >= 15000) {
      return $this.z5a(first, second);
    }
    return basecaseMultiplyWithCorrectedSize($this, first, second, firstCorrectedSize, secondCorrectedSize);
  }
  function basecaseMultiplyWithCorrectedSize($this, first, second, firstCorrectedSizeStart, secondCorrectedSizeStart) {
    var resultArray = $this.q57_1;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = ULongArray__iterator_impl_cq4d2h(second);
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m().s1_1;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.basecaseMultiplyWithCorrectedSize.<anonymous>' call
      if (_unary__edvuaz > secondCorrectedSizeStart) {
        new ULongArray(resultArray);
      } else {
        resultArray = BigInteger63Arithmetic_getInstance().c5b(resultArray, BigInteger63Arithmetic_getInstance().b5b(BigInteger63Arithmetic_getInstance().a5b(first, item), imul(_unary__edvuaz, BigInteger63Arithmetic_getInstance().v57_1)));
      }
    }
    return resultArray;
  }
  function karatsubaMultiplyWithCorrectedSizes($this, firstUnsigned, secondUnsigned, firstCorrectedSize, secondCorrectedSize) {
    var first = new SignedULongArray(firstUnsigned, true);
    var second = new SignedULongArray(secondUnsigned, true);
    // Inline function 'kotlin.math.max' call
    var halfLength = (Math.max(firstCorrectedSize, secondCorrectedSize) + 1 | 0) / 2 | 0;
    var mask = $this.d5b($this.b5b($this.r57_1, imul(halfLength, $this.w57_1)), _ULong___init__impl__c78o9k(new Long(1, 0)));
    var firstLower = $this.e5b(first, mask);
    var firstHigher = $this.f5b(first, imul(halfLength, $this.w57_1));
    var secondLower = $this.e5b(second, mask);
    var secondHigher = $this.f5b(second, imul(halfLength, $this.w57_1));
    var higherProduct = $this.g5b(firstHigher, secondHigher);
    var lowerProduct = $this.g5b(firstLower, secondLower);
    var middleProduct = $this.g5b($this.h5b(firstHigher, firstLower), $this.h5b(secondHigher, secondLower));
    var result = $this.h5b($this.h5b($this.i5b(higherProduct, imul(imul(2, $this.w57_1), halfLength)), $this.i5b($this.j5b($this.j5b(middleProduct, higherProduct), lowerProduct), imul($this.w57_1, halfLength))), lowerProduct);
    return result.k5b_1;
  }
  function isZero_0(_this__u8e3s4, $this) {
    if (equals(_this__u8e3s4, $this.q57_1))
      return true;
    if (_ULongArray___get_size__impl__ju6dtr(_this__u8e3s4) === 1 && equals(ULongArray__get_impl_pr71q9(_this__u8e3s4, 0), _ULong___init__impl__c78o9k(new Long(0, 0))))
      return true;
    if ((_ULongArray___get_size__impl__ju6dtr(_this__u8e3s4) - $this.m5b(_this__u8e3s4) | 0) === 0)
      return true;
    return false;
  }
  function SignedULongArray(unsignedValue, sign) {
    this.k5b_1 = unsignedValue;
    this.l5b_1 = sign;
  }
  protoOf(SignedULongArray).n5b = function (unsignedValue, sign) {
    return new SignedULongArray(unsignedValue, sign);
  };
  protoOf(SignedULongArray).o5b = function (unsignedValue, sign, $super) {
    unsignedValue = unsignedValue === VOID ? this.k5b_1 : unsignedValue;
    sign = sign === VOID ? this.l5b_1 : sign;
    return $super === VOID ? this.n5b(unsignedValue, sign) : $super.n5b.call(this, new ULongArray(unsignedValue), sign);
  };
  protoOf(SignedULongArray).toString = function () {
    return 'SignedULongArray(unsignedValue=' + ULongArray__toString_impl_wqk1p5(this.k5b_1) + ', sign=' + this.l5b_1 + ')';
  };
  protoOf(SignedULongArray).hashCode = function () {
    var result = ULongArray__hashCode_impl_aze4wa(this.k5b_1);
    result = imul(result, 31) + getBooleanHashCode(this.l5b_1) | 0;
    return result;
  };
  protoOf(SignedULongArray).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SignedULongArray))
      return false;
    var tmp0_other_with_cast = other instanceof SignedULongArray ? other : THROW_CCE();
    if (!equals(this.k5b_1, tmp0_other_with_cast.k5b_1))
      return false;
    if (!(this.l5b_1 === tmp0_other_with_cast.l5b_1))
      return false;
    return true;
  };
  function signedAdd($this, first, second) {
    var tmp;
    if (!!(first.l5b_1 ^ second.l5b_1)) {
      var tmp_0;
      if ($this.x58(first.k5b_1, second.k5b_1) > 0) {
        tmp_0 = new SignedULongArray($this.p5b(first.k5b_1, second.k5b_1), first.l5b_1);
      } else {
        tmp_0 = new SignedULongArray($this.p5b(second.k5b_1, first.k5b_1), second.l5b_1);
      }
      tmp = tmp_0;
    } else {
      tmp = new SignedULongArray($this.c5b(first.k5b_1, second.k5b_1), first.l5b_1);
    }
    return tmp;
  }
  function signedSubtract($this, first, second) {
    return signedAdd($this, first, second.o5b(VOID, !second.l5b_1));
  }
  function signedMultiply($this, first, second) {
    return new SignedULongArray($this.q5b(first.k5b_1, second.k5b_1), !!!(first.l5b_1 ^ second.l5b_1));
  }
  function signedDivide($this, first, second) {
    return new SignedULongArray($this.r5b(first.k5b_1, second.k5b_1), !!!(first.l5b_1 ^ second.l5b_1));
  }
  function BigInteger63Arithmetic() {
    BigInteger63Arithmetic_instance = this;
    var tmp = this;
    // Inline function 'kotlin.longArrayOf' call
    tmp.p57_1 = longArrayOf([]);
    var tmp_0 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    tmp_0.q57_1 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0))]));
    var tmp_1 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    tmp_1.r57_1 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(1, 0))]));
    var tmp_2 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    tmp_2.s57_1 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(2, 0))]));
    var tmp_3 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    tmp_3.t57_1 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(10, 0))]));
    var tmp_4 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    tmp_4.u57_1 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-1431655765, 715827882))]));
    this.v57_1 = 63;
    this.w57_1 = 63;
    this.x57_1 = _ULong___init__impl__c78o9k(new Long(-1, 2147483647));
    var tmp_5 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    tmp_5.y57_1 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-1, 2147483647))]));
    this.z57_1 = _ULong___init__impl__c78o9k(new Long(-1, 0));
    this.a58_1 = _ULong___init__impl__c78o9k(new Long(0, 2147483647));
    this.b58_1 = _ULong___init__impl__c78o9k(new Long(0, -2147483648));
    this.c58_1 = 120;
    this.d58_1 = 15000;
    this.e58_1 = false;
    this.f58_1 = new SignedULongArray(BigInteger63Arithmetic_getInstance().s57_1, true);
    var tmp_6 = this;
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_7 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(1, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_8 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(10, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_9 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(100, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_10 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(1000, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_11 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(10000, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_12 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(100000, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_13 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(1000000, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_14 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(10000000, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_15 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(100000000, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_16 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(1000000000, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_17 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(1410065408, 2))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_18 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(1215752192, 23))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_19 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-727379968, 232))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_20 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(1316134912, 2328))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_21 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(276447232, 23283))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_22 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-1530494976, 232830))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_23 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(1874919424, 2328306))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_24 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(1569325056, 23283064))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_25 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-1486618624, 232830643))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_26 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-1981284352, 180822788)), _ULong___init__impl__c78o9k(new Long(1, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_27 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(1661992960, 1808227885)), _ULong___init__impl__c78o9k(new Long(10, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_28 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-559939584, 902409669)), _ULong___init__impl__c78o9k(new Long(108, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_29 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-1304428544, 434162106)), _ULong___init__impl__c78o9k(new Long(1084, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_30 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-159383552, 46653770)), _ULong___init__impl__c78o9k(new Long(10842, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_31 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-1593835520, 466537709)), _ULong___init__impl__c78o9k(new Long(108420, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_32 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(1241513984, 370409800)), _ULong___init__impl__c78o9k(new Long(1084202, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_33 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-469762048, 1556614354)), _ULong___init__impl__c78o9k(new Long(10842021, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_34 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-402653184, 533758012)), _ULong___init__impl__c78o9k(new Long(108420217, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_35 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(268435456, 1042612833)), _ULong___init__impl__c78o9k(new Long(1084202172, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_36 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-1610612736, 1836193738)), _ULong___init__impl__c78o9k(new Long(-2042880164, 2))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_37 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(1073741824, 1182068202)), _ULong___init__impl__c78o9k(new Long(1046034848, 25))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_38 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(-2147483648, 1083263782)), _ULong___init__impl__c78o9k(new Long(1870413893, 252))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_39 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 95219585)), _ULong___init__impl__c78o9k(new Long(1524269751, 2524))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_40 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 952195850)), _ULong___init__impl__c78o9k(new Long(-1937171674, 25243))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_41 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 932023908)), _ULong___init__impl__c78o9k(new Long(2103119744, 252435))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_42 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 730304488)), _ULong___init__impl__c78o9k(new Long(-443639036, 2524354))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_43 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 860593936)), _ULong___init__impl__c78o9k(new Long(-141423061, 25243548))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_44 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 16004768)), _ULong___init__impl__c78o9k(new Long(-1414230606, 252435489))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_45 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 160047680)), _ULong___init__impl__c78o9k(new Long(-1257404172, 376871248)), _ULong___init__impl__c78o9k(new Long(1, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_46 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 1600476800)), _ULong___init__impl__c78o9k(new Long(310860168, 1621228839)), _ULong___init__impl__c78o9k(new Long(11, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_47 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 972382464)), _ULong___init__impl__c78o9k(new Long(-1186365609, 1179902854)), _ULong___init__impl__c78o9k(new Long(117, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_48 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 1133890048)), _ULong___init__impl__c78o9k(new Long(1021245802, 1061610307)), _ULong___init__impl__c78o9k(new Long(1175, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_49 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 601482240)), _ULong___init__impl__c78o9k(new Long(1622523433, 2026168480)), _ULong___init__impl__c78o9k(new Long(11754, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_50 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 1719855104)), _ULong___init__impl__c78o9k(new Long(-954634852, 934331971)), _ULong___init__impl__c78o9k(new Long(117549, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_51 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 18681856)), _ULong___init__impl__c78o9k(new Long(-956413920, 753385125)), _ULong___init__impl__c78o9k(new Long(1175494, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_52 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 186818560)), _ULong___init__impl__c78o9k(new Long(-974204608, 1091400313)), _ULong___init__impl__c78o9k(new Long(11754943, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_53 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 1868185600)), _ULong___init__impl__c78o9k(new Long(-1152111488, 176584897)), _ULong___init__impl__c78o9k(new Long(117549435, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_54 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 1501986816)), _ULong___init__impl__c78o9k(new Long(1363787016, 1765848977)), _ULong___init__impl__c78o9k(new Long(1175494350, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_55 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 2134966272)), _ULong___init__impl__c78o9k(new Long(752968278, 478620589)), _ULong___init__impl__c78o9k(new Long(-1129958380, 2))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_56 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 2022309888)), _ULong___init__impl__c78o9k(new Long(-1060251803, 491238595)), _ULong___init__impl__c78o9k(new Long(1585318090, 27))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_57 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 895746048)), _ULong___init__impl__c78o9k(new Long(-2012583429, 617418661)), _ULong___init__impl__c78o9k(new Long(-1326688282, 273))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_58 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 367525888)), _ULong___init__impl__c78o9k(new Long(1349002194, 1879219319)), _ULong___init__impl__c78o9k(new Long(-381980930, 2736))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_59 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 1527775232)), _ULong___init__impl__c78o9k(new Long(605120053, 1612324009)), _ULong___init__impl__c78o9k(new Long(475158004, 27369))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_60 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 245366784)), _ULong___init__impl__c78o9k(new Long(1756233241, 1090854555)), _ULong___init__impl__c78o9k(new Long(456612751, 273691))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_61 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 306184192)), _ULong___init__impl__c78o9k(new Long(382463227, 171127314)), _ULong___init__impl__c78o9k(new Long(271160219, 2736911))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_62 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 914358272)), _ULong___init__impl__c78o9k(new Long(-470335025, 1711273140)), _ULong___init__impl__c78o9k(new Long(-1583365106, 27369110))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_63 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 553648128)), _ULong___init__impl__c78o9k(new Long(-408382950, 2080345872)), _ULong___init__impl__c78o9k(new Long(1346218131, 273691106))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_64 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 1241513984)), _ULong___init__impl__c78o9k(new Long(211137798, 1476105897)), _ULong___init__impl__c78o9k(new Long(577279431, 589427415)), _ULong___init__impl__c78o9k(new Long(1, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_65 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 1677721600)), _ULong___init__impl__c78o9k(new Long(2111377985, 1876157082)), _ULong___init__impl__c78o9k(new Long(1477827020, 1599306855)), _ULong___init__impl__c78o9k(new Long(12, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_66 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 1744830464)), _ULong___init__impl__c78o9k(new Long(-361056623, 1581701640)), _ULong___init__impl__c78o9k(new Long(1893368320, 960683017)), _ULong___init__impl__c78o9k(new Long(127, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_67 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 268435456)), _ULong___init__impl__c78o9k(new Long(684401074, 784630873)), _ULong___init__impl__c78o9k(new Long(1753814023, 1016895582)), _ULong___init__impl__c78o9k(new Long(1274, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_68 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 536870912)), _ULong___init__impl__c78o9k(new Long(-1745923851, 1403857787)), _ULong___init__impl__c78o9k(new Long(358271049, 1579021232)), _ULong___init__impl__c78o9k(new Long(12744, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_69 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 1073741824)), _ULong___init__impl__c78o9k(new Long(-279369324, 1153675987)), _ULong___init__impl__c78o9k(new Long(-712256800, 757826784)), _ULong___init__impl__c78o9k(new Long(127447, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_70 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(1501274061, 799341639)), _ULong___init__impl__c78o9k(new Long(1467366597, 1135816904)), _ULong___init__impl__c78o9k(new Long(1274473, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_71 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(2127838722, 1550965449)), _ULong___init__impl__c78o9k(new Long(1788764085, 620750803)), _ULong___init__impl__c78o9k(new Long(12744735, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_72 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-196449260, 477268958)), _ULong___init__impl__c78o9k(new Long(707771673, 1912540738)), _ULong___init__impl__c78o9k(new Long(127447352, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_73 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-1964492600, 477722293)), _ULong___init__impl__c78o9k(new Long(-1512217860, 1945538197)), _ULong___init__impl__c78o9k(new Long(1274473528, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_74 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(1829910480, 482255639)), _ULong___init__impl__c78o9k(new Long(2057690586, 128029144)), _ULong___init__impl__c78o9k(new Long(-140166599, 2))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_75 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(1119235616, 527589098)), _ULong___init__impl__c78o9k(new Long(-897930618, 1280291444)), _ULong___init__impl__c78o9k(new Long(-1401665990, 29))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_76 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-1692545728, 980923686)), _ULong___init__impl__c78o9k(new Long(-389371586, 2065496207)), _ULong___init__impl__c78o9k(new Long(-1131758007, 296))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_77 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(254411904, 1219302274)), _ULong___init__impl__c78o9k(new Long(401251440, 1327609247)), _ULong___init__impl__c78o9k(new Long(1567321827, 2967))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_78 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-1750848256, 1455604500)), _ULong___init__impl__c78o9k(new Long(-282452891, 391190582)), _ULong___init__impl__c78o9k(new Long(-1506650908, 29673))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_79 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-328613376, 1671143117)), _ULong___init__impl__c78o9k(new Long(1470438392, 1764422181)), _ULong___init__impl__c78o9k(new Long(2113360105, 296736))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_80 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(1008833536, 1679045643)), _ULong___init__impl__c78o9k(new Long(1819482039, 464352629)), _ULong___init__impl__c78o9k(new Long(-341235422, 2967364))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_81 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(1498400768, 1758070896)), _ULong___init__impl__c78o9k(new Long(1014951213, 348558998)), _ULong___init__impl__c78o9k(new Long(882613078, 29673649))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_82 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(2099105792, 400839779)), _ULong___init__impl__c78o9k(new Long(1559577546, 1338106334)), _ULong___init__impl__c78o9k(new Long(236196189, 296736492))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_83 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-483778560, 1860914146)), _ULong___init__impl__c78o9k(new Long(-1584093723, 496161455)), _ULong___init__impl__c78o9k(new Long(-1933005400, 819881272)), _ULong___init__impl__c78o9k(new Long(1, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_84 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-542818304, 1429272284)), _ULong___init__impl__c78o9k(new Long(1338931962, 666647260)), _ULong___init__impl__c78o9k(new Long(2144782482, 1756361781)), _ULong___init__impl__c78o9k(new Long(13, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_85 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-1133215744, 1407820960)), _ULong___init__impl__c78o9k(new Long(504417738, 224021659)), _ULong___init__impl__c78o9k(new Long(-27011657, 383748630)), _ULong___init__impl__c78o9k(new Long(138, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_86 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(1552744448, 1193307719)), _ULong___init__impl__c78o9k(new Long(749210090, 92732943)), _ULong___init__impl__c78o9k(new Long(-270116569, 1690002661)), _ULong___init__impl__c78o9k(new Long(1381, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_87 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-1652424704, 1195658953)), _ULong___init__impl__c78o9k(new Long(-1097833687, 927329431)), _ULong___init__impl__c78o9k(new Long(1593801606, 1867641083)), _ULong___init__impl__c78o9k(new Long(13817, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_88 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(655622144, 1219171296)), _ULong___init__impl__c78o9k(new Long(1906565023, 683359725)), _ULong___init__impl__c78o9k(new Long(-1241853120, 1496541649)), _ULong___init__impl__c78o9k(new Long(138178, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_89 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-2033713152, 1454294721)), _ULong___init__impl__c78o9k(new Long(1885781051, 391146310)), _ULong___init__impl__c78o9k(new Long(466370691, 2080514609)), _ULong___init__impl__c78o9k(new Long(1381786, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_90 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(1137704960, 1658045327)), _ULong___init__impl__c78o9k(new Long(1677941332, 1763979456)), _ULong___init__impl__c78o9k(new Long(368739615, 1477793259)), _ULong___init__impl__c78o9k(new Long(13817869, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_91 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-1507852288, 1548067736)), _ULong___init__impl__c78o9k(new Long(-400455857, 459925379)), _ULong___init__impl__c78o9k(new Long(-607571138, 1893030702)), _ULong___init__impl__c78o9k(new Long(138178696, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_92 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(2101346304, 448291830)), _ULong___init__impl__c78o9k(new Long(290408733, 304286503)), _ULong___init__impl__c78o9k(new Long(-1780744082, 1750437844)), _ULong___init__impl__c78o9k(new Long(1381786968, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_93 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-461373440, 187951008)), _ULong___init__impl__c78o9k(new Long(-1390879964, 895381382)), _ULong___init__impl__c78o9k(new Long(-627571635, 324509261)), _ULong___init__impl__c78o9k(new Long(932967800, 3))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_94 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-318767104, 1879510088)), _ULong___init__impl__c78o9k(new Long(-1023897752, 363879234)), _ULong___init__impl__c78o9k(new Long(-1980749050, 1097608970)), _ULong___init__impl__c78o9k(new Long(739743409, 32))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_95 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(1107296256, 1615231705)), _ULong___init__impl__c78o9k(new Long(-1649042920, 1491308699)), _ULong___init__impl__c78o9k(new Long(1667345981, 238671465)), _ULong___init__impl__c78o9k(new Long(-1192500497, 321))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_96 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-1811939328, 1119931516)), _ULong___init__impl__c78o9k(new Long(689439991, 2028185108)), _ULong___init__impl__c78o9k(new Long(-506409368, 239231005)), _ULong___init__impl__c78o9k(new Long(959896919, 3217))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_97 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-939524096, 461896925)), _ULong___init__impl__c78o9k(new Long(-1695534677, 954498249)), _ULong___init__impl__c78o9k(new Long(-769126375, 244826410)), _ULong___init__impl__c78o9k(new Long(1009034599, 32172))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_98 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-805306368, 324001961)), _ULong___init__impl__c78o9k(new Long(224522416, 955047904)), _ULong___init__impl__c78o9k(new Long(898670846, 300780460)), _ULong___init__impl__c78o9k(new Long(1500411399, 321722))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_99 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(536870912, 1092535970)), _ULong___init__impl__c78o9k(new Long(-2049743135, 960544448)), _ULong___init__impl__c78o9k(new Long(396773872, 860320954)), _ULong___init__impl__c78o9k(new Long(2119212103, 3217223))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_100 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(1073741824, 187941461)), _ULong___init__impl__c78o9k(new Long(977405135, 1015509893)), _ULong___init__impl__c78o9k(new Long(-327228572, 13274948)), _ULong___init__impl__c78o9k(new Long(-282715446, 32172234))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_101 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(-2147483648, 1879414612)), _ULong___init__impl__c78o9k(new Long(1184116758, 1565164340)), _ULong___init__impl__c78o9k(new Long(1022681580, 132749489)), _ULong___init__impl__c78o9k(new Long(1467812836, 321722349))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_102 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(0, 1614276941)), _ULong___init__impl__c78o9k(new Long(-1043734300, 619257866)), _ULong___init__impl__c78o9k(new Long(1636881215, 1327494892)), _ULong___init__impl__c78o9k(new Long(1793226472, 1069739845)), _ULong___init__impl__c78o9k(new Long(1, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_103 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(0, 1110383874)), _ULong___init__impl__c78o9k(new Long(-1847408401, 1897611371)), _ULong___init__impl__c78o9k(new Long(-811057032, 390047035)), _ULong___init__impl__c78o9k(new Long(752395542, 2107463862)), _ULong___init__impl__c78o9k(new Long(14, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_104 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(0, 366420500)), _ULong___init__impl__c78o9k(new Long(-1294214821, 1796244531)), _ULong___init__impl__c78o9k(new Long(479364280, 1752986710)), _ULong___init__impl__c78o9k(new Long(-1065979171, 1747285789)), _ULong___init__impl__c78o9k(new Long(149, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_105 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(0, 1516721352)), _ULong___init__impl__c78o9k(new Long(-57246321, 782576132)), _ULong___init__impl__c78o9k(new Long(498675512, 349997917)), _ULong___init__impl__c78o9k(new Long(-2069857110, 292988713)), _ULong___init__impl__c78o9k(new Long(1498, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp_106 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(0, 134827984)), _ULong___init__impl__c78o9k(new Long(-572463203, 1383310385)), _ULong___init__impl__c78o9k(new Long(691787827, 1352495523)), _ULong___init__impl__c78o9k(new Long(776265381, 782403487)), _ULong___init__impl__c78o9k(new Long(14981, 0))]));
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp$ret$107 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(0, 1348279840)), _ULong___init__impl__c78o9k(new Long(-1429664734, 948201970)), _ULong___init__impl__c78o9k(new Long(-1672056316, 640053343)), _ULong___init__impl__c78o9k(new Long(-827280776, 1381583927)), _ULong___init__impl__c78o9k(new Long(149813, 0))]));
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_6.g58_1 = [new ULongArray(tmp_7), new ULongArray(tmp_8), new ULongArray(tmp_9), new ULongArray(tmp_10), new ULongArray(tmp_11), new ULongArray(tmp_12), new ULongArray(tmp_13), new ULongArray(tmp_14), new ULongArray(tmp_15), new ULongArray(tmp_16), new ULongArray(tmp_17), new ULongArray(tmp_18), new ULongArray(tmp_19), new ULongArray(tmp_20), new ULongArray(tmp_21), new ULongArray(tmp_22), new ULongArray(tmp_23), new ULongArray(tmp_24), new ULongArray(tmp_25), new ULongArray(tmp_26), new ULongArray(tmp_27), new ULongArray(tmp_28), new ULongArray(tmp_29), new ULongArray(tmp_30), new ULongArray(tmp_31), new ULongArray(tmp_32), new ULongArray(tmp_33), new ULongArray(tmp_34), new ULongArray(tmp_35), new ULongArray(tmp_36), new ULongArray(tmp_37), new ULongArray(tmp_38), new ULongArray(tmp_39), new ULongArray(tmp_40), new ULongArray(tmp_41), new ULongArray(tmp_42), new ULongArray(tmp_43), new ULongArray(tmp_44), new ULongArray(tmp_45), new ULongArray(tmp_46), new ULongArray(tmp_47), new ULongArray(tmp_48), new ULongArray(tmp_49), new ULongArray(tmp_50), new ULongArray(tmp_51), new ULongArray(tmp_52), new ULongArray(tmp_53), new ULongArray(tmp_54), new ULongArray(tmp_55), new ULongArray(tmp_56), new ULongArray(tmp_57), new ULongArray(tmp_58), new ULongArray(tmp_59), new ULongArray(tmp_60), new ULongArray(tmp_61), new ULongArray(tmp_62), new ULongArray(tmp_63), new ULongArray(tmp_64), new ULongArray(tmp_65), new ULongArray(tmp_66), new ULongArray(tmp_67), new ULongArray(tmp_68), new ULongArray(tmp_69), new ULongArray(tmp_70), new ULongArray(tmp_71), new ULongArray(tmp_72), new ULongArray(tmp_73), new ULongArray(tmp_74), new ULongArray(tmp_75), new ULongArray(tmp_76), new ULongArray(tmp_77), new ULongArray(tmp_78), new ULongArray(tmp_79), new ULongArray(tmp_80), new ULongArray(tmp_81), new ULongArray(tmp_82), new ULongArray(tmp_83), new ULongArray(tmp_84), new ULongArray(tmp_85), new ULongArray(tmp_86), new ULongArray(tmp_87), new ULongArray(tmp_88), new ULongArray(tmp_89), new ULongArray(tmp_90), new ULongArray(tmp_91), new ULongArray(tmp_92), new ULongArray(tmp_93), new ULongArray(tmp_94), new ULongArray(tmp_95), new ULongArray(tmp_96), new ULongArray(tmp_97), new ULongArray(tmp_98), new ULongArray(tmp_99), new ULongArray(tmp_100), new ULongArray(tmp_101), new ULongArray(tmp_102), new ULongArray(tmp_103), new ULongArray(tmp_104), new ULongArray(tmp_105), new ULongArray(tmp_106), new ULongArray(tmp$ret$107)];
  }
  protoOf(BigInteger63Arithmetic).a57 = function () {
    return this.q57_1;
  };
  protoOf(BigInteger63Arithmetic).b57 = function () {
    return this.r57_1;
  };
  protoOf(BigInteger63Arithmetic).c57 = function () {
    return this.s57_1;
  };
  protoOf(BigInteger63Arithmetic).d57 = function () {
    return this.t57_1;
  };
  protoOf(BigInteger63Arithmetic).s5b = function (value) {
    var x = value;
    var y;
    var n = 63;
    // Inline function 'kotlin.ULong.shr' call
    var this_0 = x;
    y = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_0).t3(32));
    if (!equals(y, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      n = n - 32 | 0;
      x = y;
    }
    // Inline function 'kotlin.ULong.shr' call
    var this_1 = x;
    y = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_1).t3(16));
    if (!equals(y, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      n = n - 16 | 0;
      x = y;
    }
    // Inline function 'kotlin.ULong.shr' call
    var this_2 = x;
    y = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_2).t3(8));
    if (!equals(y, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      n = n - 8 | 0;
      x = y;
    }
    // Inline function 'kotlin.ULong.shr' call
    var this_3 = x;
    y = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_3).t3(4));
    if (!equals(y, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      n = n - 4 | 0;
      x = y;
    }
    // Inline function 'kotlin.ULong.shr' call
    var this_4 = x;
    y = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_4).t3(2));
    if (!equals(y, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      n = n - 2 | 0;
      x = y;
    }
    // Inline function 'kotlin.ULong.shr' call
    var this_5 = x;
    y = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_5).t3(1));
    if (!equals(y, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      return n - 2 | 0;
    }
    var tmp = n;
    // Inline function 'kotlin.ULong.toInt' call
    var this_6 = x;
    return tmp - _ULong___get_data__impl__fggpzb(this_6).z3() | 0;
  };
  protoOf(BigInteger63Arithmetic).t5b = function (value) {
    if (isZero_0(value, this)) {
      return 0;
    }
    var start = (_ULongArray___get_size__impl__ju6dtr(value) - this.m5b(value) | 0) - 1 | 0;
    var mostSignificant = ULongArray__get_impl_pr71q9(value, start);
    return this.u5b(mostSignificant) + imul(start, 63) | 0;
  };
  protoOf(BigInteger63Arithmetic).u5b = function (value) {
    return 63 - this.s5b(value) | 0;
  };
  protoOf(BigInteger63Arithmetic).h58 = function (bigInteger) {
    var correctedSize = _ULongArray___get_size__impl__ju6dtr(bigInteger) - this.m5b(bigInteger) | 0;
    if (correctedSize === 0) {
      return this.q57_1;
    }
    if (_ULongArray___get_size__impl__ju6dtr(bigInteger) === correctedSize) {
      return bigInteger;
    }
    if (false && (_ULongArray___get_size__impl__ju6dtr(bigInteger) - correctedSize | 0) > 1000) {
      println('RLZ original array : ' + _ULongArray___get_size__impl__ju6dtr(bigInteger) + ' contains: ' + ((_ULongArray___get_size__impl__ju6dtr(bigInteger) - correctedSize | 0) - 1 | 0) + ' zeros');
    }
    // Inline function 'kotlin.collections.copyOfRange' call
    return _ULongArray___init__impl__twm1l3(copyOfRange(_ULongArray___get_storage__impl__28e64j(bigInteger), 0, correctedSize));
  };
  protoOf(BigInteger63Arithmetic).m5b = function (bigInteger) {
    var lastNonEmptyIndex = _ULongArray___get_size__impl__ju6dtr(bigInteger) - 1 | 0;
    if (lastNonEmptyIndex <= 0) {
      return 0;
    }
    var element = ULongArray__get_impl_pr71q9(bigInteger, lastNonEmptyIndex);
    while (equals(element, _ULong___init__impl__c78o9k(new Long(0, 0))) && lastNonEmptyIndex > 0) {
      lastNonEmptyIndex = lastNonEmptyIndex - 1 | 0;
      element = ULongArray__get_impl_pr71q9(bigInteger, lastNonEmptyIndex);
    }
    if (equals(ULongArray__get_impl_pr71q9(bigInteger, lastNonEmptyIndex), _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      lastNonEmptyIndex = lastNonEmptyIndex - 1 | 0;
    }
    return (_ULongArray___get_size__impl__ju6dtr(bigInteger) - lastNonEmptyIndex | 0) - 1 | 0;
  };
  protoOf(BigInteger63Arithmetic).v5b = function (operand, places) {
    if (isZero_0(operand, this)) {
      return operand;
    }
    if (places === 0) {
      return operand;
    }
    if (ULongArray__isEmpty_impl_c3yngu(operand)) {
      return this.q57_1;
    }
    var leadingZeroWords = this.m5b(operand);
    if (_ULongArray___get_size__impl__ju6dtr(operand) === leadingZeroWords) {
      return this.q57_1;
    }
    var originalSize = _ULongArray___get_size__impl__ju6dtr(operand) - leadingZeroWords | 0;
    var leadingZeros = this.s5b(ULongArray__get_impl_pr71q9(operand, originalSize - 1 | 0));
    var shiftWords = places / this.v57_1 | 0;
    var shiftBits = places % this.v57_1 | 0;
    var tmp;
    if (shiftBits > leadingZeros) {
      tmp = shiftWords + 1 | 0;
    } else {
      tmp = shiftWords;
    }
    var wordsNeeded = tmp;
    if (shiftBits === 0) {
      // Inline function 'kotlin.ULongArray' call
      var tmp_0 = 0;
      var tmp_1 = originalSize + wordsNeeded | 0;
      var tmp_2 = longArray(tmp_1);
      while (tmp_0 < tmp_1) {
        var tmp_3 = tmp_0;
        // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.shiftLeft.<anonymous>' call
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = (0 <= tmp_3 ? tmp_3 < shiftWords : false) ? _ULong___init__impl__c78o9k(new Long(0, 0)) : ULongArray__get_impl_pr71q9(operand, tmp_3 - shiftWords | 0);
        tmp_2[tmp_3] = _ULong___get_data__impl__fggpzb(this_0);
        tmp_0 = tmp_0 + 1 | 0;
      }
      return _ULongArray___init__impl__twm1l3(tmp_2);
    }
    // Inline function 'kotlin.ULongArray' call
    var tmp_4 = 0;
    var tmp_5 = originalSize + wordsNeeded | 0;
    var tmp_6 = longArray(tmp_5);
    while (tmp_4 < tmp_5) {
      var tmp_7 = tmp_4;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.shiftLeft.<anonymous>' call
      var tmp_8;
      if (0 <= tmp_7 ? tmp_7 < shiftWords : false) {
        tmp_8 = _ULong___init__impl__c78o9k(new Long(0, 0));
      } else {
        if (tmp_7 === shiftWords) {
          // Inline function 'kotlin.ULong.shl' call
          var this_1 = ULongArray__get_impl_pr71q9(operand, tmp_7 - shiftWords | 0);
          var tmp2 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_1).r3(shiftBits));
          // Inline function 'kotlin.ULong.and' call
          var other = BigInteger63Arithmetic_getInstance().x57_1;
          tmp_8 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp2).u3(_ULong___get_data__impl__fggpzb(other)));
        } else {
          var containsLower = shiftWords + 1 | 0;
          if (tmp_7 < (originalSize + shiftWords | 0) ? containsLower <= tmp_7 : false) {
            // Inline function 'kotlin.ULong.shl' call
            var this_2 = ULongArray__get_impl_pr71q9(operand, tmp_7 - shiftWords | 0);
            var tmp6 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_2).r3(shiftBits));
            // Inline function 'kotlin.ULong.and' call
            var other_0 = BigInteger63Arithmetic_getInstance().x57_1;
            var tmp10 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp6).u3(_ULong___get_data__impl__fggpzb(other_0)));
            var tmp8 = ULongArray__get_impl_pr71q9(operand, (tmp_7 - shiftWords | 0) - 1 | 0);
            // Inline function 'kotlin.ULong.shr' call
            var bitCount = BigInteger63Arithmetic_getInstance().v57_1 - shiftBits | 0;
            // Inline function 'kotlin.ULong.or' call
            var other_1 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp8).t3(bitCount));
            tmp_8 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp10).v3(_ULong___get_data__impl__fggpzb(other_1)));
          } else {
            if (tmp_7 === ((originalSize + wordsNeeded | 0) - 1 | 0)) {
              var tmp12 = ULongArray__get_impl_pr71q9(operand, tmp_7 - wordsNeeded | 0);
              // Inline function 'kotlin.ULong.shr' call
              var bitCount_0 = BigInteger63Arithmetic_getInstance().v57_1 - shiftBits | 0;
              tmp_8 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp12).t3(bitCount_0));
            } else {
              throw RuntimeException_init_$Create$_0('Invalid case ' + tmp_7);
            }
          }
        }
      }
      // Inline function 'kotlin.ULong.toLong' call
      var this_3 = tmp_8;
      tmp_6[tmp_7] = _ULong___get_data__impl__fggpzb(this_3);
      tmp_4 = tmp_4 + 1 | 0;
    }
    return _ULongArray___init__impl__twm1l3(tmp_6);
  };
  protoOf(BigInteger63Arithmetic).w5b = function (operand, places) {
    if (ULongArray__isEmpty_impl_c3yngu(operand) || places === 0) {
      return operand;
    }
    var leadingZeroWords = this.m5b(operand);
    var realOperandSize = _ULongArray___get_size__impl__ju6dtr(operand) - leadingZeroWords | 0;
    var shiftBits = places % this.v57_1 | 0;
    var wordsToDiscard = places / this.v57_1 | 0;
    if (wordsToDiscard >= realOperandSize) {
      return this.q57_1;
    }
    if (shiftBits === 0) {
      // Inline function 'kotlin.collections.copyOfRange' call
      var fromIndex = realOperandSize - wordsToDiscard | 0;
      _ULongArray___init__impl__twm1l3(copyOfRange(_ULongArray___get_storage__impl__28e64j(operand), fromIndex, realOperandSize));
    }
    if (realOperandSize > 1 && (realOperandSize - wordsToDiscard | 0) === 1) {
      // Inline function 'kotlin.ULong.shr' call
      var this_0 = ULongArray__get_impl_pr71q9(operand, realOperandSize - 1 | 0);
      var tmp$ret$1 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_0).t3(shiftBits));
      // Inline function 'kotlin.ulongArrayOf' call
      return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$1]));
    }
    var newLength = realOperandSize - wordsToDiscard | 0;
    if (newLength === 0) {
      return this.q57_1;
    }
    // Inline function 'kotlin.ULongArray' call
    var tmp = 0;
    var tmp_0 = realOperandSize - wordsToDiscard | 0;
    var tmp_1 = longArray(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.shiftRight.<anonymous>' call
      var tmp_3;
      if (0 <= tmp_2 ? tmp_2 < ((realOperandSize - 1 | 0) - wordsToDiscard | 0) : false) {
        // Inline function 'kotlin.ULong.shr' call
        var this_1 = ULongArray__get_impl_pr71q9(operand, tmp_2 + wordsToDiscard | 0);
        var tmp6 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_1).t3(shiftBits));
        var tmp2 = ULongArray__get_impl_pr71q9(operand, (tmp_2 + wordsToDiscard | 0) + 1 | 0);
        // Inline function 'kotlin.ULong.shl' call
        var bitCount = BigInteger63Arithmetic_getInstance().v57_1 - shiftBits | 0;
        var tmp4 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp2).r3(bitCount));
        // Inline function 'kotlin.ULong.and' call
        var other = BigInteger63Arithmetic_getInstance().x57_1;
        // Inline function 'kotlin.ULong.or' call
        var other_0 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp4).u3(_ULong___get_data__impl__fggpzb(other)));
        tmp_3 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp6).v3(_ULong___get_data__impl__fggpzb(other_0)));
      } else if (tmp_2 === ((realOperandSize - 1 | 0) - wordsToDiscard | 0)) {
        // Inline function 'kotlin.ULong.shr' call
        var this_2 = ULongArray__get_impl_pr71q9(operand, tmp_2 + wordsToDiscard | 0);
        tmp_3 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_2).t3(shiftBits));
      } else {
        throw RuntimeException_init_$Create$_0('Invalid case ' + tmp_2);
      }
      // Inline function 'kotlin.ULong.toLong' call
      var this_3 = tmp_3;
      tmp_1[tmp_2] = _ULong___get_data__impl__fggpzb(this_3);
      tmp = tmp + 1 | 0;
    }
    var result = _ULongArray___init__impl__twm1l3(tmp_1);
    return result;
  };
  protoOf(BigInteger63Arithmetic).x5b = function (first, second, firstStart, secondStart) {
    if (firstStart > secondStart) {
      return 1;
    }
    if (secondStart > firstStart) {
      return -1;
    }
    var counter = firstStart - 1 | 0;
    var firstIsLarger = false;
    var bothAreEqual = true;
    $l$loop_0: while (counter >= 0) {
      var tmp0 = ULongArray__get_impl_pr71q9(first, counter);
      // Inline function 'kotlin.ULong.compareTo' call
      var other = ULongArray__get_impl_pr71q9(second, counter);
      if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)) > 0) {
        firstIsLarger = true;
        bothAreEqual = false;
        break $l$loop_0;
      }
      var tmp2 = ULongArray__get_impl_pr71q9(first, counter);
      // Inline function 'kotlin.ULong.compareTo' call
      var other_0 = ULongArray__get_impl_pr71q9(second, counter);
      if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp2), _ULong___get_data__impl__fggpzb(other_0)) < 0) {
        firstIsLarger = false;
        bothAreEqual = false;
        break $l$loop_0;
      }
      counter = counter - 1 | 0;
    }
    if (bothAreEqual) {
      return 0;
    }
    if (firstIsLarger) {
      return 1;
    } else {
      return -1;
    }
  };
  protoOf(BigInteger63Arithmetic).n57 = function (first, second) {
    var firstStart = _ULongArray___get_size__impl__ju6dtr(first) - this.m5b(first) | 0;
    var secondStart = _ULongArray___get_size__impl__ju6dtr(second) - this.m5b(second) | 0;
    return this.x5b(first, second, firstStart, secondStart);
  };
  protoOf(BigInteger63Arithmetic).y5b = function (resultArray, resultArrayStart, first, second) {
    if (isZero_0(first, this)) {
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex = _ULongArray___get_size__impl__ju6dtr(first);
      var tmp0 = _ULongArray___get_storage__impl__28e64j(first);
      // Inline function 'kotlin.collections.copyInto' call
      var destination = _ULongArray___get_storage__impl__28e64j(resultArray);
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = tmp0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, destination, resultArrayStart, 0, endIndex);
      return Unit_instance;
    }
    if (isZero_0(second, this)) {
      // Inline function 'kotlin.collections.copyInto' call
      var endIndex_0 = _ULongArray___get_size__impl__ju6dtr(second);
      var tmp0_0 = _ULongArray___get_storage__impl__28e64j(second);
      // Inline function 'kotlin.collections.copyInto' call
      var destination_0 = _ULongArray___get_storage__impl__28e64j(resultArray);
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_0 = tmp0_0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp_0, destination_0, resultArrayStart, 0, endIndex_0);
      return Unit_instance;
    }
    var firstStart = _ULongArray___get_size__impl__ju6dtr(first) - this.m5b(first) | 0;
    var secondStart = _ULongArray___get_size__impl__ju6dtr(second) - this.m5b(second) | 0;
    var tmp_1;
    if (firstStart > secondStart) {
      tmp_1 = new Sextuple(_ULongArray___get_size__impl__ju6dtr(first), _ULongArray___get_size__impl__ju6dtr(second), new ULongArray(first), new ULongArray(second), firstStart, secondStart);
    } else {
      tmp_1 = new Sextuple(_ULongArray___get_size__impl__ju6dtr(second), _ULongArray___get_size__impl__ju6dtr(first), new ULongArray(second), new ULongArray(first), secondStart, firstStart);
    }
    var _destruct__k2r9zo = tmp_1;
    var largerLength = _destruct__k2r9zo.ug();
    var smallerLength = _destruct__k2r9zo.vg();
    var largerData = _destruct__k2r9zo.hm().on_1;
    var smallerData = _destruct__k2r9zo.g59().on_1;
    var largerStart = _destruct__k2r9zo.h59();
    var smallerStart = _destruct__k2r9zo.i59();
    var i = 0;
    var sum = _ULong___init__impl__c78o9k(new Long(0, 0));
    while (i < smallerStart) {
      var tmp10 = sum;
      // Inline function 'kotlin.ULong.plus' call
      var other = ULongArray__get_impl_pr71q9(largerData, i);
      var tmp12 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp10).i3(_ULong___get_data__impl__fggpzb(other)));
      // Inline function 'kotlin.ULong.plus' call
      var other_0 = ULongArray__get_impl_pr71q9(smallerData, i);
      sum = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp12).i3(_ULong___get_data__impl__fggpzb(other_0)));
      var tmp_2 = i + resultArrayStart | 0;
      var tmp14 = sum;
      // Inline function 'kotlin.ULong.and' call
      var other_1 = this.x57_1;
      var tmp$ret$14 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp14).u3(_ULong___get_data__impl__fggpzb(other_1)));
      ULongArray__set_impl_z19mvh(resultArray, tmp_2, tmp$ret$14);
      // Inline function 'kotlin.ULong.shr' call
      var this_0 = sum;
      sum = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_0).t3(63));
      i = i + 1 | 0;
    }
    while (true) {
      if (equals(sum, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
        while (i < largerStart) {
          ULongArray__set_impl_z19mvh(resultArray, i + resultArrayStart | 0, ULongArray__get_impl_pr71q9(largerData, i));
          i = i + 1 | 0;
        }
        return Unit_instance;
      }
      if (i === largerLength) {
        ULongArray__set_impl_z19mvh(resultArray, largerLength + resultArrayStart | 0, sum);
        return Unit_instance;
      }
      var tmp18 = sum;
      // Inline function 'kotlin.ULong.plus' call
      var other_2 = ULongArray__get_impl_pr71q9(largerData, i);
      sum = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp18).i3(_ULong___get_data__impl__fggpzb(other_2)));
      var tmp_3 = i;
      var tmp20 = sum;
      // Inline function 'kotlin.ULong.and' call
      var other_3 = this.x57_1;
      var tmp$ret$17 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp20).u3(_ULong___get_data__impl__fggpzb(other_3)));
      ULongArray__set_impl_z19mvh(resultArray, tmp_3, tmp$ret$17);
      // Inline function 'kotlin.ULong.shr' call
      var this_1 = sum;
      sum = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_1).t3(63));
      i = i + 1 | 0;
    }
  };
  protoOf(BigInteger63Arithmetic).k58 = function (first, second) {
    if (isZero_0(first, this))
      return second;
    if (isZero_0(second, this))
      return first;
    var firstStart = _ULongArray___get_size__impl__ju6dtr(first) - this.m5b(first) | 0;
    var secondStart = _ULongArray___get_size__impl__ju6dtr(second) - this.m5b(second) | 0;
    var tmp;
    if (firstStart > secondStart) {
      tmp = new Sextuple(_ULongArray___get_size__impl__ju6dtr(first), _ULongArray___get_size__impl__ju6dtr(second), new ULongArray(first), new ULongArray(second), firstStart, secondStart);
    } else {
      tmp = new Sextuple(_ULongArray___get_size__impl__ju6dtr(second), _ULongArray___get_size__impl__ju6dtr(first), new ULongArray(second), new ULongArray(first), secondStart, firstStart);
    }
    var _destruct__k2r9zo = tmp;
    var largerLength = _destruct__k2r9zo.ug();
    var smallerLength = _destruct__k2r9zo.vg();
    var largerData = _destruct__k2r9zo.hm().on_1;
    var smallerData = _destruct__k2r9zo.g59().on_1;
    var largerStart = _destruct__k2r9zo.h59();
    var smallerStart = _destruct__k2r9zo.i59();
    // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.possibleAdditionOverflow' call
    var firstMostSignificant = ULongArray__get_impl_pr71q9(largerData, largerStart - 1 | 0);
    var secondMostSignificant = ULongArray__get_impl_pr71q9(smallerData, smallerStart - 1 | 0);
    var tmp_0;
    // Inline function 'kotlin.ULong.and' call
    var other = _ULong___init__impl__c78o9k(new Long(0, 1610612736));
    var tmp$ret$0 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(firstMostSignificant).u3(_ULong___get_data__impl__fggpzb(other)));
    if (!equals(tmp$ret$0, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.ULong.and' call
      var other_0 = _ULong___init__impl__c78o9k(new Long(0, 1610612736));
      var tmp$ret$1 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(secondMostSignificant).u3(_ULong___get_data__impl__fggpzb(other_0)));
      tmp_0 = !equals(tmp$ret$1, _ULong___init__impl__c78o9k(new Long(0, 0)));
    }
    var possibleOverflow = tmp_0;
    var possibleOverflow_0 = possibleOverflow;
    var tmp_1;
    if (possibleOverflow_0) {
      // Inline function 'kotlin.ULongArray' call
      var tmp_2 = 0;
      var tmp_3 = largerLength + 1 | 0;
      var tmp_4 = longArray(tmp_3);
      while (tmp_2 < tmp_3) {
        var tmp_5 = tmp_2;
        // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.add.<anonymous>' call
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = _ULong___init__impl__c78o9k(new Long(0, 0));
        tmp_4[tmp_5] = _ULong___get_data__impl__fggpzb(this_0);
        tmp_2 = tmp_2 + 1 | 0;
      }
      tmp_1 = _ULongArray___init__impl__twm1l3(tmp_4);
    } else {
      // Inline function 'kotlin.ULongArray' call
      var tmp_6 = 0;
      var tmp_7 = longArray(largerLength);
      while (tmp_6 < largerLength) {
        var tmp_8 = tmp_6;
        // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.add.<anonymous>' call
        // Inline function 'kotlin.ULong.toLong' call
        var this_1 = _ULong___init__impl__c78o9k(new Long(0, 0));
        tmp_7[tmp_8] = _ULong___get_data__impl__fggpzb(this_1);
        tmp_6 = tmp_6 + 1 | 0;
      }
      tmp_1 = _ULongArray___init__impl__twm1l3(tmp_7);
    }
    var result = tmp_1;
    this.y5b(result, 0, first, second);
    var tmp_9;
    if (possibleOverflow_0) {
      tmp_9 = this.h58(result);
    } else {
      tmp_9 = result;
    }
    return tmp_9;
  };
  protoOf(BigInteger63Arithmetic).z5b = function (first, second, firstStart, secondStart) {
    var comparison = this.x5b(first, second, firstStart, secondStart);
    var firstSize = firstStart + 1 | 0;
    var secondSize = secondStart + 1 | 0;
    var firstIsLarger = comparison === 1;
    if (comparison === 0)
      return this.q57_1;
    if (secondSize === 1 && equals(ULongArray__get_impl_pr71q9(second, 0), _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      return first;
    }
    if (!firstIsLarger) {
      throw RuntimeException_init_$Create$_0('subtract result less than zero');
    }
    var tmp;
    if (firstIsLarger) {
      tmp = new Quadruple(new ULongArray(first), new ULongArray(second), firstStart, secondStart);
    } else {
      tmp = new Quadruple(new ULongArray(second), new ULongArray(first), secondStart, firstStart);
    }
    var _destruct__k2r9zo = tmp;
    var largerData = _destruct__k2r9zo.ug().on_1;
    var smallerData = _destruct__k2r9zo.vg().on_1;
    var largerStart = _destruct__k2r9zo.hm();
    var smallerStart = _destruct__k2r9zo.g59();
    // Inline function 'kotlin.ULongArray' call
    var tmp_0 = 0;
    var tmp_1 = longArray(largerStart);
    while (tmp_0 < largerStart) {
      var tmp_2 = tmp_0;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.subtractWithStartIndexes.<anonymous>' call
      // Inline function 'kotlin.ULong.toLong' call
      var this_0 = _ULong___init__impl__c78o9k(new Long(0, 0));
      tmp_1[tmp_2] = _ULong___get_data__impl__fggpzb(this_0);
      tmp_0 = tmp_0 + 1 | 0;
    }
    var result = _ULongArray___init__impl__twm1l3(tmp_1);
    var i = 0;
    var diff = _ULong___init__impl__c78o9k(new Long(0, 0));
    while (i < smallerStart) {
      var tmp2 = ULongArray__get_impl_pr71q9(largerData, i);
      // Inline function 'kotlin.ULong.minus' call
      var other = ULongArray__get_impl_pr71q9(smallerData, i);
      var tmp4 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp2).j3(_ULong___get_data__impl__fggpzb(other)));
      // Inline function 'kotlin.ULong.minus' call
      var other_0 = diff;
      diff = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp4).j3(_ULong___get_data__impl__fggpzb(other_0)));
      var tmp_3 = i;
      var tmp6 = diff;
      // Inline function 'kotlin.ULong.and' call
      var other_1 = this.x57_1;
      var tmp$ret$6 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp6).u3(_ULong___get_data__impl__fggpzb(other_1)));
      ULongArray__set_impl_z19mvh(result, tmp_3, tmp$ret$6);
      // Inline function 'kotlin.ULong.shr' call
      var this_1 = diff;
      diff = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_1).t3(63));
      i = i + 1 | 0;
    }
    while (!equals(diff, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      var tmp10 = ULongArray__get_impl_pr71q9(largerData, i);
      // Inline function 'kotlin.ULong.minus' call
      var other_2 = diff;
      diff = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp10).j3(_ULong___get_data__impl__fggpzb(other_2)));
      var tmp_4 = i;
      var tmp12 = diff;
      // Inline function 'kotlin.ULong.and' call
      var other_3 = this.x57_1;
      var tmp$ret$9 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp12).u3(_ULong___get_data__impl__fggpzb(other_3)));
      ULongArray__set_impl_z19mvh(result, tmp_4, tmp$ret$9);
      // Inline function 'kotlin.ULong.shr' call
      var this_2 = diff;
      diff = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_2).t3(63));
      i = i + 1 | 0;
    }
    while (i < largerStart) {
      ULongArray__set_impl_z19mvh(result, i, ULongArray__get_impl_pr71q9(largerData, i));
      i = i + 1 | 0;
    }
    if (this.m5b(result) === (_ULongArray___get_size__impl__ju6dtr(result) - 1 | 0) && equals(ULongArray__get_impl_pr71q9(result, 0), _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      return this.q57_1;
    }
    return this.h58(result);
  };
  protoOf(BigInteger63Arithmetic).j58 = function (first, second) {
    var firstStart = _ULongArray___get_size__impl__ju6dtr(first) - this.m5b(first) | 0;
    var secondStart = _ULongArray___get_size__impl__ju6dtr(second) - this.m5b(second) | 0;
    return this.z5b(first, second, firstStart, secondStart);
  };
  protoOf(BigInteger63Arithmetic).q58 = function (first, second) {
    var firstCorrectedSize = _ULongArray___get_size__impl__ju6dtr(first) - this.m5b(first) | 0;
    var secondCorrectedSize = _ULongArray___get_size__impl__ju6dtr(second) - this.m5b(second) | 0;
    return multiplyWithCorrectedSize(this, first, second, firstCorrectedSize, secondCorrectedSize);
  };
  protoOf(BigInteger63Arithmetic).a5c = function (original, numberOfWords, value) {
    // Inline function 'kotlin.ULongArray' call
    var tmp = 0;
    var tmp_0 = _ULongArray___get_size__impl__ju6dtr(original) + numberOfWords | 0;
    var tmp_1 = longArray(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.extendULongArray.<anonymous>' call
      // Inline function 'kotlin.ULong.toLong' call
      var this_0 = tmp_2 < _ULongArray___get_size__impl__ju6dtr(original) ? ULongArray__get_impl_pr71q9(original, tmp_2) : value;
      tmp_1[tmp_2] = _ULong___get_data__impl__fggpzb(this_0);
      tmp = tmp + 1 | 0;
    }
    return _ULongArray___init__impl__twm1l3(tmp_1);
  };
  protoOf(BigInteger63Arithmetic).z5a = function (firstUnchecked, secondUnchecked) {
    var tmp;
    if (!((_ULongArray___get_size__impl__ju6dtr(firstUnchecked) % 3 | 0) === 0)) {
      // Inline function 'kotlin.ULongArray' call
      var tmp_0 = 0;
      var tmp_1 = imul((_ULongArray___get_size__impl__ju6dtr(firstUnchecked) + 2 | 0) / 3 | 0, 3) - _ULongArray___get_size__impl__ju6dtr(firstUnchecked) | 0;
      var tmp_2 = longArray(tmp_1);
      while (tmp_0 < tmp_1) {
        var tmp_3 = tmp_0;
        // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.toomCook3Multiply.<anonymous>' call
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = _ULong___init__impl__c78o9k(new Long(0, 0));
        tmp_2[tmp_3] = _ULong___get_data__impl__fggpzb(this_0);
        tmp_0 = tmp_0 + 1 | 0;
      }
      var tmp$ret$3 = _ULongArray___init__impl__twm1l3(tmp_2);
      // Inline function 'kotlin.collections.asIterable' call
      var tmp$ret$4 = new ULongArray(tmp$ret$3);
      tmp = plus_4(new ULongArray(firstUnchecked), tmp$ret$4);
    } else {
      tmp = new ULongArray(firstUnchecked);
    }
    var first = toULongArray(tmp);
    var tmp_4;
    if (!((_ULongArray___get_size__impl__ju6dtr(secondUnchecked) % 3 | 0) === 0)) {
      // Inline function 'kotlin.ULongArray' call
      var tmp_5 = 0;
      var tmp_6 = imul((_ULongArray___get_size__impl__ju6dtr(secondUnchecked) + 2 | 0) / 3 | 0, 3) - _ULongArray___get_size__impl__ju6dtr(secondUnchecked) | 0;
      var tmp_7 = longArray(tmp_6);
      while (tmp_5 < tmp_6) {
        var tmp_8 = tmp_5;
        // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.toomCook3Multiply.<anonymous>' call
        // Inline function 'kotlin.ULong.toLong' call
        var this_1 = _ULong___init__impl__c78o9k(new Long(0, 0));
        tmp_7[tmp_8] = _ULong___get_data__impl__fggpzb(this_1);
        tmp_5 = tmp_5 + 1 | 0;
      }
      var tmp$ret$8 = _ULongArray___init__impl__twm1l3(tmp_7);
      // Inline function 'kotlin.collections.asIterable' call
      var tmp$ret$9 = new ULongArray(tmp$ret$8);
      tmp_4 = plus_4(new ULongArray(secondUnchecked), tmp$ret$9);
    } else {
      tmp_4 = new ULongArray(secondUnchecked);
    }
    var second = toULongArray(tmp_4);
    var firstLength = _ULongArray___get_size__impl__ju6dtr(first);
    var secondLength = _ULongArray___get_size__impl__ju6dtr(second);
    var tmp_9;
    if (firstLength > secondLength) {
      var prepared = this.a5c(second, firstLength - secondLength | 0, _ULong___init__impl__c78o9k(new Long(0, 0)));
      tmp_9 = new Pair(new ULongArray(first), new ULongArray(prepared));
    } else if (firstLength < secondLength) {
      var prepared_0 = this.a5c(first, secondLength - firstLength | 0, _ULong___init__impl__c78o9k(new Long(0, 0)));
      tmp_9 = new Pair(new ULongArray(prepared_0), new ULongArray(second));
    } else {
      tmp_9 = new Pair(new ULongArray(first), new ULongArray(second));
    }
    var _destruct__k2r9zo = tmp_9;
    var firstPrepared = _destruct__k2r9zo.ug().on_1;
    var secondPrepared = _destruct__k2r9zo.vg().on_1;
    var tmp6 = _ULongArray___get_size__impl__ju6dtr(first);
    // Inline function 'kotlin.math.max' call
    var b = _ULongArray___get_size__impl__ju6dtr(second);
    var longestLength = Math.max(tmp6, b);
    var extendedDigit = (longestLength + 2 | 0) / 3 | 0;
    var m0 = new SignedULongArray(toULongArray(slice(firstPrepared, until(0, extendedDigit))), true);
    var m1 = new SignedULongArray(toULongArray(slice(firstPrepared, until(extendedDigit, imul(extendedDigit, 2)))), true);
    var m2 = new SignedULongArray(toULongArray(slice(firstPrepared, until(imul(extendedDigit, 2), imul(extendedDigit, 3)))), true);
    var n0 = new SignedULongArray(toULongArray(slice(secondPrepared, until(0, extendedDigit))), true);
    var n1 = new SignedULongArray(toULongArray(slice(secondPrepared, until(extendedDigit, imul(extendedDigit, 2)))), true);
    var n2 = new SignedULongArray(toULongArray(slice(secondPrepared, until(imul(extendedDigit, 2), imul(extendedDigit, 3)))), true);
    var p0 = this.h5b(m0, m2);
    var pe0 = m0;
    var pe1 = this.h5b(p0, m1);
    var pem1 = this.j5b(p0, m1);
    var doublePemM2 = this.g5b(this.h5b(pem1, m2), this.f58_1);
    var pem2 = this.j5b(doublePemM2, m0);
    var pinf = m2;
    var q0 = this.h5b(n0, n2);
    var qe0 = n0;
    var qe1 = this.h5b(q0, n1);
    var qem1 = this.j5b(q0, n1);
    var doubleQemN2 = this.g5b(this.h5b(qem1, n2), this.f58_1);
    var qem2 = this.j5b(doubleQemN2, n0);
    var qinf = n2;
    var re0 = this.g5b(pe0, qe0);
    var re1 = this.g5b(pe1, qe1);
    var rem1 = this.g5b(pem1, qem1);
    var rem2 = this.g5b(pem2, qem2);
    var rinf = this.g5b(pinf, qinf);
    var r0 = re0;
    var r4 = rinf;
    var rem2re1diff = this.j5b(rem2, re1);
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp$ret$11 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(3, 0))]));
    var r3 = this.b5c(rem2re1diff, new SignedULongArray(tmp$ret$11, true));
    var r1 = this.f5b(this.j5b(re1, rem1), 1);
    var r2 = this.j5b(rem1, r0);
    r3 = this.h5b(this.f5b(this.j5b(r2, r3), 1), this.g5b(this.f58_1, rinf));
    r2 = this.j5b(this.h5b(r2, r1), r4);
    r1 = this.j5b(r1, r3);
    var bShiftAmount = imul(extendedDigit, 63);
    var rb0 = r0;
    var rb1 = this.i5b(r1, bShiftAmount);
    var rb2 = this.i5b(r2, imul(bShiftAmount, 2));
    var rb3 = this.i5b(r3, imul(bShiftAmount, 3));
    var rb4 = this.i5b(r4, imul(bShiftAmount, 4));
    var rb = this.h5b(this.h5b(this.h5b(this.h5b(rb0, rb1), rb2), rb3), rb4);
    return rb.k5b_1;
  };
  protoOf(BigInteger63Arithmetic).a5b = function (first, second) {
    var firstCorrectedSize = _ULongArray___get_size__impl__ju6dtr(first) - this.m5b(first) | 0;
    return this.c5c(first, second, firstCorrectedSize);
  };
  protoOf(BigInteger63Arithmetic).c5c = function (first, second, firstCorrectedSize) {
    // Inline function 'kotlin.ULong.and' call
    var other = this.z57_1;
    var secondLow = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(second).u3(_ULong___get_data__impl__fggpzb(other)));
    // Inline function 'kotlin.ULong.shr' call
    var secondHigh = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(second).t3(32));
    var requiredBits = this.t5b(first) + this.u5b(second) | 0;
    var tmp;
    if (!((requiredBits % 63 | 0) === 0)) {
      tmp = (requiredBits / 63 | 0) + 1 | 0;
    } else {
      tmp = requiredBits / 63 | 0;
    }
    var requiredWords = tmp;
    var result = _ULongArray___init__impl__twm1l3_0(requiredWords);
    var carryIntoNextRound = _ULong___init__impl__c78o9k(new Long(0, 0));
    var i = 0;
    var j = 0;
    while (i < firstCorrectedSize) {
      var tmp4 = ULongArray__get_impl_pr71q9(first, i);
      // Inline function 'kotlin.ULong.and' call
      var other_0 = this.z57_1;
      var firstLow = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp4).u3(_ULong___get_data__impl__fggpzb(other_0)));
      // Inline function 'kotlin.ULong.shr' call
      var this_0 = ULongArray__get_impl_pr71q9(first, i);
      var firstHigh = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_0).t3(32));
      i = i + 1 | 0;
      // Inline function 'kotlin.ULong.times' call
      var lowerProduct = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(firstLow).k3(_ULong___get_data__impl__fggpzb(secondLow)));
      // Inline function 'kotlin.ULong.shr' call
      var lowerCarry = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(lowerProduct).t3(63));
      var tmp14 = carryIntoNextRound;
      // Inline function 'kotlin.ULong.and' call
      var other_1 = this.x57_1;
      // Inline function 'kotlin.ULong.plus' call
      var other_2 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(lowerProduct).u3(_ULong___get_data__impl__fggpzb(other_1)));
      var lowResult = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp14).i3(_ULong___get_data__impl__fggpzb(other_2)));
      var tmp18 = lowerCarry;
      // Inline function 'kotlin.ULong.shr' call
      var this_1 = lowResult;
      // Inline function 'kotlin.ULong.plus' call
      var other_3 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_1).t3(63));
      lowerCarry = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp18).i3(_ULong___get_data__impl__fggpzb(other_3)));
      var tmp20 = lowResult;
      // Inline function 'kotlin.ULong.and' call
      var other_4 = this.x57_1;
      lowResult = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp20).u3(_ULong___get_data__impl__fggpzb(other_4)));
      // Inline function 'kotlin.ULong.times' call
      var tmp26 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(firstLow).k3(_ULong___get_data__impl__fggpzb(secondHigh)));
      // Inline function 'kotlin.ULong.times' call
      // Inline function 'kotlin.ULong.plus' call
      var other_5 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(secondLow).k3(_ULong___get_data__impl__fggpzb(firstHigh)));
      var middleProduct = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp26).i3(_ULong___get_data__impl__fggpzb(other_5)));
      var middleCarry = lowerCarry;
      var tmp30 = middleCarry;
      // Inline function 'kotlin.ULong.shr' call
      // Inline function 'kotlin.ULong.plus' call
      var other_6 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(middleProduct).t3(31));
      middleCarry = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp30).i3(_ULong___get_data__impl__fggpzb(other_6)));
      var tmp36 = lowResult;
      // Inline function 'kotlin.ULong.shl' call
      var tmp34 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(middleProduct).r3(32));
      // Inline function 'kotlin.ULong.and' call
      var other_7 = this.x57_1;
      // Inline function 'kotlin.ULong.plus' call
      var other_8 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp34).u3(_ULong___get_data__impl__fggpzb(other_7)));
      lowResult = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp36).i3(_ULong___get_data__impl__fggpzb(other_8)));
      var tmp40 = middleCarry;
      // Inline function 'kotlin.ULong.shr' call
      var this_2 = lowResult;
      // Inline function 'kotlin.ULong.plus' call
      var other_9 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_2).t3(63));
      middleCarry = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp40).i3(_ULong___get_data__impl__fggpzb(other_9)));
      var tmp_0 = j;
      var tmp42 = lowResult;
      // Inline function 'kotlin.ULong.and' call
      var other_10 = this.x57_1;
      var tmp$ret$21 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp42).u3(_ULong___get_data__impl__fggpzb(other_10)));
      ULongArray__set_impl_z19mvh(result, tmp_0, tmp$ret$21);
      var highResult = middleCarry;
      // Inline function 'kotlin.ULong.times' call
      // Inline function 'kotlin.ULong.shl' call
      var this_3 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(firstHigh).k3(_ULong___get_data__impl__fggpzb(secondHigh)));
      var higherProduct = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_3).r3(1));
      // Inline function 'kotlin.ULong.plus' call
      var this_4 = highResult;
      highResult = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_4).i3(_ULong___get_data__impl__fggpzb(higherProduct)));
      carryIntoNextRound = highResult;
      j = j + 1 | 0;
    }
    if (!equals(carryIntoNextRound, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      ULongArray__set_impl_z19mvh(result, j, carryIntoNextRound);
    }
    return result;
  };
  protoOf(BigInteger63Arithmetic).v58 = function (base, exponent) {
    if (exponent.equals(new Long(0, 0))) {
      return this.r57_1;
    }
    if (exponent.equals(new Long(1, 0))) {
      return base;
    }
    if (_ULongArray___get_size__impl__ju6dtr(base) === 1 && equals(ULongArray__get_impl_pr71q9(base, 0), _ULong___init__impl__c78o9k(new Long(10, 0))) && exponent.d1(toLong(this.g58_1.length)) < 0) {
      return this.g58_1[exponent.z3()].on_1;
    }
    var firstCorrectedSize = _ULongArray___get_size__impl__ju6dtr(base) - this.m5b(base) | 0;
    var helperVar = this.r57_1;
    var exponentVar = exponent;
    var baseVar = base;
    while (exponentVar.d1(new Long(1, 0)) > 0) {
      // Inline function 'kotlin.Long.rem' call
      if (exponentVar.m3(toLong(2)).equals(new Long(0, 0))) {
        baseVar = this.q5b(baseVar, baseVar);
        // Inline function 'kotlin.Long.div' call
        exponentVar = exponentVar.l3(toLong(2));
      } else {
        helperVar = this.q5b(baseVar, helperVar);
        baseVar = this.q5b(baseVar, baseVar);
        // Inline function 'kotlin.Long.minus' call
        // Inline function 'kotlin.Long.div' call
        exponentVar = exponentVar.j3(toLong(1)).l3(toLong(2));
      }
    }
    return this.q5b(helperVar, baseVar);
  };
  protoOf(BigInteger63Arithmetic).d5c = function (dividend, divisor) {
    var divisorSize = _ULongArray___get_size__impl__ju6dtr(divisor);
    var normalizationShift = this.s5b(ULongArray__get_impl_pr71q9(divisor, divisorSize - 1 | 0));
    var divisorNormalized = this.b5b(divisor, normalizationShift);
    var dividendNormalized = this.b5b(dividend, normalizationShift);
    return new Triple(new ULongArray(dividendNormalized), new ULongArray(divisorNormalized), normalizationShift);
  };
  protoOf(BigInteger63Arithmetic).e5c = function (remainderNormalized, normalizationShift) {
    var remainder = this.f5c(remainderNormalized, normalizationShift);
    return remainder;
  };
  protoOf(BigInteger63Arithmetic).g5c = function (unnormalizedDividend, unnormalizedDivisor) {
    if (this.x58(unnormalizedDivisor, unnormalizedDividend) > 0) {
      return new Pair(new ULongArray(this.q57_1), new ULongArray(unnormalizedDividend));
    }
    if (_ULongArray___get_size__impl__ju6dtr(unnormalizedDivisor) === 1 && _ULongArray___get_size__impl__ju6dtr(unnormalizedDividend) === 1) {
      var tmp0 = ULongArray__get_impl_pr71q9(unnormalizedDividend, 0);
      // Inline function 'kotlin.ULong.div' call
      var other = ULongArray__get_impl_pr71q9(unnormalizedDivisor, 0);
      var tmp$ret$0 = ulongDivide(tmp0, other);
      // Inline function 'kotlin.ulongArrayOf' call
      var tmp$ret$1 = _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$0]));
      var tmp = this.h58(tmp$ret$1);
      var tmp3 = ULongArray__get_impl_pr71q9(unnormalizedDividend, 0);
      // Inline function 'kotlin.ULong.rem' call
      var other_0 = ULongArray__get_impl_pr71q9(unnormalizedDivisor, 0);
      var tmp$ret$2 = ulongRemainder(tmp3, other_0);
      // Inline function 'kotlin.ulongArrayOf' call
      var tmp$ret$3 = _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$2]));
      return new Pair(new ULongArray(tmp), new ULongArray(this.h58(tmp$ret$3)));
    }
    var bitPrecision = this.t5b(unnormalizedDividend) - this.t5b(unnormalizedDivisor) | 0;
    if (bitPrecision === 0) {
      return new Pair(new ULongArray(this.r57_1), new ULongArray(this.p5b(unnormalizedDividend, unnormalizedDivisor)));
    }
    var _destruct__k2r9zo = this.d5c(unnormalizedDividend, unnormalizedDivisor);
    var dividend = _destruct__k2r9zo.ug().on_1;
    var divisor = _destruct__k2r9zo.vg().on_1;
    var normalizationShift = _destruct__k2r9zo.hm();
    var dividendSize = _ULongArray___get_size__impl__ju6dtr(dividend);
    var divisorSize = _ULongArray___get_size__impl__ju6dtr(divisor);
    var divisorCorrectedSize = _ULongArray___get_size__impl__ju6dtr(divisor) - this.m5b(divisor) | 0;
    var wordPrecision = dividendSize - divisorSize | 0;
    var qjhat;
    var reconstructedQuotient;
    var quotient = _ULongArray___init__impl__twm1l3_0(wordPrecision);
    var divisorTimesBaseToPowerOfM = this.b5b(divisor, imul(wordPrecision, this.v57_1));
    if (this.x58(dividend, divisorTimesBaseToPowerOfM) >= 0) {
      quotient = _ULongArray___init__impl__twm1l3_0(wordPrecision + 1 | 0);
      ULongArray__set_impl_z19mvh(quotient, wordPrecision, _ULong___init__impl__c78o9k(new Long(1, 0)));
      dividend = this.p5b(dividend, divisorTimesBaseToPowerOfM);
    }
    var inductionVariable = wordPrecision - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp_0;
        if ((divisorSize + j | 0) < _ULongArray___get_size__impl__ju6dtr(dividend)) {
          // Inline function 'kotlin.ulongArrayOf' call
          var tmp$ret$4 = _ULongArray___init__impl__twm1l3(longArrayOf([ULongArray__get_impl_pr71q9(dividend, divisorSize + j | 0)]));
          tmp_0 = this.h5c(this.b5b(tmp$ret$4, this.v57_1), ULongArray__get_impl_pr71q9(dividend, (divisorSize + j | 0) - 1 | 0));
        } else {
          var tmp_1;
          if ((divisorSize + j | 0) === _ULongArray___get_size__impl__ju6dtr(dividend)) {
            // Inline function 'kotlin.ulongArrayOf' call
            tmp_1 = _ULongArray___init__impl__twm1l3(longArrayOf([ULongArray__get_impl_pr71q9(dividend, (divisorSize + j | 0) - 1 | 0)]));
          } else {
            tmp_1 = this.q57_1;
          }
          tmp_0 = tmp_1;
        }
        var twoDigit = tmp_0;
        var tmp_2 = BigInteger32Arithmetic_getInstance();
        var tmp_3 = this.i5c(twoDigit);
        // Inline function 'kotlin.ulongArrayOf' call
        var tmp$ret$6 = _ULongArray___init__impl__twm1l3(longArrayOf([ULongArray__get_impl_pr71q9(divisor, divisorSize - 1 | 0)]));
        var convertedResult = tmp_2.t5a(tmp_3, this.i5c(tmp$ret$6));
        qjhat = this.j5c(convertedResult.dh_1.dn_1);
        var tmp_4 = quotient;
        var tmp_5;
        var tmp_6 = qjhat;
        var tmp9 = this.x57_1;
        // Inline function 'kotlin.ULong.minus' call
        var other_1 = _ULong___init__impl__c78o9k(new Long(1, 0));
        var tmp$ret$7 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp9).j3(_ULong___get_data__impl__fggpzb(other_1)));
        if (this.k5c(tmp_6, tmp$ret$7) < 0) {
          tmp_5 = ULongArray__get_impl_pr71q9(qjhat, 0);
        } else {
          tmp_5 = this.x57_1;
        }
        ULongArray__set_impl_z19mvh(tmp_4, j, tmp_5);
        reconstructedQuotient = this.b5b(this.c5c(divisor, ULongArray__get_impl_pr71q9(quotient, j), divisorCorrectedSize), imul(j, this.v57_1));
        while (this.x58(reconstructedQuotient, dividend) > 0) {
          var tmp_7 = quotient;
          var tmp11 = ULongArray__get_impl_pr71q9(quotient, j);
          // Inline function 'kotlin.ULong.minus' call
          // Inline function 'kotlin.UInt.toULong' call
          var this_0 = _UInt___init__impl__l7qpdl(1);
          // Inline function 'kotlin.uintToULong' call
          // Inline function 'kotlin.uintToLong' call
          var value = _UInt___get_data__impl__f0vqqw(this_0);
          var tmp$ret$8 = toLong(value).u3(new Long(-1, 0));
          // Inline function 'kotlin.ULong.minus' call
          var other_2 = _ULong___init__impl__c78o9k(tmp$ret$8);
          var tmp$ret$12 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp11).j3(_ULong___get_data__impl__fggpzb(other_2)));
          ULongArray__set_impl_z19mvh(tmp_7, j, tmp$ret$12);
          reconstructedQuotient = this.b5b(this.c5c(divisor, ULongArray__get_impl_pr71q9(quotient, j), divisorCorrectedSize), imul(j, this.v57_1));
        }
        dividend = this.p5b(dividend, reconstructedQuotient);
      }
       while (0 <= inductionVariable);
    while (this.x58(dividend, divisor) >= 0) {
      quotient = this.h5c(quotient, _ULong___init__impl__c78o9k(new Long(1, 0)));
      dividend = this.p5b(dividend, divisor);
    }
    var denormRemainder = this.e5c(dividend, normalizationShift);
    return new Pair(new ULongArray(this.h58(quotient)), new ULongArray(denormRemainder));
  };
  protoOf(BigInteger63Arithmetic).l5c = function (operand) {
    if (isZero_0(operand, this))
      return this.q57_1;
    var length = this.t5b(operand);
    var tmp;
    if ((length % 64 | 0) === 0) {
      tmp = length / 64 | 0;
    } else {
      tmp = (length / 64 | 0) + 1 | 0;
    }
    var requiredLength = tmp;
    var wordStep;
    var shiftAmount;
    var result = _ULongArray___init__impl__twm1l3_0(requiredLength);
    var inductionVariable = 0;
    if (inductionVariable < requiredLength)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        wordStep = i / 63 | 0;
        shiftAmount = i % 63 | 0;
        if (((i + wordStep | 0) + 1 | 0) < _ULongArray___get_size__impl__ju6dtr(operand)) {
          // Inline function 'kotlin.ULong.shr' call
          var this_0 = ULongArray__get_impl_pr71q9(operand, i + wordStep | 0);
          var tmp4 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_0).t3(shiftAmount));
          var tmp2 = ULongArray__get_impl_pr71q9(operand, (i + wordStep | 0) + 1 | 0);
          // Inline function 'kotlin.ULong.shl' call
          var bitCount = 63 - shiftAmount | 0;
          // Inline function 'kotlin.ULong.or' call
          var other = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp2).r3(bitCount));
          var tmp$ret$2 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp4).v3(_ULong___get_data__impl__fggpzb(other)));
          ULongArray__set_impl_z19mvh(result, i, tmp$ret$2);
        } else {
          // Inline function 'kotlin.ULong.shr' call
          var this_1 = ULongArray__get_impl_pr71q9(operand, i + wordStep | 0);
          var tmp$ret$3 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_1).t3(shiftAmount));
          ULongArray__set_impl_z19mvh(result, i, tmp$ret$3);
        }
      }
       while (inductionVariable < requiredLength);
    return this.h58(result);
  };
  protoOf(BigInteger63Arithmetic).m5c = function (operand) {
    var power64Representation = this.l5c(operand);
    var result = _UIntArray___init__impl__ghjpc6_0(imul(_ULongArray___get_size__impl__ju6dtr(power64Representation), 2));
    var inductionVariable = 0;
    var last = _ULongArray___get_size__impl__ju6dtr(power64Representation);
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(2, i);
        var tmp1 = ULongArray__get_impl_pr71q9(power64Representation, i);
        // Inline function 'kotlin.UInt.toULong' call
        var this_0 = BigInteger32Arithmetic_getInstance().u59_1;
        // Inline function 'kotlin.uintToULong' call
        // Inline function 'kotlin.uintToLong' call
        var value = _UInt___get_data__impl__f0vqqw(this_0);
        var tmp$ret$0 = toLong(value).u3(new Long(-1, 0));
        // Inline function 'kotlin.ULong.and' call
        var other = _ULong___init__impl__c78o9k(tmp$ret$0);
        // Inline function 'kotlin.ULong.toUInt' call
        var this_1 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp1).u3(_ULong___get_data__impl__fggpzb(other)));
        // Inline function 'kotlin.toUInt' call
        var this_2 = _ULong___get_data__impl__fggpzb(this_1);
        var tmp$ret$5 = _UInt___init__impl__l7qpdl(this_2.z3());
        UIntArray__set_impl_7f2zu2(result, tmp, tmp$ret$5);
        var tmp_0 = imul(2, i) + 1 | 0;
        // Inline function 'kotlin.ULong.shr' call
        var this_3 = ULongArray__get_impl_pr71q9(power64Representation, i);
        // Inline function 'kotlin.ULong.toUInt' call
        var this_4 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_3).t3(32));
        // Inline function 'kotlin.toUInt' call
        var this_5 = _ULong___get_data__impl__fggpzb(this_4);
        var tmp$ret$8 = _UInt___init__impl__l7qpdl(this_5.z3());
        UIntArray__set_impl_7f2zu2(result, tmp_0, tmp$ret$8);
      }
       while (inductionVariable < last);
    return BigInteger32Arithmetic_getInstance().h5a(result);
  };
  protoOf(BigInteger63Arithmetic).n5c = function (operand) {
    if (_UIntArray___get_size__impl__r6l8ci(operand) === 0) {
      return this.q57_1;
    }
    if (_UIntArray___get_size__impl__r6l8ci(operand) === 1) {
      // Inline function 'kotlin.UInt.toULong' call
      var this_0 = UIntArray__get_impl_gp5kza(operand, 0);
      // Inline function 'kotlin.uintToULong' call
      // Inline function 'kotlin.uintToLong' call
      var value = _UInt___get_data__impl__f0vqqw(this_0);
      var tmp$ret$0 = toLong(value).u3(new Long(-1, 0));
      var tmp$ret$2 = _ULong___init__impl__c78o9k(tmp$ret$0);
      // Inline function 'kotlin.ulongArrayOf' call
      return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$2]));
    }
    var length = BigInteger32Arithmetic_getInstance().f5a(operand);
    var tmp;
    if ((length % 63 | 0) === 0) {
      tmp = length / 63 | 0;
    } else {
      tmp = (length / 63 | 0) + 1 | 0;
    }
    var requiredLength = tmp;
    var result = _ULongArray___init__impl__twm1l3_0(requiredLength);
    var skipWordCount;
    var inductionVariable = 0;
    if (inductionVariable < requiredLength)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        skipWordCount = i / 32 | 0;
        var shiftAmount = i % 32 | 0;
        var position = imul(i, 2) - skipWordCount | 0;
        if (requiredLength === 2) {
          // Inline function 'kotlin.UInt.toULong' call
          var this_1 = UIntArray__get_impl_gp5kza(operand, 0);
          // Inline function 'kotlin.uintToULong' call
          // Inline function 'kotlin.uintToLong' call
          var value_0 = _UInt___get_data__impl__f0vqqw(this_1);
          var tmp$ret$4 = toLong(value_0).u3(new Long(-1, 0));
          var tmp8 = _ULong___init__impl__c78o9k(tmp$ret$4);
          // Inline function 'kotlin.UInt.toULong' call
          var this_2 = UIntArray__get_impl_gp5kza(operand, 1);
          // Inline function 'kotlin.uintToULong' call
          // Inline function 'kotlin.uintToLong' call
          var value_1 = _UInt___get_data__impl__f0vqqw(this_2);
          var tmp$ret$7 = toLong(value_1).u3(new Long(-1, 0));
          // Inline function 'kotlin.ULong.shl' call
          var this_3 = _ULong___init__impl__c78o9k(tmp$ret$7);
          var tmp6 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_3).r3(32));
          // Inline function 'kotlin.ULong.and' call
          var other = this.a58_1;
          // Inline function 'kotlin.ULong.or' call
          var other_0 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp6).u3(_ULong___get_data__impl__fggpzb(other)));
          var tmp$ret$12 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp8).v3(_ULong___get_data__impl__fggpzb(other_0)));
          ULongArray__set_impl_z19mvh(result, 0, tmp$ret$12);
          if (_UIntArray___get_size__impl__r6l8ci(operand) === 4) {
            // Inline function 'kotlin.UInt.toULong' call
            var this_4 = UIntArray__get_impl_gp5kza(operand, 1);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_2 = _UInt___get_data__impl__f0vqqw(this_4);
            var tmp$ret$13 = toLong(value_2).u3(new Long(-1, 0));
            // Inline function 'kotlin.ULong.shr' call
            var this_5 = _ULong___init__impl__c78o9k(tmp$ret$13);
            var tmp16 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_5).t3(31));
            // Inline function 'kotlin.UInt.toULong' call
            var this_6 = UIntArray__get_impl_gp5kza(operand, 2);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_3 = _UInt___get_data__impl__f0vqqw(this_6);
            var tmp$ret$17 = toLong(value_3).u3(new Long(-1, 0));
            // Inline function 'kotlin.ULong.shl' call
            var this_7 = _ULong___init__impl__c78o9k(tmp$ret$17);
            // Inline function 'kotlin.ULong.or' call
            var other_1 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_7).r3(1));
            var tmp21 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp16).v3(_ULong___get_data__impl__fggpzb(other_1)));
            // Inline function 'kotlin.UInt.toULong' call
            var this_8 = UIntArray__get_impl_gp5kza(operand, 3);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_4 = _UInt___get_data__impl__f0vqqw(this_8);
            var tmp$ret$22 = toLong(value_4).u3(new Long(-1, 0));
            // Inline function 'kotlin.ULong.shl' call
            var this_9 = _ULong___init__impl__c78o9k(tmp$ret$22);
            // Inline function 'kotlin.ULong.or' call
            var other_2 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_9).r3(33));
            var tmp$ret$26 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp21).v3(_ULong___get_data__impl__fggpzb(other_2)));
            ULongArray__set_impl_z19mvh(result, 1, tmp$ret$26);
          } else {
            if (_UIntArray___get_size__impl__r6l8ci(operand) > 2) {
              // Inline function 'kotlin.UInt.toULong' call
              var this_10 = UIntArray__get_impl_gp5kza(operand, 1);
              // Inline function 'kotlin.uintToULong' call
              // Inline function 'kotlin.uintToLong' call
              var value_5 = _UInt___get_data__impl__f0vqqw(this_10);
              var tmp$ret$27 = toLong(value_5).u3(new Long(-1, 0));
              // Inline function 'kotlin.ULong.shr' call
              var this_11 = _ULong___init__impl__c78o9k(tmp$ret$27);
              var tmp29 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_11).t3(31));
              // Inline function 'kotlin.UInt.toULong' call
              var this_12 = UIntArray__get_impl_gp5kza(operand, 2);
              // Inline function 'kotlin.uintToULong' call
              // Inline function 'kotlin.uintToLong' call
              var value_6 = _UInt___get_data__impl__f0vqqw(this_12);
              var tmp$ret$31 = toLong(value_6).u3(new Long(-1, 0));
              // Inline function 'kotlin.ULong.shl' call
              var this_13 = _ULong___init__impl__c78o9k(tmp$ret$31);
              // Inline function 'kotlin.ULong.or' call
              var other_3 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_13).r3(1));
              var tmp$ret$35 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp29).v3(_ULong___get_data__impl__fggpzb(other_3)));
              ULongArray__set_impl_z19mvh(result, 1, tmp$ret$35);
            } else {
              // Inline function 'kotlin.UInt.toULong' call
              var this_14 = UIntArray__get_impl_gp5kza(operand, 1);
              // Inline function 'kotlin.uintToULong' call
              // Inline function 'kotlin.uintToLong' call
              var value_7 = _UInt___get_data__impl__f0vqqw(this_14);
              var tmp$ret$36 = toLong(value_7).u3(new Long(-1, 0));
              // Inline function 'kotlin.ULong.shr' call
              var this_15 = _ULong___init__impl__c78o9k(tmp$ret$36);
              var tmp$ret$39 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_15).t3(31));
              ULongArray__set_impl_z19mvh(result, 1, tmp$ret$39);
            }
          }
        } else {
          if (i === 0) {
            // Inline function 'kotlin.UInt.toULong' call
            var this_16 = UIntArray__get_impl_gp5kza(operand, 0);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_8 = _UInt___get_data__impl__f0vqqw(this_16);
            var tmp$ret$40 = toLong(value_8).u3(new Long(-1, 0));
            var tmp40 = _ULong___init__impl__c78o9k(tmp$ret$40);
            // Inline function 'kotlin.UInt.toULong' call
            var this_17 = UIntArray__get_impl_gp5kza(operand, 1);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_9 = _UInt___get_data__impl__f0vqqw(this_17);
            var tmp$ret$43 = toLong(value_9).u3(new Long(-1, 0));
            // Inline function 'kotlin.ULong.shl' call
            var this_18 = _ULong___init__impl__c78o9k(tmp$ret$43);
            var tmp38 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_18).r3(32));
            // Inline function 'kotlin.ULong.and' call
            var other_4 = this.a58_1;
            // Inline function 'kotlin.ULong.or' call
            var other_5 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp38).u3(_ULong___get_data__impl__fggpzb(other_4)));
            var tmp$ret$48 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp40).v3(_ULong___get_data__impl__fggpzb(other_5)));
            ULongArray__set_impl_z19mvh(result, i, tmp$ret$48);
          } else if (1 <= i ? i < (requiredLength - 1 | 0) : false) {
            // Inline function 'kotlin.UInt.toULong' call
            var this_19 = UIntArray__get_impl_gp5kza(operand, position - 1 | 0);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_10 = _UInt___get_data__impl__f0vqqw(this_19);
            var tmp$ret$49 = toLong(value_10).u3(new Long(-1, 0));
            var tmp43 = _ULong___init__impl__c78o9k(tmp$ret$49);
            // Inline function 'kotlin.ULong.shr' call
            var bitCount = 32 - shiftAmount | 0;
            var tmp48 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp43).t3(bitCount));
            // Inline function 'kotlin.UInt.toULong' call
            var this_20 = UIntArray__get_impl_gp5kza(operand, position);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_11 = _UInt___get_data__impl__f0vqqw(this_20);
            var tmp$ret$53 = toLong(value_11).u3(new Long(-1, 0));
            // Inline function 'kotlin.ULong.shl' call
            var this_21 = _ULong___init__impl__c78o9k(tmp$ret$53);
            // Inline function 'kotlin.ULong.or' call
            var other_6 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_21).r3(shiftAmount));
            var tmp55 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp48).v3(_ULong___get_data__impl__fggpzb(other_6)));
            // Inline function 'kotlin.UInt.toULong' call
            var this_22 = UIntArray__get_impl_gp5kza(operand, position + 1 | 0);
            // Inline function 'kotlin.uintToULong' call
            // Inline function 'kotlin.uintToLong' call
            var value_12 = _UInt___get_data__impl__f0vqqw(this_22);
            var tmp$ret$58 = toLong(value_12).u3(new Long(-1, 0));
            var tmp51 = _ULong___init__impl__c78o9k(tmp$ret$58);
            // Inline function 'kotlin.ULong.shl' call
            var bitCount_0 = 32 + shiftAmount | 0;
            var tmp53 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp51).r3(bitCount_0));
            // Inline function 'kotlin.ULong.and' call
            var other_7 = this.a58_1;
            // Inline function 'kotlin.ULong.or' call
            var other_8 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp53).u3(_ULong___get_data__impl__fggpzb(other_7)));
            var tmp$ret$63 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp55).v3(_ULong___get_data__impl__fggpzb(other_8)));
            ULongArray__set_impl_z19mvh(result, i, tmp$ret$63);
          } else if (i === (requiredLength - 1 | 0)) {
            if (position < _UIntArray___get_size__impl__r6l8ci(operand)) {
              // Inline function 'kotlin.UInt.toULong' call
              var this_23 = UIntArray__get_impl_gp5kza(operand, position - 1 | 0);
              // Inline function 'kotlin.uintToULong' call
              // Inline function 'kotlin.uintToLong' call
              var value_13 = _UInt___get_data__impl__f0vqqw(this_23);
              var tmp$ret$64 = toLong(value_13).u3(new Long(-1, 0));
              var tmp58 = _ULong___init__impl__c78o9k(tmp$ret$64);
              // Inline function 'kotlin.ULong.shr' call
              var bitCount_1 = 32 - shiftAmount | 0;
              var tmp63 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp58).t3(bitCount_1));
              // Inline function 'kotlin.UInt.toULong' call
              var this_24 = UIntArray__get_impl_gp5kza(operand, position);
              // Inline function 'kotlin.uintToULong' call
              // Inline function 'kotlin.uintToLong' call
              var value_14 = _UInt___get_data__impl__f0vqqw(this_24);
              var tmp$ret$68 = toLong(value_14).u3(new Long(-1, 0));
              // Inline function 'kotlin.ULong.shl' call
              var this_25 = _ULong___init__impl__c78o9k(tmp$ret$68);
              // Inline function 'kotlin.ULong.or' call
              var other_9 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(this_25).r3(shiftAmount));
              var tmp$ret$72 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp63).v3(_ULong___get_data__impl__fggpzb(other_9)));
              ULongArray__set_impl_z19mvh(result, i, tmp$ret$72);
            } else {
              // Inline function 'kotlin.UInt.toULong' call
              var this_26 = UIntArray__get_impl_gp5kza(operand, position - 1 | 0);
              // Inline function 'kotlin.uintToULong' call
              // Inline function 'kotlin.uintToLong' call
              var value_15 = _UInt___get_data__impl__f0vqqw(this_26);
              var tmp$ret$73 = toLong(value_15).u3(new Long(-1, 0));
              var tmp66 = _ULong___init__impl__c78o9k(tmp$ret$73);
              // Inline function 'kotlin.ULong.shr' call
              var bitCount_2 = 32 - shiftAmount | 0;
              var tmp$ret$76 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp66).t3(bitCount_2));
              ULongArray__set_impl_z19mvh(result, i, tmp$ret$76);
            }
          }
        }
      }
       while (inductionVariable < requiredLength);
    return result;
  };
  protoOf(BigInteger63Arithmetic).s58 = function (first, second) {
    return this.g5c(first, second);
  };
  protoOf(BigInteger63Arithmetic).h5b = function (_this__u8e3s4, other) {
    return signedAdd(this, _this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).j5b = function (_this__u8e3s4, other) {
    return signedSubtract(this, _this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).g5b = function (_this__u8e3s4, other) {
    return signedMultiply(this, _this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).b5c = function (_this__u8e3s4, other) {
    return signedDivide(this, _this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).f5b = function (_this__u8e3s4, places) {
    return new SignedULongArray(this.f5c(_this__u8e3s4.k5b_1, places), _this__u8e3s4.l5b_1);
  };
  protoOf(BigInteger63Arithmetic).i5b = function (_this__u8e3s4, places) {
    return new SignedULongArray(this.b5b(_this__u8e3s4.k5b_1, places), _this__u8e3s4.l5b_1);
  };
  protoOf(BigInteger63Arithmetic).e5b = function (_this__u8e3s4, operand) {
    return new SignedULongArray(this.o5c(_this__u8e3s4.k5b_1, operand), _this__u8e3s4.l5b_1);
  };
  protoOf(BigInteger63Arithmetic).e57 = function (number, base) {
    var parsed = this.q57_1;
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.text.forEach' call
    var indexedObject = number.toLowerCase();
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(indexedObject)) {
      var element = charSequenceGet(indexedObject, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.parseForBase.<anonymous>' call
      var tmp = BigInteger63Arithmetic_getInstance();
      var tmp_0 = BigInteger63Arithmetic_getInstance();
      var tmp_1 = parsed;
      // Inline function 'kotlin.toULong' call
      var tmp$ret$2 = _ULong___init__impl__c78o9k(toLong(base));
      var tmp_2 = tmp_0.p5c(tmp_1, tmp$ret$2);
      // Inline function 'kotlin.toULong' call
      var this_0 = toDigit(element, base);
      var tmp$ret$3 = _ULong___init__impl__c78o9k(toLong(this_0));
      parsed = tmp.h5c(tmp_2, tmp$ret$3);
    }
    return this.h58(parsed);
  };
  protoOf(BigInteger63Arithmetic).z58 = function (operand, base) {
    // Inline function 'kotlin.collections.copyOf' call
    var copy = _ULongArray___init__impl__twm1l3(copyOf_7(_ULongArray___get_storage__impl__28e64j(operand)));
    // Inline function 'kotlin.toULong' call
    var tmp$ret$1 = _ULong___init__impl__c78o9k(toLong(base));
    // Inline function 'kotlin.ulongArrayOf' call
    var baseArray = _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$1]));
    var stringBuilder = StringBuilder_init_$Create$_1();
    while (!equals(copy, this.q57_1)) {
      var divremResult = this.q5c(copy, baseArray);
      if (ULongArray__isEmpty_impl_c3yngu(divremResult.eh_1.on_1)) {
        stringBuilder.ad(0);
      } else {
        stringBuilder.d9(toString_6(ULongArray__get_impl_pr71q9(divremResult.eh_1.on_1, 0), base));
      }
      copy = divremResult.dh_1.on_1;
    }
    // Inline function 'kotlin.text.reversed' call
    var this_0 = stringBuilder.toString();
    return toString_1(reversed_1(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  };
  protoOf(BigInteger63Arithmetic).o5c = function (operand, mask) {
    var tmp;
    if (_ULongArray___get_size__impl__ju6dtr(operand) > _ULongArray___get_size__impl__ju6dtr(mask)) {
      tmp = new Pair(new ULongArray(operand), new ULongArray(mask));
    } else {
      tmp = new Pair(new ULongArray(mask), new ULongArray(operand));
    }
    var _destruct__k2r9zo = tmp;
    var bigger = _destruct__k2r9zo.ug().on_1;
    var smaller = _destruct__k2r9zo.vg().on_1;
    // Inline function 'kotlin.ULongArray' call
    var tmp_0 = 0;
    var tmp_1 = _ULongArray___get_size__impl__ju6dtr(smaller);
    var tmp_2 = longArray(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      // Inline function 'com.ionspin.kotlin.bignum.integer.base63.array.BigInteger63Arithmetic.and.<anonymous>' call
      var tmp0 = ULongArray__get_impl_pr71q9(operand, tmp_3);
      // Inline function 'kotlin.ULong.and' call
      var other = ULongArray__get_impl_pr71q9(mask, tmp_3);
      // Inline function 'kotlin.ULong.toLong' call
      var this_0 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp0).u3(_ULong___get_data__impl__fggpzb(other)));
      tmp_2[tmp_3] = _ULong___get_data__impl__fggpzb(this_0);
      tmp_0 = tmp_0 + 1 | 0;
    }
    return _ULongArray___init__impl__twm1l3(tmp_2);
  };
  protoOf(BigInteger63Arithmetic).b5b = function (_this__u8e3s4, places) {
    return this.v5b(_this__u8e3s4, places);
  };
  protoOf(BigInteger63Arithmetic).f5c = function (_this__u8e3s4, places) {
    return this.w5b(_this__u8e3s4, places);
  };
  protoOf(BigInteger63Arithmetic).c5b = function (_this__u8e3s4, other) {
    return this.k58(_this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).p5b = function (_this__u8e3s4, other) {
    return this.j58(_this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).q5b = function (_this__u8e3s4, other) {
    return this.q58(_this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).h5c = function (_this__u8e3s4, other) {
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp$ret$0 = _ULongArray___init__impl__twm1l3(longArrayOf([other]));
    return this.k58(_this__u8e3s4, tmp$ret$0);
  };
  protoOf(BigInteger63Arithmetic).d5b = function (_this__u8e3s4, other) {
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp$ret$0 = _ULongArray___init__impl__twm1l3(longArrayOf([other]));
    return this.j58(_this__u8e3s4, tmp$ret$0);
  };
  protoOf(BigInteger63Arithmetic).p5c = function (_this__u8e3s4, other) {
    return this.a5b(_this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).r5b = function (_this__u8e3s4, other) {
    return this.s58(_this__u8e3s4, other).dh_1.on_1;
  };
  protoOf(BigInteger63Arithmetic).q5c = function (_this__u8e3s4, other) {
    return this.s58(_this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).x58 = function (_this__u8e3s4, other) {
    return this.n57(_this__u8e3s4, other);
  };
  protoOf(BigInteger63Arithmetic).k5c = function (_this__u8e3s4, other) {
    // Inline function 'kotlin.ulongArrayOf' call
    var tmp$ret$0 = _ULongArray___init__impl__twm1l3(longArrayOf([other]));
    return this.n57(_this__u8e3s4, tmp$ret$0);
  };
  protoOf(BigInteger63Arithmetic).i5c = function (_this__u8e3s4) {
    return this.m5c(_this__u8e3s4);
  };
  protoOf(BigInteger63Arithmetic).j5c = function (_this__u8e3s4) {
    return this.n5c(_this__u8e3s4);
  };
  protoOf(BigInteger63Arithmetic).g57 = function (uLong) {
    var tmp;
    // Inline function 'kotlin.ULong.and' call
    var other = this.b58_1;
    var tmp$ret$0 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(uLong).u3(_ULong___get_data__impl__fggpzb(other)));
    if (!equals(tmp$ret$0, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      // Inline function 'kotlin.ULong.and' call
      var other_0 = this.x57_1;
      var tmp$ret$1 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(uLong).u3(_ULong___get_data__impl__fggpzb(other_0)));
      // Inline function 'kotlin.ulongArrayOf' call
      tmp = _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$1, _ULong___init__impl__c78o9k(new Long(1, 0))]));
    } else {
      // Inline function 'kotlin.ulongArrayOf' call
      tmp = _ULongArray___init__impl__twm1l3(longArrayOf([uLong]));
    }
    return tmp;
  };
  protoOf(BigInteger63Arithmetic).i57 = function (uInt) {
    // Inline function 'kotlin.UInt.toULong' call
    // Inline function 'kotlin.uintToULong' call
    // Inline function 'kotlin.uintToLong' call
    var value = _UInt___get_data__impl__f0vqqw(uInt);
    var tmp$ret$0 = toLong(value).u3(new Long(-1, 0));
    var tmp$ret$2 = _ULong___init__impl__c78o9k(tmp$ret$0);
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$2]));
  };
  protoOf(BigInteger63Arithmetic).k57 = function (uShort) {
    // Inline function 'kotlin.UShort.toULong' call
    var tmp$ret$0 = _ULong___init__impl__c78o9k(toLong(_UShort___get_data__impl__g0245(uShort)).u3(new Long(65535, 0)));
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$0]));
  };
  protoOf(BigInteger63Arithmetic).m57 = function (uByte) {
    // Inline function 'kotlin.UByte.toULong' call
    var tmp$ret$0 = _ULong___init__impl__c78o9k(toLong(_UByte___get_data__impl__jof9qr(uByte)).u3(new Long(255, 0)));
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$0]));
  };
  protoOf(BigInteger63Arithmetic).w56 = function (long) {
    if (long.equals(new Long(0, -2147483648))) {
      // Inline function 'kotlin.ulongArrayOf' call
      return _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(0, 0)), _ULong___init__impl__c78o9k(new Long(1, 0))]));
    }
    // Inline function 'kotlin.math.absoluteValue' call
    // Inline function 'kotlin.toULong' call
    var this_0 = abs_0(long);
    var tmp3 = _ULong___init__impl__c78o9k(this_0);
    // Inline function 'kotlin.ULong.and' call
    var other = this.x57_1;
    var tmp$ret$3 = _ULong___init__impl__c78o9k(_ULong___get_data__impl__fggpzb(tmp3).u3(_ULong___get_data__impl__fggpzb(other)));
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$3]));
  };
  protoOf(BigInteger63Arithmetic).x56 = function (int) {
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = toLong(int);
    // Inline function 'kotlin.toULong' call
    var this_1 = abs_0(this_0);
    var tmp$ret$1 = _ULong___init__impl__c78o9k(this_1);
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$1]));
  };
  protoOf(BigInteger63Arithmetic).y56 = function (short) {
    // Inline function 'kotlin.math.absoluteValue' call
    // Inline function 'kotlin.toULong' call
    var this_0 = abs(short);
    var tmp$ret$1 = _ULong___init__impl__c78o9k(toLong(this_0));
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$1]));
  };
  protoOf(BigInteger63Arithmetic).z56 = function (byte) {
    // Inline function 'kotlin.math.absoluteValue' call
    // Inline function 'kotlin.toULong' call
    var this_0 = abs(byte);
    var tmp$ret$1 = _ULong___init__impl__c78o9k(toLong(this_0));
    // Inline function 'kotlin.ulongArrayOf' call
    return _ULongArray___init__impl__twm1l3(longArrayOf([tmp$ret$1]));
  };
  var BigInteger63Arithmetic_instance;
  function BigInteger63Arithmetic_getInstance() {
    if (BigInteger63Arithmetic_instance == null)
      new BigInteger63Arithmetic();
    return BigInteger63Arithmetic_instance;
  }
  function toDigit(_this__u8e3s4, base) {
    base = base === VOID ? 10 : base;
    var tmp;
    if (_Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false) {
      tmp = Char__toInt_impl_vasixd(Char__minus_impl_a2frrh_0(_this__u8e3s4, 48));
    } else if (_Char___init__impl__6a9atx(97) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(122) : false) {
      tmp = Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(97)) + 10 | 0;
    } else if (_Char___init__impl__6a9atx(65) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(90) : false) {
      tmp = Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(65)) + 10 | 0;
    } else if (_Char___init__impl__6a9atx(65313) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(65338) : false) {
      tmp = Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(65313)) - 10 | 0;
    } else if (_Char___init__impl__6a9atx(65345) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(65370) : false) {
      tmp = Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(65345)) - 10 | 0;
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(46)) {
      throw NumberFormatException_init_$Create$_0('Invalid digit for radix ' + toString(_this__u8e3s4) + ' (Possibly a decimal value, which is not supported by BigInteger parser');
    } else {
      throw NumberFormatException_init_$Create$_0('Invalid digit for radix ' + toString(_this__u8e3s4));
    }
    var digit = tmp;
    if (digit < 0 || digit >= base) {
      throw NumberFormatException_init_$Create$_0(toString(_this__u8e3s4) + ' is not a valid digit for number system with base ' + base);
    }
    return digit;
  }
  function RuntimePlatform() {
  }
  protoOf(RuntimePlatform).r56 = function () {
    return Platform_JS_getInstance();
  };
  var RuntimePlatform_instance;
  function RuntimePlatform_getInstance() {
    return RuntimePlatform_instance;
  }
  function serializer($this, serializersModule) {
    var tmp0_elvis_lhs = serializersModule.v5c($this.r5c_1, $this.t5c_1);
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? $this.s5c_1 : tmp0_elvis_lhs;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      serializerNotRegistered($this.r5c_1);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function ContextualSerializer$descriptor$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      var tmp = $this$buildSerialDescriptor;
      var tmp0_safe_receiver = this$0.s5c_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w5c();
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.x5c();
      tmp.a5d_1 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      return Unit_instance;
    };
  }
  function ContextualSerializer(serializableClass, fallbackSerializer, typeArgumentsSerializers) {
    this.r5c_1 = serializableClass;
    this.s5c_1 = fallbackSerializer;
    this.t5c_1 = asList(typeArgumentsSerializers);
    var tmp = this;
    var tmp_0 = CONTEXTUAL_getInstance();
    tmp.u5c_1 = withContext_0(buildSerialDescriptor('kotlinx.serialization.ContextualSerializer', tmp_0, [], ContextualSerializer$descriptor$lambda(this)), this.r5c_1);
  }
  protoOf(ContextualSerializer).w5c = function () {
    return this.u5c_1;
  };
  protoOf(ContextualSerializer).g5d = function (encoder, value) {
    encoder.i5d(serializer(this, encoder.h5d()), value);
  };
  protoOf(ContextualSerializer).j5d = function (encoder, value) {
    return this.g5d(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(ContextualSerializer).k5d = function (decoder) {
    return decoder.l5d(serializer(this, decoder.h5d()));
  };
  function KSerializer() {
  }
  function SerializationStrategy() {
  }
  function DeserializationStrategy() {
  }
  function PolymorphicSerializer_init_$Init$(baseClass, classAnnotations, $this) {
    PolymorphicSerializer.call($this, baseClass);
    $this.n5d_1 = asList(classAnnotations);
    return $this;
  }
  function PolymorphicSerializer_init_$Create$(baseClass, classAnnotations) {
    return PolymorphicSerializer_init_$Init$(baseClass, classAnnotations, objectCreate(protoOf(PolymorphicSerializer)));
  }
  function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.p5d('type', serializer_3(StringCompanionObject_instance).w5c());
      $this$buildSerialDescriptor.p5d('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.m5d_1.lb() + '>', CONTEXTUAL_getInstance(), []));
      $this$buildSerialDescriptor.a5d_1 = this$0.n5d_1;
      return Unit_instance;
    };
  }
  function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
    return function () {
      var tmp = OPEN_getInstance();
      return withContext_0(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.m5d_1);
    };
  }
  function PolymorphicSerializer(baseClass) {
    AbstractPolymorphicSerializer.call(this);
    this.m5d_1 = baseClass;
    this.n5d_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o5d_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
  }
  protoOf(PolymorphicSerializer).q5d = function () {
    return this.m5d_1;
  };
  protoOf(PolymorphicSerializer).w5c = function () {
    var tmp0 = this.o5d_1;
    // Inline function 'kotlin.getValue' call
    descriptor$factory();
    return tmp0.y();
  };
  protoOf(PolymorphicSerializer).toString = function () {
    return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString_1(this.m5d_1) + ')';
  };
  function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
    var tmp0_elvis_lhs = _this__u8e3s4.s5d(encoder, value);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.q5d());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
    var tmp0_elvis_lhs = _this__u8e3s4.r5d(decoder, klassName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.q5d());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function descriptor$factory() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.w5c();
    }, null);
  }
  function SealedClassSerializer_init_$Init$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations, $this) {
    SealedClassSerializer.call($this, serialName, baseClass, subclasses, subclassSerializers);
    $this.u5d_1 = asList(classAnnotations);
    return $this;
  }
  function SealedClassSerializer_init_$Create$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations) {
    return SealedClassSerializer_init_$Init$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations, objectCreate(protoOf(SealedClassSerializer)));
  }
  function SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = this$0.x5d_1.w().k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlinx.serialization.SealedClassSerializer.descriptor$delegate.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var name = element.x();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element.y();
        $this$buildSerialDescriptor.p5d(name, serializer.w5c());
      }
      return Unit_instance;
    };
  }
  function SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.p5d('type', serializer_3(StringCompanionObject_instance).w5c());
      var tmp = 'kotlinx.serialization.Sealed<' + this$0.t5d_1.lb() + '>';
      var tmp_0 = CONTEXTUAL_getInstance();
      var elementDescriptor = buildSerialDescriptor(tmp, tmp_0, [], SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0));
      $this$buildSerialDescriptor.p5d('value', elementDescriptor);
      $this$buildSerialDescriptor.a5d_1 = this$0.u5d_1;
      return Unit_instance;
    };
  }
  function SealedClassSerializer$descriptor$delegate$lambda($serialName, this$0) {
    return function () {
      var tmp = SEALED_getInstance();
      return buildSerialDescriptor($serialName, tmp, [], SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0));
    };
  }
  function SealedClassSerializer$$inlined$groupingBy$1($this) {
    this.y5d_1 = $this;
  }
  protoOf(SealedClassSerializer$$inlined$groupingBy$1).z5d = function () {
    return this.y5d_1.k();
  };
  protoOf(SealedClassSerializer$$inlined$groupingBy$1).a5e = function (element) {
    // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
    return element.y().w5c().b5e();
  };
  protoOf(SealedClassSerializer$$inlined$groupingBy$1).c5e = function (element) {
    return this.a5e((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function SealedClassSerializer(serialName, baseClass, subclasses, subclassSerializers) {
    AbstractPolymorphicSerializer.call(this);
    this.t5d_1 = baseClass;
    this.u5d_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.v5d_1 = lazy(tmp_0, SealedClassSerializer$descriptor$delegate$lambda(serialName, this));
    if (!(subclasses.length === subclassSerializers.length)) {
      throw IllegalArgumentException_init_$Create$_0('All subclasses of sealed class ' + this.t5d_1.lb() + ' should be marked @Serializable');
    }
    this.w5d_1 = toMap(zip(subclasses, subclassSerializers));
    var tmp_1 = this;
    // Inline function 'kotlin.collections.groupingBy' call
    var this_0 = this.w5d_1.w();
    // Inline function 'kotlin.collections.aggregate' call
    var tmp0 = new SealedClassSerializer$$inlined$groupingBy$1(this_0);
    // Inline function 'kotlin.collections.mutableMapOf' call
    // Inline function 'kotlin.collections.aggregateTo' call
    var destination = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = tmp0.z5d();
    while (_iterator__ex2g4s.l()) {
      var e = _iterator__ex2g4s.m();
      var key = tmp0.c5e(e);
      var accumulator = destination.y2(key);
      // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
      accumulator == null && !destination.w2(key);
      if (!(accumulator == null)) {
        // Inline function 'kotlin.error' call
        var message = "Multiple sealed subclasses of '" + toString_1(this.t5d_1) + "' have the same serial name '" + key + "':" + (" '" + toString_1(accumulator.x()) + "', '" + toString_1(e.x()) + "'");
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      // Inline function 'kotlin.collections.set' call
      destination.r2(key, e);
    }
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination_0 = LinkedHashMap_init_$Create$_0(mapCapacity(destination.n()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_0 = destination.w().k();
    while (_iterator__ex2g4s_0.l()) {
      var element = _iterator__ex2g4s_0.m();
      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
      var tmp_2 = element.x();
      // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
      var tmp$ret$7 = element.y().y();
      destination_0.r2(tmp_2, tmp$ret$7);
    }
    tmp_1.x5d_1 = destination_0;
  }
  protoOf(SealedClassSerializer).q5d = function () {
    return this.t5d_1;
  };
  protoOf(SealedClassSerializer).w5c = function () {
    var tmp0 = this.v5d_1;
    // Inline function 'kotlin.getValue' call
    descriptor$factory_0();
    return tmp0.y();
  };
  protoOf(SealedClassSerializer).r5d = function (decoder, klassName) {
    // Inline function 'kotlin.collections.get' call
    var this_0 = this.x5d_1;
    var tmp0_elvis_lhs = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).y2(klassName);
    return tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).r5d.call(this, decoder, klassName) : tmp0_elvis_lhs;
  };
  protoOf(SealedClassSerializer).s5d = function (encoder, value) {
    var tmp0_elvis_lhs = this.w5d_1.y2(getKClassFromExpression(value));
    var tmp1_safe_receiver = tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).s5d.call(this, encoder, value) : tmp0_elvis_lhs;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, SerializationStrategy) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  };
  function descriptor$factory_0() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.w5c();
    }, null);
  }
  function BinaryFormat() {
  }
  function StringFormat() {
  }
  function SerializationException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$() {
    var tmp = SerializationException_init_$Init$(objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$);
    return tmp;
  }
  function SerializationException_init_$Init$_0(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$_0(message) {
    var tmp = SerializationException_init_$Init$_0(message, objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$_0);
    return tmp;
  }
  function SerializationException_init_$Init$_1(message, cause, $this) {
    IllegalArgumentException_init_$Init$_1(message, cause, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException() {
    captureStack(this, SerializationException);
  }
  function UnknownFieldException_init_$Init$(index, $this) {
    UnknownFieldException.call($this, 'An unknown field for index ' + index);
    return $this;
  }
  function UnknownFieldException_init_$Create$(index) {
    var tmp = UnknownFieldException_init_$Init$(index, objectCreate(protoOf(UnknownFieldException)));
    captureStack(tmp, UnknownFieldException_init_$Create$);
    return tmp;
  }
  function UnknownFieldException(message) {
    SerializationException_init_$Init$_0(message, this);
    captureStack(this, UnknownFieldException);
  }
  function MissingFieldException_init_$Init$(missingFields, serialName, $this) {
    MissingFieldException.call($this, missingFields, missingFields.n() === 1 ? "Field '" + missingFields.q(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString_1(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing", null);
    return $this;
  }
  function MissingFieldException_init_$Create$(missingFields, serialName) {
    var tmp = MissingFieldException_init_$Init$(missingFields, serialName, objectCreate(protoOf(MissingFieldException)));
    captureStack(tmp, MissingFieldException_init_$Create$);
    return tmp;
  }
  function MissingFieldException(missingFields, message, cause) {
    SerializationException_init_$Init$_1(message, cause, this);
    captureStack(this, MissingFieldException);
    this.h5e_1 = missingFields;
  }
  function serializerOrNull(_this__u8e3s4) {
    var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
    var tmp;
    if (failOnMissingTypeArgSerializer) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(typeArguments, 10));
      var _iterator__ex2g4s = typeArguments.k();
      while (_iterator__ex2g4s.l()) {
        var item = _iterator__ex2g4s.m();
        // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
        var tmp$ret$0 = serializer_0(_this__u8e3s4, item);
        destination.e(tmp$ret$0);
      }
      tmp = destination;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(typeArguments, 10));
      var _iterator__ex2g4s_0 = typeArguments.k();
      while (_iterator__ex2g4s_0.l()) {
        var item_0 = _iterator__ex2g4s_0.m();
        // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
        var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$3 = tmp_0;
        destination_0.e(tmp$ret$3);
      }
      tmp = destination_0;
    }
    var serializers = tmp;
    return serializers;
  }
  function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
    return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
  }
  function serializer_0(_this__u8e3s4, type) {
    var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      platformSpecificSerializerNotRegistered(kclass(type));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerOrNull_0(_this__u8e3s4, type) {
    return serializerByKTypeImpl(_this__u8e3s4, type, false);
  }
  function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp;
    if (((_this__u8e3s4.equals(getKClass(Collection)) ? true : _this__u8e3s4.equals(getKClass(KtList))) ? true : _this__u8e3s4.equals(getKClass(KtMutableList))) ? true : _this__u8e3s4.equals(getKClass(ArrayList))) {
      tmp = new ArrayListSerializer(serializers.q(0));
    } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
      tmp = new HashSetSerializer(serializers.q(0));
    } else if ((_this__u8e3s4.equals(getKClass(KtSet)) ? true : _this__u8e3s4.equals(getKClass(KtMutableSet))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashSet))) {
      tmp = new LinkedHashSetSerializer(serializers.q(0));
    } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
      tmp = new HashMapSerializer(serializers.q(0), serializers.q(1));
    } else if ((_this__u8e3s4.equals(getKClass(KtMap)) ? true : _this__u8e3s4.equals(getKClass(KtMutableMap))) ? true : _this__u8e3s4.equals(getKClass(LinkedHashMap))) {
      tmp = new LinkedHashMapSerializer(serializers.q(0), serializers.q(1));
    } else if (_this__u8e3s4.equals(getKClass(Entry))) {
      tmp = MapEntrySerializer(serializers.q(0), serializers.q(1));
    } else if (_this__u8e3s4.equals(getKClass(Pair))) {
      tmp = PairSerializer(serializers.q(0), serializers.q(1));
    } else if (_this__u8e3s4.equals(getKClass(Triple))) {
      tmp = TripleSerializer(serializers.q(0), serializers.q(1), serializers.q(2));
    } else {
      var tmp_0;
      if (isReferenceArray(_this__u8e3s4)) {
        var tmp_1 = elementClassifierIfArray();
        tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.q(0));
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(serializers);
    return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
  }
  function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
    var rootClass = kclass(type);
    var isNullable = type.cc();
    // Inline function 'kotlin.collections.map' call
    var this_0 = type.bc();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'kotlinx.serialization.serializerByKTypeImpl.<anonymous>' call
      var tmp0 = item.pk_1;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0 == null) {
          // Inline function 'kotlinx.serialization.serializerByKTypeImpl.<anonymous>.<anonymous>' call
          var message = 'Star projections in type arguments are not allowed, but had ' + toString_1(type);
          throw IllegalArgumentException_init_$Create$_0(toString_1(message));
        } else {
          tmp$ret$1 = tmp0;
          break $l$block;
        }
      }
      var tmp$ret$2 = tmp$ret$1;
      destination.e(tmp$ret$2);
    }
    var typeArguments = destination;
    var tmp;
    if (typeArguments.p()) {
      tmp = findCachedSerializer(rootClass, isNullable);
    } else {
      var cachedResult = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
      var tmp_0;
      if (failOnMissingTypeArgSerializer) {
        // Inline function 'kotlin.Result.getOrNull' call
        var tmp_1;
        if (_Result___get_isFailure__impl__jpiriv(cachedResult)) {
          tmp_1 = null;
        } else {
          var tmp_2 = _Result___get_value__impl__bjfvqg(cachedResult);
          tmp_1 = (tmp_2 == null ? true : !(tmp_2 == null)) ? tmp_2 : THROW_CCE();
        }
        tmp_0 = tmp_1;
      } else {
        // Inline function 'kotlin.getOrElse' call
        var exception = Result__exceptionOrNull_impl_p6xea9(cachedResult);
        var tmp_3;
        if (exception == null) {
          var tmp_4 = _Result___get_value__impl__bjfvqg(cachedResult);
          tmp_3 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
        } else {
          return null;
        }
        tmp_0 = tmp_3;
      }
      tmp = tmp_0;
    }
    var cachedSerializer = tmp;
    if (cachedSerializer == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return cachedSerializer;
    }
    var tmp_5;
    if (typeArguments.p()) {
      tmp_5 = _this__u8e3s4.i5e(rootClass);
    } else {
      var tmp1_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
      var tmp_6;
      if (tmp1_elvis_lhs == null) {
        return null;
      } else {
        tmp_6 = tmp1_elvis_lhs;
      }
      var serializers = tmp_6;
      var tmp2_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
      tmp_5 = tmp2_elvis_lhs == null ? _this__u8e3s4.v5c(rootClass, serializers) : tmp2_elvis_lhs;
    }
    var contextualSerializer = tmp_5;
    var tmp_7;
    if (contextualSerializer == null) {
      tmp_7 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_7 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
    }
    var tmp4_safe_receiver = tmp_7;
    return tmp4_safe_receiver == null ? null : nullable(tmp4_safe_receiver, isNullable);
  }
  function nullable(_this__u8e3s4, shouldBeNullable) {
    if (shouldBeNullable)
      return get_nullable(_this__u8e3s4);
    return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  }
  function serializer_1(type) {
    return serializer_0(EmptySerializersModule_0(), type);
  }
  function serializer_2(_this__u8e3s4) {
    var tmp0_elvis_lhs = serializerOrNull(_this__u8e3s4);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      serializerNotRegistered(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerByKTypeImpl$lambda($typeArguments) {
    return function () {
      return $typeArguments.q(0).ac();
    };
  }
  function get_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE;
  }
  var SERIALIZERS_CACHE;
  function get_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE_NULLABLE;
  }
  var SERIALIZERS_CACHE_NULLABLE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  function findCachedSerializer(clazz, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp0_safe_receiver = get_SERIALIZERS_CACHE().j5e(clazz);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlinx.serialization.internal.cast' call
        tmp_0 = isInterface(tmp0_safe_receiver, KSerializer) ? tmp0_safe_receiver : THROW_CCE();
      }
      tmp = tmp_0;
    } else {
      tmp = get_SERIALIZERS_CACHE_NULLABLE().j5e(clazz);
    }
    return tmp;
  }
  function findParametrizedCachedSerializer(clazz, types, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().k5e(clazz, types);
      tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
    } else {
      tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().k5e(clazz, types);
    }
    return tmp;
  }
  function SERIALIZERS_CACHE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    return serializerOrNull(it);
  }
  function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp0_safe_receiver = serializerOrNull(it);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
    return function () {
      return $types.q(0).ac();
    };
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
    return function () {
      return $types.q(0).ac();
    };
  }
  var properties_initialized_SerializersCache_kt_q8kf25;
  function _init_properties_SerializersCache_kt__hgwi2p() {
    if (!properties_initialized_SerializersCache_kt_q8kf25) {
      properties_initialized_SerializersCache_kt_q8kf25 = true;
      SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
      SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
    }
  }
  function get_nullable(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.w5c().l5e()) {
      tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
    } else {
      tmp = new NullableSerializer(_this__u8e3s4);
    }
    return tmp;
  }
  function serializer_3(_this__u8e3s4) {
    return StringSerializer_getInstance();
  }
  function serializer_4(_this__u8e3s4) {
    return CharSerializer_getInstance();
  }
  function CharArraySerializer() {
    return CharArraySerializer_getInstance();
  }
  function serializer_5(_this__u8e3s4) {
    return DoubleSerializer_getInstance();
  }
  function DoubleArraySerializer() {
    return DoubleArraySerializer_getInstance();
  }
  function serializer_6(_this__u8e3s4) {
    return FloatSerializer_getInstance();
  }
  function FloatArraySerializer() {
    return FloatArraySerializer_getInstance();
  }
  function serializer_7(_this__u8e3s4) {
    return LongSerializer_getInstance();
  }
  function LongArraySerializer() {
    return LongArraySerializer_getInstance();
  }
  function serializer_8(_this__u8e3s4) {
    return ULongSerializer_getInstance();
  }
  function ULongArraySerializer() {
    return ULongArraySerializer_getInstance();
  }
  function serializer_9(_this__u8e3s4) {
    return IntSerializer_getInstance();
  }
  function IntArraySerializer() {
    return IntArraySerializer_getInstance();
  }
  function serializer_10(_this__u8e3s4) {
    return UIntSerializer_getInstance();
  }
  function UIntArraySerializer() {
    return UIntArraySerializer_getInstance();
  }
  function serializer_11(_this__u8e3s4) {
    return ShortSerializer_getInstance();
  }
  function ShortArraySerializer() {
    return ShortArraySerializer_getInstance();
  }
  function serializer_12(_this__u8e3s4) {
    return UShortSerializer_getInstance();
  }
  function UShortArraySerializer() {
    return UShortArraySerializer_getInstance();
  }
  function serializer_13(_this__u8e3s4) {
    return ByteSerializer_getInstance();
  }
  function ByteArraySerializer() {
    return ByteArraySerializer_getInstance();
  }
  function serializer_14(_this__u8e3s4) {
    return UByteSerializer_getInstance();
  }
  function UByteArraySerializer() {
    return UByteArraySerializer_getInstance();
  }
  function serializer_15(_this__u8e3s4) {
    return BooleanSerializer_getInstance();
  }
  function BooleanArraySerializer() {
    return BooleanArraySerializer_getInstance();
  }
  function serializer_16(_this__u8e3s4) {
    return UnitSerializer_getInstance();
  }
  function NothingSerializer() {
    return NothingSerializer_getInstance();
  }
  function serializer_17(_this__u8e3s4) {
    return DurationSerializer_getInstance();
  }
  function MapEntrySerializer(keySerializer, valueSerializer) {
    return new MapEntrySerializer_0(keySerializer, valueSerializer);
  }
  function PairSerializer(keySerializer, valueSerializer) {
    return new PairSerializer_0(keySerializer, valueSerializer);
  }
  function TripleSerializer(aSerializer, bSerializer, cSerializer) {
    return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
  }
  function ArraySerializer(kClass, elementSerializer) {
    return new ReferenceArraySerializer(kClass, elementSerializer);
  }
  function ListSerializer(elementSerializer) {
    return new ArrayListSerializer(elementSerializer);
  }
  function SetSerializer(elementSerializer) {
    return new LinkedHashSetSerializer(elementSerializer);
  }
  function MapSerializer(keySerializer, valueSerializer) {
    return new LinkedHashMapSerializer(keySerializer, valueSerializer);
  }
  function withContext_0(_this__u8e3s4, context) {
    return new ContextDescriptor(_this__u8e3s4, context);
  }
  function ContextDescriptor(original, kClass) {
    this.m5e_1 = original;
    this.n5e_1 = kClass;
    this.o5e_1 = this.m5e_1.b5e() + '<' + this.n5e_1.lb() + '>';
  }
  protoOf(ContextDescriptor).x5c = function () {
    return this.m5e_1.x5c();
  };
  protoOf(ContextDescriptor).p5e = function () {
    return this.m5e_1.p5e();
  };
  protoOf(ContextDescriptor).q5e = function () {
    return this.m5e_1.q5e();
  };
  protoOf(ContextDescriptor).l5e = function () {
    return this.m5e_1.l5e();
  };
  protoOf(ContextDescriptor).r5e = function () {
    return this.m5e_1.r5e();
  };
  protoOf(ContextDescriptor).s5e = function (index) {
    return this.m5e_1.s5e(index);
  };
  protoOf(ContextDescriptor).t5e = function (index) {
    return this.m5e_1.t5e(index);
  };
  protoOf(ContextDescriptor).u5e = function (name) {
    return this.m5e_1.u5e(name);
  };
  protoOf(ContextDescriptor).v5e = function (index) {
    return this.m5e_1.v5e(index);
  };
  protoOf(ContextDescriptor).w5e = function (index) {
    return this.m5e_1.w5e(index);
  };
  protoOf(ContextDescriptor).b5e = function () {
    return this.o5e_1;
  };
  protoOf(ContextDescriptor).equals = function (other) {
    var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var another = tmp;
    return equals(this.m5e_1, another.m5e_1) && another.n5e_1.equals(this.n5e_1);
  };
  protoOf(ContextDescriptor).hashCode = function () {
    var result = this.n5e_1.hashCode();
    result = imul(31, result) + getStringHashCode(this.o5e_1) | 0;
    return result;
  };
  protoOf(ContextDescriptor).toString = function () {
    return 'ContextDescriptor(kClass: ' + toString_1(this.n5e_1) + ', original: ' + toString_1(this.m5e_1) + ')';
  };
  function getContextualDescriptor(_this__u8e3s4, descriptor) {
    var tmp0_safe_receiver = get_capturedKClass(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.serialization.descriptors.getContextualDescriptor.<anonymous>' call
      var tmp0_safe_receiver_0 = _this__u8e3s4.i5e(tmp0_safe_receiver);
      tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.w5c();
    }
    return tmp;
  }
  function get_capturedKClass(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ContextDescriptor) {
      tmp = _this__u8e3s4.n5e_1;
    } else {
      if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
        tmp = get_capturedKClass(_this__u8e3s4.x5e_1);
      } else {
        tmp = null;
      }
    }
    return tmp;
  }
  function SerialDescriptor() {
  }
  function get_elementDescriptors(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new elementDescriptors$$inlined$Iterable$1(_this__u8e3s4);
  }
  function get_elementNames(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new elementNames$$inlined$Iterable$1(_this__u8e3s4);
  }
  function elementDescriptors$1($this_elementDescriptors) {
    this.b5f_1 = $this_elementDescriptors;
    this.a5f_1 = $this_elementDescriptors.p5e();
  }
  protoOf(elementDescriptors$1).l = function () {
    return this.a5f_1 > 0;
  };
  protoOf(elementDescriptors$1).m = function () {
    var tmp = this.b5f_1.p5e();
    var tmp1 = this.a5f_1;
    this.a5f_1 = tmp1 - 1 | 0;
    return this.b5f_1.t5e(tmp - tmp1 | 0);
  };
  function elementDescriptors$$inlined$Iterable$1($this_elementDescriptors) {
    this.c5f_1 = $this_elementDescriptors;
  }
  protoOf(elementDescriptors$$inlined$Iterable$1).k = function () {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementDescriptors>.<anonymous>' call
    return new elementDescriptors$1(this.c5f_1);
  };
  function elementNames$1($this_elementNames) {
    this.e5f_1 = $this_elementNames;
    this.d5f_1 = $this_elementNames.p5e();
  }
  protoOf(elementNames$1).l = function () {
    return this.d5f_1 > 0;
  };
  protoOf(elementNames$1).m = function () {
    var tmp = this.e5f_1.p5e();
    var tmp1 = this.d5f_1;
    this.d5f_1 = tmp1 - 1 | 0;
    return this.e5f_1.v5e(tmp - tmp1 | 0);
  };
  function elementNames$$inlined$Iterable$1($this_elementNames) {
    this.f5f_1 = $this_elementNames;
  }
  protoOf(elementNames$$inlined$Iterable$1).k = function () {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementNames>.<anonymous>' call
    return new elementNames$1(this.f5f_1);
  };
  function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
    var tmp;
    if (builder === VOID) {
      tmp = buildSerialDescriptor$lambda;
    } else {
      tmp = builder;
    }
    builder = tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!!equals(kind, CLASS_getInstance())) {
      // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
      var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builder(sdBuilder);
    return new SerialDescriptorImpl(serialName, kind, sdBuilder.b5d_1.n(), toList(typeParameters), sdBuilder);
  }
  function ClassSerialDescriptorBuilder(serialName) {
    this.y5c_1 = serialName;
    this.z5c_1 = false;
    this.a5d_1 = emptyList();
    this.b5d_1 = ArrayList_init_$Create$();
    this.c5d_1 = HashSet_init_$Create$();
    this.d5d_1 = ArrayList_init_$Create$();
    this.e5d_1 = ArrayList_init_$Create$();
    this.f5d_1 = ArrayList_init_$Create$();
  }
  protoOf(ClassSerialDescriptorBuilder).g5f = function (elementName, descriptor, annotations, isOptional) {
    // Inline function 'kotlin.require' call
    if (!this.c5d_1.e(elementName)) {
      // Inline function 'kotlinx.serialization.descriptors.ClassSerialDescriptorBuilder.element.<anonymous>' call
      var message = "Element with name '" + elementName + "' is already registered in " + this.y5c_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.collections.plusAssign' call
    this.b5d_1.e(elementName);
    // Inline function 'kotlin.collections.plusAssign' call
    this.d5d_1.e(descriptor);
    // Inline function 'kotlin.collections.plusAssign' call
    this.e5d_1.e(annotations);
    // Inline function 'kotlin.collections.plusAssign' call
    this.f5d_1.e(isOptional);
  };
  protoOf(ClassSerialDescriptorBuilder).p5d = function (elementName, descriptor, annotations, isOptional, $super) {
    annotations = annotations === VOID ? emptyList() : annotations;
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.g5f(elementName, descriptor, annotations, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.g5f.call(this, elementName, descriptor, annotations, isOptional);
    }
    return tmp;
  };
  function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
    var tmp;
    if (builderAction === VOID) {
      tmp = buildClassSerialDescriptor$lambda;
    } else {
      tmp = builderAction;
    }
    builderAction = tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.buildClassSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builderAction(sdBuilder);
    return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.b5d_1.n(), toList(typeParameters), sdBuilder);
  }
  function _get__hashCode__tgwhef($this) {
    var tmp0 = $this.s5f_1;
    // Inline function 'kotlin.getValue' call
    _hashCode$factory();
    return tmp0.y();
  }
  function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.r5f_1);
    };
  }
  function SerialDescriptorImpl$toString$lambda(this$0) {
    return function (it) {
      return this$0.v5e(it) + ': ' + this$0.t5e(it).b5e();
    };
  }
  function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
    this.h5f_1 = serialName;
    this.i5f_1 = kind;
    this.j5f_1 = elementsCount;
    this.k5f_1 = builder.a5d_1;
    this.l5f_1 = toHashSet(builder.b5d_1);
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = builder.b5d_1;
    tmp.m5f_1 = copyToArray(this_0);
    this.n5f_1 = compactArray(builder.d5d_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = builder.e5d_1;
    tmp_0.o5f_1 = copyToArray(this_1);
    this.p5f_1 = toBooleanArray(builder.f5d_1);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = withIndex(this.m5f_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s = this_2.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.name2Index.<anonymous>' call
      var tmp$ret$2 = to(item.tg_1, item.sg_1);
      destination.e(tmp$ret$2);
    }
    tmp_1.q5f_1 = toMap(destination);
    this.r5f_1 = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.s5f_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
  }
  protoOf(SerialDescriptorImpl).b5e = function () {
    return this.h5f_1;
  };
  protoOf(SerialDescriptorImpl).r5e = function () {
    return this.i5f_1;
  };
  protoOf(SerialDescriptorImpl).p5e = function () {
    return this.j5f_1;
  };
  protoOf(SerialDescriptorImpl).x5c = function () {
    return this.k5f_1;
  };
  protoOf(SerialDescriptorImpl).t5f = function () {
    return this.l5f_1;
  };
  protoOf(SerialDescriptorImpl).v5e = function (index) {
    return getChecked(this.m5f_1, index);
  };
  protoOf(SerialDescriptorImpl).u5e = function (name) {
    var tmp0_elvis_lhs = this.q5f_1.y2(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  protoOf(SerialDescriptorImpl).s5e = function (index) {
    return getChecked(this.o5f_1, index);
  };
  protoOf(SerialDescriptorImpl).t5e = function (index) {
    return getChecked(this.n5f_1, index);
  };
  protoOf(SerialDescriptorImpl).w5e = function (index) {
    return getChecked_0(this.p5f_1, index);
  };
  protoOf(SerialDescriptorImpl).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.b5e() === other.b5e())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.equals.<anonymous>' call
      if (!contentEquals(this.r5f_1, other.r5f_1)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.p5e() === other.p5e())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.p5e();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.t5e(index).b5e() === other.t5e(index).b5e())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.t5e(index).r5e(), other.t5e(index).r5e())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SerialDescriptorImpl).hashCode = function () {
    return _get__hashCode__tgwhef(this);
  };
  protoOf(SerialDescriptorImpl).toString = function () {
    var tmp = until(0, this.j5f_1);
    var tmp_0 = this.h5f_1 + '(';
    return joinToString_0(tmp, ', ', tmp_0, ')', VOID, VOID, SerialDescriptorImpl$toString$lambda(this));
  };
  function PrimitiveSerialDescriptor(serialName, kind) {
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.PrimitiveSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return PrimitiveDescriptorSafe(serialName, kind);
  }
  function buildSerialDescriptor$lambda($this$null) {
    return Unit_instance;
  }
  function buildClassSerialDescriptor$lambda($this$null) {
    return Unit_instance;
  }
  function _hashCode$factory() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode__tgwhef(receiver);
    }, null);
  }
  function ENUM() {
    ENUM_instance = this;
    SerialKind.call(this);
  }
  var ENUM_instance;
  function ENUM_getInstance() {
    if (ENUM_instance == null)
      new ENUM();
    return ENUM_instance;
  }
  function CONTEXTUAL() {
    CONTEXTUAL_instance = this;
    SerialKind.call(this);
  }
  var CONTEXTUAL_instance;
  function CONTEXTUAL_getInstance() {
    if (CONTEXTUAL_instance == null)
      new CONTEXTUAL();
    return CONTEXTUAL_instance;
  }
  function SerialKind() {
  }
  protoOf(SerialKind).toString = function () {
    return ensureNotNull(getKClassFromExpression(this).lb());
  };
  protoOf(SerialKind).hashCode = function () {
    return getStringHashCode(this.toString());
  };
  function BOOLEAN() {
    BOOLEAN_instance = this;
    PrimitiveKind.call(this);
  }
  var BOOLEAN_instance;
  function BOOLEAN_getInstance() {
    if (BOOLEAN_instance == null)
      new BOOLEAN();
    return BOOLEAN_instance;
  }
  function BYTE() {
    BYTE_instance = this;
    PrimitiveKind.call(this);
  }
  var BYTE_instance;
  function BYTE_getInstance() {
    if (BYTE_instance == null)
      new BYTE();
    return BYTE_instance;
  }
  function CHAR() {
    CHAR_instance = this;
    PrimitiveKind.call(this);
  }
  var CHAR_instance;
  function CHAR_getInstance() {
    if (CHAR_instance == null)
      new CHAR();
    return CHAR_instance;
  }
  function SHORT() {
    SHORT_instance = this;
    PrimitiveKind.call(this);
  }
  var SHORT_instance;
  function SHORT_getInstance() {
    if (SHORT_instance == null)
      new SHORT();
    return SHORT_instance;
  }
  function INT() {
    INT_instance = this;
    PrimitiveKind.call(this);
  }
  var INT_instance;
  function INT_getInstance() {
    if (INT_instance == null)
      new INT();
    return INT_instance;
  }
  function LONG() {
    LONG_instance = this;
    PrimitiveKind.call(this);
  }
  var LONG_instance;
  function LONG_getInstance() {
    if (LONG_instance == null)
      new LONG();
    return LONG_instance;
  }
  function FLOAT() {
    FLOAT_instance = this;
    PrimitiveKind.call(this);
  }
  var FLOAT_instance;
  function FLOAT_getInstance() {
    if (FLOAT_instance == null)
      new FLOAT();
    return FLOAT_instance;
  }
  function DOUBLE() {
    DOUBLE_instance = this;
    PrimitiveKind.call(this);
  }
  var DOUBLE_instance;
  function DOUBLE_getInstance() {
    if (DOUBLE_instance == null)
      new DOUBLE();
    return DOUBLE_instance;
  }
  function STRING() {
    STRING_instance = this;
    PrimitiveKind.call(this);
  }
  var STRING_instance;
  function STRING_getInstance() {
    if (STRING_instance == null)
      new STRING();
    return STRING_instance;
  }
  function PrimitiveKind() {
    SerialKind.call(this);
  }
  function CLASS() {
    CLASS_instance = this;
    StructureKind.call(this);
  }
  var CLASS_instance;
  function CLASS_getInstance() {
    if (CLASS_instance == null)
      new CLASS();
    return CLASS_instance;
  }
  function LIST() {
    LIST_instance = this;
    StructureKind.call(this);
  }
  var LIST_instance;
  function LIST_getInstance() {
    if (LIST_instance == null)
      new LIST();
    return LIST_instance;
  }
  function MAP() {
    MAP_instance = this;
    StructureKind.call(this);
  }
  var MAP_instance;
  function MAP_getInstance() {
    if (MAP_instance == null)
      new MAP();
    return MAP_instance;
  }
  function OBJECT() {
    OBJECT_instance = this;
    StructureKind.call(this);
  }
  var OBJECT_instance;
  function OBJECT_getInstance() {
    if (OBJECT_instance == null)
      new OBJECT();
    return OBJECT_instance;
  }
  function StructureKind() {
    SerialKind.call(this);
  }
  function SEALED_0() {
    SEALED_instance = this;
    PolymorphicKind.call(this);
  }
  var SEALED_instance;
  function SEALED_getInstance() {
    if (SEALED_instance == null)
      new SEALED_0();
    return SEALED_instance;
  }
  function OPEN() {
    OPEN_instance = this;
    PolymorphicKind.call(this);
  }
  var OPEN_instance;
  function OPEN_getInstance() {
    if (OPEN_instance == null)
      new OPEN();
    return OPEN_instance;
  }
  function PolymorphicKind() {
    SerialKind.call(this);
  }
  function AbstractDecoder() {
  }
  protoOf(AbstractDecoder).u5f = function () {
    throw SerializationException_init_$Create$_0(toString_1(getKClassFromExpression(this)) + " can't retrieve untyped values");
  };
  protoOf(AbstractDecoder).v5f = function () {
    return true;
  };
  protoOf(AbstractDecoder).w5f = function () {
    return null;
  };
  protoOf(AbstractDecoder).x5f = function () {
    var tmp = this.u5f();
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).y5f = function () {
    var tmp = this.u5f();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).z5f = function () {
    var tmp = this.u5f();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).a5g = function () {
    var tmp = this.u5f();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).b5g = function () {
    var tmp = this.u5f();
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).c5g = function () {
    var tmp = this.u5f();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).d5g = function () {
    var tmp = this.u5f();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).e5g = function () {
    var tmp = this.u5f();
    return tmp instanceof Char ? tmp.v1_1 : THROW_CCE();
  };
  protoOf(AbstractDecoder).f5g = function () {
    var tmp = this.u5f();
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).g5g = function (enumDescriptor) {
    var tmp = this.u5f();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).h5g = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).i5g = function (deserializer, previousValue) {
    return this.l5d(deserializer);
  };
  protoOf(AbstractDecoder).j5g = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).k5g = function (descriptor) {
  };
  protoOf(AbstractDecoder).l5g = function (descriptor, index) {
    return this.x5f();
  };
  protoOf(AbstractDecoder).m5g = function (descriptor, index) {
    return this.y5f();
  };
  protoOf(AbstractDecoder).n5g = function (descriptor, index) {
    return this.z5f();
  };
  protoOf(AbstractDecoder).o5g = function (descriptor, index) {
    return this.a5g();
  };
  protoOf(AbstractDecoder).p5g = function (descriptor, index) {
    return this.b5g();
  };
  protoOf(AbstractDecoder).q5g = function (descriptor, index) {
    return this.c5g();
  };
  protoOf(AbstractDecoder).r5g = function (descriptor, index) {
    return this.d5g();
  };
  protoOf(AbstractDecoder).s5g = function (descriptor, index) {
    return this.e5g();
  };
  protoOf(AbstractDecoder).t5g = function (descriptor, index) {
    return this.f5g();
  };
  protoOf(AbstractDecoder).u5g = function (descriptor, index) {
    return this.h5g(descriptor.t5e(index));
  };
  protoOf(AbstractDecoder).v5g = function (descriptor, index, deserializer, previousValue) {
    return this.i5g(deserializer, previousValue);
  };
  protoOf(AbstractDecoder).x5g = function (descriptor, index, deserializer, previousValue) {
    var isNullabilitySupported = deserializer.w5c().l5e();
    return isNullabilitySupported || this.v5f() ? this.i5g(deserializer, previousValue) : this.w5f();
  };
  function AbstractEncoder() {
  }
  protoOf(AbstractEncoder).j5g = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).k5g = function (descriptor) {
  };
  protoOf(AbstractEncoder).b5h = function (descriptor, index) {
    return true;
  };
  protoOf(AbstractEncoder).c5h = function (value) {
    throw SerializationException_init_$Create$_0('Non-serializable ' + toString_1(getKClassFromExpression(value)) + ' is not supported by ' + toString_1(getKClassFromExpression(this)) + ' encoder');
  };
  protoOf(AbstractEncoder).d5h = function () {
    throw SerializationException_init_$Create$_0("'null' is not supported by default");
  };
  protoOf(AbstractEncoder).e5h = function (value) {
    return this.c5h(value);
  };
  protoOf(AbstractEncoder).f5h = function (value) {
    return this.c5h(value);
  };
  protoOf(AbstractEncoder).g5h = function (value) {
    return this.c5h(value);
  };
  protoOf(AbstractEncoder).h5h = function (value) {
    return this.c5h(value);
  };
  protoOf(AbstractEncoder).i5h = function (value) {
    return this.c5h(value);
  };
  protoOf(AbstractEncoder).j5h = function (value) {
    return this.c5h(value);
  };
  protoOf(AbstractEncoder).k5h = function (value) {
    return this.c5h(value);
  };
  protoOf(AbstractEncoder).l5h = function (value) {
    return this.c5h(new Char(value));
  };
  protoOf(AbstractEncoder).m5h = function (value) {
    return this.c5h(value);
  };
  protoOf(AbstractEncoder).n5h = function (enumDescriptor, index) {
    return this.c5h(index);
  };
  protoOf(AbstractEncoder).o5h = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).p5h = function (descriptor, index, value) {
    if (this.b5h(descriptor, index)) {
      this.e5h(value);
    }
  };
  protoOf(AbstractEncoder).q5h = function (descriptor, index, value) {
    if (this.b5h(descriptor, index)) {
      this.f5h(value);
    }
  };
  protoOf(AbstractEncoder).r5h = function (descriptor, index, value) {
    if (this.b5h(descriptor, index)) {
      this.g5h(value);
    }
  };
  protoOf(AbstractEncoder).s5h = function (descriptor, index, value) {
    if (this.b5h(descriptor, index)) {
      this.h5h(value);
    }
  };
  protoOf(AbstractEncoder).t5h = function (descriptor, index, value) {
    if (this.b5h(descriptor, index)) {
      this.i5h(value);
    }
  };
  protoOf(AbstractEncoder).u5h = function (descriptor, index, value) {
    if (this.b5h(descriptor, index)) {
      this.j5h(value);
    }
  };
  protoOf(AbstractEncoder).v5h = function (descriptor, index, value) {
    if (this.b5h(descriptor, index)) {
      this.k5h(value);
    }
  };
  protoOf(AbstractEncoder).w5h = function (descriptor, index, value) {
    if (this.b5h(descriptor, index)) {
      this.l5h(value);
    }
  };
  protoOf(AbstractEncoder).x5h = function (descriptor, index, value) {
    if (this.b5h(descriptor, index)) {
      this.m5h(value);
    }
  };
  protoOf(AbstractEncoder).y5h = function (descriptor, index) {
    return this.b5h(descriptor, index) ? this.o5h(descriptor.t5e(index)) : NoOpEncoder_getInstance();
  };
  protoOf(AbstractEncoder).z5h = function (descriptor, index, serializer, value) {
    if (this.b5h(descriptor, index)) {
      this.i5d(serializer, value);
    }
  };
  protoOf(AbstractEncoder).a5i = function (descriptor, index, serializer, value) {
    if (this.b5h(descriptor, index)) {
      this.b5i(serializer, value);
    }
  };
  function Decoder() {
  }
  function CompositeDecoder() {
  }
  function Encoder() {
  }
  function CompositeEncoder() {
  }
  function decodeSequentially_0($this, compositeDecoder) {
    var klassName = compositeDecoder.t5g($this.w5c(), 0);
    var serializer = findPolymorphicSerializer_0($this, compositeDecoder, klassName);
    return compositeDecoder.w5g($this.w5c(), 1, serializer);
  }
  function AbstractPolymorphicSerializer() {
  }
  protoOf(AbstractPolymorphicSerializer).g5d = function (encoder, value) {
    var actualSerializer = findPolymorphicSerializer(this, encoder, value);
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.w5c();
    var composite = encoder.j5g(descriptor);
    // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.serialize.<anonymous>' call
    composite.x5h(this.w5c(), 0, actualSerializer.w5c().b5e());
    var tmp = this.w5c();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
    composite.z5h(tmp, 1, tmp$ret$0, value);
    composite.k5g(descriptor);
  };
  protoOf(AbstractPolymorphicSerializer).j5d = function (encoder, value) {
    return this.g5d(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(AbstractPolymorphicSerializer).k5d = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.w5c();
    var composite = decoder.j5g(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>' call
      var klassName = null;
      var value = null;
      if (composite.y5g()) {
        tmp$ret$0 = decodeSequentially_0(this, composite);
        break $l$block;
      }
      mainLoop: while (true) {
        var index = composite.z5g(this.w5c());
        switch (index) {
          case -1:
            break mainLoop;
          case 0:
            klassName = composite.t5g(this.w5c(), index);
            break;
          case 1:
            var tmp0 = klassName;
            var tmp$ret$2;
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              if (tmp0 == null) {
                // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
                var message = 'Cannot read polymorphic value before its type token';
                throw IllegalArgumentException_init_$Create$_0(toString_1(message));
              } else {
                tmp$ret$2 = tmp0;
                break $l$block_0;
              }
            }

            klassName = tmp$ret$2;
            var serializer = findPolymorphicSerializer_0(this, composite, klassName);
            value = composite.w5g(this.w5c(), index, serializer);
            break;
          default:
            var tmp0_elvis_lhs = klassName;
            throw SerializationException_init_$Create$_0('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
        }
      }
      var tmp1 = value;
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp1 == null) {
          // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
          var message_0 = 'Polymorphic value has not been read for class ' + klassName;
          throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
        } else {
          tmp$ret$4 = tmp1;
          break $l$block_1;
        }
      }
      var tmp = tmp$ret$4;
      tmp$ret$0 = !(tmp == null) ? tmp : THROW_CCE();
    }
    var result = tmp$ret$0;
    composite.k5g(descriptor);
    return result;
  };
  protoOf(AbstractPolymorphicSerializer).r5d = function (decoder, klassName) {
    return decoder.h5d().f5i(this.q5d(), klassName);
  };
  protoOf(AbstractPolymorphicSerializer).s5d = function (encoder, value) {
    return encoder.h5d().g5i(this.q5d(), value);
  };
  function throwSubtypeNotRegistered(subClass, baseClass) {
    var tmp0_elvis_lhs = subClass.lb();
    throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? toString_1(subClass) : tmp0_elvis_lhs, baseClass);
  }
  function throwSubtypeNotRegistered_0(subClassName, baseClass) {
    var scope = "in the scope of '" + baseClass.lb() + "'";
    throw SerializationException_init_$Create$_0(subClassName == null ? 'Class discriminator was missing and no default polymorphic serializers were registered ' + scope : "Class '" + subClassName + "' is not registered for polymorphic serialization " + scope + '.\n' + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.lb() + "' has to be sealed and '@Serializable'.\n") + ("Alternatively, register the serializer for '" + subClassName + "' explicitly in a corresponding SerializersModule."));
  }
  function NothingSerializer_0() {
    NothingSerializer_instance = this;
    this.h5i_1 = NothingSerialDescriptor_getInstance();
  }
  protoOf(NothingSerializer_0).w5c = function () {
    return this.h5i_1;
  };
  protoOf(NothingSerializer_0).i5i = function (encoder, value) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' cannot be serialized");
  };
  protoOf(NothingSerializer_0).j5d = function (encoder, value) {
    var tmp;
    if (false) {
      tmp = value;
    } else {
      tmp = THROW_CCE();
    }
    return this.i5i(encoder, tmp);
  };
  protoOf(NothingSerializer_0).k5d = function (decoder) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' does not have instances");
  };
  var NothingSerializer_instance;
  function NothingSerializer_getInstance() {
    if (NothingSerializer_instance == null)
      new NothingSerializer_0();
    return NothingSerializer_instance;
  }
  function DurationSerializer() {
    DurationSerializer_instance = this;
    this.j5i_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Duration', STRING_getInstance());
  }
  protoOf(DurationSerializer).w5c = function () {
    return this.j5i_1;
  };
  protoOf(DurationSerializer).k5i = function (encoder, value) {
    encoder.m5h(Duration__toIsoString_impl_9h6wsm(value));
  };
  protoOf(DurationSerializer).j5d = function (encoder, value) {
    return this.k5i(encoder, value instanceof Duration ? value.ef_1 : THROW_CCE());
  };
  protoOf(DurationSerializer).l5i = function (decoder) {
    return Companion_getInstance_16().jl(decoder.f5g());
  };
  protoOf(DurationSerializer).k5d = function (decoder) {
    return new Duration(this.l5i(decoder));
  };
  var DurationSerializer_instance;
  function DurationSerializer_getInstance() {
    if (DurationSerializer_instance == null)
      new DurationSerializer();
    return DurationSerializer_instance;
  }
  function CachedNames() {
  }
  function ArrayListClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayListClassDesc).b5e = function () {
    return 'kotlin.collections.ArrayList';
  };
  function HashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(HashSetClassDesc).b5e = function () {
    return 'kotlin.collections.HashSet';
  };
  function LinkedHashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(LinkedHashSetClassDesc).b5e = function () {
    return 'kotlin.collections.LinkedHashSet';
  };
  function HashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
  }
  function LinkedHashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
  }
  function ArrayClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayClassDesc).b5e = function () {
    return 'kotlin.Array';
  };
  function ListLikeDescriptor(elementDescriptor) {
    this.o5i_1 = elementDescriptor;
    this.p5i_1 = 1;
  }
  protoOf(ListLikeDescriptor).r5e = function () {
    return LIST_getInstance();
  };
  protoOf(ListLikeDescriptor).p5e = function () {
    return this.p5i_1;
  };
  protoOf(ListLikeDescriptor).v5e = function (index) {
    return index.toString();
  };
  protoOf(ListLikeDescriptor).u5e = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$_0(name + ' is not a valid list index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ListLikeDescriptor).w5e = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.b5e() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return false;
  };
  protoOf(ListLikeDescriptor).s5e = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.b5e() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return emptyList();
  };
  protoOf(ListLikeDescriptor).t5e = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.b5e() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return this.o5i_1;
  };
  protoOf(ListLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    if (equals(this.o5i_1, other.o5i_1) && this.b5e() === other.b5e())
      return true;
    return false;
  };
  protoOf(ListLikeDescriptor).hashCode = function () {
    return imul(hashCode(this.o5i_1), 31) + getStringHashCode(this.b5e()) | 0;
  };
  protoOf(ListLikeDescriptor).toString = function () {
    return this.b5e() + '(' + toString_1(this.o5i_1) + ')';
  };
  function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
    this.u5i_1 = serialName;
    this.v5i_1 = keyDescriptor;
    this.w5i_1 = valueDescriptor;
    this.x5i_1 = 2;
  }
  protoOf(MapLikeDescriptor).b5e = function () {
    return this.u5i_1;
  };
  protoOf(MapLikeDescriptor).r5e = function () {
    return MAP_getInstance();
  };
  protoOf(MapLikeDescriptor).p5e = function () {
    return this.x5i_1;
  };
  protoOf(MapLikeDescriptor).v5e = function (index) {
    return index.toString();
  };
  protoOf(MapLikeDescriptor).u5e = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$_0(name + ' is not a valid map index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).w5e = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.b5e() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return false;
  };
  protoOf(MapLikeDescriptor).s5e = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.b5e() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return emptyList();
  };
  protoOf(MapLikeDescriptor).t5e = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.b5e() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    switch (index % 2 | 0) {
      case 0:
        tmp = this.v5i_1;
        break;
      case 1:
        tmp = this.w5i_1;
        break;
      default:
        var message_0 = 'Unreached';
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapLikeDescriptor))
      return false;
    if (!(this.b5e() === other.b5e()))
      return false;
    if (!equals(this.v5i_1, other.v5i_1))
      return false;
    if (!equals(this.w5i_1, other.w5i_1))
      return false;
    return true;
  };
  protoOf(MapLikeDescriptor).hashCode = function () {
    var result = getStringHashCode(this.b5e());
    result = imul(31, result) + hashCode(this.v5i_1) | 0;
    result = imul(31, result) + hashCode(this.w5i_1) | 0;
    return result;
  };
  protoOf(MapLikeDescriptor).toString = function () {
    return this.b5e() + '(' + toString_1(this.v5i_1) + ', ' + toString_1(this.w5i_1) + ')';
  };
  function PrimitiveArrayDescriptor(primitive) {
    ListLikeDescriptor.call(this, primitive);
    this.c5j_1 = primitive.b5e() + 'Array';
  }
  protoOf(PrimitiveArrayDescriptor).b5e = function () {
    return this.c5j_1;
  };
  function ArrayListSerializer(element) {
    CollectionSerializer.call(this, element);
    this.e5j_1 = new ArrayListClassDesc(element.w5c());
  }
  protoOf(ArrayListSerializer).w5c = function () {
    return this.e5j_1;
  };
  protoOf(ArrayListSerializer).f5j = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$();
  };
  protoOf(ArrayListSerializer).g5j = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(ArrayListSerializer).h5j = function (_this__u8e3s4) {
    return this.g5j(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).i5j = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(ArrayListSerializer).j5j = function (_this__u8e3s4) {
    return this.i5j(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).k5j = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(ArrayListSerializer).l5j = function (_this__u8e3s4) {
    return this.k5j((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).m5j = function (_this__u8e3s4, size) {
    return _this__u8e3s4.i6(size);
  };
  protoOf(ArrayListSerializer).n5j = function (_this__u8e3s4, size) {
    return this.m5j(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ArrayListSerializer).o5j = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.p2(index, element);
  };
  protoOf(ArrayListSerializer).p5j = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.o5j(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function HashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.a5k_1 = new HashSetClassDesc(eSerializer.w5c());
  }
  protoOf(HashSetSerializer).w5c = function () {
    return this.a5k_1;
  };
  protoOf(HashSetSerializer).f5j = function () {
    return HashSet_init_$Create$();
  };
  protoOf(HashSetSerializer).b5k = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(HashSetSerializer).h5j = function (_this__u8e3s4) {
    return this.b5k(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).c5k = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashSetSerializer).j5j = function (_this__u8e3s4) {
    return this.c5k(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).d5k = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashSetSerializer).l5j = function (_this__u8e3s4) {
    return this.d5k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).e5k = function (_this__u8e3s4, size) {
  };
  protoOf(HashSetSerializer).n5j = function (_this__u8e3s4, size) {
    return this.e5k(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(HashSetSerializer).f5k = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.e(element);
  };
  protoOf(HashSetSerializer).p5j = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE();
    return this.f5k(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function LinkedHashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.h5k_1 = new LinkedHashSetClassDesc(eSerializer.w5c());
  }
  protoOf(LinkedHashSetSerializer).w5c = function () {
    return this.h5k_1;
  };
  protoOf(LinkedHashSetSerializer).f5j = function () {
    // Inline function 'kotlin.collections.linkedSetOf' call
    return LinkedHashSet_init_$Create$();
  };
  protoOf(LinkedHashSetSerializer).i5k = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(LinkedHashSetSerializer).h5j = function (_this__u8e3s4) {
    return this.i5k(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).j5k = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashSetSerializer).j5j = function (_this__u8e3s4) {
    return this.j5k(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).d5k = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashSetSerializer).l5j = function (_this__u8e3s4) {
    return this.d5k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).k5k = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashSetSerializer).n5j = function (_this__u8e3s4, size) {
    return this.k5k(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(LinkedHashSetSerializer).l5k = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.e(element);
  };
  protoOf(LinkedHashSetSerializer).p5j = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
    return this.l5k(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function HashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.o5k_1 = new HashMapClassDesc(kSerializer.w5c(), vSerializer.w5c());
  }
  protoOf(HashMapSerializer).w5c = function () {
    return this.o5k_1;
  };
  protoOf(HashMapSerializer).p5k = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(HashMapSerializer).q5k = function (_this__u8e3s4) {
    return this.p5k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).r5k = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.w().k();
  };
  protoOf(HashMapSerializer).s5k = function (_this__u8e3s4) {
    return this.r5k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).f5j = function () {
    return HashMap_init_$Create$();
  };
  protoOf(HashMapSerializer).t5k = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.n(), 2);
  };
  protoOf(HashMapSerializer).h5j = function (_this__u8e3s4) {
    return this.t5k(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).u5k = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashMapSerializer).j5j = function (_this__u8e3s4) {
    return this.u5k(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).v5k = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashMap_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashMapSerializer).l5j = function (_this__u8e3s4) {
    return this.v5k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).w5k = function (_this__u8e3s4, size) {
  };
  protoOf(HashMapSerializer).n5j = function (_this__u8e3s4, size) {
    return this.w5k(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function LinkedHashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.d5l_1 = new LinkedHashMapClassDesc(kSerializer.w5c(), vSerializer.w5c());
  }
  protoOf(LinkedHashMapSerializer).w5c = function () {
    return this.d5l_1;
  };
  protoOf(LinkedHashMapSerializer).p5k = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(LinkedHashMapSerializer).q5k = function (_this__u8e3s4) {
    return this.p5k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).r5k = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.w().k();
  };
  protoOf(LinkedHashMapSerializer).s5k = function (_this__u8e3s4) {
    return this.r5k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).f5j = function () {
    return LinkedHashMap_init_$Create$();
  };
  protoOf(LinkedHashMapSerializer).e5l = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.n(), 2);
  };
  protoOf(LinkedHashMapSerializer).h5j = function (_this__u8e3s4) {
    return this.e5l(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).f5l = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashMapSerializer).j5j = function (_this__u8e3s4) {
    return this.f5l(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).v5k = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashMapSerializer).l5j = function (_this__u8e3s4) {
    return this.v5k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).g5l = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashMapSerializer).n5j = function (_this__u8e3s4, size) {
    return this.g5l(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function ReferenceArraySerializer(kClass, eSerializer) {
    CollectionLikeSerializer.call(this, eSerializer);
    this.i5l_1 = kClass;
    this.j5l_1 = new ArrayClassDesc(eSerializer.w5c());
  }
  protoOf(ReferenceArraySerializer).w5c = function () {
    return this.j5l_1;
  };
  protoOf(ReferenceArraySerializer).k5l = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ReferenceArraySerializer).q5k = function (_this__u8e3s4) {
    return this.k5l((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).l5l = function (_this__u8e3s4) {
    return arrayIterator(_this__u8e3s4);
  };
  protoOf(ReferenceArraySerializer).s5k = function (_this__u8e3s4) {
    return this.l5l((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).f5j = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$();
  };
  protoOf(ReferenceArraySerializer).m5l = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(ReferenceArraySerializer).h5j = function (_this__u8e3s4) {
    return this.m5l(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).n5l = function (_this__u8e3s4) {
    return toNativeArrayImpl(_this__u8e3s4, this.i5l_1);
  };
  protoOf(ReferenceArraySerializer).j5j = function (_this__u8e3s4) {
    return this.n5l(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).o5l = function (_this__u8e3s4) {
    return ArrayList_init_$Create$_1(asList(_this__u8e3s4));
  };
  protoOf(ReferenceArraySerializer).l5j = function (_this__u8e3s4) {
    return this.o5l((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).p5l = function (_this__u8e3s4, size) {
    return _this__u8e3s4.i6(size);
  };
  protoOf(ReferenceArraySerializer).n5j = function (_this__u8e3s4, size) {
    return this.p5l(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ReferenceArraySerializer).q5l = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.p2(index, element);
  };
  protoOf(ReferenceArraySerializer).p5j = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.q5l(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function CollectionSerializer(element) {
    CollectionLikeSerializer.call(this, element);
  }
  protoOf(CollectionSerializer).r5j = function (_this__u8e3s4) {
    return _this__u8e3s4.n();
  };
  protoOf(CollectionSerializer).q5k = function (_this__u8e3s4) {
    return this.r5j((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CollectionSerializer).s5j = function (_this__u8e3s4) {
    return _this__u8e3s4.k();
  };
  protoOf(CollectionSerializer).s5k = function (_this__u8e3s4) {
    return this.s5j((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  function MapLikeSerializer(keySerializer, valueSerializer) {
    AbstractCollectionSerializer.call(this);
    this.x5k_1 = keySerializer;
    this.y5k_1 = valueSerializer;
  }
  protoOf(MapLikeSerializer).z5k = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var progression = step(until(0, imul(size, 2)), 2);
    var inductionVariable = progression.e1_1;
    var last = progression.f1_1;
    var step_0 = progression.g1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        this.a5l(decoder, startIndex + index | 0, builder, false);
      }
       while (!(index === last));
  };
  protoOf(MapLikeSerializer).v5j = function (decoder, builder, startIndex, size) {
    return this.z5k(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
  };
  protoOf(MapLikeSerializer).a5l = function (decoder, index, builder, checkIndex) {
    var key = decoder.w5g(this.w5c(), index, this.x5k_1);
    var tmp;
    if (checkIndex) {
      // Inline function 'kotlin.also' call
      var this_0 = decoder.z5g(this.w5c());
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>' call
      // Inline function 'kotlin.require' call
      if (!(this_0 === (index + 1 | 0))) {
        // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>.<anonymous>' call
        var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      tmp = this_0;
    } else {
      tmp = index + 1 | 0;
    }
    var vIndex = tmp;
    var tmp_0;
    var tmp_1;
    if (builder.w2(key)) {
      var tmp_2 = this.y5k_1.w5c().r5e();
      tmp_1 = !(tmp_2 instanceof PrimitiveKind);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = decoder.v5g(this.w5c(), vIndex, this.y5k_1, getValue_0(builder, key));
    } else {
      tmp_0 = decoder.w5g(this.w5c(), vIndex, this.y5k_1);
    }
    var value = tmp_0;
    // Inline function 'kotlin.collections.set' call
    builder.r2(key, value);
  };
  protoOf(MapLikeSerializer).w5j = function (decoder, index, builder, checkIndex) {
    return this.a5l(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(MapLikeSerializer).u5j = function (encoder, value) {
    var size = this.q5k(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.w5c();
    var composite = encoder.d5i(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>' call
    var iterator = this.s5k(value);
    var index = 0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = iterator;
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var k = element.x();
      // Inline function 'kotlin.collections.component2' call
      var v = element.y();
      var tmp = this.w5c();
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      composite.z5h(tmp, tmp0, this.x5k_1, k);
      var tmp_0 = this.w5c();
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      composite.z5h(tmp_0, tmp1, this.y5k_1, v);
    }
    composite.k5g(descriptor);
  };
  protoOf(MapLikeSerializer).j5d = function (encoder, value) {
    return this.u5j(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  function CollectionLikeSerializer(elementSerializer) {
    AbstractCollectionSerializer.call(this);
    this.t5j_1 = elementSerializer;
  }
  protoOf(CollectionLikeSerializer).u5j = function (encoder, value) {
    var size = this.q5k(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.w5c();
    var composite = encoder.d5i(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.serialize.<anonymous>' call
    var iterator = this.s5k(value);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.z5h(this.w5c(), index, this.t5j_1, iterator.m());
      }
       while (inductionVariable < size);
    composite.k5g(descriptor);
  };
  protoOf(CollectionLikeSerializer).j5d = function (encoder, value) {
    return this.u5j(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(CollectionLikeSerializer).v5j = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.w5j(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable < size);
  };
  protoOf(CollectionLikeSerializer).w5j = function (decoder, index, builder, checkIndex) {
    this.p5j(builder, index, decoder.w5g(this.w5c(), index, this.t5j_1));
  };
  function readSize($this, decoder, builder) {
    var size = decoder.a5h($this.w5c());
    $this.n5j(builder, size);
    return size;
  }
  function AbstractCollectionSerializer() {
  }
  protoOf(AbstractCollectionSerializer).y5j = function (decoder, previous) {
    var tmp1_elvis_lhs = previous == null ? null : this.l5j(previous);
    var builder = tmp1_elvis_lhs == null ? this.f5j() : tmp1_elvis_lhs;
    var startIndex = this.h5j(builder);
    var compositeDecoder = decoder.j5g(this.w5c());
    if (compositeDecoder.y5g()) {
      this.v5j(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      $l$loop: while (true) {
        var index = compositeDecoder.z5g(this.w5c());
        if (index === -1)
          break $l$loop;
        this.x5j(compositeDecoder, startIndex + index | 0, builder);
      }
    }
    compositeDecoder.k5g(this.w5c());
    return this.j5j(builder);
  };
  protoOf(AbstractCollectionSerializer).k5d = function (decoder) {
    return this.y5j(decoder, null);
  };
  protoOf(AbstractCollectionSerializer).x5j = function (decoder, index, builder, checkIndex, $super) {
    checkIndex = checkIndex === VOID ? true : checkIndex;
    var tmp;
    if ($super === VOID) {
      this.w5j(decoder, index, builder, checkIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.w5j.call(this, decoder, index, builder, checkIndex);
    }
    return tmp;
  };
  function PrimitiveArraySerializer(primitiveSerializer) {
    CollectionLikeSerializer.call(this, primitiveSerializer);
    this.s5l_1 = new PrimitiveArrayDescriptor(primitiveSerializer.w5c());
  }
  protoOf(PrimitiveArraySerializer).w5c = function () {
    return this.s5l_1;
  };
  protoOf(PrimitiveArraySerializer).t5l = function (_this__u8e3s4) {
    return _this__u8e3s4.u5l();
  };
  protoOf(PrimitiveArraySerializer).h5j = function (_this__u8e3s4) {
    return this.t5l(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).v5l = function (_this__u8e3s4) {
    return _this__u8e3s4.w5l();
  };
  protoOf(PrimitiveArraySerializer).j5j = function (_this__u8e3s4) {
    return this.v5l(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).x5l = function (_this__u8e3s4, size) {
    return _this__u8e3s4.y5l(size);
  };
  protoOf(PrimitiveArraySerializer).n5j = function (_this__u8e3s4, size) {
    return this.x5l(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(PrimitiveArraySerializer).z5l = function (_this__u8e3s4) {
    var message = 'This method lead to boxing and must not be used, use writeContents instead';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(PrimitiveArraySerializer).s5k = function (_this__u8e3s4) {
    return this.z5l((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).a5m = function (_this__u8e3s4, index, element) {
    var message = 'This method lead to boxing and must not be used, use Builder.append instead';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(PrimitiveArraySerializer).p5j = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE();
    return this.a5m(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).f5j = function () {
    return this.l5j(this.b5m());
  };
  protoOf(PrimitiveArraySerializer).e5m = function (encoder, value) {
    var size = this.q5k(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.s5l_1;
    var composite = encoder.d5i(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.PrimitiveArraySerializer.serialize.<anonymous>' call
    this.d5m(composite, value, size);
    composite.k5g(descriptor);
  };
  protoOf(PrimitiveArraySerializer).j5d = function (encoder, value) {
    return this.e5m(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).u5j = function (encoder, value) {
    return this.e5m(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).k5d = function (decoder) {
    return this.y5j(decoder, null);
  };
  function PrimitiveArrayBuilder() {
  }
  protoOf(PrimitiveArrayBuilder).f5m = function (requiredCapacity, $super) {
    requiredCapacity = requiredCapacity === VOID ? this.u5l() + 1 | 0 : requiredCapacity;
    var tmp;
    if ($super === VOID) {
      this.y5l(requiredCapacity);
      tmp = Unit_instance;
    } else {
      tmp = $super.y5l.call(this, requiredCapacity);
    }
    return tmp;
  };
  function Companion_80() {
    Companion_instance_80 = this;
    this.g5m_1 = longArray(0);
  }
  var Companion_instance_80;
  function Companion_getInstance_80() {
    if (Companion_instance_80 == null)
      new Companion_80();
    return Companion_instance_80;
  }
  function prepareHighMarksArray($this, elementsCount) {
    var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
    var elementsInLastSlot = elementsCount & 63;
    var highMarks = longArray(slotsCount);
    if (!(elementsInLastSlot === 0)) {
      highMarks[get_lastIndex_1(highMarks)] = (new Long(-1, -1)).r3(elementsCount);
    }
    return highMarks;
  }
  function markHigh($this, index) {
    var slot = (index >>> 6 | 0) - 1 | 0;
    var offsetInSlot = index & 63;
    $this.k5m_1[slot] = $this.k5m_1[slot].v3((new Long(1, 0)).r3(offsetInSlot));
  }
  function nextUnmarkedHighIndex($this) {
    var inductionVariable = 0;
    var last = $this.k5m_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var slot = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var slotOffset = imul(slot + 1 | 0, 64);
        var slotMarks = $this.k5m_1[slot];
        while (!slotMarks.equals(new Long(-1, -1))) {
          var indexInSlot = countTrailingZeroBits(slotMarks.q3());
          slotMarks = slotMarks.v3((new Long(1, 0)).r3(indexInSlot));
          var index = slotOffset + indexInSlot | 0;
          if ($this.i5m_1($this.h5m_1, index)) {
            $this.k5m_1[slot] = slotMarks;
            return index;
          }
        }
        $this.k5m_1[slot] = slotMarks;
      }
       while (inductionVariable <= last);
    return -1;
  }
  function ElementMarker(descriptor, readIfAbsent) {
    Companion_getInstance_80();
    this.h5m_1 = descriptor;
    this.i5m_1 = readIfAbsent;
    var elementsCount = this.h5m_1.p5e();
    if (elementsCount <= 64) {
      var tmp = this;
      var tmp_0;
      if (elementsCount === 64) {
        tmp_0 = new Long(0, 0);
      } else {
        tmp_0 = (new Long(-1, -1)).r3(elementsCount);
      }
      tmp.j5m_1 = tmp_0;
      this.k5m_1 = Companion_getInstance_80().g5m_1;
    } else {
      this.j5m_1 = new Long(0, 0);
      this.k5m_1 = prepareHighMarksArray(this, elementsCount);
    }
  }
  protoOf(ElementMarker).l5m = function (index) {
    if (index < 64) {
      this.j5m_1 = this.j5m_1.v3((new Long(1, 0)).r3(index));
    } else {
      markHigh(this, index);
    }
  };
  protoOf(ElementMarker).m5m = function () {
    var elementsCount = this.h5m_1.p5e();
    while (!this.j5m_1.equals(new Long(-1, -1))) {
      var index = countTrailingZeroBits(this.j5m_1.q3());
      this.j5m_1 = this.j5m_1.v3((new Long(1, 0)).r3(index));
      if (this.i5m_1(this.h5m_1, index)) {
        return index;
      }
    }
    if (elementsCount > 64) {
      return nextUnmarkedHighIndex(this);
    }
    return -1;
  };
  function createUnmarkedDescriptor($this, serialName) {
    var d = new EnumDescriptor(serialName, $this.n5m_1.length);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.n5m_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlinx.serialization.internal.EnumSerializer.createUnmarkedDescriptor.<anonymous>' call
      d.c5n(element.z2_1);
    }
    return d;
  }
  function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
    return function () {
      var tmp0_elvis_lhs = this$0.o5m_1;
      return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
    };
  }
  function EnumSerializer(serialName, values) {
    this.n5m_1 = values;
    this.o5m_1 = null;
    var tmp = this;
    tmp.p5m_1 = lazy_0(EnumSerializer$descriptor$delegate$lambda(this, serialName));
  }
  protoOf(EnumSerializer).w5c = function () {
    var tmp0 = this.p5m_1;
    // Inline function 'kotlin.getValue' call
    descriptor$factory_1();
    return tmp0.y();
  };
  protoOf(EnumSerializer).d5n = function (encoder, value) {
    var index = indexOf(this.n5m_1, value);
    if (index === -1) {
      throw SerializationException_init_$Create$_0(toString_1(value) + ' is not a valid enum ' + this.w5c().b5e() + ', ' + ('must be one of ' + contentToString(this.n5m_1)));
    }
    encoder.n5h(this.w5c(), index);
  };
  protoOf(EnumSerializer).j5d = function (encoder, value) {
    return this.d5n(encoder, value instanceof Enum ? value : THROW_CCE());
  };
  protoOf(EnumSerializer).k5d = function (decoder) {
    var index = decoder.g5g(this.w5c());
    if (!(0 <= index ? index <= (this.n5m_1.length - 1 | 0) : false)) {
      throw SerializationException_init_$Create$_0('' + index + ' is not among valid ' + this.w5c().b5e() + ' enum values, ' + ('values size is ' + this.n5m_1.length));
    }
    return this.n5m_1[index];
  };
  protoOf(EnumSerializer).toString = function () {
    return 'kotlinx.serialization.internal.EnumSerializer<' + this.w5c().b5e() + '>';
  };
  function _get_elementDescriptors__y23q9p($this) {
    var tmp0 = $this.r5n_1;
    // Inline function 'kotlin.getValue' call
    elementDescriptors$factory();
    return tmp0.y();
  }
  function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
    return function () {
      var tmp = 0;
      var tmp_0 = $elementsCount;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = buildSerialDescriptor($name + '.' + this$0.v5e(tmp_2), OBJECT_getInstance(), []);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  function EnumDescriptor(name, elementsCount) {
    PluginGeneratedSerialDescriptor.call(this, name, VOID, elementsCount);
    this.q5n_1 = ENUM_getInstance();
    var tmp = this;
    tmp.r5n_1 = lazy_0(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
  }
  protoOf(EnumDescriptor).r5e = function () {
    return this.q5n_1;
  };
  protoOf(EnumDescriptor).t5e = function (index) {
    return getChecked(_get_elementDescriptors__y23q9p(this), index);
  };
  protoOf(EnumDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (other == null)
      return false;
    if (!(!(other == null) ? isInterface(other, SerialDescriptor) : false))
      return false;
    if (!(other.r5e() === ENUM_getInstance()))
      return false;
    if (!(this.b5e() === other.b5e()))
      return false;
    if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
      return false;
    return true;
  };
  protoOf(EnumDescriptor).toString = function () {
    return joinToString_0(get_elementNames(this), ', ', this.b5e() + '(', ')');
  };
  protoOf(EnumDescriptor).hashCode = function () {
    var result = getStringHashCode(this.b5e());
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var _iterator__ex2g4s = get_elementNames(this).k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlinx.serialization.internal.EnumDescriptor.hashCode.<anonymous>' call
      // Inline function 'kotlin.hashCode' call
      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var elementsHashCode = accumulator;
    result = imul(31, result) + elementsHashCode | 0;
    return result;
  };
  function descriptor$factory_1() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.w5c();
    }, null);
  }
  function elementDescriptors$factory() {
    return getPropertyCallableRef('elementDescriptors', 1, KProperty1, function (receiver) {
      return _get_elementDescriptors__y23q9p(receiver);
    }, null);
  }
  function InlinePrimitiveDescriptor(name, primitiveSerializer) {
    return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
  }
  function InlineClassDescriptor(name, generatedSerializer) {
    PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
    this.g5o_1 = true;
  }
  protoOf(InlineClassDescriptor).q5e = function () {
    return this.g5o_1;
  };
  protoOf(InlineClassDescriptor).hashCode = function () {
    return imul(protoOf(PluginGeneratedSerialDescriptor).hashCode.call(this), 31);
  };
  protoOf(InlineClassDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof InlineClassDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.b5e() === other.b5e())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.InlineClassDescriptor.equals.<anonymous>' call
      if (!(other.g5o_1 && contentEquals(this.s5n(), other.s5n()))) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.p5e() === other.p5e())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.p5e();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.t5e(index).b5e() === other.t5e(index).b5e())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.t5e(index).r5e(), other.t5e(index).r5e())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  function InlinePrimitiveDescriptor$1($primitiveSerializer) {
    this.h5o_1 = $primitiveSerializer;
  }
  protoOf(InlinePrimitiveDescriptor$1).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.h5o_1];
  };
  protoOf(InlinePrimitiveDescriptor$1).w5c = function () {
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).j5d = function (encoder, value) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).k5d = function (decoder) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  function jsonCachedSerialNames(_this__u8e3s4) {
    return cachedSerialNames(_this__u8e3s4);
  }
  function NoOpEncoder() {
    NoOpEncoder_instance = this;
    AbstractEncoder.call(this);
    this.k5o_1 = EmptySerializersModule_0();
  }
  protoOf(NoOpEncoder).h5d = function () {
    return this.k5o_1;
  };
  protoOf(NoOpEncoder).c5h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).d5h = function () {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).e5h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).f5h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).g5h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).h5h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).i5h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).j5h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).k5h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).l5h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).m5h = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).n5h = function (enumDescriptor, index) {
    return Unit_instance;
  };
  var NoOpEncoder_instance;
  function NoOpEncoder_getInstance() {
    if (NoOpEncoder_instance == null)
      new NoOpEncoder();
    return NoOpEncoder_instance;
  }
  function error($this) {
    throw IllegalStateException_init_$Create$_0('Descriptor for type `kotlin.Nothing` does not have elements');
  }
  function NothingSerialDescriptor() {
    NothingSerialDescriptor_instance = this;
    this.l5o_1 = OBJECT_getInstance();
    this.m5o_1 = 'kotlin.Nothing';
  }
  protoOf(NothingSerialDescriptor).r5e = function () {
    return this.l5o_1;
  };
  protoOf(NothingSerialDescriptor).b5e = function () {
    return this.m5o_1;
  };
  protoOf(NothingSerialDescriptor).p5e = function () {
    return 0;
  };
  protoOf(NothingSerialDescriptor).v5e = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).u5e = function (name) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).w5e = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).t5e = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).s5e = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).toString = function () {
    return 'NothingSerialDescriptor';
  };
  protoOf(NothingSerialDescriptor).equals = function (other) {
    return this === other;
  };
  protoOf(NothingSerialDescriptor).hashCode = function () {
    return getStringHashCode(this.m5o_1) + imul(31, this.l5o_1.hashCode()) | 0;
  };
  var NothingSerialDescriptor_instance;
  function NothingSerialDescriptor_getInstance() {
    if (NothingSerialDescriptor_instance == null)
      new NothingSerialDescriptor();
    return NothingSerialDescriptor_instance;
  }
  function NullableSerializer(serializer) {
    this.n5o_1 = serializer;
    this.o5o_1 = new SerialDescriptorForNullable(this.n5o_1.w5c());
  }
  protoOf(NullableSerializer).w5c = function () {
    return this.o5o_1;
  };
  protoOf(NullableSerializer).p5o = function (encoder, value) {
    if (!(value == null)) {
      encoder.c5i();
      encoder.i5d(this.n5o_1, value);
    } else {
      encoder.d5h();
    }
  };
  protoOf(NullableSerializer).j5d = function (encoder, value) {
    return this.p5o(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(NullableSerializer).k5d = function (decoder) {
    return decoder.v5f() ? decoder.l5d(this.n5o_1) : decoder.w5f();
  };
  protoOf(NullableSerializer).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NullableSerializer))
      THROW_CCE();
    if (!equals(this.n5o_1, other.n5o_1))
      return false;
    return true;
  };
  protoOf(NullableSerializer).hashCode = function () {
    return hashCode(this.n5o_1);
  };
  function SerialDescriptorForNullable(original) {
    this.x5e_1 = original;
    this.y5e_1 = this.x5e_1.b5e() + '?';
    this.z5e_1 = cachedSerialNames(this.x5e_1);
  }
  protoOf(SerialDescriptorForNullable).x5c = function () {
    return this.x5e_1.x5c();
  };
  protoOf(SerialDescriptorForNullable).p5e = function () {
    return this.x5e_1.p5e();
  };
  protoOf(SerialDescriptorForNullable).q5e = function () {
    return this.x5e_1.q5e();
  };
  protoOf(SerialDescriptorForNullable).r5e = function () {
    return this.x5e_1.r5e();
  };
  protoOf(SerialDescriptorForNullable).s5e = function (index) {
    return this.x5e_1.s5e(index);
  };
  protoOf(SerialDescriptorForNullable).t5e = function (index) {
    return this.x5e_1.t5e(index);
  };
  protoOf(SerialDescriptorForNullable).u5e = function (name) {
    return this.x5e_1.u5e(name);
  };
  protoOf(SerialDescriptorForNullable).v5e = function (index) {
    return this.x5e_1.v5e(index);
  };
  protoOf(SerialDescriptorForNullable).w5e = function (index) {
    return this.x5e_1.w5e(index);
  };
  protoOf(SerialDescriptorForNullable).b5e = function () {
    return this.y5e_1;
  };
  protoOf(SerialDescriptorForNullable).t5f = function () {
    return this.z5e_1;
  };
  protoOf(SerialDescriptorForNullable).l5e = function () {
    return true;
  };
  protoOf(SerialDescriptorForNullable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerialDescriptorForNullable))
      return false;
    if (!equals(this.x5e_1, other.x5e_1))
      return false;
    return true;
  };
  protoOf(SerialDescriptorForNullable).toString = function () {
    return toString_1(this.x5e_1) + '?';
  };
  protoOf(SerialDescriptorForNullable).hashCode = function () {
    return imul(hashCode(this.x5e_1), 31);
  };
  function ObjectSerializer_init_$Init$(serialName, objectInstance, classAnnotations, $this) {
    ObjectSerializer.call($this, serialName, objectInstance);
    $this.r5o_1 = asList(classAnnotations);
    return $this;
  }
  function ObjectSerializer_init_$Create$(serialName, objectInstance, classAnnotations) {
    return ObjectSerializer_init_$Init$(serialName, objectInstance, classAnnotations, objectCreate(protoOf(ObjectSerializer)));
  }
  function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.a5d_1 = this$0.r5o_1;
      return Unit_instance;
    };
  }
  function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
    return function () {
      var tmp = OBJECT_getInstance();
      return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
    };
  }
  function ObjectSerializer(serialName, objectInstance) {
    this.q5o_1 = objectInstance;
    this.r5o_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.s5o_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
  }
  protoOf(ObjectSerializer).w5c = function () {
    var tmp0 = this.s5o_1;
    // Inline function 'kotlin.getValue' call
    descriptor$factory_2();
    return tmp0.y();
  };
  protoOf(ObjectSerializer).g5d = function (encoder, value) {
    encoder.j5g(this.w5c()).k5g(this.w5c());
  };
  protoOf(ObjectSerializer).j5d = function (encoder, value) {
    return this.g5d(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(ObjectSerializer).k5d = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.w5c();
    var composite = decoder.j5g(descriptor);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.internal.ObjectSerializer.deserialize.<anonymous>' call
      if (composite.y5g()) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      }
      var index = composite.z5g(this.w5c());
      if (index === -1) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      } else
        throw SerializationException_init_$Create$_0('Unexpected index ' + index);
    }
    var result = tmp$ret$0;
    composite.k5g(descriptor);
    return this.q5o_1;
  };
  function descriptor$factory_2() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.w5c();
    }, null);
  }
  function get_EMPTY_DESCRIPTOR_ARRAY() {
    _init_properties_Platform_common_kt__3qzecs();
    return EMPTY_DESCRIPTOR_ARRAY;
  }
  var EMPTY_DESCRIPTOR_ARRAY;
  function cachedSerialNames(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    if (isInterface(_this__u8e3s4, CachedNames))
      return _this__u8e3s4.t5f();
    var result = HashSet_init_$Create$_1(_this__u8e3s4.p5e());
    var inductionVariable = 0;
    var last = _this__u8e3s4.p5e();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = _this__u8e3s4.v5e(i);
        result.e(element);
      }
       while (inductionVariable < last);
    return result;
  }
  function kclass(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var t = _this__u8e3s4.ac();
    var tmp;
    if (!(t == null) ? isInterface(t, KClass) : false) {
      tmp = t;
    } else {
      if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
        var message = 'Captured type parameter ' + toString_0(t) + ' from generic non-reified function. ' + ('Such functionality cannot be supported as ' + toString_0(t) + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + toString_0(t));
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        var message_0 = 'Only KClass supported as classifier, got ' + toString_0(t);
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      }
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
  }
  function notRegisteredMessage(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var tmp0_elvis_lhs = _this__u8e3s4.lb();
    return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
  }
  function notRegisteredMessage_0(className) {
    _init_properties_Platform_common_kt__3qzecs();
    return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
  }
  function compactArray(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    // Inline function 'kotlin.takeUnless' call
    var tmp;
    // Inline function 'kotlinx.serialization.internal.compactArray.<anonymous>' call
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    if (!(_this__u8e3s4 == null || _this__u8e3s4.p())) {
      tmp = _this__u8e3s4;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
  }
  function serializerNotRegistered(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4));
  }
  var properties_initialized_Platform_common_kt_i7q4ty;
  function _init_properties_Platform_common_kt__3qzecs() {
    if (!properties_initialized_Platform_common_kt_i7q4ty) {
      properties_initialized_Platform_common_kt_i7q4ty = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_DESCRIPTOR_ARRAY = [];
    }
  }
  function throwMissingFieldException(seen, goldenMask, descriptor) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var missingFields = ArrayList_init_$Create$();
    var missingFieldsBits = goldenMask & ~seen;
    var inductionVariable = 0;
    if (inductionVariable < 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!((missingFieldsBits & 1) === 0)) {
          // Inline function 'kotlin.collections.plusAssign' call
          var element = descriptor.v5e(i);
          missingFields.e(element);
        }
        missingFieldsBits = missingFieldsBits >>> 1 | 0;
      }
       while (inductionVariable < 32);
    throw MissingFieldException_init_$Create$(missingFields, descriptor.b5e());
  }
  function _get_childSerializers__7vnyfa($this) {
    var tmp0 = $this.z5m_1;
    // Inline function 'kotlin.getValue' call
    childSerializers$factory();
    return tmp0.y();
  }
  function _get__hashCode__tgwhef_0($this) {
    var tmp0 = $this.b5n_1;
    // Inline function 'kotlin.getValue' call
    _hashCode$factory_0();
    return tmp0.y();
  }
  function buildIndices($this) {
    var indices = HashMap_init_$Create$();
    var inductionVariable = 0;
    var last = $this.u5m_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.set' call
        var key = $this.u5m_1[i];
        indices.r2(key, i);
      }
       while (inductionVariable <= last);
    return indices;
  }
  function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.r5m_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i5o();
      return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
    };
  }
  function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.r5m_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j5o();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(tmp1_safe_receiver.length);
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var item = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.typeParameterDescriptors$delegate.<anonymous>.<anonymous>' call
          var tmp$ret$0 = item.w5c();
          destination.e(tmp$ret$0);
        }
        tmp = destination;
      }
      return compactArray(tmp);
    };
  }
  function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.s5n());
    };
  }
  function PluginGeneratedSerialDescriptor$toString$lambda(this$0) {
    return function (i) {
      return this$0.v5e(i) + ': ' + this$0.t5e(i).b5e();
    };
  }
  function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
    generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
    this.q5m_1 = serialName;
    this.r5m_1 = generatedSerializer;
    this.s5m_1 = elementsCount;
    this.t5m_1 = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.s5m_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.u5m_1 = tmp_2;
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.s5m_1;
    tmp_3.v5m_1 = fillArrayVal(Array(size), null);
    this.w5m_1 = null;
    this.x5m_1 = booleanArray(this.s5m_1);
    this.y5m_1 = emptyMap();
    var tmp_4 = this;
    var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_4.z5m_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
    var tmp_6 = this;
    var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_6.a5n_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
    var tmp_8 = this;
    var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_8.b5n_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
  }
  protoOf(PluginGeneratedSerialDescriptor).b5e = function () {
    return this.q5m_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).p5e = function () {
    return this.s5m_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).r5e = function () {
    return CLASS_getInstance();
  };
  protoOf(PluginGeneratedSerialDescriptor).x5c = function () {
    var tmp0_elvis_lhs = this.w5m_1;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).t5f = function () {
    return this.y5m_1.u2();
  };
  protoOf(PluginGeneratedSerialDescriptor).s5n = function () {
    var tmp0 = this.a5n_1;
    // Inline function 'kotlin.getValue' call
    typeParameterDescriptors$factory();
    return tmp0.y();
  };
  protoOf(PluginGeneratedSerialDescriptor).t5n = function (name, isOptional) {
    this.t5m_1 = this.t5m_1 + 1 | 0;
    this.u5m_1[this.t5m_1] = name;
    this.x5m_1[this.t5m_1] = isOptional;
    this.v5m_1[this.t5m_1] = null;
    if (this.t5m_1 === (this.s5m_1 - 1 | 0)) {
      this.y5m_1 = buildIndices(this);
    }
  };
  protoOf(PluginGeneratedSerialDescriptor).c5n = function (name, isOptional, $super) {
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.t5n(name, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.t5n.call(this, name, isOptional);
    }
    return tmp;
  };
  protoOf(PluginGeneratedSerialDescriptor).t5e = function (index) {
    return getChecked(_get_childSerializers__7vnyfa(this), index).w5c();
  };
  protoOf(PluginGeneratedSerialDescriptor).w5e = function (index) {
    return getChecked_0(this.x5m_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).s5e = function (index) {
    var tmp0_elvis_lhs = getChecked(this.v5m_1, index);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).v5e = function (index) {
    return getChecked(this.u5m_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).u5e = function (name) {
    var tmp0_elvis_lhs = this.y5m_1.y2(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.b5e() === other.b5e())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.equals.<anonymous>' call
      if (!contentEquals(this.s5n(), other.s5n())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.p5e() === other.p5e())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.p5e();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.t5e(index).b5e() === other.t5e(index).b5e())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.t5e(index).r5e(), other.t5e(index).r5e())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(PluginGeneratedSerialDescriptor).hashCode = function () {
    return _get__hashCode__tgwhef_0(this);
  };
  protoOf(PluginGeneratedSerialDescriptor).toString = function () {
    var tmp = until(0, this.s5m_1);
    var tmp_0 = this.b5e() + '(';
    return joinToString_0(tmp, ', ', tmp_0, ')', VOID, VOID, PluginGeneratedSerialDescriptor$toString$lambda(this));
  };
  function hashCodeImpl(_this__u8e3s4, typeParams) {
    var result = getStringHashCode(_this__u8e3s4.b5e());
    result = imul(31, result) + contentHashCode(typeParams) | 0;
    var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var _iterator__ex2g4s = elementDescriptors.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = element.b5e();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var namesHash = accumulator;
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator_0 = 1;
    var _iterator__ex2g4s_0 = elementDescriptors.k();
    while (_iterator__ex2g4s_0.l()) {
      var element_0 = _iterator__ex2g4s_0.m();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash_0 = accumulator_0;
      var tmp_0 = imul(31, hash_0);
      // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver_0 = element_0.r5e();
      var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
      accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    }
    var kindHash = accumulator_0;
    result = imul(31, result) + namesHash | 0;
    result = imul(31, result) + kindHash | 0;
    return result;
  }
  function childSerializers$factory() {
    return getPropertyCallableRef('childSerializers', 1, KProperty1, function (receiver) {
      return _get_childSerializers__7vnyfa(receiver);
    }, null);
  }
  function typeParameterDescriptors$factory() {
    return getPropertyCallableRef('typeParameterDescriptors', 1, KProperty1, function (receiver) {
      return receiver.s5n();
    }, null);
  }
  function _hashCode$factory_0() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode__tgwhef_0(receiver);
    }, null);
  }
  function get_EMPTY_SERIALIZER_ARRAY() {
    _init_properties_PluginHelperInterfaces_kt__xgvzfp();
    return EMPTY_SERIALIZER_ARRAY;
  }
  var EMPTY_SERIALIZER_ARRAY;
  function SerializerFactory() {
  }
  function GeneratedSerializer() {
  }
  var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
  function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
    if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
      properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_SERIALIZER_ARRAY = [];
    }
  }
  function CharArraySerializer_0() {
    CharArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_4(Companion_getInstance()));
  }
  protoOf(CharArraySerializer_0).w5o = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(CharArraySerializer_0).q5k = function (_this__u8e3s4) {
    return this.w5o((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).x5o = function (_this__u8e3s4) {
    return new CharArrayBuilder(_this__u8e3s4);
  };
  protoOf(CharArraySerializer_0).l5j = function (_this__u8e3s4) {
    return this.x5o((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).b5m = function () {
    return charArray(0);
  };
  protoOf(CharArraySerializer_0).y5o = function (decoder, index, builder, checkIndex) {
    builder.b5p(decoder.s5g(this.s5l_1, index));
  };
  protoOf(CharArraySerializer_0).w5j = function (decoder, index, builder, checkIndex) {
    return this.y5o(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).c5m = function (decoder, index, builder, checkIndex) {
    return this.y5o(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).c5p = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.w5h(this.s5l_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(CharArraySerializer_0).d5m = function (encoder, content, size) {
    return this.c5p(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
  };
  var CharArraySerializer_instance;
  function CharArraySerializer_getInstance() {
    if (CharArraySerializer_instance == null)
      new CharArraySerializer_0();
    return CharArraySerializer_instance;
  }
  function DoubleArraySerializer_0() {
    DoubleArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_5(DoubleCompanionObject_instance));
  }
  protoOf(DoubleArraySerializer_0).f5p = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(DoubleArraySerializer_0).q5k = function (_this__u8e3s4) {
    return this.f5p((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).g5p = function (_this__u8e3s4) {
    return new DoubleArrayBuilder(_this__u8e3s4);
  };
  protoOf(DoubleArraySerializer_0).l5j = function (_this__u8e3s4) {
    return this.g5p((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).b5m = function () {
    return new Float64Array(0);
  };
  protoOf(DoubleArraySerializer_0).h5p = function (decoder, index, builder, checkIndex) {
    builder.k5p(decoder.r5g(this.s5l_1, index));
  };
  protoOf(DoubleArraySerializer_0).w5j = function (decoder, index, builder, checkIndex) {
    return this.h5p(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).c5m = function (decoder, index, builder, checkIndex) {
    return this.h5p(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).l5p = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.v5h(this.s5l_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(DoubleArraySerializer_0).d5m = function (encoder, content, size) {
    return this.l5p(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
  };
  var DoubleArraySerializer_instance;
  function DoubleArraySerializer_getInstance() {
    if (DoubleArraySerializer_instance == null)
      new DoubleArraySerializer_0();
    return DoubleArraySerializer_instance;
  }
  function FloatArraySerializer_0() {
    FloatArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_6(FloatCompanionObject_instance));
  }
  protoOf(FloatArraySerializer_0).o5p = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(FloatArraySerializer_0).q5k = function (_this__u8e3s4) {
    return this.o5p((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).p5p = function (_this__u8e3s4) {
    return new FloatArrayBuilder(_this__u8e3s4);
  };
  protoOf(FloatArraySerializer_0).l5j = function (_this__u8e3s4) {
    return this.p5p((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).b5m = function () {
    return new Float32Array(0);
  };
  protoOf(FloatArraySerializer_0).q5p = function (decoder, index, builder, checkIndex) {
    builder.t5p(decoder.q5g(this.s5l_1, index));
  };
  protoOf(FloatArraySerializer_0).w5j = function (decoder, index, builder, checkIndex) {
    return this.q5p(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).c5m = function (decoder, index, builder, checkIndex) {
    return this.q5p(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).u5p = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.u5h(this.s5l_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(FloatArraySerializer_0).d5m = function (encoder, content, size) {
    return this.u5p(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
  };
  var FloatArraySerializer_instance;
  function FloatArraySerializer_getInstance() {
    if (FloatArraySerializer_instance == null)
      new FloatArraySerializer_0();
    return FloatArraySerializer_instance;
  }
  function LongArraySerializer_0() {
    LongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_7(Companion_getInstance_2()));
  }
  protoOf(LongArraySerializer_0).x5p = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(LongArraySerializer_0).q5k = function (_this__u8e3s4) {
    return this.x5p((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).y5p = function (_this__u8e3s4) {
    return new LongArrayBuilder(_this__u8e3s4);
  };
  protoOf(LongArraySerializer_0).l5j = function (_this__u8e3s4) {
    return this.y5p((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).b5m = function () {
    return longArray(0);
  };
  protoOf(LongArraySerializer_0).z5p = function (decoder, index, builder, checkIndex) {
    builder.c5q(decoder.p5g(this.s5l_1, index));
  };
  protoOf(LongArraySerializer_0).w5j = function (decoder, index, builder, checkIndex) {
    return this.z5p(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).c5m = function (decoder, index, builder, checkIndex) {
    return this.z5p(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).d5q = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.t5h(this.s5l_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(LongArraySerializer_0).d5m = function (encoder, content, size) {
    return this.d5q(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
  };
  var LongArraySerializer_instance;
  function LongArraySerializer_getInstance() {
    if (LongArraySerializer_instance == null)
      new LongArraySerializer_0();
    return LongArraySerializer_instance;
  }
  function ULongArraySerializer_0() {
    ULongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_8(Companion_getInstance_20()));
  }
  protoOf(ULongArraySerializer_0).g5q = function (_this__u8e3s4) {
    return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).q5k = function (_this__u8e3s4) {
    return this.g5q(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.on_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).h5q = function (_this__u8e3s4) {
    return new ULongArrayBuilder(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).l5j = function (_this__u8e3s4) {
    return this.h5q(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.on_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).i5q = function () {
    return _ULongArray___init__impl__twm1l3_0(0);
  };
  protoOf(ULongArraySerializer_0).b5m = function () {
    return new ULongArray(this.i5q());
  };
  protoOf(ULongArraySerializer_0).j5q = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.u5g(this.s5l_1, index).b5g();
    var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
    builder.m5q(tmp$ret$0);
  };
  protoOf(ULongArraySerializer_0).w5j = function (decoder, index, builder, checkIndex) {
    return this.j5q(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).c5m = function (decoder, index, builder, checkIndex) {
    return this.j5q(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).n5q = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.y5h(this.s5l_1, i);
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = ULongArray__get_impl_pr71q9(content, i);
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
        tmp.i5h(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(ULongArraySerializer_0).d5m = function (encoder, content, size) {
    return this.n5q(encoder, content instanceof ULongArray ? content.on_1 : THROW_CCE(), size);
  };
  var ULongArraySerializer_instance;
  function ULongArraySerializer_getInstance() {
    if (ULongArraySerializer_instance == null)
      new ULongArraySerializer_0();
    return ULongArraySerializer_instance;
  }
  function IntArraySerializer_0() {
    IntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_9(IntCompanionObject_instance));
  }
  protoOf(IntArraySerializer_0).q5q = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(IntArraySerializer_0).q5k = function (_this__u8e3s4) {
    return this.q5q((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).r5q = function (_this__u8e3s4) {
    return new IntArrayBuilder(_this__u8e3s4);
  };
  protoOf(IntArraySerializer_0).l5j = function (_this__u8e3s4) {
    return this.r5q((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).b5m = function () {
    return new Int32Array(0);
  };
  protoOf(IntArraySerializer_0).s5q = function (decoder, index, builder, checkIndex) {
    builder.v5q(decoder.o5g(this.s5l_1, index));
  };
  protoOf(IntArraySerializer_0).w5j = function (decoder, index, builder, checkIndex) {
    return this.s5q(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).c5m = function (decoder, index, builder, checkIndex) {
    return this.s5q(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).w5q = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.s5h(this.s5l_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(IntArraySerializer_0).d5m = function (encoder, content, size) {
    return this.w5q(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
  };
  var IntArraySerializer_instance;
  function IntArraySerializer_getInstance() {
    if (IntArraySerializer_instance == null)
      new IntArraySerializer_0();
    return IntArraySerializer_instance;
  }
  function UIntArraySerializer_0() {
    UIntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_10(Companion_getInstance_19()));
  }
  protoOf(UIntArraySerializer_0).z5q = function (_this__u8e3s4) {
    return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).q5k = function (_this__u8e3s4) {
    return this.z5q(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.dn_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).a5r = function (_this__u8e3s4) {
    return new UIntArrayBuilder(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).l5j = function (_this__u8e3s4) {
    return this.a5r(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.dn_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).b5r = function () {
    return _UIntArray___init__impl__ghjpc6_0(0);
  };
  protoOf(UIntArraySerializer_0).b5m = function () {
    return new UIntArray(this.b5r());
  };
  protoOf(UIntArraySerializer_0).c5r = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.u5g(this.s5l_1, index).a5g();
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
    builder.f5r(tmp$ret$0);
  };
  protoOf(UIntArraySerializer_0).w5j = function (decoder, index, builder, checkIndex) {
    return this.c5r(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).c5m = function (decoder, index, builder, checkIndex) {
    return this.c5r(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).g5r = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.y5h(this.s5l_1, i);
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = UIntArray__get_impl_gp5kza(content, i);
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
        tmp.h5h(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UIntArraySerializer_0).d5m = function (encoder, content, size) {
    return this.g5r(encoder, content instanceof UIntArray ? content.dn_1 : THROW_CCE(), size);
  };
  var UIntArraySerializer_instance;
  function UIntArraySerializer_getInstance() {
    if (UIntArraySerializer_instance == null)
      new UIntArraySerializer_0();
    return UIntArraySerializer_instance;
  }
  function ShortArraySerializer_0() {
    ShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_11(ShortCompanionObject_instance));
  }
  protoOf(ShortArraySerializer_0).j5r = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ShortArraySerializer_0).q5k = function (_this__u8e3s4) {
    return this.j5r((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).k5r = function (_this__u8e3s4) {
    return new ShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(ShortArraySerializer_0).l5j = function (_this__u8e3s4) {
    return this.k5r((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).b5m = function () {
    return new Int16Array(0);
  };
  protoOf(ShortArraySerializer_0).l5r = function (decoder, index, builder, checkIndex) {
    builder.o5r(decoder.n5g(this.s5l_1, index));
  };
  protoOf(ShortArraySerializer_0).w5j = function (decoder, index, builder, checkIndex) {
    return this.l5r(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).c5m = function (decoder, index, builder, checkIndex) {
    return this.l5r(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).p5r = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.r5h(this.s5l_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ShortArraySerializer_0).d5m = function (encoder, content, size) {
    return this.p5r(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ShortArraySerializer_instance;
  function ShortArraySerializer_getInstance() {
    if (ShortArraySerializer_instance == null)
      new ShortArraySerializer_0();
    return ShortArraySerializer_instance;
  }
  function UShortArraySerializer_0() {
    UShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_12(Companion_getInstance_21()));
  }
  protoOf(UShortArraySerializer_0).s5r = function (_this__u8e3s4) {
    return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).q5k = function (_this__u8e3s4) {
    return this.s5r(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.zn_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).t5r = function (_this__u8e3s4) {
    return new UShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).l5j = function (_this__u8e3s4) {
    return this.t5r(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.zn_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).u5r = function () {
    return _UShortArray___init__impl__9b26ef_0(0);
  };
  protoOf(UShortArraySerializer_0).b5m = function () {
    return new UShortArray(this.u5r());
  };
  protoOf(UShortArraySerializer_0).v5r = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.u5g(this.s5l_1, index).z5f();
    var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
    builder.y5r(tmp$ret$0);
  };
  protoOf(UShortArraySerializer_0).w5j = function (decoder, index, builder, checkIndex) {
    return this.v5r(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).c5m = function (decoder, index, builder, checkIndex) {
    return this.v5r(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).z5r = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.y5h(this.s5l_1, i);
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = UShortArray__get_impl_fnbhmx(content, i);
        var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
        tmp.g5h(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UShortArraySerializer_0).d5m = function (encoder, content, size) {
    return this.z5r(encoder, content instanceof UShortArray ? content.zn_1 : THROW_CCE(), size);
  };
  var UShortArraySerializer_instance;
  function UShortArraySerializer_getInstance() {
    if (UShortArraySerializer_instance == null)
      new UShortArraySerializer_0();
    return UShortArraySerializer_instance;
  }
  function ByteArraySerializer_0() {
    ByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_13(ByteCompanionObject_instance));
  }
  protoOf(ByteArraySerializer_0).c5s = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ByteArraySerializer_0).q5k = function (_this__u8e3s4) {
    return this.c5s((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).d5s = function (_this__u8e3s4) {
    return new ByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(ByteArraySerializer_0).l5j = function (_this__u8e3s4) {
    return this.d5s((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).b5m = function () {
    return new Int8Array(0);
  };
  protoOf(ByteArraySerializer_0).e5s = function (decoder, index, builder, checkIndex) {
    builder.h5s(decoder.m5g(this.s5l_1, index));
  };
  protoOf(ByteArraySerializer_0).w5j = function (decoder, index, builder, checkIndex) {
    return this.e5s(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).c5m = function (decoder, index, builder, checkIndex) {
    return this.e5s(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).i5s = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.q5h(this.s5l_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ByteArraySerializer_0).d5m = function (encoder, content, size) {
    return this.i5s(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ByteArraySerializer_instance;
  function ByteArraySerializer_getInstance() {
    if (ByteArraySerializer_instance == null)
      new ByteArraySerializer_0();
    return ByteArraySerializer_instance;
  }
  function UByteArraySerializer_0() {
    UByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_14(Companion_getInstance_18()));
  }
  protoOf(UByteArraySerializer_0).l5s = function (_this__u8e3s4) {
    return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).q5k = function (_this__u8e3s4) {
    return this.l5s(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.rm_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).m5s = function (_this__u8e3s4) {
    return new UByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).l5j = function (_this__u8e3s4) {
    return this.m5s(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.rm_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).n5s = function () {
    return _UByteArray___init__impl__ip4y9n_0(0);
  };
  protoOf(UByteArraySerializer_0).b5m = function () {
    return new UByteArray(this.n5s());
  };
  protoOf(UByteArraySerializer_0).o5s = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.u5g(this.s5l_1, index).y5f();
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
    builder.r5s(tmp$ret$0);
  };
  protoOf(UByteArraySerializer_0).w5j = function (decoder, index, builder, checkIndex) {
    return this.o5s(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).c5m = function (decoder, index, builder, checkIndex) {
    return this.o5s(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).s5s = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.y5h(this.s5l_1, i);
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = UByteArray__get_impl_t5f3hv(content, i);
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
        tmp.f5h(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UByteArraySerializer_0).d5m = function (encoder, content, size) {
    return this.s5s(encoder, content instanceof UByteArray ? content.rm_1 : THROW_CCE(), size);
  };
  var UByteArraySerializer_instance;
  function UByteArraySerializer_getInstance() {
    if (UByteArraySerializer_instance == null)
      new UByteArraySerializer_0();
    return UByteArraySerializer_instance;
  }
  function BooleanArraySerializer_0() {
    BooleanArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_15(BooleanCompanionObject_instance));
  }
  protoOf(BooleanArraySerializer_0).v5s = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(BooleanArraySerializer_0).q5k = function (_this__u8e3s4) {
    return this.v5s((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).w5s = function (_this__u8e3s4) {
    return new BooleanArrayBuilder(_this__u8e3s4);
  };
  protoOf(BooleanArraySerializer_0).l5j = function (_this__u8e3s4) {
    return this.w5s((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).b5m = function () {
    return booleanArray(0);
  };
  protoOf(BooleanArraySerializer_0).x5s = function (decoder, index, builder, checkIndex) {
    builder.a5t(decoder.l5g(this.s5l_1, index));
  };
  protoOf(BooleanArraySerializer_0).w5j = function (decoder, index, builder, checkIndex) {
    return this.x5s(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).c5m = function (decoder, index, builder, checkIndex) {
    return this.x5s(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).b5t = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.p5h(this.s5l_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(BooleanArraySerializer_0).d5m = function (encoder, content, size) {
    return this.b5t(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
  };
  var BooleanArraySerializer_instance;
  function BooleanArraySerializer_getInstance() {
    if (BooleanArraySerializer_instance == null)
      new BooleanArraySerializer_0();
    return BooleanArraySerializer_instance;
  }
  function CharArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.z5o_1 = bufferWithData;
    this.a5p_1 = bufferWithData.length;
    this.y5l(10);
  }
  protoOf(CharArrayBuilder).u5l = function () {
    return this.a5p_1;
  };
  protoOf(CharArrayBuilder).y5l = function (requiredCapacity) {
    if (this.z5o_1.length < requiredCapacity)
      this.z5o_1 = copyOf(this.z5o_1, coerceAtLeast(requiredCapacity, imul(this.z5o_1.length, 2)));
  };
  protoOf(CharArrayBuilder).b5p = function (c) {
    this.f5m();
    var tmp = this.z5o_1;
    var tmp1 = this.a5p_1;
    this.a5p_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(CharArrayBuilder).w5l = function () {
    return copyOf(this.z5o_1, this.a5p_1);
  };
  function DoubleArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.i5p_1 = bufferWithData;
    this.j5p_1 = bufferWithData.length;
    this.y5l(10);
  }
  protoOf(DoubleArrayBuilder).u5l = function () {
    return this.j5p_1;
  };
  protoOf(DoubleArrayBuilder).y5l = function (requiredCapacity) {
    if (this.i5p_1.length < requiredCapacity)
      this.i5p_1 = copyOf_0(this.i5p_1, coerceAtLeast(requiredCapacity, imul(this.i5p_1.length, 2)));
  };
  protoOf(DoubleArrayBuilder).k5p = function (c) {
    this.f5m();
    var tmp = this.i5p_1;
    var tmp1 = this.j5p_1;
    this.j5p_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(DoubleArrayBuilder).w5l = function () {
    return copyOf_0(this.i5p_1, this.j5p_1);
  };
  function FloatArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.r5p_1 = bufferWithData;
    this.s5p_1 = bufferWithData.length;
    this.y5l(10);
  }
  protoOf(FloatArrayBuilder).u5l = function () {
    return this.s5p_1;
  };
  protoOf(FloatArrayBuilder).y5l = function (requiredCapacity) {
    if (this.r5p_1.length < requiredCapacity)
      this.r5p_1 = copyOf_1(this.r5p_1, coerceAtLeast(requiredCapacity, imul(this.r5p_1.length, 2)));
  };
  protoOf(FloatArrayBuilder).t5p = function (c) {
    this.f5m();
    var tmp = this.r5p_1;
    var tmp1 = this.s5p_1;
    this.s5p_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(FloatArrayBuilder).w5l = function () {
    return copyOf_1(this.r5p_1, this.s5p_1);
  };
  function LongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.a5q_1 = bufferWithData;
    this.b5q_1 = bufferWithData.length;
    this.y5l(10);
  }
  protoOf(LongArrayBuilder).u5l = function () {
    return this.b5q_1;
  };
  protoOf(LongArrayBuilder).y5l = function (requiredCapacity) {
    if (this.a5q_1.length < requiredCapacity)
      this.a5q_1 = copyOf_2(this.a5q_1, coerceAtLeast(requiredCapacity, imul(this.a5q_1.length, 2)));
  };
  protoOf(LongArrayBuilder).c5q = function (c) {
    this.f5m();
    var tmp = this.a5q_1;
    var tmp1 = this.b5q_1;
    this.b5q_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(LongArrayBuilder).w5l = function () {
    return copyOf_2(this.a5q_1, this.b5q_1);
  };
  function ULongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.k5q_1 = bufferWithData;
    this.l5q_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
    this.y5l(10);
  }
  protoOf(ULongArrayBuilder).u5l = function () {
    return this.l5q_1;
  };
  protoOf(ULongArrayBuilder).y5l = function (requiredCapacity) {
    if (_ULongArray___get_size__impl__ju6dtr(this.k5q_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.k5q_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.k5q_1), 2));
      tmp.k5q_1 = _ULongArray___init__impl__twm1l3(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
    }
  };
  protoOf(ULongArrayBuilder).m5q = function (c) {
    this.f5m();
    var tmp = this.k5q_1;
    var tmp1 = this.l5q_1;
    this.l5q_1 = tmp1 + 1 | 0;
    ULongArray__set_impl_z19mvh(tmp, tmp1, c);
  };
  protoOf(ULongArrayBuilder).c5t = function () {
    var tmp0 = this.k5q_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.l5q_1;
    return _ULongArray___init__impl__twm1l3(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
  };
  protoOf(ULongArrayBuilder).w5l = function () {
    return new ULongArray(this.c5t());
  };
  function IntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.t5q_1 = bufferWithData;
    this.u5q_1 = bufferWithData.length;
    this.y5l(10);
  }
  protoOf(IntArrayBuilder).u5l = function () {
    return this.u5q_1;
  };
  protoOf(IntArrayBuilder).y5l = function (requiredCapacity) {
    if (this.t5q_1.length < requiredCapacity)
      this.t5q_1 = copyOf_3(this.t5q_1, coerceAtLeast(requiredCapacity, imul(this.t5q_1.length, 2)));
  };
  protoOf(IntArrayBuilder).v5q = function (c) {
    this.f5m();
    var tmp = this.t5q_1;
    var tmp1 = this.u5q_1;
    this.u5q_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(IntArrayBuilder).w5l = function () {
    return copyOf_3(this.t5q_1, this.u5q_1);
  };
  function UIntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.d5r_1 = bufferWithData;
    this.e5r_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
    this.y5l(10);
  }
  protoOf(UIntArrayBuilder).u5l = function () {
    return this.e5r_1;
  };
  protoOf(UIntArrayBuilder).y5l = function (requiredCapacity) {
    if (_UIntArray___get_size__impl__r6l8ci(this.d5r_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.d5r_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.d5r_1), 2));
      tmp.d5r_1 = _UIntArray___init__impl__ghjpc6(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
    }
  };
  protoOf(UIntArrayBuilder).f5r = function (c) {
    this.f5m();
    var tmp = this.d5r_1;
    var tmp1 = this.e5r_1;
    this.e5r_1 = tmp1 + 1 | 0;
    UIntArray__set_impl_7f2zu2(tmp, tmp1, c);
  };
  protoOf(UIntArrayBuilder).d5t = function () {
    var tmp0 = this.d5r_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.e5r_1;
    return _UIntArray___init__impl__ghjpc6(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
  };
  protoOf(UIntArrayBuilder).w5l = function () {
    return new UIntArray(this.d5t());
  };
  function ShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.m5r_1 = bufferWithData;
    this.n5r_1 = bufferWithData.length;
    this.y5l(10);
  }
  protoOf(ShortArrayBuilder).u5l = function () {
    return this.n5r_1;
  };
  protoOf(ShortArrayBuilder).y5l = function (requiredCapacity) {
    if (this.m5r_1.length < requiredCapacity)
      this.m5r_1 = copyOf_4(this.m5r_1, coerceAtLeast(requiredCapacity, imul(this.m5r_1.length, 2)));
  };
  protoOf(ShortArrayBuilder).o5r = function (c) {
    this.f5m();
    var tmp = this.m5r_1;
    var tmp1 = this.n5r_1;
    this.n5r_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(ShortArrayBuilder).w5l = function () {
    return copyOf_4(this.m5r_1, this.n5r_1);
  };
  function UShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.w5r_1 = bufferWithData;
    this.x5r_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
    this.y5l(10);
  }
  protoOf(UShortArrayBuilder).u5l = function () {
    return this.x5r_1;
  };
  protoOf(UShortArrayBuilder).y5l = function (requiredCapacity) {
    if (_UShortArray___get_size__impl__jqto1b(this.w5r_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.w5r_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.w5r_1), 2));
      tmp.w5r_1 = _UShortArray___init__impl__9b26ef(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
    }
  };
  protoOf(UShortArrayBuilder).y5r = function (c) {
    this.f5m();
    var tmp = this.w5r_1;
    var tmp1 = this.x5r_1;
    this.x5r_1 = tmp1 + 1 | 0;
    UShortArray__set_impl_6d8whp(tmp, tmp1, c);
  };
  protoOf(UShortArrayBuilder).e5t = function () {
    var tmp0 = this.w5r_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.x5r_1;
    return _UShortArray___init__impl__9b26ef(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
  };
  protoOf(UShortArrayBuilder).w5l = function () {
    return new UShortArray(this.e5t());
  };
  function ByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.f5s_1 = bufferWithData;
    this.g5s_1 = bufferWithData.length;
    this.y5l(10);
  }
  protoOf(ByteArrayBuilder).u5l = function () {
    return this.g5s_1;
  };
  protoOf(ByteArrayBuilder).y5l = function (requiredCapacity) {
    if (this.f5s_1.length < requiredCapacity)
      this.f5s_1 = copyOf_5(this.f5s_1, coerceAtLeast(requiredCapacity, imul(this.f5s_1.length, 2)));
  };
  protoOf(ByteArrayBuilder).h5s = function (c) {
    this.f5m();
    var tmp = this.f5s_1;
    var tmp1 = this.g5s_1;
    this.g5s_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(ByteArrayBuilder).w5l = function () {
    return copyOf_5(this.f5s_1, this.g5s_1);
  };
  function UByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.p5s_1 = bufferWithData;
    this.q5s_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
    this.y5l(10);
  }
  protoOf(UByteArrayBuilder).u5l = function () {
    return this.q5s_1;
  };
  protoOf(UByteArrayBuilder).y5l = function (requiredCapacity) {
    if (_UByteArray___get_size__impl__h6pkdv(this.p5s_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.p5s_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.p5s_1), 2));
      tmp.p5s_1 = _UByteArray___init__impl__ip4y9n(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
    }
  };
  protoOf(UByteArrayBuilder).r5s = function (c) {
    this.f5m();
    var tmp = this.p5s_1;
    var tmp1 = this.q5s_1;
    this.q5s_1 = tmp1 + 1 | 0;
    UByteArray__set_impl_jvcicn(tmp, tmp1, c);
  };
  protoOf(UByteArrayBuilder).f5t = function () {
    var tmp0 = this.p5s_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.q5s_1;
    return _UByteArray___init__impl__ip4y9n(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
  };
  protoOf(UByteArrayBuilder).w5l = function () {
    return new UByteArray(this.f5t());
  };
  function BooleanArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.y5s_1 = bufferWithData;
    this.z5s_1 = bufferWithData.length;
    this.y5l(10);
  }
  protoOf(BooleanArrayBuilder).u5l = function () {
    return this.z5s_1;
  };
  protoOf(BooleanArrayBuilder).y5l = function (requiredCapacity) {
    if (this.y5s_1.length < requiredCapacity)
      this.y5s_1 = copyOf_6(this.y5s_1, coerceAtLeast(requiredCapacity, imul(this.y5s_1.length, 2)));
  };
  protoOf(BooleanArrayBuilder).a5t = function (c) {
    this.f5m();
    var tmp = this.y5s_1;
    var tmp1 = this.z5s_1;
    this.z5s_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  };
  protoOf(BooleanArrayBuilder).w5l = function () {
    return copyOf_6(this.y5s_1, this.z5s_1);
  };
  function get_BUILTIN_SERIALIZERS() {
    _init_properties_Primitives_kt__k0eto4();
    return BUILTIN_SERIALIZERS;
  }
  var BUILTIN_SERIALIZERS;
  function builtinSerializerOrNull(_this__u8e3s4) {
    _init_properties_Primitives_kt__k0eto4();
    var tmp = get_BUILTIN_SERIALIZERS().y2(_this__u8e3s4);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
  }
  function StringSerializer() {
    StringSerializer_instance = this;
    this.g5t_1 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
  }
  protoOf(StringSerializer).w5c = function () {
    return this.g5t_1;
  };
  protoOf(StringSerializer).h5t = function (encoder, value) {
    return encoder.m5h(value);
  };
  protoOf(StringSerializer).j5d = function (encoder, value) {
    return this.h5t(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(StringSerializer).k5d = function (decoder) {
    return decoder.f5g();
  };
  var StringSerializer_instance;
  function StringSerializer_getInstance() {
    if (StringSerializer_instance == null)
      new StringSerializer();
    return StringSerializer_instance;
  }
  function CharSerializer() {
    CharSerializer_instance = this;
    this.i5t_1 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
  }
  protoOf(CharSerializer).w5c = function () {
    return this.i5t_1;
  };
  protoOf(CharSerializer).j5t = function (encoder, value) {
    return encoder.l5h(value);
  };
  protoOf(CharSerializer).j5d = function (encoder, value) {
    return this.j5t(encoder, value instanceof Char ? value.v1_1 : THROW_CCE());
  };
  protoOf(CharSerializer).k5t = function (decoder) {
    return decoder.e5g();
  };
  protoOf(CharSerializer).k5d = function (decoder) {
    return new Char(this.k5t(decoder));
  };
  var CharSerializer_instance;
  function CharSerializer_getInstance() {
    if (CharSerializer_instance == null)
      new CharSerializer();
    return CharSerializer_instance;
  }
  function DoubleSerializer() {
    DoubleSerializer_instance = this;
    this.l5t_1 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
  }
  protoOf(DoubleSerializer).w5c = function () {
    return this.l5t_1;
  };
  protoOf(DoubleSerializer).m5t = function (encoder, value) {
    return encoder.k5h(value);
  };
  protoOf(DoubleSerializer).j5d = function (encoder, value) {
    return this.m5t(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(DoubleSerializer).k5d = function (decoder) {
    return decoder.d5g();
  };
  var DoubleSerializer_instance;
  function DoubleSerializer_getInstance() {
    if (DoubleSerializer_instance == null)
      new DoubleSerializer();
    return DoubleSerializer_instance;
  }
  function FloatSerializer() {
    FloatSerializer_instance = this;
    this.n5t_1 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
  }
  protoOf(FloatSerializer).w5c = function () {
    return this.n5t_1;
  };
  protoOf(FloatSerializer).o5t = function (encoder, value) {
    return encoder.j5h(value);
  };
  protoOf(FloatSerializer).j5d = function (encoder, value) {
    return this.o5t(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(FloatSerializer).k5d = function (decoder) {
    return decoder.c5g();
  };
  var FloatSerializer_instance;
  function FloatSerializer_getInstance() {
    if (FloatSerializer_instance == null)
      new FloatSerializer();
    return FloatSerializer_instance;
  }
  function LongSerializer() {
    LongSerializer_instance = this;
    this.p5t_1 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
  }
  protoOf(LongSerializer).w5c = function () {
    return this.p5t_1;
  };
  protoOf(LongSerializer).q5t = function (encoder, value) {
    return encoder.i5h(value);
  };
  protoOf(LongSerializer).j5d = function (encoder, value) {
    return this.q5t(encoder, value instanceof Long ? value : THROW_CCE());
  };
  protoOf(LongSerializer).k5d = function (decoder) {
    return decoder.b5g();
  };
  var LongSerializer_instance;
  function LongSerializer_getInstance() {
    if (LongSerializer_instance == null)
      new LongSerializer();
    return LongSerializer_instance;
  }
  function IntSerializer() {
    IntSerializer_instance = this;
    this.r5t_1 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
  }
  protoOf(IntSerializer).w5c = function () {
    return this.r5t_1;
  };
  protoOf(IntSerializer).s5t = function (encoder, value) {
    return encoder.h5h(value);
  };
  protoOf(IntSerializer).j5d = function (encoder, value) {
    return this.s5t(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(IntSerializer).k5d = function (decoder) {
    return decoder.a5g();
  };
  var IntSerializer_instance;
  function IntSerializer_getInstance() {
    if (IntSerializer_instance == null)
      new IntSerializer();
    return IntSerializer_instance;
  }
  function ShortSerializer() {
    ShortSerializer_instance = this;
    this.t5t_1 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
  }
  protoOf(ShortSerializer).w5c = function () {
    return this.t5t_1;
  };
  protoOf(ShortSerializer).u5t = function (encoder, value) {
    return encoder.g5h(value);
  };
  protoOf(ShortSerializer).j5d = function (encoder, value) {
    return this.u5t(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ShortSerializer).k5d = function (decoder) {
    return decoder.z5f();
  };
  var ShortSerializer_instance;
  function ShortSerializer_getInstance() {
    if (ShortSerializer_instance == null)
      new ShortSerializer();
    return ShortSerializer_instance;
  }
  function ByteSerializer() {
    ByteSerializer_instance = this;
    this.v5t_1 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
  }
  protoOf(ByteSerializer).w5c = function () {
    return this.v5t_1;
  };
  protoOf(ByteSerializer).w5t = function (encoder, value) {
    return encoder.f5h(value);
  };
  protoOf(ByteSerializer).j5d = function (encoder, value) {
    return this.w5t(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ByteSerializer).k5d = function (decoder) {
    return decoder.y5f();
  };
  var ByteSerializer_instance;
  function ByteSerializer_getInstance() {
    if (ByteSerializer_instance == null)
      new ByteSerializer();
    return ByteSerializer_instance;
  }
  function BooleanSerializer() {
    BooleanSerializer_instance = this;
    this.x5t_1 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
  }
  protoOf(BooleanSerializer).w5c = function () {
    return this.x5t_1;
  };
  protoOf(BooleanSerializer).y5t = function (encoder, value) {
    return encoder.e5h(value);
  };
  protoOf(BooleanSerializer).j5d = function (encoder, value) {
    return this.y5t(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  protoOf(BooleanSerializer).k5d = function (decoder) {
    return decoder.x5f();
  };
  var BooleanSerializer_instance;
  function BooleanSerializer_getInstance() {
    if (BooleanSerializer_instance == null)
      new BooleanSerializer();
    return BooleanSerializer_instance;
  }
  function UnitSerializer() {
    UnitSerializer_instance = this;
    this.z5t_1 = new ObjectSerializer('kotlin.Unit', Unit_instance);
  }
  protoOf(UnitSerializer).w5c = function () {
    return this.z5t_1.w5c();
  };
  protoOf(UnitSerializer).a5u = function (decoder) {
    this.z5t_1.k5d(decoder);
  };
  protoOf(UnitSerializer).k5d = function (decoder) {
    this.a5u(decoder);
    return Unit_instance;
  };
  protoOf(UnitSerializer).b5u = function (encoder, value) {
    this.z5t_1.g5d(encoder, Unit_instance);
  };
  protoOf(UnitSerializer).j5d = function (encoder, value) {
    return this.b5u(encoder, value instanceof Unit ? value : THROW_CCE());
  };
  var UnitSerializer_instance;
  function UnitSerializer_getInstance() {
    if (UnitSerializer_instance == null)
      new UnitSerializer();
    return UnitSerializer_instance;
  }
  function error_0($this) {
    throw IllegalStateException_init_$Create$_0('Primitive descriptor does not have elements');
  }
  function PrimitiveSerialDescriptor_0(serialName, kind) {
    this.c5u_1 = serialName;
    this.d5u_1 = kind;
  }
  protoOf(PrimitiveSerialDescriptor_0).b5e = function () {
    return this.c5u_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).r5e = function () {
    return this.d5u_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).p5e = function () {
    return 0;
  };
  protoOf(PrimitiveSerialDescriptor_0).v5e = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).u5e = function (name) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).w5e = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).t5e = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).s5e = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).toString = function () {
    return 'PrimitiveDescriptor(' + this.c5u_1 + ')';
  };
  protoOf(PrimitiveSerialDescriptor_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimitiveSerialDescriptor_0))
      return false;
    if (this.c5u_1 === other.c5u_1 && equals(this.d5u_1, other.d5u_1))
      return true;
    return false;
  };
  protoOf(PrimitiveSerialDescriptor_0).hashCode = function () {
    return getStringHashCode(this.c5u_1) + imul(31, this.d5u_1.hashCode()) | 0;
  };
  function PrimitiveDescriptorSafe(serialName, kind) {
    _init_properties_Primitives_kt__k0eto4();
    checkName(serialName);
    return new PrimitiveSerialDescriptor_0(serialName, kind);
  }
  function checkName(serialName) {
    _init_properties_Primitives_kt__k0eto4();
    var keys = get_BUILTIN_SERIALIZERS().u2();
    var tmp0_iterator = keys.k();
    while (tmp0_iterator.l()) {
      var primitive = tmp0_iterator.m();
      var simpleName = capitalize(ensureNotNull(primitive.lb()));
      var qualifiedName = 'kotlin.' + simpleName;
      if (equals_0(serialName, qualifiedName, true) || equals_0(serialName, simpleName, true)) {
        throw IllegalArgumentException_init_$Create$_0(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exist ' + capitalize(simpleName) + 'Serializer.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
      }
    }
  }
  function capitalize(_this__u8e3s4) {
    _init_properties_Primitives_kt__k0eto4();
    // Inline function 'kotlin.text.replaceFirstChar' call
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(_this__u8e3s4) > 0) {
      // Inline function 'kotlinx.serialization.internal.capitalize.<anonymous>' call
      var it = charSequenceGet(_this__u8e3s4, 0);
      var tmp$ret$1 = isLowerCase(it) ? titlecase(it) : toString(it);
      var tmp_0 = toString_1(tmp$ret$1);
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = tmp_0 + _this__u8e3s4.substring(1);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  var properties_initialized_Primitives_kt_6dpii6;
  function _init_properties_Primitives_kt__k0eto4() {
    if (!properties_initialized_Primitives_kt_6dpii6) {
      properties_initialized_Primitives_kt_6dpii6 = true;
      BUILTIN_SERIALIZERS = mapOf_0([to(PrimitiveClasses_getInstance().nc(), serializer_3(StringCompanionObject_instance)), to(getKClass(Char), serializer_4(Companion_getInstance())), to(PrimitiveClasses_getInstance().qc(), CharArraySerializer()), to(PrimitiveClasses_getInstance().lc(), serializer_5(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().wc(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance().kc(), serializer_6(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().vc(), FloatArraySerializer()), to(getKClass(Long), serializer_7(Companion_getInstance_2())), to(PrimitiveClasses_getInstance().uc(), LongArraySerializer()), to(getKClass(ULong), serializer_8(Companion_getInstance_20())), to(getKClass(ULongArray), ULongArraySerializer()), to(PrimitiveClasses_getInstance().jc(), serializer_9(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().tc(), IntArraySerializer()), to(getKClass(UInt), serializer_10(Companion_getInstance_19())), to(getKClass(UIntArray), UIntArraySerializer()), to(PrimitiveClasses_getInstance().ic(), serializer_11(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().sc(), ShortArraySerializer()), to(getKClass(UShort), serializer_12(Companion_getInstance_21())), to(getKClass(UShortArray), UShortArraySerializer()), to(PrimitiveClasses_getInstance().hc(), serializer_13(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().rc(), ByteArraySerializer()), to(getKClass(UByte), serializer_14(Companion_getInstance_18())), to(getKClass(UByteArray), UByteArraySerializer()), to(PrimitiveClasses_getInstance().gc(), serializer_15(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().pc(), BooleanArraySerializer()), to(getKClass(Unit), serializer_16(Unit_instance)), to(PrimitiveClasses_getInstance().fc(), NothingSerializer()), to(getKClass(Duration), serializer_17(Companion_getInstance_16()))]);
    }
  }
  function NamedValueEncoder() {
    TaggedEncoder.call(this);
  }
  protoOf(NamedValueEncoder).f5u = function (_this__u8e3s4, index) {
    return this.h5u(this.g5u(_this__u8e3s4, index));
  };
  protoOf(NamedValueEncoder).h5u = function (nestedName) {
    var tmp0_elvis_lhs = this.j5u();
    return this.k5u(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  };
  protoOf(NamedValueEncoder).g5u = function (descriptor, index) {
    return descriptor.v5e(index);
  };
  protoOf(NamedValueEncoder).k5u = function (parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  };
  function NamedValueDecoder() {
    TaggedDecoder.call(this);
  }
  protoOf(NamedValueDecoder).f5u = function (_this__u8e3s4, index) {
    return this.h5u(this.g5u(_this__u8e3s4, index));
  };
  protoOf(NamedValueDecoder).h5u = function (nestedName) {
    var tmp0_elvis_lhs = this.j5u();
    return this.k5u(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  };
  protoOf(NamedValueDecoder).g5u = function (descriptor, index) {
    return descriptor.v5e(index);
  };
  protoOf(NamedValueDecoder).k5u = function (parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  };
  function encodeElement($this, desc, index) {
    var tag = $this.f5u(desc, index);
    $this.b5v(tag);
    return true;
  }
  function TaggedEncoder() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.i5u_1 = ArrayList_init_$Create$();
  }
  protoOf(TaggedEncoder).h5d = function () {
    return EmptySerializersModule_0();
  };
  protoOf(TaggedEncoder).l5u = function (tag, value) {
    throw SerializationException_init_$Create$_0('Non-serializable ' + toString_1(getKClassFromExpression(value)) + ' is not supported by ' + toString_1(getKClassFromExpression(this)) + ' encoder');
  };
  protoOf(TaggedEncoder).m5u = function (tag) {
  };
  protoOf(TaggedEncoder).n5u = function (tag) {
    throw SerializationException_init_$Create$_0('null is not supported');
  };
  protoOf(TaggedEncoder).o5u = function (tag, value) {
    return this.l5u(tag, value);
  };
  protoOf(TaggedEncoder).p5u = function (tag, value) {
    return this.l5u(tag, value);
  };
  protoOf(TaggedEncoder).q5u = function (tag, value) {
    return this.l5u(tag, value);
  };
  protoOf(TaggedEncoder).r5u = function (tag, value) {
    return this.l5u(tag, value);
  };
  protoOf(TaggedEncoder).s5u = function (tag, value) {
    return this.l5u(tag, value);
  };
  protoOf(TaggedEncoder).t5u = function (tag, value) {
    return this.l5u(tag, value);
  };
  protoOf(TaggedEncoder).u5u = function (tag, value) {
    return this.l5u(tag, value);
  };
  protoOf(TaggedEncoder).v5u = function (tag, value) {
    return this.l5u(tag, new Char(value));
  };
  protoOf(TaggedEncoder).w5u = function (tag, value) {
    return this.l5u(tag, value);
  };
  protoOf(TaggedEncoder).x5u = function (tag, enumDescriptor, ordinal) {
    return this.l5u(tag, ordinal);
  };
  protoOf(TaggedEncoder).y5u = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlinx.serialization.internal.TaggedEncoder.encodeTaggedInline.<anonymous>' call
    this.b5v(tag);
    return this;
  };
  protoOf(TaggedEncoder).o5h = function (descriptor) {
    return this.y5u(this.c5v(), descriptor);
  };
  protoOf(TaggedEncoder).c5i = function () {
    return this.m5u(this.a5v());
  };
  protoOf(TaggedEncoder).d5h = function () {
    return this.n5u(this.c5v());
  };
  protoOf(TaggedEncoder).e5h = function (value) {
    return this.u5u(this.c5v(), value);
  };
  protoOf(TaggedEncoder).f5h = function (value) {
    return this.p5u(this.c5v(), value);
  };
  protoOf(TaggedEncoder).g5h = function (value) {
    return this.q5u(this.c5v(), value);
  };
  protoOf(TaggedEncoder).h5h = function (value) {
    return this.o5u(this.c5v(), value);
  };
  protoOf(TaggedEncoder).i5h = function (value) {
    return this.r5u(this.c5v(), value);
  };
  protoOf(TaggedEncoder).j5h = function (value) {
    return this.s5u(this.c5v(), value);
  };
  protoOf(TaggedEncoder).k5h = function (value) {
    return this.t5u(this.c5v(), value);
  };
  protoOf(TaggedEncoder).l5h = function (value) {
    return this.v5u(this.c5v(), value);
  };
  protoOf(TaggedEncoder).m5h = function (value) {
    return this.w5u(this.c5v(), value);
  };
  protoOf(TaggedEncoder).n5h = function (enumDescriptor, index) {
    return this.x5u(this.c5v(), enumDescriptor, index);
  };
  protoOf(TaggedEncoder).j5g = function (descriptor) {
    return this;
  };
  protoOf(TaggedEncoder).k5g = function (descriptor) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.i5u_1.p()) {
      this.c5v();
    }
    this.z5u(descriptor);
  };
  protoOf(TaggedEncoder).z5u = function (descriptor) {
  };
  protoOf(TaggedEncoder).p5h = function (descriptor, index, value) {
    return this.u5u(this.f5u(descriptor, index), value);
  };
  protoOf(TaggedEncoder).q5h = function (descriptor, index, value) {
    return this.p5u(this.f5u(descriptor, index), value);
  };
  protoOf(TaggedEncoder).r5h = function (descriptor, index, value) {
    return this.q5u(this.f5u(descriptor, index), value);
  };
  protoOf(TaggedEncoder).s5h = function (descriptor, index, value) {
    return this.o5u(this.f5u(descriptor, index), value);
  };
  protoOf(TaggedEncoder).t5h = function (descriptor, index, value) {
    return this.r5u(this.f5u(descriptor, index), value);
  };
  protoOf(TaggedEncoder).u5h = function (descriptor, index, value) {
    return this.s5u(this.f5u(descriptor, index), value);
  };
  protoOf(TaggedEncoder).v5h = function (descriptor, index, value) {
    return this.t5u(this.f5u(descriptor, index), value);
  };
  protoOf(TaggedEncoder).w5h = function (descriptor, index, value) {
    return this.v5u(this.f5u(descriptor, index), value);
  };
  protoOf(TaggedEncoder).x5h = function (descriptor, index, value) {
    return this.w5u(this.f5u(descriptor, index), value);
  };
  protoOf(TaggedEncoder).y5h = function (descriptor, index) {
    return this.y5u(this.f5u(descriptor, index), descriptor.t5e(index));
  };
  protoOf(TaggedEncoder).z5h = function (descriptor, index, serializer, value) {
    if (encodeElement(this, descriptor, index)) {
      this.i5d(serializer, value);
    }
  };
  protoOf(TaggedEncoder).a5i = function (descriptor, index, serializer, value) {
    if (encodeElement(this, descriptor, index)) {
      this.b5i(serializer, value);
    }
  };
  protoOf(TaggedEncoder).a5v = function () {
    return last(this.i5u_1);
  };
  protoOf(TaggedEncoder).j5u = function () {
    return lastOrNull(this.i5u_1);
  };
  protoOf(TaggedEncoder).b5v = function (name) {
    this.i5u_1.e(name);
  };
  protoOf(TaggedEncoder).c5v = function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.i5u_1.p()) {
      tmp = this.i5u_1.q2(get_lastIndex_2(this.i5u_1));
    } else {
      throw SerializationException_init_$Create$_0('No tag in stack for requested element');
    }
    return tmp;
  };
  function tagBlock($this, tag, block) {
    $this.b5v(tag);
    var r = block();
    if (!$this.g5v_1) {
      $this.c5v();
    }
    $this.g5v_1 = false;
    return r;
  }
  function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      return this$0.i5g($deserializer, $previousValue);
    };
  }
  function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      return this$0.v5f() ? this$0.i5g($deserializer, $previousValue) : this$0.w5f();
    };
  }
  function TaggedDecoder() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.f5v_1 = ArrayList_init_$Create$();
    this.g5v_1 = false;
  }
  protoOf(TaggedDecoder).h5d = function () {
    return EmptySerializersModule_0();
  };
  protoOf(TaggedDecoder).h5v = function (tag) {
    throw SerializationException_init_$Create$_0(toString_1(getKClassFromExpression(this)) + " can't retrieve untyped values");
  };
  protoOf(TaggedDecoder).i5v = function (tag) {
    return true;
  };
  protoOf(TaggedDecoder).j5v = function (tag) {
    var tmp = this.h5v(tag);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).k5v = function (tag) {
    var tmp = this.h5v(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).l5v = function (tag) {
    var tmp = this.h5v(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).m5v = function (tag) {
    var tmp = this.h5v(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).n5v = function (tag) {
    var tmp = this.h5v(tag);
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).o5v = function (tag) {
    var tmp = this.h5v(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).p5v = function (tag) {
    var tmp = this.h5v(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).q5v = function (tag) {
    var tmp = this.h5v(tag);
    return tmp instanceof Char ? tmp.v1_1 : THROW_CCE();
  };
  protoOf(TaggedDecoder).r5v = function (tag) {
    var tmp = this.h5v(tag);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).s5v = function (tag, enumDescriptor) {
    var tmp = this.h5v(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).t5v = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeTaggedInline.<anonymous>' call
    this.b5v(tag);
    return this;
  };
  protoOf(TaggedDecoder).i5g = function (deserializer, previousValue) {
    return this.l5d(deserializer);
  };
  protoOf(TaggedDecoder).h5g = function (descriptor) {
    return this.t5v(this.c5v(), descriptor);
  };
  protoOf(TaggedDecoder).v5f = function () {
    var tmp0_elvis_lhs = this.j5u();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentTag = tmp;
    return this.i5v(currentTag);
  };
  protoOf(TaggedDecoder).w5f = function () {
    return null;
  };
  protoOf(TaggedDecoder).x5f = function () {
    return this.j5v(this.c5v());
  };
  protoOf(TaggedDecoder).y5f = function () {
    return this.k5v(this.c5v());
  };
  protoOf(TaggedDecoder).z5f = function () {
    return this.l5v(this.c5v());
  };
  protoOf(TaggedDecoder).a5g = function () {
    return this.m5v(this.c5v());
  };
  protoOf(TaggedDecoder).b5g = function () {
    return this.n5v(this.c5v());
  };
  protoOf(TaggedDecoder).c5g = function () {
    return this.o5v(this.c5v());
  };
  protoOf(TaggedDecoder).d5g = function () {
    return this.p5v(this.c5v());
  };
  protoOf(TaggedDecoder).e5g = function () {
    return this.q5v(this.c5v());
  };
  protoOf(TaggedDecoder).f5g = function () {
    return this.r5v(this.c5v());
  };
  protoOf(TaggedDecoder).g5g = function (enumDescriptor) {
    return this.s5v(this.c5v(), enumDescriptor);
  };
  protoOf(TaggedDecoder).j5g = function (descriptor) {
    return this;
  };
  protoOf(TaggedDecoder).k5g = function (descriptor) {
  };
  protoOf(TaggedDecoder).l5g = function (descriptor, index) {
    return this.j5v(this.f5u(descriptor, index));
  };
  protoOf(TaggedDecoder).m5g = function (descriptor, index) {
    return this.k5v(this.f5u(descriptor, index));
  };
  protoOf(TaggedDecoder).n5g = function (descriptor, index) {
    return this.l5v(this.f5u(descriptor, index));
  };
  protoOf(TaggedDecoder).o5g = function (descriptor, index) {
    return this.m5v(this.f5u(descriptor, index));
  };
  protoOf(TaggedDecoder).p5g = function (descriptor, index) {
    return this.n5v(this.f5u(descriptor, index));
  };
  protoOf(TaggedDecoder).q5g = function (descriptor, index) {
    return this.o5v(this.f5u(descriptor, index));
  };
  protoOf(TaggedDecoder).r5g = function (descriptor, index) {
    return this.p5v(this.f5u(descriptor, index));
  };
  protoOf(TaggedDecoder).s5g = function (descriptor, index) {
    return this.q5v(this.f5u(descriptor, index));
  };
  protoOf(TaggedDecoder).t5g = function (descriptor, index) {
    return this.r5v(this.f5u(descriptor, index));
  };
  protoOf(TaggedDecoder).u5g = function (descriptor, index) {
    return this.t5v(this.f5u(descriptor, index), descriptor.t5e(index));
  };
  protoOf(TaggedDecoder).v5g = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.f5u(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).x5g = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.f5u(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).j5u = function () {
    return lastOrNull(this.f5v_1);
  };
  protoOf(TaggedDecoder).b5v = function (name) {
    this.f5v_1.e(name);
  };
  protoOf(TaggedDecoder).c5v = function () {
    var r = this.f5v_1.q2(get_lastIndex_2(this.f5v_1));
    this.g5v_1 = true;
    return r;
  };
  function get_NULL_0() {
    _init_properties_Tuples_kt__dz0qyd();
    return NULL_0;
  }
  var NULL_0;
  function MapEntry(key, value) {
    this.u5v_1 = key;
    this.v5v_1 = value;
  }
  protoOf(MapEntry).x = function () {
    return this.u5v_1;
  };
  protoOf(MapEntry).y = function () {
    return this.v5v_1;
  };
  protoOf(MapEntry).toString = function () {
    return 'MapEntry(key=' + toString_0(this.u5v_1) + ', value=' + toString_0(this.v5v_1) + ')';
  };
  protoOf(MapEntry).hashCode = function () {
    var result = this.u5v_1 == null ? 0 : hashCode(this.u5v_1);
    result = imul(result, 31) + (this.v5v_1 == null ? 0 : hashCode(this.v5v_1)) | 0;
    return result;
  };
  protoOf(MapEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
    if (!equals(this.u5v_1, tmp0_other_with_cast.u5v_1))
      return false;
    if (!equals(this.v5v_1, tmp0_other_with_cast.v5v_1))
      return false;
    return true;
  };
  function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.p5d('key', $keySerializer.w5c());
      $this$buildSerialDescriptor.p5d('value', $valueSerializer.w5c());
      return Unit_instance;
    };
  }
  function MapEntrySerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    tmp.y5v_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(MapEntrySerializer_0).w5c = function () {
    return this.y5v_1;
  };
  protoOf(MapEntrySerializer_0).z5v = function (_this__u8e3s4) {
    return _this__u8e3s4.x();
  };
  protoOf(MapEntrySerializer_0).a5w = function (_this__u8e3s4) {
    return this.z5v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).b5w = function (_this__u8e3s4) {
    return _this__u8e3s4.y();
  };
  protoOf(MapEntrySerializer_0).c5w = function (_this__u8e3s4) {
    return this.b5w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).d5w = function (key, value) {
    return new MapEntry(key, value);
  };
  function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.p5d('first', $keySerializer.w5c());
      $this$buildClassSerialDescriptor.p5d('second', $valueSerializer.w5c());
      return Unit_instance;
    };
  }
  function PairSerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    tmp.j5w_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(PairSerializer_0).w5c = function () {
    return this.j5w_1;
  };
  protoOf(PairSerializer_0).k5w = function (_this__u8e3s4) {
    return _this__u8e3s4.dh_1;
  };
  protoOf(PairSerializer_0).a5w = function (_this__u8e3s4) {
    return this.k5w(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).l5w = function (_this__u8e3s4) {
    return _this__u8e3s4.eh_1;
  };
  protoOf(PairSerializer_0).c5w = function (_this__u8e3s4) {
    return this.l5w(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).d5w = function (key, value) {
    return to(key, value);
  };
  function decodeSequentially_1($this, composite) {
    var a = composite.w5g($this.p5w_1, 0, $this.m5w_1);
    var b = composite.w5g($this.p5w_1, 1, $this.n5w_1);
    var c = composite.w5g($this.p5w_1, 2, $this.o5w_1);
    composite.k5g($this.p5w_1);
    return new Triple(a, b, c);
  }
  function decodeStructure($this, composite) {
    var a = get_NULL_0();
    var b = get_NULL_0();
    var c = get_NULL_0();
    mainLoop: while (true) {
      var index = composite.z5g($this.p5w_1);
      switch (index) {
        case -1:
          break mainLoop;
        case 0:
          a = composite.w5g($this.p5w_1, 0, $this.m5w_1);
          break;
        case 1:
          b = composite.w5g($this.p5w_1, 1, $this.n5w_1);
          break;
        case 2:
          c = composite.w5g($this.p5w_1, 2, $this.o5w_1);
          break;
        default:
          throw SerializationException_init_$Create$_0('Unexpected index ' + index);
      }
    }
    composite.k5g($this.p5w_1);
    if (a === get_NULL_0())
      throw SerializationException_init_$Create$_0("Element 'first' is missing");
    if (b === get_NULL_0())
      throw SerializationException_init_$Create$_0("Element 'second' is missing");
    if (c === get_NULL_0())
      throw SerializationException_init_$Create$_0("Element 'third' is missing");
    var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
    var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
    return new Triple(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
  }
  function TripleSerializer$descriptor$lambda(this$0) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.p5d('first', this$0.m5w_1.w5c());
      $this$buildClassSerialDescriptor.p5d('second', this$0.n5w_1.w5c());
      $this$buildClassSerialDescriptor.p5d('third', this$0.o5w_1.w5c());
      return Unit_instance;
    };
  }
  function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
    this.m5w_1 = aSerializer;
    this.n5w_1 = bSerializer;
    this.o5w_1 = cSerializer;
    var tmp = this;
    tmp.p5w_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
  }
  protoOf(TripleSerializer_0).w5c = function () {
    return this.p5w_1;
  };
  protoOf(TripleSerializer_0).q5w = function (encoder, value) {
    var structuredEncoder = encoder.j5g(this.p5w_1);
    structuredEncoder.z5h(this.p5w_1, 0, this.m5w_1, value.em_1);
    structuredEncoder.z5h(this.p5w_1, 1, this.n5w_1, value.fm_1);
    structuredEncoder.z5h(this.p5w_1, 2, this.o5w_1, value.gm_1);
    structuredEncoder.k5g(this.p5w_1);
  };
  protoOf(TripleSerializer_0).j5d = function (encoder, value) {
    return this.q5w(encoder, value instanceof Triple ? value : THROW_CCE());
  };
  protoOf(TripleSerializer_0).k5d = function (decoder) {
    var composite = decoder.j5g(this.p5w_1);
    if (composite.y5g()) {
      return decodeSequentially_1(this, composite);
    }
    return decodeStructure(this, composite);
  };
  function KeyValueSerializer(keySerializer, valueSerializer) {
    this.e5w_1 = keySerializer;
    this.f5w_1 = valueSerializer;
  }
  protoOf(KeyValueSerializer).g5w = function (encoder, value) {
    var structuredEncoder = encoder.j5g(this.w5c());
    structuredEncoder.z5h(this.w5c(), 0, this.e5w_1, this.a5w(value));
    structuredEncoder.z5h(this.w5c(), 1, this.f5w_1, this.c5w(value));
    structuredEncoder.k5g(this.w5c());
  };
  protoOf(KeyValueSerializer).j5d = function (encoder, value) {
    return this.g5w(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(KeyValueSerializer).k5d = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.w5c();
    var composite = decoder.j5g(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.KeyValueSerializer.deserialize.<anonymous>' call
      if (composite.y5g()) {
        var key = composite.w5g(this.w5c(), 0, this.e5w_1);
        var value = composite.w5g(this.w5c(), 1, this.f5w_1);
        tmp$ret$0 = this.d5w(key, value);
        break $l$block;
      }
      var key_0 = get_NULL_0();
      var value_0 = get_NULL_0();
      mainLoop: while (true) {
        var idx = composite.z5g(this.w5c());
        switch (idx) {
          case -1:
            break mainLoop;
          case 0:
            key_0 = composite.w5g(this.w5c(), 0, this.e5w_1);
            break;
          case 1:
            value_0 = composite.w5g(this.w5c(), 1, this.f5w_1);
            break;
          default:
            throw SerializationException_init_$Create$_0('Invalid index: ' + idx);
        }
      }
      if (key_0 === get_NULL_0())
        throw SerializationException_init_$Create$_0("Element 'key' is missing");
      if (value_0 === get_NULL_0())
        throw SerializationException_init_$Create$_0("Element 'value' is missing");
      var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
      tmp$ret$0 = this.d5w(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
    }
    var result = tmp$ret$0;
    composite.k5g(descriptor);
    return result;
  };
  var properties_initialized_Tuples_kt_3vs7ar;
  function _init_properties_Tuples_kt__dz0qyd() {
    if (!properties_initialized_Tuples_kt_3vs7ar) {
      properties_initialized_Tuples_kt_3vs7ar = true;
      NULL_0 = new Object();
    }
  }
  function ULongSerializer() {
    ULongSerializer_instance = this;
    this.r5w_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_7(Companion_getInstance_2()));
  }
  protoOf(ULongSerializer).w5c = function () {
    return this.r5w_1;
  };
  protoOf(ULongSerializer).s5w = function (encoder, value) {
    var tmp = encoder.o5h(this.r5w_1);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
    tmp.i5h(tmp$ret$0);
  };
  protoOf(ULongSerializer).j5d = function (encoder, value) {
    return this.s5w(encoder, value instanceof ULong ? value.s1_1 : THROW_CCE());
  };
  protoOf(ULongSerializer).t5w = function (decoder) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.h5g(this.r5w_1).b5g();
    return _ULong___init__impl__c78o9k(this_0);
  };
  protoOf(ULongSerializer).k5d = function (decoder) {
    return new ULong(this.t5w(decoder));
  };
  var ULongSerializer_instance;
  function ULongSerializer_getInstance() {
    if (ULongSerializer_instance == null)
      new ULongSerializer();
    return ULongSerializer_instance;
  }
  function UIntSerializer() {
    UIntSerializer_instance = this;
    this.u5w_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_9(IntCompanionObject_instance));
  }
  protoOf(UIntSerializer).w5c = function () {
    return this.u5w_1;
  };
  protoOf(UIntSerializer).v5w = function (encoder, value) {
    var tmp = encoder.o5h(this.u5w_1);
    // Inline function 'kotlin.UInt.toInt' call
    var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
    tmp.h5h(tmp$ret$0);
  };
  protoOf(UIntSerializer).j5d = function (encoder, value) {
    return this.v5w(encoder, value instanceof UInt ? value.ym_1 : THROW_CCE());
  };
  protoOf(UIntSerializer).w5w = function (decoder) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.h5g(this.u5w_1).a5g();
    return _UInt___init__impl__l7qpdl(this_0);
  };
  protoOf(UIntSerializer).k5d = function (decoder) {
    return new UInt(this.w5w(decoder));
  };
  var UIntSerializer_instance;
  function UIntSerializer_getInstance() {
    if (UIntSerializer_instance == null)
      new UIntSerializer();
    return UIntSerializer_instance;
  }
  function UShortSerializer() {
    UShortSerializer_instance = this;
    this.x5w_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_11(ShortCompanionObject_instance));
  }
  protoOf(UShortSerializer).w5c = function () {
    return this.x5w_1;
  };
  protoOf(UShortSerializer).y5w = function (encoder, value) {
    var tmp = encoder.o5h(this.x5w_1);
    // Inline function 'kotlin.UShort.toShort' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
    tmp.g5h(tmp$ret$0);
  };
  protoOf(UShortSerializer).j5d = function (encoder, value) {
    return this.y5w(encoder, value instanceof UShort ? value.un_1 : THROW_CCE());
  };
  protoOf(UShortSerializer).z5w = function (decoder) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.h5g(this.x5w_1).z5f();
    return _UShort___init__impl__jigrne(this_0);
  };
  protoOf(UShortSerializer).k5d = function (decoder) {
    return new UShort(this.z5w(decoder));
  };
  var UShortSerializer_instance;
  function UShortSerializer_getInstance() {
    if (UShortSerializer_instance == null)
      new UShortSerializer();
    return UShortSerializer_instance;
  }
  function UByteSerializer() {
    UByteSerializer_instance = this;
    this.a5x_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_13(ByteCompanionObject_instance));
  }
  protoOf(UByteSerializer).w5c = function () {
    return this.a5x_1;
  };
  protoOf(UByteSerializer).b5x = function (encoder, value) {
    var tmp = encoder.o5h(this.a5x_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    tmp.f5h(tmp$ret$0);
  };
  protoOf(UByteSerializer).j5d = function (encoder, value) {
    return this.b5x(encoder, value instanceof UByte ? value.mm_1 : THROW_CCE());
  };
  protoOf(UByteSerializer).c5x = function (decoder) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.h5g(this.a5x_1).y5f();
    return _UByte___init__impl__g9hnc4(this_0);
  };
  protoOf(UByteSerializer).k5d = function (decoder) {
    return new UByte(this.c5x(decoder));
  };
  var UByteSerializer_instance;
  function UByteSerializer_getInstance() {
    if (UByteSerializer_instance == null)
      new UByteSerializer();
    return UByteSerializer_instance;
  }
  function get_EmptySerializersModuleLegacyJs() {
    _init_properties_SerializersModule_kt__u78ha3();
    return EmptySerializersModule;
  }
  var EmptySerializersModule;
  function SerializersModule() {
  }
  protoOf(SerializersModule).i5e = function (kClass, typeArgumentsSerializers, $super) {
    typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
    return $super === VOID ? this.v5c(kClass, typeArgumentsSerializers) : $super.v5c.call(this, kClass, typeArgumentsSerializers);
  };
  function SerialModuleImpl(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider) {
    SerializersModule.call(this);
    this.e5x_1 = class2ContextualFactory;
    this.f5x_1 = polyBase2Serializers;
    this.g5x_1 = polyBase2DefaultSerializerProvider;
    this.h5x_1 = polyBase2NamedSerializers;
    this.i5x_1 = polyBase2DefaultDeserializerProvider;
  }
  protoOf(SerialModuleImpl).g5i = function (baseClass, value) {
    if (!baseClass.mb(value))
      return null;
    var tmp0_safe_receiver = this.f5x_1.y2(baseClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y2(getKClassFromExpression(value));
    var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
    if (!(registered == null))
      return registered;
    var tmp_0 = this.g5x_1.y2(baseClass);
    var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
  };
  protoOf(SerialModuleImpl).f5i = function (baseClass, serializedClassName) {
    var tmp0_safe_receiver = this.h5x_1.y2(baseClass);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.get' call
      tmp = (isInterface(tmp0_safe_receiver, KtMap) ? tmp0_safe_receiver : THROW_CCE()).y2(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this.i5x_1.y2(baseClass);
    var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
  };
  protoOf(SerialModuleImpl).v5c = function (kClass, typeArgumentsSerializers) {
    var tmp0_safe_receiver = this.e5x_1.y2(kClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j5x(typeArgumentsSerializers);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
  };
  protoOf(SerialModuleImpl).d5x = function (collector) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.e5x_1.w().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var kclass = element.x();
      // Inline function 'kotlin.collections.component2' call
      var serial = element.y();
      if (serial instanceof Argless) {
        var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
        var tmp_0 = serial.m5x_1;
        collector.n5x(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
      } else {
        if (serial instanceof WithTypeArguments) {
          collector.l5x(kclass, serial.k5x_1);
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = this.f5x_1.w().k();
    while (_iterator__ex2g4s_0.l()) {
      var element_0 = _iterator__ex2g4s_0.m();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass = element_0.x();
      // Inline function 'kotlin.collections.component2' call
      var classMap = element_0.y();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_1 = classMap.w().k();
      while (_iterator__ex2g4s_1.l()) {
        var element_1 = _iterator__ex2g4s_1.m();
        // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var actualClass = element_1.x();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element_1.y();
        var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
        var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var tmp$ret$9 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
        collector.o5x(tmp_1, tmp_2, tmp$ret$9);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_2 = this.g5x_1.w().k();
    while (_iterator__ex2g4s_2.l()) {
      var element_2 = _iterator__ex2g4s_2.m();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass_0 = element_2.x();
      // Inline function 'kotlin.collections.component2' call
      var provider = element_2.y();
      var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
      collector.p5x(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_3 = this.i5x_1.w().k();
    while (_iterator__ex2g4s_3.l()) {
      var element_3 = _iterator__ex2g4s_3.m();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass_1 = element_3.x();
      // Inline function 'kotlin.collections.component2' call
      var provider_0 = element_3.y();
      var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
      collector.q5x(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
    }
  };
  function Argless(serializer) {
    ContextualProvider.call(this);
    this.m5x_1 = serializer;
  }
  protoOf(Argless).j5x = function (typeArgumentsSerializers) {
    return this.m5x_1;
  };
  protoOf(Argless).equals = function (other) {
    var tmp;
    if (other instanceof Argless) {
      tmp = equals(other.m5x_1, this.m5x_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Argless).hashCode = function () {
    return hashCode(this.m5x_1);
  };
  function WithTypeArguments(provider) {
    ContextualProvider.call(this);
    this.k5x_1 = provider;
  }
  protoOf(WithTypeArguments).j5x = function (typeArgumentsSerializers) {
    return this.k5x_1(typeArgumentsSerializers);
  };
  function ContextualProvider() {
  }
  var properties_initialized_SerializersModule_kt_fjigjn;
  function _init_properties_SerializersModule_kt__u78ha3() {
    if (!properties_initialized_SerializersModule_kt_fjigjn) {
      properties_initialized_SerializersModule_kt_fjigjn = true;
      EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap());
    }
  }
  function EmptySerializersModule_0() {
    return get_EmptySerializersModuleLegacyJs();
  }
  function SerializersModuleBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.r5x_1 = HashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_0.s5x_1 = HashMap_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.t5x_1 = HashMap_init_$Create$();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_2.u5x_1 = HashMap_init_$Create$();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_3.v5x_1 = HashMap_init_$Create$();
  }
  protoOf(SerializersModuleBuilder).n5x = function (kClass, serializer) {
    return this.w5x(kClass, new Argless(serializer));
  };
  protoOf(SerializersModuleBuilder).l5x = function (kClass, provider) {
    return this.w5x(kClass, new WithTypeArguments(provider));
  };
  protoOf(SerializersModuleBuilder).o5x = function (baseClass, actualClass, actualSerializer) {
    this.x5x(baseClass, actualClass, actualSerializer);
  };
  protoOf(SerializersModuleBuilder).p5x = function (baseClass, defaultSerializerProvider) {
    this.y5x(baseClass, defaultSerializerProvider, false);
  };
  protoOf(SerializersModuleBuilder).q5x = function (baseClass, defaultDeserializerProvider) {
    this.z5x(baseClass, defaultDeserializerProvider, false);
  };
  protoOf(SerializersModuleBuilder).a5y = function (forClass, provider, allowOverwrite) {
    if (!allowOverwrite) {
      var previous = this.r5x_1.y2(forClass);
      if (!(previous == null) && !equals(previous, provider)) {
        throw new SerializerAlreadyRegisteredException('Contextual serializer or serializer provider for ' + toString_1(forClass) + ' already registered in this module');
      }
    }
    // Inline function 'kotlin.collections.set' call
    this.r5x_1.r2(forClass, provider);
  };
  protoOf(SerializersModuleBuilder).w5x = function (forClass, provider, allowOverwrite, $super) {
    allowOverwrite = allowOverwrite === VOID ? false : allowOverwrite;
    var tmp;
    if ($super === VOID) {
      this.a5y(forClass, provider, allowOverwrite);
      tmp = Unit_instance;
    } else {
      tmp = $super.a5y.call(this, forClass, provider, allowOverwrite);
    }
    return tmp;
  };
  protoOf(SerializersModuleBuilder).y5x = function (baseClass, defaultSerializerProvider, allowOverwrite) {
    var previous = this.t5x_1.y2(baseClass);
    if (!(previous == null) && !equals(previous, defaultSerializerProvider) && !allowOverwrite) {
      throw IllegalArgumentException_init_$Create$_0('Default serializers provider for ' + toString_1(baseClass) + ' is already registered: ' + toString_0(previous));
    }
    // Inline function 'kotlin.collections.set' call
    this.t5x_1.r2(baseClass, defaultSerializerProvider);
  };
  protoOf(SerializersModuleBuilder).z5x = function (baseClass, defaultDeserializerProvider, allowOverwrite) {
    var previous = this.v5x_1.y2(baseClass);
    if (!(previous == null) && !equals(previous, defaultDeserializerProvider) && !allowOverwrite) {
      throw IllegalArgumentException_init_$Create$_0('Default deserializers provider for ' + toString_1(baseClass) + ' is already registered: ' + toString_0(previous));
    }
    // Inline function 'kotlin.collections.set' call
    this.v5x_1.r2(baseClass, defaultDeserializerProvider);
  };
  protoOf(SerializersModuleBuilder).b5y = function (baseClass, concreteClass, concreteSerializer, allowOverwrite) {
    var name = concreteSerializer.w5c().b5e();
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.s5x_1;
    var value = this_0.y2(baseClass);
    var tmp;
    if (value == null) {
      // Inline function 'kotlinx.serialization.modules.SerializersModuleBuilder.registerPolymorphicSerializer.stub_for_inlining' call
      // Inline function 'kotlin.collections.hashMapOf' call
      var answer = HashMap_init_$Create$();
      this_0.r2(baseClass, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var baseClassSerializers = tmp;
    var previousSerializer = baseClassSerializers.y2(concreteClass);
    // Inline function 'kotlin.collections.getOrPut' call
    var this_1 = this.u5x_1;
    var value_0 = this_1.y2(baseClass);
    var tmp_0;
    if (value_0 == null) {
      // Inline function 'kotlinx.serialization.modules.SerializersModuleBuilder.registerPolymorphicSerializer.stub_for_inlining' call
      // Inline function 'kotlin.collections.hashMapOf' call
      var answer_0 = HashMap_init_$Create$();
      this_1.r2(baseClass, answer_0);
      tmp_0 = answer_0;
    } else {
      tmp_0 = value_0;
    }
    var names = tmp_0;
    if (allowOverwrite) {
      if (!(previousSerializer == null)) {
        names.s2(previousSerializer.w5c().b5e());
      }
      // Inline function 'kotlin.collections.set' call
      baseClassSerializers.r2(concreteClass, concreteSerializer);
      // Inline function 'kotlin.collections.set' call
      names.r2(name, concreteSerializer);
      return Unit_instance;
    }
    if (!(previousSerializer == null)) {
      if (!equals(previousSerializer, concreteSerializer)) {
        throw SerializerAlreadyRegisteredException_init_$Create$(baseClass, concreteClass);
      } else {
        names.s2(previousSerializer.w5c().b5e());
      }
    }
    var previousByName = names.y2(name);
    if (!(previousByName == null)) {
      // Inline function 'kotlin.sequences.find' call
      var tmp0 = asSequence_1(ensureNotNull(this.s5x_1.y2(baseClass)));
      var tmp$ret$7;
      $l$block: {
        // Inline function 'kotlin.sequences.firstOrNull' call
        var _iterator__ex2g4s = tmp0.k();
        while (_iterator__ex2g4s.l()) {
          var element = _iterator__ex2g4s.m();
          // Inline function 'kotlinx.serialization.modules.SerializersModuleBuilder.registerPolymorphicSerializer.<anonymous>' call
          if (element.y() === previousByName) {
            tmp$ret$7 = element;
            break $l$block;
          }
        }
        tmp$ret$7 = null;
      }
      var conflictingClass = tmp$ret$7;
      throw IllegalArgumentException_init_$Create$_0("Multiple polymorphic serializers for base class '" + toString_1(baseClass) + "' " + ("have the same serial name '" + name + "': '" + toString_1(concreteClass) + "' and '" + toString_0(conflictingClass) + "'"));
    }
    // Inline function 'kotlin.collections.set' call
    baseClassSerializers.r2(concreteClass, concreteSerializer);
    // Inline function 'kotlin.collections.set' call
    names.r2(name, concreteSerializer);
  };
  protoOf(SerializersModuleBuilder).x5x = function (baseClass, concreteClass, concreteSerializer, allowOverwrite, $super) {
    allowOverwrite = allowOverwrite === VOID ? false : allowOverwrite;
    var tmp;
    if ($super === VOID) {
      this.b5y(baseClass, concreteClass, concreteSerializer, allowOverwrite);
      tmp = Unit_instance;
    } else {
      tmp = $super.b5y.call(this, baseClass, concreteClass, concreteSerializer, allowOverwrite);
    }
    return tmp;
  };
  protoOf(SerializersModuleBuilder).w5l = function () {
    return new SerialModuleImpl(this.r5x_1, this.s5x_1, this.t5x_1, this.u5x_1, this.v5x_1);
  };
  function SerializerAlreadyRegisteredException_init_$Init$(baseClass, concreteClass, $this) {
    SerializerAlreadyRegisteredException.call($this, 'Serializer for ' + toString_1(concreteClass) + ' already registered in the scope of ' + toString_1(baseClass));
    return $this;
  }
  function SerializerAlreadyRegisteredException_init_$Create$(baseClass, concreteClass) {
    var tmp = SerializerAlreadyRegisteredException_init_$Init$(baseClass, concreteClass, objectCreate(protoOf(SerializerAlreadyRegisteredException)));
    captureStack(tmp, SerializerAlreadyRegisteredException_init_$Create$);
    return tmp;
  }
  function SerializerAlreadyRegisteredException(msg) {
    IllegalArgumentException_init_$Init$_0(msg, this);
    captureStack(this, SerializerAlreadyRegisteredException);
  }
  function SerializersModuleCollector$contextual$lambda($serializer) {
    return function (it) {
      return $serializer;
    };
  }
  function SerializersModuleCollector() {
  }
  function SerializableWith(serializer) {
    this.c5y_1 = serializer;
  }
  protoOf(SerializableWith).equals = function (other) {
    if (!(other instanceof SerializableWith))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
    if (!this.c5y_1.equals(tmp0_other_with_cast.c5y_1))
      return false;
    return true;
  };
  protoOf(SerializableWith).hashCode = function () {
    return imul(getStringHashCode('serializer'), 127) ^ this.c5y_1.hashCode();
  };
  protoOf(SerializableWith).toString = function () {
    return '@kotlinx.serialization.SerializableWith(' + 'serializer=' + toString_1(this.c5y_1) + ')';
  };
  function createCache(factory) {
    return new createCache$1(factory);
  }
  function createParametrizedCache(factory) {
    return new createParametrizedCache$1(factory);
  }
  function compiledSerializerImpl(_this__u8e3s4) {
    var tmp1_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_safe_receiver = get_js(_this__u8e3s4).Companion;
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.serializer();
      tmp = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
    throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4) + '\n' + 'On Kotlin/JS explicitly declared serializer should be used for interfaces and enums without @Serializable annotation');
  }
  function isReferenceArray(rootClass) {
    return rootClass.equals(PrimitiveClasses_getInstance().mc());
  }
  function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
    var tmp;
    try {
      // Inline function 'kotlin.reflect.findAssociatedObject' call
      var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
      var tmp_0;
      if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
        tmp_0 = (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) ? assocObject : THROW_CCE();
      } else {
        if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
          var tmp_1 = assocObject.t5o(args.slice());
          tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
        } else {
          if (get_isInterface(_this__u8e3s4)) {
            tmp_0 = new PolymorphicSerializer(_this__u8e3s4);
          } else {
            tmp_0 = null;
          }
        }
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_2;
      var e = $p;
      tmp_2 = null;
      tmp = tmp_2;
    }
    return tmp;
  }
  function get_isInterface(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
  }
  function toNativeArrayImpl(_this__u8e3s4, eClass) {
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(_this__u8e3s4);
  }
  function getChecked(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$_0('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
    return _this__u8e3s4[index];
  }
  function getChecked_0(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$_0('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
    return _this__u8e3s4[index];
  }
  function createCache$1($factory) {
    this.d5y_1 = $factory;
  }
  protoOf(createCache$1).j5e = function (key) {
    return this.d5y_1(key);
  };
  function createParametrizedCache$1($factory) {
    this.e5y_1 = $factory;
  }
  protoOf(createParametrizedCache$1).k5e = function (key, types) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlinx.serialization.internal.<no name provided>.get.<anonymous>' call
      // Inline function 'kotlin.Companion.success' call
      var value = this.e5y_1(key, types);
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  function Default_0() {
    Default_instance_0 = this;
    ProtoBuf.call(this, false, EmptySerializersModule_0());
  }
  var Default_instance_0;
  function Default_getInstance_0() {
    if (Default_instance_0 == null)
      new Default_0();
    return Default_instance_0;
  }
  function ProtoBuf(encodeDefaults, serializersModule) {
    Default_getInstance_0();
    this.f5y_1 = encodeDefaults;
    this.g5y_1 = serializersModule;
  }
  protoOf(ProtoBuf).h5d = function () {
    return this.g5y_1;
  };
  protoOf(ProtoBuf).d5e = function (serializer, value) {
    var output = new ByteArrayOutput();
    var encoder = new ProtobufEncoder(this, new ProtobufWriter(output), serializer.w5c());
    encoder.i5d(serializer, value);
    return output.p5y();
  };
  protoOf(ProtoBuf).e5e = function (deserializer, bytes) {
    var input = new ByteArrayInput(bytes);
    var decoder = new ProtobufDecoder(this, new ProtobufReader(input), deserializer.w5c());
    return decoder.l5d(deserializer);
  };
  function ProtoBuf_0(from, builderAction) {
    from = from === VOID ? Default_getInstance_0() : from;
    var b = new ProtoBufBuilder(from);
    builderAction(b);
    return new ProtoBufImpl(b.z5y_1, b.a5z_1);
  }
  function ProtoBufBuilder(proto) {
    this.z5y_1 = proto.f5y_1;
    this.a5z_1 = proto.h5d();
  }
  function ProtoBufImpl(encodeDefaults, serializersModule) {
    ProtoBuf.call(this, encodeDefaults, serializersModule);
  }
  var ProtoIntegerType_DEFAULT_instance;
  var ProtoIntegerType_SIGNED_instance;
  var ProtoIntegerType_FIXED_instance;
  var ProtoIntegerType_entriesInitialized;
  function ProtoIntegerType_initEntries() {
    if (ProtoIntegerType_entriesInitialized)
      return Unit_instance;
    ProtoIntegerType_entriesInitialized = true;
    ProtoIntegerType_DEFAULT_instance = new ProtoIntegerType('DEFAULT', 0, new Long(0, 0));
    ProtoIntegerType_SIGNED_instance = new ProtoIntegerType('SIGNED', 1, new Long(0, 2));
    ProtoIntegerType_FIXED_instance = new ProtoIntegerType('FIXED', 2, new Long(0, 4));
  }
  function ProtoIntegerType(name, ordinal, signature) {
    Enum.call(this, name, ordinal);
    this.d5z_1 = signature;
  }
  function ProtoNumber() {
  }
  function ProtoType() {
  }
  function ProtoPacked() {
  }
  function ProtoIntegerType_DEFAULT_getInstance() {
    ProtoIntegerType_initEntries();
    return ProtoIntegerType_DEFAULT_instance;
  }
  function ProtoIntegerType_SIGNED_getInstance() {
    ProtoIntegerType_initEntries();
    return ProtoIntegerType_SIGNED_instance;
  }
  function ProtoIntegerType_FIXED_getInstance() {
    ProtoIntegerType_initEntries();
    return ProtoIntegerType_FIXED_instance;
  }
  function get_isPacked(_this__u8e3s4) {
    return !_this__u8e3s4.u3(new Long(0, 1)).equals(new Long(0, 0));
  }
  function get_isPackable(_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4.r5e();
    var tmp;
    var tmp_0;
    if (equals(tmp0_subject, STRING_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = !(tmp0_subject instanceof PrimitiveKind);
    }
    if (tmp_0) {
      tmp = false;
    } else {
      tmp = true;
    }
    return tmp;
  }
  function get_integerType(_this__u8e3s4) {
    var tmp0_subject = _this__u8e3s4.u3(new Long(0, 2147483646));
    return tmp0_subject.equals(ProtoIntegerType_DEFAULT_getInstance().d5z_1) ? ProtoIntegerType_DEFAULT_getInstance() : tmp0_subject.equals(ProtoIntegerType_SIGNED_getInstance().d5z_1) ? ProtoIntegerType_SIGNED_getInstance() : ProtoIntegerType_FIXED_getInstance();
  }
  function extractProtoId(descriptor, index, zeroBasedDefault) {
    var annotations = descriptor.s5e(index);
    var inductionVariable = 0;
    var last = annotations.n() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var annotation = annotations.q(i);
        if (annotation instanceof ProtoNumber) {
          return annotation.e5z_1;
        }
      }
       while (inductionVariable <= last);
    return zeroBasedDefault ? index : index + 1 | 0;
  }
  function extractParameters(_this__u8e3s4, index) {
    var annotations = _this__u8e3s4.s5e(index);
    var protoId = index + 1 | 0;
    var format = ProtoIntegerType_DEFAULT_getInstance();
    var protoPacked = false;
    var inductionVariable = 0;
    var last = annotations.n() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var annotation = annotations.q(i);
        if (annotation instanceof ProtoNumber) {
          protoId = annotation.e5z_1;
        } else {
          if (annotation instanceof ProtoType) {
            format = annotation.f5z_1;
          } else {
            if (annotation instanceof ProtoPacked) {
              protoPacked = true;
            }
          }
        }
      }
       while (inductionVariable <= last);
    var tmp0 = protoId;
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
    var packedBits = protoPacked ? new Long(0, 1) : new Long(0, 0);
    var signature = format.d5z_1.v3(packedBits);
    return signature.v3(toLong(tmp0));
  }
  function ProtobufDecodingException(message) {
    SerializationException_init_$Init$_0(message, this);
    captureStack(this, ProtobufDecodingException);
  }
  function PackedArrayDecoder(proto, reader, descriptor) {
    ProtobufDecoder.call(this, proto, reader, descriptor);
    this.p5z_1 = 0;
  }
  protoOf(PackedArrayDecoder).f5u = function (_this__u8e3s4, index) {
    return new Long(19500, 0);
  };
  protoOf(PackedArrayDecoder).j5g = function (descriptor) {
    throw SerializationException_init_$Create$_0('Packing only supports primitive number types. The input type however was a struct: ' + toString_1(descriptor));
  };
  protoOf(PackedArrayDecoder).z5g = function (descriptor) {
    if (this.t5y_1.v5z())
      return -1;
    var tmp1 = this.p5z_1;
    this.p5z_1 = tmp1 + 1 | 0;
    return tmp1;
  };
  protoOf(PackedArrayDecoder).w5z = function (tag) {
    throw SerializationException_init_$Create$_0('Packing only supports primitive number types. The actual reading is for string.');
  };
  function PackedArrayEncoder(proto, writer, curTag, descriptor, stream) {
    stream = stream === VOID ? new ByteArrayOutput() : stream;
    NestedRepeatedEncoder.call(this, proto, writer, curTag, descriptor, stream);
  }
  protoOf(PackedArrayEncoder).f5u = function (_this__u8e3s4, index) {
    return new Long(19500, 0);
  };
  protoOf(PackedArrayEncoder).d5i = function (descriptor, collectionSize) {
    throw SerializationException_init_$Create$_0('Packing only supports primitive number types');
  };
  protoOf(PackedArrayEncoder).j5g = function (descriptor) {
    throw SerializationException_init_$Create$_0('Packing only supports primitive number types');
  };
  protoOf(PackedArrayEncoder).y60 = function (tag, value) {
    throw SerializationException_init_$Create$_0('Packing only supports primitive number types');
  };
  function populateCacheMap($this, descriptor, elements) {
    var map = HashMap_init_$Create$_0(elements);
    var inductionVariable = 0;
    if (inductionVariable < elements)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.set' call
        var key = extractProtoId(descriptor, i, false);
        map.r2(key, i);
      }
       while (inductionVariable < elements);
    $this.w5y_1 = map;
  }
  function getIndexByTag($this, protoTag) {
    var array = $this.v5y_1;
    if (!(array == null)) {
      // Inline function 'kotlin.collections.getOrElse' call
      var tmp;
      if (0 <= protoTag ? protoTag <= (array.length - 1 | 0) : false) {
        tmp = array[protoTag];
      } else {
        // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufDecoder.getIndexByTag.<anonymous>' call
        tmp = -1;
      }
      return tmp;
    }
    return getIndexByTagSlowPath($this, protoTag);
  }
  function getIndexByTagSlowPath($this, protoTag) {
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = ensureNotNull($this.w5y_1).y2(protoTag);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufDecoder.getIndexByTagSlowPath.<anonymous>' call
      tmp = -1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function findIndexByTag($this, descriptor, protoTag) {
    if (protoTag < descriptor.p5e()) {
      var protoId = extractProtoId(descriptor, protoTag, true);
      if (protoId === protoTag)
        return protoTag;
    }
    return findIndexByTagSlowPath($this, descriptor, protoTag);
  }
  function findIndexByTagSlowPath($this, desc, protoTag) {
    var inductionVariable = 0;
    var last = desc.p5e();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var protoId = extractProtoId(desc, i, true);
        if (protoId === protoTag)
          return i;
      }
       while (inductionVariable < last);
    throw new ProtobufDecodingException('' + protoTag + ' is not among valid ' + $this.u5y_1.b5e() + ' enum proto numbers');
  }
  function deserializeByteArray($this, previousValue) {
    var tag = $this.m60();
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = $this.t5y_1.w61();
    } else {
      tmp = $this.t5y_1.v61();
    }
    var array = tmp;
    var tmp_0;
    if (previousValue == null) {
      tmp_0 = array;
    } else {
      // Inline function 'kotlin.collections.plus' call
      tmp_0 = primitiveArrayConcat([previousValue, array]);
    }
    return tmp_0;
  }
  function deserializeMap($this, deserializer, previousValue) {
    var serializer = deserializer instanceof MapLikeSerializer ? deserializer : THROW_CCE();
    var mapEntrySerial = MapEntrySerializer(serializer.x5k_1, serializer.y5k_1);
    var tmp0_safe_receiver = (!(previousValue == null) ? isInterface(previousValue, KtMap) : false) ? previousValue : null;
    var oldSet = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w();
    var setOfEntries = (new LinkedHashSetSerializer(mapEntrySerial)).y5j($this, oldSet);
    // Inline function 'kotlin.collections.associateBy' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(setOfEntries, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = setOfEntries.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufDecoder.deserializeMap.<anonymous>' call
      var tmp = element.x();
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufDecoder.deserializeMap.<anonymous>' call
      var tmp$ret$1 = element.y();
      destination.r2(tmp, tmp$ret$1);
    }
    var tmp_0 = destination;
    return !(tmp_0 == null) ? tmp_0 : THROW_CCE();
  }
  function readIfAbsent($this, descriptor, index) {
    if (!descriptor.w5e(index)) {
      var elementDescriptor = descriptor.t5e(index);
      var kind = elementDescriptor.r5e();
      if (equals(kind, MAP_getInstance()) || equals(kind, LIST_getInstance())) {
        $this.x5y_1 = false;
        return true;
      } else if (elementDescriptor.l5e()) {
        $this.x5y_1 = true;
        return true;
      }
    }
    return false;
  }
  function ProtobufDecoder$readIfAbsent$ref($boundThis) {
    var l = function (p0, p1) {
      return readIfAbsent($boundThis, p0, p1);
    };
    l.callableName = 'readIfAbsent';
    return l;
  }
  function ProtobufDecoder(proto, reader, descriptor) {
    ProtobufTaggedDecoder.call(this);
    this.s5y_1 = proto;
    this.t5y_1 = reader;
    this.u5y_1 = descriptor;
    this.v5y_1 = null;
    this.w5y_1 = null;
    this.x5y_1 = false;
    var tmp = this;
    tmp.y5y_1 = new ElementMarker(this.u5y_1, ProtobufDecoder$readIfAbsent$ref(this));
    this.x5z(this.u5y_1);
  }
  protoOf(ProtobufDecoder).h5d = function () {
    return this.s5y_1.h5d();
  };
  protoOf(ProtobufDecoder).x5z = function (descriptor) {
    var elements = descriptor.p5e();
    if (elements < 32) {
      var cache = new Int32Array(elements + 1 | 0);
      var inductionVariable = 0;
      if (inductionVariable < elements)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var protoId = extractProtoId(descriptor, i, false);
          if (protoId <= elements) {
            cache[protoId] = i;
          } else {
            return populateCacheMap(this, descriptor, elements);
          }
        }
         while (inductionVariable < elements);
      this.v5y_1 = cache;
    } else {
      populateCacheMap(this, descriptor, elements);
    }
  };
  protoOf(ProtobufDecoder).j5g = function (descriptor) {
    var tmp0_subject = descriptor.r5e();
    var tmp;
    if (equals(tmp0_subject, LIST_getInstance())) {
      var tag = this.m60();
      var tmp_0;
      if (equals(this.u5y_1.r5e(), LIST_getInstance()) && !tag.equals(new Long(19500, 0)) && !equals(this.u5y_1, descriptor)) {
        var reader = makeDelimited(this.t5y_1, tag);
        reader.y61();
        // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
        var tmp$ret$0 = ProtoIntegerType_DEFAULT_getInstance().d5z_1.v3(toLong(1));
        tmp_0 = new RepeatedDecoder(this.s5y_1, reader, tmp$ret$0, descriptor);
      } else if (this.t5y_1.s5z_1 === 2 && get_isPackable(descriptor.t5e(0))) {
        var sliceReader = new ProtobufReader(this.t5y_1.x61());
        tmp_0 = new PackedArrayDecoder(this.s5y_1, sliceReader, descriptor);
      } else {
        tmp_0 = new RepeatedDecoder(this.s5y_1, this.t5y_1, tag, descriptor);
      }
      return tmp_0;
    } else {
      var tmp_1;
      if (equals(tmp0_subject, CLASS_getInstance()) ? true : equals(tmp0_subject, OBJECT_getInstance())) {
        tmp_1 = true;
      } else {
        tmp_1 = tmp0_subject instanceof PolymorphicKind;
      }
      if (tmp_1) {
        var tag_0 = this.m60();
        if (tag_0.equals(new Long(19500, 0)) && equals(this.u5y_1, descriptor))
          return this;
        return new ProtobufDecoder(this.s5y_1, makeDelimited(this.t5y_1, tag_0), descriptor);
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          tmp = new MapEntryReader(this.s5y_1, makeDelimitedForced(this.t5y_1, this.m60()), this.m60(), descriptor);
        } else {
          throw SerializationException_init_$Create$_0('Primitives are not supported at top-level');
        }
      }
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).k5g = function (descriptor) {
  };
  protoOf(ProtobufDecoder).y5z = function (tag) {
    var value = this.b60(tag);
    var tmp;
    switch (value) {
      case 0:
        tmp = false;
        break;
      case 1:
        tmp = true;
        break;
      default:
        throw SerializationException_init_$Create$_0('Unexpected boolean value: ' + value);
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).z5z = function (tag) {
    return toByte(this.b60(tag));
  };
  protoOf(ProtobufDecoder).a60 = function (tag) {
    return toShort(this.b60(tag));
  };
  protoOf(ProtobufDecoder).b60 = function (tag) {
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = this.t5y_1.a62();
    } else {
      tmp = this.t5y_1.z61(get_integerType(tag));
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).c60 = function (tag) {
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = this.t5y_1.c62();
    } else {
      tmp = this.t5y_1.b62(get_integerType(tag));
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).d60 = function (tag) {
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = this.t5y_1.e62();
    } else {
      tmp = this.t5y_1.d62();
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).e60 = function (tag) {
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = this.t5y_1.g62();
    } else {
      tmp = this.t5y_1.f62();
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).f60 = function (tag) {
    return numberToChar(this.b60(tag));
  };
  protoOf(ProtobufDecoder).w5z = function (tag) {
    var tmp;
    if (tag.equals(new Long(19500, 0))) {
      tmp = this.t5y_1.h62();
    } else {
      tmp = this.t5y_1.i2w();
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).g60 = function (tag, enumDescription) {
    return findIndexByTag(this, enumDescription, this.b60(tag));
  };
  protoOf(ProtobufDecoder).l5d = function (deserializer) {
    return this.i5g(deserializer, null);
  };
  protoOf(ProtobufDecoder).i5g = function (deserializer, previousValue) {
    var tmp;
    if (deserializer instanceof MapLikeSerializer) {
      tmp = deserializeMap(this, isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE(), previousValue);
    } else {
      if (equals(deserializer.w5c(), ByteArraySerializer().w5c())) {
        var tmp_0 = deserializeByteArray(this, (previousValue == null ? true : isByteArray(previousValue)) ? previousValue : THROW_CCE());
        tmp = !(tmp_0 == null) ? tmp_0 : THROW_CCE();
      } else {
        if (deserializer instanceof AbstractCollectionSerializer) {
          tmp = (deserializer instanceof AbstractCollectionSerializer ? deserializer : THROW_CCE()).y5j(this, previousValue);
        } else {
          tmp = deserializer.k5d(this);
        }
      }
    }
    return tmp;
  };
  protoOf(ProtobufDecoder).f5u = function (_this__u8e3s4, index) {
    return extractParameters(_this__u8e3s4, index);
  };
  protoOf(ProtobufDecoder).z5g = function (descriptor) {
    while (true) {
      var protoId = this.t5y_1.y61();
      if (protoId === -1) {
        return this.y5y_1.m5m();
      }
      var index = getIndexByTag(this, protoId);
      if (index === -1) {
        this.t5y_1.i62();
      } else {
        this.y5y_1.l5m(index);
        return index;
      }
    }
  };
  protoOf(ProtobufDecoder).v5f = function () {
    return !this.x5y_1;
  };
  function decodeListIndexNoTag($this) {
    var size = $this.t62_1.p3();
    $this.s62_1 = $this.s62_1 + 1 | 0;
    var idx = $this.s62_1;
    if (toLong(idx).equals(size) || $this.t5y_1.v5z())
      return -1;
    return idx;
  }
  function decodeTaggedListIndex($this) {
    var tmp;
    if ($this.s62_1 === -1) {
      tmp = $this.t5y_1.r5z_1;
    } else {
      tmp = $this.t5y_1.y61();
    }
    var protoId = tmp;
    var tmp_0;
    // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
    if (protoId === $this.t62_1.u3(new Long(2147483647, 0)).z3()) {
      $this.s62_1 = $this.s62_1 + 1 | 0;
      tmp_0 = $this.s62_1;
    } else {
      $this.t5y_1.u62();
      tmp_0 = -1;
    }
    return tmp_0;
  }
  function RepeatedDecoder(proto, decoder, currentTag, descriptor) {
    ProtobufDecoder.call(this, proto, decoder, descriptor);
    this.s62_1 = -1;
    var tmp = this;
    var tmp_0;
    if (currentTag.equals(new Long(19500, 0))) {
      var length = this.t5y_1.a62();
      // Inline function 'kotlin.require' call
      if (!(length >= 0)) {
        // Inline function 'kotlinx.serialization.protobuf.internal.RepeatedDecoder.<anonymous>' call
        var message = 'Expected positive length for ' + toString_1(descriptor) + ', but got ' + length;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      tmp_0 = toLong(length).p3();
    } else {
      tmp_0 = currentTag;
    }
    tmp.t62_1 = tmp_0;
  }
  protoOf(RepeatedDecoder).z5g = function (descriptor) {
    if (this.t62_1.d1(new Long(0, 0)) > 0) {
      return decodeTaggedListIndex(this);
    }
    return decodeListIndexNoTag(this);
  };
  protoOf(RepeatedDecoder).f5u = function (_this__u8e3s4, index) {
    if (this.t62_1.d1(new Long(0, 0)) > 0)
      return this.t62_1;
    return new Long(19500, 0);
  };
  function makeDelimited(decoder, parentTag) {
    var tagless = parentTag.equals(new Long(19500, 0));
    var input = tagless ? decoder.v62() : decoder.x61();
    return new ProtobufReader(input);
  }
  function MapEntryReader(proto, decoder, parentTag, descriptor) {
    ProtobufDecoder.call(this, proto, decoder, descriptor);
    this.f63_1 = parentTag;
  }
  protoOf(MapEntryReader).f5u = function (_this__u8e3s4, index) {
    var tmp;
    if ((index % 2 | 0) === 0) {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
      tmp = get_integerType(this.f63_1).d5z_1.v3(toLong(1));
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
      tmp = get_integerType(this.f63_1).d5z_1.v3(toLong(2));
    }
    return tmp;
  };
  function makeDelimitedForced(decoder, parentTag) {
    var tagless = parentTag.equals(new Long(19500, 0));
    var input = tagless ? decoder.v62() : decoder.x61();
    return new ProtobufReader(input);
  }
  function serializeByteArray($this, value) {
    var tag = $this.n60();
    if (tag.equals(new Long(19500, 0))) {
      $this.l5y_1.i63(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = tag.u3(new Long(2147483647, 0)).z3();
      $this.l5y_1.h63(value, tmp$ret$0);
    }
  }
  function serializeMap($this, serializer, value) {
    var casted = serializer instanceof MapLikeSerializer ? serializer : THROW_CCE();
    var mapEntrySerial = MapEntrySerializer(casted.x5k_1, casted.y5k_1);
    var tmp = SetSerializer(mapEntrySerial);
    tmp.j5d($this, ((!(value == null) ? isInterface(value, KtMap) : false) ? value : THROW_CCE()).w());
  }
  function ProtobufEncoder(proto, writer, descriptor) {
    ProtobufTaggedEncoder.call(this);
    this.k5y_1 = proto;
    this.l5y_1 = writer;
    this.m5y_1 = descriptor;
  }
  protoOf(ProtobufEncoder).h5d = function () {
    return this.k5y_1.h5d();
  };
  protoOf(ProtobufEncoder).e5i = function (descriptor, index) {
    return this.k5y_1.f5y_1;
  };
  protoOf(ProtobufEncoder).d5i = function (descriptor, collectionSize) {
    var tmp0_subject = descriptor.r5e();
    var tmp;
    if (equals(tmp0_subject, LIST_getInstance())) {
      var tag = this.m60();
      var tmp_0;
      if (get_isPacked(tag) && get_isPackable(descriptor.t5e(0))) {
        tmp_0 = new PackedArrayEncoder(this.k5y_1, this.l5y_1, this.m60(), descriptor);
      } else {
        if (tag.equals(new Long(19500, 0))) {
          this.l5y_1.j63(collectionSize);
        }
        var tmp_1;
        if (equals(this.m5y_1.r5e(), LIST_getInstance()) && !tag.equals(new Long(19500, 0)) && !equals(this.m5y_1, descriptor)) {
          tmp_1 = new NestedRepeatedEncoder(this.k5y_1, this.l5y_1, tag, descriptor);
        } else {
          tmp_1 = new RepeatedEncoder(this.k5y_1, this.l5y_1, tag, descriptor);
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (equals(tmp0_subject, MAP_getInstance())) {
      tmp = new MapRepeatedEncoder(this.k5y_1, this.a5v(), this.l5y_1, descriptor);
    } else {
      throw SerializationException_init_$Create$_0('This serial kind is not supported as collection: ' + toString_1(descriptor));
    }
    return tmp;
  };
  protoOf(ProtobufEncoder).j5g = function (descriptor) {
    var tmp0_subject = descriptor.r5e();
    var tmp;
    if (equals(tmp0_subject, LIST_getInstance())) {
      var tmp_0;
      if (get_isPackable(descriptor.t5e(0)) && get_isPacked(this.m60())) {
        tmp_0 = new PackedArrayEncoder(this.k5y_1, this.l5y_1, this.m60(), descriptor);
      } else {
        tmp_0 = new RepeatedEncoder(this.k5y_1, this.l5y_1, this.m60(), descriptor);
      }
      tmp = tmp_0;
    } else {
      var tmp_1;
      if (equals(tmp0_subject, CLASS_getInstance()) ? true : equals(tmp0_subject, OBJECT_getInstance())) {
        tmp_1 = true;
      } else {
        tmp_1 = tmp0_subject instanceof PolymorphicKind;
      }
      if (tmp_1) {
        var tag = this.m60();
        tmp = tag.equals(new Long(19500, 0)) && equals(descriptor, this.m5y_1) ? this : new ObjectEncoder(this.k5y_1, this.m60(), this.l5y_1, VOID, descriptor);
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          tmp = new MapRepeatedEncoder(this.k5y_1, this.m60(), this.l5y_1, descriptor);
        } else {
          throw SerializationException_init_$Create$_0('This serial kind is not supported as structure: ' + toString_1(descriptor));
        }
      }
    }
    return tmp;
  };
  protoOf(ProtobufEncoder).i61 = function (tag, value) {
    if (tag.equals(new Long(19500, 0))) {
      this.l5y_1.j63(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = tag.u3(new Long(2147483647, 0)).z3();
      this.l5y_1.k63(value, tmp$ret$0, get_integerType(tag));
    }
  };
  protoOf(ProtobufEncoder).j61 = function (tag, value) {
    return this.i61(tag, value);
  };
  protoOf(ProtobufEncoder).k61 = function (tag, value) {
    return this.i61(tag, value);
  };
  protoOf(ProtobufEncoder).l61 = function (tag, value) {
    return this.i61(tag, value ? 1 : 0);
  };
  protoOf(ProtobufEncoder).m61 = function (tag, value) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(value);
    return this.i61(tag, tmp$ret$0);
  };
  protoOf(ProtobufEncoder).n61 = function (tag, value) {
    if (tag.equals(new Long(19500, 0))) {
      this.l5y_1.m63(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = tag.u3(new Long(2147483647, 0)).z3();
      this.l5y_1.l63(value, tmp$ret$0, get_integerType(tag));
    }
  };
  protoOf(ProtobufEncoder).o61 = function (tag, value) {
    if (tag.equals(new Long(19500, 0))) {
      this.l5y_1.o63(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = tag.u3(new Long(2147483647, 0)).z3();
      this.l5y_1.n63(value, tmp$ret$0);
    }
  };
  protoOf(ProtobufEncoder).p61 = function (tag, value) {
    if (tag.equals(new Long(19500, 0))) {
      this.l5y_1.q63(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = tag.u3(new Long(2147483647, 0)).z3();
      this.l5y_1.p63(value, tmp$ret$0);
    }
  };
  protoOf(ProtobufEncoder).y60 = function (tag, value) {
    if (tag.equals(new Long(19500, 0))) {
      this.l5y_1.s63(value);
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = tag.u3(new Long(2147483647, 0)).z3();
      this.l5y_1.r63(value, tmp$ret$0);
    }
  };
  protoOf(ProtobufEncoder).q61 = function (tag, enumDescriptor, ordinal) {
    if (tag.equals(new Long(19500, 0))) {
      this.l5y_1.j63(extractProtoId(enumDescriptor, ordinal, true));
    } else {
      var tmp = extractProtoId(enumDescriptor, ordinal, true);
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = tag.u3(new Long(2147483647, 0)).z3();
      this.l5y_1.k63(tmp, tmp$ret$0, ProtoIntegerType_DEFAULT_getInstance());
    }
  };
  protoOf(ProtobufEncoder).f5u = function (_this__u8e3s4, index) {
    return extractParameters(_this__u8e3s4, index);
  };
  protoOf(ProtobufEncoder).i5d = function (serializer, value) {
    var tmp;
    if (serializer instanceof MapLikeSerializer) {
      serializeMap(this, isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
      tmp = Unit_instance;
    } else {
      if (equals(serializer.w5c(), ByteArraySerializer().w5c())) {
        serializeByteArray(this, (!(value == null) ? isByteArray(value) : false) ? value : THROW_CCE());
        tmp = Unit_instance;
      } else {
        serializer.j5d(this, value);
        tmp = Unit_instance;
      }
    }
    return tmp;
  };
  function NestedRepeatedEncoder(proto, writer, curTag, descriptor, stream) {
    stream = stream === VOID ? new ByteArrayOutput() : stream;
    ProtobufEncoder.call(this, proto, new ProtobufWriter(stream), descriptor);
    this.f61_1 = writer;
    this.g61_1 = curTag;
    this.h61_1 = stream;
  }
  protoOf(NestedRepeatedEncoder).f5u = function (_this__u8e3s4, index) {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
    return ProtoIntegerType_DEFAULT_getInstance().d5z_1.v3(toLong(1));
  };
  protoOf(NestedRepeatedEncoder).z5u = function (descriptor) {
    // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
    var tmp$ret$0 = this.g61_1.u3(new Long(2147483647, 0)).z3();
    this.f61_1.t63(this.h61_1, tmp$ret$0);
  };
  function RepeatedEncoder(proto, writer, curTag, descriptor) {
    ProtobufEncoder.call(this, proto, writer, descriptor);
    this.a64_1 = curTag;
  }
  protoOf(RepeatedEncoder).f5u = function (_this__u8e3s4, index) {
    return this.a64_1;
  };
  function MapRepeatedEncoder(proto, parentTag, parentWriter, descriptor) {
    ObjectEncoder.call(this, proto, parentTag, parentWriter, VOID, descriptor);
  }
  protoOf(MapRepeatedEncoder).f5u = function (_this__u8e3s4, index) {
    var tmp;
    if ((index % 2 | 0) === 0) {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
      tmp = get_integerType(this.q64_1).d5z_1.v3(toLong(1));
    } else {
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtoDesc' call
      tmp = get_integerType(this.q64_1).d5z_1.v3(toLong(2));
    }
    return tmp;
  };
  function ObjectEncoder(proto, parentTag, parentWriter, stream, descriptor) {
    stream = stream === VOID ? new ByteArrayOutput() : stream;
    ProtobufEncoder.call(this, proto, new ProtobufWriter(stream), descriptor);
    this.q64_1 = parentTag;
    this.r64_1 = parentWriter;
    this.s64_1 = stream;
  }
  protoOf(ObjectEncoder).z5u = function (descriptor) {
    if (!this.q64_1.equals(new Long(19500, 0))) {
      // Inline function 'kotlinx.serialization.protobuf.internal.protoId' call
      var tmp$ret$0 = this.q64_1.u3(new Long(2147483647, 0)).z3();
      this.r64_1.t63(this.s64_1, tmp$ret$0);
    } else {
      this.r64_1.t64(this.s64_1);
    }
  };
  function updateIdAndType($this, header) {
    var tmp;
    if (header === -1) {
      $this.r5z_1 = -1;
      $this.s5z_1 = -1;
      tmp = -1;
    } else {
      $this.r5z_1 = header >>> 3 | 0;
      $this.s5z_1 = header & 7;
      tmp = $this.r5z_1;
    }
    return tmp;
  }
  function readIntLittleEndian($this) {
    var result = 0;
    var inductionVariable = 0;
    if (inductionVariable <= 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var byte = $this.q5z_1.x64() & 255;
        result = result | byte << imul(i, 8);
      }
       while (inductionVariable <= 3);
    return result;
  }
  function readLongLittleEndian($this) {
    var result = new Long(0, 0);
    var inductionVariable = 0;
    if (inductionVariable <= 7)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var byte = toLong($this.q5z_1.x64() & 255);
        result = result.v3(byte.r3(imul(i, 8)));
      }
       while (inductionVariable <= 7);
    return result;
  }
  function checkLength($this, length) {
    if (length < 0) {
      throw new ProtobufDecodingException('Unexpected negative length: ' + length);
    }
  }
  function decode32($this, format) {
    var tmp;
    switch (format.a3_1) {
      case 0:
        tmp = $this.q5z_1.y64(false).z3();
        break;
      case 1:
        tmp = decodeSignedVarintInt($this, $this.q5z_1);
        break;
      case 2:
        tmp = readIntLittleEndian($this);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function decode32$default($this, format, $super) {
    format = format === VOID ? ProtoIntegerType_DEFAULT_getInstance() : format;
    return decode32($this, format);
  }
  function decode64($this, format) {
    var tmp;
    switch (format.a3_1) {
      case 0:
        tmp = $this.q5z_1.y64(false);
        break;
      case 1:
        tmp = decodeSignedVarintLong($this, $this.q5z_1);
        break;
      case 2:
        tmp = readLongLittleEndian($this);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function decodeSignedVarintInt($this, input) {
    var raw = input.z64();
    var temp = (raw << 31 >> 31 ^ raw) >> 1;
    return temp ^ raw & -2147483648;
  }
  function decodeSignedVarintLong($this, input) {
    var raw = input.y64(false);
    var temp = raw.r3(63).s3(63).w3(raw).s3(1);
    return temp.w3(raw.u3(new Long(0, -2147483648)));
  }
  function ProtobufReader(input) {
    this.q5z_1 = input;
    this.r5z_1 = -1;
    this.s5z_1 = -1;
    this.t5z_1 = false;
    this.u5z_1 = 0;
  }
  protoOf(ProtobufReader).v5z = function () {
    return !this.t5z_1 && this.q5z_1.a65() === 0;
  };
  protoOf(ProtobufReader).y61 = function () {
    if (this.t5z_1) {
      this.t5z_1 = false;
      var previousHeader = this.r5z_1 << 3 | this.s5z_1;
      // Inline function 'kotlin.also' call
      var this_0 = updateIdAndType(this, this.u5z_1);
      // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.readTag.<anonymous>' call
      this.u5z_1 = previousHeader;
      return this_0;
    }
    this.u5z_1 = this.r5z_1 << 3 | this.s5z_1;
    var header = this.q5z_1.y64(true).z3();
    return updateIdAndType(this, header);
  };
  protoOf(ProtobufReader).u62 = function () {
    this.t5z_1 = true;
    var nextHeader = this.r5z_1 << 3 | this.s5z_1;
    updateIdAndType(this, this.u5z_1);
    this.u5z_1 = nextHeader;
  };
  protoOf(ProtobufReader).i62 = function () {
    switch (this.s5z_1) {
      case 0:
        this.z61(ProtoIntegerType_DEFAULT_getInstance());
        break;
      case 1:
        this.b62(ProtoIntegerType_FIXED_getInstance());
        break;
      case 2:
        this.v61();
        break;
      case 5:
        this.z61(ProtoIntegerType_FIXED_getInstance());
        break;
      default:
        throw new ProtobufDecodingException('Unsupported start group or end group wire type: ' + this.s5z_1);
    }
  };
  protoOf(ProtobufReader).v61 = function () {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.s5z_1 === 2))
      throw new ProtobufDecodingException('Expected wire type ' + 2 + ', but found ' + this.s5z_1);
    return this.w61();
  };
  protoOf(ProtobufReader).w61 = function () {
    var length = decode32$default(this);
    checkLength(this, length);
    return this.q5z_1.b65(length);
  };
  protoOf(ProtobufReader).x61 = function () {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.s5z_1 === 2))
      throw new ProtobufDecodingException('Expected wire type ' + 2 + ', but found ' + this.s5z_1);
    return this.v62();
  };
  protoOf(ProtobufReader).v62 = function () {
    var length = decode32$default(this);
    checkLength(this, length);
    return this.q5z_1.c65(length);
  };
  protoOf(ProtobufReader).z61 = function (format) {
    var wireType = format.equals(ProtoIntegerType_FIXED_getInstance()) ? 5 : 0;
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.s5z_1 === wireType))
      throw new ProtobufDecodingException('Expected wire type ' + wireType + ', but found ' + this.s5z_1);
    return decode32(this, format);
  };
  protoOf(ProtobufReader).a62 = function () {
    return decode32$default(this);
  };
  protoOf(ProtobufReader).b62 = function (format) {
    var wireType = format.equals(ProtoIntegerType_FIXED_getInstance()) ? 1 : 0;
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.s5z_1 === wireType))
      throw new ProtobufDecodingException('Expected wire type ' + wireType + ', but found ' + this.s5z_1);
    return decode64(this, format);
  };
  protoOf(ProtobufReader).c62 = function () {
    return decode64(this, ProtoIntegerType_DEFAULT_getInstance());
  };
  protoOf(ProtobufReader).d62 = function () {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.s5z_1 === 5))
      throw new ProtobufDecodingException('Expected wire type ' + 5 + ', but found ' + this.s5z_1);
    // Inline function 'kotlin.fromBits' call
    var bits = readIntLittleEndian(this);
    return floatFromBits(bits);
  };
  protoOf(ProtobufReader).e62 = function () {
    // Inline function 'kotlin.fromBits' call
    var bits = readIntLittleEndian(this);
    return floatFromBits(bits);
  };
  protoOf(ProtobufReader).f62 = function () {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.s5z_1 === 1))
      throw new ProtobufDecodingException('Expected wire type ' + 1 + ', but found ' + this.s5z_1);
    // Inline function 'kotlin.fromBits' call
    var bits = readLongLittleEndian(this);
    return doubleFromBits(bits);
  };
  protoOf(ProtobufReader).g62 = function () {
    // Inline function 'kotlin.fromBits' call
    var bits = readLongLittleEndian(this);
    return doubleFromBits(bits);
  };
  protoOf(ProtobufReader).i2w = function () {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufReader.assertWireType' call
    if (!(this.s5z_1 === 2))
      throw new ProtobufDecodingException('Expected wire type ' + 2 + ', but found ' + this.s5z_1);
    var length = decode32$default(this);
    checkLength(this, length);
    return this.q5z_1.d65(length);
  };
  protoOf(ProtobufReader).h62 = function () {
    var length = decode32$default(this);
    checkLength(this, length);
    return this.q5z_1.d65(length);
  };
  function expand($this) {
    $this.k60_1 = copyOf_2($this.k60_1, imul($this.k60_1.length, 2));
  }
  function ProtobufTaggedBase() {
    this.k60_1 = longArray(8);
    this.l60_1 = -1;
  }
  protoOf(ProtobufTaggedBase).a5v = function () {
    return this.k60_1[this.l60_1];
  };
  protoOf(ProtobufTaggedBase).m60 = function () {
    return this.l60_1 === -1 ? new Long(19500, 0) : this.k60_1[this.l60_1];
  };
  protoOf(ProtobufTaggedBase).n60 = function () {
    var tmp;
    if (this.l60_1 === -1) {
      tmp = new Long(19500, 0);
    } else {
      var tmp_0 = this.k60_1;
      var tmp1 = this.l60_1;
      this.l60_1 = tmp1 - 1 | 0;
      tmp = tmp_0[tmp1];
    }
    return tmp;
  };
  protoOf(ProtobufTaggedBase).o60 = function (tag) {
    if (tag.equals(new Long(19500, 0)))
      return Unit_instance;
    this.l60_1 = this.l60_1 + 1 | 0;
    var idx = this.l60_1;
    if (this.l60_1 >= this.k60_1.length) {
      expand(this);
    }
    this.k60_1[idx] = tag;
  };
  protoOf(ProtobufTaggedBase).c5v = function () {
    if (this.l60_1 >= 0) {
      var tmp = this.k60_1;
      var tmp1 = this.l60_1;
      this.l60_1 = tmp1 - 1 | 0;
      return tmp[tmp1];
    }
    throw SerializationException_init_$Create$_0('No tag in stack for requested element');
  };
  function ProtobufTaggedDecoder() {
    ProtobufTaggedBase.call(this);
  }
  protoOf(ProtobufTaggedDecoder).j60 = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufTaggedDecoder.decodeTaggedInline.<anonymous>' call
    this.o60(tag);
    return this;
  };
  protoOf(ProtobufTaggedDecoder).v5f = function () {
    return true;
  };
  protoOf(ProtobufTaggedDecoder).w5f = function () {
    return null;
  };
  protoOf(ProtobufTaggedDecoder).x5f = function () {
    return this.y5z(this.n60());
  };
  protoOf(ProtobufTaggedDecoder).y5f = function () {
    return this.z5z(this.n60());
  };
  protoOf(ProtobufTaggedDecoder).z5f = function () {
    return this.a60(this.n60());
  };
  protoOf(ProtobufTaggedDecoder).a5g = function () {
    return this.b60(this.n60());
  };
  protoOf(ProtobufTaggedDecoder).b5g = function () {
    return this.c60(this.n60());
  };
  protoOf(ProtobufTaggedDecoder).c5g = function () {
    return this.d60(this.n60());
  };
  protoOf(ProtobufTaggedDecoder).d5g = function () {
    return this.e60(this.n60());
  };
  protoOf(ProtobufTaggedDecoder).e5g = function () {
    return this.f60(this.n60());
  };
  protoOf(ProtobufTaggedDecoder).f5g = function () {
    return this.w5z(this.n60());
  };
  protoOf(ProtobufTaggedDecoder).g5g = function (enumDescriptor) {
    return this.g60(this.n60(), enumDescriptor);
  };
  protoOf(ProtobufTaggedDecoder).j5g = function (descriptor) {
    return this;
  };
  protoOf(ProtobufTaggedDecoder).k5g = function (descriptor) {
  };
  protoOf(ProtobufTaggedDecoder).l5g = function (descriptor, index) {
    return this.y5z(this.f5u(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).m5g = function (descriptor, index) {
    return this.z5z(this.f5u(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).n5g = function (descriptor, index) {
    return this.a60(this.f5u(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).o5g = function (descriptor, index) {
    return this.b60(this.f5u(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).p5g = function (descriptor, index) {
    return this.c60(this.f5u(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).q5g = function (descriptor, index) {
    return this.d60(this.f5u(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).r5g = function (descriptor, index) {
    return this.e60(this.f5u(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).s5g = function (descriptor, index) {
    return this.f60(this.f5u(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).t5g = function (descriptor, index) {
    return this.w5z(this.f5u(descriptor, index));
  };
  protoOf(ProtobufTaggedDecoder).v5g = function (descriptor, index, deserializer, previousValue) {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufTaggedBase.tagBlock' call
    var tag = this.f5u(descriptor, index);
    this.o60(tag);
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufTaggedDecoder.decodeSerializableElement.<anonymous>' call
    return this.i5g(deserializer, previousValue);
  };
  protoOf(ProtobufTaggedDecoder).x5g = function (descriptor, index, deserializer, previousValue) {
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufTaggedBase.tagBlock' call
    var tag = this.f5u(descriptor, index);
    this.o60(tag);
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufTaggedDecoder.decodeNullableSerializableElement.<anonymous>' call
    var tmp;
    if (this.v5f()) {
      tmp = this.i5g(deserializer, previousValue);
    } else {
      tmp = this.w5f();
    }
    return tmp;
  };
  protoOf(ProtobufTaggedDecoder).h5g = function (descriptor) {
    return this.j60(this.c5v(), descriptor);
  };
  protoOf(ProtobufTaggedDecoder).u5g = function (descriptor, index) {
    return this.j60(this.f5u(descriptor, index), descriptor.t5e(index));
  };
  var NullableMode_ACCEPTABLE_instance;
  var NullableMode_OPTIONAL_instance;
  var NullableMode_COLLECTION_instance;
  var NullableMode_NOT_NULL_instance;
  var NullableMode_entriesInitialized;
  function NullableMode_initEntries() {
    if (NullableMode_entriesInitialized)
      return Unit_instance;
    NullableMode_entriesInitialized = true;
    NullableMode_ACCEPTABLE_instance = new NullableMode('ACCEPTABLE', 0);
    NullableMode_OPTIONAL_instance = new NullableMode('OPTIONAL', 1);
    NullableMode_COLLECTION_instance = new NullableMode('COLLECTION', 2);
    NullableMode_NOT_NULL_instance = new NullableMode('NOT_NULL', 3);
  }
  function NullableMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function NullableMode_ACCEPTABLE_getInstance() {
    NullableMode_initEntries();
    return NullableMode_ACCEPTABLE_instance;
  }
  function NullableMode_OPTIONAL_getInstance() {
    NullableMode_initEntries();
    return NullableMode_OPTIONAL_instance;
  }
  function NullableMode_COLLECTION_getInstance() {
    NullableMode_initEntries();
    return NullableMode_COLLECTION_instance;
  }
  function NullableMode_NOT_NULL_getInstance() {
    NullableMode_initEntries();
    return NullableMode_NOT_NULL_instance;
  }
  function ProtobufTaggedEncoder() {
    ProtobufTaggedBase.call(this);
    this.t61_1 = NullableMode_NOT_NULL_getInstance();
  }
  protoOf(ProtobufTaggedEncoder).u61 = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlinx.serialization.protobuf.internal.ProtobufTaggedEncoder.encodeTaggedInline.<anonymous>' call
    this.o60(tag);
    return this;
  };
  protoOf(ProtobufTaggedEncoder).d5h = function () {
    if (!this.t61_1.equals(NullableMode_ACCEPTABLE_getInstance())) {
      var message;
      switch (this.t61_1.a3_1) {
        case 1:
          message = "'null' is not supported for optional properties in ProtoBuf";
          break;
        case 2:
          message = "'null' is not supported for collection types in ProtoBuf";
          break;
        case 3:
          message = "'null' is not allowed for not-null properties";
          break;
        default:
          message = "'null' is not supported in ProtoBuf";
          break;
      }
      throw SerializationException_init_$Create$_0(message);
    }
  };
  protoOf(ProtobufTaggedEncoder).e5h = function (value) {
    this.l61(this.n60(), value);
  };
  protoOf(ProtobufTaggedEncoder).f5h = function (value) {
    this.j61(this.n60(), value);
  };
  protoOf(ProtobufTaggedEncoder).g5h = function (value) {
    this.k61(this.n60(), value);
  };
  protoOf(ProtobufTaggedEncoder).h5h = function (value) {
    this.i61(this.n60(), value);
  };
  protoOf(ProtobufTaggedEncoder).i5h = function (value) {
    this.n61(this.n60(), value);
  };
  protoOf(ProtobufTaggedEncoder).j5h = function (value) {
    this.o61(this.n60(), value);
  };
  protoOf(ProtobufTaggedEncoder).k5h = function (value) {
    this.p61(this.n60(), value);
  };
  protoOf(ProtobufTaggedEncoder).l5h = function (value) {
    this.m61(this.n60(), value);
  };
  protoOf(ProtobufTaggedEncoder).m5h = function (value) {
    this.y60(this.n60(), value);
  };
  protoOf(ProtobufTaggedEncoder).n5h = function (enumDescriptor, index) {
    return this.q61(this.n60(), enumDescriptor, index);
  };
  protoOf(ProtobufTaggedEncoder).k5g = function (descriptor) {
    if (this.l60_1 >= 0) {
      this.c5v();
    }
    this.z5u(descriptor);
  };
  protoOf(ProtobufTaggedEncoder).z5u = function (descriptor) {
  };
  protoOf(ProtobufTaggedEncoder).p5h = function (descriptor, index, value) {
    return this.l61(this.f5u(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).q5h = function (descriptor, index, value) {
    return this.j61(this.f5u(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).r5h = function (descriptor, index, value) {
    return this.k61(this.f5u(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).s5h = function (descriptor, index, value) {
    return this.i61(this.f5u(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).t5h = function (descriptor, index, value) {
    return this.n61(this.f5u(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).u5h = function (descriptor, index, value) {
    return this.o61(this.f5u(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).v5h = function (descriptor, index, value) {
    return this.p61(this.f5u(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).w5h = function (descriptor, index, value) {
    return this.m61(this.f5u(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).x5h = function (descriptor, index, value) {
    return this.y60(this.f5u(descriptor, index), value);
  };
  protoOf(ProtobufTaggedEncoder).z5h = function (descriptor, index, serializer, value) {
    this.t61_1 = NullableMode_NOT_NULL_getInstance();
    this.o60(this.f5u(descriptor, index));
    this.i5d(serializer, value);
  };
  protoOf(ProtobufTaggedEncoder).a5i = function (descriptor, index, serializer, value) {
    var elementKind = descriptor.t5e(index).r5e();
    var tmp = this;
    var tmp_0;
    if (descriptor.w5e(index)) {
      tmp_0 = NullableMode_OPTIONAL_getInstance();
    } else if (equals(elementKind, MAP_getInstance()) || equals(elementKind, LIST_getInstance())) {
      tmp_0 = NullableMode_COLLECTION_getInstance();
    } else {
      tmp_0 = NullableMode_ACCEPTABLE_getInstance();
    }
    tmp.t61_1 = tmp_0;
    this.o60(this.f5u(descriptor, index));
    this.b5i(serializer, value);
  };
  protoOf(ProtobufTaggedEncoder).o5h = function (descriptor) {
    return this.u61(this.c5v(), descriptor);
  };
  protoOf(ProtobufTaggedEncoder).y5h = function (descriptor, index) {
    return this.u61(this.f5u(descriptor, index), descriptor.t5e(index));
  };
  function encode32(_this__u8e3s4, $this, number, format) {
    switch (format.a3_1) {
      case 2:
        $this.g63_1.j63(reverseBytes_1(number));
        break;
      case 0:
        _this__u8e3s4.e65(toLong(number));
        break;
      case 1:
        _this__u8e3s4.f65(number << 1 ^ number >> 31);
        break;
    }
  }
  function encode32$default(_this__u8e3s4, $this, number, format, $super) {
    format = format === VOID ? ProtoIntegerType_DEFAULT_getInstance() : format;
    return encode32(_this__u8e3s4, $this, number, format);
  }
  function encode64(_this__u8e3s4, $this, number, format) {
    switch (format.a3_1) {
      case 2:
        $this.g63_1.m63(reverseBytes_2(number));
        break;
      case 0:
        _this__u8e3s4.e65(number);
        break;
      case 1:
        _this__u8e3s4.e65(number.r3(1).w3(number.s3(63)));
        break;
    }
  }
  function encode64$default(_this__u8e3s4, $this, number, format, $super) {
    format = format === VOID ? ProtoIntegerType_DEFAULT_getInstance() : format;
    return encode64(_this__u8e3s4, $this, number, format);
  }
  function reverseBytes(_this__u8e3s4, $this) {
    return reverseBytes_1(toRawBits_0(_this__u8e3s4));
  }
  function reverseBytes_0(_this__u8e3s4, $this) {
    return reverseBytes_2(toRawBits(_this__u8e3s4));
  }
  function ProtobufWriter(out) {
    this.g63_1 = out;
  }
  protoOf(ProtobufWriter).h63 = function (bytes, tag) {
    encode32$default(this.g63_1, this, tag << 3 | 2);
    this.i63(bytes);
  };
  protoOf(ProtobufWriter).i63 = function (bytes) {
    encode32$default(this.g63_1, this, bytes.length);
    this.g63_1.g65(bytes);
  };
  protoOf(ProtobufWriter).t63 = function (output, tag) {
    encode32$default(this.g63_1, this, tag << 3 | 2);
    this.t64(output);
  };
  protoOf(ProtobufWriter).t64 = function (output) {
    encode32$default(this.g63_1, this, output.wo());
    this.g63_1.h65(output);
  };
  protoOf(ProtobufWriter).k63 = function (value, tag, format) {
    var wireType = format.equals(ProtoIntegerType_FIXED_getInstance()) ? 5 : 0;
    encode32$default(this.g63_1, this, tag << 3 | wireType);
    encode32(this.g63_1, this, value, format);
  };
  protoOf(ProtobufWriter).j63 = function (value) {
    encode32$default(this.g63_1, this, value);
  };
  protoOf(ProtobufWriter).l63 = function (value, tag, format) {
    var wireType = format.equals(ProtoIntegerType_FIXED_getInstance()) ? 1 : 0;
    encode32$default(this.g63_1, this, tag << 3 | wireType);
    encode64(this.g63_1, this, value, format);
  };
  protoOf(ProtobufWriter).m63 = function (value) {
    encode64$default(this.g63_1, this, value);
  };
  protoOf(ProtobufWriter).r63 = function (value, tag) {
    var bytes = encodeToByteArray(value);
    this.h63(bytes, tag);
  };
  protoOf(ProtobufWriter).s63 = function (value) {
    var bytes = encodeToByteArray(value);
    this.i63(bytes);
  };
  protoOf(ProtobufWriter).p63 = function (value, tag) {
    encode32$default(this.g63_1, this, tag << 3 | 1);
    this.g63_1.m63(reverseBytes_0(value, this));
  };
  protoOf(ProtobufWriter).q63 = function (value) {
    this.g63_1.m63(reverseBytes_0(value, this));
  };
  protoOf(ProtobufWriter).n63 = function (value, tag) {
    encode32$default(this.g63_1, this, tag << 3 | 5);
    this.g63_1.j63(reverseBytes(value, this));
  };
  protoOf(ProtobufWriter).o63 = function (value) {
    this.g63_1.j63(reverseBytes(value, this));
  };
  function Companion_81() {
    Companion_instance_81 = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = new Int32Array(65);
    while (tmp_0 < 65) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = (63 - tmp_2 | 0) / 7 | 0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.i65_1 = tmp_1;
  }
  var Companion_instance_81;
  function Companion_getInstance_81() {
    if (Companion_instance_81 == null)
      new Companion_81();
    return Companion_instance_81;
  }
  function ensureCapacity_1($this, elementsToAppend) {
    if (($this.o5y_1 + elementsToAppend | 0) <= $this.n5y_1.length) {
      return Unit_instance;
    }
    var newArray = new Int8Array(takeHighestOneBit($this.o5y_1 + elementsToAppend | 0) << 1);
    var tmp0 = $this.n5y_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = tmp0.length;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, newArray, 0, 0, endIndex);
    $this.n5y_1 = newArray;
  }
  function encodeVarint($this, value, length) {
    var current = value;
    var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        $this.n5y_1[$this.o5y_1 + i | 0] = current.u3(new Long(127, 0)).v3(new Long(128, 0)).x3();
        current = current.t3(7);
      }
       while (inductionVariable < length);
    $this.n5y_1[$this.o5y_1 + length | 0] = current.x3();
    $this.o5y_1 = $this.o5y_1 + (length + 1 | 0) | 0;
  }
  function varIntLength($this, value) {
    return Companion_getInstance_81().i65_1[countLeadingZeroBits(value)];
  }
  function ByteArrayOutput() {
    Companion_getInstance_81();
    this.n5y_1 = new Int8Array(32);
    this.o5y_1 = 0;
  }
  protoOf(ByteArrayOutput).wo = function () {
    return this.o5y_1;
  };
  protoOf(ByteArrayOutput).p5y = function () {
    var newArray = new Int8Array(this.o5y_1);
    var tmp0 = this.n5y_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = this.o5y_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, newArray, 0, 0, endIndex);
    return newArray;
  };
  protoOf(ByteArrayOutput).g65 = function (buffer) {
    var count = buffer.length;
    if (count === 0) {
      return Unit_instance;
    }
    ensureCapacity_1(this, count);
    var tmp1 = this.n5y_1;
    // Inline function 'kotlin.collections.copyInto' call
    var destinationOffset = this.o5y_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = buffer;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, tmp1, destinationOffset, 0, count);
    this.o5y_1 = this.o5y_1 + count | 0;
  };
  protoOf(ByteArrayOutput).h65 = function (output) {
    var count = output.wo();
    ensureCapacity_1(this, count);
    var tmp0 = output.n5y_1;
    var tmp1 = this.n5y_1;
    // Inline function 'kotlin.collections.copyInto' call
    var destinationOffset = this.o5y_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, tmp1, destinationOffset, 0, count);
    this.o5y_1 = this.o5y_1 + count | 0;
  };
  protoOf(ByteArrayOutput).j63 = function (intValue) {
    ensureCapacity_1(this, 4);
    var inductionVariable = 3;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp = this.n5y_1;
        var tmp2 = this.o5y_1;
        this.o5y_1 = tmp2 + 1 | 0;
        tmp[tmp2] = toByte(intValue >> imul(i, 8));
      }
       while (0 <= inductionVariable);
  };
  protoOf(ByteArrayOutput).m63 = function (longValue) {
    ensureCapacity_1(this, 8);
    var inductionVariable = 7;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp = this.n5y_1;
        var tmp2 = this.o5y_1;
        this.o5y_1 = tmp2 + 1 | 0;
        tmp[tmp2] = longValue.s3(imul(i, 8)).x3();
      }
       while (0 <= inductionVariable);
  };
  protoOf(ByteArrayOutput).f65 = function (value) {
    ensureCapacity_1(this, 5);
    if ((value & -128) === 0) {
      var tmp = this.n5y_1;
      var tmp1 = this.o5y_1;
      this.o5y_1 = tmp1 + 1 | 0;
      tmp[tmp1] = toByte(value);
      return Unit_instance;
    }
    var length = varIntLength(this, toLong(value));
    encodeVarint(this, toLong(value), length);
  };
  protoOf(ByteArrayOutput).e65 = function (value) {
    var length = varIntLength(this, value);
    ensureCapacity_1(this, length + 1 | 0);
    encodeVarint(this, value, length);
  };
  function ensureEnoughBytes($this, bytesCount) {
    if (bytesCount > $this.a65()) {
      throw SerializationException_init_$Create$_0('Unexpected EOF, available ' + $this.a65() + ' bytes, requested: ' + bytesCount);
    }
  }
  function eof($this) {
    throw SerializationException_init_$Create$_0('Unexpected EOF');
  }
  function readVarint64SlowPath($this) {
    var result = new Long(0, 0);
    var shift = 0;
    while (shift < 64) {
      var byte = $this.x64();
      result = result.v3(toLong(byte & 127).r3(shift));
      if ((byte & 128) === 0) {
        return result;
      }
      shift = shift + 7 | 0;
    }
    throw SerializationException_init_$Create$_0('Input stream is malformed: Varint too long (exceeded 64 bits)');
  }
  function readVarint32SlowPath($this) {
    var result = 0;
    var shift = 0;
    while (shift < 32) {
      var byte = $this.x64();
      result = result | (byte & 127) << shift;
      if ((byte & 128) === 0) {
        return result;
      }
      shift = shift + 7 | 0;
    }
    throw SerializationException_init_$Create$_0('Input stream is malformed: Varint too long (exceeded 32 bits)');
  }
  function ByteArrayInput(array, endIndex) {
    endIndex = endIndex === VOID ? array.length : endIndex;
    this.u64_1 = array;
    this.v64_1 = endIndex;
    this.w64_1 = 0;
  }
  protoOf(ByteArrayInput).a65 = function () {
    return this.v64_1 - this.w64_1 | 0;
  };
  protoOf(ByteArrayInput).c65 = function (size) {
    ensureEnoughBytes(this, size);
    var result = new ByteArrayInput(this.u64_1, this.w64_1 + size | 0);
    result.w64_1 = this.w64_1;
    this.w64_1 = this.w64_1 + size | 0;
    return result;
  };
  protoOf(ByteArrayInput).x64 = function () {
    var tmp;
    if (this.w64_1 < this.v64_1) {
      var tmp_0 = this.u64_1;
      var tmp1 = this.w64_1;
      this.w64_1 = tmp1 + 1 | 0;
      tmp = tmp_0[tmp1] & 255;
    } else {
      tmp = -1;
    }
    return tmp;
  };
  protoOf(ByteArrayInput).b65 = function (bytesCount) {
    ensureEnoughBytes(this, bytesCount);
    var b = new Int8Array(bytesCount);
    var length = b.length;
    var copied = (this.v64_1 - this.w64_1 | 0) < length ? this.v64_1 - this.w64_1 | 0 : length;
    var tmp0 = this.u64_1;
    var tmp3 = this.w64_1;
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = this.w64_1 + copied | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = tmp0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, b, 0, tmp3, endIndex);
    this.w64_1 = this.w64_1 + copied | 0;
    return b;
  };
  protoOf(ByteArrayInput).d65 = function (length) {
    var result = decodeToString_0(this.u64_1, this.w64_1, this.w64_1 + length | 0);
    this.w64_1 = this.w64_1 + length | 0;
    return result;
  };
  protoOf(ByteArrayInput).z64 = function () {
    if (this.w64_1 === this.v64_1) {
      eof(this);
    }
    var currentPosition = this.w64_1;
    var tmp = this.u64_1;
    var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var result = tmp[tmp0];
    if (result >= 0) {
      this.w64_1 = currentPosition;
      return result;
    } else if ((this.v64_1 - this.w64_1 | 0) > 1) {
      var tmp_0 = result;
      var tmp_1 = this.u64_1;
      var tmp1 = currentPosition;
      currentPosition = tmp1 + 1 | 0;
      result = tmp_0 ^ tmp_1[tmp1] << 7;
      if (result < 0) {
        this.w64_1 = currentPosition;
        return result ^ -128;
      }
    }
    return readVarint32SlowPath(this);
  };
  protoOf(ByteArrayInput).y64 = function (eofAllowed) {
    if (this.w64_1 === this.v64_1) {
      if (eofAllowed)
        return new Long(-1, -1);
      else {
        eof(this);
      }
    }
    var currentPosition = this.w64_1;
    var tmp = this.u64_1;
    var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var result = toLong(tmp[tmp0]);
    if (result.d1(new Long(0, 0)) >= 0) {
      this.w64_1 = currentPosition;
      return result;
    } else if ((this.v64_1 - this.w64_1 | 0) > 1) {
      var tmp_0 = result;
      var tmp_1 = this.u64_1;
      var tmp1 = currentPosition;
      currentPosition = tmp1 + 1 | 0;
      result = tmp_0.w3(toLong(tmp_1[tmp1]).r3(7));
      if (result.d1(new Long(0, 0)) < 0) {
        this.w64_1 = currentPosition;
        return result.w3(new Long(-128, -1));
      }
    }
    return readVarint64SlowPath(this);
  };
  function reverseBytes_1(_this__u8e3s4) {
    return reverseBytes_3(toShort(_this__u8e3s4 & 65535)) << 16 | reverseBytes_3(toShort(_this__u8e3s4 >>> 16 | 0)) & 65535;
  }
  function reverseBytes_2(_this__u8e3s4) {
    return toLong(reverseBytes_1(_this__u8e3s4.u3(new Long(-1, 0)).z3())).r3(32).v3(toLong(reverseBytes_1(_this__u8e3s4.t3(32).z3())).u3(new Long(-1, 0)));
  }
  function reverseBytes_3(_this__u8e3s4) {
    return toShort((_this__u8e3s4 & 255) << 8 | ((_this__u8e3s4 & 65535) >>> 8 | 0));
  }
  function Default_1() {
    Default_instance_1 = this;
    Json_0.call(this, new JsonConfiguration(), EmptySerializersModule_0());
  }
  var Default_instance_1;
  function Default_getInstance_1() {
    if (Default_instance_1 == null)
      new Default_1();
    return Default_instance_1;
  }
  function Json_0(configuration, serializersModule) {
    Default_getInstance_1();
    this.j65_1 = configuration;
    this.k65_1 = serializersModule;
    this.l65_1 = new DescriptorSchemaCache();
  }
  protoOf(Json_0).h5d = function () {
    return this.k65_1;
  };
  protoOf(Json_0).f5e = function (serializer, value) {
    var result = new JsonToStringWriter();
    try {
      encodeByWriter(this, result, serializer, value);
      return result.toString();
    }finally {
      result.vz();
    }
  };
  protoOf(Json_0).g5e = function (deserializer, string) {
    var lexer = new StringJsonLexer_0(string);
    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.w5c(), null);
    var result = input.l5d(deserializer);
    lexer.b66();
    return result;
  };
  protoOf(Json_0).m65 = function (serializer, value) {
    return writeJson(this, value, serializer);
  };
  protoOf(Json_0).n65 = function (deserializer, element) {
    return readJson(this, element, deserializer);
  };
  function Json_1(from, builderAction) {
    from = from === VOID ? Default_getInstance_1() : from;
    var builder = new JsonBuilder(from);
    builderAction(builder);
    var conf = builder.q66();
    return new JsonImpl(conf, builder.p66_1);
  }
  function JsonBuilder(json) {
    this.c66_1 = json.j65_1.r66_1;
    this.d66_1 = json.j65_1.w66_1;
    this.e66_1 = json.j65_1.s66_1;
    this.f66_1 = json.j65_1.t66_1;
    this.g66_1 = json.j65_1.u66_1;
    this.h66_1 = json.j65_1.v66_1;
    this.i66_1 = json.j65_1.x66_1;
    this.j66_1 = json.j65_1.y66_1;
    this.k66_1 = json.j65_1.z66_1;
    this.l66_1 = json.j65_1.a67_1;
    this.m66_1 = json.j65_1.b67_1;
    this.n66_1 = json.j65_1.c67_1;
    this.o66_1 = json.j65_1.d67_1;
    this.p66_1 = json.h5d();
  }
  protoOf(JsonBuilder).q66 = function () {
    if (this.k66_1) {
      // Inline function 'kotlin.require' call
      if (!(this.l66_1 === 'type')) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message = 'Class discriminator should not be specified when array polymorphism is specified';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
    }
    if (!this.h66_1) {
      // Inline function 'kotlin.require' call
      if (!(this.i66_1 === '    ')) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_0 = 'Indent should not be specified when default printing mode is used';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      }
    } else if (!(this.i66_1 === '    ')) {
      var tmp2 = this.i66_1;
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(tmp2)) {
          var element = charSequenceGet(tmp2, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
          if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
            tmp$ret$3 = false;
            break $l$block;
          }
        }
        tmp$ret$3 = true;
      }
      var allWhitespaces = tmp$ret$3;
      // Inline function 'kotlin.require' call
      if (!allWhitespaces) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_1 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.i66_1;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
      }
    }
    return new JsonConfiguration(this.c66_1, this.e66_1, this.f66_1, this.g66_1, this.h66_1, this.d66_1, this.i66_1, this.j66_1, this.k66_1, this.l66_1, this.m66_1, this.n66_1, this.o66_1);
  };
  function validateConfiguration($this) {
    if (equals($this.h5d(), EmptySerializersModule_0()))
      return Unit_instance;
    var collector = new PolymorphismValidator($this.j65_1.z66_1, $this.j65_1.a67_1);
    $this.h5d().d5x(collector);
  }
  function JsonImpl(configuration, module_0) {
    Json_0.call(this, configuration, module_0);
    validateConfiguration(this);
  }
  function JsonClassDiscriminator() {
  }
  function JsonNames() {
  }
  function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy) {
    encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
    ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
    isLenient = isLenient === VOID ? false : isLenient;
    allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
    prettyPrint = prettyPrint === VOID ? false : prettyPrint;
    explicitNulls = explicitNulls === VOID ? true : explicitNulls;
    prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
    coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
    useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
    classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
    allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
    useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
    namingStrategy = namingStrategy === VOID ? null : namingStrategy;
    this.r66_1 = encodeDefaults;
    this.s66_1 = ignoreUnknownKeys;
    this.t66_1 = isLenient;
    this.u66_1 = allowStructuredMapKeys;
    this.v66_1 = prettyPrint;
    this.w66_1 = explicitNulls;
    this.x66_1 = prettyPrintIndent;
    this.y66_1 = coerceInputValues;
    this.z66_1 = useArrayPolymorphism;
    this.a67_1 = classDiscriminator;
    this.b67_1 = allowSpecialFloatingPointValues;
    this.c67_1 = useAlternativeNames;
    this.d67_1 = namingStrategy;
  }
  protoOf(JsonConfiguration).toString = function () {
    return 'JsonConfiguration(encodeDefaults=' + this.r66_1 + ', ignoreUnknownKeys=' + this.s66_1 + ', isLenient=' + this.t66_1 + ', ' + ('allowStructuredMapKeys=' + this.u66_1 + ', prettyPrint=' + this.v66_1 + ', explicitNulls=' + this.w66_1 + ', ') + ("prettyPrintIndent='" + this.x66_1 + "', coerceInputValues=" + this.y66_1 + ', useArrayPolymorphism=' + this.z66_1 + ', ') + ("classDiscriminator='" + this.a67_1 + "', allowSpecialFloatingPointValues=" + this.b67_1 + ', useAlternativeNames=' + this.c67_1 + ', ') + ('namingStrategy=' + toString_0(this.d67_1) + ')');
  };
  function JsonDecoder() {
  }
  function get_jsonUnquotedLiteralDescriptor() {
    _init_properties_JsonElement_kt__7cbdc2();
    return jsonUnquotedLiteralDescriptor;
  }
  var jsonUnquotedLiteralDescriptor;
  function Companion_82() {
  }
  var Companion_instance_82;
  function Companion_getInstance_82() {
    return Companion_instance_82;
  }
  function JsonPrimitive() {
    JsonElement.call(this);
  }
  protoOf(JsonPrimitive).toString = function () {
    return this.g67();
  };
  function get_jsonPrimitive(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error_1(_this__u8e3s4, 'JsonPrimitive');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function Companion_83() {
  }
  protoOf(Companion_83).h67 = function () {
    return JsonElementSerializer_getInstance();
  };
  var Companion_instance_83;
  function Companion_getInstance_83() {
    return Companion_instance_83;
  }
  function JsonElement() {
  }
  function JsonPrimitive_0(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, true);
  }
  function Companion_84() {
  }
  var Companion_instance_84;
  function Companion_getInstance_84() {
    return Companion_instance_84;
  }
  function JsonObject$toString$lambda(_name_for_destructuring_parameter_0__wldtmu) {
    // Inline function 'kotlin.collections.component1' call
    var k = _name_for_destructuring_parameter_0__wldtmu.x();
    // Inline function 'kotlin.collections.component2' call
    var v = _name_for_destructuring_parameter_0__wldtmu.y();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'kotlinx.serialization.json.JsonObject.toString.<anonymous>.<anonymous>' call
    printQuoted(this_0, k);
    this_0.e9(_Char___init__impl__6a9atx(58));
    this_0.c9(v);
    return this_0.toString();
  }
  function JsonObject_0(content) {
    JsonElement.call(this);
    this.i67_1 = content;
  }
  protoOf(JsonObject_0).w = function () {
    return this.i67_1.w();
  };
  protoOf(JsonObject_0).u2 = function () {
    return this.i67_1.u2();
  };
  protoOf(JsonObject_0).n = function () {
    return this.i67_1.n();
  };
  protoOf(JsonObject_0).v2 = function () {
    return this.i67_1.v2();
  };
  protoOf(JsonObject_0).j67 = function (key) {
    return this.i67_1.w2(key);
  };
  protoOf(JsonObject_0).w2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.j67((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject_0).fe = function (key) {
    return this.i67_1.y2(key);
  };
  protoOf(JsonObject_0).y2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.fe((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject_0).p = function () {
    return this.i67_1.p();
  };
  protoOf(JsonObject_0).equals = function (other) {
    return equals(this.i67_1, other);
  };
  protoOf(JsonObject_0).hashCode = function () {
    return hashCode(this.i67_1);
  };
  protoOf(JsonObject_0).toString = function () {
    var tmp = this.i67_1.w();
    return joinToString_0(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
  };
  function get_jsonObject(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonObject_0 ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error_1(_this__u8e3s4, 'JsonObject');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function error_1(_this__u8e3s4, element) {
    _init_properties_JsonElement_kt__7cbdc2();
    throw IllegalArgumentException_init_$Create$_0('Element ' + toString_1(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
  }
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.l67_1.y();
  }
  function JsonNull$_anonymous__enib48() {
    return JsonNullSerializer_getInstance();
  }
  function JsonNull_0() {
    JsonNull_instance = this;
    JsonPrimitive.call(this);
    this.k67_1 = 'null';
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.l67_1 = lazy(tmp_0, JsonNull$_anonymous__enib48);
  }
  protoOf(JsonNull_0).g67 = function () {
    return this.k67_1;
  };
  protoOf(JsonNull_0).h67 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(JsonNull_0).t5o = function (typeParamsSerializers) {
    return this.h67();
  };
  var JsonNull_instance;
  function JsonNull_getInstance() {
    if (JsonNull_instance == null)
      new JsonNull_0();
    return JsonNull_instance;
  }
  function JsonLiteral(body, isString, coerceToInlineType) {
    coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
    JsonPrimitive.call(this);
    this.m67_1 = isString;
    this.n67_1 = coerceToInlineType;
    this.o67_1 = toString_1(body);
    if (!(this.n67_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!this.n67_1.q5e()) {
        // Inline function 'kotlin.require.<anonymous>' call
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
    }
  }
  protoOf(JsonLiteral).g67 = function () {
    return this.o67_1;
  };
  protoOf(JsonLiteral).toString = function () {
    var tmp;
    if (this.m67_1) {
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$_1();
      // Inline function 'kotlinx.serialization.json.JsonLiteral.toString.<anonymous>' call
      printQuoted(this_0, this.o67_1);
      tmp = this_0.toString();
    } else {
      tmp = this.o67_1;
    }
    return tmp;
  };
  protoOf(JsonLiteral).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof JsonLiteral))
      THROW_CCE();
    if (!(this.m67_1 === other.m67_1))
      return false;
    if (!(this.o67_1 === other.o67_1))
      return false;
    return true;
  };
  protoOf(JsonLiteral).hashCode = function () {
    var result = getBooleanHashCode(this.m67_1);
    result = imul(31, result) + getStringHashCode(this.o67_1) | 0;
    return result;
  };
  function Companion_85() {
  }
  var Companion_instance_85;
  function Companion_getInstance_85() {
    return Companion_instance_85;
  }
  function JsonArray_0(content) {
    JsonElement.call(this);
    this.p67_1 = content;
  }
  protoOf(JsonArray_0).n = function () {
    return this.p67_1.n();
  };
  protoOf(JsonArray_0).q67 = function (element) {
    return this.p67_1.s(element);
  };
  protoOf(JsonArray_0).s = function (element) {
    if (!(element instanceof JsonElement))
      return false;
    return this.q67(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray_0).r67 = function (elements) {
    return this.p67_1.h2(elements);
  };
  protoOf(JsonArray_0).h2 = function (elements) {
    return this.r67(elements);
  };
  protoOf(JsonArray_0).q = function (index) {
    return this.p67_1.q(index);
  };
  protoOf(JsonArray_0).s67 = function (element) {
    return this.p67_1.t(element);
  };
  protoOf(JsonArray_0).t = function (element) {
    if (!(element instanceof JsonElement))
      return -1;
    return this.s67(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray_0).p = function () {
    return this.p67_1.p();
  };
  protoOf(JsonArray_0).k = function () {
    return this.p67_1.k();
  };
  protoOf(JsonArray_0).t67 = function (element) {
    return this.p67_1.u(element);
  };
  protoOf(JsonArray_0).u = function (element) {
    if (!(element instanceof JsonElement))
      return -1;
    return this.t67(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray_0).i2 = function () {
    return this.p67_1.i2();
  };
  protoOf(JsonArray_0).r = function (index) {
    return this.p67_1.r(index);
  };
  protoOf(JsonArray_0).j2 = function (fromIndex, toIndex) {
    return this.p67_1.j2(fromIndex, toIndex);
  };
  protoOf(JsonArray_0).equals = function (other) {
    return equals(this.p67_1, other);
  };
  protoOf(JsonArray_0).hashCode = function () {
    return hashCode(this.p67_1);
  };
  protoOf(JsonArray_0).toString = function () {
    return joinToString_0(this.p67_1, ',', '[', ']');
  };
  function get_longOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toLongOrNull(_this__u8e3s4.g67());
  }
  function get_doubleOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toDoubleOrNull(_this__u8e3s4.g67());
  }
  function get_booleanOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toBooleanStrictOrNull(_this__u8e3s4.g67());
  }
  function JsonPrimitive_1(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, false);
  }
  function JsonPrimitive_2(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, false);
  }
  function get_int(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toInt(_this__u8e3s4.g67());
  }
  function get_long(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toLong_1(_this__u8e3s4.g67());
  }
  function get_float(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    // Inline function 'kotlin.text.toFloat' call
    var this_0 = _this__u8e3s4.g67();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return toDouble(this_0);
  }
  function get_double(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toDouble(_this__u8e3s4.g67());
  }
  function get_contentOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp;
    if (_this__u8e3s4 instanceof JsonNull_0) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4.g67();
    }
    return tmp;
  }
  var properties_initialized_JsonElement_kt_abxy8s;
  function _init_properties_JsonElement_kt__7cbdc2() {
    if (!properties_initialized_JsonElement_kt_abxy8s) {
      properties_initialized_JsonElement_kt_abxy8s = true;
      jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer_3(StringCompanionObject_instance));
    }
  }
  function JsonObjectBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.linkedMapOf' call
    tmp.u67_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(JsonObjectBuilder).v67 = function (key, element) {
    return this.u67_1.r2(key, element);
  };
  protoOf(JsonObjectBuilder).q66 = function () {
    return new JsonObject_0(this.u67_1);
  };
  function put(_this__u8e3s4, key, value) {
    return _this__u8e3s4.v67(key, JsonPrimitive_0(value));
  }
  function JsonArrayBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.w67_1 = ArrayList_init_$Create$();
  }
  protoOf(JsonArrayBuilder).x67 = function (element) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.w67_1.e(element);
    return true;
  };
  protoOf(JsonArrayBuilder).q66 = function () {
    return new JsonArray_0(this.w67_1);
  };
  function JsonPrimitiveSerializer() {
    JsonPrimitiveSerializer_instance = this;
    this.y67_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
  }
  protoOf(JsonPrimitiveSerializer).w5c = function () {
    return this.y67_1;
  };
  protoOf(JsonPrimitiveSerializer).z67 = function (encoder, value) {
    verify(encoder);
    var tmp;
    if (value instanceof JsonNull_0) {
      encoder.i5d(JsonNullSerializer_getInstance(), JsonNull_getInstance());
      tmp = Unit_instance;
    } else {
      var tmp_0 = JsonLiteralSerializer_getInstance();
      encoder.i5d(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(JsonPrimitiveSerializer).j5d = function (encoder, value) {
    return this.z67(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
  };
  protoOf(JsonPrimitiveSerializer).k5d = function (decoder) {
    var result = asJsonDecoder(decoder).f67();
    if (!(result instanceof JsonPrimitive))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + toString_1(getKClassFromExpression(result)), toString_1(result));
    return result;
  };
  var JsonPrimitiveSerializer_instance;
  function JsonPrimitiveSerializer_getInstance() {
    if (JsonPrimitiveSerializer_instance == null)
      new JsonPrimitiveSerializer();
    return JsonPrimitiveSerializer_instance;
  }
  function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.p5d('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
    $this$buildSerialDescriptor.p5d('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
    $this$buildSerialDescriptor.p5d('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
    $this$buildSerialDescriptor.p5d('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
    $this$buildSerialDescriptor.p5d('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
    return Unit_instance;
  }
  function JsonElementSerializer$descriptor$lambda$lambda() {
    return JsonPrimitiveSerializer_getInstance().y67_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_0() {
    return JsonNullSerializer_getInstance().a68_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_1() {
    return JsonLiteralSerializer_getInstance().b68_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_2() {
    return JsonObjectSerializer_getInstance().c68_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_3() {
    return JsonArraySerializer_getInstance().d68_1;
  }
  function JsonElementSerializer() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    tmp.e68_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
  }
  protoOf(JsonElementSerializer).w5c = function () {
    return this.e68_1;
  };
  protoOf(JsonElementSerializer).f68 = function (encoder, value) {
    verify(encoder);
    if (value instanceof JsonPrimitive) {
      encoder.i5d(JsonPrimitiveSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonObject_0) {
        encoder.i5d(JsonObjectSerializer_getInstance(), value);
      } else {
        if (value instanceof JsonArray_0) {
          encoder.i5d(JsonArraySerializer_getInstance(), value);
        }
      }
    }
  };
  protoOf(JsonElementSerializer).j5d = function (encoder, value) {
    return this.f68(encoder, value instanceof JsonElement ? value : THROW_CCE());
  };
  protoOf(JsonElementSerializer).k5d = function (decoder) {
    var input = asJsonDecoder(decoder);
    return input.f67();
  };
  var JsonElementSerializer_instance;
  function JsonElementSerializer_getInstance() {
    if (JsonElementSerializer_instance == null)
      new JsonElementSerializer();
    return JsonElementSerializer_instance;
  }
  function JsonObjectDescriptor() {
    JsonObjectDescriptor_instance = this;
    this.g68_1 = MapSerializer(serializer_3(StringCompanionObject_instance), JsonElementSerializer_getInstance()).w5c();
    this.h68_1 = 'kotlinx.serialization.json.JsonObject';
  }
  protoOf(JsonObjectDescriptor).x5c = function () {
    return this.g68_1.x5c();
  };
  protoOf(JsonObjectDescriptor).p5e = function () {
    return this.g68_1.p5e();
  };
  protoOf(JsonObjectDescriptor).q5e = function () {
    return this.g68_1.q5e();
  };
  protoOf(JsonObjectDescriptor).l5e = function () {
    return this.g68_1.l5e();
  };
  protoOf(JsonObjectDescriptor).r5e = function () {
    return this.g68_1.r5e();
  };
  protoOf(JsonObjectDescriptor).s5e = function (index) {
    return this.g68_1.s5e(index);
  };
  protoOf(JsonObjectDescriptor).t5e = function (index) {
    return this.g68_1.t5e(index);
  };
  protoOf(JsonObjectDescriptor).u5e = function (name) {
    return this.g68_1.u5e(name);
  };
  protoOf(JsonObjectDescriptor).v5e = function (index) {
    return this.g68_1.v5e(index);
  };
  protoOf(JsonObjectDescriptor).w5e = function (index) {
    return this.g68_1.w5e(index);
  };
  protoOf(JsonObjectDescriptor).b5e = function () {
    return this.h68_1;
  };
  var JsonObjectDescriptor_instance;
  function JsonObjectDescriptor_getInstance() {
    if (JsonObjectDescriptor_instance == null)
      new JsonObjectDescriptor();
    return JsonObjectDescriptor_instance;
  }
  function JsonObjectSerializer() {
    JsonObjectSerializer_instance = this;
    this.c68_1 = JsonObjectDescriptor_getInstance();
  }
  protoOf(JsonObjectSerializer).w5c = function () {
    return this.c68_1;
  };
  protoOf(JsonObjectSerializer).i68 = function (encoder, value) {
    verify(encoder);
    MapSerializer(serializer_3(StringCompanionObject_instance), JsonElementSerializer_getInstance()).j5d(encoder, value);
  };
  protoOf(JsonObjectSerializer).j5d = function (encoder, value) {
    return this.i68(encoder, value instanceof JsonObject_0 ? value : THROW_CCE());
  };
  protoOf(JsonObjectSerializer).k5d = function (decoder) {
    verify_0(decoder);
    return new JsonObject_0(MapSerializer(serializer_3(StringCompanionObject_instance), JsonElementSerializer_getInstance()).k5d(decoder));
  };
  var JsonObjectSerializer_instance;
  function JsonObjectSerializer_getInstance() {
    if (JsonObjectSerializer_instance == null)
      new JsonObjectSerializer();
    return JsonObjectSerializer_instance;
  }
  function JsonNullSerializer() {
    JsonNullSerializer_instance = this;
    this.a68_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
  }
  protoOf(JsonNullSerializer).w5c = function () {
    return this.a68_1;
  };
  protoOf(JsonNullSerializer).j68 = function (encoder, value) {
    verify(encoder);
    encoder.d5h();
  };
  protoOf(JsonNullSerializer).j5d = function (encoder, value) {
    return this.j68(encoder, value instanceof JsonNull_0 ? value : THROW_CCE());
  };
  protoOf(JsonNullSerializer).k5d = function (decoder) {
    verify_0(decoder);
    if (decoder.v5f()) {
      throw new JsonDecodingException("Expected 'null' literal");
    }
    decoder.w5f();
    return JsonNull_getInstance();
  };
  var JsonNullSerializer_instance;
  function JsonNullSerializer_getInstance() {
    if (JsonNullSerializer_instance == null)
      new JsonNullSerializer();
    return JsonNullSerializer_instance;
  }
  function verify(encoder) {
    asJsonEncoder(encoder);
  }
  function JsonLiteralSerializer() {
    JsonLiteralSerializer_instance = this;
    this.b68_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  protoOf(JsonLiteralSerializer).w5c = function () {
    return this.b68_1;
  };
  protoOf(JsonLiteralSerializer).k68 = function (encoder, value) {
    verify(encoder);
    if (value.m67_1) {
      return encoder.m5h(value.o67_1);
    }
    if (!(value.n67_1 == null)) {
      return encoder.o5h(value.n67_1).m5h(value.o67_1);
    }
    var tmp0_safe_receiver = get_longOrNull(value);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.i5h(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = toULongOrNull(value.o67_1);
    var tmp = tmp1_safe_receiver;
    if ((tmp == null ? null : new ULong(tmp)) == null)
      null;
    else {
      var tmp_0 = tmp1_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_0 == null ? null : new ULong(tmp_0)).s1_1;
      var tmp_1 = encoder.o5h(serializer_8(Companion_getInstance_20()).w5c());
      // Inline function 'kotlin.ULong.toLong' call
      var tmp$ret$1 = _ULong___get_data__impl__fggpzb(it);
      tmp_1.i5h(tmp$ret$1);
      return Unit_instance;
    }
    var tmp2_safe_receiver = get_doubleOrNull(value);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.k5h(tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = get_booleanOrNull(value);
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return encoder.e5h(tmp3_safe_receiver);
    }
    encoder.m5h(value.o67_1);
  };
  protoOf(JsonLiteralSerializer).j5d = function (encoder, value) {
    return this.k68(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
  };
  protoOf(JsonLiteralSerializer).k5d = function (decoder) {
    var result = asJsonDecoder(decoder).f67();
    if (!(result instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + toString_1(getKClassFromExpression(result)), toString_1(result));
    return result;
  };
  var JsonLiteralSerializer_instance;
  function JsonLiteralSerializer_getInstance() {
    if (JsonLiteralSerializer_instance == null)
      new JsonLiteralSerializer();
    return JsonLiteralSerializer_instance;
  }
  function asJsonDecoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString_1(getKClassFromExpression(_this__u8e3s4))));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function defer(deferred) {
    return new defer$1(deferred);
  }
  function JsonArrayDescriptor() {
    JsonArrayDescriptor_instance = this;
    this.l68_1 = ListSerializer(JsonElementSerializer_getInstance()).w5c();
    this.m68_1 = 'kotlinx.serialization.json.JsonArray';
  }
  protoOf(JsonArrayDescriptor).x5c = function () {
    return this.l68_1.x5c();
  };
  protoOf(JsonArrayDescriptor).p5e = function () {
    return this.l68_1.p5e();
  };
  protoOf(JsonArrayDescriptor).q5e = function () {
    return this.l68_1.q5e();
  };
  protoOf(JsonArrayDescriptor).l5e = function () {
    return this.l68_1.l5e();
  };
  protoOf(JsonArrayDescriptor).r5e = function () {
    return this.l68_1.r5e();
  };
  protoOf(JsonArrayDescriptor).s5e = function (index) {
    return this.l68_1.s5e(index);
  };
  protoOf(JsonArrayDescriptor).t5e = function (index) {
    return this.l68_1.t5e(index);
  };
  protoOf(JsonArrayDescriptor).u5e = function (name) {
    return this.l68_1.u5e(name);
  };
  protoOf(JsonArrayDescriptor).v5e = function (index) {
    return this.l68_1.v5e(index);
  };
  protoOf(JsonArrayDescriptor).w5e = function (index) {
    return this.l68_1.w5e(index);
  };
  protoOf(JsonArrayDescriptor).b5e = function () {
    return this.m68_1;
  };
  var JsonArrayDescriptor_instance;
  function JsonArrayDescriptor_getInstance() {
    if (JsonArrayDescriptor_instance == null)
      new JsonArrayDescriptor();
    return JsonArrayDescriptor_instance;
  }
  function JsonArraySerializer() {
    JsonArraySerializer_instance = this;
    this.d68_1 = JsonArrayDescriptor_getInstance();
  }
  protoOf(JsonArraySerializer).w5c = function () {
    return this.d68_1;
  };
  protoOf(JsonArraySerializer).n68 = function (encoder, value) {
    verify(encoder);
    ListSerializer(JsonElementSerializer_getInstance()).j5d(encoder, value);
  };
  protoOf(JsonArraySerializer).j5d = function (encoder, value) {
    return this.n68(encoder, value instanceof JsonArray_0 ? value : THROW_CCE());
  };
  protoOf(JsonArraySerializer).k5d = function (decoder) {
    verify_0(decoder);
    return new JsonArray_0(ListSerializer(JsonElementSerializer_getInstance()).k5d(decoder));
  };
  var JsonArraySerializer_instance;
  function JsonArraySerializer_getInstance() {
    if (JsonArraySerializer_instance == null)
      new JsonArraySerializer();
    return JsonArraySerializer_instance;
  }
  function verify_0(decoder) {
    asJsonDecoder(decoder);
  }
  function asJsonEncoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString_1(getKClassFromExpression(_this__u8e3s4))));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_original__l7ku1m($this) {
    var tmp0 = $this.o68_1;
    // Inline function 'kotlin.getValue' call
    original$factory();
    return tmp0.y();
  }
  function defer$1($deferred) {
    this.o68_1 = lazy_0($deferred);
  }
  protoOf(defer$1).b5e = function () {
    return _get_original__l7ku1m(this).b5e();
  };
  protoOf(defer$1).r5e = function () {
    return _get_original__l7ku1m(this).r5e();
  };
  protoOf(defer$1).p5e = function () {
    return _get_original__l7ku1m(this).p5e();
  };
  protoOf(defer$1).v5e = function (index) {
    return _get_original__l7ku1m(this).v5e(index);
  };
  protoOf(defer$1).u5e = function (name) {
    return _get_original__l7ku1m(this).u5e(name);
  };
  protoOf(defer$1).s5e = function (index) {
    return _get_original__l7ku1m(this).s5e(index);
  };
  protoOf(defer$1).t5e = function (index) {
    return _get_original__l7ku1m(this).t5e(index);
  };
  protoOf(defer$1).w5e = function (index) {
    return _get_original__l7ku1m(this).w5e(index);
  };
  function original$factory() {
    return getPropertyCallableRef('original', 1, KProperty1, function (receiver) {
      return _get_original__l7ku1m(receiver);
    }, null);
  }
  function JsonEncoder() {
  }
  function Composer(writer) {
    this.p68_1 = writer;
    this.q68_1 = true;
  }
  protoOf(Composer).b2u = function () {
    this.q68_1 = true;
  };
  protoOf(Composer).r68 = function () {
    return Unit_instance;
  };
  protoOf(Composer).s68 = function () {
    this.q68_1 = false;
  };
  protoOf(Composer).t68 = function () {
    return Unit_instance;
  };
  protoOf(Composer).u68 = function (v) {
    return this.p68_1.v68(v);
  };
  protoOf(Composer).w68 = function (v) {
    return this.p68_1.x68(v);
  };
  protoOf(Composer).y68 = function (v) {
    return this.p68_1.x68(v.toString());
  };
  protoOf(Composer).z68 = function (v) {
    return this.p68_1.x68(v.toString());
  };
  protoOf(Composer).a69 = function (v) {
    return this.p68_1.m63(toLong(v));
  };
  protoOf(Composer).b69 = function (v) {
    return this.p68_1.m63(toLong(v));
  };
  protoOf(Composer).c69 = function (v) {
    return this.p68_1.m63(toLong(v));
  };
  protoOf(Composer).d69 = function (v) {
    return this.p68_1.m63(v);
  };
  protoOf(Composer).e69 = function (v) {
    return this.p68_1.x68(v.toString());
  };
  protoOf(Composer).f69 = function (value) {
    return this.p68_1.g69(value);
  };
  function Composer_0(sb, json) {
    return json.j65_1.v66_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
  }
  function ComposerForUnsignedNumbers(writer, forceQuoting) {
    Composer.call(this, writer);
    this.j69_1 = forceQuoting;
  }
  protoOf(ComposerForUnsignedNumbers).c69 = function (v) {
    if (this.j69_1) {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
      this.f69(UInt__toString_impl_dbgl21(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
      this.w68(UInt__toString_impl_dbgl21(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).d69 = function (v) {
    if (this.j69_1) {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
      this.f69(ULong__toString_impl_f9au7k(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
      this.w68(ULong__toString_impl_f9au7k(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).a69 = function (v) {
    if (this.j69_1) {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
      this.f69(UByte__toString_impl_v72jg(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
      this.w68(UByte__toString_impl_v72jg(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).b69 = function (v) {
    if (this.j69_1) {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$0 = _UShort___init__impl__jigrne(v);
      this.f69(UShort__toString_impl_edaoee(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$1 = _UShort___init__impl__jigrne(v);
      this.w68(UShort__toString_impl_edaoee(tmp$ret$1));
    }
  };
  function ComposerForUnquotedLiterals(writer, forceQuoting) {
    Composer.call(this, writer);
    this.m69_1 = forceQuoting;
  }
  protoOf(ComposerForUnquotedLiterals).f69 = function (value) {
    if (this.m69_1) {
      protoOf(Composer).f69.call(this, value);
    } else {
      protoOf(Composer).w68.call(this, value);
    }
  };
  function ComposerWithPrettyPrint(writer, json) {
    Composer.call(this, writer);
    this.p69_1 = json;
    this.q69_1 = 0;
  }
  protoOf(ComposerWithPrettyPrint).b2u = function () {
    this.q68_1 = true;
    this.q69_1 = this.q69_1 + 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).r68 = function () {
    this.q69_1 = this.q69_1 - 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).s68 = function () {
    this.q68_1 = false;
    this.w68('\n');
    // Inline function 'kotlin.repeat' call
    var times = this.q69_1;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.ComposerWithPrettyPrint.nextItem.<anonymous>' call
        this.w68(this.p69_1.j65_1.x66_1);
      }
       while (inductionVariable < times);
  };
  protoOf(ComposerWithPrettyPrint).t68 = function () {
    this.u68(_Char___init__impl__6a9atx(32));
  };
  function readIfAbsent_0($this, descriptor, index) {
    $this.s69_1 = (!descriptor.w5e(index) && descriptor.t5e(index).l5e());
    return $this.s69_1;
  }
  function JsonElementMarker$readIfAbsent$ref($boundThis) {
    var l = function (p0, p1) {
      return readIfAbsent_0($boundThis, p0, p1);
    };
    l.callableName = 'readIfAbsent';
    return l;
  }
  function JsonElementMarker(descriptor) {
    var tmp = this;
    tmp.r69_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
    this.s69_1 = false;
  }
  protoOf(JsonElementMarker).t69 = function (index) {
    this.r69_1.l5m(index);
  };
  protoOf(JsonElementMarker).u69 = function () {
    return this.r69_1.m5m();
  };
  function JsonDecodingException(message) {
    JsonException_0.call(this, message);
    captureStack(this, JsonDecodingException);
  }
  function JsonDecodingException_0(offset, message, input) {
    return JsonDecodingException_1(offset, message + '\nJSON input: ' + toString_1(minify(input, offset)));
  }
  function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
    _this__u8e3s4.v69('Unexpected special floating-point value ' + toString_1(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
  }
  function JsonEncodingException(message) {
    JsonException_0.call(this, message);
    captureStack(this, JsonEncodingException);
  }
  function InvalidKeyKindException(keyDescriptor) {
    return new JsonEncodingException("Value of type '" + keyDescriptor.b5e() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.r5e().toString() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
  }
  function InvalidFloatingPointEncoded(value, key, output) {
    return new JsonEncodingException(unexpectedFpErrorMessage(value, key, output));
  }
  function InvalidFloatingPointDecoded(value, key, output) {
    return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
  }
  function JsonDecodingException_1(offset, message) {
    return new JsonDecodingException(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
  }
  function UnknownKeyException(key, input) {
    return JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "'.\n" + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.\n" + ('Current input: ' + toString_1(minify(input))));
  }
  function JsonException_0(message) {
    SerializationException_init_$Init$_0(message, this);
    captureStack(this, JsonException_0);
  }
  function minify(_this__u8e3s4, offset) {
    offset = offset === VOID ? -1 : offset;
    if (charSequenceLength(_this__u8e3s4) < 200)
      return _this__u8e3s4;
    if (offset === -1) {
      var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
      if (start <= 0)
        return _this__u8e3s4;
      // Inline function 'kotlin.text.substring' call
      var endIndex = charSequenceLength(_this__u8e3s4);
      return '.....' + toString_1(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
    }
    var start_0 = offset - 30 | 0;
    var end = offset + 30 | 0;
    var prefix = start_0 <= 0 ? '' : '.....';
    var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
    var tmp4 = coerceAtLeast(start_0, 0);
    // Inline function 'kotlin.text.substring' call
    var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
    return prefix + toString_1(charSequenceSubSequence(_this__u8e3s4, tmp4, endIndex_0)) + suffix;
  }
  function unexpectedFpErrorMessage(value, key, output) {
    return 'Unexpected special floating-point value ' + toString_1(value) + ' with key ' + key + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString_1(minify(output)));
  }
  function InvalidFloatingPointEncoded_0(value, output) {
    return new JsonEncodingException('Unexpected special floating-point value ' + toString_1(value) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString_1(minify(output))));
  }
  function get_JsonDeserializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonDeserializationNamesKey;
  }
  var JsonDeserializationNamesKey;
  function get_JsonSerializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonSerializationNamesKey;
  }
  var JsonSerializationNamesKey;
  function getJsonNameIndex(_this__u8e3s4, json, name) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    if (!(strategy == null))
      return getJsonNameIndex$getJsonNameIndexSlowPath(json, _this__u8e3s4, name);
    var index = _this__u8e3s4.u5e(name);
    if (!(index === -3))
      return index;
    if (!json.j65_1.c67_1)
      return index;
    return getJsonNameIndex$getJsonNameIndexSlowPath(json, _this__u8e3s4, name);
  }
  function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
    suffix = suffix === VOID ? '' : suffix;
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var index = getJsonNameIndex(_this__u8e3s4, json, name);
    if (index === -3)
      throw SerializationException_init_$Create$_0(_this__u8e3s4.b5e() + " does not contain element with name '" + name + "'" + suffix);
    return index;
  }
  function getJsonElementName(_this__u8e3s4, json, index) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    return strategy == null ? _this__u8e3s4.v5e(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
  }
  function namingStrategy(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return equals(_this__u8e3s4.r5e(), CLASS_getInstance()) ? json.j65_1.d67_1 : null;
  }
  function deserializationNamesMap(_this__u8e3s4, descriptor) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(_this__u8e3s4);
    var tmp_0 = get_JsonDeserializationNamesKey();
    return tmp.x69(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
  }
  function serializationNamesIndices(_this__u8e3s4, json, strategy) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(json);
    var tmp_0 = get_JsonSerializationNamesKey();
    return tmp.x69(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
  }
  function buildDeserializationNamesMap(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var builder = LinkedHashMap_init_$Create$();
    var strategy = namingStrategy(_this__u8e3s4, json);
    var inductionVariable = 0;
    var last = _this__u8e3s4.p5e();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.filterIsInstance' call
        var tmp0 = _this__u8e3s4.s5e(i);
        // Inline function 'kotlin.collections.filterIsInstanceTo' call
        var destination = ArrayList_init_$Create$();
        var _iterator__ex2g4s = tmp0.k();
        while (_iterator__ex2g4s.l()) {
          var element = _iterator__ex2g4s.m();
          if (element instanceof JsonNames) {
            destination.e(element);
          }
        }
        var tmp1_safe_receiver = singleOrNull_0(destination);
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.y69_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable_0 = 0;
          var last_0 = tmp2_safe_receiver.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = tmp2_safe_receiver[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
            buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, element_0, i);
          }
        }
        if (strategy == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, strategy.z69(_this__u8e3s4, i, _this__u8e3s4.v5e(i)), i);
        }
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp;
    if (builder.p()) {
      // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
      tmp = emptyMap();
    } else {
      tmp = builder;
    }
    return tmp;
  }
  function getJsonNameIndex$getJsonNameIndexSlowPath($json, $this_getJsonNameIndex, $name) {
    var tmp0_elvis_lhs = deserializationNamesMap($json, $this_getJsonNameIndex).y2($name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  }
  function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    if ((isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).w2(name)) {
      throw new JsonException_0("The suggested name '" + name + "' for property " + $this_buildDeserializationNamesMap.v5e(index) + ' is already one of the names for property ' + ($this_buildDeserializationNamesMap.v5e(getValue_0(_this__u8e3s4, name)) + ' in ' + toString_1($this_buildDeserializationNamesMap)));
    }
    // Inline function 'kotlin.collections.set' call
    _this__u8e3s4.r2(name, index);
  }
  function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
    return function () {
      return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
    };
  }
  function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
    return function () {
      var tmp = 0;
      var tmp_0 = $this_serializationNamesIndices.p5e();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        var baseName = $this_serializationNamesIndices.v5e(tmp_2);
        tmp_1[tmp_2] = $strategy.z69($this_serializationNamesIndices, tmp_2, baseName);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  var properties_initialized_JsonNamesMap_kt_ljpf42;
  function _init_properties_JsonNamesMap_kt__cbbp0k() {
    if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
      properties_initialized_JsonNamesMap_kt_ljpf42 = true;
      JsonDeserializationNamesKey = new Key_6();
      JsonSerializationNamesKey = new Key_6();
    }
  }
  function Tombstone() {
  }
  var Tombstone_instance;
  function Tombstone_getInstance() {
    return Tombstone_instance;
  }
  function resize($this) {
    var newSize = imul($this.c6a_1, 2);
    $this.a6a_1 = copyOf_8($this.a6a_1, newSize);
    $this.b6a_1 = copyOf_3($this.b6a_1, newSize);
  }
  function JsonPath() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.a6a_1 = fillArrayVal(Array(8), null);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(8);
    while (tmp_1 < 8) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.b6a_1 = tmp_2;
    this.c6a_1 = -1;
  }
  protoOf(JsonPath).d6a = function (sd) {
    this.c6a_1 = this.c6a_1 + 1 | 0;
    var depth = this.c6a_1;
    if (depth === this.a6a_1.length) {
      resize(this);
    }
    this.a6a_1[depth] = sd;
  };
  protoOf(JsonPath).e6a = function (index) {
    this.b6a_1[this.c6a_1] = index;
  };
  protoOf(JsonPath).f6a = function (key) {
    var tmp;
    if (!(this.b6a_1[this.c6a_1] === -2)) {
      this.c6a_1 = this.c6a_1 + 1 | 0;
      tmp = this.c6a_1 === this.a6a_1.length;
    } else {
      tmp = false;
    }
    if (tmp) {
      resize(this);
    }
    this.a6a_1[this.c6a_1] = key;
    this.b6a_1[this.c6a_1] = -2;
  };
  protoOf(JsonPath).g6a = function () {
    if (this.b6a_1[this.c6a_1] === -2) {
      this.a6a_1[this.c6a_1] = Tombstone_instance;
    }
  };
  protoOf(JsonPath).h6a = function () {
    var depth = this.c6a_1;
    if (this.b6a_1[depth] === -2) {
      this.b6a_1[depth] = -1;
      this.c6a_1 = this.c6a_1 - 1 | 0;
    }
    if (!(this.c6a_1 === -1)) {
      this.c6a_1 = this.c6a_1 - 1 | 0;
    }
  };
  protoOf(JsonPath).i6a = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>' call
    this_0.d9('$');
    // Inline function 'kotlin.repeat' call
    var times = this.c6a_1 + 1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>.<anonymous>' call
        var element = this.a6a_1[index];
        if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
          if (equals(element.r5e(), LIST_getInstance())) {
            if (!(this.b6a_1[index] === -1)) {
              this_0.d9('[');
              this_0.c9(this.b6a_1[index]);
              this_0.d9(']');
            }
          } else {
            var idx = this.b6a_1[index];
            if (idx >= 0) {
              this_0.d9('.');
              this_0.d9(element.v5e(idx));
            }
          }
        } else {
          if (!(element === Tombstone_instance)) {
            this_0.d9('[');
            this_0.d9("'");
            this_0.c9(element);
            this_0.d9("'");
            this_0.d9(']');
          }
        }
      }
       while (inductionVariable < times);
    return this_0.toString();
  };
  protoOf(JsonPath).toString = function () {
    return this.i6a();
  };
  function encodeByWriter(_this__u8e3s4, writer, serializer, value) {
    var tmp = WriteMode_OBJ_getInstance();
    // Inline function 'kotlin.arrayOfNulls' call
    var size = values_3().length;
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    var encoder = StreamingJsonEncoder_init_$Create$(writer, _this__u8e3s4, tmp, tmp$ret$0);
    encoder.i5d(serializer, value);
  }
  function readObject($this) {
    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
    var lastToken = $this.r6a_1.u6a(6);
    if ($this.r6a_1.v6a() === 4) {
      $this.r6a_1.v69('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.linkedMapOf' call
    var result = LinkedHashMap_init_$Create$();
    $l$loop: while ($this.r6a_1.w6a()) {
      var key = $this.s6a_1 ? $this.r6a_1.y6a() : $this.r6a_1.x6a();
      $this.r6a_1.u6a(5);
      // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObject.<anonymous>' call
      var element = $this.x64();
      // Inline function 'kotlin.collections.set' call
      result.r2(key, element);
      lastToken = $this.r6a_1.z6a();
      var tmp0_subject = lastToken;
      if (tmp0_subject !== 4)
        if (tmp0_subject === 7)
          break $l$loop;
        else {
          $this.r6a_1.v69('Expected end of the object or comma');
        }
    }
    if (lastToken === 6) {
      $this.r6a_1.u6a(7);
    } else if (lastToken === 4) {
      $this.r6a_1.v69('Unexpected trailing comma');
    }
    return new JsonObject_0(result);
  }
  function readObject_0(_this__u8e3s4, $this, $completion) {
    var tmp = new $readObjectCOROUTINE$0($this, _this__u8e3s4, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function readArray($this) {
    var lastToken = $this.r6a_1.z6a();
    if ($this.r6a_1.v6a() === 4) {
      $this.r6a_1.v69('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.arrayListOf' call
    var result = ArrayList_init_$Create$();
    while ($this.r6a_1.w6a()) {
      var element = $this.x64();
      result.e(element);
      lastToken = $this.r6a_1.z6a();
      if (!(lastToken === 4)) {
        var tmp0 = $this.r6a_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = lastToken === 9;
        var position = tmp0.x65_1;
        if (!condition) {
          // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readArray.<anonymous>' call
          var tmp$ret$1 = 'Expected end of the array or comma';
          tmp0.v69(tmp$ret$1, position);
        }
      }
    }
    if (lastToken === 8) {
      $this.r6a_1.u6a(9);
    } else if (lastToken === 4) {
      $this.r6a_1.v69('Unexpected trailing comma');
    }
    return new JsonArray_0(result);
  }
  function readValue($this, isString) {
    var tmp;
    if ($this.s6a_1 || !isString) {
      tmp = $this.r6a_1.y6a();
    } else {
      tmp = $this.r6a_1.x6a();
    }
    var string = tmp;
    if (!isString && string === 'null')
      return JsonNull_getInstance();
    return new JsonLiteral(string, isString);
  }
  function readDeepRecursive($this) {
    return invoke_4(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this, null)), Unit_instance);
  }
  function JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation) {
    this.x6b_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsonTreeReader$readDeepRecursive$slambda).c6c = function ($this$$receiver, it, $completion) {
    var tmp = this.d6c($this$$receiver, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
    return this.c6c(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.a6c_1 = this.x6b_1.r6a_1.v6a();
            if (this.a6c_1 === 1) {
              this.b6c_1 = readValue(this.x6b_1, true);
              this.y9_1 = 2;
              continue $sm;
            } else {
              if (this.a6c_1 === 0) {
                this.b6c_1 = readValue(this.x6b_1, false);
                this.y9_1 = 2;
                continue $sm;
              } else {
                if (this.a6c_1 === 6) {
                  this.y9_1 = 1;
                  suspendResult = readObject_0(this.y6b_1, this.x6b_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (this.a6c_1 === 8) {
                    this.b6c_1 = readArray(this.x6b_1);
                    this.y9_1 = 2;
                    continue $sm;
                  } else {
                    var tmp_0 = this;
                    this.x6b_1.r6a_1.v69("Can't begin reading element, unexpected token");
                  }
                }
              }
            }

            break;
          case 1:
            this.b6c_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            return this.b6c_1;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).d6c = function ($this$$receiver, it, completion) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this.x6b_1, completion);
    i.y6b_1 = $this$$receiver;
    i.z6b_1 = it;
    return i;
  };
  function JsonTreeReader$readDeepRecursive$slambda_0(this$0, resultContinuation) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation);
    var l = function ($this$$receiver, it, $completion) {
      return i.c6c($this$$receiver, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $readObjectCOROUTINE$0(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i6b_1 = _this__u8e3s4;
    this.j6b_1 = _this__u8e3s4_0;
  }
  protoOf($readObjectCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            var tmp_0 = this;
            tmp_0.k6b_1 = this.i6b_1;
            this.l6b_1 = this.k6b_1;
            this.m6b_1 = this.l6b_1.r6a_1.u6a(6);
            if (this.l6b_1.r6a_1.v6a() === 4) {
              this.l6b_1.r6a_1.v69('Unexpected leading comma');
            }

            var tmp_1 = this;
            tmp_1.n6b_1 = LinkedHashMap_init_$Create$();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.l6b_1.r6a_1.w6a()) {
              this.y9_1 = 4;
              continue $sm;
            }

            this.o6b_1 = this.l6b_1.s6a_1 ? this.l6b_1.r6a_1.y6a() : this.l6b_1.r6a_1.x6a();
            this.l6b_1.r6a_1.u6a(5);
            this.y9_1 = 2;
            suspendResult = this.j6b_1.rl(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var element = suspendResult;
            var tmp0 = this.n6b_1;
            var key = this.o6b_1;
            tmp0.r2(key, element);
            this.m6b_1 = this.l6b_1.r6a_1.z6a();
            var tmp0_subject = this.m6b_1;
            if (tmp0_subject === 4) {
              this.y9_1 = 3;
              continue $sm;
            } else {
              if (tmp0_subject === 7) {
                this.y9_1 = 4;
                continue $sm;
              } else {
                this.l6b_1.r6a_1.v69('Expected end of the object or comma');
              }
            }

            break;
          case 3:
            this.y9_1 = 1;
            continue $sm;
          case 4:
            if (this.m6b_1 === 6) {
              this.l6b_1.r6a_1.u6a(7);
            } else if (this.m6b_1 === 4) {
              this.l6b_1.r6a_1.v69('Unexpected trailing comma');
            }

            return new JsonObject_0(this.n6b_1);
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function JsonTreeReader(configuration, lexer) {
    this.r6a_1 = lexer;
    this.s6a_1 = configuration.t66_1;
    this.t6a_1 = 0;
  }
  protoOf(JsonTreeReader).x64 = function () {
    var token = this.r6a_1.v6a();
    var tmp;
    if (token === 1) {
      tmp = readValue(this, true);
    } else if (token === 0) {
      tmp = readValue(this, false);
    } else if (token === 6) {
      var tmp_0;
      this.t6a_1 = this.t6a_1 + 1 | 0;
      if (this.t6a_1 === 200) {
        tmp_0 = readDeepRecursive(this);
      } else {
        tmp_0 = readObject(this);
      }
      var result = tmp_0;
      this.t6a_1 = this.t6a_1 - 1 | 0;
      tmp = result;
    } else if (token === 8) {
      tmp = readArray(this);
    } else {
      this.r6a_1.v69('Cannot begin reading element, unexpected token: ' + token);
    }
    return tmp;
  };
  function classDiscriminator(_this__u8e3s4, json) {
    var tmp0_iterator = _this__u8e3s4.x5c().k();
    while (tmp0_iterator.l()) {
      var annotation = tmp0_iterator.m();
      if (annotation instanceof JsonClassDiscriminator)
        return annotation.e6c_1;
    }
    return json.j65_1.a67_1;
  }
  function decodeSerializableValuePolymorphic(_this__u8e3s4, deserializer) {
    var tmp;
    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
      tmp = true;
    } else {
      tmp = _this__u8e3s4.e67().j65_1.z66_1;
    }
    if (tmp) {
      return deserializer.k5d(_this__u8e3s4);
    }
    var discriminator = classDiscriminator(deserializer.w5c(), _this__u8e3s4.e67());
    var tmp0 = _this__u8e3s4.f67();
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var descriptor = deserializer.w5c();
    if (!(tmp0 instanceof JsonObject_0)) {
      throw JsonDecodingException_1(-1, 'Expected ' + toString_1(getKClass(JsonObject_0)) + ' as the serialized body of ' + descriptor.b5e() + ', but had ' + toString_1(getKClassFromExpression(tmp0)));
    }
    var jsonTree = tmp0;
    var tmp0_safe_receiver = jsonTree.fe(discriminator);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    var type = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.g67();
    var tmp2_elvis_lhs = deserializer.r5d(_this__u8e3s4, type);
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      throwSerializerNotFound(type, jsonTree);
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var actualSerializer = tmp_0;
    var tmp_1 = _this__u8e3s4.e67();
    return readPolymorphicJson(tmp_1, discriminator, jsonTree, isInterface(actualSerializer, DeserializationStrategy) ? actualSerializer : THROW_CCE());
  }
  function throwSerializerNotFound(type, jsonTree) {
    var suffix = type == null ? "missing class discriminator ('null')" : "class discriminator '" + type + "'";
    throw JsonDecodingException_0(-1, 'Polymorphic serializer was not found for ' + suffix, jsonTree.toString());
  }
  function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
    if (!(serializer instanceof SealedClassSerializer))
      return Unit_instance;
    if (jsonCachedSerialNames(actualSerializer.w5c()).s(classDiscriminator)) {
      var baseName = serializer.w5c().b5e();
      var actualName = actualSerializer.w5c().b5e();
      // Inline function 'kotlin.error' call
      var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation or fall back to array polymorphism';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function checkKind(kind) {
    if (kind instanceof ENUM) {
      // Inline function 'kotlin.error' call
      var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (kind instanceof PrimitiveKind) {
      // Inline function 'kotlin.error' call
      var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    if (kind instanceof PolymorphicKind) {
      // Inline function 'kotlin.error' call
      var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
  }
  function access$validateIfSealed$tPolymorphicKt(serializer, actualSerializer, classDiscriminator) {
    return validateIfSealed(serializer, actualSerializer, classDiscriminator);
  }
  function checkKind_0($this, descriptor, actualClass) {
    var kind = descriptor.r5e();
    var tmp;
    if (kind instanceof PolymorphicKind) {
      tmp = true;
    } else {
      tmp = equals(kind, CONTEXTUAL_getInstance());
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$_0('Serializer for ' + actualClass.lb() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind.toString() + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
    }
    if ($this.f6c_1)
      return Unit_instance;
    var tmp_0;
    var tmp_1;
    if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) {
      tmp_1 = true;
    } else {
      tmp_1 = kind instanceof PrimitiveKind;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = kind instanceof ENUM;
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$_0('Serializer for ' + actualClass.lb() + ' of kind ' + kind.toString() + ' cannot be serialized polymorphically with class discriminator.');
    }
  }
  function checkDiscriminatorCollisions($this, descriptor, actualClass) {
    var inductionVariable = 0;
    var last = descriptor.p5e();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var name = descriptor.v5e(i);
        if (name === $this.g6c_1) {
          throw IllegalArgumentException_init_$Create$_0('Polymorphic serializer for ' + toString_1(actualClass) + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation ' + 'or fall back to array polymorphism');
        }
      }
       while (inductionVariable < last);
  }
  function PolymorphismValidator(useArrayPolymorphism, discriminator) {
    this.f6c_1 = useArrayPolymorphism;
    this.g6c_1 = discriminator;
  }
  protoOf(PolymorphismValidator).l5x = function (kClass, provider) {
  };
  protoOf(PolymorphismValidator).o5x = function (baseClass, actualClass, actualSerializer) {
    var descriptor = actualSerializer.w5c();
    checkKind_0(this, descriptor, actualClass);
    if (!this.f6c_1) {
      checkDiscriminatorCollisions(this, descriptor, actualClass);
    }
  };
  protoOf(PolymorphismValidator).p5x = function (baseClass, defaultSerializerProvider) {
  };
  protoOf(PolymorphismValidator).q5x = function (baseClass, defaultDeserializerProvider) {
  };
  function Key_6() {
  }
  function DescriptorSchemaCache() {
    this.w69_1 = createMapForCache(16);
  }
  protoOf(DescriptorSchemaCache).h6c = function (descriptor, key, value) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.w69_1;
    var value_0 = this_0.y2(descriptor);
    var tmp;
    if (value_0 == null) {
      // Inline function 'kotlinx.serialization.json.internal.DescriptorSchemaCache.set.<anonymous>' call
      var answer = createMapForCache(2);
      this_0.r2(descriptor, answer);
      tmp = answer;
    } else {
      tmp = value_0;
    }
    var tmp2 = tmp;
    var tmp3 = key instanceof Key_6 ? key : THROW_CCE();
    // Inline function 'kotlin.collections.set' call
    var value_1 = !(value == null) ? value : THROW_CCE();
    tmp2.r2(tmp3, value_1);
  };
  protoOf(DescriptorSchemaCache).x69 = function (descriptor, key, defaultValue) {
    var tmp0_safe_receiver = this.i6c(descriptor, key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var value = defaultValue();
    this.h6c(descriptor, key, value);
    return value;
  };
  protoOf(DescriptorSchemaCache).i6c = function (descriptor, key) {
    var tmp0_safe_receiver = this.w69_1.y2(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.y2(key instanceof Key_6 ? key : THROW_CCE());
    }
    var tmp_0 = tmp;
    return !(tmp_0 == null) ? tmp_0 : null;
  };
  function DiscriminatorHolder(discriminatorToSkip) {
    this.j6c_1 = discriminatorToSkip;
  }
  function trySkip(_this__u8e3s4, $this, unknownKey) {
    if (_this__u8e3s4 == null)
      return false;
    if (_this__u8e3s4.j6c_1 === unknownKey) {
      _this__u8e3s4.j6c_1 = null;
      return true;
    }
    return false;
  }
  function skipLeftoverElements($this, descriptor) {
    while (!($this.z5g(descriptor) === -1)) {
    }
  }
  function checkLeadingComma($this) {
    if ($this.r65_1.v6a() === 4) {
      $this.r65_1.v69('Unexpected leading comma');
    }
  }
  function decodeMapIndex($this) {
    var hasComma = false;
    var decodingKey = !(($this.t65_1 % 2 | 0) === 0);
    if (decodingKey) {
      if (!($this.t65_1 === -1)) {
        hasComma = $this.r65_1.l6c();
      }
    } else {
      $this.r65_1.k6c(_Char___init__impl__6a9atx(58));
    }
    var tmp;
    if ($this.r65_1.w6a()) {
      if (decodingKey) {
        if ($this.t65_1 === -1) {
          var tmp0 = $this.r65_1;
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var condition = !hasComma;
          var position = tmp0.x65_1;
          if (!condition) {
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
            var tmp$ret$0 = 'Unexpected trailing comma';
            tmp0.v69(tmp$ret$0, position);
          }
        } else {
          var tmp3 = $this.r65_1;
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var condition_0 = hasComma;
          var position_0 = tmp3.x65_1;
          if (!condition_0) {
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
            var tmp$ret$1 = 'Expected comma after the key-value pair';
            tmp3.v69(tmp$ret$1, position_0);
          }
        }
      }
      $this.t65_1 = $this.t65_1 + 1 | 0;
      tmp = $this.t65_1;
    } else {
      if (hasComma) {
        $this.r65_1.v69("Expected '}', but had ',' instead");
      }
      tmp = -1;
    }
    return tmp;
  }
  function coerceInputValue($this, descriptor, index) {
    var tmp0 = $this.p65_1;
    var tmp1 = descriptor.t5e(index);
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var tmp;
      if (!tmp1.l5e()) {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        tmp = $this.r65_1.m6c(true);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = true;
        break $l$block_2;
      }
      if (equals(tmp1.r5e(), ENUM_getInstance())) {
        var tmp_0;
        if (tmp1.l5e()) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
          tmp_0 = $this.r65_1.m6c(false);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$1 = false;
          break $l$block_2;
        }
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        var tmp0_elvis_lhs = $this.r65_1.n6c($this.v65_1.t66_1);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = false;
          break $l$block_2;
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_1;
        var enumIndex = getJsonNameIndex(tmp1, tmp0, enumValue);
        if (enumIndex === -3) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
          $this.r65_1.x6a();
          tmp$ret$1 = true;
          break $l$block_2;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function decodeObjectIndex($this, descriptor) {
    var hasComma = $this.r65_1.l6c();
    while ($this.r65_1.w6a()) {
      hasComma = false;
      var key = decodeStringKey($this);
      $this.r65_1.k6c(_Char___init__impl__6a9atx(58));
      var index = getJsonNameIndex(descriptor, $this.p65_1, key);
      var tmp;
      if (!(index === -3)) {
        var tmp_0;
        if ($this.v65_1.y66_1 && coerceInputValue($this, descriptor, index)) {
          hasComma = $this.r65_1.l6c();
          tmp_0 = false;
        } else {
          var tmp0_safe_receiver = $this.w65_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.t69(index);
          }
          return index;
        }
        tmp = tmp_0;
      } else {
        tmp = true;
      }
      var isUnknown = tmp;
      if (isUnknown) {
        hasComma = handleUnknown($this, key);
      }
    }
    if (hasComma) {
      $this.r65_1.v69('Unexpected trailing comma');
    }
    var tmp1_safe_receiver = $this.w65_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u69();
    return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
  }
  function handleUnknown($this, key) {
    if ($this.v65_1.s66_1 || trySkip($this.u65_1, $this, key)) {
      $this.r65_1.p6c($this.v65_1.t66_1);
    } else {
      $this.r65_1.o6c(key);
    }
    return $this.r65_1.l6c();
  }
  function decodeListIndex($this) {
    var hasComma = $this.r65_1.l6c();
    var tmp;
    if ($this.r65_1.w6a()) {
      if (!($this.t65_1 === -1) && !hasComma) {
        $this.r65_1.v69('Expected end of the array or comma');
      }
      $this.t65_1 = $this.t65_1 + 1 | 0;
      tmp = $this.t65_1;
    } else {
      if (hasComma) {
        $this.r65_1.v69('Unexpected trailing comma');
      }
      tmp = -1;
    }
    return tmp;
  }
  function decodeStringKey($this) {
    var tmp;
    if ($this.v65_1.t66_1) {
      tmp = $this.r65_1.r6c();
    } else {
      tmp = $this.r65_1.q6c();
    }
    return tmp;
  }
  function StreamingJsonDecoder(json, mode, lexer, descriptor, discriminatorHolder) {
    AbstractDecoder.call(this);
    this.p65_1 = json;
    this.q65_1 = mode;
    this.r65_1 = lexer;
    this.s65_1 = this.p65_1.h5d();
    this.t65_1 = -1;
    this.u65_1 = discriminatorHolder;
    this.v65_1 = this.p65_1.j65_1;
    this.w65_1 = this.v65_1.w66_1 ? null : new JsonElementMarker(descriptor);
  }
  protoOf(StreamingJsonDecoder).e67 = function () {
    return this.p65_1;
  };
  protoOf(StreamingJsonDecoder).h5d = function () {
    return this.s65_1;
  };
  protoOf(StreamingJsonDecoder).f67 = function () {
    return (new JsonTreeReader(this.p65_1.j65_1, this.r65_1)).x64();
  };
  protoOf(StreamingJsonDecoder).l5d = function (deserializer) {
    try {
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.p65_1.j65_1.z66_1;
      }
      if (tmp) {
        return deserializer.k5d(this);
      }
      var discriminator = classDiscriminator(deserializer.w5c(), this.p65_1);
      var type = this.r65_1.s6c(discriminator, this.v65_1.t66_1);
      var actualSerializer = null;
      if (!(type == null)) {
        actualSerializer = deserializer.r5d(this, type);
      }
      if (actualSerializer == null) {
        return decodeSerializableValuePolymorphic(this, isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE());
      }
      this.u65_1 = new DiscriminatorHolder(discriminator);
      var tmp_0 = actualSerializer.k5d(this);
      var result = !(tmp_0 == null) ? tmp_0 : THROW_CCE();
      return result;
    } catch ($p) {
      if ($p instanceof MissingFieldException) {
        var e = $p;
        if (contains_9(ensureNotNull(e.message), 'at path'))
          throw e;
        throw new MissingFieldException(e.h5e_1, plus_10(e.message, ' at path: ') + this.r65_1.y65_1.i6a(), e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(StreamingJsonDecoder).j5g = function (descriptor) {
    var newMode = switchMode(this.p65_1, descriptor);
    this.r65_1.y65_1.d6a(descriptor);
    this.r65_1.k6c(newMode.v6c_1);
    checkLeadingComma(this);
    var tmp;
    switch (newMode.a3_1) {
      case 1:
      case 2:
      case 3:
        tmp = new StreamingJsonDecoder(this.p65_1, newMode, this.r65_1, descriptor, this.u65_1);
        break;
      default:
        var tmp_0;
        if (this.q65_1.equals(newMode) && this.p65_1.j65_1.w66_1) {
          tmp_0 = this;
        } else {
          tmp_0 = new StreamingJsonDecoder(this.p65_1, newMode, this.r65_1, descriptor, this.u65_1);
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).k5g = function (descriptor) {
    if (this.p65_1.j65_1.s66_1 && descriptor.p5e() === 0) {
      skipLeftoverElements(this, descriptor);
    }
    this.r65_1.k6c(this.q65_1.w6c_1);
    this.r65_1.y65_1.h6a();
  };
  protoOf(StreamingJsonDecoder).v5f = function () {
    var tmp;
    var tmp0_safe_receiver = this.w65_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s69_1;
    if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
      tmp = !this.r65_1.x6c();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).w5f = function () {
    return null;
  };
  protoOf(StreamingJsonDecoder).v5g = function (descriptor, index, deserializer, previousValue) {
    var isMapKey = this.q65_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
    if (isMapKey) {
      this.r65_1.y65_1.g6a();
    }
    var value = protoOf(AbstractDecoder).v5g.call(this, descriptor, index, deserializer, previousValue);
    if (isMapKey) {
      this.r65_1.y65_1.f6a(value);
    }
    return value;
  };
  protoOf(StreamingJsonDecoder).z5g = function (descriptor) {
    var index;
    switch (this.q65_1.a3_1) {
      case 0:
        index = decodeObjectIndex(this, descriptor);
        break;
      case 2:
        index = decodeMapIndex(this);
        break;
      default:
        index = decodeListIndex(this);
        break;
    }
    if (!this.q65_1.equals(WriteMode_MAP_getInstance())) {
      this.r65_1.y65_1.e6a(index);
    }
    return index;
  };
  protoOf(StreamingJsonDecoder).x5f = function () {
    var tmp;
    if (this.v65_1.t66_1) {
      tmp = this.r65_1.z6c();
    } else {
      tmp = this.r65_1.y6c();
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).y5f = function () {
    var value = this.r65_1.a6d();
    if (!value.equals(toLong(value.x3()))) {
      this.r65_1.v69("Failed to parse byte for input '" + value.toString() + "'");
    }
    return value.x3();
  };
  protoOf(StreamingJsonDecoder).z5f = function () {
    var value = this.r65_1.a6d();
    if (!value.equals(toLong(value.y3()))) {
      this.r65_1.v69("Failed to parse short for input '" + value.toString() + "'");
    }
    return value.y3();
  };
  protoOf(StreamingJsonDecoder).a5g = function () {
    var value = this.r65_1.a6d();
    if (!value.equals(toLong(value.z3()))) {
      this.r65_1.v69("Failed to parse int for input '" + value.toString() + "'");
    }
    return value.z3();
  };
  protoOf(StreamingJsonDecoder).b5g = function () {
    return this.r65_1.a6d();
  };
  protoOf(StreamingJsonDecoder).c5g = function () {
    var tmp0 = this.r65_1;
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.y6a();
      try {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeFloat.<anonymous>' call
        // Inline function 'kotlin.text.toFloat' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$4 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.v69("Failed to parse type '" + 'float' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.p65_1.j65_1.b67_1;
    if (specialFp || isFinite_0(result))
      return result;
    throwInvalidFloatingPointDecoded(this.r65_1, result);
  };
  protoOf(StreamingJsonDecoder).d5g = function () {
    var tmp0 = this.r65_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.y6a();
      try {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeDouble.<anonymous>' call
        tmp$ret$1 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.v69("Failed to parse type '" + 'double' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.p65_1.j65_1.b67_1;
    if (specialFp || isFinite(result))
      return result;
    throwInvalidFloatingPointDecoded(this.r65_1, result);
  };
  protoOf(StreamingJsonDecoder).e5g = function () {
    var string = this.r65_1.y6a();
    if (!(string.length === 1)) {
      this.r65_1.v69("Expected single char, but got '" + string + "'");
    }
    return charSequenceGet(string, 0);
  };
  protoOf(StreamingJsonDecoder).f5g = function () {
    var tmp;
    if (this.v65_1.t66_1) {
      tmp = this.r65_1.r6c();
    } else {
      tmp = this.r65_1.x6a();
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).h5g = function (descriptor) {
    return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.r65_1, this.p65_1) : protoOf(AbstractDecoder).h5g.call(this, descriptor);
  };
  protoOf(StreamingJsonDecoder).g5g = function (enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.p65_1, this.f5g(), ' at path ' + this.r65_1.y65_1.i6a());
  };
  function JsonDecoderForUnsignedTypes(lexer, json) {
    AbstractDecoder.call(this);
    this.b6d_1 = lexer;
    this.c6d_1 = json.h5d();
  }
  protoOf(JsonDecoderForUnsignedTypes).h5d = function () {
    return this.c6d_1;
  };
  protoOf(JsonDecoderForUnsignedTypes).z5g = function (descriptor) {
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(JsonDecoderForUnsignedTypes).a5g = function () {
    var tmp0 = this.b6d_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.y6a();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeInt.<anonymous>' call
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = toUInt(input);
        tmp$ret$2 = _UInt___get_data__impl__f0vqqw(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.v69("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).b5g = function () {
    var tmp0 = this.b6d_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.y6a();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeLong.<anonymous>' call
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = toULong(input);
        tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.v69("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).y5f = function () {
    var tmp0 = this.b6d_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.y6a();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeByte.<anonymous>' call
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = toUByte(input);
        tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.v69("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).z5f = function () {
    var tmp0 = this.b6d_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var input = tmp0.y6a();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeShort.<anonymous>' call
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = toUShort(input);
        tmp$ret$2 = _UShort___get_data__impl__g0245(this_0);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0.v69("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  function get_unsignedNumberDescriptors() {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return unsignedNumberDescriptors;
  }
  var unsignedNumberDescriptors;
  function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
    StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
    return $this;
  }
  function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
    return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
  }
  function encodeTypeInfo($this, descriptor) {
    $this.j6a_1.s68();
    $this.m5h(ensureNotNull($this.q6a_1));
    $this.j6a_1.u68(_Char___init__impl__6a9atx(58));
    $this.j6a_1.t68();
    $this.m5h(descriptor.b5e());
  }
  function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
    AbstractEncoder.call(this);
    this.j6a_1 = composer;
    this.k6a_1 = json;
    this.l6a_1 = mode;
    this.m6a_1 = modeReuseCache;
    this.n6a_1 = this.k6a_1.h5d();
    this.o6a_1 = this.k6a_1.j65_1;
    this.p6a_1 = false;
    this.q6a_1 = null;
    var i = this.l6a_1.a3_1;
    if (!(this.m6a_1 == null)) {
      if (!(this.m6a_1[i] === null) || !(this.m6a_1[i] === this)) {
        this.m6a_1[i] = this;
      }
    }
  }
  protoOf(StreamingJsonEncoder).e67 = function () {
    return this.k6a_1;
  };
  protoOf(StreamingJsonEncoder).h5d = function () {
    return this.n6a_1;
  };
  protoOf(StreamingJsonEncoder).e5i = function (descriptor, index) {
    return this.o6a_1.r66_1;
  };
  protoOf(StreamingJsonEncoder).i5d = function (serializer, value) {
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
      var tmp;
      if (!(serializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.e67().j65_1.z66_1;
      }
      if (tmp) {
        serializer.j5d(this, value);
        break $l$block;
      }
      var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
      var baseClassDiscriminator = classDiscriminator(serializer.w5c(), this.e67());
      var actualSerializer = findPolymorphicSerializer(casted, this, !(value == null) ? value : THROW_CCE());
      access$validateIfSealed$tPolymorphicKt(casted, actualSerializer, baseClassDiscriminator);
      checkKind(actualSerializer.w5c().r5e());
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeSerializableValue.<anonymous>' call
      this.q6a_1 = baseClassDiscriminator;
      actualSerializer.j5d(this, value);
    }
  };
  protoOf(StreamingJsonEncoder).j5g = function (descriptor) {
    var newMode = switchMode(this.k6a_1, descriptor);
    if (!(newMode.v6c_1 === _Char___init__impl__6a9atx(0))) {
      this.j6a_1.u68(newMode.v6c_1);
      this.j6a_1.b2u();
    }
    if (!(this.q6a_1 == null)) {
      encodeTypeInfo(this, descriptor);
      this.q6a_1 = null;
    }
    if (this.l6a_1.equals(newMode)) {
      return this;
    }
    var tmp0_safe_receiver = this.m6a_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[newMode.a3_1];
    return tmp1_elvis_lhs == null ? new StreamingJsonEncoder(this.j6a_1, this.k6a_1, newMode, this.m6a_1) : tmp1_elvis_lhs;
  };
  protoOf(StreamingJsonEncoder).k5g = function (descriptor) {
    if (!(this.l6a_1.w6c_1 === _Char___init__impl__6a9atx(0))) {
      this.j6a_1.r68();
      this.j6a_1.s68();
      this.j6a_1.u68(this.l6a_1.w6c_1);
    }
  };
  protoOf(StreamingJsonEncoder).b5h = function (descriptor, index) {
    switch (this.l6a_1.a3_1) {
      case 1:
        if (!this.j6a_1.q68_1) {
          this.j6a_1.u68(_Char___init__impl__6a9atx(44));
        }

        this.j6a_1.s68();
        break;
      case 2:
        if (!this.j6a_1.q68_1) {
          var tmp = this;
          var tmp_0;
          if ((index % 2 | 0) === 0) {
            this.j6a_1.u68(_Char___init__impl__6a9atx(44));
            this.j6a_1.s68();
            tmp_0 = true;
          } else {
            this.j6a_1.u68(_Char___init__impl__6a9atx(58));
            this.j6a_1.t68();
            tmp_0 = false;
          }
          tmp.p6a_1 = tmp_0;
        } else {
          this.p6a_1 = true;
          this.j6a_1.s68();
        }

        break;
      case 3:
        if (index === 0)
          this.p6a_1 = true;
        if (index === 1) {
          this.j6a_1.u68(_Char___init__impl__6a9atx(44));
          this.j6a_1.t68();
          this.p6a_1 = false;
        }

        break;
      default:
        if (!this.j6a_1.q68_1) {
          this.j6a_1.u68(_Char___init__impl__6a9atx(44));
        }

        this.j6a_1.s68();
        this.m5h(getJsonElementName(descriptor, this.k6a_1, index));
        this.j6a_1.u68(_Char___init__impl__6a9atx(58));
        this.j6a_1.t68();
        break;
    }
    return true;
  };
  protoOf(StreamingJsonEncoder).a5i = function (descriptor, index, serializer, value) {
    if (!(value == null) || this.o6a_1.w66_1) {
      protoOf(AbstractEncoder).a5i.call(this, descriptor, index, serializer, value);
    }
  };
  protoOf(StreamingJsonEncoder).o5h = function (descriptor) {
    var tmp;
    if (get_isUnsignedNumber(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_0;
      var tmp_1 = this.j6a_1;
      if (tmp_1 instanceof ComposerForUnsignedNumbers) {
        tmp_0 = this.j6a_1;
      } else {
        var tmp1 = this.j6a_1.p68_1;
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeInline.stub_for_inlining' call
        var p1 = this.p6a_1;
        tmp_0 = new ComposerForUnsignedNumbers(tmp1, p1);
      }
      var tmp$ret$1 = tmp_0;
      tmp = new StreamingJsonEncoder(tmp$ret$1, this.k6a_1, this.l6a_1, null);
    } else if (get_isUnquotedLiteral(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_2;
      var tmp_3 = this.j6a_1;
      if (tmp_3 instanceof ComposerForUnquotedLiterals) {
        tmp_2 = this.j6a_1;
      } else {
        var tmp4 = this.j6a_1.p68_1;
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeInline.stub_for_inlining' call
        var p1_0 = this.p6a_1;
        tmp_2 = new ComposerForUnquotedLiterals(tmp4, p1_0);
      }
      var tmp$ret$3 = tmp_2;
      tmp = new StreamingJsonEncoder(tmp$ret$3, this.k6a_1, this.l6a_1, null);
    } else {
      tmp = protoOf(AbstractEncoder).o5h.call(this, descriptor);
    }
    return tmp;
  };
  protoOf(StreamingJsonEncoder).d5h = function () {
    this.j6a_1.w68('null');
  };
  protoOf(StreamingJsonEncoder).e5h = function (value) {
    if (this.p6a_1) {
      this.m5h(value.toString());
    } else {
      this.j6a_1.e69(value);
    }
  };
  protoOf(StreamingJsonEncoder).f5h = function (value) {
    if (this.p6a_1) {
      this.m5h(value.toString());
    } else {
      this.j6a_1.a69(value);
    }
  };
  protoOf(StreamingJsonEncoder).g5h = function (value) {
    if (this.p6a_1) {
      this.m5h(value.toString());
    } else {
      this.j6a_1.b69(value);
    }
  };
  protoOf(StreamingJsonEncoder).h5h = function (value) {
    if (this.p6a_1) {
      this.m5h(value.toString());
    } else {
      this.j6a_1.c69(value);
    }
  };
  protoOf(StreamingJsonEncoder).i5h = function (value) {
    if (this.p6a_1) {
      this.m5h(value.toString());
    } else {
      this.j6a_1.d69(value);
    }
  };
  protoOf(StreamingJsonEncoder).j5h = function (value) {
    if (this.p6a_1) {
      this.m5h(value.toString());
    } else {
      this.j6a_1.y68(value);
    }
    if (!this.o6a_1.b67_1 && !isFinite_0(value)) {
      throw InvalidFloatingPointEncoded_0(value, toString_1(this.j6a_1.p68_1));
    }
  };
  protoOf(StreamingJsonEncoder).k5h = function (value) {
    if (this.p6a_1) {
      this.m5h(value.toString());
    } else {
      this.j6a_1.z68(value);
    }
    if (!this.o6a_1.b67_1 && !isFinite(value)) {
      throw InvalidFloatingPointEncoded_0(value, toString_1(this.j6a_1.p68_1));
    }
  };
  protoOf(StreamingJsonEncoder).l5h = function (value) {
    this.m5h(toString(value));
  };
  protoOf(StreamingJsonEncoder).m5h = function (value) {
    return this.j6a_1.f69(value);
  };
  protoOf(StreamingJsonEncoder).n5h = function (enumDescriptor, index) {
    this.m5h(enumDescriptor.v5e(index));
  };
  function get_isUnsignedNumber(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.q5e() && get_unsignedNumberDescriptors().s(_this__u8e3s4);
  }
  function get_isUnquotedLiteral(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.q5e() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
  }
  var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
  function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
    if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
      properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
      unsignedNumberDescriptors = setOf_0([serializer_10(Companion_getInstance_19()).w5c(), serializer_8(Companion_getInstance_20()).w5c(), serializer_14(Companion_getInstance_18()).w5c(), serializer_12(Companion_getInstance_21()).w5c()]);
    }
  }
  function get_ESCAPE_STRINGS() {
    _init_properties_StringOps_kt__fcy1db();
    return ESCAPE_STRINGS;
  }
  var ESCAPE_STRINGS;
  var ESCAPE_MARKERS;
  function toHexChar(i) {
    _init_properties_StringOps_kt__fcy1db();
    var d = i & 15;
    var tmp;
    if (d < 10) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      tmp = numberToChar(d + tmp$ret$0 | 0);
    } else {
      var tmp_0 = d - 10 | 0;
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
    }
    return tmp;
  }
  function printQuoted(_this__u8e3s4, value) {
    _init_properties_StringOps_kt__fcy1db();
    _this__u8e3s4.e9(_Char___init__impl__6a9atx(34));
    var lastPos = 0;
    var inductionVariable = 0;
    var last = charSequenceLength(value) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charSequenceGet(value, i);
        var c = Char__toInt_impl_vasixd(this_0);
        if (c < get_ESCAPE_STRINGS().length && !(get_ESCAPE_STRINGS()[c] == null)) {
          _this__u8e3s4.yc(value, lastPos, i);
          _this__u8e3s4.d9(get_ESCAPE_STRINGS()[c]);
          lastPos = i + 1 | 0;
        }
      }
       while (inductionVariable <= last);
    if (!(lastPos === 0)) {
      _this__u8e3s4.yc(value, lastPos, value.length);
    } else {
      _this__u8e3s4.d9(value);
    }
    _this__u8e3s4.e9(_Char___init__impl__6a9atx(34));
  }
  function toBooleanStrictOrNull(_this__u8e3s4) {
    _init_properties_StringOps_kt__fcy1db();
    return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
  }
  var properties_initialized_StringOps_kt_wzaea7;
  function _init_properties_StringOps_kt__fcy1db() {
    if (!properties_initialized_StringOps_kt_wzaea7) {
      properties_initialized_StringOps_kt_wzaea7 = true;
      // Inline function 'kotlin.arrayOfNulls' call
      // Inline function 'kotlin.apply' call
      var this_0 = fillArrayVal(Array(93), null);
      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_STRINGS.<anonymous>' call
      var inductionVariable = 0;
      if (inductionVariable <= 31)
        do {
          var c = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var c1 = toHexChar(c >> 12);
          var c2 = toHexChar(c >> 8);
          var c3 = toHexChar(c >> 4);
          var c4 = toHexChar(c);
          this_0[c] = '\\u' + toString(c1) + toString(c2) + toString(c3) + toString(c4);
        }
         while (inductionVariable <= 31);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(34);
      this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(92);
      this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(9);
      this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(8);
      this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(10);
      this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
      // Inline function 'kotlin.code' call
      var this_6 = _Char___init__impl__6a9atx(13);
      this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
      this_0[12] = '\\f';
      ESCAPE_STRINGS = this_0;
      // Inline function 'kotlin.apply' call
      var this_7 = new Int8Array(93);
      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_MARKERS.<anonymous>' call
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= 31)
        do {
          var c_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_7[c_0] = 1;
        }
         while (inductionVariable_0 <= 31);
      // Inline function 'kotlin.code' call
      var this_8 = _Char___init__impl__6a9atx(34);
      var tmp = Char__toInt_impl_vasixd(this_8);
      // Inline function 'kotlin.code' call
      var this_9 = _Char___init__impl__6a9atx(34);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_9);
      this_7[tmp] = toByte(tmp$ret$1);
      // Inline function 'kotlin.code' call
      var this_10 = _Char___init__impl__6a9atx(92);
      var tmp_0 = Char__toInt_impl_vasixd(this_10);
      // Inline function 'kotlin.code' call
      var this_11 = _Char___init__impl__6a9atx(92);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_11);
      this_7[tmp_0] = toByte(tmp$ret$3);
      // Inline function 'kotlin.code' call
      var this_12 = _Char___init__impl__6a9atx(9);
      var tmp_1 = Char__toInt_impl_vasixd(this_12);
      // Inline function 'kotlin.code' call
      var this_13 = _Char___init__impl__6a9atx(116);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_13);
      this_7[tmp_1] = toByte(tmp$ret$5);
      // Inline function 'kotlin.code' call
      var this_14 = _Char___init__impl__6a9atx(8);
      var tmp_2 = Char__toInt_impl_vasixd(this_14);
      // Inline function 'kotlin.code' call
      var this_15 = _Char___init__impl__6a9atx(98);
      var tmp$ret$7 = Char__toInt_impl_vasixd(this_15);
      this_7[tmp_2] = toByte(tmp$ret$7);
      // Inline function 'kotlin.code' call
      var this_16 = _Char___init__impl__6a9atx(10);
      var tmp_3 = Char__toInt_impl_vasixd(this_16);
      // Inline function 'kotlin.code' call
      var this_17 = _Char___init__impl__6a9atx(110);
      var tmp$ret$9 = Char__toInt_impl_vasixd(this_17);
      this_7[tmp_3] = toByte(tmp$ret$9);
      // Inline function 'kotlin.code' call
      var this_18 = _Char___init__impl__6a9atx(13);
      var tmp_4 = Char__toInt_impl_vasixd(this_18);
      // Inline function 'kotlin.code' call
      var this_19 = _Char___init__impl__6a9atx(114);
      var tmp$ret$11 = Char__toInt_impl_vasixd(this_19);
      this_7[tmp_4] = toByte(tmp$ret$11);
      // Inline function 'kotlin.code' call
      var this_20 = _Char___init__impl__6a9atx(102);
      var tmp$ret$12 = Char__toInt_impl_vasixd(this_20);
      this_7[12] = toByte(tmp$ret$12);
      ESCAPE_MARKERS = this_7;
    }
  }
  function readJson(_this__u8e3s4, element, deserializer) {
    var tmp;
    if (element instanceof JsonObject_0) {
      tmp = new JsonTreeDecoder(_this__u8e3s4, element);
    } else {
      if (element instanceof JsonArray_0) {
        tmp = new JsonTreeListDecoder(_this__u8e3s4, element);
      } else {
        var tmp_0;
        if (element instanceof JsonLiteral) {
          tmp_0 = true;
        } else {
          tmp_0 = equals(element, JsonNull_getInstance());
        }
        if (tmp_0) {
          tmp = new JsonPrimitiveDecoder(_this__u8e3s4, element instanceof JsonPrimitive ? element : THROW_CCE());
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    var input = tmp;
    return input.l5d(deserializer);
  }
  function currentObject($this) {
    var tmp0_safe_receiver = $this.j5u();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.currentObject.<anonymous>' call
      tmp = $this.i6d(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? $this.y() : tmp1_elvis_lhs;
  }
  function unparsedPrimitive($this, primitive) {
    throw JsonDecodingException_0(-1, "Failed to parse '" + primitive + "'", toString_1(currentObject($this)));
  }
  function asLiteral(_this__u8e3s4, $this, type) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonLiteral ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw JsonDecodingException_1(-1, "Unexpected 'null' when " + type + ' was expected');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function AbstractJsonTreeDecoder(json, value) {
    NamedValueDecoder.call(this);
    this.f6d_1 = json;
    this.g6d_1 = value;
    this.h6d_1 = this.e67().j65_1;
  }
  protoOf(AbstractJsonTreeDecoder).e67 = function () {
    return this.f6d_1;
  };
  protoOf(AbstractJsonTreeDecoder).y = function () {
    return this.g6d_1;
  };
  protoOf(AbstractJsonTreeDecoder).h5d = function () {
    return this.e67().h5d();
  };
  protoOf(AbstractJsonTreeDecoder).f67 = function () {
    return currentObject(this);
  };
  protoOf(AbstractJsonTreeDecoder).l5d = function (deserializer) {
    return decodeSerializableValuePolymorphic(this, deserializer);
  };
  protoOf(AbstractJsonTreeDecoder).k5u = function (parentName, childName) {
    return childName;
  };
  protoOf(AbstractJsonTreeDecoder).j5g = function (descriptor) {
    var currentObject_0 = currentObject(this);
    var tmp0_subject = descriptor.r5e();
    var tmp;
    var tmp_0;
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_0) {
      var tmp_1 = this.e67();
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      if (!(currentObject_0 instanceof JsonArray_0)) {
        throw JsonDecodingException_1(-1, 'Expected ' + toString_1(getKClass(JsonArray_0)) + ' as the serialized body of ' + descriptor.b5e() + ', but had ' + toString_1(getKClassFromExpression(currentObject_0)));
      }
      tmp = new JsonTreeListDecoder(tmp_1, currentObject_0);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var this_0 = this.e67();
        var keyDescriptor = carrierDescriptor(descriptor.t5e(0), this_0.h5d());
        var keyKind = keyDescriptor.r5e();
        var tmp_2;
        var tmp_3;
        if (keyKind instanceof PrimitiveKind) {
          tmp_3 = true;
        } else {
          tmp_3 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_3) {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
          var tmp_4 = this.e67();
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          if (!(currentObject_0 instanceof JsonObject_0)) {
            throw JsonDecodingException_1(-1, 'Expected ' + toString_1(getKClass(JsonObject_0)) + ' as the serialized body of ' + descriptor.b5e() + ', but had ' + toString_1(getKClassFromExpression(currentObject_0)));
          }
          tmp_2 = new JsonTreeMapDecoder(tmp_4, currentObject_0);
        } else {
          if (this_0.j65_1.u66_1) {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
            var tmp_5 = this.e67();
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            if (!(currentObject_0 instanceof JsonArray_0)) {
              throw JsonDecodingException_1(-1, 'Expected ' + toString_1(getKClass(JsonArray_0)) + ' as the serialized body of ' + descriptor.b5e() + ', but had ' + toString_1(getKClassFromExpression(currentObject_0)));
            }
            tmp_2 = new JsonTreeListDecoder(tmp_5, currentObject_0);
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_2;
      } else {
        var tmp_6 = this.e67();
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        if (!(currentObject_0 instanceof JsonObject_0)) {
          throw JsonDecodingException_1(-1, 'Expected ' + toString_1(getKClass(JsonObject_0)) + ' as the serialized body of ' + descriptor.b5e() + ', but had ' + toString_1(getKClassFromExpression(currentObject_0)));
        }
        tmp = new JsonTreeDecoder(tmp_6, currentObject_0);
      }
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).k5g = function (descriptor) {
  };
  protoOf(AbstractJsonTreeDecoder).v5f = function () {
    var tmp = currentObject(this);
    return !(tmp instanceof JsonNull_0);
  };
  protoOf(AbstractJsonTreeDecoder).j6d = function (tag) {
    var currentElement = this.i6d(tag);
    var tmp0_elvis_lhs = currentElement instanceof JsonPrimitive ? currentElement : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw JsonDecodingException_0(-1, 'Expected JsonPrimitive at ' + tag + ', found ' + toString_1(currentElement), toString_1(currentObject(this)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).k6d = function (tag, enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.e67(), this.j6d(tag).g67());
  };
  protoOf(AbstractJsonTreeDecoder).s5v = function (tag, enumDescriptor) {
    return this.k6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).l6d = function (tag) {
    return !(this.i6d(tag) === JsonNull_getInstance());
  };
  protoOf(AbstractJsonTreeDecoder).i5v = function (tag) {
    return this.l6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).m6d = function (tag) {
    var value = this.j6d(tag);
    if (!this.e67().j65_1.t66_1) {
      var literal = asLiteral(value, this, 'boolean');
      if (literal.m67_1)
        throw JsonDecodingException_0(-1, "Boolean literal for key '" + tag + "' should be unquoted.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", toString_1(currentObject(this)));
    }
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedBoolean.<anonymous>' call
        var tmp0_elvis_lhs = get_booleanOrNull(value);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalArgumentException_init_$Create$();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp0_elvis_lhs_0 = tmp;
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          unparsedPrimitive(this, 'boolean');
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        tmp$ret$1 = tmp_0;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'boolean');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).j5v = function (tag) {
    return this.m6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).n6d = function (tag) {
    var tmp1 = this.j6d(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedByte.<anonymous>' call
        var result = get_int(tmp1);
        var tmp0_elvis_lhs = (-128 <= result ? result <= 127 : false) ? toByte(result) : null;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'byte');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'byte');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).k5v = function (tag) {
    return this.n6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).o6d = function (tag) {
    var tmp1 = this.j6d(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedShort.<anonymous>' call
        var result = get_int(tmp1);
        var tmp0_elvis_lhs = (-32768 <= result ? result <= 32767 : false) ? toShort(result) : null;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'short');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'short');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).l5v = function (tag) {
    return this.o6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).p6d = function (tag) {
    var tmp1 = this.j6d(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedInt.<anonymous>' call
        var tmp0_elvis_lhs = get_int(tmp1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'int');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'int');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).m5v = function (tag) {
    return this.p6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).q6d = function (tag) {
    var tmp1 = this.j6d(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedLong.<anonymous>' call
        var tmp0_elvis_lhs = get_long(tmp1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'long');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'long');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).n5v = function (tag) {
    return this.q6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).r6d = function (tag) {
    var tmp1 = this.j6d(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedFloat.<anonymous>' call
        var tmp0_elvis_lhs = get_float(tmp1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'float');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'float');
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.e67().j65_1.b67_1;
    if (specialFp || isFinite_0(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString_1(currentObject(this)));
  };
  protoOf(AbstractJsonTreeDecoder).o5v = function (tag) {
    return this.r6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).s6d = function (tag) {
    var tmp1 = this.j6d(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedDouble.<anonymous>' call
        var tmp0_elvis_lhs = get_double(tmp1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'double');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'double');
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.e67().j65_1.b67_1;
    if (specialFp || isFinite(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString_1(currentObject(this)));
  };
  protoOf(AbstractJsonTreeDecoder).p5v = function (tag) {
    return this.s6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).t6d = function (tag) {
    var tmp1 = this.j6d(tag);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedChar.<anonymous>' call
        var tmp0_elvis_lhs = new Char(single_2(tmp1.g67()));
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'char');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp.v1_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'char');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).q5v = function (tag) {
    return this.t6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).u6d = function (tag) {
    var value = this.j6d(tag);
    if (!this.e67().j65_1.t66_1) {
      var literal = asLiteral(value, this, 'string');
      if (!literal.m67_1)
        throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted.\nUse 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.", toString_1(currentObject(this)));
    }
    if (value instanceof JsonNull_0)
      throw JsonDecodingException_0(-1, "Unexpected 'null' value instead of string literal", toString_1(currentObject(this)));
    return value.g67();
  };
  protoOf(AbstractJsonTreeDecoder).r5v = function (tag) {
    return this.u6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).v6d = function (tag, inlineDescriptor) {
    return get_isUnsignedNumber(inlineDescriptor) ? new JsonDecoderForUnsignedTypes(new StringJsonLexer_0(this.j6d(tag).g67()), this.e67()) : protoOf(NamedValueDecoder).t5v.call(this, tag, inlineDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).t5v = function (tag, inlineDescriptor) {
    return this.v6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).h5g = function (descriptor) {
    return !(this.j5u() == null) ? protoOf(NamedValueDecoder).h5g.call(this, descriptor) : (new JsonPrimitiveDecoder(this.e67(), this.y())).h5g(descriptor);
  };
  function coerceInputValue_0($this, descriptor, index, tag) {
    var tmp0 = $this.e67();
    var tmp1 = descriptor.t5e(index);
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var tmp;
      if (!tmp1.l5e()) {
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
        var tmp_0 = $this.i6d(tag);
        tmp = tmp_0 instanceof JsonNull_0;
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = true;
        break $l$block_2;
      }
      if (equals(tmp1.r5e(), ENUM_getInstance())) {
        var tmp_1;
        if (tmp1.l5e()) {
          // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
          var tmp_2 = $this.i6d(tag);
          tmp_1 = tmp_2 instanceof JsonNull_0;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$1 = false;
          break $l$block_2;
        }
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
        var tmp_3 = $this.i6d(tag);
        var tmp0_safe_receiver = tmp_3 instanceof JsonPrimitive ? tmp_3 : null;
        var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
        var tmp_4;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = false;
          break $l$block_2;
        } else {
          tmp_4 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_4;
        var enumIndex = getJsonNameIndex(tmp1, tmp0, enumValue);
        if (enumIndex === -3) {
          // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue.<anonymous>' call
          tmp$ret$1 = true;
          break $l$block_2;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function absenceIsNull($this, descriptor, index) {
    $this.f6e_1 = (!$this.e67().j65_1.w66_1 && !descriptor.w5e(index) && descriptor.t5e(index).l5e());
    return $this.f6e_1;
  }
  function JsonTreeDecoder(json, value, polyDiscriminator, polyDescriptor) {
    polyDiscriminator = polyDiscriminator === VOID ? null : polyDiscriminator;
    polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
    AbstractJsonTreeDecoder.call(this, json, value);
    this.b6e_1 = value;
    this.c6e_1 = polyDiscriminator;
    this.d6e_1 = polyDescriptor;
    this.e6e_1 = 0;
    this.f6e_1 = false;
  }
  protoOf(JsonTreeDecoder).y = function () {
    return this.b6e_1;
  };
  protoOf(JsonTreeDecoder).z5g = function (descriptor) {
    while (this.e6e_1 < descriptor.p5e()) {
      var tmp1 = this.e6e_1;
      this.e6e_1 = tmp1 + 1 | 0;
      var name = this.f5u(descriptor, tmp1);
      var index = this.e6e_1 - 1 | 0;
      this.f6e_1 = false;
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = this.y();
      if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w2(name)) {
        tmp_0 = true;
      } else {
        tmp_0 = absenceIsNull(this, descriptor, index);
      }
      if (tmp_0) {
        tmp = !this.h6d_1.y66_1 || !coerceInputValue_0(this, descriptor, index, name);
      } else {
        tmp = false;
      }
      if (tmp) {
        return index;
      }
    }
    return -1;
  };
  protoOf(JsonTreeDecoder).v5f = function () {
    return !this.f6e_1 && protoOf(AbstractJsonTreeDecoder).v5f.call(this);
  };
  protoOf(JsonTreeDecoder).g5u = function (descriptor, index) {
    var strategy = namingStrategy(descriptor, this.e67());
    var baseName = descriptor.v5e(index);
    if (strategy == null) {
      if (!this.h6d_1.c67_1)
        return baseName;
      if (this.y().u2().s(baseName))
        return baseName;
    }
    var deserializationNamesMap_0 = deserializationNamesMap(this.e67(), descriptor);
    // Inline function 'kotlin.collections.find' call
    var tmp0 = this.y().u2();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.elementName.<anonymous>' call
        if (deserializationNamesMap_0.y2(element) === index) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var fallbackName = strategy == null ? null : strategy.z69(descriptor, index, baseName);
    return fallbackName == null ? baseName : fallbackName;
  };
  protoOf(JsonTreeDecoder).i6d = function (tag) {
    return getValue_0(this.y(), tag);
  };
  protoOf(JsonTreeDecoder).j5g = function (descriptor) {
    if (descriptor === this.d6e_1)
      return this;
    return protoOf(AbstractJsonTreeDecoder).j5g.call(this, descriptor);
  };
  protoOf(JsonTreeDecoder).k5g = function (descriptor) {
    var tmp;
    if (this.h6d_1.s66_1) {
      tmp = true;
    } else {
      var tmp_0 = descriptor.r5e();
      tmp = tmp_0 instanceof PolymorphicKind;
    }
    if (tmp)
      return Unit_instance;
    var strategy = namingStrategy(descriptor, this.e67());
    var tmp_1;
    if (strategy == null && !this.h6d_1.c67_1) {
      tmp_1 = jsonCachedSerialNames(descriptor);
    } else if (!(strategy == null)) {
      tmp_1 = deserializationNamesMap(this.e67(), descriptor).u2();
    } else {
      var tmp_2 = jsonCachedSerialNames(descriptor);
      var tmp0_safe_receiver = get_schemaCache(this.e67()).i6c(descriptor, get_JsonDeserializationNamesKey());
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u2();
      var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
      tmp_1 = plus_8(tmp_2, tmp$ret$0);
    }
    var names = tmp_1;
    var tmp1_iterator = this.y().u2().k();
    while (tmp1_iterator.l()) {
      var key = tmp1_iterator.m();
      if (!names.s(key) && !(key === this.c6e_1)) {
        throw UnknownKeyException(key, this.y().toString());
      }
    }
  };
  function JsonTreeListDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this.l6e_1 = value;
    this.m6e_1 = this.l6e_1.n();
    this.n6e_1 = -1;
  }
  protoOf(JsonTreeListDecoder).y = function () {
    return this.l6e_1;
  };
  protoOf(JsonTreeListDecoder).g5u = function (descriptor, index) {
    return index.toString();
  };
  protoOf(JsonTreeListDecoder).i6d = function (tag) {
    return this.l6e_1.q(toInt(tag));
  };
  protoOf(JsonTreeListDecoder).z5g = function (descriptor) {
    while (this.n6e_1 < (this.m6e_1 - 1 | 0)) {
      this.n6e_1 = this.n6e_1 + 1 | 0;
      return this.n6e_1;
    }
    return -1;
  };
  function JsonPrimitiveDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this.t6e_1 = value;
    this.b5v('primitive');
  }
  protoOf(JsonPrimitiveDecoder).y = function () {
    return this.t6e_1;
  };
  protoOf(JsonPrimitiveDecoder).z5g = function (descriptor) {
    return 0;
  };
  protoOf(JsonPrimitiveDecoder).i6d = function (tag) {
    // Inline function 'kotlin.require' call
    if (!(tag === 'primitive')) {
      // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveDecoder.currentElement.<anonymous>' call
      var message = "This input can only handle primitives with 'primitive' tag";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return this.t6e_1;
  };
  function JsonTreeMapDecoder(json, value) {
    JsonTreeDecoder.call(this, json, value);
    this.e6f_1 = value;
    this.f6f_1 = toList_0(this.e6f_1.u2());
    this.g6f_1 = imul(this.f6f_1.n(), 2);
    this.h6f_1 = -1;
  }
  protoOf(JsonTreeMapDecoder).y = function () {
    return this.e6f_1;
  };
  protoOf(JsonTreeMapDecoder).g5u = function (descriptor, index) {
    var i = index / 2 | 0;
    return this.f6f_1.q(i);
  };
  protoOf(JsonTreeMapDecoder).z5g = function (descriptor) {
    while (this.h6f_1 < (this.g6f_1 - 1 | 0)) {
      this.h6f_1 = this.h6f_1 + 1 | 0;
      return this.h6f_1;
    }
    return -1;
  };
  protoOf(JsonTreeMapDecoder).i6d = function (tag) {
    return (this.h6f_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue_0(this.e6f_1, tag);
  };
  protoOf(JsonTreeMapDecoder).k5g = function (descriptor) {
  };
  function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
    return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.w5c())).l5d(deserializer);
  }
  function writeJson(_this__u8e3s4, value, serializer) {
    var result = {_v: null};
    var encoder = new JsonTreeEncoder(_this__u8e3s4, writeJson$lambda(result));
    encoder.i5d(serializer, value);
    var tmp;
    if (result._v == null) {
      throwUninitializedPropertyAccessException('result');
    } else {
      tmp = result._v;
    }
    return tmp;
  }
  function JsonTreeEncoder(json, nodeConsumer) {
    AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
    var tmp = this;
    // Inline function 'kotlin.collections.linkedMapOf' call
    tmp.s6f_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(JsonTreeEncoder).t6f = function (key, element) {
    // Inline function 'kotlin.collections.set' call
    this.s6f_1.r2(key, element);
  };
  protoOf(JsonTreeEncoder).a5i = function (descriptor, index, serializer, value) {
    if (!(value == null) || this.l6f_1.w66_1) {
      protoOf(AbstractJsonTreeEncoder).a5i.call(this, descriptor, index, serializer, value);
    }
  };
  protoOf(JsonTreeEncoder).u6f = function () {
    return new JsonObject_0(this.s6f_1);
  };
  function inlineUnsignedNumberEncoder($this, tag) {
    return new AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1($this, tag);
  }
  function inlineUnquotedLiteralEncoder($this, tag, inlineDescriptor) {
    return new AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1($this, tag, inlineDescriptor);
  }
  function AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1(this$0, $tag) {
    this.j6g_1 = this$0;
    this.k6g_1 = $tag;
    AbstractEncoder.call(this);
    this.i6g_1 = this$0.j6f_1.h5d();
  }
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).h5d = function () {
    return this.i6g_1;
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).l6g = function (s) {
    return this.j6g_1.t6f(this.k6g_1, new JsonLiteral(s, false));
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).h5h = function (value) {
    // Inline function 'kotlin.toUInt' call
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(value);
    return this.l6g(UInt__toString_impl_dbgl21(tmp$ret$0));
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).i5h = function (value) {
    // Inline function 'kotlin.toULong' call
    var tmp$ret$0 = _ULong___init__impl__c78o9k(value);
    return this.l6g(ULong__toString_impl_f9au7k(tmp$ret$0));
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).f5h = function (value) {
    // Inline function 'kotlin.toUByte' call
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(value);
    return this.l6g(UByte__toString_impl_v72jg(tmp$ret$0));
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1).g5h = function (value) {
    // Inline function 'kotlin.toUShort' call
    var tmp$ret$0 = _UShort___init__impl__jigrne(value);
    return this.l6g(UShort__toString_impl_edaoee(tmp$ret$0));
  };
  function AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1(this$0, $tag, $inlineDescriptor) {
    this.m6g_1 = this$0;
    this.n6g_1 = $tag;
    this.o6g_1 = $inlineDescriptor;
    AbstractEncoder.call(this);
  }
  protoOf(AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1).h5d = function () {
    return this.m6g_1.j6f_1.h5d();
  };
  protoOf(AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1).m5h = function (value) {
    return this.m6g_1.t6f(this.n6g_1, new JsonLiteral(value, false, this.o6g_1));
  };
  function AbstractJsonTreeEncoder$beginStructure$lambda(this$0) {
    return function (node) {
      this$0.t6f(this$0.a5v(), node);
      return Unit_instance;
    };
  }
  function AbstractJsonTreeEncoder(json, nodeConsumer) {
    NamedValueEncoder.call(this);
    this.j6f_1 = json;
    this.k6f_1 = nodeConsumer;
    this.l6f_1 = this.j6f_1.j65_1;
    this.m6f_1 = null;
  }
  protoOf(AbstractJsonTreeEncoder).e67 = function () {
    return this.j6f_1;
  };
  protoOf(AbstractJsonTreeEncoder).h5d = function () {
    return this.j6f_1.h5d();
  };
  protoOf(AbstractJsonTreeEncoder).g5u = function (descriptor, index) {
    return getJsonElementName(descriptor, this.j6f_1, index);
  };
  protoOf(AbstractJsonTreeEncoder).e5i = function (descriptor, index) {
    return this.l6f_1.r66_1;
  };
  protoOf(AbstractJsonTreeEncoder).k5u = function (parentName, childName) {
    return childName;
  };
  protoOf(AbstractJsonTreeEncoder).c5i = function () {
  };
  protoOf(AbstractJsonTreeEncoder).d5h = function () {
    var tmp0_elvis_lhs = this.j5u();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this.k6f_1(JsonNull_getInstance());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tag = tmp;
    this.v6f(tag);
  };
  protoOf(AbstractJsonTreeEncoder).v6f = function (tag) {
    return this.t6f(tag, JsonNull_getInstance());
  };
  protoOf(AbstractJsonTreeEncoder).n5u = function (tag) {
    return this.v6f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeEncoder).w6f = function (tag, value) {
    return this.t6f(tag, JsonPrimitive_1(value));
  };
  protoOf(AbstractJsonTreeEncoder).o5u = function (tag, value) {
    return this.w6f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).x6f = function (tag, value) {
    return this.t6f(tag, JsonPrimitive_1(value));
  };
  protoOf(AbstractJsonTreeEncoder).p5u = function (tag, value) {
    return this.x6f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).y6f = function (tag, value) {
    return this.t6f(tag, JsonPrimitive_1(value));
  };
  protoOf(AbstractJsonTreeEncoder).q5u = function (tag, value) {
    return this.y6f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).z6f = function (tag, value) {
    return this.t6f(tag, JsonPrimitive_1(value));
  };
  protoOf(AbstractJsonTreeEncoder).r5u = function (tag, value) {
    return this.z6f((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).a6g = function (tag, value) {
    this.t6f(tag, JsonPrimitive_1(value));
    if (!this.l6f_1.b67_1 && !isFinite_0(value)) {
      throw InvalidFloatingPointEncoded(value, tag, toString_1(this.u6f()));
    }
  };
  protoOf(AbstractJsonTreeEncoder).s5u = function (tag, value) {
    return this.a6g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).i5d = function (serializer, value) {
    if (!(this.j5u() == null) || !get_requiresTopLevelTag(carrierDescriptor(serializer.w5c(), this.h5d()))) {
      $l$block: {
        // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
        var tmp;
        if (!(serializer instanceof AbstractPolymorphicSerializer)) {
          tmp = true;
        } else {
          tmp = this.e67().j65_1.z66_1;
        }
        if (tmp) {
          serializer.j5d(this, value);
          break $l$block;
        }
        var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
        var baseClassDiscriminator = classDiscriminator(serializer.w5c(), this.e67());
        var actualSerializer = findPolymorphicSerializer(casted, this, !(value == null) ? value : THROW_CCE());
        access$validateIfSealed$tPolymorphicKt(casted, actualSerializer, baseClassDiscriminator);
        checkKind(actualSerializer.w5c().r5e());
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeEncoder.encodeSerializableValue.<anonymous>' call
        this.m6f_1 = baseClassDiscriminator;
        actualSerializer.j5d(this, value);
      }
    } else {
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeEncoder.encodeSerializableValue.<anonymous>' call
      (new JsonPrimitiveEncoder(this.j6f_1, this.k6f_1)).i5d(serializer, value);
    }
  };
  protoOf(AbstractJsonTreeEncoder).b6g = function (tag, value) {
    this.t6f(tag, JsonPrimitive_1(value));
    if (!this.l6f_1.b67_1 && !isFinite(value)) {
      throw InvalidFloatingPointEncoded(value, tag, toString_1(this.u6f()));
    }
  };
  protoOf(AbstractJsonTreeEncoder).t5u = function (tag, value) {
    return this.b6g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).c6g = function (tag, value) {
    return this.t6f(tag, JsonPrimitive_2(value));
  };
  protoOf(AbstractJsonTreeEncoder).u5u = function (tag, value) {
    return this.c6g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).d6g = function (tag, value) {
    return this.t6f(tag, JsonPrimitive_0(toString(value)));
  };
  protoOf(AbstractJsonTreeEncoder).v5u = function (tag, value) {
    return this.d6g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).e6g = function (tag, value) {
    return this.t6f(tag, JsonPrimitive_0(value));
  };
  protoOf(AbstractJsonTreeEncoder).w5u = function (tag, value) {
    return this.e6g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).f6g = function (tag, enumDescriptor, ordinal) {
    return this.t6f(tag, JsonPrimitive_0(enumDescriptor.v5e(ordinal)));
  };
  protoOf(AbstractJsonTreeEncoder).x5u = function (tag, enumDescriptor, ordinal) {
    return this.f6g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor, ordinal);
  };
  protoOf(AbstractJsonTreeEncoder).g6g = function (tag, value) {
    this.t6f(tag, JsonPrimitive_0(toString_1(value)));
  };
  protoOf(AbstractJsonTreeEncoder).l5u = function (tag, value) {
    return this.g6g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
  };
  protoOf(AbstractJsonTreeEncoder).h6g = function (tag, inlineDescriptor) {
    return get_isUnsignedNumber(inlineDescriptor) ? inlineUnsignedNumberEncoder(this, tag) : get_isUnquotedLiteral(inlineDescriptor) ? inlineUnquotedLiteralEncoder(this, tag, inlineDescriptor) : protoOf(NamedValueEncoder).y5u.call(this, tag, inlineDescriptor);
  };
  protoOf(AbstractJsonTreeEncoder).y5u = function (tag, inlineDescriptor) {
    return this.h6g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  };
  protoOf(AbstractJsonTreeEncoder).o5h = function (descriptor) {
    return !(this.j5u() == null) ? protoOf(NamedValueEncoder).o5h.call(this, descriptor) : (new JsonPrimitiveEncoder(this.j6f_1, this.k6f_1)).o5h(descriptor);
  };
  protoOf(AbstractJsonTreeEncoder).j5g = function (descriptor) {
    var tmp;
    if (this.j5u() == null) {
      tmp = this.k6f_1;
    } else {
      tmp = AbstractJsonTreeEncoder$beginStructure$lambda(this);
    }
    var consumer = tmp;
    var tmp0_subject = descriptor.r5e();
    var tmp_0;
    var tmp_1;
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp_1 = true;
    } else {
      tmp_1 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_1) {
      tmp_0 = new JsonTreeListEncoder(this.j6f_1, consumer);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var this_0 = this.j6f_1;
        var keyDescriptor = carrierDescriptor(descriptor.t5e(0), this_0.h5d());
        var keyKind = keyDescriptor.r5e();
        var tmp_2;
        var tmp_3;
        if (keyKind instanceof PrimitiveKind) {
          tmp_3 = true;
        } else {
          tmp_3 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_3) {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeEncoder.beginStructure.<anonymous>' call
          tmp_2 = new JsonTreeMapEncoder(this.j6f_1, consumer);
        } else {
          if (this_0.j65_1.u66_1) {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeEncoder.beginStructure.<anonymous>' call
            tmp_2 = new JsonTreeListEncoder(this.j6f_1, consumer);
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp_0 = tmp_2;
      } else {
        tmp_0 = new JsonTreeEncoder(this.j6f_1, consumer);
      }
    }
    var encoder = tmp_0;
    if (!(this.m6f_1 == null)) {
      encoder.t6f(ensureNotNull(this.m6f_1), JsonPrimitive_0(descriptor.b5e()));
      this.m6f_1 = null;
    }
    return encoder;
  };
  protoOf(AbstractJsonTreeEncoder).z5u = function (descriptor) {
    this.k6f_1(this.u6f());
  };
  function get_requiresTopLevelTag(_this__u8e3s4) {
    var tmp;
    var tmp_0 = _this__u8e3s4.r5e();
    if (tmp_0 instanceof PrimitiveKind) {
      tmp = true;
    } else {
      tmp = _this__u8e3s4.r5e() === ENUM_getInstance();
    }
    return tmp;
  }
  function JsonPrimitiveEncoder(json, nodeConsumer) {
    AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
    this.u6g_1 = null;
    this.b5v('primitive');
  }
  protoOf(JsonPrimitiveEncoder).t6f = function (key, element) {
    // Inline function 'kotlin.require' call
    if (!(key === 'primitive')) {
      // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveEncoder.putElement.<anonymous>' call
      var message = "This output can only consume primitives with 'primitive' tag";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.u6g_1 == null)) {
      // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveEncoder.putElement.<anonymous>' call
      var message_0 = 'Primitive element was already recorded. Does call to .encodeXxx happen more than once?';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    this.u6g_1 = element;
    this.k6f_1(element);
  };
  protoOf(JsonPrimitiveEncoder).u6f = function () {
    var tmp0 = this.u6g_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveEncoder.getCurrent.<anonymous>' call
        var message = 'Primitive element has not been recorded. Is call to .encodeXxx is missing in serializer?';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    return tmp$ret$1;
  };
  function JsonTreeListEncoder(json, nodeConsumer) {
    AbstractJsonTreeEncoder.call(this, json, nodeConsumer);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.a6h_1 = ArrayList_init_$Create$();
  }
  protoOf(JsonTreeListEncoder).g5u = function (descriptor, index) {
    return index.toString();
  };
  protoOf(JsonTreeListEncoder).t6f = function (key, element) {
    var idx = toInt(key);
    this.a6h_1.p2(idx, element);
  };
  protoOf(JsonTreeListEncoder).u6f = function () {
    return new JsonArray_0(this.a6h_1);
  };
  function _get_tag__e6h4qf($this) {
    var tmp = $this.h6h_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('tag');
    }
  }
  function JsonTreeMapEncoder(json, nodeConsumer) {
    JsonTreeEncoder.call(this, json, nodeConsumer);
    this.i6h_1 = true;
  }
  protoOf(JsonTreeMapEncoder).t6f = function (key, element) {
    if (this.i6h_1) {
      var tmp = this;
      var tmp_0;
      if (element instanceof JsonPrimitive) {
        tmp_0 = element.g67();
      } else {
        if (element instanceof JsonObject_0) {
          throw InvalidKeyKindException(JsonObjectSerializer_getInstance().c68_1);
        } else {
          if (element instanceof JsonArray_0) {
            throw InvalidKeyKindException(JsonArraySerializer_getInstance().d68_1);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
      tmp.h6h_1 = tmp_0;
      this.i6h_1 = false;
    } else {
      var tmp0 = this.s6f_1;
      // Inline function 'kotlin.collections.set' call
      var key_0 = _get_tag__e6h4qf(this);
      tmp0.r2(key_0, element);
      this.i6h_1 = true;
    }
  };
  protoOf(JsonTreeMapEncoder).u6f = function () {
    return new JsonObject_0(this.s6f_1);
  };
  function writeJson$lambda($result) {
    return function (it) {
      $result._v = it;
      return Unit_instance;
    };
  }
  var WriteMode_OBJ_instance;
  var WriteMode_LIST_instance;
  var WriteMode_MAP_instance;
  var WriteMode_POLY_OBJ_instance;
  function values_3() {
    return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
  }
  var WriteMode_entriesInitialized;
  function WriteMode_initEntries() {
    if (WriteMode_entriesInitialized)
      return Unit_instance;
    WriteMode_entriesInitialized = true;
    WriteMode_OBJ_instance = new WriteMode('OBJ', 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
    WriteMode_LIST_instance = new WriteMode('LIST', 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
    WriteMode_MAP_instance = new WriteMode('MAP', 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
    WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
  }
  function WriteMode(name, ordinal, begin, end) {
    Enum.call(this, name, ordinal);
    this.v6c_1 = begin;
    this.w6c_1 = end;
  }
  function switchMode(_this__u8e3s4, desc) {
    var tmp0_subject = desc.r5e();
    var tmp;
    if (tmp0_subject instanceof PolymorphicKind) {
      tmp = WriteMode_POLY_OBJ_getInstance();
    } else {
      if (equals(tmp0_subject, LIST_getInstance())) {
        tmp = WriteMode_LIST_getInstance();
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
          var keyDescriptor = carrierDescriptor(desc.t5e(0), _this__u8e3s4.h5d());
          var keyKind = keyDescriptor.r5e();
          var tmp_0;
          var tmp_1;
          if (keyKind instanceof PrimitiveKind) {
            tmp_1 = true;
          } else {
            tmp_1 = equals(keyKind, ENUM_getInstance());
          }
          if (tmp_1) {
            // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
            tmp_0 = WriteMode_MAP_getInstance();
          } else {
            if (_this__u8e3s4.j65_1.u66_1) {
              // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
              tmp_0 = WriteMode_LIST_getInstance();
            } else {
              throw InvalidKeyKindException(keyDescriptor);
            }
          }
          tmp = tmp_0;
        } else {
          tmp = WriteMode_OBJ_getInstance();
        }
      }
    }
    return tmp;
  }
  function carrierDescriptor(_this__u8e3s4, module_0) {
    var tmp;
    if (equals(_this__u8e3s4.r5e(), CONTEXTUAL_getInstance())) {
      var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
      tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
    } else if (_this__u8e3s4.q5e()) {
      tmp = carrierDescriptor(_this__u8e3s4.t5e(0), module_0);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function WriteMode_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_OBJ_instance;
  }
  function WriteMode_LIST_getInstance() {
    WriteMode_initEntries();
    return WriteMode_LIST_instance;
  }
  function WriteMode_MAP_getInstance() {
    WriteMode_initEntries();
    return WriteMode_MAP_instance;
  }
  function WriteMode_POLY_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_POLY_OBJ_instance;
  }
  function appendEscape($this, lastPosition, current) {
    $this.j6h(lastPosition, current);
    return appendEsc($this, current + 1 | 0);
  }
  function decodedString($this, lastPosition, currentPosition) {
    $this.j6h(lastPosition, currentPosition);
    var result = $this.a66_1.toString();
    $this.a66_1.ed(0);
    return result;
  }
  function takePeeked($this) {
    // Inline function 'kotlin.also' call
    var this_0 = ensureNotNull($this.z65_1);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.takePeeked.<anonymous>' call
    $this.z65_1 = null;
    return this_0;
  }
  function wasUnquotedString($this) {
    return !(charSequenceGet($this.k6h(), $this.x65_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
  }
  function appendEsc($this, startPosition) {
    var currentPosition = startPosition;
    currentPosition = $this.l6h(currentPosition);
    if (currentPosition === -1) {
      $this.v69('Expected escape sequence to continue, got EOF');
    }
    var tmp = $this.k6h();
    var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var currentChar = charSequenceGet(tmp, tmp0);
    if (currentChar === _Char___init__impl__6a9atx(117)) {
      return appendHex($this, $this.k6h(), currentPosition);
    }
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
    var c = escapeToChar(tmp$ret$0);
    if (c === _Char___init__impl__6a9atx(0)) {
      $this.v69("Invalid escaped char '" + toString(currentChar) + "'");
    }
    $this.a66_1.e9(c);
    return currentPosition;
  }
  function appendHex($this, source, startPos) {
    if ((startPos + 4 | 0) >= charSequenceLength(source)) {
      $this.x65_1 = startPos;
      $this.m6h();
      if (($this.x65_1 + 4 | 0) >= charSequenceLength(source)) {
        $this.v69('Unexpected EOF during unicode escape');
      }
      return appendHex($this, source, $this.x65_1);
    }
    $this.a66_1.e9(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
    return startPos + 4 | 0;
  }
  function fromHexChar($this, source, currentPosition) {
    var character = charSequenceGet(source, currentPosition);
    var tmp;
    if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
      // Inline function 'kotlin.code' call
      var tmp_0 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
    } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
      // Inline function 'kotlin.code' call
      var tmp_1 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
    } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
      // Inline function 'kotlin.code' call
      var tmp_2 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
    } else {
      $this.v69("Invalid toHexChar char '" + toString(character) + "' in unicode escape");
    }
    return tmp;
  }
  function consumeBoolean2($this, start) {
    var current = $this.l6h(start);
    if (current >= charSequenceLength($this.k6h()) || current === -1) {
      $this.v69('EOF');
    }
    var tmp = $this.k6h();
    var tmp0 = current;
    current = tmp0 + 1 | 0;
    // Inline function 'kotlin.code' call
    var this_0 = charSequenceGet(tmp, tmp0);
    var tmp1_subject = Char__toInt_impl_vasixd(this_0) | 32;
    var tmp_0;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(116);
    if (tmp1_subject === Char__toInt_impl_vasixd(this_1)) {
      consumeBooleanLiteral($this, 'rue', current);
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(102);
      if (tmp1_subject === Char__toInt_impl_vasixd(this_2)) {
        consumeBooleanLiteral($this, 'alse', current);
        tmp_0 = false;
      } else {
        $this.v69("Expected valid boolean literal prefix, but had '" + $this.y6a() + "'");
      }
    }
    return tmp_0;
  }
  function consumeBooleanLiteral($this, literalSuffix, current) {
    if ((charSequenceLength($this.k6h()) - current | 0) < literalSuffix.length) {
      $this.v69('Unexpected end of boolean literal');
    }
    var inductionVariable = 0;
    var last = charSequenceLength(literalSuffix) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var expected = charSequenceGet(literalSuffix, i);
        var actual = charSequenceGet($this.k6h(), current + i | 0);
        // Inline function 'kotlin.code' call
        var tmp = Char__toInt_impl_vasixd(expected);
        // Inline function 'kotlin.code' call
        if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
          $this.v69("Expected valid boolean literal prefix, but had '" + $this.y6a() + "'");
        }
      }
       while (inductionVariable <= last);
    $this.x65_1 = current + literalSuffix.length | 0;
  }
  function AbstractJsonLexer() {
    this.x65_1 = 0;
    this.y65_1 = new JsonPath();
    this.z65_1 = null;
    this.a66_1 = StringBuilder_init_$Create$_1();
  }
  protoOf(AbstractJsonLexer).m6h = function () {
  };
  protoOf(AbstractJsonLexer).n6h = function (c) {
    return (((c === _Char___init__impl__6a9atx(125) ? true : c === _Char___init__impl__6a9atx(93)) ? true : c === _Char___init__impl__6a9atx(58)) ? true : c === _Char___init__impl__6a9atx(44)) ? false : true;
  };
  protoOf(AbstractJsonLexer).b66 = function () {
    var nextToken = this.z6a();
    if (!(nextToken === 10)) {
      this.v69('Expected EOF after parsing, but had ' + toString(charSequenceGet(this.k6h(), this.x65_1 - 1 | 0)) + ' instead');
    }
  };
  protoOf(AbstractJsonLexer).u6a = function (expected) {
    var token = this.z6a();
    if (!(token === expected)) {
      this.o6h(expected);
    }
    return token;
  };
  protoOf(AbstractJsonLexer).k6c = function (expected) {
    this.m6h();
    var source = this.k6h();
    var cpos = this.x65_1;
    $l$loop_0: while (true) {
      cpos = this.l6h(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var tmp0 = cpos;
      cpos = tmp0 + 1 | 0;
      var c = charSequenceGet(source, tmp0);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop_0;
      this.x65_1 = cpos;
      if (c === expected)
        return Unit_instance;
      this.p6h(expected);
    }
    this.x65_1 = cpos;
    this.p6h(expected);
  };
  protoOf(AbstractJsonLexer).p6h = function (expected) {
    this.x65_1 = this.x65_1 - 1 | 0;
    if (this.x65_1 >= 0 && expected === _Char___init__impl__6a9atx(34) && this.y6a() === 'null') {
      this.q6h("Expected string literal but 'null' literal was found", this.x65_1 - 4 | 0, "Use 'coerceInputValues = true' in 'Json {}` builder to coerce nulls to default values.");
    }
    this.o6h(charToTokenClass(expected));
  };
  protoOf(AbstractJsonLexer).o6h = function (expectedToken) {
    var expected = expectedToken === 1 ? "quotation mark '\"'" : expectedToken === 4 ? "comma ','" : expectedToken === 5 ? "colon ':'" : expectedToken === 6 ? "start of the object '{'" : expectedToken === 7 ? "end of the object '}'" : expectedToken === 8 ? "start of the array '['" : expectedToken === 9 ? "end of the array ']'" : 'valid token';
    var s = this.x65_1 === charSequenceLength(this.k6h()) || this.x65_1 <= 0 ? 'EOF' : toString(charSequenceGet(this.k6h(), this.x65_1 - 1 | 0));
    this.v69('Expected ' + expected + ", but had '" + s + "' instead", this.x65_1 - 1 | 0);
  };
  protoOf(AbstractJsonLexer).v6a = function () {
    var source = this.k6h();
    var cpos = this.x65_1;
    $l$loop_0: while (true) {
      cpos = this.l6h(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var ch = charSequenceGet(source, cpos);
      if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
        cpos = cpos + 1 | 0;
        continue $l$loop_0;
      }
      this.x65_1 = cpos;
      return charToTokenClass(ch);
    }
    this.x65_1 = cpos;
    return 10;
  };
  protoOf(AbstractJsonLexer).m6c = function (doConsume) {
    var current = this.r6h();
    current = this.l6h(current);
    var len = charSequenceLength(this.k6h()) - current | 0;
    if (len < 4 || current === -1)
      return false;
    var inductionVariable = 0;
    if (inductionVariable <= 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charSequenceGet('null', i) === charSequenceGet(this.k6h(), current + i | 0)))
          return false;
      }
       while (inductionVariable <= 3);
    if (len > 4 && charToTokenClass(charSequenceGet(this.k6h(), current + 4 | 0)) === 0)
      return false;
    if (doConsume) {
      this.x65_1 = current + 4 | 0;
    }
    return true;
  };
  protoOf(AbstractJsonLexer).x6c = function (doConsume, $super) {
    doConsume = doConsume === VOID ? true : doConsume;
    return $super === VOID ? this.m6c(doConsume) : $super.m6c.call(this, doConsume);
  };
  protoOf(AbstractJsonLexer).r6h = function () {
    var current = this.x65_1;
    $l$loop_0: while (true) {
      current = this.l6h(current);
      if (current === -1)
        break $l$loop_0;
      var c = charSequenceGet(this.k6h(), current);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop_0;
      }
    }
    this.x65_1 = current;
    return current;
  };
  protoOf(AbstractJsonLexer).n6c = function (isLenient) {
    var token = this.v6a();
    var tmp;
    if (isLenient) {
      if (!(token === 1) && !(token === 0))
        return null;
      tmp = this.y6a();
    } else {
      if (!(token === 1))
        return null;
      tmp = this.x6a();
    }
    var string = tmp;
    this.z65_1 = string;
    return string;
  };
  protoOf(AbstractJsonLexer).s6h = function (startPos, endPos) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.k6h();
    return toString_1(charSequenceSubSequence(this_0, startPos, endPos));
  };
  protoOf(AbstractJsonLexer).x6a = function () {
    if (!(this.z65_1 == null)) {
      return takePeeked(this);
    }
    return this.q6c();
  };
  protoOf(AbstractJsonLexer).consumeString2 = function (source, startPosition, current) {
    var currentPosition = current;
    var lastPosition = startPosition;
    var char = charSequenceGet(source, currentPosition);
    var usedAppend = false;
    while (!(char === _Char___init__impl__6a9atx(34))) {
      if (char === _Char___init__impl__6a9atx(92)) {
        usedAppend = true;
        currentPosition = this.l6h(appendEscape(this, lastPosition, currentPosition));
        if (currentPosition === -1) {
          this.v69('EOF', currentPosition);
        }
        lastPosition = currentPosition;
      } else {
        currentPosition = currentPosition + 1 | 0;
        if (currentPosition >= charSequenceLength(source)) {
          usedAppend = true;
          this.j6h(lastPosition, currentPosition);
          currentPosition = this.l6h(currentPosition);
          if (currentPosition === -1) {
            this.v69('EOF', currentPosition);
          }
          lastPosition = currentPosition;
        }
      }
      char = charSequenceGet(source, currentPosition);
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.s6h(lastPosition, currentPosition);
    } else {
      tmp = decodedString(this, lastPosition, currentPosition);
    }
    var string = tmp;
    this.x65_1 = currentPosition + 1 | 0;
    return string;
  };
  protoOf(AbstractJsonLexer).r6c = function () {
    var result = this.y6a();
    if (result === 'null' && wasUnquotedString(this)) {
      this.v69("Unexpected 'null' value instead of string literal");
    }
    return result;
  };
  protoOf(AbstractJsonLexer).y6a = function () {
    if (!(this.z65_1 == null)) {
      return takePeeked(this);
    }
    var current = this.r6h();
    if (current >= charSequenceLength(this.k6h()) || current === -1) {
      this.v69('EOF', current);
    }
    var token = charToTokenClass(charSequenceGet(this.k6h(), current));
    if (token === 1) {
      return this.x6a();
    }
    if (!(token === 0)) {
      this.v69('Expected beginning of the string, but got ' + toString(charSequenceGet(this.k6h(), current)));
    }
    var usedAppend = false;
    while (charToTokenClass(charSequenceGet(this.k6h(), current)) === 0) {
      current = current + 1 | 0;
      if (current >= charSequenceLength(this.k6h())) {
        usedAppend = true;
        this.j6h(this.x65_1, current);
        var eof = this.l6h(current);
        if (eof === -1) {
          this.x65_1 = current;
          return decodedString(this, 0, 0);
        } else {
          current = eof;
        }
      }
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.s6h(this.x65_1, current);
    } else {
      tmp = decodedString(this, this.x65_1, current);
    }
    var result = tmp;
    this.x65_1 = current;
    return result;
  };
  protoOf(AbstractJsonLexer).j6h = function (fromIndex, toIndex) {
    this.a66_1.yc(this.k6h(), fromIndex, toIndex);
  };
  protoOf(AbstractJsonLexer).p6c = function (allowLenientStrings) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tokenStack = ArrayList_init_$Create$();
    var lastToken = this.v6a();
    if (!(lastToken === 8) && !(lastToken === 6)) {
      this.y6a();
      return Unit_instance;
    }
    $l$loop: while (true) {
      lastToken = this.v6a();
      if (lastToken === 1) {
        if (allowLenientStrings) {
          this.y6a();
        } else {
          this.q6c();
        }
        continue $l$loop;
      }
      var tmp0_subject = lastToken;
      if (tmp0_subject === 8 ? true : tmp0_subject === 6) {
        tokenStack.e(lastToken);
      } else if (tmp0_subject === 9) {
        if (!(last(tokenStack) === 8))
          throw JsonDecodingException_0(this.x65_1, 'found ] instead of } at path: ' + this.y65_1.toString(), this.k6h());
        removeLast(tokenStack);
      } else if (tmp0_subject === 7) {
        if (!(last(tokenStack) === 6))
          throw JsonDecodingException_0(this.x65_1, 'found } instead of ] at path: ' + this.y65_1.toString(), this.k6h());
        removeLast(tokenStack);
      } else if (tmp0_subject === 10) {
        this.v69('Unexpected end of input due to malformed JSON during ignoring unknown keys');
      }
      this.z6a();
      if (tokenStack.n() === 0)
        return Unit_instance;
    }
  };
  protoOf(AbstractJsonLexer).toString = function () {
    return "JsonReader(source='" + toString_1(this.k6h()) + "', currentPosition=" + this.x65_1 + ')';
  };
  protoOf(AbstractJsonLexer).o6c = function (key) {
    var processed = this.s6h(0, this.x65_1);
    var lastIndexOf = lastIndexOf_3(processed, key);
    this.q6h("Encountered an unknown key '" + key + "'", lastIndexOf, "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.");
  };
  protoOf(AbstractJsonLexer).q6h = function (message, position, hint) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(hint) === 0) {
      tmp = '';
    } else {
      tmp = '\n' + hint;
    }
    var hintMessage = tmp;
    throw JsonDecodingException_0(position, message + ' at path: ' + this.y65_1.i6a() + hintMessage, this.k6h());
  };
  protoOf(AbstractJsonLexer).v69 = function (message, position, hint, $super) {
    position = position === VOID ? this.x65_1 : position;
    hint = hint === VOID ? '' : hint;
    return $super === VOID ? this.q6h(message, position, hint) : $super.q6h.call(this, message, position, hint);
  };
  protoOf(AbstractJsonLexer).a6d = function () {
    var current = this.r6h();
    current = this.l6h(current);
    if (current >= charSequenceLength(this.k6h()) || current === -1) {
      this.v69('EOF');
    }
    var tmp;
    if (charSequenceGet(this.k6h(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      if (current === charSequenceLength(this.k6h())) {
        this.v69('EOF');
      }
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var accumulator = new Long(0, 0);
    var isNegative = false;
    var start = current;
    var hasChars = true;
    $l$loop_0: while (hasChars) {
      var ch = charSequenceGet(this.k6h(), current);
      if (ch === _Char___init__impl__6a9atx(45)) {
        if (!(current === start)) {
          this.v69("Unexpected symbol '-' in numeric literal");
        }
        isNegative = true;
        current = current + 1 | 0;
        continue $l$loop_0;
      }
      var token = charToTokenClass(ch);
      if (!(token === 0))
        break $l$loop_0;
      current = current + 1 | 0;
      hasChars = !(current === charSequenceLength(this.k6h()));
      var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
      if (!(0 <= digit ? digit <= 9 : false)) {
        this.v69("Unexpected symbol '" + toString(ch) + "' in numeric literal");
      }
      // Inline function 'kotlin.Long.times' call
      // Inline function 'kotlin.Long.minus' call
      accumulator = accumulator.k3(toLong(10)).j3(toLong(digit));
      if (accumulator.d1(new Long(0, 0)) > 0) {
        this.v69('Numeric value overflow');
      }
    }
    if (start === current || (isNegative && start === (current - 1 | 0))) {
      this.v69('Expected numeric literal');
    }
    if (hasQuotation) {
      if (!hasChars) {
        this.v69('EOF');
      }
      if (!(charSequenceGet(this.k6h(), current) === _Char___init__impl__6a9atx(34))) {
        this.v69('Expected closing quotation mark');
      }
      current = current + 1 | 0;
    }
    this.x65_1 = current;
    var tmp_0;
    if (isNegative) {
      tmp_0 = accumulator;
    } else if (!accumulator.equals(new Long(0, -2147483648))) {
      tmp_0 = accumulator.p3();
    } else {
      this.v69('Numeric value overflow');
    }
    return tmp_0;
  };
  protoOf(AbstractJsonLexer).y6c = function () {
    return consumeBoolean2(this, this.r6h());
  };
  protoOf(AbstractJsonLexer).z6c = function () {
    var current = this.r6h();
    if (current === charSequenceLength(this.k6h())) {
      this.v69('EOF');
    }
    var tmp;
    if (charSequenceGet(this.k6h(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var result = consumeBoolean2(this, current);
    if (hasQuotation) {
      if (this.x65_1 === charSequenceLength(this.k6h())) {
        this.v69('EOF');
      }
      if (!(charSequenceGet(this.k6h(), this.x65_1) === _Char___init__impl__6a9atx(34))) {
        this.v69('Expected closing quotation mark');
      }
      this.x65_1 = this.x65_1 + 1 | 0;
    }
    return result;
  };
  function charToTokenClass(c) {
    var tmp;
    // Inline function 'kotlin.code' call
    if (Char__toInt_impl_vasixd(c) < 126) {
      var tmp_0 = CharMappings_getInstance().u6h_1;
      // Inline function 'kotlin.code' call
      tmp = tmp_0[Char__toInt_impl_vasixd(c)];
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function escapeToChar(c) {
    return c < 117 ? CharMappings_getInstance().t6h_1[c] : _Char___init__impl__6a9atx(0);
  }
  function initEscape($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2ESC($this, i, _Char___init__impl__6a9atx(117));
      }
       while (inductionVariable <= 31);
    initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
    initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
    initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
    initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
    initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
    initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
    initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
    initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
  }
  function initCharToToken($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2TC($this, i, 127);
      }
       while (inductionVariable <= 32);
    initC2TC($this, 9, 3);
    initC2TC($this, 10, 3);
    initC2TC($this, 13, 3);
    initC2TC($this, 32, 3);
    initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
    initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
    initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
    initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
    initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
    initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
    initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
    initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
  }
  function initC2ESC($this, c, esc) {
    if (!(esc === _Char___init__impl__6a9atx(117))) {
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
      $this.t6h_1[tmp$ret$0] = numberToChar(c);
    }
  }
  function initC2ESC_0($this, c, esc) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2ESC($this, tmp$ret$0, esc);
  }
  function initC2TC($this, c, cl) {
    $this.u6h_1[c] = cl;
  }
  function initC2TC_0($this, c, cl) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2TC($this, tmp$ret$0, cl);
  }
  function CharMappings() {
    CharMappings_instance = this;
    this.t6h_1 = charArray(117);
    this.u6h_1 = new Int8Array(126);
    initEscape(this);
    initCharToToken(this);
  }
  var CharMappings_instance;
  function CharMappings_getInstance() {
    if (CharMappings_instance == null)
      new CharMappings();
    return CharMappings_instance;
  }
  function StringJsonLexer_0(source) {
    AbstractJsonLexer.call(this);
    this.z6h_1 = source;
  }
  protoOf(StringJsonLexer_0).k6h = function () {
    return this.z6h_1;
  };
  protoOf(StringJsonLexer_0).l6h = function (position) {
    return position < this.z6h_1.length ? position : -1;
  };
  protoOf(StringJsonLexer_0).z6a = function () {
    var source = this.z6h_1;
    $l$loop: while (!(this.x65_1 === -1) && this.x65_1 < source.length) {
      var tmp1 = this.x65_1;
      this.x65_1 = tmp1 + 1 | 0;
      var ch = charSequenceGet(source, tmp1);
      var tc = charToTokenClass(ch);
      var tmp;
      if (tc === 3) {
        continue $l$loop;
      } else {
        tmp = tc;
      }
      return tmp;
    }
    return 10;
  };
  protoOf(StringJsonLexer_0).l6c = function () {
    var current = this.r6h();
    if (current === this.z6h_1.length || current === -1)
      return false;
    if (charSequenceGet(this.z6h_1, current) === _Char___init__impl__6a9atx(44)) {
      this.x65_1 = this.x65_1 + 1 | 0;
      return true;
    }
    return false;
  };
  protoOf(StringJsonLexer_0).w6a = function () {
    var current = this.x65_1;
    if (current === -1)
      return false;
    $l$loop: while (current < this.z6h_1.length) {
      var c = charSequenceGet(this.z6h_1, current);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop;
      }
      this.x65_1 = current;
      return this.n6h(c);
    }
    this.x65_1 = current;
    return false;
  };
  protoOf(StringJsonLexer_0).r6h = function () {
    var current = this.x65_1;
    if (current === -1)
      return current;
    $l$loop: while (current < this.z6h_1.length) {
      var c = charSequenceGet(this.z6h_1, current);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop;
      }
    }
    this.x65_1 = current;
    return current;
  };
  protoOf(StringJsonLexer_0).k6c = function (expected) {
    if (this.x65_1 === -1) {
      this.p6h(expected);
    }
    var source = this.z6h_1;
    $l$loop: while (this.x65_1 < source.length) {
      var tmp1 = this.x65_1;
      this.x65_1 = tmp1 + 1 | 0;
      var c = charSequenceGet(source, tmp1);
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      if (c === expected)
        return Unit_instance;
      this.p6h(expected);
    }
    this.p6h(expected);
  };
  protoOf(StringJsonLexer_0).q6c = function () {
    this.k6c(_Char___init__impl__6a9atx(34));
    var current = this.x65_1;
    var closingQuote = indexOf_8(this.z6h_1, _Char___init__impl__6a9atx(34), current);
    if (closingQuote === -1) {
      this.o6h(1);
    }
    var inductionVariable = current;
    if (inductionVariable < closingQuote)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charSequenceGet(this.z6h_1, i) === _Char___init__impl__6a9atx(92)) {
          return this.consumeString2(this.z6h_1, this.x65_1, i);
        }
      }
       while (inductionVariable < closingQuote);
    this.x65_1 = closingQuote + 1 | 0;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.z6h_1.substring(current, closingQuote);
  };
  protoOf(StringJsonLexer_0).s6c = function (keyToMatch, isLenient) {
    var positionSnapshot = this.x65_1;
    try {
      if (!(this.z6a() === 6))
        return null;
      var firstKey = isLenient ? this.q6c() : this.r6c();
      if (firstKey === keyToMatch) {
        if (!(this.z6a() === 5))
          return null;
        var result = isLenient ? this.x6a() : this.r6c();
        return result;
      }
      return null;
    }finally {
      this.x65_1 = positionSnapshot;
    }
  };
  function decodeFromDynamic(_this__u8e3s4, deserializer, dynamic) {
    return decodeDynamic(_this__u8e3s4, deserializer, dynamic);
  }
  function get_schemaCache(_this__u8e3s4) {
    return _this__u8e3s4.l65_1;
  }
  function decodeDynamic(_this__u8e3s4, deserializer, dynamic) {
    var tmp;
    switch (typeof dynamic) {
      case 'boolean':
      case 'number':
      case 'string':
        tmp = new PrimitiveDynamicInput(dynamic, _this__u8e3s4);
        break;
      default:
        var tmp_0;
        if (Array.isArray(dynamic)) {
          tmp_0 = new DynamicListInput(dynamic, _this__u8e3s4);
        } else {
          tmp_0 = new DynamicInput(dynamic, _this__u8e3s4);
        }

        tmp = tmp_0;
        break;
    }
    var input = tmp;
    return input.l5d(deserializer);
  }
  function coerceInputValue_1($this, descriptor, index, tag) {
    var tmp0 = $this.e67();
    var tmp1 = descriptor.t5e(index);
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var tmp;
      if (!tmp1.l5e()) {
        // Inline function 'kotlinx.serialization.json.internal.DynamicInput.coerceInputValue.<anonymous>' call
        tmp = $this.i6i(tag) == null;
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = true;
        break $l$block_2;
      }
      if (equals(tmp1.r5e(), ENUM_getInstance())) {
        var tmp_0;
        if (tmp1.l5e()) {
          // Inline function 'kotlinx.serialization.json.internal.DynamicInput.coerceInputValue.<anonymous>' call
          tmp_0 = $this.i6i(tag) == null;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$1 = false;
          break $l$block_2;
        }
        // Inline function 'kotlinx.serialization.json.internal.DynamicInput.coerceInputValue.<anonymous>' call
        var tmp_1 = $this.i6i(tag);
        var tmp0_elvis_lhs = (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : null;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = false;
          break $l$block_2;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_2;
        var enumIndex = getJsonNameIndex(tmp1, tmp0, enumValue);
        if (enumIndex === -3) {
          // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue.<anonymous>' call
          tmp$ret$1 = true;
          break $l$block_2;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function hasName($this, name) {
    return $this.c6i_1[name] !== undefined;
  }
  function absenceIsNull_0($this, descriptor, index) {
    $this.g6i_1 = (!$this.e67().j65_1.w66_1 && !descriptor.w5e(index) && descriptor.t5e(index).l5e());
    return $this.g6i_1;
  }
  function throwMissingTag($this, tag) {
    throw SerializationException_init_$Create$_0('Value for field ' + tag + ' is missing');
  }
  function DynamicInput(value, json) {
    NamedValueDecoder.call(this);
    this.c6i_1 = value;
    this.d6i_1 = json;
    var tmp = this;
    var tmp0_elvis_lhs = this.c6i_1;
    tmp.e6i_1 = Object.keys(tmp0_elvis_lhs == null ? {} : tmp0_elvis_lhs);
    var tmp_0 = this;
    var tmp_1 = this.e6i_1.length;
    tmp_0.f6i_1 = (!(tmp_1 == null) ? typeof tmp_1 === 'number' : false) ? tmp_1 : THROW_CCE();
    this.g6i_1 = false;
    this.h6i_1 = 0;
  }
  protoOf(DynamicInput).e67 = function () {
    return this.d6i_1;
  };
  protoOf(DynamicInput).n = function () {
    return this.f6i_1;
  };
  protoOf(DynamicInput).h5d = function () {
    return this.e67().h5d();
  };
  protoOf(DynamicInput).f67 = function () {
    var tag = this.j5u();
    if (!(tag == null)) {
      return decodeFromDynamic(this.e67(), Companion_instance_83.h67(), this.c6i_1[tag]);
    }
    if (this.c6i_1 == null) {
      return JsonNull_getInstance();
    }
    // Inline function 'kotlinx.serialization.json.buildJsonObject' call
    // Inline function 'kotlin.contracts.contract' call
    var builder = new JsonObjectBuilder();
    // Inline function 'kotlinx.serialization.json.internal.DynamicInput.decodeJsonElement.<anonymous>' call
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var key = this.e6i_1[i];
        var value = decodeDynamic(this.e67(), Companion_instance_83.h67(), this.c6i_1[key]);
        builder.v67(toString_1(key), value);
      }
       while (inductionVariable < last);
    return builder.q66();
  };
  protoOf(DynamicInput).l5d = function (deserializer) {
    return decodeSerializableValuePolymorphic(this, deserializer);
  };
  protoOf(DynamicInput).k5u = function (parentName, childName) {
    return childName;
  };
  protoOf(DynamicInput).z5g = function (descriptor) {
    while (this.h6i_1 < descriptor.p5e()) {
      var tmp1 = this.h6i_1;
      this.h6i_1 = tmp1 + 1 | 0;
      var name = this.f5u(descriptor, tmp1);
      var index = this.h6i_1 - 1 | 0;
      this.g6i_1 = false;
      if ((hasName(this, name) || absenceIsNull_0(this, descriptor, index)) && (!this.e67().j65_1.y66_1 || !coerceInputValue_1(this, descriptor, index, name))) {
        return index;
      }
    }
    return -1;
  };
  protoOf(DynamicInput).g5u = function (descriptor, index) {
    var strategy = namingStrategy(descriptor, this.e67());
    var mainName = descriptor.v5e(index);
    if (strategy == null) {
      if (!this.e67().j65_1.c67_1)
        return mainName;
      if (hasName(this, mainName))
        return mainName;
    }
    var deserializationNamesMap_0 = deserializationNamesMap(this.e67(), descriptor);
    var tmp = this.e6i_1;
    // Inline function 'kotlin.collections.find' call
    var tmp0 = (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = tmp0.length;
      while (inductionVariable < last) {
        var element = tmp0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.DynamicInput.elementName.<anonymous>' call
        if (deserializationNamesMap_0.y2(element) === index) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return tmp0_safe_receiver;
    }
    var fallbackName = strategy == null ? null : strategy.z69(descriptor, index, mainName);
    return fallbackName == null ? mainName : fallbackName;
  };
  protoOf(DynamicInput).k6d = function (tag, enumDescriptor) {
    var byTag = this.i6i(tag);
    var tmp0_elvis_lhs = (!(byTag == null) ? typeof byTag === 'string' : false) ? byTag : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw SerializationException_init_$Create$_0("Enum value must be a string, got '" + byTag + "'");
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var enumValue = tmp;
    return getJsonNameIndexOrThrow(enumDescriptor, this.e67(), enumValue);
  };
  protoOf(DynamicInput).s5v = function (tag, enumDescriptor) {
    return this.k6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  };
  protoOf(DynamicInput).i6i = function (tag) {
    return this.c6i_1[tag];
  };
  protoOf(DynamicInput).t6d = function (tag) {
    var value = this.i6i(tag);
    var tmp;
    if (!(value == null) ? typeof value === 'string' : false) {
      var tmp_0;
      if (value.length === 1) {
        tmp_0 = charSequenceGet(value, 0);
      } else {
        throw SerializationException_init_$Create$_0('' + value + " can't be represented as Char");
      }
      tmp = tmp_0;
    } else {
      if (isNumber(value)) {
        var tmp0_elvis_lhs = (!(value == null) ? typeof value === 'number' : false) ? value : null;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          throw SerializationException_init_$Create$_0('' + value + ' is not a Number');
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var num = tmp_1;
        var codePoint = this.j6i(num);
        var tmp_2;
        if (codePoint.d1(new Long(0, 0)) < 0) {
          tmp_2 = true;
        } else {
          // Inline function 'kotlin.code' call
          var this_0 = _Char___init__impl__6a9atx(65535);
          var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
          tmp_2 = codePoint.d1(toLong(tmp$ret$0)) > 0;
        }
        if (tmp_2)
          throw SerializationException_init_$Create$_0('' + value + " can't be represented as Char because it's not in bounds of Char.MIN_VALUE..Char.MAX_VALUE");
        tmp = numberToChar(codePoint.z3());
      } else {
        throw SerializationException_init_$Create$_0('' + value + " can't be represented as Char");
      }
    }
    return tmp;
  };
  protoOf(DynamicInput).q5v = function (tag) {
    return this.t6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicInput).q6d = function (tag) {
    var value = this.i6i(tag);
    var tmp0_elvis_lhs = (!(value == null) ? typeof value === 'number' : false) ? value : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw SerializationException_init_$Create$_0('' + value + ' is not a Number');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var number = tmp;
    return this.j6i(number);
  };
  protoOf(DynamicInput).n5v = function (tag) {
    return this.q6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicInput).j6i = function (number) {
    var tmp;
    if (isFinite(number)) {
      // Inline function 'kotlin.math.floor' call
      tmp = Math.floor(number) === number;
    } else {
      tmp = false;
    }
    var canBeConverted = tmp;
    if (!canBeConverted)
      throw SerializationException_init_$Create$_0('' + number + " can't be represented as Long because it is not finite or has non-zero fractional part");
    // Inline function 'kotlin.math.abs' call
    var inBound = Math.abs(number) <= 9.007199254740991E15;
    if (!inBound)
      throw SerializationException_init_$Create$_0('' + number + " can't be deserialized to Long due to a potential precision loss");
    return numberToLong(number);
  };
  protoOf(DynamicInput).k6i = function (tag) {
    var tmp0_elvis_lhs = this.i6i(tag);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwMissingTag(this, tag);
      tmp = Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var o = tmp;
    return !(o == null) ? o : THROW_CCE();
  };
  protoOf(DynamicInput).h5v = function (tag) {
    return this.k6i((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicInput).l6d = function (tag) {
    if (this.g6i_1) {
      return false;
    }
    var o = this.i6i(tag);
    if (o === undefined) {
      throwMissingTag(this, tag);
    }
    return o != null;
  };
  protoOf(DynamicInput).i5v = function (tag) {
    return this.l6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicInput).j5g = function (descriptor) {
    var tmp0_safe_receiver = this.j5u();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlinx.serialization.json.internal.DynamicInput.beginStructure.<anonymous>' call
      tmp = this.c6i_1[tmp0_safe_receiver];
    }
    var tmp1_elvis_lhs = tmp;
    var currentValue = tmp1_elvis_lhs == null ? this.c6i_1 : tmp1_elvis_lhs;
    var tmp_0;
    if (descriptor.r5e() instanceof PolymorphicKind) {
      tmp_0 = this.e67().j65_1.z66_1 ? LIST_getInstance() : MAP_getInstance();
    } else {
      tmp_0 = descriptor.r5e();
    }
    var kind = tmp_0;
    return equals(kind, LIST_getInstance()) ? new DynamicListInput(currentValue, this.e67()) : equals(kind, MAP_getInstance()) ? new DynamicMapInput(currentValue, this.e67()) : new DynamicInput(currentValue, this.e67());
  };
  function PrimitiveDynamicInput(value, json) {
    DynamicInput.call(this, value, json);
    this.b5v('primitive');
  }
  protoOf(PrimitiveDynamicInput).i6i = function (tag) {
    return this.c6i_1;
  };
  protoOf(PrimitiveDynamicInput).f67 = function () {
    var str = toString_1(this.c6i_1);
    var tmp;
    switch (typeof this.c6i_1) {
      case 'boolean':
        tmp = JsonPrimitive_2(toBoolean(str));
        break;
      case 'number':
        var l = toLongOrNull(str);
        if (!(l == null))
          return JsonPrimitive_1(l);
        var d = toDoubleOrNull(str);
        if (!(d == null))
          return JsonPrimitive_1(d);
        return JsonPrimitive_0(str);
      default:
        tmp = JsonPrimitive_0(str);
        break;
    }
    return tmp;
  };
  function DynamicListInput(value, json) {
    DynamicInput.call(this, value, json);
    var tmp = this;
    var tmp_0 = value.length;
    tmp.b6j_1 = (!(tmp_0 == null) ? typeof tmp_0 === 'number' : false) ? tmp_0 : THROW_CCE();
    this.c6j_1 = -1;
  }
  protoOf(DynamicListInput).n = function () {
    return this.b6j_1;
  };
  protoOf(DynamicListInput).g5u = function (descriptor, index) {
    return index.toString();
  };
  protoOf(DynamicListInput).z5g = function (descriptor) {
    while (this.c6j_1 < (this.b6j_1 - 1 | 0)) {
      this.c6j_1 = this.c6j_1 + 1 | 0;
      var o = this.c6i_1[this.c6j_1];
      if (o !== undefined)
        return this.c6j_1;
    }
    return -1;
  };
  protoOf(DynamicListInput).f67 = function () {
    var tag = this.j5u();
    if (!(tag == null)) {
      return decodeFromDynamic(this.e67(), Companion_instance_83.h67(), this.c6i_1[tag]);
    }
    // Inline function 'kotlinx.serialization.json.buildJsonArray' call
    // Inline function 'kotlin.contracts.contract' call
    var builder = new JsonArrayBuilder();
    // Inline function 'kotlinx.serialization.json.internal.DynamicListInput.decodeJsonElement.<anonymous>' call
    var inductionVariable = 0;
    var last = this.b6j_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        builder.x67(decodeFromDynamic(this.e67(), Companion_instance_83.h67(), this.c6i_1[i]));
      }
       while (inductionVariable < last);
    return builder.q66();
  };
  function _get_isKey__g0dpic($this) {
    return ($this.m6j_1 % 2 | 0) === 0;
  }
  function throwIllegalKeyType($this, tag, value, type) {
    throw SerializationException_init_$Create$_0('Property ' + tag + ' is not valid type ' + type + ': ' + toString_1(value));
  }
  function DynamicMapInput(value, json) {
    DynamicInput.call(this, value, json);
    var tmp = this;
    var tmp_0 = this.e6i_1.length;
    tmp.l6j_1 = imul((!(tmp_0 == null) ? typeof tmp_0 === 'number' : false) ? tmp_0 : THROW_CCE(), 2);
    this.m6j_1 = -1;
  }
  protoOf(DynamicMapInput).n = function () {
    return this.l6j_1;
  };
  protoOf(DynamicMapInput).g5u = function (descriptor, index) {
    var i = index / 2 | 0;
    var tmp = this.e6i_1[i];
    return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
  };
  protoOf(DynamicMapInput).n6d = function (tag) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeMapKey' call
      if (_get_isKey__g0dpic(this)) {
        var value = this.k6i(tag);
        if (!(typeof value === 'string')) {
          // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedByte.<anonymous>' call
          tmp$ret$1 = protoOf(DynamicInput).k5v.call(this, tag);
          break $l$block_0;
        }
        // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedByte.<anonymous>' call
        var $this$decodeMapKey = toString_1(value);
        var tmp0_elvis_lhs = toByteOrNull($this$decodeMapKey);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwIllegalKeyType(this, tag, value, 'byte');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block_0;
      }
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedByte.<anonymous>' call
      tmp$ret$1 = protoOf(DynamicInput).k5v.call(this, tag);
    }
    return tmp$ret$1;
  };
  protoOf(DynamicMapInput).k5v = function (tag) {
    return this.n6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicMapInput).o6d = function (tag) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeMapKey' call
      if (_get_isKey__g0dpic(this)) {
        var value = this.k6i(tag);
        if (!(typeof value === 'string')) {
          // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedShort.<anonymous>' call
          tmp$ret$1 = protoOf(DynamicInput).l5v.call(this, tag);
          break $l$block_0;
        }
        // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedShort.<anonymous>' call
        var $this$decodeMapKey = toString_1(value);
        var tmp0_elvis_lhs = toShortOrNull($this$decodeMapKey);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwIllegalKeyType(this, tag, value, 'short');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block_0;
      }
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedShort.<anonymous>' call
      tmp$ret$1 = protoOf(DynamicInput).l5v.call(this, tag);
    }
    return tmp$ret$1;
  };
  protoOf(DynamicMapInput).l5v = function (tag) {
    return this.o6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicMapInput).p6d = function (tag) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeMapKey' call
      if (_get_isKey__g0dpic(this)) {
        var value = this.k6i(tag);
        if (!(typeof value === 'string')) {
          // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedInt.<anonymous>' call
          tmp$ret$1 = protoOf(DynamicInput).m5v.call(this, tag);
          break $l$block_0;
        }
        // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedInt.<anonymous>' call
        var $this$decodeMapKey = toString_1(value);
        var tmp0_elvis_lhs = toIntOrNull($this$decodeMapKey);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwIllegalKeyType(this, tag, value, 'int');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block_0;
      }
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedInt.<anonymous>' call
      tmp$ret$1 = protoOf(DynamicInput).m5v.call(this, tag);
    }
    return tmp$ret$1;
  };
  protoOf(DynamicMapInput).m5v = function (tag) {
    return this.p6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicMapInput).q6d = function (tag) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeMapKey' call
      if (_get_isKey__g0dpic(this)) {
        var value = this.k6i(tag);
        if (!(typeof value === 'string')) {
          // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedLong.<anonymous>' call
          tmp$ret$1 = protoOf(DynamicInput).q6d.call(this, tag);
          break $l$block_0;
        }
        // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedLong.<anonymous>' call
        var $this$decodeMapKey = toString_1(value);
        var tmp0_elvis_lhs = toDoubleOrNull($this$decodeMapKey);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwIllegalKeyType(this, tag, $this$decodeMapKey, 'long');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp0_elvis_lhs_0 = this.j6i(tmp);
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          throwIllegalKeyType(this, tag, value, 'long');
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        tmp$ret$1 = tmp_0;
        break $l$block_0;
      }
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedLong.<anonymous>' call
      tmp$ret$1 = protoOf(DynamicInput).q6d.call(this, tag);
    }
    return tmp$ret$1;
  };
  protoOf(DynamicMapInput).n5v = function (tag) {
    return this.q6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicMapInput).r6d = function (tag) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeMapKey' call
      if (_get_isKey__g0dpic(this)) {
        var value = this.k6i(tag);
        if (!(typeof value === 'string')) {
          // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedFloat.<anonymous>' call
          tmp$ret$1 = protoOf(DynamicInput).o5v.call(this, tag);
          break $l$block_0;
        }
        // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedFloat.<anonymous>' call
        // Inline function 'kotlin.text.toFloatOrNull' call
        var this_0 = toString_1(value);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_elvis_lhs = toDoubleOrNull(this_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwIllegalKeyType(this, tag, value, 'float');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block_0;
      }
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedFloat.<anonymous>' call
      tmp$ret$1 = protoOf(DynamicInput).o5v.call(this, tag);
    }
    return tmp$ret$1;
  };
  protoOf(DynamicMapInput).o5v = function (tag) {
    return this.r6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicMapInput).s6d = function (tag) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeMapKey' call
      if (_get_isKey__g0dpic(this)) {
        var value = this.k6i(tag);
        if (!(typeof value === 'string')) {
          // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedDouble.<anonymous>' call
          tmp$ret$1 = protoOf(DynamicInput).p5v.call(this, tag);
          break $l$block_0;
        }
        // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedDouble.<anonymous>' call
        var $this$decodeMapKey = toString_1(value);
        var tmp0_elvis_lhs = toDoubleOrNull($this$decodeMapKey);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwIllegalKeyType(this, tag, value, 'double');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block_0;
      }
      // Inline function 'kotlinx.serialization.json.internal.DynamicMapInput.decodeTaggedDouble.<anonymous>' call
      tmp$ret$1 = protoOf(DynamicInput).p5v.call(this, tag);
    }
    return tmp$ret$1;
  };
  protoOf(DynamicMapInput).p5v = function (tag) {
    return this.s6d((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(DynamicMapInput).z5g = function (descriptor) {
    while (this.m6j_1 < (this.l6j_1 - 1 | 0)) {
      var tmp1 = this.m6j_1;
      this.m6j_1 = tmp1 + 1 | 0;
      var i = tmp1 / 2 | 0;
      var tmp = this.e6i_1[i];
      var name = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
      if (this.c6i_1[name] !== undefined)
        return this.m6j_1;
    }
    return -1;
  };
  protoOf(DynamicMapInput).i6i = function (tag) {
    return (this.m6j_1 % 2 | 0) === 0 ? tag : this.c6i_1[tag];
  };
  function JsonToStringWriter() {
    this.o65_1 = StringBuilder_init_$Create$(128);
  }
  protoOf(JsonToStringWriter).m63 = function (value) {
    this.o65_1.c9(value);
  };
  protoOf(JsonToStringWriter).v68 = function (char) {
    this.o65_1.e9(char);
  };
  protoOf(JsonToStringWriter).x68 = function (text) {
    this.o65_1.d9(text);
  };
  protoOf(JsonToStringWriter).g69 = function (text) {
    printQuoted(this.o65_1, text);
  };
  protoOf(JsonToStringWriter).vz = function () {
    this.o65_1.gd();
  };
  protoOf(JsonToStringWriter).toString = function () {
    return this.o65_1.toString();
  };
  function createMapForCache(initialCapacity) {
    return HashMap_init_$Create$_0(initialCapacity);
  }
  function DefaultNodeStorage() {
  }
  protoOf(DefaultNodeStorage).n6j = function (nodePointer, node) {
    return DocumentIdUtil_getInstance().p6j(node, nodePointer.documentId);
  };
  var DefaultNodeStorage_instance;
  function DefaultNodeStorage_getInstance() {
    return DefaultNodeStorage_instance;
  }
  function LocalNodePointerSupport$node$$inlined$query$1(this$0, $nodePointer) {
    this.q6j_1 = this$0;
    this.r6j_1 = $nodePointer;
  }
  protoOf(LocalNodePointerSupport$node$$inlined$query$1).d4x = function (builder) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'jetbrains.ocelot.langDef.model.LocalNodePointerSupport.node.<anonymous>' call
      var tmp0_elvis_lhs = builder.n51(this.q6j_1.t6j_1.v6j(this.r6j_1.documentId));
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = null;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var doc = tmp;
      var tmp1_elvis_lhs = (isInterface(doc, TypedOtNode) ? doc : THROW_CCE()).i3f();
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        throw IllegalStateException_init_$Create$_0('Document node ' + doc.w6j().n4z().qr() + ' is not attached to a model');
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var model = tmp_0;
      // Inline function 'kotlin.collections.getOrPut' call
      var this_0 = this.q6j_1.u6j_1;
      var value = this_0.y2(model);
      var tmp_1;
      if (value == null) {
        // Inline function 'jetbrains.ocelot.langDef.model.LocalNodePointerSupport.node.<anonymous>.<anonymous>' call
        var answer = new FindNodeQueryProvider(model);
        this_0.r2(model, answer);
        tmp_1 = answer;
      } else {
        tmp_1 = value;
      }
      var queryProvider = tmp_1;
      var tmp2_safe_receiver = builder.n51(queryProvider.a6k(this.r6j_1.nodeId));
      tmp$ret$0 = tmp2_safe_receiver == null ? null : toDomainNode(tmp2_safe_receiver, this.q6j_1.s6j_1);
    }
    return tmp$ret$0;
  };
  function LocalNodePointerSupport(wrapperContext, documentRepository) {
    this.s6j_1 = wrapperContext;
    this.t6j_1 = documentRepository;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.u6j_1 = HashMap_init_$Create$();
  }
  protoOf(LocalNodePointerSupport).b6k = function (nodePointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new LocalNodePointerSupport$node$$inlined$query$1(this, nodePointer);
  };
  protoOf(LocalNodePointerSupport).vr = function () {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.u6j_1.v2().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.model.LocalNodePointerSupport.dispose.<anonymous>' call
      element.vr();
    }
    this.u6j_1.m2();
  };
  function NodePointer_init_$Init$(documentId, nodeId, $this) {
    documentId = documentId === VOID ? '' : documentId;
    NodePointer.call($this, documentId, new NodeId(nodeId));
    return $this;
  }
  function NodePointerConstructor(documentId, nodeId) {
    return NodePointer_init_$Init$(documentId, nodeId, objectCreate(protoOf(NodePointer)));
  }
  function Companion_86() {
  }
  protoOf(Companion_86).h67 = function () {
    return NodePointerSerializer_getInstance();
  };
  var Companion_instance_86;
  function Companion_getInstance_86() {
    return Companion_instance_86;
  }
  function NodePointer(documentId, nodeId) {
    documentId = documentId === VOID ? '' : documentId;
    this.documentId = documentId;
    this.nodeId = nodeId;
  }
  protoOf(NodePointer).w6j = function () {
    return this.documentId;
  };
  protoOf(NodePointer).x3i = function () {
    return this.nodeId;
  };
  protoOf(NodePointer).toString = function () {
    return Companion_instance_87.c6k(this);
  };
  protoOf(NodePointer).ug = function () {
    return this.documentId;
  };
  protoOf(NodePointer).vg = function () {
    return this.nodeId;
  };
  protoOf(NodePointer).d6k = function (documentId, nodeId) {
    return new NodePointer(documentId, nodeId);
  };
  protoOf(NodePointer).copy = function (documentId, nodeId, $super) {
    documentId = documentId === VOID ? this.documentId : documentId;
    nodeId = nodeId === VOID ? this.nodeId : nodeId;
    return this.d6k(documentId, nodeId);
  };
  protoOf(NodePointer).hashCode = function () {
    var result = getStringHashCode(this.documentId);
    result = imul(result, 31) + this.nodeId.hashCode() | 0;
    return result;
  };
  protoOf(NodePointer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodePointer))
      return false;
    var tmp0_other_with_cast = other instanceof NodePointer ? other : THROW_CCE();
    if (!(this.documentId === tmp0_other_with_cast.documentId))
      return false;
    if (!this.nodeId.equals(tmp0_other_with_cast.nodeId))
      return false;
    return true;
  };
  function NodePointerSerializer() {
    NodePointerSerializer_instance = this;
    this.e6k_1 = PrimitiveSerialDescriptor(ensureNotNull(getKClass(NodePointer).lb()), STRING_getInstance());
    this.f6k_1 = _Char___init__impl__6a9atx(47);
  }
  protoOf(NodePointerSerializer).w5c = function () {
    return this.e6k_1;
  };
  protoOf(NodePointerSerializer).k5d = function (decoder) {
    var value = decoder.f5g();
    var cs = split(value, charArrayOf([_Char___init__impl__6a9atx(47)]), VOID, 2);
    if (!(cs.n() === 2)) {
      throw SerializationException_init_$Create$_0("Expected two components divided by '/' but got '" + value + "'");
    }
    return NodePointerConstructor(cs.q(0), cs.q(1));
  };
  protoOf(NodePointerSerializer).g6k = function (encoder, value) {
    return encoder.m5h(value.documentId + toString(_Char___init__impl__6a9atx(47)) + value.nodeId.i2s_1);
  };
  protoOf(NodePointerSerializer).j5d = function (encoder, value) {
    return this.g6k(encoder, value instanceof NodePointer ? value : THROW_CCE());
  };
  var NodePointerSerializer_instance;
  function NodePointerSerializer_getInstance() {
    if (NodePointerSerializer_instance == null)
      new NodePointerSerializer();
    return NodePointerSerializer_instance;
  }
  function Companion_87() {
  }
  protoOf(Companion_87).c6k = function (pointer) {
    // Inline function 'kotlinx.serialization.json.encodeToJsonElement' call
    var this_0 = Default_getInstance_1();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.h5d();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer_0(this_1, createKType(getKClass(NodePointer), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = this_0.m65(tmp$ret$1, pointer);
    return get_jsonPrimitive(tmp$ret$2).g67();
  };
  protoOf(Companion_87).w2p = function (pointer) {
    var tmp;
    try {
      var tmp0 = Default_getInstance_1();
      // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
      var json = JsonPrimitive_0(pointer);
      // Inline function 'kotlinx.serialization.serializer' call
      var this_0 = tmp0.h5d();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_1 = serializer_0(this_0, createKType(getKClass(NodePointer), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
      tmp = tmp0.n65(tmp$ret$1, json);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof SerializationException) {
        var e = $p;
        throw NodePointerFormatException_init_$Create$_0(e);
      } else {
        throw $p;
      }
    }
    return tmp;
  };
  var Companion_instance_87;
  function Companion_getInstance_87() {
    return Companion_instance_87;
  }
  function NodePointerFormatException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    NodePointerFormatException.call($this);
    return $this;
  }
  function NodePointerFormatException_init_$Create$() {
    var tmp = NodePointerFormatException_init_$Init$(objectCreate(protoOf(NodePointerFormatException)));
    captureStack(tmp, NodePointerFormatException_init_$Create$);
    return tmp;
  }
  function NodePointerFormatException_init_$Init$_0(cause, $this) {
    IllegalArgumentException_init_$Init$_2(cause, $this);
    NodePointerFormatException.call($this);
    return $this;
  }
  function NodePointerFormatException_init_$Create$_0(cause) {
    var tmp = NodePointerFormatException_init_$Init$_0(cause, objectCreate(protoOf(NodePointerFormatException)));
    captureStack(tmp, NodePointerFormatException_init_$Create$_0);
    return tmp;
  }
  function NodePointerFormatException() {
    captureStack(this, NodePointerFormatException);
  }
  function Companion_88() {
  }
  var Companion_instance_88;
  function Companion_getInstance_88() {
    return Companion_instance_88;
  }
  function NodePointersService(provider) {
    this.h6k_1 = provider;
  }
  protoOf(NodePointersService).i6k = function () {
    return this.h6k_1();
  };
  function EmptyNodeStorage() {
  }
  protoOf(EmptyNodeStorage).n6j = function (nodePointer, node) {
  };
  var EmptyNodeStorage_instance;
  function EmptyNodeStorage_getInstance() {
    return EmptyNodeStorage_instance;
  }
  function Companion_89() {
    Companion_instance_89 = this;
    this.j6k_1 = new NodeStorageService(EmptyNodeStorage_instance);
  }
  protoOf(Companion_89).g2o = function () {
    return this.j6k_1;
  };
  var Companion_instance_89;
  function Companion_getInstance_89() {
    if (Companion_instance_89 == null)
      new Companion_89();
    return Companion_instance_89;
  }
  function NodeStorageService(nodeStorage) {
    Companion_getInstance_89();
    this.k6k_1 = nodeStorage;
  }
  function get_OT_NODE_FACTORY_CONTEXT_KEY() {
    _init_properties_OtNodeFactoryService_kt__g7p7wy();
    return OT_NODE_FACTORY_CONTEXT_KEY;
  }
  var OT_NODE_FACTORY_CONTEXT_KEY;
  function OtNodeFactoryService() {
  }
  var OtNodeFactoryService_instance;
  function OtNodeFactoryService_getInstance() {
    return OtNodeFactoryService_instance;
  }
  function get_nodeFactory(_this__u8e3s4) {
    _init_properties_OtNodeFactoryService_kt__g7p7wy();
    var tmp0_elvis_lhs = _this__u8e3s4.o4u(get_OT_NODE_FACTORY_CONTEXT_KEY());
    return tmp0_elvis_lhs == null ? RawNodeFactory_instance : tmp0_elvis_lhs;
  }
  var properties_initialized_OtNodeFactoryService_kt_4iwfjo;
  function _init_properties_OtNodeFactoryService_kt__g7p7wy() {
    if (!properties_initialized_OtNodeFactoryService_kt_4iwfjo) {
      properties_initialized_OtNodeFactoryService_kt_4iwfjo = true;
      OT_NODE_FACTORY_CONTEXT_KEY = new WrapperContextKey('otNodeFactory');
    }
  }
  function Companion_90() {
  }
  protoOf(Companion_90).h67 = function () {
    return $serializer_getInstance();
  };
  var Companion_instance_90;
  function Companion_getInstance_90() {
    return Companion_instance_90;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.model.SerializedNode', this, 2);
    tmp0_serialDesc.t5n('content', false);
    tmp0_serialDesc.t5n('pointer', false);
    this.l6k_1 = tmp0_serialDesc;
  }
  protoOf($serializer).m6k = function (encoder, value) {
    var tmp0_desc = this.l6k_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.x5h(tmp0_desc, 0, value.content);
    tmp1_output.z5h(tmp0_desc, 1, NodePointerSerializer_getInstance(), value.pointer);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer).j5d = function (encoder, value) {
    return this.m6k(encoder, value instanceof SerializedNode ? value : THROW_CCE());
  };
  protoOf($serializer).k5d = function (decoder) {
    var tmp0_desc = this.l6k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.t5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, NodePointerSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.t5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, NodePointerSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return SerializedNode_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer).w5c = function () {
    return this.l6k_1;
  };
  protoOf($serializer).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), NodePointerSerializer_getInstance()];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function SerializedNode_init_$Init$(seen0, content, pointer, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance().l6k_1);
    }
    $this.content = content;
    $this.pointer = pointer;
    return $this;
  }
  function SerializedNode_init_$Create$(seen0, content, pointer, serializationConstructorMarker) {
    return SerializedNode_init_$Init$(seen0, content, pointer, serializationConstructorMarker, objectCreate(protoOf(SerializedNode)));
  }
  function SerializedNode(content, pointer) {
    this.content = content;
    this.pointer = pointer;
  }
  protoOf(SerializedNode).g67 = function () {
    return this.content;
  };
  protoOf(SerializedNode).n6k = function () {
    return this.pointer;
  };
  protoOf(SerializedNode).ug = function () {
    return this.content;
  };
  protoOf(SerializedNode).vg = function () {
    return this.pointer;
  };
  protoOf(SerializedNode).o6k = function (content, pointer) {
    return new SerializedNode(content, pointer);
  };
  protoOf(SerializedNode).copy = function (content, pointer, $super) {
    content = content === VOID ? this.content : content;
    pointer = pointer === VOID ? this.pointer : pointer;
    return this.o6k(content, pointer);
  };
  protoOf(SerializedNode).toString = function () {
    return 'SerializedNode(content=' + this.content + ', pointer=' + this.pointer.toString() + ')';
  };
  protoOf(SerializedNode).hashCode = function () {
    var result = getStringHashCode(this.content);
    result = imul(result, 31) + this.pointer.hashCode() | 0;
    return result;
  };
  protoOf(SerializedNode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedNode))
      return false;
    var tmp0_other_with_cast = other instanceof SerializedNode ? other : THROW_CCE();
    if (!(this.content === tmp0_other_with_cast.content))
      return false;
    if (!this.pointer.equals(tmp0_other_with_cast.pointer))
      return false;
    return true;
  };
  function otRoleData(_this__u8e3s4, $this) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!isInterface(_this__u8e3s4, OtChildProperty)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return _this__u8e3s4.h3b();
  }
  function otRoleData_0(_this__u8e3s4, $this) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!isInterface(_this__u8e3s4, OtChildrenList)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return _this__u8e3s4.h3b();
  }
  function DomainNodePersister(wrapperContext, nodeFactory) {
    this.p6k_1 = wrapperContext;
    this.q6k_1 = new NullPersisterForNullable();
    this.r6k_1 = new OTNodePersister(nodeFactory);
  }
  protoOf(DomainNodePersister).n2q = function () {
    return this.q6k_1;
  };
  protoOf(DomainNodePersister).s6k = function (value) {
    return this.r6k_1.v6k(toOtNode(value));
  };
  protoOf(DomainNodePersister).o2q = function (value) {
    return this.s6k((!(value == null) ? isInterface(value, DomainNode) : false) ? value : THROW_CCE());
  };
  protoOf(DomainNodePersister).p2q = function (value) {
    var tmp = toDomainNode(this.r6k_1.p2q(value), this.p6k_1);
    return isInterface(tmp, DomainNode) ? tmp : THROW_CCE();
  };
  protoOf(DomainNodePersister).w6k = function (node, link) {
    var tmp;
    if (link instanceof SingleChildLink) {
      tmp = otRoleData(link.a6l_1(node), this);
    } else {
      if (link instanceof MultipleChildLink) {
        tmp = otRoleData_0(link.y6k_1(node), this);
      } else {
        noWhenBranchMatchedException();
      }
    }
    var roleData = tmp;
    return OTLinkPersister_instance.b6l(roleData);
  };
  function FindNodeQueryProvider$createNodeRegisterListener$o$onRegister$lambda(it) {
    it.d28(Unit_instance);
    return Unit_instance;
  }
  function FindNodeQueryProvider$createNodeRegisterListener$o$onUnregister$lambda(it) {
    it.d28(Unit_instance);
    return Unit_instance;
  }
  function createNodeRegisterListener($this) {
    return $this.x6j_1.e3a(new FindNodeQueryProvider$createNodeRegisterListener$1($this));
  }
  function FindNodeQueryProvider$createNodeRegisterListener$1(this$0) {
    this.c6l_1 = this$0;
  }
  protoOf(FindNodeQueryProvider$createNodeRegisterListener$1).x39 = function (node) {
    if (node.w39()) {
      var tmp = node.v39();
      this.c6l_1.z6j_1.b2c(tmp, FindNodeQueryProvider$createNodeRegisterListener$o$onRegister$lambda);
    }
  };
  protoOf(FindNodeQueryProvider$createNodeRegisterListener$1).y39 = function (node) {
    if (node.w39()) {
      var tmp = node.v39();
      this.c6l_1.z6j_1.b2c(tmp, FindNodeQueryProvider$createNodeRegisterListener$o$onUnregister$lambda);
    }
  };
  function FindNodeQueryProvider$activeNodeQueries$1(this$0) {
    this.f6l_1 = this$0;
    ListenersMap.call(this);
    this.e6l_1 = 0;
  }
  protoOf(FindNodeQueryProvider$activeNodeQueries$1).g6l = function (element) {
    if (this.e6l_1 === 0) {
      this.f6l_1.y6j_1 = createNodeRegisterListener(this.f6l_1);
    }
    this.e6l_1 = this.e6l_1 + 1 | 0;
  };
  protoOf(FindNodeQueryProvider$activeNodeQueries$1).u2b = function (element) {
    return this.g6l(element instanceof NodeId ? element : THROW_CCE());
  };
  protoOf(FindNodeQueryProvider$activeNodeQueries$1).h6l = function (element) {
    this.e6l_1 = this.e6l_1 - 1 | 0;
    if (this.e6l_1 === 0) {
      ensureNotNull(this.f6l_1.y6j_1).vr();
      this.f6l_1.y6j_1 = null;
    }
  };
  protoOf(FindNodeQueryProvider$activeNodeQueries$1).v2b = function (element) {
    return this.h6l(element instanceof NodeId ? element : THROW_CCE());
  };
  function FindNodeQueryProvider$findNode$1(this$0, $id) {
    this.i6l_1 = this$0;
    this.j6l_1 = $id;
  }
  protoOf(FindNodeQueryProvider$findNode$1).k6l = function (handler) {
    return this.i6l_1.z6j_1.a2c(this.j6l_1, handler);
  };
  protoOf(FindNodeQueryProvider$findNode$1).o27 = function (handler) {
    return this.k6l(handler);
  };
  function FindNodeQueryProvider$findNode$$inlined$query$1(this$0, $id) {
    this.l6l_1 = this$0;
    this.m6l_1 = $id;
  }
  protoOf(FindNodeQueryProvider$findNode$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.ot.FindNodeQueryProvider.findNode.<anonymous>' call
    builder.g4x_1.e4x_1.n4v(new FindNodeQueryProvider$findNode$1(this.l6l_1, this.m6l_1), Invalidation_getInstance().v4u_1);
    return this.l6l_1.x6j_1.c3a(this.m6l_1);
  };
  function FindNodeQueryProvider(model) {
    this.x6j_1 = model;
    this.y6j_1 = null;
    var tmp = this;
    tmp.z6j_1 = new FindNodeQueryProvider$activeNodeQueries$1(this);
  }
  protoOf(FindNodeQueryProvider).a6k = function (id) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new FindNodeQueryProvider$findNode$$inlined$query$1(this, id);
  };
  protoOf(FindNodeQueryProvider).vr = function () {
    var tmp0_safe_receiver = this.y6j_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.vr();
    }
    this.z6j_1.m2();
  };
  function OTLinkPersister() {
  }
  protoOf(OTLinkPersister).b6l = function (value) {
    var concept = value.ug();
    var role = value.vg();
    return serializeWithChildId(new PersistableLink(concept, role));
  };
  var OTLinkPersister_instance;
  function OTLinkPersister_getInstance() {
    return OTLinkPersister_instance;
  }
  function serializeWithChildId(_this__u8e3s4) {
    return _this__u8e3s4.r6l(NodeIdModelKinds_getInstance().y37_1);
  }
  function _get_conceptIdPersister__p620bx($this) {
    return (new NodeIdPersistenceContext()).m37(NodeIdModelKinds_getInstance().w37_1);
  }
  function Companion_91() {
    this.s6l_1 = '/';
  }
  var Companion_instance_91;
  function Companion_getInstance_91() {
    return Companion_instance_91;
  }
  function PersistableLink(concept, role) {
    this.p6l_1 = concept;
    this.q6l_1 = role;
  }
  protoOf(PersistableLink).r6l = function (idKind) {
    var roleIdPersister = (new NodeIdPersistenceContext()).m37(idKind);
    return plus_10(_get_conceptIdPersister__p620bx(Companion_instance_91).x2p(this.p6l_1), '/') + roleIdPersister.x2p(this.q6l_1);
  };
  protoOf(PersistableLink).toString = function () {
    return 'PersistableLink(concept=' + this.p6l_1.toString() + ', role=' + toString_1(this.q6l_1) + ')';
  };
  protoOf(PersistableLink).hashCode = function () {
    var result = this.p6l_1.hashCode();
    result = imul(result, 31) + this.q6l_1.hashCode() | 0;
    return result;
  };
  protoOf(PersistableLink).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PersistableLink))
      return false;
    var tmp0_other_with_cast = other instanceof PersistableLink ? other : THROW_CCE();
    if (!this.p6l_1.equals(tmp0_other_with_cast.p6l_1))
      return false;
    if (!equals(this.q6l_1, tmp0_other_with_cast.q6l_1))
      return false;
    return true;
  };
  function OTNodePersister(nodeFactory) {
    this.t6k_1 = nodeFactory;
    this.u6k_1 = new NullPersisterForNullable();
  }
  protoOf(OTNodePersister).n2q = function () {
    return this.u6k_1;
  };
  protoOf(OTNodePersister).v6k = function (value) {
    return (new Node2JsonConverter(new NodeIdPersistenceContext())).x38(value).toString();
  };
  protoOf(OTNodePersister).o2q = function (value) {
    return this.v6k(value instanceof OtNode ? value : THROW_CCE());
  };
  protoOf(OTNodePersister).p2q = function (value) {
    var jsonBytes = encodeToByteArray(value);
    var tmp = CommonJsonStreamIterSupport_instance.b2y(jsonBytes);
    var jsonArrayReader = isInterface(tmp, JsonArrayReader) ? tmp : THROW_CCE();
    return (new Json2NodeConverter(new NodeIdPersistenceContext(), this.t6k_1)).s37(jsonArrayReader);
  };
  function Companion_92() {
  }
  var Companion_instance_92;
  function Companion_getInstance_92() {
    return Companion_instance_92;
  }
  function SameModelNodeFinder$find$$inlined$map$1($this, this$0) {
    this.t6l_1 = $this;
    this.u6l_1 = this$0;
  }
  protoOf(SameModelNodeFinder$find$$inlined$map$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.query.map.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.ot.SameModelNodeFinder.find.<anonymous>' call
    var tmp0_safe_receiver = builder.n51(this.t6l_1);
    return tmp0_safe_receiver == null ? null : toDomainNode(tmp0_safe_receiver, this.u6l_1.v6l_1);
  };
  function SameModelNodeFinder(wrapperContext) {
    this.v6l_1 = wrapperContext;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.w6l_1 = HashMap_init_$Create$();
  }
  protoOf(SameModelNodeFinder).x6l = function (source, refContents) {
    var tmp0_elvis_lhs = (isInterface(source, TypedOtNode) ? source : THROW_CCE()).i3f();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance_76().i51_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var model = tmp;
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.w6l_1;
    var value = this_0.y2(model);
    var tmp_0;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.langDef.ot.SameModelNodeFinder.find.<anonymous>' call
      var answer = new FindNodeQueryProvider(model);
      this_0.r2(model, answer);
      tmp_0 = answer;
    } else {
      tmp_0 = value;
    }
    var queryProvider = tmp_0;
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_1 = queryProvider.a6k(refContents.y6l_1);
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new SameModelNodeFinder$find$$inlined$map$1(this_1, this);
  };
  protoOf(SameModelNodeFinder).z6l = function (source, refContents) {
    return this.x6l(source, refContents instanceof LocalReferenceContent ? refContents : THROW_CCE());
  };
  protoOf(SameModelNodeFinder).vr = function () {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.w6l_1.v2().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.ot.SameModelNodeFinder.dispose.<anonymous>' call
      element.vr();
    }
    this.w6l_1.m2();
  };
  function reset_1($this, newModel, newFindNodeQueryProvider) {
    var oldFindNodeQueryProvider = $this.d6m_1;
    $this.c6m_1 = newModel;
    $this.d6m_1 = newFindNodeQueryProvider;
    if (oldFindNodeQueryProvider == null)
      null;
    else {
      oldFindNodeQueryProvider.vr();
    }
  }
  function Companion_93() {
    Companion_instance_93 = this;
    this.e6m_1 = getLogger(getKClass(SingleRootNodePointerSupport));
  }
  var Companion_instance_93;
  function Companion_getInstance_93() {
    if (Companion_instance_93 == null)
      new Companion_93();
    return Companion_instance_93;
  }
  function SingleRootNodePointerSupport$node$$inlined$query$1(this$0, $nodePointer) {
    this.f6m_1 = this$0;
    this.g6m_1 = $nodePointer;
  }
  protoOf(SingleRootNodePointerSupport$node$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.ot.SingleRootNodePointerSupport.node.<anonymous>' call
    var tmp0_safe_receiver = this.f6m_1.d6m_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a6k(this.g6m_1.nodeId);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : builder.n51(tmp1_safe_receiver);
    return tmp2_safe_receiver == null ? null : toDomainNode(tmp2_safe_receiver, this.f6m_1.b6m_1);
  };
  function SingleRootNodePointerSupport(wrapperContext) {
    Companion_getInstance_93();
    this.b6m_1 = wrapperContext;
    this.c6m_1 = null;
    this.d6m_1 = null;
  }
  protoOf(SingleRootNodePointerSupport).b6k = function (nodePointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new SingleRootNodePointerSupport$node$$inlined$query$1(this, nodePointer);
  };
  protoOf(SingleRootNodePointerSupport).h6m = function (newModel) {
    reset_1(this, newModel, new FindNodeQueryProvider(newModel));
  };
  protoOf(SingleRootNodePointerSupport).vr = function () {
    reset_1(this, null, null);
  };
  function otConceptDataFor($this, conceptId) {
    return otConceptRegistry($this.b4t_1).i6m(conceptId);
  }
  function toChildProperty(_this__u8e3s4, $this, otRoleId) {
    return new OTChildPropertyAdapter(_this__u8e3s4, $this, new OTRoleData($this.c4t_1.a38_1, otRoleId));
  }
  function toChildrenList(_this__u8e3s4, $this, otRoleId) {
    return new OTChildrenListAdapter(_this__u8e3s4, $this, new OTRoleData($this.c4t_1.a38_1, otRoleId));
  }
  function BaseNodeGen$getDescendants$lambda(it) {
    return !(it == null) ? isInterface(it, DomainNode) : false;
  }
  function BaseNodeGen$getAllChildren$lambda(it) {
    return !(it == null) ? isInterface(it, DomainNode) : false;
  }
  function BaseNodeGen(context, node) {
    NodeWrapper.call(this, context, node);
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.l6m_1 = HashMap_init_$Create$();
  }
  protoOf(BaseNodeGen).m6m = function () {
    var tmp = this.f33();
    return isInterface(tmp, ReadableProperty) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).yt = function () {
    return this.m6m().qr();
  };
  protoOf(BaseNodeGen).n6m = function () {
    var tmp0_safe_receiver = this.c4t_1.z39();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a38_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var parentConcept = tmp;
    var tmp2_elvis_lhs = this.c4t_1.h3b();
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var otRole = tmp_0;
    var tmp_1 = otConceptDataFor(this, parentConcept).o6m(otRole);
    return (tmp_1 == null ? true : tmp_1 instanceof ChildLink) ? tmp_1 : THROW_CCE();
  };
  protoOf(BaseNodeGen).h3f = function () {
    return this.c4t_1.a38_1;
  };
  protoOf(BaseNodeGen).u3o = function () {
    var tmp0_safe_receiver = this.i3f();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.ot.structure.BaseNodeGen.<get-root>.<anonymous>' call
      var tmp_0 = this.b4t_1.m4u(tmp0_safe_receiver.g30_1, getKClass(NodeWrapper));
      tmp = isInterface(tmp_0, DocumentNode) ? tmp_0 : null;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
      var tmp$ret$2 = ancestorOrSelf(this, getKClass(DocumentNode));
      tmp_1 = execute_0(tmp$ret$2);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  };
  protoOf(BaseNodeGen).p6m = function (tag, reference) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.l6m_1;
    // Inline function 'kotlin.check' call
    if (!!(isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w2(tag)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    // Inline function 'kotlin.collections.set' call
    this.l6m_1.r2(tag, reference);
  };
  protoOf(BaseNodeGen).q6m = function () {
    return this.l6m_1;
  };
  protoOf(BaseNodeGen).r6m = function (tag) {
    var tmp = this.l6m_1.y2(tag);
    return (!(tmp == null) ? isInterface(tmp, Reference) : false) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).s6m = function (new_0) {
    return this.t4t(new_0 instanceof BaseNodeGen ? new_0 : THROW_CCE());
  };
  protoOf(BaseNodeGen).t6m = function () {
    return this.n3b();
  };
  protoOf(BaseNodeGen).u6m = function () {
    var tmp = this.u4t();
    return (!(tmp == null) ? isInterface(tmp, DomainNode) : false) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).v6m = function (includeSelf) {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = this.o3b(includeSelf);
    var tmp = filter(this_0, BaseNodeGen$getDescendants$lambda);
    return isInterface(tmp, Sequence) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).w6m = function () {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = this.p3b();
    var tmp = filter(this_0, BaseNodeGen$getAllChildren$lambda);
    return isInterface(tmp, Sequence) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).x6m = function (propertyId) {
    return get_forQueries(this.o4t(propertyId, Persisters_getInstance().y2q('')));
  };
  protoOf(BaseNodeGen).y6m = function (propertyId) {
    return get_forQueries(this.n4t(propertyId));
  };
  protoOf(BaseNodeGen).z6m = function (propertyId) {
    return this.b6n(propertyId, AttributePersisters_getInstance().a6n_1);
  };
  protoOf(BaseNodeGen).c6n = function (propertyId) {
    return get_forQueries(this.p4t(propertyId));
  };
  protoOf(BaseNodeGen).d6n = function (propertyId) {
    return get_forQueries_0(this.f3b(propertyId));
  };
  protoOf(BaseNodeGen).b6n = function (propertyId, persister) {
    return get_forQueries(this.o4t(propertyId, persister));
  };
  protoOf(BaseNodeGen).e6n = function (childId) {
    var tmp = get_forQueries(this.q4t(childId));
    return isInterface(tmp, QProperty) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).f6n = function (childLink) {
    var tmp = toChildProperty(this.q4t(childLink.h6n_1), this, childLink.h6n_1);
    return isInterface(tmp, ChildProperty) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).i6n = function (childrenId) {
    var tmp = get_forQueries_1(this.r4t(childrenId));
    return isInterface(tmp, QMutableListBase) ? tmp : THROW_CCE();
  };
  protoOf(BaseNodeGen).j6n = function (childrenLink) {
    var tmp = toChildrenList(this.r4t(childrenLink.h6n_1), this, childrenLink.h6n_1);
    return isInterface(tmp, ChildrenList) ? tmp : THROW_CCE();
  };
  function OTChildLink(childLink, roleId) {
    this.g6n_1 = childLink;
    this.h6n_1 = roleId;
  }
  function OTChildPropertyAdapter(observable, parent, role) {
    QPropertyAdapter.call(this, observable);
    this.l6n_1 = parent;
    this.m6n_1 = role;
  }
  protoOf(OTChildPropertyAdapter).h3b = function () {
    return this.m6n_1;
  };
  function OTRoleData(conceptId, roleId) {
    this.n6l_1 = conceptId;
    this.o6l_1 = roleId;
  }
  protoOf(OTRoleData).ug = function () {
    return this.n6l_1;
  };
  protoOf(OTRoleData).vg = function () {
    return this.o6l_1;
  };
  protoOf(OTRoleData).toString = function () {
    return 'OTRoleData(conceptId=' + this.n6l_1.toString() + ', roleId=' + this.o6l_1.toString() + ')';
  };
  protoOf(OTRoleData).hashCode = function () {
    var result = this.n6l_1.hashCode();
    result = imul(result, 31) + this.o6l_1.hashCode() | 0;
    return result;
  };
  protoOf(OTRoleData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OTRoleData))
      return false;
    var tmp0_other_with_cast = other instanceof OTRoleData ? other : THROW_CCE();
    if (!this.n6l_1.equals(tmp0_other_with_cast.n6l_1))
      return false;
    if (!this.o6l_1.equals(tmp0_other_with_cast.o6l_1))
      return false;
    return true;
  };
  function OTChildrenListAdapter(observable, parent, role) {
    QMutableListAdapter.call(this, observable);
    this.o6n_1 = parent;
    this.p6n_1 = role;
  }
  protoOf(OTChildrenListAdapter).yt = function () {
    return this.o6n_1;
  };
  protoOf(OTChildrenListAdapter).h3b = function () {
    return this.p6n_1;
  };
  function get_child(_this__u8e3s4) {
    return NodeChildIdFactory_getInstance().f3c(_this__u8e3s4, _this__u8e3s4);
  }
  function get_property(_this__u8e3s4) {
    return NodePropertyIdFactory_getInstance().w3c(_this__u8e3s4, _this__u8e3s4);
  }
  function get_children(_this__u8e3s4) {
    return NodeChildIdFactory_getInstance().a3c(_this__u8e3s4, _this__u8e3s4);
  }
  function referenceProperty($this, referencePropertyDescriptor) {
    return new DomainNodeReferenceProperty($this, referencePropertyDescriptor);
  }
  function BaseTypedOtNode$getDescendants$lambda(it) {
    return !(it == null) ? isInterface(it, DomainNode) : false;
  }
  function BaseTypedOtNode$getAllChildren$lambda(it) {
    return !(it == null) ? isInterface(it, DomainNode) : false;
  }
  function BaseTypedOtNode(context, nodeConceptId, nodeId) {
    OtNode.call(this, nodeConceptId, nodeId);
    this.a6o_1 = context;
    this.b6o_1 = null;
  }
  protoOf(BaseTypedOtNode).u3o = function () {
    var tmp0_safe_receiver = this.c38_1;
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g30_1;
    var tmp1_elvis_lhs = (!(tmp == null) ? isInterface(tmp, DocumentNode) : false) ? tmp : null;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
      var tmp$ret$0 = ancestorOrSelf(this, getKClass(DocumentNode));
      tmp_0 = execute_0(tmp$ret$0);
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(BaseTypedOtNode).m6m = function () {
    var tmp = this.f33();
    return isInterface(tmp, ReadableProperty) ? tmp : THROW_CCE();
  };
  protoOf(BaseTypedOtNode).n6m = function () {
    var tmp0_safe_receiver = this.z39();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a38_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var parentConceptId = tmp;
    var tmp2_elvis_lhs = this.h3b();
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var childId = tmp_0;
    var tmp_1 = getChildLink(this.a6o_1.c6o_1, parentConceptId, childId);
    return tmp_1 instanceof ChildLink ? tmp_1 : null;
  };
  protoOf(BaseTypedOtNode).y2z = function () {
    return !(this.b6o_1 == null) ? setOf(DocumentIdUtil_getInstance().o6j_1) : emptySet();
  };
  protoOf(BaseTypedOtNode).v2z = function () {
    return emptySet();
  };
  protoOf(BaseTypedOtNode).np = function () {
    var tmp;
    var tmp0 = this.y2z();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.p();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.langDef.ot.structure.BaseTypedOtNode.<get-isEmpty>.<anonymous>' call
        if (!(this.g39(element) == null)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    if (tmp$ret$0) {
      var tmp2 = this.v2z();
      var tmp$ret$2;
      $l$block_2: {
        // Inline function 'kotlin.collections.all' call
        var tmp_1;
        if (isInterface(tmp2, Collection)) {
          tmp_1 = tmp2.p();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$2 = true;
          break $l$block_2;
        }
        var _iterator__ex2g4s_0 = tmp2.k();
        while (_iterator__ex2g4s_0.l()) {
          var element_0 = _iterator__ex2g4s_0.m();
          // Inline function 'jetbrains.ocelot.langDef.ot.structure.BaseTypedOtNode.<get-isEmpty>.<anonymous>' call
          if (!this.l38(element_0).p()) {
            tmp$ret$2 = false;
            break $l$block_2;
          }
        }
        tmp$ret$2 = true;
      }
      tmp = tmp$ret$2;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(BaseTypedOtNode).e6o = function () {
    return this.a6o_1.c6o_1.i6m(this.a38_1);
  };
  protoOf(BaseTypedOtNode).u6m = function () {
    var tmp = this.m3b();
    return isInterface(tmp, DomainNode) ? tmp : THROW_CCE();
  };
  protoOf(BaseTypedOtNode).s6m = function (new_0) {
    this.q3b(new_0 instanceof OtNode ? new_0 : THROW_CCE());
  };
  protoOf(BaseTypedOtNode).t6m = function () {
    this.n3b();
  };
  protoOf(BaseTypedOtNode).v6m = function (includeSelf) {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = this.o3b(includeSelf);
    var tmp = filter(this_0, BaseTypedOtNode$getDescendants$lambda);
    return isInterface(tmp, Sequence) ? tmp : THROW_CCE();
  };
  protoOf(BaseTypedOtNode).w6m = function () {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = this.p3b();
    var tmp = filter(this_0, BaseTypedOtNode$getAllChildren$lambda);
    return isInterface(tmp, Sequence) ? tmp : THROW_CCE();
  };
  protoOf(BaseTypedOtNode).q6m = function () {
    // Inline function 'kotlin.collections.associate' call
    var this_0 = this.e6o().f6o();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.ot.structure.BaseTypedOtNode.getReferences.<anonymous>' call
      var tmp = element.j6o_1.h6o_1;
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.k6o_1, (isInterface(tmp, KProperty1) ? tmp : THROW_CCE())(this));
      destination.r2(pair.dh_1, pair.eh_1);
    }
    return destination;
  };
  protoOf(BaseTypedOtNode).r6m = function (tag) {
    // Inline function 'kotlin.collections.single' call
    var single = null;
    var found = false;
    var _iterator__ex2g4s = this.e6o().f6o().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.ot.structure.BaseTypedOtNode.getReference.<anonymous>' call
      if (element.k6o_1.equals(tag)) {
        if (found)
          throw IllegalArgumentException_init_$Create$_0('Collection contains more than one matching element.');
        single = element;
        found = true;
      }
    }
    if (!found)
      throw NoSuchElementException_init_$Create$_0('Collection contains no element matching the predicate.');
    var referenceLink = ((single == null ? true : !(single == null)) ? single : THROW_CCE()).j6o_1;
    var tmp = referenceLink.h6o_1;
    return (isInterface(tmp, KProperty1) ? tmp : THROW_CCE())(this);
  };
  protoOf(BaseTypedOtNode).g39 = function (propertyId) {
    if (propertyId.equals(DocumentIdUtil_getInstance().o6j_1)) {
      return this.b6o_1;
    }
    return this.l6o(propertyId);
  };
  protoOf(BaseTypedOtNode).l6o = function (propertyId) {
    // Inline function 'kotlin.error' call
    var message = 'Unexpected property ' + propertyId.b3() + ' in node ' + this.toString();
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(BaseTypedOtNode).e3b = function (propertyId, value, oldValue) {
    if (oldValue == value)
      return true;
    if (propertyId.equals(DocumentIdUtil_getInstance().o6j_1)) {
      this.b6o_1 = value;
      return false;
    }
    this.m6o(propertyId, value);
    return false;
  };
  protoOf(BaseTypedOtNode).m6o = function (propertyId, value) {
    // Inline function 'kotlin.error' call
    var message = 'Unexpected property ' + propertyId.b3() + ' in node ' + this.toString();
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(BaseTypedOtNode).l38 = function (childId) {
    // Inline function 'kotlin.error' call
    var message = 'Unexpected child ' + childId.b3() + ' in node ' + this.toString();
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(BaseTypedOtNode).n6o = function (propertyDescriptor) {
    return new DomainNodeProperty(this, propertyDescriptor);
  };
  protoOf(BaseTypedOtNode).o6o = function (textPropertyDescriptor) {
    return new DomainNodeTextProperty(this, textPropertyDescriptor);
  };
  protoOf(BaseTypedOtNode).p6o = function (referencePropertyDescriptor) {
    var referenceProperty_0 = referenceProperty(this, referencePropertyDescriptor);
    var tmp = getReferenceTag(this.e6o(), referencePropertyDescriptor.q6o_1);
    var tmp0_elvis_lhs = tmp instanceof RefTag ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var message = 'Failed to get reference tag ' + referencePropertyDescriptor.q6o_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var refTag = tmp_0;
    var reference = createReference_0(this.a6o_1.d6o_1, refTag, this, referenceProperty_0);
    return reference;
  };
  protoOf(BaseTypedOtNode).t6o = function (childPropertyDescriptor) {
    var list = new ChildrenObservableList(this, childPropertyDescriptor.u6o_1);
    list.n27(this);
    return list;
  };
  protoOf(BaseTypedOtNode).v6o = function (childrenObservableList) {
    return new DomainNodeChildProperty(isInterface(childrenObservableList, MutableObservableCollection) ? childrenObservableList : THROW_CCE());
  };
  protoOf(BaseTypedOtNode).w6o = function (childrenPropertyDescriptor) {
    var list = new ChildrenObservableList(this, childrenPropertyDescriptor.x6o_1);
    list.n27(this);
    return list;
  };
  protoOf(BaseTypedOtNode).y6o = function (childrenObservableList) {
    return new DomainNodeChildrenProperty(isInterface(childrenObservableList, MutableObservableList) ? childrenObservableList : THROW_CCE());
  };
  function get_OT_CONCEPT_REGISTRY_CONTEXT_KEY() {
    _init_properties_ConceptRegistry_kt__idoyjx();
    return OT_CONCEPT_REGISTRY_CONTEXT_KEY;
  }
  var OT_CONCEPT_REGISTRY_CONTEXT_KEY;
  function otConceptRegistry(_this__u8e3s4) {
    _init_properties_ConceptRegistry_kt__idoyjx();
    return _this__u8e3s4.n4u(get_OT_CONCEPT_REGISTRY_CONTEXT_KEY());
  }
  function getChildLink(_this__u8e3s4, conceptId, roleId) {
    _init_properties_ConceptRegistry_kt__idoyjx();
    return _this__u8e3s4.i6m(conceptId).o6m(roleId);
  }
  function createInstance(_this__u8e3s4, sourceClass, context) {
    _init_properties_ConceptRegistry_kt__idoyjx();
    return _this__u8e3s4.z6o(sourceClass).b6p(context.n4u(Companion_getInstance_94().a6p_1));
  }
  function NodeWrapperConceptRegistry() {
  }
  var properties_initialized_ConceptRegistry_kt_hz306j;
  function _init_properties_ConceptRegistry_kt__idoyjx() {
    if (!properties_initialized_ConceptRegistry_kt_hz306j) {
      properties_initialized_ConceptRegistry_kt_hz306j = true;
      OT_CONCEPT_REGISTRY_CONTEXT_KEY = new WrapperContextKey('otConceptRegistry');
    }
  }
  function Companion_94() {
    Companion_instance_94 = this;
    this.a6p_1 = new WrapperContextKey('NODE_SETUP');
  }
  var Companion_instance_94;
  function Companion_getInstance_94() {
    if (Companion_instance_94 == null)
      new Companion_94();
    return Companion_instance_94;
  }
  function NodeSetupContext(wrapperContext, referenceFactoryRegistry) {
    Companion_getInstance_94();
    this.h6p_1 = wrapperContext;
    this.i6p_1 = referenceFactoryRegistry;
  }
  protoOf(NodeSetupContext).j6p = function (referencePropertyId, source) {
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.NodeSetupContext.createReference' call
    var tmp = getReferenceTag(otConceptRegistry(this.h6p_1).i6m(source.h3f()), referencePropertyId);
    var refTag = (tmp == null ? true : tmp instanceof RefTag) ? tmp : THROW_CCE();
    // Inline function 'kotlin.check' call
    if (!!(refTag == null)) {
      // Inline function 'jetbrains.ocelot.langDef.ot.structure.NodeSetupContext.createReference.<anonymous>' call
      var message = "reference property id is not registered: '" + referencePropertyId.toString() + "' for source: '" + source.toString() + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.NodeSetupContext.taggedReference.<anonymous>' call
    var tmp$ret$1 = get_forQueries(source.o4t(referencePropertyId, ReferenceContentPersisters_getInstance().s6p(refTag.m6p_1)));
    var reference = createReference(this.i6p_1, refTag, source, tmp$ret$1);
    var tmp0_safe_receiver = source instanceof BaseNodeGen ? source : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p6m(refTag, reference);
    }
    return reference;
  };
  function NodeSetupContextService() {
  }
  var NodeSetupContextService_instance;
  function NodeSetupContextService_getInstance() {
    return NodeSetupContextService_instance;
  }
  function registerMember($this, id, property) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = $this.y6p_1;
    // Inline function 'kotlin.check' call
    if (!!(isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w2(id)) {
      // Inline function 'jetbrains.ocelot.langDef.ot.structure.OTAbstractConceptDescriptor.registerMember.<anonymous>' call
      var message = 'Duplicate member id: ' + id.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.collections.set' call
    $this.y6p_1.r2(id, property);
  }
  function Companion_95() {
  }
  protoOf(Companion_95).z6p = function (descriptors) {
    return listOf_0(descriptors.slice());
  };
  var Companion_instance_95;
  function Companion_getInstance_95() {
    return Companion_instance_95;
  }
  function OTAbstractConceptDescriptor(superConcepts) {
    superConcepts = superConcepts === VOID ? emptyList() : superConcepts;
    this.t6p_1 = superConcepts;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.u6p_1 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.v6p_1 = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.w6p_1 = LinkedHashMap_init_$Create$();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_2.x6p_1 = LinkedHashMap_init_$Create$();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_3.y6p_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(OTAbstractConceptDescriptor).a6q = function (link, name) {
    var id = get_property(name);
    // Inline function 'kotlin.check' call
    if (!!this.u6p_1.w2(id)) {
      // Inline function 'jetbrains.ocelot.langDef.ot.structure.OTAbstractConceptDescriptor.textProperty.<anonymous>' call
      var message = 'Duplicate property(attribute) id: ' + name;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.collections.set' call
    this.u6p_1.r2(id, link);
    registerMember(this, id, link.c6q_1);
    return id;
  };
  protoOf(OTAbstractConceptDescriptor).d6q = function (link, name) {
    var id = NodeChildIdFactory_getInstance().f3c(name, name);
    // Inline function 'kotlin.check' call
    if (!!this.v6p_1.w2(id)) {
      // Inline function 'jetbrains.ocelot.langDef.ot.structure.OTAbstractConceptDescriptor.childRole.<anonymous>' call
      var message = 'Duplicate child role id: ' + name;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.collections.set' call
    this.v6p_1.r2(id, link);
    registerMember(this, id, link.a6l_1);
    return new OTChildLink(link, id);
  };
  protoOf(OTAbstractConceptDescriptor).e6q = function (link, name) {
    var id = NodeChildIdFactory_getInstance().a3c(name, name);
    // Inline function 'kotlin.check' call
    if (!!this.v6p_1.w2(id)) {
      // Inline function 'jetbrains.ocelot.langDef.ot.structure.OTAbstractConceptDescriptor.childrenRole.<anonymous>' call
      var message = 'Duplicate children role id: ' + name;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.collections.set' call
    this.v6p_1.r2(id, link);
    registerMember(this, id, link.y6k_1);
    return new OTChildLink(link, id);
  };
  protoOf(OTAbstractConceptDescriptor).f6q = function (link, tag, name) {
    // Inline function 'kotlin.also' call
    var this_0 = NodePropertyIdFactory_getInstance().x3c(name);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.OTAbstractConceptDescriptor.referenceRole.<anonymous>' call
    // Inline function 'kotlin.check' call
    if (!!this.x6p_1.w2(this_0)) {
      // Inline function 'jetbrains.ocelot.langDef.ot.structure.OTAbstractConceptDescriptor.referenceRole.<anonymous>.<anonymous>' call
      var message = 'Duplicate reference role id: ' + name;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp1 = this.x6p_1;
    // Inline function 'kotlin.collections.set' call
    var value = new ReferenceData(link, tag);
    tmp1.r2(this_0, value);
    registerMember(this, this_0, link.h6o_1);
    return this_0;
  };
  protoOf(OTAbstractConceptDescriptor).g6q = function (property, name) {
    // Inline function 'kotlin.also' call
    var this_0 = get_property(name);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.OTAbstractConceptDescriptor.propertyId.<anonymous>' call
    registerMember(this, this_0, property);
    return this_0;
  };
  protoOf(OTAbstractConceptDescriptor).h6q = function (property, name) {
    // Inline function 'kotlin.also' call
    var this_0 = get_child(name);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.OTAbstractConceptDescriptor.childId.<anonymous>' call
    registerMember(this, this_0, property);
    return this_0;
  };
  protoOf(OTAbstractConceptDescriptor).i6q = function (property, name) {
    // Inline function 'kotlin.also' call
    var this_0 = get_children(name);
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.OTAbstractConceptDescriptor.childrenId.<anonymous>' call
    registerMember(this, this_0, property);
    return this_0;
  };
  function OTConcept() {
  }
  function DomainNodeFactory() {
  }
  function getReferenceTag(_this__u8e3s4, propertyId) {
    var tmp0_safe_receiver = _this__u8e3s4.k6q(propertyId);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k6o_1;
  }
  function OTConceptWrapper() {
  }
  function DomainNodeWrapperFactory() {
  }
  function getReferenceLink(_this__u8e3s4, propertyId) {
    var tmp0_safe_receiver = _this__u8e3s4.k6q(propertyId);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j6o_1;
  }
  function otConceptByDescriptor(definitionClass, implementationClass, descriptor, useExperimentalNode) {
    useExperimentalNode = useExperimentalNode === VOID ? false : useExperimentalNode;
    var idMapping = otIdMapping(descriptor);
    var tmp;
    if (useExperimentalNode) {
      var tmp_0;
      if (descriptor instanceof OtConceptDescriptor) {
        tmp_0 = new DomainNodeFactoryImpl(descriptor);
      } else {
        tmp_0 = ErrorNodeFactory_instance.p6q();
      }
      var factory = tmp_0;
      tmp = new OTConceptImpl(definitionClass, implementationClass, factory, idMapping);
    } else {
      var tmp_1;
      if (descriptor instanceof OtConceptDescriptor) {
        tmp_1 = new DomainNodeWrapperFactoryImpl(descriptor);
      } else {
        tmp_1 = ErrorNodeFactory_instance.p6q();
      }
      var factory_0 = tmp_1;
      tmp = new OTConceptWrapperImpl(definitionClass, implementationClass, factory_0, idMapping);
    }
    return tmp;
  }
  function otIdMapping(descriptor) {
    var own = new IdMapping(descriptor);
    // Inline function 'kotlin.collections.fold' call
    var accumulator = own;
    var _iterator__ex2g4s = descriptor.t6p_1.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.ot.structure.otIdMapping.<anonymous>' call
      var acc = accumulator;
      accumulator = plus_11(acc, otIdMapping(element));
    }
    return accumulator;
  }
  function OTConceptImpl(definitionClass, implementationClass, factory, idMapping) {
    this.q6q_1 = factory;
    this.r6q_1 = idMapping;
    this.s6q_1 = definitionClass;
    this.t6q_1 = implementationClass;
  }
  protoOf(OTConceptImpl).j6q = function () {
    return this.t6q_1;
  };
  protoOf(OTConceptImpl).n6q = function (nodeSetupContext, id) {
    return this.q6q_1.n6q(nodeSetupContext, id);
  };
  protoOf(OTConceptImpl).f6o = function () {
    return this.r6q_1.f6o();
  };
  protoOf(OTConceptImpl).o6m = function (roleId) {
    return this.r6q_1.o6m(roleId);
  };
  protoOf(OTConceptImpl).k6q = function (propertyId) {
    return this.r6q_1.k6q(propertyId);
  };
  protoOf(OTConceptImpl).l6q = function (link) {
    return this.r6q_1.l6q(link);
  };
  protoOf(OTConceptImpl).m6q = function (link) {
    return this.r6q_1.m6q(link);
  };
  function DomainNodeFactoryImpl(descriptor) {
    this.u6q_1 = descriptor;
  }
  protoOf(DomainNodeFactoryImpl).n6q = function (nodeSetupContext, id) {
    return this.u6q_1.d6r_1(get_typedNodeContext(nodeSetupContext.h6p_1), id);
  };
  function ErrorNodeFactory() {
  }
  protoOf(ErrorNodeFactory).n6q = function (nodeSetupContext, id) {
    throw IllegalStateException_init_$Create$_0('Cannot instantiate abstract concept');
  };
  protoOf(ErrorNodeFactory).o6q = function (nodeSetupContext, node) {
    throw IllegalStateException_init_$Create$_0('Trying to instantiate abstract concept for concept id ' + node.a38_1.toString());
  };
  protoOf(ErrorNodeFactory).p6q = function () {
    var tmp = ErrorNodeFactory_instance;
    return isInterface(tmp, DomainNodeWrapperFactory) ? tmp : THROW_CCE();
  };
  var ErrorNodeFactory_instance;
  function ErrorNodeFactory_getInstance() {
    return ErrorNodeFactory_instance;
  }
  function OTConceptWrapperImpl(definitionClass, implementationClass, factory, idMapping) {
    this.f6r_1 = factory;
    this.g6r_1 = idMapping;
    this.h6r_1 = definitionClass;
    this.i6r_1 = implementationClass;
  }
  protoOf(OTConceptWrapperImpl).j6q = function () {
    return this.i6r_1;
  };
  protoOf(OTConceptWrapperImpl).n6q = function (nodeSetupContext, id) {
    return this.f6r_1.n6q(nodeSetupContext, id);
  };
  protoOf(OTConceptWrapperImpl).f6o = function () {
    return this.g6r_1.f6o();
  };
  protoOf(OTConceptWrapperImpl).o6m = function (roleId) {
    return this.g6r_1.o6m(roleId);
  };
  protoOf(OTConceptWrapperImpl).k6q = function (propertyId) {
    return this.g6r_1.k6q(propertyId);
  };
  protoOf(OTConceptWrapperImpl).l6q = function (link) {
    return this.g6r_1.l6q(link);
  };
  protoOf(OTConceptWrapperImpl).m6q = function (link) {
    return this.g6r_1.m6q(link);
  };
  protoOf(OTConceptWrapperImpl).o6q = function (nodeSetupContext, node) {
    return this.f6r_1.o6q(nodeSetupContext, node);
  };
  function DomainNodeWrapperFactoryImpl(descriptor) {
    this.j6r_1 = descriptor;
  }
  protoOf(DomainNodeWrapperFactoryImpl).n6q = function (nodeSetupContext, id) {
    return this.o6q(nodeSetupContext, new Node_0(this.j6r_1.e6r_1, id));
  };
  protoOf(DomainNodeWrapperFactoryImpl).o6q = function (nodeSetupContext, node) {
    return this.j6r_1.c6r_1(nodeSetupContext, node);
  };
  function IdMapping(descriptor) {
    this.k6r_1 = descriptor;
  }
  protoOf(IdMapping).f6o = function () {
    return this.k6r_1.x6p_1.v2();
  };
  protoOf(IdMapping).o6m = function (roleId) {
    return this.k6r_1.v6p_1.y2(roleId);
  };
  protoOf(IdMapping).k6q = function (propertyId) {
    return this.k6r_1.x6p_1.y2(propertyId);
  };
  protoOf(IdMapping).l6q = function (link) {
    var tmp0 = this.k6r_1.v6p_1.w();
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.langDef.ot.structure.IdMapping.getOtId.<anonymous>' call
        // Inline function 'kotlin.collections.component2' call
        var l = element.y();
        if (l.equals(link)) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    var tmp0_safe_receiver = tmp$ret$2;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x();
  };
  protoOf(IdMapping).m6q = function (link) {
    var tmp0 = this.k6r_1.u6p_1.w();
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.langDef.ot.structure.IdMapping.getOtId.<anonymous>' call
        // Inline function 'kotlin.collections.component2' call
        var l = element.y();
        if (l.equals(link)) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    var tmp0_safe_receiver = tmp$ret$2;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x();
  };
  function plus_11(_this__u8e3s4, other) {
    var first = _this__u8e3s4;
    return new plus$1(first, other);
  }
  function uncheckedCastGetOtId(_this__u8e3s4, $this, link) {
    return _this__u8e3s4.l6q(link instanceof ChildLink ? link : THROW_CCE());
  }
  function uncheckedCastGetOtId_0(_this__u8e3s4, $this, link) {
    return _this__u8e3s4.m6q(link instanceof AttributeLink ? link : THROW_CCE());
  }
  function plus$1($first, $other) {
    this.l6r_1 = $first;
    this.m6r_1 = $other;
  }
  protoOf(plus$1).f6o = function () {
    return plus_4(this.l6r_1.f6o(), this.m6r_1.f6o());
  };
  protoOf(plus$1).o6m = function (roleId) {
    var tmp0_elvis_lhs = this.l6r_1.o6m(roleId);
    return tmp0_elvis_lhs == null ? this.m6r_1.o6m(roleId) : tmp0_elvis_lhs;
  };
  protoOf(plus$1).k6q = function (propertyId) {
    var tmp0_elvis_lhs = this.l6r_1.k6q(propertyId);
    return tmp0_elvis_lhs == null ? this.m6r_1.k6q(propertyId) : tmp0_elvis_lhs;
  };
  protoOf(plus$1).l6q = function (link) {
    var tmp0_elvis_lhs = this.l6r_1.l6q(link);
    return tmp0_elvis_lhs == null ? uncheckedCastGetOtId(this.m6r_1, this, link) : tmp0_elvis_lhs;
  };
  protoOf(plus$1).m6q = function (link) {
    var tmp0_elvis_lhs = this.l6r_1.m6q(link);
    return tmp0_elvis_lhs == null ? uncheckedCastGetOtId_0(this.m6r_1, this, link) : tmp0_elvis_lhs;
  };
  function OTSplitMergeSupportFactory(conceptRegistry) {
    this.n6r_1 = conceptRegistry;
  }
  protoOf(OTSplitMergeSupportFactory).o6r = function (role, propertyLink) {
    var childId = this.n6r_1.z6o(role.x6k_1).l6q(role);
    var propertyId = this.n6r_1.z6o(propertyLink.b6q_1).m6q(propertyLink);
    // Inline function 'kotlin.checkNotNull' call
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (childId == null) {
        // Inline function 'kotlin.checkNotNull.<anonymous>' call
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    // Inline function 'kotlin.checkNotNull' call
    $l$block_0: {
      // Inline function 'kotlin.checkNotNull' call
      if (propertyId == null) {
        // Inline function 'kotlin.checkNotNull.<anonymous>' call
        var message_0 = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        break $l$block_0;
      }
    }
    return new OTSplitMergeSupport(childId, propertyId);
  };
  function OTSplitMergeSupport(childRoleId, propertyId) {
    this.p6r_1 = childRoleId;
    this.q6r_1 = propertyId;
  }
  protoOf(OTSplitMergeSupport).r6r = function (parent, childIndex, splitIndex) {
    toOtNode(parent).r3b(this.p6r_1, childIndex, this.q6r_1, splitIndex);
  };
  protoOf(OTSplitMergeSupport).s6r = function (parent, childIndex, splitIndex) {
    return this.r6r((!(parent == null) ? isInterface(parent, DomainNode) : false) ? parent : THROW_CCE(), childIndex, splitIndex);
  };
  protoOf(OTSplitMergeSupport).t6r = function (parent, child) {
    toOtNode(parent).u3b(toOtNode(child), this.q6r_1);
  };
  protoOf(OTSplitMergeSupport).u6r = function (parent, child) {
    var tmp = (!(parent == null) ? isInterface(parent, DomainNode) : false) ? parent : THROW_CCE();
    return this.t6r(tmp, isInterface(child, DomainNode) ? child : THROW_CCE());
  };
  function toNodeConceptId(_this__u8e3s4, $this, withNodeId) {
    var tmp;
    if (withNodeId) {
      tmp = NodeConceptIdFactory_getInstance().m3c(_this__u8e3s4, _this__u8e3s4);
    } else {
      tmp = NodeConceptIdFactory_getInstance().p3c(_this__u8e3s4, _this__u8e3s4);
    }
    return tmp;
  }
  function OtConceptDescriptor(conceptId, matchingText, factory, experimentalFactory, superConcepts, hasNodeId) {
    matchingText = matchingText === VOID ? conceptId : matchingText;
    superConcepts = superConcepts === VOID ? emptyList() : superConcepts;
    hasNodeId = hasNodeId === VOID ? true : hasNodeId;
    OTAbstractConceptDescriptor.call(this, superConcepts);
    this.b6r_1 = matchingText;
    this.c6r_1 = factory;
    this.d6r_1 = experimentalFactory;
    this.e6r_1 = toNodeConceptId(conceptId, this, hasNodeId);
  }
  protoOf(OtConceptDescriptor).v6r = function (nodeSetupContext, nodeId) {
    var tmp;
    if (get_useExperimentalNode(nodeSetupContext.h6p_1)) {
      tmp = this.d6r_1(get_typedNodeContext(nodeSetupContext.h6p_1), nodeId);
    } else {
      tmp = this.c6r_1(nodeSetupContext, new Node_0(this.e6r_1, nodeId));
    }
    return tmp;
  };
  function get_TYPED_NODE_CONTEXT_KEY() {
    _init_properties_TypedNodeContext_kt__mhj57n();
    return TYPED_NODE_CONTEXT_KEY;
  }
  var TYPED_NODE_CONTEXT_KEY;
  function TypedNodeContext(conceptRegistry, referenceFactoryRegistry) {
    this.c6o_1 = conceptRegistry;
    this.d6o_1 = referenceFactoryRegistry;
  }
  protoOf(TypedNodeContext).toString = function () {
    return 'TypedNodeContext(conceptRegistry=' + toString_1(this.c6o_1) + ', referenceFactoryRegistry=' + toString_1(this.d6o_1) + ')';
  };
  protoOf(TypedNodeContext).hashCode = function () {
    var result = hashCode(this.c6o_1);
    result = imul(result, 31) + hashCode(this.d6o_1) | 0;
    return result;
  };
  protoOf(TypedNodeContext).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TypedNodeContext))
      return false;
    var tmp0_other_with_cast = other instanceof TypedNodeContext ? other : THROW_CCE();
    if (!equals(this.c6o_1, tmp0_other_with_cast.c6o_1))
      return false;
    if (!equals(this.d6o_1, tmp0_other_with_cast.d6o_1))
      return false;
    return true;
  };
  function get_typedNodeContext(_this__u8e3s4) {
    _init_properties_TypedNodeContext_kt__mhj57n();
    return _this__u8e3s4.n4u(get_TYPED_NODE_CONTEXT_KEY());
  }
  var properties_initialized_TypedNodeContext_kt_82hs2j;
  function _init_properties_TypedNodeContext_kt__mhj57n() {
    if (!properties_initialized_TypedNodeContext_kt_82hs2j) {
      properties_initialized_TypedNodeContext_kt_82hs2j = true;
      TYPED_NODE_CONTEXT_KEY = new WrapperContextKey('typedNodeContext');
    }
  }
  function TypedOtNode() {
  }
  function get_USE_EXPERIMENTAL_NODE_KEY() {
    _init_properties_UseExperimentalNodeService_kt__v77gkk();
    return USE_EXPERIMENTAL_NODE_KEY;
  }
  var USE_EXPERIMENTAL_NODE_KEY;
  function UseExperimentalNodeService() {
  }
  var UseExperimentalNodeService_instance;
  function UseExperimentalNodeService_getInstance() {
    return UseExperimentalNodeService_instance;
  }
  function get_useExperimentalNode(_this__u8e3s4) {
    _init_properties_UseExperimentalNodeService_kt__v77gkk();
    return _this__u8e3s4.n4u(get_USE_EXPERIMENTAL_NODE_KEY());
  }
  var properties_initialized_UseExperimentalNodeService_kt_3wdkmy;
  function _init_properties_UseExperimentalNodeService_kt__v77gkk() {
    if (!properties_initialized_UseExperimentalNodeService_kt_3wdkmy) {
      properties_initialized_UseExperimentalNodeService_kt_3wdkmy = true;
      USE_EXPERIMENTAL_NODE_KEY = new WrapperContextKey('useExperimentalNode');
    }
  }
  function BaseDomainNodeProperty(node) {
    BaseOtNodeProperty.call(this);
    this.w6r_1 = node;
  }
  protoOf(BaseDomainNodeProperty).e39 = function () {
    return toOtNode(this.w6r_1);
  };
  protoOf(BaseDomainNodeProperty).n4z = function () {
    return this;
  };
  protoOf(BaseDomainNodeProperty).d4x = function (builder) {
    depend(builder.g4x_1.e4x_1, this.n4z());
    return this.n4z().m2c();
  };
  function DomainNodeChildProperty(collection) {
    SingleItemCollectionProperty.call(this, collection);
  }
  protoOf(DomainNodeChildProperty).n4z = function () {
    return this;
  };
  protoOf(DomainNodeChildProperty).yt = function () {
    var tmp = this.a2h_1;
    var tmp_0 = (tmp instanceof ChildrenObservableList ? tmp : THROW_CCE()).yt();
    return isInterface(tmp_0, DomainNode) ? tmp_0 : THROW_CCE();
  };
  protoOf(DomainNodeChildProperty).h3b = function () {
    return new OTRoleData(this.yt().h3f(), this.y6r());
  };
  protoOf(DomainNodeChildProperty).y6r = function () {
    var tmp = this.a2h_1;
    return (tmp instanceof ChildrenObservableList ? tmp : THROW_CCE()).b3d_1;
  };
  protoOf(DomainNodeChildProperty).d4x = function (builder) {
    depend(builder.g4x_1.e4x_1, this.n4z());
    return this.n4z().m2c();
  };
  function DomainNodeChildrenProperty(collection) {
    QMutableListAdapter.call(this, collection);
  }
  protoOf(DomainNodeChildrenProperty).yt = function () {
    var tmp = this.n4z();
    var tmp_0 = (tmp instanceof ChildrenObservableList ? tmp : THROW_CCE()).yt();
    return isInterface(tmp_0, DomainNode) ? tmp_0 : THROW_CCE();
  };
  protoOf(DomainNodeChildrenProperty).h3b = function () {
    return new OTRoleData(this.yt().h3f(), this.y6r());
  };
  protoOf(DomainNodeChildrenProperty).y6r = function () {
    var tmp = this.n4z();
    return (tmp instanceof ChildrenObservableList ? tmp : THROW_CCE()).b3d_1;
  };
  function DomainNodeInMemoryProperty(value) {
    ValueProperty.call(this, value);
  }
  protoOf(DomainNodeInMemoryProperty).n4z = function () {
    return this;
  };
  protoOf(DomainNodeInMemoryProperty).d4x = function (builder) {
    depend(builder.g4x_1.e4x_1, this.n4z());
    return this.n4z().m2c();
  };
  function DomainNodeProperty(node, propertyDescriptor) {
    BaseDomainNodeProperty.call(this, node);
    this.d6s_1 = propertyDescriptor;
  }
  protoOf(DomainNodeProperty).f39 = function () {
    return this.d6s_1.e6s_1;
  };
  protoOf(DomainNodeProperty).m2y = function () {
    return this.d6s_1.f6s_1;
  };
  function DomainNodeReferenceProperty(node, referencePropertyDescriptor) {
    BaseDomainNodeProperty.call(this, node);
    this.h6s_1 = referencePropertyDescriptor;
  }
  protoOf(DomainNodeReferenceProperty).f39 = function () {
    return this.h6s_1.q6o_1;
  };
  protoOf(DomainNodeReferenceProperty).m2y = function () {
    return this.h6s_1.r6o_1;
  };
  protoOf(DomainNodeReferenceProperty).q4z = function () {
    return this.h6s_1.s6o_1;
  };
  function DomainNodeTextProperty(node, textPropertyDescriptor) {
    BaseOtNodeTextProperty.call(this);
    this.i6s_1 = node;
    this.j6s_1 = textPropertyDescriptor;
  }
  protoOf(DomainNodeTextProperty).e39 = function () {
    return toOtNode(this.i6s_1);
  };
  protoOf(DomainNodeTextProperty).f39 = function () {
    return this.j6s_1.k6s_1;
  };
  protoOf(DomainNodeTextProperty).n4z = function () {
    return this;
  };
  protoOf(DomainNodeTextProperty).d4x = function (builder) {
    depend(builder.g4x_1.e4x_1, this.n4z());
    return this.n4z().m2c();
  };
  function OtChildProperty() {
  }
  function OtChildrenList() {
  }
  function DomainNodeChildPropertyDescriptor(childId) {
    this.u6o_1 = childId;
  }
  function DomainNodeChildrenPropertyDescriptor(childrenId) {
    this.x6o_1 = childrenId;
  }
  function DomainNodePropertyDescriptor(propertyId, persister) {
    this.e6s_1 = propertyId;
    this.f6s_1 = persister;
  }
  function DomainNodeReferencePropertyDescriptor(referencePropertyId, referenceContentPersister, referenceContentClass) {
    this.q6o_1 = referencePropertyId;
    this.r6o_1 = referenceContentPersister;
    this.s6o_1 = referenceContentClass;
  }
  function DomainNodeTextPropertyDescriptor(propertyId) {
    this.k6s_1 = propertyId;
  }
  function ConstantReference(property, resolveTarget, findTarget) {
    resolveTarget = resolveTarget === VOID ? null : resolveTarget;
    findTarget = findTarget === VOID ? resolveTarget : findTarget;
    PropertyBasedReference.call(this, property);
    this.m6s_1 = constant(resolveTarget);
    this.n6s_1 = constant(findTarget);
  }
  protoOf(ConstantReference).o6s = function () {
    return this.m6s_1;
  };
  protoOf(ConstantReference).p6s = function () {
    return this.n6s_1;
  };
  protoOf(ConstantReference).t2c = function (newValue) {
    return this.t6s((newValue == null ? true : newValue instanceof ReferenceContent) ? newValue : THROW_CCE());
  };
  protoOf(ConstantReference).h4x = function (builder, $completion) {
    return this.w6s(builder, $completion);
  };
  function ElementsContext() {
  }
  function EnclosingNodeContext(node, link) {
    ElementsContext.call(this);
    this.x6s_1 = node;
    this.y6s_1 = link;
  }
  protoOf(EnclosingNodeContext).z6s = function () {
    return this.x6s_1;
  };
  function SourceNodeContext(source) {
    ElementsContext.call(this);
    this.a6t_1 = source;
  }
  function toEnclosingNodeContext(_this__u8e3s4) {
    return new EnclosingNodeContext(_this__u8e3s4.b6t_1, _this__u8e3s4.c6t_1);
  }
  function Companion_96() {
  }
  var Companion_instance_96;
  function Companion_getInstance_96() {
    return Companion_instance_96;
  }
  function GlobalNodeFinder$find$$inlined$query$1(this$0, $source, $refContents) {
    this.d6t_1 = this$0;
    this.e6t_1 = $source;
    this.f6t_1 = $refContents;
  }
  protoOf(GlobalNodeFinder$find$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.references.GlobalNodeFinder.find.<anonymous>' call
    var nodePointer = this.d6t_1.h6t(this.e6t_1, this.f6t_1);
    return builder.n51(this.d6t_1.g6t_1.b6k(nodePointer));
  };
  function GlobalNodeFinder(nodePointerSupport) {
    this.g6t_1 = nodePointerSupport;
  }
  protoOf(GlobalNodeFinder).i6t = function (source, refContents) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new GlobalNodeFinder$find$$inlined$query$1(this, source, refContents);
  };
  protoOf(GlobalNodeFinder).z6l = function (source, refContents) {
    return this.i6t(source, refContents instanceof QualifiedReferenceContent ? refContents : THROW_CCE());
  };
  protoOf(GlobalNodeFinder).h6t = function (source, refContents) {
    return refContents.j6t_1;
  };
  protoOf(GlobalNodeFinder).a6m = function (source, refContents) {
    return this.h6t(source, refContents instanceof QualifiedReferenceContent ? refContents : THROW_CCE());
  };
  function RefTag(source, target, content, name) {
    this.k6p_1 = source;
    this.l6p_1 = target;
    this.m6p_1 = content;
    this.n6p_1 = name;
  }
  protoOf(RefTag).toString = function () {
    return 'RefTag(source=' + toString_1(this.k6p_1) + ', target=' + toString_1(this.l6p_1) + ', content=' + toString_1(this.m6p_1) + ', name=' + this.n6p_1 + ')';
  };
  protoOf(RefTag).hashCode = function () {
    var result = this.k6p_1.hashCode();
    result = imul(result, 31) + this.l6p_1.hashCode() | 0;
    result = imul(result, 31) + this.m6p_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.n6p_1) | 0;
    return result;
  };
  protoOf(RefTag).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RefTag))
      return false;
    var tmp0_other_with_cast = other instanceof RefTag ? other : THROW_CCE();
    if (!this.k6p_1.equals(tmp0_other_with_cast.k6p_1))
      return false;
    if (!this.l6p_1.equals(tmp0_other_with_cast.l6p_1))
      return false;
    if (!this.m6p_1.equals(tmp0_other_with_cast.m6p_1))
      return false;
    if (!(this.n6p_1 === tmp0_other_with_cast.n6p_1))
      return false;
    return true;
  };
  function NodeFinder() {
  }
  function throwIfMissing(_this__u8e3s4, $this) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new PrecalculatedResolutionReference$Companion$throwIfMissing$$inlined$query$1(_this__u8e3s4);
  }
  function sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0(function_0) {
    this.k6t_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0).l6t = function (source, property) {
    return this.k6t_1(source, property);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0).b4 = function () {
    return this.k6t_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ReferenceFactory) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function PrecalculatedResolutionReference$Companion$factory$lambda(_unused_var__etf5q3, property) {
    return new PrecalculatedResolutionReference(property);
  }
  function PrecalculatedResolutionReference$Companion$throwIfMissing$$inlined$query$1($this_throwIfMissing) {
    this.m6t_1 = $this_throwIfMissing;
  }
  protoOf(PrecalculatedResolutionReference$Companion$throwIfMissing$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.references.Companion.throwIfMissing.<anonymous>' call
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.m6t_1.qr();
    var tmp;
    // Inline function 'jetbrains.ocelot.langDef.references.Companion.throwIfMissing.<anonymous>.<anonymous>' call
    if (!equals(this_0, Companion_getInstance_98().n6t_1)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var message = 'Value is missing in ' + this.m6t_1.l2c();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  };
  function Companion_97() {
  }
  protoOf(Companion_97).o6t = function () {
    var tmp = PrecalculatedResolutionReference$Companion$factory$lambda;
    return new sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0(tmp);
  };
  var Companion_instance_97;
  function Companion_getInstance_97() {
    return Companion_instance_97;
  }
  function PrecalculatedResolutionReference$resolve$$inlined$map$1($this) {
    this.p6t_1 = $this;
  }
  protoOf(PrecalculatedResolutionReference$resolve$$inlined$map$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.query.map.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.references.PrecalculatedResolutionReference.resolve.<anonymous>' call
    return builder.n51(this.p6t_1).q6t_1;
  };
  function PrecalculatedResolutionReference$find$$inlined$map$1($this) {
    this.s6t_1 = $this;
  }
  protoOf(PrecalculatedResolutionReference$find$$inlined$map$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.query.map.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.references.PrecalculatedResolutionReference.find.<anonymous>' call
    return builder.n51(this.s6t_1).r6t_1;
  };
  function PrecalculatedResolutionReference(property) {
    PropertyBasedReference.call(this, property);
    this.u6t_1 = new ValueProperty(Companion_getInstance_98().n6t_1);
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_0 = throwIfMissing(this.u6t_1, Companion_instance_97);
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    tmp.v6t_1 = new PrecalculatedResolutionReference$resolve$$inlined$map$1(this_0);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_1 = throwIfMissing(this.u6t_1, Companion_instance_97);
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    tmp_0.w6t_1 = new PrecalculatedResolutionReference$find$$inlined$map$1(this_1);
  }
  protoOf(PrecalculatedResolutionReference).o6s = function () {
    return this.v6t_1;
  };
  protoOf(PrecalculatedResolutionReference).p6s = function () {
    return this.w6t_1;
  };
  protoOf(PrecalculatedResolutionReference).t2c = function (newValue) {
    return this.t6s((newValue == null ? true : newValue instanceof ReferenceContent) ? newValue : THROW_CCE());
  };
  protoOf(PrecalculatedResolutionReference).h4x = function (builder, $completion) {
    return this.w6s(builder, $completion);
  };
  function Companion_98() {
    Companion_instance_98 = this;
    this.n6t_1 = new PrecalculatedResolutionReferenceValue(null, null);
  }
  var Companion_instance_98;
  function Companion_getInstance_98() {
    if (Companion_instance_98 == null)
      new Companion_98();
    return Companion_instance_98;
  }
  function PrecalculatedResolutionReferenceValue(resolveResult, findResult) {
    Companion_getInstance_98();
    this.q6t_1 = resolveResult;
    this.r6t_1 = findResult;
  }
  function PropertyBasedReference(property) {
    this.q6s_1 = property;
  }
  protoOf(PropertyBasedReference).r6s = function () {
    return this.q6s_1;
  };
  protoOf(PropertyBasedReference).s6s = function (target) {
    var factory = ReferenceContentFactories_getInstance().y6t(this.q6s_1.q4z());
    this.t6s(factory.z6t(target));
  };
  protoOf(PropertyBasedReference).t2c = function (newValue) {
    return this.t6s((newValue == null ? true : newValue instanceof ReferenceContent) ? newValue : THROW_CCE());
  };
  protoOf(PropertyBasedReference).h4x = function (builder, $completion) {
    return this.w6s(builder, $completion);
  };
  function Reference() {
  }
  function ReferenceFactory() {
  }
  function ReferenceResolver() {
  }
  function ReferenceTargetItem(referenceContent, text, additionalText) {
    additionalText = additionalText === VOID ? null : additionalText;
    this.c6u_1 = referenceContent;
    this.d6u_1 = text;
    this.e6u_1 = additionalText;
  }
  function Empty_0() {
  }
  protoOf(Empty_0).f6u = function (context, filter) {
    return emptyFlow();
  };
  protoOf(Empty_0).g6u = function (context, filter) {
    return this.f6u(context, filter);
  };
  var Empty_instance;
  function Empty_getInstance() {
    return Empty_instance;
  }
  function ReferenceTargetsSupplier() {
  }
  function ReferenceData(link, tag) {
    this.j6o_1 = link;
    this.k6o_1 = tag;
  }
  protoOf(ReferenceData).toString = function () {
    return 'ReferenceData(link=' + this.j6o_1.toString() + ', tag=' + this.k6o_1.toString() + ')';
  };
  protoOf(ReferenceData).hashCode = function () {
    var result = this.j6o_1.hashCode();
    result = imul(result, 31) + this.k6o_1.hashCode() | 0;
    return result;
  };
  protoOf(ReferenceData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReferenceData))
      return false;
    var tmp0_other_with_cast = other instanceof ReferenceData ? other : THROW_CCE();
    if (!this.j6o_1.equals(tmp0_other_with_cast.j6o_1))
      return false;
    if (!this.k6o_1.equals(tmp0_other_with_cast.k6o_1))
      return false;
    return true;
  };
  function ReferenceLink(sourceConcept, property, targetConcept) {
    NodeLink.call(this);
    this.g6o_1 = sourceConcept;
    this.h6o_1 = property;
    this.i6o_1 = targetConcept;
  }
  protoOf(ReferenceLink).h6u = function () {
    return this.g6o_1;
  };
  protoOf(ReferenceLink).i6u = function () {
    return this.h6o_1;
  };
  protoOf(ReferenceLink).toString = function () {
    return 'ReferenceLink(sourceConcept=' + toString_1(this.g6o_1) + ', property=' + toString_1(this.h6o_1) + ', targetConcept=' + toString_1(this.i6o_1) + ')';
  };
  protoOf(ReferenceLink).hashCode = function () {
    var result = this.g6o_1.hashCode();
    result = imul(result, 31) + hashCode(this.h6o_1) | 0;
    result = imul(result, 31) + this.i6o_1.hashCode() | 0;
    return result;
  };
  protoOf(ReferenceLink).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReferenceLink))
      return false;
    var tmp0_other_with_cast = other instanceof ReferenceLink ? other : THROW_CCE();
    if (!this.g6o_1.equals(tmp0_other_with_cast.g6o_1))
      return false;
    if (!equals(this.h6o_1, tmp0_other_with_cast.h6o_1))
      return false;
    if (!this.i6o_1.equals(tmp0_other_with_cast.i6o_1))
      return false;
    return true;
  };
  function TargetInfo(target, referenceContents, text, additionalText) {
    additionalText = additionalText === VOID ? null : additionalText;
    ReferenceTargetItem.call(this, referenceContents, text, additionalText);
    this.m6u_1 = target;
  }
  protoOf(TargetInfo).toString = function () {
    return 'TargetInfo{target=' + toString_1(this.m6u_1) + ', referenceContents=' + toString_1(this.c6u_1) + ', text=' + this.d6u_1 + '}';
  };
  function sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0(function_0) {
    this.n6u_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0).o6u = function (target) {
    return this.n6u_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0).b4 = function () {
    return this.n6u_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, TargetPresentationProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0(function_0) {
    this.p6u_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0).o6u = function (target) {
    return this.p6u_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0).b4 = function () {
    return this.p6u_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, TargetPresentationProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0).hashCode = function () {
    return hashCode(this.b4());
  };
  function TargetPresentationProvider$Companion$Empty$lambda(it) {
    return Companion_getInstance_76().i51_1;
  }
  function TargetPresentationProvider$Companion$Default$lambda(it) {
    var tmp;
    if (isInterface(it, Named)) {
      tmp = it.b3();
    } else {
      tmp = Companion_getInstance_76().l51_1;
    }
    return tmp;
  }
  function Companion_99() {
    Companion_instance_99 = this;
    var tmp = this;
    var tmp_0 = TargetPresentationProvider$Companion$Empty$lambda;
    tmp.q6u_1 = new sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0(tmp_0);
    var tmp_1 = this;
    var tmp_2 = TargetPresentationProvider$Companion$Default$lambda;
    tmp_1.r6u_1 = new sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_0(tmp_2);
  }
  var Companion_instance_99;
  function Companion_getInstance_99() {
    if (Companion_instance_99 == null)
      new Companion_99();
    return Companion_instance_99;
  }
  function TargetPresentationProvider() {
  }
  function TextFilter_init_$Init$(pattern, settings, $this) {
    TextFilter.call($this, pattern, settings.s6u(), settings.t6u());
    return $this;
  }
  function TextFilter_init_$Create$(pattern, settings) {
    return TextFilter_init_$Init$(pattern, settings, objectCreate(protoOf(TextFilter)));
  }
  function TextFilter_init_$Init$_0(pattern, ignoreCase, wordTokenization, $this) {
    TextFilter.call($this, get_tokenized(pattern), ignoreCase, wordTokenization);
    return $this;
  }
  function TextFilter_init_$Create$_0(pattern, ignoreCase, wordTokenization) {
    return TextFilter_init_$Init$_0(pattern, ignoreCase, wordTokenization, objectCreate(protoOf(TextFilter)));
  }
  function TextFilter_init_$Init$_1(pattern, settings, $this) {
    TextFilter.call($this, get_tokenized(pattern), settings.s6u(), settings.t6u());
    return $this;
  }
  function TextFilter_init_$Create$_1(pattern, settings) {
    return TextFilter_init_$Init$_1(pattern, settings, objectCreate(protoOf(TextFilter)));
  }
  function Companion_100() {
    Companion_instance_100 = this;
    this.u6u_1 = new TextFilter(get_tokenized(''), false, false);
  }
  var Companion_instance_100;
  function Companion_getInstance_100() {
    if (Companion_instance_100 == null)
      new Companion_100();
    return Companion_instance_100;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.TextFilter', this, 3);
    tmp0_serialDesc.t5n('pattern', false);
    tmp0_serialDesc.t5n('ignoreCase', false);
    tmp0_serialDesc.t5n('wordTokenization', false);
    this.v6u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).w6u = function (encoder, value) {
    var tmp0_desc = this.v6u_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.z5h(tmp0_desc, 0, $serializer_getInstance_1(), value.x6u_1);
    tmp1_output.p5h(tmp0_desc, 1, value.y6u_1);
    tmp1_output.p5h(tmp0_desc, 2, value.z6u_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_0).j5d = function (encoder, value) {
    return this.w6u(encoder, value instanceof TextFilter ? value : THROW_CCE());
  };
  protoOf($serializer_0).k5d = function (decoder) {
    var tmp0_desc = this.v6u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_local2 = false;
    var tmp7_input = decoder.j5g(tmp0_desc);
    if (tmp7_input.y5g()) {
      tmp4_local0 = tmp7_input.v5g(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.l5g(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.l5g(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.v5g(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.l5g(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.l5g(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.k5g(tmp0_desc);
    return TextFilter_init_$Create$_2(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_0).w5c = function () {
    return this.v6u_1;
  };
  protoOf($serializer_0).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_1(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function TextFilter_init_$Init$_2(seen0, pattern, ignoreCase, wordTokenization, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_0().v6u_1);
    }
    $this.x6u_1 = pattern;
    $this.y6u_1 = ignoreCase;
    $this.z6u_1 = wordTokenization;
    return $this;
  }
  function TextFilter_init_$Create$_2(seen0, pattern, ignoreCase, wordTokenization, serializationConstructorMarker) {
    return TextFilter_init_$Init$_2(seen0, pattern, ignoreCase, wordTokenization, serializationConstructorMarker, objectCreate(protoOf(TextFilter)));
  }
  function TextFilter(pattern, ignoreCase, wordTokenization) {
    Companion_getInstance_100();
    this.x6u_1 = pattern;
    this.y6u_1 = ignoreCase;
    this.z6u_1 = wordTokenization;
  }
  protoOf(TextFilter).s6u = function () {
    return this.y6u_1;
  };
  protoOf(TextFilter).t6u = function () {
    return this.z6u_1;
  };
  protoOf(TextFilter).a6v = function (text) {
    if (this.z6u_1) {
      var textTokens = text.d6v();
      var _iterator__ex2g4s = this.x6u_1.d6v().k();
      while (_iterator__ex2g4s.l()) {
        var patternToken = _iterator__ex2g4s.m();
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(textTokens, Collection)) {
            tmp = textTokens.p();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s_0 = textTokens.k();
          while (_iterator__ex2g4s_0.l()) {
            var element = _iterator__ex2g4s_0.m();
            // Inline function 'jetbrains.ocelot.langDef.references.TextFilter.apply.<anonymous>' call
            if (startsWith(element, patternToken, this.y6u_1)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        if (!tmp$ret$0) {
          return false;
        }
      }
      return true;
    }
    return startsWith(text.b6v_1, this.x6u_1.b6v_1, this.y6u_1);
  };
  protoOf(TextFilter).e6v = function (text) {
    return this.a6v(get_tokenized(text));
  };
  protoOf(TextFilter).f6v = function (pattern, ignoreCase, wordTokenization) {
    return new TextFilter(pattern, ignoreCase, wordTokenization);
  };
  protoOf(TextFilter).g6v = function (pattern, ignoreCase, wordTokenization, $super) {
    pattern = pattern === VOID ? this.x6u_1 : pattern;
    ignoreCase = ignoreCase === VOID ? this.y6u_1 : ignoreCase;
    wordTokenization = wordTokenization === VOID ? this.z6u_1 : wordTokenization;
    return $super === VOID ? this.f6v(pattern, ignoreCase, wordTokenization) : $super.f6v.call(this, pattern, ignoreCase, wordTokenization);
  };
  protoOf(TextFilter).toString = function () {
    return 'TextFilter(pattern=' + this.x6u_1.toString() + ', ignoreCase=' + this.y6u_1 + ', wordTokenization=' + this.z6u_1 + ')';
  };
  protoOf(TextFilter).hashCode = function () {
    var result = this.x6u_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.y6u_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z6u_1) | 0;
    return result;
  };
  protoOf(TextFilter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextFilter))
      return false;
    var tmp0_other_with_cast = other instanceof TextFilter ? other : THROW_CCE();
    if (!this.x6u_1.equals(tmp0_other_with_cast.x6u_1))
      return false;
    if (!(this.y6u_1 === tmp0_other_with_cast.y6u_1))
      return false;
    if (!(this.z6u_1 === tmp0_other_with_cast.z6u_1))
      return false;
    return true;
  };
  function TextFilterSettings$Companion$invoke$1($ignoreCase, $wordTokenization) {
    this.h6v_1 = $ignoreCase;
    this.i6v_1 = $wordTokenization;
  }
  protoOf(TextFilterSettings$Companion$invoke$1).s6u = function () {
    return this.h6v_1;
  };
  protoOf(TextFilterSettings$Companion$invoke$1).t6u = function () {
    return this.i6v_1;
  };
  function TextFilterSettings$Companion$DEFAULT$1() {
    this.j6v_1 = true;
    this.k6v_1 = true;
  }
  protoOf(TextFilterSettings$Companion$DEFAULT$1).s6u = function () {
    return this.j6v_1;
  };
  protoOf(TextFilterSettings$Companion$DEFAULT$1).t6u = function () {
    return this.k6v_1;
  };
  function Companion_101() {
    Companion_instance_101 = this;
    var tmp = this;
    tmp.l6v_1 = new TextFilterSettings$Companion$DEFAULT$1();
  }
  protoOf(Companion_101).m6v = function (ignoreCase, wordTokenization) {
    return new TextFilterSettings$Companion$invoke$1(ignoreCase, wordTokenization);
  };
  var Companion_instance_101;
  function Companion_getInstance_101() {
    if (Companion_instance_101 == null)
      new Companion_101();
    return Companion_instance_101;
  }
  function get_matchPattern() {
    _init_properties_TokenizedText_kt__uj79ng();
    return matchPattern;
  }
  var matchPattern;
  function Companion_102() {
  }
  var Companion_instance_102;
  function Companion_getInstance_102() {
    return Companion_instance_102;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.TokenizedText', this, 1);
    tmp0_serialDesc.t5n('value', false);
    this.n6v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).o6v = function (encoder, value) {
    var tmp0_desc = this.n6v_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.x5h(tmp0_desc, 0, value.b6v_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_1).j5d = function (encoder, value) {
    return this.o6v(encoder, value instanceof TokenizedText ? value : THROW_CCE());
  };
  protoOf($serializer_1).k5d = function (decoder) {
    var tmp0_desc = this.n6v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.t5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.t5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return TokenizedText_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_1).w5c = function () {
    return this.n6v_1;
  };
  protoOf($serializer_1).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function TokenizedText_init_$Init$(seen0, value, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_1().n6v_1);
    }
    $this.b6v_1 = value;
    $this.c6v_1 = null;
    return $this;
  }
  function TokenizedText_init_$Create$(seen0, value, serializationConstructorMarker) {
    return TokenizedText_init_$Init$(seen0, value, serializationConstructorMarker, objectCreate(protoOf(TokenizedText)));
  }
  function TokenizedText(value) {
    this.b6v_1 = value;
    this.c6v_1 = null;
  }
  protoOf(TokenizedText).d6v = function () {
    var cached = this.c6v_1;
    if (!(cached == null))
      return cached;
    var result = tokens(this.b6v_1);
    this.c6v_1 = result;
    return result;
  };
  protoOf(TokenizedText).toString = function () {
    return 'TokenizedText(value=' + this.b6v_1 + ')';
  };
  protoOf(TokenizedText).hashCode = function () {
    return getStringHashCode(this.b6v_1);
  };
  protoOf(TokenizedText).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TokenizedText))
      return false;
    var tmp0_other_with_cast = other instanceof TokenizedText ? other : THROW_CCE();
    if (!(this.b6v_1 === tmp0_other_with_cast.b6v_1))
      return false;
    return true;
  };
  function get_tokenized(_this__u8e3s4) {
    _init_properties_TokenizedText_kt__uj79ng();
    return new TokenizedText(_this__u8e3s4);
  }
  function tokens(text) {
    _init_properties_TokenizedText_kt__uj79ng();
    var tmp = get_matchPattern().yd(text);
    return toSet_1(map(tmp, tokens$lambda));
  }
  function tokens$lambda(it) {
    _init_properties_TokenizedText_kt__uj79ng();
    return it.y();
  }
  var properties_initialized_TokenizedText_kt_loublm;
  function _init_properties_TokenizedText_kt__uj79ng() {
    if (!properties_initialized_TokenizedText_kt_loublm) {
      properties_initialized_TokenizedText_kt_loublm = true;
      matchPattern = Regex_init_$Create$('[^a-zA-Z0-9]|[a-zA-Z0-9]+');
    }
  }
  function sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0(function_0) {
    this.p6v_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0).l6t = function (source, property) {
    return this.p6v_1(source, property);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0).b4 = function () {
    return this.p6v_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ReferenceFactory) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0).hashCode = function () {
    return hashCode(this.b4());
  };
  function TrivialReference$Companion$factory$lambda($resolver) {
    return function (source, property) {
      return new TrivialReference(property, $resolver, source);
    };
  }
  function $runSuspendCOROUTINE$0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y6v_1 = _this__u8e3s4;
    this.z6v_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.a6w_1 = this.z6v_1;
            this.b6w_1 = this.a6w_1;
            this.c6w_1 = this.b6w_1.n51(this.y6v_1.i6w_1);
            if (this.c6w_1 == null) {
              this.d6w_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.e6w_1 = this.c6w_1;
              this.f6w_1 = this.e6w_1;
              var tmp_2 = this;
              tmp_2.g6w_1 = this.f6w_1;
              this.h6w_1 = this.g6w_1;
              this.y9_1 = 1;
              suspendResult = this.b6w_1.m51(this.y6v_1.j6w_1.a6u(this.y6v_1.k6w_1, this.h6w_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.d6w_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            return this.d6w_1;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$1(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t6w_1 = _this__u8e3s4;
    this.u6w_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.v6w_1 = this.u6w_1;
            this.w6w_1 = this.v6w_1;
            this.x6w_1 = this.w6w_1.n51(this.t6w_1.d6x_1);
            if (this.x6w_1 == null) {
              this.y6w_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.z6w_1 = this.x6w_1;
              this.a6x_1 = this.z6w_1;
              var tmp_2 = this;
              tmp_2.b6x_1 = this.a6x_1;
              this.c6x_1 = this.b6x_1;
              this.y9_1 = 1;
              suspendResult = this.w6w_1.m51(this.t6w_1.e6x_1.b6u(this.t6w_1.f6x_1, this.c6x_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.y6w_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            return this.y6w_1;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function Companion_103() {
  }
  protoOf(Companion_103).g6x = function (resolver) {
    var tmp = TrivialReference$Companion$factory$lambda(resolver);
    return new sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_0(tmp);
  };
  var Companion_instance_103;
  function Companion_getInstance_103() {
    return Companion_instance_103;
  }
  function TrivialReference$resolve$$inlined$suspendingQuery$1($property, $resolver, $source) {
    this.i6w_1 = $property;
    this.j6w_1 = $resolver;
    this.k6w_1 = $source;
  }
  protoOf(TrivialReference$resolve$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(TrivialReference$resolve$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function TrivialReference$find$$inlined$suspendingQuery$1($property, $resolver, $source) {
    this.d6x_1 = $property;
    this.e6x_1 = $resolver;
    this.f6x_1 = $source;
  }
  protoOf(TrivialReference$find$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$1(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(TrivialReference$find$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function TrivialReference(property, resolver, source) {
    PropertyBasedReference.call(this, property);
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp.i6x_1 = new TrivialReference$resolve$$inlined$suspendingQuery$1(property, resolver, source);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_0.j6x_1 = new TrivialReference$find$$inlined$suspendingQuery$1(property, resolver, source);
  }
  protoOf(TrivialReference).o6s = function () {
    return this.i6x_1;
  };
  protoOf(TrivialReference).p6s = function () {
    return this.j6x_1;
  };
  protoOf(TrivialReference).t2c = function (newValue) {
    return this.t6s((newValue == null ? true : newValue instanceof ReferenceContent) ? newValue : THROW_CCE());
  };
  protoOf(TrivialReference).h4x = function (builder, $completion) {
    return this.w6s(builder, $completion);
  };
  function ReferenceFactoryRegistryService() {
    ReferenceFactoryRegistryService_instance = this;
    this.k6x_1 = new ReferenceFactoryRegistryImpl(emptyMap());
  }
  protoOf(ReferenceFactoryRegistryService).g2o = function () {
    return this.k6x_1;
  };
  var ReferenceFactoryRegistryService_instance;
  function ReferenceFactoryRegistryService_getInstance() {
    if (ReferenceFactoryRegistryService_instance == null)
      new ReferenceFactoryRegistryService();
    return ReferenceFactoryRegistryService_instance;
  }
  function referenceFactories(_this__u8e3s4, body) {
    _this__u8e3s4.l2p(ReferenceFactoryRegistryAspect_instance, new ReferenceFactoryRegistryDefinition(body));
  }
  function ReferenceFactoryRegistryAspect$createConfigurationService$lambda($definitions) {
    return function (it) {
      var builder = new ReferenceFactoryRegistryBuilderImpl(it);
      var _iterator__ex2g4s = $definitions.k();
      while (_iterator__ex2g4s.l()) {
        var definition = _iterator__ex2g4s.m();
        definition.l6x_1(builder);
      }
      return builder.k2p();
    };
  }
  function ReferenceFactoryRegistryAspect() {
  }
  protoOf(ReferenceFactoryRegistryAspect).o6x = function (definitions) {
    var tmp = Companion_instance_33;
    var tmp_0 = [ReferenceFactoryRegistryService_getInstance()];
    return tmp.m2o(tmp_0, VOID, ReferenceFactoryRegistryAspect$createConfigurationService$lambda(definitions));
  };
  protoOf(ReferenceFactoryRegistryAspect).i2p = function (definitions) {
    return this.o6x(definitions);
  };
  var ReferenceFactoryRegistryAspect_instance;
  function ReferenceFactoryRegistryAspect_getInstance() {
    return ReferenceFactoryRegistryAspect_instance;
  }
  function ReferenceFactoryRegistryDefinition(body) {
    this.l6x_1 = body;
  }
  function ReferenceFactoryRegistryBuilderImpl(servicesScope) {
    this.m6x_1 = servicesScope;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.n6x_1 = HashMap_init_$Create$();
  }
  protoOf(ReferenceFactoryRegistryBuilderImpl).p6x = function (tag, referenceFactory) {
    // Inline function 'kotlin.collections.set' call
    this.n6x_1.r2(tag, referenceFactory);
  };
  protoOf(ReferenceFactoryRegistryBuilderImpl).k2p = function () {
    return new ReferenceFactoryRegistryImpl(this.n6x_1);
  };
  protoOf(ReferenceFactoryRegistryBuilderImpl).h2o = function (key) {
    return this.m6x_1.h2o(key);
  };
  protoOf(ReferenceFactoryRegistryBuilderImpl).e2p = function (_this__u8e3s4, thisRef, property) {
    return this.m6x_1.e2p(_this__u8e3s4, thisRef, property);
  };
  function sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1(function_0) {
    this.q6x_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1).l6t = function (source, property) {
    return this.q6x_1(source, property);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1).b4 = function () {
    return this.q6x_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ReferenceFactory) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1).hashCode = function () {
    return hashCode(this.b4());
  };
  function ReferenceFactoryRegistryImpl$referenceFactory$lambda(_unused_var__etf5q3, property) {
    return new ConstantReference(property);
  }
  function ReferenceFactoryRegistryImpl(referenceFactories) {
    this.r6x_1 = referenceFactories;
  }
  protoOf(ReferenceFactoryRegistryImpl).s6x = function (tag) {
    var tmp = this.r6x_1.y2(tag);
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, ReferenceFactory) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp_1 = ReferenceFactoryRegistryImpl$referenceFactory$lambda;
      return new sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_1(tmp_1);
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var factory = tmp_0;
    return factory;
  };
  function createReference(_this__u8e3s4, tag, source, property) {
    return createReference_0(_this__u8e3s4, tag, source, toReified(property, tag.m6p_1));
  }
  function createReference_0(_this__u8e3s4, tag, source, property) {
    return _this__u8e3s4.s6x(tag).l6t(source, property);
  }
  function ReferenceTargetPresentationProvidersRegistryService() {
    ReferenceTargetPresentationProvidersRegistryService_instance = this;
    this.t6x_1 = new ReferenceTargetPresentationProvidersRegistryImpl(emptyMap());
  }
  protoOf(ReferenceTargetPresentationProvidersRegistryService).g2o = function () {
    return this.t6x_1;
  };
  var ReferenceTargetPresentationProvidersRegistryService_instance;
  function ReferenceTargetPresentationProvidersRegistryService_getInstance() {
    if (ReferenceTargetPresentationProvidersRegistryService_instance == null)
      new ReferenceTargetPresentationProvidersRegistryService();
    return ReferenceTargetPresentationProvidersRegistryService_instance;
  }
  function referenceTargetPresentationProviders(_this__u8e3s4, body) {
    _this__u8e3s4.l2p(ReferenceTargetPresentationProvidersRegistryAspect_instance, new ReferenceTargetPresentationProvidersRegistryDefinition(body));
  }
  function ReferenceTargetPresentationProvidersRegistryAspect$createConfigurationService$lambda($definitions) {
    return function (it) {
      var builder = new ReferenceTargetPresentationProvidersRegistryBuilderImpl(it);
      var _iterator__ex2g4s = $definitions.k();
      while (_iterator__ex2g4s.l()) {
        var definition = _iterator__ex2g4s.m();
        definition.u6x_1(builder);
      }
      return builder.k2p();
    };
  }
  function ReferenceTargetPresentationProvidersRegistryAspect() {
  }
  protoOf(ReferenceTargetPresentationProvidersRegistryAspect).x6x = function (definitions) {
    var tmp = Companion_instance_33;
    var tmp_0 = [ReferenceTargetPresentationProvidersRegistryService_getInstance()];
    return tmp.m2o(tmp_0, VOID, ReferenceTargetPresentationProvidersRegistryAspect$createConfigurationService$lambda(definitions));
  };
  protoOf(ReferenceTargetPresentationProvidersRegistryAspect).i2p = function (definitions) {
    return this.x6x(definitions);
  };
  var ReferenceTargetPresentationProvidersRegistryAspect_instance;
  function ReferenceTargetPresentationProvidersRegistryAspect_getInstance() {
    return ReferenceTargetPresentationProvidersRegistryAspect_instance;
  }
  function ReferenceTargetPresentationProvidersRegistryDefinition(body) {
    this.u6x_1 = body;
  }
  function ReferenceTargetPresentationProvidersRegistryBuilder() {
  }
  function ReferenceTargetPresentationProvidersRegistryBuilderImpl(servicesScope) {
    this.v6x_1 = servicesScope;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.w6x_1 = HashMap_init_$Create$();
  }
  protoOf(ReferenceTargetPresentationProvidersRegistryBuilderImpl).y6x = function (tag, presentationProvider) {
    // Inline function 'kotlin.collections.set' call
    this.w6x_1.r2(tag, presentationProvider);
  };
  protoOf(ReferenceTargetPresentationProvidersRegistryBuilderImpl).k2p = function () {
    return new ReferenceTargetPresentationProvidersRegistryImpl(this.w6x_1);
  };
  protoOf(ReferenceTargetPresentationProvidersRegistryBuilderImpl).h2o = function (key) {
    return this.v6x_1.h2o(key);
  };
  protoOf(ReferenceTargetPresentationProvidersRegistryBuilderImpl).e2p = function (_this__u8e3s4, thisRef, property) {
    return this.v6x_1.e2p(_this__u8e3s4, thisRef, property);
  };
  function ReferenceTargetPresentationProvidersRegistryImpl(targetPresentationProviders) {
    this.a6y_1 = targetPresentationProviders;
  }
  protoOf(ReferenceTargetPresentationProvidersRegistryImpl).b6y = function (tag) {
    var tmp0_elvis_lhs = this.a6y_1.y2(tag);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance_99().q6u_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var presentationProvider = tmp;
    return isInterface(presentationProvider, TargetPresentationProvider) ? presentationProvider : THROW_CCE();
  };
  function getPresentation(_this__u8e3s4, tag, target) {
    return _this__u8e3s4.b6y(tag).o6u(target);
  }
  function ReferenceTargetsSuppliersRegistryService() {
    ReferenceTargetsSuppliersRegistryService_instance = this;
    this.c6y_1 = new ReferenceTargetsSuppliersRegistryImpl(emptyMap());
  }
  protoOf(ReferenceTargetsSuppliersRegistryService).g2o = function () {
    return this.c6y_1;
  };
  var ReferenceTargetsSuppliersRegistryService_instance;
  function ReferenceTargetsSuppliersRegistryService_getInstance() {
    if (ReferenceTargetsSuppliersRegistryService_instance == null)
      new ReferenceTargetsSuppliersRegistryService();
    return ReferenceTargetsSuppliersRegistryService_instance;
  }
  function referenceTargetsSuppliers(_this__u8e3s4, body) {
    _this__u8e3s4.l2p(ReferenceTargetsSuppliersRegistryAspect_instance, new ReferenceTargetsSuppliersRegistryDefinition(body));
  }
  function ReferenceTargetsSuppliersRegistryAspect$createConfigurationService$lambda($definitions) {
    return function (it) {
      var builder = new ReferenceTargetsSuppliersRegistryBuilderImpl(it);
      var _iterator__ex2g4s = $definitions.k();
      while (_iterator__ex2g4s.l()) {
        var definition = _iterator__ex2g4s.m();
        definition.d6y_1(builder);
      }
      return builder.k2p();
    };
  }
  function ReferenceTargetsSuppliersRegistryAspect() {
  }
  protoOf(ReferenceTargetsSuppliersRegistryAspect).g6y = function (definitions) {
    var tmp = Companion_instance_33;
    var tmp_0 = [ReferenceTargetsSuppliersRegistryService_getInstance()];
    return tmp.m2o(tmp_0, VOID, ReferenceTargetsSuppliersRegistryAspect$createConfigurationService$lambda(definitions));
  };
  protoOf(ReferenceTargetsSuppliersRegistryAspect).i2p = function (definitions) {
    return this.g6y(definitions);
  };
  var ReferenceTargetsSuppliersRegistryAspect_instance;
  function ReferenceTargetsSuppliersRegistryAspect_getInstance() {
    return ReferenceTargetsSuppliersRegistryAspect_instance;
  }
  function ReferenceTargetsSuppliersRegistryDefinition(body) {
    this.d6y_1 = body;
  }
  function ReferenceTargetsSuppliersRegistryBuilderImpl(servicesScope) {
    this.e6y_1 = servicesScope;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.f6y_1 = HashMap_init_$Create$();
  }
  protoOf(ReferenceTargetsSuppliersRegistryBuilderImpl).h6y = function (tag, targetsSupplier) {
    // Inline function 'kotlin.collections.set' call
    this.f6y_1.r2(tag, targetsSupplier);
  };
  protoOf(ReferenceTargetsSuppliersRegistryBuilderImpl).k2p = function () {
    return new ReferenceTargetsSuppliersRegistryImpl(this.f6y_1);
  };
  protoOf(ReferenceTargetsSuppliersRegistryBuilderImpl).h2o = function (key) {
    return this.e6y_1.h2o(key);
  };
  protoOf(ReferenceTargetsSuppliersRegistryBuilderImpl).e2p = function (_this__u8e3s4, thisRef, property) {
    return this.e6y_1.e2p(_this__u8e3s4, thisRef, property);
  };
  function ReferenceTargetsSuppliersRegistryImpl(targetSuppliers) {
    this.i6y_1 = targetSuppliers;
  }
  protoOf(ReferenceTargetsSuppliersRegistryImpl).j6y = function (tag) {
    var tmp0_elvis_lhs = this.i6y_1.y2(tag);
    var tmp = tmp0_elvis_lhs == null ? Empty_instance : tmp0_elvis_lhs;
    return isInterface(tmp, ReferenceTargetsSupplier) ? tmp : THROW_CCE();
  };
  function ResolveConfigImpl(referenceFactoryRegistry, referenceTargetsSuppliersRegistry, referenceTargetPresentationProvidersRegistry) {
    this.k6y_1 = referenceFactoryRegistry;
    this.l6y_1 = referenceTargetsSuppliersRegistry;
    this.m6y_1 = referenceTargetPresentationProvidersRegistry;
  }
  protoOf(ResolveConfigImpl).s6x = function (tag) {
    return this.k6y_1.s6x(tag);
  };
  protoOf(ResolveConfigImpl).j6y = function (tag) {
    return this.l6y_1.j6y(tag);
  };
  protoOf(ResolveConfigImpl).b6y = function (tag) {
    return this.m6y_1.b6y(tag);
  };
  function ResolveConfigService() {
  }
  var ResolveConfigService_instance;
  function ResolveConfigService_getInstance() {
    return ResolveConfigService_instance;
  }
  function get_refTags(_this__u8e3s4) {
    return ConceptRegistryService_instance.e2o(_this__u8e3s4).g6p();
  }
  function _get_$cachedSerializer__te6jhj_0($this) {
    return $this.n6y_1.y();
  }
  function ReferenceContent$Companion$_anonymous__a4n5i7() {
    var tmp = getKClass(ReferenceContent);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(DynamicReferenceContent), getKClass(LocalReferenceContent), getKClass(QualifiedReferenceContent)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_2(), $serializer_getInstance_3(), $serializer_getInstance_4()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    return SealedClassSerializer_init_$Create$('jetbrains.ocelot.langDef.references.content.ReferenceContent', tmp, tmp_0, tmp_1, tmp$ret$8);
  }
  function Companion_104() {
    Companion_instance_104 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n6y_1 = lazy(tmp_0, ReferenceContent$Companion$_anonymous__a4n5i7);
  }
  protoOf(Companion_104).h67 = function () {
    return _get_$cachedSerializer__te6jhj_0(this);
  };
  protoOf(Companion_104).t5o = function (typeParamsSerializers) {
    return this.h67();
  };
  var Companion_instance_104;
  function Companion_getInstance_104() {
    if (Companion_instance_104 == null)
      new Companion_104();
    return Companion_instance_104;
  }
  function ReferenceContent_init_$Init$(seen0, serializationConstructorMarker, $this) {
    return $this;
  }
  function ReferenceContent() {
    Companion_getInstance_104();
  }
  function Companion_105() {
  }
  protoOf(Companion_105).h67 = function () {
    return $serializer_getInstance_2();
  };
  var Companion_instance_105;
  function Companion_getInstance_105() {
    return Companion_instance_105;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.content.DynamicReferenceContent', this, 1);
    tmp0_serialDesc.t5n('targetName', true);
    this.o6y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).p6y = function (encoder, value) {
    var tmp0_desc = this.o6y_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    if (tmp1_output.e5i(tmp0_desc, 0) ? true : !(value.q6y_1 === '')) {
      tmp1_output.x5h(tmp0_desc, 0, value.q6y_1);
    }
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_2).j5d = function (encoder, value) {
    return this.p6y(encoder, value instanceof DynamicReferenceContent ? value : THROW_CCE());
  };
  protoOf($serializer_2).k5d = function (decoder) {
    var tmp0_desc = this.o6y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.j5g(tmp0_desc);
    if (tmp5_input.y5g()) {
      tmp4_local0 = tmp5_input.t5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.t5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.k5g(tmp0_desc);
    return DynamicReferenceContent_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_2).w5c = function () {
    return this.o6y_1;
  };
  protoOf($serializer_2).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function DynamicReferenceContent_init_$Init$(seen0, targetName, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_2().o6y_1);
    }
    ReferenceContent_init_$Init$(seen0, serializationConstructorMarker, $this);
    if (0 === (seen0 & 1))
      $this.q6y_1 = '';
    else
      $this.q6y_1 = targetName;
    return $this;
  }
  function DynamicReferenceContent_init_$Create$(seen0, targetName, serializationConstructorMarker) {
    return DynamicReferenceContent_init_$Init$(seen0, targetName, serializationConstructorMarker, objectCreate(protoOf(DynamicReferenceContent)));
  }
  function DynamicReferenceContent(targetName) {
    targetName = targetName === VOID ? '' : targetName;
    ReferenceContent.call(this);
    this.q6y_1 = targetName;
  }
  protoOf(DynamicReferenceContent).toString = function () {
    // Inline function 'jetbrains.ocelot.langDef.references.content.ReferenceContentPersisters.serialize' call
    var this_0 = ReferenceContentPersisters_getInstance();
    return ensureNotNull(this_0.s6p(getKClass(DynamicReferenceContent)).x2p(this));
  };
  protoOf(DynamicReferenceContent).hashCode = function () {
    return getStringHashCode(this.q6y_1);
  };
  protoOf(DynamicReferenceContent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DynamicReferenceContent))
      return false;
    var tmp0_other_with_cast = other instanceof DynamicReferenceContent ? other : THROW_CCE();
    if (!(this.q6y_1 === tmp0_other_with_cast.q6y_1))
      return false;
    return true;
  };
  function Companion_106() {
  }
  protoOf(Companion_106).h67 = function () {
    return $serializer_getInstance_3();
  };
  var Companion_instance_106;
  function Companion_getInstance_106() {
    return Companion_instance_106;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.content.LocalReferenceContent', this, 1);
    tmp0_serialDesc.t5n('nodeId', false);
    this.r6y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).s6y = function (encoder, value) {
    var tmp0_desc = this.r6y_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.z5h(tmp0_desc, 0, NodeIdSerializer_getInstance(), value.y6l_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_3).j5d = function (encoder, value) {
    return this.s6y(encoder, value instanceof LocalReferenceContent ? value : THROW_CCE());
  };
  protoOf($serializer_3).k5d = function (decoder) {
    var tmp0_desc = this.r6y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.j5g(tmp0_desc);
    if (tmp5_input.y5g()) {
      tmp4_local0 = tmp5_input.v5g(tmp0_desc, 0, NodeIdSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.v5g(tmp0_desc, 0, NodeIdSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.k5g(tmp0_desc);
    return LocalReferenceContent_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_3).w5c = function () {
    return this.r6y_1;
  };
  protoOf($serializer_3).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [NodeIdSerializer_getInstance()];
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function LocalReferenceContent_init_$Init$(seen0, nodeId, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_3().r6y_1);
    }
    ReferenceContent_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.y6l_1 = nodeId;
    return $this;
  }
  function LocalReferenceContent_init_$Create$(seen0, nodeId, serializationConstructorMarker) {
    return LocalReferenceContent_init_$Init$(seen0, nodeId, serializationConstructorMarker, objectCreate(protoOf(LocalReferenceContent)));
  }
  function LocalReferenceContent(nodeId) {
    ReferenceContent.call(this);
    this.y6l_1 = nodeId;
  }
  protoOf(LocalReferenceContent).toString = function () {
    // Inline function 'jetbrains.ocelot.langDef.references.content.ReferenceContentPersisters.serialize' call
    var this_0 = ReferenceContentPersisters_getInstance();
    return ensureNotNull(this_0.s6p(getKClass(LocalReferenceContent)).x2p(this));
  };
  protoOf(LocalReferenceContent).hashCode = function () {
    return this.y6l_1.hashCode();
  };
  protoOf(LocalReferenceContent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LocalReferenceContent))
      return false;
    var tmp0_other_with_cast = other instanceof LocalReferenceContent ? other : THROW_CCE();
    if (!this.y6l_1.equals(tmp0_other_with_cast.y6l_1))
      return false;
    return true;
  };
  function Companion_107() {
  }
  protoOf(Companion_107).h67 = function () {
    return $serializer_getInstance_4();
  };
  var Companion_instance_107;
  function Companion_getInstance_107() {
    return Companion_instance_107;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.content.QualifiedReferenceContent', this, 1);
    tmp0_serialDesc.t5n('nodePointer', false);
    this.t6y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).u6y = function (encoder, value) {
    var tmp0_desc = this.t6y_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.z5h(tmp0_desc, 0, NodePointerSerializer_getInstance(), value.j6t_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_4).j5d = function (encoder, value) {
    return this.u6y(encoder, value instanceof QualifiedReferenceContent ? value : THROW_CCE());
  };
  protoOf($serializer_4).k5d = function (decoder) {
    var tmp0_desc = this.t6y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.j5g(tmp0_desc);
    if (tmp5_input.y5g()) {
      tmp4_local0 = tmp5_input.v5g(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.v5g(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.k5g(tmp0_desc);
    return QualifiedReferenceContent_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_4).w5c = function () {
    return this.t6y_1;
  };
  protoOf($serializer_4).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [NodePointerSerializer_getInstance()];
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function QualifiedReferenceContent_init_$Init$(seen0, nodePointer, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_4().t6y_1);
    }
    ReferenceContent_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.j6t_1 = nodePointer;
    return $this;
  }
  function QualifiedReferenceContent_init_$Create$(seen0, nodePointer, serializationConstructorMarker) {
    return QualifiedReferenceContent_init_$Init$(seen0, nodePointer, serializationConstructorMarker, objectCreate(protoOf(QualifiedReferenceContent)));
  }
  function QualifiedReferenceContent(nodePointer) {
    ReferenceContent.call(this);
    this.j6t_1 = nodePointer;
  }
  protoOf(QualifiedReferenceContent).toString = function () {
    // Inline function 'jetbrains.ocelot.langDef.references.content.ReferenceContentPersisters.serialize' call
    var this_0 = ReferenceContentPersisters_getInstance();
    return ensureNotNull(this_0.s6p(getKClass(QualifiedReferenceContent)).x2p(this));
  };
  protoOf(QualifiedReferenceContent).hashCode = function () {
    return this.j6t_1.hashCode();
  };
  protoOf(QualifiedReferenceContent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof QualifiedReferenceContent))
      return false;
    var tmp0_other_with_cast = other instanceof QualifiedReferenceContent ? other : THROW_CCE();
    if (!this.j6t_1.equals(tmp0_other_with_cast.j6t_1))
      return false;
    return true;
  };
  function ContentFactory() {
  }
  function sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0(function_0) {
    this.v6y_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0).z6t = function (target) {
    return this.v6y_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0).b4 = function () {
    return this.v6y_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ContentFactory) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function ReferenceContentFactories$referenceContentFactories$lambda(it) {
    return new LocalReferenceContent(it.v39());
  }
  function ReferenceContentFactories$referenceContentFactories$lambda_0(it) {
    return new QualifiedReferenceContent(ensureNotNull(get_pointer(it)));
  }
  function ReferenceContentFactories() {
    ReferenceContentFactories_instance = this;
    var tmp = this;
    var tmp_0 = getKClass(LocalReferenceContent);
    var tmp_1 = ReferenceContentFactories$referenceContentFactories$lambda;
    var tmp_2 = to(tmp_0, new sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0(tmp_1));
    var tmp_3 = getKClass(QualifiedReferenceContent);
    var tmp_4 = ReferenceContentFactories$referenceContentFactories$lambda_0;
    tmp.x6t_1 = mapOf_0([tmp_2, to(tmp_3, new sam$jetbrains_ocelot_langDef_references_content_ReferenceContentFactories_ContentFactory$0(tmp_4))]);
  }
  protoOf(ReferenceContentFactories).y6t = function (contentKClass) {
    var tmp = this.x6t_1.y2(contentKClass);
    return (!(tmp == null) ? isInterface(tmp, ContentFactory) : false) ? tmp : THROW_CCE();
  };
  var ReferenceContentFactories_instance;
  function ReferenceContentFactories_getInstance() {
    if (ReferenceContentFactories_instance == null)
      new ReferenceContentFactories();
    return ReferenceContentFactories_instance;
  }
  function toDeserializable($this, value) {
    // Inline function 'kotlinx.serialization.json.buildJsonObject' call
    // Inline function 'kotlin.contracts.contract' call
    var builder = new JsonObjectBuilder();
    // Inline function 'jetbrains.ocelot.langDef.references.content.DelegatePersister.toDeserializable.<anonymous>' call
    put(builder, $this.y6y_1, value);
    return builder.q66();
  }
  function contentToStore($this, value) {
    var tmp0_safe_receiver = get_jsonObject(value).fe($this.y6y_1);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.g67();
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  }
  function DelegatePersister(serializer, format) {
    format = format === VOID ? Default_getInstance_1() : format;
    this.w6y_1 = serializer;
    this.x6y_1 = format;
    this.y6y_1 = ensureNotNull(ReferenceContentPersisters_getInstance().o6p_1.y2(this.w6y_1));
  }
  protoOf(DelegatePersister).w2p = function (value) {
    return this.x6y_1.n65(this.w6y_1, toDeserializable(this, value));
  };
  protoOf(DelegatePersister).z6y = function (value) {
    return contentToStore(this, this.x6y_1.m65(this.w6y_1, value));
  };
  protoOf(DelegatePersister).x2p = function (value) {
    return this.z6y(value instanceof ReferenceContent ? value : THROW_CCE());
  };
  function ReferenceContentPersisters() {
    ReferenceContentPersisters_instance = this;
    this.o6p_1 = mapOf_0([to(Companion_instance_106.h67(), 'nodeId'), to(Companion_instance_107.h67(), 'nodePointer'), to(Companion_instance_105.h67(), 'targetName')]);
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.content.ReferenceContentPersisters.createPersisterFor' call
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer_1(createKType(getKClass(LocalReferenceContent), arrayOf([]), false));
    var serializer = isInterface(this_0, KSerializer) ? this_0 : THROW_CCE();
    var format = Default_getInstance_1();
    tmp.p6p_1 = toNullablePersister(new DelegatePersister(serializer, format), new EmptyStringNullPersister());
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.references.content.ReferenceContentPersisters.createPersisterFor' call
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_1 = serializer_1(createKType(getKClass(QualifiedReferenceContent), arrayOf([]), false));
    var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
    var format_0 = Default_getInstance_1();
    tmp_0.q6p_1 = toNullablePersister(new DelegatePersister(serializer_0, format_0), new EmptyStringNullPersister());
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.langDef.references.content.ReferenceContentPersisters.createPersisterFor' call
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer_1(createKType(getKClass(DynamicReferenceContent), arrayOf([]), false));
    var serializer_2 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var format_1 = Default_getInstance_1();
    tmp_1.r6p_1 = toNullablePersister(new DelegatePersister(serializer_2, format_1), new EmptyStringNullPersister());
  }
  protoOf(ReferenceContentPersisters).s6p = function (clazz) {
    var tmp;
    if (clazz.equals(getKClass(LocalReferenceContent))) {
      tmp = this.p6p_1;
    } else if (clazz.equals(getKClass(QualifiedReferenceContent))) {
      tmp = this.q6p_1;
    } else if (clazz.equals(getKClass(DynamicReferenceContent))) {
      tmp = this.r6p_1;
    } else {
      throw IllegalArgumentException_init_$Create$();
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, Persister) ? tmp_0 : THROW_CCE();
  };
  var ReferenceContentPersisters_instance;
  function ReferenceContentPersisters_getInstance() {
    if (ReferenceContentPersisters_instance == null)
      new ReferenceContentPersisters();
    return ReferenceContentPersisters_instance;
  }
  function BaseDocumentRepository(documentConcepts) {
    this.a6z_1 = new BaseDocumentContainer(documentConcepts);
  }
  protoOf(BaseDocumentRepository).v6j = function (documentId) {
    return this.a6z_1.e6z(documentId);
  };
  protoOf(BaseDocumentRepository).f6z = function () {
    return this.a6z_1;
  };
  protoOf(BaseDocumentRepository).vr = function () {
    this.a6z_1.vr();
  };
  function Companion_108() {
  }
  var Companion_instance_108;
  function Companion_getInstance_108() {
    return Companion_instance_108;
  }
  function LocalDocumentRepository(documentConcepts) {
    BaseDocumentRepository.call(this, documentConcepts);
  }
  function BaseDocumentContainer$getDocumentQuery$o$run$lambda(this$0, $documentId) {
    return function (handler) {
      return this$0.c6z_1.a2c($documentId, handler);
    };
  }
  function Companion_109() {
    Companion_instance_109 = this;
    this.h6z_1 = getLogger(getKClass(DocumentContainer));
  }
  var Companion_instance_109;
  function Companion_getInstance_109() {
    if (Companion_instance_109 == null)
      new Companion_109();
    return Companion_instance_109;
  }
  function sam$jetbrains_ocelot_base_observable_event_EventSource$0(function_0) {
    this.i6z_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0).o27 = function (handler) {
    return this.i6z_1(handler);
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0).b4 = function () {
    return this.i6z_1;
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EventSource) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function BaseDocumentContainer$documents$$inlined$query$1(this$0, $conceptDescriptor) {
    this.j6z_1 = this$0;
    this.k6z_1 = $conceptDescriptor;
  }
  protoOf(BaseDocumentContainer$documents$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.repositories.containers.BaseDocumentContainer.documents.<anonymous>' call
    var tmp = builder.n51(ensureNotNull(this.j6z_1.d6z_1.y2(this.k6z_1.e6r_1)));
    return asSequence_0(isInterface(tmp, Collection) ? tmp : THROW_CCE());
  };
  function BaseDocumentContainer$getDocumentQuery$$inlined$query$1(this$0, $documentId) {
    this.l6z_1 = this$0;
    this.m6z_1 = $documentId;
  }
  protoOf(BaseDocumentContainer$getDocumentQuery$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.repositories.containers.BaseDocumentContainer.getDocumentQuery.<anonymous>' call
    var tmp = BaseDocumentContainer$getDocumentQuery$o$run$lambda(this.l6z_1, this.m6z_1);
    builder.g4x_1.e4x_1.n4v(new sam$jetbrains_ocelot_base_observable_event_EventSource$0(tmp), Invalidation_getInstance().v4u_1);
    return this.l6z_1.v6j(this.m6z_1);
  };
  function BaseDocumentContainer$dispose$lambda(it) {
    it.d28(Unit_instance);
    return Unit_instance;
  }
  function BaseDocumentContainer(conceptDescriptors) {
    Companion_getInstance_109();
    this.b6z_1 = HashMap_init_$Create$();
    this.c6z_1 = new ListenersMap();
    var tmp = this;
    // Inline function 'kotlin.collections.associate' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(conceptDescriptors, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = conceptDescriptors.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.repositories.containers.BaseDocumentContainer.conceptsMap.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.e6r_1, get_forQueries_5(ObservableHashSet_init_$Create$()));
      destination.r2(pair.dh_1, pair.eh_1);
    }
    tmp.d6z_1 = destination;
  }
  protoOf(BaseDocumentContainer).n6z = function (conceptDescriptor) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new BaseDocumentContainer$documents$$inlined$query$1(this, conceptDescriptor);
  };
  protoOf(BaseDocumentContainer).v6j = function (documentId) {
    return this.b6z_1.y2(documentId);
  };
  protoOf(BaseDocumentContainer).e6z = function (documentId) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new BaseDocumentContainer$getDocumentQuery$$inlined$query$1(this, documentId);
  };
  protoOf(BaseDocumentContainer).vr = function () {
    var documentIds = toList_0(this.b6z_1.u2());
    this.b6z_1.m2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.d6z_1.v2().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.repositories.containers.BaseDocumentContainer.dispose.<anonymous>' call
      element.m2();
    }
    var _iterator__ex2g4s_0 = documentIds.k();
    while (_iterator__ex2g4s_0.l()) {
      var documentId = _iterator__ex2g4s_0.m();
      this.c6z_1.b2c(documentId, BaseDocumentContainer$dispose$lambda);
    }
    this.c6z_1.m2();
  };
  function DocumentContainer() {
  }
  function Companion_110() {
  }
  var Companion_instance_110;
  function Companion_getInstance_110() {
    return Companion_instance_110;
  }
  function DocumentContainerProvider$provide$$inlined$query$1(this$0) {
    this.o6z_1 = this$0;
  }
  protoOf(DocumentContainerProvider$provide$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.repositories.containers.DocumentContainerProvider.provide.<anonymous>' call
    return this.o6z_1.f6z();
  };
  function DocumentContainerProvider() {
  }
  function AttributePersisters$decimalPersister$1() {
  }
  protoOf(AttributePersisters$decimalPersister$1).w2p = function (value) {
    return Companion_getInstance_77().r55(value);
  };
  protoOf(AttributePersisters$decimalPersister$1).p6z = function (value) {
    return value.toString();
  };
  protoOf(AttributePersisters$decimalPersister$1).x2p = function (value) {
    return this.p6z(value instanceof BigDecimal ? value : THROW_CCE());
  };
  protoOf(AttributePersisters$decimalPersister$1).toString = function () {
    return 'ionspin.bigDecimal.Persister';
  };
  function AttributePersisters() {
    AttributePersisters_instance = this;
    var tmp = this;
    tmp.a6n_1 = toNonNullPersister(new AttributePersisters$decimalPersister$1());
  }
  var AttributePersisters_instance;
  function AttributePersisters_getInstance() {
    if (AttributePersisters_instance == null)
      new AttributePersisters();
    return AttributePersisters_instance;
  }
  function NodeIdSerializer() {
    NodeIdSerializer_instance = this;
    this.q6z_1 = PrimitiveSerialDescriptor('NodeId', STRING_getInstance());
  }
  protoOf(NodeIdSerializer).w5c = function () {
    return this.q6z_1;
  };
  protoOf(NodeIdSerializer).k5d = function (decoder) {
    return new NodeId(decoder.f5g());
  };
  protoOf(NodeIdSerializer).r6z = function (encoder, value) {
    return encoder.m5h(value.i2s_1);
  };
  protoOf(NodeIdSerializer).j5d = function (encoder, value) {
    return this.r6z(encoder, value instanceof NodeId ? value : THROW_CCE());
  };
  var NodeIdSerializer_instance;
  function NodeIdSerializer_getInstance() {
    if (NodeIdSerializer_instance == null)
      new NodeIdSerializer();
    return NodeIdSerializer_instance;
  }
  function NodePersister() {
  }
  function Companion_111() {
  }
  var Companion_instance_111;
  function Companion_getInstance_111() {
    return Companion_instance_111;
  }
  function serialization(block) {
    var tmp = Companion_instance_33;
    var tmp_0 = [Companion_instance_111];
    return tmp.m2o(tmp_0, VOID, serialization$lambda(block));
  }
  function serialization$1$builder$1($it, $defaultNodePersister) {
    this.t6z_1 = $defaultNodePersister;
    this.s6z_1 = $it;
  }
  protoOf(serialization$1$builder$1).u6z = function (persister) {
    if (!(this.t6z_1._v == null)) {
      throw LanguageConfigurationException_init_$Create$_0('default node persister already set');
    }
    this.t6z_1._v = persister;
  };
  protoOf(serialization$1$builder$1).h2o = function (key) {
    return this.s6z_1.h2o(key);
  };
  protoOf(serialization$1$builder$1).e2p = function (_this__u8e3s4, thisRef, property) {
    return this.s6z_1.e2p(_this__u8e3s4, thisRef, property);
  };
  function serialization$1$1($defaultNodePersister) {
    this.v6z_1 = $defaultNodePersister;
  }
  protoOf(serialization$1$1).w6z = function (type) {
    var tmp0_safe_receiver = this.v6z_1._v;
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver();
    var tmp1_elvis_lhs = (!(tmp == null) ? isInterface(tmp, NodePersister) : false) ? tmp : null;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      throw LanguageConfigurationException_init_$Create$_0('persister not found for type ' + toString_1(type));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  function serialization$lambda($block) {
    return function (it) {
      var defaultNodePersister = {_v: null};
      var builder = new serialization$1$builder$1(it, defaultNodePersister);
      $block(builder);
      return new serialization$1$1(defaultNodePersister);
    };
  }
  function documentIdOfMarkedNode($this, node) {
    return toOtNode(node).z38($this.o6j_1).qr();
  }
  function topmostAncestorOrSelf(_this__u8e3s4, $this) {
    return last_1(generateSequence_0(_this__u8e3s4, DocumentIdUtil$topmostAncestorOrSelf$lambda));
  }
  function DocumentIdUtil$topmostAncestorOrSelf$lambda(it) {
    return it.yt();
  }
  function DocumentIdUtil() {
    DocumentIdUtil_instance = this;
    this.o6j_1 = NodePropertyIdFactory_getInstance().x3c('document_id_mark');
  }
  protoOf(DocumentIdUtil).p6j = function (node, documentId) {
    var tmp;
    if (isInterface(node, DocumentNode)) {
      node.w6j().t2c(documentId);
      tmp = Unit_instance;
    } else {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!(node.yt() == null)) {
        // Inline function 'kotlin.require.<anonymous>' call
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      toOtNode(node).z38(this.o6j_1).t2c(documentId);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(DocumentIdUtil).x6z = function (node) {
    var tmp0_safe_receiver = node.u3o();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w6j();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : execute_0(tmp1_safe_receiver);
    return tmp2_elvis_lhs == null ? documentIdOfMarkedNode(this, topmostAncestorOrSelf(node, this)) : tmp2_elvis_lhs;
  };
  var DocumentIdUtil_instance;
  function DocumentIdUtil_getInstance() {
    if (DocumentIdUtil_instance == null)
      new DocumentIdUtil();
    return DocumentIdUtil_instance;
  }
  function DocumentNode() {
  }
  function DomainNode() {
  }
  function LightDomainNode() {
  }
  function Named() {
  }
  function DirectlyNamed() {
  }
  function toOtNode(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof OtNode) {
      tmp = _this__u8e3s4;
    } else {
      tmp = (_this__u8e3s4 instanceof NodeWrapper ? _this__u8e3s4 : THROW_CCE()).c4t_1;
    }
    return tmp;
  }
  function get_pointer(_this__u8e3s4) {
    var docId = DocumentIdUtil_getInstance().x6z(_this__u8e3s4);
    // Inline function 'kotlin.text.isNullOrEmpty' call
    if (docId == null || charSequenceLength(docId) === 0)
      return null;
    return new NodePointer(docId, _this__u8e3s4.v39());
  }
  function toDomainNode(_this__u8e3s4, wrapperContext) {
    wrapperContext = wrapperContext === VOID ? null : wrapperContext;
    var tmp;
    if (isInterface(_this__u8e3s4, DomainNode)) {
      tmp = _this__u8e3s4;
    } else {
      tmp = ensureNotNull(wrapperContext).g4u(_this__u8e3s4);
    }
    return tmp;
  }
  function get_stringId(_this__u8e3s4) {
    return _this__u8e3s4.v39().i2s_1;
  }
  function get_wrapperContextOrNull(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof NodeWrapper) {
      tmp = _this__u8e3s4.b4t_1;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function NodeFactory() {
  }
  function ChildLink() {
    NodeLink.call(this);
  }
  function AttributeLink() {
    NodeLink.call(this);
  }
  function NodeLink() {
  }
  protoOf(NodeLink).equals = function (other) {
    if (!(other instanceof NodeLink))
      return false;
    return this.h6u().equals(other.h6u()) && this.i6u().callableName === other.i6u().callableName;
  };
  protoOf(NodeLink).hashCode = function () {
    return this.h6u().hashCode() + imul(31, getStringHashCode(this.i6u().callableName)) | 0;
  };
  protoOf(NodeLink).toString = function () {
    return toString_1(this.h6u()) + '#' + this.i6u().callableName;
  };
  function ChildProperty() {
  }
  function ChildrenList() {
  }
  function SingleChildLink(sourceConcept, property) {
    ChildLink.call(this);
    this.z6k_1 = sourceConcept;
    this.a6l_1 = property;
  }
  protoOf(SingleChildLink).h6u = function () {
    return this.z6k_1;
  };
  protoOf(SingleChildLink).i6u = function () {
    return this.a6l_1;
  };
  function MultipleChildLink(sourceConcept, property) {
    ChildLink.call(this);
    this.x6k_1 = sourceConcept;
    this.y6k_1 = property;
  }
  protoOf(MultipleChildLink).h6u = function () {
    return this.x6k_1;
  };
  protoOf(MultipleChildLink).i6u = function () {
    return this.y6k_1;
  };
  function ValueAttributeLink(sourceConcept, property) {
    AttributeLink.call(this);
    this.z6z_1 = sourceConcept;
    this.a70_1 = property;
  }
  protoOf(ValueAttributeLink).h6u = function () {
    return this.z6z_1;
  };
  protoOf(ValueAttributeLink).i6u = function () {
    return this.a70_1;
  };
  function TextAttributeLink(sourceConcept, property) {
    AttributeLink.call(this);
    this.b6q_1 = sourceConcept;
    this.c6q_1 = property;
  }
  protoOf(TextAttributeLink).h6u = function () {
    return this.b6q_1;
  };
  protoOf(TextAttributeLink).i6u = function () {
    return this.c6q_1;
  };
  function Companion_112() {
    Companion_instance_112 = this;
    this.b70_1 = new SerializedChildLink('');
  }
  var Companion_instance_112;
  function Companion_getInstance_112() {
    if (Companion_instance_112 == null)
      new Companion_112();
    return Companion_instance_112;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.structure.SerializedChildLink', this, 1);
    tmp0_serialDesc.t5n('value', false);
    this.c70_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).d70 = function (encoder, value) {
    var tmp0_desc = this.c70_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.x5h(tmp0_desc, 0, value.e70_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_5).j5d = function (encoder, value) {
    return this.d70(encoder, value instanceof SerializedChildLink ? value : THROW_CCE());
  };
  protoOf($serializer_5).k5d = function (decoder) {
    var tmp0_desc = this.c70_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.j5g(tmp0_desc);
    if (tmp5_input.y5g()) {
      tmp4_local0 = tmp5_input.t5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.t5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.k5g(tmp0_desc);
    return SerializedChildLink_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_5).w5c = function () {
    return this.c70_1;
  };
  protoOf($serializer_5).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_5;
  function $serializer_getInstance_5() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function SerializedChildLink_init_$Init$(seen0, value, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_5().c70_1);
    }
    $this.e70_1 = value;
    return $this;
  }
  function SerializedChildLink_init_$Create$(seen0, value, serializationConstructorMarker) {
    return SerializedChildLink_init_$Init$(seen0, value, serializationConstructorMarker, objectCreate(protoOf(SerializedChildLink)));
  }
  function SerializedChildLink(value) {
    Companion_getInstance_112();
    this.e70_1 = value;
  }
  protoOf(SerializedChildLink).toString = function () {
    return 'SerializedChildLink(value=' + this.e70_1 + ')';
  };
  protoOf(SerializedChildLink).hashCode = function () {
    return getStringHashCode(this.e70_1);
  };
  protoOf(SerializedChildLink).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedChildLink))
      return false;
    var tmp0_other_with_cast = other instanceof SerializedChildLink ? other : THROW_CCE();
    if (!(this.e70_1 === tmp0_other_with_cast.e70_1))
      return false;
    return true;
  };
  function ChildContext(node, link) {
    this.b6t_1 = node;
    this.c6t_1 = link;
  }
  function singleChildContext(node, childLink) {
    return new ChildContext(node, childLink);
  }
  function concrete(_this__u8e3s4, $this) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = _this__u8e3s4.w().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.structure.config.Companion.concrete.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var concept = element.x();
      // Inline function 'kotlin.collections.component2' call
      var descriptor = element.y();
      var tmp;
      if (!(descriptor instanceof OtConceptDescriptor)) {
        tmp = null;
      } else {
        tmp = to(concept, descriptor);
      }
      var tmp0_safe_receiver = tmp;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>.<anonymous>' call
        destination.e(tmp0_safe_receiver);
      }
    }
    return toMap(destination);
  }
  function checkUniqueness($this, records) {
    var conceptIds = HashSet_init_$Create$();
    var sourceClasses = HashSet_init_$Create$();
    var _iterator__ex2g4s = records.k();
    while (_iterator__ex2g4s.l()) {
      var record = _iterator__ex2g4s.m();
      var tmp = record.g70_1;
      if (tmp instanceof OtConceptDescriptor) {
        var conceptId = record.g70_1.e6r_1;
        var idWasNotPresent = conceptIds.e(conceptId);
        // Inline function 'kotlin.check' call
        if (!idWasNotPresent) {
          // Inline function 'jetbrains.ocelot.langDef.structure.config.Companion.checkUniqueness.<anonymous>' call
          var message = "duplicate concept id: '" + conceptId.toString() + "'";
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
      }
      var sourceClass = record.f70_1;
      var classWasNotPresent = sourceClasses.e(sourceClass);
      // Inline function 'kotlin.check' call
      if (!classWasNotPresent) {
        // Inline function 'jetbrains.ocelot.langDef.structure.config.Companion.checkUniqueness.<anonymous>' call
        var message_0 = "duplicate source class: '" + toString_1(sourceClass) + "'";
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      }
    }
  }
  function Companion_113() {
  }
  var Companion_instance_113;
  function Companion_getInstance_113() {
    return Companion_instance_113;
  }
  function BaseConceptRegistry(conceptRecords, implementationRecords, useExperimentalNode) {
    checkUniqueness(Companion_instance_113, conceptRecords);
    // Inline function 'kotlin.collections.associate' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(conceptRecords, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = conceptRecords.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.structure.config.BaseConceptRegistry.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.f70_1, element.g70_1);
      destination.r2(pair.dh_1, pair.eh_1);
    }
    var map = destination;
    // Inline function 'kotlin.collections.associate' call
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(implementationRecords, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap_init_$Create$_0(capacity_0);
    var _iterator__ex2g4s_0 = implementationRecords.k();
    while (_iterator__ex2g4s_0.l()) {
      var element_0 = _iterator__ex2g4s_0.m();
      // Inline function 'jetbrains.ocelot.langDef.structure.config.BaseConceptRegistry.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var pair_0 = to(element_0.h70_1, element_0.i70_1);
      destination_0.r2(pair_0.dh_1, pair_0.eh_1);
    }
    var implementations = destination_0;
    var tmp = this;
    // Inline function 'kotlin.collections.associate' call
    var this_0 = concrete(map, Companion_instance_113).w();
    var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_1 = LinkedHashMap_init_$Create$_0(capacity_1);
    var _iterator__ex2g4s_1 = this_0.k();
    while (_iterator__ex2g4s_1.l()) {
      var element_1 = _iterator__ex2g4s_1.m();
      // Inline function 'jetbrains.ocelot.langDef.structure.config.BaseConceptRegistry.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var concept = element_1.x();
      // Inline function 'kotlin.collections.component2' call
      var descriptor = element_1.y();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair_1 = to(descriptor.e6r_1, concept);
      destination_1.r2(pair_1.dh_1, pair_1.eh_1);
    }
    tmp.j70_1 = destination_1;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination_2 = LinkedHashMap_init_$Create$_0(mapCapacity(map.n()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_2 = map.w().k();
    while (_iterator__ex2g4s_2.l()) {
      var element_2 = _iterator__ex2g4s_2.m();
      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
      var tmp_1 = element_2.x();
      // Inline function 'jetbrains.ocelot.langDef.structure.config.BaseConceptRegistry.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var definitionClass = element_2.x();
      // Inline function 'kotlin.collections.component2' call
      var descriptor_0 = element_2.y();
      var tmp_2 = isInterface(definitionClass, KClass) ? definitionClass : THROW_CCE();
      var tmp_3 = implementations.y2(definitionClass);
      var tmp$ret$14 = otConceptByDescriptor(tmp_2, tmp_3, descriptor_0 instanceof OTAbstractConceptDescriptor ? descriptor_0 : THROW_CCE(), useExperimentalNode);
      destination_2.r2(tmp_1, tmp$ret$14);
    }
    tmp_0.k70_1 = destination_2;
    var tmp_4 = this;
    // Inline function 'kotlin.collections.mapValues' call
    var this_1 = concrete(map, Companion_instance_113);
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination_3 = LinkedHashMap_init_$Create$_0(mapCapacity(this_1.n()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_3 = this_1.w().k();
    while (_iterator__ex2g4s_3.l()) {
      var element_3 = _iterator__ex2g4s_3.m();
      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
      var tmp_5 = element_3.x();
      // Inline function 'jetbrains.ocelot.langDef.structure.config.BaseConceptRegistry.<anonymous>' call
      // Inline function 'kotlin.collections.component2' call
      var descriptor_1 = element_3.y();
      var tmp$ret$20 = descriptor_1.b6r_1;
      destination_3.r2(tmp_5, tmp$ret$20);
    }
    tmp_4.m70_1 = destination_3;
    var tmp_6 = this;
    // Inline function 'kotlin.collections.associate' call
    var capacity_2 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(implementationRecords, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_4 = LinkedHashMap_init_$Create$_0(capacity_2);
    var _iterator__ex2g4s_4 = implementationRecords.k();
    while (_iterator__ex2g4s_4.l()) {
      var element_4 = _iterator__ex2g4s_4.m();
      // Inline function 'jetbrains.ocelot.langDef.structure.config.BaseConceptRegistry.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var pair_2 = to(element_4.i70_1, element_4.h70_1);
      destination_4.r2(pair_2.dh_1, pair_2.eh_1);
    }
    tmp_6.l70_1 = destination_4;
  }
  protoOf(BaseConceptRegistry).z6o = function (concept) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.k70_1;
    // Inline function 'kotlin.check' call
    if (!(isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w2(concept)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp = getValue_0(this.k70_1, concept);
    return isInterface(tmp, OTConcept) ? tmp : THROW_CCE();
  };
  protoOf(BaseConceptRegistry).i6m = function (conceptId) {
    var tmp0 = this.j70_1.y2(conceptId);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'jetbrains.ocelot.langDef.structure.config.BaseConceptRegistry.forConcept.<anonymous>' call
        var message = 'Could not find concept for id ' + conceptId.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    var concept = tmp$ret$1;
    return this.z6o(concept);
  };
  protoOf(BaseConceptRegistry).e6p = function (sourceClass) {
    var tmp0_elvis_lhs = this.m70_1.y2(sourceClass);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  protoOf(BaseConceptRegistry).f6p = function (impl) {
    var tmp0_elvis_lhs = this.l70_1.y2(impl);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Unknown implementation class: ' + toString_1(impl);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(BaseConceptRegistry).g6p = function () {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = this.k70_1.v2();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.structure.config.BaseConceptRegistry.getRefTags.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = element.f6o();
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s_0 = this_0.k();
      while (_iterator__ex2g4s_0.l()) {
        var item = _iterator__ex2g4s_0.m();
        // Inline function 'jetbrains.ocelot.langDef.structure.config.BaseConceptRegistry.getRefTags.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item.k6o_1;
        destination_0.e(tmp$ret$0);
      }
      var list = destination_0;
      addAll_1(destination, list);
    }
    return destination;
  };
  function ConceptImplementationRegistryRecord(definitionClass, implementationClass) {
    this.h70_1 = definitionClass;
    this.i70_1 = implementationClass;
  }
  function ConceptRegistryBasedNodeFactory(conceptRegistry, wrapperContext) {
    NodeFactory.call(this);
    this.n70_1 = conceptRegistry;
    this.o70_1 = wrapperContext;
  }
  protoOf(ConceptRegistryBasedNodeFactory).y6z = function (concept) {
    return createInstance(this.n70_1, concept, this.o70_1);
  };
  function ConceptRegistryBuilderImpl(services, useExperimentalNode) {
    this.p70_1 = services;
    this.q70_1 = useExperimentalNode;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.r70_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.s70_1 = ArrayList_init_$Create$();
  }
  protoOf(ConceptRegistryBuilderImpl).t70 = function () {
    return this.q70_1;
  };
  protoOf(ConceptRegistryBuilderImpl).u70 = function (concept, descriptor) {
    this.r70_1.e(new ConceptRegistryRecord(concept, descriptor));
  };
  protoOf(ConceptRegistryBuilderImpl).v70 = function (concept, descriptor) {
    return this.u70(concept, descriptor);
  };
  protoOf(ConceptRegistryBuilderImpl).w70 = function (concept, implementation) {
    this.s70_1.e(new ConceptImplementationRegistryRecord(concept, implementation));
  };
  protoOf(ConceptRegistryBuilderImpl).k2p = function () {
    return createConceptRegistry(this.r70_1, this.s70_1, this.q70_1);
  };
  protoOf(ConceptRegistryBuilderImpl).h2o = function (key) {
    return this.p70_1.h2o(key);
  };
  protoOf(ConceptRegistryBuilderImpl).e2p = function (_this__u8e3s4, thisRef, property) {
    return this.p70_1.e2p(_this__u8e3s4, thisRef, property);
  };
  function createConceptRegistry(conceptRecords, implementationRecords, useExperimentalNode) {
    implementationRecords = implementationRecords === VOID ? emptyList() : implementationRecords;
    useExperimentalNode = useExperimentalNode === VOID ? false : useExperimentalNode;
    var tmp;
    if (useExperimentalNode) {
      tmp = new DomainNodeConceptRegistry(conceptRecords, implementationRecords);
    } else {
      tmp = new NodeWrapperConceptRegistryImpl(conceptRecords, implementationRecords);
    }
    return tmp;
  }
  function ConceptRegistryRecord(sourceClass, descriptor) {
    this.f70_1 = sourceClass;
    this.g70_1 = descriptor;
  }
  function DomainNodeConceptRegistry$getNodeFactory$1(this$0, $typedNodeContext) {
    this.x70_1 = this$0;
    this.y70_1 = $typedNodeContext;
  }
  protoOf(DomainNodeConceptRegistry$getNodeFactory$1).z37 = function (conceptId, nodeId) {
    var descriptor = ensureNotNull(this.x70_1.d71_1.y2(conceptId));
    var tmp = descriptor.d6r_1(this.y70_1, nodeId);
    return tmp instanceof OtNode ? tmp : THROW_CCE();
  };
  function DomainNodeConceptRegistry(conceptRecords, implementationRecords) {
    BaseConceptRegistry.call(this, conceptRecords, implementationRecords, true);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(conceptRecords, 10));
    var _iterator__ex2g4s = conceptRecords.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.structure.config.DomainNodeConceptRegistry.conceptDescriptors.<anonymous>' call
      var tmp$ret$0 = item.g70_1;
      destination.e(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var element = _iterator__ex2g4s_0.m();
      if (element instanceof OtConceptDescriptor) {
        destination_0.e(element);
      }
    }
    // Inline function 'kotlin.collections.associateBy' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_1 = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s_1 = destination_0.k();
    while (_iterator__ex2g4s_1.l()) {
      var element_0 = _iterator__ex2g4s_1.m();
      // Inline function 'jetbrains.ocelot.langDef.structure.config.DomainNodeConceptRegistry.conceptDescriptors.<anonymous>' call
      var tmp$ret$5 = element_0.e6r_1;
      destination_1.r2(tmp$ret$5, element_0);
    }
    tmp.d71_1 = destination_1;
  }
  protoOf(DomainNodeConceptRegistry).d6p = function (referenceFactoryRegistry) {
    var typedNodeContext = new TypedNodeContext(this, referenceFactoryRegistry);
    return new DomainNodeConceptRegistry$getNodeFactory$1(this, typedNodeContext);
  };
  function NodeWrapperConceptRegistryImpl$nodeWrapperFactory$1(this$0) {
    this.e71_1 = this$0;
    NodeWrapperFactory.call(this);
  }
  protoOf(NodeWrapperConceptRegistryImpl$nodeWrapperFactory$1).v4t = function (context, node) {
    var tmp = this.e71_1.i6m(node.a38_1);
    var otConcept = isInterface(tmp, OTConceptWrapper) ? tmp : THROW_CCE();
    var tmp_0 = otConcept.o6q(context.n4u(Companion_getInstance_94().a6p_1), node);
    return tmp_0 instanceof NodeWrapper ? tmp_0 : THROW_CCE();
  };
  function NodeWrapperConceptRegistryImpl(conceptRecords, implementationRecords) {
    BaseConceptRegistry.call(this, conceptRecords, implementationRecords, false);
  }
  protoOf(NodeWrapperConceptRegistryImpl).c6p = function () {
    return new NodeWrapperConceptRegistryImpl$nodeWrapperFactory$1(this);
  };
  function structure(_this__u8e3s4, body) {
    _this__u8e3s4.l2p(StructureAspect_instance, new ConceptDefinitions(body));
  }
  function StructureAspect$createConfigurationService$lambda($definitions) {
    return function (it) {
      var builder = new ConceptRegistryBuilderImpl(it, ensureNotNull(it.h2o(UseExperimentalNodeService_instance)));
      var _iterator__ex2g4s = $definitions.k();
      while (_iterator__ex2g4s.l()) {
        var definition = _iterator__ex2g4s.m();
        definition.j71_1(builder);
      }
      return builder.k2p();
    };
  }
  function StructureAspect() {
  }
  protoOf(StructureAspect).k71 = function (definitions) {
    var tmp = Companion_instance_33;
    var tmp_0 = [ConceptRegistryService_instance];
    return tmp.m2o(tmp_0, VOID, StructureAspect$createConfigurationService$lambda(definitions));
  };
  protoOf(StructureAspect).i2p = function (definitions) {
    return this.k71(definitions);
  };
  var StructureAspect_instance;
  function StructureAspect_getInstance() {
    return StructureAspect_instance;
  }
  function ConceptRegistryService() {
  }
  var ConceptRegistryService_instance;
  function ConceptRegistryService_getInstance() {
    return ConceptRegistryService_instance;
  }
  function ConceptDefinitions(body) {
    this.j71_1 = body;
  }
  function BaseStructureModel(wrapperContext, nodePointerSupport, useExperimentalNode) {
    this.l71_1 = wrapperContext;
    this.m71_1 = nodePointerSupport;
    this.n71_1 = useExperimentalNode;
  }
  protoOf(BaseStructureModel).o71 = function () {
    return this.l71_1;
  };
  protoOf(BaseStructureModel).i6k = function () {
    return this.m71_1;
  };
  protoOf(BaseStructureModel).t70 = function () {
    return this.n71_1;
  };
  protoOf(BaseStructureModel).vr = function () {
    this.l71_1.vr();
    this.m71_1.vr();
  };
  function Companion_114() {
  }
  var Companion_instance_114;
  function Companion_getInstance_114() {
    return Companion_instance_114;
  }
  function EntityNodeLayout(entityConceptId, modelBlobId) {
    this.p71_1 = entityConceptId;
    this.q71_1 = modelBlobId;
  }
  protoOf(EntityNodeLayout).r71 = function (entity) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.p71_1.equals(entity.i2z_1)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(EntityNodeLayout).s71 = function (node, entity) {
    this.r71(entity);
    entity.f30(this.q71_1, new Model(node));
    return entity;
  };
  protoOf(EntityNodeLayout).t71 = function (entityId) {
    return new Entity(this.p71_1, entityId);
  };
  protoOf(EntityNodeLayout).u71 = function (entityId, $super) {
    entityId = entityId === VOID ? EntityId_init_$Create$() : entityId;
    return $super === VOID ? this.t71(entityId) : $super.t71.call(this, entityId);
  };
  protoOf(EntityNodeLayout).toString = function () {
    return 'EntityNodeLayout(entityConceptId=' + this.p71_1.toString() + ', modelBlobId=' + this.q71_1.toString() + ')';
  };
  protoOf(EntityNodeLayout).hashCode = function () {
    var result = this.p71_1.hashCode();
    result = imul(result, 31) + this.q71_1.hashCode() | 0;
    return result;
  };
  protoOf(EntityNodeLayout).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntityNodeLayout))
      return false;
    var tmp0_other_with_cast = other instanceof EntityNodeLayout ? other : THROW_CCE();
    if (!this.p71_1.equals(tmp0_other_with_cast.p71_1))
      return false;
    if (!this.q71_1.equals(tmp0_other_with_cast.q71_1))
      return false;
    return true;
  };
  function SingleRootHolder$Companion$wrapperFactory$$inlined$entityWrapperFactory$1() {
  }
  protoOf(SingleRootHolder$Companion$wrapperFactory$$inlined$entityWrapperFactory$1).z4t = function (context, entity) {
    // Inline function 'jetbrains.ocelot.langDef.structure.model.Companion.wrapperFactory.<anonymous>' call
    return new SingleRootEntityWrapper(context, entity);
  };
  function Companion_115() {
    Companion_instance_115 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.ot.model.wrapper.entityWrapperFactory' call
    tmp.v71_1 = new SingleRootHolder$Companion$wrapperFactory$$inlined$entityWrapperFactory$1();
  }
  var Companion_instance_115;
  function Companion_getInstance_115() {
    if (Companion_instance_115 == null)
      new Companion_115();
    return Companion_instance_115;
  }
  function SingleRootEntityWrapper(context, entity) {
    EntityWrapper.call(this, context, entity);
  }
  function SingleRootHolder(layout, wrapperContext, entity, useExperimentalNode) {
    Companion_getInstance_115();
    this.w71_1 = layout;
    this.w71_1.r71(entity);
    wrapperContext.l4u(Companion_getInstance_115().v71_1);
    this.x71_1 = entity.p33(this.w71_1.q71_1);
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'jetbrains.ocelot.langDef.structure.model.SingleRootHolder.rootNode.<anonymous>' call
    var $this$run = wrapperContext.x4s(entity);
    var tmp_0;
    if (useExperimentalNode) {
      tmp_0 = $this$run.a4t(this.w71_1.q71_1);
    } else {
      tmp_0 = $this$run.y4s(this.w71_1.q71_1);
    }
    var tmp_1 = tmp_0;
    tmp.y71_1 = isInterface(tmp_1, ReadableProperty) ? tmp_1 : THROW_CCE();
  }
  function SingleRootStructureModel$nodePointerSupportUpdater$lambda($nodePointerSupport) {
    return function (it) {
      var tmp0_elvis_lhs = it.p2e_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var model = tmp;
      $nodePointerSupport.h6m(model);
      return Unit_instance;
    };
  }
  function SingleRootStructureModel(wrapperContext, nodePointerSupport, layout, entity, useExperimentalNode) {
    BaseStructureModel.call(this, wrapperContext, nodePointerSupport, useExperimentalNode);
    this.c72_1 = entity;
    this.d72_1 = new SingleRootHolder(layout, wrapperContext, this.c72_1, useExperimentalNode);
    var tmp = this;
    tmp.e72_1 = this.d72_1.x71_1.p27(SingleRootStructureModel$nodePointerSupportUpdater$lambda(nodePointerSupport));
  }
  protoOf(SingleRootStructureModel).vr = function () {
    protoOf(BaseStructureModel).vr.call(this);
    this.e72_1.vr();
  };
  function ancestorOrSelf(_this__u8e3s4, ancestorKClass) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new ancestorOrSelf$$inlined$query$1(_this__u8e3s4, ancestorKClass);
  }
  function ancestorOrSelf$$inlined$query$1($this_ancestorOrSelf, $ancestorKClass) {
    this.f72_1 = $this_ancestorOrSelf;
    this.g72_1 = $ancestorKClass;
  }
  protoOf(ancestorOrSelf$$inlined$query$1).d4x = function (builder) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf.<anonymous>' call
      var k = this.f72_1;
      while (!(k == null)) {
        if (this.g72_1.mb(k)) {
          tmp$ret$0 = safeCast(this.g72_1, k);
          break $l$block;
        }
        k = builder.n51(get_forQueries_2(k.m6m()));
      }
      tmp$ret$0 = null;
    }
    return tmp$ret$0;
  };
  function edt($this, coroutineContext) {
    var tmp0_elvis_lhs = coroutineContext.la(Key_getInstance_0());
    return tmp0_elvis_lhs == null ? get_asCoroutineDispatcher(get_platformEdt()) : tmp0_elvis_lhs;
  }
  function Companion_116() {
  }
  var Companion_instance_116;
  function Companion_getInstance_116() {
    return Companion_instance_116;
  }
  function DomainModel$services$lambda(this$0) {
    return function () {
      return this$0.i72_1.i6k();
    };
  }
  function DomainModel$services$lambda_0(it) {
    return new ResolveConfigImpl(ReferenceFactoryRegistryService_getInstance().e2o(it), ReferenceTargetsSuppliersRegistryService_getInstance().e2o(it), ReferenceTargetPresentationProvidersRegistryService_getInstance().e2o(it));
  }
  function DomainModel$services$lambda_1(this$0) {
    return function (it) {
      return new NodeSetupContext(this$0.i72_1.o71(), ReferenceFactoryRegistryService_getInstance().e2o(it));
    };
  }
  function DomainModel$services$lambda_2(it) {
    return ConceptRegistryService_instance.e2o(it).d6p(ReferenceFactoryRegistryService_getInstance().e2o(it));
  }
  function DomainModel(language, structureModel, additionalServices, parentCoroutineContext) {
    parentCoroutineContext = parentCoroutineContext === VOID ? EmptyCoroutineContext_getInstance() : parentCoroutineContext;
    this.h72_1 = language;
    this.i72_1 = structureModel;
    this.j72_1 = SupervisorJob(parentCoroutineContext.la(Key_instance_3));
    this.k72_1 = edt(Companion_instance_116, parentCoroutineContext);
    this.l72_1 = parentCoroutineContext.ej(this.j72_1).ej(this.k72_1);
    var tmp = this;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'jetbrains.ocelot.langDef.domain.DomainModel.services.<anonymous>' call
    var tmp_0 = Companion_instance_33.k2o(this.l72_1, [CoroutineContextService_getInstance()]);
    var tmp_1 = Companion_instance_33.o2o(this.i72_1);
    var tmp_2 = Companion_instance_33.k2o(this.i72_1.t70(), [UseExperimentalNodeService_instance]);
    var tmp_3 = Companion_instance_33;
    var initialServices = listOf_0([tmp_0, tmp_1, tmp_2, tmp_3.k2o(new NodePointersService(DomainModel$services$lambda(this)), [Companion_instance_88]), Companion_instance_33.k2o(this.i72_1.o71(), [WrapperContextService_instance]), ensureNotNull(this.h72_1.h2p(StructureAspect_instance)), Companion_instance_33.k2o(new GlobalNodeFinder(this.i72_1.i6k()), [Companion_instance_96]), Companion_instance_33.k2o(new SameModelNodeFinder(this.i72_1.o71()), [Companion_instance_92])]);
    this_0.o(initialServices);
    var tmp0_safe_receiver = this.h72_1.h2p(ReferenceFactoryRegistryAspect_instance);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.domain.DomainModel.services.<anonymous>.<anonymous>' call
      this_0.e(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = this.h72_1.h2p(ReferenceTargetsSuppliersRegistryAspect_instance);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.domain.DomainModel.services.<anonymous>.<anonymous>' call
      this_0.e(tmp1_safe_receiver);
    }
    var tmp2_safe_receiver = this.h72_1.h2p(ReferenceTargetPresentationProvidersRegistryAspect_instance);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.domain.DomainModel.services.<anonymous>.<anonymous>' call
      this_0.e(tmp2_safe_receiver);
    }
    var tmp_4 = Companion_instance_33;
    var tmp_5 = [ResolveConfigService_instance];
    this_0.e(tmp_4.m2o(tmp_5, VOID, DomainModel$services$lambda_0));
    var tmp_6 = Companion_instance_33;
    var tmp_7 = [NodeSetupContextService_instance];
    this_0.e(tmp_6.m2o(tmp_7, VOID, DomainModel$services$lambda_1(this)));
    var tmp_8;
    if (this.i72_1.t70()) {
      var tmp_9 = Companion_instance_33;
      var tmp_10 = [OtNodeFactoryService_instance];
      tmp_8 = tmp_9.m2o(tmp_10, VOID, DomainModel$services$lambda_2);
    } else {
      tmp_8 = Companion_instance_33.k2o(RawNodeFactory_instance, [OtNodeFactoryService_instance]);
    }
    var otNodeFactoryService = tmp_8;
    this_0.e(otNodeFactoryService);
    addAll_0(this_0, additionalServices);
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = this_0.e4();
    var tmp$ret$9 = copyToArray(this_1);
    tmp.m72_1 = serviceContainer(tmp$ret$9.slice());
    this.n72_1 = ensureNotNull(this.m72_1.h2o(ConceptRegistryService_instance));
    this.o72_1 = ensureNotNull(this.m72_1.h2o(ResolveConfigService_instance));
    this.p72_1 = ensureNotNull(this.m72_1.h2o(NodeSetupContextService_instance));
    this.q72_1 = ensureNotNull(this.m72_1.h2o(OtNodeFactoryService_instance));
    var wrapperContext = this.i72_1.o71();
    var tmp_11 = this.n72_1;
    if (isInterface(tmp_11, NodeWrapperConceptRegistry)) {
      wrapperContext.k4u(this.n72_1.c6p());
    }
    wrapperContext.p4u(Companion_getInstance_94().a6p_1, this.p72_1);
    wrapperContext.p4u(get_OT_CONCEPT_REGISTRY_CONTEXT_KEY(), this.n72_1);
    wrapperContext.p4u(get_OT_NODE_FACTORY_CONTEXT_KEY(), this.q72_1);
    wrapperContext.p4u(get_TYPED_NODE_CONTEXT_KEY(), new TypedNodeContext(this.n72_1, ReferenceFactoryRegistryService_getInstance().e2o(this.m72_1)));
    wrapperContext.p4u(get_USE_EXPERIMENTAL_NODE_KEY(), this.i72_1.t70());
  }
  protoOf(DomainModel).vr = function () {
    this.m72_1.vr();
    this.j72_1.pu();
  };
  function ErrorBase(message) {
    this.r72_1 = message;
  }
  protoOf(ErrorBase).t1 = function () {
    return this.r72_1;
  };
  function ErrorForAllNode(message, node) {
    ErrorBase.call(this, message);
    this.t72_1 = listOf(node);
  }
  protoOf(ErrorForAllNode).b3a = function () {
    return this.t72_1;
  };
  function ErrorForDescendants(message, descendantNodes) {
    ErrorBase.call(this, message);
    this.v72_1 = listOf_0(descendantNodes.slice());
  }
  protoOf(ErrorForDescendants).b3a = function () {
    return this.v72_1;
  };
  function Companion_117() {
  }
  var Companion_instance_117;
  function Companion_getInstance_117() {
    return Companion_instance_117;
  }
  function Empty_1() {
  }
  protoOf(Empty_1).w72 = function (concept) {
    return emptyList();
  };
  var Empty_instance_0;
  function Empty_getInstance_0() {
    return Empty_instance_0;
  }
  function ErrorCheckConfig() {
  }
  function EmptyErrorCheckConfig() {
  }
  protoOf(EmptyErrorCheckConfig).w72 = function (concept) {
    return emptyList();
  };
  var EmptyErrorCheckConfig_instance;
  function EmptyErrorCheckConfig_getInstance() {
    return EmptyErrorCheckConfig_instance;
  }
  function errorChecking(init) {
    var tmp = Companion_instance_33;
    var tmp_0 = [Companion_instance_117];
    return tmp.m2o(tmp_0, VOID, errorChecking$lambda(init));
  }
  function ErrorCheckConfigBuilder() {
  }
  function implClass($this, conceptClass) {
    var descriptor = $this.z72_1.z6o(conceptClass);
    return ensureNotNull(descriptor.j6q());
  }
  function ErrorCheckConfigBuilderImpl$build$1(this$0) {
    this.b73_1 = this$0;
  }
  protoOf(ErrorCheckConfigBuilderImpl$build$1).w72 = function (concept) {
    var list = this.b73_1.a73_1.y2(concept);
    var checkFunctionList = (!(list == null) ? isInterface(list, KtList) : false) ? list : null;
    var tmp;
    if (checkFunctionList == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(checkFunctionList, 10));
      var _iterator__ex2g4s = checkFunctionList.k();
      while (_iterator__ex2g4s.l()) {
        var item = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.langDef.check.config.<no name provided>.checking.<anonymous>' call
        var tmp$ret$0 = asChecker(item);
        destination.e(tmp$ret$0);
      }
      tmp = destination;
    }
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  function ErrorCheckConfigBuilderImpl(conceptRegistry, services) {
    ErrorCheckConfigBuilder.call(this);
    this.y72_1 = services;
    this.z72_1 = conceptRegistry;
    this.a73_1 = HashMap_init_$Create$();
  }
  protoOf(ErrorCheckConfigBuilderImpl).x72 = function (_this__u8e3s4, code) {
    var tmp0 = this.a73_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var key = implClass(this, _this__u8e3s4);
    var value = tmp0.y2(key);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilderImpl.checkedBy.<anonymous>' call
      var answer = ArrayList_init_$Create$();
      tmp0.r2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    tmp.e(code);
  };
  protoOf(ErrorCheckConfigBuilderImpl).k2p = function () {
    return new ErrorCheckConfigBuilderImpl$build$1(this);
  };
  protoOf(ErrorCheckConfigBuilderImpl).h2o = function (key) {
    return this.y72_1.h2o(key);
  };
  protoOf(ErrorCheckConfigBuilderImpl).e2p = function (_this__u8e3s4, thisRef, property) {
    return this.y72_1.e2p(_this__u8e3s4, thisRef, property);
  };
  function asChecker(_this__u8e3s4) {
    return new asChecker$1(_this__u8e3s4);
  }
  function errorChecking$lambda($init) {
    return function (services) {
      var conceptRegistry = ensureNotNull(services.h2o(ConceptRegistryService_instance));
      // Inline function 'kotlin.also' call
      var this_0 = new ErrorCheckConfigBuilderImpl(conceptRegistry, services);
      $init(this_0);
      return this_0.k2p();
    };
  }
  function asChecker$1($this_asChecker) {
    this.c73_1 = $this_asChecker;
  }
  protoOf(asChecker$1).d73 = function (node) {
    return this.c73_1(node);
  };
  function anyOf(filters) {
    var tmp = anyOf$lambda(filters);
    return new sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0(tmp);
  }
  function $runSuspendCOROUTINE$0_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m73_1 = _this__u8e3s4;
    this.n73_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$0_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            var tmp_0 = this;
            tmp_0.o73_1 = this.n73_1;
            this.p73_1 = this.o73_1;
            var tmp_1 = this;
            tmp_1.q73_1 = this.m73_1.y73_1.x73_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.s73_1 = this.q73_1;
            var tmp_2;
            var tmp_3 = this.s73_1;
            if (isInterface(tmp_3, Collection)) {
              tmp_2 = this.s73_1.p();
            } else {
              tmp_2 = false;
            }

            if (tmp_2) {
              this.r73_1 = true;
              this.y9_1 = 8;
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.t73_1 = this.s73_1.k();
            this.y9_1 = 3;
            continue $sm;
          case 3:
            if (!this.t73_1.l()) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.u73_1 = this.t73_1.m();
            var tmp_4 = this;
            tmp_4.v73_1 = this.u73_1;
            this.w73_1 = this.v73_1;
            this.y9_1 = 4;
            suspendResult = this.p73_1.m51(this.w73_1.a74(this.m73_1.z73_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var ARGUMENT = suspendResult;
            if (!ARGUMENT) {
              this.r73_1 = false;
              this.y9_1 = 8;
              continue $sm;
            } else {
              this.y9_1 = 5;
              continue $sm;
            }

          case 5:
            this.y9_1 = 3;
            continue $sm;
          case 6:
            this.r73_1 = true;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 8;
            continue $sm;
          case 7:
            throw this.ba_1;
          case 8:
            return this.r73_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function CompositeScopeFilter$apply$$inlined$suspendingQuery$1(this$0, $target) {
    this.y73_1 = this$0;
    this.z73_1 = $target;
  }
  protoOf(CompositeScopeFilter$apply$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$0_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CompositeScopeFilter$apply$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function CompositeScopeFilter(filters) {
    this.x73_1 = filters;
  }
  protoOf(CompositeScopeFilter).a74 = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new CompositeScopeFilter$apply$$inlined$suspendingQuery$1(this, target);
  };
  function sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0(function_0) {
    this.b74_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0).a74 = function (target) {
    return this.b74_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0).b4 = function () {
    return this.b74_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeFilter) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function $runSuspendCOROUTINE$1_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k74_1 = _this__u8e3s4;
    this.l74_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$1_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            var tmp_0 = this;
            tmp_0.m74_1 = this.l74_1;
            this.n74_1 = this.m74_1;
            var tmp_1 = this;
            tmp_1.o74_1 = this.k74_1.v74_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.q74_1 = this.o74_1;
            var tmp_2;
            var tmp_3 = this.q74_1;
            if (isInterface(tmp_3, Collection)) {
              tmp_2 = this.q74_1.p();
            } else {
              tmp_2 = false;
            }

            if (tmp_2) {
              this.p74_1 = false;
              this.y9_1 = 8;
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.r74_1 = this.q74_1.k();
            this.y9_1 = 3;
            continue $sm;
          case 3:
            if (!this.r74_1.l()) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.s74_1 = this.r74_1.m();
            var tmp_4 = this;
            tmp_4.t74_1 = this.s74_1;
            this.u74_1 = this.t74_1;
            this.y9_1 = 4;
            suspendResult = this.n74_1.m51(this.u74_1.a74(this.k74_1.w74_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            if (suspendResult) {
              this.p74_1 = true;
              this.y9_1 = 8;
              continue $sm;
            } else {
              this.y9_1 = 5;
              continue $sm;
            }

          case 5:
            this.y9_1 = 3;
            continue $sm;
          case 6:
            this.p74_1 = false;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 8;
            continue $sm;
          case 7:
            throw this.ba_1;
          case 8:
            return this.p74_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function anyOf$1$$inlined$suspendingQuery$1($filters, $target) {
    this.v74_1 = $filters;
    this.w74_1 = $target;
  }
  protoOf(anyOf$1$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$1_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(anyOf$1$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function anyOf$lambda($filters) {
    return function (target) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new anyOf$1$$inlined$suspendingQuery$1($filters, target);
    };
  }
  function Companion_118() {
    Companion_instance_118 = this;
    this.x74_1 = emptySet();
    this.y74_1 = new NamingInfo('');
  }
  var Companion_instance_118;
  function Companion_getInstance_118() {
    if (Companion_instance_118 == null)
      new Companion_118();
    return Companion_instance_118;
  }
  function NamingInfo(mainName, alternativeNames, additionalText) {
    Companion_getInstance_118();
    alternativeNames = alternativeNames === VOID ? Companion_getInstance_118().x74_1 : alternativeNames;
    additionalText = additionalText === VOID ? null : additionalText;
    this.z74_1 = mainName;
    this.a75_1 = alternativeNames;
    this.b75_1 = additionalText;
  }
  protoOf(NamingInfo).c75 = function () {
    return plus_8(setOf(this.z74_1), this.a75_1);
  };
  function NoopScopeFilter() {
  }
  protoOf(NoopScopeFilter).d75 = function (target) {
    return Companion_getInstance_76().k51_1;
  };
  protoOf(NoopScopeFilter).a74 = function (target) {
    return this.d75(!(target == null) ? target : THROW_CCE());
  };
  var NoopScopeFilter_instance;
  function NoopScopeFilter_getInstance() {
    return NoopScopeFilter_instance;
  }
  function DefaultOrigin(namespace) {
    Origin.call(this, namespace);
  }
  function Origin(namespace) {
    this.e75_1 = namespace;
  }
  function ImportOrigin(namespace) {
    Origin.call(this, namespace);
  }
  function ChildPlaceholderOrigin(namespace, link) {
    LexicalOrigin.call(this, namespace);
    this.g75_1 = link;
  }
  function LexicalOrigin(namespace) {
    Origin.call(this, namespace);
  }
  function Scope() {
  }
  function combine(_this__u8e3s4) {
    if (_this__u8e3s4.p())
      return NoopScopeFilter_instance;
    if (_this__u8e3s4.n() === 1)
      return first(_this__u8e3s4);
    // Inline function 'kotlin.collections.arrayListOf' call
    var filters = ArrayList_init_$Create$();
    var _iterator__ex2g4s = _this__u8e3s4.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var filter = _iterator__ex2g4s.m();
      if (filter instanceof NoopScopeFilter)
        continue $l$loop;
      else {
        if (filter instanceof CompositeScopeFilter)
          filters.o(filter.x73_1);
        else {
          filters.e(filter);
        }
      }
    }
    switch (filters.n()) {
      case 0:
        return NoopScopeFilter_instance;
      case 1:
        return first(filters);
      default:
        return new CompositeScopeFilter(filters);
    }
  }
  function $runSuspendCOROUTINE$2(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t75_1 = _this__u8e3s4;
    this.u75_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$2).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.v75_1 = this.u75_1;
            this.w75_1 = this.v75_1;
            this.y9_1 = 1;
            suspendResult = this.t75_1.x75_1(this.w75_1, this.t75_1.y75_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0(function_0) {
    this.z75_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0).a74 = function (target) {
    return this.z75_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0).b4 = function () {
    return this.z75_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeFilter) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0).hashCode = function () {
    return hashCode(this.b4());
  };
  function ScopeFilter$Companion$query$1$$inlined$suspendingQuery$1($body, $it) {
    this.x75_1 = $body;
    this.y75_1 = $it;
  }
  protoOf(ScopeFilter$Companion$query$1$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$2(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopeFilter$Companion$query$1$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopeFilter$Companion$query$lambda($body) {
    return function (it) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new ScopeFilter$Companion$query$1$$inlined$suspendingQuery$1($body, it);
    };
  }
  function Companion_119() {
  }
  protoOf(Companion_119).a76 = function (body) {
    var tmp = ScopeFilter$Companion$query$lambda(body);
    return new sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_0(tmp);
  };
  var Companion_instance_119;
  function Companion_getInstance_119() {
    return Companion_instance_119;
  }
  function ScopeFilter() {
  }
  function namespace($this, targetClass) {
    return new FallbackScopingRulesProvider$namespace$1(targetClass);
  }
  function FallbackScopingRulesProvider$namespace$1($targetClass) {
    this.b76_1 = $targetClass;
  }
  function FallbackScopingRulesProvider(providerScopes, scopeConstraints, defaultScopes, engine) {
    this.c76_1 = providerScopes;
    this.d76_1 = scopeConstraints;
    this.e76_1 = defaultScopes;
    this.f76_1 = engine;
  }
  protoOf(FallbackScopingRulesProvider).g76 = function (provider, originSelector, targetConcept) {
    var spec = new ScopingRuleSpec(provider.j76_1, targetConcept);
    var tmp = this.c76_1.y2(spec);
    var tmp0_elvis_lhs = (tmp == null ? true : typeof tmp === 'function') ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance_76().i51_1;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var scopeSupplier = tmp_0;
    var namespace_0 = namespace(this, targetConcept);
    var tmp_1;
    if (equals(originSelector, Any_getInstance())) {
      tmp_1 = new DefaultOrigin(namespace_0);
    } else {
      if (equals(originSelector, Import_getInstance())) {
        tmp_1 = new ImportOrigin(namespace_0);
      } else {
        if (equals(originSelector, Lexical_getInstance())) {
          tmp_1 = new ChildPlaceholderOrigin(namespace_0, null);
        } else {
          if (originSelector instanceof LexicalWithRole) {
            tmp_1 = new ChildPlaceholderOrigin(namespace_0, originSelector.n76_1);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    var origin = tmp_1;
    var scopeContext = this.f76_1.z76(targetConcept, RuleEvaluationStrategy_EAGER_getInstance(), this.f76_1.y76(provider), provider.k76_1());
    return scopeSupplier(scopeContext, provider.k76_1(), origin);
  };
  protoOf(FallbackScopingRulesProvider).a77 = function (targetConcept) {
    var tmp = this.e76_1.y2(targetConcept);
    var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'function' : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance_76().i51_1;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var scopeSupplier = tmp_0;
    var defaultOrigin = new DefaultOrigin(namespace(this, targetConcept));
    var scopeContext = this.f76_1.z76(targetConcept, RuleEvaluationStrategy_EAGER_getInstance(), this.f76_1.b77(), null);
    return scopeSupplier(scopeContext, defaultOrigin);
  };
  protoOf(FallbackScopingRulesProvider).c77 = function (providerConcept, scopeConstraintId) {
    var spec = new ScopeConstraintRuleSpec(providerConcept, scopeConstraintId);
    var tmp = this.d76_1.y2(spec);
    return (tmp == null ? true : isInterface(tmp, ScopeConstraintProvider)) ? tmp : THROW_CCE();
  };
  function scopes(_this__u8e3s4, body) {
    _this__u8e3s4.l2p(ScopeAspect_instance, new ScopeDefinition(body));
  }
  function ScopeAspect$createConfigurationService$lambda($definitions) {
    return function (it) {
      var builder = ScopeAspect_instance.d77(it);
      var _iterator__ex2g4s = $definitions.k();
      while (_iterator__ex2g4s.l()) {
        var definition = _iterator__ex2g4s.m();
        definition.e77_1(builder);
      }
      return builder.k2p();
    };
  }
  function ScopeAspect() {
  }
  protoOf(ScopeAspect).j77 = function (definitions) {
    var tmp = Companion_instance_33;
    var tmp_0 = [ScopeConfigService_instance];
    return tmp.m2o(tmp_0, VOID, ScopeAspect$createConfigurationService$lambda(definitions));
  };
  protoOf(ScopeAspect).i2p = function (definitions) {
    return this.j77(definitions);
  };
  protoOf(ScopeAspect).d77 = function (services) {
    var conceptRegistry = ensureNotNull(services.h2o(ConceptRegistryService_instance));
    return new ScopeConfigBuilder0Fallback(conceptRegistry, new ScopeConfigBuilderImpl(conceptRegistry, services));
  };
  var ScopeAspect_instance;
  function ScopeAspect_getInstance() {
    return ScopeAspect_instance;
  }
  function ScopeDefinition(body) {
    this.e77_1 = body;
  }
  function ScopeConstraintRuleSpec(provider, scopeConstraint) {
    this.k77_1 = provider;
    this.l77_1 = scopeConstraint;
  }
  protoOf(ScopeConstraintRuleSpec).toString = function () {
    return 'ScopeConstraintRuleSpec(provider=' + toString_1(this.k77_1) + ', scopeConstraint=' + toString_1(this.l77_1) + ')';
  };
  protoOf(ScopeConstraintRuleSpec).hashCode = function () {
    var result = this.k77_1.hashCode();
    result = imul(result, 31) + hashCode(this.l77_1) | 0;
    return result;
  };
  protoOf(ScopeConstraintRuleSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScopeConstraintRuleSpec))
      return false;
    var tmp0_other_with_cast = other instanceof ScopeConstraintRuleSpec ? other : THROW_CCE();
    if (!this.k77_1.equals(tmp0_other_with_cast.k77_1))
      return false;
    if (!equals(this.l77_1, tmp0_other_with_cast.l77_1))
      return false;
    return true;
  };
  function ConstraintProviderSpec(provider, target) {
    this.m77_1 = provider;
    this.n77_1 = target;
  }
  protoOf(ConstraintProviderSpec).toString = function () {
    return 'ConstraintProviderSpec(provider=' + toString_1(this.m77_1) + ', target=' + toString_1(this.n77_1) + ')';
  };
  protoOf(ConstraintProviderSpec).hashCode = function () {
    var result = this.m77_1.hashCode();
    result = imul(result, 31) + this.n77_1.hashCode() | 0;
    return result;
  };
  protoOf(ConstraintProviderSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConstraintProviderSpec))
      return false;
    var tmp0_other_with_cast = other instanceof ConstraintProviderSpec ? other : THROW_CCE();
    if (!this.m77_1.equals(tmp0_other_with_cast.m77_1))
      return false;
    if (!this.n77_1.equals(tmp0_other_with_cast.n77_1))
      return false;
    return true;
  };
  function ScopeConfigBuilder() {
  }
  function ScopingRuleSpec(provider, target) {
    this.p77_1 = provider;
    this.q77_1 = target;
  }
  protoOf(ScopingRuleSpec).toString = function () {
    return 'ScopingRuleSpec(provider=' + toString_1(this.p77_1) + ', target=' + toString_1(this.q77_1) + ')';
  };
  protoOf(ScopingRuleSpec).hashCode = function () {
    var result = this.p77_1.hashCode();
    result = imul(result, 31) + this.q77_1.hashCode() | 0;
    return result;
  };
  protoOf(ScopingRuleSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScopingRuleSpec))
      return false;
    var tmp0_other_with_cast = other instanceof ScopingRuleSpec ? other : THROW_CCE();
    if (!this.p77_1.equals(tmp0_other_with_cast.p77_1))
      return false;
    if (!this.q77_1.equals(tmp0_other_with_cast.q77_1))
      return false;
    return true;
  };
  function ScopeConfigBuilder0$buildFallbackConfig$ref($boundThis) {
    var l = function (p0) {
      return $boundThis.r77(p0);
    };
    l.callableName = 'buildFallbackConfig';
    return l;
  }
  function ScopeConfigBuilder0(conceptRegistry, services) {
    this.f77_1 = services;
    this.g77_1 = conceptRegistry;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.h77_1 = ArrayList_init_$Create$();
    this.i77_1 = HashMap_init_$Create$_1(Companion_getInstance_120().u77_1);
  }
  protoOf(ScopeConfigBuilder0).v77 = function (conceptClass) {
    var descriptor = this.g77_1.z6o(conceptClass);
    return ensureNotNull(descriptor.j6q());
  };
  protoOf(ScopeConfigBuilder0).w77 = function (definition) {
    this.h77_1.e(definition);
  };
  protoOf(ScopeConfigBuilder0).r77 = function (engine) {
    return null;
  };
  protoOf(ScopeConfigBuilder0).k2p = function () {
    var tmp = asSequence_0(this.h77_1);
    var tmp_0 = CoroutineContextService_getInstance().e2o(this);
    var tmp_1 = Companion_getInstance_126().e2o(this);
    var tmp_2 = Companion_getInstance_123().e2o(this);
    var tmp_3 = Companion_instance_122.i2o(this);
    return new ScopingRulesEngine(tmp, this.i77_1, tmp_0, tmp_1, tmp_2, tmp_3, ScopeConfigBuilder0$buildFallbackConfig$ref(this));
  };
  protoOf(ScopeConfigBuilder0).h2o = function (key) {
    return this.f77_1.h2o(key);
  };
  protoOf(ScopeConfigBuilder0).e2p = function (_this__u8e3s4, thisRef, property) {
    return this.f77_1.e2p(_this__u8e3s4, thisRef, property);
  };
  function ScopeConfigBuilder0Fallback(conceptRegistry, fallbackBuilder) {
    ScopeConfigBuilder0.call(this, conceptRegistry, fallbackBuilder);
    this.b78_1 = fallbackBuilder;
  }
  protoOf(ScopeConfigBuilder0Fallback).r77 = function (engine) {
    return this.b78_1.h78(engine);
  };
  protoOf(ScopeConfigBuilder0Fallback).h2o = function (key) {
    return this.b78_1.h2o(key);
  };
  protoOf(ScopeConfigBuilder0Fallback).e2p = function (_this__u8e3s4, thisRef, property) {
    return this.b78_1.e2p(_this__u8e3s4, thisRef, property);
  };
  protoOf(ScopeConfigBuilder0Fallback).i78 = function (_this__u8e3s4, filter) {
    this.b78_1.i78(_this__u8e3s4, filter);
  };
  protoOf(ScopeConfigBuilder0Fallback).j78 = function (_this__u8e3s4, target) {
    return this.b78_1.j78(_this__u8e3s4, target);
  };
  protoOf(ScopeConfigBuilder0Fallback).o77 = function (_this__u8e3s4, constraint) {
    return this.b78_1.o77(_this__u8e3s4, constraint);
  };
  function $runSuspendCOROUTINE$3(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s78_1 = _this__u8e3s4;
    this.t78_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.u78_1 = this.t78_1;
            this.v78_1 = this.u78_1;
            this.y9_1 = 1;
            suspendResult = this.s78_1.w78_1(new ScopeConstraintBuilder(this.v78_1.g4x_1), this.s78_1.x78_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function implClass_0($this, conceptClass) {
    var descriptor = $this.c78_1.z6o(conceptClass);
    return ensureNotNull(descriptor.j6q());
  }
  function sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0(function_0) {
    this.y78_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0).z78 = function (provider) {
    return this.y78_1(provider);
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0).b4 = function () {
    return this.y78_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeConstraintProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function ScopeConfigBuilderImpl$by$2$$inlined$suspendingQuery$1($filter, $provider) {
    this.w78_1 = $filter;
    this.x78_1 = $provider;
  }
  protoOf(ScopeConfigBuilderImpl$by$2$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$3(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopeConfigBuilderImpl$by$2$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopeConfigBuilderImpl$by$lambda($filter) {
    return function (provider) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new ScopeConfigBuilderImpl$by$2$$inlined$suspendingQuery$1($filter, provider);
    };
  }
  function ScopeConfigBuilderImpl(conceptRegistry, services) {
    this.c78_1 = conceptRegistry;
    this.d78_1 = services;
    this.e78_1 = HashMap_init_$Create$();
    this.f78_1 = HashMap_init_$Create$();
    this.g78_1 = HashMap_init_$Create$();
  }
  protoOf(ScopeConfigBuilderImpl).i78 = function (_this__u8e3s4, filter) {
    var tmp0 = this.f78_1;
    var tmp = ScopeConfigBuilderImpl$by$lambda(filter);
    // Inline function 'kotlin.collections.set' call
    var value = new sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0(tmp);
    tmp0.r2(_this__u8e3s4, value);
  };
  protoOf(ScopeConfigBuilderImpl).j78 = function (_this__u8e3s4, target) {
    return new ConstraintProviderSpec(implClass_0(this, _this__u8e3s4), target);
  };
  protoOf(ScopeConfigBuilderImpl).h78 = function (engine) {
    return new FallbackScopingRulesProvider(this.e78_1, this.f78_1, this.g78_1, engine);
  };
  protoOf(ScopeConfigBuilderImpl).h2o = function (key) {
    return this.d78_1.h2o(key);
  };
  protoOf(ScopeConfigBuilderImpl).e2p = function (_this__u8e3s4, thisRef, property) {
    return this.d78_1.e2p(_this__u8e3s4, thisRef, property);
  };
  function CollectionScopeFactory$Companion$Default$1() {
  }
  protoOf(CollectionScopeFactory$Companion$Default$1).a79 = function (specification, ruleEvaluationScope, collection, nameFunction) {
    return constant(new CollectionScope(specification, collection, nameFunction));
  };
  function CollectionScopeFactory$Companion$Indexed$1() {
  }
  protoOf(CollectionScopeFactory$Companion$Indexed$1).a79 = function (specification, ruleEvaluationScope, collection, nameFunction) {
    return createIndexingScope(specification, ruleEvaluationScope, collection, nameFunction);
  };
  function Companion_120() {
    Companion_instance_120 = this;
    var tmp = this;
    tmp.s77_1 = new CollectionScopeFactory$Companion$Default$1();
    var tmp_0 = this;
    tmp_0.t77_1 = new CollectionScopeFactory$Companion$Indexed$1();
    this.u77_1 = mapOf_0([to(RuleEvaluationStrategy_PER_REQUEST_getInstance(), this.s77_1), to(RuleEvaluationStrategy_EAGER_getInstance(), this.s77_1), to(RuleEvaluationStrategy_INDEXED_getInstance(), this.t77_1)]);
  }
  var Companion_instance_120;
  function Companion_getInstance_120() {
    if (Companion_instance_120 == null)
      new Companion_120();
    return Companion_instance_120;
  }
  function createIndexingScope(specification, ruleEvaluationScope, rawCollection, nameFunction) {
    var tmp;
    if (!(ruleEvaluationScope.c79_1 == null)) {
      tmp = ruleEvaluationScope.c79_1.e79(specification, rawCollection, nameFunction);
    } else {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      tmp = new createIndexingScope$$inlined$suspendingQuery$1(specification, rawCollection, nameFunction);
    }
    return tmp;
  }
  function $runSuspendCOROUTINE$6(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n79_1 = _this__u8e3s4;
    this.o79_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$6).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.p79_1 = this.o79_1;
            this.q79_1 = this.p79_1;
            this.y9_1 = 1;
            suspendResult = IndexingCollectionScope(this.q79_1, this.n79_1.r79_1, this.n79_1.s79_1, this.n79_1.t79_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function createIndexingScope$$inlined$suspendingQuery$1($specification, $rawCollection, $nameFunction) {
    this.r79_1 = $specification;
    this.s79_1 = $rawCollection;
    this.t79_1 = $nameFunction;
  }
  protoOf(createIndexingScope$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$6(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(createIndexingScope$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function generalize($this, selector, times) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(times >= 0)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(times < selector.v79_1)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message_0 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var current = selector;
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'jetbrains.ocelot.langDef.scopes.config.api.Companion.generalize.<anonymous>' call
        current = ensureNotNull(current.u79_1);
      }
       while (inductionVariable < times);
    return current;
  }
  function Any() {
    Any_instance = this;
    OriginSelector.call(this, null);
  }
  var Any_instance;
  function Any_getInstance() {
    if (Any_instance == null)
      new Any();
    return Any_instance;
  }
  function Lexical() {
    Lexical_instance = this;
    OriginSelector.call(this, Any_getInstance());
  }
  var Lexical_instance;
  function Lexical_getInstance() {
    if (Lexical_instance == null)
      new Lexical();
    return Lexical_instance;
  }
  function Import() {
    Import_instance = this;
    OriginSelector.call(this, Any_getInstance());
  }
  var Import_instance;
  function Import_getInstance() {
    if (Import_instance == null)
      new Import();
    return Import_instance;
  }
  function LexicalWithRole(link) {
    OriginSelector.call(this, Lexical_getInstance());
    this.n76_1 = link;
  }
  protoOf(LexicalWithRole).toString = function () {
    return 'LexicalWithRole(link=' + this.n76_1.toString() + ')';
  };
  protoOf(LexicalWithRole).hashCode = function () {
    return this.n76_1.hashCode();
  };
  protoOf(LexicalWithRole).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LexicalWithRole))
      return false;
    var tmp0_other_with_cast = other instanceof LexicalWithRole ? other : THROW_CCE();
    if (!this.n76_1.equals(tmp0_other_with_cast.n76_1))
      return false;
    return true;
  };
  function Companion_121() {
  }
  var Companion_instance_121;
  function Companion_getInstance_121() {
    return Companion_instance_121;
  }
  function OriginSelector(parent) {
    this.u79_1 = parent;
    this.v79_1 = this.u79_1 == null ? 1 : 1 + this.u79_1.v79_1 | 0;
  }
  protoOf(OriginSelector).w79 = function (selector) {
    var delta = this.v79_1 - selector.v79_1 | 0;
    if (delta < 0)
      return false;
    return equals(generalize(Companion_instance_121, this, delta), selector);
  };
  function RuleEvaluationScope(strategy, sharedScopes) {
    this.b79_1 = strategy;
    this.c79_1 = sharedScopes;
  }
  var RuleEvaluationStrategy_PER_REQUEST_instance;
  var RuleEvaluationStrategy_EAGER_instance;
  var RuleEvaluationStrategy_INDEXED_instance;
  var RuleEvaluationStrategy_entriesInitialized;
  function RuleEvaluationStrategy_initEntries() {
    if (RuleEvaluationStrategy_entriesInitialized)
      return Unit_instance;
    RuleEvaluationStrategy_entriesInitialized = true;
    RuleEvaluationStrategy_PER_REQUEST_instance = new RuleEvaluationStrategy('PER_REQUEST', 0, false);
    RuleEvaluationStrategy_EAGER_instance = new RuleEvaluationStrategy('EAGER', 1, true);
    RuleEvaluationStrategy_INDEXED_instance = new RuleEvaluationStrategy('INDEXED', 2, true);
  }
  function RuleEvaluationStrategy(name, ordinal, eager) {
    Enum.call(this, name, ordinal);
    this.z79_1 = eager;
  }
  function RuleEvaluationStrategy_PER_REQUEST_getInstance() {
    RuleEvaluationStrategy_initEntries();
    return RuleEvaluationStrategy_PER_REQUEST_instance;
  }
  function RuleEvaluationStrategy_EAGER_getInstance() {
    RuleEvaluationStrategy_initEntries();
    return RuleEvaluationStrategy_EAGER_instance;
  }
  function RuleEvaluationStrategy_INDEXED_getInstance() {
    RuleEvaluationStrategy_initEntries();
    return RuleEvaluationStrategy_INDEXED_instance;
  }
  function $constrainedInAncestorsCOROUTINE$7(_this__u8e3s4, _this__u8e3s4_0, constraintId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i7a_1 = _this__u8e3s4;
    this.j7a_1 = _this__u8e3s4_0;
    this.k7a_1 = constraintId;
  }
  protoOf($constrainedInAncestorsCOROUTINE$7).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.i7a_1.m51(this.i7a_1.m7a_1.n7a(this.k7a_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var constraints = suspendResult;
            if (constraints.p())
              return this.j7a_1;
            return filter_1(this.j7a_1, combine(constraints));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ScopeBuilderWithProvider(context, execution) {
    ScopeBuilder.call(this, context, execution);
  }
  protoOf(ScopeBuilderWithProvider).q7a = function ($completion) {
    return this.m51(this.m7a_1.r7a(), $completion);
  };
  protoOf(ScopeBuilderWithProvider).s7a = function (_this__u8e3s4, constraintId, $completion) {
    var tmp = new $constrainedInAncestorsCOROUTINE$7(this, _this__u8e3s4, constraintId, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function importScopeByLocation($this, reference, $completion) {
    var tmp = $this.n51(reference.r6s());
    var tmp0_elvis_lhs = tmp instanceof QualifiedReferenceContent ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Scopes_getInstance().y7a_1;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var content = tmp_0;
    var providerLocation = Companion_instance_124.z7a(content.j6t_1, getKClass(DomainNode));
    return $this.m51($this.m7a_1.a7b(providerLocation), $completion);
  }
  function $importScopeCOROUTINE$8(_this__u8e3s4, reference, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j7b_1 = _this__u8e3s4;
    this.k7b_1 = reference;
  }
  protoOf($importScopeCOROUTINE$8).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            this.y9_1 = 1;
            suspendResult = this.j7b_1.m51(this.k7b_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.l7b_1 = suspendResult;
            if (this.l7b_1 == null) {
              this.y9_1 = 2;
              suspendResult = importScopeByLocation(this.j7b_1, this.k7b_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.m7b_1 = this.l7b_1;
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            var tmp_0 = this;
            return suspendResult;
          case 3:
            this.n7b_1 = this.m7b_1;
            this.y9_1 = 4;
            suspendResult = this.j7b_1.m51(this.j7b_1.m7a_1.o7b(this.n7b_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return suspendResult;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ScopeBuilder(context, execution) {
    QueryBuilder.call(this, execution);
    this.m7a_1 = context;
  }
  protoOf(ScopeBuilder).t7a = function (collection, $completion) {
    return this.m51(this.m7a_1.p7b(collection), $completion);
  };
  protoOf(ScopeBuilder).u7a = function (collection, $completion) {
    return this.t7a(get_forQueries_4(get_asObservable_0(collection)), $completion);
  };
  protoOf(ScopeBuilder).v7a = function (reference, $completion) {
    var tmp = new $importScopeCOROUTINE$8(this, reference, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopeBuilder).w7a = function (provider, $completion) {
    return this.m51(this.m7a_1.o7b(provider), $completion);
  };
  protoOf(ScopeBuilder).x7a = function ($completion) {
    return this.m51(this.m7a_1.q7b(), $completion);
  };
  function ScopeConfigService() {
  }
  var ScopeConfigService_instance;
  function ScopeConfigService_getInstance() {
    return ScopeConfigService_instance;
  }
  function ScopeConstraintBuilder(execution) {
    QueryBuilder.call(this, execution);
    this.s7b_1 = NoopScopeFilter_instance;
  }
  function ScopeConstraintId() {
  }
  function ScopeConstraintProvider() {
  }
  function ScopeProvidersRegistry() {
  }
  function ProvideScope(provider, target, evaluationStrategy, origin, builder) {
    ScopingRuleDefinition.call(this);
    this.t7b_1 = provider;
    this.u7b_1 = target;
    this.v7b_1 = evaluationStrategy;
    this.w7b_1 = origin;
    this.x7b_1 = builder;
  }
  function DefaultScope(target, builder) {
    ScopingRuleDefinition.call(this);
    this.y7b_1 = target;
    this.z7b_1 = builder;
  }
  function ConstrainScope(source, id, builder) {
    ScopingRuleDefinition.call(this);
    this.a7c_1 = source;
    this.b7c_1 = id;
    this.c7c_1 = builder;
  }
  function ProvideName(target, name) {
    ScopingRuleDefinition.call(this);
    this.d7c_1 = target;
    this.e7c_1 = name;
  }
  function ScopingRuleDefinition() {
  }
  function $runSuspendCOROUTINE$10(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n7c_1 = _this__u8e3s4;
    this.o7c_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$10).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.p7c_1 = this.o7c_1;
            this.q7c_1 = Unit_instance;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.r7c_1 = this.p7c_1;
            this.s7c_1 = new ScopeKey(this.n7c_1.t7c_1, this.n7c_1.u7c_1, this.n7c_1.v7c_1);
            var tmp0 = this.n7c_1.w7c_1.d79_1;
            var key = this.s7c_1;
            if ((isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).w2(key)) {
              var tmp_1 = this;
              var tmp_2 = getValue_0(this.n7c_1.w7c_1.d79_1, this.s7c_1);
              tmp_1.q7c_1 = tmp_2 instanceof IndexingScope ? tmp_2 : THROW_CCE();
              this.y9_1 = 5;
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.y9_1 = 3;
            suspendResult = IndexingCollectionScope(this.r7c_1, this.n7c_1.t7c_1, this.n7c_1.u7c_1, this.n7c_1.v7c_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var scope = suspendResult;
            var tmp2 = this.n7c_1.w7c_1.d79_1;
            var key_0 = this.s7c_1;
            tmp2.r2(key_0, scope);
            this.q7c_1 = scope;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 5;
            continue $sm;
          case 4:
            throw this.ba_1;
          case 5:
            return this.q7c_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ScopeKey(specification, collection, nameFunction) {
    this.x7c_1 = specification;
    this.y7c_1 = collection;
    this.z7c_1 = nameFunction;
  }
  protoOf(ScopeKey).toString = function () {
    return 'ScopeKey(specification=' + this.x7c_1.toString() + ', collection=' + toString_1(this.y7c_1) + ', nameFunction=' + toString_1(this.z7c_1) + ')';
  };
  protoOf(ScopeKey).hashCode = function () {
    var result = this.x7c_1.hashCode();
    result = imul(result, 31) + hashCode(this.y7c_1) | 0;
    result = imul(result, 31) + hashCode(this.z7c_1) | 0;
    return result;
  };
  protoOf(ScopeKey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScopeKey))
      return false;
    var tmp0_other_with_cast = other instanceof ScopeKey ? other : THROW_CCE();
    if (!this.x7c_1.equals(tmp0_other_with_cast.x7c_1))
      return false;
    if (!equals(this.y7c_1, tmp0_other_with_cast.y7c_1))
      return false;
    if (!equals(this.z7c_1, tmp0_other_with_cast.z7c_1))
      return false;
    return true;
  };
  function Companion_122() {
  }
  var Companion_instance_122;
  function Companion_getInstance_122() {
    return Companion_instance_122;
  }
  function SharedScopesContainer$indexingScopeFor$$inlined$suspendingQuery$1($specification, $collection, $nameFunction, this$0) {
    this.t7c_1 = $specification;
    this.u7c_1 = $collection;
    this.v7c_1 = $nameFunction;
    this.w7c_1 = this$0;
  }
  protoOf(SharedScopesContainer$indexingScopeFor$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$10(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(SharedScopesContainer$indexingScopeFor$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function Empty_2() {
  }
  protoOf(Empty_2).a7d = function (scope, targetConcept) {
    return Companion_getInstance_76().i51_1;
  };
  var Empty_instance_1;
  function Empty_getInstance_1() {
    return Empty_instance_1;
  }
  function Companion_123() {
    Companion_instance_123 = this;
    this.b7d_1 = Empty_instance_1;
  }
  protoOf(Companion_123).g2o = function () {
    return this.b7d_1;
  };
  var Companion_instance_123;
  function Companion_getInstance_123() {
    if (Companion_instance_123 == null)
      new Companion_123();
    return Companion_instance_123;
  }
  function $runSuspendCOROUTINE$11(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k7d_1 = _this__u8e3s4;
    this.l7d_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$11).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.m7d_1 = this.l7d_1;
            this.n7d_1 = this.m7d_1;
            this.o7d_1 = this.k7d_1.r7d_1.p7d_1.z76(this.k7d_1.s7d_1, RuleEvaluationStrategy_PER_REQUEST_getInstance(), this.k7d_1.r7d_1.p7d_1.b77(), null);
            this.y9_1 = 1;
            suspendResult = this.k7d_1.t7d_1(new ScopeBuilder(this.o7d_1, this.n7d_1.g4x_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function DefaultScopesManager$getScope$$inlined$suspendingQuery$1(this$0, $targetClass, $builder) {
    this.r7d_1 = this$0;
    this.s7d_1 = $targetClass;
    this.t7d_1 = $builder;
  }
  protoOf(DefaultScopesManager$getScope$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$11(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(DefaultScopesManager$getScope$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function DefaultScopesManager(rules, engine) {
    this.p7d_1 = engine;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.q7d_1 = HashMap_init_$Create$();
    var _iterator__ex2g4s = rules.k();
    while (_iterator__ex2g4s.l()) {
      var rule = _iterator__ex2g4s.m();
      var tmp0 = this.q7d_1;
      var tmp1 = rule.y7b_1;
      // Inline function 'kotlin.collections.set' call
      var value = rule.z7b_1;
      tmp0.r2(tmp1, value);
    }
  }
  protoOf(DefaultScopesManager).u7d = function (targetClass) {
    var tmp = this.q7d_1.y2(targetClass);
    var tmp0_elvis_lhs = (!(tmp == null) ? isSuspendFunction(tmp, 1) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return constant(new EmptyScope());
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var builder = tmp_0;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new DefaultScopesManager$getScope$$inlined$suspendingQuery$1(this, targetClass, builder);
  };
  protoOf(DefaultScopesManager).v7d = function (targetConcept) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.q7d_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w2(targetConcept);
  };
  function NameProvidersManager(rules) {
    var tmp = this;
    // Inline function 'kotlin.collections.linkedMapOf' call
    tmp.w7d_1 = LinkedHashMap_init_$Create$();
    var _iterator__ex2g4s = rules.k();
    while (_iterator__ex2g4s.l()) {
      var rule = _iterator__ex2g4s.m();
      var tmp0 = this.w7d_1;
      var tmp1 = rule.d7c_1;
      // Inline function 'kotlin.collections.set' call
      var value = rule.e7c_1;
      tmp0.r2(tmp1, value);
    }
  }
  protoOf(NameProvidersManager).x7d = function (target) {
    var _iterator__ex2g4s = this.w7d_1.u2().k();
    while (_iterator__ex2g4s.l()) {
      var targetClass = _iterator__ex2g4s.m();
      if (targetClass.mb(target)) {
        return getValue_0(this.w7d_1, targetClass)(target);
      }
    }
    return constant(Companion_getInstance_118().y74_1);
  };
  function NoScopeSpecificationContext() {
    NoScopeSpecificationContext_instance = this;
    this.y7d_1 = AbsentScopeOwner_instance;
  }
  protoOf(NoScopeSpecificationContext).b77 = function () {
    return this.y7d_1;
  };
  protoOf(NoScopeSpecificationContext).y76 = function (location) {
    return AbsentScopeOwner_instance;
  };
  var NoScopeSpecificationContext_instance;
  function NoScopeSpecificationContext_getInstance() {
    if (NoScopeSpecificationContext_instance == null)
      new NoScopeSpecificationContext();
    return NoScopeSpecificationContext_instance;
  }
  function nodeId($this, node) {
    var tmp0_safe_receiver = isInterface(node, DomainNode) ? node : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v39();
    return tmp1_elvis_lhs == null ? new NodeId() : tmp1_elvis_lhs;
  }
  function NodeLocation$Companion$fromNode$lambda($node) {
    return function () {
      return $node;
    };
  }
  function NodeLocation$Companion$fromPointer$lambda($pointer) {
    return function () {
      var message = 'Location ' + $pointer.toString() + ' can not be resolved';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    };
  }
  function Companion_124() {
  }
  protoOf(Companion_124).z7d = function (node) {
    var tmp0_elvis_lhs = DocumentIdUtil_getInstance().x6z(node);
    var documentId = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    var tmp = nodeId(this, node);
    var tmp_0 = getKClassFromExpression(node);
    return new NodeLocation(tmp, documentId, tmp_0, NodeLocation$Companion$fromNode$lambda(node));
  };
  protoOf(Companion_124).z7a = function (pointer, concept) {
    return new NodeLocation(pointer.nodeId, pointer.documentId, concept, NodeLocation$Companion$fromPointer$lambda(pointer));
  };
  var Companion_instance_124;
  function Companion_getInstance_124() {
    return Companion_instance_124;
  }
  function NodeLocation(id, documentId, concept, resolveNode) {
    this.h76_1 = id;
    this.i76_1 = documentId;
    this.j76_1 = concept;
    this.k76_1 = resolveNode;
  }
  protoOf(NodeLocation).toString = function () {
    return '' + this.j76_1.lb() + '/' + this.i76_1 + '/' + this.h76_1.toString();
  };
  function $runSuspendCOROUTINE$12(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i7e_1 = _this__u8e3s4;
    this.j7e_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$12).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 9;
            var tmp_0 = this;
            tmp_0.k7e_1 = this.j7e_1;
            this.l7e_1 = Unit_instance;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.m7e_1 = this.k7e_1;
            var tmp_1 = this;
            var tmp_2 = this.i7e_1.w7e_1.x6s_1;
            tmp_1.n7e_1 = isInterface(tmp_2, DomainNode) ? tmp_2 : THROW_CCE();
            this.o7e_1 = this.n7e_1;
            this.p7e_1 = new ValueProperty(this.o7e_1);
            var tmp_3 = this;
            var tmp0_safe_receiver = this.i7e_1.w7e_1.y6s_1;
            var tmp_4;
            if (tmp0_safe_receiver == null) {
              tmp_4 = null;
            } else {
              tmp_4 = new LexicalWithRole(tmp0_safe_receiver);
            }

            var tmp1_elvis_lhs = tmp_4;
            tmp_3.q7e_1 = tmp1_elvis_lhs == null ? Lexical_getInstance() : tmp1_elvis_lhs;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.r7e_1 = this.m7e_1.n51(get_forQueries_2(this.p7e_1));
            if (this.r7e_1 == null) {
              this.y9_1 = 6;
              var tmp_5 = this;
              continue $sm;
            } else {
              this.s7e_1 = this.r7e_1;
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            this.t7e_1 = this.s7e_1;
            this.y9_1 = 4;
            suspendResult = this.m7e_1.m51(this.i7e_1.x7e_1.a7f(this.t7e_1, this.q7e_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.u7e_1 = suspendResult;
            if (!(this.u7e_1 == null)) {
              this.l7e_1 = this.u7e_1;
              this.y9_1 = 8;
              continue $sm;
            } else {
              this.y9_1 = 5;
              continue $sm;
            }

          case 5:
            this.o7e_1 = this.t7e_1;
            this.p7e_1 = this.o7e_1.m6m();
            this.v7e_1 = this.o7e_1.n6m();
            this.q7e_1 = !(this.v7e_1 == null) ? new LexicalWithRole(this.v7e_1) : Lexical_getInstance();
            this.y9_1 = 2;
            continue $sm;
          case 6:
            this.y9_1 = 7;
            suspendResult = this.m7e_1.m51(this.i7e_1.x7e_1.b7f(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            var tmp3_elvis_lhs = suspendResult;
            this.l7e_1 = tmp3_elvis_lhs == null ? Scopes_getInstance().c7f() : tmp3_elvis_lhs;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 8;
            continue $sm;
          case 8:
            return this.l7e_1;
          case 9:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 9) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ParentChildScopes$nearestEnclosingOrDefaultScope$$inlined$suspendingQuery$1($enclosing, this$0) {
    this.w7e_1 = $enclosing;
    this.x7e_1 = this$0;
  }
  protoOf(ParentChildScopes$nearestEnclosingOrDefaultScope$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$12(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ParentChildScopes$nearestEnclosingOrDefaultScope$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ParentChildScopes(scopeConfig, targetConcept) {
    this.y7e_1 = scopeConfig;
    this.z7e_1 = targetConcept;
  }
  protoOf(ParentChildScopes).d7f = function (enclosingNode, role) {
    return this.e7f(new EnclosingNodeContext(enclosingNode, role));
  };
  protoOf(ParentChildScopes).f7f = function (enclosingNode, role, $super) {
    role = role === VOID ? null : role;
    return $super === VOID ? this.d7f(enclosingNode, role) : $super.d7f.call(this, enclosingNode, role);
  };
  protoOf(ParentChildScopes).e7f = function (enclosing) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ParentChildScopes$nearestEnclosingOrDefaultScope$$inlined$suspendingQuery$1(enclosing, this);
  };
  protoOf(ParentChildScopes).a7f = function (node, selector) {
    var tmp = Companion_instance_124;
    return this.y7e_1.g76(tmp.z7d(isInterface(node, DomainNode) ? node : THROW_CCE()), selector, this.z7e_1);
  };
  protoOf(ParentChildScopes).g7f = function (location, selector) {
    return this.y7e_1.g76(location, selector, this.z7e_1);
  };
  protoOf(ParentChildScopes).b7f = function () {
    return this.y7e_1.a77(this.z7e_1);
  };
  function $runSuspendCOROUTINE$13(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.p7f_1 = _this__u8e3s4;
    this.q7f_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$13).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            var tmp_0 = this;
            tmp_0.r7f_1 = this.q7f_1;
            this.s7f_1 = this.r7f_1;
            this.t7f_1 = ArrayList_init_$Create$();
            this.u7f_1 = this.p7f_1.v7f_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.y9_1 = 2;
            suspendResult = this.s7f_1.m51(tryConstraintRule(this.p7f_1.w7f_1, this.u7f_1, this.p7f_1.w7f_1.y7f_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var constraint = suspendResult;
            if (!(constraint == null)) {
              this.t7f_1.e(constraint);
            }

            var tmp_1 = this.u7f_1;
            if (!isInterface(tmp_1, DomainNode)) {
              this.y9_1 = 6;
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            var tmp0_elvis_lhs = this.s7f_1.n51(get_forQueries_2(this.u7f_1.m6m()));
            var WHEN_RESULT;
            if (tmp0_elvis_lhs == null) {
              this.y9_1 = 6;
              continue $sm;
            } else {
              WHEN_RESULT = tmp0_elvis_lhs;
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            this.u7f_1 = WHEN_RESULT;
            this.y9_1 = 1;
            continue $sm;
          case 5:
            throw this.ba_1;
          case 6:
            return this.t7f_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$14(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h7g_1 = _this__u8e3s4;
    this.i7g_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$14).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.j7g_1 = this.i7g_1;
            this.k7g_1 = this.j7g_1;
            var tmp_1 = this;
            var tmp_2 = this.h7g_1.n7g_1.x7f_1.c77(getKClassFromExpression(this.h7g_1.o7g_1), this.h7g_1.p7g_1);
            tmp_1.l7g_1 = (tmp_2 == null ? true : isInterface(tmp_2, ScopeConstraintProvider)) ? tmp_2 : THROW_CCE();
            if (this.l7g_1 == null) {
              this.m7g_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.k7g_1.m51(this.l7g_1.z78(this.h7g_1.o7g_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.m7g_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            return this.m7g_1;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function tryConstraintRule($this, node, constraintId) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ParentScopeConstraints$tryConstraintRule$$inlined$suspendingQuery$1($this, node, constraintId);
  }
  function ParentScopeConstraints$collectConstraints$$inlined$suspendingQuery$1($node, this$0) {
    this.v7f_1 = $node;
    this.w7f_1 = this$0;
  }
  protoOf(ParentScopeConstraints$collectConstraints$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$13(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ParentScopeConstraints$collectConstraints$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ParentScopeConstraints$tryConstraintRule$$inlined$suspendingQuery$1(this$0, $node, $constraintId) {
    this.n7g_1 = this$0;
    this.o7g_1 = $node;
    this.p7g_1 = $constraintId;
  }
  protoOf(ParentScopeConstraints$tryConstraintRule$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$14(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ParentScopeConstraints$tryConstraintRule$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ParentScopeConstraints(scopeConfig, constraintId) {
    this.x7f_1 = scopeConfig;
    this.y7f_1 = constraintId;
  }
  protoOf(ParentScopeConstraints).q7g = function (node) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ParentScopeConstraints$collectConstraints$$inlined$suspendingQuery$1(node, this);
  };
  function ProviderSpec(providerClass, targetClass, originSelector) {
    this.r7g_1 = providerClass;
    this.s7g_1 = targetClass;
    this.t7g_1 = originSelector;
  }
  protoOf(ProviderSpec).toString = function () {
    return 'ProviderSpec(providerClass=' + toString_1(this.r7g_1) + ', targetClass=' + toString_1(this.s7g_1) + ', originSelector=' + toString_1(this.t7g_1) + ')';
  };
  protoOf(ProviderSpec).hashCode = function () {
    var result = this.r7g_1.hashCode();
    result = imul(result, 31) + this.s7g_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.t7g_1) | 0;
    return result;
  };
  protoOf(ProviderSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProviderSpec))
      return false;
    var tmp0_other_with_cast = other instanceof ProviderSpec ? other : THROW_CCE();
    if (!this.r7g_1.equals(tmp0_other_with_cast.r7g_1))
      return false;
    if (!this.s7g_1.equals(tmp0_other_with_cast.s7g_1))
      return false;
    if (!equals(this.t7g_1, tmp0_other_with_cast.t7g_1))
      return false;
    return true;
  };
  function ProvideScopeRulesContainer(rules) {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.u7g_1 = HashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_0.v7g_1 = HashMap_init_$Create$();
    var _iterator__ex2g4s = rules.k();
    while (_iterator__ex2g4s.l()) {
      var rule = _iterator__ex2g4s.m();
      var tmp0 = this.u7g_1;
      // Inline function 'kotlin.collections.set' call
      var key = new ProviderSpec(rule.t7b_1, rule.u7b_1, rule.w7b_1);
      tmp0.r2(key, rule);
      var tmp3 = this.v7g_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var key_0 = rule.t7b_1;
      var value = tmp3.y2(key_0);
      var tmp_1;
      if (value == null) {
        // Inline function 'jetbrains.ocelot.langDef.scopes.engine.ProvideScopeRulesContainer.<anonymous>' call
        // Inline function 'kotlin.collections.arrayListOf' call
        var answer = ArrayList_init_$Create$();
        tmp3.r2(key_0, answer);
        tmp_1 = answer;
      } else {
        tmp_1 = value;
      }
      tmp_1.e(new ProvidedScopeSpec(rule.u7b_1, rule.w7b_1));
    }
  }
  protoOf(ProvideScopeRulesContainer).w7g = function (provider, target, origin) {
    var tmp0_elvis_lhs = this.v7g_1.y2(provider);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var specs = tmp;
    var result = null;
    var _iterator__ex2g4s = specs.k();
    while (_iterator__ex2g4s.l()) {
      var spec = _iterator__ex2g4s.m();
      if (spec.x7g_1.equals(target) && origin.w79(spec.y7g_1)) {
        if (result == null || spec.y7g_1.w79(result.y7g_1)) {
          result = spec;
        }
      }
    }
    if (result == null)
      return null;
    var tmp_0 = this.u7g_1.y2(new ProviderSpec(provider, target, result.y7g_1));
    return tmp_0 instanceof ProvideScope ? tmp_0 : null;
  };
  protoOf(ProvideScopeRulesContainer).z7g = function (provider) {
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = this.v7g_1.y2(provider);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'jetbrains.ocelot.langDef.scopes.engine.ProvideScopeRulesContainer.getProvidedScopesFor.<anonymous>' call
      tmp = emptyList();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  function ProvidedScopeSpec(targetClass, originSelector) {
    this.x7g_1 = targetClass;
    this.y7g_1 = originSelector;
  }
  protoOf(ProvidedScopeSpec).toString = function () {
    return 'ProvidedScopeSpec(targetClass=' + toString_1(this.x7g_1) + ', originSelector=' + toString_1(this.y7g_1) + ')';
  };
  protoOf(ProvidedScopeSpec).hashCode = function () {
    var result = this.x7g_1.hashCode();
    result = imul(result, 31) + hashCode(this.y7g_1) | 0;
    return result;
  };
  protoOf(ProvidedScopeSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProvidedScopeSpec))
      return false;
    var tmp0_other_with_cast = other instanceof ProvidedScopeSpec ? other : THROW_CCE();
    if (!this.x7g_1.equals(tmp0_other_with_cast.x7g_1))
      return false;
    if (!equals(this.y7g_1, tmp0_other_with_cast.y7g_1))
      return false;
    return true;
  };
  function $runSuspendCOROUTINE$15(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i7h_1 = _this__u8e3s4;
    this.j7h_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$15).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.k7h_1 = this.j7h_1;
            this.l7h_1 = this.k7h_1;
            this.y9_1 = 1;
            suspendResult = this.i7h_1.m7h_1(new ScopeConstraintBuilder(this.l7h_1.g4x_1), this.i7h_1.n7h_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ConstraintSpec(sourceClass, constraintId) {
    this.o7h_1 = sourceClass;
    this.p7h_1 = constraintId;
  }
  protoOf(ConstraintSpec).toString = function () {
    return 'ConstraintSpec(sourceClass=' + toString_1(this.o7h_1) + ', constraintId=' + toString_1(this.p7h_1) + ')';
  };
  protoOf(ConstraintSpec).hashCode = function () {
    var result = this.o7h_1.hashCode();
    result = imul(result, 31) + hashCode(this.p7h_1) | 0;
    return result;
  };
  protoOf(ConstraintSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConstraintSpec))
      return false;
    var tmp0_other_with_cast = other instanceof ConstraintSpec ? other : THROW_CCE();
    if (!this.o7h_1.equals(tmp0_other_with_cast.o7h_1))
      return false;
    if (!equals(this.p7h_1, tmp0_other_with_cast.p7h_1))
      return false;
    return true;
  };
  function ScopeConstraintsManager$getScopeConstraint$$inlined$suspendingQuery$1($queryBuilder, $source) {
    this.m7h_1 = $queryBuilder;
    this.n7h_1 = $source;
  }
  protoOf(ScopeConstraintsManager$getScopeConstraint$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$15(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopeConstraintsManager$getScopeConstraint$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopeConstraintsManager(rules) {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.q7h_1 = HashMap_init_$Create$();
    var _iterator__ex2g4s = rules.k();
    while (_iterator__ex2g4s.l()) {
      var rule = _iterator__ex2g4s.m();
      var tmp0 = this.q7h_1;
      var tmp1 = new ConstraintSpec(rule.a7c_1, rule.b7c_1);
      // Inline function 'kotlin.collections.set' call
      var value = rule.c7c_1;
      tmp0.r2(tmp1, value);
    }
  }
  protoOf(ScopeConstraintsManager).r7h = function (source, constraintId) {
    var queryBuilder = this.q7h_1.y2(new ConstraintSpec(getKClassFromExpression(source), constraintId));
    var tmp;
    if (!(queryBuilder == null)) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      tmp = new ScopeConstraintsManager$getScopeConstraint$$inlined$suspendingQuery$1(queryBuilder, source);
    } else {
      tmp = Companion_getInstance_76().i51_1;
    }
    return tmp;
  };
  protoOf(ScopeConstraintsManager).s7h = function (sourceClass, constraintId) {
    var tmp0 = this.q7h_1;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var key = new ConstraintSpec(sourceClass, constraintId);
    return (isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).w2(key);
  };
  function $runSuspendCOROUTINE$16(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.b7i_1 = _this__u8e3s4;
    this.c7i_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$16).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            var tmp_0 = this;
            tmp_0.d7i_1 = this.c7i_1;
            this.e7i_1 = Unit_instance;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.f7i_1 = this.d7i_1;
            var tmp_1 = this.b7i_1.o7i_1.m7i_1;
            if (!(!(tmp_1 == null) ? isInterface(tmp_1, DomainNode) : false)) {
              this.e7i_1 = Scopes_getInstance().y7a_1;
              this.y9_1 = 7;
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.g7i_1 = this.b7i_1.o7i_1.m7i_1.yt();
            if (this.g7i_1 == null) {
              this.y9_1 = 3;
              suspendResult = this.f7i_1.m51(this.b7i_1.o7i_1.n7i_1.b7f(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.h7i_1 = this.g7i_1;
              this.y9_1 = 4;
              continue $sm;
            }

          case 3:
            this.i7i_1 = suspendResult;
            this.e7i_1 = this.i7i_1 == null ? Scopes_getInstance().y7a_1 : this.i7i_1;
            this.y9_1 = 7;
            var tmp_2 = this;
            continue $sm;
          case 4:
            this.j7i_1 = this.h7i_1;
            this.y9_1 = 5;
            suspendResult = this.f7i_1.m51(this.b7i_1.o7i_1.n7i_1.d7f(this.j7i_1, this.b7i_1.o7i_1.m7i_1.n6m()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.e7i_1 = suspendResult;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 7;
            continue $sm;
          case 6:
            throw this.ba_1;
          case 7:
            return this.e7i_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$17(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x7i_1 = _this__u8e3s4;
    this.y7i_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$17).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.z7i_1 = this.y7i_1;
            this.a7j_1 = this.z7i_1;
            this.y9_1 = 1;
            suspendResult = this.a7j_1.m51(this.x7i_1.b7j_1.n7i_1.a7f(this.x7i_1.c7j_1, Import_getInstance()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            return tmp0_elvis_lhs == null ? Scopes_getInstance().y7a_1 : tmp0_elvis_lhs;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$18(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l7j_1 = _this__u8e3s4;
    this.m7j_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$18).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.n7j_1 = this.m7j_1;
            this.o7j_1 = this.n7j_1;
            this.y9_1 = 1;
            suspendResult = this.o7j_1.m51(this.l7j_1.p7j_1.n7i_1.g7f(this.l7j_1.q7j_1, Import_getInstance()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            return tmp0_elvis_lhs == null ? Scopes_getInstance().y7a_1 : tmp0_elvis_lhs;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$19(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z7j_1 = _this__u8e3s4;
    this.a7k_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$19).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.b7k_1 = this.a7k_1;
            this.c7k_1 = this.b7k_1;
            this.y9_1 = 1;
            suspendResult = this.c7k_1.m51(this.z7j_1.d7k_1.n7i_1.b7f(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            return tmp0_elvis_lhs == null ? Scopes_getInstance().y7a_1 : tmp0_elvis_lhs;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ScopeContextImpl$parentScope$$inlined$suspendingQuery$1(this$0) {
    this.o7i_1 = this$0;
  }
  protoOf(ScopeContextImpl$parentScope$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$16(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopeContextImpl$parentScope$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopeContextImpl$importScope$$inlined$suspendingQuery$1(this$0, $provider) {
    this.b7j_1 = this$0;
    this.c7j_1 = $provider;
  }
  protoOf(ScopeContextImpl$importScope$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$17(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopeContextImpl$importScope$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopeContextImpl$importScope$$inlined$suspendingQuery$2(this$0, $providerLocation) {
    this.p7j_1 = this$0;
    this.q7j_1 = $providerLocation;
  }
  protoOf(ScopeContextImpl$importScope$$inlined$suspendingQuery$2).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$18(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopeContextImpl$importScope$$inlined$suspendingQuery$2).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopeContextImpl$defaultScope$$inlined$suspendingQuery$1(this$0) {
    this.d7k_1 = this$0;
  }
  protoOf(ScopeContextImpl$defaultScope$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$19(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopeContextImpl$defaultScope$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopeConfig$getName$ref($boundThis) {
    var l = function (p0) {
      return $boundThis.x7d(p0);
    };
    l.callableName = 'getName';
    return l;
  }
  function ScopeContextImpl(ruleEvaluation, scopeConfig, targetConcept, node) {
    this.k7i_1 = ruleEvaluation;
    this.l7i_1 = scopeConfig;
    this.m7i_1 = node;
    this.n7i_1 = new ParentChildScopes(this.l7i_1, targetConcept);
  }
  protoOf(ScopeContextImpl).r7a = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopeContextImpl$parentScope$$inlined$suspendingQuery$1(this);
  };
  protoOf(ScopeContextImpl).o7b = function (provider) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopeContextImpl$importScope$$inlined$suspendingQuery$1(this, provider);
  };
  protoOf(ScopeContextImpl).a7b = function (providerLocation) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopeContextImpl$importScope$$inlined$suspendingQuery$2(this, providerLocation);
  };
  protoOf(ScopeContextImpl).q7b = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopeContextImpl$defaultScope$$inlined$suspendingQuery$1(this);
  };
  protoOf(ScopeContextImpl).n7a = function (constraintId) {
    return this.m7i_1 == null ? constant(emptyList()) : (new ParentScopeConstraints(this.l7i_1, constraintId)).q7g(this.m7i_1);
  };
  protoOf(ScopeContextImpl).p7b = function (collection) {
    var scopeFactory = this.l7i_1.e7k(this.k7i_1.b79_1);
    var specification = collectionScopeSpecification(this.l7i_1, collection);
    return scopeFactory.a79(specification, this.k7i_1, collection, ScopeConfig$getName$ref(this.l7i_1));
  };
  function ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$o$runSuspend$lambda($scopeEvalCompleted) {
    return function (it) {
      $scopeEvalCompleted.oz();
      return Unit_instance;
    };
  }
  function $runSuspendCOROUTINE$20(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n7k_1 = _this__u8e3s4;
    this.o7k_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$20).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 10;
            var tmp_0 = this;
            tmp_0.p7k_1 = this.o7k_1;
            this.q7k_1 = this.p7k_1;
            this.r7k_1 = this.n7k_1.a7l_1.qr();
            if (this.r7k_1 == null) {
              var tmp_1 = this;
              tmp_1.s7k_1 = Job_0(get_job(this.ea()));
              var tmp_2 = this;
              tmp_2.t7k_1 = this.n7k_1.a7l_1.p27(ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$o$runSuspend$lambda(this.s7k_1));
              var tmp_3 = this;
              tmp_3.u7k_1 = this.t7k_1;
              this.y9_1 = 1;
              continue $sm;
            } else {
              this.y9_1 = 8;
              continue $sm;
            }

          case 1:
            this.w7k_1 = this.u7k_1;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 9;
            var tmp_4 = this;
            tmp_4.y7k_1 = this.w7k_1;
            this.z7k_1 = this.y7k_1;
            if (!(this.n7k_1.a7l_1.qr() == null)) {
              this.s7k_1.oz();
            }

            this.y9_1 = 4;
            suspendResult = this.s7k_1.ku(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var tmp_5 = this;
            tmp_5.x7k_1 = Unit_instance;
            this.z9_1 = 10;
            this.y9_1 = 5;
            var tmp_6 = this;
            continue $sm;
          case 5:
            this.z9_1 = 10;
            var tmp_7 = this;
            this.w7k_1.vr();
            tmp_7.v7k_1 = Unit_instance;
            this.y9_1 = 7;
            continue $sm;
          case 6:
            this.z9_1 = 10;
            this.w7k_1.vr();
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 7;
            continue $sm;
          case 7:
            this.y9_1 = 8;
            continue $sm;
          case 8:
            return ensureNotNull(this.q7k_1.n51(get_forQueries_2(this.n7k_1.a7l_1)));
          case 9:
            this.z9_1 = 10;
            var t = this.ba_1;
            this.w7k_1.vr();
            throw t;
          case 10:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 10) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$$inlined$suspendingQuery$1($scopeProperty) {
    this.a7l_1 = $scopeProperty;
  }
  protoOf(ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$20(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function $runSuspendCOROUTINE$21(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j7l_1 = _this__u8e3s4;
    this.k7l_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$21).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            var tmp_0 = this;
            tmp_0.l7l_1 = this.k7l_1;
            this.m7l_1 = this.l7l_1;
            Companion_getInstance_125().o7l_1.go('Scope provider rule is evaluating, provider ' + toString_1(this.j7l_1.p7l_1) + ', specification ' + this.j7l_1.q7l_1.toString() + ', instance ' + toString_1(this.j7l_1.r7l_1) + ', id ' + this.j7l_1.s7l_1);
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 4;
            this.y9_1 = 2;
            suspendResult = this.j7l_1.t7l_1(new ScopeBuilderWithProvider(this.j7l_1.u7l_1, this.m7l_1.g4x_1), this.j7l_1.r7l_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n7l_1 = suspendResult;
            this.z9_1 = 5;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            var tmp_1 = this.n7l_1;
            this.z9_1 = 5;
            Companion_getInstance_125().o7l_1.go('Scope provider rule evaluated, provider ' + toString_1(this.j7l_1.p7l_1) + ', specification ' + this.j7l_1.q7l_1.toString() + ', instance ' + toString_1(this.j7l_1.r7l_1) + ', id ' + this.j7l_1.s7l_1);
            return tmp_1;
          case 4:
            this.z9_1 = 5;
            var t = this.ba_1;
            Companion_getInstance_125().o7l_1.go('Scope provider rule evaluated, provider ' + toString_1(this.j7l_1.p7l_1) + ', specification ' + this.j7l_1.q7l_1.toString() + ', instance ' + toString_1(this.j7l_1.r7l_1) + ', id ' + this.j7l_1.s7l_1);
            throw t;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ScopeProvidersManager$populateScopesFor$1$$inlined$suspendingQuery$1($providerClass, $spec, $provider, $id, $ruleBuilder, $scopeContext) {
    this.p7l_1 = $providerClass;
    this.q7l_1 = $spec;
    this.r7l_1 = $provider;
    this.s7l_1 = $id;
    this.t7l_1 = $ruleBuilder;
    this.u7l_1 = $scopeContext;
  }
  protoOf(ScopeProvidersManager$populateScopesFor$1$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$21(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopeProvidersManager$populateScopesFor$1$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopeProvidersManager$populateScopesFor$slambda$lambda($scopeProperty) {
    return function (event) {
      var tmp = event.p2e_1;
      var queryState = tmp instanceof Ready ? tmp : null;
      var tmp_0 = queryState == null ? null : queryState.j4x_1;
      var queryOutcome = tmp_0 instanceof Success ? tmp_0 : null;
      var tmp2_elvis_lhs = queryOutcome == null ? null : queryOutcome.k4x_1;
      var scope = tmp2_elvis_lhs == null ? Scopes_getInstance().y7a_1 : tmp2_elvis_lhs;
      $scopeProperty.t2c(scope);
      return Unit_instance;
    };
  }
  function $runSuspendCOROUTINE$22(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d7m_1 = _this__u8e3s4;
    this.e7m_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$22).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.f7m_1 = this.e7m_1;
            this.g7m_1 = this.f7m_1;
            var tmp_1 = this;
            var tmp_2 = Companion_instance_124;
            var tmp_3 = this.d7m_1.k7m_1;
            tmp_1.h7m_1 = this.d7m_1.j7m_1.n7m_1.y76(tmp_2.z7d(isInterface(tmp_3, DomainNode) ? tmp_3 : THROW_CCE()));
            this.i7m_1 = this.d7m_1.j7m_1.n7m_1.z76(this.d7m_1.l7m_1, RuleEvaluationStrategy_PER_REQUEST_getInstance(), this.h7m_1, this.d7m_1.k7m_1);
            this.y9_1 = 1;
            suspendResult = this.d7m_1.m7m_1(new ScopeBuilderWithProvider(this.i7m_1, this.g7m_1.g4x_1), this.d7m_1.k7m_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function hasEagerRuleFor($this, providerConcept, targetConcept, selector) {
    return !($this.p7m_1.w7g(providerConcept, targetConcept, selector) == null);
  }
  function hasPerRequestRuleFor($this, providerConcept, targetConcept, selector) {
    return !($this.q7m_1.w7g(providerConcept, targetConcept, selector) == null);
  }
  function ProvidedScopesContainer(job) {
    this.t7m_1 = job;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.u7m_1 = HashMap_init_$Create$();
  }
  protoOf(ProvidedScopesContainer).v7m = function (key) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.u7m_1;
    var value = this_0.y2(key);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.langDef.scopes.engine.ProvidedScopesContainer.defineScopeProperty.<anonymous>' call
      var answer = new ValueProperty(null);
      this_0.r2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, Property) ? tmp_0 : THROW_CCE();
  };
  protoOf(ProvidedScopesContainer).w7m = function (key) {
    var rightKey = key;
    $l$loop: while (true) {
      var tmp;
      var tmp0 = this.u7m_1;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var key_0 = rightKey;
      if (!(isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).w2(key_0)) {
        tmp = !(rightKey.y7g_1.u79_1 == null);
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      rightKey = new ProvidedScopeSpec(key.x7g_1, ensureNotNull(rightKey.y7g_1.u79_1));
    }
    var tmp_0 = this.u7m_1.y2(rightKey);
    var scopeProperty = (!(tmp_0 == null) ? isInterface(tmp_0, Property) : false) ? tmp_0 : THROW_CCE();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopeProvidersManager$ProvidedScopesContainer$readScopeProperty$$inlined$suspendingQuery$1(scopeProperty);
  };
  protoOf(ProvidedScopesContainer).vr = function () {
    this.t7m_1.pu();
  };
  function Companion_125() {
    Companion_instance_125 = this;
    this.o7l_1 = getLogger(getKClass(ScopeProvidersManager));
  }
  var Companion_instance_125;
  function Companion_getInstance_125() {
    if (Companion_instance_125 == null)
      new Companion_125();
    return Companion_instance_125;
  }
  function ScopeProvidersManager$eagerRules$lambda(it) {
    return it.v7b_1.z79_1;
  }
  function ScopeProvidersManager$perRequestRules$lambda(it) {
    return !it.v7b_1.z79_1;
  }
  function ScopeProvidersManager$populateScopesFor$slambda(this$0, $provider, $editable, resultContinuation) {
    this.f7n_1 = this$0;
    this.g7n_1 = $provider;
    this.h7n_1 = $editable;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ScopeProvidersManager$populateScopesFor$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopeProvidersManager$populateScopesFor$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ScopeProvidersManager$populateScopesFor$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            this.j7n_1 = new ProvidedScopesContainer(get_job(this.i7n_1.et()));
            var tmp0 = this.f7n_1.s7m_1;
            var tmp1 = this.g7n_1;
            var value = this.j7n_1;
            tmp0.r2(tmp1, value);
            this.k7n_1 = getKClassFromExpression(this.g7n_1);
            this.l7n_1 = this.f7n_1.p7m_1.z7g(this.k7n_1).k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.l7n_1.l()) {
              this.y9_1 = 4;
              continue $sm;
            }

            this.m7n_1 = this.l7n_1.m();
            var tmp_0 = this;
            var _unary__edvuaz = this.f7n_1.o7m_1;
            this.f7n_1.o7m_1 = _unary__edvuaz + 1 | 0;
            tmp_0.n7n_1 = _unary__edvuaz;
            Companion_getInstance_125().o7l_1.go('Evaluation loop for scope provider rule created, provider ' + toString_1(this.k7n_1) + ', specification ' + this.m7n_1.toString() + ', instance ' + toString_1(this.g7n_1) + ', id ' + this.n7n_1);
            var tmp_1 = this;
            var tmp0_0 = this.f7n_1.p7m_1.w7g(this.k7n_1, this.m7n_1.x7g_1, this.m7n_1.y7g_1);
            var tmp$ret$0 = Unit_instance;
            l$ret$1: do {
              if (tmp0_0 == null) {
                var message = 'Required value was null.';
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              } else {
                tmp$ret$0 = tmp0_0;
                break l$ret$1;
              }
            }
             while (false);
            tmp_1.o7n_1 = tmp$ret$0;
            this.p7n_1 = this.o7n_1.x7b_1;
            this.q7n_1 = new CoroutineName('ScopeProvider-' + this.n7n_1);
            this.r7n_1 = this.i7n_1.et().ej(this.q7n_1);
            var tmp_2 = this;
            var tmp_3 = Companion_instance_124;
            var tmp_4 = this.g7n_1;
            tmp_2.s7n_1 = this.f7n_1.n7m_1.y76(tmp_3.z7d(isInterface(tmp_4, DomainNode) ? tmp_4 : THROW_CCE()));
            this.t7n_1 = this.f7n_1.n7m_1.z76(this.m7n_1.x7g_1, this.o7n_1.v7b_1, this.s7n_1, this.g7n_1);
            var tmp_5 = this;
            tmp_5.u7n_1 = new ScopeProvidersManager$populateScopesFor$1$$inlined$suspendingQuery$1(this.k7n_1, this.m7n_1, this.g7n_1, this.n7n_1, this.p7n_1, this.t7n_1);
            this.v7n_1 = this.j7n_1.v7m(this.m7n_1);
            if (this.h7n_1) {
              var loopingQuery = new LoopingQuery(this.r7n_1, this.u7n_1);
              loopingQuery.p27(ScopeProvidersManager$populateScopesFor$slambda$lambda(this.v7n_1));
              var result = loopingQuery.qr();
              if (result instanceof Ready) {
                var outcome = result.j4x_1;
                if (outcome instanceof Success) {
                  this.v7n_1.t2c(outcome.k4x_1);
                }
              }
              this.y9_1 = 3;
              continue $sm;
            } else {
              this.y9_1 = 2;
              suspendResult = execute_1(this.u7n_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            var ARGUMENT = suspendResult;
            this.v7n_1.t2c(ARGUMENT);
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.y9_1 = 1;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ScopeProvidersManager$populateScopesFor$slambda).i1l = function ($this$launch, completion) {
    var i = new ScopeProvidersManager$populateScopesFor$slambda(this.f7n_1, this.g7n_1, this.h7n_1, completion);
    i.i7n_1 = $this$launch;
    return i;
  };
  function ScopeProvidersManager$populateScopesFor$slambda_0(this$0, $provider, $editable, resultContinuation) {
    var i = new ScopeProvidersManager$populateScopesFor$slambda(this$0, $provider, $editable, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ScopeProvidersManager$getScope$$inlined$suspendingQuery$1(this$0, $provider, $targetClass, $ruleBuilder) {
    this.j7m_1 = this$0;
    this.k7m_1 = $provider;
    this.l7m_1 = $targetClass;
    this.m7m_1 = $ruleBuilder;
  }
  protoOf(ScopeProvidersManager$getScope$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$22(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopeProvidersManager$getScope$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopeProvidersManager(rules, engine, coroutineContext) {
    Companion_getInstance_125();
    this.n7m_1 = engine;
    this.o7m_1 = 0;
    var tmp = this;
    tmp.p7m_1 = new ProvideScopeRulesContainer(filter(rules, ScopeProvidersManager$eagerRules$lambda));
    var tmp_0 = this;
    tmp_0.q7m_1 = new ProvideScopeRulesContainer(filter(rules, ScopeProvidersManager$perRequestRules$lambda));
    this.r7m_1 = CoroutineScope_0(coroutineContext.ej(Job_0(get_job(coroutineContext))));
    var tmp_1 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_1.s7m_1 = HashMap_init_$Create$();
  }
  protoOf(ScopeProvidersManager).w7n = function (provider, editable) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.s7m_1;
    // Inline function 'kotlin.check' call
    if (!!(isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w2(provider)) {
      // Inline function 'jetbrains.ocelot.langDef.scopes.engine.ScopeProvidersManager.populateScopesFor.<anonymous>' call
      var message = 'Scopes for ' + toString_1(provider) + ' have already populated';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp = CoroutineStart_UNDISPATCHED_getInstance();
    launch(this.r7m_1, VOID, tmp, ScopeProvidersManager$populateScopesFor$slambda_0(this, provider, editable, null));
  };
  protoOf(ScopeProvidersManager).x7n = function (provider) {
    var container = this.s7m_1.s2(provider);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (container == null) {
        // Inline function 'jetbrains.ocelot.langDef.scopes.engine.ScopeProvidersManager.retractScopesFor.<anonymous>' call
        var message = 'Scopes for ' + toString_1(provider) + " haven't been populated";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    container.vr();
  };
  protoOf(ScopeProvidersManager).y7n = function (provider, targetClass, originSelector) {
    var providerClass = getKClassFromExpression(provider);
    // Inline function 'kotlin.check' call
    if (!this.z7n(providerClass, targetClass, originSelector)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.s7m_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w2(provider)) {
      tmp_0 = hasEagerRuleFor(this, providerClass, targetClass, originSelector);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var container = getValue_0(this.s7m_1, provider);
      tmp = container.w7m(new ProvidedScopeSpec(targetClass, originSelector));
    } else {
      // Inline function 'kotlin.checkNotNull' call
      var tmp0 = this.q7m_1.w7g(providerClass, targetClass, originSelector);
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          tmp$ret$3 = tmp0;
          break $l$block;
        }
      }
      var rule = tmp$ret$3;
      // Inline function 'kotlin.check' call
      if (!rule.v7b_1.equals(RuleEvaluationStrategy_PER_REQUEST_getInstance())) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      var ruleBuilder = rule.x7b_1;
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      tmp = new ScopeProvidersManager$getScope$$inlined$suspendingQuery$1(this, provider, targetClass, ruleBuilder);
    }
    return tmp;
  };
  protoOf(ScopeProvidersManager).vr = function () {
    cancel(this.r7m_1);
  };
  protoOf(ScopeProvidersManager).z7n = function (providerConcept, targetConcept, selector) {
    return hasEagerRuleFor(this, providerConcept, targetConcept, selector) || hasPerRequestRuleFor(this, providerConcept, targetConcept, selector);
  };
  function Companion_126() {
    Companion_instance_126 = this;
    this.a7o_1 = NoScopeSpecificationContext_getInstance();
  }
  protoOf(Companion_126).g2o = function () {
    return this.a7o_1;
  };
  var Companion_instance_126;
  function Companion_getInstance_126() {
    if (Companion_instance_126 == null)
      new Companion_126();
    return Companion_instance_126;
  }
  function defaultScopeSpecification(_this__u8e3s4, targetConcept) {
    return new ScopeSpecification(_this__u8e3s4.b77(), new Default_2(ensureNotNull(targetConcept.lb())));
  }
  function providedScopeSpecification(_this__u8e3s4, selector, provider, targetConcept) {
    var tmp;
    var tmp_0;
    if (equals(selector, Lexical_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = selector instanceof LexicalWithRole;
    }
    if (tmp_0) {
      tmp = lexicalScopeSpecification(_this__u8e3s4, provider, targetConcept);
    } else {
      if (equals(selector, Import_getInstance())) {
        tmp = exportedScopeSpecification(_this__u8e3s4, provider, targetConcept);
      } else {
        var message = 'unknown specification: ' + toString_1(selector);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    return tmp;
  }
  function lexicalScopeSpecification(_this__u8e3s4, provider, targetConcept) {
    return new ScopeSpecification(_this__u8e3s4.y76(provider), new Lexical_0(provider.h76_1, ensureNotNull(targetConcept.lb())));
  }
  function exportedScopeSpecification(_this__u8e3s4, provider, targetConcept) {
    return new ScopeSpecification(_this__u8e3s4.y76(provider), new Exported(provider.h76_1, ensureNotNull(targetConcept.lb())));
  }
  function collectionScopeSpecification(_this__u8e3s4, collection) {
    if (isInterface(collection, OtChildrenList)) {
      var node = collection.yt();
      return new ScopeSpecification(_this__u8e3s4.y76(Companion_instance_124.z7d(node)), new Children(node.v39(), collection.h3b().o6l_1.i2s_1));
    }
    var observableCollection = collection.n4z();
    if (observableCollection instanceof AnnotatedDocumentsList) {
      return new ScopeSpecification(_this__u8e3s4.b77(), new Collection_0(observableCollection.c7o_1));
    }
    return new ScopeSpecification(_this__u8e3s4.b77(), new Collection_0());
  }
  function $runSuspendCOROUTINE$23(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l7o_1 = _this__u8e3s4;
    this.m7o_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$23).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.n7o_1 = this.m7o_1;
            this.o7o_1 = this.n7o_1;
            this.y9_1 = 1;
            suspendResult = this.o7o_1.m51(this.l7o_1.p7o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp_1;
            if (tmp0_safe_receiver == null) {
              tmp_1 = null;
            } else {
              tmp_1 = new LocatableScope(this.l7o_1.q7o_1, tmp0_safe_receiver);
            }

            return tmp_1;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$24(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z7o_1 = _this__u8e3s4;
    this.a7p_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$24).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.b7p_1 = this.a7p_1;
            this.c7p_1 = this.b7p_1;
            this.y9_1 = 1;
            suspendResult = this.c7p_1.m51(this.z7o_1.d7p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp_1;
            if (tmp0_safe_receiver == null) {
              tmp_1 = null;
            } else {
              tmp_1 = new LocatableScope(this.z7o_1.e7p_1, tmp0_safe_receiver);
            }

            return tmp_1;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$25(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n7p_1 = _this__u8e3s4;
    this.o7p_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$25).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.p7p_1 = this.o7p_1;
            this.q7p_1 = this.p7p_1;
            var tmp_1 = this;
            var tmp0_safe_receiver = this.n7p_1.u7p_1.w76_1;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c77(this.n7p_1.v7p_1, this.n7p_1.w7p_1);
            tmp_1.r7p_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.z78(this.n7p_1.x7p_1);
            if (this.r7p_1 == null) {
              this.s7p_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.q7p_1.m51(this.r7p_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.s7p_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.t7p_1 = this.s7p_1;
            this.y9_1 = 3;
            suspendResult = this.q7p_1.m51(this.n7p_1.u7p_1.u76_1.r7h(this.n7p_1.x7p_1, this.n7p_1.w7p_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var ARGUMENT = suspendResult;
            var constraint = ensureNotNull(ARGUMENT);
            var tmp_2;
            if (!(this.t7p_1 == null)) {
              tmp_2 = combine(listOf_0([this.t7p_1, constraint]));
            } else {
              tmp_2 = constraint;
            }

            return tmp_2;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0(function_0) {
    this.y7p_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0).z78 = function (provider) {
    return this.y7p_1(provider);
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0).b4 = function () {
    return this.y7p_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeConstraintProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_3(function_0) {
    this.z7p_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_3).vr = function () {
    return this.z7p_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_3).b4 = function () {
    return this.z7p_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_3).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0(function_0) {
    this.a7q_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0).b4 = function () {
    return this.a7q_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeProvidersRegistry) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function ScopingRulesEngine$_init_$lambda_c1plh9(it) {
    return null;
  }
  function ScopingRulesEngine$scopeProviders$lambda(it) {
    return it instanceof ProvideScope;
  }
  function ScopingRulesEngine$defaultScopes$lambda(it) {
    return it instanceof DefaultScope;
  }
  function ScopingRulesEngine$scopeConstraints$lambda(it) {
    return it instanceof ConstrainScope;
  }
  function ScopingRulesEngine$nameProviders$lambda(it) {
    return it instanceof ProvideName;
  }
  function ScopingRulesEngine$getDefaultScope$$inlined$mapSuspending$1($this, $scope) {
    this.p7o_1 = $this;
    this.q7o_1 = $scope;
  }
  protoOf(ScopingRulesEngine$getDefaultScope$$inlined$mapSuspending$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$23(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopingRulesEngine$getDefaultScope$$inlined$mapSuspending$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopingRulesEngine$getDocumentScope$$inlined$map$1($this, $scope) {
    this.b7q_1 = $this;
    this.c7q_1 = $scope;
  }
  protoOf(ScopingRulesEngine$getDocumentScope$$inlined$map$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.query.map.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.scopes.engine.ScopingRulesEngine.getDocumentScope.<anonymous>' call
    var tmp0_safe_receiver = builder.n51(this.b7q_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.engine.ScopingRulesEngine.getDocumentScope.<anonymous>.<anonymous>' call
      tmp = new LocatableScope(this.c7q_1, tmp0_safe_receiver);
    }
    return tmp;
  };
  function ScopingRulesEngine$getDocumentScope$$inlined$map$2($this, $scope) {
    this.d7p_1 = $this;
    this.e7p_1 = $scope;
  }
  protoOf(ScopingRulesEngine$getDocumentScope$$inlined$map$2).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$24(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopingRulesEngine$getDocumentScope$$inlined$map$2).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopingRulesEngine$getScopeConstraint$1$$inlined$suspendingQuery$1(this$0, $providerConcept, $scopeConstraintId, $provider) {
    this.u7p_1 = this$0;
    this.v7p_1 = $providerConcept;
    this.w7p_1 = $scopeConstraintId;
    this.x7p_1 = $provider;
  }
  protoOf(ScopingRulesEngine$getScopeConstraint$1$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$25(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopingRulesEngine$getScopeConstraint$1$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopingRulesEngine$getScopeConstraint$lambda(this$0, $providerConcept, $scopeConstraintId) {
    return function (provider) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new ScopingRulesEngine$getScopeConstraint$1$$inlined$suspendingQuery$1(this$0, $providerConcept, $scopeConstraintId, provider);
    };
  }
  function ScopingRulesEngine$providersRegistry$lambda$lambda(this$0, $provider) {
    return function () {
      this$0.s76_1.x7n($provider);
      return Unit_instance;
    };
  }
  function ScopingRulesEngine$providersRegistry$lambda(this$0) {
    return function (provider, editable) {
      this$0.s76_1.w7n(provider, editable);
      var tmp = ScopingRulesEngine$providersRegistry$lambda$lambda(this$0, provider);
      return new sam$jetbrains_ocelot_base_disposable_Disposable$0_3(tmp);
    };
  }
  function ScopingRulesEngine(rules, scopeFactories, coroutineContext, scopeSpecificationContext, dbScopes, sharedScopes, fallbackRulesBuilder) {
    sharedScopes = sharedScopes === VOID ? null : sharedScopes;
    var tmp;
    if (fallbackRulesBuilder === VOID) {
      tmp = ScopingRulesEngine$_init_$lambda_c1plh9;
    } else {
      tmp = fallbackRulesBuilder;
    }
    fallbackRulesBuilder = tmp;
    this.o76_1 = scopeSpecificationContext;
    this.p76_1 = scopeFactories;
    this.q76_1 = dbScopes;
    this.r76_1 = sharedScopes;
    var tmp_0 = this;
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var tmp_1 = filter(rules, ScopingRulesEngine$scopeProviders$lambda);
    var tmp$ret$0 = isInterface(tmp_1, Sequence) ? tmp_1 : THROW_CCE();
    tmp_0.s76_1 = new ScopeProvidersManager(tmp$ret$0, this, coroutineContext);
    var tmp_2 = this;
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var tmp_3 = filter(rules, ScopingRulesEngine$defaultScopes$lambda);
    var tmp$ret$1 = isInterface(tmp_3, Sequence) ? tmp_3 : THROW_CCE();
    tmp_2.t76_1 = new DefaultScopesManager(tmp$ret$1, this);
    var tmp_4 = this;
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var tmp_5 = filter(rules, ScopingRulesEngine$scopeConstraints$lambda);
    var tmp$ret$2 = isInterface(tmp_5, Sequence) ? tmp_5 : THROW_CCE();
    tmp_4.u76_1 = new ScopeConstraintsManager(tmp$ret$2);
    var tmp_6 = this;
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var tmp_7 = filter(rules, ScopingRulesEngine$nameProviders$lambda);
    var tmp$ret$3 = isInterface(tmp_7, Sequence) ? tmp_7 : THROW_CCE();
    tmp_6.v76_1 = new NameProvidersManager(tmp$ret$3);
    this.w76_1 = fallbackRulesBuilder(this);
    var tmp_8 = this;
    var tmp_9 = ScopingRulesEngine$providersRegistry$lambda(this);
    tmp_8.x76_1 = new sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeProvidersRegistry$0(tmp_9);
  }
  protoOf(ScopingRulesEngine).a77 = function (targetConcept) {
    var scope = defaultScopeSpecification(this, targetConcept);
    var resultQuery = this.t76_1.v7d(targetConcept) ? this.t76_1.u7d(targetConcept) : !(this.w76_1 == null) ? this.w76_1.a77(targetConcept) : Companion_getInstance_76().i51_1;
    // Inline function 'jetbrains.ocelot.langDef.query.mapSuspending' call
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopingRulesEngine$getDefaultScope$$inlined$mapSuspending$1(resultQuery, scope);
  };
  protoOf(ScopingRulesEngine).g76 = function (provider, originSelector, targetConcept) {
    var scope = providedScopeSpecification(this, originSelector, provider, targetConcept);
    var resultQuery = this.s76_1.z7n(provider.j76_1, targetConcept, originSelector) ? this.s76_1.y7n(provider.k76_1(), targetConcept, originSelector) : !(this.w76_1 == null) ? this.w76_1.g76(provider, originSelector, targetConcept) : Companion_getInstance_76().i51_1;
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var tmp;
    if (isInterface(resultQuery, Query)) {
      // Inline function 'jetbrains.ocelot.langDef.query.map' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      tmp = new ScopingRulesEngine$getDocumentScope$$inlined$map$1(resultQuery, scope);
    } else {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      tmp = new ScopingRulesEngine$getDocumentScope$$inlined$map$2(resultQuery, scope);
    }
    return tmp;
  };
  protoOf(ScopingRulesEngine).c77 = function (providerConcept, scopeConstraintId) {
    var tmp;
    if (this.u76_1.s7h(providerConcept, scopeConstraintId)) {
      var tmp_0 = ScopingRulesEngine$getScopeConstraint$lambda(this, providerConcept, scopeConstraintId);
      tmp = new sam$jetbrains_ocelot_langDef_scopes_config_api_ScopeConstraintProvider$0_0(tmp_0);
    } else {
      var tmp0_safe_receiver = this.w76_1;
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c77(providerConcept, scopeConstraintId);
    }
    return tmp;
  };
  protoOf(ScopingRulesEngine).x7d = function (declaration) {
    return this.v76_1.x7d(declaration);
  };
  protoOf(ScopingRulesEngine).z76 = function (targetClass, strategy, owner, location) {
    var scope = new RuleEvaluationScope(strategy, this.r76_1);
    return new ScopeContextImpl(scope, this.d7q(owner), targetClass, location);
  };
  protoOf(ScopingRulesEngine).e7k = function (strategy) {
    return getValue_0(this.p76_1, strategy);
  };
  protoOf(ScopingRulesEngine).d7q = function (origin) {
    return new ScopingRulesEngineRemoteAdapter(this.q76_1, this, origin);
  };
  protoOf(ScopingRulesEngine).b77 = function () {
    return this.o76_1.b77();
  };
  protoOf(ScopingRulesEngine).y76 = function (location) {
    return this.o76_1.y76(location);
  };
  function ScopingRulesEngineRemoteAdapter(dbScopes, original, owner) {
    this.e7q_1 = dbScopes;
    this.f7q_1 = original;
    this.g7q_1 = owner;
  }
  protoOf(ScopingRulesEngineRemoteAdapter).g76 = function (provider, originSelector, targetConcept) {
    var scope = providedScopeSpecification(this.f7q_1, originSelector, provider, targetConcept);
    if (!equals(this.g7q_1, scope.h7q_1)) {
      return this.e7q_1.a7d(scope, targetConcept);
    }
    return this.f7q_1.g76(provider, originSelector, targetConcept);
  };
  protoOf(ScopingRulesEngineRemoteAdapter).a77 = function (targetConcept) {
    var scope = defaultScopeSpecification(this.f7q_1, targetConcept);
    if (!equals(scope.h7q_1, this.g7q_1)) {
      return this.e7q_1.a7d(scope, targetConcept);
    }
    return this.f7q_1.a77(targetConcept);
  };
  protoOf(ScopingRulesEngineRemoteAdapter).x7d = function (declaration) {
    return this.f7q_1.x7d(declaration);
  };
  protoOf(ScopingRulesEngineRemoteAdapter).e7k = function (strategy) {
    return this.f7q_1.e7k(strategy);
  };
  protoOf(ScopingRulesEngineRemoteAdapter).d7q = function (origin) {
    return this.f7q_1.d7q(origin);
  };
  protoOf(ScopingRulesEngineRemoteAdapter).c77 = function (providerConcept, scopeConstraintId) {
    return this.f7q_1.c77(providerConcept, scopeConstraintId);
  };
  protoOf(ScopingRulesEngineRemoteAdapter).b77 = function () {
    return this.f7q_1.b77();
  };
  protoOf(ScopingRulesEngineRemoteAdapter).y76 = function (location) {
    return this.f7q_1.y76(location);
  };
  function AnnotatedDocumentsList(role, delegate) {
    this.b7o_1 = delegate;
    this.c7o_1 = role;
  }
  protoOf(AnnotatedDocumentsList).p = function () {
    return this.b7o_1.p();
  };
  protoOf(AnnotatedDocumentsList).qg = function (element) {
    return this.b7o_1.s(element);
  };
  protoOf(AnnotatedDocumentsList).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.qg((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AnnotatedDocumentsList).k = function () {
    return this.b7o_1.k();
  };
  protoOf(AnnotatedDocumentsList).rg = function (elements) {
    return this.b7o_1.h2(elements);
  };
  protoOf(AnnotatedDocumentsList).h2 = function (elements) {
    return this.rg(elements);
  };
  protoOf(AnnotatedDocumentsList).q = function (index) {
    return this.b7o_1.q(index);
  };
  protoOf(AnnotatedDocumentsList).j7q = function (element) {
    return this.b7o_1.t(element);
  };
  protoOf(AnnotatedDocumentsList).t = function (element) {
    if (!(element == null ? true : !(element == null)))
      return -1;
    return this.j7q((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AnnotatedDocumentsList).k7q = function (element) {
    return this.b7o_1.u(element);
  };
  protoOf(AnnotatedDocumentsList).u = function (element) {
    if (!(element == null ? true : !(element == null)))
      return -1;
    return this.k7q((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AnnotatedDocumentsList).i2 = function () {
    return this.b7o_1.i2();
  };
  protoOf(AnnotatedDocumentsList).r = function (index) {
    return this.b7o_1.r(index);
  };
  protoOf(AnnotatedDocumentsList).j2 = function (fromIndex, toIndex) {
    return this.b7o_1.j2(fromIndex, toIndex);
  };
  protoOf(AnnotatedDocumentsList).asJsReadonlyArrayView = function () {
    return this.b7o_1.asJsReadonlyArrayView();
  };
  protoOf(AnnotatedDocumentsList).n = function () {
    return this.b7o_1.n();
  };
  protoOf(AnnotatedDocumentsList).l7q = function (listener) {
    return this.b7o_1.n27(listener);
  };
  protoOf(AnnotatedDocumentsList).n27 = function (listener) {
    return this.l7q(listener);
  };
  protoOf(AnnotatedDocumentsList).m7q = function (handler) {
    return this.b7o_1.o27(handler);
  };
  protoOf(AnnotatedDocumentsList).o27 = function (handler) {
    return this.m7q(handler);
  };
  protoOf(AnnotatedDocumentsList).n7q = function (handler) {
    return this.b7o_1.p27(handler);
  };
  protoOf(AnnotatedDocumentsList).p27 = function (handler) {
    return this.n7q(handler);
  };
  function CollectionScope$getElements$slambda(this$0, $filter, resultContinuation) {
    this.w7q_1 = this$0;
    this.x7q_1 = $filter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CollectionScope$getElements$slambda).c7r = function ($this$flow, $completion) {
    var tmp = this.d7r($this$flow, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CollectionScope$getElements$slambda).oa = function (p1, $completion) {
    return this.c7r((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CollectionScope$getElements$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            this.z7q_1 = this.w7q_1.e7r_1.n4z().k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.z7q_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.a7r_1 = this.z7q_1.m();
            this.y9_1 = 2;
            suspendResult = execute_1(this.w7q_1.f7r_1(this.a7r_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.b7r_1 = suspendResult;
            var tmp0 = this.b7r_1.c75();
            var tmp$ret$0;
            l$ret$1: do {
              var tmp_0;
              if (isInterface(tmp0, Collection)) {
                tmp_0 = tmp0.p();
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                tmp$ret$0 = false;
                break l$ret$1;
              }
              var _iterator__ex2g4s = tmp0.k();
              while (_iterator__ex2g4s.l()) {
                var element = _iterator__ex2g4s.m();
                var tmp_1;
                if (!isBlank(element)) {
                  tmp_1 = this.x7q_1.e6v(element);
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  tmp$ret$0 = true;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = false;
            }
             while (false);
            if (tmp$ret$0) {
              this.y9_1 = 3;
              suspendResult = this.y7q_1.d1f(this.a7r_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 4;
              continue $sm;
            }

          case 3:
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.y9_1 = 1;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(CollectionScope$getElements$slambda).d7r = function ($this$flow, completion) {
    var i = new CollectionScope$getElements$slambda(this.w7q_1, this.x7q_1, completion);
    i.y7q_1 = $this$flow;
    return i;
  };
  function CollectionScope$getElements$slambda_0(this$0, $filter, resultContinuation) {
    var i = new CollectionScope$getElements$slambda(this$0, $filter, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.c7r($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CollectionScope$scopeTree$delegate$lambda($specification, this$0) {
    return function () {
      return new ScopeTree(listOf(new ScopeContent($specification, this$0)));
    };
  }
  function CollectionScope(specification, collection, present) {
    this.e7r_1 = collection;
    this.f7r_1 = present;
    var tmp = this;
    tmp.g7r_1 = lazy_0(CollectionScope$scopeTree$delegate$lambda(specification, this));
  }
  protoOf(CollectionScope).h7r = function (target) {
    return this.e7r_1.s(target);
  };
  protoOf(CollectionScope).i75 = function (target) {
    return this.h7r(!(target == null) ? target : THROW_CCE());
  };
  protoOf(CollectionScope).j75 = function (filter) {
    return flow(CollectionScope$getElements$slambda_0(this, filter, null));
  };
  function $runSuspendCOROUTINE$28(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q7r_1 = _this__u8e3s4;
    this.r7r_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$28).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            var tmp_0 = this;
            tmp_0.s7r_1 = this.r7r_1;
            this.t7r_1 = Unit_instance;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.u7r_1 = this.s7r_1;
            this.v7r_1 = this.q7r_1.y7r_1.x7r_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.v7r_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.w7r_1 = this.v7r_1.m();
            this.y9_1 = 3;
            suspendResult = this.u7r_1.m51(this.w7r_1.h75(this.q7r_1.z7r_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var result = suspendResult;
            if (!(result == null)) {
              this.t7r_1 = result;
              this.y9_1 = 6;
              continue $sm;
            } else {
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            this.y9_1 = 2;
            continue $sm;
          case 5:
            this.t7r_1 = null;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 6;
            continue $sm;
          case 6:
            return this.t7r_1;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$29(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i7s_1 = _this__u8e3s4;
    this.j7s_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$29).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            var tmp_0 = this;
            tmp_0.k7s_1 = this.j7s_1;
            this.l7s_1 = Unit_instance;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.m7s_1 = this.k7s_1;
            this.n7s_1 = this.i7s_1.p7s_1.x7r_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.n7s_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.o7s_1 = this.n7s_1.m();
            this.y9_1 = 3;
            suspendResult = this.m7s_1.m51(this.o7s_1.i75(this.i7s_1.q7s_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (suspendResult) {
              this.l7s_1 = true;
              this.y9_1 = 6;
              continue $sm;
            } else {
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            this.y9_1 = 2;
            continue $sm;
          case 5:
            this.l7s_1 = false;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 6;
            continue $sm;
          case 6:
            return this.l7s_1;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function CompositeScope$find$$inlined$suspendingQuery$1(this$0, $pointer) {
    this.y7r_1 = this$0;
    this.z7r_1 = $pointer;
  }
  protoOf(CompositeScope$find$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$28(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CompositeScope$find$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function CompositeScope$contains$$inlined$suspendingQuery$1(this$0, $target) {
    this.p7s_1 = this$0;
    this.q7s_1 = $target;
  }
  protoOf(CompositeScope$contains$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$29(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CompositeScope$contains$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function CompositeScope$getElements$slambda($filter, resultContinuation) {
    this.z7s_1 = $filter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CompositeScope$getElements$slambda).b7t = function (it, $completion) {
    var tmp = this.c7t(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CompositeScope$getElements$slambda).oa = function (p1, $completion) {
    return this.b7t((!(p1 == null) ? isInterface(p1, Scope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CompositeScope$getElements$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return this.a7t_1.j75(this.z7s_1);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CompositeScope$getElements$slambda).c7t = function (it, completion) {
    var i = new CompositeScope$getElements$slambda(this.z7s_1, completion);
    i.a7t_1 = it;
    return i;
  };
  function CompositeScope$getElements$slambda_0($filter, resultContinuation) {
    var i = new CompositeScope$getElements$slambda($filter, resultContinuation);
    var l = function (it, $completion) {
      return i.b7t(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CompositeScope(scopes) {
    this.x7r_1 = scopes;
  }
  protoOf(CompositeScope).h75 = function (pointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new CompositeScope$find$$inlined$suspendingQuery$1(this, pointer);
  };
  protoOf(CompositeScope).d7t = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new CompositeScope$contains$$inlined$suspendingQuery$1(this, target);
  };
  protoOf(CompositeScope).i75 = function (target) {
    return this.d7t(!(target == null) ? target : THROW_CCE());
  };
  protoOf(CompositeScope).j75 = function (filter) {
    var tmp = asFlow(this.x7r_1);
    return flatMapConcat(tmp, CompositeScope$getElements$slambda_0(filter, null));
  };
  protoOf(CompositeScope).e7t = function (filter) {
    var tmp;
    if (filter instanceof NoopScopeFilter) {
      tmp = this;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.x7r_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.k();
      while (_iterator__ex2g4s.l()) {
        var item = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.langDef.scopes.helper.CompositeScope.applyFilter.<anonymous>' call
        var tmp$ret$0 = item.k75(filter);
        destination.e(tmp$ret$0);
      }
      tmp = new CompositeScope(destination);
    }
    return tmp;
  };
  protoOf(CompositeScope).k75 = function (filter) {
    return this.e7t(filter);
  };
  function DelegatingScope(scope) {
    this.f7t_1 = scope;
  }
  protoOf(DelegatingScope).h75 = function (pointer) {
    return this.f7t_1.h75(pointer);
  };
  protoOf(DelegatingScope).i75 = function (target) {
    return this.f7t_1.i75(target);
  };
  protoOf(DelegatingScope).j75 = function (filter) {
    return this.f7t_1.j75(filter);
  };
  function EmptyScope() {
  }
  protoOf(EmptyScope).i75 = function (target) {
    return Companion_getInstance_76().j51_1;
  };
  protoOf(EmptyScope).j75 = function (filter) {
    return emptyFlow();
  };
  protoOf(EmptyScope).k75 = function (filter) {
    return this;
  };
  function $runSuspendCOROUTINE$31(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o7t_1 = _this__u8e3s4;
    this.p7t_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$31).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            var tmp_0 = this;
            tmp_0.q7t_1 = this.p7t_1;
            this.r7t_1 = this.q7t_1;
            var tmp_1 = this;
            tmp_1.s7t_1 = this.r7t_1;
            this.y9_1 = 1;
            suspendResult = this.r7t_1.m51(this.o7t_1.y7t_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.t7t_1 = suspendResult;
            this.u7t_1 = this.s7t_1;
            this.v7t_1 = this.t7t_1;
            if (!(this.v7t_1 == null)) {
              this.y9_1 = 2;
              suspendResult = this.u7t_1.m51(this.o7t_1.z7t_1.c7u_1.a74(this.v7t_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.x7t_1 = false;
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            this.x7t_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            if (this.x7t_1) {
              this.w7t_1 = this.v7t_1;
              this.y9_1 = 4;
              continue $sm;
            } else {
              this.w7t_1 = null;
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            return this.w7t_1;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$32(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l7u_1 = _this__u8e3s4;
    this.m7u_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$32).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.n7u_1 = this.m7u_1;
            this.o7u_1 = this.n7u_1;
            this.y9_1 = 1;
            suspendResult = this.o7u_1.m51(protoOf(DelegatingScope).i75.call(this.l7u_1.q7u_1, this.l7u_1.r7u_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              this.y9_1 = 2;
              suspendResult = this.o7u_1.m51(this.l7u_1.q7u_1.c7u_1.a74(this.l7u_1.r7u_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.p7u_1 = false;
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            this.p7u_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.p7u_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function FilteredScope$getElements$o$collect$slambda($$this$unsafeFlow, this$0, resultContinuation) {
    this.a7v_1 = $$this$unsafeFlow;
    this.b7v_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FilteredScope$getElements$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(FilteredScope$getElements$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FilteredScope$getElements$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            var tmp_0 = this;
            tmp_0.d7v_1 = this.a7v_1;
            var tmp_1 = this;
            tmp_1.e7v_1 = this.c7v_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.g7v_1 = this.d7v_1;
            this.h7v_1 = this.e7v_1;
            var tmp_2 = this;
            tmp_2.i7v_1 = this.h7v_1;
            this.j7v_1 = this.i7v_1;
            this.y9_1 = 2;
            suspendResult = execute_1(this.b7v_1.c7u_1.a74(this.j7v_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (suspendResult) {
              this.y9_1 = 4;
              suspendResult = this.g7v_1.d1f(this.h7v_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 5;
            continue $sm;
          case 4:
            this.f7v_1 = suspendResult;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(FilteredScope$getElements$o$collect$slambda).a1u = function (value, completion) {
    var i = new FilteredScope$getElements$o$collect$slambda(this.a7v_1, this.b7v_1, completion);
    i.c7v_1 = value;
    return i;
  };
  function FilteredScope$getElements$o$collect$slambda_0($$this$unsafeFlow, this$0, resultContinuation) {
    var i = new FilteredScope$getElements$o$collect$slambda($$this$unsafeFlow, this$0, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$33(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s7v_1 = _this__u8e3s4;
    this.t7v_1 = collector;
  }
  protoOf($collectCOROUTINE$33).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.u7v_1 = this.t7v_1;
            this.v7v_1 = this.u7v_1;
            this.y9_1 = 1;
            var tmp_1 = FilteredScope$getElements$o$collect$slambda_0(this.v7v_1, this.s7v_1.x7v_1, null);
            suspendResult = this.s7v_1.w7v_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_5(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_5(function_0) {
    this.y7v_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).d1f = function (value, $completion) {
    return this.y7v_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).b4 = function () {
    return this.y7v_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).hashCode = function () {
    return hashCode(this.b4());
  };
  function FilteredScope$find$$inlined$flatMap$1($this, this$0) {
    this.y7t_1 = $this;
    this.z7t_1 = this$0;
  }
  protoOf(FilteredScope$find$$inlined$flatMap$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$31(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(FilteredScope$find$$inlined$flatMap$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function FilteredScope$contains$$inlined$suspendingQuery$1(this$0, $target) {
    this.q7u_1 = this$0;
    this.r7u_1 = $target;
  }
  protoOf(FilteredScope$contains$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$32(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(FilteredScope$contains$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function FilteredScope$getElements$$inlined$filter$1($this, this$0) {
    this.w7v_1 = $this;
    this.x7v_1 = this$0;
  }
  protoOf(FilteredScope$getElements$$inlined$filter$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$33(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(FilteredScope$getElements$$inlined$filter$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function FilteredScope(base, condition) {
    DelegatingScope.call(this, base);
    this.b7u_1 = base;
    this.c7u_1 = condition;
  }
  protoOf(FilteredScope).h75 = function (pointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.flatMap' call
    var this_0 = protoOf(DelegatingScope).h75.call(this, pointer);
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new FilteredScope$find$$inlined$flatMap$1(this_0, this);
  };
  protoOf(FilteredScope).i75 = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new FilteredScope$contains$$inlined$suspendingQuery$1(this, target);
  };
  protoOf(FilteredScope).j75 = function (filter) {
    // Inline function 'kotlinx.coroutines.flow.filter' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = protoOf(DelegatingScope).j75.call(this, filter);
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new FilteredScope$getElements$$inlined$filter$1(this_0, this);
  };
  function filter_0(_this__u8e3s4, condition) {
    var tmp = filter$lambda(condition);
    return _this__u8e3s4.k75(new sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1(tmp));
  }
  function filter_1(_this__u8e3s4, condition) {
    return _this__u8e3s4.k75(condition);
  }
  function sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1(function_0) {
    this.z7v_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1).a74 = function (target) {
    return this.z7v_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1).b4 = function () {
    return this.z7v_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeFilter) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_api_ScopeFilter$0_1).hashCode = function () {
    return hashCode(this.b4());
  };
  function $runSuspendCOROUTINE$34(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i7w_1 = _this__u8e3s4;
    this.j7w_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$34).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.k7w_1 = this.j7w_1;
            this.l7w_1 = this.k7w_1;
            this.y9_1 = 1;
            suspendResult = this.i7w_1.m7w_1(this.l7w_1, this.i7w_1.n7w_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function filter$1$$inlined$suspendingQuery$1($condition, $it) {
    this.m7w_1 = $condition;
    this.n7w_1 = $it;
  }
  protoOf(filter$1$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$34(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(filter$1$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function filter$lambda($condition) {
    return function (it) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new filter$1$$inlined$suspendingQuery$1($condition, it);
    };
  }
  function get_LOG() {
    _init_properties_IndexingScope_kt__inhlv6();
    return LOG;
  }
  var LOG;
  function IndexingScope$depend$o$runSuspend$lambda($triggered) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      $triggered.t2c(true);
      return Unit_instance;
    };
  }
  function $runSuspendCOROUTINE$35(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w7w_1 = _this__u8e3s4;
    this.x7w_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$35).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.y7w_1 = this.x7w_1;
            this.z7w_1 = this.y7w_1;
            this.y9_1 = 1;
            suspendResult = awaitValue(this.w7w_1.h7x_1.e7x_1, 0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (this.w7w_1.h7x_1.a7x_1) {
              var triggered = new ValueProperty(false);
              depend(this.z7w_1.g4x_1.e4x_1, triggered);
              var tmp_1 = IndexingScope$depend$o$runSuspend$lambda(triggered);
              this.z7w_1.g4x_1.e4x_1.o4w(this.w7w_1.h7x_1.d7x_1.z27(new sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0(tmp_1)));
            }

            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$37(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q7x_1 = _this__u8e3s4;
    this.r7x_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$37).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.s7x_1 = this.r7x_1;
            this.t7x_1 = this.s7x_1;
            this.y9_1 = 1;
            suspendResult = this.t7x_1.m51(this.q7x_1.u7x_1.f7x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0 = this.q7x_1.u7x_1.c7x_1;
            var key = this.q7x_1.v7x_1;
            return (isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).w2(key);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function recordTreeSet($this) {
    var tmp = IndexingScope$recordTreeSet$lambda;
    return newTreeSet(new sam$kotlin_Comparator$0_1(tmp));
  }
  function removeItem0($this, item) {
    var records = getValue_0($this.c7x_1, item);
    var _iterator__ex2g4s = records.k();
    while (_iterator__ex2g4s.l()) {
      var record = _iterator__ex2g4s.m();
      var _iterator__ex2g4s_0 = record.x7x_1.d6v().k();
      while (_iterator__ex2g4s_0.l()) {
        var token = _iterator__ex2g4s_0.m();
        // Inline function 'kotlin.let' call
        // Inline function 'jetbrains.ocelot.langDef.scopes.helper.IndexingScope.removeItem0.<anonymous>' call
        var elements = getValue_0($this.b7x_1, token);
        elements.k2(record);
        if (elements.p()) {
          $this.b7x_1.s2(token);
        }
      }
    }
    $this.c7x_1.s2(item);
  }
  function ItemRecord(item, name) {
    this.w7x_1 = item;
    this.x7x_1 = name;
  }
  protoOf(ItemRecord).toString = function () {
    return 'ItemRecord(item=' + toString_0(this.w7x_1) + ', name=' + this.x7x_1.toString() + ')';
  };
  protoOf(ItemRecord).hashCode = function () {
    var result = this.w7x_1 == null ? 0 : hashCode(this.w7x_1);
    result = imul(result, 31) + this.x7x_1.hashCode() | 0;
    return result;
  };
  protoOf(ItemRecord).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ItemRecord))
      return false;
    var tmp0_other_with_cast = other instanceof ItemRecord ? other : THROW_CCE();
    if (!equals(this.w7x_1, tmp0_other_with_cast.w7x_1))
      return false;
    if (!this.x7x_1.equals(tmp0_other_with_cast.x7x_1))
      return false;
    return true;
  };
  function sam$kotlin_Comparator$0_0(function_0) {
    this.y7x_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).te = function (a, b) {
    return this.y7x_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.te(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).b4 = function () {
    return this.y7x_1;
  };
  protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$kotlin_Comparator$0_1(function_0) {
    this.z7x_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_1).te = function (a, b) {
    return this.z7x_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).compare = function (a, b) {
    return this.te(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_1).b4 = function () {
    return this.z7x_1;
  };
  protoOf(sam$kotlin_Comparator$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_1).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0(function_0) {
    this.a7y_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).b7y = function (target, eventType, namingInfo) {
    return this.a7y_1(target, eventType, namingInfo);
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).b4 = function () {
    return this.a7y_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ScopeListenerAdapter) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function IndexingScope$elementsIndex$lambda(a, b) {
    return compareTo_1(a, b, true);
  }
  function IndexingScope$insertItem$lambda($item, $presentation) {
    return function (it) {
      it.d7y($item, $presentation);
      return Unit_instance;
    };
  }
  function IndexingScope$insertItem$lambda_0($item, $presentation) {
    return function (it) {
      it.c7y($item, $presentation);
      return Unit_instance;
    };
  }
  function IndexingScope$recordTreeSet$lambda(left, right) {
    // Inline function 'kotlin.takeIf' call
    var this_0 = compareTo_1(left.x7x_1.b6v_1, right.x7x_1.b6v_1, true);
    var tmp;
    // Inline function 'jetbrains.ocelot.langDef.scopes.helper.IndexingScope.recordTreeSet.<anonymous>.<anonymous>' call
    if (!(this_0 === 0)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? compareTo_0(left.x7x_1.b6v_1, right.x7x_1.b6v_1) : tmp0_elvis_lhs;
  }
  function IndexingScope$removeItem$lambda($item) {
    return function (it) {
      it.e7y($item);
      return Unit_instance;
    };
  }
  function IndexingScope$depend$$inlined$suspendingQuery$1(this$0) {
    this.h7x_1 = this$0;
  }
  protoOf(IndexingScope$depend$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$35(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(IndexingScope$depend$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function IndexingScope$contains$$inlined$suspendingQuery$1(this$0, $target) {
    this.u7x_1 = this$0;
    this.v7x_1 = $target;
  }
  protoOf(IndexingScope$contains$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$37(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(IndexingScope$contains$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function IndexingScope$getElements$slambda(this$0, $filter, resultContinuation) {
    this.n7y_1 = this$0;
    this.o7y_1 = $filter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(IndexingScope$getElements$slambda).c7r = function ($this$flow, $completion) {
    var tmp = this.d7r($this$flow, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(IndexingScope$getElements$slambda).oa = function (p1, $completion) {
    return this.c7r((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(IndexingScope$getElements$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 12;
            this.y9_1 = 1;
            suspendResult = execute_1(this.n7y_1.f7x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0.q7y_1 = LinkedHashSet_init_$Create$();
            var tmp_1 = this;
            tmp_1.r7y_1 = ArrayList_init_$Create$();
            this.s7y_1 = this.o7y_1.z6u_1 ? this.o7y_1.g6v(VOID, VOID, false) : null;
            this.t7y_1 = this.o7y_1.x6u_1.d6v();
            var tmp_2 = this;
            var tmp0 = this.t7y_1;
            var tmp$ret$0;
            l$ret$1: do {
              var iterator = tmp0.k();
              if (!iterator.l()) {
                tmp$ret$0 = null;
                break l$ret$1;
              }
              var maxElem = iterator.m();
              if (!iterator.l()) {
                tmp$ret$0 = maxElem;
                break l$ret$1;
              }
              var maxValue = maxElem.length;
              do {
                var e = iterator.m();
                var v = e.length;
                if (compareTo_0(maxValue, v) < 0) {
                  maxElem = e;
                  maxValue = v;
                }
              }
               while (iterator.l());
              tmp$ret$0 = maxElem;
            }
             while (false);
            var tmp0_elvis_lhs = tmp$ret$0;
            tmp_2.u7y_1 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
            var tmp_3 = this;
            tmp_3.v7y_1 = this.n7y_1.b7x_1.er(this.u7y_1).w().k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.v7y_1.l()) {
              this.y9_1 = 10;
              continue $sm;
            }

            this.w7y_1 = this.v7y_1.m();
            var tmp_4 = this;
            tmp_4.x7y_1 = this.w7y_1.x();
            var tmp_5 = this;
            tmp_5.y7y_1 = this.w7y_1.y();
            if (!startsWith(this.x7y_1, this.u7y_1, true)) {
              this.y9_1 = 10;
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            this.z7y_1 = this.y7y_1.k();
            this.y9_1 = 4;
            continue $sm;
          case 4:
            if (!this.z7y_1.l()) {
              this.y9_1 = 9;
              continue $sm;
            }

            this.a7z_1 = this.z7y_1.m();
            if (this.q7y_1.s(this.a7z_1.w7x_1)) {
              this.y9_1 = 4;
              continue $sm;
            } else {
              this.y9_1 = 5;
              continue $sm;
            }

          case 5:
            if (!this.o7y_1.a6v(this.a7z_1.x7x_1)) {
              this.y9_1 = 4;
              continue $sm;
            } else {
              this.y9_1 = 6;
              continue $sm;
            }

          case 6:
            var tmp6 = this.q7y_1;
            var element = this.a7z_1.w7x_1;
            tmp6.e(element);
            if (this.s7y_1 == null || this.s7y_1.a6v(this.a7z_1.x7x_1)) {
              this.y9_1 = 7;
              suspendResult = this.p7y_1.d1f(this.a7z_1.w7x_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp8 = this.r7y_1;
              var element_0 = this.a7z_1.w7x_1;
              tmp8.e(element_0);
              this.y9_1 = 8;
              continue $sm;
            }

          case 7:
            this.y9_1 = 8;
            continue $sm;
          case 8:
            this.y9_1 = 4;
            continue $sm;
          case 9:
            this.y9_1 = 2;
            continue $sm;
          case 10:
            this.y9_1 = 11;
            suspendResult = emitAll_0(this.p7y_1, asFlow(this.r7y_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            return Unit_instance;
          case 12:
            throw this.ba_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 12) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(IndexingScope$getElements$slambda).d7r = function ($this$flow, completion) {
    var i = new IndexingScope$getElements$slambda(this.n7y_1, this.o7y_1, completion);
    i.p7y_1 = $this$flow;
    return i;
  };
  function IndexingScope$getElements$slambda_0(this$0, $filter, resultContinuation) {
    var i = new IndexingScope$getElements$slambda(this$0, $filter, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.c7r($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function IndexingScope$scopeTree$delegate$lambda($specification, this$0) {
    return function () {
      return new ScopeTree(listOf(new ScopeContent($specification, this$0)));
    };
  }
  function IndexingScope(specification, followChanges, initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 12 : initialCapacity;
    this.a7x_1 = followChanges;
    var tmp = this;
    var tmp_0 = IndexingScope$elementsIndex$lambda;
    tmp.b7x_1 = newTreeMap(new sam$kotlin_Comparator$0_0(tmp_0));
    this.c7x_1 = HashMap_init_$Create$_0(capacity(initialCapacity));
    this.d7x_1 = new Listeners();
    this.e7x_1 = new ValueProperty(0);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    tmp_1.f7x_1 = new IndexingScope$depend$$inlined$suspendingQuery$1(this);
    var tmp_2 = this;
    tmp_2.g7x_1 = lazy_0(IndexingScope$scopeTree$delegate$lambda(specification, this));
  }
  protoOf(IndexingScope).b7z = function (item, presentation) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.c7x_1;
    var itemRenamed = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w2(item);
    // Inline function 'kotlin.collections.map' call
    var this_1 = presentation.c75();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s = this_1.k();
    while (_iterator__ex2g4s.l()) {
      var item_0 = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.scopes.helper.IndexingScope.insertItem.<anonymous>' call
      var tmp$ret$2 = new ItemRecord(item, get_tokenized(item_0));
      destination.e(tmp$ret$2);
    }
    var records = destination;
    if (itemRenamed) {
      if (equals(getValue_0(this.c7x_1, item), records)) {
        return Unit_instance;
      }
      removeItem0(this, item);
    }
    var _iterator__ex2g4s_0 = records.k();
    while (_iterator__ex2g4s_0.l()) {
      var record = _iterator__ex2g4s_0.m();
      var _iterator__ex2g4s_1 = record.x7x_1.d6v().k();
      while (_iterator__ex2g4s_1.l()) {
        var token = _iterator__ex2g4s_1.m();
        // Inline function 'kotlin.collections.getOrPut' call
        var this_2 = this.b7x_1;
        var value = this_2.y2(token);
        var tmp;
        if (value == null) {
          // Inline function 'jetbrains.ocelot.langDef.scopes.helper.IndexingScope.insertItem.<anonymous>' call
          var answer = recordTreeSet(this);
          this_2.r2(token, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        tmp.e(record);
      }
    }
    // Inline function 'kotlin.collections.set' call
    this.c7x_1.r2(item, records);
    if (itemRenamed) {
      this.d7x_1.a28(IndexingScope$insertItem$lambda(item, presentation));
    } else {
      this.d7x_1.a28(IndexingScope$insertItem$lambda_0(item, presentation));
    }
  };
  protoOf(IndexingScope).c7z = function (item) {
    removeItem0(this, item);
    this.d7x_1.a28(IndexingScope$removeItem$lambda(item));
  };
  protoOf(IndexingScope).c4e = function () {
    this.e7x_1.t2c(this.e7x_1.qr() + 1 | 0);
  };
  protoOf(IndexingScope).d7z = function () {
    this.e7x_1.t2c(this.e7x_1.qr() - 1 | 0);
  };
  protoOf(IndexingScope).h7r = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new IndexingScope$contains$$inlined$suspendingQuery$1(this, target);
  };
  protoOf(IndexingScope).i75 = function (target) {
    return this.h7r(!(target == null) ? target : THROW_CCE());
  };
  protoOf(IndexingScope).j75 = function (filter) {
    return flow(IndexingScope$getElements$slambda_0(this, filter, null));
  };
  function capacity(initialCapacity) {
    _init_properties_IndexingScope_kt__inhlv6();
    return numberToInt(initialCapacity / 0.75);
  }
  function IndexingCollectionScope(_this__u8e3s4, specification, collection, present, $completion) {
    var tmp = new $IndexingCollectionScopeCOROUTINE$38(_this__u8e3s4, specification, collection, present, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function IndexingCollectionScope$insertItem$handleQueryResult(scope, $item, $specification, result) {
    if (!(result instanceof Ready)) {
      return Unit_instance;
    }
    var outcome = result.j4x_1;
    if (outcome instanceof Success) {
      scope.b7z($item, outcome.k4x_1);
    } else {
      if (outcome instanceof Failure_0) {
        get_LOG().eo("Item's name calculation thrown exception, setting it to null, scope " + $specification.toString() + ', item ' + toString_1($item), outcome.l4x_1);
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  function IndexingCollectionScope$insertItem(scope, $present, followChanges, $this_IndexingCollectionScope, nameProperties, $specification, item, $completion) {
    var tmp = new $IndexingCollectionScope$insertItemCOROUTINE$39(scope, $present, followChanges, $this_IndexingCollectionScope, nameProperties, $specification, item, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function IndexingCollectionScope$removeItem(followChanges, nameProperties, scope, item) {
    if (followChanges) {
      getValue_0(nameProperties, item).vr();
    }
    scope.c7z(item);
  }
  function IndexingCollectionScope$populateScope(scope, $specification, followChanges, $present, $this_IndexingCollectionScope, nameProperties, initialItems, $completion) {
    var tmp = new $IndexingCollectionScope$populateScopeCOROUTINE$40(scope, $specification, followChanges, $present, $this_IndexingCollectionScope, nameProperties, initialItems, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function IndexingCollectionScope$lambda($scope) {
    return function (it) {
      $scope.d7z();
      return Unit_instance;
    };
  }
  function IndexingCollectionScope$lambda_0($events) {
    return function (it) {
      $events.i1c();
      return Unit_instance;
    };
  }
  function IndexingCollectionScope$lambda_1($scope, $events) {
    return function (it) {
      $scope.c4e();
      var tmp;
      if (!_ChannelResult___get_isSuccess__impl__odq1z9($events.a1c(it))) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      return Unit_instance;
    };
  }
  function IndexingCollectionScope$slambda($itemsChangeHandler, $events, $scope, $present, $followChanges, $this_IndexingCollectionScope, $nameProperties, $specification, resultContinuation) {
    this.p81_1 = $itemsChangeHandler;
    this.q81_1 = $events;
    this.r81_1 = $scope;
    this.s81_1 = $present;
    this.t81_1 = $followChanges;
    this.u81_1 = $this_IndexingCollectionScope;
    this.v81_1 = $nameProperties;
    this.w81_1 = $specification;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(IndexingCollectionScope$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(IndexingCollectionScope$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(IndexingCollectionScope$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 16;
            var tmp_0 = this;
            tmp_0.y81_1 = this.p81_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.a82_1 = this.y81_1;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 15;
            var tmp_1 = this;
            tmp_1.c82_1 = this.a82_1;
            this.d82_1 = this.c82_1;
            this.e82_1 = this.q81_1.k();
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.y9_1 = 5;
            suspendResult = this.e82_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.y9_1 = 11;
              continue $sm;
            }

            this.f82_1 = this.e82_1.m();
            this.y9_1 = 6;
            continue $sm;
          case 6:
            this.z9_1 = 10;
            if (!this.f82_1.h27_1.equals(EventType_REMOVE_getInstance())) {
              this.y9_1 = 7;
              suspendResult = IndexingCollectionScope$insertItem(this.r81_1, this.s81_1, this.t81_1, this.u81_1, this.v81_1, this.w81_1, this.f82_1.k27(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 8;
              continue $sm;
            }

          case 7:
            this.y9_1 = 8;
            continue $sm;
          case 8:
            var tmp_2 = this;
            var tmp_3;
            if (!this.f82_1.h27_1.equals(EventType_ADD_getInstance())) {
              IndexingCollectionScope$removeItem(this.t81_1, this.v81_1, this.r81_1, this.f82_1.i27());
              tmp_3 = Unit_instance;
            }

            tmp_2.g82_1 = tmp_3;
            this.y9_1 = 9;
            continue $sm;
          case 9:
            this.z9_1 = 15;
            this.r81_1.d7z();
            this.y9_1 = 4;
            continue $sm;
          case 10:
            this.z9_1 = 15;
            var t = this.ba_1;
            this.r81_1.d7z();
            throw t;
          case 11:
            var tmp_4 = this;
            tmp_4.b82_1 = Unit_instance;
            this.z9_1 = 16;
            this.y9_1 = 12;
            var tmp_5 = this;
            continue $sm;
          case 12:
            this.z9_1 = 16;
            var tmp_6 = this;
            this.a82_1.vr();
            tmp_6.z81_1 = Unit_instance;
            this.y9_1 = 14;
            continue $sm;
          case 13:
            this.z9_1 = 16;
            this.a82_1.vr();
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 14;
            continue $sm;
          case 14:
            return Unit_instance;
          case 15:
            this.z9_1 = 16;
            var t_0 = this.ba_1;
            this.a82_1.vr();
            throw t_0;
          case 16:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 16) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(IndexingCollectionScope$slambda).i1l = function ($this$launch, completion) {
    var i = new IndexingCollectionScope$slambda(this.p81_1, this.q81_1, this.r81_1, this.s81_1, this.t81_1, this.u81_1, this.v81_1, this.w81_1, completion);
    i.x81_1 = $this$launch;
    return i;
  };
  function IndexingCollectionScope$slambda_0($itemsChangeHandler, $events, $scope, $present, $followChanges, $this_IndexingCollectionScope, $nameProperties, $specification, resultContinuation) {
    var i = new IndexingCollectionScope$slambda($itemsChangeHandler, $events, $scope, $present, $followChanges, $this_IndexingCollectionScope, $nameProperties, $specification, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function IndexingCollectionScope$insertItem$lambda($scope, $item, $specification) {
    return function (event) {
      IndexingCollectionScope$insertItem$handleQueryResult($scope, $item, $specification, event.p2e_1);
      return Unit_instance;
    };
  }
  function $IndexingCollectionScopeCOROUTINE$38(_this__u8e3s4, specification, collection, present, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m7z_1 = _this__u8e3s4;
    this.n7z_1 = specification;
    this.o7z_1 = collection;
    this.p7z_1 = present;
  }
  protoOf($IndexingCollectionScopeCOROUTINE$38).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.q7z_1 = this.m7z_1.g4x_1.i4x();
            this.r7z_1 = new IndexingScope(this.n7z_1, this.q7z_1, execute_0(this.o7z_1.n()));
            this.s7z_1 = this.o7z_1.n4z();
            var tmp_0 = this;
            tmp_0.t7z_1 = HashMap_init_$Create$();
            if (this.q7z_1) {
              var tmp_1 = this;
              tmp_1.v7z_1 = Channel(2147483647, VOID, IndexingCollectionScope$lambda(this.r7z_1));
              var tmp_2 = get_job(this.m7z_1.g4x_1.f4x_1.et());
              tmp_2.hu(IndexingCollectionScope$lambda_0(this.v7z_1));
              var tmp_3 = this;
              tmp_3.w7z_1 = this.s7z_1.p27(IndexingCollectionScope$lambda_1(this.r7z_1, this.v7z_1));
              this.y9_1 = 2;
              suspendResult = IndexingCollectionScope$populateScope(this.r7z_1, this.n7z_1, this.q7z_1, this.p7z_1, this.m7z_1, this.t7z_1, ArrayList_init_$Create$_1(this.s7z_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = IndexingCollectionScope$populateScope(this.r7z_1, this.n7z_1, this.q7z_1, this.p7z_1, this.m7z_1, this.t7z_1, ArrayList_init_$Create$_1(this.s7z_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_4 = this;
            tmp_4.u7z_1 = Unit_instance;
            this.y9_1 = 3;
            continue $sm;
          case 2:
            var tmp_5 = this;
            tmp_5.u7z_1 = launch(this.m7z_1.g4x_1.f4x_1, VOID, VOID, IndexingCollectionScope$slambda_0(this.w7z_1, this.v7z_1, this.r7z_1, this.p7z_1, this.q7z_1, this.m7z_1, this.t7z_1, this.n7z_1, null));
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.r7z_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $IndexingCollectionScope$insertItemCOROUTINE$39(scope, $present, followChanges, $this_IndexingCollectionScope, nameProperties, $specification, item, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f80_1 = scope;
    this.g80_1 = $present;
    this.h80_1 = followChanges;
    this.i80_1 = $this_IndexingCollectionScope;
    this.j80_1 = nameProperties;
    this.k80_1 = $specification;
    this.l80_1 = item;
  }
  protoOf($IndexingCollectionScope$insertItemCOROUTINE$39).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = execute_1(this.g80_1(this.l80_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.f80_1.b7z(this.l80_1, ARGUMENT);
            if (this.h80_1) {
              var loopingQuery = new LoopingQuery(this.i80_1.g4x_1.f4x_1.et(), this.g80_1(this.l80_1));
              var tmp0 = this.j80_1;
              var tmp1 = this.l80_1;
              var value = loopingQuery.p27(IndexingCollectionScope$insertItem$lambda(this.f80_1, this.l80_1, this.k80_1));
              tmp0.r2(tmp1, value);
            }

            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $IndexingCollectionScope$populateScopeCOROUTINE$40(scope, $specification, followChanges, $present, $this_IndexingCollectionScope, nameProperties, initialItems, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u80_1 = scope;
    this.v80_1 = $specification;
    this.w80_1 = followChanges;
    this.x80_1 = $present;
    this.y80_1 = $this_IndexingCollectionScope;
    this.z80_1 = nameProperties;
    this.a81_1 = initialItems;
  }
  protoOf($IndexingCollectionScope$populateScopeCOROUTINE$40).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            this.u80_1.c4e();
            get_LOG().go('Scope index population started, scope ' + this.v80_1.toString() + ', size: ' + this.a81_1.n() + ', follow changes: ' + this.w80_1);
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 6;
            var tmp_0 = this;
            tmp_0.c81_1 = Monotonic_instance;
            this.d81_1 = this.c81_1;
            this.e81_1 = this.d81_1.ye();
            this.f81_1 = this.a81_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.f81_1.l()) {
              this.y9_1 = 4;
              continue $sm;
            }

            this.g81_1 = this.f81_1.m();
            this.y9_1 = 3;
            suspendResult = IndexingCollectionScope$insertItem(this.u80_1, this.x80_1, this.w80_1, this.y80_1, this.z80_1, this.v80_1, this.g81_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.y9_1 = 2;
            continue $sm;
          case 4:
            this.b81_1 = ValueTimeMark__elapsedNow_impl_eonqvs(this.e81_1);
            this.z9_1 = 7;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            var tmp_1 = this.b81_1;
            this.z9_1 = 7;
            this.u80_1.d7z();
            var time = tmp_1;
            get_LOG().go('Scope index population finished, scope ' + this.v80_1.toString() + ', time: ' + Duration__toString_impl_8d916b_0(time, DurationUnit_SECONDS_getInstance(), 2));
            return Unit_instance;
          case 6:
            this.z9_1 = 7;
            var t = this.ba_1;
            this.u80_1.d7z();
            throw t;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_IndexingScope_kt_pkg5po;
  function _init_properties_IndexingScope_kt__inhlv6() {
    if (!properties_initialized_IndexingScope_kt_pkg5po) {
      properties_initialized_IndexingScope_kt_pkg5po = true;
      LOG = getLogger(getKClass(IndexingScope));
    }
  }
  function LocatableScope(specification, body) {
    DelegatingScope.call(this, body);
    this.i82_1 = specification;
    this.j82_1 = body;
    this.k82_1 = new ScopeTree(listOf(new ScopeContent(this.i82_1)));
  }
  function ScopeListenerAdapter() {
  }
  function Scopes() {
    Scopes_instance = this;
    this.y7a_1 = new EmptyScope();
  }
  protoOf(Scopes).c7f = function () {
    return this.y7a_1;
  };
  var Scopes_instance;
  function Scopes_getInstance() {
    if (Scopes_instance == null)
      new Scopes();
    return Scopes_instance;
  }
  function $runSuspendCOROUTINE$42(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t82_1 = _this__u8e3s4;
    this.u82_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$42).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.v82_1 = this.u82_1;
            this.w82_1 = this.v82_1;
            this.y9_1 = 1;
            suspendResult = this.w82_1.m51(this.t82_1.a83_1.y82_1.h75(this.t82_1.b83_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x82_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.w82_1.m51(this.t82_1.a83_1.z82_1.h75(this.t82_1.b83_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var secondResolveResult = suspendResult;
            var tmp_1;
            if (this.x82_1 == null) {
              tmp_1 = secondResolveResult;
            } else {
              tmp_1 = secondResolveResult == null ? this.x82_1 : null;
            }

            return tmp_1;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$43(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k83_1 = _this__u8e3s4;
    this.l83_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$43).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.m83_1 = this.l83_1;
            this.n83_1 = this.m83_1;
            this.y9_1 = 1;
            suspendResult = this.n83_1.m51(this.k83_1.p83_1.y82_1.i75(this.k83_1.q83_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o83_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.n83_1.m51(this.k83_1.p83_1.z82_1.i75(this.k83_1.q83_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = this.o83_1 === ARGUMENT;
            return !ARGUMENT_0;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function UniqueSumScope$find$$inlined$suspendingQuery$1(this$0, $pointer) {
    this.a83_1 = this$0;
    this.b83_1 = $pointer;
  }
  protoOf(UniqueSumScope$find$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$42(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(UniqueSumScope$find$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function UniqueSumScope$contains$$inlined$suspendingQuery$1(this$0, $target) {
    this.p83_1 = this$0;
    this.q83_1 = $target;
  }
  protoOf(UniqueSumScope$contains$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$43(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(UniqueSumScope$contains$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function UniqueSumScope$getElements$slambda(this$0, $filter, resultContinuation) {
    this.z83_1 = this$0;
    this.a84_1 = $filter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(UniqueSumScope$getElements$slambda).c1m = function ($this$flow, $completion) {
    var tmp = this.d1m($this$flow, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(UniqueSumScope$getElements$slambda).oa = function (p1, $completion) {
    return this.c1m((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(UniqueSumScope$getElements$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = emitAll_0(this.b84_1, this.z83_1.y82_1.j75(this.a84_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y9_1 = 2;
            suspendResult = emitAll_0(this.b84_1, this.z83_1.z82_1.j75(this.a84_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(UniqueSumScope$getElements$slambda).d1m = function ($this$flow, completion) {
    var i = new UniqueSumScope$getElements$slambda(this.z83_1, this.a84_1, completion);
    i.b84_1 = $this$flow;
    return i;
  };
  function UniqueSumScope$getElements$slambda_0(this$0, $filter, resultContinuation) {
    var i = new UniqueSumScope$getElements$slambda(this$0, $filter, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.c1m($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function UniqueSumScope(firstScope, secondScope) {
    this.y82_1 = firstScope;
    this.z82_1 = secondScope;
  }
  protoOf(UniqueSumScope).h75 = function (pointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new UniqueSumScope$find$$inlined$suspendingQuery$1(this, pointer);
  };
  protoOf(UniqueSumScope).d7t = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new UniqueSumScope$contains$$inlined$suspendingQuery$1(this, target);
  };
  protoOf(UniqueSumScope).i75 = function (target) {
    return this.d7t(!(target == null) ? target : THROW_CCE());
  };
  protoOf(UniqueSumScope).j75 = function (filter) {
    return flow(UniqueSumScope$getElements$slambda_0(this, filter, null));
  };
  protoOf(UniqueSumScope).e7t = function (filter) {
    var tmp;
    if (filter instanceof NoopScopeFilter) {
      tmp = this;
    } else {
      tmp = new UniqueSumScope(this.y82_1.k75(filter), this.z82_1.k75(filter));
    }
    return tmp;
  };
  protoOf(UniqueSumScope).k75 = function (filter) {
    return this.e7t(filter);
  };
  function parentChildScopes($this, source) {
    var tmp = Companion_instance_124;
    return new ParentChildScopes($this.d84_1.d7q($this.d84_1.y76(tmp.z7d(isInterface(source, DomainNode) ? source : THROW_CCE()))), $this.c84_1.l6p_1);
  }
  function AbstractScopedReferenceResolver(refTag, scopeConfig) {
    this.c84_1 = refTag;
    this.d84_1 = scopeConfig;
  }
  protoOf(AbstractScopedReferenceResolver).e84 = function (_this__u8e3s4, source, $completion) {
    return _this__u8e3s4.m51(parentChildScopes(this, source).f7f(source), $completion);
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda($this_flow, this$0, $$this$executeSuspendingQuery, $filter, resultContinuation) {
    this.n84_1 = $this_flow;
    this.o84_1 = this$0;
    this.p84_1 = $$this$executeSuspendingQuery;
    this.q84_1 = $filter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 8;
            var tmp_0 = this;
            tmp_0.s84_1 = this.n84_1;
            var tmp_1 = this;
            tmp_1.t84_1 = this.r84_1;
            this.u84_1 = this.s84_1;
            this.v84_1 = this.t84_1;
            var tmp_2 = this.v84_1;
            if (isInterface(tmp_2, TargetInfoStub)) {
              this.y9_1 = 6;
              var tmp_3 = this.v84_1.m85();
              suspendResult = this.u84_1.d1f(tmp_3 instanceof TargetInfo ? tmp_3 : THROW_CCE(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = execute_1(this.o84_1.l85(this.v84_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.x84_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.p84_1.m51(this.o84_1.k85_1.x7d(this.v84_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.y84_1 = suspendResult;
            var tmp_4 = this;
            var tmp0 = this.y84_1.c75();
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              if (this.q84_1.e6v(element)) {
                destination.e(element);
              }
            }

            tmp_4.z84_1 = destination;
            this.a85_1 = this.z84_1;
            var tmp_5 = this;
            tmp_5.b85_1 = this.a85_1;
            this.c85_1 = this.b85_1;
            var tmp_6 = this;
            tmp_6.d85_1 = this.c85_1;
            this.e85_1 = this.d85_1;
            this.f85_1 = this.e85_1.k();
            this.y9_1 = 3;
            continue $sm;
          case 3:
            if (!this.f85_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.g85_1 = this.f85_1.m();
            var tmp_7 = this;
            tmp_7.h85_1 = this.g85_1;
            this.i85_1 = this.h85_1;
            this.y9_1 = 4;
            suspendResult = this.u84_1.d1f(new TargetInfo(this.v84_1, this.x84_1, this.i85_1, this.y84_1.b75_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.y9_1 = 3;
            continue $sm;
          case 5:
            this.w84_1 = this.c85_1;
            this.y9_1 = 7;
            continue $sm;
          case 6:
            var tmp_8 = this;
            tmp_8.w84_1 = Unit_instance;
            this.y9_1 = 7;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 8) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda).a1u = function (value, completion) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda(this.n84_1, this.o84_1, this.p84_1, this.q84_1, completion);
    i.r84_1 = value;
    return i;
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda_0($this_flow, this$0, $$this$executeSuspendingQuery, $filter, resultContinuation) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda($this_flow, this$0, $$this$executeSuspendingQuery, $filter, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda($this, this$0, $$this$executeSuspendingQuery, $filter, resultContinuation) {
    this.v85_1 = $this;
    this.w85_1 = this$0;
    this.x85_1 = $$this$executeSuspendingQuery;
    this.y85_1 = $filter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).a86 = function ($this$flow, $completion) {
    var tmp = this.b86($this$flow, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).oa = function (p1, $completion) {
    return this.a86((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            var tmp_0 = AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda$slambda_0(this.z85_1, this.w85_1, this.x85_1, this.y85_1, null);
            suspendResult = this.v85_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_6(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).b86 = function ($this$flow, completion) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda(this.v85_1, this.w85_1, this.x85_1, this.y85_1, completion);
    i.z85_1 = $this$flow;
    return i;
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_0($this, this$0, $$this$executeSuspendingQuery, $filter, resultContinuation) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda($this, this$0, $$this$executeSuspendingQuery, $filter, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.a86($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1($this_channelFlow, resultContinuation) {
    this.k86_1 = $this_channelFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).m86 = function (it, $completion) {
    var tmp = this.n86(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).oa = function (p1, $completion) {
    return this.m86(p1 instanceof TargetInfo ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.k86_1.y15().z1b(this.l86_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).n86 = function (it, completion) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1(this.k86_1, completion);
    i.l86_1 = it;
    return i;
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_2($this_channelFlow, resultContinuation) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1($this_channelFlow, resultContinuation);
    var l = function (it, $completion) {
      return i.m86(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $runSuspendCOROUTINE$44(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w86_1 = _this__u8e3s4;
    this.x86_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$44).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.y86_1 = this.x86_1;
            this.z86_1 = this.y86_1;
            this.y9_1 = 1;
            suspendResult = this.z86_1.m51(this.w86_1.c87_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.a87_1 = suspendResult;
            var tmp_1 = this;
            var this_0 = this.a87_1.j75(this.w86_1.d87_1);
            tmp_1.b87_1 = flow(AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_0(this_0, this.w86_1.e87_1, this.z86_1, this.w86_1.d87_1, null));
            this.y9_1 = 2;
            var tmp_2 = AbstractScopedReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_2(this.w86_1.f87_1, null);
            suspendResult = this.b87_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_6(tmp_2), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$1$$inlined$executeSuspendingQuery$1($scopeQuery, $filter, this$0, $this_channelFlow) {
    this.c87_1 = $scopeQuery;
    this.d87_1 = $filter;
    this.e87_1 = this$0;
    this.f87_1 = $this_channelFlow;
  }
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$1$$inlined$executeSuspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$44(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$1$$inlined$executeSuspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function parentChildScopes_0($this, source) {
    var tmp = Companion_instance_124;
    return new ParentChildScopes($this.k85_1.d7q($this.k85_1.y76(tmp.z7d(isInterface(source, DomainNode) ? source : THROW_CCE()))), $this.j85_1.l6p_1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_6(function_0) {
    this.g87_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).d1f = function (value, $completion) {
    return this.g87_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).b4 = function () {
    return this.g87_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).hashCode = function () {
    return hashCode(this.b4());
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda($scopeQuery, $filter, this$0, resultContinuation) {
    this.p87_1 = $scopeQuery;
    this.q87_1 = $filter;
    this.r87_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda).t87 = function ($this$channelFlow, $completion) {
    var tmp = this.u87($this$channelFlow, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda).oa = function (p1, $completion) {
    return this.t87((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = execute_1(new AbstractScopedReferenceTargetsSupplier$getElements$1$$inlined$executeSuspendingQuery$1(this.p87_1, this.q87_1, this.r87_1, this.s87_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(AbstractScopedReferenceTargetsSupplier$getElements$slambda).u87 = function ($this$channelFlow, completion) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda(this.p87_1, this.q87_1, this.r87_1, completion);
    i.s87_1 = $this$channelFlow;
    return i;
  };
  function AbstractScopedReferenceTargetsSupplier$getElements$slambda_0($scopeQuery, $filter, this$0, resultContinuation) {
    var i = new AbstractScopedReferenceTargetsSupplier$getElements$slambda($scopeQuery, $filter, this$0, resultContinuation);
    var l = function ($this$channelFlow, $completion) {
      return i.t87($this$channelFlow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AbstractScopedReferenceTargetsSupplier(refTag, scopeConfig) {
    this.j85_1 = refTag;
    this.k85_1 = scopeConfig;
  }
  protoOf(AbstractScopedReferenceTargetsSupplier).g6u = function (context, filter) {
    var tmp;
    if (context instanceof EnclosingNodeContext) {
      var tmp_0 = context.x6s_1;
      tmp = !isInterface(tmp_0, DomainNode);
    } else {
      tmp = false;
    }
    // Inline function 'kotlin.require' call
    if (!!tmp) {
      // Inline function 'jetbrains.ocelot.langDef.scopes.resolve.AbstractScopedReferenceTargetsSupplier.getElements.<anonymous>' call
      var message = 'Cannot use scopes based reference resolver on objects that are not DomainNode';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp_1;
    if (context instanceof SourceNodeContext) {
      tmp_1 = parentChildScopes_0(this, context.a6t_1).f7f(context.a6t_1);
    } else {
      if (context instanceof EnclosingNodeContext) {
        tmp_1 = parentChildScopes_0(this, context.z6s()).e7f(context);
      } else {
        noWhenBranchMatchedException();
      }
    }
    var scopeQuery = tmp_1;
    return channelFlow(AbstractScopedReferenceTargetsSupplier$getElements$slambda_0(scopeQuery, filter, this, null));
  };
  function scoped(_this__u8e3s4, tags, skipValidation) {
    skipValidation = skipValidation === VOID ? false : skipValidation;
    return scoped_0(_this__u8e3s4, tags, scoped$lambda(skipValidation));
  }
  function scoped_0(_this__u8e3s4, tags, skipValidationPredicate) {
    var builder = new ScopedReferenceFactoryRegistryBuilder(_this__u8e3s4, ScopeConfigService_instance.e2o(_this__u8e3s4), Companion_instance_92.e2o(_this__u8e3s4), Companion_instance_96.e2o(_this__u8e3s4));
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tags.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.scopes.resolve.scoped.<anonymous>' call
      builder.z87(element, skipValidationPredicate);
    }
  }
  function getDefaultFinder($this, refContentClass) {
    var tmp;
    if (refContentClass.equals(getKClass(LocalReferenceContent))) {
      tmp = $this.x87_1;
    } else if (refContentClass.equals(getKClass(QualifiedReferenceContent))) {
      tmp = $this.y87_1;
    } else {
      throw IllegalStateException_init_$Create$();
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, NodeFinder) ? tmp_0 : THROW_CCE();
  }
  function ScopedReferenceFactoryRegistryBuilder(builder, scopeConfig, sameModelNodeFinder, globalNodeFinder) {
    this.v87_1 = builder;
    this.w87_1 = scopeConfig;
    this.x87_1 = sameModelNodeFinder;
    this.y87_1 = globalNodeFinder;
  }
  protoOf(ScopedReferenceFactoryRegistryBuilder).z87 = function (tag, skipValidationPredicate) {
    var referenceResolver = new ScopedReferenceResolver(tag, this.w87_1, getDefaultFinder(this, tag.m6p_1), skipValidationPredicate);
    this.v87_1.p6x(tag, Companion_instance_103.g6x(referenceResolver));
  };
  function scoped$lambda($skipValidation) {
    return function (it) {
      return $skipValidation;
    };
  }
  function $runSuspendCOROUTINE$46(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i88_1 = _this__u8e3s4;
    this.j88_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$46).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 9;
            var tmp_0 = this;
            tmp_0.k88_1 = this.j88_1;
            this.l88_1 = this.k88_1;
            this.y9_1 = 1;
            suspendResult = this.l88_1.m51(this.i88_1.y88_1.b6u(this.i88_1.z88_1, this.i88_1.a89_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.m88_1 = suspendResult;
            if (this.m88_1 == null) {
              this.n88_1 = null;
              this.y9_1 = 6;
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.o88_1 = this.m88_1;
              this.p88_1 = this.o88_1;
              var tmp_2 = this;
              tmp_2.r88_1 = this.p88_1;
              this.s88_1 = this.r88_1;
              if (this.i88_1.y88_1.e89_1(this.i88_1.z88_1)) {
                this.t88_1 = true;
                this.y9_1 = 4;
                continue $sm;
              } else {
                this.y9_1 = 2;
                suspendResult = this.i88_1.y88_1.e84(this.l88_1, this.i88_1.z88_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 2:
            this.u88_1 = suspendResult;
            this.v88_1 = this.u88_1.i75(this.s88_1);
            this.y9_1 = 3;
            suspendResult = this.l88_1.m51(this.v88_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.t88_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            if (this.t88_1) {
              this.q88_1 = this.p88_1;
              this.y9_1 = 5;
              continue $sm;
            } else {
              this.q88_1 = null;
              this.y9_1 = 5;
              continue $sm;
            }

          case 5:
            this.n88_1 = this.q88_1;
            this.y9_1 = 6;
            continue $sm;
          case 6:
            this.w88_1 = this.n88_1;
            if (this.w88_1 == null) {
              this.y9_1 = 7;
              suspendResult = findByPointer(this.l88_1, this.i88_1.y88_1, this.i88_1.z88_1, this.i88_1.a89_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.x88_1 = this.w88_1;
              this.y9_1 = 8;
              continue $sm;
            }

          case 7:
            this.x88_1 = suspendResult;
            this.y9_1 = 8;
            continue $sm;
          case 8:
            return this.x88_1;
          case 9:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 9) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$47(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n89_1 = _this__u8e3s4;
    this.o89_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$47).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.p89_1 = this.o89_1;
            this.q89_1 = this.p89_1;
            this.y9_1 = 1;
            suspendResult = this.q89_1.m51(this.n89_1.u89_1.d89_1.z6l(this.n89_1.v89_1, this.n89_1.w89_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.r89_1 = suspendResult;
            var tmp_1 = this;
            var tmp_2;
            if (this.r89_1 == null) {
              tmp_2 = null;
            } else {
              var it = this.r89_1;
              tmp_2 = safeCast(this.n89_1.u89_1.c84_1.l6p_1, it);
            }

            tmp_1.s89_1 = tmp_2;
            if (this.s89_1 == null) {
              this.y9_1 = 2;
              suspendResult = findByPointer(this.q89_1, this.n89_1.u89_1, this.n89_1.v89_1, this.n89_1.w89_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.t89_1 = this.s89_1;
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            this.t89_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.t89_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function findByPointer(_this__u8e3s4, $this, source, refContent, $completion) {
    var tmp = new $findByPointerCOROUTINE$45($this, _this__u8e3s4, source, refContent, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function ScopedReferenceResolver$_init_$lambda_p6sh3e(it) {
    return false;
  }
  function ScopedReferenceResolver$resolve$$inlined$suspendingQuery$1(this$0, $source, $refContent) {
    this.y88_1 = this$0;
    this.z88_1 = $source;
    this.a89_1 = $refContent;
  }
  protoOf(ScopedReferenceResolver$resolve$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$46(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopedReferenceResolver$resolve$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopedReferenceResolver$find$$inlined$suspendingQuery$1(this$0, $source, $refContent) {
    this.u89_1 = this$0;
    this.v89_1 = $source;
    this.w89_1 = $refContent;
  }
  protoOf(ScopedReferenceResolver$find$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$47(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopedReferenceResolver$find$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function $findByPointerCOROUTINE$45(_this__u8e3s4, _this__u8e3s4_0, source, refContent, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f8a_1 = _this__u8e3s4;
    this.g8a_1 = _this__u8e3s4_0;
    this.h8a_1 = source;
    this.i8a_1 = refContent;
  }
  protoOf($findByPointerCOROUTINE$45).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.j8a_1 = this.f8a_1.d89_1.a6m(this.h8a_1, this.i8a_1);
            if (this.j8a_1 == null) {
              this.k8a_1 = null;
              this.y9_1 = 3;
              continue $sm;
            } else {
              var tmp_0 = this;
              tmp_0.l8a_1 = this.j8a_1;
              this.m8a_1 = this.l8a_1;
              var tmp_1 = this;
              tmp_1.n8a_1 = this.m8a_1;
              this.o8a_1 = this.n8a_1;
              this.y9_1 = 1;
              suspendResult = this.f8a_1.e84(this.g8a_1, this.h8a_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.p8a_1 = suspendResult;
            this.q8a_1 = this.p8a_1.h75(this.o8a_1);
            this.y9_1 = 2;
            suspendResult = this.g8a_1.m51(this.q8a_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.k8a_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.k8a_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ScopedReferenceResolver(refTag, scopeConfig, finder, skipValidationPredicate) {
    var tmp;
    if (skipValidationPredicate === VOID) {
      tmp = ScopedReferenceResolver$_init_$lambda_p6sh3e;
    } else {
      tmp = skipValidationPredicate;
    }
    skipValidationPredicate = tmp;
    AbstractScopedReferenceResolver.call(this, refTag, scopeConfig);
    this.d89_1 = finder;
    this.e89_1 = skipValidationPredicate;
  }
  protoOf(ScopedReferenceResolver).a6u = function (source, refContent) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopedReferenceResolver$resolve$$inlined$suspendingQuery$1(this, source, refContent);
  };
  protoOf(ScopedReferenceResolver).b6u = function (source, refContent) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopedReferenceResolver$find$$inlined$suspendingQuery$1(this, source, refContent);
  };
  function $runSuspendCOROUTINE$48(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z8a_1 = _this__u8e3s4;
    this.a8b_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$48).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.b8b_1 = this.a8b_1;
            this.c8b_1 = this.b8b_1;
            var tmp_1 = this;
            tmp_1.d8b_1 = this.c8b_1;
            this.y9_1 = 1;
            suspendResult = this.c8b_1.m51(this.z8a_1.e8b_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            this.d8b_1;
            return tmp2.z74_1;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ScopedReferenceTargetPresentationProvider$getPresentation$$inlined$flatMap$1($this) {
    this.e8b_1 = $this;
  }
  protoOf(ScopedReferenceTargetPresentationProvider$getPresentation$$inlined$flatMap$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$48(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ScopedReferenceTargetPresentationProvider$getPresentation$$inlined$flatMap$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopedReferenceTargetPresentationProvider(scopeConfig) {
    this.f8b_1 = scopeConfig;
  }
  protoOf(ScopedReferenceTargetPresentationProvider).o6u = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.flatMap' call
    var this_0 = this.f8b_1.x7d(target);
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopedReferenceTargetPresentationProvider$getPresentation$$inlined$flatMap$1(this_0);
  };
  function scoped_1(_this__u8e3s4, tags) {
    var scopeConfig = ScopeConfigService_instance.e2o(_this__u8e3s4);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tags.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.scopes.resolve.scoped.<anonymous>' call
      scopeReferenceTargetPresentation(_this__u8e3s4, element, scopeConfig);
    }
  }
  function scopeReferenceTargetPresentation(_this__u8e3s4, tag, scopeConfig) {
    _this__u8e3s4.y6x(tag, new ScopedReferenceTargetPresentationProvider(scopeConfig));
  }
  function ScopedReferenceTargetsSupplier$referenceContents$$inlined$suspendingQuery$1(this$0, $target) {
    this.g8b_1 = this$0;
    this.h8b_1 = $target;
  }
  protoOf(ScopedReferenceTargetsSupplier$referenceContents$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.ocelot.langDef.scopes.resolve.ScopedReferenceTargetsSupplier.referenceContents.<anonymous>' call
    return ReferenceContentFactories_getInstance().y6t(this.g8b_1.j85_1.m6p_1).z6t(this.h8b_1);
  };
  protoOf(ScopedReferenceTargetsSupplier$referenceContents$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ScopedReferenceTargetsSupplier(refTag, scopeConfig) {
    AbstractScopedReferenceTargetsSupplier.call(this, refTag, scopeConfig);
  }
  protoOf(ScopedReferenceTargetsSupplier).l85 = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ScopedReferenceTargetsSupplier$referenceContents$$inlined$suspendingQuery$1(this, target);
  };
  function scoped_2(_this__u8e3s4, tags) {
    var scopeConfig = ScopeConfigService_instance.e2o(_this__u8e3s4);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tags.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.scopes.resolve.scoped.<anonymous>' call
      scopedReferenceTargetSupplier(_this__u8e3s4, element, scopeConfig);
    }
  }
  function scopedReferenceTargetSupplier(_this__u8e3s4, tag, scopeConfig) {
    _this__u8e3s4.h6y(tag, new ScopedReferenceTargetsSupplier(tag, scopeConfig));
  }
  function TargetInfoStub() {
  }
  function AbsentScopeOwner() {
  }
  var AbsentScopeOwner_instance;
  function AbsentScopeOwner_getInstance() {
    return AbsentScopeOwner_instance;
  }
  function ScopeContent(specification, elements) {
    elements = elements === VOID ? null : elements;
    this.k8b_1 = specification;
    this.l8b_1 = elements;
  }
  protoOf(ScopeContent).toString = function () {
    return 'ScopeContent(specification=' + this.k8b_1.toString() + ', elements=' + toString_0(this.l8b_1) + ')';
  };
  protoOf(ScopeContent).hashCode = function () {
    var result = this.k8b_1.hashCode();
    result = imul(result, 31) + (this.l8b_1 == null ? 0 : hashCode(this.l8b_1)) | 0;
    return result;
  };
  protoOf(ScopeContent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScopeContent))
      return false;
    var tmp0_other_with_cast = other instanceof ScopeContent ? other : THROW_CCE();
    if (!this.k8b_1.equals(tmp0_other_with_cast.k8b_1))
      return false;
    if (!equals(this.l8b_1, tmp0_other_with_cast.l8b_1))
      return false;
    return true;
  };
  function Default_2(name) {
    ScopeId.call(this);
    this.n8b_1 = name;
  }
  protoOf(Default_2).toString = function () {
    return 'Default/' + this.n8b_1;
  };
  protoOf(Default_2).hashCode = function () {
    return getStringHashCode(this.n8b_1);
  };
  protoOf(Default_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Default_2))
      return false;
    var tmp0_other_with_cast = other instanceof Default_2 ? other : THROW_CCE();
    if (!(this.n8b_1 === tmp0_other_with_cast.n8b_1))
      return false;
    return true;
  };
  function Exported(provider, name) {
    ScopeId.call(this);
    this.p8b_1 = provider;
    this.q8b_1 = name;
  }
  protoOf(Exported).toString = function () {
    return 'Exported/' + this.p8b_1.toString() + '/' + this.q8b_1;
  };
  protoOf(Exported).hashCode = function () {
    var result = this.p8b_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.q8b_1) | 0;
    return result;
  };
  protoOf(Exported).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Exported))
      return false;
    var tmp0_other_with_cast = other instanceof Exported ? other : THROW_CCE();
    if (!this.p8b_1.equals(tmp0_other_with_cast.p8b_1))
      return false;
    if (!(this.q8b_1 === tmp0_other_with_cast.q8b_1))
      return false;
    return true;
  };
  function Lexical_0(provider, name) {
    ScopeId.call(this);
    this.s8b_1 = provider;
    this.t8b_1 = name;
  }
  protoOf(Lexical_0).toString = function () {
    return 'Lexical/' + this.s8b_1.toString() + '/' + this.t8b_1;
  };
  protoOf(Lexical_0).hashCode = function () {
    var result = this.s8b_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.t8b_1) | 0;
    return result;
  };
  protoOf(Lexical_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Lexical_0))
      return false;
    var tmp0_other_with_cast = other instanceof Lexical_0 ? other : THROW_CCE();
    if (!this.s8b_1.equals(tmp0_other_with_cast.s8b_1))
      return false;
    if (!(this.t8b_1 === tmp0_other_with_cast.t8b_1))
      return false;
    return true;
  };
  function Children(provider, role) {
    ScopeId.call(this);
    this.v8b_1 = provider;
    this.w8b_1 = role;
  }
  protoOf(Children).toString = function () {
    return 'Children/' + this.v8b_1.toString() + '/' + this.w8b_1;
  };
  protoOf(Children).hashCode = function () {
    var result = this.v8b_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.w8b_1) | 0;
    return result;
  };
  protoOf(Children).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Children))
      return false;
    var tmp0_other_with_cast = other instanceof Children ? other : THROW_CCE();
    if (!this.v8b_1.equals(tmp0_other_with_cast.v8b_1))
      return false;
    if (!(this.w8b_1 === tmp0_other_with_cast.w8b_1))
      return false;
    return true;
  };
  function Collection_0(id) {
    id = id === VOID ? Companion_getInstance_35().c2s() : id;
    ScopeId.call(this);
    this.y8b_1 = id;
  }
  protoOf(Collection_0).toString = function () {
    return 'Collection/' + this.y8b_1;
  };
  protoOf(Collection_0).hashCode = function () {
    return getStringHashCode(this.y8b_1);
  };
  protoOf(Collection_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Collection_0))
      return false;
    var tmp0_other_with_cast = other instanceof Collection_0 ? other : THROW_CCE();
    if (!(this.y8b_1 === tmp0_other_with_cast.y8b_1))
      return false;
    return true;
  };
  function Companion_127() {
  }
  var Companion_instance_127;
  function Companion_getInstance_127() {
    return Companion_instance_127;
  }
  function ScopeId() {
    this.z8b_1 = null;
  }
  function ScopeSpecification(owner, id) {
    this.h7q_1 = owner;
    this.i7q_1 = id;
  }
  protoOf(ScopeSpecification).toString = function () {
    return toString_1(this.h7q_1) + '/' + toString_1(this.i7q_1);
  };
  protoOf(ScopeSpecification).hashCode = function () {
    var result = hashCode(this.h7q_1);
    result = imul(result, 31) + hashCode(this.i7q_1) | 0;
    return result;
  };
  protoOf(ScopeSpecification).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ScopeSpecification))
      return false;
    var tmp0_other_with_cast = other instanceof ScopeSpecification ? other : THROW_CCE();
    if (!equals(this.h7q_1, tmp0_other_with_cast.h7q_1))
      return false;
    if (!equals(this.i7q_1, tmp0_other_with_cast.i7q_1))
      return false;
    return true;
  };
  function Companion_128() {
    Companion_instance_128 = this;
    this.a8c_1 = new ScopeTree(emptyList());
  }
  var Companion_instance_128;
  function Companion_getInstance_128() {
    if (Companion_instance_128 == null)
      new Companion_128();
    return Companion_instance_128;
  }
  function ScopeTree$toString$lambda(it) {
    return it.k8b_1.toString();
  }
  function ScopeTree(contents) {
    Companion_getInstance_128();
    this.b8c_1 = contents;
  }
  protoOf(ScopeTree).toString = function () {
    return joinToString_0(this.b8c_1, VOID, '[', ']', VOID, VOID, ScopeTree$toString$lambda);
  };
  function findUsages(_this__u8e3s4, body) {
    _this__u8e3s4.l2p(FindUsagesAspect_instance, new FindUsagesDefinition(body));
  }
  function FindUsagesAspect$createConfigurationService$lambda($definitions) {
    return function (services) {
      var conceptRegistry = ensureNotNull(services.h2o(ConceptRegistryService_instance));
      var builder = new FindUsagesConfigBuilderImpl(conceptRegistry);
      var _iterator__ex2g4s = $definitions.k();
      while (_iterator__ex2g4s.l()) {
        var definition = _iterator__ex2g4s.m();
        definition.c8c_1(builder);
      }
      return builder.k2p();
    };
  }
  function FindUsagesAspect() {
  }
  protoOf(FindUsagesAspect).h8c = function (definitions) {
    var tmp = Companion_instance_33;
    var tmp_0 = [FindUsagesConfigService_instance];
    return tmp.m2o(tmp_0, VOID, FindUsagesAspect$createConfigurationService$lambda(definitions));
  };
  protoOf(FindUsagesAspect).i2p = function (definitions) {
    return this.h8c(definitions);
  };
  var FindUsagesAspect_instance;
  function FindUsagesAspect_getInstance() {
    return FindUsagesAspect_instance;
  }
  function FindUsagesDefinition(body) {
    this.c8c_1 = body;
  }
  function FindUsagesConfigService() {
  }
  var FindUsagesConfigService_instance;
  function FindUsagesConfigService_getInstance() {
    return FindUsagesConfigService_instance;
  }
  function usageKinds(_this__u8e3s4, kinds) {
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = kinds.length;
    while (inductionVariable < last) {
      var element = kinds[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'jetbrains.ocelot.langDef.usages.usageKinds.<anonymous>' call
      _this__u8e3s4.i8c(element);
    }
  }
  function FindUsagesData() {
  }
  function get_targetConcept(_this__u8e3s4) {
    return _this__u8e3s4.l8c().k8c_1.i6o_1;
  }
  function ProperUsage(usage) {
    FindUsagesData.call(this);
    this.m8c_1 = usage;
  }
  function DontKnow() {
    DontKnow_instance = this;
    FindUsagesData.call(this);
  }
  var DontKnow_instance;
  function DontKnow_getInstance() {
    if (DontKnow_instance == null)
      new DontKnow();
    return DontKnow_instance;
  }
  function ReferenceContext(sourceNode, link) {
    this.j8c_1 = sourceNode;
    this.k8c_1 = link;
  }
  function implClass_1($this, conceptClass) {
    var descriptor = $this.d8c_1.z6o(conceptClass);
    return ensureNotNull(descriptor.j6q());
  }
  function FindUsagesConfigBuilderImpl$lambda(node, _unused_var__etf5q3) {
    return defaultPresentation(node);
  }
  function FindUsagesConfigBuilderImpl$build$1(this$0) {
    this.n8c_1 = this$0;
  }
  protoOf(FindUsagesConfigBuilderImpl$build$1).o8c = function (id) {
    // Inline function 'kotlin.check' call
    if (!this.n8c_1.f8c_1.u2().s(id)) {
      // Inline function 'jetbrains.ocelot.langDef.usages.<no name provided>.getUsageKind.<anonymous>' call
      var message = 'Usage kind ' + id + ' is not registered';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return ensureNotNull(this.n8c_1.f8c_1.y2(id));
  };
  protoOf(FindUsagesConfigBuilderImpl$build$1).p8c = function (usage) {
    // Inline function 'kotlin.check' call
    if (!this.n8c_1.g8c_1.u2().s(usage.q8c_1)) {
      // Inline function 'jetbrains.ocelot.langDef.usages.<no name provided>.getPresentation.<anonymous>' call
      var message = 'Presentation is not defined for usage kind ' + toString_1(usage.q8c_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp = ensureNotNull(this.n8c_1.g8c_1.y2(usage.q8c_1));
    var presentation = typeof tmp === 'function' ? tmp : THROW_CCE();
    return presentation(usage.r8c_1, usage.s8c_1);
  };
  function FindUsagesConfigBuilderImpl(conceptRegistry) {
    this.d8c_1 = conceptRegistry;
    this.e8c_1 = HashMap_init_$Create$();
    this.f8c_1 = HashMap_init_$Create$();
    this.g8c_1 = HashMap_init_$Create$();
    var tmp0 = this.f8c_1;
    var tmp1 = DefaultUsageKind_getInstance().t8c_1;
    // Inline function 'kotlin.collections.set' call
    var value = DefaultUsageKind_getInstance();
    tmp0.r2(tmp1, value);
    var tmp3 = this.g8c_1;
    var tmp4 = DefaultUsageKind_getInstance();
    // Inline function 'kotlin.collections.set' call
    var value_0 = FindUsagesConfigBuilderImpl$lambda;
    tmp3.r2(tmp4, value_0);
  }
  protoOf(FindUsagesConfigBuilderImpl).i8c = function (kind) {
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = kind.t8c_1;
    // Inline function 'kotlin.require' call
    if (!(charSequenceLength(this_0) > 0)) {
      // Inline function 'jetbrains.ocelot.langDef.usages.FindUsagesConfigBuilderImpl.usageKind.<anonymous>' call
      var message = 'Usage kind must not have empty id';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!!this.f8c_1.w2(kind.t8c_1)) {
      // Inline function 'jetbrains.ocelot.langDef.usages.FindUsagesConfigBuilderImpl.usageKind.<anonymous>' call
      var message_0 = 'Usage kind with id ' + kind.t8c_1 + ' is already registered';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    var tmp3 = this.f8c_1;
    // Inline function 'kotlin.collections.set' call
    var key = kind.t8c_1;
    tmp3.r2(key, kind);
  };
  protoOf(FindUsagesConfigBuilderImpl).u8c = function (concept, body) {
    var tmp0 = this.e8c_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var key = implClass_1(this, concept);
    var value = tmp0.y2(key);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.langDef.usages.FindUsagesConfigBuilderImpl.ruleFor.<anonymous>' call
      var answer = ArrayList_init_$Create$();
      tmp0.r2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.e(body);
  };
  protoOf(FindUsagesConfigBuilderImpl).v8c = function (concept, body) {
    return this.u8c(concept, body);
  };
  protoOf(FindUsagesConfigBuilderImpl).w8c = function (kind, body) {
    // Inline function 'kotlin.check' call
    if (!!this.g8c_1.w2(kind)) {
      // Inline function 'jetbrains.ocelot.langDef.usages.FindUsagesConfigBuilderImpl.presentationFor.<anonymous>' call
      var message = 'Presentation for usage kind ' + toString_1(kind) + ' is already registered';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp1 = this.g8c_1;
    // Inline function 'kotlin.collections.set' call
    var value = typeof body === 'function' ? body : THROW_CCE();
    tmp1.r2(kind, value);
  };
  protoOf(FindUsagesConfigBuilderImpl).x8c = function (kind, body) {
    return this.w8c(kind, body);
  };
  protoOf(FindUsagesConfigBuilderImpl).k2p = function () {
    return new FindUsagesConfigBuilderImpl$build$1(this);
  };
  function defaultPresentation(node) {
    return new DefaultUsagePresentation(node);
  }
  function UsageKind(id) {
    this.t8c_1 = id;
  }
  function UsagePresentationData() {
  }
  function Usage(kind, node, reference) {
    this.q8c_1 = kind;
    this.r8c_1 = node;
    this.s8c_1 = reference;
  }
  function DefaultUsageKind() {
    DefaultUsageKind_instance = this;
    UsageKind.call(this, 'default');
  }
  var DefaultUsageKind_instance;
  function DefaultUsageKind_getInstance() {
    if (DefaultUsageKind_instance == null)
      new DefaultUsageKind();
    return DefaultUsageKind_instance;
  }
  function DefaultUsagePresentation(node) {
    UsagePresentationData.call(this);
    this.z8c_1 = node;
  }
  function ByteReadChannel(content) {
    return ByteReadChannel_0(content, 0, content.length);
  }
  function _get_isCancelled__nhbn6y($this) {
    var tmp0_safe_receiver = $this.g8d_1.kotlinx$atomicfu$value;
    return !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o8d_1) == null);
  }
  function flushImpl($this) {
    if ($this.h8d_1.np()) {
      $this.l8d_1.q8d();
      return false;
    }
    flushWrittenBytes($this);
    $this.l8d_1.q8d();
    return true;
  }
  function flushWrittenBytes($this) {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    $this.m8d_1;
    // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.flushWrittenBytes.<anonymous>' call
    var size = $this.h8d_1.n();
    var buffer = ensureNotNull($this.h8d_1.h8e());
    $this.n8d_1.i8e(buffer);
    $this.e8d_1.atomicfu$addAndGet(size);
  }
  function ensureNotClosed($this) {
    if ($this.k8e()) {
      var tmp0_elvis_lhs = $this.j8e();
      throw tmp0_elvis_lhs == null ? new ClosedWriteChannelException('Channel ' + toString_1($this) + ' is already closed') : tmp0_elvis_lhs;
    }
  }
  function ensureNotFailed($this) {
    var tmp0_safe_receiver = $this.j8e();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp0_safe_receiver;
    }
  }
  function ensureNotFailed_0($this, closeable) {
    var tmp0_safe_receiver = $this.j8e();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      closeable.vz();
      throw tmp0_safe_receiver;
    }
  }
  function readRemainingSuspend($this, builder, limit, $completion) {
    var tmp = new $readRemainingSuspendCOROUTINE$27($this, builder, limit, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function addBytesRead($this, count) {
    // Inline function 'kotlin.require' call
    if (!(count >= 0)) {
      // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.addBytesRead.<anonymous>' call
      var message = "Can't read negative amount of bytes: " + count;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlinx.atomicfu.AtomicInt.minusAssign' call
    $this.f8d_1.atomicfu$getAndAdd(-count | 0);
    $this.c8d_1.atomicfu$addAndGet$long(toLong(count));
    // Inline function 'kotlinx.atomicfu.AtomicInt.minusAssign' call
    $this.e8d_1.atomicfu$getAndAdd(-count | 0);
    // Inline function 'kotlin.check' call
    if (!($this.f8d_1.kotlinx$atomicfu$value >= 0)) {
      // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.addBytesRead.<anonymous>' call
      var message_0 = 'Readable bytes count is negative: ' + $this.x8e() + ', ' + count + ' in ' + toString_1($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!($this.x8e() >= 0)) {
      // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.addBytesRead.<anonymous>' call
      var message_1 = 'Readable bytes count is negative: ' + $this.x8e() + ', ' + count + ' in ' + toString_1($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
  }
  function addBytesWritten($this, count) {
    // Inline function 'kotlin.require' call
    if (!(count >= 0)) {
      // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.addBytesWritten.<anonymous>' call
      var message = "Can't write negative amount of bytes: " + count;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlinx.atomicfu.AtomicInt.plusAssign' call
    $this.f8d_1.atomicfu$getAndAdd(count);
    $this.d8d_1.atomicfu$addAndGet$long(toLong(count));
    // Inline function 'kotlin.check' call
    if (!($this.f8d_1.kotlinx$atomicfu$value >= 0)) {
      // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.addBytesWritten.<anonymous>' call
      var message_0 = 'Readable bytes count is negative: ' + $this.f8d_1.kotlinx$atomicfu$value + ', ' + count + ' in ' + toString_1($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  function ByteChannelSequentialBase$awaitAtLeastNBytesAvailableForWrite$lambda(this$0, $count) {
    return function () {
      return this$0.y8e() < $count && !this$0.k8e();
    };
  }
  function ByteChannelSequentialBase$awaitAtLeastNBytesAvailableForRead$lambda(this$0, $count) {
    return function () {
      return this$0.x8e() < $count && !this$0.z8e();
    };
  }
  function $awaitAtLeastNBytesAvailableForWriteCOROUTINE$0(_this__u8e3s4, count, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i8f_1 = _this__u8e3s4;
    this.j8f_1 = count;
  }
  protoOf($awaitAtLeastNBytesAvailableForWriteCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.i8f_1.y8e() < this.j8f_1 && !this.i8f_1.k8e())) {
              this.y9_1 = 5;
              continue $sm;
            }

            if (!flushImpl(this.i8f_1)) {
              this.y9_1 = 2;
              suspendResult = this.i8f_1.l8d_1.k8f(ByteChannelSequentialBase$awaitAtLeastNBytesAvailableForWrite$lambda(this.i8f_1, this.j8f_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.y9_1 = 1;
            continue $sm;
          case 4:
            throw this.ba_1;
          case 5:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $awaitAtLeastNBytesAvailableForReadCOROUTINE$1(_this__u8e3s4, count, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t8f_1 = _this__u8e3s4;
    this.u8f_1 = count;
  }
  protoOf($awaitAtLeastNBytesAvailableForReadCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.t8f_1.x8e() < this.u8f_1 && !this.t8f_1.z8e())) {
              this.y9_1 = 4;
              continue $sm;
            }

            this.y9_1 = 2;
            suspendResult = this.t8f_1.l8d_1.k8f(ByteChannelSequentialBase$awaitAtLeastNBytesAvailableForRead$lambda(this.t8f_1, this.u8f_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.y9_1 = 1;
            continue $sm;
          case 3:
            throw this.ba_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $writeFullyCOROUTINE$9(_this__u8e3s4, src, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d8g_1 = _this__u8e3s4;
    this.e8g_1 = src;
  }
  protoOf($writeFullyCOROUTINE$9).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.d8g_1.f8g(1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = this.e8g_1;
            var count = this_0.i8g_1 - this_0.h8g_1 | 0;
            writeFully_2(this.d8g_1.h8d_1, this.e8g_1);
            this.d8g_1.m8g(count);
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $writeFullyCOROUTINE$10(_this__u8e3s4, src, offset, length, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v8g_1 = _this__u8e3s4;
    this.w8g_1 = src;
    this.x8g_1 = offset;
    this.y8g_1 = length;
  }
  protoOf($writeFullyCOROUTINE$10).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.z8g_1 = this.x8g_1;
            this.a8h_1 = this.x8g_1 + this.y8g_1 | 0;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.z8g_1 < this.a8h_1)) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.y9_1 = 2;
            suspendResult = this.v8g_1.f8g(1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0 = this.v8g_1.y8e();
            var b = this.a8h_1 - this.z8g_1 | 0;
            var bytesCount = Math.min(tmp0, b);
            writeFully_3(this.v8g_1.h8d_1, this.w8g_1, this.z8g_1, bytesCount);
            this.z8g_1 = this.z8g_1 + bytesCount | 0;
            this.v8g_1.m8g(bytesCount);
            this.y9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $readRemainingCOROUTINE$26(_this__u8e3s4, limit, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j8h_1 = _this__u8e3s4;
    this.k8h_1 = limit;
  }
  protoOf($readRemainingCOROUTINE$26).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            ensureNotFailed(this.j8h_1);
            this.l8h_1 = new BytePacketBuilder();
            var tmp_0 = this;
            var tmp0 = this.k8h_1;
            var b = this.j8h_1.i8d_1.w8h();
            tmp_0.m8h_1 = tmp0.d1(b) <= 0 ? tmp0 : b;
            this.l8h_1.x8h(this.j8h_1.i8d_1, this.m8h_1);
            this.j8h_1.y8h(this.m8h_1.z3());
            var tmp_1 = this;
            var tmp2 = this.k8h_1;
            var other = this.l8h_1.n();
            tmp_1.n8h_1 = tmp2.j3(toLong(other));
            if (this.n8h_1.equals(new Long(0, 0)) || this.j8h_1.z8e()) {
              var tmp_2 = this;
              ensureNotFailed_0(this.j8h_1, this.l8h_1);
              tmp_2.o8h_1 = this.l8h_1.k2p();
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = readRemainingSuspend(this.j8h_1, this.l8h_1, this.k8h_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.o8h_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            return this.o8h_1;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $readRemainingSuspendCOROUTINE$27(_this__u8e3s4, builder, limit, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t8e_1 = _this__u8e3s4;
    this.u8e_1 = builder;
    this.v8e_1 = limit;
  }
  protoOf($readRemainingSuspendCOROUTINE$27).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!(toLong(this.u8e_1.n()).d1(this.v8e_1) < 0)) {
              this.y9_1 = 4;
              continue $sm;
            }

            var tmp_0 = this;
            var tmp0 = this.v8e_1;
            var other = this.u8e_1.n();
            var tmp2 = tmp0.j3(toLong(other));
            var b = this.t8e_1.i8d_1.w8h();
            tmp_0.w8e_1 = tmp2.d1(b) <= 0 ? tmp2 : b;
            this.u8e_1.x8h(this.t8e_1.i8d_1, this.w8e_1);
            this.t8e_1.y8h(this.w8e_1.z3());
            ensureNotFailed_0(this.t8e_1, this.u8e_1);
            if (this.t8e_1.z8e() || this.u8e_1.n() === this.v8e_1.z3()) {
              this.y9_1 = 4;
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.y9_1 = 3;
            suspendResult = this.t8e_1.z8h(1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.y9_1 = 1;
            continue $sm;
          case 4:
            ensureNotFailed_0(this.t8e_1, this.u8e_1);
            return this.u8e_1.k2p();
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $readAvailableCOROUTINE$30(_this__u8e3s4, dst, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i8i_1 = _this__u8e3s4;
    this.j8i_1 = dst;
  }
  protoOf($readAvailableCOROUTINE$30).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp0_safe_receiver = this.i8i_1.j8e();
            if (tmp0_safe_receiver == null)
              null;
            else {
              throw tmp0_safe_receiver;
            }

            if (this.i8i_1.k8e() && this.i8i_1.x8e() === 0)
              return -1;
            var this_0 = this.j8i_1;
            if ((this_0.k8g_1 - this_0.i8g_1 | 0) === 0)
              return 0;
            if (this.i8i_1.x8e() === 0) {
              this.y9_1 = 1;
              suspendResult = this.i8i_1.z8h(1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 1:
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.i8i_1.i8d_1.l8i()) {
              this.i8i_1.k8i();
            }

            var this_1 = this.j8i_1;
            var tmp4 = toLong(this_1.k8g_1 - this_1.i8g_1 | 0);
            var b = this.i8i_1.i8d_1.w8h();
            var size = (tmp4.d1(b) <= 0 ? tmp4 : b).z3();
            readFully_2(this.i8i_1.i8d_1, this.j8i_1, size);
            this.i8i_1.y8h(size);
            return size;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $readAvailableCOROUTINE$33(_this__u8e3s4, dst, offset, length, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u8i_1 = _this__u8e3s4;
    this.v8i_1 = dst;
    this.w8i_1 = offset;
    this.x8i_1 = length;
  }
  protoOf($readAvailableCOROUTINE$33).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp0_safe_receiver = this.u8i_1.j8e();
            if (tmp0_safe_receiver == null)
              null;
            else {
              throw tmp0_safe_receiver;
            }

            if (this.u8i_1.k8e() && this.u8i_1.x8e() === 0)
              return -1;
            if (this.x8i_1 === 0)
              return 0;
            if (this.u8i_1.x8e() === 0) {
              this.y9_1 = 1;
              suspendResult = this.u8i_1.z8h(1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 1:
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.u8i_1.i8d_1.l8i()) {
              this.u8i_1.k8i();
            }

            var tmp2 = toLong(this.x8i_1);
            var b = this.u8i_1.i8d_1.w8h();
            var size = (tmp2.d1(b) <= 0 ? tmp2 : b).z3();
            readFully_1(this.u8i_1.i8d_1, this.v8i_1, this.w8i_1, size);
            this.u8i_1.y8h(size);
            return size;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $awaitInternalAtLeast1COROUTINE$38(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g8j_1 = _this__u8e3s4;
  }
  protoOf($awaitInternalAtLeast1COROUTINE$38).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            if (!this.g8j_1.i8d_1.i8j()) {
              var tmp_0 = this;
              tmp_0.h8j_1 = true;
              this.y9_1 = 3;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.g8j_1.z8h(1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.h8j_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 2:
            throw this.ba_1;
          case 3:
            return this.h8j_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $awaitSuspendCOROUTINE$39(_this__u8e3s4, atLeast, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r8j_1 = _this__u8e3s4;
    this.s8j_1 = atLeast;
  }
  protoOf($awaitSuspendCOROUTINE$39).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            if (!(this.s8j_1 >= 0)) {
              var message = 'Failed requirement.';
              throw IllegalArgumentException_init_$Create$_0(toString_1(message));
            }

            this.y9_1 = 1;
            suspendResult = this.r8j_1.t8j(this.s8j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.r8j_1.k8i();
            var tmp0_safe_receiver = this.r8j_1.j8e();
            if (tmp0_safe_receiver == null)
              null;
            else {
              throw tmp0_safe_receiver;
            }

            return !this.r8j_1.z8e() && this.r8j_1.x8e() >= this.s8j_1;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ByteChannelSequentialBase(initial, autoFlush, pool) {
    pool = pool === VOID ? Companion_getInstance_132().y8j() : pool;
    this.a8d_1 = autoFlush;
    this.b8d_1 = atomic$ref$1(Companion_getInstance_132().v8j_1);
    this.c8d_1 = atomic$long$1(new Long(0, 0));
    this.d8d_1 = atomic$long$1(new Long(0, 0));
    this.e8d_1 = atomic$int$1(0);
    this.f8d_1 = atomic$int$1(0);
    this.g8d_1 = atomic$ref$1(null);
    this.h8d_1 = new BytePacketBuilder(pool);
    this.i8d_1 = ByteReadPacket_init_$Create$(initial, pool);
    this.j8d_1 = atomic$int$1(0);
    this.k8d_1 = atomic$ref$1(Companion_getInstance_132().v8j_1);
    this.l8d_1 = new AwaitingSlot();
    this.m8d_1 = new Object();
    this.n8d_1 = new BytePacketBuilder();
    var count = remainingAll(initial).z3();
    this.m8g(count);
    this.e8d_1.atomicfu$addAndGet(count);
  }
  protoOf(ByteChannelSequentialBase).z8j = function () {
    return this.a8d_1;
  };
  protoOf(ByteChannelSequentialBase).k8e = function () {
    return !(this.g8d_1.kotlinx$atomicfu$value == null);
  };
  protoOf(ByteChannelSequentialBase).x8e = function () {
    return this.e8d_1.kotlinx$atomicfu$value;
  };
  protoOf(ByteChannelSequentialBase).y8e = function () {
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = 4088 - this.f8d_1.kotlinx$atomicfu$value | 0;
    return Math.max(0, b);
  };
  protoOf(ByteChannelSequentialBase).z8e = function () {
    return _get_isCancelled__nhbn6y(this) || (this.k8e() && this.f8d_1.kotlinx$atomicfu$value === 0);
  };
  protoOf(ByteChannelSequentialBase).j8e = function () {
    var tmp0_safe_receiver = this.g8d_1.kotlinx$atomicfu$value;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o8d_1;
  };
  protoOf(ByteChannelSequentialBase).f8g = function (count, $completion) {
    var tmp = new $awaitAtLeastNBytesAvailableForWriteCOROUTINE$0(this, count, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ByteChannelSequentialBase).t8j = function (count, $completion) {
    var tmp = new $awaitAtLeastNBytesAvailableForReadCOROUTINE$1(this, count, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ByteChannelSequentialBase).v9 = function () {
    flushImpl(this);
  };
  protoOf(ByteChannelSequentialBase).k8i = function () {
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.m8d_1;
    // Inline function 'io.ktor.utils.io.ByteChannelSequentialBase.prepareFlushedBytes.<anonymous>' call
    unsafeAppend(this.i8d_1, this.n8d_1);
  };
  protoOf(ByteChannelSequentialBase).a8k = function (src, $completion) {
    var tmp = new $writeFullyCOROUTINE$9(this, src, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ByteChannelSequentialBase).b8k = function (src, offset, length, $completion) {
    var tmp = new $writeFullyCOROUTINE$10(this, src, offset, length, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ByteChannelSequentialBase).y8h = function (count) {
    addBytesRead(this, count);
    this.l8d_1.q8d();
  };
  protoOf(ByteChannelSequentialBase).c8k = function (limit, $completion) {
    var tmp = new $readRemainingCOROUTINE$26(this, limit, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ByteChannelSequentialBase).e8k = function (dst, $completion) {
    return this.f8k(dst instanceof Buffer ? dst : THROW_CCE(), $completion);
  };
  protoOf(ByteChannelSequentialBase).f8k = function (dst, $completion) {
    var tmp = new $readAvailableCOROUTINE$30(this, dst, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ByteChannelSequentialBase).g8k = function (dst, offset, length, $completion) {
    var tmp = new $readAvailableCOROUTINE$33(this, dst, offset, length, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ByteChannelSequentialBase).h8k = function ($completion) {
    var tmp = new $awaitInternalAtLeast1COROUTINE$38(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ByteChannelSequentialBase).z8h = function (atLeast, $completion) {
    var tmp = new $awaitSuspendCOROUTINE$39(this, atLeast, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ByteChannelSequentialBase).my = function (cause) {
    if (!(this.j8e() == null) || this.k8e()) {
      return false;
    }
    return this.g1c(cause == null ? CancellationException_init_$Create$_0('Channel cancelled') : cause);
  };
  protoOf(ByteChannelSequentialBase).g1c = function (cause) {
    var closeElement = cause == null ? get_CLOSED_SUCCESS() : new CloseElement(cause);
    if (!this.g8d_1.atomicfu$compareAndSet(null, closeElement))
      return false;
    if (!(cause == null)) {
      this.i8d_1.vz();
      this.h8d_1.vz();
      this.n8d_1.vz();
    } else {
      this.v9();
      this.h8d_1.vz();
    }
    this.l8d_1.i8k(cause);
    return true;
  };
  protoOf(ByteChannelSequentialBase).j8k = function (dst, limit) {
    var size = this.i8d_1.w8h();
    var tmp;
    if (size.d1(limit) <= 0) {
      dst.h8d_1.k8k(this.i8d_1);
      dst.m8g(size.z3());
      this.y8h(size.z3());
      tmp = size;
    } else {
      tmp = new Long(0, 0);
    }
    return tmp;
  };
  protoOf(ByteChannelSequentialBase).m8g = function (count) {
    addBytesWritten(this, count);
    if (this.k8e()) {
      this.h8d_1.vz();
      ensureNotClosed(this);
    }
    if (this.z8j() || this.y8e() === 0) {
      this.v9();
    }
  };
  function cancel_3(_this__u8e3s4) {
    return _this__u8e3s4.my(null);
  }
  function readAvailable(_this__u8e3s4, dst, $completion) {
    return _this__u8e3s4.g8k(dst, 0, dst.length, $completion);
  }
  function close_0(_this__u8e3s4) {
    return _this__u8e3s4.g1c(null);
  }
  function ClosedWriteChannelException(message) {
    CancellationException_init_$Init$_0(message, this);
    captureStack(this, ClosedWriteChannelException);
  }
  function writeFully(_this__u8e3s4, src, $completion) {
    return _this__u8e3s4.b8k(src, 0, src.length, $completion);
  }
  function get_CLOSED_SUCCESS() {
    _init_properties_CloseElement_kt__5e72ik();
    return CLOSED_SUCCESS;
  }
  var CLOSED_SUCCESS;
  function CloseElement(cause) {
    this.o8d_1 = cause;
  }
  var properties_initialized_CloseElement_kt_clkism;
  function _init_properties_CloseElement_kt__5e72ik() {
    if (!properties_initialized_CloseElement_kt_clkism) {
      properties_initialized_CloseElement_kt_clkism = true;
      CLOSED_SUCCESS = new CloseElement(null);
    }
  }
  function writer(_this__u8e3s4, coroutineContext, autoFlush, block) {
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    autoFlush = autoFlush === VOID ? false : autoFlush;
    return launchChannel(_this__u8e3s4, coroutineContext, ByteChannel(autoFlush), true, block);
  }
  function WriterScope() {
  }
  function ChannelJob(delegate, channel) {
    this.m8k_1 = delegate;
    this.n8k_1 = channel;
  }
  protoOf(ChannelJob).y15 = function () {
    return this.n8k_1;
  };
  protoOf(ChannelJob).ft = function () {
    return this.m8k_1.ft();
  };
  protoOf(ChannelJob).au = function () {
    return this.m8k_1.au();
  };
  protoOf(ChannelJob).x = function () {
    return this.m8k_1.x();
  };
  protoOf(ChannelJob).lu = function () {
    return this.m8k_1.lu();
  };
  protoOf(ChannelJob).yt = function () {
    return this.m8k_1.yt();
  };
  protoOf(ChannelJob).wu = function (child) {
    return this.m8k_1.wu(child);
  };
  protoOf(ChannelJob).ou = function (cause) {
    this.m8k_1.ou(cause);
  };
  protoOf(ChannelJob).dj = function (initial, operation) {
    return this.m8k_1.dj(initial, operation);
  };
  protoOf(ChannelJob).la = function (key) {
    return this.m8k_1.la(key);
  };
  protoOf(ChannelJob).eu = function () {
    return this.m8k_1.eu();
  };
  protoOf(ChannelJob).iu = function (onCancelling, invokeImmediately, handler) {
    return this.m8k_1.iu(onCancelling, invokeImmediately, handler);
  };
  protoOf(ChannelJob).hu = function (handler) {
    return this.m8k_1.hu(handler);
  };
  protoOf(ChannelJob).ku = function ($completion) {
    return this.m8k_1.ku($completion);
  };
  protoOf(ChannelJob).cj = function (key) {
    return this.m8k_1.cj(key);
  };
  protoOf(ChannelJob).ej = function (context) {
    return this.m8k_1.ej(context);
  };
  protoOf(ChannelJob).cu = function () {
    return this.m8k_1.cu();
  };
  protoOf(ChannelJob).toString = function () {
    return 'ChannelJob[' + toString_1(this.m8k_1) + ']';
  };
  function launchChannel(_this__u8e3s4, context, channel, attachJob, block) {
    var dispatcher = _this__u8e3s4.et().la(Key_getInstance_0());
    var job = launch(_this__u8e3s4, context, VOID, launchChannel$slambda_0(attachJob, channel, block, dispatcher, null));
    job.hu(launchChannel$lambda(channel));
    return new ChannelJob(job, channel);
  }
  function ChannelScope(delegate, channel) {
    this.o8k_1 = channel;
    this.p8k_1 = delegate;
  }
  protoOf(ChannelScope).y15 = function () {
    return this.o8k_1;
  };
  protoOf(ChannelScope).et = function () {
    return this.p8k_1.et();
  };
  function launchChannel$slambda($attachJob, $channel, $block, $dispatcher, resultContinuation) {
    this.y8k_1 = $attachJob;
    this.z8k_1 = $channel;
    this.a8l_1 = $block;
    this.b8l_1 = $dispatcher;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchChannel$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(launchChannel$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchChannel$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            if (this.y8k_1) {
              this.z8k_1.l8k(ensureNotNull(this.c8l_1.et().la(Key_instance_3)));
            }

            var tmp_0 = this;
            var tmp_1 = new ChannelScope(this.c8l_1, this.z8k_1);
            tmp_0.d8l_1 = isInterface(tmp_1, CoroutineScope) ? tmp_1 : THROW_CCE();
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.a8l_1(this.d8l_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z9_1 = 3;
            this.y9_1 = 4;
            continue $sm;
          case 2:
            this.z9_1 = 3;
            var tmp_2 = this.ba_1;
            if (tmp_2 instanceof Error) {
              var cause = this.ba_1;
              if (!equals(this.b8l_1, Dispatchers_getInstance().q14_1) && !(this.b8l_1 == null)) {
                throw cause;
              }
              this.z8k_1.my(cause);
              this.y9_1 = 4;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 3:
            throw this.ba_1;
          case 4:
            this.z9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(launchChannel$slambda).i1l = function ($this$launch, completion) {
    var i = new launchChannel$slambda(this.y8k_1, this.z8k_1, this.a8l_1, this.b8l_1, completion);
    i.c8l_1 = $this$launch;
    return i;
  };
  function launchChannel$slambda_0($attachJob, $channel, $block, $dispatcher, resultContinuation) {
    var i = new launchChannel$slambda($attachJob, $channel, $block, $dispatcher, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function launchChannel$lambda($channel) {
    return function (cause) {
      $channel.g1c(cause);
      return Unit_instance;
    };
  }
  function unwrapCancellationException(_this__u8e3s4) {
    var exception = _this__u8e3s4;
    $l$loop: while (exception instanceof CancellationException) {
      if (equals(exception, exception.cause)) {
        return _this__u8e3s4;
      }
      var tmp0_elvis_lhs = exception.cause;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return exception;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      exception = tmp;
    }
    return exception;
  }
  function decode(_this__u8e3s4, input, max) {
    max = max === VOID ? 2147483647 : max;
    var tmp0 = toLong(max);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = sizeEstimate(input);
    // Inline function 'kotlin.text.buildString' call
    var capacity = (tmp0.d1(b) <= 0 ? tmp0 : b).z3();
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$(capacity);
    // Inline function 'io.ktor.utils.io.charsets.decode.<anonymous>' call
    decode_0(_this__u8e3s4, input, this_0, max);
    return this_0.toString();
  }
  function encodeToImpl(_this__u8e3s4, destination, input, fromIndex, toIndex) {
    var start = fromIndex;
    if (start >= toIndex)
      return 0;
    var bytesWritten = 0;
    // Inline function 'io.ktor.utils.io.core.writeWhileSize' call
    var tail = prepareWriteHead(destination, 1, null);
    try {
      var size;
      $l$loop: while (true) {
        // Inline function 'io.ktor.utils.io.charsets.encodeToImpl.<anonymous>' call
        var view = tail;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        var before = view.k8g_1 - view.i8g_1 | 0;
        var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, view);
        // Inline function 'kotlin.check' call
        if (!(rc >= 0)) {
          throw IllegalStateException_init_$Create$_0('Check failed.');
        }
        start = start + rc | 0;
        var tmp = bytesWritten;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        bytesWritten = tmp + (before - (view.k8g_1 - view.i8g_1 | 0) | 0) | 0;
        size = start >= toIndex ? 0 : rc === 0 ? 8 : 1;
        if (size <= 0)
          break $l$loop;
        tail = prepareWriteHead(destination, size, tail);
      }
    }finally {
      destination.e8l();
    }
    bytesWritten = bytesWritten + encodeCompleteImpl(_this__u8e3s4, destination) | 0;
    return bytesWritten;
  }
  function sizeEstimate(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ByteReadPacket) {
      tmp = _this__u8e3s4.w8h();
    } else {
      var tmp0 = _this__u8e3s4.w8h();
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = new Long(16, 0);
      tmp = tmp0.d1(b) >= 0 ? tmp0 : b;
    }
    return tmp;
  }
  function encodeCompleteImpl(_this__u8e3s4, dst) {
    var size = 1;
    var bytesWritten = 0;
    // Inline function 'io.ktor.utils.io.core.writeWhile' call
    var tail = prepareWriteHead(dst, 1, null);
    try {
      $l$loop: while (true) {
        // Inline function 'io.ktor.utils.io.charsets.encodeCompleteImpl.<anonymous>' call
        var view = tail;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        var before = view.k8g_1 - view.i8g_1 | 0;
        if (encodeComplete(_this__u8e3s4, view)) {
          size = 0;
        } else {
          size = size + 1 | 0;
        }
        var tmp = bytesWritten;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        bytesWritten = tmp + (before - (view.k8g_1 - view.i8g_1 | 0) | 0) | 0;
        if (!(size > 0))
          break $l$loop;
        tail = prepareWriteHead(dst, 1, tail);
      }
    }finally {
      dst.e8l();
    }
    return bytesWritten;
  }
  function encode(_this__u8e3s4, input, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.buildPacket' call
      // Inline function 'kotlin.contracts.contract' call
      var builder = new BytePacketBuilder();
      try {
        // Inline function 'io.ktor.utils.io.charsets.encode.<anonymous>' call
        encodeToImpl(_this__u8e3s4, builder, input, fromIndex, toIndex);
        tmp$ret$0 = builder.k2p();
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          builder.vz();
          throw t;
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$0;
  }
  function Companion_129() {
    this.f8l_1 = 8;
  }
  protoOf(Companion_129).g8l = function () {
    return Companion_getInstance_132().v8j_1;
  };
  var Companion_instance_129;
  function Companion_getInstance_129() {
    return Companion_instance_129;
  }
  function Buffer(memory) {
    this.g8g_1 = memory;
    this.h8g_1 = 0;
    this.i8g_1 = 0;
    this.j8g_1 = 0;
    var tmp = this;
    // Inline function 'io.ktor.utils.io.bits.Memory.size32' call
    tmp.k8g_1 = this.g8g_1.h8l_1.byteLength;
    var tmp_0 = this;
    // Inline function 'io.ktor.utils.io.bits.Memory.size32' call
    tmp_0.l8g_1 = this.g8g_1.h8l_1.byteLength;
  }
  protoOf(Buffer).i8l = function (count) {
    if (count === 0)
      return Unit_instance;
    var newReadPosition = this.h8g_1 + count | 0;
    if (count < 0 || newReadPosition > this.i8g_1) {
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      var tmp$ret$1 = this.i8g_1 - this.h8g_1 | 0;
      discardFailed(count, tmp$ret$1);
    }
    this.h8g_1 = newReadPosition;
  };
  protoOf(Buffer).j8l = function (count) {
    var newWritePosition = this.i8g_1 + count | 0;
    if (count < 0 || newWritePosition > this.k8g_1) {
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var tmp$ret$0 = this.k8g_1 - this.i8g_1 | 0;
      commitWrittenFailed(count, tmp$ret$0);
    }
    this.i8g_1 = newWritePosition;
  };
  protoOf(Buffer).k8l = function (position) {
    var limit = this.k8g_1;
    if (position < this.i8g_1) {
      var tmp = position - this.i8g_1 | 0;
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var tmp$ret$0 = this.k8g_1 - this.i8g_1 | 0;
      commitWrittenFailed(tmp, tmp$ret$0);
    }
    if (position >= limit) {
      if (position === limit) {
        this.i8g_1 = position;
        return false;
      }
      var tmp_0 = position - this.i8g_1 | 0;
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var tmp$ret$1 = this.k8g_1 - this.i8g_1 | 0;
      commitWrittenFailed(tmp_0, tmp$ret$1);
    }
    this.i8g_1 = position;
    return true;
  };
  protoOf(Buffer).l8l = function (position) {
    if (position < 0 || position > this.i8g_1) {
      var tmp = position - this.h8g_1 | 0;
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      var tmp$ret$0 = this.i8g_1 - this.h8g_1 | 0;
      discardFailed(tmp, tmp$ret$0);
    }
    if (!(this.h8g_1 === position)) {
      this.h8g_1 = position;
    }
  };
  protoOf(Buffer).m8l = function (count) {
    var newReadPosition = this.h8g_1 - count | 0;
    if (newReadPosition < this.j8g_1) {
      rewindFailed(count, this.h8g_1 - this.j8g_1 | 0);
    }
    this.h8g_1 = newReadPosition;
  };
  protoOf(Buffer).n8l = function (startGap) {
    // Inline function 'kotlin.require' call
    if (!(startGap >= 0)) {
      // Inline function 'io.ktor.utils.io.core.Buffer.reserveStartGap.<anonymous>' call
      var message = "startGap shouldn't be negative: " + startGap;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (this.h8g_1 >= startGap) {
      this.j8g_1 = startGap;
      return Unit_instance;
    }
    if (this.h8g_1 === this.i8g_1) {
      if (startGap > this.k8g_1) {
        startGapReservationFailedDueToLimit(this, startGap);
      }
      this.i8g_1 = startGap;
      this.h8g_1 = startGap;
      this.j8g_1 = startGap;
      return Unit_instance;
    }
    startGapReservationFailed(this, startGap);
  };
  protoOf(Buffer).o8l = function (endGap) {
    // Inline function 'kotlin.require' call
    if (!(endGap >= 0)) {
      // Inline function 'io.ktor.utils.io.core.Buffer.reserveEndGap.<anonymous>' call
      var message = "endGap shouldn't be negative: " + endGap;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var newLimit = this.l8g_1 - endGap | 0;
    if (newLimit >= this.i8g_1) {
      this.k8g_1 = newLimit;
      return Unit_instance;
    }
    if (newLimit < 0) {
      endGapReservationFailedDueToCapacity(this, endGap);
    }
    if (newLimit < this.j8g_1) {
      endGapReservationFailedDueToStartGap(this, endGap);
    }
    if (this.h8g_1 === this.i8g_1) {
      this.k8g_1 = newLimit;
      this.h8g_1 = newLimit;
      this.i8g_1 = newLimit;
      return Unit_instance;
    }
    endGapReservationFailedDueToContent(this, endGap);
  };
  protoOf(Buffer).p8l = function () {
    this.j8g_1 = 0;
    this.h8g_1 = 0;
    var capacity = this.l8g_1;
    this.i8g_1 = capacity;
  };
  protoOf(Buffer).q8l = function () {
    this.r8l(this.l8g_1 - this.j8g_1 | 0);
  };
  protoOf(Buffer).r8l = function (limit) {
    var startGap = this.j8g_1;
    this.h8g_1 = startGap;
    this.i8g_1 = startGap;
    this.k8g_1 = limit;
  };
  protoOf(Buffer).s8l = function () {
    this.t8l(0);
    this.u8l();
  };
  protoOf(Buffer).u8l = function () {
    this.k8g_1 = this.l8g_1;
  };
  protoOf(Buffer).t8l = function (newReadPosition) {
    // Inline function 'kotlin.require' call
    if (!(newReadPosition >= 0)) {
      // Inline function 'io.ktor.utils.io.core.Buffer.releaseStartGap.<anonymous>' call
      var message = "newReadPosition shouldn't be negative: " + newReadPosition;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(newReadPosition <= this.h8g_1)) {
      // Inline function 'io.ktor.utils.io.core.Buffer.releaseStartGap.<anonymous>' call
      var message_0 = "newReadPosition shouldn't be ahead of the read position: " + newReadPosition + ' > ' + this.h8g_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    this.h8g_1 = newReadPosition;
    if (this.j8g_1 > newReadPosition) {
      this.j8g_1 = newReadPosition;
    }
  };
  protoOf(Buffer).v8l = function (copy) {
    copy.k8g_1 = this.k8g_1;
    copy.j8g_1 = this.j8g_1;
    copy.h8g_1 = this.h8g_1;
    copy.i8g_1 = this.i8g_1;
  };
  protoOf(Buffer).w8l = function () {
    var readPosition = this.h8g_1;
    if (readPosition === this.i8g_1) {
      throw new EOFException('No readable bytes available.');
    }
    this.h8g_1 = readPosition + 1 | 0;
    // Inline function 'io.ktor.utils.io.bits.get' call
    // Inline function 'io.ktor.utils.io.bits.Memory.loadAt' call
    return this.g8g_1.h8l_1.getInt8(readPosition);
  };
  protoOf(Buffer).x8l = function (value) {
    var writePosition = this.i8g_1;
    if (writePosition === this.k8g_1) {
      throw new InsufficientSpaceException('No free space in the buffer to write a byte');
    }
    // Inline function 'io.ktor.utils.io.bits.set' call
    this.g8g_1.h8l_1.setInt8(writePosition, value);
    this.i8g_1 = writePosition + 1 | 0;
  };
  protoOf(Buffer).a3j = function () {
    this.s8l();
    this.q8l();
  };
  protoOf(Buffer).toString = function () {
    var tmp = 'Buffer[0x' + toString_3(hashCode(this), 16) + ']';
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var tmp_0 = this.i8g_1 - this.h8g_1 | 0;
    // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
    var tmp_1 = this.k8g_1 - this.i8g_1 | 0;
    var tmp_2 = this.j8g_1;
    // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
    return tmp + ('(' + tmp_0 + ' used, ' + tmp_1 + ' free, ' + (tmp_2 + (this.l8g_1 - this.k8g_1 | 0) | 0) + ' reserved of ' + this.l8g_1 + ')');
  };
  function discardFailed(count, readRemaining) {
    throw new EOFException('Unable to discard ' + count + ' bytes: only ' + readRemaining + ' available for reading');
  }
  function commitWrittenFailed(count, writeRemaining) {
    throw new EOFException('Unable to discard ' + count + ' bytes: only ' + writeRemaining + ' available for writing');
  }
  function rewindFailed(count, rewindRemaining) {
    throw IllegalArgumentException_init_$Create$_0('Unable to rewind ' + count + ' bytes: only ' + rewindRemaining + ' could be rewinded');
  }
  function startGapReservationFailedDueToLimit(_this__u8e3s4, startGap) {
    if (startGap > _this__u8e3s4.l8g_1) {
      throw IllegalArgumentException_init_$Create$_0('Start gap ' + startGap + ' is bigger than the capacity ' + _this__u8e3s4.l8g_1);
    }
    // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
    var tmp$ret$0 = _this__u8e3s4.l8g_1 - _this__u8e3s4.k8g_1 | 0;
    throw IllegalStateException_init_$Create$_0('Unable to reserve ' + startGap + ' start gap: there are already ' + tmp$ret$0 + ' bytes reserved in the end');
  }
  function startGapReservationFailed(_this__u8e3s4, startGap) {
    var tmp = 'Unable to reserve ' + startGap + ' start gap: ';
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var tmp$ret$0 = _this__u8e3s4.i8g_1 - _this__u8e3s4.h8g_1 | 0;
    throw IllegalStateException_init_$Create$_0(tmp + ('there are already ' + tmp$ret$0 + ' content bytes starting at offset ' + _this__u8e3s4.h8g_1));
  }
  function endGapReservationFailedDueToCapacity(_this__u8e3s4, endGap) {
    throw IllegalArgumentException_init_$Create$_0('End gap ' + endGap + ' is too big: capacity is ' + _this__u8e3s4.l8g_1);
  }
  function endGapReservationFailedDueToStartGap(_this__u8e3s4, endGap) {
    throw IllegalArgumentException_init_$Create$_0('End gap ' + endGap + ' is too big: there are already ' + _this__u8e3s4.j8g_1 + ' bytes reserved in the beginning');
  }
  function endGapReservationFailedDueToContent(_this__u8e3s4, endGap) {
    var tmp = 'Unable to reserve end gap ' + endGap + ':';
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var tmp$ret$0 = _this__u8e3s4.i8g_1 - _this__u8e3s4.h8g_1 | 0;
    throw IllegalArgumentException_init_$Create$_0(tmp + (' there are already ' + tmp$ret$0 + ' content bytes at offset ' + _this__u8e3s4.h8g_1));
  }
  function InsufficientSpaceException_init_$Init$(name, size, availableSpace, $this) {
    InsufficientSpaceException.call($this, 'Not enough free space to write ' + name + ' of ' + size + ' bytes, available ' + availableSpace + ' bytes.');
    return $this;
  }
  function InsufficientSpaceException_init_$Create$(name, size, availableSpace) {
    var tmp = InsufficientSpaceException_init_$Init$(name, size, availableSpace, objectCreate(protoOf(InsufficientSpaceException)));
    captureStack(tmp, InsufficientSpaceException_init_$Create$);
    return tmp;
  }
  function InsufficientSpaceException(message) {
    message = message === VOID ? 'Not enough free space' : message;
    Exception_init_$Init$_0(message, this);
    captureStack(this, InsufficientSpaceException);
  }
  function restoreStartGap(_this__u8e3s4, size) {
    _this__u8e3s4.t8l(_this__u8e3s4.h8g_1 - size | 0);
  }
  function writeBufferAppend(_this__u8e3s4, other, maxSize) {
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    // Inline function 'kotlin.comparisons.minOf' call
    var a = other.i8g_1 - other.h8g_1 | 0;
    var size = Math.min(a, maxSize);
    // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
    if ((_this__u8e3s4.k8g_1 - _this__u8e3s4.i8g_1 | 0) <= size) {
      writeBufferAppendUnreserve(_this__u8e3s4, size);
    }
    // Inline function 'io.ktor.utils.io.core.write' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp5 = _this__u8e3s4.g8g_1;
    var tmp6 = _this__u8e3s4.i8g_1;
    // Inline function 'io.ktor.utils.io.core.writeBufferAppend.<anonymous>' call
    _this__u8e3s4.k8g_1;
    // Inline function 'io.ktor.utils.io.core.read' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp1 = other.g8g_1;
    var tmp2 = other.h8g_1;
    // Inline function 'io.ktor.utils.io.core.writeBufferAppend.<anonymous>.<anonymous>' call
    other.i8g_1;
    tmp1.y8l(tmp5, tmp2, size, tmp6);
    var rc = size;
    other.i8l(rc);
    var rc_0 = rc;
    _this__u8e3s4.j8l(rc_0);
    return rc_0;
  }
  function writeBufferAppendUnreserve(_this__u8e3s4, writeSize) {
    // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
    var tmp = _this__u8e3s4.k8g_1 - _this__u8e3s4.i8g_1 | 0;
    // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
    if ((tmp + (_this__u8e3s4.l8g_1 - _this__u8e3s4.k8g_1 | 0) | 0) < writeSize) {
      throw IllegalArgumentException_init_$Create$_0("Can't append buffer: not enough free space at the end");
    }
    var newWritePosition = _this__u8e3s4.i8g_1 + writeSize | 0;
    var overrunSize = newWritePosition - _this__u8e3s4.k8g_1 | 0;
    if (overrunSize > 0) {
      _this__u8e3s4.u8l();
    }
  }
  function writeBufferPrepend(_this__u8e3s4, other) {
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var size = other.i8g_1 - other.h8g_1 | 0;
    var readPosition = _this__u8e3s4.h8g_1;
    if (readPosition < size) {
      throw IllegalArgumentException_init_$Create$_0('Not enough space in the beginning to prepend bytes');
    }
    var newReadPosition = readPosition - size | 0;
    other.g8g_1.y8l(_this__u8e3s4.g8g_1, other.h8g_1, size, newReadPosition);
    other.i8l(size);
    _this__u8e3s4.t8l(newReadPosition);
    return size;
  }
  function get_DefaultChunkedBufferPool() {
    _init_properties_BufferFactory_kt__uj6b48();
    return DefaultChunkedBufferPool;
  }
  var DefaultChunkedBufferPool;
  function DefaultBufferPool(bufferSize, capacity, allocator) {
    bufferSize = bufferSize === VOID ? 4096 : bufferSize;
    capacity = capacity === VOID ? 1000 : capacity;
    allocator = allocator === VOID ? DefaultAllocator_instance : allocator;
    DefaultPool.call(this, capacity);
    this.c8m_1 = bufferSize;
    this.d8m_1 = allocator;
  }
  protoOf(DefaultBufferPool).e8m = function () {
    return new ChunkBuffer(this.d8m_1.f8m(this.c8m_1), null, this);
  };
  protoOf(DefaultBufferPool).g8m = function (instance) {
    this.d8m_1.h8m(instance.g8g_1);
    protoOf(DefaultPool).l8m.call(this, instance);
    instance.w8m();
  };
  protoOf(DefaultBufferPool).l8m = function (instance) {
    return this.g8m(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  protoOf(DefaultBufferPool).x8m = function (instance) {
    protoOf(DefaultPool).y8m.call(this, instance);
    // Inline function 'io.ktor.utils.io.bits.Memory.size' call
    var this_0 = instance.g8g_1;
    // Inline function 'kotlin.check' call
    if (!toLong(this_0.h8l_1.byteLength).equals(toLong(this.c8m_1))) {
      // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.validateInstance.<anonymous>' call
      // Inline function 'io.ktor.utils.io.bits.Memory.size' call
      var this_1 = instance.g8g_1;
      var tmp$ret$1 = toLong(this_1.h8l_1.byteLength);
      var message = 'Buffer size mismatch. Expected: ' + this.c8m_1 + ', actual: ' + tmp$ret$1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!!(instance === Companion_getInstance_132().v8j_1)) {
      // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.validateInstance.<anonymous>' call
      var message_0 = "ChunkBuffer.Empty couldn't be recycled";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!!(instance === Companion_instance_129.g8l())) {
      // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.validateInstance.<anonymous>' call
      var message_1 = "Empty instance couldn't be recycled";
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.check' call
    if (!(instance.z8m() === 0)) {
      // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.validateInstance.<anonymous>' call
      var message_2 = 'Unable to clear buffer: it is still in use.';
      throw IllegalStateException_init_$Create$_0(toString_1(message_2));
    }
    // Inline function 'kotlin.check' call
    if (!(instance.c17() == null)) {
      // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.validateInstance.<anonymous>' call
      var message_3 = "Recycled instance shouldn't be a part of a chain.";
      throw IllegalStateException_init_$Create$_0(toString_1(message_3));
    }
    // Inline function 'kotlin.check' call
    if (!(instance.v8m_1 == null)) {
      // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.validateInstance.<anonymous>' call
      var message_4 = "Recycled instance shouldn't be a view or another buffer.";
      throw IllegalStateException_init_$Create$_0(toString_1(message_4));
    }
  };
  protoOf(DefaultBufferPool).y8m = function (instance) {
    return this.x8m(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  protoOf(DefaultBufferPool).a8n = function (instance) {
    // Inline function 'kotlin.apply' call
    var this_0 = protoOf(DefaultPool).b8n.call(this, instance);
    // Inline function 'io.ktor.utils.io.core.DefaultBufferPool.clearInstance.<anonymous>' call
    this_0.c8n();
    this_0.a3j();
    return this_0;
  };
  protoOf(DefaultBufferPool).b8n = function (instance) {
    return this.a8n(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  var properties_initialized_BufferFactory_kt_q9tgbq;
  function _init_properties_BufferFactory_kt__uj6b48() {
    if (!properties_initialized_BufferFactory_kt_q9tgbq) {
      properties_initialized_BufferFactory_kt_q9tgbq = true;
      DefaultChunkedBufferPool = new DefaultBufferPool();
    }
  }
  function writeFully_0(_this__u8e3s4, source, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? source.length - offset | 0 : length;
    // Inline function 'io.ktor.utils.io.core.writeExact' call
    var name = 'byte array';
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.utils.io.core.write' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp1 = _this__u8e3s4.g8g_1;
    var tmp2 = _this__u8e3s4.i8g_1;
    // Inline function 'io.ktor.utils.io.core.writeExact.<anonymous>' call
    var writeRemaining = _this__u8e3s4.k8g_1 - tmp2 | 0;
    if (writeRemaining < length) {
      throw InsufficientSpaceException_init_$Create$(name, length, writeRemaining);
    }
    // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
    // Inline function 'io.ktor.utils.io.bits.storeByteArray' call
    // Inline function 'io.ktor.utils.io.bits.useMemory' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.let' call
    of(Companion_getInstance_134(), source, offset, length).y8l(tmp1, 0, length, tmp2);
    var rc = length;
    _this__u8e3s4.j8l(rc);
  }
  function writeFully_1(_this__u8e3s4, src, length) {
    // Inline function 'kotlin.require' call
    if (!(length >= 0)) {
      // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
      var message = "length shouldn't be negative: " + length;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    // Inline function 'kotlin.require' call
    if (!(length <= (src.i8g_1 - src.h8g_1 | 0))) {
      // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      var message_0 = "length shouldn't be greater than the source read remaining: " + length + ' > ' + (src.i8g_1 - src.h8g_1 | 0);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
    // Inline function 'kotlin.require' call
    if (!(length <= (_this__u8e3s4.k8g_1 - _this__u8e3s4.i8g_1 | 0))) {
      // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var message_1 = "length shouldn't be greater than the destination write remaining space: " + length + ' > ' + (_this__u8e3s4.k8g_1 - _this__u8e3s4.i8g_1 | 0);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'io.ktor.utils.io.core.writeExact' call
    var name = 'buffer readable content';
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.utils.io.core.write' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp1 = _this__u8e3s4.g8g_1;
    var tmp2 = _this__u8e3s4.i8g_1;
    // Inline function 'io.ktor.utils.io.core.writeExact.<anonymous>' call
    var writeRemaining = _this__u8e3s4.k8g_1 - tmp2 | 0;
    if (writeRemaining < length) {
      throw InsufficientSpaceException_init_$Create$(name, length, writeRemaining);
    }
    // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
    src.g8g_1.y8l(tmp1, src.h8g_1, length, tmp2);
    src.i8l(length);
    var rc = length;
    _this__u8e3s4.j8l(rc);
  }
  function readFully(_this__u8e3s4, destination, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? destination.length - offset | 0 : length;
    // Inline function 'io.ktor.utils.io.core.readExact' call
    var name = 'byte array';
    // Inline function 'kotlin.contracts.contract' call
    var value;
    // Inline function 'io.ktor.utils.io.core.read' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp1 = _this__u8e3s4.g8g_1;
    var tmp2 = _this__u8e3s4.h8g_1;
    // Inline function 'io.ktor.utils.io.core.readExact.<anonymous>' call
    if ((_this__u8e3s4.i8g_1 - tmp2 | 0) < length) {
      throw new EOFException('Not enough bytes to read a ' + name + ' of size ' + length + '.');
    }
    copyTo_1(tmp1, destination, tmp2, length, offset);
    value = Unit_instance;
    var rc = length;
    _this__u8e3s4.i8l(rc);
  }
  function readFully_0(_this__u8e3s4, dst, length) {
    var tmp;
    if (length === VOID) {
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      tmp = dst.k8g_1 - dst.i8g_1 | 0;
    } else {
      tmp = length;
    }
    length = tmp;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(length >= 0)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(length <= (dst.k8g_1 - dst.i8g_1 | 0))) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message_0 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'io.ktor.utils.io.core.readExact' call
    var name = 'buffer content';
    // Inline function 'kotlin.contracts.contract' call
    var value;
    // Inline function 'io.ktor.utils.io.core.read' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp1 = _this__u8e3s4.g8g_1;
    var tmp2 = _this__u8e3s4.h8g_1;
    // Inline function 'io.ktor.utils.io.core.readExact.<anonymous>' call
    if ((_this__u8e3s4.i8g_1 - tmp2 | 0) < length) {
      throw new EOFException('Not enough bytes to read a ' + name + ' of size ' + length + '.');
    }
    tmp1.y8l(dst.g8g_1, tmp2, length, dst.i8g_1);
    dst.j8l(length);
    value = Unit_instance;
    var rc = length;
    _this__u8e3s4.i8l(rc);
    return length;
  }
  function writeShort(_this__u8e3s4, value) {
    var name = 'short integer';
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.utils.io.core.write' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp1 = _this__u8e3s4.g8g_1;
    var tmp2 = _this__u8e3s4.i8g_1;
    // Inline function 'io.ktor.utils.io.core.writeExact.<anonymous>' call
    var writeRemaining = _this__u8e3s4.k8g_1 - tmp2 | 0;
    if (writeRemaining < 2) {
      throw InsufficientSpaceException_init_$Create$(name, 2, writeRemaining);
    }
    // Inline function 'io.ktor.utils.io.core.writeShort.<anonymous>' call
    // Inline function 'io.ktor.utils.io.bits.storeShortAt' call
    tmp1.h8l_1.setInt16(tmp2, value, false);
    var rc = 2;
    _this__u8e3s4.j8l(rc);
    return Unit_instance;
  }
  function readShort(_this__u8e3s4) {
    // Inline function 'io.ktor.utils.io.core.readExact' call
    var name = 'short integer';
    // Inline function 'kotlin.contracts.contract' call
    var value;
    // Inline function 'io.ktor.utils.io.core.read' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp1 = _this__u8e3s4.g8g_1;
    var tmp2 = _this__u8e3s4.h8g_1;
    // Inline function 'io.ktor.utils.io.core.readExact.<anonymous>' call
    if ((_this__u8e3s4.i8g_1 - tmp2 | 0) < 2) {
      throw new EOFException('Not enough bytes to read a ' + name + ' of size ' + 2 + '.');
    }
    // Inline function 'io.ktor.utils.io.core.readShort.<anonymous>' call
    // Inline function 'io.ktor.utils.io.bits.loadShortAt' call
    value = tmp1.h8l_1.getInt16(tmp2, false);
    var rc = 2;
    _this__u8e3s4.i8l(rc);
    return value;
  }
  function remainingAll(_this__u8e3s4) {
    return remainingAll_0(_this__u8e3s4, new Long(0, 0));
  }
  function findTail(_this__u8e3s4) {
    var $this = _this__u8e3s4;
    $l$1: do {
      $l$0: do {
        var tmp0_elvis_lhs = $this.c17();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return $this;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var next = tmp;
        $this = next;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function releaseAll(_this__u8e3s4, pool) {
    var current = _this__u8e3s4;
    while (!(current == null)) {
      var next = current.f8n();
      current.g8n(pool);
      current = next;
    }
  }
  function remainingAll_0(_this__u8e3s4, n) {
    var $this = _this__u8e3s4;
    var n_0 = n;
    $l$1: do {
      $l$0: do {
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var this_0 = $this;
        var tmp$ret$0 = this_0.i8g_1 - this_0.h8g_1 | 0;
        var rem = toLong(tmp$ret$0).i3(n_0);
        var tmp0_elvis_lhs = $this.c17();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return rem;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var next = tmp;
        $this = next;
        n_0 = rem;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function BytePacketBuilder(pool) {
    pool = pool === VOID ? Companion_getInstance_132().y8j() : pool;
    Output.call(this, pool);
  }
  protoOf(BytePacketBuilder).n = function () {
    return this.h8n();
  };
  protoOf(BytePacketBuilder).np = function () {
    return this.h8n() === 0;
  };
  protoOf(BytePacketBuilder).i8n = function () {
  };
  protoOf(BytePacketBuilder).j8n = function (source, offset, length) {
  };
  protoOf(BytePacketBuilder).e9 = function (value) {
    var tmp = protoOf(Output).e9.call(this, value);
    return tmp instanceof BytePacketBuilder ? tmp : THROW_CCE();
  };
  protoOf(BytePacketBuilder).f = function (value) {
    var tmp = protoOf(Output).f.call(this, value);
    return tmp instanceof BytePacketBuilder ? tmp : THROW_CCE();
  };
  protoOf(BytePacketBuilder).yc = function (value, startIndex, endIndex) {
    var tmp = protoOf(Output).yc.call(this, value, startIndex, endIndex);
    return tmp instanceof BytePacketBuilder ? tmp : THROW_CCE();
  };
  protoOf(BytePacketBuilder).k2p = function () {
    var size = this.n();
    var head = this.h8e();
    return head == null ? Companion_getInstance_130().k8n_1 : new ByteReadPacket(head, toLong(size), this.z8d_1);
  };
  protoOf(BytePacketBuilder).toString = function () {
    return 'BytePacketBuilder[0x' + hashCode(this) + ']';
  };
  function ByteReadPacket_init_$Init$(head, pool, $this) {
    ByteReadPacket.call($this, head, remainingAll(head), pool);
    return $this;
  }
  function ByteReadPacket_init_$Create$(head, pool) {
    return ByteReadPacket_init_$Init$(head, pool, objectCreate(protoOf(ByteReadPacket)));
  }
  function Companion_130() {
    Companion_instance_130 = this;
    this.k8n_1 = new ByteReadPacket(Companion_getInstance_132().v8j_1, new Long(0, 0), Companion_getInstance_132().u8j_1);
  }
  var Companion_instance_130;
  function Companion_getInstance_130() {
    if (Companion_instance_130 == null)
      new Companion_130();
    return Companion_instance_130;
  }
  function ByteReadPacket(head, remaining, pool) {
    Companion_getInstance_130();
    Input.call(this, head, remaining, pool);
    this.q8n();
  }
  protoOf(ByteReadPacket).y8n = function () {
    return null;
  };
  protoOf(ByteReadPacket).z8n = function (destination, offset, length) {
    return 0;
  };
  protoOf(ByteReadPacket).toString = function () {
    return 'ByteReadPacket[' + hashCode(this) + ']';
  };
  function _set__head__b4pap2($this, newHead) {
    $this.q8h_1 = newHead;
    $this.r8h_1 = newHead.g8g_1;
    $this.s8h_1 = newHead.h8g_1;
    $this.t8h_1 = newHead.i8g_1;
  }
  function readASCII($this, out, min, max) {
    if (max === 0 && min === 0)
      return 0;
    else if ($this.i8j())
      if (min === 0)
        return 0;
      else {
        atLeastMinCharactersRequire($this, min);
      }
     else if (max < min) {
      minShouldBeLess($this, min, max);
    }
    var copied = 0;
    var utf8 = false;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.takeWhile' call
      var release = true;
      var tmp0_elvis_lhs = prepareReadFirstHead($this, 1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      try {
        $l$loop_0: do {
          // Inline function 'io.ktor.utils.io.core.Input.readASCII.<anonymous>' call
          var tmp0 = current;
          var tmp$ret$4;
          $l$block_0: {
            // Inline function 'io.ktor.utils.io.core.internal.decodeASCII' call
            // Inline function 'io.ktor.utils.io.core.read' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp1 = tmp0.g8g_1;
            var tmp2 = tmp0.h8g_1;
            // Inline function 'io.ktor.utils.io.core.internal.decodeASCII.<anonymous>' call
            var endExclusive = tmp0.i8g_1;
            var inductionVariable = tmp2;
            if (inductionVariable < endExclusive)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'io.ktor.utils.io.bits.get' call
                // Inline function 'io.ktor.utils.io.bits.Memory.loadAt' call
                var codepoint = tmp1.h8l_1.getInt8(index) & 255;
                var tmp_0;
                if ((codepoint & 128) === 128) {
                  tmp_0 = true;
                } else {
                  // Inline function 'io.ktor.utils.io.core.Input.readASCII.<anonymous>.<anonymous>' call
                  var it = numberToChar(codepoint);
                  var tmp_1;
                  if (copied === max) {
                    tmp_1 = false;
                  } else {
                    out.e9(it);
                    copied = copied + 1 | 0;
                    tmp_1 = true;
                  }
                  tmp_0 = !tmp_1;
                }
                if (tmp_0) {
                  tmp0.i8l(index - tmp2 | 0);
                  tmp$ret$4 = false;
                  break $l$block_0;
                }
              }
               while (inductionVariable < endExclusive);
            var rc = endExclusive - tmp2 | 0;
            tmp0.i8l(rc);
            tmp$ret$4 = true;
          }
          var rc_0 = tmp$ret$4;
          var tmp_2;
          if (rc_0) {
            tmp_2 = true;
          } else if (copied === max) {
            tmp_2 = false;
          } else {
            utf8 = true;
            tmp_2 = false;
          }
          if (!tmp_2) {
            break $l$loop_0;
          }
          release = false;
          var tmp1_elvis_lhs = prepareReadNextHead($this, current);
          var tmp_3;
          if (tmp1_elvis_lhs == null) {
            break $l$loop_0;
          } else {
            tmp_3 = tmp1_elvis_lhs;
          }
          var next = tmp_3;
          current = next;
          release = true;
        }
         while (true);
      }finally {
        if (release) {
          completeReadHead($this, current);
        }
      }
    }
    if (utf8) {
      return copied + readUtf8($this, out, min - copied | 0, max - copied | 0) | 0;
    }
    if (copied < min) {
      prematureEndOfStreamChars($this, min, copied);
    }
    return copied;
  }
  function atLeastMinCharactersRequire($this, min) {
    throw new EOFException('at least ' + min + ' characters required but no bytes available');
  }
  function minShouldBeLess($this, min, max) {
    throw IllegalArgumentException_init_$Create$_0('min should be less or equal to max but min = ' + min + ', max = ' + max);
  }
  function prematureEndOfStreamChars($this, min, copied) {
    throw new MalformedUTF8InputException('Premature end of stream: expected at least ' + min + ' chars but had only ' + copied);
  }
  function readUtf8($this, out, min, max) {
    var copied = 0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.takeWhileSize' call
      var release = true;
      var tmp0_elvis_lhs = prepareReadFirstHead($this, 1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      var size = 1;
      try {
        $l$loop_0: do {
          // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
          var this_0 = current;
          var before = this_0.i8g_1 - this_0.h8g_1 | 0;
          var after;
          if (before >= size) {
            try {
              // Inline function 'io.ktor.utils.io.core.Input.readUtf8.<anonymous>' call
              var tmp0 = current;
              var tmp$ret$5;
              $l$block_3: {
                // Inline function 'io.ktor.utils.io.core.internal.decodeUTF8' call
                var byteCount = 0;
                var value = 0;
                var lastByteCount = 0;
                // Inline function 'io.ktor.utils.io.core.read' call
                // Inline function 'kotlin.contracts.contract' call
                var tmp1 = tmp0.g8g_1;
                var tmp2 = tmp0.h8g_1;
                // Inline function 'io.ktor.utils.io.core.internal.decodeUTF8.<anonymous>' call
                var endExclusive = tmp0.i8g_1;
                var inductionVariable = tmp2;
                if (inductionVariable < endExclusive)
                  do {
                    var index = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    // Inline function 'io.ktor.utils.io.bits.get' call
                    // Inline function 'io.ktor.utils.io.bits.Memory.loadAt' call
                    var v = tmp1.h8l_1.getInt8(index) & 255;
                    if ((v & 128) === 0) {
                      if (!(byteCount === 0)) {
                        malformedByteCount(byteCount);
                      }
                      // Inline function 'io.ktor.utils.io.core.Input.readUtf8.<anonymous>.<anonymous>' call
                      var it = numberToChar(v);
                      var tmp_0;
                      if (copied === max) {
                        tmp_0 = false;
                      } else {
                        out.e9(it);
                        copied = copied + 1 | 0;
                        tmp_0 = true;
                      }
                      if (!tmp_0) {
                        tmp0.i8l(index - tmp2 | 0);
                        tmp$ret$5 = -1;
                        break $l$block_3;
                      }
                    } else if (byteCount === 0) {
                      var mask = 128;
                      value = v;
                      var inductionVariable_0 = 1;
                      if (inductionVariable_0 <= 6)
                        $l$loop: do {
                          var i = inductionVariable_0;
                          inductionVariable_0 = inductionVariable_0 + 1 | 0;
                          if (!((value & mask) === 0)) {
                            value = value & ~mask;
                            mask = mask >> 1;
                            byteCount = byteCount + 1 | 0;
                          } else {
                            break $l$loop;
                          }
                        }
                         while (inductionVariable_0 <= 6);
                      lastByteCount = byteCount;
                      byteCount = byteCount - 1 | 0;
                      if (lastByteCount > (endExclusive - index | 0)) {
                        tmp0.i8l(index - tmp2 | 0);
                        tmp$ret$5 = lastByteCount;
                        break $l$block_3;
                      }
                    } else {
                      value = value << 6 | v & 127;
                      byteCount = byteCount - 1 | 0;
                      if (byteCount === 0) {
                        if (isBmpCodePoint(value)) {
                          // Inline function 'io.ktor.utils.io.core.Input.readUtf8.<anonymous>.<anonymous>' call
                          var it_0 = numberToChar(value);
                          var tmp_1;
                          if (copied === max) {
                            tmp_1 = false;
                          } else {
                            out.e9(it_0);
                            copied = copied + 1 | 0;
                            tmp_1 = true;
                          }
                          if (!tmp_1) {
                            tmp0.i8l(((index - tmp2 | 0) - lastByteCount | 0) + 1 | 0);
                            tmp$ret$5 = -1;
                            break $l$block_3;
                          }
                        } else if (!isValidCodePoint(value)) {
                          malformedCodePoint(value);
                        } else {
                          var tmp_2;
                          // Inline function 'io.ktor.utils.io.core.Input.readUtf8.<anonymous>.<anonymous>' call
                          var it_1 = numberToChar(highSurrogate(value));
                          var tmp_3;
                          if (copied === max) {
                            tmp_3 = false;
                          } else {
                            out.e9(it_1);
                            copied = copied + 1 | 0;
                            tmp_3 = true;
                          }
                          if (!tmp_3) {
                            tmp_2 = true;
                          } else {
                            // Inline function 'io.ktor.utils.io.core.Input.readUtf8.<anonymous>.<anonymous>' call
                            var it_2 = numberToChar(lowSurrogate(value));
                            var tmp_4;
                            if (copied === max) {
                              tmp_4 = false;
                            } else {
                              out.e9(it_2);
                              copied = copied + 1 | 0;
                              tmp_4 = true;
                            }
                            tmp_2 = !tmp_4;
                          }
                          if (tmp_2) {
                            tmp0.i8l(((index - tmp2 | 0) - lastByteCount | 0) + 1 | 0);
                            tmp$ret$5 = -1;
                            break $l$block_3;
                          }
                        }
                        value = 0;
                      }
                    }
                  }
                   while (inductionVariable < endExclusive);
                var rc = endExclusive - tmp2 | 0;
                tmp0.i8l(rc);
                tmp$ret$5 = 0;
              }
              var size_0 = tmp$ret$5;
              size = size_0 === 0 ? 1 : size_0 > 0 ? size_0 : 0;
            }finally {
              // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
              var this_1 = current;
              after = this_1.i8g_1 - this_1.h8g_1 | 0;
            }
          } else {
            after = before;
          }
          release = false;
          var tmp_5;
          if (after === 0) {
            tmp_5 = prepareReadNextHead($this, current);
          } else {
            var tmp_6;
            if (after < size) {
              tmp_6 = true;
            } else {
              // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
              var this_2 = current;
              tmp_6 = (this_2.l8g_1 - this_2.k8g_1 | 0) < 8;
            }
            if (tmp_6) {
              completeReadHead($this, current);
              tmp_5 = prepareReadFirstHead($this, size);
            } else {
              tmp_5 = current;
            }
          }
          var tmp1_elvis_lhs = tmp_5;
          var tmp_7;
          if (tmp1_elvis_lhs == null) {
            break $l$loop_0;
          } else {
            tmp_7 = tmp1_elvis_lhs;
          }
          var next = tmp_7;
          current = next;
          release = true;
        }
         while (size > 0);
      }finally {
        if (release) {
          completeReadHead($this, current);
        }
      }
    }
    if (copied < min) {
      prematureEndOfStreamChars($this, min, copied);
    }
    return copied;
  }
  function discardAsMuchAsPossible($this, n, skipped) {
    var $this_0 = $this;
    var n_0 = n;
    var skipped_0 = skipped;
    $l$1: do {
      $l$0: do {
        if (n_0.equals(new Long(0, 0)))
          return skipped_0;
        var tmp0_elvis_lhs = $this_0.m8o(1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return skipped_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var current = tmp;
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var tmp$ret$0 = current.i8g_1 - current.h8g_1 | 0;
        var tmp1 = toLong(tmp$ret$0);
        // Inline function 'kotlin.comparisons.minOf' call
        var b = n_0;
        var size = (tmp1.d1(b) <= 0 ? tmp1 : b).z3();
        current.i8l(size);
        var tmp1_this = $this_0;
        tmp1_this.s8h_1 = tmp1_this.s8h_1 + size | 0;
        afterRead($this_0, current);
        var tmp0 = $this_0;
        // Inline function 'kotlin.Long.minus' call
        var tmp1_0 = n_0.j3(toLong(size));
        // Inline function 'kotlin.Long.plus' call
        var tmp2 = skipped_0.i3(toLong(size));
        $this_0 = tmp0;
        n_0 = tmp1_0;
        skipped_0 = tmp2;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function discardAsMuchAsPossible_0($this, n, skipped) {
    var currentCount = n;
    var currentSkipped = skipped;
    while (true) {
      if (currentCount === 0) {
        return currentSkipped;
      }
      var tmp0_elvis_lhs = $this.m8o(1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return currentSkipped;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      var tmp1 = current.i8g_1 - current.h8g_1 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = currentCount;
      var size = Math.min(tmp1, b);
      current.i8l(size);
      $this.s8h_1 = $this.s8h_1 + size | 0;
      afterRead($this, current);
      currentCount = currentCount - size | 0;
      currentSkipped = currentSkipped + size | 0;
    }
  }
  function fixGapAfterReadFallback($this, current) {
    if ($this.v8h_1 && current.c17() == null) {
      $this.s8h_1 = current.h8g_1;
      $this.t8h_1 = current.i8g_1;
      $this.a8o(new Long(0, 0));
      return Unit_instance;
    }
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var size = current.i8g_1 - current.h8g_1 | 0;
    // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
    // Inline function 'kotlin.comparisons.minOf' call
    var b = 8 - (current.l8g_1 - current.k8g_1 | 0) | 0;
    var overrun = Math.min(size, b);
    if (size > overrun) {
      fixGapAfterReadFallbackUnreserved($this, current, size, overrun);
    } else {
      var new_0 = $this.p8h_1.d8n();
      new_0.o8l(8);
      new_0.o8o(current.f8n());
      writeBufferAppend(new_0, current, size);
      _set__head__b4pap2($this, new_0);
    }
    current.g8n($this.p8h_1);
  }
  function fixGapAfterReadFallbackUnreserved($this, current, size, overrun) {
    var chunk1 = $this.p8h_1.d8n();
    var chunk2 = $this.p8h_1.d8n();
    chunk1.o8l(8);
    chunk2.o8l(8);
    chunk1.o8o(chunk2);
    chunk2.o8o(current.f8n());
    writeBufferAppend(chunk1, current, size - overrun | 0);
    writeBufferAppend(chunk2, current, overrun);
    _set__head__b4pap2($this, chunk1);
    $this.a8o(remainingAll(chunk2));
  }
  function ensureNext($this, current, empty) {
    var $this_0 = $this;
    var current_0 = current;
    var empty_0 = empty;
    $l$1: do {
      $l$0: do {
        if (current_0 === empty_0) {
          return doFill($this_0);
        }
        var next = current_0.f8n();
        current_0.g8n($this_0.p8h_1);
        var tmp;
        if (next == null) {
          _set__head__b4pap2($this_0, empty_0);
          $this_0.a8o(new Long(0, 0));
          var tmp0 = $this_0;
          var tmp1 = empty_0;
          var tmp2 = empty_0;
          $this_0 = tmp0;
          current_0 = tmp1;
          empty_0 = tmp2;
          continue $l$0;
        } else {
          // Inline function 'io.ktor.utils.io.core.canRead' call
          if (next.i8g_1 > next.h8g_1) {
            _set__head__b4pap2($this_0, next);
            var tmp0_this = $this_0;
            var tmp2_0 = tmp0_this.u8h_1;
            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
            // Inline function 'kotlin.Long.minus' call
            var other = next.i8g_1 - next.h8g_1 | 0;
            var tmp$ret$2 = tmp2_0.j3(toLong(other));
            tmp0_this.a8o(tmp$ret$2);
            tmp = next;
          } else {
            var tmp3 = $this_0;
            var tmp5 = empty_0;
            $this_0 = tmp3;
            current_0 = next;
            empty_0 = tmp5;
            continue $l$0;
          }
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function doFill($this) {
    if ($this.v8h_1)
      return null;
    var chunk = $this.y8n();
    if (chunk == null) {
      $this.v8h_1 = true;
      return null;
    }
    appendView($this, chunk);
    return chunk;
  }
  function appendView($this, chunk) {
    var tail = findTail($this.q8h_1);
    if (tail === Companion_getInstance_132().v8j_1) {
      _set__head__b4pap2($this, chunk);
      // Inline function 'kotlin.require' call
      if (!$this.u8h_1.equals(new Long(0, 0))) {
        throw IllegalStateException_init_$Create$_0('It should be no tail remaining bytes if current tail is EmptyBuffer');
      }
      var tmp0_safe_receiver = chunk.c17();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : remainingAll(tmp0_safe_receiver);
      $this.a8o(tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs);
    } else {
      tail.o8o(chunk);
      $this.a8o($this.u8h_1.i3(remainingAll(chunk)));
    }
  }
  function prepareReadLoop($this, minSize, head) {
    var $this_0 = $this;
    var minSize_0 = minSize;
    var head_0 = head;
    $l$1: do {
      $l$0: do {
        // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
        var this_0 = $this_0;
        var headSize = this_0.t8h_1 - this_0.s8h_1 | 0;
        if (headSize >= minSize_0)
          return head_0;
        var tmp0_elvis_lhs = head_0.c17();
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? doFill($this_0) : tmp0_elvis_lhs;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          return null;
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var next = tmp;
        if (headSize === 0) {
          if (!(head_0 === Companion_getInstance_132().v8j_1)) {
            $this_0.n8o(head_0);
          }
          var tmp0 = $this_0;
          var tmp1 = minSize_0;
          $this_0 = tmp0;
          minSize_0 = tmp1;
          head_0 = next;
          continue $l$0;
        } else {
          var desiredExtraBytes = minSize_0 - headSize | 0;
          var copied = writeBufferAppend(head_0, next, desiredExtraBytes);
          $this_0.t8h_1 = head_0.i8g_1;
          var tmp2_this = $this_0;
          // Inline function 'kotlin.Long.minus' call
          var tmp$ret$1 = tmp2_this.u8h_1.j3(toLong(copied));
          tmp2_this.a8o(tmp$ret$1);
          // Inline function 'io.ktor.utils.io.core.canRead' call
          if (!(next.i8g_1 > next.h8g_1)) {
            head_0.o8o(null);
            head_0.o8o(next.f8n());
            next.g8n($this_0.p8h_1);
          } else {
            next.n8l(copied);
          }
        }
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var this_1 = head_0;
        if ((this_1.i8g_1 - this_1.h8g_1 | 0) >= minSize_0)
          return head_0;
        if (minSize_0 > 8) {
          minSizeIsTooBig($this_0, minSize_0);
        }
        var tmp3 = $this_0;
        var tmp4 = minSize_0;
        var tmp5 = head_0;
        $this_0 = tmp3;
        minSize_0 = tmp4;
        head_0 = tmp5;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function minSizeIsTooBig($this, minSize) {
    throw IllegalStateException_init_$Create$_0('minSize of ' + minSize + ' is too big (should be less than 8)');
  }
  function afterRead($this, head) {
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    if ((head.i8g_1 - head.h8g_1 | 0) === 0) {
      $this.n8o(head);
    }
  }
  function Companion_131() {
  }
  var Companion_instance_131;
  function Companion_getInstance_131() {
    return Companion_instance_131;
  }
  function Input(head, remaining, pool) {
    head = head === VOID ? Companion_getInstance_132().v8j_1 : head;
    remaining = remaining === VOID ? remainingAll(head) : remaining;
    pool = pool === VOID ? Companion_getInstance_132().y8j() : pool;
    this.p8h_1 = pool;
    this.q8h_1 = head;
    this.r8h_1 = head.g8g_1;
    this.s8h_1 = head.h8g_1;
    this.t8h_1 = head.i8g_1;
    var tmp = this;
    // Inline function 'kotlin.Long.minus' call
    var other = this.t8h_1 - this.s8h_1 | 0;
    tmp.u8h_1 = remaining.j3(toLong(other));
    this.v8h_1 = false;
  }
  protoOf(Input).i8j = function () {
    var tmp;
    var tmp_0;
    // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
    if ((this.t8h_1 - this.s8h_1 | 0) === 0) {
      tmp_0 = this.u8h_1.equals(new Long(0, 0));
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.v8h_1 || doFill(this) == null;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Input).l8n = function () {
    // Inline function 'kotlin.also' call
    var this_0 = this.q8h_1;
    // Inline function 'io.ktor.utils.io.core.Input.<get-head>.<anonymous>' call
    this_0.l8l(this.s8h_1);
    return this_0;
  };
  protoOf(Input).a8o = function (newValue) {
    // Inline function 'kotlin.require' call
    if (!(newValue.d1(new Long(0, 0)) >= 0)) {
      // Inline function 'io.ktor.utils.io.core.Input.<set-tailRemaining>.<anonymous>' call
      var message = "tailRemaining shouldn't be negative: " + newValue.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.u8h_1 = newValue;
  };
  protoOf(Input).w8h = function () {
    // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
    var tmp$ret$0 = this.t8h_1 - this.s8h_1 | 0;
    return toLong(tmp$ret$0).i3(this.u8h_1);
  };
  protoOf(Input).l8i = function () {
    return !(this.s8h_1 === this.t8h_1) || !this.u8h_1.equals(new Long(0, 0));
  };
  protoOf(Input).vz = function () {
    var head = this.l8n();
    var empty = Companion_getInstance_132().v8j_1;
    if (!(head === empty)) {
      _set__head__b4pap2(this, empty);
      this.a8o(new Long(0, 0));
      releaseAll(head, this.p8h_1);
    }
  };
  protoOf(Input).h8e = function () {
    var head = this.l8n();
    var empty = Companion_getInstance_132().v8j_1;
    if (head === empty)
      return null;
    _set__head__b4pap2(this, empty);
    this.a8o(new Long(0, 0));
    return head;
  };
  protoOf(Input).b8o = function () {
    var head = this.l8n();
    var next = head.c17();
    var empty = Companion_getInstance_132().v8j_1;
    if (head === empty)
      return null;
    if (next == null) {
      _set__head__b4pap2(this, empty);
      this.a8o(new Long(0, 0));
    } else {
      _set__head__b4pap2(this, next);
      var tmp1 = this.u8h_1;
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      // Inline function 'kotlin.Long.minus' call
      var other = next.i8g_1 - next.h8g_1 | 0;
      var tmp$ret$1 = tmp1.j3(toLong(other));
      this.a8o(tmp$ret$1);
    }
    head.o8o(null);
    return head;
  };
  protoOf(Input).c8o = function (chain) {
    if (chain === Companion_getInstance_132().v8j_1)
      return Unit_instance;
    var size = remainingAll(chain);
    if (this.q8h_1 === Companion_getInstance_132().v8j_1) {
      _set__head__b4pap2(this, chain);
      // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
      // Inline function 'kotlin.Long.minus' call
      var other = this.t8h_1 - this.s8h_1 | 0;
      var tmp$ret$1 = size.j3(toLong(other));
      this.a8o(tmp$ret$1);
    } else {
      findTail(this.q8h_1).o8o(chain);
      this.a8o(this.u8h_1.i3(size));
    }
  };
  protoOf(Input).d8o = function (chain) {
    var tail = findTail(this.l8n());
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var size = chain.i8g_1 - chain.h8g_1 | 0;
    var tmp;
    if (size === 0) {
      tmp = true;
    } else {
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      tmp = (tail.k8g_1 - tail.i8g_1 | 0) < size;
    }
    if (tmp)
      return false;
    writeBufferAppend(tail, chain, size);
    if (this.l8n() === tail) {
      this.t8h_1 = tail.i8g_1;
    } else {
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$2 = this.u8h_1.i3(toLong(size));
      this.a8o(tmp$ret$2);
    }
    return true;
  };
  protoOf(Input).e8o = function (n) {
    // Inline function 'kotlin.require' call
    if (!(n >= 0)) {
      // Inline function 'io.ktor.utils.io.core.Input.discard.<anonymous>' call
      var message = 'Negative discard is not allowed: ' + n;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return discardAsMuchAsPossible_0(this, n, 0);
  };
  protoOf(Input).i8l = function (n) {
    if (!(this.e8o(n) === n))
      throw new EOFException('Unable to discard ' + n + ' bytes due to end of packet');
  };
  protoOf(Input).f8o = function (n) {
    if (n.d1(new Long(0, 0)) <= 0)
      return new Long(0, 0);
    return discardAsMuchAsPossible(this, n, new Long(0, 0));
  };
  protoOf(Input).g8o = function (min, max) {
    if (min === 0 && (max === 0 || this.i8j()))
      return '';
    var remaining = this.w8h();
    if (remaining.d1(new Long(0, 0)) > 0 && toLong(max).d1(remaining) >= 0)
      return readTextExactBytes(this, remaining.z3());
    // Inline function 'kotlin.text.buildString' call
    var capacity = coerceAtMost(coerceAtLeast(min, 16), max);
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$(capacity);
    // Inline function 'io.ktor.utils.io.core.Input.readText.<anonymous>' call
    readASCII(this, this_0, min, max);
    return this_0.toString();
  };
  protoOf(Input).h8o = function (min, max, $super) {
    min = min === VOID ? 0 : min;
    max = max === VOID ? 2147483647 : max;
    return $super === VOID ? this.g8o(min, max) : $super.g8o.call(this, min, max);
  };
  protoOf(Input).i8o = function (minSize) {
    return prepareReadLoop(this, minSize, this.l8n());
  };
  protoOf(Input).j8o = function (current) {
    return this.k8o(current);
  };
  protoOf(Input).k8o = function (current) {
    return ensureNext(this, current, Companion_getInstance_132().v8j_1);
  };
  protoOf(Input).l8o = function (current) {
    var tmp0_elvis_lhs = current.c17();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return fixGapAfterReadFallback(this, current);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var next = tmp;
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var remaining = current.i8g_1 - current.h8g_1 | 0;
    // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
    // Inline function 'kotlin.comparisons.minOf' call
    var b = 8 - (current.l8g_1 - current.k8g_1 | 0) | 0;
    var overrunSize = Math.min(remaining, b);
    if (next.j8g_1 < overrunSize) {
      return fixGapAfterReadFallback(this, current);
    }
    restoreStartGap(next, overrunSize);
    if (remaining > overrunSize) {
      current.u8l();
      this.t8h_1 = current.i8g_1;
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$3 = this.u8h_1.i3(toLong(overrunSize));
      this.a8o(tmp$ret$3);
    } else {
      _set__head__b4pap2(this, next);
      var tmp7 = this.u8h_1;
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      // Inline function 'kotlin.Long.minus' call
      var other = (next.i8g_1 - next.h8g_1 | 0) - overrunSize | 0;
      var tmp$ret$5 = tmp7.j3(toLong(other));
      this.a8o(tmp$ret$5);
      current.f8n();
      current.g8n(this.p8h_1);
    }
  };
  protoOf(Input).y8n = function () {
    var buffer = this.p8h_1.d8n();
    try {
      buffer.o8l(8);
      var tmp = buffer.i8g_1;
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var tmp$ret$0 = buffer.k8g_1 - buffer.i8g_1 | 0;
      var copied = this.z8n(buffer.g8g_1, tmp, tmp$ret$0);
      if (copied === 0) {
        this.v8h_1 = true;
        // Inline function 'io.ktor.utils.io.core.canRead' call
        if (!(buffer.i8g_1 > buffer.h8g_1)) {
          buffer.g8n(this.p8h_1);
          return null;
        }
      }
      buffer.j8l(copied);
      return buffer;
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        buffer.g8n(this.p8h_1);
        throw t;
      } else {
        throw $p;
      }
    }
  };
  protoOf(Input).q8n = function () {
    if (!this.v8h_1) {
      this.v8h_1 = true;
    }
  };
  protoOf(Input).m8o = function (minSize) {
    var head = this.l8n();
    if ((this.t8h_1 - this.s8h_1 | 0) >= minSize)
      return head;
    return prepareReadLoop(this, minSize, head);
  };
  protoOf(Input).n8o = function (head) {
    var tmp0_elvis_lhs = head.f8n();
    var next = tmp0_elvis_lhs == null ? Companion_getInstance_132().v8j_1 : tmp0_elvis_lhs;
    _set__head__b4pap2(this, next);
    var tmp1 = this.u8h_1;
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    // Inline function 'kotlin.Long.minus' call
    var other = next.i8g_1 - next.h8g_1 | 0;
    var tmp$ret$1 = tmp1.j3(toLong(other));
    this.a8o(tmp$ret$1);
    head.g8n(this.p8h_1);
    return next;
  };
  function discard(_this__u8e3s4) {
    return _this__u8e3s4.f8o(new Long(-1, 2147483647));
  }
  function readFully_1(_this__u8e3s4, dst, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? dst.length - offset | 0 : length;
    // Inline function 'io.ktor.utils.io.core.readFullyBytesTemplate' call
    var remaining = length;
    var dstOffset = offset;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.takeWhile' call
      var release = true;
      var tmp0_elvis_lhs = prepareReadFirstHead(_this__u8e3s4, 1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      try {
        $l$loop_0: do {
          // Inline function 'io.ktor.utils.io.core.readFullyBytesTemplate.<anonymous>' call
          var buffer = current;
          var tmp1 = remaining;
          // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
          // Inline function 'kotlin.comparisons.minOf' call
          var b = buffer.i8g_1 - buffer.h8g_1 | 0;
          var count = Math.min(tmp1, b);
          // Inline function 'io.ktor.utils.io.core.readFully.<anonymous>' call
          var dstOffset_0 = dstOffset;
          readFully(buffer, dst, dstOffset_0, count);
          remaining = remaining - count | 0;
          dstOffset = dstOffset + count | 0;
          if (!(remaining > 0)) {
            break $l$loop_0;
          }
          release = false;
          var tmp1_elvis_lhs = prepareReadNextHead(_this__u8e3s4, current);
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            break $l$loop_0;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          var next = tmp_0;
          current = next;
          release = true;
        }
         while (true);
      }finally {
        if (release) {
          completeReadHead(_this__u8e3s4, current);
        }
      }
    }
    // Inline function 'io.ktor.utils.io.core.requireNoRemaining' call
    var this_0 = remaining;
    if (this_0 > 0) {
      prematureEndOfStream(this_0);
    }
  }
  function readFully_2(_this__u8e3s4, dst, length) {
    var tmp;
    if (length === VOID) {
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      tmp = dst.k8g_1 - dst.i8g_1 | 0;
    } else {
      tmp = length;
    }
    length = tmp;
    // Inline function 'io.ktor.utils.io.core.readFullyBytesTemplate' call
    var remaining = length;
    var dstOffset = 0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.takeWhile' call
      var release = true;
      var tmp0_elvis_lhs = prepareReadFirstHead(_this__u8e3s4, 1);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var current = tmp_0;
      try {
        $l$loop_0: do {
          // Inline function 'io.ktor.utils.io.core.readFullyBytesTemplate.<anonymous>' call
          var buffer = current;
          var tmp1 = remaining;
          // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
          // Inline function 'kotlin.comparisons.minOf' call
          var b = buffer.i8g_1 - buffer.h8g_1 | 0;
          var count = Math.min(tmp1, b);
          // Inline function 'io.ktor.utils.io.core.readFully.<anonymous>' call
          readFully_0(buffer, dst, count);
          remaining = remaining - count | 0;
          dstOffset = dstOffset + count | 0;
          if (!(remaining > 0)) {
            break $l$loop_0;
          }
          release = false;
          var tmp1_elvis_lhs = prepareReadNextHead(_this__u8e3s4, current);
          var tmp_1;
          if (tmp1_elvis_lhs == null) {
            break $l$loop_0;
          } else {
            tmp_1 = tmp1_elvis_lhs;
          }
          var next = tmp_1;
          current = next;
          release = true;
        }
         while (true);
      }finally {
        if (release) {
          completeReadHead(_this__u8e3s4, current);
        }
      }
    }
    // Inline function 'io.ktor.utils.io.core.requireNoRemaining' call
    var this_0 = remaining;
    if (this_0 > 0) {
      prematureEndOfStream(this_0);
    }
  }
  function readShort_0(_this__u8e3s4) {
    var tmp$ret$3;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.readPrimitive' call
      // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
      if ((_this__u8e3s4.t8h_1 - _this__u8e3s4.s8h_1 | 0) > 2) {
        var index = _this__u8e3s4.s8h_1;
        _this__u8e3s4.s8h_1 = index + 2 | 0;
        // Inline function 'io.ktor.utils.io.core.readShort.<anonymous>' call
        // Inline function 'io.ktor.utils.io.bits.loadShortAt' call
        tmp$ret$3 = _this__u8e3s4.r8h_1.h8l_1.getInt16(index, false);
        break $l$block;
      }
      // Inline function 'io.ktor.utils.io.core.readShort.<anonymous>' call
      tmp$ret$3 = readShortFallback(_this__u8e3s4);
    }
    return tmp$ret$3;
  }
  function readShortFallback(_this__u8e3s4) {
    // Inline function 'io.ktor.utils.io.core.readPrimitiveFallback' call
    var tmp0_elvis_lhs = prepareReadFirstHead(_this__u8e3s4, 2);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      prematureEndOfStream(2);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var head = tmp;
    // Inline function 'io.ktor.utils.io.core.readShortFallback.<anonymous>' call
    var value = readShort(head);
    completeReadHead(_this__u8e3s4, head);
    return value;
  }
  function flushChain($this) {
    var tmp0_elvis_lhs = $this.h8e();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var oldTail = tmp;
    try {
      // Inline function 'io.ktor.utils.io.core.forEachChunk' call
      // Inline function 'kotlin.contracts.contract' call
      var current = oldTail;
      $l$loop: do {
        // Inline function 'io.ktor.utils.io.core.Output.flushChain.<anonymous>' call
        var chunk = current;
        var tmp_0 = chunk.h8g_1;
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var tmp$ret$0 = chunk.i8g_1 - chunk.h8g_1 | 0;
        $this.j8n(chunk.g8g_1, tmp_0, tmp$ret$0);
        var tmp0_elvis_lhs_0 = current.c17();
        var tmp_1;
        if (tmp0_elvis_lhs_0 == null) {
          break $l$loop;
        } else {
          tmp_1 = tmp0_elvis_lhs_0;
        }
        current = tmp_1;
      }
       while (true);
    }finally {
      releaseAll(oldTail, $this.z8d_1);
    }
  }
  function appendNewChunk($this) {
    var new_0 = $this.z8d_1.d8n();
    new_0.o8l(8);
    $this.m8n(new_0);
    return new_0;
  }
  function appendChainImpl($this, head, newTail, chainedSizeDelta) {
    var _tail = $this.b8e_1;
    if (_tail == null) {
      $this.a8e_1 = head;
      $this.g8e_1 = 0;
    } else {
      _tail.o8o(head);
      var tailPosition = $this.d8e_1;
      _tail.k8l(tailPosition);
      $this.g8e_1 = $this.g8e_1 + (tailPosition - $this.f8e_1 | 0) | 0;
    }
    $this.b8e_1 = newTail;
    $this.g8e_1 = $this.g8e_1 + chainedSizeDelta | 0;
    $this.c8e_1 = newTail.g8g_1;
    $this.d8e_1 = newTail.i8g_1;
    $this.f8e_1 = newTail.h8g_1;
    $this.e8e_1 = newTail.k8g_1;
  }
  function writeByteFallback($this, v) {
    appendNewChunk($this).x8l(v);
    $this.d8e_1 = $this.d8e_1 + 1 | 0;
  }
  function appendCharFallback($this, c) {
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.Output.write' call
      var buffer = $this.o8n(3);
      try {
        // Inline function 'io.ktor.utils.io.core.Output.appendCharFallback.<anonymous>' call
        var tmp1 = buffer.g8g_1;
        var tmp2 = buffer.i8g_1;
        // Inline function 'kotlin.code' call
        // Inline function 'io.ktor.utils.io.core.internal.putUtf8Char' call
        var v = Char__toInt_impl_vasixd(c);
        var tmp;
        if (0 <= v ? v <= 127 : false) {
          // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
          var value = toByte(v);
          tmp1.h8l_1.setInt8(tmp2, value);
          tmp = 1;
        } else if (128 <= v ? v <= 2047 : false) {
          // Inline function 'io.ktor.utils.io.bits.set' call
          var value_0 = toByte(192 | v >> 6 & 31);
          tmp1.h8l_1.setInt8(tmp2, value_0);
          var tmp7 = tmp2 + 1 | 0;
          // Inline function 'io.ktor.utils.io.bits.set' call
          var value_1 = toByte(128 | v & 63);
          tmp1.h8l_1.setInt8(tmp7, value_1);
          tmp = 2;
        } else if (2048 <= v ? v <= 65535 : false) {
          // Inline function 'io.ktor.utils.io.bits.set' call
          var value_2 = toByte(224 | v >> 12 & 15);
          tmp1.h8l_1.setInt8(tmp2, value_2);
          var tmp13 = tmp2 + 1 | 0;
          // Inline function 'io.ktor.utils.io.bits.set' call
          var value_3 = toByte(128 | v >> 6 & 63);
          tmp1.h8l_1.setInt8(tmp13, value_3);
          var tmp16 = tmp2 + 2 | 0;
          // Inline function 'io.ktor.utils.io.bits.set' call
          var value_4 = toByte(128 | v & 63);
          tmp1.h8l_1.setInt8(tmp16, value_4);
          tmp = 3;
        } else if (65536 <= v ? v <= 1114111 : false) {
          // Inline function 'io.ktor.utils.io.bits.set' call
          var value_5 = toByte(240 | v >> 18 & 7);
          tmp1.h8l_1.setInt8(tmp2, value_5);
          var tmp22 = tmp2 + 1 | 0;
          // Inline function 'io.ktor.utils.io.bits.set' call
          var value_6 = toByte(128 | v >> 12 & 63);
          tmp1.h8l_1.setInt8(tmp22, value_6);
          var tmp25 = tmp2 + 2 | 0;
          // Inline function 'io.ktor.utils.io.bits.set' call
          var value_7 = toByte(128 | v >> 6 & 63);
          tmp1.h8l_1.setInt8(tmp25, value_7);
          var tmp28 = tmp2 + 3 | 0;
          // Inline function 'io.ktor.utils.io.bits.set' call
          var value_8 = toByte(128 | v & 63);
          tmp1.h8l_1.setInt8(tmp28, value_8);
          tmp = 4;
        } else {
          malformedCodePoint(v);
        }
        var size = tmp;
        buffer.j8l(size);
        var result = size;
        // Inline function 'kotlin.check' call
        if (!(result >= 0)) {
          // Inline function 'io.ktor.utils.io.core.Output.write.<anonymous>' call
          var message = "The returned value shouldn't be negative";
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        break $l$block;
      }finally {
        $this.e8l();
      }
    }
  }
  function writePacketMerging($this, tail, foreignStolen, pool) {
    tail.k8l($this.d8e_1);
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var lastSize = tail.i8g_1 - tail.h8g_1 | 0;
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    var nextSize = foreignStolen.i8g_1 - foreignStolen.h8g_1 | 0;
    var maxCopySize = get_PACKET_MAX_COPY_SIZE();
    var tmp;
    var tmp_0;
    if (nextSize < maxCopySize) {
      // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
      var tmp_1 = tail.l8g_1 - tail.k8g_1 | 0;
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      tmp_0 = nextSize <= (tmp_1 + (tail.k8g_1 - tail.i8g_1 | 0) | 0);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = nextSize;
    } else {
      tmp = -1;
    }
    var appendSize = tmp;
    var tmp_2;
    if (lastSize < maxCopySize && lastSize <= foreignStolen.j8g_1 && isExclusivelyOwned(foreignStolen)) {
      tmp_2 = lastSize;
    } else {
      tmp_2 = -1;
    }
    var prependSize = tmp_2;
    if (appendSize === -1 && prependSize === -1) {
      $this.n8n(foreignStolen);
    } else if (prependSize === -1 || appendSize <= prependSize) {
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var tmp_3 = tail.k8g_1 - tail.i8g_1 | 0;
      // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
      var tmp$ret$5 = tail.l8g_1 - tail.k8g_1 | 0;
      writeBufferAppend(tail, foreignStolen, tmp_3 + tmp$ret$5 | 0);
      $this.e8l();
      var tmp0_safe_receiver = foreignStolen.f8n();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'io.ktor.utils.io.core.Output.writePacketMerging.<anonymous>' call
        $this.n8n(tmp0_safe_receiver);
      }
      foreignStolen.g8n(pool);
    } else if (appendSize === -1 || prependSize < appendSize) {
      writePacketSlowPrepend($this, foreignStolen, tail);
    } else {
      throw IllegalStateException_init_$Create$_0('prep = ' + prependSize + ', app = ' + appendSize);
    }
  }
  function writePacketSlowPrepend($this, foreignStolen, tail) {
    writeBufferPrepend(foreignStolen, tail);
    var tmp0_elvis_lhs = $this.a8e_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = "head should't be null since it is already handled in the fast-path";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var _head = tmp;
    if (_head === tail) {
      $this.a8e_1 = foreignStolen;
    } else {
      var pre = _head;
      $l$loop: while (true) {
        var next = ensureNotNull(pre.c17());
        if (next === tail)
          break $l$loop;
        pre = next;
      }
      pre.o8o(foreignStolen);
    }
    tail.g8n($this.z8d_1);
    $this.b8e_1 = findTail(foreignStolen);
  }
  function Output(pool) {
    this.z8d_1 = pool;
    this.a8e_1 = null;
    this.b8e_1 = null;
    this.c8e_1 = Companion_getInstance_134().p8o_1;
    this.d8e_1 = 0;
    this.e8e_1 = 0;
    this.f8e_1 = 0;
    this.g8e_1 = 0;
  }
  protoOf(Output).h8n = function () {
    return this.g8e_1 + (this.d8e_1 - this.f8e_1 | 0) | 0;
  };
  protoOf(Output).l8n = function () {
    var tmp0_elvis_lhs = this.a8e_1;
    return tmp0_elvis_lhs == null ? Companion_getInstance_132().v8j_1 : tmp0_elvis_lhs;
  };
  protoOf(Output).v9 = function () {
    flushChain(this);
  };
  protoOf(Output).h8e = function () {
    var tmp0_elvis_lhs = this.a8e_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var head = tmp;
    var tmp1_safe_receiver = this.b8e_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.k8l(this.d8e_1);
    this.a8e_1 = null;
    this.b8e_1 = null;
    this.d8e_1 = 0;
    this.e8e_1 = 0;
    this.f8e_1 = 0;
    this.g8e_1 = 0;
    this.c8e_1 = Companion_getInstance_134().p8o_1;
    return head;
  };
  protoOf(Output).m8n = function (buffer) {
    // Inline function 'kotlin.check' call
    if (!(buffer.c17() == null)) {
      // Inline function 'io.ktor.utils.io.core.Output.appendSingleChunk.<anonymous>' call
      var message = 'It should be a single buffer chunk.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    appendChainImpl(this, buffer, buffer, 0);
  };
  protoOf(Output).n8n = function (head) {
    var tail = findTail(head);
    var tmp1 = remainingAll(head);
    // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
    // Inline function 'kotlin.Long.minus' call
    var other = tail.i8g_1 - tail.h8g_1 | 0;
    var tmp3 = tmp1.j3(toLong(other));
    // Inline function 'io.ktor.utils.io.core.internal.toIntOrFail' call
    var name = 'total size increase';
    if (tmp3.d1(new Long(2147483647, 0)) >= 0) {
      failLongToIntConversion(tmp3, name);
    }
    var chainedSizeDelta = tmp3.z3();
    appendChainImpl(this, head, tail, chainedSizeDelta);
  };
  protoOf(Output).x8l = function (v) {
    var index = this.d8e_1;
    if (index < this.e8e_1) {
      this.d8e_1 = index + 1 | 0;
      // Inline function 'io.ktor.utils.io.bits.set' call
      this.c8e_1.h8l_1.setInt8(index, v);
      return Unit_instance;
    }
    return writeByteFallback(this, v);
  };
  protoOf(Output).up = function () {
    try {
      this.v9();
    }finally {
      this.i8n();
    }
  };
  protoOf(Output).e9 = function (value) {
    var tailPosition = this.d8e_1;
    if ((this.e8e_1 - tailPosition | 0) >= 3) {
      var tmp1 = this.c8e_1;
      // Inline function 'kotlin.code' call
      // Inline function 'io.ktor.utils.io.core.internal.putUtf8Char' call
      var v = Char__toInt_impl_vasixd(value);
      var tmp;
      if (0 <= v ? v <= 127 : false) {
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value_0 = toByte(v);
        tmp1.h8l_1.setInt8(tailPosition, value_0);
        tmp = 1;
      } else if (128 <= v ? v <= 2047 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_1 = toByte(192 | v >> 6 & 31);
        tmp1.h8l_1.setInt8(tailPosition, value_1);
        var tmp7 = tailPosition + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_2 = toByte(128 | v & 63);
        tmp1.h8l_1.setInt8(tmp7, value_2);
        tmp = 2;
      } else if (2048 <= v ? v <= 65535 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_3 = toByte(224 | v >> 12 & 15);
        tmp1.h8l_1.setInt8(tailPosition, value_3);
        var tmp13 = tailPosition + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_4 = toByte(128 | v >> 6 & 63);
        tmp1.h8l_1.setInt8(tmp13, value_4);
        var tmp16 = tailPosition + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_5 = toByte(128 | v & 63);
        tmp1.h8l_1.setInt8(tmp16, value_5);
        tmp = 3;
      } else if (65536 <= v ? v <= 1114111 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_6 = toByte(240 | v >> 18 & 7);
        tmp1.h8l_1.setInt8(tailPosition, value_6);
        var tmp22 = tailPosition + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_7 = toByte(128 | v >> 12 & 63);
        tmp1.h8l_1.setInt8(tmp22, value_7);
        var tmp25 = tailPosition + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_8 = toByte(128 | v >> 6 & 63);
        tmp1.h8l_1.setInt8(tmp25, value_8);
        var tmp28 = tailPosition + 3 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_9 = toByte(128 | v & 63);
        tmp1.h8l_1.setInt8(tmp28, value_9);
        tmp = 4;
      } else {
        malformedCodePoint(v);
      }
      var size = tmp;
      this.d8e_1 = tailPosition + size | 0;
      return this;
    }
    appendCharFallback(this, value);
    return this;
  };
  protoOf(Output).f = function (value) {
    if (value == null) {
      this.yc('null', 0, 4);
    } else {
      this.yc(value, 0, charSequenceLength(value));
    }
    return this;
  };
  protoOf(Output).yc = function (value, startIndex, endIndex) {
    if (value == null) {
      return this.yc('null', startIndex, endIndex);
    }
    writeText(this, value, startIndex, endIndex, Charsets_getInstance().q8o_1);
    return this;
  };
  protoOf(Output).k8k = function (packet) {
    var foreignStolen = packet.h8e();
    if (foreignStolen == null) {
      packet.vz();
      return Unit_instance;
    }
    var tail = this.b8e_1;
    if (tail == null) {
      this.n8n(foreignStolen);
      return Unit_instance;
    }
    writePacketMerging(this, tail, foreignStolen, packet.p8h_1);
  };
  protoOf(Output).i8e = function (chunkBuffer) {
    var _tail = this.b8e_1;
    if (_tail == null) {
      this.n8n(chunkBuffer);
      return Unit_instance;
    }
    writePacketMerging(this, _tail, chunkBuffer, this.z8d_1);
  };
  protoOf(Output).x8h = function (p, n) {
    var remaining = n;
    $l$loop: while (remaining.d1(new Long(0, 0)) > 0) {
      // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
      var tmp$ret$0 = p.t8h_1 - p.s8h_1 | 0;
      var headRemaining = toLong(tmp$ret$0);
      if (headRemaining.d1(remaining) <= 0) {
        remaining = remaining.j3(headRemaining);
        var tmp0_elvis_lhs = p.b8o();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw new EOFException('Unexpected end of packet');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        this.m8n(tmp);
      } else {
        // Inline function 'io.ktor.utils.io.core.read' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp0_elvis_lhs_0 = p.m8o(1);
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          prematureEndOfStream(1);
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        var buffer = tmp_0;
        var positionBefore = buffer.h8g_1;
        try {
          // Inline function 'io.ktor.utils.io.core.Output.writePacket.<anonymous>' call
          writeFully_2(this, buffer, remaining.z3());
        }finally {
          var positionAfter = buffer.h8g_1;
          if (positionAfter < positionBefore) {
            throw IllegalStateException_init_$Create$_0("Buffer's position shouldn't be rewinded");
          }
          if (positionAfter === buffer.i8g_1) {
            p.k8o(buffer);
          } else {
            p.s8h_1 = positionAfter;
          }
        }
        break $l$loop;
      }
    }
  };
  protoOf(Output).vz = function () {
    this.up();
  };
  protoOf(Output).o8n = function (n) {
    // Inline function 'io.ktor.utils.io.core.Output.tailRemaining' call
    if ((this.e8e_1 - this.d8e_1 | 0) >= n) {
      var tmp0_safe_receiver = this.b8e_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        tmp0_safe_receiver.k8l(this.d8e_1);
        return tmp0_safe_receiver;
      }
    }
    return appendNewChunk(this);
  };
  protoOf(Output).e8l = function () {
    var tmp0_safe_receiver = this.b8e_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'io.ktor.utils.io.core.Output.afterHeadWrite.<anonymous>' call
      this.d8e_1 = tmp0_safe_receiver.i8g_1;
    }
  };
  protoOf(Output).p8n = function () {
    var head = this.l8n();
    if (!(head === Companion_getInstance_132().v8j_1)) {
      // Inline function 'kotlin.check' call
      if (!(head.c17() == null)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      head.q8l();
      head.o8l(8);
      this.d8e_1 = head.i8g_1;
      this.f8e_1 = this.d8e_1;
      this.e8e_1 = head.k8g_1;
    }
  };
  function writeFully_2(_this__u8e3s4, src, length) {
    var tmp;
    if (length === VOID) {
      // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
      tmp = src.i8g_1 - src.h8g_1 | 0;
    } else {
      tmp = length;
    }
    length = tmp;
    // Inline function 'io.ktor.utils.io.core.writeFullyBytesTemplate' call
    var currentOffset = 0;
    var remaining = length;
    // Inline function 'io.ktor.utils.io.core.writeWhile' call
    var tail = prepareWriteHead(_this__u8e3s4, 1, null);
    try {
      $l$loop: while (true) {
        // Inline function 'io.ktor.utils.io.core.writeFullyBytesTemplate.<anonymous>' call
        var buffer = tail;
        var tmp1 = remaining;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        // Inline function 'kotlin.comparisons.minOf' call
        var b = buffer.k8g_1 - buffer.i8g_1 | 0;
        var size = Math.min(tmp1, b);
        // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
        writeFully_1(buffer, src, size);
        currentOffset = currentOffset + size | 0;
        remaining = remaining - size | 0;
        if (!(remaining > 0))
          break $l$loop;
        tail = prepareWriteHead(_this__u8e3s4, 1, tail);
      }
    }finally {
      _this__u8e3s4.e8l();
    }
  }
  function writeFully_3(_this__u8e3s4, src, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? src.length - offset | 0 : length;
    // Inline function 'io.ktor.utils.io.core.writeFullyBytesTemplate' call
    var currentOffset = offset;
    var remaining = length;
    // Inline function 'io.ktor.utils.io.core.writeWhile' call
    var tail = prepareWriteHead(_this__u8e3s4, 1, null);
    try {
      $l$loop: while (true) {
        // Inline function 'io.ktor.utils.io.core.writeFullyBytesTemplate.<anonymous>' call
        var buffer = tail;
        var tmp1 = remaining;
        // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
        // Inline function 'kotlin.comparisons.minOf' call
        var b = buffer.k8g_1 - buffer.i8g_1 | 0;
        var size = Math.min(tmp1, b);
        // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
        var currentOffset_0 = currentOffset;
        writeFully_0(buffer, src, currentOffset_0, size);
        currentOffset = currentOffset + size | 0;
        remaining = remaining - size | 0;
        if (!(remaining > 0))
          break $l$loop;
        tail = prepareWriteHead(_this__u8e3s4, 1, tail);
      }
    }finally {
      _this__u8e3s4.e8l();
    }
  }
  function writeShort_0(_this__u8e3s4, value) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.writePrimitiveTemplate' call
      var index = _this__u8e3s4.d8e_1;
      if ((_this__u8e3s4.e8e_1 - index | 0) > 2) {
        _this__u8e3s4.d8e_1 = index + 2 | 0;
        // Inline function 'io.ktor.utils.io.core.writeShort.<anonymous>' call
        // Inline function 'io.ktor.utils.io.bits.storeShortAt' call
        _this__u8e3s4.c8e_1.h8l_1.setInt16(index, value, false);
        tmp$ret$0 = true;
        break $l$block;
      }
      tmp$ret$0 = false;
    }
    if (!tmp$ret$0) {
      writeShortFallback(_this__u8e3s4, value);
    }
  }
  function writeShortFallback(_this__u8e3s4, value) {
    // Inline function 'io.ktor.utils.io.core.writePrimitiveFallbackTemplate' call
    var tail = _this__u8e3s4.o8n(2);
    // Inline function 'io.ktor.utils.io.core.writeShortFallback.<anonymous>' call
    writeShort(tail, value);
    _this__u8e3s4.e8l();
    if (!true) {
      // Inline function 'io.ktor.utils.io.bits.highByte' call
      var tmp$ret$1 = toByte(value >>> 8 | 0);
      _this__u8e3s4.x8l(tmp$ret$1);
      // Inline function 'io.ktor.utils.io.bits.lowByte' call
      var tmp$ret$2 = toByte(value & 255);
      _this__u8e3s4.x8l(tmp$ret$2);
    }
  }
  function readText(_this__u8e3s4, charset, max) {
    charset = charset === VOID ? Charsets_getInstance().q8o_1 : charset;
    max = max === VOID ? 2147483647 : max;
    return decode(charset.t8o(), _this__u8e3s4, max);
  }
  function readBytes(_this__u8e3s4, n) {
    var tmp;
    if (n === VOID) {
      var tmp0 = _this__u8e3s4.w8h();
      // Inline function 'io.ktor.utils.io.core.coerceAtMostMaxIntOrFail' call
      var message = 'Unable to convert to a ByteArray: packet is too big';
      if (tmp0.d1(new Long(2147483647, 0)) > 0)
        throw IllegalArgumentException_init_$Create$_0(message);
      tmp = tmp0.z3();
    } else {
      tmp = n;
    }
    n = tmp;
    var tmp_0;
    if (!(n === 0)) {
      // Inline function 'kotlin.also' call
      var this_0 = new Int8Array(n);
      // Inline function 'io.ktor.utils.io.core.readBytes.<anonymous>' call
      readFully_1(_this__u8e3s4, this_0, 0, n);
      tmp_0 = this_0;
    } else {
      tmp_0 = get_EmptyByteArray();
    }
    return tmp_0;
  }
  function prematureEndOfStream(size) {
    throw new EOFException('Premature end of stream: expected ' + size + ' bytes');
  }
  function readTextExactBytes(_this__u8e3s4, bytesCount, charset) {
    charset = charset === VOID ? Charsets_getInstance().q8o_1 : charset;
    return decodeExactBytes(charset.t8o(), _this__u8e3s4, bytesCount);
  }
  function writeText(_this__u8e3s4, text, fromIndex, toIndex, charset) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(text) : toIndex;
    charset = charset === VOID ? Charsets_getInstance().q8o_1 : charset;
    if (charset === Charsets_getInstance().q8o_1) {
      return writeTextUtf8(_this__u8e3s4, text, fromIndex, toIndex);
    }
    encodeToImpl(charset.u8o(), _this__u8e3s4, text, fromIndex, toIndex);
  }
  function writeTextUtf8(_this__u8e3s4, text, fromIndex, toIndex) {
    var index = fromIndex;
    // Inline function 'io.ktor.utils.io.core.writeWhileSize' call
    var tail = prepareWriteHead(_this__u8e3s4, 1, null);
    try {
      var size;
      $l$loop: while (true) {
        // Inline function 'io.ktor.utils.io.core.writeTextUtf8.<anonymous>' call
        var buffer = tail;
        var memory = buffer.g8g_1;
        var dstOffset = buffer.i8g_1;
        var dstLimit = buffer.k8g_1;
        var tmp0_container = encodeUTF8(memory, text, index, toIndex, dstOffset, dstLimit);
        var characters = EncodeResult__component1_impl_36tlhi(tmp0_container);
        var bytes = EncodeResult__component2_impl_3nv7vp(tmp0_container);
        var tmp = index;
        // Inline function 'kotlin.UShort.toInt' call
        index = tmp + (_UShort___get_data__impl__g0245(characters) & 65535) | 0;
        // Inline function 'kotlin.UShort.toInt' call
        var tmp$ret$1 = _UShort___get_data__impl__g0245(bytes) & 65535;
        buffer.j8l(tmp$ret$1);
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.UShort.toInt' call
        if ((_UShort___get_data__impl__g0245(characters) & 65535) === 0) {
          tmp_1 = index < toIndex;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = 8;
        } else {
          if (index < toIndex) {
            tmp_0 = 1;
          } else {
            tmp_0 = 0;
          }
        }
        size = tmp_0;
        if (size <= 0)
          break $l$loop;
        tail = prepareWriteHead(_this__u8e3s4, size, tail);
      }
    }finally {
      _this__u8e3s4.e8l();
    }
  }
  function ChunkBuffer$Companion$EmptyPool$1() {
  }
  protoOf(ChunkBuffer$Companion$EmptyPool$1).d8n = function () {
    return Companion_getInstance_132().v8j_1;
  };
  protoOf(ChunkBuffer$Companion$EmptyPool$1).v8o = function (instance) {
    // Inline function 'kotlin.require' call
    if (!(instance === Companion_getInstance_132().v8j_1)) {
      // Inline function 'io.ktor.utils.io.core.internal.<no name provided>.recycle.<anonymous>' call
      var message = 'Only ChunkBuffer.Empty instance could be recycled.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(ChunkBuffer$Companion$EmptyPool$1).e8n = function (instance) {
    return this.v8o(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  function ChunkBuffer$Companion$NoPool$1() {
    NoPoolImpl.call(this);
  }
  protoOf(ChunkBuffer$Companion$NoPool$1).d8n = function () {
    return new ChunkBuffer(DefaultAllocator_instance.f8m(4096), null, this);
  };
  protoOf(ChunkBuffer$Companion$NoPool$1).v8o = function (instance) {
    DefaultAllocator_instance.h8m(instance.g8g_1);
  };
  protoOf(ChunkBuffer$Companion$NoPool$1).e8n = function (instance) {
    return this.v8o(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  function ChunkBuffer$Companion$NoPoolManuallyManaged$1() {
    NoPoolImpl.call(this);
  }
  protoOf(ChunkBuffer$Companion$NoPoolManuallyManaged$1).d8n = function () {
    throw UnsupportedOperationException_init_$Create$_0("This pool doesn't support borrow");
  };
  protoOf(ChunkBuffer$Companion$NoPoolManuallyManaged$1).v8o = function (instance) {
  };
  protoOf(ChunkBuffer$Companion$NoPoolManuallyManaged$1).e8n = function (instance) {
    return this.v8o(instance instanceof ChunkBuffer ? instance : THROW_CCE());
  };
  function appendNext($this, chunk) {
    if (!$this.t8m_1.atomicfu$compareAndSet(null, chunk)) {
      throw IllegalStateException_init_$Create$_0('This chunk has already a next chunk.');
    }
  }
  function Companion_132() {
    Companion_instance_132 = this;
    var tmp = this;
    tmp.u8j_1 = new ChunkBuffer$Companion$EmptyPool$1();
    this.v8j_1 = new ChunkBuffer(Companion_getInstance_134().p8o_1, null, this.u8j_1);
    var tmp_0 = this;
    tmp_0.w8j_1 = new ChunkBuffer$Companion$NoPool$1();
    var tmp_1 = this;
    tmp_1.x8j_1 = new ChunkBuffer$Companion$NoPoolManuallyManaged$1();
  }
  protoOf(Companion_132).y8j = function () {
    return get_DefaultChunkedBufferPool();
  };
  var Companion_instance_132;
  function Companion_getInstance_132() {
    if (Companion_instance_132 == null)
      new Companion_132();
    return Companion_instance_132;
  }
  function ChunkBuffer(memory, origin, parentPool) {
    Companion_getInstance_132();
    Buffer.call(this, memory);
    this.s8m_1 = parentPool;
    // Inline function 'kotlin.require' call
    if (!!(origin === this)) {
      // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.<anonymous>' call
      var message = "A chunk couldn't be a view of itself.";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.t8m_1 = atomic$ref$1(null);
    this.u8m_1 = atomic$int$1(1);
    this.v8m_1 = origin;
  }
  protoOf(ChunkBuffer).o8o = function (newValue) {
    if (newValue == null) {
      this.f8n();
    } else {
      appendNext(this, newValue);
    }
  };
  protoOf(ChunkBuffer).c17 = function () {
    return this.t8m_1.kotlinx$atomicfu$value;
  };
  protoOf(ChunkBuffer).z8m = function () {
    return this.u8m_1.kotlinx$atomicfu$value;
  };
  protoOf(ChunkBuffer).f8n = function () {
    return this.t8m_1.atomicfu$getAndSet(null);
  };
  protoOf(ChunkBuffer).w8o = function () {
    var tmp0_elvis_lhs = this.v8m_1;
    // Inline function 'kotlin.let' call
    // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.duplicate.<anonymous>' call
    var newOrigin = tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
    newOrigin.x8o();
    // Inline function 'kotlin.also' call
    var this_0 = new ChunkBuffer(this.g8g_1, newOrigin, this.s8m_1);
    // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.duplicate.<anonymous>.<anonymous>' call
    this.v8l(this_0);
    return this_0;
  };
  protoOf(ChunkBuffer).g8n = function (pool) {
    if (this.y8o()) {
      var origin = this.v8m_1;
      if (!(origin == null)) {
        this.w8m();
        origin.g8n(pool);
      } else {
        var tmp0_elvis_lhs = this.s8m_1;
        var poolToUse = tmp0_elvis_lhs == null ? pool : tmp0_elvis_lhs;
        poolToUse.e8n(this);
      }
    }
  };
  protoOf(ChunkBuffer).w8m = function () {
    if (!this.u8m_1.atomicfu$compareAndSet(0, -1)) {
      throw IllegalStateException_init_$Create$_0('Unable to unlink: buffer is in use.');
    }
    this.f8n();
    this.v8m_1 = null;
  };
  protoOf(ChunkBuffer).x8o = function () {
    var tmp0 = this.u8m_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.acquire.<anonymous>' call
        if (cur <= 0)
          throw IllegalStateException_init_$Create$_0('Unable to acquire chunk: it is already released.');
        var upd = cur + 1 | 0;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
  };
  protoOf(ChunkBuffer).c8n = function () {
    var tmp0 = this.u8m_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.unpark.<anonymous>' call
        if (cur < 0) {
          throw IllegalStateException_init_$Create$_0("This instance is already disposed and couldn't be borrowed.");
        }
        if (cur > 0) {
          throw IllegalStateException_init_$Create$_0('This instance is already in use but somehow appeared in the pool.');
        }
        var upd = 1;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
  };
  protoOf(ChunkBuffer).y8o = function () {
    var tmp0 = this.u8m_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.release.<anonymous>' call
        if (cur <= 0)
          throw IllegalStateException_init_$Create$_0('Unable to release: it is already released.');
        var upd = cur - 1 | 0;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$1 = upd;
          break $l$block;
        }
      }
    }
    return tmp$ret$1 === 0;
  };
  protoOf(ChunkBuffer).a3j = function () {
    // Inline function 'kotlin.require' call
    if (!(this.v8m_1 == null)) {
      // Inline function 'io.ktor.utils.io.core.internal.ChunkBuffer.reset.<anonymous>' call
      var message = 'Unable to reset buffer with origin';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    protoOf(Buffer).a3j.call(this);
    this.t8m_1.kotlinx$atomicfu$value = null;
  };
  function isExclusivelyOwned(_this__u8e3s4) {
    return _this__u8e3s4.z8m() === 1;
  }
  function _EncodeResult___init__impl__vkc0cy(value) {
    return value;
  }
  function _EncodeResult___get_value__impl__h0r466($this) {
    return $this;
  }
  function _EncodeResult___init__impl__vkc0cy_0(characters, bytes) {
    // Inline function 'kotlin.UShort.toInt' call
    var tmp = (_UShort___get_data__impl__g0245(characters) & 65535) << 16;
    // Inline function 'kotlin.UShort.toInt' call
    var tmp$ret$1 = _UShort___get_data__impl__g0245(bytes) & 65535;
    return _EncodeResult___init__impl__vkc0cy(tmp | tmp$ret$1);
  }
  function _EncodeResult___get_characters__impl__rrxzcv($this) {
    // Inline function 'io.ktor.utils.io.bits.highShort' call
    var this_0 = _EncodeResult___get_value__impl__h0r466($this);
    // Inline function 'kotlin.toUShort' call
    var this_1 = toShort(this_0 >>> 16 | 0);
    return _UShort___init__impl__jigrne(this_1);
  }
  function _EncodeResult___get_bytes__impl__bt0kq0($this) {
    // Inline function 'io.ktor.utils.io.bits.lowShort' call
    var this_0 = _EncodeResult___get_value__impl__h0r466($this);
    // Inline function 'kotlin.toUShort' call
    var this_1 = toShort(this_0 & 65535);
    return _UShort___init__impl__jigrne(this_1);
  }
  function EncodeResult__component1_impl_36tlhi($this) {
    return _EncodeResult___get_characters__impl__rrxzcv($this);
  }
  function EncodeResult__component2_impl_3nv7vp($this) {
    return _EncodeResult___get_bytes__impl__bt0kq0($this);
  }
  function failLongToIntConversion(value, name) {
    throw IllegalArgumentException_init_$Create$_0('Long value ' + value.toString() + ' of ' + name + " doesn't fit into 32-bit integer");
  }
  function MalformedUTF8InputException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, MalformedUTF8InputException);
  }
  function malformedByteCount(byteCount) {
    throw new MalformedUTF8InputException('Expected ' + byteCount + ' more character bytes');
  }
  function isBmpCodePoint(cp) {
    return (cp >>> 16 | 0) === 0;
  }
  function isValidCodePoint(codePoint) {
    return codePoint <= 1114111;
  }
  function malformedCodePoint(value) {
    throw IllegalArgumentException_init_$Create$_0('Malformed code-point ' + value + ' found');
  }
  function highSurrogate(cp) {
    return (cp >>> 10 | 0) + 55232 | 0;
  }
  function lowSurrogate(cp) {
    return (cp & 1023) + 56320 | 0;
  }
  function encodeUTF8(_this__u8e3s4, text, from, to, dstOffset, dstLimit) {
    // Inline function 'kotlin.UShort.toInt' call
    var this_0 = _UShort___init__impl__jigrne(-1);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = from + (_UShort___get_data__impl__g0245(this_0) & 65535) | 0;
    var lastCharIndex = Math.min(to, b);
    // Inline function 'kotlin.UShort.toInt' call
    var this_1 = _UShort___init__impl__jigrne(-1);
    var tmp$ret$2 = _UShort___get_data__impl__g0245(this_1) & 65535;
    var resultLimit = coerceAtMost(dstLimit, tmp$ret$2);
    var resultPosition = dstOffset;
    var index = from;
    $l$loop: do {
      if (resultPosition >= resultLimit || index >= lastCharIndex) {
        // Inline function 'kotlin.toUShort' call
        var this_2 = index - from | 0;
        var tmp = _UShort___init__impl__jigrne(toShort(this_2));
        // Inline function 'kotlin.toUShort' call
        var this_3 = resultPosition - dstOffset | 0;
        var tmp$ret$4 = _UShort___init__impl__jigrne(toShort(this_3));
        return _EncodeResult___init__impl__vkc0cy_0(tmp, tmp$ret$4);
      }
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_4 = charSequenceGet(text, tmp0);
      var character = Char__toInt_impl_vasixd(this_4) & 65535;
      if ((character & 65408) === 0) {
        var tmp1 = resultPosition;
        resultPosition = tmp1 + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value = toByte(character);
        _this__u8e3s4.h8l_1.setInt8(tmp1, value);
      } else {
        break $l$loop;
      }
    }
     while (true);
    index = index - 1 | 0;
    return encodeUTF8Stage1(_this__u8e3s4, text, index, lastCharIndex, from, resultPosition, resultLimit, dstOffset);
  }
  function encodeUTF8Stage1(_this__u8e3s4, text, index1, lastCharIndex, from, resultPosition1, resultLimit, dstOffset) {
    var index = index1;
    var resultPosition = resultPosition1;
    var stage1Limit = resultLimit - 3 | 0;
    $l$loop: do {
      var freeSpace = stage1Limit - resultPosition | 0;
      if (freeSpace <= 0 || index >= lastCharIndex) {
        break $l$loop;
      }
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      var character = charSequenceGet(text, tmp0);
      var tmp;
      if (isHighSurrogate(character)) {
        var tmp_0;
        if (index === lastCharIndex || !isLowSurrogate(charSequenceGet(text, index))) {
          tmp_0 = 63;
        } else {
          var tmp1 = index;
          index = tmp1 + 1 | 0;
          tmp_0 = codePoint(character, charSequenceGet(text, tmp1));
        }
        tmp = tmp_0;
      } else {
        // Inline function 'kotlin.code' call
        tmp = Char__toInt_impl_vasixd(character);
      }
      var codepoint = tmp;
      // Inline function 'io.ktor.utils.io.core.internal.putUtf8Char' call
      var offset = resultPosition;
      var tmp_1;
      if (0 <= codepoint ? codepoint <= 127 : false) {
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value = toByte(codepoint);
        _this__u8e3s4.h8l_1.setInt8(offset, value);
        tmp_1 = 1;
      } else if (128 <= codepoint ? codepoint <= 2047 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_0 = toByte(192 | codepoint >> 6 & 31);
        _this__u8e3s4.h8l_1.setInt8(offset, value_0);
        var tmp7 = offset + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_1 = toByte(128 | codepoint & 63);
        _this__u8e3s4.h8l_1.setInt8(tmp7, value_1);
        tmp_1 = 2;
      } else if (2048 <= codepoint ? codepoint <= 65535 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_2 = toByte(224 | codepoint >> 12 & 15);
        _this__u8e3s4.h8l_1.setInt8(offset, value_2);
        var tmp13 = offset + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_3 = toByte(128 | codepoint >> 6 & 63);
        _this__u8e3s4.h8l_1.setInt8(tmp13, value_3);
        var tmp16 = offset + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_4 = toByte(128 | codepoint & 63);
        _this__u8e3s4.h8l_1.setInt8(tmp16, value_4);
        tmp_1 = 3;
      } else if (65536 <= codepoint ? codepoint <= 1114111 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_5 = toByte(240 | codepoint >> 18 & 7);
        _this__u8e3s4.h8l_1.setInt8(offset, value_5);
        var tmp22 = offset + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_6 = toByte(128 | codepoint >> 12 & 63);
        _this__u8e3s4.h8l_1.setInt8(tmp22, value_6);
        var tmp25 = offset + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_7 = toByte(128 | codepoint >> 6 & 63);
        _this__u8e3s4.h8l_1.setInt8(tmp25, value_7);
        var tmp28 = offset + 3 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_8 = toByte(128 | codepoint & 63);
        _this__u8e3s4.h8l_1.setInt8(tmp28, value_8);
        tmp_1 = 4;
      } else {
        malformedCodePoint(codepoint);
      }
      var size = tmp_1;
      resultPosition = resultPosition + size | 0;
    }
     while (true);
    if (resultPosition === stage1Limit) {
      return encodeUTF8Stage2(_this__u8e3s4, text, index, lastCharIndex, from, resultPosition, resultLimit, dstOffset);
    }
    // Inline function 'kotlin.toUShort' call
    var this_0 = index - from | 0;
    var tmp_2 = _UShort___init__impl__jigrne(toShort(this_0));
    // Inline function 'kotlin.toUShort' call
    var this_1 = resultPosition - dstOffset | 0;
    var tmp$ret$12 = _UShort___init__impl__jigrne(toShort(this_1));
    return _EncodeResult___init__impl__vkc0cy_0(tmp_2, tmp$ret$12);
  }
  function codePoint(high, low) {
    // Inline function 'kotlin.code' call
    var highValue = Char__toInt_impl_vasixd(high) - 55232 | 0;
    // Inline function 'kotlin.code' call
    var lowValue = Char__toInt_impl_vasixd(low) - 56320 | 0;
    return highValue << 10 | lowValue;
  }
  function encodeUTF8Stage2(_this__u8e3s4, text, index1, lastCharIndex, from, resultPosition1, resultLimit, dstOffset) {
    var index = index1;
    var resultPosition = resultPosition1;
    $l$loop_0: do {
      var freeSpace = resultLimit - resultPosition | 0;
      if (freeSpace <= 0 || index >= lastCharIndex) {
        break $l$loop_0;
      }
      var tmp0 = index;
      index = tmp0 + 1 | 0;
      var character = charSequenceGet(text, tmp0);
      var tmp;
      if (!isHighSurrogate(character)) {
        // Inline function 'kotlin.code' call
        tmp = Char__toInt_impl_vasixd(character);
      } else {
        var tmp_0;
        if (index === lastCharIndex || !isLowSurrogate(charSequenceGet(text, index))) {
          tmp_0 = 63;
        } else {
          var tmp1 = index;
          index = tmp1 + 1 | 0;
          tmp_0 = codePoint(character, charSequenceGet(text, tmp1));
        }
        tmp = tmp_0;
      }
      var codepoint = tmp;
      // Inline function 'io.ktor.utils.io.core.internal.charactersSize' call
      var tmp_1;
      if (1 <= codepoint ? codepoint <= 127 : false) {
        tmp_1 = 1;
      } else if (128 <= codepoint ? codepoint <= 2047 : false) {
        tmp_1 = 2;
      } else if (2048 <= codepoint ? codepoint <= 65535 : false) {
        tmp_1 = 3;
      } else if (65536 <= codepoint ? codepoint <= 1114111 : false) {
        tmp_1 = 4;
      } else {
        malformedCodePoint(codepoint);
      }
      if (tmp_1 > freeSpace) {
        index = index - 1 | 0;
        break $l$loop_0;
      }
      // Inline function 'io.ktor.utils.io.core.internal.putUtf8Char' call
      var offset = resultPosition;
      var tmp_2;
      if (0 <= codepoint ? codepoint <= 127 : false) {
        // Inline function 'io.ktor.utils.io.bits.Memory.storeAt' call
        var value = toByte(codepoint);
        _this__u8e3s4.h8l_1.setInt8(offset, value);
        tmp_2 = 1;
      } else if (128 <= codepoint ? codepoint <= 2047 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_0 = toByte(192 | codepoint >> 6 & 31);
        _this__u8e3s4.h8l_1.setInt8(offset, value_0);
        var tmp7 = offset + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_1 = toByte(128 | codepoint & 63);
        _this__u8e3s4.h8l_1.setInt8(tmp7, value_1);
        tmp_2 = 2;
      } else if (2048 <= codepoint ? codepoint <= 65535 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_2 = toByte(224 | codepoint >> 12 & 15);
        _this__u8e3s4.h8l_1.setInt8(offset, value_2);
        var tmp13 = offset + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_3 = toByte(128 | codepoint >> 6 & 63);
        _this__u8e3s4.h8l_1.setInt8(tmp13, value_3);
        var tmp16 = offset + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_4 = toByte(128 | codepoint & 63);
        _this__u8e3s4.h8l_1.setInt8(tmp16, value_4);
        tmp_2 = 3;
      } else if (65536 <= codepoint ? codepoint <= 1114111 : false) {
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_5 = toByte(240 | codepoint >> 18 & 7);
        _this__u8e3s4.h8l_1.setInt8(offset, value_5);
        var tmp22 = offset + 1 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_6 = toByte(128 | codepoint >> 12 & 63);
        _this__u8e3s4.h8l_1.setInt8(tmp22, value_6);
        var tmp25 = offset + 2 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_7 = toByte(128 | codepoint >> 6 & 63);
        _this__u8e3s4.h8l_1.setInt8(tmp25, value_7);
        var tmp28 = offset + 3 | 0;
        // Inline function 'io.ktor.utils.io.bits.set' call
        var value_8 = toByte(128 | codepoint & 63);
        _this__u8e3s4.h8l_1.setInt8(tmp28, value_8);
        tmp_2 = 4;
      } else {
        malformedCodePoint(codepoint);
      }
      var size = tmp_2;
      resultPosition = resultPosition + size | 0;
    }
     while (true);
    // Inline function 'kotlin.toUShort' call
    var this_0 = index - from | 0;
    var tmp_3 = _UShort___init__impl__jigrne(toShort(this_0));
    // Inline function 'kotlin.toUShort' call
    var this_1 = resultPosition - dstOffset | 0;
    var tmp$ret$13 = _UShort___init__impl__jigrne(toShort(this_1));
    return _EncodeResult___init__impl__vkc0cy_0(tmp_3, tmp$ret$13);
  }
  function get_EmptyByteArray() {
    _init_properties_Unsafe_kt__orlvcq();
    return EmptyByteArray;
  }
  var EmptyByteArray;
  function completeReadHead(_this__u8e3s4, current) {
    _init_properties_Unsafe_kt__orlvcq();
    if (current === _this__u8e3s4)
      return Unit_instance;
    else {
      // Inline function 'io.ktor.utils.io.core.canRead' call
      if (!(current.i8g_1 > current.h8g_1)) {
        _this__u8e3s4.k8o(current);
      } else {
        // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
        if ((current.l8g_1 - current.k8g_1 | 0) < 8) {
          _this__u8e3s4.l8o(current);
        } else {
          _this__u8e3s4.s8h_1 = current.h8g_1;
        }
      }
    }
  }
  function prepareReadFirstHead(_this__u8e3s4, minSize) {
    _init_properties_Unsafe_kt__orlvcq();
    return _this__u8e3s4.i8o(minSize);
  }
  function prepareReadNextHead(_this__u8e3s4, current) {
    _init_properties_Unsafe_kt__orlvcq();
    if (current === _this__u8e3s4) {
      return _this__u8e3s4.l8i() ? _this__u8e3s4 : null;
    }
    return _this__u8e3s4.j8o(current);
  }
  function unsafeAppend(_this__u8e3s4, builder) {
    _init_properties_Unsafe_kt__orlvcq();
    var builderSize = builder.n();
    var tmp0_elvis_lhs = builder.h8e();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return 0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var builderHead = tmp;
    if (builderSize <= get_PACKET_MAX_COPY_SIZE() && builderHead.c17() == null && _this__u8e3s4.d8o(builderHead)) {
      builder.p8n();
      return builderSize;
    }
    _this__u8e3s4.c8o(builderHead);
    return builderSize;
  }
  function prepareWriteHead(_this__u8e3s4, capacity, current) {
    _init_properties_Unsafe_kt__orlvcq();
    if (!(current == null)) {
      _this__u8e3s4.e8l();
    }
    return _this__u8e3s4.o8n(capacity);
  }
  var properties_initialized_Unsafe_kt_o5mw48;
  function _init_properties_Unsafe_kt__orlvcq() {
    if (!properties_initialized_Unsafe_kt_o5mw48) {
      properties_initialized_Unsafe_kt_o5mw48 = true;
      EmptyByteArray = new Int8Array(0);
    }
  }
  function trySuspend_1($this, sleepCondition, $completion) {
    var tmp = new $trySuspendCOROUTINE$53($this, sleepCondition, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function $sleepCOROUTINE$52(_this__u8e3s4, sleepCondition, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t8p_1 = _this__u8e3s4;
    this.u8p_1 = sleepCondition;
  }
  protoOf($sleepCOROUTINE$52).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = trySuspend_1(this.t8p_1, this.u8p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              return Unit_instance;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.t8p_1.q8d();
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $trySuspendCOROUTINE$53(_this__u8e3s4, sleepCondition, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h8p_1 = _this__u8e3s4;
    this.i8p_1 = sleepCondition;
  }
  protoOf($trySuspendCOROUTINE$53).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.j8p_1 = false;
            this.k8p_1 = Job_0();
            if (this.h8p_1.p8d_1.atomicfu$compareAndSet(null, this.k8p_1) && this.i8p_1()) {
              this.j8p_1 = true;
              this.y9_1 = 1;
              suspendResult = this.k8p_1.ku(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 1:
            this.y9_1 = 2;
            continue $sm;
          case 2:
            return this.j8p_1;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function AwaitingSlot() {
    this.p8d_1 = atomic$ref$1(null);
  }
  protoOf(AwaitingSlot).k8f = function (sleepCondition, $completion) {
    var tmp = new $sleepCOROUTINE$52(this, sleepCondition, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(AwaitingSlot).q8d = function () {
    var tmp0_safe_receiver = this.p8d_1.atomicfu$getAndSet(null);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.oz();
  };
  protoOf(AwaitingSlot).i8k = function (cause) {
    var tmp0_elvis_lhs = this.p8d_1.atomicfu$getAndSet(null);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var continuation = tmp;
    if (!(cause == null)) {
      continuation.nz(cause);
    } else {
      continuation.oz();
    }
  };
  function copyToSequentialImpl(_this__u8e3s4, dst, limit, $completion) {
    var tmp = new $copyToSequentialImplCOROUTINE$54(_this__u8e3s4, dst, limit, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function copyToTail(_this__u8e3s4, dst, limit, $completion) {
    var tmp = new $copyToTailCOROUTINE$55(_this__u8e3s4, dst, limit, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function $copyToSequentialImplCOROUTINE$54(_this__u8e3s4, dst, limit, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d8q_1 = _this__u8e3s4;
    this.e8q_1 = dst;
    this.f8q_1 = limit;
  }
  protoOf($copyToSequentialImplCOROUTINE$54).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 10;
            if (!!(this.d8q_1 === this.e8q_1)) {
              var message = 'Failed requirement.';
              throw IllegalArgumentException_init_$Create$_0(toString_1(message));
            }

            if (!(this.d8q_1.j8e() == null)) {
              this.e8q_1.g1c(this.d8q_1.j8e());
              return new Long(0, 0);
            }

            this.g8q_1 = this.f8q_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.g8q_1.d1(new Long(0, 0)) > 0)) {
              this.y9_1 = 9;
              continue $sm;
            }

            this.y9_1 = 2;
            suspendResult = this.d8q_1.h8k(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.h8q_1 = suspendResult;
            if (!this.h8q_1) {
              this.y9_1 = 9;
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            this.i8q_1 = this.d8q_1.j8k(this.e8q_1, this.g8q_1);
            if (this.i8q_1.equals(new Long(0, 0))) {
              this.y9_1 = 6;
              suspendResult = copyToTail(this.d8q_1, this.e8q_1, this.g8q_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (this.e8q_1.y8e() === 0) {
                this.y9_1 = 4;
                suspendResult = this.e8q_1.f8g(1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.y9_1 = 5;
                continue $sm;
              }
            }

          case 4:
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.j8q_1 = this.i8q_1;
            this.y9_1 = 8;
            continue $sm;
          case 6:
            var tail = suspendResult;
            if (tail.equals(new Long(0, 0))) {
              this.y9_1 = 9;
              continue $sm;
            } else {
              this.y9_1 = 7;
              continue $sm;
            }

          case 7:
            this.j8q_1 = tail;
            this.y9_1 = 8;
            continue $sm;
          case 8:
            var copied = this.j8q_1;
            this.g8q_1 = this.g8q_1.j3(copied);
            if (copied.d1(new Long(0, 0)) > 0) {
              this.e8q_1.v9();
            }

            this.y9_1 = 1;
            continue $sm;
          case 9:
            return this.f8q_1.j3(this.g8q_1);
          case 10:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 10) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $copyToTailCOROUTINE$55(_this__u8e3s4, dst, limit, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s8q_1 = _this__u8e3s4;
    this.t8q_1 = dst;
    this.u8q_1 = limit;
  }
  protoOf($copyToTailCOROUTINE$55).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 9;
            this.v8q_1 = Companion_getInstance_132().y8j().d8n();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.z9_1 = 8;
            this.v8q_1.r8l(coerceAtMost_0(this.u8q_1, toLong(this.v8q_1.l8g_1)).z3());
            this.y9_1 = 3;
            suspendResult = this.s8q_1.e8k(this.v8q_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.x8q_1 = suspendResult;
            if (this.x8q_1 === -1) {
              this.v8q_1.g8n(Companion_getInstance_132().y8j());
              this.w8q_1 = new Long(0, 0);
              this.z9_1 = 9;
              this.y9_1 = 6;
              continue $sm;
            } else {
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            this.y9_1 = 5;
            suspendResult = this.t8q_1.a8k(this.v8q_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.w8q_1 = toLong(this.x8q_1);
            this.z9_1 = 9;
            this.y9_1 = 6;
            var tmp_0 = this;
            continue $sm;
          case 6:
            var tmp_1 = this.w8q_1;
            this.z9_1 = 9;
            this.v8q_1.g8n(Companion_getInstance_132().y8j());
            return tmp_1;
          case 7:
            this.z9_1 = 9;
            this.v8q_1.g8n(Companion_getInstance_132().y8j());
            return Unit_instance;
          case 8:
            this.z9_1 = 9;
            var t = this.ba_1;
            this.v8q_1.g8n(Companion_getInstance_132().y8j());
            throw t;
          case 9:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 9) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function get_ByteArrayPool() {
    _init_properties_ByteArrayPool_kt__kfi3uj();
    return ByteArrayPool;
  }
  var ByteArrayPool;
  function ByteArrayPool$1() {
    DefaultPool.call(this, 128);
  }
  protoOf(ByteArrayPool$1).e8m = function () {
    return new Int8Array(4096);
  };
  var properties_initialized_ByteArrayPool_kt_td6pfh;
  function _init_properties_ByteArrayPool_kt__kfi3uj() {
    if (!properties_initialized_ByteArrayPool_kt_td6pfh) {
      properties_initialized_ByteArrayPool_kt_td6pfh = true;
      ByteArrayPool = new ByteArrayPool$1();
    }
  }
  function NoPoolImpl() {
  }
  protoOf(NoPoolImpl).e8n = function (instance) {
  };
  function ByteChannel(autoFlush) {
    autoFlush = autoFlush === VOID ? false : autoFlush;
    return new ByteChannelJS(Companion_getInstance_132().v8j_1, autoFlush);
  }
  function copyTo(_this__u8e3s4, dst, limit, $completion) {
    var tmp = _this__u8e3s4 instanceof ByteChannelSequentialBase ? _this__u8e3s4 : THROW_CCE();
    return copyToSequentialImpl(tmp, dst instanceof ByteChannelSequentialBase ? dst : THROW_CCE(), limit, $completion);
  }
  function ByteReadChannel_0(content, offset, length) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (content.length === 0)
      return Companion_getInstance_133().g8l();
    var head = Companion_getInstance_132().y8j().d8n();
    var tail = head;
    var start = offset;
    var end = start + length | 0;
    $l$loop: while (true) {
      tail.o8l(8);
      var tmp2 = end - start | 0;
      // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
      var this_0 = tail;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = this_0.k8g_1 - this_0.i8g_1 | 0;
      var size = Math.min(tmp2, b);
      writeFully_0(tail instanceof Buffer ? tail : THROW_CCE(), content, start, size);
      start = start + size | 0;
      if (start === end)
        break $l$loop;
      var current = tail;
      tail = Companion_getInstance_132().y8j().d8n();
      current.o8o(tail);
    }
    // Inline function 'kotlin.apply' call
    var this_1 = new ByteChannelJS(head, false);
    // Inline function 'io.ktor.utils.io.ByteReadChannel.<anonymous>' call
    close_0(this_1);
    return this_1;
  }
  function ByteChannelJS$attachJob$lambda(this$0) {
    return function (cause) {
      this$0.q8r_1 = null;
      var tmp;
      if (!(cause == null)) {
        this$0.my(unwrapCancellationException(cause));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ByteChannelJS(initial, autoFlush) {
    ByteChannelSequentialBase.call(this, initial, autoFlush);
    this.q8r_1 = null;
  }
  protoOf(ByteChannelJS).l8k = function (job) {
    var tmp0_safe_receiver = this.q8r_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.pu();
    }
    this.q8r_1 = job;
    job.ju(true, VOID, ByteChannelJS$attachJob$lambda(this));
  };
  protoOf(ByteChannelJS).toString = function () {
    return 'ByteChannel[' + toString_0(this.q8r_1) + ', ' + hashCode(this) + ']';
  };
  function ByteReadChannel$Companion$Empty$delegate$lambda() {
    // Inline function 'kotlin.apply' call
    var this_0 = new ByteChannelJS(Companion_getInstance_132().v8j_1, false);
    // Inline function 'io.ktor.utils.io.Companion.Empty$delegate.<anonymous>.<anonymous>' call
    this_0.g1c(null);
    return this_0;
  }
  function Companion_133() {
    Companion_instance_133 = this;
    var tmp = this;
    tmp.b8r_1 = lazy_0(ByteReadChannel$Companion$Empty$delegate$lambda);
  }
  protoOf(Companion_133).g8l = function () {
    var tmp0 = this.b8r_1;
    // Inline function 'kotlin.getValue' call
    Empty$factory();
    return tmp0.y();
  };
  var Companion_instance_133;
  function Companion_getInstance_133() {
    if (Companion_instance_133 == null)
      new Companion_133();
    return Companion_instance_133;
  }
  function ByteReadChannel_1() {
  }
  function Empty$factory() {
    return getPropertyCallableRef('Empty', 1, KProperty1, function (receiver) {
      return receiver.g8l();
    }, null);
  }
  function DefaultAllocator() {
  }
  protoOf(DefaultAllocator).f8m = function (size) {
    return new Memory(new DataView(new ArrayBuffer(size)));
  };
  protoOf(DefaultAllocator).h8m = function (instance) {
  };
  var DefaultAllocator_instance;
  function DefaultAllocator_getInstance() {
    return DefaultAllocator_instance;
  }
  function of(_this__u8e3s4, array, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? array.length - offset | 0 : length;
    // Inline function 'kotlin.js.asDynamic' call
    var typedArray = array;
    return of_0(Companion_getInstance_134(), typedArray, offset, length);
  }
  function of_0(_this__u8e3s4, view, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? view.byteLength : length;
    return of_1(Companion_getInstance_134(), view.buffer, view.byteOffset + offset | 0, length);
  }
  function of_1(_this__u8e3s4, buffer, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? buffer.byteLength - offset | 0 : length;
    return new Memory(new DataView(buffer, offset, length));
  }
  function Companion_134() {
    Companion_instance_134 = this;
    this.p8o_1 = new Memory(new DataView(new ArrayBuffer(0)));
  }
  var Companion_instance_134;
  function Companion_getInstance_134() {
    if (Companion_instance_134 == null)
      new Companion_134();
    return Companion_instance_134;
  }
  function Memory(view) {
    Companion_getInstance_134();
    this.h8l_1 = view;
  }
  protoOf(Memory).r8r = function (offset, length) {
    // Inline function 'kotlin.require' call
    if (!(offset >= 0)) {
      // Inline function 'io.ktor.utils.io.bits.Memory.slice.<anonymous>' call
      var message = "offset shouldn't be negative: " + offset;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!(length >= 0)) {
      // Inline function 'io.ktor.utils.io.bits.Memory.slice.<anonymous>' call
      var message_0 = "length shouldn't be negative: " + length;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var tmp = toLong(offset + length | 0);
    // Inline function 'io.ktor.utils.io.bits.Memory.size' call
    var tmp$ret$2 = toLong(this.h8l_1.byteLength);
    if (tmp.d1(tmp$ret$2) > 0) {
      // Inline function 'io.ktor.utils.io.bits.Memory.size' call
      var tmp$ret$3 = toLong(this.h8l_1.byteLength);
      throw IndexOutOfBoundsException_init_$Create$_0('offset + length > size: ' + offset + ' + ' + length + ' > ' + tmp$ret$3.toString());
    }
    return new Memory(new DataView(this.h8l_1.buffer, this.h8l_1.byteOffset + offset | 0, length));
  };
  protoOf(Memory).y8l = function (destination, offset, length, destinationOffset) {
    var src = new Int8Array(this.h8l_1.buffer, this.h8l_1.byteOffset + offset | 0, length);
    var dst = new Int8Array(destination.h8l_1.buffer, destination.h8l_1.byteOffset + destinationOffset | 0, length);
    dst.set(src);
  };
  function copyTo_0(_this__u8e3s4, destination, offset, length, destinationOffset) {
    copyTo_2(_this__u8e3s4.buffer, destination, offset + _this__u8e3s4.byteOffset | 0, length, destinationOffset);
  }
  function copyTo_1(_this__u8e3s4, destination, offset, length, destinationOffset) {
    // Inline function 'kotlin.js.asDynamic' call
    var to = destination;
    var from = new Int8Array(_this__u8e3s4.h8l_1.buffer, _this__u8e3s4.h8l_1.byteOffset + offset | 0, length);
    to.set(from, destinationOffset);
  }
  function copyTo_2(_this__u8e3s4, destination, offset, length, destinationOffset) {
    var from = new Int8Array(_this__u8e3s4, offset, length);
    var to = new Int8Array(destination.h8l_1.buffer, destination.h8l_1.byteOffset + destinationOffset | 0, length);
    to.set(from, 0);
  }
  function Companion_135() {
  }
  protoOf(Companion_135).s8r = function (name) {
    switch (name) {
      case 'UTF-8':
      case 'utf-8':
      case 'UTF8':
      case 'utf8':
        return Charsets_getInstance().q8o_1;
    }
    var tmp;
    var tmp_0;
    var tmp_1;
    switch (name) {
      case 'ISO-8859-1':
      case 'iso-8859-1':
        tmp_1 = true;
        break;
      default:
        // Inline function 'kotlin.let' call

        // Inline function 'io.ktor.utils.io.charsets.Companion.forName.<anonymous>' call

        var it = replace_0(name, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
        var tmp_2;
        if (it === 'iso-8859-1') {
          tmp_2 = true;
        } else {
          // Inline function 'kotlin.text.lowercase' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_2 = it.toLowerCase() === 'iso-8859-1';
        }

        tmp_1 = tmp_2;
        break;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = name === 'latin1';
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = name === 'Latin1';
    }
    if (tmp) {
      return Charsets_getInstance().r8o_1;
    }
    throw IllegalArgumentException_init_$Create$_0('Charset ' + name + ' is not supported');
  };
  protoOf(Companion_135).t8r = function (charset) {
    var tmp;
    switch (charset) {
      case 'UTF-8':
      case 'utf-8':
      case 'UTF8':
      case 'utf8':
        tmp = true;
        break;
      default:
        var tmp_0;
        var tmp_1;
        switch (charset) {
          case 'ISO-8859-1':
          case 'iso-8859-1':
            tmp_1 = true;
            break;
          default:
            // Inline function 'kotlin.let' call

            // Inline function 'io.ktor.utils.io.charsets.Companion.isSupported.<anonymous>' call

            var it = replace_0(charset, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
            var tmp_2;
            if (it === 'iso-8859-1') {
              tmp_2 = true;
            } else {
              // Inline function 'kotlin.text.lowercase' call
              // Inline function 'kotlin.js.asDynamic' call
              tmp_2 = it.toLowerCase() === 'iso-8859-1';
            }

            tmp_1 = tmp_2;
            break;
        }

        if (tmp_1) {
          tmp_0 = true;
        } else {
          tmp_0 = charset === 'latin1';
        }

        if (tmp_0) {
          tmp = true;
        } else {
          tmp = false;
        }

        break;
    }
    return tmp;
  };
  var Companion_instance_135;
  function Companion_getInstance_135() {
    return Companion_instance_135;
  }
  function Charset(_name) {
    this.s8o_1 = _name;
  }
  protoOf(Charset).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !(this.constructor == other.constructor))
      return false;
    if (!(other instanceof Charset))
      THROW_CCE();
    if (!(this.s8o_1 === other.s8o_1))
      return false;
    return true;
  };
  protoOf(Charset).hashCode = function () {
    return getStringHashCode(this.s8o_1);
  };
  protoOf(Charset).toString = function () {
    return this.s8o_1;
  };
  function get_name_6(_this__u8e3s4) {
    return _this__u8e3s4.s8o_1;
  }
  function Charsets() {
    Charsets_instance = this;
    this.q8o_1 = new CharsetImpl('UTF-8');
    this.r8o_1 = new CharsetImpl('ISO-8859-1');
  }
  var Charsets_instance;
  function Charsets_getInstance() {
    if (Charsets_instance == null)
      new Charsets();
    return Charsets_instance;
  }
  function MalformedInputException(message) {
    extendThrowable(this, message);
    captureStack(this, MalformedInputException);
  }
  function CharsetDecoder(_charset) {
    this.u8r_1 = _charset;
  }
  function encodeToByteArray_0(_this__u8e3s4, input, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
    return encodeToByteArrayImpl1(_this__u8e3s4, input, fromIndex, toIndex);
  }
  function CharsetEncoder(_charset) {
    this.v8r_1 = _charset;
  }
  function CharsetImpl(name) {
    Charset.call(this, name);
    this.x8r_1 = name;
  }
  protoOf(CharsetImpl).u8o = function () {
    return new CharsetEncoderImpl(this);
  };
  protoOf(CharsetImpl).t8o = function () {
    return new CharsetDecoderImpl(this);
  };
  protoOf(CharsetImpl).toString = function () {
    return 'CharsetImpl(name=' + this.x8r_1 + ')';
  };
  protoOf(CharsetImpl).hashCode = function () {
    return getStringHashCode(this.x8r_1);
  };
  protoOf(CharsetImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetImpl))
      return false;
    var tmp0_other_with_cast = other instanceof CharsetImpl ? other : THROW_CCE();
    if (!(this.x8r_1 === tmp0_other_with_cast.x8r_1))
      return false;
    return true;
  };
  function encodeToByteArrayImpl1(_this__u8e3s4, input, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
    var start = fromIndex;
    if (start >= toIndex)
      return get_EmptyByteArray();
    var single = Companion_getInstance_132().y8j().d8n();
    try {
      var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, single);
      start = start + rc | 0;
      if (start === toIndex) {
        // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
        var tmp$ret$0 = single.i8g_1 - single.h8g_1 | 0;
        var result = new Int8Array(tmp$ret$0);
        // Inline function 'io.ktor.utils.io.core.readFully' call
        var length = result.length - 0 | 0;
        readFully(single instanceof Buffer ? single : THROW_CCE(), result, 0, length);
        return result;
      }
      var tmp$ret$1;
      $l$block: {
        // Inline function 'io.ktor.utils.io.core.buildPacket' call
        // Inline function 'kotlin.contracts.contract' call
        var builder = new BytePacketBuilder();
        try {
          // Inline function 'io.ktor.utils.io.charsets.encodeToByteArrayImpl1.<anonymous>' call
          builder.m8n(single.w8o());
          encodeToImpl(_this__u8e3s4, builder, input, start, toIndex);
          tmp$ret$1 = builder.k2p();
          break $l$block;
        } catch ($p) {
          if ($p instanceof Error) {
            var t = $p;
            builder.vz();
            throw t;
          } else {
            throw $p;
          }
        }
      }
      return readBytes(tmp$ret$1);
    }finally {
      single.g8n(Companion_getInstance_132().y8j());
    }
  }
  function CharsetEncoderImpl(charset) {
    CharsetEncoder.call(this, charset);
    this.z8r_1 = charset;
  }
  protoOf(CharsetEncoderImpl).toString = function () {
    return 'CharsetEncoderImpl(charset=' + this.z8r_1.toString() + ')';
  };
  protoOf(CharsetEncoderImpl).hashCode = function () {
    return this.z8r_1.hashCode();
  };
  protoOf(CharsetEncoderImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetEncoderImpl))
      return false;
    var tmp0_other_with_cast = other instanceof CharsetEncoderImpl ? other : THROW_CCE();
    if (!this.z8r_1.equals(tmp0_other_with_cast.z8r_1))
      return false;
    return true;
  };
  function CharsetDecoderImpl(charset) {
    CharsetDecoder.call(this, charset);
    this.b8s_1 = charset;
  }
  protoOf(CharsetDecoderImpl).toString = function () {
    return 'CharsetDecoderImpl(charset=' + this.b8s_1.toString() + ')';
  };
  protoOf(CharsetDecoderImpl).hashCode = function () {
    return this.b8s_1.hashCode();
  };
  protoOf(CharsetDecoderImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetDecoderImpl))
      return false;
    var tmp0_other_with_cast = other instanceof CharsetDecoderImpl ? other : THROW_CCE();
    if (!this.b8s_1.equals(tmp0_other_with_cast.b8s_1))
      return false;
    return true;
  };
  function encodeImpl(_this__u8e3s4, input, fromIndex, toIndex, dst) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(fromIndex <= toIndex)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (get_charset(_this__u8e3s4).equals(Charsets_getInstance().r8o_1)) {
      return encodeISO88591(input, fromIndex, toIndex, dst);
    }
    // Inline function 'kotlin.require' call
    if (!(get_charset(_this__u8e3s4) === Charsets_getInstance().q8o_1)) {
      // Inline function 'io.ktor.utils.io.charsets.encodeImpl.<anonymous>' call
      var message_0 = 'Only UTF-8 encoding is supported in JS';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var encoder = new TextEncoder();
    var start = fromIndex;
    // Inline function 'io.ktor.utils.io.core.Buffer.writeRemaining' call
    var dstRemaining = dst.k8g_1 - dst.i8g_1 | 0;
    $l$loop: while (start < toIndex && dstRemaining > 0) {
      var tmp3 = toIndex - start | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = dstRemaining / 6 | 0;
      var tmp$ret$3 = Math.min(tmp3, b);
      var numChars = coerceAtLeast(tmp$ret$3, 1);
      var dropLastChar = isHighSurrogate(charSequenceGet(input, (start + numChars | 0) - 1 | 0));
      var endIndexExclusive = dropLastChar && numChars === 1 ? start + 2 | 0 : dropLastChar ? (start + numChars | 0) - 1 | 0 : start + numChars | 0;
      // Inline function 'kotlin.text.substring' call
      var startIndex = start;
      var tmp$ret$4 = toString_1(charSequenceSubSequence(input, startIndex, endIndexExclusive));
      var array1 = encoder.encode(tmp$ret$4);
      if (array1.length > dstRemaining)
        break $l$loop;
      writeFully_4(dst, array1);
      start = endIndexExclusive;
      dstRemaining = dstRemaining - array1.length | 0;
    }
    return start - fromIndex | 0;
  }
  function get_charset(_this__u8e3s4) {
    return _this__u8e3s4.v8r_1;
  }
  function decode_0(_this__u8e3s4, input, dst, max) {
    var decoder = Decoder_0(get_name_6(get_charset_0(_this__u8e3s4)), true);
    var charactersCopied = 0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.takeWhileSize' call
      var release = true;
      var tmp0_elvis_lhs = prepareReadFirstHead(input, 1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      var size = 1;
      try {
        $l$loop: do {
          // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
          var this_0 = current;
          var before = this_0.i8g_1 - this_0.h8g_1 | 0;
          var after;
          if (before >= size) {
            try {
              var tmp2 = current;
              var tmp$ret$3;
              $l$block_0: {
                // Inline function 'io.ktor.utils.io.charsets.decode.<anonymous>' call
                var rem = max - charactersCopied | 0;
                // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                var bufferSize = tmp2.i8g_1 - tmp2.h8g_1 | 0;
                if (rem < bufferSize) {
                  tmp$ret$3 = 0;
                  break $l$block_0;
                }
                // Inline function 'io.ktor.utils.io.core.readDirectInt8Array' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'io.ktor.utils.io.core.read' call
                // Inline function 'kotlin.contracts.contract' call
                var tmp1 = tmp2.g8g_1;
                var tmp2_0 = tmp2.h8g_1;
                // Inline function 'io.ktor.utils.io.core.readDirectInt8Array.<anonymous>' call
                var endExclusive = tmp2.i8g_1;
                // Inline function 'io.ktor.utils.io.charsets.decode.<anonymous>.<anonymous>' call
                var view = new Int8Array(tmp1.h8l_1.buffer, tmp1.h8l_1.byteOffset + tmp2_0 | 0, endExclusive - tmp2_0 | 0);
                $l$block_2: {
                  // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                  try {
                    // Inline function 'io.ktor.utils.io.charsets.decode.<anonymous>.<anonymous>.<anonymous>' call
                    var tmp$ret$4;
                    $l$block_1: {
                      // Inline function 'io.ktor.utils.io.js.decodeStream' call
                      // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                      try {
                        tmp$ret$4 = decoder.c8s(view, decodeOptions(true));
                        break $l$block_1;
                      } catch ($p) {
                        if ($p instanceof Error) {
                          var t = $p;
                          var tmp0_elvis_lhs_0 = t.message;
                          throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs_0 == null ? 'no cause provided' : tmp0_elvis_lhs_0));
                        } else {
                          throw $p;
                        }
                      }
                    }
                    break $l$block_2;
                  } catch ($p) {
                    if ($p instanceof Error) {
                      var t_0 = $p;
                      var tmp0_elvis_lhs_1 = t_0.message;
                      throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs_1 == null ? 'no cause provided' : tmp0_elvis_lhs_1));
                    } else {
                      throw $p;
                    }
                  }
                }
                var decodedText = tmp$ret$4;
                dst.f(decodedText);
                charactersCopied = charactersCopied + decodedText.length | 0;
                var rc = view.byteLength;
                tmp2.i8l(rc);
                var tmp_0;
                if (charactersCopied === max) {
                  var tmp_1;
                  try {
                    tmp_1 = decoder.d8s();
                  } catch ($p) {
                    var tmp_2;
                    var _ = $p;
                    tmp_2 = '';
                    tmp_1 = tmp_2;
                  }
                  var tail = tmp_1;
                  // Inline function 'kotlin.text.isNotEmpty' call
                  if (charSequenceLength(tail) > 0) {
                    tmp2.m8l(bufferSize);
                  }
                  tmp_0 = 0;
                } else if (charactersCopied < max) {
                  tmp_0 = 8;
                } else {
                  tmp_0 = 0;
                }
                tmp$ret$3 = tmp_0;
              }
              size = tmp$ret$3;
            }finally {
              // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
              var this_1 = current;
              after = this_1.i8g_1 - this_1.h8g_1 | 0;
            }
          } else {
            after = before;
          }
          release = false;
          var tmp_3;
          if (after === 0) {
            tmp_3 = prepareReadNextHead(input, current);
          } else {
            var tmp_4;
            if (after < size) {
              tmp_4 = true;
            } else {
              // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
              var this_2 = current;
              tmp_4 = (this_2.l8g_1 - this_2.k8g_1 | 0) < 8;
            }
            if (tmp_4) {
              completeReadHead(input, current);
              tmp_3 = prepareReadFirstHead(input, size);
            } else {
              tmp_3 = current;
            }
          }
          var tmp1_elvis_lhs = tmp_3;
          var tmp_5;
          if (tmp1_elvis_lhs == null) {
            break $l$loop;
          } else {
            tmp_5 = tmp1_elvis_lhs;
          }
          var next = tmp_5;
          current = next;
          release = true;
        }
         while (size > 0);
      }finally {
        if (release) {
          completeReadHead(input, current);
        }
      }
    }
    if (charactersCopied < max) {
      var size_0 = 1;
      $l$block_3: {
        // Inline function 'io.ktor.utils.io.core.takeWhileSize' call
        var release_0 = true;
        var tmp0_elvis_lhs_2 = prepareReadFirstHead(input, 1);
        var tmp_6;
        if (tmp0_elvis_lhs_2 == null) {
          break $l$block_3;
        } else {
          tmp_6 = tmp0_elvis_lhs_2;
        }
        var current_0 = tmp_6;
        var size_1 = 1;
        try {
          $l$loop_0: do {
            // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
            var this_3 = current_0;
            var before_0 = this_3.i8g_1 - this_3.h8g_1 | 0;
            var after_0;
            if (before_0 >= size_1) {
              try {
                // Inline function 'io.ktor.utils.io.charsets.decode.<anonymous>' call
                // Inline function 'io.ktor.utils.io.core.readDirectInt8Array' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'io.ktor.utils.io.core.read' call
                var this_4 = current_0;
                // Inline function 'kotlin.contracts.contract' call
                var tmp1_0 = this_4.g8g_1;
                var tmp2_1 = this_4.h8g_1;
                // Inline function 'io.ktor.utils.io.core.readDirectInt8Array.<anonymous>' call
                var endExclusive_0 = this_4.i8g_1;
                // Inline function 'io.ktor.utils.io.charsets.decode.<anonymous>.<anonymous>' call
                var view_0 = new Int8Array(tmp1_0.h8l_1.buffer, tmp1_0.h8l_1.byteOffset + tmp2_1 | 0, endExclusive_0 - tmp2_1 | 0);
                var result = decodeBufferImpl(view_0, decoder, max - charactersCopied | 0);
                dst.f(result.e8s_1);
                charactersCopied = charactersCopied + result.e8s_1.length | 0;
                var rc_0 = result.f8s_1;
                this_4.i8l(rc_0);
                var rc_1 = rc_0;
                if (rc_1 > 0)
                  size_0 = 1;
                else if (size_0 === 8)
                  size_0 = 0;
                else {
                  size_0 = size_0 + 1 | 0;
                }
                size_1 = size_0;
              }finally {
                // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                var this_5 = current_0;
                after_0 = this_5.i8g_1 - this_5.h8g_1 | 0;
              }
            } else {
              after_0 = before_0;
            }
            release_0 = false;
            var tmp_7;
            if (after_0 === 0) {
              tmp_7 = prepareReadNextHead(input, current_0);
            } else {
              var tmp_8;
              if (after_0 < size_1) {
                tmp_8 = true;
              } else {
                // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
                var this_6 = current_0;
                tmp_8 = (this_6.l8g_1 - this_6.k8g_1 | 0) < 8;
              }
              if (tmp_8) {
                completeReadHead(input, current_0);
                tmp_7 = prepareReadFirstHead(input, size_1);
              } else {
                tmp_7 = current_0;
              }
            }
            var tmp1_elvis_lhs_0 = tmp_7;
            var tmp_9;
            if (tmp1_elvis_lhs_0 == null) {
              break $l$loop_0;
            } else {
              tmp_9 = tmp1_elvis_lhs_0;
            }
            var next_0 = tmp_9;
            current_0 = next_0;
            release_0 = true;
          }
           while (size_1 > 0);
        }finally {
          if (release_0) {
            completeReadHead(input, current_0);
          }
        }
      }
    }
    return charactersCopied;
  }
  function encodeComplete(_this__u8e3s4, dst) {
    return true;
  }
  function decodeExactBytes(_this__u8e3s4, input, inputLength) {
    if (inputLength === 0)
      return '';
    // Inline function 'io.ktor.utils.io.core.Input.headRemaining' call
    if ((input.t8h_1 - input.s8h_1 | 0) >= inputLength) {
      var decoder = Decoder_0(get_charset_0(_this__u8e3s4).s8o_1, true);
      var head = input.l8n();
      var view = input.r8h_1.h8l_1;
      var tmp$ret$2;
      $l$block: {
        // Inline function 'io.ktor.utils.io.js.decodeWrap' call
        try {
          // Inline function 'io.ktor.utils.io.charsets.decodeExactBytes.<anonymous>' call
          var subView = head.h8g_1 === 0 && inputLength === view.byteLength ? view : new DataView(view.buffer, view.byteOffset + head.h8g_1 | 0, inputLength);
          tmp$ret$2 = decoder.g8s(subView);
          break $l$block;
        } catch ($p) {
          if ($p instanceof Error) {
            var t = $p;
            var tmp0_elvis_lhs = t.message;
            throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs == null ? 'no cause provided' : tmp0_elvis_lhs));
          } else {
            throw $p;
          }
        }
      }
      var text = tmp$ret$2;
      input.i8l(inputLength);
      return text;
    }
    return decodeExactBytesSlow(_this__u8e3s4, input, inputLength);
  }
  function get_charset_0(_this__u8e3s4) {
    return _this__u8e3s4.u8r_1;
  }
  function decodeExactBytesSlow(_this__u8e3s4, input, inputLength) {
    var decoder = Decoder_0(get_name_6(get_charset_0(_this__u8e3s4)), true);
    var inputRemaining = inputLength;
    var sb = StringBuilder_init_$Create$(inputLength);
    $l$block_4: {
      // Inline function 'io.ktor.utils.io.js.decodeWrap' call
      try {
        // Inline function 'io.ktor.utils.io.charsets.decodeExactBytesSlow.<anonymous>' call
        $l$block: {
          // Inline function 'io.ktor.utils.io.core.takeWhileSize' call
          var release = true;
          var tmp0_elvis_lhs = prepareReadFirstHead(input, 6);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            break $l$block;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var current = tmp;
          var size = 6;
          try {
            $l$loop: do {
              // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
              var this_0 = current;
              var before = this_0.i8g_1 - this_0.h8g_1 | 0;
              var after;
              if (before >= size) {
                try {
                  // Inline function 'io.ktor.utils.io.charsets.decodeExactBytesSlow.<anonymous>.<anonymous>' call
                  var buffer = current;
                  // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                  var chunkSize = buffer.i8g_1 - buffer.h8g_1 | 0;
                  // Inline function 'kotlin.comparisons.minOf' call
                  var b = inputRemaining;
                  var size_0 = Math.min(chunkSize, b);
                  var tmp_0;
                  if (buffer.h8g_1 === 0 && buffer.g8g_1.h8l_1.byteLength === size_0) {
                    var tmp4 = buffer.g8g_1.h8l_1;
                    var tmp$ret$4;
                    $l$block_0: {
                      // Inline function 'io.ktor.utils.io.js.decodeStream' call
                      // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                      try {
                        tmp$ret$4 = decoder.c8s(tmp4, decodeOptions(true));
                        break $l$block_0;
                      } catch ($p) {
                        if ($p instanceof Error) {
                          var t = $p;
                          var tmp0_elvis_lhs_0 = t.message;
                          throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs_0 == null ? 'no cause provided' : tmp0_elvis_lhs_0));
                        } else {
                          throw $p;
                        }
                      }
                    }
                    tmp_0 = tmp$ret$4;
                  } else {
                    var tmp7 = new Int8Array(buffer.g8g_1.h8l_1.buffer, buffer.g8g_1.h8l_1.byteOffset + buffer.h8g_1 | 0, size_0);
                    var tmp$ret$6;
                    $l$block_1: {
                      // Inline function 'io.ktor.utils.io.js.decodeStream' call
                      // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                      try {
                        tmp$ret$6 = decoder.c8s(tmp7, decodeOptions(true));
                        break $l$block_1;
                      } catch ($p) {
                        if ($p instanceof Error) {
                          var t_0 = $p;
                          var tmp0_elvis_lhs_1 = t_0.message;
                          throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs_1 == null ? 'no cause provided' : tmp0_elvis_lhs_1));
                        } else {
                          throw $p;
                        }
                      }
                    }
                    tmp_0 = tmp$ret$6;
                  }
                  var text = tmp_0;
                  sb.d9(text);
                  buffer.i8l(size_0);
                  inputRemaining = inputRemaining - size_0 | 0;
                  size = inputRemaining > 0 ? 6 : 0;
                }finally {
                  // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                  var this_1 = current;
                  after = this_1.i8g_1 - this_1.h8g_1 | 0;
                }
              } else {
                after = before;
              }
              release = false;
              var tmp_1;
              if (after === 0) {
                tmp_1 = prepareReadNextHead(input, current);
              } else {
                var tmp_2;
                if (after < size) {
                  tmp_2 = true;
                } else {
                  // Inline function 'io.ktor.utils.io.core.Buffer.endGap' call
                  var this_2 = current;
                  tmp_2 = (this_2.l8g_1 - this_2.k8g_1 | 0) < 8;
                }
                if (tmp_2) {
                  completeReadHead(input, current);
                  tmp_1 = prepareReadFirstHead(input, size);
                } else {
                  tmp_1 = current;
                }
              }
              var tmp1_elvis_lhs = tmp_1;
              var tmp_3;
              if (tmp1_elvis_lhs == null) {
                break $l$loop;
              } else {
                tmp_3 = tmp1_elvis_lhs;
              }
              var next = tmp_3;
              current = next;
              release = true;
            }
             while (size > 0);
          }finally {
            if (release) {
              completeReadHead(input, current);
            }
          }
        }
        if (inputRemaining > 0) {
          $l$block_2: {
            // Inline function 'io.ktor.utils.io.core.takeWhile' call
            var release_0 = true;
            var tmp0_elvis_lhs_2 = prepareReadFirstHead(input, 1);
            var tmp_4;
            if (tmp0_elvis_lhs_2 == null) {
              break $l$block_2;
            } else {
              tmp_4 = tmp0_elvis_lhs_2;
            }
            var current_0 = tmp_4;
            try {
              $l$loop_1: do {
                // Inline function 'io.ktor.utils.io.charsets.decodeExactBytesSlow.<anonymous>.<anonymous>' call
                var buffer_0 = current_0;
                // Inline function 'io.ktor.utils.io.core.Buffer.readRemaining' call
                var chunkSize_0 = buffer_0.i8g_1 - buffer_0.h8g_1 | 0;
                // Inline function 'kotlin.comparisons.minOf' call
                var b_0 = inputRemaining;
                var size_1 = Math.min(chunkSize_0, b_0);
                var tmp_5;
                if (buffer_0.h8g_1 === 0 && buffer_0.g8g_1.h8l_1.byteLength === size_1) {
                  tmp_5 = decoder.g8s(buffer_0.g8g_1.h8l_1);
                } else {
                  var tmp4_0 = new Int8Array(buffer_0.g8g_1.h8l_1.buffer, buffer_0.g8g_1.h8l_1.byteOffset + buffer_0.h8g_1 | 0, size_1);
                  var tmp$ret$14;
                  $l$block_3: {
                    // Inline function 'io.ktor.utils.io.js.decodeStream' call
                    // Inline function 'io.ktor.utils.io.js.decodeWrap' call
                    try {
                      tmp$ret$14 = decoder.c8s(tmp4_0, decodeOptions(true));
                      break $l$block_3;
                    } catch ($p) {
                      if ($p instanceof Error) {
                        var t_1 = $p;
                        var tmp0_elvis_lhs_3 = t_1.message;
                        throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs_3 == null ? 'no cause provided' : tmp0_elvis_lhs_3));
                      } else {
                        throw $p;
                      }
                    }
                  }
                  tmp_5 = tmp$ret$14;
                }
                var text_0 = tmp_5;
                sb.d9(text_0);
                buffer_0.i8l(size_1);
                inputRemaining = inputRemaining - size_1 | 0;
                if (!true) {
                  break $l$loop_1;
                }
                release_0 = false;
                var tmp1_elvis_lhs_0 = prepareReadNextHead(input, current_0);
                var tmp_6;
                if (tmp1_elvis_lhs_0 == null) {
                  break $l$loop_1;
                } else {
                  tmp_6 = tmp1_elvis_lhs_0;
                }
                var next_0 = tmp_6;
                current_0 = next_0;
                release_0 = true;
              }
               while (true);
            }finally {
              if (release_0) {
                completeReadHead(input, current_0);
              }
            }
          }
        }
        sb.d9(decoder.d8s());
        break $l$block_4;
      } catch ($p) {
        if ($p instanceof Error) {
          var t_2 = $p;
          var tmp0_elvis_lhs_4 = t_2.message;
          throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs_4 == null ? 'no cause provided' : tmp0_elvis_lhs_4));
        } else {
          throw $p;
        }
      }
    }
    if (inputRemaining > 0) {
      throw new EOFException('Not enough bytes available: had only ' + (inputLength - inputRemaining | 0) + ' instead of ' + inputLength);
    }
    return sb.toString();
  }
  function DecodeBufferResult(charactersDecoded, bytesConsumed) {
    this.e8s_1 = charactersDecoded;
    this.f8s_1 = bytesConsumed;
  }
  protoOf(DecodeBufferResult).toString = function () {
    return 'DecodeBufferResult(charactersDecoded=' + this.e8s_1 + ', bytesConsumed=' + this.f8s_1 + ')';
  };
  protoOf(DecodeBufferResult).hashCode = function () {
    var result = getStringHashCode(this.e8s_1);
    result = imul(result, 31) + this.f8s_1 | 0;
    return result;
  };
  protoOf(DecodeBufferResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DecodeBufferResult))
      return false;
    var tmp0_other_with_cast = other instanceof DecodeBufferResult ? other : THROW_CCE();
    if (!(this.e8s_1 === tmp0_other_with_cast.e8s_1))
      return false;
    if (!(this.f8s_1 === tmp0_other_with_cast.f8s_1))
      return false;
    return true;
  };
  function decodeBufferImpl(_this__u8e3s4, nativeDecoder, maxCharacters) {
    if (maxCharacters === 0) {
      return new DecodeBufferResult('', 0);
    }
    try {
      var sizeInBytes = coerceAtMost(maxCharacters, _this__u8e3s4.byteLength);
      var text = nativeDecoder.g8s(_this__u8e3s4.subarray(0, sizeInBytes));
      if (text.length <= maxCharacters) {
        return new DecodeBufferResult(text, sizeInBytes);
      }
    } catch ($p) {
      var _ = $p;
    }
    return decodeBufferImplSlow(_this__u8e3s4, nativeDecoder, maxCharacters);
  }
  function decodeBufferImplSlow(_this__u8e3s4, nativeDecoder, maxCharacters) {
    var maxBytes = coerceAtMost(maxCharacters >= 268435455 ? 2147483647 : imul(maxCharacters, 8), _this__u8e3s4.byteLength);
    var sizeInBytes = maxBytes;
    while (sizeInBytes > 8) {
      try {
        var text = nativeDecoder.g8s(_this__u8e3s4.subarray(0, sizeInBytes));
        if (text.length <= maxCharacters) {
          return new DecodeBufferResult(text, sizeInBytes);
        }
      } catch ($p) {
        var _ = $p;
      }
      sizeInBytes = sizeInBytes / 2 | 0;
    }
    sizeInBytes = 8;
    while (sizeInBytes > 0) {
      try {
        var text_0 = nativeDecoder.g8s(_this__u8e3s4.subarray(0, sizeInBytes));
        if (text_0.length <= maxCharacters) {
          return new DecodeBufferResult(text_0, sizeInBytes);
        }
      } catch ($p) {
        var __0 = $p;
      }
      sizeInBytes = sizeInBytes - 1 | 0;
    }
    $l$block: {
      // Inline function 'io.ktor.utils.io.js.decodeWrap' call
      try {
        // Inline function 'io.ktor.utils.io.charsets.decodeBufferImplSlow.<anonymous>' call
        nativeDecoder.g8s(_this__u8e3s4);
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          var tmp0_elvis_lhs = t.message;
          throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs == null ? 'no cause provided' : tmp0_elvis_lhs));
        } else {
          throw $p;
        }
      }
    }
    throw new MalformedInputException('Unable to decode buffer');
  }
  function encodeISO88591(input, fromIndex, toIndex, dst) {
    if (fromIndex >= toIndex)
      return 0;
    // Inline function 'io.ktor.utils.io.core.writeDirect' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.utils.io.core.write' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp1 = dst.g8g_1;
    var tmp2 = dst.i8g_1;
    // Inline function 'io.ktor.utils.io.core.writeDirect.<anonymous>' call
    var endExclusive = dst.k8g_1;
    // Inline function 'io.ktor.utils.io.charsets.encodeISO88591.<anonymous>' call
    var view = tmp1.r8r(tmp2, endExclusive - tmp2 | 0).h8l_1;
    var i8 = new Int8Array(view.buffer, view.byteOffset, view.byteLength);
    var writeIndex = 0;
    var inductionVariable = fromIndex;
    if (inductionVariable < toIndex)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charSequenceGet(input, index);
        var character = Char__toInt_impl_vasixd(this_0);
        if (character > 255) {
          failedToMapError(character);
        }
        var tmp1_0 = writeIndex;
        writeIndex = tmp1_0 + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        i8[tmp1_0] = toByte(character);
      }
       while (inductionVariable < toIndex);
    var rc = writeIndex;
    dst.j8l(rc);
    return toIndex - fromIndex | 0;
  }
  function failedToMapError(ch) {
    throw new MalformedInputException('The character with unicode point ' + ch + " couldn't be mapped to ISO-8859-1 character");
  }
  function writeFully_4(_this__u8e3s4, src, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? src.byteLength - offset | 0 : length;
    // Inline function 'io.ktor.utils.io.core.write' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp1 = _this__u8e3s4.g8g_1;
    var tmp2 = _this__u8e3s4.i8g_1;
    // Inline function 'io.ktor.utils.io.core.writeFully.<anonymous>' call
    if ((_this__u8e3s4.k8g_1 - tmp2 | 0) < length) {
      throw new InsufficientSpaceException('Not enough free space to write ' + length + ' bytes');
    }
    copyTo_0(src, tmp1, offset, length, tmp2);
    var rc = length;
    _this__u8e3s4.j8l(rc);
  }
  function get_PACKET_MAX_COPY_SIZE() {
    return PACKET_MAX_COPY_SIZE;
  }
  var PACKET_MAX_COPY_SIZE;
  function String_0(bytes, offset, length, charset) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? bytes.length : length;
    charset = charset === VOID ? Charsets_getInstance().q8o_1 : charset;
    if (offset < 0 || length < 0 || (offset + length | 0) > bytes.length) {
      checkIndices(offset, length, bytes);
    }
    // Inline function 'kotlin.js.asDynamic' call
    var i8 = bytes;
    var bufferOffset = i8.byteOffset + offset | 0;
    var buffer = i8.buffer.slice(bufferOffset, bufferOffset + length | 0);
    var view = new ChunkBuffer(of_1(Companion_getInstance_134(), buffer), null, Companion_getInstance_132().w8j_1);
    view.p8l();
    var packet = ByteReadPacket_init_$Create$(view, Companion_getInstance_132().x8j_1);
    return decode(charset.t8o(), packet, 2147483647);
  }
  function checkIndices(offset, length, bytes) {
    // Inline function 'kotlin.require' call
    if (!(offset >= 0)) {
      throw IndexOutOfBoundsException_init_$Create$_0('offset (' + offset + ") shouldn't be negative");
    }
    // Inline function 'kotlin.require' call
    if (!(length >= 0)) {
      throw IndexOutOfBoundsException_init_$Create$_0('length (' + length + ") shouldn't be negative");
    }
    // Inline function 'kotlin.require' call
    if (!((offset + length | 0) <= bytes.length)) {
      throw IndexOutOfBoundsException_init_$Create$_0('offset (' + offset + ') + length (' + length + ') > bytes.size (' + bytes.length + ')');
    }
    throw IndexOutOfBoundsException_init_$Create$();
  }
  function EOFException(message) {
    IOException_init_$Init$(message, this);
    captureStack(this, EOFException);
  }
  function IOException_init_$Init$(message, $this) {
    IOException.call($this, message, null);
    return $this;
  }
  function IOException_init_$Create$(message) {
    var tmp = IOException_init_$Init$(message, objectCreate(protoOf(IOException)));
    captureStack(tmp, IOException_init_$Create$);
    return tmp;
  }
  function IOException(message, cause) {
    Exception_init_$Init$_1(message, cause, this);
    captureStack(this, IOException);
  }
  function Decoder_0(encoding, fatal) {
    fatal = fatal === VOID ? true : fatal;
    var tmp;
    try {
      tmp = toKtor(new TextDecoder(encoding, textDecoderOptions(fatal)));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var cause = $p;
        tmp_0 = new TextDecoderFallback(encoding, fatal);
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function decodeOptions(stream) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Object();
    // Inline function 'io.ktor.utils.io.js.decodeOptions.<anonymous>' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.with' call
    // Inline function 'io.ktor.utils.io.js.decodeOptions.<anonymous>.<anonymous>' call
    this_0.stream = stream;
    return this_0;
  }
  function toKtor(_this__u8e3s4) {
    return new toKtor$1(_this__u8e3s4);
  }
  function textDecoderOptions(fatal) {
    fatal = fatal === VOID ? false : fatal;
    // Inline function 'kotlin.apply' call
    var this_0 = new Object();
    // Inline function 'io.ktor.utils.io.js.textDecoderOptions.<anonymous>' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.with' call
    // Inline function 'io.ktor.utils.io.js.textDecoderOptions.<anonymous>.<anonymous>' call
    this_0.fatal = fatal;
    return this_0;
  }
  function toKtor$1($this_toKtor) {
    this.h8s_1 = $this_toKtor;
  }
  protoOf(toKtor$1).d8s = function () {
    return this.h8s_1.decode();
  };
  protoOf(toKtor$1).g8s = function (buffer) {
    return this.h8s_1.decode(buffer);
  };
  protoOf(toKtor$1).c8s = function (buffer, options) {
    return this.h8s_1.decode(buffer, options);
  };
  function get_ENCODING_ALIASES() {
    _init_properties_TextDecoderFallback_kt__nrrftl();
    return ENCODING_ALIASES;
  }
  var ENCODING_ALIASES;
  function get_REPLACEMENT() {
    _init_properties_TextDecoderFallback_kt__nrrftl();
    return REPLACEMENT;
  }
  var REPLACEMENT;
  function TextDecoderFallback(encoding, fatal) {
    this.i8s_1 = fatal;
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var requestedEncoding = toString_1(trim(isCharSequence(encoding) ? encoding : THROW_CCE())).toLowerCase();
    // Inline function 'kotlin.check' call
    if (!get_ENCODING_ALIASES().s(requestedEncoding)) {
      // Inline function 'io.ktor.utils.io.js.TextDecoderFallback.<anonymous>' call
      var message = encoding + ' is not supported.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(TextDecoderFallback).d8s = function () {
    return '';
  };
  protoOf(TextDecoderFallback).g8s = function (buffer) {
    var tmp$ret$3;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.buildPacket' call
      // Inline function 'kotlin.contracts.contract' call
      var builder = new BytePacketBuilder();
      try {
        // Inline function 'io.ktor.utils.io.js.TextDecoderFallback.decode.<anonymous>' call
        var bytes = buffer instanceof Int8Array ? buffer : THROW_CCE();
        var inductionVariable = 0;
        var last = bytes.length;
        if (inductionVariable < last)
          $l$loop: do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'org.khronos.webgl.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var byte = bytes[index];
            var point = toCodePoint(byte);
            if (point < 0) {
              // Inline function 'kotlin.check' call
              if (!!this.i8s_1) {
                // Inline function 'io.ktor.utils.io.js.TextDecoderFallback.decode.<anonymous>.<anonymous>' call
                var message = 'Invalid character: ' + point;
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              }
              writeFully_3(builder, get_REPLACEMENT());
              continue $l$loop;
            }
            if (point > 255) {
              builder.x8l(toByte(point >> 8));
            }
            builder.x8l(toByte(point & 255));
          }
           while (inductionVariable < last);
        tmp$ret$3 = builder.k2p();
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          builder.vz();
          throw t;
        } else {
          throw $p;
        }
      }
    }
    return decodeToString(readBytes(tmp$ret$3));
  };
  protoOf(TextDecoderFallback).c8s = function (buffer, options) {
    return this.g8s(buffer);
  };
  function toCodePoint(_this__u8e3s4) {
    _init_properties_TextDecoderFallback_kt__nrrftl();
    var value = _this__u8e3s4 & 255;
    if (isASCII(value)) {
      return value;
    }
    return get_WIN1252_TABLE()[value - 128 | 0];
  }
  function isASCII(_this__u8e3s4) {
    _init_properties_TextDecoderFallback_kt__nrrftl();
    return 0 <= _this__u8e3s4 ? _this__u8e3s4 <= 127 : false;
  }
  var properties_initialized_TextDecoderFallback_kt_7y92ax;
  function _init_properties_TextDecoderFallback_kt__nrrftl() {
    if (!properties_initialized_TextDecoderFallback_kt_7y92ax) {
      properties_initialized_TextDecoderFallback_kt_7y92ax = true;
      ENCODING_ALIASES = setOf_0(['ansi_x3.4-1968', 'ascii', 'cp1252', 'cp819', 'csisolatin1', 'ibm819', 'iso-8859-1', 'iso-ir-100', 'iso8859-1', 'iso88591', 'iso_8859-1', 'iso_8859-1:1987', 'l1', 'latin1', 'us-ascii', 'windows-1252', 'x-cp1252']);
      // Inline function 'kotlin.byteArrayOf' call
      REPLACEMENT = new Int8Array([-17, -65, -67]);
    }
  }
  function get_WIN1252_TABLE() {
    _init_properties_Win1252Table_kt__tl0v64();
    return WIN1252_TABLE;
  }
  var WIN1252_TABLE;
  var properties_initialized_Win1252Table_kt_pkmjoq;
  function _init_properties_Win1252Table_kt__tl0v64() {
    if (!properties_initialized_Win1252Table_kt_pkmjoq) {
      properties_initialized_Win1252Table_kt_pkmjoq = true;
      // Inline function 'kotlin.intArrayOf' call
      WIN1252_TABLE = new Int32Array([8364, -1, 8218, 402, 8222, 8230, 8224, 8225, 710, 8240, 352, 8249, 338, -1, 381, -1, -1, 8216, 8217, 8220, 8221, 8226, 8211, 8212, 732, 8482, 353, 8250, 339, -1, 382, 376, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255]);
    }
  }
  function DefaultPool(capacity) {
    this.i8m_1 = capacity;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.i8m_1;
    tmp.j8m_1 = fillArrayVal(Array(size), null);
    this.k8m_1 = 0;
  }
  protoOf(DefaultPool).l8m = function (instance) {
  };
  protoOf(DefaultPool).b8n = function (instance) {
    return instance;
  };
  protoOf(DefaultPool).y8m = function (instance) {
  };
  protoOf(DefaultPool).d8n = function () {
    if (this.k8m_1 === 0)
      return this.e8m();
    this.k8m_1 = this.k8m_1 - 1 | 0;
    var idx = this.k8m_1;
    var tmp = this.j8m_1[idx];
    var instance = !(tmp == null) ? tmp : THROW_CCE();
    this.j8m_1[idx] = null;
    return this.b8n(instance);
  };
  protoOf(DefaultPool).e8n = function (instance) {
    this.y8m(instance);
    if (this.k8m_1 === this.i8m_1) {
      this.l8m(instance);
    } else {
      var tmp1 = this.k8m_1;
      this.k8m_1 = tmp1 + 1 | 0;
      this.j8m_1[tmp1] = instance;
    }
  };
  function AttributeKey(name) {
    this.j8s_1 = name;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = this.j8s_1;
    if (charSequenceLength(this_0) === 0) {
      throw IllegalStateException_init_$Create$_0("Name can't be blank");
    }
  }
  protoOf(AttributeKey).toString = function () {
    return 'AttributeKey: ' + this.j8s_1;
  };
  protoOf(AttributeKey).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof AttributeKey))
      THROW_CCE();
    if (!(this.j8s_1 === other.j8s_1))
      return false;
    return true;
  };
  protoOf(AttributeKey).hashCode = function () {
    return getStringHashCode(this.j8s_1);
  };
  function Attributes() {
  }
  function putAll_1(_this__u8e3s4, other) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = other.q8s().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.util.putAll.<anonymous>' call
      _this__u8e3s4.n8s(element instanceof AttributeKey ? element : THROW_CCE(), other.k8s(element));
    }
  }
  var BASE64_INVERSE_ALPHABET;
  function encodeBase64(_this__u8e3s4) {
    _init_properties_Base64_kt__ymmsz3();
    var array = _this__u8e3s4;
    var position = 0;
    var writeOffset = 0;
    var charArray_0 = charArray((imul(_this__u8e3s4.length, 8) / 6 | 0) + 3 | 0);
    while ((position + 3 | 0) <= array.length) {
      var first = array[position];
      var second = array[position + 1 | 0];
      var third = array[position + 2 | 0];
      position = position + 3 | 0;
      var chunk = (first & 255) << 16 | (second & 255) << 8 | third & 255;
      var inductionVariable = 3;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var char = chunk >> imul(6, index) & 63;
          var tmp1 = writeOffset;
          writeOffset = tmp1 + 1 | 0;
          // Inline function 'io.ktor.util.toBase64' call
          charArray_0[tmp1] = charSequenceGet(access$_get_BASE64_ALPHABET_$tBase64Kt_i8vdt6(), char);
        }
         while (0 <= inductionVariable);
    }
    var remaining = array.length - position | 0;
    if (remaining === 0)
      return concatToString_0(charArray_0, 0, writeOffset);
    var tmp;
    if (remaining === 1) {
      tmp = (array[position] & 255) << 16 | 0 | 0;
    } else {
      tmp = (array[position] & 255) << 16 | (array[position + 1 | 0] & 255) << 8 | 0;
    }
    var chunk_0 = tmp;
    var padSize = imul(3 - remaining | 0, 8) / 6 | 0;
    var inductionVariable_0 = 3;
    if (padSize <= inductionVariable_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + -1 | 0;
        var char_0 = chunk_0 >> imul(6, index_0) & 63;
        var tmp3 = writeOffset;
        writeOffset = tmp3 + 1 | 0;
        // Inline function 'io.ktor.util.toBase64' call
        charArray_0[tmp3] = charSequenceGet(access$_get_BASE64_ALPHABET_$tBase64Kt_i8vdt6(), char_0);
      }
       while (!(index_0 === padSize));
    // Inline function 'kotlin.repeat' call
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < padSize)
      do {
        var index_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'io.ktor.util.encodeBase64.<anonymous>' call
        var tmp0 = writeOffset;
        writeOffset = tmp0 + 1 | 0;
        charArray_0[tmp0] = _Char___init__impl__6a9atx(61);
      }
       while (inductionVariable_1 < padSize);
    return concatToString_0(charArray_0, 0, writeOffset);
  }
  function access$_get_BASE64_ALPHABET_$tBase64Kt_i8vdt6() {
    return 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  }
  var properties_initialized_Base64_kt_5g824v;
  function _init_properties_Base64_kt__ymmsz3() {
    if (!properties_initialized_Base64_kt_5g824v) {
      properties_initialized_Base64_kt_5g824v = true;
      var tmp = 0;
      var tmp_0 = new Int32Array(256);
      while (tmp < 256) {
        var tmp_1 = tmp;
        tmp_0[tmp_1] = indexOf_8('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', numberToChar(tmp_1));
        tmp = tmp + 1 | 0;
      }
      BASE64_INVERSE_ALPHABET = tmp_0;
    }
  }
  function toByteArray(_this__u8e3s4, $completion) {
    var tmp = new $toByteArrayCOROUTINE$0(_this__u8e3s4, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function $toByteArrayCOROUTINE$0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z8s_1 = _this__u8e3s4;
  }
  protoOf($toByteArrayCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.z8s_1.d8k(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return readBytes(ARGUMENT);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj($this$$receiver) {
    return $this$$receiver.a8t_1;
  }
  function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0($this$$receiver) {
    return caseInsensitive($this$$receiver);
  }
  function CaseInsensitiveMap$_get_entries_$lambda_r32w19($this$$receiver) {
    return new Entry_2($this$$receiver.x().a8t_1, $this$$receiver.y());
  }
  function CaseInsensitiveMap$_get_entries_$lambda_r32w19_0($this$$receiver) {
    return new Entry_2(caseInsensitive($this$$receiver.x()), $this$$receiver.y());
  }
  function CaseInsensitiveMap() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.c8t_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(CaseInsensitiveMap).n = function () {
    return this.c8t_1.n();
  };
  protoOf(CaseInsensitiveMap).j67 = function (key) {
    return this.c8t_1.w2(new CaseInsensitiveString(key));
  };
  protoOf(CaseInsensitiveMap).w2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.j67((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).d8t = function (value) {
    return this.c8t_1.x2(value);
  };
  protoOf(CaseInsensitiveMap).x2 = function (value) {
    if (!!(value == null))
      return false;
    return this.d8t(!(value == null) ? value : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).fe = function (key) {
    return this.c8t_1.y2(caseInsensitive(key));
  };
  protoOf(CaseInsensitiveMap).y2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.fe((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).p = function () {
    return this.c8t_1.p();
  };
  protoOf(CaseInsensitiveMap).m2 = function () {
    this.c8t_1.m2();
  };
  protoOf(CaseInsensitiveMap).e8t = function (key, value) {
    return this.c8t_1.r2(caseInsensitive(key), value);
  };
  protoOf(CaseInsensitiveMap).r2 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.e8t(tmp, !(value == null) ? value : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).f8t = function (from) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = from.w().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.util.CaseInsensitiveMap.putAll.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.x();
      // Inline function 'kotlin.collections.component2' call
      var value = element.y();
      this.e8t(key, value);
    }
  };
  protoOf(CaseInsensitiveMap).t2 = function (from) {
    return this.f8t(from);
  };
  protoOf(CaseInsensitiveMap).g8t = function (key) {
    return this.c8t_1.s2(caseInsensitive(key));
  };
  protoOf(CaseInsensitiveMap).s2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.g8t((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveMap).u2 = function () {
    var tmp = this.c8t_1.u2();
    var tmp_0 = CaseInsensitiveMap$_get_keys_$lambda_ptzlqj;
    return new DelegatingMutableSet(tmp, tmp_0, CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0);
  };
  protoOf(CaseInsensitiveMap).w = function () {
    var tmp = this.c8t_1.w();
    var tmp_0 = CaseInsensitiveMap$_get_entries_$lambda_r32w19;
    return new DelegatingMutableSet(tmp, tmp_0, CaseInsensitiveMap$_get_entries_$lambda_r32w19_0);
  };
  protoOf(CaseInsensitiveMap).v2 = function () {
    return this.c8t_1.v2();
  };
  protoOf(CaseInsensitiveMap).equals = function (other) {
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(other instanceof CaseInsensitiveMap);
    }
    if (tmp)
      return false;
    return equals(other.c8t_1, this.c8t_1);
  };
  protoOf(CaseInsensitiveMap).hashCode = function () {
    return hashCode(this.c8t_1);
  };
  function Entry_2(key, value) {
    this.h8t_1 = key;
    this.i8t_1 = value;
  }
  protoOf(Entry_2).x = function () {
    return this.h8t_1;
  };
  protoOf(Entry_2).y = function () {
    return this.i8t_1;
  };
  protoOf(Entry_2).hashCode = function () {
    return (527 + hashCode(ensureNotNull(this.h8t_1)) | 0) + hashCode(ensureNotNull(this.i8t_1)) | 0;
  };
  protoOf(Entry_2).equals = function (other) {
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(!(other == null) ? isInterface(other, Entry) : false);
    }
    if (tmp)
      return false;
    return equals(other.x(), this.h8t_1) && equals(other.y(), this.i8t_1);
  };
  protoOf(Entry_2).toString = function () {
    return toString_0(this.h8t_1) + '=' + toString_0(this.i8t_1);
  };
  function toCharArray(_this__u8e3s4) {
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.length;
    var tmp_1 = charArray(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = charSequenceGet(_this__u8e3s4, tmp_2);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  }
  function isLowerCase_0(_this__u8e3s4) {
    // Inline function 'kotlin.text.lowercaseChar' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2 = toString(_this__u8e3s4).toLowerCase();
    return charSequenceGet(tmp$ret$2, 0) === _this__u8e3s4;
  }
  function caseInsensitiveMap() {
    return new CaseInsensitiveMap();
  }
  function SilentSupervisor(parent) {
    parent = parent === VOID ? null : parent;
    var tmp = SupervisorJob(parent);
    // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
    var tmp$ret$0 = new SilentSupervisor$$inlined$CoroutineExceptionHandler$1();
    return tmp.ej(tmp$ret$0);
  }
  function SilentSupervisor$$inlined$CoroutineExceptionHandler$1() {
    AbstractCoroutineContextElement.call(this, Key_instance_1);
  }
  protoOf(SilentSupervisor$$inlined$CoroutineExceptionHandler$1).wz = function (context, exception) {
    // Inline function 'io.ktor.util.SilentSupervisor.<anonymous>' call
    return Unit_instance;
  };
  function get_digits() {
    _init_properties_Crypto_kt__txayzl();
    return digits;
  }
  var digits;
  function generateNonce(size) {
    _init_properties_Crypto_kt__txayzl();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.buildPacket' call
      // Inline function 'kotlin.contracts.contract' call
      var builder = new BytePacketBuilder();
      try {
        // Inline function 'io.ktor.util.generateNonce.<anonymous>' call
        while (builder.n() < size) {
          writeText(builder, generateNonce_0());
        }
        tmp$ret$0 = builder.k2p();
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          builder.vz();
          throw t;
        } else {
          throw $p;
        }
      }
    }
    return readBytes(tmp$ret$0, size);
  }
  function hex(bytes) {
    _init_properties_Crypto_kt__txayzl();
    var result = charArray(imul(bytes.length, 2));
    var resultIndex = 0;
    var digits = get_digits();
    var inductionVariable = 0;
    var last = bytes.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var b = bytes[index] & 255;
        var tmp1 = resultIndex;
        resultIndex = tmp1 + 1 | 0;
        result[tmp1] = digits[b >> 4];
        var tmp2 = resultIndex;
        resultIndex = tmp2 + 1 | 0;
        result[tmp2] = digits[b & 15];
      }
       while (inductionVariable < last);
    return concatToString(result);
  }
  var properties_initialized_Crypto_kt_8g5vqb;
  function _init_properties_Crypto_kt__txayzl() {
    if (!properties_initialized_Crypto_kt_8g5vqb) {
      properties_initialized_Crypto_kt_8g5vqb = true;
      digits = toCharArray('0123456789abcdef');
    }
  }
  function DelegatingMutableSet$iterator$1(this$0) {
    this.l8t_1 = this$0;
    this.k8t_1 = this$0.m8t_1.k();
  }
  protoOf(DelegatingMutableSet$iterator$1).l = function () {
    return this.k8t_1.l();
  };
  protoOf(DelegatingMutableSet$iterator$1).m = function () {
    return this.l8t_1.n8t_1(this.k8t_1.m());
  };
  protoOf(DelegatingMutableSet$iterator$1).b5 = function () {
    return this.k8t_1.b5();
  };
  function DelegatingMutableSet(delegate, convertTo, convert) {
    this.m8t_1 = delegate;
    this.n8t_1 = convertTo;
    this.o8t_1 = convert;
    this.p8t_1 = this.m8t_1.n();
  }
  protoOf(DelegatingMutableSet).q8t = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this__u8e3s4, 10));
    var _iterator__ex2g4s = _this__u8e3s4.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.util.DelegatingMutableSet.convert.<anonymous>' call
      var tmp$ret$0 = this.o8t_1(item);
      destination.e(tmp$ret$0);
    }
    return destination;
  };
  protoOf(DelegatingMutableSet).r8t = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this__u8e3s4, 10));
    var _iterator__ex2g4s = _this__u8e3s4.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.util.DelegatingMutableSet.convertTo.<anonymous>' call
      var tmp$ret$0 = this.n8t_1(item);
      destination.e(tmp$ret$0);
    }
    return destination;
  };
  protoOf(DelegatingMutableSet).n = function () {
    return this.p8t_1;
  };
  protoOf(DelegatingMutableSet).s8t = function (element) {
    return this.m8t_1.e(this.o8t_1(element));
  };
  protoOf(DelegatingMutableSet).e = function (element) {
    return this.s8t((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(DelegatingMutableSet).t8t = function (elements) {
    return this.m8t_1.o(this.q8t(elements));
  };
  protoOf(DelegatingMutableSet).o = function (elements) {
    return this.t8t(elements);
  };
  protoOf(DelegatingMutableSet).m2 = function () {
    this.m8t_1.m2();
  };
  protoOf(DelegatingMutableSet).u8t = function (element) {
    return this.m8t_1.k2(this.o8t_1(element));
  };
  protoOf(DelegatingMutableSet).k2 = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.u8t((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(DelegatingMutableSet).v8t = function (elements) {
    return this.m8t_1.k1(this.q8t(elements));
  };
  protoOf(DelegatingMutableSet).k1 = function (elements) {
    return this.v8t(elements);
  };
  protoOf(DelegatingMutableSet).w8t = function (elements) {
    return this.m8t_1.l2(this.q8t(elements));
  };
  protoOf(DelegatingMutableSet).l2 = function (elements) {
    return this.w8t(elements);
  };
  protoOf(DelegatingMutableSet).x8t = function (element) {
    return this.m8t_1.s(this.o8t_1(element));
  };
  protoOf(DelegatingMutableSet).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.x8t((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(DelegatingMutableSet).y8t = function (elements) {
    return this.m8t_1.h2(this.q8t(elements));
  };
  protoOf(DelegatingMutableSet).h2 = function (elements) {
    return this.y8t(elements);
  };
  protoOf(DelegatingMutableSet).p = function () {
    return this.m8t_1.p();
  };
  protoOf(DelegatingMutableSet).k = function () {
    return new DelegatingMutableSet$iterator$1(this);
  };
  protoOf(DelegatingMutableSet).hashCode = function () {
    return hashCode(this.m8t_1);
  };
  protoOf(DelegatingMutableSet).equals = function (other) {
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(!(other == null) ? isInterface(other, KtSet) : false);
    }
    if (tmp)
      return false;
    var elements = this.r8t(this.m8t_1);
    var tmp_0;
    if (other.h2(elements)) {
      // Inline function 'kotlin.collections.containsAll' call
      tmp_0 = elements.h2(other);
    } else {
      tmp_0 = false;
    }
    return tmp_0;
  };
  protoOf(DelegatingMutableSet).toString = function () {
    return toString_1(this.r8t(this.m8t_1));
  };
  var Platform_Jvm_instance;
  var Platform_Native_instance;
  var Platform_Browser_instance;
  var Platform_Node_instance;
  var Platform_entriesInitialized_0;
  function Platform_initEntries_0() {
    if (Platform_entriesInitialized_0)
      return Unit_instance;
    Platform_entriesInitialized_0 = true;
    Platform_Jvm_instance = new Platform_0('Jvm', 0);
    Platform_Native_instance = new Platform_0('Native', 1);
    Platform_Browser_instance = new Platform_0('Browser', 2);
    Platform_Node_instance = new Platform_0('Node', 3);
  }
  function Platform_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PlatformUtils() {
    PlatformUtils_instance = this;
    this.z8t_1 = get_platform(this).equals(Platform_Browser_getInstance());
    this.a8u_1 = get_platform(this).equals(Platform_Node_getInstance());
    this.b8u_1 = get_platform(this).equals(Platform_Jvm_getInstance());
    this.c8u_1 = get_platform(this).equals(Platform_Native_getInstance());
    this.d8u_1 = get_isDevelopmentMode(this);
    this.e8u_1 = get_isNewMemoryModel(this);
  }
  var PlatformUtils_instance;
  function PlatformUtils_getInstance() {
    if (PlatformUtils_instance == null)
      new PlatformUtils();
    return PlatformUtils_instance;
  }
  function Platform_Jvm_getInstance() {
    Platform_initEntries_0();
    return Platform_Jvm_instance;
  }
  function Platform_Native_getInstance() {
    Platform_initEntries_0();
    return Platform_Native_instance;
  }
  function Platform_Browser_getInstance() {
    Platform_initEntries_0();
    return Platform_Browser_instance;
  }
  function Platform_Node_getInstance() {
    Platform_initEntries_0();
    return Platform_Node_instance;
  }
  function StringValues() {
  }
  function ensureListForKey($this, name) {
    var tmp0_elvis_lhs = $this.l8u_1.y2(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.mutableListOf' call
      // Inline function 'kotlin.also' call
      var this_0 = ArrayList_init_$Create$();
      // Inline function 'io.ktor.util.StringValuesBuilderImpl.ensureListForKey.<anonymous>' call
      $this.m8u(name);
      // Inline function 'kotlin.collections.set' call
      $this.l8u_1.r2(name, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function StringValuesBuilderImpl$appendAll$lambda(this$0) {
    return function (name, values) {
      this$0.n8u(name, values);
      return Unit_instance;
    };
  }
  function StringValuesBuilderImpl(caseInsensitiveName, size) {
    caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
    size = size === VOID ? 8 : size;
    this.k8u_1 = caseInsensitiveName;
    this.l8u_1 = this.k8u_1 ? caseInsensitiveMap() : LinkedHashMap_init_$Create$_0(size);
  }
  protoOf(StringValuesBuilderImpl).f8u = function () {
    return this.k8u_1;
  };
  protoOf(StringValuesBuilderImpl).g8u = function (name) {
    return this.l8u_1.y2(name);
  };
  protoOf(StringValuesBuilderImpl).o8u = function (name, value) {
    var tmp0_safe_receiver = this.l8u_1.y2(name);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s(value);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(StringValuesBuilderImpl).h8u = function () {
    return this.l8u_1.u2();
  };
  protoOf(StringValuesBuilderImpl).p = function () {
    return this.l8u_1.p();
  };
  protoOf(StringValuesBuilderImpl).i8u = function () {
    return unmodifiable(this.l8u_1.w());
  };
  protoOf(StringValuesBuilderImpl).p8u = function (name, value) {
    this.q8u(value);
    var list = ensureListForKey(this, name);
    list.m2();
    list.e(value);
  };
  protoOf(StringValuesBuilderImpl).fe = function (name) {
    var tmp0_safe_receiver = this.g8u(name);
    return tmp0_safe_receiver == null ? null : firstOrNull_0(tmp0_safe_receiver);
  };
  protoOf(StringValuesBuilderImpl).r8u = function (name, value) {
    this.q8u(value);
    ensureListForKey(this, name).e(value);
  };
  protoOf(StringValuesBuilderImpl).s8u = function (stringValues) {
    stringValues.j8u(StringValuesBuilderImpl$appendAll$lambda(this));
  };
  protoOf(StringValuesBuilderImpl).n8u = function (name, values) {
    // Inline function 'kotlin.let' call
    // Inline function 'io.ktor.util.StringValuesBuilderImpl.appendAll.<anonymous>' call
    var list = ensureListForKey(this, name);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = values.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.util.StringValuesBuilderImpl.appendAll.<anonymous>.<anonymous>' call
      this.q8u(element);
      list.e(element);
    }
  };
  protoOf(StringValuesBuilderImpl).t8u = function (name) {
    this.l8u_1.s2(name);
  };
  protoOf(StringValuesBuilderImpl).m2 = function () {
    this.l8u_1.m2();
  };
  protoOf(StringValuesBuilderImpl).m8u = function (name) {
  };
  protoOf(StringValuesBuilderImpl).q8u = function (value) {
  };
  function listForKey($this, name) {
    return $this.v8u_1.y2(name);
  }
  function StringValuesImpl(caseInsensitiveName, values) {
    caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
    values = values === VOID ? emptyMap() : values;
    this.u8u_1 = caseInsensitiveName;
    var tmp;
    if (this.u8u_1) {
      tmp = caseInsensitiveMap();
    } else {
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp = LinkedHashMap_init_$Create$();
    }
    var newMap = tmp;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = values.w().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.util.StringValuesImpl.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.x();
      // Inline function 'kotlin.collections.component2' call
      var value = element.y();
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size = value.n();
      var list = ArrayList_init_$Create$_0(size);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < size)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.collections.MutableList.<anonymous>' call
          // Inline function 'io.ktor.util.StringValuesImpl.<anonymous>.<anonymous>' call
          var tmp$ret$4 = value.q(index);
          list.e(tmp$ret$4);
        }
         while (inductionVariable < size);
      // Inline function 'kotlin.collections.set' call
      newMap.r2(key, list);
    }
    this.v8u_1 = newMap;
  }
  protoOf(StringValuesImpl).f8u = function () {
    return this.u8u_1;
  };
  protoOf(StringValuesImpl).fe = function (name) {
    var tmp0_safe_receiver = listForKey(this, name);
    return tmp0_safe_receiver == null ? null : firstOrNull_0(tmp0_safe_receiver);
  };
  protoOf(StringValuesImpl).g8u = function (name) {
    return listForKey(this, name);
  };
  protoOf(StringValuesImpl).h8u = function () {
    return unmodifiable(this.v8u_1.u2());
  };
  protoOf(StringValuesImpl).p = function () {
    return this.v8u_1.p();
  };
  protoOf(StringValuesImpl).i8u = function () {
    return unmodifiable(this.v8u_1.w());
  };
  protoOf(StringValuesImpl).j8u = function (body) {
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.v8u_1.w().k();
    while (tmp0_iterator.l()) {
      var tmp1_loop_parameter = tmp0_iterator.m();
      // Inline function 'kotlin.collections.component1' call
      var key = tmp1_loop_parameter.x();
      // Inline function 'kotlin.collections.component2' call
      var value = tmp1_loop_parameter.y();
      body(key, value);
    }
  };
  protoOf(StringValuesImpl).toString = function () {
    return 'StringValues(case=' + !this.u8u_1 + ') ' + toString_1(this.i8u());
  };
  protoOf(StringValuesImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(!(other == null) ? isInterface(other, StringValues) : false))
      return false;
    if (!(this.u8u_1 === other.f8u()))
      return false;
    return entriesEquals(this.i8u(), other.i8u());
  };
  protoOf(StringValuesImpl).hashCode = function () {
    return entriesHashCode(this.i8u(), imul(31, getBooleanHashCode(this.u8u_1)));
  };
  function appendAll(_this__u8e3s4, builder) {
    // Inline function 'kotlin.apply' call
    // Inline function 'io.ktor.util.appendAll.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = builder.i8u().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.util.appendAll.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var name = element.x();
      // Inline function 'kotlin.collections.component2' call
      var values = element.y();
      _this__u8e3s4.n8u(name, values);
    }
    return _this__u8e3s4;
  }
  function entriesEquals(a, b) {
    return equals(a, b);
  }
  function entriesHashCode(entries, seed) {
    return imul(seed, 31) + hashCode(entries) | 0;
  }
  function toLowerCasePreservingASCIIRules(_this__u8e3s4) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.indexOfFirst' call
      var inductionVariable = 0;
      var last = charSequenceLength(_this__u8e3s4) - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'io.ktor.util.toLowerCasePreservingASCIIRules.<anonymous>' call
          var it = charSequenceGet(_this__u8e3s4, index);
          if (!(toLowerCasePreservingASCII(it) === it)) {
            tmp$ret$1 = index;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$1 = -1;
    }
    var firstIndex = tmp$ret$1;
    if (firstIndex === -1) {
      return _this__u8e3s4;
    }
    var original = _this__u8e3s4;
    // Inline function 'kotlin.text.buildString' call
    var capacity = _this__u8e3s4.length;
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$(capacity);
    // Inline function 'io.ktor.util.toLowerCasePreservingASCIIRules.<anonymous>' call
    this_0.yc(original, 0, firstIndex);
    var inductionVariable_0 = firstIndex;
    var last_0 = get_lastIndex_3(original);
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_0.e9(toLowerCasePreservingASCII(charSequenceGet(original, index_0)));
      }
       while (!(index_0 === last_0));
    return this_0.toString();
  }
  function toLowerCasePreservingASCII(ch) {
    var tmp;
    if (_Char___init__impl__6a9atx(65) <= ch ? ch <= _Char___init__impl__6a9atx(90) : false) {
      tmp = Char__plus_impl_qi7pgj(ch, 32);
    } else if (_Char___init__impl__6a9atx(0) <= ch ? ch <= _Char___init__impl__6a9atx(127) : false) {
      tmp = ch;
    } else {
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$2 = toString(ch).toLowerCase();
      tmp = charSequenceGet(tmp$ret$2, 0);
    }
    return tmp;
  }
  function CaseInsensitiveString(content) {
    this.a8t_1 = content;
    var tmp = this;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.a8t_1.toLowerCase();
    tmp.b8t_1 = getStringHashCode(tmp$ret$1);
  }
  protoOf(CaseInsensitiveString).equals = function (other) {
    var tmp0_safe_receiver = other instanceof CaseInsensitiveString ? other : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a8t_1;
    return (tmp1_safe_receiver == null ? null : equals_0(tmp1_safe_receiver, this.a8t_1, true)) === true;
  };
  protoOf(CaseInsensitiveString).hashCode = function () {
    return this.b8t_1;
  };
  protoOf(CaseInsensitiveString).toString = function () {
    return this.a8t_1;
  };
  function caseInsensitive(_this__u8e3s4) {
    return new CaseInsensitiveString(_this__u8e3s4);
  }
  function ChannelIOException() {
  }
  function CopyOnWriteHashMap() {
    this.w8u_1 = atomic$ref$1(emptyMap());
  }
  protoOf(CopyOnWriteHashMap).x8u = function (key) {
    return this.w8u_1.kotlinx$atomicfu$value.y2(key);
  };
  function Companion_136() {
    Companion_instance_136 = this;
    this.y8u_1 = GMTDate_0(new Long(0, 0));
  }
  var Companion_instance_136;
  function Companion_getInstance_136() {
    if (Companion_instance_136 == null)
      new Companion_136();
    return Companion_instance_136;
  }
  function GMTDate(seconds, minutes, hours, dayOfWeek, dayOfMonth, dayOfYear, month, year, timestamp) {
    Companion_getInstance_136();
    this.z8u_1 = seconds;
    this.a8v_1 = minutes;
    this.b8v_1 = hours;
    this.c8v_1 = dayOfWeek;
    this.d8v_1 = dayOfMonth;
    this.e8v_1 = dayOfYear;
    this.f8v_1 = month;
    this.g8v_1 = year;
    this.h8v_1 = timestamp;
  }
  protoOf(GMTDate).i8v = function (other) {
    return this.h8v_1.d1(other.h8v_1);
  };
  protoOf(GMTDate).d = function (other) {
    return this.i8v(other instanceof GMTDate ? other : THROW_CCE());
  };
  protoOf(GMTDate).toString = function () {
    return 'GMTDate(seconds=' + this.z8u_1 + ', minutes=' + this.a8v_1 + ', hours=' + this.b8v_1 + ', dayOfWeek=' + this.c8v_1.toString() + ', dayOfMonth=' + this.d8v_1 + ', dayOfYear=' + this.e8v_1 + ', month=' + this.f8v_1.toString() + ', year=' + this.g8v_1 + ', timestamp=' + this.h8v_1.toString() + ')';
  };
  protoOf(GMTDate).hashCode = function () {
    var result = this.z8u_1;
    result = imul(result, 31) + this.a8v_1 | 0;
    result = imul(result, 31) + this.b8v_1 | 0;
    result = imul(result, 31) + this.c8v_1.hashCode() | 0;
    result = imul(result, 31) + this.d8v_1 | 0;
    result = imul(result, 31) + this.e8v_1 | 0;
    result = imul(result, 31) + this.f8v_1.hashCode() | 0;
    result = imul(result, 31) + this.g8v_1 | 0;
    result = imul(result, 31) + this.h8v_1.hashCode() | 0;
    return result;
  };
  protoOf(GMTDate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GMTDate))
      return false;
    var tmp0_other_with_cast = other instanceof GMTDate ? other : THROW_CCE();
    if (!(this.z8u_1 === tmp0_other_with_cast.z8u_1))
      return false;
    if (!(this.a8v_1 === tmp0_other_with_cast.a8v_1))
      return false;
    if (!(this.b8v_1 === tmp0_other_with_cast.b8v_1))
      return false;
    if (!this.c8v_1.equals(tmp0_other_with_cast.c8v_1))
      return false;
    if (!(this.d8v_1 === tmp0_other_with_cast.d8v_1))
      return false;
    if (!(this.e8v_1 === tmp0_other_with_cast.e8v_1))
      return false;
    if (!this.f8v_1.equals(tmp0_other_with_cast.f8v_1))
      return false;
    if (!(this.g8v_1 === tmp0_other_with_cast.g8v_1))
      return false;
    if (!this.h8v_1.equals(tmp0_other_with_cast.h8v_1))
      return false;
    return true;
  };
  var WeekDay_MONDAY_instance;
  var WeekDay_TUESDAY_instance;
  var WeekDay_WEDNESDAY_instance;
  var WeekDay_THURSDAY_instance;
  var WeekDay_FRIDAY_instance;
  var WeekDay_SATURDAY_instance;
  var WeekDay_SUNDAY_instance;
  function Companion_137() {
  }
  protoOf(Companion_137).j8v = function (ordinal) {
    return values_4()[ordinal];
  };
  var Companion_instance_137;
  function Companion_getInstance_137() {
    return Companion_instance_137;
  }
  function values_4() {
    return [WeekDay_MONDAY_getInstance(), WeekDay_TUESDAY_getInstance(), WeekDay_WEDNESDAY_getInstance(), WeekDay_THURSDAY_getInstance(), WeekDay_FRIDAY_getInstance(), WeekDay_SATURDAY_getInstance(), WeekDay_SUNDAY_getInstance()];
  }
  var WeekDay_entriesInitialized;
  function WeekDay_initEntries() {
    if (WeekDay_entriesInitialized)
      return Unit_instance;
    WeekDay_entriesInitialized = true;
    WeekDay_MONDAY_instance = new WeekDay('MONDAY', 0, 'Mon');
    WeekDay_TUESDAY_instance = new WeekDay('TUESDAY', 1, 'Tue');
    WeekDay_WEDNESDAY_instance = new WeekDay('WEDNESDAY', 2, 'Wed');
    WeekDay_THURSDAY_instance = new WeekDay('THURSDAY', 3, 'Thu');
    WeekDay_FRIDAY_instance = new WeekDay('FRIDAY', 4, 'Fri');
    WeekDay_SATURDAY_instance = new WeekDay('SATURDAY', 5, 'Sat');
    WeekDay_SUNDAY_instance = new WeekDay('SUNDAY', 6, 'Sun');
  }
  function WeekDay(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.m8v_1 = value;
  }
  var Month_JANUARY_instance;
  var Month_FEBRUARY_instance;
  var Month_MARCH_instance;
  var Month_APRIL_instance;
  var Month_MAY_instance;
  var Month_JUNE_instance;
  var Month_JULY_instance;
  var Month_AUGUST_instance;
  var Month_SEPTEMBER_instance;
  var Month_OCTOBER_instance;
  var Month_NOVEMBER_instance;
  var Month_DECEMBER_instance;
  function Companion_138() {
  }
  protoOf(Companion_138).j8v = function (ordinal) {
    return values_5()[ordinal];
  };
  var Companion_instance_138;
  function Companion_getInstance_138() {
    return Companion_instance_138;
  }
  function values_5() {
    return [Month_JANUARY_getInstance(), Month_FEBRUARY_getInstance(), Month_MARCH_getInstance(), Month_APRIL_getInstance(), Month_MAY_getInstance(), Month_JUNE_getInstance(), Month_JULY_getInstance(), Month_AUGUST_getInstance(), Month_SEPTEMBER_getInstance(), Month_OCTOBER_getInstance(), Month_NOVEMBER_getInstance(), Month_DECEMBER_getInstance()];
  }
  var Month_entriesInitialized;
  function Month_initEntries() {
    if (Month_entriesInitialized)
      return Unit_instance;
    Month_entriesInitialized = true;
    Month_JANUARY_instance = new Month('JANUARY', 0, 'Jan');
    Month_FEBRUARY_instance = new Month('FEBRUARY', 1, 'Feb');
    Month_MARCH_instance = new Month('MARCH', 2, 'Mar');
    Month_APRIL_instance = new Month('APRIL', 3, 'Apr');
    Month_MAY_instance = new Month('MAY', 4, 'May');
    Month_JUNE_instance = new Month('JUNE', 5, 'Jun');
    Month_JULY_instance = new Month('JULY', 6, 'Jul');
    Month_AUGUST_instance = new Month('AUGUST', 7, 'Aug');
    Month_SEPTEMBER_instance = new Month('SEPTEMBER', 8, 'Sep');
    Month_OCTOBER_instance = new Month('OCTOBER', 9, 'Oct');
    Month_NOVEMBER_instance = new Month('NOVEMBER', 10, 'Nov');
    Month_DECEMBER_instance = new Month('DECEMBER', 11, 'Dec');
  }
  function Month(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.p8v_1 = value;
  }
  function WeekDay_MONDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_MONDAY_instance;
  }
  function WeekDay_TUESDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_TUESDAY_instance;
  }
  function WeekDay_WEDNESDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_WEDNESDAY_instance;
  }
  function WeekDay_THURSDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_THURSDAY_instance;
  }
  function WeekDay_FRIDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_FRIDAY_instance;
  }
  function WeekDay_SATURDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_SATURDAY_instance;
  }
  function WeekDay_SUNDAY_getInstance() {
    WeekDay_initEntries();
    return WeekDay_SUNDAY_instance;
  }
  function Month_JANUARY_getInstance() {
    Month_initEntries();
    return Month_JANUARY_instance;
  }
  function Month_FEBRUARY_getInstance() {
    Month_initEntries();
    return Month_FEBRUARY_instance;
  }
  function Month_MARCH_getInstance() {
    Month_initEntries();
    return Month_MARCH_instance;
  }
  function Month_APRIL_getInstance() {
    Month_initEntries();
    return Month_APRIL_instance;
  }
  function Month_MAY_getInstance() {
    Month_initEntries();
    return Month_MAY_instance;
  }
  function Month_JUNE_getInstance() {
    Month_initEntries();
    return Month_JUNE_instance;
  }
  function Month_JULY_getInstance() {
    Month_initEntries();
    return Month_JULY_instance;
  }
  function Month_AUGUST_getInstance() {
    Month_initEntries();
    return Month_AUGUST_instance;
  }
  function Month_SEPTEMBER_getInstance() {
    Month_initEntries();
    return Month_SEPTEMBER_instance;
  }
  function Month_OCTOBER_getInstance() {
    Month_initEntries();
    return Month_OCTOBER_instance;
  }
  function Month_NOVEMBER_getInstance() {
    Month_initEntries();
    return Month_NOVEMBER_instance;
  }
  function Month_DECEMBER_getInstance() {
    Month_initEntries();
    return Month_DECEMBER_instance;
  }
  var CONDITION_FALSE;
  var ALREADY_REMOVED;
  var LIST_EMPTY;
  var REMOVE_PREPARED;
  var NO_DECISION;
  function Symbol_1(symbol) {
    this.q8v_1 = symbol;
  }
  protoOf(Symbol_1).toString = function () {
    return this.q8v_1;
  };
  function LockFreeLinkedListNode() {
  }
  protoOf(LockFreeLinkedListNode).c17 = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.r8v_1;
    while (true) {
      // Inline function 'io.ktor.util.internal.LockFreeLinkedListNode.<get-next>.<anonymous>' call
      var next = this_0.kotlinx$atomicfu$value;
      if (!(next instanceof OpDescriptor_0))
        return next;
      next.c13(this);
    }
  };
  protoOf(LockFreeLinkedListNode).s8v = function () {
    return unwrap_0(this.c17());
  };
  function Removed() {
  }
  function OpDescriptor_0() {
  }
  function unwrap_0(_this__u8e3s4) {
    _init_properties_LockFreeLinkedList_kt__wekxce();
    var tmp0_safe_receiver = _this__u8e3s4 instanceof Removed ? _this__u8e3s4 : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t8v_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      tmp = _this__u8e3s4 instanceof LockFreeLinkedListNode ? _this__u8e3s4 : THROW_CCE();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  var properties_initialized_LockFreeLinkedList_kt_lnmdgw;
  function _init_properties_LockFreeLinkedList_kt__wekxce() {
    if (!properties_initialized_LockFreeLinkedList_kt_lnmdgw) {
      properties_initialized_LockFreeLinkedList_kt_lnmdgw = true;
      CONDITION_FALSE = new Symbol_1('CONDITION_FALSE');
      ALREADY_REMOVED = new Symbol_1('ALREADY_REMOVED');
      LIST_EMPTY = new Symbol_1('LIST_EMPTY');
      REMOVE_PREPARED = new Symbol_1('REMOVE_PREPARED');
      NO_DECISION = new Symbol_1('NO_DECISION');
    }
  }
  function proceedLoop($this, $completion) {
    var tmp = new $proceedLoopCOROUTINE$1($this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function $proceedLoopCOROUTINE$1(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c8w_1 = _this__u8e3s4;
  }
  protoOf($proceedLoopCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.d8w_1 = this.c8w_1.k8w_1;
            if (this.d8w_1 === -1) {
              this.y9_1 = 5;
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.e8w_1 = this.c8w_1.h8w_1;
            if (this.d8w_1 >= this.e8w_1.n()) {
              this.c8w_1.s4n();
              this.y9_1 = 5;
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            this.f8w_1 = this.e8w_1.q(this.d8w_1);
            this.c8w_1.k8w_1 = this.d8w_1 + 1 | 0;
            this.y9_1 = 4;
            var tmp_0 = this.f8w_1;
            suspendResult = (isSuspendFunction(tmp_0, 2) ? tmp_0 : THROW_CCE())(this.c8w_1, this.c8w_1.j8w_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.y9_1 = 1;
            continue $sm;
          case 5:
            return this.c8w_1.j8w_1;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function DebugPipelineContext(context, interceptors, subject, coroutineContext) {
    PipelineContext.call(this, context);
    this.h8w_1 = interceptors;
    this.i8w_1 = coroutineContext;
    this.j8w_1 = subject;
    this.k8w_1 = 0;
  }
  protoOf(DebugPipelineContext).et = function () {
    return this.i8w_1;
  };
  protoOf(DebugPipelineContext).l8w = function () {
    return this.j8w_1;
  };
  protoOf(DebugPipelineContext).s4n = function () {
    this.k8w_1 = -1;
  };
  protoOf(DebugPipelineContext).m8w = function (subject, $completion) {
    this.j8w_1 = subject;
    return this.n8w($completion);
  };
  protoOf(DebugPipelineContext).n8w = function ($completion) {
    var index = this.k8w_1;
    if (index < 0)
      return this.j8w_1;
    if (index >= this.h8w_1.n()) {
      this.s4n();
      return this.j8w_1;
    }
    return proceedLoop(this, $completion);
  };
  protoOf(DebugPipelineContext).o8w = function (initial, $completion) {
    this.k8w_1 = 0;
    this.j8w_1 = initial;
    return this.n8w($completion);
  };
  function PhaseContent_init_$Init$(phase, relation, $this) {
    var tmp = Companion_getInstance_139().p8w_1;
    PhaseContent.call($this, phase, relation, isInterface(tmp, KtMutableList) ? tmp : THROW_CCE());
    // Inline function 'kotlin.check' call
    if (!Companion_getInstance_139().p8w_1.p()) {
      // Inline function 'io.ktor.util.pipeline.PhaseContent.<init>.<anonymous>' call
      var message = 'The shared empty array list has been modified';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return $this;
  }
  function PhaseContent_init_$Create$(phase, relation) {
    return PhaseContent_init_$Init$(phase, relation, objectCreate(protoOf(PhaseContent)));
  }
  function copyInterceptors($this) {
    $this.s8w_1 = $this.u8w();
    $this.t8w_1 = false;
  }
  function Companion_139() {
    Companion_instance_139 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.p8w_1 = ArrayList_init_$Create$();
  }
  var Companion_instance_139;
  function Companion_getInstance_139() {
    if (Companion_instance_139 == null)
      new Companion_139();
    return Companion_instance_139;
  }
  function PhaseContent(phase, relation, interceptors) {
    Companion_getInstance_139();
    this.q8w_1 = phase;
    this.r8w_1 = relation;
    this.s8w_1 = interceptors;
    this.t8w_1 = true;
  }
  protoOf(PhaseContent).np = function () {
    return this.s8w_1.p();
  };
  protoOf(PhaseContent).n = function () {
    return this.s8w_1.n();
  };
  protoOf(PhaseContent).v8w = function (interceptor) {
    if (this.t8w_1) {
      copyInterceptors(this);
    }
    this.s8w_1.e(interceptor);
  };
  protoOf(PhaseContent).w8w = function (destination) {
    var interceptors = this.s8w_1;
    if (destination instanceof ArrayList) {
      destination.i6(destination.n() + interceptors.n() | 0);
    }
    var inductionVariable = 0;
    var last = interceptors.n();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        destination.e(interceptors.q(index));
      }
       while (inductionVariable < last);
  };
  protoOf(PhaseContent).x8w = function () {
    this.t8w_1 = true;
    return this.s8w_1;
  };
  protoOf(PhaseContent).u8w = function () {
    // Inline function 'kotlin.collections.mutableListOf' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'io.ktor.util.pipeline.PhaseContent.copiedInterceptors.<anonymous>' call
    this_0.o(this.s8w_1);
    return this_0;
  };
  protoOf(PhaseContent).toString = function () {
    return 'Phase `' + this.q8w_1.y8w_1 + '`, ' + this.n() + ' handlers';
  };
  function _set_interceptors__wod97b($this, value) {
    $this.d8x_1.kotlinx$atomicfu$value = value;
  }
  function _get_interceptors__h4min7($this) {
    return $this.d8x_1.kotlinx$atomicfu$value;
  }
  function createContext($this, context, subject, coroutineContext) {
    return pipelineContextFor(context, sharedInterceptorsList($this), subject, coroutineContext, $this.g8x());
  }
  function findPhase($this, phase) {
    var phasesList = $this.b8x_1;
    var inductionVariable = 0;
    var last = phasesList.n();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var current = phasesList.q(index);
        if (current === phase) {
          var content = PhaseContent_init_$Create$(phase, Last_getInstance());
          phasesList.o2(index, content);
          return content;
        }
        var tmp;
        if (current instanceof PhaseContent) {
          tmp = current.q8w_1 === phase;
        } else {
          tmp = false;
        }
        if (tmp) {
          return current instanceof PhaseContent ? current : THROW_CCE();
        }
      }
       while (inductionVariable < last);
    return null;
  }
  function findPhaseIndex($this, phase) {
    var phasesList = $this.b8x_1;
    var inductionVariable = 0;
    var last = phasesList.n();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var current = phasesList.q(index);
        var tmp;
        if (current === phase) {
          tmp = true;
        } else {
          var tmp_0;
          if (current instanceof PhaseContent) {
            tmp_0 = current.q8w_1 === phase;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        if (tmp) {
          return index;
        }
      }
       while (inductionVariable < last);
    return -1;
  }
  function hasPhase($this, phase) {
    var phasesList = $this.b8x_1;
    var inductionVariable = 0;
    var last = phasesList.n();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var current = phasesList.q(index);
        var tmp;
        if (current === phase) {
          tmp = true;
        } else {
          var tmp_0;
          if (current instanceof PhaseContent) {
            tmp_0 = current.q8w_1 === phase;
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        if (tmp) {
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  }
  function cacheInterceptors($this) {
    var interceptorsQuantity = $this.c8x_1;
    if (interceptorsQuantity === 0) {
      notSharedInterceptorsList($this, emptyList());
      return emptyList();
    }
    var phases = $this.b8x_1;
    if (interceptorsQuantity === 1) {
      var inductionVariable = 0;
      var last = get_lastIndex_2(phases);
      if (inductionVariable <= last)
        $l$loop_0: do {
          var phaseIndex = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp = phases.q(phaseIndex);
          var tmp1_elvis_lhs = tmp instanceof PhaseContent ? tmp : null;
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            continue $l$loop_0;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          var phaseContent = tmp_0;
          if (phaseContent.np())
            continue $l$loop_0;
          var interceptors = phaseContent.x8w();
          setInterceptorsListFromPhase($this, phaseContent);
          return interceptors;
        }
         while (!(phaseIndex === last));
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = get_lastIndex_2(phases);
    if (inductionVariable_0 <= last_0)
      $l$loop_1: do {
        var phaseIndex_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp_1 = phases.q(phaseIndex_0);
        var tmp3_elvis_lhs = tmp_1 instanceof PhaseContent ? tmp_1 : null;
        var tmp_2;
        if (tmp3_elvis_lhs == null) {
          continue $l$loop_1;
        } else {
          tmp_2 = tmp3_elvis_lhs;
        }
        var phase = tmp_2;
        phase.w8w(destination);
      }
       while (!(phaseIndex_0 === last_0));
    notSharedInterceptorsList($this, destination);
    return destination;
  }
  function sharedInterceptorsList($this) {
    if (_get_interceptors__h4min7($this) == null) {
      cacheInterceptors($this);
    }
    $this.e8x_1 = true;
    return ensureNotNull(_get_interceptors__h4min7($this));
  }
  function resetInterceptorsList($this) {
    _set_interceptors__wod97b($this, null);
    $this.e8x_1 = false;
    $this.f8x_1 = null;
  }
  function notSharedInterceptorsList($this, list) {
    _set_interceptors__wod97b($this, list);
    $this.e8x_1 = false;
    $this.f8x_1 = null;
  }
  function setInterceptorsListFromPhase($this, phaseContent) {
    _set_interceptors__wod97b($this, phaseContent.x8w());
    $this.e8x_1 = false;
    $this.f8x_1 = phaseContent.q8w_1;
  }
  function tryAddToPhaseFastPath($this, phase, block) {
    var currentInterceptors = _get_interceptors__h4min7($this);
    if ($this.b8x_1.p() || currentInterceptors == null) {
      return false;
    }
    var tmp;
    if ($this.e8x_1) {
      tmp = true;
    } else {
      tmp = !(!(currentInterceptors == null) ? isInterface(currentInterceptors, KtMutableList) : false);
    }
    if (tmp) {
      return false;
    }
    if (equals($this.f8x_1, phase)) {
      currentInterceptors.e(block);
      return true;
    }
    if (equals(phase, last($this.b8x_1)) || findPhaseIndex($this, phase) === get_lastIndex_2($this.b8x_1)) {
      ensureNotNull(findPhase($this, phase)).v8w(block);
      currentInterceptors.e(block);
      return true;
    }
    return false;
  }
  function Pipeline(phases) {
    this.z8w_1 = AttributesJsFn(true);
    this.a8x_1 = false;
    this.b8x_1 = mutableListOf(phases.slice());
    this.c8x_1 = 0;
    this.d8x_1 = atomic$ref$1(null);
    this.e8x_1 = false;
    this.f8x_1 = null;
  }
  protoOf(Pipeline).g8x = function () {
    return this.a8x_1;
  };
  protoOf(Pipeline).h8x = function (context, subject, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.ea();
    return createContext(this, context, subject, tmp$ret$0).o8w(subject, $completion);
  };
  protoOf(Pipeline).j8x = function (reference, phase) {
    if (hasPhase(this, phase))
      return Unit_instance;
    var index = findPhaseIndex(this, reference);
    if (index === -1) {
      throw new InvalidPhaseException('Phase ' + reference.toString() + ' was not registered for this pipeline');
    }
    var lastRelatedPhaseIndex = index;
    var inductionVariable = index + 1 | 0;
    var last = get_lastIndex_2(this.b8x_1);
    if (inductionVariable <= last)
      $l$loop_0: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.b8x_1.q(i);
        var tmp1_safe_receiver = tmp instanceof PhaseContent ? tmp : null;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r8w_1;
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var relation = tmp_0;
        var tmp3_safe_receiver = relation instanceof After ? relation : null;
        var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.k8x_1;
        var tmp_1;
        if (tmp4_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_1 = tmp4_elvis_lhs;
        }
        var relatedTo = tmp_1;
        lastRelatedPhaseIndex = equals(relatedTo, reference) ? i : lastRelatedPhaseIndex;
      }
       while (!(i === last));
    this.b8x_1.p2(lastRelatedPhaseIndex + 1 | 0, PhaseContent_init_$Create$(phase, new After(reference)));
  };
  protoOf(Pipeline).l8x = function (reference, phase) {
    if (hasPhase(this, phase))
      return Unit_instance;
    var index = findPhaseIndex(this, reference);
    if (index === -1) {
      throw new InvalidPhaseException('Phase ' + reference.toString() + ' was not registered for this pipeline');
    }
    this.b8x_1.p2(index, PhaseContent_init_$Create$(phase, new Before(reference)));
  };
  protoOf(Pipeline).m8x = function (phase, block) {
    var tmp0_elvis_lhs = findPhase(this, phase);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw new InvalidPhaseException('Phase ' + phase.toString() + ' was not registered for this pipeline');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var phaseContent = tmp;
    if (typeof block !== 'function')
      THROW_CCE();
    if (tryAddToPhaseFastPath(this, phase, block)) {
      this.c8x_1 = this.c8x_1 + 1 | 0;
      return Unit_instance;
    }
    phaseContent.v8w(block);
    this.c8x_1 = this.c8x_1 + 1 | 0;
    resetInterceptorsList(this);
    this.n8x();
  };
  protoOf(Pipeline).n8x = function () {
  };
  function PipelineContext(context) {
    this.i8x_1 = context;
  }
  function pipelineContextFor(context, interceptors, subject, coroutineContext, debugMode) {
    debugMode = debugMode === VOID ? false : debugMode;
    var tmp;
    if (get_DISABLE_SFG() || debugMode) {
      tmp = new DebugPipelineContext(context, interceptors, subject, coroutineContext);
    } else {
      tmp = new SuspendFunctionGun(subject, context, interceptors);
    }
    return tmp;
  }
  function PipelinePhase(name) {
    this.y8w_1 = name;
  }
  protoOf(PipelinePhase).toString = function () {
    return "Phase('" + this.y8w_1 + "')";
  };
  function InvalidPhaseException(message) {
    extendThrowable(this, message);
    captureStack(this, InvalidPhaseException);
  }
  function After(relativeTo) {
    PipelinePhaseRelation.call(this);
    this.k8x_1 = relativeTo;
  }
  function Before(relativeTo) {
    PipelinePhaseRelation.call(this);
    this.o8x_1 = relativeTo;
  }
  function Last() {
    Last_instance = this;
    PipelinePhaseRelation.call(this);
  }
  var Last_instance;
  function Last_getInstance() {
    if (Last_instance == null)
      new Last();
    return Last_instance;
  }
  function PipelinePhaseRelation() {
  }
  function recoverStackTraceBridge(exception, continuation) {
    var tmp;
    try {
      tmp = withCause(recoverStackTrace(exception, continuation), exception.cause);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var _ = $p;
        tmp_0 = exception;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function loop($this, direct) {
    do {
      var currentIndex = $this.v8x_1;
      if (currentIndex === $this.q8x_1.n()) {
        if (!direct) {
          // Inline function 'kotlin.Companion.success' call
          var value = $this.s8x_1;
          var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
          resumeRootWith($this, tmp$ret$0);
          return false;
        }
        return true;
      }
      $this.v8x_1 = currentIndex + 1 | 0;
      var next = $this.q8x_1.q(currentIndex);
      try {
        var result = next($this, $this.s8x_1, $this.r8x_1);
        if (result === get_COROUTINE_SUSPENDED())
          return false;
      } catch ($p) {
        if ($p instanceof Error) {
          var cause = $p;
          // Inline function 'kotlin.Companion.failure' call
          var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
          resumeRootWith($this, tmp$ret$1);
          return false;
        } else {
          throw $p;
        }
      }
    }
     while (true);
  }
  function resumeRootWith($this, result) {
    if ($this.u8x_1 < 0) {
      // Inline function 'kotlin.error' call
      var message = 'No more continuations to resume';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var next = ensureNotNull($this.t8x_1[$this.u8x_1]);
    var tmp1 = $this.u8x_1;
    $this.u8x_1 = tmp1 - 1 | 0;
    $this.t8x_1[tmp1] = null;
    if (!_Result___get_isFailure__impl__jpiriv(result)) {
      next.ja(result);
    } else {
      var exception = recoverStackTraceBridge(ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result)), next);
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      next.ja(tmp$ret$0);
    }
  }
  function discardLastRootContinuation($this) {
    if ($this.u8x_1 < 0)
      throw IllegalStateException_init_$Create$_0('No more continuations to resume');
    var tmp1 = $this.u8x_1;
    $this.u8x_1 = tmp1 - 1 | 0;
    $this.t8x_1[tmp1] = null;
  }
  function SuspendFunctionGun$continuation$1(this$0) {
    this.x8x_1 = this$0;
    this.w8x_1 = -2147483648;
  }
  protoOf(SuspendFunctionGun$continuation$1).ea = function () {
    var continuation = this.x8x_1.t8x_1[this.x8x_1.u8x_1];
    if (!(continuation === this) && !(continuation == null))
      return continuation.ea();
    var index = this.x8x_1.u8x_1 - 1 | 0;
    while (index >= 0) {
      var tmp0 = index;
      index = tmp0 - 1 | 0;
      var cont = this.x8x_1.t8x_1[tmp0];
      if (!(cont === this) && !(cont == null))
        return cont.ea();
    }
    // Inline function 'kotlin.error' call
    var message = 'Not started';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(SuspendFunctionGun$continuation$1).sh = function (result) {
    if (_Result___get_isFailure__impl__jpiriv(result)) {
      // Inline function 'kotlin.Companion.failure' call
      var exception = ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result));
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      resumeRootWith(this.x8x_1, tmp$ret$0);
      return Unit_instance;
    }
    loop(this.x8x_1, false);
  };
  protoOf(SuspendFunctionGun$continuation$1).ja = function (result) {
    return this.sh(result);
  };
  function SuspendFunctionGun(initial, context, blocks) {
    PipelineContext.call(this, context);
    this.q8x_1 = blocks;
    var tmp = this;
    tmp.r8x_1 = new SuspendFunctionGun$continuation$1(this);
    this.s8x_1 = initial;
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.q8x_1.n();
    tmp_0.t8x_1 = fillArrayVal(Array(size), null);
    this.u8x_1 = -1;
    this.v8x_1 = 0;
  }
  protoOf(SuspendFunctionGun).et = function () {
    return this.r8x_1.ea();
  };
  protoOf(SuspendFunctionGun).l8w = function () {
    return this.s8x_1;
  };
  protoOf(SuspendFunctionGun).n8w = function ($completion) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'io.ktor.util.pipeline.SuspendFunctionGun.proceed.<anonymous>' call
      if (this.v8x_1 === this.q8x_1.n()) {
        tmp$ret$0 = this.s8x_1;
        break $l$block_0;
      }
      this.y8x(intercepted($completion));
      if (loop(this, true)) {
        discardLastRootContinuation(this);
        tmp$ret$0 = this.s8x_1;
        break $l$block_0;
      }
      tmp$ret$0 = get_COROUTINE_SUSPENDED();
    }
    return tmp$ret$0;
  };
  protoOf(SuspendFunctionGun).m8w = function (subject, $completion) {
    this.s8x_1 = subject;
    return this.n8w($completion);
  };
  protoOf(SuspendFunctionGun).o8w = function (initial, $completion) {
    this.v8x_1 = 0;
    if (this.v8x_1 === this.q8x_1.n())
      return initial;
    this.s8x_1 = initial;
    if (this.u8x_1 >= 0)
      throw IllegalStateException_init_$Create$_0('Already started');
    return this.n8w($completion);
  };
  protoOf(SuspendFunctionGun).y8x = function (continuation) {
    this.u8x_1 = this.u8x_1 + 1 | 0;
    this.t8x_1[this.u8x_1] = continuation;
  };
  function TypeInfo(type, reifiedType, kotlinType) {
    kotlinType = kotlinType === VOID ? null : kotlinType;
    this.z8x_1 = type;
    this.a8y_1 = reifiedType;
    this.b8y_1 = kotlinType;
  }
  protoOf(TypeInfo).toString = function () {
    return 'TypeInfo(type=' + toString_1(this.z8x_1) + ', reifiedType=' + toString_1(this.a8y_1) + ', kotlinType=' + toString_0(this.b8y_1) + ')';
  };
  protoOf(TypeInfo).hashCode = function () {
    var result = this.z8x_1.hashCode();
    result = imul(result, 31) + hashCode(this.a8y_1) | 0;
    result = imul(result, 31) + (this.b8y_1 == null ? 0 : hashCode(this.b8y_1)) | 0;
    return result;
  };
  protoOf(TypeInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TypeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof TypeInfo ? other : THROW_CCE();
    if (!this.z8x_1.equals(tmp0_other_with_cast.z8x_1))
      return false;
    if (!equals(this.a8y_1, tmp0_other_with_cast.a8y_1))
      return false;
    if (!equals(this.b8y_1, tmp0_other_with_cast.b8y_1))
      return false;
    return true;
  };
  function AttributesJsFn(concurrent) {
    concurrent = concurrent === VOID ? false : concurrent;
    return new AttributesJs();
  }
  function AttributesJs() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.c8y_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(AttributesJs).l8s = function (key) {
    var tmp = this.c8y_1.y2(key);
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  protoOf(AttributesJs).m8s = function (key) {
    return this.c8y_1.w2(key);
  };
  protoOf(AttributesJs).n8s = function (key, value) {
    // Inline function 'kotlin.collections.set' call
    this.c8y_1.r2(key, value);
  };
  protoOf(AttributesJs).o8s = function (key) {
    this.c8y_1.s2(key);
  };
  protoOf(AttributesJs).p8s = function (key, block) {
    var tmp0_safe_receiver = this.c8y_1.y2(key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return !(tmp0_safe_receiver == null) ? tmp0_safe_receiver : THROW_CCE();
    }
    // Inline function 'kotlin.also' call
    var this_0 = block();
    // Inline function 'io.ktor.util.AttributesJs.computeIfAbsent.<anonymous>' call
    // Inline function 'kotlin.collections.set' call
    this.c8y_1.r2(key, this_0);
    return this_0;
  };
  protoOf(AttributesJs).q8s = function () {
    return toList_0(this.c8y_1.u2());
  };
  function unmodifiable(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  function get__crypto() {
    _init_properties_CryptoJs_kt__3vpuru();
    var tmp0 = _crypto$delegate;
    // Inline function 'kotlin.getValue' call
    _crypto$factory();
    return tmp0.y();
  }
  var _crypto$delegate;
  function generateNonce_0() {
    _init_properties_CryptoJs_kt__3vpuru();
    var buffer = new Int8Array(16);
    if (get_platform(PlatformUtils_getInstance()).a3_1 === 3) {
      get__crypto().randomFillSync(buffer);
    } else {
      get__crypto().getRandomValues(buffer);
    }
    return hex(buffer);
  }
  function _crypto$delegate$lambda() {
    _init_properties_CryptoJs_kt__3vpuru();
    return get_platform(PlatformUtils_getInstance()).a3_1 === 3 ? eval('require')('crypto') : window ? window.crypto ? window.crypto : window.msCrypto : self.crypto;
  }
  function _crypto$factory() {
    return getPropertyCallableRef('_crypto', 0, KProperty0, function () {
      return get__crypto();
    }, null);
  }
  var properties_initialized_CryptoJs_kt_linsrw;
  function _init_properties_CryptoJs_kt__3vpuru() {
    if (!properties_initialized_CryptoJs_kt_linsrw) {
      properties_initialized_CryptoJs_kt_linsrw = true;
      _crypto$delegate = lazy_0(_crypto$delegate$lambda);
    }
  }
  function get_platform(_this__u8e3s4) {
    var tmp = typeof process !== 'undefined' && process.versions != null && process.versions.node != null || (typeof window !== 'undefined' && typeof window.process !== 'undefined' && window.process.versions != null && window.process.versions.node != null);
    var hasNodeApi = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : THROW_CCE();
    return hasNodeApi ? Platform_Node_getInstance() : Platform_Browser_getInstance();
  }
  function get_isDevelopmentMode(_this__u8e3s4) {
    return false;
  }
  function get_isNewMemoryModel(_this__u8e3s4) {
    return true;
  }
  function GMTDate_0(timestamp) {
    timestamp = timestamp === VOID ? null : timestamp;
    var tmp1_safe_receiver = timestamp == null ? null : timestamp.a4();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'io.ktor.util.date.GMTDate.<anonymous>' call
      tmp = new Date(tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var date = tmp2_elvis_lhs == null ? new Date() : tmp2_elvis_lhs;
    if (isNaN_0(date.getTime()))
      throw new InvalidTimestampException(ensureNotNull(timestamp));
    // Inline function 'kotlin.with' call
    var dayOfWeek = Companion_instance_137.j8v((date.getUTCDay() + 6 | 0) % 7 | 0);
    var month = Companion_instance_138.j8v(date.getUTCMonth());
    return new GMTDate(date.getUTCSeconds(), date.getUTCMinutes(), date.getUTCHours(), dayOfWeek, date.getUTCDate(), date.getUTCFullYear(), month, date.getUTCFullYear(), numberToLong(date.getTime()));
  }
  function InvalidTimestampException(timestamp) {
    IllegalStateException_init_$Init$_0('Invalid date timestamp exception: ' + timestamp.toString(), this);
    captureStack(this, InvalidTimestampException);
  }
  function getTimeMillis() {
    return numberToLong((new Date()).getTime());
  }
  function KtorSimpleLogger(name) {
    return new KtorSimpleLogger$1();
  }
  function KtorSimpleLogger$1() {
    var tmp = this;
    var tmp_0;
    switch (PlatformUtils_getInstance().a8u_1 || PlatformUtils_getInstance().z8t_1) {
      case true:
        // Inline function 'kotlin.runCatching' call

        var tmp_1;
        try {
          // Inline function 'io.ktor.util.logging.<no name provided>.level.<anonymous>' call
          var tmp_2 = process.env.KTOR_LOG_LEVEL;
          // Inline function 'kotlin.Companion.success' call
          var value = (tmp_2 == null ? true : typeof tmp_2 === 'string') ? tmp_2 : THROW_CCE();
          tmp_1 = _Result___init__impl__xyqfz8(value);
        } catch ($p) {
          var tmp_3;
          if ($p instanceof Error) {
            var e = $p;
            // Inline function 'kotlin.Companion.failure' call
            tmp_3 = _Result___init__impl__xyqfz8(createFailure(e));
          } else {
            throw $p;
          }
          tmp_1 = tmp_3;
        }

        // Inline function 'kotlin.Result.getOrNull' call

        var this_0 = tmp_1;
        var tmp_4;
        if (_Result___get_isFailure__impl__jpiriv(this_0)) {
          tmp_4 = null;
        } else {
          var tmp_5 = _Result___get_value__impl__bjfvqg(this_0);
          tmp_4 = (tmp_5 == null ? true : !(tmp_5 == null)) ? tmp_5 : THROW_CCE();
        }

        var tmp1_safe_receiver = tmp_4;
        var tmp_6;
        if (tmp1_safe_receiver == null) {
          tmp_6 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'io.ktor.util.logging.<no name provided>.level.<anonymous>' call
          var tmp0 = values_6();
          var tmp$ret$6;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var inductionVariable = 0;
            var last = tmp0.length;
            while (inductionVariable < last) {
              var element = tmp0[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'io.ktor.util.logging.<no name provided>.level.<anonymous>.<anonymous>' call
              if (element.z2_1 === tmp1_safe_receiver) {
                tmp$ret$6 = element;
                break $l$block;
              }
            }
            tmp$ret$6 = null;
          }
          tmp_6 = tmp$ret$6;
        }

        var tmp2_elvis_lhs = tmp_6;
        tmp_0 = tmp2_elvis_lhs == null ? LogLevel_INFO_getInstance() : tmp2_elvis_lhs;
        break;
      case false:
        tmp_0 = LogLevel_TRACE_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.d8y_1 = tmp_0;
  }
  protoOf(KtorSimpleLogger$1).e8y = function (message) {
    if (this.d8y_1.d3(LogLevel_TRACE_getInstance()) > 0)
      return Unit_instance;
    console.debug('TRACE: ' + message);
  };
  var LogLevel_TRACE_instance;
  var LogLevel_DEBUG_instance;
  var LogLevel_INFO_instance;
  var LogLevel_WARN_instance;
  var LogLevel_ERROR_instance;
  var LogLevel_NONE_instance;
  function values_6() {
    return [LogLevel_TRACE_getInstance(), LogLevel_DEBUG_getInstance(), LogLevel_INFO_getInstance(), LogLevel_WARN_getInstance(), LogLevel_ERROR_getInstance(), LogLevel_NONE_getInstance()];
  }
  var LogLevel_entriesInitialized;
  function LogLevel_initEntries() {
    if (LogLevel_entriesInitialized)
      return Unit_instance;
    LogLevel_entriesInitialized = true;
    LogLevel_TRACE_instance = new LogLevel('TRACE', 0);
    LogLevel_DEBUG_instance = new LogLevel('DEBUG', 1);
    LogLevel_INFO_instance = new LogLevel('INFO', 2);
    LogLevel_WARN_instance = new LogLevel('WARN', 3);
    LogLevel_ERROR_instance = new LogLevel('ERROR', 4);
    LogLevel_NONE_instance = new LogLevel('NONE', 5);
  }
  function LogLevel(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function LogLevel_TRACE_getInstance() {
    LogLevel_initEntries();
    return LogLevel_TRACE_instance;
  }
  function LogLevel_DEBUG_getInstance() {
    LogLevel_initEntries();
    return LogLevel_DEBUG_instance;
  }
  function LogLevel_INFO_getInstance() {
    LogLevel_initEntries();
    return LogLevel_INFO_instance;
  }
  function LogLevel_WARN_getInstance() {
    LogLevel_initEntries();
    return LogLevel_WARN_instance;
  }
  function LogLevel_ERROR_getInstance() {
    LogLevel_initEntries();
    return LogLevel_ERROR_instance;
  }
  function LogLevel_NONE_getInstance() {
    LogLevel_initEntries();
    return LogLevel_NONE_instance;
  }
  function get_DISABLE_SFG() {
    return DISABLE_SFG;
  }
  var DISABLE_SFG;
  function withCause(_this__u8e3s4, cause) {
    return _this__u8e3s4;
  }
  function instanceOf(_this__u8e3s4, type) {
    return type.mb(_this__u8e3s4);
  }
  function typeInfoImpl(reifiedType, kClass, kType) {
    return new TypeInfo(kClass, reifiedType, kType);
  }
  function JsType() {
  }
  var JsType_instance;
  function JsType_getInstance() {
    return JsType_instance;
  }
  function get_URL_ALPHABET() {
    _init_properties_Codecs_kt__fudxxf();
    return URL_ALPHABET;
  }
  var URL_ALPHABET;
  function get_URL_ALPHABET_CHARS() {
    _init_properties_Codecs_kt__fudxxf();
    return URL_ALPHABET_CHARS;
  }
  var URL_ALPHABET_CHARS;
  function get_HEX_ALPHABET() {
    _init_properties_Codecs_kt__fudxxf();
    return HEX_ALPHABET;
  }
  var HEX_ALPHABET;
  function get_URL_PROTOCOL_PART() {
    _init_properties_Codecs_kt__fudxxf();
    return URL_PROTOCOL_PART;
  }
  var URL_PROTOCOL_PART;
  function get_VALID_PATH_PART() {
    _init_properties_Codecs_kt__fudxxf();
    return VALID_PATH_PART;
  }
  var VALID_PATH_PART;
  var ATTRIBUTE_CHARACTERS;
  function get_SPECIAL_SYMBOLS() {
    _init_properties_Codecs_kt__fudxxf();
    return SPECIAL_SYMBOLS;
  }
  var SPECIAL_SYMBOLS;
  function encodeURLParameter(_this__u8e3s4, spaceToPlus) {
    spaceToPlus = spaceToPlus === VOID ? false : spaceToPlus;
    _init_properties_Codecs_kt__fudxxf();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'io.ktor.http.encodeURLParameter.<anonymous>' call
    var content = encode(Charsets_getInstance().q8o_1.u8o(), _this__u8e3s4);
    forEach_0(content, encodeURLParameter$lambda(this_0, spaceToPlus));
    return this_0.toString();
  }
  function decodeURLPart(_this__u8e3s4, start, end, charset) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? _this__u8e3s4.length : end;
    charset = charset === VOID ? Charsets_getInstance().q8o_1 : charset;
    _init_properties_Codecs_kt__fudxxf();
    return decodeScan(_this__u8e3s4, start, end, false, charset);
  }
  function encodeURLQueryComponent(_this__u8e3s4, encodeFull, spaceToPlus, charset) {
    encodeFull = encodeFull === VOID ? false : encodeFull;
    spaceToPlus = spaceToPlus === VOID ? false : spaceToPlus;
    charset = charset === VOID ? Charsets_getInstance().q8o_1 : charset;
    _init_properties_Codecs_kt__fudxxf();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'io.ktor.http.encodeURLQueryComponent.<anonymous>' call
    var content = encode(charset.u8o(), _this__u8e3s4);
    forEach_0(content, encodeURLQueryComponent$lambda(spaceToPlus, this_0, encodeFull));
    return this_0.toString();
  }
  function decodeURLQueryComponent(_this__u8e3s4, start, end, plusIsSpace, charset) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? _this__u8e3s4.length : end;
    plusIsSpace = plusIsSpace === VOID ? false : plusIsSpace;
    charset = charset === VOID ? Charsets_getInstance().q8o_1 : charset;
    _init_properties_Codecs_kt__fudxxf();
    return decodeScan(_this__u8e3s4, start, end, plusIsSpace, charset);
  }
  function encodeURLPathPart(_this__u8e3s4) {
    _init_properties_Codecs_kt__fudxxf();
    return encodeURLPath(_this__u8e3s4, true);
  }
  function forEach_0(_this__u8e3s4, block) {
    _init_properties_Codecs_kt__fudxxf();
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.takeWhile' call
      var release = true;
      var tmp0_elvis_lhs = prepareReadFirstHead(_this__u8e3s4, 1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var current = tmp;
      try {
        $l$loop_1: do {
          // Inline function 'io.ktor.http.forEach.<anonymous>' call
          var buffer = current;
          $l$loop: while (true) {
            // Inline function 'io.ktor.utils.io.core.canRead' call
            if (!(buffer.i8g_1 > buffer.h8g_1)) {
              break $l$loop;
            }
            block(buffer.w8l());
          }
          if (!true) {
            break $l$loop_1;
          }
          release = false;
          var tmp1_elvis_lhs = prepareReadNextHead(_this__u8e3s4, current);
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            break $l$loop_1;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          var next = tmp_0;
          current = next;
          release = true;
        }
         while (true);
      }finally {
        if (release) {
          completeReadHead(_this__u8e3s4, current);
        }
      }
    }
  }
  function percentEncode(_this__u8e3s4) {
    _init_properties_Codecs_kt__fudxxf();
    var code = _this__u8e3s4 & 255;
    var array = charArray(3);
    array[0] = _Char___init__impl__6a9atx(37);
    array[1] = hexDigitToChar(code >> 4);
    array[2] = hexDigitToChar(code & 15);
    return concatToString(array);
  }
  function decodeScan(_this__u8e3s4, start, end, plusIsSpace, charset) {
    _init_properties_Codecs_kt__fudxxf();
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ch = charSequenceGet(_this__u8e3s4, index);
        if (ch === _Char___init__impl__6a9atx(37) || (plusIsSpace && ch === _Char___init__impl__6a9atx(43))) {
          return decodeImpl(_this__u8e3s4, start, end, index, plusIsSpace, charset);
        }
      }
       while (inductionVariable < end);
    var tmp;
    if (start === 0 && end === _this__u8e3s4.length) {
      tmp = toString_1(_this__u8e3s4);
    } else {
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = _this__u8e3s4.substring(start, end);
    }
    return tmp;
  }
  function encodeURLPath(_this__u8e3s4, encodeSlash) {
    _init_properties_Codecs_kt__fudxxf();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'io.ktor.http.encodeURLPath.<anonymous>' call
    var charset = Charsets_getInstance().q8o_1;
    var index = 0;
    $l$loop_0: while (index < _this__u8e3s4.length) {
      var current = charSequenceGet(_this__u8e3s4, index);
      if (!encodeSlash && current === _Char___init__impl__6a9atx(47) || get_URL_ALPHABET_CHARS().s(new Char(current)) || get_VALID_PATH_PART().s(new Char(current))) {
        this_0.e9(current);
        index = index + 1 | 0;
        continue $l$loop_0;
      }
      if (current === _Char___init__impl__6a9atx(37) && (index + 2 | 0) < _this__u8e3s4.length && get_HEX_ALPHABET().s(new Char(charSequenceGet(_this__u8e3s4, index + 1 | 0))) && get_HEX_ALPHABET().s(new Char(charSequenceGet(_this__u8e3s4, index + 2 | 0)))) {
        this_0.e9(current);
        this_0.e9(charSequenceGet(_this__u8e3s4, index + 1 | 0));
        this_0.e9(charSequenceGet(_this__u8e3s4, index + 2 | 0));
        index = index + 3 | 0;
        continue $l$loop_0;
      }
      var symbolSize = isSurrogate(current) ? 2 : 1;
      var tmp = encode(charset.u8o(), _this__u8e3s4, index, index + symbolSize | 0);
      forEach_0(tmp, encodeURLPath$lambda(this_0));
      index = index + symbolSize | 0;
    }
    return this_0.toString();
  }
  function hexDigitToChar(digit) {
    _init_properties_Codecs_kt__fudxxf();
    return (0 <= digit ? digit <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), digit) : Char__minus_impl_a2frrh_0(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(65), digit), 10);
  }
  function decodeImpl(_this__u8e3s4, start, end, prefixEnd, plusIsSpace, charset) {
    _init_properties_Codecs_kt__fudxxf();
    var length = end - start | 0;
    var sbSize = length > 255 ? length / 3 | 0 : length;
    var sb = StringBuilder_init_$Create$(sbSize);
    if (prefixEnd > start) {
      sb.yc(_this__u8e3s4, start, prefixEnd);
    }
    var index = prefixEnd;
    var bytes = null;
    while (index < end) {
      var c = charSequenceGet(_this__u8e3s4, index);
      if (plusIsSpace && c === _Char___init__impl__6a9atx(43)) {
        sb.e9(_Char___init__impl__6a9atx(32));
        index = index + 1 | 0;
      } else if (c === _Char___init__impl__6a9atx(37)) {
        if (bytes == null) {
          bytes = new Int8Array((end - index | 0) / 3 | 0);
        }
        var count = 0;
        while (index < end && charSequenceGet(_this__u8e3s4, index) === _Char___init__impl__6a9atx(37)) {
          if ((index + 2 | 0) >= end) {
            // Inline function 'kotlin.text.substring' call
            var startIndex = index;
            var endIndex = charSequenceLength(_this__u8e3s4);
            var tmp$ret$0 = toString_1(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex));
            throw new URLDecodeException('Incomplete trailing HEX escape: ' + tmp$ret$0 + ', in ' + toString_1(_this__u8e3s4) + ' at ' + index);
          }
          var digit1 = charToHexDigit(charSequenceGet(_this__u8e3s4, index + 1 | 0));
          var digit2 = charToHexDigit(charSequenceGet(_this__u8e3s4, index + 2 | 0));
          if (digit1 === -1 || digit2 === -1) {
            throw new URLDecodeException('Wrong HEX escape: %' + toString(charSequenceGet(_this__u8e3s4, index + 1 | 0)) + toString(charSequenceGet(_this__u8e3s4, index + 2 | 0)) + ', in ' + toString_1(_this__u8e3s4) + ', at ' + index);
          }
          var tmp = bytes;
          var tmp1 = count;
          count = tmp1 + 1 | 0;
          tmp[tmp1] = toByte(imul(digit1, 16) + digit2 | 0);
          index = index + 3 | 0;
        }
        sb.d9(String_0(bytes, 0, count, charset));
      } else {
        sb.e9(c);
        index = index + 1 | 0;
      }
    }
    return sb.toString();
  }
  function URLDecodeException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, URLDecodeException);
  }
  function charToHexDigit(c2) {
    _init_properties_Codecs_kt__fudxxf();
    return (_Char___init__impl__6a9atx(48) <= c2 ? c2 <= _Char___init__impl__6a9atx(57) : false) ? Char__minus_impl_a2frrh(c2, _Char___init__impl__6a9atx(48)) : (_Char___init__impl__6a9atx(65) <= c2 ? c2 <= _Char___init__impl__6a9atx(70) : false) ? Char__minus_impl_a2frrh(c2, _Char___init__impl__6a9atx(65)) + 10 | 0 : (_Char___init__impl__6a9atx(97) <= c2 ? c2 <= _Char___init__impl__6a9atx(102) : false) ? Char__minus_impl_a2frrh(c2, _Char___init__impl__6a9atx(97)) + 10 | 0 : -1;
  }
  function encodeURLParameterValue(_this__u8e3s4) {
    _init_properties_Codecs_kt__fudxxf();
    return encodeURLParameter(_this__u8e3s4, true);
  }
  function encodeURLParameter$lambda($$this$buildString, $spaceToPlus) {
    return function (it) {
      var tmp;
      if (get_URL_ALPHABET().s(it) || get_SPECIAL_SYMBOLS().s(it)) {
        $$this$buildString.e9(numberToChar(it));
        tmp = Unit_instance;
      } else {
        var tmp_0;
        if ($spaceToPlus) {
          var tmp_1 = it;
          // Inline function 'kotlin.code' call
          var this_0 = _Char___init__impl__6a9atx(32);
          var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
          tmp_0 = tmp_1 === toByte(tmp$ret$0);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          $$this$buildString.e9(_Char___init__impl__6a9atx(43));
          tmp = Unit_instance;
        } else {
          $$this$buildString.d9(percentEncode(it));
          tmp = Unit_instance;
        }
      }
      return Unit_instance;
    };
  }
  function encodeURLQueryComponent$lambda($spaceToPlus, $$this$buildString, $encodeFull) {
    return function (it) {
      var tmp;
      var tmp_0 = it;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(32);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      if (tmp_0 === toByte(tmp$ret$0)) {
        var tmp_1;
        if ($spaceToPlus) {
          $$this$buildString.e9(_Char___init__impl__6a9atx(43));
          tmp_1 = Unit_instance;
        } else {
          $$this$buildString.d9('%20');
          tmp_1 = Unit_instance;
        }
        tmp = tmp_1;
      } else {
        if (get_URL_ALPHABET().s(it) || (!$encodeFull && get_URL_PROTOCOL_PART().s(it))) {
          $$this$buildString.e9(numberToChar(it));
          tmp = Unit_instance;
        } else {
          $$this$buildString.d9(percentEncode(it));
          tmp = Unit_instance;
        }
      }
      return Unit_instance;
    };
  }
  function encodeURLPath$lambda($$this$buildString) {
    return function (it) {
      $$this$buildString.d9(percentEncode(it));
      return Unit_instance;
    };
  }
  var properties_initialized_Codecs_kt_hkj9s1;
  function _init_properties_Codecs_kt__fudxxf() {
    if (!properties_initialized_Codecs_kt_hkj9s1) {
      properties_initialized_Codecs_kt_hkj9s1 = true;
      // Inline function 'kotlin.collections.map' call
      var this_0 = plus_4(plus_5(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57)));
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.k();
      while (_iterator__ex2g4s.l()) {
        var item = _iterator__ex2g4s.m();
        // Inline function 'io.ktor.http.URL_ALPHABET.<anonymous>' call
        // Inline function 'kotlin.code' call
        var this_1 = item.v1_1;
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_1);
        var tmp$ret$1 = toByte(tmp$ret$0);
        destination.e(tmp$ret$1);
      }
      URL_ALPHABET = toSet_0(destination);
      URL_ALPHABET_CHARS = toSet_0(plus_4(plus_5(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57))));
      HEX_ALPHABET = toSet_0(plus_4(plus_5(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(102)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(70))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57))));
      // Inline function 'kotlin.collections.map' call
      var this_2 = setOf_0([new Char(_Char___init__impl__6a9atx(58)), new Char(_Char___init__impl__6a9atx(47)), new Char(_Char___init__impl__6a9atx(63)), new Char(_Char___init__impl__6a9atx(35)), new Char(_Char___init__impl__6a9atx(91)), new Char(_Char___init__impl__6a9atx(93)), new Char(_Char___init__impl__6a9atx(64)), new Char(_Char___init__impl__6a9atx(33)), new Char(_Char___init__impl__6a9atx(36)), new Char(_Char___init__impl__6a9atx(38)), new Char(_Char___init__impl__6a9atx(39)), new Char(_Char___init__impl__6a9atx(40)), new Char(_Char___init__impl__6a9atx(41)), new Char(_Char___init__impl__6a9atx(42)), new Char(_Char___init__impl__6a9atx(44)), new Char(_Char___init__impl__6a9atx(59)), new Char(_Char___init__impl__6a9atx(61)), new Char(_Char___init__impl__6a9atx(45)), new Char(_Char___init__impl__6a9atx(46)), new Char(_Char___init__impl__6a9atx(95)), new Char(_Char___init__impl__6a9atx(126)), new Char(_Char___init__impl__6a9atx(43))]);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
      var _iterator__ex2g4s_0 = this_2.k();
      while (_iterator__ex2g4s_0.l()) {
        var item_0 = _iterator__ex2g4s_0.m();
        // Inline function 'io.ktor.http.URL_PROTOCOL_PART.<anonymous>' call
        // Inline function 'kotlin.code' call
        var this_3 = item_0.v1_1;
        var tmp$ret$0_0 = Char__toInt_impl_vasixd(this_3);
        var tmp$ret$1_0 = toByte(tmp$ret$0_0);
        destination_0.e(tmp$ret$1_0);
      }
      URL_PROTOCOL_PART = destination_0;
      VALID_PATH_PART = setOf_0([new Char(_Char___init__impl__6a9atx(58)), new Char(_Char___init__impl__6a9atx(64)), new Char(_Char___init__impl__6a9atx(33)), new Char(_Char___init__impl__6a9atx(36)), new Char(_Char___init__impl__6a9atx(38)), new Char(_Char___init__impl__6a9atx(39)), new Char(_Char___init__impl__6a9atx(40)), new Char(_Char___init__impl__6a9atx(41)), new Char(_Char___init__impl__6a9atx(42)), new Char(_Char___init__impl__6a9atx(43)), new Char(_Char___init__impl__6a9atx(44)), new Char(_Char___init__impl__6a9atx(59)), new Char(_Char___init__impl__6a9atx(61)), new Char(_Char___init__impl__6a9atx(45)), new Char(_Char___init__impl__6a9atx(46)), new Char(_Char___init__impl__6a9atx(95)), new Char(_Char___init__impl__6a9atx(126))]);
      ATTRIBUTE_CHARACTERS = plus_8(get_URL_ALPHABET_CHARS(), setOf_0([new Char(_Char___init__impl__6a9atx(33)), new Char(_Char___init__impl__6a9atx(35)), new Char(_Char___init__impl__6a9atx(36)), new Char(_Char___init__impl__6a9atx(38)), new Char(_Char___init__impl__6a9atx(43)), new Char(_Char___init__impl__6a9atx(45)), new Char(_Char___init__impl__6a9atx(46)), new Char(_Char___init__impl__6a9atx(94)), new Char(_Char___init__impl__6a9atx(95)), new Char(_Char___init__impl__6a9atx(96)), new Char(_Char___init__impl__6a9atx(124)), new Char(_Char___init__impl__6a9atx(126))]));
      // Inline function 'kotlin.collections.map' call
      var this_4 = listOf_0([new Char(_Char___init__impl__6a9atx(45)), new Char(_Char___init__impl__6a9atx(46)), new Char(_Char___init__impl__6a9atx(95)), new Char(_Char___init__impl__6a9atx(126))]);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_4, 10));
      var _iterator__ex2g4s_1 = this_4.k();
      while (_iterator__ex2g4s_1.l()) {
        var item_1 = _iterator__ex2g4s_1.m();
        // Inline function 'io.ktor.http.SPECIAL_SYMBOLS.<anonymous>' call
        // Inline function 'kotlin.code' call
        var this_5 = item_1.v1_1;
        var tmp$ret$0_1 = Char__toInt_impl_vasixd(this_5);
        var tmp$ret$1_1 = toByte(tmp$ret$0_1);
        destination_1.e(tmp$ret$1_1);
      }
      SPECIAL_SYMBOLS = destination_1;
    }
  }
  function ContentType_init_$Init$(contentType, contentSubtype, parameters, $this) {
    parameters = parameters === VOID ? emptyList() : parameters;
    ContentType.call($this, contentType, contentSubtype, contentType + '/' + contentSubtype, parameters);
    return $this;
  }
  function ContentType_init_$Create$(contentType, contentSubtype, parameters) {
    return ContentType_init_$Init$(contentType, contentSubtype, parameters, objectCreate(protoOf(ContentType)));
  }
  function hasParameter($this, name, value) {
    var tmp;
    switch ($this.g8y_1.n()) {
      case 0:
        tmp = false;
        break;
      case 1:
        // Inline function 'kotlin.let' call

        // Inline function 'io.ktor.http.ContentType.hasParameter.<anonymous>' call

        var it = $this.g8y_1.q(0);
        tmp = (equals_0(it.h8y_1, name, true) && equals_0(it.i8y_1, value, true));
        break;
      default:
        var tmp2 = $this.g8y_1;
        var tmp$ret$2;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_0;
          if (isInterface(tmp2, Collection)) {
            tmp_0 = tmp2.p();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$2 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp2.k();
          while (_iterator__ex2g4s.l()) {
            var element = _iterator__ex2g4s.m();
            // Inline function 'io.ktor.http.ContentType.hasParameter.<anonymous>' call
            if (equals_0(element.h8y_1, name, true) && equals_0(element.i8y_1, value, true)) {
              tmp$ret$2 = true;
              break $l$block_0;
            }
          }
          tmp$ret$2 = false;
        }

        tmp = tmp$ret$2;
        break;
    }
    return tmp;
  }
  function Companion_140() {
    Companion_instance_140 = this;
    this.k8y_1 = ContentType_init_$Create$('*', '*');
  }
  protoOf(Companion_140).t2t = function (value) {
    if (isBlank(value))
      return this.k8y_1;
    // Inline function 'io.ktor.http.Companion.parse' call
    var headerValue = last(parseHeaderValue(value));
    var tmp2 = headerValue.l8y_1;
    // Inline function 'io.ktor.http.Companion.parse.<anonymous>' call
    var parameters = headerValue.m8y_1;
    var slash = indexOf_8(tmp2, _Char___init__impl__6a9atx(47));
    if (slash === -1) {
      // Inline function 'kotlin.text.trim' call
      if (toString_1(trim(isCharSequence(tmp2) ? tmp2 : THROW_CCE())) === '*')
        return Companion_getInstance_140().k8y_1;
      throw new BadContentTypeFormatException(value);
    }
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.text.trim' call
    var this_0 = tmp2.substring(0, slash);
    var type = toString_1(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(type) === 0) {
      throw new BadContentTypeFormatException(value);
    }
    // Inline function 'kotlin.text.substring' call
    var startIndex = slash + 1 | 0;
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.text.trim' call
    var this_1 = tmp2.substring(startIndex);
    var subtype = toString_1(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
    if (contains_8(type, _Char___init__impl__6a9atx(32)) || contains_8(subtype, _Char___init__impl__6a9atx(32))) {
      throw new BadContentTypeFormatException(value);
    }
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(subtype) === 0) {
      tmp = true;
    } else {
      tmp = contains_8(subtype, _Char___init__impl__6a9atx(47));
    }
    if (tmp) {
      throw new BadContentTypeFormatException(value);
    }
    return ContentType_init_$Create$(type, subtype, parameters);
  };
  var Companion_instance_140;
  function Companion_getInstance_140() {
    if (Companion_instance_140 == null)
      new Companion_140();
    return Companion_instance_140;
  }
  function Application() {
    Application_instance = this;
    this.o8y_1 = ContentType_init_$Create$('application', '*');
    this.p8y_1 = ContentType_init_$Create$('application', 'atom+xml');
    this.q8y_1 = ContentType_init_$Create$('application', 'cbor');
    this.r8y_1 = ContentType_init_$Create$('application', 'json');
    this.s8y_1 = ContentType_init_$Create$('application', 'hal+json');
    this.t8y_1 = ContentType_init_$Create$('application', 'javascript');
    this.u8y_1 = ContentType_init_$Create$('application', 'octet-stream');
    this.v8y_1 = ContentType_init_$Create$('application', 'rss+xml');
    this.w8y_1 = ContentType_init_$Create$('application', 'xml');
    this.x8y_1 = ContentType_init_$Create$('application', 'xml-dtd');
    this.y8y_1 = ContentType_init_$Create$('application', 'zip');
    this.z8y_1 = ContentType_init_$Create$('application', 'gzip');
    this.a8z_1 = ContentType_init_$Create$('application', 'x-www-form-urlencoded');
    this.b8z_1 = ContentType_init_$Create$('application', 'pdf');
    this.c8z_1 = ContentType_init_$Create$('application', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    this.d8z_1 = ContentType_init_$Create$('application', 'vnd.openxmlformats-officedocument.wordprocessingml.document');
    this.e8z_1 = ContentType_init_$Create$('application', 'vnd.openxmlformats-officedocument.presentationml.presentation');
    this.f8z_1 = ContentType_init_$Create$('application', 'protobuf');
    this.g8z_1 = ContentType_init_$Create$('application', 'wasm');
    this.h8z_1 = ContentType_init_$Create$('application', 'problem+json');
    this.i8z_1 = ContentType_init_$Create$('application', 'problem+xml');
  }
  var Application_instance;
  function Application_getInstance() {
    if (Application_instance == null)
      new Application();
    return Application_instance;
  }
  function Text() {
    Text_instance = this;
    this.j8z_1 = ContentType_init_$Create$('text', '*');
    this.k8z_1 = ContentType_init_$Create$('text', 'plain');
    this.l8z_1 = ContentType_init_$Create$('text', 'css');
    this.m8z_1 = ContentType_init_$Create$('text', 'csv');
    this.n8z_1 = ContentType_init_$Create$('text', 'html');
    this.o8z_1 = ContentType_init_$Create$('text', 'javascript');
    this.p8z_1 = ContentType_init_$Create$('text', 'vcard');
    this.q8z_1 = ContentType_init_$Create$('text', 'xml');
    this.r8z_1 = ContentType_init_$Create$('text', 'event-stream');
  }
  var Text_instance;
  function Text_getInstance() {
    if (Text_instance == null)
      new Text();
    return Text_instance;
  }
  function ContentType(contentType, contentSubtype, existingContent, parameters) {
    Companion_getInstance_140();
    parameters = parameters === VOID ? emptyList() : parameters;
    HeaderValueWithParameters.call(this, existingContent, parameters);
    this.u8z_1 = contentType;
    this.v8z_1 = contentSubtype;
  }
  protoOf(ContentType).w8z = function (name, value) {
    if (hasParameter(this, name, value))
      return this;
    return new ContentType(this.u8z_1, this.v8z_1, this.f8y_1, plus_3(this.g8y_1, HeaderValueParam_init_$Create$(name, value)));
  };
  protoOf(ContentType).x8z = function () {
    return this.g8y_1.p() ? this : ContentType_init_$Create$(this.u8z_1, this.v8z_1);
  };
  protoOf(ContentType).y8z = function (pattern) {
    if (!(pattern.u8z_1 === '*') && !equals_0(pattern.u8z_1, this.u8z_1, true)) {
      return false;
    }
    if (!(pattern.v8z_1 === '*') && !equals_0(pattern.v8z_1, this.v8z_1, true)) {
      return false;
    }
    var tmp0_iterator = pattern.g8y_1.k();
    while (tmp0_iterator.l()) {
      var tmp1_loop_parameter = tmp0_iterator.m();
      var patternName = tmp1_loop_parameter.ug();
      var patternValue = tmp1_loop_parameter.vg();
      var tmp;
      if (patternName === '*') {
        var tmp_0;
        if (patternValue === '*') {
          tmp_0 = true;
        } else {
          var tmp0 = this.g8y_1;
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp_1;
            if (isInterface(tmp0, Collection)) {
              tmp_1 = tmp0.p();
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              // Inline function 'io.ktor.http.ContentType.match.<anonymous>' call
              if (equals_0(element.i8y_1, patternValue, true)) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          tmp_0 = tmp$ret$0;
        }
        tmp = tmp_0;
      } else {
        var value = this.z8z(patternName);
        tmp = patternValue === '*' ? !(value == null) : equals_0(value, patternValue, true);
      }
      var matches = tmp;
      if (!matches) {
        return false;
      }
    }
    return true;
  };
  protoOf(ContentType).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof ContentType) {
      tmp_1 = equals_0(this.u8z_1, other.u8z_1, true);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals_0(this.v8z_1, other.v8z_1, true);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.g8y_1, other.g8y_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ContentType).hashCode = function () {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.u8z_1.toLowerCase();
    var result = getStringHashCode(tmp$ret$1);
    var tmp = result;
    var tmp_0 = imul(31, result);
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = this.v8z_1.toLowerCase();
    result = tmp + (tmp_0 + getStringHashCode(tmp$ret$3) | 0) | 0;
    result = result + imul(31, hashCode(this.g8y_1)) | 0;
    return result;
  };
  function BadContentTypeFormatException(value) {
    Exception_init_$Init$_0('Bad Content-Type format: ' + value, this);
    captureStack(this, BadContentTypeFormatException);
  }
  function charset(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.z8z('charset');
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'io.ktor.http.charset.<anonymous>' call
      var tmp_0;
      try {
        tmp_0 = Companion_instance_135.s8r(tmp0_safe_receiver);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof IllegalArgumentException) {
          var exception = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function withCharset(_this__u8e3s4, charset) {
    return _this__u8e3s4.w8z('charset', get_name_6(charset));
  }
  function withCharsetIfNeeded(_this__u8e3s4, charset) {
    var tmp;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    if (!(_this__u8e3s4.u8z_1.toLowerCase() === 'text')) {
      tmp = _this__u8e3s4;
    } else {
      tmp = _this__u8e3s4.w8z('charset', get_name_6(charset));
    }
    return tmp;
  }
  function get_HeaderFieldValueSeparators() {
    _init_properties_HeaderValueWithParameters_kt__z6luvy();
    return HeaderFieldValueSeparators;
  }
  var HeaderFieldValueSeparators;
  function Companion_141() {
  }
  var Companion_instance_141;
  function Companion_getInstance_141() {
    return Companion_instance_141;
  }
  function HeaderValueWithParameters(content, parameters) {
    parameters = parameters === VOID ? emptyList() : parameters;
    this.f8y_1 = content;
    this.g8y_1 = parameters;
  }
  protoOf(HeaderValueWithParameters).z8z = function (name) {
    var inductionVariable = 0;
    var last = get_lastIndex_2(this.g8y_1);
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var parameter = this.g8y_1.q(index);
        if (equals_0(parameter.h8y_1, name, true)) {
          return parameter.i8y_1;
        }
      }
       while (!(index === last));
    return null;
  };
  protoOf(HeaderValueWithParameters).toString = function () {
    var tmp;
    if (this.g8y_1.p()) {
      tmp = this.f8y_1;
    } else {
      var tmp_0 = this.f8y_1.length;
      // Inline function 'kotlin.collections.sumOf' call
      var sum = 0;
      var _iterator__ex2g4s = this.g8y_1.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        var tmp_1 = sum;
        // Inline function 'io.ktor.http.HeaderValueWithParameters.toString.<anonymous>' call
        sum = tmp_1 + ((element.h8y_1.length + element.i8y_1.length | 0) + 3 | 0) | 0;
      }
      var size = tmp_0 + sum | 0;
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$(size);
      // Inline function 'io.ktor.http.HeaderValueWithParameters.toString.<anonymous>' call
      this_0.d9(this.f8y_1);
      var inductionVariable = 0;
      var last = get_lastIndex_2(this.g8y_1);
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var element_0 = this.g8y_1.q(index);
          this_0.d9('; ');
          this_0.d9(element_0.h8y_1);
          this_0.d9('=');
          // Inline function 'io.ktor.http.escapeIfNeededTo' call
          var this_1 = element_0.i8y_1;
          if (needQuotes(this_1)) {
            this_0.d9(quote(this_1));
          } else {
            this_0.d9(this_1);
          }
        }
         while (!(index === last));
      tmp = this_0.toString();
    }
    return tmp;
  };
  function needQuotes(_this__u8e3s4) {
    _init_properties_HeaderValueWithParameters_kt__z6luvy();
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0)
      return true;
    if (isQuoted(_this__u8e3s4))
      return false;
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (get_HeaderFieldValueSeparators().s(new Char(charSequenceGet(_this__u8e3s4, index))))
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  function quote(_this__u8e3s4) {
    _init_properties_HeaderValueWithParameters_kt__z6luvy();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'io.ktor.http.quote.<anonymous>' call
    quoteTo(_this__u8e3s4, this_0);
    return this_0.toString();
  }
  function isQuoted(_this__u8e3s4) {
    _init_properties_HeaderValueWithParameters_kt__z6luvy();
    if (_this__u8e3s4.length < 2) {
      return false;
    }
    if (!(first_2(_this__u8e3s4) === _Char___init__impl__6a9atx(34)) || !(last_2(_this__u8e3s4) === _Char___init__impl__6a9atx(34))) {
      return false;
    }
    var startIndex = 1;
    $l$loop: do {
      var index = indexOf_8(_this__u8e3s4, _Char___init__impl__6a9atx(34), startIndex);
      if (index === get_lastIndex_3(_this__u8e3s4)) {
        break $l$loop;
      }
      var slashesCount = 0;
      var slashIndex = index - 1 | 0;
      while (charSequenceGet(_this__u8e3s4, slashIndex) === _Char___init__impl__6a9atx(92)) {
        slashesCount = slashesCount + 1 | 0;
        slashIndex = slashIndex - 1 | 0;
      }
      if ((slashesCount % 2 | 0) === 0) {
        return false;
      }
      startIndex = index + 1 | 0;
    }
     while (startIndex < _this__u8e3s4.length);
    return true;
  }
  function quoteTo(_this__u8e3s4, out) {
    _init_properties_HeaderValueWithParameters_kt__z6luvy();
    out.d9('"');
    var inductionVariable = 0;
    var last = _this__u8e3s4.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ch = charSequenceGet(_this__u8e3s4, i);
        if (ch === _Char___init__impl__6a9atx(92)) {
          out.d9('\\\\');
        } else if (ch === _Char___init__impl__6a9atx(10)) {
          out.d9('\\n');
        } else if (ch === _Char___init__impl__6a9atx(13)) {
          out.d9('\\r');
        } else if (ch === _Char___init__impl__6a9atx(9)) {
          out.d9('\\t');
        } else if (ch === _Char___init__impl__6a9atx(34)) {
          out.d9('\\"');
        } else {
          out.e9(ch);
        }
      }
       while (inductionVariable < last);
    out.d9('"');
  }
  var properties_initialized_HeaderValueWithParameters_kt_yu5xg;
  function _init_properties_HeaderValueWithParameters_kt__z6luvy() {
    if (!properties_initialized_HeaderValueWithParameters_kt_yu5xg) {
      properties_initialized_HeaderValueWithParameters_kt_yu5xg = true;
      HeaderFieldValueSeparators = setOf_0([new Char(_Char___init__impl__6a9atx(40)), new Char(_Char___init__impl__6a9atx(41)), new Char(_Char___init__impl__6a9atx(60)), new Char(_Char___init__impl__6a9atx(62)), new Char(_Char___init__impl__6a9atx(64)), new Char(_Char___init__impl__6a9atx(44)), new Char(_Char___init__impl__6a9atx(59)), new Char(_Char___init__impl__6a9atx(58)), new Char(_Char___init__impl__6a9atx(92)), new Char(_Char___init__impl__6a9atx(34)), new Char(_Char___init__impl__6a9atx(47)), new Char(_Char___init__impl__6a9atx(91)), new Char(_Char___init__impl__6a9atx(93)), new Char(_Char___init__impl__6a9atx(63)), new Char(_Char___init__impl__6a9atx(61)), new Char(_Char___init__impl__6a9atx(123)), new Char(_Char___init__impl__6a9atx(125)), new Char(_Char___init__impl__6a9atx(32)), new Char(_Char___init__impl__6a9atx(9)), new Char(_Char___init__impl__6a9atx(10)), new Char(_Char___init__impl__6a9atx(13))]);
    }
  }
  function Companion_142() {
    Companion_instance_142 = this;
    this.a90_1 = EmptyHeaders_instance;
  }
  var Companion_instance_142;
  function Companion_getInstance_142() {
    if (Companion_instance_142 == null)
      new Companion_142();
    return Companion_instance_142;
  }
  function HeadersBuilder(size) {
    size = size === VOID ? 8 : size;
    StringValuesBuilderImpl.call(this, true, size);
  }
  protoOf(HeadersBuilder).k2p = function () {
    return new HeadersImpl(this.l8u_1);
  };
  protoOf(HeadersBuilder).m8u = function (name) {
    protoOf(StringValuesBuilderImpl).m8u.call(this, name);
    HttpHeaders_getInstance().z93(name);
  };
  protoOf(HeadersBuilder).q8u = function (value) {
    protoOf(StringValuesBuilderImpl).q8u.call(this, value);
    HttpHeaders_getInstance().a94(value);
  };
  function EmptyHeaders() {
  }
  protoOf(EmptyHeaders).f8u = function () {
    return true;
  };
  protoOf(EmptyHeaders).g8u = function (name) {
    return null;
  };
  protoOf(EmptyHeaders).h8u = function () {
    return emptySet();
  };
  protoOf(EmptyHeaders).i8u = function () {
    return emptySet();
  };
  protoOf(EmptyHeaders).toString = function () {
    return 'Headers ' + toString_1(this.i8u());
  };
  var EmptyHeaders_instance;
  function EmptyHeaders_getInstance() {
    return EmptyHeaders_instance;
  }
  function HeadersImpl(values) {
    values = values === VOID ? emptyMap() : values;
    StringValuesImpl.call(this, true, values);
  }
  protoOf(HeadersImpl).toString = function () {
    return 'Headers ' + toString_1(this.i8u());
  };
  function HeaderValueParam_init_$Init$(name, value, $this) {
    HeaderValueParam.call($this, name, value, false);
    return $this;
  }
  function HeaderValueParam_init_$Create$(name, value) {
    return HeaderValueParam_init_$Init$(name, value, objectCreate(protoOf(HeaderValueParam)));
  }
  function HeaderValueParam(name, value, escapeValue) {
    this.h8y_1 = name;
    this.i8y_1 = value;
    this.j8y_1 = escapeValue;
  }
  protoOf(HeaderValueParam).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof HeaderValueParam) {
      tmp_0 = equals_0(other.h8y_1, this.h8y_1, true);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals_0(other.i8y_1, this.i8y_1, true);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(HeaderValueParam).hashCode = function () {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.h8y_1.toLowerCase();
    var result = getStringHashCode(tmp$ret$1);
    var tmp = result;
    var tmp_0 = imul(31, result);
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = this.i8y_1.toLowerCase();
    result = tmp + (tmp_0 + getStringHashCode(tmp$ret$3) | 0) | 0;
    return result;
  };
  protoOf(HeaderValueParam).ug = function () {
    return this.h8y_1;
  };
  protoOf(HeaderValueParam).vg = function () {
    return this.i8y_1;
  };
  protoOf(HeaderValueParam).toString = function () {
    return 'HeaderValueParam(name=' + this.h8y_1 + ', value=' + this.i8y_1 + ', escapeValue=' + this.j8y_1 + ')';
  };
  function HeaderValue(value, params) {
    params = params === VOID ? emptyList() : params;
    this.l8y_1 = value;
    this.m8y_1 = params;
    var tmp = this;
    var tmp0 = this.m8y_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'io.ktor.http.HeaderValue.quality.<anonymous>' call
        if (element.h8y_1 === 'q') {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i8y_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toDoubleOrNull(tmp1_safe_receiver);
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_1;
      // Inline function 'io.ktor.http.HeaderValue.quality.<anonymous>' call
      if (0.0 <= tmp2_safe_receiver ? tmp2_safe_receiver <= 1.0 : false) {
        tmp_1 = tmp2_safe_receiver;
      } else {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    }
    var tmp3_elvis_lhs = tmp_0;
    tmp.n8y_1 = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
  }
  protoOf(HeaderValue).ug = function () {
    return this.l8y_1;
  };
  protoOf(HeaderValue).toString = function () {
    return 'HeaderValue(value=' + this.l8y_1 + ', params=' + toString_1(this.m8y_1) + ')';
  };
  protoOf(HeaderValue).hashCode = function () {
    var result = getStringHashCode(this.l8y_1);
    result = imul(result, 31) + hashCode(this.m8y_1) | 0;
    return result;
  };
  protoOf(HeaderValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HeaderValue))
      return false;
    var tmp0_other_with_cast = other instanceof HeaderValue ? other : THROW_CCE();
    if (!(this.l8y_1 === tmp0_other_with_cast.l8y_1))
      return false;
    if (!equals(this.m8y_1, tmp0_other_with_cast.m8y_1))
      return false;
    return true;
  };
  function parseHeaderValue(text) {
    return parseHeaderValue_0(text, false);
  }
  function parseHeaderValue_0(text, parametersOnly) {
    if (text == null) {
      return emptyList();
    }
    var position = 0;
    var tmp = LazyThreadSafetyMode_NONE_getInstance();
    var items = lazy(tmp, parseHeaderValue$lambda);
    while (position <= get_lastIndex_3(text)) {
      position = parseHeaderValueItem(text, position, items, parametersOnly);
    }
    return valueOrEmpty(items);
  }
  function parseHeaderValueItem(text, start, items, parametersOnly) {
    var position = start;
    var tmp = LazyThreadSafetyMode_NONE_getInstance();
    var parameters = lazy(tmp, parseHeaderValueItem$lambda);
    var valueEnd = parametersOnly ? position : null;
    while (position <= get_lastIndex_3(text)) {
      var tmp0_subject = charSequenceGet(text, position);
      if (tmp0_subject === _Char___init__impl__6a9atx(44)) {
        var tmp_0 = items.y();
        var tmp1_elvis_lhs = valueEnd;
        tmp_0.e(new HeaderValue(subtrim(text, start, tmp1_elvis_lhs == null ? position : tmp1_elvis_lhs), valueOrEmpty(parameters)));
        return position + 1 | 0;
      } else if (tmp0_subject === _Char___init__impl__6a9atx(59)) {
        if (valueEnd == null)
          valueEnd = position;
        position = parseHeaderValueParameter(text, position + 1 | 0, parameters);
      } else {
        var tmp_1;
        if (parametersOnly) {
          tmp_1 = parseHeaderValueParameter(text, position, parameters);
        } else {
          tmp_1 = position + 1 | 0;
        }
        position = tmp_1;
      }
    }
    var tmp_2 = items.y();
    var tmp2_elvis_lhs = valueEnd;
    tmp_2.e(new HeaderValue(subtrim(text, start, tmp2_elvis_lhs == null ? position : tmp2_elvis_lhs), valueOrEmpty(parameters)));
    return position;
  }
  function valueOrEmpty(_this__u8e3s4) {
    return _this__u8e3s4.bm() ? _this__u8e3s4.y() : emptyList();
  }
  function subtrim(_this__u8e3s4, start, end) {
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.text.trim' call
    var this_0 = _this__u8e3s4.substring(start, end);
    return toString_1(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  }
  function parseHeaderValueParameter(text, start, parameters) {
    var position = start;
    while (position <= get_lastIndex_3(text)) {
      var tmp0_subject = charSequenceGet(text, position);
      if (tmp0_subject === _Char___init__impl__6a9atx(61)) {
        var tmp1_container = parseHeaderValueParameterValue(text, position + 1 | 0);
        var paramEnd = tmp1_container.ug();
        var paramValue = tmp1_container.vg();
        parseHeaderValueParameter$addParam(parameters, text, start, position, paramValue);
        return paramEnd;
      } else if (tmp0_subject === _Char___init__impl__6a9atx(59) ? true : tmp0_subject === _Char___init__impl__6a9atx(44)) {
        parseHeaderValueParameter$addParam(parameters, text, start, position, '');
        return position;
      } else {
        position = position + 1 | 0;
      }
    }
    parseHeaderValueParameter$addParam(parameters, text, start, position, '');
    return position;
  }
  function parseHeaderValueParameterValue(value, start) {
    if (value.length === start) {
      return to(start, '');
    }
    var position = start;
    if (charSequenceGet(value, start) === _Char___init__impl__6a9atx(34)) {
      return parseHeaderValueParameterValueQuoted(value, position + 1 | 0);
    }
    while (position <= get_lastIndex_3(value)) {
      var tmp0_subject = charSequenceGet(value, position);
      if (tmp0_subject === _Char___init__impl__6a9atx(59) ? true : tmp0_subject === _Char___init__impl__6a9atx(44))
        return to(position, subtrim(value, start, position));
      else {
        position = position + 1 | 0;
      }
    }
    return to(position, subtrim(value, start, position));
  }
  function parseHeaderValueParameterValueQuoted(value, start) {
    var position = start;
    var builder = StringBuilder_init_$Create$_1();
    loop: while (position <= get_lastIndex_3(value)) {
      var currentChar = charSequenceGet(value, position);
      if (currentChar === _Char___init__impl__6a9atx(34) && nextIsSemicolonOrEnd(value, position)) {
        return to(position + 1 | 0, builder.toString());
      } else if (currentChar === _Char___init__impl__6a9atx(92) && position < (get_lastIndex_3(value) - 2 | 0)) {
        builder.e9(charSequenceGet(value, position + 1 | 0));
        position = position + 2 | 0;
        continue loop;
      }
      builder.e9(currentChar);
      position = position + 1 | 0;
    }
    var tmp = position;
    var tmp0 = _Char___init__impl__6a9atx(34);
    // Inline function 'kotlin.text.plus' call
    var other = builder.toString();
    var tmp$ret$0 = toString(tmp0) + other;
    return to(tmp, tmp$ret$0);
  }
  function nextIsSemicolonOrEnd(_this__u8e3s4, start) {
    var position = start + 1 | 0;
    loop: while (position < _this__u8e3s4.length && charSequenceGet(_this__u8e3s4, position) === _Char___init__impl__6a9atx(32)) {
      position = position + 1 | 0;
    }
    return position === _this__u8e3s4.length || charSequenceGet(_this__u8e3s4, position) === _Char___init__impl__6a9atx(59);
  }
  function parseAndSortHeader(header) {
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_0 = parseHeaderValue(header);
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = parseAndSortHeader$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0_2(tmp);
    return sortedWith(this_0, tmp$ret$0);
  }
  function sam$kotlin_Comparator$0_2(function_0) {
    this.b94_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_2).te = function (a, b) {
    return this.b94_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_2).compare = function (a, b) {
    return this.te(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_2).b4 = function () {
    return this.b94_1;
  };
  protoOf(sam$kotlin_Comparator$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_2).hashCode = function () {
    return hashCode(this.b4());
  };
  function parseHeaderValueParameter$addParam($parameters, text, start, end, value) {
    var name = subtrim(text, start, end);
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(name) === 0) {
      return Unit_instance;
    }
    $parameters.y().e(HeaderValueParam_init_$Create$(name, value));
  }
  function parseHeaderValue$lambda() {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$();
  }
  function parseHeaderValueItem$lambda() {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$();
  }
  function parseAndSortHeader$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'io.ktor.http.parseAndSortHeader.<anonymous>' call
    var tmp = b.n8y_1;
    // Inline function 'io.ktor.http.parseAndSortHeader.<anonymous>' call
    var tmp$ret$1 = a.n8y_1;
    return compareValues(tmp, tmp$ret$1);
  }
  function HttpHeaders() {
    HttpHeaders_instance = this;
    this.d90_1 = 'Accept';
    this.e90_1 = 'Accept-Charset';
    this.f90_1 = 'Accept-Encoding';
    this.g90_1 = 'Accept-Language';
    this.h90_1 = 'Accept-Ranges';
    this.i90_1 = 'Age';
    this.j90_1 = 'Allow';
    this.k90_1 = 'ALPN';
    this.l90_1 = 'Authentication-Info';
    this.m90_1 = 'Authorization';
    this.n90_1 = 'Cache-Control';
    this.o90_1 = 'Connection';
    this.p90_1 = 'Content-Disposition';
    this.q90_1 = 'Content-Encoding';
    this.r90_1 = 'Content-Language';
    this.s90_1 = 'Content-Length';
    this.t90_1 = 'Content-Location';
    this.u90_1 = 'Content-Range';
    this.v90_1 = 'Content-Type';
    this.w90_1 = 'Cookie';
    this.x90_1 = 'DASL';
    this.y90_1 = 'Date';
    this.z90_1 = 'DAV';
    this.a91_1 = 'Depth';
    this.b91_1 = 'Destination';
    this.c91_1 = 'ETag';
    this.d91_1 = 'Expect';
    this.e91_1 = 'Expires';
    this.f91_1 = 'From';
    this.g91_1 = 'Forwarded';
    this.h91_1 = 'Host';
    this.i91_1 = 'HTTP2-Settings';
    this.j91_1 = 'If';
    this.k91_1 = 'If-Match';
    this.l91_1 = 'If-Modified-Since';
    this.m91_1 = 'If-None-Match';
    this.n91_1 = 'If-Range';
    this.o91_1 = 'If-Schedule-Tag-Match';
    this.p91_1 = 'If-Unmodified-Since';
    this.q91_1 = 'Last-Modified';
    this.r91_1 = 'Location';
    this.s91_1 = 'Lock-Token';
    this.t91_1 = 'Link';
    this.u91_1 = 'Max-Forwards';
    this.v91_1 = 'MIME-Version';
    this.w91_1 = 'Ordering-Type';
    this.x91_1 = 'Origin';
    this.y91_1 = 'Overwrite';
    this.z91_1 = 'Position';
    this.a92_1 = 'Pragma';
    this.b92_1 = 'Prefer';
    this.c92_1 = 'Preference-Applied';
    this.d92_1 = 'Proxy-Authenticate';
    this.e92_1 = 'Proxy-Authentication-Info';
    this.f92_1 = 'Proxy-Authorization';
    this.g92_1 = 'Public-Key-Pins';
    this.h92_1 = 'Public-Key-Pins-Report-Only';
    this.i92_1 = 'Range';
    this.j92_1 = 'Referer';
    this.k92_1 = 'Retry-After';
    this.l92_1 = 'Schedule-Reply';
    this.m92_1 = 'Schedule-Tag';
    this.n92_1 = 'Sec-WebSocket-Accept';
    this.o92_1 = 'Sec-WebSocket-Extensions';
    this.p92_1 = 'Sec-WebSocket-Key';
    this.q92_1 = 'Sec-WebSocket-Protocol';
    this.r92_1 = 'Sec-WebSocket-Version';
    this.s92_1 = 'Server';
    this.t92_1 = 'Set-Cookie';
    this.u92_1 = 'SLUG';
    this.v92_1 = 'Strict-Transport-Security';
    this.w92_1 = 'TE';
    this.x92_1 = 'Timeout';
    this.y92_1 = 'Trailer';
    this.z92_1 = 'Transfer-Encoding';
    this.a93_1 = 'Upgrade';
    this.b93_1 = 'User-Agent';
    this.c93_1 = 'Vary';
    this.d93_1 = 'Via';
    this.e93_1 = 'Warning';
    this.f93_1 = 'WWW-Authenticate';
    this.g93_1 = 'Access-Control-Allow-Origin';
    this.h93_1 = 'Access-Control-Allow-Methods';
    this.i93_1 = 'Access-Control-Allow-Credentials';
    this.j93_1 = 'Access-Control-Allow-Headers';
    this.k93_1 = 'Access-Control-Request-Method';
    this.l93_1 = 'Access-Control-Request-Headers';
    this.m93_1 = 'Access-Control-Expose-Headers';
    this.n93_1 = 'Access-Control-Max-Age';
    this.o93_1 = 'X-Http-Method-Override';
    this.p93_1 = 'X-Forwarded-Host';
    this.q93_1 = 'X-Forwarded-Server';
    this.r93_1 = 'X-Forwarded-Proto';
    this.s93_1 = 'X-Forwarded-For';
    this.t93_1 = 'X-Forwarded-Port';
    this.u93_1 = 'X-Request-ID';
    this.v93_1 = 'X-Correlation-ID';
    this.w93_1 = 'X-Total-Count';
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x93_1 = [this.z92_1, this.a93_1];
    this.y93_1 = asList(this.x93_1);
  }
  protoOf(HttpHeaders).z93 = function (name) {
    // Inline function 'kotlin.text.forEachIndexed' call
    var index = 0;
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(name)) {
      var item = charSequenceGet(name, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      // Inline function 'io.ktor.http.HttpHeaders.checkHeaderName.<anonymous>' call
      if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) <= 0 || isDelimiter(item)) {
        throw new IllegalHeaderNameException(name, _unary__edvuaz);
      }
    }
  };
  protoOf(HttpHeaders).a94 = function (value) {
    // Inline function 'kotlin.text.forEachIndexed' call
    var index = 0;
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(value)) {
      var item = charSequenceGet(value, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      // Inline function 'io.ktor.http.HttpHeaders.checkHeaderValue.<anonymous>' call
      if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) {
        throw new IllegalHeaderValueException(value, _unary__edvuaz);
      }
    }
  };
  var HttpHeaders_instance;
  function HttpHeaders_getInstance() {
    if (HttpHeaders_instance == null)
      new HttpHeaders();
    return HttpHeaders_instance;
  }
  function isDelimiter(ch) {
    return contains_8('"(),/:;<=>?@[\\]{}', ch);
  }
  function IllegalHeaderNameException(headerName, position) {
    var tmp = "Header name '" + headerName + "' contains illegal character '" + toString(charSequenceGet(headerName, position)) + "'";
    // Inline function 'kotlin.code' call
    var this_0 = charSequenceGet(headerName, position);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    IllegalArgumentException_init_$Init$_0(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'), this);
    captureStack(this, IllegalHeaderNameException);
    this.c94_1 = headerName;
    this.d94_1 = position;
  }
  function IllegalHeaderValueException(headerValue, position) {
    var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString(charSequenceGet(headerValue, position)) + "'";
    // Inline function 'kotlin.code' call
    var this_0 = charSequenceGet(headerValue, position);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    IllegalArgumentException_init_$Init$_0(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'), this);
    captureStack(this, IllegalHeaderValueException);
    this.e94_1 = headerValue;
    this.f94_1 = position;
  }
  function UnsafeHeaderException(header) {
    IllegalArgumentException_init_$Init$_0('Header(s) ' + header + ' are controlled by the engine and ' + 'cannot be set explicitly', this);
    captureStack(this, UnsafeHeaderException);
  }
  function contentType(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.g94().fe(HttpHeaders_getInstance().v90_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'io.ktor.http.contentType.<anonymous>' call
      tmp = Companion_getInstance_140().t2t(tmp0_safe_receiver);
    }
    return tmp;
  }
  function contentLength(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.g94().fe(HttpHeaders_getInstance().s90_1);
    return tmp0_safe_receiver == null ? null : toLong_1(tmp0_safe_receiver);
  }
  function charset_0(_this__u8e3s4) {
    var tmp0_safe_receiver = contentType_0(_this__u8e3s4);
    return tmp0_safe_receiver == null ? null : charset(tmp0_safe_receiver);
  }
  function contentType_0(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.g94().fe(HttpHeaders_getInstance().v90_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'io.ktor.http.contentType.<anonymous>' call
      tmp = Companion_getInstance_140().t2t(tmp0_safe_receiver);
    }
    return tmp;
  }
  function contentType_1(_this__u8e3s4, type) {
    return _this__u8e3s4.g94().p8u(HttpHeaders_getInstance().v90_1, type.toString());
  }
  function Companion_143() {
    Companion_instance_143 = this;
    this.h94_1 = new HttpMethod('GET');
    this.i94_1 = new HttpMethod('POST');
    this.j94_1 = new HttpMethod('PUT');
    this.k94_1 = new HttpMethod('PATCH');
    this.l94_1 = new HttpMethod('DELETE');
    this.m94_1 = new HttpMethod('HEAD');
    this.n94_1 = new HttpMethod('OPTIONS');
    this.o94_1 = listOf_0([this.h94_1, this.i94_1, this.j94_1, this.k94_1, this.l94_1, this.m94_1, this.n94_1]);
  }
  var Companion_instance_143;
  function Companion_getInstance_143() {
    if (Companion_instance_143 == null)
      new Companion_143();
    return Companion_instance_143;
  }
  function HttpMethod(value) {
    Companion_getInstance_143();
    this.p94_1 = value;
  }
  protoOf(HttpMethod).toString = function () {
    return 'HttpMethod(value=' + this.p94_1 + ')';
  };
  protoOf(HttpMethod).hashCode = function () {
    return getStringHashCode(this.p94_1);
  };
  protoOf(HttpMethod).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpMethod))
      return false;
    var tmp0_other_with_cast = other instanceof HttpMethod ? other : THROW_CCE();
    if (!(this.p94_1 === tmp0_other_with_cast.p94_1))
      return false;
    return true;
  };
  function Companion_144() {
    Companion_instance_144 = this;
    this.q94_1 = new HttpProtocolVersion('HTTP', 2, 0);
    this.r94_1 = new HttpProtocolVersion('HTTP', 1, 1);
    this.s94_1 = new HttpProtocolVersion('HTTP', 1, 0);
    this.t94_1 = new HttpProtocolVersion('SPDY', 3, 0);
    this.u94_1 = new HttpProtocolVersion('QUIC', 1, 0);
  }
  var Companion_instance_144;
  function Companion_getInstance_144() {
    if (Companion_instance_144 == null)
      new Companion_144();
    return Companion_instance_144;
  }
  function HttpProtocolVersion(name, major, minor) {
    Companion_getInstance_144();
    this.v94_1 = name;
    this.w94_1 = major;
    this.x94_1 = minor;
  }
  protoOf(HttpProtocolVersion).toString = function () {
    return this.v94_1 + '/' + this.w94_1 + '.' + this.x94_1;
  };
  protoOf(HttpProtocolVersion).hashCode = function () {
    var result = getStringHashCode(this.v94_1);
    result = imul(result, 31) + this.w94_1 | 0;
    result = imul(result, 31) + this.x94_1 | 0;
    return result;
  };
  protoOf(HttpProtocolVersion).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpProtocolVersion))
      return false;
    var tmp0_other_with_cast = other instanceof HttpProtocolVersion ? other : THROW_CCE();
    if (!(this.v94_1 === tmp0_other_with_cast.v94_1))
      return false;
    if (!(this.w94_1 === tmp0_other_with_cast.w94_1))
      return false;
    if (!(this.x94_1 === tmp0_other_with_cast.x94_1))
      return false;
    return true;
  };
  function Companion_145() {
    Companion_instance_145 = this;
    this.y94_1 = new HttpStatusCode(100, 'Continue');
    this.z94_1 = new HttpStatusCode(101, 'Switching Protocols');
    this.a95_1 = new HttpStatusCode(102, 'Processing');
    this.b95_1 = new HttpStatusCode(200, 'OK');
    this.c95_1 = new HttpStatusCode(201, 'Created');
    this.d95_1 = new HttpStatusCode(202, 'Accepted');
    this.e95_1 = new HttpStatusCode(203, 'Non-Authoritative Information');
    this.f95_1 = new HttpStatusCode(204, 'No Content');
    this.g95_1 = new HttpStatusCode(205, 'Reset Content');
    this.h95_1 = new HttpStatusCode(206, 'Partial Content');
    this.i95_1 = new HttpStatusCode(207, 'Multi-Status');
    this.j95_1 = new HttpStatusCode(300, 'Multiple Choices');
    this.k95_1 = new HttpStatusCode(301, 'Moved Permanently');
    this.l95_1 = new HttpStatusCode(302, 'Found');
    this.m95_1 = new HttpStatusCode(303, 'See Other');
    this.n95_1 = new HttpStatusCode(304, 'Not Modified');
    this.o95_1 = new HttpStatusCode(305, 'Use Proxy');
    this.p95_1 = new HttpStatusCode(306, 'Switch Proxy');
    this.q95_1 = new HttpStatusCode(307, 'Temporary Redirect');
    this.r95_1 = new HttpStatusCode(308, 'Permanent Redirect');
    this.s95_1 = new HttpStatusCode(400, 'Bad Request');
    this.t95_1 = new HttpStatusCode(401, 'Unauthorized');
    this.u95_1 = new HttpStatusCode(402, 'Payment Required');
    this.v95_1 = new HttpStatusCode(403, 'Forbidden');
    this.w95_1 = new HttpStatusCode(404, 'Not Found');
    this.x95_1 = new HttpStatusCode(405, 'Method Not Allowed');
    this.y95_1 = new HttpStatusCode(406, 'Not Acceptable');
    this.z95_1 = new HttpStatusCode(407, 'Proxy Authentication Required');
    this.a96_1 = new HttpStatusCode(408, 'Request Timeout');
    this.b96_1 = new HttpStatusCode(409, 'Conflict');
    this.c96_1 = new HttpStatusCode(410, 'Gone');
    this.d96_1 = new HttpStatusCode(411, 'Length Required');
    this.e96_1 = new HttpStatusCode(412, 'Precondition Failed');
    this.f96_1 = new HttpStatusCode(413, 'Payload Too Large');
    this.g96_1 = new HttpStatusCode(414, 'Request-URI Too Long');
    this.h96_1 = new HttpStatusCode(415, 'Unsupported Media Type');
    this.i96_1 = new HttpStatusCode(416, 'Requested Range Not Satisfiable');
    this.j96_1 = new HttpStatusCode(417, 'Expectation Failed');
    this.k96_1 = new HttpStatusCode(422, 'Unprocessable Entity');
    this.l96_1 = new HttpStatusCode(423, 'Locked');
    this.m96_1 = new HttpStatusCode(424, 'Failed Dependency');
    this.n96_1 = new HttpStatusCode(425, 'Too Early');
    this.o96_1 = new HttpStatusCode(426, 'Upgrade Required');
    this.p96_1 = new HttpStatusCode(429, 'Too Many Requests');
    this.q96_1 = new HttpStatusCode(431, 'Request Header Fields Too Large');
    this.r96_1 = new HttpStatusCode(500, 'Internal Server Error');
    this.s96_1 = new HttpStatusCode(501, 'Not Implemented');
    this.t96_1 = new HttpStatusCode(502, 'Bad Gateway');
    this.u96_1 = new HttpStatusCode(503, 'Service Unavailable');
    this.v96_1 = new HttpStatusCode(504, 'Gateway Timeout');
    this.w96_1 = new HttpStatusCode(505, 'HTTP Version Not Supported');
    this.x96_1 = new HttpStatusCode(506, 'Variant Also Negotiates');
    this.y96_1 = new HttpStatusCode(507, 'Insufficient Storage');
    this.z96_1 = allStatusCodes();
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.z96_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.http.Companion.statusCodesMap.<anonymous>' call
      var tmp$ret$0 = element.b97_1;
      destination.r2(tmp$ret$0, element);
    }
    tmp.a97_1 = destination;
  }
  var Companion_instance_145;
  function Companion_getInstance_145() {
    if (Companion_instance_145 == null)
      new Companion_145();
    return Companion_instance_145;
  }
  function HttpStatusCode(value, description) {
    Companion_getInstance_145();
    this.b97_1 = value;
    this.c97_1 = description;
  }
  protoOf(HttpStatusCode).toString = function () {
    return '' + this.b97_1 + ' ' + this.c97_1;
  };
  protoOf(HttpStatusCode).equals = function (other) {
    var tmp;
    if (other instanceof HttpStatusCode) {
      tmp = other.b97_1 === this.b97_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(HttpStatusCode).hashCode = function () {
    return this.b97_1;
  };
  protoOf(HttpStatusCode).d97 = function (other) {
    return this.b97_1 - other.b97_1 | 0;
  };
  protoOf(HttpStatusCode).d = function (other) {
    return this.d97(other instanceof HttpStatusCode ? other : THROW_CCE());
  };
  function allStatusCodes() {
    return listOf_0([Companion_getInstance_145().y94_1, Companion_getInstance_145().z94_1, Companion_getInstance_145().a95_1, Companion_getInstance_145().b95_1, Companion_getInstance_145().c95_1, Companion_getInstance_145().d95_1, Companion_getInstance_145().e95_1, Companion_getInstance_145().f95_1, Companion_getInstance_145().g95_1, Companion_getInstance_145().h95_1, Companion_getInstance_145().i95_1, Companion_getInstance_145().j95_1, Companion_getInstance_145().k95_1, Companion_getInstance_145().l95_1, Companion_getInstance_145().m95_1, Companion_getInstance_145().n95_1, Companion_getInstance_145().o95_1, Companion_getInstance_145().p95_1, Companion_getInstance_145().q95_1, Companion_getInstance_145().r95_1, Companion_getInstance_145().s95_1, Companion_getInstance_145().t95_1, Companion_getInstance_145().u95_1, Companion_getInstance_145().v95_1, Companion_getInstance_145().w95_1, Companion_getInstance_145().x95_1, Companion_getInstance_145().y95_1, Companion_getInstance_145().z95_1, Companion_getInstance_145().a96_1, Companion_getInstance_145().b96_1, Companion_getInstance_145().c96_1, Companion_getInstance_145().d96_1, Companion_getInstance_145().e96_1, Companion_getInstance_145().f96_1, Companion_getInstance_145().g96_1, Companion_getInstance_145().h96_1, Companion_getInstance_145().i96_1, Companion_getInstance_145().j96_1, Companion_getInstance_145().k96_1, Companion_getInstance_145().l96_1, Companion_getInstance_145().m96_1, Companion_getInstance_145().n96_1, Companion_getInstance_145().o96_1, Companion_getInstance_145().p96_1, Companion_getInstance_145().q96_1, Companion_getInstance_145().r96_1, Companion_getInstance_145().s96_1, Companion_getInstance_145().t96_1, Companion_getInstance_145().u96_1, Companion_getInstance_145().v96_1, Companion_getInstance_145().w96_1, Companion_getInstance_145().x96_1, Companion_getInstance_145().y96_1]);
  }
  function Companion_146() {
    Companion_instance_146 = this;
    this.e97_1 = EmptyParameters_instance;
  }
  var Companion_instance_146;
  function Companion_getInstance_146() {
    if (Companion_instance_146 == null)
      new Companion_146();
    return Companion_instance_146;
  }
  function Parameters() {
  }
  function ParametersBuilder(size) {
    size = size === VOID ? 8 : size;
    return new ParametersBuilderImpl(size);
  }
  function EmptyParameters() {
  }
  protoOf(EmptyParameters).f8u = function () {
    return true;
  };
  protoOf(EmptyParameters).g8u = function (name) {
    return null;
  };
  protoOf(EmptyParameters).h8u = function () {
    return emptySet();
  };
  protoOf(EmptyParameters).i8u = function () {
    return emptySet();
  };
  protoOf(EmptyParameters).p = function () {
    return true;
  };
  protoOf(EmptyParameters).toString = function () {
    return 'Parameters ' + toString_1(this.i8u());
  };
  protoOf(EmptyParameters).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Parameters) : false) {
      tmp = other.p();
    } else {
      tmp = false;
    }
    return tmp;
  };
  var EmptyParameters_instance;
  function EmptyParameters_getInstance() {
    return EmptyParameters_instance;
  }
  function ParametersBuilderImpl(size) {
    size = size === VOID ? 8 : size;
    StringValuesBuilderImpl.call(this, true, size);
  }
  protoOf(ParametersBuilderImpl).k2p = function () {
    return new ParametersImpl(this.l8u_1);
  };
  function ParametersImpl(values) {
    values = values === VOID ? emptyMap() : values;
    StringValuesImpl.call(this, true, values);
  }
  protoOf(ParametersImpl).toString = function () {
    return 'Parameters ' + toString_1(this.i8u());
  };
  function parseQueryString(query, startIndex, limit, decode) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    limit = limit === VOID ? 1000 : limit;
    decode = decode === VOID ? true : decode;
    var tmp;
    if (startIndex > get_lastIndex_3(query)) {
      tmp = Companion_getInstance_146().e97_1;
    } else {
      // Inline function 'io.ktor.http.Companion.build' call
      Companion_getInstance_146();
      // Inline function 'kotlin.apply' call
      var this_0 = ParametersBuilder();
      // Inline function 'io.ktor.http.parseQueryString.<anonymous>' call
      parse_0(this_0, query, startIndex, limit, decode);
      tmp = this_0.k2p();
    }
    return tmp;
  }
  function parse_0(_this__u8e3s4, query, startIndex, limit, decode) {
    var count = 0;
    var nameIndex = startIndex;
    var equalIndex = -1;
    var inductionVariable = startIndex;
    var last = get_lastIndex_3(query);
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (count === limit) {
          return Unit_instance;
        }
        var tmp1_subject = charSequenceGet(query, index);
        if (tmp1_subject === _Char___init__impl__6a9atx(38)) {
          appendParam(_this__u8e3s4, query, nameIndex, equalIndex, index, decode);
          nameIndex = index + 1 | 0;
          equalIndex = -1;
          count = count + 1 | 0;
        } else if (tmp1_subject === _Char___init__impl__6a9atx(61)) {
          if (equalIndex === -1) {
            equalIndex = index;
          }
        }
      }
       while (!(index === last));
    if (count === limit) {
      return Unit_instance;
    }
    appendParam(_this__u8e3s4, query, nameIndex, equalIndex, query.length, decode);
  }
  function appendParam(_this__u8e3s4, query, nameIndex, equalIndex, endIndex, decode) {
    if (equalIndex === -1) {
      var spaceNameIndex = trimStart(nameIndex, endIndex, query);
      var spaceEndIndex = trimEnd_0(spaceNameIndex, endIndex, query);
      if (spaceEndIndex > spaceNameIndex) {
        var tmp;
        if (decode) {
          tmp = decodeURLQueryComponent(query, spaceNameIndex, spaceEndIndex);
        } else {
          // Inline function 'kotlin.text.substring' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp = query.substring(spaceNameIndex, spaceEndIndex);
        }
        var name = tmp;
        _this__u8e3s4.n8u(name, emptyList());
      }
      return Unit_instance;
    }
    var spaceNameIndex_0 = trimStart(nameIndex, equalIndex, query);
    var spaceEqualIndex = trimEnd_0(spaceNameIndex_0, equalIndex, query);
    if (spaceEqualIndex > spaceNameIndex_0) {
      var tmp_0;
      if (decode) {
        tmp_0 = decodeURLQueryComponent(query, spaceNameIndex_0, spaceEqualIndex);
      } else {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = query.substring(spaceNameIndex_0, spaceEqualIndex);
      }
      var name_0 = tmp_0;
      var spaceValueIndex = trimStart(equalIndex + 1 | 0, endIndex, query);
      var spaceEndIndex_0 = trimEnd_0(spaceValueIndex, endIndex, query);
      var tmp_1;
      if (decode) {
        tmp_1 = decodeURLQueryComponent(query, spaceValueIndex, spaceEndIndex_0, true);
      } else {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_1 = query.substring(spaceValueIndex, spaceEndIndex_0);
      }
      var value = tmp_1;
      _this__u8e3s4.r8u(name_0, value);
    }
  }
  function trimStart(start, end, query) {
    var spaceIndex = start;
    while (spaceIndex < end && isWhitespace(charSequenceGet(query, spaceIndex))) {
      spaceIndex = spaceIndex + 1 | 0;
    }
    return spaceIndex;
  }
  function trimEnd_0(start, end, text) {
    var spaceIndex = end;
    while (spaceIndex > start && isWhitespace(charSequenceGet(text, spaceIndex - 1 | 0))) {
      spaceIndex = spaceIndex - 1 | 0;
    }
    return spaceIndex;
  }
  function applyOrigin($this) {
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = $this.i97_1;
    if (charSequenceLength(this_0) > 0) {
      tmp = true;
    } else {
      tmp = $this.h97_1.r97_1 === 'file';
    }
    if (tmp)
      return Unit_instance;
    $this.i97_1 = Companion_getInstance_147().j98_1.u97_1;
    if ($this.h97_1.equals(Companion_getInstance_148().k98_1))
      $this.h97_1 = Companion_getInstance_147().j98_1.t97_1;
    if ($this.j97_1 === 0)
      $this.j97_1 = Companion_getInstance_147().j98_1.v97_1;
  }
  function Companion_147() {
    Companion_instance_147 = this;
    this.j98_1 = Url(get_origin(this));
  }
  var Companion_instance_147;
  function Companion_getInstance_147() {
    if (Companion_instance_147 == null)
      new Companion_147();
    return Companion_instance_147;
  }
  function URLBuilder(protocol, host, port, user, password, pathSegments, parameters, fragment, trailingQuery) {
    Companion_getInstance_147();
    protocol = protocol === VOID ? Companion_getInstance_148().k98_1 : protocol;
    host = host === VOID ? '' : host;
    port = port === VOID ? 0 : port;
    user = user === VOID ? null : user;
    password = password === VOID ? null : password;
    pathSegments = pathSegments === VOID ? emptyList() : pathSegments;
    parameters = parameters === VOID ? Companion_getInstance_146().e97_1 : parameters;
    fragment = fragment === VOID ? '' : fragment;
    trailingQuery = trailingQuery === VOID ? false : trailingQuery;
    this.h97_1 = protocol;
    this.i97_1 = host;
    this.j97_1 = port;
    this.k97_1 = trailingQuery;
    var tmp = this;
    tmp.l97_1 = user == null ? null : encodeURLParameter(user);
    var tmp_0 = this;
    tmp_0.m97_1 = password == null ? null : encodeURLParameter(password);
    this.n97_1 = encodeURLQueryComponent(fragment);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(pathSegments, 10));
    var _iterator__ex2g4s = pathSegments.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.http.URLBuilder.encodedPathSegments.<anonymous>' call
      var tmp$ret$0 = encodeURLPathPart(item);
      destination.e(tmp$ret$0);
    }
    tmp_1.o97_1 = destination;
    this.p97_1 = encodeParameters(parameters);
    this.q97_1 = new UrlDecodedParametersBuilder(this.p97_1);
  }
  protoOf(URLBuilder).q98 = function (value) {
    var tmp = this;
    tmp.l97_1 = value == null ? null : encodeURLParameter(value);
  };
  protoOf(URLBuilder).r98 = function () {
    var tmp0_safe_receiver = this.l97_1;
    return tmp0_safe_receiver == null ? null : decodeURLPart(tmp0_safe_receiver);
  };
  protoOf(URLBuilder).s98 = function () {
    var tmp0_safe_receiver = this.m97_1;
    return tmp0_safe_receiver == null ? null : decodeURLPart(tmp0_safe_receiver);
  };
  protoOf(URLBuilder).t98 = function () {
    return decodeURLQueryComponent(this.n97_1);
  };
  protoOf(URLBuilder).u98 = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.o97_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.http.URLBuilder.<get-pathSegments>.<anonymous>' call
      var tmp$ret$0 = decodeURLPart(item);
      destination.e(tmp$ret$0);
    }
    return destination;
  };
  protoOf(URLBuilder).v98 = function (value) {
    this.p97_1 = value;
    this.q97_1 = new UrlDecodedParametersBuilder(value);
  };
  protoOf(URLBuilder).w98 = function () {
    applyOrigin(this);
    return appendTo(this, StringBuilder_init_$Create$(256)).toString();
  };
  protoOf(URLBuilder).toString = function () {
    return appendTo(this, StringBuilder_init_$Create$(256)).toString();
  };
  protoOf(URLBuilder).k2p = function () {
    applyOrigin(this);
    return new Url_0(this.h97_1, this.i97_1, this.j97_1, this.u98(), this.q97_1.k2p(), this.t98(), this.r98(), this.s98(), this.k97_1, this.w98());
  };
  function get_authority(_this__u8e3s4) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'io.ktor.http.<get-authority>.<anonymous>' call
    this_0.d9(get_encodedUserAndPassword(_this__u8e3s4));
    this_0.d9(_this__u8e3s4.i97_1);
    if (!(_this__u8e3s4.j97_1 === 0) && !(_this__u8e3s4.j97_1 === _this__u8e3s4.h97_1.s97_1)) {
      this_0.d9(':');
      this_0.d9(_this__u8e3s4.j97_1.toString());
    }
    return this_0.toString();
  }
  function appendTo(_this__u8e3s4, out) {
    out.f(_this__u8e3s4.h97_1.r97_1);
    var tmp0_subject = _this__u8e3s4.h97_1.r97_1;
    if (tmp0_subject === 'file') {
      appendFile(out, _this__u8e3s4.i97_1, get_encodedPath(_this__u8e3s4));
      return out;
    } else if (tmp0_subject === 'mailto') {
      appendMailto(out, get_encodedUserAndPassword(_this__u8e3s4), _this__u8e3s4.i97_1);
      return out;
    }
    out.f('://');
    out.f(get_authority(_this__u8e3s4));
    appendUrlFullPath(out, get_encodedPath(_this__u8e3s4), _this__u8e3s4.p97_1, _this__u8e3s4.k97_1);
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = _this__u8e3s4.n97_1;
    if (charSequenceLength(this_0) > 0) {
      out.e9(_Char___init__impl__6a9atx(35));
      out.f(_this__u8e3s4.n97_1);
    }
    return out;
  }
  function get_encodedUserAndPassword(_this__u8e3s4) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'io.ktor.http.<get-encodedUserAndPassword>.<anonymous>' call
    appendUserAndPassword(this_0, _this__u8e3s4.l97_1, _this__u8e3s4.m97_1);
    return this_0.toString();
  }
  function appendFile(_this__u8e3s4, host, encodedPath) {
    _this__u8e3s4.f('://');
    _this__u8e3s4.f(host);
    if (!startsWith_1(encodedPath, _Char___init__impl__6a9atx(47))) {
      _this__u8e3s4.e9(_Char___init__impl__6a9atx(47));
    }
    _this__u8e3s4.f(encodedPath);
  }
  function set_encodedPath(_this__u8e3s4, value) {
    _this__u8e3s4.o97_1 = isBlank(value) ? emptyList() : value === '/' ? get_ROOT_PATH() : toMutableList_1(split(value, charArrayOf([_Char___init__impl__6a9atx(47)])));
  }
  function get_encodedPath(_this__u8e3s4) {
    return joinPath(_this__u8e3s4.o97_1);
  }
  function appendMailto(_this__u8e3s4, encodedUser, host) {
    _this__u8e3s4.f(':');
    _this__u8e3s4.f(encodedUser);
    _this__u8e3s4.f(host);
  }
  function joinPath(_this__u8e3s4) {
    if (_this__u8e3s4.p())
      return '';
    if (_this__u8e3s4.n() === 1) {
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = first(_this__u8e3s4);
      if (charSequenceLength(this_0) === 0)
        return '/';
      return first(_this__u8e3s4);
    }
    return joinToString_0(_this__u8e3s4, '/');
  }
  function set_0(_this__u8e3s4, scheme, host, port, path, block) {
    scheme = scheme === VOID ? null : scheme;
    host = host === VOID ? null : host;
    port = port === VOID ? null : port;
    path = path === VOID ? null : path;
    var tmp;
    if (block === VOID) {
      tmp = set$lambda;
    } else {
      tmp = block;
    }
    block = tmp;
    if (!(scheme == null))
      _this__u8e3s4.h97_1 = Companion_getInstance_148().x98(scheme);
    if (!(host == null))
      _this__u8e3s4.i97_1 = host;
    if (!(port == null))
      _this__u8e3s4.j97_1 = port;
    if (!(path == null)) {
      set_encodedPath(_this__u8e3s4, path);
    }
    block(_this__u8e3s4);
  }
  function set$lambda($this$null) {
    return Unit_instance;
  }
  function get_ROOT_PATH() {
    _init_properties_URLParser_kt__sf11to();
    return ROOT_PATH;
  }
  var ROOT_PATH;
  function takeFrom(_this__u8e3s4, urlString) {
    _init_properties_URLParser_kt__sf11to();
    if (isBlank(urlString))
      return _this__u8e3s4;
    var tmp;
    try {
      tmp = takeFromUnsafe(_this__u8e3s4, urlString);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var cause = $p;
        throw new URLParserException(urlString, cause);
      } else {
        throw $p;
      }
    }
    return tmp;
  }
  function takeFromUnsafe(_this__u8e3s4, urlString) {
    _init_properties_URLParser_kt__sf11to();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.indexOfFirst' call
      var inductionVariable = 0;
      var last = charSequenceLength(urlString) - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'io.ktor.http.takeFromUnsafe.<anonymous>' call
          var it = charSequenceGet(urlString, index);
          if (!isWhitespace(it)) {
            tmp$ret$1 = index;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$1 = -1;
    }
    var startIndex = tmp$ret$1;
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.text.indexOfLast' call
      var inductionVariable_0 = charSequenceLength(urlString) - 1 | 0;
      if (0 <= inductionVariable_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          // Inline function 'io.ktor.http.takeFromUnsafe.<anonymous>' call
          var it_0 = charSequenceGet(urlString, index_0);
          if (!isWhitespace(it_0)) {
            tmp$ret$3 = index_0;
            break $l$block_0;
          }
        }
         while (0 <= inductionVariable_0);
      tmp$ret$3 = -1;
    }
    var endIndex = tmp$ret$3 + 1 | 0;
    var schemeLength = findScheme(urlString, startIndex, endIndex);
    if (schemeLength > 0) {
      var tmp5 = startIndex;
      // Inline function 'kotlin.text.substring' call
      var endIndex_0 = startIndex + schemeLength | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var scheme = urlString.substring(tmp5, endIndex_0);
      _this__u8e3s4.h97_1 = Companion_getInstance_148().x98(scheme);
      startIndex = startIndex + (schemeLength + 1 | 0) | 0;
    }
    var slashCount = count(urlString, startIndex, endIndex, _Char___init__impl__6a9atx(47));
    startIndex = startIndex + slashCount | 0;
    if (_this__u8e3s4.h97_1.r97_1 === 'file') {
      parseFile(_this__u8e3s4, urlString, startIndex, endIndex, slashCount);
      return _this__u8e3s4;
    }
    if (_this__u8e3s4.h97_1.r97_1 === 'mailto') {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!(slashCount === 0)) {
        // Inline function 'kotlin.require.<anonymous>' call
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      parseMailto(_this__u8e3s4, urlString, startIndex, endIndex);
      return _this__u8e3s4;
    }
    if (slashCount >= 2) {
      loop: while (true) {
        // Inline function 'kotlin.takeIf' call
        var this_0 = indexOfAny(urlString, toCharArray('@/\\?#'), startIndex);
        var tmp;
        // Inline function 'io.ktor.http.takeFromUnsafe.<anonymous>' call
        if (this_0 > 0) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var delimiter = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
        if (delimiter < endIndex && charSequenceGet(urlString, delimiter) === _Char___init__impl__6a9atx(64)) {
          var passwordIndex = indexOfColonInHostPort(urlString, startIndex, delimiter);
          if (!(passwordIndex === -1)) {
            var tmp_0 = _this__u8e3s4;
            // Inline function 'kotlin.text.substring' call
            var startIndex_0 = startIndex;
            // Inline function 'kotlin.js.asDynamic' call
            tmp_0.l97_1 = urlString.substring(startIndex_0, passwordIndex);
            var tmp_1 = _this__u8e3s4;
            // Inline function 'kotlin.text.substring' call
            var startIndex_1 = passwordIndex + 1 | 0;
            // Inline function 'kotlin.js.asDynamic' call
            tmp_1.m97_1 = urlString.substring(startIndex_1, delimiter);
          } else {
            var tmp_2 = _this__u8e3s4;
            // Inline function 'kotlin.text.substring' call
            var startIndex_2 = startIndex;
            // Inline function 'kotlin.js.asDynamic' call
            tmp_2.l97_1 = urlString.substring(startIndex_2, delimiter);
          }
          startIndex = delimiter + 1 | 0;
        } else {
          fillHost(_this__u8e3s4, urlString, startIndex, delimiter);
          startIndex = delimiter;
          break loop;
        }
      }
    }
    if (startIndex >= endIndex) {
      _this__u8e3s4.o97_1 = charSequenceGet(urlString, endIndex - 1 | 0) === _Char___init__impl__6a9atx(47) ? get_ROOT_PATH() : emptyList();
      return _this__u8e3s4;
    }
    var tmp_3 = _this__u8e3s4;
    var tmp_4;
    if (slashCount === 0) {
      tmp_4 = dropLast(_this__u8e3s4.o97_1, 1);
    } else {
      tmp_4 = emptyList();
    }
    tmp_3.o97_1 = tmp_4;
    // Inline function 'kotlin.takeIf' call
    var this_1 = indexOfAny(urlString, toCharArray('?#'), startIndex);
    var tmp_5;
    // Inline function 'io.ktor.http.takeFromUnsafe.<anonymous>' call
    if (this_1 > 0) {
      tmp_5 = this_1;
    } else {
      tmp_5 = null;
    }
    var tmp1_elvis_lhs = tmp_5;
    var pathEnd = tmp1_elvis_lhs == null ? endIndex : tmp1_elvis_lhs;
    if (pathEnd > startIndex) {
      // Inline function 'kotlin.text.substring' call
      var startIndex_3 = startIndex;
      // Inline function 'kotlin.js.asDynamic' call
      var rawPath = urlString.substring(startIndex_3, pathEnd);
      var tmp_6;
      var tmp_7;
      if (_this__u8e3s4.o97_1.n() === 1) {
        // Inline function 'kotlin.text.isEmpty' call
        var this_2 = first(_this__u8e3s4.o97_1);
        tmp_7 = charSequenceLength(this_2) === 0;
      } else {
        tmp_7 = false;
      }
      if (tmp_7) {
        tmp_6 = emptyList();
      } else {
        tmp_6 = _this__u8e3s4.o97_1;
      }
      var basePath = tmp_6;
      var rawChunks = rawPath === '/' ? get_ROOT_PATH() : split(rawPath, charArrayOf([_Char___init__impl__6a9atx(47)]));
      var relativePath = plus_4(slashCount === 1 ? get_ROOT_PATH() : emptyList(), rawChunks);
      _this__u8e3s4.o97_1 = plus_4(basePath, relativePath);
      startIndex = pathEnd;
    }
    if (startIndex < endIndex && charSequenceGet(urlString, startIndex) === _Char___init__impl__6a9atx(63)) {
      startIndex = parseQuery(_this__u8e3s4, urlString, startIndex, endIndex);
    }
    parseFragment(_this__u8e3s4, urlString, startIndex, endIndex);
    return _this__u8e3s4;
  }
  function URLParserException(urlString, cause) {
    IllegalStateException_init_$Init$_1('Fail to parse url: ' + urlString, cause, this);
    captureStack(this, URLParserException);
  }
  function findScheme(urlString, startIndex, endIndex) {
    _init_properties_URLParser_kt__sf11to();
    var current = startIndex;
    var incorrectSchemePosition = -1;
    var firstChar = charSequenceGet(urlString, current);
    if (!(_Char___init__impl__6a9atx(97) <= firstChar ? firstChar <= _Char___init__impl__6a9atx(122) : false) && !(_Char___init__impl__6a9atx(65) <= firstChar ? firstChar <= _Char___init__impl__6a9atx(90) : false)) {
      incorrectSchemePosition = current;
    }
    while (current < endIndex) {
      var char = charSequenceGet(urlString, current);
      if (char === _Char___init__impl__6a9atx(58)) {
        if (!(incorrectSchemePosition === -1)) {
          throw IllegalArgumentException_init_$Create$_0('Illegal character in scheme at position ' + incorrectSchemePosition);
        }
        return current - startIndex | 0;
      }
      if (char === _Char___init__impl__6a9atx(47) || char === _Char___init__impl__6a9atx(63) || char === _Char___init__impl__6a9atx(35))
        return -1;
      if (incorrectSchemePosition === -1 && !(_Char___init__impl__6a9atx(97) <= char ? char <= _Char___init__impl__6a9atx(122) : false) && !(_Char___init__impl__6a9atx(65) <= char ? char <= _Char___init__impl__6a9atx(90) : false) && !(_Char___init__impl__6a9atx(48) <= char ? char <= _Char___init__impl__6a9atx(57) : false) && !(char === _Char___init__impl__6a9atx(46)) && !(char === _Char___init__impl__6a9atx(43)) && !(char === _Char___init__impl__6a9atx(45))) {
        incorrectSchemePosition = current;
      }
      current = current + 1 | 0;
    }
    return -1;
  }
  function count(urlString, startIndex, endIndex, char) {
    _init_properties_URLParser_kt__sf11to();
    var result = 0;
    $l$loop: while ((startIndex + result | 0) < endIndex && charSequenceGet(urlString, startIndex + result | 0) === char) {
      result = result + 1 | 0;
    }
    return result;
  }
  function parseFile(_this__u8e3s4, urlString, startIndex, endIndex, slashCount) {
    _init_properties_URLParser_kt__sf11to();
    switch (slashCount) {
      case 2:
        var nextSlash = indexOf_8(urlString, _Char___init__impl__6a9atx(47), startIndex);
        if (nextSlash === -1 || nextSlash === endIndex) {
          var tmp = _this__u8e3s4;
          // Inline function 'kotlin.text.substring' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp.i97_1 = urlString.substring(startIndex, endIndex);
          return Unit_instance;
        }

        var tmp_0 = _this__u8e3s4;
        // Inline function 'kotlin.text.substring' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0.i97_1 = urlString.substring(startIndex, nextSlash);
        // Inline function 'kotlin.text.substring' call

        // Inline function 'kotlin.js.asDynamic' call

        var tmp$ret$5 = urlString.substring(nextSlash, endIndex);
        set_encodedPath(_this__u8e3s4, tmp$ret$5);
        break;
      case 3:
        _this__u8e3s4.i97_1 = '';
        // Inline function 'kotlin.text.substring' call

        // Inline function 'kotlin.js.asDynamic' call

        var tmp$ret$7 = urlString.substring(startIndex, endIndex);
        set_encodedPath(_this__u8e3s4, '/' + tmp$ret$7);
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('Invalid file url: ' + urlString);
    }
  }
  function parseMailto(_this__u8e3s4, urlString, startIndex, endIndex) {
    _init_properties_URLParser_kt__sf11to();
    var delimiter = indexOf_9(urlString, '@', startIndex);
    if (delimiter === -1) {
      throw IllegalArgumentException_init_$Create$_0('Invalid mailto url: ' + urlString + ", it should contain '@'.");
    }
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = urlString.substring(startIndex, delimiter);
    _this__u8e3s4.q98(decodeURLPart(tmp$ret$1));
    var tmp = _this__u8e3s4;
    // Inline function 'kotlin.text.substring' call
    var startIndex_0 = delimiter + 1 | 0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i97_1 = urlString.substring(startIndex_0, endIndex);
  }
  function indexOfColonInHostPort(_this__u8e3s4, startIndex, endIndex) {
    _init_properties_URLParser_kt__sf11to();
    var skip = false;
    var inductionVariable = startIndex;
    if (inductionVariable < endIndex)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp1_subject = charSequenceGet(_this__u8e3s4, index);
        if (tmp1_subject === _Char___init__impl__6a9atx(91))
          skip = true;
        else if (tmp1_subject === _Char___init__impl__6a9atx(93))
          skip = false;
        else if (tmp1_subject === _Char___init__impl__6a9atx(58))
          if (!skip)
            return index;
      }
       while (inductionVariable < endIndex);
    return -1;
  }
  function fillHost(_this__u8e3s4, urlString, startIndex, endIndex) {
    _init_properties_URLParser_kt__sf11to();
    // Inline function 'kotlin.takeIf' call
    var this_0 = indexOfColonInHostPort(urlString, startIndex, endIndex);
    var tmp;
    // Inline function 'io.ktor.http.fillHost.<anonymous>' call
    if (this_0 > 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var colonIndex = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
    var tmp_0 = _this__u8e3s4;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.i97_1 = urlString.substring(startIndex, colonIndex);
    if ((colonIndex + 1 | 0) < endIndex) {
      var tmp_1 = _this__u8e3s4;
      // Inline function 'kotlin.text.substring' call
      var startIndex_0 = colonIndex + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$5 = urlString.substring(startIndex_0, endIndex);
      tmp_1.j97_1 = toInt(tmp$ret$5);
    } else {
      _this__u8e3s4.j97_1 = 0;
    }
  }
  function parseQuery(_this__u8e3s4, urlString, startIndex, endIndex) {
    _init_properties_URLParser_kt__sf11to();
    if ((startIndex + 1 | 0) === endIndex) {
      _this__u8e3s4.k97_1 = true;
      return endIndex;
    }
    // Inline function 'kotlin.takeIf' call
    var this_0 = indexOf_8(urlString, _Char___init__impl__6a9atx(35), startIndex + 1 | 0);
    var tmp;
    // Inline function 'io.ktor.http.parseQuery.<anonymous>' call
    if (this_0 > 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var fragmentStart = tmp0_elvis_lhs == null ? endIndex : tmp0_elvis_lhs;
    // Inline function 'kotlin.text.substring' call
    var startIndex_0 = startIndex + 1 | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = urlString.substring(startIndex_0, fragmentStart);
    var rawParameters = parseQueryString(tmp$ret$3, VOID, VOID, false);
    rawParameters.j8u(parseQuery$lambda(_this__u8e3s4));
    return fragmentStart;
  }
  function parseFragment(_this__u8e3s4, urlString, startIndex, endIndex) {
    _init_properties_URLParser_kt__sf11to();
    if (startIndex < endIndex && charSequenceGet(urlString, startIndex) === _Char___init__impl__6a9atx(35)) {
      var tmp = _this__u8e3s4;
      // Inline function 'kotlin.text.substring' call
      var startIndex_0 = startIndex + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp.n97_1 = urlString.substring(startIndex_0, endIndex);
    }
  }
  function parseQuery$lambda($this_parseQuery) {
    return function (key, values) {
      $this_parseQuery.p97_1.n8u(key, values);
      return Unit_instance;
    };
  }
  var properties_initialized_URLParser_kt_hd1g6a;
  function _init_properties_URLParser_kt__sf11to() {
    if (!properties_initialized_URLParser_kt_hd1g6a) {
      properties_initialized_URLParser_kt_hd1g6a = true;
      ROOT_PATH = listOf('');
    }
  }
  function isWebsocket(_this__u8e3s4) {
    return _this__u8e3s4.r97_1 === 'ws' || _this__u8e3s4.r97_1 === 'wss';
  }
  function Companion_148() {
    Companion_instance_148 = this;
    this.k98_1 = new URLProtocol('http', 80);
    this.l98_1 = new URLProtocol('https', 443);
    this.m98_1 = new URLProtocol('ws', 80);
    this.n98_1 = new URLProtocol('wss', 443);
    this.o98_1 = new URLProtocol('socks', 1080);
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = listOf_0([this.k98_1, this.l98_1, this.m98_1, this.n98_1, this.o98_1]);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.http.Companion.byName.<anonymous>' call
      var tmp$ret$0 = element.r97_1;
      destination.r2(tmp$ret$0, element);
    }
    tmp.p98_1 = destination;
  }
  protoOf(Companion_148).x98 = function (name) {
    // Inline function 'kotlin.let' call
    // Inline function 'io.ktor.http.Companion.createOrDefault.<anonymous>' call
    var it = toLowerCasePreservingASCIIRules(name);
    var tmp0_elvis_lhs = Companion_getInstance_148().p98_1.y2(it);
    return tmp0_elvis_lhs == null ? new URLProtocol(it, 0) : tmp0_elvis_lhs;
  };
  var Companion_instance_148;
  function Companion_getInstance_148() {
    if (Companion_instance_148 == null)
      new Companion_148();
    return Companion_instance_148;
  }
  function URLProtocol(name, defaultPort) {
    Companion_getInstance_148();
    this.r97_1 = name;
    this.s97_1 = defaultPort;
    var tmp0 = this.r97_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.all' call
      var inductionVariable = 0;
      while (inductionVariable < charSequenceLength(tmp0)) {
        var element = charSequenceGet(tmp0, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'io.ktor.http.URLProtocol.<anonymous>' call
        if (!isLowerCase_0(element)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    // Inline function 'kotlin.require' call
    if (!tmp$ret$1) {
      // Inline function 'io.ktor.http.URLProtocol.<anonymous>' call
      var message = 'All characters should be lower case';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(URLProtocol).toString = function () {
    return 'URLProtocol(name=' + this.r97_1 + ', defaultPort=' + this.s97_1 + ')';
  };
  protoOf(URLProtocol).hashCode = function () {
    var result = getStringHashCode(this.r97_1);
    result = imul(result, 31) + this.s97_1 | 0;
    return result;
  };
  protoOf(URLProtocol).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof URLProtocol))
      return false;
    var tmp0_other_with_cast = other instanceof URLProtocol ? other : THROW_CCE();
    if (!(this.r97_1 === tmp0_other_with_cast.r97_1))
      return false;
    if (!(this.s97_1 === tmp0_other_with_cast.s97_1))
      return false;
    return true;
  };
  function isSecure(_this__u8e3s4) {
    return _this__u8e3s4.r97_1 === 'https' || _this__u8e3s4.r97_1 === 'wss';
  }
  function takeFrom_0(_this__u8e3s4, url) {
    _this__u8e3s4.h97_1 = url.h97_1;
    _this__u8e3s4.i97_1 = url.i97_1;
    _this__u8e3s4.j97_1 = url.j97_1;
    _this__u8e3s4.o97_1 = url.o97_1;
    _this__u8e3s4.l97_1 = url.l97_1;
    _this__u8e3s4.m97_1 = url.m97_1;
    // Inline function 'kotlin.apply' call
    var this_0 = ParametersBuilder();
    // Inline function 'io.ktor.http.takeFrom.<anonymous>' call
    appendAll(this_0, url.p97_1);
    _this__u8e3s4.v98(this_0);
    _this__u8e3s4.n97_1 = url.n97_1;
    _this__u8e3s4.k97_1 = url.k97_1;
    return _this__u8e3s4;
  }
  function Url(urlString) {
    return URLBuilder_0(urlString).k2p();
  }
  function appendUrlFullPath(_this__u8e3s4, encodedPath, encodedQueryParameters, trailingQuery) {
    var tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(encodedPath)) {
      tmp = !startsWith(encodedPath, '/');
    } else {
      tmp = false;
    }
    if (tmp) {
      _this__u8e3s4.e9(_Char___init__impl__6a9atx(47));
    }
    _this__u8e3s4.f(encodedPath);
    if (!encodedQueryParameters.p() || trailingQuery) {
      _this__u8e3s4.f('?');
    }
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = encodedQueryParameters.i8u();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.http.appendUrlFullPath.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.x();
      // Inline function 'kotlin.collections.component2' call
      var value = element.y();
      var tmp_0;
      if (value.p()) {
        tmp_0 = listOf(to(key, null));
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(value, 10));
        var _iterator__ex2g4s_0 = value.k();
        while (_iterator__ex2g4s_0.l()) {
          var item = _iterator__ex2g4s_0.m();
          // Inline function 'io.ktor.http.appendUrlFullPath.<anonymous>.<anonymous>' call
          var tmp$ret$3 = to(key, item);
          destination_0.e(tmp$ret$3);
        }
        tmp_0 = destination_0;
      }
      var list = tmp_0;
      addAll_1(destination, list);
    }
    var tmp_1 = destination;
    joinTo_0(tmp_1, _this__u8e3s4, '&', VOID, VOID, VOID, VOID, appendUrlFullPath$lambda);
  }
  function appendUserAndPassword(_this__u8e3s4, encodedUser, encodedPassword) {
    if (encodedUser == null) {
      return Unit_instance;
    }
    _this__u8e3s4.d9(encodedUser);
    if (!(encodedPassword == null)) {
      _this__u8e3s4.e9(_Char___init__impl__6a9atx(58));
      _this__u8e3s4.d9(encodedPassword);
    }
    _this__u8e3s4.d9('@');
  }
  function get_hostWithPort(_this__u8e3s4) {
    return _this__u8e3s4.u97_1 + ':' + _this__u8e3s4.y98();
  }
  function URLBuilder_0(urlString) {
    return takeFrom(new URLBuilder(), urlString);
  }
  function appendUrlFullPath$lambda(it) {
    var key = it.dh_1;
    var tmp;
    if (it.eh_1 == null) {
      tmp = key;
    } else {
      var value = toString_0(it.eh_1);
      tmp = key + '=' + value;
    }
    return tmp;
  }
  function Companion_149() {
  }
  var Companion_instance_149;
  function Companion_getInstance_149() {
    return Companion_instance_149;
  }
  function Url$encodedPath$delegate$lambda(this$0) {
    return function () {
      var tmp;
      if (this$0.w97_1.p()) {
        return '';
      }
      var pathStartIndex = indexOf_8(this$0.c98_1, _Char___init__impl__6a9atx(47), this$0.t97_1.r97_1.length + 3 | 0);
      var tmp_0;
      if (pathStartIndex === -1) {
        return '';
      }
      // Inline function 'kotlin.charArrayOf' call
      var tmp$ret$0 = charArrayOf([_Char___init__impl__6a9atx(63), _Char___init__impl__6a9atx(35)]);
      var pathEndIndex = indexOfAny(this$0.c98_1, tmp$ret$0, pathStartIndex);
      var tmp_1;
      if (pathEndIndex === -1) {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        return this$0.c98_1.substring(pathStartIndex);
      }
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      return this$0.c98_1.substring(pathStartIndex, pathEndIndex);
    };
  }
  function Url$encodedQuery$delegate$lambda(this$0) {
    return function () {
      var queryStart = indexOf_8(this$0.c98_1, _Char___init__impl__6a9atx(63)) + 1 | 0;
      var tmp;
      if (queryStart === 0) {
        return '';
      }
      var queryEnd = indexOf_8(this$0.c98_1, _Char___init__impl__6a9atx(35), queryStart);
      var tmp_0;
      if (queryEnd === -1) {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        return this$0.c98_1.substring(queryStart);
      }
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      return this$0.c98_1.substring(queryStart, queryEnd);
    };
  }
  function Url$encodedPathAndQuery$delegate$lambda(this$0) {
    return function () {
      var pathStart = indexOf_8(this$0.c98_1, _Char___init__impl__6a9atx(47), this$0.t97_1.r97_1.length + 3 | 0);
      var tmp;
      if (pathStart === -1) {
        return '';
      }
      var queryEnd = indexOf_8(this$0.c98_1, _Char___init__impl__6a9atx(35), pathStart);
      var tmp_0;
      if (queryEnd === -1) {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        return this$0.c98_1.substring(pathStart);
      }
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      return this$0.c98_1.substring(pathStart, queryEnd);
    };
  }
  function Url$encodedUser$delegate$lambda(this$0) {
    return function () {
      var tmp;
      if (this$0.z97_1 == null) {
        return null;
      }
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = this$0.z97_1;
      if (charSequenceLength(this_0) === 0) {
        return '';
      }
      var usernameStart = this$0.t97_1.r97_1.length + 3 | 0;
      // Inline function 'kotlin.charArrayOf' call
      var tmp$ret$1 = charArrayOf([_Char___init__impl__6a9atx(58), _Char___init__impl__6a9atx(64)]);
      var usernameEnd = indexOfAny(this$0.c98_1, tmp$ret$1, usernameStart);
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      return this$0.c98_1.substring(usernameStart, usernameEnd);
    };
  }
  function Url$encodedPassword$delegate$lambda(this$0) {
    return function () {
      var tmp;
      if (this$0.a98_1 == null) {
        return null;
      }
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = this$0.a98_1;
      if (charSequenceLength(this_0) === 0) {
        return '';
      }
      var passwordStart = indexOf_8(this$0.c98_1, _Char___init__impl__6a9atx(58), this$0.t97_1.r97_1.length + 3 | 0) + 1 | 0;
      var passwordEnd = indexOf_8(this$0.c98_1, _Char___init__impl__6a9atx(64));
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      return this$0.c98_1.substring(passwordStart, passwordEnd);
    };
  }
  function Url$encodedFragment$delegate$lambda(this$0) {
    return function () {
      var fragmentStart = indexOf_8(this$0.c98_1, _Char___init__impl__6a9atx(35)) + 1 | 0;
      var tmp;
      if (fragmentStart === 0) {
        return '';
      }
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      return this$0.c98_1.substring(fragmentStart);
    };
  }
  function Url_0(protocol, host, specifiedPort, pathSegments, parameters, fragment, user, password, trailingQuery, urlString) {
    this.t97_1 = protocol;
    this.u97_1 = host;
    this.v97_1 = specifiedPort;
    this.w97_1 = pathSegments;
    this.x97_1 = parameters;
    this.y97_1 = fragment;
    this.z97_1 = user;
    this.a98_1 = password;
    this.b98_1 = trailingQuery;
    this.c98_1 = urlString;
    var tmp;
    var containsArg = this.v97_1;
    if (0 <= containsArg ? containsArg <= 65535 : false) {
      tmp = true;
    } else {
      tmp = this.v97_1 === 0;
    }
    // Inline function 'kotlin.require' call
    if (!tmp) {
      // Inline function 'io.ktor.http.Url.<anonymous>' call
      var message = 'port must be between 0 and 65535, or 0 if not set';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp_0 = this;
    tmp_0.d98_1 = lazy_0(Url$encodedPath$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.e98_1 = lazy_0(Url$encodedQuery$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.f98_1 = lazy_0(Url$encodedPathAndQuery$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.g98_1 = lazy_0(Url$encodedUser$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.h98_1 = lazy_0(Url$encodedPassword$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.i98_1 = lazy_0(Url$encodedFragment$delegate$lambda(this));
  }
  protoOf(Url_0).y98 = function () {
    // Inline function 'kotlin.takeUnless' call
    var this_0 = this.v97_1;
    var tmp;
    // Inline function 'io.ktor.http.Url.<get-port>.<anonymous>' call
    if (!(this_0 === 0)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? this.t97_1.s97_1 : tmp0_elvis_lhs;
  };
  protoOf(Url_0).z98 = function () {
    var tmp0 = this.g98_1;
    // Inline function 'kotlin.getValue' call
    encodedUser$factory();
    return tmp0.y();
  };
  protoOf(Url_0).a99 = function () {
    var tmp0 = this.h98_1;
    // Inline function 'kotlin.getValue' call
    encodedPassword$factory();
    return tmp0.y();
  };
  protoOf(Url_0).toString = function () {
    return this.c98_1;
  };
  protoOf(Url_0).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof Url_0))
      THROW_CCE();
    if (!(this.c98_1 === other.c98_1))
      return false;
    return true;
  };
  protoOf(Url_0).hashCode = function () {
    return getStringHashCode(this.c98_1);
  };
  function get_authority_0(_this__u8e3s4) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'io.ktor.http.<get-authority>.<anonymous>' call
    this_0.d9(get_encodedUserAndPassword_0(_this__u8e3s4));
    if (_this__u8e3s4.v97_1 === 0 || _this__u8e3s4.v97_1 === _this__u8e3s4.t97_1.s97_1) {
      this_0.d9(_this__u8e3s4.u97_1);
    } else {
      this_0.d9(get_hostWithPort(_this__u8e3s4));
    }
    return this_0.toString();
  }
  function get_encodedUserAndPassword_0(_this__u8e3s4) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'io.ktor.http.<get-encodedUserAndPassword>.<anonymous>' call
    appendUserAndPassword(this_0, _this__u8e3s4.z98(), _this__u8e3s4.a99());
    return this_0.toString();
  }
  function encodedUser$factory() {
    return getPropertyCallableRef('encodedUser', 1, KProperty1, function (receiver) {
      return receiver.z98();
    }, null);
  }
  function encodedPassword$factory() {
    return getPropertyCallableRef('encodedPassword', 1, KProperty1, function (receiver) {
      return receiver.a99();
    }, null);
  }
  function UrlDecodedParametersBuilder(encodedParametersBuilder) {
    this.b99_1 = encodedParametersBuilder;
    this.c99_1 = this.b99_1.f8u();
  }
  protoOf(UrlDecodedParametersBuilder).k2p = function () {
    return decodeParameters(this.b99_1);
  };
  protoOf(UrlDecodedParametersBuilder).f8u = function () {
    return this.c99_1;
  };
  protoOf(UrlDecodedParametersBuilder).g8u = function (name) {
    var tmp0_safe_receiver = this.b99_1.g8u(encodeURLParameter(name));
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_safe_receiver, 10));
      var _iterator__ex2g4s = tmp0_safe_receiver.k();
      while (_iterator__ex2g4s.l()) {
        var item = _iterator__ex2g4s.m();
        // Inline function 'io.ktor.http.UrlDecodedParametersBuilder.getAll.<anonymous>' call
        var tmp$ret$0 = decodeURLQueryComponent(item, VOID, VOID, true);
        destination.e(tmp$ret$0);
      }
      tmp = destination;
    }
    return tmp;
  };
  protoOf(UrlDecodedParametersBuilder).h8u = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.b99_1.h8u();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.http.UrlDecodedParametersBuilder.names.<anonymous>' call
      var tmp$ret$0 = decodeURLQueryComponent(item);
      destination.e(tmp$ret$0);
    }
    return toSet_0(destination);
  };
  protoOf(UrlDecodedParametersBuilder).p = function () {
    return this.b99_1.p();
  };
  protoOf(UrlDecodedParametersBuilder).i8u = function () {
    return decodeParameters(this.b99_1).i8u();
  };
  protoOf(UrlDecodedParametersBuilder).r8u = function (name, value) {
    return this.b99_1.r8u(encodeURLParameter(name), encodeURLParameterValue(value));
  };
  protoOf(UrlDecodedParametersBuilder).n8u = function (name, values) {
    var tmp = encodeURLParameter(name);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s = values.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.http.UrlDecodedParametersBuilder.appendAll.<anonymous>' call
      var tmp$ret$0 = encodeURLParameterValue(item);
      destination.e(tmp$ret$0);
    }
    return this.b99_1.n8u(tmp, destination);
  };
  protoOf(UrlDecodedParametersBuilder).m2 = function () {
    return this.b99_1.m2();
  };
  function encodeParameters(parameters) {
    // Inline function 'kotlin.apply' call
    var this_0 = ParametersBuilder();
    // Inline function 'io.ktor.http.encodeParameters.<anonymous>' call
    appendAllEncoded(this_0, parameters);
    return this_0;
  }
  function decodeParameters(parameters) {
    // Inline function 'kotlin.apply' call
    var this_0 = ParametersBuilder();
    // Inline function 'io.ktor.http.decodeParameters.<anonymous>' call
    appendAllDecoded(this_0, parameters);
    return this_0.k2p();
  }
  function appendAllEncoded(_this__u8e3s4, parameters) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = parameters.h8u().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.http.appendAllEncoded.<anonymous>' call
      var tmp0_elvis_lhs = parameters.g8u(element);
      var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      var tmp = encodeURLParameter(element);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(values, 10));
      var _iterator__ex2g4s_0 = values.k();
      while (_iterator__ex2g4s_0.l()) {
        var item = _iterator__ex2g4s_0.m();
        // Inline function 'io.ktor.http.appendAllEncoded.<anonymous>.<anonymous>' call
        var tmp$ret$0 = encodeURLParameterValue(item);
        destination.e(tmp$ret$0);
      }
      _this__u8e3s4.n8u(tmp, destination);
    }
  }
  function appendAllDecoded(_this__u8e3s4, parameters) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = parameters.h8u().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.http.appendAllDecoded.<anonymous>' call
      var tmp0_elvis_lhs = parameters.g8u(element);
      var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      var tmp = decodeURLQueryComponent(element);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(values, 10));
      var _iterator__ex2g4s_0 = values.k();
      while (_iterator__ex2g4s_0.l()) {
        var item = _iterator__ex2g4s_0.m();
        // Inline function 'io.ktor.http.appendAllDecoded.<anonymous>.<anonymous>' call
        var tmp$ret$0 = decodeURLQueryComponent(item, VOID, VOID, true);
        destination.e(tmp$ret$0);
      }
      _this__u8e3s4.n8u(tmp, destination);
    }
  }
  function ByteArrayContent(bytes, contentType, status) {
    contentType = contentType === VOID ? null : contentType;
    status = status === VOID ? null : status;
    ByteArrayContent_0.call(this);
    this.e99_1 = bytes;
    this.f99_1 = contentType;
    this.g99_1 = status;
  }
  protoOf(ByteArrayContent).h99 = function () {
    return this.f99_1;
  };
  protoOf(ByteArrayContent).i99 = function () {
    return toLong(this.e99_1.length);
  };
  protoOf(ByteArrayContent).j99 = function () {
    return this.e99_1;
  };
  function NoContent() {
    OutgoingContent.call(this);
  }
  function ReadChannelContent() {
    OutgoingContent.call(this);
  }
  function WriteChannelContent() {
  }
  function ByteArrayContent_0() {
    OutgoingContent.call(this);
  }
  function ProtocolUpgrade() {
  }
  function OutgoingContent() {
    this.k99_1 = null;
  }
  protoOf(OutgoingContent).h99 = function () {
    return null;
  };
  protoOf(OutgoingContent).i99 = function () {
    return null;
  };
  protoOf(OutgoingContent).g94 = function () {
    return Companion_getInstance_142().a90_1;
  };
  function NullBody() {
  }
  var NullBody_instance;
  function NullBody_getInstance() {
    return NullBody_instance;
  }
  function TextContent(text, contentType, status) {
    status = status === VOID ? null : status;
    ByteArrayContent_0.call(this);
    this.r99_1 = text;
    this.s99_1 = contentType;
    this.t99_1 = status;
    var tmp = this;
    var tmp0 = this.r99_1;
    var tmp0_elvis_lhs = charset(this.s99_1);
    var tmp1 = tmp0_elvis_lhs == null ? Charsets_getInstance().q8o_1 : tmp0_elvis_lhs;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.toByteArray' call
      if (tmp1.equals(Charsets_getInstance().q8o_1)) {
        tmp$ret$0 = encodeToByteArray(tmp0);
        break $l$block;
      }
      tmp$ret$0 = encodeToByteArray_0(tmp1.u8o(), tmp0, 0, tmp0.length);
    }
    tmp.u99_1 = tmp$ret$0;
  }
  protoOf(TextContent).h99 = function () {
    return this.s99_1;
  };
  protoOf(TextContent).i99 = function () {
    return toLong(this.u99_1.length);
  };
  protoOf(TextContent).j99 = function () {
    return this.u99_1;
  };
  protoOf(TextContent).toString = function () {
    return 'TextContent[' + this.s99_1.toString() + '] "' + take_1(this.r99_1, 30) + '"';
  };
  function get_origin(_this__u8e3s4) {
    var tmp;
    if (get_platform(PlatformUtils_getInstance()).a3_1 === 2) {
      var tmp_0 = function () {
        var tmpLocation = null;
        if (typeof window !== 'undefined') {
          tmpLocation = window.location;
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location;
        }
        var origin = '';
        if (tmpLocation) {
          origin = tmpLocation.origin;
        }
        return origin && origin != 'null' ? origin : 'http://localhost';
      }();
      tmp = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
    } else {
      tmp = 'http://localhost';
    }
    return tmp;
  }
  var Codes_NORMAL_instance;
  var Codes_GOING_AWAY_instance;
  var Codes_PROTOCOL_ERROR_instance;
  var Codes_CANNOT_ACCEPT_instance;
  var Codes_CLOSED_ABNORMALLY_instance;
  var Codes_NOT_CONSISTENT_instance;
  var Codes_VIOLATED_POLICY_instance;
  var Codes_TOO_BIG_instance;
  var Codes_NO_EXTENSION_instance;
  var Codes_INTERNAL_ERROR_instance;
  var Codes_SERVICE_RESTART_instance;
  var Codes_TRY_AGAIN_LATER_instance;
  function Companion_150() {
    Companion_instance_150 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_7();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'io.ktor.websocket.Companion.byCodeMap.<anonymous>' call
      var tmp$ret$0 = element.x99_1;
      destination.r2(tmp$ret$0, element);
    }
    tmp.y99_1 = destination;
    this.z99_1 = Codes_INTERNAL_ERROR_getInstance();
  }
  protoOf(Companion_150).a9a = function (code) {
    return this.y99_1.y2(code);
  };
  var Companion_instance_150;
  function Companion_getInstance_150() {
    Codes_initEntries();
    if (Companion_instance_150 == null)
      new Companion_150();
    return Companion_instance_150;
  }
  function values_7() {
    return [Codes_NORMAL_getInstance(), Codes_GOING_AWAY_getInstance(), Codes_PROTOCOL_ERROR_getInstance(), Codes_CANNOT_ACCEPT_getInstance(), Codes_CLOSED_ABNORMALLY_getInstance(), Codes_NOT_CONSISTENT_getInstance(), Codes_VIOLATED_POLICY_getInstance(), Codes_TOO_BIG_getInstance(), Codes_NO_EXTENSION_getInstance(), Codes_INTERNAL_ERROR_getInstance(), Codes_SERVICE_RESTART_getInstance(), Codes_TRY_AGAIN_LATER_getInstance()];
  }
  var Codes_entriesInitialized;
  function Codes_initEntries() {
    if (Codes_entriesInitialized)
      return Unit_instance;
    Codes_entriesInitialized = true;
    Codes_NORMAL_instance = new Codes('NORMAL', 0, 1000);
    Codes_GOING_AWAY_instance = new Codes('GOING_AWAY', 1, 1001);
    Codes_PROTOCOL_ERROR_instance = new Codes('PROTOCOL_ERROR', 2, 1002);
    Codes_CANNOT_ACCEPT_instance = new Codes('CANNOT_ACCEPT', 3, 1003);
    Codes_CLOSED_ABNORMALLY_instance = new Codes('CLOSED_ABNORMALLY', 4, 1006);
    Codes_NOT_CONSISTENT_instance = new Codes('NOT_CONSISTENT', 5, 1007);
    Codes_VIOLATED_POLICY_instance = new Codes('VIOLATED_POLICY', 6, 1008);
    Codes_TOO_BIG_instance = new Codes('TOO_BIG', 7, 1009);
    Codes_NO_EXTENSION_instance = new Codes('NO_EXTENSION', 8, 1010);
    Codes_INTERNAL_ERROR_instance = new Codes('INTERNAL_ERROR', 9, 1011);
    Codes_SERVICE_RESTART_instance = new Codes('SERVICE_RESTART', 10, 1012);
    Codes_TRY_AGAIN_LATER_instance = new Codes('TRY_AGAIN_LATER', 11, 1013);
    Companion_getInstance_150();
  }
  function CloseReason_init_$Init$(code, message, $this) {
    CloseReason.call($this, code.x99_1, message);
    return $this;
  }
  function CloseReason_init_$Create$(code, message) {
    return CloseReason_init_$Init$(code, message, objectCreate(protoOf(CloseReason)));
  }
  function Codes(name, ordinal, code) {
    Enum.call(this, name, ordinal);
    this.x99_1 = code;
  }
  function Codes_NORMAL_getInstance() {
    Codes_initEntries();
    return Codes_NORMAL_instance;
  }
  function Codes_GOING_AWAY_getInstance() {
    Codes_initEntries();
    return Codes_GOING_AWAY_instance;
  }
  function Codes_PROTOCOL_ERROR_getInstance() {
    Codes_initEntries();
    return Codes_PROTOCOL_ERROR_instance;
  }
  function Codes_CANNOT_ACCEPT_getInstance() {
    Codes_initEntries();
    return Codes_CANNOT_ACCEPT_instance;
  }
  function Codes_CLOSED_ABNORMALLY_getInstance() {
    Codes_initEntries();
    return Codes_CLOSED_ABNORMALLY_instance;
  }
  function Codes_NOT_CONSISTENT_getInstance() {
    Codes_initEntries();
    return Codes_NOT_CONSISTENT_instance;
  }
  function Codes_VIOLATED_POLICY_getInstance() {
    Codes_initEntries();
    return Codes_VIOLATED_POLICY_instance;
  }
  function Codes_TOO_BIG_getInstance() {
    Codes_initEntries();
    return Codes_TOO_BIG_instance;
  }
  function Codes_NO_EXTENSION_getInstance() {
    Codes_initEntries();
    return Codes_NO_EXTENSION_instance;
  }
  function Codes_INTERNAL_ERROR_getInstance() {
    Codes_initEntries();
    return Codes_INTERNAL_ERROR_instance;
  }
  function Codes_SERVICE_RESTART_getInstance() {
    Codes_initEntries();
    return Codes_SERVICE_RESTART_instance;
  }
  function Codes_TRY_AGAIN_LATER_getInstance() {
    Codes_initEntries();
    return Codes_TRY_AGAIN_LATER_instance;
  }
  function CloseReason(code, message) {
    this.b9a_1 = code;
    this.c9a_1 = message;
  }
  protoOf(CloseReason).d9a = function () {
    return Companion_getInstance_150().a9a(this.b9a_1);
  };
  protoOf(CloseReason).toString = function () {
    var tmp0_elvis_lhs = this.d9a();
    return 'CloseReason(reason=' + toString_1(tmp0_elvis_lhs == null ? this.b9a_1 : tmp0_elvis_lhs) + ', message=' + this.c9a_1 + ')';
  };
  protoOf(CloseReason).hashCode = function () {
    var result = this.b9a_1;
    result = imul(result, 31) + getStringHashCode(this.c9a_1) | 0;
    return result;
  };
  protoOf(CloseReason).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CloseReason))
      return false;
    var tmp0_other_with_cast = other instanceof CloseReason ? other : THROW_CCE();
    if (!(this.b9a_1 === tmp0_other_with_cast.b9a_1))
      return false;
    if (!(this.c9a_1 === tmp0_other_with_cast.c9a_1))
      return false;
    return true;
  };
  function get_LOGGER() {
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    return LOGGER;
  }
  var LOGGER;
  function get_IncomingProcessorCoroutineName() {
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    return IncomingProcessorCoroutineName;
  }
  var IncomingProcessorCoroutineName;
  function get_OutgoingProcessorCoroutineName() {
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    return OutgoingProcessorCoroutineName;
  }
  var OutgoingProcessorCoroutineName;
  function get_NORMAL_CLOSE() {
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    return NORMAL_CLOSE;
  }
  var NORMAL_CLOSE;
  function DefaultWebSocketSession() {
  }
  function DefaultWebSocketSession_0(session, pingInterval, timeoutMillis) {
    pingInterval = pingInterval === VOID ? new Long(-1, -1) : pingInterval;
    timeoutMillis = timeoutMillis === VOID ? new Long(15000, 0) : timeoutMillis;
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    // Inline function 'kotlin.require' call
    if (!!isInterface(session, DefaultWebSocketSession)) {
      // Inline function 'io.ktor.websocket.DefaultWebSocketSession.<anonymous>' call
      var message = 'Cannot wrap other DefaultWebSocketSession';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new DefaultWebSocketSessionImpl(session, pingInterval, timeoutMillis);
  }
  function runIncomingProcessor($this, ponger) {
    var tmp = get_IncomingProcessorCoroutineName().ej(Dispatchers_getInstance().q14_1);
    return launch($this, tmp, VOID, DefaultWebSocketSessionImpl$runIncomingProcessor$slambda_0($this, ponger, null));
  }
  function runOutgoingProcessor($this) {
    var tmp = get_OutgoingProcessorCoroutineName().ej(Dispatchers_getInstance().q14_1);
    var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
    return launch($this, tmp, tmp_0, DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda_0($this, null));
  }
  function outgoingProcessorLoop($this, $completion) {
    var tmp = new $outgoingProcessorLoopCOROUTINE$0($this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function sendCloseSequence($this, reason, exception, $completion) {
    var tmp = new $sendCloseSequenceCOROUTINE$1($this, reason, exception, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function sendCloseSequence$default($this, reason, exception, $completion, $super) {
    exception = exception === VOID ? null : exception;
    return sendCloseSequence($this, reason, exception, $completion);
  }
  function tryClose($this) {
    return $this.s9b_1.atomicfu$compareAndSet(false, true);
  }
  function runOrCancelPinger($this) {
    var interval = $this.x9b_1;
    var tmp;
    if ($this.s9b_1.kotlinx$atomicfu$value) {
      tmp = null;
    } else if (interval.d1(new Long(0, 0)) > 0) {
      var tmp_0 = $this.n9b_1.j9a();
      var tmp_1 = $this.y9b_1;
      tmp = pinger($this, tmp_0, interval, tmp_1, DefaultWebSocketSessionImpl$runOrCancelPinger$slambda_0($this, null));
    } else {
      tmp = null;
    }
    var newPinger = tmp;
    var tmp0_safe_receiver = $this.o9b_1.atomicfu$getAndSet(newPinger);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.i1c();
    var tmp2_safe_receiver = newPinger == null ? null : new ChannelResult(newPinger.a1c(Companion_getInstance_151().a9c_1));
    if (tmp2_safe_receiver == null)
      null;
    else
      _ChannelResult___get_isSuccess__impl__odq1z9(tmp2_safe_receiver.c1c_1);
    if ($this.s9b_1.kotlinx$atomicfu$value && !(newPinger == null)) {
      runOrCancelPinger($this);
    }
  }
  function checkMaxFrameSize($this, packet, frame, $completion) {
    var tmp = new $checkMaxFrameSizeCOROUTINE$2($this, packet, frame, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function processIncomingExtensions($this, frame) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = frame;
    var _iterator__ex2g4s = $this.n9c().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.websocket.DefaultWebSocketSessionImpl.processIncomingExtensions.<anonymous>' call
      var current = accumulator;
      accumulator = element.o9c(current);
    }
    return accumulator;
  }
  function processOutgoingExtensions($this, frame) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = frame;
    var _iterator__ex2g4s = $this.n9c().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.websocket.DefaultWebSocketSessionImpl.processOutgoingExtensions.<anonymous>' call
      var current = accumulator;
      accumulator = element.p9c(current);
    }
    return accumulator;
  }
  function Companion_151() {
    Companion_instance_151 = this;
    this.a9c_1 = new Pong(new Int8Array(0), NonDisposableHandle_instance_0);
  }
  var Companion_instance_151;
  function Companion_getInstance_151() {
    if (Companion_instance_151 == null)
      new Companion_151();
    return Companion_instance_151;
  }
  function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this$0, $ponger, resultContinuation) {
    this.y9c_1 = this$0;
    this.z9c_1 = $ponger;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 39;
            this.b9d_1 = null;
            this.c9d_1 = null;
            this.d9d_1 = false;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.z9_1 = 33;
            this.z9_1 = 32;
            var tmp_0 = this;
            tmp_0.g9d_1 = this.y9c_1.n9b_1.i9a();
            this.h9d_1 = this.g9d_1;
            var tmp_1 = this;
            tmp_1.i9d_1 = this.h9d_1;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.k9d_1 = this.i9d_1;
            this.l9d_1 = null;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.y9_1 = 6;
            continue $sm;
          case 6:
            this.z9_1 = 29;
            this.z9_1 = 28;
            var tmp_2 = this;
            tmp_2.o9d_1 = this.k9d_1;
            this.p9d_1 = this.o9d_1;
            this.q9d_1 = this.p9d_1.k();
            this.y9_1 = 7;
            continue $sm;
          case 7:
            this.y9_1 = 8;
            suspendResult = this.q9d_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            if (!suspendResult) {
              this.y9_1 = 26;
              continue $sm;
            }

            this.r9d_1 = this.q9d_1.m();
            var tmp_3 = this;
            tmp_3.s9d_1 = this.r9d_1;
            this.y9_1 = 9;
            continue $sm;
          case 9:
            this.u9d_1 = this.s9d_1;
            get_LOGGER().e8y('WebSocketSession(' + toString_1(this.a9d_1) + ') receiving frame ' + this.u9d_1.toString());
            this.v9d_1 = this.u9d_1;
            var tmp_4 = this.v9d_1;
            if (tmp_4 instanceof Close) {
              if (!this.y9c_1.j9a().j19()) {
                this.y9_1 = 20;
                var tmp_5 = this.y9c_1.j9a();
                var tmp1_elvis_lhs = readReason(this.u9d_1);
                suspendResult = tmp_5.z1b(Close_init_$Create$(tmp1_elvis_lhs == null ? get_NORMAL_CLOSE() : tmp1_elvis_lhs), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.y9_1 = 21;
                continue $sm;
              }
            } else {
              var tmp_6 = this.v9d_1;
              if (tmp_6 instanceof Pong) {
                this.w9d_1 = this.y9c_1.o9b_1.kotlinx$atomicfu$value;
                if (this.w9d_1 == null) {
                  this.x9d_1 = null;
                  this.y9_1 = 17;
                  continue $sm;
                } else {
                  this.y9_1 = 16;
                  suspendResult = this.w9d_1.z1b(this.u9d_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                var tmp_7 = this.v9d_1;
                if (tmp_7 instanceof Ping) {
                  this.y9_1 = 15;
                  suspendResult = this.z9c_1.z1b(this.u9d_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.y9_1 = 10;
                  suspendResult = checkMaxFrameSize(this.y9c_1, this.c9d_1, this.u9d_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              }
            }

          case 10:
            if (!this.u9d_1.e9e_1) {
              if (this.b9d_1 == null) {
                this.b9d_1 = this.u9d_1;
              }
              if (this.c9d_1 == null) {
                this.c9d_1 = new BytePacketBuilder();
              }
              writeFully_3(ensureNotNull(this.c9d_1), this.u9d_1.g9e_1);
              this.t9d_1 = Unit_instance;
              this.y9_1 = 19;
              continue $sm;
            } else {
              this.y9_1 = 11;
              continue $sm;
            }

          case 11:
            if (this.b9d_1 == null) {
              this.y9_1 = 14;
              suspendResult = this.y9c_1.q9b_1.z1b(processIncomingExtensions(this.y9c_1, this.u9d_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 12;
              continue $sm;
            }

          case 12:
            writeFully_3(ensureNotNull(this.c9d_1), this.u9d_1.g9e_1);
            this.y9d_1 = Companion_getInstance_153().m9e(true, ensureNotNull(this.b9d_1).f9e_1, readBytes(ensureNotNull(this.c9d_1).k2p()), ensureNotNull(this.b9d_1).i9e_1, ensureNotNull(this.b9d_1).j9e_1, ensureNotNull(this.b9d_1).k9e_1);
            this.b9d_1 = null;
            this.y9_1 = 13;
            suspendResult = this.y9c_1.q9b_1.z1b(processIncomingExtensions(this.y9c_1, this.y9d_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 13:
            this.y9_1 = 18;
            continue $sm;
          case 14:
            this.t9d_1 = Unit_instance;
            this.y9_1 = 19;
            continue $sm;
          case 15:
            this.y9_1 = 18;
            continue $sm;
          case 16:
            var tmp_8 = this;
            tmp_8.x9d_1 = Unit_instance;
            this.y9_1 = 17;
            continue $sm;
          case 17:
            this.y9_1 = 18;
            continue $sm;
          case 18:
            if (false) {
              this.y9_1 = 9;
              continue $sm;
            }

            this.y9_1 = 19;
            continue $sm;
          case 19:
            this.y9_1 = 7;
            continue $sm;
          case 20:
            this.y9_1 = 21;
            continue $sm;
          case 21:
            this.d9d_1 = true;
            this.n9d_1 = Unit_instance;
            this.y9_1 = 22;
            continue $sm;
          case 22:
            this.z9_1 = 32;
            var tmp_9 = this;
            cancelConsumed(this.k9d_1, this.l9d_1);
            tmp_9.f9d_1 = Unit_instance;
            this.z9_1 = 39;
            this.y9_1 = 23;
            continue $sm;
          case 23:
            this.z9_1 = 39;
            this.z9c_1.i1c();
            var tmp0_safe_receiver = this.c9d_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.vz();
            }

            this.y9c_1.q9b_1.i1c();
            if (!this.d9d_1) {
              this.y9_1 = 24;
              suspendResult = close_1(this.y9c_1, CloseReason_init_$Create$(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 25;
              continue $sm;
            }

          case 24:
            this.y9_1 = 25;
            continue $sm;
          case 25:
            return Unit_instance;
          case 26:
            var tmp_10 = this;
            tmp_10.m9d_1 = Unit_instance;
            this.y9_1 = 27;
            var tmp_11 = this;
            continue $sm;
          case 27:
            this.z9_1 = 32;
            var tmp_12 = this;
            cancelConsumed(this.k9d_1, this.l9d_1);
            tmp_12.j9d_1 = Unit_instance;
            this.y9_1 = 31;
            continue $sm;
          case 28:
            this.z9_1 = 29;
            var tmp_13 = this.ba_1;
            if (tmp_13 instanceof Error) {
              this.z9d_1 = this.ba_1;
              var tmp_14 = this;
              this.l9d_1 = this.z9d_1;
              throw this.z9d_1;
            } else {
              throw this.ba_1;
            }

          case 29:
            this.z9_1 = 32;
            this.a9e_1 = this.ba_1;
            cancelConsumed(this.k9d_1, this.l9d_1);
            throw this.a9e_1;
          case 30:
            this.z9_1 = 32;
            cancelConsumed(this.k9d_1, this.l9d_1);
            if (false) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.y9_1 = 31;
            continue $sm;
          case 31:
            this.e9d_1 = Unit_instance;
            this.z9_1 = 39;
            this.y9_1 = 36;
            continue $sm;
          case 32:
            this.z9_1 = 33;
            var tmp_15 = this.ba_1;
            if (tmp_15 instanceof ClosedSendChannelException) {
              this.b9e_1 = this.ba_1;
              var tmp_16 = this;
              tmp_16.e9d_1 = Unit_instance;
              this.z9_1 = 39;
              this.y9_1 = 36;
              continue $sm;
            } else {
              var tmp_17 = this.ba_1;
              if (tmp_17 instanceof Error) {
                this.c9e_1 = this.ba_1;
                var tmp_18 = this;
                this.z9c_1.i1c();
                this.y9c_1.q9b_1.g1c(this.c9e_1);
                tmp_18.e9d_1 = Unit_instance;
                this.z9_1 = 39;
                this.y9_1 = 36;
                continue $sm;
              } else {
                throw this.ba_1;
              }
            }

          case 33:
            this.z9_1 = 39;
            this.d9e_1 = this.ba_1;
            this.z9c_1.i1c();
            var tmp0_safe_receiver_0 = this.c9d_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              tmp0_safe_receiver_0.vz();
            }

            this.y9c_1.q9b_1.i1c();
            if (!this.d9d_1) {
              this.y9_1 = 34;
              suspendResult = close_1(this.y9c_1, CloseReason_init_$Create$(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 35;
              continue $sm;
            }

          case 34:
            this.y9_1 = 35;
            continue $sm;
          case 35:
            throw this.d9e_1;
          case 36:
            this.z9_1 = 39;
            this.z9c_1.i1c();
            var tmp0_safe_receiver_1 = this.c9d_1;
            if (tmp0_safe_receiver_1 == null)
              null;
            else {
              tmp0_safe_receiver_1.vz();
            }

            this.y9c_1.q9b_1.i1c();
            if (!this.d9d_1) {
              this.y9_1 = 37;
              suspendResult = close_1(this.y9c_1, CloseReason_init_$Create$(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 38;
              continue $sm;
            }

          case 37:
            this.y9_1 = 38;
            continue $sm;
          case 38:
            return Unit_instance;
          case 39:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 39) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).i1l = function ($this$launch, completion) {
    var i = new DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this.y9c_1, this.z9c_1, completion);
    i.a9d_1 = $this$launch;
    return i;
  };
  function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda_0(this$0, $ponger, resultContinuation) {
    var i = new DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this$0, $ponger, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this$0, resultContinuation) {
    this.v9e_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 10;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 6;
            this.z9_1 = 3;
            this.y9_1 = 2;
            suspendResult = outgoingProcessorLoop(this.v9e_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.x9e_1 = suspendResult;
            this.z9_1 = 10;
            this.y9_1 = 8;
            continue $sm;
          case 3:
            this.z9_1 = 6;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof ClosedSendChannelException) {
              this.y9e_1 = this.ba_1;
              var tmp_1 = this;
              tmp_1.x9e_1 = Unit_instance;
              this.z9_1 = 10;
              this.y9_1 = 8;
              continue $sm;
            } else {
              var tmp_2 = this.ba_1;
              if (tmp_2 instanceof ClosedReceiveChannelException) {
                this.z9e_1 = this.ba_1;
                var tmp_3 = this;
                tmp_3.x9e_1 = Unit_instance;
                this.z9_1 = 10;
                this.y9_1 = 8;
                continue $sm;
              } else {
                var tmp_4 = this.ba_1;
                if (tmp_4 instanceof CancellationException) {
                  this.a9f_1 = this.ba_1;
                  this.y9_1 = 4;
                  suspendResult = sendCloseSequence$default(this.v9e_1, CloseReason_init_$Create$(Codes_NORMAL_getInstance(), ''), VOID, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_5 = this.ba_1;
                  if (tmp_5 instanceof ChannelIOException) {
                    this.b9f_1 = this.ba_1;
                    var tmp_6 = this;
                    tmp_6.x9e_1 = Unit_instance;
                    this.z9_1 = 10;
                    this.y9_1 = 8;
                    continue $sm;
                  } else {
                    var tmp_7 = this.ba_1;
                    if (tmp_7 instanceof Error) {
                      this.c9f_1 = this.ba_1;
                      this.v9e_1.r9b_1.ou(CancellationException_init_$Create$_1('Failed to send frame', this.c9f_1));
                      this.y9_1 = 5;
                      suspendResult = closeExceptionally(this.v9e_1.n9b_1, this.c9f_1, this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      throw this.ba_1;
                    }
                  }
                }
              }
            }

          case 4:
            this.x9e_1 = suspendResult;
            this.z9_1 = 10;
            this.y9_1 = 8;
            continue $sm;
          case 5:
            this.x9e_1 = suspendResult;
            this.z9_1 = 10;
            this.y9_1 = 8;
            continue $sm;
          case 6:
            this.z9_1 = 10;
            this.d9f_1 = this.ba_1;
            this.v9e_1.r9b_1.k1c();
            this.y9_1 = 7;
            suspendResult = close_1(this.v9e_1.n9b_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            throw this.d9f_1;
          case 8:
            this.z9_1 = 10;
            this.v9e_1.r9b_1.k1c();
            this.y9_1 = 9;
            suspendResult = close_1(this.v9e_1.n9b_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            return Unit_instance;
          case 10:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 10) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).i1l = function ($this$launch, completion) {
    var i = new DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this.v9e_1, completion);
    i.w9e_1 = $this$launch;
    return i;
  };
  function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda_0(this$0, resultContinuation) {
    var i = new DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this$0, resultContinuation) {
    this.m9f_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).o9f = function (it, $completion) {
    var tmp = this.p9f(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).oa = function (p1, $completion) {
    return this.o9f(p1 instanceof CloseReason ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = sendCloseSequence(this.m9f_1, this.n9f_1, IOException_init_$Create$('Ping timeout'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).p9f = function (it, completion) {
    var i = new DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this.m9f_1, completion);
    i.n9f_1 = it;
    return i;
  };
  function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda_0(this$0, resultContinuation) {
    var i = new DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this$0, resultContinuation);
    var l = function (it, $completion) {
      return i.o9f(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $outgoingProcessorLoopCOROUTINE$0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u9a_1 = _this__u8e3s4;
  }
  protoOf($outgoingProcessorLoopCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            this.v9a_1 = this.u9a_1.r9b_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.y9_1 = 2;
            suspendResult = this.v9a_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (!suspendResult) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.w9a_1 = this.v9a_1.m();
            get_LOGGER().e8y('Sending ' + this.w9a_1.toString() + ' from session ' + toString_1(this.u9a_1));
            this.x9a_1 = this.w9a_1;
            var tmp_0 = this.x9a_1;
            if (tmp_0 instanceof Close) {
              this.y9_1 = 3;
              suspendResult = sendCloseSequence$default(this.u9a_1, readReason(this.w9a_1), VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1;
              var tmp_2 = this.x9a_1;
              if (tmp_2 instanceof Text_0) {
                tmp_1 = true;
              } else {
                var tmp_3 = this.x9a_1;
                tmp_1 = tmp_3 instanceof Binary;
              }
              if (tmp_1) {
                this.y9a_1 = processOutgoingExtensions(this.u9a_1, this.w9a_1);
                this.y9_1 = 4;
                continue $sm;
              } else {
                this.y9a_1 = this.w9a_1;
                this.y9_1 = 4;
                continue $sm;
              }
            }

          case 3:
            this.y9_1 = 6;
            var tmp_4 = this;
            continue $sm;
          case 4:
            this.z9a_1 = this.y9a_1;
            this.y9_1 = 5;
            suspendResult = this.u9a_1.n9b_1.j9a().z1b(this.z9a_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.y9_1 = 1;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $sendCloseSequenceCOROUTINE$1(_this__u8e3s4, reason, exception, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i9b_1 = _this__u8e3s4;
    this.j9b_1 = reason;
    this.k9b_1 = exception;
  }
  protoOf($sendCloseSequenceCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            if (!tryClose(this.i9b_1))
              return Unit_instance;
            get_LOGGER().e8y('Sending Close Sequence for session ' + toString_1(this.i9b_1) + ' with reason ' + toString_0(this.j9b_1) + ' and exception ' + toString_0(this.k9b_1));
            this.i9b_1.t9b_1.oz();
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.j9b_1;
            tmp_0.l9b_1 = tmp0_elvis_lhs == null ? CloseReason_init_$Create$(Codes_NORMAL_getInstance(), '') : tmp0_elvis_lhs;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 5;
            runOrCancelPinger(this.i9b_1);
            if (!(this.l9b_1.b9a_1 === Codes_CLOSED_ABNORMALLY_getInstance().x99_1)) {
              this.y9_1 = 2;
              suspendResult = this.i9b_1.n9b_1.j9a().z1b(Close_init_$Create$(this.l9b_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.m9b_1 = Unit_instance;
            this.z9_1 = 6;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.z9_1 = 6;
            this.i9b_1.p9b_1.lz(this.l9b_1);
            if (!(this.k9b_1 == null)) {
              this.i9b_1.r9b_1.g1c(this.k9b_1);
              this.i9b_1.q9b_1.g1c(this.k9b_1);
            }

            return Unit_instance;
          case 5:
            this.z9_1 = 6;
            var t = this.ba_1;
            this.i9b_1.p9b_1.lz(this.l9b_1);
            if (!(this.k9b_1 == null)) {
              this.i9b_1.r9b_1.g1c(this.k9b_1);
              this.i9b_1.q9b_1.g1c(this.k9b_1);
            }

            throw t;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $checkMaxFrameSizeCOROUTINE$2(_this__u8e3s4, packet, frame, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j9c_1 = _this__u8e3s4;
    this.k9c_1 = packet;
    this.l9c_1 = frame;
  }
  protoOf($checkMaxFrameSizeCOROUTINE$2).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            var tmp_1 = this.l9c_1.g9e_1.length;
            var tmp0_safe_receiver = this.k9c_1;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n();
            tmp_0.m9c_1 = tmp_1 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
            if (toLong(this.m9c_1).d1(this.j9c_1.h9a()) > 0) {
              var tmp2_safe_receiver = this.k9c_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                tmp2_safe_receiver.vz();
              }
              this.y9_1 = 2;
              suspendResult = close_1(this.j9c_1, CloseReason_init_$Create$(Codes_TOO_BIG_getInstance(), 'Frame is too big: ' + this.m9c_1 + '. Max size is ' + this.j9c_1.h9a().toString()), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 1;
              continue $sm;
            }

          case 1:
            return Unit_instance;
          case 2:
            throw new FrameTooBigException(toLong(this.m9c_1));
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function DefaultWebSocketSessionImpl(raw, pingInterval, timeoutMillis) {
    Companion_getInstance_151();
    this.n9b_1 = raw;
    this.o9b_1 = atomic$ref$1(null);
    this.p9b_1 = CompletableDeferred();
    this.q9b_1 = Channel(8);
    this.r9b_1 = Channel(get_OUTGOING_CHANNEL_CAPACITY());
    this.s9b_1 = atomic$boolean$1(false);
    this.t9b_1 = Job_0(this.n9b_1.et().la(Key_instance_3));
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.u9b_1 = ArrayList_init_$Create$();
    this.v9b_1 = atomic$boolean$1(false);
    this.w9b_1 = this.n9b_1.et().ej(this.t9b_1).ej(new CoroutineName('ws-default'));
    this.x9b_1 = pingInterval;
    this.y9b_1 = timeoutMillis;
    this.z9b_1 = this.p9b_1;
  }
  protoOf(DefaultWebSocketSessionImpl).i9a = function () {
    return this.q9b_1;
  };
  protoOf(DefaultWebSocketSessionImpl).j9a = function () {
    return this.r9b_1;
  };
  protoOf(DefaultWebSocketSessionImpl).n9c = function () {
    return this.u9b_1;
  };
  protoOf(DefaultWebSocketSessionImpl).et = function () {
    return this.w9b_1;
  };
  protoOf(DefaultWebSocketSessionImpl).g9a = function (value) {
    this.n9b_1.g9a(value);
  };
  protoOf(DefaultWebSocketSessionImpl).h9a = function () {
    return this.n9b_1.h9a();
  };
  protoOf(DefaultWebSocketSessionImpl).e9a = function () {
    return this.z9b_1;
  };
  protoOf(DefaultWebSocketSessionImpl).f9a = function (negotiatedExtensions) {
    if (!this.v9b_1.atomicfu$compareAndSet(false, true)) {
      // Inline function 'kotlin.error' call
      var message = 'WebSocket session ' + toString_1(this) + ' is already started.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    get_LOGGER().e8y('Starting default WebSocketSession(' + toString_1(this) + ') ' + ('with negotiated extensions: ' + joinToString_0(negotiatedExtensions)));
    this.u9b_1.o(negotiatedExtensions);
    runOrCancelPinger(this);
    runIncomingProcessor(this, ponger(this, this.j9a()));
    runOutgoingProcessor(this);
  };
  protoOf(DefaultWebSocketSessionImpl).l9a = function ($completion) {
    return this.n9b_1.l9a($completion);
  };
  var properties_initialized_DefaultWebSocketSession_kt_6cjlhc;
  function _init_properties_DefaultWebSocketSession_kt__469s0y() {
    if (!properties_initialized_DefaultWebSocketSession_kt_6cjlhc) {
      properties_initialized_DefaultWebSocketSession_kt_6cjlhc = true;
      LOGGER = KtorSimpleLogger('io.ktor.websocket.WebSocket');
      IncomingProcessorCoroutineName = new CoroutineName('ws-incoming-processor');
      OutgoingProcessorCoroutineName = new CoroutineName('ws-outgoing-processor');
      NORMAL_CLOSE = CloseReason_init_$Create$(Codes_NORMAL_getInstance(), 'OK');
    }
  }
  function NonDisposableHandle_0() {
  }
  protoOf(NonDisposableHandle_0).vr = function () {
  };
  protoOf(NonDisposableHandle_0).toString = function () {
    return 'NonDisposableHandle';
  };
  var NonDisposableHandle_instance_0;
  function NonDisposableHandle_getInstance_0() {
    return NonDisposableHandle_instance_0;
  }
  function readReason(_this__u8e3s4) {
    if (_this__u8e3s4.g9e_1.length < 2) {
      return null;
    }
    var tmp$ret$0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.buildPacket' call
      // Inline function 'kotlin.contracts.contract' call
      var builder = new BytePacketBuilder();
      try {
        // Inline function 'io.ktor.websocket.readReason.<anonymous>' call
        writeFully_3(builder, _this__u8e3s4.g9e_1);
        tmp$ret$0 = builder.k2p();
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          builder.vz();
          throw t;
        } else {
          throw $p;
        }
      }
    }
    var packet = tmp$ret$0;
    var code = readShort_0(packet);
    var message = packet.h8o();
    return new CloseReason(code, message);
  }
  function FrameTooBigException(frameSize) {
    Exception_init_$Init$(this);
    captureStack(this, FrameTooBigException);
    this.q9f_1 = frameSize;
  }
  protoOf(FrameTooBigException).t1 = function () {
    return 'Frame is too big: ' + this.q9f_1.toString();
  };
  var FrameType_TEXT_instance;
  var FrameType_BINARY_instance;
  var FrameType_CLOSE_instance;
  var FrameType_PING_instance;
  var FrameType_PONG_instance;
  function Companion_152() {
    Companion_instance_152 = this;
    var tmp = this;
    var tmp0 = values_8();
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.maxByOrNull' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (tmp0.length === 0) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      var maxElem = tmp0[0];
      var lastIndex = get_lastIndex(tmp0);
      if (lastIndex === 0) {
        tmp$ret$1 = maxElem;
        break $l$block_0;
      }
      // Inline function 'io.ktor.websocket.Companion.maxOpcode.<anonymous>' call
      var maxValue = maxElem.u9f_1;
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = tmp0[i];
          // Inline function 'io.ktor.websocket.Companion.maxOpcode.<anonymous>' call
          var v = e.u9f_1;
          if (compareTo_0(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$1 = maxElem;
    }
    tmp.v9f_1 = ensureNotNull(tmp$ret$1).u9f_1;
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = this.v9f_1 + 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(tmp_2), null);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      var tmp1 = values_8();
      var tmp$ret$6;
      $l$block_2: {
        // Inline function 'kotlin.collections.singleOrNull' call
        var single = null;
        var found = false;
        var inductionVariable_0 = 0;
        var last = tmp1.length;
        while (inductionVariable_0 < last) {
          var element = tmp1[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'io.ktor.websocket.Companion.byOpcodeArray.<anonymous>' call
          if (element.u9f_1 === tmp_4) {
            if (found) {
              tmp$ret$6 = null;
              break $l$block_2;
            }
            single = element;
            found = true;
          }
        }
        if (!found) {
          tmp$ret$6 = null;
          break $l$block_2;
        }
        tmp$ret$6 = single;
      }
      tmp_3[tmp_4] = tmp$ret$6;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.w9f_1 = tmp_3;
  }
  var Companion_instance_152;
  function Companion_getInstance_152() {
    FrameType_initEntries();
    if (Companion_instance_152 == null)
      new Companion_152();
    return Companion_instance_152;
  }
  function values_8() {
    return [FrameType_TEXT_getInstance(), FrameType_BINARY_getInstance(), FrameType_CLOSE_getInstance(), FrameType_PING_getInstance(), FrameType_PONG_getInstance()];
  }
  var FrameType_entriesInitialized;
  function FrameType_initEntries() {
    if (FrameType_entriesInitialized)
      return Unit_instance;
    FrameType_entriesInitialized = true;
    FrameType_TEXT_instance = new FrameType('TEXT', 0, false, 1);
    FrameType_BINARY_instance = new FrameType('BINARY', 1, false, 2);
    FrameType_CLOSE_instance = new FrameType('CLOSE', 2, true, 8);
    FrameType_PING_instance = new FrameType('PING', 3, true, 9);
    FrameType_PONG_instance = new FrameType('PONG', 4, true, 10);
    Companion_getInstance_152();
  }
  function FrameType(name, ordinal, controlFrame, opcode) {
    Enum.call(this, name, ordinal);
    this.t9f_1 = controlFrame;
    this.u9f_1 = opcode;
  }
  function FrameType_TEXT_getInstance() {
    FrameType_initEntries();
    return FrameType_TEXT_instance;
  }
  function FrameType_BINARY_getInstance() {
    FrameType_initEntries();
    return FrameType_BINARY_instance;
  }
  function FrameType_CLOSE_getInstance() {
    FrameType_initEntries();
    return FrameType_CLOSE_instance;
  }
  function FrameType_PING_getInstance() {
    FrameType_initEntries();
    return FrameType_PING_instance;
  }
  function FrameType_PONG_getInstance() {
    FrameType_initEntries();
    return FrameType_PONG_instance;
  }
  function get_PongerCoroutineName() {
    _init_properties_PingPong_kt__9aqxey();
    return PongerCoroutineName;
  }
  var PongerCoroutineName;
  function get_PingerCoroutineName() {
    _init_properties_PingPong_kt__9aqxey();
    return PingerCoroutineName;
  }
  var PingerCoroutineName;
  function ponger(_this__u8e3s4, outgoing) {
    _init_properties_PingPong_kt__9aqxey();
    var channel = Channel(5);
    var tmp = get_PongerCoroutineName();
    launch(_this__u8e3s4, tmp, VOID, ponger$slambda_0(channel, outgoing, null));
    return channel;
  }
  function pinger(_this__u8e3s4, outgoing, periodMillis, timeoutMillis, onTimeout) {
    _init_properties_PingPong_kt__9aqxey();
    var actorJob = Job_0();
    var channel = Channel(2147483647);
    var tmp = actorJob.ej(get_PingerCoroutineName());
    launch(_this__u8e3s4, tmp, VOID, pinger$slambda_0(periodMillis, timeoutMillis, onTimeout, channel, outgoing, null));
    var tmp_0 = ensureNotNull(_this__u8e3s4.et().la(Key_instance_3));
    tmp_0.hu(pinger$lambda(actorJob));
    return channel;
  }
  function ponger$slambda($channel, $outgoing, resultContinuation) {
    this.f9g_1 = $channel;
    this.g9g_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ponger$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ponger$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ponger$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 14;
            this.z9_1 = 13;
            var tmp_0 = this;
            tmp_0.i9g_1 = this.f9g_1;
            this.j9g_1 = this.i9g_1;
            var tmp_1 = this;
            tmp_1.k9g_1 = this.j9g_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.m9g_1 = this.k9g_1;
            this.n9g_1 = null;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 10;
            this.z9_1 = 9;
            var tmp_2 = this;
            tmp_2.p9g_1 = this.m9g_1;
            this.q9g_1 = this.p9g_1;
            this.r9g_1 = this.q9g_1.k();
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.y9_1 = 5;
            suspendResult = this.r9g_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.y9_1 = 7;
              continue $sm;
            }

            this.s9g_1 = this.r9g_1.m();
            var tmp_3 = this;
            tmp_3.t9g_1 = this.s9g_1;
            this.u9g_1 = this.t9g_1;
            get_LOGGER().e8y('Received ping message, sending pong message');
            this.y9_1 = 6;
            suspendResult = this.g9g_1.z1b(new Pong(this.u9g_1.g9e_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.y9_1 = 4;
            continue $sm;
          case 7:
            var tmp_4 = this;
            tmp_4.o9g_1 = Unit_instance;
            this.y9_1 = 8;
            var tmp_5 = this;
            continue $sm;
          case 8:
            this.z9_1 = 13;
            var tmp_6 = this;
            cancelConsumed(this.m9g_1, this.n9g_1);
            tmp_6.l9g_1 = Unit_instance;
            this.y9_1 = 12;
            continue $sm;
          case 9:
            this.z9_1 = 10;
            var tmp_7 = this.ba_1;
            if (tmp_7 instanceof Error) {
              var e = this.ba_1;
              var tmp_8 = this;
              this.n9g_1 = e;
              throw e;
            } else {
              throw this.ba_1;
            }

          case 10:
            this.z9_1 = 13;
            var t = this.ba_1;
            cancelConsumed(this.m9g_1, this.n9g_1);
            throw t;
          case 11:
            this.z9_1 = 13;
            cancelConsumed(this.m9g_1, this.n9g_1);
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 12;
            continue $sm;
          case 12:
            this.z9_1 = 14;
            this.y9_1 = 15;
            continue $sm;
          case 13:
            this.z9_1 = 14;
            var tmp_9 = this.ba_1;
            if (tmp_9 instanceof ClosedSendChannelException) {
              var _ = this.ba_1;
              this.y9_1 = 15;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 14:
            throw this.ba_1;
          case 15:
            this.z9_1 = 14;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 14) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(ponger$slambda).i1l = function ($this$launch, completion) {
    var i = new ponger$slambda(this.f9g_1, this.g9g_1, completion);
    i.h9g_1 = $this$launch;
    return i;
  };
  function ponger$slambda_0($channel, $outgoing, resultContinuation) {
    var i = new ponger$slambda($channel, $outgoing, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function pinger$slambda$slambda($channel, resultContinuation) {
    this.d9h_1 = $channel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(pinger$slambda$slambda).h1l = function ($this$withTimeoutOrNull, $completion) {
    var tmp = this.i1l($this$withTimeoutOrNull, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(pinger$slambda$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(pinger$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.y9_1 = 4;
              continue $sm;
            }

            this.y9_1 = 2;
            suspendResult = this.d9h_1.d1c(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.y9_1 = 1;
            continue $sm;
          case 3:
            throw this.ba_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(pinger$slambda$slambda).i1l = function ($this$withTimeoutOrNull, completion) {
    var i = new pinger$slambda$slambda(this.d9h_1, completion);
    i.e9h_1 = $this$withTimeoutOrNull;
    return i;
  };
  function pinger$slambda$slambda_0($channel, resultContinuation) {
    var i = new pinger$slambda$slambda($channel, resultContinuation);
    var l = function ($this$withTimeoutOrNull, $completion) {
      return i.h1l($this$withTimeoutOrNull, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function pinger$slambda$slambda_1($outgoing, $pingMessage, $channel, resultContinuation) {
    this.n9h_1 = $outgoing;
    this.o9h_1 = $pingMessage;
    this.p9h_1 = $channel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(pinger$slambda$slambda_1).h1l = function ($this$withTimeoutOrNull, $completion) {
    var tmp = this.i1l($this$withTimeoutOrNull, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(pinger$slambda$slambda_1).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(pinger$slambda$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            get_LOGGER().e8y('WebSocket Pinger: sending ping frame');
            this.y9_1 = 1;
            var tmp0 = this.o9h_1;
            var tmp1 = Charsets_getInstance().r8o_1;
            var tmp$ret$0;
            l$ret$1: do {
              if (tmp1.equals(Charsets_getInstance().q8o_1)) {
                tmp$ret$0 = encodeToByteArray(tmp0);
                break l$ret$1;
              }
              tmp$ret$0 = encodeToByteArray_0(tmp1.u8o(), tmp0, 0, tmp0.length);
            }
             while (false);
            suspendResult = this.n9h_1.z1b(new Ping(tmp$ret$0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.y9_1 = 3;
            suspendResult = this.p9h_1.d1c(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var msg = suspendResult;
            if (String_0(msg.g9e_1, VOID, VOID, Charsets_getInstance().r8o_1) === this.o9h_1) {
              get_LOGGER().e8y('WebSocket Pinger: received valid pong frame ' + msg.toString());
              this.y9_1 = 5;
              continue $sm;
            } else {
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            get_LOGGER().e8y('WebSocket Pinger: received invalid pong frame ' + msg.toString() + ', continue waiting');
            this.y9_1 = 2;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(pinger$slambda$slambda_1).i1l = function ($this$withTimeoutOrNull, completion) {
    var i = new pinger$slambda$slambda_1(this.n9h_1, this.o9h_1, this.p9h_1, completion);
    i.q9h_1 = $this$withTimeoutOrNull;
    return i;
  };
  function pinger$slambda$slambda_2($outgoing, $pingMessage, $channel, resultContinuation) {
    var i = new pinger$slambda$slambda_1($outgoing, $pingMessage, $channel, resultContinuation);
    var l = function ($this$withTimeoutOrNull, $completion) {
      return i.h1l($this$withTimeoutOrNull, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function pinger$slambda($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing, resultContinuation) {
    this.z9h_1 = $periodMillis;
    this.a9i_1 = $timeoutMillis;
    this.b9i_1 = $onTimeout;
    this.c9i_1 = $channel;
    this.d9i_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(pinger$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(pinger$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(pinger$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 9;
            get_LOGGER().e8y('Starting WebSocket pinger coroutine with period ' + this.z9h_1.toString() + ' ms and timeout ' + this.a9i_1.toString() + ' ms');
            this.f9i_1 = Random_1(getTimeMillis());
            this.g9i_1 = new Int8Array(32);
            this.z9_1 = 7;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.y9_1 = 2;
            suspendResult = withTimeoutOrNull(this.z9h_1, pinger$slambda$slambda_0(this.c9i_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.f9i_1.qj(this.g9i_1);
            this.h9i_1 = '[ping ' + hex(this.g9i_1) + ' ping]';
            this.y9_1 = 3;
            suspendResult = withTimeoutOrNull(this.a9i_1, pinger$slambda$slambda_2(this.d9i_1, this.h9i_1, this.c9i_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.i9i_1 = suspendResult;
            if (this.i9i_1 == null) {
              get_LOGGER().e8y('WebSocket pinger has timed out');
              this.y9_1 = 5;
              suspendResult = this.b9i_1(CloseReason_init_$Create$(Codes_INTERNAL_ERROR_getInstance(), 'Ping timeout'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            this.y9_1 = 1;
            continue $sm;
          case 5:
            this.y9_1 = 6;
            continue $sm;
          case 6:
            this.z9_1 = 9;
            this.y9_1 = 8;
            continue $sm;
          case 7:
            this.z9_1 = 9;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof CancellationException) {
              var ignore = this.ba_1;
              this.y9_1 = 8;
              continue $sm;
            } else {
              var tmp_1 = this.ba_1;
              if (tmp_1 instanceof ClosedReceiveChannelException) {
                var ignore_0 = this.ba_1;
                this.y9_1 = 8;
                continue $sm;
              } else {
                var tmp_2 = this.ba_1;
                if (tmp_2 instanceof ClosedSendChannelException) {
                  var ignore_1 = this.ba_1;
                  this.y9_1 = 8;
                  continue $sm;
                } else {
                  throw this.ba_1;
                }
              }
            }

          case 8:
            this.z9_1 = 9;
            return Unit_instance;
          case 9:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 9) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(pinger$slambda).i1l = function ($this$launch, completion) {
    var i = new pinger$slambda(this.z9h_1, this.a9i_1, this.b9i_1, this.c9i_1, this.d9i_1, completion);
    i.e9i_1 = $this$launch;
    return i;
  };
  function pinger$slambda_0($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing, resultContinuation) {
    var i = new pinger$slambda($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function pinger$lambda($actorJob) {
    return function (it) {
      $actorJob.pu();
      return Unit_instance;
    };
  }
  var properties_initialized_PingPong_kt_fbfhmc;
  function _init_properties_PingPong_kt__9aqxey() {
    if (!properties_initialized_PingPong_kt_fbfhmc) {
      properties_initialized_PingPong_kt_fbfhmc = true;
      PongerCoroutineName = new CoroutineName('ws-ponger');
      PingerCoroutineName = new CoroutineName('ws-pinger');
    }
  }
  function WebSocketExtensionsConfig() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.j9i_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.k9i_1 = [false, false, false];
  }
  protoOf(WebSocketExtensionsConfig).k2p = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.j9i_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.websocket.WebSocketExtensionsConfig.build.<anonymous>' call
      var tmp$ret$0 = item();
      destination.e(tmp$ret$0);
    }
    return destination;
  };
  function parametersToString($this) {
    return $this.m9i_1.p() ? '' : ', ' + joinToString_0($this.m9i_1, ',');
  }
  function WebSocketExtensionHeader(name, parameters) {
    this.l9i_1 = name;
    this.m9i_1 = parameters;
  }
  protoOf(WebSocketExtensionHeader).toString = function () {
    return this.l9i_1 + ' ' + parametersToString(this);
  };
  function parseWebSocketExtensions(value) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = split_0(value, [',']);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.websocket.parseWebSocketExtensions.<anonymous>' call
      var extension = split_0(item, [';']);
      // Inline function 'kotlin.text.trim' call
      var this_1 = first(extension);
      var name = toString_1(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
      // Inline function 'kotlin.collections.map' call
      var this_2 = drop(extension, 1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
      var _iterator__ex2g4s_0 = this_2.k();
      while (_iterator__ex2g4s_0.l()) {
        var item_0 = _iterator__ex2g4s_0.m();
        // Inline function 'io.ktor.websocket.parseWebSocketExtensions.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.text.trim' call
        var tmp$ret$2 = toString_1(trim(isCharSequence(item_0) ? item_0 : THROW_CCE()));
        destination_0.e(tmp$ret$2);
      }
      var parameters = destination_0;
      var tmp$ret$5 = new WebSocketExtensionHeader(name, parameters);
      destination.e(tmp$ret$5);
    }
    return destination;
  }
  function WebSocketSession() {
  }
  function close_1(_this__u8e3s4, reason, $completion) {
    reason = reason === VOID ? CloseReason_init_$Create$(Codes_NORMAL_getInstance(), '') : reason;
    var tmp = new $closeCOROUTINE$3(_this__u8e3s4, reason, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function closeExceptionally(_this__u8e3s4, cause, $completion) {
    var tmp;
    if (cause instanceof CancellationException) {
      tmp = CloseReason_init_$Create$(Codes_NORMAL_getInstance(), '');
    } else {
      tmp = CloseReason_init_$Create$(Codes_INTERNAL_ERROR_getInstance(), cause.toString());
    }
    var reason = tmp;
    return close_1(_this__u8e3s4, reason, $completion);
  }
  function $closeCOROUTINE$3(_this__u8e3s4, reason, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v9i_1 = _this__u8e3s4;
    this.w9i_1 = reason;
  }
  protoOf($closeCOROUTINE$3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.v9i_1.k9a(Close_init_$Create$(this.w9i_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y9_1 = 2;
            suspendResult = this.v9i_1.l9a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.z9_1 = 4;
            this.y9_1 = 5;
            continue $sm;
          case 3:
            this.z9_1 = 4;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof Error) {
              var _ = this.ba_1;
              this.y9_1 = 5;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 4:
            throw this.ba_1;
          case 5:
            this.z9_1 = 4;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function Binary_init_$Init$(fin, data, $this) {
    Binary.call($this, fin, data, false, false, false);
    return $this;
  }
  function Binary_init_$Create$(fin, data) {
    return Binary_init_$Init$(fin, data, objectCreate(protoOf(Binary)));
  }
  function Text_init_$Init$(fin, data, $this) {
    Text_0.call($this, fin, data, false, false, false);
    return $this;
  }
  function Text_init_$Init$_0(text, $this) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.toByteArray' call
      var charset = Charsets_getInstance().q8o_1;
      if (charset.equals(Charsets_getInstance().q8o_1)) {
        tmp$ret$0 = encodeToByteArray(text);
        break $l$block;
      }
      tmp$ret$0 = encodeToByteArray_0(charset.u8o(), text, 0, text.length);
    }
    Text_init_$Init$(true, tmp$ret$0, $this);
    return $this;
  }
  function Text_init_$Create$(text) {
    return Text_init_$Init$_0(text, objectCreate(protoOf(Text_0)));
  }
  function Close_init_$Init$(reason, $this) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'io.ktor.utils.io.core.buildPacket' call
      // Inline function 'kotlin.contracts.contract' call
      var builder = new BytePacketBuilder();
      try {
        // Inline function 'io.ktor.websocket.Close.<init>.<anonymous>' call
        writeShort_0(builder, reason.b9a_1);
        writeText(builder, reason.c9a_1);
        tmp$ret$0 = builder.k2p();
        break $l$block;
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          builder.vz();
          throw t;
        } else {
          throw $p;
        }
      }
    }
    Close_init_$Init$_0(tmp$ret$0, $this);
    return $this;
  }
  function Close_init_$Create$(reason) {
    return Close_init_$Init$(reason, objectCreate(protoOf(Close)));
  }
  function Close_init_$Init$_0(packet, $this) {
    Close.call($this, readBytes(packet));
    return $this;
  }
  function Close_init_$Init$_1($this) {
    Close.call($this, Companion_getInstance_153().l9e_1);
    return $this;
  }
  function Close_init_$Create$_0() {
    return Close_init_$Init$_1(objectCreate(protoOf(Close)));
  }
  function Binary(fin, data, rsv1, rsv2, rsv3) {
    rsv1 = rsv1 === VOID ? false : rsv1;
    rsv2 = rsv2 === VOID ? false : rsv2;
    rsv3 = rsv3 === VOID ? false : rsv3;
    Frame.call(this, fin, FrameType_BINARY_getInstance(), data, NonDisposableHandle_instance_0, rsv1, rsv2, rsv3);
  }
  function Text_0(fin, data, rsv1, rsv2, rsv3) {
    rsv1 = rsv1 === VOID ? false : rsv1;
    rsv2 = rsv2 === VOID ? false : rsv2;
    rsv3 = rsv3 === VOID ? false : rsv3;
    Frame.call(this, fin, FrameType_TEXT_getInstance(), data, NonDisposableHandle_instance_0, rsv1, rsv2, rsv3);
  }
  function Close(data) {
    Frame.call(this, true, FrameType_CLOSE_getInstance(), data, NonDisposableHandle_instance_0, false, false, false);
  }
  function Ping(data) {
    Frame.call(this, true, FrameType_PING_getInstance(), data, NonDisposableHandle_instance_0, false, false, false);
  }
  function Pong(data, disposableHandle) {
    disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance_0 : disposableHandle;
    Frame.call(this, true, FrameType_PONG_getInstance(), data, disposableHandle, false, false, false);
  }
  function Companion_153() {
    Companion_instance_153 = this;
    this.l9e_1 = new Int8Array(0);
  }
  protoOf(Companion_153).m9e = function (fin, frameType, data, rsv1, rsv2, rsv3) {
    var tmp;
    switch (frameType.a3_1) {
      case 1:
        tmp = new Binary(fin, data, rsv1, rsv2, rsv3);
        break;
      case 0:
        tmp = new Text_0(fin, data, rsv1, rsv2, rsv3);
        break;
      case 2:
        tmp = new Close(data);
        break;
      case 3:
        tmp = new Ping(data);
        break;
      case 4:
        tmp = new Pong(data, NonDisposableHandle_instance_0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  var Companion_instance_153;
  function Companion_getInstance_153() {
    if (Companion_instance_153 == null)
      new Companion_153();
    return Companion_instance_153;
  }
  function Frame(fin, frameType, data, disposableHandle, rsv1, rsv2, rsv3) {
    Companion_getInstance_153();
    disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance_0 : disposableHandle;
    rsv1 = rsv1 === VOID ? false : rsv1;
    rsv2 = rsv2 === VOID ? false : rsv2;
    rsv3 = rsv3 === VOID ? false : rsv3;
    this.e9e_1 = fin;
    this.f9e_1 = frameType;
    this.g9e_1 = data;
    this.h9e_1 = disposableHandle;
    this.i9e_1 = rsv1;
    this.j9e_1 = rsv2;
    this.k9e_1 = rsv3;
  }
  protoOf(Frame).toString = function () {
    return 'Frame ' + this.f9e_1.toString() + ' (fin=' + this.e9e_1 + ', buffer len = ' + this.g9e_1.length + ')';
  };
  function get_OUTGOING_CHANNEL_CAPACITY() {
    return 8;
  }
  function Companion_154() {
  }
  var Companion_instance_154;
  function Companion_getInstance_154() {
    return Companion_instance_154;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.PublishedInstanceId', this, 1);
    tmp0_serialDesc.t5n('id', false);
    this.x9i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).y9i = function (encoder, value) {
    var tmp0_desc = this.x9i_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.t5h(tmp0_desc, 0, value.z9i_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_6).j5d = function (encoder, value) {
    return this.y9i(encoder, value instanceof PublishedInstanceId ? value : THROW_CCE());
  };
  protoOf($serializer_6).k5d = function (decoder) {
    var tmp0_desc = this.x9i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_input = decoder.j5g(tmp0_desc);
    if (tmp5_input.y5g()) {
      tmp4_local0 = tmp5_input.p5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.p5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.k5g(tmp0_desc);
    return PublishedInstanceId_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_6).w5c = function () {
    return this.x9i_1;
  };
  protoOf($serializer_6).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance()];
  };
  var $serializer_instance_6;
  function $serializer_getInstance_6() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function PublishedInstanceId_init_$Init$(seen0, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_6().x9i_1);
    }
    InstanceId_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.z9i_1 = id;
    return $this;
  }
  function PublishedInstanceId_init_$Create$(seen0, id, serializationConstructorMarker) {
    return PublishedInstanceId_init_$Init$(seen0, id, serializationConstructorMarker, objectCreate(protoOf(PublishedInstanceId)));
  }
  function PublishedInstanceId(id) {
    InstanceId.call(this);
    this.z9i_1 = id;
  }
  protoOf(PublishedInstanceId).v39 = function () {
    return this.z9i_1;
  };
  protoOf(PublishedInstanceId).toString = function () {
    return 'Published#' + this.z9i_1.toString();
  };
  protoOf(PublishedInstanceId).hashCode = function () {
    return this.z9i_1.hashCode();
  };
  protoOf(PublishedInstanceId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PublishedInstanceId))
      return false;
    var tmp0_other_with_cast = other instanceof PublishedInstanceId ? other : THROW_CCE();
    if (!this.z9i_1.equals(tmp0_other_with_cast.z9i_1))
      return false;
    return true;
  };
  function Companion_155() {
  }
  var Companion_instance_155;
  function Companion_getInstance_155() {
    return Companion_instance_155;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RemoteInstanceId', this, 1);
    tmp0_serialDesc.t5n('id', false);
    this.a9j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).b9j = function (encoder, value) {
    var tmp0_desc = this.a9j_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.t5h(tmp0_desc, 0, value.c9j_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_7).j5d = function (encoder, value) {
    return this.b9j(encoder, value instanceof RemoteInstanceId ? value : THROW_CCE());
  };
  protoOf($serializer_7).k5d = function (decoder) {
    var tmp0_desc = this.a9j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_input = decoder.j5g(tmp0_desc);
    if (tmp5_input.y5g()) {
      tmp4_local0 = tmp5_input.p5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.p5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.k5g(tmp0_desc);
    return RemoteInstanceId_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_7).w5c = function () {
    return this.a9j_1;
  };
  protoOf($serializer_7).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance()];
  };
  var $serializer_instance_7;
  function $serializer_getInstance_7() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function RemoteInstanceId_init_$Init$(seen0, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_7().a9j_1);
    }
    InstanceId_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.c9j_1 = id;
    return $this;
  }
  function RemoteInstanceId_init_$Create$(seen0, id, serializationConstructorMarker) {
    return RemoteInstanceId_init_$Init$(seen0, id, serializationConstructorMarker, objectCreate(protoOf(RemoteInstanceId)));
  }
  function RemoteInstanceId(id) {
    InstanceId.call(this);
    this.c9j_1 = id;
  }
  protoOf(RemoteInstanceId).v39 = function () {
    return this.c9j_1;
  };
  protoOf(RemoteInstanceId).toString = function () {
    return 'Remote#' + this.c9j_1.toString();
  };
  protoOf(RemoteInstanceId).hashCode = function () {
    return this.c9j_1.hashCode();
  };
  protoOf(RemoteInstanceId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemoteInstanceId))
      return false;
    var tmp0_other_with_cast = other instanceof RemoteInstanceId ? other : THROW_CCE();
    if (!this.c9j_1.equals(tmp0_other_with_cast.c9j_1))
      return false;
    return true;
  };
  function Companion_156() {
  }
  var Companion_instance_156;
  function Companion_getInstance_156() {
    return Companion_instance_156;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.MethodId', this, 1);
    tmp0_serialDesc.t5n('methodName', false);
    this.d9j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).e9j = function (encoder, value) {
    var tmp0_desc = this.d9j_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.x5h(tmp0_desc, 0, value.f9j_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_8).j5d = function (encoder, value) {
    return this.e9j(encoder, value instanceof MethodId ? value : THROW_CCE());
  };
  protoOf($serializer_8).k5d = function (decoder) {
    var tmp0_desc = this.d9j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.j5g(tmp0_desc);
    if (tmp5_input.y5g()) {
      tmp4_local0 = tmp5_input.t5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.t5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.k5g(tmp0_desc);
    return MethodId_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_8).w5c = function () {
    return this.d9j_1;
  };
  protoOf($serializer_8).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_8;
  function $serializer_getInstance_8() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function MethodId_init_$Init$(seen0, methodName, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_8().d9j_1);
    }
    $this.f9j_1 = methodName;
    return $this;
  }
  function MethodId_init_$Create$(seen0, methodName, serializationConstructorMarker) {
    return MethodId_init_$Init$(seen0, methodName, serializationConstructorMarker, objectCreate(protoOf(MethodId)));
  }
  function MethodId(methodName) {
    this.f9j_1 = methodName;
  }
  protoOf(MethodId).toString = function () {
    return this.f9j_1;
  };
  protoOf(MethodId).hashCode = function () {
    return getStringHashCode(this.f9j_1);
  };
  protoOf(MethodId).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MethodId))
      return false;
    var tmp0_other_with_cast = other instanceof MethodId ? other : THROW_CCE();
    if (!(this.f9j_1 === tmp0_other_with_cast.f9j_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_1($this) {
    return $this.g9j_1.y();
  }
  function InstanceId$Companion$_anonymous__ifoni9() {
    var tmp = getKClass(InstanceId);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(PublishedInstanceId), getKClass(RemoteInstanceId)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_6(), $serializer_getInstance_7()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    return SealedClassSerializer_init_$Create$('jetbrains.ocelot.langDef.rpc.InstanceId', tmp, tmp_0, tmp_1, tmp$ret$8);
  }
  function Companion_157() {
    Companion_instance_157 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.g9j_1 = lazy(tmp_0, InstanceId$Companion$_anonymous__ifoni9);
  }
  protoOf(Companion_157).h67 = function () {
    return _get_$cachedSerializer__te6jhj_1(this);
  };
  protoOf(Companion_157).t5o = function (typeParamsSerializers) {
    return this.h67();
  };
  var Companion_instance_157;
  function Companion_getInstance_157() {
    if (Companion_instance_157 == null)
      new Companion_157();
    return Companion_instance_157;
  }
  function InstanceId_init_$Init$(seen0, serializationConstructorMarker, $this) {
    return $this;
  }
  function InstanceId() {
    Companion_getInstance_157();
  }
  protoOf(InstanceId).toString = function () {
    return this.v39().toString();
  };
  function get_opposite(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof PublishedInstanceId) {
      tmp = new RemoteInstanceId(_this__u8e3s4.z9i_1);
    } else {
      if (_this__u8e3s4 instanceof RemoteInstanceId) {
        tmp = new PublishedInstanceId(_this__u8e3s4.c9j_1);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function get_published(_this__u8e3s4) {
    return new PublishedInstanceId(_this__u8e3s4.v39());
  }
  function ImmediateMethodHandle() {
  }
  function InstanceDescriptor() {
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.i9j_1 = HashMap_init_$Create$();
  }
  protoOf(InstanceDescriptor).k9j = function (method) {
    var tmp0 = this.i9j_1;
    // Inline function 'kotlin.collections.set' call
    var key = method.v39();
    tmp0.r2(key, method);
  };
  function InstancePublication() {
  }
  function LocalInstancePublication(instance, id, facade, publicationDisposal) {
    this.m9j_1 = publicationDisposal;
    this.n9j_1 = instance;
    this.o9j_1 = id;
    this.p9j_1 = facade;
  }
  protoOf(LocalInstancePublication).b2p = function () {
    return this.n9j_1;
  };
  protoOf(LocalInstancePublication).v39 = function () {
    return this.o9j_1;
  };
  protoOf(LocalInstancePublication).l9j = function () {
    return this.p9j_1;
  };
  protoOf(LocalInstancePublication).vr = function () {
    this.m9j_1.vr();
  };
  protoOf(LocalInstancePublication).sr = function (disposable) {
    return this.m9j_1.sr(disposable);
  };
  function RemoteInstancePublication(id, endpoint, instance) {
    this.q9j_1 = id;
    this.r9j_1 = endpoint;
    this.s9j_1 = instance;
  }
  protoOf(RemoteInstancePublication).v39 = function () {
    return this.q9j_1;
  };
  protoOf(RemoteInstancePublication).b2p = function () {
    return this.s9j_1;
  };
  protoOf(RemoteInstancePublication).vr = function () {
    this.r9j_1.vr();
  };
  protoOf(RemoteInstancePublication).l9j = function () {
    return this.r9j_1.l9j();
  };
  function OppositeInstanceIdSerializer() {
    OppositeInstanceIdSerializer_instance = this;
    this.t9j_1 = Companion_getInstance_157().h67().w5c();
  }
  protoOf(OppositeInstanceIdSerializer).w5c = function () {
    return this.t9j_1;
  };
  protoOf(OppositeInstanceIdSerializer).k5d = function (decoder) {
    return get_opposite(decoder.l5d(Companion_getInstance_157().h67()));
  };
  protoOf(OppositeInstanceIdSerializer).u9j = function (encoder, value) {
    return encoder.i5d(Companion_getInstance_157().h67(), get_opposite(value));
  };
  protoOf(OppositeInstanceIdSerializer).j5d = function (encoder, value) {
    return this.u9j(encoder, value instanceof InstanceId ? value : THROW_CCE());
  };
  var OppositeInstanceIdSerializer_instance;
  function OppositeInstanceIdSerializer_getInstance() {
    if (OppositeInstanceIdSerializer_instance == null)
      new OppositeInstanceIdSerializer();
    return OppositeInstanceIdSerializer_instance;
  }
  function InstancePublicationSerializer(instanceDescriptor) {
    this.v9j_1 = instanceDescriptor;
    this.w9j_1 = Companion_getInstance_158().h67();
    this.x9j_1 = this.w9j_1.w5c();
  }
  protoOf(InstancePublicationSerializer).w5c = function () {
    return this.x9j_1;
  };
  protoOf(InstancePublicationSerializer).k5d = function (decoder) {
    var _destruct__k2r9zo = decoder.l5d(this.w9j_1);
    var facade = _destruct__k2r9zo.ug();
    var id = _destruct__k2r9zo.vg();
    var tmp;
    if (id instanceof PublishedInstanceId) {
      tmp = facade.c9k(id, this.v9j_1);
    } else {
      if (id instanceof RemoteInstanceId) {
        tmp = facade.b9k(id, this.v9j_1);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  };
  protoOf(InstancePublicationSerializer).d9k = function (encoder, value) {
    var transfer = new InstancePublicationTransfer(value.l9j(), value.v39());
    encoder.i5d(this.w9j_1, transfer);
  };
  protoOf(InstancePublicationSerializer).j5d = function (encoder, value) {
    return this.d9k(encoder, (!(value == null) ? isInterface(value, InstancePublication) : false) ? value : THROW_CCE());
  };
  function Companion_158() {
    Companion_instance_158 = this;
    var tmp = this;
    var tmp_0 = getKClass(RpcFacade);
    var tmp_1 = getKClass(RpcFacade);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    var tmp_2 = PolymorphicSerializer_init_$Create$(tmp_1, tmp$ret$2);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [];
    var tmp_3 = new ContextualSerializer(tmp_0, tmp_2, tmp$ret$5);
    var tmp_4 = getKClass(InstanceId);
    var tmp_5 = Companion_getInstance_157().h67();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y9j_1 = [tmp_3, new ContextualSerializer(tmp_4, tmp_5, tmp$ret$8)];
  }
  protoOf(Companion_158).h67 = function () {
    return $serializer_getInstance_9();
  };
  var Companion_instance_158;
  function Companion_getInstance_158() {
    if (Companion_instance_158 == null)
      new Companion_158();
    return Companion_instance_158;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.InstancePublicationTransfer', this, 2);
    tmp0_serialDesc.t5n('facade', false);
    tmp0_serialDesc.t5n('id', false);
    this.e9k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).f9k = function (encoder, value) {
    var tmp0_desc = this.e9k_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    var tmp2_cached = Companion_getInstance_158().y9j_1;
    tmp1_output.z5h(tmp0_desc, 0, tmp2_cached[0], value.z9j_1);
    tmp1_output.z5h(tmp0_desc, 1, tmp2_cached[1], value.a9k_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_9).j5d = function (encoder, value) {
    return this.f9k(encoder, value instanceof InstancePublicationTransfer ? value : THROW_CCE());
  };
  protoOf($serializer_9).k5d = function (decoder) {
    var tmp0_desc = this.e9k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    var tmp7_cached = Companion_getInstance_158().y9j_1;
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return InstancePublicationTransfer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_9).w5c = function () {
    return this.e9k_1;
  };
  protoOf($serializer_9).i5o = function () {
    var tmp0_cached = Companion_getInstance_158().y9j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1]];
  };
  var $serializer_instance_9;
  function $serializer_getInstance_9() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function InstancePublicationTransfer_init_$Init$(seen0, facade, id, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_9().e9k_1);
    }
    $this.z9j_1 = facade;
    $this.a9k_1 = id;
    return $this;
  }
  function InstancePublicationTransfer_init_$Create$(seen0, facade, id, serializationConstructorMarker) {
    return InstancePublicationTransfer_init_$Init$(seen0, facade, id, serializationConstructorMarker, objectCreate(protoOf(InstancePublicationTransfer)));
  }
  function InstancePublicationTransfer(facade, id) {
    Companion_getInstance_158();
    this.z9j_1 = facade;
    this.a9k_1 = id;
  }
  protoOf(InstancePublicationTransfer).ug = function () {
    return this.z9j_1;
  };
  protoOf(InstancePublicationTransfer).vg = function () {
    return this.a9k_1;
  };
  protoOf(InstancePublicationTransfer).toString = function () {
    return 'InstancePublicationTransfer(facade=' + toString_1(this.z9j_1) + ', id=' + this.a9k_1.toString() + ')';
  };
  protoOf(InstancePublicationTransfer).hashCode = function () {
    var result = hashCode(this.z9j_1);
    result = imul(result, 31) + hashCode(this.a9k_1) | 0;
    return result;
  };
  protoOf(InstancePublicationTransfer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InstancePublicationTransfer))
      return false;
    var tmp0_other_with_cast = other instanceof InstancePublicationTransfer ? other : THROW_CCE();
    if (!equals(this.z9j_1, tmp0_other_with_cast.z9j_1))
      return false;
    if (!equals(this.a9k_1, tmp0_other_with_cast.a9k_1))
      return false;
    return true;
  };
  function method(_this__u8e3s4, id, parameterSerializer, resultSerializer, handle) {
    var descriptor = new MethodDescriptorImpl(new MethodId(id), parameterSerializer, resultSerializer, handle);
    _this__u8e3s4.k9j(descriptor);
    return descriptor;
  }
  function MethodDescriptorImpl(id, parameterSerializer, resultSerializer, handle) {
    this.g9k_1 = id;
    this.h9k_1 = parameterSerializer;
    this.i9k_1 = resultSerializer;
    this.j9k_1 = handle;
  }
  protoOf(MethodDescriptorImpl).v39 = function () {
    return this.g9k_1;
  };
  protoOf(MethodDescriptorImpl).k9k = function () {
    return this.h9k_1;
  };
  protoOf(MethodDescriptorImpl).l9k = function () {
    return this.i9k_1;
  };
  protoOf(MethodDescriptorImpl).m9k = function (instance, parameter, $completion) {
    return this.j9k_1(instance, parameter, $completion);
  };
  protoOf(MethodDescriptorImpl).n9k = function (endpoint, parameter, $completion) {
    return endpoint.o9k(this.g9k_1, this.h9k_1, this.i9k_1, parameter, $completion);
  };
  function mapResult(_this__u8e3s4, resultMapper) {
    var delegate = _this__u8e3s4;
    return new mapResult$1(delegate, resultMapper);
  }
  function $callCOROUTINE$0(_this__u8e3s4, endpoint, parameter, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x9k_1 = _this__u8e3s4;
    this.y9k_1 = endpoint;
    this.z9k_1 = parameter;
  }
  protoOf($callCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.x9k_1.a9l_1.n9k(this.y9k_1, this.z9k_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            return this.x9k_1.b9l_1(this_0);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function mapResult$1($delegate, $resultMapper) {
    this.a9l_1 = $delegate;
    this.b9l_1 = $resultMapper;
  }
  protoOf(mapResult$1).c9l = function (endpoint, parameter, $completion) {
    var tmp = new $callCOROUTINE$0(this, endpoint, parameter, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(mapResult$1).n9k = function (endpoint, parameter, $completion) {
    return this.c9l(endpoint, (parameter == null ? true : !(parameter == null)) ? parameter : THROW_CCE(), $completion);
  };
  function RemoteInvocationException(message) {
    RuntimeException_init_$Init$_0(message, this);
    captureStack(this, RemoteInvocationException);
  }
  function CallRemote(instanceId, methodId, parameter, result) {
    RpcEndpointMethod.call(this, result);
    this.e9l_1 = instanceId;
    this.f9l_1 = methodId;
    this.g9l_1 = parameter;
    this.h9l_1 = result;
  }
  protoOf(CallRemote).toString = function () {
    return 'CallRemote(instanceId=' + this.e9l_1.toString() + ', methodId=' + this.f9l_1.toString() + ', parameter=' + toString_1(this.g9l_1) + ', result=' + toString_1(this.h9l_1) + ')';
  };
  protoOf(CallRemote).hashCode = function () {
    var result = this.e9l_1.hashCode();
    result = imul(result, 31) + this.f9l_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.g9l_1) | 0;
    result = imul(result, 31) + hashCode(this.h9l_1) | 0;
    return result;
  };
  protoOf(CallRemote).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CallRemote))
      return false;
    var tmp0_other_with_cast = other instanceof CallRemote ? other : THROW_CCE();
    if (!this.e9l_1.equals(tmp0_other_with_cast.e9l_1))
      return false;
    if (!this.f9l_1.equals(tmp0_other_with_cast.f9l_1))
      return false;
    if (!equals(this.g9l_1, tmp0_other_with_cast.g9l_1))
      return false;
    if (!equals(this.h9l_1, tmp0_other_with_cast.h9l_1))
      return false;
    return true;
  };
  function DisposeRemote(instanceId) {
    RpcEndpointMethod.call(this, Job_0());
    this.k9l_1 = instanceId;
  }
  protoOf(DisposeRemote).toString = function () {
    return 'DisposeRemote(instanceId=' + this.k9l_1.toString() + ')';
  };
  protoOf(DisposeRemote).hashCode = function () {
    return this.k9l_1.hashCode();
  };
  protoOf(DisposeRemote).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DisposeRemote))
      return false;
    var tmp0_other_with_cast = other instanceof DisposeRemote ? other : THROW_CCE();
    if (!this.k9l_1.equals(tmp0_other_with_cast.k9l_1))
      return false;
    return true;
  };
  function RpcEndpointMethod(job) {
    this.i9l_1 = job;
  }
  protoOf(RpcEndpointMethod).wu = function (child) {
    return this.i9l_1.wu(child);
  };
  protoOf(RpcEndpointMethod).ou = function (cause) {
    this.i9l_1.ou(cause);
  };
  protoOf(RpcEndpointMethod).eu = function () {
    return this.i9l_1.eu();
  };
  protoOf(RpcEndpointMethod).iu = function (onCancelling, invokeImmediately, handler) {
    return this.i9l_1.iu(onCancelling, invokeImmediately, handler);
  };
  protoOf(RpcEndpointMethod).hu = function (handler) {
    return this.i9l_1.hu(handler);
  };
  protoOf(RpcEndpointMethod).ku = function ($completion) {
    return this.i9l_1.ku($completion);
  };
  protoOf(RpcEndpointMethod).ej = function (context) {
    return this.i9l_1.ej(context);
  };
  protoOf(RpcEndpointMethod).cu = function () {
    return this.i9l_1.cu();
  };
  protoOf(RpcEndpointMethod).ft = function () {
    return this.i9l_1.ft();
  };
  protoOf(RpcEndpointMethod).au = function () {
    return this.i9l_1.au();
  };
  protoOf(RpcEndpointMethod).lu = function () {
    return this.i9l_1.lu();
  };
  protoOf(RpcEndpointMethod).yt = function () {
    return this.i9l_1.yt();
  };
  protoOf(RpcEndpointMethod).la = function (key) {
    return this.i9l_1.la(key);
  };
  protoOf(RpcEndpointMethod).dj = function (initial, operation) {
    return this.i9l_1.dj(initial, operation);
  };
  protoOf(RpcEndpointMethod).cj = function (key) {
    return this.i9l_1.cj(key);
  };
  protoOf(RpcEndpointMethod).x = function () {
    return this.i9l_1.x();
  };
  function RpcFacade() {
  }
  function RpcFacadeCancellationException() {
    CancellationException_init_$Init$_0('RPC facade has been disposed', this);
    captureStack(this, RpcFacadeCancellationException);
  }
  function get_LOG_0() {
    _init_properties_RpcFacadeImpl_kt__t7eclv();
    return LOG_0;
  }
  var LOG_0;
  function $callRemoteCOROUTINE$1(_this__u8e3s4, methodId, parameterSerializer, resultSerializer, parameter, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v9l_1 = _this__u8e3s4;
    this.w9l_1 = methodId;
    this.x9l_1 = parameterSerializer;
    this.y9l_1 = resultSerializer;
    this.z9l_1 = parameter;
  }
  protoOf($callRemoteCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            this.a9m_1 = this.v9l_1.l9m_1.i9m_1.f9m_1.d5e(this.x9l_1, this.z9l_1);
            this.b9m_1 = CompletableDeferred();
            var tmp_0 = this;
            tmp_0.c9m_1 = this.v9l_1.l9m_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.d9m_1 = this.c9m_1;
            this.z9_1 = 5;
            this.y9_1 = 2;
            suspendResult = this.v9l_1.l9m_1.g9m_1.z1b(new CallRemote(this.v9l_1.k9m_1, this.w9l_1, this.a9m_1, this.b9m_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.y9_1 = 3;
            suspendResult = this.b9m_1.gw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var resultBytes = suspendResult;
            var tmp_1 = this;
            return this.v9l_1.l9m_1.i9m_1.e9m_1.e5e(this.y9l_1, resultBytes);
          case 4:
            return Unit_instance;
          case 5:
            this.z9_1 = 6;
            var tmp_2 = this.ba_1;
            if (tmp_2 instanceof CancellationException) {
              var exception = this.ba_1;
              throw new RpcFacadeCancellationException();
            } else {
              throw this.ba_1;
            }

          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function RpcEndpointImpl($outer, instanceId) {
    this.l9m_1 = $outer;
    this.k9m_1 = instanceId;
  }
  protoOf(RpcEndpointImpl).l9j = function () {
    return this.l9m_1;
  };
  protoOf(RpcEndpointImpl).vr = function () {
    this.l9m_1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.langDef.rpc.RpcFacadeImpl.coerceCancellation' call
      try {
        // Inline function 'jetbrains.ocelot.langDef.rpc.RpcEndpointImpl.dispose.<anonymous>' call
        ChannelResult__getOrThrow_impl_od1axs(this.l9m_1.g9m_1.a1c(new DisposeRemote(this.k9m_1)));
        break $l$block;
      } catch ($p) {
        if ($p instanceof CancellationException) {
          var exception = $p;
          throw new RpcFacadeCancellationException();
        } else {
          throw $p;
        }
      }
    }
  };
  protoOf(RpcEndpointImpl).o9k = function (methodId, parameterSerializer, resultSerializer, parameter, $completion) {
    var tmp = new $callRemoteCOROUTINE$1(this, methodId, parameterSerializer, resultSerializer, parameter, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_4(function_0) {
    this.m9m_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_4).vr = function () {
    return this.m9m_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_4).b4 = function () {
    return this.m9m_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_4).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_5(function_0) {
    this.n9m_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_5).vr = function () {
    return this.n9m_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_5).b4 = function () {
    return this.n9m_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_5).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_5).hashCode = function () {
    return hashCode(this.b4());
  };
  function RpcFacadeImpl$publishInstance$lambda(this$0, $instanceId) {
    return function () {
      this$0.j9m_1.s9m($instanceId);
      return Unit_instance;
    };
  }
  function RpcFacadeImpl$obtainLocalInstance$lambda(this$0, $instanceId) {
    return function () {
      this$0.j9m_1.s9m($instanceId);
      return Unit_instance;
    };
  }
  function RpcFacadeImpl(channel, job) {
    this.g9m_1 = channel;
    this.h9m_1 = job;
    this.i9m_1 = new BinaryFormatsImpl(this);
    this.j9m_1 = new RpcInstancesPublisher(this.i9m_1);
  }
  protoOf(RpcFacadeImpl).k11 = function () {
    return this.h9m_1;
  };
  protoOf(RpcFacadeImpl).l9l = function (instance, instanceDescriptor, instanceDisposal, $completion) {
    var entry = new PublicationEntry(instance, instanceDescriptor, instanceDisposal);
    var instanceId = this.j9m_1.t9m(entry);
    get_LOG_0().go('Processed publishInstance(): ' + instanceId.toString());
    var tmp = RpcFacadeImpl$publishInstance$lambda(this, instanceId);
    return new LocalInstancePublication(entry.u9m_1, instanceId, this, new sam$jetbrains_ocelot_base_disposable_Disposable$0_4(tmp));
  };
  protoOf(RpcFacadeImpl).b9k = function (instanceId, instanceDescriptor) {
    var endpoint = new RpcEndpointImpl(this, instanceId);
    return new RemoteInstancePublication(instanceId, endpoint, instanceDescriptor.j9j(endpoint));
  };
  protoOf(RpcFacadeImpl).c9k = function (instanceId, instanceDescriptor) {
    var instance = this.j9m_1.x9m(instanceId);
    var tmp = RpcFacadeImpl$obtainLocalInstance$lambda(this, instanceId);
    return new LocalInstancePublication(instance, instanceId, this, new sam$jetbrains_ocelot_base_disposable_Disposable$0_5(tmp));
  };
  function BinaryFormatsImpl$incoming$lambda($facade) {
    return function ($this$ProtoBuf) {
      var tmp = $this$ProtoBuf;
      // Inline function 'kotlinx.serialization.modules.SerializersModule' call
      var builder = new SerializersModuleBuilder();
      // Inline function 'jetbrains.ocelot.langDef.rpc.BinaryFormatsImpl.incoming.<anonymous>.<anonymous>' call
      builder.n5x(getKClass(RpcFacade), new RpcFacadeIntrinsicSerializer($facade));
      builder.n5x(getKClass(InstanceId), Companion_getInstance_157().h67());
      tmp.a5z_1 = builder.w5l();
      return Unit_instance;
    };
  }
  function BinaryFormatsImpl$outgoing$lambda($facade) {
    return function ($this$ProtoBuf) {
      var tmp = $this$ProtoBuf;
      // Inline function 'kotlinx.serialization.modules.SerializersModule' call
      var builder = new SerializersModuleBuilder();
      // Inline function 'jetbrains.ocelot.langDef.rpc.BinaryFormatsImpl.outgoing.<anonymous>.<anonymous>' call
      builder.n5x(getKClass(RpcFacade), new RpcFacadeIntrinsicSerializer($facade));
      builder.n5x(getKClass(InstanceId), OppositeInstanceIdSerializer_getInstance());
      tmp.a5z_1 = builder.w5l();
      return Unit_instance;
    };
  }
  function BinaryFormatsImpl(facade) {
    var tmp = this;
    tmp.e9m_1 = ProtoBuf_0(VOID, BinaryFormatsImpl$incoming$lambda(facade));
    var tmp_0 = this;
    tmp_0.f9m_1 = ProtoBuf_0(VOID, BinaryFormatsImpl$outgoing$lambda(facade));
  }
  protoOf(BinaryFormatsImpl).i9a = function () {
    return this.e9m_1;
  };
  protoOf(BinaryFormatsImpl).j9a = function () {
    return this.f9m_1;
  };
  function rpcFacade(_this__u8e3s4, incoming, outgoing, newCoroutineContext) {
    newCoroutineContext = newCoroutineContext === VOID ? EmptyCoroutineContext_getInstance() : newCoroutineContext;
    _init_properties_RpcFacadeImpl_kt__t7eclv();
    var channel = Channel(2147483647, VOID, rpcFacade$lambda);
    var job = Job_0(get_job(_this__u8e3s4.et()));
    var facade = new RpcFacadeImpl(channel, job);
    var publisher = facade.j9m_1;
    var tmp = newCoroutineContext.ej(facade.h9m_1);
    var tmp_0 = launch(_this__u8e3s4, tmp, VOID, rpcFacade$slambda_0(outgoing, publisher, incoming, job, channel, null));
    tmp_0.hu(rpcFacade$lambda_0(outgoing, channel, publisher));
    return facade;
  }
  function rpcIncomingMessagesProcessor(_this__u8e3s4, messages, outgoingCalls, incomingCalls, publisher, facadeJob) {
    _init_properties_RpcFacadeImpl_kt__t7eclv();
    launch(_this__u8e3s4, VOID, VOID, rpcIncomingMessagesProcessor$slambda_0(messages, incomingCalls, publisher, outgoingCalls, facadeJob, null));
  }
  function rpcOutgoingCallsProcessor(_this__u8e3s4, messages, outgoing, outgoingCalls) {
    _init_properties_RpcFacadeImpl_kt__t7eclv();
    launch(_this__u8e3s4, VOID, VOID, rpcOutgoingCallsProcessor$slambda_0(messages, outgoingCalls, outgoing, null));
  }
  function rpcFacade$lambda(it) {
    _init_properties_RpcFacadeImpl_kt__t7eclv();
    it.pu();
    return Unit_instance;
  }
  function rpcFacade$slambda($outgoing, $publisher, $incoming, $job, $channel, resultContinuation) {
    this.g9n_1 = $outgoing;
    this.h9n_1 = $publisher;
    this.i9n_1 = $incoming;
    this.j9n_1 = $job;
    this.k9n_1 = $channel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcFacade$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(rpcFacade$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcFacade$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var outgoingCalls = rpcOutgoingCalls(this.l9n_1);
          var incomingCalls = rpcIncomingCalls(this.l9n_1, this.g9n_1, this.h9n_1);
          rpcIncomingMessagesProcessor(this.l9n_1, this.i9n_1, outgoingCalls, incomingCalls, this.h9n_1, this.j9n_1);
          rpcOutgoingCallsProcessor(this.l9n_1, this.k9n_1, this.g9n_1, outgoingCalls);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(rpcFacade$slambda).i1l = function ($this$launch, completion) {
    var i = new rpcFacade$slambda(this.g9n_1, this.h9n_1, this.i9n_1, this.j9n_1, this.k9n_1, completion);
    i.l9n_1 = $this$launch;
    return i;
  };
  function rpcFacade$slambda_0($outgoing, $publisher, $incoming, $job, $channel, resultContinuation) {
    var i = new rpcFacade$slambda($outgoing, $publisher, $incoming, $job, $channel, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function rpcFacade$lambda_0($outgoing, $channel, $publisher) {
    return function (it) {
      $outgoing.i1c();
      $channel.k1c();
      $publisher.vr();
      return Unit_instance;
    };
  }
  function rpcIncomingMessagesProcessor$slambda($messages, $incomingCalls, $publisher, $outgoingCalls, $facadeJob, resultContinuation) {
    this.u9n_1 = $messages;
    this.v9n_1 = $incomingCalls;
    this.w9n_1 = $publisher;
    this.x9n_1 = $outgoingCalls;
    this.y9n_1 = $facadeJob;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcIncomingMessagesProcessor$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(rpcIncomingMessagesProcessor$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcIncomingMessagesProcessor$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 11;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 10;
            this.b9o_1 = this.u9n_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            suspendResult = this.b9o_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (!suspendResult) {
              this.y9_1 = 8;
              continue $sm;
            }

            this.c9o_1 = this.b9o_1.m();
            this.d9o_1 = this.c9o_1;
            var tmp_0 = this.d9o_1;
            if (tmp_0 instanceof Call) {
              var tmp_1 = this;
              tmp_1.e9o_1 = this.c9o_1;
              this.f9o_1 = this.e9o_1;
              var tmp_2 = this;
              tmp_2.g9o_1 = this.f9o_1;
              this.h9o_1 = this.g9o_1;
              get_LOG_0().go('Received call request with id ' + this.h9o_1.q9o_1.toString() + ', instance ' + this.h9o_1.r9o_1.toString() + ', method ' + this.h9o_1.s9o_1.toString());
              this.y9_1 = 6;
              suspendResult = this.v9n_1.x9o(this.h9o_1.q9o_1, get_published(this.h9o_1.r9o_1), this.h9o_1.s9o_1, this.h9o_1.t9o_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_3 = this.d9o_1;
              if (tmp_3 instanceof Dispose) {
                try {
                  var instanceId = get_published(this.c9o_1.p9o_1);
                  get_LOG_0().go('Received dispose request with of instance ' + instanceId.toString());
                  this.w9n_1.s9m(instanceId);
                } catch ($p) {
                  if ($p instanceof Exception) {
                    var e = $p;
                    get_LOG_0().co('Error during handling dispose request', e);
                  } else {
                    throw $p;
                  }
                }
                this.y9_1 = 7;
                continue $sm;
              } else {
                var tmp_4 = this.d9o_1;
                if (tmp_4 instanceof Answer) {
                  get_LOG_0().go('Received answer response for call ' + this.c9o_1.m9o_1.toString());
                  this.y9_1 = 5;
                  suspendResult = this.x9n_1.o9o(this.c9o_1.m9o_1, this.c9o_1.n9o_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_5 = this.d9o_1;
                  if (tmp_5 instanceof ErrorAnswer) {
                    get_LOG_0().go('Received error answer response for call ' + this.c9o_1.i9o_1.toString());
                    this.y9_1 = 4;
                    suspendResult = this.x9n_1.l9o(this.c9o_1.i9o_1, this.c9o_1.j9o_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }

            break;
          case 4:
            this.y9_1 = 7;
            continue $sm;
          case 5:
            this.y9_1 = 7;
            continue $sm;
          case 6:
            this.y9_1 = 7;
            continue $sm;
          case 7:
            this.y9_1 = 2;
            continue $sm;
          case 8:
            this.a9o_1 = Unit_instance;
            this.z9_1 = 11;
            this.y9_1 = 9;
            continue $sm;
          case 9:
            this.z9_1 = 11;
            this.y9n_1.pu();
            return Unit_instance;
          case 10:
            this.z9_1 = 11;
            var t = this.ba_1;
            this.y9n_1.pu();
            throw t;
          case 11:
            throw this.ba_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 11) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(rpcIncomingMessagesProcessor$slambda).i1l = function ($this$launch, completion) {
    var i = new rpcIncomingMessagesProcessor$slambda(this.u9n_1, this.v9n_1, this.w9n_1, this.x9n_1, this.y9n_1, completion);
    i.z9n_1 = $this$launch;
    return i;
  };
  function rpcIncomingMessagesProcessor$slambda_0($messages, $incomingCalls, $publisher, $outgoingCalls, $facadeJob, resultContinuation) {
    var i = new rpcIncomingMessagesProcessor$slambda($messages, $incomingCalls, $publisher, $outgoingCalls, $facadeJob, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function rpcOutgoingCallsProcessor$slambda($messages, $outgoingCalls, $outgoing, resultContinuation) {
    this.g9p_1 = $messages;
    this.h9p_1 = $outgoingCalls;
    this.i9p_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcOutgoingCallsProcessor$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(rpcOutgoingCallsProcessor$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcOutgoingCallsProcessor$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 11;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 10;
            this.l9p_1 = this.g9p_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            suspendResult = this.l9p_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (!suspendResult) {
              this.y9_1 = 8;
              continue $sm;
            }

            this.m9p_1 = this.l9p_1.m();
            this.n9p_1 = this.m9p_1;
            var tmp_0 = this.n9p_1;
            if (tmp_0 instanceof CallRemote) {
              this.y9_1 = 5;
              suspendResult = this.h9p_1.p9p(this.m9p_1.h9l_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this.n9p_1;
              if (tmp_1 instanceof DisposeRemote) {
                this.y9_1 = 4;
                suspendResult = this.i9p_1.z1b(new Dispose(this.m9p_1.k9l_1), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                noWhenBranchMatchedException();
              }
            }

            break;
          case 4:
            get_LOG_0().go('Processed disposeRemote(' + this.m9p_1.k9l_1.toString() + ')');
            this.y9_1 = 7;
            continue $sm;
          case 5:
            this.o9p_1 = suspendResult;
            this.y9_1 = 6;
            suspendResult = this.i9p_1.z1b(new Call(this.o9p_1, this.m9p_1.e9l_1, this.m9p_1.f9l_1, this.m9p_1.g9l_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            get_LOG_0().go('Processed callRemote(' + this.m9p_1.e9l_1.toString() + ', ' + this.m9p_1.f9l_1.toString() + '): ' + this.o9p_1.toString());
            this.y9_1 = 7;
            continue $sm;
          case 7:
            this.y9_1 = 2;
            continue $sm;
          case 8:
            this.k9p_1 = Unit_instance;
            this.z9_1 = 11;
            this.y9_1 = 9;
            continue $sm;
          case 9:
            this.z9_1 = 11;
            get_LOG_0().ho('RPC facade is disposed');
            return Unit_instance;
          case 10:
            this.z9_1 = 11;
            var t = this.ba_1;
            get_LOG_0().ho('RPC facade is disposed');
            throw t;
          case 11:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 11) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(rpcOutgoingCallsProcessor$slambda).i1l = function ($this$launch, completion) {
    var i = new rpcOutgoingCallsProcessor$slambda(this.g9p_1, this.h9p_1, this.i9p_1, completion);
    i.j9p_1 = $this$launch;
    return i;
  };
  function rpcOutgoingCallsProcessor$slambda_0($messages, $outgoingCalls, $outgoing, resultContinuation) {
    var i = new rpcOutgoingCallsProcessor$slambda($messages, $outgoingCalls, $outgoing, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var properties_initialized_RpcFacadeImpl_kt_cmxezz;
  function _init_properties_RpcFacadeImpl_kt__t7eclv() {
    if (!properties_initialized_RpcFacadeImpl_kt_cmxezz) {
      properties_initialized_RpcFacadeImpl_kt_cmxezz = true;
      LOG_0 = getLogger(getKClass(RpcFacadeImpl));
    }
  }
  function _get_$cachedSerializer__te6jhj_2($this) {
    return $this.q9p_1.y();
  }
  function RpcFacadeIntrinsicSerializer$RpcFacadeStub$_anonymous__8jv50q() {
    var tmp = RpcFacadeStub_getInstance();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    return ObjectSerializer_init_$Create$('jetbrains.ocelot.langDef.rpc.RpcFacadeIntrinsicSerializer.RpcFacadeStub', tmp, tmp$ret$2);
  }
  function RpcFacadeStub() {
    RpcFacadeStub_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q9p_1 = lazy(tmp_0, RpcFacadeIntrinsicSerializer$RpcFacadeStub$_anonymous__8jv50q);
  }
  protoOf(RpcFacadeStub).h67 = function () {
    return _get_$cachedSerializer__te6jhj_2(this);
  };
  protoOf(RpcFacadeStub).t5o = function (typeParamsSerializers) {
    return this.h67();
  };
  var RpcFacadeStub_instance;
  function RpcFacadeStub_getInstance() {
    if (RpcFacadeStub_instance == null)
      new RpcFacadeStub();
    return RpcFacadeStub_instance;
  }
  function RpcFacadeIntrinsicSerializer(facade) {
    this.r9p_1 = facade;
    this.s9p_1 = RpcFacadeStub_getInstance().h67().w5c();
  }
  protoOf(RpcFacadeIntrinsicSerializer).w5c = function () {
    return this.s9p_1;
  };
  protoOf(RpcFacadeIntrinsicSerializer).k5d = function (decoder) {
    decoder.l5d(RpcFacadeStub_getInstance().h67());
    return this.r9p_1;
  };
  protoOf(RpcFacadeIntrinsicSerializer).t9p = function (encoder, value) {
    encoder.i5d(RpcFacadeStub_getInstance().h67(), RpcFacadeStub_getInstance());
  };
  protoOf(RpcFacadeIntrinsicSerializer).j5d = function (encoder, value) {
    return this.t9p(encoder, (!(value == null) ? isInterface(value, RpcFacade) : false) ? value : THROW_CCE());
  };
  function mixinFacade(_this__u8e3s4) {
    return new mixinFacade$1(_this__u8e3s4);
  }
  function $serializer_init_$Init$(typeSerial0, $this) {
    $serializer_10.call($this);
    $this.v9p_1 = typeSerial0;
    return $this;
  }
  function $serializer_init_$Create$(typeSerial0) {
    return $serializer_init_$Init$(typeSerial0, objectCreate(protoOf($serializer_10)));
  }
  function Companion_159() {
    Companion_instance_159 = this;
    var tmp = this;
    var tmp_0 = getKClass(RpcFacade);
    var tmp_1 = getKClass(RpcFacade);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [];
    var tmp_2 = PolymorphicSerializer_init_$Create$(tmp_1, tmp$ret$2);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w9p_1 = [new ContextualSerializer(tmp_0, tmp_2, tmp$ret$5), null];
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RpcFacadeMixin', null, 2);
    tmp0_serialDesc.t5n('facade', false);
    tmp0_serialDesc.t5n('parameter', false);
    this.x9p_1 = tmp0_serialDesc;
  }
  protoOf(Companion_159).y9p = function (typeSerial0) {
    return $serializer_init_$Create$(typeSerial0);
  };
  protoOf(Companion_159).t5o = function (typeParamsSerializers) {
    return this.y9p(typeParamsSerializers[0]);
  };
  var Companion_instance_159;
  function Companion_getInstance_159() {
    if (Companion_instance_159 == null)
      new Companion_159();
    return Companion_instance_159;
  }
  function $serializer_10() {
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RpcFacadeMixin', this, 2);
    tmp0_serialDesc.t5n('facade', false);
    tmp0_serialDesc.t5n('parameter', false);
    this.u9p_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).z9p = function (encoder, value) {
    var tmp0_desc = this.u9p_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    var tmp2_cached = Companion_getInstance_159().w9p_1;
    tmp1_output.z5h(tmp0_desc, 0, tmp2_cached[0], value.a9q_1);
    tmp1_output.z5h(tmp0_desc, 1, this.v9p_1, value.b9q_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_10).j5d = function (encoder, value) {
    return this.z9p(encoder, value instanceof RpcFacadeMixin ? value : THROW_CCE());
  };
  protoOf($serializer_10).k5d = function (decoder) {
    var tmp0_desc = this.u9p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    var tmp7_cached = Companion_getInstance_159().w9p_1;
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, this.v9p_1, tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, this.v9p_1, tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return RpcFacadeMixin_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_10).w5c = function () {
    return this.u9p_1;
  };
  protoOf($serializer_10).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_159().w9p_1[0], this.v9p_1];
  };
  protoOf($serializer_10).j5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.v9p_1];
  };
  function RpcFacadeMixin_init_$Init$(seen0, facade, parameter, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, Companion_getInstance_159().x9p_1);
    }
    $this.a9q_1 = facade;
    $this.b9q_1 = parameter;
    return $this;
  }
  function RpcFacadeMixin_init_$Create$(seen0, facade, parameter, serializationConstructorMarker) {
    return RpcFacadeMixin_init_$Init$(seen0, facade, parameter, serializationConstructorMarker, objectCreate(protoOf(RpcFacadeMixin)));
  }
  function RpcFacadeMixin(facade, parameter) {
    Companion_getInstance_159();
    this.a9q_1 = facade;
    this.b9q_1 = parameter;
  }
  protoOf(RpcFacadeMixin).ug = function () {
    return this.a9q_1;
  };
  protoOf(RpcFacadeMixin).vg = function () {
    return this.b9q_1;
  };
  protoOf(RpcFacadeMixin).toString = function () {
    return 'RpcFacadeMixin(facade=' + toString_1(this.a9q_1) + ', parameter=' + toString_0(this.b9q_1) + ')';
  };
  protoOf(RpcFacadeMixin).hashCode = function () {
    var result = hashCode(this.a9q_1);
    result = imul(result, 31) + (this.b9q_1 == null ? 0 : hashCode(this.b9q_1)) | 0;
    return result;
  };
  protoOf(RpcFacadeMixin).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RpcFacadeMixin))
      return false;
    var tmp0_other_with_cast = other instanceof RpcFacadeMixin ? other : THROW_CCE();
    if (!equals(this.a9q_1, tmp0_other_with_cast.a9q_1))
      return false;
    if (!equals(this.b9q_1, tmp0_other_with_cast.b9q_1))
      return false;
    return true;
  };
  function get_withFacade(_this__u8e3s4) {
    return Companion_getInstance_159().y9p(_this__u8e3s4);
  }
  function mixedTo(_this__u8e3s4, parameter) {
    return new RpcFacadeMixin(_this__u8e3s4, parameter);
  }
  function mixinFacade$1($this_mixinFacade) {
    this.c9q_1 = $this_mixinFacade;
  }
  protoOf(mixinFacade$1).n9k = function (endpoint, parameter, $completion) {
    return this.c9q_1.n9k(endpoint, mixedTo(endpoint.l9j(), parameter), $completion);
  };
  function get_LOG_1() {
    _init_properties_RpcIncomingCalls_kt__keqp3e();
    return LOG_1;
  }
  var LOG_1;
  function launchCall($this, callId, methodHandle, parameter) {
    launch($this.u9o_1, VOID, VOID, RpcIncomingCalls$launchCall$slambda_0(methodHandle, parameter, callId, $this, null));
  }
  function RpcIncomingCalls$launchCall$slambda($methodHandle, $parameter, $callId, this$0, resultContinuation) {
    this.l9q_1 = $methodHandle;
    this.m9q_1 = $parameter;
    this.n9q_1 = $callId;
    this.o9q_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RpcIncomingCalls$launchCall$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(RpcIncomingCalls$launchCall$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RpcIncomingCalls$launchCall$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 9;
            var tmp_0 = this;
            tmp_0.q9q_1 = this.p9q_1;
            this.r9q_1 = this.q9q_1;
            this.z9_1 = 2;
            var tmp_1 = this;
            tmp_1.t9q_1 = Companion_instance_17;
            var tmp_2 = this;
            tmp_2.u9q_1 = this.r9q_1;
            this.v9q_1 = this.u9q_1;
            this.y9_1 = 1;
            suspendResult = this.l9q_1.p9r(this.m9q_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.w9q_1 = suspendResult;
            var tmp_3 = this;
            this.t9q_1;
            var value = this.w9q_1;
            tmp_3.s9q_1 = _Result___init__impl__xyqfz8(value);
            this.z9_1 = 9;
            this.y9_1 = 3;
            continue $sm;
          case 2:
            this.z9_1 = 9;
            var tmp_4 = this.ba_1;
            if (tmp_4 instanceof Error) {
              this.x9q_1 = this.ba_1;
              var tmp_5 = this;
              var exception = this.x9q_1;
              tmp_5.s9q_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.y9_1 = 3;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 3:
            this.z9_1 = 9;
            this.y9q_1 = this.s9q_1;
            this.z9q_1 = this.y9q_1;
            if (_Result___get_isSuccess__impl__sndoy8(this.z9q_1)) {
              var tmp_6 = this;
              var tmp_7 = _Result___get_value__impl__bjfvqg(this.z9q_1);
              tmp_6.a9r_1 = (tmp_7 == null ? true : !(tmp_7 == null)) ? tmp_7 : THROW_CCE();
              this.b9r_1 = this.a9r_1;
              get_LOG_1().go('Execution of a call ' + this.n9q_1.toString() + ' completed successfully');
              this.y9_1 = 4;
              suspendResult = this.o9q_1.v9o_1.z1b(new Answer(this.n9q_1, this.b9r_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 5;
              continue $sm;
            }

          case 4:
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.c9r_1 = this.z9q_1;
            this.d9r_1 = this.c9r_1;
            this.e9r_1 = Result__exceptionOrNull_impl_p6xea9(this.d9r_1);
            if (this.e9r_1 == null) {
              this.f9r_1 = null;
              this.y9_1 = 8;
              continue $sm;
            } else {
              var tmp_8 = this;
              tmp_8.g9r_1 = this.e9r_1;
              this.h9r_1 = this.g9r_1;
              var tmp_9 = this;
              tmp_9.i9r_1 = this.h9r_1;
              this.j9r_1 = this.i9r_1;
              var tmp_10 = this;
              tmp_10.k9r_1 = this.j9r_1;
              this.l9r_1 = this.k9r_1;
              var tmp_11 = this.l9r_1;
              if (tmp_11 instanceof CancellationException) {
                get_LOG_1().go('Execution of a call ' + this.n9q_1.toString() + ' cancelled since RPC facade has been disposed');
                this.y9_1 = 7;
                continue $sm;
              } else {
                get_LOG_1().eo('Execution of a call ' + this.n9q_1.toString() + ' completed with an error: ' + this.l9r_1.toString(), this.l9r_1);
                this.y9_1 = 6;
                suspendResult = this.o9q_1.v9o_1.z1b(Companion_getInstance_164().r9r(this.n9q_1, this.l9q_1.m9r_1, this.l9q_1.n9r_1, this.l9r_1), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 6:
            this.y9_1 = 7;
            continue $sm;
          case 7:
            var tmp_12 = this;
            tmp_12.f9r_1 = Unit_instance;
            this.y9_1 = 8;
            continue $sm;
          case 8:
            return Unit_instance;
          case 9:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 9) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(RpcIncomingCalls$launchCall$slambda).i1l = function ($this$launch, completion) {
    var i = new RpcIncomingCalls$launchCall$slambda(this.l9q_1, this.m9q_1, this.n9q_1, this.o9q_1, completion);
    i.p9q_1 = $this$launch;
    return i;
  };
  function RpcIncomingCalls$launchCall$slambda_0($methodHandle, $parameter, $callId, this$0, resultContinuation) {
    var i = new RpcIncomingCalls$launchCall$slambda($methodHandle, $parameter, $callId, this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $processCallCOROUTINE$2(_this__u8e3s4, callId, instanceId, methodId, parameter, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a9s_1 = _this__u8e3s4;
    this.b9s_1 = callId;
    this.c9s_1 = instanceId;
    this.d9s_1 = methodId;
    this.e9s_1 = parameter;
  }
  protoOf($processCallCOROUTINE$2).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            get_LOG_1().go('Processing a call ' + this.b9s_1.toString() + ', instance: ' + this.c9s_1.toString() + ', method: ' + this.d9s_1.toString());
            this.z9_1 = 1;
            var tmp_0 = this;
            tmp_0.f9s_1 = this.a9s_1.w9o_1.h9s(this.c9s_1, this.d9s_1);
            this.z9_1 = 4;
            this.y9_1 = 3;
            continue $sm;
          case 1:
            this.z9_1 = 4;
            var tmp_1 = this.ba_1;
            if (tmp_1 instanceof Exception) {
              this.g9s_1 = this.ba_1;
              get_LOG_1().co('Error during accessing a method for call ' + this.b9s_1.toString() + ' (instance: ' + this.c9s_1.toString() + ', method: ' + this.d9s_1.toString() + ')', this.g9s_1);
              this.y9_1 = 2;
              suspendResult = this.a9s_1.v9o_1.z1b(new ErrorAnswer(this.b9s_1, ensureNotNull(this.g9s_1.message)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 2:
            var tmp_2 = this;
            return Unit_instance;
          case 3:
            this.z9_1 = 4;
            var methodHandle = this.f9s_1;
            launchCall(this.a9s_1, this.b9s_1, methodHandle, this.e9s_1);
            return Unit_instance;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function RpcIncomingCalls(scope, outgoing, publisher) {
    this.u9o_1 = scope;
    this.v9o_1 = outgoing;
    this.w9o_1 = publisher;
  }
  protoOf(RpcIncomingCalls).x9o = function (callId, instanceId, methodId, parameter, $completion) {
    var tmp = new $processCallCOROUTINE$2(this, callId, instanceId, methodId, parameter, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function rpcIncomingCalls(_this__u8e3s4, outgoing, publisher) {
    _init_properties_RpcIncomingCalls_kt__keqp3e();
    return new RpcIncomingCalls(_this__u8e3s4, outgoing, publisher);
  }
  var properties_initialized_RpcIncomingCalls_kt_x8oz58;
  function _init_properties_RpcIncomingCalls_kt__keqp3e() {
    if (!properties_initialized_RpcIncomingCalls_kt_x8oz58) {
      properties_initialized_RpcIncomingCalls_kt_x8oz58 = true;
      LOG_1 = getLogger(getKClass(RpcIncomingCalls));
    }
  }
  function get_LOG_2() {
    _init_properties_RpcInstancesPublisher_kt__kqbo5r();
    return LOG_2;
  }
  var LOG_2;
  function RpcInstancesPublisher$publishInstance$lambda(this$0, $entry) {
    return function () {
      var _unary__edvuaz = this$0.q9m_1;
      this$0.q9m_1 = _unary__edvuaz.n3();
      // Inline function 'kotlin.also' call
      var this_0 = new PublishedInstanceId(_unary__edvuaz);
      // Inline function 'jetbrains.ocelot.langDef.rpc.RpcInstancesPublisher.publishInstance.<anonymous>.<anonymous>' call
      var tmp0 = this$0.r9m_1;
      // Inline function 'kotlin.collections.set' call
      var value = $entry;
      tmp0.r2(this_0, value);
      return this_0;
    };
  }
  function RpcInstancesPublisher$accessInstance$lambda(this$0, $id) {
    return function () {
      return this$0.r9m_1.y2($id);
    };
  }
  function RpcInstancesPublisher$disposeInstance$lambda(this$0, $instanceId) {
    return function () {
      return this$0.r9m_1.s2($instanceId);
    };
  }
  function RpcInstancesPublisher$accessMethod$lambda(this$0, $instanceId) {
    return function () {
      return this$0.r9m_1.y2($instanceId);
    };
  }
  function RpcInstancesPublisher$dispose$lambda(this$0) {
    return function () {
      var _iterator__ex2g4s = this$0.r9m_1.v2().k();
      while (_iterator__ex2g4s.l()) {
        var entry = _iterator__ex2g4s.m();
        entry.w9m_1.vr();
      }
      return Unit_instance;
    };
  }
  function RpcInstancesPublisher(formats) {
    this.o9m_1 = formats;
    this.p9m_1 = newLock();
    this.q9m_1 = new Long(0, 0);
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.r9m_1 = HashMap_init_$Create$();
  }
  protoOf(RpcInstancesPublisher).t9m = function (entry) {
    var id = this.p9m_1.kr(RpcInstancesPublisher$publishInstance$lambda(this, entry));
    get_LOG_2().go('Publishing instance with id: ' + id.toString());
    return id;
  };
  protoOf(RpcInstancesPublisher).x9m = function (id) {
    var entry = this.p9m_1.kr(RpcInstancesPublisher$accessInstance$lambda(this, id));
    if (entry == null) {
      get_LOG_2().do('Accessing a non-published instance ' + id.toString());
      throw new MissingInstanceException(id);
    }
    var tmp = entry.u9m_1;
    return !(tmp == null) ? tmp : THROW_CCE();
  };
  protoOf(RpcInstancesPublisher).s9m = function (instanceId) {
    get_LOG_2().go('Disposing publication for instance ' + instanceId.toString());
    var removed = this.p9m_1.kr(RpcInstancesPublisher$disposeInstance$lambda(this, instanceId));
    if (removed == null) {
      get_LOG_2().do('Disposing occurred for a non-published instance ' + instanceId.toString());
      throw new MissingInstanceException(instanceId);
    }
    removed.w9m_1.vr();
  };
  protoOf(RpcInstancesPublisher).h9s = function (instanceId, methodId) {
    get_LOG_2().go('Accessing method for published instance ' + instanceId.toString());
    var entry = this.p9m_1.kr(RpcInstancesPublisher$accessMethod$lambda(this, instanceId));
    if (entry == null) {
      get_LOG_2().do('Accessing method for a non-published instance ' + instanceId.toString());
      throw new MissingInstanceException(instanceId);
    }
    var method = entry.i9s(instanceId, methodId, this.o9m_1);
    if (method == null) {
      get_LOG_2().do('Accessing non-existing method ' + methodId.toString() + ' for an instance ' + instanceId.toString());
      throw new MissingMethodException(instanceId, methodId);
    }
    return method;
  };
  protoOf(RpcInstancesPublisher).vr = function () {
    this.p9m_1.kr(RpcInstancesPublisher$dispose$lambda(this));
  };
  function asHandle(_this__u8e3s4, $this, formats) {
    return PublicationEntry$asHandle$slambda_0(formats, _this__u8e3s4, $this, null);
  }
  function PublicationEntry$asHandle$slambda($formats, $this_asHandle, this$0, resultContinuation) {
    this.r9s_1 = $formats;
    this.s9s_1 = $this_asHandle;
    this.t9s_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PublicationEntry$asHandle$slambda).p9r = function (parameterBytes, $completion) {
    var tmp = this.y9s(parameterBytes, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(PublicationEntry$asHandle$slambda).oa = function (p1, $completion) {
    return this.p9r((!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PublicationEntry$asHandle$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.v9s_1 = this.r9s_1.i9a().e5e(this.s9s_1.k9k(), this.u9s_1);
            this.w9s_1 = this.r9s_1.j9a();
            this.x9s_1 = this.s9s_1.l9k();
            this.y9_1 = 1;
            suspendResult = this.s9s_1.m9k(this.t9s_1.u9m_1, this.v9s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return this.w9s_1.d5e(this.x9s_1, ARGUMENT);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(PublicationEntry$asHandle$slambda).y9s = function (parameterBytes, completion) {
    var i = new PublicationEntry$asHandle$slambda(this.r9s_1, this.s9s_1, this.t9s_1, completion);
    i.u9s_1 = parameterBytes;
    return i;
  };
  function PublicationEntry$asHandle$slambda_0($formats, $this_asHandle, this$0, resultContinuation) {
    var i = new PublicationEntry$asHandle$slambda($formats, $this_asHandle, this$0, resultContinuation);
    var l = function (parameterBytes, $completion) {
      return i.p9r(parameterBytes, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function PublicationEntry(instance, descriptor, instanceDisposal) {
    this.u9m_1 = instance;
    this.v9m_1 = descriptor;
    this.w9m_1 = instanceDisposal;
  }
  protoOf(PublicationEntry).i9s = function (instanceId, methodId, formats) {
    var tmp0_elvis_lhs = this.v9m_1.i9j_1.y2(methodId);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var descriptor = tmp;
    return new PublishedMethodHandle(instanceId, methodId, asHandle(descriptor, this, formats));
  };
  function PublishedMethodHandle(instanceId, methodId, handle) {
    this.m9r_1 = instanceId;
    this.n9r_1 = methodId;
    this.o9r_1 = handle;
  }
  protoOf(PublishedMethodHandle).p9r = function (array, $completion) {
    return this.o9r_1(array, $completion);
  };
  function MissingInstanceException(id) {
    RuntimeException_init_$Init$_0('Published instance not found with id: ' + id.toString(), this);
    captureStack(this, MissingInstanceException);
    this.z9s_1 = id;
  }
  function MissingMethodException(id, methodId) {
    RuntimeException_init_$Init$_0('Published instance ' + id.toString() + ' has no method with id: ' + methodId.toString(), this);
    captureStack(this, MissingMethodException);
    this.a9t_1 = id;
    this.b9t_1 = methodId;
  }
  var properties_initialized_RpcInstancesPublisher_kt_x0rcwd;
  function _init_properties_RpcInstancesPublisher_kt__kqbo5r() {
    if (!properties_initialized_RpcInstancesPublisher_kt_x0rcwd) {
      properties_initialized_RpcInstancesPublisher_kt_x0rcwd = true;
      LOG_2 = getLogger(getKClass(RpcInstancesPublisher));
    }
  }
  function Companion_160() {
    Companion_instance_160 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c9t_1 = [null, Companion_getInstance_157().h67(), null, null];
  }
  var Companion_instance_160;
  function Companion_getInstance_160() {
    if (Companion_instance_160 == null)
      new Companion_160();
    return Companion_instance_160;
  }
  function $serializer_11() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RpcMessage.Call', this, 4);
    tmp0_serialDesc.t5n('callId', false);
    tmp0_serialDesc.t5n('instanceId', false);
    tmp0_serialDesc.t5n('methodId', false);
    tmp0_serialDesc.t5n('parameters', true);
    this.d9t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_11).e9t = function (encoder, value) {
    var tmp0_desc = this.d9t_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    var tmp2_cached = Companion_getInstance_160().c9t_1;
    tmp1_output.t5h(tmp0_desc, 0, value.q9o_1);
    tmp1_output.z5h(tmp0_desc, 1, tmp2_cached[1], value.r9o_1);
    tmp1_output.z5h(tmp0_desc, 2, $serializer_getInstance_8(), value.s9o_1);
    if (tmp1_output.e5i(tmp0_desc, 3) ? true : !equals(value.t9o_1, new Int8Array(0))) {
      tmp1_output.z5h(tmp0_desc, 3, ByteArraySerializer_getInstance(), value.t9o_1);
    }
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_11).j5d = function (encoder, value) {
    return this.e9t(encoder, value instanceof Call ? value : THROW_CCE());
  };
  protoOf($serializer_11).k5d = function (decoder) {
    var tmp0_desc = this.d9t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.j5g(tmp0_desc);
    var tmp9_cached = Companion_getInstance_160().c9t_1;
    if (tmp8_input.y5g()) {
      tmp4_local0 = tmp8_input.p5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.v5g(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.v5g(tmp0_desc, 2, $serializer_getInstance_8(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.v5g(tmp0_desc, 3, ByteArraySerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.p5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.v5g(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.v5g(tmp0_desc, 2, $serializer_getInstance_8(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.v5g(tmp0_desc, 3, ByteArraySerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.k5g(tmp0_desc);
    return Call_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_11).w5c = function () {
    return this.d9t_1;
  };
  protoOf($serializer_11).i5o = function () {
    var tmp0_cached = Companion_getInstance_160().c9t_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), tmp0_cached[1], $serializer_getInstance_8(), ByteArraySerializer_getInstance()];
  };
  var $serializer_instance_10;
  function $serializer_getInstance_10() {
    if ($serializer_instance_10 == null)
      new $serializer_11();
    return $serializer_instance_10;
  }
  function Call_init_$Init$(seen0, callId, instanceId, methodId, parameters, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_10().d9t_1);
    }
    RpcMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.q9o_1 = callId;
    $this.r9o_1 = instanceId;
    $this.s9o_1 = methodId;
    if (0 === (seen0 & 8))
      $this.t9o_1 = new Int8Array(0);
    else
      $this.t9o_1 = parameters;
    return $this;
  }
  function Call_init_$Create$(seen0, callId, instanceId, methodId, parameters, serializationConstructorMarker) {
    return Call_init_$Init$(seen0, callId, instanceId, methodId, parameters, serializationConstructorMarker, objectCreate(protoOf(Call)));
  }
  function Companion_161() {
    Companion_instance_161 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f9t_1 = [Companion_getInstance_157().h67()];
  }
  var Companion_instance_161;
  function Companion_getInstance_161() {
    if (Companion_instance_161 == null)
      new Companion_161();
    return Companion_instance_161;
  }
  function $serializer_12() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RpcMessage.Dispose', this, 1);
    tmp0_serialDesc.t5n('instanceId', false);
    this.g9t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_12).h9t = function (encoder, value) {
    var tmp0_desc = this.g9t_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    var tmp2_cached = Companion_getInstance_161().f9t_1;
    tmp1_output.z5h(tmp0_desc, 0, tmp2_cached[0], value.p9o_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_12).j5d = function (encoder, value) {
    return this.h9t(encoder, value instanceof Dispose ? value : THROW_CCE());
  };
  protoOf($serializer_12).k5d = function (decoder) {
    var tmp0_desc = this.g9t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.j5g(tmp0_desc);
    var tmp6_cached = Companion_getInstance_161().f9t_1;
    if (tmp5_input.y5g()) {
      tmp4_local0 = tmp5_input.v5g(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.v5g(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.k5g(tmp0_desc);
    return Dispose_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_12).w5c = function () {
    return this.g9t_1;
  };
  protoOf($serializer_12).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_161().f9t_1[0]];
  };
  var $serializer_instance_11;
  function $serializer_getInstance_11() {
    if ($serializer_instance_11 == null)
      new $serializer_12();
    return $serializer_instance_11;
  }
  function Dispose_init_$Init$(seen0, instanceId, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_11().g9t_1);
    }
    RpcMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.p9o_1 = instanceId;
    return $this;
  }
  function Dispose_init_$Create$(seen0, instanceId, serializationConstructorMarker) {
    return Dispose_init_$Init$(seen0, instanceId, serializationConstructorMarker, objectCreate(protoOf(Dispose)));
  }
  function Companion_162() {
  }
  var Companion_instance_162;
  function Companion_getInstance_162() {
    return Companion_instance_162;
  }
  function $serializer_13() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RpcMessage.Answer', this, 2);
    tmp0_serialDesc.t5n('callId', false);
    tmp0_serialDesc.t5n('result', false);
    this.i9t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_13).j9t = function (encoder, value) {
    var tmp0_desc = this.i9t_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.t5h(tmp0_desc, 0, value.m9o_1);
    tmp1_output.z5h(tmp0_desc, 1, ByteArraySerializer_getInstance(), value.n9o_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_13).j5d = function (encoder, value) {
    return this.j9t(encoder, value instanceof Answer ? value : THROW_CCE());
  };
  protoOf($serializer_13).k5d = function (decoder) {
    var tmp0_desc = this.i9t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.p5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, ByteArraySerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.p5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, ByteArraySerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return Answer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_13).w5c = function () {
    return this.i9t_1;
  };
  protoOf($serializer_13).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), ByteArraySerializer_getInstance()];
  };
  var $serializer_instance_12;
  function $serializer_getInstance_12() {
    if ($serializer_instance_12 == null)
      new $serializer_13();
    return $serializer_instance_12;
  }
  function Answer_init_$Init$(seen0, callId, result, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_12().i9t_1);
    }
    RpcMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.m9o_1 = callId;
    $this.n9o_1 = result;
    return $this;
  }
  function Answer_init_$Create$(seen0, callId, result, serializationConstructorMarker) {
    return Answer_init_$Init$(seen0, callId, result, serializationConstructorMarker, objectCreate(protoOf(Answer)));
  }
  function Companion_163() {
  }
  var Companion_instance_163;
  function Companion_getInstance_163() {
    return Companion_instance_163;
  }
  function $serializer_14() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.RpcMessage.ErrorAnswer', this, 2);
    tmp0_serialDesc.t5n('callId', false);
    tmp0_serialDesc.t5n('errorMessage', false);
    this.k9t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_14).l9t = function (encoder, value) {
    var tmp0_desc = this.k9t_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.t5h(tmp0_desc, 0, value.i9o_1);
    tmp1_output.x5h(tmp0_desc, 1, value.j9o_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_14).j5d = function (encoder, value) {
    return this.l9t(encoder, value instanceof ErrorAnswer ? value : THROW_CCE());
  };
  protoOf($serializer_14).k5d = function (decoder) {
    var tmp0_desc = this.k9t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.p5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.t5g(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.p5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.t5g(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return ErrorAnswer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_14).w5c = function () {
    return this.k9t_1;
  };
  protoOf($serializer_14).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_13;
  function $serializer_getInstance_13() {
    if ($serializer_instance_13 == null)
      new $serializer_14();
    return $serializer_instance_13;
  }
  function ErrorAnswer_init_$Init$(seen0, callId, errorMessage, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_13().k9t_1);
    }
    RpcMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.i9o_1 = callId;
    $this.j9o_1 = errorMessage;
    return $this;
  }
  function ErrorAnswer_init_$Create$(seen0, callId, errorMessage, serializationConstructorMarker) {
    return ErrorAnswer_init_$Init$(seen0, callId, errorMessage, serializationConstructorMarker, objectCreate(protoOf(ErrorAnswer)));
  }
  function _get_$cachedSerializer__te6jhj_3($this) {
    return $this.q9r_1.y();
  }
  function RpcMessage$Companion$_anonymous__qcfs19() {
    var tmp = getKClass(RpcMessage);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(Answer), getKClass(Call), getKClass(Dispose), getKClass(ErrorAnswer)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_12(), $serializer_getInstance_10(), $serializer_getInstance_11(), $serializer_getInstance_13()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    return SealedClassSerializer_init_$Create$('jetbrains.ocelot.langDef.rpc.RpcMessage', tmp, tmp_0, tmp_1, tmp$ret$8);
  }
  function Call(callId, instanceId, methodId, parameters) {
    Companion_getInstance_160();
    parameters = parameters === VOID ? new Int8Array(0) : parameters;
    RpcMessage.call(this);
    this.q9o_1 = callId;
    this.r9o_1 = instanceId;
    this.s9o_1 = methodId;
    this.t9o_1 = parameters;
  }
  protoOf(Call).toString = function () {
    return 'Call(callId=' + this.q9o_1.toString() + ', instanceId=' + this.r9o_1.toString() + ', methodId=' + this.s9o_1.toString() + ', parameters=' + toString_1(this.t9o_1) + ')';
  };
  protoOf(Call).hashCode = function () {
    var result = this.q9o_1.hashCode();
    result = imul(result, 31) + hashCode(this.r9o_1) | 0;
    result = imul(result, 31) + this.s9o_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.t9o_1) | 0;
    return result;
  };
  protoOf(Call).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Call))
      return false;
    var tmp0_other_with_cast = other instanceof Call ? other : THROW_CCE();
    if (!this.q9o_1.equals(tmp0_other_with_cast.q9o_1))
      return false;
    if (!equals(this.r9o_1, tmp0_other_with_cast.r9o_1))
      return false;
    if (!this.s9o_1.equals(tmp0_other_with_cast.s9o_1))
      return false;
    if (!equals(this.t9o_1, tmp0_other_with_cast.t9o_1))
      return false;
    return true;
  };
  function Dispose(instanceId) {
    Companion_getInstance_161();
    RpcMessage.call(this);
    this.p9o_1 = instanceId;
  }
  protoOf(Dispose).toString = function () {
    return 'Dispose(instanceId=' + this.p9o_1.toString() + ')';
  };
  protoOf(Dispose).hashCode = function () {
    return hashCode(this.p9o_1);
  };
  protoOf(Dispose).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Dispose))
      return false;
    var tmp0_other_with_cast = other instanceof Dispose ? other : THROW_CCE();
    if (!equals(this.p9o_1, tmp0_other_with_cast.p9o_1))
      return false;
    return true;
  };
  function Answer(callId, result) {
    RpcMessage.call(this);
    this.m9o_1 = callId;
    this.n9o_1 = result;
  }
  protoOf(Answer).toString = function () {
    return 'Answer(callId=' + this.m9o_1.toString() + ', result=' + toString_1(this.n9o_1) + ')';
  };
  protoOf(Answer).hashCode = function () {
    var result = this.m9o_1.hashCode();
    result = imul(result, 31) + hashCode(this.n9o_1) | 0;
    return result;
  };
  protoOf(Answer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Answer))
      return false;
    var tmp0_other_with_cast = other instanceof Answer ? other : THROW_CCE();
    if (!this.m9o_1.equals(tmp0_other_with_cast.m9o_1))
      return false;
    if (!equals(this.n9o_1, tmp0_other_with_cast.n9o_1))
      return false;
    return true;
  };
  function ErrorAnswer(callId, errorMessage) {
    RpcMessage.call(this);
    this.i9o_1 = callId;
    this.j9o_1 = errorMessage;
  }
  protoOf(ErrorAnswer).toString = function () {
    return 'ErrorAnswer(callId=' + this.i9o_1.toString() + ', errorMessage=' + this.j9o_1 + ')';
  };
  protoOf(ErrorAnswer).hashCode = function () {
    var result = this.i9o_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.j9o_1) | 0;
    return result;
  };
  protoOf(ErrorAnswer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ErrorAnswer))
      return false;
    var tmp0_other_with_cast = other instanceof ErrorAnswer ? other : THROW_CCE();
    if (!this.i9o_1.equals(tmp0_other_with_cast.i9o_1))
      return false;
    if (!(this.j9o_1 === tmp0_other_with_cast.j9o_1))
      return false;
    return true;
  };
  function Companion_164() {
    Companion_instance_164 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q9r_1 = lazy(tmp_0, RpcMessage$Companion$_anonymous__qcfs19);
  }
  protoOf(Companion_164).r9r = function (callId, instanceId, methodId, throwable) {
    var tmp = 'Exception on calling the remote method (instance = ' + instanceId.toString() + ', method = ' + methodId.toString() + '): ';
    var tmp0_elvis_lhs = throwable.message;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = throwable.cause;
      tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.message;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tmp2_elvis_lhs = tmp_0;
    return new ErrorAnswer(callId, tmp + (tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs));
  };
  protoOf(Companion_164).h67 = function () {
    return _get_$cachedSerializer__te6jhj_3(this);
  };
  protoOf(Companion_164).t5o = function (typeParamsSerializers) {
    return this.h67();
  };
  var Companion_instance_164;
  function Companion_getInstance_164() {
    if (Companion_instance_164 == null)
      new Companion_164();
    return Companion_instance_164;
  }
  function RpcMessage_init_$Init$(seen0, serializationConstructorMarker, $this) {
    return $this;
  }
  function RpcMessage() {
    Companion_getInstance_164();
  }
  function get_LOG_3() {
    _init_properties_RpcOutgoingCalls_kt__8dk83o();
    return LOG_3;
  }
  var LOG_3;
  function $startCallCOROUTINE$3(_this__u8e3s4, answer, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u9t_1 = _this__u8e3s4;
    this.v9t_1 = answer;
  }
  protoOf($startCallCOROUTINE$3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.w9t_1 = CompletableDeferred();
            this.y9_1 = 1;
            suspendResult = this.u9t_1.k9o_1.z1b(new InitiateCall(this.v9t_1, this.w9t_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y9_1 = 2;
            suspendResult = this.w9t_1.gw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $completeCallCOROUTINE$4(_this__u8e3s4, callId, answer, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f9u_1 = _this__u8e3s4;
    this.g9u_1 = callId;
    this.h9u_1 = answer;
  }
  protoOf($completeCallCOROUTINE$4).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.i9u_1 = LoggableJob('completeCall(' + this.g9u_1.toString() + ')');
            this.y9_1 = 1;
            suspendResult = this.f9u_1.k9o_1.z1b(new CompleteCall(this.g9u_1, this.h9u_1, this.i9u_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y9_1 = 2;
            suspendResult = this.i9u_1.ku(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $failCallCOROUTINE$5(_this__u8e3s4, callId, reason, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r9u_1 = _this__u8e3s4;
    this.s9u_1 = callId;
    this.t9u_1 = reason;
  }
  protoOf($failCallCOROUTINE$5).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.u9u_1 = LoggableJob('failCall(' + this.s9u_1.toString() + ')');
            this.y9_1 = 1;
            suspendResult = this.r9u_1.k9o_1.z1b(new FailCall(this.s9u_1, this.t9u_1, this.u9u_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y9_1 = 2;
            suspendResult = this.u9u_1.ku(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function RpcOutgoingCalls(channel) {
    this.k9o_1 = channel;
  }
  protoOf(RpcOutgoingCalls).p9p = function (answer, $completion) {
    var tmp = new $startCallCOROUTINE$3(this, answer, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(RpcOutgoingCalls).o9o = function (callId, answer, $completion) {
    var tmp = new $completeCallCOROUTINE$4(this, callId, answer, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(RpcOutgoingCalls).l9o = function (callId, reason, $completion) {
    var tmp = new $failCallCOROUTINE$5(this, callId, reason, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function InitiateCall(answer, callId) {
    RpcOutgoingCallsMessage.call(this);
    this.v9u_1 = answer;
    this.w9u_1 = callId;
  }
  protoOf(InitiateCall).toString = function () {
    return 'InitiateCall(answer=' + toString_1(this.v9u_1) + ', callId=' + toString_1(this.w9u_1) + ')';
  };
  protoOf(InitiateCall).hashCode = function () {
    var result = hashCode(this.v9u_1);
    result = imul(result, 31) + hashCode(this.w9u_1) | 0;
    return result;
  };
  protoOf(InitiateCall).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InitiateCall))
      return false;
    var tmp0_other_with_cast = other instanceof InitiateCall ? other : THROW_CCE();
    if (!equals(this.v9u_1, tmp0_other_with_cast.v9u_1))
      return false;
    if (!equals(this.w9u_1, tmp0_other_with_cast.w9u_1))
      return false;
    return true;
  };
  function CompleteCall(callId, answer, result) {
    RpcOutgoingCallsMessage.call(this);
    this.x9u_1 = callId;
    this.y9u_1 = answer;
    this.z9u_1 = result;
  }
  function FailCall(callId, reason, result) {
    RpcOutgoingCallsMessage.call(this);
    this.a9v_1 = callId;
    this.b9v_1 = reason;
    this.c9v_1 = result;
  }
  function RpcOutgoingCallsMessage() {
  }
  function LoggableJob(jobName) {
    _init_properties_RpcOutgoingCalls_kt__8dk83o();
    // Inline function 'kotlin.apply' call
    var this_0 = Job_0();
    // Inline function 'jetbrains.ocelot.langDef.rpc.LoggableJob.<anonymous>' call
    this_0.hu(LoggableJob$lambda(jobName));
    return this_0;
  }
  function rpcOutgoingCalls(_this__u8e3s4) {
    _init_properties_RpcOutgoingCalls_kt__8dk83o();
    var channel = Channel();
    var tmp = launch(_this__u8e3s4, VOID, VOID, rpcOutgoingCalls$slambda_0(channel, null));
    tmp.hu(rpcOutgoingCalls$lambda(channel));
    return new RpcOutgoingCalls(channel);
  }
  function MissingOutgoingCallException(id) {
    RuntimeException_init_$Init$_0('Outgoing call with id ' + id.toString() + ' not found', this);
    captureStack(this, MissingOutgoingCallException);
    this.d9v_1 = id;
  }
  function LoggableJob$lambda($jobName) {
    return function (exception) {
      var tmp;
      if (!(exception == null)) {
        get_LOG_3().co("Job '" + $jobName + "' completed with an exception", exception);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function rpcOutgoingCalls$slambda($channel, resultContinuation) {
    this.m9v_1 = $channel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcOutgoingCalls$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(rpcOutgoingCalls$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcOutgoingCalls$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 10;
            this.o9v_1 = new Long(0, 0);
            var tmp_0 = this;
            tmp_0.p9v_1 = HashMap_init_$Create$();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 9;
            this.r9v_1 = this.m9v_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            suspendResult = this.r9v_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (!suspendResult) {
              this.y9_1 = 7;
              continue $sm;
            }

            var message = this.r9v_1.m();
            var tmp0_subject = message;
            var WHEN_RESULT;
            if (tmp0_subject instanceof InitiateCall) {
              var _unary__edvuaz = this.o9v_1;
              this.o9v_1 = _unary__edvuaz.n3();
              var callId = _unary__edvuaz;
              get_LOG_3().go('Initiated outgoing call with id: ' + callId.toString());
              var tmp0 = this.p9v_1;
              var value = message.v9u_1;
              tmp0.r2(callId, value);
              WHEN_RESULT = message.w9u_1.lz(callId);
              this.y9_1 = 6;
              continue $sm;
            } else {
              if (tmp0_subject instanceof CompleteCall) {
                var callId_0 = message.x9u_1;
                var callAnswer = this.p9v_1.s2(callId_0);
                if (callAnswer == null) {
                  get_LOG_3().do('Completing an absent outgoing call with id ' + callId_0.toString());
                  message.z9u_1.nz(new MissingOutgoingCallException(callId_0));
                  this.y9_1 = 2;
                  continue $sm;
                } else {
                  this.y9_1 = 5;
                  continue $sm;
                }
              } else {
                if (tmp0_subject instanceof FailCall) {
                  var callId_1 = message.a9v_1;
                  var callAnswer_0 = this.p9v_1.s2(callId_1);
                  if (callAnswer_0 == null) {
                    get_LOG_3().do('Failing an absent outgoing call with id ' + callId_1.toString());
                    message.c9v_1.nz(new MissingOutgoingCallException(callId_1));
                    this.y9_1 = 2;
                    continue $sm;
                  } else {
                    this.y9_1 = 4;
                    continue $sm;
                  }
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 4:
            get_LOG_3().go('Outgoing call with id ' + callId_1.toString() + ' failed');
            callAnswer_0.nz(new RemoteInvocationException(message.b9v_1));
            WHEN_RESULT = message.c9v_1.oz();
            this.y9_1 = 6;
            continue $sm;
          case 5:
            get_LOG_3().go('Outgoing call with id ' + callId_0.toString() + ' completed');
            callAnswer.lz(message.y9u_1);
            WHEN_RESULT = message.z9u_1.oz();
            this.y9_1 = 6;
            continue $sm;
          case 6:
            this.y9_1 = 2;
            continue $sm;
          case 7:
            this.q9v_1 = Unit_instance;
            this.z9_1 = 10;
            this.y9_1 = 8;
            continue $sm;
          case 8:
            this.z9_1 = 10;
            var _iterator__ex2g4s = this.p9v_1.v2().k();
            while (_iterator__ex2g4s.l()) {
              var call = _iterator__ex2g4s.m();
              call.ou(new RpcFacadeCancellationException());
            }

            return Unit_instance;
          case 9:
            this.z9_1 = 10;
            var t = this.ba_1;
            var _iterator__ex2g4s_0 = this.p9v_1.v2().k();
            while (_iterator__ex2g4s_0.l()) {
              var call_0 = _iterator__ex2g4s_0.m();
              call_0.ou(new RpcFacadeCancellationException());
            }

            throw t;
          case 10:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 10) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(rpcOutgoingCalls$slambda).i1l = function ($this$launch, completion) {
    var i = new rpcOutgoingCalls$slambda(this.m9v_1, completion);
    i.n9v_1 = $this$launch;
    return i;
  };
  function rpcOutgoingCalls$slambda_0($channel, resultContinuation) {
    var i = new rpcOutgoingCalls$slambda($channel, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function rpcOutgoingCalls$lambda($channel) {
    return function (it) {
      $channel.i1c();
      return Unit_instance;
    };
  }
  var properties_initialized_RpcOutgoingCalls_kt_8fayzq;
  function _init_properties_RpcOutgoingCalls_kt__8dk83o() {
    if (!properties_initialized_RpcOutgoingCalls_kt_8fayzq) {
      properties_initialized_RpcOutgoingCalls_kt_8fayzq = true;
      LOG_3 = getLogger(getKClass(RpcOutgoingCalls));
    }
  }
  function Runnable_0() {
  }
  function RunnableSerializer() {
    RunnableSerializer_instance = this;
    InstancePublicationSerializer.call(this, Descriptor_getInstance());
  }
  var RunnableSerializer_instance;
  function RunnableSerializer_getInstance() {
    if (RunnableSerializer_instance == null)
      new RunnableSerializer();
    return RunnableSerializer_instance;
  }
  function RemoteRunnable$Descriptor$run$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteRunnable$Descriptor$run$slambda).d9w = function (instance, _unused_var__etf5q3, $completion) {
    var tmp = this.e9w(instance, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(RemoteRunnable$Descriptor$run$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, Runnable_0) : false) ? p1 : THROW_CCE();
    return this.d9w(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(RemoteRunnable$Descriptor$run$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.b9w_1.s9v(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteRunnable$Descriptor$run$slambda).e9w = function (instance, _unused_var__etf5q3, completion) {
    var i = new RemoteRunnable$Descriptor$run$slambda(completion);
    i.b9w_1 = instance;
    i.c9w_1 = _unused_var__etf5q3;
    return i;
  };
  function RemoteRunnable$Descriptor$run$slambda_0(resultContinuation) {
    var i = new RemoteRunnable$Descriptor$run$slambda(resultContinuation);
    var l = function (instance, _unused_var__etf5q3, $completion) {
      return i.d9w(instance, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Descriptor_0() {
    Descriptor_instance = this;
    InstanceDescriptor.call(this);
    var tmp = this;
    var tmp_0 = serializer_16(Unit_instance);
    var tmp_1 = serializer_16(Unit_instance);
    tmp.g9w_1 = method(this, 'run', tmp_0, tmp_1, RemoteRunnable$Descriptor$run$slambda_0(null));
  }
  protoOf(Descriptor_0).h9w = function (endpoint) {
    return new RemoteRunnable(endpoint);
  };
  protoOf(Descriptor_0).j9j = function (endpoint) {
    return this.h9w(endpoint);
  };
  var Descriptor_instance;
  function Descriptor_getInstance() {
    if (Descriptor_instance == null)
      new Descriptor_0();
    return Descriptor_instance;
  }
  function RemoteRunnable(endpoint) {
    this.i9w_1 = endpoint;
  }
  protoOf(RemoteRunnable).s9v = function ($completion) {
    return Descriptor_getInstance().g9w_1.n9k(this.i9w_1, Unit_instance, $completion);
  };
  function Companion_165() {
    Companion_instance_165 = this;
    this.j9w_1 = getLogger(getKClass(RpcFacadeContainer));
  }
  var Companion_instance_165;
  function Companion_getInstance_165() {
    if (Companion_instance_165 == null)
      new Companion_165();
    return Companion_instance_165;
  }
  function RpcFacadeContainer() {
    Companion_getInstance_165();
    this.k9w_1 = null;
  }
  function flowBasedMethod(_this__u8e3s4, id, parameterSerializer, resultSerializer, elementSerializer, handle) {
    var collectorSerializer = new PublishedFlowCollectorSerializer(elementSerializer);
    var tmp = get_withFacade(PairSerializer(collectorSerializer, parameterSerializer));
    var tmp_0 = PairSerializer(resultSerializer, PublishedDisposableSerializer_getInstance());
    var emitHandle = method(_this__u8e3s4, id, tmp, tmp_0, flowBasedMethod$slambda_0(handle, null));
    return new flowBasedMethod$1(collectorSerializer, emitHandle);
  }
  function flowBasedMethod$slambda$slambda$o$collect$slambda($$this$unsafeFlow, resultContinuation) {
    this.t9w_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowBasedMethod$slambda$slambda$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowBasedMethod$slambda$slambda$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flowBasedMethod$slambda$slambda$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.v9w_1 = this.t9w_1;
            var tmp_1 = this;
            tmp_1.w9w_1 = this.u9w_1;
            this.x9w_1 = this.v9w_1;
            this.y9w_1 = this.w9w_1;
            this.y9_1 = 1;
            var it = this.y9w_1;
            suspendResult = this.x9w_1.d1f(new Element_2(it), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowBasedMethod$slambda$slambda$o$collect$slambda).a1u = function (value, completion) {
    var i = new flowBasedMethod$slambda$slambda$o$collect$slambda(this.t9w_1, completion);
    i.u9w_1 = value;
    return i;
  };
  function flowBasedMethod$slambda$slambda$o$collect$slambda_0($$this$unsafeFlow, resultContinuation) {
    var i = new flowBasedMethod$slambda$slambda$o$collect$slambda($$this$unsafeFlow, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$6(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h9x_1 = _this__u8e3s4;
    this.i9x_1 = collector;
  }
  protoOf($collectCOROUTINE$6).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.j9x_1 = this.i9x_1;
            this.k9x_1 = this.j9x_1;
            this.y9_1 = 1;
            var tmp_1 = flowBasedMethod$slambda$slambda$o$collect$slambda_0(this.k9x_1, null);
            suspendResult = this.h9x_1.l9x_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_7(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function flowBasedMethod$1$1$$inlined$map$1($this) {
    this.l9x_1 = $this;
  }
  protoOf(flowBasedMethod$1$1$$inlined$map$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$6(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowBasedMethod$1$1$$inlined$map$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_7(function_0) {
    this.m9x_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_7).d1f = function (value, $completion) {
    return this.m9x_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_7).b4 = function () {
    return this.m9x_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_7).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_7).hashCode = function () {
    return hashCode(this.b4());
  };
  function flowBasedMethod$slambda$slambda($collector, $flow, $stoppedByCaller, resultContinuation) {
    this.v9x_1 = $collector;
    this.w9x_1 = $flow;
    this.x9x_1 = $stoppedByCaller;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowBasedMethod$slambda$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowBasedMethod$slambda$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flowBasedMethod$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            this.z9_1 = 4;
            this.y9_1 = 1;
            var tmp_0 = this.v9x_1.b2p();
            var this_0 = this.w9x_1;
            suspendResult = emitAll_0(tmp_0, new flowBasedMethod$1$1$$inlined$map$1(this_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y9_1 = 2;
            suspendResult = this.v9x_1.b2p().d1f(new End(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.z9_1 = 7;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 7;
            return Unit_instance;
          case 4:
            this.z9_1 = 7;
            var tmp_1 = this.ba_1;
            if (tmp_1 instanceof RuntimeException) {
              this.z9x_1 = this.ba_1;
              if (!this.x9x_1._v) {
                this.y9_1 = 5;
                var tmp_2 = this.v9x_1.b2p();
                var tmp0_elvis_lhs = this.z9x_1.message;
                suspendResult = tmp_2.d1f(new Error_1(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.y9_1 = 6;
                continue $sm;
              }
            } else {
              throw this.ba_1;
            }

          case 5:
            this.y9_1 = 6;
            continue $sm;
          case 6:
            throw this.z9x_1;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowBasedMethod$slambda$slambda).i1l = function ($this$launch, completion) {
    var i = new flowBasedMethod$slambda$slambda(this.v9x_1, this.w9x_1, this.x9x_1, completion);
    i.y9x_1 = $this$launch;
    return i;
  };
  function flowBasedMethod$slambda$slambda_0($collector, $flow, $stoppedByCaller, resultContinuation) {
    var i = new flowBasedMethod$slambda$slambda($collector, $flow, $stoppedByCaller, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function flowBasedMethod$1$$inlined$toDisposable$1($stoppedByCaller, $job) {
    this.a9y_1 = $stoppedByCaller;
    this.b9y_1 = $job;
  }
  protoOf(flowBasedMethod$1$$inlined$toDisposable$1).vr = function () {
    this.a9y_1._v = true;
    this.b9y_1.pu();
    return Unit_instance;
  };
  function flowBasedMethod$slambda($handle, resultContinuation) {
    this.k9y_1 = $handle;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowBasedMethod$slambda).y9y = function (instance, _destruct__k2r9zo, $completion) {
    var tmp = this.z9y(instance, _destruct__k2r9zo, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowBasedMethod$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE();
    return this.y9y(tmp, p2 instanceof RpcFacadeMixin ? p2 : THROW_CCE(), $completion);
  };
  protoOf(flowBasedMethod$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.n9y_1 = this.m9y_1.ug();
            this.o9y_1 = this.m9y_1.vg();
            this.p9y_1 = this.o9y_1;
            this.q9y_1 = this.p9y_1.ug();
            this.r9y_1 = this.p9y_1.vg();
            this.y9_1 = 1;
            suspendResult = this.k9y_1(this.l9y_1, this.r9y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.s9y_1 = suspendResult;
            this.t9y_1 = this.s9y_1.ug();
            this.u9y_1 = this.s9y_1.vg();
            this.v9y_1 = {_v: false};
            if (!get_isActive(this.l9y_1)) {
              var message = 'Instance ' + toString_1(this.l9y_1) + ' in not an active coroutine scope';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }

            var tmp_0 = this;
            tmp_0.w9y_1 = launch(this.l9y_1, VOID, VOID, flowBasedMethod$slambda$slambda_0(this.q9y_1, this.u9y_1, this.v9y_1, null));
            var tmp_1 = this;
            tmp_1.x9y_1 = new flowBasedMethod$1$$inlined$toDisposable$1(this.v9y_1, this.w9y_1);
            this.y9_1 = 2;
            suspendResult = this.n9y_1.l9l(this.x9y_1, Companion_getInstance_167(), this.x9y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var publication = suspendResult;
            return to(this.t9y_1, publication);
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowBasedMethod$slambda).z9y = function (instance, _destruct__k2r9zo, completion) {
    var i = new flowBasedMethod$slambda(this.k9y_1, completion);
    i.l9y_1 = instance;
    i.m9y_1 = _destruct__k2r9zo;
    return i;
  };
  function flowBasedMethod$slambda_0($handle, resultContinuation) {
    var i = new flowBasedMethod$slambda($handle, resultContinuation);
    var l = function (instance, _destruct__k2r9zo, $completion) {
      return i.y9y(instance, _destruct__k2r9zo, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function flowBasedMethod$o$call$slambda($lastMessage, resultContinuation) {
    this.i9z_1 = $lastMessage;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowBasedMethod$o$call$slambda).n9z = function ($this$transformWhile, it, $completion) {
    var tmp = this.o9z($this$transformWhile, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowBasedMethod$o$call$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE();
    return this.n9z(tmp, p2 instanceof FlowMessage ? p2 : THROW_CCE(), $completion);
  };
  protoOf(flowBasedMethod$o$call$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.i9z_1._v = this.k9z_1;
            this.l9z_1 = this.k9z_1;
            var tmp_0 = this.l9z_1;
            if (tmp_0 instanceof Element_2) {
              this.y9_1 = 1;
              suspendResult = this.j9z_1.d1f(this.k9z_1.q9z_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this.l9z_1;
              if (tmp_1 instanceof Error_1) {
                var tmp_2 = this;
                throw RuntimeException_init_$Create$_0(this.k9z_1.p9z_1);
              } else {
                var tmp_3 = this.l9z_1;
                if (tmp_3 instanceof End) {
                  this.m9z_1 = false;
                  this.y9_1 = 2;
                  continue $sm;
                } else {
                  var tmp_4 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            this.m9z_1 = true;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            return this.m9z_1;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowBasedMethod$o$call$slambda).o9z = function ($this$transformWhile, it, completion) {
    var i = new flowBasedMethod$o$call$slambda(this.i9z_1, completion);
    i.j9z_1 = $this$transformWhile;
    i.k9z_1 = it;
    return i;
  };
  function flowBasedMethod$o$call$slambda_0($lastMessage, resultContinuation) {
    var i = new flowBasedMethod$o$call$slambda($lastMessage, resultContinuation);
    var l = function ($this$transformWhile, it, $completion) {
      return i.n9z($this$transformWhile, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function flowBasedMethod$o$call$slambda_1($lastMessage, $flowCollecting, $publication, resultContinuation) {
    this.z9z_1 = $lastMessage;
    this.aa0_1 = $flowCollecting;
    this.ba0_1 = $publication;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowBasedMethod$o$call$slambda_1).ea0 = function ($this$onCompletion, it, $completion) {
    var tmp = this.fa0($this$onCompletion, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowBasedMethod$o$call$slambda_1).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE();
    return this.ea0(tmp, (p2 == null ? true : p2 instanceof Error) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(flowBasedMethod$o$call$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var it = this.z9z_1._v;
          var stoppedByCallee = !(it == null) && it.ga0();
          if (!stoppedByCallee) {
            this.aa0_1.b2p().vr();
          }
          this.ba0_1.vr();
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(flowBasedMethod$o$call$slambda_1).fa0 = function ($this$onCompletion, it, completion) {
    var i = new flowBasedMethod$o$call$slambda_1(this.z9z_1, this.aa0_1, this.ba0_1, completion);
    i.ca0_1 = $this$onCompletion;
    i.da0_1 = it;
    return i;
  };
  function flowBasedMethod$o$call$slambda_2($lastMessage, $flowCollecting, $publication, resultContinuation) {
    var i = new flowBasedMethod$o$call$slambda_1($lastMessage, $flowCollecting, $publication, resultContinuation);
    var l = function ($this$onCompletion, it, $completion) {
      return i.ea0($this$onCompletion, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $callCOROUTINE$7(_this__u8e3s4, endpoint, parameter, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pa0_1 = _this__u8e3s4;
    this.qa0_1 = endpoint;
    this.ra0_1 = parameter;
  }
  protoOf($callCOROUTINE$7).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.sa0_1 = Channel();
            this.ta0_1 = new SendingCollector(this.sa0_1);
            this.ua0_1 = this.qa0_1.l9j();
            this.y9_1 = 1;
            suspendResult = this.ua0_1.m9l(this.ta0_1, this.pa0_1.wa0_1.v9j_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.va0_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.pa0_1.xa0_1.n9k(this.qa0_1, mixedTo(this.ua0_1, to(this.va0_1, this.ra0_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var _destruct__k2r9zo = suspendResult;
            var result = _destruct__k2r9zo.ug();
            var flowCollecting = _destruct__k2r9zo.vg();
            var lastMessage = {_v: null};
            var tmp_0 = consumeAsFlow(this.sa0_1);
            var tmp_1 = transformWhile(tmp_0, flowBasedMethod$o$call$slambda_0(lastMessage, null));
            var flow = onCompletion(tmp_1, flowBasedMethod$o$call$slambda_2(lastMessage, flowCollecting, this.va0_1, null));
            return to(result, flow);
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function flowBasedMethod$1($collectorSerializer, $emitHandle) {
    this.wa0_1 = $collectorSerializer;
    this.xa0_1 = $emitHandle;
  }
  protoOf(flowBasedMethod$1).ya0 = function (endpoint, parameter, $completion) {
    var tmp = new $callCOROUTINE$7(this, endpoint, parameter, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowBasedMethod$1).n9k = function (endpoint, parameter, $completion) {
    return this.ya0(endpoint, (parameter == null ? true : !(parameter == null)) ? parameter : THROW_CCE(), $completion);
  };
  function flowMethod(_this__u8e3s4, id, parameterSerializer, elementSerializer, handle) {
    var tmp = id + '/stop';
    var tmp_0 = get_withFacade(serializer_16(Unit_instance));
    var tmp_1 = RunnableSerializer_getInstance();
    var stopHandleMethod = method(_this__u8e3s4, tmp, tmp_0, tmp_1, flowMethod$slambda_0(null));
    var collectorSerializer = new PublishedFlowCollectorSerializer(elementSerializer);
    var tmp_2 = TripleSerializer(collectorSerializer, parameterSerializer, RunnableSerializer_getInstance());
    var tmp_3 = serializer_16(Unit_instance);
    var emitHandle = method(_this__u8e3s4, id, tmp_2, tmp_3, flowMethod$slambda_2(handle, null));
    var tmp_4 = flowMethod$lambda(stopHandleMethod, collectorSerializer, emitHandle);
    return new sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0(tmp_4);
  }
  function StopHandle() {
    this.za0_1 = false;
  }
  protoOf(StopHandle).aa1 = function () {
    this.za0_1 = true;
  };
  protoOf(StopHandle).s9v = function ($completion) {
    this.aa1();
    return Unit_instance;
  };
  function sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0(function_0) {
    this.ba1_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0).h9j = function (endpoint, parameter) {
    return this.ba1_1(endpoint, parameter);
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0).b4 = function () {
    return this.ba1_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ImmediateMethodHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_ImmediateMethodHandle$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function flowMethod$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowMethod$slambda).oa1 = function (_unused_var__etf5q3, _destruct__k2r9zo, $completion) {
    var tmp = this.pa1(_unused_var__etf5q3, _destruct__k2r9zo, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowMethod$slambda).pa = function (p1, p2, $completion) {
    var tmp = !(p1 == null) ? p1 : THROW_CCE();
    return this.oa1(tmp, p2 instanceof RpcFacadeMixin ? p2 : THROW_CCE(), $completion);
  };
  protoOf(flowMethod$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.ma1_1 = this.la1_1.ug();
            this.na1_1 = new StopHandle();
            this.y9_1 = 1;
            suspendResult = this.ma1_1.m9l(this.na1_1, Descriptor_getInstance(), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowMethod$slambda).pa1 = function (_unused_var__etf5q3, _destruct__k2r9zo, completion) {
    var i = new flowMethod$slambda(completion);
    i.ka1_1 = _unused_var__etf5q3;
    i.la1_1 = _destruct__k2r9zo;
    return i;
  };
  function flowMethod$slambda_0(resultContinuation) {
    var i = new flowMethod$slambda(resultContinuation);
    var l = function (_unused_var__etf5q3, _destruct__k2r9zo, $completion) {
      return i.oa1(_unused_var__etf5q3, _destruct__k2r9zo, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function flowMethod$slambda$o$collect$slambda($$this$unsafeFlow, resultContinuation) {
    this.ya1_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowMethod$slambda$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowMethod$slambda$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flowMethod$slambda$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.aa2_1 = this.ya1_1;
            var tmp_1 = this;
            tmp_1.ba2_1 = this.za1_1;
            this.ca2_1 = this.aa2_1;
            this.da2_1 = this.ba2_1;
            this.y9_1 = 1;
            var it = this.da2_1;
            suspendResult = this.ca2_1.d1f(new Element_2(it), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowMethod$slambda$o$collect$slambda).a1u = function (value, completion) {
    var i = new flowMethod$slambda$o$collect$slambda(this.ya1_1, completion);
    i.za1_1 = value;
    return i;
  };
  function flowMethod$slambda$o$collect$slambda_0($$this$unsafeFlow, resultContinuation) {
    var i = new flowMethod$slambda$o$collect$slambda($$this$unsafeFlow, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$8(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ma2_1 = _this__u8e3s4;
    this.na2_1 = collector;
  }
  protoOf($collectCOROUTINE$8).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.oa2_1 = this.na2_1;
            this.pa2_1 = this.oa2_1;
            this.y9_1 = 1;
            var tmp_1 = flowMethod$slambda$o$collect$slambda_0(this.pa2_1, null);
            suspendResult = this.ma2_1.qa2_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_8(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_8(function_0) {
    this.ra2_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_8).d1f = function (value, $completion) {
    return this.ra2_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_8).b4 = function () {
    return this.ra2_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_8).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_8).hashCode = function () {
    return hashCode(this.b4());
  };
  function flowMethod$slambda$slambda($stopHandle, resultContinuation) {
    this.aa3_1 = $stopHandle;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowMethod$slambda$slambda).ca3 = function (it, $completion) {
    var tmp = this.da3(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowMethod$slambda$slambda).oa = function (p1, $completion) {
    return this.ca3((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flowMethod$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !this.aa3_1.za0_1;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(flowMethod$slambda$slambda).da3 = function (it, completion) {
    var i = new flowMethod$slambda$slambda(this.aa3_1, completion);
    i.ba3_1 = it;
    return i;
  };
  function flowMethod$slambda$slambda_0($stopHandle, resultContinuation) {
    var i = new flowMethod$slambda$slambda($stopHandle, resultContinuation);
    var l = function (it, $completion) {
      return i.ca3(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function flowMethod$1$$inlined$map$1($this) {
    this.qa2_1 = $this;
  }
  protoOf(flowMethod$1$$inlined$map$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$8(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowMethod$1$$inlined$map$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function flowMethod$slambda_1($handle, resultContinuation) {
    this.ma3_1 = $handle;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowMethod$slambda_1).wa3 = function (instance, _destruct__k2r9zo, $completion) {
    var tmp = this.xa3(instance, _destruct__k2r9zo, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowMethod$slambda_1).pa = function (p1, p2, $completion) {
    var tmp = !(p1 == null) ? p1 : THROW_CCE();
    return this.wa3(tmp, p2 instanceof Triple ? p2 : THROW_CCE(), $completion);
  };
  protoOf(flowMethod$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            this.pa3_1 = this.oa3_1.ug();
            this.qa3_1 = this.oa3_1.vg();
            this.ra3_1 = this.oa3_1.hm();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 4;
            this.ta3_1 = this.ma3_1(this.na3_1, this.qa3_1);
            var tmp_0 = this;
            var tmp_1 = this.ra3_1;
            tmp_0.ua3_1 = tmp_1 instanceof LocalInstancePublication ? tmp_1 : THROW_CCE();
            var tmp_2 = this;
            var tmp_3 = this.ua3_1.n9j_1;
            tmp_2.va3_1 = tmp_3 instanceof StopHandle ? tmp_3 : THROW_CCE();
            this.y9_1 = 2;
            var tmp_4 = this.pa3_1.b2p();
            var this_0 = takeWhile(this.ta3_1, flowMethod$slambda$slambda_0(this.va3_1, null));
            suspendResult = emitAll_0(tmp_4, new flowMethod$1$$inlined$map$1(this_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.sa3_1 = suspendResult;
            this.z9_1 = 5;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 5;
            this.pa3_1.vr();
            return Unit_instance;
          case 4:
            this.z9_1 = 5;
            var t = this.ba_1;
            this.pa3_1.vr();
            throw t;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowMethod$slambda_1).xa3 = function (instance, _destruct__k2r9zo, completion) {
    var i = new flowMethod$slambda_1(this.ma3_1, completion);
    i.na3_1 = instance;
    i.oa3_1 = _destruct__k2r9zo;
    return i;
  };
  function flowMethod$slambda_2($handle, resultContinuation) {
    var i = new flowMethod$slambda_1($handle, resultContinuation);
    var l = function (instance, _destruct__k2r9zo, $completion) {
      return i.wa3(instance, _destruct__k2r9zo, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function flowMethod$lambda$slambda($endpoint, $stopHandleMethod, $collectorSerializer, $emitHandle, $parameter, resultContinuation) {
    this.ga4_1 = $endpoint;
    this.ha4_1 = $stopHandleMethod;
    this.ia4_1 = $collectorSerializer;
    this.ja4_1 = $emitHandle;
    this.ka4_1 = $parameter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowMethod$lambda$slambda).sa4 = function ($this$channelFlow, $completion) {
    var tmp = this.ta4($this$channelFlow, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowMethod$lambda$slambda).oa = function (p1, $completion) {
    return this.sa4((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flowMethod$lambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 10;
            this.ma4_1 = this.ga4_1.l9j();
            this.y9_1 = 1;
            suspendResult = this.ha4_1.n9k(this.ga4_1, mixedTo(this.ma4_1, Unit_instance), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.na4_1 = suspendResult;
            this.oa4_1 = new SendingCollector(this.la4_1.y15());
            this.y9_1 = 2;
            suspendResult = this.ma4_1.m9l(this.oa4_1, this.ia4_1.v9j_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.pa4_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 9;
            this.z9_1 = 5;
            this.y9_1 = 4;
            suspendResult = this.ja4_1.n9k(this.ga4_1, new Triple(this.pa4_1, this.ka4_1, this.na4_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.qa4_1 = suspendResult;
            this.z9_1 = 10;
            this.y9_1 = 8;
            continue $sm;
          case 5:
            this.z9_1 = 9;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof Exception) {
              this.ra4_1 = this.ba_1;
              var tmp_1 = this.ra4_1;
              if (!(tmp_1 instanceof RemoteInvocationException)) {
                this.y9_1 = 6;
                suspendResult = this.na4_1.b2p().s9v(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.y9_1 = 7;
                continue $sm;
              }
            } else {
              throw this.ba_1;
            }

          case 6:
            this.y9_1 = 7;
            continue $sm;
          case 7:
            var tmp_2 = this;
            throw this.ra4_1;
          case 8:
            this.z9_1 = 10;
            this.na4_1.vr();
            return Unit_instance;
          case 9:
            this.z9_1 = 10;
            var t = this.ba_1;
            this.na4_1.vr();
            throw t;
          case 10:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 10) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowMethod$lambda$slambda).ta4 = function ($this$channelFlow, completion) {
    var i = new flowMethod$lambda$slambda(this.ga4_1, this.ha4_1, this.ia4_1, this.ja4_1, this.ka4_1, completion);
    i.la4_1 = $this$channelFlow;
    return i;
  };
  function flowMethod$lambda$slambda_0($endpoint, $stopHandleMethod, $collectorSerializer, $emitHandle, $parameter, resultContinuation) {
    var i = new flowMethod$lambda$slambda($endpoint, $stopHandleMethod, $collectorSerializer, $emitHandle, $parameter, resultContinuation);
    var l = function ($this$channelFlow, $completion) {
      return i.sa4($this$channelFlow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function flowMethod$lambda$o$collect$slambda($$this$unsafeFlow, resultContinuation) {
    this.ca5_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(flowMethod$lambda$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowMethod$lambda$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(flowMethod$lambda$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.ea5_1 = this.ca5_1;
            var tmp_1 = this;
            tmp_1.fa5_1 = this.da5_1;
            this.ga5_1 = this.ea5_1;
            this.ha5_1 = this.fa5_1;
            this.y9_1 = 1;
            var it = this.ha5_1;
            suspendResult = this.ga5_1.d1f(expectElement(it), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(flowMethod$lambda$o$collect$slambda).a1u = function (value, completion) {
    var i = new flowMethod$lambda$o$collect$slambda(this.ca5_1, completion);
    i.da5_1 = value;
    return i;
  };
  function flowMethod$lambda$o$collect$slambda_0($$this$unsafeFlow, resultContinuation) {
    var i = new flowMethod$lambda$o$collect$slambda($$this$unsafeFlow, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$9(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qa5_1 = _this__u8e3s4;
    this.ra5_1 = collector;
  }
  protoOf($collectCOROUTINE$9).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.sa5_1 = this.ra5_1;
            this.ta5_1 = this.sa5_1;
            this.y9_1 = 1;
            var tmp_1 = flowMethod$lambda$o$collect$slambda_0(this.ta5_1, null);
            suspendResult = this.qa5_1.ua5_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_8(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function flowMethod$1$$inlined$map$2($this) {
    this.ua5_1 = $this;
  }
  protoOf(flowMethod$1$$inlined$map$2).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$9(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(flowMethod$1$$inlined$map$2).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function flowMethod$lambda($stopHandleMethod, $collectorSerializer, $emitHandle) {
    return function (endpoint, parameter) {
      // Inline function 'kotlinx.coroutines.flow.map' call
      // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
      var this_0 = channelFlow(flowMethod$lambda$slambda_0(endpoint, $stopHandleMethod, $collectorSerializer, $emitHandle, parameter, null));
      // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
      return new flowMethod$1$$inlined$map$2(this_0);
    };
  }
  function PublishedFlowCollectorSerializer(elementSerializer) {
    InstancePublicationSerializer.call(this, new Descriptor_1(elementSerializer));
  }
  function RemoteFlowCollector$Descriptor$emit$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteFlowCollector$Descriptor$emit$slambda).fa6 = function (instance, value, $completion) {
    var tmp = this.ga6(instance, value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(RemoteFlowCollector$Descriptor$emit$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE();
    return this.fa6(tmp, p2 instanceof FlowMessageData ? p2 : THROW_CCE(), $completion);
  };
  protoOf(RemoteFlowCollector$Descriptor$emit$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.da6_1.d1f(fromFlatData(this.ea6_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteFlowCollector$Descriptor$emit$slambda).ga6 = function (instance, value, completion) {
    var i = new RemoteFlowCollector$Descriptor$emit$slambda(completion);
    i.da6_1 = instance;
    i.ea6_1 = value;
    return i;
  };
  function RemoteFlowCollector$Descriptor$emit$slambda_0(resultContinuation) {
    var i = new RemoteFlowCollector$Descriptor$emit$slambda(resultContinuation);
    var l = function (instance, value, $completion) {
      return i.fa6(instance, value, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Descriptor_1(elementSerializer) {
    InstanceDescriptor.call(this);
    var tmp = this;
    var tmp_0 = Companion_getInstance_166().ia6(elementSerializer);
    var tmp_1 = serializer_16(Unit_instance);
    tmp.ka6_1 = method(this, 'emit', tmp_0, tmp_1, RemoteFlowCollector$Descriptor$emit$slambda_0(null));
  }
  protoOf(Descriptor_1).la6 = function (endpoint) {
    return new RemoteFlowCollector(endpoint, this);
  };
  protoOf(Descriptor_1).j9j = function (endpoint) {
    return this.la6(endpoint);
  };
  function RemoteFlowCollector(endpoint, descriptor) {
    this.ma6_1 = endpoint;
    this.na6_1 = descriptor;
  }
  protoOf(RemoteFlowCollector).oa6 = function (value, $completion) {
    return this.na6_1.ka6_1.n9k(this.ma6_1, toFlatData(value), $completion);
  };
  protoOf(RemoteFlowCollector).d1f = function (value, $completion) {
    return this.oa6(value instanceof FlowMessage ? value : THROW_CCE(), $completion);
  };
  function FlowMessage() {
  }
  function Element_2(element) {
    FlowMessage.call(this);
    this.q9z_1 = element;
  }
  protoOf(Element_2).ga0 = function () {
    return false;
  };
  protoOf(Element_2).toString = function () {
    return 'Element(element=' + toString_0(this.q9z_1) + ')';
  };
  protoOf(Element_2).hashCode = function () {
    return this.q9z_1 == null ? 0 : hashCode(this.q9z_1);
  };
  protoOf(Element_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Element_2))
      return false;
    var tmp0_other_with_cast = other instanceof Element_2 ? other : THROW_CCE();
    if (!equals(this.q9z_1, tmp0_other_with_cast.q9z_1))
      return false;
    return true;
  };
  function expectElement(_this__u8e3s4) {
    // Inline function 'kotlin.check' call
    if (!(_this__u8e3s4 instanceof Element_2)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return _this__u8e3s4.q9z_1;
  }
  function End() {
    FlowMessage.call(this);
  }
  protoOf(End).ga0 = function () {
    return true;
  };
  function Error_1(message) {
    FlowMessage.call(this);
    this.p9z_1 = message;
  }
  protoOf(Error_1).ga0 = function () {
    return true;
  };
  protoOf(Error_1).toString = function () {
    return 'Error(message=' + this.p9z_1 + ')';
  };
  protoOf(Error_1).hashCode = function () {
    return getStringHashCode(this.p9z_1);
  };
  protoOf(Error_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Error_1))
      return false;
    var tmp0_other_with_cast = other instanceof Error_1 ? other : THROW_CCE();
    if (!(this.p9z_1 === tmp0_other_with_cast.p9z_1))
      return false;
    return true;
  };
  function $serializer_init_$Init$_0(typeSerial0, $this) {
    $serializer_15.call($this);
    $this.qa6_1 = typeSerial0;
    return $this;
  }
  function $serializer_init_$Create$_0(typeSerial0) {
    return $serializer_init_$Init$_0(typeSerial0, objectCreate(protoOf($serializer_15)));
  }
  function Companion_166() {
    Companion_instance_166 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.flow.FlowMessageData', null, 2);
    tmp0_serialDesc.t5n('element', true);
    tmp0_serialDesc.t5n('errorMessage', true);
    this.ha6_1 = tmp0_serialDesc;
  }
  protoOf(Companion_166).ia6 = function (typeSerial0) {
    return $serializer_init_$Create$_0(typeSerial0);
  };
  protoOf(Companion_166).t5o = function (typeParamsSerializers) {
    return this.ia6(typeParamsSerializers[0]);
  };
  var Companion_instance_166;
  function Companion_getInstance_166() {
    if (Companion_instance_166 == null)
      new Companion_166();
    return Companion_instance_166;
  }
  function $serializer_15() {
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.rpc.flow.FlowMessageData', this, 2);
    tmp0_serialDesc.t5n('element', true);
    tmp0_serialDesc.t5n('errorMessage', true);
    this.pa6_1 = tmp0_serialDesc;
  }
  protoOf($serializer_15).ra6 = function (encoder, value) {
    var tmp0_desc = this.pa6_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    if (tmp1_output.e5i(tmp0_desc, 0) ? true : !(value.sa6_1 == null)) {
      tmp1_output.a5i(tmp0_desc, 0, this.qa6_1, value.sa6_1);
    }
    if (tmp1_output.e5i(tmp0_desc, 1) ? true : !(value.ta6_1 == null)) {
      tmp1_output.a5i(tmp0_desc, 1, StringSerializer_getInstance(), value.ta6_1);
    }
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_15).j5d = function (encoder, value) {
    return this.ra6(encoder, value instanceof FlowMessageData ? value : THROW_CCE());
  };
  protoOf($serializer_15).k5d = function (decoder) {
    var tmp0_desc = this.pa6_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.x5g(tmp0_desc, 0, this.qa6_1, tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.x5g(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.x5g(tmp0_desc, 0, this.qa6_1, tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.x5g(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return FlowMessageData_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_15).w5c = function () {
    return this.pa6_1;
  };
  protoOf($serializer_15).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(this.qa6_1), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_15).j5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.qa6_1];
  };
  function FlowMessageData_init_$Init$(seen0, element, errorMessage, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, Companion_getInstance_166().ha6_1);
    }
    if (0 === (seen0 & 1))
      $this.sa6_1 = null;
    else
      $this.sa6_1 = element;
    if (0 === (seen0 & 2))
      $this.ta6_1 = null;
    else
      $this.ta6_1 = errorMessage;
    return $this;
  }
  function FlowMessageData_init_$Create$(seen0, element, errorMessage, serializationConstructorMarker) {
    return FlowMessageData_init_$Init$(seen0, element, errorMessage, serializationConstructorMarker, objectCreate(protoOf(FlowMessageData)));
  }
  function FlowMessageData(element, errorMessage) {
    Companion_getInstance_166();
    element = element === VOID ? null : element;
    errorMessage = errorMessage === VOID ? null : errorMessage;
    this.sa6_1 = element;
    this.ta6_1 = errorMessage;
  }
  protoOf(FlowMessageData).toString = function () {
    return 'FlowMessageData(element=' + toString_0(this.sa6_1) + ', errorMessage=' + this.ta6_1 + ')';
  };
  protoOf(FlowMessageData).hashCode = function () {
    var result = this.sa6_1 == null ? 0 : hashCode(this.sa6_1);
    result = imul(result, 31) + (this.ta6_1 == null ? 0 : getStringHashCode(this.ta6_1)) | 0;
    return result;
  };
  protoOf(FlowMessageData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FlowMessageData))
      return false;
    var tmp0_other_with_cast = other instanceof FlowMessageData ? other : THROW_CCE();
    if (!equals(this.sa6_1, tmp0_other_with_cast.sa6_1))
      return false;
    if (!(this.ta6_1 == tmp0_other_with_cast.ta6_1))
      return false;
    return true;
  };
  function toFlatData(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof Element_2) {
      tmp = new FlowMessageData(_this__u8e3s4.q9z_1);
    } else {
      if (_this__u8e3s4 instanceof Error_1) {
        tmp = new FlowMessageData(VOID, _this__u8e3s4.p9z_1);
      } else {
        if (_this__u8e3s4 instanceof End) {
          tmp = new FlowMessageData();
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function fromFlatData(_this__u8e3s4) {
    return !(_this__u8e3s4.sa6_1 == null) ? new Element_2(_this__u8e3s4.sa6_1) : !(_this__u8e3s4.ta6_1 == null) ? new Error_1(_this__u8e3s4.ta6_1) : new End();
  }
  function PublishedDisposableSerializer() {
    PublishedDisposableSerializer_instance = this;
    InstancePublicationSerializer.call(this, Companion_getInstance_167());
  }
  var PublishedDisposableSerializer_instance;
  function PublishedDisposableSerializer_getInstance() {
    if (PublishedDisposableSerializer_instance == null)
      new PublishedDisposableSerializer();
    return PublishedDisposableSerializer_instance;
  }
  function Companion_167() {
    Companion_instance_167 = this;
    InstanceDescriptor.call(this);
  }
  protoOf(Companion_167).va6 = function (endpoint) {
    return new RemoteDisposable(endpoint);
  };
  protoOf(Companion_167).j9j = function (endpoint) {
    return this.va6(endpoint);
  };
  var Companion_instance_167;
  function Companion_getInstance_167() {
    if (Companion_instance_167 == null)
      new Companion_167();
    return Companion_instance_167;
  }
  function RemoteDisposable(endpoint) {
    Companion_getInstance_167();
    this.wa6_1 = endpoint;
  }
  protoOf(RemoteDisposable).vr = function () {
    this.wa6_1.vr();
  };
  function get_LOG_4() {
    _init_properties_RpcClient_kt__px582m();
    return LOG_4;
  }
  var LOG_4;
  function RpcClient(states, coroutineScope) {
    this.xa6_1 = coroutineScope;
    this.ya6_1 = states;
  }
  protoOf(RpcClient).et = function () {
    return this.xa6_1.et();
  };
  function wsRpcClient(_this__u8e3s4, schema, wsSessionProvider) {
    _init_properties_RpcClient_kt__px582m();
    return rpcClient(_this__u8e3s4, wsRpcClient$lambda(wsSessionProvider, schema));
  }
  function rpcClient(_this__u8e3s4, entriesProvider) {
    _init_properties_RpcClient_kt__px582m();
    var job = Job_0(get_job(_this__u8e3s4.et()));
    var rpcClientScope = CoroutineScope_0(_this__u8e3s4.et().ej(job));
    var entriesChannel = entriesProvider(rpcClientScope);
    var sharedFlowDeferred = async(rpcClientScope, VOID, VOID, rpcClient$slambda_0(entriesChannel, rpcClientScope, null));
    return new RpcClient(flow(rpcClient$slambda_2(sharedFlowDeferred, null)), rpcClientScope);
  }
  function wsEntryPoints(_this__u8e3s4, wsSessionProvider, schema) {
    _init_properties_RpcClient_kt__px582m();
    return produce_0(_this__u8e3s4, VOID, VOID, wsEntryPoints$slambda_0(wsSessionProvider, schema, null));
  }
  function sessionJob(_this__u8e3s4) {
    _init_properties_RpcClient_kt__px582m();
    var tmp = SupervisorJob(get_job(_this__u8e3s4.et()));
    // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
    var tmp$ret$0 = new sessionJob$$inlined$CoroutineExceptionHandler$1();
    return tmp.ej(tmp$ret$0);
  }
  function wsRpcClient$lambda($wsSessionProvider, $schema) {
    return function ($this$rpcClient) {
      return wsEntryPoints($this$rpcClient, $wsSessionProvider, $schema);
    };
  }
  function rpcClient$slambda($entriesChannel, $rpcClientScope, resultContinuation) {
    this.ha7_1 = $entriesChannel;
    this.ia7_1 = $rpcClientScope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcClient$slambda).ka7 = function ($this$async, $completion) {
    var tmp = this.i1l($this$async, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(rpcClient$slambda).oa = function (p1, $completion) {
    return this.ka7((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcClient$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = stateIn(consumeAsFlow(this.ha7_1), this.ia7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(rpcClient$slambda).i1l = function ($this$async, completion) {
    var i = new rpcClient$slambda(this.ha7_1, this.ia7_1, completion);
    i.ja7_1 = $this$async;
    return i;
  };
  function rpcClient$slambda_0($entriesChannel, $rpcClientScope, resultContinuation) {
    var i = new rpcClient$slambda($entriesChannel, $rpcClientScope, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.ka7($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function rpcClient$slambda_1($sharedFlowDeferred, resultContinuation) {
    this.ta7_1 = $sharedFlowDeferred;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcClient$slambda_1).c1m = function ($this$flow, $completion) {
    var tmp = this.d1m($this$flow, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(rpcClient$slambda_1).oa = function (p1, $completion) {
    return this.c1m((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcClient$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.ta7_1.gw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.va7_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = emitAll_0(this.ua7_1, this.va7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(rpcClient$slambda_1).d1m = function ($this$flow, completion) {
    var i = new rpcClient$slambda_1(this.ta7_1, completion);
    i.ua7_1 = $this$flow;
    return i;
  };
  function rpcClient$slambda_2($sharedFlowDeferred, resultContinuation) {
    var i = new rpcClient$slambda_1($sharedFlowDeferred, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.c1m($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function wsEntryPoints$slambda$slambda($this_produce, resultContinuation) {
    this.ea8_1 = $this_produce;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(wsEntryPoints$slambda$slambda).ga8 = function (it, $completion) {
    var tmp = this.ha8(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(wsEntryPoints$slambda$slambda).oa = function (p1, $completion) {
    return this.ga8(!(p1 == null) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(wsEntryPoints$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ea8_1.y15().z1b(this.fa8_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(wsEntryPoints$slambda$slambda).ha8 = function (it, completion) {
    var i = new wsEntryPoints$slambda$slambda(this.ea8_1, completion);
    i.fa8_1 = it;
    return i;
  };
  function wsEntryPoints$slambda$slambda_0($this_produce, resultContinuation) {
    var i = new wsEntryPoints$slambda$slambda($this_produce, resultContinuation);
    var l = function (it, $completion) {
      return i.ga8(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function wsEntryPoints$slambda($wsSessionProvider, $schema, resultContinuation) {
    this.qa8_1 = $wsSessionProvider;
    this.ra8_1 = $schema;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(wsEntryPoints$slambda).u1k = function ($this$produce, $completion) {
    var tmp = this.v1k($this$produce, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(wsEntryPoints$slambda).oa = function (p1, $completion) {
    return this.u1k((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(wsEntryPoints$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 11;
            var tmp_0 = this;
            tmp_0.ta8_1 = this.qa8_1;
            this.ua8_1 = this.ta8_1;
            var tmp_1 = this;
            tmp_1.va8_1 = this.ua8_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.xa8_1 = this.va8_1;
            this.ya8_1 = null;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 10;
            this.z9_1 = 9;
            var tmp_2 = this;
            tmp_2.aa9_1 = this.xa8_1;
            this.ba9_1 = this.aa9_1;
            this.ca9_1 = this.ba9_1.k();
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.y9_1 = 5;
            suspendResult = this.ca9_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.y9_1 = 7;
              continue $sm;
            }

            this.da9_1 = this.ca9_1.m();
            var tmp_3 = this;
            tmp_3.ea9_1 = this.da9_1;
            this.fa9_1 = this.ea9_1;
            this.y9_1 = 6;
            var tmp_4 = rpcSession(this.sa8_1, sessionJob(this.sa8_1), get_ClientRpcInitiationHandler(), this.fa9_1);
            suspendResult = this.ra8_1.ha9(tmp_4, wsEntryPoints$slambda$slambda_0(this.sa8_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.y9_1 = 4;
            continue $sm;
          case 7:
            var tmp_5 = this;
            tmp_5.za8_1 = Unit_instance;
            this.z9_1 = 11;
            this.y9_1 = 8;
            var tmp_6 = this;
            continue $sm;
          case 8:
            this.z9_1 = 11;
            var tmp_7 = this;
            cancelConsumed(this.xa8_1, this.ya8_1);
            tmp_7.wa8_1 = Unit_instance;
            this.y9_1 = 13;
            continue $sm;
          case 9:
            this.z9_1 = 10;
            var tmp_8 = this.ba_1;
            if (tmp_8 instanceof Error) {
              var e = this.ba_1;
              var tmp_9 = this;
              this.ya8_1 = e;
              throw e;
            } else {
              throw this.ba_1;
            }

          case 10:
            this.z9_1 = 11;
            var t = this.ba_1;
            cancelConsumed(this.xa8_1, this.ya8_1);
            throw t;
          case 11:
            throw this.ba_1;
          case 12:
            this.z9_1 = 11;
            cancelConsumed(this.xa8_1, this.ya8_1);
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 13;
            continue $sm;
          case 13:
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 11) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(wsEntryPoints$slambda).v1k = function ($this$produce, completion) {
    var i = new wsEntryPoints$slambda(this.qa8_1, this.ra8_1, completion);
    i.sa8_1 = $this$produce;
    return i;
  };
  function wsEntryPoints$slambda_0($wsSessionProvider, $schema, resultContinuation) {
    var i = new wsEntryPoints$slambda($wsSessionProvider, $schema, resultContinuation);
    var l = function ($this$produce, $completion) {
      return i.u1k($this$produce, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function sessionJob$$inlined$CoroutineExceptionHandler$1() {
    AbstractCoroutineContextElement.call(this, Key_instance_1);
  }
  protoOf(sessionJob$$inlined$CoroutineExceptionHandler$1).wz = function (context, exception) {
    get_LOG_4().eo('Session finished with an exception ' + exception.toString(), exception);
    return Unit_instance;
  };
  var properties_initialized_RpcClient_kt_x4l1a8;
  function _init_properties_RpcClient_kt__px582m() {
    if (!properties_initialized_RpcClient_kt_x4l1a8) {
      properties_initialized_RpcClient_kt_x4l1a8 = true;
      LOG_4 = getLogger(getKClass(RpcClient));
    }
  }
  function get_RPC_INITIAL_SEQUENCE() {
    _init_properties_RpcInitiationHandler_kt__6estzr();
    return RPC_INITIAL_SEQUENCE;
  }
  var RPC_INITIAL_SEQUENCE;
  function get_NoRpcInitiationHandler() {
    _init_properties_RpcInitiationHandler_kt__6estzr();
    return NoRpcInitiationHandler;
  }
  var NoRpcInitiationHandler;
  function get_ClientRpcInitiationHandler() {
    _init_properties_RpcInitiationHandler_kt__6estzr();
    return ClientRpcInitiationHandler;
  }
  var ClientRpcInitiationHandler;
  var ServerRpcInitiationHandler;
  function RpcInitiationHandler() {
  }
  function sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0(function_0) {
    this.ka9_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0).ja9 = function (_this__u8e3s4, session, initiationJob) {
    return this.ka9_1(_this__u8e3s4, session, initiationJob);
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0).b4 = function () {
    return this.ka9_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RpcInitiationHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0(function_0) {
    this.la9_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0).ja9 = function (_this__u8e3s4, session, initiationJob) {
    return this.la9_1(_this__u8e3s4, session, initiationJob);
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0).b4 = function () {
    return this.la9_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RpcInitiationHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1(function_0) {
    this.ma9_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1).ja9 = function (_this__u8e3s4, session, initiationJob) {
    return this.ma9_1(_this__u8e3s4, session, initiationJob);
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1).b4 = function () {
    return this.ma9_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RpcInitiationHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1).hashCode = function () {
    return hashCode(this.b4());
  };
  function NoRpcInitiationHandler$lambda($this$RpcInitiationHandler, _unused_var__etf5q3, initiationJob) {
    _init_properties_RpcInitiationHandler_kt__6estzr();
    initiationJob.oz();
    return Unit_instance;
  }
  function ClientRpcInitiationHandler$lambda($this$RpcInitiationHandler, session, initiationJob) {
    _init_properties_RpcInitiationHandler_kt__6estzr();
    launch($this$RpcInitiationHandler, VOID, VOID, ClientRpcInitiationHandler$lambda$slambda_0(session, initiationJob, null));
    return Unit_instance;
  }
  function ClientRpcInitiationHandler$lambda$slambda($session, $initiationJob, resultContinuation) {
    this.va9_1 = $session;
    this.wa9_1 = $initiationJob;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ClientRpcInitiationHandler$lambda$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ClientRpcInitiationHandler$lambda$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ClientRpcInitiationHandler$lambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.va9_1.ya9_1.d1c(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var initial = suspendResult;
            var tmp_0;
            if (initial instanceof Binary) {
              tmp_0 = contentEquals_0(initial.g9e_1, get_RPC_INITIAL_SEQUENCE());
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              this.wa9_1.oz();
            } else {
              this.wa9_1.nz(IllegalStateException_init_$Create$_0('Invalid rpc initial sequence: ' + initial.toString() + ', ' + toString_1(initial.g9e_1)));
            }

            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ClientRpcInitiationHandler$lambda$slambda).i1l = function ($this$launch, completion) {
    var i = new ClientRpcInitiationHandler$lambda$slambda(this.va9_1, this.wa9_1, completion);
    i.xa9_1 = $this$launch;
    return i;
  };
  function ClientRpcInitiationHandler$lambda$slambda_0($session, $initiationJob, resultContinuation) {
    var i = new ClientRpcInitiationHandler$lambda$slambda($session, $initiationJob, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ServerRpcInitiationHandler$lambda($this$RpcInitiationHandler, session, initiationJob) {
    _init_properties_RpcInitiationHandler_kt__6estzr();
    launch($this$RpcInitiationHandler, VOID, VOID, ServerRpcInitiationHandler$lambda$slambda_0(initiationJob, session, null));
    return Unit_instance;
  }
  function ServerRpcInitiationHandler$lambda$slambda($initiationJob, $session, resultContinuation) {
    this.iaa_1 = $initiationJob;
    this.jaa_1 = $session;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ServerRpcInitiationHandler$lambda$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ServerRpcInitiationHandler$lambda$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ServerRpcInitiationHandler$lambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.iaa_1.ku(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y9_1 = 2;
            suspendResult = this.jaa_1.za9_1.z1b(Binary_init_$Create$(true, get_RPC_INITIAL_SEQUENCE()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ServerRpcInitiationHandler$lambda$slambda).i1l = function ($this$launch, completion) {
    var i = new ServerRpcInitiationHandler$lambda$slambda(this.iaa_1, this.jaa_1, completion);
    i.kaa_1 = $this$launch;
    return i;
  };
  function ServerRpcInitiationHandler$lambda$slambda_0($initiationJob, $session, resultContinuation) {
    var i = new ServerRpcInitiationHandler$lambda$slambda($initiationJob, $session, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var properties_initialized_RpcInitiationHandler_kt_679g2d;
  function _init_properties_RpcInitiationHandler_kt__6estzr() {
    if (!properties_initialized_RpcInitiationHandler_kt_679g2d) {
      properties_initialized_RpcInitiationHandler_kt_679g2d = true;
      // Inline function 'kotlin.byteArrayOf' call
      RPC_INITIAL_SEQUENCE = new Int8Array([75, 79, 67, 82, 80, 67]);
      var tmp = NoRpcInitiationHandler$lambda;
      NoRpcInitiationHandler = new sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0(tmp);
      var tmp_0 = ClientRpcInitiationHandler$lambda;
      ClientRpcInitiationHandler = new sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_0(tmp_0);
      var tmp_1 = ServerRpcInitiationHandler$lambda;
      ServerRpcInitiationHandler = new sam$jetbrains_ocelot_langDef_rpc_session_RpcInitiationHandler$0_1(tmp_1);
    }
  }
  function RpcSchema$connect$slambda$lambda($facade) {
    return function (it) {
      $facade.k11().pu();
      return Unit_instance;
    };
  }
  function RpcSchema$connect$slambda($session, this$0, $connection, resultContinuation) {
    this.taa_1 = $session;
    this.uaa_1 = this$0;
    this.vaa_1 = $connection;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RpcSchema$connect$slambda).h1l = function ($this$coroutineScope, $completion) {
    var tmp = this.i1l($this$coroutineScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(RpcSchema$connect$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RpcSchema$connect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.xaa_1 = rpcFacade(this.waa_1, this.taa_1.i9a(), this.taa_1.j9a(), this.taa_1.b3());
            this.yaa_1 = this.xaa_1.b9k(new RemoteInstanceId(new Long(0, 0)), this.uaa_1.ga9_1).b2p();
            var tmp_0 = this.taa_1.k11();
            tmp_0.hu(RpcSchema$connect$slambda$lambda(this.xaa_1));
            this.y9_1 = 1;
            suspendResult = this.taa_1.zaa().ku(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y9_1 = 2;
            suspendResult = this.vaa_1(this.yaa_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(RpcSchema$connect$slambda).i1l = function ($this$coroutineScope, completion) {
    var i = new RpcSchema$connect$slambda(this.taa_1, this.uaa_1, this.vaa_1, completion);
    i.waa_1 = $this$coroutineScope;
    return i;
  };
  function RpcSchema$connect$slambda_0($session, this$0, $connection, resultContinuation) {
    var i = new RpcSchema$connect$slambda($session, this$0, $connection, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.h1l($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function RpcSchema(entryPointDescriptor) {
    this.ga9_1 = entryPointDescriptor;
  }
  protoOf(RpcSchema).ha9 = function (session, connection, $completion) {
    return coroutineScope(RpcSchema$connect$slambda_0(session, this, connection, null), $completion);
  };
  function Companion_168() {
    Companion_instance_168 = this;
    this.aab_1 = new RpcSessionCounter();
  }
  protoOf(Companion_168).bab = function (coroutineContext) {
    var tmp0_elvis_lhs = coroutineContext.la(Companion_getInstance_168());
    var counter = tmp0_elvis_lhs == null ? this.aab_1 : tmp0_elvis_lhs;
    var tmp1_safe_receiver = coroutineContext.la(Key_instance_2);
    var oldName = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.yz_1;
    var tmp;
    if (oldName == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.rpc.session.Companion.sessionName.<anonymous>' call
      tmp = oldName + '-';
    }
    var tmp3_elvis_lhs = tmp;
    var prefix = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
    var _unary__edvuaz = counter.dab_1;
    counter.dab_1 = _unary__edvuaz + 1 | 0;
    return new CoroutineName(prefix + _unary__edvuaz);
  };
  var Companion_instance_168;
  function Companion_getInstance_168() {
    if (Companion_instance_168 == null)
      new Companion_168();
    return Companion_instance_168;
  }
  function RpcSessionCounter() {
    Companion_getInstance_168();
    AbstractCoroutineContextElement.call(this, Companion_getInstance_168());
    this.dab_1 = 0;
  }
  function rpcSession(_this__u8e3s4, context, initiationHandler, launcher) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    initiationHandler = initiationHandler === VOID ? get_NoRpcInitiationHandler() : initiationHandler;
    var newContext = _this__u8e3s4.et().ej(context);
    var job = Job_0(get_job(newContext));
    var name = Companion_getInstance_168().bab(newContext);
    var outgoing = Channel();
    var incoming = Channel();
    var initiationJob = Job_0(job);
    var tmp = newContext.ej(job).ej(name);
    launch(_this__u8e3s4, tmp, VOID, rpcSession$slambda_0(launcher, initiationHandler, initiationJob, incoming, outgoing, null));
    return new WsRpcSession(incoming, outgoing, job, name, initiationJob);
  }
  function WsRpcSession(incoming, outgoing, job, name, initiationJob) {
    this.eab_1 = incoming;
    this.fab_1 = outgoing;
    this.gab_1 = job;
    this.hab_1 = name;
    this.iab_1 = initiationJob;
  }
  protoOf(WsRpcSession).i9a = function () {
    return this.eab_1;
  };
  protoOf(WsRpcSession).j9a = function () {
    return this.fab_1;
  };
  protoOf(WsRpcSession).k11 = function () {
    return this.gab_1;
  };
  protoOf(WsRpcSession).b3 = function () {
    return this.hab_1;
  };
  protoOf(WsRpcSession).zaa = function () {
    return this.iab_1;
  };
  function rpcSession$slambda$slambda($initiationJob, $wsSession, $incoming, resultContinuation) {
    this.rab_1 = $initiationJob;
    this.sab_1 = $wsSession;
    this.tab_1 = $incoming;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcSession$slambda$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(rpcSession$slambda$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcSession$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 15;
            this.y9_1 = 1;
            suspendResult = this.rab_1.ku(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0.vab_1 = this.sab_1.ya9_1;
            this.wab_1 = this.vab_1;
            var tmp_1 = this;
            tmp_1.xab_1 = this.wab_1;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.zab_1 = this.xab_1;
            this.aac_1 = null;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.z9_1 = 12;
            this.z9_1 = 11;
            var tmp_2 = this;
            tmp_2.cac_1 = this.zab_1;
            this.dac_1 = this.cac_1;
            this.eac_1 = this.dac_1.k();
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.y9_1 = 6;
            suspendResult = this.eac_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            if (!suspendResult) {
              this.y9_1 = 9;
              continue $sm;
            }

            this.fac_1 = this.eac_1.m();
            var tmp_3 = this;
            tmp_3.gac_1 = this.fac_1;
            this.hac_1 = this.gac_1;
            var tmp_4 = this.hac_1;
            if (tmp_4 instanceof Binary) {
              this.iac_1 = Default_getInstance_0().e5e(Companion_getInstance_164().h67(), this.hac_1.g9e_1);
              this.y9_1 = 7;
              suspendResult = this.tab_1.z1b(this.iac_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 8;
              continue $sm;
            }

          case 7:
            this.y9_1 = 8;
            continue $sm;
          case 8:
            this.y9_1 = 5;
            continue $sm;
          case 9:
            var tmp_5 = this;
            tmp_5.bac_1 = Unit_instance;
            this.z9_1 = 15;
            this.y9_1 = 10;
            var tmp_6 = this;
            continue $sm;
          case 10:
            this.z9_1 = 15;
            var tmp_7 = this;
            cancelConsumed(this.zab_1, this.aac_1);
            tmp_7.yab_1 = Unit_instance;
            this.y9_1 = 14;
            continue $sm;
          case 11:
            this.z9_1 = 12;
            var tmp_8 = this.ba_1;
            if (tmp_8 instanceof Error) {
              var e = this.ba_1;
              var tmp_9 = this;
              this.aac_1 = e;
              throw e;
            } else {
              throw this.ba_1;
            }

          case 12:
            this.z9_1 = 15;
            var t = this.ba_1;
            cancelConsumed(this.zab_1, this.aac_1);
            throw t;
          case 13:
            this.z9_1 = 15;
            cancelConsumed(this.zab_1, this.aac_1);
            if (false) {
              this.y9_1 = 2;
              continue $sm;
            }

            this.y9_1 = 14;
            continue $sm;
          case 14:
            this.tab_1.i1c();
            return Unit_instance;
          case 15:
            throw this.ba_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 15) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(rpcSession$slambda$slambda).i1l = function ($this$launch, completion) {
    var i = new rpcSession$slambda$slambda(this.rab_1, this.sab_1, this.tab_1, completion);
    i.uab_1 = $this$launch;
    return i;
  };
  function rpcSession$slambda$slambda_0($initiationJob, $wsSession, $incoming, resultContinuation) {
    var i = new rpcSession$slambda$slambda($initiationJob, $wsSession, $incoming, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function rpcSession$slambda$slambda_1($outgoing, $wsSession, resultContinuation) {
    this.rac_1 = $outgoing;
    this.sac_1 = $wsSession;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcSession$slambda$slambda_1).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(rpcSession$slambda$slambda_1).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcSession$slambda$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 14;
            this.z9_1 = 13;
            var tmp_0 = this;
            tmp_0.uac_1 = this.rac_1;
            this.vac_1 = this.uac_1;
            var tmp_1 = this;
            tmp_1.wac_1 = this.vac_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.yac_1 = this.wac_1;
            this.zac_1 = null;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 10;
            this.z9_1 = 9;
            var tmp_2 = this;
            tmp_2.bad_1 = this.yac_1;
            this.cad_1 = this.bad_1;
            this.dad_1 = this.cad_1.k();
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.y9_1 = 5;
            suspendResult = this.dad_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.y9_1 = 7;
              continue $sm;
            }

            this.ead_1 = this.dad_1.m();
            var tmp_3 = this;
            tmp_3.fad_1 = this.ead_1;
            this.gad_1 = this.fad_1;
            this.had_1 = Default_getInstance_0().d5e(Companion_getInstance_164().h67(), this.gad_1);
            this.y9_1 = 6;
            suspendResult = this.sac_1.za9_1.z1b(Binary_init_$Create$(true, this.had_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.y9_1 = 4;
            continue $sm;
          case 7:
            var tmp_4 = this;
            tmp_4.aad_1 = Unit_instance;
            this.y9_1 = 8;
            var tmp_5 = this;
            continue $sm;
          case 8:
            this.z9_1 = 13;
            var tmp_6 = this;
            cancelConsumed(this.yac_1, this.zac_1);
            tmp_6.xac_1 = Unit_instance;
            this.y9_1 = 12;
            continue $sm;
          case 9:
            this.z9_1 = 10;
            var tmp_7 = this.ba_1;
            if (tmp_7 instanceof Error) {
              var e = this.ba_1;
              var tmp_8 = this;
              this.zac_1 = e;
              throw e;
            } else {
              throw this.ba_1;
            }

          case 10:
            this.z9_1 = 13;
            var t = this.ba_1;
            cancelConsumed(this.yac_1, this.zac_1);
            throw t;
          case 11:
            this.z9_1 = 13;
            cancelConsumed(this.yac_1, this.zac_1);
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 12;
            continue $sm;
          case 12:
            this.z9_1 = 14;
            this.y9_1 = 15;
            continue $sm;
          case 13:
            this.z9_1 = 14;
            var tmp_9 = this.ba_1;
            if (tmp_9 instanceof ClosedSendChannelException) {
              var e_0 = this.ba_1;
              this.y9_1 = 15;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 14:
            throw this.ba_1;
          case 15:
            this.z9_1 = 14;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.z9_1 === 14) {
          throw e_1;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(rpcSession$slambda$slambda_1).i1l = function ($this$launch, completion) {
    var i = new rpcSession$slambda$slambda_1(this.rac_1, this.sac_1, completion);
    i.tac_1 = $this$launch;
    return i;
  };
  function rpcSession$slambda$slambda_2($outgoing, $wsSession, resultContinuation) {
    var i = new rpcSession$slambda$slambda_1($outgoing, $wsSession, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function rpcSession$slambda($launcher, $initiationHandler, $initiationJob, $incoming, $outgoing, resultContinuation) {
    this.qad_1 = $launcher;
    this.rad_1 = $initiationHandler;
    this.sad_1 = $initiationJob;
    this.tad_1 = $incoming;
    this.uad_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(rpcSession$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(rpcSession$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(rpcSession$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var wsSession = this.qad_1(this.vad_1);
          this.rad_1.ja9(this.vad_1, wsSession, this.sad_1);
          launch(this.vad_1, VOID, VOID, rpcSession$slambda$slambda_0(this.sad_1, wsSession, this.tad_1, null));
          launch(this.vad_1, VOID, VOID, rpcSession$slambda$slambda_2(this.uad_1, wsSession, null));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(rpcSession$slambda).i1l = function ($this$launch, completion) {
    var i = new rpcSession$slambda(this.qad_1, this.rad_1, this.sad_1, this.tad_1, this.uad_1, completion);
    i.vad_1 = $this$launch;
    return i;
  };
  function rpcSession$slambda_0($launcher, $initiationHandler, $initiationJob, $incoming, $outgoing, resultContinuation) {
    var i = new rpcSession$slambda($launcher, $initiationHandler, $initiationJob, $incoming, $outgoing, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function get_WS_SESSION_RECONNECT_DURATION() {
    _init_properties_WsSession_kt__dx1ve0();
    return WS_SESSION_RECONNECT_DURATION;
  }
  var WS_SESSION_RECONNECT_DURATION;
  function WsSession(incoming, outgoing) {
    this.ya9_1 = incoming;
    this.za9_1 = outgoing;
  }
  protoOf(WsSession).toString = function () {
    return 'WsSession(incoming=' + toString_1(this.ya9_1) + ', outgoing=' + toString_1(this.za9_1) + ')';
  };
  protoOf(WsSession).hashCode = function () {
    var result = hashCode(this.ya9_1);
    result = imul(result, 31) + hashCode(this.za9_1) | 0;
    return result;
  };
  protoOf(WsSession).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WsSession))
      return false;
    var tmp0_other_with_cast = other instanceof WsSession ? other : THROW_CCE();
    if (!equals(this.ya9_1, tmp0_other_with_cast.ya9_1))
      return false;
    if (!equals(this.za9_1, tmp0_other_with_cast.za9_1))
      return false;
    return true;
  };
  function WsSessionScope$bind$slambda$slambda($incoming, this$0, resultContinuation) {
    this.eae_1 = $incoming;
    this.fae_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSessionScope$bind$slambda$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(WsSessionScope$bind$slambda$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WsSessionScope$bind$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 11;
            var tmp_0 = this;
            tmp_0.hae_1 = this.eae_1;
            this.iae_1 = this.hae_1;
            var tmp_1 = this;
            tmp_1.jae_1 = this.iae_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.lae_1 = this.jae_1;
            this.mae_1 = null;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 10;
            this.z9_1 = 9;
            var tmp_2 = this;
            tmp_2.oae_1 = this.lae_1;
            this.pae_1 = this.oae_1;
            this.qae_1 = this.pae_1.k();
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.y9_1 = 5;
            suspendResult = this.qae_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.y9_1 = 7;
              continue $sm;
            }

            this.rae_1 = this.qae_1.m();
            var tmp_3 = this;
            tmp_3.sae_1 = this.rae_1;
            this.tae_1 = this.sae_1;
            this.y9_1 = 6;
            suspendResult = this.fae_1.vae_1.z1b(this.tae_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.y9_1 = 4;
            continue $sm;
          case 7:
            var tmp_4 = this;
            tmp_4.nae_1 = Unit_instance;
            this.z9_1 = 11;
            this.y9_1 = 8;
            var tmp_5 = this;
            continue $sm;
          case 8:
            this.z9_1 = 11;
            var tmp_6 = this;
            cancelConsumed(this.lae_1, this.mae_1);
            tmp_6.kae_1 = Unit_instance;
            this.y9_1 = 13;
            continue $sm;
          case 9:
            this.z9_1 = 10;
            var tmp_7 = this.ba_1;
            if (tmp_7 instanceof Error) {
              var e = this.ba_1;
              var tmp_8 = this;
              this.mae_1 = e;
              throw e;
            } else {
              throw this.ba_1;
            }

          case 10:
            this.z9_1 = 11;
            var t = this.ba_1;
            cancelConsumed(this.lae_1, this.mae_1);
            throw t;
          case 11:
            throw this.ba_1;
          case 12:
            this.z9_1 = 11;
            cancelConsumed(this.lae_1, this.mae_1);
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 13;
            continue $sm;
          case 13:
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 11) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(WsSessionScope$bind$slambda$slambda).i1l = function ($this$launch, completion) {
    var i = new WsSessionScope$bind$slambda$slambda(this.eae_1, this.fae_1, completion);
    i.gae_1 = $this$launch;
    return i;
  };
  function WsSessionScope$bind$slambda$slambda_0($incoming, this$0, resultContinuation) {
    var i = new WsSessionScope$bind$slambda$slambda($incoming, this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WsSessionScope$bind$slambda$slambda_1(this$0, $outgoing, resultContinuation) {
    this.faf_1 = this$0;
    this.gaf_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSessionScope$bind$slambda$slambda_1).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(WsSessionScope$bind$slambda$slambda_1).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WsSessionScope$bind$slambda$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 11;
            var tmp_0 = this;
            tmp_0.iaf_1 = this.faf_1.wae_1;
            this.jaf_1 = this.iaf_1;
            var tmp_1 = this;
            tmp_1.kaf_1 = this.jaf_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.maf_1 = this.kaf_1;
            this.naf_1 = null;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 10;
            this.z9_1 = 9;
            var tmp_2 = this;
            tmp_2.paf_1 = this.maf_1;
            this.qaf_1 = this.paf_1;
            this.raf_1 = this.qaf_1.k();
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.y9_1 = 5;
            suspendResult = this.raf_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.y9_1 = 7;
              continue $sm;
            }

            this.saf_1 = this.raf_1.m();
            var tmp_3 = this;
            tmp_3.taf_1 = this.saf_1;
            this.uaf_1 = this.taf_1;
            this.y9_1 = 6;
            suspendResult = this.gaf_1.z1b(this.uaf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.y9_1 = 4;
            continue $sm;
          case 7:
            var tmp_4 = this;
            tmp_4.oaf_1 = Unit_instance;
            this.z9_1 = 11;
            this.y9_1 = 8;
            var tmp_5 = this;
            continue $sm;
          case 8:
            this.z9_1 = 11;
            var tmp_6 = this;
            cancelConsumed(this.maf_1, this.naf_1);
            tmp_6.laf_1 = Unit_instance;
            this.y9_1 = 13;
            continue $sm;
          case 9:
            this.z9_1 = 10;
            var tmp_7 = this.ba_1;
            if (tmp_7 instanceof Error) {
              var e = this.ba_1;
              var tmp_8 = this;
              this.naf_1 = e;
              throw e;
            } else {
              throw this.ba_1;
            }

          case 10:
            this.z9_1 = 11;
            var t = this.ba_1;
            cancelConsumed(this.maf_1, this.naf_1);
            throw t;
          case 11:
            throw this.ba_1;
          case 12:
            this.z9_1 = 11;
            cancelConsumed(this.maf_1, this.naf_1);
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 13;
            continue $sm;
          case 13:
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 11) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(WsSessionScope$bind$slambda$slambda_1).i1l = function ($this$launch, completion) {
    var i = new WsSessionScope$bind$slambda$slambda_1(this.faf_1, this.gaf_1, completion);
    i.haf_1 = $this$launch;
    return i;
  };
  function WsSessionScope$bind$slambda$slambda_2(this$0, $outgoing, resultContinuation) {
    var i = new WsSessionScope$bind$slambda$slambda_1(this$0, $outgoing, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WsSessionScope$bind$slambda$slambda_3(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSessionScope$bind$slambda$slambda_3).dag = function ($completion) {
    var tmp = this.eag($completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(WsSessionScope$bind$slambda$slambda_3).fag = function ($completion) {
    return this.dag($completion);
  };
  protoOf(WsSessionScope$bind$slambda$slambda_3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(WsSessionScope$bind$slambda$slambda_3).eag = function (completion) {
    return new WsSessionScope$bind$slambda$slambda_3(completion);
  };
  function WsSessionScope$bind$slambda$slambda_4(resultContinuation) {
    var i = new WsSessionScope$bind$slambda$slambda_3(resultContinuation);
    var l = function ($completion) {
      return i.dag($completion);
    };
    l.$arity = 0;
    return l;
  }
  function WsSessionScope$bind$slambda$slambda_5(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSessionScope$bind$slambda$slambda_5).dag = function ($completion) {
    var tmp = this.eag($completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(WsSessionScope$bind$slambda$slambda_5).fag = function ($completion) {
    return this.dag($completion);
  };
  protoOf(WsSessionScope$bind$slambda$slambda_5).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(WsSessionScope$bind$slambda$slambda_5).eag = function (completion) {
    return new WsSessionScope$bind$slambda$slambda_5(completion);
  };
  function WsSessionScope$bind$slambda$slambda_6(resultContinuation) {
    var i = new WsSessionScope$bind$slambda$slambda_5(resultContinuation);
    var l = function ($completion) {
      return i.dag($completion);
    };
    l.$arity = 0;
    return l;
  }
  function WsSessionScope$bind$slambda(this$0, $connectionJob, $bindingJob, $incoming, $outgoing, resultContinuation) {
    this.wag_1 = this$0;
    this.xag_1 = $connectionJob;
    this.yag_1 = $bindingJob;
    this.zag_1 = $incoming;
    this.aah_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSessionScope$bind$slambda).h1l = function ($this$withContext, $completion) {
    var tmp = this.i1l($this$withContext, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(WsSessionScope$bind$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WsSessionScope$bind$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            launch(this.bah_1, VOID, VOID, WsSessionScope$bind$slambda$slambda_0(this.zag_1, this.wag_1, null));
            launch(this.bah_1, VOID, VOID, WsSessionScope$bind$slambda$slambda_2(this.wag_1, this.aah_1, null));
            var tmp_0 = this;
            tmp_0.cah_1 = new SelectImplementation(this.ea());
            this.dah_1 = this.cah_1;
            var tmp_1 = this;
            tmp_1.eah_1 = this.dah_1;
            this.fah_1 = this.eah_1;
            var $this$select = this.fah_1;
            var tmp_2 = this.wag_1.uae_1.lu();
            $this$select.x24(tmp_2, WsSessionScope$bind$slambda$slambda_4(null));
            var tmp_3 = this.xag_1.lu();
            $this$select.x24(tmp_3, WsSessionScope$bind$slambda$slambda_6(null));
            this.y9_1 = 1;
            suspendResult = this.fah_1.w24(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.wag_1.vae_1.i1c();
            this.wag_1.wae_1.k1c();
            this.yag_1.pu();
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(WsSessionScope$bind$slambda).i1l = function ($this$withContext, completion) {
    var i = new WsSessionScope$bind$slambda(this.wag_1, this.xag_1, this.yag_1, this.zag_1, this.aah_1, completion);
    i.bah_1 = $this$withContext;
    return i;
  };
  function WsSessionScope$bind$slambda_0(this$0, $connectionJob, $bindingJob, $incoming, $outgoing, resultContinuation) {
    var i = new WsSessionScope$bind$slambda(this$0, $connectionJob, $bindingJob, $incoming, $outgoing, resultContinuation);
    var l = function ($this$withContext, $completion) {
      return i.h1l($this$withContext, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WsSessionScope(sessionJob, sessionIncoming, sessionOutgoing) {
    this.uae_1 = sessionJob;
    this.vae_1 = sessionIncoming;
    this.wae_1 = sessionOutgoing;
  }
  protoOf(WsSessionScope).gah = function (incoming, outgoing, connectionJob, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.ea();
    var bindingJob = Job_0(get_job(tmp$ret$0));
    return withContext(bindingJob, WsSessionScope$bind$slambda_0(this, connectionJob, bindingJob, incoming, outgoing, null), $completion);
  };
  function WsSessionProvider(_this__u8e3s4, session) {
    _init_properties_WsSession_kt__dx1ve0();
    return produce_0(_this__u8e3s4, VOID, VOID, WsSessionProvider$slambda_0(session, null));
  }
  function WsSession_0(_this__u8e3s4, body) {
    _init_properties_WsSession_kt__dx1ve0();
    var sessionIncoming = Channel();
    var sessionOutgoing = Channel();
    var sessionJob = Job_0(get_job(_this__u8e3s4.et()));
    launch(_this__u8e3s4, VOID, VOID, WsSession$slambda_0(body, sessionJob, sessionIncoming, sessionOutgoing, null));
    return new WsSession(sessionIncoming, sessionOutgoing);
  }
  function WsSessionProvider$slambda$lambda($session) {
    return function ($this$send) {
      return WsSession_0($this$send, $session);
    };
  }
  function WsSessionProvider$slambda$lambda_0($session) {
    return function ($this$send) {
      return WsSession_0($this$send, $session);
    };
  }
  function WsSessionProvider$slambda($session, resultContinuation) {
    this.pah_1 = $session;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSessionProvider$slambda).rah = function ($this$produce, $completion) {
    var tmp = this.sah($this$produce, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(WsSessionProvider$slambda).oa = function (p1, $completion) {
    return this.rah((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WsSessionProvider$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            this.y9_1 = 1;
            var tmp_0 = this.qah_1.y15();
            suspendResult = tmp_0.z1b(WsSessionProvider$slambda$lambda(this.pah_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!get_isActive_0(this.qah_1.et())) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.y9_1 = 3;
            suspendResult = delay_0(get_WS_SESSION_RECONNECT_DURATION(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.y9_1 = 4;
            var tmp_1 = this.qah_1.y15();
            suspendResult = tmp_1.z1b(WsSessionProvider$slambda$lambda_0(this.pah_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.y9_1 = 2;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(WsSessionProvider$slambda).sah = function ($this$produce, completion) {
    var i = new WsSessionProvider$slambda(this.pah_1, completion);
    i.qah_1 = $this$produce;
    return i;
  };
  function WsSessionProvider$slambda_0($session, resultContinuation) {
    var i = new WsSessionProvider$slambda($session, resultContinuation);
    var l = function ($this$produce, $completion) {
      return i.rah($this$produce, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WsSession$slambda($body, $sessionJob, $sessionIncoming, $sessionOutgoing, resultContinuation) {
    this.bai_1 = $body;
    this.cai_1 = $sessionJob;
    this.dai_1 = $sessionIncoming;
    this.eai_1 = $sessionOutgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WsSession$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(WsSession$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WsSession$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.bai_1(new WsSessionScope(this.cai_1, this.dai_1, this.eai_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(WsSession$slambda).i1l = function ($this$launch, completion) {
    var i = new WsSession$slambda(this.bai_1, this.cai_1, this.dai_1, this.eai_1, completion);
    i.fai_1 = $this$launch;
    return i;
  };
  function WsSession$slambda_0($body, $sessionJob, $sessionIncoming, $sessionOutgoing, resultContinuation) {
    var i = new WsSession$slambda($body, $sessionJob, $sessionIncoming, $sessionOutgoing, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var properties_initialized_WsSession_kt_f6mf4a;
  function _init_properties_WsSession_kt__dx1ve0() {
    if (!properties_initialized_WsSession_kt_f6mf4a) {
      properties_initialized_WsSession_kt_f6mf4a = true;
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance_16();
      WS_SESSION_RECONNECT_DURATION = toDuration(30, DurationUnit_SECONDS_getInstance());
    }
  }
  function Companion_169() {
    Companion_instance_169 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.gai_1 = [new ArrayListSerializer($serializer_getInstance()), new ArrayListSerializer($serializer_getInstance_15())];
  }
  var Companion_instance_169;
  function Companion_getInstance_169() {
    if (Companion_instance_169 == null)
      new Companion_169();
    return Companion_instance_169;
  }
  function $serializer_16() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.NodeResolveInfo', this, 2);
    tmp0_serialDesc.t5n('targets', true);
    tmp0_serialDesc.t5n('references', true);
    this.hai_1 = tmp0_serialDesc;
  }
  protoOf($serializer_16).iai = function (encoder, value) {
    var tmp0_desc = this.hai_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    var tmp2_cached = Companion_getInstance_169().gai_1;
    if (tmp1_output.e5i(tmp0_desc, 0) ? true : !equals(value.jai_1, emptyList())) {
      tmp1_output.z5h(tmp0_desc, 0, tmp2_cached[0], value.jai_1);
    }
    if (tmp1_output.e5i(tmp0_desc, 1) ? true : !equals(value.kai_1, emptyList())) {
      tmp1_output.z5h(tmp0_desc, 1, tmp2_cached[1], value.kai_1);
    }
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_16).j5d = function (encoder, value) {
    return this.iai(encoder, value instanceof NodeResolveInfo ? value : THROW_CCE());
  };
  protoOf($serializer_16).k5d = function (decoder) {
    var tmp0_desc = this.hai_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    var tmp7_cached = Companion_getInstance_169().gai_1;
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return NodeResolveInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_16).w5c = function () {
    return this.hai_1;
  };
  protoOf($serializer_16).i5o = function () {
    var tmp0_cached = Companion_getInstance_169().gai_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1]];
  };
  var $serializer_instance_14;
  function $serializer_getInstance_14() {
    if ($serializer_instance_14 == null)
      new $serializer_16();
    return $serializer_instance_14;
  }
  function NodeResolveInfo_init_$Init$(seen0, targets, references, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_14().hai_1);
    }
    if (0 === (seen0 & 1))
      $this.jai_1 = emptyList();
    else
      $this.jai_1 = targets;
    if (0 === (seen0 & 2))
      $this.kai_1 = emptyList();
    else
      $this.kai_1 = references;
    return $this;
  }
  function NodeResolveInfo_init_$Create$(seen0, targets, references, serializationConstructorMarker) {
    return NodeResolveInfo_init_$Init$(seen0, targets, references, serializationConstructorMarker, objectCreate(protoOf(NodeResolveInfo)));
  }
  function NodeResolveInfo(targets, references) {
    Companion_getInstance_169();
    targets = targets === VOID ? emptyList() : targets;
    references = references === VOID ? emptyList() : references;
    this.jai_1 = targets;
    this.kai_1 = references;
  }
  protoOf(NodeResolveInfo).toString = function () {
    return 'NodeResolveInfo(targets=' + toString_1(this.jai_1) + ', references=' + toString_1(this.kai_1) + ')';
  };
  protoOf(NodeResolveInfo).hashCode = function () {
    var result = hashCode(this.jai_1);
    result = imul(result, 31) + hashCode(this.kai_1) | 0;
    return result;
  };
  protoOf(NodeResolveInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeResolveInfo))
      return false;
    var tmp0_other_with_cast = other instanceof NodeResolveInfo ? other : THROW_CCE();
    if (!equals(this.jai_1, tmp0_other_with_cast.jai_1))
      return false;
    if (!equals(this.kai_1, tmp0_other_with_cast.kai_1))
      return false;
    return true;
  };
  function $serializer_17() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.SerializedReference', this, 2);
    tmp0_serialDesc.t5n('location', false);
    tmp0_serialDesc.t5n('value', false);
    this.lai_1 = tmp0_serialDesc;
  }
  protoOf($serializer_17).mai = function (encoder, value) {
    var tmp0_desc = this.lai_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.z5h(tmp0_desc, 0, $serializer_getInstance_16(), value.nai_1);
    tmp1_output.z5h(tmp0_desc, 1, $serializer_getInstance_17(), value.oai_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_17).j5d = function (encoder, value) {
    return this.mai(encoder, value instanceof SerializedReference ? value : THROW_CCE());
  };
  protoOf($serializer_17).k5d = function (decoder) {
    var tmp0_desc = this.lai_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, $serializer_getInstance_16(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, $serializer_getInstance_17(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, $serializer_getInstance_16(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, $serializer_getInstance_17(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return SerializedReference_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_17).w5c = function () {
    return this.lai_1;
  };
  protoOf($serializer_17).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_16(), $serializer_getInstance_17()];
  };
  var $serializer_instance_15;
  function $serializer_getInstance_15() {
    if ($serializer_instance_15 == null)
      new $serializer_17();
    return $serializer_instance_15;
  }
  function SerializedReference_init_$Init$(seen0, location, value, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_15().lai_1);
    }
    $this.nai_1 = location;
    $this.oai_1 = value;
    return $this;
  }
  function SerializedReference_init_$Create$(seen0, location, value, serializationConstructorMarker) {
    return SerializedReference_init_$Init$(seen0, location, value, serializationConstructorMarker, objectCreate(protoOf(SerializedReference)));
  }
  function SerializedReference() {
  }
  protoOf(SerializedReference).toString = function () {
    return 'SerializedReference(location=' + this.nai_1.toString() + ', value=' + this.oai_1.toString() + ')';
  };
  protoOf(SerializedReference).hashCode = function () {
    var result = this.nai_1.hashCode();
    result = imul(result, 31) + this.oai_1.hashCode() | 0;
    return result;
  };
  protoOf(SerializedReference).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedReference))
      return false;
    var tmp0_other_with_cast = other instanceof SerializedReference ? other : THROW_CCE();
    if (!this.nai_1.equals(tmp0_other_with_cast.nai_1))
      return false;
    if (!this.oai_1.equals(tmp0_other_with_cast.oai_1))
      return false;
    return true;
  };
  function Companion_170() {
  }
  var Companion_instance_170;
  function Companion_getInstance_170() {
    return Companion_instance_170;
  }
  function $serializer_18() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.SerializedReferenceLocation', this, 2);
    tmp0_serialDesc.t5n('source', false);
    tmp0_serialDesc.t5n('tag', false);
    this.pai_1 = tmp0_serialDesc;
  }
  protoOf($serializer_18).qai = function (encoder, value) {
    var tmp0_desc = this.pai_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.z5h(tmp0_desc, 0, NodePointerSerializer_getInstance(), value.rai_1);
    tmp1_output.x5h(tmp0_desc, 1, value.sai_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_18).j5d = function (encoder, value) {
    return this.qai(encoder, value instanceof SerializedReferenceLocation ? value : THROW_CCE());
  };
  protoOf($serializer_18).k5d = function (decoder) {
    var tmp0_desc = this.pai_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.t5g(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.t5g(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return SerializedReferenceLocation_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_18).w5c = function () {
    return this.pai_1;
  };
  protoOf($serializer_18).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [NodePointerSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_16;
  function $serializer_getInstance_16() {
    if ($serializer_instance_16 == null)
      new $serializer_18();
    return $serializer_instance_16;
  }
  function SerializedReferenceLocation_init_$Init$(seen0, source, tag, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_16().pai_1);
    }
    $this.rai_1 = source;
    $this.sai_1 = tag;
    return $this;
  }
  function SerializedReferenceLocation_init_$Create$(seen0, source, tag, serializationConstructorMarker) {
    return SerializedReferenceLocation_init_$Init$(seen0, source, tag, serializationConstructorMarker, objectCreate(protoOf(SerializedReferenceLocation)));
  }
  function SerializedReferenceLocation(source, tag) {
    this.rai_1 = source;
    this.sai_1 = tag;
  }
  protoOf(SerializedReferenceLocation).toString = function () {
    return 'SerializedReferenceLocation(source=' + this.rai_1.toString() + ', tag=' + this.sai_1 + ')';
  };
  protoOf(SerializedReferenceLocation).hashCode = function () {
    var result = this.rai_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.sai_1) | 0;
    return result;
  };
  protoOf(SerializedReferenceLocation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedReferenceLocation))
      return false;
    var tmp0_other_with_cast = other instanceof SerializedReferenceLocation ? other : THROW_CCE();
    if (!this.rai_1.equals(tmp0_other_with_cast.rai_1))
      return false;
    if (!(this.sai_1 === tmp0_other_with_cast.sai_1))
      return false;
    return true;
  };
  function Companion_171() {
    Companion_instance_171 = this;
    this.tai_1 = new SerializedReferenceValue();
  }
  var Companion_instance_171;
  function Companion_getInstance_171() {
    if (Companion_instance_171 == null)
      new Companion_171();
    return Companion_instance_171;
  }
  function $serializer_19() {
    $serializer_instance_17 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.SerializedReferenceValue', this, 2);
    tmp0_serialDesc.t5n('resolveResult', true);
    tmp0_serialDesc.t5n('findResult', true);
    this.uai_1 = tmp0_serialDesc;
  }
  protoOf($serializer_19).vai = function (encoder, value) {
    var tmp0_desc = this.uai_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    if (tmp1_output.e5i(tmp0_desc, 0) ? true : !(value.wai_1 == null)) {
      tmp1_output.a5i(tmp0_desc, 0, NodePointerSerializer_getInstance(), value.wai_1);
    }
    if (tmp1_output.e5i(tmp0_desc, 1) ? true : !(value.xai_1 == null)) {
      tmp1_output.a5i(tmp0_desc, 1, NodePointerSerializer_getInstance(), value.xai_1);
    }
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_19).j5d = function (encoder, value) {
    return this.vai(encoder, value instanceof SerializedReferenceValue ? value : THROW_CCE());
  };
  protoOf($serializer_19).k5d = function (decoder) {
    var tmp0_desc = this.uai_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.x5g(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.x5g(tmp0_desc, 1, NodePointerSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.x5g(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.x5g(tmp0_desc, 1, NodePointerSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return SerializedReferenceValue_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_19).w5c = function () {
    return this.uai_1;
  };
  protoOf($serializer_19).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(NodePointerSerializer_getInstance()), get_nullable(NodePointerSerializer_getInstance())];
  };
  var $serializer_instance_17;
  function $serializer_getInstance_17() {
    if ($serializer_instance_17 == null)
      new $serializer_19();
    return $serializer_instance_17;
  }
  function SerializedReferenceValue_init_$Init$(seen0, resolveResult, findResult, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_17().uai_1);
    }
    if (0 === (seen0 & 1))
      $this.wai_1 = null;
    else
      $this.wai_1 = resolveResult;
    if (0 === (seen0 & 2))
      $this.xai_1 = null;
    else
      $this.xai_1 = findResult;
    return $this;
  }
  function SerializedReferenceValue_init_$Create$(seen0, resolveResult, findResult, serializationConstructorMarker) {
    return SerializedReferenceValue_init_$Init$(seen0, resolveResult, findResult, serializationConstructorMarker, objectCreate(protoOf(SerializedReferenceValue)));
  }
  function SerializedReferenceValue(resolveResult, findResult) {
    Companion_getInstance_171();
    resolveResult = resolveResult === VOID ? null : resolveResult;
    findResult = findResult === VOID ? null : findResult;
    this.wai_1 = resolveResult;
    this.xai_1 = findResult;
  }
  protoOf(SerializedReferenceValue).toString = function () {
    return 'SerializedReferenceValue(resolveResult=' + toString_0(this.wai_1) + ', findResult=' + toString_0(this.xai_1) + ')';
  };
  protoOf(SerializedReferenceValue).hashCode = function () {
    var result = this.wai_1 == null ? 0 : this.wai_1.hashCode();
    result = imul(result, 31) + (this.xai_1 == null ? 0 : this.xai_1.hashCode()) | 0;
    return result;
  };
  protoOf(SerializedReferenceValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedReferenceValue))
      return false;
    var tmp0_other_with_cast = other instanceof SerializedReferenceValue ? other : THROW_CCE();
    if (!equals(this.wai_1, tmp0_other_with_cast.wai_1))
      return false;
    if (!equals(this.xai_1, tmp0_other_with_cast.xai_1))
      return false;
    return true;
  };
  function nodeResolutionMethod(_this__u8e3s4, id, parameterSerializer, handle) {
    var tmp = get_withFacade(parameterSerializer);
    var tmp_0 = Serializer_getInstance();
    var tmp_1 = Companion_getInstance_175().h67();
    var tmp_2 = mixinFacade(flowBasedMethod(_this__u8e3s4, id, tmp, tmp_0, tmp_1, nodeResolutionMethod$slambda_0(handle, null)));
    return mapResult(tmp_2, nodeResolutionMethod$lambda);
  }
  function nodeResolutionMethod$slambda($handle, resultContinuation) {
    this.haj_1 = $handle;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(nodeResolutionMethod$slambda).naj = function (instance, _destruct__k2r9zo, $completion) {
    var tmp = this.oaj(instance, _destruct__k2r9zo, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(nodeResolutionMethod$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE();
    return this.naj(tmp, p2 instanceof RpcFacadeMixin ? p2 : THROW_CCE(), $completion);
  };
  protoOf(nodeResolutionMethod$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.kaj_1 = this.jaj_1.ug();
            this.laj_1 = this.jaj_1.vg();
            this.y9_1 = 1;
            suspendResult = this.haj_1(this.iaj_1, this.laj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.maj_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.kaj_1.m9l(this.maj_1.qaj_1, Companion_getInstance_178(), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var completionPublication = suspendResult;
            return to(completionPublication, this.maj_1.paj_1);
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(nodeResolutionMethod$slambda).oaj = function (instance, _destruct__k2r9zo, completion) {
    var i = new nodeResolutionMethod$slambda(this.haj_1, completion);
    i.iaj_1 = instance;
    i.jaj_1 = _destruct__k2r9zo;
    return i;
  };
  function nodeResolutionMethod$slambda_0($handle, resultContinuation) {
    var i = new nodeResolutionMethod$slambda($handle, resultContinuation);
    var l = function (instance, _destruct__k2r9zo, $completion) {
      return i.naj(instance, _destruct__k2r9zo, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function nodeResolutionMethod$lambda(_destruct__k2r9zo) {
    var completionPublication = _destruct__k2r9zo.ug();
    var messages = _destruct__k2r9zo.vg();
    return new NodeResolutionProvider(messages, completionPublication.b2p());
  }
  function Companion_172() {
    Companion_instance_172 = this;
    this.raj_1 = new NodeResolutionProvider(emptyFlow(), Empty_instance_2);
  }
  var Companion_instance_172;
  function Companion_getInstance_172() {
    if (Companion_instance_172 == null)
      new Companion_172();
    return Companion_instance_172;
  }
  function NodeResolutionProvider(messages, completion) {
    Companion_getInstance_172();
    this.paj_1 = messages;
    this.qaj_1 = completion;
  }
  protoOf(NodeResolutionProvider).toString = function () {
    return 'NodeResolutionProvider(messages=' + toString_1(this.paj_1) + ', completion=' + toString_1(this.qaj_1) + ')';
  };
  protoOf(NodeResolutionProvider).hashCode = function () {
    var result = hashCode(this.paj_1);
    result = imul(result, 31) + hashCode(this.qaj_1) | 0;
    return result;
  };
  protoOf(NodeResolutionProvider).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeResolutionProvider))
      return false;
    var tmp0_other_with_cast = other instanceof NodeResolutionProvider ? other : THROW_CCE();
    if (!equals(this.paj_1, tmp0_other_with_cast.paj_1))
      return false;
    if (!equals(this.qaj_1, tmp0_other_with_cast.qaj_1))
      return false;
    return true;
  };
  function Companion_173() {
  }
  var Companion_instance_173;
  function Companion_getInstance_173() {
    return Companion_instance_173;
  }
  function $serializer_20() {
    $serializer_instance_18 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.live.NodeResolveInfoMessage.StateReceived', this, 1);
    tmp0_serialDesc.t5n('info', false);
    this.saj_1 = tmp0_serialDesc;
  }
  protoOf($serializer_20).taj = function (encoder, value) {
    var tmp0_desc = this.saj_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.z5h(tmp0_desc, 0, $serializer_getInstance_14(), value.uaj_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_20).j5d = function (encoder, value) {
    return this.taj(encoder, value instanceof StateReceived ? value : THROW_CCE());
  };
  protoOf($serializer_20).k5d = function (decoder) {
    var tmp0_desc = this.saj_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.j5g(tmp0_desc);
    if (tmp5_input.y5g()) {
      tmp4_local0 = tmp5_input.v5g(tmp0_desc, 0, $serializer_getInstance_14(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.v5g(tmp0_desc, 0, $serializer_getInstance_14(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.k5g(tmp0_desc);
    return StateReceived_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_20).w5c = function () {
    return this.saj_1;
  };
  protoOf($serializer_20).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_14()];
  };
  var $serializer_instance_18;
  function $serializer_getInstance_18() {
    if ($serializer_instance_18 == null)
      new $serializer_20();
    return $serializer_instance_18;
  }
  function StateReceived_init_$Init$(seen0, info, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_18().saj_1);
    }
    NodeResolveInfoMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.uaj_1 = info;
    return $this;
  }
  function StateReceived_init_$Create$(seen0, info, serializationConstructorMarker) {
    return StateReceived_init_$Init$(seen0, info, serializationConstructorMarker, objectCreate(protoOf(StateReceived)));
  }
  function Companion_174() {
  }
  var Companion_instance_174;
  function Companion_getInstance_174() {
    return Companion_instance_174;
  }
  function $serializer_21() {
    $serializer_instance_19 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.live.NodeResolveInfoMessage.UpdateReceived', this, 1);
    tmp0_serialDesc.t5n('update', false);
    this.vaj_1 = tmp0_serialDesc;
  }
  protoOf($serializer_21).waj = function (encoder, value) {
    var tmp0_desc = this.vaj_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.z5h(tmp0_desc, 0, $serializer_getInstance_20(), value.xaj_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_21).j5d = function (encoder, value) {
    return this.waj(encoder, value instanceof UpdateReceived ? value : THROW_CCE());
  };
  protoOf($serializer_21).k5d = function (decoder) {
    var tmp0_desc = this.vaj_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.j5g(tmp0_desc);
    if (tmp5_input.y5g()) {
      tmp4_local0 = tmp5_input.v5g(tmp0_desc, 0, $serializer_getInstance_20(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.v5g(tmp0_desc, 0, $serializer_getInstance_20(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.k5g(tmp0_desc);
    return UpdateReceived_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_21).w5c = function () {
    return this.vaj_1;
  };
  protoOf($serializer_21).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_20()];
  };
  var $serializer_instance_19;
  function $serializer_getInstance_19() {
    if ($serializer_instance_19 == null)
      new $serializer_21();
    return $serializer_instance_19;
  }
  function UpdateReceived_init_$Init$(seen0, update, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_19().vaj_1);
    }
    NodeResolveInfoMessage_init_$Init$(seen0, serializationConstructorMarker, $this);
    $this.xaj_1 = update;
    return $this;
  }
  function UpdateReceived_init_$Create$(seen0, update, serializationConstructorMarker) {
    return UpdateReceived_init_$Init$(seen0, update, serializationConstructorMarker, objectCreate(protoOf(UpdateReceived)));
  }
  function _get_$cachedSerializer__te6jhj_4($this) {
    return $this.yai_1.y();
  }
  function NodeResolveInfoMessage$Companion$_anonymous__e62eyo() {
    var tmp = getKClass(NodeResolveInfoMessage);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(StateReceived), getKClass(UpdateReceived)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_18(), $serializer_getInstance_19()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    return SealedClassSerializer_init_$Create$('jetbrains.ocelot.langDef.references.remote.live.NodeResolveInfoMessage', tmp, tmp_0, tmp_1, tmp$ret$8);
  }
  function StateReceived(info) {
    NodeResolveInfoMessage.call(this);
    this.uaj_1 = info;
  }
  protoOf(StateReceived).toString = function () {
    return 'StateReceived(info=' + this.uaj_1.toString() + ')';
  };
  protoOf(StateReceived).hashCode = function () {
    return this.uaj_1.hashCode();
  };
  protoOf(StateReceived).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StateReceived))
      return false;
    var tmp0_other_with_cast = other instanceof StateReceived ? other : THROW_CCE();
    if (!this.uaj_1.equals(tmp0_other_with_cast.uaj_1))
      return false;
    return true;
  };
  function UpdateReceived(update) {
    NodeResolveInfoMessage.call(this);
    this.xaj_1 = update;
  }
  protoOf(UpdateReceived).toString = function () {
    return 'UpdateReceived(update=' + this.xaj_1.toString() + ')';
  };
  protoOf(UpdateReceived).hashCode = function () {
    return this.xaj_1.hashCode();
  };
  protoOf(UpdateReceived).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateReceived))
      return false;
    var tmp0_other_with_cast = other instanceof UpdateReceived ? other : THROW_CCE();
    if (!this.xaj_1.equals(tmp0_other_with_cast.xaj_1))
      return false;
    return true;
  };
  function Companion_175() {
    Companion_instance_175 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.yai_1 = lazy(tmp_0, NodeResolveInfoMessage$Companion$_anonymous__e62eyo);
  }
  protoOf(Companion_175).h67 = function () {
    return _get_$cachedSerializer__te6jhj_4(this);
  };
  protoOf(Companion_175).t5o = function (typeParamsSerializers) {
    return this.h67();
  };
  var Companion_instance_175;
  function Companion_getInstance_175() {
    if (Companion_instance_175 == null)
      new Companion_175();
    return Companion_instance_175;
  }
  function NodeResolveInfoMessage_init_$Init$(seen0, serializationConstructorMarker, $this) {
    return $this;
  }
  function NodeResolveInfoMessage() {
    Companion_getInstance_175();
  }
  function Companion_176() {
    Companion_instance_176 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.yaj_1 = [new ArrayListSerializer($serializer_getInstance_15()), new ArrayListSerializer($serializer_getInstance_16()), new ArrayListSerializer($serializer_getInstance()), new ArrayListSerializer(NodePointerSerializer_getInstance())];
    this.zaj_1 = new NodeResolveInfoUpdate(emptyList(), emptyList(), emptyList(), emptyList());
  }
  var Companion_instance_176;
  function Companion_getInstance_176() {
    if (Companion_instance_176 == null)
      new Companion_176();
    return Companion_instance_176;
  }
  function $serializer_22() {
    $serializer_instance_20 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.live.NodeResolveInfoUpdate', this, 4);
    tmp0_serialDesc.t5n('updatedReferences', true);
    tmp0_serialDesc.t5n('droppedReferences', true);
    tmp0_serialDesc.t5n('updatedTargets', true);
    tmp0_serialDesc.t5n('droppedTargets', true);
    this.aak_1 = tmp0_serialDesc;
  }
  protoOf($serializer_22).bak = function (encoder, value) {
    var tmp0_desc = this.aak_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    var tmp2_cached = Companion_getInstance_176().yaj_1;
    if (tmp1_output.e5i(tmp0_desc, 0) ? true : !equals(value.cak_1, emptyList())) {
      tmp1_output.z5h(tmp0_desc, 0, tmp2_cached[0], value.cak_1);
    }
    if (tmp1_output.e5i(tmp0_desc, 1) ? true : !equals(value.dak_1, emptyList())) {
      tmp1_output.z5h(tmp0_desc, 1, tmp2_cached[1], value.dak_1);
    }
    if (tmp1_output.e5i(tmp0_desc, 2) ? true : !equals(value.eak_1, emptyList())) {
      tmp1_output.z5h(tmp0_desc, 2, tmp2_cached[2], value.eak_1);
    }
    if (tmp1_output.e5i(tmp0_desc, 3) ? true : !equals(value.fak_1, emptyList())) {
      tmp1_output.z5h(tmp0_desc, 3, tmp2_cached[3], value.fak_1);
    }
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_22).j5d = function (encoder, value) {
    return this.bak(encoder, value instanceof NodeResolveInfoUpdate ? value : THROW_CCE());
  };
  protoOf($serializer_22).k5d = function (decoder) {
    var tmp0_desc = this.aak_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.j5g(tmp0_desc);
    var tmp9_cached = Companion_getInstance_176().yaj_1;
    if (tmp8_input.y5g()) {
      tmp4_local0 = tmp8_input.v5g(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.v5g(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.v5g(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.v5g(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.v5g(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.v5g(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.v5g(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.v5g(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.k5g(tmp0_desc);
    return NodeResolveInfoUpdate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_22).w5c = function () {
    return this.aak_1;
  };
  protoOf($serializer_22).i5o = function () {
    var tmp0_cached = Companion_getInstance_176().yaj_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], tmp0_cached[2], tmp0_cached[3]];
  };
  var $serializer_instance_20;
  function $serializer_getInstance_20() {
    if ($serializer_instance_20 == null)
      new $serializer_22();
    return $serializer_instance_20;
  }
  function NodeResolveInfoUpdate_init_$Init$(seen0, updatedReferences, droppedReferences, updatedTargets, droppedTargets, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_20().aak_1);
    }
    if (0 === (seen0 & 1))
      $this.cak_1 = emptyList();
    else
      $this.cak_1 = updatedReferences;
    if (0 === (seen0 & 2))
      $this.dak_1 = emptyList();
    else
      $this.dak_1 = droppedReferences;
    if (0 === (seen0 & 4))
      $this.eak_1 = emptyList();
    else
      $this.eak_1 = updatedTargets;
    if (0 === (seen0 & 8))
      $this.fak_1 = emptyList();
    else
      $this.fak_1 = droppedTargets;
    return $this;
  }
  function NodeResolveInfoUpdate_init_$Create$(seen0, updatedReferences, droppedReferences, updatedTargets, droppedTargets, serializationConstructorMarker) {
    return NodeResolveInfoUpdate_init_$Init$(seen0, updatedReferences, droppedReferences, updatedTargets, droppedTargets, serializationConstructorMarker, objectCreate(protoOf(NodeResolveInfoUpdate)));
  }
  function NodeResolveInfoUpdate(updatedReferences, droppedReferences, updatedTargets, droppedTargets) {
    Companion_getInstance_176();
    updatedReferences = updatedReferences === VOID ? emptyList() : updatedReferences;
    droppedReferences = droppedReferences === VOID ? emptyList() : droppedReferences;
    updatedTargets = updatedTargets === VOID ? emptyList() : updatedTargets;
    droppedTargets = droppedTargets === VOID ? emptyList() : droppedTargets;
    this.cak_1 = updatedReferences;
    this.dak_1 = droppedReferences;
    this.eak_1 = updatedTargets;
    this.fak_1 = droppedTargets;
  }
  protoOf(NodeResolveInfoUpdate).toString = function () {
    return 'NodeResolveInfoUpdate(updatedReferences=' + toString_1(this.cak_1) + ', droppedReferences=' + toString_1(this.dak_1) + ', updatedTargets=' + toString_1(this.eak_1) + ', droppedTargets=' + toString_1(this.fak_1) + ')';
  };
  protoOf(NodeResolveInfoUpdate).hashCode = function () {
    var result = hashCode(this.cak_1);
    result = imul(result, 31) + hashCode(this.dak_1) | 0;
    result = imul(result, 31) + hashCode(this.eak_1) | 0;
    result = imul(result, 31) + hashCode(this.fak_1) | 0;
    return result;
  };
  protoOf(NodeResolveInfoUpdate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeResolveInfoUpdate))
      return false;
    var tmp0_other_with_cast = other instanceof NodeResolveInfoUpdate ? other : THROW_CCE();
    if (!equals(this.cak_1, tmp0_other_with_cast.cak_1))
      return false;
    if (!equals(this.dak_1, tmp0_other_with_cast.dak_1))
      return false;
    if (!equals(this.eak_1, tmp0_other_with_cast.eak_1))
      return false;
    if (!equals(this.fak_1, tmp0_other_with_cast.fak_1))
      return false;
    return true;
  };
  function ReferenceCompletionService$Companion$elements$lambda(instance, parameters) {
    var tagName = parameters.ug();
    var enclosing = parameters.vg();
    var enclosingChildLink = parameters.hm();
    var source = parameters.g59();
    var filter = parameters.h59();
    return instance.lak(tagName, enclosing, enclosingChildLink, source, filter);
  }
  function Companion_177() {
  }
  protoOf(Companion_177).h67 = function () {
    return $serializer_getInstance_21();
  };
  var Companion_instance_177;
  function Companion_getInstance_177() {
    return Companion_instance_177;
  }
  function $serializer_23() {
    $serializer_instance_21 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.live.ReferenceCompletionService.ElementsParameters', this, 5);
    tmp0_serialDesc.t5n('tagName', false);
    tmp0_serialDesc.t5n('enclosing', false);
    tmp0_serialDesc.t5n('enclosingChildLink', false);
    tmp0_serialDesc.t5n('source', false);
    tmp0_serialDesc.t5n('filter', false);
    this.mak_1 = tmp0_serialDesc;
  }
  protoOf($serializer_23).nak = function (encoder, value) {
    var tmp0_desc = this.mak_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.x5h(tmp0_desc, 0, value.gak_1);
    tmp1_output.a5i(tmp0_desc, 1, NodePointerSerializer_getInstance(), value.hak_1);
    tmp1_output.z5h(tmp0_desc, 2, $serializer_getInstance_5(), value.iak_1);
    tmp1_output.a5i(tmp0_desc, 3, NodePointerSerializer_getInstance(), value.jak_1);
    tmp1_output.z5h(tmp0_desc, 4, $serializer_getInstance_0(), value.kak_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_23).j5d = function (encoder, value) {
    return this.nak(encoder, value instanceof ElementsParameters ? value : THROW_CCE());
  };
  protoOf($serializer_23).k5d = function (decoder) {
    var tmp0_desc = this.mak_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.j5g(tmp0_desc);
    if (tmp9_input.y5g()) {
      tmp4_local0 = tmp9_input.t5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.x5g(tmp0_desc, 1, NodePointerSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.v5g(tmp0_desc, 2, $serializer_getInstance_5(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.x5g(tmp0_desc, 3, NodePointerSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.v5g(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.t5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.x5g(tmp0_desc, 1, NodePointerSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.v5g(tmp0_desc, 2, $serializer_getInstance_5(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.x5g(tmp0_desc, 3, NodePointerSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.v5g(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.k5g(tmp0_desc);
    return ElementsParameters_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_23).w5c = function () {
    return this.mak_1;
  };
  protoOf($serializer_23).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(NodePointerSerializer_getInstance()), $serializer_getInstance_5(), get_nullable(NodePointerSerializer_getInstance()), $serializer_getInstance_0()];
  };
  var $serializer_instance_21;
  function $serializer_getInstance_21() {
    if ($serializer_instance_21 == null)
      new $serializer_23();
    return $serializer_instance_21;
  }
  function ElementsParameters_init_$Init$(seen0, tagName, enclosing, enclosingChildLink, source, filter, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_21().mak_1);
    }
    $this.gak_1 = tagName;
    $this.hak_1 = enclosing;
    $this.iak_1 = enclosingChildLink;
    $this.jak_1 = source;
    $this.kak_1 = filter;
    return $this;
  }
  function ElementsParameters_init_$Create$(seen0, tagName, enclosing, enclosingChildLink, source, filter, serializationConstructorMarker) {
    return ElementsParameters_init_$Init$(seen0, tagName, enclosing, enclosingChildLink, source, filter, serializationConstructorMarker, objectCreate(protoOf(ElementsParameters)));
  }
  function Remote(endpoint) {
    this.oak_1 = endpoint;
  }
  protoOf(Remote).lak = function (tagName, enclosing, enclosingChildLink, source, filter) {
    return Companion_getInstance_178().qak_1.h9j(this.oak_1, new ElementsParameters(tagName, enclosing, enclosingChildLink, source, filter));
  };
  function Companion_178() {
    Companion_instance_178 = this;
    InstanceDescriptor.call(this);
    var tmp = this;
    var tmp_0 = Companion_instance_177.h67();
    var tmp_1 = Companion_getInstance_179().h67();
    tmp.qak_1 = flowMethod(this, 'elements', tmp_0, tmp_1, ReferenceCompletionService$Companion$elements$lambda);
  }
  protoOf(Companion_178).sak = function (endpoint) {
    return new Remote(endpoint);
  };
  protoOf(Companion_178).j9j = function (endpoint) {
    return this.sak(endpoint);
  };
  var Companion_instance_178;
  function Companion_getInstance_178() {
    if (Companion_instance_178 == null)
      new Companion_178();
    return Companion_instance_178;
  }
  function Empty_3() {
  }
  protoOf(Empty_3).lak = function (tagName, enclosing, enclosingChildLink, source, filter) {
    return emptyFlow();
  };
  var Empty_instance_2;
  function Empty_getInstance_2() {
    return Empty_instance_2;
  }
  function ElementsParameters(tagName, enclosing, enclosingChildLink, source, filter) {
    this.gak_1 = tagName;
    this.hak_1 = enclosing;
    this.iak_1 = enclosingChildLink;
    this.jak_1 = source;
    this.kak_1 = filter;
  }
  protoOf(ElementsParameters).ug = function () {
    return this.gak_1;
  };
  protoOf(ElementsParameters).vg = function () {
    return this.hak_1;
  };
  protoOf(ElementsParameters).hm = function () {
    return this.iak_1;
  };
  protoOf(ElementsParameters).g59 = function () {
    return this.jak_1;
  };
  protoOf(ElementsParameters).h59 = function () {
    return this.kak_1;
  };
  protoOf(ElementsParameters).toString = function () {
    return 'ElementsParameters(tagName=' + this.gak_1 + ', enclosing=' + toString_0(this.hak_1) + ', enclosingChildLink=' + this.iak_1.toString() + ', source=' + toString_0(this.jak_1) + ', filter=' + this.kak_1.toString() + ')';
  };
  protoOf(ElementsParameters).hashCode = function () {
    var result = getStringHashCode(this.gak_1);
    result = imul(result, 31) + (this.hak_1 == null ? 0 : this.hak_1.hashCode()) | 0;
    result = imul(result, 31) + this.iak_1.hashCode() | 0;
    result = imul(result, 31) + (this.jak_1 == null ? 0 : this.jak_1.hashCode()) | 0;
    result = imul(result, 31) + this.kak_1.hashCode() | 0;
    return result;
  };
  protoOf(ElementsParameters).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ElementsParameters))
      return false;
    var tmp0_other_with_cast = other instanceof ElementsParameters ? other : THROW_CCE();
    if (!(this.gak_1 === tmp0_other_with_cast.gak_1))
      return false;
    if (!equals(this.hak_1, tmp0_other_with_cast.hak_1))
      return false;
    if (!this.iak_1.equals(tmp0_other_with_cast.iak_1))
      return false;
    if (!equals(this.jak_1, tmp0_other_with_cast.jak_1))
      return false;
    if (!this.kak_1.equals(tmp0_other_with_cast.kak_1))
      return false;
    return true;
  };
  function Serializer_0() {
    Serializer_instance = this;
    InstancePublicationSerializer.call(this, Companion_getInstance_178());
  }
  var Serializer_instance;
  function Serializer_getInstance() {
    if (Serializer_instance == null)
      new Serializer_0();
    return Serializer_instance;
  }
  function Companion_179() {
    Companion_instance_179 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.rak_1 = [Companion_getInstance_104().h67(), null, null];
  }
  protoOf(Companion_179).h67 = function () {
    return $serializer_getInstance_22();
  };
  var Companion_instance_179;
  function Companion_getInstance_179() {
    if (Companion_instance_179 == null)
      new Companion_179();
    return Companion_instance_179;
  }
  function $serializer_24() {
    $serializer_instance_22 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.live.ReferenceTarget', this, 3);
    tmp0_serialDesc.t5n('content', false);
    tmp0_serialDesc.t5n('presentation', false);
    tmp0_serialDesc.t5n('additionalText', true);
    this.tak_1 = tmp0_serialDesc;
  }
  protoOf($serializer_24).uak = function (encoder, value) {
    var tmp0_desc = this.tak_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    var tmp2_cached = Companion_getInstance_179().rak_1;
    tmp1_output.z5h(tmp0_desc, 0, tmp2_cached[0], value.vak_1);
    tmp1_output.x5h(tmp0_desc, 1, value.wak_1);
    if (tmp1_output.e5i(tmp0_desc, 2) ? true : !(value.xak_1 == null)) {
      tmp1_output.a5i(tmp0_desc, 2, StringSerializer_getInstance(), value.xak_1);
    }
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_24).j5d = function (encoder, value) {
    return this.uak(encoder, value instanceof ReferenceTarget ? value : THROW_CCE());
  };
  protoOf($serializer_24).k5d = function (decoder) {
    var tmp0_desc = this.tak_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.j5g(tmp0_desc);
    var tmp8_cached = Companion_getInstance_179().rak_1;
    if (tmp7_input.y5g()) {
      tmp4_local0 = tmp7_input.v5g(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.t5g(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.x5g(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.v5g(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.t5g(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.x5g(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.k5g(tmp0_desc);
    return ReferenceTarget_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_24).w5c = function () {
    return this.tak_1;
  };
  protoOf($serializer_24).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_179().rak_1[0], StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_22;
  function $serializer_getInstance_22() {
    if ($serializer_instance_22 == null)
      new $serializer_24();
    return $serializer_instance_22;
  }
  function ReferenceTarget_init_$Init$(seen0, content, presentation, additionalText, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_22().tak_1);
    }
    $this.vak_1 = content;
    $this.wak_1 = presentation;
    if (0 === (seen0 & 4))
      $this.xak_1 = null;
    else
      $this.xak_1 = additionalText;
    return $this;
  }
  function ReferenceTarget_init_$Create$(seen0, content, presentation, additionalText, serializationConstructorMarker) {
    return ReferenceTarget_init_$Init$(seen0, content, presentation, additionalText, serializationConstructorMarker, objectCreate(protoOf(ReferenceTarget)));
  }
  function ReferenceTarget() {
  }
  protoOf(ReferenceTarget).toString = function () {
    return 'ReferenceTarget(content=' + toString_1(this.vak_1) + ', presentation=' + this.wak_1 + ', additionalText=' + this.xak_1 + ')';
  };
  protoOf(ReferenceTarget).hashCode = function () {
    var result = hashCode(this.vak_1);
    result = imul(result, 31) + getStringHashCode(this.wak_1) | 0;
    result = imul(result, 31) + (this.xak_1 == null ? 0 : getStringHashCode(this.xak_1)) | 0;
    return result;
  };
  protoOf(ReferenceTarget).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReferenceTarget))
      return false;
    var tmp0_other_with_cast = other instanceof ReferenceTarget ? other : THROW_CCE();
    if (!equals(this.vak_1, tmp0_other_with_cast.vak_1))
      return false;
    if (!(this.wak_1 === tmp0_other_with_cast.wak_1))
      return false;
    if (!(this.xak_1 == tmp0_other_with_cast.xak_1))
      return false;
    return true;
  };
  function Companion_180() {
  }
  protoOf(Companion_180).h67 = function () {
    return $serializer_getInstance_23();
  };
  var Companion_instance_180;
  function Companion_getInstance_180() {
    return Companion_instance_180;
  }
  function $serializer_25() {
    $serializer_instance_23 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.ocelot.langDef.references.remote.precalculated.SerializedResolvedNode', this, 2);
    tmp0_serialDesc.t5n('node', false);
    tmp0_serialDesc.t5n('resolveInfo', false);
    this.yak_1 = tmp0_serialDesc;
  }
  protoOf($serializer_25).zak = function (encoder, value) {
    var tmp0_desc = this.yak_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.z5h(tmp0_desc, 0, $serializer_getInstance(), value.node);
    tmp1_output.z5h(tmp0_desc, 1, $serializer_getInstance_14(), value.resolveInfo);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_25).j5d = function (encoder, value) {
    return this.zak(encoder, value instanceof SerializedResolvedNode ? value : THROW_CCE());
  };
  protoOf($serializer_25).k5d = function (decoder) {
    var tmp0_desc = this.yak_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, $serializer_getInstance_14(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, $serializer_getInstance_14(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return SerializedResolvedNode_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_25).w5c = function () {
    return this.yak_1;
  };
  protoOf($serializer_25).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance(), $serializer_getInstance_14()];
  };
  var $serializer_instance_23;
  function $serializer_getInstance_23() {
    if ($serializer_instance_23 == null)
      new $serializer_25();
    return $serializer_instance_23;
  }
  function SerializedResolvedNode_init_$Init$(seen0, node, resolveInfo, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_23().yak_1);
    }
    $this.node = node;
    $this.resolveInfo = resolveInfo;
    return $this;
  }
  function SerializedResolvedNode_init_$Create$(seen0, node, resolveInfo, serializationConstructorMarker) {
    return SerializedResolvedNode_init_$Init$(seen0, node, resolveInfo, serializationConstructorMarker, objectCreate(protoOf(SerializedResolvedNode)));
  }
  function SerializedResolvedNode(node, resolveInfo) {
    this.node = node;
    this.resolveInfo = resolveInfo;
  }
  protoOf(SerializedResolvedNode).y8c = function () {
    return this.node;
  };
  protoOf(SerializedResolvedNode).aal = function () {
    return this.resolveInfo;
  };
  protoOf(SerializedResolvedNode).ug = function () {
    return this.node;
  };
  protoOf(SerializedResolvedNode).vg = function () {
    return this.resolveInfo;
  };
  protoOf(SerializedResolvedNode).bal = function (node, resolveInfo) {
    return new SerializedResolvedNode(node, resolveInfo);
  };
  protoOf(SerializedResolvedNode).copy = function (node, resolveInfo, $super) {
    node = node === VOID ? this.node : node;
    resolveInfo = resolveInfo === VOID ? this.resolveInfo : resolveInfo;
    return this.bal(node, resolveInfo);
  };
  protoOf(SerializedResolvedNode).toString = function () {
    return 'SerializedResolvedNode(node=' + this.node.toString() + ', resolveInfo=' + this.resolveInfo.toString() + ')';
  };
  protoOf(SerializedResolvedNode).hashCode = function () {
    var result = this.node.hashCode();
    result = imul(result, 31) + this.resolveInfo.hashCode() | 0;
    return result;
  };
  protoOf(SerializedResolvedNode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializedResolvedNode))
      return false;
    var tmp0_other_with_cast = other instanceof SerializedResolvedNode ? other : THROW_CCE();
    if (!this.node.equals(tmp0_other_with_cast.node))
      return false;
    if (!this.resolveInfo.equals(tmp0_other_with_cast.resolveInfo))
      return false;
    return true;
  };
  function LiveResolutionClient(messages, completionServices) {
    this.cal_1 = messages;
    this.dal_1 = completionServices;
  }
  protoOf(LiveResolutionClient).lak = function (tagName, enclosing, enclosingChildLink, source, filter) {
    return this.dal_1.y().lak(tagName, enclosing, enclosingChildLink, source, filter);
  };
  protoOf(LiveResolutionClient).eal = function (source, tag, property) {
    // Inline function 'kotlin.check' call
    if (!_ChannelResult___get_isSuccess__impl__odq1z9(this.cal_1.a1c(new ReferenceActivated(source, tag, property)))) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
  };
  function LiveResolutionClient_0(_this__u8e3s4, persister, nodeStorage, wrapperContext, liveResolutionService, rootHolder) {
    var messages = Channel(2147483647);
    var completionServices = MutableStateFlow(Empty_instance_2);
    launch(_this__u8e3s4, VOID, VOID, LiveResolutionClient$slambda_0(liveResolutionService, messages, completionServices, null));
    var client = {_v: null};
    var tmp = launch(_this__u8e3s4, VOID, VOID, LiveResolutionClient$slambda_2(rootHolder, client, wrapperContext, persister, nodeStorage, messages, liveResolutionService, null));
    tmp.hu(LiveResolutionClient$lambda(liveResolutionService));
    client._v = new LiveResolutionClient(messages, completionServices);
    var tmp_0;
    if (client._v == null) {
      throwUninitializedPropertyAccessException('client');
    } else {
      tmp_0 = client._v;
    }
    return tmp_0;
  }
  function activateStateReferences(client, wrapperContext, node, activated) {
    var wrapper = toDomainNode(node, wrapperContext);
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = (isInterface(wrapper, TypedOtNode) ? wrapper : THROW_CCE()).q6m().w().k();
    while (_iterator__ex2g4s.l()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.component1' call
      var tag = _destruct__k2r9zo.x();
      // Inline function 'kotlin.collections.component2' call
      var reference = _destruct__k2r9zo.y();
      // Inline function 'kotlin.check' call
      if (!(reference instanceof LiveResolutionReference)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      if (activated) {
        client.eal(wrapper, tag, reference.gal_1);
      } else {
        client.eal(wrapper, tag, null);
      }
    }
  }
  function createReferenceActivatorNodeListener(client, wrapperContext) {
    return new createReferenceActivatorNodeListener$1(client, wrapperContext);
  }
  function LiveResolutionClientState$findTarget$o$run$lambda(this$0, $pointer) {
    return function (handler) {
      return this$0.pal_1.a2c($pointer, handler);
    };
  }
  function restoreState($this, info) {
    var droppedTargets = toMap_2($this.oal_1);
    $this.oal_1.m2();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = droppedTargets.w().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.references.remote.live.client.LiveResolutionClientState.restoreState.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var pointer = element.x();
      // Inline function 'kotlin.collections.component2' call
      var value = element.y();
      activateTargetReferences($this, value, false);
      var event = new PropertyChangeEvent(value, null);
      $this.pal_1.b2c(pointer, LiveResolutionClientState$restoreState$lambda(event));
    }
    $this.lal_1.m2();
    updateTargets($this, info.jai_1);
    updateReferences($this, info.kai_1);
  }
  function updateState_0($this, update) {
    updateTargets($this, update.eak_1);
    dropTargets($this, update.fak_1);
    updateReferences($this, update.cak_1);
    dropReferences($this, update.dak_1);
  }
  function updateTargets($this, updatedTargets) {
    var _iterator__ex2g4s = updatedTargets.k();
    while (_iterator__ex2g4s.l()) {
      var target = _iterator__ex2g4s.m();
      var targetValue = $this.hal_1.q2q(target.content);
      $this.ial_1.n6j(target.pointer, targetValue);
      var previousTargetValue = $this.oal_1.y2(target.pointer);
      if (!equals(previousTargetValue, targetValue)) {
        if (!(previousTargetValue == null)) {
          activateTargetReferences($this, previousTargetValue, false);
        }
        activateTargetReferences($this, targetValue, true);
        var tmp0 = $this.oal_1;
        // Inline function 'kotlin.collections.set' call
        var key = target.pointer;
        tmp0.r2(key, targetValue);
        var event = new PropertyChangeEvent(previousTargetValue, targetValue);
        $this.pal_1.b2c(target.pointer, LiveResolutionClientState$updateTargets$lambda(event));
      }
    }
  }
  function dropTargets($this, droppedTargetPointers) {
    var _iterator__ex2g4s = droppedTargetPointers.k();
    while (_iterator__ex2g4s.l()) {
      var targetPointer = _iterator__ex2g4s.m();
      var previousTargetValue = $this.oal_1.y2(targetPointer);
      if (!(previousTargetValue == null)) {
        activateTargetReferences($this, previousTargetValue, false);
        $this.oal_1.s2(targetPointer);
        var event = new PropertyChangeEvent(previousTargetValue, null);
        $this.pal_1.b2c(targetPointer, LiveResolutionClientState$dropTargets$lambda(event));
      }
    }
  }
  function dropReferences($this, droppedReferences) {
    var _iterator__ex2g4s = droppedReferences.k();
    while (_iterator__ex2g4s.l()) {
      var location = _iterator__ex2g4s.m();
      var tmp0_safe_receiver = $this.mal_1.y2(location);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.t2c(Companion_getInstance_182().qal_1);
      }
      $this.lal_1.s2(location);
    }
  }
  function updateReferences($this, updatedReferences) {
    var _iterator__ex2g4s = updatedReferences.k();
    while (_iterator__ex2g4s.l()) {
      var reference = _iterator__ex2g4s.m();
      var location = reference.nai_1;
      var tmp0_elvis_lhs = reference.oai_1.wai_1;
      var tmp = tmp0_elvis_lhs == null ? reference.oai_1.xai_1 : tmp0_elvis_lhs;
      var value = new LiveResolutionReferenceValue(reference.oai_1.wai_1, tmp, LiveResolutionClientState$findTarget$ref($this));
      var state = $this.mal_1.y2(location);
      if (state == null) {
        // Inline function 'kotlin.collections.set' call
        $this.lal_1.r2(location, value);
      } else {
        state.t2c(value);
      }
    }
  }
  function findTarget($this, pointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new LiveResolutionClientState$findTarget$$inlined$query$1($this, pointer);
  }
  function findLocalTarget($this, pointer) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new LiveResolutionClientState$findLocalTarget$$inlined$query$1($this, pointer);
  }
  function activateTargetReferences($this, target, activated) {
    var _iterator__ex2g4s = target.v6m(true).k();
    while (_iterator__ex2g4s.l()) {
      var targetChild = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_0 = (isInterface(targetChild, TypedOtNode) ? targetChild : THROW_CCE()).q6m().w().k();
      while (_iterator__ex2g4s_0.l()) {
        var _destruct__k2r9zo = _iterator__ex2g4s_0.m();
        // Inline function 'kotlin.collections.component1' call
        var tag = _destruct__k2r9zo.x();
        // Inline function 'kotlin.collections.component2' call
        var reference = _destruct__k2r9zo.y();
        // Inline function 'kotlin.check' call
        if (!(reference instanceof LiveResolutionReference)) {
          throw IllegalStateException_init_$Create$_0('Check failed.');
        }
        if (activated) {
          $this.ral(targetChild, tag, reference.gal_1);
        } else {
          $this.ral(targetChild, tag, null);
        }
      }
    }
  }
  function sam$jetbrains_ocelot_base_observable_event_EventSource$0_0(function_0) {
    this.sal_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_0).o27 = function (handler) {
    return this.sal_1(handler);
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_0).b4 = function () {
    return this.sal_1;
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EventSource) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_0).hashCode = function () {
    return hashCode(this.b4());
  };
  function LiveResolutionClientState$restoreState$lambda($event) {
    return function (it) {
      it.d28($event);
      return Unit_instance;
    };
  }
  function LiveResolutionClientState$updateTargets$lambda($event) {
    return function (it) {
      it.d28($event);
      return Unit_instance;
    };
  }
  function LiveResolutionClientState$dropTargets$lambda($event) {
    return function (it) {
      it.d28($event);
      return Unit_instance;
    };
  }
  function LiveResolutionClientState$findTarget$ref($boundThis) {
    var l = function (p0) {
      return findTarget($boundThis, p0);
    };
    l.callableName = 'findTarget';
    return l;
  }
  function LiveResolutionClientState$findTarget$$inlined$query$1(this$0, $pointer) {
    this.tal_1 = this$0;
    this.ual_1 = $pointer;
  }
  protoOf(LiveResolutionClientState$findTarget$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.references.remote.live.client.LiveResolutionClientState.findTarget.<anonymous>' call
    var tmp = LiveResolutionClientState$findTarget$o$run$lambda(this.tal_1, this.ual_1);
    builder.g4x_1.e4x_1.n4v(new sam$jetbrains_ocelot_base_observable_event_EventSource$0_0(tmp), Invalidation_getInstance().v4u_1);
    var tmp0_elvis_lhs = this.tal_1.oal_1.y2(this.ual_1);
    return tmp0_elvis_lhs == null ? builder.n51(findLocalTarget(this.tal_1, this.ual_1)) : tmp0_elvis_lhs;
  };
  function LiveResolutionClientState$findLocalTarget$$inlined$query$1(this$0, $pointer) {
    this.val_1 = this$0;
    this.wal_1 = $pointer;
  }
  protoOf(LiveResolutionClientState$findLocalTarget$$inlined$query$1).d4x = function (builder) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'jetbrains.ocelot.langDef.references.remote.live.client.LiveResolutionClientState.findLocalTarget.<anonymous>' call
      var tmp0_elvis_lhs = builder.n51(this.val_1.jal_1.a6k(this.wal_1.nodeId));
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = null;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var otNode = tmp;
      tmp$ret$0 = toDomainNode(otNode, this.val_1.kal_1);
    }
    return tmp$ret$0;
  };
  function LiveResolutionClientState(persister, storage, localTargetQueryProvider, wrapperContext) {
    this.hal_1 = persister;
    this.ial_1 = storage;
    this.jal_1 = localTargetQueryProvider;
    this.kal_1 = wrapperContext;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.lal_1 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.mal_1 = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.nal_1 = LinkedHashMap_init_$Create$();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_2.oal_1 = LinkedHashMap_init_$Create$();
    this.pal_1 = new ListenersMap();
  }
  protoOf(LiveResolutionClientState).xal = function (message) {
    if (message instanceof StateReceived) {
      restoreState(this, message.uaj_1);
    } else {
      if (message instanceof UpdateReceived) {
        updateState_0(this, message.xaj_1);
      } else {
        noWhenBranchMatchedException();
      }
    }
  };
  protoOf(LiveResolutionClientState).yal = function (source, tag, update) {
    if (update) {
      this.nal_1.s2(source);
    }
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.nal_1;
    var value = this_0.y2(source);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.langDef.references.remote.live.client.LiveResolutionClientState.location.<anonymous>' call
      var answer = ensureNotNull(get_pointer(source));
      this_0.r2(source, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var sourceLocation = tmp;
    return new SerializedReferenceLocation(sourceLocation, tag.n6p_1);
  };
  protoOf(LiveResolutionClientState).ral = function (source, tag, stateProperty) {
    var location = this.yal(source, tag, !(stateProperty == null));
    if (stateProperty == null) {
      var tmp0_elvis_lhs = this.mal_1.s2(location);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var currentState = tmp;
      // Inline function 'kotlin.takeIf' call
      var this_0 = currentState.qr();
      var tmp_0;
      // Inline function 'jetbrains.ocelot.langDef.references.remote.live.client.LiveResolutionClientState.referenceActivated.<anonymous>' call
      if (!equals(this_0, Companion_getInstance_182().qal_1)) {
        tmp_0 = this_0;
      } else {
        tmp_0 = null;
      }
      var tmp1_elvis_lhs = tmp_0;
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      var currentValue = tmp_1;
      // Inline function 'kotlin.collections.set' call
      this.lal_1.r2(location, currentValue);
    } else {
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_1 = this.mal_1;
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!!(isInterface(this_1, KtMap) ? this_1 : THROW_CCE()).w2(location)) {
        // Inline function 'kotlin.require.<anonymous>' call
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      var tmp2_elvis_lhs = this.lal_1.s2(location);
      var currentValue_0 = tmp2_elvis_lhs == null ? Companion_getInstance_182().qal_1 : tmp2_elvis_lhs;
      stateProperty.t2c(currentValue_0);
      // Inline function 'kotlin.collections.set' call
      this.mal_1.r2(location, stateProperty);
    }
  };
  function LiveResolutionClient$slambda$slambda$slambda($messages, resultContinuation) {
    this.ham_1 = $messages;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LiveResolutionClient$slambda$slambda$slambda).jam = function (it, $completion) {
    var tmp = this.kam(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(LiveResolutionClient$slambda$slambda$slambda).oa = function (p1, $completion) {
    return this.jam(p1 instanceof NodeResolveInfoMessage ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LiveResolutionClient$slambda$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ham_1.z1b(new MessageReceived(this.iam_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(LiveResolutionClient$slambda$slambda$slambda).kam = function (it, completion) {
    var i = new LiveResolutionClient$slambda$slambda$slambda(this.ham_1, completion);
    i.iam_1 = it;
    return i;
  };
  function LiveResolutionClient$slambda$slambda$slambda_0($messages, resultContinuation) {
    var i = new LiveResolutionClient$slambda$slambda$slambda($messages, resultContinuation);
    var l = function (it, $completion) {
      return i.jam(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_9(function_0) {
    this.lam_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_9).d1f = function (value, $completion) {
    return this.lam_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_9).b4 = function () {
    return this.lam_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_9).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_9).hashCode = function () {
    return hashCode(this.b4());
  };
  function LiveResolutionClient$slambda$slambda($completionServices, $messages, resultContinuation) {
    this.uam_1 = $completionServices;
    this.vam_1 = $messages;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LiveResolutionClient$slambda$slambda).xam = function (provider, $completion) {
    var tmp = this.yam(provider, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(LiveResolutionClient$slambda$slambda).oa = function (p1, $completion) {
    return this.xam(p1 instanceof NodeResolutionProvider ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LiveResolutionClient$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.uam_1.p1j(this.wam_1.qaj_1);
            this.y9_1 = 1;
            var tmp_0 = LiveResolutionClient$slambda$slambda$slambda_0(this.vam_1, null);
            suspendResult = this.wam_1.paj_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_9(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(LiveResolutionClient$slambda$slambda).yam = function (provider, completion) {
    var i = new LiveResolutionClient$slambda$slambda(this.uam_1, this.vam_1, completion);
    i.wam_1 = provider;
    return i;
  };
  function LiveResolutionClient$slambda$slambda_0($completionServices, $messages, resultContinuation) {
    var i = new LiveResolutionClient$slambda$slambda($completionServices, $messages, resultContinuation);
    var l = function (provider, $completion) {
      return i.xam(provider, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function LiveResolutionClient$slambda($liveResolutionService, $messages, $completionServices, resultContinuation) {
    this.han_1 = $liveResolutionService;
    this.ian_1 = $messages;
    this.jan_1 = $completionServices;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LiveResolutionClient$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(LiveResolutionClient$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LiveResolutionClient$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 4;
            this.y9_1 = 2;
            suspendResult = collectLatest(this.han_1.man_1, LiveResolutionClient$slambda$slambda_0(this.jan_1, this.ian_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.lan_1 = suspendResult;
            this.z9_1 = 5;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 5;
            this.ian_1.i1c();
            return Unit_instance;
          case 4:
            this.z9_1 = 5;
            var t = this.ba_1;
            this.ian_1.i1c();
            throw t;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(LiveResolutionClient$slambda).i1l = function ($this$launch, completion) {
    var i = new LiveResolutionClient$slambda(this.han_1, this.ian_1, this.jan_1, completion);
    i.kan_1 = $this$launch;
    return i;
  };
  function LiveResolutionClient$slambda_0($liveResolutionService, $messages, $completionServices, resultContinuation) {
    var i = new LiveResolutionClient$slambda($liveResolutionService, $messages, $completionServices, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function LiveResolutionClient$slambda_1($rootHolder, $client, $wrapperContext, $persister, $nodeStorage, $messages, $liveResolutionService, resultContinuation) {
    this.wan_1 = $rootHolder;
    this.xan_1 = $client;
    this.yan_1 = $wrapperContext;
    this.zan_1 = $persister;
    this.aao_1 = $nodeStorage;
    this.bao_1 = $messages;
    this.cao_1 = $liveResolutionService;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(LiveResolutionClient$slambda_1).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(LiveResolutionClient$slambda_1).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(LiveResolutionClient$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 20;
            this.y9_1 = 1;
            suspendResult = awaitNotNull(this.wan_1.x71_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.eao_1 = suspendResult;
            var _iterator__ex2g4s = this.eao_1.b3a().k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              var tmp_0;
              if (this.xan_1._v == null) {
                throwUninitializedPropertyAccessException('client');
              } else {
                tmp_0 = this.xan_1._v;
              }
              activateStateReferences(tmp_0, this.yan_1, element, true);
            }

            var tmp_1 = this;
            var tmp_2;
            if (this.xan_1._v == null) {
              throwUninitializedPropertyAccessException('client');
            } else {
              tmp_2 = this.xan_1._v;
            }

            tmp_1.fao_1 = this.eao_1.e3a(createReferenceActivatorNodeListener(tmp_2, this.yan_1));
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.hao_1 = this.fao_1;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.z9_1 = 16;
            var tmp_3 = this;
            tmp_3.jao_1 = this.hao_1;
            this.kao_1 = this.jao_1;
            this.lao_1 = new LiveResolutionClientState(this.zan_1, this.aao_1, new FindNodeQueryProvider(this.eao_1), this.yan_1);
            var tmp_4 = this;
            tmp_4.mao_1 = this.bao_1;
            this.nao_1 = this.mao_1;
            var tmp_5 = this;
            tmp_5.oao_1 = this.nao_1;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.qao_1 = this.oao_1;
            this.rao_1 = null;
            this.y9_1 = 6;
            continue $sm;
          case 6:
            this.y9_1 = 7;
            continue $sm;
          case 7:
            this.z9_1 = 13;
            this.z9_1 = 12;
            var tmp_6 = this;
            tmp_6.tao_1 = this.qao_1;
            this.uao_1 = this.tao_1;
            this.vao_1 = this.uao_1.k();
            this.y9_1 = 8;
            continue $sm;
          case 8:
            this.y9_1 = 9;
            suspendResult = this.vao_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            if (!suspendResult) {
              this.y9_1 = 10;
              continue $sm;
            }

            var e = this.vao_1.m();
            if (e instanceof MessageReceived) {
              this.lao_1.xal(e.zao_1);
              this.cao_1.nan_1.p1j(State_ACTIVE_getInstance());
            } else {
              if (e instanceof ReferenceActivated) {
                this.lao_1.ral(e.wao_1, e.xao_1, e.yao_1);
              } else {
                noWhenBranchMatchedException();
              }
            }

            this.y9_1 = 8;
            continue $sm;
          case 10:
            var tmp_7 = this;
            tmp_7.sao_1 = Unit_instance;
            this.y9_1 = 11;
            var tmp_8 = this;
            continue $sm;
          case 11:
            this.z9_1 = 16;
            var tmp_9 = this;
            cancelConsumed(this.qao_1, this.rao_1);
            tmp_9.pao_1 = Unit_instance;
            this.y9_1 = 15;
            continue $sm;
          case 12:
            this.z9_1 = 13;
            var tmp_10 = this.ba_1;
            if (tmp_10 instanceof Error) {
              var e_0 = this.ba_1;
              var tmp_11 = this;
              this.rao_1 = e_0;
              throw e_0;
            } else {
              throw this.ba_1;
            }

          case 13:
            this.z9_1 = 16;
            var t = this.ba_1;
            cancelConsumed(this.qao_1, this.rao_1);
            throw t;
          case 14:
            this.z9_1 = 16;
            cancelConsumed(this.qao_1, this.rao_1);
            if (false) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.y9_1 = 15;
            continue $sm;
          case 15:
            var tmp_12 = this;
            tmp_12.iao_1 = Unit_instance;
            this.z9_1 = 20;
            this.y9_1 = 17;
            var tmp_13 = this;
            continue $sm;
          case 16:
            this.z9_1 = 20;
            var t_0 = this.ba_1;
            this.hao_1.vr();
            throw t_0;
          case 17:
            this.z9_1 = 20;
            var tmp_14 = this;
            this.hao_1.vr();
            tmp_14.gao_1 = Unit_instance;
            this.y9_1 = 19;
            continue $sm;
          case 18:
            this.z9_1 = 20;
            this.hao_1.vr();
            if (false) {
              this.y9_1 = 2;
              continue $sm;
            }

            this.y9_1 = 19;
            continue $sm;
          case 19:
            return Unit_instance;
          case 20:
            throw this.ba_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.z9_1 === 20) {
          throw e_1;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(LiveResolutionClient$slambda_1).i1l = function ($this$launch, completion) {
    var i = new LiveResolutionClient$slambda_1(this.wan_1, this.xan_1, this.yan_1, this.zan_1, this.aao_1, this.bao_1, this.cao_1, completion);
    i.dao_1 = $this$launch;
    return i;
  };
  function LiveResolutionClient$slambda_2($rootHolder, $client, $wrapperContext, $persister, $nodeStorage, $messages, $liveResolutionService, resultContinuation) {
    var i = new LiveResolutionClient$slambda_1($rootHolder, $client, $wrapperContext, $persister, $nodeStorage, $messages, $liveResolutionService, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function LiveResolutionClient$lambda($liveResolutionService) {
    return function (it) {
      $liveResolutionService.nan_1.p1j(State_DISPOSED_getInstance());
      return Unit_instance;
    };
  }
  function createReferenceActivatorNodeListener$1($client, $wrapperContext) {
    this.aap_1 = $client;
    this.bap_1 = $wrapperContext;
  }
  protoOf(createReferenceActivatorNodeListener$1).x39 = function (node) {
    activateStateReferences(this.aap_1, this.bap_1, node, true);
  };
  protoOf(createReferenceActivatorNodeListener$1).y39 = function (node) {
    activateStateReferences(this.aap_1, this.bap_1, node, false);
  };
  function MessageReceived(message) {
    LiveResolutionClientMessage.call(this);
    this.zao_1 = message;
  }
  protoOf(MessageReceived).toString = function () {
    return 'MessageReceived(message=' + toString_1(this.zao_1) + ')';
  };
  protoOf(MessageReceived).hashCode = function () {
    return hashCode(this.zao_1);
  };
  protoOf(MessageReceived).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MessageReceived))
      return false;
    var tmp0_other_with_cast = other instanceof MessageReceived ? other : THROW_CCE();
    if (!equals(this.zao_1, tmp0_other_with_cast.zao_1))
      return false;
    return true;
  };
  function ReferenceActivated(source, tag, property) {
    LiveResolutionClientMessage.call(this);
    this.wao_1 = source;
    this.xao_1 = tag;
    this.yao_1 = property;
  }
  protoOf(ReferenceActivated).toString = function () {
    return 'ReferenceActivated(source=' + toString_1(this.wao_1) + ', tag=' + this.xao_1.toString() + ', property=' + toString_0(this.yao_1) + ')';
  };
  protoOf(ReferenceActivated).hashCode = function () {
    var result = hashCode(this.wao_1);
    result = imul(result, 31) + this.xao_1.hashCode() | 0;
    result = imul(result, 31) + (this.yao_1 == null ? 0 : hashCode(this.yao_1)) | 0;
    return result;
  };
  protoOf(ReferenceActivated).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReferenceActivated))
      return false;
    var tmp0_other_with_cast = other instanceof ReferenceActivated ? other : THROW_CCE();
    if (!equals(this.wao_1, tmp0_other_with_cast.wao_1))
      return false;
    if (!this.xao_1.equals(tmp0_other_with_cast.xao_1))
      return false;
    if (!equals(this.yao_1, tmp0_other_with_cast.yao_1))
      return false;
    return true;
  };
  function LiveResolutionClientMessage() {
  }
  function sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2(function_0) {
    this.cap_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2).l6t = function (source, property) {
    return this.cap_1(source, property);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2).b4 = function () {
    return this.cap_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ReferenceFactory) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2).hashCode = function () {
    return hashCode(this.b4());
  };
  function LiveResolutionReference$Companion$factory$lambda(_unused_var__etf5q3, property) {
    return new LiveResolutionReference(property);
  }
  function $runSuspendCOROUTINE$0_1(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lap_1 = _this__u8e3s4;
    this.map_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$0_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.nap_1 = this.map_1;
            this.oap_1 = this.nap_1;
            var tmp_1 = this;
            tmp_1.pap_1 = this.oap_1;
            this.y9_1 = 1;
            suspendResult = this.oap_1.m51(this.lap_1.qap_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            return this.pap_1.n51(tmp2.sap_1);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$1_1(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.baq_1 = _this__u8e3s4;
    this.caq_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$1_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.daq_1 = this.caq_1;
            this.eaq_1 = this.daq_1;
            var tmp_1 = this;
            tmp_1.faq_1 = this.eaq_1;
            this.y9_1 = 1;
            suspendResult = this.eaq_1.m51(this.baq_1.gaq_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp2 = suspendResult;
            return this.faq_1.n51(tmp2.rap_1);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function Companion_181() {
  }
  protoOf(Companion_181).haq = function () {
    var tmp = LiveResolutionReference$Companion$factory$lambda;
    return new sam$jetbrains_ocelot_langDef_references_ReferenceFactory$0_2(tmp);
  };
  var Companion_instance_181;
  function Companion_getInstance_181() {
    return Companion_instance_181;
  }
  function LiveResolutionReference$resolve$$inlined$flatMap$1($this) {
    this.qap_1 = $this;
  }
  protoOf(LiveResolutionReference$resolve$$inlined$flatMap$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$0_1(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(LiveResolutionReference$resolve$$inlined$flatMap$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function LiveResolutionReference$find$$inlined$flatMap$1($this) {
    this.gaq_1 = $this;
  }
  protoOf(LiveResolutionReference$find$$inlined$flatMap$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$1_1(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(LiveResolutionReference$find$$inlined$flatMap$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function LiveResolutionReference(property) {
    PropertyBasedReference.call(this, property);
    this.gal_1 = new ValueProperty(Companion_getInstance_182().qal_1);
  }
  protoOf(LiveResolutionReference).o6s = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.flatMap' call
    var this_0 = waitUntilNot(this.gal_1, Companion_getInstance_182().qal_1);
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new LiveResolutionReference$resolve$$inlined$flatMap$1(this_0);
  };
  protoOf(LiveResolutionReference).p6s = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.flatMap' call
    var this_0 = waitUntilNot(this.gal_1, Companion_getInstance_182().qal_1);
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new LiveResolutionReference$find$$inlined$flatMap$1(this_0);
  };
  protoOf(LiveResolutionReference).t2c = function (newValue) {
    return this.t6s((newValue == null ? true : newValue instanceof ReferenceContent) ? newValue : THROW_CCE());
  };
  protoOf(LiveResolutionReference).h4x = function (builder, $completion) {
    return this.w6s(builder, $completion);
  };
  function LiveResolutionReferenceValue$Companion$MISSING$lambda(it) {
    return constant(null);
  }
  function Companion_182() {
    Companion_instance_182 = this;
    var tmp = this;
    tmp.qal_1 = new LiveResolutionReferenceValue(null, null, LiveResolutionReferenceValue$Companion$MISSING$lambda);
  }
  var Companion_instance_182;
  function Companion_getInstance_182() {
    if (Companion_instance_182 == null)
      new Companion_182();
    return Companion_instance_182;
  }
  function LiveResolutionReferenceValue(resolveResultPointer, findResultPointer, targetQuery) {
    Companion_getInstance_182();
    var tmp = this;
    var tmp_0;
    if (findResultPointer == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = targetQuery(findResultPointer);
    }
    var tmp1_elvis_lhs = tmp_0;
    tmp.rap_1 = tmp1_elvis_lhs == null ? Companion_getInstance_76().i51_1 : tmp1_elvis_lhs;
    var tmp_1 = this;
    var tmp_2;
    if (resolveResultPointer == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_2 = targetQuery(resolveResultPointer);
    }
    var tmp1_elvis_lhs_0 = tmp_2;
    tmp_1.sap_1 = tmp1_elvis_lhs_0 == null ? Companion_getInstance_76().i51_1 : tmp1_elvis_lhs_0;
  }
  var State_NEW_instance;
  var State_ACTIVE_instance;
  var State_DISPOSED_instance;
  var State_entriesInitialized;
  function State_initEntries() {
    if (State_entriesInitialized)
      return Unit_instance;
    State_entriesInitialized = true;
    State_NEW_instance = new State_0('NEW', 0);
    State_ACTIVE_instance = new State_0('ACTIVE', 1);
    State_DISPOSED_instance = new State_0('DISPOSED', 2);
  }
  function Companion_183() {
  }
  var Companion_instance_183;
  function Companion_getInstance_183() {
    return Companion_instance_183;
  }
  function State_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function State_NEW_getInstance() {
    State_initEntries();
    return State_NEW_instance;
  }
  function State_ACTIVE_getInstance() {
    State_initEntries();
    return State_ACTIVE_instance;
  }
  function State_DISPOSED_getInstance() {
    State_initEntries();
    return State_DISPOSED_instance;
  }
  function LiveResolutionService(providers) {
    this.man_1 = providers;
    this.nan_1 = MutableStateFlow(State_NEW_getInstance());
  }
  function remote(_this__u8e3s4, tags) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tags.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.references.remote.live.client.remote.<anonymous>' call
      _this__u8e3s4.p6x(element, Companion_instance_181.haq());
    }
  }
  function RemoteReferenceTargetsSupplier$getElements$slambda$slambda($this_flow, this$0, resultContinuation) {
    this.qaq_1 = $this_flow;
    this.raq_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda$slambda).taq = function (it, $completion) {
    var tmp = this.uaq(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda$slambda).oa = function (p1, $completion) {
    return this.taq(p1 instanceof ReferenceTarget ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.qaq_1.d1f(new ReferenceTargetItem(cast(this.raq_1.vaq_1.m6p_1, this.saq_1.vak_1), this.saq_1.wak_1, this.saq_1.xak_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda$slambda).uaq = function (it, completion) {
    var i = new RemoteReferenceTargetsSupplier$getElements$slambda$slambda(this.qaq_1, this.raq_1, completion);
    i.saq_1 = it;
    return i;
  };
  function RemoteReferenceTargetsSupplier$getElements$slambda$slambda_0($this_flow, this$0, resultContinuation) {
    var i = new RemoteReferenceTargetsSupplier$getElements$slambda$slambda($this_flow, this$0, resultContinuation);
    var l = function (it, $completion) {
      return i.taq(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function serializedLink(_this__u8e3s4, $this) {
    var tmp;
    if (_this__u8e3s4 instanceof SourceNodeContext) {
      tmp = Companion_getInstance_112().b70_1;
    } else {
      if (_this__u8e3s4 instanceof EnclosingNodeContext) {
        tmp = persistLink(_this__u8e3s4, $this);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function persistLink(_this__u8e3s4, $this) {
    var tmp0_elvis_lhs = _this__u8e3s4.y6s_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance_112().b70_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var link = tmp;
    return new SerializedChildLink($this.waq_1.w6k(_this__u8e3s4.x6s_1, link));
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_10(function_0) {
    this.yaq_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_10).d1f = function (value, $completion) {
    return this.yaq_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_10).b4 = function () {
    return this.yaq_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_10).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_10).hashCode = function () {
    return hashCode(this.b4());
  };
  function RemoteReferenceTargetsSupplier$getElements$slambda($context, this$0, $filter, resultContinuation) {
    this.har_1 = $context;
    this.iar_1 = this$0;
    this.jar_1 = $filter;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda).nar = function ($this$flow, $completion) {
    var tmp = this.oar($this$flow, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda).oa = function (p1, $completion) {
    return this.nar((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp_1 = this.har_1;
            var tmp0_safe_receiver = tmp_1 instanceof EnclosingNodeContext ? tmp_1 : null;
            var tmp_2 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x6s_1;
            tmp_0.lar_1 = (!(tmp_2 == null) ? isInterface(tmp_2, DomainNode) : false) ? tmp_2 : null;
            var tmp_3 = this;
            var tmp_4 = this.har_1;
            var tmp1_safe_receiver = tmp_4 instanceof SourceNodeContext ? tmp_4 : null;
            tmp_3.mar_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.a6t_1;
            this.y9_1 = 1;
            var tmp2_safe_receiver = this.lar_1;
            var tmp_5 = tmp2_safe_receiver == null ? null : get_pointer(tmp2_safe_receiver);
            var tmp_6 = serializedLink(this.har_1, this.iar_1);
            var tmp3_safe_receiver = this.mar_1;
            var tmp_7 = this.iar_1.xaq_1.lak(this.iar_1.vaq_1.n6p_1, tmp_5, tmp_6, tmp3_safe_receiver == null ? null : get_pointer(tmp3_safe_receiver), this.jar_1);
            var tmp_8 = RemoteReferenceTargetsSupplier$getElements$slambda$slambda_0(this.kar_1, this.iar_1, null);
            suspendResult = tmp_7.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_10(tmp_8), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteReferenceTargetsSupplier$getElements$slambda).oar = function ($this$flow, completion) {
    var i = new RemoteReferenceTargetsSupplier$getElements$slambda(this.har_1, this.iar_1, this.jar_1, completion);
    i.kar_1 = $this$flow;
    return i;
  };
  function RemoteReferenceTargetsSupplier$getElements$slambda_0($context, this$0, $filter, resultContinuation) {
    var i = new RemoteReferenceTargetsSupplier$getElements$slambda($context, this$0, $filter, resultContinuation);
    var l = function ($this$flow, $completion) {
      return i.nar($this$flow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function RemoteReferenceTargetsSupplier(tag, persister, completionService) {
    this.vaq_1 = tag;
    this.waq_1 = persister;
    this.xaq_1 = completionService;
  }
  protoOf(RemoteReferenceTargetsSupplier).g6u = function (context, filter) {
    return flow(RemoteReferenceTargetsSupplier$getElements$slambda_0(context, this, filter, null));
  };
  function remote_0(_this__u8e3s4, tags) {
    var serializationConfig = Companion_instance_111.e2o(_this__u8e3s4);
    var client = LiveResolutionClient_0(CoroutineScope_0(CoroutineContextService_getInstance().e2o(_this__u8e3s4)), serializationConfig.w6z(getKClass(DomainNode)), Companion_getInstance_89().e2o(_this__u8e3s4).k6k_1, WrapperContextService_instance.e2o(_this__u8e3s4), Companion_instance_183.e2o(_this__u8e3s4), Companion_getInstance_115().e2o(_this__u8e3s4));
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tags.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.references.remote.live.client.remote.<anonymous>' call
      remoteReferenceTargetsSupplier(_this__u8e3s4, element, serializationConfig, client);
    }
  }
  function remoteReferenceTargetsSupplier(_this__u8e3s4, tag, serializationConfig, referenceCompletionService) {
    var tmp = serializationConfig.w6z(getKClass(DomainNode));
    var referenceTargetsSupplier = new RemoteReferenceTargetsSupplier(tag, isInterface(tmp, NodePersister) ? tmp : THROW_CCE(), referenceCompletionService);
    _this__u8e3s4.h6y(tag, referenceTargetsSupplier);
  }
  function precalculated(_this__u8e3s4, tags) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tags.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.references.remote.precalculated.client.precalculated.<anonymous>' call
      _this__u8e3s4.p6x(element, Companion_instance_97.o6t());
    }
  }
  function _get_targets__run9lb($this) {
    var tmp0 = $this.uar_1;
    // Inline function 'kotlin.getValue' call
    targets$factory();
    return tmp0.y();
  }
  function setReferences($this, node) {
    var references = (isInterface(node, TypedOtNode) ? node : THROW_CCE()).q6m();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = references.w().k();
    while (_iterator__ex2g4s.l()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.component1' call
      var tag = _destruct__k2r9zo.x();
      // Inline function 'kotlin.collections.component2' call
      var reference = _destruct__k2r9zo.y();
      // Inline function 'kotlin.check' call
      if (!(reference instanceof PrecalculatedResolutionReference)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      var location = new SerializedReferenceLocation(ensureNotNull(get_pointer(node)), tag.n6p_1);
      var tmp0_elvis_lhs = $this.tar_1.y2(location);
      var value = tmp0_elvis_lhs == null ? Companion_getInstance_171().tai_1 : tmp0_elvis_lhs;
      var resolveResult = findTarget_0($this, tag.l6p_1, value.wai_1);
      var tmp;
      if (!(value.xai_1 == null)) {
        tmp = findTarget_0($this, tag.l6p_1, value.xai_1);
      } else {
        tmp = resolveResult;
      }
      var findResult = tmp;
      reference.u6t_1.t2c(new PrecalculatedResolutionReferenceValue(resolveResult, findResult));
    }
    var _iterator__ex2g4s_0 = node.w6m().k();
    while (_iterator__ex2g4s_0.l()) {
      var childNode = _iterator__ex2g4s_0.m();
      setReferences($this, childNode);
    }
  }
  function findTarget_0($this, kClass, pointer) {
    var tmp;
    if (pointer == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.references.remote.precalculated.client.PrecalculatedResolutionService.findTarget.<anonymous>' call
      var tmp0_elvis_lhs = _get_targets__run9lb($this).y2(pointer);
      var target = tmp0_elvis_lhs == null ? findLocalTarget_0($this, pointer) : tmp0_elvis_lhs;
      // Inline function 'kotlin.checkNotNull' call
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (target == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      var tmp1_elvis_lhs = safeCast(kClass, target);
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        var message_0 = 'Target ' + toString_0(target) + ' cannot be cast to ' + toString_1(kClass);
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function findLocalTarget_0($this, pointer) {
    var tmp0_elvis_lhs = $this.rar_1.x71_1.qr();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var model = tmp;
    var tmp1_elvis_lhs = model.c3a(pointer.nodeId);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var otNode = tmp_0;
    return toDomainNode(otNode, $this.sar_1);
  }
  function Companion_184() {
  }
  var Companion_instance_184;
  function Companion_getInstance_184() {
    return Companion_instance_184;
  }
  function PrecalculatedResolutionService$targets$delegate$lambda($resolveInfo, this$0) {
    return function () {
      // Inline function 'kotlin.collections.associate' call
      var this_0 = $resolveInfo.jai_1;
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination = LinkedHashMap_init_$Create$_0(capacity);
      var _iterator__ex2g4s = this_0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.langDef.references.remote.precalculated.client.PrecalculatedResolutionService.targets$delegate.<anonymous>.<anonymous>' call
        var node = this$0.qar_1.q2q(element.content);
        this$0.par_1.n6j(element.pointer, node);
        // Inline function 'kotlin.collections.plusAssign' call
        var pair = to(element.pointer, node);
        destination.r2(pair.dh_1, pair.eh_1);
      }
      return destination;
    };
  }
  function PrecalculatedResolutionService(nodeStorage, persister, rootHolder, wrapperContext, resolveInfo) {
    this.par_1 = nodeStorage;
    this.qar_1 = persister;
    this.rar_1 = rootHolder;
    this.sar_1 = wrapperContext;
    var tmp = this;
    // Inline function 'kotlin.collections.associate' call
    var this_0 = resolveInfo.kai_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.references.remote.precalculated.client.PrecalculatedResolutionService.locationToValue.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.nai_1, element.oai_1);
      destination.r2(pair.dh_1, pair.eh_1);
    }
    tmp.tar_1 = destination;
    var tmp_0 = this;
    tmp_0.uar_1 = lazy_0(PrecalculatedResolutionService$targets$delegate$lambda(resolveInfo, this));
  }
  protoOf(PrecalculatedResolutionService).var = function () {
    var tmp0_elvis_lhs = this.rar_1.x71_1.qr();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var model = tmp;
    var rootNode = toDomainNode(model.g30_1, this.sar_1);
    setReferences(this, rootNode);
    var _iterator__ex2g4s = _get_targets__run9lb(this).v2().k();
    while (_iterator__ex2g4s.l()) {
      var node = _iterator__ex2g4s.m();
      setReferences(this, node);
    }
  };
  function precalculatedResolutionService(resolveInfo) {
    var tmp = Companion_instance_33;
    var tmp_0 = [Companion_instance_184];
    return tmp.m2o(tmp_0, VOID, precalculatedResolutionService$lambda(resolveInfo));
  }
  function precalculatedResolutionService$lambda($resolveInfo) {
    return function (it) {
      return new PrecalculatedResolutionService(Companion_getInstance_89().e2o(it).k6k_1, Companion_instance_111.e2o(it).w6z(getKClass(DomainNode)), Companion_getInstance_115().e2o(it), WrapperContextService_instance.e2o(it), $resolveInfo);
    };
  }
  function targets$factory() {
    return getPropertyCallableRef('targets', 1, KProperty1, function (receiver) {
      return _get_targets__run9lb(receiver);
    }, null);
  }
  function BioKbOtStructureRuntime() {
  }
  protoOf(BioKbOtStructureRuntime).war = function (_this__u8e3s4) {
    btbConceptRegistry(_this__u8e3s4);
  };
  function PropertyReferenceOperation(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyReferenceOperationConcept_getInstance().e6r_1) : nodeId;
    return PropertyReferenceOperation_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ObjectPropertyReferenceValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ObjectPropertyReferenceValueConcept_getInstance().e6r_1) : nodeId;
    return ObjectPropertyReferenceValue_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function PropertyReferenceOperation_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyReferenceOperationConcept_getInstance().e6r_1) : nodeId;
    return PropertyReferenceOperationConcept_getInstance().v6r(context, nodeId);
  }
  function ObjectPropertyReferenceValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ObjectPropertyReferenceValueConcept_getInstance().e6r_1) : nodeId;
    return ObjectPropertyReferenceValueConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyLibraryReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLibraryReferenceConcept_getInstance().e6r_1) : nodeId;
    return OntologyLibraryReference_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyElementReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementReferenceConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementReference_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function Context(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ContextConcept_getInstance().e6r_1) : nodeId;
    return Context_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function Category(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CategoryConcept_getInstance().e6r_1) : nodeId;
    return Category_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyImportRootReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyImportRootReferenceConcept_getInstance().e6r_1) : nodeId;
    return OntologyImportRootReference_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function TypePlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(TypePlaceholderConcept_getInstance().e6r_1) : nodeId;
    return TypePlaceholder_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyElementType(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementTypeConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementType_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function LibraryProcessSpecification(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LibraryProcessSpecificationConcept_getInstance().e6r_1) : nodeId;
    return LibraryProcessSpecification_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ProcessType(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessTypeConcept_getInstance().e6r_1) : nodeId;
    return ProcessType_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OneOf(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OneOfConcept_getInstance().e6r_1) : nodeId;
    return OneOf_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function SetValuedPropertyParameter(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(SetValuedPropertyParameterConcept_getInstance().e6r_1) : nodeId;
    return SetValuedPropertyParameter_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function IsExpression(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(IsExpressionConcept_getInstance().e6r_1) : nodeId;
    return IsExpression_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ClassExpressionPlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ClassExpressionPlaceholderConcept_getInstance().e6r_1) : nodeId;
    return ClassExpressionPlaceholder_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function QualifiedOntologyElementReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(QualifiedOntologyElementReferenceConcept_getInstance().e6r_1) : nodeId;
    return QualifiedOntologyElementReference_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function UnionClass(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(UnionClassConcept_getInstance().e6r_1) : nodeId;
    return UnionClass_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function VariableDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(VariableDeclarationConcept_getInstance().e6r_1) : nodeId;
    return VariableDeclaration_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function FunctionTerm(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FunctionTermConcept_getInstance().e6r_1) : nodeId;
    return FunctionTerm_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function MeasurableValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MeasurableValueConcept_getInstance().e6r_1) : nodeId;
    return MeasurableValue_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function EnumValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EnumValueConcept_getInstance().e6r_1) : nodeId;
    return EnumValue_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function VariableReferenceValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(VariableReferenceValueConcept_getInstance().e6r_1) : nodeId;
    return VariableReferenceValue_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function SetExpression(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(SetExpressionConcept_getInstance().e6r_1) : nodeId;
    return SetExpression_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyElementReferenceValueLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementReferenceValueLibraryConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementReferenceValueLibrary_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyElementReferenceValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementReferenceValueConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementReferenceValue_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ValueWithRelations(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ValueWithRelationsConcept_getInstance().e6r_1) : nodeId;
    return ValueWithRelations_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ConstantCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ConstantCustomCellConcept_getInstance().e6r_1) : nodeId;
    return ConstantCustomCell_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ProcessPropertyCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyCustomCellConcept_getInstance().e6r_1) : nodeId;
    return ProcessPropertyCustomCell_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function PropertyCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyCustomCellConcept_getInstance().e6r_1) : nodeId;
    return PropertyCustomCell_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function LinkCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LinkCustomCellConcept_getInstance().e6r_1) : nodeId;
    return LinkCustomCell_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function KindCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(KindCustomCellConcept_getInstance().e6r_1) : nodeId;
    return KindCustomCell_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ReturnTypeCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ReturnTypeCustomCellConcept_getInstance().e6r_1) : nodeId;
    return ReturnTypeCustomCell_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function CardinalityCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityCustomCellConcept_getInstance().e6r_1) : nodeId;
    return CardinalityCustomCell_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function DeclarationNameCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(DeclarationNameCustomCellConcept_getInstance().e6r_1) : nodeId;
    return DeclarationNameCustomCell_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function PropertiesCustomCell(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertiesCustomCellConcept_getInstance().e6r_1) : nodeId;
    return PropertiesCustomCell_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function FieldDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FieldDeclarationConcept_getInstance().e6r_1) : nodeId;
    return FieldDeclaration_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function FactPrecondition(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactPreconditionConcept_getInstance().e6r_1) : nodeId;
    return FactPrecondition_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function Cardinality(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityConcept_getInstance().e6r_1) : nodeId;
    return Cardinality_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function CardinalityBoundN(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityBoundNConcept_getInstance().e6r_1) : nodeId;
    return CardinalityBoundN_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function CardinalityBoundPlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityBoundPlaceholderConcept_getInstance().e6r_1) : nodeId;
    return CardinalityBoundPlaceholder_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function CardinalityBoundConstant(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityBoundConstantConcept_getInstance().e6r_1) : nodeId;
    return CardinalityBoundConstant_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function KnowledgeSourceReferencePlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(KnowledgeSourceReferencePlaceholderConcept_getInstance().e6r_1) : nodeId;
    return KnowledgeSourceReferencePlaceholder_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function Page(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PageConcept_getInstance().e6r_1) : nodeId;
    return Page_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function Author(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(AuthorConcept_getInstance().e6r_1) : nodeId;
    return Author_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function LibraryItemPlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LibraryItemPlaceholderConcept_getInstance().e6r_1) : nodeId;
    return LibraryItemPlaceholder_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function UrlKnowledgeSourceReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(UrlKnowledgeSourceReferenceConcept_getInstance().e6r_1) : nodeId;
    return UrlKnowledgeSourceReference_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function PubMedSourceReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PubMedSourceReferenceConcept_getInstance().e6r_1) : nodeId;
    return PubMedSourceReference_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function PublishedSourceReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PublishedSourceReferenceConcept_getInstance().e6r_1) : nodeId;
    return PublishedSourceReference_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function PageRange(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PageRangeConcept_getInstance().e6r_1) : nodeId;
    return PageRange_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function Book(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BookConcept_getInstance().e6r_1) : nodeId;
    return Book_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function Paper(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PaperConcept_getInstance().e6r_1) : nodeId;
    return Paper_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function LinkDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LinkDeclarationConcept_getInstance().e6r_1) : nodeId;
    return LinkDeclaration_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function QueryLabelsFactExpressionContainer(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(QueryLabelsFactExpressionContainerConcept_getInstance().e6r_1) : nodeId;
    return QueryLabelsFactExpressionContainer_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function RelationFactExpression(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(RelationFactExpressionConcept_getInstance().e6r_1) : nodeId;
    return RelationFactExpression_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function NotionPlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NotionPlaceholderConcept_getInstance().e6r_1) : nodeId;
    return NotionPlaceholder_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function MeasurementUnit(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MeasurementUnitConcept_getInstance().e6r_1) : nodeId;
    return MeasurementUnit_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function EnumerationConstant(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EnumerationConstantConcept_getInstance().e6r_1) : nodeId;
    return EnumerationConstant_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function EnumerableNotion(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EnumerableNotionConcept_getInstance().e6r_1) : nodeId;
    return EnumerableNotion_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function MeasurableNotion(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MeasurableNotionConcept_getInstance().e6r_1) : nodeId;
    return MeasurableNotion_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ObjectPropertyDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ObjectPropertyDeclarationConcept_getInstance().e6r_1) : nodeId;
    return ObjectPropertyDeclaration_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function NoValues(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NoValuesConcept_getInstance().e6r_1) : nodeId;
    return NoValues_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function MultiplePropertyValueRange(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MultiplePropertyValueRangeConcept_getInstance().e6r_1) : nodeId;
    return MultiplePropertyValueRange_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function SinglePropertyValueRange(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(SinglePropertyValueRangeConcept_getInstance().e6r_1) : nodeId;
    return SinglePropertyValueRange_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function PropertyConstraint(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyConstraintConcept_getInstance().e6r_1) : nodeId;
    return PropertyConstraint_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyElementSynonym(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementSynonymConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementSynonym_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyElementDefinition(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementDefinitionConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementDefinition_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyIsRelation(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyIsRelationConcept_getInstance().e6r_1) : nodeId;
    return OntologyIsRelation_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyCardinalityRelation(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyCardinalityRelationConcept_getInstance().e6r_1) : nodeId;
    return OntologyCardinalityRelation_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ProcessReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessReferenceConcept_getInstance().e6r_1) : nodeId;
    return ProcessReference_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ProcessProperty(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyConcept_getInstance().e6r_1) : nodeId;
    return ProcessProperty_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function MultipleProcessPropertyValueRange(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MultipleProcessPropertyValueRangeConcept_getInstance().e6r_1) : nodeId;
    return MultipleProcessPropertyValueRange_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ProcessPropertyDefault(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyDefaultConcept_getInstance().e6r_1) : nodeId;
    return ProcessPropertyDefault_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function EmptyBindingEntry(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EmptyBindingEntryConcept_getInstance().e6r_1) : nodeId;
    return EmptyBindingEntry_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function EmptyPropertyLibraryElement(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EmptyPropertyLibraryElementConcept_getInstance().e6r_1) : nodeId;
    return EmptyPropertyLibraryElement_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyLink(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLinkConcept_getInstance().e6r_1) : nodeId;
    return OntologyLink_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function BindingProperty(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BindingPropertyConcept_getInstance().e6r_1) : nodeId;
    return BindingProperty_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ImportedLink(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ImportedLinkConcept_getInstance().e6r_1) : nodeId;
    return ImportedLink_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ImportedProperty(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ImportedPropertyConcept_getInstance().e6r_1) : nodeId;
    return ImportedProperty_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function PropertyValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyValueConcept_getInstance().e6r_1) : nodeId;
    return PropertyValue_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyLinkValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLinkValueConcept_getInstance().e6r_1) : nodeId;
    return OntologyLinkValue_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ProcessPropertyValue(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyValueConcept_getInstance().e6r_1) : nodeId;
    return ProcessPropertyValue_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function PropertyDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyDeclarationConcept_getInstance().e6r_1) : nodeId;
    return PropertyDeclaration_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyElementPropertyType(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementPropertyTypeConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementPropertyType_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function LibraryProcessSpecificationQuery(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LibraryProcessSpecificationQueryConcept_getInstance().e6r_1) : nodeId;
    return LibraryProcessSpecificationQuery_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function FindConnectionCommand(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FindConnectionCommandConcept_getInstance().e6r_1) : nodeId;
    return FindConnectionCommand_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ContextQuery(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ContextQueryConcept_getInstance().e6r_1) : nodeId;
    return ContextQuery_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OrValueQuery(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OrValueQueryConcept_getInstance().e6r_1) : nodeId;
    return OrValueQuery_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function BindingValueMask(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BindingValueMaskConcept_getInstance().e6r_1) : nodeId;
    return BindingValueMask_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyLinkDeclarationValueQuery(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLinkDeclarationValueQueryConcept_getInstance().e6r_1) : nodeId;
    return OntologyLinkDeclarationValueQuery_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function PropertyDeclarationValueQuery(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyDeclarationValueQueryConcept_getInstance().e6r_1) : nodeId;
    return PropertyDeclarationValueQuery_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ClassExpressionType(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ClassExpressionTypeConcept_getInstance().e6r_1) : nodeId;
    return ClassExpressionType_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ExtensionFieldReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ExtensionFieldReferenceConcept_getInstance().e6r_1) : nodeId;
    return ExtensionFieldReference_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function BindingValuePlaceholder(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BindingValuePlaceholderConcept_getInstance().e6r_1) : nodeId;
    return BindingValuePlaceholder_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function FactSet(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactSetConcept_getInstance().e6r_1) : nodeId;
    return FactSet_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function Fact(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactConcept_getInstance().e6r_1) : nodeId;
    return Fact_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ExtensionDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ExtensionDeclarationConcept_getInstance().e6r_1) : nodeId;
    return ExtensionDeclaration_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function FactReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactReferenceConcept_getInstance().e6r_1) : nodeId;
    return FactReference_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function FunctionDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FunctionDeclarationConcept_getInstance().e6r_1) : nodeId;
    return FunctionDeclaration_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyElement(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementConcept_getInstance().e6r_1) : nodeId;
    return OntologyElement_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function LocalOntologyElementReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LocalOntologyElementReferenceConcept_getInstance().e6r_1) : nodeId;
    return LocalOntologyElementReference_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ProcessDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessDeclarationConcept_getInstance().e6r_1) : nodeId;
    return ProcessDeclaration_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ProcessKind(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessKindConcept_getInstance().e6r_1) : nodeId;
    return ProcessKind_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function BindingValuePlaceholderQuery(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BindingValuePlaceholderQueryConcept_getInstance().e6r_1) : nodeId;
    return BindingValuePlaceholderQuery_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ProcessRelationDeclaration(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessRelationDeclarationConcept_getInstance().e6r_1) : nodeId;
    return ProcessRelationDeclaration_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyImport(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyImportConcept_getInstance().e6r_1) : nodeId;
    return OntologyImport_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function BTBDocument(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BTBDocumentConcept_getInstance().e6r_1) : nodeId;
    return BTBDocument_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyImportRoot(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyImportRootConcept_getInstance().e6r_1) : nodeId;
    return OntologyImportRoot_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLibraryConcept_getInstance().e6r_1) : nodeId;
    return OntologyLibrary_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ProcessKindContainer(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessKindContainerConcept_getInstance().e6r_1) : nodeId;
    return ProcessKindContainer_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ProcessLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessLibraryConcept_getInstance().e6r_1) : nodeId;
    return ProcessLibrary_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function RelationContainer(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(RelationContainerConcept_getInstance().e6r_1) : nodeId;
    return RelationContainer_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function NotionLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NotionLibraryConcept_getInstance().e6r_1) : nodeId;
    return NotionLibrary_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function FunctionLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FunctionLibraryConcept_getInstance().e6r_1) : nodeId;
    return FunctionLibrary_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function ExtensionLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ExtensionLibraryConcept_getInstance().e6r_1) : nodeId;
    return ExtensionLibrary_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function PropertyLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyLibraryConcept_getInstance().e6r_1) : nodeId;
    return PropertyLibrary_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function LinkLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LinkLibraryConcept_getInstance().e6r_1) : nodeId;
    return LinkLibrary_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function PublishedSourcesLibrary(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PublishedSourcesLibraryConcept_getInstance().e6r_1) : nodeId;
    return PublishedSourcesLibrary_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function QueryCommands(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(QueryCommandsConcept_getInstance().e6r_1) : nodeId;
    return QueryCommands_0(context.n4u(Companion_getInstance_94().a6p_1), nodeId);
  }
  function OntologyLibraryReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLibraryReferenceConcept_getInstance().e6r_1) : nodeId;
    return OntologyLibraryReferenceConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyElementReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementReferenceConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementReferenceConcept_getInstance().v6r(context, nodeId);
  }
  function Context_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ContextConcept_getInstance().e6r_1) : nodeId;
    return ContextConcept_getInstance().v6r(context, nodeId);
  }
  function Category_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CategoryConcept_getInstance().e6r_1) : nodeId;
    return CategoryConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyImportRootReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyImportRootReferenceConcept_getInstance().e6r_1) : nodeId;
    return OntologyImportRootReferenceConcept_getInstance().v6r(context, nodeId);
  }
  function TypePlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(TypePlaceholderConcept_getInstance().e6r_1) : nodeId;
    return TypePlaceholderConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyElementType_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementTypeConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementTypeConcept_getInstance().v6r(context, nodeId);
  }
  function LibraryProcessSpecification_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LibraryProcessSpecificationConcept_getInstance().e6r_1) : nodeId;
    return LibraryProcessSpecificationConcept_getInstance().v6r(context, nodeId);
  }
  function ProcessType_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessTypeConcept_getInstance().e6r_1) : nodeId;
    return ProcessTypeConcept_getInstance().v6r(context, nodeId);
  }
  function OneOf_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OneOfConcept_getInstance().e6r_1) : nodeId;
    return OneOfConcept_getInstance().v6r(context, nodeId);
  }
  function SetValuedPropertyParameter_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(SetValuedPropertyParameterConcept_getInstance().e6r_1) : nodeId;
    return SetValuedPropertyParameterConcept_getInstance().v6r(context, nodeId);
  }
  function IsExpression_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(IsExpressionConcept_getInstance().e6r_1) : nodeId;
    return IsExpressionConcept_getInstance().v6r(context, nodeId);
  }
  function ClassExpressionPlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ClassExpressionPlaceholderConcept_getInstance().e6r_1) : nodeId;
    return ClassExpressionPlaceholderConcept_getInstance().v6r(context, nodeId);
  }
  function QualifiedOntologyElementReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(QualifiedOntologyElementReferenceConcept_getInstance().e6r_1) : nodeId;
    return QualifiedOntologyElementReferenceConcept_getInstance().v6r(context, nodeId);
  }
  function UnionClass_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(UnionClassConcept_getInstance().e6r_1) : nodeId;
    return UnionClassConcept_getInstance().v6r(context, nodeId);
  }
  function VariableDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(VariableDeclarationConcept_getInstance().e6r_1) : nodeId;
    return VariableDeclarationConcept_getInstance().v6r(context, nodeId);
  }
  function FunctionTerm_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FunctionTermConcept_getInstance().e6r_1) : nodeId;
    return FunctionTermConcept_getInstance().v6r(context, nodeId);
  }
  function MeasurableValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MeasurableValueConcept_getInstance().e6r_1) : nodeId;
    return MeasurableValueConcept_getInstance().v6r(context, nodeId);
  }
  function EnumValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EnumValueConcept_getInstance().e6r_1) : nodeId;
    return EnumValueConcept_getInstance().v6r(context, nodeId);
  }
  function VariableReferenceValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(VariableReferenceValueConcept_getInstance().e6r_1) : nodeId;
    return VariableReferenceValueConcept_getInstance().v6r(context, nodeId);
  }
  function SetExpression_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(SetExpressionConcept_getInstance().e6r_1) : nodeId;
    return SetExpressionConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyElementReferenceValueLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementReferenceValueLibraryConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementReferenceValueLibraryConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyElementReferenceValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementReferenceValueConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementReferenceValueConcept_getInstance().v6r(context, nodeId);
  }
  function ValueWithRelations_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ValueWithRelationsConcept_getInstance().e6r_1) : nodeId;
    return ValueWithRelationsConcept_getInstance().v6r(context, nodeId);
  }
  function ConstantCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ConstantCustomCellConcept_getInstance().e6r_1) : nodeId;
    return ConstantCustomCellConcept_getInstance().v6r(context, nodeId);
  }
  function ProcessPropertyCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyCustomCellConcept_getInstance().e6r_1) : nodeId;
    return ProcessPropertyCustomCellConcept_getInstance().v6r(context, nodeId);
  }
  function PropertyCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyCustomCellConcept_getInstance().e6r_1) : nodeId;
    return PropertyCustomCellConcept_getInstance().v6r(context, nodeId);
  }
  function LinkCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LinkCustomCellConcept_getInstance().e6r_1) : nodeId;
    return LinkCustomCellConcept_getInstance().v6r(context, nodeId);
  }
  function KindCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(KindCustomCellConcept_getInstance().e6r_1) : nodeId;
    return KindCustomCellConcept_getInstance().v6r(context, nodeId);
  }
  function ReturnTypeCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ReturnTypeCustomCellConcept_getInstance().e6r_1) : nodeId;
    return ReturnTypeCustomCellConcept_getInstance().v6r(context, nodeId);
  }
  function CardinalityCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityCustomCellConcept_getInstance().e6r_1) : nodeId;
    return CardinalityCustomCellConcept_getInstance().v6r(context, nodeId);
  }
  function DeclarationNameCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(DeclarationNameCustomCellConcept_getInstance().e6r_1) : nodeId;
    return DeclarationNameCustomCellConcept_getInstance().v6r(context, nodeId);
  }
  function PropertiesCustomCell_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertiesCustomCellConcept_getInstance().e6r_1) : nodeId;
    return PropertiesCustomCellConcept_getInstance().v6r(context, nodeId);
  }
  function FieldDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FieldDeclarationConcept_getInstance().e6r_1) : nodeId;
    return FieldDeclarationConcept_getInstance().v6r(context, nodeId);
  }
  function FactPrecondition_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactPreconditionConcept_getInstance().e6r_1) : nodeId;
    return FactPreconditionConcept_getInstance().v6r(context, nodeId);
  }
  function Cardinality_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityConcept_getInstance().e6r_1) : nodeId;
    return CardinalityConcept_getInstance().v6r(context, nodeId);
  }
  function CardinalityBoundN_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityBoundNConcept_getInstance().e6r_1) : nodeId;
    return CardinalityBoundNConcept_getInstance().v6r(context, nodeId);
  }
  function CardinalityBoundPlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityBoundPlaceholderConcept_getInstance().e6r_1) : nodeId;
    return CardinalityBoundPlaceholderConcept_getInstance().v6r(context, nodeId);
  }
  function CardinalityBoundConstant_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityBoundConstantConcept_getInstance().e6r_1) : nodeId;
    return CardinalityBoundConstantConcept_getInstance().v6r(context, nodeId);
  }
  function KnowledgeSourceReferencePlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(KnowledgeSourceReferencePlaceholderConcept_getInstance().e6r_1) : nodeId;
    return KnowledgeSourceReferencePlaceholderConcept_getInstance().v6r(context, nodeId);
  }
  function Page_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PageConcept_getInstance().e6r_1) : nodeId;
    return PageConcept_getInstance().v6r(context, nodeId);
  }
  function Author_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(AuthorConcept_getInstance().e6r_1) : nodeId;
    return AuthorConcept_getInstance().v6r(context, nodeId);
  }
  function LibraryItemPlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LibraryItemPlaceholderConcept_getInstance().e6r_1) : nodeId;
    return LibraryItemPlaceholderConcept_getInstance().v6r(context, nodeId);
  }
  function UrlKnowledgeSourceReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(UrlKnowledgeSourceReferenceConcept_getInstance().e6r_1) : nodeId;
    return UrlKnowledgeSourceReferenceConcept_getInstance().v6r(context, nodeId);
  }
  function PubMedSourceReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PubMedSourceReferenceConcept_getInstance().e6r_1) : nodeId;
    return PubMedSourceReferenceConcept_getInstance().v6r(context, nodeId);
  }
  function PublishedSourceReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PublishedSourceReferenceConcept_getInstance().e6r_1) : nodeId;
    return PublishedSourceReferenceConcept_getInstance().v6r(context, nodeId);
  }
  function PageRange_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PageRangeConcept_getInstance().e6r_1) : nodeId;
    return PageRangeConcept_getInstance().v6r(context, nodeId);
  }
  function Book_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BookConcept_getInstance().e6r_1) : nodeId;
    return BookConcept_getInstance().v6r(context, nodeId);
  }
  function Paper_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PaperConcept_getInstance().e6r_1) : nodeId;
    return PaperConcept_getInstance().v6r(context, nodeId);
  }
  function LinkDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LinkDeclarationConcept_getInstance().e6r_1) : nodeId;
    return LinkDeclarationConcept_getInstance().v6r(context, nodeId);
  }
  function QueryLabelsFactExpressionContainer_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(QueryLabelsFactExpressionContainerConcept_getInstance().e6r_1) : nodeId;
    return QueryLabelsFactExpressionContainerConcept_getInstance().v6r(context, nodeId);
  }
  function RelationFactExpression_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(RelationFactExpressionConcept_getInstance().e6r_1) : nodeId;
    return RelationFactExpressionConcept_getInstance().v6r(context, nodeId);
  }
  function NotionPlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NotionPlaceholderConcept_getInstance().e6r_1) : nodeId;
    return NotionPlaceholderConcept_getInstance().v6r(context, nodeId);
  }
  function MeasurementUnit_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MeasurementUnitConcept_getInstance().e6r_1) : nodeId;
    return MeasurementUnitConcept_getInstance().v6r(context, nodeId);
  }
  function EnumerationConstant_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EnumerationConstantConcept_getInstance().e6r_1) : nodeId;
    return EnumerationConstantConcept_getInstance().v6r(context, nodeId);
  }
  function EnumerableNotion_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EnumerableNotionConcept_getInstance().e6r_1) : nodeId;
    return EnumerableNotionConcept_getInstance().v6r(context, nodeId);
  }
  function MeasurableNotion_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MeasurableNotionConcept_getInstance().e6r_1) : nodeId;
    return MeasurableNotionConcept_getInstance().v6r(context, nodeId);
  }
  function ObjectPropertyDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ObjectPropertyDeclarationConcept_getInstance().e6r_1) : nodeId;
    return ObjectPropertyDeclarationConcept_getInstance().v6r(context, nodeId);
  }
  function NoValues_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NoValuesConcept_getInstance().e6r_1) : nodeId;
    return NoValuesConcept_getInstance().v6r(context, nodeId);
  }
  function MultiplePropertyValueRange_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MultiplePropertyValueRangeConcept_getInstance().e6r_1) : nodeId;
    return MultiplePropertyValueRangeConcept_getInstance().v6r(context, nodeId);
  }
  function SinglePropertyValueRange_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(SinglePropertyValueRangeConcept_getInstance().e6r_1) : nodeId;
    return SinglePropertyValueRangeConcept_getInstance().v6r(context, nodeId);
  }
  function PropertyConstraint_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyConstraintConcept_getInstance().e6r_1) : nodeId;
    return PropertyConstraintConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyElementSynonym_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementSynonymConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementSynonymConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyElementDefinition_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementDefinitionConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementDefinitionConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyIsRelation_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyIsRelationConcept_getInstance().e6r_1) : nodeId;
    return OntologyIsRelationConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyCardinalityRelation_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyCardinalityRelationConcept_getInstance().e6r_1) : nodeId;
    return OntologyCardinalityRelationConcept_getInstance().v6r(context, nodeId);
  }
  function ProcessReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessReferenceConcept_getInstance().e6r_1) : nodeId;
    return ProcessReferenceConcept_getInstance().v6r(context, nodeId);
  }
  function ProcessProperty_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyConcept_getInstance().e6r_1) : nodeId;
    return ProcessPropertyConcept_getInstance().v6r(context, nodeId);
  }
  function MultipleProcessPropertyValueRange_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MultipleProcessPropertyValueRangeConcept_getInstance().e6r_1) : nodeId;
    return MultipleProcessPropertyValueRangeConcept_getInstance().v6r(context, nodeId);
  }
  function ProcessPropertyDefault_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyDefaultConcept_getInstance().e6r_1) : nodeId;
    return ProcessPropertyDefaultConcept_getInstance().v6r(context, nodeId);
  }
  function EmptyBindingEntry_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EmptyBindingEntryConcept_getInstance().e6r_1) : nodeId;
    return EmptyBindingEntryConcept_getInstance().v6r(context, nodeId);
  }
  function EmptyPropertyLibraryElement_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EmptyPropertyLibraryElementConcept_getInstance().e6r_1) : nodeId;
    return EmptyPropertyLibraryElementConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyLink_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLinkConcept_getInstance().e6r_1) : nodeId;
    return OntologyLinkConcept_getInstance().v6r(context, nodeId);
  }
  function BindingProperty_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BindingPropertyConcept_getInstance().e6r_1) : nodeId;
    return BindingPropertyConcept_getInstance().v6r(context, nodeId);
  }
  function ImportedLink_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ImportedLinkConcept_getInstance().e6r_1) : nodeId;
    return ImportedLinkConcept_getInstance().v6r(context, nodeId);
  }
  function ImportedProperty_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ImportedPropertyConcept_getInstance().e6r_1) : nodeId;
    return ImportedPropertyConcept_getInstance().v6r(context, nodeId);
  }
  function PropertyValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyValueConcept_getInstance().e6r_1) : nodeId;
    return PropertyValueConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyLinkValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLinkValueConcept_getInstance().e6r_1) : nodeId;
    return OntologyLinkValueConcept_getInstance().v6r(context, nodeId);
  }
  function ProcessPropertyValue_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyValueConcept_getInstance().e6r_1) : nodeId;
    return ProcessPropertyValueConcept_getInstance().v6r(context, nodeId);
  }
  function PropertyDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyDeclarationConcept_getInstance().e6r_1) : nodeId;
    return PropertyDeclarationConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyElementPropertyType_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementPropertyTypeConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementPropertyTypeConcept_getInstance().v6r(context, nodeId);
  }
  function LibraryProcessSpecificationQuery_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LibraryProcessSpecificationQueryConcept_getInstance().e6r_1) : nodeId;
    return LibraryProcessSpecificationQueryConcept_getInstance().v6r(context, nodeId);
  }
  function FindConnectionCommand_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FindConnectionCommandConcept_getInstance().e6r_1) : nodeId;
    return FindConnectionCommandConcept_getInstance().v6r(context, nodeId);
  }
  function ContextQuery_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ContextQueryConcept_getInstance().e6r_1) : nodeId;
    return ContextQueryConcept_getInstance().v6r(context, nodeId);
  }
  function OrValueQuery_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OrValueQueryConcept_getInstance().e6r_1) : nodeId;
    return OrValueQueryConcept_getInstance().v6r(context, nodeId);
  }
  function BindingValueMask_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BindingValueMaskConcept_getInstance().e6r_1) : nodeId;
    return BindingValueMaskConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyLinkDeclarationValueQuery_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLinkDeclarationValueQueryConcept_getInstance().e6r_1) : nodeId;
    return OntologyLinkDeclarationValueQueryConcept_getInstance().v6r(context, nodeId);
  }
  function PropertyDeclarationValueQuery_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyDeclarationValueQueryConcept_getInstance().e6r_1) : nodeId;
    return PropertyDeclarationValueQueryConcept_getInstance().v6r(context, nodeId);
  }
  function ClassExpressionType_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ClassExpressionTypeConcept_getInstance().e6r_1) : nodeId;
    return ClassExpressionTypeConcept_getInstance().v6r(context, nodeId);
  }
  function ExtensionFieldReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ExtensionFieldReferenceConcept_getInstance().e6r_1) : nodeId;
    return ExtensionFieldReferenceConcept_getInstance().v6r(context, nodeId);
  }
  function BindingValuePlaceholder_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BindingValuePlaceholderConcept_getInstance().e6r_1) : nodeId;
    return BindingValuePlaceholderConcept_getInstance().v6r(context, nodeId);
  }
  function FactSet_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactSetConcept_getInstance().e6r_1) : nodeId;
    return FactSetConcept_getInstance().v6r(context, nodeId);
  }
  function Fact_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactConcept_getInstance().e6r_1) : nodeId;
    return FactConcept_getInstance().v6r(context, nodeId);
  }
  function ExtensionDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ExtensionDeclarationConcept_getInstance().e6r_1) : nodeId;
    return ExtensionDeclarationConcept_getInstance().v6r(context, nodeId);
  }
  function FactReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactReferenceConcept_getInstance().e6r_1) : nodeId;
    return FactReferenceConcept_getInstance().v6r(context, nodeId);
  }
  function FunctionDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FunctionDeclarationConcept_getInstance().e6r_1) : nodeId;
    return FunctionDeclarationConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyElement_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementConcept_getInstance().v6r(context, nodeId);
  }
  function LocalOntologyElementReference_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LocalOntologyElementReferenceConcept_getInstance().e6r_1) : nodeId;
    return LocalOntologyElementReferenceConcept_getInstance().v6r(context, nodeId);
  }
  function ProcessDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessDeclarationConcept_getInstance().e6r_1) : nodeId;
    return ProcessDeclarationConcept_getInstance().v6r(context, nodeId);
  }
  function ProcessKind_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessKindConcept_getInstance().e6r_1) : nodeId;
    return ProcessKindConcept_getInstance().v6r(context, nodeId);
  }
  function BindingValuePlaceholderQuery_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BindingValuePlaceholderQueryConcept_getInstance().e6r_1) : nodeId;
    return BindingValuePlaceholderQueryConcept_getInstance().v6r(context, nodeId);
  }
  function ProcessRelationDeclaration_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessRelationDeclarationConcept_getInstance().e6r_1) : nodeId;
    return ProcessRelationDeclarationConcept_getInstance().v6r(context, nodeId);
  }
  function OntologyImport_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyImportConcept_getInstance().e6r_1) : nodeId;
    return OntologyImportConcept_getInstance().v6r(context, nodeId);
  }
  function BTBDocument_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BTBDocumentConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = BTBDocumentConcept_getInstance().v6r(context, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.BTBDocument.<anonymous>' call
    new Model(toOtNode(this_0));
    return this_0;
  }
  function OntologyImportRoot_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyImportRootConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = OntologyImportRootConcept_getInstance().v6r(context, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.OntologyImportRoot.<anonymous>' call
    new Model(toOtNode(this_0));
    return this_0;
  }
  function OntologyLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLibraryConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = OntologyLibraryConcept_getInstance().v6r(context, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.OntologyLibrary.<anonymous>' call
    new Model(toOtNode(this_0));
    return this_0;
  }
  function ProcessKindContainer_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessKindContainerConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ProcessKindContainerConcept_getInstance().v6r(context, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.ProcessKindContainer.<anonymous>' call
    new Model(toOtNode(this_0));
    return this_0;
  }
  function ProcessLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessLibraryConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ProcessLibraryConcept_getInstance().v6r(context, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.ProcessLibrary.<anonymous>' call
    new Model(toOtNode(this_0));
    return this_0;
  }
  function RelationContainer_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(RelationContainerConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = RelationContainerConcept_getInstance().v6r(context, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.RelationContainer.<anonymous>' call
    new Model(toOtNode(this_0));
    return this_0;
  }
  function NotionLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NotionLibraryConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = NotionLibraryConcept_getInstance().v6r(context, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.NotionLibrary.<anonymous>' call
    new Model(toOtNode(this_0));
    return this_0;
  }
  function FunctionLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FunctionLibraryConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = FunctionLibraryConcept_getInstance().v6r(context, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.FunctionLibrary.<anonymous>' call
    new Model(toOtNode(this_0));
    return this_0;
  }
  function ExtensionLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ExtensionLibraryConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ExtensionLibraryConcept_getInstance().v6r(context, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.ExtensionLibrary.<anonymous>' call
    new Model(toOtNode(this_0));
    return this_0;
  }
  function PropertyLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyLibraryConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = PropertyLibraryConcept_getInstance().v6r(context, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.PropertyLibrary.<anonymous>' call
    new Model(toOtNode(this_0));
    return this_0;
  }
  function LinkLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LinkLibraryConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = LinkLibraryConcept_getInstance().v6r(context, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.LinkLibrary.<anonymous>' call
    new Model(toOtNode(this_0));
    return this_0;
  }
  function PublishedSourcesLibrary_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PublishedSourcesLibraryConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = PublishedSourcesLibraryConcept_getInstance().v6r(context, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.PublishedSourcesLibrary.<anonymous>' call
    new Model(toOtNode(this_0));
    return this_0;
  }
  function QueryCommands_0(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(QueryCommandsConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = QueryCommandsConcept_getInstance().v6r(context, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.QueryCommands.<anonymous>' call
    new Model(toOtNode(this_0));
    return this_0;
  }
  function ConstantPrecondition(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ConstantPreconditionConcept_getInstance().e6r_1) : nodeId;
    return ConstantPreconditionConcept_getInstance().v6r(context, nodeId);
  }
  function NewFactReference(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NewFactReferenceConcept_getInstance().e6r_1) : nodeId;
    return NewFactReferenceConcept_getInstance().v6r(context, nodeId);
  }
  function ModifierFactExpression(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ModifierFactExpressionConcept_getInstance().e6r_1) : nodeId;
    return ModifierFactExpressionConcept_getInstance().v6r(context, nodeId);
  }
  function ProcessPrerequisite(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPrerequisiteConcept_getInstance().e6r_1) : nodeId;
    return ProcessPrerequisiteConcept_getInstance().v6r(context, nodeId);
  }
  function ProcessEffect(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessEffectConcept_getInstance().e6r_1) : nodeId;
    return ProcessEffectConcept_getInstance().v6r(context, nodeId);
  }
  function NotionType(context, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NotionTypeConcept_getInstance().e6r_1) : nodeId;
    return NotionTypeConcept_getInstance().v6r(context, nodeId);
  }
  function GeneratedBioKbStuff() {
  }
  protoOf(GeneratedBioKbStuff).xar = function () {
    return new BioKbOtStructureRuntime();
  };
  var GeneratedBioKbStuff_instance;
  function GeneratedBioKbStuff_getInstance() {
    return GeneratedBioKbStuff_instance;
  }
  function AbstractBindingDeclarationConcept() {
    AbstractBindingDeclarationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance(), HasCommentsConcept_getInstance()]));
    var tmp = this;
    var tmp2 = ontologyElements$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'ontologyElements';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(AbstractBindingDeclaration), tmp2);
    tmp.eas_1 = this.e6q(tmp$ret$0, name);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = entries$factory();
    var tmp$ret$2 = new MultipleChildLink(getKClass(AbstractBindingDeclaration), this_0);
    tmp_0.fas_1 = this.e6q(tmp$ret$2, 'entries');
    var tmp_1 = this;
    var tmp2_0 = properties$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_0 = 'properties';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$4 = new MultipleChildLink(getKClass(AbstractBindingDeclaration), tmp2_0);
    tmp_1.gas_1 = this.e6q(tmp$ret$4, name_0);
    var tmp_2 = this;
    var tmp2_1 = customEditor$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_1 = 'customEditor';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$6 = new SingleChildLink(getKClass(AbstractBindingDeclaration), tmp2_1);
    tmp_2.has_1 = this.d6q(tmp$ret$6, name_1);
    this.ias_1 = this.g6q(customEditorEnabled$factory(), 'customEditorEnabled');
    this.jas_1 = new DomainNodeChildrenPropertyDescriptor(this.eas_1.h6n_1);
    this.kas_1 = new DomainNodeChildrenPropertyDescriptor(this.fas_1.h6n_1);
    this.las_1 = new DomainNodeChildrenPropertyDescriptor(this.gas_1.h6n_1);
    this.mas_1 = new DomainNodeChildPropertyDescriptor(this.has_1.h6n_1);
    this.nas_1 = new DomainNodePropertyDescriptor(this.ias_1, toNonNullPersister(NonNullPersisters_getInstance().l2q(), new DefaultValueNullPersister(false)));
  }
  var AbstractBindingDeclarationConcept_instance;
  function AbstractBindingDeclarationConcept_getInstance() {
    if (AbstractBindingDeclarationConcept_instance == null)
      new AbstractBindingDeclarationConcept();
    return AbstractBindingDeclarationConcept_instance;
  }
  function ontologyElements$factory() {
    return getPropertyCallableRef('ontologyElements', 1, KProperty1, function (receiver) {
      return receiver.oas();
    }, null);
  }
  function entries$factory() {
    return getPropertyCallableRef('entries', 1, KProperty1, function (receiver) {
      return receiver.w();
    }, null);
  }
  function properties$factory() {
    return getPropertyCallableRef('properties', 1, KProperty1, function (receiver) {
      return receiver.pas();
    }, null);
  }
  function customEditor$factory() {
    return getPropertyCallableRef('customEditor', 1, KProperty1, function (receiver) {
      return receiver.qas();
    }, null);
  }
  function customEditorEnabled$factory() {
    return getPropertyCallableRef('customEditorEnabled', 1, KProperty1, function (receiver) {
      return receiver.ras();
    }, null);
  }
  function AbstractBindingEntryConcept() {
    AbstractBindingEntryConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var AbstractBindingEntryConcept_instance;
  function AbstractBindingEntryConcept_getInstance() {
    if (AbstractBindingEntryConcept_instance == null)
      new AbstractBindingEntryConcept();
    return AbstractBindingEntryConcept_instance;
  }
  function AbstractBindingValueConcept() {
    AbstractBindingValueConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([BindingValuePlaceholderConcept_getInstance()]));
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = value$factory();
    var tmp$ret$0 = new SingleChildLink(getKClass(AbstractBindingValue), this_0);
    tmp.yas_1 = this.d6q(tmp$ret$0, 'value');
    this.zas_1 = new DomainNodeChildPropertyDescriptor(this.yas_1.h6n_1);
  }
  var AbstractBindingValueConcept_instance;
  function AbstractBindingValueConcept_getInstance() {
    if (AbstractBindingValueConcept_instance == null)
      new AbstractBindingValueConcept();
    return AbstractBindingValueConcept_instance;
  }
  function value$factory() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function AbstractBindingValueQueryConcept() {
    AbstractBindingValueQueryConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([BindingValuePlaceholderQueryConcept_getInstance()]));
  }
  var AbstractBindingValueQueryConcept_instance;
  function AbstractBindingValueQueryConcept_getInstance() {
    if (AbstractBindingValueQueryConcept_instance == null)
      new AbstractBindingValueQueryConcept();
    return AbstractBindingValueQueryConcept_instance;
  }
  function AbstractLinkConcept() {
    AbstractLinkConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([AbstractBindingEntryConcept_getInstance()]));
    var tmp = this;
    var tmp2 = specializes$factory();
    var tmp3 = Companion_getInstance_201().aat_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'specializes';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(AbstractLink), tmp2, getKClass(AbstractLink));
    tmp.hat_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.iat_1 = new DomainNodeReferencePropertyDescriptor(this.hat_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var AbstractLinkConcept_instance;
  function AbstractLinkConcept_getInstance() {
    if (AbstractLinkConcept_instance == null)
      new AbstractLinkConcept();
    return AbstractLinkConcept_instance;
  }
  function specializes$factory() {
    return getPropertyCallableRef('specializes', 1, KProperty1, function (receiver) {
      return receiver.jat();
    }, null);
  }
  function AbstractNotionConcept() {
    AbstractNotionConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
  }
  var AbstractNotionConcept_instance;
  function AbstractNotionConcept_getInstance() {
    if (AbstractNotionConcept_instance == null)
      new AbstractNotionConcept();
    return AbstractNotionConcept_instance;
  }
  function AbstractOntologyRelationConcept() {
    AbstractOntologyRelationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var AbstractOntologyRelationConcept_instance;
  function AbstractOntologyRelationConcept_getInstance() {
    if (AbstractOntologyRelationConcept_instance == null)
      new AbstractOntologyRelationConcept();
    return AbstractOntologyRelationConcept_instance;
  }
  function AbstractProcessSpecificationConcept() {
    AbstractProcessSpecificationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var AbstractProcessSpecificationConcept_instance;
  function AbstractProcessSpecificationConcept_getInstance() {
    if (AbstractProcessSpecificationConcept_instance == null)
      new AbstractProcessSpecificationConcept();
    return AbstractProcessSpecificationConcept_instance;
  }
  function AbstractPropertyConcept() {
    AbstractPropertyConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([AbstractBindingEntryConcept_getInstance()]));
  }
  var AbstractPropertyConcept_instance;
  function AbstractPropertyConcept_getInstance() {
    if (AbstractPropertyConcept_instance == null)
      new AbstractPropertyConcept();
    return AbstractPropertyConcept_instance;
  }
  function AbstractValueConcept() {
    AbstractValueConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var AbstractValueConcept_instance;
  function AbstractValueConcept_getInstance() {
    if (AbstractValueConcept_instance == null)
      new AbstractValueConcept();
    return AbstractValueConcept_instance;
  }
  function AnonymousClassConcept() {
    AnonymousClassConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([ClassExpressionConcept_getInstance(), ClassDeclarationConcept_getInstance(), AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance()]));
  }
  var AnonymousClassConcept_instance;
  function AnonymousClassConcept_getInstance() {
    if (AnonymousClassConcept_instance == null)
      new AnonymousClassConcept();
    return AnonymousClassConcept_instance;
  }
  function AuthorImpl$_init_$ref_3dxjqy() {
    var l = function (p0, p1) {
      return new AuthorImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function AuthorConcept$_init_$lambda_rm44xa(context, nodeId) {
    return new TypedAuthorImpl(context, VOID, nodeId);
  }
  function AuthorConcept() {
    AuthorConcept_instance = this;
    var tmp = AuthorImpl$_init_$ref_3dxjqy();
    OtConceptDescriptor.call(this, 'Author', VOID, tmp, AuthorConcept$_init_$lambda_rm44xa, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
  }
  var AuthorConcept_instance;
  function AuthorConcept_getInstance() {
    if (AuthorConcept_instance == null)
      new AuthorConcept();
    return AuthorConcept_instance;
  }
  function AuthoredWorkImpl$_init_$ref_2tbewa() {
    var l = function (p0, p1) {
      return new AuthoredWorkImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function AuthoredWorkConcept$_init_$lambda_hq3c3i(context, nodeId) {
    return new TypedAuthoredWorkImpl(context, VOID, nodeId);
  }
  function AuthoredWorkConcept() {
    AuthoredWorkConcept_instance = this;
    var tmp = AuthoredWorkImpl$_init_$ref_2tbewa();
    OtConceptDescriptor.call(this, 'AuthoredWork', VOID, tmp, AuthoredWorkConcept$_init_$lambda_hq3c3i);
    var tmp_0 = this;
    var tmp2 = authors$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'authors_list';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(AuthoredWork), tmp2);
    tmp_0.uat_1 = this.e6q(tmp$ret$0, name);
    this.vat_1 = this.g6q(title$factory(), 'title');
    this.wat_1 = new DomainNodeChildrenPropertyDescriptor(this.uat_1.h6n_1);
    this.xat_1 = new DomainNodePropertyDescriptor(this.vat_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
  }
  var AuthoredWorkConcept_instance;
  function AuthoredWorkConcept_getInstance() {
    if (AuthoredWorkConcept_instance == null)
      new AuthoredWorkConcept();
    return AuthoredWorkConcept_instance;
  }
  function authors$factory() {
    return getPropertyCallableRef('authors', 1, KProperty1, function (receiver) {
      return receiver.yat();
    }, null);
  }
  function title$factory() {
    return getPropertyCallableRef('title', 1, KProperty1, function (receiver) {
      return receiver.zat();
    }, null);
  }
  function BTBDocumentImpl$_init_$ref_6ye4qi() {
    var l = function (p0, p1) {
      return new BTBDocumentImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function BTBDocumentConcept$_init_$lambda_3ce17y(context, nodeId) {
    return new TypedBTBDocumentImpl(context, VOID, nodeId);
  }
  function BTBDocumentConcept() {
    BTBDocumentConcept_instance = this;
    var tmp = BTBDocumentImpl$_init_$ref_6ye4qi();
    OtConceptDescriptor.call(this, 'BTBDocument', VOID, tmp, BTBDocumentConcept$_init_$lambda_3ce17y, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    this.kau_1 = this.i6q(factSets$factory(), 'factSets');
    this.lau_1 = this.i6q(categories$factory(), 'categories');
    this.mau_1 = this.i6q(imports$factory(), 'imports');
    this.nau_1 = new DomainNodeChildrenPropertyDescriptor(this.kau_1);
    this.oau_1 = new DomainNodeChildrenPropertyDescriptor(this.lau_1);
    this.pau_1 = new DomainNodeChildrenPropertyDescriptor(this.mau_1);
  }
  var BTBDocumentConcept_instance;
  function BTBDocumentConcept_getInstance() {
    if (BTBDocumentConcept_instance == null)
      new BTBDocumentConcept();
    return BTBDocumentConcept_instance;
  }
  function factSets$factory() {
    return getPropertyCallableRef('factSets', 1, KProperty1, function (receiver) {
      return receiver.qau();
    }, null);
  }
  function categories$factory() {
    return getPropertyCallableRef('categories', 1, KProperty1, function (receiver) {
      return receiver.rau();
    }, null);
  }
  function imports$factory() {
    return getPropertyCallableRef('imports', 1, KProperty1, function (receiver) {
      return receiver.sau();
    }, null);
  }
  function BindingPropertyImpl$_init_$ref_d0d8rv() {
    var l = function (p0, p1) {
      return new BindingPropertyImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function BindingPropertyConcept$_init_$lambda_4epohp(context, nodeId) {
    return new TypedBindingPropertyImpl(context, VOID, nodeId);
  }
  function BindingPropertyConcept() {
    BindingPropertyConcept_instance = this;
    var tmp = BindingPropertyImpl$_init_$ref_d0d8rv();
    OtConceptDescriptor.call(this, 'BindingProperty', VOID, tmp, BindingPropertyConcept$_init_$lambda_4epohp, Companion_instance_95.z6p([AbstractPropertyConcept_getInstance()]));
    this.dav_1 = this.h6q(property$factory(), 'property');
    this.eav_1 = new DomainNodeChildPropertyDescriptor(this.dav_1);
  }
  var BindingPropertyConcept_instance;
  function BindingPropertyConcept_getInstance() {
    if (BindingPropertyConcept_instance == null)
      new BindingPropertyConcept();
    return BindingPropertyConcept_instance;
  }
  function property$factory() {
    return getPropertyCallableRef('property', 1, KProperty1, function (receiver) {
      return receiver.i6u();
    }, null);
  }
  function BindingValueMaskImpl$_init_$ref_yxhrh() {
    var l = function (p0, p1) {
      return new BindingValueMaskImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function BindingValueMaskConcept$_init_$lambda_uabsud(context, nodeId) {
    return new TypedBindingValueMaskImpl(context, VOID, nodeId);
  }
  function BindingValueMaskConcept() {
    BindingValueMaskConcept_instance = this;
    var tmp = BindingValueMaskImpl$_init_$ref_yxhrh();
    OtConceptDescriptor.call(this, 'BindingValueMask', VOID, tmp, BindingValueMaskConcept$_init_$lambda_uabsud, Companion_instance_95.z6p([AbstractBindingValueQueryConcept_getInstance()]));
    this.pav_1 = this.h6q(value$factory_0(), 'value');
    this.qav_1 = new DomainNodeChildPropertyDescriptor(this.pav_1);
  }
  var BindingValueMaskConcept_instance;
  function BindingValueMaskConcept_getInstance() {
    if (BindingValueMaskConcept_instance == null)
      new BindingValueMaskConcept();
    return BindingValueMaskConcept_instance;
  }
  function value$factory_0() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function BindingValuePlaceholderImpl$_init_$ref_5w9ztq() {
    var l = function (p0, p1) {
      return new BindingValuePlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function BindingValuePlaceholderConcept$_init_$lambda_g8hwmu(context, nodeId) {
    return new TypedBindingValuePlaceholderImpl(context, VOID, nodeId);
  }
  function BindingValuePlaceholderConcept() {
    BindingValuePlaceholderConcept_instance = this;
    var tmp = BindingValuePlaceholderImpl$_init_$ref_5w9ztq();
    OtConceptDescriptor.call(this, 'BindingValuePlaceholder', VOID, tmp, BindingValuePlaceholderConcept$_init_$lambda_g8hwmu);
  }
  var BindingValuePlaceholderConcept_instance;
  function BindingValuePlaceholderConcept_getInstance() {
    if (BindingValuePlaceholderConcept_instance == null)
      new BindingValuePlaceholderConcept();
    return BindingValuePlaceholderConcept_instance;
  }
  function BindingValuePlaceholderQueryImpl$_init_$ref_2h3rj0() {
    var l = function (p0, p1) {
      return new BindingValuePlaceholderQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function BindingValuePlaceholderQueryConcept$_init_$lambda_szxmbg(context, nodeId) {
    return new TypedBindingValuePlaceholderQueryImpl(context, VOID, nodeId);
  }
  function BindingValuePlaceholderQueryConcept() {
    BindingValuePlaceholderQueryConcept_instance = this;
    var tmp = BindingValuePlaceholderQueryImpl$_init_$ref_2h3rj0();
    OtConceptDescriptor.call(this, 'BindingValuePlaceholderQuery', VOID, tmp, BindingValuePlaceholderQueryConcept$_init_$lambda_szxmbg);
  }
  var BindingValuePlaceholderQueryConcept_instance;
  function BindingValuePlaceholderQueryConcept_getInstance() {
    if (BindingValuePlaceholderQueryConcept_instance == null)
      new BindingValuePlaceholderQueryConcept();
    return BindingValuePlaceholderQueryConcept_instance;
  }
  function BookImpl$_init_$ref_1p7hng() {
    var l = function (p0, p1) {
      return new BookImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function BookConcept$_init_$lambda_rvnjpo(context, nodeId) {
    return new TypedBookImpl(context, VOID, nodeId);
  }
  function BookConcept() {
    BookConcept_instance = this;
    var tmp = BookImpl$_init_$ref_1p7hng();
    OtConceptDescriptor.call(this, 'Book', VOID, tmp, BookConcept$_init_$lambda_rvnjpo, Companion_instance_95.z6p([PublishedWorkConcept_getInstance(), LibraryItemConcept_getInstance()]));
    this.baw_1 = this.g6q(edition$factory(), 'edition');
    this.caw_1 = new DomainNodePropertyDescriptor(this.baw_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
  }
  var BookConcept_instance;
  function BookConcept_getInstance() {
    if (BookConcept_instance == null)
      new BookConcept();
    return BookConcept_instance;
  }
  function edition$factory() {
    return getPropertyCallableRef('edition', 1, KProperty1, function (receiver) {
      return receiver.daw();
    }, null);
  }
  function CardinalityBoundImpl$_init_$ref_iazhjp() {
    var l = function (p0, p1) {
      return new CardinalityBoundImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CardinalityBoundConcept$_init_$lambda_qvwo9f(context, nodeId) {
    return new TypedCardinalityBoundImpl(context, VOID, nodeId);
  }
  function CardinalityBoundConcept() {
    CardinalityBoundConcept_instance = this;
    var tmp = CardinalityBoundImpl$_init_$ref_iazhjp();
    OtConceptDescriptor.call(this, 'CardinalityBound', VOID, tmp, CardinalityBoundConcept$_init_$lambda_qvwo9f);
  }
  var CardinalityBoundConcept_instance;
  function CardinalityBoundConcept_getInstance() {
    if (CardinalityBoundConcept_instance == null)
      new CardinalityBoundConcept();
    return CardinalityBoundConcept_instance;
  }
  function CardinalityBoundConstantImpl$_init_$ref_4ykgj3() {
    var l = function (p0, p1) {
      return new CardinalityBoundConstantImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CardinalityBoundConstantConcept$_init_$lambda_um3s47(context, nodeId) {
    return new TypedCardinalityBoundConstantImpl(context, VOID, nodeId);
  }
  function CardinalityBoundConstantConcept() {
    CardinalityBoundConstantConcept_instance = this;
    var tmp = CardinalityBoundConstantImpl$_init_$ref_4ykgj3();
    OtConceptDescriptor.call(this, 'CardinalityBoundConstant', VOID, tmp, CardinalityBoundConstantConcept$_init_$lambda_um3s47, Companion_instance_95.z6p([CardinalityBoundConcept_getInstance()]));
    this.oaw_1 = this.g6q(value$factory_1(), 'value');
    this.paw_1 = new DomainNodePropertyDescriptor(this.oaw_1, toNonNullPersister(NonNullPersisters_getInstance().j2q()));
  }
  var CardinalityBoundConstantConcept_instance;
  function CardinalityBoundConstantConcept_getInstance() {
    if (CardinalityBoundConstantConcept_instance == null)
      new CardinalityBoundConstantConcept();
    return CardinalityBoundConstantConcept_instance;
  }
  function value$factory_1() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function CardinalityBoundNImpl$_init_$ref_n9bief() {
    var l = function (p0, p1) {
      return new CardinalityBoundNImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CardinalityBoundNConcept$_init_$lambda_p9j5z3(context, nodeId) {
    return new TypedCardinalityBoundNImpl(context, VOID, nodeId);
  }
  function CardinalityBoundNConcept() {
    CardinalityBoundNConcept_instance = this;
    var tmp = CardinalityBoundNImpl$_init_$ref_n9bief();
    OtConceptDescriptor.call(this, 'CardinalityBoundN', VOID, tmp, CardinalityBoundNConcept$_init_$lambda_p9j5z3, Companion_instance_95.z6p([CardinalityBoundConcept_getInstance()]));
  }
  var CardinalityBoundNConcept_instance;
  function CardinalityBoundNConcept_getInstance() {
    if (CardinalityBoundNConcept_instance == null)
      new CardinalityBoundNConcept();
    return CardinalityBoundNConcept_instance;
  }
  function CardinalityBoundPlaceholderImpl$_init_$ref_ksoo8u() {
    var l = function (p0, p1) {
      return new CardinalityBoundPlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CardinalityBoundPlaceholderConcept$_init_$lambda_8kiy92(context, nodeId) {
    return new TypedCardinalityBoundPlaceholderImpl(context, VOID, nodeId);
  }
  function CardinalityBoundPlaceholderConcept() {
    CardinalityBoundPlaceholderConcept_instance = this;
    var tmp = CardinalityBoundPlaceholderImpl$_init_$ref_ksoo8u();
    OtConceptDescriptor.call(this, 'CardinalityBoundPlaceholder', VOID, tmp, CardinalityBoundPlaceholderConcept$_init_$lambda_8kiy92);
    this.aax_1 = this.h6q(bound$factory(), 'bound');
    this.bax_1 = new DomainNodeChildPropertyDescriptor(this.aax_1);
  }
  var CardinalityBoundPlaceholderConcept_instance;
  function CardinalityBoundPlaceholderConcept_getInstance() {
    if (CardinalityBoundPlaceholderConcept_instance == null)
      new CardinalityBoundPlaceholderConcept();
    return CardinalityBoundPlaceholderConcept_instance;
  }
  function bound$factory() {
    return getPropertyCallableRef('bound', 1, KProperty1, function (receiver) {
      return receiver.cax();
    }, null);
  }
  function CardinalityImpl$_init_$ref_e6f85z() {
    var l = function (p0, p1) {
      return new CardinalityImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CardinalityConcept$_init_$lambda_l8hgz3(context, nodeId) {
    return new TypedCardinalityImpl(context, VOID, nodeId);
  }
  function CardinalityConcept() {
    CardinalityConcept_instance = this;
    var tmp = CardinalityImpl$_init_$ref_e6f85z();
    OtConceptDescriptor.call(this, 'Cardinality', VOID, tmp, CardinalityConcept$_init_$lambda_l8hgz3);
    this.nax_1 = this.h6q(lowerBound$factory(), 'lowerBound');
    this.oax_1 = this.h6q(upperBound$factory(), 'upperBoundPlaceholder');
    this.pax_1 = this.h6q(deprecatedUpperBound$factory(), 'upperBound');
    this.qax_1 = new DomainNodeChildPropertyDescriptor(this.nax_1);
    this.rax_1 = new DomainNodeChildPropertyDescriptor(this.oax_1);
    this.sax_1 = new DomainNodeChildPropertyDescriptor(this.pax_1);
  }
  var CardinalityConcept_instance;
  function CardinalityConcept_getInstance() {
    if (CardinalityConcept_instance == null)
      new CardinalityConcept();
    return CardinalityConcept_instance;
  }
  function lowerBound$factory() {
    return getPropertyCallableRef('lowerBound', 1, KProperty1, function (receiver) {
      return receiver.tax();
    }, null);
  }
  function upperBound$factory() {
    return getPropertyCallableRef('upperBound', 1, KProperty1, function (receiver) {
      return receiver.uax();
    }, null);
  }
  function deprecatedUpperBound$factory() {
    return getPropertyCallableRef('deprecatedUpperBound', 1, KProperty1, function (receiver) {
      return receiver.vax();
    }, null);
  }
  function CardinalityCustomCellImpl$_init_$ref_a34zvo() {
    var l = function (p0, p1) {
      return new CardinalityCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CardinalityCustomCellConcept$_init_$lambda_cbn9xg(context, nodeId) {
    return new TypedCardinalityCustomCellImpl(context, VOID, nodeId);
  }
  function CardinalityCustomCellConcept() {
    CardinalityCustomCellConcept_instance = this;
    var tmp = CardinalityCustomCellImpl$_init_$ref_a34zvo();
    OtConceptDescriptor.call(this, 'CardinalityCustomCell', VOID, tmp, CardinalityCustomCellConcept$_init_$lambda_cbn9xg, Companion_instance_95.z6p([CustomCellConcept_getInstance()]));
  }
  var CardinalityCustomCellConcept_instance;
  function CardinalityCustomCellConcept_getInstance() {
    if (CardinalityCustomCellConcept_instance == null)
      new CardinalityCustomCellConcept();
    return CardinalityCustomCellConcept_instance;
  }
  function CategoryImpl$_init_$ref_yj9xg9() {
    var l = function (p0, p1) {
      return new CategoryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CategoryConcept$_init_$lambda_ldaz5t(context, nodeId) {
    return new TypedCategoryImpl(context, VOID, nodeId);
  }
  function CategoryConcept() {
    CategoryConcept_instance = this;
    var tmp = CategoryImpl$_init_$ref_yj9xg9();
    OtConceptDescriptor.call(this, 'Category', VOID, tmp, CategoryConcept$_init_$lambda_ldaz5t);
    this.gay_1 = this.h6q(library$factory(), 'library');
    this.hay_1 = this.h6q(element$factory(), 'element');
    this.iay_1 = new DomainNodeChildPropertyDescriptor(this.gay_1);
    this.jay_1 = new DomainNodeChildPropertyDescriptor(this.hay_1);
  }
  var CategoryConcept_instance;
  function CategoryConcept_getInstance() {
    if (CategoryConcept_instance == null)
      new CategoryConcept();
    return CategoryConcept_instance;
  }
  function library$factory() {
    return getPropertyCallableRef('library', 1, KProperty1, function (receiver) {
      return receiver.kay();
    }, null);
  }
  function element$factory() {
    return getPropertyCallableRef('element', 1, KProperty1, function (receiver) {
      return receiver.lay();
    }, null);
  }
  function ClassDeclarationConcept() {
    ClassDeclarationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var ClassDeclarationConcept_instance;
  function ClassDeclarationConcept_getInstance() {
    if (ClassDeclarationConcept_instance == null)
      new ClassDeclarationConcept();
    return ClassDeclarationConcept_instance;
  }
  function ClassExpressionConcept() {
    ClassExpressionConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([ClassExpressionPlaceholderConcept_getInstance()]));
  }
  var ClassExpressionConcept_instance;
  function ClassExpressionConcept_getInstance() {
    if (ClassExpressionConcept_instance == null)
      new ClassExpressionConcept();
    return ClassExpressionConcept_instance;
  }
  function ClassExpressionPlaceholderImpl$_init_$ref_yvwlnm() {
    var l = function (p0, p1) {
      return new ClassExpressionPlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ClassExpressionPlaceholderConcept$_init_$lambda_cileva(context, nodeId) {
    return new TypedClassExpressionPlaceholderImpl(context, VOID, nodeId);
  }
  function ClassExpressionPlaceholderConcept() {
    ClassExpressionPlaceholderConcept_instance = this;
    var tmp = ClassExpressionPlaceholderImpl$_init_$ref_yvwlnm();
    OtConceptDescriptor.call(this, 'ClassExpression', VOID, tmp, ClassExpressionPlaceholderConcept$_init_$lambda_cileva);
  }
  var ClassExpressionPlaceholderConcept_instance;
  function ClassExpressionPlaceholderConcept_getInstance() {
    if (ClassExpressionPlaceholderConcept_instance == null)
      new ClassExpressionPlaceholderConcept();
    return ClassExpressionPlaceholderConcept_instance;
  }
  function ClassExpressionTypeImpl$_init_$ref_os18kb() {
    var l = function (p0, p1) {
      return new ClassExpressionTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ClassExpressionTypeConcept$_init_$lambda_v4kvn(context, nodeId) {
    return new TypedClassExpressionTypeImpl(context, VOID, nodeId);
  }
  function ClassExpressionTypeConcept() {
    ClassExpressionTypeConcept_instance = this;
    var tmp = ClassExpressionTypeImpl$_init_$ref_os18kb();
    OtConceptDescriptor.call(this, 'ClassExpressionType', VOID, tmp, ClassExpressionTypeConcept$_init_$lambda_v4kvn, Companion_instance_95.z6p([TypeConcept_getInstance(), ProcessPropertyTypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = classExpression$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'classExpression';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(ClassExpressionType_1), tmp2);
    tmp_0.way_1 = this.d6q(tmp$ret$0, name);
    this.xay_1 = new DomainNodeChildPropertyDescriptor(this.way_1.h6n_1);
  }
  var ClassExpressionTypeConcept_instance;
  function ClassExpressionTypeConcept_getInstance() {
    if (ClassExpressionTypeConcept_instance == null)
      new ClassExpressionTypeConcept();
    return ClassExpressionTypeConcept_instance;
  }
  function classExpression$factory() {
    return getPropertyCallableRef('classExpression', 1, KProperty1, function (receiver) {
      return receiver.yay();
    }, null);
  }
  function CommandConcept() {
    CommandConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var CommandConcept_instance;
  function CommandConcept_getInstance() {
    if (CommandConcept_instance == null)
      new CommandConcept();
    return CommandConcept_instance;
  }
  function ConstantCustomCellImpl$_init_$ref_4rmnle() {
    var l = function (p0, p1) {
      return new ConstantCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ConstantCustomCellConcept$_init_$lambda_3mzxeu(context, nodeId) {
    return new TypedConstantCustomCellImpl(context, VOID, nodeId);
  }
  function ConstantCustomCellConcept() {
    ConstantCustomCellConcept_instance = this;
    var tmp = ConstantCustomCellImpl$_init_$ref_4rmnle();
    OtConceptDescriptor.call(this, 'ConstantCustomCell', VOID, tmp, ConstantCustomCellConcept$_init_$lambda_3mzxeu, Companion_instance_95.z6p([CustomCellConcept_getInstance()]));
    this.jaz_1 = this.g6q(text$factory(), 'text');
    this.kaz_1 = new DomainNodePropertyDescriptor(this.jaz_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
  }
  var ConstantCustomCellConcept_instance;
  function ConstantCustomCellConcept_getInstance() {
    if (ConstantCustomCellConcept_instance == null)
      new ConstantCustomCellConcept();
    return ConstantCustomCellConcept_instance;
  }
  function text$factory() {
    return getPropertyCallableRef('text', 1, KProperty1, function (receiver) {
      return receiver.laz();
    }, null);
  }
  function ConstantPreconditionImpl$_init_$ref_i7ey2f() {
    var l = function (p0, p1) {
      return new ConstantPreconditionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ConstantPreconditionConcept$_init_$lambda_qup7q7(context, nodeId) {
    return new TypedConstantPreconditionImpl(context, VOID, nodeId);
  }
  function ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_9();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1).maz = function (value) {
    return value.toString();
  };
  protoOf(ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1).x2p = function (value) {
    return this.maz(value instanceof When ? value : THROW_CCE());
  };
  protoOf(ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_9();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1).maz = function (value) {
    return value.toString();
  };
  protoOf(ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1).x2p = function (value) {
    return this.maz(value instanceof When ? value : THROW_CCE());
  };
  protoOf(ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function ConstantPreconditionConcept() {
    ConstantPreconditionConcept_instance = this;
    var tmp = ConstantPreconditionImpl$_init_$ref_i7ey2f();
    OtConceptDescriptor.call(this, 'ConstantPrecondition', VOID, tmp, ConstantPreconditionConcept$_init_$lambda_qup7q7, Companion_instance_95.z6p([PreconditionConcept_getInstance()]));
    this.xaz_1 = this.g6q(kind$factory(), 'kind');
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$0 = new ConstantPreconditionConcept$KIND_PERSISTER$$inlined$enumPersister$1();
    tmp_0.yaz_1 = toNullablePersister(tmp$ret$0);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$1 = new ConstantPreconditionConcept$kindPropertyDescriptor$$inlined$enumPersister$1();
    tmp_1.zaz_1 = new DomainNodePropertyDescriptor(this.xaz_1, toNullablePersister(tmp$ret$1));
  }
  var ConstantPreconditionConcept_instance;
  function ConstantPreconditionConcept_getInstance() {
    if (ConstantPreconditionConcept_instance == null)
      new ConstantPreconditionConcept();
    return ConstantPreconditionConcept_instance;
  }
  function kind$factory() {
    return getPropertyCallableRef('kind', 1, KProperty1, function (receiver) {
      return receiver.r5e();
    }, null);
  }
  function ContextImpl$_init_$ref_y1alzq() {
    var l = function (p0, p1) {
      return new ContextImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ContextConcept$_init_$lambda_sz1t8y(context, nodeId) {
    return new TypedContextImpl(context, VOID, nodeId);
  }
  function ContextConcept() {
    ContextConcept_instance = this;
    var tmp = ContextImpl$_init_$ref_y1alzq();
    OtConceptDescriptor.call(this, 'Context', VOID, tmp, ContextConcept$_init_$lambda_sz1t8y, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
    this.kb0_1 = this.h6q(library$factory_0(), 'library');
    this.lb0_1 = this.h6q(element$factory_0(), 'element');
    this.mb0_1 = new DomainNodeChildPropertyDescriptor(this.kb0_1);
    this.nb0_1 = new DomainNodeChildPropertyDescriptor(this.lb0_1);
  }
  var ContextConcept_instance;
  function ContextConcept_getInstance() {
    if (ContextConcept_instance == null)
      new ContextConcept();
    return ContextConcept_instance;
  }
  function library$factory_0() {
    return getPropertyCallableRef('library', 1, KProperty1, function (receiver) {
      return receiver.kay();
    }, null);
  }
  function element$factory_0() {
    return getPropertyCallableRef('element', 1, KProperty1, function (receiver) {
      return receiver.lay();
    }, null);
  }
  function ContextQueryImpl$_init_$ref_jz0o5w() {
    var l = function (p0, p1) {
      return new ContextQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ContextQueryConcept$_init_$lambda_o1905g(context, nodeId) {
    return new TypedContextQueryImpl(context, VOID, nodeId);
  }
  function ContextQueryConcept() {
    ContextQueryConcept_instance = this;
    var tmp = ContextQueryImpl$_init_$ref_jz0o5w();
    OtConceptDescriptor.call(this, 'ContextQuery', VOID, tmp, ContextQueryConcept$_init_$lambda_o1905g);
    this.yb0_1 = this.h6q(library$factory_1(), 'library');
    this.zb0_1 = this.h6q(element$factory_1(), 'element');
    this.ab1_1 = new DomainNodeChildPropertyDescriptor(this.yb0_1);
    this.bb1_1 = new DomainNodeChildPropertyDescriptor(this.zb0_1);
  }
  var ContextQueryConcept_instance;
  function ContextQueryConcept_getInstance() {
    if (ContextQueryConcept_instance == null)
      new ContextQueryConcept();
    return ContextQueryConcept_instance;
  }
  function library$factory_1() {
    return getPropertyCallableRef('library', 1, KProperty1, function (receiver) {
      return receiver.kay();
    }, null);
  }
  function element$factory_1() {
    return getPropertyCallableRef('element', 1, KProperty1, function (receiver) {
      return receiver.lay();
    }, null);
  }
  function CustomCellConcept() {
    CustomCellConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var CustomCellConcept_instance;
  function CustomCellConcept_getInstance() {
    if (CustomCellConcept_instance == null)
      new CustomCellConcept();
    return CustomCellConcept_instance;
  }
  function CustomEditorImpl$_init_$ref_7f9dlz() {
    var l = function (p0, p1) {
      return new CustomEditorImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CustomEditorConcept$_init_$lambda_bashc1(context, nodeId) {
    return new TypedCustomEditorImpl(context, VOID, nodeId);
  }
  function CustomEditorConcept() {
    CustomEditorConcept_instance = this;
    var tmp = CustomEditorImpl$_init_$ref_7f9dlz();
    OtConceptDescriptor.call(this, 'CustomEditor', VOID, tmp, CustomEditorConcept$_init_$lambda_bashc1);
    this.mb1_1 = this.i6q(cells$factory(), 'cells');
    this.nb1_1 = new DomainNodeChildrenPropertyDescriptor(this.mb1_1);
  }
  var CustomEditorConcept_instance;
  function CustomEditorConcept_getInstance() {
    if (CustomEditorConcept_instance == null)
      new CustomEditorConcept();
    return CustomEditorConcept_instance;
  }
  function cells$factory() {
    return getPropertyCallableRef('cells', 1, KProperty1, function (receiver) {
      return receiver.ob1();
    }, null);
  }
  function DeclarationNameCustomCellImpl$_init_$ref_djfdar() {
    var l = function (p0, p1) {
      return new DeclarationNameCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function DeclarationNameCustomCellConcept$_init_$lambda_83cu4l(context, nodeId) {
    return new TypedDeclarationNameCustomCellImpl(context, VOID, nodeId);
  }
  function DeclarationNameCustomCellConcept() {
    DeclarationNameCustomCellConcept_instance = this;
    var tmp = DeclarationNameCustomCellImpl$_init_$ref_djfdar();
    OtConceptDescriptor.call(this, 'DeclarationNameCustomCell', VOID, tmp, DeclarationNameCustomCellConcept$_init_$lambda_83cu4l, Companion_instance_95.z6p([CustomCellConcept_getInstance()]));
  }
  var DeclarationNameCustomCellConcept_instance;
  function DeclarationNameCustomCellConcept_getInstance() {
    if (DeclarationNameCustomCellConcept_instance == null)
      new DeclarationNameCustomCellConcept();
    return DeclarationNameCustomCellConcept_instance;
  }
  function DeclarationValueQueryImpl$_init_$ref_1pv0ic() {
    var l = function (p0, p1) {
      return new DeclarationValueQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function DeclarationValueQueryConcept$_init_$lambda_odg7ys(context, nodeId) {
    return new TypedDeclarationValueQueryImpl(context, VOID, nodeId);
  }
  function DeclarationValueQueryConcept() {
    DeclarationValueQueryConcept_instance = this;
    var tmp = DeclarationValueQueryImpl$_init_$ref_1pv0ic();
    OtConceptDescriptor.call(this, 'DeclarationValueQuery', VOID, tmp, DeclarationValueQueryConcept$_init_$lambda_odg7ys, Companion_instance_95.z6p([AbstractBindingValueQueryConcept_getInstance()]));
    this.zb1_1 = this.h6q(value$factory_2(), 'value');
    this.ab2_1 = new DomainNodeChildPropertyDescriptor(this.zb1_1);
  }
  var DeclarationValueQueryConcept_instance;
  function DeclarationValueQueryConcept_getInstance() {
    if (DeclarationValueQueryConcept_instance == null)
      new DeclarationValueQueryConcept();
    return DeclarationValueQueryConcept_instance;
  }
  function value$factory_2() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function DirectlyNamedConcept() {
    DirectlyNamedConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
    this.hb2_1 = this.g6q(name$factory(), 'name');
    this.ib2_1 = new DomainNodePropertyDescriptor(this.hb2_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
  }
  var DirectlyNamedConcept_instance;
  function DirectlyNamedConcept_getInstance() {
    if (DirectlyNamedConcept_instance == null)
      new DirectlyNamedConcept();
    return DirectlyNamedConcept_instance;
  }
  function name$factory() {
    return getPropertyCallableRef('name', 1, KProperty1, function (receiver) {
      return receiver.b3();
    }, null);
  }
  function DocumentNodeConcept() {
    DocumentNodeConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([ExternallyNamedConcept_getInstance()]));
  }
  var DocumentNodeConcept_instance;
  function DocumentNodeConcept_getInstance() {
    if (DocumentNodeConcept_instance == null)
      new DocumentNodeConcept();
    return DocumentNodeConcept_instance;
  }
  function EmptyBindingEntryImpl$_init_$ref_vza823() {
    var l = function (p0, p1) {
      return new EmptyBindingEntryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EmptyBindingEntryConcept$_init_$lambda_31otr1(context, nodeId) {
    return new TypedEmptyBindingEntryImpl(context, VOID, nodeId);
  }
  function EmptyBindingEntryConcept() {
    EmptyBindingEntryConcept_instance = this;
    var tmp = EmptyBindingEntryImpl$_init_$ref_vza823();
    OtConceptDescriptor.call(this, 'EmptyBindingEntry', VOID, tmp, EmptyBindingEntryConcept$_init_$lambda_31otr1, Companion_instance_95.z6p([AbstractBindingEntryConcept_getInstance()]));
  }
  var EmptyBindingEntryConcept_instance;
  function EmptyBindingEntryConcept_getInstance() {
    if (EmptyBindingEntryConcept_instance == null)
      new EmptyBindingEntryConcept();
    return EmptyBindingEntryConcept_instance;
  }
  function EmptyPropertyLibraryElementImpl$_init_$ref_2qk0gy() {
    var l = function (p0, p1) {
      return new EmptyPropertyLibraryElementImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EmptyPropertyLibraryElementConcept$_init_$lambda_aq558m(context, nodeId) {
    return new TypedEmptyPropertyLibraryElementImpl(context, VOID, nodeId);
  }
  function EmptyPropertyLibraryElementConcept() {
    EmptyPropertyLibraryElementConcept_instance = this;
    var tmp = EmptyPropertyLibraryElementImpl$_init_$ref_2qk0gy();
    OtConceptDescriptor.call(this, 'EmptyPropertyLibraryElement', VOID, tmp, EmptyPropertyLibraryElementConcept$_init_$lambda_aq558m, Companion_instance_95.z6p([PropertyLibraryElementConcept_getInstance()]));
  }
  var EmptyPropertyLibraryElementConcept_instance;
  function EmptyPropertyLibraryElementConcept_getInstance() {
    if (EmptyPropertyLibraryElementConcept_instance == null)
      new EmptyPropertyLibraryElementConcept();
    return EmptyPropertyLibraryElementConcept_instance;
  }
  function EnumValueImpl$_init_$ref_lxj98r() {
    var l = function (p0, p1) {
      return new EnumValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EnumValueConcept$_init_$lambda_iya7f1(context, nodeId) {
    return new TypedEnumValueImpl(context, VOID, nodeId);
  }
  function EnumValueConcept() {
    EnumValueConcept_instance = this;
    var tmp = EnumValueImpl$_init_$ref_lxj98r();
    OtConceptDescriptor.call(this, 'EnumValue', VOID, tmp, EnumValueConcept$_init_$lambda_iya7f1, Companion_instance_95.z6p([AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = constant$factory();
    var tmp3 = Companion_getInstance_224().jb2_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'constant';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(EnumValue_1), tmp2, getKClass(EnumerationConstant_1));
    tmp_0.ub2_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.vb2_1 = new DomainNodeReferencePropertyDescriptor(this.ub2_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var EnumValueConcept_instance;
  function EnumValueConcept_getInstance() {
    if (EnumValueConcept_instance == null)
      new EnumValueConcept();
    return EnumValueConcept_instance;
  }
  function constant$factory() {
    return getPropertyCallableRef('constant', 1, KProperty1, function (receiver) {
      return receiver.wb2();
    }, null);
  }
  function EnumerableNotionImpl$_init_$ref_f21glk() {
    var l = function (p0, p1) {
      return new EnumerableNotionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EnumerableNotionConcept$_init_$lambda_vrxgm8(context, nodeId) {
    return new TypedEnumerableNotionImpl(context, VOID, nodeId);
  }
  function EnumerableNotionConcept() {
    EnumerableNotionConcept_instance = this;
    var tmp = EnumerableNotionImpl$_init_$ref_f21glk();
    OtConceptDescriptor.call(this, 'EnumerableNotion', VOID, tmp, EnumerableNotionConcept$_init_$lambda_vrxgm8, Companion_instance_95.z6p([AbstractNotionConcept_getInstance()]));
    this.hb3_1 = this.i6q(constants$factory(), 'constants');
    this.ib3_1 = new DomainNodeChildrenPropertyDescriptor(this.hb3_1);
  }
  var EnumerableNotionConcept_instance;
  function EnumerableNotionConcept_getInstance() {
    if (EnumerableNotionConcept_instance == null)
      new EnumerableNotionConcept();
    return EnumerableNotionConcept_instance;
  }
  function constants$factory() {
    return getPropertyCallableRef('constants', 1, KProperty1, function (receiver) {
      return receiver.jb3();
    }, null);
  }
  function EnumerationConstantImpl$_init_$ref_egcl4q() {
    var l = function (p0, p1) {
      return new EnumerationConstantImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function EnumerationConstantConcept$_init_$lambda_xi55im(context, nodeId) {
    return new TypedEnumerationConstantImpl(context, VOID, nodeId);
  }
  function EnumerationConstantConcept() {
    EnumerationConstantConcept_instance = this;
    var tmp = EnumerationConstantImpl$_init_$ref_egcl4q();
    OtConceptDescriptor.call(this, 'EnumerationConstant', VOID, tmp, EnumerationConstantConcept$_init_$lambda_xi55im, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
  }
  var EnumerationConstantConcept_instance;
  function EnumerationConstantConcept_getInstance() {
    if (EnumerationConstantConcept_instance == null)
      new EnumerationConstantConcept();
    return EnumerationConstantConcept_instance;
  }
  function ExtensionDeclarationImpl$_init_$ref_qxamtm() {
    var l = function (p0, p1) {
      return new ExtensionDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ExtensionDeclarationConcept$_init_$lambda_muywo2(context, nodeId) {
    return new TypedExtensionDeclarationImpl(context, VOID, nodeId);
  }
  function ExtensionDeclarationConcept() {
    ExtensionDeclarationConcept_instance = this;
    var tmp = ExtensionDeclarationImpl$_init_$ref_qxamtm();
    OtConceptDescriptor.call(this, 'ExtensionDeclaraiton', VOID, tmp, ExtensionDeclarationConcept$_init_$lambda_muywo2, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = fields$factory();
    var tmp$ret$0 = new MultipleChildLink(getKClass(ExtensionDeclaration_1), this_0);
    tmp_0.ub3_1 = this.e6q(tmp$ret$0, 'fields');
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = type$factory();
    var tmp$ret$2 = new SingleChildLink(getKClass(ExtensionDeclaration_1), this_1);
    tmp_1.vb3_1 = this.d6q(tmp$ret$2, 'type');
    this.wb3_1 = new DomainNodeChildrenPropertyDescriptor(this.ub3_1.h6n_1);
    this.xb3_1 = new DomainNodeChildPropertyDescriptor(this.vb3_1.h6n_1);
  }
  var ExtensionDeclarationConcept_instance;
  function ExtensionDeclarationConcept_getInstance() {
    if (ExtensionDeclarationConcept_instance == null)
      new ExtensionDeclarationConcept();
    return ExtensionDeclarationConcept_instance;
  }
  function fields$factory() {
    return getPropertyCallableRef('fields', 1, KProperty1, function (receiver) {
      return receiver.yb3();
    }, null);
  }
  function type$factory() {
    return getPropertyCallableRef('type', 1, KProperty1, function (receiver) {
      return receiver.zb3();
    }, null);
  }
  function ExtensionFieldReferenceImpl$_init_$ref_cs8baj() {
    var l = function (p0, p1) {
      return new ExtensionFieldReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ExtensionFieldReferenceConcept$_init_$lambda_r4s57x(context, nodeId) {
    return new TypedExtensionFieldReferenceImpl(context, VOID, nodeId);
  }
  function ExtensionFieldReferenceConcept() {
    ExtensionFieldReferenceConcept_instance = this;
    var tmp = ExtensionFieldReferenceImpl$_init_$ref_cs8baj();
    OtConceptDescriptor.call(this, 'ExtensionFieldReference', VOID, tmp, ExtensionFieldReferenceConcept$_init_$lambda_r4s57x, Companion_instance_95.z6p([PartReferenceOperationConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = field$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_196().ab4_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ExtensionFieldReference_1), tmp2, getKClass(FieldDeclaration_1));
    tmp_0.lb4_1 = this.f6q(tmp$ret$0, tag, 'field');
    this.mb4_1 = new DomainNodeReferencePropertyDescriptor(this.lb4_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ExtensionFieldReferenceConcept_instance;
  function ExtensionFieldReferenceConcept_getInstance() {
    if (ExtensionFieldReferenceConcept_instance == null)
      new ExtensionFieldReferenceConcept();
    return ExtensionFieldReferenceConcept_instance;
  }
  function field$factory() {
    return getPropertyCallableRef('field', 1, KProperty1, function (receiver) {
      return receiver.nb4();
    }, null);
  }
  function ExtensionLibraryImpl$_init_$ref_sbhjqh() {
    var l = function (p0, p1) {
      return new ExtensionLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ExtensionLibraryConcept$_init_$lambda_5ea0xr(context, nodeId) {
    return new TypedExtensionLibraryImpl(context, VOID, nodeId);
  }
  function ExtensionLibraryConcept() {
    ExtensionLibraryConcept_instance = this;
    var tmp = ExtensionLibraryImpl$_init_$ref_sbhjqh();
    OtConceptDescriptor.call(this, 'ExtensionLibrary', VOID, tmp, ExtensionLibraryConcept$_init_$lambda_5ea0xr, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    this.yb4_1 = this.i6q(extensions$factory(), 'extensions');
    this.zb4_1 = new DomainNodeChildrenPropertyDescriptor(this.yb4_1);
  }
  var ExtensionLibraryConcept_instance;
  function ExtensionLibraryConcept_getInstance() {
    if (ExtensionLibraryConcept_instance == null)
      new ExtensionLibraryConcept();
    return ExtensionLibraryConcept_instance;
  }
  function extensions$factory() {
    return getPropertyCallableRef('extensions', 1, KProperty1, function (receiver) {
      return receiver.n9c();
    }, null);
  }
  function ExternallyNamedConcept() {
    ExternallyNamedConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
  }
  var ExternallyNamedConcept_instance;
  function ExternallyNamedConcept_getInstance() {
    if (ExternallyNamedConcept_instance == null)
      new ExternallyNamedConcept();
    return ExternallyNamedConcept_instance;
  }
  function FactImpl$_init_$ref_pt6bbb() {
    var l = function (p0, p1) {
      return new FactImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FactConcept$_init_$lambda_a59cr5(context, nodeId) {
    return new TypedFactImpl(context, VOID, nodeId);
  }
  function FactConcept() {
    FactConcept_instance = this;
    var tmp = FactImpl$_init_$ref_pt6bbb();
    OtConceptDescriptor.call(this, 'Fact', VOID, tmp, FactConcept$_init_$lambda_a59cr5, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
    this.kb5_1 = this.h6q(precondition$factory(), 'precondition');
    this.lb5_1 = this.h6q(specification$factory(), 'specification');
    this.mb5_1 = new DomainNodeChildPropertyDescriptor(this.kb5_1);
    this.nb5_1 = new DomainNodeChildPropertyDescriptor(this.lb5_1);
  }
  var FactConcept_instance;
  function FactConcept_getInstance() {
    if (FactConcept_instance == null)
      new FactConcept();
    return FactConcept_instance;
  }
  function precondition$factory() {
    return getPropertyCallableRef('precondition', 1, KProperty1, function (receiver) {
      return receiver.ob5();
    }, null);
  }
  function specification$factory() {
    return getPropertyCallableRef('specification', 1, KProperty1, function (receiver) {
      return receiver.pb5();
    }, null);
  }
  function FactExpressionConcept() {
    FactExpressionConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([FactExpressionPlaceholderConcept_getInstance()]));
  }
  var FactExpressionConcept_instance;
  function FactExpressionConcept_getInstance() {
    if (FactExpressionConcept_instance == null)
      new FactExpressionConcept();
    return FactExpressionConcept_instance;
  }
  function FactExpressionPlaceholderImpl$_init_$ref_hsnuwa() {
    var l = function (p0, p1) {
      return new FactExpressionPlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FactExpressionPlaceholderConcept$_init_$lambda_ihskha(context, nodeId) {
    return new TypedFactExpressionPlaceholderImpl(context, VOID, nodeId);
  }
  function FactExpressionPlaceholderConcept() {
    FactExpressionPlaceholderConcept_instance = this;
    var tmp = FactExpressionPlaceholderImpl$_init_$ref_hsnuwa();
    OtConceptDescriptor.call(this, 'FactExpressionPlaceholder', VOID, tmp, FactExpressionPlaceholderConcept$_init_$lambda_ihskha);
  }
  var FactExpressionPlaceholderConcept_instance;
  function FactExpressionPlaceholderConcept_getInstance() {
    if (FactExpressionPlaceholderConcept_instance == null)
      new FactExpressionPlaceholderConcept();
    return FactExpressionPlaceholderConcept_instance;
  }
  function FactPreconditionImpl$_init_$ref_wo6ain() {
    var l = function (p0, p1) {
      return new FactPreconditionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FactPreconditionConcept$_init_$lambda_d85w9(context, nodeId) {
    return new TypedFactPreconditionImpl(context, VOID, nodeId);
  }
  function FactPreconditionConcept() {
    FactPreconditionConcept_instance = this;
    var tmp = FactPreconditionImpl$_init_$ref_wo6ain();
    OtConceptDescriptor.call(this, 'FactPrecondition', VOID, tmp, FactPreconditionConcept$_init_$lambda_d85w9, Companion_instance_95.z6p([PreconditionConcept_getInstance()]));
    this.ab6_1 = this.i6q(facts$factory(), 'factRef');
    var tmp_0 = this;
    var tmp2 = relation$factory();
    var tmp3 = Companion_getInstance_187().eb6_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'relation';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(FactPrecondition_1), tmp2, getKClass(ProcessRelationDeclaration_1));
    tmp_0.bb6_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.cb6_1 = new DomainNodeChildrenPropertyDescriptor(this.ab6_1);
    this.db6_1 = new DomainNodeReferencePropertyDescriptor(this.bb6_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var FactPreconditionConcept_instance;
  function FactPreconditionConcept_getInstance() {
    if (FactPreconditionConcept_instance == null)
      new FactPreconditionConcept();
    return FactPreconditionConcept_instance;
  }
  function facts$factory() {
    return getPropertyCallableRef('facts', 1, KProperty1, function (receiver) {
      return receiver.fb6();
    }, null);
  }
  function relation$factory() {
    return getPropertyCallableRef('relation', 1, KProperty1, function (receiver) {
      return receiver.gb6();
    }, null);
  }
  function FactReferenceImpl$_init_$ref_dvtkjq() {
    var l = function (p0, p1) {
      return new FactReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FactReferenceConcept$_init_$lambda_z7k4pu(context, nodeId) {
    return new TypedFactReferenceImpl(context, VOID, nodeId);
  }
  function FactReferenceConcept() {
    FactReferenceConcept_instance = this;
    var tmp = FactReferenceImpl$_init_$ref_dvtkjq();
    OtConceptDescriptor.call(this, 'FactReference', VOID, tmp, FactReferenceConcept$_init_$lambda_z7k4pu);
    var tmp_0 = this;
    var tmp2 = ref$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_188().hb6_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(FactReference_1), tmp2, getKClass(Fact_1));
    tmp_0.sb6_1 = this.f6q(tmp$ret$0, tag, 'fact');
    this.tb6_1 = new DomainNodeReferencePropertyDescriptor(this.sb6_1, ReferenceContentPersisters_getInstance().s6p(getKClass(LocalReferenceContent)), getKClass(LocalReferenceContent));
  }
  var FactReferenceConcept_instance;
  function FactReferenceConcept_getInstance() {
    if (FactReferenceConcept_instance == null)
      new FactReferenceConcept();
    return FactReferenceConcept_instance;
  }
  function ref$factory() {
    return getPropertyCallableRef('ref', 1, KProperty1, function (receiver) {
      return receiver.ub6();
    }, null);
  }
  function FactSetImpl$_init_$ref_s0cjap() {
    var l = function (p0, p1) {
      return new FactSetImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FactSetConcept$_init_$lambda_1ta36h(context, nodeId) {
    return new TypedFactSetImpl(context, VOID, nodeId);
  }
  function FactSetConcept() {
    FactSetConcept_instance = this;
    var tmp = FactSetImpl$_init_$ref_s0cjap();
    OtConceptDescriptor.call(this, 'FactSet', VOID, tmp, FactSetConcept$_init_$lambda_1ta36h, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance(), HasKnowledgeSourcesConcept_getInstance(), HasCommentsConcept_getInstance(), HasVariablesConcept_getInstance()]));
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = factsContext$factory();
    var tmp$ret$0 = new SingleChildLink(getKClass(FactSet_1), this_0);
    tmp_0.fb7_1 = this.d6q(tmp$ret$0, 'context');
    var tmp_1 = this;
    var tmp2 = contexts$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'contexts';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new MultipleChildLink(getKClass(FactSet_1), tmp2);
    tmp_1.gb7_1 = this.e6q(tmp$ret$2, name);
    this.hb7_1 = this.i6q(facts$factory_0(), 'facts');
    var tmp_2 = this;
    var tmp2_0 = newFacts$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_0 = 'newFacts';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$4 = new MultipleChildLink(getKClass(FactSet_1), tmp2_0);
    tmp_2.ib7_1 = this.e6q(tmp$ret$4, name_0);
    this.jb7_1 = new DomainNodeChildPropertyDescriptor(this.fb7_1.h6n_1);
    this.kb7_1 = new DomainNodeChildrenPropertyDescriptor(this.gb7_1.h6n_1);
    this.lb7_1 = new DomainNodeChildrenPropertyDescriptor(this.hb7_1);
    this.mb7_1 = new DomainNodeChildrenPropertyDescriptor(this.ib7_1.h6n_1);
  }
  var FactSetConcept_instance;
  function FactSetConcept_getInstance() {
    if (FactSetConcept_instance == null)
      new FactSetConcept();
    return FactSetConcept_instance;
  }
  function factsContext$factory() {
    return getPropertyCallableRef('factsContext', 1, KProperty1, function (receiver) {
      return receiver.nb7();
    }, null);
  }
  function contexts$factory() {
    return getPropertyCallableRef('contexts', 1, KProperty1, function (receiver) {
      return receiver.ob7();
    }, null);
  }
  function facts$factory_0() {
    return getPropertyCallableRef('facts', 1, KProperty1, function (receiver) {
      return receiver.fb6();
    }, null);
  }
  function newFacts$factory() {
    return getPropertyCallableRef('newFacts', 1, KProperty1, function (receiver) {
      return receiver.pb7();
    }, null);
  }
  function FieldDeclarationImpl$_init_$ref_i0tp1h() {
    var l = function (p0, p1) {
      return new FieldDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FieldDeclarationConcept$_init_$lambda_i40rrx(context, nodeId) {
    return new TypedFieldDeclarationImpl(context, VOID, nodeId);
  }
  function FieldDeclarationConcept() {
    FieldDeclarationConcept_instance = this;
    var tmp = FieldDeclarationImpl$_init_$ref_i0tp1h();
    OtConceptDescriptor.call(this, 'FieldDeclaration', VOID, tmp, FieldDeclarationConcept$_init_$lambda_i40rrx, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
    this.ab8_1 = this.h6q(type$factory_0(), 'type');
    this.bb8_1 = this.h6q(cardinality$factory(), 'cardinality');
    this.cb8_1 = new DomainNodeChildPropertyDescriptor(this.ab8_1);
    this.db8_1 = new DomainNodeChildPropertyDescriptor(this.bb8_1);
  }
  var FieldDeclarationConcept_instance;
  function FieldDeclarationConcept_getInstance() {
    if (FieldDeclarationConcept_instance == null)
      new FieldDeclarationConcept();
    return FieldDeclarationConcept_instance;
  }
  function type$factory_0() {
    return getPropertyCallableRef('type', 1, KProperty1, function (receiver) {
      return receiver.zb3();
    }, null);
  }
  function cardinality$factory() {
    return getPropertyCallableRef('cardinality', 1, KProperty1, function (receiver) {
      return receiver.eb8();
    }, null);
  }
  function FindConnectionCommandImpl$_init_$ref_aput5d() {
    var l = function (p0, p1) {
      return new FindConnectionCommandImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FindConnectionCommandConcept$_init_$lambda_qo234n(context, nodeId) {
    return new TypedFindConnectionCommandImpl(context, VOID, nodeId);
  }
  function FindConnectionCommandConcept() {
    FindConnectionCommandConcept_instance = this;
    var tmp = FindConnectionCommandImpl$_init_$ref_aput5d();
    OtConceptDescriptor.call(this, 'FindConnectionCommand', VOID, tmp, FindConnectionCommandConcept$_init_$lambda_qo234n, Companion_instance_95.z6p([CommandConcept_getInstance()]));
    this.pb8_1 = this.h6q(contextQuery$factory(), 'context');
    this.qb8_1 = this.h6q(from$factory(), 'from');
    this.rb8_1 = this.h6q(to$factory(), 'to');
    this.sb8_1 = new DomainNodeChildPropertyDescriptor(this.pb8_1);
    this.tb8_1 = new DomainNodeChildPropertyDescriptor(this.qb8_1);
    this.ub8_1 = new DomainNodeChildPropertyDescriptor(this.rb8_1);
  }
  var FindConnectionCommandConcept_instance;
  function FindConnectionCommandConcept_getInstance() {
    if (FindConnectionCommandConcept_instance == null)
      new FindConnectionCommandConcept();
    return FindConnectionCommandConcept_instance;
  }
  function contextQuery$factory() {
    return getPropertyCallableRef('contextQuery', 1, KProperty1, function (receiver) {
      return receiver.vb8();
    }, null);
  }
  function from$factory() {
    return getPropertyCallableRef('from', 1, KProperty1, function (receiver) {
      return receiver.g3x();
    }, null);
  }
  function to$factory() {
    return getPropertyCallableRef('to', 1, KProperty1, function (receiver) {
      return receiver.h3x();
    }, null);
  }
  function FunctionDeclarationImpl$_init_$ref_7dy8pv() {
    var l = function (p0, p1) {
      return new FunctionDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionDeclarationConcept$_init_$lambda_fmiqbf(context, nodeId) {
    return new TypedFunctionDeclarationImpl(context, VOID, nodeId);
  }
  function FunctionDeclarationConcept() {
    FunctionDeclarationConcept_instance = this;
    var tmp = FunctionDeclarationImpl$_init_$ref_7dy8pv();
    OtConceptDescriptor.call(this, 'FunctionDeclaration', VOID, tmp, FunctionDeclarationConcept$_init_$lambda_fmiqbf, Companion_instance_95.z6p([AbstractBindingDeclarationConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = returnType$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'returnType';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(FunctionDeclaration_1), tmp2);
    tmp_0.gb9_1 = this.d6q(tmp$ret$0, name);
    this.hb9_1 = this.h6q(cardinality$factory_0(), 'cardinality');
    this.ib9_1 = new DomainNodeChildPropertyDescriptor(this.gb9_1.h6n_1);
    this.jb9_1 = new DomainNodeChildPropertyDescriptor(this.hb9_1);
  }
  var FunctionDeclarationConcept_instance;
  function FunctionDeclarationConcept_getInstance() {
    if (FunctionDeclarationConcept_instance == null)
      new FunctionDeclarationConcept();
    return FunctionDeclarationConcept_instance;
  }
  function returnType$factory() {
    return getPropertyCallableRef('returnType', 1, KProperty1, function (receiver) {
      return receiver.kb9();
    }, null);
  }
  function cardinality$factory_0() {
    return getPropertyCallableRef('cardinality', 1, KProperty1, function (receiver) {
      return receiver.eb8();
    }, null);
  }
  function FunctionLibraryImpl$_init_$ref_dz73cu() {
    var l = function (p0, p1) {
      return new FunctionLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionLibraryConcept$_init_$lambda_smc1k6(context, nodeId) {
    return new TypedFunctionLibraryImpl(context, VOID, nodeId);
  }
  function FunctionLibraryConcept() {
    FunctionLibraryConcept_instance = this;
    var tmp = FunctionLibraryImpl$_init_$ref_dz73cu();
    OtConceptDescriptor.call(this, 'FunctionLibrary', VOID, tmp, FunctionLibraryConcept$_init_$lambda_smc1k6, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    this.vb9_1 = this.i6q(functions$factory(), 'functions');
    this.wb9_1 = new DomainNodeChildrenPropertyDescriptor(this.vb9_1);
  }
  var FunctionLibraryConcept_instance;
  function FunctionLibraryConcept_getInstance() {
    if (FunctionLibraryConcept_instance == null)
      new FunctionLibraryConcept();
    return FunctionLibraryConcept_instance;
  }
  function functions$factory() {
    return getPropertyCallableRef('functions', 1, KProperty1, function (receiver) {
      return receiver.xb9();
    }, null);
  }
  function FunctionTermImpl$_init_$ref_55iiip() {
    var l = function (p0, p1) {
      return new FunctionTermImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function FunctionTermConcept$_init_$lambda_11undl(context, nodeId) {
    return new TypedFunctionTermImpl(context, VOID, nodeId);
  }
  function FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_10();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).yb9 = function (value) {
    return value.toString();
  };
  protoOf(FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).x2p = function (value) {
    return this.yb9(value instanceof CardinalitySpecificator ? value : THROW_CCE());
  };
  protoOf(FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_10();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).yb9 = function (value) {
    return value.toString();
  };
  protoOf(FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).x2p = function (value) {
    return this.yb9(value instanceof CardinalitySpecificator ? value : THROW_CCE());
  };
  protoOf(FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function FunctionTermConcept() {
    FunctionTermConcept_instance = this;
    var tmp = FunctionTermImpl$_init_$ref_55iiip();
    OtConceptDescriptor.call(this, 'FunctionTerm', VOID, tmp, FunctionTermConcept$_init_$lambda_11undl, Companion_instance_95.z6p([AbstractValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = function$factory();
    var tmp3 = Companion_getInstance_197().zb9_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'function';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(FunctionTerm_1), tmp2, getKClass(FunctionDeclaration_1));
    tmp_0.kba_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.lba_1 = this.g6q(specificator$factory(), 'specificator');
    this.mba_1 = this.i6q(parameters$factory(), 'parameters');
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$2 = new FunctionTermConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1();
    tmp_1.nba_1 = toNonNullPersister(tmp$ret$2);
    this.oba_1 = new DomainNodeReferencePropertyDescriptor(this.kba_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    var tmp_2 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$3 = new FunctionTermConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1();
    tmp_2.pba_1 = new DomainNodePropertyDescriptor(this.lba_1, toNonNullPersister(tmp$ret$3));
    this.qba_1 = new DomainNodeChildrenPropertyDescriptor(this.mba_1);
  }
  var FunctionTermConcept_instance;
  function FunctionTermConcept_getInstance() {
    if (FunctionTermConcept_instance == null)
      new FunctionTermConcept();
    return FunctionTermConcept_instance;
  }
  function function$factory() {
    return getPropertyCallableRef('function', 1, KProperty1, function (receiver) {
      return receiver.rba();
    }, null);
  }
  function specificator$factory() {
    return getPropertyCallableRef('specificator', 1, KProperty1, function (receiver) {
      return receiver.sba();
    }, null);
  }
  function parameters$factory() {
    return getPropertyCallableRef('parameters', 1, KProperty1, function (receiver) {
      return receiver.tba();
    }, null);
  }
  function HasCommentsConcept() {
    HasCommentsConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = comment$factory();
    var tmp$ret$0 = new SingleChildLink(getKClass(HasComments), this_0);
    tmp.abb_1 = this.d6q(tmp$ret$0, 'comment');
    this.bbb_1 = new DomainNodeChildPropertyDescriptor(this.abb_1.h6n_1);
  }
  var HasCommentsConcept_instance;
  function HasCommentsConcept_getInstance() {
    if (HasCommentsConcept_instance == null)
      new HasCommentsConcept();
    return HasCommentsConcept_instance;
  }
  function comment$factory() {
    return getPropertyCallableRef('comment', 1, KProperty1, function (receiver) {
      return receiver.cbb();
    }, null);
  }
  function HasFactExpressionConcept() {
    HasFactExpressionConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
    var tmp = this;
    var tmp2 = expression$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'expression';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(HasFactExpression), tmp2);
    tmp.jbb_1 = this.d6q(tmp$ret$0, name);
    this.kbb_1 = new DomainNodeChildPropertyDescriptor(this.jbb_1.h6n_1);
  }
  var HasFactExpressionConcept_instance;
  function HasFactExpressionConcept_getInstance() {
    if (HasFactExpressionConcept_instance == null)
      new HasFactExpressionConcept();
    return HasFactExpressionConcept_instance;
  }
  function expression$factory() {
    return getPropertyCallableRef('expression', 1, KProperty1, function (receiver) {
      return receiver.lbb();
    }, null);
  }
  function HasKnowledgeSourcesConcept() {
    HasKnowledgeSourcesConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
    var tmp = this;
    var tmp2 = sources$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'sourceRefs';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(HasKnowledgeSources), tmp2);
    tmp.sbb_1 = this.e6q(tmp$ret$0, name);
    this.tbb_1 = new DomainNodeChildrenPropertyDescriptor(this.sbb_1.h6n_1);
  }
  var HasKnowledgeSourcesConcept_instance;
  function HasKnowledgeSourcesConcept_getInstance() {
    if (HasKnowledgeSourcesConcept_instance == null)
      new HasKnowledgeSourcesConcept();
    return HasKnowledgeSourcesConcept_instance;
  }
  function sources$factory() {
    return getPropertyCallableRef('sources', 1, KProperty1, function (receiver) {
      return receiver.ubb();
    }, null);
  }
  function HasPropertyConstraintsConcept() {
    HasPropertyConstraintsConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
    var tmp = this;
    var tmp2 = constraints$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'constraints';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(HasPropertyConstraints), tmp2);
    tmp.bbc_1 = this.e6q(tmp$ret$0, name);
    this.cbc_1 = new DomainNodeChildrenPropertyDescriptor(this.bbc_1.h6n_1);
  }
  var HasPropertyConstraintsConcept_instance;
  function HasPropertyConstraintsConcept_getInstance() {
    if (HasPropertyConstraintsConcept_instance == null)
      new HasPropertyConstraintsConcept();
    return HasPropertyConstraintsConcept_instance;
  }
  function constraints$factory() {
    return getPropertyCallableRef('constraints', 1, KProperty1, function (receiver) {
      return receiver.dbc();
    }, null);
  }
  function HasQueryLabelsConcept() {
    HasQueryLabelsConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
    this.kbc_1 = this.g6q(noEntry$factory(), 'noEntry');
    this.lbc_1 = this.g6q(noExit$factory(), 'noExit');
    this.mbc_1 = new DomainNodePropertyDescriptor(this.kbc_1, toNonNullPersister(NonNullPersisters_getInstance().l2q(), new DefaultValueNullPersister(false)));
    this.nbc_1 = new DomainNodePropertyDescriptor(this.lbc_1, toNonNullPersister(NonNullPersisters_getInstance().l2q(), new DefaultValueNullPersister(false)));
  }
  var HasQueryLabelsConcept_instance;
  function HasQueryLabelsConcept_getInstance() {
    if (HasQueryLabelsConcept_instance == null)
      new HasQueryLabelsConcept();
    return HasQueryLabelsConcept_instance;
  }
  function noEntry$factory() {
    return getPropertyCallableRef('noEntry', 1, KProperty1, function (receiver) {
      return receiver.obc();
    }, null);
  }
  function noExit$factory() {
    return getPropertyCallableRef('noExit', 1, KProperty1, function (receiver) {
      return receiver.pbc();
    }, null);
  }
  function HasVariablesConcept() {
    HasVariablesConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
    var tmp = this;
    var tmp2 = variables$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'variables';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(HasVariables), tmp2);
    tmp.wbc_1 = this.e6q(tmp$ret$0, name);
    this.xbc_1 = new DomainNodeChildrenPropertyDescriptor(this.wbc_1.h6n_1);
  }
  var HasVariablesConcept_instance;
  function HasVariablesConcept_getInstance() {
    if (HasVariablesConcept_instance == null)
      new HasVariablesConcept();
    return HasVariablesConcept_instance;
  }
  function variables$factory() {
    return getPropertyCallableRef('variables', 1, KProperty1, function (receiver) {
      return receiver.ybc();
    }, null);
  }
  function ImportedLinkImpl$_init_$ref_d7f1kp() {
    var l = function (p0, p1) {
      return new ImportedLinkImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ImportedLinkConcept$_init_$lambda_ik1xup(context, nodeId) {
    return new TypedImportedLinkImpl(context, VOID, nodeId);
  }
  function ImportedLinkConcept() {
    ImportedLinkConcept_instance = this;
    var tmp = ImportedLinkImpl$_init_$ref_d7f1kp();
    OtConceptDescriptor.call(this, 'ImportedLink', VOID, tmp, ImportedLinkConcept$_init_$lambda_ik1xup, Companion_instance_95.z6p([AbstractLinkConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = declaration$factory();
    var tmp3 = Companion_getInstance_202().zbc_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'declaration';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ImportedLink_1), tmp2, getKClass(LinkDeclaration_1));
    tmp_0.kbd_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.lbd_1 = new DomainNodeReferencePropertyDescriptor(this.kbd_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ImportedLinkConcept_instance;
  function ImportedLinkConcept_getInstance() {
    if (ImportedLinkConcept_instance == null)
      new ImportedLinkConcept();
    return ImportedLinkConcept_instance;
  }
  function declaration$factory() {
    return getPropertyCallableRef('declaration', 1, KProperty1, function (receiver) {
      return receiver.mbd();
    }, null);
  }
  function ImportedPropertyImpl$_init_$ref_42jth0() {
    var l = function (p0, p1) {
      return new ImportedPropertyImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ImportedPropertyConcept$_init_$lambda_7uoy90(context, nodeId) {
    return new TypedImportedPropertyImpl(context, VOID, nodeId);
  }
  function ImportedPropertyConcept() {
    ImportedPropertyConcept_instance = this;
    var tmp = ImportedPropertyImpl$_init_$ref_42jth0();
    OtConceptDescriptor.call(this, 'ImportedProperty', VOID, tmp, ImportedPropertyConcept$_init_$lambda_7uoy90, Companion_instance_95.z6p([AbstractPropertyConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = declaration$factory_0();
    var tmp3 = Companion_getInstance_214().nbd_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'declaration';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ImportedProperty_1), tmp2, getKClass(PropertyDeclaration_1));
    tmp_0.ybd_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.zbd_1 = new DomainNodeReferencePropertyDescriptor(this.ybd_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ImportedPropertyConcept_instance;
  function ImportedPropertyConcept_getInstance() {
    if (ImportedPropertyConcept_instance == null)
      new ImportedPropertyConcept();
    return ImportedPropertyConcept_instance;
  }
  function declaration$factory_0() {
    return getPropertyCallableRef('declaration', 1, KProperty1, function (receiver) {
      return receiver.mbd();
    }, null);
  }
  function InstanceRelationDeclarationImpl$_init_$ref_xyg2f0() {
    var l = function (p0, p1) {
      return new InstanceRelationDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function InstanceRelationDeclarationConcept$_init_$lambda_9076uk(context, nodeId) {
    return new TypedInstanceRelationDeclarationImpl(context, VOID, nodeId);
  }
  function InstanceRelationDeclarationConcept() {
    InstanceRelationDeclarationConcept_instance = this;
    var tmp = InstanceRelationDeclarationImpl$_init_$ref_xyg2f0();
    OtConceptDescriptor.call(this, 'InstanceRelationDeclaration', VOID, tmp, InstanceRelationDeclarationConcept$_init_$lambda_9076uk, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = domain$factory();
    var tmp$ret$0 = new SingleChildLink(getKClass(InstanceRelationDeclaration), this_0);
    tmp_0.kbe_1 = this.d6q(tmp$ret$0, 'domain');
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = range$factory();
    var tmp$ret$2 = new SingleChildLink(getKClass(InstanceRelationDeclaration), this_1);
    tmp_1.lbe_1 = this.d6q(tmp$ret$2, 'range');
    this.mbe_1 = new DomainNodeChildPropertyDescriptor(this.kbe_1.h6n_1);
    this.nbe_1 = new DomainNodeChildPropertyDescriptor(this.lbe_1.h6n_1);
  }
  var InstanceRelationDeclarationConcept_instance;
  function InstanceRelationDeclarationConcept_getInstance() {
    if (InstanceRelationDeclarationConcept_instance == null)
      new InstanceRelationDeclarationConcept();
    return InstanceRelationDeclarationConcept_instance;
  }
  function domain$factory() {
    return getPropertyCallableRef('domain', 1, KProperty1, function (receiver) {
      return receiver.obe();
    }, null);
  }
  function range$factory() {
    return getPropertyCallableRef('range', 1, KProperty1, function (receiver) {
      return receiver.be();
    }, null);
  }
  function InstanceRelationValueImpl$_init_$ref_phql7() {
    var l = function (p0, p1) {
      return new InstanceRelationValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function InstanceRelationValueConcept$_init_$lambda_q9ihml(context, nodeId) {
    return new TypedInstanceRelationValueImpl(context, VOID, nodeId);
  }
  function InstanceRelationValueConcept() {
    InstanceRelationValueConcept_instance = this;
    var tmp = InstanceRelationValueImpl$_init_$ref_phql7();
    OtConceptDescriptor.call(this, 'InstanceRelationReferenceValue', VOID, tmp, InstanceRelationValueConcept$_init_$lambda_q9ihml, Companion_instance_95.z6p([InstanceRelationValuePlaceholderConcept_getInstance()]));
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = value$factory_3();
    var tmp$ret$0 = new SingleChildLink(getKClass(InstanceRelationValue), this_0);
    tmp_0.zbe_1 = this.d6q(tmp$ret$0, 'value');
    var tmp_1 = this;
    var tmp2 = relation$factory_0();
    var tmp3 = Companion_getInstance_219().dbf_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$2 = new ReferenceLink(getKClass(InstanceRelationValue), tmp2, getKClass(InstanceRelationDeclaration));
    tmp_1.abf_1 = this.f6q(tmp$ret$2, tmp3, name);
    this.bbf_1 = new DomainNodeChildPropertyDescriptor(this.zbe_1.h6n_1);
    this.cbf_1 = new DomainNodeReferencePropertyDescriptor(this.abf_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var InstanceRelationValueConcept_instance;
  function InstanceRelationValueConcept_getInstance() {
    if (InstanceRelationValueConcept_instance == null)
      new InstanceRelationValueConcept();
    return InstanceRelationValueConcept_instance;
  }
  function value$factory_3() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function relation$factory_0() {
    return getPropertyCallableRef('relation', 1, KProperty1, function (receiver) {
      return receiver.gb6();
    }, null);
  }
  function InstanceRelationValuePlaceholderImpl$_init_$ref_y5nbke() {
    var l = function (p0, p1) {
      return new InstanceRelationValuePlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function InstanceRelationValuePlaceholderConcept$_init_$lambda_282zd6(context, nodeId) {
    return new TypedInstanceRelationValuePlaceholderImpl(context, VOID, nodeId);
  }
  function InstanceRelationValuePlaceholderConcept() {
    InstanceRelationValuePlaceholderConcept_instance = this;
    var tmp = InstanceRelationValuePlaceholderImpl$_init_$ref_y5nbke();
    OtConceptDescriptor.call(this, 'InstanceRelationValuePlaceholder', VOID, tmp, InstanceRelationValuePlaceholderConcept$_init_$lambda_282zd6);
  }
  var InstanceRelationValuePlaceholderConcept_instance;
  function InstanceRelationValuePlaceholderConcept_getInstance() {
    if (InstanceRelationValuePlaceholderConcept_instance == null)
      new InstanceRelationValuePlaceholderConcept();
    return InstanceRelationValuePlaceholderConcept_instance;
  }
  function IsExpressionImpl$_init_$ref_i32f0d() {
    var l = function (p0, p1) {
      return new IsExpressionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function IsExpressionConcept$_init_$lambda_ox5d3v(context, nodeId) {
    return new TypedIsExpressionImpl(context, VOID, nodeId);
  }
  function IsExpressionConcept() {
    IsExpressionConcept_instance = this;
    var tmp = IsExpressionImpl$_init_$ref_i32f0d();
    OtConceptDescriptor.call(this, 'IsExpression', VOID, tmp, IsExpressionConcept$_init_$lambda_ox5d3v, Companion_instance_95.z6p([FactExpressionConcept_getInstance()]));
    this.obf_1 = this.h6q(left$factory(), 'left');
    this.pbf_1 = this.h6q(right$factory(), 'right');
    this.qbf_1 = new DomainNodeChildPropertyDescriptor(this.obf_1);
    this.rbf_1 = new DomainNodeChildPropertyDescriptor(this.pbf_1);
  }
  var IsExpressionConcept_instance;
  function IsExpressionConcept_getInstance() {
    if (IsExpressionConcept_instance == null)
      new IsExpressionConcept();
    return IsExpressionConcept_instance;
  }
  function left$factory() {
    return getPropertyCallableRef('left', 1, KProperty1, function (receiver) {
      return receiver.sbf();
    }, null);
  }
  function right$factory() {
    return getPropertyCallableRef('right', 1, KProperty1, function (receiver) {
      return receiver.tbf();
    }, null);
  }
  function KindCustomCellImpl$_init_$ref_w6oila() {
    var l = function (p0, p1) {
      return new KindCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function KindCustomCellConcept$_init_$lambda_z0ndhm(context, nodeId) {
    return new TypedKindCustomCellImpl(context, VOID, nodeId);
  }
  function KindCustomCellConcept() {
    KindCustomCellConcept_instance = this;
    var tmp = KindCustomCellImpl$_init_$ref_w6oila();
    OtConceptDescriptor.call(this, 'KindCustomCell', VOID, tmp, KindCustomCellConcept$_init_$lambda_z0ndhm, Companion_instance_95.z6p([CustomCellConcept_getInstance()]));
  }
  var KindCustomCellConcept_instance;
  function KindCustomCellConcept_getInstance() {
    if (KindCustomCellConcept_instance == null)
      new KindCustomCellConcept();
    return KindCustomCellConcept_instance;
  }
  function KnowledgeSourceReferenceConcept() {
    KnowledgeSourceReferenceConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var KnowledgeSourceReferenceConcept_instance;
  function KnowledgeSourceReferenceConcept_getInstance() {
    if (KnowledgeSourceReferenceConcept_instance == null)
      new KnowledgeSourceReferenceConcept();
    return KnowledgeSourceReferenceConcept_instance;
  }
  function KnowledgeSourceReferencePlaceholderImpl$_init_$ref_nw1ttw() {
    var l = function (p0, p1) {
      return new KnowledgeSourceReferencePlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function KnowledgeSourceReferencePlaceholderConcept$_init_$lambda_tc6yqs(context, nodeId) {
    return new TypedKnowledgeSourceReferencePlaceholderImpl(context, VOID, nodeId);
  }
  function KnowledgeSourceReferencePlaceholderConcept() {
    KnowledgeSourceReferencePlaceholderConcept_instance = this;
    var tmp = KnowledgeSourceReferencePlaceholderImpl$_init_$ref_nw1ttw();
    OtConceptDescriptor.call(this, 'KnowledgeSourcePlaceholder', VOID, tmp, KnowledgeSourceReferencePlaceholderConcept$_init_$lambda_tc6yqs, Companion_instance_95.z6p([KnowledgeSourceReferenceConcept_getInstance()]));
  }
  var KnowledgeSourceReferencePlaceholderConcept_instance;
  function KnowledgeSourceReferencePlaceholderConcept_getInstance() {
    if (KnowledgeSourceReferencePlaceholderConcept_instance == null)
      new KnowledgeSourceReferencePlaceholderConcept();
    return KnowledgeSourceReferencePlaceholderConcept_instance;
  }
  function LibraryItemConcept() {
    LibraryItemConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var LibraryItemConcept_instance;
  function LibraryItemConcept_getInstance() {
    if (LibraryItemConcept_instance == null)
      new LibraryItemConcept();
    return LibraryItemConcept_instance;
  }
  function LibraryItemPlaceholderImpl$_init_$ref_945co0() {
    var l = function (p0, p1) {
      return new LibraryItemPlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LibraryItemPlaceholderConcept$_init_$lambda_63hh6w(context, nodeId) {
    return new TypedLibraryItemPlaceholderImpl(context, VOID, nodeId);
  }
  function LibraryItemPlaceholderConcept() {
    LibraryItemPlaceholderConcept_instance = this;
    var tmp = LibraryItemPlaceholderImpl$_init_$ref_945co0();
    OtConceptDescriptor.call(this, 'PublishedSourcePlaceholder', VOID, tmp, LibraryItemPlaceholderConcept$_init_$lambda_63hh6w, Companion_instance_95.z6p([LibraryItemConcept_getInstance()]));
  }
  var LibraryItemPlaceholderConcept_instance;
  function LibraryItemPlaceholderConcept_getInstance() {
    if (LibraryItemPlaceholderConcept_instance == null)
      new LibraryItemPlaceholderConcept();
    return LibraryItemPlaceholderConcept_instance;
  }
  function LibraryProcessSpecificationImpl$_init_$ref_1nwbze() {
    var l = function (p0, p1) {
      return new LibraryProcessSpecificationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LibraryProcessSpecificationConcept$_init_$lambda_ywj102(context, nodeId) {
    return new TypedLibraryProcessSpecificationImpl(context, VOID, nodeId);
  }
  function LibraryProcessSpecificationConcept() {
    LibraryProcessSpecificationConcept_instance = this;
    var tmp = LibraryProcessSpecificationImpl$_init_$ref_1nwbze();
    OtConceptDescriptor.call(this, 'LibraryProcessSpecification', VOID, tmp, LibraryProcessSpecificationConcept$_init_$lambda_ywj102, Companion_instance_95.z6p([AbstractProcessSpecificationConcept_getInstance(), ProcessProviderConcept_getInstance(), FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = process$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_185().ubf_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(LibraryProcessSpecification_1), tmp2, getKClass(ProcessDeclaration_1));
    tmp_0.fbg_1 = this.f6q(tmp$ret$0, tag, 'process');
    this.gbg_1 = this.i6q(parameters$factory_0(), 'parameters');
    this.hbg_1 = new DomainNodeReferencePropertyDescriptor(this.fbg_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.ibg_1 = new DomainNodeChildrenPropertyDescriptor(this.gbg_1);
  }
  var LibraryProcessSpecificationConcept_instance;
  function LibraryProcessSpecificationConcept_getInstance() {
    if (LibraryProcessSpecificationConcept_instance == null)
      new LibraryProcessSpecificationConcept();
    return LibraryProcessSpecificationConcept_instance;
  }
  function process$factory() {
    return getPropertyCallableRef('process', 1, KProperty1, function (receiver) {
      return receiver.jbg();
    }, null);
  }
  function parameters$factory_0() {
    return getPropertyCallableRef('parameters', 1, KProperty1, function (receiver) {
      return receiver.tba();
    }, null);
  }
  function LibraryProcessSpecificationQueryImpl$_init_$ref_1u06hg() {
    var l = function (p0, p1) {
      return new LibraryProcessSpecificationQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LibraryProcessSpecificationQueryConcept$_init_$lambda_6ipny4(context, nodeId) {
    return new TypedLibraryProcessSpecificationQueryImpl(context, VOID, nodeId);
  }
  function LibraryProcessSpecificationQueryConcept() {
    LibraryProcessSpecificationQueryConcept_instance = this;
    var tmp = LibraryProcessSpecificationQueryImpl$_init_$ref_1u06hg();
    OtConceptDescriptor.call(this, 'LibraryProcessSpecificationQuery', VOID, tmp, LibraryProcessSpecificationQueryConcept$_init_$lambda_6ipny4, Companion_instance_95.z6p([ProcessProviderConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = process$factory_0();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_217().lbg_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(LibraryProcessSpecificationQuery_1), tmp2, getKClass(ProcessDeclaration_1));
    tmp_0.wbg_1 = this.f6q(tmp$ret$0, tag, 'process');
    var tmp_1 = this;
    var tmp2_0 = kind$factory_0();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag_0 = Companion_getInstance_217().kbg_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$2 = new ReferenceLink(getKClass(LibraryProcessSpecificationQuery_1), tmp2_0, getKClass(ProcessKind_1));
    tmp_1.xbg_1 = this.f6q(tmp$ret$2, tag_0, 'kind');
    this.ybg_1 = this.i6q(parameters$factory_1(), 'parameters');
    this.zbg_1 = new DomainNodeReferencePropertyDescriptor(this.wbg_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.abh_1 = new DomainNodeReferencePropertyDescriptor(this.xbg_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.bbh_1 = new DomainNodeChildrenPropertyDescriptor(this.ybg_1);
  }
  var LibraryProcessSpecificationQueryConcept_instance;
  function LibraryProcessSpecificationQueryConcept_getInstance() {
    if (LibraryProcessSpecificationQueryConcept_instance == null)
      new LibraryProcessSpecificationQueryConcept();
    return LibraryProcessSpecificationQueryConcept_instance;
  }
  function process$factory_0() {
    return getPropertyCallableRef('process', 1, KProperty1, function (receiver) {
      return receiver.jbg();
    }, null);
  }
  function kind$factory_0() {
    return getPropertyCallableRef('kind', 1, KProperty1, function (receiver) {
      return receiver.r5e();
    }, null);
  }
  function parameters$factory_1() {
    return getPropertyCallableRef('parameters', 1, KProperty1, function (receiver) {
      return receiver.tba();
    }, null);
  }
  function LinkCustomCellImpl$_init_$ref_nshxfs() {
    var l = function (p0, p1) {
      return new LinkCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LinkCustomCellConcept$_init_$lambda_q3coc0(context, nodeId) {
    return new TypedLinkCustomCellImpl(context, VOID, nodeId);
  }
  function LinkCustomCellConcept() {
    LinkCustomCellConcept_instance = this;
    var tmp = LinkCustomCellImpl$_init_$ref_nshxfs();
    OtConceptDescriptor.call(this, 'LinkCustomCell', VOID, tmp, LinkCustomCellConcept$_init_$lambda_q3coc0, Companion_instance_95.z6p([CustomCellConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = link$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_193().cbh_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(LinkCustomCell_1), tmp2, getKClass(AbstractLink));
    tmp_0.nbh_1 = this.f6q(tmp$ret$0, tag, 'link');
    this.obh_1 = new DomainNodeReferencePropertyDescriptor(this.nbh_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var LinkCustomCellConcept_instance;
  function LinkCustomCellConcept_getInstance() {
    if (LinkCustomCellConcept_instance == null)
      new LinkCustomCellConcept();
    return LinkCustomCellConcept_instance;
  }
  function link$factory() {
    return getPropertyCallableRef('link', 1, KProperty1, function (receiver) {
      return receiver.pbh();
    }, null);
  }
  function LinkDeclarationImpl$_init_$ref_voaim3() {
    var l = function (p0, p1) {
      return new LinkDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LinkDeclarationConcept$_init_$lambda_guw7h9(context, nodeId) {
    return new TypedLinkDeclarationImpl(context, VOID, nodeId);
  }
  function LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_11();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).qbh = function (value) {
    return value.toString();
  };
  protoOf(LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).x2p = function (value) {
    return this.qbh(value instanceof LinkTypeSpecificator ? value : THROW_CCE());
  };
  protoOf(LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_11();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).qbh = function (value) {
    return value.toString();
  };
  protoOf(LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).x2p = function (value) {
    return this.qbh(value instanceof LinkTypeSpecificator ? value : THROW_CCE());
  };
  protoOf(LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function LinkDeclarationConcept() {
    LinkDeclarationConcept_instance = this;
    var tmp = LinkDeclarationImpl$_init_$ref_voaim3();
    OtConceptDescriptor.call(this, 'LinkDeclaration', VOID, tmp, LinkDeclarationConcept$_init_$lambda_guw7h9, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
    this.bbi_1 = this.g6q(specificator$factory_0(), 'specificator');
    this.cbi_1 = this.h6q(type$factory_1(), 'type');
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$0 = new LinkDeclarationConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1();
    tmp_0.dbi_1 = toNullablePersister(tmp$ret$0);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$1 = new LinkDeclarationConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1();
    tmp_1.ebi_1 = new DomainNodePropertyDescriptor(this.bbi_1, toNullablePersister(tmp$ret$1));
    this.fbi_1 = new DomainNodeChildPropertyDescriptor(this.cbi_1);
  }
  var LinkDeclarationConcept_instance;
  function LinkDeclarationConcept_getInstance() {
    if (LinkDeclarationConcept_instance == null)
      new LinkDeclarationConcept();
    return LinkDeclarationConcept_instance;
  }
  function specificator$factory_0() {
    return getPropertyCallableRef('specificator', 1, KProperty1, function (receiver) {
      return receiver.sba();
    }, null);
  }
  function type$factory_1() {
    return getPropertyCallableRef('type', 1, KProperty1, function (receiver) {
      return receiver.zb3();
    }, null);
  }
  function LinkLibraryImpl$_init_$ref_3a0qos() {
    var l = function (p0, p1) {
      return new LinkLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LinkLibraryConcept$_init_$lambda_7ufdj0(context, nodeId) {
    return new TypedLinkLibraryImpl(context, VOID, nodeId);
  }
  function LinkLibraryConcept() {
    LinkLibraryConcept_instance = this;
    var tmp = LinkLibraryImpl$_init_$ref_3a0qos();
    OtConceptDescriptor.call(this, 'LinkLibrary', VOID, tmp, LinkLibraryConcept$_init_$lambda_7ufdj0, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    this.qbi_1 = this.i6q(links$factory(), 'links');
    this.rbi_1 = new DomainNodeChildrenPropertyDescriptor(this.qbi_1);
  }
  var LinkLibraryConcept_instance;
  function LinkLibraryConcept_getInstance() {
    if (LinkLibraryConcept_instance == null)
      new LinkLibraryConcept();
    return LinkLibraryConcept_instance;
  }
  function links$factory() {
    return getPropertyCallableRef('links', 1, KProperty1, function (receiver) {
      return receiver.sbi();
    }, null);
  }
  function LocalOntologyElementReferenceImpl$_init_$ref_kzz15o() {
    var l = function (p0, p1) {
      return new LocalOntologyElementReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LocalOntologyElementReferenceConcept$_init_$lambda_iyyozw(context, nodeId) {
    return new TypedLocalOntologyElementReferenceImpl(context, VOID, nodeId);
  }
  function LocalOntologyElementReferenceConcept() {
    LocalOntologyElementReferenceConcept_instance = this;
    var tmp = LocalOntologyElementReferenceImpl$_init_$ref_kzz15o();
    OtConceptDescriptor.call(this, 'LocalOntologyElementReference', VOID, tmp, LocalOntologyElementReferenceConcept$_init_$lambda_iyyozw, Companion_instance_95.z6p([OntologyElementReferenceProviderConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = element$factory_2();
    var tmp3 = Companion_getInstance_207().tbi_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'localElement';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(LocalOntologyElementReference_1), tmp2, getKClass(OntologyElement_1));
    tmp_0.ebj_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.fbj_1 = new DomainNodeReferencePropertyDescriptor(this.ebj_1, ReferenceContentPersisters_getInstance().s6p(getKClass(LocalReferenceContent)), getKClass(LocalReferenceContent));
  }
  var LocalOntologyElementReferenceConcept_instance;
  function LocalOntologyElementReferenceConcept_getInstance() {
    if (LocalOntologyElementReferenceConcept_instance == null)
      new LocalOntologyElementReferenceConcept();
    return LocalOntologyElementReferenceConcept_instance;
  }
  function element$factory_2() {
    return getPropertyCallableRef('element', 1, KProperty1, function (receiver) {
      return receiver.lay();
    }, null);
  }
  function MeasurableNotionImpl$_init_$ref_bbltld() {
    var l = function (p0, p1) {
      return new MeasurableNotionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function MeasurableNotionConcept$_init_$lambda_ocyadj(context, nodeId) {
    return new TypedMeasurableNotionImpl(context, VOID, nodeId);
  }
  function MeasurableNotionConcept() {
    MeasurableNotionConcept_instance = this;
    var tmp = MeasurableNotionImpl$_init_$ref_bbltld();
    OtConceptDescriptor.call(this, 'MeasurableNotion', VOID, tmp, MeasurableNotionConcept$_init_$lambda_ocyadj, Companion_instance_95.z6p([AbstractNotionConcept_getInstance()]));
    this.qbj_1 = this.i6q(units$factory(), 'units');
    this.rbj_1 = new DomainNodeChildrenPropertyDescriptor(this.qbj_1);
  }
  var MeasurableNotionConcept_instance;
  function MeasurableNotionConcept_getInstance() {
    if (MeasurableNotionConcept_instance == null)
      new MeasurableNotionConcept();
    return MeasurableNotionConcept_instance;
  }
  function units$factory() {
    return getPropertyCallableRef('units', 1, KProperty1, function (receiver) {
      return receiver.sbj();
    }, null);
  }
  function MeasurableValueImpl$_init_$ref_9xaz7v() {
    var l = function (p0, p1) {
      return new MeasurableValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function MeasurableValueConcept$_init_$lambda_4s9b8z(context, nodeId) {
    return new TypedMeasurableValueImpl(context, VOID, nodeId);
  }
  function MeasurableValueConcept() {
    MeasurableValueConcept_instance = this;
    var tmp = MeasurableValueImpl$_init_$ref_9xaz7v();
    OtConceptDescriptor.call(this, 'MeasurableValue', VOID, tmp, MeasurableValueConcept$_init_$lambda_4s9b8z, Companion_instance_95.z6p([AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance()]));
    this.dbk_1 = this.g6q(amount$factory(), 'amount');
    var tmp_0 = this;
    var tmp2 = unit$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_223().hbk_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(MeasurableValue_1), tmp2, getKClass(MeasurementUnit_1));
    tmp_0.ebk_1 = this.f6q(tmp$ret$0, tag, 'unit');
    this.fbk_1 = new DomainNodePropertyDescriptor(this.dbk_1, AttributePersisters_getInstance().a6n_1);
    this.gbk_1 = new DomainNodeReferencePropertyDescriptor(this.ebk_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var MeasurableValueConcept_instance;
  function MeasurableValueConcept_getInstance() {
    if (MeasurableValueConcept_instance == null)
      new MeasurableValueConcept();
    return MeasurableValueConcept_instance;
  }
  function amount$factory() {
    return getPropertyCallableRef('amount', 1, KProperty1, function (receiver) {
      return receiver.ibk();
    }, null);
  }
  function unit$factory() {
    return getPropertyCallableRef('unit', 1, KProperty1, function (receiver) {
      return receiver.jbk();
    }, null);
  }
  function MeasurementUnitImpl$_init_$ref_g1fhtx() {
    var l = function (p0, p1) {
      return new MeasurementUnitImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function MeasurementUnitConcept$_init_$lambda_wj7of7(context, nodeId) {
    return new TypedMeasurementUnitImpl(context, VOID, nodeId);
  }
  function MeasurementUnitConcept() {
    MeasurementUnitConcept_instance = this;
    var tmp = MeasurementUnitImpl$_init_$ref_g1fhtx();
    OtConceptDescriptor.call(this, 'MeasurementUnit', VOID, tmp, MeasurementUnitConcept$_init_$lambda_wj7of7, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
    this.ubk_1 = this.g6q(main$factory(), 'main');
    this.vbk_1 = new DomainNodePropertyDescriptor(this.ubk_1, toNonNullPersister(NonNullPersisters_getInstance().l2q(), new DefaultValueNullPersister(false)));
  }
  var MeasurementUnitConcept_instance;
  function MeasurementUnitConcept_getInstance() {
    if (MeasurementUnitConcept_instance == null)
      new MeasurementUnitConcept();
    return MeasurementUnitConcept_instance;
  }
  function main$factory() {
    return getPropertyCallableRef('main', 1, KProperty1, function (receiver) {
      return receiver.wbk();
    }, null);
  }
  function ModifierContainerImpl$_init_$ref_l6cqm3() {
    var l = function (p0, p1) {
      return new ModifierContainerImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ModifierContainerConcept$_init_$lambda_cl7avn(context, nodeId) {
    return new TypedModifierContainerImpl(context, VOID, nodeId);
  }
  function ModifierContainerConcept() {
    ModifierContainerConcept_instance = this;
    var tmp = ModifierContainerImpl$_init_$ref_l6cqm3();
    OtConceptDescriptor.call(this, 'ModifierContainer', VOID, tmp, ModifierContainerConcept$_init_$lambda_cl7avn, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    this.hbl_1 = this.i6q(modifiers$factory(), 'modifiers');
    this.ibl_1 = new DomainNodeChildrenPropertyDescriptor(this.hbl_1);
  }
  var ModifierContainerConcept_instance;
  function ModifierContainerConcept_getInstance() {
    if (ModifierContainerConcept_instance == null)
      new ModifierContainerConcept();
    return ModifierContainerConcept_instance;
  }
  function modifiers$factory() {
    return getPropertyCallableRef('modifiers', 1, KProperty1, function (receiver) {
      return receiver.jbl();
    }, null);
  }
  function ModifierDeclarationImpl$_init_$ref_vtdlnm() {
    var l = function (p0, p1) {
      return new ModifierDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ModifierDeclarationConcept$_init_$lambda_g8fm12(context, nodeId) {
    return new TypedModifierDeclarationImpl(context, VOID, nodeId);
  }
  function ModifierDeclarationConcept() {
    ModifierDeclarationConcept_instance = this;
    var tmp = ModifierDeclarationImpl$_init_$ref_vtdlnm();
    OtConceptDescriptor.call(this, 'ModifierDeclaration', VOID, tmp, ModifierDeclarationConcept$_init_$lambda_g8fm12, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
  }
  var ModifierDeclarationConcept_instance;
  function ModifierDeclarationConcept_getInstance() {
    if (ModifierDeclarationConcept_instance == null)
      new ModifierDeclarationConcept();
    return ModifierDeclarationConcept_instance;
  }
  function ModifierFactExpressionImpl$_init_$ref_g3i7l6() {
    var l = function (p0, p1) {
      return new ModifierFactExpressionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ModifierFactExpressionConcept$_init_$lambda_l5rn42(context, nodeId) {
    return new TypedModifierFactExpressionImpl(context, VOID, nodeId);
  }
  function ModifierFactExpressionConcept() {
    ModifierFactExpressionConcept_instance = this;
    var tmp = ModifierFactExpressionImpl$_init_$ref_g3i7l6();
    OtConceptDescriptor.call(this, 'ModifierFactExpression', VOID, tmp, ModifierFactExpressionConcept$_init_$lambda_l5rn42, Companion_instance_95.z6p([FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = modifier$factory();
    var tmp3 = Companion_getInstance_189().kbl_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'modifier';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ModifierFactExpression_0), tmp2, getKClass(ModifierDeclaration));
    tmp_0.vbl_1 = this.f6q(tmp$ret$0, tmp3, name);
    var tmp_1 = this;
    var tmp2_0 = expression$factory_0();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_0 = 'expression';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(ModifierFactExpression_0), tmp2_0);
    tmp_1.wbl_1 = this.d6q(tmp$ret$2, name_0);
    this.xbl_1 = new DomainNodeReferencePropertyDescriptor(this.vbl_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.ybl_1 = new DomainNodeChildPropertyDescriptor(this.wbl_1.h6n_1);
  }
  var ModifierFactExpressionConcept_instance;
  function ModifierFactExpressionConcept_getInstance() {
    if (ModifierFactExpressionConcept_instance == null)
      new ModifierFactExpressionConcept();
    return ModifierFactExpressionConcept_instance;
  }
  function modifier$factory() {
    return getPropertyCallableRef('modifier', 1, KProperty1, function (receiver) {
      return receiver.zbl();
    }, null);
  }
  function expression$factory_0() {
    return getPropertyCallableRef('expression', 1, KProperty1, function (receiver) {
      return receiver.lbb();
    }, null);
  }
  function MultilineTextImpl$_init_$ref_yept91() {
    var l = function (p0, p1) {
      return new MultilineTextImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function MultilineTextConcept$_init_$lambda_472car(context, nodeId) {
    return new TypedMultilineTextImpl(context, VOID, nodeId);
  }
  function MultilineTextConcept() {
    MultilineTextConcept_instance = this;
    var tmp = MultilineTextImpl$_init_$ref_yept91();
    OtConceptDescriptor.call(this, 'MultilineText', VOID, tmp, MultilineTextConcept$_init_$lambda_472car);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = lines$factory();
    var tmp$ret$0 = new MultipleChildLink(getKClass(MultilineText), this_0);
    tmp_0.kbm_1 = this.e6q(tmp$ret$0, 'lines');
    this.lbm_1 = new DomainNodeChildrenPropertyDescriptor(this.kbm_1.h6n_1);
  }
  var MultilineTextConcept_instance;
  function MultilineTextConcept_getInstance() {
    if (MultilineTextConcept_instance == null)
      new MultilineTextConcept();
    return MultilineTextConcept_instance;
  }
  function lines$factory() {
    return getPropertyCallableRef('lines', 1, KProperty1, function (receiver) {
      return receiver.mbm();
    }, null);
  }
  function MultipleProcessPropertyValueRangeImpl$_init_$ref_e13gzp() {
    var l = function (p0, p1) {
      return new MultipleProcessPropertyValueRangeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function MultipleProcessPropertyValueRangeConcept$_init_$lambda_4f6kwt(context, nodeId) {
    return new TypedMultipleProcessPropertyValueRangeImpl(context, VOID, nodeId);
  }
  function MultipleProcessPropertyValueRangeConcept() {
    MultipleProcessPropertyValueRangeConcept_instance = this;
    var tmp = MultipleProcessPropertyValueRangeImpl$_init_$ref_e13gzp();
    OtConceptDescriptor.call(this, 'MultipleProcessPropertyValueRange', VOID, tmp, MultipleProcessPropertyValueRangeConcept$_init_$lambda_4f6kwt, Companion_instance_95.z6p([ProcessPropertyValueRangeConcept_getInstance()]));
    this.xbm_1 = this.h6q(type$factory_2(), 'type');
    this.ybm_1 = new DomainNodeChildPropertyDescriptor(this.xbm_1);
  }
  var MultipleProcessPropertyValueRangeConcept_instance;
  function MultipleProcessPropertyValueRangeConcept_getInstance() {
    if (MultipleProcessPropertyValueRangeConcept_instance == null)
      new MultipleProcessPropertyValueRangeConcept();
    return MultipleProcessPropertyValueRangeConcept_instance;
  }
  function type$factory_2() {
    return getPropertyCallableRef('type', 1, KProperty1, function (receiver) {
      return receiver.zb3();
    }, null);
  }
  function MultiplePropertyValueRangeImpl$_init_$ref_og45as() {
    var l = function (p0, p1) {
      return new MultiplePropertyValueRangeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function MultiplePropertyValueRangeConcept$_init_$lambda_xrm9m4(context, nodeId) {
    return new TypedMultiplePropertyValueRangeImpl(context, VOID, nodeId);
  }
  function MultiplePropertyValueRangeConcept() {
    MultiplePropertyValueRangeConcept_instance = this;
    var tmp = MultiplePropertyValueRangeImpl$_init_$ref_og45as();
    OtConceptDescriptor.call(this, 'MultiplePropertyValueRange', VOID, tmp, MultiplePropertyValueRangeConcept$_init_$lambda_xrm9m4, Companion_instance_95.z6p([PropertyValueRangeConcept_getInstance()]));
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = types$factory();
    var tmp$ret$0 = new MultipleChildLink(getKClass(MultiplePropertyValueRange_1), this_0);
    tmp_0.jbn_1 = this.e6q(tmp$ret$0, 'types');
    this.kbn_1 = new DomainNodeChildrenPropertyDescriptor(this.jbn_1.h6n_1);
  }
  var MultiplePropertyValueRangeConcept_instance;
  function MultiplePropertyValueRangeConcept_getInstance() {
    if (MultiplePropertyValueRangeConcept_instance == null)
      new MultiplePropertyValueRangeConcept();
    return MultiplePropertyValueRangeConcept_instance;
  }
  function types$factory() {
    return getPropertyCallableRef('types', 1, KProperty1, function (receiver) {
      return receiver.lbn();
    }, null);
  }
  function NewFactImpl$_init_$ref_iy80jd() {
    var l = function (p0, p1) {
      return new NewFactImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NewFactConcept$_init_$lambda_rd31r(context, nodeId) {
    return new TypedNewFactImpl(context, VOID, nodeId);
  }
  function NewFactConcept() {
    NewFactConcept_instance = this;
    var tmp = NewFactImpl$_init_$ref_iy80jd();
    OtConceptDescriptor.call(this, 'NewFact', VOID, tmp, NewFactConcept$_init_$lambda_rd31r, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = expression$factory_1();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'expression';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(NewFact), tmp2);
    tmp_0.wbn_1 = this.d6q(tmp$ret$0, name);
    this.xbn_1 = new DomainNodeChildPropertyDescriptor(this.wbn_1.h6n_1);
  }
  var NewFactConcept_instance;
  function NewFactConcept_getInstance() {
    if (NewFactConcept_instance == null)
      new NewFactConcept();
    return NewFactConcept_instance;
  }
  function expression$factory_1() {
    return getPropertyCallableRef('expression', 1, KProperty1, function (receiver) {
      return receiver.lbb();
    }, null);
  }
  function NewFactReferenceImpl$_init_$ref_2k5k92() {
    var l = function (p0, p1) {
      return new NewFactReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NewFactReferenceConcept$_init_$lambda_bmulcu(context, nodeId) {
    return new TypedNewFactReferenceImpl(context, VOID, nodeId);
  }
  function NewFactReferenceConcept() {
    NewFactReferenceConcept_instance = this;
    var tmp = NewFactReferenceImpl$_init_$ref_2k5k92();
    OtConceptDescriptor.call(this, 'NewFactReference', VOID, tmp, NewFactReferenceConcept$_init_$lambda_bmulcu, Companion_instance_95.z6p([FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = ref$factory_0();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_190().ybn_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(NewFactReference_0), tmp2, getKClass(NewFact));
    tmp_0.jbo_1 = this.f6q(tmp$ret$0, tag, 'ref');
    this.kbo_1 = new DomainNodeReferencePropertyDescriptor(this.jbo_1, ReferenceContentPersisters_getInstance().s6p(getKClass(LocalReferenceContent)), getKClass(LocalReferenceContent));
  }
  var NewFactReferenceConcept_instance;
  function NewFactReferenceConcept_getInstance() {
    if (NewFactReferenceConcept_instance == null)
      new NewFactReferenceConcept();
    return NewFactReferenceConcept_instance;
  }
  function ref$factory_0() {
    return getPropertyCallableRef('ref', 1, KProperty1, function (receiver) {
      return receiver.ub6();
    }, null);
  }
  function NoValuesImpl$_init_$ref_ehnszm() {
    var l = function (p0, p1) {
      return new NoValuesImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NoValuesConcept$_init_$lambda_x3fplm(context, nodeId) {
    return new TypedNoValuesImpl(context, VOID, nodeId);
  }
  function NoValuesConcept() {
    NoValuesConcept_instance = this;
    var tmp = NoValuesImpl$_init_$ref_ehnszm();
    OtConceptDescriptor.call(this, 'NoValues', VOID, tmp, NoValuesConcept$_init_$lambda_x3fplm, Companion_instance_95.z6p([PropertyValueRangeConcept_getInstance()]));
  }
  var NoValuesConcept_instance;
  function NoValuesConcept_getInstance() {
    if (NoValuesConcept_instance == null)
      new NoValuesConcept();
    return NoValuesConcept_instance;
  }
  function NotionLibraryImpl$_init_$ref_mwqjgf() {
    var l = function (p0, p1) {
      return new NotionLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NotionLibraryConcept$_init_$lambda_4m94pj(context, nodeId) {
    return new TypedNotionLibraryImpl(context, VOID, nodeId);
  }
  function NotionLibraryConcept() {
    NotionLibraryConcept_instance = this;
    var tmp = NotionLibraryImpl$_init_$ref_mwqjgf();
    OtConceptDescriptor.call(this, 'NotionsLibrary', VOID, tmp, NotionLibraryConcept$_init_$lambda_4m94pj, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    this.vbo_1 = this.i6q(notions$factory(), 'notions');
    this.wbo_1 = new DomainNodeChildrenPropertyDescriptor(this.vbo_1);
  }
  var NotionLibraryConcept_instance;
  function NotionLibraryConcept_getInstance() {
    if (NotionLibraryConcept_instance == null)
      new NotionLibraryConcept();
    return NotionLibraryConcept_instance;
  }
  function notions$factory() {
    return getPropertyCallableRef('notions', 1, KProperty1, function (receiver) {
      return receiver.xbo();
    }, null);
  }
  function NotionPlaceholderImpl$_init_$ref_o93ttz() {
    var l = function (p0, p1) {
      return new NotionPlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NotionPlaceholderConcept$_init_$lambda_uzt1y9(context, nodeId) {
    return new TypedNotionPlaceholderImpl(context, VOID, nodeId);
  }
  function NotionPlaceholderConcept() {
    NotionPlaceholderConcept_instance = this;
    var tmp = NotionPlaceholderImpl$_init_$ref_o93ttz();
    OtConceptDescriptor.call(this, 'NotionPlaceholder', VOID, tmp, NotionPlaceholderConcept$_init_$lambda_uzt1y9, Companion_instance_95.z6p([AbstractNotionConcept_getInstance()]));
  }
  var NotionPlaceholderConcept_instance;
  function NotionPlaceholderConcept_getInstance() {
    if (NotionPlaceholderConcept_instance == null)
      new NotionPlaceholderConcept();
    return NotionPlaceholderConcept_instance;
  }
  function NotionTypeImpl$_init_$ref_xybv8q() {
    var l = function (p0, p1) {
      return new NotionTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NotionTypeConcept$_init_$lambda_me3gnm(context, nodeId) {
    return new TypedNotionTypeImpl(context, VOID, nodeId);
  }
  function NotionTypeConcept() {
    NotionTypeConcept_instance = this;
    var tmp = NotionTypeImpl$_init_$ref_xybv8q();
    OtConceptDescriptor.call(this, 'NotionType', VOID, tmp, NotionTypeConcept$_init_$lambda_me3gnm, Companion_instance_95.z6p([TypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = notion$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_220().ybo_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(NotionType_0), tmp2, getKClass(AbstractNotion));
    tmp_0.jbp_1 = this.f6q(tmp$ret$0, tag, 'notion');
    this.kbp_1 = new DomainNodeReferencePropertyDescriptor(this.jbp_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var NotionTypeConcept_instance;
  function NotionTypeConcept_getInstance() {
    if (NotionTypeConcept_instance == null)
      new NotionTypeConcept();
    return NotionTypeConcept_instance;
  }
  function notion$factory() {
    return getPropertyCallableRef('notion', 1, KProperty1, function (receiver) {
      return receiver.lbp();
    }, null);
  }
  function ObjectPropertiesLibraryImpl$_init_$ref_sd76po() {
    var l = function (p0, p1) {
      return new ObjectPropertiesLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ObjectPropertiesLibraryConcept$_init_$lambda_s3cvl8(context, nodeId) {
    return new TypedObjectPropertiesLibraryImpl(context, VOID, nodeId);
  }
  function ObjectPropertiesLibraryConcept() {
    ObjectPropertiesLibraryConcept_instance = this;
    var tmp = ObjectPropertiesLibraryImpl$_init_$ref_sd76po();
    OtConceptDescriptor.call(this, 'ObjectPropertiesLibrary', VOID, tmp, ObjectPropertiesLibraryConcept$_init_$lambda_s3cvl8, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = properties$factory_0();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'properties';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(ObjectPropertiesLibrary), tmp2);
    tmp_0.wbp_1 = this.e6q(tmp$ret$0, name);
    this.xbp_1 = new DomainNodeChildrenPropertyDescriptor(this.wbp_1.h6n_1);
  }
  var ObjectPropertiesLibraryConcept_instance;
  function ObjectPropertiesLibraryConcept_getInstance() {
    if (ObjectPropertiesLibraryConcept_instance == null)
      new ObjectPropertiesLibraryConcept();
    return ObjectPropertiesLibraryConcept_instance;
  }
  function properties$factory_0() {
    return getPropertyCallableRef('properties', 1, KProperty1, function (receiver) {
      return receiver.pas();
    }, null);
  }
  function ObjectPropertyDeclarationImpl$_init_$ref_q9z281() {
    var l = function (p0, p1) {
      return new ObjectPropertyDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ObjectPropertyDeclarationConcept$_init_$lambda_fj5jpz(context, nodeId) {
    return new TypedObjectPropertyDeclarationImpl(context, VOID, nodeId);
  }
  function ObjectPropertyDeclarationConcept() {
    ObjectPropertyDeclarationConcept_instance = this;
    var tmp = ObjectPropertyDeclarationImpl$_init_$ref_q9z281();
    OtConceptDescriptor.call(this, 'ObjectPropertyDeclaration', VOID, tmp, ObjectPropertyDeclarationConcept$_init_$lambda_fj5jpz, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
    this.ibq_1 = this.g6q(grouping$factory(), 'grouping');
    var tmp_0 = this;
    var tmp2 = superProperty$factory();
    var tmp3 = Companion_getInstance_203().ubq_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'superProperty';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ObjectPropertyDeclaration_1), tmp2, getKClass(ObjectPropertyDeclaration_1));
    tmp_0.jbq_1 = this.f6q(tmp$ret$0, tmp3, name);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = domain$factory_0();
    var tmp$ret$2 = new MultipleChildLink(getKClass(ObjectPropertyDeclaration_1), this_0);
    tmp_1.kbq_1 = this.e6q(tmp$ret$2, 'dmn');
    var tmp_2 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = range$factory_0();
    var tmp$ret$4 = new SingleChildLink(getKClass(ObjectPropertyDeclaration_1), this_1);
    tmp_2.lbq_1 = this.d6q(tmp$ret$4, 'range');
    this.mbq_1 = this.g6q(dependent$factory(), 'dependent');
    var tmp_3 = this;
    var tmp2_0 = inverse$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_203().vbq_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$6 = new ReferenceLink(getKClass(ObjectPropertyDeclaration_1), tmp2_0, getKClass(ObjectPropertyDeclaration_1));
    tmp_3.nbq_1 = this.f6q(tmp$ret$6, tag, 'inverse');
    this.obq_1 = new DomainNodePropertyDescriptor(this.ibq_1, toNonNullPersister(NonNullPersisters_getInstance().l2q(), new DefaultValueNullPersister(false)));
    this.pbq_1 = new DomainNodeReferencePropertyDescriptor(this.jbq_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.qbq_1 = new DomainNodeChildrenPropertyDescriptor(this.kbq_1.h6n_1);
    this.rbq_1 = new DomainNodeChildPropertyDescriptor(this.lbq_1.h6n_1);
    this.sbq_1 = new DomainNodePropertyDescriptor(this.mbq_1, toNonNullPersister(NonNullPersisters_getInstance().l2q(), new DefaultValueNullPersister(false)));
    this.tbq_1 = new DomainNodeReferencePropertyDescriptor(this.nbq_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ObjectPropertyDeclarationConcept_instance;
  function ObjectPropertyDeclarationConcept_getInstance() {
    if (ObjectPropertyDeclarationConcept_instance == null)
      new ObjectPropertyDeclarationConcept();
    return ObjectPropertyDeclarationConcept_instance;
  }
  function grouping$factory() {
    return getPropertyCallableRef('grouping', 1, KProperty1, function (receiver) {
      return receiver.wbq();
    }, null);
  }
  function superProperty$factory() {
    return getPropertyCallableRef('superProperty', 1, KProperty1, function (receiver) {
      return receiver.xbq();
    }, null);
  }
  function domain$factory_0() {
    return getPropertyCallableRef('domain', 1, KProperty1, function (receiver) {
      return receiver.obe();
    }, null);
  }
  function range$factory_0() {
    return getPropertyCallableRef('range', 1, KProperty1, function (receiver) {
      return receiver.be();
    }, null);
  }
  function dependent$factory() {
    return getPropertyCallableRef('dependent', 1, KProperty1, function (receiver) {
      return receiver.ybq();
    }, null);
  }
  function inverse$factory() {
    return getPropertyCallableRef('inverse', 1, KProperty1, function (receiver) {
      return receiver.zbq();
    }, null);
  }
  function ObjectPropertyReferenceValueImpl$_init_$ref_p57lbf() {
    var l = function (p0, p1) {
      return new ObjectPropertyReferenceValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ObjectPropertyReferenceValueConcept$_init_$lambda_li5t4z(context, nodeId) {
    return new TypedObjectPropertyReferenceValueImpl(context, VOID, nodeId);
  }
  function ObjectPropertyReferenceValueConcept() {
    ObjectPropertyReferenceValueConcept_instance = this;
    var tmp = ObjectPropertyReferenceValueImpl$_init_$ref_p57lbf();
    OtConceptDescriptor.call(this, 'ObjectPropertyReferenceValue', VOID, tmp, ObjectPropertyReferenceValueConcept$_init_$lambda_li5t4z, Companion_instance_95.z6p([AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = operand$factory();
    var tmp$ret$0 = new SingleChildLink(getKClass(ObjectPropertyReferenceValue_1), this_0);
    tmp_0.kbr_1 = this.d6q(tmp$ret$0, 'operand');
    var tmp_1 = this;
    var tmp2 = property$factory_0();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(ObjectPropertyReferenceValue_1), tmp2);
    tmp_1.lbr_1 = this.d6q(tmp$ret$2, name);
    this.mbr_1 = new DomainNodeChildPropertyDescriptor(this.kbr_1.h6n_1);
    this.nbr_1 = new DomainNodeChildPropertyDescriptor(this.lbr_1.h6n_1);
  }
  var ObjectPropertyReferenceValueConcept_instance;
  function ObjectPropertyReferenceValueConcept_getInstance() {
    if (ObjectPropertyReferenceValueConcept_instance == null)
      new ObjectPropertyReferenceValueConcept();
    return ObjectPropertyReferenceValueConcept_instance;
  }
  function operand$factory() {
    return getPropertyCallableRef('operand', 1, KProperty1, function (receiver) {
      return receiver.obr();
    }, null);
  }
  function property$factory_0() {
    return getPropertyCallableRef('property', 1, KProperty1, function (receiver) {
      return receiver.i6u();
    }, null);
  }
  function OldPublishedSourceImpl$_init_$ref_9vd5v() {
    var l = function (p0, p1) {
      return new OldPublishedSourceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OldPublishedSourceConcept$_init_$lambda_91keij(context, nodeId) {
    return new TypedOldPublishedSourceImpl(context, VOID, nodeId);
  }
  function OldPublishedSourceConcept() {
    OldPublishedSourceConcept_instance = this;
    var tmp = OldPublishedSourceImpl$_init_$ref_9vd5v();
    OtConceptDescriptor.call(this, 'PublishedSource', VOID, tmp, OldPublishedSourceConcept$_init_$lambda_91keij, Companion_instance_95.z6p([PublishedWorkConcept_getInstance(), LibraryItemConcept_getInstance()]));
    this.zbr_1 = this.g6q(authorsProperty$factory(), 'authors');
    this.abs_1 = this.g6q(data$factory(), 'data');
    this.bbs_1 = new DomainNodePropertyDescriptor(this.zbr_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
    this.cbs_1 = new DomainNodePropertyDescriptor(this.abs_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
  }
  var OldPublishedSourceConcept_instance;
  function OldPublishedSourceConcept_getInstance() {
    if (OldPublishedSourceConcept_instance == null)
      new OldPublishedSourceConcept();
    return OldPublishedSourceConcept_instance;
  }
  function authorsProperty$factory() {
    return getPropertyCallableRef('authorsProperty', 1, KProperty1, function (receiver) {
      return receiver.dbs();
    }, null);
  }
  function data$factory() {
    return getPropertyCallableRef('data', 1, KProperty1, function (receiver) {
      return receiver.ebs();
    }, null);
  }
  function OneOfImpl$_init_$ref_mbczyw() {
    var l = function (p0, p1) {
      return new OneOfImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OneOfConcept$_init_$lambda_atpphc(context, nodeId) {
    return new TypedOneOfImpl(context, VOID, nodeId);
  }
  function OneOfConcept() {
    OneOfConcept_instance = this;
    var tmp = OneOfImpl$_init_$ref_mbczyw();
    OtConceptDescriptor.call(this, 'OneOf', VOID, tmp, OneOfConcept$_init_$lambda_atpphc, Companion_instance_95.z6p([TypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = expressions$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'expressions';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(OneOf_1), tmp2);
    tmp_0.pbs_1 = this.e6q(tmp$ret$0, name);
    this.qbs_1 = new DomainNodeChildrenPropertyDescriptor(this.pbs_1.h6n_1);
  }
  var OneOfConcept_instance;
  function OneOfConcept_getInstance() {
    if (OneOfConcept_instance == null)
      new OneOfConcept();
    return OneOfConcept_instance;
  }
  function expressions$factory() {
    return getPropertyCallableRef('expressions', 1, KProperty1, function (receiver) {
      return receiver.rbs();
    }, null);
  }
  function OntologyCardinalityRelationImpl$_init_$ref_bsrbje() {
    var l = function (p0, p1) {
      return new OntologyCardinalityRelationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyCardinalityRelationConcept$_init_$lambda_vxauwy(context, nodeId) {
    return new TypedOntologyCardinalityRelationImpl(context, VOID, nodeId);
  }
  function OntologyCardinalityRelationConcept() {
    OntologyCardinalityRelationConcept_instance = this;
    var tmp = OntologyCardinalityRelationImpl$_init_$ref_bsrbje();
    OtConceptDescriptor.call(this, 'OntologyCardinalityRelation', VOID, tmp, OntologyCardinalityRelationConcept$_init_$lambda_vxauwy, Companion_instance_95.z6p([AbstractOntologyRelationConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = classExpression$factory_0();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'elementReferenceProvider';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyCardinalityRelation_1), tmp2);
    tmp_0.cbt_1 = this.d6q(tmp$ret$0, name);
    this.dbt_1 = this.h6q(cardinality$factory_1(), 'cardinality');
    this.ebt_1 = new DomainNodeChildPropertyDescriptor(this.cbt_1.h6n_1);
    this.fbt_1 = new DomainNodeChildPropertyDescriptor(this.dbt_1);
  }
  var OntologyCardinalityRelationConcept_instance;
  function OntologyCardinalityRelationConcept_getInstance() {
    if (OntologyCardinalityRelationConcept_instance == null)
      new OntologyCardinalityRelationConcept();
    return OntologyCardinalityRelationConcept_instance;
  }
  function classExpression$factory_0() {
    return getPropertyCallableRef('classExpression', 1, KProperty1, function (receiver) {
      return receiver.yay();
    }, null);
  }
  function cardinality$factory_1() {
    return getPropertyCallableRef('cardinality', 1, KProperty1, function (receiver) {
      return receiver.eb8();
    }, null);
  }
  function OntologyElementImpl$_init_$ref_3aqors() {
    var l = function (p0, p1) {
      return new OntologyElementImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementConcept$_init_$lambda_9azl3k(context, nodeId) {
    return new TypedOntologyElementImpl(context, VOID, nodeId);
  }
  function OntologyElementConcept() {
    OntologyElementConcept_instance = this;
    var tmp = OntologyElementImpl$_init_$ref_3aqors();
    OtConceptDescriptor.call(this, 'OntologyElement', VOID, tmp, OntologyElementConcept$_init_$lambda_9azl3k, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance(), ClassDeclarationConcept_getInstance(), HasPropertyConstraintsConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = superElements$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'superElements';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(OntologyElement_1), tmp2);
    tmp_0.qbt_1 = this.e6q(tmp$ret$0, name);
    var tmp_1 = this;
    var tmp2_0 = enclosingElements$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_0 = 'isPartOf';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new MultipleChildLink(getKClass(OntologyElement_1), tmp2_0);
    tmp_1.rbt_1 = this.e6q(tmp$ret$2, name_0);
    var tmp_2 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = taxon$factory();
    var tmp$ret$4 = new SingleChildLink(getKClass(OntologyElement_1), this_0);
    tmp_2.sbt_1 = this.d6q(tmp$ret$4, 'taxon');
    this.tbt_1 = this.g6q(url$factory(), 'url');
    var tmp_3 = this;
    var tmp2_1 = synonyms$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_1 = 'synonyms';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$6 = new MultipleChildLink(getKClass(OntologyElement_1), tmp2_1);
    tmp_3.ubt_1 = this.e6q(tmp$ret$6, name_1);
    var tmp_4 = this;
    var tmp2_2 = xRefContainers$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_2 = 'xRefContainers';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$8 = new MultipleChildLink(getKClass(OntologyElement_1), tmp2_2);
    tmp_4.vbt_1 = this.e6q(tmp$ret$8, name_2);
    var tmp_5 = this;
    var tmp2_3 = oldDefinition$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_3 = 'definition';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$10 = new SingleChildLink(getKClass(OntologyElement_1), tmp2_3);
    tmp_5.wbt_1 = this.d6q(tmp$ret$10, name_3);
    var tmp_6 = this;
    var tmp2_4 = definition$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_4 = 'newDefinition';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$12 = new SingleChildLink(getKClass(OntologyElement_1), tmp2_4);
    tmp_6.xbt_1 = this.d6q(tmp$ret$12, name_4);
    this.ybt_1 = new DomainNodeChildrenPropertyDescriptor(this.qbt_1.h6n_1);
    this.zbt_1 = new DomainNodeChildrenPropertyDescriptor(this.rbt_1.h6n_1);
    this.abu_1 = new DomainNodeChildPropertyDescriptor(this.sbt_1.h6n_1);
    this.bbu_1 = new DomainNodePropertyDescriptor(this.tbt_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
    this.cbu_1 = new DomainNodeChildrenPropertyDescriptor(this.ubt_1.h6n_1);
    this.dbu_1 = new DomainNodeChildrenPropertyDescriptor(this.vbt_1.h6n_1);
    this.ebu_1 = new DomainNodeChildPropertyDescriptor(this.wbt_1.h6n_1);
    this.fbu_1 = new DomainNodeChildPropertyDescriptor(this.xbt_1.h6n_1);
  }
  var OntologyElementConcept_instance;
  function OntologyElementConcept_getInstance() {
    if (OntologyElementConcept_instance == null)
      new OntologyElementConcept();
    return OntologyElementConcept_instance;
  }
  function superElements$factory() {
    return getPropertyCallableRef('superElements', 1, KProperty1, function (receiver) {
      return receiver.gbu();
    }, null);
  }
  function enclosingElements$factory() {
    return getPropertyCallableRef('enclosingElements', 1, KProperty1, function (receiver) {
      return receiver.hbu();
    }, null);
  }
  function taxon$factory() {
    return getPropertyCallableRef('taxon', 1, KProperty1, function (receiver) {
      return receiver.ibu();
    }, null);
  }
  function url$factory() {
    return getPropertyCallableRef('url', 1, KProperty1, function (receiver) {
      return receiver.jbu();
    }, null);
  }
  function synonyms$factory() {
    return getPropertyCallableRef('synonyms', 1, KProperty1, function (receiver) {
      return receiver.kbu();
    }, null);
  }
  function xRefContainers$factory() {
    return getPropertyCallableRef('xRefContainers', 1, KProperty1, function (receiver) {
      return receiver.lbu();
    }, null);
  }
  function oldDefinition$factory() {
    return getPropertyCallableRef('oldDefinition', 1, KProperty1, function (receiver) {
      return receiver.mbu();
    }, null);
  }
  function definition$factory() {
    return getPropertyCallableRef('definition', 1, KProperty1, function (receiver) {
      return receiver.nbu();
    }, null);
  }
  function OntologyElementDefinitionImpl$_init_$ref_pvcepx() {
    var l = function (p0, p1) {
      return new OntologyElementDefinitionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementDefinitionConcept$_init_$lambda_bscz6l(context, nodeId) {
    return new TypedOntologyElementDefinitionImpl(context, VOID, nodeId);
  }
  function OntologyElementDefinitionConcept() {
    OntologyElementDefinitionConcept_instance = this;
    var tmp = OntologyElementDefinitionImpl$_init_$ref_pvcepx();
    OtConceptDescriptor.call(this, 'OntologyElementDefinition', VOID, tmp, OntologyElementDefinitionConcept$_init_$lambda_bscz6l, Companion_instance_95.z6p([HasPropertyConstraintsConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = classExpression$factory_1();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'classExpression';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElementDefinition_1), tmp2);
    tmp_0.ybu_1 = this.d6q(tmp$ret$0, name);
    this.zbu_1 = new DomainNodeChildPropertyDescriptor(this.ybu_1.h6n_1);
  }
  var OntologyElementDefinitionConcept_instance;
  function OntologyElementDefinitionConcept_getInstance() {
    if (OntologyElementDefinitionConcept_instance == null)
      new OntologyElementDefinitionConcept();
    return OntologyElementDefinitionConcept_instance;
  }
  function classExpression$factory_1() {
    return getPropertyCallableRef('classExpression', 1, KProperty1, function (receiver) {
      return receiver.yay();
    }, null);
  }
  function OntologyElementPropertyTypeImpl$_init_$ref_za1621() {
    var l = function (p0, p1) {
      return new OntologyElementPropertyTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementPropertyTypeConcept$_init_$lambda_8wnwcf(context, nodeId) {
    return new TypedOntologyElementPropertyTypeImpl(context, VOID, nodeId);
  }
  function OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_11();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).qbh = function (value) {
    return value.toString();
  };
  protoOf(OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).x2p = function (value) {
    return this.qbh(value instanceof LinkTypeSpecificator ? value : THROW_CCE());
  };
  protoOf(OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_11();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).qbh = function (value) {
    return value.toString();
  };
  protoOf(OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).x2p = function (value) {
    return this.qbh(value instanceof LinkTypeSpecificator ? value : THROW_CCE());
  };
  protoOf(OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function OntologyElementPropertyTypeConcept() {
    OntologyElementPropertyTypeConcept_instance = this;
    var tmp = OntologyElementPropertyTypeImpl$_init_$ref_za1621();
    OtConceptDescriptor.call(this, 'OntologyElementPropertyType', VOID, tmp, OntologyElementPropertyTypeConcept$_init_$lambda_8wnwcf, Companion_instance_95.z6p([ProcessPropertyTypeConcept_getInstance()]));
    this.kbv_1 = this.g6q(specificator$factory_1(), 'specificator');
    this.lbv_1 = this.h6q(library$factory_2(), 'library');
    this.mbv_1 = this.h6q(element$factory_3(), 'element');
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$0 = new OntologyElementPropertyTypeConcept$SPECIFICATOR_PERSISTER$$inlined$enumPersister$1();
    tmp_0.nbv_1 = toNullablePersister(tmp$ret$0);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$1 = new OntologyElementPropertyTypeConcept$specificatorPropertyDescriptor$$inlined$enumPersister$1();
    tmp_1.obv_1 = new DomainNodePropertyDescriptor(this.kbv_1, toNullablePersister(tmp$ret$1));
    this.pbv_1 = new DomainNodeChildPropertyDescriptor(this.lbv_1);
    this.qbv_1 = new DomainNodeChildPropertyDescriptor(this.mbv_1);
  }
  var OntologyElementPropertyTypeConcept_instance;
  function OntologyElementPropertyTypeConcept_getInstance() {
    if (OntologyElementPropertyTypeConcept_instance == null)
      new OntologyElementPropertyTypeConcept();
    return OntologyElementPropertyTypeConcept_instance;
  }
  function specificator$factory_1() {
    return getPropertyCallableRef('specificator', 1, KProperty1, function (receiver) {
      return receiver.sba();
    }, null);
  }
  function library$factory_2() {
    return getPropertyCallableRef('library', 1, KProperty1, function (receiver) {
      return receiver.kay();
    }, null);
  }
  function element$factory_3() {
    return getPropertyCallableRef('element', 1, KProperty1, function (receiver) {
      return receiver.lay();
    }, null);
  }
  function OntologyElementReferenceImpl$_init_$ref_92b7lz() {
    var l = function (p0, p1) {
      return new OntologyElementReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementReferenceConcept$_init_$lambda_5yxizj(context, nodeId) {
    return new TypedOntologyElementReferenceImpl(context, VOID, nodeId);
  }
  function OntologyElementReferenceConcept() {
    OntologyElementReferenceConcept_instance = this;
    var tmp = OntologyElementReferenceImpl$_init_$ref_92b7lz();
    OtConceptDescriptor.call(this, 'OntologyElementReference', VOID, tmp, OntologyElementReferenceConcept$_init_$lambda_5yxizj, Companion_instance_95.z6p([OntologyElementReferenceProviderConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = element$factory_4();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_205().rbv_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(OntologyElementReference_1), tmp2, getKClass(OntologyElement_1));
    tmp_0.cbw_1 = this.f6q(tmp$ret$0, tag, 'element');
    this.dbw_1 = new DomainNodeReferencePropertyDescriptor(this.cbw_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var OntologyElementReferenceConcept_instance;
  function OntologyElementReferenceConcept_getInstance() {
    if (OntologyElementReferenceConcept_instance == null)
      new OntologyElementReferenceConcept();
    return OntologyElementReferenceConcept_instance;
  }
  function element$factory_4() {
    return getPropertyCallableRef('element', 1, KProperty1, function (receiver) {
      return receiver.lay();
    }, null);
  }
  function OntologyElementReferenceProviderConcept() {
    OntologyElementReferenceProviderConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([ClassExpressionConcept_getInstance()]));
  }
  var OntologyElementReferenceProviderConcept_instance;
  function OntologyElementReferenceProviderConcept_getInstance() {
    if (OntologyElementReferenceProviderConcept_instance == null)
      new OntologyElementReferenceProviderConcept();
    return OntologyElementReferenceProviderConcept_instance;
  }
  function OntologyElementReferenceValueImpl$_init_$ref_es0ctq() {
    var l = function (p0, p1) {
      return new OntologyElementReferenceValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementReferenceValueConcept$_init_$lambda_gorega(context, nodeId) {
    return new TypedOntologyElementReferenceValueImpl(context, VOID, nodeId);
  }
  function OntologyElementReferenceValueConcept() {
    OntologyElementReferenceValueConcept_instance = this;
    var tmp = OntologyElementReferenceValueImpl$_init_$ref_es0ctq();
    OtConceptDescriptor.call(this, 'OntologyElementReferenceValue', VOID, tmp, OntologyElementReferenceValueConcept$_init_$lambda_gorega, Companion_instance_95.z6p([AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance()]));
    this.obw_1 = this.h6q(element$factory_5(), 'element');
    this.pbw_1 = new DomainNodeChildPropertyDescriptor(this.obw_1);
  }
  var OntologyElementReferenceValueConcept_instance;
  function OntologyElementReferenceValueConcept_getInstance() {
    if (OntologyElementReferenceValueConcept_instance == null)
      new OntologyElementReferenceValueConcept();
    return OntologyElementReferenceValueConcept_instance;
  }
  function element$factory_5() {
    return getPropertyCallableRef('element', 1, KProperty1, function (receiver) {
      return receiver.lay();
    }, null);
  }
  function OntologyElementReferenceValueLibraryImpl$_init_$ref_tg65st() {
    var l = function (p0, p1) {
      return new OntologyElementReferenceValueLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementReferenceValueLibraryConcept$_init_$lambda_8185fv(context, nodeId) {
    return new TypedOntologyElementReferenceValueLibraryImpl(context, VOID, nodeId);
  }
  function OntologyElementReferenceValueLibraryConcept() {
    OntologyElementReferenceValueLibraryConcept_instance = this;
    var tmp = OntologyElementReferenceValueLibraryImpl$_init_$ref_tg65st();
    OtConceptDescriptor.call(this, 'OntologyElementReferenceValueLibrary', VOID, tmp, OntologyElementReferenceValueLibraryConcept$_init_$lambda_8185fv, Companion_instance_95.z6p([OntologyElementReferenceValueConcept_getInstance()]));
    this.abx_1 = this.h6q(library$factory_3(), 'library');
    this.bbx_1 = new DomainNodeChildPropertyDescriptor(this.abx_1);
  }
  var OntologyElementReferenceValueLibraryConcept_instance;
  function OntologyElementReferenceValueLibraryConcept_getInstance() {
    if (OntologyElementReferenceValueLibraryConcept_instance == null)
      new OntologyElementReferenceValueLibraryConcept();
    return OntologyElementReferenceValueLibraryConcept_instance;
  }
  function library$factory_3() {
    return getPropertyCallableRef('library', 1, KProperty1, function (receiver) {
      return receiver.kay();
    }, null);
  }
  function OntologyElementSynonymImpl$_init_$ref_sk8zl5() {
    var l = function (p0, p1) {
      return new OntologyElementSynonymImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementSynonymConcept$_init_$lambda_vd5dkf(context, nodeId) {
    return new TypedOntologyElementSynonymImpl(context, VOID, nodeId);
  }
  function OntologyElementSynonymConcept() {
    OntologyElementSynonymConcept_instance = this;
    var tmp = OntologyElementSynonymImpl$_init_$ref_sk8zl5();
    OtConceptDescriptor.call(this, 'Synonym', VOID, tmp, OntologyElementSynonymConcept$_init_$lambda_vd5dkf);
    this.mbx_1 = this.g6q(name$factory_0(), 'name');
    this.nbx_1 = new DomainNodePropertyDescriptor(this.mbx_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
  }
  var OntologyElementSynonymConcept_instance;
  function OntologyElementSynonymConcept_getInstance() {
    if (OntologyElementSynonymConcept_instance == null)
      new OntologyElementSynonymConcept();
    return OntologyElementSynonymConcept_instance;
  }
  function name$factory_0() {
    return getPropertyCallableRef('name', 1, KProperty1, function (receiver) {
      return receiver.b3();
    }, null);
  }
  function OntologyElementTypeImpl$_init_$ref_dnw7pe() {
    var l = function (p0, p1) {
      return new OntologyElementTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyElementTypeConcept$_init_$lambda_n5a40m(context, nodeId) {
    return new TypedOntologyElementTypeImpl(context, VOID, nodeId);
  }
  function OntologyElementTypeConcept() {
    OntologyElementTypeConcept_instance = this;
    var tmp = OntologyElementTypeImpl$_init_$ref_dnw7pe();
    OtConceptDescriptor.call(this, 'OntologyElementType', VOID, tmp, OntologyElementTypeConcept$_init_$lambda_n5a40m, Companion_instance_95.z6p([TypeConcept_getInstance()]));
    this.ybx_1 = this.h6q(library$factory_4(), 'library');
    this.zbx_1 = this.h6q(element$factory_6(), 'element');
    this.aby_1 = new DomainNodeChildPropertyDescriptor(this.ybx_1);
    this.bby_1 = new DomainNodeChildPropertyDescriptor(this.zbx_1);
  }
  var OntologyElementTypeConcept_instance;
  function OntologyElementTypeConcept_getInstance() {
    if (OntologyElementTypeConcept_instance == null)
      new OntologyElementTypeConcept();
    return OntologyElementTypeConcept_instance;
  }
  function library$factory_4() {
    return getPropertyCallableRef('library', 1, KProperty1, function (receiver) {
      return receiver.kay();
    }, null);
  }
  function element$factory_6() {
    return getPropertyCallableRef('element', 1, KProperty1, function (receiver) {
      return receiver.lay();
    }, null);
  }
  function OntologyImportImpl$_init_$ref_wqann3() {
    var l = function (p0, p1) {
      return new OntologyImportImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyImportConcept$_init_$lambda_jllb4n(context, nodeId) {
    return new TypedOntologyImportImpl(context, VOID, nodeId);
  }
  function OntologyImportConcept() {
    OntologyImportConcept_instance = this;
    var tmp = OntologyImportImpl$_init_$ref_wqann3();
    OtConceptDescriptor.call(this, 'OntologyImport', VOID, tmp, OntologyImportConcept$_init_$lambda_jllb4n);
    var tmp_0 = this;
    var tmp2 = ontology$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'ontology';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyImport_1), tmp2);
    tmp_0.mby_1 = this.d6q(tmp$ret$0, name);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = element$factory_7();
    var tmp$ret$2 = new SingleChildLink(getKClass(OntologyImport_1), this_0);
    tmp_1.nby_1 = this.d6q(tmp$ret$2, 'element');
    var tmp_2 = this;
    var tmp2_0 = libraryToUse$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_0 = 'libraryToUse';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$4 = new SingleChildLink(getKClass(OntologyImport_1), tmp2_0);
    tmp_2.oby_1 = this.d6q(tmp$ret$4, name_0);
    this.pby_1 = new DomainNodeChildPropertyDescriptor(this.mby_1.h6n_1);
    this.qby_1 = new DomainNodeChildPropertyDescriptor(this.nby_1.h6n_1);
    this.rby_1 = new DomainNodeChildPropertyDescriptor(this.oby_1.h6n_1);
  }
  var OntologyImportConcept_instance;
  function OntologyImportConcept_getInstance() {
    if (OntologyImportConcept_instance == null)
      new OntologyImportConcept();
    return OntologyImportConcept_instance;
  }
  function ontology$factory() {
    return getPropertyCallableRef('ontology', 1, KProperty1, function (receiver) {
      return receiver.sby();
    }, null);
  }
  function element$factory_7() {
    return getPropertyCallableRef('element', 1, KProperty1, function (receiver) {
      return receiver.lay();
    }, null);
  }
  function libraryToUse$factory() {
    return getPropertyCallableRef('libraryToUse', 1, KProperty1, function (receiver) {
      return receiver.tby();
    }, null);
  }
  function OntologyImportRootImpl$_init_$ref_43ud1r() {
    var l = function (p0, p1) {
      return new OntologyImportRootImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyImportRootConcept$_init_$lambda_hnj9ll(context, nodeId) {
    return new TypedOntologyImportRootImpl(context, VOID, nodeId);
  }
  function OntologyImportRootConcept() {
    OntologyImportRootConcept_instance = this;
    var tmp = OntologyImportRootImpl$_init_$ref_43ud1r();
    OtConceptDescriptor.call(this, 'OntologyImportRoot', VOID, tmp, OntologyImportRootConcept$_init_$lambda_hnj9ll, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    this.ebz_1 = this.i6q(imports$factory_0(), 'imports');
    this.fbz_1 = new DomainNodeChildrenPropertyDescriptor(this.ebz_1);
  }
  var OntologyImportRootConcept_instance;
  function OntologyImportRootConcept_getInstance() {
    if (OntologyImportRootConcept_instance == null)
      new OntologyImportRootConcept();
    return OntologyImportRootConcept_instance;
  }
  function imports$factory_0() {
    return getPropertyCallableRef('imports', 1, KProperty1, function (receiver) {
      return receiver.sau();
    }, null);
  }
  function OntologyImportRootReferenceImpl$_init_$ref_mgkrbk() {
    var l = function (p0, p1) {
      return new OntologyImportRootReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyImportRootReferenceConcept$_init_$lambda_n0554(context, nodeId) {
    return new TypedOntologyImportRootReferenceImpl(context, VOID, nodeId);
  }
  function OntologyImportRootReferenceConcept() {
    OntologyImportRootReferenceConcept_instance = this;
    var tmp = OntologyImportRootReferenceImpl$_init_$ref_mgkrbk();
    OtConceptDescriptor.call(this, 'OntologyImportRootReference', VOID, tmp, OntologyImportRootReferenceConcept$_init_$lambda_n0554);
    var tmp_0 = this;
    var tmp2 = ref$factory_1();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_198().gbz_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(OntologyImportRootReference_1), tmp2, getKClass(OntologyImportRoot_1));
    tmp_0.rbz_1 = this.f6q(tmp$ret$0, tag, 'root');
    this.sbz_1 = new DomainNodeReferencePropertyDescriptor(this.rbz_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var OntologyImportRootReferenceConcept_instance;
  function OntologyImportRootReferenceConcept_getInstance() {
    if (OntologyImportRootReferenceConcept_instance == null)
      new OntologyImportRootReferenceConcept();
    return OntologyImportRootReferenceConcept_instance;
  }
  function ref$factory_1() {
    return getPropertyCallableRef('ref', 1, KProperty1, function (receiver) {
      return receiver.ub6();
    }, null);
  }
  function OntologyIsRelationImpl$_init_$ref_3lw5f4() {
    var l = function (p0, p1) {
      return new OntologyIsRelationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyIsRelationConcept$_init_$lambda_wzklco(context, nodeId) {
    return new TypedOntologyIsRelationImpl(context, VOID, nodeId);
  }
  function OntologyIsRelationConcept() {
    OntologyIsRelationConcept_instance = this;
    var tmp = OntologyIsRelationImpl$_init_$ref_3lw5f4();
    OtConceptDescriptor.call(this, 'OntologyIsRelation', VOID, tmp, OntologyIsRelationConcept$_init_$lambda_wzklco, Companion_instance_95.z6p([AbstractOntologyRelationConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = elementReferenceProvider$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'elementReferenceProvider';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyIsRelation_1), tmp2);
    tmp_0.dc0_1 = this.d6q(tmp$ret$0, name);
    this.ec0_1 = new DomainNodeChildPropertyDescriptor(this.dc0_1.h6n_1);
  }
  var OntologyIsRelationConcept_instance;
  function OntologyIsRelationConcept_getInstance() {
    if (OntologyIsRelationConcept_instance == null)
      new OntologyIsRelationConcept();
    return OntologyIsRelationConcept_instance;
  }
  function elementReferenceProvider$factory() {
    return getPropertyCallableRef('elementReferenceProvider', 1, KProperty1, function (receiver) {
      return receiver.fc0();
    }, null);
  }
  function OntologyLibraryImpl$_init_$ref_r37q0p() {
    var l = function (p0, p1) {
      return new OntologyLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyLibraryConcept$_init_$lambda_dlbtox(context, nodeId) {
    return new TypedOntologyLibraryImpl(context, VOID, nodeId);
  }
  function OntologyLibraryConcept() {
    OntologyLibraryConcept_instance = this;
    var tmp = OntologyLibraryImpl$_init_$ref_r37q0p();
    OtConceptDescriptor.call(this, 'OntologyLibrary', VOID, tmp, OntologyLibraryConcept$_init_$lambda_dlbtox, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = elements$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'elements';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(OntologyLibrary_1), tmp2);
    tmp_0.qc0_1 = this.e6q(tmp$ret$0, name);
    this.rc0_1 = new DomainNodeChildrenPropertyDescriptor(this.qc0_1.h6n_1);
  }
  var OntologyLibraryConcept_instance;
  function OntologyLibraryConcept_getInstance() {
    if (OntologyLibraryConcept_instance == null)
      new OntologyLibraryConcept();
    return OntologyLibraryConcept_instance;
  }
  function elements$factory() {
    return getPropertyCallableRef('elements', 1, KProperty1, function (receiver) {
      return receiver.sc0();
    }, null);
  }
  function OntologyLibraryReferenceImpl$_init_$ref_qkmvp6() {
    var l = function (p0, p1) {
      return new OntologyLibraryReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyLibraryReferenceConcept$_init_$lambda_cxpvs2(context, nodeId) {
    return new TypedOntologyLibraryReferenceImpl(context, VOID, nodeId);
  }
  function OntologyLibraryReferenceConcept() {
    OntologyLibraryReferenceConcept_instance = this;
    var tmp = OntologyLibraryReferenceImpl$_init_$ref_qkmvp6();
    OtConceptDescriptor.call(this, 'OntologyLibraryReference', VOID, tmp, OntologyLibraryReferenceConcept$_init_$lambda_cxpvs2);
    var tmp_0 = this;
    var tmp2 = ref$factory_2();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_206().tc0_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(OntologyLibraryReference_1), tmp2, getKClass(OntologyLibrary_1));
    tmp_0.ec1_1 = this.f6q(tmp$ret$0, tag, 'library');
    this.fc1_1 = new DomainNodeReferencePropertyDescriptor(this.ec1_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var OntologyLibraryReferenceConcept_instance;
  function OntologyLibraryReferenceConcept_getInstance() {
    if (OntologyLibraryReferenceConcept_instance == null)
      new OntologyLibraryReferenceConcept();
    return OntologyLibraryReferenceConcept_instance;
  }
  function ref$factory_2() {
    return getPropertyCallableRef('ref', 1, KProperty1, function (receiver) {
      return receiver.ub6();
    }, null);
  }
  function OntologyLinkImpl$_init_$ref_2lukmc() {
    var l = function (p0, p1) {
      return new OntologyLinkImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyLinkConcept$_init_$lambda_xpp46s(context, nodeId) {
    return new TypedOntologyLinkImpl(context, VOID, nodeId);
  }
  function OntologyLinkConcept() {
    OntologyLinkConcept_instance = this;
    var tmp = OntologyLinkImpl$_init_$ref_2lukmc();
    OtConceptDescriptor.call(this, 'OntologyLink', VOID, tmp, OntologyLinkConcept$_init_$lambda_xpp46s, Companion_instance_95.z6p([AbstractLinkConcept_getInstance()]));
    this.qc1_1 = this.h6q(link$factory_0(), 'link');
    this.rc1_1 = this.h6q(defaultLibraryReference$factory(), 'defaultLibrary');
    this.sc1_1 = new DomainNodeChildPropertyDescriptor(this.qc1_1);
    this.tc1_1 = new DomainNodeChildPropertyDescriptor(this.rc1_1);
  }
  var OntologyLinkConcept_instance;
  function OntologyLinkConcept_getInstance() {
    if (OntologyLinkConcept_instance == null)
      new OntologyLinkConcept();
    return OntologyLinkConcept_instance;
  }
  function link$factory_0() {
    return getPropertyCallableRef('link', 1, KProperty1, function (receiver) {
      return receiver.pbh();
    }, null);
  }
  function defaultLibraryReference$factory() {
    return getPropertyCallableRef('defaultLibraryReference', 1, KProperty1, function (receiver) {
      return receiver.uc1();
    }, null);
  }
  function OntologyLinkDeclarationValueQueryImpl$_init_$ref_b82iar() {
    var l = function (p0, p1) {
      return new OntologyLinkDeclarationValueQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyLinkDeclarationValueQueryConcept$_init_$lambda_3dpx85(context, nodeId) {
    return new TypedOntologyLinkDeclarationValueQueryImpl(context, VOID, nodeId);
  }
  function OntologyLinkDeclarationValueQueryConcept() {
    OntologyLinkDeclarationValueQueryConcept_instance = this;
    var tmp = OntologyLinkDeclarationValueQueryImpl$_init_$ref_b82iar();
    OtConceptDescriptor.call(this, 'OntologyLinkDeclarationValueQuery', VOID, tmp, OntologyLinkDeclarationValueQueryConcept$_init_$lambda_3dpx85, Companion_instance_95.z6p([DeclarationValueQueryConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = linkDeclaration$factory();
    var tmp3 = Companion_getInstance_218().vc1_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'linkDeclaration';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(OntologyLinkDeclarationValueQuery_1), tmp2, getKClass(LinkDeclaration_1));
    tmp_0.gc2_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.hc2_1 = new DomainNodeReferencePropertyDescriptor(this.gc2_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var OntologyLinkDeclarationValueQueryConcept_instance;
  function OntologyLinkDeclarationValueQueryConcept_getInstance() {
    if (OntologyLinkDeclarationValueQueryConcept_instance == null)
      new OntologyLinkDeclarationValueQueryConcept();
    return OntologyLinkDeclarationValueQueryConcept_instance;
  }
  function linkDeclaration$factory() {
    return getPropertyCallableRef('linkDeclaration', 1, KProperty1, function (receiver) {
      return receiver.ic2();
    }, null);
  }
  function OntologyLinkValueImpl$_init_$ref_i717bx() {
    var l = function (p0, p1) {
      return new OntologyLinkValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OntologyLinkValueConcept$_init_$lambda_fqor1x(context, nodeId) {
    return new TypedOntologyLinkValueImpl(context, VOID, nodeId);
  }
  function OntologyLinkValueConcept() {
    OntologyLinkValueConcept_instance = this;
    var tmp = OntologyLinkValueImpl$_init_$ref_i717bx();
    OtConceptDescriptor.call(this, 'OntologyLinkValue', VOID, tmp, OntologyLinkValueConcept$_init_$lambda_fqor1x, Companion_instance_95.z6p([AbstractBindingValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = linkReference$factory();
    var tmp3 = Companion_getInstance_200().jc2_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'linkReference';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(OntologyLinkValue_1), tmp2, getKClass(AbstractLink));
    tmp_0.uc2_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.vc2_1 = new DomainNodeReferencePropertyDescriptor(this.uc2_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var OntologyLinkValueConcept_instance;
  function OntologyLinkValueConcept_getInstance() {
    if (OntologyLinkValueConcept_instance == null)
      new OntologyLinkValueConcept();
    return OntologyLinkValueConcept_instance;
  }
  function linkReference$factory() {
    return getPropertyCallableRef('linkReference', 1, KProperty1, function (receiver) {
      return receiver.wc2();
    }, null);
  }
  function OrValueQueryImpl$_init_$ref_37c1cb() {
    var l = function (p0, p1) {
      return new OrValueQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function OrValueQueryConcept$_init_$lambda_g6vdb1(context, nodeId) {
    return new TypedOrValueQueryImpl(context, VOID, nodeId);
  }
  function OrValueQueryConcept() {
    OrValueQueryConcept_instance = this;
    var tmp = OrValueQueryImpl$_init_$ref_37c1cb();
    OtConceptDescriptor.call(this, 'OrValueQuery', VOID, tmp, OrValueQueryConcept$_init_$lambda_g6vdb1, Companion_instance_95.z6p([AbstractBindingValueQueryConcept_getInstance()]));
    this.hc3_1 = this.h6q(left$factory_0(), 'left');
    this.ic3_1 = this.h6q(right$factory_0(), 'right');
    this.jc3_1 = new DomainNodeChildPropertyDescriptor(this.hc3_1);
    this.kc3_1 = new DomainNodeChildPropertyDescriptor(this.ic3_1);
  }
  var OrValueQueryConcept_instance;
  function OrValueQueryConcept_getInstance() {
    if (OrValueQueryConcept_instance == null)
      new OrValueQueryConcept();
    return OrValueQueryConcept_instance;
  }
  function left$factory_0() {
    return getPropertyCallableRef('left', 1, KProperty1, function (receiver) {
      return receiver.sbf();
    }, null);
  }
  function right$factory_0() {
    return getPropertyCallableRef('right', 1, KProperty1, function (receiver) {
      return receiver.tbf();
    }, null);
  }
  function PageImpl$_init_$ref_kbrpsa() {
    var l = function (p0, p1) {
      return new PageImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PageConcept$_init_$lambda_tkv4vm(context, nodeId) {
    return new TypedPageImpl(context, VOID, nodeId);
  }
  function PageConcept() {
    PageConcept_instance = this;
    var tmp = PageImpl$_init_$ref_kbrpsa();
    OtConceptDescriptor.call(this, 'Page', VOID, tmp, PageConcept$_init_$lambda_tkv4vm, Companion_instance_95.z6p([PageSpecificationConcept_getInstance()]));
    this.vc3_1 = this.g6q(page$factory(), 'page');
    this.wc3_1 = new DomainNodePropertyDescriptor(this.vc3_1, toNonNullPersister(NonNullPersisters_getInstance().j2q()));
  }
  var PageConcept_instance;
  function PageConcept_getInstance() {
    if (PageConcept_instance == null)
      new PageConcept();
    return PageConcept_instance;
  }
  function page$factory() {
    return getPropertyCallableRef('page', 1, KProperty1, function (receiver) {
      return receiver.xc3();
    }, null);
  }
  function PageRangeImpl$_init_$ref_z18kzt() {
    var l = function (p0, p1) {
      return new PageRangeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PageRangeConcept$_init_$lambda_8hq6rz(context, nodeId) {
    return new TypedPageRangeImpl(context, VOID, nodeId);
  }
  function PageRangeConcept() {
    PageRangeConcept_instance = this;
    var tmp = PageRangeImpl$_init_$ref_z18kzt();
    OtConceptDescriptor.call(this, 'PageRange', VOID, tmp, PageRangeConcept$_init_$lambda_8hq6rz, Companion_instance_95.z6p([PageSpecificationConcept_getInstance()]));
    this.ic4_1 = this.g6q(start$factory(), 'start');
    this.jc4_1 = this.g6q(end$factory(), 'end');
    this.kc4_1 = new DomainNodePropertyDescriptor(this.ic4_1, toNonNullPersister(NonNullPersisters_getInstance().j2q()));
    this.lc4_1 = new DomainNodePropertyDescriptor(this.jc4_1, toNonNullPersister(NonNullPersisters_getInstance().j2q()));
  }
  var PageRangeConcept_instance;
  function PageRangeConcept_getInstance() {
    if (PageRangeConcept_instance == null)
      new PageRangeConcept();
    return PageRangeConcept_instance;
  }
  function start$factory() {
    return getPropertyCallableRef('start', 1, KProperty1, function (receiver) {
      return receiver.q1();
    }, null);
  }
  function end$factory() {
    return getPropertyCallableRef('end', 1, KProperty1, function (receiver) {
      return receiver.mc4();
    }, null);
  }
  function PageSpecificationConcept() {
    PageSpecificationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var PageSpecificationConcept_instance;
  function PageSpecificationConcept_getInstance() {
    if (PageSpecificationConcept_instance == null)
      new PageSpecificationConcept();
    return PageSpecificationConcept_instance;
  }
  function PaperImpl$_init_$ref_70aa1l() {
    var l = function (p0, p1) {
      return new PaperImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PaperConcept$_init_$lambda_31s4y7(context, nodeId) {
    return new TypedPaperImpl(context, VOID, nodeId);
  }
  function PaperConcept() {
    PaperConcept_instance = this;
    var tmp = PaperImpl$_init_$ref_70aa1l();
    OtConceptDescriptor.call(this, 'Paper', VOID, tmp, PaperConcept$_init_$lambda_31s4y7, Companion_instance_95.z6p([PublishedWorkConcept_getInstance(), LibraryItemConcept_getInstance()]));
    this.xc4_1 = this.g6q(sourceShortTitle$factory(), 'journalShortTitle');
    this.yc4_1 = this.g6q(sourceFullTitle$factory(), 'journalFullTitle');
    this.zc4_1 = this.g6q(volume$factory(), 'volume');
    this.ac5_1 = this.g6q(issue$factory(), 'issue');
    this.bc5_1 = this.g6q(pubMedId$factory(), 'pubmedId');
    this.cc5_1 = this.g6q(pmcId$factory(), 'pmcId');
    this.dc5_1 = this.g6q(doi$factory(), 'doi');
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = pages$factory();
    var tmp$ret$0 = new SingleChildLink(getKClass(Paper_1), this_0);
    tmp_0.ec5_1 = this.d6q(tmp$ret$0, 'pages');
    this.fc5_1 = new DomainNodePropertyDescriptor(this.xc4_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
    this.gc5_1 = new DomainNodePropertyDescriptor(this.yc4_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
    this.hc5_1 = new DomainNodePropertyDescriptor(this.zc4_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
    this.ic5_1 = new DomainNodePropertyDescriptor(this.ac5_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
    this.jc5_1 = new DomainNodePropertyDescriptor(this.bc5_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
    this.kc5_1 = new DomainNodePropertyDescriptor(this.cc5_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
    this.lc5_1 = new DomainNodePropertyDescriptor(this.dc5_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
    this.mc5_1 = new DomainNodeChildPropertyDescriptor(this.ec5_1.h6n_1);
  }
  var PaperConcept_instance;
  function PaperConcept_getInstance() {
    if (PaperConcept_instance == null)
      new PaperConcept();
    return PaperConcept_instance;
  }
  function sourceShortTitle$factory() {
    return getPropertyCallableRef('sourceShortTitle', 1, KProperty1, function (receiver) {
      return receiver.nc5();
    }, null);
  }
  function sourceFullTitle$factory() {
    return getPropertyCallableRef('sourceFullTitle', 1, KProperty1, function (receiver) {
      return receiver.oc5();
    }, null);
  }
  function volume$factory() {
    return getPropertyCallableRef('volume', 1, KProperty1, function (receiver) {
      return receiver.pc5();
    }, null);
  }
  function issue$factory() {
    return getPropertyCallableRef('issue', 1, KProperty1, function (receiver) {
      return receiver.qc5();
    }, null);
  }
  function pubMedId$factory() {
    return getPropertyCallableRef('pubMedId', 1, KProperty1, function (receiver) {
      return receiver.rc5();
    }, null);
  }
  function pmcId$factory() {
    return getPropertyCallableRef('pmcId', 1, KProperty1, function (receiver) {
      return receiver.sc5();
    }, null);
  }
  function doi$factory() {
    return getPropertyCallableRef('doi', 1, KProperty1, function (receiver) {
      return receiver.tc5();
    }, null);
  }
  function pages$factory() {
    return getPropertyCallableRef('pages', 1, KProperty1, function (receiver) {
      return receiver.uc5();
    }, null);
  }
  function PartReferenceOperationConcept() {
    PartReferenceOperationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var PartReferenceOperationConcept_instance;
  function PartReferenceOperationConcept_getInstance() {
    if (PartReferenceOperationConcept_instance == null)
      new PartReferenceOperationConcept();
    return PartReferenceOperationConcept_instance;
  }
  function PartValueImpl$_init_$ref_y3ek61() {
    var l = function (p0, p1) {
      return new PartValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PartValueConcept$_init_$lambda_41hjep(context, nodeId) {
    return new TypedPartValueImpl(context, VOID, nodeId);
  }
  function PartValueConcept() {
    PartValueConcept_instance = this;
    var tmp = PartValueImpl$_init_$ref_y3ek61();
    OtConceptDescriptor.call(this, 'PartValue', VOID, tmp, PartValueConcept$_init_$lambda_41hjep, Companion_instance_95.z6p([AbstractValueConcept_getInstance()]));
    this.fc6_1 = this.h6q(operand$factory_0(), 'operand');
    this.gc6_1 = this.h6q(operation$factory(), 'operation');
    this.hc6_1 = new DomainNodeChildPropertyDescriptor(this.fc6_1);
    this.ic6_1 = new DomainNodeChildPropertyDescriptor(this.gc6_1);
  }
  var PartValueConcept_instance;
  function PartValueConcept_getInstance() {
    if (PartValueConcept_instance == null)
      new PartValueConcept();
    return PartValueConcept_instance;
  }
  function operand$factory_0() {
    return getPropertyCallableRef('operand', 1, KProperty1, function (receiver) {
      return receiver.obr();
    }, null);
  }
  function operation$factory() {
    return getPropertyCallableRef('operation', 1, KProperty1, function (receiver) {
      return receiver.u3l();
    }, null);
  }
  function PreconditionImpl$_init_$ref_xg8r4d() {
    var l = function (p0, p1) {
      return new PreconditionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PreconditionConcept$_init_$lambda_84bf8l(context, nodeId) {
    return new TypedPreconditionImpl(context, VOID, nodeId);
  }
  function PreconditionConcept() {
    PreconditionConcept_instance = this;
    var tmp = PreconditionImpl$_init_$ref_xg8r4d();
    OtConceptDescriptor.call(this, 'Precondition', VOID, tmp, PreconditionConcept$_init_$lambda_84bf8l);
  }
  var PreconditionConcept_instance;
  function PreconditionConcept_getInstance() {
    if (PreconditionConcept_instance == null)
      new PreconditionConcept();
    return PreconditionConcept_instance;
  }
  function ProcessDeclarationImpl$_init_$ref_zcz0sm() {
    var l = function (p0, p1) {
      return new ProcessDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessDeclarationConcept$_init_$lambda_8sxbse(context, nodeId) {
    return new TypedProcessDeclarationImpl(context, VOID, nodeId);
  }
  function ProcessDeclarationConcept() {
    ProcessDeclarationConcept_instance = this;
    var tmp = ProcessDeclarationImpl$_init_$ref_zcz0sm();
    OtConceptDescriptor.call(this, 'ProcessDeclaration', VOID, tmp, ProcessDeclarationConcept$_init_$lambda_8sxbse, Companion_instance_95.z6p([AbstractBindingDeclarationConcept_getInstance(), HasVariablesConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = kind$factory_1();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_208().jc6_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ProcessDeclaration_1), tmp2, getKClass(ProcessKind_1));
    tmp_0.wc6_1 = this.f6q(tmp$ret$0, tag, 'kind');
    var tmp_1 = this;
    var tmp2_0 = extends$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag_0 = Companion_getInstance_208().kc6_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$2 = new ReferenceLink(getKClass(ProcessDeclaration_1), tmp2_0, getKClass(ProcessDeclaration_1));
    tmp_1.xc6_1 = this.f6q(tmp$ret$2, tag_0, 'extends');
    var tmp_2 = this;
    var tmp2_1 = inherited$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'inherited';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$4 = new MultipleChildLink(getKClass(ProcessDeclaration_1), tmp2_1);
    tmp_2.yc6_1 = this.e6q(tmp$ret$4, name);
    var tmp_3 = this;
    var tmp2_2 = prerequisites$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name_0 = 'prerequisites';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$6 = new MultipleChildLink(getKClass(ProcessDeclaration_1), tmp2_2);
    tmp_3.zc6_1 = this.e6q(tmp$ret$6, name_0);
    var tmp_4 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = effects$factory();
    var tmp$ret$8 = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_0);
    tmp_4.ac7_1 = this.e6q(tmp$ret$8, 'effects');
    this.bc7_1 = new DomainNodeReferencePropertyDescriptor(this.wc6_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.cc7_1 = new DomainNodeReferencePropertyDescriptor(this.xc6_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.dc7_1 = new DomainNodeChildrenPropertyDescriptor(this.yc6_1.h6n_1);
    this.ec7_1 = new DomainNodeChildrenPropertyDescriptor(this.zc6_1.h6n_1);
    this.fc7_1 = new DomainNodeChildrenPropertyDescriptor(this.ac7_1.h6n_1);
  }
  var ProcessDeclarationConcept_instance;
  function ProcessDeclarationConcept_getInstance() {
    if (ProcessDeclarationConcept_instance == null)
      new ProcessDeclarationConcept();
    return ProcessDeclarationConcept_instance;
  }
  function kind$factory_1() {
    return getPropertyCallableRef('kind', 1, KProperty1, function (receiver) {
      return receiver.r5e();
    }, null);
  }
  function extends$factory() {
    return getPropertyCallableRef('extends', 1, KProperty1, function (receiver) {
      return receiver.gc7();
    }, null);
  }
  function inherited$factory() {
    return getPropertyCallableRef('inherited', 1, KProperty1, function (receiver) {
      return receiver.hc7();
    }, null);
  }
  function prerequisites$factory() {
    return getPropertyCallableRef('prerequisites', 1, KProperty1, function (receiver) {
      return receiver.ic7();
    }, null);
  }
  function effects$factory() {
    return getPropertyCallableRef('effects', 1, KProperty1, function (receiver) {
      return receiver.jc7();
    }, null);
  }
  function ProcessEffectImpl$_init_$ref_ybssb() {
    var l = function (p0, p1) {
      return new ProcessEffectImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessEffectConcept$_init_$lambda_4yzx25(context, nodeId) {
    return new TypedProcessEffectImpl(context, VOID, nodeId);
  }
  function ProcessEffectConcept() {
    ProcessEffectConcept_instance = this;
    var tmp = ProcessEffectImpl$_init_$ref_ybssb();
    OtConceptDescriptor.call(this, 'ProcessEffect', VOID, tmp, ProcessEffectConcept$_init_$lambda_4yzx25, Companion_instance_95.z6p([HasQueryLabelsConcept_getInstance(), HasFactExpressionConcept_getInstance()]));
  }
  var ProcessEffectConcept_instance;
  function ProcessEffectConcept_getInstance() {
    if (ProcessEffectConcept_instance == null)
      new ProcessEffectConcept();
    return ProcessEffectConcept_instance;
  }
  function ProcessKindImpl$_init_$ref_p3yogy() {
    var l = function (p0, p1) {
      return new ProcessKindImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessKindConcept$_init_$lambda_7l5r96(context, nodeId) {
    return new TypedProcessKindImpl(context, VOID, nodeId);
  }
  function ProcessKindConcept() {
    ProcessKindConcept_instance = this;
    var tmp = ProcessKindImpl$_init_$ref_p3yogy();
    OtConceptDescriptor.call(this, 'ProcessKind', VOID, tmp, ProcessKindConcept$_init_$lambda_7l5r96, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
  }
  var ProcessKindConcept_instance;
  function ProcessKindConcept_getInstance() {
    if (ProcessKindConcept_instance == null)
      new ProcessKindConcept();
    return ProcessKindConcept_instance;
  }
  function ProcessKindContainerImpl$_init_$ref_e5alaf() {
    var l = function (p0, p1) {
      return new ProcessKindContainerImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessKindContainerConcept$_init_$lambda_ls1vhd(context, nodeId) {
    return new TypedProcessKindContainerImpl(context, VOID, nodeId);
  }
  function ProcessKindContainerConcept() {
    ProcessKindContainerConcept_instance = this;
    var tmp = ProcessKindContainerImpl$_init_$ref_e5alaf();
    OtConceptDescriptor.call(this, 'ProcessKindContainer', VOID, tmp, ProcessKindContainerConcept$_init_$lambda_ls1vhd, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    this.uc7_1 = this.i6q(kinds$factory(), 'kinds');
    this.vc7_1 = new DomainNodeChildrenPropertyDescriptor(this.uc7_1);
  }
  var ProcessKindContainerConcept_instance;
  function ProcessKindContainerConcept_getInstance() {
    if (ProcessKindContainerConcept_instance == null)
      new ProcessKindContainerConcept();
    return ProcessKindContainerConcept_instance;
  }
  function kinds$factory() {
    return getPropertyCallableRef('kinds', 1, KProperty1, function (receiver) {
      return receiver.wc7();
    }, null);
  }
  function ProcessLibraryImpl$_init_$ref_l0hpi1() {
    var l = function (p0, p1) {
      return new ProcessLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessLibraryConcept$_init_$lambda_hjws1d(context, nodeId) {
    return new TypedProcessLibraryImpl(context, VOID, nodeId);
  }
  function ProcessLibraryConcept() {
    ProcessLibraryConcept_instance = this;
    var tmp = ProcessLibraryImpl$_init_$ref_l0hpi1();
    OtConceptDescriptor.call(this, 'ProcessLibrary', VOID, tmp, ProcessLibraryConcept$_init_$lambda_hjws1d, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = processes$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'processes';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(ProcessLibrary_1), tmp2);
    tmp_0.hc8_1 = this.e6q(tmp$ret$0, name);
    this.ic8_1 = new DomainNodeChildrenPropertyDescriptor(this.hc8_1.h6n_1);
  }
  var ProcessLibraryConcept_instance;
  function ProcessLibraryConcept_getInstance() {
    if (ProcessLibraryConcept_instance == null)
      new ProcessLibraryConcept();
    return ProcessLibraryConcept_instance;
  }
  function processes$factory() {
    return getPropertyCallableRef('processes', 1, KProperty1, function (receiver) {
      return receiver.jc8();
    }, null);
  }
  function ProcessPrerequisiteImpl$_init_$ref_8xi1hc() {
    var l = function (p0, p1) {
      return new ProcessPrerequisiteImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessPrerequisiteConcept$_init_$lambda_ubdkd4(context, nodeId) {
    return new TypedProcessPrerequisiteImpl(context, VOID, nodeId);
  }
  function ProcessPrerequisiteConcept() {
    ProcessPrerequisiteConcept_instance = this;
    var tmp = ProcessPrerequisiteImpl$_init_$ref_8xi1hc();
    OtConceptDescriptor.call(this, 'ProcessPrerequisite', VOID, tmp, ProcessPrerequisiteConcept$_init_$lambda_ubdkd4, Companion_instance_95.z6p([HasQueryLabelsConcept_getInstance(), HasFactExpressionConcept_getInstance()]));
  }
  var ProcessPrerequisiteConcept_instance;
  function ProcessPrerequisiteConcept_getInstance() {
    if (ProcessPrerequisiteConcept_instance == null)
      new ProcessPrerequisiteConcept();
    return ProcessPrerequisiteConcept_instance;
  }
  function ProcessPropertyImpl$_init_$ref_heo8zj() {
    var l = function (p0, p1) {
      return new ProcessPropertyImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessPropertyConcept$_init_$lambda_24cp2f(context, nodeId) {
    return new TypedProcessPropertyImpl(context, VOID, nodeId);
  }
  function ProcessPropertyConcept() {
    ProcessPropertyConcept_instance = this;
    var tmp = ProcessPropertyImpl$_init_$ref_heo8zj();
    OtConceptDescriptor.call(this, 'ProcessProperty', VOID, tmp, ProcessPropertyConcept$_init_$lambda_24cp2f, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
    this.uc8_1 = this.h6q(type$factory_3(), 'type');
    var tmp_0 = this;
    var tmp2 = aliasedProperties$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    var name = 'aliasedProperties';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new MultipleChildLink(getKClass(ProcessProperty_1), tmp2);
    tmp_0.vc8_1 = this.e6q(tmp$ret$0, name);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = default$factory();
    var tmp$ret$2 = new SingleChildLink(getKClass(ProcessProperty_1), this_0);
    tmp_1.wc8_1 = this.d6q(tmp$ret$2, 'default');
    this.xc8_1 = new DomainNodeChildPropertyDescriptor(this.uc8_1);
    this.yc8_1 = new DomainNodeChildrenPropertyDescriptor(this.vc8_1.h6n_1);
    this.zc8_1 = new DomainNodeChildPropertyDescriptor(this.wc8_1.h6n_1);
  }
  var ProcessPropertyConcept_instance;
  function ProcessPropertyConcept_getInstance() {
    if (ProcessPropertyConcept_instance == null)
      new ProcessPropertyConcept();
    return ProcessPropertyConcept_instance;
  }
  function type$factory_3() {
    return getPropertyCallableRef('type', 1, KProperty1, function (receiver) {
      return receiver.zb3();
    }, null);
  }
  function aliasedProperties$factory() {
    return getPropertyCallableRef('aliasedProperties', 1, KProperty1, function (receiver) {
      return receiver.ac9();
    }, null);
  }
  function default$factory() {
    return getPropertyCallableRef('default', 1, KProperty1, function (receiver) {
      return receiver.g2o();
    }, null);
  }
  function ProcessPropertyCustomCellImpl$_init_$ref_3fib6() {
    var l = function (p0, p1) {
      return new ProcessPropertyCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessPropertyCustomCellConcept$_init_$lambda_22h7ru(context, nodeId) {
    return new TypedProcessPropertyCustomCellImpl(context, VOID, nodeId);
  }
  function ProcessPropertyCustomCellConcept() {
    ProcessPropertyCustomCellConcept_instance = this;
    var tmp = ProcessPropertyCustomCellImpl$_init_$ref_3fib6();
    OtConceptDescriptor.call(this, 'ProcessPropertyCustomCell', VOID, tmp, ProcessPropertyCustomCellConcept$_init_$lambda_22h7ru, Companion_instance_95.z6p([CustomCellConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = property$factory_1();
    var tmp3 = Companion_getInstance_194().bc9_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'processProperty';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ProcessPropertyCustomCell_1), tmp2, getKClass(ProcessProperty_1));
    tmp_0.mc9_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.nc9_1 = new DomainNodeReferencePropertyDescriptor(this.mc9_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ProcessPropertyCustomCellConcept_instance;
  function ProcessPropertyCustomCellConcept_getInstance() {
    if (ProcessPropertyCustomCellConcept_instance == null)
      new ProcessPropertyCustomCellConcept();
    return ProcessPropertyCustomCellConcept_instance;
  }
  function property$factory_1() {
    return getPropertyCallableRef('property', 1, KProperty1, function (receiver) {
      return receiver.i6u();
    }, null);
  }
  function ProcessPropertyDefaultImpl$_init_$ref_c88qt4() {
    var l = function (p0, p1) {
      return new ProcessPropertyDefaultImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessPropertyDefaultConcept$_init_$lambda_krbjog(context, nodeId) {
    return new TypedProcessPropertyDefaultImpl(context, VOID, nodeId);
  }
  function ProcessPropertyDefaultConcept() {
    ProcessPropertyDefaultConcept_instance = this;
    var tmp = ProcessPropertyDefaultImpl$_init_$ref_c88qt4();
    OtConceptDescriptor.call(this, 'ProcessPropertyDefault', VOID, tmp, ProcessPropertyDefaultConcept$_init_$lambda_krbjog);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = value$factory_4();
    var tmp$ret$0 = new SingleChildLink(getKClass(ProcessPropertyDefault_1), this_0);
    tmp_0.yc9_1 = this.d6q(tmp$ret$0, 'value');
    this.zc9_1 = new DomainNodeChildPropertyDescriptor(this.yc9_1.h6n_1);
  }
  var ProcessPropertyDefaultConcept_instance;
  function ProcessPropertyDefaultConcept_getInstance() {
    if (ProcessPropertyDefaultConcept_instance == null)
      new ProcessPropertyDefaultConcept();
    return ProcessPropertyDefaultConcept_instance;
  }
  function value$factory_4() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function ProcessPropertyReferenceImpl$_init_$ref_l9uygu() {
    var l = function (p0, p1) {
      return new ProcessPropertyReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessPropertyReferenceConcept$_init_$lambda_tzmre2(context, nodeId) {
    return new TypedProcessPropertyReferenceImpl(context, VOID, nodeId);
  }
  function ProcessPropertyReferenceConcept() {
    ProcessPropertyReferenceConcept_instance = this;
    var tmp = ProcessPropertyReferenceImpl$_init_$ref_l9uygu();
    OtConceptDescriptor.call(this, 'ProcessPropertyReference', VOID, tmp, ProcessPropertyReferenceConcept$_init_$lambda_tzmre2, Companion_instance_95.z6p([VariableInitializerConcept_getInstance(), FactExpressionConcept_getInstance(), AbstractValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = property$factory_2();
    var tmp3 = Companion_getInstance_211().aca_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'propertyReference';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ProcessPropertyReference), tmp2, getKClass(ProcessProperty_1));
    tmp_0.lca_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.mca_1 = new DomainNodeReferencePropertyDescriptor(this.lca_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ProcessPropertyReferenceConcept_instance;
  function ProcessPropertyReferenceConcept_getInstance() {
    if (ProcessPropertyReferenceConcept_instance == null)
      new ProcessPropertyReferenceConcept();
    return ProcessPropertyReferenceConcept_instance;
  }
  function property$factory_2() {
    return getPropertyCallableRef('property', 1, KProperty1, function (receiver) {
      return receiver.i6u();
    }, null);
  }
  function ProcessPropertyTypeConcept() {
    ProcessPropertyTypeConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([ProcessPropertyValueRangeConcept_getInstance()]));
  }
  var ProcessPropertyTypeConcept_instance;
  function ProcessPropertyTypeConcept_getInstance() {
    if (ProcessPropertyTypeConcept_instance == null)
      new ProcessPropertyTypeConcept();
    return ProcessPropertyTypeConcept_instance;
  }
  function ProcessPropertyValueImpl$_init_$ref_xdb0tk() {
    var l = function (p0, p1) {
      return new ProcessPropertyValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessPropertyValueConcept$_init_$lambda_f39m6o(context, nodeId) {
    return new TypedProcessPropertyValueImpl(context, VOID, nodeId);
  }
  function ProcessPropertyValueConcept() {
    ProcessPropertyValueConcept_instance = this;
    var tmp = ProcessPropertyValueImpl$_init_$ref_xdb0tk();
    OtConceptDescriptor.call(this, 'ProcessPropertyValue', VOID, tmp, ProcessPropertyValueConcept$_init_$lambda_f39m6o, Companion_instance_95.z6p([BindingValuePlaceholderConcept_getInstance(), HasQueryLabelsConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = property$factory_3();
    var tmp3 = Companion_getInstance_192().nca_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ProcessPropertyValue_1), tmp2, getKClass(ProcessProperty_1));
    tmp_0.yca_1 = this.f6q(tmp$ret$0, tmp3, name);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = value$factory_5();
    var tmp$ret$2 = new SingleChildLink(getKClass(ProcessPropertyValue_1), this_0);
    tmp_1.zca_1 = this.d6q(tmp$ret$2, 'value');
    this.acb_1 = new DomainNodeReferencePropertyDescriptor(this.yca_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.bcb_1 = new DomainNodeChildPropertyDescriptor(this.zca_1.h6n_1);
  }
  var ProcessPropertyValueConcept_instance;
  function ProcessPropertyValueConcept_getInstance() {
    if (ProcessPropertyValueConcept_instance == null)
      new ProcessPropertyValueConcept();
    return ProcessPropertyValueConcept_instance;
  }
  function property$factory_3() {
    return getPropertyCallableRef('property', 1, KProperty1, function (receiver) {
      return receiver.i6u();
    }, null);
  }
  function value$factory_5() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function ProcessPropertyValueRangeConcept() {
    ProcessPropertyValueRangeConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var ProcessPropertyValueRangeConcept_instance;
  function ProcessPropertyValueRangeConcept_getInstance() {
    if (ProcessPropertyValueRangeConcept_instance == null)
      new ProcessPropertyValueRangeConcept();
    return ProcessPropertyValueRangeConcept_instance;
  }
  function ProcessProviderConcept() {
    ProcessProviderConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var ProcessProviderConcept_instance;
  function ProcessProviderConcept_getInstance() {
    if (ProcessProviderConcept_instance == null)
      new ProcessProviderConcept();
    return ProcessProviderConcept_instance;
  }
  function ProcessReferenceImpl$_init_$ref_k2mg3b() {
    var l = function (p0, p1) {
      return new ProcessReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessReferenceConcept$_init_$lambda_n8m65d(context, nodeId) {
    return new TypedProcessReferenceImpl(context, VOID, nodeId);
  }
  function ProcessReferenceConcept() {
    ProcessReferenceConcept_instance = this;
    var tmp = ProcessReferenceImpl$_init_$ref_k2mg3b();
    OtConceptDescriptor.call(this, 'ProcessReference', VOID, tmp, ProcessReferenceConcept$_init_$lambda_n8m65d);
    var tmp_0 = this;
    var tmp2 = process$factory_1();
    var tmp3 = Companion_getInstance_209().ccb_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'processRef';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(ProcessReference_1), tmp2, getKClass(ProcessDeclaration_1));
    tmp_0.ncb_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.ocb_1 = new DomainNodeReferencePropertyDescriptor(this.ncb_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var ProcessReferenceConcept_instance;
  function ProcessReferenceConcept_getInstance() {
    if (ProcessReferenceConcept_instance == null)
      new ProcessReferenceConcept();
    return ProcessReferenceConcept_instance;
  }
  function process$factory_1() {
    return getPropertyCallableRef('process', 1, KProperty1, function (receiver) {
      return receiver.jbg();
    }, null);
  }
  function ProcessRelationDeclarationImpl$_init_$ref_tn4fje() {
    var l = function (p0, p1) {
      return new ProcessRelationDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessRelationDeclarationConcept$_init_$lambda_zda0by(context, nodeId) {
    return new TypedProcessRelationDeclarationImpl(context, VOID, nodeId);
  }
  function ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_13();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1).pcb = function (value) {
    return value.toString();
  };
  protoOf(ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1).x2p = function (value) {
    return this.pcb(value instanceof RelationDirection ? value : THROW_CCE());
  };
  protoOf(ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_14();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1).qcb = function (value) {
    return value.toString();
  };
  protoOf(ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1).x2p = function (value) {
    return this.qcb(value instanceof RelationEffect ? value : THROW_CCE());
  };
  protoOf(ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_13();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1).pcb = function (value) {
    return value.toString();
  };
  protoOf(ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1).x2p = function (value) {
    return this.pcb(value instanceof RelationDirection ? value : THROW_CCE());
  };
  protoOf(ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_14();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1).qcb = function (value) {
    return value.toString();
  };
  protoOf(ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1).x2p = function (value) {
    return this.qcb(value instanceof RelationEffect ? value : THROW_CCE());
  };
  protoOf(ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function ProcessRelationDeclarationConcept() {
    ProcessRelationDeclarationConcept_instance = this;
    var tmp = ProcessRelationDeclarationImpl$_init_$ref_tn4fje();
    OtConceptDescriptor.call(this, 'RelationDeclaration', VOID, tmp, ProcessRelationDeclarationConcept$_init_$lambda_zda0by, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance()]));
    this.bcc_1 = this.g6q(symbol$factory(), 'symbol');
    this.ccc_1 = this.g6q(direction$factory(), 'direction');
    this.dcc_1 = this.g6q(effect$factory(), 'effect');
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$0 = new ProcessRelationDeclarationConcept$DIRECTION_PERSISTER$$inlined$enumPersister$1();
    tmp_0.ecc_1 = toNullablePersister(tmp$ret$0);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$1 = new ProcessRelationDeclarationConcept$EFFECT_PERSISTER$$inlined$enumPersister$1();
    tmp_1.fcc_1 = toNullablePersister(tmp$ret$1);
    this.gcc_1 = new DomainNodePropertyDescriptor(this.bcc_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
    var tmp_2 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$2 = new ProcessRelationDeclarationConcept$directionPropertyDescriptor$$inlined$enumPersister$1();
    tmp_2.hcc_1 = new DomainNodePropertyDescriptor(this.ccc_1, toNullablePersister(tmp$ret$2));
    var tmp_3 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$3 = new ProcessRelationDeclarationConcept$effectPropertyDescriptor$$inlined$enumPersister$1();
    tmp_3.icc_1 = new DomainNodePropertyDescriptor(this.dcc_1, toNullablePersister(tmp$ret$3));
  }
  var ProcessRelationDeclarationConcept_instance;
  function ProcessRelationDeclarationConcept_getInstance() {
    if (ProcessRelationDeclarationConcept_instance == null)
      new ProcessRelationDeclarationConcept();
    return ProcessRelationDeclarationConcept_instance;
  }
  function symbol$factory() {
    return getPropertyCallableRef('symbol', 1, KProperty1, function (receiver) {
      return receiver.jcc();
    }, null);
  }
  function direction$factory() {
    return getPropertyCallableRef('direction', 1, KProperty1, function (receiver) {
      return receiver.kcc();
    }, null);
  }
  function effect$factory() {
    return getPropertyCallableRef('effect', 1, KProperty1, function (receiver) {
      return receiver.lcc();
    }, null);
  }
  function ProcessTypeImpl$_init_$ref_r1xhbw() {
    var l = function (p0, p1) {
      return new ProcessTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ProcessTypeConcept$_init_$lambda_rqcn1o(context, nodeId) {
    return new TypedProcessTypeImpl(context, VOID, nodeId);
  }
  function ProcessTypeConcept() {
    ProcessTypeConcept_instance = this;
    var tmp = ProcessTypeImpl$_init_$ref_r1xhbw();
    OtConceptDescriptor.call(this, 'ProcessType', VOID, tmp, ProcessTypeConcept$_init_$lambda_rqcn1o, Companion_instance_95.z6p([TypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = specification$factory_0();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'specification';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(ProcessType_1), tmp2);
    tmp_0.wcc_1 = this.d6q(tmp$ret$0, name);
    this.xcc_1 = new DomainNodeChildPropertyDescriptor(this.wcc_1.h6n_1);
  }
  var ProcessTypeConcept_instance;
  function ProcessTypeConcept_getInstance() {
    if (ProcessTypeConcept_instance == null)
      new ProcessTypeConcept();
    return ProcessTypeConcept_instance;
  }
  function specification$factory_0() {
    return getPropertyCallableRef('specification', 1, KProperty1, function (receiver) {
      return receiver.pb5();
    }, null);
  }
  function PropertiesCustomCellImpl$_init_$ref_firujj() {
    var l = function (p0, p1) {
      return new PropertiesCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertiesCustomCellConcept$_init_$lambda_xk0qdl(context, nodeId) {
    return new TypedPropertiesCustomCellImpl(context, VOID, nodeId);
  }
  function PropertiesCustomCellConcept() {
    PropertiesCustomCellConcept_instance = this;
    var tmp = PropertiesCustomCellImpl$_init_$ref_firujj();
    OtConceptDescriptor.call(this, 'PropertiesCustomCell', VOID, tmp, PropertiesCustomCellConcept$_init_$lambda_xk0qdl, Companion_instance_95.z6p([CustomCellConcept_getInstance()]));
  }
  var PropertiesCustomCellConcept_instance;
  function PropertiesCustomCellConcept_getInstance() {
    if (PropertiesCustomCellConcept_instance == null)
      new PropertiesCustomCellConcept();
    return PropertiesCustomCellConcept_instance;
  }
  function PropertyConstraintImpl$_init_$ref_mdvtf1() {
    var l = function (p0, p1) {
      return new PropertyConstraintImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyConstraintConcept$_init_$lambda_pk21yj(context, nodeId) {
    return new TypedPropertyConstraintImpl(context, VOID, nodeId);
  }
  function PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1() {
  }
  protoOf(PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_12();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1).ycc = function (value) {
    return value.toString();
  };
  protoOf(PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1).x2p = function (value) {
    return this.ycc(value instanceof ConstraintOperation ? value : THROW_CCE());
  };
  protoOf(PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1() {
  }
  protoOf(PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1).w2p = function (value) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'jetbrains.ocelot.base.enums.Enums.valueOf' call
      // Inline function 'kotlin.enumValues' call
      var indexedObject = values_12();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var e = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (value === e.toString()) {
          tmp$ret$1 = e;
          break $l$block;
        }
      }
      throw IllegalArgumentException_init_$Create$_0(value);
    }
    return tmp$ret$1;
  };
  protoOf(PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1).ycc = function (value) {
    return value.toString();
  };
  protoOf(PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1).x2p = function (value) {
    return this.ycc(value instanceof ConstraintOperation ? value : THROW_CCE());
  };
  protoOf(PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1).toString = function () {
    return 'enumPersister';
  };
  function PropertyConstraintConcept() {
    PropertyConstraintConcept_instance = this;
    var tmp = PropertyConstraintImpl$_init_$ref_mdvtf1();
    OtConceptDescriptor.call(this, 'PropertyConstraint', VOID, tmp, PropertyConstraintConcept$_init_$lambda_pk21yj, Companion_instance_95.z6p([HasPropertyConstraintsConcept_getInstance()]));
    this.jcd_1 = this.g6q(operation$factory_0(), 'operation');
    var tmp_0 = this;
    var tmp2 = property$factory_4();
    var tmp3 = Companion_getInstance_204().qcd_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(PropertyConstraint_1), tmp2, getKClass(ObjectPropertyDeclaration_1));
    tmp_0.kcd_1 = this.f6q(tmp$ret$0, tmp3, name);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = value$factory_6();
    var tmp$ret$2 = new SingleChildLink(getKClass(PropertyConstraint_1), this_0);
    tmp_1.lcd_1 = this.d6q(tmp$ret$2, 'value');
    var tmp_2 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$4 = new PropertyConstraintConcept$OPERATION_PERSISTER$$inlined$enumPersister$1();
    tmp_2.mcd_1 = toNullablePersister(tmp$ret$4);
    var tmp_3 = this;
    // Inline function 'jetbrains.ocelot.base.persister.NonNullPersisters.enumPersister' call
    NonNullPersisters_getInstance();
    var tmp$ret$5 = new PropertyConstraintConcept$operationPropertyDescriptor$$inlined$enumPersister$1();
    tmp_3.ncd_1 = new DomainNodePropertyDescriptor(this.jcd_1, toNullablePersister(tmp$ret$5));
    this.ocd_1 = new DomainNodeReferencePropertyDescriptor(this.kcd_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.pcd_1 = new DomainNodeChildPropertyDescriptor(this.lcd_1.h6n_1);
  }
  var PropertyConstraintConcept_instance;
  function PropertyConstraintConcept_getInstance() {
    if (PropertyConstraintConcept_instance == null)
      new PropertyConstraintConcept();
    return PropertyConstraintConcept_instance;
  }
  function operation$factory_0() {
    return getPropertyCallableRef('operation', 1, KProperty1, function (receiver) {
      return receiver.u3l();
    }, null);
  }
  function property$factory_4() {
    return getPropertyCallableRef('property', 1, KProperty1, function (receiver) {
      return receiver.i6u();
    }, null);
  }
  function value$factory_6() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function PropertyCustomCellImpl$_init_$ref_405iir() {
    var l = function (p0, p1) {
      return new PropertyCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyCustomCellConcept$_init_$lambda_hcr0bv(context, nodeId) {
    return new TypedPropertyCustomCellImpl(context, VOID, nodeId);
  }
  function PropertyCustomCellConcept() {
    PropertyCustomCellConcept_instance = this;
    var tmp = PropertyCustomCellImpl$_init_$ref_405iir();
    OtConceptDescriptor.call(this, 'PropertyCustomCell', VOID, tmp, PropertyCustomCellConcept$_init_$lambda_hcr0bv, Companion_instance_95.z6p([CustomCellConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = property$factory_5();
    var tmp3 = Companion_getInstance_195().rcd_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(PropertyCustomCell_1), tmp2, getKClass(AbstractProperty));
    tmp_0.cce_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.dce_1 = new DomainNodeReferencePropertyDescriptor(this.cce_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var PropertyCustomCellConcept_instance;
  function PropertyCustomCellConcept_getInstance() {
    if (PropertyCustomCellConcept_instance == null)
      new PropertyCustomCellConcept();
    return PropertyCustomCellConcept_instance;
  }
  function property$factory_5() {
    return getPropertyCallableRef('property', 1, KProperty1, function (receiver) {
      return receiver.i6u();
    }, null);
  }
  function PropertyDeclarationImpl$_init_$ref_dhhw0w() {
    var l = function (p0, p1) {
      return new PropertyDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyDeclarationConcept$_init_$lambda_3n3np4(context, nodeId) {
    return new TypedPropertyDeclarationImpl(context, VOID, nodeId);
  }
  function PropertyDeclarationConcept() {
    PropertyDeclarationConcept_instance = this;
    var tmp = PropertyDeclarationImpl$_init_$ref_dhhw0w();
    OtConceptDescriptor.call(this, 'PropertyDeclaration', VOID, tmp, PropertyDeclarationConcept$_init_$lambda_3n3np4, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance(), PropertyLibraryElementConcept_getInstance()]));
    this.oce_1 = this.h6q(type$factory_4(), 'type');
    this.pce_1 = new DomainNodeChildPropertyDescriptor(this.oce_1);
  }
  var PropertyDeclarationConcept_instance;
  function PropertyDeclarationConcept_getInstance() {
    if (PropertyDeclarationConcept_instance == null)
      new PropertyDeclarationConcept();
    return PropertyDeclarationConcept_instance;
  }
  function type$factory_4() {
    return getPropertyCallableRef('type', 1, KProperty1, function (receiver) {
      return receiver.zb3();
    }, null);
  }
  function PropertyDeclarationValueQueryImpl$_init_$ref_1zl0i1() {
    var l = function (p0, p1) {
      return new PropertyDeclarationValueQueryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyDeclarationValueQueryConcept$_init_$lambda_9v53z5(context, nodeId) {
    return new TypedPropertyDeclarationValueQueryImpl(context, VOID, nodeId);
  }
  function PropertyDeclarationValueQueryConcept() {
    PropertyDeclarationValueQueryConcept_instance = this;
    var tmp = PropertyDeclarationValueQueryImpl$_init_$ref_1zl0i1();
    OtConceptDescriptor.call(this, 'PropertyDeclarationValueQuery', VOID, tmp, PropertyDeclarationValueQueryConcept$_init_$lambda_9v53z5, Companion_instance_95.z6p([DeclarationValueQueryConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = propertyDeclaration$factory();
    var tmp3 = Companion_getInstance_216().qce_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'linkDeclaration';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(PropertyDeclarationValueQuery_1), tmp2, getKClass(PropertyDeclaration_1));
    tmp_0.bcf_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.ccf_1 = new DomainNodeReferencePropertyDescriptor(this.bcf_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var PropertyDeclarationValueQueryConcept_instance;
  function PropertyDeclarationValueQueryConcept_getInstance() {
    if (PropertyDeclarationValueQueryConcept_instance == null)
      new PropertyDeclarationValueQueryConcept();
    return PropertyDeclarationValueQueryConcept_instance;
  }
  function propertyDeclaration$factory() {
    return getPropertyCallableRef('propertyDeclaration', 1, KProperty1, function (receiver) {
      return receiver.dcf();
    }, null);
  }
  function PropertyLibraryImpl$_init_$ref_ayn5hd() {
    var l = function (p0, p1) {
      return new PropertyLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyLibraryConcept$_init_$lambda_7hwluf(context, nodeId) {
    return new TypedPropertyLibraryImpl(context, VOID, nodeId);
  }
  function PropertyLibraryConcept() {
    PropertyLibraryConcept_instance = this;
    var tmp = PropertyLibraryImpl$_init_$ref_ayn5hd();
    OtConceptDescriptor.call(this, 'PropertyLibrary', VOID, tmp, PropertyLibraryConcept$_init_$lambda_7hwluf, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    this.ocf_1 = this.i6q(elements$factory_0(), 'properties');
    this.pcf_1 = new DomainNodeChildrenPropertyDescriptor(this.ocf_1);
  }
  var PropertyLibraryConcept_instance;
  function PropertyLibraryConcept_getInstance() {
    if (PropertyLibraryConcept_instance == null)
      new PropertyLibraryConcept();
    return PropertyLibraryConcept_instance;
  }
  function elements$factory_0() {
    return getPropertyCallableRef('elements', 1, KProperty1, function (receiver) {
      return receiver.sc0();
    }, null);
  }
  function PropertyLibraryElementConcept() {
    PropertyLibraryElementConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var PropertyLibraryElementConcept_instance;
  function PropertyLibraryElementConcept_getInstance() {
    if (PropertyLibraryElementConcept_instance == null)
      new PropertyLibraryElementConcept();
    return PropertyLibraryElementConcept_instance;
  }
  function PropertyReferenceOperationImpl$_init_$ref_4trzf0() {
    var l = function (p0, p1) {
      return new PropertyReferenceOperationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyReferenceOperationConcept$_init_$lambda_i8u4wc(context, nodeId) {
    return new TypedPropertyReferenceOperationImpl(context, VOID, nodeId);
  }
  function PropertyReferenceOperationConcept() {
    PropertyReferenceOperationConcept_instance = this;
    var tmp = PropertyReferenceOperationImpl$_init_$ref_4trzf0();
    OtConceptDescriptor.call(this, 'PropertyReferenceOperation', VOID, tmp, PropertyReferenceOperationConcept$_init_$lambda_i8u4wc);
    var tmp_0 = this;
    var tmp2 = property$factory_6();
    var tmp3 = Companion_getInstance_222().qcf_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(PropertyReferenceOperation_1), tmp2, getKClass(ObjectPropertyDeclaration_1));
    tmp_0.bcg_1 = this.f6q(tmp$ret$0, tmp3, name);
    var tmp_1 = this;
    var tmp2_0 = parameter$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name_0 = 'parameter';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(PropertyReferenceOperation_1), tmp2_0);
    tmp_1.ccg_1 = this.d6q(tmp$ret$2, name_0);
    this.dcg_1 = new DomainNodeReferencePropertyDescriptor(this.bcg_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.ecg_1 = new DomainNodeChildPropertyDescriptor(this.ccg_1.h6n_1);
  }
  var PropertyReferenceOperationConcept_instance;
  function PropertyReferenceOperationConcept_getInstance() {
    if (PropertyReferenceOperationConcept_instance == null)
      new PropertyReferenceOperationConcept();
    return PropertyReferenceOperationConcept_instance;
  }
  function property$factory_6() {
    return getPropertyCallableRef('property', 1, KProperty1, function (receiver) {
      return receiver.i6u();
    }, null);
  }
  function parameter$factory() {
    return getPropertyCallableRef('parameter', 1, KProperty1, function (receiver) {
      return receiver.fcg();
    }, null);
  }
  function PropertyValueImpl$_init_$ref_c3xgaf() {
    var l = function (p0, p1) {
      return new PropertyValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyValueConcept$_init_$lambda_5skb8h(context, nodeId) {
    return new TypedPropertyValueImpl(context, VOID, nodeId);
  }
  function PropertyValueConcept() {
    PropertyValueConcept_instance = this;
    var tmp = PropertyValueImpl$_init_$ref_c3xgaf();
    OtConceptDescriptor.call(this, 'PropertyValue', VOID, tmp, PropertyValueConcept$_init_$lambda_5skb8h, Companion_instance_95.z6p([AbstractBindingValueConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = property$factory_7();
    var tmp3 = Companion_getInstance_212().gcg_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'property';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(PropertyValue_1), tmp2, getKClass(AbstractProperty));
    tmp_0.rcg_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.scg_1 = new DomainNodeReferencePropertyDescriptor(this.rcg_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var PropertyValueConcept_instance;
  function PropertyValueConcept_getInstance() {
    if (PropertyValueConcept_instance == null)
      new PropertyValueConcept();
    return PropertyValueConcept_instance;
  }
  function property$factory_7() {
    return getPropertyCallableRef('property', 1, KProperty1, function (receiver) {
      return receiver.i6u();
    }, null);
  }
  function PropertyValueRangeConcept() {
    PropertyValueRangeConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var PropertyValueRangeConcept_instance;
  function PropertyValueRangeConcept_getInstance() {
    if (PropertyValueRangeConcept_instance == null)
      new PropertyValueRangeConcept();
    return PropertyValueRangeConcept_instance;
  }
  function PubMedSourceReferenceImpl$_init_$ref_5o0s4k() {
    var l = function (p0, p1) {
      return new PubMedSourceReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PubMedSourceReferenceConcept$_init_$lambda_s2kf9g(context, nodeId) {
    return new TypedPubMedSourceReferenceImpl(context, VOID, nodeId);
  }
  function PubMedSourceReferenceConcept() {
    PubMedSourceReferenceConcept_instance = this;
    var tmp = PubMedSourceReferenceImpl$_init_$ref_5o0s4k();
    OtConceptDescriptor.call(this, 'PubMedSourceReference', VOID, tmp, PubMedSourceReferenceConcept$_init_$lambda_s2kf9g, Companion_instance_95.z6p([KnowledgeSourceReferenceConcept_getInstance()]));
    this.dch_1 = this.g6q(pubMedId$factory_0(), 'id');
    this.ech_1 = new DomainNodePropertyDescriptor(this.dch_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
  }
  var PubMedSourceReferenceConcept_instance;
  function PubMedSourceReferenceConcept_getInstance() {
    if (PubMedSourceReferenceConcept_instance == null)
      new PubMedSourceReferenceConcept();
    return PubMedSourceReferenceConcept_instance;
  }
  function pubMedId$factory_0() {
    return getPropertyCallableRef('pubMedId', 1, KProperty1, function (receiver) {
      return receiver.rc5();
    }, null);
  }
  function PublishedSourceReferenceImpl$_init_$ref_8p401v() {
    var l = function (p0, p1) {
      return new PublishedSourceReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PublishedSourceReferenceConcept$_init_$lambda_1psbs5(context, nodeId) {
    return new TypedPublishedSourceReferenceImpl(context, VOID, nodeId);
  }
  function PublishedSourceReferenceConcept() {
    PublishedSourceReferenceConcept_instance = this;
    var tmp = PublishedSourceReferenceImpl$_init_$ref_8p401v();
    OtConceptDescriptor.call(this, 'PublishedSourceReference', VOID, tmp, PublishedSourceReferenceConcept$_init_$lambda_1psbs5, Companion_instance_95.z6p([KnowledgeSourceReferenceConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = source$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_199().fch_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(PublishedSourceReference_1), tmp2, getKClass(PublishedWork));
    tmp_0.qch_1 = this.f6q(tmp$ret$0, tag, 'source');
    var tmp_1 = this;
    var tmp2_0 = pageSpecification$factory();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    var name = 'pageSpecification';
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(PublishedSourceReference_1), tmp2_0);
    tmp_1.rch_1 = this.d6q(tmp$ret$2, name);
    this.sch_1 = new DomainNodeReferencePropertyDescriptor(this.qch_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.tch_1 = new DomainNodeChildPropertyDescriptor(this.rch_1.h6n_1);
  }
  var PublishedSourceReferenceConcept_instance;
  function PublishedSourceReferenceConcept_getInstance() {
    if (PublishedSourceReferenceConcept_instance == null)
      new PublishedSourceReferenceConcept();
    return PublishedSourceReferenceConcept_instance;
  }
  function source$factory() {
    return getPropertyCallableRef('source', 1, KProperty1, function (receiver) {
      return receiver.k6h();
    }, null);
  }
  function pageSpecification$factory() {
    return getPropertyCallableRef('pageSpecification', 1, KProperty1, function (receiver) {
      return receiver.uch();
    }, null);
  }
  function PublishedSourcesLibraryImpl$_init_$ref_mux0wk() {
    var l = function (p0, p1) {
      return new PublishedSourcesLibraryImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PublishedSourcesLibraryConcept$_init_$lambda_2v7rjg(context, nodeId) {
    return new TypedPublishedSourcesLibraryImpl(context, VOID, nodeId);
  }
  function PublishedSourcesLibraryConcept() {
    PublishedSourcesLibraryConcept_instance = this;
    var tmp = PublishedSourcesLibraryImpl$_init_$ref_mux0wk();
    OtConceptDescriptor.call(this, 'PublishedSourcesLibrary', VOID, tmp, PublishedSourcesLibraryConcept$_init_$lambda_2v7rjg, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = items$factory();
    var tmp$ret$0 = new MultipleChildLink(getKClass(PublishedSourcesLibrary_1), this_0);
    tmp_0.fci_1 = this.e6q(tmp$ret$0, 'sources');
    this.gci_1 = new DomainNodeChildrenPropertyDescriptor(this.fci_1.h6n_1);
  }
  var PublishedSourcesLibraryConcept_instance;
  function PublishedSourcesLibraryConcept_getInstance() {
    if (PublishedSourcesLibraryConcept_instance == null)
      new PublishedSourcesLibraryConcept();
    return PublishedSourcesLibraryConcept_instance;
  }
  function items$factory() {
    return getPropertyCallableRef('items', 1, KProperty1, function (receiver) {
      return receiver.cq();
    }, null);
  }
  function PublishedWorkImpl$_init_$ref_ve8a6y() {
    var l = function (p0, p1) {
      return new PublishedWorkImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PublishedWorkConcept$_init_$lambda_7k069u(context, nodeId) {
    return new TypedPublishedWorkImpl(context, VOID, nodeId);
  }
  function PublishedWorkConcept() {
    PublishedWorkConcept_instance = this;
    var tmp = PublishedWorkImpl$_init_$ref_ve8a6y();
    OtConceptDescriptor.call(this, 'PublishedWork', VOID, tmp, PublishedWorkConcept$_init_$lambda_7k069u, Companion_instance_95.z6p([AuthoredWorkConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
    this.rci_1 = this.g6q(publisher$factory(), 'publisher');
    this.sci_1 = this.g6q(date$factory(), 'date');
    this.tci_1 = new DomainNodePropertyDescriptor(this.rci_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
    this.uci_1 = new DomainNodePropertyDescriptor(this.sci_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
  }
  var PublishedWorkConcept_instance;
  function PublishedWorkConcept_getInstance() {
    if (PublishedWorkConcept_instance == null)
      new PublishedWorkConcept();
    return PublishedWorkConcept_instance;
  }
  function publisher$factory() {
    return getPropertyCallableRef('publisher', 1, KProperty1, function (receiver) {
      return receiver.vci();
    }, null);
  }
  function date$factory() {
    return getPropertyCallableRef('date', 1, KProperty1, function (receiver) {
      return receiver.wci();
    }, null);
  }
  function QualifiedOntologyElementReferenceImpl$_init_$ref_vybrd7() {
    var l = function (p0, p1) {
      return new QualifiedOntologyElementReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function QualifiedOntologyElementReferenceConcept$_init_$lambda_dnlcgz(context, nodeId) {
    return new TypedQualifiedOntologyElementReferenceImpl(context, VOID, nodeId);
  }
  function QualifiedOntologyElementReferenceConcept() {
    QualifiedOntologyElementReferenceConcept_instance = this;
    var tmp = QualifiedOntologyElementReferenceImpl$_init_$ref_vybrd7();
    OtConceptDescriptor.call(this, 'QualifiedOntologyElementReferenceImpl', VOID, tmp, QualifiedOntologyElementReferenceConcept$_init_$lambda_dnlcgz, Companion_instance_95.z6p([OntologyElementReferenceProviderConcept_getInstance()]));
    this.hcj_1 = this.h6q(libraryReference$factory(), 'library');
    this.icj_1 = this.h6q(elementReference$factory(), 'elementReference');
    this.jcj_1 = new DomainNodeChildPropertyDescriptor(this.hcj_1);
    this.kcj_1 = new DomainNodeChildPropertyDescriptor(this.icj_1);
  }
  var QualifiedOntologyElementReferenceConcept_instance;
  function QualifiedOntologyElementReferenceConcept_getInstance() {
    if (QualifiedOntologyElementReferenceConcept_instance == null)
      new QualifiedOntologyElementReferenceConcept();
    return QualifiedOntologyElementReferenceConcept_instance;
  }
  function libraryReference$factory() {
    return getPropertyCallableRef('libraryReference', 1, KProperty1, function (receiver) {
      return receiver.lcj();
    }, null);
  }
  function elementReference$factory() {
    return getPropertyCallableRef('elementReference', 1, KProperty1, function (receiver) {
      return receiver.mcj();
    }, null);
  }
  function QueryCommandsImpl$_init_$ref_u2jq4r() {
    var l = function (p0, p1) {
      return new QueryCommandsImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function QueryCommandsConcept$_init_$lambda_jytcp9(context, nodeId) {
    return new TypedQueryCommandsImpl(context, VOID, nodeId);
  }
  function QueryCommandsConcept() {
    QueryCommandsConcept_instance = this;
    var tmp = QueryCommandsImpl$_init_$ref_u2jq4r();
    OtConceptDescriptor.call(this, 'QueryCommands', VOID, tmp, QueryCommandsConcept$_init_$lambda_jytcp9, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    this.xcj_1 = this.i6q(commands$factory(), 'commands');
    this.ycj_1 = new DomainNodeChildrenPropertyDescriptor(this.xcj_1);
  }
  var QueryCommandsConcept_instance;
  function QueryCommandsConcept_getInstance() {
    if (QueryCommandsConcept_instance == null)
      new QueryCommandsConcept();
    return QueryCommandsConcept_instance;
  }
  function commands$factory() {
    return getPropertyCallableRef('commands', 1, KProperty1, function (receiver) {
      return receiver.v4n();
    }, null);
  }
  function QueryLabelsFactExpressionContainerImpl$_init_$ref_y37l3j() {
    var l = function (p0, p1) {
      return new QueryLabelsFactExpressionContainerImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function QueryLabelsFactExpressionContainerConcept$_init_$lambda_wcjcd5(context, nodeId) {
    return new TypedQueryLabelsFactExpressionContainerImpl(context, VOID, nodeId);
  }
  function QueryLabelsFactExpressionContainerConcept() {
    QueryLabelsFactExpressionContainerConcept_instance = this;
    var tmp = QueryLabelsFactExpressionContainerImpl$_init_$ref_y37l3j();
    OtConceptDescriptor.call(this, 'QueryLabelsFactExpressionContainer', VOID, tmp, QueryLabelsFactExpressionContainerConcept$_init_$lambda_wcjcd5, Companion_instance_95.z6p([HasQueryLabelsConcept_getInstance(), HasFactExpressionConcept_getInstance()]));
  }
  var QueryLabelsFactExpressionContainerConcept_instance;
  function QueryLabelsFactExpressionContainerConcept_getInstance() {
    if (QueryLabelsFactExpressionContainerConcept_instance == null)
      new QueryLabelsFactExpressionContainerConcept();
    return QueryLabelsFactExpressionContainerConcept_instance;
  }
  function QueryParametersBlackListImpl$_init_$ref_ob5fba() {
    var l = function (p0, p1) {
      return new QueryParametersBlackListImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function QueryParametersBlackListConcept$_init_$lambda_rrf40i(context, nodeId) {
    return new TypedQueryParametersBlackListImpl(context, VOID, nodeId);
  }
  function QueryParametersBlackListConcept() {
    QueryParametersBlackListConcept_instance = this;
    var tmp = QueryParametersBlackListImpl$_init_$ref_ob5fba();
    OtConceptDescriptor.call(this, 'QueryParametersBlackList', VOID, tmp, QueryParametersBlackListConcept$_init_$lambda_rrf40i, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = library$factory_5();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_215().zcj_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(QueryParametersBlackList), tmp2, getKClass(OntologyLibrary_1));
    tmp_0.kck_1 = this.f6q(tmp$ret$0, tag, 'library');
    this.lck_1 = this.i6q(elements$factory_1(), 'elements');
    this.mck_1 = new DomainNodeReferencePropertyDescriptor(this.kck_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
    this.nck_1 = new DomainNodeChildrenPropertyDescriptor(this.lck_1);
  }
  var QueryParametersBlackListConcept_instance;
  function QueryParametersBlackListConcept_getInstance() {
    if (QueryParametersBlackListConcept_instance == null)
      new QueryParametersBlackListConcept();
    return QueryParametersBlackListConcept_instance;
  }
  function library$factory_5() {
    return getPropertyCallableRef('library', 1, KProperty1, function (receiver) {
      return receiver.kay();
    }, null);
  }
  function elements$factory_1() {
    return getPropertyCallableRef('elements', 1, KProperty1, function (receiver) {
      return receiver.sc0();
    }, null);
  }
  function RelationContainerImpl$_init_$ref_3e7ye8() {
    var l = function (p0, p1) {
      return new RelationContainerImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function RelationContainerConcept$_init_$lambda_4lz394(context, nodeId) {
    return new TypedRelationContainerImpl(context, VOID, nodeId);
  }
  function RelationContainerConcept() {
    RelationContainerConcept_instance = this;
    var tmp = RelationContainerImpl$_init_$ref_3e7ye8();
    OtConceptDescriptor.call(this, 'RelationContainer', VOID, tmp, RelationContainerConcept$_init_$lambda_4lz394, Companion_instance_95.z6p([DocumentNodeConcept_getInstance()]));
    this.yck_1 = this.i6q(processRelations$factory(), 'relations');
    this.zck_1 = this.i6q(instanceRelations$factory(), 'instanceRelations');
    this.acl_1 = new DomainNodeChildrenPropertyDescriptor(this.yck_1);
    this.bcl_1 = new DomainNodeChildrenPropertyDescriptor(this.zck_1);
  }
  var RelationContainerConcept_instance;
  function RelationContainerConcept_getInstance() {
    if (RelationContainerConcept_instance == null)
      new RelationContainerConcept();
    return RelationContainerConcept_instance;
  }
  function processRelations$factory() {
    return getPropertyCallableRef('processRelations', 1, KProperty1, function (receiver) {
      return receiver.ccl();
    }, null);
  }
  function instanceRelations$factory() {
    return getPropertyCallableRef('instanceRelations', 1, KProperty1, function (receiver) {
      return receiver.dcl();
    }, null);
  }
  function RelationFactExpressionImpl$_init_$ref_4dswkl() {
    var l = function (p0, p1) {
      return new RelationFactExpressionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function RelationFactExpressionConcept$_init_$lambda_7ahail(context, nodeId) {
    return new TypedRelationFactExpressionImpl(context, VOID, nodeId);
  }
  function RelationFactExpressionConcept() {
    RelationFactExpressionConcept_instance = this;
    var tmp = RelationFactExpressionImpl$_init_$ref_4dswkl();
    OtConceptDescriptor.call(this, 'RelationFactExpression', VOID, tmp, RelationFactExpressionConcept$_init_$lambda_7ahail, Companion_instance_95.z6p([FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = left$factory_1();
    var tmp$ret$0 = new SingleChildLink(getKClass(RelationFactExpression_1), this_0);
    tmp_0.ocl_1 = this.d6q(tmp$ret$0, 'left');
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = right$factory_1();
    var tmp$ret$2 = new SingleChildLink(getKClass(RelationFactExpression_1), this_1);
    tmp_1.pcl_1 = this.d6q(tmp$ret$2, 'right');
    var tmp_2 = this;
    var tmp2 = relation$factory_1();
    var tmp3 = Companion_getInstance_191().ucl_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'relation';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$4 = new ReferenceLink(getKClass(RelationFactExpression_1), tmp2, getKClass(ProcessRelationDeclaration_1));
    tmp_2.qcl_1 = this.f6q(tmp$ret$4, tmp3, name);
    this.rcl_1 = new DomainNodeChildPropertyDescriptor(this.ocl_1.h6n_1);
    this.scl_1 = new DomainNodeChildPropertyDescriptor(this.pcl_1.h6n_1);
    this.tcl_1 = new DomainNodeReferencePropertyDescriptor(this.qcl_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var RelationFactExpressionConcept_instance;
  function RelationFactExpressionConcept_getInstance() {
    if (RelationFactExpressionConcept_instance == null)
      new RelationFactExpressionConcept();
    return RelationFactExpressionConcept_instance;
  }
  function left$factory_1() {
    return getPropertyCallableRef('left', 1, KProperty1, function (receiver) {
      return receiver.sbf();
    }, null);
  }
  function right$factory_1() {
    return getPropertyCallableRef('right', 1, KProperty1, function (receiver) {
      return receiver.tbf();
    }, null);
  }
  function relation$factory_1() {
    return getPropertyCallableRef('relation', 1, KProperty1, function (receiver) {
      return receiver.gb6();
    }, null);
  }
  function ReturnTypeCustomCellImpl$_init_$ref_nusc14() {
    var l = function (p0, p1) {
      return new ReturnTypeCustomCellImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ReturnTypeCustomCellConcept$_init_$lambda_9kfneo(context, nodeId) {
    return new TypedReturnTypeCustomCellImpl(context, VOID, nodeId);
  }
  function ReturnTypeCustomCellConcept() {
    ReturnTypeCustomCellConcept_instance = this;
    var tmp = ReturnTypeCustomCellImpl$_init_$ref_nusc14();
    OtConceptDescriptor.call(this, 'ReturnTypeCustomCell', VOID, tmp, ReturnTypeCustomCellConcept$_init_$lambda_9kfneo, Companion_instance_95.z6p([CustomCellConcept_getInstance()]));
  }
  var ReturnTypeCustomCellConcept_instance;
  function ReturnTypeCustomCellConcept_getInstance() {
    if (ReturnTypeCustomCellConcept_instance == null)
      new ReturnTypeCustomCellConcept();
    return ReturnTypeCustomCellConcept_instance;
  }
  function SetExpressionImpl$_init_$ref_70rzij() {
    var l = function (p0, p1) {
      return new SetExpressionImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function SetExpressionConcept$_init_$lambda_wznnab(context, nodeId) {
    return new TypedSetExpressionImpl(context, VOID, nodeId);
  }
  function SetExpressionConcept() {
    SetExpressionConcept_instance = this;
    var tmp = SetExpressionImpl$_init_$ref_70rzij();
    OtConceptDescriptor.call(this, 'SetExpression', VOID, tmp, SetExpressionConcept$_init_$lambda_wznnab, Companion_instance_95.z6p([AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance()]));
    this.fcm_1 = this.i6q(expressions$factory_0(), 'expressions');
    this.gcm_1 = this.g6q(isOpen$factory(), 'isOpen');
    this.hcm_1 = new DomainNodeChildrenPropertyDescriptor(this.fcm_1);
    this.icm_1 = new DomainNodePropertyDescriptor(this.gcm_1, toNonNullPersister(NonNullPersisters_getInstance().l2q(), new DefaultValueNullPersister(false)));
  }
  var SetExpressionConcept_instance;
  function SetExpressionConcept_getInstance() {
    if (SetExpressionConcept_instance == null)
      new SetExpressionConcept();
    return SetExpressionConcept_instance;
  }
  function expressions$factory_0() {
    return getPropertyCallableRef('expressions', 1, KProperty1, function (receiver) {
      return receiver.rbs();
    }, null);
  }
  function isOpen$factory() {
    return getPropertyCallableRef('isOpen', 1, KProperty1, function (receiver) {
      return receiver.jcm();
    }, null);
  }
  function SetValuedPropertyParameterImpl$_init_$ref_h96c1m() {
    var l = function (p0, p1) {
      return new SetValuedPropertyParameterImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function SetValuedPropertyParameterConcept$_init_$lambda_i7m6am(context, nodeId) {
    return new TypedSetValuedPropertyParameterImpl(context, VOID, nodeId);
  }
  function SetValuedPropertyParameterConcept() {
    SetValuedPropertyParameterConcept_instance = this;
    var tmp = SetValuedPropertyParameterImpl$_init_$ref_h96c1m();
    OtConceptDescriptor.call(this, 'SetValuedPropertyParameter', VOID, tmp, SetValuedPropertyParameterConcept$_init_$lambda_i7m6am);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = value$factory_7();
    var tmp$ret$0 = new SingleChildLink(getKClass(SetValuedPropertyParameter_1), this_0);
    tmp_0.ucm_1 = this.d6q(tmp$ret$0, 'value');
    this.vcm_1 = new DomainNodeChildPropertyDescriptor(this.ucm_1.h6n_1);
  }
  var SetValuedPropertyParameterConcept_instance;
  function SetValuedPropertyParameterConcept_getInstance() {
    if (SetValuedPropertyParameterConcept_instance == null)
      new SetValuedPropertyParameterConcept();
    return SetValuedPropertyParameterConcept_instance;
  }
  function value$factory_7() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function SimplePropertyTypeImpl$_init_$ref_b6ab2c() {
    var l = function (p0, p1) {
      return new SimplePropertyTypeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function SimplePropertyTypeConcept$_init_$lambda_tme4t8(context, nodeId) {
    return new TypedSimplePropertyTypeImpl(context, VOID, nodeId);
  }
  function SimplePropertyTypeConcept() {
    SimplePropertyTypeConcept_instance = this;
    var tmp = SimplePropertyTypeImpl$_init_$ref_b6ab2c();
    OtConceptDescriptor.call(this, 'SimplePropertyType', VOID, tmp, SimplePropertyTypeConcept$_init_$lambda_tme4t8, Companion_instance_95.z6p([ProcessPropertyTypeConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = notion$factory_0();
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var tag = Companion_getInstance_210().wcm_1;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(SimplePropertyType), tmp2, getKClass(AbstractNotion));
    tmp_0.hcn_1 = this.f6q(tmp$ret$0, tag, 'notion');
    this.icn_1 = new DomainNodeReferencePropertyDescriptor(this.hcn_1, ReferenceContentPersisters_getInstance().s6p(getKClass(QualifiedReferenceContent)), getKClass(QualifiedReferenceContent));
  }
  var SimplePropertyTypeConcept_instance;
  function SimplePropertyTypeConcept_getInstance() {
    if (SimplePropertyTypeConcept_instance == null)
      new SimplePropertyTypeConcept();
    return SimplePropertyTypeConcept_instance;
  }
  function notion$factory_0() {
    return getPropertyCallableRef('notion', 1, KProperty1, function (receiver) {
      return receiver.lbp();
    }, null);
  }
  function SinglePropertyValueRangeImpl$_init_$ref_k2k2g4() {
    var l = function (p0, p1) {
      return new SinglePropertyValueRangeImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function SinglePropertyValueRangeConcept$_init_$lambda_8dh5o4(context, nodeId) {
    return new TypedSinglePropertyValueRangeImpl(context, VOID, nodeId);
  }
  function SinglePropertyValueRangeConcept() {
    SinglePropertyValueRangeConcept_instance = this;
    var tmp = SinglePropertyValueRangeImpl$_init_$ref_k2k2g4();
    OtConceptDescriptor.call(this, 'SinglePropertyValueRange', VOID, tmp, SinglePropertyValueRangeConcept$_init_$lambda_8dh5o4, Companion_instance_95.z6p([PropertyValueRangeConcept_getInstance()]));
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = types$factory_0();
    var tmp$ret$0 = new MultipleChildLink(getKClass(SinglePropertyValueRange_1), this_0);
    tmp_0.tcn_1 = this.e6q(tmp$ret$0, 'types');
    this.ucn_1 = new DomainNodeChildrenPropertyDescriptor(this.tcn_1.h6n_1);
  }
  var SinglePropertyValueRangeConcept_instance;
  function SinglePropertyValueRangeConcept_getInstance() {
    if (SinglePropertyValueRangeConcept_instance == null)
      new SinglePropertyValueRangeConcept();
    return SinglePropertyValueRangeConcept_instance;
  }
  function types$factory_0() {
    return getPropertyCallableRef('types', 1, KProperty1, function (receiver) {
      return receiver.lbn();
    }, null);
  }
  function TextLineImpl$_init_$ref_994090() {
    var l = function (p0, p1) {
      return new TextLineImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function TextLineConcept$_init_$lambda_lv3jac(context, nodeId) {
    return new TypedTextLineImpl(context, VOID, nodeId);
  }
  function TextLineConcept() {
    TextLineConcept_instance = this;
    var tmp = TextLineImpl$_init_$ref_994090();
    OtConceptDescriptor.call(this, 'TextLine', VOID, tmp, TextLineConcept$_init_$lambda_lv3jac);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.textProperty' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = text$factory_0();
    var tmp$ret$0 = new TextAttributeLink(getKClass(TextLine), this_0);
    tmp_0.fco_1 = this.a6q(tmp$ret$0, 'text');
    this.gco_1 = new DomainNodeTextPropertyDescriptor(this.fco_1);
  }
  var TextLineConcept_instance;
  function TextLineConcept_getInstance() {
    if (TextLineConcept_instance == null)
      new TextLineConcept();
    return TextLineConcept_instance;
  }
  function text$factory_0() {
    return getPropertyCallableRef('text', 1, KProperty1, function (receiver) {
      return receiver.laz();
    }, null);
  }
  function TypeConcept() {
    TypeConcept_instance = this;
    OTAbstractConceptDescriptor.call(this, Companion_instance_95.z6p([VariableSpecificationConcept_getInstance()]));
  }
  var TypeConcept_instance;
  function TypeConcept_getInstance() {
    if (TypeConcept_instance == null)
      new TypeConcept();
    return TypeConcept_instance;
  }
  function TypePlaceholderImpl$_init_$ref_egxawc() {
    var l = function (p0, p1) {
      return new TypePlaceholderImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function TypePlaceholderConcept$_init_$lambda_733cg4(context, nodeId) {
    return new TypedTypePlaceholderImpl(context, VOID, nodeId);
  }
  function TypePlaceholderConcept() {
    TypePlaceholderConcept_instance = this;
    var tmp = TypePlaceholderImpl$_init_$ref_egxawc();
    OtConceptDescriptor.call(this, 'TypePlaceholder', VOID, tmp, TypePlaceholderConcept$_init_$lambda_733cg4, Companion_instance_95.z6p([TypeConcept_getInstance()]));
  }
  var TypePlaceholderConcept_instance;
  function TypePlaceholderConcept_getInstance() {
    if (TypePlaceholderConcept_instance == null)
      new TypePlaceholderConcept();
    return TypePlaceholderConcept_instance;
  }
  function UnionClassImpl$_init_$ref_kxg74s() {
    var l = function (p0, p1) {
      return new UnionClassImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function UnionClassConcept$_init_$lambda_tpo0wc(context, nodeId) {
    return new TypedUnionClassImpl(context, VOID, nodeId);
  }
  function UnionClassConcept() {
    UnionClassConcept_instance = this;
    var tmp = UnionClassImpl$_init_$ref_kxg74s();
    OtConceptDescriptor.call(this, 'UnionExpression', VOID, tmp, UnionClassConcept$_init_$lambda_tpo0wc, Companion_instance_95.z6p([AnonymousClassConcept_getInstance()]));
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childrenRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = classes$factory();
    var tmp$ret$0 = new MultipleChildLink(getKClass(UnionClass_1), this_0);
    tmp_0.rco_1 = this.e6q(tmp$ret$0, 'classes');
    this.sco_1 = new DomainNodeChildrenPropertyDescriptor(this.rco_1.h6n_1);
  }
  var UnionClassConcept_instance;
  function UnionClassConcept_getInstance() {
    if (UnionClassConcept_instance == null)
      new UnionClassConcept();
    return UnionClassConcept_instance;
  }
  function classes$factory() {
    return getPropertyCallableRef('classes', 1, KProperty1, function (receiver) {
      return receiver.tco();
    }, null);
  }
  function UrlKnowledgeSourceReferenceImpl$_init_$ref_sgpb50() {
    var l = function (p0, p1) {
      return new UrlKnowledgeSourceReferenceImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function UrlKnowledgeSourceReferenceConcept$_init_$lambda_68k7b8(context, nodeId) {
    return new TypedUrlKnowledgeSourceReferenceImpl(context, VOID, nodeId);
  }
  function UrlKnowledgeSourceReferenceConcept() {
    UrlKnowledgeSourceReferenceConcept_instance = this;
    var tmp = UrlKnowledgeSourceReferenceImpl$_init_$ref_sgpb50();
    OtConceptDescriptor.call(this, 'UrlKnowledgeSource', VOID, tmp, UrlKnowledgeSourceReferenceConcept$_init_$lambda_68k7b8, Companion_instance_95.z6p([KnowledgeSourceReferenceConcept_getInstance()]));
    this.ecp_1 = this.g6q(url$factory_0(), 'url');
    this.fcp_1 = new DomainNodePropertyDescriptor(this.ecp_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
  }
  var UrlKnowledgeSourceReferenceConcept_instance;
  function UrlKnowledgeSourceReferenceConcept_getInstance() {
    if (UrlKnowledgeSourceReferenceConcept_instance == null)
      new UrlKnowledgeSourceReferenceConcept();
    return UrlKnowledgeSourceReferenceConcept_instance;
  }
  function url$factory_0() {
    return getPropertyCallableRef('url', 1, KProperty1, function (receiver) {
      return receiver.jbu();
    }, null);
  }
  function ValueWithRelationsImpl$_init_$ref_h1z1yz() {
    var l = function (p0, p1) {
      return new ValueWithRelationsImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function ValueWithRelationsConcept$_init_$lambda_md949p(context, nodeId) {
    return new TypedValueWithRelationsImpl(context, VOID, nodeId);
  }
  function ValueWithRelationsConcept() {
    ValueWithRelationsConcept_instance = this;
    var tmp = ValueWithRelationsImpl$_init_$ref_h1z1yz();
    OtConceptDescriptor.call(this, 'ValueWithRelations', VOID, tmp, ValueWithRelationsConcept$_init_$lambda_md949p, Companion_instance_95.z6p([AbstractValueConcept_getInstance()]));
    this.qcp_1 = this.h6q(value$factory_8(), 'value');
    this.rcp_1 = this.i6q(relations$factory(), 'relations');
    this.scp_1 = new DomainNodeChildPropertyDescriptor(this.qcp_1);
    this.tcp_1 = new DomainNodeChildrenPropertyDescriptor(this.rcp_1);
  }
  var ValueWithRelationsConcept_instance;
  function ValueWithRelationsConcept_getInstance() {
    if (ValueWithRelationsConcept_instance == null)
      new ValueWithRelationsConcept();
    return ValueWithRelationsConcept_instance;
  }
  function value$factory_8() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function relations$factory() {
    return getPropertyCallableRef('relations', 1, KProperty1, function (receiver) {
      return receiver.ucp();
    }, null);
  }
  function VariableDeclarationImpl$_init_$ref_lqg8ft() {
    var l = function (p0, p1) {
      return new VariableDeclarationImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function VariableDeclarationConcept$_init_$lambda_pqjz33(context, nodeId) {
    return new TypedVariableDeclarationImpl(context, VOID, nodeId);
  }
  function VariableDeclarationConcept() {
    VariableDeclarationConcept_instance = this;
    var tmp = VariableDeclarationImpl$_init_$ref_lqg8ft();
    OtConceptDescriptor.call(this, 'VariableDeclaration', VOID, tmp, VariableDeclarationConcept$_init_$lambda_pqjz33, Companion_instance_95.z6p([DirectlyNamedConcept_getInstance(), HasQueryLabelsConcept_getInstance(), HasPropertyConstraintsConcept_getInstance()]));
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.childRole' call
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = spec$factory();
    var tmp$ret$0 = new SingleChildLink(getKClass(VariableDeclaration_1), this_0);
    tmp_0.fcq_1 = this.d6q(tmp$ret$0, 'type');
    this.gcq_1 = this.i6q(relations$factory_0(), 'relations');
    this.hcq_1 = new DomainNodeChildPropertyDescriptor(this.fcq_1.h6n_1);
    this.icq_1 = new DomainNodeChildrenPropertyDescriptor(this.gcq_1);
  }
  var VariableDeclarationConcept_instance;
  function VariableDeclarationConcept_getInstance() {
    if (VariableDeclarationConcept_instance == null)
      new VariableDeclarationConcept();
    return VariableDeclarationConcept_instance;
  }
  function spec$factory() {
    return getPropertyCallableRef('spec', 1, KProperty1, function (receiver) {
      return receiver.jcq();
    }, null);
  }
  function relations$factory_0() {
    return getPropertyCallableRef('relations', 1, KProperty1, function (receiver) {
      return receiver.ucp();
    }, null);
  }
  function VariableInitializerImpl$_init_$ref_ymrzmp() {
    var l = function (p0, p1) {
      return new VariableInitializerImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function VariableInitializerConcept$_init_$lambda_8mmarb(context, nodeId) {
    return new TypedVariableInitializerImpl(context, VOID, nodeId);
  }
  function VariableInitializerConcept() {
    VariableInitializerConcept_instance = this;
    var tmp = VariableInitializerImpl$_init_$ref_ymrzmp();
    OtConceptDescriptor.call(this, 'VariableInitializer', VOID, tmp, VariableInitializerConcept$_init_$lambda_8mmarb, Companion_instance_95.z6p([VariableSpecificationConcept_getInstance()]));
  }
  var VariableInitializerConcept_instance;
  function VariableInitializerConcept_getInstance() {
    if (VariableInitializerConcept_instance == null)
      new VariableInitializerConcept();
    return VariableInitializerConcept_instance;
  }
  function VariableReferenceValueImpl$_init_$ref_v2s40z() {
    var l = function (p0, p1) {
      return new VariableReferenceValueImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function VariableReferenceValueConcept$_init_$lambda_rhgscl(context, nodeId) {
    return new TypedVariableReferenceValueImpl(context, VOID, nodeId);
  }
  function VariableReferenceValueConcept() {
    VariableReferenceValueConcept_instance = this;
    var tmp = VariableReferenceValueImpl$_init_$ref_v2s40z();
    OtConceptDescriptor.call(this, 'VariableReferenceValue', VOID, tmp, VariableReferenceValueConcept$_init_$lambda_rhgscl, Companion_instance_95.z6p([VariableInitializerConcept_getInstance(), AbstractValueConcept_getInstance(), FactExpressionConcept_getInstance()]));
    var tmp_0 = this;
    var tmp2 = variable$factory();
    var tmp3 = Companion_getInstance_221().kcq_1;
    // Inline function 'jetbrains.ocelot.langDef.ot.structure.Companion.referenceRole' call
    var name = 'variable';
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var tmp$ret$0 = new ReferenceLink(getKClass(VariableReferenceValue_1), tmp2, getKClass(VariableDeclaration_1));
    tmp_0.vcq_1 = this.f6q(tmp$ret$0, tmp3, name);
    this.wcq_1 = new DomainNodeReferencePropertyDescriptor(this.vcq_1, ReferenceContentPersisters_getInstance().s6p(getKClass(LocalReferenceContent)), getKClass(LocalReferenceContent));
  }
  var VariableReferenceValueConcept_instance;
  function VariableReferenceValueConcept_getInstance() {
    if (VariableReferenceValueConcept_instance == null)
      new VariableReferenceValueConcept();
    return VariableReferenceValueConcept_instance;
  }
  function variable$factory() {
    return getPropertyCallableRef('variable', 1, KProperty1, function (receiver) {
      return receiver.xcq();
    }, null);
  }
  function VariableSpecificationConcept() {
    VariableSpecificationConcept_instance = this;
    OTAbstractConceptDescriptor.call(this);
  }
  var VariableSpecificationConcept_instance;
  function VariableSpecificationConcept_getInstance() {
    if (VariableSpecificationConcept_instance == null)
      new VariableSpecificationConcept();
    return VariableSpecificationConcept_instance;
  }
  function XRefContainerImpl$_init_$ref_w9w469() {
    var l = function (p0, p1) {
      return new XRefContainerImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function XRefContainerConcept$_init_$lambda_bet5h3(context, nodeId) {
    return new TypedXRefContainerImpl(context, VOID, nodeId);
  }
  function XRefContainerConcept() {
    XRefContainerConcept_instance = this;
    var tmp = XRefContainerImpl$_init_$ref_w9w469();
    OtConceptDescriptor.call(this, 'XRefContainer', VOID, tmp, XRefContainerConcept$_init_$lambda_bet5h3);
    this.icr_1 = this.g6q(xRef$factory(), 'xRef');
    this.jcr_1 = new DomainNodePropertyDescriptor(this.icr_1, toNonNullPersister(NonNullPersisters_getInstance().i2q(), new DefaultValueNullPersister('')));
  }
  var XRefContainerConcept_instance;
  function XRefContainerConcept_getInstance() {
    if (XRefContainerConcept_instance == null)
      new XRefContainerConcept();
    return XRefContainerConcept_instance;
  }
  function xRef$factory() {
    return getPropertyCallableRef('xRef', 1, KProperty1, function (receiver) {
      return receiver.kcr();
    }, null);
  }
  function btbConceptRegistry(_this__u8e3s4) {
    structure(_this__u8e3s4, btbConceptRegistry$lambda);
  }
  function btbConceptRegistry$lambda($this$structure) {
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor = AbstractBindingDeclarationConcept_getInstance();
    $this$structure.v70(getKClass(AbstractBindingDeclaration), descriptor);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_0 = AbstractBindingEntryConcept_getInstance();
    $this$structure.v70(getKClass(AbstractBindingEntry), descriptor_0);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_1 = AbstractBindingValueConcept_getInstance();
    $this$structure.v70(getKClass(AbstractBindingValue), descriptor_1);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_2 = AbstractBindingValueQueryConcept_getInstance();
    $this$structure.v70(getKClass(AbstractBindingValueQuery), descriptor_2);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_3 = AbstractLinkConcept_getInstance();
    $this$structure.v70(getKClass(AbstractLink), descriptor_3);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_4 = AbstractNotionConcept_getInstance();
    $this$structure.v70(getKClass(AbstractNotion), descriptor_4);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_5 = AbstractOntologyRelationConcept_getInstance();
    $this$structure.v70(getKClass(AbstractOntologyRelation), descriptor_5);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_6 = AbstractProcessSpecificationConcept_getInstance();
    $this$structure.v70(getKClass(AbstractProcessSpecification), descriptor_6);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_7 = AbstractPropertyConcept_getInstance();
    $this$structure.v70(getKClass(AbstractProperty), descriptor_7);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_8 = AuthorConcept_getInstance();
    $this$structure.v70(getKClass(Author_1), descriptor_8);
    $this$structure.w70(getKClass(Author_1), $this$structure.t70() ? getKClass(TypedAuthorImpl) : getKClass(AuthorImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_9 = AuthoredWorkConcept_getInstance();
    $this$structure.v70(getKClass(AuthoredWork), descriptor_9);
    $this$structure.w70(getKClass(AuthoredWork), $this$structure.t70() ? getKClass(TypedAuthoredWorkImpl) : getKClass(AuthoredWorkImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_10 = BTBDocumentConcept_getInstance();
    $this$structure.v70(getKClass(BTBDocument_1), descriptor_10);
    $this$structure.w70(getKClass(BTBDocument_1), $this$structure.t70() ? getKClass(TypedBTBDocumentImpl) : getKClass(BTBDocumentImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_11 = BindingPropertyConcept_getInstance();
    $this$structure.v70(getKClass(BindingProperty_1), descriptor_11);
    $this$structure.w70(getKClass(BindingProperty_1), $this$structure.t70() ? getKClass(TypedBindingPropertyImpl) : getKClass(BindingPropertyImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_12 = BindingValueMaskConcept_getInstance();
    $this$structure.v70(getKClass(BindingValueMask_1), descriptor_12);
    $this$structure.w70(getKClass(BindingValueMask_1), $this$structure.t70() ? getKClass(TypedBindingValueMaskImpl) : getKClass(BindingValueMaskImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_13 = BindingValuePlaceholderConcept_getInstance();
    $this$structure.v70(getKClass(BindingValuePlaceholder_1), descriptor_13);
    $this$structure.w70(getKClass(BindingValuePlaceholder_1), $this$structure.t70() ? getKClass(TypedBindingValuePlaceholderImpl) : getKClass(BindingValuePlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_14 = BindingValuePlaceholderQueryConcept_getInstance();
    $this$structure.v70(getKClass(BindingValuePlaceholderQuery_1), descriptor_14);
    $this$structure.w70(getKClass(BindingValuePlaceholderQuery_1), $this$structure.t70() ? getKClass(TypedBindingValuePlaceholderQueryImpl) : getKClass(BindingValuePlaceholderQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_15 = BookConcept_getInstance();
    $this$structure.v70(getKClass(Book_1), descriptor_15);
    $this$structure.w70(getKClass(Book_1), $this$structure.t70() ? getKClass(TypedBookImpl) : getKClass(BookImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_16 = CardinalityConcept_getInstance();
    $this$structure.v70(getKClass(Cardinality_1), descriptor_16);
    $this$structure.w70(getKClass(Cardinality_1), $this$structure.t70() ? getKClass(TypedCardinalityImpl) : getKClass(CardinalityImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_17 = CardinalityBoundConcept_getInstance();
    $this$structure.v70(getKClass(CardinalityBound), descriptor_17);
    $this$structure.w70(getKClass(CardinalityBound), $this$structure.t70() ? getKClass(TypedCardinalityBoundImpl) : getKClass(CardinalityBoundImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_18 = CardinalityBoundConstantConcept_getInstance();
    $this$structure.v70(getKClass(CardinalityBoundConstant_1), descriptor_18);
    $this$structure.w70(getKClass(CardinalityBoundConstant_1), $this$structure.t70() ? getKClass(TypedCardinalityBoundConstantImpl) : getKClass(CardinalityBoundConstantImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_19 = CardinalityBoundNConcept_getInstance();
    $this$structure.v70(getKClass(CardinalityBoundN_1), descriptor_19);
    $this$structure.w70(getKClass(CardinalityBoundN_1), $this$structure.t70() ? getKClass(TypedCardinalityBoundNImpl) : getKClass(CardinalityBoundNImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_20 = CardinalityBoundPlaceholderConcept_getInstance();
    $this$structure.v70(getKClass(CardinalityBoundPlaceholder_1), descriptor_20);
    $this$structure.w70(getKClass(CardinalityBoundPlaceholder_1), $this$structure.t70() ? getKClass(TypedCardinalityBoundPlaceholderImpl) : getKClass(CardinalityBoundPlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_21 = CardinalityCustomCellConcept_getInstance();
    $this$structure.v70(getKClass(CardinalityCustomCell_1), descriptor_21);
    $this$structure.w70(getKClass(CardinalityCustomCell_1), $this$structure.t70() ? getKClass(TypedCardinalityCustomCellImpl) : getKClass(CardinalityCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_22 = CategoryConcept_getInstance();
    $this$structure.v70(getKClass(Category_1), descriptor_22);
    $this$structure.w70(getKClass(Category_1), $this$structure.t70() ? getKClass(TypedCategoryImpl) : getKClass(CategoryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_23 = ClassExpressionPlaceholderConcept_getInstance();
    $this$structure.v70(getKClass(ClassExpressionPlaceholder_1), descriptor_23);
    $this$structure.w70(getKClass(ClassExpressionPlaceholder_1), $this$structure.t70() ? getKClass(TypedClassExpressionPlaceholderImpl) : getKClass(ClassExpressionPlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_24 = ClassExpressionTypeConcept_getInstance();
    $this$structure.v70(getKClass(ClassExpressionType_1), descriptor_24);
    $this$structure.w70(getKClass(ClassExpressionType_1), $this$structure.t70() ? getKClass(TypedClassExpressionTypeImpl) : getKClass(ClassExpressionTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_25 = CommandConcept_getInstance();
    $this$structure.v70(getKClass(Command_0), descriptor_25);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_26 = ConstantCustomCellConcept_getInstance();
    $this$structure.v70(getKClass(ConstantCustomCell_1), descriptor_26);
    $this$structure.w70(getKClass(ConstantCustomCell_1), $this$structure.t70() ? getKClass(TypedConstantCustomCellImpl) : getKClass(ConstantCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_27 = ConstantPreconditionConcept_getInstance();
    $this$structure.v70(getKClass(ConstantPrecondition_0), descriptor_27);
    $this$structure.w70(getKClass(ConstantPrecondition_0), $this$structure.t70() ? getKClass(TypedConstantPreconditionImpl) : getKClass(ConstantPreconditionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_28 = ContextConcept_getInstance();
    $this$structure.v70(getKClass(Context_1), descriptor_28);
    $this$structure.w70(getKClass(Context_1), $this$structure.t70() ? getKClass(TypedContextImpl) : getKClass(ContextImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_29 = ContextQueryConcept_getInstance();
    $this$structure.v70(getKClass(ContextQuery_1), descriptor_29);
    $this$structure.w70(getKClass(ContextQuery_1), $this$structure.t70() ? getKClass(TypedContextQueryImpl) : getKClass(ContextQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_30 = CustomCellConcept_getInstance();
    $this$structure.v70(getKClass(CustomCell), descriptor_30);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_31 = CustomEditorConcept_getInstance();
    $this$structure.v70(getKClass(CustomEditor), descriptor_31);
    $this$structure.w70(getKClass(CustomEditor), $this$structure.t70() ? getKClass(TypedCustomEditorImpl) : getKClass(CustomEditorImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_32 = DeclarationNameCustomCellConcept_getInstance();
    $this$structure.v70(getKClass(DeclarationNameCustomCell_1), descriptor_32);
    $this$structure.w70(getKClass(DeclarationNameCustomCell_1), $this$structure.t70() ? getKClass(TypedDeclarationNameCustomCellImpl) : getKClass(DeclarationNameCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_33 = DeclarationValueQueryConcept_getInstance();
    $this$structure.v70(getKClass(DeclarationValueQuery), descriptor_33);
    $this$structure.w70(getKClass(DeclarationValueQuery), $this$structure.t70() ? getKClass(TypedDeclarationValueQueryImpl) : getKClass(DeclarationValueQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_34 = DocumentNodeConcept_getInstance();
    $this$structure.v70(getKClass(DocumentNode_0), descriptor_34);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_35 = EmptyBindingEntryConcept_getInstance();
    $this$structure.v70(getKClass(EmptyBindingEntry_1), descriptor_35);
    $this$structure.w70(getKClass(EmptyBindingEntry_1), $this$structure.t70() ? getKClass(TypedEmptyBindingEntryImpl) : getKClass(EmptyBindingEntryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_36 = EmptyPropertyLibraryElementConcept_getInstance();
    $this$structure.v70(getKClass(EmptyPropertyLibraryElement_1), descriptor_36);
    $this$structure.w70(getKClass(EmptyPropertyLibraryElement_1), $this$structure.t70() ? getKClass(TypedEmptyPropertyLibraryElementImpl) : getKClass(EmptyPropertyLibraryElementImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_37 = EnumValueConcept_getInstance();
    $this$structure.v70(getKClass(EnumValue_1), descriptor_37);
    $this$structure.w70(getKClass(EnumValue_1), $this$structure.t70() ? getKClass(TypedEnumValueImpl) : getKClass(EnumValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_38 = EnumerableNotionConcept_getInstance();
    $this$structure.v70(getKClass(EnumerableNotion_1), descriptor_38);
    $this$structure.w70(getKClass(EnumerableNotion_1), $this$structure.t70() ? getKClass(TypedEnumerableNotionImpl) : getKClass(EnumerableNotionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_39 = EnumerationConstantConcept_getInstance();
    $this$structure.v70(getKClass(EnumerationConstant_1), descriptor_39);
    $this$structure.w70(getKClass(EnumerationConstant_1), $this$structure.t70() ? getKClass(TypedEnumerationConstantImpl) : getKClass(EnumerationConstantImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_40 = ExtensionDeclarationConcept_getInstance();
    $this$structure.v70(getKClass(ExtensionDeclaration_1), descriptor_40);
    $this$structure.w70(getKClass(ExtensionDeclaration_1), $this$structure.t70() ? getKClass(TypedExtensionDeclarationImpl) : getKClass(ExtensionDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_41 = ExtensionFieldReferenceConcept_getInstance();
    $this$structure.v70(getKClass(ExtensionFieldReference_1), descriptor_41);
    $this$structure.w70(getKClass(ExtensionFieldReference_1), $this$structure.t70() ? getKClass(TypedExtensionFieldReferenceImpl) : getKClass(ExtensionFieldReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_42 = ExtensionLibraryConcept_getInstance();
    $this$structure.v70(getKClass(ExtensionLibrary_1), descriptor_42);
    $this$structure.w70(getKClass(ExtensionLibrary_1), $this$structure.t70() ? getKClass(TypedExtensionLibraryImpl) : getKClass(ExtensionLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_43 = FactConcept_getInstance();
    $this$structure.v70(getKClass(Fact_1), descriptor_43);
    $this$structure.w70(getKClass(Fact_1), $this$structure.t70() ? getKClass(TypedFactImpl) : getKClass(FactImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_44 = FactExpressionPlaceholderConcept_getInstance();
    $this$structure.v70(getKClass(FactExpressionPlaceholder), descriptor_44);
    $this$structure.w70(getKClass(FactExpressionPlaceholder), $this$structure.t70() ? getKClass(TypedFactExpressionPlaceholderImpl) : getKClass(FactExpressionPlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_45 = FactPreconditionConcept_getInstance();
    $this$structure.v70(getKClass(FactPrecondition_1), descriptor_45);
    $this$structure.w70(getKClass(FactPrecondition_1), $this$structure.t70() ? getKClass(TypedFactPreconditionImpl) : getKClass(FactPreconditionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_46 = FactReferenceConcept_getInstance();
    $this$structure.v70(getKClass(FactReference_1), descriptor_46);
    $this$structure.w70(getKClass(FactReference_1), $this$structure.t70() ? getKClass(TypedFactReferenceImpl) : getKClass(FactReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_47 = FactSetConcept_getInstance();
    $this$structure.v70(getKClass(FactSet_1), descriptor_47);
    $this$structure.w70(getKClass(FactSet_1), $this$structure.t70() ? getKClass(TypedFactSetImpl) : getKClass(FactSetImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_48 = FieldDeclarationConcept_getInstance();
    $this$structure.v70(getKClass(FieldDeclaration_1), descriptor_48);
    $this$structure.w70(getKClass(FieldDeclaration_1), $this$structure.t70() ? getKClass(TypedFieldDeclarationImpl) : getKClass(FieldDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_49 = FindConnectionCommandConcept_getInstance();
    $this$structure.v70(getKClass(FindConnectionCommand_1), descriptor_49);
    $this$structure.w70(getKClass(FindConnectionCommand_1), $this$structure.t70() ? getKClass(TypedFindConnectionCommandImpl) : getKClass(FindConnectionCommandImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_50 = FunctionDeclarationConcept_getInstance();
    $this$structure.v70(getKClass(FunctionDeclaration_1), descriptor_50);
    $this$structure.w70(getKClass(FunctionDeclaration_1), $this$structure.t70() ? getKClass(TypedFunctionDeclarationImpl) : getKClass(FunctionDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_51 = FunctionLibraryConcept_getInstance();
    $this$structure.v70(getKClass(FunctionLibrary_1), descriptor_51);
    $this$structure.w70(getKClass(FunctionLibrary_1), $this$structure.t70() ? getKClass(TypedFunctionLibraryImpl) : getKClass(FunctionLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_52 = FunctionTermConcept_getInstance();
    $this$structure.v70(getKClass(FunctionTerm_1), descriptor_52);
    $this$structure.w70(getKClass(FunctionTerm_1), $this$structure.t70() ? getKClass(TypedFunctionTermImpl) : getKClass(FunctionTermImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_53 = ImportedLinkConcept_getInstance();
    $this$structure.v70(getKClass(ImportedLink_1), descriptor_53);
    $this$structure.w70(getKClass(ImportedLink_1), $this$structure.t70() ? getKClass(TypedImportedLinkImpl) : getKClass(ImportedLinkImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_54 = ImportedPropertyConcept_getInstance();
    $this$structure.v70(getKClass(ImportedProperty_1), descriptor_54);
    $this$structure.w70(getKClass(ImportedProperty_1), $this$structure.t70() ? getKClass(TypedImportedPropertyImpl) : getKClass(ImportedPropertyImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_55 = InstanceRelationDeclarationConcept_getInstance();
    $this$structure.v70(getKClass(InstanceRelationDeclaration), descriptor_55);
    $this$structure.w70(getKClass(InstanceRelationDeclaration), $this$structure.t70() ? getKClass(TypedInstanceRelationDeclarationImpl) : getKClass(InstanceRelationDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_56 = InstanceRelationValueConcept_getInstance();
    $this$structure.v70(getKClass(InstanceRelationValue), descriptor_56);
    $this$structure.w70(getKClass(InstanceRelationValue), $this$structure.t70() ? getKClass(TypedInstanceRelationValueImpl) : getKClass(InstanceRelationValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_57 = InstanceRelationValuePlaceholderConcept_getInstance();
    $this$structure.v70(getKClass(InstanceRelationValuePlaceholder), descriptor_57);
    $this$structure.w70(getKClass(InstanceRelationValuePlaceholder), $this$structure.t70() ? getKClass(TypedInstanceRelationValuePlaceholderImpl) : getKClass(InstanceRelationValuePlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_58 = IsExpressionConcept_getInstance();
    $this$structure.v70(getKClass(IsExpression_1), descriptor_58);
    $this$structure.w70(getKClass(IsExpression_1), $this$structure.t70() ? getKClass(TypedIsExpressionImpl) : getKClass(IsExpressionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_59 = KindCustomCellConcept_getInstance();
    $this$structure.v70(getKClass(KindCustomCell_1), descriptor_59);
    $this$structure.w70(getKClass(KindCustomCell_1), $this$structure.t70() ? getKClass(TypedKindCustomCellImpl) : getKClass(KindCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_60 = KnowledgeSourceReferenceConcept_getInstance();
    $this$structure.v70(getKClass(KnowledgeSourceReference), descriptor_60);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_61 = KnowledgeSourceReferencePlaceholderConcept_getInstance();
    $this$structure.v70(getKClass(KnowledgeSourceReferencePlaceholder_1), descriptor_61);
    $this$structure.w70(getKClass(KnowledgeSourceReferencePlaceholder_1), $this$structure.t70() ? getKClass(TypedKnowledgeSourceReferencePlaceholderImpl) : getKClass(KnowledgeSourceReferencePlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_62 = LibraryItemPlaceholderConcept_getInstance();
    $this$structure.v70(getKClass(LibraryItemPlaceholder_1), descriptor_62);
    $this$structure.w70(getKClass(LibraryItemPlaceholder_1), $this$structure.t70() ? getKClass(TypedLibraryItemPlaceholderImpl) : getKClass(LibraryItemPlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_63 = LibraryProcessSpecificationConcept_getInstance();
    $this$structure.v70(getKClass(LibraryProcessSpecification_1), descriptor_63);
    $this$structure.w70(getKClass(LibraryProcessSpecification_1), $this$structure.t70() ? getKClass(TypedLibraryProcessSpecificationImpl) : getKClass(LibraryProcessSpecificationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_64 = LibraryProcessSpecificationQueryConcept_getInstance();
    $this$structure.v70(getKClass(LibraryProcessSpecificationQuery_1), descriptor_64);
    $this$structure.w70(getKClass(LibraryProcessSpecificationQuery_1), $this$structure.t70() ? getKClass(TypedLibraryProcessSpecificationQueryImpl) : getKClass(LibraryProcessSpecificationQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_65 = LinkCustomCellConcept_getInstance();
    $this$structure.v70(getKClass(LinkCustomCell_1), descriptor_65);
    $this$structure.w70(getKClass(LinkCustomCell_1), $this$structure.t70() ? getKClass(TypedLinkCustomCellImpl) : getKClass(LinkCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_66 = LinkDeclarationConcept_getInstance();
    $this$structure.v70(getKClass(LinkDeclaration_1), descriptor_66);
    $this$structure.w70(getKClass(LinkDeclaration_1), $this$structure.t70() ? getKClass(TypedLinkDeclarationImpl) : getKClass(LinkDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_67 = LinkLibraryConcept_getInstance();
    $this$structure.v70(getKClass(LinkLibrary_1), descriptor_67);
    $this$structure.w70(getKClass(LinkLibrary_1), $this$structure.t70() ? getKClass(TypedLinkLibraryImpl) : getKClass(LinkLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_68 = LinkStubConcept_getInstance();
    $this$structure.v70(getKClass(LinkStub), descriptor_68);
    $this$structure.w70(getKClass(LinkStub), $this$structure.t70() ? getKClass(TypedLinkStubImpl) : getKClass(LinkStubImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_69 = LocalOntologyElementReferenceConcept_getInstance();
    $this$structure.v70(getKClass(LocalOntologyElementReference_1), descriptor_69);
    $this$structure.w70(getKClass(LocalOntologyElementReference_1), $this$structure.t70() ? getKClass(TypedLocalOntologyElementReferenceImpl) : getKClass(LocalOntologyElementReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_70 = MeasurableNotionConcept_getInstance();
    $this$structure.v70(getKClass(MeasurableNotion_1), descriptor_70);
    $this$structure.w70(getKClass(MeasurableNotion_1), $this$structure.t70() ? getKClass(TypedMeasurableNotionImpl) : getKClass(MeasurableNotionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_71 = MeasurableValueConcept_getInstance();
    $this$structure.v70(getKClass(MeasurableValue_1), descriptor_71);
    $this$structure.w70(getKClass(MeasurableValue_1), $this$structure.t70() ? getKClass(TypedMeasurableValueImpl) : getKClass(MeasurableValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_72 = MeasurementUnitConcept_getInstance();
    $this$structure.v70(getKClass(MeasurementUnit_1), descriptor_72);
    $this$structure.w70(getKClass(MeasurementUnit_1), $this$structure.t70() ? getKClass(TypedMeasurementUnitImpl) : getKClass(MeasurementUnitImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_73 = ModifierContainerConcept_getInstance();
    $this$structure.v70(getKClass(ModifierContainer), descriptor_73);
    $this$structure.w70(getKClass(ModifierContainer), $this$structure.t70() ? getKClass(TypedModifierContainerImpl) : getKClass(ModifierContainerImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_74 = ModifierDeclarationConcept_getInstance();
    $this$structure.v70(getKClass(ModifierDeclaration), descriptor_74);
    $this$structure.w70(getKClass(ModifierDeclaration), $this$structure.t70() ? getKClass(TypedModifierDeclarationImpl) : getKClass(ModifierDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_75 = ModifierFactExpressionConcept_getInstance();
    $this$structure.v70(getKClass(ModifierFactExpression_0), descriptor_75);
    $this$structure.w70(getKClass(ModifierFactExpression_0), $this$structure.t70() ? getKClass(TypedModifierFactExpressionImpl) : getKClass(ModifierFactExpressionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_76 = MultilineTextConcept_getInstance();
    $this$structure.v70(getKClass(MultilineText), descriptor_76);
    $this$structure.w70(getKClass(MultilineText), $this$structure.t70() ? getKClass(TypedMultilineTextImpl) : getKClass(MultilineTextImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_77 = MultipleProcessPropertyValueRangeConcept_getInstance();
    $this$structure.v70(getKClass(MultipleProcessPropertyValueRange_1), descriptor_77);
    $this$structure.w70(getKClass(MultipleProcessPropertyValueRange_1), $this$structure.t70() ? getKClass(TypedMultipleProcessPropertyValueRangeImpl) : getKClass(MultipleProcessPropertyValueRangeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_78 = MultiplePropertyValueRangeConcept_getInstance();
    $this$structure.v70(getKClass(MultiplePropertyValueRange_1), descriptor_78);
    $this$structure.w70(getKClass(MultiplePropertyValueRange_1), $this$structure.t70() ? getKClass(TypedMultiplePropertyValueRangeImpl) : getKClass(MultiplePropertyValueRangeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_79 = NewFactConcept_getInstance();
    $this$structure.v70(getKClass(NewFact), descriptor_79);
    $this$structure.w70(getKClass(NewFact), $this$structure.t70() ? getKClass(TypedNewFactImpl) : getKClass(NewFactImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_80 = NewFactReferenceConcept_getInstance();
    $this$structure.v70(getKClass(NewFactReference_0), descriptor_80);
    $this$structure.w70(getKClass(NewFactReference_0), $this$structure.t70() ? getKClass(TypedNewFactReferenceImpl) : getKClass(NewFactReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_81 = NoValuesConcept_getInstance();
    $this$structure.v70(getKClass(NoValues_1), descriptor_81);
    $this$structure.w70(getKClass(NoValues_1), $this$structure.t70() ? getKClass(TypedNoValuesImpl) : getKClass(NoValuesImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_82 = NotionLibraryConcept_getInstance();
    $this$structure.v70(getKClass(NotionLibrary_1), descriptor_82);
    $this$structure.w70(getKClass(NotionLibrary_1), $this$structure.t70() ? getKClass(TypedNotionLibraryImpl) : getKClass(NotionLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_83 = NotionPlaceholderConcept_getInstance();
    $this$structure.v70(getKClass(NotionPlaceholder_1), descriptor_83);
    $this$structure.w70(getKClass(NotionPlaceholder_1), $this$structure.t70() ? getKClass(TypedNotionPlaceholderImpl) : getKClass(NotionPlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_84 = NotionStubConcept_getInstance();
    $this$structure.v70(getKClass(NotionStub), descriptor_84);
    $this$structure.w70(getKClass(NotionStub), $this$structure.t70() ? getKClass(TypedNotionStubImpl) : getKClass(NotionStubImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_85 = NotionTypeConcept_getInstance();
    $this$structure.v70(getKClass(NotionType_0), descriptor_85);
    $this$structure.w70(getKClass(NotionType_0), $this$structure.t70() ? getKClass(TypedNotionTypeImpl) : getKClass(NotionTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_86 = ObjectPropertiesLibraryConcept_getInstance();
    $this$structure.v70(getKClass(ObjectPropertiesLibrary), descriptor_86);
    $this$structure.w70(getKClass(ObjectPropertiesLibrary), $this$structure.t70() ? getKClass(TypedObjectPropertiesLibraryImpl) : getKClass(ObjectPropertiesLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_87 = ObjectPropertyDeclarationConcept_getInstance();
    $this$structure.v70(getKClass(ObjectPropertyDeclaration_1), descriptor_87);
    $this$structure.w70(getKClass(ObjectPropertyDeclaration_1), $this$structure.t70() ? getKClass(TypedObjectPropertyDeclarationImpl) : getKClass(ObjectPropertyDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_88 = ObjectPropertyReferenceValueConcept_getInstance();
    $this$structure.v70(getKClass(ObjectPropertyReferenceValue_1), descriptor_88);
    $this$structure.w70(getKClass(ObjectPropertyReferenceValue_1), $this$structure.t70() ? getKClass(TypedObjectPropertyReferenceValueImpl) : getKClass(ObjectPropertyReferenceValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_89 = OldPublishedSourceConcept_getInstance();
    $this$structure.v70(getKClass(OldPublishedSource), descriptor_89);
    $this$structure.w70(getKClass(OldPublishedSource), $this$structure.t70() ? getKClass(TypedOldPublishedSourceImpl) : getKClass(OldPublishedSourceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_90 = OneOfConcept_getInstance();
    $this$structure.v70(getKClass(OneOf_1), descriptor_90);
    $this$structure.w70(getKClass(OneOf_1), $this$structure.t70() ? getKClass(TypedOneOfImpl) : getKClass(OneOfImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_91 = OntologyCardinalityRelationConcept_getInstance();
    $this$structure.v70(getKClass(OntologyCardinalityRelation_1), descriptor_91);
    $this$structure.w70(getKClass(OntologyCardinalityRelation_1), $this$structure.t70() ? getKClass(TypedOntologyCardinalityRelationImpl) : getKClass(OntologyCardinalityRelationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_92 = OntologyElementConcept_getInstance();
    $this$structure.v70(getKClass(OntologyElement_1), descriptor_92);
    $this$structure.w70(getKClass(OntologyElement_1), $this$structure.t70() ? getKClass(TypedOntologyElementImpl) : getKClass(OntologyElementImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_93 = OntologyElementDefinitionConcept_getInstance();
    $this$structure.v70(getKClass(OntologyElementDefinition_1), descriptor_93);
    $this$structure.w70(getKClass(OntologyElementDefinition_1), $this$structure.t70() ? getKClass(TypedOntologyElementDefinitionImpl) : getKClass(OntologyElementDefinitionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_94 = OntologyElementPropertyTypeConcept_getInstance();
    $this$structure.v70(getKClass(OntologyElementPropertyType_1), descriptor_94);
    $this$structure.w70(getKClass(OntologyElementPropertyType_1), $this$structure.t70() ? getKClass(TypedOntologyElementPropertyTypeImpl) : getKClass(OntologyElementPropertyTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_95 = OntologyElementReferenceConcept_getInstance();
    $this$structure.v70(getKClass(OntologyElementReference_1), descriptor_95);
    $this$structure.w70(getKClass(OntologyElementReference_1), $this$structure.t70() ? getKClass(TypedOntologyElementReferenceImpl) : getKClass(OntologyElementReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_96 = OntologyElementReferenceValueConcept_getInstance();
    $this$structure.v70(getKClass(OntologyElementReferenceValue_1), descriptor_96);
    $this$structure.w70(getKClass(OntologyElementReferenceValue_1), $this$structure.t70() ? getKClass(TypedOntologyElementReferenceValueImpl) : getKClass(OntologyElementReferenceValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_97 = OntologyElementReferenceValueLibraryConcept_getInstance();
    $this$structure.v70(getKClass(OntologyElementReferenceValueLibrary_1), descriptor_97);
    $this$structure.w70(getKClass(OntologyElementReferenceValueLibrary_1), $this$structure.t70() ? getKClass(TypedOntologyElementReferenceValueLibraryImpl) : getKClass(OntologyElementReferenceValueLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_98 = OntologyElementSynonymConcept_getInstance();
    $this$structure.v70(getKClass(OntologyElementSynonym_1), descriptor_98);
    $this$structure.w70(getKClass(OntologyElementSynonym_1), $this$structure.t70() ? getKClass(TypedOntologyElementSynonymImpl) : getKClass(OntologyElementSynonymImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_99 = OntologyElementTypeConcept_getInstance();
    $this$structure.v70(getKClass(OntologyElementType_1), descriptor_99);
    $this$structure.w70(getKClass(OntologyElementType_1), $this$structure.t70() ? getKClass(TypedOntologyElementTypeImpl) : getKClass(OntologyElementTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_100 = OntologyImportConcept_getInstance();
    $this$structure.v70(getKClass(OntologyImport_1), descriptor_100);
    $this$structure.w70(getKClass(OntologyImport_1), $this$structure.t70() ? getKClass(TypedOntologyImportImpl) : getKClass(OntologyImportImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_101 = OntologyImportRootConcept_getInstance();
    $this$structure.v70(getKClass(OntologyImportRoot_1), descriptor_101);
    $this$structure.w70(getKClass(OntologyImportRoot_1), $this$structure.t70() ? getKClass(TypedOntologyImportRootImpl) : getKClass(OntologyImportRootImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_102 = OntologyImportRootReferenceConcept_getInstance();
    $this$structure.v70(getKClass(OntologyImportRootReference_1), descriptor_102);
    $this$structure.w70(getKClass(OntologyImportRootReference_1), $this$structure.t70() ? getKClass(TypedOntologyImportRootReferenceImpl) : getKClass(OntologyImportRootReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_103 = OntologyIsRelationConcept_getInstance();
    $this$structure.v70(getKClass(OntologyIsRelation_1), descriptor_103);
    $this$structure.w70(getKClass(OntologyIsRelation_1), $this$structure.t70() ? getKClass(TypedOntologyIsRelationImpl) : getKClass(OntologyIsRelationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_104 = OntologyLibraryConcept_getInstance();
    $this$structure.v70(getKClass(OntologyLibrary_1), descriptor_104);
    $this$structure.w70(getKClass(OntologyLibrary_1), $this$structure.t70() ? getKClass(TypedOntologyLibraryImpl) : getKClass(OntologyLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_105 = OntologyLibraryReferenceConcept_getInstance();
    $this$structure.v70(getKClass(OntologyLibraryReference_1), descriptor_105);
    $this$structure.w70(getKClass(OntologyLibraryReference_1), $this$structure.t70() ? getKClass(TypedOntologyLibraryReferenceImpl) : getKClass(OntologyLibraryReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_106 = OntologyLinkConcept_getInstance();
    $this$structure.v70(getKClass(OntologyLink_1), descriptor_106);
    $this$structure.w70(getKClass(OntologyLink_1), $this$structure.t70() ? getKClass(TypedOntologyLinkImpl) : getKClass(OntologyLinkImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_107 = OntologyLinkDeclarationValueQueryConcept_getInstance();
    $this$structure.v70(getKClass(OntologyLinkDeclarationValueQuery_1), descriptor_107);
    $this$structure.w70(getKClass(OntologyLinkDeclarationValueQuery_1), $this$structure.t70() ? getKClass(TypedOntologyLinkDeclarationValueQueryImpl) : getKClass(OntologyLinkDeclarationValueQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_108 = OntologyLinkValueConcept_getInstance();
    $this$structure.v70(getKClass(OntologyLinkValue_1), descriptor_108);
    $this$structure.w70(getKClass(OntologyLinkValue_1), $this$structure.t70() ? getKClass(TypedOntologyLinkValueImpl) : getKClass(OntologyLinkValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_109 = OrValueQueryConcept_getInstance();
    $this$structure.v70(getKClass(OrValueQuery_1), descriptor_109);
    $this$structure.w70(getKClass(OrValueQuery_1), $this$structure.t70() ? getKClass(TypedOrValueQueryImpl) : getKClass(OrValueQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_110 = PageConcept_getInstance();
    $this$structure.v70(getKClass(Page_1), descriptor_110);
    $this$structure.w70(getKClass(Page_1), $this$structure.t70() ? getKClass(TypedPageImpl) : getKClass(PageImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_111 = PageRangeConcept_getInstance();
    $this$structure.v70(getKClass(PageRange_1), descriptor_111);
    $this$structure.w70(getKClass(PageRange_1), $this$structure.t70() ? getKClass(TypedPageRangeImpl) : getKClass(PageRangeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_112 = PageSpecificationConcept_getInstance();
    $this$structure.v70(getKClass(PageSpecification), descriptor_112);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_113 = PaperConcept_getInstance();
    $this$structure.v70(getKClass(Paper_1), descriptor_113);
    $this$structure.w70(getKClass(Paper_1), $this$structure.t70() ? getKClass(TypedPaperImpl) : getKClass(PaperImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_114 = PartReferenceOperationConcept_getInstance();
    $this$structure.v70(getKClass(PartReferenceOperation), descriptor_114);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_115 = PartValueConcept_getInstance();
    $this$structure.v70(getKClass(PartValue), descriptor_115);
    $this$structure.w70(getKClass(PartValue), $this$structure.t70() ? getKClass(TypedPartValueImpl) : getKClass(PartValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_116 = PreconditionConcept_getInstance();
    $this$structure.v70(getKClass(Precondition), descriptor_116);
    $this$structure.w70(getKClass(Precondition), $this$structure.t70() ? getKClass(TypedPreconditionImpl) : getKClass(PreconditionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_117 = ProcessDeclarationConcept_getInstance();
    $this$structure.v70(getKClass(ProcessDeclaration_1), descriptor_117);
    $this$structure.w70(getKClass(ProcessDeclaration_1), $this$structure.t70() ? getKClass(TypedProcessDeclarationImpl) : getKClass(ProcessDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_118 = ProcessEffectConcept_getInstance();
    $this$structure.v70(getKClass(ProcessEffect_0), descriptor_118);
    $this$structure.w70(getKClass(ProcessEffect_0), $this$structure.t70() ? getKClass(TypedProcessEffectImpl) : getKClass(ProcessEffectImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_119 = ProcessKindConcept_getInstance();
    $this$structure.v70(getKClass(ProcessKind_1), descriptor_119);
    $this$structure.w70(getKClass(ProcessKind_1), $this$structure.t70() ? getKClass(TypedProcessKindImpl) : getKClass(ProcessKindImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_120 = ProcessKindContainerConcept_getInstance();
    $this$structure.v70(getKClass(ProcessKindContainer_1), descriptor_120);
    $this$structure.w70(getKClass(ProcessKindContainer_1), $this$structure.t70() ? getKClass(TypedProcessKindContainerImpl) : getKClass(ProcessKindContainerImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_121 = ProcessLibraryConcept_getInstance();
    $this$structure.v70(getKClass(ProcessLibrary_1), descriptor_121);
    $this$structure.w70(getKClass(ProcessLibrary_1), $this$structure.t70() ? getKClass(TypedProcessLibraryImpl) : getKClass(ProcessLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_122 = ProcessPrerequisiteConcept_getInstance();
    $this$structure.v70(getKClass(ProcessPrerequisite_0), descriptor_122);
    $this$structure.w70(getKClass(ProcessPrerequisite_0), $this$structure.t70() ? getKClass(TypedProcessPrerequisiteImpl) : getKClass(ProcessPrerequisiteImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_123 = ProcessPropertyConcept_getInstance();
    $this$structure.v70(getKClass(ProcessProperty_1), descriptor_123);
    $this$structure.w70(getKClass(ProcessProperty_1), $this$structure.t70() ? getKClass(TypedProcessPropertyImpl) : getKClass(ProcessPropertyImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_124 = ProcessPropertyCustomCellConcept_getInstance();
    $this$structure.v70(getKClass(ProcessPropertyCustomCell_1), descriptor_124);
    $this$structure.w70(getKClass(ProcessPropertyCustomCell_1), $this$structure.t70() ? getKClass(TypedProcessPropertyCustomCellImpl) : getKClass(ProcessPropertyCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_125 = ProcessPropertyDefaultConcept_getInstance();
    $this$structure.v70(getKClass(ProcessPropertyDefault_1), descriptor_125);
    $this$structure.w70(getKClass(ProcessPropertyDefault_1), $this$structure.t70() ? getKClass(TypedProcessPropertyDefaultImpl) : getKClass(ProcessPropertyDefaultImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_126 = ProcessPropertyReferenceConcept_getInstance();
    $this$structure.v70(getKClass(ProcessPropertyReference), descriptor_126);
    $this$structure.w70(getKClass(ProcessPropertyReference), $this$structure.t70() ? getKClass(TypedProcessPropertyReferenceImpl) : getKClass(ProcessPropertyReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_127 = ProcessPropertyValueConcept_getInstance();
    $this$structure.v70(getKClass(ProcessPropertyValue_1), descriptor_127);
    $this$structure.w70(getKClass(ProcessPropertyValue_1), $this$structure.t70() ? getKClass(TypedProcessPropertyValueImpl) : getKClass(ProcessPropertyValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_128 = ProcessReferenceConcept_getInstance();
    $this$structure.v70(getKClass(ProcessReference_1), descriptor_128);
    $this$structure.w70(getKClass(ProcessReference_1), $this$structure.t70() ? getKClass(TypedProcessReferenceImpl) : getKClass(ProcessReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_129 = ProcessRelationDeclarationConcept_getInstance();
    $this$structure.v70(getKClass(ProcessRelationDeclaration_1), descriptor_129);
    $this$structure.w70(getKClass(ProcessRelationDeclaration_1), $this$structure.t70() ? getKClass(TypedProcessRelationDeclarationImpl) : getKClass(ProcessRelationDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_130 = ProcessTypeConcept_getInstance();
    $this$structure.v70(getKClass(ProcessType_1), descriptor_130);
    $this$structure.w70(getKClass(ProcessType_1), $this$structure.t70() ? getKClass(TypedProcessTypeImpl) : getKClass(ProcessTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_131 = PropertiesCustomCellConcept_getInstance();
    $this$structure.v70(getKClass(PropertiesCustomCell_1), descriptor_131);
    $this$structure.w70(getKClass(PropertiesCustomCell_1), $this$structure.t70() ? getKClass(TypedPropertiesCustomCellImpl) : getKClass(PropertiesCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_132 = PropertyConstraintConcept_getInstance();
    $this$structure.v70(getKClass(PropertyConstraint_1), descriptor_132);
    $this$structure.w70(getKClass(PropertyConstraint_1), $this$structure.t70() ? getKClass(TypedPropertyConstraintImpl) : getKClass(PropertyConstraintImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_133 = PropertyCustomCellConcept_getInstance();
    $this$structure.v70(getKClass(PropertyCustomCell_1), descriptor_133);
    $this$structure.w70(getKClass(PropertyCustomCell_1), $this$structure.t70() ? getKClass(TypedPropertyCustomCellImpl) : getKClass(PropertyCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_134 = PropertyDeclarationConcept_getInstance();
    $this$structure.v70(getKClass(PropertyDeclaration_1), descriptor_134);
    $this$structure.w70(getKClass(PropertyDeclaration_1), $this$structure.t70() ? getKClass(TypedPropertyDeclarationImpl) : getKClass(PropertyDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_135 = PropertyDeclarationValueQueryConcept_getInstance();
    $this$structure.v70(getKClass(PropertyDeclarationValueQuery_1), descriptor_135);
    $this$structure.w70(getKClass(PropertyDeclarationValueQuery_1), $this$structure.t70() ? getKClass(TypedPropertyDeclarationValueQueryImpl) : getKClass(PropertyDeclarationValueQueryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_136 = PropertyLibraryConcept_getInstance();
    $this$structure.v70(getKClass(PropertyLibrary_1), descriptor_136);
    $this$structure.w70(getKClass(PropertyLibrary_1), $this$structure.t70() ? getKClass(TypedPropertyLibraryImpl) : getKClass(PropertyLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_137 = PropertyReferenceOperationConcept_getInstance();
    $this$structure.v70(getKClass(PropertyReferenceOperation_1), descriptor_137);
    $this$structure.w70(getKClass(PropertyReferenceOperation_1), $this$structure.t70() ? getKClass(TypedPropertyReferenceOperationImpl) : getKClass(PropertyReferenceOperationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_138 = PropertyStubConcept_getInstance();
    $this$structure.v70(getKClass(PropertyStub), descriptor_138);
    $this$structure.w70(getKClass(PropertyStub), $this$structure.t70() ? getKClass(TypedPropertyStubImpl) : getKClass(PropertyStubImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_139 = PropertyValueConcept_getInstance();
    $this$structure.v70(getKClass(PropertyValue_1), descriptor_139);
    $this$structure.w70(getKClass(PropertyValue_1), $this$structure.t70() ? getKClass(TypedPropertyValueImpl) : getKClass(PropertyValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_140 = PropertyValueRangeConcept_getInstance();
    $this$structure.v70(getKClass(PropertyValueRange), descriptor_140);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_141 = PubMedSourceReferenceConcept_getInstance();
    $this$structure.v70(getKClass(PubMedSourceReference_1), descriptor_141);
    $this$structure.w70(getKClass(PubMedSourceReference_1), $this$structure.t70() ? getKClass(TypedPubMedSourceReferenceImpl) : getKClass(PubMedSourceReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_142 = PublishedSourceReferenceConcept_getInstance();
    $this$structure.v70(getKClass(PublishedSourceReference_1), descriptor_142);
    $this$structure.w70(getKClass(PublishedSourceReference_1), $this$structure.t70() ? getKClass(TypedPublishedSourceReferenceImpl) : getKClass(PublishedSourceReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_143 = PublishedSourcesLibraryConcept_getInstance();
    $this$structure.v70(getKClass(PublishedSourcesLibrary_1), descriptor_143);
    $this$structure.w70(getKClass(PublishedSourcesLibrary_1), $this$structure.t70() ? getKClass(TypedPublishedSourcesLibraryImpl) : getKClass(PublishedSourcesLibraryImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_144 = PublishedWorkConcept_getInstance();
    $this$structure.v70(getKClass(PublishedWork), descriptor_144);
    $this$structure.w70(getKClass(PublishedWork), $this$structure.t70() ? getKClass(TypedPublishedWorkImpl) : getKClass(PublishedWorkImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_145 = QualifiedOntologyElementReferenceConcept_getInstance();
    $this$structure.v70(getKClass(QualifiedOntologyElementReference_1), descriptor_145);
    $this$structure.w70(getKClass(QualifiedOntologyElementReference_1), $this$structure.t70() ? getKClass(TypedQualifiedOntologyElementReferenceImpl) : getKClass(QualifiedOntologyElementReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_146 = QueryCommandsConcept_getInstance();
    $this$structure.v70(getKClass(QueryCommands_1), descriptor_146);
    $this$structure.w70(getKClass(QueryCommands_1), $this$structure.t70() ? getKClass(TypedQueryCommandsImpl) : getKClass(QueryCommandsImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_147 = QueryLabelsFactExpressionContainerConcept_getInstance();
    $this$structure.v70(getKClass(QueryLabelsFactExpressionContainer_1), descriptor_147);
    $this$structure.w70(getKClass(QueryLabelsFactExpressionContainer_1), $this$structure.t70() ? getKClass(TypedQueryLabelsFactExpressionContainerImpl) : getKClass(QueryLabelsFactExpressionContainerImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_148 = QueryParametersBlackListConcept_getInstance();
    $this$structure.v70(getKClass(QueryParametersBlackList), descriptor_148);
    $this$structure.w70(getKClass(QueryParametersBlackList), $this$structure.t70() ? getKClass(TypedQueryParametersBlackListImpl) : getKClass(QueryParametersBlackListImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_149 = RelationContainerConcept_getInstance();
    $this$structure.v70(getKClass(RelationContainer_1), descriptor_149);
    $this$structure.w70(getKClass(RelationContainer_1), $this$structure.t70() ? getKClass(TypedRelationContainerImpl) : getKClass(RelationContainerImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_150 = RelationFactExpressionConcept_getInstance();
    $this$structure.v70(getKClass(RelationFactExpression_1), descriptor_150);
    $this$structure.w70(getKClass(RelationFactExpression_1), $this$structure.t70() ? getKClass(TypedRelationFactExpressionImpl) : getKClass(RelationFactExpressionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_151 = ReturnTypeCustomCellConcept_getInstance();
    $this$structure.v70(getKClass(ReturnTypeCustomCell_1), descriptor_151);
    $this$structure.w70(getKClass(ReturnTypeCustomCell_1), $this$structure.t70() ? getKClass(TypedReturnTypeCustomCellImpl) : getKClass(ReturnTypeCustomCellImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_152 = SetExpressionConcept_getInstance();
    $this$structure.v70(getKClass(SetExpression_1), descriptor_152);
    $this$structure.w70(getKClass(SetExpression_1), $this$structure.t70() ? getKClass(TypedSetExpressionImpl) : getKClass(SetExpressionImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_153 = SetValuedPropertyParameterConcept_getInstance();
    $this$structure.v70(getKClass(SetValuedPropertyParameter_1), descriptor_153);
    $this$structure.w70(getKClass(SetValuedPropertyParameter_1), $this$structure.t70() ? getKClass(TypedSetValuedPropertyParameterImpl) : getKClass(SetValuedPropertyParameterImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_154 = SimplePropertyTypeConcept_getInstance();
    $this$structure.v70(getKClass(SimplePropertyType), descriptor_154);
    $this$structure.w70(getKClass(SimplePropertyType), $this$structure.t70() ? getKClass(TypedSimplePropertyTypeImpl) : getKClass(SimplePropertyTypeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_155 = SinglePropertyValueRangeConcept_getInstance();
    $this$structure.v70(getKClass(SinglePropertyValueRange_1), descriptor_155);
    $this$structure.w70(getKClass(SinglePropertyValueRange_1), $this$structure.t70() ? getKClass(TypedSinglePropertyValueRangeImpl) : getKClass(SinglePropertyValueRangeImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_156 = TextLineConcept_getInstance();
    $this$structure.v70(getKClass(TextLine), descriptor_156);
    $this$structure.w70(getKClass(TextLine), $this$structure.t70() ? getKClass(TypedTextLineImpl) : getKClass(TextLineImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_157 = TypeConcept_getInstance();
    $this$structure.v70(getKClass(Type), descriptor_157);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_158 = TypePlaceholderConcept_getInstance();
    $this$structure.v70(getKClass(TypePlaceholder_1), descriptor_158);
    $this$structure.w70(getKClass(TypePlaceholder_1), $this$structure.t70() ? getKClass(TypedTypePlaceholderImpl) : getKClass(TypePlaceholderImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_159 = UnionClassConcept_getInstance();
    $this$structure.v70(getKClass(UnionClass_1), descriptor_159);
    $this$structure.w70(getKClass(UnionClass_1), $this$structure.t70() ? getKClass(TypedUnionClassImpl) : getKClass(UnionClassImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_160 = UrlKnowledgeSourceReferenceConcept_getInstance();
    $this$structure.v70(getKClass(UrlKnowledgeSourceReference_1), descriptor_160);
    $this$structure.w70(getKClass(UrlKnowledgeSourceReference_1), $this$structure.t70() ? getKClass(TypedUrlKnowledgeSourceReferenceImpl) : getKClass(UrlKnowledgeSourceReferenceImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_161 = ValueWithRelationsConcept_getInstance();
    $this$structure.v70(getKClass(ValueWithRelations_1), descriptor_161);
    $this$structure.w70(getKClass(ValueWithRelations_1), $this$structure.t70() ? getKClass(TypedValueWithRelationsImpl) : getKClass(ValueWithRelationsImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_162 = VariableDeclarationConcept_getInstance();
    $this$structure.v70(getKClass(VariableDeclaration_1), descriptor_162);
    $this$structure.w70(getKClass(VariableDeclaration_1), $this$structure.t70() ? getKClass(TypedVariableDeclarationImpl) : getKClass(VariableDeclarationImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_163 = VariableInitializerConcept_getInstance();
    $this$structure.v70(getKClass(VariableInitializer), descriptor_163);
    $this$structure.w70(getKClass(VariableInitializer), $this$structure.t70() ? getKClass(TypedVariableInitializerImpl) : getKClass(VariableInitializerImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_164 = VariableReferenceValueConcept_getInstance();
    $this$structure.v70(getKClass(VariableReferenceValue_1), descriptor_164);
    $this$structure.w70(getKClass(VariableReferenceValue_1), $this$structure.t70() ? getKClass(TypedVariableReferenceValueImpl) : getKClass(VariableReferenceValueImpl));
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_165 = VariableSpecificationConcept_getInstance();
    $this$structure.v70(getKClass(VariableSpecification), descriptor_165);
    // Inline function 'jetbrains.ocelot.langDef.structure.config.concept' call
    var descriptor_166 = XRefContainerConcept_getInstance();
    $this$structure.v70(getKClass(XRefContainer), descriptor_166);
    $this$structure.w70(getKClass(XRefContainer), $this$structure.t70() ? getKClass(TypedXRefContainerImpl) : getKClass(XRefContainerImpl));
    return Unit_instance;
  }
  function AbstractBindingDeclarationImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
    this.ocr_1 = this.j6n(AbstractBindingDeclarationConcept_getInstance().eas_1);
    this.pcr_1 = this.j6n(AbstractBindingDeclarationConcept_getInstance().fas_1);
    this.qcr_1 = this.j6n(AbstractBindingDeclarationConcept_getInstance().gas_1);
    this.rcr_1 = this.f6n(AbstractBindingDeclarationConcept_getInstance().has_1);
    this.scr_1 = this.c6n(AbstractBindingDeclarationConcept_getInstance().ias_1);
    this.tcr_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
    this.ucr_1 = this.f6n(HasCommentsConcept_getInstance().abb_1);
  }
  protoOf(AbstractBindingDeclarationImpl).oas = function () {
    return this.ocr_1;
  };
  protoOf(AbstractBindingDeclarationImpl).w = function () {
    return this.pcr_1;
  };
  protoOf(AbstractBindingDeclarationImpl).pas = function () {
    return this.qcr_1;
  };
  protoOf(AbstractBindingDeclarationImpl).qas = function () {
    return this.rcr_1;
  };
  protoOf(AbstractBindingDeclarationImpl).ras = function () {
    return this.scr_1;
  };
  protoOf(AbstractBindingDeclarationImpl).b3 = function () {
    return this.tcr_1;
  };
  protoOf(AbstractBindingDeclarationImpl).cbb = function () {
    return this.ucr_1;
  };
  function AbstractBindingEntryImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function AbstractBindingValueImpl(context, node) {
    BindingValuePlaceholderImpl.call(this, context, node);
    this.ycr_1 = this.f6n(AbstractBindingValueConcept_getInstance().yas_1);
  }
  protoOf(AbstractBindingValueImpl).y = function () {
    return this.ycr_1;
  };
  function AbstractBindingValueQueryImpl(context, node) {
    BindingValuePlaceholderQueryImpl.call(this, context, node);
  }
  function AbstractLinkImpl(context, node) {
    AbstractBindingEntryImpl.call(this, context, node);
    this.ccs_1 = context.j6p(AbstractLinkConcept_getInstance().hat_1, this);
  }
  protoOf(AbstractLinkImpl).jat = function () {
    return this.ccs_1;
  };
  function AbstractNotionImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
    this.gcs_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(AbstractNotionImpl).b3 = function () {
    return this.gcs_1;
  };
  function AbstractOntologyRelationImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function AbstractProcessSpecificationImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function AbstractPropertyImpl(context, node) {
    AbstractBindingEntryImpl.call(this, context, node);
  }
  function AuthorImpl(context, node) {
    node = node === VOID ? new Node_0(AuthorConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.kcs_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(AuthorImpl).b3 = function () {
    return this.kcs_1;
  };
  function AuthoredWorkImpl(context, node) {
    node = node === VOID ? new Node_0(AuthoredWorkConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ocs_1 = this.j6n(AuthoredWorkConcept_getInstance().uat_1);
    this.pcs_1 = this.x6m(AuthoredWorkConcept_getInstance().vat_1);
  }
  protoOf(AuthoredWorkImpl).yat = function () {
    return this.ocs_1;
  };
  protoOf(AuthoredWorkImpl).zat = function () {
    return this.pcs_1;
  };
  function BTBDocumentImpl(context, node) {
    node = node === VOID ? new Node_0(BTBDocumentConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.vcs_1 = this.i6n(BTBDocumentConcept_getInstance().kau_1);
    this.wcs_1 = this.i6n(BTBDocumentConcept_getInstance().lau_1);
    this.xcs_1 = this.i6n(BTBDocumentConcept_getInstance().mau_1);
  }
  protoOf(BTBDocumentImpl).qau = function () {
    return this.vcs_1;
  };
  protoOf(BTBDocumentImpl).rau = function () {
    return this.wcs_1;
  };
  protoOf(BTBDocumentImpl).sau = function () {
    return this.xcs_1;
  };
  function BindingPropertyImpl(context, node) {
    node = node === VOID ? new Node_0(BindingPropertyConcept_getInstance().e6r_1) : node;
    AbstractPropertyImpl.call(this, context, node);
    this.hct_1 = this.e6n(BindingPropertyConcept_getInstance().dav_1);
  }
  protoOf(BindingPropertyImpl).i6u = function () {
    return this.hct_1;
  };
  function BindingValueMaskImpl(context, node) {
    node = node === VOID ? new Node_0(BindingValueMaskConcept_getInstance().e6r_1) : node;
    AbstractBindingValueQueryImpl.call(this, context, node);
    this.lct_1 = this.e6n(BindingValueMaskConcept_getInstance().pav_1);
  }
  protoOf(BindingValueMaskImpl).y = function () {
    return this.lct_1;
  };
  function BindingValuePlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(BindingValuePlaceholderConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function BindingValuePlaceholderQueryImpl(context, node) {
    node = node === VOID ? new Node_0(BindingValuePlaceholderQueryConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function BookImpl(context, node) {
    node = node === VOID ? new Node_0(BookConcept_getInstance().e6r_1) : node;
    PublishedWorkImpl.call(this, context, node);
    this.uct_1 = this.x6m(BookConcept_getInstance().baw_1);
  }
  protoOf(BookImpl).daw = function () {
    return this.uct_1;
  };
  function CardinalityBoundConstantImpl(context, node) {
    node = node === VOID ? new Node_0(CardinalityBoundConstantConcept_getInstance().e6r_1) : node;
    CardinalityBoundImpl.call(this, context, node);
    this.hcu_1 = this.y6m(CardinalityBoundConstantConcept_getInstance().oaw_1);
  }
  protoOf(CardinalityBoundConstantImpl).y = function () {
    return this.hcu_1;
  };
  function CardinalityBoundImpl(context, node) {
    node = node === VOID ? new Node_0(CardinalityBoundConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function CardinalityBoundNImpl(context, node) {
    node = node === VOID ? new Node_0(CardinalityBoundNConcept_getInstance().e6r_1) : node;
    CardinalityBoundImpl.call(this, context, node);
  }
  function CardinalityBoundPlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(CardinalityBoundPlaceholderConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.lcu_1 = this.e6n(CardinalityBoundPlaceholderConcept_getInstance().aax_1);
  }
  protoOf(CardinalityBoundPlaceholderImpl).cax = function () {
    return this.lcu_1;
  };
  function CardinalityCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(CardinalityCustomCellConcept_getInstance().e6r_1) : node;
    CustomCellImpl.call(this, context, node);
  }
  function CardinalityImpl(context, node) {
    node = node === VOID ? new Node_0(CardinalityConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.pcu_1 = this.e6n(CardinalityConcept_getInstance().nax_1);
    this.qcu_1 = this.e6n(CardinalityConcept_getInstance().oax_1);
    this.rcu_1 = this.e6n(CardinalityConcept_getInstance().pax_1);
  }
  protoOf(CardinalityImpl).tax = function () {
    return this.pcu_1;
  };
  protoOf(CardinalityImpl).uax = function () {
    return this.qcu_1;
  };
  protoOf(CardinalityImpl).vax = function () {
    return this.rcu_1;
  };
  function CategoryImpl(context, node) {
    node = node === VOID ? new Node_0(CategoryConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.vcu_1 = this.e6n(CategoryConcept_getInstance().gay_1);
    this.wcu_1 = this.e6n(CategoryConcept_getInstance().hay_1);
  }
  protoOf(CategoryImpl).kay = function () {
    return this.vcu_1;
  };
  protoOf(CategoryImpl).lay = function () {
    return this.wcu_1;
  };
  function ClassExpressionPlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(ClassExpressionPlaceholderConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function ClassExpressionTypeImpl(context, node) {
    node = node === VOID ? new Node_0(ClassExpressionTypeConcept_getInstance().e6r_1) : node;
    TypeImpl.call(this, context, node);
    this.acv_1 = this.f6n(ClassExpressionTypeConcept_getInstance().way_1);
  }
  protoOf(ClassExpressionTypeImpl).yay = function () {
    return this.acv_1;
  };
  function CommandImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function ConstantCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(ConstantCustomCellConcept_getInstance().e6r_1) : node;
    CustomCellImpl.call(this, context, node);
    this.ecv_1 = this.x6m(ConstantCustomCellConcept_getInstance().jaz_1);
  }
  protoOf(ConstantCustomCellImpl).laz = function () {
    return this.ecv_1;
  };
  function ConstantPreconditionImpl(context, node) {
    node = node === VOID ? new Node_0(ConstantPreconditionConcept_getInstance().e6r_1) : node;
    PreconditionImpl.call(this, context, node);
    this.icv_1 = this.b6n(ConstantPreconditionConcept_getInstance().xaz_1, ConstantPreconditionConcept_getInstance().yaz_1);
  }
  protoOf(ConstantPreconditionImpl).r5e = function () {
    return this.icv_1;
  };
  function ContextImpl(context, node) {
    node = node === VOID ? new Node_0(ContextConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.mcv_1 = this.e6n(ContextConcept_getInstance().kb0_1);
    this.ncv_1 = this.e6n(ContextConcept_getInstance().lb0_1);
    this.ocv_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(ContextImpl).kay = function () {
    return this.mcv_1;
  };
  protoOf(ContextImpl).lay = function () {
    return this.ncv_1;
  };
  protoOf(ContextImpl).b3 = function () {
    return this.ocv_1;
  };
  function ContextQueryImpl(context, node) {
    node = node === VOID ? new Node_0(ContextQueryConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.scv_1 = this.e6n(ContextQueryConcept_getInstance().yb0_1);
    this.tcv_1 = this.e6n(ContextQueryConcept_getInstance().zb0_1);
  }
  protoOf(ContextQueryImpl).kay = function () {
    return this.scv_1;
  };
  protoOf(ContextQueryImpl).lay = function () {
    return this.tcv_1;
  };
  function CustomCellImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function CustomEditorImpl(context, node) {
    node = node === VOID ? new Node_0(CustomEditorConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.xcv_1 = this.i6n(CustomEditorConcept_getInstance().mb1_1);
  }
  protoOf(CustomEditorImpl).ob1 = function () {
    return this.xcv_1;
  };
  function DeclarationNameCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(DeclarationNameCustomCellConcept_getInstance().e6r_1) : node;
    CustomCellImpl.call(this, context, node);
  }
  function DeclarationValueQueryImpl(context, node) {
    node = node === VOID ? new Node_0(DeclarationValueQueryConcept_getInstance().e6r_1) : node;
    AbstractBindingValueQueryImpl.call(this, context, node);
    this.bcw_1 = this.e6n(DeclarationValueQueryConcept_getInstance().zb1_1);
  }
  protoOf(DeclarationValueQueryImpl).y = function () {
    return this.bcw_1;
  };
  function DocumentNodeImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
    this.bct_1 = get_forQueries(new ValueProperty(''));
    this.cct_1 = get_forQueries(new ValueProperty(''));
  }
  protoOf(DocumentNodeImpl).w6j = function () {
    return this.bct_1;
  };
  protoOf(DocumentNodeImpl).b3 = function () {
    return this.cct_1;
  };
  function EmptyBindingEntryImpl(context, node) {
    node = node === VOID ? new Node_0(EmptyBindingEntryConcept_getInstance().e6r_1) : node;
    AbstractBindingEntryImpl.call(this, context, node);
  }
  function EmptyPropertyLibraryElementImpl(context, node) {
    node = node === VOID ? new Node_0(EmptyPropertyLibraryElementConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function EnumValueImpl(context, node) {
    node = node === VOID ? new Node_0(EnumValueConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.fcw_1 = context.j6p(EnumValueConcept_getInstance().ub2_1, this);
  }
  protoOf(EnumValueImpl).wb2 = function () {
    return this.fcw_1;
  };
  function EnumerableNotionImpl(context, node) {
    node = node === VOID ? new Node_0(EnumerableNotionConcept_getInstance().e6r_1) : node;
    AbstractNotionImpl.call(this, context, node);
    this.lcw_1 = this.i6n(EnumerableNotionConcept_getInstance().hb3_1);
  }
  protoOf(EnumerableNotionImpl).jb3 = function () {
    return this.lcw_1;
  };
  function EnumerationConstantImpl(context, node) {
    node = node === VOID ? new Node_0(EnumerationConstantConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.pcw_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(EnumerationConstantImpl).b3 = function () {
    return this.pcw_1;
  };
  function ExtensionDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(ExtensionDeclarationConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.tcw_1 = this.j6n(ExtensionDeclarationConcept_getInstance().ub3_1);
    this.ucw_1 = this.f6n(ExtensionDeclarationConcept_getInstance().vb3_1);
    this.vcw_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(ExtensionDeclarationImpl).yb3 = function () {
    return this.tcw_1;
  };
  protoOf(ExtensionDeclarationImpl).zb3 = function () {
    return this.ucw_1;
  };
  protoOf(ExtensionDeclarationImpl).b3 = function () {
    return this.vcw_1;
  };
  function ExtensionFieldReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(ExtensionFieldReferenceConcept_getInstance().e6r_1) : node;
    PartReferenceOperationImpl.call(this, context, node);
    this.zcw_1 = context.j6p(ExtensionFieldReferenceConcept_getInstance().lb4_1, this);
  }
  protoOf(ExtensionFieldReferenceImpl).nb4 = function () {
    return this.zcw_1;
  };
  function ExtensionLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(ExtensionLibraryConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.fcx_1 = this.i6n(ExtensionLibraryConcept_getInstance().yb4_1);
  }
  protoOf(ExtensionLibraryImpl).n9c = function () {
    return this.fcx_1;
  };
  function FactExpressionPlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(FactExpressionPlaceholderConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function FactImpl(context, node) {
    node = node === VOID ? new Node_0(FactConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.jcx_1 = this.e6n(FactConcept_getInstance().kb5_1);
    this.kcx_1 = this.e6n(FactConcept_getInstance().lb5_1);
    this.lcx_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(FactImpl).ob5 = function () {
    return this.jcx_1;
  };
  protoOf(FactImpl).pb5 = function () {
    return this.kcx_1;
  };
  protoOf(FactImpl).b3 = function () {
    return this.lcx_1;
  };
  function FactPreconditionImpl(context, node) {
    node = node === VOID ? new Node_0(FactPreconditionConcept_getInstance().e6r_1) : node;
    PreconditionImpl.call(this, context, node);
    this.pcx_1 = this.i6n(FactPreconditionConcept_getInstance().ab6_1);
    this.qcx_1 = context.j6p(FactPreconditionConcept_getInstance().bb6_1, this);
  }
  protoOf(FactPreconditionImpl).fb6 = function () {
    return this.pcx_1;
  };
  protoOf(FactPreconditionImpl).gb6 = function () {
    return this.qcx_1;
  };
  function FactReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(FactReferenceConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ucx_1 = context.j6p(FactReferenceConcept_getInstance().sb6_1, this);
  }
  protoOf(FactReferenceImpl).ub6 = function () {
    return this.ucx_1;
  };
  function FactSetImpl(context, node) {
    node = node === VOID ? new Node_0(FactSetConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ycx_1 = this.f6n(FactSetConcept_getInstance().fb7_1);
    this.zcx_1 = this.j6n(FactSetConcept_getInstance().gb7_1);
    this.acy_1 = this.i6n(FactSetConcept_getInstance().hb7_1);
    this.bcy_1 = this.j6n(FactSetConcept_getInstance().ib7_1);
    this.ccy_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
    this.dcy_1 = this.j6n(HasKnowledgeSourcesConcept_getInstance().sbb_1);
    this.ecy_1 = this.f6n(HasCommentsConcept_getInstance().abb_1);
    this.fcy_1 = this.j6n(HasVariablesConcept_getInstance().wbc_1);
  }
  protoOf(FactSetImpl).nb7 = function () {
    return this.ycx_1;
  };
  protoOf(FactSetImpl).ob7 = function () {
    return this.zcx_1;
  };
  protoOf(FactSetImpl).fb6 = function () {
    return this.acy_1;
  };
  protoOf(FactSetImpl).pb7 = function () {
    return this.bcy_1;
  };
  protoOf(FactSetImpl).b3 = function () {
    return this.ccy_1;
  };
  protoOf(FactSetImpl).ubb = function () {
    return this.dcy_1;
  };
  protoOf(FactSetImpl).cbb = function () {
    return this.ecy_1;
  };
  protoOf(FactSetImpl).ybc = function () {
    return this.fcy_1;
  };
  function FieldDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(FieldDeclarationConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.jcy_1 = this.e6n(FieldDeclarationConcept_getInstance().ab8_1);
    this.kcy_1 = this.e6n(FieldDeclarationConcept_getInstance().bb8_1);
    this.lcy_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(FieldDeclarationImpl).zb3 = function () {
    return this.jcy_1;
  };
  protoOf(FieldDeclarationImpl).eb8 = function () {
    return this.kcy_1;
  };
  protoOf(FieldDeclarationImpl).b3 = function () {
    return this.lcy_1;
  };
  function FindConnectionCommandImpl(context, node) {
    node = node === VOID ? new Node_0(FindConnectionCommandConcept_getInstance().e6r_1) : node;
    CommandImpl.call(this, context, node);
    this.pcy_1 = this.e6n(FindConnectionCommandConcept_getInstance().pb8_1);
    this.qcy_1 = this.e6n(FindConnectionCommandConcept_getInstance().qb8_1);
    this.rcy_1 = this.e6n(FindConnectionCommandConcept_getInstance().rb8_1);
  }
  protoOf(FindConnectionCommandImpl).vb8 = function () {
    return this.pcy_1;
  };
  protoOf(FindConnectionCommandImpl).g3x = function () {
    return this.qcy_1;
  };
  protoOf(FindConnectionCommandImpl).h3x = function () {
    return this.rcy_1;
  };
  function FunctionDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(FunctionDeclarationConcept_getInstance().e6r_1) : node;
    AbstractBindingDeclarationImpl.call(this, context, node);
    this.ccz_1 = this.f6n(FunctionDeclarationConcept_getInstance().gb9_1);
    this.dcz_1 = this.e6n(FunctionDeclarationConcept_getInstance().hb9_1);
  }
  protoOf(FunctionDeclarationImpl).kb9 = function () {
    return this.ccz_1;
  };
  protoOf(FunctionDeclarationImpl).eb8 = function () {
    return this.dcz_1;
  };
  function FunctionLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(FunctionLibraryConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.jcz_1 = this.i6n(FunctionLibraryConcept_getInstance().vb9_1);
  }
  protoOf(FunctionLibraryImpl).xb9 = function () {
    return this.jcz_1;
  };
  function FunctionTermImpl(context, node) {
    node = node === VOID ? new Node_0(FunctionTermConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ncz_1 = context.j6p(FunctionTermConcept_getInstance().kba_1, this);
    this.ocz_1 = this.b6n(FunctionTermConcept_getInstance().lba_1, FunctionTermConcept_getInstance().nba_1);
    this.pcz_1 = this.i6n(FunctionTermConcept_getInstance().mba_1);
  }
  protoOf(FunctionTermImpl).rba = function () {
    return this.ncz_1;
  };
  protoOf(FunctionTermImpl).sba = function () {
    return this.ocz_1;
  };
  protoOf(FunctionTermImpl).tba = function () {
    return this.pcz_1;
  };
  function ImportedLinkImpl(context, node) {
    node = node === VOID ? new Node_0(ImportedLinkConcept_getInstance().e6r_1) : node;
    AbstractLinkImpl.call(this, context, node);
    this.ucz_1 = context.j6p(ImportedLinkConcept_getInstance().kbd_1, this);
  }
  protoOf(ImportedLinkImpl).mbd = function () {
    return this.ucz_1;
  };
  function ImportedPropertyImpl(context, node) {
    node = node === VOID ? new Node_0(ImportedPropertyConcept_getInstance().e6r_1) : node;
    AbstractPropertyImpl.call(this, context, node);
    this.ycz_1 = context.j6p(ImportedPropertyConcept_getInstance().ybd_1, this);
  }
  protoOf(ImportedPropertyImpl).mbd = function () {
    return this.ycz_1;
  };
  function InstanceRelationDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(InstanceRelationDeclarationConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.cd0_1 = this.f6n(InstanceRelationDeclarationConcept_getInstance().kbe_1);
    this.dd0_1 = this.f6n(InstanceRelationDeclarationConcept_getInstance().lbe_1);
    this.ed0_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(InstanceRelationDeclarationImpl).obe = function () {
    return this.cd0_1;
  };
  protoOf(InstanceRelationDeclarationImpl).be = function () {
    return this.dd0_1;
  };
  protoOf(InstanceRelationDeclarationImpl).b3 = function () {
    return this.ed0_1;
  };
  function InstanceRelationValueImpl(context, node) {
    node = node === VOID ? new Node_0(InstanceRelationValueConcept_getInstance().e6r_1) : node;
    InstanceRelationValuePlaceholderImpl.call(this, context, node);
    this.id0_1 = this.f6n(InstanceRelationValueConcept_getInstance().zbe_1);
    this.jd0_1 = context.j6p(InstanceRelationValueConcept_getInstance().abf_1, this);
  }
  protoOf(InstanceRelationValueImpl).y = function () {
    return this.id0_1;
  };
  protoOf(InstanceRelationValueImpl).gb6 = function () {
    return this.jd0_1;
  };
  function InstanceRelationValuePlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(InstanceRelationValuePlaceholderConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function IsExpressionImpl(context, node) {
    node = node === VOID ? new Node_0(IsExpressionConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.nd0_1 = this.e6n(IsExpressionConcept_getInstance().obf_1);
    this.od0_1 = this.e6n(IsExpressionConcept_getInstance().pbf_1);
  }
  protoOf(IsExpressionImpl).sbf = function () {
    return this.nd0_1;
  };
  protoOf(IsExpressionImpl).tbf = function () {
    return this.od0_1;
  };
  function KindCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(KindCustomCellConcept_getInstance().e6r_1) : node;
    CustomCellImpl.call(this, context, node);
  }
  function KnowledgeSourceReferenceImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function KnowledgeSourceReferencePlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(KnowledgeSourceReferencePlaceholderConcept_getInstance().e6r_1) : node;
    KnowledgeSourceReferenceImpl.call(this, context, node);
  }
  function LibraryItemPlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(LibraryItemPlaceholderConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function LibraryProcessSpecificationImpl(context, node) {
    node = node === VOID ? new Node_0(LibraryProcessSpecificationConcept_getInstance().e6r_1) : node;
    AbstractProcessSpecificationImpl.call(this, context, node);
    this.sd0_1 = context.j6p(LibraryProcessSpecificationConcept_getInstance().fbg_1, this);
    this.td0_1 = this.i6n(LibraryProcessSpecificationConcept_getInstance().gbg_1);
  }
  protoOf(LibraryProcessSpecificationImpl).jbg = function () {
    return this.sd0_1;
  };
  protoOf(LibraryProcessSpecificationImpl).tba = function () {
    return this.td0_1;
  };
  function LibraryProcessSpecificationQueryImpl(context, node) {
    node = node === VOID ? new Node_0(LibraryProcessSpecificationQueryConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.xd0_1 = context.j6p(LibraryProcessSpecificationQueryConcept_getInstance().wbg_1, this);
    this.yd0_1 = context.j6p(LibraryProcessSpecificationQueryConcept_getInstance().xbg_1, this);
    this.zd0_1 = this.i6n(LibraryProcessSpecificationQueryConcept_getInstance().ybg_1);
  }
  protoOf(LibraryProcessSpecificationQueryImpl).jbg = function () {
    return this.xd0_1;
  };
  protoOf(LibraryProcessSpecificationQueryImpl).r5e = function () {
    return this.yd0_1;
  };
  protoOf(LibraryProcessSpecificationQueryImpl).tba = function () {
    return this.zd0_1;
  };
  function LinkCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(LinkCustomCellConcept_getInstance().e6r_1) : node;
    CustomCellImpl.call(this, context, node);
    this.dd1_1 = context.j6p(LinkCustomCellConcept_getInstance().nbh_1, this);
  }
  protoOf(LinkCustomCellImpl).pbh = function () {
    return this.dd1_1;
  };
  function LinkDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(LinkDeclarationConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.hd1_1 = this.b6n(LinkDeclarationConcept_getInstance().bbi_1, LinkDeclarationConcept_getInstance().dbi_1);
    this.id1_1 = this.e6n(LinkDeclarationConcept_getInstance().cbi_1);
    this.jd1_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(LinkDeclarationImpl).sba = function () {
    return this.hd1_1;
  };
  protoOf(LinkDeclarationImpl).zb3 = function () {
    return this.id1_1;
  };
  protoOf(LinkDeclarationImpl).b3 = function () {
    return this.jd1_1;
  };
  function LinkLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(LinkLibraryConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.pd1_1 = this.i6n(LinkLibraryConcept_getInstance().qbi_1);
  }
  protoOf(LinkLibraryImpl).sbi = function () {
    return this.pd1_1;
  };
  function LocalOntologyElementReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(LocalOntologyElementReferenceConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.td1_1 = context.j6p(LocalOntologyElementReferenceConcept_getInstance().ebj_1, this);
  }
  protoOf(LocalOntologyElementReferenceImpl).lay = function () {
    return this.td1_1;
  };
  function MeasurableNotionImpl(context, node) {
    node = node === VOID ? new Node_0(MeasurableNotionConcept_getInstance().e6r_1) : node;
    AbstractNotionImpl.call(this, context, node);
    this.zd1_1 = this.i6n(MeasurableNotionConcept_getInstance().qbj_1);
  }
  protoOf(MeasurableNotionImpl).sbj = function () {
    return this.zd1_1;
  };
  function MeasurableValueImpl(context, node) {
    node = node === VOID ? new Node_0(MeasurableValueConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.dd2_1 = this.z6m(MeasurableValueConcept_getInstance().dbk_1);
    this.ed2_1 = context.j6p(MeasurableValueConcept_getInstance().ebk_1, this);
  }
  protoOf(MeasurableValueImpl).ibk = function () {
    return this.dd2_1;
  };
  protoOf(MeasurableValueImpl).jbk = function () {
    return this.ed2_1;
  };
  function MeasurementUnitImpl(context, node) {
    node = node === VOID ? new Node_0(MeasurementUnitConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.jd2_1 = this.c6n(MeasurementUnitConcept_getInstance().ubk_1);
    this.kd2_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(MeasurementUnitImpl).wbk = function () {
    return this.jd2_1;
  };
  protoOf(MeasurementUnitImpl).b3 = function () {
    return this.kd2_1;
  };
  function ModifierContainerImpl(context, node) {
    node = node === VOID ? new Node_0(ModifierContainerConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.qd2_1 = this.i6n(ModifierContainerConcept_getInstance().hbl_1);
  }
  protoOf(ModifierContainerImpl).jbl = function () {
    return this.qd2_1;
  };
  function ModifierDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(ModifierDeclarationConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ud2_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(ModifierDeclarationImpl).b3 = function () {
    return this.ud2_1;
  };
  function ModifierFactExpressionImpl(context, node) {
    node = node === VOID ? new Node_0(ModifierFactExpressionConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.yd2_1 = context.j6p(ModifierFactExpressionConcept_getInstance().vbl_1, this);
    this.zd2_1 = this.f6n(ModifierFactExpressionConcept_getInstance().wbl_1);
  }
  protoOf(ModifierFactExpressionImpl).zbl = function () {
    return this.yd2_1;
  };
  protoOf(ModifierFactExpressionImpl).lbb = function () {
    return this.zd2_1;
  };
  function MultilineTextImpl(context, node) {
    node = node === VOID ? new Node_0(MultilineTextConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.dd3_1 = this.j6n(MultilineTextConcept_getInstance().kbm_1);
  }
  protoOf(MultilineTextImpl).mbm = function () {
    return this.dd3_1;
  };
  function MultipleProcessPropertyValueRangeImpl(context, node) {
    node = node === VOID ? new Node_0(MultipleProcessPropertyValueRangeConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.hd3_1 = this.e6n(MultipleProcessPropertyValueRangeConcept_getInstance().xbm_1);
  }
  protoOf(MultipleProcessPropertyValueRangeImpl).zb3 = function () {
    return this.hd3_1;
  };
  function MultiplePropertyValueRangeImpl(context, node) {
    node = node === VOID ? new Node_0(MultiplePropertyValueRangeConcept_getInstance().e6r_1) : node;
    PropertyValueRangeImpl.call(this, context, node);
    this.ld3_1 = this.j6n(MultiplePropertyValueRangeConcept_getInstance().jbn_1);
  }
  protoOf(MultiplePropertyValueRangeImpl).lbn = function () {
    return this.ld3_1;
  };
  function NewFactImpl(context, node) {
    node = node === VOID ? new Node_0(NewFactConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.pd3_1 = this.f6n(NewFactConcept_getInstance().wbn_1);
    this.qd3_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(NewFactImpl).lbb = function () {
    return this.pd3_1;
  };
  protoOf(NewFactImpl).b3 = function () {
    return this.qd3_1;
  };
  function NewFactReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(NewFactReferenceConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ud3_1 = context.j6p(NewFactReferenceConcept_getInstance().jbo_1, this);
  }
  protoOf(NewFactReferenceImpl).ub6 = function () {
    return this.ud3_1;
  };
  function NoValuesImpl(context, node) {
    node = node === VOID ? new Node_0(NoValuesConcept_getInstance().e6r_1) : node;
    PropertyValueRangeImpl.call(this, context, node);
  }
  function NotionLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(NotionLibraryConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.ad4_1 = this.i6n(NotionLibraryConcept_getInstance().vbo_1);
  }
  protoOf(NotionLibraryImpl).xbo = function () {
    return this.ad4_1;
  };
  function NotionPlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(NotionPlaceholderConcept_getInstance().e6r_1) : node;
    AbstractNotionImpl.call(this, context, node);
  }
  function NotionTypeImpl(context, node) {
    node = node === VOID ? new Node_0(NotionTypeConcept_getInstance().e6r_1) : node;
    TypeImpl.call(this, context, node);
    this.ed4_1 = context.j6p(NotionTypeConcept_getInstance().jbp_1, this);
  }
  protoOf(NotionTypeImpl).lbp = function () {
    return this.ed4_1;
  };
  function ObjectPropertiesLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(ObjectPropertiesLibraryConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.kd4_1 = this.j6n(ObjectPropertiesLibraryConcept_getInstance().wbp_1);
  }
  protoOf(ObjectPropertiesLibraryImpl).pas = function () {
    return this.kd4_1;
  };
  function ObjectPropertyDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(ObjectPropertyDeclarationConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.od4_1 = this.c6n(ObjectPropertyDeclarationConcept_getInstance().ibq_1);
    this.pd4_1 = context.j6p(ObjectPropertyDeclarationConcept_getInstance().jbq_1, this);
    this.qd4_1 = this.j6n(ObjectPropertyDeclarationConcept_getInstance().kbq_1);
    this.rd4_1 = this.f6n(ObjectPropertyDeclarationConcept_getInstance().lbq_1);
    this.sd4_1 = this.c6n(ObjectPropertyDeclarationConcept_getInstance().mbq_1);
    this.td4_1 = context.j6p(ObjectPropertyDeclarationConcept_getInstance().nbq_1, this);
    this.ud4_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(ObjectPropertyDeclarationImpl).wbq = function () {
    return this.od4_1;
  };
  protoOf(ObjectPropertyDeclarationImpl).xbq = function () {
    return this.pd4_1;
  };
  protoOf(ObjectPropertyDeclarationImpl).obe = function () {
    return this.qd4_1;
  };
  protoOf(ObjectPropertyDeclarationImpl).be = function () {
    return this.rd4_1;
  };
  protoOf(ObjectPropertyDeclarationImpl).ybq = function () {
    return this.sd4_1;
  };
  protoOf(ObjectPropertyDeclarationImpl).zbq = function () {
    return this.td4_1;
  };
  protoOf(ObjectPropertyDeclarationImpl).b3 = function () {
    return this.ud4_1;
  };
  function ObjectPropertyReferenceValueImpl(context, node) {
    node = node === VOID ? new Node_0(ObjectPropertyReferenceValueConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.yd4_1 = this.f6n(ObjectPropertyReferenceValueConcept_getInstance().kbr_1);
    this.zd4_1 = this.f6n(ObjectPropertyReferenceValueConcept_getInstance().lbr_1);
  }
  protoOf(ObjectPropertyReferenceValueImpl).obr = function () {
    return this.yd4_1;
  };
  protoOf(ObjectPropertyReferenceValueImpl).i6u = function () {
    return this.zd4_1;
  };
  function OldPublishedSourceImpl(context, node) {
    node = node === VOID ? new Node_0(OldPublishedSourceConcept_getInstance().e6r_1) : node;
    PublishedWorkImpl.call(this, context, node);
    this.jd5_1 = this.x6m(OldPublishedSourceConcept_getInstance().zbr_1);
    this.kd5_1 = this.x6m(OldPublishedSourceConcept_getInstance().abs_1);
    this.ld5_1 = get_name_4.call(this);
  }
  protoOf(OldPublishedSourceImpl).dbs = function () {
    return this.jd5_1;
  };
  protoOf(OldPublishedSourceImpl).ebs = function () {
    return this.kd5_1;
  };
  protoOf(OldPublishedSourceImpl).b3 = function () {
    return this.ld5_1;
  };
  function OneOfImpl(context, node) {
    node = node === VOID ? new Node_0(OneOfConcept_getInstance().e6r_1) : node;
    TypeImpl.call(this, context, node);
    this.pd5_1 = this.j6n(OneOfConcept_getInstance().pbs_1);
  }
  protoOf(OneOfImpl).rbs = function () {
    return this.pd5_1;
  };
  function OntologyCardinalityRelationImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyCardinalityRelationConcept_getInstance().e6r_1) : node;
    AbstractOntologyRelationImpl.call(this, context, node);
    this.td5_1 = this.f6n(OntologyCardinalityRelationConcept_getInstance().cbt_1);
    this.ud5_1 = this.e6n(OntologyCardinalityRelationConcept_getInstance().dbt_1);
  }
  protoOf(OntologyCardinalityRelationImpl).yay = function () {
    return this.td5_1;
  };
  protoOf(OntologyCardinalityRelationImpl).eb8 = function () {
    return this.ud5_1;
  };
  function OntologyElementDefinitionImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementDefinitionConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.yd5_1 = this.f6n(OntologyElementDefinitionConcept_getInstance().ybu_1);
    this.zd5_1 = this.j6n(HasPropertyConstraintsConcept_getInstance().bbc_1);
  }
  protoOf(OntologyElementDefinitionImpl).yay = function () {
    return this.yd5_1;
  };
  protoOf(OntologyElementDefinitionImpl).dbc = function () {
    return this.zd5_1;
  };
  function OntologyElementImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.dd6_1 = this.j6n(OntologyElementConcept_getInstance().qbt_1);
    this.ed6_1 = this.j6n(OntologyElementConcept_getInstance().rbt_1);
    this.fd6_1 = this.f6n(OntologyElementConcept_getInstance().sbt_1);
    this.gd6_1 = this.x6m(OntologyElementConcept_getInstance().tbt_1);
    this.hd6_1 = this.j6n(OntologyElementConcept_getInstance().ubt_1);
    this.id6_1 = this.j6n(OntologyElementConcept_getInstance().vbt_1);
    this.jd6_1 = this.f6n(OntologyElementConcept_getInstance().wbt_1);
    this.kd6_1 = this.f6n(OntologyElementConcept_getInstance().xbt_1);
    this.ld6_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
    this.md6_1 = this.j6n(HasPropertyConstraintsConcept_getInstance().bbc_1);
  }
  protoOf(OntologyElementImpl).gbu = function () {
    return this.dd6_1;
  };
  protoOf(OntologyElementImpl).hbu = function () {
    return this.ed6_1;
  };
  protoOf(OntologyElementImpl).ibu = function () {
    return this.fd6_1;
  };
  protoOf(OntologyElementImpl).jbu = function () {
    return this.gd6_1;
  };
  protoOf(OntologyElementImpl).kbu = function () {
    return this.hd6_1;
  };
  protoOf(OntologyElementImpl).lbu = function () {
    return this.id6_1;
  };
  protoOf(OntologyElementImpl).mbu = function () {
    return this.jd6_1;
  };
  protoOf(OntologyElementImpl).nbu = function () {
    return this.kd6_1;
  };
  protoOf(OntologyElementImpl).b3 = function () {
    return this.ld6_1;
  };
  protoOf(OntologyElementImpl).dbc = function () {
    return this.md6_1;
  };
  function OntologyElementPropertyTypeImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementPropertyTypeConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.td6_1 = this.b6n(OntologyElementPropertyTypeConcept_getInstance().kbv_1, OntologyElementPropertyTypeConcept_getInstance().nbv_1);
    this.ud6_1 = this.e6n(OntologyElementPropertyTypeConcept_getInstance().lbv_1);
    this.vd6_1 = this.e6n(OntologyElementPropertyTypeConcept_getInstance().mbv_1);
  }
  protoOf(OntologyElementPropertyTypeImpl).sba = function () {
    return this.td6_1;
  };
  protoOf(OntologyElementPropertyTypeImpl).kay = function () {
    return this.ud6_1;
  };
  protoOf(OntologyElementPropertyTypeImpl).lay = function () {
    return this.vd6_1;
  };
  function OntologyElementReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementReferenceConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.zd6_1 = context.j6p(OntologyElementReferenceConcept_getInstance().cbw_1, this);
  }
  protoOf(OntologyElementReferenceImpl).lay = function () {
    return this.zd6_1;
  };
  function OntologyElementReferenceValueImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementReferenceValueConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.dd7_1 = this.e6n(OntologyElementReferenceValueConcept_getInstance().obw_1);
  }
  protoOf(OntologyElementReferenceValueImpl).lay = function () {
    return this.dd7_1;
  };
  function OntologyElementReferenceValueLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementReferenceValueLibraryConcept_getInstance().e6r_1) : node;
    OntologyElementReferenceValueImpl.call(this, context, node);
    this.id7_1 = this.e6n(OntologyElementReferenceValueLibraryConcept_getInstance().abx_1);
  }
  protoOf(OntologyElementReferenceValueLibraryImpl).kay = function () {
    return this.id7_1;
  };
  function OntologyElementSynonymImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementSynonymConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.md7_1 = this.x6m(OntologyElementSynonymConcept_getInstance().mbx_1);
  }
  protoOf(OntologyElementSynonymImpl).b3 = function () {
    return this.md7_1;
  };
  function OntologyElementTypeImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyElementTypeConcept_getInstance().e6r_1) : node;
    TypeImpl.call(this, context, node);
    this.qd7_1 = this.e6n(OntologyElementTypeConcept_getInstance().ybx_1);
    this.rd7_1 = this.e6n(OntologyElementTypeConcept_getInstance().zbx_1);
  }
  protoOf(OntologyElementTypeImpl).kay = function () {
    return this.qd7_1;
  };
  protoOf(OntologyElementTypeImpl).lay = function () {
    return this.rd7_1;
  };
  function OntologyImportImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyImportConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.vd7_1 = this.f6n(OntologyImportConcept_getInstance().mby_1);
    this.wd7_1 = this.f6n(OntologyImportConcept_getInstance().nby_1);
    this.xd7_1 = this.f6n(OntologyImportConcept_getInstance().oby_1);
  }
  protoOf(OntologyImportImpl).sby = function () {
    return this.vd7_1;
  };
  protoOf(OntologyImportImpl).lay = function () {
    return this.wd7_1;
  };
  protoOf(OntologyImportImpl).tby = function () {
    return this.xd7_1;
  };
  function OntologyImportRootImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyImportRootConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.dd8_1 = this.i6n(OntologyImportRootConcept_getInstance().ebz_1);
  }
  protoOf(OntologyImportRootImpl).sau = function () {
    return this.dd8_1;
  };
  function OntologyImportRootReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyImportRootReferenceConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.hd8_1 = context.j6p(OntologyImportRootReferenceConcept_getInstance().rbz_1, this);
  }
  protoOf(OntologyImportRootReferenceImpl).ub6 = function () {
    return this.hd8_1;
  };
  function OntologyIsRelationImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyIsRelationConcept_getInstance().e6r_1) : node;
    AbstractOntologyRelationImpl.call(this, context, node);
    this.ld8_1 = this.f6n(OntologyIsRelationConcept_getInstance().dc0_1);
  }
  protoOf(OntologyIsRelationImpl).fc0 = function () {
    return this.ld8_1;
  };
  function OntologyLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyLibraryConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.sd8_1 = this.j6n(OntologyLibraryConcept_getInstance().qc0_1);
  }
  protoOf(OntologyLibraryImpl).sc0 = function () {
    return this.sd8_1;
  };
  function OntologyLibraryReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyLibraryReferenceConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.wd8_1 = context.j6p(OntologyLibraryReferenceConcept_getInstance().ec1_1, this);
  }
  protoOf(OntologyLibraryReferenceImpl).ub6 = function () {
    return this.wd8_1;
  };
  function OntologyLinkDeclarationValueQueryImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyLinkDeclarationValueQueryConcept_getInstance().e6r_1) : node;
    DeclarationValueQueryImpl.call(this, context, node);
    this.bd9_1 = context.j6p(OntologyLinkDeclarationValueQueryConcept_getInstance().gc2_1, this);
  }
  protoOf(OntologyLinkDeclarationValueQueryImpl).ic2 = function () {
    return this.bd9_1;
  };
  function OntologyLinkImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyLinkConcept_getInstance().e6r_1) : node;
    AbstractLinkImpl.call(this, context, node);
    this.gd9_1 = this.e6n(OntologyLinkConcept_getInstance().qc1_1);
    this.hd9_1 = this.e6n(OntologyLinkConcept_getInstance().rc1_1);
  }
  protoOf(OntologyLinkImpl).pbh = function () {
    return this.gd9_1;
  };
  protoOf(OntologyLinkImpl).uc1 = function () {
    return this.hd9_1;
  };
  function OntologyLinkValueImpl(context, node) {
    node = node === VOID ? new Node_0(OntologyLinkValueConcept_getInstance().e6r_1) : node;
    AbstractBindingValueImpl.call(this, context, node);
    this.md9_1 = context.j6p(OntologyLinkValueConcept_getInstance().uc2_1, this);
  }
  protoOf(OntologyLinkValueImpl).wc2 = function () {
    return this.md9_1;
  };
  function OrValueQueryImpl(context, node) {
    node = node === VOID ? new Node_0(OrValueQueryConcept_getInstance().e6r_1) : node;
    AbstractBindingValueQueryImpl.call(this, context, node);
    this.rd9_1 = this.e6n(OrValueQueryConcept_getInstance().hc3_1);
    this.sd9_1 = this.e6n(OrValueQueryConcept_getInstance().ic3_1);
  }
  protoOf(OrValueQueryImpl).sbf = function () {
    return this.rd9_1;
  };
  protoOf(OrValueQueryImpl).tbf = function () {
    return this.sd9_1;
  };
  function PageImpl(context, node) {
    node = node === VOID ? new Node_0(PageConcept_getInstance().e6r_1) : node;
    PageSpecificationImpl.call(this, context, node);
    this.wd9_1 = this.y6m(PageConcept_getInstance().vc3_1);
  }
  protoOf(PageImpl).xc3 = function () {
    return this.wd9_1;
  };
  function PageRangeImpl(context, node) {
    node = node === VOID ? new Node_0(PageRangeConcept_getInstance().e6r_1) : node;
    PageSpecificationImpl.call(this, context, node);
    this.ada_1 = this.y6m(PageRangeConcept_getInstance().ic4_1);
    this.bda_1 = this.y6m(PageRangeConcept_getInstance().jc4_1);
  }
  protoOf(PageRangeImpl).q1 = function () {
    return this.ada_1;
  };
  protoOf(PageRangeImpl).mc4 = function () {
    return this.bda_1;
  };
  function PageSpecificationImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function PaperImpl(context, node) {
    node = node === VOID ? new Node_0(PaperConcept_getInstance().e6r_1) : node;
    PublishedWorkImpl.call(this, context, node);
    this.kda_1 = this.x6m(PaperConcept_getInstance().xc4_1);
    this.lda_1 = this.x6m(PaperConcept_getInstance().yc4_1);
    this.mda_1 = this.x6m(PaperConcept_getInstance().zc4_1);
    this.nda_1 = this.x6m(PaperConcept_getInstance().ac5_1);
    this.oda_1 = this.x6m(PaperConcept_getInstance().bc5_1);
    this.pda_1 = this.x6m(PaperConcept_getInstance().cc5_1);
    this.qda_1 = this.x6m(PaperConcept_getInstance().dc5_1);
    this.rda_1 = this.f6n(PaperConcept_getInstance().ec5_1);
  }
  protoOf(PaperImpl).nc5 = function () {
    return this.kda_1;
  };
  protoOf(PaperImpl).oc5 = function () {
    return this.lda_1;
  };
  protoOf(PaperImpl).pc5 = function () {
    return this.mda_1;
  };
  protoOf(PaperImpl).qc5 = function () {
    return this.nda_1;
  };
  protoOf(PaperImpl).rc5 = function () {
    return this.oda_1;
  };
  protoOf(PaperImpl).sc5 = function () {
    return this.pda_1;
  };
  protoOf(PaperImpl).tc5 = function () {
    return this.qda_1;
  };
  protoOf(PaperImpl).uc5 = function () {
    return this.rda_1;
  };
  function PartReferenceOperationImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function PartValueImpl(context, node) {
    node = node === VOID ? new Node_0(PartValueConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.vda_1 = this.e6n(PartValueConcept_getInstance().fc6_1);
    this.wda_1 = this.e6n(PartValueConcept_getInstance().gc6_1);
  }
  protoOf(PartValueImpl).obr = function () {
    return this.vda_1;
  };
  protoOf(PartValueImpl).u3l = function () {
    return this.wda_1;
  };
  function PreconditionImpl(context, node) {
    node = node === VOID ? new Node_0(PreconditionConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
  }
  function ProcessDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessDeclarationConcept_getInstance().e6r_1) : node;
    AbstractBindingDeclarationImpl.call(this, context, node);
    this.idb_1 = context.j6p(ProcessDeclarationConcept_getInstance().wc6_1, this);
    this.jdb_1 = context.j6p(ProcessDeclarationConcept_getInstance().xc6_1, this);
    this.kdb_1 = this.j6n(ProcessDeclarationConcept_getInstance().yc6_1);
    this.ldb_1 = this.j6n(ProcessDeclarationConcept_getInstance().zc6_1);
    this.mdb_1 = this.j6n(ProcessDeclarationConcept_getInstance().ac7_1);
    this.ndb_1 = this.j6n(HasVariablesConcept_getInstance().wbc_1);
  }
  protoOf(ProcessDeclarationImpl).r5e = function () {
    return this.idb_1;
  };
  protoOf(ProcessDeclarationImpl).gc7 = function () {
    return this.jdb_1;
  };
  protoOf(ProcessDeclarationImpl).hc7 = function () {
    return this.kdb_1;
  };
  protoOf(ProcessDeclarationImpl).ic7 = function () {
    return this.ldb_1;
  };
  protoOf(ProcessDeclarationImpl).jc7 = function () {
    return this.mdb_1;
  };
  protoOf(ProcessDeclarationImpl).ybc = function () {
    return this.ndb_1;
  };
  function ProcessEffectImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessEffectConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.wdb_1 = this.c6n(HasQueryLabelsConcept_getInstance().kbc_1);
    this.xdb_1 = this.c6n(HasQueryLabelsConcept_getInstance().lbc_1);
    this.ydb_1 = this.f6n(HasFactExpressionConcept_getInstance().jbb_1);
  }
  protoOf(ProcessEffectImpl).obc = function () {
    return this.wdb_1;
  };
  protoOf(ProcessEffectImpl).pbc = function () {
    return this.xdb_1;
  };
  protoOf(ProcessEffectImpl).lbb = function () {
    return this.ydb_1;
  };
  function ProcessKindContainerImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessKindContainerConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.edc_1 = this.i6n(ProcessKindContainerConcept_getInstance().uc7_1);
  }
  protoOf(ProcessKindContainerImpl).wc7 = function () {
    return this.edc_1;
  };
  function ProcessKindImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessKindConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.idc_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(ProcessKindImpl).b3 = function () {
    return this.idc_1;
  };
  function ProcessLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessLibraryConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.odc_1 = this.j6n(ProcessLibraryConcept_getInstance().hc8_1);
  }
  protoOf(ProcessLibraryImpl).jc8 = function () {
    return this.odc_1;
  };
  function ProcessPrerequisiteImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessPrerequisiteConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.sdc_1 = this.c6n(HasQueryLabelsConcept_getInstance().kbc_1);
    this.tdc_1 = this.c6n(HasQueryLabelsConcept_getInstance().lbc_1);
    this.udc_1 = this.f6n(HasFactExpressionConcept_getInstance().jbb_1);
  }
  protoOf(ProcessPrerequisiteImpl).obc = function () {
    return this.sdc_1;
  };
  protoOf(ProcessPrerequisiteImpl).pbc = function () {
    return this.tdc_1;
  };
  protoOf(ProcessPrerequisiteImpl).lbb = function () {
    return this.udc_1;
  };
  function ProcessPropertyCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessPropertyCustomCellConcept_getInstance().e6r_1) : node;
    CustomCellImpl.call(this, context, node);
    this.ydc_1 = context.j6p(ProcessPropertyCustomCellConcept_getInstance().mc9_1, this);
  }
  protoOf(ProcessPropertyCustomCellImpl).i6u = function () {
    return this.ydc_1;
  };
  function ProcessPropertyDefaultImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessPropertyDefaultConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.cdd_1 = this.f6n(ProcessPropertyDefaultConcept_getInstance().yc9_1);
  }
  protoOf(ProcessPropertyDefaultImpl).y = function () {
    return this.cdd_1;
  };
  function ProcessPropertyImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessPropertyConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.gdd_1 = this.e6n(ProcessPropertyConcept_getInstance().uc8_1);
    this.hdd_1 = this.j6n(ProcessPropertyConcept_getInstance().vc8_1);
    this.idd_1 = this.f6n(ProcessPropertyConcept_getInstance().wc8_1);
    this.jdd_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(ProcessPropertyImpl).zb3 = function () {
    return this.gdd_1;
  };
  protoOf(ProcessPropertyImpl).ac9 = function () {
    return this.hdd_1;
  };
  protoOf(ProcessPropertyImpl).g2o = function () {
    return this.idd_1;
  };
  protoOf(ProcessPropertyImpl).b3 = function () {
    return this.jdd_1;
  };
  function ProcessPropertyReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessPropertyReferenceConcept_getInstance().e6r_1) : node;
    VariableInitializerImpl.call(this, context, node);
    this.ndd_1 = context.j6p(ProcessPropertyReferenceConcept_getInstance().lca_1, this);
  }
  protoOf(ProcessPropertyReferenceImpl).i6u = function () {
    return this.ndd_1;
  };
  function ProcessPropertyValueImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessPropertyValueConcept_getInstance().e6r_1) : node;
    BindingValuePlaceholderImpl.call(this, context, node);
    this.rdd_1 = context.j6p(ProcessPropertyValueConcept_getInstance().yca_1, this);
    this.sdd_1 = this.f6n(ProcessPropertyValueConcept_getInstance().zca_1);
    this.tdd_1 = this.c6n(HasQueryLabelsConcept_getInstance().kbc_1);
    this.udd_1 = this.c6n(HasQueryLabelsConcept_getInstance().lbc_1);
  }
  protoOf(ProcessPropertyValueImpl).i6u = function () {
    return this.rdd_1;
  };
  protoOf(ProcessPropertyValueImpl).y = function () {
    return this.sdd_1;
  };
  protoOf(ProcessPropertyValueImpl).obc = function () {
    return this.tdd_1;
  };
  protoOf(ProcessPropertyValueImpl).pbc = function () {
    return this.udd_1;
  };
  function ProcessReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessReferenceConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ydd_1 = context.j6p(ProcessReferenceConcept_getInstance().ncb_1, this);
  }
  protoOf(ProcessReferenceImpl).jbg = function () {
    return this.ydd_1;
  };
  function ProcessRelationDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessRelationDeclarationConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.cde_1 = this.x6m(ProcessRelationDeclarationConcept_getInstance().bcc_1);
    this.dde_1 = this.b6n(ProcessRelationDeclarationConcept_getInstance().ccc_1, ProcessRelationDeclarationConcept_getInstance().ecc_1);
    this.ede_1 = this.b6n(ProcessRelationDeclarationConcept_getInstance().dcc_1, ProcessRelationDeclarationConcept_getInstance().fcc_1);
    this.fde_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(ProcessRelationDeclarationImpl).jcc = function () {
    return this.cde_1;
  };
  protoOf(ProcessRelationDeclarationImpl).kcc = function () {
    return this.dde_1;
  };
  protoOf(ProcessRelationDeclarationImpl).lcc = function () {
    return this.ede_1;
  };
  protoOf(ProcessRelationDeclarationImpl).b3 = function () {
    return this.fde_1;
  };
  function ProcessTypeImpl(context, node) {
    node = node === VOID ? new Node_0(ProcessTypeConcept_getInstance().e6r_1) : node;
    TypeImpl.call(this, context, node);
    this.kde_1 = this.f6n(ProcessTypeConcept_getInstance().wcc_1);
  }
  protoOf(ProcessTypeImpl).pb5 = function () {
    return this.kde_1;
  };
  function PropertiesCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(PropertiesCustomCellConcept_getInstance().e6r_1) : node;
    CustomCellImpl.call(this, context, node);
  }
  function PropertyConstraintImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyConstraintConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.ode_1 = this.b6n(PropertyConstraintConcept_getInstance().jcd_1, PropertyConstraintConcept_getInstance().mcd_1);
    this.pde_1 = context.j6p(PropertyConstraintConcept_getInstance().kcd_1, this);
    this.qde_1 = this.f6n(PropertyConstraintConcept_getInstance().lcd_1);
    this.rde_1 = this.j6n(HasPropertyConstraintsConcept_getInstance().bbc_1);
  }
  protoOf(PropertyConstraintImpl).u3l = function () {
    return this.ode_1;
  };
  protoOf(PropertyConstraintImpl).i6u = function () {
    return this.pde_1;
  };
  protoOf(PropertyConstraintImpl).y = function () {
    return this.qde_1;
  };
  protoOf(PropertyConstraintImpl).dbc = function () {
    return this.rde_1;
  };
  function PropertyCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyCustomCellConcept_getInstance().e6r_1) : node;
    CustomCellImpl.call(this, context, node);
    this.vde_1 = context.j6p(PropertyCustomCellConcept_getInstance().cce_1, this);
  }
  protoOf(PropertyCustomCellImpl).i6u = function () {
    return this.vde_1;
  };
  function PropertyDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyDeclarationConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.zde_1 = this.e6n(PropertyDeclarationConcept_getInstance().oce_1);
    this.adf_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
  }
  protoOf(PropertyDeclarationImpl).zb3 = function () {
    return this.zde_1;
  };
  protoOf(PropertyDeclarationImpl).b3 = function () {
    return this.adf_1;
  };
  function PropertyDeclarationValueQueryImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyDeclarationValueQueryConcept_getInstance().e6r_1) : node;
    DeclarationValueQueryImpl.call(this, context, node);
    this.fdf_1 = context.j6p(PropertyDeclarationValueQueryConcept_getInstance().bcf_1, this);
  }
  protoOf(PropertyDeclarationValueQueryImpl).dcf = function () {
    return this.fdf_1;
  };
  function PropertyLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyLibraryConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.ldf_1 = this.i6n(PropertyLibraryConcept_getInstance().ocf_1);
  }
  protoOf(PropertyLibraryImpl).sc0 = function () {
    return this.ldf_1;
  };
  function PropertyReferenceOperationImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyReferenceOperationConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.pdf_1 = context.j6p(PropertyReferenceOperationConcept_getInstance().bcg_1, this);
    this.qdf_1 = this.f6n(PropertyReferenceOperationConcept_getInstance().ccg_1);
  }
  protoOf(PropertyReferenceOperationImpl).i6u = function () {
    return this.pdf_1;
  };
  protoOf(PropertyReferenceOperationImpl).fcg = function () {
    return this.qdf_1;
  };
  function PropertyValueImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyValueConcept_getInstance().e6r_1) : node;
    AbstractBindingValueImpl.call(this, context, node);
    this.vdf_1 = context.j6p(PropertyValueConcept_getInstance().rcg_1, this);
  }
  protoOf(PropertyValueImpl).i6u = function () {
    return this.vdf_1;
  };
  function PropertyValueRangeImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function PubMedSourceReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(PubMedSourceReferenceConcept_getInstance().e6r_1) : node;
    KnowledgeSourceReferenceImpl.call(this, context, node);
    this.zdf_1 = this.x6m(PubMedSourceReferenceConcept_getInstance().dch_1);
  }
  protoOf(PubMedSourceReferenceImpl).rc5 = function () {
    return this.zdf_1;
  };
  function PublishedSourceReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(PublishedSourceReferenceConcept_getInstance().e6r_1) : node;
    KnowledgeSourceReferenceImpl.call(this, context, node);
    this.ddg_1 = context.j6p(PublishedSourceReferenceConcept_getInstance().qch_1, this);
    this.edg_1 = this.f6n(PublishedSourceReferenceConcept_getInstance().rch_1);
  }
  protoOf(PublishedSourceReferenceImpl).k6h = function () {
    return this.ddg_1;
  };
  protoOf(PublishedSourceReferenceImpl).uch = function () {
    return this.edg_1;
  };
  function PublishedSourcesLibraryImpl(context, node) {
    node = node === VOID ? new Node_0(PublishedSourcesLibraryConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.kdg_1 = this.j6n(PublishedSourcesLibraryConcept_getInstance().fci_1);
  }
  protoOf(PublishedSourcesLibraryImpl).cq = function () {
    return this.kdg_1;
  };
  function PublishedWorkImpl(context, node) {
    node = node === VOID ? new Node_0(PublishedWorkConcept_getInstance().e6r_1) : node;
    AuthoredWorkImpl.call(this, context, node);
    this.acu_1 = this.x6m(PublishedWorkConcept_getInstance().rci_1);
    this.bcu_1 = this.x6m(PublishedWorkConcept_getInstance().sci_1);
    this.ccu_1 = get_name_0.call(this);
  }
  protoOf(PublishedWorkImpl).vci = function () {
    return this.acu_1;
  };
  protoOf(PublishedWorkImpl).wci = function () {
    return this.bcu_1;
  };
  protoOf(PublishedWorkImpl).b3 = function () {
    return this.ccu_1;
  };
  function QualifiedOntologyElementReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(QualifiedOntologyElementReferenceConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.odg_1 = this.e6n(QualifiedOntologyElementReferenceConcept_getInstance().hcj_1);
    this.pdg_1 = this.e6n(QualifiedOntologyElementReferenceConcept_getInstance().icj_1);
  }
  protoOf(QualifiedOntologyElementReferenceImpl).lcj = function () {
    return this.odg_1;
  };
  protoOf(QualifiedOntologyElementReferenceImpl).mcj = function () {
    return this.pdg_1;
  };
  function QueryCommandsImpl(context, node) {
    node = node === VOID ? new Node_0(QueryCommandsConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.vdg_1 = this.i6n(QueryCommandsConcept_getInstance().xcj_1);
  }
  protoOf(QueryCommandsImpl).v4n = function () {
    return this.vdg_1;
  };
  function QueryLabelsFactExpressionContainerImpl(context, node) {
    node = node === VOID ? new Node_0(QueryLabelsFactExpressionContainerConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.zdg_1 = this.c6n(HasQueryLabelsConcept_getInstance().kbc_1);
    this.adh_1 = this.c6n(HasQueryLabelsConcept_getInstance().lbc_1);
    this.bdh_1 = this.f6n(HasFactExpressionConcept_getInstance().jbb_1);
  }
  protoOf(QueryLabelsFactExpressionContainerImpl).obc = function () {
    return this.zdg_1;
  };
  protoOf(QueryLabelsFactExpressionContainerImpl).pbc = function () {
    return this.adh_1;
  };
  protoOf(QueryLabelsFactExpressionContainerImpl).lbb = function () {
    return this.bdh_1;
  };
  function QueryParametersBlackListImpl(context, node) {
    node = node === VOID ? new Node_0(QueryParametersBlackListConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.hdh_1 = context.j6p(QueryParametersBlackListConcept_getInstance().kck_1, this);
    this.idh_1 = this.i6n(QueryParametersBlackListConcept_getInstance().lck_1);
  }
  protoOf(QueryParametersBlackListImpl).kay = function () {
    return this.hdh_1;
  };
  protoOf(QueryParametersBlackListImpl).sc0 = function () {
    return this.idh_1;
  };
  function RelationContainerImpl(context, node) {
    node = node === VOID ? new Node_0(RelationContainerConcept_getInstance().e6r_1) : node;
    DocumentNodeImpl.call(this, context, node);
    this.odh_1 = this.i6n(RelationContainerConcept_getInstance().yck_1);
    this.pdh_1 = this.i6n(RelationContainerConcept_getInstance().zck_1);
  }
  protoOf(RelationContainerImpl).ccl = function () {
    return this.odh_1;
  };
  protoOf(RelationContainerImpl).dcl = function () {
    return this.pdh_1;
  };
  function RelationFactExpressionImpl(context, node) {
    node = node === VOID ? new Node_0(RelationFactExpressionConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.tdh_1 = this.f6n(RelationFactExpressionConcept_getInstance().ocl_1);
    this.udh_1 = this.f6n(RelationFactExpressionConcept_getInstance().pcl_1);
    this.vdh_1 = context.j6p(RelationFactExpressionConcept_getInstance().qcl_1, this);
  }
  protoOf(RelationFactExpressionImpl).sbf = function () {
    return this.tdh_1;
  };
  protoOf(RelationFactExpressionImpl).tbf = function () {
    return this.udh_1;
  };
  protoOf(RelationFactExpressionImpl).gb6 = function () {
    return this.vdh_1;
  };
  function ReturnTypeCustomCellImpl(context, node) {
    node = node === VOID ? new Node_0(ReturnTypeCustomCellConcept_getInstance().e6r_1) : node;
    CustomCellImpl.call(this, context, node);
  }
  function SetExpressionImpl(context, node) {
    node = node === VOID ? new Node_0(SetExpressionConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.zdh_1 = this.i6n(SetExpressionConcept_getInstance().fcm_1);
    this.adi_1 = this.c6n(SetExpressionConcept_getInstance().gcm_1);
  }
  protoOf(SetExpressionImpl).rbs = function () {
    return this.zdh_1;
  };
  protoOf(SetExpressionImpl).jcm = function () {
    return this.adi_1;
  };
  function SetValuedPropertyParameterImpl(context, node) {
    node = node === VOID ? new Node_0(SetValuedPropertyParameterConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.edi_1 = this.f6n(SetValuedPropertyParameterConcept_getInstance().ucm_1);
  }
  protoOf(SetValuedPropertyParameterImpl).y = function () {
    return this.edi_1;
  };
  function SimplePropertyTypeImpl(context, node) {
    node = node === VOID ? new Node_0(SimplePropertyTypeConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.idi_1 = context.j6p(SimplePropertyTypeConcept_getInstance().hcn_1, this);
  }
  protoOf(SimplePropertyTypeImpl).lbp = function () {
    return this.idi_1;
  };
  function SinglePropertyValueRangeImpl(context, node) {
    node = node === VOID ? new Node_0(SinglePropertyValueRangeConcept_getInstance().e6r_1) : node;
    PropertyValueRangeImpl.call(this, context, node);
    this.mdi_1 = this.j6n(SinglePropertyValueRangeConcept_getInstance().tcn_1);
  }
  protoOf(SinglePropertyValueRangeImpl).lbn = function () {
    return this.mdi_1;
  };
  function TextLineImpl(context, node) {
    node = node === VOID ? new Node_0(TextLineConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.qdi_1 = this.d6n(TextLineConcept_getInstance().fco_1);
  }
  protoOf(TextLineImpl).laz = function () {
    return this.qdi_1;
  };
  function TypeImpl(context, node) {
    VariableSpecificationImpl.call(this, context, node);
  }
  function TypePlaceholderImpl(context, node) {
    node = node === VOID ? new Node_0(TypePlaceholderConcept_getInstance().e6r_1) : node;
    TypeImpl.call(this, context, node);
  }
  function _get_ontologyElementsField__6bq4mb($this) {
    if ($this.ddj_1 == null) {
      $this.ddj_1 = $this.w6o(AbstractBindingDeclarationConcept_getInstance().jas_1);
    }
    return ensureNotNull($this.ddj_1);
  }
  function _get_entriesField__p2z5bz($this) {
    if ($this.edj_1 == null) {
      $this.edj_1 = $this.w6o(AbstractBindingDeclarationConcept_getInstance().kas_1);
    }
    return ensureNotNull($this.edj_1);
  }
  function _get_propertiesField__rzp1g6($this) {
    if ($this.fdj_1 == null) {
      $this.fdj_1 = $this.w6o(AbstractBindingDeclarationConcept_getInstance().las_1);
    }
    return ensureNotNull($this.fdj_1);
  }
  function _get_customEditorField__k9tlsb($this) {
    if ($this.gdj_1 == null) {
      $this.gdj_1 = $this.t6o(AbstractBindingDeclarationConcept_getInstance().mas_1);
    }
    return ensureNotNull($this.gdj_1);
  }
  function _get_commentField__ylav5c($this) {
    if ($this.jdj_1 == null) {
      $this.jdj_1 = $this.t6o(HasCommentsConcept_getInstance().bbb_1);
    }
    return ensureNotNull($this.jdj_1);
  }
  function TypedAbstractBindingDeclarationImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ddj_1 = null;
    this.edj_1 = null;
    this.fdj_1 = null;
    this.gdj_1 = null;
    this.hdj_1 = null;
    this.idj_1 = null;
    this.jdj_1 = null;
  }
  protoOf(TypedAbstractBindingDeclarationImpl).oas = function () {
    return this.y6o(_get_ontologyElementsField__6bq4mb(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).w = function () {
    return this.y6o(_get_entriesField__p2z5bz(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).pas = function () {
    return this.y6o(_get_propertiesField__rzp1g6(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).qas = function () {
    return this.v6o(_get_customEditorField__k9tlsb(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).ras = function () {
    return this.n6o(AbstractBindingDeclarationConcept_getInstance().nas_1);
  };
  protoOf(TypedAbstractBindingDeclarationImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedAbstractBindingDeclarationImpl).cbb = function () {
    return this.v6o(_get_commentField__ylav5c(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedAbstractBindingDeclarationImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.hdj_1 == null)) {
      this_0.e(AbstractBindingDeclarationConcept_getInstance().nas_1.e6s_1);
    }
    if (!(this.idj_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedAbstractBindingDeclarationImpl.<get-childIds>.<anonymous>' call
    if (!(this.ddj_1 == null)) {
      this_0.e(AbstractBindingDeclarationConcept_getInstance().jas_1.x6o_1);
    }
    if (!(this.edj_1 == null)) {
      this_0.e(AbstractBindingDeclarationConcept_getInstance().kas_1.x6o_1);
    }
    if (!(this.fdj_1 == null)) {
      this_0.e(AbstractBindingDeclarationConcept_getInstance().las_1.x6o_1);
    }
    if (!(this.gdj_1 == null)) {
      this_0.e(AbstractBindingDeclarationConcept_getInstance().mas_1.u6o_1);
    }
    if (!(this.jdj_1 == null)) {
      this_0.e(HasCommentsConcept_getInstance().bbb_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedAbstractBindingDeclarationImpl).l6o = function (propertyId) {
    return propertyId.equals(AbstractBindingDeclarationConcept_getInstance().nas_1.e6s_1) ? this.hdj_1 : propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.idj_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedAbstractBindingDeclarationImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(AbstractBindingDeclarationConcept_getInstance().nas_1.e6s_1)) {
      this.hdj_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.idj_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedAbstractBindingDeclarationImpl).l38 = function (childId) {
    return childId.equals(AbstractBindingDeclarationConcept_getInstance().jas_1.x6o_1) ? _get_ontologyElementsField__6bq4mb(this) : childId.equals(AbstractBindingDeclarationConcept_getInstance().kas_1.x6o_1) ? _get_entriesField__p2z5bz(this) : childId.equals(AbstractBindingDeclarationConcept_getInstance().las_1.x6o_1) ? _get_propertiesField__rzp1g6(this) : childId.equals(AbstractBindingDeclarationConcept_getInstance().mas_1.u6o_1) ? _get_customEditorField__k9tlsb(this) : childId.equals(HasCommentsConcept_getInstance().bbb_1.u6o_1) ? _get_commentField__ylav5c(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedAbstractBindingEntryImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function _get_valueField__9y0rz6($this) {
    if ($this.idk_1 == null) {
      $this.idk_1 = $this.t6o(AbstractBindingValueConcept_getInstance().zas_1);
    }
    return ensureNotNull($this.idk_1);
  }
  function TypedAbstractBindingValueImpl(context, conceptId, nodeId) {
    TypedBindingValuePlaceholderImpl.call(this, context, conceptId, nodeId);
    this.idk_1 = null;
  }
  protoOf(TypedAbstractBindingValueImpl).y = function () {
    return this.v6o(_get_valueField__9y0rz6(this));
  };
  protoOf(TypedAbstractBindingValueImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedAbstractBindingValueImpl.<get-childIds>.<anonymous>' call
    if (!(this.idk_1 == null)) {
      this_0.e(AbstractBindingValueConcept_getInstance().zas_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBindingValuePlaceholderImpl).v2z.call(this));
  };
  protoOf(TypedAbstractBindingValueImpl).l38 = function (childId) {
    return childId.equals(AbstractBindingValueConcept_getInstance().zas_1.u6o_1) ? _get_valueField__9y0rz6(this) : protoOf(TypedBindingValuePlaceholderImpl).l38.call(this, childId);
  };
  function TypedAbstractBindingValueQueryImpl(context, conceptId, nodeId) {
    TypedBindingValuePlaceholderQueryImpl.call(this, context, conceptId, nodeId);
  }
  function TypedAbstractLinkImpl(context, conceptId, nodeId) {
    TypedAbstractBindingEntryImpl.call(this, context, conceptId, nodeId);
    this.tdl_1 = null;
    this.udl_1 = this.p6o(AbstractLinkConcept_getInstance().iat_1);
  }
  protoOf(TypedAbstractLinkImpl).jat = function () {
    return this.udl_1;
  };
  protoOf(TypedAbstractLinkImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedAbstractLinkImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.tdl_1 == null)) {
      this_0.e(AbstractLinkConcept_getInstance().iat_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractBindingEntryImpl).y2z.call(this));
  };
  protoOf(TypedAbstractLinkImpl).l6o = function (propertyId) {
    return propertyId.equals(AbstractLinkConcept_getInstance().iat_1.q6o_1) ? this.tdl_1 : protoOf(TypedAbstractBindingEntryImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedAbstractLinkImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(AbstractLinkConcept_getInstance().iat_1.q6o_1)) {
      this.tdl_1 = value;
    } else {
      protoOf(TypedAbstractBindingEntryImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedAbstractNotionImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.hdm_1 = null;
  }
  protoOf(TypedAbstractNotionImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedAbstractNotionImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedAbstractNotionImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.hdm_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedAbstractNotionImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.hdm_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedAbstractNotionImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.hdm_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedAbstractOntologyRelationImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function TypedAbstractProcessSpecificationImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function TypedAbstractPropertyImpl(context, conceptId, nodeId) {
    TypedAbstractBindingEntryImpl.call(this, context, conceptId, nodeId);
  }
  function TypedAuthorImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? AuthorConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(AuthorConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.udm_1 = null;
  }
  protoOf(TypedAuthorImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedAuthorImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedAuthorImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.udm_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedAuthorImpl).c3b = function (nodeId) {
    return new TypedAuthorImpl(this.a6o_1, AuthorConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedAuthorImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.udm_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedAuthorImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.udm_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_authorsField__o0tsl5($this) {
    if ($this.hdn_1 == null) {
      $this.hdn_1 = $this.w6o(AuthoredWorkConcept_getInstance().wat_1);
    }
    return ensureNotNull($this.hdn_1);
  }
  function TypedAuthoredWorkImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? AuthoredWorkConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(AuthoredWorkConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.hdn_1 = null;
    this.idn_1 = null;
  }
  protoOf(TypedAuthoredWorkImpl).yat = function () {
    return this.y6o(_get_authorsField__o0tsl5(this));
  };
  protoOf(TypedAuthoredWorkImpl).zat = function () {
    return this.n6o(AuthoredWorkConcept_getInstance().xat_1);
  };
  protoOf(TypedAuthoredWorkImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedAuthoredWorkImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.idn_1 == null)) {
      this_0.e(AuthoredWorkConcept_getInstance().xat_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedAuthoredWorkImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedAuthoredWorkImpl.<get-childIds>.<anonymous>' call
    if (!(this.hdn_1 == null)) {
      this_0.e(AuthoredWorkConcept_getInstance().wat_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedAuthoredWorkImpl).c3b = function (nodeId) {
    return new TypedAuthoredWorkImpl(this.a6o_1, AuthoredWorkConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedAuthoredWorkImpl).l6o = function (propertyId) {
    return propertyId.equals(AuthoredWorkConcept_getInstance().xat_1.e6s_1) ? this.idn_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedAuthoredWorkImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(AuthoredWorkConcept_getInstance().xat_1.e6s_1)) {
      this.idn_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedAuthoredWorkImpl).l38 = function (childId) {
    return childId.equals(AuthoredWorkConcept_getInstance().wat_1.x6o_1) ? _get_authorsField__o0tsl5(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_factSetsField__38hxv0($this) {
    if ($this.xdn_1 == null) {
      $this.xdn_1 = $this.w6o(BTBDocumentConcept_getInstance().nau_1);
    }
    return ensureNotNull($this.xdn_1);
  }
  function _get_categoriesField__hhjj3h($this) {
    if ($this.ydn_1 == null) {
      $this.ydn_1 = $this.w6o(BTBDocumentConcept_getInstance().oau_1);
    }
    return ensureNotNull($this.ydn_1);
  }
  function _get_importsField__w7vue7($this) {
    if ($this.zdn_1 == null) {
      $this.zdn_1 = $this.w6o(BTBDocumentConcept_getInstance().pau_1);
    }
    return ensureNotNull($this.zdn_1);
  }
  function TypedBTBDocumentImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? BTBDocumentConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BTBDocumentConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.xdn_1 = null;
    this.ydn_1 = null;
    this.zdn_1 = null;
  }
  protoOf(TypedBTBDocumentImpl).qau = function () {
    return this.y6o(_get_factSetsField__38hxv0(this));
  };
  protoOf(TypedBTBDocumentImpl).rau = function () {
    return this.y6o(_get_categoriesField__hhjj3h(this));
  };
  protoOf(TypedBTBDocumentImpl).sau = function () {
    return this.y6o(_get_importsField__w7vue7(this));
  };
  protoOf(TypedBTBDocumentImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedBTBDocumentImpl.<get-childIds>.<anonymous>' call
    if (!(this.xdn_1 == null)) {
      this_0.e(BTBDocumentConcept_getInstance().nau_1.x6o_1);
    }
    if (!(this.ydn_1 == null)) {
      this_0.e(BTBDocumentConcept_getInstance().oau_1.x6o_1);
    }
    if (!(this.zdn_1 == null)) {
      this_0.e(BTBDocumentConcept_getInstance().pau_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedBTBDocumentImpl).c3b = function (nodeId) {
    return new TypedBTBDocumentImpl(this.a6o_1, BTBDocumentConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedBTBDocumentImpl).l38 = function (childId) {
    return childId.equals(BTBDocumentConcept_getInstance().nau_1.x6o_1) ? _get_factSetsField__38hxv0(this) : childId.equals(BTBDocumentConcept_getInstance().oau_1.x6o_1) ? _get_categoriesField__hhjj3h(this) : childId.equals(BTBDocumentConcept_getInstance().pau_1.x6o_1) ? _get_importsField__w7vue7(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function _get_propertyField__spxghg($this) {
    if ($this.adp_1 == null) {
      $this.adp_1 = $this.t6o(BindingPropertyConcept_getInstance().eav_1);
    }
    return ensureNotNull($this.adp_1);
  }
  function TypedBindingPropertyImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? BindingPropertyConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BindingPropertyConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractPropertyImpl.call(this, context, conceptId, nodeId);
    this.adp_1 = null;
  }
  protoOf(TypedBindingPropertyImpl).i6u = function () {
    return this.v6o(_get_propertyField__spxghg(this));
  };
  protoOf(TypedBindingPropertyImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedBindingPropertyImpl.<get-childIds>.<anonymous>' call
    if (!(this.adp_1 == null)) {
      this_0.e(BindingPropertyConcept_getInstance().eav_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractPropertyImpl).v2z.call(this));
  };
  protoOf(TypedBindingPropertyImpl).c3b = function (nodeId) {
    return new TypedBindingPropertyImpl(this.a6o_1, BindingPropertyConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedBindingPropertyImpl).l38 = function (childId) {
    return childId.equals(BindingPropertyConcept_getInstance().eav_1.u6o_1) ? _get_propertyField__spxghg(this) : protoOf(TypedAbstractPropertyImpl).l38.call(this, childId);
  };
  function _get_valueField__9y0rz6_0($this) {
    if ($this.ndp_1 == null) {
      $this.ndp_1 = $this.t6o(BindingValueMaskConcept_getInstance().qav_1);
    }
    return ensureNotNull($this.ndp_1);
  }
  function TypedBindingValueMaskImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? BindingValueMaskConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BindingValueMaskConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractBindingValueQueryImpl.call(this, context, conceptId, nodeId);
    this.ndp_1 = null;
  }
  protoOf(TypedBindingValueMaskImpl).y = function () {
    return this.v6o(_get_valueField__9y0rz6_0(this));
  };
  protoOf(TypedBindingValueMaskImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedBindingValueMaskImpl.<get-childIds>.<anonymous>' call
    if (!(this.ndp_1 == null)) {
      this_0.e(BindingValueMaskConcept_getInstance().qav_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractBindingValueQueryImpl).v2z.call(this));
  };
  protoOf(TypedBindingValueMaskImpl).c3b = function (nodeId) {
    return new TypedBindingValueMaskImpl(this.a6o_1, BindingValueMaskConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedBindingValueMaskImpl).l38 = function (childId) {
    return childId.equals(BindingValueMaskConcept_getInstance().qav_1.u6o_1) ? _get_valueField__9y0rz6_0(this) : protoOf(TypedAbstractBindingValueQueryImpl).l38.call(this, childId);
  };
  function TypedBindingValuePlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? BindingValuePlaceholderConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BindingValuePlaceholderConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedBindingValuePlaceholderImpl).c3b = function (nodeId) {
    return new TypedBindingValuePlaceholderImpl(this.a6o_1, BindingValuePlaceholderConcept_getInstance().e6r_1, nodeId);
  };
  function TypedBindingValuePlaceholderQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? BindingValuePlaceholderQueryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BindingValuePlaceholderQueryConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedBindingValuePlaceholderQueryImpl).c3b = function (nodeId) {
    return new TypedBindingValuePlaceholderQueryImpl(this.a6o_1, BindingValuePlaceholderQueryConcept_getInstance().e6r_1, nodeId);
  };
  function TypedBookImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? BookConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(BookConcept_getInstance().e6r_1) : nodeId;
    TypedPublishedWorkImpl.call(this, context, conceptId, nodeId);
    this.fdq_1 = null;
  }
  protoOf(TypedBookImpl).daw = function () {
    return this.n6o(BookConcept_getInstance().caw_1);
  };
  protoOf(TypedBookImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedBookImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.fdq_1 == null)) {
      this_0.e(BookConcept_getInstance().caw_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedPublishedWorkImpl).y2z.call(this));
  };
  protoOf(TypedBookImpl).c3b = function (nodeId) {
    return new TypedBookImpl(this.a6o_1, BookConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedBookImpl).l6o = function (propertyId) {
    return propertyId.equals(BookConcept_getInstance().caw_1.e6s_1) ? this.fdq_1 : protoOf(TypedPublishedWorkImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedBookImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(BookConcept_getInstance().caw_1.e6s_1)) {
      this.fdq_1 = value;
    } else {
      protoOf(TypedPublishedWorkImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedCardinalityBoundConstantImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CardinalityBoundConstantConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityBoundConstantConcept_getInstance().e6r_1) : nodeId;
    TypedCardinalityBoundImpl.call(this, context, conceptId, nodeId);
    this.jdr_1 = null;
  }
  protoOf(TypedCardinalityBoundConstantImpl).y = function () {
    return this.n6o(CardinalityBoundConstantConcept_getInstance().paw_1);
  };
  protoOf(TypedCardinalityBoundConstantImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedCardinalityBoundConstantImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.jdr_1 == null)) {
      this_0.e(CardinalityBoundConstantConcept_getInstance().paw_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedCardinalityBoundImpl).y2z.call(this));
  };
  protoOf(TypedCardinalityBoundConstantImpl).c3b = function (nodeId) {
    return new TypedCardinalityBoundConstantImpl(this.a6o_1, CardinalityBoundConstantConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedCardinalityBoundConstantImpl).l6o = function (propertyId) {
    return propertyId.equals(CardinalityBoundConstantConcept_getInstance().paw_1.e6s_1) ? this.jdr_1 : protoOf(TypedCardinalityBoundImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedCardinalityBoundConstantImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(CardinalityBoundConstantConcept_getInstance().paw_1.e6s_1)) {
      this.jdr_1 = value;
    } else {
      protoOf(TypedCardinalityBoundImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedCardinalityBoundImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CardinalityBoundConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityBoundConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedCardinalityBoundImpl).c3b = function (nodeId) {
    return new TypedCardinalityBoundImpl(this.a6o_1, CardinalityBoundConcept_getInstance().e6r_1, nodeId);
  };
  function TypedCardinalityBoundNImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CardinalityBoundNConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityBoundNConcept_getInstance().e6r_1) : nodeId;
    TypedCardinalityBoundImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedCardinalityBoundNImpl).c3b = function (nodeId) {
    return new TypedCardinalityBoundNImpl(this.a6o_1, CardinalityBoundNConcept_getInstance().e6r_1, nodeId);
  };
  function _get_boundField__2bbh0v($this) {
    if ($this.uds_1 == null) {
      $this.uds_1 = $this.t6o(CardinalityBoundPlaceholderConcept_getInstance().bax_1);
    }
    return ensureNotNull($this.uds_1);
  }
  function TypedCardinalityBoundPlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CardinalityBoundPlaceholderConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityBoundPlaceholderConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.uds_1 = null;
  }
  protoOf(TypedCardinalityBoundPlaceholderImpl).cax = function () {
    return this.v6o(_get_boundField__2bbh0v(this));
  };
  protoOf(TypedCardinalityBoundPlaceholderImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedCardinalityBoundPlaceholderImpl.<get-childIds>.<anonymous>' call
    if (!(this.uds_1 == null)) {
      this_0.e(CardinalityBoundPlaceholderConcept_getInstance().bax_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedCardinalityBoundPlaceholderImpl).c3b = function (nodeId) {
    return new TypedCardinalityBoundPlaceholderImpl(this.a6o_1, CardinalityBoundPlaceholderConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedCardinalityBoundPlaceholderImpl).l38 = function (childId) {
    return childId.equals(CardinalityBoundPlaceholderConcept_getInstance().bax_1.u6o_1) ? _get_boundField__2bbh0v(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedCardinalityCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CardinalityCustomCellConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityCustomCellConcept_getInstance().e6r_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedCardinalityCustomCellImpl).c3b = function (nodeId) {
    return new TypedCardinalityCustomCellImpl(this.a6o_1, CardinalityCustomCellConcept_getInstance().e6r_1, nodeId);
  };
  function _get_lowerBoundField__30y1f8($this) {
    if ($this.tdt_1 == null) {
      $this.tdt_1 = $this.t6o(CardinalityConcept_getInstance().qax_1);
    }
    return ensureNotNull($this.tdt_1);
  }
  function _get_upperBoundField__ahukc3($this) {
    if ($this.udt_1 == null) {
      $this.udt_1 = $this.t6o(CardinalityConcept_getInstance().rax_1);
    }
    return ensureNotNull($this.udt_1);
  }
  function _get_deprecatedUpperBoundField__ezod52($this) {
    if ($this.vdt_1 == null) {
      $this.vdt_1 = $this.t6o(CardinalityConcept_getInstance().sax_1);
    }
    return ensureNotNull($this.vdt_1);
  }
  function TypedCardinalityImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CardinalityConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CardinalityConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.tdt_1 = null;
    this.udt_1 = null;
    this.vdt_1 = null;
  }
  protoOf(TypedCardinalityImpl).tax = function () {
    return this.v6o(_get_lowerBoundField__30y1f8(this));
  };
  protoOf(TypedCardinalityImpl).uax = function () {
    return this.v6o(_get_upperBoundField__ahukc3(this));
  };
  protoOf(TypedCardinalityImpl).vax = function () {
    return this.v6o(_get_deprecatedUpperBoundField__ezod52(this));
  };
  protoOf(TypedCardinalityImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedCardinalityImpl.<get-childIds>.<anonymous>' call
    if (!(this.tdt_1 == null)) {
      this_0.e(CardinalityConcept_getInstance().qax_1.u6o_1);
    }
    if (!(this.udt_1 == null)) {
      this_0.e(CardinalityConcept_getInstance().rax_1.u6o_1);
    }
    if (!(this.vdt_1 == null)) {
      this_0.e(CardinalityConcept_getInstance().sax_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedCardinalityImpl).c3b = function (nodeId) {
    return new TypedCardinalityImpl(this.a6o_1, CardinalityConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedCardinalityImpl).l38 = function (childId) {
    return childId.equals(CardinalityConcept_getInstance().qax_1.u6o_1) ? _get_lowerBoundField__30y1f8(this) : childId.equals(CardinalityConcept_getInstance().rax_1.u6o_1) ? _get_upperBoundField__ahukc3(this) : childId.equals(CardinalityConcept_getInstance().sax_1.u6o_1) ? _get_deprecatedUpperBoundField__ezod52(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_libraryField__um0bho($this) {
    if ($this.idu_1 == null) {
      $this.idu_1 = $this.t6o(CategoryConcept_getInstance().iay_1);
    }
    return ensureNotNull($this.idu_1);
  }
  function _get_elementField__q1p5qr($this) {
    if ($this.jdu_1 == null) {
      $this.jdu_1 = $this.t6o(CategoryConcept_getInstance().jay_1);
    }
    return ensureNotNull($this.jdu_1);
  }
  function TypedCategoryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CategoryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CategoryConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.idu_1 = null;
    this.jdu_1 = null;
  }
  protoOf(TypedCategoryImpl).kay = function () {
    return this.v6o(_get_libraryField__um0bho(this));
  };
  protoOf(TypedCategoryImpl).lay = function () {
    return this.v6o(_get_elementField__q1p5qr(this));
  };
  protoOf(TypedCategoryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedCategoryImpl.<get-childIds>.<anonymous>' call
    if (!(this.idu_1 == null)) {
      this_0.e(CategoryConcept_getInstance().iay_1.u6o_1);
    }
    if (!(this.jdu_1 == null)) {
      this_0.e(CategoryConcept_getInstance().jay_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedCategoryImpl).c3b = function (nodeId) {
    return new TypedCategoryImpl(this.a6o_1, CategoryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedCategoryImpl).l38 = function (childId) {
    return childId.equals(CategoryConcept_getInstance().iay_1.u6o_1) ? _get_libraryField__um0bho(this) : childId.equals(CategoryConcept_getInstance().jay_1.u6o_1) ? _get_elementField__q1p5qr(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedClassExpressionPlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ClassExpressionPlaceholderConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ClassExpressionPlaceholderConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedClassExpressionPlaceholderImpl).c3b = function (nodeId) {
    return new TypedClassExpressionPlaceholderImpl(this.a6o_1, ClassExpressionPlaceholderConcept_getInstance().e6r_1, nodeId);
  };
  function _get_classExpressionField__3dueap($this) {
    if ($this.idv_1 == null) {
      $this.idv_1 = $this.t6o(ClassExpressionTypeConcept_getInstance().xay_1);
    }
    return ensureNotNull($this.idv_1);
  }
  function TypedClassExpressionTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ClassExpressionTypeConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ClassExpressionTypeConcept_getInstance().e6r_1) : nodeId;
    TypedTypeImpl.call(this, context, conceptId, nodeId);
    this.idv_1 = null;
  }
  protoOf(TypedClassExpressionTypeImpl).yay = function () {
    return this.v6o(_get_classExpressionField__3dueap(this));
  };
  protoOf(TypedClassExpressionTypeImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedClassExpressionTypeImpl.<get-childIds>.<anonymous>' call
    if (!(this.idv_1 == null)) {
      this_0.e(ClassExpressionTypeConcept_getInstance().xay_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedTypeImpl).v2z.call(this));
  };
  protoOf(TypedClassExpressionTypeImpl).c3b = function (nodeId) {
    return new TypedClassExpressionTypeImpl(this.a6o_1, ClassExpressionTypeConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedClassExpressionTypeImpl).l38 = function (childId) {
    return childId.equals(ClassExpressionTypeConcept_getInstance().xay_1.u6o_1) ? _get_classExpressionField__3dueap(this) : protoOf(TypedTypeImpl).l38.call(this, childId);
  };
  function TypedCommandImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function TypedConstantCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ConstantCustomCellConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ConstantCustomCellConcept_getInstance().e6r_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
    this.vdv_1 = null;
  }
  protoOf(TypedConstantCustomCellImpl).laz = function () {
    return this.n6o(ConstantCustomCellConcept_getInstance().kaz_1);
  };
  protoOf(TypedConstantCustomCellImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedConstantCustomCellImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.vdv_1 == null)) {
      this_0.e(ConstantCustomCellConcept_getInstance().kaz_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedCustomCellImpl).y2z.call(this));
  };
  protoOf(TypedConstantCustomCellImpl).c3b = function (nodeId) {
    return new TypedConstantCustomCellImpl(this.a6o_1, ConstantCustomCellConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedConstantCustomCellImpl).l6o = function (propertyId) {
    return propertyId.equals(ConstantCustomCellConcept_getInstance().kaz_1.e6s_1) ? this.vdv_1 : protoOf(TypedCustomCellImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedConstantCustomCellImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(ConstantCustomCellConcept_getInstance().kaz_1.e6s_1)) {
      this.vdv_1 = value;
    } else {
      protoOf(TypedCustomCellImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedConstantPreconditionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ConstantPreconditionConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ConstantPreconditionConcept_getInstance().e6r_1) : nodeId;
    TypedPreconditionImpl.call(this, context, conceptId, nodeId);
    this.idw_1 = null;
  }
  protoOf(TypedConstantPreconditionImpl).r5e = function () {
    return this.n6o(ConstantPreconditionConcept_getInstance().zaz_1);
  };
  protoOf(TypedConstantPreconditionImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedConstantPreconditionImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.idw_1 == null)) {
      this_0.e(ConstantPreconditionConcept_getInstance().zaz_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedPreconditionImpl).y2z.call(this));
  };
  protoOf(TypedConstantPreconditionImpl).c3b = function (nodeId) {
    return new TypedConstantPreconditionImpl(this.a6o_1, ConstantPreconditionConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedConstantPreconditionImpl).l6o = function (propertyId) {
    return propertyId.equals(ConstantPreconditionConcept_getInstance().zaz_1.e6s_1) ? this.idw_1 : protoOf(TypedPreconditionImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedConstantPreconditionImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(ConstantPreconditionConcept_getInstance().zaz_1.e6s_1)) {
      this.idw_1 = value;
    } else {
      protoOf(TypedPreconditionImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_libraryField__um0bho_0($this) {
    if ($this.vdw_1 == null) {
      $this.vdw_1 = $this.t6o(ContextConcept_getInstance().mb0_1);
    }
    return ensureNotNull($this.vdw_1);
  }
  function _get_elementField__q1p5qr_0($this) {
    if ($this.wdw_1 == null) {
      $this.wdw_1 = $this.t6o(ContextConcept_getInstance().nb0_1);
    }
    return ensureNotNull($this.wdw_1);
  }
  function TypedContextImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ContextConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ContextConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.vdw_1 = null;
    this.wdw_1 = null;
    this.xdw_1 = null;
  }
  protoOf(TypedContextImpl).kay = function () {
    return this.v6o(_get_libraryField__um0bho_0(this));
  };
  protoOf(TypedContextImpl).lay = function () {
    return this.v6o(_get_elementField__q1p5qr_0(this));
  };
  protoOf(TypedContextImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedContextImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedContextImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.xdw_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedContextImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedContextImpl.<get-childIds>.<anonymous>' call
    if (!(this.vdw_1 == null)) {
      this_0.e(ContextConcept_getInstance().mb0_1.u6o_1);
    }
    if (!(this.wdw_1 == null)) {
      this_0.e(ContextConcept_getInstance().nb0_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedContextImpl).c3b = function (nodeId) {
    return new TypedContextImpl(this.a6o_1, ContextConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedContextImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.xdw_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedContextImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.xdw_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedContextImpl).l38 = function (childId) {
    return childId.equals(ContextConcept_getInstance().mb0_1.u6o_1) ? _get_libraryField__um0bho_0(this) : childId.equals(ContextConcept_getInstance().nb0_1.u6o_1) ? _get_elementField__q1p5qr_0(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_libraryField__um0bho_1($this) {
    if ($this.kdx_1 == null) {
      $this.kdx_1 = $this.t6o(ContextQueryConcept_getInstance().ab1_1);
    }
    return ensureNotNull($this.kdx_1);
  }
  function _get_elementField__q1p5qr_1($this) {
    if ($this.ldx_1 == null) {
      $this.ldx_1 = $this.t6o(ContextQueryConcept_getInstance().bb1_1);
    }
    return ensureNotNull($this.ldx_1);
  }
  function TypedContextQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ContextQueryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ContextQueryConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.kdx_1 = null;
    this.ldx_1 = null;
  }
  protoOf(TypedContextQueryImpl).kay = function () {
    return this.v6o(_get_libraryField__um0bho_1(this));
  };
  protoOf(TypedContextQueryImpl).lay = function () {
    return this.v6o(_get_elementField__q1p5qr_1(this));
  };
  protoOf(TypedContextQueryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedContextQueryImpl.<get-childIds>.<anonymous>' call
    if (!(this.kdx_1 == null)) {
      this_0.e(ContextQueryConcept_getInstance().ab1_1.u6o_1);
    }
    if (!(this.ldx_1 == null)) {
      this_0.e(ContextQueryConcept_getInstance().bb1_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedContextQueryImpl).c3b = function (nodeId) {
    return new TypedContextQueryImpl(this.a6o_1, ContextQueryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedContextQueryImpl).l38 = function (childId) {
    return childId.equals(ContextQueryConcept_getInstance().ab1_1.u6o_1) ? _get_libraryField__um0bho_1(this) : childId.equals(ContextQueryConcept_getInstance().bb1_1.u6o_1) ? _get_elementField__q1p5qr_1(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedCustomCellImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function _get_cellsField__aghev6($this) {
    if ($this.ydx_1 == null) {
      $this.ydx_1 = $this.w6o(CustomEditorConcept_getInstance().nb1_1);
    }
    return ensureNotNull($this.ydx_1);
  }
  function TypedCustomEditorImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? CustomEditorConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(CustomEditorConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ydx_1 = null;
  }
  protoOf(TypedCustomEditorImpl).ob1 = function () {
    return this.y6o(_get_cellsField__aghev6(this));
  };
  protoOf(TypedCustomEditorImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedCustomEditorImpl.<get-childIds>.<anonymous>' call
    if (!(this.ydx_1 == null)) {
      this_0.e(CustomEditorConcept_getInstance().nb1_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedCustomEditorImpl).c3b = function (nodeId) {
    return new TypedCustomEditorImpl(this.a6o_1, CustomEditorConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedCustomEditorImpl).l38 = function (childId) {
    return childId.equals(CustomEditorConcept_getInstance().nb1_1.x6o_1) ? _get_cellsField__aghev6(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedDeclarationNameCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? DeclarationNameCustomCellConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(DeclarationNameCustomCellConcept_getInstance().e6r_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedDeclarationNameCustomCellImpl).c3b = function (nodeId) {
    return new TypedDeclarationNameCustomCellImpl(this.a6o_1, DeclarationNameCustomCellConcept_getInstance().e6r_1, nodeId);
  };
  function _get_valueField__9y0rz6_1($this) {
    if ($this.xdy_1 == null) {
      $this.xdy_1 = $this.t6o(DeclarationValueQueryConcept_getInstance().ab2_1);
    }
    return ensureNotNull($this.xdy_1);
  }
  function TypedDeclarationValueQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? DeclarationValueQueryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(DeclarationValueQueryConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractBindingValueQueryImpl.call(this, context, conceptId, nodeId);
    this.xdy_1 = null;
  }
  protoOf(TypedDeclarationValueQueryImpl).y = function () {
    return this.v6o(_get_valueField__9y0rz6_1(this));
  };
  protoOf(TypedDeclarationValueQueryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedDeclarationValueQueryImpl.<get-childIds>.<anonymous>' call
    if (!(this.xdy_1 == null)) {
      this_0.e(DeclarationValueQueryConcept_getInstance().ab2_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractBindingValueQueryImpl).v2z.call(this));
  };
  protoOf(TypedDeclarationValueQueryImpl).c3b = function (nodeId) {
    return new TypedDeclarationValueQueryImpl(this.a6o_1, DeclarationValueQueryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedDeclarationValueQueryImpl).l38 = function (childId) {
    return childId.equals(DeclarationValueQueryConcept_getInstance().ab2_1.u6o_1) ? _get_valueField__9y0rz6_1(this) : protoOf(TypedAbstractBindingValueQueryImpl).l38.call(this, childId);
  };
  function TypedDocumentNodeImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.mdo_1 = new DomainNodeInMemoryProperty('');
    this.ndo_1 = new DomainNodeInMemoryProperty('');
  }
  protoOf(TypedDocumentNodeImpl).w6j = function () {
    return this.mdo_1;
  };
  protoOf(TypedDocumentNodeImpl).b3 = function () {
    return this.ndo_1;
  };
  function TypedEmptyBindingEntryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? EmptyBindingEntryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EmptyBindingEntryConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractBindingEntryImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedEmptyBindingEntryImpl).c3b = function (nodeId) {
    return new TypedEmptyBindingEntryImpl(this.a6o_1, EmptyBindingEntryConcept_getInstance().e6r_1, nodeId);
  };
  function TypedEmptyPropertyLibraryElementImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? EmptyPropertyLibraryElementConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EmptyPropertyLibraryElementConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedEmptyPropertyLibraryElementImpl).c3b = function (nodeId) {
    return new TypedEmptyPropertyLibraryElementImpl(this.a6o_1, EmptyPropertyLibraryElementConcept_getInstance().e6r_1, nodeId);
  };
  function TypedEnumValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? EnumValueConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EnumValueConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ie0_1 = null;
    this.je0_1 = this.p6o(EnumValueConcept_getInstance().vb2_1);
  }
  protoOf(TypedEnumValueImpl).wb2 = function () {
    return this.je0_1;
  };
  protoOf(TypedEnumValueImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedEnumValueImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.ie0_1 == null)) {
      this_0.e(EnumValueConcept_getInstance().vb2_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedEnumValueImpl).c3b = function (nodeId) {
    return new TypedEnumValueImpl(this.a6o_1, EnumValueConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedEnumValueImpl).l6o = function (propertyId) {
    return propertyId.equals(EnumValueConcept_getInstance().vb2_1.q6o_1) ? this.ie0_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedEnumValueImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(EnumValueConcept_getInstance().vb2_1.q6o_1)) {
      this.ie0_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_constantsField__xzniww($this) {
    if ($this.xe0_1 == null) {
      $this.xe0_1 = $this.w6o(EnumerableNotionConcept_getInstance().ib3_1);
    }
    return ensureNotNull($this.xe0_1);
  }
  function TypedEnumerableNotionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? EnumerableNotionConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EnumerableNotionConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractNotionImpl.call(this, context, conceptId, nodeId);
    this.xe0_1 = null;
  }
  protoOf(TypedEnumerableNotionImpl).jb3 = function () {
    return this.y6o(_get_constantsField__xzniww(this));
  };
  protoOf(TypedEnumerableNotionImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedEnumerableNotionImpl.<get-childIds>.<anonymous>' call
    if (!(this.xe0_1 == null)) {
      this_0.e(EnumerableNotionConcept_getInstance().ib3_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractNotionImpl).v2z.call(this));
  };
  protoOf(TypedEnumerableNotionImpl).c3b = function (nodeId) {
    return new TypedEnumerableNotionImpl(this.a6o_1, EnumerableNotionConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedEnumerableNotionImpl).l38 = function (childId) {
    return childId.equals(EnumerableNotionConcept_getInstance().ib3_1.x6o_1) ? _get_constantsField__xzniww(this) : protoOf(TypedAbstractNotionImpl).l38.call(this, childId);
  };
  function TypedEnumerationConstantImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? EnumerationConstantConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(EnumerationConstantConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ke1_1 = null;
  }
  protoOf(TypedEnumerationConstantImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedEnumerationConstantImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedEnumerationConstantImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.ke1_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedEnumerationConstantImpl).c3b = function (nodeId) {
    return new TypedEnumerationConstantImpl(this.a6o_1, EnumerationConstantConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedEnumerationConstantImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.ke1_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedEnumerationConstantImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.ke1_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_fieldsField__jxfhm8($this) {
    if ($this.xe1_1 == null) {
      $this.xe1_1 = $this.w6o(ExtensionDeclarationConcept_getInstance().wb3_1);
    }
    return ensureNotNull($this.xe1_1);
  }
  function _get_typeField__jjl181($this) {
    if ($this.ye1_1 == null) {
      $this.ye1_1 = $this.t6o(ExtensionDeclarationConcept_getInstance().xb3_1);
    }
    return ensureNotNull($this.ye1_1);
  }
  function TypedExtensionDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ExtensionDeclarationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ExtensionDeclarationConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.xe1_1 = null;
    this.ye1_1 = null;
    this.ze1_1 = null;
  }
  protoOf(TypedExtensionDeclarationImpl).yb3 = function () {
    return this.y6o(_get_fieldsField__jxfhm8(this));
  };
  protoOf(TypedExtensionDeclarationImpl).zb3 = function () {
    return this.v6o(_get_typeField__jjl181(this));
  };
  protoOf(TypedExtensionDeclarationImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedExtensionDeclarationImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedExtensionDeclarationImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.ze1_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedExtensionDeclarationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedExtensionDeclarationImpl.<get-childIds>.<anonymous>' call
    if (!(this.xe1_1 == null)) {
      this_0.e(ExtensionDeclarationConcept_getInstance().wb3_1.x6o_1);
    }
    if (!(this.ye1_1 == null)) {
      this_0.e(ExtensionDeclarationConcept_getInstance().xb3_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedExtensionDeclarationImpl).c3b = function (nodeId) {
    return new TypedExtensionDeclarationImpl(this.a6o_1, ExtensionDeclarationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedExtensionDeclarationImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.ze1_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedExtensionDeclarationImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.ze1_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedExtensionDeclarationImpl).l38 = function (childId) {
    return childId.equals(ExtensionDeclarationConcept_getInstance().wb3_1.x6o_1) ? _get_fieldsField__jxfhm8(this) : childId.equals(ExtensionDeclarationConcept_getInstance().xb3_1.u6o_1) ? _get_typeField__jjl181(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedExtensionFieldReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ExtensionFieldReferenceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ExtensionFieldReferenceConcept_getInstance().e6r_1) : nodeId;
    TypedPartReferenceOperationImpl.call(this, context, conceptId, nodeId);
    this.me2_1 = null;
    this.ne2_1 = this.p6o(ExtensionFieldReferenceConcept_getInstance().mb4_1);
  }
  protoOf(TypedExtensionFieldReferenceImpl).nb4 = function () {
    return this.ne2_1;
  };
  protoOf(TypedExtensionFieldReferenceImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedExtensionFieldReferenceImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.me2_1 == null)) {
      this_0.e(ExtensionFieldReferenceConcept_getInstance().mb4_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedPartReferenceOperationImpl).y2z.call(this));
  };
  protoOf(TypedExtensionFieldReferenceImpl).c3b = function (nodeId) {
    return new TypedExtensionFieldReferenceImpl(this.a6o_1, ExtensionFieldReferenceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedExtensionFieldReferenceImpl).l6o = function (propertyId) {
    return propertyId.equals(ExtensionFieldReferenceConcept_getInstance().mb4_1.q6o_1) ? this.me2_1 : protoOf(TypedPartReferenceOperationImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedExtensionFieldReferenceImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(ExtensionFieldReferenceConcept_getInstance().mb4_1.q6o_1)) {
      this.me2_1 = value;
    } else {
      protoOf(TypedPartReferenceOperationImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_extensionsField__nt2et1($this) {
    if ($this.ce3_1 == null) {
      $this.ce3_1 = $this.w6o(ExtensionLibraryConcept_getInstance().zb4_1);
    }
    return ensureNotNull($this.ce3_1);
  }
  function TypedExtensionLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ExtensionLibraryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ExtensionLibraryConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.ce3_1 = null;
  }
  protoOf(TypedExtensionLibraryImpl).n9c = function () {
    return this.y6o(_get_extensionsField__nt2et1(this));
  };
  protoOf(TypedExtensionLibraryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedExtensionLibraryImpl.<get-childIds>.<anonymous>' call
    if (!(this.ce3_1 == null)) {
      this_0.e(ExtensionLibraryConcept_getInstance().zb4_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedExtensionLibraryImpl).c3b = function (nodeId) {
    return new TypedExtensionLibraryImpl(this.a6o_1, ExtensionLibraryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedExtensionLibraryImpl).l38 = function (childId) {
    return childId.equals(ExtensionLibraryConcept_getInstance().zb4_1.x6o_1) ? _get_extensionsField__nt2et1(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function TypedFactExpressionPlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FactExpressionPlaceholderConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactExpressionPlaceholderConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedFactExpressionPlaceholderImpl).c3b = function (nodeId) {
    return new TypedFactExpressionPlaceholderImpl(this.a6o_1, FactExpressionPlaceholderConcept_getInstance().e6r_1, nodeId);
  };
  function _get_preconditionField__y5h65t($this) {
    if ($this.be4_1 == null) {
      $this.be4_1 = $this.t6o(FactConcept_getInstance().mb5_1);
    }
    return ensureNotNull($this.be4_1);
  }
  function _get_specificationField__lszznw($this) {
    if ($this.ce4_1 == null) {
      $this.ce4_1 = $this.t6o(FactConcept_getInstance().nb5_1);
    }
    return ensureNotNull($this.ce4_1);
  }
  function TypedFactImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FactConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.be4_1 = null;
    this.ce4_1 = null;
    this.de4_1 = null;
  }
  protoOf(TypedFactImpl).ob5 = function () {
    return this.v6o(_get_preconditionField__y5h65t(this));
  };
  protoOf(TypedFactImpl).pb5 = function () {
    return this.v6o(_get_specificationField__lszznw(this));
  };
  protoOf(TypedFactImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedFactImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFactImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.de4_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedFactImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFactImpl.<get-childIds>.<anonymous>' call
    if (!(this.be4_1 == null)) {
      this_0.e(FactConcept_getInstance().mb5_1.u6o_1);
    }
    if (!(this.ce4_1 == null)) {
      this_0.e(FactConcept_getInstance().nb5_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedFactImpl).c3b = function (nodeId) {
    return new TypedFactImpl(this.a6o_1, FactConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedFactImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.de4_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedFactImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.de4_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedFactImpl).l38 = function (childId) {
    return childId.equals(FactConcept_getInstance().mb5_1.u6o_1) ? _get_preconditionField__y5h65t(this) : childId.equals(FactConcept_getInstance().nb5_1.u6o_1) ? _get_specificationField__lszznw(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_factsField__7q8854($this) {
    if ($this.qe4_1 == null) {
      $this.qe4_1 = $this.w6o(FactPreconditionConcept_getInstance().cb6_1);
    }
    return ensureNotNull($this.qe4_1);
  }
  function TypedFactPreconditionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FactPreconditionConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactPreconditionConcept_getInstance().e6r_1) : nodeId;
    TypedPreconditionImpl.call(this, context, conceptId, nodeId);
    this.qe4_1 = null;
    this.re4_1 = null;
    this.se4_1 = this.p6o(FactPreconditionConcept_getInstance().db6_1);
  }
  protoOf(TypedFactPreconditionImpl).fb6 = function () {
    return this.y6o(_get_factsField__7q8854(this));
  };
  protoOf(TypedFactPreconditionImpl).gb6 = function () {
    return this.se4_1;
  };
  protoOf(TypedFactPreconditionImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFactPreconditionImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.re4_1 == null)) {
      this_0.e(FactPreconditionConcept_getInstance().db6_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedPreconditionImpl).y2z.call(this));
  };
  protoOf(TypedFactPreconditionImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFactPreconditionImpl.<get-childIds>.<anonymous>' call
    if (!(this.qe4_1 == null)) {
      this_0.e(FactPreconditionConcept_getInstance().cb6_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedPreconditionImpl).v2z.call(this));
  };
  protoOf(TypedFactPreconditionImpl).c3b = function (nodeId) {
    return new TypedFactPreconditionImpl(this.a6o_1, FactPreconditionConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedFactPreconditionImpl).l6o = function (propertyId) {
    return propertyId.equals(FactPreconditionConcept_getInstance().db6_1.q6o_1) ? this.re4_1 : protoOf(TypedPreconditionImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedFactPreconditionImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(FactPreconditionConcept_getInstance().db6_1.q6o_1)) {
      this.re4_1 = value;
    } else {
      protoOf(TypedPreconditionImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedFactPreconditionImpl).l38 = function (childId) {
    return childId.equals(FactPreconditionConcept_getInstance().cb6_1.x6o_1) ? _get_factsField__7q8854(this) : protoOf(TypedPreconditionImpl).l38.call(this, childId);
  };
  function TypedFactReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FactReferenceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactReferenceConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.fe5_1 = null;
    this.ge5_1 = this.p6o(FactReferenceConcept_getInstance().tb6_1);
  }
  protoOf(TypedFactReferenceImpl).ub6 = function () {
    return this.ge5_1;
  };
  protoOf(TypedFactReferenceImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFactReferenceImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.fe5_1 == null)) {
      this_0.e(FactReferenceConcept_getInstance().tb6_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedFactReferenceImpl).c3b = function (nodeId) {
    return new TypedFactReferenceImpl(this.a6o_1, FactReferenceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedFactReferenceImpl).l6o = function (propertyId) {
    return propertyId.equals(FactReferenceConcept_getInstance().tb6_1.q6o_1) ? this.fe5_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedFactReferenceImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(FactReferenceConcept_getInstance().tb6_1.q6o_1)) {
      this.fe5_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_factsContextField__2692qp($this) {
    if ($this.te5_1 == null) {
      $this.te5_1 = $this.t6o(FactSetConcept_getInstance().jb7_1);
    }
    return ensureNotNull($this.te5_1);
  }
  function _get_contextsField__9rt25h($this) {
    if ($this.ue5_1 == null) {
      $this.ue5_1 = $this.w6o(FactSetConcept_getInstance().kb7_1);
    }
    return ensureNotNull($this.ue5_1);
  }
  function _get_factsField__7q8854_0($this) {
    if ($this.ve5_1 == null) {
      $this.ve5_1 = $this.w6o(FactSetConcept_getInstance().lb7_1);
    }
    return ensureNotNull($this.ve5_1);
  }
  function _get_newFactsField__f3knr6($this) {
    if ($this.we5_1 == null) {
      $this.we5_1 = $this.w6o(FactSetConcept_getInstance().mb7_1);
    }
    return ensureNotNull($this.we5_1);
  }
  function _get_sourcesField__ca0b6f($this) {
    if ($this.ye5_1 == null) {
      $this.ye5_1 = $this.w6o(HasKnowledgeSourcesConcept_getInstance().tbb_1);
    }
    return ensureNotNull($this.ye5_1);
  }
  function _get_commentField__ylav5c_0($this) {
    if ($this.ze5_1 == null) {
      $this.ze5_1 = $this.t6o(HasCommentsConcept_getInstance().bbb_1);
    }
    return ensureNotNull($this.ze5_1);
  }
  function _get_variablesField__8i4vo8($this) {
    if ($this.ae6_1 == null) {
      $this.ae6_1 = $this.w6o(HasVariablesConcept_getInstance().xbc_1);
    }
    return ensureNotNull($this.ae6_1);
  }
  function TypedFactSetImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FactSetConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactSetConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.te5_1 = null;
    this.ue5_1 = null;
    this.ve5_1 = null;
    this.we5_1 = null;
    this.xe5_1 = null;
    this.ye5_1 = null;
    this.ze5_1 = null;
    this.ae6_1 = null;
  }
  protoOf(TypedFactSetImpl).nb7 = function () {
    return this.v6o(_get_factsContextField__2692qp(this));
  };
  protoOf(TypedFactSetImpl).ob7 = function () {
    return this.y6o(_get_contextsField__9rt25h(this));
  };
  protoOf(TypedFactSetImpl).fb6 = function () {
    return this.y6o(_get_factsField__7q8854_0(this));
  };
  protoOf(TypedFactSetImpl).pb7 = function () {
    return this.y6o(_get_newFactsField__f3knr6(this));
  };
  protoOf(TypedFactSetImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedFactSetImpl).ubb = function () {
    return this.y6o(_get_sourcesField__ca0b6f(this));
  };
  protoOf(TypedFactSetImpl).cbb = function () {
    return this.v6o(_get_commentField__ylav5c_0(this));
  };
  protoOf(TypedFactSetImpl).ybc = function () {
    return this.y6o(_get_variablesField__8i4vo8(this));
  };
  protoOf(TypedFactSetImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFactSetImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.xe5_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedFactSetImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFactSetImpl.<get-childIds>.<anonymous>' call
    if (!(this.te5_1 == null)) {
      this_0.e(FactSetConcept_getInstance().jb7_1.u6o_1);
    }
    if (!(this.ue5_1 == null)) {
      this_0.e(FactSetConcept_getInstance().kb7_1.x6o_1);
    }
    if (!(this.ve5_1 == null)) {
      this_0.e(FactSetConcept_getInstance().lb7_1.x6o_1);
    }
    if (!(this.we5_1 == null)) {
      this_0.e(FactSetConcept_getInstance().mb7_1.x6o_1);
    }
    if (!(this.ye5_1 == null)) {
      this_0.e(HasKnowledgeSourcesConcept_getInstance().tbb_1.x6o_1);
    }
    if (!(this.ze5_1 == null)) {
      this_0.e(HasCommentsConcept_getInstance().bbb_1.u6o_1);
    }
    if (!(this.ae6_1 == null)) {
      this_0.e(HasVariablesConcept_getInstance().xbc_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedFactSetImpl).c3b = function (nodeId) {
    return new TypedFactSetImpl(this.a6o_1, FactSetConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedFactSetImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.xe5_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedFactSetImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.xe5_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedFactSetImpl).l38 = function (childId) {
    return childId.equals(FactSetConcept_getInstance().jb7_1.u6o_1) ? _get_factsContextField__2692qp(this) : childId.equals(FactSetConcept_getInstance().kb7_1.x6o_1) ? _get_contextsField__9rt25h(this) : childId.equals(FactSetConcept_getInstance().lb7_1.x6o_1) ? _get_factsField__7q8854_0(this) : childId.equals(FactSetConcept_getInstance().mb7_1.x6o_1) ? _get_newFactsField__f3knr6(this) : childId.equals(HasKnowledgeSourcesConcept_getInstance().tbb_1.x6o_1) ? _get_sourcesField__ca0b6f(this) : childId.equals(HasCommentsConcept_getInstance().bbb_1.u6o_1) ? _get_commentField__ylav5c_0(this) : childId.equals(HasVariablesConcept_getInstance().xbc_1.x6o_1) ? _get_variablesField__8i4vo8(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_typeField__jjl181_0($this) {
    if ($this.ne6_1 == null) {
      $this.ne6_1 = $this.t6o(FieldDeclarationConcept_getInstance().cb8_1);
    }
    return ensureNotNull($this.ne6_1);
  }
  function _get_cardinalityField__qxjnpd($this) {
    if ($this.oe6_1 == null) {
      $this.oe6_1 = $this.t6o(FieldDeclarationConcept_getInstance().db8_1);
    }
    return ensureNotNull($this.oe6_1);
  }
  function TypedFieldDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FieldDeclarationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FieldDeclarationConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ne6_1 = null;
    this.oe6_1 = null;
    this.pe6_1 = null;
  }
  protoOf(TypedFieldDeclarationImpl).zb3 = function () {
    return this.v6o(_get_typeField__jjl181_0(this));
  };
  protoOf(TypedFieldDeclarationImpl).eb8 = function () {
    return this.v6o(_get_cardinalityField__qxjnpd(this));
  };
  protoOf(TypedFieldDeclarationImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedFieldDeclarationImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFieldDeclarationImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.pe6_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedFieldDeclarationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFieldDeclarationImpl.<get-childIds>.<anonymous>' call
    if (!(this.ne6_1 == null)) {
      this_0.e(FieldDeclarationConcept_getInstance().cb8_1.u6o_1);
    }
    if (!(this.oe6_1 == null)) {
      this_0.e(FieldDeclarationConcept_getInstance().db8_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedFieldDeclarationImpl).c3b = function (nodeId) {
    return new TypedFieldDeclarationImpl(this.a6o_1, FieldDeclarationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedFieldDeclarationImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.pe6_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedFieldDeclarationImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.pe6_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedFieldDeclarationImpl).l38 = function (childId) {
    return childId.equals(FieldDeclarationConcept_getInstance().cb8_1.u6o_1) ? _get_typeField__jjl181_0(this) : childId.equals(FieldDeclarationConcept_getInstance().db8_1.u6o_1) ? _get_cardinalityField__qxjnpd(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_contextQueryField__q258kw($this) {
    if ($this.ce7_1 == null) {
      $this.ce7_1 = $this.t6o(FindConnectionCommandConcept_getInstance().sb8_1);
    }
    return ensureNotNull($this.ce7_1);
  }
  function _get_fromField__7qc8o1($this) {
    if ($this.de7_1 == null) {
      $this.de7_1 = $this.t6o(FindConnectionCommandConcept_getInstance().tb8_1);
    }
    return ensureNotNull($this.de7_1);
  }
  function _get_toField__k0vny($this) {
    if ($this.ee7_1 == null) {
      $this.ee7_1 = $this.t6o(FindConnectionCommandConcept_getInstance().ub8_1);
    }
    return ensureNotNull($this.ee7_1);
  }
  function TypedFindConnectionCommandImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FindConnectionCommandConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FindConnectionCommandConcept_getInstance().e6r_1) : nodeId;
    TypedCommandImpl.call(this, context, conceptId, nodeId);
    this.ce7_1 = null;
    this.de7_1 = null;
    this.ee7_1 = null;
  }
  protoOf(TypedFindConnectionCommandImpl).vb8 = function () {
    return this.v6o(_get_contextQueryField__q258kw(this));
  };
  protoOf(TypedFindConnectionCommandImpl).g3x = function () {
    return this.v6o(_get_fromField__7qc8o1(this));
  };
  protoOf(TypedFindConnectionCommandImpl).h3x = function () {
    return this.v6o(_get_toField__k0vny(this));
  };
  protoOf(TypedFindConnectionCommandImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFindConnectionCommandImpl.<get-childIds>.<anonymous>' call
    if (!(this.ce7_1 == null)) {
      this_0.e(FindConnectionCommandConcept_getInstance().sb8_1.u6o_1);
    }
    if (!(this.de7_1 == null)) {
      this_0.e(FindConnectionCommandConcept_getInstance().tb8_1.u6o_1);
    }
    if (!(this.ee7_1 == null)) {
      this_0.e(FindConnectionCommandConcept_getInstance().ub8_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedCommandImpl).v2z.call(this));
  };
  protoOf(TypedFindConnectionCommandImpl).c3b = function (nodeId) {
    return new TypedFindConnectionCommandImpl(this.a6o_1, FindConnectionCommandConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedFindConnectionCommandImpl).l38 = function (childId) {
    return childId.equals(FindConnectionCommandConcept_getInstance().sb8_1.u6o_1) ? _get_contextQueryField__q258kw(this) : childId.equals(FindConnectionCommandConcept_getInstance().tb8_1.u6o_1) ? _get_fromField__7qc8o1(this) : childId.equals(FindConnectionCommandConcept_getInstance().ub8_1.u6o_1) ? _get_toField__k0vny(this) : protoOf(TypedCommandImpl).l38.call(this, childId);
  };
  function _get_returnTypeField__h3naf5($this) {
    if ($this.ye7_1 == null) {
      $this.ye7_1 = $this.t6o(FunctionDeclarationConcept_getInstance().ib9_1);
    }
    return ensureNotNull($this.ye7_1);
  }
  function _get_cardinalityField__qxjnpd_0($this) {
    if ($this.ze7_1 == null) {
      $this.ze7_1 = $this.t6o(FunctionDeclarationConcept_getInstance().jb9_1);
    }
    return ensureNotNull($this.ze7_1);
  }
  function TypedFunctionDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FunctionDeclarationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FunctionDeclarationConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractBindingDeclarationImpl.call(this, context, conceptId, nodeId);
    this.ye7_1 = null;
    this.ze7_1 = null;
  }
  protoOf(TypedFunctionDeclarationImpl).kb9 = function () {
    return this.v6o(_get_returnTypeField__h3naf5(this));
  };
  protoOf(TypedFunctionDeclarationImpl).eb8 = function () {
    return this.v6o(_get_cardinalityField__qxjnpd_0(this));
  };
  protoOf(TypedFunctionDeclarationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFunctionDeclarationImpl.<get-childIds>.<anonymous>' call
    if (!(this.ye7_1 == null)) {
      this_0.e(FunctionDeclarationConcept_getInstance().ib9_1.u6o_1);
    }
    if (!(this.ze7_1 == null)) {
      this_0.e(FunctionDeclarationConcept_getInstance().jb9_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractBindingDeclarationImpl).v2z.call(this));
  };
  protoOf(TypedFunctionDeclarationImpl).c3b = function (nodeId) {
    return new TypedFunctionDeclarationImpl(this.a6o_1, FunctionDeclarationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedFunctionDeclarationImpl).l38 = function (childId) {
    return childId.equals(FunctionDeclarationConcept_getInstance().ib9_1.u6o_1) ? _get_returnTypeField__h3naf5(this) : childId.equals(FunctionDeclarationConcept_getInstance().jb9_1.u6o_1) ? _get_cardinalityField__qxjnpd_0(this) : protoOf(TypedAbstractBindingDeclarationImpl).l38.call(this, childId);
  };
  function _get_functionsField__8q6zm4($this) {
    if ($this.oe8_1 == null) {
      $this.oe8_1 = $this.w6o(FunctionLibraryConcept_getInstance().wb9_1);
    }
    return ensureNotNull($this.oe8_1);
  }
  function TypedFunctionLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FunctionLibraryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FunctionLibraryConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.oe8_1 = null;
  }
  protoOf(TypedFunctionLibraryImpl).xb9 = function () {
    return this.y6o(_get_functionsField__8q6zm4(this));
  };
  protoOf(TypedFunctionLibraryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFunctionLibraryImpl.<get-childIds>.<anonymous>' call
    if (!(this.oe8_1 == null)) {
      this_0.e(FunctionLibraryConcept_getInstance().wb9_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedFunctionLibraryImpl).c3b = function (nodeId) {
    return new TypedFunctionLibraryImpl(this.a6o_1, FunctionLibraryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedFunctionLibraryImpl).l38 = function (childId) {
    return childId.equals(FunctionLibraryConcept_getInstance().wb9_1.x6o_1) ? _get_functionsField__8q6zm4(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function _get_parametersField__3o4zz3($this) {
    if ($this.ee9_1 == null) {
      $this.ee9_1 = $this.w6o(FunctionTermConcept_getInstance().qba_1);
    }
    return ensureNotNull($this.ee9_1);
  }
  function TypedFunctionTermImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? FunctionTermConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FunctionTermConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.be9_1 = null;
    this.ce9_1 = this.p6o(FunctionTermConcept_getInstance().oba_1);
    this.de9_1 = null;
    this.ee9_1 = null;
  }
  protoOf(TypedFunctionTermImpl).rba = function () {
    return this.ce9_1;
  };
  protoOf(TypedFunctionTermImpl).sba = function () {
    return this.n6o(FunctionTermConcept_getInstance().pba_1);
  };
  protoOf(TypedFunctionTermImpl).tba = function () {
    return this.y6o(_get_parametersField__3o4zz3(this));
  };
  protoOf(TypedFunctionTermImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFunctionTermImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.be9_1 == null)) {
      this_0.e(FunctionTermConcept_getInstance().oba_1.q6o_1);
    }
    if (!(this.de9_1 == null)) {
      this_0.e(FunctionTermConcept_getInstance().pba_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedFunctionTermImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedFunctionTermImpl.<get-childIds>.<anonymous>' call
    if (!(this.ee9_1 == null)) {
      this_0.e(FunctionTermConcept_getInstance().qba_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedFunctionTermImpl).c3b = function (nodeId) {
    return new TypedFunctionTermImpl(this.a6o_1, FunctionTermConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedFunctionTermImpl).l6o = function (propertyId) {
    return propertyId.equals(FunctionTermConcept_getInstance().oba_1.q6o_1) ? this.be9_1 : propertyId.equals(FunctionTermConcept_getInstance().pba_1.e6s_1) ? this.de9_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedFunctionTermImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(FunctionTermConcept_getInstance().oba_1.q6o_1)) {
      this.be9_1 = value;
    } else if (propertyId.equals(FunctionTermConcept_getInstance().pba_1.e6s_1)) {
      this.de9_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedFunctionTermImpl).l38 = function (childId) {
    return childId.equals(FunctionTermConcept_getInstance().qba_1.x6o_1) ? _get_parametersField__3o4zz3(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedImportedLinkImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ImportedLinkConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ImportedLinkConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractLinkImpl.call(this, context, conceptId, nodeId);
    this.te9_1 = null;
    this.ue9_1 = this.p6o(ImportedLinkConcept_getInstance().lbd_1);
  }
  protoOf(TypedImportedLinkImpl).mbd = function () {
    return this.ue9_1;
  };
  protoOf(TypedImportedLinkImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedImportedLinkImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.te9_1 == null)) {
      this_0.e(ImportedLinkConcept_getInstance().lbd_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractLinkImpl).y2z.call(this));
  };
  protoOf(TypedImportedLinkImpl).c3b = function (nodeId) {
    return new TypedImportedLinkImpl(this.a6o_1, ImportedLinkConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedImportedLinkImpl).l6o = function (propertyId) {
    return propertyId.equals(ImportedLinkConcept_getInstance().lbd_1.q6o_1) ? this.te9_1 : protoOf(TypedAbstractLinkImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedImportedLinkImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(ImportedLinkConcept_getInstance().lbd_1.q6o_1)) {
      this.te9_1 = value;
    } else {
      protoOf(TypedAbstractLinkImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedImportedPropertyImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ImportedPropertyConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ImportedPropertyConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractPropertyImpl.call(this, context, conceptId, nodeId);
    this.hea_1 = null;
    this.iea_1 = this.p6o(ImportedPropertyConcept_getInstance().zbd_1);
  }
  protoOf(TypedImportedPropertyImpl).mbd = function () {
    return this.iea_1;
  };
  protoOf(TypedImportedPropertyImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedImportedPropertyImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.hea_1 == null)) {
      this_0.e(ImportedPropertyConcept_getInstance().zbd_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractPropertyImpl).y2z.call(this));
  };
  protoOf(TypedImportedPropertyImpl).c3b = function (nodeId) {
    return new TypedImportedPropertyImpl(this.a6o_1, ImportedPropertyConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedImportedPropertyImpl).l6o = function (propertyId) {
    return propertyId.equals(ImportedPropertyConcept_getInstance().zbd_1.q6o_1) ? this.hea_1 : protoOf(TypedAbstractPropertyImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedImportedPropertyImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(ImportedPropertyConcept_getInstance().zbd_1.q6o_1)) {
      this.hea_1 = value;
    } else {
      protoOf(TypedAbstractPropertyImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_domainField__27e0qt($this) {
    if ($this.vea_1 == null) {
      $this.vea_1 = $this.t6o(InstanceRelationDeclarationConcept_getInstance().mbe_1);
    }
    return ensureNotNull($this.vea_1);
  }
  function _get_rangeField__ko1zla($this) {
    if ($this.wea_1 == null) {
      $this.wea_1 = $this.t6o(InstanceRelationDeclarationConcept_getInstance().nbe_1);
    }
    return ensureNotNull($this.wea_1);
  }
  function TypedInstanceRelationDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? InstanceRelationDeclarationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(InstanceRelationDeclarationConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.vea_1 = null;
    this.wea_1 = null;
    this.xea_1 = null;
  }
  protoOf(TypedInstanceRelationDeclarationImpl).obe = function () {
    return this.v6o(_get_domainField__27e0qt(this));
  };
  protoOf(TypedInstanceRelationDeclarationImpl).be = function () {
    return this.v6o(_get_rangeField__ko1zla(this));
  };
  protoOf(TypedInstanceRelationDeclarationImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedInstanceRelationDeclarationImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedInstanceRelationDeclarationImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.xea_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedInstanceRelationDeclarationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedInstanceRelationDeclarationImpl.<get-childIds>.<anonymous>' call
    if (!(this.vea_1 == null)) {
      this_0.e(InstanceRelationDeclarationConcept_getInstance().mbe_1.u6o_1);
    }
    if (!(this.wea_1 == null)) {
      this_0.e(InstanceRelationDeclarationConcept_getInstance().nbe_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedInstanceRelationDeclarationImpl).c3b = function (nodeId) {
    return new TypedInstanceRelationDeclarationImpl(this.a6o_1, InstanceRelationDeclarationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedInstanceRelationDeclarationImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.xea_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedInstanceRelationDeclarationImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.xea_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedInstanceRelationDeclarationImpl).l38 = function (childId) {
    return childId.equals(InstanceRelationDeclarationConcept_getInstance().mbe_1.u6o_1) ? _get_domainField__27e0qt(this) : childId.equals(InstanceRelationDeclarationConcept_getInstance().nbe_1.u6o_1) ? _get_rangeField__ko1zla(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_valueField__9y0rz6_2($this) {
    if ($this.keb_1 == null) {
      $this.keb_1 = $this.t6o(InstanceRelationValueConcept_getInstance().bbf_1);
    }
    return ensureNotNull($this.keb_1);
  }
  function TypedInstanceRelationValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? InstanceRelationValueConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(InstanceRelationValueConcept_getInstance().e6r_1) : nodeId;
    TypedInstanceRelationValuePlaceholderImpl.call(this, context, conceptId, nodeId);
    this.keb_1 = null;
    this.leb_1 = null;
    this.meb_1 = this.p6o(InstanceRelationValueConcept_getInstance().cbf_1);
  }
  protoOf(TypedInstanceRelationValueImpl).y = function () {
    return this.v6o(_get_valueField__9y0rz6_2(this));
  };
  protoOf(TypedInstanceRelationValueImpl).gb6 = function () {
    return this.meb_1;
  };
  protoOf(TypedInstanceRelationValueImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedInstanceRelationValueImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.leb_1 == null)) {
      this_0.e(InstanceRelationValueConcept_getInstance().cbf_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedInstanceRelationValuePlaceholderImpl).y2z.call(this));
  };
  protoOf(TypedInstanceRelationValueImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedInstanceRelationValueImpl.<get-childIds>.<anonymous>' call
    if (!(this.keb_1 == null)) {
      this_0.e(InstanceRelationValueConcept_getInstance().bbf_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedInstanceRelationValuePlaceholderImpl).v2z.call(this));
  };
  protoOf(TypedInstanceRelationValueImpl).c3b = function (nodeId) {
    return new TypedInstanceRelationValueImpl(this.a6o_1, InstanceRelationValueConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedInstanceRelationValueImpl).l6o = function (propertyId) {
    return propertyId.equals(InstanceRelationValueConcept_getInstance().cbf_1.q6o_1) ? this.leb_1 : protoOf(TypedInstanceRelationValuePlaceholderImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedInstanceRelationValueImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(InstanceRelationValueConcept_getInstance().cbf_1.q6o_1)) {
      this.leb_1 = value;
    } else {
      protoOf(TypedInstanceRelationValuePlaceholderImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedInstanceRelationValueImpl).l38 = function (childId) {
    return childId.equals(InstanceRelationValueConcept_getInstance().bbf_1.u6o_1) ? _get_valueField__9y0rz6_2(this) : protoOf(TypedInstanceRelationValuePlaceholderImpl).l38.call(this, childId);
  };
  function TypedInstanceRelationValuePlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? InstanceRelationValuePlaceholderConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(InstanceRelationValuePlaceholderConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedInstanceRelationValuePlaceholderImpl).c3b = function (nodeId) {
    return new TypedInstanceRelationValuePlaceholderImpl(this.a6o_1, InstanceRelationValuePlaceholderConcept_getInstance().e6r_1, nodeId);
  };
  function _get_leftField__72ma9q($this) {
    if ($this.lec_1 == null) {
      $this.lec_1 = $this.t6o(IsExpressionConcept_getInstance().qbf_1);
    }
    return ensureNotNull($this.lec_1);
  }
  function _get_rightField__qpqtcd($this) {
    if ($this.mec_1 == null) {
      $this.mec_1 = $this.t6o(IsExpressionConcept_getInstance().rbf_1);
    }
    return ensureNotNull($this.mec_1);
  }
  function TypedIsExpressionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? IsExpressionConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(IsExpressionConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.lec_1 = null;
    this.mec_1 = null;
  }
  protoOf(TypedIsExpressionImpl).sbf = function () {
    return this.v6o(_get_leftField__72ma9q(this));
  };
  protoOf(TypedIsExpressionImpl).tbf = function () {
    return this.v6o(_get_rightField__qpqtcd(this));
  };
  protoOf(TypedIsExpressionImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedIsExpressionImpl.<get-childIds>.<anonymous>' call
    if (!(this.lec_1 == null)) {
      this_0.e(IsExpressionConcept_getInstance().qbf_1.u6o_1);
    }
    if (!(this.mec_1 == null)) {
      this_0.e(IsExpressionConcept_getInstance().rbf_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedIsExpressionImpl).c3b = function (nodeId) {
    return new TypedIsExpressionImpl(this.a6o_1, IsExpressionConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedIsExpressionImpl).l38 = function (childId) {
    return childId.equals(IsExpressionConcept_getInstance().qbf_1.u6o_1) ? _get_leftField__72ma9q(this) : childId.equals(IsExpressionConcept_getInstance().rbf_1.u6o_1) ? _get_rightField__qpqtcd(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedKindCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? KindCustomCellConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(KindCustomCellConcept_getInstance().e6r_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedKindCustomCellImpl).c3b = function (nodeId) {
    return new TypedKindCustomCellImpl(this.a6o_1, KindCustomCellConcept_getInstance().e6r_1, nodeId);
  };
  function TypedKnowledgeSourceReferenceImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function TypedKnowledgeSourceReferencePlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? KnowledgeSourceReferencePlaceholderConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(KnowledgeSourceReferencePlaceholderConcept_getInstance().e6r_1) : nodeId;
    TypedKnowledgeSourceReferenceImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedKnowledgeSourceReferencePlaceholderImpl).c3b = function (nodeId) {
    return new TypedKnowledgeSourceReferencePlaceholderImpl(this.a6o_1, KnowledgeSourceReferencePlaceholderConcept_getInstance().e6r_1, nodeId);
  };
  function TypedLibraryItemPlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LibraryItemPlaceholderConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LibraryItemPlaceholderConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedLibraryItemPlaceholderImpl).c3b = function (nodeId) {
    return new TypedLibraryItemPlaceholderImpl(this.a6o_1, LibraryItemPlaceholderConcept_getInstance().e6r_1, nodeId);
  };
  function _get_parametersField__3o4zz3_0($this) {
    if ($this.lee_1 == null) {
      $this.lee_1 = $this.w6o(LibraryProcessSpecificationConcept_getInstance().ibg_1);
    }
    return ensureNotNull($this.lee_1);
  }
  function TypedLibraryProcessSpecificationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LibraryProcessSpecificationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LibraryProcessSpecificationConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractProcessSpecificationImpl.call(this, context, conceptId, nodeId);
    this.jee_1 = null;
    this.kee_1 = this.p6o(LibraryProcessSpecificationConcept_getInstance().hbg_1);
    this.lee_1 = null;
  }
  protoOf(TypedLibraryProcessSpecificationImpl).jbg = function () {
    return this.kee_1;
  };
  protoOf(TypedLibraryProcessSpecificationImpl).tba = function () {
    return this.y6o(_get_parametersField__3o4zz3_0(this));
  };
  protoOf(TypedLibraryProcessSpecificationImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedLibraryProcessSpecificationImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.jee_1 == null)) {
      this_0.e(LibraryProcessSpecificationConcept_getInstance().hbg_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractProcessSpecificationImpl).y2z.call(this));
  };
  protoOf(TypedLibraryProcessSpecificationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedLibraryProcessSpecificationImpl.<get-childIds>.<anonymous>' call
    if (!(this.lee_1 == null)) {
      this_0.e(LibraryProcessSpecificationConcept_getInstance().ibg_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractProcessSpecificationImpl).v2z.call(this));
  };
  protoOf(TypedLibraryProcessSpecificationImpl).c3b = function (nodeId) {
    return new TypedLibraryProcessSpecificationImpl(this.a6o_1, LibraryProcessSpecificationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedLibraryProcessSpecificationImpl).l6o = function (propertyId) {
    return propertyId.equals(LibraryProcessSpecificationConcept_getInstance().hbg_1.q6o_1) ? this.jee_1 : protoOf(TypedAbstractProcessSpecificationImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedLibraryProcessSpecificationImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(LibraryProcessSpecificationConcept_getInstance().hbg_1.q6o_1)) {
      this.jee_1 = value;
    } else {
      protoOf(TypedAbstractProcessSpecificationImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedLibraryProcessSpecificationImpl).l38 = function (childId) {
    return childId.equals(LibraryProcessSpecificationConcept_getInstance().ibg_1.x6o_1) ? _get_parametersField__3o4zz3_0(this) : protoOf(TypedAbstractProcessSpecificationImpl).l38.call(this, childId);
  };
  function _get_parametersField__3o4zz3_1($this) {
    if ($this.cef_1 == null) {
      $this.cef_1 = $this.w6o(LibraryProcessSpecificationQueryConcept_getInstance().bbh_1);
    }
    return ensureNotNull($this.cef_1);
  }
  function TypedLibraryProcessSpecificationQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LibraryProcessSpecificationQueryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LibraryProcessSpecificationQueryConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.yee_1 = null;
    this.zee_1 = this.p6o(LibraryProcessSpecificationQueryConcept_getInstance().zbg_1);
    this.aef_1 = null;
    this.bef_1 = this.p6o(LibraryProcessSpecificationQueryConcept_getInstance().abh_1);
    this.cef_1 = null;
  }
  protoOf(TypedLibraryProcessSpecificationQueryImpl).jbg = function () {
    return this.zee_1;
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).r5e = function () {
    return this.bef_1;
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).tba = function () {
    return this.y6o(_get_parametersField__3o4zz3_1(this));
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedLibraryProcessSpecificationQueryImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.yee_1 == null)) {
      this_0.e(LibraryProcessSpecificationQueryConcept_getInstance().zbg_1.q6o_1);
    }
    if (!(this.aef_1 == null)) {
      this_0.e(LibraryProcessSpecificationQueryConcept_getInstance().abh_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedLibraryProcessSpecificationQueryImpl.<get-childIds>.<anonymous>' call
    if (!(this.cef_1 == null)) {
      this_0.e(LibraryProcessSpecificationQueryConcept_getInstance().bbh_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).c3b = function (nodeId) {
    return new TypedLibraryProcessSpecificationQueryImpl(this.a6o_1, LibraryProcessSpecificationQueryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).l6o = function (propertyId) {
    return propertyId.equals(LibraryProcessSpecificationQueryConcept_getInstance().zbg_1.q6o_1) ? this.yee_1 : propertyId.equals(LibraryProcessSpecificationQueryConcept_getInstance().abh_1.q6o_1) ? this.aef_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(LibraryProcessSpecificationQueryConcept_getInstance().zbg_1.q6o_1)) {
      this.yee_1 = value;
    } else if (propertyId.equals(LibraryProcessSpecificationQueryConcept_getInstance().abh_1.q6o_1)) {
      this.aef_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedLibraryProcessSpecificationQueryImpl).l38 = function (childId) {
    return childId.equals(LibraryProcessSpecificationQueryConcept_getInstance().bbh_1.x6o_1) ? _get_parametersField__3o4zz3_1(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedLinkCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LinkCustomCellConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LinkCustomCellConcept_getInstance().e6r_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
    this.pef_1 = null;
    this.qef_1 = this.p6o(LinkCustomCellConcept_getInstance().obh_1);
  }
  protoOf(TypedLinkCustomCellImpl).pbh = function () {
    return this.qef_1;
  };
  protoOf(TypedLinkCustomCellImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedLinkCustomCellImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.pef_1 == null)) {
      this_0.e(LinkCustomCellConcept_getInstance().obh_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedCustomCellImpl).y2z.call(this));
  };
  protoOf(TypedLinkCustomCellImpl).c3b = function (nodeId) {
    return new TypedLinkCustomCellImpl(this.a6o_1, LinkCustomCellConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedLinkCustomCellImpl).l6o = function (propertyId) {
    return propertyId.equals(LinkCustomCellConcept_getInstance().obh_1.q6o_1) ? this.pef_1 : protoOf(TypedCustomCellImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedLinkCustomCellImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(LinkCustomCellConcept_getInstance().obh_1.q6o_1)) {
      this.pef_1 = value;
    } else {
      protoOf(TypedCustomCellImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_typeField__jjl181_1($this) {
    if ($this.eeg_1 == null) {
      $this.eeg_1 = $this.t6o(LinkDeclarationConcept_getInstance().fbi_1);
    }
    return ensureNotNull($this.eeg_1);
  }
  function TypedLinkDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LinkDeclarationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LinkDeclarationConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.deg_1 = null;
    this.eeg_1 = null;
    this.feg_1 = null;
  }
  protoOf(TypedLinkDeclarationImpl).sba = function () {
    return this.n6o(LinkDeclarationConcept_getInstance().ebi_1);
  };
  protoOf(TypedLinkDeclarationImpl).zb3 = function () {
    return this.v6o(_get_typeField__jjl181_1(this));
  };
  protoOf(TypedLinkDeclarationImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedLinkDeclarationImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedLinkDeclarationImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.deg_1 == null)) {
      this_0.e(LinkDeclarationConcept_getInstance().ebi_1.e6s_1);
    }
    if (!(this.feg_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedLinkDeclarationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedLinkDeclarationImpl.<get-childIds>.<anonymous>' call
    if (!(this.eeg_1 == null)) {
      this_0.e(LinkDeclarationConcept_getInstance().fbi_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedLinkDeclarationImpl).c3b = function (nodeId) {
    return new TypedLinkDeclarationImpl(this.a6o_1, LinkDeclarationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedLinkDeclarationImpl).l6o = function (propertyId) {
    return propertyId.equals(LinkDeclarationConcept_getInstance().ebi_1.e6s_1) ? this.deg_1 : propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.feg_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedLinkDeclarationImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(LinkDeclarationConcept_getInstance().ebi_1.e6s_1)) {
      this.deg_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.feg_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedLinkDeclarationImpl).l38 = function (childId) {
    return childId.equals(LinkDeclarationConcept_getInstance().fbi_1.u6o_1) ? _get_typeField__jjl181_1(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_linksField__3gitxy($this) {
    if ($this.ueg_1 == null) {
      $this.ueg_1 = $this.w6o(LinkLibraryConcept_getInstance().rbi_1);
    }
    return ensureNotNull($this.ueg_1);
  }
  function TypedLinkLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LinkLibraryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LinkLibraryConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.ueg_1 = null;
  }
  protoOf(TypedLinkLibraryImpl).sbi = function () {
    return this.y6o(_get_linksField__3gitxy(this));
  };
  protoOf(TypedLinkLibraryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedLinkLibraryImpl.<get-childIds>.<anonymous>' call
    if (!(this.ueg_1 == null)) {
      this_0.e(LinkLibraryConcept_getInstance().rbi_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedLinkLibraryImpl).c3b = function (nodeId) {
    return new TypedLinkLibraryImpl(this.a6o_1, LinkLibraryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedLinkLibraryImpl).l38 = function (childId) {
    return childId.equals(LinkLibraryConcept_getInstance().rbi_1.x6o_1) ? _get_linksField__3gitxy(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function TypedLocalOntologyElementReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LocalOntologyElementReferenceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LocalOntologyElementReferenceConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.heh_1 = null;
    this.ieh_1 = this.p6o(LocalOntologyElementReferenceConcept_getInstance().fbj_1);
  }
  protoOf(TypedLocalOntologyElementReferenceImpl).lay = function () {
    return this.ieh_1;
  };
  protoOf(TypedLocalOntologyElementReferenceImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedLocalOntologyElementReferenceImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.heh_1 == null)) {
      this_0.e(LocalOntologyElementReferenceConcept_getInstance().fbj_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedLocalOntologyElementReferenceImpl).c3b = function (nodeId) {
    return new TypedLocalOntologyElementReferenceImpl(this.a6o_1, LocalOntologyElementReferenceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedLocalOntologyElementReferenceImpl).l6o = function (propertyId) {
    return propertyId.equals(LocalOntologyElementReferenceConcept_getInstance().fbj_1.q6o_1) ? this.heh_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedLocalOntologyElementReferenceImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(LocalOntologyElementReferenceConcept_getInstance().fbj_1.q6o_1)) {
      this.heh_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_unitsField__kdaj8g($this) {
    if ($this.weh_1 == null) {
      $this.weh_1 = $this.w6o(MeasurableNotionConcept_getInstance().rbj_1);
    }
    return ensureNotNull($this.weh_1);
  }
  function TypedMeasurableNotionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? MeasurableNotionConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MeasurableNotionConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractNotionImpl.call(this, context, conceptId, nodeId);
    this.weh_1 = null;
  }
  protoOf(TypedMeasurableNotionImpl).sbj = function () {
    return this.y6o(_get_unitsField__kdaj8g(this));
  };
  protoOf(TypedMeasurableNotionImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedMeasurableNotionImpl.<get-childIds>.<anonymous>' call
    if (!(this.weh_1 == null)) {
      this_0.e(MeasurableNotionConcept_getInstance().rbj_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractNotionImpl).v2z.call(this));
  };
  protoOf(TypedMeasurableNotionImpl).c3b = function (nodeId) {
    return new TypedMeasurableNotionImpl(this.a6o_1, MeasurableNotionConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedMeasurableNotionImpl).l38 = function (childId) {
    return childId.equals(MeasurableNotionConcept_getInstance().rbj_1.x6o_1) ? _get_unitsField__kdaj8g(this) : protoOf(TypedAbstractNotionImpl).l38.call(this, childId);
  };
  function TypedMeasurableValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? MeasurableValueConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MeasurableValueConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.jei_1 = null;
    this.kei_1 = null;
    this.lei_1 = this.p6o(MeasurableValueConcept_getInstance().gbk_1);
  }
  protoOf(TypedMeasurableValueImpl).ibk = function () {
    return this.n6o(MeasurableValueConcept_getInstance().fbk_1);
  };
  protoOf(TypedMeasurableValueImpl).jbk = function () {
    return this.lei_1;
  };
  protoOf(TypedMeasurableValueImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedMeasurableValueImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.jei_1 == null)) {
      this_0.e(MeasurableValueConcept_getInstance().fbk_1.e6s_1);
    }
    if (!(this.kei_1 == null)) {
      this_0.e(MeasurableValueConcept_getInstance().gbk_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedMeasurableValueImpl).c3b = function (nodeId) {
    return new TypedMeasurableValueImpl(this.a6o_1, MeasurableValueConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedMeasurableValueImpl).l6o = function (propertyId) {
    return propertyId.equals(MeasurableValueConcept_getInstance().fbk_1.e6s_1) ? this.jei_1 : propertyId.equals(MeasurableValueConcept_getInstance().gbk_1.q6o_1) ? this.kei_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedMeasurableValueImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(MeasurableValueConcept_getInstance().fbk_1.e6s_1)) {
      this.jei_1 = value;
    } else if (propertyId.equals(MeasurableValueConcept_getInstance().gbk_1.q6o_1)) {
      this.kei_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedMeasurementUnitImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? MeasurementUnitConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MeasurementUnitConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.yei_1 = null;
    this.zei_1 = null;
  }
  protoOf(TypedMeasurementUnitImpl).wbk = function () {
    return this.n6o(MeasurementUnitConcept_getInstance().vbk_1);
  };
  protoOf(TypedMeasurementUnitImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedMeasurementUnitImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedMeasurementUnitImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.yei_1 == null)) {
      this_0.e(MeasurementUnitConcept_getInstance().vbk_1.e6s_1);
    }
    if (!(this.zei_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedMeasurementUnitImpl).c3b = function (nodeId) {
    return new TypedMeasurementUnitImpl(this.a6o_1, MeasurementUnitConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedMeasurementUnitImpl).l6o = function (propertyId) {
    return propertyId.equals(MeasurementUnitConcept_getInstance().vbk_1.e6s_1) ? this.yei_1 : propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.zei_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedMeasurementUnitImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(MeasurementUnitConcept_getInstance().vbk_1.e6s_1)) {
      this.yei_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.zei_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_modifiersField__bh4sur($this) {
    if ($this.oej_1 == null) {
      $this.oej_1 = $this.w6o(ModifierContainerConcept_getInstance().ibl_1);
    }
    return ensureNotNull($this.oej_1);
  }
  function TypedModifierContainerImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ModifierContainerConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ModifierContainerConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.oej_1 = null;
  }
  protoOf(TypedModifierContainerImpl).jbl = function () {
    return this.y6o(_get_modifiersField__bh4sur(this));
  };
  protoOf(TypedModifierContainerImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedModifierContainerImpl.<get-childIds>.<anonymous>' call
    if (!(this.oej_1 == null)) {
      this_0.e(ModifierContainerConcept_getInstance().ibl_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedModifierContainerImpl).c3b = function (nodeId) {
    return new TypedModifierContainerImpl(this.a6o_1, ModifierContainerConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedModifierContainerImpl).l38 = function (childId) {
    return childId.equals(ModifierContainerConcept_getInstance().ibl_1.x6o_1) ? _get_modifiersField__bh4sur(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function TypedModifierDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ModifierDeclarationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ModifierDeclarationConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.bek_1 = null;
  }
  protoOf(TypedModifierDeclarationImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedModifierDeclarationImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedModifierDeclarationImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.bek_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedModifierDeclarationImpl).c3b = function (nodeId) {
    return new TypedModifierDeclarationImpl(this.a6o_1, ModifierDeclarationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedModifierDeclarationImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.bek_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedModifierDeclarationImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.bek_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_expressionField__tmo0lr($this) {
    if ($this.qek_1 == null) {
      $this.qek_1 = $this.t6o(ModifierFactExpressionConcept_getInstance().ybl_1);
    }
    return ensureNotNull($this.qek_1);
  }
  function TypedModifierFactExpressionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ModifierFactExpressionConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ModifierFactExpressionConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.oek_1 = null;
    this.pek_1 = this.p6o(ModifierFactExpressionConcept_getInstance().xbl_1);
    this.qek_1 = null;
  }
  protoOf(TypedModifierFactExpressionImpl).zbl = function () {
    return this.pek_1;
  };
  protoOf(TypedModifierFactExpressionImpl).lbb = function () {
    return this.v6o(_get_expressionField__tmo0lr(this));
  };
  protoOf(TypedModifierFactExpressionImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedModifierFactExpressionImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.oek_1 == null)) {
      this_0.e(ModifierFactExpressionConcept_getInstance().xbl_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedModifierFactExpressionImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedModifierFactExpressionImpl.<get-childIds>.<anonymous>' call
    if (!(this.qek_1 == null)) {
      this_0.e(ModifierFactExpressionConcept_getInstance().ybl_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedModifierFactExpressionImpl).c3b = function (nodeId) {
    return new TypedModifierFactExpressionImpl(this.a6o_1, ModifierFactExpressionConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedModifierFactExpressionImpl).l6o = function (propertyId) {
    return propertyId.equals(ModifierFactExpressionConcept_getInstance().xbl_1.q6o_1) ? this.oek_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedModifierFactExpressionImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(ModifierFactExpressionConcept_getInstance().xbl_1.q6o_1)) {
      this.oek_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedModifierFactExpressionImpl).l38 = function (childId) {
    return childId.equals(ModifierFactExpressionConcept_getInstance().ybl_1.u6o_1) ? _get_expressionField__tmo0lr(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_linesField__yc1kcw($this) {
    if ($this.del_1 == null) {
      $this.del_1 = $this.w6o(MultilineTextConcept_getInstance().lbm_1);
    }
    return ensureNotNull($this.del_1);
  }
  function TypedMultilineTextImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? MultilineTextConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MultilineTextConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.del_1 = null;
  }
  protoOf(TypedMultilineTextImpl).mbm = function () {
    return this.y6o(_get_linesField__yc1kcw(this));
  };
  protoOf(TypedMultilineTextImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedMultilineTextImpl.<get-childIds>.<anonymous>' call
    if (!(this.del_1 == null)) {
      this_0.e(MultilineTextConcept_getInstance().lbm_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedMultilineTextImpl).c3b = function (nodeId) {
    return new TypedMultilineTextImpl(this.a6o_1, MultilineTextConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedMultilineTextImpl).l38 = function (childId) {
    return childId.equals(MultilineTextConcept_getInstance().lbm_1.x6o_1) ? _get_linesField__yc1kcw(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_typeField__jjl181_2($this) {
    if ($this.qel_1 == null) {
      $this.qel_1 = $this.t6o(MultipleProcessPropertyValueRangeConcept_getInstance().ybm_1);
    }
    return ensureNotNull($this.qel_1);
  }
  function TypedMultipleProcessPropertyValueRangeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? MultipleProcessPropertyValueRangeConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MultipleProcessPropertyValueRangeConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.qel_1 = null;
  }
  protoOf(TypedMultipleProcessPropertyValueRangeImpl).zb3 = function () {
    return this.v6o(_get_typeField__jjl181_2(this));
  };
  protoOf(TypedMultipleProcessPropertyValueRangeImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedMultipleProcessPropertyValueRangeImpl.<get-childIds>.<anonymous>' call
    if (!(this.qel_1 == null)) {
      this_0.e(MultipleProcessPropertyValueRangeConcept_getInstance().ybm_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedMultipleProcessPropertyValueRangeImpl).c3b = function (nodeId) {
    return new TypedMultipleProcessPropertyValueRangeImpl(this.a6o_1, MultipleProcessPropertyValueRangeConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedMultipleProcessPropertyValueRangeImpl).l38 = function (childId) {
    return childId.equals(MultipleProcessPropertyValueRangeConcept_getInstance().ybm_1.u6o_1) ? _get_typeField__jjl181_2(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_typesField__spk11y($this) {
    if ($this.dem_1 == null) {
      $this.dem_1 = $this.w6o(MultiplePropertyValueRangeConcept_getInstance().kbn_1);
    }
    return ensureNotNull($this.dem_1);
  }
  function TypedMultiplePropertyValueRangeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? MultiplePropertyValueRangeConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(MultiplePropertyValueRangeConcept_getInstance().e6r_1) : nodeId;
    TypedPropertyValueRangeImpl.call(this, context, conceptId, nodeId);
    this.dem_1 = null;
  }
  protoOf(TypedMultiplePropertyValueRangeImpl).lbn = function () {
    return this.y6o(_get_typesField__spk11y(this));
  };
  protoOf(TypedMultiplePropertyValueRangeImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedMultiplePropertyValueRangeImpl.<get-childIds>.<anonymous>' call
    if (!(this.dem_1 == null)) {
      this_0.e(MultiplePropertyValueRangeConcept_getInstance().kbn_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedPropertyValueRangeImpl).v2z.call(this));
  };
  protoOf(TypedMultiplePropertyValueRangeImpl).c3b = function (nodeId) {
    return new TypedMultiplePropertyValueRangeImpl(this.a6o_1, MultiplePropertyValueRangeConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedMultiplePropertyValueRangeImpl).l38 = function (childId) {
    return childId.equals(MultiplePropertyValueRangeConcept_getInstance().kbn_1.x6o_1) ? _get_typesField__spk11y(this) : protoOf(TypedPropertyValueRangeImpl).l38.call(this, childId);
  };
  function _get_expressionField__tmo0lr_0($this) {
    if ($this.qem_1 == null) {
      $this.qem_1 = $this.t6o(NewFactConcept_getInstance().xbn_1);
    }
    return ensureNotNull($this.qem_1);
  }
  function TypedNewFactImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NewFactConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NewFactConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.qem_1 = null;
    this.rem_1 = null;
  }
  protoOf(TypedNewFactImpl).lbb = function () {
    return this.v6o(_get_expressionField__tmo0lr_0(this));
  };
  protoOf(TypedNewFactImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedNewFactImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedNewFactImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.rem_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedNewFactImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedNewFactImpl.<get-childIds>.<anonymous>' call
    if (!(this.qem_1 == null)) {
      this_0.e(NewFactConcept_getInstance().xbn_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedNewFactImpl).c3b = function (nodeId) {
    return new TypedNewFactImpl(this.a6o_1, NewFactConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedNewFactImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.rem_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedNewFactImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.rem_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedNewFactImpl).l38 = function (childId) {
    return childId.equals(NewFactConcept_getInstance().xbn_1.u6o_1) ? _get_expressionField__tmo0lr_0(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedNewFactReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NewFactReferenceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NewFactReferenceConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.een_1 = null;
    this.fen_1 = this.p6o(NewFactReferenceConcept_getInstance().kbo_1);
  }
  protoOf(TypedNewFactReferenceImpl).ub6 = function () {
    return this.fen_1;
  };
  protoOf(TypedNewFactReferenceImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedNewFactReferenceImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.een_1 == null)) {
      this_0.e(NewFactReferenceConcept_getInstance().kbo_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedNewFactReferenceImpl).c3b = function (nodeId) {
    return new TypedNewFactReferenceImpl(this.a6o_1, NewFactReferenceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedNewFactReferenceImpl).l6o = function (propertyId) {
    return propertyId.equals(NewFactReferenceConcept_getInstance().kbo_1.q6o_1) ? this.een_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedNewFactReferenceImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(NewFactReferenceConcept_getInstance().kbo_1.q6o_1)) {
      this.een_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedNoValuesImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NoValuesConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NoValuesConcept_getInstance().e6r_1) : nodeId;
    TypedPropertyValueRangeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedNoValuesImpl).c3b = function (nodeId) {
    return new TypedNoValuesImpl(this.a6o_1, NoValuesConcept_getInstance().e6r_1, nodeId);
  };
  function _get_notionsField__scghe9($this) {
    if ($this.geo_1 == null) {
      $this.geo_1 = $this.w6o(NotionLibraryConcept_getInstance().wbo_1);
    }
    return ensureNotNull($this.geo_1);
  }
  function TypedNotionLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NotionLibraryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NotionLibraryConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.geo_1 = null;
  }
  protoOf(TypedNotionLibraryImpl).xbo = function () {
    return this.y6o(_get_notionsField__scghe9(this));
  };
  protoOf(TypedNotionLibraryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedNotionLibraryImpl.<get-childIds>.<anonymous>' call
    if (!(this.geo_1 == null)) {
      this_0.e(NotionLibraryConcept_getInstance().wbo_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedNotionLibraryImpl).c3b = function (nodeId) {
    return new TypedNotionLibraryImpl(this.a6o_1, NotionLibraryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedNotionLibraryImpl).l38 = function (childId) {
    return childId.equals(NotionLibraryConcept_getInstance().wbo_1.x6o_1) ? _get_notionsField__scghe9(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function TypedNotionPlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NotionPlaceholderConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NotionPlaceholderConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractNotionImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedNotionPlaceholderImpl).c3b = function (nodeId) {
    return new TypedNotionPlaceholderImpl(this.a6o_1, NotionPlaceholderConcept_getInstance().e6r_1, nodeId);
  };
  function TypedNotionTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NotionTypeConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NotionTypeConcept_getInstance().e6r_1) : nodeId;
    TypedTypeImpl.call(this, context, conceptId, nodeId);
    this.gep_1 = null;
    this.hep_1 = this.p6o(NotionTypeConcept_getInstance().kbp_1);
  }
  protoOf(TypedNotionTypeImpl).lbp = function () {
    return this.hep_1;
  };
  protoOf(TypedNotionTypeImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedNotionTypeImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.gep_1 == null)) {
      this_0.e(NotionTypeConcept_getInstance().kbp_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedTypeImpl).y2z.call(this));
  };
  protoOf(TypedNotionTypeImpl).c3b = function (nodeId) {
    return new TypedNotionTypeImpl(this.a6o_1, NotionTypeConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedNotionTypeImpl).l6o = function (propertyId) {
    return propertyId.equals(NotionTypeConcept_getInstance().kbp_1.q6o_1) ? this.gep_1 : protoOf(TypedTypeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedNotionTypeImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(NotionTypeConcept_getInstance().kbp_1.q6o_1)) {
      this.gep_1 = value;
    } else {
      protoOf(TypedTypeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_propertiesField__rzp1g6_0($this) {
    if ($this.wep_1 == null) {
      $this.wep_1 = $this.w6o(ObjectPropertiesLibraryConcept_getInstance().xbp_1);
    }
    return ensureNotNull($this.wep_1);
  }
  function TypedObjectPropertiesLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ObjectPropertiesLibraryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ObjectPropertiesLibraryConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.wep_1 = null;
  }
  protoOf(TypedObjectPropertiesLibraryImpl).pas = function () {
    return this.y6o(_get_propertiesField__rzp1g6_0(this));
  };
  protoOf(TypedObjectPropertiesLibraryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedObjectPropertiesLibraryImpl.<get-childIds>.<anonymous>' call
    if (!(this.wep_1 == null)) {
      this_0.e(ObjectPropertiesLibraryConcept_getInstance().xbp_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedObjectPropertiesLibraryImpl).c3b = function (nodeId) {
    return new TypedObjectPropertiesLibraryImpl(this.a6o_1, ObjectPropertiesLibraryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedObjectPropertiesLibraryImpl).l38 = function (childId) {
    return childId.equals(ObjectPropertiesLibraryConcept_getInstance().xbp_1.x6o_1) ? _get_propertiesField__rzp1g6_0(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function _get_domainField__27e0qt_0($this) {
    if ($this.meq_1 == null) {
      $this.meq_1 = $this.w6o(ObjectPropertyDeclarationConcept_getInstance().qbq_1);
    }
    return ensureNotNull($this.meq_1);
  }
  function _get_rangeField__ko1zla_0($this) {
    if ($this.neq_1 == null) {
      $this.neq_1 = $this.t6o(ObjectPropertyDeclarationConcept_getInstance().rbq_1);
    }
    return ensureNotNull($this.neq_1);
  }
  function TypedObjectPropertyDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ObjectPropertyDeclarationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ObjectPropertyDeclarationConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.jeq_1 = null;
    this.keq_1 = null;
    this.leq_1 = this.p6o(ObjectPropertyDeclarationConcept_getInstance().pbq_1);
    this.meq_1 = null;
    this.neq_1 = null;
    this.oeq_1 = null;
    this.peq_1 = null;
    this.qeq_1 = this.p6o(ObjectPropertyDeclarationConcept_getInstance().tbq_1);
    this.req_1 = null;
  }
  protoOf(TypedObjectPropertyDeclarationImpl).wbq = function () {
    return this.n6o(ObjectPropertyDeclarationConcept_getInstance().obq_1);
  };
  protoOf(TypedObjectPropertyDeclarationImpl).xbq = function () {
    return this.leq_1;
  };
  protoOf(TypedObjectPropertyDeclarationImpl).obe = function () {
    return this.y6o(_get_domainField__27e0qt_0(this));
  };
  protoOf(TypedObjectPropertyDeclarationImpl).be = function () {
    return this.v6o(_get_rangeField__ko1zla_0(this));
  };
  protoOf(TypedObjectPropertyDeclarationImpl).ybq = function () {
    return this.n6o(ObjectPropertyDeclarationConcept_getInstance().sbq_1);
  };
  protoOf(TypedObjectPropertyDeclarationImpl).zbq = function () {
    return this.qeq_1;
  };
  protoOf(TypedObjectPropertyDeclarationImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedObjectPropertyDeclarationImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedObjectPropertyDeclarationImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.jeq_1 == null)) {
      this_0.e(ObjectPropertyDeclarationConcept_getInstance().obq_1.e6s_1);
    }
    if (!(this.keq_1 == null)) {
      this_0.e(ObjectPropertyDeclarationConcept_getInstance().pbq_1.q6o_1);
    }
    if (!(this.oeq_1 == null)) {
      this_0.e(ObjectPropertyDeclarationConcept_getInstance().sbq_1.e6s_1);
    }
    if (!(this.peq_1 == null)) {
      this_0.e(ObjectPropertyDeclarationConcept_getInstance().tbq_1.q6o_1);
    }
    if (!(this.req_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedObjectPropertyDeclarationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedObjectPropertyDeclarationImpl.<get-childIds>.<anonymous>' call
    if (!(this.meq_1 == null)) {
      this_0.e(ObjectPropertyDeclarationConcept_getInstance().qbq_1.x6o_1);
    }
    if (!(this.neq_1 == null)) {
      this_0.e(ObjectPropertyDeclarationConcept_getInstance().rbq_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedObjectPropertyDeclarationImpl).c3b = function (nodeId) {
    return new TypedObjectPropertyDeclarationImpl(this.a6o_1, ObjectPropertyDeclarationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedObjectPropertyDeclarationImpl).l6o = function (propertyId) {
    return propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().obq_1.e6s_1) ? this.jeq_1 : propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().pbq_1.q6o_1) ? this.keq_1 : propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().sbq_1.e6s_1) ? this.oeq_1 : propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().tbq_1.q6o_1) ? this.peq_1 : propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.req_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedObjectPropertyDeclarationImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().obq_1.e6s_1)) {
      this.jeq_1 = value;
    } else if (propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().pbq_1.q6o_1)) {
      this.keq_1 = value;
    } else if (propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().sbq_1.e6s_1)) {
      this.oeq_1 = value;
    } else if (propertyId.equals(ObjectPropertyDeclarationConcept_getInstance().tbq_1.q6o_1)) {
      this.peq_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.req_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedObjectPropertyDeclarationImpl).l38 = function (childId) {
    return childId.equals(ObjectPropertyDeclarationConcept_getInstance().qbq_1.x6o_1) ? _get_domainField__27e0qt_0(this) : childId.equals(ObjectPropertyDeclarationConcept_getInstance().rbq_1.u6o_1) ? _get_rangeField__ko1zla_0(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_operandField__fjb16i($this) {
    if ($this.eer_1 == null) {
      $this.eer_1 = $this.t6o(ObjectPropertyReferenceValueConcept_getInstance().mbr_1);
    }
    return ensureNotNull($this.eer_1);
  }
  function _get_propertyField__spxghg_0($this) {
    if ($this.fer_1 == null) {
      $this.fer_1 = $this.t6o(ObjectPropertyReferenceValueConcept_getInstance().nbr_1);
    }
    return ensureNotNull($this.fer_1);
  }
  function TypedObjectPropertyReferenceValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ObjectPropertyReferenceValueConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ObjectPropertyReferenceValueConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.eer_1 = null;
    this.fer_1 = null;
  }
  protoOf(TypedObjectPropertyReferenceValueImpl).obr = function () {
    return this.v6o(_get_operandField__fjb16i(this));
  };
  protoOf(TypedObjectPropertyReferenceValueImpl).i6u = function () {
    return this.v6o(_get_propertyField__spxghg_0(this));
  };
  protoOf(TypedObjectPropertyReferenceValueImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedObjectPropertyReferenceValueImpl.<get-childIds>.<anonymous>' call
    if (!(this.eer_1 == null)) {
      this_0.e(ObjectPropertyReferenceValueConcept_getInstance().mbr_1.u6o_1);
    }
    if (!(this.fer_1 == null)) {
      this_0.e(ObjectPropertyReferenceValueConcept_getInstance().nbr_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedObjectPropertyReferenceValueImpl).c3b = function (nodeId) {
    return new TypedObjectPropertyReferenceValueImpl(this.a6o_1, ObjectPropertyReferenceValueConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedObjectPropertyReferenceValueImpl).l38 = function (childId) {
    return childId.equals(ObjectPropertyReferenceValueConcept_getInstance().mbr_1.u6o_1) ? _get_operandField__fjb16i(this) : childId.equals(ObjectPropertyReferenceValueConcept_getInstance().nbr_1.u6o_1) ? _get_propertyField__spxghg_0(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedOldPublishedSourceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OldPublishedSourceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OldPublishedSourceConcept_getInstance().e6r_1) : nodeId;
    TypedPublishedWorkImpl.call(this, context, conceptId, nodeId);
    this.xer_1 = null;
    this.yer_1 = null;
    this.zer_1 = get_name_4.call(this);
  }
  protoOf(TypedOldPublishedSourceImpl).dbs = function () {
    return this.n6o(OldPublishedSourceConcept_getInstance().bbs_1);
  };
  protoOf(TypedOldPublishedSourceImpl).ebs = function () {
    return this.n6o(OldPublishedSourceConcept_getInstance().cbs_1);
  };
  protoOf(TypedOldPublishedSourceImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOldPublishedSourceImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.xer_1 == null)) {
      this_0.e(OldPublishedSourceConcept_getInstance().bbs_1.e6s_1);
    }
    if (!(this.yer_1 == null)) {
      this_0.e(OldPublishedSourceConcept_getInstance().cbs_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedPublishedWorkImpl).y2z.call(this));
  };
  protoOf(TypedOldPublishedSourceImpl).b3 = function () {
    return this.zer_1;
  };
  protoOf(TypedOldPublishedSourceImpl).c3b = function (nodeId) {
    return new TypedOldPublishedSourceImpl(this.a6o_1, OldPublishedSourceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOldPublishedSourceImpl).l6o = function (propertyId) {
    return propertyId.equals(OldPublishedSourceConcept_getInstance().bbs_1.e6s_1) ? this.xer_1 : propertyId.equals(OldPublishedSourceConcept_getInstance().cbs_1.e6s_1) ? this.yer_1 : protoOf(TypedPublishedWorkImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedOldPublishedSourceImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(OldPublishedSourceConcept_getInstance().bbs_1.e6s_1)) {
      this.xer_1 = value;
    } else if (propertyId.equals(OldPublishedSourceConcept_getInstance().cbs_1.e6s_1)) {
      this.yer_1 = value;
    } else {
      protoOf(TypedPublishedWorkImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_expressionsField__6fs50($this) {
    if ($this.mes_1 == null) {
      $this.mes_1 = $this.w6o(OneOfConcept_getInstance().qbs_1);
    }
    return ensureNotNull($this.mes_1);
  }
  function TypedOneOfImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OneOfConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OneOfConcept_getInstance().e6r_1) : nodeId;
    TypedTypeImpl.call(this, context, conceptId, nodeId);
    this.mes_1 = null;
  }
  protoOf(TypedOneOfImpl).rbs = function () {
    return this.y6o(_get_expressionsField__6fs50(this));
  };
  protoOf(TypedOneOfImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOneOfImpl.<get-childIds>.<anonymous>' call
    if (!(this.mes_1 == null)) {
      this_0.e(OneOfConcept_getInstance().qbs_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedTypeImpl).v2z.call(this));
  };
  protoOf(TypedOneOfImpl).c3b = function (nodeId) {
    return new TypedOneOfImpl(this.a6o_1, OneOfConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOneOfImpl).l38 = function (childId) {
    return childId.equals(OneOfConcept_getInstance().qbs_1.x6o_1) ? _get_expressionsField__6fs50(this) : protoOf(TypedTypeImpl).l38.call(this, childId);
  };
  function _get_classExpressionField__3dueap_0($this) {
    if ($this.zes_1 == null) {
      $this.zes_1 = $this.t6o(OntologyCardinalityRelationConcept_getInstance().ebt_1);
    }
    return ensureNotNull($this.zes_1);
  }
  function _get_cardinalityField__qxjnpd_1($this) {
    if ($this.aet_1 == null) {
      $this.aet_1 = $this.t6o(OntologyCardinalityRelationConcept_getInstance().fbt_1);
    }
    return ensureNotNull($this.aet_1);
  }
  function TypedOntologyCardinalityRelationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyCardinalityRelationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyCardinalityRelationConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractOntologyRelationImpl.call(this, context, conceptId, nodeId);
    this.zes_1 = null;
    this.aet_1 = null;
  }
  protoOf(TypedOntologyCardinalityRelationImpl).yay = function () {
    return this.v6o(_get_classExpressionField__3dueap_0(this));
  };
  protoOf(TypedOntologyCardinalityRelationImpl).eb8 = function () {
    return this.v6o(_get_cardinalityField__qxjnpd_1(this));
  };
  protoOf(TypedOntologyCardinalityRelationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyCardinalityRelationImpl.<get-childIds>.<anonymous>' call
    if (!(this.zes_1 == null)) {
      this_0.e(OntologyCardinalityRelationConcept_getInstance().ebt_1.u6o_1);
    }
    if (!(this.aet_1 == null)) {
      this_0.e(OntologyCardinalityRelationConcept_getInstance().fbt_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractOntologyRelationImpl).v2z.call(this));
  };
  protoOf(TypedOntologyCardinalityRelationImpl).c3b = function (nodeId) {
    return new TypedOntologyCardinalityRelationImpl(this.a6o_1, OntologyCardinalityRelationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyCardinalityRelationImpl).l38 = function (childId) {
    return childId.equals(OntologyCardinalityRelationConcept_getInstance().ebt_1.u6o_1) ? _get_classExpressionField__3dueap_0(this) : childId.equals(OntologyCardinalityRelationConcept_getInstance().fbt_1.u6o_1) ? _get_cardinalityField__qxjnpd_1(this) : protoOf(TypedAbstractOntologyRelationImpl).l38.call(this, childId);
  };
  function _get_classExpressionField__3dueap_1($this) {
    if ($this.net_1 == null) {
      $this.net_1 = $this.t6o(OntologyElementDefinitionConcept_getInstance().zbu_1);
    }
    return ensureNotNull($this.net_1);
  }
  function _get_constraintsField__3m7315($this) {
    if ($this.oet_1 == null) {
      $this.oet_1 = $this.w6o(HasPropertyConstraintsConcept_getInstance().cbc_1);
    }
    return ensureNotNull($this.oet_1);
  }
  function TypedOntologyElementDefinitionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementDefinitionConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementDefinitionConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.net_1 = null;
    this.oet_1 = null;
  }
  protoOf(TypedOntologyElementDefinitionImpl).yay = function () {
    return this.v6o(_get_classExpressionField__3dueap_1(this));
  };
  protoOf(TypedOntologyElementDefinitionImpl).dbc = function () {
    return this.y6o(_get_constraintsField__3m7315(this));
  };
  protoOf(TypedOntologyElementDefinitionImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyElementDefinitionImpl.<get-childIds>.<anonymous>' call
    if (!(this.net_1 == null)) {
      this_0.e(OntologyElementDefinitionConcept_getInstance().zbu_1.u6o_1);
    }
    if (!(this.oet_1 == null)) {
      this_0.e(HasPropertyConstraintsConcept_getInstance().cbc_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedOntologyElementDefinitionImpl).c3b = function (nodeId) {
    return new TypedOntologyElementDefinitionImpl(this.a6o_1, OntologyElementDefinitionConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyElementDefinitionImpl).l38 = function (childId) {
    return childId.equals(OntologyElementDefinitionConcept_getInstance().zbu_1.u6o_1) ? _get_classExpressionField__3dueap_1(this) : childId.equals(HasPropertyConstraintsConcept_getInstance().cbc_1.x6o_1) ? _get_constraintsField__3m7315(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_superElementsField__k34qgz($this) {
    if ($this.beu_1 == null) {
      $this.beu_1 = $this.w6o(OntologyElementConcept_getInstance().ybt_1);
    }
    return ensureNotNull($this.beu_1);
  }
  function _get_enclosingElementsField__5hj60k($this) {
    if ($this.ceu_1 == null) {
      $this.ceu_1 = $this.w6o(OntologyElementConcept_getInstance().zbt_1);
    }
    return ensureNotNull($this.ceu_1);
  }
  function _get_taxonField__ozsb3v($this) {
    if ($this.deu_1 == null) {
      $this.deu_1 = $this.t6o(OntologyElementConcept_getInstance().abu_1);
    }
    return ensureNotNull($this.deu_1);
  }
  function _get_synonymsField__k9btgx($this) {
    if ($this.feu_1 == null) {
      $this.feu_1 = $this.w6o(OntologyElementConcept_getInstance().cbu_1);
    }
    return ensureNotNull($this.feu_1);
  }
  function _get_xRefContainersField__3g8uxw($this) {
    if ($this.geu_1 == null) {
      $this.geu_1 = $this.w6o(OntologyElementConcept_getInstance().dbu_1);
    }
    return ensureNotNull($this.geu_1);
  }
  function _get_oldDefinitionField__pdwtaj($this) {
    if ($this.heu_1 == null) {
      $this.heu_1 = $this.t6o(OntologyElementConcept_getInstance().ebu_1);
    }
    return ensureNotNull($this.heu_1);
  }
  function _get_definitionField__4sf3wq($this) {
    if ($this.ieu_1 == null) {
      $this.ieu_1 = $this.t6o(OntologyElementConcept_getInstance().fbu_1);
    }
    return ensureNotNull($this.ieu_1);
  }
  function _get_constraintsField__3m7315_0($this) {
    if ($this.keu_1 == null) {
      $this.keu_1 = $this.w6o(HasPropertyConstraintsConcept_getInstance().cbc_1);
    }
    return ensureNotNull($this.keu_1);
  }
  function TypedOntologyElementImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.beu_1 = null;
    this.ceu_1 = null;
    this.deu_1 = null;
    this.eeu_1 = null;
    this.feu_1 = null;
    this.geu_1 = null;
    this.heu_1 = null;
    this.ieu_1 = null;
    this.jeu_1 = null;
    this.keu_1 = null;
  }
  protoOf(TypedOntologyElementImpl).gbu = function () {
    return this.y6o(_get_superElementsField__k34qgz(this));
  };
  protoOf(TypedOntologyElementImpl).hbu = function () {
    return this.y6o(_get_enclosingElementsField__5hj60k(this));
  };
  protoOf(TypedOntologyElementImpl).ibu = function () {
    return this.v6o(_get_taxonField__ozsb3v(this));
  };
  protoOf(TypedOntologyElementImpl).jbu = function () {
    return this.n6o(OntologyElementConcept_getInstance().bbu_1);
  };
  protoOf(TypedOntologyElementImpl).kbu = function () {
    return this.y6o(_get_synonymsField__k9btgx(this));
  };
  protoOf(TypedOntologyElementImpl).lbu = function () {
    return this.y6o(_get_xRefContainersField__3g8uxw(this));
  };
  protoOf(TypedOntologyElementImpl).mbu = function () {
    return this.v6o(_get_oldDefinitionField__pdwtaj(this));
  };
  protoOf(TypedOntologyElementImpl).nbu = function () {
    return this.v6o(_get_definitionField__4sf3wq(this));
  };
  protoOf(TypedOntologyElementImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedOntologyElementImpl).dbc = function () {
    return this.y6o(_get_constraintsField__3m7315_0(this));
  };
  protoOf(TypedOntologyElementImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyElementImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.eeu_1 == null)) {
      this_0.e(OntologyElementConcept_getInstance().bbu_1.e6s_1);
    }
    if (!(this.jeu_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedOntologyElementImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyElementImpl.<get-childIds>.<anonymous>' call
    if (!(this.beu_1 == null)) {
      this_0.e(OntologyElementConcept_getInstance().ybt_1.x6o_1);
    }
    if (!(this.ceu_1 == null)) {
      this_0.e(OntologyElementConcept_getInstance().zbt_1.x6o_1);
    }
    if (!(this.deu_1 == null)) {
      this_0.e(OntologyElementConcept_getInstance().abu_1.u6o_1);
    }
    if (!(this.feu_1 == null)) {
      this_0.e(OntologyElementConcept_getInstance().cbu_1.x6o_1);
    }
    if (!(this.geu_1 == null)) {
      this_0.e(OntologyElementConcept_getInstance().dbu_1.x6o_1);
    }
    if (!(this.heu_1 == null)) {
      this_0.e(OntologyElementConcept_getInstance().ebu_1.u6o_1);
    }
    if (!(this.ieu_1 == null)) {
      this_0.e(OntologyElementConcept_getInstance().fbu_1.u6o_1);
    }
    if (!(this.keu_1 == null)) {
      this_0.e(HasPropertyConstraintsConcept_getInstance().cbc_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedOntologyElementImpl).c3b = function (nodeId) {
    return new TypedOntologyElementImpl(this.a6o_1, OntologyElementConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyElementImpl).l6o = function (propertyId) {
    return propertyId.equals(OntologyElementConcept_getInstance().bbu_1.e6s_1) ? this.eeu_1 : propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.jeu_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedOntologyElementImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(OntologyElementConcept_getInstance().bbu_1.e6s_1)) {
      this.eeu_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.jeu_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedOntologyElementImpl).l38 = function (childId) {
    return childId.equals(OntologyElementConcept_getInstance().ybt_1.x6o_1) ? _get_superElementsField__k34qgz(this) : childId.equals(OntologyElementConcept_getInstance().zbt_1.x6o_1) ? _get_enclosingElementsField__5hj60k(this) : childId.equals(OntologyElementConcept_getInstance().abu_1.u6o_1) ? _get_taxonField__ozsb3v(this) : childId.equals(OntologyElementConcept_getInstance().cbu_1.x6o_1) ? _get_synonymsField__k9btgx(this) : childId.equals(OntologyElementConcept_getInstance().dbu_1.x6o_1) ? _get_xRefContainersField__3g8uxw(this) : childId.equals(OntologyElementConcept_getInstance().ebu_1.u6o_1) ? _get_oldDefinitionField__pdwtaj(this) : childId.equals(OntologyElementConcept_getInstance().fbu_1.u6o_1) ? _get_definitionField__4sf3wq(this) : childId.equals(HasPropertyConstraintsConcept_getInstance().cbc_1.x6o_1) ? _get_constraintsField__3m7315_0(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_libraryField__um0bho_2($this) {
    if ($this.yeu_1 == null) {
      $this.yeu_1 = $this.t6o(OntologyElementPropertyTypeConcept_getInstance().pbv_1);
    }
    return ensureNotNull($this.yeu_1);
  }
  function _get_elementField__q1p5qr_2($this) {
    if ($this.zeu_1 == null) {
      $this.zeu_1 = $this.t6o(OntologyElementPropertyTypeConcept_getInstance().qbv_1);
    }
    return ensureNotNull($this.zeu_1);
  }
  function TypedOntologyElementPropertyTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementPropertyTypeConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementPropertyTypeConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.xeu_1 = null;
    this.yeu_1 = null;
    this.zeu_1 = null;
  }
  protoOf(TypedOntologyElementPropertyTypeImpl).sba = function () {
    return this.n6o(OntologyElementPropertyTypeConcept_getInstance().obv_1);
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).kay = function () {
    return this.v6o(_get_libraryField__um0bho_2(this));
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).lay = function () {
    return this.v6o(_get_elementField__q1p5qr_2(this));
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyElementPropertyTypeImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.xeu_1 == null)) {
      this_0.e(OntologyElementPropertyTypeConcept_getInstance().obv_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyElementPropertyTypeImpl.<get-childIds>.<anonymous>' call
    if (!(this.yeu_1 == null)) {
      this_0.e(OntologyElementPropertyTypeConcept_getInstance().pbv_1.u6o_1);
    }
    if (!(this.zeu_1 == null)) {
      this_0.e(OntologyElementPropertyTypeConcept_getInstance().qbv_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).c3b = function (nodeId) {
    return new TypedOntologyElementPropertyTypeImpl(this.a6o_1, OntologyElementPropertyTypeConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).l6o = function (propertyId) {
    return propertyId.equals(OntologyElementPropertyTypeConcept_getInstance().obv_1.e6s_1) ? this.xeu_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(OntologyElementPropertyTypeConcept_getInstance().obv_1.e6s_1)) {
      this.xeu_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedOntologyElementPropertyTypeImpl).l38 = function (childId) {
    return childId.equals(OntologyElementPropertyTypeConcept_getInstance().pbv_1.u6o_1) ? _get_libraryField__um0bho_2(this) : childId.equals(OntologyElementPropertyTypeConcept_getInstance().qbv_1.u6o_1) ? _get_elementField__q1p5qr_2(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedOntologyElementReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementReferenceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementReferenceConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.mev_1 = null;
    this.nev_1 = this.p6o(OntologyElementReferenceConcept_getInstance().dbw_1);
  }
  protoOf(TypedOntologyElementReferenceImpl).lay = function () {
    return this.nev_1;
  };
  protoOf(TypedOntologyElementReferenceImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyElementReferenceImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.mev_1 == null)) {
      this_0.e(OntologyElementReferenceConcept_getInstance().dbw_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedOntologyElementReferenceImpl).c3b = function (nodeId) {
    return new TypedOntologyElementReferenceImpl(this.a6o_1, OntologyElementReferenceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyElementReferenceImpl).l6o = function (propertyId) {
    return propertyId.equals(OntologyElementReferenceConcept_getInstance().dbw_1.q6o_1) ? this.mev_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedOntologyElementReferenceImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(OntologyElementReferenceConcept_getInstance().dbw_1.q6o_1)) {
      this.mev_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_elementField__q1p5qr_3($this) {
    if ($this.aew_1 == null) {
      $this.aew_1 = $this.t6o(OntologyElementReferenceValueConcept_getInstance().pbw_1);
    }
    return ensureNotNull($this.aew_1);
  }
  function TypedOntologyElementReferenceValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementReferenceValueConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementReferenceValueConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.aew_1 = null;
  }
  protoOf(TypedOntologyElementReferenceValueImpl).lay = function () {
    return this.v6o(_get_elementField__q1p5qr_3(this));
  };
  protoOf(TypedOntologyElementReferenceValueImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyElementReferenceValueImpl.<get-childIds>.<anonymous>' call
    if (!(this.aew_1 == null)) {
      this_0.e(OntologyElementReferenceValueConcept_getInstance().pbw_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedOntologyElementReferenceValueImpl).c3b = function (nodeId) {
    return new TypedOntologyElementReferenceValueImpl(this.a6o_1, OntologyElementReferenceValueConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyElementReferenceValueImpl).l38 = function (childId) {
    return childId.equals(OntologyElementReferenceValueConcept_getInstance().pbw_1.u6o_1) ? _get_elementField__q1p5qr_3(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_libraryField__um0bho_3($this) {
    if ($this.oew_1 == null) {
      $this.oew_1 = $this.t6o(OntologyElementReferenceValueLibraryConcept_getInstance().bbx_1);
    }
    return ensureNotNull($this.oew_1);
  }
  function TypedOntologyElementReferenceValueLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementReferenceValueLibraryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementReferenceValueLibraryConcept_getInstance().e6r_1) : nodeId;
    TypedOntologyElementReferenceValueImpl.call(this, context, conceptId, nodeId);
    this.oew_1 = null;
  }
  protoOf(TypedOntologyElementReferenceValueLibraryImpl).kay = function () {
    return this.v6o(_get_libraryField__um0bho_3(this));
  };
  protoOf(TypedOntologyElementReferenceValueLibraryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyElementReferenceValueLibraryImpl.<get-childIds>.<anonymous>' call
    if (!(this.oew_1 == null)) {
      this_0.e(OntologyElementReferenceValueLibraryConcept_getInstance().bbx_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedOntologyElementReferenceValueImpl).v2z.call(this));
  };
  protoOf(TypedOntologyElementReferenceValueLibraryImpl).c3b = function (nodeId) {
    return new TypedOntologyElementReferenceValueLibraryImpl(this.a6o_1, OntologyElementReferenceValueLibraryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyElementReferenceValueLibraryImpl).l38 = function (childId) {
    return childId.equals(OntologyElementReferenceValueLibraryConcept_getInstance().bbx_1.u6o_1) ? _get_libraryField__um0bho_3(this) : protoOf(TypedOntologyElementReferenceValueImpl).l38.call(this, childId);
  };
  function TypedOntologyElementSynonymImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementSynonymConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementSynonymConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.bex_1 = null;
  }
  protoOf(TypedOntologyElementSynonymImpl).b3 = function () {
    return this.n6o(OntologyElementSynonymConcept_getInstance().nbx_1);
  };
  protoOf(TypedOntologyElementSynonymImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyElementSynonymImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.bex_1 == null)) {
      this_0.e(OntologyElementSynonymConcept_getInstance().nbx_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedOntologyElementSynonymImpl).c3b = function (nodeId) {
    return new TypedOntologyElementSynonymImpl(this.a6o_1, OntologyElementSynonymConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyElementSynonymImpl).l6o = function (propertyId) {
    return propertyId.equals(OntologyElementSynonymConcept_getInstance().nbx_1.e6s_1) ? this.bex_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedOntologyElementSynonymImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(OntologyElementSynonymConcept_getInstance().nbx_1.e6s_1)) {
      this.bex_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_libraryField__um0bho_4($this) {
    if ($this.oex_1 == null) {
      $this.oex_1 = $this.t6o(OntologyElementTypeConcept_getInstance().aby_1);
    }
    return ensureNotNull($this.oex_1);
  }
  function _get_elementField__q1p5qr_4($this) {
    if ($this.pex_1 == null) {
      $this.pex_1 = $this.t6o(OntologyElementTypeConcept_getInstance().bby_1);
    }
    return ensureNotNull($this.pex_1);
  }
  function TypedOntologyElementTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyElementTypeConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementTypeConcept_getInstance().e6r_1) : nodeId;
    TypedTypeImpl.call(this, context, conceptId, nodeId);
    this.oex_1 = null;
    this.pex_1 = null;
  }
  protoOf(TypedOntologyElementTypeImpl).kay = function () {
    return this.v6o(_get_libraryField__um0bho_4(this));
  };
  protoOf(TypedOntologyElementTypeImpl).lay = function () {
    return this.v6o(_get_elementField__q1p5qr_4(this));
  };
  protoOf(TypedOntologyElementTypeImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyElementTypeImpl.<get-childIds>.<anonymous>' call
    if (!(this.oex_1 == null)) {
      this_0.e(OntologyElementTypeConcept_getInstance().aby_1.u6o_1);
    }
    if (!(this.pex_1 == null)) {
      this_0.e(OntologyElementTypeConcept_getInstance().bby_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedTypeImpl).v2z.call(this));
  };
  protoOf(TypedOntologyElementTypeImpl).c3b = function (nodeId) {
    return new TypedOntologyElementTypeImpl(this.a6o_1, OntologyElementTypeConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyElementTypeImpl).l38 = function (childId) {
    return childId.equals(OntologyElementTypeConcept_getInstance().aby_1.u6o_1) ? _get_libraryField__um0bho_4(this) : childId.equals(OntologyElementTypeConcept_getInstance().bby_1.u6o_1) ? _get_elementField__q1p5qr_4(this) : protoOf(TypedTypeImpl).l38.call(this, childId);
  };
  function _get_ontologyField__fslpom($this) {
    if ($this.cey_1 == null) {
      $this.cey_1 = $this.t6o(OntologyImportConcept_getInstance().pby_1);
    }
    return ensureNotNull($this.cey_1);
  }
  function _get_elementField__q1p5qr_5($this) {
    if ($this.dey_1 == null) {
      $this.dey_1 = $this.t6o(OntologyImportConcept_getInstance().qby_1);
    }
    return ensureNotNull($this.dey_1);
  }
  function _get_libraryToUseField__uukqo8($this) {
    if ($this.eey_1 == null) {
      $this.eey_1 = $this.t6o(OntologyImportConcept_getInstance().rby_1);
    }
    return ensureNotNull($this.eey_1);
  }
  function TypedOntologyImportImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyImportConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyImportConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.cey_1 = null;
    this.dey_1 = null;
    this.eey_1 = null;
  }
  protoOf(TypedOntologyImportImpl).sby = function () {
    return this.v6o(_get_ontologyField__fslpom(this));
  };
  protoOf(TypedOntologyImportImpl).lay = function () {
    return this.v6o(_get_elementField__q1p5qr_5(this));
  };
  protoOf(TypedOntologyImportImpl).tby = function () {
    return this.v6o(_get_libraryToUseField__uukqo8(this));
  };
  protoOf(TypedOntologyImportImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyImportImpl.<get-childIds>.<anonymous>' call
    if (!(this.cey_1 == null)) {
      this_0.e(OntologyImportConcept_getInstance().pby_1.u6o_1);
    }
    if (!(this.dey_1 == null)) {
      this_0.e(OntologyImportConcept_getInstance().qby_1.u6o_1);
    }
    if (!(this.eey_1 == null)) {
      this_0.e(OntologyImportConcept_getInstance().rby_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedOntologyImportImpl).c3b = function (nodeId) {
    return new TypedOntologyImportImpl(this.a6o_1, OntologyImportConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyImportImpl).l38 = function (childId) {
    return childId.equals(OntologyImportConcept_getInstance().pby_1.u6o_1) ? _get_ontologyField__fslpom(this) : childId.equals(OntologyImportConcept_getInstance().qby_1.u6o_1) ? _get_elementField__q1p5qr_5(this) : childId.equals(OntologyImportConcept_getInstance().rby_1.u6o_1) ? _get_libraryToUseField__uukqo8(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_importsField__w7vue7_0($this) {
    if ($this.tey_1 == null) {
      $this.tey_1 = $this.w6o(OntologyImportRootConcept_getInstance().fbz_1);
    }
    return ensureNotNull($this.tey_1);
  }
  function TypedOntologyImportRootImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyImportRootConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyImportRootConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.tey_1 = null;
  }
  protoOf(TypedOntologyImportRootImpl).sau = function () {
    return this.y6o(_get_importsField__w7vue7_0(this));
  };
  protoOf(TypedOntologyImportRootImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyImportRootImpl.<get-childIds>.<anonymous>' call
    if (!(this.tey_1 == null)) {
      this_0.e(OntologyImportRootConcept_getInstance().fbz_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedOntologyImportRootImpl).c3b = function (nodeId) {
    return new TypedOntologyImportRootImpl(this.a6o_1, OntologyImportRootConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyImportRootImpl).l38 = function (childId) {
    return childId.equals(OntologyImportRootConcept_getInstance().fbz_1.x6o_1) ? _get_importsField__w7vue7_0(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function TypedOntologyImportRootReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyImportRootReferenceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyImportRootReferenceConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.gez_1 = null;
    this.hez_1 = this.p6o(OntologyImportRootReferenceConcept_getInstance().sbz_1);
  }
  protoOf(TypedOntologyImportRootReferenceImpl).ub6 = function () {
    return this.hez_1;
  };
  protoOf(TypedOntologyImportRootReferenceImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyImportRootReferenceImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.gez_1 == null)) {
      this_0.e(OntologyImportRootReferenceConcept_getInstance().sbz_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedOntologyImportRootReferenceImpl).c3b = function (nodeId) {
    return new TypedOntologyImportRootReferenceImpl(this.a6o_1, OntologyImportRootReferenceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyImportRootReferenceImpl).l6o = function (propertyId) {
    return propertyId.equals(OntologyImportRootReferenceConcept_getInstance().sbz_1.q6o_1) ? this.gez_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedOntologyImportRootReferenceImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(OntologyImportRootReferenceConcept_getInstance().sbz_1.q6o_1)) {
      this.gez_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_elementReferenceProviderField__dm1eyf($this) {
    if ($this.uez_1 == null) {
      $this.uez_1 = $this.t6o(OntologyIsRelationConcept_getInstance().ec0_1);
    }
    return ensureNotNull($this.uez_1);
  }
  function TypedOntologyIsRelationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyIsRelationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyIsRelationConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractOntologyRelationImpl.call(this, context, conceptId, nodeId);
    this.uez_1 = null;
  }
  protoOf(TypedOntologyIsRelationImpl).fc0 = function () {
    return this.v6o(_get_elementReferenceProviderField__dm1eyf(this));
  };
  protoOf(TypedOntologyIsRelationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyIsRelationImpl.<get-childIds>.<anonymous>' call
    if (!(this.uez_1 == null)) {
      this_0.e(OntologyIsRelationConcept_getInstance().ec0_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractOntologyRelationImpl).v2z.call(this));
  };
  protoOf(TypedOntologyIsRelationImpl).c3b = function (nodeId) {
    return new TypedOntologyIsRelationImpl(this.a6o_1, OntologyIsRelationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyIsRelationImpl).l38 = function (childId) {
    return childId.equals(OntologyIsRelationConcept_getInstance().ec0_1.u6o_1) ? _get_elementReferenceProviderField__dm1eyf(this) : protoOf(TypedAbstractOntologyRelationImpl).l38.call(this, childId);
  };
  function _get_elementsField__lf2xhu($this) {
    if ($this.jf0_1 == null) {
      $this.jf0_1 = $this.w6o(OntologyLibraryConcept_getInstance().rc0_1);
    }
    return ensureNotNull($this.jf0_1);
  }
  function TypedOntologyLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyLibraryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLibraryConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.jf0_1 = null;
  }
  protoOf(TypedOntologyLibraryImpl).sc0 = function () {
    return this.y6o(_get_elementsField__lf2xhu(this));
  };
  protoOf(TypedOntologyLibraryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyLibraryImpl.<get-childIds>.<anonymous>' call
    if (!(this.jf0_1 == null)) {
      this_0.e(OntologyLibraryConcept_getInstance().rc0_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedOntologyLibraryImpl).c3b = function (nodeId) {
    return new TypedOntologyLibraryImpl(this.a6o_1, OntologyLibraryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyLibraryImpl).l38 = function (childId) {
    return childId.equals(OntologyLibraryConcept_getInstance().rc0_1.x6o_1) ? _get_elementsField__lf2xhu(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function TypedOntologyLibraryReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyLibraryReferenceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLibraryReferenceConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.wf0_1 = null;
    this.xf0_1 = this.p6o(OntologyLibraryReferenceConcept_getInstance().fc1_1);
  }
  protoOf(TypedOntologyLibraryReferenceImpl).ub6 = function () {
    return this.xf0_1;
  };
  protoOf(TypedOntologyLibraryReferenceImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyLibraryReferenceImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.wf0_1 == null)) {
      this_0.e(OntologyLibraryReferenceConcept_getInstance().fc1_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedOntologyLibraryReferenceImpl).c3b = function (nodeId) {
    return new TypedOntologyLibraryReferenceImpl(this.a6o_1, OntologyLibraryReferenceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyLibraryReferenceImpl).l6o = function (propertyId) {
    return propertyId.equals(OntologyLibraryReferenceConcept_getInstance().fc1_1.q6o_1) ? this.wf0_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedOntologyLibraryReferenceImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(OntologyLibraryReferenceConcept_getInstance().fc1_1.q6o_1)) {
      this.wf0_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedOntologyLinkDeclarationValueQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyLinkDeclarationValueQueryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLinkDeclarationValueQueryConcept_getInstance().e6r_1) : nodeId;
    TypedDeclarationValueQueryImpl.call(this, context, conceptId, nodeId);
    this.lf1_1 = null;
    this.mf1_1 = this.p6o(OntologyLinkDeclarationValueQueryConcept_getInstance().hc2_1);
  }
  protoOf(TypedOntologyLinkDeclarationValueQueryImpl).ic2 = function () {
    return this.mf1_1;
  };
  protoOf(TypedOntologyLinkDeclarationValueQueryImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyLinkDeclarationValueQueryImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.lf1_1 == null)) {
      this_0.e(OntologyLinkDeclarationValueQueryConcept_getInstance().hc2_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDeclarationValueQueryImpl).y2z.call(this));
  };
  protoOf(TypedOntologyLinkDeclarationValueQueryImpl).c3b = function (nodeId) {
    return new TypedOntologyLinkDeclarationValueQueryImpl(this.a6o_1, OntologyLinkDeclarationValueQueryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyLinkDeclarationValueQueryImpl).l6o = function (propertyId) {
    return propertyId.equals(OntologyLinkDeclarationValueQueryConcept_getInstance().hc2_1.q6o_1) ? this.lf1_1 : protoOf(TypedDeclarationValueQueryImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedOntologyLinkDeclarationValueQueryImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(OntologyLinkDeclarationValueQueryConcept_getInstance().hc2_1.q6o_1)) {
      this.lf1_1 = value;
    } else {
      protoOf(TypedDeclarationValueQueryImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_linkField__e0eken($this) {
    if ($this.bf2_1 == null) {
      $this.bf2_1 = $this.t6o(OntologyLinkConcept_getInstance().sc1_1);
    }
    return ensureNotNull($this.bf2_1);
  }
  function _get_defaultLibraryReferenceField__tuthwe($this) {
    if ($this.cf2_1 == null) {
      $this.cf2_1 = $this.t6o(OntologyLinkConcept_getInstance().tc1_1);
    }
    return ensureNotNull($this.cf2_1);
  }
  function TypedOntologyLinkImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyLinkConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLinkConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractLinkImpl.call(this, context, conceptId, nodeId);
    this.bf2_1 = null;
    this.cf2_1 = null;
  }
  protoOf(TypedOntologyLinkImpl).pbh = function () {
    return this.v6o(_get_linkField__e0eken(this));
  };
  protoOf(TypedOntologyLinkImpl).uc1 = function () {
    return this.v6o(_get_defaultLibraryReferenceField__tuthwe(this));
  };
  protoOf(TypedOntologyLinkImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyLinkImpl.<get-childIds>.<anonymous>' call
    if (!(this.bf2_1 == null)) {
      this_0.e(OntologyLinkConcept_getInstance().sc1_1.u6o_1);
    }
    if (!(this.cf2_1 == null)) {
      this_0.e(OntologyLinkConcept_getInstance().tc1_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractLinkImpl).v2z.call(this));
  };
  protoOf(TypedOntologyLinkImpl).c3b = function (nodeId) {
    return new TypedOntologyLinkImpl(this.a6o_1, OntologyLinkConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyLinkImpl).l38 = function (childId) {
    return childId.equals(OntologyLinkConcept_getInstance().sc1_1.u6o_1) ? _get_linkField__e0eken(this) : childId.equals(OntologyLinkConcept_getInstance().tc1_1.u6o_1) ? _get_defaultLibraryReferenceField__tuthwe(this) : protoOf(TypedAbstractLinkImpl).l38.call(this, childId);
  };
  function TypedOntologyLinkValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OntologyLinkValueConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLinkValueConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractBindingValueImpl.call(this, context, conceptId, nodeId);
    this.qf2_1 = null;
    this.rf2_1 = this.p6o(OntologyLinkValueConcept_getInstance().vc2_1);
  }
  protoOf(TypedOntologyLinkValueImpl).wc2 = function () {
    return this.rf2_1;
  };
  protoOf(TypedOntologyLinkValueImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOntologyLinkValueImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.qf2_1 == null)) {
      this_0.e(OntologyLinkValueConcept_getInstance().vc2_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractBindingValueImpl).y2z.call(this));
  };
  protoOf(TypedOntologyLinkValueImpl).c3b = function (nodeId) {
    return new TypedOntologyLinkValueImpl(this.a6o_1, OntologyLinkValueConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOntologyLinkValueImpl).l6o = function (propertyId) {
    return propertyId.equals(OntologyLinkValueConcept_getInstance().vc2_1.q6o_1) ? this.qf2_1 : protoOf(TypedAbstractBindingValueImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedOntologyLinkValueImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(OntologyLinkValueConcept_getInstance().vc2_1.q6o_1)) {
      this.qf2_1 = value;
    } else {
      protoOf(TypedAbstractBindingValueImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_leftField__72ma9q_0($this) {
    if ($this.ef3_1 == null) {
      $this.ef3_1 = $this.t6o(OrValueQueryConcept_getInstance().jc3_1);
    }
    return ensureNotNull($this.ef3_1);
  }
  function _get_rightField__qpqtcd_0($this) {
    if ($this.ff3_1 == null) {
      $this.ff3_1 = $this.t6o(OrValueQueryConcept_getInstance().kc3_1);
    }
    return ensureNotNull($this.ff3_1);
  }
  function TypedOrValueQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? OrValueQueryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OrValueQueryConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractBindingValueQueryImpl.call(this, context, conceptId, nodeId);
    this.ef3_1 = null;
    this.ff3_1 = null;
  }
  protoOf(TypedOrValueQueryImpl).sbf = function () {
    return this.v6o(_get_leftField__72ma9q_0(this));
  };
  protoOf(TypedOrValueQueryImpl).tbf = function () {
    return this.v6o(_get_rightField__qpqtcd_0(this));
  };
  protoOf(TypedOrValueQueryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedOrValueQueryImpl.<get-childIds>.<anonymous>' call
    if (!(this.ef3_1 == null)) {
      this_0.e(OrValueQueryConcept_getInstance().jc3_1.u6o_1);
    }
    if (!(this.ff3_1 == null)) {
      this_0.e(OrValueQueryConcept_getInstance().kc3_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractBindingValueQueryImpl).v2z.call(this));
  };
  protoOf(TypedOrValueQueryImpl).c3b = function (nodeId) {
    return new TypedOrValueQueryImpl(this.a6o_1, OrValueQueryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedOrValueQueryImpl).l38 = function (childId) {
    return childId.equals(OrValueQueryConcept_getInstance().jc3_1.u6o_1) ? _get_leftField__72ma9q_0(this) : childId.equals(OrValueQueryConcept_getInstance().kc3_1.u6o_1) ? _get_rightField__qpqtcd_0(this) : protoOf(TypedAbstractBindingValueQueryImpl).l38.call(this, childId);
  };
  function TypedPageImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PageConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PageConcept_getInstance().e6r_1) : nodeId;
    TypedPageSpecificationImpl.call(this, context, conceptId, nodeId);
    this.sf3_1 = null;
  }
  protoOf(TypedPageImpl).xc3 = function () {
    return this.n6o(PageConcept_getInstance().wc3_1);
  };
  protoOf(TypedPageImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPageImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.sf3_1 == null)) {
      this_0.e(PageConcept_getInstance().wc3_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedPageSpecificationImpl).y2z.call(this));
  };
  protoOf(TypedPageImpl).c3b = function (nodeId) {
    return new TypedPageImpl(this.a6o_1, PageConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPageImpl).l6o = function (propertyId) {
    return propertyId.equals(PageConcept_getInstance().wc3_1.e6s_1) ? this.sf3_1 : protoOf(TypedPageSpecificationImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedPageImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(PageConcept_getInstance().wc3_1.e6s_1)) {
      this.sf3_1 = value;
    } else {
      protoOf(TypedPageSpecificationImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedPageRangeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PageRangeConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PageRangeConcept_getInstance().e6r_1) : nodeId;
    TypedPageSpecificationImpl.call(this, context, conceptId, nodeId);
    this.ff4_1 = null;
    this.gf4_1 = null;
  }
  protoOf(TypedPageRangeImpl).q1 = function () {
    return this.n6o(PageRangeConcept_getInstance().kc4_1);
  };
  protoOf(TypedPageRangeImpl).mc4 = function () {
    return this.n6o(PageRangeConcept_getInstance().lc4_1);
  };
  protoOf(TypedPageRangeImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPageRangeImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.ff4_1 == null)) {
      this_0.e(PageRangeConcept_getInstance().kc4_1.e6s_1);
    }
    if (!(this.gf4_1 == null)) {
      this_0.e(PageRangeConcept_getInstance().lc4_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedPageSpecificationImpl).y2z.call(this));
  };
  protoOf(TypedPageRangeImpl).c3b = function (nodeId) {
    return new TypedPageRangeImpl(this.a6o_1, PageRangeConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPageRangeImpl).l6o = function (propertyId) {
    return propertyId.equals(PageRangeConcept_getInstance().kc4_1.e6s_1) ? this.ff4_1 : propertyId.equals(PageRangeConcept_getInstance().lc4_1.e6s_1) ? this.gf4_1 : protoOf(TypedPageSpecificationImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedPageRangeImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(PageRangeConcept_getInstance().kc4_1.e6s_1)) {
      this.ff4_1 = value;
    } else if (propertyId.equals(PageRangeConcept_getInstance().lc4_1.e6s_1)) {
      this.gf4_1 = value;
    } else {
      protoOf(TypedPageSpecificationImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedPageSpecificationImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function _get_pagesField__b06ncl($this) {
    if ($this.ff5_1 == null) {
      $this.ff5_1 = $this.t6o(PaperConcept_getInstance().mc5_1);
    }
    return ensureNotNull($this.ff5_1);
  }
  function TypedPaperImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PaperConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PaperConcept_getInstance().e6r_1) : nodeId;
    TypedPublishedWorkImpl.call(this, context, conceptId, nodeId);
    this.yf4_1 = null;
    this.zf4_1 = null;
    this.af5_1 = null;
    this.bf5_1 = null;
    this.cf5_1 = null;
    this.df5_1 = null;
    this.ef5_1 = null;
    this.ff5_1 = null;
  }
  protoOf(TypedPaperImpl).nc5 = function () {
    return this.n6o(PaperConcept_getInstance().fc5_1);
  };
  protoOf(TypedPaperImpl).oc5 = function () {
    return this.n6o(PaperConcept_getInstance().gc5_1);
  };
  protoOf(TypedPaperImpl).pc5 = function () {
    return this.n6o(PaperConcept_getInstance().hc5_1);
  };
  protoOf(TypedPaperImpl).qc5 = function () {
    return this.n6o(PaperConcept_getInstance().ic5_1);
  };
  protoOf(TypedPaperImpl).rc5 = function () {
    return this.n6o(PaperConcept_getInstance().jc5_1);
  };
  protoOf(TypedPaperImpl).sc5 = function () {
    return this.n6o(PaperConcept_getInstance().kc5_1);
  };
  protoOf(TypedPaperImpl).tc5 = function () {
    return this.n6o(PaperConcept_getInstance().lc5_1);
  };
  protoOf(TypedPaperImpl).uc5 = function () {
    return this.v6o(_get_pagesField__b06ncl(this));
  };
  protoOf(TypedPaperImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPaperImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.yf4_1 == null)) {
      this_0.e(PaperConcept_getInstance().fc5_1.e6s_1);
    }
    if (!(this.zf4_1 == null)) {
      this_0.e(PaperConcept_getInstance().gc5_1.e6s_1);
    }
    if (!(this.af5_1 == null)) {
      this_0.e(PaperConcept_getInstance().hc5_1.e6s_1);
    }
    if (!(this.bf5_1 == null)) {
      this_0.e(PaperConcept_getInstance().ic5_1.e6s_1);
    }
    if (!(this.cf5_1 == null)) {
      this_0.e(PaperConcept_getInstance().jc5_1.e6s_1);
    }
    if (!(this.df5_1 == null)) {
      this_0.e(PaperConcept_getInstance().kc5_1.e6s_1);
    }
    if (!(this.ef5_1 == null)) {
      this_0.e(PaperConcept_getInstance().lc5_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedPublishedWorkImpl).y2z.call(this));
  };
  protoOf(TypedPaperImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPaperImpl.<get-childIds>.<anonymous>' call
    if (!(this.ff5_1 == null)) {
      this_0.e(PaperConcept_getInstance().mc5_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedPublishedWorkImpl).v2z.call(this));
  };
  protoOf(TypedPaperImpl).c3b = function (nodeId) {
    return new TypedPaperImpl(this.a6o_1, PaperConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPaperImpl).l6o = function (propertyId) {
    return propertyId.equals(PaperConcept_getInstance().fc5_1.e6s_1) ? this.yf4_1 : propertyId.equals(PaperConcept_getInstance().gc5_1.e6s_1) ? this.zf4_1 : propertyId.equals(PaperConcept_getInstance().hc5_1.e6s_1) ? this.af5_1 : propertyId.equals(PaperConcept_getInstance().ic5_1.e6s_1) ? this.bf5_1 : propertyId.equals(PaperConcept_getInstance().jc5_1.e6s_1) ? this.cf5_1 : propertyId.equals(PaperConcept_getInstance().kc5_1.e6s_1) ? this.df5_1 : propertyId.equals(PaperConcept_getInstance().lc5_1.e6s_1) ? this.ef5_1 : protoOf(TypedPublishedWorkImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedPaperImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(PaperConcept_getInstance().fc5_1.e6s_1)) {
      this.yf4_1 = value;
    } else if (propertyId.equals(PaperConcept_getInstance().gc5_1.e6s_1)) {
      this.zf4_1 = value;
    } else if (propertyId.equals(PaperConcept_getInstance().hc5_1.e6s_1)) {
      this.af5_1 = value;
    } else if (propertyId.equals(PaperConcept_getInstance().ic5_1.e6s_1)) {
      this.bf5_1 = value;
    } else if (propertyId.equals(PaperConcept_getInstance().jc5_1.e6s_1)) {
      this.cf5_1 = value;
    } else if (propertyId.equals(PaperConcept_getInstance().kc5_1.e6s_1)) {
      this.df5_1 = value;
    } else if (propertyId.equals(PaperConcept_getInstance().lc5_1.e6s_1)) {
      this.ef5_1 = value;
    } else {
      protoOf(TypedPublishedWorkImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedPaperImpl).l38 = function (childId) {
    return childId.equals(PaperConcept_getInstance().mc5_1.u6o_1) ? _get_pagesField__b06ncl(this) : protoOf(TypedPublishedWorkImpl).l38.call(this, childId);
  };
  function TypedPartReferenceOperationImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function _get_operandField__fjb16i_0($this) {
    if ($this.sf5_1 == null) {
      $this.sf5_1 = $this.t6o(PartValueConcept_getInstance().hc6_1);
    }
    return ensureNotNull($this.sf5_1);
  }
  function _get_operationField__jv73iw($this) {
    if ($this.tf5_1 == null) {
      $this.tf5_1 = $this.t6o(PartValueConcept_getInstance().ic6_1);
    }
    return ensureNotNull($this.tf5_1);
  }
  function TypedPartValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PartValueConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PartValueConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.sf5_1 = null;
    this.tf5_1 = null;
  }
  protoOf(TypedPartValueImpl).obr = function () {
    return this.v6o(_get_operandField__fjb16i_0(this));
  };
  protoOf(TypedPartValueImpl).u3l = function () {
    return this.v6o(_get_operationField__jv73iw(this));
  };
  protoOf(TypedPartValueImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPartValueImpl.<get-childIds>.<anonymous>' call
    if (!(this.sf5_1 == null)) {
      this_0.e(PartValueConcept_getInstance().hc6_1.u6o_1);
    }
    if (!(this.tf5_1 == null)) {
      this_0.e(PartValueConcept_getInstance().ic6_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedPartValueImpl).c3b = function (nodeId) {
    return new TypedPartValueImpl(this.a6o_1, PartValueConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPartValueImpl).l38 = function (childId) {
    return childId.equals(PartValueConcept_getInstance().hc6_1.u6o_1) ? _get_operandField__fjb16i_0(this) : childId.equals(PartValueConcept_getInstance().ic6_1.u6o_1) ? _get_operationField__jv73iw(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedPreconditionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PreconditionConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PreconditionConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedPreconditionImpl).c3b = function (nodeId) {
    return new TypedPreconditionImpl(this.a6o_1, PreconditionConcept_getInstance().e6r_1, nodeId);
  };
  function _get_inheritedField__w0x2ob($this) {
    if ($this.df7_1 == null) {
      $this.df7_1 = $this.w6o(ProcessDeclarationConcept_getInstance().dc7_1);
    }
    return ensureNotNull($this.df7_1);
  }
  function _get_prerequisitesField__14p2ge($this) {
    if ($this.ef7_1 == null) {
      $this.ef7_1 = $this.w6o(ProcessDeclarationConcept_getInstance().ec7_1);
    }
    return ensureNotNull($this.ef7_1);
  }
  function _get_effectsField__xeo0mr($this) {
    if ($this.ff7_1 == null) {
      $this.ff7_1 = $this.w6o(ProcessDeclarationConcept_getInstance().fc7_1);
    }
    return ensureNotNull($this.ff7_1);
  }
  function _get_variablesField__8i4vo8_0($this) {
    if ($this.gf7_1 == null) {
      $this.gf7_1 = $this.w6o(HasVariablesConcept_getInstance().xbc_1);
    }
    return ensureNotNull($this.gf7_1);
  }
  function TypedProcessDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessDeclarationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessDeclarationConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractBindingDeclarationImpl.call(this, context, conceptId, nodeId);
    this.zf6_1 = null;
    this.af7_1 = this.p6o(ProcessDeclarationConcept_getInstance().bc7_1);
    this.bf7_1 = null;
    this.cf7_1 = this.p6o(ProcessDeclarationConcept_getInstance().cc7_1);
    this.df7_1 = null;
    this.ef7_1 = null;
    this.ff7_1 = null;
    this.gf7_1 = null;
  }
  protoOf(TypedProcessDeclarationImpl).r5e = function () {
    return this.af7_1;
  };
  protoOf(TypedProcessDeclarationImpl).gc7 = function () {
    return this.cf7_1;
  };
  protoOf(TypedProcessDeclarationImpl).hc7 = function () {
    return this.y6o(_get_inheritedField__w0x2ob(this));
  };
  protoOf(TypedProcessDeclarationImpl).ic7 = function () {
    return this.y6o(_get_prerequisitesField__14p2ge(this));
  };
  protoOf(TypedProcessDeclarationImpl).jc7 = function () {
    return this.y6o(_get_effectsField__xeo0mr(this));
  };
  protoOf(TypedProcessDeclarationImpl).ybc = function () {
    return this.y6o(_get_variablesField__8i4vo8_0(this));
  };
  protoOf(TypedProcessDeclarationImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessDeclarationImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.zf6_1 == null)) {
      this_0.e(ProcessDeclarationConcept_getInstance().bc7_1.q6o_1);
    }
    if (!(this.bf7_1 == null)) {
      this_0.e(ProcessDeclarationConcept_getInstance().cc7_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractBindingDeclarationImpl).y2z.call(this));
  };
  protoOf(TypedProcessDeclarationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessDeclarationImpl.<get-childIds>.<anonymous>' call
    if (!(this.df7_1 == null)) {
      this_0.e(ProcessDeclarationConcept_getInstance().dc7_1.x6o_1);
    }
    if (!(this.ef7_1 == null)) {
      this_0.e(ProcessDeclarationConcept_getInstance().ec7_1.x6o_1);
    }
    if (!(this.ff7_1 == null)) {
      this_0.e(ProcessDeclarationConcept_getInstance().fc7_1.x6o_1);
    }
    if (!(this.gf7_1 == null)) {
      this_0.e(HasVariablesConcept_getInstance().xbc_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractBindingDeclarationImpl).v2z.call(this));
  };
  protoOf(TypedProcessDeclarationImpl).c3b = function (nodeId) {
    return new TypedProcessDeclarationImpl(this.a6o_1, ProcessDeclarationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessDeclarationImpl).l6o = function (propertyId) {
    return propertyId.equals(ProcessDeclarationConcept_getInstance().bc7_1.q6o_1) ? this.zf6_1 : propertyId.equals(ProcessDeclarationConcept_getInstance().cc7_1.q6o_1) ? this.bf7_1 : protoOf(TypedAbstractBindingDeclarationImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedProcessDeclarationImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(ProcessDeclarationConcept_getInstance().bc7_1.q6o_1)) {
      this.zf6_1 = value;
    } else if (propertyId.equals(ProcessDeclarationConcept_getInstance().cc7_1.q6o_1)) {
      this.bf7_1 = value;
    } else {
      protoOf(TypedAbstractBindingDeclarationImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedProcessDeclarationImpl).l38 = function (childId) {
    return childId.equals(ProcessDeclarationConcept_getInstance().dc7_1.x6o_1) ? _get_inheritedField__w0x2ob(this) : childId.equals(ProcessDeclarationConcept_getInstance().ec7_1.x6o_1) ? _get_prerequisitesField__14p2ge(this) : childId.equals(ProcessDeclarationConcept_getInstance().fc7_1.x6o_1) ? _get_effectsField__xeo0mr(this) : childId.equals(HasVariablesConcept_getInstance().xbc_1.x6o_1) ? _get_variablesField__8i4vo8_0(this) : protoOf(TypedAbstractBindingDeclarationImpl).l38.call(this, childId);
  };
  function _get_expressionField__tmo0lr_1($this) {
    if ($this.vf7_1 == null) {
      $this.vf7_1 = $this.t6o(HasFactExpressionConcept_getInstance().kbb_1);
    }
    return ensureNotNull($this.vf7_1);
  }
  function TypedProcessEffectImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessEffectConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessEffectConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.tf7_1 = null;
    this.uf7_1 = null;
    this.vf7_1 = null;
  }
  protoOf(TypedProcessEffectImpl).obc = function () {
    return this.n6o(HasQueryLabelsConcept_getInstance().mbc_1);
  };
  protoOf(TypedProcessEffectImpl).pbc = function () {
    return this.n6o(HasQueryLabelsConcept_getInstance().nbc_1);
  };
  protoOf(TypedProcessEffectImpl).lbb = function () {
    return this.v6o(_get_expressionField__tmo0lr_1(this));
  };
  protoOf(TypedProcessEffectImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessEffectImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.tf7_1 == null)) {
      this_0.e(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1);
    }
    if (!(this.uf7_1 == null)) {
      this_0.e(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedProcessEffectImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessEffectImpl.<get-childIds>.<anonymous>' call
    if (!(this.vf7_1 == null)) {
      this_0.e(HasFactExpressionConcept_getInstance().kbb_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedProcessEffectImpl).c3b = function (nodeId) {
    return new TypedProcessEffectImpl(this.a6o_1, ProcessEffectConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessEffectImpl).l6o = function (propertyId) {
    return propertyId.equals(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1) ? this.tf7_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1) ? this.uf7_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedProcessEffectImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1)) {
      this.tf7_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1)) {
      this.uf7_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedProcessEffectImpl).l38 = function (childId) {
    return childId.equals(HasFactExpressionConcept_getInstance().kbb_1.u6o_1) ? _get_expressionField__tmo0lr_1(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_kindsField__xft4vk($this) {
    if ($this.kf8_1 == null) {
      $this.kf8_1 = $this.w6o(ProcessKindContainerConcept_getInstance().vc7_1);
    }
    return ensureNotNull($this.kf8_1);
  }
  function TypedProcessKindContainerImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessKindContainerConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessKindContainerConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.kf8_1 = null;
  }
  protoOf(TypedProcessKindContainerImpl).wc7 = function () {
    return this.y6o(_get_kindsField__xft4vk(this));
  };
  protoOf(TypedProcessKindContainerImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessKindContainerImpl.<get-childIds>.<anonymous>' call
    if (!(this.kf8_1 == null)) {
      this_0.e(ProcessKindContainerConcept_getInstance().vc7_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedProcessKindContainerImpl).c3b = function (nodeId) {
    return new TypedProcessKindContainerImpl(this.a6o_1, ProcessKindContainerConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessKindContainerImpl).l38 = function (childId) {
    return childId.equals(ProcessKindContainerConcept_getInstance().vc7_1.x6o_1) ? _get_kindsField__xft4vk(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function TypedProcessKindImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessKindConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessKindConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.xf8_1 = null;
  }
  protoOf(TypedProcessKindImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedProcessKindImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessKindImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.xf8_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedProcessKindImpl).c3b = function (nodeId) {
    return new TypedProcessKindImpl(this.a6o_1, ProcessKindConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessKindImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.xf8_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedProcessKindImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.xf8_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_processesField__sgfytq($this) {
    if ($this.mf9_1 == null) {
      $this.mf9_1 = $this.w6o(ProcessLibraryConcept_getInstance().ic8_1);
    }
    return ensureNotNull($this.mf9_1);
  }
  function TypedProcessLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessLibraryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessLibraryConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.mf9_1 = null;
  }
  protoOf(TypedProcessLibraryImpl).jc8 = function () {
    return this.y6o(_get_processesField__sgfytq(this));
  };
  protoOf(TypedProcessLibraryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessLibraryImpl.<get-childIds>.<anonymous>' call
    if (!(this.mf9_1 == null)) {
      this_0.e(ProcessLibraryConcept_getInstance().ic8_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedProcessLibraryImpl).c3b = function (nodeId) {
    return new TypedProcessLibraryImpl(this.a6o_1, ProcessLibraryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessLibraryImpl).l38 = function (childId) {
    return childId.equals(ProcessLibraryConcept_getInstance().ic8_1.x6o_1) ? _get_processesField__sgfytq(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function _get_expressionField__tmo0lr_2($this) {
    if ($this.bfa_1 == null) {
      $this.bfa_1 = $this.t6o(HasFactExpressionConcept_getInstance().kbb_1);
    }
    return ensureNotNull($this.bfa_1);
  }
  function TypedProcessPrerequisiteImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessPrerequisiteConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPrerequisiteConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.zf9_1 = null;
    this.afa_1 = null;
    this.bfa_1 = null;
  }
  protoOf(TypedProcessPrerequisiteImpl).obc = function () {
    return this.n6o(HasQueryLabelsConcept_getInstance().mbc_1);
  };
  protoOf(TypedProcessPrerequisiteImpl).pbc = function () {
    return this.n6o(HasQueryLabelsConcept_getInstance().nbc_1);
  };
  protoOf(TypedProcessPrerequisiteImpl).lbb = function () {
    return this.v6o(_get_expressionField__tmo0lr_2(this));
  };
  protoOf(TypedProcessPrerequisiteImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessPrerequisiteImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.zf9_1 == null)) {
      this_0.e(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1);
    }
    if (!(this.afa_1 == null)) {
      this_0.e(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedProcessPrerequisiteImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessPrerequisiteImpl.<get-childIds>.<anonymous>' call
    if (!(this.bfa_1 == null)) {
      this_0.e(HasFactExpressionConcept_getInstance().kbb_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedProcessPrerequisiteImpl).c3b = function (nodeId) {
    return new TypedProcessPrerequisiteImpl(this.a6o_1, ProcessPrerequisiteConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessPrerequisiteImpl).l6o = function (propertyId) {
    return propertyId.equals(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1) ? this.zf9_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1) ? this.afa_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedProcessPrerequisiteImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1)) {
      this.zf9_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1)) {
      this.afa_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedProcessPrerequisiteImpl).l38 = function (childId) {
    return childId.equals(HasFactExpressionConcept_getInstance().kbb_1.u6o_1) ? _get_expressionField__tmo0lr_2(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedProcessPropertyCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessPropertyCustomCellConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyCustomCellConcept_getInstance().e6r_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
    this.ofa_1 = null;
    this.pfa_1 = this.p6o(ProcessPropertyCustomCellConcept_getInstance().nc9_1);
  }
  protoOf(TypedProcessPropertyCustomCellImpl).i6u = function () {
    return this.pfa_1;
  };
  protoOf(TypedProcessPropertyCustomCellImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessPropertyCustomCellImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.ofa_1 == null)) {
      this_0.e(ProcessPropertyCustomCellConcept_getInstance().nc9_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedCustomCellImpl).y2z.call(this));
  };
  protoOf(TypedProcessPropertyCustomCellImpl).c3b = function (nodeId) {
    return new TypedProcessPropertyCustomCellImpl(this.a6o_1, ProcessPropertyCustomCellConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessPropertyCustomCellImpl).l6o = function (propertyId) {
    return propertyId.equals(ProcessPropertyCustomCellConcept_getInstance().nc9_1.q6o_1) ? this.ofa_1 : protoOf(TypedCustomCellImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedProcessPropertyCustomCellImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(ProcessPropertyCustomCellConcept_getInstance().nc9_1.q6o_1)) {
      this.ofa_1 = value;
    } else {
      protoOf(TypedCustomCellImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_valueField__9y0rz6_3($this) {
    if ($this.cfb_1 == null) {
      $this.cfb_1 = $this.t6o(ProcessPropertyDefaultConcept_getInstance().zc9_1);
    }
    return ensureNotNull($this.cfb_1);
  }
  function TypedProcessPropertyDefaultImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessPropertyDefaultConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyDefaultConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.cfb_1 = null;
  }
  protoOf(TypedProcessPropertyDefaultImpl).y = function () {
    return this.v6o(_get_valueField__9y0rz6_3(this));
  };
  protoOf(TypedProcessPropertyDefaultImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessPropertyDefaultImpl.<get-childIds>.<anonymous>' call
    if (!(this.cfb_1 == null)) {
      this_0.e(ProcessPropertyDefaultConcept_getInstance().zc9_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedProcessPropertyDefaultImpl).c3b = function (nodeId) {
    return new TypedProcessPropertyDefaultImpl(this.a6o_1, ProcessPropertyDefaultConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessPropertyDefaultImpl).l38 = function (childId) {
    return childId.equals(ProcessPropertyDefaultConcept_getInstance().zc9_1.u6o_1) ? _get_valueField__9y0rz6_3(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_typeField__jjl181_3($this) {
    if ($this.pfb_1 == null) {
      $this.pfb_1 = $this.t6o(ProcessPropertyConcept_getInstance().xc8_1);
    }
    return ensureNotNull($this.pfb_1);
  }
  function _get_aliasedPropertiesField__w72rv1($this) {
    if ($this.qfb_1 == null) {
      $this.qfb_1 = $this.w6o(ProcessPropertyConcept_getInstance().yc8_1);
    }
    return ensureNotNull($this.qfb_1);
  }
  function _get_defaultField__5h0hf6($this) {
    if ($this.rfb_1 == null) {
      $this.rfb_1 = $this.t6o(ProcessPropertyConcept_getInstance().zc8_1);
    }
    return ensureNotNull($this.rfb_1);
  }
  function TypedProcessPropertyImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessPropertyConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.pfb_1 = null;
    this.qfb_1 = null;
    this.rfb_1 = null;
    this.sfb_1 = null;
  }
  protoOf(TypedProcessPropertyImpl).zb3 = function () {
    return this.v6o(_get_typeField__jjl181_3(this));
  };
  protoOf(TypedProcessPropertyImpl).ac9 = function () {
    return this.y6o(_get_aliasedPropertiesField__w72rv1(this));
  };
  protoOf(TypedProcessPropertyImpl).g2o = function () {
    return this.v6o(_get_defaultField__5h0hf6(this));
  };
  protoOf(TypedProcessPropertyImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedProcessPropertyImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessPropertyImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.sfb_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedProcessPropertyImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessPropertyImpl.<get-childIds>.<anonymous>' call
    if (!(this.pfb_1 == null)) {
      this_0.e(ProcessPropertyConcept_getInstance().xc8_1.u6o_1);
    }
    if (!(this.qfb_1 == null)) {
      this_0.e(ProcessPropertyConcept_getInstance().yc8_1.x6o_1);
    }
    if (!(this.rfb_1 == null)) {
      this_0.e(ProcessPropertyConcept_getInstance().zc8_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedProcessPropertyImpl).c3b = function (nodeId) {
    return new TypedProcessPropertyImpl(this.a6o_1, ProcessPropertyConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessPropertyImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.sfb_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedProcessPropertyImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.sfb_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedProcessPropertyImpl).l38 = function (childId) {
    return childId.equals(ProcessPropertyConcept_getInstance().xc8_1.u6o_1) ? _get_typeField__jjl181_3(this) : childId.equals(ProcessPropertyConcept_getInstance().yc8_1.x6o_1) ? _get_aliasedPropertiesField__w72rv1(this) : childId.equals(ProcessPropertyConcept_getInstance().zc8_1.u6o_1) ? _get_defaultField__5h0hf6(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedProcessPropertyReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessPropertyReferenceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyReferenceConcept_getInstance().e6r_1) : nodeId;
    TypedVariableInitializerImpl.call(this, context, conceptId, nodeId);
    this.ffc_1 = null;
    this.gfc_1 = this.p6o(ProcessPropertyReferenceConcept_getInstance().mca_1);
  }
  protoOf(TypedProcessPropertyReferenceImpl).i6u = function () {
    return this.gfc_1;
  };
  protoOf(TypedProcessPropertyReferenceImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessPropertyReferenceImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.ffc_1 == null)) {
      this_0.e(ProcessPropertyReferenceConcept_getInstance().mca_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedVariableInitializerImpl).y2z.call(this));
  };
  protoOf(TypedProcessPropertyReferenceImpl).c3b = function (nodeId) {
    return new TypedProcessPropertyReferenceImpl(this.a6o_1, ProcessPropertyReferenceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessPropertyReferenceImpl).l6o = function (propertyId) {
    return propertyId.equals(ProcessPropertyReferenceConcept_getInstance().mca_1.q6o_1) ? this.ffc_1 : protoOf(TypedVariableInitializerImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedProcessPropertyReferenceImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(ProcessPropertyReferenceConcept_getInstance().mca_1.q6o_1)) {
      this.ffc_1 = value;
    } else {
      protoOf(TypedVariableInitializerImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_valueField__9y0rz6_4($this) {
    if ($this.vfc_1 == null) {
      $this.vfc_1 = $this.t6o(ProcessPropertyValueConcept_getInstance().bcb_1);
    }
    return ensureNotNull($this.vfc_1);
  }
  function TypedProcessPropertyValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessPropertyValueConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyValueConcept_getInstance().e6r_1) : nodeId;
    TypedBindingValuePlaceholderImpl.call(this, context, conceptId, nodeId);
    this.tfc_1 = null;
    this.ufc_1 = this.p6o(ProcessPropertyValueConcept_getInstance().acb_1);
    this.vfc_1 = null;
    this.wfc_1 = null;
    this.xfc_1 = null;
  }
  protoOf(TypedProcessPropertyValueImpl).i6u = function () {
    return this.ufc_1;
  };
  protoOf(TypedProcessPropertyValueImpl).y = function () {
    return this.v6o(_get_valueField__9y0rz6_4(this));
  };
  protoOf(TypedProcessPropertyValueImpl).obc = function () {
    return this.n6o(HasQueryLabelsConcept_getInstance().mbc_1);
  };
  protoOf(TypedProcessPropertyValueImpl).pbc = function () {
    return this.n6o(HasQueryLabelsConcept_getInstance().nbc_1);
  };
  protoOf(TypedProcessPropertyValueImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessPropertyValueImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.tfc_1 == null)) {
      this_0.e(ProcessPropertyValueConcept_getInstance().acb_1.q6o_1);
    }
    if (!(this.wfc_1 == null)) {
      this_0.e(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1);
    }
    if (!(this.xfc_1 == null)) {
      this_0.e(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBindingValuePlaceholderImpl).y2z.call(this));
  };
  protoOf(TypedProcessPropertyValueImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessPropertyValueImpl.<get-childIds>.<anonymous>' call
    if (!(this.vfc_1 == null)) {
      this_0.e(ProcessPropertyValueConcept_getInstance().bcb_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBindingValuePlaceholderImpl).v2z.call(this));
  };
  protoOf(TypedProcessPropertyValueImpl).c3b = function (nodeId) {
    return new TypedProcessPropertyValueImpl(this.a6o_1, ProcessPropertyValueConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessPropertyValueImpl).l6o = function (propertyId) {
    return propertyId.equals(ProcessPropertyValueConcept_getInstance().acb_1.q6o_1) ? this.tfc_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1) ? this.wfc_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1) ? this.xfc_1 : protoOf(TypedBindingValuePlaceholderImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedProcessPropertyValueImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(ProcessPropertyValueConcept_getInstance().acb_1.q6o_1)) {
      this.tfc_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1)) {
      this.wfc_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1)) {
      this.xfc_1 = value;
    } else {
      protoOf(TypedBindingValuePlaceholderImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedProcessPropertyValueImpl).l38 = function (childId) {
    return childId.equals(ProcessPropertyValueConcept_getInstance().bcb_1.u6o_1) ? _get_valueField__9y0rz6_4(this) : protoOf(TypedBindingValuePlaceholderImpl).l38.call(this, childId);
  };
  function TypedProcessReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessReferenceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessReferenceConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.kfd_1 = null;
    this.lfd_1 = this.p6o(ProcessReferenceConcept_getInstance().ocb_1);
  }
  protoOf(TypedProcessReferenceImpl).jbg = function () {
    return this.lfd_1;
  };
  protoOf(TypedProcessReferenceImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessReferenceImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.kfd_1 == null)) {
      this_0.e(ProcessReferenceConcept_getInstance().ocb_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedProcessReferenceImpl).c3b = function (nodeId) {
    return new TypedProcessReferenceImpl(this.a6o_1, ProcessReferenceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessReferenceImpl).l6o = function (propertyId) {
    return propertyId.equals(ProcessReferenceConcept_getInstance().ocb_1.q6o_1) ? this.kfd_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedProcessReferenceImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(ProcessReferenceConcept_getInstance().ocb_1.q6o_1)) {
      this.kfd_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedProcessRelationDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessRelationDeclarationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessRelationDeclarationConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.yfd_1 = null;
    this.zfd_1 = null;
    this.afe_1 = null;
    this.bfe_1 = null;
  }
  protoOf(TypedProcessRelationDeclarationImpl).jcc = function () {
    return this.n6o(ProcessRelationDeclarationConcept_getInstance().gcc_1);
  };
  protoOf(TypedProcessRelationDeclarationImpl).kcc = function () {
    return this.n6o(ProcessRelationDeclarationConcept_getInstance().hcc_1);
  };
  protoOf(TypedProcessRelationDeclarationImpl).lcc = function () {
    return this.n6o(ProcessRelationDeclarationConcept_getInstance().icc_1);
  };
  protoOf(TypedProcessRelationDeclarationImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedProcessRelationDeclarationImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessRelationDeclarationImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.yfd_1 == null)) {
      this_0.e(ProcessRelationDeclarationConcept_getInstance().gcc_1.e6s_1);
    }
    if (!(this.zfd_1 == null)) {
      this_0.e(ProcessRelationDeclarationConcept_getInstance().hcc_1.e6s_1);
    }
    if (!(this.afe_1 == null)) {
      this_0.e(ProcessRelationDeclarationConcept_getInstance().icc_1.e6s_1);
    }
    if (!(this.bfe_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedProcessRelationDeclarationImpl).c3b = function (nodeId) {
    return new TypedProcessRelationDeclarationImpl(this.a6o_1, ProcessRelationDeclarationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessRelationDeclarationImpl).l6o = function (propertyId) {
    return propertyId.equals(ProcessRelationDeclarationConcept_getInstance().gcc_1.e6s_1) ? this.yfd_1 : propertyId.equals(ProcessRelationDeclarationConcept_getInstance().hcc_1.e6s_1) ? this.zfd_1 : propertyId.equals(ProcessRelationDeclarationConcept_getInstance().icc_1.e6s_1) ? this.afe_1 : propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.bfe_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedProcessRelationDeclarationImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(ProcessRelationDeclarationConcept_getInstance().gcc_1.e6s_1)) {
      this.yfd_1 = value;
    } else if (propertyId.equals(ProcessRelationDeclarationConcept_getInstance().hcc_1.e6s_1)) {
      this.zfd_1 = value;
    } else if (propertyId.equals(ProcessRelationDeclarationConcept_getInstance().icc_1.e6s_1)) {
      this.afe_1 = value;
    } else if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.bfe_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_specificationField__lszznw_0($this) {
    if ($this.ofe_1 == null) {
      $this.ofe_1 = $this.t6o(ProcessTypeConcept_getInstance().xcc_1);
    }
    return ensureNotNull($this.ofe_1);
  }
  function TypedProcessTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ProcessTypeConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessTypeConcept_getInstance().e6r_1) : nodeId;
    TypedTypeImpl.call(this, context, conceptId, nodeId);
    this.ofe_1 = null;
  }
  protoOf(TypedProcessTypeImpl).pb5 = function () {
    return this.v6o(_get_specificationField__lszznw_0(this));
  };
  protoOf(TypedProcessTypeImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedProcessTypeImpl.<get-childIds>.<anonymous>' call
    if (!(this.ofe_1 == null)) {
      this_0.e(ProcessTypeConcept_getInstance().xcc_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedTypeImpl).v2z.call(this));
  };
  protoOf(TypedProcessTypeImpl).c3b = function (nodeId) {
    return new TypedProcessTypeImpl(this.a6o_1, ProcessTypeConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedProcessTypeImpl).l38 = function (childId) {
    return childId.equals(ProcessTypeConcept_getInstance().xcc_1.u6o_1) ? _get_specificationField__lszznw_0(this) : protoOf(TypedTypeImpl).l38.call(this, childId);
  };
  function TypedPropertiesCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertiesCustomCellConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertiesCustomCellConcept_getInstance().e6r_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedPropertiesCustomCellImpl).c3b = function (nodeId) {
    return new TypedPropertiesCustomCellImpl(this.a6o_1, PropertiesCustomCellConcept_getInstance().e6r_1, nodeId);
  };
  function _get_valueField__9y0rz6_5($this) {
    if ($this.qff_1 == null) {
      $this.qff_1 = $this.t6o(PropertyConstraintConcept_getInstance().pcd_1);
    }
    return ensureNotNull($this.qff_1);
  }
  function _get_constraintsField__3m7315_1($this) {
    if ($this.rff_1 == null) {
      $this.rff_1 = $this.w6o(HasPropertyConstraintsConcept_getInstance().cbc_1);
    }
    return ensureNotNull($this.rff_1);
  }
  function TypedPropertyConstraintImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyConstraintConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyConstraintConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.nff_1 = null;
    this.off_1 = null;
    this.pff_1 = this.p6o(PropertyConstraintConcept_getInstance().ocd_1);
    this.qff_1 = null;
    this.rff_1 = null;
  }
  protoOf(TypedPropertyConstraintImpl).u3l = function () {
    return this.n6o(PropertyConstraintConcept_getInstance().ncd_1);
  };
  protoOf(TypedPropertyConstraintImpl).i6u = function () {
    return this.pff_1;
  };
  protoOf(TypedPropertyConstraintImpl).y = function () {
    return this.v6o(_get_valueField__9y0rz6_5(this));
  };
  protoOf(TypedPropertyConstraintImpl).dbc = function () {
    return this.y6o(_get_constraintsField__3m7315_1(this));
  };
  protoOf(TypedPropertyConstraintImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPropertyConstraintImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.nff_1 == null)) {
      this_0.e(PropertyConstraintConcept_getInstance().ncd_1.e6s_1);
    }
    if (!(this.off_1 == null)) {
      this_0.e(PropertyConstraintConcept_getInstance().ocd_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedPropertyConstraintImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPropertyConstraintImpl.<get-childIds>.<anonymous>' call
    if (!(this.qff_1 == null)) {
      this_0.e(PropertyConstraintConcept_getInstance().pcd_1.u6o_1);
    }
    if (!(this.rff_1 == null)) {
      this_0.e(HasPropertyConstraintsConcept_getInstance().cbc_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedPropertyConstraintImpl).c3b = function (nodeId) {
    return new TypedPropertyConstraintImpl(this.a6o_1, PropertyConstraintConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPropertyConstraintImpl).l6o = function (propertyId) {
    return propertyId.equals(PropertyConstraintConcept_getInstance().ncd_1.e6s_1) ? this.nff_1 : propertyId.equals(PropertyConstraintConcept_getInstance().ocd_1.q6o_1) ? this.off_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedPropertyConstraintImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(PropertyConstraintConcept_getInstance().ncd_1.e6s_1)) {
      this.nff_1 = value;
    } else if (propertyId.equals(PropertyConstraintConcept_getInstance().ocd_1.q6o_1)) {
      this.off_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedPropertyConstraintImpl).l38 = function (childId) {
    return childId.equals(PropertyConstraintConcept_getInstance().pcd_1.u6o_1) ? _get_valueField__9y0rz6_5(this) : childId.equals(HasPropertyConstraintsConcept_getInstance().cbc_1.x6o_1) ? _get_constraintsField__3m7315_1(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedPropertyCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyCustomCellConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyCustomCellConcept_getInstance().e6r_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
    this.efg_1 = null;
    this.ffg_1 = this.p6o(PropertyCustomCellConcept_getInstance().dce_1);
  }
  protoOf(TypedPropertyCustomCellImpl).i6u = function () {
    return this.ffg_1;
  };
  protoOf(TypedPropertyCustomCellImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPropertyCustomCellImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.efg_1 == null)) {
      this_0.e(PropertyCustomCellConcept_getInstance().dce_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedCustomCellImpl).y2z.call(this));
  };
  protoOf(TypedPropertyCustomCellImpl).c3b = function (nodeId) {
    return new TypedPropertyCustomCellImpl(this.a6o_1, PropertyCustomCellConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPropertyCustomCellImpl).l6o = function (propertyId) {
    return propertyId.equals(PropertyCustomCellConcept_getInstance().dce_1.q6o_1) ? this.efg_1 : protoOf(TypedCustomCellImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedPropertyCustomCellImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(PropertyCustomCellConcept_getInstance().dce_1.q6o_1)) {
      this.efg_1 = value;
    } else {
      protoOf(TypedCustomCellImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_typeField__jjl181_4($this) {
    if ($this.sfg_1 == null) {
      $this.sfg_1 = $this.t6o(PropertyDeclarationConcept_getInstance().pce_1);
    }
    return ensureNotNull($this.sfg_1);
  }
  function TypedPropertyDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyDeclarationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyDeclarationConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.sfg_1 = null;
    this.tfg_1 = null;
  }
  protoOf(TypedPropertyDeclarationImpl).zb3 = function () {
    return this.v6o(_get_typeField__jjl181_4(this));
  };
  protoOf(TypedPropertyDeclarationImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedPropertyDeclarationImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPropertyDeclarationImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.tfg_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedPropertyDeclarationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPropertyDeclarationImpl.<get-childIds>.<anonymous>' call
    if (!(this.sfg_1 == null)) {
      this_0.e(PropertyDeclarationConcept_getInstance().pce_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedPropertyDeclarationImpl).c3b = function (nodeId) {
    return new TypedPropertyDeclarationImpl(this.a6o_1, PropertyDeclarationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPropertyDeclarationImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.tfg_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedPropertyDeclarationImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.tfg_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedPropertyDeclarationImpl).l38 = function (childId) {
    return childId.equals(PropertyDeclarationConcept_getInstance().pce_1.u6o_1) ? _get_typeField__jjl181_4(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedPropertyDeclarationValueQueryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyDeclarationValueQueryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyDeclarationValueQueryConcept_getInstance().e6r_1) : nodeId;
    TypedDeclarationValueQueryImpl.call(this, context, conceptId, nodeId);
    this.hfh_1 = null;
    this.ifh_1 = this.p6o(PropertyDeclarationValueQueryConcept_getInstance().ccf_1);
  }
  protoOf(TypedPropertyDeclarationValueQueryImpl).dcf = function () {
    return this.ifh_1;
  };
  protoOf(TypedPropertyDeclarationValueQueryImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPropertyDeclarationValueQueryImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.hfh_1 == null)) {
      this_0.e(PropertyDeclarationValueQueryConcept_getInstance().ccf_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDeclarationValueQueryImpl).y2z.call(this));
  };
  protoOf(TypedPropertyDeclarationValueQueryImpl).c3b = function (nodeId) {
    return new TypedPropertyDeclarationValueQueryImpl(this.a6o_1, PropertyDeclarationValueQueryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPropertyDeclarationValueQueryImpl).l6o = function (propertyId) {
    return propertyId.equals(PropertyDeclarationValueQueryConcept_getInstance().ccf_1.q6o_1) ? this.hfh_1 : protoOf(TypedDeclarationValueQueryImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedPropertyDeclarationValueQueryImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(PropertyDeclarationValueQueryConcept_getInstance().ccf_1.q6o_1)) {
      this.hfh_1 = value;
    } else {
      protoOf(TypedDeclarationValueQueryImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_elementsField__lf2xhu_0($this) {
    if ($this.xfh_1 == null) {
      $this.xfh_1 = $this.w6o(PropertyLibraryConcept_getInstance().pcf_1);
    }
    return ensureNotNull($this.xfh_1);
  }
  function TypedPropertyLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyLibraryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyLibraryConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.xfh_1 = null;
  }
  protoOf(TypedPropertyLibraryImpl).sc0 = function () {
    return this.y6o(_get_elementsField__lf2xhu_0(this));
  };
  protoOf(TypedPropertyLibraryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPropertyLibraryImpl.<get-childIds>.<anonymous>' call
    if (!(this.xfh_1 == null)) {
      this_0.e(PropertyLibraryConcept_getInstance().pcf_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedPropertyLibraryImpl).c3b = function (nodeId) {
    return new TypedPropertyLibraryImpl(this.a6o_1, PropertyLibraryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPropertyLibraryImpl).l38 = function (childId) {
    return childId.equals(PropertyLibraryConcept_getInstance().pcf_1.x6o_1) ? _get_elementsField__lf2xhu_0(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function _get_parameterField__e0nesm($this) {
    if ($this.mfi_1 == null) {
      $this.mfi_1 = $this.t6o(PropertyReferenceOperationConcept_getInstance().ecg_1);
    }
    return ensureNotNull($this.mfi_1);
  }
  function TypedPropertyReferenceOperationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyReferenceOperationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyReferenceOperationConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.kfi_1 = null;
    this.lfi_1 = this.p6o(PropertyReferenceOperationConcept_getInstance().dcg_1);
    this.mfi_1 = null;
  }
  protoOf(TypedPropertyReferenceOperationImpl).i6u = function () {
    return this.lfi_1;
  };
  protoOf(TypedPropertyReferenceOperationImpl).fcg = function () {
    return this.v6o(_get_parameterField__e0nesm(this));
  };
  protoOf(TypedPropertyReferenceOperationImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPropertyReferenceOperationImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.kfi_1 == null)) {
      this_0.e(PropertyReferenceOperationConcept_getInstance().dcg_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedPropertyReferenceOperationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPropertyReferenceOperationImpl.<get-childIds>.<anonymous>' call
    if (!(this.mfi_1 == null)) {
      this_0.e(PropertyReferenceOperationConcept_getInstance().ecg_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedPropertyReferenceOperationImpl).c3b = function (nodeId) {
    return new TypedPropertyReferenceOperationImpl(this.a6o_1, PropertyReferenceOperationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPropertyReferenceOperationImpl).l6o = function (propertyId) {
    return propertyId.equals(PropertyReferenceOperationConcept_getInstance().dcg_1.q6o_1) ? this.kfi_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedPropertyReferenceOperationImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(PropertyReferenceOperationConcept_getInstance().dcg_1.q6o_1)) {
      this.kfi_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedPropertyReferenceOperationImpl).l38 = function (childId) {
    return childId.equals(PropertyReferenceOperationConcept_getInstance().ecg_1.u6o_1) ? _get_parameterField__e0nesm(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedPropertyValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyValueConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyValueConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractBindingValueImpl.call(this, context, conceptId, nodeId);
    this.afj_1 = null;
    this.bfj_1 = this.p6o(PropertyValueConcept_getInstance().scg_1);
  }
  protoOf(TypedPropertyValueImpl).i6u = function () {
    return this.bfj_1;
  };
  protoOf(TypedPropertyValueImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPropertyValueImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.afj_1 == null)) {
      this_0.e(PropertyValueConcept_getInstance().scg_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAbstractBindingValueImpl).y2z.call(this));
  };
  protoOf(TypedPropertyValueImpl).c3b = function (nodeId) {
    return new TypedPropertyValueImpl(this.a6o_1, PropertyValueConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPropertyValueImpl).l6o = function (propertyId) {
    return propertyId.equals(PropertyValueConcept_getInstance().scg_1.q6o_1) ? this.afj_1 : protoOf(TypedAbstractBindingValueImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedPropertyValueImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(PropertyValueConcept_getInstance().scg_1.q6o_1)) {
      this.afj_1 = value;
    } else {
      protoOf(TypedAbstractBindingValueImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedPropertyValueRangeImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function TypedPubMedSourceReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PubMedSourceReferenceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PubMedSourceReferenceConcept_getInstance().e6r_1) : nodeId;
    TypedKnowledgeSourceReferenceImpl.call(this, context, conceptId, nodeId);
    this.ofj_1 = null;
  }
  protoOf(TypedPubMedSourceReferenceImpl).rc5 = function () {
    return this.n6o(PubMedSourceReferenceConcept_getInstance().ech_1);
  };
  protoOf(TypedPubMedSourceReferenceImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPubMedSourceReferenceImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.ofj_1 == null)) {
      this_0.e(PubMedSourceReferenceConcept_getInstance().ech_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedKnowledgeSourceReferenceImpl).y2z.call(this));
  };
  protoOf(TypedPubMedSourceReferenceImpl).c3b = function (nodeId) {
    return new TypedPubMedSourceReferenceImpl(this.a6o_1, PubMedSourceReferenceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPubMedSourceReferenceImpl).l6o = function (propertyId) {
    return propertyId.equals(PubMedSourceReferenceConcept_getInstance().ech_1.e6s_1) ? this.ofj_1 : protoOf(TypedKnowledgeSourceReferenceImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedPubMedSourceReferenceImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(PubMedSourceReferenceConcept_getInstance().ech_1.e6s_1)) {
      this.ofj_1 = value;
    } else {
      protoOf(TypedKnowledgeSourceReferenceImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_pageSpecificationField__867h7f($this) {
    if ($this.dfk_1 == null) {
      $this.dfk_1 = $this.t6o(PublishedSourceReferenceConcept_getInstance().tch_1);
    }
    return ensureNotNull($this.dfk_1);
  }
  function TypedPublishedSourceReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PublishedSourceReferenceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PublishedSourceReferenceConcept_getInstance().e6r_1) : nodeId;
    TypedKnowledgeSourceReferenceImpl.call(this, context, conceptId, nodeId);
    this.bfk_1 = null;
    this.cfk_1 = this.p6o(PublishedSourceReferenceConcept_getInstance().sch_1);
    this.dfk_1 = null;
  }
  protoOf(TypedPublishedSourceReferenceImpl).k6h = function () {
    return this.cfk_1;
  };
  protoOf(TypedPublishedSourceReferenceImpl).uch = function () {
    return this.v6o(_get_pageSpecificationField__867h7f(this));
  };
  protoOf(TypedPublishedSourceReferenceImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPublishedSourceReferenceImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.bfk_1 == null)) {
      this_0.e(PublishedSourceReferenceConcept_getInstance().sch_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedKnowledgeSourceReferenceImpl).y2z.call(this));
  };
  protoOf(TypedPublishedSourceReferenceImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPublishedSourceReferenceImpl.<get-childIds>.<anonymous>' call
    if (!(this.dfk_1 == null)) {
      this_0.e(PublishedSourceReferenceConcept_getInstance().tch_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedKnowledgeSourceReferenceImpl).v2z.call(this));
  };
  protoOf(TypedPublishedSourceReferenceImpl).c3b = function (nodeId) {
    return new TypedPublishedSourceReferenceImpl(this.a6o_1, PublishedSourceReferenceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPublishedSourceReferenceImpl).l6o = function (propertyId) {
    return propertyId.equals(PublishedSourceReferenceConcept_getInstance().sch_1.q6o_1) ? this.bfk_1 : protoOf(TypedKnowledgeSourceReferenceImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedPublishedSourceReferenceImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(PublishedSourceReferenceConcept_getInstance().sch_1.q6o_1)) {
      this.bfk_1 = value;
    } else {
      protoOf(TypedKnowledgeSourceReferenceImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedPublishedSourceReferenceImpl).l38 = function (childId) {
    return childId.equals(PublishedSourceReferenceConcept_getInstance().tch_1.u6o_1) ? _get_pageSpecificationField__867h7f(this) : protoOf(TypedKnowledgeSourceReferenceImpl).l38.call(this, childId);
  };
  function _get_itemsField__lgr4c1($this) {
    if ($this.sfk_1 == null) {
      $this.sfk_1 = $this.w6o(PublishedSourcesLibraryConcept_getInstance().gci_1);
    }
    return ensureNotNull($this.sfk_1);
  }
  function TypedPublishedSourcesLibraryImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PublishedSourcesLibraryConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PublishedSourcesLibraryConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.sfk_1 = null;
  }
  protoOf(TypedPublishedSourcesLibraryImpl).cq = function () {
    return this.y6o(_get_itemsField__lgr4c1(this));
  };
  protoOf(TypedPublishedSourcesLibraryImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPublishedSourcesLibraryImpl.<get-childIds>.<anonymous>' call
    if (!(this.sfk_1 == null)) {
      this_0.e(PublishedSourcesLibraryConcept_getInstance().gci_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedPublishedSourcesLibraryImpl).c3b = function (nodeId) {
    return new TypedPublishedSourcesLibraryImpl(this.a6o_1, PublishedSourcesLibraryConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPublishedSourcesLibraryImpl).l38 = function (childId) {
    return childId.equals(PublishedSourcesLibraryConcept_getInstance().gci_1.x6o_1) ? _get_itemsField__lgr4c1(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function TypedPublishedWorkImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PublishedWorkConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PublishedWorkConcept_getInstance().e6r_1) : nodeId;
    TypedAuthoredWorkImpl.call(this, context, conceptId, nodeId);
    this.udq_1 = null;
    this.vdq_1 = null;
    this.wdq_1 = get_name_0.call(this);
  }
  protoOf(TypedPublishedWorkImpl).vci = function () {
    return this.n6o(PublishedWorkConcept_getInstance().tci_1);
  };
  protoOf(TypedPublishedWorkImpl).wci = function () {
    return this.n6o(PublishedWorkConcept_getInstance().uci_1);
  };
  protoOf(TypedPublishedWorkImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedPublishedWorkImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.udq_1 == null)) {
      this_0.e(PublishedWorkConcept_getInstance().tci_1.e6s_1);
    }
    if (!(this.vdq_1 == null)) {
      this_0.e(PublishedWorkConcept_getInstance().uci_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedAuthoredWorkImpl).y2z.call(this));
  };
  protoOf(TypedPublishedWorkImpl).b3 = function () {
    return this.wdq_1;
  };
  protoOf(TypedPublishedWorkImpl).c3b = function (nodeId) {
    return new TypedPublishedWorkImpl(this.a6o_1, PublishedWorkConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedPublishedWorkImpl).l6o = function (propertyId) {
    return propertyId.equals(PublishedWorkConcept_getInstance().tci_1.e6s_1) ? this.udq_1 : propertyId.equals(PublishedWorkConcept_getInstance().uci_1.e6s_1) ? this.vdq_1 : protoOf(TypedAuthoredWorkImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedPublishedWorkImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(PublishedWorkConcept_getInstance().tci_1.e6s_1)) {
      this.udq_1 = value;
    } else if (propertyId.equals(PublishedWorkConcept_getInstance().uci_1.e6s_1)) {
      this.vdq_1 = value;
    } else {
      protoOf(TypedAuthoredWorkImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_libraryReferenceField__pf1ou1($this) {
    if ($this.ffl_1 == null) {
      $this.ffl_1 = $this.t6o(QualifiedOntologyElementReferenceConcept_getInstance().jcj_1);
    }
    return ensureNotNull($this.ffl_1);
  }
  function _get_elementReferenceField__f83ycm($this) {
    if ($this.gfl_1 == null) {
      $this.gfl_1 = $this.t6o(QualifiedOntologyElementReferenceConcept_getInstance().kcj_1);
    }
    return ensureNotNull($this.gfl_1);
  }
  function TypedQualifiedOntologyElementReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? QualifiedOntologyElementReferenceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(QualifiedOntologyElementReferenceConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ffl_1 = null;
    this.gfl_1 = null;
  }
  protoOf(TypedQualifiedOntologyElementReferenceImpl).lcj = function () {
    return this.v6o(_get_libraryReferenceField__pf1ou1(this));
  };
  protoOf(TypedQualifiedOntologyElementReferenceImpl).mcj = function () {
    return this.v6o(_get_elementReferenceField__f83ycm(this));
  };
  protoOf(TypedQualifiedOntologyElementReferenceImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedQualifiedOntologyElementReferenceImpl.<get-childIds>.<anonymous>' call
    if (!(this.ffl_1 == null)) {
      this_0.e(QualifiedOntologyElementReferenceConcept_getInstance().jcj_1.u6o_1);
    }
    if (!(this.gfl_1 == null)) {
      this_0.e(QualifiedOntologyElementReferenceConcept_getInstance().kcj_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedQualifiedOntologyElementReferenceImpl).c3b = function (nodeId) {
    return new TypedQualifiedOntologyElementReferenceImpl(this.a6o_1, QualifiedOntologyElementReferenceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedQualifiedOntologyElementReferenceImpl).l38 = function (childId) {
    return childId.equals(QualifiedOntologyElementReferenceConcept_getInstance().jcj_1.u6o_1) ? _get_libraryReferenceField__pf1ou1(this) : childId.equals(QualifiedOntologyElementReferenceConcept_getInstance().kcj_1.u6o_1) ? _get_elementReferenceField__f83ycm(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_commandsField__o5mz41($this) {
    if ($this.vfl_1 == null) {
      $this.vfl_1 = $this.w6o(QueryCommandsConcept_getInstance().ycj_1);
    }
    return ensureNotNull($this.vfl_1);
  }
  function TypedQueryCommandsImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? QueryCommandsConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(QueryCommandsConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.vfl_1 = null;
  }
  protoOf(TypedQueryCommandsImpl).v4n = function () {
    return this.y6o(_get_commandsField__o5mz41(this));
  };
  protoOf(TypedQueryCommandsImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedQueryCommandsImpl.<get-childIds>.<anonymous>' call
    if (!(this.vfl_1 == null)) {
      this_0.e(QueryCommandsConcept_getInstance().ycj_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedQueryCommandsImpl).c3b = function (nodeId) {
    return new TypedQueryCommandsImpl(this.a6o_1, QueryCommandsConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedQueryCommandsImpl).l38 = function (childId) {
    return childId.equals(QueryCommandsConcept_getInstance().ycj_1.x6o_1) ? _get_commandsField__o5mz41(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function _get_expressionField__tmo0lr_3($this) {
    if ($this.kfm_1 == null) {
      $this.kfm_1 = $this.t6o(HasFactExpressionConcept_getInstance().kbb_1);
    }
    return ensureNotNull($this.kfm_1);
  }
  function TypedQueryLabelsFactExpressionContainerImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? QueryLabelsFactExpressionContainerConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(QueryLabelsFactExpressionContainerConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ifm_1 = null;
    this.jfm_1 = null;
    this.kfm_1 = null;
  }
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).obc = function () {
    return this.n6o(HasQueryLabelsConcept_getInstance().mbc_1);
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).pbc = function () {
    return this.n6o(HasQueryLabelsConcept_getInstance().nbc_1);
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).lbb = function () {
    return this.v6o(_get_expressionField__tmo0lr_3(this));
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedQueryLabelsFactExpressionContainerImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.ifm_1 == null)) {
      this_0.e(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1);
    }
    if (!(this.jfm_1 == null)) {
      this_0.e(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedQueryLabelsFactExpressionContainerImpl.<get-childIds>.<anonymous>' call
    if (!(this.kfm_1 == null)) {
      this_0.e(HasFactExpressionConcept_getInstance().kbb_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).c3b = function (nodeId) {
    return new TypedQueryLabelsFactExpressionContainerImpl(this.a6o_1, QueryLabelsFactExpressionContainerConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).l6o = function (propertyId) {
    return propertyId.equals(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1) ? this.ifm_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1) ? this.jfm_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1)) {
      this.ifm_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1)) {
      this.jfm_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedQueryLabelsFactExpressionContainerImpl).l38 = function (childId) {
    return childId.equals(HasFactExpressionConcept_getInstance().kbb_1.u6o_1) ? _get_expressionField__tmo0lr_3(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_elementsField__lf2xhu_1($this) {
    if ($this.bfn_1 == null) {
      $this.bfn_1 = $this.w6o(QueryParametersBlackListConcept_getInstance().nck_1);
    }
    return ensureNotNull($this.bfn_1);
  }
  function TypedQueryParametersBlackListImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? QueryParametersBlackListConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(QueryParametersBlackListConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.zfm_1 = null;
    this.afn_1 = this.p6o(QueryParametersBlackListConcept_getInstance().mck_1);
    this.bfn_1 = null;
  }
  protoOf(TypedQueryParametersBlackListImpl).kay = function () {
    return this.afn_1;
  };
  protoOf(TypedQueryParametersBlackListImpl).sc0 = function () {
    return this.y6o(_get_elementsField__lf2xhu_1(this));
  };
  protoOf(TypedQueryParametersBlackListImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedQueryParametersBlackListImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.zfm_1 == null)) {
      this_0.e(QueryParametersBlackListConcept_getInstance().mck_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).y2z.call(this));
  };
  protoOf(TypedQueryParametersBlackListImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedQueryParametersBlackListImpl.<get-childIds>.<anonymous>' call
    if (!(this.bfn_1 == null)) {
      this_0.e(QueryParametersBlackListConcept_getInstance().nck_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedQueryParametersBlackListImpl).c3b = function (nodeId) {
    return new TypedQueryParametersBlackListImpl(this.a6o_1, QueryParametersBlackListConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedQueryParametersBlackListImpl).l6o = function (propertyId) {
    return propertyId.equals(QueryParametersBlackListConcept_getInstance().mck_1.q6o_1) ? this.zfm_1 : protoOf(TypedDocumentNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedQueryParametersBlackListImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(QueryParametersBlackListConcept_getInstance().mck_1.q6o_1)) {
      this.zfm_1 = value;
    } else {
      protoOf(TypedDocumentNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedQueryParametersBlackListImpl).l38 = function (childId) {
    return childId.equals(QueryParametersBlackListConcept_getInstance().nck_1.x6o_1) ? _get_elementsField__lf2xhu_1(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function _get_processRelationsField__rapabj($this) {
    if ($this.qfn_1 == null) {
      $this.qfn_1 = $this.w6o(RelationContainerConcept_getInstance().acl_1);
    }
    return ensureNotNull($this.qfn_1);
  }
  function _get_instanceRelationsField__97xosz($this) {
    if ($this.rfn_1 == null) {
      $this.rfn_1 = $this.w6o(RelationContainerConcept_getInstance().bcl_1);
    }
    return ensureNotNull($this.rfn_1);
  }
  function TypedRelationContainerImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? RelationContainerConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(RelationContainerConcept_getInstance().e6r_1) : nodeId;
    TypedDocumentNodeImpl.call(this, context, conceptId, nodeId);
    this.qfn_1 = null;
    this.rfn_1 = null;
  }
  protoOf(TypedRelationContainerImpl).ccl = function () {
    return this.y6o(_get_processRelationsField__rapabj(this));
  };
  protoOf(TypedRelationContainerImpl).dcl = function () {
    return this.y6o(_get_instanceRelationsField__97xosz(this));
  };
  protoOf(TypedRelationContainerImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedRelationContainerImpl.<get-childIds>.<anonymous>' call
    if (!(this.qfn_1 == null)) {
      this_0.e(RelationContainerConcept_getInstance().acl_1.x6o_1);
    }
    if (!(this.rfn_1 == null)) {
      this_0.e(RelationContainerConcept_getInstance().bcl_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedDocumentNodeImpl).v2z.call(this));
  };
  protoOf(TypedRelationContainerImpl).c3b = function (nodeId) {
    return new TypedRelationContainerImpl(this.a6o_1, RelationContainerConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedRelationContainerImpl).l38 = function (childId) {
    return childId.equals(RelationContainerConcept_getInstance().acl_1.x6o_1) ? _get_processRelationsField__rapabj(this) : childId.equals(RelationContainerConcept_getInstance().bcl_1.x6o_1) ? _get_instanceRelationsField__97xosz(this) : protoOf(TypedDocumentNodeImpl).l38.call(this, childId);
  };
  function _get_leftField__72ma9q_1($this) {
    if ($this.efo_1 == null) {
      $this.efo_1 = $this.t6o(RelationFactExpressionConcept_getInstance().rcl_1);
    }
    return ensureNotNull($this.efo_1);
  }
  function _get_rightField__qpqtcd_1($this) {
    if ($this.ffo_1 == null) {
      $this.ffo_1 = $this.t6o(RelationFactExpressionConcept_getInstance().scl_1);
    }
    return ensureNotNull($this.ffo_1);
  }
  function TypedRelationFactExpressionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? RelationFactExpressionConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(RelationFactExpressionConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.efo_1 = null;
    this.ffo_1 = null;
    this.gfo_1 = null;
    this.hfo_1 = this.p6o(RelationFactExpressionConcept_getInstance().tcl_1);
  }
  protoOf(TypedRelationFactExpressionImpl).sbf = function () {
    return this.v6o(_get_leftField__72ma9q_1(this));
  };
  protoOf(TypedRelationFactExpressionImpl).tbf = function () {
    return this.v6o(_get_rightField__qpqtcd_1(this));
  };
  protoOf(TypedRelationFactExpressionImpl).gb6 = function () {
    return this.hfo_1;
  };
  protoOf(TypedRelationFactExpressionImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedRelationFactExpressionImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.gfo_1 == null)) {
      this_0.e(RelationFactExpressionConcept_getInstance().tcl_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedRelationFactExpressionImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedRelationFactExpressionImpl.<get-childIds>.<anonymous>' call
    if (!(this.efo_1 == null)) {
      this_0.e(RelationFactExpressionConcept_getInstance().rcl_1.u6o_1);
    }
    if (!(this.ffo_1 == null)) {
      this_0.e(RelationFactExpressionConcept_getInstance().scl_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedRelationFactExpressionImpl).c3b = function (nodeId) {
    return new TypedRelationFactExpressionImpl(this.a6o_1, RelationFactExpressionConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedRelationFactExpressionImpl).l6o = function (propertyId) {
    return propertyId.equals(RelationFactExpressionConcept_getInstance().tcl_1.q6o_1) ? this.gfo_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedRelationFactExpressionImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(RelationFactExpressionConcept_getInstance().tcl_1.q6o_1)) {
      this.gfo_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedRelationFactExpressionImpl).l38 = function (childId) {
    return childId.equals(RelationFactExpressionConcept_getInstance().rcl_1.u6o_1) ? _get_leftField__72ma9q_1(this) : childId.equals(RelationFactExpressionConcept_getInstance().scl_1.u6o_1) ? _get_rightField__qpqtcd_1(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedReturnTypeCustomCellImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ReturnTypeCustomCellConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ReturnTypeCustomCellConcept_getInstance().e6r_1) : nodeId;
    TypedCustomCellImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedReturnTypeCustomCellImpl).c3b = function (nodeId) {
    return new TypedReturnTypeCustomCellImpl(this.a6o_1, ReturnTypeCustomCellConcept_getInstance().e6r_1, nodeId);
  };
  function _get_expressionsField__6fs50_0($this) {
    if ($this.gfp_1 == null) {
      $this.gfp_1 = $this.w6o(SetExpressionConcept_getInstance().hcm_1);
    }
    return ensureNotNull($this.gfp_1);
  }
  function TypedSetExpressionImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? SetExpressionConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(SetExpressionConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.gfp_1 = null;
    this.hfp_1 = null;
  }
  protoOf(TypedSetExpressionImpl).rbs = function () {
    return this.y6o(_get_expressionsField__6fs50_0(this));
  };
  protoOf(TypedSetExpressionImpl).jcm = function () {
    return this.n6o(SetExpressionConcept_getInstance().icm_1);
  };
  protoOf(TypedSetExpressionImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedSetExpressionImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.hfp_1 == null)) {
      this_0.e(SetExpressionConcept_getInstance().icm_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedSetExpressionImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedSetExpressionImpl.<get-childIds>.<anonymous>' call
    if (!(this.gfp_1 == null)) {
      this_0.e(SetExpressionConcept_getInstance().hcm_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedSetExpressionImpl).c3b = function (nodeId) {
    return new TypedSetExpressionImpl(this.a6o_1, SetExpressionConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedSetExpressionImpl).l6o = function (propertyId) {
    return propertyId.equals(SetExpressionConcept_getInstance().icm_1.e6s_1) ? this.hfp_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedSetExpressionImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(SetExpressionConcept_getInstance().icm_1.e6s_1)) {
      this.hfp_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedSetExpressionImpl).l38 = function (childId) {
    return childId.equals(SetExpressionConcept_getInstance().hcm_1.x6o_1) ? _get_expressionsField__6fs50_0(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_valueField__9y0rz6_6($this) {
    if ($this.ufp_1 == null) {
      $this.ufp_1 = $this.t6o(SetValuedPropertyParameterConcept_getInstance().vcm_1);
    }
    return ensureNotNull($this.ufp_1);
  }
  function TypedSetValuedPropertyParameterImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? SetValuedPropertyParameterConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(SetValuedPropertyParameterConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ufp_1 = null;
  }
  protoOf(TypedSetValuedPropertyParameterImpl).y = function () {
    return this.v6o(_get_valueField__9y0rz6_6(this));
  };
  protoOf(TypedSetValuedPropertyParameterImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedSetValuedPropertyParameterImpl.<get-childIds>.<anonymous>' call
    if (!(this.ufp_1 == null)) {
      this_0.e(SetValuedPropertyParameterConcept_getInstance().vcm_1.u6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedSetValuedPropertyParameterImpl).c3b = function (nodeId) {
    return new TypedSetValuedPropertyParameterImpl(this.a6o_1, SetValuedPropertyParameterConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedSetValuedPropertyParameterImpl).l38 = function (childId) {
    return childId.equals(SetValuedPropertyParameterConcept_getInstance().vcm_1.u6o_1) ? _get_valueField__9y0rz6_6(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedSimplePropertyTypeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? SimplePropertyTypeConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(SimplePropertyTypeConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.hfq_1 = null;
    this.ifq_1 = this.p6o(SimplePropertyTypeConcept_getInstance().icn_1);
  }
  protoOf(TypedSimplePropertyTypeImpl).lbp = function () {
    return this.ifq_1;
  };
  protoOf(TypedSimplePropertyTypeImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedSimplePropertyTypeImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.hfq_1 == null)) {
      this_0.e(SimplePropertyTypeConcept_getInstance().icn_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedSimplePropertyTypeImpl).c3b = function (nodeId) {
    return new TypedSimplePropertyTypeImpl(this.a6o_1, SimplePropertyTypeConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedSimplePropertyTypeImpl).l6o = function (propertyId) {
    return propertyId.equals(SimplePropertyTypeConcept_getInstance().icn_1.q6o_1) ? this.hfq_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedSimplePropertyTypeImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(SimplePropertyTypeConcept_getInstance().icn_1.q6o_1)) {
      this.hfq_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_typesField__spk11y_0($this) {
    if ($this.vfq_1 == null) {
      $this.vfq_1 = $this.w6o(SinglePropertyValueRangeConcept_getInstance().ucn_1);
    }
    return ensureNotNull($this.vfq_1);
  }
  function TypedSinglePropertyValueRangeImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? SinglePropertyValueRangeConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(SinglePropertyValueRangeConcept_getInstance().e6r_1) : nodeId;
    TypedPropertyValueRangeImpl.call(this, context, conceptId, nodeId);
    this.vfq_1 = null;
  }
  protoOf(TypedSinglePropertyValueRangeImpl).lbn = function () {
    return this.y6o(_get_typesField__spk11y_0(this));
  };
  protoOf(TypedSinglePropertyValueRangeImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedSinglePropertyValueRangeImpl.<get-childIds>.<anonymous>' call
    if (!(this.vfq_1 == null)) {
      this_0.e(SinglePropertyValueRangeConcept_getInstance().ucn_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedPropertyValueRangeImpl).v2z.call(this));
  };
  protoOf(TypedSinglePropertyValueRangeImpl).c3b = function (nodeId) {
    return new TypedSinglePropertyValueRangeImpl(this.a6o_1, SinglePropertyValueRangeConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedSinglePropertyValueRangeImpl).l38 = function (childId) {
    return childId.equals(SinglePropertyValueRangeConcept_getInstance().ucn_1.x6o_1) ? _get_typesField__spk11y_0(this) : protoOf(TypedPropertyValueRangeImpl).l38.call(this, childId);
  };
  function TypedTextLineImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? TextLineConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(TextLineConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.ifr_1 = null;
  }
  protoOf(TypedTextLineImpl).laz = function () {
    return this.o6o(TextLineConcept_getInstance().gco_1);
  };
  protoOf(TypedTextLineImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedTextLineImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.ifr_1 == null)) {
      this_0.e(TextLineConcept_getInstance().gco_1.k6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedTextLineImpl).c3b = function (nodeId) {
    return new TypedTextLineImpl(this.a6o_1, TextLineConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedTextLineImpl).l6o = function (propertyId) {
    return propertyId.equals(TextLineConcept_getInstance().gco_1.k6s_1) ? this.ifr_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedTextLineImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(TextLineConcept_getInstance().gco_1.k6s_1)) {
      this.ifr_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedTypeImpl(context, conceptId, nodeId) {
    TypedVariableSpecificationImpl.call(this, context, conceptId, nodeId);
  }
  function TypedTypePlaceholderImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? TypePlaceholderConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(TypePlaceholderConcept_getInstance().e6r_1) : nodeId;
    TypedTypeImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedTypePlaceholderImpl).c3b = function (nodeId) {
    return new TypedTypePlaceholderImpl(this.a6o_1, TypePlaceholderConcept_getInstance().e6r_1, nodeId);
  };
  function _get_classesField__tqjl1z($this) {
    if ($this.hfs_1 == null) {
      $this.hfs_1 = $this.w6o(UnionClassConcept_getInstance().sco_1);
    }
    return ensureNotNull($this.hfs_1);
  }
  function TypedUnionClassImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? UnionClassConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(UnionClassConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.hfs_1 = null;
  }
  protoOf(TypedUnionClassImpl).tco = function () {
    return this.y6o(_get_classesField__tqjl1z(this));
  };
  protoOf(TypedUnionClassImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedUnionClassImpl.<get-childIds>.<anonymous>' call
    if (!(this.hfs_1 == null)) {
      this_0.e(UnionClassConcept_getInstance().sco_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedUnionClassImpl).c3b = function (nodeId) {
    return new TypedUnionClassImpl(this.a6o_1, UnionClassConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedUnionClassImpl).l38 = function (childId) {
    return childId.equals(UnionClassConcept_getInstance().sco_1.x6o_1) ? _get_classesField__tqjl1z(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedUrlKnowledgeSourceReferenceImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? UrlKnowledgeSourceReferenceConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(UrlKnowledgeSourceReferenceConcept_getInstance().e6r_1) : nodeId;
    TypedKnowledgeSourceReferenceImpl.call(this, context, conceptId, nodeId);
    this.ufs_1 = null;
  }
  protoOf(TypedUrlKnowledgeSourceReferenceImpl).jbu = function () {
    return this.n6o(UrlKnowledgeSourceReferenceConcept_getInstance().fcp_1);
  };
  protoOf(TypedUrlKnowledgeSourceReferenceImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedUrlKnowledgeSourceReferenceImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.ufs_1 == null)) {
      this_0.e(UrlKnowledgeSourceReferenceConcept_getInstance().fcp_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedKnowledgeSourceReferenceImpl).y2z.call(this));
  };
  protoOf(TypedUrlKnowledgeSourceReferenceImpl).c3b = function (nodeId) {
    return new TypedUrlKnowledgeSourceReferenceImpl(this.a6o_1, UrlKnowledgeSourceReferenceConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedUrlKnowledgeSourceReferenceImpl).l6o = function (propertyId) {
    return propertyId.equals(UrlKnowledgeSourceReferenceConcept_getInstance().fcp_1.e6s_1) ? this.ufs_1 : protoOf(TypedKnowledgeSourceReferenceImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedUrlKnowledgeSourceReferenceImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(UrlKnowledgeSourceReferenceConcept_getInstance().fcp_1.e6s_1)) {
      this.ufs_1 = value;
    } else {
      protoOf(TypedKnowledgeSourceReferenceImpl).m6o.call(this, propertyId, value);
    }
  };
  function _get_valueField__9y0rz6_7($this) {
    if ($this.hft_1 == null) {
      $this.hft_1 = $this.t6o(ValueWithRelationsConcept_getInstance().scp_1);
    }
    return ensureNotNull($this.hft_1);
  }
  function _get_relationsField__kxte08($this) {
    if ($this.ift_1 == null) {
      $this.ift_1 = $this.w6o(ValueWithRelationsConcept_getInstance().tcp_1);
    }
    return ensureNotNull($this.ift_1);
  }
  function TypedValueWithRelationsImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? ValueWithRelationsConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ValueWithRelationsConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.hft_1 = null;
    this.ift_1 = null;
  }
  protoOf(TypedValueWithRelationsImpl).y = function () {
    return this.v6o(_get_valueField__9y0rz6_7(this));
  };
  protoOf(TypedValueWithRelationsImpl).ucp = function () {
    return this.y6o(_get_relationsField__kxte08(this));
  };
  protoOf(TypedValueWithRelationsImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedValueWithRelationsImpl.<get-childIds>.<anonymous>' call
    if (!(this.hft_1 == null)) {
      this_0.e(ValueWithRelationsConcept_getInstance().scp_1.u6o_1);
    }
    if (!(this.ift_1 == null)) {
      this_0.e(ValueWithRelationsConcept_getInstance().tcp_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedValueWithRelationsImpl).c3b = function (nodeId) {
    return new TypedValueWithRelationsImpl(this.a6o_1, ValueWithRelationsConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedValueWithRelationsImpl).l38 = function (childId) {
    return childId.equals(ValueWithRelationsConcept_getInstance().scp_1.u6o_1) ? _get_valueField__9y0rz6_7(this) : childId.equals(ValueWithRelationsConcept_getInstance().tcp_1.x6o_1) ? _get_relationsField__kxte08(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function _get_specField__gg1gz6($this) {
    if ($this.vft_1 == null) {
      $this.vft_1 = $this.t6o(VariableDeclarationConcept_getInstance().hcq_1);
    }
    return ensureNotNull($this.vft_1);
  }
  function _get_relationsField__kxte08_0($this) {
    if ($this.wft_1 == null) {
      $this.wft_1 = $this.w6o(VariableDeclarationConcept_getInstance().icq_1);
    }
    return ensureNotNull($this.wft_1);
  }
  function _get_constraintsField__3m7315_2($this) {
    if ($this.afu_1 == null) {
      $this.afu_1 = $this.w6o(HasPropertyConstraintsConcept_getInstance().cbc_1);
    }
    return ensureNotNull($this.afu_1);
  }
  function TypedVariableDeclarationImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? VariableDeclarationConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(VariableDeclarationConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.vft_1 = null;
    this.wft_1 = null;
    this.xft_1 = null;
    this.yft_1 = null;
    this.zft_1 = null;
    this.afu_1 = null;
  }
  protoOf(TypedVariableDeclarationImpl).jcq = function () {
    return this.v6o(_get_specField__gg1gz6(this));
  };
  protoOf(TypedVariableDeclarationImpl).ucp = function () {
    return this.y6o(_get_relationsField__kxte08_0(this));
  };
  protoOf(TypedVariableDeclarationImpl).b3 = function () {
    return this.n6o(DirectlyNamedConcept_getInstance().ib2_1);
  };
  protoOf(TypedVariableDeclarationImpl).obc = function () {
    return this.n6o(HasQueryLabelsConcept_getInstance().mbc_1);
  };
  protoOf(TypedVariableDeclarationImpl).pbc = function () {
    return this.n6o(HasQueryLabelsConcept_getInstance().nbc_1);
  };
  protoOf(TypedVariableDeclarationImpl).dbc = function () {
    return this.y6o(_get_constraintsField__3m7315_2(this));
  };
  protoOf(TypedVariableDeclarationImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedVariableDeclarationImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.xft_1 == null)) {
      this_0.e(DirectlyNamedConcept_getInstance().ib2_1.e6s_1);
    }
    if (!(this.yft_1 == null)) {
      this_0.e(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1);
    }
    if (!(this.zft_1 == null)) {
      this_0.e(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedVariableDeclarationImpl).v2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedVariableDeclarationImpl.<get-childIds>.<anonymous>' call
    if (!(this.vft_1 == null)) {
      this_0.e(VariableDeclarationConcept_getInstance().hcq_1.u6o_1);
    }
    if (!(this.wft_1 == null)) {
      this_0.e(VariableDeclarationConcept_getInstance().icq_1.x6o_1);
    }
    if (!(this.afu_1 == null)) {
      this_0.e(HasPropertyConstraintsConcept_getInstance().cbc_1.x6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).v2z.call(this));
  };
  protoOf(TypedVariableDeclarationImpl).c3b = function (nodeId) {
    return new TypedVariableDeclarationImpl(this.a6o_1, VariableDeclarationConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedVariableDeclarationImpl).l6o = function (propertyId) {
    return propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1) ? this.xft_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1) ? this.yft_1 : propertyId.equals(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1) ? this.zft_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedVariableDeclarationImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(DirectlyNamedConcept_getInstance().ib2_1.e6s_1)) {
      this.xft_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().mbc_1.e6s_1)) {
      this.yft_1 = value;
    } else if (propertyId.equals(HasQueryLabelsConcept_getInstance().nbc_1.e6s_1)) {
      this.zft_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  protoOf(TypedVariableDeclarationImpl).l38 = function (childId) {
    return childId.equals(VariableDeclarationConcept_getInstance().hcq_1.u6o_1) ? _get_specField__gg1gz6(this) : childId.equals(VariableDeclarationConcept_getInstance().icq_1.x6o_1) ? _get_relationsField__kxte08_0(this) : childId.equals(HasPropertyConstraintsConcept_getInstance().cbc_1.x6o_1) ? _get_constraintsField__3m7315_2(this) : protoOf(TypedBTBNodeImpl).l38.call(this, childId);
  };
  function TypedVariableInitializerImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? VariableInitializerConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(VariableInitializerConcept_getInstance().e6r_1) : nodeId;
    TypedVariableSpecificationImpl.call(this, context, conceptId, nodeId);
  }
  protoOf(TypedVariableInitializerImpl).c3b = function (nodeId) {
    return new TypedVariableInitializerImpl(this.a6o_1, VariableInitializerConcept_getInstance().e6r_1, nodeId);
  };
  function TypedVariableReferenceValueImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? VariableReferenceValueConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(VariableReferenceValueConcept_getInstance().e6r_1) : nodeId;
    TypedVariableInitializerImpl.call(this, context, conceptId, nodeId);
    this.zfu_1 = null;
    this.afv_1 = this.p6o(VariableReferenceValueConcept_getInstance().wcq_1);
  }
  protoOf(TypedVariableReferenceValueImpl).xcq = function () {
    return this.afv_1;
  };
  protoOf(TypedVariableReferenceValueImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedVariableReferenceValueImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.zfu_1 == null)) {
      this_0.e(VariableReferenceValueConcept_getInstance().wcq_1.q6o_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedVariableInitializerImpl).y2z.call(this));
  };
  protoOf(TypedVariableReferenceValueImpl).c3b = function (nodeId) {
    return new TypedVariableReferenceValueImpl(this.a6o_1, VariableReferenceValueConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedVariableReferenceValueImpl).l6o = function (propertyId) {
    return propertyId.equals(VariableReferenceValueConcept_getInstance().wcq_1.q6o_1) ? this.zfu_1 : protoOf(TypedVariableInitializerImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedVariableReferenceValueImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(VariableReferenceValueConcept_getInstance().wcq_1.q6o_1)) {
      this.zfu_1 = value;
    } else {
      protoOf(TypedVariableInitializerImpl).m6o.call(this, propertyId, value);
    }
  };
  function TypedVariableSpecificationImpl(context, conceptId, nodeId) {
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
  }
  function TypedXRefContainerImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? XRefContainerConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(XRefContainerConcept_getInstance().e6r_1) : nodeId;
    TypedBTBNodeImpl.call(this, context, conceptId, nodeId);
    this.nfv_1 = null;
  }
  protoOf(TypedXRefContainerImpl).kcr = function () {
    return this.n6o(XRefContainerConcept_getInstance().jcr_1);
  };
  protoOf(TypedXRefContainerImpl).y2z = function () {
    // Inline function 'kotlin.collections.buildSet' call
    // Inline function 'kotlin.collections.buildSetInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.impl.TypedXRefContainerImpl.<get-propertyIds>.<anonymous>' call
    if (!(this.nfv_1 == null)) {
      this_0.e(XRefContainerConcept_getInstance().jcr_1.e6s_1);
    }
    var tmp$ret$2 = this_0.e4();
    return plus_8(tmp$ret$2, protoOf(TypedBTBNodeImpl).y2z.call(this));
  };
  protoOf(TypedXRefContainerImpl).c3b = function (nodeId) {
    return new TypedXRefContainerImpl(this.a6o_1, XRefContainerConcept_getInstance().e6r_1, nodeId);
  };
  protoOf(TypedXRefContainerImpl).l6o = function (propertyId) {
    return propertyId.equals(XRefContainerConcept_getInstance().jcr_1.e6s_1) ? this.nfv_1 : protoOf(TypedBTBNodeImpl).l6o.call(this, propertyId);
  };
  protoOf(TypedXRefContainerImpl).m6o = function (propertyId, value) {
    if (propertyId.equals(XRefContainerConcept_getInstance().jcr_1.e6s_1)) {
      this.nfv_1 = value;
    } else {
      protoOf(TypedBTBNodeImpl).m6o.call(this, propertyId, value);
    }
  };
  function UnionClassImpl(context, node) {
    node = node === VOID ? new Node_0(UnionClassConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.rfv_1 = this.j6n(UnionClassConcept_getInstance().rco_1);
  }
  protoOf(UnionClassImpl).tco = function () {
    return this.rfv_1;
  };
  function UrlKnowledgeSourceReferenceImpl(context, node) {
    node = node === VOID ? new Node_0(UrlKnowledgeSourceReferenceConcept_getInstance().e6r_1) : node;
    KnowledgeSourceReferenceImpl.call(this, context, node);
    this.vfv_1 = this.x6m(UrlKnowledgeSourceReferenceConcept_getInstance().ecp_1);
  }
  protoOf(UrlKnowledgeSourceReferenceImpl).jbu = function () {
    return this.vfv_1;
  };
  function ValueWithRelationsImpl(context, node) {
    node = node === VOID ? new Node_0(ValueWithRelationsConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.zfv_1 = this.e6n(ValueWithRelationsConcept_getInstance().qcp_1);
    this.afw_1 = this.i6n(ValueWithRelationsConcept_getInstance().rcp_1);
  }
  protoOf(ValueWithRelationsImpl).y = function () {
    return this.zfv_1;
  };
  protoOf(ValueWithRelationsImpl).ucp = function () {
    return this.afw_1;
  };
  function VariableDeclarationImpl(context, node) {
    node = node === VOID ? new Node_0(VariableDeclarationConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.efw_1 = this.f6n(VariableDeclarationConcept_getInstance().fcq_1);
    this.ffw_1 = this.i6n(VariableDeclarationConcept_getInstance().gcq_1);
    this.gfw_1 = this.x6m(DirectlyNamedConcept_getInstance().hb2_1);
    this.hfw_1 = this.c6n(HasQueryLabelsConcept_getInstance().kbc_1);
    this.ifw_1 = this.c6n(HasQueryLabelsConcept_getInstance().lbc_1);
    this.jfw_1 = this.j6n(HasPropertyConstraintsConcept_getInstance().bbc_1);
  }
  protoOf(VariableDeclarationImpl).jcq = function () {
    return this.efw_1;
  };
  protoOf(VariableDeclarationImpl).ucp = function () {
    return this.ffw_1;
  };
  protoOf(VariableDeclarationImpl).b3 = function () {
    return this.gfw_1;
  };
  protoOf(VariableDeclarationImpl).obc = function () {
    return this.hfw_1;
  };
  protoOf(VariableDeclarationImpl).pbc = function () {
    return this.ifw_1;
  };
  protoOf(VariableDeclarationImpl).dbc = function () {
    return this.jfw_1;
  };
  function VariableInitializerImpl(context, node) {
    node = node === VOID ? new Node_0(VariableInitializerConcept_getInstance().e6r_1) : node;
    VariableSpecificationImpl.call(this, context, node);
  }
  function VariableReferenceValueImpl(context, node) {
    node = node === VOID ? new Node_0(VariableReferenceValueConcept_getInstance().e6r_1) : node;
    VariableInitializerImpl.call(this, context, node);
    this.nfw_1 = context.j6p(VariableReferenceValueConcept_getInstance().vcq_1, this);
  }
  protoOf(VariableReferenceValueImpl).xcq = function () {
    return this.nfw_1;
  };
  function VariableSpecificationImpl(context, node) {
    BTBNodeImpl.call(this, context, node);
  }
  function XRefContainerImpl(context, node) {
    node = node === VOID ? new Node_0(XRefContainerConcept_getInstance().e6r_1) : node;
    BTBNodeImpl.call(this, context, node);
    this.rfw_1 = this.x6m(XRefContainerConcept_getInstance().icr_1);
  }
  protoOf(XRefContainerImpl).kcr = function () {
    return this.rfw_1;
  };
  function LinkStubImpl$_init_$ref_6cvkbn() {
    var l = function (p0, p1) {
      return new LinkStubImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function LinkStubConcept$_init_$lambda_hdvymj(context, nodeId) {
    return new TypedLinkStubImpl(context, VOID, nodeId);
  }
  function LinkStubConcept() {
    LinkStubConcept_instance = this;
    var tmp = LinkStubImpl$_init_$ref_6cvkbn();
    OtConceptDescriptor.call(this, 'LinkStub', VOID, tmp, LinkStubConcept$_init_$lambda_hdvymj, Companion_instance_95.z6p([AbstractLinkConcept_getInstance(), ExternallyNamedConcept_getInstance()]));
  }
  var LinkStubConcept_instance;
  function LinkStubConcept_getInstance() {
    if (LinkStubConcept_instance == null)
      new LinkStubConcept();
    return LinkStubConcept_instance;
  }
  function NotionStubImpl$_init_$ref_de8afy() {
    var l = function (p0, p1) {
      return new NotionStubImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function NotionStubConcept$_init_$lambda_8gh33u(context, nodeId) {
    return new TypedNotionStubImpl(context, VOID, nodeId);
  }
  function NotionStubConcept() {
    NotionStubConcept_instance = this;
    var tmp = NotionStubImpl$_init_$ref_de8afy();
    OtConceptDescriptor.call(this, 'NotionStub', VOID, tmp, NotionStubConcept$_init_$lambda_8gh33u, Companion_instance_95.z6p([AbstractNotionConcept_getInstance(), DirectlyNamedConcept_getInstance()]));
  }
  var NotionStubConcept_instance;
  function NotionStubConcept_getInstance() {
    if (NotionStubConcept_instance == null)
      new NotionStubConcept();
    return NotionStubConcept_instance;
  }
  function PropertyStubImpl$_init_$ref_arkxia() {
    var l = function (p0, p1) {
      return new PropertyStubImpl(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function PropertyStubConcept$_init_$lambda_2eggai(context, nodeId) {
    return new TypedPropertyStubImpl(context, VOID, nodeId);
  }
  function PropertyStubConcept() {
    PropertyStubConcept_instance = this;
    var tmp = PropertyStubImpl$_init_$ref_arkxia();
    OtConceptDescriptor.call(this, 'PropertyStub', VOID, tmp, PropertyStubConcept$_init_$lambda_2eggai, Companion_instance_95.z6p([AbstractPropertyConcept_getInstance(), ExternallyNamedConcept_getInstance()]));
  }
  var PropertyStubConcept_instance;
  function PropertyStubConcept_getInstance() {
    if (PropertyStubConcept_instance == null)
      new PropertyStubConcept();
    return PropertyStubConcept_instance;
  }
  function LinkStubImpl(context, node) {
    node = node === VOID ? new Node_0(LinkStubConcept_getInstance().e6r_1) : node;
    AbstractLinkImpl.call(this, context, node);
    this.wfw_1 = get_forQueries(new ValueProperty(''));
    this.xfw_1 = get_specializes.call(this);
  }
  protoOf(LinkStubImpl).b3 = function () {
    return this.wfw_1;
  };
  protoOf(LinkStubImpl).jat = function () {
    return this.xfw_1;
  };
  function NotionStubImpl(context, node) {
    node = node === VOID ? new Node_0(NotionStubConcept_getInstance().e6r_1) : node;
    AbstractNotionImpl.call(this, context, node);
    this.cfx_1 = get_forQueries(new ValueProperty(''));
  }
  protoOf(NotionStubImpl).b3 = function () {
    return this.cfx_1;
  };
  function PropertyStubImpl(context, node) {
    node = node === VOID ? new Node_0(PropertyStubConcept_getInstance().e6r_1) : node;
    AbstractPropertyImpl.call(this, context, node);
    this.gfx_1 = get_forQueries(new ValueProperty(null));
    this.hfx_1 = get_forQueries(new ValueProperty(''));
  }
  protoOf(PropertyStubImpl).zb3 = function () {
    return this.gfx_1;
  };
  protoOf(PropertyStubImpl).b3 = function () {
    return this.hfx_1;
  };
  function TypedLinkStubImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? LinkStubConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LinkStubConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractLinkImpl.call(this, context, conceptId, nodeId);
    this.wfx_1 = new DomainNodeInMemoryProperty('');
    this.xfx_1 = get_specializes.call(this);
  }
  protoOf(TypedLinkStubImpl).b3 = function () {
    return this.wfx_1;
  };
  protoOf(TypedLinkStubImpl).jat = function () {
    return this.xfx_1;
  };
  protoOf(TypedLinkStubImpl).c3b = function (nodeId) {
    return new TypedLinkStubImpl(this.a6o_1, LinkStubConcept_getInstance().e6r_1, nodeId);
  };
  function TypedNotionStubImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? NotionStubConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NotionStubConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractNotionImpl.call(this, context, conceptId, nodeId);
    this.lfy_1 = new DomainNodeInMemoryProperty('');
  }
  protoOf(TypedNotionStubImpl).b3 = function () {
    return this.lfy_1;
  };
  protoOf(TypedNotionStubImpl).c3b = function (nodeId) {
    return new TypedNotionStubImpl(this.a6o_1, NotionStubConcept_getInstance().e6r_1, nodeId);
  };
  function TypedPropertyStubImpl(context, conceptId, nodeId) {
    conceptId = conceptId === VOID ? PropertyStubConcept_getInstance().e6r_1 : conceptId;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(PropertyStubConcept_getInstance().e6r_1) : nodeId;
    TypedAbstractPropertyImpl.call(this, context, conceptId, nodeId);
    this.yfy_1 = new DomainNodeInMemoryProperty(null);
    this.zfy_1 = new DomainNodeInMemoryProperty('');
  }
  protoOf(TypedPropertyStubImpl).zb3 = function () {
    return this.yfy_1;
  };
  protoOf(TypedPropertyStubImpl).b3 = function () {
    return this.zfy_1;
  };
  protoOf(TypedPropertyStubImpl).c3b = function (nodeId) {
    return new TypedPropertyStubImpl(this.a6o_1, PropertyStubConcept_getInstance().e6r_1, nodeId);
  };
  function Fact_1() {
  }
  function FactSet_1() {
  }
  function NewFact() {
  }
  function Context_1() {
  }
  function Category_1() {
  }
  function $runSuspendCOROUTINE$0_2(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ifz_1 = _this__u8e3s4;
    this.jfz_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$0_2).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 9;
            var tmp_0 = this;
            tmp_0.kfz_1 = this.jfz_1;
            this.lfz_1 = this.kfz_1;
            var tmp_1 = this;
            tmp_1.mfz_1 = this.lfz_1.n51(this.ifz_1.og0_1.sau());
            this.nfz_1 = this.mfz_1;
            var tmp_2 = this;
            tmp_2.ofz_1 = this.nfz_1;
            var tmp_3 = this;
            tmp_3.pfz_1 = ArrayList_init_$Create$();
            this.qfz_1 = this.ofz_1;
            this.rfz_1 = this.pfz_1;
            var tmp_4 = this;
            tmp_4.sfz_1 = this.qfz_1;
            this.tfz_1 = this.sfz_1;
            this.ufz_1 = this.tfz_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.ufz_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.vfz_1 = this.ufz_1.m();
            var tmp_5 = this;
            tmp_5.wfz_1 = this.vfz_1;
            this.xfz_1 = this.wfz_1;
            var tmp_6 = this;
            tmp_6.yfz_1 = this.xfz_1;
            this.zfz_1 = this.yfz_1;
            this.y9_1 = 2;
            suspendResult = this.lfz_1.m51(this.zfz_1.ub6(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.ag0_1 = suspendResult;
            if (this.ag0_1 == null)
              null;
            else {
              var it = this.ag0_1;
              this.rfz_1.e(it);
            }

            this.y9_1 = 1;
            continue $sm;
          case 3:
            this.bg0_1 = this.rfz_1;
            var tmp_7 = this;
            var tmp0 = this.bg0_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              var list = this.lfz_1.n51(element.sau());
              addAll_1(destination, list);
            }

            tmp_7.cg0_1 = destination;
            this.dg0_1 = this.cg0_1;
            var tmp_8 = this;
            tmp_8.eg0_1 = this.dg0_1;
            var tmp_9 = this;
            tmp_9.fg0_1 = ArrayList_init_$Create$();
            this.gg0_1 = this.eg0_1;
            this.hg0_1 = this.fg0_1;
            this.ig0_1 = this.gg0_1.k();
            this.y9_1 = 4;
            continue $sm;
          case 4:
            if (!this.ig0_1.l()) {
              this.y9_1 = 8;
              continue $sm;
            }

            this.jg0_1 = this.ig0_1.m();
            var tmp_10 = this;
            tmp_10.kg0_1 = this.jg0_1;
            this.lg0_1 = this.kg0_1;
            var tmp_11 = this;
            var tmp0_safe_receiver = this.lfz_1.n51(this.lg0_1.lay());
            tmp_11.mg0_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lay();
            if (this.mg0_1 == null) {
              this.ng0_1 = null;
              this.y9_1 = 6;
              continue $sm;
            } else {
              this.y9_1 = 5;
              suspendResult = this.lfz_1.m51(this.mg0_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 5:
            this.ng0_1 = suspendResult;
            this.y9_1 = 6;
            continue $sm;
          case 6:
            var ARGUMENT = this.ng0_1;
            if (ARGUMENT === this.ifz_1.pg0_1) {
              this.hg0_1.e(this.jg0_1);
              this.y9_1 = 7;
              continue $sm;
            } else {
              this.y9_1 = 7;
              continue $sm;
            }

          case 7:
            this.y9_1 = 4;
            continue $sm;
          case 8:
            var tmp0_0 = this.hg0_1;
            var destination_0 = ArrayList_init_$Create$();
            var _iterator__ex2g4s_0 = tmp0_0.k();
            while (_iterator__ex2g4s_0.l()) {
              var element_0 = _iterator__ex2g4s_0.m();
              var tmp0_safe_receiver_0 = this.lfz_1.n51(element_0.tby());
              if (tmp0_safe_receiver_0 == null)
                null;
              else {
                destination_0.e(tmp0_safe_receiver_0);
              }
            }

            return destination_0;
          case 9:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 9) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function BTBDocument$librariesForElement$$inlined$suspendingQuery$1(this$0, $element) {
    this.og0_1 = this$0;
    this.pg0_1 = $element;
  }
  protoOf(BTBDocument$librariesForElement$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$0_2(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(BTBDocument$librariesForElement$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function BTBDocument_1() {
  }
  function Companion_185() {
    Companion_instance_185 = this;
    this.ubf_1 = Companion_getInstance_208().kc6_1;
  }
  var Companion_instance_185;
  function Companion_getInstance_185() {
    if (Companion_instance_185 == null)
      new Companion_185();
    return Companion_instance_185;
  }
  function LibraryProcessSpecification_1() {
  }
  function HasVariables() {
  }
  function Companion_186() {
    Companion_instance_186 = this;
    this.qg0_1 = GeneratedBioKbStuff_instance;
  }
  var Companion_instance_186;
  function Companion_getInstance_186() {
    if (Companion_instance_186 == null)
      new Companion_186();
    return Companion_instance_186;
  }
  function Precondition() {
  }
  function AbstractProcessSpecification() {
  }
  function FactExpression() {
  }
  function FactExpressionPlaceholder() {
  }
  function HasFactExpression() {
  }
  function MultilineText() {
  }
  function TextLine() {
  }
  function ConstantPrecondition_0() {
  }
  function Companion_187() {
    Companion_instance_187 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'relation';
    tmp.eb6_1 = new RefTag(getKClass(FactPrecondition_1), getKClass(ProcessRelationDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_187;
  function Companion_getInstance_187() {
    if (Companion_instance_187 == null)
      new Companion_187();
    return Companion_instance_187;
  }
  function FactPrecondition_1() {
  }
  function Companion_188() {
    Companion_instance_188 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.localRefTag' call
    tmp.hb6_1 = new RefTag(getKClass(FactReference_1), getKClass(Fact_1), getKClass(LocalReferenceContent), 'fact');
  }
  var Companion_instance_188;
  function Companion_getInstance_188() {
    if (Companion_instance_188 == null)
      new Companion_188();
    return Companion_instance_188;
  }
  function FactReference_1() {
  }
  function Companion_189() {
    Companion_instance_189 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'modifierReference';
    tmp.kbl_1 = new RefTag(getKClass(ModifierFactExpression_0), getKClass(ModifierDeclaration), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_189;
  function Companion_getInstance_189() {
    if (Companion_instance_189 == null)
      new Companion_189();
    return Companion_instance_189;
  }
  function ModifierFactExpression_0() {
  }
  function Companion_190() {
    Companion_instance_190 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.localRefTag' call
    tmp.ybn_1 = new RefTag(getKClass(NewFactReference_0), getKClass(NewFact), getKClass(LocalReferenceContent), 'newFact');
  }
  var Companion_instance_190;
  function Companion_getInstance_190() {
    if (Companion_instance_190 == null)
      new Companion_190();
    return Companion_instance_190;
  }
  function NewFactReference_0() {
  }
  function QueryLabelsFactExpressionContainer_1() {
  }
  function Companion_191() {
    Companion_instance_191 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'relationInFact';
    tmp.ucl_1 = new RefTag(getKClass(RelationFactExpression_1), getKClass(ProcessRelationDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_191;
  function Companion_getInstance_191() {
    if (Companion_instance_191 == null)
      new Companion_191();
    return Companion_instance_191;
  }
  function RelationFactExpression_1() {
  }
  var When_ALWAYS_instance;
  var When_NEVER_instance;
  function values_9() {
    return [When_ALWAYS_getInstance(), When_NEVER_getInstance()];
  }
  var When_entriesInitialized;
  function When_initEntries() {
    if (When_entriesInitialized)
      return Unit_instance;
    When_entriesInitialized = true;
    When_ALWAYS_instance = new When('ALWAYS', 0);
    When_NEVER_instance = new When('NEVER', 1);
  }
  function When(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function When_ALWAYS_getInstance() {
    When_initEntries();
    return When_ALWAYS_instance;
  }
  function When_NEVER_getInstance() {
    When_initEntries();
    return When_NEVER_instance;
  }
  function BTBNode() {
  }
  function get_searchableNodeType(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, ProcessDeclaration_1)) {
      tmp = 'process';
    } else {
      if (isInterface(_this__u8e3s4, ProcessKind_1)) {
        tmp = 'process kind';
      } else {
        if (isInterface(_this__u8e3s4, ProcessProperty_1)) {
          tmp = 'process property';
        } else {
          if (isInterface(_this__u8e3s4, PropertyDeclaration_1)) {
            tmp = 'process property';
          } else {
            if (isInterface(_this__u8e3s4, AbstractProperty)) {
              tmp = 'process property';
            } else {
              if (isInterface(_this__u8e3s4, LinkDeclaration_1)) {
                tmp = 'process link';
              } else {
                if (isInterface(_this__u8e3s4, ObjectPropertyDeclaration_1)) {
                  tmp = 'property';
                } else {
                  if (isInterface(_this__u8e3s4, AbstractLink)) {
                    tmp = 'process link';
                  } else {
                    if (isInterface(_this__u8e3s4, VariableDeclaration_1)) {
                      tmp = 'variable';
                    } else {
                      if (isInterface(_this__u8e3s4, ProcessRelationDeclaration_1)) {
                        tmp = 'fact relation';
                      } else {
                        if (isInterface(_this__u8e3s4, InstanceRelationDeclaration)) {
                          tmp = 'instance relation';
                        } else {
                          if (isInterface(_this__u8e3s4, Fact_1)) {
                            tmp = 'fact';
                          } else {
                            if (isInterface(_this__u8e3s4, FieldDeclaration_1)) {
                              tmp = 'extension field';
                            } else {
                              if (isInterface(_this__u8e3s4, FunctionDeclaration_1)) {
                                tmp = 'function';
                              } else {
                                if (isInterface(_this__u8e3s4, OntologyImportRoot_1)) {
                                  tmp = 'ontology import root';
                                } else {
                                  if (isInterface(_this__u8e3s4, MeasurementUnit_1)) {
                                    tmp = 'measurement unit';
                                  } else {
                                    if (isInterface(_this__u8e3s4, EnumerationConstant_1)) {
                                      tmp = 'enumeration constant';
                                    } else {
                                      if (isInterface(_this__u8e3s4, AbstractNotion)) {
                                        tmp = 'notion';
                                      } else {
                                        if (isInterface(_this__u8e3s4, OntologyElement_1)) {
                                          tmp = '';
                                        } else {
                                          if (isInterface(_this__u8e3s4, PublishedWork)) {
                                            tmp = 'published work';
                                          } else {
                                            tmp = ensureNotNull(getKClassFromExpression(_this__u8e3s4).lb());
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  function BTBNodePersister(wrapperContext, nodeFactory) {
    DomainNodePersister.call(this, wrapperContext, nodeFactory);
    this.ug0_1 = wrapperContext;
    this.vg0_1 = new NullPersisterForNullable();
    this.wg0_1 = new BtbOtNodePersister(nodeFactory);
  }
  protoOf(BTBNodePersister).n2q = function () {
    return this.vg0_1;
  };
  protoOf(BTBNodePersister).xg0 = function (value) {
    var tmp = toOtNode(value);
    var tmp_0;
    if (isInterface(value, ExternallyNamed)) {
      tmp_0 = execute_0(value.b3());
    } else {
      tmp_0 = null;
    }
    var nodeWithName = new NodeWithName(tmp, tmp_0);
    return this.wg0_1.ag1(nodeWithName);
  };
  protoOf(BTBNodePersister).o2q = function (value) {
    return this.xg0((!(value == null) ? isInterface(value, BTBNode) : false) ? value : THROW_CCE());
  };
  protoOf(BTBNodePersister).s6k = function (value) {
    return this.xg0(isInterface(value, BTBNode) ? value : THROW_CCE());
  };
  protoOf(BTBNodePersister).p2q = function (value) {
    var nodeWithName = this.wg0_1.p2q(value);
    var tmp = toDomainNode(nodeWithName.bg1_1, this.ug0_1);
    var btbNode = isInterface(tmp, BTBNode) ? tmp : THROW_CCE();
    if (!(nodeWithName.cg1_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!isInterface(btbNode, ExternallyNamed)) {
        // Inline function 'kotlin.require.<anonymous>' call
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      btbNode.b3().t2c(nodeWithName.cg1_1);
    }
    return btbNode;
  };
  function BtbOtNodePersister$deserializeNonNull$lambda(this$0) {
    return function ($this$readArray) {
      var node = this$0.zg0_1.s37(ensureNotNull($this$readArray.t2v()));
      var name = $this$readArray.s2v();
      return new NodeWithName(node, name);
    };
  }
  function BtbOtNodePersister(nodeFactory) {
    this.yg0_1 = new NullPersisterForNullable();
    this.zg0_1 = new Json2NodeConverter(new NodeIdPersistenceContext(), nodeFactory);
  }
  protoOf(BtbOtNodePersister).n2q = function () {
    return this.yg0_1;
  };
  protoOf(BtbOtNodePersister).ag1 = function (value) {
    var json = new JsonArray();
    json.s2t((new Node2JsonConverter(new NodeIdPersistenceContext())).x38(value.bg1_1));
    if (!(value.cg1_1 == null)) {
      json.h2u(value.cg1_1);
    }
    return json.toString();
  };
  protoOf(BtbOtNodePersister).o2q = function (value) {
    return this.ag1(value instanceof NodeWithName ? value : THROW_CCE());
  };
  protoOf(BtbOtNodePersister).p2q = function (value) {
    var tmp = CommonJsonStreamIterSupport_instance.a2y(value);
    var jsonReader = isInterface(tmp, JsonArrayReader) ? tmp : THROW_CCE();
    return jsonReader.r2v(BtbOtNodePersister$deserializeNonNull$lambda(this));
  };
  function NodeWithName(node, name) {
    this.bg1_1 = node;
    this.cg1_1 = name;
  }
  protoOf(NodeWithName).toString = function () {
    return 'NodeWithName(node=' + this.bg1_1.toString() + ', name=' + this.cg1_1 + ')';
  };
  protoOf(NodeWithName).hashCode = function () {
    var result = hashCode(this.bg1_1);
    result = imul(result, 31) + (this.cg1_1 == null ? 0 : getStringHashCode(this.cg1_1)) | 0;
    return result;
  };
  protoOf(NodeWithName).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NodeWithName))
      return false;
    var tmp0_other_with_cast = other instanceof NodeWithName ? other : THROW_CCE();
    if (!equals(this.bg1_1, tmp0_other_with_cast.bg1_1))
      return false;
    if (!(this.cg1_1 == tmp0_other_with_cast.cg1_1))
      return false;
    return true;
  };
  function Companion_192() {
    Companion_instance_192 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'processPropertyInValue';
    tmp.nca_1 = new RefTag(getKClass(ProcessPropertyValue_1), getKClass(ProcessProperty_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_192;
  function Companion_getInstance_192() {
    if (Companion_instance_192 == null)
      new Companion_192();
    return Companion_instance_192;
  }
  function ProcessPropertyValue_1() {
  }
  function AbstractBindingEntry() {
  }
  function AbstractBindingDeclaration() {
  }
  function BindingValuePlaceholder_1() {
  }
  function AbstractBindingValue() {
  }
  function EmptyBindingEntry_1() {
  }
  function ClassExpression() {
  }
  function ClassExpressionType_1() {
  }
  function ClassDeclaration() {
  }
  function UnionClass_1() {
  }
  function ClassExpressionPlaceholder_1() {
  }
  function AnonymousClass$getClassDeclaration$$inlined$suspendingQuery$1(this$0) {
    this.dg1_1 = this$0;
  }
  protoOf(AnonymousClass$getClassDeclaration$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.biokb.lang.model.AnonymousClass.<get-getClassDeclaration>.<anonymous>' call
    return this.dg1_1;
  };
  protoOf(AnonymousClass$getClassDeclaration$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function AnonymousClass() {
  }
  function CustomEditor() {
  }
  function CustomCell() {
  }
  function CardinalityCustomCell_1() {
  }
  function ConstantCustomCell_1() {
  }
  function DeclarationNameCustomCell_1() {
  }
  function KindCustomCell_1() {
  }
  function Companion_193() {
    Companion_instance_193 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.cbh_1 = new RefTag(getKClass(LinkCustomCell_1), getKClass(AbstractLink), getKClass(QualifiedReferenceContent), 'link');
  }
  var Companion_instance_193;
  function Companion_getInstance_193() {
    if (Companion_instance_193 == null)
      new Companion_193();
    return Companion_instance_193;
  }
  function LinkCustomCell_1() {
  }
  function Companion_194() {
    Companion_instance_194 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'processProperty';
    tmp.bc9_1 = new RefTag(getKClass(ProcessPropertyCustomCell_1), getKClass(ProcessProperty_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_194;
  function Companion_getInstance_194() {
    if (Companion_instance_194 == null)
      new Companion_194();
    return Companion_instance_194;
  }
  function ProcessPropertyCustomCell_1() {
  }
  function PropertiesCustomCell_1() {
  }
  function Companion_195() {
    Companion_instance_195 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'property';
    tmp.rcd_1 = new RefTag(getKClass(PropertyCustomCell_1), getKClass(AbstractProperty), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_195;
  function Companion_getInstance_195() {
    if (Companion_instance_195 == null)
      new Companion_195();
    return Companion_instance_195;
  }
  function PropertyCustomCell_1() {
  }
  function ReturnTypeCustomCell_1() {
  }
  function DocumentNode_0() {
  }
  function FieldDeclaration_1() {
  }
  function ExtensionDeclaration_1() {
  }
  function ExtensionLibrary_1() {
  }
  function Companion_196() {
    Companion_instance_196 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.ab4_1 = new RefTag(getKClass(BTBNode), getKClass(FieldDeclaration_1), getKClass(QualifiedReferenceContent), 'field');
  }
  var Companion_instance_196;
  function Companion_getInstance_196() {
    if (Companion_instance_196 == null)
      new Companion_196();
    return Companion_instance_196;
  }
  function ExtensionFieldReference_1() {
  }
  function ExternallyNamed() {
  }
  function FunctionDeclaration_1() {
  }
  function Companion_197() {
    Companion_instance_197 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'function';
    tmp.zb9_1 = new RefTag(getKClass(BTBNode), getKClass(FunctionDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_197;
  function Companion_getInstance_197() {
    if (Companion_instance_197 == null)
      new Companion_197();
    return Companion_instance_197;
  }
  function FunctionTerm_1() {
  }
  function FunctionLibrary_1() {
  }
  function Cardinality_1() {
  }
  var CardinalitySpecificator_ALL_OF_instance;
  var CardinalitySpecificator_SOME_OF_instance;
  var CardinalitySpecificator_AT_LEAST_ONE_OF_instance;
  var CardinalitySpecificator_EXACTLY_ONE_OF_instance;
  function values_10() {
    return [CardinalitySpecificator_ALL_OF_getInstance(), CardinalitySpecificator_SOME_OF_getInstance(), CardinalitySpecificator_AT_LEAST_ONE_OF_getInstance(), CardinalitySpecificator_EXACTLY_ONE_OF_getInstance()];
  }
  var CardinalitySpecificator_entriesInitialized;
  function CardinalitySpecificator_initEntries() {
    if (CardinalitySpecificator_entriesInitialized)
      return Unit_instance;
    CardinalitySpecificator_entriesInitialized = true;
    CardinalitySpecificator_ALL_OF_instance = new CardinalitySpecificator('ALL_OF', 0);
    CardinalitySpecificator_SOME_OF_instance = new CardinalitySpecificator('SOME_OF', 1);
    CardinalitySpecificator_AT_LEAST_ONE_OF_instance = new CardinalitySpecificator('AT_LEAST_ONE_OF', 2);
    CardinalitySpecificator_EXACTLY_ONE_OF_instance = new CardinalitySpecificator('EXACTLY_ONE_OF', 3);
  }
  function CardinalitySpecificator(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CardinalityBoundConstant_1() {
  }
  function CardinalityBoundPlaceholder_1() {
  }
  function CardinalityBound() {
  }
  function CardinalityBoundN_1() {
  }
  function CardinalitySpecificator_ALL_OF_getInstance() {
    CardinalitySpecificator_initEntries();
    return CardinalitySpecificator_ALL_OF_instance;
  }
  function CardinalitySpecificator_SOME_OF_getInstance() {
    CardinalitySpecificator_initEntries();
    return CardinalitySpecificator_SOME_OF_instance;
  }
  function CardinalitySpecificator_AT_LEAST_ONE_OF_getInstance() {
    CardinalitySpecificator_initEntries();
    return CardinalitySpecificator_AT_LEAST_ONE_OF_instance;
  }
  function CardinalitySpecificator_EXACTLY_ONE_OF_getInstance() {
    CardinalitySpecificator_initEntries();
    return CardinalitySpecificator_EXACTLY_ONE_OF_instance;
  }
  function HasComments() {
  }
  function OntologyImport_1() {
  }
  function OntologyImportRoot_1() {
  }
  function Companion_198() {
    Companion_instance_198 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'ontologyImport';
    tmp.gbz_1 = new RefTag(getKClass(OntologyImportRootReference_1), getKClass(OntologyImportRoot_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_198;
  function Companion_getInstance_198() {
    if (Companion_instance_198 == null)
      new Companion_198();
    return Companion_instance_198;
  }
  function OntologyImportRootReference_1() {
  }
  function Companion_199() {
    Companion_instance_199 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'publishedSource';
    tmp.fch_1 = new RefTag(getKClass(PublishedSourceReference_1), getKClass(PublishedWork), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_199;
  function Companion_getInstance_199() {
    if (Companion_instance_199 == null)
      new Companion_199();
    return Companion_instance_199;
  }
  function PublishedSourceReference_1() {
  }
  function PublishedSourcesLibrary_1() {
  }
  function KnowledgeSourceReference() {
  }
  function PageSpecification() {
  }
  function HasKnowledgeSources() {
  }
  function KnowledgeSourceReferencePlaceholder_1() {
  }
  function LibraryItemPlaceholder_1() {
  }
  function Page_1() {
  }
  function PageRange_1() {
  }
  function PubMedSourceReference_1() {
  }
  function UrlKnowledgeSourceReference_1() {
  }
  function $runSuspendCOROUTINE$1_2(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mg1_1 = _this__u8e3s4;
    this.ng1_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$1_2).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 9;
            var tmp_0 = this;
            tmp_0.og1_1 = this.ng1_1;
            this.pg1_1 = Unit_instance;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.qg1_1 = this.og1_1;
            this.y9_1 = 2;
            suspendResult = this.qg1_1.m51(this.mg1_1.ag2_1.wc2(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.rg1_1 = suspendResult;
            this.sg1_1 = this.rg1_1 == null ? null : this.rg1_1.lay();
            if (this.sg1_1 == null) {
              this.tg1_1 = null;
              this.y9_1 = 4;
              continue $sm;
            } else {
              this.y9_1 = 3;
              suspendResult = this.qg1_1.m51(this.sg1_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.tg1_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.ug1_1 = this.tg1_1;
            if (this.ug1_1 == null) {
              this.pg1_1 = emptyList();
              this.y9_1 = 8;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.vg1_1 = this.ug1_1;
              this.y9_1 = 5;
              continue $sm;
            }

          case 5:
            this.wg1_1 = this.vg1_1;
            var tmp_2 = this;
            var this_0 = this.mg1_1.ag2_1;
            tmp_2.xg1_1 = this.qg1_1.n51(ancestorOrSelf(this_0, getKClass(BTBDocument_1)));
            if (this.xg1_1 == null) {
              this.pg1_1 = emptyList();
              this.y9_1 = 8;
              var tmp_3 = this;
              continue $sm;
            } else {
              this.yg1_1 = this.xg1_1;
              this.y9_1 = 6;
              continue $sm;
            }

          case 6:
            this.zg1_1 = this.yg1_1;
            this.y9_1 = 7;
            suspendResult = this.qg1_1.m51(this.zg1_1.dct(this.wg1_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.pg1_1 = suspendResult;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 8;
            continue $sm;
          case 8:
            return this.pg1_1;
          case 9:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 9) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function Companion_200() {
    Companion_instance_200 = this;
    this.jc2_1 = Companion_getInstance_201().aat_1;
  }
  var Companion_instance_200;
  function Companion_getInstance_200() {
    if (Companion_instance_200 == null)
      new Companion_200();
    return Companion_instance_200;
  }
  function OntologyLinkValue$importedLibraries$$inlined$suspendingQuery$1(this$0) {
    this.ag2_1 = this$0;
  }
  protoOf(OntologyLinkValue$importedLibraries$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$1_2(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyLinkValue$importedLibraries$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyLinkValue_1() {
  }
  function Companion_201() {
    Companion_instance_201 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'abstractLink';
    tmp.aat_1 = new RefTag(getKClass(BTBNode), getKClass(AbstractLink), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_201;
  function Companion_getInstance_201() {
    if (Companion_instance_201 == null)
      new Companion_201();
    return Companion_instance_201;
  }
  function AbstractLink() {
  }
  var LinkTypeSpecificator_INSTANCE_OF_instance;
  var LinkTypeSpecificator_TYPE_OF_instance;
  function values_11() {
    return [LinkTypeSpecificator_INSTANCE_OF_getInstance(), LinkTypeSpecificator_TYPE_OF_getInstance()];
  }
  var LinkTypeSpecificator_entriesInitialized;
  function LinkTypeSpecificator_initEntries() {
    if (LinkTypeSpecificator_entriesInitialized)
      return Unit_instance;
    LinkTypeSpecificator_entriesInitialized = true;
    LinkTypeSpecificator_INSTANCE_OF_instance = new LinkTypeSpecificator('INSTANCE_OF', 0);
    LinkTypeSpecificator_TYPE_OF_instance = new LinkTypeSpecificator('TYPE_OF', 1);
  }
  function LinkTypeSpecificator(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function LinkDeclaration_1() {
  }
  function LinkLibrary_1() {
  }
  function $runSuspendCOROUTINE$2_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jg2_1 = _this__u8e3s4;
    this.kg2_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$2_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.lg2_1 = this.kg2_1;
            this.mg2_1 = this.lg2_1;
            this.y9_1 = 1;
            suspendResult = this.mg2_1.m51(this.jg2_1.ng2_1.mbd(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b3();
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : this.mg2_1.n51(tmp1_safe_receiver);
            return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$4(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wg2_1 = _this__u8e3s4;
    this.xg2_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$4).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.yg2_1 = this.xg2_1;
            this.zg2_1 = this.yg2_1;
            this.y9_1 = 1;
            suspendResult = this.zg2_1.m51(this.wg2_1.ag3_1.mbd(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sba();
            return tmp1_safe_receiver == null ? null : this.zg2_1.n51(tmp1_safe_receiver);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$5_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jg3_1 = _this__u8e3s4;
    this.kg3_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$5_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.lg3_1 = this.kg3_1;
            this.mg3_1 = this.lg3_1;
            this.y9_1 = 1;
            suspendResult = this.mg3_1.m51(this.jg3_1.ug3_1.mbd(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ng3_1 = suspendResult;
            this.og3_1 = this.ng3_1 == null ? null : this.ng3_1.zb3();
            this.pg3_1 = this.og3_1 == null ? null : this.mg3_1.n51(this.og3_1);
            this.qg3_1 = this.pg3_1 == null ? null : this.pg3_1.lay();
            this.rg3_1 = this.qg3_1 == null ? null : this.mg3_1.n51(this.qg3_1);
            this.sg3_1 = this.rg3_1 == null ? null : this.rg3_1.lay();
            if (this.sg3_1 == null) {
              this.tg3_1 = null;
              this.y9_1 = 3;
              continue $sm;
            } else {
              this.y9_1 = 2;
              suspendResult = this.mg3_1.m51(this.sg3_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.tg3_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.tg3_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function Companion_202() {
    Companion_instance_202 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'importedLinkReference';
    tmp.zbc_1 = new RefTag(getKClass(ImportedLink_1), getKClass(LinkDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_202;
  function Companion_getInstance_202() {
    if (Companion_instance_202 == null)
      new Companion_202();
    return Companion_instance_202;
  }
  function ImportedLink$name$$inlined$suspendingQuery$1(this$0) {
    this.ng2_1 = this$0;
  }
  protoOf(ImportedLink$name$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$2_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ImportedLink$name$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ImportedLink$specificator$$inlined$suspendingQuery$1(this$0) {
    this.ag3_1 = this$0;
  }
  protoOf(ImportedLink$specificator$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$4(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ImportedLink$specificator$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ImportedLink$element$$inlined$suspendingQuery$1(this$0) {
    this.ug3_1 = this$0;
  }
  protoOf(ImportedLink$element$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$5_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ImportedLink$element$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ImportedLink_1() {
  }
  function $runSuspendCOROUTINE$7(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dg4_1 = _this__u8e3s4;
    this.eg4_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$7).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.fg4_1 = this.eg4_1;
            this.gg4_1 = this.fg4_1;
            var tmp_1 = this;
            var tmp0_safe_receiver = this.gg4_1.n51(this.dg4_1.jg4_1.pbh());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zb3();
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : this.gg4_1.n51(tmp1_safe_receiver);
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.lay();
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : this.gg4_1.n51(tmp3_safe_receiver);
            tmp_1.hg4_1 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.lay();
            if (this.hg4_1 == null) {
              this.ig4_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.gg4_1.m51(this.hg4_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.ig4_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            return this.ig4_1;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function OntologyLink$name$$inlined$suspendingQuery$1(this$0) {
    this.kg4_1 = this$0;
  }
  protoOf(OntologyLink$name$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.biokb.lang.model.OntologyLink.<get-name>.<anonymous>' call
    var tmp0_safe_receiver = builder.n51(this.kg4_1.pbh());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b3();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : builder.n51(tmp1_safe_receiver);
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  };
  protoOf(OntologyLink$name$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyLink$element$$inlined$suspendingQuery$1(this$0) {
    this.jg4_1 = this$0;
  }
  protoOf(OntologyLink$element$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$7(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyLink$element$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyLink$specificator$$inlined$query$1(this$0) {
    this.lg4_1 = this$0;
  }
  protoOf(OntologyLink$specificator$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.OntologyLink.<get-specificator>.<anonymous>' call
    var tmp0_safe_receiver = builder.n51(this.lg4_1.pbh());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sba();
    return tmp1_safe_receiver == null ? null : builder.n51(tmp1_safe_receiver);
  };
  function OntologyLink_1() {
  }
  function LinkTypeSpecificator_INSTANCE_OF_getInstance() {
    LinkTypeSpecificator_initEntries();
    return LinkTypeSpecificator_INSTANCE_OF_instance;
  }
  function LinkTypeSpecificator_TYPE_OF_getInstance() {
    LinkTypeSpecificator_initEntries();
    return LinkTypeSpecificator_TYPE_OF_instance;
  }
  function ModifierDeclaration() {
  }
  function ModifierContainer() {
  }
  function Companion_203() {
    Companion_instance_203 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.refTag' call
    var name = 'superProperty';
    tmp.ubq_1 = new RefTag(getKClass(ObjectPropertyDeclaration_1), getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent), name);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.references.refTag' call
    var name_0 = 'inverseProperty';
    tmp_0.vbq_1 = new RefTag(getKClass(ObjectPropertyDeclaration_1), getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent), name_0);
  }
  var Companion_instance_203;
  function Companion_getInstance_203() {
    if (Companion_instance_203 == null)
      new Companion_203();
    return Companion_instance_203;
  }
  function ObjectPropertyDeclaration_1() {
  }
  function Companion_204() {
    Companion_instance_204 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'propertyInConstraint';
    tmp.qcd_1 = new RefTag(getKClass(PropertyConstraint_1), getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_204;
  function Companion_getInstance_204() {
    if (Companion_instance_204 == null)
      new Companion_204();
    return Companion_instance_204;
  }
  function PropertyConstraint_1() {
  }
  function PropertyValueRange() {
  }
  function HasPropertyConstraints() {
  }
  function ObjectPropertiesLibrary() {
  }
  var ConstraintOperation_ADDITION_ASSIGNMENT_instance;
  var ConstraintOperation_SUBTRACT_ASSIGNMENT_instance;
  function values_12() {
    return [ConstraintOperation_ADDITION_ASSIGNMENT_getInstance(), ConstraintOperation_SUBTRACT_ASSIGNMENT_getInstance()];
  }
  var ConstraintOperation_entriesInitialized;
  function ConstraintOperation_initEntries() {
    if (ConstraintOperation_entriesInitialized)
      return Unit_instance;
    ConstraintOperation_entriesInitialized = true;
    ConstraintOperation_ADDITION_ASSIGNMENT_instance = new ConstraintOperation('ADDITION_ASSIGNMENT', 0, '+=');
    ConstraintOperation_SUBTRACT_ASSIGNMENT_instance = new ConstraintOperation('SUBTRACT_ASSIGNMENT', 1, '-=');
  }
  function ConstraintOperation(name, ordinal, label) {
    Enum.call(this, name, ordinal);
    this.og4_1 = label;
  }
  protoOf(ConstraintOperation).toString = function () {
    return this.og4_1;
  };
  function MultiplePropertyValueRange_1() {
  }
  function NoValues_1() {
  }
  function SinglePropertyValueRange_1() {
  }
  function TypePlaceholder_1() {
  }
  function ConstraintOperation_ADDITION_ASSIGNMENT_getInstance() {
    ConstraintOperation_initEntries();
    return ConstraintOperation_ADDITION_ASSIGNMENT_instance;
  }
  function ConstraintOperation_SUBTRACT_ASSIGNMENT_getInstance() {
    ConstraintOperation_initEntries();
    return ConstraintOperation_SUBTRACT_ASSIGNMENT_instance;
  }
  function $runSuspendCOROUTINE$8(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xg4_1 = _this__u8e3s4;
    this.yg4_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$8).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            var tmp_0 = this;
            tmp_0.zg4_1 = this.yg4_1;
            this.ag5_1 = this.zg4_1;
            this.bg5_1 = ontologyElementHierarchy();
            this.y9_1 = 1;
            suspendResult = this.ag5_1.m51(getAllNaturalDefinitionElements(this.bg5_1, this.xg4_1.ug5_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.cg5_1 = suspendResult;
            var tmp_1 = this;
            var tmp0 = this.cg5_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              var tmp0_safe_receiver = this.ag5_1.n51(element.ibu());
              if (tmp0_safe_receiver == null)
                null;
              else {
                destination.e(tmp0_safe_receiver);
              }
            }

            tmp_1.dg5_1 = destination;
            var tmp_2 = this;
            tmp_2.eg5_1 = this.dg5_1;
            this.fg5_1 = this.eg5_1;
            var tmp_3 = this;
            tmp_3.gg5_1 = this.fg5_1;
            var tmp_4 = this;
            tmp_4.hg5_1 = ArrayList_init_$Create$();
            this.ig5_1 = this.gg5_1;
            this.jg5_1 = this.hg5_1;
            var tmp_5 = this;
            tmp_5.kg5_1 = this.ig5_1;
            this.lg5_1 = this.kg5_1;
            this.mg5_1 = this.lg5_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.mg5_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.ng5_1 = this.mg5_1.m();
            var tmp_6 = this;
            tmp_6.og5_1 = this.ng5_1;
            this.pg5_1 = this.og5_1;
            var tmp_7 = this;
            tmp_7.qg5_1 = this.pg5_1;
            this.rg5_1 = this.qg5_1;
            this.sg5_1 = this.rg5_1;
            var tmp_8 = this.sg5_1;
            if (isInterface(tmp_8, UnionClass_1)) {
              this.tg5_1 = this.rg5_1;
              this.y9_1 = 4;
              continue $sm;
            } else {
              var tmp_9 = this.sg5_1;
              if (isInterface(tmp_9, OntologyElementReferenceProvider)) {
                this.y9_1 = 3;
                suspendResult = this.ag5_1.m51(this.rg5_1.ud1(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_10 = this;
                noWhenBranchMatchedException();
              }
            }

            break;
          case 3:
            this.tg5_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            var tmp0_safe_receiver_0 = this.tg5_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              this.jg5_1.e(tmp0_safe_receiver_0);
            }

            this.y9_1 = 2;
            continue $sm;
          case 5:
            return this.jg5_1;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function OntologyElement$temporaryUnionClassDefinition$$inlined$query$1(this$0) {
    this.vg5_1 = this$0;
  }
  protoOf(OntologyElement$temporaryUnionClassDefinition$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.OntologyElement.<get-temporaryUnionClassDefinition>.<anonymous>' call
    var tmp = builder.n51(this.vg5_1.mbu());
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, UnionClass_1) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = builder.n51(this.vg5_1.nbu());
      var tmp_1 = tmp1_safe_receiver == null ? null : builder.n51(tmp1_safe_receiver.yay());
      tmp_0 = (!(tmp_1 == null) ? isInterface(tmp_1, UnionClass_1) : false) ? tmp_1 : null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  };
  function OntologyElement$allTaxonElements$$inlined$suspendingQuery$1(this$0) {
    this.ug5_1 = this$0;
  }
  protoOf(OntologyElement$allTaxonElements$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$8(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyElement$allTaxonElements$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyElement_1() {
  }
  function Companion_205() {
    Companion_instance_205 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.rbv_1 = new RefTag(getKClass(OntologyElementReference_1), getKClass(OntologyElement_1), getKClass(QualifiedReferenceContent), 'element');
  }
  var Companion_instance_205;
  function Companion_getInstance_205() {
    if (Companion_instance_205 == null)
      new Companion_205();
    return Companion_instance_205;
  }
  function OntologyElementReference_1() {
  }
  function OntologyIsRelation$getElementReference$$inlined$executeQuery$1(this$0) {
    this.wg5_1 = this$0;
  }
  protoOf(OntologyIsRelation$getElementReference$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.OntologyIsRelation.getElementReference.<anonymous>' call
    var tmp0_safe_receiver = builder.n51(this.wg5_1.fc0());
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lay();
  };
  function OntologyIsRelation_1() {
  }
  function OntologyLibrary_1() {
  }
  function OntologyCardinalityRelation_1() {
  }
  function OntologyElementDefinition_1() {
  }
  function Companion_206() {
    Companion_instance_206 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'ontologyLibrary';
    tmp.tc0_1 = new RefTag(getKClass(BTBNode), getKClass(OntologyLibrary_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_206;
  function Companion_getInstance_206() {
    if (Companion_instance_206 == null)
      new Companion_206();
    return Companion_instance_206;
  }
  function OntologyLibraryReference_1() {
  }
  function QualifiedOntologyElementReference$element$$inlined$executeQuery$1(this$0) {
    this.xg5_1 = this$0;
  }
  protoOf(QualifiedOntologyElementReference$element$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.QualifiedOntologyElementReference.<get-element>.<anonymous>' call
    var tmp0_safe_receiver = builder.n51(this.xg5_1.mcj());
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lay();
  };
  function QualifiedOntologyElementReference_1() {
  }
  function OntologyElementType_1() {
  }
  function $runSuspendCOROUTINE$9(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gg6_1 = _this__u8e3s4;
    this.hg6_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$9).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.ig6_1 = this.hg6_1;
            this.jg6_1 = this.ig6_1;
            this.kg6_1 = this.gg6_1.mg6_1.lay();
            if (this.kg6_1 == null) {
              this.lg6_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.jg6_1.m51(this.kg6_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.lg6_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            return this.lg6_1;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function OntologyElementReferenceProvider$getClassDeclaration$$inlined$suspendingQuery$1(this$0) {
    this.mg6_1 = this$0;
  }
  protoOf(OntologyElementReferenceProvider$getClassDeclaration$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$9(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyElementReferenceProvider$getClassDeclaration$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyElementReferenceProvider() {
  }
  function OntologyElementSynonym_1() {
  }
  function XRefContainer() {
  }
  function AbstractOntologyRelation() {
  }
  function Companion_207() {
    Companion_instance_207 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.localRefTag' call
    var name = 'localElement';
    tmp.tbi_1 = new RefTag(getKClass(LocalOntologyElementReference_1), getKClass(OntologyElement_1), getKClass(LocalReferenceContent), name);
  }
  var Companion_instance_207;
  function Companion_getInstance_207() {
    if (Companion_instance_207 == null)
      new Companion_207();
    return Companion_instance_207;
  }
  function LocalOntologyElementReference_1() {
  }
  function $runSuspendCOROUTINE$10_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vg6_1 = _this__u8e3s4;
    this.wg6_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$10_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            var tmp_0 = this;
            tmp_0.xg6_1 = this.wg6_1;
            this.yg6_1 = this.xg6_1;
            var tmp_1 = this;
            tmp_1.zg6_1 = this.yg6_1.n51(this.vg6_1.xg7_1.pas());
            this.ag7_1 = this.zg6_1;
            var tmp_2 = this;
            tmp_2.bg7_1 = this.ag7_1;
            var tmp_3 = this;
            tmp_3.cg7_1 = ArrayList_init_$Create$();
            this.dg7_1 = this.bg7_1;
            this.eg7_1 = this.cg7_1;
            this.fg7_1 = this.dg7_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.fg7_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.gg7_1 = this.fg7_1.m();
            var tmp_4 = this;
            tmp_4.hg7_1 = this.gg7_1;
            this.ig7_1 = this.hg7_1;
            var tmp_5 = this;
            tmp_5.jg7_1 = this.yg6_1.n51(this.ig7_1.ac9());
            this.kg7_1 = this.jg7_1;
            var tmp_6 = this;
            tmp_6.lg7_1 = this.kg7_1;
            var tmp_7 = this;
            tmp_7.mg7_1 = ArrayList_init_$Create$();
            this.ng7_1 = this.lg7_1;
            this.og7_1 = this.mg7_1;
            var tmp_8 = this;
            tmp_8.pg7_1 = this.ng7_1;
            this.qg7_1 = this.pg7_1;
            this.rg7_1 = this.qg7_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.rg7_1.l()) {
              this.y9_1 = 4;
              continue $sm;
            }

            this.sg7_1 = this.rg7_1.m();
            var tmp_9 = this;
            tmp_9.tg7_1 = this.sg7_1;
            this.ug7_1 = this.tg7_1;
            var tmp_10 = this;
            tmp_10.vg7_1 = this.ug7_1;
            this.wg7_1 = this.vg7_1;
            this.y9_1 = 3;
            suspendResult = this.yg6_1.m51(this.wg7_1.i6u().o6s(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.og7_1.e(tmp0_safe_receiver);
            }

            this.y9_1 = 2;
            continue $sm;
          case 4:
            var list = this.og7_1;
            addAll_1(this.eg7_1, list);
            this.y9_1 = 1;
            continue $sm;
          case 5:
            var ARGUMENT = this.eg7_1;
            return toSet_0(ARGUMENT);
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$12_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gg8_1 = _this__u8e3s4;
    this.hg8_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$12_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            var tmp_0 = this;
            tmp_0.ig8_1 = this.hg8_1;
            this.jg8_1 = this.ig8_1;
            var tmp_1 = this;
            tmp_1.kg8_1 = this.jg8_1.n51(this.gg8_1.lg9_1.hc7());
            this.lg8_1 = this.kg8_1;
            var tmp_2 = this;
            tmp_2.mg8_1 = this.lg8_1;
            var tmp_3 = this;
            tmp_3.ng8_1 = ArrayList_init_$Create$();
            this.og8_1 = this.mg8_1;
            this.pg8_1 = this.ng8_1;
            var tmp_4 = this;
            tmp_4.qg8_1 = this.og8_1;
            this.rg8_1 = this.qg8_1;
            this.sg8_1 = this.rg8_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.sg8_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.tg8_1 = this.sg8_1.m();
            var tmp_5 = this;
            tmp_5.ug8_1 = this.tg8_1;
            this.vg8_1 = this.ug8_1;
            var tmp_6 = this;
            tmp_6.wg8_1 = this.vg8_1;
            this.xg8_1 = this.wg8_1;
            this.y9_1 = 2;
            suspendResult = this.jg8_1.m51(this.xg8_1.jbg(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.yg8_1 = suspendResult;
            if (this.yg8_1 == null)
              null;
            else {
              var it = this.yg8_1;
              this.pg8_1.e(it);
            }

            this.y9_1 = 1;
            continue $sm;
          case 3:
            this.zg8_1 = this.pg8_1;
            this.ag9_1 = toSet_0(this.zg8_1);
            var tmp_7 = this;
            tmp_7.bg9_1 = this.ag9_1;
            this.cg9_1 = this.bg9_1;
            var tmp_8 = this;
            tmp_8.dg9_1 = this.cg9_1;
            var tmp_9 = this;
            tmp_9.eg9_1 = ArrayList_init_$Create$();
            this.fg9_1 = this.dg9_1;
            this.gg9_1 = this.eg9_1;
            this.hg9_1 = this.fg9_1.k();
            this.y9_1 = 4;
            continue $sm;
          case 4:
            if (!this.hg9_1.l()) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.ig9_1 = this.hg9_1.m();
            var tmp_10 = this;
            tmp_10.jg9_1 = this.ig9_1;
            this.kg9_1 = this.jg9_1;
            this.y9_1 = 5;
            suspendResult = this.jg8_1.m51(allProperties_0(this.kg9_1, emptySet(), this.ag9_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var list = suspendResult;
            addAll_1(this.gg9_1, list);
            this.y9_1 = 4;
            continue $sm;
          case 6:
            return this.gg9_1;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$15_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ug9_1 = _this__u8e3s4;
    this.vg9_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$15_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 8;
            var tmp_0 = this;
            tmp_0.wg9_1 = this.vg9_1;
            this.xg9_1 = Unit_instance;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.yg9_1 = this.wg9_1;
            this.y9_1 = 2;
            suspendResult = this.yg9_1.m51(this.ug9_1.cga_1.gc7(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.zg9_1 = suspendResult;
            if (this.zg9_1 == null) {
              this.xg9_1 = emptyList();
              this.y9_1 = 7;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.aga_1 = this.zg9_1;
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            this.bga_1 = this.aga_1;
            if (this.bga_1 === this.ug9_1.dga_1) {
              var tmp_2 = this;
              var this_0 = this.ug9_1.ega_1;
              var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
              var _iterator__ex2g4s = this_0.k();
              while (_iterator__ex2g4s.l()) {
                var item = _iterator__ex2g4s.m();
                destination.e(this.yg9_1.n51(item.b3()));
              }
              tmp_2.xg9_1 = destination;
              this.y9_1 = 7;
              continue $sm;
            } else {
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            if (this.ug9_1.ega_1.s(this.bga_1)) {
              this.xg9_1 = emptyList();
              this.y9_1 = 7;
              continue $sm;
            } else {
              this.y9_1 = 5;
              continue $sm;
            }

          case 5:
            this.ug9_1.ega_1.e(this.bga_1);
            this.y9_1 = 6;
            suspendResult = this.yg9_1.m51(cycleInExtends_0(this.bga_1, this.ug9_1.dga_1, this.ug9_1.ega_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.xg9_1 = suspendResult;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 7;
            continue $sm;
          case 7:
            return this.xg9_1;
          case 8:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 8) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$16_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nga_1 = _this__u8e3s4;
    this.oga_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$16_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            var tmp_0 = this;
            tmp_0.pga_1 = this.oga_1;
            this.qga_1 = this.pga_1;
            this.rga_1 = ArrayList_init_$Create$();
            this.rga_1.o(this.qga_1.n51(this.nga_1.igb_1.w()));
            this.y9_1 = 1;
            suspendResult = this.qga_1.m51(this.nga_1.igb_1.gc7(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.sga_1 = suspendResult;
            if (!(this.sga_1 == null) && !this.nga_1.jgb_1.s(this.sga_1)) {
              this.nga_1.jgb_1.e(this.sga_1);
              this.y9_1 = 2;
              suspendResult = this.qga_1.m51(allEntries_0(this.sga_1, this.nga_1.jgb_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 6;
              continue $sm;
            }

          case 2:
            this.tga_1 = suspendResult;
            this.rga_1.o(this.tga_1);
            var tmp_1 = this;
            var tmp0 = this.qga_1.n51(this.nga_1.igb_1.w());
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              if (!(element == null) ? isInterface(element, AbstractLink) : false) {
                destination.e(element);
              }
            }

            tmp_1.uga_1 = destination;
            this.vga_1 = this.uga_1;
            var tmp_2 = this;
            tmp_2.wga_1 = this.vga_1;
            var tmp_3 = this;
            tmp_3.xga_1 = ArrayList_init_$Create$();
            this.yga_1 = this.wga_1;
            this.zga_1 = this.xga_1;
            var tmp_4 = this;
            tmp_4.agb_1 = this.yga_1;
            this.bgb_1 = this.agb_1;
            this.cgb_1 = this.bgb_1.k();
            this.y9_1 = 3;
            continue $sm;
          case 3:
            if (!this.cgb_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.dgb_1 = this.cgb_1.m();
            var tmp_5 = this;
            tmp_5.egb_1 = this.dgb_1;
            this.fgb_1 = this.egb_1;
            var tmp_6 = this;
            tmp_6.ggb_1 = this.fgb_1;
            this.hgb_1 = this.ggb_1;
            this.y9_1 = 4;
            suspendResult = this.qga_1.m51(this.hgb_1.jat(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.zga_1.e(tmp0_safe_receiver);
            }

            this.y9_1 = 3;
            continue $sm;
          case 5:
            var ARGUMENT = this.zga_1;
            this.rga_1.k1(ARGUMENT);
            this.y9_1 = 6;
            continue $sm;
          case 6:
            return this.rga_1;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$17_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.sgb_1 = _this__u8e3s4;
    this.tgb_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$17_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 8;
            var tmp_0 = this;
            tmp_0.ugb_1 = this.tgb_1;
            this.vgb_1 = this.ugb_1;
            this.wgb_1 = ArrayList_init_$Create$();
            this.wgb_1.o(subtract(this.vgb_1.n51(this.sgb_1.wgc_1.pas()), this.sgb_1.xgc_1));
            this.y9_1 = 1;
            suspendResult = this.vgb_1.m51(this.sgb_1.wgc_1.odb(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.xgb_1 = suspendResult;
            var tmp_1 = this;
            tmp_1.ygb_1 = this.vgb_1.n51(this.sgb_1.wgc_1.hc7());
            this.zgb_1 = this.ygb_1;
            var tmp_2 = this;
            tmp_2.agc_1 = this.zgb_1;
            var tmp_3 = this;
            tmp_3.bgc_1 = ArrayList_init_$Create$();
            this.cgc_1 = this.agc_1;
            this.dgc_1 = this.bgc_1;
            var tmp_4 = this;
            tmp_4.egc_1 = this.cgc_1;
            this.fgc_1 = this.egc_1;
            this.ggc_1 = this.fgc_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.ggc_1.l()) {
              this.y9_1 = 4;
              continue $sm;
            }

            this.hgc_1 = this.ggc_1.m();
            var tmp_5 = this;
            tmp_5.igc_1 = this.hgc_1;
            this.jgc_1 = this.igc_1;
            var tmp_6 = this;
            tmp_6.kgc_1 = this.jgc_1;
            this.lgc_1 = this.kgc_1;
            this.y9_1 = 3;
            suspendResult = this.vgb_1.m51(this.lgc_1.jbg().o6s(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.mgc_1 = suspendResult;
            if (this.mgc_1 == null)
              null;
            else {
              var it = this.mgc_1;
              this.dgc_1.e(it);
            }

            this.y9_1 = 2;
            continue $sm;
          case 4:
            this.ngc_1 = this.dgc_1;
            this.ogc_1 = subtract(this.ngc_1, this.sgb_1.ygc_1);
            this.pgc_1 = plus_8(this.sgb_1.ygc_1, this.ogc_1);
            var tmp_7 = this;
            tmp_7.qgc_1 = this.ogc_1;
            this.rgc_1 = this.qgc_1;
            this.sgc_1 = this.rgc_1.k();
            this.y9_1 = 5;
            continue $sm;
          case 5:
            if (!this.sgc_1.l()) {
              this.y9_1 = 7;
              continue $sm;
            }

            this.tgc_1 = this.sgc_1.m();
            var tmp_8 = this;
            tmp_8.ugc_1 = this.tgc_1;
            this.vgc_1 = this.ugc_1;
            this.y9_1 = 6;
            suspendResult = this.vgb_1.m51(allProperties_0(this.vgc_1, plus_8(this.sgb_1.xgc_1, this.xgb_1), this.pgc_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var ARGUMENT = suspendResult;
            this.wgb_1.o(ARGUMENT);
            this.y9_1 = 5;
            continue $sm;
          case 7:
            return this.wgb_1;
          case 8:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 8) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function cycleInExtends_0($this, origin, ps) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ProcessDeclaration$cycleInExtends$$inlined$suspendingQuery$1($this, origin, ps);
  }
  function allEntries_0($this, ps) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ProcessDeclaration$allEntries$$inlined$suspendingQuery$1($this, ps);
  }
  function allProperties_0($this, visitedAliasedProperties, visitedProcesses) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ProcessDeclaration$allProperties$$inlined$suspendingQuery$1($this, visitedAliasedProperties, visitedProcesses);
  }
  function Companion_208() {
    Companion_instance_208 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.jc6_1 = new RefTag(getKClass(BTBNode), getKClass(ProcessKind_1), getKClass(QualifiedReferenceContent), 'kind');
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp_0.kc6_1 = new RefTag(getKClass(BTBNode), getKClass(ProcessDeclaration_1), getKClass(QualifiedReferenceContent), 'process');
    this.lc6_1 = getLogger(getKClass(ProcessDeclaration_1));
  }
  var Companion_instance_208;
  function Companion_getInstance_208() {
    if (Companion_instance_208 == null)
      new Companion_208();
    return Companion_instance_208;
  }
  function ProcessDeclaration$aliasedProperties$$inlined$suspendingQuery$1(this$0) {
    this.xg7_1 = this$0;
  }
  protoOf(ProcessDeclaration$aliasedProperties$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$10_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ProcessDeclaration$aliasedProperties$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ProcessDeclaration$allSuperProperties$$inlined$suspendingQuery$1(this$0) {
    this.lg9_1 = this$0;
  }
  protoOf(ProcessDeclaration$allSuperProperties$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$12_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ProcessDeclaration$allSuperProperties$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ProcessDeclaration$cycleInExtends$$inlined$suspendingQuery$1(this$0, $origin, $ps) {
    this.cga_1 = this$0;
    this.dga_1 = $origin;
    this.ega_1 = $ps;
  }
  protoOf(ProcessDeclaration$cycleInExtends$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$15_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ProcessDeclaration$cycleInExtends$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ProcessDeclaration$allEntries$$inlined$suspendingQuery$1(this$0, $ps) {
    this.igb_1 = this$0;
    this.jgb_1 = $ps;
  }
  protoOf(ProcessDeclaration$allEntries$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$16_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ProcessDeclaration$allEntries$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ProcessDeclaration$allProperties$$inlined$suspendingQuery$1(this$0, $visitedAliasedProperties, $visitedProcesses) {
    this.wgc_1 = this$0;
    this.xgc_1 = $visitedAliasedProperties;
    this.ygc_1 = $visitedProcesses;
  }
  protoOf(ProcessDeclaration$allProperties$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$17_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ProcessDeclaration$allProperties$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ProcessDeclaration_1() {
  }
  function ProcessType_1() {
  }
  function Companion_209() {
    Companion_instance_209 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'processReference';
    tmp.ccb_1 = new RefTag(getKClass(ProcessReference_1), getKClass(ProcessDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_209;
  function Companion_getInstance_209() {
    if (Companion_instance_209 == null)
      new Companion_209();
    return Companion_instance_209;
  }
  function ProcessReference_1() {
  }
  function ProcessPrerequisite_0() {
  }
  function ProcessEffect_0() {
  }
  function ProcessLibrary_1() {
  }
  function ProcessKind_1() {
  }
  function ProcessKindContainer_1() {
  }
  function OntologyElementPropertyType_1() {
  }
  function ProcessPropertyDefault_1() {
  }
  function ProcessProperty_1() {
  }
  function ProcessPropertyType$type$$inlined$query$1(this$0) {
    this.zgc_1 = this$0;
  }
  protoOf(ProcessPropertyType$type$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.ProcessPropertyType.<get-type>.<anonymous>' call
    return this.zgc_1;
  };
  function ProcessPropertyType() {
  }
  function ProcessPropertyValueRange() {
  }
  function Companion_210() {
    Companion_instance_210 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'notionReference';
    tmp.wcm_1 = new RefTag(getKClass(SimplePropertyType), getKClass(AbstractNotion), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_210;
  function Companion_getInstance_210() {
    if (Companion_instance_210 == null)
      new Companion_210();
    return Companion_instance_210;
  }
  function SimplePropertyType() {
  }
  function Companion_211() {
    Companion_instance_211 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'propertyReference';
    tmp.aca_1 = new RefTag(getKClass(ProcessPropertyReference), getKClass(ProcessProperty_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_211;
  function Companion_getInstance_211() {
    if (Companion_instance_211 == null)
      new Companion_211();
    return Companion_instance_211;
  }
  function ProcessPropertyReference() {
  }
  function MultipleProcessPropertyValueRange_1() {
  }
  function PropertyDeclaration_1() {
  }
  function Companion_212() {
    Companion_instance_212 = this;
    this.gcg_1 = Companion_getInstance_213().agd_1;
  }
  var Companion_instance_212;
  function Companion_getInstance_212() {
    if (Companion_instance_212 == null)
      new Companion_212();
    return Companion_instance_212;
  }
  function PropertyValue_1() {
  }
  function Companion_213() {
    Companion_instance_213 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'abstractProperty';
    tmp.agd_1 = new RefTag(getKClass(BTBNode), getKClass(AbstractProperty), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_213;
  function Companion_getInstance_213() {
    if (Companion_instance_213 == null)
      new Companion_213();
    return Companion_instance_213;
  }
  function AbstractProperty() {
  }
  function PropertyLibrary$properties$$inlined$map$1($this) {
    this.bgd_1 = $this;
  }
  protoOf(PropertyLibrary$properties$$inlined$map$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.query.map.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.model.PropertyLibrary.<get-properties>.<anonymous>' call
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = builder.n51(this.bgd_1);
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      if (!(element == null) ? isInterface(element, PropertyDeclaration_1) : false) {
        destination.e(element);
      }
    }
    return destination;
  };
  function PropertyLibrary_1() {
  }
  function PropertyLibraryElement() {
  }
  function $runSuspendCOROUTINE$18_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kgd_1 = _this__u8e3s4;
    this.lgd_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$18_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.mgd_1 = this.lgd_1;
            this.ngd_1 = this.mgd_1;
            this.y9_1 = 1;
            suspendResult = this.ngd_1.m51(this.kgd_1.ogd_1.mbd(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b3();
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : this.ngd_1.n51(tmp1_safe_receiver);
            return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$19_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xgd_1 = _this__u8e3s4;
    this.ygd_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$19_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.zgd_1 = this.ygd_1;
            this.age_1 = this.zgd_1;
            this.y9_1 = 1;
            suspendResult = this.age_1.m51(this.xgd_1.bge_1.mbd(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zb3();
            return tmp1_safe_receiver == null ? null : this.age_1.n51(tmp1_safe_receiver);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function Companion_214() {
    Companion_instance_214 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'importedPropertyReference';
    tmp.nbd_1 = new RefTag(getKClass(ImportedProperty_1), getKClass(PropertyDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_214;
  function Companion_getInstance_214() {
    if (Companion_instance_214 == null)
      new Companion_214();
    return Companion_instance_214;
  }
  function ImportedProperty$name$$inlined$suspendingQuery$1(this$0) {
    this.ogd_1 = this$0;
  }
  protoOf(ImportedProperty$name$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$18_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ImportedProperty$name$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ImportedProperty$type$$inlined$suspendingQuery$1(this$0) {
    this.bge_1 = this$0;
  }
  protoOf(ImportedProperty$type$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$19_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ImportedProperty$type$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ImportedProperty_1() {
  }
  function BindingProperty$name$$inlined$query$1(this$0) {
    this.cge_1 = this$0;
  }
  protoOf(BindingProperty$name$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.BindingProperty.<get-name>.<anonymous>' call
    var tmp0_safe_receiver = builder.n51(this.cge_1.i6u());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b3();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : builder.n51(tmp1_safe_receiver);
    return tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
  };
  function BindingProperty$type$$inlined$suspendingQuery$1(this$0) {
    this.dge_1 = this$0;
  }
  protoOf(BindingProperty$type$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.biokb.lang.model.BindingProperty.<get-type>.<anonymous>' call
    var tmp0_safe_receiver = builder.n51(this.dge_1.i6u());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zb3();
    return tmp1_safe_receiver == null ? null : builder.n51(tmp1_safe_receiver);
  };
  protoOf(BindingProperty$type$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function BindingProperty_1() {
  }
  function EmptyPropertyLibraryElement_1() {
  }
  function authorsPart($this) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new PublishedWork$authorsPart$$inlined$query$1($this);
  }
  function PublishedWork$citation$$inlined$query$1(this$0) {
    this.ege_1 = this$0;
  }
  protoOf(PublishedWork$citation$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.PublishedWork.citation.<anonymous>' call
    var authorsAndName = builder.n51(authorsPart(this.ege_1)) + builder.n51(get_forQueries_2(this.ege_1.zat().n4z()));
    var tmp;
    if (isBlank(builder.n51(this.ege_1.wci()))) {
      tmp = authorsAndName;
    } else {
      var tmp_0;
      // Inline function 'kotlin.text.trimEnd' call
      var tmp$ret$0 = toString_1(trimEnd(isCharSequence(authorsAndName) ? authorsAndName : THROW_CCE()));
      if (endsWith(tmp$ret$0, '.')) {
        tmp_0 = authorsAndName + ' ' + builder.n51(this.ege_1.wci());
      } else {
        tmp_0 = authorsAndName + '. ' + builder.n51(this.ege_1.wci());
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  function PublishedWork$authorsPart$$inlined$query$1(this$0) {
    this.fge_1 = this$0;
  }
  protoOf(PublishedWork$authorsPart$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.PublishedWork.authorsPart.<anonymous>' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = builder.n51(this.fge_1.yat());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.biokb.lang.model.PublishedWork.authorsPart.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.b3().n4z().m2c();
      destination.e(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var element = _iterator__ex2g4s_0.m();
      // Inline function 'jetbrains.biokb.lang.model.PublishedWork.authorsPart.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element)) {
        destination_0.e(element);
      }
    }
    var list = destination_0;
    var shortList = list.n() <= 2 ? list : plus_3(take(list, 2), 'et al.');
    // Inline function 'kotlin.text.trimEnd' call
    var this_1 = joinToString_0(shortList, ', ');
    var authorsString = toString_1(trimEnd(isCharSequence(this_1) ? this_1 : THROW_CCE()));
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(authorsString) === 0) {
      tmp = '';
    } else {
      if (endsWith(authorsString, '.')) {
        tmp = authorsString + ' ';
      } else {
        tmp = authorsString + '. ';
      }
    }
    return tmp;
  };
  function PublishedWork() {
  }
  function LibraryItem() {
  }
  function AuthoredWork() {
  }
  function Author_1() {
  }
  function Book_1() {
  }
  function OldPublishedSource() {
  }
  function Paper_1() {
  }
  function FindConnectionCommand_1() {
  }
  function ContextQuery_1() {
  }
  function Companion_215() {
    Companion_instance_215 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.zcj_1 = new RefTag(getKClass(QueryParametersBlackList), getKClass(OntologyLibrary_1), getKClass(QualifiedReferenceContent), 'library');
  }
  var Companion_instance_215;
  function Companion_getInstance_215() {
    if (Companion_instance_215 == null)
      new Companion_215();
    return Companion_instance_215;
  }
  function QueryParametersBlackList() {
  }
  function Companion_216() {
    Companion_instance_216 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'propertyDeclaration';
    tmp.qce_1 = new RefTag(getKClass(BTBNode), getKClass(PropertyDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_216;
  function Companion_getInstance_216() {
    if (Companion_instance_216 == null)
      new Companion_216();
    return Companion_instance_216;
  }
  function PropertyDeclarationValueQuery_1() {
  }
  function Companion_217() {
    Companion_instance_217 = this;
    this.kbg_1 = Companion_getInstance_208().jc6_1;
    this.lbg_1 = Companion_getInstance_208().kc6_1;
  }
  var Companion_instance_217;
  function Companion_getInstance_217() {
    if (Companion_instance_217 == null)
      new Companion_217();
    return Companion_instance_217;
  }
  function LibraryProcessSpecificationQuery_1() {
  }
  function Command_0() {
  }
  function DeclarationValueQuery() {
  }
  function BindingValuePlaceholderQuery_1() {
  }
  function AbstractBindingValueQuery() {
  }
  function BindingValueMask_1() {
  }
  function Companion_218() {
    Companion_instance_218 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'linkDeclaration';
    tmp.vc1_1 = new RefTag(getKClass(BTBNode), getKClass(LinkDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_218;
  function Companion_getInstance_218() {
    if (Companion_instance_218 == null)
      new Companion_218();
    return Companion_instance_218;
  }
  function OntologyLinkDeclarationValueQuery_1() {
  }
  function OrValueQuery_1() {
  }
  function QueryCommands_1() {
  }
  function Companion_219() {
    Companion_instance_219 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'instanceRelationInValue';
    tmp.dbf_1 = new RefTag(getKClass(InstanceRelationValue), getKClass(InstanceRelationDeclaration), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_219;
  function Companion_getInstance_219() {
    if (Companion_instance_219 == null)
      new Companion_219();
    return Companion_instance_219;
  }
  function InstanceRelationValue() {
  }
  function InstanceRelationDeclaration() {
  }
  function ProcessRelationDeclaration$isValid$$inlined$query$1(this$0) {
    this.gge_1 = this$0;
  }
  protoOf(ProcessRelationDeclaration$isValid$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.ProcessRelationDeclaration.isValid.<anonymous>' call
    return !(builder.n51(this.gge_1.kcc()) == null) && !(builder.n51(this.gge_1.lcc()) == null);
  };
  function ProcessRelationDeclaration_1() {
  }
  function RelationContainer_1() {
  }
  function InstanceRelationValuePlaceholder() {
  }
  var RelationDirection_UNIDIRECTIONAL_instance;
  var RelationDirection_BIDIRECTIONAL_instance;
  function values_13() {
    return [RelationDirection_UNIDIRECTIONAL_getInstance(), RelationDirection_BIDIRECTIONAL_getInstance()];
  }
  var RelationDirection_entriesInitialized;
  function RelationDirection_initEntries() {
    if (RelationDirection_entriesInitialized)
      return Unit_instance;
    RelationDirection_entriesInitialized = true;
    RelationDirection_UNIDIRECTIONAL_instance = new RelationDirection('UNIDIRECTIONAL', 0, 'Unidirectional');
    RelationDirection_BIDIRECTIONAL_instance = new RelationDirection('BIDIRECTIONAL', 1, 'Bidirectional');
  }
  function RelationDirection(name, ordinal, displayName) {
    Enum.call(this, name, ordinal);
    this.jge_1 = displayName;
  }
  protoOf(RelationDirection).toString = function () {
    return this.jge_1;
  };
  var RelationEffect_POSITIVE_instance;
  var RelationEffect_NEGATIVE_instance;
  var RelationEffect_UNKNOWN_instance;
  var RelationEffect_NO_EFFECT_instance;
  function values_14() {
    return [RelationEffect_POSITIVE_getInstance(), RelationEffect_NEGATIVE_getInstance(), RelationEffect_UNKNOWN_getInstance(), RelationEffect_NO_EFFECT_getInstance()];
  }
  var RelationEffect_entriesInitialized;
  function RelationEffect_initEntries() {
    if (RelationEffect_entriesInitialized)
      return Unit_instance;
    RelationEffect_entriesInitialized = true;
    RelationEffect_POSITIVE_instance = new RelationEffect('POSITIVE', 0, 'Positive');
    RelationEffect_NEGATIVE_instance = new RelationEffect('NEGATIVE', 1, 'Negative');
    RelationEffect_UNKNOWN_instance = new RelationEffect('UNKNOWN', 2, 'Unknown');
    RelationEffect_NO_EFFECT_instance = new RelationEffect('NO_EFFECT', 3, 'No Effect');
  }
  function RelationEffect(name, ordinal, displayName) {
    Enum.call(this, name, ordinal);
    this.mge_1 = displayName;
  }
  protoOf(RelationEffect).toString = function () {
    return this.mge_1;
  };
  function RelationDirection_UNIDIRECTIONAL_getInstance() {
    RelationDirection_initEntries();
    return RelationDirection_UNIDIRECTIONAL_instance;
  }
  function RelationDirection_BIDIRECTIONAL_getInstance() {
    RelationDirection_initEntries();
    return RelationDirection_BIDIRECTIONAL_instance;
  }
  function RelationEffect_POSITIVE_getInstance() {
    RelationEffect_initEntries();
    return RelationEffect_POSITIVE_instance;
  }
  function RelationEffect_NEGATIVE_getInstance() {
    RelationEffect_initEntries();
    return RelationEffect_NEGATIVE_instance;
  }
  function RelationEffect_UNKNOWN_getInstance() {
    RelationEffect_initEntries();
    return RelationEffect_UNKNOWN_instance;
  }
  function RelationEffect_NO_EFFECT_getInstance() {
    RelationEffect_initEntries();
    return RelationEffect_NO_EFFECT_instance;
  }
  function Type() {
  }
  function EnumerationConstant_1() {
  }
  function EnumerableNotion_1() {
  }
  function MeasurementUnit_1() {
  }
  function MeasurableNotion_1() {
  }
  function Companion_220() {
    Companion_instance_220 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.ybo_1 = new RefTag(getKClass(BTBNode), getKClass(AbstractNotion), getKClass(QualifiedReferenceContent), 'notion');
  }
  var Companion_instance_220;
  function Companion_getInstance_220() {
    if (Companion_instance_220 == null)
      new Companion_220();
    return Companion_instance_220;
  }
  function NotionType_0() {
  }
  function AbstractNotion() {
  }
  function OneOf_1() {
  }
  function NotionLibrary_1() {
  }
  function NotionPlaceholder_1() {
  }
  function PartValue$transformToVariableReference$$inlined$executeQuery$1(this$0) {
    this.nge_1 = this$0;
  }
  protoOf(PartValue$transformToVariableReference$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.PartValue.transformToVariableReference.<anonymous>' call
    var tmp0_safe_receiver = builder.n51(this.nge_1.obr());
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u6m();
    var tmp1_safe_receiver = (!(tmp == null) ? isInterface(tmp, VariableReferenceValue_1) : false) ? tmp : null;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'jetbrains.biokb.lang.model.PartValue.transformToVariableReference.<anonymous>.<anonymous>' call
      this.nge_1.s6m(tmp1_safe_receiver);
      tmp_0 = tmp1_safe_receiver;
    }
    return tmp_0;
  };
  function PartValue() {
  }
  function Companion_221() {
    Companion_instance_221 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.localRefTag' call
    var name = 'variable';
    tmp.kcq_1 = new RefTag(getKClass(BTBNode), getKClass(VariableDeclaration_1), getKClass(LocalReferenceContent), name);
  }
  var Companion_instance_221;
  function Companion_getInstance_221() {
    if (Companion_instance_221 == null)
      new Companion_221();
    return Companion_instance_221;
  }
  function VariableReferenceValue_1() {
  }
  function IsExpression_1() {
  }
  function Companion_222() {
    Companion_instance_222 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'objectProperty';
    tmp.qcf_1 = new RefTag(getKClass(BTBNode), getKClass(ObjectPropertyDeclaration_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_222;
  function Companion_getInstance_222() {
    if (Companion_instance_222 == null)
      new Companion_222();
    return Companion_instance_222;
  }
  function PropertyReferenceOperation_1() {
  }
  function ObjectPropertyReferenceValue$removePropertyReference$$inlined$executeQuery$1(this$0) {
    this.oge_1 = this$0;
  }
  protoOf(ObjectPropertyReferenceValue$removePropertyReference$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.ObjectPropertyReferenceValue.removePropertyReference.<anonymous>' call
    var tmp0_safe_receiver = builder.n51(this.oge_1.obr());
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u6m();
    var tmp1_safe_receiver = (tmp == null ? true : isInterface(tmp, AbstractValue)) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'jetbrains.biokb.lang.model.ObjectPropertyReferenceValue.removePropertyReference.<anonymous>.<anonymous>' call
      this.oge_1.s6m(tmp1_safe_receiver);
      tmp_0 = tmp1_safe_receiver;
    }
    return tmp_0;
  };
  function ObjectPropertyReferenceValue_1() {
  }
  function OntologyElementReferenceValueLibrary_1() {
  }
  function propertyReferenceValue($this, wrapperContext) {
    // Inline function 'kotlin.also' call
    var this_0 = ObjectPropertyReferenceValue(wrapperContext);
    // Inline function 'jetbrains.biokb.lang.model.AbstractValue.propertyReferenceValue.<anonymous>' call
    var tmp = this_0.obr();
    var tmp_0 = $this.u6m();
    tmp.v2c(isInterface(tmp_0, AbstractValue) ? tmp_0 : THROW_CCE());
    this_0.i6u().v2c(PropertyReferenceOperation(wrapperContext));
    return this_0;
  }
  function AbstractValue() {
  }
  function OntologyElementReferenceValue_1() {
  }
  function Companion_223() {
    Companion_instance_223 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    tmp.hbk_1 = new RefTag(getKClass(BTBNode), getKClass(MeasurementUnit_1), getKClass(QualifiedReferenceContent), 'unit');
  }
  var Companion_instance_223;
  function Companion_getInstance_223() {
    if (Companion_instance_223 == null)
      new Companion_223();
    return Companion_instance_223;
  }
  function MeasurableValue_1() {
  }
  function Companion_224() {
    Companion_instance_224 = this;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.langDef.references.repoRefTag' call
    var name = 'constant';
    tmp.jb2_1 = new RefTag(getKClass(BTBNode), getKClass(EnumerationConstant_1), getKClass(QualifiedReferenceContent), name);
  }
  var Companion_instance_224;
  function Companion_getInstance_224() {
    if (Companion_instance_224 == null)
      new Companion_224();
    return Companion_instance_224;
  }
  function EnumValue_1() {
  }
  function ValueWithRelations_1() {
  }
  function HasQueryLabels() {
  }
  function PartReferenceOperation() {
  }
  function SetValuedPropertyParameter_1() {
  }
  function SetExpression_1() {
  }
  function VariableDeclaration_1() {
  }
  function VariableSpecification() {
  }
  function VariableInitializer() {
  }
  var serialization_0;
  function get_serializationWithName() {
    _init_properties_BTBConfiguration_kt__auaap2();
    return serializationWithName;
  }
  var serializationWithName;
  function get_nodeStorage() {
    _init_properties_BTBConfiguration_kt__auaap2();
    return nodeStorage;
  }
  var nodeStorage;
  function get_wrapperContext(_this__u8e3s4) {
    _init_properties_BTBConfiguration_kt__auaap2();
    return _this__u8e3s4.i72_1.o71();
  }
  function createFrontendDomainModel(coroutineContext, client, entity, entityContext) {
    entityContext = entityContext === VOID ? new EntityContext() : entityContext;
    _init_properties_BTBConfiguration_kt__auaap2();
    var tmp = get_btbLanguageWithRemoteResolve();
    return buildClientBtbDomainModel(tmp, coroutineContext, entityContext, entity, createFrontendDomainModel$lambda(client));
  }
  function get_nodePointerSupport(_this__u8e3s4) {
    _init_properties_BTBConfiguration_kt__auaap2();
    return ensureNotNull(_this__u8e3s4.m72_1.h2o(Companion_instance_88)).i6k();
  }
  function createFreshDomainModel(useExperimentalNode) {
    useExperimentalNode = useExperimentalNode === VOID ? false : useExperimentalNode;
    _init_properties_BTBConfiguration_kt__auaap2();
    return createDomainModelWithLocalResolve(VOID, useExperimentalNode);
  }
  function buildClientBtbDomainModel(language, coroutineContext, entityContext, entity, configure) {
    _init_properties_BTBConfiguration_kt__auaap2();
    var wrapperContext = WrapperContext_init_$Create$(entityContext);
    var nodePointerSupport = new SingleRootNodePointerSupport(wrapperContext);
    var structureModel = new SingleRootStructureModel(wrapperContext, nodePointerSupport, get_btbEntityNodeLayout(), entity, false);
    var builder = new BTBConfigurationBuilder(coroutineContext, language, structureModel);
    builder.tge(Companion_instance_33.k2o(structureModel.d72_1, [Companion_getInstance_115()]));
    configure(builder);
    return builder.k2p();
  }
  function BTBConfigurationBuilder(coroutineContext, language, structureModel) {
    this.pge_1 = coroutineContext;
    this.qge_1 = language;
    this.rge_1 = structureModel;
    this.sge_1 = ArrayList_init_$Create$();
  }
  protoOf(BTBConfigurationBuilder).tge = function (service) {
    this.sge_1.e(service);
  };
  protoOf(BTBConfigurationBuilder).k2p = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.sge_1;
    var tmp$ret$0 = copyToArray(this_0);
    return new DomainModel(this.qge_1, this.rge_1, tmp$ret$0.slice(), this.pge_1);
  };
  function frontendResolutionService(client) {
    _init_properties_BTBConfiguration_kt__auaap2();
    var tmp = Companion_instance_33;
    var tmp_0 = [Companion_instance_183];
    return tmp.m2o(tmp_0, VOID, frontendResolutionService$lambda(client));
  }
  function createDomainModelWithLocalResolve(coroutineContext, useExperimentalNode) {
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    useExperimentalNode = useExperimentalNode === VOID ? false : useExperimentalNode;
    _init_properties_BTBConfiguration_kt__auaap2();
    var repository = new LocalDocumentRepository(get_libraries());
    var tmp = get_btbLanguageWithLocalResolve();
    return buildLocalBtbDomainModel(tmp, repository, coroutineContext, VOID, useExperimentalNode, createDomainModelWithLocalResolve$lambda(repository));
  }
  function buildLocalBtbDomainModel(language, documentRepository, coroutineContext, entityContext, useExperimentalNode, configure) {
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    entityContext = entityContext === VOID ? new EntityContext() : entityContext;
    useExperimentalNode = useExperimentalNode === VOID ? false : useExperimentalNode;
    _init_properties_BTBConfiguration_kt__auaap2();
    var wrapperContext = WrapperContext_init_$Create$(entityContext);
    var nodePointerSupport = new LocalNodePointerSupport(wrapperContext, documentRepository);
    var structureModel = new BaseStructureModel(wrapperContext, nodePointerSupport, useExperimentalNode);
    var builder = new BTBConfigurationBuilder(coroutineContext, language, structureModel);
    configure(builder);
    return builder.k2p();
  }
  function createDomainModelWithPrecalculatedResolve(coroutineContext, resolveInfo, entity) {
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    _init_properties_BTBConfiguration_kt__auaap2();
    var tmp = get_btbLanguageWithPrecalculatedResolve();
    var tmp_0 = new EntityContext();
    return buildClientBtbDomainModel(tmp, coroutineContext, tmp_0, entity, createDomainModelWithPrecalculatedResolve$lambda(resolveInfo));
  }
  function serialization$lambda_0($this$serialization) {
    _init_properties_BTBConfiguration_kt__auaap2();
    var wrapperContext = ensureNotNull($this$serialization.h2o(WrapperContextService_instance));
    $this$serialization.u6z(serialization$lambda$lambda(wrapperContext, $this$serialization));
    return Unit_instance;
  }
  function serialization$lambda$lambda($wrapperContext, $this_serialization) {
    return function () {
      return new DomainNodePersister($wrapperContext, OtNodeFactoryService_instance.e2o($this_serialization));
    };
  }
  function serializationWithName$lambda($this$serialization) {
    _init_properties_BTBConfiguration_kt__auaap2();
    var wrapperContext = ensureNotNull($this$serialization.h2o(WrapperContextService_instance));
    $this$serialization.u6z(serializationWithName$lambda$lambda(wrapperContext, $this$serialization));
    return Unit_instance;
  }
  function serializationWithName$lambda$lambda($wrapperContext, $this_serialization) {
    return function () {
      return new BTBNodePersister($wrapperContext, OtNodeFactoryService_instance.e2o($this_serialization));
    };
  }
  function createFrontendDomainModel$lambda($client) {
    return function ($this$buildClientBtbDomainModel) {
      $this$buildClientBtbDomainModel.tge(get_btbErrorChecking());
      $this$buildClientBtbDomainModel.tge(frontendResolutionService($client));
      $this$buildClientBtbDomainModel.tge(get_serializationWithName());
      $this$buildClientBtbDomainModel.tge(get_nodeStorage());
      $this$buildClientBtbDomainModel.tge(Companion_instance_33.k2o(new RpcFacadeContainer(), [Companion_getInstance_165()]));
      return Unit_instance;
    };
  }
  function frontendResolutionService$lambda($client) {
    return function (it) {
      return new LiveResolutionService($client.vge_1);
    };
  }
  function createDomainModelWithLocalResolve$lambda($repository) {
    return function ($this$buildLocalBtbDomainModel) {
      $this$buildLocalBtbDomainModel.tge(ensureNotNull(get_btbLanguageWithLocalResolve().h2p(ScopeAspect_instance)));
      $this$buildLocalBtbDomainModel.tge(ensureNotNull(get_btbLanguageWithLocalResolve().h2p(FindUsagesAspect_instance)));
      $this$buildLocalBtbDomainModel.tge(get_serializationWithName());
      $this$buildLocalBtbDomainModel.tge(get_btbErrorChecking());
      $this$buildLocalBtbDomainModel.tge(Companion_instance_33.k2o($repository, [Companion_instance_110]));
      $this$buildLocalBtbDomainModel.tge(Companion_instance_33.n2o($repository, [Companion_instance_108]));
      return Unit_instance;
    };
  }
  function createDomainModelWithPrecalculatedResolve$lambda($resolveInfo) {
    return function ($this$buildClientBtbDomainModel) {
      $this$buildClientBtbDomainModel.tge(get_serializationWithName());
      $this$buildClientBtbDomainModel.tge(get_nodeStorage());
      $this$buildClientBtbDomainModel.tge(ensureNotNull(get_btbLanguageWithPrecalculatedResolve().h2p(FindUsagesAspect_instance)));
      $this$buildClientBtbDomainModel.tge(precalculatedResolutionService($resolveInfo));
      return Unit_instance;
    };
  }
  var properties_initialized_BTBConfiguration_kt_ti9h4;
  function _init_properties_BTBConfiguration_kt__auaap2() {
    if (!properties_initialized_BTBConfiguration_kt_ti9h4) {
      properties_initialized_BTBConfiguration_kt_ti9h4 = true;
      serialization_0 = serialization(serialization$lambda_0);
      serializationWithName = serialization(serializationWithName$lambda);
      nodeStorage = Companion_instance_33.k2o(new NodeStorageService(DefaultNodeStorage_instance), [Companion_getInstance_89()]);
    }
  }
  function get_btbEntityNodeLayout() {
    _init_properties_BtbEntityNodeLayout_kt__gd8dvx();
    return btbEntityNodeLayout;
  }
  var btbEntityNodeLayout;
  var properties_initialized_BtbEntityNodeLayout_kt_ozjemn;
  function _init_properties_BtbEntityNodeLayout_kt__gd8dvx() {
    if (!properties_initialized_BtbEntityNodeLayout_kt_ozjemn) {
      properties_initialized_BtbEntityNodeLayout_kt_ozjemn = true;
      btbEntityNodeLayout = new EntityNodeLayout(EntityConceptId_init_$Create$_0('edited.v1'), EntityModelBlobId_init_$Create$_0('edited-node-model'));
    }
  }
  function btbStructure(_this__u8e3s4) {
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.biokb.lang.model.config.btbStructure.<anonymous>' call
    Companion_getInstance_186().qg0_1.xar().war(_this__u8e3s4);
    return Unit_instance;
  }
  function RemoteDocumentClient(accession, providers) {
    this.uge_1 = accession;
    this.vge_1 = providers;
  }
  function get_btbErrorChecking() {
    return errorChecking(_get_btbErrorChecking_$lambda_iq0vgy);
  }
  function checkForCycleInVariableSpecs(_this__u8e3s4, variables, $completion) {
    var tmp = new $checkForCycleInVariableSpecsCOROUTINE$20(_this__u8e3s4, variables, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function checkClassExpressionType(_this__u8e3s4, type) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    if (!(type == null) ? isInterface(type, ClassExpressionType_1) : false) {
      var tmp0_elvis_lhs = _this__u8e3s4.n51(type.yay());
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return emptyList();
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var classExpression = tmp;
      if (isInterface(classExpression, UnionClass_1)) {
        // Inline function 'kotlin.collections.filterIsInstance' call
        var tmp0 = _this__u8e3s4.n51(classExpression.tco());
        // Inline function 'kotlin.collections.filterIsInstanceTo' call
        var destination = ArrayList_init_$Create$();
        var _iterator__ex2g4s = tmp0.k();
        while (_iterator__ex2g4s.l()) {
          var element = _iterator__ex2g4s.m();
          if (!(element == null) ? isInterface(element, ClassExpression) : false) {
            destination.e(element);
          }
        }
        if (destination.p()) {
          result.e(new ErrorForAllNode('empty unions are not supported', classExpression));
        }
      } else {
        result.e(new ErrorForAllNode('only unions are now supported as class expression type', type));
      }
    }
    return result;
  }
  function checkOneOfType(_this__u8e3s4, variable, spec) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var result = ArrayList_init_$Create$();
    var tmp;
    if (!(spec == null) ? isInterface(spec, OneOf_1) : false) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !_this__u8e3s4.n51(variable.dbc()).p();
    } else {
      tmp = false;
    }
    if (tmp) {
      result.e(new ErrorForAllNode('Constraints are not supported for One Of variable type', variable));
    }
    return result;
  }
  function checkForDuplicatePropertiesInConstraints(_this__u8e3s4, constraints, $completion) {
    var tmp = new $checkForDuplicatePropertiesInConstraintsCOROUTINE$21(_this__u8e3s4, constraints, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function checkForCycleInProcessDefaults(_this__u8e3s4, processDeclaration, $completion) {
    var tmp = new $checkForCycleInProcessDefaultsCOROUTINE$22(_this__u8e3s4, processDeclaration, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function checkNewFact(fact) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new checkNewFact$$inlined$suspendingQuery$1(fact);
  }
  function checkOntologyElement(element) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new checkOntologyElement$$inlined$suspendingQuery$1(element);
  }
  function checkOntologyElementDefinition(definition) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new checkOntologyElementDefinition$$inlined$suspendingQuery$1(definition);
  }
  function checkProcessRelationDeclaration(relation) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new checkProcessRelationDeclaration$$inlined$suspendingQuery$1(relation);
  }
  function duplicates(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new duplicates$$inlined$query$1(_this__u8e3s4);
  }
  function isProcessExpression(_this__u8e3s4, expression, $completion) {
    var tmp = new $isProcessExpressionCOROUTINE$23(_this__u8e3s4, expression, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function checkProcessRelation(_this__u8e3s4, expression, $completion) {
    var tmp = new $checkProcessRelationCOROUTINE$24(_this__u8e3s4, expression, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function _get_btbErrorChecking_$lambda_iq0vgy($this$errorChecking) {
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp1 = _get_btbErrorChecking_$lambda$lambda_niu9bb($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList = _get_btbErrorChecking_$lambda$lambda_niu9bb_0;
    tmp1(_get_btbErrorChecking_$lambda$lambda_niu9bb_1(uniqueList));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp4 = _get_btbErrorChecking_$lambda$lambda_niu9bb_2($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_0 = _get_btbErrorChecking_$lambda$lambda_niu9bb_3;
    tmp4(_get_btbErrorChecking_$lambda$lambda_niu9bb_4(uniqueList_0));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code = _get_btbErrorChecking_$lambda$lambda_niu9bb_5;
    $this$errorChecking.x72(getKClass(FactSet_1), code);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_0 = _get_btbErrorChecking_$lambda$lambda_niu9bb_6;
    $this$errorChecking.x72(getKClass(VariableDeclaration_1), code_0);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_1 = _get_btbErrorChecking_$lambda$lambda_niu9bb_7;
    $this$errorChecking.x72(getKClass(VariableDeclaration_1), code_1);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_2 = _get_btbErrorChecking_$lambda$lambda_niu9bb_8;
    $this$errorChecking.x72(getKClass(PropertyConstraint_1), code_2);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_3 = _get_btbErrorChecking_$lambda$lambda_niu9bb_9;
    $this$errorChecking.x72(getKClass(ObjectPropertyDeclaration_1), code_3);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_4 = _get_btbErrorChecking_$lambda$lambda_niu9bb_10;
    $this$errorChecking.x72(getKClass(PropertyReferenceOperation_1), code_4);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp19 = _get_btbErrorChecking_$lambda$lambda_niu9bb_11($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_1 = _get_btbErrorChecking_$lambda$lambda_niu9bb_12;
    tmp19(_get_btbErrorChecking_$lambda$lambda_niu9bb_13(uniqueList_1));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp22 = _get_btbErrorChecking_$lambda$lambda_niu9bb_14($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_2 = _get_btbErrorChecking_$lambda$lambda_niu9bb_15;
    tmp22(_get_btbErrorChecking_$lambda$lambda_niu9bb_16(uniqueList_2));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp25 = _get_btbErrorChecking_$lambda$lambda_niu9bb_17($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_3 = _get_btbErrorChecking_$lambda$lambda_niu9bb_18;
    tmp25(_get_btbErrorChecking_$lambda$lambda_niu9bb_19(uniqueList_3));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp28 = _get_btbErrorChecking_$lambda$lambda_niu9bb_20($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_4 = _get_btbErrorChecking_$lambda$lambda_niu9bb_21;
    tmp28(_get_btbErrorChecking_$lambda$lambda_niu9bb_22(uniqueList_4));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp31 = _get_btbErrorChecking_$lambda$lambda_niu9bb_23($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_5 = _get_btbErrorChecking_$lambda$lambda_niu9bb_24;
    tmp31(_get_btbErrorChecking_$lambda$lambda_niu9bb_25(uniqueList_5));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp34 = _get_btbErrorChecking_$lambda$lambda_niu9bb_26($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_6 = _get_btbErrorChecking_$lambda$lambda_niu9bb_27;
    tmp34(_get_btbErrorChecking_$lambda$lambda_niu9bb_28(uniqueList_6));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp37 = _get_btbErrorChecking_$lambda$lambda_niu9bb_29($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_7 = _get_btbErrorChecking_$lambda$lambda_niu9bb_30;
    tmp37(_get_btbErrorChecking_$lambda$lambda_niu9bb_31(uniqueList_7));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp40 = _get_btbErrorChecking_$lambda$lambda_niu9bb_32($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_8 = _get_btbErrorChecking_$lambda$lambda_niu9bb_33;
    tmp40(_get_btbErrorChecking_$lambda$lambda_niu9bb_34(uniqueList_8));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp43 = _get_btbErrorChecking_$lambda$lambda_niu9bb_35($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_9 = _get_btbErrorChecking_$lambda$lambda_niu9bb_36;
    tmp43(_get_btbErrorChecking_$lambda$lambda_niu9bb_37(uniqueList_9));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp46 = _get_btbErrorChecking_$lambda$lambda_niu9bb_38($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_10 = _get_btbErrorChecking_$lambda$lambda_niu9bb_39;
    tmp46(_get_btbErrorChecking_$lambda$lambda_niu9bb_40(uniqueList_10));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp49 = _get_btbErrorChecking_$lambda$lambda_niu9bb_41($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_11 = _get_btbErrorChecking_$lambda$lambda_niu9bb_42;
    tmp49(_get_btbErrorChecking_$lambda$lambda_niu9bb_43(uniqueList_11));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp52 = _get_btbErrorChecking_$lambda$lambda_niu9bb_44($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_12 = _get_btbErrorChecking_$lambda$lambda_niu9bb_45;
    tmp52(_get_btbErrorChecking_$lambda$lambda_niu9bb_46(uniqueList_12));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_5 = _get_btbErrorChecking_$lambda$lambda_niu9bb_47;
    $this$errorChecking.x72(getKClass(ProcessDeclaration_1), code_5);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var tmp57 = _get_btbErrorChecking_$lambda$lambda_niu9bb_48($this$errorChecking);
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.forDuplicates' call
    var uniqueList_13 = _get_btbErrorChecking_$lambda$lambda_niu9bb_49;
    tmp57(_get_btbErrorChecking_$lambda$lambda_niu9bb_50(uniqueList_13));
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_6 = _get_btbErrorChecking_$lambda$lambda_niu9bb_51;
    $this$errorChecking.x72(getKClass(ProcessDeclaration_1), code_6);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_7 = _get_btbErrorChecking_$lambda$lambda_niu9bb_52;
    $this$errorChecking.x72(getKClass(ProcessDeclaration_1), code_7);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_8 = _get_btbErrorChecking_$lambda$lambda_niu9bb_53;
    $this$errorChecking.x72(getKClass(ProcessProperty_1), code_8);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_9 = _get_btbErrorChecking_$lambda$lambda_niu9bb_54;
    $this$errorChecking.x72(getKClass(NewFact), code_9);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_10 = _get_btbErrorChecking_$lambda$lambda_niu9bb_55;
    $this$errorChecking.x72(getKClass(OntologyElement_1), code_10);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_11 = _get_btbErrorChecking_$lambda$lambda_niu9bb_56;
    $this$errorChecking.x72(getKClass(OntologyElementDefinition_1), code_11);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_12 = _get_btbErrorChecking_$lambda$lambda_niu9bb_57;
    $this$errorChecking.x72(getKClass(ProcessRelationDeclaration_1), code_12);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_13 = _get_btbErrorChecking_$lambda$lambda_niu9bb_58;
    $this$errorChecking.x72(getKClass(OntologyLibrary_1), code_13);
    // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
    var code_14 = _get_btbErrorChecking_$lambda$lambda_niu9bb_59;
    $this$errorChecking.x72(getKClass(ProcessPropertyValue_1), code_14);
    return Unit_instance;
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(FactSet_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_0(it) {
    return it.fb6();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_1($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_2($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(FactSet_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_3(it) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new btbErrorChecking$1$2$$inlined$query$1(it);
  }
  function btbErrorChecking$1$2$$inlined$query$1($it) {
    this.mgj_1 = $it;
  }
  protoOf(btbErrorChecking$1$2$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.<get-btbErrorChecking>.<anonymous>.<anonymous>.<anonymous>' call
    return plus_4(builder.n51(this.mgj_1.ybc()), builder.n51(this.mgj_1.pb7()));
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_4($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_5(it) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$1$3$$inlined$suspendingQuery$1(it);
  }
  function $runSuspendCOROUTINE$25_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vgj_1 = _this__u8e3s4;
    this.wgj_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$25_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.xgj_1 = this.wgj_1;
            this.ygj_1 = this.xgj_1;
            this.y9_1 = 1;
            suspendResult = checkForCycleInVariableSpecs(this.ygj_1, this.ygj_1.n51(this.vgj_1.zgj_1.ybc()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$1$3$$inlined$suspendingQuery$1($it) {
    this.zgj_1 = $it;
  }
  protoOf(btbErrorChecking$1$3$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$25_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbErrorChecking$1$3$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_6(variableDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$1$4$$inlined$suspendingQuery$1(variableDeclaration);
  }
  function btbErrorChecking$1$4$$inlined$suspendingQuery$1($variableDeclaration) {
    this.agk_1 = $variableDeclaration;
  }
  protoOf(btbErrorChecking$1$4$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.<get-btbErrorChecking>.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.arrayListOf' call
    var result = ArrayList_init_$Create$();
    var type = builder.n51(this.agk_1.jcq());
    result.o(checkClassExpressionType(builder, type));
    result.o(checkOneOfType(builder, this.agk_1, type));
    return result;
  };
  protoOf(btbErrorChecking$1$4$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_7(variableDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$1$5$$inlined$suspendingQuery$1(variableDeclaration);
  }
  function $runSuspendCOROUTINE$26(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jgk_1 = _this__u8e3s4;
    this.kgk_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$26).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.lgk_1 = this.kgk_1;
            this.mgk_1 = this.lgk_1;
            this.y9_1 = 1;
            suspendResult = checkForDuplicatePropertiesInConstraints(this.mgk_1, this.jgk_1.ngk_1.dbc(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$1$5$$inlined$suspendingQuery$1($variableDeclaration) {
    this.ngk_1 = $variableDeclaration;
  }
  protoOf(btbErrorChecking$1$5$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$26(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbErrorChecking$1$5$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_8(constraint) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$1$6$$inlined$suspendingQuery$1(constraint);
  }
  function $runSuspendCOROUTINE$27(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wgk_1 = _this__u8e3s4;
    this.xgk_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$27).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.ygk_1 = this.xgk_1;
            this.zgk_1 = this.ygk_1;
            this.y9_1 = 1;
            suspendResult = checkForDuplicatePropertiesInConstraints(this.zgk_1, this.wgk_1.agl_1.dbc(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$1$6$$inlined$suspendingQuery$1($constraint) {
    this.agl_1 = $constraint;
  }
  protoOf(btbErrorChecking$1$6$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$27(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbErrorChecking$1$6$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_9(property) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$1$7$$inlined$suspendingQuery$1(property);
  }
  function btbErrorChecking$1$7$$inlined$suspendingQuery$1($property) {
    this.bgl_1 = $property;
  }
  protoOf(btbErrorChecking$1$7$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.<get-btbErrorChecking>.<anonymous>.<anonymous>.<anonymous>' call
    var range = builder.n51(this.bgl_1.be());
    var tmp;
    if (!builder.n51(this.bgl_1.ybq()) && !(range == null)) {
      // Inline function 'kotlin.collections.filterNot' call
      var tmp0 = builder.n51(range.lbn());
      // Inline function 'kotlin.collections.filterNotTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.biokb.lang.model.errorCheck.<get-btbErrorChecking>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
        var tmp_0;
        var tmp_1;
        if (isInterface(element, OntologyElementType_1)) {
          tmp_1 = true;
        } else {
          tmp_1 = isInterface(element, ClassExpressionType_1);
        }
        if (tmp_1) {
          tmp_0 = true;
        } else {
          tmp_0 = isInterface(element, TypePlaceholder_1);
        }
        if (!tmp_0) {
          destination.e(element);
        }
      }
      var nonOntologyTypes = destination;
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(nonOntologyTypes, 10));
      var _iterator__ex2g4s_0 = nonOntologyTypes.k();
      while (_iterator__ex2g4s_0.l()) {
        var item = _iterator__ex2g4s_0.m();
        // Inline function 'jetbrains.biokb.lang.model.errorCheck.<get-btbErrorChecking>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$3 = copyToArray(nonOntologyTypes);
        var tmp$ret$4 = new ErrorForDescendants('Only ontology types are allowed for independent properties', tmp$ret$3.slice());
        destination_0.e(tmp$ret$4);
      }
      tmp = destination_0;
    } else {
      tmp = emptyList();
    }
    return tmp;
  };
  protoOf(btbErrorChecking$1$7$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_10(operation) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$1$8$$inlined$suspendingQuery$1(operation);
  }
  function $runSuspendCOROUTINE$28_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kgl_1 = _this__u8e3s4;
    this.lgl_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$28_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.mgl_1 = this.lgl_1;
            this.ngl_1 = this.mgl_1;
            this.y9_1 = 1;
            suspendResult = this.ngl_1.m51(this.kgl_1.ogl_1.i6u().o6s(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var propertyRange = tmp0_safe_receiver == null ? null : this.ngl_1.n51(tmp0_safe_receiver.be());
            var parameter = this.ngl_1.n51(this.kgl_1.ogl_1.fcg());
            var tmp_1;
            var tmp_2;
            if (!(parameter == null)) {
              tmp_2 = !(!(propertyRange == null) ? isInterface(propertyRange, MultiplePropertyValueRange_1) : false);
            } else {
              tmp_2 = false;
            }

            if (tmp_2) {
              tmp_1 = listOf(new ErrorForAllNode("Parameter makes no sense as property doesn't have 'set' type ", parameter));
            } else {
              tmp_1 = emptyList();
            }

            return tmp_1;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$1$8$$inlined$suspendingQuery$1($operation) {
    this.ogl_1 = $operation;
  }
  protoOf(btbErrorChecking$1$8$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$28_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbErrorChecking$1$8$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_11($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(ProcessLibrary_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_12(it) {
    return it.jc8();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_13($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_14($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(PropertyLibrary_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_15(it) {
    return it.pas();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_16($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_17($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(ObjectPropertiesLibrary), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_18(it) {
    return it.pas();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_19($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_20($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(LinkLibrary_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_21(it) {
    return it.sbi();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_22($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_23($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(NotionLibrary_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_24(it) {
    return it.xbo();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_25($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_26($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(EnumerableNotion_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_27(it) {
    return it.jb3();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_28($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_29($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(MeasurableNotion_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_30(it) {
    return it.sbj();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_31($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_32($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(ExtensionLibrary_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_33(it) {
    return it.n9c();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_34($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_35($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(ExtensionDeclaration_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_36(it) {
    return it.yb3();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_37($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_38($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(RelationContainer_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_39(it) {
    return it.ccl();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_40($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_41($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(ModifierContainer), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_42(it) {
    return it.jbl();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_43($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_44($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(ProcessKindContainer_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_45(it) {
    return it.wc7();
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_46($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_47(process) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$1$21$$inlined$suspendingQuery$1(process);
  }
  function $runSuspendCOROUTINE$29_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xgl_1 = _this__u8e3s4;
    this.ygl_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$29_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.zgl_1 = this.ygl_1;
            this.agm_1 = this.zgl_1;
            this.y9_1 = 1;
            suspendResult = this.agm_1.m51(this.xgl_1.bgm_1.sdb(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var cycle = suspendResult;
            return cycle.p() ? emptyList() : cycle.n() === 1 ? listOf(new ErrorForAllNode('process cannot extend itself', this.xgl_1.bgm_1)) : listOf(new ErrorForAllNode("cycle in 'process extends' chain: " + joinToString_0(cycle), this.xgl_1.bgm_1));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$1$21$$inlined$suspendingQuery$1($process) {
    this.bgm_1 = $process;
  }
  protoOf(btbErrorChecking$1$21$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$29_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbErrorChecking$1$21$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_48($this) {
    return function (code) {
      // Inline function 'jetbrains.ocelot.langDef.check.config.ErrorCheckConfigBuilder.check' call
      $this.x72(getKClass(ProcessDeclaration_1), code);
      return Unit_instance;
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_49(it) {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new btbErrorChecking$1$22$$inlined$query$1(it);
  }
  function btbErrorChecking$1$22$$inlined$query$1($it) {
    this.cgm_1 = $it;
  }
  protoOf(btbErrorChecking$1$22$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.<get-btbErrorChecking>.<anonymous>.<anonymous>.<anonymous>' call
    return plus_4(builder.n51(this.cgm_1.pas()), builder.n51(this.cgm_1.ybc()));
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_50($uniqueList) {
    return function (node) {
      return duplicates($uniqueList(node));
    };
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_51(processDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$1$23$$inlined$suspendingQuery$1(processDeclaration);
  }
  function $runSuspendCOROUTINE$30(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lgm_1 = _this__u8e3s4;
    this.mgm_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$30).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.ngm_1 = this.mgm_1;
            this.ogm_1 = this.ngm_1;
            this.y9_1 = 1;
            suspendResult = checkForCycleInProcessDefaults(this.ogm_1, this.lgm_1.pgm_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$1$23$$inlined$suspendingQuery$1($processDeclaration) {
    this.pgm_1 = $processDeclaration;
  }
  protoOf(btbErrorChecking$1$23$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$30(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbErrorChecking$1$23$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_52(it) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$1$24$$inlined$suspendingQuery$1(it);
  }
  function $runSuspendCOROUTINE$31_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ygm_1 = _this__u8e3s4;
    this.zgm_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$31_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.agn_1 = this.zgm_1;
            this.bgn_1 = this.agn_1;
            this.y9_1 = 1;
            suspendResult = checkForCycleInVariableSpecs(this.bgn_1, this.bgn_1.n51(this.ygm_1.cgn_1.ybc()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function btbErrorChecking$1$24$$inlined$suspendingQuery$1($it) {
    this.cgn_1 = $it;
  }
  protoOf(btbErrorChecking$1$24$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$31_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbErrorChecking$1$24$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_53(property) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$1$25$$inlined$suspendingQuery$1(property);
  }
  function btbErrorChecking$1$25$$inlined$suspendingQuery$1($property) {
    this.dgn_1 = $property;
  }
  protoOf(btbErrorChecking$1$25$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.<get-btbErrorChecking>.<anonymous>.<anonymous>.<anonymous>' call
    var tmp0_safe_receiver = builder.n51(this.dgn_1.zb3());
    return checkClassExpressionType(builder, tmp0_safe_receiver == null ? null : builder.n51(tmp0_safe_receiver.zb3()));
  };
  protoOf(btbErrorChecking$1$25$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_54(fact) {
    return checkNewFact(fact);
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_55(element) {
    return checkOntologyElement(element);
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_56(definition) {
    return checkOntologyElementDefinition(definition);
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_57(relation) {
    return checkProcessRelationDeclaration(relation);
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_58(ontology) {
    return checkOntology(ontology, ontology.b3().n4z().m2c() === 'metaOntology');
  }
  function _get_btbErrorChecking_$lambda$lambda_niu9bb_59(propertyValue) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbErrorChecking$1$31$$inlined$suspendingQuery$1(propertyValue);
  }
  function btbErrorChecking$1$31$$inlined$suspendingQuery$1($propertyValue) {
    this.egn_1 = $propertyValue;
  }
  protoOf(btbErrorChecking$1$31$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.<get-btbErrorChecking>.<anonymous>.<anonymous>.<anonymous>' call
    var tmp;
    if (builder.n51(this.egn_1.y()) == null) {
      tmp = listOf(new ErrorForAllNode('Empty process property value', this.egn_1));
    } else {
      tmp = emptyList();
    }
    return tmp;
  };
  protoOf(btbErrorChecking$1$31$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function checkForCycleInVariableSpecs$lambda($visited, $result) {
    return function ($this$traverseDepthFirst) {
      $visited.e($this$traverseDepthFirst.y8c());
      $result.e($this$traverseDepthFirst.y8c());
      return Unit_instance;
    };
  }
  function checkForCycleInProcessDefaults$lambda($currentCycle) {
    return function ($this$traverseDepthFirst) {
      var tmp0 = $this$traverseDepthFirst.jgn();
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.minByOrNull' call
        var iterator = tmp0.k();
        if (!iterator.l()) {
          tmp$ret$0 = null;
          break $l$block_0;
        }
        var minElem = iterator.m();
        if (!iterator.l()) {
          tmp$ret$0 = minElem;
          break $l$block_0;
        }
        // Inline function 'jetbrains.biokb.lang.model.errorCheck.checkForCycleInProcessDefaults.<anonymous>.<anonymous>' call
        var minValue = minElem.v39().i2s_1;
        do {
          var e = iterator.m();
          // Inline function 'jetbrains.biokb.lang.model.errorCheck.checkForCycleInProcessDefaults.<anonymous>.<anonymous>' call
          var v = e.v39().i2s_1;
          if (compareTo_0(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (iterator.l());
        tmp$ret$0 = minElem;
      }
      var cycleStartNode = tmp$ret$0;
      var tmp;
      if (equals($this$traverseDepthFirst.y8c(), cycleStartNode)) {
        var nodeIndex = $this$traverseDepthFirst.jgn().t($this$traverseDepthFirst.y8c());
        // Inline function 'kotlin.collections.filter' call
        var tmp0_0 = $this$traverseDepthFirst.jgn();
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList_init_$Create$();
        var _iterator__ex2g4s = tmp0_0.k();
        while (_iterator__ex2g4s.l()) {
          var element = _iterator__ex2g4s.m();
          // Inline function 'jetbrains.biokb.lang.model.errorCheck.checkForCycleInProcessDefaults.<anonymous>.<anonymous>' call
          if (drop($this$traverseDepthFirst.jgn(), nodeIndex).s(element)) {
            destination.e(element);
          }
        }
        var cycleNodes = destination;
        $currentCycle.m2();
        $currentCycle.o(cycleNodes);
        $currentCycle.e($this$traverseDepthFirst.y8c());
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function checkForCycleInProcessDefaults$lambda_0($this_checkForCycleInProcessDefaults) {
    return function (it) {
      return $this_checkForCycleInProcessDefaults.n51(it.b3());
    };
  }
  function $runSuspendCOROUTINE$32_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.sgn_1 = _this__u8e3s4;
    this.tgn_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$32_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 16;
            var tmp_0 = this;
            tmp_0.ugn_1 = this.tgn_1;
            this.vgn_1 = Unit_instance;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.wgn_1 = this.ugn_1;
            var tmp_1 = this;
            tmp_1.xgn_1 = ArrayList_init_$Create$();
            this.ygn_1 = this.wgn_1.n51(this.sgn_1.ngo_1.lbb());
            if (this.ygn_1 == null) {
              this.vgn_1 = this.xgn_1;
              this.y9_1 = 15;
              var tmp_2 = this;
              continue $sm;
            } else {
              this.zgn_1 = this.ygn_1;
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.ago_1 = this.zgn_1;
            var tmp_3 = this;
            var tmp_4 = this.ago_1;
            tmp_3.bgo_1 = isInterface(tmp_4, RelationFactExpression_1);
            if (this.bgo_1) {
              this.cgo_1 = true;
              this.y9_1 = 4;
              continue $sm;
            } else {
              this.y9_1 = 3;
              suspendResult = isProcessExpression(this.wgn_1, this.ago_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.cgo_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.bgo_1 = this.cgo_1;
            if (this.bgo_1) {
              this.dgo_1 = true;
              this.y9_1 = 13;
              continue $sm;
            } else {
              var tmp_5 = this.ago_1;
              if (isInterface(tmp_5, SetExpression_1)) {
                var tmp_6 = this;
                var tmp0 = this.wgn_1.n51(this.ago_1.rbs());
                var destination = ArrayList_init_$Create$();
                var _iterator__ex2g4s = tmp0.k();
                while (_iterator__ex2g4s.l()) {
                  var element = _iterator__ex2g4s.m();
                  if (!(element == null) ? isInterface(element, FactExpression) : false) {
                    destination.e(element);
                  }
                }
                tmp_6.fgo_1 = destination;
                this.y9_1 = 5;
                continue $sm;
              } else {
                this.ego_1 = false;
                this.y9_1 = 12;
                continue $sm;
              }
            }

          case 5:
            this.hgo_1 = this.fgo_1;
            var tmp_7;
            var tmp_8 = this.hgo_1;
            if (isInterface(tmp_8, Collection)) {
              tmp_7 = this.hgo_1.p();
            } else {
              tmp_7 = false;
            }

            if (tmp_7) {
              this.ggo_1 = true;
              this.y9_1 = 11;
              continue $sm;
            } else {
              this.y9_1 = 6;
              continue $sm;
            }

          case 6:
            this.igo_1 = this.hgo_1.k();
            this.y9_1 = 7;
            continue $sm;
          case 7:
            if (!this.igo_1.l()) {
              this.y9_1 = 10;
              continue $sm;
            }

            this.jgo_1 = this.igo_1.m();
            var tmp_9 = this;
            tmp_9.kgo_1 = this.jgo_1;
            this.lgo_1 = this.kgo_1;
            this.y9_1 = 8;
            suspendResult = isProcessExpression(this.wgn_1, this.lgo_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.mgo_1 = suspendResult;
            if (!this.mgo_1) {
              this.ggo_1 = false;
              this.y9_1 = 11;
              continue $sm;
            } else {
              this.y9_1 = 9;
              continue $sm;
            }

          case 9:
            this.y9_1 = 7;
            continue $sm;
          case 10:
            this.ggo_1 = true;
            if (false) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.y9_1 = 11;
            continue $sm;
          case 11:
            this.ego_1 = this.ggo_1;
            this.y9_1 = 12;
            continue $sm;
          case 12:
            this.dgo_1 = this.ego_1;
            this.y9_1 = 13;
            continue $sm;
          case 13:
            this.bgo_1 = this.dgo_1;
            if (!this.bgo_1) {
              this.xgn_1.e(new ErrorForAllNode('Fact should be either relation or process', this.ago_1));
            }

            this.y9_1 = 14;
            suspendResult = checkProcessRelation(this.wgn_1, this.ago_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 14:
            var tmp1_safe_receiver = suspendResult;
            if (tmp1_safe_receiver == null)
              null;
            else {
              this.xgn_1.e(tmp1_safe_receiver);
            }

            this.vgn_1 = this.xgn_1;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 15;
            continue $sm;
          case 15:
            return this.vgn_1;
          case 16:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 16) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function checkNewFact$$inlined$suspendingQuery$1($fact) {
    this.ngo_1 = $fact;
  }
  protoOf(checkNewFact$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$32_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(checkNewFact$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function $runSuspendCOROUTINE$33(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wgo_1 = _this__u8e3s4;
    this.xgo_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$33).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.ygo_1 = this.xgo_1;
            this.zgo_1 = this.ygo_1;
            this.agp_1 = ontologyElementHierarchy();
            var tmp_1 = this;
            tmp_1.bgp_1 = ArrayList_init_$Create$();
            this.y9_1 = 1;
            suspendResult = this.zgo_1.m51(isNatural(this.agp_1, this.wgo_1.dgp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              var tmp_2 = this;
              var tmp0_safe_receiver = this.zgo_1.n51(this.wgo_1.dgp_1.mbu());
              var tmp_3;
              if (tmp0_safe_receiver == null) {
                tmp_3 = null;
              } else {
                tmp_3 = this.bgp_1.e(new ErrorForAllNode('Empty definition is not supported. Element will be treated as natural', tmp0_safe_receiver));
              }
              tmp_2.cgp_1 = tmp_3;
              this.y9_1 = 2;
              continue $sm;
            } else {
              var tmp_4 = this;
              if (!this.zgo_1.n51(this.wgo_1.dgp_1.gbu()).p()) {
                this.bgp_1.e(new ErrorForAllNode('Both definition and super-type is not currently supported', this.wgo_1.dgp_1));
              }
              if (!(this.zgo_1.n51(this.wgo_1.dgp_1.ibu()) == null)) {
                this.bgp_1.e(new ErrorForAllNode('Both definition and onlyInTaxon is not currently supported', this.wgo_1.dgp_1));
              }
              tmp_4.cgp_1 = Unit_instance;
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            return this.bgp_1;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function checkOntologyElement$$inlined$suspendingQuery$1($element) {
    this.dgp_1 = $element;
  }
  protoOf(checkOntologyElement$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$33(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(checkOntologyElement$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function checkOntologyElementDefinition$$inlined$suspendingQuery$1($definition) {
    this.egp_1 = $definition;
  }
  protoOf(checkOntologyElementDefinition$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.checkOntologyElementDefinition.<anonymous>' call
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.checkOntologyElementDefinition.<anonymous>.<anonymous>' call
    var classExpression = builder.n51(this.egp_1.yay());
    var tmp;
    var tmp_0;
    if (!(classExpression == null)) {
      tmp_0 = !(!(classExpression == null) ? isInterface(classExpression, UnionClass_1) : false);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = builder.n51(this.egp_1.dbc()).p();
    } else {
      tmp = false;
    }
    if (tmp) {
      this_0.e(new ErrorForAllNode('Non-union definition should include constraints', this.egp_1));
    }
    return this_0.e4();
  };
  protoOf(checkOntologyElementDefinition$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function checkProcessRelationDeclaration$$inlined$suspendingQuery$1($relation) {
    this.fgp_1 = $relation;
  }
  protoOf(checkProcessRelationDeclaration$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.checkProcessRelationDeclaration.<anonymous>' call
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.checkProcessRelationDeclaration.<anonymous>.<anonymous>' call
    if (builder.n51(this.fgp_1.kcc()) == null) {
      this_0.e(new ErrorForAllNode('direction is missing', this.fgp_1));
    }
    if (builder.n51(this.fgp_1.lcc()) == null) {
      this_0.e(new ErrorForAllNode('effect is missing', this.fgp_1));
    }
    return this_0.e4();
  };
  protoOf(checkProcessRelationDeclaration$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function duplicates$$inlined$query$1($this_duplicates) {
    this.ggp_1 = $this_duplicates;
  }
  protoOf(duplicates$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.duplicates.<anonymous>' call
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = builder.n51(this.ggp_1);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.biokb.lang.model.errorCheck.duplicates.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = builder.n51(element.b3());
      if (!isBlank(this_0)) {
        destination.e(element);
      }
    }
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var destination_0 = LinkedHashMap_init_$Create$();
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var element_0 = _iterator__ex2g4s_0.m();
      // Inline function 'jetbrains.biokb.lang.model.errorCheck.duplicates.<anonymous>.<anonymous>' call
      var key = builder.n51(element_0.b3());
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination_0.y2(key);
      var tmp;
      if (value == null) {
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        var answer = ArrayList_init_$Create$();
        destination_0.r2(key, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      var list = tmp;
      list.e(element_0);
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(destination_0.n());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_1 = destination_0.w().k();
    while (_iterator__ex2g4s_1.l()) {
      var item = _iterator__ex2g4s_1.m();
      // Inline function 'jetbrains.biokb.lang.model.errorCheck.duplicates.<anonymous>.<anonymous>' call
      var tmp$ret$10 = item.y();
      destination_1.e(tmp$ret$10);
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_2 = destination_1.k();
    while (_iterator__ex2g4s_2.l()) {
      var element_1 = _iterator__ex2g4s_2.m();
      // Inline function 'jetbrains.biokb.lang.model.errorCheck.duplicates.<anonymous>.<anonymous>' call
      if (element_1.n() > 1) {
        destination_2.e(element_1);
      }
    }
    var duplicates = destination_2;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(duplicates, 10));
    var _iterator__ex2g4s_3 = duplicates.k();
    while (_iterator__ex2g4s_3.l()) {
      var item_0 = _iterator__ex2g4s_3.m();
      // Inline function 'jetbrains.biokb.lang.model.errorCheck.duplicates.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$16 = copyToArray(item_0);
      var tmp$ret$17 = new ErrorForDescendants('duplicate names', tmp$ret$16.slice());
      destination_3.e(tmp$ret$17);
    }
    return destination_3;
  };
  function $checkForCycleInVariableSpecsCOROUTINE$20(_this__u8e3s4, variables, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.egf_1 = _this__u8e3s4;
    this.fgf_1 = variables;
  }
  protoOf($checkForCycleInVariableSpecsCOROUTINE$20).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 18;
            var tmp_0 = this;
            tmp_0.ggf_1 = LinkedHashSet_init_$Create$();
            var tmp_1 = this;
            tmp_1.hgf_1 = ArrayList_init_$Create$();
            this.igf_1 = this.fgf_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.igf_1.l()) {
              this.y9_1 = 17;
              continue $sm;
            }

            this.jgf_1 = this.igf_1.m();
            var tmp_2 = this;
            tmp_2.kgf_1 = this.jgf_1;
            var tmp_3 = this;
            tmp_3.lgf_1 = checkForCycleInVariableSpecs$lambda(this.hgf_1, this.ggf_1);
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.ngf_1 = this.kgf_1;
            this.ogf_1 = this.lgf_1;
            this.pgf_1 = new PreProcessNodeFrame(this.ngf_1, null);
            this.qgf_1 = HashSet_init_$Create$();
            this.y9_1 = 3;
            continue $sm;
          case 3:
            if (!!(this.pgf_1 == null)) {
              this.y9_1 = 15;
              continue $sm;
            }

            this.rgf_1 = new TraversalContext(this.pgf_1);
            this.sgf_1 = this.pgf_1;
            var tmp_4 = this.sgf_1;
            if (tmp_4 instanceof PreProcessNodeFrame) {
              if (this.qgf_1.s(this.rgf_1.y8c())) {
                var tmp_5 = this;
                if (!isNoop(this.ogf_1) && this.rgf_1.jgp(this.rgf_1.y8c())) {
                  this.ogf_1(this.rgf_1);
                }
                tmp_5.ugf_1 = this.pgf_1.igp_1;
                this.y9_1 = 12;
                continue $sm;
              } else {
                var $this$traverseDepthFirst = this.rgf_1;
                if (this.hgf_1.e($this$traverseDepthFirst.y8c())) {
                  var tmp0 = this.qgf_1;
                  var element = this.rgf_1.y8c();
                  tmp0.e(element);
                  var tmp_6 = this;
                  tmp_6.wgf_1 = this.rgf_1.y8c();
                  this.xgf_1 = this.wgf_1;
                  this.ygf_1 = this.egf_1.n51(this.xgf_1.jcq());
                  var tmp_7 = this.ygf_1;
                  if (!(tmp_7 == null) ? isInterface(tmp_7, VariableReferenceValue_1) : false) {
                    this.y9_1 = 7;
                    suspendResult = this.egf_1.m51(this.ygf_1.xcq(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    var tmp_8 = this.ygf_1;
                    if (!(tmp_8 == null) ? isInterface(tmp_8, OneOf_1) : false) {
                      var tmp_9 = this;
                      var tmp0_0 = this.egf_1.n51(this.ygf_1.rbs());
                      var destination = ArrayList_init_$Create$();
                      var _iterator__ex2g4s = tmp0_0.k();
                      while (_iterator__ex2g4s.l()) {
                        var element_0 = _iterator__ex2g4s.m();
                        if (!(element_0 == null) ? isInterface(element_0, VariableReferenceValue_1) : false) {
                          destination.e(element_0);
                        }
                      }
                      tmp_9.bgg_1 = destination;
                      this.cgg_1 = this.bgg_1;
                      var tmp_10 = this;
                      tmp_10.dgg_1 = this.cgg_1;
                      var tmp_11 = this;
                      tmp_11.egg_1 = ArrayList_init_$Create$();
                      this.fgg_1 = this.dgg_1;
                      this.ggg_1 = this.egg_1;
                      var tmp_12 = this;
                      tmp_12.hgg_1 = this.fgg_1;
                      this.igg_1 = this.hgg_1;
                      this.jgg_1 = this.igg_1.k();
                      this.y9_1 = 4;
                      continue $sm;
                    } else {
                      this.zgf_1 = emptyList();
                      this.y9_1 = 10;
                      continue $sm;
                    }
                  }
                } else {
                  var tmp_13 = this;
                  tmp_13.vgf_1 = emptyList();
                  this.y9_1 = 11;
                  continue $sm;
                }
              }
            } else {
              var tmp_14 = this.sgf_1;
              if (tmp_14 instanceof PostProcessChildNodeFrame) {
                this.tgf_1 = createNextChildProcessingFrame(this.pgf_1);
                this.y9_1 = 13;
                continue $sm;
              } else {
                var tmp_15 = this.sgf_1;
                if (tmp_15 instanceof PostProcessNodeFrame) {
                  var tmp_16 = this;
                  this.rgf_1;
                  tmp_16.tgf_1 = this.pgf_1.igp_1;
                  this.y9_1 = 13;
                  continue $sm;
                } else {
                  var tmp_17 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 4:
            if (!this.jgg_1.l()) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.kgg_1 = this.jgg_1.m();
            var tmp_18 = this;
            tmp_18.lgg_1 = this.kgg_1;
            this.mgg_1 = this.lgg_1;
            var tmp_19 = this;
            tmp_19.ngg_1 = this.mgg_1;
            this.ogg_1 = this.ngg_1;
            this.y9_1 = 5;
            suspendResult = this.egf_1.m51(this.ogg_1.xcq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.pgg_1 = suspendResult;
            if (this.pgg_1 == null)
              null;
            else {
              var it = this.pgg_1;
              this.ggg_1.e(it);
            }

            this.y9_1 = 4;
            continue $sm;
          case 6:
            this.qgg_1 = this.ggg_1;
            var tmp_20 = this;
            var this_0 = this.qgg_1;
            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s_0 = this_0.k();
            while (_iterator__ex2g4s_0.l()) {
              var item = _iterator__ex2g4s_0.m();
              destination_0.e(to(item, Unit_instance));
            }

            tmp_20.zgf_1 = destination_0;
            this.y9_1 = 10;
            continue $sm;
          case 7:
            this.rgg_1 = suspendResult;
            this.sgg_1 = this.rgg_1 == null;
            if (!this.sgg_1) {
              this.y9_1 = 8;
              suspendResult = this.egf_1.m51(this.ygf_1.xcq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.agg_1 = emptyList();
              this.y9_1 = 9;
              continue $sm;
            }

          case 8:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ensureNotNull(ARGUMENT);
            var ARGUMENT_1 = to(ARGUMENT_0, Unit_instance);
            this.agg_1 = listOf(ARGUMENT_1);
            this.y9_1 = 9;
            continue $sm;
          case 9:
            this.zgf_1 = this.agg_1;
            this.y9_1 = 10;
            continue $sm;
          case 10:
            this.vgf_1 = this.zgf_1;
            this.y9_1 = 11;
            continue $sm;
          case 11:
            var edges = this.vgf_1;
            this.ugf_1 = createChildProcessingFrame(this.pgf_1, edges.k());
            this.y9_1 = 12;
            continue $sm;
          case 12:
            this.tgf_1 = this.ugf_1;
            this.y9_1 = 13;
            continue $sm;
          case 13:
            this.pgf_1 = this.tgf_1;
            if (this.rgf_1.kgp()) {
              this.mgf_1 = null;
              this.y9_1 = 16;
              continue $sm;
            } else {
              this.y9_1 = 14;
              continue $sm;
            }

          case 14:
            this.y9_1 = 3;
            continue $sm;
          case 15:
            this.mgf_1 = this.qgf_1;
            if (false) {
              this.y9_1 = 2;
              continue $sm;
            }

            this.y9_1 = 16;
            continue $sm;
          case 16:
            this.y9_1 = 1;
            continue $sm;
          case 17:
            var tmp_21;
            if (this.ggf_1.p()) {
              tmp_21 = emptyList();
            } else {
              var this_1 = this.ggf_1;
              tmp_21 = listOf(new ErrorForDescendants('Variables form a cycle with the initializers', copyToArray(this_1).slice()));
            }

            return tmp_21;
          case 18:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 18) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $checkForDuplicatePropertiesInConstraintsCOROUTINE$21(_this__u8e3s4, constraints, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bgh_1 = _this__u8e3s4;
    this.cgh_1 = constraints;
  }
  protoOf($checkForDuplicatePropertiesInConstraintsCOROUTINE$21).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            var tmp_0 = this;
            tmp_0.dgh_1 = HashMap_init_$Create$();
            this.egh_1 = this.bgh_1.n51(this.cgh_1).k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.egh_1.l()) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.fgh_1 = this.egh_1.m();
            if (!(this.bgh_1.n51(this.fgh_1.u3l()) == null)) {
              this.y9_1 = 1;
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.y9_1 = 3;
            suspendResult = this.bgh_1.m51(this.fgh_1.i6u(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp0_elvis_lhs = suspendResult;
            var WHEN_RESULT;
            if (tmp0_elvis_lhs == null) {
              this.y9_1 = 1;
              continue $sm;
            } else {
              WHEN_RESULT = tmp0_elvis_lhs;
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            var property = WHEN_RESULT;
            var tmp_1 = this.bgh_1.n51(property.be());
            if (!(tmp_1 == null) ? isInterface(tmp_1, MultiplePropertyValueRange_1) : false) {
              this.y9_1 = 1;
              continue $sm;
            } else {
              this.y9_1 = 5;
              continue $sm;
            }

          case 5:
            var tmp0 = this.dgh_1;
            var key = property;
            var value = tmp0.y2(key);
            var tmp_2;
            if (value == null) {
              var answer = ArrayList_init_$Create$();
              tmp0.r2(key, answer);
              tmp_2 = answer;
            } else {
              tmp_2 = value;
            }

            tmp_2.e(this.fgh_1);
            this.y9_1 = 1;
            continue $sm;
          case 6:
            var tmp0_0 = this.dgh_1.v2();
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0_0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              if (element.n() > 1) {
                destination.e(element);
              }
            }

            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
            var _iterator__ex2g4s_0 = destination.k();
            while (_iterator__ex2g4s_0.l()) {
              var item = _iterator__ex2g4s_0.m();
              destination_0.e(new ErrorForDescendants('Multiple constraints reference the same property', copyToArray(item).slice()));
            }

            return destination_0;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $checkForCycleInProcessDefaultsCOROUTINE$22(_this__u8e3s4, processDeclaration, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ogh_1 = _this__u8e3s4;
    this.pgh_1 = processDeclaration;
  }
  protoOf($checkForCycleInProcessDefaultsCOROUTINE$22).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 14;
            var tmp_0 = this;
            tmp_0.qgh_1 = ArrayList_init_$Create$();
            var tmp_1 = this;
            tmp_1.rgh_1 = LinkedHashSet_init_$Create$();
            this.sgh_1 = this.ogh_1.n51(this.pgh_1.pas()).k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.sgh_1.l()) {
              this.y9_1 = 13;
              continue $sm;
            }

            this.tgh_1 = this.sgh_1.m();
            if (this.rgh_1.s(this.tgh_1)) {
              this.y9_1 = 1;
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            var tmp_2 = this;
            tmp_2.ugh_1 = ArrayList_init_$Create$();
            var tmp_3 = this;
            tmp_3.vgh_1 = this.tgh_1;
            var tmp_4 = this;
            tmp_4.wgh_1 = checkForCycleInProcessDefaults$lambda(this.ugh_1);
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.ygh_1 = this.vgh_1;
            this.zgh_1 = this.wgh_1;
            this.agi_1 = new PreProcessNodeFrame(this.ygh_1, null);
            this.bgi_1 = HashSet_init_$Create$();
            this.y9_1 = 4;
            continue $sm;
          case 4:
            if (!!(this.agi_1 == null)) {
              this.y9_1 = 11;
              continue $sm;
            }

            this.cgi_1 = new TraversalContext(this.agi_1);
            this.dgi_1 = this.agi_1;
            var tmp_5 = this.dgi_1;
            if (tmp_5 instanceof PreProcessNodeFrame) {
              if (this.bgi_1.s(this.cgi_1.y8c())) {
                var tmp_6 = this;
                if (!isNoop(this.zgh_1) && this.cgi_1.jgp(this.cgi_1.y8c())) {
                  this.zgh_1(this.cgi_1);
                }
                tmp_6.fgi_1 = this.agi_1.igp_1;
                this.y9_1 = 8;
                continue $sm;
              } else {
                this.cgi_1;
                var tmp0 = this.bgi_1;
                var element = this.cgi_1.y8c();
                tmp0.e(element);
                var tmp_7 = this;
                tmp_7.hgi_1 = this.cgi_1.y8c();
                this.igi_1 = this.hgi_1;
                var tmp_8 = this;
                var tmp0_safe_receiver = this.ogh_1.n51(this.igi_1.g2o());
                var tmp_9 = tmp0_safe_receiver == null ? null : this.ogh_1.n51(tmp0_safe_receiver.y());
                tmp_8.jgi_1 = (!(tmp_9 == null) ? isInterface(tmp_9, ProcessPropertyReference) : false) ? tmp_9 : null;
                this.kgi_1 = this.jgi_1;
                if (this.kgi_1 == null) {
                  this.lgi_1 = null;
                  this.y9_1 = 6;
                  continue $sm;
                } else {
                  this.y9_1 = 5;
                  suspendResult = this.ogh_1.m51(this.kgi_1.i6u(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              }
            } else {
              var tmp_10 = this.dgi_1;
              if (tmp_10 instanceof PostProcessChildNodeFrame) {
                this.egi_1 = createNextChildProcessingFrame(this.agi_1);
                this.y9_1 = 9;
                continue $sm;
              } else {
                var tmp_11 = this.dgi_1;
                if (tmp_11 instanceof PostProcessNodeFrame) {
                  var tmp_12 = this;
                  this.cgi_1;
                  tmp_12.egi_1 = this.agi_1.igp_1;
                  this.y9_1 = 9;
                  continue $sm;
                } else {
                  var tmp_13 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 5:
            this.lgi_1 = suspendResult;
            this.y9_1 = 6;
            continue $sm;
          case 6:
            var nextProperty = this.lgi_1;
            var tmp_14 = this;
            var tmp_15;
            if (!(nextProperty == null)) {
              tmp_15 = listOf(to(nextProperty, Unit_instance));
            } else {
              tmp_15 = emptyList();
            }

            tmp_14.ggi_1 = tmp_15;
            this.y9_1 = 7;
            continue $sm;
          case 7:
            var edges = this.ggi_1;
            this.fgi_1 = createChildProcessingFrame(this.agi_1, edges.k());
            this.y9_1 = 8;
            continue $sm;
          case 8:
            this.egi_1 = this.fgi_1;
            this.y9_1 = 9;
            continue $sm;
          case 9:
            this.agi_1 = this.egi_1;
            if (this.cgi_1.kgp()) {
              this.xgh_1 = null;
              this.y9_1 = 12;
              continue $sm;
            } else {
              this.y9_1 = 10;
              continue $sm;
            }

          case 10:
            this.y9_1 = 4;
            continue $sm;
          case 11:
            this.xgh_1 = this.bgi_1;
            if (false) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.y9_1 = 12;
            continue $sm;
          case 12:
            if (!this.ugh_1.p()) {
              this.qgh_1.e(toList_0(this.ugh_1));
              this.rgh_1.o(this.ugh_1);
            }

            this.y9_1 = 1;
            continue $sm;
          case 13:
            var this_0 = this.qgh_1;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.k();
            while (_iterator__ex2g4s.l()) {
              var item = _iterator__ex2g4s.m();
              var cyclePath = joinToString_0(item, ' -> ', VOID, VOID, VOID, VOID, checkForCycleInProcessDefaults$lambda_0(this.ogh_1));
              var errorMessage = 'Cycle detected in default value references: ' + cyclePath;
              destination.e(new ErrorForDescendants(errorMessage, copyToArray(item).slice()));
            }

            return destination;
          case 14:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 14) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $isProcessExpressionCOROUTINE$23(_this__u8e3s4, expression, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ugi_1 = _this__u8e3s4;
    this.vgi_1 = expression;
  }
  protoOf($isProcessExpressionCOROUTINE$23).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.wgi_1 = this.ugi_1;
            this.xgi_1 = this.wgi_1;
            var tmp_1 = this;
            tmp_1.ygi_1 = this.xgi_1;
            this.zgi_1 = this.ygi_1;
            var tmp_2 = this.vgi_1;
            if (isInterface(tmp_2, LibraryProcessSpecification_1)) {
              this.agj_1 = true;
              this.y9_1 = 4;
              continue $sm;
            } else {
              var tmp_3 = this.vgi_1;
              if (isInterface(tmp_3, VariableReferenceValue_1)) {
                this.y9_1 = 1;
                suspendResult = this.zgi_1.m51(this.vgi_1.xcq(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.bgj_1 = false;
                this.y9_1 = 2;
                continue $sm;
              }
            }

          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp_4 = this;
            var tmp_5 = tmp0_safe_receiver == null ? null : this.zgi_1.n51(tmp0_safe_receiver.jcq());
            tmp_4.bgj_1 = !(tmp_5 == null) ? isInterface(tmp_5, ProcessType_1) : false;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.agj_1 = this.bgj_1;
            this.y9_1 = 4;
            continue $sm;
          case 3:
            throw this.ba_1;
          case 4:
            return this.agj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $checkProcessRelationCOROUTINE$24(_this__u8e3s4, expression, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kgj_1 = _this__u8e3s4;
    this.lgj_1 = expression;
  }
  protoOf($checkProcessRelationCOROUTINE$24).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this.lgj_1;
            if (!isInterface(tmp_0, RelationFactExpression_1)) {
              return null;
            }

            this.y9_1 = 1;
            suspendResult = this.kgj_1.m51(this.lgj_1.gb6(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var relation = suspendResult;
            var tmp_1;
            if (!(relation == null) && !this.kgj_1.n51(relation.gde())) {
              tmp_1 = new ErrorForDescendants('The relation being used here has an incomplete declaration', [this.lgj_1]);
            } else {
              tmp_1 = null;
            }

            return tmp_1;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function checkOntology(ontology, isRootOntology) {
    return (new OntologyProcessor(ontology)).tgp(isRootOntology);
  }
  function $runSuspendCOROUTINE$35_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cgq_1 = _this__u8e3s4;
    this.dgq_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$35_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            var tmp_0 = this;
            tmp_0.egq_1 = this.dgq_1;
            this.fgq_1 = this.egq_1;
            var tmp_1 = this;
            tmp_1.ggq_1 = this.fgq_1.n51(this.cgq_1.pgq_1.lgp_1.sc0());
            this.hgq_1 = this.ggq_1;
            this.igq_1 = this.hgq_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.igq_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.jgq_1 = this.igq_1.m();
            var tmp_2 = this;
            tmp_2.kgq_1 = this.jgq_1;
            this.lgq_1 = this.kgq_1;
            this.y9_1 = 2;
            suspendResult = this.fgq_1.m51(process$default(this.cgq_1.pgq_1, this.lgq_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.y9_1 = 1;
            continue $sm;
          case 3:
            var tmp_3 = this;
            var this_0 = this.cgq_1.pgq_1.ngp_1;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.k();
            while (_iterator__ex2g4s.l()) {
              var item = _iterator__ex2g4s.m();
              destination.e(new ErrorForAllNode('Cycle in super elements', item));
            }

            tmp_3.mgq_1 = destination;
            this.ngq_1 = this.cgq_1.qgq_1;
            if (this.ngq_1 === true) {
              var tmp_4 = this;
              var this_1 = this.cgq_1.pgq_1.pgp_1.u2();
              var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
              var _iterator__ex2g4s_0 = this_1.k();
              while (_iterator__ex2g4s_0.l()) {
                var item_0 = _iterator__ex2g4s_0.m();
                destination_0.e(new ErrorForAllNode('Meta-ontology elements must not have external super elements', item_0));
              }
              tmp_4.ogq_1 = destination_0;
              this.y9_1 = 5;
              continue $sm;
            } else {
              if (this.ngq_1 === false) {
                this.y9_1 = 4;
                suspendResult = this.fgq_1.m51(errors(this.cgq_1.pgq_1.pgp_1, this.cgq_1.pgq_1), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_5 = this;
                noWhenBranchMatchedException();
              }
            }

            break;
          case 4:
            var ARGUMENT = suspendResult;
            var tmp_6 = this;
            var tmp0 = this.fgq_1.n51(this.cgq_1.pgq_1.lgp_1.sc0());
            var destination_1 = ArrayList_init_$Create$();
            var _iterator__ex2g4s_1 = tmp0.k();
            while (_iterator__ex2g4s_1.l()) {
              var element = _iterator__ex2g4s_1.m();
              if (this.fgq_1.n51(element.nbu()) == null && !this.cgq_1.pgq_1.pgp_1.u2().s(element)) {
                destination_1.e(element);
              }
            }

            var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_1, 10));
            var _iterator__ex2g4s_2 = destination_1.k();
            while (_iterator__ex2g4s_2.l()) {
              var item_1 = _iterator__ex2g4s_2.m();
              destination_2.e(new ErrorForAllNode("No external super element. Cannot decide element's type", item_1));
            }

            tmp_6.ogq_1 = plus_4(ARGUMENT, destination_2);
            this.y9_1 = 5;
            continue $sm;
          case 5:
            var externalErrors = this.ogq_1;
            var this_2 = this.cgq_1.pgq_1.ogp_1;
            var destination_3 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
            var _iterator__ex2g4s_3 = this_2.k();
            while (_iterator__ex2g4s_3.l()) {
              var item_2 = _iterator__ex2g4s_3.m();
              destination_3.e(new ErrorForAllNode('Cycle in definition', item_2));
            }

            var definitionCycleErrors = destination_3;
            return plus_4(plus_4(this.mgq_1, externalErrors), definitionCycleErrors);
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$36(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zgq_1 = _this__u8e3s4;
    this.agr_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$36).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 15;
            var tmp_0 = this;
            tmp_0.bgr_1 = this.agr_1;
            this.cgr_1 = Unit_instance;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.dgr_1 = this.bgr_1;
            if (this.zgq_1.ngr_1.qgp_1.s(this.zgq_1.ogr_1)) {
              this.cgr_1 = Unit_instance;
              this.y9_1 = 14;
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.zgq_1.ngr_1.qgp_1.e(this.zgq_1.ogr_1);
            this.y9_1 = 3;
            suspendResult = this.dgr_1.m51(isNatural(this.zgq_1.ngr_1.rgp_1, this.zgq_1.ogr_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (suspendResult) {
              var tmp_1 = this;
              var this_0 = this.dgr_1.n51(this.zgq_1.ogr_1.gbu());
              var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
              var _iterator__ex2g4s = this_0.k();
              while (_iterator__ex2g4s.l()) {
                var item = _iterator__ex2g4s.m();
                destination.e(this.dgr_1.n51(item.fc0()));
              }
              tmp_1.egr_1 = destination;
              var tmp_2 = this;
              var tmp0 = this.egr_1;
              var destination_0 = ArrayList_init_$Create$();
              var _iterator__ex2g4s_0 = tmp0.k();
              while (_iterator__ex2g4s_0.l()) {
                var element = _iterator__ex2g4s_0.m();
                if (!(element == null) ? isInterface(element, LocalOntologyElementReference_1) : false) {
                  destination_0.e(element);
                }
              }
              tmp_2.fgr_1 = destination_0;
              var tmp_3 = this;
              var tmp0_0 = this.egr_1;
              var destination_1 = ArrayList_init_$Create$();
              var _iterator__ex2g4s_1 = tmp0_0.k();
              while (_iterator__ex2g4s_1.l()) {
                var element_0 = _iterator__ex2g4s_1.m();
                if (!(element_0 == null) ? isInterface(element_0, QualifiedOntologyElementReference_1) : false) {
                  destination_1.e(element_0);
                }
              }
              tmp_3.ggr_1 = destination_1;
              if (!this.ggr_1.p()) {
                var tmp5 = this.zgq_1.ngr_1.pgp_1;
                var key = this.zgq_1.ogr_1;
                var value = tmp5.y2(key);
                var tmp_4;
                if (value == null) {
                  var answer = ArrayList_init_$Create$();
                  tmp5.r2(key, answer);
                  tmp_4 = answer;
                } else {
                  tmp_4 = value;
                }
                tmp_4.o(this.ggr_1);
              }
              this.hgr_1 = this.fgr_1.k();
              this.y9_1 = 6;
              continue $sm;
            } else {
              if (!this.zgq_1.ngr_1.ogp_1.s(this.zgq_1.ogr_1)) {
                this.y9_1 = 4;
                suspendResult = this.dgr_1.m51(this.zgq_1.ngr_1.rgp_1.vgr(toAdapter_0(this.zgq_1.ogr_1)), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.y9_1 = 5;
                continue $sm;
              }
            }

          case 4:
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.y9_1 = 13;
            continue $sm;
          case 6:
            if (!this.hgr_1.l()) {
              this.y9_1 = 12;
              continue $sm;
            }

            this.igr_1 = this.hgr_1.m();
            this.y9_1 = 7;
            suspendResult = this.dgr_1.m51(_get_resolve__tijxk5(this.igr_1, this.zgq_1.ngr_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.jgr_1 = suspendResult;
            if (this.jgr_1 == null) {
              this.y9_1 = 6;
              var tmp_5 = this;
              continue $sm;
            } else {
              this.kgr_1 = this.jgr_1;
              this.y9_1 = 8;
              continue $sm;
            }

          case 8:
            this.lgr_1 = this.kgr_1;
            if (this.lgr_1 === this.zgq_1.ogr_1) {
              this.zgq_1.ngr_1.ngp_1.e(this.zgq_1.ogr_1);
              this.y9_1 = 6;
              continue $sm;
            } else {
              this.y9_1 = 9;
              continue $sm;
            }

          case 9:
            if (this.zgq_1.pgr_1.s(this.lgr_1)) {
              this.mgr_1 = this.zgq_1.pgr_1.t(this.lgr_1);
              this.zgq_1.ngr_1.ngp_1.o(plus_4(listOf(this.zgq_1.ogr_1), this.zgq_1.pgr_1.j2(this.mgr_1, this.zgq_1.pgr_1.n())));
              this.y9_1 = 6;
              continue $sm;
            } else {
              this.y9_1 = 10;
              continue $sm;
            }

          case 10:
            this.y9_1 = 11;
            suspendResult = this.dgr_1.m51(process_0(this.zgq_1.ngr_1, this.lgr_1, plus_4(this.zgq_1.pgr_1, listOf(this.zgq_1.ogr_1))), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            if (this.zgq_1.ngr_1.pgp_1.u2().s(this.lgr_1)) {
              var tmp7 = this.zgq_1.ngr_1.pgp_1;
              var key_0 = this.zgq_1.ogr_1;
              var value_0 = tmp7.y2(key_0);
              var tmp_6;
              if (value_0 == null) {
                var answer_0 = ArrayList_init_$Create$();
                tmp7.r2(key_0, answer_0);
                tmp_6 = answer_0;
              } else {
                tmp_6 = value_0;
              }
              tmp_6.o(ensureNotNull(this.zgq_1.ngr_1.pgp_1.y2(this.lgr_1)));
            }

            this.y9_1 = 6;
            continue $sm;
          case 12:
            this.y9_1 = 13;
            continue $sm;
          case 13:
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 14;
            continue $sm;
          case 14:
            return this.cgr_1;
          case 15:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 15) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$37_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.egs_1 = _this__u8e3s4;
    this.fgs_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$37_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.ggs_1 = this.fgs_1;
            this.hgs_1 = this.ggs_1;
            this.y9_1 = 1;
            suspendResult = this.hgs_1.m51(resolved(this.egs_1.jgs_1, this.egs_1.igs_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            var result = LinkedHashMap_init_$Create$();
            var _iterator__ex2g4s = this_0.w().k();
            while (_iterator__ex2g4s.l()) {
              var entry = _iterator__ex2g4s.m();
              if (entry.y().lgs_1.n() > 1) {
                result.r2(entry.x(), entry.y());
              }
            }

            var destination = ArrayList_init_$Create$_0(result.n());
            var _iterator__ex2g4s_0 = result.w().k();
            while (_iterator__ex2g4s_0.l()) {
              var item = _iterator__ex2g4s_0.m();
              var resolveResult = item.y();
              var this_1 = resolveResult.kgs_1;
              destination.e(new ErrorForDescendants("More than one external super element. Cannot decide element's type.", copyToArray(this_1).slice()));
            }

            return destination;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$38(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ugs_1 = _this__u8e3s4;
    this.vgs_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$38).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            var tmp_0 = this;
            tmp_0.wgs_1 = this.vgs_1;
            this.xgs_1 = this.wgs_1;
            var tmp_1 = this;
            tmp_1.ygs_1 = this.ugs_1.egu_1;
            this.zgs_1 = this.ygs_1;
            var tmp_2 = this;
            tmp_2.agt_1 = this.zgs_1;
            var tmp_3 = this;
            tmp_3.bgt_1 = LinkedHashMap_init_$Create$_0(mapCapacity(this.zgs_1.n()));
            this.cgt_1 = this.agt_1;
            this.dgt_1 = this.bgt_1;
            var tmp_4 = this;
            tmp_4.egt_1 = this.cgt_1.w();
            var tmp_5 = this;
            tmp_5.fgt_1 = this.dgt_1;
            this.ggt_1 = this.egt_1;
            this.hgt_1 = this.fgt_1;
            this.igt_1 = this.ggt_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.igt_1.l()) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.jgt_1 = this.igt_1.m();
            var tmp_6 = this;
            tmp_6.kgt_1 = this.jgt_1.x();
            var tmp_7 = this;
            tmp_7.lgt_1 = this.jgt_1;
            this.mgt_1 = this.lgt_1;
            var tmp_8 = this;
            tmp_8.ngt_1 = this.mgt_1.y();
            var tmp_9 = this;
            tmp_9.ogt_1 = this.ngt_1;
            this.pgt_1 = this.ogt_1;
            var tmp_10 = this;
            tmp_10.qgt_1 = this.pgt_1;
            var tmp_11 = this;
            tmp_11.rgt_1 = ArrayList_init_$Create$();
            this.sgt_1 = this.qgt_1;
            this.tgt_1 = this.rgt_1;
            var tmp_12 = this;
            tmp_12.ugt_1 = this.sgt_1;
            this.vgt_1 = this.ugt_1;
            this.wgt_1 = this.vgt_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.wgt_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.xgt_1 = this.wgt_1.m();
            var tmp_13 = this;
            tmp_13.ygt_1 = this.xgt_1;
            this.zgt_1 = this.ygt_1;
            var tmp_14 = this;
            tmp_14.agu_1 = this.zgt_1;
            this.bgu_1 = this.agu_1;
            var tmp_15 = this;
            var tmp0_safe_receiver = this.xgs_1.n51(this.bgu_1.mcj());
            tmp_15.cgu_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lay();
            if (this.cgu_1 == null) {
              this.dgu_1 = null;
              this.y9_1 = 4;
              continue $sm;
            } else {
              this.y9_1 = 3;
              suspendResult = this.xgs_1.m51(this.cgu_1.o6s(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.dgu_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            var tmp0_safe_receiver_0 = this.dgu_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              this.tgt_1.e(tmp0_safe_receiver_0);
            }

            this.y9_1 = 2;
            continue $sm;
          case 5:
            var this_0 = this.tgt_1;
            var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
            var destination = LinkedHashMap_init_$Create$_0(capacity);
            var _iterator__ex2g4s = this_0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              destination.r2(get_stringId(element), element);
            }

            var externalElements = destination;
            var ARGUMENT = new ExternalResolveResult(this.ngt_1, externalElements.v2());
            this.hgt_1.r2(this.kgt_1, ARGUMENT);
            this.y9_1 = 1;
            continue $sm;
          case 6:
            return this.hgt_1;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$39(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ngu_1 = _this__u8e3s4;
    this.ogu_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$39).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.pgu_1 = this.ogu_1;
            this.qgu_1 = this.pgu_1;
            this.y9_1 = 1;
            suspendResult = this.qgu_1.m51(this.ngu_1.rgu_1.lay().o6s(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function process_0($this, element, superPath) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyProcessor$process$$inlined$suspendingQuery$1($this, element, superPath);
  }
  function process$default($this, element, superPath, $super) {
    superPath = superPath === VOID ? emptyList() : superPath;
    return process_0($this, element, superPath);
  }
  function errors(_this__u8e3s4, $this) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyProcessor$errors$$inlined$suspendingQuery$1($this, _this__u8e3s4);
  }
  function resolved(_this__u8e3s4, $this) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyProcessor$resolved$$inlined$suspendingQuery$1(_this__u8e3s4);
  }
  function ExternalResolveResult(qualifiedRefs, resolvedExternal) {
    this.kgs_1 = qualifiedRefs;
    this.lgs_1 = resolvedExternal;
  }
  protoOf(ExternalResolveResult).toString = function () {
    return 'ExternalResolveResult(qualifiedRefs=' + toString_1(this.kgs_1) + ', resolvedExternal=' + toString_1(this.lgs_1) + ')';
  };
  protoOf(ExternalResolveResult).hashCode = function () {
    var result = hashCode(this.kgs_1);
    result = imul(result, 31) + hashCode(this.lgs_1) | 0;
    return result;
  };
  protoOf(ExternalResolveResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ExternalResolveResult))
      return false;
    var tmp0_other_with_cast = other instanceof ExternalResolveResult ? other : THROW_CCE();
    if (!equals(this.kgs_1, tmp0_other_with_cast.kgs_1))
      return false;
    if (!equals(this.lgs_1, tmp0_other_with_cast.lgs_1))
      return false;
    return true;
  };
  function prepareResolve($this) {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = $this.lgp_1.sc0().n4z();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.biokb.lang.model.errorCheck.OntologyProcessor.prepareResolve.<anonymous>' call
      var tmp$ret$0 = new LocalReferenceContent(element.v39());
      destination.r2(tmp$ret$0, element);
    }
    return destination;
  }
  function _get_resolve__tijxk5(_this__u8e3s4, $this) {
    var tmp;
    switch ($this.mgp_1) {
      case true:
        // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call

        tmp = new OntologyProcessor$resolve$$inlined$suspendingQuery$1($this, _this__u8e3s4);
        break;
      case false:
        // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call

        tmp = new OntologyProcessor$resolve$$inlined$suspendingQuery$2(_this__u8e3s4);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function OntologyProcessor$ontologyHierarchy$lambda(this$0) {
    return function (path) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(path, 10));
      var _iterator__ex2g4s = path.k();
      while (_iterator__ex2g4s.l()) {
        var item = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.biokb.lang.model.errorCheck.OntologyProcessor.ontologyHierarchy.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item.sgu();
        destination.e(tmp$ret$0);
      }
      this$0.ogp_1.o(destination);
      return Unit_instance;
    };
  }
  function OntologyProcessor$checkErrors$$inlined$suspendingQuery$1(this$0, $rootOntology) {
    this.pgq_1 = this$0;
    this.qgq_1 = $rootOntology;
  }
  protoOf(OntologyProcessor$checkErrors$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$35_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyProcessor$checkErrors$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyProcessor$process$$inlined$suspendingQuery$1(this$0, $element, $superPath) {
    this.ngr_1 = this$0;
    this.ogr_1 = $element;
    this.pgr_1 = $superPath;
  }
  protoOf(OntologyProcessor$process$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$36(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyProcessor$process$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyProcessor$errors$$inlined$suspendingQuery$1(this$0, $this_errors) {
    this.igs_1 = this$0;
    this.jgs_1 = $this_errors;
  }
  protoOf(OntologyProcessor$errors$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$37_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyProcessor$errors$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyProcessor$resolved$$inlined$suspendingQuery$1($this_resolved) {
    this.egu_1 = $this_resolved;
  }
  protoOf(OntologyProcessor$resolved$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$38(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyProcessor$resolved$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyProcessor$resolve$$inlined$suspendingQuery$1(this$0, $this_resolve) {
    this.tgu_1 = this$0;
    this.ugu_1 = $this_resolve;
  }
  protoOf(OntologyProcessor$resolve$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.biokb.lang.model.errorCheck.OntologyProcessor.<get-resolve>.<anonymous>' call
    var tmp0 = this.tgu_1.sgp_1;
    // Inline function 'kotlin.collections.get' call
    var key = builder.n51(this.ugu_1.lay().r6s());
    return (isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).y2(key);
  };
  protoOf(OntologyProcessor$resolve$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyProcessor$resolve$$inlined$suspendingQuery$2($this_resolve) {
    this.rgu_1 = $this_resolve;
  }
  protoOf(OntologyProcessor$resolve$$inlined$suspendingQuery$2).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$39(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyProcessor$resolve$$inlined$suspendingQuery$2).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyProcessor(ontology) {
    this.lgp_1 = ontology;
    this.mgp_1 = true;
    this.ngp_1 = HashSet_init_$Create$();
    this.ogp_1 = HashSet_init_$Create$();
    this.pgp_1 = HashMap_init_$Create$();
    this.qgp_1 = HashSet_init_$Create$();
    var tmp = this;
    tmp.rgp_1 = new OntologyHierarchyImpl(OntologyProcessor$ontologyHierarchy$lambda(this));
    this.sgp_1 = prepareResolve(this);
  }
  protoOf(OntologyProcessor).tgp = function (rootOntology) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyProcessor$checkErrors$$inlined$suspendingQuery$1(this, rootOntology);
  };
  function OntologyLibraryReference_2(wrapperContext, libraryRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLibraryReferenceConcept_getInstance().e6r_1) : nodeId;
    return OntologyLibraryReference_3(wrapperContext.n4u(Companion_getInstance_94().a6p_1), libraryRef, nodeId);
  }
  function LocalOntologyElementReference_2(wrapperContext, elementRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LocalOntologyElementReferenceConcept_getInstance().e6r_1) : nodeId;
    return LocalOntologyElementReference_3(wrapperContext.n4u(Companion_getInstance_94().a6p_1), elementRef, nodeId);
  }
  function OntologyElementReference_2(wrapperContext, elementRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementReferenceConcept_getInstance().e6r_1) : nodeId;
    return OntologyElementReference_3(wrapperContext.n4u(Companion_getInstance_94().a6p_1), elementRef, nodeId);
  }
  function ConstantPrecondition_1(wrapperContext, kindValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ConstantPreconditionConcept_getInstance().e6r_1) : nodeId;
    return ConstantPrecondition_2(wrapperContext.n4u(Companion_getInstance_94().a6p_1), kindValue, nodeId);
  }
  function FactReference_2(wrapperContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactReferenceConcept_getInstance().e6r_1) : nodeId;
    return FactReference_3(wrapperContext.n4u(Companion_getInstance_94().a6p_1), refValue, nodeId);
  }
  function QueryLabelsFactExpressionContainer_2(wrapperContext, expression, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(QueryLabelsFactExpressionContainerConcept_getInstance().e6r_1) : nodeId;
    return QueryLabelsFactExpressionContainer_3(wrapperContext.n4u(Companion_getInstance_94().a6p_1), expression, nodeId);
  }
  function ProcessPropertyReference_0(wrapperContext, propertyRef, nodeId) {
    propertyRef = propertyRef === VOID ? null : propertyRef;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyReferenceConcept_getInstance().e6r_1) : nodeId;
    return ProcessPropertyReference_1(wrapperContext.n4u(Companion_getInstance_94().a6p_1), propertyRef, nodeId);
  }
  function NewFactReference_1(wrapperContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NewFactReferenceConcept_getInstance().e6r_1) : nodeId;
    return NewFactReference_2(wrapperContext.n4u(Companion_getInstance_94().a6p_1), refValue, nodeId);
  }
  function RelationFactExpression_2(wrapperContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(RelationFactExpressionConcept_getInstance().e6r_1) : nodeId;
    return RelationFactExpression_3(wrapperContext.n4u(Companion_getInstance_94().a6p_1), refValue, nodeId);
  }
  function ModifierFactExpression_1(wrapperContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ModifierFactExpressionConcept_getInstance().e6r_1) : nodeId;
    return ModifierFactExpression_2(wrapperContext.n4u(Companion_getInstance_94().a6p_1), refValue, nodeId);
  }
  function ExtensionFieldReference_2(wrapperContext, ref, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ExtensionFieldReferenceConcept_getInstance().e6r_1) : nodeId;
    return ExtensionFieldReference_3(wrapperContext.n4u(Companion_getInstance_94().a6p_1), ref, nodeId);
  }
  function ProcessPrerequisite_1(wrapperContext, expression, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPrerequisiteConcept_getInstance().e6r_1) : nodeId;
    return ProcessPrerequisite_2(wrapperContext.n4u(Companion_getInstance_94().a6p_1), expression, nodeId);
  }
  function ProcessEffect_1(wrapperContext, expression, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessEffectConcept_getInstance().e6r_1) : nodeId;
    return ProcessEffect_2(wrapperContext.n4u(Companion_getInstance_94().a6p_1), expression, nodeId);
  }
  function SimplePropertyType_0(wrapperContext, notionRef, nodeId) {
    notionRef = notionRef === VOID ? null : notionRef;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(SimplePropertyTypeConcept_getInstance().e6r_1) : nodeId;
    return SimplePropertyType_1(wrapperContext.n4u(Companion_getInstance_94().a6p_1), notionRef, nodeId);
  }
  function InstanceRelationValue_0(wrapperContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(InstanceRelationValueConcept_getInstance().e6r_1) : nodeId;
    return InstanceRelationValue_1(wrapperContext.n4u(Companion_getInstance_94().a6p_1), refValue, nodeId);
  }
  function NotionType_1(wrapperContext, notionRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NotionTypeConcept_getInstance().e6r_1) : nodeId;
    return NotionType_2(wrapperContext.n4u(Companion_getInstance_94().a6p_1), notionRef, nodeId);
  }
  function LibraryProcessSpecification_2(wrapperContext, notionRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LibraryProcessSpecificationConcept_getInstance().e6r_1) : nodeId;
    return LibraryProcessSpecification_3(wrapperContext.n4u(Companion_getInstance_94().a6p_1), notionRef, nodeId);
  }
  function OntologyLibraryReference_3(nodeSetupContext, libraryRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyLibraryReferenceConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = OntologyLibraryReference_0(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.OntologyLibraryReference.<anonymous>' call
    this_0.ub6().v2c(libraryRef);
    return this_0;
  }
  function LocalOntologyElementReference_3(nodeSetupContext, elementRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LocalOntologyElementReferenceConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = LocalOntologyElementReference_0(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.LocalOntologyElementReference.<anonymous>' call
    this_0.lay().v2c(elementRef);
    return this_0;
  }
  function OntologyElementReference_3(nodeSetupContext, elementRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(OntologyElementReferenceConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = OntologyElementReference_0(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.OntologyElementReference.<anonymous>' call
    this_0.lay().v2c(elementRef);
    return this_0;
  }
  function ConstantPrecondition_2(nodeSetupContext, kindValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ConstantPreconditionConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ConstantPrecondition(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.ConstantPrecondition.<anonymous>' call
    this_0.r5e().v2c(kindValue);
    return this_0;
  }
  function FactReference_3(nodeSetupContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(FactReferenceConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = FactReference_0(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.FactReference.<anonymous>' call
    this_0.ub6().v2c(refValue);
    return this_0;
  }
  function QueryLabelsFactExpressionContainer_3(nodeSetupContext, expression, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(QueryLabelsFactExpressionContainerConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = QueryLabelsFactExpressionContainer_0(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.QueryLabelsFactExpressionContainer.<anonymous>' call
    this_0.lbb().v2c(expression);
    return this_0;
  }
  function ProcessPropertyReference_1(nodeSetupContext, propertyRef, nodeId) {
    propertyRef = propertyRef === VOID ? null : propertyRef;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPropertyReferenceConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ProcessPropertyReferenceConcept_getInstance().v6r(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.ProcessPropertyReference.<anonymous>' call
    this_0.i6u().v2c(propertyRef);
    return this_0;
  }
  function NewFactReference_2(nodeSetupContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NewFactReferenceConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = NewFactReference(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.NewFactReference.<anonymous>' call
    this_0.ub6().v2c(refValue);
    return this_0;
  }
  function RelationFactExpression_3(nodeSetupContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(RelationFactExpressionConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = RelationFactExpression_0(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.RelationFactExpression.<anonymous>' call
    this_0.gb6().v2c(refValue);
    return this_0;
  }
  function ModifierFactExpression_2(nodeSetupContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ModifierFactExpressionConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ModifierFactExpression(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.ModifierFactExpression.<anonymous>' call
    this_0.zbl().v2c(refValue);
    return this_0;
  }
  function ExtensionFieldReference_3(nodeSetupContext, ref, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ExtensionFieldReferenceConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ExtensionFieldReference_0(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.ExtensionFieldReference.<anonymous>' call
    this_0.nb4().v2c(ref);
    return this_0;
  }
  function ProcessPrerequisite_2(nodeSetupContext, expression, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessPrerequisiteConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ProcessPrerequisite(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.ProcessPrerequisite.<anonymous>' call
    this_0.lbb().v2c(expression);
    return this_0;
  }
  function ProcessEffect_2(nodeSetupContext, expression, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(ProcessEffectConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = ProcessEffect(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.ProcessEffect.<anonymous>' call
    this_0.lbb().v2c(expression);
    return this_0;
  }
  function SimplePropertyType_1(nodeSetupContext, notionRef, nodeId) {
    notionRef = notionRef === VOID ? null : notionRef;
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(SimplePropertyTypeConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = SimplePropertyTypeConcept_getInstance().v6r(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.SimplePropertyType.<anonymous>' call
    this_0.lbp().v2c(notionRef);
    return this_0;
  }
  function InstanceRelationValue_1(nodeSetupContext, refValue, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(InstanceRelationValueConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = InstanceRelationValueConcept_getInstance().v6r(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.InstanceRelationValue.<anonymous>' call
    this_0.gb6().v2c(refValue);
    return this_0;
  }
  function NotionType_2(nodeSetupContext, notionRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(NotionTypeConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = NotionType(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.NotionType.<anonymous>' call
    this_0.lbp().v2c(notionRef);
    return this_0;
  }
  function LibraryProcessSpecification_3(nodeSetupContext, processRef, nodeId) {
    nodeId = nodeId === VOID ? Companion_instance_43.p3a(LibraryProcessSpecificationConcept_getInstance().e6r_1) : nodeId;
    // Inline function 'kotlin.apply' call
    var this_0 = LibraryProcessSpecification_0(nodeSetupContext, nodeId);
    // Inline function 'jetbrains.biokb.lang.model.LibraryProcessSpecification.<anonymous>' call
    this_0.jbg().v2c(processRef);
    return this_0;
  }
  function ReferenceAspects() {
    ReferenceAspects_instance = this;
    this.vgu_1 = listOf_0([to(ExtensionFieldReferenceConcept_getInstance().e6r_1, ExtensionFieldReferenceConcept_getInstance().lb4_1), to(EnumValueConcept_getInstance().e6r_1, EnumValueConcept_getInstance().ub2_1), to(FunctionTermConcept_getInstance().e6r_1, FunctionTermConcept_getInstance().kba_1), to(FactPreconditionConcept_getInstance().e6r_1, FactPreconditionConcept_getInstance().bb6_1), to(ImportedLinkConcept_getInstance().e6r_1, ImportedLinkConcept_getInstance().kbd_1), to(ImportedLinkConcept_getInstance().e6r_1, AbstractLinkConcept_getInstance().hat_1), to(OntologyLinkConcept_getInstance().e6r_1, AbstractLinkConcept_getInstance().hat_1), to(ImportedPropertyConcept_getInstance().e6r_1, ImportedPropertyConcept_getInstance().ybd_1), to(LibraryProcessSpecificationConcept_getInstance().e6r_1, LibraryProcessSpecificationConcept_getInstance().fbg_1), to(MeasurableValueConcept_getInstance().e6r_1, MeasurableValueConcept_getInstance().ebk_1), to(NotionTypeConcept_getInstance().e6r_1, NotionTypeConcept_getInstance().jbp_1), to(SimplePropertyTypeConcept_getInstance().e6r_1, SimplePropertyTypeConcept_getInstance().hcn_1), to(OntologyLinkValueConcept_getInstance().e6r_1, OntologyLinkValueConcept_getInstance().uc2_1), to(OntologyElementReferenceConcept_getInstance().e6r_1, OntologyElementReferenceConcept_getInstance().cbw_1), to(OntologyLibraryReferenceConcept_getInstance().e6r_1, OntologyLibraryReferenceConcept_getInstance().ec1_1), to(ProcessDeclarationConcept_getInstance().e6r_1, ProcessDeclarationConcept_getInstance().xc6_1), to(ProcessReferenceConcept_getInstance().e6r_1, ProcessReferenceConcept_getInstance().ncb_1), to(ProcessDeclarationConcept_getInstance().e6r_1, ProcessDeclarationConcept_getInstance().wc6_1), to(PropertyValueConcept_getInstance().e6r_1, PropertyValueConcept_getInstance().rcg_1), to(ProcessPropertyValueConcept_getInstance().e6r_1, ProcessPropertyValueConcept_getInstance().yca_1), to(ProcessPropertyCustomCellConcept_getInstance().e6r_1, ProcessPropertyCustomCellConcept_getInstance().mc9_1), to(ProcessPropertyReferenceConcept_getInstance().e6r_1, ProcessPropertyReferenceConcept_getInstance().lca_1), to(PropertyCustomCellConcept_getInstance().e6r_1, PropertyCustomCellConcept_getInstance().cce_1), to(LinkCustomCellConcept_getInstance().e6r_1, LinkCustomCellConcept_getInstance().nbh_1), to(OntologyImportRootReferenceConcept_getInstance().e6r_1, OntologyImportRootReferenceConcept_getInstance().rbz_1), to(LibraryProcessSpecificationQueryConcept_getInstance().e6r_1, LibraryProcessSpecificationQueryConcept_getInstance().xbg_1), to(LibraryProcessSpecificationQueryConcept_getInstance().e6r_1, LibraryProcessSpecificationQueryConcept_getInstance().wbg_1), to(OntologyLinkDeclarationValueQueryConcept_getInstance().e6r_1, OntologyLinkDeclarationValueQueryConcept_getInstance().gc2_1), to(PropertyDeclarationValueQueryConcept_getInstance().e6r_1, PropertyDeclarationValueQueryConcept_getInstance().bcf_1), to(PublishedSourceReferenceConcept_getInstance().e6r_1, PublishedSourceReferenceConcept_getInstance().qch_1), to(InstanceRelationValueConcept_getInstance().e6r_1, InstanceRelationValueConcept_getInstance().abf_1), to(FactReferenceConcept_getInstance().e6r_1, FactReferenceConcept_getInstance().sb6_1), to(VariableReferenceValueConcept_getInstance().e6r_1, VariableReferenceValueConcept_getInstance().vcq_1), to(LocalOntologyElementReferenceConcept_getInstance().e6r_1, LocalOntologyElementReferenceConcept_getInstance().ebj_1), to(ModifierFactExpressionConcept_getInstance().e6r_1, ModifierFactExpressionConcept_getInstance().vbl_1), to(RelationFactExpressionConcept_getInstance().e6r_1, RelationFactExpressionConcept_getInstance().qcl_1), to(NewFactReferenceConcept_getInstance().e6r_1, NewFactReferenceConcept_getInstance().jbo_1), to(PropertyConstraintConcept_getInstance().e6r_1, PropertyConstraintConcept_getInstance().kcd_1), to(ObjectPropertyDeclarationConcept_getInstance().e6r_1, ObjectPropertyDeclarationConcept_getInstance().jbq_1), to(ObjectPropertyDeclarationConcept_getInstance().e6r_1, ObjectPropertyDeclarationConcept_getInstance().nbq_1), to(PropertyReferenceOperationConcept_getInstance().e6r_1, PropertyReferenceOperationConcept_getInstance().bcg_1)]);
    var tmp = this;
    // Inline function 'kotlin.collections.groupBy' call
    var tmp0 = this.vgu_1;
    // Inline function 'kotlin.collections.groupByTo' call
    var destination = LinkedHashMap_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.biokb.lang.model.findUsages.ReferenceAspects.implementationsListMap.<anonymous>' call
      var key = element.dh_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination.y2(key);
      var tmp_0;
      if (value == null) {
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        var answer = ArrayList_init_$Create$();
        destination.r2(key, answer);
        tmp_0 = answer;
      } else {
        tmp_0 = value;
      }
      var list = tmp_0;
      // Inline function 'jetbrains.biokb.lang.model.findUsages.ReferenceAspects.implementationsListMap.<anonymous>' call
      var tmp$ret$3 = element.eh_1;
      list.e(tmp$ret$3);
    }
    tmp.wgu_1 = destination;
  }
  protoOf(ReferenceAspects).xgu = function (nodeConceptId) {
    var tmp0_elvis_lhs = this.wgu_1.y2(nodeConceptId);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  var ReferenceAspects_instance;
  function ReferenceAspects_getInstance() {
    if (ReferenceAspects_instance == null)
      new ReferenceAspects();
    return ReferenceAspects_instance;
  }
  function SuperElementUsageKind() {
    SuperElementUsageKind_instance = this;
    UsageKind.call(this, 'superElement');
  }
  var SuperElementUsageKind_instance;
  function SuperElementUsageKind_getInstance() {
    if (SuperElementUsageKind_instance == null)
      new SuperElementUsageKind();
    return SuperElementUsageKind_instance;
  }
  function OntologyInSuperElementUsageKind() {
    OntologyInSuperElementUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInSuperElement');
  }
  var OntologyInSuperElementUsageKind_instance;
  function OntologyInSuperElementUsageKind_getInstance() {
    if (OntologyInSuperElementUsageKind_instance == null)
      new OntologyInSuperElementUsageKind();
    return OntologyInSuperElementUsageKind_instance;
  }
  function PartOfElementUsageKind() {
    PartOfElementUsageKind_instance = this;
    UsageKind.call(this, 'partOfElement');
  }
  var PartOfElementUsageKind_instance;
  function PartOfElementUsageKind_getInstance() {
    if (PartOfElementUsageKind_instance == null)
      new PartOfElementUsageKind();
    return PartOfElementUsageKind_instance;
  }
  function OntologyInPartOfElementUsageKind() {
    OntologyInPartOfElementUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInPartOfElement');
  }
  var OntologyInPartOfElementUsageKind_instance;
  function OntologyInPartOfElementUsageKind_getInstance() {
    if (OntologyInPartOfElementUsageKind_instance == null)
      new OntologyInPartOfElementUsageKind();
    return OntologyInPartOfElementUsageKind_instance;
  }
  function ElementsTaxonUsageKind() {
    ElementsTaxonUsageKind_instance = this;
    UsageKind.call(this, 'elementsTaxon');
  }
  var ElementsTaxonUsageKind_instance;
  function ElementsTaxonUsageKind_getInstance() {
    if (ElementsTaxonUsageKind_instance == null)
      new ElementsTaxonUsageKind();
    return ElementsTaxonUsageKind_instance;
  }
  function OntologyInElementsTaxonUsageKind() {
    OntologyInElementsTaxonUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInElementsTaxon');
  }
  var OntologyInElementsTaxonUsageKind_instance;
  function OntologyInElementsTaxonUsageKind_getInstance() {
    if (OntologyInElementsTaxonUsageKind_instance == null)
      new OntologyInElementsTaxonUsageKind();
    return OntologyInElementsTaxonUsageKind_instance;
  }
  function OntologyInCategoryUsageKind() {
    OntologyInCategoryUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInCategory');
  }
  var OntologyInCategoryUsageKind_instance;
  function OntologyInCategoryUsageKind_getInstance() {
    if (OntologyInCategoryUsageKind_instance == null)
      new OntologyInCategoryUsageKind();
    return OntologyInCategoryUsageKind_instance;
  }
  function ElementInCategoryUsageKind() {
    ElementInCategoryUsageKind_instance = this;
    UsageKind.call(this, 'elementInCategory');
  }
  var ElementInCategoryUsageKind_instance;
  function ElementInCategoryUsageKind_getInstance() {
    if (ElementInCategoryUsageKind_instance == null)
      new ElementInCategoryUsageKind();
    return ElementInCategoryUsageKind_instance;
  }
  function ElementInFactSetContextUsageKind() {
    ElementInFactSetContextUsageKind_instance = this;
    UsageKind.call(this, 'elementInFactSetContext');
  }
  var ElementInFactSetContextUsageKind_instance;
  function ElementInFactSetContextUsageKind_getInstance() {
    if (ElementInFactSetContextUsageKind_instance == null)
      new ElementInFactSetContextUsageKind();
    return ElementInFactSetContextUsageKind_instance;
  }
  function OntologyInFactSetContextUsageKind() {
    OntologyInFactSetContextUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInFactSetContext');
  }
  var OntologyInFactSetContextUsageKind_instance;
  function OntologyInFactSetContextUsageKind_getInstance() {
    if (OntologyInFactSetContextUsageKind_instance == null)
      new OntologyInFactSetContextUsageKind();
    return OntologyInFactSetContextUsageKind_instance;
  }
  function AnythingInsideFactUsageKind() {
    AnythingInsideFactUsageKind_instance = this;
    UsageKind.call(this, 'anyUsageInsideFact');
  }
  var AnythingInsideFactUsageKind_instance;
  function AnythingInsideFactUsageKind_getInstance() {
    if (AnythingInsideFactUsageKind_instance == null)
      new AnythingInsideFactUsageKind();
    return AnythingInsideFactUsageKind_instance;
  }
  function SomethingAsVariableSpecUsageKind() {
    SomethingAsVariableSpecUsageKind_instance = this;
    UsageKind.call(this, 'variableType');
  }
  var SomethingAsVariableSpecUsageKind_instance;
  function SomethingAsVariableSpecUsageKind_getInstance() {
    if (SomethingAsVariableSpecUsageKind_instance == null)
      new SomethingAsVariableSpecUsageKind();
    return SomethingAsVariableSpecUsageKind_instance;
  }
  function ProcessKindUsageKind() {
    ProcessKindUsageKind_instance = this;
    UsageKind.call(this, 'processKind');
  }
  var ProcessKindUsageKind_instance;
  function ProcessKindUsageKind_getInstance() {
    if (ProcessKindUsageKind_instance == null)
      new ProcessKindUsageKind();
    return ProcessKindUsageKind_instance;
  }
  function ExtendedProcessUsageKind() {
    ExtendedProcessUsageKind_instance = this;
    UsageKind.call(this, 'extendedProcess');
  }
  var ExtendedProcessUsageKind_instance;
  function ExtendedProcessUsageKind_getInstance() {
    if (ExtendedProcessUsageKind_instance == null)
      new ExtendedProcessUsageKind();
    return ExtendedProcessUsageKind_instance;
  }
  function InheritedProcessUsageKind() {
    InheritedProcessUsageKind_instance = this;
    UsageKind.call(this, 'inheritedProcess');
  }
  var InheritedProcessUsageKind_instance;
  function InheritedProcessUsageKind_getInstance() {
    if (InheritedProcessUsageKind_instance == null)
      new InheritedProcessUsageKind();
    return InheritedProcessUsageKind_instance;
  }
  function FunctionReturnTypeOntologyUsageKind() {
    FunctionReturnTypeOntologyUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInFunctionReturnType');
  }
  var FunctionReturnTypeOntologyUsageKind_instance;
  function FunctionReturnTypeOntologyUsageKind_getInstance() {
    if (FunctionReturnTypeOntologyUsageKind_instance == null)
      new FunctionReturnTypeOntologyUsageKind();
    return FunctionReturnTypeOntologyUsageKind_instance;
  }
  function FunctionReturnTypeOntologyElementUsageKind() {
    FunctionReturnTypeOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'ontologyElementInFunctionReturnType');
  }
  var FunctionReturnTypeOntologyElementUsageKind_instance;
  function FunctionReturnTypeOntologyElementUsageKind_getInstance() {
    if (FunctionReturnTypeOntologyElementUsageKind_instance == null)
      new FunctionReturnTypeOntologyElementUsageKind();
    return FunctionReturnTypeOntologyElementUsageKind_instance;
  }
  function AnythingInsideCustomEditorUsageKind() {
    AnythingInsideCustomEditorUsageKind_instance = this;
    UsageKind.call(this, 'anythingInsideCustomEditor');
  }
  var AnythingInsideCustomEditorUsageKind_instance;
  function AnythingInsideCustomEditorUsageKind_getInstance() {
    if (AnythingInsideCustomEditorUsageKind_instance == null)
      new AnythingInsideCustomEditorUsageKind();
    return AnythingInsideCustomEditorUsageKind_instance;
  }
  function OntologyElementInAbstractBindingElementsUsageKind() {
    OntologyElementInAbstractBindingElementsUsageKind_instance = this;
    UsageKind.call(this, 'ontologyElementInBindingDeclElementsUsageKind');
  }
  var OntologyElementInAbstractBindingElementsUsageKind_instance;
  function OntologyElementInAbstractBindingElementsUsageKind_getInstance() {
    if (OntologyElementInAbstractBindingElementsUsageKind_instance == null)
      new OntologyElementInAbstractBindingElementsUsageKind();
    return OntologyElementInAbstractBindingElementsUsageKind_instance;
  }
  function OntologyInAbstractBindingElementsUsageKind() {
    OntologyInAbstractBindingElementsUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInBindingDeclElementsUsageKind');
  }
  var OntologyInAbstractBindingElementsUsageKind_instance;
  function OntologyInAbstractBindingElementsUsageKind_getInstance() {
    if (OntologyInAbstractBindingElementsUsageKind_instance == null)
      new OntologyInAbstractBindingElementsUsageKind();
    return OntologyInAbstractBindingElementsUsageKind_instance;
  }
  function AliasedPropertyUsageKind() {
    AliasedPropertyUsageKind_instance = this;
    UsageKind.call(this, 'propertyAlias');
  }
  var AliasedPropertyUsageKind_instance;
  function AliasedPropertyUsageKind_getInstance() {
    if (AliasedPropertyUsageKind_instance == null)
      new AliasedPropertyUsageKind();
    return AliasedPropertyUsageKind_instance;
  }
  function PropertyTypeOntologyUsageKind() {
    PropertyTypeOntologyUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInPropertyType');
  }
  var PropertyTypeOntologyUsageKind_instance;
  function PropertyTypeOntologyUsageKind_getInstance() {
    if (PropertyTypeOntologyUsageKind_instance == null)
      new PropertyTypeOntologyUsageKind();
    return PropertyTypeOntologyUsageKind_instance;
  }
  function PropertyTypeOntologyElementUsageKind() {
    PropertyTypeOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'ontologyElementInPropertyType');
  }
  var PropertyTypeOntologyElementUsageKind_instance;
  function PropertyTypeOntologyElementUsageKind_getInstance() {
    if (PropertyTypeOntologyElementUsageKind_instance == null)
      new PropertyTypeOntologyElementUsageKind();
    return PropertyTypeOntologyElementUsageKind_instance;
  }
  function PropertyTypeNotionUsageKind() {
    PropertyTypeNotionUsageKind_instance = this;
    UsageKind.call(this, 'notionAsPropertyType');
  }
  var PropertyTypeNotionUsageKind_instance;
  function PropertyTypeNotionUsageKind_getInstance() {
    if (PropertyTypeNotionUsageKind_instance == null)
      new PropertyTypeNotionUsageKind();
    return PropertyTypeNotionUsageKind_instance;
  }
  function OldPropertyTypeNotionUsageKind() {
    OldPropertyTypeNotionUsageKind_instance = this;
    UsageKind.call(this, 'notionAsOldPropertyType');
  }
  var OldPropertyTypeNotionUsageKind_instance;
  function OldPropertyTypeNotionUsageKind_getInstance() {
    if (OldPropertyTypeNotionUsageKind_instance == null)
      new OldPropertyTypeNotionUsageKind();
    return OldPropertyTypeNotionUsageKind_instance;
  }
  function OldImportedPropertyUsageKind() {
    OldImportedPropertyUsageKind_instance = this;
    UsageKind.call(this, 'oldImportedProperty');
  }
  var OldImportedPropertyUsageKind_instance;
  function OldImportedPropertyUsageKind_getInstance() {
    if (OldImportedPropertyUsageKind_instance == null)
      new OldImportedPropertyUsageKind();
    return OldImportedPropertyUsageKind_instance;
  }
  function OldLinkOntologyUsageKind() {
    OldLinkOntologyUsageKind_instance = this;
    UsageKind.call(this, 'ontologyInOldLink');
  }
  var OldLinkOntologyUsageKind_instance;
  function OldLinkOntologyUsageKind_getInstance() {
    if (OldLinkOntologyUsageKind_instance == null)
      new OldLinkOntologyUsageKind();
    return OldLinkOntologyUsageKind_instance;
  }
  function OldLinkOntologyElementUsageKind() {
    OldLinkOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'ontologyElementInOldLink');
  }
  var OldLinkOntologyElementUsageKind_instance;
  function OldLinkOntologyElementUsageKind_getInstance() {
    if (OldLinkOntologyElementUsageKind_instance == null)
      new OldLinkOntologyElementUsageKind();
    return OldLinkOntologyElementUsageKind_instance;
  }
  function OldImportedLinkUsageKind() {
    OldImportedLinkUsageKind_instance = this;
    UsageKind.call(this, 'oldImportedLink');
  }
  var OldImportedLinkUsageKind_instance;
  function OldImportedLinkUsageKind_getInstance() {
    if (OldImportedLinkUsageKind_instance == null)
      new OldImportedLinkUsageKind();
    return OldImportedLinkUsageKind_instance;
  }
  function OldLinkSpecializesLinkUsageKind() {
    OldLinkSpecializesLinkUsageKind_instance = this;
    UsageKind.call(this, 'oldLinkSpecializesLink');
  }
  var OldLinkSpecializesLinkUsageKind_instance;
  function OldLinkSpecializesLinkUsageKind_getInstance() {
    if (OldLinkSpecializesLinkUsageKind_instance == null)
      new OldLinkSpecializesLinkUsageKind();
    return OldLinkSpecializesLinkUsageKind_instance;
  }
  function InOntologyImportForOntologyUsageKind() {
    InOntologyImportForOntologyUsageKind_instance = this;
    UsageKind.call(this, 'inOntologyImportForOntology');
  }
  var InOntologyImportForOntologyUsageKind_instance;
  function InOntologyImportForOntologyUsageKind_getInstance() {
    if (InOntologyImportForOntologyUsageKind_instance == null)
      new InOntologyImportForOntologyUsageKind();
    return InOntologyImportForOntologyUsageKind_instance;
  }
  function InOntologyImportForOntologyElementUsageKind() {
    InOntologyImportForOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'inOntologyImportForOntologyElement');
  }
  var InOntologyImportForOntologyElementUsageKind_instance;
  function InOntologyImportForOntologyElementUsageKind_getInstance() {
    if (InOntologyImportForOntologyElementUsageKind_instance == null)
      new InOntologyImportForOntologyElementUsageKind();
    return InOntologyImportForOntologyElementUsageKind_instance;
  }
  function InOntologyImportOntologyToUseUsageKind() {
    InOntologyImportOntologyToUseUsageKind_instance = this;
    UsageKind.call(this, 'inOntologyImportOntologyToUse');
  }
  var InOntologyImportOntologyToUseUsageKind_instance;
  function InOntologyImportOntologyToUseUsageKind_getInstance() {
    if (InOntologyImportOntologyToUseUsageKind_instance == null)
      new InOntologyImportOntologyToUseUsageKind();
    return InOntologyImportOntologyToUseUsageKind_instance;
  }
  function ExtensionTypeOntologyUsageKind() {
    ExtensionTypeOntologyUsageKind_instance = this;
    UsageKind.call(this, 'extensionTypeOntologyUsageKind');
  }
  var ExtensionTypeOntologyUsageKind_instance;
  function ExtensionTypeOntologyUsageKind_getInstance() {
    if (ExtensionTypeOntologyUsageKind_instance == null)
      new ExtensionTypeOntologyUsageKind();
    return ExtensionTypeOntologyUsageKind_instance;
  }
  function ExtensionTypeOntologyElementUsageKind() {
    ExtensionTypeOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'extensionTypeOntologyElementUsageKind');
  }
  var ExtensionTypeOntologyElementUsageKind_instance;
  function ExtensionTypeOntologyElementUsageKind_getInstance() {
    if (ExtensionTypeOntologyElementUsageKind_instance == null)
      new ExtensionTypeOntologyElementUsageKind();
    return ExtensionTypeOntologyElementUsageKind_instance;
  }
  function ExtensionFieldOntologyUsageKind() {
    ExtensionFieldOntologyUsageKind_instance = this;
    UsageKind.call(this, 'extensionFieldOntologyUsageKind');
  }
  var ExtensionFieldOntologyUsageKind_instance;
  function ExtensionFieldOntologyUsageKind_getInstance() {
    if (ExtensionFieldOntologyUsageKind_instance == null)
      new ExtensionFieldOntologyUsageKind();
    return ExtensionFieldOntologyUsageKind_instance;
  }
  function ExtensionFieldOntologyElementUsageKind() {
    ExtensionFieldOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'extensionFieldOntologyElementUsageKind');
  }
  var ExtensionFieldOntologyElementUsageKind_instance;
  function ExtensionFieldOntologyElementUsageKind_getInstance() {
    if (ExtensionFieldOntologyElementUsageKind_instance == null)
      new ExtensionFieldOntologyElementUsageKind();
    return ExtensionFieldOntologyElementUsageKind_instance;
  }
  function ImportOntologyImportRootUsageKind() {
    ImportOntologyImportRootUsageKind_instance = this;
    UsageKind.call(this, 'importOntologyImportRoot');
  }
  var ImportOntologyImportRootUsageKind_instance;
  function ImportOntologyImportRootUsageKind_getInstance() {
    if (ImportOntologyImportRootUsageKind_instance == null)
      new ImportOntologyImportRootUsageKind();
    return ImportOntologyImportRootUsageKind_instance;
  }
  function TypeOfOldPropertyNotionUsageKind() {
    TypeOfOldPropertyNotionUsageKind_instance = this;
    UsageKind.call(this, 'oldPropertyNotionTypeUsageKind');
  }
  var TypeOfOldPropertyNotionUsageKind_instance;
  function TypeOfOldPropertyNotionUsageKind_getInstance() {
    if (TypeOfOldPropertyNotionUsageKind_instance == null)
      new TypeOfOldPropertyNotionUsageKind();
    return TypeOfOldPropertyNotionUsageKind_instance;
  }
  function TypeOfOldLinkOntologyUsageKind() {
    TypeOfOldLinkOntologyUsageKind_instance = this;
    UsageKind.call(this, 'oldLinkOntologyInTypeUsageKind');
  }
  var TypeOfOldLinkOntologyUsageKind_instance;
  function TypeOfOldLinkOntologyUsageKind_getInstance() {
    if (TypeOfOldLinkOntologyUsageKind_instance == null)
      new TypeOfOldLinkOntologyUsageKind();
    return TypeOfOldLinkOntologyUsageKind_instance;
  }
  function TypeOfOldLinkOntologyElementUsageKind() {
    TypeOfOldLinkOntologyElementUsageKind_instance = this;
    UsageKind.call(this, 'oldLinkOntologyElementInTypeUsageKind');
  }
  var TypeOfOldLinkOntologyElementUsageKind_instance;
  function TypeOfOldLinkOntologyElementUsageKind_getInstance() {
    if (TypeOfOldLinkOntologyElementUsageKind_instance == null)
      new TypeOfOldLinkOntologyElementUsageKind();
    return TypeOfOldLinkOntologyElementUsageKind_instance;
  }
  function SuperPropertyUsageKind() {
    SuperPropertyUsageKind_instance = this;
    UsageKind.call(this, 'superPropertyUsageKind');
  }
  var SuperPropertyUsageKind_instance;
  function SuperPropertyUsageKind_getInstance() {
    if (SuperPropertyUsageKind_instance == null)
      new SuperPropertyUsageKind();
    return SuperPropertyUsageKind_instance;
  }
  function InversePropertyUsageKind() {
    InversePropertyUsageKind_instance = this;
    UsageKind.call(this, 'inversePropertyUsageKind');
  }
  var InversePropertyUsageKind_instance;
  function InversePropertyUsageKind_getInstance() {
    if (InversePropertyUsageKind_instance == null)
      new InversePropertyUsageKind();
    return InversePropertyUsageKind_instance;
  }
  function SuperElementUsage(node, usedElement, kind) {
    OntologyElementRelatedToAnotherElementUsage.call(this);
    this.ygu_1 = node;
    this.zgu_1 = usedElement;
    this.agv_1 = kind;
  }
  protoOf(SuperElementUsage).y8c = function () {
    return this.ygu_1;
  };
  protoOf(SuperElementUsage).bgv = function () {
    return this.zgu_1;
  };
  var OntologyTargetKind_ELEMENT_instance;
  var OntologyTargetKind_ONTOLOGY_instance;
  var OntologyTargetKind_entriesInitialized;
  function OntologyTargetKind_initEntries() {
    if (OntologyTargetKind_entriesInitialized)
      return Unit_instance;
    OntologyTargetKind_entriesInitialized = true;
    OntologyTargetKind_ELEMENT_instance = new OntologyTargetKind('ELEMENT', 0);
    OntologyTargetKind_ONTOLOGY_instance = new OntologyTargetKind('ONTOLOGY', 1);
  }
  function OntologyTargetKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PartOfElementUsage(node, usedElement, kind) {
    OntologyElementRelatedToAnotherElementUsage.call(this);
    this.cgv_1 = node;
    this.dgv_1 = usedElement;
    this.egv_1 = kind;
  }
  protoOf(PartOfElementUsage).y8c = function () {
    return this.cgv_1;
  };
  protoOf(PartOfElementUsage).bgv = function () {
    return this.dgv_1;
  };
  function ElementsTaxonUsage(node, taxonElement, kind) {
    OntologyElementUsageByAnotherElement.call(this);
    this.fgv_1 = node;
    this.ggv_1 = taxonElement;
    this.hgv_1 = kind;
  }
  protoOf(ElementsTaxonUsage).y8c = function () {
    return this.fgv_1;
  };
  function CategoryOntologyUsage(node, kind) {
    UsagePresentationData.call(this);
    this.igv_1 = node;
    this.jgv_1 = kind;
  }
  function FactSetContextOntologyUsage(node, context) {
    UsagePresentationData.call(this);
    this.kgv_1 = node;
    this.lgv_1 = context;
  }
  function SomethingAsVariableSpecUsage(node) {
    UsagePresentationData.call(this);
    this.mgv_1 = node;
  }
  function AnyUsageInFact(node) {
    UsagePresentationData.call(this);
    this.ngv_1 = node;
  }
  function ProcessKindUsage(node) {
    UsageInProcess.call(this, node);
  }
  function ExtendedProcessUsage(node) {
    UsageInProcess.call(this, node);
  }
  function InheritedProcessUsage(node, inherited) {
    UsageInProcess.call(this, node);
    this.qgv_1 = inherited;
  }
  function OntologyElementInBindingDeclarationUsage(node, elementType, kind) {
    UsageInBindingDeclaration.call(this, node);
    this.sgv_1 = elementType;
    this.tgv_1 = kind;
  }
  function AnythingInsideCustomEditorUsage(node, cell) {
    UsageInBindingDeclaration.call(this, node);
    this.wgv_1 = cell;
  }
  function AliasedBindingPropertyUsage(node, property, aliasedProperty) {
    UsageInBindingProperty.call(this);
    this.xgv_1 = node;
    this.ygv_1 = property;
    this.zgv_1 = aliasedProperty;
  }
  function PropertyTypeUsage(node, property) {
    UsageInBindingProperty.call(this);
    this.agw_1 = node;
    this.bgw_1 = property;
  }
  function OldPropertyTypeNotionUsage(node, property) {
    UsageInBindingDeclaration.call(this, node);
    this.dgw_1 = property;
  }
  function OldImportedPropertyUsage(node, importedProperty) {
    UsageInBindingDeclaration.call(this, node);
    this.fgw_1 = importedProperty;
  }
  function OldLinkOntologyUsage(node, link) {
    UsageInBindingDeclaration.call(this, node);
    this.hgw_1 = link;
  }
  function OldImportedLinkUsage(node, importedLink) {
    UsageInBindingDeclaration.call(this, node);
    this.jgw_1 = importedLink;
  }
  function OldLinkSpecializesLinkUsage(node, link) {
    UsageInBindingDeclaration.call(this, node);
    this.lgw_1 = link;
  }
  function OntologyInFunctionReturnTypeUsage(node, kind) {
    UsagePresentationData.call(this);
    this.mgw_1 = node;
    this.ngw_1 = kind;
  }
  function InOntologyImportForOntologyUsage(node, kind) {
    UsageInOntologyImport.call(this, node);
    this.pgw_1 = kind;
  }
  protoOf(InOntologyImportForOntologyUsage).qgw = function () {
    return 'replaced hierarchy:';
  };
  function InOntologyImportOntologyToUseUsage(node) {
    UsageInOntologyImport.call(this, node);
  }
  protoOf(InOntologyImportOntologyToUseUsage).qgw = function () {
    return 'ontology to use:';
  };
  function OntologyInExtensionTypeUsage(node, kind) {
    UsagePresentationData.call(this);
    this.tgw_1 = node;
    this.ugw_1 = kind;
  }
  function OntologyInExtensionFieldUsage(node, field, kind) {
    UsagePresentationData.call(this);
    this.vgw_1 = node;
    this.wgw_1 = field;
    this.xgw_1 = kind;
  }
  function ImportOntologyImportRootUsage(node) {
    UsagePresentationData.call(this);
    this.ygw_1 = node;
  }
  function PublishedSourceUsageKind() {
    PublishedSourceUsageKind_instance = this;
    UsageKind.call(this, 'publishedSourceUsageKind');
  }
  var PublishedSourceUsageKind_instance;
  function PublishedSourceUsageKind_getInstance() {
    if (PublishedSourceUsageKind_instance == null)
      new PublishedSourceUsageKind();
    return PublishedSourceUsageKind_instance;
  }
  function PublishedSourceUsage(node) {
    UsagePresentationData.call(this);
    this.zgw_1 = node;
  }
  function TypeOfOldPropertyDeclarationUsage(node) {
    UsagePresentationData.call(this);
    this.agx_1 = node;
  }
  function TypeOfOldLinkDeclarationUsage(node, kind) {
    UsagePresentationData.call(this);
    this.bgx_1 = node;
  }
  function ObjectPropertyUsageByAnotherProperty(node, kind) {
    UsagePresentationData.call(this);
    this.cgx_1 = node;
    this.dgx_1 = kind;
  }
  var ObjectPropertyUsageByAnotherPropertyKind_SUPER_PROPERTY_instance;
  var ObjectPropertyUsageByAnotherPropertyKind_INVERSE_PROPERTY_instance;
  var ObjectPropertyUsageByAnotherPropertyKind_entriesInitialized;
  function ObjectPropertyUsageByAnotherPropertyKind_initEntries() {
    if (ObjectPropertyUsageByAnotherPropertyKind_entriesInitialized)
      return Unit_instance;
    ObjectPropertyUsageByAnotherPropertyKind_entriesInitialized = true;
    ObjectPropertyUsageByAnotherPropertyKind_SUPER_PROPERTY_instance = new ObjectPropertyUsageByAnotherPropertyKind('SUPER_PROPERTY', 0);
    ObjectPropertyUsageByAnotherPropertyKind_INVERSE_PROPERTY_instance = new ObjectPropertyUsageByAnotherPropertyKind('INVERSE_PROPERTY', 1);
  }
  function ObjectPropertyUsageByAnotherPropertyKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function OntologyElementRelatedToAnotherElementUsage() {
    OntologyElementUsageByAnotherElement.call(this);
  }
  function OntologyElementUsageByAnotherElement() {
    UsagePresentationData.call(this);
  }
  function UsageInProcess(node) {
    UsagePresentationData.call(this);
    this.ogv_1 = node;
  }
  protoOf(UsageInProcess).y8c = function () {
    return this.ogv_1;
  };
  function UsageInBindingDeclaration(node) {
    UsagePresentationData.call(this);
    this.ugv_1 = node;
  }
  protoOf(UsageInBindingDeclaration).y8c = function () {
    return this.ugv_1;
  };
  function UsageInBindingProperty() {
    UsagePresentationData.call(this);
  }
  function UsageInOntologyImport(node) {
    UsagePresentationData.call(this);
    this.rgw_1 = node;
  }
  protoOf(UsageInOntologyImport).y8c = function () {
    return this.rgw_1;
  };
  function OntologyTargetKind_ELEMENT_getInstance() {
    OntologyTargetKind_initEntries();
    return OntologyTargetKind_ELEMENT_instance;
  }
  function OntologyTargetKind_ONTOLOGY_getInstance() {
    OntologyTargetKind_initEntries();
    return OntologyTargetKind_ONTOLOGY_instance;
  }
  function ObjectPropertyUsageByAnotherPropertyKind_SUPER_PROPERTY_getInstance() {
    ObjectPropertyUsageByAnotherPropertyKind_initEntries();
    return ObjectPropertyUsageByAnotherPropertyKind_SUPER_PROPERTY_instance;
  }
  function ObjectPropertyUsageByAnotherPropertyKind_INVERSE_PROPERTY_getInstance() {
    ObjectPropertyUsageByAnotherPropertyKind_initEntries();
    return ObjectPropertyUsageByAnotherPropertyKind_INVERSE_PROPERTY_instance;
  }
  function btbFindUsages(_this__u8e3s4) {
    findUsages(_this__u8e3s4, btbFindUsages$lambda);
  }
  function btbFindUsages$lambda($this$findUsages) {
    usageKinds($this$findUsages, [SuperElementUsageKind_getInstance(), OntologyInSuperElementUsageKind_getInstance(), PartOfElementUsageKind_getInstance(), OntologyInPartOfElementUsageKind_getInstance(), ElementsTaxonUsageKind_getInstance(), OntologyInElementsTaxonUsageKind_getInstance()]);
    usageKinds($this$findUsages, [OntologyInCategoryUsageKind_getInstance(), ElementInCategoryUsageKind_getInstance(), ElementInFactSetContextUsageKind_getInstance(), OntologyInFactSetContextUsageKind_getInstance()]);
    usageKinds($this$findUsages, [AnythingInsideFactUsageKind_getInstance(), SomethingAsVariableSpecUsageKind_getInstance()]);
    usageKinds($this$findUsages, [ProcessKindUsageKind_getInstance(), ExtendedProcessUsageKind_getInstance(), InheritedProcessUsageKind_getInstance()]);
    usageKinds($this$findUsages, [FunctionReturnTypeOntologyUsageKind_getInstance(), FunctionReturnTypeOntologyElementUsageKind_getInstance()]);
    usageKinds($this$findUsages, [AnythingInsideCustomEditorUsageKind_getInstance(), OntologyElementInAbstractBindingElementsUsageKind_getInstance(), OntologyInAbstractBindingElementsUsageKind_getInstance(), AliasedPropertyUsageKind_getInstance(), PropertyTypeOntologyUsageKind_getInstance(), PropertyTypeOntologyElementUsageKind_getInstance(), PropertyTypeNotionUsageKind_getInstance(), OldPropertyTypeNotionUsageKind_getInstance(), OldImportedPropertyUsageKind_getInstance(), OldLinkOntologyUsageKind_getInstance(), OldLinkOntologyElementUsageKind_getInstance(), OldImportedLinkUsageKind_getInstance(), OldLinkSpecializesLinkUsageKind_getInstance()]);
    usageKinds($this$findUsages, [InOntologyImportForOntologyUsageKind_getInstance(), InOntologyImportForOntologyElementUsageKind_getInstance(), InOntologyImportOntologyToUseUsageKind_getInstance()]);
    usageKinds($this$findUsages, [ExtensionTypeOntologyUsageKind_getInstance(), ExtensionTypeOntologyElementUsageKind_getInstance(), ExtensionFieldOntologyUsageKind_getInstance(), ExtensionFieldOntologyElementUsageKind_getInstance()]);
    $this$findUsages.i8c(ImportOntologyImportRootUsageKind_getInstance());
    usageKinds($this$findUsages, [TypeOfOldPropertyNotionUsageKind_getInstance(), TypeOfOldLinkOntologyUsageKind_getInstance(), TypeOfOldLinkOntologyElementUsageKind_getInstance()]);
    usageKinds($this$findUsages, [SuperPropertyUsageKind_getInstance(), InversePropertyUsageKind_getInstance()]);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body = btbFindUsages$lambda$lambda;
    $this$findUsages.v8c(getKClass(OntologyElement_1), body);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_0 = btbFindUsages$lambda$lambda_0;
    $this$findUsages.v8c(getKClass(Category_1), body_0);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_1 = btbFindUsages$lambda$lambda_1;
    $this$findUsages.v8c(getKClass(FactSet_1), body_1);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_2 = btbFindUsages$lambda$lambda_2;
    $this$findUsages.v8c(getKClass(Fact_1), body_2);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_3 = btbFindUsages$lambda$lambda_3;
    $this$findUsages.v8c(getKClass(VariableDeclaration_1), body_3);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_4 = btbFindUsages$lambda$lambda_4;
    $this$findUsages.v8c(getKClass(ObjectPropertyDeclaration_1), body_4);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_5 = btbFindUsages$lambda$lambda_5;
    $this$findUsages.v8c(getKClass(ProcessDeclaration_1), body_5);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_6 = btbFindUsages$lambda$lambda_6;
    $this$findUsages.v8c(getKClass(FunctionDeclaration_1), body_6);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_7 = btbFindUsages$lambda$lambda_7;
    $this$findUsages.v8c(getKClass(OntologyImport_1), body_7);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_8 = btbFindUsages$lambda$lambda_8;
    $this$findUsages.v8c(getKClass(ExtensionDeclaration_1), body_8);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_9 = btbFindUsages$lambda$lambda_9;
    $this$findUsages.v8c(getKClass(OntologyImportRootReference_1), body_9);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_10 = btbFindUsages$lambda$lambda_10;
    $this$findUsages.v8c(getKClass(PropertyDeclaration_1), body_10);
    // Inline function 'jetbrains.ocelot.langDef.usages.ruleFor' call
    var body_11 = btbFindUsages$lambda$lambda_11;
    $this$findUsages.v8c(getKClass(LinkDeclaration_1), body_11);
    var tmp = SuperElementUsageKind_getInstance();
    $this$findUsages.x8c(tmp, btbFindUsages$lambda$lambda_12);
    var tmp_0 = OntologyInSuperElementUsageKind_getInstance();
    $this$findUsages.x8c(tmp_0, btbFindUsages$lambda$lambda_13);
    var tmp_1 = PartOfElementUsageKind_getInstance();
    $this$findUsages.x8c(tmp_1, btbFindUsages$lambda$lambda_14);
    var tmp_2 = OntologyInPartOfElementUsageKind_getInstance();
    $this$findUsages.x8c(tmp_2, btbFindUsages$lambda$lambda_15);
    var tmp_3 = ElementsTaxonUsageKind_getInstance();
    $this$findUsages.x8c(tmp_3, btbFindUsages$lambda$lambda_16);
    var tmp_4 = OntologyInElementsTaxonUsageKind_getInstance();
    $this$findUsages.x8c(tmp_4, btbFindUsages$lambda$lambda_17);
    var tmp_5 = ElementInCategoryUsageKind_getInstance();
    $this$findUsages.x8c(tmp_5, btbFindUsages$lambda$lambda_18);
    var tmp_6 = OntologyInCategoryUsageKind_getInstance();
    $this$findUsages.x8c(tmp_6, btbFindUsages$lambda$lambda_19);
    var tmp_7 = ElementInFactSetContextUsageKind_getInstance();
    $this$findUsages.x8c(tmp_7, btbFindUsages$lambda$lambda_20);
    var tmp_8 = OntologyInFactSetContextUsageKind_getInstance();
    $this$findUsages.x8c(tmp_8, btbFindUsages$lambda$lambda_21);
    var tmp_9 = SomethingAsVariableSpecUsageKind_getInstance();
    $this$findUsages.x8c(tmp_9, btbFindUsages$lambda$lambda_22);
    var tmp_10 = AnythingInsideFactUsageKind_getInstance();
    $this$findUsages.x8c(tmp_10, btbFindUsages$lambda$lambda_23);
    var tmp_11 = ProcessKindUsageKind_getInstance();
    $this$findUsages.x8c(tmp_11, btbFindUsages$lambda$lambda_24);
    var tmp_12 = ExtendedProcessUsageKind_getInstance();
    $this$findUsages.x8c(tmp_12, btbFindUsages$lambda$lambda_25);
    var tmp_13 = InheritedProcessUsageKind_getInstance();
    $this$findUsages.x8c(tmp_13, btbFindUsages$lambda$lambda_26);
    var tmp_14 = OntologyElementInAbstractBindingElementsUsageKind_getInstance();
    $this$findUsages.x8c(tmp_14, btbFindUsages$lambda$lambda_27);
    var tmp_15 = OntologyInAbstractBindingElementsUsageKind_getInstance();
    $this$findUsages.x8c(tmp_15, btbFindUsages$lambda$lambda_28);
    var tmp_16 = AnythingInsideCustomEditorUsageKind_getInstance();
    $this$findUsages.x8c(tmp_16, btbFindUsages$lambda$lambda_29);
    var tmp_17 = AliasedPropertyUsageKind_getInstance();
    $this$findUsages.x8c(tmp_17, btbFindUsages$lambda$lambda_30);
    var tmp_18 = PropertyTypeOntologyUsageKind_getInstance();
    $this$findUsages.x8c(tmp_18, btbFindUsages$lambda$lambda_31);
    var tmp_19 = PropertyTypeOntologyElementUsageKind_getInstance();
    $this$findUsages.x8c(tmp_19, btbFindUsages$lambda$lambda_32);
    var tmp_20 = PropertyTypeNotionUsageKind_getInstance();
    $this$findUsages.x8c(tmp_20, btbFindUsages$lambda$lambda_33);
    var tmp_21 = OldPropertyTypeNotionUsageKind_getInstance();
    $this$findUsages.x8c(tmp_21, btbFindUsages$lambda$lambda_34);
    var tmp_22 = OldImportedPropertyUsageKind_getInstance();
    $this$findUsages.x8c(tmp_22, btbFindUsages$lambda$lambda_35);
    var tmp_23 = OldLinkOntologyUsageKind_getInstance();
    $this$findUsages.x8c(tmp_23, btbFindUsages$lambda$lambda_36);
    var tmp_24 = OldLinkOntologyElementUsageKind_getInstance();
    $this$findUsages.x8c(tmp_24, btbFindUsages$lambda$lambda_37);
    var tmp_25 = OldImportedLinkUsageKind_getInstance();
    $this$findUsages.x8c(tmp_25, btbFindUsages$lambda$lambda_38);
    var tmp_26 = OldLinkSpecializesLinkUsageKind_getInstance();
    $this$findUsages.x8c(tmp_26, btbFindUsages$lambda$lambda_39);
    var tmp_27 = FunctionReturnTypeOntologyUsageKind_getInstance();
    $this$findUsages.x8c(tmp_27, btbFindUsages$lambda$lambda_40);
    var tmp_28 = FunctionReturnTypeOntologyElementUsageKind_getInstance();
    $this$findUsages.x8c(tmp_28, btbFindUsages$lambda$lambda_41);
    var tmp_29 = InOntologyImportForOntologyUsageKind_getInstance();
    $this$findUsages.x8c(tmp_29, btbFindUsages$lambda$lambda_42);
    var tmp_30 = InOntologyImportForOntologyElementUsageKind_getInstance();
    $this$findUsages.x8c(tmp_30, btbFindUsages$lambda$lambda_43);
    var tmp_31 = InOntologyImportOntologyToUseUsageKind_getInstance();
    $this$findUsages.x8c(tmp_31, btbFindUsages$lambda$lambda_44);
    var tmp_32 = ExtensionTypeOntologyUsageKind_getInstance();
    $this$findUsages.x8c(tmp_32, btbFindUsages$lambda$lambda_45);
    var tmp_33 = ExtensionTypeOntologyElementUsageKind_getInstance();
    $this$findUsages.x8c(tmp_33, btbFindUsages$lambda$lambda_46);
    var tmp_34 = ExtensionFieldOntologyUsageKind_getInstance();
    $this$findUsages.x8c(tmp_34, btbFindUsages$lambda$lambda_47);
    var tmp_35 = ExtensionFieldOntologyElementUsageKind_getInstance();
    $this$findUsages.x8c(tmp_35, btbFindUsages$lambda$lambda_48);
    var tmp_36 = ImportOntologyImportRootUsageKind_getInstance();
    $this$findUsages.x8c(tmp_36, btbFindUsages$lambda$lambda_49);
    var tmp_37 = PublishedSourceUsageKind_getInstance();
    $this$findUsages.x8c(tmp_37, btbFindUsages$lambda$lambda_50);
    var tmp_38 = TypeOfOldPropertyNotionUsageKind_getInstance();
    $this$findUsages.x8c(tmp_38, btbFindUsages$lambda$lambda_51);
    var tmp_39 = TypeOfOldLinkOntologyUsageKind_getInstance();
    $this$findUsages.x8c(tmp_39, btbFindUsages$lambda$lambda_52);
    var tmp_40 = TypeOfOldLinkOntologyElementUsageKind_getInstance();
    $this$findUsages.x8c(tmp_40, btbFindUsages$lambda$lambda_53);
    var tmp_41 = SuperPropertyUsageKind_getInstance();
    $this$findUsages.x8c(tmp_41, btbFindUsages$lambda$lambda_54);
    var tmp_42 = InversePropertyUsageKind_getInstance();
    $this$findUsages.x8c(tmp_42, btbFindUsages$lambda$lambda_55);
    return Unit_instance;
  }
  function invoke$handleAbstractBindingDeclaration(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.egx();
    var tmp1_subject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i6u();
    var tmp;
    if (equals(tmp1_subject, properties$factory_1())) {
      var tmp2_subject = get_targetConcept(_this__u8e3s4);
      tmp = tmp2_subject.equals(getKClass(ProcessProperty_1)) ? new ProperUsage(AliasedPropertyUsageKind_getInstance()) : tmp2_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(PropertyTypeOntologyElementUsageKind_getInstance()) : tmp2_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(PropertyTypeOntologyUsageKind_getInstance()) : tmp2_subject.equals(getKClass(AbstractNotion)) ? new ProperUsage(PropertyTypeNotionUsageKind_getInstance()) : DontKnow_getInstance();
    } else if (equals(tmp1_subject, entries$factory_0())) {
      // Inline function 'kotlin.run' call
      // Inline function 'jetbrains.biokb.lang.model.findUsages.btbFindUsages$lambda.invoke.handleAbstractBindingDeclaration.<anonymous>' call
      var tmp_0;
      if (equals(_this__u8e3s4.l8c().k8c_1.h6o_1, specializes$factory_0())) {
        tmp_0 = new ProperUsage(OldLinkSpecializesLinkUsageKind_getInstance());
      } else {
        var tmp0_subject = get_targetConcept(_this__u8e3s4);
        tmp_0 = tmp0_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(OldLinkOntologyElementUsageKind_getInstance()) : tmp0_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OldLinkOntologyUsageKind_getInstance()) : tmp0_subject.equals(getKClass(AbstractNotion)) ? new ProperUsage(OldPropertyTypeNotionUsageKind_getInstance()) : tmp0_subject.equals(getKClass(PropertyDeclaration_1)) ? new ProperUsage(OldImportedPropertyUsageKind_getInstance()) : tmp0_subject.equals(getKClass(LinkDeclaration_1)) ? new ProperUsage(OldImportedLinkUsageKind_getInstance()) : DontKnow_getInstance();
      }
      tmp = tmp_0;
    } else if (equals(tmp1_subject, ontologyElements$factory_0())) {
      var tmp3_subject = get_targetConcept(_this__u8e3s4);
      tmp = tmp3_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OntologyElementInAbstractBindingElementsUsageKind_getInstance()) : tmp3_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(OntologyInAbstractBindingElementsUsageKind_getInstance()) : DontKnow_getInstance();
    } else if (equals(tmp1_subject, customEditor$factory_0())) {
      tmp = new ProperUsage(AnythingInsideCustomEditorUsageKind_getInstance());
    } else {
      tmp = DontKnow_getInstance();
    }
    return tmp;
  }
  function btbFindUsages$lambda$lambda($this$ruleFor) {
    var tmp0_safe_receiver = $this$ruleFor.egx();
    var tmp1_subject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i6u();
    var tmp;
    if (equals(tmp1_subject, superElements$factory_0())) {
      var tmp2_subject = get_targetConcept($this$ruleFor);
      tmp = tmp2_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(SuperElementUsageKind_getInstance()) : tmp2_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OntologyInSuperElementUsageKind_getInstance()) : DontKnow_getInstance();
    } else if (equals(tmp1_subject, enclosingElements$factory_0())) {
      var tmp3_subject = get_targetConcept($this$ruleFor);
      tmp = tmp3_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(PartOfElementUsageKind_getInstance()) : tmp3_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OntologyInPartOfElementUsageKind_getInstance()) : DontKnow_getInstance();
    } else if (equals(tmp1_subject, taxon$factory_0())) {
      var tmp4_subject = get_targetConcept($this$ruleFor);
      tmp = tmp4_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(ElementsTaxonUsageKind_getInstance()) : tmp4_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OntologyInElementsTaxonUsageKind_getInstance()) : DontKnow_getInstance();
    } else {
      tmp = DontKnow_getInstance();
    }
    return tmp;
  }
  function btbFindUsages$lambda$lambda_0($this$ruleFor) {
    var tmp0_subject = get_targetConcept($this$ruleFor);
    return tmp0_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OntologyInCategoryUsageKind_getInstance()) : tmp0_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(ElementInCategoryUsageKind_getInstance()) : DontKnow_getInstance();
  }
  function btbFindUsages$lambda$lambda_1($this$ruleFor) {
    var tmp;
    var tmp_0;
    var tmp1_safe_receiver = $this$ruleFor.egx();
    if (equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.i6u(), factsContext$factory_0())) {
      tmp_0 = true;
    } else {
      var tmp2_safe_receiver = $this$ruleFor.egx();
      tmp_0 = equals(tmp2_safe_receiver == null ? null : tmp2_safe_receiver.i6u(), contexts$factory_0());
    }
    if (tmp_0) {
      var tmp0_subject = get_targetConcept($this$ruleFor);
      tmp = tmp0_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(OntologyInFactSetContextUsageKind_getInstance()) : tmp0_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(ElementInFactSetContextUsageKind_getInstance()) : DontKnow_getInstance();
    } else {
      tmp = DontKnow_getInstance();
    }
    return tmp;
  }
  function btbFindUsages$lambda$lambda_2($this$ruleFor) {
    return new ProperUsage(AnythingInsideFactUsageKind_getInstance());
  }
  function btbFindUsages$lambda$lambda_3($this$ruleFor) {
    var tmp;
    var tmp0_safe_receiver = $this$ruleFor.egx();
    if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i6u(), spec$factory_0())) {
      tmp = new ProperUsage(SomethingAsVariableSpecUsageKind_getInstance());
    } else {
      tmp = DontKnow_getInstance();
    }
    return tmp;
  }
  function btbFindUsages$lambda$lambda_4($this$ruleFor) {
    var tmp0_subject = $this$ruleFor.l8c().k8c_1;
    var tmp;
    // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
    var this_0 = superProperty$factory_0();
    var tmp$ret$0 = new ReferenceLink(getKClass(ObjectPropertyDeclaration_1), this_0, getKClass(ObjectPropertyDeclaration_1));
    if (tmp0_subject.equals(tmp$ret$0)) {
      tmp = new ProperUsage(SuperPropertyUsageKind_getInstance());
    } else {
      // Inline function 'jetbrains.ocelot.langDef.references.asLink' call
      var this_1 = inverse$factory_0();
      var tmp$ret$1 = new ReferenceLink(getKClass(ObjectPropertyDeclaration_1), this_1, getKClass(ObjectPropertyDeclaration_1));
      if (tmp0_subject.equals(tmp$ret$1)) {
        tmp = new ProperUsage(InversePropertyUsageKind_getInstance());
      } else {
        tmp = DontKnow_getInstance();
      }
    }
    return tmp;
  }
  function btbFindUsages$lambda$lambda_5($this$ruleFor) {
    var tmp0_subject = $this$ruleFor.l8c().k8c_1.h6o_1;
    var tmp;
    if (equals(tmp0_subject, extends$factory_0())) {
      tmp = new ProperUsage(ExtendedProcessUsageKind_getInstance());
    } else if (equals(tmp0_subject, kind$factory_2())) {
      tmp = new ProperUsage(ProcessKindUsageKind_getInstance());
    } else {
      var tmp1_safe_receiver = $this$ruleFor.egx();
      var tmp2_subject = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.i6u();
      var tmp_0;
      if (equals(tmp2_subject, inherited$factory_0())) {
        var tmp_1;
        if (get_targetConcept($this$ruleFor).equals(getKClass(ProcessDeclaration_1))) {
          tmp_1 = new ProperUsage(InheritedProcessUsageKind_getInstance());
        } else {
          tmp_1 = DontKnow_getInstance();
        }
        tmp_0 = tmp_1;
      } else {
        tmp_0 = invoke$handleAbstractBindingDeclaration($this$ruleFor);
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function btbFindUsages$lambda$lambda_6($this$ruleFor) {
    var tmp0_safe_receiver = $this$ruleFor.egx();
    var tmp1_subject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i6u();
    var tmp;
    if (equals(tmp1_subject, returnType$factory_0())) {
      var tmp2_subject = get_targetConcept($this$ruleFor);
      tmp = tmp2_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(FunctionReturnTypeOntologyElementUsageKind_getInstance()) : tmp2_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(FunctionReturnTypeOntologyUsageKind_getInstance()) : DontKnow_getInstance();
    } else {
      tmp = invoke$handleAbstractBindingDeclaration($this$ruleFor);
    }
    return tmp;
  }
  function btbFindUsages$lambda$lambda_7($this$ruleFor) {
    var tmp0_safe_receiver = $this$ruleFor.egx();
    var tmp1_subject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i6u();
    return equals(tmp1_subject, ontology$factory_0()) ? new ProperUsage(InOntologyImportForOntologyUsageKind_getInstance()) : equals(tmp1_subject, element$factory_8()) ? new ProperUsage(InOntologyImportForOntologyElementUsageKind_getInstance()) : equals(tmp1_subject, libraryToUse$factory_0()) ? new ProperUsage(InOntologyImportOntologyToUseUsageKind_getInstance()) : DontKnow_getInstance();
  }
  function btbFindUsages$lambda$lambda_8($this$ruleFor) {
    var tmp0_safe_receiver = $this$ruleFor.egx();
    var tmp1_subject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i6u();
    var tmp;
    if (equals(tmp1_subject, type$factory_5())) {
      var tmp2_subject = get_targetConcept($this$ruleFor);
      tmp = tmp2_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(ExtensionTypeOntologyUsageKind_getInstance()) : tmp2_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(ExtensionTypeOntologyElementUsageKind_getInstance()) : DontKnow_getInstance();
    } else if (equals(tmp1_subject, fields$factory_0())) {
      var tmp3_subject = get_targetConcept($this$ruleFor);
      tmp = tmp3_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(ExtensionFieldOntologyUsageKind_getInstance()) : tmp3_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(ExtensionFieldOntologyElementUsageKind_getInstance()) : DontKnow_getInstance();
    } else {
      tmp = DontKnow_getInstance();
    }
    return tmp;
  }
  function btbFindUsages$lambda$lambda_9($this$ruleFor) {
    return new ProperUsage(ImportOntologyImportRootUsageKind_getInstance());
  }
  function btbFindUsages$lambda$lambda_10($this$ruleFor) {
    var tmp;
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = $this$ruleFor.l8c().j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(PropertyLibrary_1));
    if (execute_0(tmp$ret$0) == null) {
      tmp = DontKnow_getInstance();
    } else {
      tmp = new ProperUsage(TypeOfOldPropertyNotionUsageKind_getInstance());
    }
    return tmp;
  }
  function btbFindUsages$lambda$lambda_11($this$ruleFor) {
    var tmp;
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = $this$ruleFor.l8c().j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(LinkLibrary_1));
    if (execute_0(tmp$ret$0) == null) {
      tmp = DontKnow_getInstance();
    } else {
      var tmp0_subject = get_targetConcept($this$ruleFor);
      tmp = tmp0_subject.equals(getKClass(OntologyLibrary_1)) ? new ProperUsage(TypeOfOldLinkOntologyUsageKind_getInstance()) : tmp0_subject.equals(getKClass(OntologyElement_1)) ? new ProperUsage(TypeOfOldLinkOntologyElementUsageKind_getInstance()) : DontKnow_getInstance();
    }
    return tmp;
  }
  function btbFindUsages$lambda$lambda_12(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(OntologyIsRelation_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new SuperElementUsage(element, ensureNotNull(tmp$ret$1), OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_13(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(OntologyIsRelation_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new SuperElementUsage(element, ensureNotNull(tmp$ret$1), OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_14(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(OntologyCardinalityRelation_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new PartOfElementUsage(element, ensureNotNull(tmp$ret$1), OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_15(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(OntologyCardinalityRelation_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new PartOfElementUsage(element, ensureNotNull(tmp$ret$1), OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_16(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(QualifiedOntologyElementReference_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new ElementsTaxonUsage(element, ensureNotNull(tmp$ret$1), OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_17(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(QualifiedOntologyElementReference_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new ElementsTaxonUsage(element, ensureNotNull(tmp$ret$1), OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_18(category, _unused_var__etf5q3) {
    return new CategoryOntologyUsage(category, OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_19(category, _unused_var__etf5q3) {
    return new CategoryOntologyUsage(category, OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_20(factSet, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(Context_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new FactSetContextOntologyUsage(factSet, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_21(factSet, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(Context_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new FactSetContextOntologyUsage(factSet, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_22(variable, _unused_var__etf5q3) {
    return new SomethingAsVariableSpecUsage(variable);
  }
  function btbFindUsages$lambda$lambda_23(fact, _unused_var__etf5q3) {
    return new AnyUsageInFact(fact);
  }
  function btbFindUsages$lambda$lambda_24(process, _unused_var__etf5q3) {
    return new ProcessKindUsage(process);
  }
  function btbFindUsages$lambda$lambda_25(process, _unused_var__etf5q3) {
    return new ExtendedProcessUsage(process);
  }
  function btbFindUsages$lambda$lambda_26(process, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessReference_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new InheritedProcessUsage(process, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_27(process, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(OntologyElementType_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OntologyElementInBindingDeclarationUsage(process, ensureNotNull(tmp$ret$1), OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_28(process, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(OntologyElementType_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OntologyElementInBindingDeclarationUsage(process, ensureNotNull(tmp$ret$1), OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_29(process, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(CustomCell));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new AnythingInsideCustomEditorUsage(process, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_30(element, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessProperty_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    var tmp = ensureNotNull(tmp$ret$1);
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_1 = referenceContext.j8c_1;
    var tmp$ret$2 = ancestorOrSelf(this_1, getKClass(ProcessPropertyReference));
    var tmp$ret$3 = execute_0(tmp$ret$2);
    return new AliasedBindingPropertyUsage(element, tmp, ensureNotNull(tmp$ret$3));
  }
  function btbFindUsages$lambda$lambda_31(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessProperty_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new PropertyTypeUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_32(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessProperty_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new PropertyTypeUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_33(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessProperty_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new PropertyTypeUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_34(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(PropertyDeclaration_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OldPropertyTypeNotionUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_35(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ImportedProperty_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OldImportedPropertyUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_36(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(LinkDeclaration_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OldLinkOntologyUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_37(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(LinkDeclaration_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OldLinkOntologyUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_38(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ImportedLink_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OldImportedLinkUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_39(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(AbstractLink));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OldLinkSpecializesLinkUsage(node, ensureNotNull(tmp$ret$1));
  }
  function btbFindUsages$lambda$lambda_40(node, _unused_var__etf5q3) {
    return new OntologyInFunctionReturnTypeUsage(node, OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_41(node, _unused_var__etf5q3) {
    return new OntologyInFunctionReturnTypeUsage(node, OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_42(import_0, _unused_var__etf5q3) {
    return new InOntologyImportForOntologyUsage(import_0, OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_43(import_0, _unused_var__etf5q3) {
    return new InOntologyImportForOntologyUsage(import_0, OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_44(import_0, _unused_var__etf5q3) {
    return new InOntologyImportOntologyToUseUsage(import_0);
  }
  function btbFindUsages$lambda$lambda_45(node, _unused_var__etf5q3) {
    return new OntologyInExtensionTypeUsage(node, OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_46(node, _unused_var__etf5q3) {
    return new OntologyInExtensionTypeUsage(node, OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_47(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(FieldDeclaration_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OntologyInExtensionFieldUsage(node, ensureNotNull(tmp$ret$1), OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_48(node, referenceContext) {
    // Inline function 'jetbrains.biokb.lang.model.findUsages.ancestor' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = referenceContext.j8c_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(FieldDeclaration_1));
    var tmp$ret$1 = execute_0(tmp$ret$0);
    return new OntologyInExtensionFieldUsage(node, ensureNotNull(tmp$ret$1), OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_49(node, _unused_var__etf5q3) {
    return new ImportOntologyImportRootUsage(node);
  }
  function btbFindUsages$lambda$lambda_50(node, _unused_var__etf5q3) {
    return new PublishedSourceUsage(node);
  }
  function btbFindUsages$lambda$lambda_51(node, _unused_var__etf5q3) {
    return new TypeOfOldPropertyDeclarationUsage(node);
  }
  function btbFindUsages$lambda$lambda_52(node, _unused_var__etf5q3) {
    return new TypeOfOldLinkDeclarationUsage(node, OntologyTargetKind_ONTOLOGY_getInstance());
  }
  function btbFindUsages$lambda$lambda_53(node, _unused_var__etf5q3) {
    return new TypeOfOldLinkDeclarationUsage(node, OntologyTargetKind_ELEMENT_getInstance());
  }
  function btbFindUsages$lambda$lambda_54(node, _unused_var__etf5q3) {
    return new ObjectPropertyUsageByAnotherProperty(node, ObjectPropertyUsageByAnotherPropertyKind_SUPER_PROPERTY_getInstance());
  }
  function btbFindUsages$lambda$lambda_55(node, _unused_var__etf5q3) {
    return new ObjectPropertyUsageByAnotherProperty(node, ObjectPropertyUsageByAnotherPropertyKind_INVERSE_PROPERTY_getInstance());
  }
  function properties$factory_1() {
    return getPropertyCallableRef('properties', 1, KProperty1, function (receiver) {
      return receiver.pas();
    }, null);
  }
  function entries$factory_0() {
    return getPropertyCallableRef('entries', 1, KProperty1, function (receiver) {
      return receiver.w();
    }, null);
  }
  function specializes$factory_0() {
    return getPropertyCallableRef('specializes', 1, KProperty1, function (receiver) {
      return receiver.jat();
    }, null);
  }
  function ontologyElements$factory_0() {
    return getPropertyCallableRef('ontologyElements', 1, KProperty1, function (receiver) {
      return receiver.oas();
    }, null);
  }
  function customEditor$factory_0() {
    return getPropertyCallableRef('customEditor', 1, KProperty1, function (receiver) {
      return receiver.qas();
    }, null);
  }
  function superElements$factory_0() {
    return getPropertyCallableRef('superElements', 1, KProperty1, function (receiver) {
      return receiver.gbu();
    }, null);
  }
  function enclosingElements$factory_0() {
    return getPropertyCallableRef('enclosingElements', 1, KProperty1, function (receiver) {
      return receiver.hbu();
    }, null);
  }
  function taxon$factory_0() {
    return getPropertyCallableRef('taxon', 1, KProperty1, function (receiver) {
      return receiver.ibu();
    }, null);
  }
  function factsContext$factory_0() {
    return getPropertyCallableRef('factsContext', 1, KProperty1, function (receiver) {
      return receiver.nb7();
    }, null);
  }
  function contexts$factory_0() {
    return getPropertyCallableRef('contexts', 1, KProperty1, function (receiver) {
      return receiver.ob7();
    }, null);
  }
  function spec$factory_0() {
    return getPropertyCallableRef('spec', 1, KProperty1, function (receiver) {
      return receiver.jcq();
    }, null);
  }
  function superProperty$factory_0() {
    return getPropertyCallableRef('superProperty', 1, KProperty1, function (receiver) {
      return receiver.xbq();
    }, null);
  }
  function inverse$factory_0() {
    return getPropertyCallableRef('inverse', 1, KProperty1, function (receiver) {
      return receiver.zbq();
    }, null);
  }
  function extends$factory_0() {
    return getPropertyCallableRef('extends', 1, KProperty1, function (receiver) {
      return receiver.gc7();
    }, null);
  }
  function kind$factory_2() {
    return getPropertyCallableRef('kind', 1, KProperty1, function (receiver) {
      return receiver.r5e();
    }, null);
  }
  function inherited$factory_0() {
    return getPropertyCallableRef('inherited', 1, KProperty1, function (receiver) {
      return receiver.hc7();
    }, null);
  }
  function returnType$factory_0() {
    return getPropertyCallableRef('returnType', 1, KProperty1, function (receiver) {
      return receiver.kb9();
    }, null);
  }
  function ontology$factory_0() {
    return getPropertyCallableRef('ontology', 1, KProperty1, function (receiver) {
      return receiver.sby();
    }, null);
  }
  function element$factory_8() {
    return getPropertyCallableRef('element', 1, KProperty1, function (receiver) {
      return receiver.lay();
    }, null);
  }
  function libraryToUse$factory_0() {
    return getPropertyCallableRef('libraryToUse', 1, KProperty1, function (receiver) {
      return receiver.tby();
    }, null);
  }
  function type$factory_5() {
    return getPropertyCallableRef('type', 1, KProperty1, function (receiver) {
      return receiver.zb3();
    }, null);
  }
  function fields$factory_0() {
    return getPropertyCallableRef('fields', 1, KProperty1, function (receiver) {
      return receiver.yb3();
    }, null);
  }
  function BTBNodeImpl(context, node) {
    BaseNodeGen.call(this, context.h6p_1, node);
  }
  function TypedBTBNodeImpl(context, nodeConceptId, nodeId) {
    BaseTypedOtNode.call(this, context, nodeConceptId, nodeId);
  }
  protoOf(TypedBTBNodeImpl).m6m = function () {
    var tmp = protoOf(BaseTypedOtNode).m6m.call(this);
    return isInterface(tmp, ReadableProperty) ? tmp : THROW_CCE();
  };
  protoOf(TypedBTBNodeImpl).yt = function () {
    var tmp = protoOf(BaseTypedOtNode).yt.call(this);
    return (!(tmp == null) ? isInterface(tmp, BTBNode) : false) ? tmp : null;
  };
  protoOf(TypedBTBNodeImpl).u6m = function () {
    var tmp = protoOf(BaseTypedOtNode).u6m.call(this);
    return isInterface(tmp, BTBNode) ? tmp : THROW_CCE();
  };
  function get_elementTypeAndTaxon() {
    _init_properties_BTBResolvers_kt__y423vn();
    return elementTypeAndTaxon;
  }
  var elementTypeAndTaxon;
  function get_onlyOntologyVars() {
    _init_properties_BTBResolvers_kt__y423vn();
    return onlyOntologyVars;
  }
  var onlyOntologyVars;
  function get_libraries() {
    _init_properties_BTBResolvers_kt__y423vn();
    return libraries;
  }
  var libraries;
  function get_ONTOLOGIES_WITH_SPECIES() {
    _init_properties_BTBResolvers_kt__y423vn();
    return ONTOLOGIES_WITH_SPECIES;
  }
  var ONTOLOGIES_WITH_SPECIES;
  function get_btbLanguageWithRemoteResolve() {
    _init_properties_BTBResolvers_kt__y423vn();
    return btbLanguageWithRemoteResolve;
  }
  var btbLanguageWithRemoteResolve;
  function get_btbLanguageWithPrecalculatedResolve() {
    _init_properties_BTBResolvers_kt__y423vn();
    return btbLanguageWithPrecalculatedResolve;
  }
  var btbLanguageWithPrecalculatedResolve;
  function get_btbLanguageWithLocalResolve() {
    _init_properties_BTBResolvers_kt__y423vn();
    return btbLanguageWithLocalResolve;
  }
  var btbLanguageWithLocalResolve;
  function btbRemoteResolve(_this__u8e3s4) {
    _init_properties_BTBResolvers_kt__y423vn();
    referenceFactories(_this__u8e3s4, btbRemoteResolve$lambda);
    referenceTargetsSuppliers(_this__u8e3s4, btbRemoteResolve$lambda_0);
    referenceTargetPresentationProviders(_this__u8e3s4, btbRemoteResolve$lambda_1);
  }
  function btbPrecalculatedResolve(_this__u8e3s4) {
    _init_properties_BTBResolvers_kt__y423vn();
    referenceFactories(_this__u8e3s4, btbPrecalculatedResolve$lambda);
    referenceTargetPresentationProviders(_this__u8e3s4, btbPrecalculatedResolve$lambda_0);
  }
  function btbLocalResolve(_this__u8e3s4) {
    _init_properties_BTBResolvers_kt__y423vn();
    referenceFactories(_this__u8e3s4, btbLocalResolve$lambda);
    referenceTargetsSuppliers(_this__u8e3s4, btbLocalResolve$lambda_0);
    referenceTargetPresentationProviders(_this__u8e3s4, btbLocalResolve$lambda_1);
  }
  function btbScopes(_this__u8e3s4) {
    _init_properties_BTBResolvers_kt__y423vn();
    scopes(_this__u8e3s4, btbScopes$lambda);
  }
  function librariesScope(_this__u8e3s4, librariesScopeProvider, library, $completion) {
    var elements = get_asObservable(toList_2(_this__u8e3s4.n51(librariesScopeProvider.f6z().n6z(library))));
    var taggedElements = new AnnotatedDocumentsList(library.b6r_1, elements);
    return _this__u8e3s4.t7a(get_forQueries_3(taggedElements), $completion);
  }
  function importOntologyLibrary(_this__u8e3s4, reference, $completion) {
    return _this__u8e3s4.v7a(reference.ub6(), $completion);
  }
  function importOntologyLibraries(_this__u8e3s4, libraryReferences, $completion) {
    var tmp = new $importOntologyLibrariesCOROUTINE$40(_this__u8e3s4, libraryReferences, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function propertyTypeElements(propertyValue) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.flatMap' call
    var this_0 = new propertyTypeElements$$inlined$suspendingQuery$1(propertyValue);
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new propertyTypeElements$$inlined$flatMap$1(this_0);
  }
  function typeElements(type) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new typeElements$$inlined$suspendingQuery$1(type);
  }
  function processPropertyElements(_this__u8e3s4, processProperty, $completion) {
    var tmp = new $processPropertyElementsCOROUTINE$41(_this__u8e3s4, processProperty, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function propertyFilterByDomainType(spec, specTrace) {
    specTrace = specTrace === VOID ? emptySet() : specTrace;
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new propertyFilterByDomainType$$inlined$suspendingQuery$1(spec, specTrace);
  }
  function filterObjectProperties(elements) {
    _init_properties_BTBResolvers_kt__y423vn();
    var tmp = Companion_instance_119;
    return tmp.a76(filterObjectProperties$slambda_0(elements, null));
  }
  function getCustomEditorPropertiesScope(_this__u8e3s4, customEditor, $completion) {
    var tmp = new $getCustomEditorPropertiesScopeCOROUTINE$42(_this__u8e3s4, customEditor, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function filterInstanceRelations(elements) {
    _init_properties_BTBResolvers_kt__y423vn();
    var tmp = Companion_instance_119;
    return tmp.a76(filterInstanceRelations$slambda_0(elements, null));
  }
  function filterInstanceRelations_0(typeNotion) {
    _init_properties_BTBResolvers_kt__y423vn();
    var tmp = Companion_instance_119;
    return tmp.a76(filterInstanceRelations$slambda_2(typeNotion, null));
  }
  function filterObjectProperties_0(typeNotion) {
    _init_properties_BTBResolvers_kt__y423vn();
    var tmp = Companion_instance_119;
    return tmp.a76(filterObjectProperties$slambda_2(typeNotion, null));
  }
  function libraryElementsScope(_this__u8e3s4, librariesScopeProvider, library, $completion) {
    var tmp = new $libraryElementsScopeCOROUTINE$43(_this__u8e3s4, librariesScopeProvider, library, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function btbLanguageWithRemoteResolve$lambda($this$language) {
    _init_properties_BTBResolvers_kt__y423vn();
    btbStructure($this$language);
    btbRemoteResolve($this$language);
    return Unit_instance;
  }
  function btbLanguageWithPrecalculatedResolve$lambda($this$language) {
    _init_properties_BTBResolvers_kt__y423vn();
    btbStructure($this$language);
    btbPrecalculatedResolve($this$language);
    btbFindUsages($this$language);
    return Unit_instance;
  }
  function btbLanguageWithLocalResolve$lambda($this$language) {
    _init_properties_BTBResolvers_kt__y423vn();
    btbStructure($this$language);
    btbLocalResolve($this$language);
    btbScopes($this$language);
    btbFindUsages($this$language);
    return Unit_instance;
  }
  function btbRemoteResolve$lambda($this$referenceFactories) {
    _init_properties_BTBResolvers_kt__y423vn();
    remote($this$referenceFactories, get_refTags($this$referenceFactories));
    return Unit_instance;
  }
  function btbRemoteResolve$lambda_0($this$referenceTargetsSuppliers) {
    _init_properties_BTBResolvers_kt__y423vn();
    remote_0($this$referenceTargetsSuppliers, get_refTags($this$referenceTargetsSuppliers));
    return Unit_instance;
  }
  function btbRemoteResolve$lambda_1($this$referenceTargetPresentationProviders) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = minus_1(get_refTags($this$referenceTargetPresentationProviders), Companion_getInstance_199().fch_1).k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.biokb.lang.model.resolve.btbRemoteResolve.<anonymous>.<anonymous>' call
      $this$referenceTargetPresentationProviders.z6x(element);
    }
    var tmp = Companion_getInstance_199().fch_1;
    var tmp_0 = btbRemoteResolve$lambda$lambda;
    $this$referenceTargetPresentationProviders.y6x(tmp, new sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1(tmp_0));
    return Unit_instance;
  }
  function sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1(function_0) {
    this.hh0_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1).o6u = function (target) {
    return this.hh0_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1).b4 = function () {
    return this.hh0_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, TargetPresentationProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_1).hashCode = function () {
    return hashCode(this.b4());
  };
  function btbRemoteResolve$lambda$lambda(it) {
    _init_properties_BTBResolvers_kt__y423vn();
    return it.dcu();
  }
  function btbPrecalculatedResolve$lambda($this$referenceFactories) {
    _init_properties_BTBResolvers_kt__y423vn();
    precalculated($this$referenceFactories, get_refTags($this$referenceFactories));
    return Unit_instance;
  }
  function btbPrecalculatedResolve$lambda_0($this$referenceTargetPresentationProviders) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = minus_1(get_refTags($this$referenceTargetPresentationProviders), Companion_getInstance_199().fch_1).k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.biokb.lang.model.resolve.btbPrecalculatedResolve.<anonymous>.<anonymous>' call
      $this$referenceTargetPresentationProviders.z6x(element);
    }
    var tmp = Companion_getInstance_199().fch_1;
    var tmp_0 = btbPrecalculatedResolve$lambda$lambda;
    $this$referenceTargetPresentationProviders.y6x(tmp, new sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2(tmp_0));
    return Unit_instance;
  }
  function sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2(function_0) {
    this.ih0_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2).o6u = function (target) {
    return this.ih0_1(target);
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2).b4 = function () {
    return this.ih0_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, TargetPresentationProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_references_TargetPresentationProvider$0_2).hashCode = function () {
    return hashCode(this.b4());
  };
  function btbPrecalculatedResolve$lambda$lambda(it) {
    _init_properties_BTBResolvers_kt__y423vn();
    return it.dcu();
  }
  function btbLocalResolve$lambda($this$referenceFactories) {
    _init_properties_BTBResolvers_kt__y423vn();
    scoped($this$referenceFactories, minus_1(get_refTags($this$referenceFactories), Companion_getInstance_199().fch_1));
    var publishedWorkReferenceResolver = new PublishedWorkReferenceResolver(Companion_instance_88.e2o($this$referenceFactories));
    $this$referenceFactories.p6x(Companion_getInstance_199().fch_1, Companion_instance_103.g6x(publishedWorkReferenceResolver));
    return Unit_instance;
  }
  function btbLocalResolve$lambda_0($this$referenceTargetsSuppliers) {
    _init_properties_BTBResolvers_kt__y423vn();
    scoped_2($this$referenceTargetsSuppliers, minus_1(get_refTags($this$referenceTargetsSuppliers), Companion_getInstance_199().fch_1));
    var publishedWorkReferenceTargetsSupplier = new PublishedWorkReferenceTargetsSupplier(Companion_instance_110.e2o($this$referenceTargetsSuppliers));
    $this$referenceTargetsSuppliers.h6y(Companion_getInstance_199().fch_1, publishedWorkReferenceTargetsSupplier);
    return Unit_instance;
  }
  function btbLocalResolve$lambda_1($this$referenceTargetPresentationProviders) {
    _init_properties_BTBResolvers_kt__y423vn();
    scoped_1($this$referenceTargetPresentationProviders, minus_1(get_refTags($this$referenceTargetPresentationProviders), Companion_getInstance_199().fch_1));
    $this$referenceTargetPresentationProviders.y6x(Companion_getInstance_199().fch_1, new PublishedWorkReferenceTargetPresentationProvider());
    return Unit_instance;
  }
  function btbScopes$lambda($this$scopes) {
    _init_properties_BTBResolvers_kt__y423vn();
    var librariesScopeProvider$delegate = Companion_instance_110.m2c();
    var subtypeScopeFilters$delegate = Companion_getInstance_225().m2c();
    var taxonScopeFilters$delegate = Companion_getInstance_226().m2c();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder = btbScopes$lambda$slambda_0(null);
    var evaluationStrategy = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp;
    if (null == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs = tmp;
    var origin = tmp1_elvis_lhs == null ? Lexical_getInstance() : tmp1_elvis_lhs;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(FactSet_1)), getKClass(Fact_1), evaluationStrategy, origin, builder));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_0 = btbScopes$lambda$slambda_2(null);
    var evaluationStrategy_0 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_0;
    if (null == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_0 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_0 = tmp_0;
    var origin_0 = tmp1_elvis_lhs_0 == null ? Lexical_getInstance() : tmp1_elvis_lhs_0;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(FactSet_1)), getKClass(VariableDeclaration_1), evaluationStrategy_0, origin_0, builder_0));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_1 = btbScopes$lambda$slambda_4(null);
    var evaluationStrategy_1 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_1;
    if (null == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_1 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_1 = tmp_1;
    var origin_1 = tmp1_elvis_lhs_1 == null ? Lexical_getInstance() : tmp1_elvis_lhs_1;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(Fact_1)), getKClass(Fact_1), evaluationStrategy_1, origin_1, builder_1));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_2 = btbScopes$lambda$slambda_6(null);
    var evaluationStrategy_2 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_2;
    if (null == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_2 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_2 = tmp_2;
    var origin_2 = tmp1_elvis_lhs_2 == null ? Lexical_getInstance() : tmp1_elvis_lhs_2;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(FactSet_1)), getKClass(NewFact), evaluationStrategy_2, origin_2, builder_2));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_3 = btbScopes$lambda$slambda_8(null);
    var evaluationStrategy_3 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_3;
    if (null == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_3 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_3 = tmp_3;
    var origin_3 = tmp1_elvis_lhs_3 == null ? Lexical_getInstance() : tmp1_elvis_lhs_3;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(NewFact)), getKClass(NewFact), evaluationStrategy_3, origin_3, builder_3));
    var tmp21 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_4 = btbScopes$lambda$slambda_10($this$scopes, taxonScopeFilters$delegate, null);
    $this$scopes.w77(new ConstrainScope($this$scopes.v77(getKClass(FactSet_1)), tmp21, builder_4));
    var tmp_4 = $this$scopes.o77($this$scopes.j78(getKClass(FindConnectionCommand_1), getKClass(OntologyElement_1)), get_elementTypeAndTaxon());
    $this$scopes.i78(tmp_4, btbScopes$lambda$slambda_12($this$scopes, taxonScopeFilters$delegate, null));
    var tmp24 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_5 = btbScopes$lambda$slambda_14(null);
    $this$scopes.w77(new ConstrainScope($this$scopes.v77(getKClass(OntologyIsRelation_1)), tmp24, builder_5));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder_6 = btbScopes$lambda$slambda_16(null);
    var evaluationStrategy_4 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyLibrary_1)), getKClass(OntologyElement_1), evaluationStrategy_4, Any_getInstance(), builder_6));
    var tmp30 = OntologyElementConcept_getInstance().qbt_1.g6n_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_7 = btbScopes$lambda$slambda_18(null);
    var evaluationStrategy_5 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_5;
    if (tmp30 == null) {
      tmp_5 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_5 = new LexicalWithRole(tmp30);
    }
    var tmp1_elvis_lhs_4 = tmp_5;
    var origin_4 = tmp1_elvis_lhs_4 == null ? Lexical_getInstance() : tmp1_elvis_lhs_4;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyElement_1)), getKClass(OntologyLibrary_1), evaluationStrategy_5, origin_4, builder_7));
    var tmp34 = OntologyElementConcept_getInstance().qbt_1.g6n_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_8 = btbScopes$lambda$slambda_20(null);
    var evaluationStrategy_6 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_6;
    if (tmp34 == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_6 = new LexicalWithRole(tmp34);
    }
    var tmp1_elvis_lhs_5 = tmp_6;
    var origin_5 = tmp1_elvis_lhs_5 == null ? Lexical_getInstance() : tmp1_elvis_lhs_5;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyElement_1)), getKClass(OntologyElement_1), evaluationStrategy_6, origin_5, builder_8));
    var tmp38 = OntologyElementConcept_getInstance().rbt_1.g6n_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_9 = btbScopes$lambda$slambda_22(null);
    var evaluationStrategy_7 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_7;
    if (tmp38 == null) {
      tmp_7 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_7 = new LexicalWithRole(tmp38);
    }
    var tmp1_elvis_lhs_6 = tmp_7;
    var origin_6 = tmp1_elvis_lhs_6 == null ? Lexical_getInstance() : tmp1_elvis_lhs_6;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyElement_1)), getKClass(OntologyLibrary_1), evaluationStrategy_7, origin_6, builder_9));
    var tmp42 = OntologyElementConcept_getInstance().xbt_1.g6n_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_10 = btbScopes$lambda$slambda_24(null);
    var evaluationStrategy_8 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_8;
    if (tmp42 == null) {
      tmp_8 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_8 = new LexicalWithRole(tmp42);
    }
    var tmp1_elvis_lhs_7 = tmp_8;
    var origin_7 = tmp1_elvis_lhs_7 == null ? Lexical_getInstance() : tmp1_elvis_lhs_7;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyElement_1)), getKClass(OntologyLibrary_1), evaluationStrategy_8, origin_7, builder_10));
    var tmp46 = OntologyElementConcept_getInstance().sbt_1.g6n_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_11 = btbScopes$lambda$slambda_26(null);
    var evaluationStrategy_9 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_9;
    if (tmp46 == null) {
      tmp_9 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_9 = new LexicalWithRole(tmp46);
    }
    var tmp1_elvis_lhs_8 = tmp_9;
    var origin_8 = tmp1_elvis_lhs_8 == null ? Lexical_getInstance() : tmp1_elvis_lhs_8;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyElement_1)), getKClass(OntologyLibrary_1), evaluationStrategy_9, origin_8, builder_11));
    var tmp50 = OntologyElementConcept_getInstance().sbt_1.g6n_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_12 = btbScopes$lambda$slambda_28(null);
    var evaluationStrategy_10 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_10;
    if (tmp50 == null) {
      tmp_10 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_10 = new LexicalWithRole(tmp50);
    }
    var tmp1_elvis_lhs_9 = tmp_10;
    var origin_9 = tmp1_elvis_lhs_9 == null ? Lexical_getInstance() : tmp1_elvis_lhs_9;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyElement_1)), getKClass(OntologyElement_1), evaluationStrategy_10, origin_9, builder_12));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_13 = btbScopes$lambda$slambda_30($this$scopes, librariesScopeProvider$delegate, null);
    var evaluationStrategy_11 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_11;
    if (null == null) {
      tmp_11 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_11 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_10 = tmp_11;
    var origin_10 = tmp1_elvis_lhs_10 == null ? Lexical_getInstance() : tmp1_elvis_lhs_10;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyLibrary_1)), getKClass(OntologyLibrary_1), evaluationStrategy_11, origin_10, builder_13));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_14 = btbScopes$lambda$slambda_32($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.w77(new DefaultScope(getKClass(OntologyLibrary_1), builder_14));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_15 = btbScopes$lambda$slambda_34(null);
    var evaluationStrategy_12 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_12;
    if (null == null) {
      tmp_12 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_12 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_11 = tmp_12;
    var origin_11 = tmp1_elvis_lhs_11 == null ? Lexical_getInstance() : tmp1_elvis_lhs_11;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(Context_1)), getKClass(OntologyElement_1), evaluationStrategy_12, origin_11, builder_15));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_16 = btbScopes$lambda$slambda_36(null);
    var evaluationStrategy_13 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_13;
    if (null == null) {
      tmp_13 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_13 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_12 = tmp_13;
    var origin_12 = tmp1_elvis_lhs_12 == null ? Lexical_getInstance() : tmp1_elvis_lhs_12;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ContextQuery_1)), getKClass(OntologyElement_1), evaluationStrategy_13, origin_12, builder_16));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_17 = btbScopes$lambda$slambda_38(null);
    var evaluationStrategy_14 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_14;
    if (null == null) {
      tmp_14 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_14 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_13 = tmp_14;
    var origin_13 = tmp1_elvis_lhs_13 == null ? Lexical_getInstance() : tmp1_elvis_lhs_13;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(QualifiedOntologyElementReference_1)), getKClass(OntologyElement_1), evaluationStrategy_14, origin_13, builder_17));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_18 = btbScopes$lambda$slambda_40(null);
    var evaluationStrategy_15 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_15;
    if (null == null) {
      tmp_15 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_15 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_14 = tmp_15;
    var origin_14 = tmp1_elvis_lhs_14 == null ? Lexical_getInstance() : tmp1_elvis_lhs_14;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(Category_1)), getKClass(OntologyElement_1), evaluationStrategy_15, origin_14, builder_18));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_19 = btbScopes$lambda$slambda_42(null);
    var evaluationStrategy_16 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_16;
    if (null == null) {
      tmp_16 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_16 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_15 = tmp_16;
    var origin_15 = tmp1_elvis_lhs_15 == null ? Lexical_getInstance() : tmp1_elvis_lhs_15;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyImport_1)), getKClass(OntologyElement_1), evaluationStrategy_16, origin_15, builder_19));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_20 = btbScopes$lambda$slambda_44(null);
    var evaluationStrategy_17 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_17;
    if (null == null) {
      tmp_17 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_17 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_16 = tmp_17;
    var origin_16 = tmp1_elvis_lhs_16 == null ? Lexical_getInstance() : tmp1_elvis_lhs_16;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyElementType_1)), getKClass(OntologyElement_1), evaluationStrategy_17, origin_16, builder_20));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_21 = btbScopes$lambda$slambda_46(null);
    var evaluationStrategy_18 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_18;
    if (null == null) {
      tmp_18 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_18 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_17 = tmp_18;
    var origin_17 = tmp1_elvis_lhs_17 == null ? Lexical_getInstance() : tmp1_elvis_lhs_17;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyElementPropertyType_1)), getKClass(OntologyElement_1), evaluationStrategy_18, origin_17, builder_21));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_22 = btbScopes$lambda$slambda_48(null);
    var evaluationStrategy_19 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_19;
    if (null == null) {
      tmp_19 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_19 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_18 = tmp_19;
    var origin_18 = tmp1_elvis_lhs_18 == null ? Lexical_getInstance() : tmp1_elvis_lhs_18;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(QueryParametersBlackList)), getKClass(OntologyElement_1), evaluationStrategy_19, origin_18, builder_22));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_23 = btbScopes$lambda$slambda_50(null);
    var evaluationStrategy_20 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_20;
    if (null == null) {
      tmp_20 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_20 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_19 = tmp_20;
    var origin_19 = tmp1_elvis_lhs_19 == null ? Lexical_getInstance() : tmp1_elvis_lhs_19;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ObjectPropertyDeclaration_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_20, origin_19, builder_23));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_24 = btbScopes$lambda$slambda_52($this$scopes, librariesScopeProvider$delegate, null);
    var evaluationStrategy_21 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_21;
    if (null == null) {
      tmp_21 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_21 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_20 = tmp_21;
    var origin_20 = tmp1_elvis_lhs_20 == null ? Lexical_getInstance() : tmp1_elvis_lhs_20;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PartValue)), getKClass(FieldDeclaration_1), evaluationStrategy_21, origin_20, builder_24));
    var tmp100 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_25 = btbScopes$lambda$slambda_54($this$scopes, subtypeScopeFilters$delegate, null);
    $this$scopes.w77(new ConstrainScope($this$scopes.v77(getKClass(OntologyLinkValue_1)), tmp100, builder_25));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_26 = btbScopes$lambda$slambda_56(null);
    var evaluationStrategy_22 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_22;
    if (null == null) {
      tmp_22 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_22 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_21 = tmp_22;
    var origin_21 = tmp1_elvis_lhs_21 == null ? Lexical_getInstance() : tmp1_elvis_lhs_21;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyLinkValue_1)), getKClass(OntologyElement_1), evaluationStrategy_22, origin_21, builder_26));
    var tmp107 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_27 = btbScopes$lambda$slambda_58($this$scopes, subtypeScopeFilters$delegate, null);
    $this$scopes.w77(new ConstrainScope($this$scopes.v77(getKClass(ProcessPropertyValue_1)), tmp107, builder_27));
    var tmp110 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_28 = btbScopes$lambda$slambda_60($this$scopes, subtypeScopeFilters$delegate, null);
    $this$scopes.w77(new ConstrainScope($this$scopes.v77(getKClass(InstanceRelationValue)), tmp110, builder_28));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_29 = btbScopes$lambda$slambda_62(null);
    var evaluationStrategy_23 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_23;
    if (null == null) {
      tmp_23 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_23 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_22 = tmp_23;
    var origin_22 = tmp1_elvis_lhs_22 == null ? Lexical_getInstance() : tmp1_elvis_lhs_22;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyConstraint_1)), getKClass(OntologyLibrary_1), evaluationStrategy_23, origin_22, builder_29));
    var tmp117 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_30 = btbScopes$lambda$slambda_64($this$scopes, subtypeScopeFilters$delegate, null);
    $this$scopes.w77(new ConstrainScope($this$scopes.v77(getKClass(IsExpression_1)), tmp117, builder_30));
    var tmp120 = get_elementTypeAndTaxon();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_31 = btbScopes$lambda$slambda_66($this$scopes, subtypeScopeFilters$delegate, null);
    $this$scopes.w77(new ConstrainScope($this$scopes.v77(getKClass(ProcessPropertyDefault_1)), tmp120, builder_31));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_32 = btbScopes$lambda$slambda_68(null);
    var evaluationStrategy_24 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_24;
    if (null == null) {
      tmp_24 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_24 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_23 = tmp_24;
    var origin_23 = tmp1_elvis_lhs_23 == null ? Lexical_getInstance() : tmp1_elvis_lhs_23;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessPropertyValue_1)), getKClass(OntologyElement_1), evaluationStrategy_24, origin_23, builder_32));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_33 = btbScopes$lambda$slambda_70(null);
    var evaluationStrategy_25 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_25;
    if (null == null) {
      tmp_25 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_25 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_24 = tmp_25;
    var origin_24 = tmp1_elvis_lhs_24 == null ? Lexical_getInstance() : tmp1_elvis_lhs_24;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(IsExpression_1)), getKClass(OntologyElement_1), evaluationStrategy_25, origin_24, builder_33));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_34 = btbScopes$lambda$slambda_72(null);
    var evaluationStrategy_26 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_26;
    if (null == null) {
      tmp_26 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_26 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_25 = tmp_26;
    var origin_25 = tmp1_elvis_lhs_25 == null ? Lexical_getInstance() : tmp1_elvis_lhs_25;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyElementReferenceValueLibrary_1)), getKClass(OntologyElement_1), evaluationStrategy_26, origin_25, builder_34));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_35 = btbScopes$lambda$slambda_74(null);
    var evaluationStrategy_27 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(EnumerableNotion_1)), getKClass(EnumerationConstant_1), evaluationStrategy_27, Import_getInstance(), builder_35));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_36 = btbScopes$lambda$slambda_76(null);
    var evaluationStrategy_28 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(MeasurableNotion_1)), getKClass(MeasurementUnit_1), evaluationStrategy_28, Import_getInstance(), builder_36));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_37 = btbScopes$lambda$slambda_78(null);
    var evaluationStrategy_29 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyDeclaration_1)), getKClass(MeasurementUnit_1), evaluationStrategy_29, Import_getInstance(), builder_37));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder_38 = btbScopes$lambda$slambda_80(null);
    var evaluationStrategy_30 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessProperty_1)), getKClass(MeasurementUnit_1), evaluationStrategy_30, Any_getInstance(), builder_38));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_39 = btbScopes$lambda$slambda_82(null);
    var evaluationStrategy_31 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(InstanceRelationDeclaration)), getKClass(MeasurementUnit_1), evaluationStrategy_31, Import_getInstance(), builder_39));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_40 = btbScopes$lambda$slambda_84(null);
    var evaluationStrategy_32 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ObjectPropertyDeclaration_1)), getKClass(MeasurementUnit_1), evaluationStrategy_32, Import_getInstance(), builder_40));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_41 = btbScopes$lambda$slambda_86(null);
    var evaluationStrategy_33 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyDeclaration_1)), getKClass(EnumerationConstant_1), evaluationStrategy_33, Import_getInstance(), builder_41));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder_42 = btbScopes$lambda$slambda_88(null);
    var evaluationStrategy_34 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessProperty_1)), getKClass(EnumerationConstant_1), evaluationStrategy_34, Any_getInstance(), builder_42));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_43 = btbScopes$lambda$slambda_90(null);
    var evaluationStrategy_35 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(InstanceRelationDeclaration)), getKClass(EnumerationConstant_1), evaluationStrategy_35, Import_getInstance(), builder_43));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_44 = btbScopes$lambda$slambda_92(null);
    var evaluationStrategy_36 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ObjectPropertyDeclaration_1)), getKClass(EnumerationConstant_1), evaluationStrategy_36, Import_getInstance(), builder_44));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_45 = btbScopes$lambda$slambda_94(null);
    var evaluationStrategy_37 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ObjectPropertyDeclaration_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_37, Import_getInstance(), builder_45));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_46 = btbScopes$lambda$slambda_96(null);
    var evaluationStrategy_38 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_27;
    if (null == null) {
      tmp_27 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_27 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_26 = tmp_27;
    var origin_26 = tmp1_elvis_lhs_26 == null ? Lexical_getInstance() : tmp1_elvis_lhs_26;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessPropertyValue_1)), getKClass(MeasurementUnit_1), evaluationStrategy_38, origin_26, builder_46));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_47 = btbScopes$lambda$slambda_98(null);
    var evaluationStrategy_39 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_28;
    if (null == null) {
      tmp_28 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_28 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_27 = tmp_28;
    var origin_27 = tmp1_elvis_lhs_27 == null ? Lexical_getInstance() : tmp1_elvis_lhs_27;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyValue_1)), getKClass(MeasurementUnit_1), evaluationStrategy_39, origin_27, builder_47));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_48 = btbScopes$lambda$slambda_100(null);
    var evaluationStrategy_40 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_29;
    if (null == null) {
      tmp_29 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_29 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_28 = tmp_29;
    var origin_28 = tmp1_elvis_lhs_28 == null ? Lexical_getInstance() : tmp1_elvis_lhs_28;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(InstanceRelationValue)), getKClass(MeasurementUnit_1), evaluationStrategy_40, origin_28, builder_48));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_49 = btbScopes$lambda$slambda_102(null);
    var evaluationStrategy_41 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_30;
    if (null == null) {
      tmp_30 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_30 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_29 = tmp_30;
    var origin_29 = tmp1_elvis_lhs_29 == null ? Lexical_getInstance() : tmp1_elvis_lhs_29;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyConstraint_1)), getKClass(MeasurementUnit_1), evaluationStrategy_41, origin_29, builder_49));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_50 = btbScopes$lambda$slambda_104(null);
    var evaluationStrategy_42 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_31;
    if (null == null) {
      tmp_31 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_31 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_30 = tmp_31;
    var origin_30 = tmp1_elvis_lhs_30 == null ? Lexical_getInstance() : tmp1_elvis_lhs_30;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(IsExpression_1)), getKClass(MeasurementUnit_1), evaluationStrategy_42, origin_30, builder_50));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_51 = btbScopes$lambda$slambda_106(null);
    var evaluationStrategy_43 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_32;
    if (null == null) {
      tmp_32 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_32 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_31 = tmp_32;
    var origin_31 = tmp1_elvis_lhs_31 == null ? Lexical_getInstance() : tmp1_elvis_lhs_31;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyDeclarationValueQuery_1)), getKClass(MeasurementUnit_1), evaluationStrategy_43, origin_31, builder_51));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_52 = btbScopes$lambda$slambda_108(null);
    var evaluationStrategy_44 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_33;
    if (null == null) {
      tmp_33 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_33 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_32 = tmp_33;
    var origin_32 = tmp1_elvis_lhs_32 == null ? Lexical_getInstance() : tmp1_elvis_lhs_32;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyValue_1)), getKClass(EnumerationConstant_1), evaluationStrategy_44, origin_32, builder_52));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_53 = btbScopes$lambda$slambda_110(null);
    var evaluationStrategy_45 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_34;
    if (null == null) {
      tmp_34 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_34 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_33 = tmp_34;
    var origin_33 = tmp1_elvis_lhs_33 == null ? Lexical_getInstance() : tmp1_elvis_lhs_33;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessPropertyValue_1)), getKClass(EnumerationConstant_1), evaluationStrategy_45, origin_33, builder_53));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_54 = btbScopes$lambda$slambda_112(null);
    var evaluationStrategy_46 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_35;
    if (null == null) {
      tmp_35 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_35 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_34 = tmp_35;
    var origin_34 = tmp1_elvis_lhs_34 == null ? Lexical_getInstance() : tmp1_elvis_lhs_34;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(InstanceRelationValue)), getKClass(EnumerationConstant_1), evaluationStrategy_46, origin_34, builder_54));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_55 = btbScopes$lambda$slambda_114(null);
    var evaluationStrategy_47 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_36;
    if (null == null) {
      tmp_36 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_36 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_35 = tmp_36;
    var origin_35 = tmp1_elvis_lhs_35 == null ? Lexical_getInstance() : tmp1_elvis_lhs_35;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyConstraint_1)), getKClass(EnumerationConstant_1), evaluationStrategy_47, origin_35, builder_55));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_56 = btbScopes$lambda$slambda_116(null);
    var evaluationStrategy_48 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_37;
    if (null == null) {
      tmp_37 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_37 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_36 = tmp_37;
    var origin_36 = tmp1_elvis_lhs_36 == null ? Lexical_getInstance() : tmp1_elvis_lhs_36;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(IsExpression_1)), getKClass(EnumerationConstant_1), evaluationStrategy_48, origin_36, builder_56));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_57 = btbScopes$lambda$slambda_118(null);
    var evaluationStrategy_49 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_38;
    if (null == null) {
      tmp_38 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_38 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_37 = tmp_38;
    var origin_37 = tmp1_elvis_lhs_37 == null ? Lexical_getInstance() : tmp1_elvis_lhs_37;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessPropertyValue_1)), getKClass(ProcessRelationDeclaration_1), evaluationStrategy_49, origin_37, builder_57));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_58 = btbScopes$lambda$slambda_120(null);
    var evaluationStrategy_50 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_39;
    if (null == null) {
      tmp_39 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_39 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_38 = tmp_39;
    var origin_38 = tmp1_elvis_lhs_38 == null ? Lexical_getInstance() : tmp1_elvis_lhs_38;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessPropertyValue_1)), getKClass(NewFact), evaluationStrategy_50, origin_38, builder_58));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_59 = btbScopes$lambda$slambda_122(null);
    var evaluationStrategy_51 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_40;
    if (null == null) {
      tmp_40 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_40 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_39 = tmp_40;
    var origin_39 = tmp1_elvis_lhs_39 == null ? Lexical_getInstance() : tmp1_elvis_lhs_39;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessPropertyValue_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_51, origin_39, builder_59));
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = value$factory_9();
    var tmp225 = new SingleChildLink(getKClass(ProcessPropertyValue_1), this_0);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_60 = btbScopes$lambda$slambda_124(null);
    var evaluationStrategy_52 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_41;
    if (tmp225 == null) {
      tmp_41 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_41 = new LexicalWithRole(tmp225);
    }
    var tmp1_elvis_lhs_40 = tmp_41;
    var origin_40 = tmp1_elvis_lhs_40 == null ? Lexical_getInstance() : tmp1_elvis_lhs_40;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessPropertyValue_1)), getKClass(ProcessProperty_1), evaluationStrategy_52, origin_40, builder_60));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_61 = btbScopes$lambda$slambda_126(null);
    var evaluationStrategy_53 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_42;
    if (null == null) {
      tmp_42 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_42 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_41 = tmp_42;
    var origin_41 = tmp1_elvis_lhs_41 == null ? Lexical_getInstance() : tmp1_elvis_lhs_41;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyConstraint_1)), getKClass(ProcessRelationDeclaration_1), evaluationStrategy_53, origin_41, builder_61));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_62 = btbScopes$lambda$slambda_128(null);
    var evaluationStrategy_54 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_43;
    if (null == null) {
      tmp_43 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_43 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_42 = tmp_43;
    var origin_42 = tmp1_elvis_lhs_42 == null ? Lexical_getInstance() : tmp1_elvis_lhs_42;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyConstraint_1)), getKClass(NewFact), evaluationStrategy_54, origin_42, builder_62));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_63 = btbScopes$lambda$slambda_130(null);
    var evaluationStrategy_55 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_44;
    if (null == null) {
      tmp_44 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_44 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_43 = tmp_44;
    var origin_43 = tmp1_elvis_lhs_43 == null ? Lexical_getInstance() : tmp1_elvis_lhs_43;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyConstraint_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_55, origin_43, builder_63));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_64 = btbScopes$lambda$slambda_132(null);
    var evaluationStrategy_56 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_45;
    if (null == null) {
      tmp_45 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_45 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_44 = tmp_45;
    var origin_44 = tmp1_elvis_lhs_44 == null ? Lexical_getInstance() : tmp1_elvis_lhs_44;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(IsExpression_1)), getKClass(ProcessRelationDeclaration_1), evaluationStrategy_56, origin_44, builder_64));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_65 = btbScopes$lambda$slambda_134(null);
    var evaluationStrategy_57 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_46;
    if (null == null) {
      tmp_46 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_46 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_45 = tmp_46;
    var origin_45 = tmp1_elvis_lhs_45 == null ? Lexical_getInstance() : tmp1_elvis_lhs_45;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(IsExpression_1)), getKClass(NewFact), evaluationStrategy_57, origin_45, builder_65));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_66 = btbScopes$lambda$slambda_136(null);
    var evaluationStrategy_58 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_47;
    if (null == null) {
      tmp_47 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_47 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_46 = tmp_47;
    var origin_46 = tmp1_elvis_lhs_46 == null ? Lexical_getInstance() : tmp1_elvis_lhs_46;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(IsExpression_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_58, origin_46, builder_66));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_67 = btbScopes$lambda$slambda_138(null);
    var evaluationStrategy_59 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_48;
    if (null == null) {
      tmp_48 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_48 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_47 = tmp_48;
    var origin_47 = tmp1_elvis_lhs_47 == null ? Lexical_getInstance() : tmp1_elvis_lhs_47;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OneOf_1)), getKClass(ProcessRelationDeclaration_1), evaluationStrategy_59, origin_47, builder_67));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_68 = btbScopes$lambda$slambda_140(null);
    var evaluationStrategy_60 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_49;
    if (null == null) {
      tmp_49 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_49 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_48 = tmp_49;
    var origin_48 = tmp1_elvis_lhs_48 == null ? Lexical_getInstance() : tmp1_elvis_lhs_48;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OneOf_1)), getKClass(NewFact), evaluationStrategy_60, origin_48, builder_68));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_69 = btbScopes$lambda$slambda_142(null);
    var evaluationStrategy_61 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_50;
    if (null == null) {
      tmp_50 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_50 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_49 = tmp_50;
    var origin_49 = tmp1_elvis_lhs_49 == null ? Lexical_getInstance() : tmp1_elvis_lhs_49;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OneOf_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_61, origin_49, builder_69));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_70 = btbScopes$lambda$slambda_144(null);
    var evaluationStrategy_62 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_51;
    if (null == null) {
      tmp_51 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_51 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_50 = tmp_51;
    var origin_50 = tmp1_elvis_lhs_50 == null ? Lexical_getInstance() : tmp1_elvis_lhs_50;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OneOf_1)), getKClass(OntologyLibrary_1), evaluationStrategy_62, origin_50, builder_70));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_71 = btbScopes$lambda$slambda_146(null);
    var evaluationStrategy_63 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_52;
    if (null == null) {
      tmp_52 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_52 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_51 = tmp_52;
    var origin_51 = tmp1_elvis_lhs_51 == null ? Lexical_getInstance() : tmp1_elvis_lhs_51;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OneOf_1)), getKClass(ModifierDeclaration), evaluationStrategy_63, origin_51, builder_71));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_72 = btbScopes$lambda$slambda_148(null);
    var evaluationStrategy_64 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_53;
    if (null == null) {
      tmp_53 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_53 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_52 = tmp_53;
    var origin_52 = tmp1_elvis_lhs_52 == null ? Lexical_getInstance() : tmp1_elvis_lhs_52;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyDeclarationValueQuery_1)), getKClass(EnumerationConstant_1), evaluationStrategy_64, origin_52, builder_72));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_73 = btbScopes$lambda$slambda_150(null);
    var evaluationStrategy_65 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_54;
    if (null == null) {
      tmp_54 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_54 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_53 = tmp_54;
    var origin_53 = tmp1_elvis_lhs_53 == null ? Lexical_getInstance() : tmp1_elvis_lhs_53;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyDeclarationValueQuery_1)), getKClass(EnumerationConstant_1), evaluationStrategy_65, origin_53, builder_73));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_74 = btbScopes$lambda$slambda_152(null);
    var evaluationStrategy_66 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_55;
    if (null == null) {
      tmp_55 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_55 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_54 = tmp_55;
    var origin_54 = tmp1_elvis_lhs_54 == null ? Lexical_getInstance() : tmp1_elvis_lhs_54;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ObjectPropertyReferenceValue_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_66, origin_54, builder_74));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_75 = btbScopes$lambda$slambda_154(null);
    var evaluationStrategy_67 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_56;
    if (null == null) {
      tmp_56 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_56 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_55 = tmp_56;
    var origin_55 = tmp1_elvis_lhs_55 == null ? Lexical_getInstance() : tmp1_elvis_lhs_55;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyElement_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_67, origin_55, builder_75));
    var tmp289 = get_onlyOntologyVars();
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.constrainScope' call
    var builder_76 = btbScopes$lambda$slambda_156(null);
    $this$scopes.w77(new ConstrainScope($this$scopes.v77(getKClass(FactSet_1)), tmp289, builder_76));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_77 = btbScopes$lambda$slambda_158(null);
    var evaluationStrategy_68 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_57;
    if (null == null) {
      tmp_57 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_57 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_56 = tmp_57;
    var origin_56 = tmp1_elvis_lhs_56 == null ? Lexical_getInstance() : tmp1_elvis_lhs_56;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(LibraryProcessSpecification_1)), getKClass(VariableDeclaration_1), evaluationStrategy_68, origin_56, builder_77));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_78 = btbScopes$lambda$slambda_160(null);
    var evaluationStrategy_69 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_58;
    if (null == null) {
      tmp_58 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_58 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_57 = tmp_58;
    var origin_57 = tmp1_elvis_lhs_57 == null ? Lexical_getInstance() : tmp1_elvis_lhs_57;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(InstanceRelationValue)), getKClass(FunctionDeclaration_1), evaluationStrategy_69, origin_57, builder_78));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_79 = btbScopes$lambda$slambda_162(null);
    var evaluationStrategy_70 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_59;
    if (null == null) {
      tmp_59 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_59 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_58 = tmp_59;
    var origin_58 = tmp1_elvis_lhs_58 == null ? Lexical_getInstance() : tmp1_elvis_lhs_58;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(InstanceRelationValue)), getKClass(VariableDeclaration_1), evaluationStrategy_70, origin_58, builder_79));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_80 = btbScopes$lambda$slambda_164(null);
    var evaluationStrategy_71 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_60;
    if (null == null) {
      tmp_60 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_60 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_59 = tmp_60;
    var origin_59 = tmp1_elvis_lhs_59 == null ? Lexical_getInstance() : tmp1_elvis_lhs_59;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessPropertyValue_1)), getKClass(OntologyLibrary_1), evaluationStrategy_71, origin_59, builder_80));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_81 = btbScopes$lambda$slambda_166(null);
    var evaluationStrategy_72 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_61;
    if (null == null) {
      tmp_61 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_61 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_60 = tmp_61;
    var origin_60 = tmp1_elvis_lhs_60 == null ? Lexical_getInstance() : tmp1_elvis_lhs_60;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(IsExpression_1)), getKClass(OntologyLibrary_1), evaluationStrategy_72, origin_60, builder_81));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_82 = btbScopes$lambda$slambda_168(null);
    var evaluationStrategy_73 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_62;
    if (null == null) {
      tmp_62 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_62 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_61 = tmp_62;
    var origin_61 = tmp1_elvis_lhs_61 == null ? Lexical_getInstance() : tmp1_elvis_lhs_61;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(InstanceRelationValue)), getKClass(OntologyLibrary_1), evaluationStrategy_73, origin_61, builder_82));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder_83 = btbScopes$lambda$slambda_170(null);
    var evaluationStrategy_74 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessDeclaration_1)), getKClass(AbstractLink), evaluationStrategy_74, Any_getInstance(), builder_83));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder_84 = btbScopes$lambda$slambda_172(null);
    var evaluationStrategy_75 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessDeclaration_1)), getKClass(AbstractProperty), evaluationStrategy_75, Any_getInstance(), builder_84));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideCommonScope' call
    var builder_85 = btbScopes$lambda$slambda_174(null);
    var evaluationStrategy_76 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessDeclaration_1)), getKClass(ProcessProperty_1), evaluationStrategy_76, Any_getInstance(), builder_85));
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = aliasedProperties$factory_0();
    var tmp326 = new MultipleChildLink(getKClass(ProcessProperty_1), this_1);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_86 = btbScopes$lambda$slambda_176(null);
    var evaluationStrategy_77 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_63;
    if (tmp326 == null) {
      tmp_63 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_63 = new LexicalWithRole(tmp326);
    }
    var tmp1_elvis_lhs_62 = tmp_63;
    var origin_62 = tmp1_elvis_lhs_62 == null ? Lexical_getInstance() : tmp1_elvis_lhs_62;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessProperty_1)), getKClass(ProcessProperty_1), evaluationStrategy_77, origin_62, builder_86));
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_2 = default$factory_0();
    var tmp331 = new SingleChildLink(getKClass(ProcessProperty_1), this_2);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_87 = btbScopes$lambda$slambda_178(null);
    var evaluationStrategy_78 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_64;
    if (tmp331 == null) {
      tmp_64 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_64 = new LexicalWithRole(tmp331);
    }
    var tmp1_elvis_lhs_63 = tmp_64;
    var origin_63 = tmp1_elvis_lhs_63 == null ? Lexical_getInstance() : tmp1_elvis_lhs_63;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessProperty_1)), getKClass(ProcessProperty_1), evaluationStrategy_78, origin_63, builder_87));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_88 = btbScopes$lambda$slambda_180(null);
    var evaluationStrategy_79 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_65;
    if (null == null) {
      tmp_65 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_65 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_64 = tmp_65;
    var origin_64 = tmp1_elvis_lhs_64 == null ? Lexical_getInstance() : tmp1_elvis_lhs_64;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessDeclaration_1)), getKClass(VariableDeclaration_1), evaluationStrategy_79, origin_64, builder_88));
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_3 = inherited$factory_1();
    var tmp340 = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_3);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_89 = btbScopes$lambda$slambda_182(null);
    var evaluationStrategy_80 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_66;
    if (tmp340 == null) {
      tmp_66 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_66 = new LexicalWithRole(tmp340);
    }
    var tmp1_elvis_lhs_65 = tmp_66;
    var origin_65 = tmp1_elvis_lhs_65 == null ? Lexical_getInstance() : tmp1_elvis_lhs_65;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessDeclaration_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_80, origin_65, builder_89));
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_4 = prerequisites$factory_0();
    var tmp345 = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_4);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_90 = btbScopes$lambda$slambda_184(null);
    var evaluationStrategy_81 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_67;
    if (tmp345 == null) {
      tmp_67 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_67 = new LexicalWithRole(tmp345);
    }
    var tmp1_elvis_lhs_66 = tmp_67;
    var origin_66 = tmp1_elvis_lhs_66 == null ? Lexical_getInstance() : tmp1_elvis_lhs_66;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessDeclaration_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_81, origin_66, builder_90));
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_5 = effects$factory_0();
    var tmp350 = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_5);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_91 = btbScopes$lambda$slambda_186(null);
    var evaluationStrategy_82 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_68;
    if (tmp350 == null) {
      tmp_68 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_68 = new LexicalWithRole(tmp350);
    }
    var tmp1_elvis_lhs_67 = tmp_68;
    var origin_67 = tmp1_elvis_lhs_67 == null ? Lexical_getInstance() : tmp1_elvis_lhs_67;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessDeclaration_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_82, origin_67, builder_91));
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_6 = variables$factory_0();
    var tmp355 = new MultipleChildLink(getKClass(HasVariables), this_6);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_92 = btbScopes$lambda$slambda_188(null);
    var evaluationStrategy_83 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_69;
    if (tmp355 == null) {
      tmp_69 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_69 = new LexicalWithRole(tmp355);
    }
    var tmp1_elvis_lhs_68 = tmp_69;
    var origin_68 = tmp1_elvis_lhs_68 == null ? Lexical_getInstance() : tmp1_elvis_lhs_68;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessDeclaration_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_83, origin_68, builder_92));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_93 = btbScopes$lambda$slambda_190(null);
    var evaluationStrategy_84 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_70;
    if (null == null) {
      tmp_70 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_70 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_69 = tmp_70;
    var origin_69 = tmp1_elvis_lhs_69 == null ? Lexical_getInstance() : tmp1_elvis_lhs_69;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(LibraryProcessSpecification_1)), getKClass(AbstractLink), evaluationStrategy_84, origin_69, builder_93));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_94 = btbScopes$lambda$slambda_192(null);
    var evaluationStrategy_85 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_71;
    if (null == null) {
      tmp_71 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_71 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_70 = tmp_71;
    var origin_70 = tmp1_elvis_lhs_70 == null ? Lexical_getInstance() : tmp1_elvis_lhs_70;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(LibraryProcessSpecification_1)), getKClass(ProcessProperty_1), evaluationStrategy_85, origin_70, builder_94));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_95 = btbScopes$lambda$slambda_194(null);
    var evaluationStrategy_86 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_72;
    if (null == null) {
      tmp_72 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_72 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_71 = tmp_72;
    var origin_71 = tmp1_elvis_lhs_71 == null ? Lexical_getInstance() : tmp1_elvis_lhs_71;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(LibraryProcessSpecification_1)), getKClass(AbstractProperty), evaluationStrategy_86, origin_71, builder_95));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_96 = btbScopes$lambda$slambda_196(null);
    var evaluationStrategy_87 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_73;
    if (null == null) {
      tmp_73 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_73 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_72 = tmp_73;
    var origin_72 = tmp1_elvis_lhs_72 == null ? Lexical_getInstance() : tmp1_elvis_lhs_72;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(LibraryProcessSpecificationQuery_1)), getKClass(AbstractLink), evaluationStrategy_87, origin_72, builder_96));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_97 = btbScopes$lambda$slambda_198(null);
    var evaluationStrategy_88 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_74;
    if (null == null) {
      tmp_74 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_74 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_73 = tmp_74;
    var origin_73 = tmp1_elvis_lhs_73 == null ? Lexical_getInstance() : tmp1_elvis_lhs_73;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(LibraryProcessSpecificationQuery_1)), getKClass(AbstractProperty), evaluationStrategy_88, origin_73, builder_97));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_98 = btbScopes$lambda$slambda_200(null);
    var evaluationStrategy_89 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_75;
    if (null == null) {
      tmp_75 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_75 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_74 = tmp_75;
    var origin_74 = tmp1_elvis_lhs_74 == null ? Lexical_getInstance() : tmp1_elvis_lhs_74;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(LibraryProcessSpecificationQuery_1)), getKClass(ProcessProperty_1), evaluationStrategy_89, origin_74, builder_98));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_99 = btbScopes$lambda$slambda_202(null);
    var evaluationStrategy_90 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_76;
    if (null == null) {
      tmp_76 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_76 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_75 = tmp_76;
    var origin_75 = tmp1_elvis_lhs_75 == null ? Lexical_getInstance() : tmp1_elvis_lhs_75;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(FunctionTerm_1)), getKClass(AbstractLink), evaluationStrategy_90, origin_75, builder_99));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_100 = btbScopes$lambda$slambda_204(null);
    var evaluationStrategy_91 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_77;
    if (null == null) {
      tmp_77 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_77 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_76 = tmp_77;
    var origin_76 = tmp1_elvis_lhs_76 == null ? Lexical_getInstance() : tmp1_elvis_lhs_76;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(FunctionTerm_1)), getKClass(AbstractProperty), evaluationStrategy_91, origin_76, builder_100));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_101 = btbScopes$lambda$slambda_206(null);
    var evaluationStrategy_92 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_78;
    if (null == null) {
      tmp_78 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_78 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_77 = tmp_78;
    var origin_77 = tmp1_elvis_lhs_77 == null ? Lexical_getInstance() : tmp1_elvis_lhs_77;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(FunctionTerm_1)), getKClass(ProcessProperty_1), evaluationStrategy_92, origin_77, builder_101));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_102 = btbScopes$lambda$slambda_208(null);
    var evaluationStrategy_93 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(FunctionDeclaration_1)), getKClass(ProcessProperty_1), evaluationStrategy_93, Import_getInstance(), builder_102));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_103 = btbScopes$lambda$slambda_210(null);
    var evaluationStrategy_94 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_79;
    if (null == null) {
      tmp_79 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_79 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_78 = tmp_79;
    var origin_78 = tmp1_elvis_lhs_78 == null ? Lexical_getInstance() : tmp1_elvis_lhs_78;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(CustomEditor)), getKClass(ProcessProperty_1), evaluationStrategy_94, origin_78, builder_103));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_104 = btbScopes$lambda$slambda_212(null);
    var evaluationStrategy_95 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_80;
    if (null == null) {
      tmp_80 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_80 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_79 = tmp_80;
    var origin_79 = tmp1_elvis_lhs_79 == null ? Lexical_getInstance() : tmp1_elvis_lhs_79;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(CustomEditor)), getKClass(AbstractLink), evaluationStrategy_95, origin_79, builder_104));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_105 = btbScopes$lambda$slambda_214(null);
    var evaluationStrategy_96 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_81;
    if (null == null) {
      tmp_81 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_81 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_80 = tmp_81;
    var origin_80 = tmp1_elvis_lhs_80 == null ? Lexical_getInstance() : tmp1_elvis_lhs_80;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(CustomEditor)), getKClass(AbstractProperty), evaluationStrategy_96, origin_80, builder_105));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_106 = btbScopes$lambda$slambda_216($this$scopes, librariesScopeProvider$delegate, null);
    var evaluationStrategy_97 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_82;
    if (null == null) {
      tmp_82 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_82 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_81 = tmp_82;
    var origin_81 = tmp1_elvis_lhs_81 == null ? Lexical_getInstance() : tmp1_elvis_lhs_81;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(LibraryProcessSpecificationQuery_1)), getKClass(LinkDeclaration_1), evaluationStrategy_97, origin_81, builder_106));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_107 = btbScopes$lambda$slambda_218($this$scopes, librariesScopeProvider$delegate, null);
    var evaluationStrategy_98 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_83;
    if (null == null) {
      tmp_83 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_83 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_82 = tmp_83;
    var origin_82 = tmp1_elvis_lhs_82 == null ? Lexical_getInstance() : tmp1_elvis_lhs_82;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(LibraryProcessSpecificationQuery_1)), getKClass(PropertyDeclaration_1), evaluationStrategy_98, origin_82, builder_107));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_108 = btbScopes$lambda$slambda_220(null);
    var evaluationStrategy_99 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_84;
    if (null == null) {
      tmp_84 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_84 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_83 = tmp_84;
    var origin_83 = tmp1_elvis_lhs_83 == null ? Lexical_getInstance() : tmp1_elvis_lhs_83;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(VariableDeclaration_1)), getKClass(InstanceRelationDeclaration), evaluationStrategy_99, origin_83, builder_108));
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_7 = constraints$factory_0();
    var tmp423 = new MultipleChildLink(getKClass(HasPropertyConstraints), this_7);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_109 = btbScopes$lambda$slambda_222(null);
    var evaluationStrategy_100 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_85;
    if (tmp423 == null) {
      tmp_85 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_85 = new LexicalWithRole(tmp423);
    }
    var tmp1_elvis_lhs_84 = tmp_85;
    var origin_84 = tmp1_elvis_lhs_84 == null ? Lexical_getInstance() : tmp1_elvis_lhs_84;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(VariableDeclaration_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_100, origin_84, builder_109));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_110 = btbScopes$lambda$slambda_224(null);
    var evaluationStrategy_101 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_86;
    if (null == null) {
      tmp_86 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_86 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_85 = tmp_86;
    var origin_85 = tmp1_elvis_lhs_85 == null ? Lexical_getInstance() : tmp1_elvis_lhs_85;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(VariableDeclaration_1)), getKClass(VariableDeclaration_1), evaluationStrategy_101, origin_85, builder_110));
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_8 = constraints$factory_1();
    var tmp432 = new MultipleChildLink(getKClass(HasPropertyConstraints), this_8);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_111 = btbScopes$lambda$slambda_226(null);
    var evaluationStrategy_102 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_87;
    if (tmp432 == null) {
      tmp_87 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_87 = new LexicalWithRole(tmp432);
    }
    var tmp1_elvis_lhs_86 = tmp_87;
    var origin_86 = tmp1_elvis_lhs_86 == null ? Lexical_getInstance() : tmp1_elvis_lhs_86;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyConstraint_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_102, origin_86, builder_111));
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_9 = constraints$factory_2();
    var tmp437 = new MultipleChildLink(getKClass(HasPropertyConstraints), this_9);
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_112 = btbScopes$lambda$slambda_228(null);
    var evaluationStrategy_103 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_88;
    if (tmp437 == null) {
      tmp_88 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_88 = new LexicalWithRole(tmp437);
    }
    var tmp1_elvis_lhs_87 = tmp_88;
    var origin_87 = tmp1_elvis_lhs_87 == null ? Lexical_getInstance() : tmp1_elvis_lhs_87;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(OntologyElementDefinition_1)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_103, origin_87, builder_112));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope' call
    var builder_113 = btbScopes$lambda$slambda_230(null);
    var evaluationStrategy_104 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    var tmp_89;
    if (null == null) {
      tmp_89 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideLexicalScope.<anonymous>' call
      tmp_89 = new LexicalWithRole(null);
    }
    var tmp1_elvis_lhs_88 = tmp_89;
    var origin_88 = tmp1_elvis_lhs_88 == null ? Lexical_getInstance() : tmp1_elvis_lhs_88;
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ValueWithRelations_1)), getKClass(InstanceRelationDeclaration), evaluationStrategy_104, origin_88, builder_113));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_114 = btbScopes$lambda$slambda_232(null);
    var evaluationStrategy_105 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessLibrary_1)), getKClass(ProcessDeclaration_1), evaluationStrategy_105, Import_getInstance(), builder_114));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_115 = btbScopes$lambda$slambda_234(null);
    var evaluationStrategy_106 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ObjectPropertiesLibrary)), getKClass(ObjectPropertyDeclaration_1), evaluationStrategy_106, Import_getInstance(), builder_115));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_116 = btbScopes$lambda$slambda_236(null);
    var evaluationStrategy_107 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(RelationContainer_1)), getKClass(ProcessRelationDeclaration_1), evaluationStrategy_107, Import_getInstance(), builder_116));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_117 = btbScopes$lambda$slambda_238(null);
    var evaluationStrategy_108 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(RelationContainer_1)), getKClass(InstanceRelationDeclaration), evaluationStrategy_108, Import_getInstance(), builder_117));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_118 = btbScopes$lambda$slambda_240(null);
    var evaluationStrategy_109 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ModifierContainer)), getKClass(ModifierDeclaration), evaluationStrategy_109, Import_getInstance(), builder_118));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_119 = btbScopes$lambda$slambda_242(null);
    var evaluationStrategy_110 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(FunctionLibrary_1)), getKClass(FunctionDeclaration_1), evaluationStrategy_110, Import_getInstance(), builder_119));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_120 = btbScopes$lambda$slambda_244(null);
    var evaluationStrategy_111 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(ProcessKindContainer_1)), getKClass(ProcessKind_1), evaluationStrategy_111, Import_getInstance(), builder_120));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_121 = btbScopes$lambda$slambda_246(null);
    var evaluationStrategy_112 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(LinkLibrary_1)), getKClass(LinkDeclaration_1), evaluationStrategy_112, Import_getInstance(), builder_121));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_122 = btbScopes$lambda$slambda_248(null);
    var evaluationStrategy_113 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PropertyLibrary_1)), getKClass(PropertyDeclaration_1), evaluationStrategy_113, Import_getInstance(), builder_122));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_123 = btbScopes$lambda$slambda_250(null);
    var evaluationStrategy_114 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(NotionLibrary_1)), getKClass(AbstractNotion), evaluationStrategy_114, Import_getInstance(), builder_123));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.provideImportScope' call
    var builder_124 = btbScopes$lambda$slambda_252(null);
    var evaluationStrategy_115 = RuleEvaluationStrategy_PER_REQUEST_getInstance();
    $this$scopes.w77(new ProvideScope($this$scopes.v77(getKClass(PublishedSourcesLibrary_1)), getKClass(LibraryItem), evaluationStrategy_115, Import_getInstance(), builder_124));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_125 = btbScopes$lambda$slambda_254($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.w77(new DefaultScope(getKClass(ProcessDeclaration_1), builder_125));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_126 = btbScopes$lambda$slambda_256($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.w77(new DefaultScope(getKClass(ObjectPropertyDeclaration_1), builder_126));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_127 = btbScopes$lambda$slambda_258($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.w77(new DefaultScope(getKClass(ProcessRelationDeclaration_1), builder_127));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_128 = btbScopes$lambda$slambda_260($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.w77(new DefaultScope(getKClass(InstanceRelationDeclaration), builder_128));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_129 = btbScopes$lambda$slambda_262($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.w77(new DefaultScope(getKClass(ModifierDeclaration), builder_129));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_130 = btbScopes$lambda$slambda_264($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.w77(new DefaultScope(getKClass(FunctionDeclaration_1), builder_130));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_131 = btbScopes$lambda$slambda_266($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.w77(new DefaultScope(getKClass(ProcessKind_1), builder_131));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_132 = btbScopes$lambda$slambda_268($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.w77(new DefaultScope(getKClass(LinkDeclaration_1), builder_132));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_133 = btbScopes$lambda$slambda_270($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.w77(new DefaultScope(getKClass(PropertyDeclaration_1), builder_133));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_134 = btbScopes$lambda$slambda_272($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.w77(new DefaultScope(getKClass(AbstractNotion), builder_134));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_135 = btbScopes$lambda$slambda_274($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.w77(new DefaultScope(getKClass(LibraryItem), builder_135));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.defaultScope' call
    var builder_136 = btbScopes$lambda$slambda_276($this$scopes, librariesScopeProvider$delegate, null);
    $this$scopes.w77(new DefaultScope(getKClass(OntologyImportRoot_1), builder_136));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.names' call
    var body = btbScopes$lambda$lambda;
    $this$scopes.w77(new ProvideName(getKClass(OntologyElement_1), body));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.names' call
    var body_0 = btbScopes$lambda$lambda_0;
    $this$scopes.w77(new ProvideName(getKClass(ProcessRelationDeclaration_1), body_0));
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.name' call
    var body_1 = btbScopes$lambda$lambda_1;
    // Inline function 'jetbrains.ocelot.langDef.scopes.config.ScopeConfigBuilder0.names' call
    var body_2 = btbScopes$lambda$lambda_2(body_1);
    $this$scopes.w77(new ProvideName(getKClass(Named), body_2));
    return Unit_instance;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_11(function_0) {
    this.jh0_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_11).d1f = function (value, $completion) {
    return this.jh0_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_11).b4 = function () {
    return this.jh0_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_11).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_11).hashCode = function () {
    return hashCode(this.b4());
  };
  function invoke$lambda($this_scopes, $librariesScopeProvider$delegate) {
    _init_properties_BTBResolvers_kt__y423vn();
    return $this_scopes.e2p($librariesScopeProvider$delegate, null, getLocalDelegateReference('librariesScopeProvider', KProperty0, false, function () {
      return THROW_ISE();
    }));
  }
  function invoke$lambda_0($this_scopes, $subtypeScopeFilters$delegate) {
    _init_properties_BTBResolvers_kt__y423vn();
    return $this_scopes.e2p($subtypeScopeFilters$delegate, null, getLocalDelegateReference('subtypeScopeFilters', KProperty0, false, function () {
      return THROW_ISE();
    }));
  }
  function invoke$lambda_1($this_scopes, $taxonScopeFilters$delegate) {
    _init_properties_BTBResolvers_kt__y423vn();
    return $this_scopes.e2p($taxonScopeFilters$delegate, null, getLocalDelegateReference('taxonScopeFilters', KProperty0, false, function () {
      return THROW_ISE();
    }));
  }
  function btbScopes$lambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda).uh0 = function ($this$provideLexicalScope, factSet, $completion) {
    var tmp = this.vh0($this$provideLexicalScope, factSet, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.uh0(tmp, (!(p2 == null) ? isInterface(p2, FactSet_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.sh0_1.t7a(this.th0_1.fb6(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda).vh0 = function ($this$provideLexicalScope, factSet, completion) {
    var i = new btbScopes$lambda$slambda(completion);
    i.sh0_1 = $this$provideLexicalScope;
    i.th0_1 = factSet;
    return i;
  };
  function btbScopes$lambda$slambda_0(resultContinuation) {
    var i = new btbScopes$lambda$slambda(resultContinuation);
    var l = function ($this$provideLexicalScope, factSet, $completion) {
      return i.uh0($this$provideLexicalScope, factSet, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_1).gh1 = function ($this$provideLexicalScope, factSet, $completion) {
    var tmp = this.hh1($this$provideLexicalScope, factSet, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_1).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.gh1(tmp, (!(p2 == null) ? isInterface(p2, FactSet_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.eh1_1.t7a(this.fh1_1.ybc(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_1).hh1 = function ($this$provideLexicalScope, factSet, completion) {
    var i = new btbScopes$lambda$slambda_1(completion);
    i.eh1_1 = $this$provideLexicalScope;
    i.fh1_1 = factSet;
    return i;
  };
  function btbScopes$lambda$slambda_2(resultContinuation) {
    var i = new btbScopes$lambda$slambda_1(resultContinuation);
    var l = function ($this$provideLexicalScope, factSet, $completion) {
      return i.gh1($this$provideLexicalScope, factSet, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda($fact, resultContinuation) {
    this.qh1_1 = $fact;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda).th1 = function ($this$filter, it, $completion) {
    var tmp = this.uh1($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.th1(tmp, (!(p2 == null) ? isInterface(p2, Fact_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !equals(this.sh1_1, this.qh1_1);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda).uh1 = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda(this.qh1_1, completion);
    i.rh1_1 = $this$filter;
    i.sh1_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_0($fact, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda($fact, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.th1($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_3(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_3).fh2 = function ($this$provideLexicalScope, fact, $completion) {
    var tmp = this.gh2($this$provideLexicalScope, fact, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_3).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fh2(tmp, (!(p2 == null) ? isInterface(p2, Fact_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.dh2_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_0(this.eh2_1, null));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_3).gh2 = function ($this$provideLexicalScope, fact, completion) {
    var i = new btbScopes$lambda$slambda_3(completion);
    i.dh2_1 = $this$provideLexicalScope;
    i.eh2_1 = fact;
    return i;
  };
  function btbScopes$lambda$slambda_4(resultContinuation) {
    var i = new btbScopes$lambda$slambda_3(resultContinuation);
    var l = function ($this$provideLexicalScope, fact, $completion) {
      return i.fh2($this$provideLexicalScope, fact, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_5(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_5).rh2 = function ($this$provideLexicalScope, factSet, $completion) {
    var tmp = this.sh2($this$provideLexicalScope, factSet, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_5).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.rh2(tmp, (!(p2 == null) ? isInterface(p2, FactSet_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_5).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ph2_1.t7a(this.qh2_1.pb7(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_5).sh2 = function ($this$provideLexicalScope, factSet, completion) {
    var i = new btbScopes$lambda$slambda_5(completion);
    i.ph2_1 = $this$provideLexicalScope;
    i.qh2_1 = factSet;
    return i;
  };
  function btbScopes$lambda$slambda_6(resultContinuation) {
    var i = new btbScopes$lambda$slambda_5(resultContinuation);
    var l = function ($this$provideLexicalScope, factSet, $completion) {
      return i.rh2($this$provideLexicalScope, factSet, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_1($fact, resultContinuation) {
    this.bh3_1 = $fact;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_1).eh3 = function ($this$filter, it, $completion) {
    var tmp = this.fh3($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_1).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.eh3(tmp, (!(p2 == null) ? isInterface(p2, NewFact) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !equals(this.dh3_1, this.bh3_1);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_1).fh3 = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_1(this.bh3_1, completion);
    i.ch3_1 = $this$filter;
    i.dh3_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_2($fact, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_1($fact, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.eh3($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_7(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_7).qh3 = function ($this$provideLexicalScope, fact, $completion) {
    var tmp = this.rh3($this$provideLexicalScope, fact, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_7).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.qh3(tmp, (!(p2 == null) ? isInterface(p2, NewFact) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_7).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.oh3_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_2(this.ph3_1, null));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_7).rh3 = function ($this$provideLexicalScope, fact, completion) {
    var i = new btbScopes$lambda$slambda_7(completion);
    i.oh3_1 = $this$provideLexicalScope;
    i.ph3_1 = fact;
    return i;
  };
  function btbScopes$lambda$slambda_8(resultContinuation) {
    var i = new btbScopes$lambda$slambda_7(resultContinuation);
    var l = function ($this$provideLexicalScope, fact, $completion) {
      return i.qh3($this$provideLexicalScope, fact, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_9($this_scopes, $taxonScopeFilters$delegate, resultContinuation) {
    this.ah4_1 = $this_scopes;
    this.bh4_1 = $taxonScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_9).zh4 = function ($this$constrainScope, factSet, $completion) {
    var tmp = this.ah5($this$constrainScope, factSet, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_9).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.zh4(tmp, (!(p2 == null) ? isInterface(p2, FactSet_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_9).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 8;
            var tmp_0 = this;
            tmp_0.eh4_1 = this.ch4_1.n51(this.dh4_1.ob7());
            this.fh4_1 = this.eh4_1;
            var tmp_1 = this;
            tmp_1.gh4_1 = this.fh4_1;
            var tmp_2 = this;
            tmp_2.hh4_1 = ArrayList_init_$Create$();
            this.ih4_1 = this.gh4_1;
            this.jh4_1 = this.hh4_1;
            var tmp_3 = this;
            tmp_3.kh4_1 = this.ih4_1;
            this.lh4_1 = this.kh4_1;
            this.mh4_1 = this.lh4_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.mh4_1.l()) {
              this.y9_1 = 4;
              continue $sm;
            }

            this.nh4_1 = this.mh4_1.m();
            var tmp_4 = this;
            tmp_4.oh4_1 = this.nh4_1;
            this.ph4_1 = this.oh4_1;
            var tmp_5 = this;
            tmp_5.qh4_1 = this.ph4_1;
            this.rh4_1 = this.qh4_1;
            var tmp_6 = this;
            var tmp0_safe_receiver = this.ch4_1.n51(this.rh4_1.lay());
            tmp_6.sh4_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lay();
            if (this.sh4_1 == null) {
              this.th4_1 = null;
              this.y9_1 = 3;
              continue $sm;
            } else {
              this.y9_1 = 2;
              suspendResult = this.ch4_1.m51(this.sh4_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.th4_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.uh4_1 = this.th4_1;
            if (this.uh4_1 == null)
              null;
            else {
              var it = this.uh4_1;
              this.jh4_1.e(it);
            }

            this.y9_1 = 1;
            continue $sm;
          case 4:
            this.vh4_1 = this.jh4_1;
            if (!this.vh4_1.p()) {
              var tmp_7 = this;
              var this_0 = this.vh4_1;
              var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
              var _iterator__ex2g4s = this_0.k();
              while (_iterator__ex2g4s.l()) {
                var item = _iterator__ex2g4s.m();
                destination.e(invoke$lambda_1(this.ah4_1, this.bh4_1).bh5(item));
              }
              tmp_7.wh4_1 = anyOf(destination);
              this.y9_1 = 7;
              continue $sm;
            } else {
              var tmp_8 = this;
              var tmp0_safe_receiver_0 = this.ch4_1.n51(this.dh4_1.nb7());
              var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.lay();
              var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : this.ch4_1.n51(tmp1_safe_receiver);
              tmp_8.xh4_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.lay();
              if (this.xh4_1 == null) {
                this.yh4_1 = null;
                this.y9_1 = 6;
                continue $sm;
              } else {
                this.y9_1 = 5;
                suspendResult = this.ch4_1.m51(this.xh4_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 5:
            this.yh4_1 = suspendResult;
            this.y9_1 = 6;
            continue $sm;
          case 6:
            var tmp4_elvis_lhs = this.yh4_1;
            var tmp_9;
            if (tmp4_elvis_lhs == null) {
              return this.ch4_1.s7b_1;
            } else {
              tmp_9 = tmp4_elvis_lhs;
            }

            var contextTaxon = tmp_9;
            this.wh4_1 = invoke$lambda_1(this.ah4_1, this.bh4_1).bh5(contextTaxon);
            this.y9_1 = 7;
            continue $sm;
          case 7:
            return this.wh4_1;
          case 8:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 8) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_9).ah5 = function ($this$constrainScope, factSet, completion) {
    var i = new btbScopes$lambda$slambda_9(this.ah4_1, this.bh4_1, completion);
    i.ch4_1 = $this$constrainScope;
    i.dh4_1 = factSet;
    return i;
  };
  function btbScopes$lambda$slambda_10($this_scopes, $taxonScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_9($this_scopes, $taxonScopeFilters$delegate, resultContinuation);
    var l = function ($this$constrainScope, factSet, $completion) {
      return i.zh4($this$constrainScope, factSet, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_11($this_scopes, $taxonScopeFilters$delegate, resultContinuation) {
    this.kh5_1 = $this_scopes;
    this.lh5_1 = $taxonScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_11).qh5 = function ($this$by, command, $completion) {
    var tmp = this.rh5($this$by, command, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_11).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.qh5(tmp, (!(p2 == null) ? isInterface(p2, FindConnectionCommand_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_11).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.mh5_1.n51(this.nh5_1.vb8());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lay();
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : this.mh5_1.n51(tmp1_safe_receiver);
            tmp_0.oh5_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.lay();
            if (this.oh5_1 == null) {
              this.ph5_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.mh5_1.m51(this.oh5_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.ph5_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            var tmp4_elvis_lhs = this.ph5_1;
            var tmp_1;
            if (tmp4_elvis_lhs == null) {
              return this.mh5_1.s7b_1;
            } else {
              tmp_1 = tmp4_elvis_lhs;
            }

            var contextTaxon = tmp_1;
            return invoke$lambda_1(this.kh5_1, this.lh5_1).bh5(contextTaxon);
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_11).rh5 = function ($this$by, command, completion) {
    var i = new btbScopes$lambda$slambda_11(this.kh5_1, this.lh5_1, completion);
    i.mh5_1 = $this$by;
    i.nh5_1 = command;
    return i;
  };
  function btbScopes$lambda$slambda_12($this_scopes, $taxonScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_11($this_scopes, $taxonScopeFilters$delegate, resultContinuation);
    var l = function ($this$by, command, $completion) {
      return i.qh5($this$by, command, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_3($ontologyHierarchy, resultContinuation) {
    this.ah6_1 = $ontologyHierarchy;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_3).dh6 = function ($this$query, it, $completion) {
    var tmp = this.eh6($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_3).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.dh6(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.bh6_1.m51(isNatural(this.ah6_1, this.ch6_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_3).eh6 = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_3(this.ah6_1, completion);
    i.bh6_1 = $this$query;
    i.ch6_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_4($ontologyHierarchy, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_3($ontologyHierarchy, resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.dh6($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_13(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_13).ph6 = function ($this$constrainScope, _unused_var__etf5q3, $completion) {
    var tmp = this.qh6($this$constrainScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_13).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.ph6(tmp, (!(p2 == null) ? isInterface(p2, OntologyIsRelation_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_13).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var ontologyHierarchy = ontologyElementHierarchy();
          var tmp_0 = Companion_instance_119;
          return tmp_0.a76(btbScopes$lambda$slambda$slambda_4(ontologyHierarchy, null));
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_13).qh6 = function ($this$constrainScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_13(completion);
    i.nh6_1 = $this$constrainScope;
    i.oh6_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_14(resultContinuation) {
    var i = new btbScopes$lambda$slambda_13(resultContinuation);
    var l = function ($this$constrainScope, _unused_var__etf5q3, $completion) {
      return i.ph6($this$constrainScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_15(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_15).bh7 = function ($this$provideCommonScope, library, $completion) {
    var tmp = this.ch7($this$provideCommonScope, library, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_15).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.bh7(tmp, (!(p2 == null) ? isInterface(p2, OntologyLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_15).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.zh6_1.t7a(this.ah7_1.sc0(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_15).ch7 = function ($this$provideCommonScope, library, completion) {
    var i = new btbScopes$lambda$slambda_15(completion);
    i.zh6_1 = $this$provideCommonScope;
    i.ah7_1 = library;
    return i;
  };
  function btbScopes$lambda$slambda_16(resultContinuation) {
    var i = new btbScopes$lambda$slambda_15(resultContinuation);
    var l = function ($this$provideCommonScope, library, $completion) {
      return i.bh7($this$provideCommonScope, library, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_5(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_5).nh7 = function ($this$filter, it, $completion) {
    var tmp = this.oh7($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_5).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.nh7(tmp, (!(p2 == null) ? isInterface(p2, OntologyLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_5).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return this.lh7_1.n51(this.mh7_1.b3()) === 'metaOntology';
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_5).oh7 = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_5(completion);
    i.lh7_1 = $this$filter;
    i.mh7_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_6(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_5(resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.nh7($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_17(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_17).zh7 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.ah8($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_17).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.zh7(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_17).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.xh7_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_6(null));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_17).ah8 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_17(completion);
    i.xh7_1 = $this$provideLexicalScope;
    i.yh7_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_18(resultContinuation) {
    var i = new btbScopes$lambda$slambda_17(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.zh7($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_7($ontologyHierarchy, resultContinuation) {
    this.jh8_1 = $ontologyHierarchy;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_7).dh6 = function ($this$filter, it, $completion) {
    var tmp = this.eh6($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_7).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.dh6(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_7).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.kh8_1.m51(isNatural(this.jh8_1, this.lh8_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_7).eh6 = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_7(this.jh8_1, completion);
    i.kh8_1 = $this$filter;
    i.lh8_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_8($ontologyHierarchy, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_7($ontologyHierarchy, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.dh6($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_19(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_19).xh8 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.yh8($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_19).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.xh8(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_19).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.wh8_1 = ontologyElementHierarchy();
            this.y9_1 = 1;
            suspendResult = this.uh8_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_8(this.wh8_1, null));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_19).yh8 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_19(completion);
    i.uh8_1 = $this$provideLexicalScope;
    i.vh8_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_20(resultContinuation) {
    var i = new btbScopes$lambda$slambda_19(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.xh8($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_9(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_9).nh7 = function ($this$filter, it, $completion) {
    var tmp = this.oh7($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_9).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.nh7(tmp, (!(p2 == null) ? isInterface(p2, OntologyLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_9).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return this.hh9_1.n51(this.ih9_1.b3()) === 'metaOntology';
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_9).oh7 = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_9(completion);
    i.hh9_1 = $this$filter;
    i.ih9_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_10(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_9(resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.nh7($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_21(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_21).zh7 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.ah8($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_21).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.zh7(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_21).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.rh9_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_10(null));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_21).ah8 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_21(completion);
    i.rh9_1 = $this$provideLexicalScope;
    i.sh9_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_22(resultContinuation) {
    var i = new btbScopes$lambda$slambda_21(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.zh7($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_23(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_23).zh7 = function ($this$provideLexicalScope, ontologyElement, $completion) {
    var tmp = this.ah8($this$provideLexicalScope, ontologyElement, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_23).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.zh7(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_23).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var this_0 = this.cha_1;
            var tmp0_safe_receiver = this.bha_1.n51(ancestorOrSelf(this_0, getKClass(OntologyLibrary_1)));
            if (tmp0_safe_receiver == null)
              null;
            else {
              if (this.bha_1.n51(tmp0_safe_receiver.b3()) === 'metaOntology') {
                return Scopes_getInstance().c7f();
              }
            }

            this.y9_1 = 1;
            suspendResult = this.bha_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_23).ah8 = function ($this$provideLexicalScope, ontologyElement, completion) {
    var i = new btbScopes$lambda$slambda_23(completion);
    i.bha_1 = $this$provideLexicalScope;
    i.cha_1 = ontologyElement;
    return i;
  };
  function btbScopes$lambda$slambda_24(resultContinuation) {
    var i = new btbScopes$lambda$slambda_23(resultContinuation);
    var l = function ($this$provideLexicalScope, ontologyElement, $completion) {
      return i.zh7($this$provideLexicalScope, ontologyElement, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_11(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_11).nh7 = function ($this$filter, it, $completion) {
    var tmp = this.oh7($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_11).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.nh7(tmp, (!(p2 == null) ? isInterface(p2, OntologyLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_11).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return contains_9(this.lha_1.n51(this.mha_1.b3()), 'NCBI Taxonomy');
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_11).oh7 = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_11(completion);
    i.lha_1 = $this$filter;
    i.mha_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_12(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_11(resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.nh7($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_25(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_25).zh7 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.ah8($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_25).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.zh7(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_25).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.vha_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_12(null));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_25).ah8 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_25(completion);
    i.vha_1 = $this$provideLexicalScope;
    i.wha_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_26(resultContinuation) {
    var i = new btbScopes$lambda$slambda_25(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.zh7($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_27(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_27).xh8 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.yh8($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_27).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.xh8(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_27).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_27).yh8 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_27(completion);
    i.fhb_1 = $this$provideLexicalScope;
    i.ghb_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_28(resultContinuation) {
    var i = new btbScopes$lambda$slambda_27(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.xh8($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_29($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.phb_1 = $this_scopes;
    this.qhb_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_29).uhb = function ($this$provideLexicalScope, library, $completion) {
    var tmp = this.vhb($this$provideLexicalScope, library, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_29).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.uhb(tmp, (!(p2 == null) ? isInterface(p2, OntologyLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_29).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.thb_1 = toList_2(this.rhb_1.n51(this.rhb_1.n51(invoke$lambda(this.phb_1, this.qhb_1).g6z(this.shb_1)).n6z(OntologyLibraryConcept_getInstance())));
            this.y9_1 = 1;
            suspendResult = this.rhb_1.u7a(this.thb_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_29).vhb = function ($this$provideLexicalScope, library, completion) {
    var i = new btbScopes$lambda$slambda_29(this.phb_1, this.qhb_1, completion);
    i.rhb_1 = $this$provideLexicalScope;
    i.shb_1 = library;
    return i;
  };
  function btbScopes$lambda$slambda_30($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_29($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$provideLexicalScope, library, $completion) {
      return i.uhb($this$provideLexicalScope, library, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_31($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.ehc_1 = $this_scopes;
    this.fhc_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_31).hhc = function ($this$defaultScope, $completion) {
    var tmp = this.ihc($this$defaultScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_31).oa = function (p1, $completion) {
    return this.hhc(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_31).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = librariesScope(this.ghc_1, invoke$lambda(this.ehc_1, this.fhc_1), OntologyLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_31).ihc = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_31(this.ehc_1, this.fhc_1, completion);
    i.ghc_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_32($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_31($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.hhc($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_33(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_33).uhc = function ($this$provideLexicalScope, contextNode, $completion) {
    var tmp = this.vhc($this$provideLexicalScope, contextNode, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_33).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.uhc(tmp, (!(p2 == null) ? isInterface(p2, Context_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_33).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.rhc_1.n51(this.shc_1.kay());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.thc_1 = tmp_1;
            this.y9_1 = 1;
            suspendResult = importOntologyLibrary(this.rhc_1, this.thc_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_33).vhc = function ($this$provideLexicalScope, contextNode, completion) {
    var i = new btbScopes$lambda$slambda_33(completion);
    i.rhc_1 = $this$provideLexicalScope;
    i.shc_1 = contextNode;
    return i;
  };
  function btbScopes$lambda$slambda_34(resultContinuation) {
    var i = new btbScopes$lambda$slambda_33(resultContinuation);
    var l = function ($this$provideLexicalScope, contextNode, $completion) {
      return i.uhc($this$provideLexicalScope, contextNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_35(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_35).hhd = function ($this$provideLexicalScope, contextNode, $completion) {
    var tmp = this.ihd($this$provideLexicalScope, contextNode, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_35).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hhd(tmp, (!(p2 == null) ? isInterface(p2, ContextQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_35).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.ehd_1.n51(this.fhd_1.kay());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.ghd_1 = tmp_1;
            this.y9_1 = 1;
            suspendResult = importOntologyLibrary(this.ehd_1, this.ghd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_35).ihd = function ($this$provideLexicalScope, contextNode, completion) {
    var i = new btbScopes$lambda$slambda_35(completion);
    i.ehd_1 = $this$provideLexicalScope;
    i.fhd_1 = contextNode;
    return i;
  };
  function btbScopes$lambda$slambda_36(resultContinuation) {
    var i = new btbScopes$lambda$slambda_35(resultContinuation);
    var l = function ($this$provideLexicalScope, contextNode, $completion) {
      return i.hhd($this$provideLexicalScope, contextNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_37(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_37).vhd = function ($this$provideLexicalScope, contextNode, $completion) {
    var tmp = this.whd($this$provideLexicalScope, contextNode, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_37).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.vhd(tmp, (!(p2 == null) ? isInterface(p2, QualifiedOntologyElementReference_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_37).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.rhd_1.n51(this.shd_1.lcj());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.thd_1 = tmp_1;
            this.y9_1 = 1;
            suspendResult = importOntologyLibrary(this.rhd_1, this.thd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.uhd_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.rhd_1.s7a(this.uhd_1, get_elementTypeAndTaxon(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_37).whd = function ($this$provideLexicalScope, contextNode, completion) {
    var i = new btbScopes$lambda$slambda_37(completion);
    i.rhd_1 = $this$provideLexicalScope;
    i.shd_1 = contextNode;
    return i;
  };
  function btbScopes$lambda$slambda_38(resultContinuation) {
    var i = new btbScopes$lambda$slambda_37(resultContinuation);
    var l = function ($this$provideLexicalScope, contextNode, $completion) {
      return i.vhd($this$provideLexicalScope, contextNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_39(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_39).ihe = function ($this$provideLexicalScope, category, $completion) {
    var tmp = this.jhe($this$provideLexicalScope, category, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_39).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ihe(tmp, (!(p2 == null) ? isInterface(p2, Category_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_39).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.fhe_1.n51(this.ghe_1.kay());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.hhe_1 = tmp_1;
            this.y9_1 = 1;
            suspendResult = importOntologyLibrary(this.fhe_1, this.hhe_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_39).jhe = function ($this$provideLexicalScope, category, completion) {
    var i = new btbScopes$lambda$slambda_39(completion);
    i.fhe_1 = $this$provideLexicalScope;
    i.ghe_1 = category;
    return i;
  };
  function btbScopes$lambda$slambda_40(resultContinuation) {
    var i = new btbScopes$lambda$slambda_39(resultContinuation);
    var l = function ($this$provideLexicalScope, category, $completion) {
      return i.ihe($this$provideLexicalScope, category, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_41(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_41).vhe = function ($this$provideLexicalScope, importNode, $completion) {
    var tmp = this.whe($this$provideLexicalScope, importNode, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_41).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.vhe(tmp, (!(p2 == null) ? isInterface(p2, OntologyImport_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_41).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.she_1.n51(this.the_1.sby());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.uhe_1 = tmp_1;
            this.y9_1 = 1;
            suspendResult = importOntologyLibrary(this.she_1, this.uhe_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_41).whe = function ($this$provideLexicalScope, importNode, completion) {
    var i = new btbScopes$lambda$slambda_41(completion);
    i.she_1 = $this$provideLexicalScope;
    i.the_1 = importNode;
    return i;
  };
  function btbScopes$lambda$slambda_42(resultContinuation) {
    var i = new btbScopes$lambda$slambda_41(resultContinuation);
    var l = function ($this$provideLexicalScope, importNode, $completion) {
      return i.vhe($this$provideLexicalScope, importNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_43(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_43).jhf = function ($this$provideLexicalScope, typeNode, $completion) {
    var tmp = this.khf($this$provideLexicalScope, typeNode, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_43).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.jhf(tmp, (!(p2 == null) ? isInterface(p2, OntologyElementType_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_43).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.fhf_1.n51(this.ghf_1.kay());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.hhf_1 = tmp_1;
            this.y9_1 = 1;
            suspendResult = importOntologyLibrary(this.fhf_1, this.hhf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ihf_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.fhf_1.s7a(this.ihf_1, get_elementTypeAndTaxon(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_43).khf = function ($this$provideLexicalScope, typeNode, completion) {
    var i = new btbScopes$lambda$slambda_43(completion);
    i.fhf_1 = $this$provideLexicalScope;
    i.ghf_1 = typeNode;
    return i;
  };
  function btbScopes$lambda$slambda_44(resultContinuation) {
    var i = new btbScopes$lambda$slambda_43(resultContinuation);
    var l = function ($this$provideLexicalScope, typeNode, $completion) {
      return i.jhf($this$provideLexicalScope, typeNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_45(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_45).whf = function ($this$provideLexicalScope, typeNode, $completion) {
    var tmp = this.xhf($this$provideLexicalScope, typeNode, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_45).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.whf(tmp, (!(p2 == null) ? isInterface(p2, OntologyElementPropertyType_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_45).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.thf_1.n51(this.uhf_1.kay());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.vhf_1 = tmp_1;
            this.y9_1 = 1;
            suspendResult = importOntologyLibrary(this.thf_1, this.vhf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_45).xhf = function ($this$provideLexicalScope, typeNode, completion) {
    var i = new btbScopes$lambda$slambda_45(completion);
    i.thf_1 = $this$provideLexicalScope;
    i.uhf_1 = typeNode;
    return i;
  };
  function btbScopes$lambda$slambda_46(resultContinuation) {
    var i = new btbScopes$lambda$slambda_45(resultContinuation);
    var l = function ($this$provideLexicalScope, typeNode, $completion) {
      return i.whf($this$provideLexicalScope, typeNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_47(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_47).ihg = function ($this$provideLexicalScope, contextNode, $completion) {
    var tmp = this.jhg($this$provideLexicalScope, contextNode, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_47).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ihg(tmp, (!(p2 == null) ? isInterface(p2, QueryParametersBlackList) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_47).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ghg_1.v7a(this.hhg_1.kay(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_47).jhg = function ($this$provideLexicalScope, contextNode, completion) {
    var i = new btbScopes$lambda$slambda_47(completion);
    i.ghg_1 = $this$provideLexicalScope;
    i.hhg_1 = contextNode;
    return i;
  };
  function btbScopes$lambda$slambda_48(resultContinuation) {
    var i = new btbScopes$lambda$slambda_47(resultContinuation);
    var l = function ($this$provideLexicalScope, contextNode, $completion) {
      return i.ihg($this$provideLexicalScope, contextNode, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_13($property, resultContinuation) {
    this.shg_1 = $property;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_13).vhg = function ($this$filter, it, $completion) {
    var tmp = this.whg($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_13).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vhg(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_13).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !equals(this.uhg_1, this.shg_1);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_13).whg = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_13(this.shg_1, completion);
    i.thg_1 = $this$filter;
    i.uhg_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_14($property, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_13($property, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.vhg($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_49(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_49).hhh = function ($this$provideLexicalScope, property, $completion) {
    var tmp = this.ihh($this$provideLexicalScope, property, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_49).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hhh(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_49).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.fhh_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_14(this.ghh_1, null));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_49).ihh = function ($this$provideLexicalScope, property, completion) {
    var i = new btbScopes$lambda$slambda_49(completion);
    i.fhh_1 = $this$provideLexicalScope;
    i.ghh_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_50(resultContinuation) {
    var i = new btbScopes$lambda$slambda_49(resultContinuation);
    var l = function ($this$provideLexicalScope, property, $completion) {
      return i.hhh($this$provideLexicalScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$o$collect$slambda($$this$unsafeFlow, $this_provideLexicalScope, $type, resultContinuation) {
    this.rhh_1 = $$this$unsafeFlow;
    this.shh_1 = $this_provideLexicalScope;
    this.thh_1 = $type;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 12;
            var tmp_0 = this;
            tmp_0.vhh_1 = this.rhh_1;
            var tmp_1 = this;
            tmp_1.whh_1 = this.uhh_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.yhh_1 = this.vhh_1;
            this.zhh_1 = this.whh_1;
            var tmp_2 = this;
            tmp_2.ahi_1 = this.zhh_1;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.chi_1 = this.ahi_1;
            this.dhi_1 = this.shh_1.n51(this.chi_1.zb3());
            if (this.dhi_1 == null) {
              this.bhi_1 = false;
              this.y9_1 = 8;
              var tmp_3 = this;
              continue $sm;
            } else {
              this.ehi_1 = this.dhi_1;
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            this.fhi_1 = this.ehi_1;
            this.ghi_1 = this.shh_1.n51(this.fhi_1.lay());
            if (this.ghi_1 == null) {
              this.bhi_1 = false;
              this.y9_1 = 8;
              var tmp_4 = this;
              continue $sm;
            } else {
              this.hhi_1 = this.ghi_1;
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            this.ihi_1 = this.hhi_1;
            this.y9_1 = 5;
            suspendResult = this.shh_1.m51(this.ihi_1.lay(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.jhi_1 = suspendResult;
            if (this.jhi_1 == null) {
              this.bhi_1 = false;
              this.y9_1 = 8;
              var tmp_5 = this;
              continue $sm;
            } else {
              this.khi_1 = this.jhi_1;
              this.y9_1 = 6;
              continue $sm;
            }

          case 6:
            this.lhi_1 = this.khi_1;
            this.y9_1 = 7;
            suspendResult = this.shh_1.m51(this.thh_1.pd6(this.lhi_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.bhi_1 = suspendResult;
            if (false) {
              this.y9_1 = 2;
              continue $sm;
            }

            this.y9_1 = 8;
            continue $sm;
          case 8:
            if (this.bhi_1) {
              this.y9_1 = 10;
              suspendResult = this.yhh_1.d1f(this.zhh_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 9;
              continue $sm;
            }

          case 9:
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 11;
            continue $sm;
          case 10:
            this.xhh_1 = suspendResult;
            this.y9_1 = 11;
            continue $sm;
          case 11:
            return Unit_instance;
          case 12:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 12) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$o$collect$slambda).a1u = function (value, completion) {
    var i = new btbScopes$lambda$slambda$o$collect$slambda(this.rhh_1, this.shh_1, this.thh_1, completion);
    i.uhh_1 = value;
    return i;
  };
  function btbScopes$lambda$slambda$o$collect$slambda_0($$this$unsafeFlow, $this_provideLexicalScope, $type, resultContinuation) {
    var i = new btbScopes$lambda$slambda$o$collect$slambda($$this$unsafeFlow, $this_provideLexicalScope, $type, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$44(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.uhi_1 = _this__u8e3s4;
    this.vhi_1 = collector;
  }
  protoOf($collectCOROUTINE$44).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.whi_1 = this.vhi_1;
            this.xhi_1 = this.whi_1;
            this.y9_1 = 1;
            var tmp_1 = btbScopes$lambda$slambda$o$collect$slambda_0(this.xhi_1, this.uhi_1.zhi_1, this.uhi_1.ahj_1, null);
            suspendResult = this.uhi_1.yhi_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_11(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function btbScopes$lambda$slambda$lambda($this_provideLexicalScope) {
    return function (it) {
      return $this_provideLexicalScope.n51(it.n9c());
    };
  }
  function btbScopes$lambda$slambda$lambda_0($this_provideLexicalScope) {
    return function (it) {
      return $this_provideLexicalScope.n51(it.yb3());
    };
  }
  function btbScopes$1$27$$inlined$filter$1($this, $this_provideLexicalScope, $type) {
    this.yhi_1 = $this;
    this.zhi_1 = $this_provideLexicalScope;
    this.ahj_1 = $type;
  }
  protoOf(btbScopes$1$27$$inlined$filter$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$44(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$1$27$$inlined$filter$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function btbScopes$lambda$slambda_51($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.jhj_1 = $this_scopes;
    this.khj_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_51).yhj = function ($this$provideLexicalScope, partValue, $completion) {
    var tmp = this.zhj($this$provideLexicalScope, partValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_51).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.yhj(tmp, (!(p2 == null) ? isInterface(p2, PartValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_51).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.lhj_1.n51(this.mhj_1.obr());
            tmp_0.nhj_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.xcq();
            if (this.nhj_1 == null) {
              this.ohj_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.lhj_1.m51(this.nhj_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.ohj_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.phj_1 = this.ohj_1;
            var tmp_1 = this;
            var tmp_2;
            if (this.phj_1 == null) {
              return new EmptyScope();
            } else {
              tmp_2 = this.phj_1;
            }

            tmp_1.qhj_1 = tmp_2;
            var tmp_3 = this;
            var tmp3_elvis_lhs = this.lhj_1.n51(this.qhj_1.jcq());
            var tmp_4;
            if (tmp3_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_4 = tmp3_elvis_lhs;
            }

            tmp_3.rhj_1 = tmp_4;
            var tmp_5 = this;
            var tmp_6 = this.rhj_1;
            var tmp4_elvis_lhs = isInterface(tmp_6, OntologyElementType_1) ? tmp_6 : null;
            var tmp_7;
            if (tmp4_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_7 = tmp4_elvis_lhs;
            }

            tmp_5.shj_1 = tmp_7;
            var tmp_8 = this;
            var tmp5_safe_receiver = this.lhj_1.n51(this.shj_1.lay());
            tmp_8.thj_1 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.lay();
            if (this.thj_1 == null) {
              this.uhj_1 = null;
              this.y9_1 = 4;
              continue $sm;
            } else {
              this.y9_1 = 3;
              suspendResult = this.lhj_1.m51(this.thj_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.uhj_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.vhj_1 = this.uhj_1;
            var tmp_9 = this;
            var tmp_10;
            if (this.vhj_1 == null) {
              return new EmptyScope();
            } else {
              tmp_10 = this.vhj_1;
            }

            tmp_9.whj_1 = tmp_10;
            this.y9_1 = 5;
            var tmp_11 = this.lhj_1.n51(this.lhj_1.n51(invoke$lambda(this.jhj_1, this.khj_1).g6z(this.mhj_1)).n6z(ExtensionLibraryConcept_getInstance()));
            var tmp_12 = flatMap(tmp_11, btbScopes$lambda$slambda$lambda(this.lhj_1));
            var this_0 = asFlow_0(flatMap(tmp_12, btbScopes$lambda$slambda$lambda_0(this.lhj_1)));
            suspendResult = toList_3(new btbScopes$1$27$$inlined$filter$1(this_0, this.lhj_1, this.whj_1), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.xhj_1 = suspendResult;
            this.y9_1 = 6;
            suspendResult = this.lhj_1.u7a(this.xhj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            return suspendResult;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_51).zhj = function ($this$provideLexicalScope, partValue, completion) {
    var i = new btbScopes$lambda$slambda_51(this.jhj_1, this.khj_1, completion);
    i.lhj_1 = $this$provideLexicalScope;
    i.mhj_1 = partValue;
    return i;
  };
  function btbScopes$lambda$slambda_52($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_51($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$provideLexicalScope, partValue, $completion) {
      return i.yhj($this$provideLexicalScope, partValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_53($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    this.ihk_1 = $this_scopes;
    this.jhk_1 = $subtypeScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_53).vhk = function ($this$constrainScope, linkValue, $completion) {
    var tmp = this.whk($this$constrainScope, linkValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_53).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.vhk(tmp, (!(p2 == null) ? isInterface(p2, OntologyLinkValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_53).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            this.y9_1 = 1;
            suspendResult = this.khk_1.m51(this.lhk_1.wc2(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.mhk_1 = suspendResult;
            if (this.mhk_1 == null) {
              this.nhk_1 = null;
              this.y9_1 = 5;
              continue $sm;
            } else {
              var tmp_0 = this;
              tmp_0.ohk_1 = this.mhk_1;
              this.phk_1 = this.ohk_1;
              var tmp_1 = this;
              tmp_1.qhk_1 = this.phk_1;
              this.rhk_1 = this.qhk_1;
              this.y9_1 = 2;
              suspendResult = this.khk_1.m51(this.rhk_1.sba(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.thk_1 = suspendResult;
            this.uhk_1 = equals(this.thk_1, LinkTypeSpecificator_TYPE_OF_getInstance());
            if (!this.uhk_1) {
              var tmp_2 = this;
              tmp_2.shk_1 = null;
              this.y9_1 = 4;
              continue $sm;
            } else {
              this.y9_1 = 3;
              suspendResult = this.khk_1.m51(this.rhk_1.lay(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.shk_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.nhk_1 = this.shk_1;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            var upperElement = this.nhk_1;
            return upperElement == null ? this.khk_1.s7b_1 : invoke$lambda_0(this.ihk_1, this.jhk_1).bh5(upperElement);
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_53).whk = function ($this$constrainScope, linkValue, completion) {
    var i = new btbScopes$lambda$slambda_53(this.ihk_1, this.jhk_1, completion);
    i.khk_1 = $this$constrainScope;
    i.lhk_1 = linkValue;
    return i;
  };
  function btbScopes$lambda$slambda_54($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_53($this_scopes, $subtypeScopeFilters$delegate, resultContinuation);
    var l = function ($this$constrainScope, linkValue, $completion) {
      return i.vhk($this$constrainScope, linkValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_55(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_55).phl = function ($this$provideLexicalScope, linkValue, $completion) {
    var tmp = this.qhl($this$provideLexicalScope, linkValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_55).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.phl(tmp, (!(p2 == null) ? isInterface(p2, OntologyLinkValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_55).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            this.y9_1 = 1;
            suspendResult = this.fhl_1.m51(this.ghl_1.wc2(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.hhl_1 = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (this.hhl_1 == null) {
              return new EmptyScope();
            } else {
              tmp_1 = this.hhl_1;
            }

            tmp_0.ihl_1 = tmp_1;
            this.y9_1 = 2;
            suspendResult = this.fhl_1.m51(this.ihl_1.sba(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.jhl_1 = suspendResult;
            this.khl_1 = equals(this.jhl_1, LinkTypeSpecificator_TYPE_OF_getInstance());
            if (!this.khl_1) {
              return Scopes_getInstance().c7f();
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            this.lhl_1 = this.fhl_1.n51(this.ihl_1.uc1());
            var tmp_2 = this;
            var tmp1_safe_receiver = this.lhl_1;
            var tmp_3;
            if (tmp1_safe_receiver == null) {
              tmp_3 = null;
            } else {
              tmp_3 = listOf(tmp1_safe_receiver);
            }

            tmp_2.mhl_1 = tmp_3;
            if (this.mhl_1 == null) {
              this.y9_1 = 4;
              suspendResult = this.fhl_1.m51(this.ghl_1.nd9(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.nhl_1 = this.mhl_1;
              this.y9_1 = 5;
              continue $sm;
            }

          case 4:
            this.nhl_1 = suspendResult;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.ohl_1 = this.nhl_1;
            this.y9_1 = 6;
            suspendResult = importOntologyLibraries(this.fhl_1, this.ohl_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            return suspendResult;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_55).qhl = function ($this$provideLexicalScope, linkValue, completion) {
    var i = new btbScopes$lambda$slambda_55(completion);
    i.fhl_1 = $this$provideLexicalScope;
    i.ghl_1 = linkValue;
    return i;
  };
  function btbScopes$lambda$slambda_56(resultContinuation) {
    var i = new btbScopes$lambda$slambda_55(resultContinuation);
    var l = function ($this$provideLexicalScope, linkValue, $completion) {
      return i.phl($this$provideLexicalScope, linkValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_57($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    this.zhl_1 = $this_scopes;
    this.ahm_1 = $subtypeScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_57).dhm = function ($this$constrainScope, propertyValue, $completion) {
    var tmp = this.ehm($this$constrainScope, propertyValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_57).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.dhm(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_57).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.bhm_1.m51(propertyTypeElements(this.chm_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return this.bhm_1.s7b_1;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var baseTypeElements = tmp_0;
            return invoke$lambda_0(this.zhl_1, this.ahm_1).fhm(baseTypeElements);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_57).ehm = function ($this$constrainScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_57(this.zhl_1, this.ahm_1, completion);
    i.bhm_1 = $this$constrainScope;
    i.chm_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_58($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_57($this_scopes, $subtypeScopeFilters$delegate, resultContinuation);
    var l = function ($this$constrainScope, propertyValue, $completion) {
      return i.dhm($this$constrainScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_59($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    this.ohm_1 = $this_scopes;
    this.phm_1 = $subtypeScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_59).vhm = function ($this$constrainScope, relationValue, $completion) {
    var tmp = this.whm($this$constrainScope, relationValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_59).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.vhm(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_59).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.qhm_1.m51(this.rhm_1.gb6(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.shm_1 = suspendResult;
            this.thm_1 = this.shm_1 == null ? null : this.qhm_1.n51(this.shm_1.be());
            this.uhm_1 = typeElements(this.thm_1);
            this.y9_1 = 2;
            suspendResult = this.qhm_1.m51(this.uhm_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp1_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              return this.qhm_1.s7b_1;
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }

            var ontologyElementRangeType = tmp_0;
            return invoke$lambda_0(this.ohm_1, this.phm_1).fhm(ontologyElementRangeType);
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_59).whm = function ($this$constrainScope, relationValue, completion) {
    var i = new btbScopes$lambda$slambda_59(this.ohm_1, this.phm_1, completion);
    i.qhm_1 = $this$constrainScope;
    i.rhm_1 = relationValue;
    return i;
  };
  function btbScopes$lambda$slambda_60($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_59($this_scopes, $subtypeScopeFilters$delegate, resultContinuation);
    var l = function ($this$constrainScope, relationValue, $completion) {
      return i.vhm($this$constrainScope, relationValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_61(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_61).gho = function ($this$provideLexicalScope, constraint, $completion) {
    var tmp = this.hho($this$provideLexicalScope, constraint, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_61).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.gho(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_61).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 10;
            this.y9_1 = 1;
            suspendResult = this.fhn_1.m51(this.ghn_1.i6u(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.hhn_1 = suspendResult;
            this.ihn_1 = this.hhn_1 == null ? null : this.fhn_1.n51(this.hhn_1.be());
            this.jhn_1 = this.ihn_1 == null ? null : this.fhn_1.n51(this.ihn_1.lbn());
            if (this.jhn_1 == null) {
              this.khn_1 = null;
              this.y9_1 = 5;
              continue $sm;
            } else {
              var tmp_0 = this;
              tmp_0.lhn_1 = this.jhn_1;
              this.mhn_1 = this.lhn_1;
              var tmp_1 = this;
              tmp_1.nhn_1 = this.mhn_1;
              var tmp_2 = this;
              tmp_2.ohn_1 = ArrayList_init_$Create$();
              this.phn_1 = this.nhn_1;
              this.qhn_1 = this.ohn_1;
              var tmp_3 = this;
              tmp_3.rhn_1 = this.phn_1;
              this.shn_1 = this.rhn_1;
              this.thn_1 = this.shn_1.k();
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            if (!this.thn_1.l()) {
              this.y9_1 = 4;
              continue $sm;
            }

            this.uhn_1 = this.thn_1.m();
            var tmp_4 = this;
            tmp_4.vhn_1 = this.uhn_1;
            this.whn_1 = this.vhn_1;
            var tmp_5 = this;
            tmp_5.xhn_1 = this.whn_1;
            this.yhn_1 = this.xhn_1;
            this.y9_1 = 3;
            suspendResult = this.fhn_1.m51(typeElements(this.yhn_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.zhn_1 = suspendResult;
            if (this.zhn_1 == null)
              null;
            else {
              var it = this.zhn_1;
              this.qhn_1.e(it);
            }

            this.y9_1 = 2;
            continue $sm;
          case 4:
            this.khn_1 = this.qhn_1;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.aho_1 = this.khn_1;
            this.bho_1 = this.aho_1 == null ? null : flatten(this.aho_1);
            this.cho_1 = this.bho_1 == null ? null : toSet_0(this.bho_1);
            if (this.cho_1 == null) {
              this.y9_1 = 6;
              suspendResult = this.fhn_1.x7a(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.dho_1 = this.cho_1;
              this.y9_1 = 7;
              continue $sm;
            }

          case 6:
            var tmp_6 = this;
            return suspendResult;
          case 7:
            this.eho_1 = this.dho_1;
            if (!this.eho_1.p()) {
              this.y9_1 = 8;
              suspendResult = this.fhn_1.x7a(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.fho_1 = Scopes_getInstance().c7f();
              this.y9_1 = 9;
              continue $sm;
            }

          case 8:
            this.fho_1 = suspendResult;
            this.y9_1 = 9;
            continue $sm;
          case 9:
            return this.fho_1;
          case 10:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 10) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_61).hho = function ($this$provideLexicalScope, constraint, completion) {
    var i = new btbScopes$lambda$slambda_61(completion);
    i.fhn_1 = $this$provideLexicalScope;
    i.ghn_1 = constraint;
    return i;
  };
  function btbScopes$lambda$slambda_62(resultContinuation) {
    var i = new btbScopes$lambda$slambda_61(resultContinuation);
    var l = function ($this$provideLexicalScope, constraint, $completion) {
      return i.gho($this$provideLexicalScope, constraint, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_63($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    this.qho_1 = $this_scopes;
    this.rho_1 = $subtypeScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_63).ohp = function ($this$constrainScope, expression, $completion) {
    var tmp = this.php($this$constrainScope, expression, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_63).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.ohp(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_63).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.sho_1.n51(this.tho_1.sbf());
            tmp_0.uho_1 = tmp0_safe_receiver == null ? null : this.sho_1.n51(tmp0_safe_receiver.i6u());
            if (this.uho_1 == null) {
              this.vho_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.sho_1.m51(this.uho_1.i6u(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.vho_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.who_1 = this.vho_1;
            this.xho_1 = this.who_1 == null ? null : this.sho_1.n51(this.who_1.be());
            this.yho_1 = this.xho_1 == null ? null : this.sho_1.n51(this.xho_1.lbn());
            this.zho_1 = this.yho_1 == null ? emptyList() : this.yho_1;
            var tmp_1 = this;
            tmp_1.ahp_1 = this.zho_1;
            this.bhp_1 = this.ahp_1;
            var tmp_2 = this;
            tmp_2.chp_1 = this.bhp_1;
            var tmp_3 = this;
            tmp_3.dhp_1 = ArrayList_init_$Create$();
            this.ehp_1 = this.chp_1;
            this.fhp_1 = this.dhp_1;
            var tmp_4 = this;
            tmp_4.ghp_1 = this.ehp_1;
            this.hhp_1 = this.ghp_1;
            this.ihp_1 = this.hhp_1.k();
            this.y9_1 = 3;
            continue $sm;
          case 3:
            if (!this.ihp_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.jhp_1 = this.ihp_1.m();
            var tmp_5 = this;
            tmp_5.khp_1 = this.jhp_1;
            this.lhp_1 = this.khp_1;
            var tmp_6 = this;
            tmp_6.mhp_1 = this.lhp_1;
            this.nhp_1 = this.mhp_1;
            this.y9_1 = 4;
            suspendResult = this.sho_1.m51(typeElements(this.nhp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var tmp0_safe_receiver_0 = suspendResult;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              this.fhp_1.e(tmp0_safe_receiver_0);
            }

            this.y9_1 = 3;
            continue $sm;
          case 5:
            var ARGUMENT = this.fhp_1;
            var baseTypeElements = flatten(ARGUMENT);
            return invoke$lambda_0(this.qho_1, this.rho_1).fhm(baseTypeElements);
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_63).php = function ($this$constrainScope, expression, completion) {
    var i = new btbScopes$lambda$slambda_63(this.qho_1, this.rho_1, completion);
    i.sho_1 = $this$constrainScope;
    i.tho_1 = expression;
    return i;
  };
  function btbScopes$lambda$slambda_64($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_63($this_scopes, $subtypeScopeFilters$delegate, resultContinuation);
    var l = function ($this$constrainScope, expression, $completion) {
      return i.ohp($this$constrainScope, expression, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_65($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    this.yhp_1 = $this_scopes;
    this.zhp_1 = $subtypeScopeFilters$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_65).dhq = function ($this$constrainScope, processPropertyDefault, $completion) {
    var tmp = this.ehq($this$constrainScope, processPropertyDefault, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_65).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.dhq(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyDefault_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_65).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.ahq_1.n51(ancestorOrSelf(this.bhq_1, getKClass(ProcessProperty_1)));
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return this.ahq_1.s7b_1;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.chq_1 = tmp_1;
            this.y9_1 = 1;
            suspendResult = processPropertyElements(this.ahq_1, this.chq_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp1_elvis_lhs = suspendResult;
            var tmp_2;
            if (tmp1_elvis_lhs == null) {
              return this.ahq_1.s7b_1;
            } else {
              tmp_2 = tmp1_elvis_lhs;
            }

            var baseTypeElements = tmp_2;
            return invoke$lambda_0(this.yhp_1, this.zhp_1).fhm(baseTypeElements);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_65).ehq = function ($this$constrainScope, processPropertyDefault, completion) {
    var i = new btbScopes$lambda$slambda_65(this.yhp_1, this.zhp_1, completion);
    i.ahq_1 = $this$constrainScope;
    i.bhq_1 = processPropertyDefault;
    return i;
  };
  function btbScopes$lambda$slambda_66($this_scopes, $subtypeScopeFilters$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_65($this_scopes, $subtypeScopeFilters$delegate, resultContinuation);
    var l = function ($this$constrainScope, processPropertyDefault, $completion) {
      return i.dhq($this$constrainScope, processPropertyDefault, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_67(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_67).thq = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.uhq($this$provideLexicalScope, propertyValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_67).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.thq(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_67).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.y9_1 = 1;
            suspendResult = this.nhq_1.m51(propertyTypeElements(this.ohq_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.phq_1 = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (this.phq_1 == null) {
              return new EmptyScope();
            } else {
              tmp_1 = this.phq_1;
            }

            tmp_0.qhq_1 = tmp_1;
            if (!(this.qhq_1.n() === 1))
              return new EmptyScope();
            var tmp_2 = this;
            var this_0 = this.ohq_1;
            var tmp1_elvis_lhs = this.nhq_1.n51(ancestorOrSelf(this_0, getKClass(BTBDocument_1)));
            var tmp_3;
            if (tmp1_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_3 = tmp1_elvis_lhs;
            }

            tmp_2.rhq_1 = tmp_3;
            this.y9_1 = 2;
            suspendResult = this.nhq_1.m51(this.rhq_1.dct(first_0(this.qhq_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.shq_1 = suspendResult;
            this.y9_1 = 3;
            suspendResult = importOntologyLibraries(this.nhq_1, this.shq_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_67).uhq = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_67(completion);
    i.nhq_1 = $this$provideLexicalScope;
    i.ohq_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_68(resultContinuation) {
    var i = new btbScopes$lambda$slambda_67(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.thq($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_69(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_69).ehs = function ($this$provideLexicalScope, expression, $completion) {
    var tmp = this.fhs($this$provideLexicalScope, expression, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_69).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ehs(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_69).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 8;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.dhr_1.n51(this.ehr_1.sbf());
            tmp_0.fhr_1 = tmp0_safe_receiver == null ? null : this.dhr_1.n51(tmp0_safe_receiver.i6u());
            if (this.fhr_1 == null) {
              this.ghr_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.dhr_1.m51(this.fhr_1.i6u(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.ghr_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.hhr_1 = this.ghr_1;
            this.ihr_1 = this.hhr_1 == null ? null : this.dhr_1.n51(this.hhr_1.be());
            this.jhr_1 = this.ihr_1 == null ? null : this.dhr_1.n51(this.ihr_1.lbn());
            this.khr_1 = this.jhr_1 == null ? emptyList() : this.jhr_1;
            var tmp_1 = this;
            tmp_1.lhr_1 = this.khr_1;
            this.mhr_1 = this.lhr_1;
            var tmp_2 = this;
            tmp_2.nhr_1 = this.mhr_1;
            var tmp_3 = this;
            tmp_3.ohr_1 = ArrayList_init_$Create$();
            this.phr_1 = this.nhr_1;
            this.qhr_1 = this.ohr_1;
            var tmp_4 = this;
            tmp_4.rhr_1 = this.phr_1;
            this.shr_1 = this.rhr_1;
            this.thr_1 = this.shr_1.k();
            this.y9_1 = 3;
            continue $sm;
          case 3:
            if (!this.thr_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.uhr_1 = this.thr_1.m();
            var tmp_5 = this;
            tmp_5.vhr_1 = this.uhr_1;
            this.whr_1 = this.vhr_1;
            var tmp_6 = this;
            tmp_6.xhr_1 = this.whr_1;
            this.yhr_1 = this.xhr_1;
            this.y9_1 = 4;
            suspendResult = this.dhr_1.m51(typeElements(this.yhr_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.zhr_1 = suspendResult;
            if (this.zhr_1 == null)
              null;
            else {
              var it = this.zhr_1;
              this.qhr_1.e(it);
            }

            this.y9_1 = 3;
            continue $sm;
          case 5:
            this.ahs_1 = this.qhr_1;
            this.bhs_1 = flatten(this.ahs_1);
            if (!(this.bhs_1.n() === 1))
              return new EmptyScope();
            var tmp_7 = this;
            var this_0 = this.ehr_1;
            var tmp5_elvis_lhs = this.dhr_1.n51(ancestorOrSelf(this_0, getKClass(BTBDocument_1)));
            var tmp_8;
            if (tmp5_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_8 = tmp5_elvis_lhs;
            }

            tmp_7.chs_1 = tmp_8;
            this.y9_1 = 6;
            suspendResult = this.dhr_1.m51(this.chs_1.dct(first(this.bhs_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.dhs_1 = suspendResult;
            this.y9_1 = 7;
            suspendResult = importOntologyLibraries(this.dhr_1, this.dhs_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            return suspendResult;
          case 8:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 8) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_69).fhs = function ($this$provideLexicalScope, expression, completion) {
    var i = new btbScopes$lambda$slambda_69(completion);
    i.dhr_1 = $this$provideLexicalScope;
    i.ehr_1 = expression;
    return i;
  };
  function btbScopes$lambda$slambda_70(resultContinuation) {
    var i = new btbScopes$lambda$slambda_69(resultContinuation);
    var l = function ($this$provideLexicalScope, expression, $completion) {
      return i.ehs($this$provideLexicalScope, expression, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_71(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_71).shs = function ($this$provideLexicalScope, elementReferenceValue, $completion) {
    var tmp = this.ths($this$provideLexicalScope, elementReferenceValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_71).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.shs(tmp, (!(p2 == null) ? isInterface(p2, OntologyElementReferenceValueLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_71).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.ohs_1.n51(this.phs_1.kay());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.qhs_1 = tmp_1;
            this.y9_1 = 1;
            suspendResult = importOntologyLibrary(this.ohs_1, this.qhs_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.rhs_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.ohs_1.s7a(this.rhs_1, get_elementTypeAndTaxon(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_71).ths = function ($this$provideLexicalScope, elementReferenceValue, completion) {
    var i = new btbScopes$lambda$slambda_71(completion);
    i.ohs_1 = $this$provideLexicalScope;
    i.phs_1 = elementReferenceValue;
    return i;
  };
  function btbScopes$lambda$slambda_72(resultContinuation) {
    var i = new btbScopes$lambda$slambda_71(resultContinuation);
    var l = function ($this$provideLexicalScope, elementReferenceValue, $completion) {
      return i.shs($this$provideLexicalScope, elementReferenceValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_73(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_73).eht = function ($this$provideImportScope, notion, $completion) {
    var tmp = this.fht($this$provideImportScope, notion, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_73).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.eht(tmp, (!(p2 == null) ? isInterface(p2, EnumerableNotion_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_73).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.cht_1.t7a(this.dht_1.jb3(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_73).fht = function ($this$provideImportScope, notion, completion) {
    var i = new btbScopes$lambda$slambda_73(completion);
    i.cht_1 = $this$provideImportScope;
    i.dht_1 = notion;
    return i;
  };
  function btbScopes$lambda$slambda_74(resultContinuation) {
    var i = new btbScopes$lambda$slambda_73(resultContinuation);
    var l = function ($this$provideImportScope, notion, $completion) {
      return i.eht($this$provideImportScope, notion, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_75(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_75).qht = function ($this$provideImportScope, notion, $completion) {
    var tmp = this.rht($this$provideImportScope, notion, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_75).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.qht(tmp, (!(p2 == null) ? isInterface(p2, MeasurableNotion_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_75).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.oht_1.t7a(this.pht_1.sbj(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_75).rht = function ($this$provideImportScope, notion, completion) {
    var i = new btbScopes$lambda$slambda_75(completion);
    i.oht_1 = $this$provideImportScope;
    i.pht_1 = notion;
    return i;
  };
  function btbScopes$lambda$slambda_76(resultContinuation) {
    var i = new btbScopes$lambda$slambda_75(resultContinuation);
    var l = function ($this$provideImportScope, notion, $completion) {
      return i.qht($this$provideImportScope, notion, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_77(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_77).dhu = function ($this$provideImportScope, property, $completion) {
    var tmp = this.ehu($this$provideImportScope, property, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_77).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.dhu(tmp, (!(p2 == null) ? isInterface(p2, PropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_77).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.ahu_1.n51(this.bhu_1.zb3());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.chu_1 = tmp_1;
            this.y9_1 = 1;
            suspendResult = this.ahu_1.v7a(this.chu_1.lbp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_77).ehu = function ($this$provideImportScope, property, completion) {
    var i = new btbScopes$lambda$slambda_77(completion);
    i.ahu_1 = $this$provideImportScope;
    i.bhu_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_78(resultContinuation) {
    var i = new btbScopes$lambda$slambda_77(resultContinuation);
    var l = function ($this$provideImportScope, property, $completion) {
      return i.dhu($this$provideImportScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_79(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_79).qhu = function ($this$provideCommonScope, property, $completion) {
    var tmp = this.rhu($this$provideCommonScope, property, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_79).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.qhu(tmp, (!(p2 == null) ? isInterface(p2, ProcessProperty_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_79).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.nhu_1.n51(this.ohu_1.zb3());
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.nhu_1.n51(tmp0_safe_receiver.zb3());
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            tmp_0.phu_1 = tmp_1;
            var tmp_2 = this.phu_1;
            if (!isInterface(tmp_2, SimplePropertyType))
              return new EmptyScope();
            this.y9_1 = 1;
            suspendResult = this.nhu_1.v7a(this.phu_1.lbp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_79).rhu = function ($this$provideCommonScope, property, completion) {
    var i = new btbScopes$lambda$slambda_79(completion);
    i.nhu_1 = $this$provideCommonScope;
    i.ohu_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_80(resultContinuation) {
    var i = new btbScopes$lambda$slambda_79(resultContinuation);
    var l = function ($this$provideCommonScope, property, $completion) {
      return i.qhu($this$provideCommonScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_81(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_81).dhv = function ($this$provideImportScope, property, $completion) {
    var tmp = this.ehv($this$provideImportScope, property, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_81).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.dhv(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationDeclaration) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_81).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.ahv_1.n51(this.bhv_1.be());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.chv_1 = tmp_1;
            var tmp_2 = this.chv_1;
            if (!isInterface(tmp_2, NotionType_0))
              return new EmptyScope();
            this.y9_1 = 1;
            suspendResult = this.ahv_1.v7a(this.chv_1.lbp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_81).ehv = function ($this$provideImportScope, property, completion) {
    var i = new btbScopes$lambda$slambda_81(completion);
    i.ahv_1 = $this$provideImportScope;
    i.bhv_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_82(resultContinuation) {
    var i = new btbScopes$lambda$slambda_81(resultContinuation);
    var l = function ($this$provideImportScope, property, $completion) {
      return i.dhv($this$provideImportScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_83(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_83).ahw = function ($this$s, property, $completion) {
    var tmp = this.bhw($this$s, property, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_83).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ahw(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_83).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.nhv_1.n51(this.ohv_1.be());
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.nhv_1.n51(tmp0_safe_receiver.lbn());
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            tmp_0.phv_1 = tmp_1;
            var tmp_2 = this;
            var tmp0 = this.phv_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              if (!(element == null) ? isInterface(element, NotionType_0) : false) {
                destination.e(element);
              }
            }

            tmp_2.qhv_1 = destination;
            this.rhv_1 = this.qhv_1;
            var tmp_3 = this;
            tmp_3.shv_1 = this.rhv_1;
            var tmp_4 = this;
            tmp_4.thv_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this.rhv_1, 10));
            this.uhv_1 = this.shv_1;
            this.vhv_1 = this.thv_1;
            this.whv_1 = this.uhv_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.whv_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.xhv_1 = this.whv_1.m();
            var tmp_5 = this;
            tmp_5.yhv_1 = this.xhv_1;
            this.zhv_1 = this.yhv_1;
            this.y9_1 = 2;
            suspendResult = this.nhv_1.v7a(this.zhv_1.lbp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.vhv_1.e(ARGUMENT);
            this.y9_1 = 1;
            continue $sm;
          case 3:
            var tmp3 = this.vhv_1;
            var accumulator = new EmptyScope();
            var _iterator__ex2g4s_0 = tmp3.k();
            while (_iterator__ex2g4s_0.l()) {
              var element_0 = _iterator__ex2g4s_0.m();
              var p0 = accumulator;
              accumulator = new UniqueSumScope(p0, element_0);
            }

            return accumulator;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_83).bhw = function ($this$s, property, completion) {
    var i = new btbScopes$lambda$slambda_83(completion);
    i.nhv_1 = $this$s;
    i.ohv_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_84(resultContinuation) {
    var i = new btbScopes$lambda$slambda_83(resultContinuation);
    var l = function ($this$s, property, $completion) {
      return i.ahw($this$s, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_85(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_85).nhw = function ($this$provideImportScope, property, $completion) {
    var tmp = this.ohw($this$provideImportScope, property, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_85).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.nhw(tmp, (!(p2 == null) ? isInterface(p2, PropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_85).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.khw_1.n51(this.lhw_1.zb3());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.mhw_1 = tmp_1;
            this.y9_1 = 1;
            suspendResult = this.khw_1.v7a(this.mhw_1.lbp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_85).ohw = function ($this$provideImportScope, property, completion) {
    var i = new btbScopes$lambda$slambda_85(completion);
    i.khw_1 = $this$provideImportScope;
    i.lhw_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_86(resultContinuation) {
    var i = new btbScopes$lambda$slambda_85(resultContinuation);
    var l = function ($this$provideImportScope, property, $completion) {
      return i.nhw($this$provideImportScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_87(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_87).ahx = function ($this$provideCommonScope, property, $completion) {
    var tmp = this.bhx($this$provideCommonScope, property, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_87).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ahx(tmp, (!(p2 == null) ? isInterface(p2, ProcessProperty_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_87).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.xhw_1.n51(this.yhw_1.zb3());
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.xhw_1.n51(tmp0_safe_receiver.zb3());
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            tmp_0.zhw_1 = tmp_1;
            var tmp_2 = this.zhw_1;
            if (!isInterface(tmp_2, SimplePropertyType))
              return new EmptyScope();
            this.y9_1 = 1;
            suspendResult = this.xhw_1.v7a(this.zhw_1.lbp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_87).bhx = function ($this$provideCommonScope, property, completion) {
    var i = new btbScopes$lambda$slambda_87(completion);
    i.xhw_1 = $this$provideCommonScope;
    i.yhw_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_88(resultContinuation) {
    var i = new btbScopes$lambda$slambda_87(resultContinuation);
    var l = function ($this$provideCommonScope, property, $completion) {
      return i.ahx($this$provideCommonScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_89(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_89).nhx = function ($this$provideImportScope, property, $completion) {
    var tmp = this.ohx($this$provideImportScope, property, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_89).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.nhx(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationDeclaration) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_89).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.khx_1.n51(this.lhx_1.be());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.mhx_1 = tmp_1;
            var tmp_2 = this.mhx_1;
            if (!isInterface(tmp_2, NotionType_0))
              return new EmptyScope();
            this.y9_1 = 1;
            suspendResult = this.khx_1.v7a(this.mhx_1.lbp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_89).ohx = function ($this$provideImportScope, property, completion) {
    var i = new btbScopes$lambda$slambda_89(completion);
    i.khx_1 = $this$provideImportScope;
    i.lhx_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_90(resultContinuation) {
    var i = new btbScopes$lambda$slambda_89(resultContinuation);
    var l = function ($this$provideImportScope, property, $completion) {
      return i.nhx($this$provideImportScope, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_91(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_91).khy = function ($this$s, property, $completion) {
    var tmp = this.lhy($this$s, property, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_91).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.khy(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_91).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.xhx_1.n51(this.yhx_1.be());
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.xhx_1.n51(tmp0_safe_receiver.lbn());
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              return new EmptyScope();
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            tmp_0.zhx_1 = tmp_1;
            var tmp_2 = this;
            var tmp0 = this.zhx_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              if (!(element == null) ? isInterface(element, NotionType_0) : false) {
                destination.e(element);
              }
            }

            tmp_2.ahy_1 = destination;
            this.bhy_1 = this.ahy_1;
            var tmp_3 = this;
            tmp_3.chy_1 = this.bhy_1;
            var tmp_4 = this;
            tmp_4.dhy_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this.bhy_1, 10));
            this.ehy_1 = this.chy_1;
            this.fhy_1 = this.dhy_1;
            this.ghy_1 = this.ehy_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.ghy_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.hhy_1 = this.ghy_1.m();
            var tmp_5 = this;
            tmp_5.ihy_1 = this.hhy_1;
            this.jhy_1 = this.ihy_1;
            this.y9_1 = 2;
            suspendResult = this.xhx_1.v7a(this.jhy_1.lbp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.fhy_1.e(ARGUMENT);
            this.y9_1 = 1;
            continue $sm;
          case 3:
            var tmp3 = this.fhy_1;
            var accumulator = new EmptyScope();
            var _iterator__ex2g4s_0 = tmp3.k();
            while (_iterator__ex2g4s_0.l()) {
              var element_0 = _iterator__ex2g4s_0.m();
              var p0 = accumulator;
              accumulator = new UniqueSumScope(p0, element_0);
            }

            return accumulator;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_91).lhy = function ($this$s, property, completion) {
    var i = new btbScopes$lambda$slambda_91(completion);
    i.xhx_1 = $this$s;
    i.yhx_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_92(resultContinuation) {
    var i = new btbScopes$lambda$slambda_91(resultContinuation);
    var l = function ($this$s, property, $completion) {
      return i.khy($this$s, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_93(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_93).hhh = function ($this$s, property, $completion) {
    var tmp = this.ihh($this$s, property, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_93).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hhh(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_93).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.uhy_1.n51(this.vhy_1.be());
            tmp_0.why_1 = tmp0_safe_receiver == null ? null : this.uhy_1.n51(tmp0_safe_receiver.lbn());
            if (this.why_1 == null) {
              this.xhy_1 = null;
              this.y9_1 = 4;
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.yhy_1 = this.why_1;
              this.zhy_1 = this.yhy_1;
              var tmp_2 = this;
              tmp_2.ahz_1 = this.zhy_1;
              var tmp_3 = this;
              tmp_3.bhz_1 = ArrayList_init_$Create$();
              this.chz_1 = this.ahz_1;
              this.dhz_1 = this.bhz_1;
              var tmp_4 = this;
              tmp_4.ehz_1 = this.chz_1;
              this.fhz_1 = this.ehz_1;
              this.ghz_1 = this.fhz_1.k();
              this.y9_1 = 1;
              continue $sm;
            }

          case 1:
            if (!this.ghz_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.hhz_1 = this.ghz_1.m();
            var tmp_5 = this;
            tmp_5.ihz_1 = this.hhz_1;
            this.jhz_1 = this.ihz_1;
            var tmp_6 = this;
            tmp_6.khz_1 = this.jhz_1;
            this.lhz_1 = this.khz_1;
            this.y9_1 = 2;
            suspendResult = this.uhy_1.m51(propertyFilterByDomainType(this.lhz_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.mhz_1 = suspendResult;
            if (this.mhz_1 == null)
              null;
            else {
              var it = this.mhz_1;
              this.dhz_1.e(it);
            }

            this.y9_1 = 1;
            continue $sm;
          case 3:
            this.xhy_1 = this.dhz_1;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.nhz_1 = this.xhy_1;
            var tmp_7 = this;
            var tmp_8;
            if (this.nhz_1 == null) {
              return Scopes_getInstance().c7f();
            } else {
              tmp_8 = this.nhz_1;
            }

            tmp_7.ohz_1 = tmp_8;
            this.phz_1 = anyOf(this.ohz_1);
            this.y9_1 = 5;
            suspendResult = this.uhy_1.x7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var ARGUMENT = suspendResult;
            return filter_1(ARGUMENT, this.phz_1);
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_93).ihh = function ($this$s, property, completion) {
    var i = new btbScopes$lambda$slambda_93(completion);
    i.uhy_1 = $this$s;
    i.vhy_1 = property;
    return i;
  };
  function btbScopes$lambda$slambda_94(resultContinuation) {
    var i = new btbScopes$lambda$slambda_93(resultContinuation);
    var l = function ($this$s, property, $completion) {
      return i.hhh($this$s, property, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_95(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_95).ai0 = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.bi0($this$provideLexicalScope, propertyValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_95).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ai0(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_95).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.yhz_1.v7a(this.zhz_1.i6u(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_95).bi0 = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_95(completion);
    i.yhz_1 = $this$provideLexicalScope;
    i.zhz_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_96(resultContinuation) {
    var i = new btbScopes$lambda$slambda_95(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.ai0($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_97(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_97).mi0 = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.ni0($this$provideLexicalScope, propertyValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_97).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.mi0(tmp, (!(p2 == null) ? isInterface(p2, PropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_97).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ki0_1.v7a(this.li0_1.i6u(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_97).ni0 = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_97(completion);
    i.ki0_1 = $this$provideLexicalScope;
    i.li0_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_98(resultContinuation) {
    var i = new btbScopes$lambda$slambda_97(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.mi0($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_99(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_99).yi0 = function ($this$provideLexicalScope, value, $completion) {
    var tmp = this.zi0($this$provideLexicalScope, value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_99).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.yi0(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_99).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.wi0_1.v7a(this.xi0_1.gb6(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_99).zi0 = function ($this$provideLexicalScope, value, completion) {
    var i = new btbScopes$lambda$slambda_99(completion);
    i.wi0_1 = $this$provideLexicalScope;
    i.xi0_1 = value;
    return i;
  };
  function btbScopes$lambda$slambda_100(resultContinuation) {
    var i = new btbScopes$lambda$slambda_99(resultContinuation);
    var l = function ($this$provideLexicalScope, value, $completion) {
      return i.yi0($this$provideLexicalScope, value, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_101(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_101).ki1 = function ($this$s, constraint, $completion) {
    var tmp = this.li1($this$s, constraint, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_101).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ki1(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_101).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ii1_1.v7a(this.ji1_1.i6u(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_101).li1 = function ($this$s, constraint, completion) {
    var i = new btbScopes$lambda$slambda_101(completion);
    i.ii1_1 = $this$s;
    i.ji1_1 = constraint;
    return i;
  };
  function btbScopes$lambda$slambda_102(resultContinuation) {
    var i = new btbScopes$lambda$slambda_101(resultContinuation);
    var l = function ($this$s, constraint, $completion) {
      return i.ki1($this$s, constraint, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_103(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_103).xi1 = function ($this$s, expression, $completion) {
    var tmp = this.yi1($this$s, expression, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_103).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.xi1(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_103).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.ui1_1.n51(this.vi1_1.sbf());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.ui1_1.n51(tmp0_safe_receiver.i6u());
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.i6u();
            var tmp_1;
            if (tmp2_elvis_lhs == null) {
              return Scopes_getInstance().c7f();
            } else {
              tmp_1 = tmp2_elvis_lhs;
            }

            tmp_0.wi1_1 = tmp_1;
            this.y9_1 = 1;
            suspendResult = this.ui1_1.v7a(this.wi1_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_103).yi1 = function ($this$s, expression, completion) {
    var i = new btbScopes$lambda$slambda_103(completion);
    i.ui1_1 = $this$s;
    i.vi1_1 = expression;
    return i;
  };
  function btbScopes$lambda$slambda_104(resultContinuation) {
    var i = new btbScopes$lambda$slambda_103(resultContinuation);
    var l = function ($this$s, expression, $completion) {
      return i.xi1($this$s, expression, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_105(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_105).ji2 = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.ki2($this$provideLexicalScope, propertyValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_105).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ji2(tmp, (!(p2 == null) ? isInterface(p2, PropertyDeclarationValueQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_105).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.hi2_1.v7a(this.ii2_1.dcf(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_105).ki2 = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_105(completion);
    i.hi2_1 = $this$provideLexicalScope;
    i.ii2_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_106(resultContinuation) {
    var i = new btbScopes$lambda$slambda_105(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.ji2($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_107(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_107).vi2 = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.wi2($this$provideLexicalScope, propertyValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_107).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.vi2(tmp, (!(p2 == null) ? isInterface(p2, PropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_107).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ti2_1.v7a(this.ui2_1.i6u(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_107).wi2 = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_107(completion);
    i.ti2_1 = $this$provideLexicalScope;
    i.ui2_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_108(resultContinuation) {
    var i = new btbScopes$lambda$slambda_107(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.vi2($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_109(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_109).hi3 = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.ii3($this$provideLexicalScope, propertyValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_109).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.hi3(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_109).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.fi3_1.v7a(this.gi3_1.i6u(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_109).ii3 = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_109(completion);
    i.fi3_1 = $this$provideLexicalScope;
    i.gi3_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_110(resultContinuation) {
    var i = new btbScopes$lambda$slambda_109(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.hi3($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_111(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_111).ti3 = function ($this$provideLexicalScope, value, $completion) {
    var tmp = this.ui3($this$provideLexicalScope, value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_111).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ti3(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_111).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ri3_1.v7a(this.si3_1.gb6(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_111).ui3 = function ($this$provideLexicalScope, value, completion) {
    var i = new btbScopes$lambda$slambda_111(completion);
    i.ri3_1 = $this$provideLexicalScope;
    i.si3_1 = value;
    return i;
  };
  function btbScopes$lambda$slambda_112(resultContinuation) {
    var i = new btbScopes$lambda$slambda_111(resultContinuation);
    var l = function ($this$provideLexicalScope, value, $completion) {
      return i.ti3($this$provideLexicalScope, value, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_113(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_113).fi4 = function ($this$provideLexicalScope, constraint, $completion) {
    var tmp = this.gi4($this$provideLexicalScope, constraint, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_113).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.fi4(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_113).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.di4_1.v7a(this.ei4_1.i6u(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_113).gi4 = function ($this$provideLexicalScope, constraint, completion) {
    var i = new btbScopes$lambda$slambda_113(completion);
    i.di4_1 = $this$provideLexicalScope;
    i.ei4_1 = constraint;
    return i;
  };
  function btbScopes$lambda$slambda_114(resultContinuation) {
    var i = new btbScopes$lambda$slambda_113(resultContinuation);
    var l = function ($this$provideLexicalScope, constraint, $completion) {
      return i.fi4($this$provideLexicalScope, constraint, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_115(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_115).si4 = function ($this$s, expression, $completion) {
    var tmp = this.ti4($this$s, expression, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_115).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.si4(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_115).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.pi4_1.n51(this.qi4_1.sbf());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : this.pi4_1.n51(tmp0_safe_receiver.i6u());
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.i6u();
            var tmp_1;
            if (tmp2_elvis_lhs == null) {
              return Scopes_getInstance().c7f();
            } else {
              tmp_1 = tmp2_elvis_lhs;
            }

            tmp_0.ri4_1 = tmp_1;
            this.y9_1 = 1;
            suspendResult = this.pi4_1.v7a(this.ri4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_115).ti4 = function ($this$s, expression, completion) {
    var i = new btbScopes$lambda$slambda_115(completion);
    i.pi4_1 = $this$s;
    i.qi4_1 = expression;
    return i;
  };
  function btbScopes$lambda$slambda_116(resultContinuation) {
    var i = new btbScopes$lambda$slambda_115(resultContinuation);
    var l = function ($this$s, expression, $completion) {
      return i.si4($this$s, expression, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_117(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_117).ei5 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.fi5($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_117).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ei5(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_117).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_117).fi5 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_117(completion);
    i.ci5_1 = $this$provideLexicalScope;
    i.di5_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_118(resultContinuation) {
    var i = new btbScopes$lambda$slambda_117(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.ei5($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_119(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_119).qi5 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.ri5($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_119).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.qi5(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_119).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_119).ri5 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_119(completion);
    i.oi5_1 = $this$provideLexicalScope;
    i.pi5_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_120(resultContinuation) {
    var i = new btbScopes$lambda$slambda_119(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.qi5($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_121(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_121).ci6 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.di6($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_121).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ci6(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_121).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_121).di6 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_121(completion);
    i.ai6_1 = $this$provideLexicalScope;
    i.bi6_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_122(resultContinuation) {
    var i = new btbScopes$lambda$slambda_121(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.ci6($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_123(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_123).oi6 = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.pi6($this$provideLexicalScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_123).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.oi6(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_123).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_123).pi6 = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_123(completion);
    i.mi6_1 = $this$provideLexicalScope;
    i.ni6_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_124(resultContinuation) {
    var i = new btbScopes$lambda$slambda_123(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.oi6($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_125(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_125).ai7 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.bi7($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_125).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ai7(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_125).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_125).bi7 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_125(completion);
    i.yi6_1 = $this$provideLexicalScope;
    i.zi6_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_126(resultContinuation) {
    var i = new btbScopes$lambda$slambda_125(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.ai7($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_127(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_127).mi7 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.ni7($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_127).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.mi7(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_127).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_127).ni7 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_127(completion);
    i.ki7_1 = $this$provideLexicalScope;
    i.li7_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_128(resultContinuation) {
    var i = new btbScopes$lambda$slambda_127(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.mi7($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_129(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_129).yi7 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.zi7($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_129).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.yi7(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_129).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_129).zi7 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_129(completion);
    i.wi7_1 = $this$provideLexicalScope;
    i.xi7_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_130(resultContinuation) {
    var i = new btbScopes$lambda$slambda_129(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.yi7($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_131(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_131).ki8 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.li8($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_131).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ki8(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_131).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_131).li8 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_131(completion);
    i.ii8_1 = $this$provideLexicalScope;
    i.ji8_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_132(resultContinuation) {
    var i = new btbScopes$lambda$slambda_131(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.ki8($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_133(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_133).wi8 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.xi8($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_133).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.wi8(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_133).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_133).xi8 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_133(completion);
    i.ui8_1 = $this$provideLexicalScope;
    i.vi8_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_134(resultContinuation) {
    var i = new btbScopes$lambda$slambda_133(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.wi8($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_135(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_135).ii9 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.ji9($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_135).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ii9(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_135).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_135).ji9 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_135(completion);
    i.gi9_1 = $this$provideLexicalScope;
    i.hi9_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_136(resultContinuation) {
    var i = new btbScopes$lambda$slambda_135(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.ii9($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_137(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_137).ui9 = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.vi9($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_137).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ui9(tmp, (!(p2 == null) ? isInterface(p2, OneOf_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_137).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_137).vi9 = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_137(completion);
    i.si9_1 = $this$provideLexicalScope;
    i.ti9_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_138(resultContinuation) {
    var i = new btbScopes$lambda$slambda_137(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.ui9($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_139(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_139).gia = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.hia($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_139).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.gia(tmp, (!(p2 == null) ? isInterface(p2, OneOf_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_139).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_139).hia = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_139(completion);
    i.eia_1 = $this$provideLexicalScope;
    i.fia_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_140(resultContinuation) {
    var i = new btbScopes$lambda$slambda_139(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.gia($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_141(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_141).sia = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.tia($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_141).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.sia(tmp, (!(p2 == null) ? isInterface(p2, OneOf_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_141).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_141).tia = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_141(completion);
    i.qia_1 = $this$provideLexicalScope;
    i.ria_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_142(resultContinuation) {
    var i = new btbScopes$lambda$slambda_141(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.sia($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_143(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_143).eib = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.fib($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_143).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.eib(tmp, (!(p2 == null) ? isInterface(p2, OneOf_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_143).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_143).fib = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_143(completion);
    i.cib_1 = $this$provideLexicalScope;
    i.dib_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_144(resultContinuation) {
    var i = new btbScopes$lambda$slambda_143(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.eib($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_145(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_145).qib = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.rib($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_145).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.qib(tmp, (!(p2 == null) ? isInterface(p2, OneOf_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_145).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_145).rib = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_145(completion);
    i.oib_1 = $this$provideLexicalScope;
    i.pib_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_146(resultContinuation) {
    var i = new btbScopes$lambda$slambda_145(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.qib($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_147(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_147).cic = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.dic($this$provideLexicalScope, propertyValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_147).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.cic(tmp, (!(p2 == null) ? isInterface(p2, PropertyDeclarationValueQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_147).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.aic_1.v7a(this.bic_1.dcf(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_147).dic = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_147(completion);
    i.aic_1 = $this$provideLexicalScope;
    i.bic_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_148(resultContinuation) {
    var i = new btbScopes$lambda$slambda_147(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.cic($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_149(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_149).cic = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.dic($this$provideLexicalScope, propertyValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_149).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.cic(tmp, (!(p2 == null) ? isInterface(p2, PropertyDeclarationValueQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_149).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.mic_1.v7a(this.nic_1.dcf(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_149).dic = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_149(completion);
    i.mic_1 = $this$provideLexicalScope;
    i.nic_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_150(resultContinuation) {
    var i = new btbScopes$lambda$slambda_149(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.cic($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_15(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_15).vhg = function ($this$query, it, $completion) {
    var tmp = this.whg($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_15).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vhg(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_15).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !this.wic_1.n51(this.xic_1.wbq());
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_15).whg = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_15(completion);
    i.wic_1 = $this$query;
    i.xic_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_16(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_15(resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.vhg($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_151(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_151).mie = function ($this$s, refValue, $completion) {
    var tmp = this.nie($this$s, refValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_151).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.mie(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyReferenceValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_151).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 12;
            this.iid_1 = this.gid_1.n51(this.hid_1.obr());
            var tmp_0 = this.iid_1;
            if (!(tmp_0 == null) ? isInterface(tmp_0, VariableReferenceValue_1) : false) {
              this.y9_1 = 4;
              suspendResult = this.gid_1.m51(this.iid_1.xcq().o6s(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this.iid_1;
              if (!(tmp_1 == null) ? isInterface(tmp_1, ObjectPropertyReferenceValue_1) : false) {
                var tmp_2 = this;
                var tmp2_safe_receiver = this.gid_1.n51(this.iid_1.i6u());
                tmp_2.kid_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.i6u();
                if (this.kid_1 == null) {
                  this.lid_1 = null;
                  this.y9_1 = 3;
                  continue $sm;
                } else {
                  this.y9_1 = 2;
                  suspendResult = this.gid_1.m51(this.kid_1.o6s(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                var tmp_3 = this.iid_1;
                if (!(tmp_3 == null) ? isInterface(tmp_3, ProcessPropertyReference) : false) {
                  this.y9_1 = 1;
                  suspendResult = this.gid_1.m51(this.iid_1.i6u(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.jid_1 = null;
                  this.y9_1 = 5;
                  continue $sm;
                }
              }
            }

          case 1:
            this.mid_1 = suspendResult;
            this.nid_1 = this.mid_1 == null ? null : this.gid_1.n51(this.mid_1.zb3());
            this.oid_1 = this.nid_1 == null ? null : this.gid_1.n51(this.nid_1.zb3());
            var tmp_4 = this;
            var tmp_5;
            if (this.oid_1 == null) {
              tmp_5 = null;
            } else {
              var it = this.oid_1;
              tmp_5 = listOf(it);
            }

            tmp_4.jid_1 = tmp_5;
            this.y9_1 = 5;
            continue $sm;
          case 2:
            this.lid_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.pid_1 = this.lid_1;
            this.qid_1 = this.pid_1 == null ? null : this.gid_1.n51(this.pid_1.be());
            this.jid_1 = this.qid_1 == null ? null : this.gid_1.n51(this.qid_1.lbn());
            this.y9_1 = 5;
            continue $sm;
          case 4:
            this.rid_1 = suspendResult;
            this.sid_1 = this.rid_1 == null ? null : this.gid_1.n51(this.rid_1.jcq());
            var tmp_6 = this;
            var tmp_7;
            if (this.sid_1 == null) {
              tmp_7 = null;
            } else {
              var it_0 = this.sid_1;
              tmp_7 = listOf(it_0);
            }

            tmp_6.jid_1 = tmp_7;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.tid_1 = this.jid_1;
            if (this.tid_1 == null) {
              this.y9_1 = 11;
              suspendResult = this.gid_1.x7a(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 6;
              continue $sm;
            }

          case 6:
            var tmp_8 = this;
            tmp_8.uid_1 = this.tid_1;
            this.vid_1 = this.uid_1;
            var tmp_9 = this;
            tmp_9.wid_1 = this.vid_1;
            var tmp_10 = this;
            tmp_10.xid_1 = ArrayList_init_$Create$();
            this.yid_1 = this.wid_1;
            this.zid_1 = this.xid_1;
            var tmp_11 = this;
            tmp_11.aie_1 = this.yid_1;
            this.bie_1 = this.aie_1;
            this.cie_1 = this.bie_1.k();
            this.y9_1 = 7;
            continue $sm;
          case 7:
            if (!this.cie_1.l()) {
              this.y9_1 = 9;
              continue $sm;
            }

            this.die_1 = this.cie_1.m();
            var tmp_12 = this;
            tmp_12.eie_1 = this.die_1;
            this.fie_1 = this.eie_1;
            var tmp_13 = this;
            tmp_13.gie_1 = this.fie_1;
            this.hie_1 = this.gie_1;
            this.y9_1 = 8;
            suspendResult = this.gid_1.m51(propertyFilterByDomainType(this.hie_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.iie_1 = suspendResult;
            if (this.iie_1 == null)
              null;
            else {
              var it_1 = this.iie_1;
              this.zid_1.e(it_1);
            }

            this.y9_1 = 7;
            continue $sm;
          case 9:
            this.jie_1 = this.zid_1;
            var tmp_14 = this;
            var tmp_15 = Companion_instance_119;
            tmp_14.kie_1 = tmp_15.a76(btbScopes$lambda$slambda$slambda_16(null));
            this.lie_1 = new CompositeScopeFilter(listOf_0([this.kie_1, anyOf(this.jie_1)]));
            this.y9_1 = 10;
            suspendResult = this.gid_1.x7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            var ARGUMENT = suspendResult;
            return filter_1(ARGUMENT, this.lie_1);
          case 11:
            return suspendResult;
          case 12:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 12) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_151).nie = function ($this$s, refValue, completion) {
    var i = new btbScopes$lambda$slambda_151(completion);
    i.gid_1 = $this$s;
    i.hid_1 = refValue;
    return i;
  };
  function btbScopes$lambda$slambda_152(resultContinuation) {
    var i = new btbScopes$lambda$slambda_151(resultContinuation);
    var l = function ($this$s, refValue, $completion) {
      return i.mie($this$s, refValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_153(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_153).yie = function ($this$s, element, $completion) {
    var tmp = this.zie($this$s, element, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_153).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.yie(tmp, (!(p2 == null) ? isInterface(p2, OntologyElement_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_153).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.wie_1.x7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_1(ARGUMENT, filterObjectProperties(setOf(this.xie_1)));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_153).zie = function ($this$s, element, completion) {
    var i = new btbScopes$lambda$slambda_153(completion);
    i.wie_1 = $this$s;
    i.xie_1 = element;
    return i;
  };
  function btbScopes$lambda$slambda_154(resultContinuation) {
    var i = new btbScopes$lambda$slambda_153(resultContinuation);
    var l = function ($this$s, element, $completion) {
      return i.yie($this$s, element, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_17(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_17).kif = function ($this$query, it, $completion) {
    var tmp = this.lif($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_17).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.kif(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_17).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var variableType = this.iif_1.n51(this.jif_1.jcq());
          return !(!(variableType == null) ? isInterface(variableType, ProcessType_1) : false);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_17).lif = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_17(completion);
    i.iif_1 = $this$query;
    i.jif_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_18(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_17(resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.kif($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_155(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_155).wif = function ($this$constrainScope, _unused_var__etf5q3, $completion) {
    var tmp = this.xif($this$constrainScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_155).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeConstraintBuilder ? p1 : THROW_CCE();
    return this.wif(tmp, (!(p2 == null) ? isInterface(p2, FactSet_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_155).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var tmp_0 = Companion_instance_119;
          return tmp_0.a76(btbScopes$lambda$slambda$slambda_18(null));
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_155).xif = function ($this$constrainScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_155(completion);
    i.uif_1 = $this$constrainScope;
    i.vif_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_156(resultContinuation) {
    var i = new btbScopes$lambda$slambda_155(resultContinuation);
    var l = function ($this$constrainScope, _unused_var__etf5q3, $completion) {
      return i.wif($this$constrainScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_157(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_157).jig = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
    var tmp = this.kig($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_157).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.jig(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecification_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_157).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.gig_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.iig_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.gig_1.s7a(this.iig_1, get_onlyOntologyVars(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_157).kig = function ($this$provideLexicalScope, _unused_var__etf5q3, completion) {
    var i = new btbScopes$lambda$slambda_157(completion);
    i.gig_1 = $this$provideLexicalScope;
    i.hig_1 = _unused_var__etf5q3;
    return i;
  };
  function btbScopes$lambda$slambda_158(resultContinuation) {
    var i = new btbScopes$lambda$slambda_157(resultContinuation);
    var l = function ($this$provideLexicalScope, _unused_var__etf5q3, $completion) {
      return i.jig($this$provideLexicalScope, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_159(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_159).vig = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.wig($this$provideLexicalScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_159).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.vig(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_159).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_159).wig = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_159(completion);
    i.tig_1 = $this$provideLexicalScope;
    i.uig_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_160(resultContinuation) {
    var i = new btbScopes$lambda$slambda_159(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.vig($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_19($typeElements, resultContinuation) {
    this.fih_1 = $typeElements;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_19).kif = function ($this$query, it, $completion) {
    var tmp = this.lif($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_19).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.kif(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_19).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            if (this.fih_1 == null) {
              return false;
            }

            this.iih_1 = this.gih_1.n51(this.hih_1.jcq());
            this.y9_1 = 1;
            suspendResult = this.gih_1.m51(typeElements(this.iih_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.jih_1 = suspendResult;
            if (!(this.jih_1 == null)) {
              this.y9_1 = 2;
              suspendResult = this.gih_1.m51(isSubtypeOf_0(ontologyElementHierarchy(), this.jih_1, this.fih_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.kih_1 = false;
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            this.kih_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.kih_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_19).lif = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_19(this.fih_1, completion);
    i.gih_1 = $this$query;
    i.hih_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_20($typeElements, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_19($typeElements, resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.kif($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_21($typeNotion, resultContinuation) {
    this.tih_1 = $typeNotion;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_21).kif = function ($this$query, it, $completion) {
    var tmp = this.lif($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_21).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.kif(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_21).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.wih_1 = this.uih_1.n51(this.vih_1.jcq());
            var tmp_0 = this.wih_1;
            if (!(!(tmp_0 == null) ? isInterface(tmp_0, NotionType_0) : false))
              return false;
            this.y9_1 = 1;
            suspendResult = this.uih_1.m51(this.wih_1.lbp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return equals(this.tih_1, ARGUMENT);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_21).lif = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_21(this.tih_1, completion);
    i.uih_1 = $this$query;
    i.vih_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_22($typeNotion, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_21($typeNotion, resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.kif($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_161(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_161).sii = function ($this$provideLexicalScope, relationValue, $completion) {
    var tmp = this.tii($this$provideLexicalScope, relationValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_161).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.sii(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_161).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 10;
            this.y9_1 = 1;
            suspendResult = this.fii_1.m51(this.gii_1.gb6(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.hii_1 = suspendResult;
            if (this.hii_1 == null) {
              this.y9_1 = 2;
              suspendResult = this.fii_1.q7a(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.iii_1 = this.hii_1;
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            var tmp_0 = this;
            return suspendResult;
          case 3:
            this.jii_1 = this.iii_1;
            this.kii_1 = this.fii_1.n51(this.jii_1.be());
            if (this.kii_1 == null) {
              this.y9_1 = 4;
              suspendResult = this.fii_1.q7a(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.lii_1 = this.kii_1;
              this.y9_1 = 5;
              continue $sm;
            }

          case 4:
            var tmp_1 = this;
            return suspendResult;
          case 5:
            this.mii_1 = this.lii_1;
            this.nii_1 = this.mii_1;
            var tmp_2;
            var tmp_3 = this.nii_1;
            if (isInterface(tmp_3, OntologyElementType_1)) {
              tmp_2 = true;
            } else {
              var tmp_4 = this.nii_1;
              tmp_2 = isInterface(tmp_4, ClassExpressionType_1);
            }

            if (tmp_2) {
              this.y9_1 = 7;
              suspendResult = this.fii_1.m51(typeElements(this.mii_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_5 = this.nii_1;
              if (isInterface(tmp_5, NotionType_0)) {
                this.y9_1 = 6;
                suspendResult = this.fii_1.m51(this.mii_1.lbp(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.oii_1 = NoopScopeFilter_instance;
                this.y9_1 = 8;
                continue $sm;
              }
            }

          case 6:
            this.pii_1 = suspendResult;
            var tmp_6 = this;
            var tmp_7 = Companion_instance_119;
            tmp_6.oii_1 = tmp_7.a76(btbScopes$lambda$slambda$slambda_22(this.pii_1, null));
            this.y9_1 = 8;
            continue $sm;
          case 7:
            this.qii_1 = suspendResult;
            var tmp_8 = this;
            var tmp_9 = Companion_instance_119;
            tmp_8.oii_1 = tmp_9.a76(btbScopes$lambda$slambda$slambda_20(this.qii_1, null));
            this.y9_1 = 8;
            continue $sm;
          case 8:
            this.rii_1 = this.oii_1;
            this.y9_1 = 9;
            suspendResult = this.fii_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            var ARGUMENT = suspendResult;
            return filter_1(ARGUMENT, this.rii_1);
          case 10:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 10) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_161).tii = function ($this$provideLexicalScope, relationValue, completion) {
    var i = new btbScopes$lambda$slambda_161(completion);
    i.fii_1 = $this$provideLexicalScope;
    i.gii_1 = relationValue;
    return i;
  };
  function btbScopes$lambda$slambda_162(resultContinuation) {
    var i = new btbScopes$lambda$slambda_161(resultContinuation);
    var l = function ($this$provideLexicalScope, relationValue, $completion) {
      return i.sii($this$provideLexicalScope, relationValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_163(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_163).iij = function ($this$provideLexicalScope, propertyValue, $completion) {
    var tmp = this.jij($this$provideLexicalScope, propertyValue, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_163).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.iij(tmp, (!(p2 == null) ? isInterface(p2, ProcessPropertyValue_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_163).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.y9_1 = 1;
            suspendResult = this.cij_1.m51(this.dij_1.i6u(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.eij_1 = suspendResult;
            this.fij_1 = this.eij_1 == null ? null : this.cij_1.n51(this.eij_1.zb3());
            this.gij_1 = this.fij_1 == null ? null : this.cij_1.n51(this.fij_1.zb3());
            var tmp_0 = this.gij_1;
            if (!(tmp_0 == null) ? isInterface(tmp_0, SimplePropertyType) : false) {
              var tmp_1 = this;
              return Scopes_getInstance().c7f();
            } else {
              this.y9_1 = 2;
              suspendResult = this.cij_1.q7a(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            var tmp_2 = this;
            return suspendResult;
          case 3:
            return this.hij_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_163).jij = function ($this$provideLexicalScope, propertyValue, completion) {
    var i = new btbScopes$lambda$slambda_163(completion);
    i.cij_1 = $this$provideLexicalScope;
    i.dij_1 = propertyValue;
    return i;
  };
  function btbScopes$lambda$slambda_164(resultContinuation) {
    var i = new btbScopes$lambda$slambda_163(resultContinuation);
    var l = function ($this$provideLexicalScope, propertyValue, $completion) {
      return i.iij($this$provideLexicalScope, propertyValue, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_165(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_165).aik = function ($this$provideLexicalScope, expression, $completion) {
    var tmp = this.bik($this$provideLexicalScope, expression, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_165).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.aik(tmp, (!(p2 == null) ? isInterface(p2, IsExpression_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_165).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.sij_1.n51(this.tij_1.sbf());
            tmp_0.uij_1 = tmp0_safe_receiver == null ? null : this.sij_1.n51(tmp0_safe_receiver.i6u());
            if (this.uij_1 == null) {
              this.vij_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.sij_1.m51(this.uij_1.i6u(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.vij_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.wij_1 = this.vij_1;
            this.xij_1 = this.wij_1 == null ? null : this.sij_1.n51(this.wij_1.be());
            this.yij_1 = this.xij_1 == null ? null : this.sij_1.n51(this.xij_1.lbn());
            var tmp_1;
            var this_0 = this.yij_1;
            if (this_0 == null || this_0.p()) {
              tmp_1 = true;
            } else {
              var tmp1 = this.yij_1;
              var tmp$ret$0;
              l$ret$1: do {
                var tmp_2;
                if (isInterface(tmp1, Collection)) {
                  tmp_2 = tmp1.p();
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp$ret$0 = false;
                  break l$ret$1;
                }
                var _iterator__ex2g4s = tmp1.k();
                while (_iterator__ex2g4s.l()) {
                  var element = _iterator__ex2g4s.m();
                  if (isInterface(element, OntologyElementType_1)) {
                    tmp$ret$0 = true;
                    break l$ret$1;
                  }
                }
                tmp$ret$0 = false;
              }
               while (false);
              tmp_1 = tmp$ret$0;
            }

            if (tmp_1) {
              this.y9_1 = 3;
              suspendResult = this.sij_1.q7a(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_3 = this;
              return Scopes_getInstance().c7f();
            }

          case 3:
            var tmp_4 = this;
            return suspendResult;
          case 4:
            return this.zij_1;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_165).bik = function ($this$provideLexicalScope, expression, completion) {
    var i = new btbScopes$lambda$slambda_165(completion);
    i.sij_1 = $this$provideLexicalScope;
    i.tij_1 = expression;
    return i;
  };
  function btbScopes$lambda$slambda_166(resultContinuation) {
    var i = new btbScopes$lambda$slambda_165(resultContinuation);
    var l = function ($this$provideLexicalScope, expression, $completion) {
      return i.aik($this$provideLexicalScope, expression, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_167(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_167).pik = function ($this$provideLexicalScope, value, $completion) {
    var tmp = this.qik($this$provideLexicalScope, value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_167).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.pik(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationValue) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_167).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.y9_1 = 1;
            suspendResult = this.kik_1.m51(this.lik_1.gb6(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.mik_1 = suspendResult;
            this.nik_1 = this.mik_1 == null ? null : this.kik_1.n51(this.mik_1.be());
            var tmp_0 = this.nik_1;
            if (!(tmp_0 == null) ? isInterface(tmp_0, NotionType_0) : false) {
              var tmp_1 = this;
              return Scopes_getInstance().c7f();
            } else {
              this.y9_1 = 2;
              suspendResult = this.kik_1.q7a(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            var tmp_2 = this;
            return suspendResult;
          case 3:
            return this.oik_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_167).qik = function ($this$provideLexicalScope, value, completion) {
    var i = new btbScopes$lambda$slambda_167(completion);
    i.kik_1 = $this$provideLexicalScope;
    i.lik_1 = value;
    return i;
  };
  function btbScopes$lambda$slambda_168(resultContinuation) {
    var i = new btbScopes$lambda$slambda_167(resultContinuation);
    var l = function ($this$provideLexicalScope, value, $completion) {
      return i.pik($this$provideLexicalScope, value, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_23(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_23).bil = function ($this$filter, it, $completion) {
    var tmp = this.cil($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_23).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.bil(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_23).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var tmp_0 = this.ail_1;
          return isInterface(tmp_0, AbstractLink);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_23).cil = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_23(completion);
    i.zik_1 = $this$filter;
    i.ail_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_24(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_23(resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.bil($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_169(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_169).pil = function ($this$provideCommonScope, process, $completion) {
    var tmp = this.qil($this$provideCommonScope, process, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_169).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.pil(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_169).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.lil_1.t7a(this.mil_1.w(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.nil_1 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.nil_1;
            var tmp_1 = filter_0(this_0, btbScopes$lambda$slambda$slambda_24(null));
            tmp_0.oil_1 = isInterface(tmp_1, Scope) ? tmp_1 : THROW_CCE();
            this.y9_1 = 2;
            suspendResult = this.lil_1.v7a(this.mil_1.gc7(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return new UniqueSumScope(this.oil_1, ARGUMENT);
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_169).qil = function ($this$provideCommonScope, process, completion) {
    var i = new btbScopes$lambda$slambda_169(completion);
    i.lil_1 = $this$provideCommonScope;
    i.mil_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_170(resultContinuation) {
    var i = new btbScopes$lambda$slambda_169(resultContinuation);
    var l = function ($this$provideCommonScope, process, $completion) {
      return i.pil($this$provideCommonScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_25(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_25).bil = function ($this$filter, it, $completion) {
    var tmp = this.cil($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_25).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.bil(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_25).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var tmp_0 = this.aim_1;
          return isInterface(tmp_0, AbstractProperty);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_25).cil = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_25(completion);
    i.zil_1 = $this$filter;
    i.aim_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_26(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_25(resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.bil($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_171(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_171).nim = function ($this$provideCommonScope, process, $completion) {
    var tmp = this.oim($this$provideCommonScope, process, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_171).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.nim(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_171).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.jim_1.t7a(this.kim_1.w(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.lim_1 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.lim_1;
            var tmp_1 = filter_0(this_0, btbScopes$lambda$slambda$slambda_26(null));
            tmp_0.mim_1 = isInterface(tmp_1, Scope) ? tmp_1 : THROW_CCE();
            this.y9_1 = 2;
            suspendResult = this.jim_1.v7a(this.kim_1.gc7(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return new UniqueSumScope(this.mim_1, ARGUMENT);
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_171).oim = function ($this$provideCommonScope, process, completion) {
    var i = new btbScopes$lambda$slambda_171(completion);
    i.jim_1 = $this$provideCommonScope;
    i.kim_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_172(resultContinuation) {
    var i = new btbScopes$lambda$slambda_171(resultContinuation);
    var l = function ($this$provideCommonScope, process, $completion) {
      return i.nim($this$provideCommonScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_173(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_173).ain = function ($this$provideCommonScope, process, $completion) {
    var tmp = this.bin($this$provideCommonScope, process, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_173).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ain(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_173).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.xim_1.m51(this.yim_1.qdb(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.zim_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.xim_1.u7a(this.zim_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_173).bin = function ($this$provideCommonScope, process, completion) {
    var i = new btbScopes$lambda$slambda_173(completion);
    i.xim_1 = $this$provideCommonScope;
    i.yim_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_174(resultContinuation) {
    var i = new btbScopes$lambda$slambda_173(resultContinuation);
    var l = function ($this$provideCommonScope, process, $completion) {
      return i.ain($this$provideCommonScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_175(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_175).rin = function ($this$provideLexicalScope, processProperty, $completion) {
    var tmp = this.sin($this$provideLexicalScope, processProperty, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_175).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.rin(tmp, (!(p2 == null) ? isInterface(p2, ProcessProperty_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_175).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.min_1 = ancestorOrSelf(this.lin_1, getKClass(ProcessDeclaration_1));
            this.nin_1 = this.kin_1.n51(this.min_1);
            if (this.nin_1 == null) {
              this.oin_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.kin_1.m51(this.nin_1.rdb(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.oin_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.pin_1 = this.oin_1;
            this.qin_1 = this.pin_1 == null ? emptyList() : this.pin_1;
            this.y9_1 = 3;
            suspendResult = this.kin_1.u7a(this.qin_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_175).sin = function ($this$provideLexicalScope, processProperty, completion) {
    var i = new btbScopes$lambda$slambda_175(completion);
    i.kin_1 = $this$provideLexicalScope;
    i.lin_1 = processProperty;
    return i;
  };
  function btbScopes$lambda$slambda_176(resultContinuation) {
    var i = new btbScopes$lambda$slambda_175(resultContinuation);
    var l = function ($this$provideLexicalScope, processProperty, $completion) {
      return i.rin($this$provideLexicalScope, processProperty, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_27($processProperty, resultContinuation) {
    this.bio_1 = $processProperty;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_27).eio = function ($this$filter, it, $completion) {
    var tmp = this.fio($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_27).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.eio(tmp, (!(p2 == null) ? isInterface(p2, ProcessProperty_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_27).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !equals(this.dio_1, this.bio_1);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_27).fio = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_27(this.bio_1, completion);
    i.cio_1 = $this$filter;
    i.dio_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_28($processProperty, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_27($processProperty, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.eio($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_177(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_177).rin = function ($this$provideLexicalScope, processProperty, $completion) {
    var tmp = this.sin($this$provideLexicalScope, processProperty, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_177).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.rin(tmp, (!(p2 == null) ? isInterface(p2, ProcessProperty_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_177).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.oio_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_28(this.pio_1, null));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_177).sin = function ($this$provideLexicalScope, processProperty, completion) {
    var i = new btbScopes$lambda$slambda_177(completion);
    i.oio_1 = $this$provideLexicalScope;
    i.pio_1 = processProperty;
    return i;
  };
  function btbScopes$lambda$slambda_178(resultContinuation) {
    var i = new btbScopes$lambda$slambda_177(resultContinuation);
    var l = function ($this$provideLexicalScope, processProperty, $completion) {
      return i.rin($this$provideLexicalScope, processProperty, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_179(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_179).aip = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.bip($this$provideLexicalScope, process, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_179).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.aip(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_179).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.yio_1.t7a(this.zio_1.ybc(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_179).bip = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_179(completion);
    i.yio_1 = $this$provideLexicalScope;
    i.zio_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_180(resultContinuation) {
    var i = new btbScopes$lambda$slambda_179(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.aip($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_29($process, resultContinuation) {
    this.kip_1 = $process;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_29).nip = function ($this$filter, it, $completion) {
    var tmp = this.oip($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_29).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.nip(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_29).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !equals(this.mip_1, this.kip_1);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_29).oip = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_29(this.kip_1, completion);
    i.lip_1 = $this$filter;
    i.mip_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_30($process, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_29($process, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.nip($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_181(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_181).zip = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.aiq($this$provideLexicalScope, process, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_181).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.zip(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_181).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.xip_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_30(this.yip_1, null));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_181).aiq = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_181(completion);
    i.xip_1 = $this$provideLexicalScope;
    i.yip_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_182(resultContinuation) {
    var i = new btbScopes$lambda$slambda_181(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.zip($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_183(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_183).zip = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.aiq($this$provideLexicalScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_183).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.zip(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_183).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_183).aiq = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_183(completion);
    i.jiq_1 = $this$provideLexicalScope;
    i.kiq_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_184(resultContinuation) {
    var i = new btbScopes$lambda$slambda_183(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.zip($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_185(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_185).zip = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.aiq($this$provideLexicalScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_185).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.zip(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_185).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_185).aiq = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_185(completion);
    i.tiq_1 = $this$provideLexicalScope;
    i.uiq_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_186(resultContinuation) {
    var i = new btbScopes$lambda$slambda_185(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.zip($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_187(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_187).zip = function ($this$provideLexicalScope, it, $completion) {
    var tmp = this.aiq($this$provideLexicalScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_187).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.zip(tmp, (!(p2 == null) ? isInterface(p2, ProcessDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_187).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return Scopes_getInstance().c7f();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_187).aiq = function ($this$provideLexicalScope, it, completion) {
    var i = new btbScopes$lambda$slambda_187(completion);
    i.dir_1 = $this$provideLexicalScope;
    i.eir_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_188(resultContinuation) {
    var i = new btbScopes$lambda$slambda_187(resultContinuation);
    var l = function ($this$provideLexicalScope, it, $completion) {
      return i.zip($this$provideLexicalScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_189(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_189).pir = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.qir($this$provideLexicalScope, process, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_189).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.pir(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecification_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_189).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.nir_1.v7a(this.oir_1.jbg(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_189).qir = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_189(completion);
    i.nir_1 = $this$provideLexicalScope;
    i.oir_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_190(resultContinuation) {
    var i = new btbScopes$lambda$slambda_189(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.pir($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_191(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_191).bis = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.cis($this$provideLexicalScope, process, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_191).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.bis(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecification_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_191).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.zir_1.v7a(this.ais_1.jbg(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_191).cis = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_191(completion);
    i.zir_1 = $this$provideLexicalScope;
    i.ais_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_192(resultContinuation) {
    var i = new btbScopes$lambda$slambda_191(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.bis($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_193(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_193).nis = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.ois($this$provideLexicalScope, process, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_193).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.nis(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecification_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_193).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.lis_1.v7a(this.mis_1.jbg(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_193).ois = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_193(completion);
    i.lis_1 = $this$provideLexicalScope;
    i.mis_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_194(resultContinuation) {
    var i = new btbScopes$lambda$slambda_193(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.nis($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_195(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_195).zis = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.ait($this$provideLexicalScope, process, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_195).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.zis(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecificationQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_195).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.xis_1.v7a(this.yis_1.jbg(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_195).ait = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_195(completion);
    i.xis_1 = $this$provideLexicalScope;
    i.yis_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_196(resultContinuation) {
    var i = new btbScopes$lambda$slambda_195(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.zis($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_197(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_197).lit = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.mit($this$provideLexicalScope, process, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_197).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.lit(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecificationQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_197).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.jit_1.v7a(this.kit_1.jbg(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_197).mit = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_197(completion);
    i.jit_1 = $this$provideLexicalScope;
    i.kit_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_198(resultContinuation) {
    var i = new btbScopes$lambda$slambda_197(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.lit($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_199(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_199).xit = function ($this$provideLexicalScope, process, $completion) {
    var tmp = this.yit($this$provideLexicalScope, process, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_199).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.xit(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecificationQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_199).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.vit_1.v7a(this.wit_1.jbg(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_199).yit = function ($this$provideLexicalScope, process, completion) {
    var i = new btbScopes$lambda$slambda_199(completion);
    i.vit_1 = $this$provideLexicalScope;
    i.wit_1 = process;
    return i;
  };
  function btbScopes$lambda$slambda_200(resultContinuation) {
    var i = new btbScopes$lambda$slambda_199(resultContinuation);
    var l = function ($this$provideLexicalScope, process, $completion) {
      return i.xit($this$provideLexicalScope, process, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_201(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_201).uiu = function ($this$provideLexicalScope, term, $completion) {
    var tmp = this.viu($this$provideLexicalScope, term, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_201).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.uiu(tmp, (!(p2 == null) ? isInterface(p2, FunctionTerm_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_201).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.jiu_1 = this.hiu_1;
            var tmp_1 = this;
            tmp_1.kiu_1 = this.iiu_1;
            this.liu_1 = this.jiu_1;
            this.miu_1 = this.kiu_1;
            this.y9_1 = 1;
            suspendResult = this.liu_1.m51(this.miu_1.rba().o6s(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.niu_1 = suspendResult;
            var tmp_2 = this;
            tmp_2.oiu_1 = this.liu_1;
            var tmp_3 = this;
            tmp_3.piu_1 = this.niu_1;
            this.qiu_1 = this.oiu_1;
            this.riu_1 = this.piu_1;
            if (this.riu_1 == null) {
              var tmp_4 = this;
              tmp_4.siu_1 = new EmptyScope();
              this.y9_1 = 3;
              continue $sm;
            } else {
              var tmp_5 = this;
              var tmp0 = this.qiu_1.n51(this.riu_1.w());
              var destination = ArrayList_init_$Create$();
              var _iterator__ex2g4s = tmp0.k();
              while (_iterator__ex2g4s.l()) {
                var element = _iterator__ex2g4s.m();
                if (!(element == null) ? isInterface(element, AbstractLink) : false) {
                  destination.e(element);
                }
              }
              tmp_5.tiu_1 = destination;
              this.y9_1 = 2;
              suspendResult = this.qiu_1.u7a(this.tiu_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.siu_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.siu_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_201).viu = function ($this$provideLexicalScope, term, completion) {
    var i = new btbScopes$lambda$slambda_201(completion);
    i.hiu_1 = $this$provideLexicalScope;
    i.iiu_1 = term;
    return i;
  };
  function btbScopes$lambda$slambda_202(resultContinuation) {
    var i = new btbScopes$lambda$slambda_201(resultContinuation);
    var l = function ($this$provideLexicalScope, term, $completion) {
      return i.uiu($this$provideLexicalScope, term, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_203(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_203).riv = function ($this$provideLexicalScope, term, $completion) {
    var tmp = this.siv($this$provideLexicalScope, term, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_203).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.riv(tmp, (!(p2 == null) ? isInterface(p2, FunctionTerm_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_203).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.giv_1 = this.eiv_1;
            var tmp_1 = this;
            tmp_1.hiv_1 = this.fiv_1;
            this.iiv_1 = this.giv_1;
            this.jiv_1 = this.hiv_1;
            this.y9_1 = 1;
            suspendResult = this.iiv_1.m51(this.jiv_1.rba().o6s(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.kiv_1 = suspendResult;
            var tmp_2 = this;
            tmp_2.liv_1 = this.iiv_1;
            var tmp_3 = this;
            tmp_3.miv_1 = this.kiv_1;
            this.niv_1 = this.liv_1;
            this.oiv_1 = this.miv_1;
            if (this.oiv_1 == null) {
              var tmp_4 = this;
              tmp_4.piv_1 = new EmptyScope();
              this.y9_1 = 3;
              continue $sm;
            } else {
              var tmp_5 = this;
              var tmp0 = this.niv_1.n51(this.oiv_1.w());
              var destination = ArrayList_init_$Create$();
              var _iterator__ex2g4s = tmp0.k();
              while (_iterator__ex2g4s.l()) {
                var element = _iterator__ex2g4s.m();
                if (!(element == null) ? isInterface(element, AbstractProperty) : false) {
                  destination.e(element);
                }
              }
              tmp_5.qiv_1 = destination;
              this.y9_1 = 2;
              suspendResult = this.niv_1.u7a(this.qiv_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.piv_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.piv_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_203).siv = function ($this$provideLexicalScope, term, completion) {
    var i = new btbScopes$lambda$slambda_203(completion);
    i.eiv_1 = $this$provideLexicalScope;
    i.fiv_1 = term;
    return i;
  };
  function btbScopes$lambda$slambda_204(resultContinuation) {
    var i = new btbScopes$lambda$slambda_203(resultContinuation);
    var l = function ($this$provideLexicalScope, term, $completion) {
      return i.riv($this$provideLexicalScope, term, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_205(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_205).diw = function ($this$provideLexicalScope, term, $completion) {
    var tmp = this.eiw($this$provideLexicalScope, term, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_205).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.diw(tmp, (!(p2 == null) ? isInterface(p2, FunctionTerm_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_205).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.biw_1.v7a(this.ciw_1.rba(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_205).eiw = function ($this$provideLexicalScope, term, completion) {
    var i = new btbScopes$lambda$slambda_205(completion);
    i.biw_1 = $this$provideLexicalScope;
    i.ciw_1 = term;
    return i;
  };
  function btbScopes$lambda$slambda_206(resultContinuation) {
    var i = new btbScopes$lambda$slambda_205(resultContinuation);
    var l = function ($this$provideLexicalScope, term, $completion) {
      return i.diw($this$provideLexicalScope, term, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_207(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_207).piw = function ($this$provideImportScope, function_0, $completion) {
    var tmp = this.qiw($this$provideImportScope, function_0, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_207).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.piw(tmp, (!(p2 == null) ? isInterface(p2, FunctionDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_207).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.niw_1.t7a(this.oiw_1.pas(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_207).qiw = function ($this$provideImportScope, function_0, completion) {
    var i = new btbScopes$lambda$slambda_207(completion);
    i.niw_1 = $this$provideImportScope;
    i.oiw_1 = function_0;
    return i;
  };
  function btbScopes$lambda$slambda_208(resultContinuation) {
    var i = new btbScopes$lambda$slambda_207(resultContinuation);
    var l = function ($this$provideImportScope, function_0, $completion) {
      return i.piw($this$provideImportScope, function_0, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_209(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_209).bix = function ($this$provideLexicalScope, customEditor, $completion) {
    var tmp = this.cix($this$provideLexicalScope, customEditor, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_209).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.bix(tmp, (!(p2 == null) ? isInterface(p2, CustomEditor) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_209).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = getCustomEditorPropertiesScope(this.ziw_1, this.aix_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_209).cix = function ($this$provideLexicalScope, customEditor, completion) {
    var i = new btbScopes$lambda$slambda_209(completion);
    i.ziw_1 = $this$provideLexicalScope;
    i.aix_1 = customEditor;
    return i;
  };
  function btbScopes$lambda$slambda_210(resultContinuation) {
    var i = new btbScopes$lambda$slambda_209(resultContinuation);
    var l = function ($this$provideLexicalScope, customEditor, $completion) {
      return i.bix($this$provideLexicalScope, customEditor, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_211(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_211).biy = function ($this$provideLexicalScope, customEditor, $completion) {
    var tmp = this.ciy($this$provideLexicalScope, customEditor, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_211).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.biy(tmp, (!(p2 == null) ? isInterface(p2, CustomEditor) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_211).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            var tmp_0 = this;
            tmp_0.nix_1 = this.lix_1;
            var tmp_1 = this;
            tmp_1.oix_1 = this.mix_1;
            this.pix_1 = this.nix_1;
            this.qix_1 = this.oix_1;
            var tmp_2 = this;
            var tmp_3 = this.qix_1.yt();
            tmp_2.rix_1 = (tmp_3 == null ? true : isInterface(tmp_3, AbstractBindingDeclaration)) ? tmp_3 : THROW_CCE();
            var tmp_4 = this.rix_1;
            if (!(tmp_4 == null) ? isInterface(tmp_4, ProcessDeclaration_1) : false) {
              this.y9_1 = 3;
              suspendResult = this.pix_1.m51(this.rix_1.pdb(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_5 = this.rix_1;
              if (!(tmp_5 == null) ? isInterface(tmp_5, FunctionDeclaration_1) : false) {
                var tmp_6 = this;
                tmp_6.tix_1 = this.pix_1;
                var tmp_7 = this;
                tmp_7.uix_1 = this.rix_1;
                this.vix_1 = this.tix_1;
                this.wix_1 = this.uix_1;
                if (this.wix_1 == null) {
                  var tmp_8 = this;
                  tmp_8.xix_1 = new EmptyScope();
                  this.y9_1 = 2;
                  continue $sm;
                } else {
                  var tmp_9 = this;
                  var tmp0 = this.vix_1.n51(this.wix_1.w());
                  var destination = ArrayList_init_$Create$();
                  var _iterator__ex2g4s = tmp0.k();
                  while (_iterator__ex2g4s.l()) {
                    var element = _iterator__ex2g4s.m();
                    if (!(element == null) ? isInterface(element, AbstractLink) : false) {
                      destination.e(element);
                    }
                  }
                  tmp_9.yix_1 = destination;
                  this.y9_1 = 1;
                  suspendResult = this.vix_1.u7a(this.yix_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                if (this.rix_1 == null) {
                  var tmp_10 = this;
                  throw NullPointerException_init_$Create$_0('null parent for custom editor');
                } else {
                  var tmp_11 = this;
                  throw UnsupportedOperationException_init_$Create$_0('unknown class: ' + toString_1(getKClassFromExpression(this.rix_1)));
                }
              }
            }

          case 1:
            this.xix_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.six_1 = this.xix_1;
            this.y9_1 = 5;
            continue $sm;
          case 3:
            this.zix_1 = suspendResult;
            var tmp_12 = this;
            var tmp0_0 = this.zix_1;
            var destination_0 = ArrayList_init_$Create$();
            var _iterator__ex2g4s_0 = tmp0_0.k();
            while (_iterator__ex2g4s_0.l()) {
              var element_0 = _iterator__ex2g4s_0.m();
              if (!(element_0 == null) ? isInterface(element_0, AbstractLink) : false) {
                destination_0.e(element_0);
              }
            }

            tmp_12.aiy_1 = destination_0;
            this.y9_1 = 4;
            suspendResult = this.pix_1.u7a(this.aiy_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.six_1 = suspendResult;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            return this.six_1;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_211).ciy = function ($this$provideLexicalScope, customEditor, completion) {
    var i = new btbScopes$lambda$slambda_211(completion);
    i.lix_1 = $this$provideLexicalScope;
    i.mix_1 = customEditor;
    return i;
  };
  function btbScopes$lambda$slambda_212(resultContinuation) {
    var i = new btbScopes$lambda$slambda_211(resultContinuation);
    var l = function ($this$provideLexicalScope, customEditor, $completion) {
      return i.biy($this$provideLexicalScope, customEditor, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_213(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_213).biz = function ($this$provideLexicalScope, customEditor, $completion) {
    var tmp = this.ciz($this$provideLexicalScope, customEditor, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_213).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.biz(tmp, (!(p2 == null) ? isInterface(p2, CustomEditor) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_213).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            var tmp_0 = this;
            tmp_0.niy_1 = this.liy_1;
            var tmp_1 = this;
            tmp_1.oiy_1 = this.miy_1;
            this.piy_1 = this.niy_1;
            this.qiy_1 = this.oiy_1;
            var tmp_2 = this;
            var tmp_3 = this.qiy_1.yt();
            tmp_2.riy_1 = (tmp_3 == null ? true : isInterface(tmp_3, AbstractBindingDeclaration)) ? tmp_3 : THROW_CCE();
            var tmp_4 = this.riy_1;
            if (!(tmp_4 == null) ? isInterface(tmp_4, ProcessDeclaration_1) : false) {
              this.y9_1 = 3;
              suspendResult = this.piy_1.m51(this.riy_1.pdb(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_5 = this.riy_1;
              if (!(tmp_5 == null) ? isInterface(tmp_5, FunctionDeclaration_1) : false) {
                var tmp_6 = this;
                tmp_6.tiy_1 = this.piy_1;
                var tmp_7 = this;
                tmp_7.uiy_1 = this.riy_1;
                this.viy_1 = this.tiy_1;
                this.wiy_1 = this.uiy_1;
                if (this.wiy_1 == null) {
                  var tmp_8 = this;
                  tmp_8.xiy_1 = new EmptyScope();
                  this.y9_1 = 2;
                  continue $sm;
                } else {
                  var tmp_9 = this;
                  var tmp0 = this.viy_1.n51(this.wiy_1.w());
                  var destination = ArrayList_init_$Create$();
                  var _iterator__ex2g4s = tmp0.k();
                  while (_iterator__ex2g4s.l()) {
                    var element = _iterator__ex2g4s.m();
                    if (!(element == null) ? isInterface(element, AbstractProperty) : false) {
                      destination.e(element);
                    }
                  }
                  tmp_9.yiy_1 = destination;
                  this.y9_1 = 1;
                  suspendResult = this.viy_1.u7a(this.yiy_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                if (this.riy_1 == null) {
                  var tmp_10 = this;
                  throw NullPointerException_init_$Create$_0('null parent for custom editor');
                } else {
                  var tmp_11 = this;
                  throw UnsupportedOperationException_init_$Create$_0('unknown class: ' + toString_1(getKClassFromExpression(this.riy_1)));
                }
              }
            }

          case 1:
            this.xiy_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.siy_1 = this.xiy_1;
            this.y9_1 = 5;
            continue $sm;
          case 3:
            this.ziy_1 = suspendResult;
            var tmp_12 = this;
            var tmp0_0 = this.ziy_1;
            var destination_0 = ArrayList_init_$Create$();
            var _iterator__ex2g4s_0 = tmp0_0.k();
            while (_iterator__ex2g4s_0.l()) {
              var element_0 = _iterator__ex2g4s_0.m();
              if (!(element_0 == null) ? isInterface(element_0, AbstractProperty) : false) {
                destination_0.e(element_0);
              }
            }

            tmp_12.aiz_1 = destination_0;
            this.y9_1 = 4;
            suspendResult = this.piy_1.u7a(this.aiz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.siy_1 = suspendResult;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            return this.siy_1;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_213).ciz = function ($this$provideLexicalScope, customEditor, completion) {
    var i = new btbScopes$lambda$slambda_213(completion);
    i.liy_1 = $this$provideLexicalScope;
    i.miy_1 = customEditor;
    return i;
  };
  function btbScopes$lambda$slambda_214(resultContinuation) {
    var i = new btbScopes$lambda$slambda_213(resultContinuation);
    var l = function ($this$provideLexicalScope, customEditor, $completion) {
      return i.biz($this$provideLexicalScope, customEditor, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$lambda_1($this_provideLexicalScope) {
    return function (it) {
      return $this_provideLexicalScope.n51(it.sbi());
    };
  }
  function btbScopes$lambda$slambda_215($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.liz_1 = $this_scopes;
    this.miz_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_215).siz = function ($this$provideLexicalScope, query, $completion) {
    var tmp = this.tiz($this$provideLexicalScope, query, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_215).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.siz(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecificationQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_215).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.y9_1 = 1;
            suspendResult = this.niz_1.m51(this.oiz_1.jbg(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.piz_1 = suspendResult;
            if (this.piz_1 == null) {
              var tmp_0 = this;
              var tmp_1 = this.niz_1.n51(this.niz_1.n51(invoke$lambda(this.liz_1, this.miz_1).g6z(this.oiz_1)).n6z(LinkLibraryConcept_getInstance()));
              tmp_0.riz_1 = toList_2(flatMap(tmp_1, btbScopes$lambda$slambda$lambda_1(this.niz_1)));
              this.y9_1 = 2;
              suspendResult = this.niz_1.u7a(this.riz_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_2 = this;
              tmp_2.qiz_1 = new EmptyScope();
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            this.qiz_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.qiz_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_215).tiz = function ($this$provideLexicalScope, query, completion) {
    var i = new btbScopes$lambda$slambda_215(this.liz_1, this.miz_1, completion);
    i.niz_1 = $this$provideLexicalScope;
    i.oiz_1 = query;
    return i;
  };
  function btbScopes$lambda$slambda_216($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_215($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$provideLexicalScope, query, $completion) {
      return i.siz($this$provideLexicalScope, query, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$lambda_2($this_provideLexicalScope) {
    return function (it) {
      return $this_provideLexicalScope.n51(it.pas());
    };
  }
  function btbScopes$lambda$slambda_217($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.cj0_1 = $this_scopes;
    this.dj0_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_217).jj0 = function ($this$provideLexicalScope, query, $completion) {
    var tmp = this.kj0($this$provideLexicalScope, query, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_217).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.jj0(tmp, (!(p2 == null) ? isInterface(p2, LibraryProcessSpecificationQuery_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_217).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.y9_1 = 1;
            suspendResult = this.ej0_1.m51(this.fj0_1.jbg(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.gj0_1 = suspendResult;
            if (this.gj0_1 == null) {
              var tmp_0 = this;
              var tmp_1 = this.ej0_1.n51(this.ej0_1.n51(invoke$lambda(this.cj0_1, this.dj0_1).g6z(this.fj0_1)).n6z(PropertyLibraryConcept_getInstance()));
              tmp_0.ij0_1 = toList_2(flatMap(tmp_1, btbScopes$lambda$slambda$lambda_2(this.ej0_1)));
              this.y9_1 = 2;
              suspendResult = this.ej0_1.u7a(this.ij0_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_2 = this;
              tmp_2.hj0_1 = new EmptyScope();
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            this.hj0_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.hj0_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_217).kj0 = function ($this$provideLexicalScope, query, completion) {
    var i = new btbScopes$lambda$slambda_217(this.cj0_1, this.dj0_1, completion);
    i.ej0_1 = $this$provideLexicalScope;
    i.fj0_1 = query;
    return i;
  };
  function btbScopes$lambda$slambda_218($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_217($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$provideLexicalScope, query, $completion) {
      return i.jj0($this$provideLexicalScope, query, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_31(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_31).vj0 = function ($this$query, it, $completion) {
    var tmp = this.wj0($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_31).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vj0(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationDeclaration) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_31).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return false;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_31).wj0 = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_31(completion);
    i.tj0_1 = $this$query;
    i.uj0_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_32(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_31(resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.vj0($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_219(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_219).mj1 = function ($this$provideLexicalScope, variable, $completion) {
    var tmp = this.nj1($this$provideLexicalScope, variable, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_219).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.mj1(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_219).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            this.hj1_1 = this.fj1_1.n51(this.gj1_1.jcq());
            var tmp_0;
            var tmp_1 = this.hj1_1;
            if (!(tmp_1 == null) ? isInterface(tmp_1, OntologyElementType_1) : false) {
              tmp_0 = true;
            } else {
              var tmp_2 = this.hj1_1;
              tmp_0 = !(tmp_2 == null) ? isInterface(tmp_2, ClassExpressionType_1) : false;
            }

            if (tmp_0) {
              this.y9_1 = 2;
              suspendResult = this.fj1_1.m51(typeElements(this.hj1_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_3 = this.hj1_1;
              if (!(tmp_3 == null) ? isInterface(tmp_3, NotionType_0) : false) {
                this.y9_1 = 1;
                suspendResult = this.fj1_1.m51(this.hj1_1.lbp(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_4 = this.hj1_1;
                if (!(tmp_4 == null) ? isInterface(tmp_4, ProcessType_1) : false) {
                  var tmp_5 = this;
                  var tmp_6 = Companion_instance_119;
                  tmp_5.ij1_1 = tmp_6.a76(btbScopes$lambda$slambda$slambda_32(null));
                  this.y9_1 = 3;
                  continue $sm;
                } else {
                  this.ij1_1 = null;
                  this.y9_1 = 3;
                  continue $sm;
                }
              }
            }

          case 1:
            this.jj1_1 = suspendResult;
            var tmp_7 = this;
            var tmp_8;
            if (this.jj1_1 == null) {
              tmp_8 = null;
            } else {
              var it = this.jj1_1;
              tmp_8 = filterInstanceRelations_0(it);
            }

            tmp_7.ij1_1 = tmp_8;
            this.y9_1 = 3;
            continue $sm;
          case 2:
            this.kj1_1 = suspendResult;
            var tmp_9 = this;
            var tmp_10;
            if (this.kj1_1 == null) {
              tmp_10 = null;
            } else {
              var it_0 = this.kj1_1;
              tmp_10 = filterInstanceRelations(it_0);
            }

            tmp_9.ij1_1 = tmp_10;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.lj1_1 = this.ij1_1;
            this.y9_1 = 4;
            suspendResult = this.fj1_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var ARGUMENT = suspendResult;
            var tmp2_elvis_lhs = this.lj1_1;
            return filter_1(ARGUMENT, tmp2_elvis_lhs == null ? NoopScopeFilter_instance : tmp2_elvis_lhs);
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_219).nj1 = function ($this$provideLexicalScope, variable, completion) {
    var i = new btbScopes$lambda$slambda_219(completion);
    i.fj1_1 = $this$provideLexicalScope;
    i.gj1_1 = variable;
    return i;
  };
  function btbScopes$lambda$slambda_220(resultContinuation) {
    var i = new btbScopes$lambda$slambda_219(resultContinuation);
    var l = function ($this$provideLexicalScope, variable, $completion) {
      return i.mj1($this$provideLexicalScope, variable, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_33(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_33).vhg = function ($this$query, it, $completion) {
    var tmp = this.whg($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_33).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vhg(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_33).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !this.wj1_1.n51(this.xj1_1.wbq());
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_33).whg = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_33(completion);
    i.wj1_1 = $this$query;
    i.xj1_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_34(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_33(resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.vhg($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_221(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_221).lj2 = function ($this$provideLexicalScope, variable, $completion) {
    var tmp = this.mj2($this$provideLexicalScope, variable, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_221).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.lj2(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_221).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.gj2_1.m51(propertyFilterByDomainType(this.gj2_1.n51(this.hj2_1.jcq())), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ij2_1 = suspendResult;
            var tmp_0 = this;
            var tmp_1 = Companion_instance_119;
            tmp_0.jj2_1 = tmp_1.a76(btbScopes$lambda$slambda$slambda_34(null));
            var tmp_2 = this;
            var tmp_3;
            if (!(this.ij2_1 == null)) {
              tmp_3 = new CompositeScopeFilter(listOf_0([this.ij2_1, this.jj2_1]));
            } else {
              tmp_3 = this.jj2_1;
            }

            tmp_2.kj2_1 = tmp_3;
            this.y9_1 = 2;
            suspendResult = this.gj2_1.x7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            return filter_1(ARGUMENT, this.kj2_1);
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_221).mj2 = function ($this$provideLexicalScope, variable, completion) {
    var i = new btbScopes$lambda$slambda_221(completion);
    i.gj2_1 = $this$provideLexicalScope;
    i.hj2_1 = variable;
    return i;
  };
  function btbScopes$lambda$slambda_222(resultContinuation) {
    var i = new btbScopes$lambda$slambda_221(resultContinuation);
    var l = function ($this$provideLexicalScope, variable, $completion) {
      return i.lj2($this$provideLexicalScope, variable, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_35($variable, resultContinuation) {
    this.vj2_1 = $variable;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_35).kif = function ($this$filter, it, $completion) {
    var tmp = this.lif($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_35).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.kif(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_35).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !equals(this.xj2_1, this.vj2_1);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_35).lif = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_35(this.vj2_1, completion);
    i.wj2_1 = $this$filter;
    i.xj2_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_36($variable, resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_35($variable, resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.kif($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_223(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_223).ij3 = function ($this$provideLexicalScope, variable, $completion) {
    var tmp = this.jj3($this$provideLexicalScope, variable, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_223).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ij3(tmp, (!(p2 == null) ? isInterface(p2, VariableDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_223).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.gj3_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return filter_0(ARGUMENT, btbScopes$lambda$slambda$slambda_36(this.hj3_1, null));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_223).jj3 = function ($this$provideLexicalScope, variable, completion) {
    var i = new btbScopes$lambda$slambda_223(completion);
    i.gj3_1 = $this$provideLexicalScope;
    i.hj3_1 = variable;
    return i;
  };
  function btbScopes$lambda$slambda_224(resultContinuation) {
    var i = new btbScopes$lambda$slambda_223(resultContinuation);
    var l = function ($this$provideLexicalScope, variable, $completion) {
      return i.ij3($this$provideLexicalScope, variable, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_37(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_37).vhg = function ($this$query, it, $completion) {
    var tmp = this.whg($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_37).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vhg(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_37).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !this.sj3_1.n51(this.tj3_1.wbq());
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_37).whg = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_37(completion);
    i.sj3_1 = $this$query;
    i.tj3_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_38(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_37(resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.vhg($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_225(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_225).sj4 = function ($this$provideLexicalScope, constraint, $completion) {
    var tmp = this.tj4($this$provideLexicalScope, constraint, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_225).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.sj4(tmp, (!(p2 == null) ? isInterface(p2, PropertyConstraint_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_225).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 10;
            var tmp_0 = this;
            var tmp_1 = Companion_instance_119;
            tmp_0.ej4_1 = tmp_1.a76(btbScopes$lambda$slambda$slambda_38(null));
            if (!(this.cj4_1.n51(this.dj4_1.y()) == null)) {
              this.gj4_1 = this.cj4_1.n51(this.dj4_1.y());
              var tmp_2 = this.gj4_1;
              if (!(tmp_2 == null) ? isInterface(tmp_2, OntologyElementReferenceValue_1) : false) {
                this.ij4_1 = this.cj4_1.n51(this.gj4_1.lay());
                if (this.ij4_1 == null) {
                  this.jj4_1 = null;
                  this.y9_1 = 6;
                  continue $sm;
                } else {
                  this.y9_1 = 5;
                  suspendResult = this.cj4_1.m51(this.ij4_1.lay(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                var tmp_3 = this.gj4_1;
                if (!(tmp_3 == null) ? isInterface(tmp_3, MeasurableValue_1) : false) {
                  this.y9_1 = 4;
                  suspendResult = this.cj4_1.m51(this.gj4_1.jbk().p6s(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_4 = this.gj4_1;
                  if (!(tmp_4 == null) ? isInterface(tmp_4, EnumValue_1) : false) {
                    this.y9_1 = 3;
                    suspendResult = this.cj4_1.m51(this.gj4_1.wb2().p6s(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.hj4_1 = null;
                    this.y9_1 = 7;
                    continue $sm;
                  }
                }
              }
            } else {
              if (!(this.cj4_1.n51(this.dj4_1.i6u().r6s()) == null)) {
                this.y9_1 = 2;
                suspendResult = this.cj4_1.v7a(this.dj4_1.i6u(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.y9_1 = 1;
                suspendResult = this.cj4_1.x7a(this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 1:
            this.fj4_1 = suspendResult;
            this.y9_1 = 9;
            continue $sm;
          case 2:
            this.fj4_1 = suspendResult;
            this.y9_1 = 9;
            continue $sm;
          case 3:
            this.kj4_1 = suspendResult;
            var tmp_5 = this;
            var tmp_6;
            if (this.kj4_1 == null) {
              tmp_6 = null;
            } else {
              var this_0 = this.kj4_1;
              tmp_6 = ancestorOrSelf(this_0, getKClass(EnumerableNotion_1));
            }

            tmp_5.lj4_1 = tmp_6;
            this.mj4_1 = this.lj4_1 == null ? null : this.cj4_1.n51(this.lj4_1);
            this.hj4_1 = !(this.mj4_1 == null) ? filterObjectProperties_0(this.mj4_1) : null;
            this.y9_1 = 7;
            continue $sm;
          case 4:
            this.nj4_1 = suspendResult;
            var tmp_7 = this;
            var tmp_8;
            if (this.nj4_1 == null) {
              tmp_8 = null;
            } else {
              var this_1 = this.nj4_1;
              tmp_8 = ancestorOrSelf(this_1, getKClass(MeasurableNotion_1));
            }

            tmp_7.oj4_1 = tmp_8;
            this.pj4_1 = this.oj4_1 == null ? null : this.cj4_1.n51(this.oj4_1);
            this.hj4_1 = !(this.pj4_1 == null) ? filterObjectProperties_0(this.pj4_1) : null;
            this.y9_1 = 7;
            continue $sm;
          case 5:
            this.jj4_1 = suspendResult;
            this.y9_1 = 6;
            continue $sm;
          case 6:
            this.qj4_1 = this.jj4_1;
            this.hj4_1 = !(this.qj4_1 == null) ? filterObjectProperties(setOf(this.qj4_1)) : null;
            this.y9_1 = 7;
            continue $sm;
          case 7:
            this.rj4_1 = this.hj4_1;
            this.y9_1 = 8;
            suspendResult = this.cj4_1.x7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            var ARGUMENT = suspendResult;
            var tmp_9 = this;
            var tmp5_elvis_lhs = this.rj4_1;
            tmp_9.fj4_1 = filter_1(ARGUMENT, tmp5_elvis_lhs == null ? NoopScopeFilter_instance : tmp5_elvis_lhs);
            this.y9_1 = 9;
            continue $sm;
          case 9:
            var scope = this.fj4_1;
            return filter_1(scope, this.ej4_1);
          case 10:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 10) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_225).tj4 = function ($this$provideLexicalScope, constraint, completion) {
    var i = new btbScopes$lambda$slambda_225(completion);
    i.cj4_1 = $this$provideLexicalScope;
    i.dj4_1 = constraint;
    return i;
  };
  function btbScopes$lambda$slambda_226(resultContinuation) {
    var i = new btbScopes$lambda$slambda_225(resultContinuation);
    var l = function ($this$provideLexicalScope, constraint, $completion) {
      return i.sj4($this$provideLexicalScope, constraint, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_39(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_39).vhg = function ($this$query, it, $completion) {
    var tmp = this.whg($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_39).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vhg(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_39).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !this.cj5_1.n51(this.dj5_1.wbq());
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_39).whg = function ($this$query, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_39(completion);
    i.cj5_1 = $this$query;
    i.dj5_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_40(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_39(resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.vhg($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_227(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_227).cj6 = function ($this$provideLexicalScope, definition, $completion) {
    var tmp = this.dj6($this$provideLexicalScope, definition, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_227).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.cj6(tmp, (!(p2 == null) ? isInterface(p2, OntologyElementDefinition_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_227).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            var tmp_0 = this;
            var tmp_1 = Companion_instance_119;
            tmp_0.oj5_1 = tmp_1.a76(btbScopes$lambda$slambda$slambda_40(null));
            var tmp_2 = this;
            var tmp0_safe_receiver = this.mj5_1.n51(this.nj5_1.yay());
            tmp_2.pj5_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ud1();
            if (this.pj5_1 == null) {
              this.qj5_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.mj5_1.m51(this.pj5_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.qj5_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.rj5_1 = this.qj5_1;
            if (this.rj5_1 == null) {
              this.sj5_1 = null;
              this.y9_1 = 5;
              continue $sm;
            } else {
              var tmp_3 = this;
              tmp_3.tj5_1 = this.rj5_1;
              this.uj5_1 = this.tj5_1;
              var tmp_4 = this;
              tmp_4.vj5_1 = this.uj5_1;
              this.wj5_1 = this.vj5_1;
              this.xj5_1 = this.wj5_1;
              var tmp_5 = this.xj5_1;
              if (isInterface(tmp_5, UnionClass_1)) {
                this.y9_1 = 3;
                suspendResult = this.mj5_1.m51(getAssertedDefinitionElements_0(ontologyElementHierarchy(), this.wj5_1), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_6 = this.xj5_1;
                if (isInterface(tmp_6, OntologyElement_1)) {
                  this.yj5_1 = setOf(this.wj5_1);
                  this.y9_1 = 4;
                  continue $sm;
                } else {
                  var tmp_7 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 3:
            this.yj5_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.zj5_1 = this.yj5_1;
            this.sj5_1 = new CompositeScopeFilter(listOf_0([this.oj5_1, filterObjectProperties(this.zj5_1)]));
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.aj6_1 = this.sj5_1;
            this.bj6_1 = this.aj6_1 == null ? this.oj5_1 : this.aj6_1;
            this.y9_1 = 6;
            suspendResult = this.mj5_1.x7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var ARGUMENT = suspendResult;
            return filter_1(ARGUMENT, this.bj6_1);
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_227).dj6 = function ($this$provideLexicalScope, definition, completion) {
    var i = new btbScopes$lambda$slambda_227(completion);
    i.mj5_1 = $this$provideLexicalScope;
    i.nj5_1 = definition;
    return i;
  };
  function btbScopes$lambda$slambda_228(resultContinuation) {
    var i = new btbScopes$lambda$slambda_227(resultContinuation);
    var l = function ($this$provideLexicalScope, definition, $completion) {
      return i.cj6($this$provideLexicalScope, definition, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_229(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_229).cj7 = function ($this$provideLexicalScope, valueWithProperties, $completion) {
    var tmp = this.dj7($this$provideLexicalScope, valueWithProperties, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_229).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.cj7(tmp, (!(p2 == null) ? isInterface(p2, ValueWithRelations_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_229).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 9;
            this.oj6_1 = this.mj6_1.n51(this.nj6_1.y());
            var tmp_0 = this.oj6_1;
            if (!(tmp_0 == null) ? isInterface(tmp_0, OntologyElementReferenceValueLibrary_1) : false) {
              this.qj6_1 = this.mj6_1.n51(this.oj6_1.lay());
              if (this.qj6_1 == null) {
                this.rj6_1 = null;
                this.y9_1 = 6;
                continue $sm;
              } else {
                this.y9_1 = 5;
                suspendResult = this.mj6_1.m51(this.qj6_1.lay(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_1;
              var tmp_2 = this.oj6_1;
              if (!(tmp_2 == null) ? isInterface(tmp_2, MeasurableValue_1) : false) {
                tmp_1 = true;
              } else {
                var tmp_3 = this.oj6_1;
                tmp_1 = !(tmp_3 == null) ? isInterface(tmp_3, EnumValue_1) : false;
              }
              if (tmp_1) {
                var tmp_4 = this;
                var this_0 = this.nj6_1;
                tmp_4.sj6_1 = this.mj6_1.n51(ancestorOrSelf(this_0, getKClass(ProcessPropertyValue_1)));
                if (this.sj6_1 == null) {
                  this.tj6_1 = null;
                  this.y9_1 = 2;
                  continue $sm;
                } else {
                  this.y9_1 = 1;
                  suspendResult = this.mj6_1.m51(this.sj6_1.i6u(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                this.pj6_1 = null;
                this.y9_1 = 7;
                continue $sm;
              }
            }

          case 1:
            this.tj6_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.uj6_1 = this.tj6_1;
            this.vj6_1 = this.uj6_1 == null ? null : this.mj6_1.n51(this.uj6_1.zb3());
            var tmp_5 = this;
            var tmp_6 = this.vj6_1 == null ? null : this.mj6_1.n51(this.vj6_1.zb3());
            tmp_5.wj6_1 = (!(tmp_6 == null) ? isInterface(tmp_6, SimplePropertyType) : false) ? tmp_6 : null;
            this.xj6_1 = this.wj6_1;
            if (this.xj6_1 == null) {
              this.yj6_1 = null;
              this.y9_1 = 4;
              continue $sm;
            } else {
              this.y9_1 = 3;
              suspendResult = this.mj6_1.m51(this.xj6_1.lbp(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 3:
            this.yj6_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.zj6_1 = this.yj6_1;
            var tmp_7 = this;
            var tmp_8;
            if (this.zj6_1 == null) {
              tmp_8 = null;
            } else {
              var it = this.zj6_1;
              tmp_8 = filterInstanceRelations_0(it);
            }

            tmp_7.pj6_1 = tmp_8;
            this.y9_1 = 7;
            continue $sm;
          case 5:
            this.rj6_1 = suspendResult;
            this.y9_1 = 6;
            continue $sm;
          case 6:
            this.aj7_1 = this.rj6_1;
            var tmp_9 = this;
            var tmp_10;
            if (this.aj7_1 == null) {
              tmp_10 = null;
            } else {
              var it_0 = this.aj7_1;
              tmp_10 = filterInstanceRelations(setOf(it_0));
            }

            tmp_9.pj6_1 = tmp_10;
            this.y9_1 = 7;
            continue $sm;
          case 7:
            this.bj7_1 = this.pj6_1;
            this.y9_1 = 8;
            suspendResult = this.mj6_1.q7a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            var ARGUMENT = suspendResult;
            var tmp7_elvis_lhs = this.bj7_1;
            return filter_1(ARGUMENT, tmp7_elvis_lhs == null ? NoopScopeFilter_instance : tmp7_elvis_lhs);
          case 9:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 9) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_229).dj7 = function ($this$provideLexicalScope, valueWithProperties, completion) {
    var i = new btbScopes$lambda$slambda_229(completion);
    i.mj6_1 = $this$provideLexicalScope;
    i.nj6_1 = valueWithProperties;
    return i;
  };
  function btbScopes$lambda$slambda_230(resultContinuation) {
    var i = new btbScopes$lambda$slambda_229(resultContinuation);
    var l = function ($this$provideLexicalScope, valueWithProperties, $completion) {
      return i.cj7($this$provideLexicalScope, valueWithProperties, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_231(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_231).oj7 = function ($this$provideImportScope, it, $completion) {
    var tmp = this.pj7($this$provideImportScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_231).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.oj7(tmp, (!(p2 == null) ? isInterface(p2, ProcessLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_231).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.mj7_1.t7a(this.nj7_1.jc8(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_231).pj7 = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_231(completion);
    i.mj7_1 = $this$provideImportScope;
    i.nj7_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_232(resultContinuation) {
    var i = new btbScopes$lambda$slambda_231(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.oj7($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_41(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_41).bil = function ($this$filter, it, $completion) {
    var tmp = this.cil($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_41).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.bil(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_41).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var tmp_0 = this.zj7_1;
          return isInterface(tmp_0, ObjectPropertyDeclaration_1);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_41).cil = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_41(completion);
    i.yj7_1 = $this$filter;
    i.zj7_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_42(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_41(resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.bil($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_233(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_233).kj8 = function ($this$provideImportScope, it, $completion) {
    var tmp = this.lj8($this$provideImportScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_233).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.kj8(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertiesLibrary) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_233).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ij8_1.t7a(this.jj8_1.pas(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            var tmp_0 = filter_0(this_0, btbScopes$lambda$slambda$slambda_42(null));
            return isInterface(tmp_0, Scope) ? tmp_0 : THROW_CCE();
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_233).lj8 = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_233(completion);
    i.ij8_1 = $this$provideImportScope;
    i.jj8_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_234(resultContinuation) {
    var i = new btbScopes$lambda$slambda_233(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.kj8($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_235(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_235).wj8 = function ($this$provideImportScope, it, $completion) {
    var tmp = this.xj8($this$provideImportScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_235).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.wj8(tmp, (!(p2 == null) ? isInterface(p2, RelationContainer_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_235).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.uj8_1.t7a(this.vj8_1.ccl(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_235).xj8 = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_235(completion);
    i.uj8_1 = $this$provideImportScope;
    i.vj8_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_236(resultContinuation) {
    var i = new btbScopes$lambda$slambda_235(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.wj8($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_237(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_237).ij9 = function ($this$provideImportScope, it, $completion) {
    var tmp = this.jj9($this$provideImportScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_237).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ij9(tmp, (!(p2 == null) ? isInterface(p2, RelationContainer_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_237).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.gj9_1.t7a(this.hj9_1.dcl(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_237).jj9 = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_237(completion);
    i.gj9_1 = $this$provideImportScope;
    i.hj9_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_238(resultContinuation) {
    var i = new btbScopes$lambda$slambda_237(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.ij9($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_239(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_239).uj9 = function ($this$provideImportScope, it, $completion) {
    var tmp = this.vj9($this$provideImportScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_239).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.uj9(tmp, (!(p2 == null) ? isInterface(p2, ModifierContainer) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_239).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.sj9_1.t7a(this.tj9_1.jbl(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_239).vj9 = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_239(completion);
    i.sj9_1 = $this$provideImportScope;
    i.tj9_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_240(resultContinuation) {
    var i = new btbScopes$lambda$slambda_239(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.uj9($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_241(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_241).gja = function ($this$provideImportScope, it, $completion) {
    var tmp = this.hja($this$provideImportScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_241).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.gja(tmp, (!(p2 == null) ? isInterface(p2, FunctionLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_241).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.eja_1.t7a(this.fja_1.xb9(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_241).hja = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_241(completion);
    i.eja_1 = $this$provideImportScope;
    i.fja_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_242(resultContinuation) {
    var i = new btbScopes$lambda$slambda_241(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.gja($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_243(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_243).sja = function ($this$provideImportScope, it, $completion) {
    var tmp = this.tja($this$provideImportScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_243).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.sja(tmp, (!(p2 == null) ? isInterface(p2, ProcessKindContainer_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_243).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.qja_1.t7a(this.rja_1.wc7(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_243).tja = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_243(completion);
    i.qja_1 = $this$provideImportScope;
    i.rja_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_244(resultContinuation) {
    var i = new btbScopes$lambda$slambda_243(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.sja($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_245(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_245).ejb = function ($this$provideImportScope, it, $completion) {
    var tmp = this.fjb($this$provideImportScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_245).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ejb(tmp, (!(p2 == null) ? isInterface(p2, LinkLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_245).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.cjb_1.t7a(this.djb_1.sbi(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_245).fjb = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_245(completion);
    i.cjb_1 = $this$provideImportScope;
    i.djb_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_246(resultContinuation) {
    var i = new btbScopes$lambda$slambda_245(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.ejb($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda$slambda_43(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda$slambda_43).bil = function ($this$filter, it, $completion) {
    var tmp = this.cil($this$filter, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda$slambda_43).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.bil(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda$slambda_43).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var tmp_0 = this.pjb_1;
          return isInterface(tmp_0, PropertyDeclaration_1);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda$slambda_43).cil = function ($this$filter, it, completion) {
    var i = new btbScopes$lambda$slambda$slambda_43(completion);
    i.ojb_1 = $this$filter;
    i.pjb_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda$slambda_44(resultContinuation) {
    var i = new btbScopes$lambda$slambda$slambda_43(resultContinuation);
    var l = function ($this$filter, it, $completion) {
      return i.bil($this$filter, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_247(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_247).ajc = function ($this$provideImportScope, it, $completion) {
    var tmp = this.bjc($this$provideImportScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_247).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.ajc(tmp, (!(p2 == null) ? isInterface(p2, PropertyLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_247).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.yjb_1.t7a(this.zjb_1.sc0(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            var tmp_0 = filter_0(this_0, btbScopes$lambda$slambda$slambda_44(null));
            return isInterface(tmp_0, Scope) ? tmp_0 : THROW_CCE();
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_247).bjc = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_247(completion);
    i.yjb_1 = $this$provideImportScope;
    i.zjb_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_248(resultContinuation) {
    var i = new btbScopes$lambda$slambda_247(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.ajc($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_249(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_249).mjc = function ($this$provideImportScope, it, $completion) {
    var tmp = this.njc($this$provideImportScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_249).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.mjc(tmp, (!(p2 == null) ? isInterface(p2, NotionLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_249).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.kjc_1.t7a(this.ljc_1.xbo(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_249).njc = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_249(completion);
    i.kjc_1 = $this$provideImportScope;
    i.ljc_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_250(resultContinuation) {
    var i = new btbScopes$lambda$slambda_249(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.mjc($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_251(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_251).yjc = function ($this$provideImportScope, it, $completion) {
    var tmp = this.zjc($this$provideImportScope, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_251).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof ScopeBuilderWithProvider ? p1 : THROW_CCE();
    return this.yjc(tmp, (!(p2 == null) ? isInterface(p2, PublishedSourcesLibrary_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_251).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.wjc_1.t7a(this.xjc_1.cq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_251).zjc = function ($this$provideImportScope, it, completion) {
    var i = new btbScopes$lambda$slambda_251(completion);
    i.wjc_1 = $this$provideImportScope;
    i.xjc_1 = it;
    return i;
  };
  function btbScopes$lambda$slambda_252(resultContinuation) {
    var i = new btbScopes$lambda$slambda_251(resultContinuation);
    var l = function ($this$provideImportScope, it, $completion) {
      return i.yjc($this$provideImportScope, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function btbScopes$lambda$slambda_253($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.ijd_1 = $this_scopes;
    this.jjd_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_253).ljd = function ($this$defaultScope, $completion) {
    var tmp = this.mjd($this$defaultScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_253).oa = function (p1, $completion) {
    return this.ljd(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_253).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = libraryElementsScope(this.kjd_1, invoke$lambda(this.ijd_1, this.jjd_1), ProcessLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_253).mjd = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_253(this.ijd_1, this.jjd_1, completion);
    i.kjd_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_254($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_253($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.ljd($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_255($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.vjd_1 = $this_scopes;
    this.wjd_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_255).yjd = function ($this$defaultScope, $completion) {
    var tmp = this.zjd($this$defaultScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_255).oa = function (p1, $completion) {
    return this.yjd(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_255).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = libraryElementsScope(this.xjd_1, invoke$lambda(this.vjd_1, this.wjd_1), ObjectPropertiesLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_255).zjd = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_255(this.vjd_1, this.wjd_1, completion);
    i.xjd_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_256($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_255($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.yjd($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_257($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.ije_1 = $this_scopes;
    this.jje_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_257).lje = function ($this$defaultScope, $completion) {
    var tmp = this.mje($this$defaultScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_257).oa = function (p1, $completion) {
    return this.lje(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_257).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = libraryElementsScope(this.kje_1, invoke$lambda(this.ije_1, this.jje_1), RelationContainerConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_257).mje = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_257(this.ije_1, this.jje_1, completion);
    i.kje_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_258($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_257($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.lje($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_259($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.vje_1 = $this_scopes;
    this.wje_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_259).yje = function ($this$defaultScope, $completion) {
    var tmp = this.zje($this$defaultScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_259).oa = function (p1, $completion) {
    return this.yje(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_259).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = libraryElementsScope(this.xje_1, invoke$lambda(this.vje_1, this.wje_1), RelationContainerConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_259).zje = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_259(this.vje_1, this.wje_1, completion);
    i.xje_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_260($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_259($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.yje($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_261($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.ijf_1 = $this_scopes;
    this.jjf_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_261).ljf = function ($this$defaultScope, $completion) {
    var tmp = this.mjf($this$defaultScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_261).oa = function (p1, $completion) {
    return this.ljf(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_261).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = libraryElementsScope(this.kjf_1, invoke$lambda(this.ijf_1, this.jjf_1), ModifierContainerConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_261).mjf = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_261(this.ijf_1, this.jjf_1, completion);
    i.kjf_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_262($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_261($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.ljf($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_263($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.vjf_1 = $this_scopes;
    this.wjf_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_263).yjf = function ($this$defaultScope, $completion) {
    var tmp = this.zjf($this$defaultScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_263).oa = function (p1, $completion) {
    return this.yjf(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_263).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = libraryElementsScope(this.xjf_1, invoke$lambda(this.vjf_1, this.wjf_1), FunctionLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_263).zjf = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_263(this.vjf_1, this.wjf_1, completion);
    i.xjf_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_264($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_263($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.yjf($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_265($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.ijg_1 = $this_scopes;
    this.jjg_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_265).ljg = function ($this$defaultScope, $completion) {
    var tmp = this.mjg($this$defaultScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_265).oa = function (p1, $completion) {
    return this.ljg(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_265).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = libraryElementsScope(this.kjg_1, invoke$lambda(this.ijg_1, this.jjg_1), ProcessKindContainerConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_265).mjg = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_265(this.ijg_1, this.jjg_1, completion);
    i.kjg_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_266($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_265($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.ljg($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_267($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.vjg_1 = $this_scopes;
    this.wjg_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_267).yjg = function ($this$defaultScope, $completion) {
    var tmp = this.zjg($this$defaultScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_267).oa = function (p1, $completion) {
    return this.yjg(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_267).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = libraryElementsScope(this.xjg_1, invoke$lambda(this.vjg_1, this.wjg_1), LinkLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_267).zjg = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_267(this.vjg_1, this.wjg_1, completion);
    i.xjg_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_268($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_267($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.yjg($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_269($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.ijh_1 = $this_scopes;
    this.jjh_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_269).ljh = function ($this$defaultScope, $completion) {
    var tmp = this.mjh($this$defaultScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_269).oa = function (p1, $completion) {
    return this.ljh(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_269).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = libraryElementsScope(this.kjh_1, invoke$lambda(this.ijh_1, this.jjh_1), PropertyLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_269).mjh = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_269(this.ijh_1, this.jjh_1, completion);
    i.kjh_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_270($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_269($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.ljh($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_271($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.vjh_1 = $this_scopes;
    this.wjh_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_271).yjh = function ($this$defaultScope, $completion) {
    var tmp = this.zjh($this$defaultScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_271).oa = function (p1, $completion) {
    return this.yjh(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_271).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = libraryElementsScope(this.xjh_1, invoke$lambda(this.vjh_1, this.wjh_1), NotionLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_271).zjh = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_271(this.vjh_1, this.wjh_1, completion);
    i.xjh_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_272($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_271($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.yjh($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_273($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.iji_1 = $this_scopes;
    this.jji_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_273).lji = function ($this$defaultScope, $completion) {
    var tmp = this.mji($this$defaultScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_273).oa = function (p1, $completion) {
    return this.lji(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_273).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = libraryElementsScope(this.kji_1, invoke$lambda(this.iji_1, this.jji_1), PublishedSourcesLibraryConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_273).mji = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_273(this.iji_1, this.jji_1, completion);
    i.kji_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_274($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_273($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.lji($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$slambda_275($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    this.vji_1 = $this_scopes;
    this.wji_1 = $librariesScopeProvider$delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbScopes$lambda$slambda_275).yji = function ($this$defaultScope, $completion) {
    var tmp = this.zji($this$defaultScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$lambda$slambda_275).oa = function (p1, $completion) {
    return this.yji(p1 instanceof ScopeBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbScopes$lambda$slambda_275).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = librariesScope(this.xji_1, invoke$lambda(this.vji_1, this.wji_1), OntologyImportRootConcept_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbScopes$lambda$slambda_275).zji = function ($this$defaultScope, completion) {
    var i = new btbScopes$lambda$slambda_275(this.vji_1, this.wji_1, completion);
    i.xji_1 = $this$defaultScope;
    return i;
  };
  function btbScopes$lambda$slambda_276($this_scopes, $librariesScopeProvider$delegate, resultContinuation) {
    var i = new btbScopes$lambda$slambda_275($this_scopes, $librariesScopeProvider$delegate, resultContinuation);
    var l = function ($this$defaultScope, $completion) {
      return i.yji($this$defaultScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbScopes$lambda$lambda(it) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbScopes$1$150$$inlined$suspendingQuery$1(it);
  }
  function $runSuspendCOROUTINE$46_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ijj_1 = _this__u8e3s4;
    this.jjj_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$46_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.kjj_1 = this.jjj_1;
            this.ljj_1 = this.kjj_1;
            var tmp_1 = this;
            tmp_1.mjj_1 = this.ljj_1;
            this.y9_1 = 1;
            suspendResult = this.ljj_1.m51(this.ijj_1.njj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp3 = suspendResult;
            var $this$flatMap = this.mjj_1;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp3, 10));
            var _iterator__ex2g4s = tmp3.k();
            while (_iterator__ex2g4s.l()) {
              var item = _iterator__ex2g4s.m();
              destination.e($this$flatMap.n51(item.b3()));
            }

            return destination;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function btbScopes$1$150$$inlined$suspendingQuery$1$runSuspend$2($this) {
    this.njj_1 = $this;
  }
  protoOf(btbScopes$1$150$$inlined$suspendingQuery$1$runSuspend$2).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$46_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$1$150$$inlined$suspendingQuery$1$runSuspend$2).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function $runSuspendCOROUTINE$45(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wjj_1 = _this__u8e3s4;
    this.xjj_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$45).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 8;
            var tmp_0 = this;
            tmp_0.yjj_1 = this.xjj_1;
            this.zjj_1 = this.yjj_1;
            var tmp_1 = get_ONTOLOGIES_WITH_SPECIES();
            var tmp_2 = this.wjj_1.ljk_1.u3o();
            var tmp0_safe_receiver = (!(tmp_2 == null) ? isInterface(tmp_2, OntologyLibrary_1) : false) ? tmp_2 : null;
            if (!contains_5(tmp_1, tmp0_safe_receiver == null ? null : this.zjj_1.n51(tmp0_safe_receiver.b3()))) {
              var tmp_3 = this;
              tmp_3.ajk_1 = null;
              this.y9_1 = 6;
              continue $sm;
            } else {
              this.bjk_1 = this.zjj_1.n51(this.wjj_1.ljk_1.ibu());
              var tmp_4 = this.bjk_1;
              if (!(tmp_4 == null) ? isInterface(tmp_4, UnionClass_1) : false) {
                var tmp_5 = this;
                var tmp0 = this.zjj_1.n51(this.bjk_1.tco());
                var destination = ArrayList_init_$Create$();
                var _iterator__ex2g4s = tmp0.k();
                while (_iterator__ex2g4s.l()) {
                  var element = _iterator__ex2g4s.m();
                  if (!(element == null) ? isInterface(element, OntologyElementReferenceProvider) : false) {
                    destination.e(element);
                  }
                }
                var tmp1_safe_receiver = firstOrNull_0(destination);
                tmp_5.djk_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.lay();
                if (this.djk_1 == null) {
                  this.ejk_1 = null;
                  this.y9_1 = 4;
                  continue $sm;
                } else {
                  this.y9_1 = 3;
                  suspendResult = this.zjj_1.m51(this.djk_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                var tmp_6 = this.bjk_1;
                if (!(tmp_6 == null) ? isInterface(tmp_6, OntologyElementReferenceProvider) : false) {
                  this.fjk_1 = this.bjk_1.lay();
                  if (this.fjk_1 == null) {
                    this.gjk_1 = null;
                    this.y9_1 = 2;
                    continue $sm;
                  } else {
                    this.y9_1 = 1;
                    suspendResult = this.zjj_1.m51(this.fjk_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  }
                } else {
                  this.cjk_1 = null;
                  this.y9_1 = 5;
                  continue $sm;
                }
              }
            }

          case 1:
            this.gjk_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.hjk_1 = this.gjk_1;
            this.cjk_1 = this.hjk_1 == null ? null : this.zjj_1.n51(this.hjk_1.b3());
            this.y9_1 = 5;
            continue $sm;
          case 3:
            this.ejk_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.ijk_1 = this.ejk_1;
            this.cjk_1 = this.ijk_1 == null ? null : this.zjj_1.n51(this.ijk_1.b3());
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.ajk_1 = this.cjk_1;
            this.y9_1 = 6;
            continue $sm;
          case 6:
            this.jjk_1 = this.ajk_1;
            this.kjk_1 = this.zjj_1.n51(this.wjj_1.ljk_1.b3());
            this.y9_1 = 7;
            var this_0 = this.wjj_1.ljk_1.kbu();
            suspendResult = this.zjj_1.m51(new btbScopes$1$150$$inlined$suspendingQuery$1$runSuspend$2(this_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            var synonyms = suspendResult;
            return new NamingInfo(this.kjk_1, toSet_0(synonyms), this.jjk_1);
          case 8:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 8) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function btbScopes$1$150$$inlined$suspendingQuery$1($it) {
    this.ljk_1 = $it;
  }
  protoOf(btbScopes$1$150$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$45(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$1$150$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function btbScopes$lambda$lambda_0(relation) {
    _init_properties_BTBResolvers_kt__y423vn();
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new btbScopes$1$151$$inlined$suspendingQuery$1(relation);
  }
  function btbScopes$1$151$$inlined$suspendingQuery$1($relation) {
    this.mjk_1 = $relation;
  }
  protoOf(btbScopes$1$151$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.biokb.lang.model.resolve.btbScopes.<anonymous>.<anonymous>.<anonymous>' call
    var name = builder.n51(this.mjk_1.b3());
    var symbol = builder.n51(this.mjk_1.jcc());
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(name)) {
      // Inline function 'kotlin.text.isNotBlank' call
      tmp_0 = !isBlank(symbol);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = new NamingInfo(name, setOf(symbol), name);
    } else {
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(symbol)) {
        tmp = new NamingInfo(symbol);
      } else {
        tmp = new NamingInfo(name);
      }
    }
    return tmp;
  };
  protoOf(btbScopes$1$151$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function btbScopes$lambda$lambda_1(it) {
    _init_properties_BTBResolvers_kt__y423vn();
    return it.b3();
  }
  function $runSuspendCOROUTINE$47_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vjk_1 = _this__u8e3s4;
    this.wjk_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$47_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.xjk_1 = this.wjk_1;
            this.yjk_1 = this.xjk_1;
            this.y9_1 = 1;
            suspendResult = this.yjk_1.m51(this.vjk_1.zjk_1(this.vjk_1.ajl_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var singleName = suspendResult;
            return new NamingInfo(singleName);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function btbScopes$1$$inlined$name$1$1($body, $target) {
    this.zjk_1 = $body;
    this.ajl_1 = $target;
  }
  protoOf(btbScopes$1$$inlined$name$1$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$47_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbScopes$1$$inlined$name$1$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function btbScopes$lambda$lambda_2($body) {
    return function (target) {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new btbScopes$1$$inlined$name$1$1($body, target);
    };
  }
  function $runSuspendCOROUTINE$48_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jjl_1 = _this__u8e3s4;
    this.kjl_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$48_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.ljl_1 = this.kjl_1;
            this.mjl_1 = this.ljl_1;
            this.y9_1 = 1;
            suspendResult = this.mjl_1.m51(this.jjl_1.njl_1.i6u(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function propertyTypeElements$$inlined$suspendingQuery$1($propertyValue) {
    this.njl_1 = $propertyValue;
  }
  protoOf(propertyTypeElements$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$48_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(propertyTypeElements$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function $runSuspendCOROUTINE$49(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wjl_1 = _this__u8e3s4;
    this.xjl_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$49).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.yjl_1 = this.xjl_1;
            this.zjl_1 = this.yjl_1;
            var tmp_1 = this;
            tmp_1.ajm_1 = this.zjl_1;
            this.y9_1 = 1;
            suspendResult = this.zjl_1.m51(this.wjl_1.kjm_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.bjm_1 = suspendResult;
            this.cjm_1 = this.ajm_1;
            this.djm_1 = this.bjm_1;
            this.ejm_1 = this.djm_1;
            if (this.ejm_1 == null) {
              this.fjm_1 = null;
              this.y9_1 = 3;
              continue $sm;
            } else {
              var tmp_2 = this;
              tmp_2.gjm_1 = this.ejm_1;
              this.hjm_1 = this.gjm_1;
              var tmp_3 = this;
              tmp_3.ijm_1 = this.hjm_1;
              this.jjm_1 = this.ijm_1;
              this.y9_1 = 2;
              suspendResult = processPropertyElements(this.cjm_1, this.jjm_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.fjm_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.fjm_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function propertyTypeElements$$inlined$flatMap$1($this) {
    this.kjm_1 = $this;
  }
  protoOf(propertyTypeElements$$inlined$flatMap$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$49(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(propertyTypeElements$$inlined$flatMap$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function $runSuspendCOROUTINE$50(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tjm_1 = _this__u8e3s4;
    this.ujm_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$50).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 9;
            var tmp_0 = this;
            tmp_0.vjm_1 = this.ujm_1;
            this.wjm_1 = this.vjm_1;
            this.xjm_1 = this.tjm_1.kjn_1;
            var tmp_1 = this.xjm_1;
            if (!(tmp_1 == null) ? isInterface(tmp_1, OntologyElementType_1) : false) {
              this.zjm_1 = this.wjm_1.n51(this.tjm_1.kjn_1.lay());
              if (this.zjm_1 == null) {
                this.ajn_1 = null;
                this.y9_1 = 7;
                continue $sm;
              } else {
                this.y9_1 = 6;
                suspendResult = this.wjm_1.m51(this.zjm_1.lay(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_2 = this.xjm_1;
              if (!(tmp_2 == null) ? isInterface(tmp_2, OntologyElementPropertyType_1) : false) {
                if (!equals(this.wjm_1.n51(this.tjm_1.kjn_1.sba()), LinkTypeSpecificator_TYPE_OF_getInstance())) {
                  this.cjn_1 = this.wjm_1.n51(this.tjm_1.kjn_1.lay());
                  if (this.cjn_1 == null) {
                    this.djn_1 = null;
                    this.y9_1 = 4;
                    continue $sm;
                  } else {
                    this.y9_1 = 3;
                    suspendResult = this.wjm_1.m51(this.cjn_1.lay(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  }
                } else {
                  this.bjn_1 = emptySet();
                  this.y9_1 = 5;
                  continue $sm;
                }
              } else {
                var tmp_3 = this.xjm_1;
                if (!(tmp_3 == null) ? isInterface(tmp_3, ClassExpressionType_1) : false) {
                  var tmp_4 = this;
                  var tmp_5 = this.wjm_1.n51(this.tjm_1.kjn_1.yay());
                  tmp_4.ejn_1 = (!(tmp_5 == null) ? isInterface(tmp_5, UnionClass_1) : false) ? tmp_5 : null;
                  if (this.ejn_1 == null) {
                    this.fjn_1 = null;
                    this.y9_1 = 2;
                    continue $sm;
                  } else {
                    var tmp_6 = this;
                    tmp_6.gjn_1 = this.ejn_1;
                    this.hjn_1 = this.gjn_1;
                    var tmp_7 = this;
                    tmp_7.ijn_1 = this.hjn_1;
                    this.jjn_1 = this.ijn_1;
                    this.y9_1 = 1;
                    suspendResult = this.wjm_1.m51(getAssertedDefinitionElements_0(ontologyElementHierarchy(), this.jjn_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  }
                } else {
                  this.yjm_1 = null;
                  this.y9_1 = 8;
                  continue $sm;
                }
              }
            }

          case 1:
            this.fjn_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.yjm_1 = this.fjn_1;
            this.y9_1 = 8;
            continue $sm;
          case 3:
            this.djn_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            var tmp4_safe_receiver = this.djn_1;
            var tmp_8 = this;
            var tmp_9;
            if (tmp4_safe_receiver == null) {
              tmp_9 = null;
            } else {
              tmp_9 = setOf(tmp4_safe_receiver);
            }

            tmp_8.bjn_1 = tmp_9;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.yjm_1 = this.bjn_1;
            this.y9_1 = 8;
            continue $sm;
          case 6:
            this.ajn_1 = suspendResult;
            this.y9_1 = 7;
            continue $sm;
          case 7:
            var tmp2_safe_receiver = this.ajn_1;
            var tmp_10 = this;
            var tmp_11;
            if (tmp2_safe_receiver == null) {
              tmp_11 = null;
            } else {
              tmp_11 = setOf(tmp2_safe_receiver);
            }

            tmp_10.yjm_1 = tmp_11;
            this.y9_1 = 8;
            continue $sm;
          case 8:
            return this.yjm_1;
          case 9:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 9) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function typeElements$$inlined$suspendingQuery$1($type) {
    this.kjn_1 = $type;
  }
  protoOf(typeElements$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$50(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(typeElements$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function propertyFilterByDomainType$o$runSuspend$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(propertyFilterByDomainType$o$runSuspend$slambda).vhg = function ($this$query, it, $completion) {
    var tmp = this.whg($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(propertyFilterByDomainType$o$runSuspend$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vhg(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(propertyFilterByDomainType$o$runSuspend$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return false;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(propertyFilterByDomainType$o$runSuspend$slambda).whg = function ($this$query, it, completion) {
    var i = new propertyFilterByDomainType$o$runSuspend$slambda(completion);
    i.tjn_1 = $this$query;
    i.ujn_1 = it;
    return i;
  };
  function propertyFilterByDomainType$o$runSuspend$slambda_0(resultContinuation) {
    var i = new propertyFilterByDomainType$o$runSuspend$slambda(resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.vhg($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $runSuspendCOROUTINE$51(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.djo_1 = _this__u8e3s4;
    this.ejo_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$51).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 11;
            var tmp_0 = this;
            tmp_0.fjo_1 = this.ejo_1;
            this.gjo_1 = Unit_instance;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.hjo_1 = this.fjo_1;
            if (!(this.djo_1.qjo_1 == null) && this.djo_1.rjo_1.s(this.djo_1.qjo_1)) {
              this.gjo_1 = null;
              this.y9_1 = 12;
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.ijo_1 = this.djo_1.qjo_1;
            var tmp_1;
            var tmp_2 = this.ijo_1;
            if (!(tmp_2 == null) ? isInterface(tmp_2, OntologyElementType_1) : false) {
              tmp_1 = true;
            } else {
              var tmp_3;
              var tmp_4 = this.ijo_1;
              if (!(tmp_4 == null) ? isInterface(tmp_4, OntologyElementPropertyType_1) : false) {
                tmp_3 = true;
              } else {
                var tmp_5 = this.ijo_1;
                tmp_3 = !(tmp_5 == null) ? isInterface(tmp_5, ClassExpressionType_1) : false;
              }
              tmp_1 = tmp_3;
            }

            if (tmp_1) {
              this.y9_1 = 9;
              suspendResult = this.hjo_1.m51(typeElements(this.djo_1.qjo_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_6 = this.ijo_1;
              if (!(tmp_6 == null) ? isInterface(tmp_6, NotionType_0) : false) {
                this.y9_1 = 8;
                suspendResult = this.hjo_1.m51(this.djo_1.qjo_1.lbp(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_7 = this.ijo_1;
                if (!(tmp_7 == null) ? isInterface(tmp_7, SimplePropertyType) : false) {
                  this.y9_1 = 7;
                  suspendResult = this.hjo_1.m51(this.djo_1.qjo_1.lbp(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_8 = this.ijo_1;
                  if (!(tmp_8 == null) ? isInterface(tmp_8, ProcessType_1) : false) {
                    var tmp_9 = this;
                    var tmp_10 = Companion_instance_119;
                    tmp_9.jjo_1 = tmp_10.a76(propertyFilterByDomainType$o$runSuspend$slambda_0(null));
                    this.y9_1 = 10;
                    continue $sm;
                  } else {
                    var tmp_11 = this.ijo_1;
                    if (!(tmp_11 == null) ? isInterface(tmp_11, VariableReferenceValue_1) : false) {
                      this.y9_1 = 5;
                      suspendResult = this.hjo_1.m51(this.djo_1.qjo_1.xcq(), this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      var tmp_12 = this.ijo_1;
                      if (!(tmp_12 == null) ? isInterface(tmp_12, ProcessPropertyReference) : false) {
                        this.y9_1 = 3;
                        suspendResult = this.hjo_1.m51(this.djo_1.qjo_1.i6u(), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        this.jjo_1 = null;
                        this.y9_1 = 10;
                        continue $sm;
                      }
                    }
                  }
                }
              }
            }

          case 3:
            this.kjo_1 = suspendResult;
            this.ljo_1 = this.kjo_1 == null ? null : this.hjo_1.n51(this.kjo_1.zb3());
            this.mjo_1 = propertyFilterByDomainType(this.ljo_1, plus_9(this.djo_1.rjo_1, this.djo_1.qjo_1));
            this.y9_1 = 4;
            suspendResult = this.hjo_1.m51(this.mjo_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.jjo_1 = suspendResult;
            this.y9_1 = 10;
            continue $sm;
          case 5:
            this.njo_1 = suspendResult;
            this.ojo_1 = this.njo_1 == null ? null : this.hjo_1.n51(this.njo_1.jcq());
            this.pjo_1 = propertyFilterByDomainType(this.ojo_1, plus_9(this.djo_1.rjo_1, this.djo_1.qjo_1));
            this.y9_1 = 6;
            suspendResult = this.hjo_1.m51(this.pjo_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.jjo_1 = suspendResult;
            this.y9_1 = 10;
            continue $sm;
          case 7:
            var tmp3_safe_receiver = suspendResult;
            var tmp_13 = this;
            var tmp_14;
            if (tmp3_safe_receiver == null) {
              tmp_14 = null;
            } else {
              tmp_14 = filterObjectProperties_0(tmp3_safe_receiver);
            }

            tmp_13.jjo_1 = tmp_14;
            this.y9_1 = 10;
            continue $sm;
          case 8:
            var tmp2_safe_receiver = suspendResult;
            var tmp_15 = this;
            var tmp_16;
            if (tmp2_safe_receiver == null) {
              tmp_16 = null;
            } else {
              tmp_16 = filterObjectProperties_0(tmp2_safe_receiver);
            }

            tmp_15.jjo_1 = tmp_16;
            this.y9_1 = 10;
            continue $sm;
          case 9:
            var tmp1_safe_receiver = suspendResult;
            var tmp_17 = this;
            var tmp_18;
            if (tmp1_safe_receiver == null) {
              tmp_18 = null;
            } else {
              tmp_18 = filterObjectProperties(tmp1_safe_receiver);
            }

            tmp_17.jjo_1 = tmp_18;
            this.y9_1 = 10;
            continue $sm;
          case 10:
            this.gjo_1 = this.jjo_1;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 12;
            continue $sm;
          case 11:
            throw this.ba_1;
          case 12:
            return this.gjo_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 11) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function propertyFilterByDomainType$$inlined$suspendingQuery$1($spec, $specTrace) {
    this.qjo_1 = $spec;
    this.rjo_1 = $specTrace;
  }
  protoOf(propertyFilterByDomainType$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$51(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(propertyFilterByDomainType$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function filterObjectProperties$slambda($elements, resultContinuation) {
    this.ajp_1 = $elements;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(filterObjectProperties$slambda).vhg = function ($this$query, it, $completion) {
    var tmp = this.whg($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(filterObjectProperties$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vhg(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(filterObjectProperties$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            var tmp_0 = this;
            var tmp0 = this.bjp_1.n51(this.cjp_1.obe());
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              var tmp_1;
              if (isInterface(element, OntologyElementType_1)) {
                tmp_1 = true;
              } else {
                tmp_1 = isInterface(element, ClassExpressionType_1);
              }
              if (tmp_1) {
                destination.e(element);
              }
            }

            tmp_0.djp_1 = destination;
            this.ejp_1 = this.djp_1;
            var tmp_2 = this;
            tmp_2.fjp_1 = this.ejp_1;
            var tmp_3 = this;
            tmp_3.gjp_1 = ArrayList_init_$Create$();
            this.hjp_1 = this.fjp_1;
            this.ijp_1 = this.gjp_1;
            var tmp_4 = this;
            tmp_4.jjp_1 = this.hjp_1;
            this.kjp_1 = this.jjp_1;
            this.ljp_1 = this.kjp_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.ljp_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.mjp_1 = this.ljp_1.m();
            var tmp_5 = this;
            tmp_5.njp_1 = this.mjp_1;
            this.ojp_1 = this.njp_1;
            var tmp_6 = this;
            tmp_6.pjp_1 = this.ojp_1;
            this.qjp_1 = this.pjp_1;
            this.y9_1 = 2;
            suspendResult = this.bjp_1.m51(typeElements(this.qjp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.rjp_1 = suspendResult;
            if (this.rjp_1 == null)
              null;
            else {
              var it = this.rjp_1;
              this.ijp_1.e(it);
            }

            this.y9_1 = 1;
            continue $sm;
          case 3:
            this.sjp_1 = this.ijp_1;
            var tmp_7 = this;
            tmp_7.tjp_1 = emptySet();
            var tmp_8 = this;
            var this_0 = this.sjp_1;
            var accumulator = this.tjp_1;
            var _iterator__ex2g4s_0 = this_0.k();
            while (_iterator__ex2g4s_0.l()) {
              var element_0 = _iterator__ex2g4s_0.m();
              var p0 = accumulator;
              accumulator = plus_8(p0, element_0);
            }

            tmp_8.ujp_1 = accumulator;
            this.y9_1 = 4;
            suspendResult = this.bjp_1.m51(isSubtypeOf_0(ontologyElementHierarchy(), this.ajp_1, this.ujp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return suspendResult;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(filterObjectProperties$slambda).whg = function ($this$query, it, completion) {
    var i = new filterObjectProperties$slambda(this.ajp_1, completion);
    i.bjp_1 = $this$query;
    i.cjp_1 = it;
    return i;
  };
  function filterObjectProperties$slambda_0($elements, resultContinuation) {
    var i = new filterObjectProperties$slambda($elements, resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.vhg($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function filterInstanceRelations$slambda($elements, resultContinuation) {
    this.djq_1 = $elements;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(filterInstanceRelations$slambda).vj0 = function ($this$query, it, $completion) {
    var tmp = this.wj0($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(filterInstanceRelations$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vj0(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationDeclaration) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(filterInstanceRelations$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.gjq_1 = this.ejq_1.n51(this.fjq_1.obe());
            this.y9_1 = 1;
            suspendResult = this.ejq_1.m51(typeElements(this.gjq_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.hjq_1 = suspendResult;
            if (!(this.hjq_1 == null)) {
              this.y9_1 = 2;
              suspendResult = this.ejq_1.m51(isSubtypeOf_0(ontologyElementHierarchy(), this.djq_1, this.hjq_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.ijq_1 = false;
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            this.ijq_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            return this.ijq_1;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(filterInstanceRelations$slambda).wj0 = function ($this$query, it, completion) {
    var i = new filterInstanceRelations$slambda(this.djq_1, completion);
    i.ejq_1 = $this$query;
    i.fjq_1 = it;
    return i;
  };
  function filterInstanceRelations$slambda_0($elements, resultContinuation) {
    var i = new filterInstanceRelations$slambda($elements, resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.vj0($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function filterInstanceRelations$slambda_1($typeNotion, resultContinuation) {
    this.rjq_1 = $typeNotion;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(filterInstanceRelations$slambda_1).vj0 = function ($this$query, it, $completion) {
    var tmp = this.wj0($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(filterInstanceRelations$slambda_1).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vj0(tmp, (!(p2 == null) ? isInterface(p2, InstanceRelationDeclaration) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(filterInstanceRelations$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            var tmp_1 = this.sjq_1.n51(this.tjq_1.obe());
            tmp_0.ujq_1 = (!(tmp_1 == null) ? isInterface(tmp_1, NotionType_0) : false) ? tmp_1 : null;
            if (this.ujq_1 == null) {
              this.vjq_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.sjq_1.m51(this.ujq_1.lbp(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.vjq_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            var domainNotion = this.vjq_1;
            return equals(domainNotion, this.rjq_1);
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(filterInstanceRelations$slambda_1).wj0 = function ($this$query, it, completion) {
    var i = new filterInstanceRelations$slambda_1(this.rjq_1, completion);
    i.sjq_1 = $this$query;
    i.tjq_1 = it;
    return i;
  };
  function filterInstanceRelations$slambda_2($typeNotion, resultContinuation) {
    var i = new filterInstanceRelations$slambda_1($typeNotion, resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.vj0($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function filterObjectProperties$slambda_1($typeNotion, resultContinuation) {
    this.ejr_1 = $typeNotion;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(filterObjectProperties$slambda_1).vhg = function ($this$query, it, $completion) {
    var tmp = this.whg($this$query, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(filterObjectProperties$slambda_1).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof QueryBuilder ? p1 : THROW_CCE();
    return this.vhg(tmp, (!(p2 == null) ? isInterface(p2, ObjectPropertyDeclaration_1) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(filterObjectProperties$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            var tmp0 = this.fjr_1.n51(this.gjr_1.obe());
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              if (!(element == null) ? isInterface(element, NotionType_0) : false) {
                destination.e(element);
              }
            }

            tmp_0.hjr_1 = destination;
            this.ijr_1 = this.hjr_1;
            var tmp_1 = this;
            tmp_1.jjr_1 = this.ijr_1;
            var tmp_2 = this;
            tmp_2.kjr_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this.ijr_1, 10));
            this.ljr_1 = this.jjr_1;
            this.mjr_1 = this.kjr_1;
            this.njr_1 = this.ljr_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.njr_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.ojr_1 = this.njr_1.m();
            var tmp_3 = this;
            tmp_3.pjr_1 = this.ojr_1;
            this.qjr_1 = this.pjr_1;
            this.y9_1 = 2;
            suspendResult = this.fjr_1.m51(this.qjr_1.lbp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.mjr_1.e(ARGUMENT);
            this.y9_1 = 1;
            continue $sm;
          case 3:
            var domainNotions = this.mjr_1;
            return domainNotions.s(this.ejr_1);
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(filterObjectProperties$slambda_1).whg = function ($this$query, it, completion) {
    var i = new filterObjectProperties$slambda_1(this.ejr_1, completion);
    i.fjr_1 = $this$query;
    i.gjr_1 = it;
    return i;
  };
  function filterObjectProperties$slambda_2($typeNotion, resultContinuation) {
    var i = new filterObjectProperties$slambda_1($typeNotion, resultContinuation);
    var l = function ($this$query, it, $completion) {
      return i.vhg($this$query, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $importOntologyLibrariesCOROUTINE$40(_this__u8e3s4, libraryReferences, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ngx_1 = _this__u8e3s4;
    this.ogx_1 = libraryReferences;
  }
  protoOf($importOntologyLibrariesCOROUTINE$40).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            var tmp_0 = this;
            tmp_0.pgx_1 = this.ogx_1;
            this.qgx_1 = this.pgx_1;
            var tmp_1 = this;
            tmp_1.rgx_1 = this.qgx_1;
            var tmp_2 = this;
            tmp_2.sgx_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this.qgx_1, 10));
            this.tgx_1 = this.rgx_1;
            this.ugx_1 = this.sgx_1;
            this.vgx_1 = this.tgx_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.vgx_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.wgx_1 = this.vgx_1.m();
            var tmp_3 = this;
            tmp_3.xgx_1 = this.wgx_1;
            this.ygx_1 = this.xgx_1;
            this.y9_1 = 2;
            suspendResult = importOntologyLibrary(this.ngx_1, this.ygx_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.zgx_1 = suspendResult;
            this.ugx_1.e(this.zgx_1);
            this.y9_1 = 1;
            continue $sm;
          case 3:
            this.agy_1 = this.ugx_1;
            var tmp_4 = this;
            tmp_4.bgy_1 = new EmptyScope();
            var tmp_5 = this;
            var this_0 = this.agy_1;
            var accumulator = this.bgy_1;
            var _iterator__ex2g4s = this_0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              var p0 = accumulator;
              accumulator = new UniqueSumScope(p0, element);
            }

            tmp_5.cgy_1 = accumulator;
            this.y9_1 = 4;
            suspendResult = this.ngx_1.s7a(this.cgy_1, get_elementTypeAndTaxon(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return suspendResult;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $processPropertyElementsCOROUTINE$41(_this__u8e3s4, processProperty, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lgy_1 = _this__u8e3s4;
    this.mgy_1 = processProperty;
  }
  protoOf($processPropertyElementsCOROUTINE$41).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.lgy_1.n51(this.mgy_1.zb3());
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.lgy_1.n51(tmp0_safe_receiver.zb3());
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              return null;
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }

            tmp_0.ngy_1 = tmp_1;
            this.ogy_1 = this.ngy_1;
            var tmp_2 = this.ogy_1;
            if (isInterface(tmp_2, OntologyElementPropertyType_1)) {
              this.qgy_1 = this.lgy_1.n51(this.ngy_1.lay());
              if (this.qgy_1 == null) {
                this.rgy_1 = null;
                this.y9_1 = 4;
                continue $sm;
              } else {
                this.y9_1 = 3;
                suspendResult = this.lgy_1.m51(this.qgy_1.lay(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_3 = this.ogy_1;
              if (isInterface(tmp_3, ClassExpressionType_1)) {
                var tmp_4 = this;
                var tmp_5 = this.lgy_1.n51(this.ngy_1.yay());
                tmp_4.sgy_1 = (!(tmp_5 == null) ? isInterface(tmp_5, UnionClass_1) : false) ? tmp_5 : null;
                if (this.sgy_1 == null) {
                  this.tgy_1 = null;
                  this.y9_1 = 2;
                  continue $sm;
                } else {
                  var tmp_6 = this;
                  tmp_6.ugy_1 = this.sgy_1;
                  this.vgy_1 = this.ugy_1;
                  var tmp_7 = this;
                  tmp_7.wgy_1 = this.vgy_1;
                  this.xgy_1 = this.wgy_1;
                  this.y9_1 = 1;
                  suspendResult = this.lgy_1.m51(getAssertedDefinitionElements_0(ontologyElementHierarchy(), this.xgy_1), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                this.pgy_1 = null;
                this.y9_1 = 5;
                continue $sm;
              }
            }

          case 1:
            this.tgy_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.pgy_1 = this.tgy_1;
            this.y9_1 = 5;
            continue $sm;
          case 3:
            this.rgy_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            var tmp4_safe_receiver = this.rgy_1;
            var tmp_8 = this;
            var tmp_9;
            if (tmp4_safe_receiver == null) {
              tmp_9 = null;
            } else {
              tmp_9 = setOf(tmp4_safe_receiver);
            }

            tmp_8.pgy_1 = tmp_9;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            return this.pgy_1;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $getCustomEditorPropertiesScopeCOROUTINE$42(_this__u8e3s4, customEditor, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ggz_1 = _this__u8e3s4;
    this.hgz_1 = customEditor;
  }
  protoOf($getCustomEditorPropertiesScopeCOROUTINE$42).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            var tmp_0 = this;
            var tmp_1 = this.hgz_1.yt();
            tmp_0.igz_1 = (tmp_1 == null ? true : isInterface(tmp_1, AbstractBindingDeclaration)) ? tmp_1 : THROW_CCE();
            var tmp_2 = this.igz_1;
            if (!(tmp_2 == null) ? isInterface(tmp_2, ProcessDeclaration_1) : false) {
              this.y9_1 = 2;
              suspendResult = this.ggz_1.m51(this.igz_1.qdb(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_3 = this.igz_1;
              if (!(tmp_3 == null) ? isInterface(tmp_3, FunctionDeclaration_1) : false) {
                this.kgz_1 = this.ggz_1.n51(this.igz_1.pas());
                this.y9_1 = 1;
                suspendResult = this.ggz_1.u7a(this.kgz_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (this.igz_1 == null) {
                  var tmp_4 = this;
                  throw NullPointerException_init_$Create$_0('null parent for custom editor');
                } else {
                  var tmp_5 = this;
                  throw UnsupportedOperationException_init_$Create$_0('unknown class: ' + toString_1(getKClassFromExpression(this.igz_1)));
                }
              }
            }

          case 1:
            this.jgz_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 2:
            this.lgz_1 = suspendResult;
            this.y9_1 = 3;
            suspendResult = this.ggz_1.u7a(this.lgz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.jgz_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            return this.jgz_1;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $libraryElementsScopeCOROUTINE$43(_this__u8e3s4, librariesScopeProvider, library, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ugz_1 = _this__u8e3s4;
    this.vgz_1 = librariesScopeProvider;
    this.wgz_1 = library;
  }
  protoOf($libraryElementsScopeCOROUTINE$43).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.xgz_1 = toList_2(this.ugz_1.n51(this.vgz_1.f6z().n6z(this.wgz_1)));
            this.ygz_1 = this.xgz_1;
            var tmp_1 = this;
            tmp_1.zgz_1 = this.ygz_1;
            var tmp_2 = this;
            tmp_2.ah0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this.ygz_1, 10));
            this.bh0_1 = this.zgz_1;
            this.ch0_1 = this.ah0_1;
            this.dh0_1 = this.bh0_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.dh0_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.eh0_1 = this.dh0_1.m();
            var tmp_3 = this;
            tmp_3.fh0_1 = this.eh0_1;
            this.gh0_1 = this.fh0_1;
            this.y9_1 = 2;
            suspendResult = this.ugz_1.w7a(this.gh0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.ch0_1.e(ARGUMENT);
            this.y9_1 = 1;
            continue $sm;
          case 3:
            var ARGUMENT_0 = this.ch0_1;
            return new CompositeScope(ARGUMENT_0);
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function value$factory_9() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function aliasedProperties$factory_0() {
    return getPropertyCallableRef('aliasedProperties', 1, KProperty1, function (receiver) {
      return receiver.ac9();
    }, null);
  }
  function default$factory_0() {
    return getPropertyCallableRef('default', 1, KProperty1, function (receiver) {
      return receiver.g2o();
    }, null);
  }
  function inherited$factory_1() {
    return getPropertyCallableRef('inherited', 1, KProperty1, function (receiver) {
      return receiver.hc7();
    }, null);
  }
  function prerequisites$factory_0() {
    return getPropertyCallableRef('prerequisites', 1, KProperty1, function (receiver) {
      return receiver.ic7();
    }, null);
  }
  function effects$factory_0() {
    return getPropertyCallableRef('effects', 1, KProperty1, function (receiver) {
      return receiver.jc7();
    }, null);
  }
  function variables$factory_0() {
    return getPropertyCallableRef('variables', 1, KProperty1, function (receiver) {
      return receiver.ybc();
    }, null);
  }
  function constraints$factory_0() {
    return getPropertyCallableRef('constraints', 1, KProperty1, function (receiver) {
      return receiver.dbc();
    }, null);
  }
  function constraints$factory_1() {
    return getPropertyCallableRef('constraints', 1, KProperty1, function (receiver) {
      return receiver.dbc();
    }, null);
  }
  function constraints$factory_2() {
    return getPropertyCallableRef('constraints', 1, KProperty1, function (receiver) {
      return receiver.dbc();
    }, null);
  }
  var properties_initialized_BTBResolvers_kt_kedsbj;
  function _init_properties_BTBResolvers_kt__y423vn() {
    if (!properties_initialized_BTBResolvers_kt_kedsbj) {
      properties_initialized_BTBResolvers_kt_kedsbj = true;
      elementTypeAndTaxon = new ScopeConstraintId();
      onlyOntologyVars = new ScopeConstraintId();
      libraries = listOf_0([ProcessLibraryConcept_getInstance(), ObjectPropertiesLibraryConcept_getInstance(), LinkLibraryConcept_getInstance(), PropertyLibraryConcept_getInstance(), OntologyLibraryConcept_getInstance(), FunctionLibraryConcept_getInstance(), NotionLibraryConcept_getInstance(), ProcessKindContainerConcept_getInstance(), ExtensionLibraryConcept_getInstance(), RelationContainerConcept_getInstance(), ModifierContainerConcept_getInstance(), OntologyImportRootConcept_getInstance(), QueryParametersBlackListConcept_getInstance(), PublishedSourcesLibraryConcept_getInstance()]);
      ONTOLOGIES_WITH_SPECIES = setOf_0(['Uniprot', 'MirBase Dictionary']);
      btbLanguageWithRemoteResolve = language(btbLanguageWithRemoteResolve$lambda);
      btbLanguageWithPrecalculatedResolve = language(btbLanguageWithPrecalculatedResolve$lambda);
      btbLanguageWithLocalResolve = language(btbLanguageWithLocalResolve$lambda);
    }
  }
  function PublishedWorkReferenceResolver$resolve$$inlined$map$1($this) {
    this.rjr_1 = $this;
  }
  protoOf(PublishedWorkReferenceResolver$resolve$$inlined$map$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.query.map.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.model.resolve.PublishedWorkReferenceResolver.resolve.<anonymous>' call
    var it = builder.n51(this.rjr_1);
    return (it == null ? true : isInterface(it, PublishedWork)) ? it : THROW_CCE();
  };
  function PublishedWorkReferenceResolver(nodePointers) {
    this.sjr_1 = nodePointers;
  }
  protoOf(PublishedWorkReferenceResolver).tjr = function (source, refContent) {
    var nodePointerSupport = this.sjr_1.i6k();
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_0 = nodePointerSupport.b6k(refContent.j6t_1);
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new PublishedWorkReferenceResolver$resolve$$inlined$map$1(this_0);
  };
  protoOf(PublishedWorkReferenceResolver).a6u = function (source, refContent) {
    var tmp = isInterface(source, PublishedSourceReference_1) ? source : THROW_CCE();
    return this.tjr(tmp, refContent instanceof QualifiedReferenceContent ? refContent : THROW_CCE());
  };
  function PublishedWorkReferenceTargetPresentationProvider() {
  }
  protoOf(PublishedWorkReferenceTargetPresentationProvider).ujr = function (target) {
    return target.dcu();
  };
  protoOf(PublishedWorkReferenceTargetPresentationProvider).o6u = function (target) {
    return this.ujr(isInterface(target, PublishedWork) ? target : THROW_CCE());
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda($$this$unsafeFlow, this$0, resultContinuation) {
    this.djs_1 = $$this$unsafeFlow;
    this.ejs_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.gjs_1 = this.djs_1;
            var tmp_1 = this;
            tmp_1.hjs_1 = this.fjs_1;
            this.ijs_1 = this.gjs_1;
            this.jjs_1 = this.hjs_1;
            this.y9_1 = 1;
            var it = this.jjs_1;
            suspendResult = this.ijs_1.d1f(targetItem(it, this.ejs_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda).a1u = function (value, completion) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda(this.djs_1, this.ejs_1, completion);
    i.fjs_1 = value;
    return i;
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_0($$this$unsafeFlow, this$0, resultContinuation) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda($$this$unsafeFlow, this$0, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$53(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.sjs_1 = _this__u8e3s4;
    this.tjs_1 = collector;
  }
  protoOf($collectCOROUTINE$53).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.ujs_1 = this.tjs_1;
            this.vjs_1 = this.ujs_1;
            this.y9_1 = 1;
            var tmp_1 = PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_0(this.vjs_1, this.sjs_1.xjs_1, null);
            suspendResult = this.sjs_1.wjs_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_12(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1($$this$unsafeFlow, resultContinuation) {
    this.gjt_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            var tmp_0 = this;
            tmp_0.ijt_1 = this.gjt_1;
            var tmp_1 = this;
            tmp_1.jjt_1 = this.hjt_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.ljt_1 = this.ijt_1;
            this.mjt_1 = this.jjt_1;
            var this_0 = this.mjt_1.d6u_1;
            if (!isBlank(this_0)) {
              this.y9_1 = 3;
              suspendResult = this.ljt_1.d1f(this.mjt_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 4;
            continue $sm;
          case 3:
            this.kjt_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1).a1u = function (value, completion) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1(this.gjt_1, completion);
    i.hjt_1 = value;
    return i;
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_2($$this$unsafeFlow, resultContinuation) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_1($$this$unsafeFlow, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$54(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vjt_1 = _this__u8e3s4;
    this.wjt_1 = collector;
  }
  protoOf($collectCOROUTINE$54).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.xjt_1 = this.wjt_1;
            this.yjt_1 = this.xjt_1;
            this.y9_1 = 1;
            var tmp_1 = PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$o$collect$slambda_2(this.yjt_1, null);
            suspendResult = this.vjt_1.zjt_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_12(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda($$this$suspendingQuery, resultContinuation) {
    this.iju_1 = $$this$suspendingQuery;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).kju = function (it, $completion) {
    var tmp = this.lju(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).oa = function (p1, $completion) {
    return this.kju((!(p1 == null) ? isInterface(p1, PublishedSourcesLibrary_1) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var tmp0 = this.iju_1.n51(this.jju_1.cq());
          var destination = ArrayList_init_$Create$();
          var _iterator__ex2g4s = tmp0.k();
          while (_iterator__ex2g4s.l()) {
            var element = _iterator__ex2g4s.m();
            if (!(element == null) ? isInterface(element, PublishedWork) : false) {
              destination.e(element);
            }
          }
          return asFlow(destination);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda).lju = function (it, completion) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda(this.iju_1, completion);
    i.jju_1 = it;
    return i;
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_0($$this$suspendingQuery, resultContinuation) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda($$this$suspendingQuery, resultContinuation);
    var l = function (it, $completion) {
      return i.kju(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1$runSuspend$3($this, this$0) {
    this.wjs_1 = $this;
    this.xjs_1 = this$0;
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1$runSuspend$3).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$53(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1$runSuspend$3).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1$runSuspend$4($this) {
    this.zjt_1 = $this;
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1$runSuspend$4).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$54(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1$runSuspend$4).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1($this_channelFlow, resultContinuation) {
    this.uju_1 = $this_channelFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).wju = function (it, $completion) {
    var tmp = this.xju(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).oa = function (p1, $completion) {
    return this.wju(p1 instanceof ReferenceTargetItem ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.uju_1.y15().z1b(this.vju_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1).xju = function (it, completion) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1(this.uju_1, completion);
    i.vju_1 = it;
    return i;
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_2($this_channelFlow, resultContinuation) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_1($this_channelFlow, resultContinuation);
    var l = function (it, $completion) {
      return i.wju(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $runSuspendCOROUTINE$52(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gjv_1 = _this__u8e3s4;
    this.hjv_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$52).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.ijv_1 = this.hjv_1;
            this.jjv_1 = this.ijv_1;
            this.y9_1 = 1;
            var tmp_1 = asFlow_0(this.jjv_1.n51(this.gjv_1.ljv_1.kjv_1.f6z().n6z(PublishedSourcesLibraryConcept_getInstance())));
            var this_0 = flatMapConcat(tmp_1, PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_0(this.jjv_1, null));
            var this_1 = new PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1$runSuspend$3(this_0, this.gjv_1.ljv_1);
            var tmp_2 = new PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1$runSuspend$4(this_1);
            var tmp_3 = PublishedWorkReferenceTargetsSupplier$getElements$slambda$o$runSuspend$slambda_2(this.gjv_1.mjv_1, null);
            suspendResult = tmp_2.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_12(tmp_3), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1(this$0, $this_channelFlow) {
    this.ljv_1 = this$0;
    this.mjv_1 = $this_channelFlow;
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$52(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function targetItem(_this__u8e3s4, $this) {
    return new ReferenceTargetItem(new QualifiedReferenceContent(ensureNotNull(get_pointer(_this__u8e3s4))), execute_0(_this__u8e3s4.dcu()));
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_12(function_0) {
    this.njv_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_12).d1f = function (value, $completion) {
    return this.njv_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_12).b4 = function () {
    return this.njv_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_12).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_12).hashCode = function () {
    return hashCode(this.b4());
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda(this$0, resultContinuation) {
    this.wjv_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda).yjv = function ($this$channelFlow, $completion) {
    var tmp = this.zjv($this$channelFlow, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda).oa = function (p1, $completion) {
    return this.yjv((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = execute_1(new PublishedWorkReferenceTargetsSupplier$getElements$1$$inlined$suspendingQuery$1(this.wjv_1, this.xjv_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(PublishedWorkReferenceTargetsSupplier$getElements$slambda).zjv = function ($this$channelFlow, completion) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda(this.wjv_1, completion);
    i.xjv_1 = $this$channelFlow;
    return i;
  };
  function PublishedWorkReferenceTargetsSupplier$getElements$slambda_0(this$0, resultContinuation) {
    var i = new PublishedWorkReferenceTargetsSupplier$getElements$slambda(this$0, resultContinuation);
    var l = function ($this$channelFlow, $completion) {
      return i.yjv($this$channelFlow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function PublishedWorkReferenceTargetsSupplier(libraryScopeProvider) {
    this.kjv_1 = libraryScopeProvider;
  }
  protoOf(PublishedWorkReferenceTargetsSupplier).ajw = function (context, filter) {
    return channelFlow(PublishedWorkReferenceTargetsSupplier$getElements$slambda_0(this, null));
  };
  protoOf(PublishedWorkReferenceTargetsSupplier).g6u = function (context, filter) {
    return this.ajw(context, filter);
  };
  function SubtypeScopeFilter(supertypeElements) {
    this.bjw_1 = supertypeElements;
    this.cjw_1 = ontologyElementHierarchy();
  }
  protoOf(SubtypeScopeFilter).djw = function (target) {
    return isSubtypeOf_0(this.cjw_1, listOf(target), this.bjw_1);
  };
  protoOf(SubtypeScopeFilter).a74 = function (target) {
    return this.djw(isInterface(target, OntologyElement_1) ? target : THROW_CCE());
  };
  function SubtypeScopeFilterService$Companion$default$1() {
  }
  protoOf(SubtypeScopeFilterService$Companion$default$1).fhm = function (elements) {
    return new SubtypeScopeFilter(elements);
  };
  function Companion_225() {
    Companion_instance_225 = this;
    var tmp = this;
    tmp.ejw_1 = new SubtypeScopeFilterService$Companion$default$1();
  }
  protoOf(Companion_225).g2o = function () {
    return this.ejw_1;
  };
  var Companion_instance_225;
  function Companion_getInstance_225() {
    if (Companion_instance_225 == null)
      new Companion_225();
    return Companion_instance_225;
  }
  function SubtypeScopeFilterService() {
  }
  function $runSuspendCOROUTINE$55(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.njw_1 = _this__u8e3s4;
    this.ojw_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$55).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 8;
            var tmp_0 = this;
            tmp_0.pjw_1 = this.ojw_1;
            this.qjw_1 = Unit_instance;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.rjw_1 = this.pjw_1;
            this.y9_1 = 2;
            suspendResult = this.rjw_1.m51(this.njw_1.wjw_1.od6(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.sjw_1 = suspendResult;
            if (this.sjw_1.p()) {
              this.qjw_1 = true;
              this.y9_1 = 7;
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            this.tjw_1 = toAdapter(this.sjw_1);
            this.ujw_1 = toAdapter_0(this.njw_1.xjw_1.yjw_1);
            this.y9_1 = 4;
            suspendResult = this.rjw_1.m51(this.njw_1.xjw_1.zjw_1.ajx(this.tjw_1, this.ujw_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            if (suspendResult) {
              this.vjw_1 = true;
              this.y9_1 = 6;
              continue $sm;
            } else {
              this.y9_1 = 5;
              suspendResult = this.rjw_1.m51(this.njw_1.xjw_1.zjw_1.ajx(this.ujw_1, this.tjw_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 5:
            this.vjw_1 = suspendResult;
            this.y9_1 = 6;
            continue $sm;
          case 6:
            this.qjw_1 = this.vjw_1;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 7;
            continue $sm;
          case 7:
            return this.qjw_1;
          case 8:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 8) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function TaxonScopeFilter$apply$$inlined$suspendingQuery$1($target, this$0) {
    this.wjw_1 = $target;
    this.xjw_1 = this$0;
  }
  protoOf(TaxonScopeFilter$apply$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$55(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(TaxonScopeFilter$apply$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function TaxonScopeFilter(taxon) {
    this.yjw_1 = taxon;
    this.zjw_1 = ontologyElementHierarchy();
  }
  protoOf(TaxonScopeFilter).djw = function (target) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new TaxonScopeFilter$apply$$inlined$suspendingQuery$1(target, this);
  };
  protoOf(TaxonScopeFilter).a74 = function (target) {
    return this.djw(isInterface(target, OntologyElement_1) ? target : THROW_CCE());
  };
  function sam$jetbrains_biokb_lang_model_resolve_TaxonScopeFilterService$0(function_0) {
    this.bjx_1 = function_0;
  }
  protoOf(sam$jetbrains_biokb_lang_model_resolve_TaxonScopeFilterService$0).bh5 = function (element) {
    return this.bjx_1(element);
  };
  protoOf(sam$jetbrains_biokb_lang_model_resolve_TaxonScopeFilterService$0).b4 = function () {
    return this.bjx_1;
  };
  protoOf(sam$jetbrains_biokb_lang_model_resolve_TaxonScopeFilterService$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, TaxonScopeFilterService) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_biokb_lang_model_resolve_TaxonScopeFilterService$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function TaxonScopeFilterService$Companion$default$lambda(it) {
    return new TaxonScopeFilter(it);
  }
  function Companion_226() {
    Companion_instance_226 = this;
    var tmp = this;
    var tmp_0 = TaxonScopeFilterService$Companion$default$lambda;
    tmp.cjx_1 = new sam$jetbrains_biokb_lang_model_resolve_TaxonScopeFilterService$0(tmp_0);
  }
  protoOf(Companion_226).g2o = function () {
    return this.cjx_1;
  };
  var Companion_instance_226;
  function Companion_getInstance_226() {
    if (Companion_instance_226 == null)
      new Companion_226();
    return Companion_instance_226;
  }
  function TaxonScopeFilterService() {
  }
  function LinkStub() {
  }
  function NotionStub() {
  }
  function PropertyStub() {
  }
  function get_noopTraverseCycleHandler() {
    _init_properties_GraphByClosure_kt__tlbrze();
    return noopTraverseCycleHandler;
  }
  var noopTraverseCycleHandler;
  var noopReachableCycleHandler;
  function getFrames($this) {
    return asSequence_2(new TraversalContext$getFrames$1($this));
  }
  function TraversalContext$pathNodesAndEdges$delegate$lambda$lambda(it) {
    return to(it.hgp_1, it.gjx_1);
  }
  function TraversalContext$pathNodesAndEdges$delegate$lambda(this$0) {
    return function () {
      var tmp = getFrames(this$0);
      return reversed(toList_2(map(tmp, TraversalContext$pathNodesAndEdges$delegate$lambda$lambda)));
    };
  }
  function TraversalContext$pathNodes$delegate$lambda$lambda(it) {
    return it.hgp_1;
  }
  function TraversalContext$pathNodes$delegate$lambda(this$0) {
    return function () {
      var tmp = getFrames(this$0);
      return reversed(toList_2(map(tmp, TraversalContext$pathNodes$delegate$lambda$lambda)));
    };
  }
  function TraversalContext$getFrames$1(this$0) {
    this.hjx_1 = this$0.fgn_1.igp_1;
  }
  protoOf(TraversalContext$getFrames$1).l = function () {
    return !(this.hjx_1 == null);
  };
  protoOf(TraversalContext$getFrames$1).m = function () {
    if (this.hjx_1 == null) {
      throw NoSuchElementException_init_$Create$();
    }
    var result = ensureNotNull(this.hjx_1);
    this.hjx_1 = result.igp_1;
    return result;
  };
  function TraversalContext(frame) {
    this.fgn_1 = frame;
    this.ggn_1 = false;
    var tmp = this;
    tmp.hgn_1 = lazy_0(TraversalContext$pathNodesAndEdges$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.ign_1 = lazy_0(TraversalContext$pathNodes$delegate$lambda(this));
  }
  protoOf(TraversalContext).kgp = function () {
    return this.ggn_1;
  };
  protoOf(TraversalContext).y8c = function () {
    return this.fgn_1.hgp_1;
  };
  protoOf(TraversalContext).jgp = function (node) {
    var tmp0 = getFrames(this);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.biokb.lang.model.util.TraversalContext.pathContains.<anonymous>' call
        if (equals(element.hgp_1, node)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  protoOf(TraversalContext).jgn = function () {
    var tmp0 = this.ign_1;
    // Inline function 'kotlin.getValue' call
    pathNodes$factory();
    return tmp0.y();
  };
  function Frame_0(node, prevFrame) {
    this.hgp_1 = node;
    this.igp_1 = prevFrame;
  }
  function PostProcessChildNodeFrame(node, prevFrame, edges, edge) {
    Frame_0.call(this, node, prevFrame);
    this.fjx_1 = edges;
    this.gjx_1 = edge;
  }
  function PreProcessNodeFrame(node, prevFrame) {
    Frame_0.call(this, node, prevFrame);
  }
  function isNoop(_this__u8e3s4) {
    _init_properties_GraphByClosure_kt__tlbrze();
    return equals(_this__u8e3s4, get_noopTraverseCycleHandler());
  }
  function createChildProcessingFrame(_this__u8e3s4, edges) {
    _init_properties_GraphByClosure_kt__tlbrze();
    return createChildProcessingFrame_0(_this__u8e3s4.hgp_1, _this__u8e3s4.igp_1, edges);
  }
  function createNextChildProcessingFrame(_this__u8e3s4) {
    _init_properties_GraphByClosure_kt__tlbrze();
    return createChildProcessingFrame_0(_this__u8e3s4.hgp_1, _this__u8e3s4.igp_1, _this__u8e3s4.fjx_1);
  }
  function PostProcessNodeFrame(node, prevFrame) {
    Frame_0.call(this, node, prevFrame);
  }
  function createChildProcessingFrame_0(node, prevFrame, edges) {
    _init_properties_GraphByClosure_kt__tlbrze();
    var tmp;
    if (edges.l()) {
      var _destruct__k2r9zo = edges.m();
      var nextNode = _destruct__k2r9zo.ug();
      var nextEdge = _destruct__k2r9zo.vg();
      var postChildNodeFrame = new PostProcessChildNodeFrame(node, prevFrame, edges, nextEdge);
      tmp = new PreProcessNodeFrame(nextNode, postChildNodeFrame);
    } else {
      tmp = new PostProcessNodeFrame(node, prevFrame);
    }
    return tmp;
  }
  function noopTraverseCycleHandler$lambda(_this__u8e3s4) {
    _init_properties_GraphByClosure_kt__tlbrze();
    return Unit_instance;
  }
  function noopReachableCycleHandler$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0) {
    _init_properties_GraphByClosure_kt__tlbrze();
    return Unit_instance;
  }
  function pathNodes$factory() {
    return getPropertyCallableRef('pathNodes', 1, KProperty1, function (receiver) {
      return receiver.jgn();
    }, null);
  }
  var properties_initialized_GraphByClosure_kt_8c6fzs;
  function _init_properties_GraphByClosure_kt__tlbrze() {
    if (!properties_initialized_GraphByClosure_kt_8c6fzs) {
      properties_initialized_GraphByClosure_kt_8c6fzs = true;
      noopTraverseCycleHandler = noopTraverseCycleHandler$lambda;
      noopReachableCycleHandler = noopReachableCycleHandler$lambda;
    }
  }
  function $runSuspendCOROUTINE$62(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qjx_1 = _this__u8e3s4;
    this.rjx_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$62).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 14;
            var tmp_0 = this;
            tmp_0.sjx_1 = this.rjx_1;
            this.tjx_1 = Unit_instance;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.ujx_1 = this.sjx_1;
            if (equals(this.qjx_1.ejy_1, this.qjx_1.fjy_1)) {
              this.tjx_1 = true;
              this.y9_1 = 13;
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.y9_1 = 3;
            suspendResult = getAllNaturalDefinitions(this.ujx_1, this.qjx_1.gjy_1, this.qjx_1.ejy_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.vjx_1 = suspendResult;
            this.y9_1 = 4;
            suspendResult = getAllNaturalDefinitions(this.ujx_1, this.qjx_1.gjy_1, this.qjx_1.fjy_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.wjx_1 = suspendResult;
            if (this.vjx_1.p() || this.wjx_1.p()) {
              this.tjx_1 = false;
              this.y9_1 = 13;
              continue $sm;
            } else {
              this.y9_1 = 5;
              continue $sm;
            }

          case 5:
            var tmp_1 = this;
            tmp_1.xjx_1 = this.vjx_1;
            this.y9_1 = 6;
            continue $sm;
          case 6:
            this.zjx_1 = this.xjx_1;
            var tmp_2;
            var tmp_3 = this.zjx_1;
            if (isInterface(tmp_3, Collection)) {
              tmp_2 = this.zjx_1.p();
            } else {
              tmp_2 = false;
            }

            if (tmp_2) {
              this.yjx_1 = true;
              this.y9_1 = 12;
              continue $sm;
            } else {
              this.y9_1 = 7;
              continue $sm;
            }

          case 7:
            this.ajy_1 = this.zjx_1.k();
            this.y9_1 = 8;
            continue $sm;
          case 8:
            if (!this.ajy_1.l()) {
              this.y9_1 = 11;
              continue $sm;
            }

            this.bjy_1 = this.ajy_1.m();
            var tmp_4 = this;
            tmp_4.cjy_1 = this.bjy_1;
            this.djy_1 = this.cjy_1;
            this.y9_1 = 9;
            suspendResult = getAllSuperElements(this.ujx_1, this.qjx_1.gjy_1, this.djy_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            var allSuperElements = suspendResult;
            var tmp0 = this.wjx_1;
            var tmp$ret$4;
            l$ret$5: do {
              var tmp_5;
              if (isInterface(tmp0, Collection)) {
                tmp_5 = tmp0.p();
              } else {
                tmp_5 = false;
              }
              if (tmp_5) {
                tmp$ret$4 = false;
                break l$ret$5;
              }
              var _iterator__ex2g4s = tmp0.k();
              while (_iterator__ex2g4s.l()) {
                var element = _iterator__ex2g4s.m();
                if (allSuperElements.s(element)) {
                  tmp$ret$4 = true;
                  break l$ret$5;
                }
              }
              tmp$ret$4 = false;
            }
             while (false);
            var ARGUMENT = tmp$ret$4;
            if (!ARGUMENT) {
              this.yjx_1 = false;
              this.y9_1 = 12;
              continue $sm;
            } else {
              this.y9_1 = 10;
              continue $sm;
            }

          case 10:
            this.y9_1 = 8;
            continue $sm;
          case 11:
            this.yjx_1 = true;
            if (false) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.y9_1 = 12;
            continue $sm;
          case 12:
            this.tjx_1 = this.yjx_1;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 13;
            continue $sm;
          case 13:
            return this.tjx_1;
          case 14:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 14) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$63(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pjy_1 = _this__u8e3s4;
    this.qjy_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$63).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.rjy_1 = this.qjy_1;
            this.sjy_1 = this.rjy_1;
            this.tjy_1 = this.pjy_1.vjy_1;
            var tmp_1 = this.tjy_1;
            if (isInterface(tmp_1, AbstractUnion)) {
              this.ujy_1 = false;
              this.y9_1 = 3;
              continue $sm;
            } else {
              var tmp_2 = this.tjy_1;
              if (isInterface(tmp_2, AbstractOntologyElement)) {
                this.y9_1 = 1;
                suspendResult = getAssertedDefinitionElements(this.sjy_1, this.pjy_1.wjy_1, this.pjy_1.vjy_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_3 = this;
                noWhenBranchMatchedException();
              }
            }

            break;
          case 1:
            var ARGUMENT = suspendResult;
            this.ujy_1 = ARGUMENT.p();
            this.y9_1 = 3;
            continue $sm;
          case 2:
            throw this.ba_1;
          case 3:
            return this.ujy_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$64(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fjz_1 = _this__u8e3s4;
    this.gjz_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$64).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.hjz_1 = this.gjz_1;
            this.ijz_1 = this.hjz_1;
            this.y9_1 = 1;
            suspendResult = getAssertedDefinitionElements(this.ijz_1, this.fjz_1.jjz_1, this.fjz_1.kjz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $runSuspendCOROUTINE$65(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tjz_1 = _this__u8e3s4;
    this.ujz_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$65).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.vjz_1 = this.ujz_1;
            this.wjz_1 = this.vjz_1;
            this.y9_1 = 1;
            suspendResult = getAllNaturalDefinitions(this.wjz_1, this.tjz_1.xjz_1, this.tjz_1.yjz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function getAssertedDefinitionElements(_this__u8e3s4, $this, classDeclaration, $completion) {
    var tmp = new $getAssertedDefinitionElementsCOROUTINE$56($this, _this__u8e3s4, classDeclaration, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function calculateElementsToAllNaturalDefinitions(_this__u8e3s4, $this, classDeclaration, $completion) {
    var tmp = new $calculateElementsToAllNaturalDefinitionsCOROUTINE$57($this, _this__u8e3s4, classDeclaration, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function getAllNaturalDefinitions(_this__u8e3s4, $this, classDeclaration, $completion) {
    var tmp = new $getAllNaturalDefinitionsCOROUTINE$58($this, _this__u8e3s4, classDeclaration, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function getAssertedSuperElements(_this__u8e3s4, $this, ontologyElement, $completion) {
    var tmp = new $getAssertedSuperElementsCOROUTINE$59($this, _this__u8e3s4, ontologyElement, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function calculateElementToAllSuperElements(_this__u8e3s4, $this, element, $completion) {
    var tmp = new $calculateElementToAllSuperElementsCOROUTINE$60($this, _this__u8e3s4, element, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function getAllSuperElements(_this__u8e3s4, $this, ontologyElement, $completion) {
    var tmp = new $getAllSuperElementsCOROUTINE$61($this, _this__u8e3s4, ontologyElement, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function Companion_227() {
    Companion_instance_227 = this;
    this.qk6_1 = getLogger(getKClass(OntologyHierarchyImpl));
  }
  var Companion_instance_227;
  function Companion_getInstance_227() {
    if (Companion_instance_227 == null)
      new Companion_227();
    return Companion_instance_227;
  }
  function OntologyHierarchyImpl$_init_$lambda_svs6xx(path) {
    Companion_getInstance_227().qk6_1.do('There is a cycle in ontology: ' + toString_1(path));
    return Unit_instance;
  }
  function OntologyHierarchyImpl$isSubtypeOf$$inlined$suspendingQuery$1($one, $other, this$0) {
    this.ejy_1 = $one;
    this.fjy_1 = $other;
    this.gjy_1 = this$0;
  }
  protoOf(OntologyHierarchyImpl$isSubtypeOf$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$62(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyHierarchyImpl$isSubtypeOf$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyHierarchyImpl$isNatural$$inlined$suspendingQuery$1($element, this$0) {
    this.vjy_1 = $element;
    this.wjy_1 = this$0;
  }
  protoOf(OntologyHierarchyImpl$isNatural$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$63(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyHierarchyImpl$isNatural$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyHierarchyImpl$getAssertedDefinitionElements$$inlined$suspendingQuery$1(this$0, $classDeclaration) {
    this.jjz_1 = this$0;
    this.kjz_1 = $classDeclaration;
  }
  protoOf(OntologyHierarchyImpl$getAssertedDefinitionElements$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$64(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyHierarchyImpl$getAssertedDefinitionElements$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyHierarchyImpl$getAllNaturalDefinitionElements$$inlined$suspendingQuery$1(this$0, $classDeclaration) {
    this.xjz_1 = this$0;
    this.yjz_1 = $classDeclaration;
  }
  protoOf(OntologyHierarchyImpl$getAllNaturalDefinitionElements$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$65(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyHierarchyImpl$getAllNaturalDefinitionElements$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyHierarchyImpl$getAssertedDefinitionElements$lambda(this$0) {
    return function ($this$traverseDepthFirst) {
      // Inline function 'kotlin.collections.filterIsInstance' call
      var tmp0 = plus_3($this$traverseDepthFirst.jgn(), $this$traverseDepthFirst.y8c());
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        if (!(element == null) ? isInterface(element, AbstractOntologyElement) : false) {
          destination.e(element);
        }
      }
      this$0.qgr_1(destination);
      return Unit_instance;
    };
  }
  function OntologyHierarchyImpl$getAssertedDefinitionElements$lambda_0(it) {
    return !(it == null) ? isInterface(it, AbstractOntologyElement) : false;
  }
  function OntologyHierarchyImpl$calculateElementsToAllNaturalDefinitions$lambda($isValid, this$0) {
    return function ($this$traverseDepthFirst) {
      $isValid._v = false;
      // Inline function 'kotlin.collections.filterIsInstance' call
      var tmp0 = plus_3($this$traverseDepthFirst.jgn(), $this$traverseDepthFirst.y8c());
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        if (!(element == null) ? isInterface(element, AbstractOntologyElement) : false) {
          destination.e(element);
        }
      }
      this$0.qgr_1(destination);
      return Unit_instance;
    };
  }
  function OntologyHierarchyImpl$calculateElementToAllSuperElements$lambda($isValid, this$0) {
    return function ($this$traverseDepthFirst) {
      $isValid._v = false;
      this$0.qgr_1(plus_3($this$traverseDepthFirst.jgn(), $this$traverseDepthFirst.y8c()));
      return Unit_instance;
    };
  }
  function $getAssertedDefinitionElementsCOROUTINE$56(_this__u8e3s4, _this__u8e3s4_0, classDeclaration, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hk0_1 = _this__u8e3s4;
    this.ik0_1 = _this__u8e3s4_0;
    this.jk0_1 = classDeclaration;
  }
  protoOf($getAssertedDefinitionElementsCOROUTINE$56).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 17;
            var tmp_0 = this;
            tmp_0.kk0_1 = this.hk0_1.rgr_1;
            var tmp_1 = this;
            tmp_1.lk0_1 = this.jk0_1;
            this.mk0_1 = this.kk0_1;
            this.nk0_1 = this.lk0_1;
            this.ok0_1 = this.mk0_1.y2(this.nk0_1);
            if (this.ok0_1 == null) {
              this.qk0_1 = Unit_instance;
              this.y9_1 = 1;
              continue $sm;
            } else {
              var tmp_2 = this;
              tmp_2.pk0_1 = this.ok0_1;
              this.y9_1 = 16;
              continue $sm;
            }

          case 1:
            this.rk0_1 = this.jk0_1;
            var tmp_3 = this.rk0_1;
            if (isInterface(tmp_3, AbstractOntologyElement)) {
              this.y9_1 = 2;
              suspendResult = this.ik0_1.m51(this.jk0_1.nbu(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_4 = this.rk0_1;
              if (isInterface(tmp_4, AbstractUnion)) {
                this.sk0_1 = this.jk0_1;
                this.y9_1 = 3;
                continue $sm;
              } else {
                var tmp_5 = this;
                noWhenBranchMatchedException();
              }
            }

            break;
          case 2:
            this.sk0_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.tk0_1 = this.sk0_1;
            if (this.tk0_1 == null) {
              this.qk0_1 = emptySet();
              this.y9_1 = 15;
              var tmp_6 = this;
              continue $sm;
            } else {
              this.uk0_1 = this.tk0_1;
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            this.vk0_1 = this.uk0_1;
            var tmp_7 = this;
            tmp_7.wk0_1 = this.vk0_1;
            var tmp_8 = this;
            tmp_8.xk0_1 = OntologyHierarchyImpl$getAssertedDefinitionElements$lambda(this.hk0_1);
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.zk0_1 = this.wk0_1;
            this.ak1_1 = this.xk0_1;
            this.bk1_1 = new PreProcessNodeFrame(this.zk0_1, null);
            this.ck1_1 = HashSet_init_$Create$();
            this.y9_1 = 6;
            continue $sm;
          case 6:
            if (!!(this.bk1_1 == null)) {
              this.y9_1 = 13;
              continue $sm;
            }

            this.dk1_1 = new TraversalContext(this.bk1_1);
            this.ek1_1 = this.bk1_1;
            var tmp_9 = this.ek1_1;
            if (tmp_9 instanceof PreProcessNodeFrame) {
              if (this.ck1_1.s(this.dk1_1.y8c())) {
                var tmp_10 = this;
                if (!isNoop(this.ak1_1) && this.dk1_1.jgp(this.dk1_1.y8c())) {
                  this.ak1_1(this.dk1_1);
                }
                tmp_10.gk1_1 = this.bk1_1.igp_1;
                this.y9_1 = 10;
                continue $sm;
              } else {
                this.dk1_1;
                var tmp0 = this.ck1_1;
                var element = this.dk1_1.y8c();
                tmp0.e(element);
                var tmp_11 = this;
                tmp_11.ik1_1 = this.dk1_1.y8c();
                this.jk1_1 = this.ik1_1;
                this.kk1_1 = this.jk1_1;
                var tmp_12 = this.kk1_1;
                if (isInterface(tmp_12, AbstractOntologyElement)) {
                  this.lk1_1 = emptyList();
                  this.y9_1 = 8;
                  continue $sm;
                } else {
                  var tmp_13 = this.kk1_1;
                  if (isInterface(tmp_13, AbstractUnion)) {
                    this.y9_1 = 7;
                    suspendResult = this.ik0_1.m51(this.jk1_1.tco(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    var tmp_14 = this;
                    noWhenBranchMatchedException();
                  }
                }
              }
            } else {
              var tmp_15 = this.ek1_1;
              if (tmp_15 instanceof PostProcessChildNodeFrame) {
                this.fk1_1 = createNextChildProcessingFrame(this.bk1_1);
                this.y9_1 = 11;
                continue $sm;
              } else {
                var tmp_16 = this.ek1_1;
                if (tmp_16 instanceof PostProcessNodeFrame) {
                  var tmp_17 = this;
                  this.dk1_1;
                  tmp_17.fk1_1 = this.bk1_1.igp_1;
                  this.y9_1 = 11;
                  continue $sm;
                } else {
                  var tmp_18 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 7:
            var tmp_19 = this;
            var this_0 = suspendResult;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.k();
            while (_iterator__ex2g4s.l()) {
              var item = _iterator__ex2g4s.m();
              destination.e(to(item, Unit_instance));
            }

            tmp_19.lk1_1 = destination;
            this.y9_1 = 8;
            continue $sm;
          case 8:
            this.hk1_1 = this.lk1_1;
            this.y9_1 = 9;
            continue $sm;
          case 9:
            var edges = this.hk1_1;
            this.gk1_1 = createChildProcessingFrame(this.bk1_1, edges.k());
            this.y9_1 = 10;
            continue $sm;
          case 10:
            this.fk1_1 = this.gk1_1;
            this.y9_1 = 11;
            continue $sm;
          case 11:
            this.bk1_1 = this.fk1_1;
            if (this.dk1_1.kgp()) {
              this.yk0_1 = null;
              this.y9_1 = 14;
              continue $sm;
            } else {
              this.y9_1 = 12;
              continue $sm;
            }

          case 12:
            this.y9_1 = 6;
            continue $sm;
          case 13:
            this.yk0_1 = this.ck1_1;
            if (false) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.y9_1 = 14;
            continue $sm;
          case 14:
            var tmp0_elvis_lhs = this.yk0_1;
            var ARGUMENT = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
            var this_1 = asSequence_0(ARGUMENT);
            var tmp_20 = filter(this_1, OntologyHierarchyImpl$getAssertedDefinitionElements$lambda_0);
            var ARGUMENT_0 = isInterface(tmp_20, Sequence) ? tmp_20 : THROW_CCE();
            this.qk0_1 = toSet_1(ARGUMENT_0);
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 15;
            continue $sm;
          case 15:
            var answer = this.qk0_1;
            this.mk0_1.r2(this.nk0_1, answer);
            this.pk0_1 = answer;
            this.y9_1 = 16;
            continue $sm;
          case 16:
            return this.pk0_1;
          case 17:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 17) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $calculateElementsToAllNaturalDefinitionsCOROUTINE$57(_this__u8e3s4, _this__u8e3s4_0, classDeclaration, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.uk1_1 = _this__u8e3s4;
    this.vk1_1 = _this__u8e3s4_0;
    this.wk1_1 = classDeclaration;
  }
  protoOf($calculateElementsToAllNaturalDefinitionsCOROUTINE$57).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 13;
            this.xk1_1 = HashMap_init_$Create$();
            this.yk1_1 = {_v: true};
            var tmp_0 = this;
            tmp_0.zk1_1 = this.wk1_1;
            var tmp_1 = this;
            tmp_1.ak2_1 = OntologyHierarchyImpl$calculateElementsToAllNaturalDefinitions$lambda(this.yk1_1, this.uk1_1);
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.ck2_1 = this.zk1_1;
            this.dk2_1 = this.ak2_1;
            this.ek2_1 = new PreProcessNodeFrame(this.ck2_1, null);
            this.fk2_1 = HashSet_init_$Create$();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!!(this.ek2_1 == null)) {
              this.y9_1 = 11;
              continue $sm;
            }

            this.gk2_1 = new TraversalContext(this.ek2_1);
            this.hk2_1 = this.ek2_1;
            var tmp_2 = this.hk2_1;
            if (tmp_2 instanceof PreProcessNodeFrame) {
              if (this.fk2_1.s(this.gk2_1.y8c())) {
                var tmp_3 = this;
                if (!isNoop(this.dk2_1) && this.gk2_1.jgp(this.gk2_1.y8c())) {
                  this.dk2_1(this.gk2_1);
                }
                tmp_3.jk2_1 = this.ek2_1.igp_1;
                this.y9_1 = 8;
                continue $sm;
              } else {
                var $this$traverseDepthFirst = this.gk2_1;
                var tmp_4;
                var tmp0 = this.uk1_1.sgr_1;
                var key = $this$traverseDepthFirst.y8c();
                if ((isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).w2(key)) {
                  tmp_4 = true;
                } else {
                  var tmp2 = this.xk1_1;
                  var key_0 = $this$traverseDepthFirst.y8c();
                  tmp_4 = (isInterface(tmp2, KtMap) ? tmp2 : THROW_CCE()).w2(key_0);
                }
                if (!tmp_4) {
                  var tmp0_0 = this.fk2_1;
                  var element = this.gk2_1.y8c();
                  tmp0_0.e(element);
                  var tmp_5 = this;
                  tmp_5.lk2_1 = this.gk2_1.y8c();
                  this.mk2_1 = this.lk2_1;
                  this.y9_1 = 6;
                  suspendResult = getAssertedDefinitionElements(this.vk1_1, this.uk1_1, this.mk2_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_6 = this;
                  tmp_6.kk2_1 = emptyList();
                  this.y9_1 = 7;
                  continue $sm;
                }
              }
            } else {
              var tmp_7 = this.hk2_1;
              if (tmp_7 instanceof PostProcessChildNodeFrame) {
                this.ik2_1 = createNextChildProcessingFrame(this.ek2_1);
                this.y9_1 = 9;
                continue $sm;
              } else {
                var tmp_8 = this.hk2_1;
                if (tmp_8 instanceof PostProcessNodeFrame) {
                  var tmp_9 = this;
                  tmp_9.nk2_1 = this.gk2_1;
                  this.ok2_1 = this.nk2_1;
                  this.pk2_1 = this.ok2_1.y8c();
                  var tmp_10;
                  var tmp0_1 = this.uk1_1.sgr_1;
                  var key_1 = this.pk2_1;
                  if ((isInterface(tmp0_1, KtMap) ? tmp0_1 : THROW_CCE()).w2(key_1)) {
                    tmp_10 = true;
                  } else {
                    var tmp2_0 = this.xk1_1;
                    var key_2 = this.pk2_1;
                    tmp_10 = (isInterface(tmp2_0, KtMap) ? tmp2_0 : THROW_CCE()).w2(key_2);
                  }
                  if (!tmp_10) {
                    this.qk2_1 = HashSet_init_$Create$();
                    this.y9_1 = 3;
                    suspendResult = this.vk1_1.m51(this.uk1_1.rk6(this.pk2_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.y9_1 = 5;
                    continue $sm;
                  }
                } else {
                  var tmp_11 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 3:
            if (suspendResult) {
              var tmp_12 = this;
              var tmp_13 = this.pk2_1;
              if (!isInterface(tmp_13, AbstractOntologyElement)) {
                throw IllegalStateException_init_$Create$_0('Check failed.');
              }
              var tmp_14 = this.pk2_1;
              tmp_12.rk2_1 = this.qk2_1.e(isInterface(tmp_14, AbstractOntologyElement) ? tmp_14 : THROW_CCE());
              this.y9_1 = 4;
              continue $sm;
            } else {
              var tmp_15 = this;
              var assertedDefinitions = getValue_0(this.uk1_1.rgr_1, this.pk2_1);
              var destination = this.qk2_1;
              var _iterator__ex2g4s = assertedDefinitions.k();
              while (_iterator__ex2g4s.l()) {
                var element_0 = _iterator__ex2g4s.m();
                var tmp0_elvis_lhs = this.uk1_1.sgr_1.y2(element_0);
                var tmp_16 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
                var tmp0_elvis_lhs_0 = this.xk1_1.y2(element_0);
                var list = plus_8(tmp_16, tmp0_elvis_lhs_0 == null ? emptySet() : tmp0_elvis_lhs_0);
                addAll_1(destination, list);
              }
              tmp_15.rk2_1 = destination;
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            var tmp8 = this.xk1_1;
            var tmp9 = this.pk2_1;
            var value = this.qk2_1;
            tmp8.r2(tmp9, value);
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.ik2_1 = this.ek2_1.igp_1;
            this.y9_1 = 9;
            continue $sm;
          case 6:
            var tmp_17 = this;
            var this_0 = suspendResult;
            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s_0 = this_0.k();
            while (_iterator__ex2g4s_0.l()) {
              var item = _iterator__ex2g4s_0.m();
              destination_0.e(to(item, Unit_instance));
            }

            tmp_17.kk2_1 = destination_0;
            this.y9_1 = 7;
            continue $sm;
          case 7:
            var edges = this.kk2_1;
            this.jk2_1 = createChildProcessingFrame(this.ek2_1, edges.k());
            this.y9_1 = 8;
            continue $sm;
          case 8:
            this.ik2_1 = this.jk2_1;
            this.y9_1 = 9;
            continue $sm;
          case 9:
            this.ek2_1 = this.ik2_1;
            if (this.gk2_1.kgp()) {
              this.bk2_1 = null;
              this.y9_1 = 12;
              continue $sm;
            } else {
              this.y9_1 = 10;
              continue $sm;
            }

          case 10:
            this.y9_1 = 2;
            continue $sm;
          case 11:
            this.bk2_1 = this.fk2_1;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 12;
            continue $sm;
          case 12:
            return to(this.xk1_1, this.yk1_1._v);
          case 13:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 13) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $getAllNaturalDefinitionsCOROUTINE$58(_this__u8e3s4, _this__u8e3s4_0, classDeclaration, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ak3_1 = _this__u8e3s4;
    this.bk3_1 = _this__u8e3s4_0;
    this.ck3_1 = classDeclaration;
  }
  protoOf($getAllNaturalDefinitionsCOROUTINE$58).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.dk3_1 = this.ak3_1.sgr_1.y2(this.ck3_1);
            if (!(this.dk3_1 == null)) {
              return this.dk3_1;
            }

            this.y9_1 = 1;
            suspendResult = calculateElementsToAllNaturalDefinitions(this.bk3_1, this.ak3_1, this.ck3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var _destruct__k2r9zo = suspendResult;
            var elementToAllNaturalDefinitions = _destruct__k2r9zo.ug();
            var isValid = _destruct__k2r9zo.vg();
            this.dk3_1 = getValue_0(elementToAllNaturalDefinitions, this.ck3_1);
            if (isValid) {
              this.ak3_1.sgr_1.t2(elementToAllNaturalDefinitions);
            }

            return this.dk3_1;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $getAssertedSuperElementsCOROUTINE$59(_this__u8e3s4, _this__u8e3s4_0, ontologyElement, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mk3_1 = _this__u8e3s4;
    this.nk3_1 = _this__u8e3s4_0;
    this.ok3_1 = ontologyElement;
  }
  protoOf($getAssertedSuperElementsCOROUTINE$59).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 13;
            var tmp_0 = this;
            tmp_0.pk3_1 = this.mk3_1.tgr_1;
            var tmp_1 = this;
            tmp_1.qk3_1 = this.ok3_1;
            this.rk3_1 = this.pk3_1;
            this.sk3_1 = this.qk3_1;
            this.tk3_1 = this.rk3_1.y2(this.sk3_1);
            if (this.tk3_1 == null) {
              this.y9_1 = 1;
              suspendResult = this.nk3_1.m51(this.mk3_1.rk6(this.ok3_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_2 = this;
              tmp_2.uk3_1 = this.tk3_1;
              this.y9_1 = 11;
              continue $sm;
            }

          case 1:
            this.vk3_1 = suspendResult;
            this.wk3_1 = this.vk3_1;
            if (!this.wk3_1) {
              this.y9_1 = 12;
              suspendResult = this.nk3_1.m51(this.ok3_1.b3(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.y9_1 = 3;
            suspendResult = this.nk3_1.m51(this.ok3_1.gbu(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.xk3_1 = suspendResult;
            this.yk3_1 = this.xk3_1;
            var tmp_3 = this;
            tmp_3.zk3_1 = this.yk3_1;
            var tmp_4 = this;
            tmp_4.ak4_1 = ArrayList_init_$Create$();
            this.bk4_1 = this.zk3_1;
            this.ck4_1 = this.ak4_1;
            var tmp_5 = this;
            tmp_5.dk4_1 = this.bk4_1;
            this.ek4_1 = this.dk4_1;
            this.fk4_1 = this.ek4_1.k();
            this.y9_1 = 4;
            continue $sm;
          case 4:
            if (!this.fk4_1.l()) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.gk4_1 = this.fk4_1.m();
            var tmp_6 = this;
            tmp_6.hk4_1 = this.gk4_1;
            this.ik4_1 = this.hk4_1;
            var tmp_7 = this;
            tmp_7.jk4_1 = this.ik4_1;
            this.kk4_1 = this.jk4_1;
            this.y9_1 = 5;
            suspendResult = this.kk4_1.sk6(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.lk4_1 = suspendResult;
            if (this.lk4_1 == null)
              null;
            else {
              var it = this.lk4_1;
              this.ck4_1.e(it);
            }

            this.y9_1 = 4;
            continue $sm;
          case 6:
            this.mk4_1 = this.ck4_1;
            this.nk4_1 = this.mk4_1;
            var tmp_8 = this;
            tmp_8.ok4_1 = this.nk4_1;
            var tmp_9 = this;
            tmp_9.pk4_1 = ArrayList_init_$Create$();
            this.qk4_1 = this.ok4_1;
            this.rk4_1 = this.pk4_1;
            this.sk4_1 = this.qk4_1.k();
            this.y9_1 = 7;
            continue $sm;
          case 7:
            if (!this.sk4_1.l()) {
              this.y9_1 = 10;
              continue $sm;
            }

            this.tk4_1 = this.sk4_1.m();
            var tmp_10 = this;
            tmp_10.uk4_1 = this.tk4_1;
            this.vk4_1 = this.uk4_1;
            this.y9_1 = 8;
            suspendResult = this.nk3_1.m51(this.mk3_1.rk6(this.vk4_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            if (suspendResult) {
              this.rk4_1.e(this.tk4_1);
              this.y9_1 = 9;
              continue $sm;
            } else {
              this.y9_1 = 9;
              continue $sm;
            }

          case 9:
            this.y9_1 = 7;
            continue $sm;
          case 10:
            var ARGUMENT = this.rk4_1;
            var answer = toSet_0(ARGUMENT);
            this.rk3_1.r2(this.sk3_1, answer);
            this.uk3_1 = answer;
            this.y9_1 = 11;
            continue $sm;
          case 11:
            return this.uk3_1;
          case 12:
            var ARGUMENT_0 = suspendResult;
            var message = '' + ARGUMENT_0 + ' is supposed to be natural, but has definition';
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
          case 13:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 13) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $calculateElementToAllSuperElementsCOROUTINE$60(_this__u8e3s4, _this__u8e3s4_0, element, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ek5_1 = _this__u8e3s4;
    this.fk5_1 = _this__u8e3s4_0;
    this.gk5_1 = element;
  }
  protoOf($calculateElementToAllSuperElementsCOROUTINE$60).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 10;
            this.hk5_1 = HashMap_init_$Create$();
            this.ik5_1 = {_v: true};
            var tmp_0 = this;
            tmp_0.jk5_1 = this.gk5_1;
            var tmp_1 = this;
            tmp_1.kk5_1 = OntologyHierarchyImpl$calculateElementToAllSuperElements$lambda(this.ik5_1, this.ek5_1);
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.mk5_1 = this.jk5_1;
            this.nk5_1 = this.kk5_1;
            this.ok5_1 = new PreProcessNodeFrame(this.mk5_1, null);
            this.pk5_1 = HashSet_init_$Create$();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!!(this.ok5_1 == null)) {
              this.y9_1 = 8;
              continue $sm;
            }

            this.qk5_1 = new TraversalContext(this.ok5_1);
            this.rk5_1 = this.ok5_1;
            var tmp_2 = this.rk5_1;
            if (tmp_2 instanceof PreProcessNodeFrame) {
              if (this.pk5_1.s(this.qk5_1.y8c())) {
                var tmp_3 = this;
                if (!isNoop(this.nk5_1) && this.qk5_1.jgp(this.qk5_1.y8c())) {
                  this.nk5_1(this.qk5_1);
                }
                tmp_3.tk5_1 = this.ok5_1.igp_1;
                this.y9_1 = 5;
                continue $sm;
              } else {
                var $this$traverseDepthFirst = this.qk5_1;
                var tmp_4;
                var tmp0 = this.ek5_1.ugr_1;
                var key = $this$traverseDepthFirst.y8c();
                if ((isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).w2(key)) {
                  tmp_4 = true;
                } else {
                  var tmp2 = this.hk5_1;
                  var key_0 = $this$traverseDepthFirst.y8c();
                  tmp_4 = (isInterface(tmp2, KtMap) ? tmp2 : THROW_CCE()).w2(key_0);
                }
                if (!tmp_4) {
                  var tmp0_0 = this.pk5_1;
                  var element = this.qk5_1.y8c();
                  tmp0_0.e(element);
                  var tmp_5 = this;
                  tmp_5.vk5_1 = this.qk5_1.y8c();
                  this.wk5_1 = this.vk5_1;
                  this.y9_1 = 3;
                  suspendResult = getAssertedSuperElements(this.fk5_1, this.ek5_1, this.wk5_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_6 = this;
                  tmp_6.uk5_1 = emptyList();
                  this.y9_1 = 4;
                  continue $sm;
                }
              }
            } else {
              var tmp_7 = this.rk5_1;
              if (tmp_7 instanceof PostProcessChildNodeFrame) {
                this.sk5_1 = createNextChildProcessingFrame(this.ok5_1);
                this.y9_1 = 6;
                continue $sm;
              } else {
                var tmp_8 = this.rk5_1;
                if (tmp_8 instanceof PostProcessNodeFrame) {
                  var tmp_9 = this;
                  var currentNode = this.qk5_1.y8c();
                  var tmp_10;
                  var this_0 = this.ek5_1.ugr_1;
                  if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w2(currentNode)) {
                    tmp_10 = true;
                  } else {
                    var this_1 = this.hk5_1;
                    tmp_10 = (isInterface(this_1, KtMap) ? this_1 : THROW_CCE()).w2(currentNode);
                  }
                  if (!tmp_10) {
                    var allSuperElements = HashSet_init_$Create$();
                    allSuperElements.e(currentNode);
                    var _iterator__ex2g4s = getValue_0(this.ek5_1.tgr_1, currentNode).k();
                    while (_iterator__ex2g4s.l()) {
                      var element_0 = _iterator__ex2g4s.m();
                      var tmp0_elvis_lhs = this.ek5_1.ugr_1.y2(element_0);
                      var tmp_11 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
                      var tmp0_elvis_lhs_0 = this.hk5_1.y2(element_0);
                      var list = plus_8(tmp_11, tmp0_elvis_lhs_0 == null ? emptySet() : tmp0_elvis_lhs_0);
                      addAll_1(allSuperElements, list);
                    }
                    var tmp9 = this.hk5_1;
                    var value = toSet_0(allSuperElements);
                    tmp9.r2(currentNode, value);
                  }
                  tmp_9.sk5_1 = this.ok5_1.igp_1;
                  this.y9_1 = 6;
                  continue $sm;
                } else {
                  var tmp_12 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 3:
            var tmp_13 = this;
            var this_2 = suspendResult;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
            var _iterator__ex2g4s_0 = this_2.k();
            while (_iterator__ex2g4s_0.l()) {
              var item = _iterator__ex2g4s_0.m();
              destination.e(to(item, Unit_instance));
            }

            tmp_13.uk5_1 = destination;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            var edges = this.uk5_1;
            this.tk5_1 = createChildProcessingFrame(this.ok5_1, edges.k());
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.sk5_1 = this.tk5_1;
            this.y9_1 = 6;
            continue $sm;
          case 6:
            this.ok5_1 = this.sk5_1;
            if (this.qk5_1.kgp()) {
              this.lk5_1 = null;
              this.y9_1 = 9;
              continue $sm;
            } else {
              this.y9_1 = 7;
              continue $sm;
            }

          case 7:
            this.y9_1 = 2;
            continue $sm;
          case 8:
            this.lk5_1 = this.pk5_1;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 9;
            continue $sm;
          case 9:
            return to(this.hk5_1, this.ik5_1._v);
          case 10:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 10) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $getAllSuperElementsCOROUTINE$61(_this__u8e3s4, _this__u8e3s4_0, ontologyElement, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fk6_1 = _this__u8e3s4;
    this.gk6_1 = _this__u8e3s4_0;
    this.hk6_1 = ontologyElement;
  }
  protoOf($getAllSuperElementsCOROUTINE$61).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            this.y9_1 = 1;
            suspendResult = this.gk6_1.m51(this.fk6_1.rk6(this.hk6_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ik6_1 = suspendResult;
            this.jk6_1 = this.ik6_1;
            if (!this.jk6_1) {
              this.y9_1 = 5;
              suspendResult = this.gk6_1.m51(this.hk6_1.b3(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            var tmp_0 = this;
            tmp_0.kk6_1 = this.fk6_1.ugr_1;
            var tmp_1 = this;
            tmp_1.lk6_1 = this.hk6_1;
            this.mk6_1 = this.kk6_1;
            this.nk6_1 = this.lk6_1;
            this.ok6_1 = this.mk6_1.y2(this.nk6_1);
            if (this.ok6_1 == null) {
              this.y9_1 = 3;
              suspendResult = calculateElementToAllSuperElements(this.gk6_1, this.fk6_1, this.hk6_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.pk6_1 = this.ok6_1;
              this.y9_1 = 4;
              continue $sm;
            }

          case 3:
            var _destruct__k2r9zo = suspendResult;
            var elementToAllSuperElements = _destruct__k2r9zo.ug();
            var isValid = _destruct__k2r9zo.vg();
            if (isValid) {
              this.fk6_1.ugr_1.t2(elementToAllSuperElements);
            }

            this.pk6_1 = getValue_0(elementToAllSuperElements, this.hk6_1);
            this.y9_1 = 4;
            continue $sm;
          case 4:
            return this.pk6_1;
          case 5:
            var ARGUMENT = suspendResult;
            var message = '' + ARGUMENT + ' is supposed to be natural, but has definition';
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function OntologyHierarchyImpl(cycleStrategy) {
    Companion_getInstance_227();
    var tmp;
    if (cycleStrategy === VOID) {
      tmp = OntologyHierarchyImpl$_init_$lambda_svs6xx;
    } else {
      tmp = cycleStrategy;
    }
    cycleStrategy = tmp;
    this.qgr_1 = cycleStrategy;
    this.rgr_1 = HashMap_init_$Create$();
    this.sgr_1 = HashMap_init_$Create$();
    this.tgr_1 = HashMap_init_$Create$();
    this.ugr_1 = HashMap_init_$Create$();
  }
  protoOf(OntologyHierarchyImpl).ajx = function (one, other) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyHierarchyImpl$isSubtypeOf$$inlined$suspendingQuery$1(one, other, this);
  };
  protoOf(OntologyHierarchyImpl).rk6 = function (element) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyHierarchyImpl$isNatural$$inlined$suspendingQuery$1(element, this);
  };
  protoOf(OntologyHierarchyImpl).tk6 = function (classDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyHierarchyImpl$getAssertedDefinitionElements$$inlined$suspendingQuery$1(this, classDeclaration);
  };
  protoOf(OntologyHierarchyImpl).vgr = function (classDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyHierarchyImpl$getAllNaturalDefinitionElements$$inlined$suspendingQuery$1(this, classDeclaration);
  };
  function ontologyElementHierarchy() {
    return new OntologyHierarchyImpl();
  }
  function isNatural(_this__u8e3s4, ontologyElement) {
    return _this__u8e3s4.rk6(toAdapter_0(ontologyElement));
  }
  function isSubtypeOf_0(_this__u8e3s4, one, other) {
    return _this__u8e3s4.ajx(toAdapter(one), toAdapter(other));
  }
  function getAssertedDefinitionElements_0(_this__u8e3s4, classDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_0 = _this__u8e3s4.tk6(toAdapter_1(classDeclaration));
    var tmp;
    if (isInterface(this_0, Query)) {
      // Inline function 'jetbrains.ocelot.langDef.query.map' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      tmp = new getAssertedDefinitionElements$$inlined$map$1(this_0);
    } else {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      tmp = new getAssertedDefinitionElements$$inlined$map$2(this_0);
    }
    return tmp;
  }
  function toAdapter(_this__u8e3s4) {
    return _this__u8e3s4.n() === 1 ? toAdapter_1(first_0(_this__u8e3s4)) : new ClassDeclarationAdapter(toSet_0(_this__u8e3s4));
  }
  function AbstractOntologyElement() {
  }
  function toAdapter_0(_this__u8e3s4) {
    return new OntologyElementAdapter(_this__u8e3s4);
  }
  function AbstractUnion() {
  }
  function AbstractClassReference() {
  }
  function toAdapter_1(_this__u8e3s4) {
    var tmp;
    if (isInterface(_this__u8e3s4, OntologyElement_1)) {
      tmp = new OntologyElementAdapter(_this__u8e3s4);
    } else {
      if (isInterface(_this__u8e3s4, UnionClass_1)) {
        tmp = new UnionAdapter(_this__u8e3s4);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function ClassDeclarationAdapter$classes$$inlined$suspendingQuery$1(this$0) {
    this.uk6_1 = this$0;
  }
  protoOf(ClassDeclarationAdapter$classes$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.biokb.lang.model.util.ClassDeclarationAdapter.<get-classes>.<anonymous>' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.uk6_1.vk6_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.biokb.lang.model.util.ClassDeclarationAdapter.<get-classes>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = toAdapter_1(item);
      destination.e(tmp$ret$0);
    }
    return destination;
  };
  protoOf(ClassDeclarationAdapter$classes$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ClassDeclarationAdapter(elements) {
    this.vk6_1 = elements;
  }
  protoOf(ClassDeclarationAdapter).tco = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new ClassDeclarationAdapter$classes$$inlined$suspendingQuery$1(this);
  };
  protoOf(ClassDeclarationAdapter).toString = function () {
    return 'ClassDeclarationAdapter(elements=' + toString_1(this.vk6_1) + ')';
  };
  protoOf(ClassDeclarationAdapter).hashCode = function () {
    return hashCode(this.vk6_1);
  };
  protoOf(ClassDeclarationAdapter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ClassDeclarationAdapter))
      return false;
    var tmp0_other_with_cast = other instanceof ClassDeclarationAdapter ? other : THROW_CCE();
    if (!equals(this.vk6_1, tmp0_other_with_cast.vk6_1))
      return false;
    return true;
  };
  function OntologyElementAdapter$superElements$$inlined$suspendingQuery$1(this$0) {
    this.wk6_1 = this$0;
  }
  protoOf(OntologyElementAdapter$superElements$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    // Inline function 'jetbrains.biokb.lang.model.util.OntologyElementAdapter.<get-superElements>.<anonymous>' call
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = builder.n51(this.wk6_1.xk6_1.gbu());
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.model.util.OntologyElementAdapter.<get-superElements>.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver = element.md8();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>.<anonymous>' call
        destination.e(tmp0_safe_receiver);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var item = _iterator__ex2g4s_0.m();
      // Inline function 'jetbrains.biokb.lang.model.util.OntologyElementAdapter.<get-superElements>.<anonymous>.<anonymous>' call
      var tmp$ret$4 = new OntologyElementReferenceAdapter(item);
      destination_0.e(tmp$ret$4);
    }
    return destination_0;
  };
  protoOf(OntologyElementAdapter$superElements$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyElementAdapter$definition$$inlined$query$1(this$0) {
    this.yk6_1 = this$0;
  }
  protoOf(OntologyElementAdapter$definition$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.model.util.OntologyElementAdapter.<get-definition>.<anonymous>' call
    var tmp0_safe_receiver = builder.n51(this.yk6_1.xk6_1.nd6());
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.biokb.lang.model.util.OntologyElementAdapter.<get-definition>.<anonymous>.<anonymous>' call
      tmp = new UnionAdapter(tmp0_safe_receiver);
    }
    return tmp;
  };
  function OntologyElementAdapter(origin) {
    this.xk6_1 = origin;
  }
  protoOf(OntologyElementAdapter).sgu = function () {
    return this.xk6_1;
  };
  protoOf(OntologyElementAdapter).gbu = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyElementAdapter$superElements$$inlined$suspendingQuery$1(this);
  };
  protoOf(OntologyElementAdapter).nbu = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new OntologyElementAdapter$definition$$inlined$query$1(this);
  };
  protoOf(OntologyElementAdapter).b3 = function () {
    return this.xk6_1.b3();
  };
  protoOf(OntologyElementAdapter).toString = function () {
    return 'OntologyElementAdapter(origin=' + toString_1(this.xk6_1) + ')';
  };
  protoOf(OntologyElementAdapter).hashCode = function () {
    return hashCode(this.xk6_1);
  };
  protoOf(OntologyElementAdapter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OntologyElementAdapter))
      return false;
    var tmp0_other_with_cast = other instanceof OntologyElementAdapter ? other : THROW_CCE();
    if (!equals(this.xk6_1, tmp0_other_with_cast.xk6_1))
      return false;
    return true;
  };
  function $runSuspendCOROUTINE$68(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hk7_1 = _this__u8e3s4;
    this.ik7_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$68).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.jk7_1 = this.ik7_1;
            this.kk7_1 = this.jk7_1;
            var tmp_1 = this;
            var tmp0 = this.kk7_1.n51(this.hk7_1.ak8_1.zk7_1.tco());
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              if (!(element == null) ? isInterface(element, ClassExpression) : false) {
                destination.e(element);
              }
            }

            tmp_1.lk7_1 = destination;
            this.mk7_1 = this.lk7_1;
            var tmp_2 = this;
            tmp_2.nk7_1 = this.mk7_1;
            var tmp_3 = this;
            tmp_3.ok7_1 = ArrayList_init_$Create$();
            this.pk7_1 = this.nk7_1;
            this.qk7_1 = this.ok7_1;
            var tmp_4 = this;
            tmp_4.rk7_1 = this.pk7_1;
            this.sk7_1 = this.rk7_1;
            this.tk7_1 = this.sk7_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.tk7_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.uk7_1 = this.tk7_1.m();
            var tmp_5 = this;
            tmp_5.vk7_1 = this.uk7_1;
            this.wk7_1 = this.vk7_1;
            var tmp_6 = this;
            tmp_6.xk7_1 = this.wk7_1;
            this.yk7_1 = this.xk7_1;
            this.y9_1 = 2;
            suspendResult = this.kk7_1.m51(this.yk7_1.ud1(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.qk7_1.e(tmp0_safe_receiver);
            }

            this.y9_1 = 1;
            continue $sm;
          case 3:
            var this_0 = this.qk7_1;
            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s_0 = this_0.k();
            while (_iterator__ex2g4s_0.l()) {
              var item = _iterator__ex2g4s_0.m();
              destination_0.e(toAdapter_1(item));
            }

            return destination_0;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function UnionAdapter$classes$$inlined$suspendingQuery$1(this$0) {
    this.ak8_1 = this$0;
  }
  protoOf(UnionAdapter$classes$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$68(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(UnionAdapter$classes$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function UnionAdapter(union) {
    this.zk7_1 = union;
  }
  protoOf(UnionAdapter).tco = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new UnionAdapter$classes$$inlined$suspendingQuery$1(this);
  };
  protoOf(UnionAdapter).toString = function () {
    return 'UnionAdapter(union=' + toString_1(this.zk7_1) + ')';
  };
  protoOf(UnionAdapter).hashCode = function () {
    return hashCode(this.zk7_1);
  };
  protoOf(UnionAdapter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UnionAdapter))
      return false;
    var tmp0_other_with_cast = other instanceof UnionAdapter ? other : THROW_CCE();
    if (!equals(this.zk7_1, tmp0_other_with_cast.zk7_1))
      return false;
    return true;
  };
  function $runSuspendCOROUTINE$69(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jk8_1 = _this__u8e3s4;
    this.kk8_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$69).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.lk8_1 = this.kk8_1;
            this.mk8_1 = this.lk8_1;
            this.y9_1 = 1;
            suspendResult = this.mk8_1.m51(this.jk8_1.ok8_1.nk8_1.p6s(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp_1;
            if (tmp0_safe_receiver == null) {
              tmp_1 = null;
            } else {
              tmp_1 = new OntologyElementAdapter(tmp0_safe_receiver);
            }

            return tmp_1;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function OntologyElementReferenceAdapter$element$$inlined$suspendingQuery$1(this$0) {
    this.ok8_1 = this$0;
  }
  protoOf(OntologyElementReferenceAdapter$element$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$69(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OntologyElementReferenceAdapter$element$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function OntologyElementReferenceAdapter(reference) {
    this.nk8_1 = reference;
  }
  protoOf(OntologyElementReferenceAdapter).lay = function () {
    // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
    return new OntologyElementReferenceAdapter$element$$inlined$suspendingQuery$1(this);
  };
  function getAllNaturalDefinitionElements(_this__u8e3s4, classDeclaration) {
    // Inline function 'jetbrains.ocelot.langDef.query.map' call
    var this_0 = _this__u8e3s4.vgr(toAdapter_1(classDeclaration));
    var tmp;
    if (isInterface(this_0, Query)) {
      // Inline function 'jetbrains.ocelot.langDef.query.map' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      tmp = new getAllNaturalDefinitionElements$$inlined$map$1(this_0);
    } else {
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      tmp = new getAllNaturalDefinitionElements$$inlined$map$2(this_0);
    }
    return tmp;
  }
  function isSubtypeOf_1(_this__u8e3s4, one, other) {
    return _this__u8e3s4.ajx(toAdapter_1(one), toAdapter_1(other));
  }
  function getAssertedDefinitionElements$$inlined$map$1($this) {
    this.pk8_1 = $this;
  }
  protoOf(getAssertedDefinitionElements$$inlined$map$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.query.map.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.model.util.getAssertedDefinitionElements.<anonymous>' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = builder.n51(this.pk8_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.biokb.lang.model.util.getAssertedDefinitionElements.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.sgu();
      destination.e(tmp$ret$0);
    }
    return toSet_0(destination);
  };
  function $runSuspendCOROUTINE$70(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yk8_1 = _this__u8e3s4;
    this.zk8_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$70).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.ak9_1 = this.zk8_1;
            this.bk9_1 = this.ak9_1;
            this.y9_1 = 1;
            suspendResult = this.bk9_1.m51(this.yk8_1.ck9_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.k();
            while (_iterator__ex2g4s.l()) {
              var item = _iterator__ex2g4s.m();
              destination.e(item.sgu());
            }

            return toSet_0(destination);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function getAssertedDefinitionElements$$inlined$map$2($this) {
    this.ck9_1 = $this;
  }
  protoOf(getAssertedDefinitionElements$$inlined$map$2).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$70(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(getAssertedDefinitionElements$$inlined$map$2).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function getAllNaturalDefinitionElements$$inlined$map$1($this) {
    this.dk9_1 = $this;
  }
  protoOf(getAllNaturalDefinitionElements$$inlined$map$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.query.map.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.model.util.getAllNaturalDefinitionElements.<anonymous>' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = builder.n51(this.dk9_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.biokb.lang.model.util.getAllNaturalDefinitionElements.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.sgu();
      destination.e(tmp$ret$0);
    }
    return toSet_0(destination);
  };
  function $runSuspendCOROUTINE$71(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mk9_1 = _this__u8e3s4;
    this.nk9_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$71).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.ok9_1 = this.nk9_1;
            this.pk9_1 = this.ok9_1;
            this.y9_1 = 1;
            suspendResult = this.pk9_1.m51(this.mk9_1.qk9_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
            var _iterator__ex2g4s = this_0.k();
            while (_iterator__ex2g4s.l()) {
              var item = _iterator__ex2g4s.m();
              destination.e(item.sgu());
            }

            return toSet_0(destination);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function getAllNaturalDefinitionElements$$inlined$map$2($this) {
    this.qk9_1 = $this;
  }
  protoOf(getAllNaturalDefinitionElements$$inlined$map$2).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$71(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(getAllNaturalDefinitionElements$$inlined$map$2).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function Companion_228() {
  }
  protoOf(Companion_228).h67 = function () {
    return $serializer_getInstance_24();
  };
  var Companion_instance_228;
  function Companion_getInstance_228() {
    return Companion_instance_228;
  }
  function $serializer_26() {
    $serializer_instance_24 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.findUsages.UsageDto', this, 4);
    tmp0_serialDesc.t5n('kind', false);
    tmp0_serialDesc.t5n('node', false);
    tmp0_serialDesc.t5n('referenceSourceNodeId', false);
    tmp0_serialDesc.t5n('propertyId', false);
    this.rk9_1 = tmp0_serialDesc;
  }
  protoOf($serializer_26).sk9 = function (encoder, value) {
    var tmp0_desc = this.rk9_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.x5h(tmp0_desc, 0, value.kind);
    tmp1_output.z5h(tmp0_desc, 1, $serializer_getInstance_23(), value.node);
    tmp1_output.x5h(tmp0_desc, 2, value.referenceSourceNodeId);
    tmp1_output.x5h(tmp0_desc, 3, value.propertyId);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_26).j5d = function (encoder, value) {
    return this.sk9(encoder, value instanceof UsageDto ? value : THROW_CCE());
  };
  protoOf($serializer_26).k5d = function (decoder) {
    var tmp0_desc = this.rk9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.j5g(tmp0_desc);
    if (tmp8_input.y5g()) {
      tmp4_local0 = tmp8_input.t5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.v5g(tmp0_desc, 1, $serializer_getInstance_23(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.t5g(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.t5g(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.t5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.v5g(tmp0_desc, 1, $serializer_getInstance_23(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.t5g(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.t5g(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.k5g(tmp0_desc);
    return UsageDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_26).w5c = function () {
    return this.rk9_1;
  };
  protoOf($serializer_26).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_23(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_24;
  function $serializer_getInstance_24() {
    if ($serializer_instance_24 == null)
      new $serializer_26();
    return $serializer_instance_24;
  }
  function UsageDto_init_$Init$(seen0, kind, node, referenceSourceNodeId, propertyId, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_24().rk9_1);
    }
    $this.kind = kind;
    $this.node = node;
    $this.referenceSourceNodeId = referenceSourceNodeId;
    $this.propertyId = propertyId;
    return $this;
  }
  function UsageDto_init_$Create$(seen0, kind, node, referenceSourceNodeId, propertyId, serializationConstructorMarker) {
    return UsageDto_init_$Init$(seen0, kind, node, referenceSourceNodeId, propertyId, serializationConstructorMarker, objectCreate(protoOf(UsageDto)));
  }
  function UsageDto(kind, node, referenceSourceNodeId, propertyId) {
    this.kind = kind;
    this.node = node;
    this.referenceSourceNodeId = referenceSourceNodeId;
    this.propertyId = propertyId;
  }
  protoOf(UsageDto).r5e = function () {
    return this.kind;
  };
  protoOf(UsageDto).y8c = function () {
    return this.node;
  };
  protoOf(UsageDto).tk9 = function () {
    return this.referenceSourceNodeId;
  };
  protoOf(UsageDto).f39 = function () {
    return this.propertyId;
  };
  protoOf(UsageDto).ug = function () {
    return this.kind;
  };
  protoOf(UsageDto).vg = function () {
    return this.node;
  };
  protoOf(UsageDto).hm = function () {
    return this.referenceSourceNodeId;
  };
  protoOf(UsageDto).g59 = function () {
    return this.propertyId;
  };
  protoOf(UsageDto).uk9 = function (kind, node, referenceSourceNodeId, propertyId) {
    return new UsageDto(kind, node, referenceSourceNodeId, propertyId);
  };
  protoOf(UsageDto).copy = function (kind, node, referenceSourceNodeId, propertyId, $super) {
    kind = kind === VOID ? this.kind : kind;
    node = node === VOID ? this.node : node;
    referenceSourceNodeId = referenceSourceNodeId === VOID ? this.referenceSourceNodeId : referenceSourceNodeId;
    propertyId = propertyId === VOID ? this.propertyId : propertyId;
    return this.uk9(kind, node, referenceSourceNodeId, propertyId);
  };
  protoOf(UsageDto).toString = function () {
    return 'UsageDto(kind=' + this.kind + ', node=' + this.node.toString() + ', referenceSourceNodeId=' + this.referenceSourceNodeId + ', propertyId=' + this.propertyId + ')';
  };
  protoOf(UsageDto).hashCode = function () {
    var result = getStringHashCode(this.kind);
    result = imul(result, 31) + this.node.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.referenceSourceNodeId) | 0;
    result = imul(result, 31) + getStringHashCode(this.propertyId) | 0;
    return result;
  };
  protoOf(UsageDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UsageDto))
      return false;
    var tmp0_other_with_cast = other instanceof UsageDto ? other : THROW_CCE();
    if (!(this.kind === tmp0_other_with_cast.kind))
      return false;
    if (!this.node.equals(tmp0_other_with_cast.node))
      return false;
    if (!(this.referenceSourceNodeId === tmp0_other_with_cast.referenceSourceNodeId))
      return false;
    if (!(this.propertyId === tmp0_other_with_cast.propertyId))
      return false;
    return true;
  };
  function Companion_229() {
  }
  var Companion_instance_229;
  function Companion_getInstance_229() {
    return Companion_instance_229;
  }
  function $serializer_27() {
    $serializer_instance_25 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.pubMedImport.PubMedPaperLoadResultDto', this, 2);
    tmp0_serialDesc.t5n('referenceValue', false);
    tmp0_serialDesc.t5n('errorMessage', false);
    this.vk9_1 = tmp0_serialDesc;
  }
  protoOf($serializer_27).wk9 = function (encoder, value) {
    var tmp0_desc = this.vk9_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.a5i(tmp0_desc, 0, $serializer_getInstance_4(), value.xk9_1);
    tmp1_output.a5i(tmp0_desc, 1, StringSerializer_getInstance(), value.yk9_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_27).j5d = function (encoder, value) {
    return this.wk9(encoder, value instanceof PubMedPaperLoadResultDto ? value : THROW_CCE());
  };
  protoOf($serializer_27).k5d = function (decoder) {
    var tmp0_desc = this.vk9_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.x5g(tmp0_desc, 0, $serializer_getInstance_4(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.x5g(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.x5g(tmp0_desc, 0, $serializer_getInstance_4(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.x5g(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return PubMedPaperLoadResultDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_27).w5c = function () {
    return this.vk9_1;
  };
  protoOf($serializer_27).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_4()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_25;
  function $serializer_getInstance_25() {
    if ($serializer_instance_25 == null)
      new $serializer_27();
    return $serializer_instance_25;
  }
  function PubMedPaperLoadResultDto_init_$Init$(seen0, referenceValue, errorMessage, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_25().vk9_1);
    }
    $this.xk9_1 = referenceValue;
    $this.yk9_1 = errorMessage;
    return $this;
  }
  function PubMedPaperLoadResultDto_init_$Create$(seen0, referenceValue, errorMessage, serializationConstructorMarker) {
    return PubMedPaperLoadResultDto_init_$Init$(seen0, referenceValue, errorMessage, serializationConstructorMarker, objectCreate(protoOf(PubMedPaperLoadResultDto)));
  }
  function PubMedPaperLoadResultDto(referenceValue, errorMessage) {
    this.xk9_1 = referenceValue;
    this.yk9_1 = errorMessage;
  }
  function DocPersistence(nodeFactory) {
    this.zk9_1 = new Json2NodeConverter(new NodeIdPersistenceContext(), nodeFactory);
  }
  protoOf(DocPersistence).aka = function (doc) {
    return (new Node2JsonConverter(new NodeIdPersistenceContext())).x38(doc).toString();
  };
  protoOf(DocPersistence).w2p = function (jsonString) {
    var jsonBytes = encodeToByteArray(jsonString);
    var tmp = CommonJsonStreamIterSupport_instance.b2y(jsonBytes);
    var jsonArrayReader = isInterface(tmp, JsonArrayReader) ? tmp : THROW_CCE();
    // Inline function 'kotlin.also' call
    var this_0 = this.zk9_1.s37(jsonArrayReader);
    // Inline function 'jetbrains.biokb.publish.DocPersistence.deserialize.<anonymous>' call
    new Model(this_0);
    return this_0;
  };
  function get_docPersistence(_this__u8e3s4) {
    return _this__u8e3s4.i72_1.t70() ? new DocPersistence(_this__u8e3s4.q72_1) : RawDocPersistence_getInstance();
  }
  function RawDocPersistence() {
    RawDocPersistence_instance = this;
    DocPersistence.call(this, RawNodeFactory_instance);
  }
  var RawDocPersistence_instance;
  function RawDocPersistence_getInstance() {
    if (RawDocPersistence_instance == null)
      new RawDocPersistence();
    return RawDocPersistence_instance;
  }
  function ClientId_init_$Init$($this) {
    BaseId.call($this);
    ClientId.call($this);
    return $this;
  }
  function ClientId_init_$Create$() {
    return ClientId_init_$Init$(objectCreate(protoOf(ClientId)));
  }
  function Companion_230() {
    this.bka_1 = 'client_id';
  }
  var Companion_instance_230;
  function Companion_getInstance_230() {
    return Companion_instance_230;
  }
  function ClientId() {
  }
  function ConnectionId_init_$Init$($this) {
    BaseId.call($this);
    ConnectionId.call($this);
    return $this;
  }
  function ConnectionId_init_$Create$() {
    return ConnectionId_init_$Init$(objectCreate(protoOf(ConnectionId)));
  }
  function Companion_231() {
    this.cka_1 = 'connection_id';
  }
  var Companion_instance_231;
  function Companion_getInstance_231() {
    return Companion_instance_231;
  }
  function ConnectionId() {
  }
  function StringChannel() {
  }
  function JsonChannel() {
  }
  function JsonService$Companion$toStringPort$1$setOutput$$inlined$jsonChannel$1($output) {
    this.eka_1 = $output;
  }
  protoOf(JsonService$Companion$toStringPort$1$setOutput$$inlined$jsonChannel$1).fka = function (message) {
    this.eka_1.dka(message.toString());
    return Unit_instance;
  };
  protoOf(JsonService$Companion$toStringPort$1$setOutput$$inlined$jsonChannel$1).dka = function (message) {
    return this.fka(message instanceof JsonArray ? message : THROW_CCE());
  };
  function JsonService$Companion$toStringPort$$inlined$stringChannel$1($port) {
    this.gka_1 = $port;
  }
  protoOf(JsonService$Companion$toStringPort$$inlined$stringChannel$1).hka = function (message) {
    var tmp = this.gka_1.ika();
    var tmp_0 = Json_getInstance().t2t(message);
    tmp.dka(tmp_0 instanceof JsonArray ? tmp_0 : THROW_CCE());
    return Unit_instance;
  };
  protoOf(JsonService$Companion$toStringPort$$inlined$stringChannel$1).dka = function (message) {
    return this.hka((!(message == null) ? typeof message === 'string' : false) ? message : THROW_CCE());
  };
  function JsonService$Companion$toStringPort$1($inputChannel, $port) {
    this.jka_1 = $inputChannel;
    this.kka_1 = $port;
  }
  protoOf(JsonService$Companion$toStringPort$1).ika = function () {
    return this.jka_1;
  };
  protoOf(JsonService$Companion$toStringPort$1).lka = function (output, internalErrorHandler) {
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.json.jsonChannel' call
    var outputJsonChannel = new JsonService$Companion$toStringPort$1$setOutput$$inlined$jsonChannel$1(output);
    this.kka_1.mka(outputJsonChannel, internalErrorHandler);
  };
  protoOf(JsonService$Companion$toStringPort$1).mka = function (output, internalErrorHandler) {
    return this.lka((!(output == null) ? isInterface(output, StringChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(JsonService$Companion$toStringPort$1).vr = function () {
    this.kka_1.vr();
  };
  function Companion_232() {
  }
  protoOf(Companion_232).nka = function (port) {
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.stringChannel' call
    var inputChannel = new JsonService$Companion$toStringPort$$inlined$stringChannel$1(port);
    return new JsonService$Companion$toStringPort$1(inputChannel, port);
  };
  var Companion_instance_232;
  function Companion_getInstance_232() {
    return Companion_instance_232;
  }
  function JsonServiceEndpoint() {
  }
  protoOf(JsonServiceEndpoint).oka = function () {
    return Companion_instance_232.nka(this.pka());
  };
  function hasAsyncs($this) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this.rka_1.p();
  }
  function call($this, caller) {
    if (hasAsyncs($this)) {
      try {
        var _iterator__ex2g4s = $this.rka_1.k();
        while (_iterator__ex2g4s.l()) {
          var a = _iterator__ex2g4s.m();
          try {
            caller(a);
          } catch ($p) {
            if ($p instanceof Error) {
              var t = $p;
              ThrowableHandlers_getInstance().ps_1.os(t);
            } else {
              throw $p;
            }
          }
        }
      }finally {
        $this.rka_1.m2();
      }
    }
  }
  function AsyncsListHandler$succeed$lambda($item) {
    return function (async) {
      async.n2l($item);
      return Unit_instance;
    };
  }
  function AsyncsListHandler$fail$lambda($reason) {
    return function (async) {
      async.o2l(new OtRejectionException($reason));
      return Unit_instance;
    };
  }
  function AsyncsListHandler() {
    this.rka_1 = ArrayList_init_$Create$();
  }
  protoOf(AsyncsListHandler).wo = function () {
    return this.rka_1.n();
  };
  protoOf(AsyncsListHandler).ska = function (async) {
    return contains_5(this.rka_1, async);
  };
  protoOf(AsyncsListHandler).tka = function (async) {
    // Inline function 'kotlin.collections.remove' call
    var this_0 = this.rka_1;
    return (isInterface(this_0, MutableCollection) ? this_0 : THROW_CCE()).k2(async);
  };
  protoOf(AsyncsListHandler).uka = function () {
    var async = new SimpleAsync();
    this.rka_1.e(async);
    return async;
  };
  protoOf(AsyncsListHandler).vka = function (item) {
    call(this, AsyncsListHandler$succeed$lambda(item));
  };
  protoOf(AsyncsListHandler).wka = function (reason) {
    call(this, AsyncsListHandler$fail$lambda(reason));
  };
  function isInLoadedSubtree($this, path) {
    var iterator = path.r(path.n());
    while (iterator.l5()) {
      if ($this.zka(iterator.n5())) {
        return true;
      }
    }
    return false;
  }
  function markLoaded($this, pathToLeaf) {
    // Inline function 'kotlin.check' call
    if (!!isInLoadedSubtree($this, pathToLeaf)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.LoadedEntitiesTree.markLoaded.<anonymous>' call
      var message = 'Entity is in loaded subtree, entityId=' + last(pathToLeaf).toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var iterator = pathToLeaf.k();
    var rootId = iterator.m();
    var element = getOrCreateRoot($this, rootId);
    if (!iterator.l()) {
      element.ekb();
      return Unit_instance;
    }
    while (iterator.l()) {
      var id = iterator.m();
      element = addChild($this, element, id, !iterator.l());
    }
  }
  function containsRoot($this, rootId) {
    return $this.e35(rootId) && ensureNotNull($this.xka_1.y2(rootId)).fkb();
  }
  function getPath($this, entity) {
    var tmp = ancestorsFrom(entity);
    return asReversed(toList_2(map(tmp, LoadedEntitiesTree$getPath$lambda)));
  }
  function setupFullRoot($this, rootId) {
    return getOrCreateRoot($this, rootId).ekb();
  }
  function getOrCreateRoot($this, rootId) {
    if ($this.e35(rootId)) {
      // Inline function 'kotlin.check' call
      if (!ensureNotNull($this.xka_1.y2(rootId)).fkb()) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
    } else {
      createRoot($this, rootId);
    }
    return ensureNotNull($this.xka_1.y2(rootId));
  }
  function createRoot($this, rootId) {
    var rootElement = new LoadedEntitiesTreeElement(rootId);
    $this.gkb(rootId, rootElement);
    return rootElement;
  }
  function addChild($this, parent, childId, isLeaf) {
    var child = parent.hkb(childId);
    if (!(child == null)) {
      if (isLeaf) {
        child.ekb();
      }
    } else {
      child = parent.ikb(childId);
      $this.gkb(childId, child);
    }
    return child;
  }
  function LoadedEntitiesTree$getPath$lambda(e) {
    return e.j2z_1;
  }
  function LoadedEntitiesTree() {
    this.xka_1 = HashMap_init_$Create$();
    this.yka_1 = HashSet_init_$Create$();
  }
  protoOf(LoadedEntitiesTree).e35 = function (id) {
    return this.xka_1.w2(id);
  };
  protoOf(LoadedEntitiesTree).zka = function (id) {
    return this.xka_1.w2(id) && ensureNotNull(this.xka_1.y2(id)).jkb();
  };
  protoOf(LoadedEntitiesTree).kkb = function (id) {
    return this.xka_1.w2(id) && !ensureNotNull(this.xka_1.y2(id)).jkb();
  };
  protoOf(LoadedEntitiesTree).lkb = function (entity) {
    if (this.zka(entity.j2z_1))
      return true;
    var currentEntity = entity.yt();
    while (!(currentEntity == null)) {
      if (this.zka(currentEntity.j2z_1))
        return true;
      currentEntity = currentEntity.yt();
    }
    return false;
  };
  protoOf(LoadedEntitiesTree).mkb = function (rootId) {
    // Inline function 'kotlin.check' call
    if (!!this.zka(rootId)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.LoadedEntitiesTree.markRootLoaded.<anonymous>' call
      var message = 'Already loaded, root id=' + rootId.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    setupFullRoot(this, rootId);
  };
  protoOf(LoadedEntitiesTree).nkb = function (entity) {
    return markLoaded(this, getPath(this, entity));
  };
  protoOf(LoadedEntitiesTree).okb = function (id) {
    if (!this.e35(id))
      return false;
    ensureNotNull(this.xka_1.y2(id)).pkb();
    return true;
  };
  protoOf(LoadedEntitiesTree).qkb = function (rootId) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!containsRoot(this, rootId)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return ensureNotNull(this.xka_1.y2(rootId));
  };
  protoOf(LoadedEntitiesTree).gkb = function (id, element) {
    // Inline function 'kotlin.collections.set' call
    this.xka_1.r2(id, element);
    if (element.fkb()) {
      this.yka_1.e(id);
    }
    element.rkb(this);
  };
  protoOf(LoadedEntitiesTree).skb = function (element) {
    this.xka_1.s2(element.akb_1);
    this.yka_1.k2(element.akb_1);
  };
  protoOf(LoadedEntitiesTree).toString = function () {
    var sb = new StringBuilder('LoadedEntitiesTree: [');
    var _iterator__ex2g4s = this.yka_1.k();
    while (_iterator__ex2g4s.l()) {
      var rootId = _iterator__ex2g4s.m();
      sb.c9(this.xka_1.y2(rootId)).d9('; ');
    }
    sb.e9(_Char___init__impl__6a9atx(93));
    return sb.toString();
  };
  function unregister($this) {
    if (!($this.dkb_1 == null)) {
      ensureNotNull($this.dkb_1).skb($this);
      $this.dkb_1 = null;
    }
  }
  function copyChildren($this, copy) {
    if ($this.jkb())
      return Unit_instance;
    var _iterator__ex2g4s = ensureNotNull($this.ckb_1).u2().k();
    while (_iterator__ex2g4s.l()) {
      var id = _iterator__ex2g4s.m();
      var childCopy = copy.ikb(id);
      copyChildren(ensureNotNull($this.hkb(id)), childCopy);
    }
  }
  function Companion_233() {
  }
  var Companion_instance_233;
  function Companion_getInstance_233() {
    return Companion_instance_233;
  }
  function LoadedEntitiesTreeElement(id, parent) {
    parent = parent === VOID ? null : parent;
    this.akb_1 = id;
    this.bkb_1 = parent;
    this.ckb_1 = null;
    this.dkb_1 = null;
  }
  protoOf(LoadedEntitiesTreeElement).fkb = function () {
    return this.bkb_1 == null;
  };
  protoOf(LoadedEntitiesTreeElement).jkb = function () {
    return this.ckb_1 == null;
  };
  protoOf(LoadedEntitiesTreeElement).tkb = function () {
    return this.jkb() ? null : ensureNotNull(this.ckb_1).v2();
  };
  protoOf(LoadedEntitiesTreeElement).hkb = function (id) {
    return this.jkb() ? null : ensureNotNull(this.ckb_1).y2(id);
  };
  protoOf(LoadedEntitiesTreeElement).ikb = function (childId) {
    if (this.ckb_1 == null) {
      this.ckb_1 = HashMap_init_$Create$();
    }
    var child = new LoadedEntitiesTreeElement(childId, this);
    // Inline function 'kotlin.collections.set' call
    ensureNotNull(this.ckb_1).r2(childId, child);
    return child;
  };
  protoOf(LoadedEntitiesTreeElement).ukb = function (id) {
    ensureNotNull(this.ckb_1).s2(id);
    if (ensureNotNull(this.ckb_1).p()) {
      this.ckb_1 = null;
    }
  };
  protoOf(LoadedEntitiesTreeElement).pkb = function () {
    this.ekb();
    if (!this.fkb()) {
      ensureNotNull(this.bkb_1).ukb(this.akb_1);
      if (this.bkb_1.jkb()) {
        unregister(this);
        this.bkb_1.pkb();
        return Unit_instance;
      }
    }
    unregister(this);
  };
  protoOf(LoadedEntitiesTreeElement).ekb = function () {
    if (this.jkb())
      return Unit_instance;
    var _iterator__ex2g4s = ensureNotNull(this.ckb_1).v2().k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      child.ekb();
      unregister(child);
    }
    this.ckb_1 = null;
  };
  protoOf(LoadedEntitiesTreeElement).rkb = function (tree) {
    // Inline function 'kotlin.check' call
    if (!(this.dkb_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.dkb_1 = tree;
  };
  protoOf(LoadedEntitiesTreeElement).vkb = function () {
    // Inline function 'kotlin.check' call
    if (!this.fkb()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var copy = new LoadedEntitiesTreeElement(this.akb_1);
    copyChildren(this, copy);
    return copy;
  };
  protoOf(LoadedEntitiesTreeElement).toString = function () {
    return this.akb_1.toString() + (this.ckb_1 == null ? '' : '-' + toString_0(this.ckb_1));
  };
  function LoadedEntitiesTreeReconnectHelper(tree) {
    this.wkb_1 = tree;
  }
  protoOf(LoadedEntitiesTreeReconnectHelper).xkb = function (rootId, version) {
    return new RootReconnectData(this.wkb_1.qkb(rootId).vkb(), version);
  };
  function OtChannel() {
  }
  function OtChannelAdapter() {
  }
  protoOf(OtChannelAdapter).ykb = function (command) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).zkb = function (id, baseVersion, resultVersion) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).akc = function (id, reason) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).bkc = function (id) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).ckc = function (id, rootsToLoad) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).dkc = function (id) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).ekc = function (id, reason) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).fkc = function (id) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).gkc = function (id) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).hkc = function (id, reason) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).ikc = function (id, from, to) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).jkc = function (id, history) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).kkc = function (id, reason) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).lkc = function (id, rootIds) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).mkc = function (id, rootIds) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(OtChannelAdapter).nkc = function (commandId) {
    throw UnsupportedOperationException_init_$Create$();
  };
  function OtChannelDelegate(source) {
    this.okc_1 = source;
  }
  protoOf(OtChannelDelegate).ykb = function (command) {
    this.okc_1.ykb(command);
  };
  protoOf(OtChannelDelegate).zkb = function (id, baseVersion, resultVersion) {
    this.okc_1.zkb(id, baseVersion, resultVersion);
  };
  protoOf(OtChannelDelegate).akc = function (id, reason) {
    this.okc_1.akc(id, reason);
  };
  protoOf(OtChannelDelegate).bkc = function (id) {
    this.okc_1.bkc(id);
  };
  protoOf(OtChannelDelegate).ckc = function (id, rootsToLoad) {
    this.okc_1.ckc(id, rootsToLoad);
  };
  protoOf(OtChannelDelegate).dkc = function (id) {
    this.okc_1.dkc(id);
  };
  protoOf(OtChannelDelegate).ekc = function (id, reason) {
    this.okc_1.ekc(id, reason);
  };
  protoOf(OtChannelDelegate).fkc = function (id) {
    this.okc_1.fkc(id);
  };
  protoOf(OtChannelDelegate).gkc = function (id) {
    this.okc_1.gkc(id);
  };
  protoOf(OtChannelDelegate).hkc = function (id, reason) {
    this.okc_1.hkc(id, reason);
  };
  protoOf(OtChannelDelegate).ikc = function (id, from, to) {
    this.okc_1.ikc(id, from, to);
  };
  protoOf(OtChannelDelegate).jkc = function (id, history) {
    this.okc_1.jkc(id, history);
  };
  protoOf(OtChannelDelegate).kkc = function (id, reason) {
    this.okc_1.kkc(id, reason);
  };
  protoOf(OtChannelDelegate).lkc = function (id, rootIds) {
    this.okc_1.lkc(id, rootIds);
  };
  protoOf(OtChannelDelegate).mkc = function (id, rootIds) {
    this.okc_1.mkc(id, rootIds);
  };
  protoOf(OtChannelDelegate).nkc = function (commandId) {
    this.okc_1.nkc(commandId);
  };
  function _get_isPortOpened__9rr51l($this) {
    return !($this.rkc_1 == null);
  }
  function closeInternally($this) {
    if (_get_isPortOpened__9rr51l($this)) {
      ensureNotNull($this.rkc_1).vr();
      $this.rkc_1 = null;
    }
  }
  function lazyInit($this) {
    if ($this.skc_1 == null) {
      $this.vkc(PortExecutingDelegate$lazyInit$lambda($this));
      $this.skc_1 = createInput($this);
    }
  }
  function createInput($this) {
    return $this.wkc(PortExecutingDelegate$createInput$lambda($this));
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_2(function_0) {
    this.xkc_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_2).wy = function () {
    return this.xkc_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_2).b4 = function () {
    return this.xkc_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_2).hashCode = function () {
    return hashCode(this.b4());
  };
  function PortExecutingDelegate$setOutput$lambda$lambda(this$0) {
    return function (item) {
      closeInternally(this$0);
      var tmp;
      if (this$0.tkc_1 == null) {
        this$0.tkc_1 = item;
        tmp = ensureNotNull(this$0.ukc_1)(item);
      }
      return Unit_instance;
    };
  }
  function PortExecutingDelegate$setOutput$lambda(this$0, $output) {
    return function () {
      var tmp = ensureNotNull(this$0.rkc_1);
      tmp.mka($output, PortExecutingDelegate$setOutput$lambda$lambda(this$0));
      return Unit_instance;
    };
  }
  function PortExecutingDelegate$closeInternally$ref($boundThis) {
    var l = function () {
      closeInternally($boundThis);
      return Unit_instance;
    };
    l.callableName = 'closeInternally';
    return l;
  }
  function PortExecutingDelegate$lazyInit$lambda(this$0) {
    return function () {
      this$0.rkc_1 = this$0.pkc_1();
      return Unit_instance;
    };
  }
  function PortExecutingDelegate$createInput$lambda(this$0) {
    return function () {
      return ensureNotNull(this$0.rkc_1).ika();
    };
  }
  function PortExecutingDelegate(portSupplier, edt) {
    this.pkc_1 = portSupplier;
    this.qkc_1 = edt;
    this.rkc_1 = null;
    this.skc_1 = null;
    this.tkc_1 = null;
    this.ukc_1 = null;
  }
  protoOf(PortExecutingDelegate).ika = function () {
    lazyInit(this);
    return ensureNotNull(this.skc_1);
  };
  protoOf(PortExecutingDelegate).vkc = function (r) {
    if (this.tkc_1 == null) {
      try {
        this.qkc_1.u2m(new sam$jetbrains_ocelot_base_edt_EdtTask$0_2(r));
      } catch ($p) {
        if ($p instanceof EdtException) {
          var e = $p;
          this.tkc_1 = e;
          if (!(this.ukc_1 == null)) {
            ensureNotNull(this.ukc_1)(e);
          }
        } else {
          throw $p;
        }
      }
    }
  };
  protoOf(PortExecutingDelegate).ykc = function (output, internalErrorHandler) {
    lazyInit(this);
    if (!(this.tkc_1 == null)) {
      internalErrorHandler(ensureNotNull(this.tkc_1));
      return Unit_instance;
    }
    this.ukc_1 = internalErrorHandler;
    this.vkc(PortExecutingDelegate$setOutput$lambda(this, output));
  };
  protoOf(PortExecutingDelegate).mka = function (output, internalErrorHandler) {
    return this.ykc((output == null ? true : !(output == null)) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(PortExecutingDelegate).vr = function () {
    if (this.skc_1 == null || !(this.tkc_1 == null)) {
      return Unit_instance;
    }
    this.vkc(PortExecutingDelegate$closeInternally$ref(this));
  };
  function unwrap_1($this, operation) {
    var $this_0 = $this;
    var operation_0 = operation;
    $l$1: do {
      $l$0: do {
        var tmp;
        if (isInterface(operation_0, OperationContainer)) {
          tmp = !(operation_0 instanceof TargetedOperation);
        } else {
          tmp = false;
        }
        if (tmp) {
          var operationContainer = isInterface(operation_0, OperationContainer) ? operation_0 : THROW_CCE();
          var wrappedOps = operationContainer.l3i();
          if (wrappedOps.p())
            return null;
          var tmp_0;
          if (wrappedOps.n() === 1) {
            var tmp0 = $this_0;
            var tmp1 = wrappedOps.q(0);
            $this_0 = tmp0;
            operation_0 = tmp1;
            continue $l$0;
          } else {
            tmp_0 = wrappedOps;
          }
          return tmp_0;
        }
        return listOf(operation_0);
      }
       while (false);
    }
     while (true);
  }
  function RootOperationsUtil() {
  }
  protoOf(RootOperationsUtil).zkc = function (id, op) {
    var operation = this.akd(op);
    var tmp;
    if (operation instanceof AddRootOperation) {
      tmp = id.equals(operation.o3i());
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(RootOperationsUtil).bkd = function (id, op) {
    var tmp0_elvis_lhs = this.akd(op);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var operation = tmp;
    var tmp_0;
    if (operation instanceof AddRootOperation) {
      tmp_0 = id.equals(operation.o3i());
    } else {
      tmp_0 = false;
    }
    var isAddOp = tmp_0;
    var tmp_1;
    if (operation instanceof BuildRootOperation) {
      tmp_1 = id.equals(operation.o3i());
    } else {
      tmp_1 = false;
    }
    var isBuildOp = tmp_1;
    return isAddOp || isBuildOp;
  };
  protoOf(RootOperationsUtil).akd = function (op) {
    var unwrapped = unwrap_1(this, op);
    return unwrapped == null ? null : unwrapped.q(0);
  };
  var RootOperationsUtil_instance;
  function RootOperationsUtil_getInstance() {
    return RootOperationsUtil_instance;
  }
  function RootReconnectData(treeElement, version) {
    this.ckd_1 = treeElement;
    this.dkd_1 = version;
  }
  protoOf(RootReconnectData).toString = function () {
    return '[v=' + this.dkd_1 + ', root=' + this.ckd_1.toString() + ']';
  };
  function _get_wrappedInput__vocaje($this) {
    if ($this.pkd_1 == null) {
      $this.pkd_1 = ensureNotNull($this.qkd_1)();
    }
    return ensureNotNull($this.pkd_1);
  }
  function process_1($this) {
    $this.skd();
    var start = $this.qkc_1.t2m();
    while (!$this.nkd_1.p() && $this.qkc_1.t2m().j3(start).d1(toLong($this.kkd_1)) <= 0) {
      var array = $this.nkd_1.fg();
      _get_wrappedInput__vocaje($this).dka(array);
    }
    var elapsedTime = $this.qkc_1.t2m().j3(start);
    var shouldWarn = elapsedTime.d1(toLong($this.mkd_1)) > 0;
    if (elapsedTime.d1(toLong($this.kkd_1)) > 0) {
      Companion_getInstance_234().tkd_1.go('OT Messages handling took more than ' + $this.kkd_1 + ' ms, the next messages handling is delayed ' + ('for ' + $this.lkd_1 + ' ms'));
      if (shouldWarn) {
        Companion_getInstance_234().tkd_1.fo('OT Messages handling took ' + elapsedTime.toString() + ' ms, consider profiling and optimizing your code');
      }
      if ($this.rkd_1 == null) {
        var tmp = $this;
        var tmp_0 = ThrottlingJsonPort$process$lambda($this);
        tmp.rkd_1 = $this.qkc_1.v2m($this.lkd_1, new sam$jetbrains_ocelot_base_edt_EdtTask$0_3(tmp_0));
      }
    }
    $this.ukd(shouldWarn);
  }
  function Companion_234() {
    Companion_instance_234 = this;
    this.tkd_1 = getLogger(getKClass(ThrottlingJsonPort));
  }
  var Companion_instance_234;
  function Companion_getInstance_234() {
    if (Companion_instance_234 == null)
      new Companion_234();
    return Companion_instance_234;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_3(function_0) {
    this.vkd_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_3).wy = function () {
    return this.vkd_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_3).b4 = function () {
    return this.vkd_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_3).hashCode = function () {
    return hashCode(this.b4());
  };
  function ThrottlingJsonPort$createChannelDelegate$$inlined$jsonChannel$1(this$0) {
    this.wkd_1 = this$0;
  }
  protoOf(ThrottlingJsonPort$createChannelDelegate$$inlined$jsonChannel$1).fka = function (message) {
    this.wkd_1.nkd_1.e(message);
    var tmp;
    if (this.wkd_1.rkd_1 == null) {
      process_1(this.wkd_1);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(ThrottlingJsonPort$createChannelDelegate$$inlined$jsonChannel$1).dka = function (message) {
    return this.fka(message instanceof JsonArray ? message : THROW_CCE());
  };
  function ThrottlingJsonPort$process$lambda(this$0) {
    return function () {
      this$0.rkd_1 = null;
      process_1(this$0);
      return Unit_instance;
    };
  }
  function ThrottlingJsonPort(portSupplier, edt, runLimit, runDelay, warnLimit) {
    Companion_getInstance_234();
    warnLimit = warnLimit === VOID ? runLimit : warnLimit;
    PortExecutingDelegate.call(this, portSupplier, edt);
    this.kkd_1 = runLimit;
    this.lkd_1 = runDelay;
    this.mkd_1 = warnLimit;
    this.nkd_1 = ArrayDeque_init_$Create$();
    this.okd_1 = Companion_getInstance_25().wr_1;
    this.pkd_1 = null;
    this.qkd_1 = null;
    this.rkd_1 = null;
  }
  protoOf(ThrottlingJsonPort).xkd = function (channelSupplier) {
    this.qkd_1 = channelSupplier;
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.json.jsonChannel' call
    return new ThrottlingJsonPort$createChannelDelegate$$inlined$jsonChannel$1(this);
  };
  protoOf(ThrottlingJsonPort).wkc = function (channelSupplier) {
    return this.xkd(channelSupplier);
  };
  protoOf(ThrottlingJsonPort).skd = function () {
  };
  protoOf(ThrottlingJsonPort).ukd = function (longRun) {
  };
  protoOf(ThrottlingJsonPort).vr = function () {
    this.okd_1.vr();
    if (!(this.rkd_1 == null)) {
      ensureNotNull(this.rkd_1).vr();
    }
    protoOf(PortExecutingDelegate).vr.call(this);
  };
  function ProtocolPersistentParameter(tag, persister) {
    this.ykd_1 = tag;
    this.zkd_1 = persister;
  }
  protoOf(ProtocolPersistentParameter).p2y = function () {
    return this.ykd_1;
  };
  protoOf(ProtocolPersistentParameter).m2y = function () {
    return this.zkd_1;
  };
  protoOf(ProtocolPersistentParameter).i2y = function () {
    return true;
  };
  function BooleanPersistentParameter(key) {
    ProtocolPersistentParameter.call(this, key, Persisters_getInstance().l2q());
  }
  function LongPersistentParameter(key) {
    ProtocolPersistentParameter.call(this, key, Persisters_getInstance().k2q());
  }
  function StringPersistentParameter(key) {
    ProtocolPersistentParameter.call(this, key, Persisters_getInstance().a2r());
  }
  function ProtocolParameters$RECONNECT_ENABLED$1() {
    BooleanPersistentParameter.call(this, 'r');
  }
  protoOf(ProtocolParameters$RECONNECT_ENABLED$1).g2y = function () {
    return true;
  };
  protoOf(ProtocolParameters$RECONNECT_ENABLED$1).toString = function () {
    return 'reconnect protocol parameter';
  };
  function ProtocolParameters$PING_TIMEOUT_MS$1() {
    LongPersistentParameter.call(this, 'pt');
  }
  protoOf(ProtocolParameters$PING_TIMEOUT_MS$1).g2y = function () {
    return new Long(30000, 0);
  };
  protoOf(ProtocolParameters$PING_TIMEOUT_MS$1).toString = function () {
    return 'ping timeout in milliseconds protocol parameter';
  };
  function ProtocolParameters$ID_COMPRESSION_ENABLED$1() {
    BooleanPersistentParameter.call(this, 'i');
  }
  protoOf(ProtocolParameters$ID_COMPRESSION_ENABLED$1).g2y = function () {
    return true;
  };
  protoOf(ProtocolParameters$ID_COMPRESSION_ENABLED$1).toString = function () {
    return 'id compression protocol parameter';
  };
  function ProtocolParameters$PARTIAL_LOADING_ENABLED$1() {
    BooleanPersistentParameter.call(this, 'p');
  }
  protoOf(ProtocolParameters$PARTIAL_LOADING_ENABLED$1).g2y = function () {
    return false;
  };
  protoOf(ProtocolParameters$PARTIAL_LOADING_ENABLED$1).toString = function () {
    return 'partial loading protocol parameter';
  };
  function ProtocolParameters$OT_VERSION$1() {
    StringPersistentParameter.call(this, 'otv');
  }
  protoOf(ProtocolParameters$OT_VERSION$1).g2y = function () {
    return '6';
  };
  protoOf(ProtocolParameters$OT_VERSION$1).toString = function () {
    return 'ot version protocol parameter';
  };
  function ProtocolParameters() {
    ProtocolParameters_instance = this;
    var tmp = this;
    tmp.kke_1 = new ProtocolParameters$RECONNECT_ENABLED$1();
    var tmp_0 = this;
    tmp_0.lke_1 = new ProtocolParameters$PING_TIMEOUT_MS$1();
    var tmp_1 = this;
    tmp_1.mke_1 = new ProtocolParameters$ID_COMPRESSION_ENABLED$1();
    var tmp_2 = this;
    tmp_2.nke_1 = new ProtocolParameters$PARTIAL_LOADING_ENABLED$1();
    var tmp_3 = this;
    tmp_3.oke_1 = new ProtocolParameters$OT_VERSION$1();
  }
  var ProtocolParameters_instance;
  function ProtocolParameters_getInstance() {
    if (ProtocolParameters_instance == null)
      new ProtocolParameters();
    return ProtocolParameters_instance;
  }
  function ProtocolPersistentContext() {
    ConfigurationPersistentContext.call(this);
    this.o2y(ProtocolParameters_getInstance().kke_1);
    this.o2y(ProtocolParameters_getInstance().lke_1);
    this.o2y(ProtocolParameters_getInstance().mke_1);
    this.o2y(ProtocolParameters_getInstance().nke_1);
    this.o2y(ProtocolParameters_getInstance().oke_1);
  }
  function Companion_235() {
  }
  protoOf(Companion_235).pke = function (array, shift) {
    var commandId = CommandId_init_$Create$_0(array.m2u(shift));
    var rootId = EntityId_init_$Create$_0(array.m2u(shift + 1 | 0));
    return new RootCommandId(commandId, rootId);
  };
  var Companion_instance_235;
  function Companion_getInstance_235() {
    return Companion_instance_235;
  }
  function CommandDeserializer(context) {
    this.qke_1 = new DictionaryAwareOperationDeserializer(context);
  }
  protoOf(CommandDeserializer).o4d = function (json) {
    var index = 0;
    var id = Companion_instance_235.pke(json, index);
    index = index + 2 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var baseVersion = json.q2u(_unary__edvuaz);
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    var resultVersion = json.q2u(_unary__edvuaz_0);
    var operation = this.qke_1.o4d(json.l2u(index));
    return new Command(id, baseVersion, resultVersion, operation);
  };
  protoOf(CommandDeserializer).vr = function () {
  };
  function Companion_236() {
  }
  protoOf(Companion_236).rke = function (array, commandId, rootId) {
    array.h2u(commandId.i2s_1);
    array.h2u(rootId.i2s_1);
  };
  var Companion_instance_236;
  function Companion_getInstance_236() {
    return Companion_instance_236;
  }
  function CommandSerializer(context) {
    this.ske_1 = new DictionaryAwareOperationSerializer(context);
  }
  protoOf(CommandSerializer).tke = function (command) {
    var message = new JsonArray();
    Companion_instance_236.rke(message, command.c4r_1.g4r_1, command.c4r_1.h4r_1);
    message.j2u(command.d4r_1);
    message.j2u(command.e4r_1);
    message.s2t(this.ske_1.u4d(command.f4r_1));
    return message;
  };
  function DictionaryAwareOperationDeserializer(context) {
    DictionaryAwareDeserializer.call(this, context.m4c_1.k4g());
    this.wke_1 = context;
  }
  protoOf(DictionaryAwareOperationDeserializer).n4d = function (json) {
    return this.wke_1.e4i(json instanceof JsonArray ? json : THROW_CCE());
  };
  function DictionaryAwareOperationSerializer(context) {
    DictionaryAwareSerializer.call(this, context.m4c_1.k4g());
    this.zke_1 = context;
  }
  protoOf(DictionaryAwareOperationSerializer).akf = function (value) {
    return this.zke_1.d4i(value);
  };
  protoOf(DictionaryAwareOperationSerializer).t4d = function (value) {
    return this.akf((!(value == null) ? isInterface(value, Operation) : false) ? value : THROW_CCE());
  };
  function getFullSerializerFactory($this) {
    // Inline function 'jetbrains.ocelot.ot.model.protocol.json.commandSerializerFactory' call
    return new Json2OtChannelAdapter$Companion$getFullSerializerFactory$$inlined$commandSerializerFactory$1();
  }
  function Json2OtChannelAdapter$Companion$getFullSerializerFactory$$inlined$commandSerializerFactory$1() {
  }
  protoOf(Json2OtChannelAdapter$Companion$getFullSerializerFactory$$inlined$commandSerializerFactory$1).bkf = function (idCompressor, persistenceContextFactory, nodeFactory) {
    // Inline function 'jetbrains.ocelot.ot.model.protocol.json.Companion.getFullSerializerFactory.<anonymous>' call
    var context = persistenceContextFactory.ckf(idCompressor, nodeFactory);
    return new CommandSerializer(context);
  };
  function Json2OtChannelAdapter_init_$Init$(idCompressor, channel, nodeFactory, $this) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    Json2OtChannelAdapter.call($this, idCompressor, null, null, null, channel, nodeFactory);
    return $this;
  }
  function Json2OtChannelAdapter_init_$Create$(idCompressor, channel, nodeFactory) {
    return Json2OtChannelAdapter_init_$Init$(idCompressor, channel, nodeFactory, objectCreate(protoOf(Json2OtChannelAdapter)));
  }
  function sendMessage($this, commandKind, id, additional) {
    var message = createMessage($this, commandKind, id.g4r_1, id.h4r_1, additional);
    $this.dkf_1.dka(message);
  }
  function createMessage($this, commandKind, commandId, rootId, additional) {
    var message = new JsonArray();
    message.h2u(commandKind);
    Companion_instance_236.rke(message, commandId, rootId);
    var inductionVariable = 0;
    var last = additional.length;
    while (inductionVariable < last) {
      var integer = additional[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      message.i2u(integer);
    }
    return message;
  }
  function sendLoadMessage($this, commandKind, commandId, additional) {
    var message = createMessage($this, commandKind, commandId.j4r_1, commandId.o3i(), additional);
    if (!commandId.l4r()) {
      message.h2u(commandId.r3i().i2s_1);
    }
    $this.dkf_1.dka(message);
  }
  function toMessage($this, rootIds) {
    var tmp;
    if (rootIds.n() === 1) {
      tmp = new JsonString(first_0(rootIds).i2s_1);
    } else {
      var array = new JsonArray();
      var _iterator__ex2g4s = rootIds.k();
      while (_iterator__ex2g4s.l()) {
        var entityId = _iterator__ex2g4s.m();
        array.h2u(entityId.i2s_1);
      }
      tmp = array;
    }
    return tmp;
  }
  function Companion_237() {
  }
  var Companion_instance_237;
  function Companion_getInstance_237() {
    return Companion_instance_237;
  }
  function Json2OtChannelAdapter$$inlined$entityOperationPersistenceContextFactory$1() {
  }
  protoOf(Json2OtChannelAdapter$$inlined$entityOperationPersistenceContextFactory$1).ckf = function (idCompressor, nodeFactory) {
    // Inline function 'jetbrains.ocelot.ot.model.protocol.json.Json2OtChannelAdapter.stub_for_inlining' call
    return EntityOperationPersistenceContext_init_$Create$(idCompressor, nodeFactory);
  };
  function Json2OtChannelAdapter$1() {
    JsonReconnectHelper.call(this);
  }
  protoOf(Json2OtChannelAdapter$1).hkf = function () {
    return new RootReconnectDataPersister();
  };
  function Json2OtChannelAdapter(idCompressor, commandSerializerFactory, persistenceContextFactory, reconnectHelper, channel, nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.dkf_1 = channel;
    var serializerFactory = commandSerializerFactory;
    var contextFactory = persistenceContextFactory;
    if (contextFactory == null) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.entity.operationContext.entityOperationPersistenceContextFactory' call
      contextFactory = new Json2OtChannelAdapter$$inlined$entityOperationPersistenceContextFactory$1();
    }
    var fullSerializerFactory = getFullSerializerFactory(Companion_instance_237);
    if (serializerFactory == null) {
      serializerFactory = fullSerializerFactory;
    }
    var tmp = this;
    var tmp_0;
    if (reconnectHelper == null) {
      tmp_0 = new Json2OtChannelAdapter$1();
    } else {
      tmp_0 = reconnectHelper;
    }
    tmp.gkf_1 = tmp_0;
    this.ekf_1 = serializerFactory.bkf(idCompressor, contextFactory, nodeFactory);
    this.fkf_1 = fullSerializerFactory.bkf(idCompressor, contextFactory, nodeFactory);
  }
  protoOf(Json2OtChannelAdapter).ykb = function (command) {
    var message = new JsonArray();
    message.h2u('cr');
    message.s2t(this.ekf_1.tke(command));
    this.dkf_1.dka(message);
  };
  protoOf(Json2OtChannelAdapter).zkb = function (id, baseVersion, resultVersion) {
    sendMessage(this, 'ca', id, new Int32Array([baseVersion, resultVersion]));
  };
  protoOf(Json2OtChannelAdapter).akc = function (id, reason) {
    sendMessage(this, 'cj', id, new Int32Array([reason.a3_1]));
  };
  protoOf(Json2OtChannelAdapter).bkc = function (id) {
    sendMessage(this, 'rh', id, new Int32Array([]));
  };
  protoOf(Json2OtChannelAdapter).ckc = function (id, rootsToLoad) {
    this.dkf_1.dka(this.gkf_1.ikf(id, rootsToLoad));
  };
  protoOf(Json2OtChannelAdapter).dkc = function (id) {
    sendMessage(this, 'ra', id, new Int32Array([]));
  };
  protoOf(Json2OtChannelAdapter).ekc = function (id, reason) {
    sendLoadMessage(this, 'rr', id, new Int32Array([reason.a3_1]));
  };
  protoOf(Json2OtChannelAdapter).fkc = function (id) {
    sendLoadMessage(this, 'lf', id, new Int32Array([]));
  };
  protoOf(Json2OtChannelAdapter).gkc = function (id) {
    sendLoadMessage(this, 'lfa', id, new Int32Array([]));
  };
  protoOf(Json2OtChannelAdapter).hkc = function (id, reason) {
    sendLoadMessage(this, 'lfr', id, new Int32Array([reason.a3_1]));
  };
  protoOf(Json2OtChannelAdapter).ikc = function (id, from, to) {
    sendMessage(this, 'lh', id, new Int32Array([from, to]));
  };
  protoOf(Json2OtChannelAdapter).jkc = function (id, history) {
    var message = new JsonArray();
    message.h2u('lha');
    Companion_instance_236.rke(message, id.g4r_1, id.h4r_1);
    var commandsArray = new JsonArray();
    var _iterator__ex2g4s = history.k();
    while (_iterator__ex2g4s.l()) {
      var otOperationRecord = _iterator__ex2g4s.m();
      var operationJson = this.fkf_1.tke(new Command(otOperationRecord.n4r_1, otOperationRecord.p4r_1, otOperationRecord.q4r_1, otOperationRecord.o4r_1));
      commandsArray.s2t(operationJson);
    }
    message.s2t(commandsArray);
    this.dkf_1.dka(message);
  };
  protoOf(Json2OtChannelAdapter).kkc = function (id, reason) {
    sendMessage(this, 'lhr', id, new Int32Array([reason.a3_1]));
  };
  protoOf(Json2OtChannelAdapter).lkc = function (id, rootIds) {
    var message = new JsonArray();
    message.h2u('u');
    message.h2u(id.i2s_1);
    message.s2t(toMessage(this, rootIds));
    this.dkf_1.dka(message);
  };
  protoOf(Json2OtChannelAdapter).mkc = function (id, rootIds) {
    var message = new JsonArray();
    message.h2u('uh');
    message.h2u(id.i2s_1);
    message.s2t(toMessage(this, rootIds));
    this.dkf_1.dka(message);
  };
  protoOf(Json2OtChannelAdapter).nkc = function (commandId) {
    sendMessage(this, 'sa', commandId, new Int32Array([]));
  };
  function toJson($this, data) {
    var array = new JsonArray();
    var persister = $this.hkf();
    var _iterator__ex2g4s = data.k();
    while (_iterator__ex2g4s.l()) {
      var d = _iterator__ex2g4s.m();
      array.s2t(persister.lkf(d));
    }
    return array;
  }
  function readRootLoadData($this, array) {
    var data = ArrayList_init_$Create$();
    var persister = $this.hkf();
    var inductionVariable = 0;
    var last = array.wo();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data.e(persister.o4d(array.l2u(i)));
      }
       while (inductionVariable < last);
    return data;
  }
  function Data(commandId, rootsToLoad) {
    this.mkf_1 = commandId;
    this.nkf_1 = rootsToLoad;
  }
  function JsonReconnectHelper() {
  }
  protoOf(JsonReconnectHelper).ikf = function (commandId, rootsToLoad) {
    var json = new JsonArray();
    json.h2u('rc');
    json.h2u(commandId.i2s_1);
    json.s2t(toJson(this, rootsToLoad));
    return json;
  };
  protoOf(JsonReconnectHelper).jkf = function (json) {
    var index = 1;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var id = CommandId_init_$Create$_0(json.m2u(_unary__edvuaz));
    var rootsToLoad = readRootLoadData(this, json.l2u(index));
    return new Data(id, rootsToLoad);
  };
  function deserialize_0($this, json, parent) {
    if (json instanceof JsonString) {
      return createTreeElement($this, EntityId_init_$Create$_0(json.n2u_1), parent);
    }
    var i = (json instanceof JsonArray ? json : THROW_CCE()).k();
    var tmp = i.m();
    var element = createTreeElement($this, EntityId_init_$Create$_0((tmp instanceof JsonString ? tmp : THROW_CCE()).n2u_1), parent);
    while (i.l()) {
      deserialize_0($this, i.m(), element);
    }
    return element;
  }
  function createTreeElement($this, id, parent) {
    var tmp1_elvis_lhs = parent == null ? null : parent.ikb(id);
    return tmp1_elvis_lhs == null ? new LoadedEntitiesTreeElement(id) : tmp1_elvis_lhs;
  }
  function LoadedEntitiesTreeElementPersister() {
  }
  protoOf(LoadedEntitiesTreeElementPersister).okf = function (element) {
    if (element.jkb()) {
      return new JsonString(element.akb_1.i2s_1);
    }
    var json = new JsonArray();
    json.h2u(element.akb_1.i2s_1);
    var _iterator__ex2g4s = ensureNotNull(element.tkb()).k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      json.s2t(this.okf(child));
    }
    return json;
  };
  protoOf(LoadedEntitiesTreeElementPersister).pkf = function (json) {
    return deserialize_0(this, json, null);
  };
  function Ot2JsonChannelAdapter_init_$Init$(idCompressor, channel, nodeFactory, $this) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    Ot2JsonChannelAdapter.call($this, idCompressor, null, null, channel, nodeFactory);
    return $this;
  }
  function Ot2JsonChannelAdapter_init_$Create$(idCompressor, channel, nodeFactory) {
    return Ot2JsonChannelAdapter_init_$Init$(idCompressor, channel, nodeFactory, objectCreate(protoOf(Ot2JsonChannelAdapter)));
  }
  function getLoadingEntityId($this, json, pos) {
    return json.wo() <= pos ? null : EntityId_init_$Create$_0(json.m2u(pos));
  }
  function connected($this) {
    return !($this.vkf_1 == null);
  }
  function readEntityIds($this, json) {
    var tmp;
    if (json instanceof JsonArray) {
      var set = HashSet_init_$Create$();
      var inductionVariable = 0;
      var last = json.wo();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          set.e(EntityId_init_$Create$_0(json.m2u(i)));
        }
         while (inductionVariable < last);
      tmp = set;
    } else {
      tmp = setOf(EntityId_init_$Create$_0((json instanceof JsonString ? json : THROW_CCE()).n2u_1));
    }
    return tmp;
  }
  function readData($this, json) {
    var index = 1;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var commandId = CommandId_init_$Create$_0(json.m2u(_unary__edvuaz));
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    var rootId = EntityId_init_$Create$_0(json.m2u(_unary__edvuaz_0));
    return new MyRootCommandData(commandId, rootId, json.q2u(index));
  }
  function getRootCommandId($this, jsonCommand) {
    return Companion_instance_235.pke(jsonCommand, 1);
  }
  function getLoadCommandId($this, json) {
    var index = 1;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var commandId = CommandId_init_$Create$_0(json.m2u(_unary__edvuaz));
    var _unary__edvuaz_0 = index;
    index = _unary__edvuaz_0 + 1 | 0;
    var rootId = EntityId_init_$Create$_0(json.m2u(_unary__edvuaz_0));
    var entityId = getLoadingEntityId($this, json, index);
    return LoadCommandId_init_$Create$_0(commandId, rootId, entityId);
  }
  function MyRootCommandData(commandId, rootId, value) {
    this.wkf_1 = commandId;
    this.xkf_1 = rootId;
    this.ykf_1 = value;
  }
  protoOf(MyRootCommandData).zkf = function () {
    return new RootCommandId(this.wkf_1, this.xkf_1);
  };
  protoOf(MyRootCommandData).akg = function () {
    return values()[this.ykf_1];
  };
  function Ot2JsonChannelAdapter$persistenceContextFactory$$inlined$entityOperationPersistenceContextFactory$1() {
  }
  protoOf(Ot2JsonChannelAdapter$persistenceContextFactory$$inlined$entityOperationPersistenceContextFactory$1).ckf = function (idCompressor, nodeFactory) {
    // Inline function 'jetbrains.ocelot.ot.model.protocol.json.Ot2JsonChannelAdapter.persistenceContextFactory.stub_for_inlining' call
    return EntityOperationPersistenceContext_init_$Create$(idCompressor, nodeFactory);
  };
  function Ot2JsonChannelAdapter$reconnectHelper$1() {
    JsonReconnectHelper.call(this);
  }
  protoOf(Ot2JsonChannelAdapter$reconnectHelper$1).hkf = function () {
    return new RootReconnectDataPersister();
  };
  function Ot2JsonChannelAdapter(idCompressor, persistenceContextFactory, reconnectHelper, channel, nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.qkf_1 = idCompressor;
    this.rkf_1 = channel;
    this.skf_1 = nodeFactory;
    var tmp = this;
    var tmp_0;
    if (persistenceContextFactory == null) {
      // Inline function 'jetbrains.ocelot.ot.model.ot.persistence.entity.operationContext.entityOperationPersistenceContextFactory' call
      tmp_0 = new Ot2JsonChannelAdapter$persistenceContextFactory$$inlined$entityOperationPersistenceContextFactory$1();
    } else {
      tmp_0 = persistenceContextFactory;
    }
    tmp.tkf_1 = tmp_0;
    var tmp_1 = this;
    var tmp_2;
    if (reconnectHelper == null) {
      tmp_2 = new Ot2JsonChannelAdapter$reconnectHelper$1();
    } else {
      tmp_2 = reconnectHelper;
    }
    tmp_1.ukf_1 = tmp_2;
    this.vkf_1 = null;
  }
  protoOf(Ot2JsonChannelAdapter).bkg = function () {
    // Inline function 'kotlin.check' call
    if (!!connected(this)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp0_safe_receiver = this.qkf_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.m2();
    }
    var context = this.tkf_1.ckf(this.qkf_1, this.skf_1);
    this.vkf_1 = new CommandDeserializer(context);
  };
  protoOf(Ot2JsonChannelAdapter).fka = function (message) {
    var op = message.m2u(0);
    switch (op) {
      case 'cr':
        this.rkf_1.ykb(ensureNotNull(this.vkf_1).o4d(message.l2u(1)));
        break;
      case 'ca':
        this.rkf_1.zkb(getRootCommandId(this, message), message.q2u(3), message.q2u(4));
        break;
      case 'lfa':
        this.rkf_1.gkc(getLoadCommandId(this, message));
        break;
      case 'lfr':
        var data = readData(this, message);
        var entityId = getLoadingEntityId(this, message, 4);
        this.rkf_1.hkc(LoadCommandId_init_$Create$_0(data.wkf_1, data.xkf_1, entityId), data.akg());
        break;
      case 'lf':
        var rootCommandId = getRootCommandId(this, message);
        var entityId_0 = getLoadingEntityId(this, message, 3);
        this.rkf_1.fkc(LoadCommandId_init_$Create$_0(rootCommandId.g4r_1, rootCommandId.h4r_1, entityId_0));
        break;
      case 'lh':
        this.rkf_1.ikc(getRootCommandId(this, message), message.q2u(3), message.q2u(4));
        break;
      case 'lha':
        var commandsArray = message.l2u(3);
        var history = ArrayList_init_$Create$();
        var _iterator__ex2g4s = commandsArray.k();
        while (_iterator__ex2g4s.l()) {
          var commandJson = _iterator__ex2g4s.m();
          var tmp = ensureNotNull(this.vkf_1);
          history.e(OtOperationRecord_init_$Create$(tmp.o4d(commandJson instanceof JsonArray ? commandJson : THROW_CCE())));
        }

        this.rkf_1.jkc(getRootCommandId(this, message), history);
        break;
      case 'lhr':
        var data_0 = readData(this, message);
        this.rkf_1.kkc(data_0.zkf(), data_0.akg());
        break;
      case 'ra':
        this.rkf_1.dkc(getRootCommandId(this, message));
        break;
      case 'rr':
        var d = readData(this, message);
        var entityId_1 = getLoadingEntityId(this, message, 4);
        this.rkf_1.ekc(LoadCommandId_init_$Create$_0(d.wkf_1, d.xkf_1, entityId_1), d.akg());
        break;
      case 'rc':
        var d_0 = this.ukf_1.jkf(message);
        this.rkf_1.ckc(d_0.mkf_1, d_0.nkf_1);
        break;
      case 'uh':
        this.rkf_1.mkc(CommandId_init_$Create$_0(message.m2u(1)), readEntityIds(this, message.q(2)));
        break;
      case 'u':
        this.rkf_1.lkc(CommandId_init_$Create$_0(message.m2u(1)), readEntityIds(this, message.q(2)));
        break;
      case 'cj':
        var d_1 = readData(this, message);
        this.rkf_1.akc(d_1.zkf(), d_1.akg());
        break;
      case 'rh':
        this.rkf_1.bkc(getRootCommandId(this, message));
        break;
      case 'sa':
        this.rkf_1.nkc(getRootCommandId(this, message));
        break;
      default:
        throw RuntimeException_init_$Create$_0(op);
    }
  };
  protoOf(Ot2JsonChannelAdapter).dka = function (message) {
    return this.fka(message instanceof JsonArray ? message : THROW_CCE());
  };
  protoOf(Ot2JsonChannelAdapter).vr = function () {
    ensureNotNull(this.vkf_1).vr();
    this.vkf_1 = null;
  };
  function RootReconnectDataPersister() {
    this.kkf_1 = new LoadedEntitiesTreeElementPersister();
  }
  protoOf(RootReconnectDataPersister).lkf = function (data) {
    var json = new JsonArray();
    json.i2u(data.dkd_1);
    json.s2t(this.kkf_1.okf(data.ckd_1));
    return json;
  };
  protoOf(RootReconnectDataPersister).o4d = function (json) {
    var version = json.q2u(0);
    var treeElement = this.kkf_1.pkf(json.q(1));
    return new RootReconnectData(treeElement, version);
  };
  function defaultClientIdCompressorSupplier() {
    return defaultClientIdCompressorSupplier$lambda;
  }
  function defaultClientIdCompressorSupplier$lambda() {
    return DefaultSelfUpdatingIdCompressor_init_$Create$();
  }
  function EndpointMultiplexPort$ServiceEndpointPort$setOutput$$inlined$stringChannel$1(this$0, $output, this$1) {
    this.ckg_1 = this$0;
    this.dkg_1 = $output;
    this.ekg_1 = this$1;
  }
  protoOf(EndpointMultiplexPort$ServiceEndpointPort$setOutput$$inlined$stringChannel$1).hka = function (message) {
    var tmp;
    if (!(this.ckg_1.nkg_1.qr() === EndpointMultiplexPortState_CLOSED_getInstance())) {
      this.dkg_1.dka(new ServiceContainerMessage(this.ekg_1.gkg_1, this.ekg_1.hkg_1, message));
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(EndpointMultiplexPort$ServiceEndpointPort$setOutput$$inlined$stringChannel$1).dka = function (message) {
    return this.hka((!(message == null) ? typeof message === 'string' : false) ? message : THROW_CCE());
  };
  function onServiceContainerMessage($this, message) {
    var serviceName = message.rkg_1;
    if ('sercnt' === serviceName) {
      onSystemMessage($this, message.tkg_1);
      return Unit_instance;
    }
    var port = $this.kkg_1.y2(serviceName);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (port == null) {
        // Inline function 'jetbrains.ocelot.ot.model.protocol.service.EndpointMultiplexPort.onServiceContainerMessage.<anonymous>' call
        var message_0 = 'No port for service ' + serviceName;
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        break $l$block;
      }
    }
    if (!(message.skg_1 === port.hkg_1)) {
      Companion_getInstance_238().ukg_1.fo('Message with incorrect portId received. Expected: ' + port.hkg_1 + '. Actual: ' + message.skg_1 + '. Message: ' + message.toString());
    }
    port.ika().dka(message.tkg_1);
  }
  function onSystemMessage($this, rawMessage) {
    var systemMessage;
    try {
      systemMessage = ServiceContainerMessageUtil_instance.vkg(rawMessage);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        handle($this, e);
        return Unit_instance;
      } else {
        throw $p;
      }
    }
    var serviceAndPort = systemMessage.ykg();
    switch (systemMessage.wkg_1) {
      case 'cl':
        if (serviceAndPort == null) {
          handle($this, IllegalArgumentException_init_$Create$_0('Wrong close port message format: ' + rawMessage));
          return Unit_instance;
        }

        onSystemClosePortMessage($this, serviceAndPort.dh_1, serviceAndPort.eh_1);
        break;
      case 'op':
        if (serviceAndPort == null) {
          handle($this, IllegalArgumentException_init_$Create$_0('Wrong open port message format: ' + rawMessage));
          return Unit_instance;
        }

        onSystemOpenPortMessage($this, serviceAndPort.dh_1, serviceAndPort.eh_1);
        break;
      case 'cfg':
        var payload = systemMessage.xkg_1;
        var tmp = Json_getInstance().t2t(payload);
        var json = tmp instanceof JsonObject ? tmp : THROW_CCE();
        var configurationPersister = new ConfigurationPersister($this.jkg_1.zkg_1);
        var configuration = configurationPersister.s2y(json);
        onSystemConfigurationMessage($this, configuration);
        break;
      default:
        handle($this, IllegalArgumentException_init_$Create$_0('Unexpected action type=' + systemMessage.wkg_1 + ', message=' + rawMessage));
        break;
    }
  }
  function onSystemConfigurationMessage($this, configuration) {
    var tmp0 = $this.lkg_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'jetbrains.ocelot.ot.model.protocol.service.EndpointMultiplexPort.onSystemConfigurationMessage.<anonymous>' call
        var message = 'Output is null';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    $this.jkg_1.fkh(configuration);
    doSendMessage($this, ServiceContainerConstants_instance.nkh($this.jkg_1.gkh().u2()));
  }
  function onSystemOpenPortMessage($this, serviceName, portId) {
    var service = $this.jkg_1.gkh().y2(serviceName);
    if (service == null) {
      handle($this, IllegalArgumentException_init_$Create$_0('Unknown service ' + serviceName));
      return Unit_instance;
    }
    var port = null;
    if (portId < 0) {
      handle($this, IllegalArgumentException_init_$Create$_0('Received incorrect port id ' + portId));
      return Unit_instance;
    }
    if (!$this.kkg_1.w2(serviceName)) {
      port = new ServiceEndpointPort($this, service.oka(), serviceName, portId);
      var tmp0 = $this.kkg_1;
      // Inline function 'kotlin.collections.set' call
      var value = port;
      tmp0.r2(serviceName, value);
    }
    if (port == null) {
      handle($this, IllegalStateException_init_$Create$_0('Port for service ' + serviceName + ' is already opened'));
      return Unit_instance;
    }
    port.okh(outputChannel($this), ensureNotNull($this.mkg_1));
    Companion_getInstance_238().ukg_1.go('Port opened for service ' + serviceName);
  }
  function onSystemClosePortMessage($this, serviceName, portId) {
    var port = $this.kkg_1.s2(serviceName);
    if (port == null) {
      handle($this, RuntimeException_init_$Create$_0('No port to close for service ' + serviceName));
      return Unit_instance;
    }
    if (!(port.hkg_1 === portId)) {
      Companion_getInstance_238().ukg_1.do('Receive close port message with incorrect port id. Expected ' + port.hkg_1 + ', actual ' + portId + '. Service is ' + serviceName);
    }
    port.vr();
    Companion_getInstance_238().ukg_1.go('Port closed for service ' + serviceName);
  }
  function handle($this, t) {
    var errorHandler = $this.mkg_1;
    if (errorHandler == null) {
      Companion_getInstance_238().ukg_1.eo('Exception happened', t);
    } else {
      errorHandler(t);
    }
  }
  function outputChannel($this) {
    // Inline function 'jetbrains.ocelot.ot.model.protocol.service.serviceContainerChannel' call
    return new EndpointMultiplexPort$outputChannel$$inlined$serviceContainerChannel$1($this);
  }
  function doSendMessage($this, message) {
    if ($this.lkg_1 == null) {
      return Unit_instance;
    }
    try {
      ensureNotNull($this.lkg_1).dka(message);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        handle($this, t);
      } else {
        throw $p;
      }
    }
  }
  function ServiceEndpointPort($outer, port, serviceName, id) {
    this.ikg_1 = $outer;
    this.fkg_1 = port;
    this.gkg_1 = serviceName;
    this.hkg_1 = id;
  }
  protoOf(ServiceEndpointPort).ika = function () {
    return this.fkg_1.ika();
  };
  protoOf(ServiceEndpointPort).vr = function () {
    return this.fkg_1.vr();
  };
  protoOf(ServiceEndpointPort).okh = function (output, internalErrorHandler) {
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.stringChannel' call
    var tmp$ret$0 = new EndpointMultiplexPort$ServiceEndpointPort$setOutput$$inlined$stringChannel$1(this.ikg_1, output, this);
    this.fkg_1.mka(tmp$ret$0, internalErrorHandler);
  };
  protoOf(ServiceEndpointPort).mka = function (output, internalErrorHandler) {
    return this.okh((!(output == null) ? isInterface(output, ServiceContainerChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  function Companion_238() {
    Companion_instance_238 = this;
    this.ukg_1 = getLogger(getKClass(EndpointMultiplexPort));
  }
  var Companion_instance_238;
  function Companion_getInstance_238() {
    if (Companion_instance_238 == null)
      new Companion_238();
    return Companion_instance_238;
  }
  function EndpointMultiplexPort$input$$inlined$serviceContainerChannel$1(this$0) {
    this.pkh_1 = this$0;
  }
  protoOf(EndpointMultiplexPort$input$$inlined$serviceContainerChannel$1).qkh = function (message) {
    // Inline function 'jetbrains.ocelot.ot.model.protocol.service.EndpointMultiplexPort.input.stub_for_inlining' call
    var $receiver = this.pkh_1;
    onServiceContainerMessage($receiver, message);
    return Unit_instance;
  };
  protoOf(EndpointMultiplexPort$input$$inlined$serviceContainerChannel$1).dka = function (message) {
    return this.qkh(message instanceof ServiceContainerMessage ? message : THROW_CCE());
  };
  function EndpointMultiplexPort$outputChannel$$inlined$serviceContainerChannel$1(this$0) {
    this.rkh_1 = this$0;
  }
  protoOf(EndpointMultiplexPort$outputChannel$$inlined$serviceContainerChannel$1).qkh = function (message) {
    // Inline function 'jetbrains.ocelot.ot.model.protocol.service.EndpointMultiplexPort.outputChannel.stub_for_inlining' call
    var $receiver = this.rkh_1;
    doSendMessage($receiver, message);
    return Unit_instance;
  };
  protoOf(EndpointMultiplexPort$outputChannel$$inlined$serviceContainerChannel$1).dka = function (message) {
    return this.qkh(message instanceof ServiceContainerMessage ? message : THROW_CCE());
  };
  function EndpointMultiplexPort(container) {
    Companion_getInstance_238();
    this.jkg_1 = container;
    this.kkg_1 = newConcurrentHashMap();
    this.lkg_1 = null;
    this.mkg_1 = null;
    this.nkg_1 = new SynchronizedAtomicReference(EndpointMultiplexPortState_INIT_getInstance());
    var tmp = this;
    // Inline function 'jetbrains.ocelot.ot.model.protocol.service.serviceContainerChannel' call
    tmp.okg_1 = new EndpointMultiplexPort$input$$inlined$serviceContainerChannel$1(this);
  }
  protoOf(EndpointMultiplexPort).ika = function () {
    return this.okg_1;
  };
  protoOf(EndpointMultiplexPort).okh = function (output, internalErrorHandler) {
    // Inline function 'kotlin.check' call
    if (!this.nkg_1.skh(EndpointMultiplexPortState_INIT_getInstance(), EndpointMultiplexPortState_OPENING_getInstance())) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.EndpointMultiplexPort.setOutput.<anonymous>' call
      var message = 'Cannot set output for multiplex endpoint port in state ' + toString_1(this.nkg_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.lkg_1 = output;
    this.mkg_1 = internalErrorHandler;
    // Inline function 'kotlin.check' call
    if (!this.nkg_1.skh(EndpointMultiplexPortState_OPENING_getInstance(), EndpointMultiplexPortState_OPENED_getInstance())) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.EndpointMultiplexPort.setOutput.<anonymous>' call
      var message_0 = 'Cannot set output for multiplex endpoint port in state ' + toString_1(this.nkg_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  };
  protoOf(EndpointMultiplexPort).mka = function (output, internalErrorHandler) {
    return this.okh((!(output == null) ? isInterface(output, ServiceContainerChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(EndpointMultiplexPort).vr = function () {
    // Inline function 'kotlin.check' call
    if (!!(this.nkg_1.tkh(EndpointMultiplexPortState_CLOSED_getInstance()) === EndpointMultiplexPortState_CLOSED_getInstance())) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.EndpointMultiplexPort.dispose.<anonymous>' call
      var message = 'The port is already disposed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var _iterator__ex2g4s = this.kkg_1.v2().k();
    while (_iterator__ex2g4s.l()) {
      var port = _iterator__ex2g4s.m();
      port.vr();
    }
    this.lkg_1 = null;
    this.mkg_1 = null;
    this.jkg_1.ukh();
  };
  var EndpointMultiplexPortState_INIT_instance;
  var EndpointMultiplexPortState_OPENING_instance;
  var EndpointMultiplexPortState_OPENED_instance;
  var EndpointMultiplexPortState_CLOSED_instance;
  var EndpointMultiplexPortState_entriesInitialized;
  function EndpointMultiplexPortState_initEntries() {
    if (EndpointMultiplexPortState_entriesInitialized)
      return Unit_instance;
    EndpointMultiplexPortState_entriesInitialized = true;
    EndpointMultiplexPortState_INIT_instance = new EndpointMultiplexPortState('INIT', 0);
    EndpointMultiplexPortState_OPENING_instance = new EndpointMultiplexPortState('OPENING', 1);
    EndpointMultiplexPortState_OPENED_instance = new EndpointMultiplexPortState('OPENED', 2);
    EndpointMultiplexPortState_CLOSED_instance = new EndpointMultiplexPortState('CLOSED', 3);
  }
  function EndpointMultiplexPortState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function EndpointMultiplexPortState_INIT_getInstance() {
    EndpointMultiplexPortState_initEntries();
    return EndpointMultiplexPortState_INIT_instance;
  }
  function EndpointMultiplexPortState_OPENING_getInstance() {
    EndpointMultiplexPortState_initEntries();
    return EndpointMultiplexPortState_OPENING_instance;
  }
  function EndpointMultiplexPortState_OPENED_getInstance() {
    EndpointMultiplexPortState_initEntries();
    return EndpointMultiplexPortState_OPENED_instance;
  }
  function EndpointMultiplexPortState_CLOSED_getInstance() {
    EndpointMultiplexPortState_initEntries();
    return EndpointMultiplexPortState_CLOSED_instance;
  }
  function FatalEndpointException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    FatalEndpointException.call($this);
    return $this;
  }
  function FatalEndpointException_init_$Create$() {
    var tmp = FatalEndpointException_init_$Init$(objectCreate(protoOf(FatalEndpointException)));
    captureStack(tmp, FatalEndpointException_init_$Create$);
    return tmp;
  }
  function FatalEndpointException_init_$Init$_0(message, cause, $this) {
    RuntimeException_init_$Init$_1(message, cause, $this);
    FatalEndpointException.call($this);
    return $this;
  }
  function FatalEndpointException_init_$Create$_0(message, cause) {
    var tmp = FatalEndpointException_init_$Init$_0(message, cause, objectCreate(protoOf(FatalEndpointException)));
    captureStack(tmp, FatalEndpointException_init_$Create$_0);
    return tmp;
  }
  function FatalEndpointException() {
    captureStack(this, FatalEndpointException);
  }
  function getSource($this) {
    if ($this.xkh_1 == null) {
      $this.xkh_1 = $this.vkh_1();
    }
    return ensureNotNull($this.xkh_1);
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_4(function_0) {
    this.ykh_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_4).wy = function () {
    return this.ykh_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_4).b4 = function () {
    return this.ykh_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_4).hashCode = function () {
    return hashCode(this.b4());
  };
  function JsonPortExecutingDelegate$JsonChannelExecutingDelegate$messageReceived$lambda(this$0, $message) {
    return function () {
      getSource(this$0).dka($message);
      return Unit_instance;
    };
  }
  function JsonChannelExecutingDelegate(sourceSupplier, edt) {
    this.vkh_1 = sourceSupplier;
    this.wkh_1 = edt;
    this.xkh_1 = null;
  }
  protoOf(JsonChannelExecutingDelegate).fka = function (message) {
    var tmp = JsonPortExecutingDelegate$JsonChannelExecutingDelegate$messageReceived$lambda(this, message);
    this.wkh_1.u2m(new sam$jetbrains_ocelot_base_edt_EdtTask$0_4(tmp));
  };
  protoOf(JsonChannelExecutingDelegate).dka = function (message) {
    return this.fka(message instanceof JsonArray ? message : THROW_CCE());
  };
  function JsonPortExecutingDelegate$setOutput$$inlined$jsonChannel$1(this$0, $output) {
    this.zkh_1 = this$0;
    this.aki_1 = $output;
  }
  protoOf(JsonPortExecutingDelegate$setOutput$$inlined$jsonChannel$1).fka = function (message) {
    var tmp;
    if (!this.zkh_1.hki_1) {
      this.aki_1.dka(message);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(JsonPortExecutingDelegate$setOutput$$inlined$jsonChannel$1).dka = function (message) {
    return this.fka(message instanceof JsonArray ? message : THROW_CCE());
  };
  function JsonPortExecutingDelegate(portSupplier, edt) {
    PortExecutingDelegate.call(this, portSupplier, edt);
    this.hki_1 = false;
  }
  protoOf(JsonPortExecutingDelegate).xkd = function (channelSupplier) {
    return new JsonChannelExecutingDelegate(channelSupplier, this.qkc_1);
  };
  protoOf(JsonPortExecutingDelegate).wkc = function (channelSupplier) {
    return this.xkd(channelSupplier);
  };
  protoOf(JsonPortExecutingDelegate).iki = function (output, internalErrorHandler) {
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.json.jsonChannel' call
    var outputJsonChannel = new JsonPortExecutingDelegate$setOutput$$inlined$jsonChannel$1(this, output);
    protoOf(PortExecutingDelegate).ykc.call(this, outputJsonChannel, internalErrorHandler);
  };
  protoOf(JsonPortExecutingDelegate).mka = function (output, internalErrorHandler) {
    return this.iki((!(output == null) ? isInterface(output, JsonChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(JsonPortExecutingDelegate).ykc = function (output, internalErrorHandler) {
    return this.iki((!(output == null) ? isInterface(output, JsonChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(JsonPortExecutingDelegate).vr = function () {
    this.hki_1 = true;
    protoOf(PortExecutingDelegate).vr.call(this);
  };
  function PingPongServiceConstants() {
    this.jki_1 = 'pp';
  }
  var PingPongServiceConstants_instance;
  function PingPongServiceConstants_getInstance() {
    return PingPongServiceConstants_instance;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_5(function_0) {
    this.kki_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_5).wy = function () {
    return this.kki_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_5).b4 = function () {
    return this.kki_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_5).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_5).hashCode = function () {
    return hashCode(this.b4());
  };
  function PingPongServiceEndpoint$MyPort$input$$inlined$jsonChannel$1(this$0) {
    this.lki_1 = this$0;
  }
  protoOf(PingPongServiceEndpoint$MyPort$input$$inlined$jsonChannel$1).fka = function (message) {
    var tmp;
    if (!(message == null)) {
      Companion_getInstance_239().mki_1.ho('Receive pong');
      this.lki_1.nki_1 = false;
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(PingPongServiceEndpoint$MyPort$input$$inlined$jsonChannel$1).dka = function (message) {
    return this.fka(message instanceof JsonArray ? message : THROW_CCE());
  };
  function PingPongServiceEndpoint$MyPort$setOutput$lambda(this$0, $output) {
    return function () {
      var tmp;
      if (!this$0.nki_1) {
        Companion_getInstance_239().mki_1.ho('Sending ping');
        this$0.nki_1 = true;
        $output.dka(new JsonArray());
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function MyPort($outer) {
    this.qki_1 = $outer;
    this.nki_1 = false;
    this.oki_1 = false;
    this.pki_1 = Companion_getInstance_25().wr_1;
  }
  protoOf(MyPort).ika = function () {
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.json.jsonChannel' call
    return new PingPongServiceEndpoint$MyPort$input$$inlined$jsonChannel$1(this);
  };
  protoOf(MyPort).iki = function (output, internalErrorHandler) {
    if (this.oki_1) {
      throw IllegalStateException_init_$Create$_0('Port is already connected');
    }
    this.oki_1 = true;
    var tmp = this;
    var tmp_0 = this.qki_1.ski_1.z3();
    var tmp_1 = PingPongServiceEndpoint$MyPort$setOutput$lambda(this, output);
    tmp.pki_1 = this.qki_1.rki_1.w2m(tmp_0, new sam$jetbrains_ocelot_base_edt_EdtTask$0_5(tmp_1));
  };
  protoOf(MyPort).mka = function (output, internalErrorHandler) {
    return this.iki((!(output == null) ? isInterface(output, JsonChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(MyPort).vr = function () {
    this.qki_1.tki_1 = false;
    this.pki_1.vr();
  };
  function Companion_239() {
    Companion_instance_239 = this;
    this.mki_1 = getLogger(getKClass(PingPongServiceEndpoint));
  }
  var Companion_instance_239;
  function Companion_getInstance_239() {
    if (Companion_instance_239 == null)
      new Companion_239();
    return Companion_instance_239;
  }
  function PingPongServiceEndpoint(edt, periodMs) {
    Companion_getInstance_239();
    JsonServiceEndpoint.call(this);
    this.rki_1 = edt;
    this.ski_1 = periodMs;
    this.tki_1 = false;
  }
  protoOf(PingPongServiceEndpoint).qka = function () {
    return PingPongServiceConstants_instance.jki_1;
  };
  protoOf(PingPongServiceEndpoint).pka = function () {
    if (this.tki_1) {
      throw IllegalArgumentException_init_$Create$_0('Port is already opened');
    }
    this.tki_1 = true;
    return new MyPort(this);
  };
  protoOf(PingPongServiceEndpoint).vr = function () {
  };
  function ServiceContainerChannel() {
  }
  function ServiceContainerConstants() {
    this.hkh_1 = 'sercnt';
    this.ikh_1 = 'op';
    this.jkh_1 = 'cl';
    this.kkh_1 = 'cfg';
    this.lkh_1 = 'sl';
    this.mkh_1 = ':';
  }
  protoOf(ServiceContainerConstants).uki = function (name) {
    // Inline function 'kotlin.require' call
    if (!!('sercnt' === name)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.ServiceContainerConstants.checkServiceShortName.<anonymous>' call
      var message = 'Service cannot have short name sercnt. The name is reserved';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(ServiceContainerConstants).nkh = function (serviceNames) {
    var serviceNamesString = joinToString_0(serviceNames, ':');
    var payload = StringBuilder_init_$Create$_1().d9('sl').d9(':').d9(serviceNamesString).toString();
    return new ServiceContainerMessage('sercnt', 0, payload);
  };
  var ServiceContainerConstants_instance;
  function ServiceContainerConstants_getInstance() {
    return ServiceContainerConstants_instance;
  }
  function ServiceContainerMessage(serviceName, portId, payload) {
    this.rkg_1 = serviceName;
    this.skg_1 = portId;
    this.tkg_1 = payload;
  }
  protoOf(ServiceContainerMessage).toString = function () {
    return 'ServiceContainerMessage(serviceName=' + this.rkg_1 + ', portId=' + this.skg_1 + ', payload=' + this.tkg_1 + ')';
  };
  protoOf(ServiceContainerMessage).hashCode = function () {
    var result = getStringHashCode(this.rkg_1);
    result = imul(result, 31) + this.skg_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.tkg_1) | 0;
    return result;
  };
  protoOf(ServiceContainerMessage).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ServiceContainerMessage))
      return false;
    var tmp0_other_with_cast = other instanceof ServiceContainerMessage ? other : THROW_CCE();
    if (!(this.rkg_1 === tmp0_other_with_cast.rkg_1))
      return false;
    if (!(this.skg_1 === tmp0_other_with_cast.skg_1))
      return false;
    if (!(this.tkg_1 === tmp0_other_with_cast.tkg_1))
      return false;
    return true;
  };
  function ServiceContainerMessagePersister() {
  }
  protoOf(ServiceContainerMessagePersister).w2p = function (value) {
    // Inline function 'kotlin.text.toRegex' call
    // Inline function 'kotlin.text.split' call
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = Regex_init_$Create$(':').ce(value, 3);
    var parts = copyToArray(this_0);
    // Inline function 'kotlin.require' call
    if (!(parts.length === 3)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.ServiceContainerMessagePersister.deserialize.<anonymous>' call
      var message = 'Wrong ServiceContainerMessage format: ' + value;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new ServiceContainerMessage(parts[0], toInt(parts[1]), parts[2]);
  };
  protoOf(ServiceContainerMessagePersister).vki = function (value) {
    return StringBuilder_init_$Create$_1().d9(value.rkg_1).d9(':').ad(value.skg_1).d9(':').d9(value.tkg_1).toString();
  };
  protoOf(ServiceContainerMessagePersister).x2p = function (value) {
    return this.vki(value instanceof ServiceContainerMessage ? value : THROW_CCE());
  };
  function ServiceContainerMessageUtil() {
  }
  protoOf(ServiceContainerMessageUtil).vkg = function (rawMessage) {
    // Inline function 'kotlin.text.toRegex' call
    // Inline function 'kotlin.text.split' call
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = Regex_init_$Create$(':').ce(rawMessage, 2);
    var parts = copyToArray(this_0);
    // Inline function 'kotlin.require' call
    if (!(parts.length === 2)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.ServiceContainerMessageUtil.parseSystemMessage.<anonymous>' call
      var message = 'Wrong container message format: ' + rawMessage;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new ServiceContainerSystemMessage(parts[0], parts[1]);
  };
  var ServiceContainerMessageUtil_instance;
  function ServiceContainerMessageUtil_getInstance() {
    return ServiceContainerMessageUtil_instance;
  }
  function ServiceContainerSystemMessage(actionType, payload) {
    this.wkg_1 = actionType;
    this.xkg_1 = payload;
  }
  protoOf(ServiceContainerSystemMessage).ykg = function () {
    var tmp1 = this.xkg_1;
    // Inline function 'kotlin.text.toRegex' call
    // Inline function 'kotlin.text.split' call
    var tmp4 = Regex_init_$Create$(':').ce(tmp1, 0);
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.dropLastWhile' call
      if (!tmp4.p()) {
        var iterator = tmp4.r(tmp4.n());
        while (iterator.l5()) {
          // Inline function 'jetbrains.ocelot.ot.model.protocol.service.ServiceContainerSystemMessage.<get-serviceAndPort>.stub_for_inlining' call
          // Inline function 'kotlin.text.isEmpty' call
          var this_0 = iterator.n5();
          if (!(charSequenceLength(this_0) === 0)) {
            tmp$ret$4 = take(tmp4, iterator.m5() + 1 | 0);
            break $l$block;
          }
        }
      }
      tmp$ret$4 = emptyList();
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = tmp$ret$4;
    var parts = copyToArray(this_1);
    if (!(parts.length === 2)) {
      return null;
    }
    var tmp;
    try {
      tmp = new Pair(parts[0], toInt(parts[1]));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof NumberFormatException) {
        var e = $p;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  function initConfigurableServices($this, protocolConfiguration) {
    var _iterator__ex2g4s = $this.ckh_1.k();
    while (_iterator__ex2g4s.l()) {
      var configurationService = _iterator__ex2g4s.m();
      var serviceEndpoint = configurationService.wki(protocolConfiguration);
      if (serviceEndpoint == null) {
        Companion_getInstance_240().yki_1.ho('Service endpoint from ' + toString_1(configurationService) + " hasn't been initialized");
      } else {
        $this.xki(serviceEndpoint);
      }
    }
  }
  function Companion_240() {
    Companion_instance_240 = this;
    this.yki_1 = getLogger(getKClass(ServiceEndpointContainer));
  }
  var Companion_instance_240;
  function Companion_getInstance_240() {
    if (Companion_instance_240 == null)
      new Companion_240();
    return Companion_instance_240;
  }
  function ServiceEndpointContainer$addConfigurableService$configurableService$1($serviceEndpointFunction) {
    this.zki_1 = $serviceEndpointFunction;
  }
  protoOf(ServiceEndpointContainer$addConfigurableService$configurableService$1).wki = function (configuration) {
    return this.zki_1(configuration);
  };
  function ServiceEndpointContainer(configContext) {
    Companion_getInstance_240();
    configContext = configContext === VOID ? new ProtocolPersistentContext() : configContext;
    this.zkg_1 = configContext;
    this.akh_1 = new ValueProperty(null);
    this.bkh_1 = newConcurrentHashMap();
    this.ckh_1 = newConcurrentHashSet();
    this.dkh_1 = newAtomicBoolean(false);
    this.ekh_1 = new SynchronizedAtomicReference(ServiceEndpointContainerState_INIT_getInstance());
  }
  protoOf(ServiceEndpointContainer).gkh = function () {
    return this.bkh_1;
  };
  protoOf(ServiceEndpointContainer).xki = function (service) {
    var name = service.qka();
    // Inline function 'kotlin.text.isNotEmpty' call
    // Inline function 'kotlin.check' call
    if (!(charSequenceLength(name) > 0)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.ServiceEndpointContainer.addService.<anonymous>' call
      var message = 'No name for service ' + toString_1(service);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var state = this.ekh_1.qr();
    // Inline function 'kotlin.check' call
    if (!(state === ServiceEndpointContainerState_INIT_getInstance() || state === ServiceEndpointContainerState_CONFIGURING_getInstance())) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.ServiceEndpointContainer.addService.<anonymous>' call
      var message_0 = 'Cannot add service ' + name + ' to ServiceEndpointContainer in state ' + state.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    ServiceContainerConstants_instance.uki(name);
    var prevEndpoint = this.bkh_1.r2(name, service);
    // Inline function 'kotlin.check' call
    if (!(prevEndpoint == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.ServiceEndpointContainer.addService.<anonymous>' call
      var message_1 = "Service '" + name + "' has already been added";
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
  };
  protoOf(ServiceEndpointContainer).akj = function (serviceEndpointFunction) {
    var state = this.ekh_1.qr();
    // Inline function 'kotlin.check' call
    if (!(state === ServiceEndpointContainerState_INIT_getInstance())) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.ServiceEndpointContainer.addConfigurableService.<anonymous>' call
      var message = 'Cannot add configurable service to ServiceEndpointContainer in state ' + state.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var configurableService = new ServiceEndpointContainer$addConfigurableService$configurableService$1(serviceEndpointFunction);
    this.ckh_1.e(configurableService);
  };
  protoOf(ServiceEndpointContainer).oka = function () {
    // Inline function 'kotlin.check' call
    if (!!(this.ekh_1.qr() === ServiceEndpointContainerState_CLOSED_getInstance())) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.ServiceEndpointContainer.openPort.<anonymous>' call
      var message = "Can't open port for closed ServiceEndpointContainer";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var successful = this.dkh_1.nr(false, true);
    // Inline function 'kotlin.check' call
    if (!successful) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.ServiceEndpointContainer.openPort.<anonymous>' call
      var message_0 = 'The port is already opened';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    return new EndpointMultiplexPort(this);
  };
  protoOf(ServiceEndpointContainer).vr = function () {
    var prevState = this.ekh_1.tkh(ServiceEndpointContainerState_CLOSED_getInstance());
    // Inline function 'kotlin.check' call
    if (!!(prevState === ServiceEndpointContainerState_CLOSED_getInstance())) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.ServiceEndpointContainer.dispose.<anonymous>' call
      var message = 'ServiceEndpointContainer is already disposed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var _iterator__ex2g4s = this.bkh_1.v2().k();
    while (_iterator__ex2g4s.l()) {
      var serviceEndpoint = _iterator__ex2g4s.m();
      serviceEndpoint.vr();
    }
  };
  protoOf(ServiceEndpointContainer).bkj = function (configuration) {
    var otVersion = configuration.f2y(ProtocolParameters_getInstance().oke_1);
    if (!('6' === otVersion)) {
      throw VersionMismatchException_init_$Create$_0(otVersion);
    }
    Companion_getInstance_240().yki_1.go('OT version is ' + otVersion);
  };
  protoOf(ServiceEndpointContainer).fkh = function (configuration) {
    this.bkj(configuration);
    if (this.ekh_1.skh(ServiceEndpointContainerState_INIT_getInstance(), ServiceEndpointContainerState_CONFIGURING_getInstance())) {
      initConfigurableServices(this, configuration);
      this.akh_1.t2c(configuration);
    } else if (this.ekh_1.skh(ServiceEndpointContainerState_CONFIGURED_getInstance(), ServiceEndpointContainerState_CONFIGURING_getInstance())) {
      var currentConfig = ensureNotNull(this.akh_1.qr());
      var parameter = currentConfig.j2y(configuration);
      // Inline function 'kotlin.check' call
      if (!(parameter == null)) {
        // Inline function 'jetbrains.ocelot.ot.model.protocol.service.ServiceEndpointContainer.configure.<anonymous>' call
        var message = 'Received different configuration (differs in key ' + parameter + '). ' + 'Initial value: ' + currentConfig.f2y(ensureNotNull(parameter)) + '. New value: ' + toString_0(configuration.f2y(parameter));
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    } else
      throw IllegalStateException_init_$Create$_0('Endpoint container in state ' + this.ekh_1.qr().toString() + " can't be configured");
    this.ekh_1.ckj(ServiceEndpointContainerState_CONFIGURED_getInstance());
  };
  protoOf(ServiceEndpointContainer).ukh = function () {
    return this.dkh_1.or(false);
  };
  var ServiceEndpointContainerState_INIT_instance;
  var ServiceEndpointContainerState_CONFIGURING_instance;
  var ServiceEndpointContainerState_CONFIGURED_instance;
  var ServiceEndpointContainerState_CLOSED_instance;
  var ServiceEndpointContainerState_entriesInitialized;
  function ServiceEndpointContainerState_initEntries() {
    if (ServiceEndpointContainerState_entriesInitialized)
      return Unit_instance;
    ServiceEndpointContainerState_entriesInitialized = true;
    ServiceEndpointContainerState_INIT_instance = new ServiceEndpointContainerState('INIT', 0);
    ServiceEndpointContainerState_CONFIGURING_instance = new ServiceEndpointContainerState('CONFIGURING', 1);
    ServiceEndpointContainerState_CONFIGURED_instance = new ServiceEndpointContainerState('CONFIGURED', 2);
    ServiceEndpointContainerState_CLOSED_instance = new ServiceEndpointContainerState('CLOSED', 3);
  }
  function ServiceEndpointContainerState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ServiceEndpointContainerState_INIT_getInstance() {
    ServiceEndpointContainerState_initEntries();
    return ServiceEndpointContainerState_INIT_instance;
  }
  function ServiceEndpointContainerState_CONFIGURING_getInstance() {
    ServiceEndpointContainerState_initEntries();
    return ServiceEndpointContainerState_CONFIGURING_instance;
  }
  function ServiceEndpointContainerState_CONFIGURED_getInstance() {
    ServiceEndpointContainerState_initEntries();
    return ServiceEndpointContainerState_CONFIGURED_instance;
  }
  function ServiceEndpointContainerState_CLOSED_getInstance() {
    ServiceEndpointContainerState_initEntries();
    return ServiceEndpointContainerState_CLOSED_instance;
  }
  function SynchronizedAtomicReference$get$lambda(this$0) {
    return function () {
      return this$0.pkg_1;
    };
  }
  function SynchronizedAtomicReference$set$lambda(this$0, $newValue) {
    return function () {
      this$0.pkg_1 = $newValue;
      return Unit_instance;
    };
  }
  function SynchronizedAtomicReference$getAndSet$lambda(this$0, $newValue) {
    return function () {
      var prevValue = this$0.pkg_1;
      this$0.pkg_1 = $newValue;
      return prevValue;
    };
  }
  function SynchronizedAtomicReference$compareAndSet$lambda(this$0, $expect, $update) {
    return function () {
      var isSuccess = this$0.pkg_1 === $expect;
      var tmp;
      if (isSuccess) {
        this$0.pkg_1 = $update;
        tmp = Unit_instance;
      }
      return isSuccess;
    };
  }
  function SynchronizedAtomicReference(value) {
    this.pkg_1 = value;
    this.qkg_1 = newLock();
  }
  protoOf(SynchronizedAtomicReference).qr = function () {
    return this.qkg_1.kr(SynchronizedAtomicReference$get$lambda(this));
  };
  protoOf(SynchronizedAtomicReference).ckj = function (newValue) {
    return this.qkg_1.kr(SynchronizedAtomicReference$set$lambda(this, newValue));
  };
  protoOf(SynchronizedAtomicReference).tkh = function (newValue) {
    return this.qkg_1.kr(SynchronizedAtomicReference$getAndSet$lambda(this, newValue));
  };
  protoOf(SynchronizedAtomicReference).skh = function (expect, update) {
    return this.qkg_1.kr(SynchronizedAtomicReference$compareAndSet$lambda(this, expect, update));
  };
  function VersionMismatchException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    VersionMismatchException.call($this);
    return $this;
  }
  function VersionMismatchException_init_$Create$() {
    var tmp = VersionMismatchException_init_$Init$(objectCreate(protoOf(VersionMismatchException)));
    captureStack(tmp, VersionMismatchException_init_$Create$);
    return tmp;
  }
  function VersionMismatchException_init_$Init$_0(differentVersion, $this) {
    RuntimeException_init_$Init$_0('actual is 6 but received ' + differentVersion, $this);
    VersionMismatchException.call($this);
    return $this;
  }
  function VersionMismatchException_init_$Create$_0(differentVersion) {
    var tmp = VersionMismatchException_init_$Init$_0(differentVersion, objectCreate(protoOf(VersionMismatchException)));
    captureStack(tmp, VersionMismatchException_init_$Create$_0);
    return tmp;
  }
  function VersionMismatchException() {
    captureStack(this, VersionMismatchException);
  }
  var State_OPENING_instance;
  var State_OPENED_instance;
  var State_CLOSED_instance;
  var State_entriesInitialized_0;
  function State_initEntries_0() {
    if (State_entriesInitialized_0)
      return Unit_instance;
    State_entriesInitialized_0 = true;
    State_OPENING_instance = new State_1('OPENING', 0);
    State_OPENED_instance = new State_1('OPENED', 1);
    State_CLOSED_instance = new State_1('CLOSED', 2);
  }
  function Companion_241() {
    Companion_instance_241 = this;
    this.dkj_1 = new EmptyListener();
  }
  var Companion_instance_241;
  function Companion_getInstance_241() {
    if (Companion_instance_241 == null)
      new Companion_241();
    return Companion_instance_241;
  }
  function SocketConnection$connect$lambda$o$messageReceived$lambda(this$0, $msg) {
    return function () {
      ensureNotNull(this$0.gkj_1).mkj(Companion_getInstance_242().lkj_1.vki($msg));
      return Unit_instance;
    };
  }
  function connect($this, container) {
    $this.ekj_1.kr(SocketConnection$connect$lambda_1($this, container));
    fireOpened($this);
  }
  function receive($this, message) {
    var t = {_v: null};
    $this.ekj_1.kr(SocketConnection$receive$lambda($this, message, t));
    if (!(t._v == null)) {
      fireError($this, ensureNotNull(t._v), true);
    }
  }
  function fireDisconnectEvent($this, code, reason) {
    var old = {_v: null};
    $this.ikj_1.kr(SocketConnection$fireDisconnectEvent$lambda(old, $this));
    ensureNotNull(old._v).nkj(code, reason);
  }
  function fireOpened($this) {
    var listener = {_v: null};
    $this.ikj_1.kr(SocketConnection$fireOpened$lambda(listener, $this));
    ensureNotNull(listener._v).okj();
  }
  function fireError($this, t, fatal) {
    var listener = {_v: null};
    $this.ikj_1.kr(SocketConnection$fireError$lambda(listener, $this));
    ensureNotNull(listener._v).pkj(t, fatal);
  }
  function Companion_242() {
    Companion_instance_242 = this;
    this.kkj_1 = getLogger(getKClass(SocketConnection));
    this.lkj_1 = new ServiceContainerMessagePersister();
  }
  var Companion_instance_242;
  function Companion_getInstance_242() {
    if (Companion_instance_242 == null)
      new Companion_242();
    return Companion_instance_242;
  }
  function State_1(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function EmptyListener() {
    Companion_getInstance_241();
  }
  protoOf(EmptyListener).okj = function () {
  };
  protoOf(EmptyListener).nkj = function (code, reason) {
  };
  protoOf(EmptyListener).pkj = function (t, fatal) {
  };
  function SocketConnection$lambda(this$0, $listener) {
    return function () {
      this$0.jkj_1 = $listener;
      return Unit_instance;
    };
  }
  function SocketConnection$connect$lambda(this$0) {
    return function () {
      var tmp;
      if (!(this$0.fkj_1 == null)) {
        // Inline function 'jetbrains.ocelot.ot.transport.socket.SocketConnection.connect.<anonymous>.<anonymous>' call
        var message = "Socket 'init' when socket is " + ensureNotNull(this$0.fkj_1).toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      this$0.fkj_1 = State_OPENING_getInstance();
      return Unit_instance;
    };
  }
  function SocketConnection$connect$socketHandler$1($url, this$0, $container) {
    this.qkj_1 = $url;
    this.rkj_1 = this$0;
    this.skj_1 = $container;
    SocketHandler.call(this);
  }
  protoOf(SocketConnection$connect$socketHandler$1).tkj = function (code, reason) {
    Companion_getInstance_242().kkj_1.go('Disposing connection due to close event url=' + this.qkj_1 + ', code=' + code + ', reason=' + reason);
    this.rkj_1.vr();
    fireDisconnectEvent(this.rkj_1, code, reason == null ? '' : reason);
  };
  protoOf(SocketConnection$connect$socketHandler$1).ukj = function () {
    Companion_getInstance_242().kkj_1.go('Disposing connection due to error event url=' + this.qkj_1);
    this.rkj_1.vr();
    fireDisconnectEvent(this.rkj_1, 1006, '');
  };
  protoOf(SocketConnection$connect$socketHandler$1).vkj = function (message) {
    return receive(this.rkj_1, message);
  };
  protoOf(SocketConnection$connect$socketHandler$1).wkj = function () {
    return connect(this.rkj_1, this.skj_1);
  };
  function SocketConnection$connect$lambda_0(this$0, $socket) {
    return function () {
      this$0.gkj_1 = $socket;
      return Unit_instance;
    };
  }
  function SocketConnection$connect$3$$inlined$serviceContainerChannel$1(this$0) {
    this.bkk_1 = this$0;
  }
  protoOf(SocketConnection$connect$3$$inlined$serviceContainerChannel$1).qkh = function (message) {
    return this.bkk_1.ekj_1.kr(SocketConnection$connect$lambda$o$messageReceived$lambda(this.bkk_1, message));
  };
  protoOf(SocketConnection$connect$3$$inlined$serviceContainerChannel$1).dka = function (message) {
    return this.qkh(message instanceof ServiceContainerMessage ? message : THROW_CCE());
  };
  function SocketConnection$connect$lambda$lambda(this$0) {
    return function (item) {
      var tmp = ensureNotNull(item);
      fireError(this$0, tmp, item instanceof FatalEndpointException);
      return Unit_instance;
    };
  }
  function SocketConnection$connect$lambda_1(this$0, $container) {
    return function () {
      var tmp;
      if (!equals(this$0.fkj_1, State_OPENING_getInstance())) {
        // Inline function 'jetbrains.ocelot.ot.transport.socket.SocketConnection.connect.<anonymous>.<anonymous>' call
        var message = "Socket 'onOpen' when socket is " + ensureNotNull(this$0.fkj_1).toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      this$0.hkj_1 = $container.oka();
      var tmp_0 = ensureNotNull(this$0.hkj_1);
      // Inline function 'jetbrains.ocelot.ot.model.protocol.service.serviceContainerChannel' call
      var tmp_1 = new SocketConnection$connect$3$$inlined$serviceContainerChannel$1(this$0);
      tmp_0.mka(tmp_1, SocketConnection$connect$lambda$lambda(this$0));
      this$0.fkj_1 = State_OPENED_getInstance();
      return Unit_instance;
    };
  }
  function SocketConnection$receive$lambda(this$0, $message, $t) {
    return function () {
      var tmp;
      if (!equals(this$0.fkj_1, State_CLOSED_getInstance())) {
        // Inline function 'kotlin.check' call
        if (!equals(this$0.fkj_1, State_OPENED_getInstance())) {
          // Inline function 'jetbrains.ocelot.ot.transport.socket.SocketConnection.receive.<anonymous>.<anonymous>' call
          var message = 'Message received when socket is ' + toString_0(this$0.fkj_1) + '\nmessage=' + $message;
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        var tmp_0;
        try {
          ensureNotNull(this$0.hkj_1).ika().dka(Companion_getInstance_242().lkj_1.w2p($message));
          tmp_0 = Unit_instance;
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Error) {
            var th = $p;
            $t._v = th;
            tmp_1 = Unit_instance;
          } else {
            throw $p;
          }
          tmp_0 = tmp_1;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function SocketConnection$dispose$lambda(this$0, $port, $socket) {
    return function () {
      var tmp;
      if (!equals(this$0.fkj_1, State_CLOSED_getInstance())) {
        this$0.fkj_1 = State_CLOSED_getInstance();
        $port._v = this$0.hkj_1;
        this$0.hkj_1 = null;
        $socket._v = this$0.gkj_1;
        this$0.gkj_1 = null;
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SocketConnection$fireDisconnectEvent$lambda($old, this$0) {
    return function () {
      $old._v = this$0.jkj_1;
      this$0.jkj_1 = Companion_getInstance_241().dkj_1;
      return Unit_instance;
    };
  }
  function SocketConnection$fireOpened$lambda($listener, this$0) {
    return function () {
      $listener._v = this$0.jkj_1;
      return Unit_instance;
    };
  }
  function SocketConnection$fireError$lambda($listener, this$0) {
    return function () {
      $listener._v = this$0.jkj_1;
      return Unit_instance;
    };
  }
  function State_OPENING_getInstance() {
    State_initEntries_0();
    return State_OPENING_instance;
  }
  function State_OPENED_getInstance() {
    State_initEntries_0();
    return State_OPENED_instance;
  }
  function State_CLOSED_getInstance() {
    State_initEntries_0();
    return State_CLOSED_instance;
  }
  function SocketConnection(listener) {
    Companion_getInstance_242();
    this.ekj_1 = newLock();
    this.fkj_1 = null;
    this.gkj_1 = null;
    this.hkj_1 = null;
    this.ikj_1 = newLock();
    this.jkj_1 = null;
    this.ikj_1.kr(SocketConnection$lambda(this, listener));
  }
  protoOf(SocketConnection).ckk = function (url, socketFactory, container) {
    this.ekj_1.kr(SocketConnection$connect$lambda(this));
    var socket;
    try {
      var socketHandler = new SocketConnection$connect$socketHandler$1(url, this, container);
      socket = socketFactory.dkk(url, socketHandler);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        fireError(this, t, true);
        return Unit_instance;
      } else {
        throw $p;
      }
    }
    this.ekj_1.kr(SocketConnection$connect$lambda_0(this, socket));
    try {
      socket.ekk();
    } catch ($p) {
      if ($p instanceof Error) {
        var t_0 = $p;
        fireError(this, t_0, false);
      } else {
        throw $p;
      }
    }
  };
  protoOf(SocketConnection).vr = function () {
    var port = {_v: null};
    var socket = {_v: null};
    this.ekj_1.kr(SocketConnection$dispose$lambda(this, port, socket));
    try {
      var tmp0_safe_receiver = port._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.vr();
      }
      var tmp1_safe_receiver = socket._v;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.up();
      }
    } catch ($p) {
      if ($p instanceof RuntimeException) {
        var e = $p;
        Companion_getInstance_242().kkj_1.co('Exception while disposing socket connection:', e);
      } else {
        throw $p;
      }
    }
  };
  function SocketHandler() {
  }
  protoOf(SocketHandler).xkj = function (code, reason) {
    try {
      this.tkj(code, reason);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().ps_1.os(t);
      } else {
        throw $p;
      }
    }
  };
  protoOf(SocketHandler).ykj = function () {
    try {
      this.ukj();
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().ps_1.os(t);
      } else {
        throw $p;
      }
    }
  };
  protoOf(SocketHandler).zkj = function (message) {
    try {
      this.vkj(message);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().ps_1.os(t);
      } else {
        throw $p;
      }
    }
  };
  protoOf(SocketHandler).akk = function () {
    try {
      this.wkj();
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().ps_1.os(t);
      } else {
        throw $p;
      }
    }
  };
  function SocketManager$o$onDisconnect$lambda(this$0) {
    return function () {
      this$0.tkk_1 = null;
      return Unit_instance;
    };
  }
  function SocketManager$initSocket$ref($boundThis) {
    var l = function () {
      initSocket($boundThis);
      return Unit_instance;
    };
    l.callableName = 'initSocket';
    return l;
  }
  function SocketManager$o$onDisconnect$lambda_0(this$0) {
    return function () {
      var delay = this$0.okk_1.ckl().z3();
      var tmp;
      if (this$0.hkl()) {
        Companion_getInstance_243().dkl_1.go('reconnect in ' + delay + ' ms');
        var tmp_0 = this$0;
        var tmp_1 = SocketManager$initSocket$ref(this$0);
        tmp_0.qkk_1 = this$0.ikk_1.v2m(delay, new sam$jetbrains_ocelot_base_edt_EdtTask$0_6(tmp_1));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function _set_isStarted__srcka6($this, value) {
    return $this.lkk_1.kr(SocketManager$_set_isStarted_$lambda_vah29z($this, value));
  }
  function _get_url__e6i4g2($this) {
    return $this.gkk_1 + (contains_9($this.gkk_1, '?') ? '&' : '?') + 'connection_id' + '=' + ensureNotNull($this.ikl()).i2s_1 + '&' + 'client_id' + '=' + $this.jkk_1.i2s_1;
  }
  function SocketManager_init_$Init$(container, url, socketFactory, edt, clientId, isReconnectEnabled, $this) {
    clientId = clientId === VOID ? ClientId_init_$Create$() : clientId;
    isReconnectEnabled = isReconnectEnabled === VOID ? true : isReconnectEnabled;
    SocketManager.call($this, container, url, socketFactory, edt, clientId, isReconnectEnabled, Companion_getInstance_243().fkl_1);
    return $this;
  }
  function SocketManager_init_$Create$(container, url, socketFactory, edt, clientId, isReconnectEnabled) {
    return SocketManager_init_$Init$(container, url, socketFactory, edt, clientId, isReconnectEnabled, objectCreate(protoOf(SocketManager)));
  }
  function initSocket($this) {
    $this.vkk_1.t2c(ConnectionId_init_$Create$());
    var tmp = $this.jkl();
    var tmp_0 = SocketManager$initSocket$lambda($this);
    tmp.k2l(tmp_0, SocketManager$initSocket$lambda_0($this));
  }
  function doInitSocket($this) {
    var connection = {_v: null};
    $this.skk_1.kr(SocketManager$doInitSocket$lambda($this, connection));
    ensureNotNull(connection._v).ckk(_get_url__e6i4g2($this), $this.hkk_1, $this.fkk_1);
  }
  function onError($this, t, fatal) {
    if (fatal) {
      $this.nkk_1.s2c(t);
    }
    try {
      ThrowableHandlers_getInstance().ps_1.os(t);
    }finally {
      disposeConnection($this);
      if (fatal) {
        $this.nkk_1.v9();
      }
    }
  }
  function disposeConnection($this) {
    $this.skk_1.kr(SocketManager$disposeConnection$lambda($this));
  }
  function Companion_243() {
    Companion_instance_243 = this;
    this.dkl_1 = getLogger(getKClass(SocketManager));
    this.ekl_1 = new Long(5000, 0);
    this.fkl_1 = new UniformDelays(new Long(5000, 0), DurationUnit_MILLISECONDS_getInstance());
    this.gkl_1 = 10000;
  }
  var Companion_instance_243;
  function Companion_getInstance_243() {
    if (Companion_instance_243 == null)
      new Companion_243();
    return Companion_instance_243;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_6(function_0) {
    this.kkl_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_6).wy = function () {
    return this.kkl_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_6).b4 = function () {
    return this.kkl_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_6).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_6).hashCode = function () {
    return hashCode(this.b4());
  };
  function SocketManager$_get_isStarted_$lambda_aniqmd(this$0) {
    return function () {
      return this$0.mkk_1;
    };
  }
  function SocketManager$_set_isStarted_$lambda_vah29z(this$0, $value) {
    return function () {
      var tmp;
      if (!!(this$0.mkk_1 === $value)) {
        // Inline function 'jetbrains.ocelot.ot.transport.socket.SocketManager.<set-isStarted>.<anonymous>.<anonymous>' call
        var message = this$0.toString() + ' has ' + ($value ? 'already' : 'not') + ' been started';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      this$0.mkk_1 = $value;
      return Unit_instance;
    };
  }
  function SocketManager$1(this$0) {
    this.lkl_1 = this$0;
  }
  protoOf(SocketManager$1).okj = function () {
    Companion_getInstance_243().dkl_1.go('Socket connection opened: ' + _get_url__e6i4g2(this.lkl_1));
    if (this.lkl_1.kkk_1) {
      this.lkl_1.okk_1.mkl();
    }
    this.lkl_1.ukk_1.t2c(true);
  };
  protoOf(SocketManager$1).nkj = function (code, reason) {
    Companion_getInstance_243().dkl_1.go('Socket connection closed with code ' + code + ': ' + _get_url__e6i4g2(this.lkl_1) + '. Reason: ' + reason);
    this.lkl_1.skk_1.kr(SocketManager$o$onDisconnect$lambda(this.lkl_1));
    if (this.lkl_1.nkk_1.qr() == null && this.lkl_1.kkk_1 && !(code === 4403)) {
      this.lkl_1.pkk_1.kr(SocketManager$o$onDisconnect$lambda_0(this.lkl_1));
    }
    this.lkl_1.ukk_1.t2c(false);
  };
  protoOf(SocketManager$1).pkj = function (t, fatal) {
    onError(this.lkl_1, t, fatal);
  };
  function Disposable$dispose$ref($boundThis) {
    var l = function () {
      $boundThis.vr();
      return Unit_instance;
    };
    l.callableName = 'dispose';
    return l;
  }
  function SocketManager$initSocket$lambda$lambda($started, this$0) {
    return function () {
      $started._v = this$0.mkk_1;
      return Unit_instance;
    };
  }
  function SocketManager$initSocket$lambda(this$0) {
    return function (it) {
      var started = {_v: false};
      this$0.lkk_1.kr(SocketManager$initSocket$lambda$lambda(started, this$0));
      var tmp;
      if (started._v) {
        doInitSocket(this$0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SocketManager$initSocket$lambda_0(this$0) {
    return function (t) {
      onError(this$0, t, true);
      return Unit_instance;
    };
  }
  function SocketManager$doInitSocket$lambda(this$0, $connection) {
    return function () {
      var tmp;
      if (!(this$0.tkk_1 == null)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      $connection._v = new SocketConnection(this$0.rkk_1);
      this$0.tkk_1 = $connection._v;
      return Unit_instance;
    };
  }
  function SocketManager$disposeConnection$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.tkk_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver.vr();
        tmp = Unit_instance;
      }
      return tmp;
    };
  }
  function SocketManager(container, _url, socketFactory, edt, clientId, isReconnectEnabled, waitStrategy) {
    Companion_getInstance_243();
    clientId = clientId === VOID ? ClientId_init_$Create$() : clientId;
    isReconnectEnabled = isReconnectEnabled === VOID ? true : isReconnectEnabled;
    waitStrategy = waitStrategy === VOID ? Companion_getInstance_243().fkl_1 : waitStrategy;
    this.fkk_1 = container;
    this.gkk_1 = _url;
    this.hkk_1 = socketFactory;
    this.ikk_1 = edt;
    this.jkk_1 = clientId;
    this.kkk_1 = isReconnectEnabled;
    this.lkk_1 = newLock();
    this.mkk_1 = false;
    this.nkk_1 = new DelayedValueProperty();
    this.pkk_1 = newLock();
    this.qkk_1 = Companion_getInstance_25().wr_1;
    this.skk_1 = newLock();
    this.tkk_1 = null;
    this.ukk_1 = new ThreadSafeProperty(false);
    this.vkk_1 = new ThreadSafeProperty(null);
    this.okk_1 = new ReconnectStrategy(this.ikk_1, waitStrategy, 10000);
    var tmp = this;
    tmp.rkk_1 = new SocketManager$1(this);
  }
  protoOf(SocketManager).ikl = function () {
    return this.vkk_1.qr();
  };
  protoOf(SocketManager).hkl = function () {
    return this.lkk_1.kr(SocketManager$_get_isStarted_$lambda_aniqmd(this));
  };
  protoOf(SocketManager).nkl = function () {
    Companion_getInstance_243().dkl_1.go('Starting socket manager: url=' + this.gkk_1 + ', clientId=' + this.jkk_1.toString());
    _set_isStarted__srcka6(this, true);
    initSocket(this);
  };
  protoOf(SocketManager).aa1 = function () {
    Companion_getInstance_243().dkl_1.go('Stopping socket manager: url=' + this.gkk_1 + ', clientId=' + this.jkk_1.toString());
    _set_isStarted__srcka6(this, false);
    disposeConnection(this);
    this.pkk_1.kr(Disposable$dispose$ref(this.qkk_1));
    this.okk_1.vr();
  };
  protoOf(SocketManager).jkl = function () {
    return Asyncs_instance.r2l();
  };
  protoOf(SocketManager).toString = function () {
    var cl = getKClassFromExpression(this).lb();
    return plus_10(cl, toString(_Char___init__impl__6a9atx(64))) + toString_3(hashCode(this), 16);
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_7(function_0) {
    this.okl_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_7).wy = function () {
    return this.okl_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_7).b4 = function () {
    return this.okl_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_7).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_7).hashCode = function () {
    return hashCode(this.b4());
  };
  function ReconnectStrategy$nextDelay$lambda(this$0) {
    return function () {
      this$0.vr();
      return this$0.akl_1.m();
    };
  }
  function ReconnectStrategy$onSuccessfulReconnect$lambda$lambda$lambda(this$0) {
    return function () {
      this$0.akl_1 = this$0.xkk_1.pkl();
      return Unit_instance;
    };
  }
  function ReconnectStrategy$onSuccessfulReconnect$lambda$lambda(this$0) {
    return function () {
      this$0.zkk_1.kr(ReconnectStrategy$onSuccessfulReconnect$lambda$lambda$lambda(this$0));
      return Unit_instance;
    };
  }
  function ReconnectStrategy$onSuccessfulReconnect$lambda(this$0) {
    return function () {
      var tmp;
      if (this$0.bkl_1 === Companion_getInstance_25().wr_1) {
        var tmp_0 = this$0;
        var tmp_1 = ReconnectStrategy$onSuccessfulReconnect$lambda$lambda(this$0);
        tmp_0.bkl_1 = this$0.wkk_1.v2m(this$0.ykk_1, new sam$jetbrains_ocelot_base_edt_EdtTask$0_7(tmp_1));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ReconnectStrategy(edt, waitStrategy, resetDelayMs) {
    this.wkk_1 = edt;
    this.xkk_1 = waitStrategy;
    this.ykk_1 = resetDelayMs;
    this.zkk_1 = newLock();
    this.akl_1 = this.xkk_1.pkl();
    this.bkl_1 = Companion_getInstance_25().wr_1;
  }
  protoOf(ReconnectStrategy).ckl = function () {
    return this.zkk_1.kr(ReconnectStrategy$nextDelay$lambda(this));
  };
  protoOf(ReconnectStrategy).mkl = function () {
    return this.zkk_1.kr(ReconnectStrategy$onSuccessfulReconnect$lambda(this));
  };
  protoOf(ReconnectStrategy).vr = function () {
    this.bkl_1.vr();
    this.bkl_1 = Companion_getInstance_25().wr_1;
  };
  function UniformDelays$delays$1(this$0) {
    this.qkl_1 = this$0;
  }
  protoOf(UniformDelays$delays$1).l = function () {
    return true;
  };
  protoOf(UniformDelays$delays$1).m = function () {
    return this.qkl_1.rkl_1;
  };
  function UniformDelays(delay, unit) {
    this.rkl_1 = _Duration___get_inWholeMilliseconds__impl__msfiry(toDuration_0(delay, unit));
  }
  protoOf(UniformDelays).pkl = function () {
    return new UniformDelays$delays$1(this);
  };
  function JsWebsocket$lambda(this$0) {
    return function (_unused_var__etf5q3) {
      this$0.skl_1.akk();
      return Unit_instance;
    };
  }
  function JsWebsocket$lambda_0(this$0) {
    return function (event) {
      // Inline function 'kotlin.with' call
      // Inline function 'jetbrains.ocelot.ot.transport.socket.js.JsWebsocket.<anonymous>.<anonymous>' call
      var $this$with = event instanceof CloseEvent ? event : THROW_CCE();
      this$0.skl_1.xkj($this$with.code, $this$with.reason);
      return Unit_instance;
    };
  }
  function JsWebsocket$lambda_1(this$0) {
    return function (_unused_var__etf5q3) {
      this$0.skl_1.ykj();
      return Unit_instance;
    };
  }
  function JsWebsocket$lambda_2(this$0) {
    return function (event) {
      var tmp = event.data;
      this$0.skl_1.zkj((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE());
      return Unit_instance;
    };
  }
  function JsWebsocket(url, socketHandler) {
    this.skl_1 = socketHandler;
    this.tkl_1 = new WebSocket(url);
    var tmp = this.tkl_1;
    tmp.onopen = JsWebsocket$lambda(this);
    var tmp_0 = this.tkl_1;
    tmp_0.onclose = JsWebsocket$lambda_0(this);
    var tmp_1 = this.tkl_1;
    tmp_1.onerror = JsWebsocket$lambda_1(this);
    var tmp_2 = this.tkl_1;
    tmp_2.onmessage = JsWebsocket$lambda_2(this);
  }
  protoOf(JsWebsocket).ekk = function () {
  };
  protoOf(JsWebsocket).up = function () {
    return this.tkl_1.close();
  };
  protoOf(JsWebsocket).mkj = function (msg) {
    return this.tkl_1.send(msg);
  };
  function JsWebsocketFactory() {
  }
  protoOf(JsWebsocketFactory).dkk = function (url, socketHandler) {
    return new JsWebsocket(url, socketHandler);
  };
  function Companion_244() {
  }
  var Companion_instance_244;
  function Companion_getInstance_244() {
    return Companion_instance_244;
  }
  function AsyncWithDisposable(async, disposable) {
    disposable = disposable === VOID ? Companion_getInstance_25().wr_1 : disposable;
    this.ukl_1 = async;
    this.vkl_1 = disposable;
  }
  protoOf(AsyncWithDisposable).wkl = function () {
    return this.vkl_1 == null;
  };
  protoOf(AsyncWithDisposable).xkl = function (source) {
    // Inline function 'kotlin.check' call
    if (!!this.wkl()) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.AsyncWithDisposable.delegate.<anonymous>' call
      var message = 'Async, delegating to, is already cancelled';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!!source.wkl()) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.AsyncWithDisposable.delegate.<anonymous>' call
      var message_0 = 'Async, delegating from, is already cancelled';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!(this.vkl_1 === Companion_getInstance_25().wr_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.AsyncWithDisposable.delegate.<anonymous>' call
      var message_1 = 'Async, delegating to, has not empty registration';
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    var tmp = Asyncs_instance;
    var tmp_0 = this.ukl_1;
    tmp.s2l(source.ukl_1, tmp_0 instanceof SimpleAsync ? tmp_0 : THROW_CCE());
    this.vkl_1 = source.vkl_1;
    return this;
  };
  function shouldProcess($this, clientRoot) {
    return !clientRoot.ykl();
  }
  function Client$MyPort$o$commandAccepted$lambda($id) {
    return function (listener) {
      listener.zkl($id);
      return Unit_instance;
    };
  }
  function Client$MyPort$o$loadAccepted$lambda($id) {
    return function (listener) {
      listener.akm($id.k4r_1);
      return Unit_instance;
    };
  }
  function Client$MyPort$o$loadHistoryAccepted$lambda($id, $history) {
    return function (listener) {
      listener.bkm($id, $history);
      return Unit_instance;
    };
  }
  function Client$MyPort$o$loadHistoryRejected$lambda($id, $reason) {
    return function (listener) {
      listener.ckm($id, $reason);
      return Unit_instance;
    };
  }
  function Client$MyPort$o$reconnectRejected$lambda($id, $reason) {
    return function (listener) {
      listener.dkm($id, $reason);
      return Unit_instance;
    };
  }
  function Client$MyPort$o$loadRejected$lambda($id, $reason) {
    return function (listener) {
      listener.ekm($id.k4r_1, $reason);
      return Unit_instance;
    };
  }
  function Client$MyPort$o$unloadHandled$lambda($id, $rootIds) {
    return function (listener) {
      listener.fkm($id, $rootIds);
      return Unit_instance;
    };
  }
  function Client$MyPort$setOutput$o$load$lambda($ref) {
    return function (listener) {
      listener.gkm($ref);
      return Unit_instance;
    };
  }
  function _get_isConnected__klcexa($this) {
    return !($this.wkm_1.ukm_1 == null);
  }
  function Client$MyPort$1(this$0, this$1) {
    this.xkm_1 = this$0;
    this.ykm_1 = this$1;
    OtChannelAdapter.call(this);
  }
  protoOf(Client$MyPort$1).nkc = function (commandId) {
    fireCommandUnprocessed(this.xkm_1, commandId);
  };
  protoOf(Client$MyPort$1).ykb = function (command) {
    if (_get_isConnected__klcexa(this.ykm_1)) {
      var clientRoot = getRoot(this.xkm_1, command.c4r_1.h4r_1);
      if (shouldProcess(this, clientRoot)) {
        (new IncomingRequest()).ckn(clientRoot.akn(command));
      } else {
        this.xkm_1.zkm(command.c4r_1, command.d4r_1, command.e4r_1);
      }
    }
  };
  protoOf(Client$MyPort$1).zkb = function (id, baseVersion, resultVersion) {
    this.xkm_1.skm_1.a28(Client$MyPort$o$commandAccepted$lambda(id));
    var clientRoot = getRoot(this.xkm_1, id.h4r_1);
    if (clientRoot.ikn() && shouldProcess(this, clientRoot)) {
      IncomingAcceptance_init_$Create$(id.g4r_1, baseVersion, resultVersion).ckn(clientRoot.dkn());
    }
  };
  protoOf(Client$MyPort$1).dkc = function (id) {
    (new IncomingAcceptance(id.g4r_1)).ckn(getRoot(this.xkm_1, id.h4r_1).jkn());
  };
  protoOf(Client$MyPort$1).gkc = function (id) {
    assertRootCommand(this.xkm_1, id);
    this.xkm_1.skm_1.a28(Client$MyPort$o$loadAccepted$lambda(id));
    (new IncomingAcceptance(id.j4r_1, id.r3i(), null, null)).ckn(getRoot(this.xkm_1, id.o3i()).kkn());
  };
  protoOf(Client$MyPort$1).jkc = function (id, history) {
    var request = this.xkm_1.rkm_1.s2(id);
    if (request == null)
      null;
    else {
      request.n2l(history);
    }
    this.xkm_1.skm_1.a28(Client$MyPort$o$loadHistoryAccepted$lambda(id, history));
  };
  protoOf(Client$MyPort$1).kkc = function (id, reason) {
    var request = this.xkm_1.rkm_1.s2(id);
    if (request == null)
      null;
    else {
      request.o2l(new OtRejectionException(reason));
    }
    this.xkm_1.skm_1.a28(Client$MyPort$o$loadHistoryRejected$lambda(id, reason));
  };
  protoOf(Client$MyPort$1).akc = function (id, reason) {
    if (_get_isConnected__klcexa(this.ykm_1)) {
      var clientRoot = getRoot(this.xkm_1, id.h4r_1);
      if (clientRoot.ikn() && shouldProcess(this, clientRoot)) {
        IncomingRejection_init_$Create$(id.g4r_1, reason).ckn(clientRoot.dkn());
      } else {
        this.xkm_1.lkn(id, reason);
      }
    }
  };
  protoOf(Client$MyPort$1).ekc = function (id, reason) {
    assertRootCommand(this.xkm_1, id);
    this.xkm_1.skm_1.a28(Client$MyPort$o$reconnectRejected$lambda(id, reason));
    IncomingRejection_init_$Create$(id.j4r_1, reason).ckn(getRoot(this.xkm_1, id.o3i()).jkn());
  };
  protoOf(Client$MyPort$1).hkc = function (id, reason) {
    assertRootCommand(this.xkm_1, id);
    this.xkm_1.skm_1.a28(Client$MyPort$o$loadRejected$lambda(id, reason));
    (new IncomingRejection(id.j4r_1, id.r3i(), reason)).ckn(getRoot(this.xkm_1, id.o3i()).kkn());
  };
  protoOf(Client$MyPort$1).mkc = function (id, rootIds) {
    var _iterator__ex2g4s = rootIds.k();
    while (_iterator__ex2g4s.l()) {
      var rootId = _iterator__ex2g4s.m();
      getRoot(this.xkm_1, rootId).pkn();
    }
    this.xkm_1.skm_1.a28(Client$MyPort$o$unloadHandled$lambda(id, rootIds));
  };
  function Client$MyPort$setOutput$1($output, this$0) {
    this.rkn_1 = this$0;
    OtChannelDelegate.call(this, $output);
  }
  protoOf(Client$MyPort$setOutput$1).fkc = function (id) {
    assertRootCommand(this.rkn_1, id);
    var ref = new EntityReference(id.o3i(), id.r3i());
    this.rkn_1.skm_1.a28(Client$MyPort$setOutput$o$load$lambda(ref));
    protoOf(OtChannelDelegate).fkc.call(this, id);
  };
  function runCallbacks($this) {
    if ($this.skn_1.tkm_1.p())
      return Unit_instance;
    var iterator = $this.skn_1.tkm_1.k();
    while (iterator.l()) {
      var callback = iterator.m();
      iterator.b5();
      try {
        callback();
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          ThrowableHandlers_getInstance().ps_1.os(t);
        } else {
          throw $p;
        }
      }
    }
    // Inline function 'kotlin.check' call
    if (!$this.skn_1.tkm_1.p()) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.<no name provided>.runCallbacks.<anonymous>' call
      var message = '' + $this.skn_1.tkm_1.n() + ' callbacks are left';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function Client$init$o$onCommandCommitted$lambda($cmd) {
    return function (listener) {
      listener.tkn($cmd);
      return Unit_instance;
    };
  }
  function fireProcessingRestored($this) {
    var _iterator__ex2g4s = $this.lkm_1.k();
    while (_iterator__ex2g4s.l()) {
      var rootId = _iterator__ex2g4s.m();
      $this.mkm_1.a28(Client$fireProcessingRestored$lambda(rootId));
    }
    $this.lkm_1.m2();
  }
  function doLoadEntity($this, reference) {
    // Inline function 'kotlin.check' call
    if (!!commandInProgress($this)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.doLoadEntity.<anonymous>' call
      var message = 'Invalid internal loadEntity() call, ' + reference.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if ($this.hkm_1) {
      Companion_getInstance_245().ukn_1.ho('loading reference: ' + reference.toString());
    }
    var entityId = reference.g35_1;
    var status = $this.vkn(reference);
    if ($this.hkm_1) {
      Companion_getInstance_245().ukn_1.ho('status for reference ' + reference.toString() + ' is ' + status.toString());
    }
    switch (status.a3_1) {
      case 1:
        return new AsyncWithDisposable(Asyncs_instance.p2l(ensureNotNull($this.i3f().w34().w32(entityId))));
      case 2:
        return new AsyncWithDisposable(Asyncs_instance.q2l(new OtRejectionException(RejectionReason_NOT_FOUND_getInstance())));
      case 0:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    checkLoadRestrictions($this, reference);
    var rootId = reference.f35_1;
    var clientRoot = getRoot($this, rootId);
    var shouldLoadEntity = !$this.qkm_1.xkn(reference);
    if ($this.hkm_1 && !shouldLoadEntity) {
      Companion_getInstance_245().ukn_1.ho('reference ' + reference.toString() + ' is being loaded');
    }
    var result = clientRoot.ykn(entityId);
    $this.qkm_1.zkn(rootId, entityId, clientRoot);
    if ($this.hkm_1 && clientRoot.ako()) {
      Companion_getInstance_245().ukn_1.ho('root is being reconnecting, skipping message for ' + reference.toString());
    }
    if ($this.hkm_1 && !$this.bko().qr()) {
      Companion_getInstance_245().ukn_1.ho('client is disconnected, skipping loading message for ' + reference.toString());
    }
    if (shouldLoadEntity && !clientRoot.ako() && $this.bko().qr()) {
      $this.cko(rootId, entityId);
    }
    return result;
  }
  function commandInProgress($this) {
    return $this.kkm_1.n3j_1 || $this.kkm_1.o3j_1;
  }
  function checkLoadRestrictions($this, reference) {
    // Inline function 'kotlin.check' call
    if (!reference.h35()) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.checkLoadRestrictions.<anonymous>' call
      var message = 'Trying to load not root ' + reference.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function getRoot($this, rootId) {
    var clientRoot = $this.okm_1.y2(rootId);
    if (clientRoot == null) {
      clientRoot = $this.qkm_1.dko(rootId);
      if (clientRoot == null) {
        clientRoot = new ClientRootImpl(rootId, $this, VOID, $this.ikm_1);
      }
    }
    return clientRoot;
  }
  function checkCanBeUnloaded($this, rootId) {
    var root = getRoot($this, rootId);
    // Inline function 'kotlin.check' call
    if (!(root.ikn() && !root.ykl())) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.checkCanBeUnloaded.<anonymous>' call
      var message = "Can't unload root, id=" + rootId.toString() + ', state=' + root.eko();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function doConnect($this) {
    // Inline function 'kotlin.check' call
    if (!!$this.jkm_1.qr()) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.doConnect.<anonymous>' call
      var message = 'Client is already connected';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    onConnectionEstablished_0($this);
    $this.jkm_1.t2c(true);
    fireProcessingRestored($this);
    $this.skm_1.a28(ProtocolListener$onConnectionEstablished$ref());
  }
  function onConnectionEstablished_0($this) {
    var rootsToLoad = ArrayList_init_$Create$();
    var reconnectHelper = new LoadedEntitiesTreeReconnectHelper($this.pkm_1);
    var _iterator__ex2g4s = $this.okm_1.v2().k();
    while (_iterator__ex2g4s.l()) {
      var root = _iterator__ex2g4s.m();
      // Inline function 'kotlin.check' call
      if (!root.ikn()) {
        // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.onConnectionEstablished.<anonymous>' call
        var message = 'Nonexistent root in collection, ' + toString_1(root);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      (new OutgoingRequest()).ckn(root.jkn());
      rootsToLoad.e(reconnectHelper.xkb(root.o3i(), root.gko()));
    }
    if (!rootsToLoad.p()) {
      ensureNotNull($this.ukm_1).ckc(CommandId_init_$Create$(), rootsToLoad);
    }
    var _iterator__ex2g4s_0 = $this.qkm_1.hko().k();
    while (_iterator__ex2g4s_0.l()) {
      var root_0 = _iterator__ex2g4s_0.m();
      if (!root_0.ikn()) {
        (new OutgoingRequest()).ckn(root_0.jkn());
      }
    }
  }
  function onConnectionBroken_0($this) {
    $this.jkm_1.t2c(false);
    var _iterator__ex2g4s = HashSet_init_$Create$_0($this.okm_1.v2()).k();
    while (_iterator__ex2g4s.l()) {
      var clientRoot = _iterator__ex2g4s.m();
      (new IncomingRequest()).ckn(clientRoot.jkn());
    }
    $this.skm_1.a28(ProtocolListener$onConnectionBroken$ref());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = $this.rkm_1.w().k();
    while (_iterator__ex2g4s_0.l()) {
      // Inline function 'kotlin.collections.component2' call
      var value = _iterator__ex2g4s_0.m().y();
      value.o2l(new OtRejectionException(RejectionReason_DISCONNECTED_getInstance()));
    }
    $this.rkm_1.m2();
  }
  function applyHighLevelRemovals($this, rootId, highLevelRemovals) {
    if (highLevelRemovals.s(rootId)) {
      var root = $this.i3f().c31_1.w32(rootId);
      if (root == null) {
        getRoot($this, rootId).iko();
        return Unit_instance;
      }
      if ($this.qkm_1.jko(rootId)) {
        getRoot($this, rootId).iko();
        var destroyRootOperation = OperationBuilder_instance.m3l(root);
        $this.kkm_1.j3l(destroyRootOperation);
        return Unit_instance;
      }
      if (!getRoot($this, rootId).ako()) {
        $this.kko(rootId);
      }
      return Unit_instance;
    }
    var updateOps = ArrayList_init_$Create$();
    var _iterator__ex2g4s = highLevelRemovals.k();
    while (_iterator__ex2g4s.l()) {
      var id = _iterator__ex2g4s.m();
      var entity = $this.i3f().w34().w32(id);
      if (!(entity == null)) {
        updateOps.e(OperationConverter_instance.o3l(ensureNotNull(entity.yt()), OperationBuilder_instance.p3l(entity, ensureNotNull(entity.l2z_1))));
      }
    }
    $this.kkm_1.j3l(Companion_instance_64.d3m(updateOps));
  }
  function cleanup_0($this, entity, redundantIds) {
    if (!$this.pkm_1.e35(entity.j2z_1)) {
      redundantIds.e(entity.j2z_1);
      return Unit_instance;
    }
    if ($this.lko(entity.j2z_1)) {
      var _iterator__ex2g4s = entity.v2z().k();
      while (_iterator__ex2g4s.l()) {
        var childId = _iterator__ex2g4s.m();
        var _iterator__ex2g4s_0 = entity.w2z(childId).k();
        while (_iterator__ex2g4s_0.l()) {
          var child = _iterator__ex2g4s_0.m();
          cleanup_0($this, child, redundantIds);
        }
      }
    }
  }
  function isNotRegisteredInTree($this, rootId) {
    return !$this.pkm_1.e35(rootId);
  }
  function assertRootCommand($this, loadCommandId) {
    // Inline function 'kotlin.check' call
    if (!loadCommandId.l4r()) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.assertRootCommand.<anonymous>' call
      var message = 'Expected root load command: ' + loadCommandId.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function fireCommandUnprocessed($this, commandId) {
    $this.skm_1.a28(Client$fireCommandUnprocessed$lambda(commandId));
    fireEntityUnprocessed($this, commandId.h4r_1);
  }
  function fireEntityUnprocessed($this, rootId) {
    if ($this.lkm_1.s(rootId)) {
      return Unit_instance;
    }
    $this.lkm_1.e(rootId);
    $this.mkm_1.a28(Client$fireEntityUnprocessed$lambda(rootId));
  }
  function MyPort_0($outer) {
    this.wkm_1 = $outer;
    var tmp = this;
    tmp.vkm_1 = new Client$MyPort$1(this.wkm_1, this);
  }
  protoOf(MyPort_0).ika = function () {
    return this.vkm_1;
  };
  protoOf(MyPort_0).mko = function (output, internalErrorHandler) {
    // Inline function 'kotlin.check' call
    if (!(this.wkm_1.ukm_1 == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.MyPort.setOutput.<anonymous>' call
      var message = 'Output is already set';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp = this.wkm_1;
    tmp.ukm_1 = new Client$MyPort$setOutput$1(output, this.wkm_1);
    doConnect(this.wkm_1);
  };
  protoOf(MyPort_0).mka = function (output, internalErrorHandler) {
    return this.mko((!(output == null) ? isInterface(output, OtChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(MyPort_0).vr = function () {
    var tmp0 = this.wkm_1.ukm_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'jetbrains.ocelot.ot.model.protocol.client.MyPort.dispose.<anonymous>' call
        var message = 'Connection has already been broken';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    this.wkm_1.ukm_1 = null;
    this.wkm_1.nkm_1 = false;
    onConnectionBroken_0(this.wkm_1);
  };
  function Companion_245() {
    Companion_instance_245 = this;
    this.ukn_1 = getLogger(getKClass(Client));
  }
  var Companion_instance_245;
  function Companion_getInstance_245() {
    if (Companion_instance_245 == null)
      new Companion_245();
    return Companion_instance_245;
  }
  function Client$init$validator$1(this$0) {
    this.nko_1 = this$0;
  }
  protoOf(Client$init$validator$1).z3i = function (operationRootId, op) {
    var clientRoot = getRoot(this.nko_1, operationRootId);
    // Inline function 'kotlin.check' call
    if (!(!clientRoot.ikn() || clientRoot.ft() || clientRoot.ako())) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.<no name provided>.validate.<anonymous>' call
      var message = '[operation on ' + clientRoot.eko() + ' root]';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  };
  function Client$init$listener$1(this$0) {
    this.skn_1 = this$0;
  }
  protoOf(Client$init$listener$1).oko = function (op) {
    if (!(op == null)) {
      var operationRootId = ensureNotNull(OperationRootIdInfo_init_$Create$_0(op).x3j_1);
      var root = getRoot(this.skn_1, operationRootId);
      root.pko(op);
      var cmd = Command_init_$Create$(new RootCommandId(CommandId_init_$Create$(), operationRootId), root.gko(), op);
      this.skn_1.skm_1.a28(Client$init$o$onCommandCommitted$lambda(cmd));
      (new OutgoingRequest()).ckn(root.akn(cmd));
      if (!this.skn_1.bko().qr()) {
        fireEntityUnprocessed(this.skn_1, operationRootId);
      }
    }
    runCallbacks(this);
  };
  protoOf(Client$init$listener$1).x3k = function (op) {
    return this.oko(op);
  };
  protoOf(Client$init$listener$1).qko = function (op) {
    if (!this.skn_1.kkm_1.n3j_1) {
      runCallbacks(this);
    }
  };
  protoOf(Client$init$listener$1).z3k = function (op) {
    return this.qko(op);
  };
  protoOf(Client$init$listener$1).a3l = function () {
    if (!this.skn_1.kkm_1.n3j_1) {
      runCallbacks(this);
    }
  };
  function Client$fireProcessingRestored$lambda($rootId) {
    return function (listener) {
      listener.rko($rootId);
      return Unit_instance;
    };
  }
  function Client$loadEntity$lambda($result, this$0, $reference) {
    return function () {
      var tmp;
      if (!$result.wkl()) {
        $result.xkl(doLoadEntity(this$0, $reference));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Client$sendCommand$lambda($cmd) {
    return function (listener) {
      listener.sko($cmd);
      return Unit_instance;
    };
  }
  function Client$commandRejected$lambda($rootCommandId, $reason) {
    return function (listener) {
      listener.tko($rootCommandId, $reason);
      return Unit_instance;
    };
  }
  function ProtocolListener$onConnectionEstablished$ref() {
    var l = function (p0) {
      p0.uko();
      return Unit_instance;
    };
    l.callableName = 'onConnectionEstablished';
    return l;
  }
  function ProtocolListener$onConnectionBroken$ref() {
    var l = function (p0) {
      p0.vko();
      return Unit_instance;
    };
    l.callableName = 'onConnectionBroken';
    return l;
  }
  function Client$fireAlreadyProcessed$lambda($receivedCommand) {
    return function (listener) {
      listener.wko($receivedCommand);
      return Unit_instance;
    };
  }
  function Client$fireCommandReceived$lambda($receivedCommand) {
    return function (listener) {
      listener.xko($receivedCommand);
      return Unit_instance;
    };
  }
  function Client$fireCommandUnprocessed$lambda($commandId) {
    return function (listener) {
      listener.yko($commandId);
      return Unit_instance;
    };
  }
  function Client$fireEntityUnprocessed$lambda($rootId) {
    return function (listener) {
      listener.zko($rootId);
      return Unit_instance;
    };
  }
  function Client(context, merger, noModel, verboseLog, enableAddRemoveValidator, nodeFactory) {
    Companion_getInstance_245();
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.hkm_1 = verboseLog;
    this.ikm_1 = nodeFactory;
    this.jkm_1 = new ValueProperty(false);
    this.lkm_1 = HashSet_init_$Create$();
    this.mkm_1 = new Listeners();
    this.nkm_1 = false;
    this.okm_1 = HashMap_init_$Create$();
    this.pkm_1 = new LoadedEntitiesTree();
    this.qkm_1 = new LoadingReferences();
    this.rkm_1 = HashMap_init_$Create$();
    this.skm_1 = new Listeners();
    this.tkm_1 = ArrayList_init_$Create$_0(0);
    this.ukm_1 = null;
    // Inline function 'kotlin.require' call
    if (!(!noModel || context.w34().p())) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.<anonymous>' call
      var message = 'To create client with state, use ' + toString_1(getKClass(Memento));
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.kkm_1 = newCommandProcessor(context, merger, true, enableAddRemoveValidator, this.ikm_1);
  }
  protoOf(Client).bko = function () {
    return this.jkm_1;
  };
  protoOf(Client).i3f = function () {
    return this.kkm_1.d3j_1;
  };
  protoOf(Client).y98 = function () {
    // Inline function 'kotlin.check' call
    if (!!this.nkm_1) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.<get-port>.<anonymous>' call
      var message = 'Port is already opened';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.nkm_1 = true;
    return new MyPort_0(this);
  };
  protoOf(Client).akp = function () {
    var validator = new Client$init$validator$1(this);
    this.kkm_1.d3l(validator);
    var listener = new Client$init$listener$1(this);
    this.kkm_1.f3l(listener);
  };
  protoOf(Client).bkp = function (wrapperContext, edt) {
    // Inline function 'kotlin.check' call
    if (!equals(this.i3f(), wrapperContext.d4s_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.bind.<anonymous>' call
      var message = "Client can't be bound to WrapperContext with not same EntityContext";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(wrapperContext.o4u(get_COMMAND_PROCESSOR_KEY()) == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.bind.<anonymous>' call
      var message_0 = 'WrapperContext already has CommandProcessor';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    wrapperContext.p4u(get_COMMAND_PROCESSOR_KEY(), this.kkm_1);
    wrapperContext.v4s_1 = new ClientLoadingPeer(this, edt);
  };
  protoOf(Client).vr = function () {
    return this.kkm_1.vr();
  };
  protoOf(Client).ckp = function (reference) {
    return this.dkp(reference).ukl_1;
  };
  protoOf(Client).dkp = function (reference) {
    var tmp;
    if (commandInProgress(this)) {
      if (this.hkm_1) {
        Companion_getInstance_245().ukn_1.ho('postpone load ' + reference.toString());
      }
      var result = new AsyncWithDisposable(new SimpleAsync());
      this.tkm_1.e(Client$loadEntity$lambda(result, this, reference));
      tmp = result;
    } else {
      tmp = doLoadEntity(this, reference);
    }
    return tmp;
  };
  protoOf(Client).ekp = function (memento) {
    // Inline function 'kotlin.check' call
    if (!this.okm_1.p()) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.restore.<anonymous>' call
      var message = 'Client already has internal state';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (!(memento.hkp_1 == null)) {
      this.pkm_1 = ensureNotNull(memento.hkp_1);
    }
    var restored = memento.gkp_1;
    var _iterator__ex2g4s = this.i3f().c31_1.k();
    while (_iterator__ex2g4s.l()) {
      var root = _iterator__ex2g4s.m();
      var rootId = root.j2z_1;
      var m = ensureNotNull(restored).s2(rootId);
      new ClientRootImpl(rootId, this, ensureNotNull(m), this.ikm_1);
    }
    // Inline function 'kotlin.check' call
    if (!ensureNotNull(restored).p()) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.restore.<anonymous>' call
      var message_0 = 'Roots set mismatch';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    memento.m2();
  };
  protoOf(Client).cko = function (rootId, entityId) {
    ensureNotNull(this.ukm_1).fkc(LoadCommandId_init_$Create$(rootId, entityId));
  };
  protoOf(Client).ikp = function (cmd) {
    ensureNotNull(this.ukm_1).ykb(cmd);
    this.skm_1.a28(Client$sendCommand$lambda(cmd));
  };
  protoOf(Client).lkn = function (rootCommandId, reason) {
    ensureNotNull(this.ukm_1).bkc(rootCommandId);
    this.skm_1.a28(Client$commandRejected$lambda(rootCommandId, reason));
  };
  protoOf(Client).kko = function (rootId) {
    this.jkp(setOf(rootId));
  };
  protoOf(Client).jkp = function (rootIds) {
    var _iterator__ex2g4s = rootIds.k();
    while (_iterator__ex2g4s.l()) {
      var rootId = _iterator__ex2g4s.m();
      checkCanBeUnloaded(this, rootId);
    }
    if (!rootIds.p() && this.bko().qr()) {
      ensureNotNull(this.ukm_1).lkc(CommandId_init_$Create$(), rootIds);
    }
    var _iterator__ex2g4s_0 = rootIds.k();
    while (_iterator__ex2g4s_0.l()) {
      var rootId_0 = _iterator__ex2g4s_0.m();
      getRoot(this, rootId_0).kkp();
    }
  };
  protoOf(Client).lkp = function (rootId) {
    var root = this.i3f().c31_1.w32(rootId);
    if (root == null) {
      // Inline function 'kotlin.check' call
      if (!!this.pkm_1.e35(rootId)) {
        // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.cleanup.<anonymous>' call
        var message = rootId.toString() + ' is not in loaded entities';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    } else {
      var redundantIds = HashSet_init_$Create$();
      cleanup_0(this, root, redundantIds);
      applyHighLevelRemovals(this, rootId, redundantIds);
    }
  };
  protoOf(Client).vkn = function (reference) {
    var tmp0_elvis_lhs = this.i3f().w34().w32(reference.g35_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return ReferenceStatus_NOT_LOADED_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var entity = tmp;
    var refRoot = ensureNotNull(Entities_getInstance().p30(entity));
    var tmp_0;
    if (reference.f35_1.equals(refRoot.j2z_1)) {
      var tmp_1;
      if (this.pkm_1.lkb(entity)) {
        tmp_1 = ReferenceStatus_LOADED_getInstance();
      } else {
        tmp_1 = ReferenceStatus_NOT_LOADED_getInstance();
      }
      tmp_0 = tmp_1;
    } else {
      Companion_getInstance_245().ukn_1.fo('Broken reference ' + reference.toString() + ': actual root=' + refRoot.toString() + ', entity=' + entity.toString());
      tmp_0 = ReferenceStatus_ERROR_getInstance();
    }
    return tmp_0;
  };
  protoOf(Client).lko = function (id) {
    return this.pkm_1.kkb(id);
  };
  protoOf(Client).mkp = function (entity) {
    if (!this.pkm_1.lkb(entity)) {
      this.pkm_1.nkb(entity);
    }
  };
  protoOf(Client).nkp = function (rootId) {
    return this.okm_1.w2(rootId) && !isNotRegisteredInTree(this, rootId);
  };
  protoOf(Client).okp = function (root) {
    var rootId = root.o3i();
    // Inline function 'kotlin.collections.set' call
    this.okm_1.r2(rootId, root);
    if (isNotRegisteredInTree(this, rootId) && !this.qkm_1.jko(rootId)) {
      this.pkm_1.mkb(rootId);
    }
  };
  protoOf(Client).pkp = function (rootId) {
    this.pkm_1.okb(rootId);
    this.okm_1.s2(rootId);
  };
  protoOf(Client).zkm = function (commandId, baseVersion, resultVersion) {
    ensureNotNull(this.ukm_1).zkb(commandId, baseVersion, resultVersion);
  };
  protoOf(Client).qkp = function (receivedCommand) {
    this.skm_1.a28(Client$fireAlreadyProcessed$lambda(receivedCommand));
  };
  protoOf(Client).rkp = function (receivedCommand) {
    this.skm_1.a28(Client$fireCommandReceived$lambda(receivedCommand));
  };
  protoOf(Client).skp = function (rootId, buildOperation) {
    var root = this.i3f().c31_1.w32(rootId);
    var info = OperationRootIdInfo_init_$Create$_0(buildOperation);
    // Inline function 'kotlin.check' call
    if (!info.z3j()) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.makeReloadOperation.<anonymous>' call
      var message = ensureNotNull(info.y3j_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!equals(info.x3j_1, rootId)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.makeReloadOperation.<anonymous>' call
      var message_0 = 'Command for different root: expected ' + rootId + ', got ' + toString_0(info.x3j_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.check' call
    if (!RootOperationsUtil_instance.bkd(rootId, buildOperation)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.Client.makeReloadOperation.<anonymous>' call
      var message_1 = 'Invalid build operation for ' + toString_0(root) + ': ' + toString_1(buildOperation);
      throw IllegalStateException_init_$Create$_0(toString_1(message_1));
    }
    var context = new EntityContext();
    buildOperation.a3k(context, this.ikm_1);
    var target = context.c31_1.w32(rootId);
    // Inline function 'kotlin.collections.remove' call
    var this_0 = context.c31_1;
    (isInterface(this_0, MutableCollection) ? this_0 : THROW_CCE()).k2(target);
    this.kkm_1.k3l(rootId);
    var entityDiffBuilder = new EntityDiffBuilder(ensureNotNull(root), ensureNotNull(target));
    return entityDiffBuilder.v3t();
  };
  function defaultMerger($this) {
    return new AccumulatorBasedMerger();
  }
  function withEmptyModel($this, context) {
    return build($this, context, true);
  }
  function fromMemento($this) {
    var currentMemento = $this.xkp_1;
    var noModel = ensureNotNull(currentMemento).np();
    var entityContext = noModel ? new EntityContext() : ensureNotNull(currentMemento.fkp_1);
    var client = build($this, entityContext, noModel);
    if (!noModel) {
      client.ekp(currentMemento);
    }
    return client;
  }
  function build($this, context, noModel) {
    var merger = $this.wkp_1;
    if (merger == null) {
      merger = defaultMerger($this);
      $this.wkp_1 = merger;
    }
    var client = new Client(context, merger, noModel, $this.ukp_1, $this.vkp_1, $this.tkp_1);
    client.akp();
    return client;
  }
  function ClientBuilder(nodeFactory) {
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.tkp_1 = nodeFactory;
    this.ukp_1 = false;
    this.vkp_1 = true;
    this.wkp_1 = null;
    this.xkp_1 = null;
    this.ykp_1 = null;
  }
  protoOf(ClientBuilder).k2p = function () {
    var tmp;
    if (this.xkp_1 == null) {
      var tmp0_elvis_lhs = this.ykp_1;
      tmp = withEmptyModel(this, tmp0_elvis_lhs == null ? new EntityContext() : tmp0_elvis_lhs);
    } else {
      tmp = fromMemento(this);
    }
    return tmp;
  };
  protoOf(ClientBuilder).zkp = function (context) {
    // Inline function 'kotlin.check' call
    if (!(this.xkp_1 == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientBuilder.setEntityContext.<anonymous>' call
      var message = 'Either memento or entity context should be used to configure client';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!(this.ykp_1 == null)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientBuilder.setEntityContext.<anonymous>' call
      var message_0 = 'EntityContext is already set';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    this.ykp_1 = context;
    return this;
  };
  function Companion_246() {
    Companion_instance_246 = this;
    this.akq_1 = getLogger(getKClass(ClientLoadingPeer));
  }
  var Companion_instance_246;
  function Companion_getInstance_246() {
    if (Companion_instance_246 == null)
      new Companion_246();
    return Companion_instance_246;
  }
  function ClientLoadingPeer(client, edt) {
    Companion_getInstance_246();
    this.bkq_1 = client;
    this.ckq_1 = edt;
  }
  var State_NONE_instance;
  var State_RECONNECTING_instance;
  var State_ACTIVE_instance_0;
  var State_UNLOADING_instance;
  var State_entriesInitialized_1;
  function State_initEntries_1() {
    if (State_entriesInitialized_1)
      return Unit_instance;
    State_entriesInitialized_1 = true;
    State_NONE_instance = new State_2('NONE', 0);
    State_RECONNECTING_instance = new State_2('RECONNECTING', 1);
    State_ACTIVE_instance_0 = new State_2('ACTIVE', 2);
    State_UNLOADING_instance = new State_2('UNLOADING', 3);
  }
  function _get_isNonExistent__5hkdae($this) {
    return $this.hkq_1.equals(State_NONE_getInstance());
  }
  function _get_isAlive__mwnani($this) {
    return $this.ikn() && !$this.ykl();
  }
  function _get_root__dd8asp($this) {
    return $this.ekq_1.i3f().c31_1.w32($this.dkq_1);
  }
  function _get_loadingIdsWithoutAsyncs__8u76oe($this) {
    var loadingEntityIds = HashSet_init_$Create$_0($this.ekq_1.qkm_1.jkq($this.dkq_1));
    loadingEntityIds.k1($this.ikq_1.u2());
    return loadingEntityIds;
  }
  function _get_isZeroVersionRoot__ff8urt($this) {
    var tmp;
    if (_get_isNonExistent__5hkdae($this)) {
      tmp = false;
    } else {
      tmp = (!($this.gkq_1 == null) && ensureNotNull($this.gkq_1).lkq_1 === 0 && !ensureNotNull($this.gkq_1).np());
    }
    return tmp;
  }
  function _get_idStateMessage__ekeloa($this) {
    return 'rootId=' + $this.dkq_1.toString() + ', state=' + $this.hkq_1.toString();
  }
  function activate($this, operation) {
    setupCommandQueue_0($this, operation);
    doActivate($this);
  }
  function doActivate($this) {
    $this.hkq_1 = State_ACTIVE_getInstance_0();
    $this.ekq_1.okp($this);
  }
  function setActive($this) {
    $this.hkq_1 = State_ACTIVE_getInstance_0();
    // Inline function 'kotlin.check' call
    if (!!(!(_get_root__dd8asp($this) == null) && !$this.ekq_1.nkp($this.dkq_1))) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientRootImpl.setActive.<anonymous>' call
      var message = _get_idStateMessage__ekeloa($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function getAsyncsHandler($this, id) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.ikq_1;
    var value = this_0.y2(id);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientRootImpl.getAsyncsHandler.<anonymous>' call
      var answer = new AsyncsListHandler();
      this_0.r2(id, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
  function failLoadAsyncs($this, entityId, reason) {
    var loadingReferences = $this.ekq_1.qkm_1;
    if (loadingReferences.okq($this.dkq_1, entityId)) {
      loadingReferences.nkq($this.dkq_1, entityId);
    }
    if ($this.ikq_1.w2(entityId)) {
      ensureNotNull($this.ikq_1.s2(entityId)).wka(reason);
    }
  }
  function succeedLoadAsyncs($this, entityId) {
    if ($this.dkq_1.equals(entityId)) {
      handleAllLoadAsyncs($this);
    } else {
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = $this.ikq_1;
      if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w2(entityId)) {
        handleEntityLoadAsyncs($this, ensureNotNull(entityId));
      }
    }
  }
  function handleAllLoadAsyncs($this) {
    updateLoadingRefsStates($this, $this.ikq_1.u2());
    var _iterator__ex2g4s = LinkedHashSet_init_$Create$_0($this.ikq_1.u2()).k();
    while (_iterator__ex2g4s.l()) {
      var id = _iterator__ex2g4s.m();
      var entity = getEntity($this, id);
      if (entity == null) {
        ensureNotNull($this.ikq_1.s2(id)).wka(RejectionReason_NOT_FOUND_getInstance());
      } else {
        ensureNotNull($this.ikq_1.s2(id)).vka(entity);
      }
    }
  }
  function updateLoadingRefsStates($this, toRemoveFromLoadingRefs) {
    var _iterator__ex2g4s = toRemoveFromLoadingRefs.k();
    while (_iterator__ex2g4s.l()) {
      var id = _iterator__ex2g4s.m();
      $this.ekq_1.qkm_1.nkq($this.dkq_1, id);
    }
    var _iterator__ex2g4s_0 = $this.ikq_1.u2().k();
    while (_iterator__ex2g4s_0.l()) {
      var id_0 = _iterator__ex2g4s_0.m();
      var entity = getEntity($this, id_0);
      if (!(entity == null)) {
        $this.ekq_1.mkp(entity);
      }
    }
    $this.ekq_1.lkp($this.dkq_1);
  }
  function handleEntityLoadAsyncs($this, id) {
    $this.ekq_1.qkm_1.nkq($this.dkq_1, id);
    var entity = getEntity($this, id);
    if (entity == null) {
      $this.ekq_1.lkp($this.dkq_1);
      ensureNotNull($this.ikq_1.s2(id)).wka(RejectionReason_NOT_FOUND_getInstance());
    } else {
      $this.ekq_1.mkp(entity);
      ensureNotNull($this.ikq_1.s2(id)).vka(entity);
    }
  }
  function getEntity($this, entityId) {
    return $this.ekq_1.i3f().w34().w32(entityId);
  }
  function onLoadAccepted_0($this, entityId) {
    var isLoading = $this.ekq_1.qkm_1.okq($this.dkq_1, entityId);
    if (isLoading && !$this.ikq_1.w2(entityId)) {
      $this.ekq_1.qkm_1.nkq($this.dkq_1, entityId);
      if (!$this.ekq_1.qkm_1.jko($this.dkq_1) && !$this.ekq_1.pkm_1.e35($this.dkq_1)) {
        $this.ekq_1.kko($this.dkq_1);
      }
    } else {
      onRootBecameActive($this);
      succeedLoadAsyncs($this, entityId);
    }
  }
  function onLoadRejected_0($this, entityId, reason) {
    if (!(getEntity($this, entityId) == null) && !$this.ekq_1.lko(entityId)) {
      succeedLoadAsyncs($this, entityId);
      return Unit_instance;
    }
    failLoadAsyncs($this, entityId, reason);
    if ($this.dkq_1.equals(entityId) && !$this.ekq_1.lko($this.dkq_1)) {
      remove($this);
    }
  }
  function reconnect($this) {
    switch ($this.hkq_1.a3_1) {
      case 0:
        processPendingLoadingAsyncs($this);
        break;
      case 2:
        $this.hkq_1 = State_RECONNECTING_getInstance();
        break;
      default:
        throw IllegalStateException_init_$Create$_0(_get_idStateMessage__ekeloa($this));
    }
  }
  function processPendingLoadingAsyncs($this) {
    cleanupLoadingEntitiesWithoutAsyncs($this);
    var _iterator__ex2g4s = LinkedHashSet_init_$Create$_0($this.ikq_1.u2()).k();
    while (_iterator__ex2g4s.l()) {
      var id = _iterator__ex2g4s.m();
      var status = $this.ekq_1.vkn(new EntityReference($this.dkq_1, id));
      if (!(status === ReferenceStatus_NOT_LOADED_getInstance())) {
        $this.ekq_1.qkm_1.nkq($this.dkq_1, id);
        if (status === ReferenceStatus_LOADED_getInstance()) {
          ensureNotNull($this.ikq_1.s2(id)).vka(ensureNotNull(getEntity($this, id)));
        } else {
          ensureNotNull($this.ikq_1.s2(id)).wka(RejectionReason_NOT_FOUND_getInstance());
        }
      }
    }
    var _iterator__ex2g4s_0 = $this.ikq_1.u2().k();
    while (_iterator__ex2g4s_0.l()) {
      var id_0 = _iterator__ex2g4s_0.m();
      $this.ekq_1.cko($this.dkq_1, id_0);
    }
  }
  function cleanupLoadingEntitiesWithoutAsyncs($this) {
    var _iterator__ex2g4s = _get_loadingIdsWithoutAsyncs__8u76oe($this).k();
    while (_iterator__ex2g4s.l()) {
      var loadingIdWithoutAsyncs = _iterator__ex2g4s.m();
      if (!($this.ekq_1.i3f().w34().w32(loadingIdWithoutAsyncs) == null)) {
        throw RuntimeException_init_$Create$();
      }
      $this.ekq_1.qkm_1.nkq($this.dkq_1, loadingIdWithoutAsyncs);
    }
  }
  function remove($this) {
    if ($this.ikn()) {
      if (!(_get_root__dd8asp($this) == null)) {
        doRemoveRoot($this);
      }
      $this.iko();
    }
  }
  function doRemoveRoot($this) {
    var op = OperationBuilder_instance.m3l(ensureNotNull(_get_root__dd8asp($this)));
    $this.ekq_1.kkm_1.j3l(op);
  }
  function commitNewRoot($this) {
    // Inline function 'kotlin.check' call
    if (!RootOperationsUtil_instance.zkc($this.dkq_1, ensureNotNull($this.gkq_1).pkq().f4r_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientRootImpl.commitNewRoot.<anonymous>' call
      var message = 'Root operations without root creation, id=' + $this.dkq_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    commitQueue($this);
  }
  function onReconnectAccepted($this) {
    // Inline function 'kotlin.check' call
    if (!$this.ako()) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientRootImpl.onReconnectAccepted.<anonymous>' call
      var message = _get_idStateMessage__ekeloa($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    onRootBecameActive($this);
    processPendingLoadingAsyncs($this);
  }
  function onReconnectRejected_0($this, reason) {
    processPendingLoadingAsyncs($this);
    if (_get_isNonExistent__5hkdae($this))
      return Unit_instance;
    // Inline function 'kotlin.check' call
    if (!$this.ako()) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientRootImpl.onReconnectRejected.<anonymous>' call
      var message = _get_idStateMessage__ekeloa($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    switch (reason.a3_1) {
      case 0:
        if (_get_isZeroVersionRoot__ff8urt($this)) {
          commitNewRoot($this);
          setActive($this);
        } else {
          remove($this);
        }

        break;
      case 1:
        remove($this);
        break;
      case 2:
        throw IllegalStateException_init_$Create$_0(reconnectRejectedMessage($this, "Possible reasons are: entity '" + $this.dkq_1.toString() + "' is not a root or reconnect command contains invalid data"));
      case 3:
        throw IllegalStateException_init_$Create$_0(reconnectRejectedMessage($this, 'Server internal error occurred'));
      default:
        throw IllegalStateException_init_$Create$_0('Unknown rejection reason: ' + reason.toString());
    }
  }
  function reconnectRejectedMessage($this, details) {
    var r = $this.ekq_1.i3f().z34($this.dkq_1);
    var root = r == null ? 'rootId=' + $this.dkq_1.i2s_1 : 'root=' + toString_0(r);
    return 'Reconnect rejected for ' + root + '. ' + details + '. See server log for details.';
  }
  function onConnectionBroken_1($this) {
    switch ($this.hkq_1.a3_1) {
      case 0:
        throw IllegalStateException_init_$Create$();
      case 1:
        setActive($this);
        break;
      case 3:
        $this.pkn();
        break;
      case 2:
        updateLoadingRefsStates($this, _get_loadingIdsWithoutAsyncs__8u76oe($this));
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  function onCommandCommitted_0($this, commandId, operation) {
    // Inline function 'kotlin.check' call
    if (!_get_isAlive__mwnani($this)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientRootImpl.onCommandCommitted.<anonymous>' call
      var message = _get_idStateMessage__ekeloa($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var toTransit = addCommand($this, commandId, operation);
    if ($this.ekq_1.bko().qr() && !$this.ako()) {
      transitCommand($this, toTransit);
    }
  }
  function addCommand($this, id, op) {
    var cmd = Command_init_$Create$(new RootCommandId(id, $this.dkq_1), ensureNotNull($this.gkq_1).lkq_1, op);
    ensureNotNull($this.gkq_1).qkq(cmd);
    return cmd;
  }
  function transitCommand($this, command) {
    $this.ekq_1.ikp(command);
  }
  function commitQueue($this) {
    var _iterator__ex2g4s = ensureNotNull($this.gkq_1).rkq().k();
    while (_iterator__ex2g4s.l()) {
      var cmd = _iterator__ex2g4s.m();
      transitCommand($this, cmd);
    }
  }
  function onCommandReceived_0($this, command) {
    if (_get_isNonExistent__5hkdae($this)) {
      activate($this, command.f4r_1);
    }
    if (ensureNotNull($this.gkq_1).skq(command.c4r_1)) {
      poll($this, command.c4r_1, true);
      updateVersion($this, command.c4r_1, command.d4r_1, command.e4r_1);
      $this.ekq_1.zkm(command.c4r_1, command.d4r_1, command.e4r_1);
      $this.ekq_1.qkp(command);
      return Unit_instance;
    }
    if ($this.ako() && $this.gko() > 0 && command.d4r_1 === 0) {
      var newOperation = $this.ekq_1.skp($this.dkq_1, command.f4r_1);
      invalidateCommandQueue($this);
      doExecuteExternalCommand($this, command.c4r_1, command.d4r_1, command.e4r_1, newOperation);
      $this.ekq_1.rkp(command);
    } else {
      doExecuteExternalCommand($this, command.c4r_1, command.d4r_1, command.e4r_1, transform_0($this, command).f4r_1);
      $this.ekq_1.rkp(command);
    }
  }
  function doExecuteExternalCommand($this, id, baseV, resultV, op) {
    $this.ekq_1.zkm(id, baseV, resultV);
    doExecuteExternalOp($this, op);
    updateVersion($this, id, baseV, resultV);
  }
  function doExecuteExternalOp($this, op) {
    $this.ekq_1.kkm_1.j3l(op);
    cleanUpCommandQueue($this);
  }
  function updateVersion($this, id, baseV, resultV) {
    if ($this.gkq_1 == null)
      return Unit_instance;
    // Inline function 'kotlin.check' call
    if (!(baseV === ensureNotNull($this.gkq_1).lkq_1)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientRootImpl.updateVersion.<anonymous>' call
      var message = toString_1($this.ekq_1) + ' model version is ' + ensureNotNull($this.gkq_1).lkq_1 + '; received command ' + id.toString() + ', ' + baseV + '->' + resultV;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    ensureNotNull($this.gkq_1).lkq_1 = resultV;
  }
  function onCommandAccepted_0($this, id, baseVersion, resultVersion) {
    var cmd = poll($this, id, true);
    var commandQueue = $this.gkq_1;
    if (!(commandQueue == null)) {
      // Inline function 'kotlin.check' call
      if (!(commandQueue.lkq_1 === baseVersion || RootOperationsUtil_instance.zkc(id.h4r_1, cmd.f4r_1))) {
        // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientRootImpl.onCommandAccepted.<anonymous>' call
        var message = 'Versions mismatch for accepted command';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      commandQueue.lkq_1 = resultVersion;
    }
  }
  function onCommandRejected_0($this, id, reason) {
    if (!$this.ft()) {
      var tmp = _get_idStateMessage__ekeloa($this) + ' reason=' + reason.toString();
      var tmp_0;
      if ($this.gkq_1 == null) {
        tmp_0 = ' message queue is null';
      } else {
        tmp_0 = ' last command=' + toString_0(ensureNotNull($this.gkq_1).tkq());
      }
      var msg = tmp + tmp_0;
      throw IllegalStateException_init_$Create$_0(msg);
    }
    var command = poll($this, id, false);
    var inverse = command.f4r_1.s3l();
    var inverseCommand = new Command(command.c4r_1, 0, 0, inverse);
    var toApply = transform_0($this, inverseCommand);
    doExecuteExternalOp($this, toApply.f4r_1);
    $this.ekq_1.lkn(id, reason);
    resendCommands($this);
  }
  function transform_0($this, command) {
    var commandQueue = $this.gkq_1;
    var tmp;
    if (commandQueue == null) {
      tmp = command;
    } else {
      var newCommand = commandQueue.ukq(command);
      commandQueue.vkq(command);
      tmp = newCommand;
    }
    return tmp;
  }
  function poll($this, toVerify, cleanup) {
    var cmd = ensureNotNull($this.gkq_1).wkq();
    if (cleanup) {
      cleanUpCommandQueue($this);
    }
    // Inline function 'kotlin.check' call
    if (!cmd.c4r_1.equals(toVerify)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientRootImpl.poll.<anonymous>' call
      var message = 'Invalid command, expected: ' + cmd.c4r_1.toString() + '; actual: ' + toVerify.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return cmd;
  }
  function cleanUpCommandQueue($this) {
    var commandQueue = $this.gkq_1;
    if (!(commandQueue == null) && commandQueue.np() && _get_root__dd8asp($this) == null) {
      $this.iko();
    }
  }
  function onRootBecameActive($this) {
    if ($this.ft() || $this.ykl())
      return Unit_instance;
    setActive($this);
    resendCommands($this);
  }
  function resendCommands($this) {
    var commandQueue = $this.gkq_1;
    if (!(commandQueue == null)) {
      commandQueue.xkq();
      commitQueue($this);
    }
  }
  function setupCommandQueue($this, baseVersion) {
    // Inline function 'kotlin.check' call
    if (!($this.gkq_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    $this.gkq_1 = new CommandQueue($this.dkq_1);
    ensureNotNull($this.gkq_1).lkq_1 = baseVersion;
  }
  function setupCommandQueue_0($this, op) {
    if ($this.gkq_1 == null) {
      // Inline function 'kotlin.check' call
      if (!RootOperationsUtil_instance.bkd($this.dkq_1, op)) {
        // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientRootImpl.setupCommandQueue.<anonymous>' call
        var message = 'Invalid root operation: ' + toString_1(op);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      setupCommandQueue($this, 0);
    }
  }
  function invalidateCommandQueue($this) {
    // Inline function 'kotlin.checkNotNull' call
    var tmp0 = $this.gkq_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'kotlin.checkNotNull.<anonymous>' call
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    $this.gkq_1 = new CommandQueue($this.dkq_1);
    ensureNotNull($this.gkq_1).lkq_1 = 0;
  }
  function State_2(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function LoadHandler($outer) {
    this.ykq_1 = $outer;
  }
  protoOf(LoadHandler).zkq = function (acceptance) {
    onLoadAccepted_0(this.ykq_1, ensureNotNull(acceptance.fkn_1));
  };
  protoOf(LoadHandler).akr = function (rejection) {
    onLoadRejected_0(this.ykq_1, ensureNotNull(rejection.nkn_1), rejection.okn_1);
  };
  protoOf(LoadHandler).bkr = function (request) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(LoadHandler).ckr = function (request) {
    throw UnsupportedOperationException_init_$Create$();
  };
  function ReconnectHandler($outer) {
    this.dkr_1 = $outer;
  }
  protoOf(ReconnectHandler).zkq = function (acceptance) {
    return onReconnectAccepted(this.dkr_1);
  };
  protoOf(ReconnectHandler).akr = function (rejection) {
    return onReconnectRejected_0(this.dkr_1, rejection.okn_1);
  };
  protoOf(ReconnectHandler).bkr = function (request) {
    return onConnectionBroken_1(this.dkr_1);
  };
  protoOf(ReconnectHandler).ckr = function (request) {
    return reconnect(this.dkr_1);
  };
  function EventHandler($outer) {
    this.ekr_1 = $outer;
  }
  protoOf(EventHandler).bkr = function (request) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EventHandler).ckr = function (request) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EventHandler).zkq = function (acceptance) {
    onCommandAccepted_0(this.ekr_1, new RootCommandId(acceptance.ekn_1, this.ekr_1.dkq_1), ensureNotNull(acceptance.gkn_1), ensureNotNull(acceptance.hkn_1));
  };
  protoOf(EventHandler).akr = function (rejection) {
    onCommandRejected_0(this.ekr_1, new RootCommandId(rejection.mkn_1, this.ekr_1.dkq_1), rejection.okn_1);
  };
  function CommandEventHandler($outer, command) {
    this.hkr_1 = $outer;
    EventHandler.call(this, $outer);
    this.gkr_1 = command;
  }
  protoOf(CommandEventHandler).bkr = function (request) {
    return onCommandReceived_0(this.hkr_1, this.gkr_1);
  };
  protoOf(CommandEventHandler).ckr = function (request) {
    onCommandCommitted_0(this.hkr_1, this.gkr_1.c4r_1.g4r_1, this.gkr_1.f4r_1);
  };
  function ClientRootImpl$load$$inlined$toDisposable$1(this$0, $entityId, $async) {
    this.ikr_1 = this$0;
    this.jkr_1 = $entityId;
    this.kkr_1 = $async;
  }
  protoOf(ClientRootImpl$load$$inlined$toDisposable$1).vr = function () {
    var asyncsHandler = this.ikr_1.ikq_1.y2(this.jkr_1);
    var tmp;
    if (!(asyncsHandler == null) && asyncsHandler.ska(this.kkr_1)) {
      asyncsHandler.tka(this.kkr_1);
      var tmp_0;
      if (asyncsHandler.wo() === 0) {
        this.ikr_1.ikq_1.s2(this.jkr_1);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  function State_NONE_getInstance() {
    State_initEntries_1();
    return State_NONE_instance;
  }
  function State_RECONNECTING_getInstance() {
    State_initEntries_1();
    return State_RECONNECTING_instance;
  }
  function State_ACTIVE_getInstance_0() {
    State_initEntries_1();
    return State_ACTIVE_instance_0;
  }
  function State_UNLOADING_getInstance() {
    State_initEntries_1();
    return State_UNLOADING_instance;
  }
  function ClientRootImpl(rootId, client, memento, nodeFactory) {
    memento = memento === VOID ? null : memento;
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    this.dkq_1 = rootId;
    this.ekq_1 = client;
    this.fkq_1 = nodeFactory;
    this.gkq_1 = null;
    this.hkq_1 = State_NONE_getInstance();
    this.ikq_1 = LinkedHashMap_init_$Create$();
    if (!(memento == null)) {
      setupCommandQueue(this, memento.lkr_1);
      var _iterator__ex2g4s = memento.mkr_1.k();
      while (_iterator__ex2g4s.l()) {
        var command = _iterator__ex2g4s.m();
        ensureNotNull(this.gkq_1).qkq(command);
      }
      doActivate(this);
    }
  }
  protoOf(ClientRootImpl).o3i = function () {
    return this.dkq_1;
  };
  protoOf(ClientRootImpl).gko = function () {
    // Inline function 'kotlin.check' call
    if (!_get_isAlive__mwnani(this)) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientRootImpl.<get-version>.<anonymous>' call
      var message = _get_idStateMessage__ekeloa(this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return ensureNotNull(this.gkq_1).lkq_1;
  };
  protoOf(ClientRootImpl).eko = function () {
    var tmp;
    if (!this.ikq_1.p()) {
      tmp = 'loading';
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.hkq_1.z2_1.toLowerCase();
    }
    return tmp;
  };
  protoOf(ClientRootImpl).ako = function () {
    return this.hkq_1.equals(State_RECONNECTING_getInstance());
  };
  protoOf(ClientRootImpl).ykl = function () {
    return this.hkq_1.equals(State_UNLOADING_getInstance());
  };
  protoOf(ClientRootImpl).ft = function () {
    return this.hkq_1.equals(State_ACTIVE_getInstance_0());
  };
  protoOf(ClientRootImpl).ikn = function () {
    return !this.hkq_1.equals(State_NONE_getInstance());
  };
  protoOf(ClientRootImpl).kkn = function () {
    return new LoadHandler(this);
  };
  protoOf(ClientRootImpl).jkn = function () {
    return new ReconnectHandler(this);
  };
  protoOf(ClientRootImpl).toString = function () {
    return this.dkq_1.i2s_1 + '(' + this.hkq_1.toString() + ')';
  };
  protoOf(ClientRootImpl).ykn = function (entityId) {
    var loadRoot = this.dkq_1.equals(entityId);
    // Inline function 'kotlin.check' call
    if (!!(loadRoot && _get_isZeroVersionRoot__ff8urt(this))) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientRootImpl.load.<anonymous>' call
      var message = 'Loading root with history, ' + _get_idStateMessage__ekeloa(this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var async = getAsyncsHandler(this, entityId).uka();
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$1 = new ClientRootImpl$load$$inlined$toDisposable$1(this, entityId, async);
    return new AsyncWithDisposable(async, tmp$ret$1);
  };
  protoOf(ClientRootImpl).kkp = function () {
    doRemoveRoot(this);
    if (this.ekq_1.bko().qr()) {
      this.hkq_1 = State_UNLOADING_getInstance();
      this.gkq_1 = null;
    } else {
      this.iko();
    }
  };
  protoOf(ClientRootImpl).pkn = function () {
    // Inline function 'kotlin.check' call
    if (!this.ykl()) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.ClientRootImpl.unloadHandled.<anonymous>' call
      var message = _get_idStateMessage__ekeloa(this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.iko();
  };
  protoOf(ClientRootImpl).pko = function (operation) {
    if (_get_isNonExistent__5hkdae(this)) {
      activate(this, operation);
    }
  };
  protoOf(ClientRootImpl).iko = function () {
    this.ekq_1.pkp(this.dkq_1);
    this.hkq_1 = State_NONE_getInstance();
    this.gkq_1 = null;
  };
  protoOf(ClientRootImpl).akn = function (command) {
    return new CommandEventHandler(this, command);
  };
  protoOf(ClientRootImpl).dkn = function () {
    return new EventHandler(this);
  };
  function getIndex($this, id) {
    var tmp0 = $this.mkq_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var item = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.ot.model.protocol.client.CommandQueue.getIndex.<anonymous>' call
        if (item.c4r_1.equals(id)) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  }
  function CommandQueue(rootId) {
    this.kkq_1 = rootId;
    this.lkq_1 = 0;
    this.mkq_1 = ArrayDeque_init_$Create$();
  }
  protoOf(CommandQueue).np = function () {
    return this.mkq_1.p();
  };
  protoOf(CommandQueue).rkq = function () {
    return this.mkq_1;
  };
  protoOf(CommandQueue).ukq = function (command) {
    var result = command;
    var _iterator__ex2g4s = this.mkq_1.k();
    while (_iterator__ex2g4s.l()) {
      var cmd = _iterator__ex2g4s.m();
      result = cmd.i4r(result, false);
    }
    return result;
  };
  protoOf(CommandQueue).vkq = function (cmd) {
    var newQueue = ArrayDeque_init_$Create$();
    var currentCmd = cmd;
    var _iterator__ex2g4s = this.mkq_1.k();
    while (_iterator__ex2g4s.l()) {
      var c = _iterator__ex2g4s.m();
      var newCmd = c.i4r(currentCmd, false);
      newQueue.e(currentCmd.i4r(c, true));
      currentCmd = newCmd;
    }
    this.mkq_1 = newQueue;
  };
  protoOf(CommandQueue).qkq = function (command) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.kkq_1.equals(command.c4r_1.h4r_1)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.mkq_1.eg(command);
  };
  protoOf(CommandQueue).wkq = function () {
    return this.mkq_1.fg();
  };
  protoOf(CommandQueue).tkq = function () {
    return this.mkq_1.cg();
  };
  protoOf(CommandQueue).pkq = function () {
    return this.mkq_1.bg();
  };
  protoOf(CommandQueue).skq = function (id) {
    var tmp0_elvis_lhs = this.tkq();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var cmd = tmp;
    if (cmd.c4r_1.equals(id)) {
      return true;
    }
    if (getIndex(this, id) === -1)
      return false;
    throw IllegalStateException_init_$Create$();
  };
  protoOf(CommandQueue).xkq = function () {
    var replacedCommands = ArrayDeque_init_$Create$();
    var _iterator__ex2g4s = this.mkq_1.k();
    while (_iterator__ex2g4s.l()) {
      var command = _iterator__ex2g4s.m();
      replacedCommands.e(new Command(RootCommandId_init_$Create$(command.c4r_1.h4r_1), command.d4r_1, command.e4r_1, command.f4r_1));
    }
    this.mkq_1 = replacedCommands;
  };
  function LoadingReferences$LoadingRootData$loadingEntities$delegate$lambda() {
    return HashSet_init_$Create$();
  }
  function LoadingRootData(clientRoot) {
    this.nkr_1 = clientRoot;
    var tmp = this;
    tmp.okr_1 = lazy_0(LoadingReferences$LoadingRootData$loadingEntities$delegate$lambda);
  }
  protoOf(LoadingRootData).pkr = function () {
    var tmp0 = this.okr_1;
    // Inline function 'kotlin.getValue' call
    loadingEntities$factory();
    return tmp0.y();
  };
  protoOf(LoadingRootData).qkr = function () {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.pkr().p();
  };
  protoOf(LoadingRootData).rkr = function (entityId) {
    return contains_5(this.pkr(), entityId);
  };
  protoOf(LoadingRootData).skr = function (entityId) {
    this.pkr().e(entityId);
  };
  protoOf(LoadingRootData).tkr = function (entityId) {
    var removed = this.pkr().k2(entityId);
    // Inline function 'kotlin.check' call
    if (!removed) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
  };
  function LoadingReferences() {
    this.wkn_1 = HashMap_init_$Create$();
  }
  protoOf(LoadingReferences).hko = function () {
    var loadingRoots = HashSet_init_$Create$_1(this.wkn_1.n());
    var _iterator__ex2g4s = this.wkn_1.v2().k();
    while (_iterator__ex2g4s.l()) {
      var data = _iterator__ex2g4s.m();
      loadingRoots.e(data.nkr_1);
    }
    return loadingRoots;
  };
  protoOf(LoadingReferences).jko = function (rootId) {
    return this.wkn_1.w2(rootId);
  };
  protoOf(LoadingReferences).xkn = function (reference) {
    return this.okq(reference.f35_1, reference.g35_1);
  };
  protoOf(LoadingReferences).okq = function (rootId, entityId) {
    var tmp0_safe_receiver = this.wkn_1.y2(rootId);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.rkr(entityId);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(LoadingReferences).jkq = function (rootId) {
    var tmp0_safe_receiver = this.wkn_1.y2(rootId);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pkr();
    return tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  };
  protoOf(LoadingReferences).dko = function (rootId) {
    var tmp0_safe_receiver = this.wkn_1.y2(rootId);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.nkr_1;
  };
  protoOf(LoadingReferences).zkn = function (rootId, entityId, clientRoot) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.wkn_1;
    var value = this_0.y2(rootId);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.LoadingReferences.put.<anonymous>' call
      var answer = new LoadingRootData(clientRoot);
      this_0.r2(rootId, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var data = tmp;
    // Inline function 'kotlin.check' call
    if (!equals(clientRoot, data.nkr_1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    data.skr(entityId);
  };
  protoOf(LoadingReferences).nkq = function (rootId, entityId) {
    var data = this.wkn_1.y2(rootId);
    // Inline function 'kotlin.check' call
    if (!!(data == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    data.tkr(entityId);
    if (!data.qkr()) {
      this.wkn_1.s2(rootId);
    }
  };
  function loadingEntities$factory() {
    return getPropertyCallableRef('loadingEntities', 1, KProperty1, function (receiver) {
      return receiver.pkr();
    }, null);
  }
  function Memento_init_$Init$($this) {
    Memento.call($this);
    return $this;
  }
  function Memento_init_$Create$() {
    return Memento_init_$Init$(objectCreate(protoOf(Memento)));
  }
  protoOf(Memento).np = function () {
    if (!(this.hkp_1 == null))
      return false;
    if (!!(this.fkp_1 == null ^ this.gkp_1 == null))
      return false;
    return this.fkp_1 == null ? true : ensureNotNull(this.fkp_1).w34().p() && ensureNotNull(this.gkp_1).p();
  };
  protoOf(Memento).m2 = function () {
    this.fkp_1 = null;
    this.gkp_1 = null;
    this.hkp_1 = null;
  };
  function Memento() {
    this.fkp_1 = null;
    this.gkp_1 = null;
    this.hkp_1 = null;
  }
  function OtServiceEndpoint$ExecutingJsonPort$_init_$lambda_574k41(this$0) {
    return function () {
      return new CommonJsonPort(this$0.zkr_1, this$0.vkr_1.y98(), this$0.ykr_1);
    };
  }
  function OtServiceEndpoint$MyThrottlingJsonPort$1$wrappedClientPort$1$input$1($clientPort, $operations) {
    this.cks_1 = $operations;
    OtChannelDelegate.call(this, $clientPort.ika());
  }
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$1$wrappedClientPort$1$input$1).ykb = function (command) {
    this.cks_1.e(command.f4r_1);
    protoOf(OtChannelDelegate).ykb.call(this, command);
  };
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$1$wrappedClientPort$1$input$1).zkb = function (id, baseVersion, resultVersion) {
    Companion_getInstance_247().dks_1.go('command accepted: ' + id.toString());
    protoOf(OtChannelDelegate).zkb.call(this, id, baseVersion, resultVersion);
  };
  function getLogCaption($this, n) {
    return n.toString() + (n === 1 ? ' OT command was executed during long run:' : ' OT commands were executed during long run:');
  }
  function OtServiceEndpoint$MyThrottlingJsonPort$1$wrappedClientPort$1($clientPort, $operations) {
    this.hks_1 = $clientPort;
    this.iks_1 = $operations;
  }
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$1$wrappedClientPort$1).ika = function () {
    return new OtServiceEndpoint$MyThrottlingJsonPort$1$wrappedClientPort$1$input$1(this.hks_1, this.iks_1);
  };
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$1$wrappedClientPort$1).vr = function () {
    this.hks_1.vr();
  };
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$1$wrappedClientPort$1).mko = function (output, internalErrorHandler) {
    this.hks_1.mka(output, internalErrorHandler);
  };
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$1$wrappedClientPort$1).mka = function (output, internalErrorHandler) {
    return this.mko((!(output == null) ? isInterface(output, OtChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  function OtServiceEndpoint$MyThrottlingJsonPort$_init_$lambda_bvoohc(this$0, $operations) {
    return function () {
      var clientPort = this$0.vkr_1.y98();
      var wrappedClientPort = new OtServiceEndpoint$MyThrottlingJsonPort$1$wrappedClientPort$1(clientPort, $operations);
      return new CommonJsonPort(this$0.zkr_1, wrappedClientPort, this$0.ykr_1);
    };
  }
  function OtServiceEndpoint$CommonJsonPort$$inlined$jsonChannel$1(this$0) {
    this.jks_1 = this$0;
  }
  protoOf(OtServiceEndpoint$CommonJsonPort$$inlined$jsonChannel$1).fka = function (message) {
    // Inline function 'jetbrains.ocelot.ot.model.protocol.client.CommonJsonPort.stub_for_inlining' call
    this.jks_1.qks(message);
    return Unit_instance;
  };
  protoOf(OtServiceEndpoint$CommonJsonPort$$inlined$jsonChannel$1).dka = function (message) {
    return this.fka(message instanceof JsonArray ? message : THROW_CCE());
  };
  function OtServiceEndpoint_init_$Init$(client, protocolConfiguration, clientEdt, isThrottlingEnabled, nodeFactory, $this) {
    isThrottlingEnabled = isThrottlingEnabled === VOID ? false : isThrottlingEnabled;
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    OtServiceEndpoint.call($this, 'ot', client, protocolConfiguration, clientEdt, isThrottlingEnabled, nodeFactory);
    return $this;
  }
  function OtServiceEndpoint_init_$Create$(client, protocolConfiguration, clientEdt, isThrottlingEnabled, nodeFactory) {
    return OtServiceEndpoint_init_$Init$(client, protocolConfiguration, clientEdt, isThrottlingEnabled, nodeFactory, objectCreate(protoOf(OtServiceEndpoint)));
  }
  function doOpenPort($this) {
    var tmp;
    if ($this.xkr_1) {
      tmp = new MyThrottlingJsonPort($this, ArrayList_init_$Create$());
    } else {
      tmp = new ExecutingJsonPort($this);
    }
    return tmp;
  }
  function ExecutingJsonPort($outer) {
    this.yks_1 = $outer;
    JsonPortExecutingDelegate.call(this, OtServiceEndpoint$ExecutingJsonPort$_init_$lambda_574k41($outer), $outer.wkr_1);
  }
  protoOf(ExecutingJsonPort).vr = function () {
    this.yks_1.aks_1 = false;
    protoOf(JsonPortExecutingDelegate).vr.call(this);
  };
  function MyThrottlingJsonPort($outer, operations) {
    this.okt_1 = $outer;
    ThrottlingJsonPort.call(this, OtServiceEndpoint$MyThrottlingJsonPort$_init_$lambda_bvoohc($outer, operations), $outer.wkr_1, 150, 400, numberToInt(2.0 * 150));
    this.nkt_1 = operations;
  }
  protoOf(MyThrottlingJsonPort).skd = function () {
    this.nkt_1.m2();
  };
  protoOf(MyThrottlingJsonPort).ukd = function (longRun) {
    if (longRun) {
      try {
        Companion_getInstance_247().dks_1.fo(getLogCaption(this, this.nkt_1.n()));
        var iterator = this.nkt_1.k();
        var index = 0;
        while (iterator.l()) {
          var index_0 = index;
          index = index + 1 | 0;
          var operation = iterator.m();
          Companion_getInstance_247().dks_1.go('operation ' + index_0 + ': ' + Companion_instance_49.i3m(operation).toString());
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var throwable = $p;
          Companion_getInstance_247().dks_1.co('exception caught during collecting operation statistics', throwable);
        } else {
          throw $p;
        }
      }
    }
  };
  protoOf(MyThrottlingJsonPort).vr = function () {
    this.okt_1.aks_1 = false;
    protoOf(ThrottlingJsonPort).vr.call(this);
  };
  function CommonJsonPort(idCompressor, port, nodeFactory) {
    this.kks_1 = idCompressor;
    this.lks_1 = port;
    this.mks_1 = nodeFactory;
    this.nks_1 = Ot2JsonChannelAdapter_init_$Create$(this.kks_1, this.lks_1.ika(), this.mks_1);
    this.pks_1 = null;
    var tmp = this;
    // Inline function 'jetbrains.ocelot.ot.commons.protocol.json.jsonChannel' call
    tmp.oks_1 = new OtServiceEndpoint$CommonJsonPort$$inlined$jsonChannel$1(this);
  }
  protoOf(CommonJsonPort).ika = function () {
    return this.oks_1;
  };
  protoOf(CommonJsonPort).qks = function (msg) {
    try {
      this.nks_1.fka(msg);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        if (this.pks_1 == null) {
          throw IllegalStateException_init_$Create$_1('internal error handler is null during processing error in message ' + msg.toString(), t);
        }
        ensureNotNull(this.pks_1)(FatalEndpointException_init_$Create$_0('OT service failed', t));
      } else {
        throw $p;
      }
    }
  };
  protoOf(CommonJsonPort).iki = function (output, internalErrorHandler) {
    this.pks_1 = internalErrorHandler;
    this.nks_1.bkg();
    var json2OtChannelAdapter = Json2OtChannelAdapter_init_$Create$(this.kks_1, output, this.mks_1);
    this.lks_1.mka(json2OtChannelAdapter, internalErrorHandler);
  };
  protoOf(CommonJsonPort).mka = function (output, internalErrorHandler) {
    return this.iki((!(output == null) ? isInterface(output, JsonChannel) : false) ? output : THROW_CCE(), internalErrorHandler);
  };
  protoOf(CommonJsonPort).vr = function () {
    this.lks_1.vr();
    this.nks_1.vr();
  };
  function Companion_247() {
    Companion_instance_247 = this;
    this.dks_1 = getLogger(getKClass(OtServiceEndpoint));
    this.eks_1 = 150;
    this.fks_1 = 400;
    this.gks_1 = 2.0;
  }
  var Companion_instance_247;
  function Companion_getInstance_247() {
    if (Companion_instance_247 == null)
      new Companion_247();
    return Companion_instance_247;
  }
  function OtServiceEndpoint(shortName, client, protocolConfiguration, clientEdt, isThrottlingEnabled, nodeFactory) {
    Companion_getInstance_247();
    isThrottlingEnabled = isThrottlingEnabled === VOID ? false : isThrottlingEnabled;
    nodeFactory = nodeFactory === VOID ? RawNodeFactory_instance : nodeFactory;
    JsonServiceEndpoint.call(this);
    this.ukr_1 = shortName;
    this.vkr_1 = client;
    this.wkr_1 = clientEdt;
    this.xkr_1 = isThrottlingEnabled;
    this.ykr_1 = nodeFactory;
    this.aks_1 = false;
    var tmp;
    if (protocolConfiguration.f2y(ProtocolParameters_getInstance().mke_1)) {
      tmp = defaultClientIdCompressorSupplier();
    } else {
      tmp = nullIdCompressorSupplier();
    }
    var idCompressorSupplier = tmp;
    this.zkr_1 = idCompressorSupplier();
  }
  protoOf(OtServiceEndpoint).qka = function () {
    return this.ukr_1;
  };
  protoOf(OtServiceEndpoint).pka = function () {
    // Inline function 'kotlin.check' call
    if (!!this.aks_1) {
      // Inline function 'jetbrains.ocelot.ot.model.protocol.client.OtServiceEndpoint.openJsonPort.<anonymous>' call
      var message = 'port is already opened';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var port = doOpenPort(this);
    this.aks_1 = true;
    return port;
  };
  protoOf(OtServiceEndpoint).vr = function () {
    this.vkr_1.vr();
  };
  function ProtocolListener() {
  }
  function IncomingAcceptance_init_$Init$(commandId, baseVersion, resultVersion, $this) {
    IncomingAcceptance.call($this, commandId, null, baseVersion, resultVersion);
    return $this;
  }
  function IncomingAcceptance_init_$Create$(commandId, baseVersion, resultVersion) {
    return IncomingAcceptance_init_$Init$(commandId, baseVersion, resultVersion, objectCreate(protoOf(IncomingAcceptance)));
  }
  function IncomingAcceptance(commandId, entityId, baseVersion, resultVersion) {
    entityId = entityId === VOID ? null : entityId;
    baseVersion = baseVersion === VOID ? null : baseVersion;
    resultVersion = resultVersion === VOID ? null : resultVersion;
    this.ekn_1 = commandId;
    this.fkn_1 = entityId;
    this.gkn_1 = baseVersion;
    this.hkn_1 = resultVersion;
  }
  protoOf(IncomingAcceptance).ckn = function (handler) {
    handler.zkq(this);
  };
  function IncomingRejection_init_$Init$(commandId, reason, $this) {
    IncomingRejection.call($this, commandId, null, reason);
    return $this;
  }
  function IncomingRejection_init_$Create$(commandId, reason) {
    return IncomingRejection_init_$Init$(commandId, reason, objectCreate(protoOf(IncomingRejection)));
  }
  function IncomingRejection(commandId, entityId, reason) {
    this.mkn_1 = commandId;
    this.nkn_1 = entityId;
    this.okn_1 = reason;
  }
  protoOf(IncomingRejection).ckn = function (handler) {
    handler.akr(this);
  };
  function IncomingRequest(commandId) {
    commandId = commandId === VOID ? null : commandId;
    this.bkn_1 = commandId;
  }
  protoOf(IncomingRequest).ckn = function (handler) {
    handler.bkr(this);
  };
  function OutgoingRequest(entityId) {
    entityId = entityId === VOID ? null : entityId;
    this.fko_1 = entityId;
  }
  protoOf(OutgoingRequest).ckn = function (handler) {
    handler.ckr(this);
  };
  function Companion_248() {
  }
  var Companion_instance_248;
  function Companion_getInstance_248() {
    return Companion_instance_248;
  }
  function DoubleRectangle(origin, dimension) {
    this.pkt_1 = origin;
    this.qkt_1 = dimension;
  }
  protoOf(DoubleRectangle).rkt = function () {
    var result = ArrayList_init_$Create$();
    result.e(new DoubleSegment(this.pkt_1, this.pkt_1.ukt(new DoubleVector(this.qkt_1.skt_1, 0.0))));
    result.e(new DoubleSegment(this.pkt_1, this.pkt_1.ukt(new DoubleVector(0.0, this.qkt_1.tkt_1))));
    result.e(new DoubleSegment(this.pkt_1.ukt(this.qkt_1), this.pkt_1.ukt(new DoubleVector(this.qkt_1.skt_1, 0.0))));
    result.e(new DoubleSegment(this.pkt_1.ukt(this.qkt_1), this.pkt_1.ukt(new DoubleVector(0.0, this.qkt_1.tkt_1))));
    return result;
  };
  protoOf(DoubleRectangle).vkt = function (to) {
    var result = 0.0;
    var hasResult = false;
    var _iterator__ex2g4s = this.rkt().k();
    while (_iterator__ex2g4s.l()) {
      var s = _iterator__ex2g4s.m();
      if (!hasResult) {
        result = s.vkt(to);
        hasResult = true;
      } else {
        var distance = s.vkt(to);
        if (distance < result) {
          result = distance;
        }
      }
    }
    return result;
  };
  protoOf(DoubleRectangle).toString = function () {
    return '[rect ' + this.pkt_1.toString() + ', ' + this.qkt_1.toString() + ']';
  };
  protoOf(DoubleRectangle).hashCode = function () {
    var result = this.pkt_1.hashCode();
    result = imul(result, 31) + this.qkt_1.hashCode() | 0;
    return result;
  };
  protoOf(DoubleRectangle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DoubleRectangle))
      return false;
    var tmp0_other_with_cast = other instanceof DoubleRectangle ? other : THROW_CCE();
    if (!this.pkt_1.equals(tmp0_other_with_cast.pkt_1))
      return false;
    if (!this.qkt_1.equals(tmp0_other_with_cast.qkt_1))
      return false;
    return true;
  };
  function isDistanceToLineBest($this, v) {
    var es = $this.wkt_1.ykt($this.xkt_1);
    var se = es.p3();
    var ev = v.ykt($this.xkt_1);
    var sv = v.ykt($this.wkt_1);
    return es.zkt(ev) >= 0 && se.zkt(sv) >= 0;
  }
  function DoubleSegment(start, end) {
    this.wkt_1 = start;
    this.xkt_1 = end;
  }
  protoOf(DoubleSegment).vkt = function (v) {
    var vs = this.wkt_1.ykt(v);
    var ve = this.xkt_1.ykt(v);
    var tmp;
    if (isDistanceToLineBest(this, v)) {
      // Inline function 'kotlin.math.abs' call
      var x = vs.skt_1 * ve.tkt_1 - vs.tkt_1 * ve.skt_1;
      var pVolume = Math.abs(x);
      tmp = pVolume / this.aku();
    } else {
      var tmp1 = vs.aku();
      // Inline function 'kotlin.math.min' call
      var b = ve.aku();
      tmp = Math.min(tmp1, b);
    }
    return tmp;
  };
  protoOf(DoubleSegment).aku = function () {
    return this.wkt_1.ykt(this.xkt_1).aku();
  };
  protoOf(DoubleSegment).toString = function () {
    return '[' + this.wkt_1.toString() + ' -> ' + this.xkt_1.toString() + ']';
  };
  protoOf(DoubleSegment).hashCode = function () {
    var result = this.wkt_1.hashCode();
    result = imul(result, 31) + this.xkt_1.hashCode() | 0;
    return result;
  };
  protoOf(DoubleSegment).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DoubleSegment))
      return false;
    var tmp0_other_with_cast = other instanceof DoubleSegment ? other : THROW_CCE();
    if (!this.wkt_1.equals(tmp0_other_with_cast.wkt_1))
      return false;
    if (!this.xkt_1.equals(tmp0_other_with_cast.xkt_1))
      return false;
    return true;
  };
  function Companion_249() {
    Companion_instance_249 = this;
    this.bku_1 = new DoubleVector(0.0, 0.0);
  }
  var Companion_instance_249;
  function Companion_getInstance_249() {
    if (Companion_instance_249 == null)
      new Companion_249();
    return Companion_instance_249;
  }
  function DoubleVector(x, y) {
    Companion_getInstance_249();
    this.skt_1 = x;
    this.tkt_1 = y;
  }
  protoOf(DoubleVector).ukt = function (v) {
    return new DoubleVector(this.skt_1 + v.skt_1, this.tkt_1 + v.tkt_1);
  };
  protoOf(DoubleVector).ykt = function (v) {
    return new DoubleVector(this.skt_1 - v.skt_1, this.tkt_1 - v.tkt_1);
  };
  protoOf(DoubleVector).zkt = function (v) {
    return this.skt_1 * v.skt_1 + this.tkt_1 * v.tkt_1;
  };
  protoOf(DoubleVector).p3 = function () {
    return new DoubleVector(-this.skt_1, -this.tkt_1);
  };
  protoOf(DoubleVector).aku = function () {
    // Inline function 'kotlin.math.sqrt' call
    var x = this.skt_1 * this.skt_1 + this.tkt_1 * this.tkt_1;
    return Math.sqrt(x);
  };
  protoOf(DoubleVector).toString = function () {
    return '(' + this.skt_1 + ', ' + this.tkt_1 + ')';
  };
  protoOf(DoubleVector).hashCode = function () {
    var result = getNumberHashCode(this.skt_1);
    result = imul(result, 31) + getNumberHashCode(this.tkt_1) | 0;
    return result;
  };
  protoOf(DoubleVector).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DoubleVector))
      return false;
    var tmp0_other_with_cast = other instanceof DoubleVector ? other : THROW_CCE();
    if (!equals(this.skt_1, tmp0_other_with_cast.skt_1))
      return false;
    if (!equals(this.tkt_1, tmp0_other_with_cast.tkt_1))
      return false;
    return true;
  };
  function Rectangle_init_$Init$(x, y, width, height, $this) {
    Rectangle.call($this, new Vector(x, y), new Vector(width, height));
    return $this;
  }
  function Rectangle_init_$Create$(x, y, width, height) {
    return Rectangle_init_$Init$(x, y, width, height, objectCreate(protoOf(Rectangle)));
  }
  function toDoubleRectangle($this) {
    return new DoubleRectangle($this.cku_1.gku(), $this.dku_1.gku());
  }
  function Companion_250() {
    Companion_instance_250 = this;
    this.hku_1 = new Rectangle(Companion_getInstance_251().iku_1, Companion_getInstance_251().iku_1);
  }
  var Companion_instance_250;
  function Companion_getInstance_250() {
    if (Companion_instance_250 == null)
      new Companion_250();
    return Companion_instance_250;
  }
  function Rectangle(origin, dimension) {
    Companion_getInstance_250();
    this.cku_1 = origin;
    this.dku_1 = dimension;
  }
  protoOf(Rectangle).jku = function (v) {
    return new Rectangle(this.cku_1.jku(v), this.dku_1);
  };
  protoOf(Rectangle).kku = function (v) {
    return new Rectangle(this.cku_1.kku(v), this.dku_1);
  };
  protoOf(Rectangle).lku = function (r) {
    return this.mku(r.cku_1) && this.mku(r.cku_1.jku(r.dku_1));
  };
  protoOf(Rectangle).mku = function (v) {
    return this.cku_1.eku_1 <= v.eku_1 && (this.cku_1.eku_1 + this.dku_1.eku_1 | 0) >= v.eku_1 && this.cku_1.fku_1 <= v.fku_1 && (this.cku_1.fku_1 + this.dku_1.fku_1 | 0) >= v.fku_1;
  };
  protoOf(Rectangle).nku = function (rect) {
    var newOrigin = this.cku_1.oku(rect.cku_1);
    var corner = this.cku_1.jku(this.dku_1);
    var rectCorner = rect.cku_1.jku(rect.dku_1);
    var newCorner = corner.pku(rectCorner);
    var newDimension = newCorner.kku(newOrigin);
    return new Rectangle(newOrigin, newDimension);
  };
  protoOf(Rectangle).qku = function (rect) {
    var t1 = this.cku_1;
    var t2 = this.cku_1.jku(this.dku_1);
    var r1 = rect.cku_1;
    var r2 = rect.cku_1.jku(rect.dku_1);
    return r2.eku_1 >= t1.eku_1 && t2.eku_1 >= r1.eku_1 && r2.fku_1 >= t1.fku_1 && t2.fku_1 >= r1.fku_1;
  };
  protoOf(Rectangle).rku = function (r) {
    // Inline function 'kotlin.check' call
    if (!this.qku(r)) {
      // Inline function 'jetbrains.ocelot.base.geometry.Rectangle.intersect.<anonymous>' call
      var message = 'rectangle [' + this.toString() + "] doesn't intersect [" + r.toString() + ']';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var too = this.cku_1.jku(this.dku_1);
    var roo = r.cku_1.jku(r.dku_1);
    var ioo = too.oku(roo);
    var io = this.cku_1.pku(r.cku_1);
    return new Rectangle(io, ioo.kku(io));
  };
  protoOf(Rectangle).sku = function (dim) {
    return new Rectangle(this.cku_1, dim);
  };
  protoOf(Rectangle).tku = function (to) {
    return toDoubleRectangle(this).vkt(to.gku());
  };
  protoOf(Rectangle).uku = function () {
    return Companion_instance_36.p2s(this.cku_1.eku_1, this.dku_1.eku_1);
  };
  protoOf(Rectangle).vku = function () {
    return Companion_instance_36.p2s(this.cku_1.fku_1, this.dku_1.fku_1);
  };
  protoOf(Rectangle).wku = function () {
    return this.cku_1.jku(new Vector(this.dku_1.eku_1 / 2 | 0, this.dku_1.fku_1 / 2 | 0));
  };
  protoOf(Rectangle).toString = function () {
    return this.cku_1.toString() + ' - ' + this.dku_1.toString();
  };
  protoOf(Rectangle).ug = function () {
    return this.cku_1;
  };
  protoOf(Rectangle).vg = function () {
    return this.dku_1;
  };
  protoOf(Rectangle).hashCode = function () {
    var result = this.cku_1.hashCode();
    result = imul(result, 31) + this.dku_1.hashCode() | 0;
    return result;
  };
  protoOf(Rectangle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    var tmp0_other_with_cast = other instanceof Rectangle ? other : THROW_CCE();
    if (!this.cku_1.equals(tmp0_other_with_cast.cku_1))
      return false;
    if (!this.dku_1.equals(tmp0_other_with_cast.dku_1))
      return false;
    return true;
  };
  function assertOuterInner($this, outer, inner) {
    // Inline function 'kotlin.require' call
    if (!outer.lku(inner)) {
      // Inline function 'jetbrains.ocelot.base.geometry.Rectangles.assertOuterInner.<anonymous>' call
      var message = 'Outer does not contain inner: outer = ' + outer.toString() + ', inner = ' + inner.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function topLeft($this, r) {
    return r.cku_1;
  }
  function bottomLeft($this, r) {
    return r.cku_1.jku(new Vector(0, r.dku_1.fku_1));
  }
  function Rectangles() {
  }
  protoOf(Rectangles).xku = function (r) {
    return new Rectangle(Companion_getInstance_251().iku_1, r.dku_1);
  };
  protoOf(Rectangles).yku = function (inner, outer) {
    assertOuterInner(this, outer, inner);
    return topLeft(this, inner).fku_1 - topLeft(this, outer).fku_1 | 0;
  };
  protoOf(Rectangles).zku = function (inner, outer) {
    assertOuterInner(this, outer, inner);
    return bottomLeft(this, outer).fku_1 - bottomLeft(this, inner).fku_1 | 0;
  };
  protoOf(Rectangles).akv = function (inner, outer) {
    assertOuterInner(this, outer, inner);
    return topLeft(this, inner).eku_1 - topLeft(this, outer).eku_1 | 0;
  };
  protoOf(Rectangles).bkv = function (inner, outer) {
    assertOuterInner(this, outer, inner);
    return this.ckv(outer).eku_1 - this.ckv(inner).eku_1 | 0;
  };
  protoOf(Rectangles).dkv = function (r, distance) {
    var change = new Vector(0, distance);
    return new Rectangle(r.cku_1.kku(change), r.dku_1.jku(change));
  };
  protoOf(Rectangles).ekv = function (r, distance) {
    return r.sku(r.dku_1.jku(new Vector(0, distance)));
  };
  protoOf(Rectangles).fkv = function (r, distance) {
    var change = new Vector(distance, 0);
    return new Rectangle(r.cku_1.kku(change), r.dku_1.jku(change));
  };
  protoOf(Rectangles).gkv = function (r, distance) {
    return r.sku(r.dku_1.jku(new Vector(distance, 0)));
  };
  protoOf(Rectangles).hkv = function (left, r, right) {
    return this.gkv(this.fkv(r, left), right);
  };
  protoOf(Rectangles).ckv = function (r) {
    return r.cku_1.jku(new Vector(r.dku_1.eku_1, 0));
  };
  var Rectangles_instance;
  function Rectangles_getInstance() {
    return Rectangles_instance;
  }
  function Companion_251() {
    Companion_instance_251 = this;
    this.iku_1 = new Vector(0, 0);
  }
  var Companion_instance_251;
  function Companion_getInstance_251() {
    if (Companion_instance_251 == null)
      new Companion_251();
    return Companion_instance_251;
  }
  function Vector(x, y) {
    Companion_getInstance_251();
    this.eku_1 = x;
    this.fku_1 = y;
  }
  protoOf(Vector).jku = function (v) {
    return new Vector(this.eku_1 + v.eku_1 | 0, this.fku_1 + v.fku_1 | 0);
  };
  protoOf(Vector).kku = function (v) {
    return this.jku(v.p3());
  };
  protoOf(Vector).p3 = function () {
    return new Vector(-this.eku_1 | 0, -this.fku_1 | 0);
  };
  protoOf(Vector).pku = function (v) {
    var tmp0 = this.eku_1;
    // Inline function 'kotlin.math.max' call
    var b = v.eku_1;
    var tmp = Math.max(tmp0, b);
    var tmp2 = this.fku_1;
    // Inline function 'kotlin.math.max' call
    var b_0 = v.fku_1;
    var tmp$ret$1 = Math.max(tmp2, b_0);
    return new Vector(tmp, tmp$ret$1);
  };
  protoOf(Vector).oku = function (v) {
    var tmp0 = this.eku_1;
    // Inline function 'kotlin.math.min' call
    var b = v.eku_1;
    var tmp = Math.min(tmp0, b);
    var tmp2 = this.fku_1;
    // Inline function 'kotlin.math.min' call
    var b_0 = v.fku_1;
    var tmp$ret$1 = Math.min(tmp2, b_0);
    return new Vector(tmp, tmp$ret$1);
  };
  protoOf(Vector).h53 = function (i) {
    return new Vector(imul(this.eku_1, i), imul(this.fku_1, i));
  };
  protoOf(Vector).gku = function () {
    return new DoubleVector(this.eku_1, this.fku_1);
  };
  protoOf(Vector).toString = function () {
    return '(' + this.eku_1 + ', ' + this.fku_1 + ')';
  };
  protoOf(Vector).ug = function () {
    return this.eku_1;
  };
  protoOf(Vector).vg = function () {
    return this.fku_1;
  };
  protoOf(Vector).hashCode = function () {
    var result = this.eku_1;
    result = imul(result, 31) + this.fku_1 | 0;
    return result;
  };
  protoOf(Vector).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector))
      return false;
    var tmp0_other_with_cast = other instanceof Vector ? other : THROW_CCE();
    if (!(this.eku_1 === tmp0_other_with_cast.eku_1))
      return false;
    if (!(this.fku_1 === tmp0_other_with_cast.fku_1))
      return false;
    return true;
  };
  function DomUtil$timerBasedProperty$o$doAddListeners$lambda(this$0) {
    return function () {
      this$0.h2g();
      return Unit_instance;
    };
  }
  function timerBasedProperty($this, supplier, period) {
    return new DomUtil$timerBasedProperty$1(period, supplier);
  }
  function DomUtil$nodeChildren$1($node) {
    this.jkv_1 = $node;
    AbstractMutableList.call(this);
  }
  protoOf(DomUtil$nodeChildren$1).n = function () {
    return get_childCount(this.jkv_1);
  };
  protoOf(DomUtil$nodeChildren$1).q = function (index) {
    return getChild(this.jkv_1, index);
  };
  protoOf(DomUtil$nodeChildren$1).kkv = function (index, element) {
    // Inline function 'kotlin.check' call
    if (!(ensureNotNull(element).parentNode == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var child = ensureNotNull(this.q(index));
    this.jkv_1.replaceChild(child, element);
    return child;
  };
  protoOf(DomUtil$nodeChildren$1).o2 = function (index, element) {
    return this.kkv(index, (element == null ? true : element instanceof Node) ? element : THROW_CCE());
  };
  protoOf(DomUtil$nodeChildren$1).lkv = function (index, element) {
    // Inline function 'kotlin.check' call
    if (!(ensureNotNull(element).parentNode == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    if (index === 0) {
      insertFirst(this.jkv_1, element);
    } else {
      var prev = getChild(this.jkv_1, index - 1 | 0);
      insertAfter(this.jkv_1, element, prev);
    }
  };
  protoOf(DomUtil$nodeChildren$1).p2 = function (index, element) {
    return this.lkv(index, (element == null ? true : element instanceof Node) ? element : THROW_CCE());
  };
  protoOf(DomUtil$nodeChildren$1).q2 = function (index) {
    var child = ensureNotNull(getChild(this.jkv_1, index));
    this.jkv_1.removeChild(child);
    return child;
  };
  function DomUtil$dimension$lambda($element) {
    return function () {
      return new Vector($element.clientWidth, $element.clientHeight);
    };
  }
  function DomUtil$timerBasedProperty$1($period, $supplier) {
    this.pkv_1 = $period;
    this.qkv_1 = $supplier;
    UpdatableProperty.call(this);
    this.okv_1 = -1;
  }
  protoOf(DomUtil$timerBasedProperty$1).h2c = function () {
    var handler = DomUtil$timerBasedProperty$o$doAddListeners$lambda(this);
    this.okv_1 = window.setInterval(handler, this.pkv_1);
  };
  protoOf(DomUtil$timerBasedProperty$1).i2c = function () {
    return window.clearInterval(this.okv_1);
  };
  protoOf(DomUtil$timerBasedProperty$1).g2c = function () {
    return this.qkv_1();
  };
  function DomUtil() {
  }
  protoOf(DomUtil).rkv = function (node) {
    return new DomUtil$nodeChildren$1(node);
  };
  protoOf(DomUtil).skv = function (element) {
    var supplier = DomUtil$dimension$lambda(element);
    return timerBasedProperty(this, supplier, 200);
  };
  var DomUtil_instance;
  function DomUtil_getInstance() {
    return DomUtil_instance;
  }
  var CssUnit_EM_instance;
  var CssUnit_NUMBER_instance;
  var CssUnit_ENUMERABLE_instance;
  var CssUnit_PX_instance;
  var CssUnit_PERCENT_instance;
  var CssUnit_VW_instance;
  var CssUnit_VH_instance;
  var CssUnit_entriesInitialized;
  function CssUnit_initEntries() {
    if (CssUnit_entriesInitialized)
      return Unit_instance;
    CssUnit_entriesInitialized = true;
    CssUnit_EM_instance = new CssUnit('EM', 0, 'em');
    CssUnit_NUMBER_instance = new CssUnit('NUMBER', 1, '');
    CssUnit_ENUMERABLE_instance = new CssUnit('ENUMERABLE', 2, '');
    CssUnit_PX_instance = new CssUnit('PX', 3, 'px');
    CssUnit_PERCENT_instance = new CssUnit('PERCENT', 4, '%');
    CssUnit_VW_instance = new CssUnit('VW', 5, 'vw');
    CssUnit_VH_instance = new CssUnit('VH', 6, 'vh');
  }
  function CssUnit(name, ordinal, stringRepresentation) {
    Enum.call(this, name, ordinal);
    this.vkv_1 = stringRepresentation;
  }
  function CssUnit_PX_getInstance() {
    CssUnit_initEntries();
    return CssUnit_PX_instance;
  }
  function setVisibility(_this__u8e3s4, visibility) {
    return doSetProperty(_this__u8e3s4, 'visibility', visibility);
  }
  function setTop(_this__u8e3s4, top, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'top', top, unit);
  }
  function setHeight(_this__u8e3s4, height, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'height', height, unit);
  }
  function setWidth(_this__u8e3s4, width, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'width', width, unit);
  }
  function setDisplay(_this__u8e3s4, display) {
    return doSetProperty(_this__u8e3s4, 'display', display);
  }
  function setFont(_this__u8e3s4, value) {
    return doSetProperty_1(_this__u8e3s4, 'font', value);
  }
  function clearWidth(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'width');
  }
  function clearHeight(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'height');
  }
  function clearBorderTop(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'border-top');
  }
  function clearBorderBottom(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'border-bottom');
  }
  function clearBorderLeft(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'border-left');
  }
  function clearBorderRight(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'border-right');
  }
  function clearOutline(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'outline');
  }
  function setBorderTop(_this__u8e3s4, border) {
    return doSetProperty_1(_this__u8e3s4, 'border-top', border);
  }
  function setBorderBottom(_this__u8e3s4, border) {
    return doSetProperty_1(_this__u8e3s4, 'border-bottom', border);
  }
  function setBorderRight(_this__u8e3s4, border) {
    return doSetProperty_1(_this__u8e3s4, 'border-right', border);
  }
  function setOutline(_this__u8e3s4, outline) {
    return doSetProperty_1(_this__u8e3s4, 'outline', outline);
  }
  function clearBackgroundColor(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'background-color');
  }
  function setBackgroundColor(_this__u8e3s4, color) {
    return doSetProperty_1(_this__u8e3s4, 'background-color', color);
  }
  function getProperty(_this__u8e3s4, name) {
    return _this__u8e3s4.getPropertyValue(name);
  }
  function get_cssOverflow(_this__u8e3s4) {
    return Companion_instance_252.t2t(getProperty(_this__u8e3s4, 'overflow'));
  }
  function get_cssOverflowX(_this__u8e3s4) {
    return Companion_instance_252.t2t(getProperty(_this__u8e3s4, 'overflow-x'));
  }
  function get_cssOverflowY(_this__u8e3s4) {
    return Companion_instance_252.t2t(getProperty(_this__u8e3s4, 'overflow-y'));
  }
  function setLeft(_this__u8e3s4, left, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'left', left, unit);
  }
  function setPosition(_this__u8e3s4, position) {
    return doSetProperty(_this__u8e3s4, 'position', position);
  }
  function setAlignItems(_this__u8e3s4, alignItems) {
    return doSetProperty(_this__u8e3s4, 'align-items', alignItems);
  }
  function clearAlignItems(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'align-items');
  }
  function setSelfAlignment(_this__u8e3s4, alignItems) {
    return doSetProperty(_this__u8e3s4, 'self-alignment', alignItems);
  }
  function clearSelfAlignment(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'self-alignment');
  }
  function setZIndex(_this__u8e3s4, zIndex) {
    return doSetProperty_1(_this__u8e3s4, 'z-index', zIndex.toString());
  }
  function setMarginRight(_this__u8e3s4, margin, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'margin-right', margin, unit);
  }
  function setMarginBottom(_this__u8e3s4, margin, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'margin-bottom', margin, unit);
  }
  function clearDisplay(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'display');
  }
  function setOverflowX(_this__u8e3s4, overflow) {
    return doSetProperty(_this__u8e3s4, 'overflow-x', overflow);
  }
  function setMaxWidth(_this__u8e3s4, width, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'max-width', width, unit);
  }
  function setMaxHeight(_this__u8e3s4, height, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'max-height', height, unit);
  }
  function setOverflowY(_this__u8e3s4, overflow) {
    return doSetProperty(_this__u8e3s4, 'overflow-y', overflow);
  }
  function setVerticalAlign(_this__u8e3s4, align) {
    return doSetProperty(_this__u8e3s4, 'vertical-align', align);
  }
  function setPadding(_this__u8e3s4, padding, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    setPaddingLeft(_this__u8e3s4, padding, unit);
    setPaddingRight(_this__u8e3s4, padding, unit);
    setPaddingTop(_this__u8e3s4, padding, unit);
    setPaddingBottom(_this__u8e3s4, padding, unit);
    return _this__u8e3s4;
  }
  function setColor(_this__u8e3s4, color) {
    return doSetProperty_1(_this__u8e3s4, 'color', color);
  }
  function setWhiteSpace(_this__u8e3s4, whiteSpace) {
    return doSetProperty(_this__u8e3s4, 'white-space', whiteSpace);
  }
  function setFontWeight(_this__u8e3s4, value) {
    return doSetProperty(_this__u8e3s4, 'font-weight', value);
  }
  function setFontStyle_0(_this__u8e3s4, value) {
    return doSetProperty(_this__u8e3s4, 'font-style', value);
  }
  function setFontFamily(_this__u8e3s4, value) {
    return doSetProperty_1(_this__u8e3s4, 'font-family', value);
  }
  function setFontSize(_this__u8e3s4, value, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'font-size', value, unit);
  }
  function setOverflow(_this__u8e3s4, overflow) {
    return doSetProperty(_this__u8e3s4, 'overflow', overflow);
  }
  function setBorderStyle(_this__u8e3s4, value) {
    return doSetProperty(_this__u8e3s4, 'border-style', value);
  }
  function setOutlineStyle(_this__u8e3s4, value) {
    return doSetProperty(_this__u8e3s4, 'outline-style', value);
  }
  function clearMarginBottom(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'margin-bottom');
  }
  function setMarginTop(_this__u8e3s4, margin, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'margin-top', margin, unit);
  }
  function clearMarginTop(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'margin-top');
  }
  function setStrokeWidth(_this__u8e3s4, width, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'stroke-width', width, unit);
  }
  function setFill(_this__u8e3s4, fill) {
    return doSetProperty_1(_this__u8e3s4, 'fill', fill);
  }
  function setPaddingLeft(_this__u8e3s4, padding, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'padding-left', padding, unit);
  }
  function setClear(_this__u8e3s4, clear) {
    return doSetProperty(_this__u8e3s4, 'clear', clear);
  }
  function setFloat(_this__u8e3s4, cssFloat) {
    return doSetProperty(_this__u8e3s4, 'float', cssFloat);
  }
  function clearOutlineStyle(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'outline-style');
  }
  function clearOutlineColor(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'outline-color');
  }
  function clearBorderWidth(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'border-width');
  }
  function setOutlineColor(_this__u8e3s4, color) {
    return doSetProperty_1(_this__u8e3s4, 'outline-color', color);
  }
  function setOutlineWidth(_this__u8e3s4, width, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'outline-width', width, unit);
  }
  function setBoxShadow(_this__u8e3s4, value) {
    return doSetProperty_1(_this__u8e3s4, 'box-shadow', value);
  }
  function clearBoxShadow(_this__u8e3s4) {
    return clearProperty(_this__u8e3s4, 'box-shadow');
  }
  function setBottom(_this__u8e3s4, bottom, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'bottom', bottom, unit);
  }
  function doSetProperty(_this__u8e3s4, name, value) {
    doSetProperty_1(_this__u8e3s4, name, value.wkv());
    return _this__u8e3s4;
  }
  function doSetProperty_0(_this__u8e3s4, name, value, unit) {
    return doSetProperty_1(_this__u8e3s4, name, toString_0(value) + unit.vkv_1);
  }
  function doSetProperty_1(_this__u8e3s4, name, value) {
    _this__u8e3s4.setProperty(name, value == null ? '' : value);
    return _this__u8e3s4;
  }
  function clearProperty(_this__u8e3s4, name) {
    _this__u8e3s4.removeProperty(name);
    return _this__u8e3s4;
  }
  function setPaddingRight(_this__u8e3s4, padding, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'padding-right', padding, unit);
  }
  function setPaddingTop(_this__u8e3s4, padding, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'padding-top', padding, unit);
  }
  function setPaddingBottom(_this__u8e3s4, padding, unit) {
    unit = unit === VOID ? CssUnit_PX_getInstance() : unit;
    return doSetProperty_0(_this__u8e3s4, 'padding-bottom', padding, unit);
  }
  var CssAlignItem_DEFAULT_instance;
  var CssAlignItem_CENTER_instance;
  var CssAlignItem_STRETCH_instance;
  var CssAlignItem_FLEX_START_instance;
  var CssAlignItem_FLEX_END_instance;
  var CssAlignItem_entriesInitialized;
  function CssAlignItem_initEntries() {
    if (CssAlignItem_entriesInitialized)
      return Unit_instance;
    CssAlignItem_entriesInitialized = true;
    CssAlignItem_DEFAULT_instance = new CssAlignItem('DEFAULT', 0, 'default');
    CssAlignItem_CENTER_instance = new CssAlignItem('CENTER', 1, 'center');
    CssAlignItem_STRETCH_instance = new CssAlignItem('STRETCH', 2, 'stretch');
    CssAlignItem_FLEX_START_instance = new CssAlignItem('FLEX_START', 3, 'flex-start');
    CssAlignItem_FLEX_END_instance = new CssAlignItem('FLEX_END', 4, 'flex-end');
  }
  function CssAlignItem(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.zkv_1 = stringQualifier;
  }
  protoOf(CssAlignItem).wkv = function () {
    return this.zkv_1;
  };
  function CssAlignItem_STRETCH_getInstance() {
    CssAlignItem_initEntries();
    return CssAlignItem_STRETCH_instance;
  }
  function CssAlignItem_FLEX_START_getInstance() {
    CssAlignItem_initEntries();
    return CssAlignItem_FLEX_START_instance;
  }
  function CssAlignItem_FLEX_END_getInstance() {
    CssAlignItem_initEntries();
    return CssAlignItem_FLEX_END_instance;
  }
  function parse_1(str, values) {
    var inductionVariable = 0;
    var last = values.length;
    while (inductionVariable < last) {
      var value = values[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (equals_0(value.wkv(), str, true)) {
        return value;
      }
    }
    return null;
  }
  var CssBorderStyle_NONE_instance;
  var CssBorderStyle_DOTTED_instance;
  var CssBorderStyle_DASHED_instance;
  var CssBorderStyle_HIDDEN_instance;
  var CssBorderStyle_SOLID_instance;
  var CssBorderStyle_entriesInitialized;
  function CssBorderStyle_initEntries() {
    if (CssBorderStyle_entriesInitialized)
      return Unit_instance;
    CssBorderStyle_entriesInitialized = true;
    CssBorderStyle_NONE_instance = new CssBorderStyle('NONE', 0, 'none');
    CssBorderStyle_DOTTED_instance = new CssBorderStyle('DOTTED', 1, 'dotted');
    CssBorderStyle_DASHED_instance = new CssBorderStyle('DASHED', 2, 'dashed');
    CssBorderStyle_HIDDEN_instance = new CssBorderStyle('HIDDEN', 3, 'hidden');
    CssBorderStyle_SOLID_instance = new CssBorderStyle('SOLID', 4, 'solid');
  }
  function CssBorderStyle(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.ckw_1 = stringQualifier;
  }
  protoOf(CssBorderStyle).wkv = function () {
    return this.ckw_1;
  };
  function CssBorderStyle_NONE_getInstance() {
    CssBorderStyle_initEntries();
    return CssBorderStyle_NONE_instance;
  }
  var CssClear_NONE_instance;
  var CssClear_BOTH_instance;
  var CssClear_LEFT_instance;
  var CssClear_RIGHT_instance;
  var CssClear_entriesInitialized;
  function CssClear_initEntries() {
    if (CssClear_entriesInitialized)
      return Unit_instance;
    CssClear_entriesInitialized = true;
    CssClear_NONE_instance = new CssClear('NONE', 0, 'none');
    CssClear_BOTH_instance = new CssClear('BOTH', 1, 'both');
    CssClear_LEFT_instance = new CssClear('LEFT', 2, 'left');
    CssClear_RIGHT_instance = new CssClear('RIGHT', 3, 'right');
  }
  function CssClear(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.fkw_1 = stringQualifier;
  }
  protoOf(CssClear).wkv = function () {
    return this.fkw_1;
  };
  function CssClear_BOTH_getInstance() {
    CssClear_initEntries();
    return CssClear_BOTH_instance;
  }
  var CssDisplay_DEFAULT_instance;
  var CssDisplay_NONE_instance;
  var CssDisplay_BLOCK_instance;
  var CssDisplay_FLEX_instance;
  var CssDisplay_GRID_instance;
  var CssDisplay_INLINE_BLOCK_instance;
  var CssDisplay_entriesInitialized;
  function CssDisplay_initEntries() {
    if (CssDisplay_entriesInitialized)
      return Unit_instance;
    CssDisplay_entriesInitialized = true;
    CssDisplay_DEFAULT_instance = new CssDisplay('DEFAULT', 0, 'default');
    CssDisplay_NONE_instance = new CssDisplay('NONE', 1, 'none');
    CssDisplay_BLOCK_instance = new CssDisplay('BLOCK', 2, 'block');
    CssDisplay_FLEX_instance = new CssDisplay('FLEX', 3, 'flex');
    CssDisplay_GRID_instance = new CssDisplay('GRID', 4, 'grid');
    CssDisplay_INLINE_BLOCK_instance = new CssDisplay('INLINE_BLOCK', 5, 'inline-block');
  }
  function CssDisplay(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.ikw_1 = stringQualifier;
  }
  protoOf(CssDisplay).wkv = function () {
    return this.ikw_1;
  };
  function CssDisplay_NONE_getInstance() {
    CssDisplay_initEntries();
    return CssDisplay_NONE_instance;
  }
  function CssDisplay_BLOCK_getInstance() {
    CssDisplay_initEntries();
    return CssDisplay_BLOCK_instance;
  }
  function CssDisplay_INLINE_BLOCK_getInstance() {
    CssDisplay_initEntries();
    return CssDisplay_INLINE_BLOCK_instance;
  }
  var CssFloat_NONE_instance;
  var CssFloat_LEFT_instance;
  var CssFloat_RIGHT_instance;
  var CssFloat_entriesInitialized;
  function CssFloat_initEntries() {
    if (CssFloat_entriesInitialized)
      return Unit_instance;
    CssFloat_entriesInitialized = true;
    CssFloat_NONE_instance = new CssFloat('NONE', 0, 'none');
    CssFloat_LEFT_instance = new CssFloat('LEFT', 1, 'left');
    CssFloat_RIGHT_instance = new CssFloat('RIGHT', 2, 'right');
  }
  function CssFloat(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.lkw_1 = stringQualifier;
  }
  protoOf(CssFloat).wkv = function () {
    return this.lkw_1;
  };
  function CssFloat_LEFT_getInstance() {
    CssFloat_initEntries();
    return CssFloat_LEFT_instance;
  }
  var CssFontStyle_NORMAL_instance;
  var CssFontStyle_ITALIC_instance;
  var CssFontStyle_entriesInitialized;
  function CssFontStyle_initEntries() {
    if (CssFontStyle_entriesInitialized)
      return Unit_instance;
    CssFontStyle_entriesInitialized = true;
    CssFontStyle_NORMAL_instance = new CssFontStyle('NORMAL', 0, 'normal');
    CssFontStyle_ITALIC_instance = new CssFontStyle('ITALIC', 1, 'italic');
  }
  function CssFontStyle(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.okw_1 = stringQualifier;
  }
  protoOf(CssFontStyle).wkv = function () {
    return this.okw_1;
  };
  function CssFontStyle_NORMAL_getInstance() {
    CssFontStyle_initEntries();
    return CssFontStyle_NORMAL_instance;
  }
  function CssFontStyle_ITALIC_getInstance() {
    CssFontStyle_initEntries();
    return CssFontStyle_ITALIC_instance;
  }
  var CssFontWeight_NORMAL_instance;
  var CssFontWeight_BOLD_instance;
  var CssFontWeight_BOLDER_instance;
  var CssFontWeight_LIGHTER_instance;
  var CssFontWeight_entriesInitialized;
  function CssFontWeight_initEntries() {
    if (CssFontWeight_entriesInitialized)
      return Unit_instance;
    CssFontWeight_entriesInitialized = true;
    CssFontWeight_NORMAL_instance = new CssFontWeight('NORMAL', 0, 'normal');
    CssFontWeight_BOLD_instance = new CssFontWeight('BOLD', 1, 'bold');
    CssFontWeight_BOLDER_instance = new CssFontWeight('BOLDER', 2, 'bolder');
    CssFontWeight_LIGHTER_instance = new CssFontWeight('LIGHTER', 3, 'lighter');
  }
  function CssFontWeight(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.rkw_1 = stringQualifier;
  }
  protoOf(CssFontWeight).wkv = function () {
    return this.rkw_1;
  };
  function CssFontWeight_NORMAL_getInstance() {
    CssFontWeight_initEntries();
    return CssFontWeight_NORMAL_instance;
  }
  function CssFontWeight_BOLD_getInstance() {
    CssFontWeight_initEntries();
    return CssFontWeight_BOLD_instance;
  }
  var CssOutlineStyle_NONE_instance;
  var CssOutlineStyle_DASHED_instance;
  var CssOutlineStyle_DOTTED_instance;
  var CssOutlineStyle_DOUBLE_instance;
  var CssOutlineStyle_GROOVE_instance;
  var CssOutlineStyle_INSET_instance;
  var CssOutlineStyle_OUTSET_instance;
  var CssOutlineStyle_RIDGE_instance;
  var CssOutlineStyle_SOLID_instance;
  var CssOutlineStyle_entriesInitialized;
  function CssOutlineStyle_initEntries() {
    if (CssOutlineStyle_entriesInitialized)
      return Unit_instance;
    CssOutlineStyle_entriesInitialized = true;
    CssOutlineStyle_NONE_instance = new CssOutlineStyle('NONE', 0, 'none');
    CssOutlineStyle_DASHED_instance = new CssOutlineStyle('DASHED', 1, 'dashed');
    CssOutlineStyle_DOTTED_instance = new CssOutlineStyle('DOTTED', 2, 'dotted');
    CssOutlineStyle_DOUBLE_instance = new CssOutlineStyle('DOUBLE', 3, 'double');
    CssOutlineStyle_GROOVE_instance = new CssOutlineStyle('GROOVE', 4, 'groove');
    CssOutlineStyle_INSET_instance = new CssOutlineStyle('INSET', 5, 'inset');
    CssOutlineStyle_OUTSET_instance = new CssOutlineStyle('OUTSET', 6, 'outset');
    CssOutlineStyle_RIDGE_instance = new CssOutlineStyle('RIDGE', 7, 'ridge');
    CssOutlineStyle_SOLID_instance = new CssOutlineStyle('SOLID', 8, 'solid');
  }
  function CssOutlineStyle(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.ukw_1 = stringQualifier;
  }
  protoOf(CssOutlineStyle).wkv = function () {
    return this.ukw_1;
  };
  function CssOutlineStyle_NONE_getInstance() {
    CssOutlineStyle_initEntries();
    return CssOutlineStyle_NONE_instance;
  }
  function CssOutlineStyle_SOLID_getInstance() {
    CssOutlineStyle_initEntries();
    return CssOutlineStyle_SOLID_instance;
  }
  var CssOverflow_VISIBLE_instance;
  var CssOverflow_HIDDEN_instance;
  var CssOverflow_SCROLL_instance;
  var CssOverflow_AUTO_instance;
  var CssOverflow_INITIAL_instance;
  var CssOverflow_INHERIT_instance;
  function Companion_252() {
  }
  protoOf(Companion_252).t2t = function (value) {
    return parse_1(value, values_15());
  };
  var Companion_instance_252;
  function Companion_getInstance_252() {
    return Companion_instance_252;
  }
  function values_15() {
    return [CssOverflow_VISIBLE_getInstance(), CssOverflow_HIDDEN_getInstance(), CssOverflow_SCROLL_getInstance(), CssOverflow_AUTO_getInstance(), CssOverflow_INITIAL_getInstance(), CssOverflow_INHERIT_getInstance()];
  }
  var CssOverflow_entriesInitialized;
  function CssOverflow_initEntries() {
    if (CssOverflow_entriesInitialized)
      return Unit_instance;
    CssOverflow_entriesInitialized = true;
    CssOverflow_VISIBLE_instance = new CssOverflow('VISIBLE', 0, 'visible');
    CssOverflow_HIDDEN_instance = new CssOverflow('HIDDEN', 1, 'hidden');
    CssOverflow_SCROLL_instance = new CssOverflow('SCROLL', 2, 'scroll');
    CssOverflow_AUTO_instance = new CssOverflow('AUTO', 3, 'auto');
    CssOverflow_INITIAL_instance = new CssOverflow('INITIAL', 4, 'initial');
    CssOverflow_INHERIT_instance = new CssOverflow('INHERIT', 5, 'inherit');
  }
  function CssOverflow(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.xkw_1 = stringQualifier;
  }
  protoOf(CssOverflow).wkv = function () {
    return this.xkw_1;
  };
  function CssOverflow_VISIBLE_getInstance() {
    CssOverflow_initEntries();
    return CssOverflow_VISIBLE_instance;
  }
  function CssOverflow_HIDDEN_getInstance() {
    CssOverflow_initEntries();
    return CssOverflow_HIDDEN_instance;
  }
  function CssOverflow_SCROLL_getInstance() {
    CssOverflow_initEntries();
    return CssOverflow_SCROLL_instance;
  }
  function CssOverflow_AUTO_getInstance() {
    CssOverflow_initEntries();
    return CssOverflow_AUTO_instance;
  }
  function CssOverflow_INITIAL_getInstance() {
    CssOverflow_initEntries();
    return CssOverflow_INITIAL_instance;
  }
  function CssOverflow_INHERIT_getInstance() {
    CssOverflow_initEntries();
    return CssOverflow_INHERIT_instance;
  }
  var CssPosition_ABSOLUTE_instance;
  var CssPosition_FIXED_instance;
  var CssPosition_RELATIVE_instance;
  var CssPosition_STATIC_instance;
  var CssPosition_STICKY_instance;
  function Companion_253() {
  }
  var Companion_instance_253;
  function Companion_getInstance_253() {
    return Companion_instance_253;
  }
  var CssPosition_entriesInitialized;
  function CssPosition_initEntries() {
    if (CssPosition_entriesInitialized)
      return Unit_instance;
    CssPosition_entriesInitialized = true;
    CssPosition_ABSOLUTE_instance = new CssPosition('ABSOLUTE', 0, 'absolute');
    CssPosition_FIXED_instance = new CssPosition('FIXED', 1, 'fixed');
    CssPosition_RELATIVE_instance = new CssPosition('RELATIVE', 2, 'relative');
    CssPosition_STATIC_instance = new CssPosition('STATIC', 3, 'static');
    CssPosition_STICKY_instance = new CssPosition('STICKY', 4, 'sticky');
  }
  function CssPosition(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.akx_1 = stringQualifier;
  }
  protoOf(CssPosition).wkv = function () {
    return this.akx_1;
  };
  function CssPosition_ABSOLUTE_getInstance() {
    CssPosition_initEntries();
    return CssPosition_ABSOLUTE_instance;
  }
  function CssPosition_FIXED_getInstance() {
    CssPosition_initEntries();
    return CssPosition_FIXED_instance;
  }
  function CssPosition_RELATIVE_getInstance() {
    CssPosition_initEntries();
    return CssPosition_RELATIVE_instance;
  }
  var CssVerticalAlign_BASELINE_instance;
  var CssVerticalAlign_SUB_instance;
  var CssVerticalAlign_SUPER_instance;
  var CssVerticalAlign_TOP_instance;
  var CssVerticalAlign_TEXT_TOP_instance;
  var CssVerticalAlign_MIDDLE_instance;
  var CssVerticalAlign_BOTTOM_instance;
  var CssVerticalAlign_TEXT_BOTTOM_instance;
  var CssVerticalAlign_entriesInitialized;
  function CssVerticalAlign_initEntries() {
    if (CssVerticalAlign_entriesInitialized)
      return Unit_instance;
    CssVerticalAlign_entriesInitialized = true;
    CssVerticalAlign_BASELINE_instance = new CssVerticalAlign('BASELINE', 0, 'baseline');
    CssVerticalAlign_SUB_instance = new CssVerticalAlign('SUB', 1, 'sub');
    CssVerticalAlign_SUPER_instance = new CssVerticalAlign('SUPER', 2, 'super');
    CssVerticalAlign_TOP_instance = new CssVerticalAlign('TOP', 3, 'top');
    CssVerticalAlign_TEXT_TOP_instance = new CssVerticalAlign('TEXT_TOP', 4, 'text_top');
    CssVerticalAlign_MIDDLE_instance = new CssVerticalAlign('MIDDLE', 5, 'middle');
    CssVerticalAlign_BOTTOM_instance = new CssVerticalAlign('BOTTOM', 6, 'bottom');
    CssVerticalAlign_TEXT_BOTTOM_instance = new CssVerticalAlign('TEXT_BOTTOM', 7, 'text_bottom');
  }
  function CssVerticalAlign(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.dkx_1 = stringQualifier;
  }
  protoOf(CssVerticalAlign).wkv = function () {
    return this.dkx_1;
  };
  function CssVerticalAlign_BOTTOM_getInstance() {
    CssVerticalAlign_initEntries();
    return CssVerticalAlign_BOTTOM_instance;
  }
  var CssVisibility_COLLAPSE_instance;
  var CssVisibility_HIDDEN_instance;
  var CssVisibility_VISIBLE_instance;
  var CssVisibility_entriesInitialized;
  function CssVisibility_initEntries() {
    if (CssVisibility_entriesInitialized)
      return Unit_instance;
    CssVisibility_entriesInitialized = true;
    CssVisibility_COLLAPSE_instance = new CssVisibility('COLLAPSE', 0, 'collapse');
    CssVisibility_HIDDEN_instance = new CssVisibility('HIDDEN', 1, 'hidden');
    CssVisibility_VISIBLE_instance = new CssVisibility('VISIBLE', 2, 'visible');
  }
  function CssVisibility(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.gkx_1 = stringQualifier;
  }
  protoOf(CssVisibility).wkv = function () {
    return this.gkx_1;
  };
  function CssVisibility_HIDDEN_getInstance() {
    CssVisibility_initEntries();
    return CssVisibility_HIDDEN_instance;
  }
  function CssVisibility_VISIBLE_getInstance() {
    CssVisibility_initEntries();
    return CssVisibility_VISIBLE_instance;
  }
  var CssWhiteSpace_NORMAL_instance;
  var CssWhiteSpace_NOWRAP_instance;
  var CssWhiteSpace_PRE_instance;
  var CssWhiteSpace_PRE_LINE_instance;
  var CssWhiteSpace_PRE_WRAP_instance;
  var CssWhiteSpace_entriesInitialized;
  function CssWhiteSpace_initEntries() {
    if (CssWhiteSpace_entriesInitialized)
      return Unit_instance;
    CssWhiteSpace_entriesInitialized = true;
    CssWhiteSpace_NORMAL_instance = new CssWhiteSpace('NORMAL', 0, 'normal');
    CssWhiteSpace_NOWRAP_instance = new CssWhiteSpace('NOWRAP', 1, 'nowrap');
    CssWhiteSpace_PRE_instance = new CssWhiteSpace('PRE', 2, 'pre');
    CssWhiteSpace_PRE_LINE_instance = new CssWhiteSpace('PRE_LINE', 3, 'pre-line');
    CssWhiteSpace_PRE_WRAP_instance = new CssWhiteSpace('PRE_WRAP', 4, 'pre-wrap');
  }
  function CssWhiteSpace(name, ordinal, stringQualifier) {
    Enum.call(this, name, ordinal);
    this.jkx_1 = stringQualifier;
  }
  protoOf(CssWhiteSpace).wkv = function () {
    return this.jkx_1;
  };
  function CssWhiteSpace_NOWRAP_getInstance() {
    CssWhiteSpace_initEntries();
    return CssWhiteSpace_NOWRAP_instance;
  }
  function DomApi() {
  }
  protoOf(DomApi).kkx = function () {
    return ensureNotNull(this.lkx().body);
  };
  protoOf(DomApi).lkx = function () {
    return document;
  };
  protoOf(DomApi).mkx = function () {
    return window;
  };
  protoOf(DomApi).nkx = function () {
    var tmp = this.okx('div');
    return tmp instanceof HTMLDivElement ? tmp : THROW_CCE();
  };
  protoOf(DomApi).pkx = function () {
    return this.okx('span');
  };
  protoOf(DomApi).qkx = function () {
    return cast_0(this.okx('canvas'));
  };
  protoOf(DomApi).okx = function (tag) {
    return this.lkx().createElement(tag);
  };
  protoOf(DomApi).rkx = function () {
    return cast_0(this.okx('textarea'));
  };
  protoOf(DomApi).skx = function () {
    return cast_0(this.okx('img'));
  };
  protoOf(DomApi).tkx = function (data) {
    return this.lkx().createTextNode(data);
  };
  var DomApi_instance;
  function DomApi_getInstance() {
    return DomApi_instance;
  }
  function get_eventTarget(_this__u8e3s4) {
    return _this__u8e3s4.target;
  }
  function addClassName(_this__u8e3s4, className) {
    _this__u8e3s4.classList.add(className);
  }
  function setTabIndex(_this__u8e3s4, index) {
    _this__u8e3s4.setAttribute('tabindex', index.toString());
  }
  function removeClassName(_this__u8e3s4, className) {
    _this__u8e3s4.classList.remove(className);
  }
  function getAbsoluteTop(_this__u8e3s4) {
    return _this__u8e3s4.getBoundingClientRect().top;
  }
  function getAbsoluteLeft(_this__u8e3s4) {
    return _this__u8e3s4.getBoundingClientRect().left;
  }
  function clearTabIndex(_this__u8e3s4) {
    _this__u8e3s4.removeAttribute('tabindex');
  }
  function cast_0(_this__u8e3s4) {
    return !(_this__u8e3s4 == null) ? _this__u8e3s4 : THROW_CCE();
  }
  function on(_this__u8e3s4, event, handler) {
    var eventListener = new on$eventListener$1(handler);
    return onEvent(_this__u8e3s4, event, eventListener, false);
  }
  function onEventWithRunner(_this__u8e3s4, event, runner) {
    var consumer = onEventWithRunner$lambda(runner);
    var handler = onEventWithRunner$lambda_0(consumer);
    return on(_this__u8e3s4, event, handler);
  }
  function onEvent(_this__u8e3s4, type, domEventListener, capture) {
    var eventListener = new onEvent$eventListener$1(domEventListener);
    _this__u8e3s4.addEventListener(type.ukx_1, eventListener, capture);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new onEvent$$inlined$toDisposable$1(_this__u8e3s4, type, eventListener);
  }
  function on$eventListener$1($handler) {
    this.vkx_1 = $handler;
  }
  protoOf(on$eventListener$1).wkx = function (event) {
    var result = this.vkx_1(event);
    if (!result) {
      event.preventDefault();
      event.stopPropagation();
    }
  };
  function onEventWithRunner$lambda($runner) {
    return function (it) {
      $runner();
      return Unit_instance;
    };
  }
  function onEventWithRunner$lambda_0($consumer) {
    return function (it) {
      $consumer(it);
      return true;
    };
  }
  function onEvent$eventListener$1($domEventListener) {
    this.xkx_1 = $domEventListener;
  }
  protoOf(onEvent$eventListener$1).ykx = function (event) {
    var domEvent = event instanceof Event ? event : THROW_CCE();
    this.xkx_1.wkx(domEvent);
  };
  protoOf(onEvent$eventListener$1).handleEvent = function (event) {
    return this.ykx(event);
  };
  function onEvent$$inlined$toDisposable$1($this_onEvent, $type, $eventListener) {
    this.zkx_1 = $this_onEvent;
    this.aky_1 = $type;
    this.bky_1 = $eventListener;
  }
  protoOf(onEvent$$inlined$toDisposable$1).vr = function () {
    this.zkx_1.removeEventListener(this.aky_1.ukx_1, this.bky_1);
    return Unit_instance;
  };
  function Companion_254() {
    Companion_instance_254 = this;
    this.cky_1 = new DomEventType('blur');
    this.dky_1 = new DomEventType('change');
    this.eky_1 = new DomEventType('input');
    this.fky_1 = new DomEventType('paste');
    this.gky_1 = new DomEventType('resize');
    this.hky_1 = new DomEventType('click');
    this.iky_1 = new DomEventType('contextmenu');
    this.jky_1 = new DomEventType('dblclick');
    this.kky_1 = new DomEventType('drag');
    this.lky_1 = new DomEventType('dragend');
    this.mky_1 = new DomEventType('dragenter');
    this.nky_1 = new DomEventType('dragleave');
    this.oky_1 = new DomEventType('dragover');
    this.pky_1 = new DomEventType('dragstart');
    this.qky_1 = new DomEventType('drop');
    this.rky_1 = new DomEventType('focus');
    this.sky_1 = new DomEventType('focusin');
    this.tky_1 = new DomEventType('focusout');
    this.uky_1 = new DomEventType('keydown');
    this.vky_1 = new DomEventType('keypress');
    this.wky_1 = new DomEventType('keyup');
    this.xky_1 = new DomEventType('load');
    this.yky_1 = new DomEventType('mouseenter');
    this.zky_1 = new DomEventType('mouseleave');
    this.akz_1 = new DomEventType('mousedown');
    this.bkz_1 = new DomEventType('mousemove');
    this.ckz_1 = new DomEventType('mouseout');
    this.dkz_1 = new DomEventType('mouseover');
    this.ekz_1 = new DomEventType('mouseup');
    this.fkz_1 = new DomEventType('wheel');
    this.gkz_1 = new DomEventType('scroll');
    this.hkz_1 = new DomEventType('touchcancel');
    this.ikz_1 = new DomEventType('touchend');
    this.jkz_1 = new DomEventType('touchmove');
    this.kkz_1 = new DomEventType('touchstart');
    this.lkz_1 = new DomEventType('compositionstart');
    this.mkz_1 = new DomEventType('compositionend');
    this.nkz_1 = new DomEventType('compositionupdate');
    this.okz_1 = new DomEventType('message');
    this.pkz_1 = new DomEventType('progress');
    this.qkz_1 = new DomEventType('load');
    this.rkz_1 = new DomEventType('loadstart');
    this.skz_1 = new DomEventType('loadend');
    this.tkz_1 = new DomEventType('abort');
    this.ukz_1 = new DomEventType('error');
  }
  var Companion_instance_254;
  function Companion_getInstance_254() {
    if (Companion_instance_254 == null)
      new Companion_254();
    return Companion_instance_254;
  }
  function DomEventType(name) {
    Companion_getInstance_254();
    this.ukx_1 = name;
  }
  protoOf(DomEventType).toString = function () {
    return 'DomEventType(name=' + this.ukx_1 + ')';
  };
  protoOf(DomEventType).hashCode = function () {
    return getStringHashCode(this.ukx_1);
  };
  protoOf(DomEventType).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DomEventType))
      return false;
    var tmp0_other_with_cast = other instanceof DomEventType ? other : THROW_CCE();
    if (!(this.ukx_1 === tmp0_other_with_cast.ukx_1))
      return false;
    return true;
  };
  function get_context2d(_this__u8e3s4) {
    var tmp = _this__u8e3s4.getContext('2d');
    return tmp instanceof CanvasRenderingContext2D ? tmp : THROW_CCE();
  }
  function onMessage($this, event) {
    var tmp;
    if (equals($this.vkz_1, event.data)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !$this.wkz_1.p();
    } else {
      tmp = false;
    }
    if (tmp) {
      var head = $this.wkz_1.q2(0);
      head();
    }
  }
  function DomImmediatePolyfill$setImmediate$lambda(event) {
    onMessage(DomImmediatePolyfill_getInstance(), event);
    return true;
  }
  function DomImmediatePolyfill() {
    DomImmediatePolyfill_instance = this;
    this.vkz_1 = 'set_immediate_' + Default_getInstance().pj();
    this.wkz_1 = ArrayList_init_$Create$();
    this.xkz_1 = null;
  }
  protoOf(DomImmediatePolyfill).ykz = function (runnable) {
    var window_0 = DomApi_instance.mkx();
    if (this.xkz_1 == null) {
      var consumer = DomImmediatePolyfill$setImmediate$lambda;
      this.xkz_1 = on(window_0, Companion_getInstance_254().okz_1, consumer);
    }
    this.wkz_1.e(runnable);
    window_0.postMessage(this.vkz_1, '*');
  };
  var DomImmediatePolyfill_instance;
  function DomImmediatePolyfill_getInstance() {
    if (DomImmediatePolyfill_instance == null)
      new DomImmediatePolyfill();
    return DomImmediatePolyfill_instance;
  }
  function removeFromParent(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.parentElement;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.removeChild(_this__u8e3s4);
  }
  function removeAllChildren(_this__u8e3s4) {
    while (!(_this__u8e3s4.lastChild == null)) {
      _this__u8e3s4.removeChild(ensureNotNull(_this__u8e3s4.lastChild));
    }
  }
  function insertFirst(_this__u8e3s4, child) {
    _this__u8e3s4.insertBefore(child, _this__u8e3s4.firstChild);
  }
  function get_childCount(_this__u8e3s4) {
    return _this__u8e3s4.childNodes.length;
  }
  function getChild(_this__u8e3s4, index) {
    return _this__u8e3s4.childNodes.item(index);
  }
  function insertAfter(_this__u8e3s4, newChild, refChild) {
    var next = refChild == null ? null : refChild.nextSibling;
    if (next == null) {
      _this__u8e3s4.appendChild(newChild);
    } else {
      _this__u8e3s4.insertBefore(newChild, next);
    }
  }
  function createElement($this, contents) {
    var style = document.createElement('style');
    style.setAttribute('language', 'text/css');
    appendText(style, contents);
    return style;
  }
  function getHead($this) {
    if ($this.al0_1 == null) {
      var tmp = $this;
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp.al0_1 = document.getElementsByTagName('head')[0];
    }
    return ensureNotNull($this.al0_1);
  }
  function StyleInjector() {
    StyleInjector_instance = this;
    this.zkz_1 = 'style';
    this.al0_1 = null;
    this.bl0_1 = ArrayList_init_$Create$();
  }
  protoOf(StyleInjector).cl0 = function (css) {
    this.bl0_1.e(css);
    this.dl0();
  };
  protoOf(StyleInjector).el0 = function (contents) {
    var style = createElement(this, contents);
    getHead(this).appendChild(style);
    return style;
  };
  protoOf(StyleInjector).dl0 = function () {
    var result = null;
    if (!(this.bl0_1.n() === 0)) {
      var css = joinToString_0(this.bl0_1, '');
      result = this.el0(css);
      this.bl0_1.m2();
    }
    return result;
  };
  var StyleInjector_instance;
  function StyleInjector_getInstance() {
    if (StyleInjector_instance == null)
      new StyleInjector();
    return StyleInjector_instance;
  }
  function ClipboardContent() {
  }
  function CompositionEvent(composite) {
    Event_0.call(this);
    this.kl0_1 = composite;
  }
  function CopyCutEvent() {
    Event_0.call(this);
    this.tl0_1 = EmptyClipboardContent_instance;
  }
  protoOf(CopyCutEvent).ul0 = function (content) {
    this.ol0();
    this.tl0_1 = content;
  };
  protoOf(CopyCutEvent).ql0 = function () {
    return this.vl0(EmptyClipboardContent_instance);
  };
  protoOf(CopyCutEvent).vl0 = function (content) {
    if (this.ml0_1) {
      // Inline function 'kotlin.check' call
      if (!(this.tl0_1 === content)) {
        // Inline function 'jetbrains.ocelot.base.event.CopyCutEvent.ensureConsumed.<anonymous>' call
        var message = 'Different contents: ' + toString_1(this.tl0_1) + ', ' + toString_1(content);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    } else {
      this.ul0(content);
    }
  };
  function DerivedCopyCutEvent(cause, result) {
    DerivedEvent.call(this, cause);
    this.zl0_1 = result;
  }
  protoOf(DerivedCopyCutEvent).ol0 = function () {
    this.cl1_1.ul0(this.zl0_1);
    this.pl0();
  };
  function DerivedEvent(cause) {
    Event_0.call(this);
    this.cl1_1 = cause;
    // Inline function 'kotlin.check' call
    if (!!this.cl1_1.ml0_1) {
      // Inline function 'jetbrains.ocelot.base.event.DerivedEvent.<anonymous>' call
      var message = "Can't derive from a consumed event: " + toString_1(this.cl1_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(DerivedEvent).ol0 = function () {
    this.cl1_1.ol0();
    this.pl0();
  };
  function EmptyClipboardContent() {
  }
  protoOf(EmptyClipboardContent).fl0 = function (kind) {
    return false;
  };
  protoOf(EmptyClipboardContent).gl0 = function (kind) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyClipboardContent).hl0 = function () {
    return '';
  };
  var EmptyClipboardContent_instance;
  function EmptyClipboardContent_getInstance() {
    return EmptyClipboardContent_instance;
  }
  function Event_0() {
    this.ll0_1 = null;
    this.ml0_1 = false;
  }
  protoOf(Event_0).nl0 = function (eventContext) {
    // Inline function 'kotlin.check' call
    if (!(this.ll0_1 == null)) {
      // Inline function 'jetbrains.ocelot.base.event.Event.<set-eventContext>.<anonymous>' call
      var message = 'Already set ' + toString_1(ensureNotNull(this.ll0_1));
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!!this.ml0_1) {
      // Inline function 'jetbrains.ocelot.base.event.Event.<set-eventContext>.<anonymous>' call
      var message_0 = "Can't set a context to the consumed event";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (eventContext == null) {
        // Inline function 'jetbrains.ocelot.base.event.Event.<set-eventContext>.<anonymous>' call
        var message_1 = "Can't set null context";
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
      } else {
        break $l$block;
      }
    }
    this.ll0_1 = eventContext;
  };
  protoOf(Event_0).ol0 = function () {
    return this.pl0();
  };
  protoOf(Event_0).pl0 = function () {
    // Inline function 'kotlin.check' call
    if (!!this.ml0_1) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.ml0_1 = true;
  };
  protoOf(Event_0).ql0 = function () {
    if (!this.ml0_1) {
      this.ol0();
    }
  };
  var Key_A_instance;
  var Key_B_instance;
  var Key_C_instance;
  var Key_D_instance;
  var Key_E_instance;
  var Key_F_instance;
  var Key_G_instance;
  var Key_H_instance;
  var Key_I_instance;
  var Key_J_instance;
  var Key_K_instance;
  var Key_L_instance;
  var Key_M_instance;
  var Key_N_instance;
  var Key_O_instance;
  var Key_P_instance;
  var Key_Q_instance;
  var Key_R_instance;
  var Key_S_instance;
  var Key_T_instance;
  var Key_U_instance;
  var Key_V_instance;
  var Key_W_instance;
  var Key_X_instance;
  var Key_Y_instance;
  var Key_Z_instance;
  var Key_DIGIT_0_instance;
  var Key_DIGIT_1_instance;
  var Key_DIGIT_2_instance;
  var Key_DIGIT_3_instance;
  var Key_DIGIT_4_instance;
  var Key_DIGIT_5_instance;
  var Key_DIGIT_6_instance;
  var Key_DIGIT_7_instance;
  var Key_DIGIT_8_instance;
  var Key_DIGIT_9_instance;
  var Key_LEFT_BRACE_instance;
  var Key_RIGHT_BRACE_instance;
  var Key_UP_instance;
  var Key_DOWN_instance;
  var Key_LEFT_instance;
  var Key_RIGHT_instance;
  var Key_PAGE_UP_instance;
  var Key_PAGE_DOWN_instance;
  var Key_ESCAPE_instance;
  var Key_ENTER_instance;
  var Key_HOME_instance;
  var Key_END_instance;
  var Key_TAB_instance;
  var Key_SPACE_instance;
  var Key_INSERT_instance;
  var Key_DELETE_instance;
  var Key_BACKSPACE_instance;
  var Key_EQUALS_instance;
  var Key_BACK_QUOTE_instance;
  var Key_PLUS_instance;
  var Key_MINUS_instance;
  var Key_SLASH_instance;
  var Key_CONTROL_instance;
  var Key_META_instance;
  var Key_ALT_instance;
  var Key_SHIFT_instance;
  var Key_UNKNOWN_instance;
  var Key_F1_instance;
  var Key_F2_instance;
  var Key_F3_instance;
  var Key_F4_instance;
  var Key_F5_instance;
  var Key_F6_instance;
  var Key_F7_instance;
  var Key_F8_instance;
  var Key_F9_instance;
  var Key_F10_instance;
  var Key_F11_instance;
  var Key_F12_instance;
  var Key_COMMA_instance;
  var Key_PERIOD_instance;
  var Key_entriesInitialized;
  function Key_initEntries() {
    if (Key_entriesInitialized)
      return Unit_instance;
    Key_entriesInitialized = true;
    Key_A_instance = new Key_7('A', 0, 'A');
    Key_B_instance = new Key_7('B', 1, 'B');
    Key_C_instance = new Key_7('C', 2, 'C');
    Key_D_instance = new Key_7('D', 3, 'D');
    Key_E_instance = new Key_7('E', 4, 'E');
    Key_F_instance = new Key_7('F', 5, 'F');
    Key_G_instance = new Key_7('G', 6, 'G');
    Key_H_instance = new Key_7('H', 7, 'H');
    Key_I_instance = new Key_7('I', 8, 'I');
    Key_J_instance = new Key_7('J', 9, 'J');
    Key_K_instance = new Key_7('K', 10, 'K');
    Key_L_instance = new Key_7('L', 11, 'L');
    Key_M_instance = new Key_7('M', 12, 'M');
    Key_N_instance = new Key_7('N', 13, 'N');
    Key_O_instance = new Key_7('O', 14, 'O');
    Key_P_instance = new Key_7('P', 15, 'P');
    Key_Q_instance = new Key_7('Q', 16, 'Q');
    Key_R_instance = new Key_7('R', 17, 'R');
    Key_S_instance = new Key_7('S', 18, 'S');
    Key_T_instance = new Key_7('T', 19, 'T');
    Key_U_instance = new Key_7('U', 20, 'U');
    Key_V_instance = new Key_7('V', 21, 'V');
    Key_W_instance = new Key_7('W', 22, 'W');
    Key_X_instance = new Key_7('X', 23, 'X');
    Key_Y_instance = new Key_7('Y', 24, 'Y');
    Key_Z_instance = new Key_7('Z', 25, 'Z');
    Key_DIGIT_0_instance = new Key_7('DIGIT_0', 26, '0');
    Key_DIGIT_1_instance = new Key_7('DIGIT_1', 27, '1');
    Key_DIGIT_2_instance = new Key_7('DIGIT_2', 28, '2');
    Key_DIGIT_3_instance = new Key_7('DIGIT_3', 29, '3');
    Key_DIGIT_4_instance = new Key_7('DIGIT_4', 30, '4');
    Key_DIGIT_5_instance = new Key_7('DIGIT_5', 31, '5');
    Key_DIGIT_6_instance = new Key_7('DIGIT_6', 32, '6');
    Key_DIGIT_7_instance = new Key_7('DIGIT_7', 33, '7');
    Key_DIGIT_8_instance = new Key_7('DIGIT_8', 34, '8');
    Key_DIGIT_9_instance = new Key_7('DIGIT_9', 35, '9');
    Key_LEFT_BRACE_instance = new Key_7('LEFT_BRACE', 36, '[');
    Key_RIGHT_BRACE_instance = new Key_7('RIGHT_BRACE', 37, ']');
    Key_UP_instance = new Key_7('UP', 38, 'Up');
    Key_DOWN_instance = new Key_7('DOWN', 39, 'Down');
    Key_LEFT_instance = new Key_7('LEFT', 40, 'Left');
    Key_RIGHT_instance = new Key_7('RIGHT', 41, 'Right');
    Key_PAGE_UP_instance = new Key_7('PAGE_UP', 42, 'Page Up');
    Key_PAGE_DOWN_instance = new Key_7('PAGE_DOWN', 43, 'Page Down');
    Key_ESCAPE_instance = new Key_7('ESCAPE', 44, 'Escape');
    Key_ENTER_instance = new Key_7('ENTER', 45, 'Enter');
    Key_HOME_instance = new Key_7('HOME', 46, 'Home');
    Key_END_instance = new Key_7('END', 47, 'End');
    Key_TAB_instance = new Key_7('TAB', 48, 'Tab');
    Key_SPACE_instance = new Key_7('SPACE', 49, 'Space');
    Key_INSERT_instance = new Key_7('INSERT', 50, 'Insert');
    Key_DELETE_instance = new Key_7('DELETE', 51, 'Delete');
    Key_BACKSPACE_instance = new Key_7('BACKSPACE', 52, 'Backspace');
    Key_EQUALS_instance = new Key_7('EQUALS', 53, 'Equals');
    Key_BACK_QUOTE_instance = new Key_7('BACK_QUOTE', 54, '`');
    Key_PLUS_instance = new Key_7('PLUS', 55, 'Plus');
    Key_MINUS_instance = new Key_7('MINUS', 56, 'Minus');
    Key_SLASH_instance = new Key_7('SLASH', 57, 'Slash');
    Key_CONTROL_instance = new Key_7('CONTROL', 58, 'Ctrl');
    Key_META_instance = new Key_7('META', 59, 'Meta');
    Key_ALT_instance = new Key_7('ALT', 60, 'Alt');
    Key_SHIFT_instance = new Key_7('SHIFT', 61, 'Shift');
    Key_UNKNOWN_instance = new Key_7('UNKNOWN', 62, '?');
    Key_F1_instance = new Key_7('F1', 63, 'F1');
    Key_F2_instance = new Key_7('F2', 64, 'F2');
    Key_F3_instance = new Key_7('F3', 65, 'F3');
    Key_F4_instance = new Key_7('F4', 66, 'F4');
    Key_F5_instance = new Key_7('F5', 67, 'F5');
    Key_F6_instance = new Key_7('F6', 68, 'F6');
    Key_F7_instance = new Key_7('F7', 69, 'F7');
    Key_F8_instance = new Key_7('F8', 70, 'F8');
    Key_F9_instance = new Key_7('F9', 71, 'F9');
    Key_F10_instance = new Key_7('F10', 72, 'F10');
    Key_F11_instance = new Key_7('F11', 73, 'F11');
    Key_F12_instance = new Key_7('F12', 74, 'F12');
    Key_COMMA_instance = new Key_7('COMMA', 75, ',');
    Key_PERIOD_instance = new Key_7('PERIOD', 76, '.');
  }
  function Key_7(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.fl1_1 = value;
  }
  protoOf(Key_7).toString = function () {
    return this.fl1_1;
  };
  function Key_A_getInstance() {
    Key_initEntries();
    return Key_A_instance;
  }
  function Key_B_getInstance() {
    Key_initEntries();
    return Key_B_instance;
  }
  function Key_C_getInstance() {
    Key_initEntries();
    return Key_C_instance;
  }
  function Key_D_getInstance() {
    Key_initEntries();
    return Key_D_instance;
  }
  function Key_E_getInstance() {
    Key_initEntries();
    return Key_E_instance;
  }
  function Key_F_getInstance() {
    Key_initEntries();
    return Key_F_instance;
  }
  function Key_G_getInstance() {
    Key_initEntries();
    return Key_G_instance;
  }
  function Key_H_getInstance() {
    Key_initEntries();
    return Key_H_instance;
  }
  function Key_I_getInstance() {
    Key_initEntries();
    return Key_I_instance;
  }
  function Key_J_getInstance() {
    Key_initEntries();
    return Key_J_instance;
  }
  function Key_K_getInstance() {
    Key_initEntries();
    return Key_K_instance;
  }
  function Key_L_getInstance() {
    Key_initEntries();
    return Key_L_instance;
  }
  function Key_M_getInstance() {
    Key_initEntries();
    return Key_M_instance;
  }
  function Key_N_getInstance() {
    Key_initEntries();
    return Key_N_instance;
  }
  function Key_O_getInstance() {
    Key_initEntries();
    return Key_O_instance;
  }
  function Key_P_getInstance() {
    Key_initEntries();
    return Key_P_instance;
  }
  function Key_Q_getInstance() {
    Key_initEntries();
    return Key_Q_instance;
  }
  function Key_R_getInstance() {
    Key_initEntries();
    return Key_R_instance;
  }
  function Key_S_getInstance() {
    Key_initEntries();
    return Key_S_instance;
  }
  function Key_T_getInstance() {
    Key_initEntries();
    return Key_T_instance;
  }
  function Key_U_getInstance() {
    Key_initEntries();
    return Key_U_instance;
  }
  function Key_V_getInstance() {
    Key_initEntries();
    return Key_V_instance;
  }
  function Key_W_getInstance() {
    Key_initEntries();
    return Key_W_instance;
  }
  function Key_X_getInstance() {
    Key_initEntries();
    return Key_X_instance;
  }
  function Key_Y_getInstance() {
    Key_initEntries();
    return Key_Y_instance;
  }
  function Key_Z_getInstance() {
    Key_initEntries();
    return Key_Z_instance;
  }
  function Key_DIGIT_0_getInstance() {
    Key_initEntries();
    return Key_DIGIT_0_instance;
  }
  function Key_DIGIT_1_getInstance() {
    Key_initEntries();
    return Key_DIGIT_1_instance;
  }
  function Key_DIGIT_2_getInstance() {
    Key_initEntries();
    return Key_DIGIT_2_instance;
  }
  function Key_DIGIT_3_getInstance() {
    Key_initEntries();
    return Key_DIGIT_3_instance;
  }
  function Key_DIGIT_4_getInstance() {
    Key_initEntries();
    return Key_DIGIT_4_instance;
  }
  function Key_DIGIT_5_getInstance() {
    Key_initEntries();
    return Key_DIGIT_5_instance;
  }
  function Key_DIGIT_6_getInstance() {
    Key_initEntries();
    return Key_DIGIT_6_instance;
  }
  function Key_DIGIT_7_getInstance() {
    Key_initEntries();
    return Key_DIGIT_7_instance;
  }
  function Key_DIGIT_8_getInstance() {
    Key_initEntries();
    return Key_DIGIT_8_instance;
  }
  function Key_DIGIT_9_getInstance() {
    Key_initEntries();
    return Key_DIGIT_9_instance;
  }
  function Key_LEFT_BRACE_getInstance() {
    Key_initEntries();
    return Key_LEFT_BRACE_instance;
  }
  function Key_RIGHT_BRACE_getInstance() {
    Key_initEntries();
    return Key_RIGHT_BRACE_instance;
  }
  function Key_UP_getInstance() {
    Key_initEntries();
    return Key_UP_instance;
  }
  function Key_DOWN_getInstance() {
    Key_initEntries();
    return Key_DOWN_instance;
  }
  function Key_LEFT_getInstance() {
    Key_initEntries();
    return Key_LEFT_instance;
  }
  function Key_RIGHT_getInstance() {
    Key_initEntries();
    return Key_RIGHT_instance;
  }
  function Key_PAGE_UP_getInstance() {
    Key_initEntries();
    return Key_PAGE_UP_instance;
  }
  function Key_PAGE_DOWN_getInstance() {
    Key_initEntries();
    return Key_PAGE_DOWN_instance;
  }
  function Key_ESCAPE_getInstance() {
    Key_initEntries();
    return Key_ESCAPE_instance;
  }
  function Key_ENTER_getInstance() {
    Key_initEntries();
    return Key_ENTER_instance;
  }
  function Key_HOME_getInstance() {
    Key_initEntries();
    return Key_HOME_instance;
  }
  function Key_END_getInstance() {
    Key_initEntries();
    return Key_END_instance;
  }
  function Key_TAB_getInstance() {
    Key_initEntries();
    return Key_TAB_instance;
  }
  function Key_SPACE_getInstance() {
    Key_initEntries();
    return Key_SPACE_instance;
  }
  function Key_INSERT_getInstance() {
    Key_initEntries();
    return Key_INSERT_instance;
  }
  function Key_DELETE_getInstance() {
    Key_initEntries();
    return Key_DELETE_instance;
  }
  function Key_BACKSPACE_getInstance() {
    Key_initEntries();
    return Key_BACKSPACE_instance;
  }
  function Key_BACK_QUOTE_getInstance() {
    Key_initEntries();
    return Key_BACK_QUOTE_instance;
  }
  function Key_SLASH_getInstance() {
    Key_initEntries();
    return Key_SLASH_instance;
  }
  function Key_CONTROL_getInstance() {
    Key_initEntries();
    return Key_CONTROL_instance;
  }
  function Key_ALT_getInstance() {
    Key_initEntries();
    return Key_ALT_instance;
  }
  function Key_SHIFT_getInstance() {
    Key_initEntries();
    return Key_SHIFT_instance;
  }
  function Key_UNKNOWN_getInstance() {
    Key_initEntries();
    return Key_UNKNOWN_instance;
  }
  function Key_F1_getInstance() {
    Key_initEntries();
    return Key_F1_instance;
  }
  function Key_F2_getInstance() {
    Key_initEntries();
    return Key_F2_instance;
  }
  function Key_F3_getInstance() {
    Key_initEntries();
    return Key_F3_instance;
  }
  function Key_F4_getInstance() {
    Key_initEntries();
    return Key_F4_instance;
  }
  function Key_F5_getInstance() {
    Key_initEntries();
    return Key_F5_instance;
  }
  function Key_F6_getInstance() {
    Key_initEntries();
    return Key_F6_instance;
  }
  function Key_F7_getInstance() {
    Key_initEntries();
    return Key_F7_instance;
  }
  function Key_F8_getInstance() {
    Key_initEntries();
    return Key_F8_instance;
  }
  function Key_F9_getInstance() {
    Key_initEntries();
    return Key_F9_instance;
  }
  function Key_F10_getInstance() {
    Key_initEntries();
    return Key_F10_instance;
  }
  function Key_F11_getInstance() {
    Key_initEntries();
    return Key_F11_instance;
  }
  function Key_F12_getInstance() {
    Key_initEntries();
    return Key_F12_instance;
  }
  function Key_COMMA_getInstance() {
    Key_initEntries();
    return Key_COMMA_instance;
  }
  function Key_PERIOD_getInstance() {
    Key_initEntries();
    return Key_PERIOD_instance;
  }
  function KeyEvent_init_$Init$(key, ch, $this) {
    ch = ch === VOID ? _Char___init__impl__6a9atx(0) : ch;
    Event_0.call($this);
    KeyEvent.call($this);
    $this.il1_1 = new KeyStroke(key, emptyList());
    $this.jl1_1 = ch;
    return $this;
  }
  function KeyEvent_init_$Create$(key, ch) {
    return KeyEvent_init_$Init$(key, ch, objectCreate(protoOf(KeyEvent)));
  }
  function KeyEvent_init_$Init$_0(key, ch, modifiers, $this) {
    Event_0.call($this);
    KeyEvent.call($this);
    $this.il1_1 = new KeyStroke(key, modifiers);
    $this.jl1_1 = ch;
    return $this;
  }
  function KeyEvent_init_$Create$_0(key, ch, modifiers) {
    return KeyEvent_init_$Init$_0(key, ch, modifiers, objectCreate(protoOf(KeyEvent)));
  }
  protoOf(KeyEvent).x = function () {
    return this.il1_1.kl1_1;
  };
  protoOf(KeyEvent).jbl = function () {
    return this.il1_1.jbl();
  };
  protoOf(KeyEvent).ml1 = function (key, modifiers) {
    return this.il1_1.nl1(key, modifiers.slice());
  };
  protoOf(KeyEvent).ol1 = function (specs) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable = 0;
      var last = specs.length;
      while (inductionVariable < last) {
        var element = specs[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'jetbrains.ocelot.base.event.KeyEvent.matches.<anonymous>' call
        if (element.ql1(this.il1_1)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  protoOf(KeyEvent).rl1 = function (specs) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable = 0;
      var last = specs.length;
      while (inductionVariable < last) {
        var element = specs[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'jetbrains.ocelot.base.event.KeyEvent.matches.<anonymous>' call
        if (element.sl1(this.il1_1)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  protoOf(KeyEvent).tl1 = function (key) {
    return this.il1_1.ul1(key);
  };
  protoOf(KeyEvent).o30 = function () {
    return KeyEvent_init_$Create$_0(this.x(), this.jl1_1, this.jbl());
  };
  protoOf(KeyEvent).toString = function () {
    return toString(this.jl1_1) + ', ' + this.il1_1.toString();
  };
  function KeyEvent() {
  }
  function KeyModifiers_init_$Init$($this) {
    KeyModifiers.call($this, false, false, false, false);
    return $this;
  }
  function KeyModifiers_init_$Create$() {
    return KeyModifiers_init_$Init$(objectCreate(protoOf(KeyModifiers)));
  }
  function Companion_255() {
    Companion_instance_255 = this;
    this.vl1_1 = KeyModifiers_init_$Create$();
  }
  protoOf(Companion_255).wl1 = function () {
    return this.vl1_1;
  };
  var Companion_instance_255;
  function Companion_getInstance_255() {
    if (Companion_instance_255 == null)
      new Companion_255();
    return Companion_instance_255;
  }
  function KeyModifiers(isCtrl, isAlt, isShift, isMeta) {
    Companion_getInstance_255();
    this.xl1_1 = isCtrl;
    this.yl1_1 = isAlt;
    this.zl1_1 = isShift;
    this.al2_1 = isMeta;
  }
  protoOf(KeyModifiers).toString = function () {
    return 'KeyModifiers(isCtrl=' + this.xl1_1 + ', isAlt=' + this.yl1_1 + ', isShift=' + this.zl1_1 + ', isMeta=' + this.al2_1 + ')';
  };
  protoOf(KeyModifiers).hashCode = function () {
    var result = getBooleanHashCode(this.xl1_1);
    result = imul(result, 31) + getBooleanHashCode(this.yl1_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.zl1_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.al2_1) | 0;
    return result;
  };
  protoOf(KeyModifiers).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyModifiers))
      return false;
    var tmp0_other_with_cast = other instanceof KeyModifiers ? other : THROW_CCE();
    if (!(this.xl1_1 === tmp0_other_with_cast.xl1_1))
      return false;
    if (!(this.yl1_1 === tmp0_other_with_cast.yl1_1))
      return false;
    if (!(this.zl1_1 === tmp0_other_with_cast.zl1_1))
      return false;
    if (!(this.al2_1 === tmp0_other_with_cast.al2_1))
      return false;
    return true;
  };
  function KeyStroke_init_$Init$(key, modifiers, $this) {
    KeyStroke.call($this, key, toList(modifiers));
    return $this;
  }
  function KeyStroke_init_$Create$(key, modifiers) {
    return KeyStroke_init_$Init$(key, modifiers, objectCreate(protoOf(KeyStroke)));
  }
  function KeyStroke(key, modifiers) {
    this.kl1_1 = key;
    this.ll1_1 = HashSet_init_$Create$_0(modifiers);
  }
  protoOf(KeyStroke).jbl = function () {
    return this.ll1_1;
  };
  protoOf(KeyStroke).ul1 = function (key) {
    return this.ll1_1.s(key);
  };
  protoOf(KeyStroke).nl1 = function (key, modifiers) {
    return this.sl1(KeyStroke_init_$Create$(key, modifiers.slice()));
  };
  protoOf(KeyStroke).sl1 = function (keyStroke) {
    return this.equals(keyStroke);
  };
  protoOf(KeyStroke).bl2 = function (keys) {
    var modifiers = HashSet_init_$Create$_0(this.ll1_1);
    modifiers.o(toList(keys));
    return new KeyStroke(this.kl1_1, modifiers);
  };
  protoOf(KeyStroke).hashCode = function () {
    return imul(this.kl1_1.hashCode(), 31) + hashCode(this.ll1_1) | 0;
  };
  protoOf(KeyStroke).equals = function (other) {
    if (!(other instanceof KeyStroke))
      return false;
    var otherKeyStroke = other instanceof KeyStroke ? other : THROW_CCE();
    return this.kl1_1.equals(ensureNotNull(otherKeyStroke).kl1_1) && equals(this.ll1_1, otherKeyStroke.ll1_1);
  };
  protoOf(KeyStroke).toString = function () {
    return "'" + this.kl1_1.toString() + "' " + toString_1(this.ll1_1);
  };
  function KeyStrokeSpec_init_$Init$(key, modifiers, $this) {
    KeyStrokeSpec.call($this, listOf(KeyStroke_init_$Create$(key, modifiers.slice())));
    return $this;
  }
  function KeyStrokeSpec_init_$Create$(key, modifiers) {
    return KeyStrokeSpec_init_$Init$(key, modifiers, objectCreate(protoOf(KeyStrokeSpec)));
  }
  function KeyStrokeSpec_init_$Init$_0(keyStrokes, $this) {
    KeyStrokeSpec.call($this, ArrayList_init_$Create$_1(keyStrokes));
    return $this;
  }
  function KeyStrokeSpec_init_$Create$_0(keyStrokes) {
    return KeyStrokeSpec_init_$Init$_0(keyStrokes, objectCreate(protoOf(KeyStrokeSpec)));
  }
  function KeyStrokeSpec_init_$Init$_1(keyStrokes, $this) {
    KeyStrokeSpec.call($this, toList(keyStrokes));
    return $this;
  }
  function KeyStrokeSpec_init_$Create$_1(keyStrokes) {
    return KeyStrokeSpec_init_$Init$_1(keyStrokes, objectCreate(protoOf(KeyStrokeSpec)));
  }
  function KeyStrokeSpec(keyStrokes) {
    this.pl1_1 = keyStrokes;
  }
  protoOf(KeyStrokeSpec).ql1 = function (keyStroke) {
    var tmp0 = this.pl1_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.base.event.KeyStrokeSpec.matches.<anonymous>' call
        if (element.sl1(keyStroke)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
  protoOf(KeyStrokeSpec).cl2 = function (key) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.pl1_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.base.event.KeyStrokeSpec.with.<anonymous>' call
      var tmp$ret$0 = item.bl2([key]);
      destination.e(tmp$ret$0);
    }
    var modified = destination;
    return new KeyStrokeSpec(modified);
  };
  protoOf(KeyStrokeSpec).toString = function () {
    return toString_1(this.pl1_1);
  };
  function ctrlOrMeta($this, key) {
    return $this.ml3([KeyStroke_init_$Create$(key, []).bl2([ModifierKey_CONTROL_getInstance()]), KeyStroke_init_$Create$(key, []).bl2([ModifierKey_META_getInstance()])]);
  }
  function ctrlAltOrMetaAlt($this, key) {
    return $this.ml3([KeyStroke_init_$Create$(key, []).bl2([ModifierKey_CONTROL_getInstance(), ModifierKey_ALT_getInstance()]), KeyStroke_init_$Create$(key, []).bl2([ModifierKey_META_getInstance(), ModifierKey_ALT_getInstance()])]);
  }
  function ctrlOrAlt($this, key) {
    return $this.ml3([KeyStroke_init_$Create$(key, []).bl2([ModifierKey_CONTROL_getInstance()]), KeyStroke_init_$Create$(key, []).bl2([ModifierKey_ALT_getInstance()])]);
  }
  function ctrlOrMetaOrAlt($this, key) {
    return $this.ml3([KeyStroke_init_$Create$(key, []).bl2([ModifierKey_CONTROL_getInstance()]), KeyStroke_init_$Create$(key, []).bl2([ModifierKey_META_getInstance()]), KeyStroke_init_$Create$(key, []).bl2([ModifierKey_ALT_getInstance()])]);
  }
  function KeyStrokeSpecs() {
    KeyStrokeSpecs_instance = this;
    this.dl2_1 = this.nl3([ctrlOrMeta(this, Key_C_getInstance()), KeyStrokeSpec_init_$Create$(Key_INSERT_getInstance(), [ModifierKey_CONTROL_getInstance()])]);
    this.el2_1 = this.nl3([ctrlOrMeta(this, Key_X_getInstance()), KeyStrokeSpec_init_$Create$(Key_DELETE_getInstance(), [ModifierKey_SHIFT_getInstance()])]);
    this.fl2_1 = this.nl3([ctrlOrMeta(this, Key_V_getInstance()), KeyStrokeSpec_init_$Create$(Key_INSERT_getInstance(), [ModifierKey_SHIFT_getInstance()])]);
    this.gl2_1 = ctrlOrMeta(this, Key_Z_getInstance());
    this.hl2_1 = this.gl2_1.cl2(ModifierKey_SHIFT_getInstance());
    this.il2_1 = ctrlOrMetaOrAlt(this, Key_SPACE_getInstance());
    this.jl2_1 = this.nl3([KeyStrokeSpec_init_$Create$(Key_F1_getInstance(), []), ctrlOrMeta(this, Key_J_getInstance())]);
    this.kl2_1 = this.nl3([ctrlOrMeta(this, Key_I_getInstance()), ctrlOrMeta(this, Key_F1_getInstance())]);
    this.ll2_1 = this.ml3([KeyStroke_init_$Create$(Key_HOME_getInstance(), []), KeyStroke_init_$Create$(Key_LEFT_getInstance(), [ModifierKey_META_getInstance()])]);
    this.ml2_1 = this.ml3([KeyStroke_init_$Create$(Key_END_getInstance(), []), KeyStroke_init_$Create$(Key_RIGHT_getInstance(), [ModifierKey_META_getInstance()])]);
    this.nl2_1 = ctrlOrMeta(this, Key_HOME_getInstance());
    this.ol2_1 = ctrlOrMeta(this, Key_END_getInstance());
    this.pl2_1 = ctrlOrAlt(this, Key_LEFT_getInstance());
    this.ql2_1 = ctrlOrAlt(this, Key_RIGHT_getInstance());
    this.rl2_1 = ctrlAltOrMetaAlt(this, Key_RIGHT_getInstance());
    this.sl2_1 = ctrlAltOrMetaAlt(this, Key_LEFT_getInstance());
    this.tl2_1 = ctrlOrMeta(this, Key_A_getInstance());
    this.ul2_1 = this.nl2_1.cl2(ModifierKey_SHIFT_getInstance());
    this.vl2_1 = this.ol2_1.cl2(ModifierKey_SHIFT_getInstance());
    this.wl2_1 = this.ll2_1.cl2(ModifierKey_SHIFT_getInstance());
    this.xl2_1 = this.ml2_1.cl2(ModifierKey_SHIFT_getInstance());
    this.yl2_1 = this.ql2_1.cl2(ModifierKey_SHIFT_getInstance());
    this.zl2_1 = this.pl2_1.cl2(ModifierKey_SHIFT_getInstance());
    this.al3_1 = KeyStrokeSpec_init_$Create$(Key_LEFT_getInstance(), [ModifierKey_SHIFT_getInstance()]);
    this.bl3_1 = KeyStrokeSpec_init_$Create$(Key_RIGHT_getInstance(), [ModifierKey_SHIFT_getInstance()]);
    this.cl3_1 = KeyStrokeSpec_init_$Create$(Key_UP_getInstance(), [ModifierKey_SHIFT_getInstance()]);
    this.dl3_1 = KeyStrokeSpec_init_$Create$(Key_DOWN_getInstance(), [ModifierKey_SHIFT_getInstance()]);
    this.el3_1 = KeyStrokeSpec_init_$Create$(Key_UP_getInstance(), [ModifierKey_ALT_getInstance()]);
    this.fl3_1 = KeyStrokeSpec_init_$Create$(Key_DOWN_getInstance(), [ModifierKey_ALT_getInstance()]);
    this.gl3_1 = ctrlOrMeta(this, Key_D_getInstance());
    this.hl3_1 = this.nl3([KeyStrokeSpec_init_$Create$(Key_BACKSPACE_getInstance(), [ModifierKey_META_getInstance()]), KeyStrokeSpec_init_$Create$(Key_DELETE_getInstance(), [ModifierKey_META_getInstance()])]);
    this.il3_1 = ctrlOrAlt(this, Key_BACKSPACE_getInstance());
    this.jl3_1 = this.nl3([ctrlAltOrMetaAlt(this, Key_LEFT_BRACE_getInstance()), ctrlAltOrMetaAlt(this, Key_RIGHT_BRACE_getInstance())]);
    this.kl3_1 = ctrlOrMeta(this, Key_LEFT_BRACE_getInstance());
    this.ll3_1 = ctrlOrMeta(this, Key_RIGHT_BRACE_getInstance());
  }
  protoOf(KeyStrokeSpecs).nl3 = function (specs) {
    var keyStrokes = HashSet_init_$Create$();
    var inductionVariable = 0;
    var last = specs.length;
    while (inductionVariable < last) {
      var spec = specs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var _iterator__ex2g4s = spec.pl1_1.k();
      while (_iterator__ex2g4s.l()) {
        var ks = _iterator__ex2g4s.m();
        keyStrokes.e(ks);
      }
    }
    return KeyStrokeSpec_init_$Create$_0(keyStrokes);
  };
  protoOf(KeyStrokeSpecs).ml3 = function (specs) {
    return KeyStrokeSpec_init_$Create$_1(specs.slice());
  };
  var KeyStrokeSpecs_instance;
  function KeyStrokeSpecs_getInstance() {
    if (KeyStrokeSpecs_instance == null)
      new KeyStrokeSpecs();
    return KeyStrokeSpecs_instance;
  }
  var ModifierKey_CONTROL_instance;
  var ModifierKey_ALT_instance;
  var ModifierKey_SHIFT_instance;
  var ModifierKey_META_instance;
  var ModifierKey_entriesInitialized;
  function ModifierKey_initEntries() {
    if (ModifierKey_entriesInitialized)
      return Unit_instance;
    ModifierKey_entriesInitialized = true;
    ModifierKey_CONTROL_instance = new ModifierKey('CONTROL', 0);
    ModifierKey_ALT_instance = new ModifierKey('ALT', 1);
    ModifierKey_SHIFT_instance = new ModifierKey('SHIFT', 2);
    ModifierKey_META_instance = new ModifierKey('META', 3);
  }
  function ModifierKey(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ModifierKey_CONTROL_getInstance() {
    ModifierKey_initEntries();
    return ModifierKey_CONTROL_instance;
  }
  function ModifierKey_ALT_getInstance() {
    ModifierKey_initEntries();
    return ModifierKey_ALT_instance;
  }
  function ModifierKey_SHIFT_getInstance() {
    ModifierKey_initEntries();
    return ModifierKey_SHIFT_instance;
  }
  function ModifierKey_META_getInstance() {
    ModifierKey_initEntries();
    return ModifierKey_META_instance;
  }
  var MouseButton_NONE_instance;
  var MouseButton_LEFT_instance;
  var MouseButton_MIDDLE_instance;
  var MouseButton_RIGHT_instance;
  var MouseButton_entriesInitialized;
  function MouseButton_initEntries() {
    if (MouseButton_entriesInitialized)
      return Unit_instance;
    MouseButton_entriesInitialized = true;
    MouseButton_NONE_instance = new MouseButton('NONE', 0);
    MouseButton_LEFT_instance = new MouseButton('LEFT', 1);
    MouseButton_MIDDLE_instance = new MouseButton('MIDDLE', 2);
    MouseButton_RIGHT_instance = new MouseButton('RIGHT', 3);
  }
  function MouseButton(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function MouseButton_NONE_getInstance() {
    MouseButton_initEntries();
    return MouseButton_NONE_instance;
  }
  function MouseButton_LEFT_getInstance() {
    MouseButton_initEntries();
    return MouseButton_LEFT_instance;
  }
  function MouseButton_MIDDLE_getInstance() {
    MouseButton_initEntries();
    return MouseButton_MIDDLE_instance;
  }
  function MouseButton_RIGHT_getInstance() {
    MouseButton_initEntries();
    return MouseButton_RIGHT_instance;
  }
  function MouseEvent_init_$Init$(v, button, modifiers, $this) {
    modifiers = modifiers === VOID ? Companion_getInstance_255().wl1() : modifiers;
    MouseEvent.call($this, v.eku_1, v.fku_1, button, modifiers);
    return $this;
  }
  function MouseEvent_init_$Create$(v, button, modifiers) {
    return MouseEvent_init_$Init$(v, button, modifiers, objectCreate(protoOf(MouseEvent)));
  }
  function Companion_256() {
  }
  protoOf(Companion_256).ol3 = function (v) {
    return MouseEvent_init_$Create$(v, MouseButton_NONE_getInstance());
  };
  var Companion_instance_256;
  function Companion_getInstance_256() {
    return Companion_instance_256;
  }
  function MouseEvent(x, y, button, modifiers) {
    PointEvent.call(this, x, y);
    this.tl3_1 = button;
    this.ul3_1 = modifiers;
  }
  function PasteEvent(content) {
    Event_0.call(this);
    this.cl4_1 = content;
  }
  function PointEvent(x, y) {
    Event_0.call(this);
    this.xl3_1 = x;
    this.yl3_1 = y;
  }
  protoOf(PointEvent).zl3 = function () {
    return new Vector(this.xl3_1, this.yl3_1);
  };
  protoOf(PointEvent).toString = function () {
    return '{x=' + this.xl3_1 + ',y=' + this.yl3_1 + '}';
  };
  function TouchEvent() {
  }
  function SimpleContentKind(name) {
    this.dl4_1 = name;
  }
  protoOf(SimpleContentKind).toString = function () {
    return 'SimpleContentKind(name=' + this.dl4_1 + ')';
  };
  protoOf(SimpleContentKind).hashCode = function () {
    return getStringHashCode(this.dl4_1);
  };
  protoOf(SimpleContentKind).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SimpleContentKind))
      return false;
    var tmp0_other_with_cast = other instanceof SimpleContentKind ? other : THROW_CCE();
    if (!(this.dl4_1 === tmp0_other_with_cast.dl4_1))
      return false;
    return true;
  };
  function ListContentKind(baseKind) {
    this.el4_1 = baseKind;
  }
  protoOf(ListContentKind).toString = function () {
    return 'ListContentKind(baseKind=' + toString_1(this.el4_1) + ')';
  };
  protoOf(ListContentKind).hashCode = function () {
    return hashCode(this.el4_1);
  };
  protoOf(ListContentKind).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ListContentKind))
      return false;
    var tmp0_other_with_cast = other instanceof ListContentKind ? other : THROW_CCE();
    if (!equals(this.el4_1, tmp0_other_with_cast.el4_1))
      return false;
    return true;
  };
  function ReifiedContentKind(contentClass) {
    this.fl4_1 = contentClass;
  }
  protoOf(ReifiedContentKind).toString = function () {
    return 'ReifiedContentKind(contentClass=' + toString_1(this.fl4_1) + ')';
  };
  protoOf(ReifiedContentKind).hashCode = function () {
    return this.fl4_1.hashCode();
  };
  protoOf(ReifiedContentKind).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReifiedContentKind))
      return false;
    var tmp0_other_with_cast = other instanceof ReifiedContentKind ? other : THROW_CCE();
    if (!this.fl4_1.equals(tmp0_other_with_cast.fl4_1))
      return false;
    return true;
  };
  function ContentKinds() {
    ContentKinds_instance = this;
    this.gl4_1 = this.il4('singleLineText');
    this.hl4_1 = this.il4('multilineText');
  }
  protoOf(ContentKinds).il4 = function (name) {
    return new SimpleContentKind(name);
  };
  protoOf(ContentKinds).jl4 = function (kind) {
    return new ListContentKind(kind);
  };
  protoOf(ContentKinds).kl4 = function (klass) {
    return new ReifiedContentKind(klass);
  };
  var ContentKinds_instance;
  function ContentKinds_getInstance() {
    if (ContentKinds_instance == null)
      new ContentKinds();
    return ContentKinds_instance;
  }
  function MultilineTextClipboardContent(lines) {
    this.ll4_1 = lines;
  }
  protoOf(MultilineTextClipboardContent).fl0 = function (kind) {
    return equals(kind, ContentKinds_getInstance().hl4_1);
  };
  protoOf(MultilineTextClipboardContent).gl0 = function (kind) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(kind === ContentKinds_getInstance().hl4_1)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp = this.ll4_1;
    return !(tmp == null) ? tmp : THROW_CCE();
  };
  function SingleLineTextClipboardContent(text) {
    this.ml4_1 = text;
  }
  protoOf(SingleLineTextClipboardContent).fl0 = function (kind) {
    return equals(kind, ContentKinds_getInstance().gl4_1);
  };
  protoOf(SingleLineTextClipboardContent).gl0 = function (kind) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(kind === ContentKinds_getInstance().gl4_1)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp = this.ml4_1;
    return !(tmp == null) ? tmp : THROW_CCE();
  };
  function advancePastStringBody($this) {
    while (lookingAtStringBody($this)) {
      advance($this);
    }
  }
  function advancePastNewline($this) {
    if (!tryAdvancePast($this, _Char___init__impl__6a9atx(13), _Char___init__impl__6a9atx(10))) {
      // Inline function 'kotlin.check' call
      if (!tryAdvancePast($this, _Char___init__impl__6a9atx(10), _Char___init__impl__6a9atx(13))) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
    }
  }
  function tryAdvancePast($this, required, optional) {
    var tmp;
    if (current($this) === required) {
      advance($this);
      if (!lookingAtEOF($this) && current($this) === optional) {
        advance($this);
      }
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function current($this) {
    return charSequenceGet($this.nl4_1, $this.ol4_1);
  }
  function advance($this) {
    $this.ol4_1 = $this.ol4_1 + 1 | 0;
  }
  function lookingAtStringBody($this) {
    return !lookingAtEOF($this) && !(current($this) === _Char___init__impl__6a9atx(13)) && !(current($this) === _Char___init__impl__6a9atx(10));
  }
  function lookingAtEOF($this) {
    return $this.ol4_1 === $this.nl4_1.length;
  }
  function _get_hasLineFeed__kp5f8b(_this__u8e3s4, $this) {
    return contains_8(_this__u8e3s4, _Char___init__impl__6a9atx(10)) || contains_8(_this__u8e3s4, _Char___init__impl__6a9atx(13));
  }
  function LinesIterator_0(multiline) {
    this.nl4_1 = multiline;
    this.ol4_1 = 0;
    this.pl4_1 = lookingAtEOF(this);
  }
  protoOf(LinesIterator_0).l = function () {
    return !lookingAtEOF(this) || this.pl4_1;
  };
  protoOf(LinesIterator_0).m = function () {
    if (!this.l()) {
      throw NoSuchElementException_init_$Create$();
    }
    var nextLine;
    if (this.pl4_1) {
      this.pl4_1 = false;
      nextLine = '';
    } else {
      var lineBeginning = this.ol4_1;
      advancePastStringBody(this);
      var lineRightBound = this.ol4_1;
      if (!lookingAtEOF(this)) {
        advancePastNewline(this);
        if (lookingAtEOF(this)) {
          this.pl4_1 = true;
        }
      }
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      nextLine = this.nl4_1.substring(lineBeginning, lineRightBound);
    }
    return nextLine;
  };
  function TextContentHelper$splitByNewline$1($multiline) {
    this.ql4_1 = $multiline;
  }
  protoOf(TextContentHelper$splitByNewline$1).k = function () {
    return new LinesIterator_0(this.ql4_1);
  };
  function TextContentHelper() {
    TextContentHelper_instance = this;
    this.rl4_1 = _Char___init__impl__6a9atx(13);
    this.sl4_1 = _Char___init__impl__6a9atx(10);
  }
  protoOf(TextContentHelper).tl4 = function (string) {
    var tmp;
    if (_get_hasLineFeed__kp5f8b(string, this)) {
      tmp = new MultilineTextClipboardContent(this.ul4(string));
    } else {
      tmp = new SingleLineTextClipboardContent(string);
    }
    return tmp;
  };
  protoOf(TextContentHelper).vl4 = function (string) {
    // Inline function 'kotlin.check' call
    if (!!_get_hasLineFeed__kp5f8b(string, this)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return new SingleLineTextClipboardContent(string);
  };
  protoOf(TextContentHelper).wl4 = function (strings) {
    return new MultilineTextClipboardContent(strings);
  };
  protoOf(TextContentHelper).ul4 = function (multiline) {
    return new TextContentHelper$splitByNewline$1(multiline);
  };
  protoOf(TextContentHelper).xl4 = function (lines) {
    var multiline = StringBuilder_init_$Create$_1();
    var lineIter = lines.k();
    while (lineIter.l()) {
      multiline.d9(lineIter.m());
      if (lineIter.l()) {
        multiline.e9(_Char___init__impl__6a9atx(10));
      }
    }
    return multiline.toString();
  };
  var TextContentHelper_instance;
  function TextContentHelper_getInstance() {
    if (TextContentHelper_instance == null)
      new TextContentHelper();
    return TextContentHelper_instance;
  }
  function getText(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.fl0(ContentKinds_getInstance().gl4_1)) {
      tmp = _this__u8e3s4.gl0(ContentKinds_getInstance().gl4_1);
    } else if (_this__u8e3s4.fl0(ContentKinds_getInstance().hl4_1)) {
      tmp = TextContentHelper_getInstance().xl4(_this__u8e3s4.gl0(ContentKinds_getInstance().hl4_1));
    } else {
      tmp = _this__u8e3s4.hl0();
    }
    return tmp;
  }
  function execCopyCommand($this) {
    DomApi_instance.lkx().execCommand('copy');
  }
  function createAndFillClipboardTextArea($this, text) {
    var clipboardArea = createClipboardTextArea($this);
    clipboardArea.value = text;
    clipboardArea.select();
    return clipboardArea;
  }
  function createClipboardTextArea($this) {
    var pasteArea = DomApi_instance.rkx();
    var style = pasteArea.style;
    setPosition(style, CssPosition_ABSOLUTE_getInstance());
    setWidth(style, 1);
    setHeight(style, 1);
    setBottom(style, -100.0);
    setLeft(style, -100.0);
    setZIndex(style, -1);
    DomApi_instance.kkx().appendChild(pasteArea);
    pasteArea.focus();
    return pasteArea;
  }
  function scheduleCutAreaRemoval($this, textArea, retries, delay, delayIncreasePerRetry) {
    (new Timer(DomClipboardSupport$scheduleCutAreaRemoval$lambda(textArea, retries, $this, delay, delayIncreasePerRetry))).m2n(delay);
  }
  function Companion_257() {
  }
  var Companion_instance_257;
  function Companion_getInstance_257() {
    return Companion_instance_257;
  }
  function DomClipboardSupport$pasteContent$lambda($pasteArea, this$0, $handler) {
    return function () {
      DomApi_instance.kkx().removeChild($pasteArea);
      this$0.yl4_1.focus();
      var text = $pasteArea.value;
      $handler(text);
      return Unit_instance;
    };
  }
  function DomClipboardSupport$copyContent$lambda($copyArea, this$0) {
    return function () {
      DomApi_instance.kkx().removeChild($copyArea);
      this$0.yl4_1.focus();
      return Unit_instance;
    };
  }
  function DomClipboardSupport$scheduleCutAreaRemoval$lambda($textArea, $retries, this$0, $delay, $delayIncreasePerRetry) {
    return function () {
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = $textArea.innerText;
      if (charSequenceLength(this_0) === 0) {
        tmp_0 = true;
      } else {
        tmp_0 = $retries === 0;
      }
      if (tmp_0) {
        DomApi_instance.kkx().removeChild($textArea);
        this$0.yl4_1.focus();
        tmp = Unit_instance;
      } else {
        scheduleCutAreaRemoval(this$0, $textArea, $retries - 1 | 0, $delay + $delayIncreasePerRetry | 0, $delayIncreasePerRetry);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DomClipboardSupport(target) {
    this.yl4_1 = target;
  }
  protoOf(DomClipboardSupport).zl4 = function (handler) {
    var pasteArea = createClipboardTextArea(Companion_instance_257);
    (new Timer(DomClipboardSupport$pasteContent$lambda(pasteArea, this, handler))).m2n(20);
  };
  protoOf(DomClipboardSupport).al5 = function (text) {
    var copyArea = createAndFillClipboardTextArea(Companion_instance_257, text);
    execCopyCommand(Companion_instance_257);
    (new Timer(DomClipboardSupport$copyContent$lambda(copyArea, this))).m2n(20);
  };
  protoOf(DomClipboardSupport).bl5 = function (text) {
    var cutArea = createAndFillClipboardTextArea(Companion_instance_257, text);
    scheduleCutAreaRemoval(this, cutArea, 3, 20, 30);
  };
  function toKeyEvent($this, e) {
    var key = DomKeyCodeMapper_getInstance().dl5(e.keyCode);
    var modifiers = HashSet_init_$Create$();
    if (e.ctrlKey) {
      modifiers.e(ModifierKey_CONTROL_getInstance());
    }
    if (e.altKey) {
      modifiers.e(ModifierKey_ALT_getInstance());
    }
    if (e.shiftKey) {
      modifiers.e(ModifierKey_SHIFT_getInstance());
    }
    if (e.metaKey) {
      modifiers.e(ModifierKey_META_getInstance());
    }
    return KeyEvent_init_$Create$_0(key, numberToChar(e.charCode), modifiers);
  }
  function DomEventUtil() {
  }
  protoOf(DomEventUtil).el5 = function (e, handler) {
    var event = toKeyEvent(this, e);
    handler(event);
    if (event.x().equals(Key_BACKSPACE_getInstance()))
      return false;
    if (event.x().equals(Key_UP_getInstance()) || event.x().equals(Key_DOWN_getInstance()) || event.x().equals(Key_LEFT_getInstance()) || event.x().equals(Key_RIGHT_getInstance()))
      return false;
    if (event.x().equals(Key_SPACE_getInstance()))
      return false;
    if (event.ol1([KeyStrokeSpecs_getInstance().al3_1]) || event.ol1([KeyStrokeSpecs_getInstance().cl3_1]) || event.ol1([KeyStrokeSpecs_getInstance().bl3_1]) || event.ol1([KeyStrokeSpecs_getInstance().dl3_1])) {
      return false;
    }
    if (event.ol1([KeyStrokeSpecs_getInstance().jl3_1]))
      return false;
    return event.ml1(Key_TAB_getInstance(), []) || event.ml1(Key_TAB_getInstance(), [ModifierKey_SHIFT_getInstance()]) ? false : !event.ml0_1;
  };
  protoOf(DomEventUtil).fl5 = function (e, handler) {
    var event = toKeyEvent(this, e);
    handler(event);
    return !event.ml0_1;
  };
  protoOf(DomEventUtil).gl5 = function (e, handler) {
    var event = toKeyEvent(this, e);
    if (e.charCode < 32 || e.charCode === 127)
      return true;
    var tmp = e.charCode;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(10);
    if (tmp === Char__toInt_impl_vasixd(this_0))
      return true;
    var tmp_0 = e.charCode;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(13);
    if (tmp_0 === Char__toInt_impl_vasixd(this_1))
      return true;
    if (event.tl1(ModifierKey_META_getInstance()) || (event.tl1(ModifierKey_CONTROL_getInstance()) && !event.tl1(ModifierKey_ALT_getInstance())))
      return true;
    handler(event);
    return !event.ml0_1;
  };
  protoOf(DomEventUtil).hl5 = function (event) {
    var tmp0_subject = event.button;
    return tmp0_subject === 0 ? MouseButton_LEFT_getInstance() : tmp0_subject === 1 ? MouseButton_MIDDLE_getInstance() : tmp0_subject === 2 ? MouseButton_RIGHT_getInstance() : MouseButton_NONE_getInstance();
  };
  protoOf(DomEventUtil).il5 = function (e) {
    var ctrlKey = e.ctrlKey;
    var altKey = e.altKey;
    var shiftKey = e.shiftKey;
    var metaKey = e.metaKey;
    return new KeyModifiers(ctrlKey, altKey, shiftKey, metaKey);
  };
  var DomEventUtil_instance;
  function DomEventUtil_getInstance() {
    return DomEventUtil_instance;
  }
  function DomKeyCodeMapper() {
    DomKeyCodeMapper_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.cl5_1 = fillArrayVal(Array(222), null);
    this.cl5_1[18] = Key_ALT_getInstance();
    this.cl5_1[8] = Key_BACKSPACE_getInstance();
    this.cl5_1[17] = Key_CONTROL_getInstance();
    this.cl5_1[46] = Key_DELETE_getInstance();
    this.cl5_1[40] = Key_DOWN_getInstance();
    this.cl5_1[35] = Key_END_getInstance();
    this.cl5_1[13] = Key_ENTER_getInstance();
    this.cl5_1[27] = Key_ESCAPE_getInstance();
    this.cl5_1[36] = Key_HOME_getInstance();
    this.cl5_1[37] = Key_LEFT_getInstance();
    this.cl5_1[34] = Key_PAGE_DOWN_getInstance();
    this.cl5_1[33] = Key_PAGE_UP_getInstance();
    this.cl5_1[39] = Key_RIGHT_getInstance();
    this.cl5_1[16] = Key_SHIFT_getInstance();
    this.cl5_1[9] = Key_TAB_getInstance();
    this.cl5_1[38] = Key_UP_getInstance();
    this.cl5_1[45] = Key_INSERT_getInstance();
    this.cl5_1[32] = Key_SPACE_getInstance();
    set_1(this.cl5_1, _Char___init__impl__6a9atx(65), Key_A_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(66), Key_B_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(67), Key_C_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(68), Key_D_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(69), Key_E_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(70), Key_F_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(71), Key_G_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(72), Key_H_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(73), Key_I_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(74), Key_J_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(75), Key_K_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(76), Key_L_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(77), Key_M_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(78), Key_N_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(79), Key_O_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(80), Key_P_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(81), Key_Q_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(82), Key_R_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(83), Key_S_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(84), Key_T_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(85), Key_U_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(86), Key_V_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(87), Key_W_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(88), Key_X_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(89), Key_Y_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(90), Key_Z_getInstance());
    this.cl5_1[219] = Key_LEFT_BRACE_getInstance();
    this.cl5_1[221] = Key_RIGHT_BRACE_getInstance();
    set_1(this.cl5_1, _Char___init__impl__6a9atx(48), Key_DIGIT_0_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(49), Key_DIGIT_1_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(50), Key_DIGIT_2_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(51), Key_DIGIT_3_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(52), Key_DIGIT_4_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(53), Key_DIGIT_5_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(54), Key_DIGIT_6_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(55), Key_DIGIT_7_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(56), Key_DIGIT_8_getInstance());
    set_1(this.cl5_1, _Char___init__impl__6a9atx(57), Key_DIGIT_9_getInstance());
    this.cl5_1[112] = Key_F1_getInstance();
    this.cl5_1[113] = Key_F2_getInstance();
    this.cl5_1[114] = Key_F3_getInstance();
    this.cl5_1[115] = Key_F4_getInstance();
    this.cl5_1[116] = Key_F5_getInstance();
    this.cl5_1[117] = Key_F6_getInstance();
    this.cl5_1[118] = Key_F7_getInstance();
    this.cl5_1[119] = Key_F8_getInstance();
    this.cl5_1[120] = Key_F9_getInstance();
    this.cl5_1[121] = Key_F10_getInstance();
    this.cl5_1[122] = Key_F11_getInstance();
    this.cl5_1[123] = Key_F12_getInstance();
    this.cl5_1[188] = Key_COMMA_getInstance();
    this.cl5_1[190] = Key_PERIOD_getInstance();
    this.cl5_1[191] = Key_SLASH_getInstance();
    this.cl5_1[192] = Key_BACK_QUOTE_getInstance();
  }
  protoOf(DomKeyCodeMapper).dl5 = function (code) {
    if (code < this.cl5_1.length) {
      var result = this.cl5_1[code];
      if (!(result == null)) {
        return result;
      }
    }
    return Key_UNKNOWN_getInstance();
  };
  var DomKeyCodeMapper_instance;
  function DomKeyCodeMapper_getInstance() {
    if (DomKeyCodeMapper_instance == null)
      new DomKeyCodeMapper();
    return DomKeyCodeMapper_instance;
  }
  function set_1(_this__u8e3s4, c, value) {
    // Inline function 'kotlin.code' call
    _this__u8e3s4[Char__toInt_impl_vasixd(c)] = value;
  }
  function KeyEventUtil() {
  }
  protoOf(KeyEventUtil).jl5 = function (target, event) {
    var tmp;
    if (event.x().equals(Key_SPACE_getInstance()) && !event.ol1([KeyStrokeSpecs_getInstance().il2_1])) {
      target.kl5(event);
      target.ll5(KeyEvent_init_$Create$(Key_SPACE_getInstance(), _Char___init__impl__6a9atx(32)));
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  var KeyEventUtil_instance;
  function KeyEventUtil_getInstance() {
    return KeyEventUtil_instance;
  }
  function canDragging($this, pressed, moved) {
    var tmp0 = abs(pressed.xl3_1 - moved.xl3_1 | 0);
    // Inline function 'kotlin.math.max' call
    var b = abs(pressed.yl3_1 - moved.yl3_1 | 0);
    return Math.max(tmp0, b) > 5;
  }
  function toMouseEvent($this, e) {
    var vec = new Vector(e.clientX, e.clientY);
    return MouseEvent_init_$Create$($this.ol5(vec), DomEventUtil_instance.hl5(e), DomEventUtil_instance.il5(e));
  }
  function Companion_258() {
    this.pl5_1 = 5;
  }
  var Companion_instance_258;
  function Companion_getInstance_258() {
    return Companion_instance_258;
  }
  function MouseTranslator$translate$lambda(this$0) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      var tmp;
      if (this$0.rl5(event)) {
        tmp = true;
      } else {
        this$0.nl5_1.ql5(event);
        tmp = !event.ml0_1;
      }
      return tmp;
    };
  }
  function MouseTranslator$translate$lambda_0(this$0) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      var tmp;
      if (this$0.rl5(event)) {
        tmp = true;
      } else {
        this$0.nl5_1.sl5(event);
        tmp = !event.ml0_1;
      }
      return tmp;
    };
  }
  function MouseTranslator$translate$lambda_1(this$0, $pressed) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      var tmp0 = $pressed;
      var key = event.tl3_1;
      tmp0.r2(key, event);
      var tmp;
      if (this$0.rl5(event)) {
        tmp = true;
      } else {
        this$0.nl5_1.tl5(event);
        this$0.ul5();
        tmp = !event.ml0_1;
      }
      return tmp;
    };
  }
  function MouseTranslator$translate$lambda_2(this$0, $pressed, $pressedOutside) {
    return function (e) {
      var pressedInside = this$0.ml5_1.contains(cast_0(ensureNotNull(get_eventTarget(e))));
      var evt = toMouseEvent(this$0, e);
      var tmp0 = $pressed;
      var key = evt.tl3_1;
      tmp0.r2(key, evt);
      var tmp;
      if (!pressedInside || this$0.rl5(evt)) {
        $pressedOutside.e(evt.tl3_1);
        tmp = Unit_instance;
      }
      return true;
    };
  }
  function MouseTranslator$translate$lambda_3($pressed, $pressedOutside) {
    return function (e) {
      $pressed.s2(DomEventUtil_instance.hl5(e));
      $pressedOutside.k2(DomEventUtil_instance.hl5(e));
      return true;
    };
  }
  function MouseTranslator$translate$lambda_4(this$0, $pressed) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      $pressed.s2(event.tl3_1);
      var tmp;
      if (!this$0.rl5(event)) {
        this$0.nl5_1.vl5(event);
        tmp = Unit_instance;
      }
      return true;
    };
  }
  function MouseTranslator$translate$lambda_5(this$0, $pressed, $pressedOutside) {
    return function (e) {
      var evt = toMouseEvent(this$0, e);
      var pressedEvent = $pressed.y2(evt.tl3_1);
      var tmp;
      if (!(pressedEvent == null) && !$pressedOutside.s(evt.tl3_1) && canDragging(this$0, pressedEvent, evt)) {
        this$0.nl5_1.wl5(evt);
        tmp = Unit_instance;
      }
      return true;
    };
  }
  function MouseTranslator$translate$lambda_6(this$0, $pressed, $pressedOutside) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      var tmp;
      if (this$0.rl5(event)) {
        tmp = true;
      } else {
        var pressedEvent = $pressed.y2(event.tl3_1);
        if (!(pressedEvent == null) && !$pressedOutside.s(event.tl3_1) && canDragging(this$0, pressedEvent, event)) {
          this$0.nl5_1.wl5(event);
        } else {
          this$0.nl5_1.xl5(event);
        }
        tmp = !event.ml0_1;
      }
      return tmp;
    };
  }
  function MouseTranslator$translate$lambda_7(this$0) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      var tmp;
      if (this$0.zl5(event)) {
        tmp = true;
      } else {
        this$0.nl5_1.yl5(event);
        tmp = false;
      }
      return tmp;
    };
  }
  function MouseTranslator$translate$lambda_8(this$0) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      var tmp;
      if (this$0.zl5(event)) {
        tmp = true;
      } else {
        this$0.nl5_1.al6(event);
        tmp = false;
      }
      return tmp;
    };
  }
  function MouseTranslator$translate$lambda_9(this$0) {
    return function (e) {
      var event = toMouseEvent(this$0, e);
      this$0.nl5_1.yl5(event);
      return true;
    };
  }
  function MouseTranslator(source, target) {
    this.ml5_1 = source;
    this.nl5_1 = target;
  }
  protoOf(MouseTranslator).ol5 = function (vec) {
    return vec.jku(new Vector(numberToInt(DomApi_instance.mkx().scrollX), numberToInt(DomApi_instance.mkx().scrollY)));
  };
  protoOf(MouseTranslator).bl6 = function () {
    var disposable = new CompositeDisposable([]);
    var pressed = HashMap_init_$Create$();
    var pressedOutside = HashSet_init_$Create$();
    var tmp = Companion_getInstance_254().hky_1;
    disposable.ur([on(this.ml5_1, tmp, MouseTranslator$translate$lambda(this))]);
    var tmp_0 = Companion_getInstance_254().jky_1;
    disposable.ur([on(this.ml5_1, tmp_0, MouseTranslator$translate$lambda_0(this))]);
    var tmp_1 = Companion_getInstance_254().akz_1;
    disposable.ur([on(this.ml5_1, tmp_1, MouseTranslator$translate$lambda_1(this, pressed))]);
    var document = DomApi_instance.lkx();
    var tmp_2 = Companion_getInstance_254().akz_1;
    disposable.ur([on(document, tmp_2, MouseTranslator$translate$lambda_2(this, pressed, pressedOutside))]);
    var tmp_3 = Companion_getInstance_254().ekz_1;
    disposable.ur([on(document, tmp_3, MouseTranslator$translate$lambda_3(pressed, pressedOutside))]);
    var tmp_4 = Companion_getInstance_254().ekz_1;
    disposable.ur([on(this.ml5_1, tmp_4, MouseTranslator$translate$lambda_4(this, pressed))]);
    var tmp_5 = Companion_getInstance_254().bkz_1;
    disposable.ur([on(document, tmp_5, MouseTranslator$translate$lambda_5(this, pressed, pressedOutside))]);
    var tmp_6 = Companion_getInstance_254().bkz_1;
    disposable.ur([on(this.ml5_1, tmp_6, MouseTranslator$translate$lambda_6(this, pressed, pressedOutside))]);
    var tmp_7 = Companion_getInstance_254().dkz_1;
    disposable.ur([on(this.ml5_1, tmp_7, MouseTranslator$translate$lambda_7(this))]);
    var tmp_8 = Companion_getInstance_254().ckz_1;
    disposable.ur([on(this.ml5_1, tmp_8, MouseTranslator$translate$lambda_8(this))]);
    var tmp_9 = Companion_getInstance_254().fkz_1;
    disposable.ur([on(this.ml5_1, tmp_9, MouseTranslator$translate$lambda_9(this))]);
    return disposable;
  };
  function onKeyDown($this, event) {
    if (!KeyEventUtil_instance.jl5($this.dl6_1, event)) {
      if (event.ol1([KeyStrokeSpecs_getInstance().fl2_1])) {
        $this.el6_1.zl4(SimpleKeyTranslator$onKeyDown$lambda($this, event));
      } else if (event.ol1([KeyStrokeSpecs_getInstance().dl2_1])) {
        var copyEvent = new CopyCutEvent();
        $this.dl6_1.gl6(copyEvent);
        $this.el6_1.al5(getText(copyEvent.tl0_1));
      } else if (event.ol1([KeyStrokeSpecs_getInstance().el2_1])) {
        var cutEvent = new CopyCutEvent();
        $this.dl6_1.fl6(cutEvent);
        $this.el6_1.bl5(getText(cutEvent.tl0_1));
      } else {
        $this.dl6_1.kl5(event);
      }
    }
  }
  function SimpleKeyTranslator$translate$lambda$lambda(this$0) {
    return function (te) {
      onKeyDown(this$0, te);
      return Unit_instance;
    };
  }
  function SimpleKeyTranslator$translate$lambda(this$0) {
    return function (e) {
      var tmp = DomEventUtil_instance;
      return tmp.el5(e, SimpleKeyTranslator$translate$lambda$lambda(this$0));
    };
  }
  function UIEventsTarget$keyReleased$ref($boundThis) {
    var l = function (p0) {
      $boundThis.hl6(p0);
      return Unit_instance;
    };
    l.callableName = 'keyReleased';
    return l;
  }
  function SimpleKeyTranslator$translate$lambda_0(this$0) {
    return function (event) {
      var tmp = DomEventUtil_instance;
      return tmp.fl5(event, UIEventsTarget$keyReleased$ref(this$0.dl6_1));
    };
  }
  function SimpleKeyTranslator$translate$lambda$lambda_0(this$0) {
    return function (te) {
      var tmp;
      if (!(te.jl1_1 === _Char___init__impl__6a9atx(32))) {
        this$0.dl6_1.ll5(te);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SimpleKeyTranslator$translate$lambda_1(this$0) {
    return function (e) {
      var tmp = DomEventUtil_instance;
      return tmp.gl5(e, SimpleKeyTranslator$translate$lambda$lambda_0(this$0));
    };
  }
  function SimpleKeyTranslator$onKeyDown$lambda(this$0, $event) {
    return function (text) {
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(text) === 0) {
        this$0.dl6_1.kl5($event.o30());
        tmp = Unit_instance;
      } else {
        this$0.dl6_1.il6(text);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SimpleKeyTranslator(focusOwner, target) {
    this.cl6_1 = focusOwner;
    this.dl6_1 = target;
    this.el6_1 = new DomClipboardSupport(cast_0(this.cl6_1));
  }
  protoOf(SimpleKeyTranslator).bl6 = function () {
    var disposable = new CompositeDisposable([]);
    var tmp = Companion_getInstance_254().uky_1;
    disposable.ur([on(this.cl6_1, tmp, SimpleKeyTranslator$translate$lambda(this))]);
    var tmp_0 = Companion_getInstance_254().wky_1;
    disposable.ur([on(this.cl6_1, tmp_0, SimpleKeyTranslator$translate$lambda_0(this))]);
    var tmp_1 = Companion_getInstance_254().vky_1;
    disposable.ur([on(this.cl6_1, tmp_1, SimpleKeyTranslator$translate$lambda_1(this))]);
    return disposable;
  };
  function _get_selectionStart__pp91ud($this) {
    return ensureNotNull($this.jl6_1.selectionStart);
  }
  function _get_selectionEnd__cvpe9o($this) {
    return ensureNotNull($this.jl6_1.selectionEnd);
  }
  function _get_composite__sy6tzq($this) {
    var tmp0 = $this.jl6_1.value;
    var tmp1 = $this.nl6_1;
    // Inline function 'kotlin.text.substring' call
    var endIndex = _get_selectionEnd__cvpe9o($this);
    // Inline function 'kotlin.js.asDynamic' call
    return tmp0.substring(tmp1, endIndex);
  }
  function applyIfNotEditor($this, handler) {
    return TextAreaKeyTranslator$applyIfNotEditor$lambda($this, handler);
  }
  function isInputArea($this, target) {
    var e = target instanceof Element ? target : THROW_CCE();
    return 'TEXTAREA' === e.tagName;
  }
  function isEditableContent($this, target) {
    var e = target instanceof Element ? target : THROW_CCE();
    var tmp0_safe_receiver = e.getAttribute('contenteditable');
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toBoolean(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  function onInputChange($this) {
    if ($this.ml6_1) {
      updateComposition($this);
    }
  }
  function onKeyDown_0($this, e) {
    var tmp;
    if ($this.ml6_1) {
      tmp = true;
    } else {
      var tmp_0 = DomEventUtil_instance;
      tmp = tmp_0.el5(e, TextAreaKeyTranslator$doDispatchKeyPress$ref($this));
    }
    return tmp;
  }
  function onKeyUp($this, e) {
    var tmp;
    if ($this.ml6_1) {
      tmp = true;
    } else {
      var tmp_0 = DomEventUtil_instance;
      tmp = tmp_0.fl5(e, UIEventsTarget$keyReleased$ref_0($this.ll6_1));
    }
    return tmp;
  }
  function onKeyPress($this, e) {
    var tmp;
    if ($this.ml6_1) {
      tmp = true;
    } else {
      var tmp_0 = DomEventUtil_instance;
      tmp = tmp_0.gl5(e, TextAreaKeyTranslator$onKeyPress$lambda($this));
    }
    return tmp;
  }
  function startComposition($this) {
    $this.ml6_1 = true;
    $this.nl6_1 = _get_selectionStart__pp91ud($this);
    $this.ll6_1.ol6(new CompositionEvent(_get_composite__sy6tzq($this)));
  }
  function updateComposition($this) {
    $this.ll6_1.pl6(new CompositionEvent(_get_composite__sy6tzq($this)));
  }
  function endComposition($this) {
    try {
      $this.ll6_1.ql6(new CompositionEvent(''));
      var composite = _get_composite__sy6tzq($this);
      if (composite.length === 1) {
        $this.ll6_1.ll5(KeyEvent_init_$Create$(Key_UNKNOWN_getInstance(), charSequenceGet(composite, 0)));
      } else if (composite.length > 1) {
        $this.ll6_1.il6(composite);
      }
    }finally {
      $this.ml6_1 = false;
      $this.nl6_1 = -1;
      clearTextArea($this);
    }
  }
  function doDispatchKeyPress($this, e) {
    if (KeyEventUtil_instance.jl5($this.ll6_1, e)) {
      return Unit_instance;
    }
    if (e.ol1([KeyStrokeSpecs_getInstance().fl2_1])) {
      $this.ll6_1.rl6();
      return Unit_instance;
    }
    if (e.ol1([KeyStrokeSpecs_getInstance().dl2_1])) {
      var copyEvent = new CopyCutEvent();
      $this.ll6_1.gl6(copyEvent);
      return Unit_instance;
    }
    if (e.ol1([KeyStrokeSpecs_getInstance().el2_1])) {
      var cutEvent = new CopyCutEvent();
      $this.ll6_1.fl6(cutEvent);
      return Unit_instance;
    }
    $this.ll6_1.kl5(e);
    clearTextArea($this);
  }
  function clearTextArea($this) {
    $this.jl6_1.value = '';
  }
  function TextAreaKeyTranslator$startComposition$ref($boundThis) {
    var l = function () {
      startComposition($boundThis);
      return Unit_instance;
    };
    l.callableName = 'startComposition';
    return l;
  }
  function TextAreaKeyTranslator$updateComposition$ref($boundThis) {
    var l = function () {
      updateComposition($boundThis);
      return Unit_instance;
    };
    l.callableName = 'updateComposition';
    return l;
  }
  function TextAreaKeyTranslator$endComposition$ref($boundThis) {
    var l = function () {
      endComposition($boundThis);
      return Unit_instance;
    };
    l.callableName = 'endComposition';
    return l;
  }
  function TextAreaKeyTranslator$onInputChange$ref($boundThis) {
    var l = function () {
      onInputChange($boundThis);
      return Unit_instance;
    };
    l.callableName = 'onInputChange';
    return l;
  }
  function TextAreaKeyTranslator$onInputChange$ref_0($boundThis) {
    var l = function () {
      onInputChange($boundThis);
      return Unit_instance;
    };
    l.callableName = 'onInputChange';
    return l;
  }
  function TextAreaKeyTranslator$onKeyDown$ref($boundThis) {
    var l = function (p0) {
      return onKeyDown_0($boundThis, p0);
    };
    l.callableName = 'onKeyDown';
    return l;
  }
  function TextAreaKeyTranslator$onKeyUp$ref($boundThis) {
    var l = function (p0) {
      return onKeyUp($boundThis, p0);
    };
    l.callableName = 'onKeyUp';
    return l;
  }
  function TextAreaKeyTranslator$onKeyPress$ref($boundThis) {
    var l = function (p0) {
      return onKeyPress($boundThis, p0);
    };
    l.callableName = 'onKeyPress';
    return l;
  }
  function TextAreaKeyTranslator$onKeyDown$ref_0($boundThis) {
    var l = function (p0) {
      return onKeyDown_0($boundThis, p0);
    };
    l.callableName = 'onKeyDown';
    return l;
  }
  function TextAreaKeyTranslator$onKeyUp$ref_0($boundThis) {
    var l = function (p0) {
      return onKeyUp($boundThis, p0);
    };
    l.callableName = 'onKeyUp';
    return l;
  }
  function TextAreaKeyTranslator$onKeyPress$ref_0($boundThis) {
    var l = function (p0) {
      return onKeyPress($boundThis, p0);
    };
    l.callableName = 'onKeyPress';
    return l;
  }
  function TextAreaKeyTranslator$applyIfNotEditor$lambda(this$0, $handler) {
    return function (event) {
      var target = get_eventTarget(event);
      var tmp;
      if (equals(target, this$0.jl6_1) || isEditableContent(this$0, ensureNotNull(target)) || isInputArea(this$0, target)) {
        tmp = true;
      } else {
        tmp = $handler(event);
      }
      return tmp;
    };
  }
  function TextAreaKeyTranslator$doDispatchKeyPress$ref($boundThis) {
    var l = function (p0) {
      doDispatchKeyPress($boundThis, p0);
      return Unit_instance;
    };
    l.callableName = 'doDispatchKeyPress';
    return l;
  }
  function UIEventsTarget$keyReleased$ref_0($boundThis) {
    var l = function (p0) {
      $boundThis.hl6(p0);
      return Unit_instance;
    };
    l.callableName = 'keyReleased';
    return l;
  }
  function TextAreaKeyTranslator$onKeyPress$lambda(this$0) {
    return function (te) {
      var tmp;
      if (!(te.jl1_1 === _Char___init__impl__6a9atx(32))) {
        this$0.ll6_1.ll5(te);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function TextAreaKeyTranslator(textArea, rootElement, target) {
    this.jl6_1 = textArea;
    this.kl6_1 = rootElement;
    this.ll6_1 = target;
    this.ml6_1 = false;
    this.nl6_1 = -1;
  }
  protoOf(TextAreaKeyTranslator).bl6 = function () {
    var disposable = new CompositeDisposable([]);
    var tmp = Companion_getInstance_254().lkz_1;
    disposable.ur([onEventWithRunner(this.jl6_1, tmp, TextAreaKeyTranslator$startComposition$ref(this))]);
    var tmp_0 = Companion_getInstance_254().nkz_1;
    disposable.ur([onEventWithRunner(this.jl6_1, tmp_0, TextAreaKeyTranslator$updateComposition$ref(this))]);
    var tmp_1 = Companion_getInstance_254().mkz_1;
    disposable.ur([onEventWithRunner(this.jl6_1, tmp_1, TextAreaKeyTranslator$endComposition$ref(this))]);
    var tmp_2 = Companion_getInstance_254().eky_1;
    disposable.ur([onEventWithRunner(this.jl6_1, tmp_2, TextAreaKeyTranslator$onInputChange$ref(this))]);
    var tmp_3 = Companion_getInstance_254().dky_1;
    disposable.ur([onEventWithRunner(this.jl6_1, tmp_3, TextAreaKeyTranslator$onInputChange$ref_0(this))]);
    var tmp_4 = Companion_getInstance_254().uky_1;
    disposable.ur([on(this.jl6_1, tmp_4, TextAreaKeyTranslator$onKeyDown$ref(this))]);
    var tmp_5 = Companion_getInstance_254().wky_1;
    disposable.ur([on(this.jl6_1, tmp_5, TextAreaKeyTranslator$onKeyUp$ref(this))]);
    var tmp_6 = Companion_getInstance_254().vky_1;
    disposable.ur([on(this.jl6_1, tmp_6, TextAreaKeyTranslator$onKeyPress$ref(this))]);
    var tmp_7 = Companion_getInstance_254().uky_1;
    disposable.ur([on(this.kl6_1, tmp_7, applyIfNotEditor(this, TextAreaKeyTranslator$onKeyDown$ref_0(this)))]);
    var tmp_8 = Companion_getInstance_254().wky_1;
    disposable.ur([on(this.kl6_1, tmp_8, applyIfNotEditor(this, TextAreaKeyTranslator$onKeyUp$ref_0(this)))]);
    var tmp_9 = Companion_getInstance_254().vky_1;
    disposable.ur([on(this.kl6_1, tmp_9, applyIfNotEditor(this, TextAreaKeyTranslator$onKeyPress$ref_0(this)))]);
    return disposable;
  };
  function Companion_259() {
  }
  protoOf(Companion_259).sl6 = function (builder) {
    // Inline function 'kotlin.apply' call
    var this_0 = new ClipboardAdapterBuilder();
    // Inline function 'jetbrains.ocelot.base.clipboard.Companion.build.<anonymous>' call
    builder(this_0);
    return this_0.vl6();
  };
  var Companion_instance_259;
  function Companion_getInstance_259() {
    return Companion_instance_259;
  }
  function ClipboardAdapter() {
  }
  function sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0(function_0) {
    this.xl6_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0).wl6 = function (systemClipboard) {
    return this.xl6_1(systemClipboard);
  };
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0).b4 = function () {
    return this.xl6_1;
  };
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ClipboardAdapter) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function ClipboardAdapterBuilder$restoreByText$lambda(it) {
    return new RestoringExternalClipboard(it);
  }
  function ClipboardAdapterBuilder$build$lambda(this$0) {
    return function (systemClipboard) {
      var tmp1 = this$0.ul6_1;
      // Inline function 'kotlin.collections.toTypedArray' call
      var this_0 = this$0.tl6_1;
      var tmp$ret$0 = copyToArray(this_0);
      // Inline function 'kotlin.collections.fold' call
      var accumulator = externalClipboard(systemClipboard, tmp$ret$0.slice());
      var _iterator__ex2g4s = tmp1.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.base.clipboard.ClipboardAdapterBuilder.build.<anonymous>.<anonymous>' call
        accumulator = element(accumulator);
      }
      return accumulator;
    };
  }
  function ClipboardAdapterBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.tl6_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.ul6_1 = ArrayList_init_$Create$();
  }
  protoOf(ClipboardAdapterBuilder).yl6 = function (serialization) {
    this.tl6_1.e(serialization);
  };
  protoOf(ClipboardAdapterBuilder).zl6 = function () {
    this.ul6_1.e(ClipboardAdapterBuilder$restoreByText$lambda);
  };
  protoOf(ClipboardAdapterBuilder).vl6 = function () {
    var tmp = ClipboardAdapterBuilder$build$lambda(this);
    return new sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0(tmp);
  };
  function CompositeClipboardContentSerialization$deserialize$lambda($data) {
    return function (it) {
      return it.al7($data);
    };
  }
  function CompositeClipboardContentSerialization(list) {
    this.bl7_1 = list;
  }
  protoOf(CompositeClipboardContentSerialization).cl7 = function (content) {
    var tmp0 = this.bl7_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.any' call
      var inductionVariable = 0;
      var last = tmp0.length;
      while (inductionVariable < last) {
        var element = tmp0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'jetbrains.ocelot.base.clipboard.CompositeClipboardContentSerialization.accepts.<anonymous>' call
        if (element.cl7(content)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  protoOf(CompositeClipboardContentSerialization).dl7 = function (content) {
    var tmp0 = this.bl7_1;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.first' call
      var inductionVariable = 0;
      var last = tmp0.length;
      while (inductionVariable < last) {
        var element = tmp0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'jetbrains.ocelot.base.clipboard.CompositeClipboardContentSerialization.serialize.<anonymous>' call
        if (element.cl7(content)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      throw NoSuchElementException_init_$Create$_0('Array contains no element matching the predicate.');
    }
    return tmp$ret$1.dl7(content);
  };
  protoOf(CompositeClipboardContentSerialization).al7 = function (data) {
    var tmp = asSequence(this.bl7_1);
    return firstOrNull_2(filterNotNull_0(map(tmp, CompositeClipboardContentSerialization$deserialize$lambda(data))));
  };
  function defaultSystemClipboardInteraction(systemClipboard) {
    return new RestoringExternalClipboard(new OnlyTextExternalClipboard(systemClipboard));
  }
  function $retrieveCOROUTINE$0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ml7_1 = _this__u8e3s4;
  }
  protoOf($retrieveCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ml7_1.nl7_1.ol7(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var mimeDataSet = tmp_0;
            if (!mimeDataSet.w2('text/plain'))
              return null;
            return TextContentHelper_getInstance().tl4(getValue_0(mimeDataSet, 'text/plain'));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function OnlyTextExternalClipboard(clipboard) {
    this.nl7_1 = clipboard;
  }
  protoOf(OnlyTextExternalClipboard).pl7 = function (content) {
    var textual = getText(content);
    var textData = new MimeTypedData('text/plain', textual);
    this.nl7_1.ql7(mimeDataSet(listOf(textData)));
  };
  protoOf(OnlyTextExternalClipboard).rl7 = function ($completion) {
    var tmp = new $retrieveCOROUTINE$0(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function $retrieveCOROUTINE$1(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.al8_1 = _this__u8e3s4;
  }
  protoOf($retrieveCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.al8_1.bl8_1.rl7(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var content = suspendResult;
            var tmp_0;
            var tmp_1 = content == null ? null : getText(content);
            var tmp1_safe_receiver = this.al8_1.cl8_1;
            if (tmp_1 == (tmp1_safe_receiver == null ? null : getText(tmp1_safe_receiver))) {
              tmp_0 = this.al8_1.cl8_1;
            } else {
              tmp_0 = content;
            }

            return tmp_0;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function RestoringExternalClipboard(delegate) {
    this.bl8_1 = delegate;
    this.cl8_1 = null;
  }
  protoOf(RestoringExternalClipboard).pl7 = function (content) {
    this.bl8_1.pl7(content);
    this.cl8_1 = content;
  };
  protoOf(RestoringExternalClipboard).rl7 = function ($completion) {
    var tmp = new $retrieveCOROUTINE$1(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function externalClipboard(systemClipboard, serializers) {
    return new SerializingExternalClipboard(systemClipboard, new CompositeClipboardContentSerialization(serializers.slice()));
  }
  function $retrieveCOROUTINE$2(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ll8_1 = _this__u8e3s4;
  }
  protoOf($retrieveCOROUTINE$2).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ll8_1.ml8_1.ol7(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var mimeDataSet = tmp_0;
            return this.ll8_1.nl8_1.al7(mimeDataSet);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function SerializingExternalClipboard(clipboard, serialization) {
    this.ml8_1 = clipboard;
    this.nl8_1 = serialization;
  }
  protoOf(SerializingExternalClipboard).pl7 = function (content) {
    if (!this.nl8_1.cl7(content))
      return Unit_instance;
    var contents = this.nl8_1.dl7(content);
    this.ml8_1.ql7(contents);
  };
  protoOf(SerializingExternalClipboard).rl7 = function ($completion) {
    var tmp = new $retrieveCOROUTINE$2(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function TextClipboardSerialization() {
  }
  protoOf(TextClipboardSerialization).cl7 = function (content) {
    var tmp;
    if (content instanceof SingleLineTextClipboardContent) {
      tmp = true;
    } else {
      tmp = content instanceof MultilineTextClipboardContent;
    }
    return tmp;
  };
  protoOf(TextClipboardSerialization).dl7 = function (content) {
    return mimeDataSet(listOf(new MimeTypedData('text/plain', getText(content))));
  };
  protoOf(TextClipboardSerialization).al7 = function (data) {
    var tmp0_elvis_lhs = data.y2('text/plain');
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var plainText = tmp;
    return TextContentHelper_getInstance().tl4(plainText);
  };
  var TextClipboardSerialization_instance;
  function TextClipboardSerialization_getInstance() {
    return TextClipboardSerialization_instance;
  }
  function MimeTypedData(type, data) {
    this.ol8_1 = type;
    this.pl8_1 = data;
  }
  protoOf(MimeTypedData).toString = function () {
    return 'MimeTypedData(type=' + this.ol8_1 + ', data=' + this.pl8_1 + ')';
  };
  protoOf(MimeTypedData).hashCode = function () {
    var result = getStringHashCode(this.ol8_1);
    result = imul(result, 31) + getStringHashCode(this.pl8_1) | 0;
    return result;
  };
  protoOf(MimeTypedData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MimeTypedData))
      return false;
    var tmp0_other_with_cast = other instanceof MimeTypedData ? other : THROW_CCE();
    if (!(this.ol8_1 === tmp0_other_with_cast.ol8_1))
      return false;
    if (!(this.pl8_1 === tmp0_other_with_cast.pl8_1))
      return false;
    return true;
  };
  function mimeDataSet(list) {
    // Inline function 'kotlin.collections.associate' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(list, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = list.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.base.clipboard.mime.mimeDataSet.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.ol8_1, element.pl8_1);
      destination.r2(pair.dh_1, pair.eh_1);
    }
    return destination;
  }
  function TrivialSystemClipboard() {
    this.ql8_1 = null;
  }
  protoOf(TrivialSystemClipboard).ol7 = function ($completion) {
    return this.ql8_1;
  };
  protoOf(TrivialSystemClipboard).ql7 = function (contents) {
    this.ql8_1 = contents;
  };
  function clipboard() {
    var tmp = window.navigator.clipboard;
    return tmp instanceof Clipboard ? tmp : THROW_CCE();
  }
  function readTextFromBlob(blob) {
    return new Promise(readTextFromBlob$lambda(blob));
  }
  function clipboardItem(data) {
    var dataObject = {};
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = data.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.base.clipboard.clipboardItem.<anonymous>' call
      var mime = element.ug();
      var blob = element.vg();
      dataObject[mime] = blob;
    }
    return new ClipboardItem(dataObject, inlinePresentationStyleOption());
  }
  function inlinePresentationStyleOption() {
    var o = {};
    o['presentationStyle'] = 'inline';
    return o;
  }
  function readTextFromBlob$lambda$lambda($resolve, $reader) {
    return function (it) {
      var tmp = $reader.result;
      $resolve((!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE());
      return Unit_instance;
    };
  }
  function readTextFromBlob$lambda($blob) {
    return function (resolve, _unused_var__etf5q3) {
      var reader = new FileReader();
      reader.onload = readTextFromBlob$lambda$lambda(resolve, reader);
      reader.readAsText($blob);
      return Unit_instance;
    };
  }
  function $retrieveCOROUTINE$3(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zl8_1 = _this__u8e3s4;
  }
  protoOf($retrieveCOROUTINE$3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 8;
            this.y9_1 = 1;
            suspendResult = await_0(clipboard().read(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.al9_1 = suspendResult;
            if (this.al9_1.length === 0)
              return null;
            this.bl9_1 = HashMap_init_$Create$();
            this.cl9_1 = arrayIterator(this.al9_1);
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.cl9_1.l()) {
              this.y9_1 = 7;
              continue $sm;
            }

            this.dl9_1 = this.cl9_1.m();
            this.el9_1 = arrayIterator(this.dl9_1.types);
            this.y9_1 = 3;
            continue $sm;
          case 3:
            if (!this.el9_1.l()) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.fl9_1 = this.el9_1.m();
            this.y9_1 = 4;
            suspendResult = await_0(this.dl9_1.getType(this.fl9_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.gl9_1 = suspendResult;
            var tmp_0 = this;
            tmp_0.hl9_1 = this.bl9_1;
            var tmp_1 = this;
            tmp_1.il9_1 = this.fl9_1;
            this.y9_1 = 5;
            suspendResult = await_0(readTextFromBlob(this.gl9_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var tmp3 = suspendResult;
            var this_0 = this.hl9_1;
            var key = this.il9_1;
            this_0.r2(key, tmp3);
            this.y9_1 = 3;
            continue $sm;
          case 6:
            this.y9_1 = 2;
            continue $sm;
          case 7:
            return this.bl9_1;
          case 8:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 8) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function JsSystemClipboard() {
  }
  protoOf(JsSystemClipboard).ol7 = function ($completion) {
    var tmp = new $retrieveCOROUTINE$3(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(JsSystemClipboard).ql7 = function (contents) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(contents.n());
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = contents.w().k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.base.clipboard.JsSystemClipboard.store.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var mimeType = item.x();
      // Inline function 'kotlin.collections.component2' call
      var data = item.y();
      // Inline function 'org.w3c.files.BlobPropertyBag' call
      var o = {};
      o['type'] = mimeType;
      var properties = o;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = [data];
      var blob = new Blob(tmp$ret$6, properties);
      var tmp$ret$7 = to(mimeType, blob);
      destination.e(tmp$ret$7);
    }
    var items = destination;
    var tmp = clipboard();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$12 = [clipboardItem(items)];
    tmp.write(tmp$ret$12);
  };
  var JsSystemClipboard_instance;
  function JsSystemClipboard_getInstance() {
    return JsSystemClipboard_instance;
  }
  function MapperUpdater($outer) {
    this.jl9_1 = $outer;
  }
  protoOf(MapperUpdater).kl9 = function (sourceList) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var targetContent = ArrayList_init_$Create$();
    var mappers = this.jl9_1.ol9();
    var _iterator__ex2g4s = mappers.k();
    while (_iterator__ex2g4s.l()) {
      var mapper = _iterator__ex2g4s.m();
      targetContent.e(mapper.pl9_1);
    }
    var difference = (new DifferenceBuilder(sourceList, targetContent)).k2p();
    var _iterator__ex2g4s_0 = difference.k();
    while (_iterator__ex2g4s_0.l()) {
      var item = _iterator__ex2g4s_0.m();
      var itemIndex = item.yl9_1;
      if (item.ala_1) {
        var mapper_0 = this.jl9_1.fla(item.zl9_1);
        mappers.p2(itemIndex, mapper_0);
        this.gla(itemIndex, mapper_0);
        this.jl9_1.hla(mapper_0);
      } else {
        var mapper_1 = mappers.q2(itemIndex);
        this.cla(itemIndex, mapper_1);
      }
    }
  };
  protoOf(MapperUpdater).gla = function (index, mapper) {
  };
  protoOf(MapperUpdater).cla = function (index, mapper) {
  };
  function BaseCollectionRoleSynchronizer(factory) {
    BaseRoleSynchronizer.call(this, factory);
  }
  protoOf(BaseCollectionRoleSynchronizer).ol9 = function () {
    var tmp = this.nl9_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('modifiableMappers');
    }
  };
  protoOf(BaseCollectionRoleSynchronizer).ila = function () {
    return this.ol9();
  };
  protoOf(BaseCollectionRoleSynchronizer).jla = function (ctx) {
    this.nl9_1 = ctx.kla().lla();
    this.mla();
  };
  protoOf(BaseCollectionRoleSynchronizer).t6m = function () {
    return this.nla();
  };
  protoOf(BaseCollectionRoleSynchronizer).mla = function () {
  };
  protoOf(BaseCollectionRoleSynchronizer).nla = function () {
  };
  function BaseRoleSynchronizer(mapperFactory) {
    this.dla_1 = mapperFactory;
    this.ela_1 = null;
  }
  protoOf(BaseRoleSynchronizer).fla = function (source) {
    return this.dla_1(source);
  };
  protoOf(BaseRoleSynchronizer).hla = function (mapper) {
    var tmp0_safe_receiver = this.ela_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'jetbrains.ocelot.mapper.core.BaseRoleSynchronizer.processMapper.<anonymous>' call
        element.ola(mapper);
      }
    }
  };
  function removeTarget($this, target) {
    $this.qla_1.s2(target);
  }
  function putMapper($this, mapper) {
    if (mapper.rla()) {
      var target = ensureNotNull(mapper.ql9_1);
      var mapperSet = fetchMappers($this, target);
      mapperSet.e(mapper);
    }
  }
  function fetchMappers($this, target) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.qla_1;
    var value = this_0.y2(target);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.mapper.core.ByTargetIndex.fetchMappers.<anonymous>' call
      var answer = HashSet_init_$Create$();
      this_0.r2(target, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
  function Companion_260() {
    Companion_instance_260 = this;
    this.sla_1 = new MappingContextProperty('ByTargetIndex');
  }
  var Companion_instance_260;
  function Companion_getInstance_260() {
    if (Companion_instance_260 == null)
      new Companion_260();
    return Companion_instance_260;
  }
  function ByTargetIndex$1(this$0) {
    this.tla_1 = this$0;
  }
  protoOf(ByTargetIndex$1).ula = function (mapper) {
    return putMapper(this.tla_1, mapper);
  };
  protoOf(ByTargetIndex$1).vla = function (mapper) {
    if (mapper.rla()) {
      var target = ensureNotNull(mapper.ql9_1);
      var mappers = fetchMappers(this.tla_1, target);
      // Inline function 'kotlin.check' call
      if (!mappers.s(mapper)) {
        // Inline function 'jetbrains.ocelot.mapper.core.<no name provided>.onMapperUnregistered.<anonymous>' call
        var message = 'unregistered mapper ' + toString_1(mapper) + ' with target ' + toString_1(target);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      mappers.k2(mapper);
      if (mappers.p()) {
        removeTarget(this.tla_1, target);
      }
    }
  };
  function ByTargetIndex(ctx) {
    Companion_getInstance_260();
    this.qla_1 = HashMap_init_$Create$();
    var _iterator__ex2g4s = ctx.zla().k();
    while (_iterator__ex2g4s.l()) {
      var mapper = _iterator__ex2g4s.m();
      putMapper(this, mapper);
    }
    var tmp = this;
    tmp.pla_1 = ctx.alb(new ByTargetIndex$1(this));
  }
  protoOf(ByTargetIndex).vr = function () {
    return this.pla_1.vr();
  };
  protoOf(ByTargetIndex).blb = function (target) {
    // Inline function 'kotlin.collections.getOrElse' call
    var tmp0_elvis_lhs = this.qla_1.y2(target);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'jetbrains.ocelot.mapper.core.ByTargetIndex.getMappers.<anonymous>' call
      tmp = emptySet();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  function DifferenceItem($outer, index, item, isAdd) {
    this.bla_1 = $outer;
    this.yl9_1 = index;
    this.zl9_1 = item;
    this.ala_1 = isAdd;
  }
  protoOf(DifferenceItem).toString = function () {
    return (this.ala_1 ? 'add' : 'remove') + ' ' + toString_0(this.zl9_1) + '@' + this.yl9_1;
  };
  function DifferenceBuilder(sourceList, targetList) {
    this.wl9_1 = sourceList;
    this.xl9_1 = targetList;
  }
  protoOf(DifferenceBuilder).k2p = function () {
    var result = ArrayList_init_$Create$();
    var sourceContent = this.wl9_1;
    var target = ArrayList_init_$Create$_1(this.xl9_1);
    var inductionVariable = target.n() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var current = target.q(i);
        if (!sourceContent.s(current)) {
          result.e(new DifferenceItem(this, i, current, false));
          target.q2(i);
        }
      }
       while (0 <= inductionVariable);
    var inductionVariable_0 = 0;
    var last = sourceContent.n() - 1 | 0;
    if (inductionVariable_0 <= last)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var current_0 = sourceContent.q(i_0);
        var next = null;
        if ((i_0 + 1 | 0) < sourceContent.n()) {
          next = sourceContent.q(i_0 + 1 | 0);
        }
        if (target.n() <= i_0) {
          result.e(new DifferenceItem(this, i_0, current_0, true));
          target.p2(i_0, current_0);
        } else {
          var currentTarget = target.q(i_0);
          if (!(currentTarget === current_0)) {
            var currentIndex = target.t(current_0);
            if (!(currentIndex === -1)) {
              result.e(new DifferenceItem(this, currentIndex, current_0, false));
              target.k2(current_0);
            }
            if (next === currentTarget) {
              result.e(new DifferenceItem(this, i_0, current_0, true));
              target.p2(i_0, current_0);
            } else {
              result.e(new DifferenceItem(this, i_0, currentTarget, false));
              result.e(new DifferenceItem(this, i_0, current_0, true));
              target.o2(i_0, current_0);
            }
          }
        }
      }
       while (inductionVariable_0 <= last);
    return result;
  };
  function _get_disposable__lofx05_0($this) {
    var tmp = $this.clb_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('disposable');
    }
  }
  function DisposableSynchronizer() {
  }
  protoOf(DisposableSynchronizer).jla = function (ctx) {
    this.clb_1 = this.dlb(ctx);
  };
  protoOf(DisposableSynchronizer).t6m = function () {
    return _get_disposable__lofx05_0(this).vr();
  };
  function syncOneWay(_this__u8e3s4, target) {
    return new syncOneWay$1(target, _this__u8e3s4);
  }
  function syncTwoWay(_this__u8e3s4, target) {
    return new syncTwoWay$1(_this__u8e3s4, target);
  }
  function syncOneWay$o$doAttach$lambda($target) {
    return function (event) {
      $target.t2c(event.p2e_1);
      return Unit_instance;
    };
  }
  function syncOneWay$1($target, $this_syncOneWay) {
    this.flb_1 = $target;
    this.glb_1 = $this_syncOneWay;
    DisposableSynchronizer.call(this);
  }
  protoOf(syncOneWay$1).dlb = function (ctx) {
    this.flb_1.t2c(this.glb_1.qr());
    return this.glb_1.p27(syncOneWay$o$doAttach$lambda(this.flb_1));
  };
  function _get_disposable__lofx05_1($this) {
    var tmp = $this.ilb_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('disposable');
    }
  }
  function syncTwoWay$1($this_syncTwoWay, $target) {
    this.jlb_1 = $this_syncTwoWay;
    this.klb_1 = $target;
    this.hlb_1 = null;
  }
  protoOf(syncTwoWay$1).jla = function (ctx) {
    var property = this.jlb_1;
    this.hlb_1 = property.qr();
    this.ilb_1 = PropertyBinding_instance.e2g(property, this.klb_1);
  };
  protoOf(syncTwoWay$1).t6m = function () {
    _get_disposable__lofx05_1(this).vr();
    var tmp = this.hlb_1;
    var value = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    this.klb_1.t2c(value);
  };
  var State_NOT_ATTACHED_instance;
  var State_ATTACHING_SYNCHRONIZERS_instance;
  var State_ATTACHING_CHILDREN_instance;
  var State_ATTACHED_instance;
  var State_DETACHED_instance;
  var State_entriesInitialized_2;
  function State_initEntries_2() {
    if (State_entriesInitialized_2)
      return Unit_instance;
    State_entriesInitialized_2 = true;
    State_NOT_ATTACHED_instance = new State_3('NOT_ATTACHED', 0);
    State_ATTACHING_SYNCHRONIZERS_instance = new State_3('ATTACHING_SYNCHRONIZERS', 1);
    State_ATTACHING_CHILDREN_instance = new State_3('ATTACHING_CHILDREN', 2);
    State_ATTACHED_instance = new State_3('ATTACHED', 3);
    State_DETACHED_instance = new State_3('DETACHED', 4);
  }
  function instantiateSynchronizers($this) {
    $this.llb(new Mapper$instantiateSynchronizers$1($this));
  }
  function addPart($this, part) {
    var tmp = $this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = $this.tl9_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [part];
    tmp.tl9_1 = tmp$ret$0.concat(tmp$ret$3);
  }
  function removePart($this, part) {
    var index = indexOf($this.tl9_1, part);
    var tmp = $this;
    var tmp_0 = 0;
    var tmp_1 = $this.tl9_1.length - 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = tmp_3 < index ? $this.tl9_1[tmp_3] : $this.tl9_1[tmp_3 + 1 | 0];
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.tl9_1 = tmp_2;
  }
  function addChild_0($this, child) {
    // Inline function 'kotlin.check' call
    if (!($this.sl9_1.equals(State_ATTACHING_SYNCHRONIZERS_getInstance()) || $this.sl9_1.equals(State_ATTACHING_CHILDREN_getInstance()) || $this.sl9_1.equals(State_ATTACHED_getInstance()))) {
      // Inline function 'jetbrains.ocelot.mapper.core.Mapper.addChild.<anonymous>' call
      var message = 'State =  ' + $this.sl9_1.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    child.ul9_1 = $this;
    if (!$this.sl9_1.equals(State_ATTACHING_SYNCHRONIZERS_getInstance())) {
      child.nlb($this.mlb());
    }
  }
  function removeChild($this, child) {
    child.t6m();
    child.ul9_1 = null;
  }
  function checkCanAdd($this, item) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(item.ul9_1 == null)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function checkCanRemove($this, item) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(item.ul9_1 === $this)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function ChildProperty_0($outer) {
    this.qlb_1 = $outer;
    ValueProperty.call(this, null);
  }
  protoOf(ChildProperty_0).rlb = function (newValue) {
    if (this.qr() == null && !(newValue == null)) {
      addPart(this.qlb_1, this);
    }
    if (!(this.qr() == null) && newValue == null) {
      removePart(this.qlb_1, this);
    }
    var oldValue = this.qr();
    if (!(oldValue == null)) {
      checkCanRemove(this.qlb_1, oldValue);
      removeChild(this.qlb_1, oldValue);
    }
    protoOf(ValueProperty).t2c.call(this, newValue);
    if (!(newValue == null)) {
      checkCanAdd(this.qlb_1, newValue);
      addChild_0(this.qlb_1, newValue);
    }
  };
  protoOf(ChildProperty_0).t2c = function (newValue) {
    return this.rlb((newValue == null ? true : newValue instanceof Mapper) ? newValue : THROW_CCE());
  };
  protoOf(ChildProperty_0).k = function () {
    var tmp0_safe_receiver = this.qr();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.mapper.core.ChildProperty.iterator.<anonymous>' call
      tmp = listOf(tmp0_safe_receiver);
    }
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp;
    return (tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs).k();
  };
  function ChildList($outer) {
    this.vlb_1 = $outer;
    ObservableArrayList.call(this);
  }
  protoOf(ChildList).wlb = function (index, item) {
    checkCanAdd(this.vlb_1, item);
    protoOf(ObservableArrayList).e28.call(this, index, item);
  };
  protoOf(ChildList).e28 = function (index, item) {
    return this.wlb(index, item instanceof Mapper ? item : THROW_CCE());
  };
  protoOf(ChildList).xlb = function (index, oldItem, newItem) {
    checkCanRemove(this.vlb_1, oldItem);
    checkCanAdd(this.vlb_1, newItem);
    protoOf(ObservableArrayList).f28.call(this, index, oldItem, newItem);
  };
  protoOf(ChildList).f28 = function (index, oldItem, newItem) {
    var tmp = oldItem instanceof Mapper ? oldItem : THROW_CCE();
    return this.xlb(index, tmp, newItem instanceof Mapper ? newItem : THROW_CCE());
  };
  protoOf(ChildList).ylb = function (index, item) {
    checkCanRemove(this.vlb_1, item);
    protoOf(ObservableArrayList).g28.call(this, index, item);
  };
  protoOf(ChildList).g28 = function (index, item) {
    return this.ylb(index, item instanceof Mapper ? item : THROW_CCE());
  };
  protoOf(ChildList).zlb = function (index, item) {
    if (this.p()) {
      addPart(this.vlb_1, this);
    }
    protoOf(ObservableArrayList).i28.call(this, index, item);
  };
  protoOf(ChildList).i28 = function (index, item) {
    return this.zlb(index, item instanceof Mapper ? item : THROW_CCE());
  };
  protoOf(ChildList).alc = function (index, item, success) {
    protoOf(ObservableArrayList).l28.call(this, index, item, success);
    addChild_0(this.vlb_1, item);
  };
  protoOf(ChildList).l28 = function (index, item, success) {
    return this.alc(index, item instanceof Mapper ? item : THROW_CCE(), success);
  };
  protoOf(ChildList).blc = function (index, oldItem, newItem) {
    removeChild(this.vlb_1, oldItem);
    addChild_0(this.vlb_1, newItem);
    protoOf(ObservableArrayList).n28.call(this, index, oldItem, newItem);
  };
  protoOf(ChildList).n28 = function (index, oldItem, newItem) {
    var tmp = oldItem instanceof Mapper ? oldItem : THROW_CCE();
    return this.blc(index, tmp, newItem instanceof Mapper ? newItem : THROW_CCE());
  };
  protoOf(ChildList).clc = function (index, item) {
    removeChild(this.vlb_1, item);
    protoOf(ObservableArrayList).s28.call(this, index, item);
  };
  protoOf(ChildList).s28 = function (index, item) {
    return this.clc(index, item instanceof Mapper ? item : THROW_CCE());
  };
  protoOf(ChildList).dlc = function (index, item, success) {
    if (this.p()) {
      removePart(this.vlb_1, this);
    }
    protoOf(ObservableArrayList).u28.call(this, index, item, success);
  };
  protoOf(ChildList).u28 = function (index, item, success) {
    return this.dlc(index, item instanceof Mapper ? item : THROW_CCE(), success);
  };
  function ChildSet($outer) {
    this.glc_1 = $outer;
    ObservableHashSet_init_$Init$(this);
  }
  protoOf(ChildSet).hlc = function (item) {
    checkCanAdd(this.glc_1, ensureNotNull(item));
    protoOf(ObservableHashSet).g29.call(this, item);
  };
  protoOf(ChildSet).g29 = function (item) {
    return this.hlc((item == null ? true : item instanceof Mapper) ? item : THROW_CCE());
  };
  protoOf(ChildSet).ilc = function (item) {
    checkCanRemove(this.glc_1, ensureNotNull(item));
    protoOf(ObservableHashSet).j29.call(this, item);
  };
  protoOf(ChildSet).j29 = function (item) {
    return this.ilc((item == null ? true : item instanceof Mapper) ? item : THROW_CCE());
  };
  protoOf(ChildSet).jlc = function (item) {
    if (this.p()) {
      addPart(this.glc_1, this);
    }
    protoOf(ObservableHashSet).h29.call(this, item);
  };
  protoOf(ChildSet).h29 = function (item) {
    return this.jlc((item == null ? true : item instanceof Mapper) ? item : THROW_CCE());
  };
  protoOf(ChildSet).klc = function (item, success) {
    protoOf(ObservableHashSet).i29.call(this, item, success);
    addChild_0(this.glc_1, ensureNotNull(item));
  };
  protoOf(ChildSet).i29 = function (item, success) {
    return this.klc((item == null ? true : item instanceof Mapper) ? item : THROW_CCE(), success);
  };
  protoOf(ChildSet).llc = function (item) {
    removeChild(this.glc_1, ensureNotNull(item));
    protoOf(ObservableHashSet).k29.call(this, item);
  };
  protoOf(ChildSet).k29 = function (item) {
    return this.llc((item == null ? true : item instanceof Mapper) ? item : THROW_CCE());
  };
  protoOf(ChildSet).mlc = function (item, success) {
    if (this.p()) {
      removePart(this.glc_1, this);
    }
    protoOf(ObservableHashSet).l29.call(this, item, success);
  };
  protoOf(ChildSet).l29 = function (item, success) {
    return this.mlc((item == null ? true : item instanceof Mapper) ? item : THROW_CCE(), success);
  };
  function ChildContainer() {
  }
  function State_3(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_261() {
    Companion_instance_261 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.nlc_1 = [];
  }
  var Companion_instance_261;
  function Companion_getInstance_261() {
    if (Companion_instance_261 == null)
      new Companion_261();
    return Companion_instance_261;
  }
  function Mapper$instantiateSynchronizers$1(this$0) {
    this.olc_1 = this$0;
  }
  protoOf(Mapper$instantiateSynchronizers$1).x4v = function (sync) {
    return addPart(this.olc_1, sync);
  };
  function Mapper$attach$synchronizerContext$1(this$0) {
    this.plc_1 = this$0;
  }
  protoOf(Mapper$attach$synchronizerContext$1).mlb = function () {
    return this.plc_1.mlb();
  };
  protoOf(Mapper$attach$synchronizerContext$1).kla = function () {
    return this.plc_1;
  };
  function Mapper$synchronizers$lambda(it) {
    return !(it == null) ? isInterface(it, Synchronizer) : false;
  }
  function Mapper$children$lambda(it) {
    return !(it == null) ? isInterface(it, ChildContainer) : false;
  }
  function State_NOT_ATTACHED_getInstance() {
    State_initEntries_2();
    return State_NOT_ATTACHED_instance;
  }
  function State_ATTACHING_SYNCHRONIZERS_getInstance() {
    State_initEntries_2();
    return State_ATTACHING_SYNCHRONIZERS_instance;
  }
  function State_ATTACHING_CHILDREN_getInstance() {
    State_initEntries_2();
    return State_ATTACHING_CHILDREN_instance;
  }
  function State_ATTACHED_getInstance() {
    State_initEntries_2();
    return State_ATTACHED_instance;
  }
  function State_DETACHED_getInstance() {
    State_initEntries_2();
    return State_DETACHED_instance;
  }
  function Mapper(source, target) {
    Companion_getInstance_261();
    this.pl9_1 = source;
    this.ql9_1 = target;
    this.sl9_1 = State_NOT_ATTACHED_getInstance();
    this.tl9_1 = Companion_getInstance_261().nlc_1;
    this.ul9_1 = null;
    this.vl9_1 = true;
  }
  protoOf(Mapper).mlb = function () {
    var tmp = this.rl9_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('mappingContext');
    }
  };
  protoOf(Mapper).yt = function () {
    return this.ul9_1;
  };
  protoOf(Mapper).rla = function () {
    return this.vl9_1;
  };
  protoOf(Mapper).qlc = function () {
    return this.sl9_1.equals(State_ATTACHED_getInstance());
  };
  protoOf(Mapper).llb = function (conf) {
  };
  protoOf(Mapper).rlc = function (source) {
    return this.mlb().slc(this, source);
  };
  protoOf(Mapper).tlc = function (ctx) {
    // Inline function 'kotlin.check' call
    if (!(this.ul9_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.nlb(ctx);
  };
  protoOf(Mapper).ulc = function (ctx, $super) {
    ctx = ctx === VOID ? new MappingContext() : ctx;
    var tmp;
    if ($super === VOID) {
      this.tlc(ctx);
      tmp = Unit_instance;
    } else {
      tmp = $super.tlc.call(this, ctx);
    }
    return tmp;
  };
  protoOf(Mapper).vlc = function () {
    // Inline function 'kotlin.check' call
    if (!(this.ul9_1 == null)) {
      // Inline function 'jetbrains.ocelot.mapper.core.Mapper.detachRoot.<anonymous>' call
      var message = 'Dispose can be called only on the root mapper';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.t6m();
  };
  protoOf(Mapper).nlb = function (ctx) {
    // Inline function 'kotlin.check' call
    if (!!this.sl9_1.equals(State_ATTACHED_getInstance())) {
      // Inline function 'jetbrains.ocelot.mapper.core.Mapper.attach.<anonymous>' call
      var message = 'Mapper is already attached';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!this.sl9_1.equals(State_NOT_ATTACHED_getInstance())) {
      // Inline function 'jetbrains.ocelot.mapper.core.Mapper.attach.<anonymous>' call
      var message_0 = "Mapper can't be reused because it was already detached";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    try {
      this.wlc(ctx);
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().ps_1.os(t);
      } else {
        throw $p;
      }
    }
    this.sl9_1 = State_ATTACHING_SYNCHRONIZERS_getInstance();
    this.rl9_1 = ctx;
    instantiateSynchronizers(this);
    this.mlb().xlc(this);
    var synchronizerContext = new Mapper$attach$synchronizerContext$1(this);
    // Inline function 'kotlin.sequences.forEach' call
    var _iterator__ex2g4s = this.ylc().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.mapper.core.Mapper.attach.<anonymous>' call
      element.jla(synchronizerContext);
    }
    this.sl9_1 = State_ATTACHING_CHILDREN_getInstance();
    // Inline function 'kotlin.sequences.forEach' call
    var _iterator__ex2g4s_0 = this.g2r().k();
    while (_iterator__ex2g4s_0.l()) {
      var element_0 = _iterator__ex2g4s_0.m();
      // Inline function 'jetbrains.ocelot.mapper.core.Mapper.attach.<anonymous>' call
      element_0.nlb(ctx);
    }
    this.sl9_1 = State_ATTACHED_getInstance();
    try {
      this.zlc(ctx);
    } catch ($p) {
      if ($p instanceof Error) {
        var t_0 = $p;
        ThrowableHandlers_getInstance().ps_1.os(t_0);
      } else {
        throw $p;
      }
    }
  };
  protoOf(Mapper).t6m = function () {
    try {
      this.nla();
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().ps_1.os(t);
      } else {
        throw $p;
      }
    }
    var indexedObject = this.tl9_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var part = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (isInterface(part, Disposable)) {
        try {
          part.vr();
        } catch ($p) {
          if ($p instanceof Error) {
            var t_0 = $p;
            ThrowableHandlers_getInstance().ps_1.os(t_0);
          } else {
            throw $p;
          }
        }
      }
      if (isInterface(part, ChildContainer)) {
        var _iterator__ex2g4s = part.k();
        while (_iterator__ex2g4s.l()) {
          var mapper = _iterator__ex2g4s.m();
          mapper.t6m();
        }
      }
    }
    this.mlb().ald(this);
    this.sl9_1 = State_DETACHED_getInstance();
    this.tl9_1 = Companion_getInstance_261().nlc_1;
  };
  protoOf(Mapper).wlc = function (ctx) {
  };
  protoOf(Mapper).zlc = function (ctx) {
  };
  protoOf(Mapper).nla = function () {
  };
  protoOf(Mapper).ylc = function () {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = asSequence(this.tl9_1);
    var tmp = filter(this_0, Mapper$synchronizers$lambda);
    return isInterface(tmp, Sequence) ? tmp : THROW_CCE();
  };
  protoOf(Mapper).g2r = function () {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = asSequence(this.tl9_1);
    var tmp = filter(this_0, Mapper$children$lambda);
    var tmp$ret$0 = isInterface(tmp, Sequence) ? tmp : THROW_CCE();
    return flatten_0(tmp$ret$0);
  };
  protoOf(Mapper).lla = function () {
    return new ChildList(this);
  };
  protoOf(Mapper).bld = function () {
    return new ChildSet(this);
  };
  protoOf(Mapper).cld = function () {
    return new ChildProperty_0(this);
  };
  function Mappers$attachRoot$$inlined$toDisposable$1($mapper) {
    this.dld_1 = $mapper;
  }
  protoOf(Mappers$attachRoot$$inlined$toDisposable$1).vr = function () {
    // Inline function 'jetbrains.ocelot.mapper.core.Mappers.attachRoot.stub_for_inlining' call
    this.dld_1.vlc();
    return Unit_instance;
  };
  function Mappers$augment$1($mainMapper, $mappers) {
    this.lld_1 = $mainMapper;
    this.mld_1 = $mappers;
    Mapper.call(this, $mainMapper.pl9_1, $mainMapper.ql9_1);
  }
  protoOf(Mappers$augment$1).zlc = function (ctx) {
    protoOf(Mapper).zlc.call(this, ctx);
    // Inline function 'kotlin.apply' call
    var this_0 = this.lla();
    // Inline function 'jetbrains.ocelot.mapper.core.<no name provided>.onAttach.<anonymous>' call
    this_0.e(this.lld_1);
    addAll_0(this_0, this.mld_1);
  };
  function Mappers() {
  }
  protoOf(Mappers).nld = function (mapper) {
    mapper.ulc();
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new Mappers$attachRoot$$inlined$toDisposable$1(mapper);
  };
  protoOf(Mappers).old = function (mainMapper, mappers) {
    return new Mappers$augment$1(mainMapper, mappers);
  };
  var Mappers_instance;
  function Mappers_getInstance() {
    return Mappers_instance;
  }
  function getMappers(_this__u8e3s4, $this, source) {
    var value = _this__u8e3s4.y2(source);
    var tmp;
    if (!(value == null) ? isInterface(value, KtSet) : false) {
      tmp = isInterface(value, KtMutableSet) ? value : THROW_CCE();
    } else {
      if (value instanceof Mapper) {
        tmp = mutableSetOf([value instanceof Mapper ? value : THROW_CCE()]);
      } else {
        throw IllegalArgumentException_init_$Create$_0('Source ' + toString_0(source) + ' was not found in the list of registered sources');
      }
    }
    return tmp;
  }
  function MappingContext$register$lambda($mapper) {
    return function (listener) {
      listener.ula($mapper);
      return Unit_instance;
    };
  }
  function MappingContext$unregister$lambda($mapper) {
    return function (listener) {
      listener.vla($mapper);
      return Unit_instance;
    };
  }
  function MappingContext() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.wla_1 = LinkedHashMap_init_$Create$();
    this.xla_1 = new Listeners();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.yla_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(MappingContext).alb = function (listener) {
    return this.xla_1.z27(listener);
  };
  protoOf(MappingContext).xlc = function (mapper) {
    if (mapper.rla()) {
      var source = mapper.pl9_1;
      var tmp2 = this.wla_1;
      var tmp;
      if (this.wla_1.w2(source)) {
        // Inline function 'kotlin.apply' call
        var this_0 = getMappers(this.wla_1, this, source);
        // Inline function 'jetbrains.ocelot.mapper.core.MappingContext.register.<anonymous>' call
        this_0.e(mapper);
        tmp = this_0;
      } else {
        tmp = mapper;
      }
      // Inline function 'kotlin.collections.set' call
      var value = tmp;
      tmp2.r2(source, value);
    }
    this.xla_1.a28(MappingContext$register$lambda(mapper));
  };
  protoOf(MappingContext).ald = function (mapper) {
    if (mapper.rla()) {
      var source = mapper.pl9_1;
      // Inline function 'kotlin.check' call
      if (!this.wla_1.w2(source)) {
        // Inline function 'jetbrains.ocelot.mapper.core.MappingContext.unregister.<anonymous>' call
        var message = 'Source ' + toString_0(source) + ' of the mapper ' + toString_1(mapper) + ' was not found in the set of registered sources';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      var allMappers = getMappers(this.wla_1, this, source);
      var wasRemoved = allMappers.k2(mapper);
      // Inline function 'kotlin.check' call
      if (!wasRemoved) {
        // Inline function 'jetbrains.ocelot.mapper.core.MappingContext.unregister.<anonymous>' call
        var message_0 = 'Trying to unregister not registered mapper: ' + toString_1(mapper);
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      }
      switch (allMappers.n()) {
        case 0:
          this.wla_1.s2(source);
          break;
        case 1:
          var tmp2 = this.wla_1;
          // Inline function 'kotlin.collections.set' call

          var value = first_0(allMappers);
          tmp2.r2(source, value);
          break;
        default:
          // Inline function 'kotlin.collections.set' call

          this.wla_1.r2(source, allMappers);
          break;
      }
    }
    this.xla_1.a28(MappingContext$unregister$lambda(mapper));
  };
  protoOf(MappingContext).slc = function (ancestor, source) {
    var result = this.pld(ancestor, source);
    // Inline function 'kotlin.check' call
    if (!(result.n() <= 1)) {
      // Inline function 'jetbrains.ocelot.mapper.core.MappingContext.getMapper.<anonymous>' call
      var message = 'There are more than one mapper for ' + toString_0(source);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return singleOrNull(result);
  };
  protoOf(MappingContext).pld = function (ancestor, source) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.qld(source);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.mapper.core.MappingContext.getMappers.<anonymous>' call
      if (isDescendant(ancestor, element)) {
        destination.e(element);
      }
    }
    return toSet_0(destination);
  };
  protoOf(MappingContext).rld = function (property, value) {
    // Inline function 'kotlin.check' call
    if (!!this.yla_1.w2(property)) {
      // Inline function 'jetbrains.ocelot.mapper.core.MappingContext.set.<anonymous>' call
      var message = 'Property ' + property.toString() + ' is already defined';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.require' call
    if (!!(value == null)) {
      // Inline function 'jetbrains.ocelot.mapper.core.MappingContext.set.<anonymous>' call
      var message_0 = 'Trying to set null as a value of ' + property.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    var tmp2 = this.yla_1;
    // Inline function 'kotlin.collections.set' call
    var value_0 = !(value == null) ? value : THROW_CCE();
    tmp2.r2(property, value_0);
  };
  protoOf(MappingContext).sld = function (property) {
    var value = this.yla_1.y2(property);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (value == null) {
        // Inline function 'jetbrains.ocelot.mapper.core.MappingContext.get.<anonymous>' call
        var message = 'Property ' + property.toString() + " wasn't found";
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return (value == null ? true : !(value == null)) ? value : THROW_CCE();
  };
  protoOf(MappingContext).tld = function (property) {
    return this.yla_1.w2(property);
  };
  protoOf(MappingContext).zla = function () {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = this.wla_1.u2();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.mapper.core.MappingContext.getMappers.<anonymous>' call
      var list = this.qld(element);
      addAll_1(destination, list);
    }
    return toSet_0(destination);
  };
  protoOf(MappingContext).qld = function (source) {
    var tmp;
    if (this.wla_1.w2(source)) {
      tmp = getMappers(this.wla_1, this, source);
    } else {
      // Inline function 'kotlin.collections.setOf' call
      tmp = emptySet();
    }
    return tmp;
  };
  function MappingContextProperty(name) {
    this.uld_1 = name;
  }
  protoOf(MappingContextProperty).toString = function () {
    return 'MappingContextProperty[' + this.uld_1 + ']';
  };
  function ObservableCollectionRoleSynchronizer$onAttach$1(this$0) {
    this.vld_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(ObservableCollectionRoleSynchronizer$onAttach$1).r2j = function (event) {
    var mapper = this.vld_1.fla(event.k27());
    this.vld_1.ol9().p2(event.g27_1, mapper);
    this.vld_1.ale_1.p2(event.g27_1, mapper.ql9_1);
    this.vld_1.hla(mapper);
  };
  protoOf(ObservableCollectionRoleSynchronizer$onAttach$1).c27 = function (event) {
    return this.r2j(event);
  };
  protoOf(ObservableCollectionRoleSynchronizer$onAttach$1).t2j = function (event) {
    this.vld_1.ol9().q2(event.g27_1);
    this.vld_1.ale_1.q2(event.g27_1);
  };
  protoOf(ObservableCollectionRoleSynchronizer$onAttach$1).j27 = function (event) {
    return this.t2j(event);
  };
  function ObservableCollectionRoleSynchronizer(source, target, factory) {
    BaseCollectionRoleSynchronizer.call(this, factory);
    this.zld_1 = source;
    this.ale_1 = target;
    this.ble_1 = Companion_getInstance_25().wr_1;
  }
  protoOf(ObservableCollectionRoleSynchronizer).mla = function () {
    protoOf(BaseCollectionRoleSynchronizer).mla.call(this);
    // Inline function 'kotlin.require' call
    if (!this.ale_1.p()) {
      // Inline function 'jetbrains.ocelot.mapper.core.ObservableCollectionRoleSynchronizer.onAttach.<anonymous>' call
      var message = 'Target Collection Should Be Empty';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    (new MapperUpdater(this)).kl9(this.zld_1);
    var _iterator__ex2g4s = this.ol9().k();
    while (_iterator__ex2g4s.l()) {
      var mapper = _iterator__ex2g4s.m();
      this.ale_1.e(mapper.ql9_1);
    }
    var tmp = this;
    tmp.ble_1 = this.zld_1.n27(new ObservableCollectionRoleSynchronizer$onAttach$1(this));
  };
  protoOf(ObservableCollectionRoleSynchronizer).nla = function () {
    protoOf(BaseCollectionRoleSynchronizer).nla.call(this);
    this.ble_1.vr();
    this.ale_1.m2();
  };
  function indexOf_12(_this__u8e3s4, item) {
    var tmp0 = _this__u8e3s4.ila();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var item_0 = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.mapper.core.indexOf.<anonymous>' call
        if (item_0.pl9_1 === item) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  }
  function _get_targetMapper__ndmpif($this) {
    var tmp = $this.gle_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('targetMapper');
    }
  }
  function sync($this) {
    var modelValue = $this.ele_1.qr();
    var tmp0_safe_receiver = _get_targetMapper__ndmpif($this).qr();
    var viewValue = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pl9_1;
    if (modelValue === viewValue)
      return Unit_instance;
    if (modelValue == null) {
      _get_targetMapper__ndmpif($this).t2c(null);
      $this.fle_1.t2c(null);
    } else {
      var mapper = $this.fla(modelValue);
      _get_targetMapper__ndmpif($this).t2c(mapper);
      $this.fle_1.t2c(mapper.ql9_1);
      $this.hla(mapper);
    }
  }
  function SingleChildRoleSynchronizer$attach$lambda(this$0) {
    return function (it) {
      sync(this$0);
      return Unit_instance;
    };
  }
  function SingleChildRoleSynchronizer(childProperty, targetProperty, factory) {
    BaseRoleSynchronizer.call(this, factory);
    this.ele_1 = childProperty;
    this.fle_1 = targetProperty;
    this.hle_1 = Companion_getInstance_25().wr_1;
  }
  protoOf(SingleChildRoleSynchronizer).ila = function () {
    var tmp0_safe_receiver = _get_targetMapper__ndmpif(this).qr();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.mapper.core.SingleChildRoleSynchronizer.<get-mappers>.<anonymous>' call
      tmp = listOf(tmp0_safe_receiver);
    }
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(SingleChildRoleSynchronizer).jla = function (ctx) {
    this.gle_1 = ctx.kla().cld();
    sync(this);
    var tmp = this;
    tmp.hle_1 = this.ele_1.p27(SingleChildRoleSynchronizer$attach$lambda(this));
  };
  protoOf(SingleChildRoleSynchronizer).t6m = function () {
    this.hle_1.vr();
    _get_targetMapper__ndmpif(this).t2c(null);
  };
  function Synchronizer() {
  }
  function Synchronizers$forProperty$o$doAttach$lambda($sync) {
    return function (it) {
      $sync();
      return Unit_instance;
    };
  }
  function Synchronizers$forProperty$$inlined$forEventSource$1($sync, $src) {
    this.jle_1 = $sync;
    this.kle_1 = $src;
    DisposableSynchronizer.call(this);
  }
  protoOf(Synchronizers$forProperty$$inlined$forEventSource$1).dlb = function (ctx) {
    this.jle_1();
    return this.kle_1.p27(Synchronizers$forProperty$o$doAttach$lambda(this.jle_1));
  };
  function Synchronizers$forDisposables$1($disposables) {
    this.lle_1 = $disposables;
  }
  protoOf(Synchronizers$forDisposables$1).jla = function (ctx) {
  };
  protoOf(Synchronizers$forDisposables$1).t6m = function () {
    var indexedObject = this.lle_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var disposable = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      disposable.vr();
    }
  };
  function Synchronizers$composite$1($syncs) {
    this.mle_1 = $syncs;
  }
  protoOf(Synchronizers$composite$1).jla = function (ctx) {
    var indexedObject = this.mle_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var sync = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      sync.jla(ctx);
    }
  };
  protoOf(Synchronizers$composite$1).t6m = function () {
    var inductionVariable = this.mle_1.length - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.mle_1[i].t6m();
      }
       while (0 <= inductionVariable);
  };
  function Synchronizers() {
  }
  protoOf(Synchronizers).nle = function (source, target, factory) {
    return new ObservableCollectionRoleSynchronizer(source, target, factory);
  };
  protoOf(Synchronizers).ole = function (source, target, factory) {
    return this.ple(constantProp(source), target, factory);
  };
  protoOf(Synchronizers).ple = function (source, target, factory) {
    return new SingleChildRoleSynchronizer(source, target, factory);
  };
  protoOf(Synchronizers).qle = function (property, sync) {
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forEventSource' call
    return new Synchronizers$forProperty$$inlined$forEventSource$1(sync, property);
  };
  protoOf(Synchronizers).rle = function (disposables) {
    return new Synchronizers$forDisposables$1(disposables);
  };
  protoOf(Synchronizers).sle = function (syncs) {
    return new Synchronizers$composite$1(syncs);
  };
  var Synchronizers_instance;
  function Synchronizers_getInstance() {
    return Synchronizers_instance;
  }
  var State_INITIALIZING_instance;
  var State_ATTACHING_instance;
  var State_ATTACHED_instance_0;
  var State_DETACHING_instance;
  var State_DETACHED_instance_0;
  var State_CLEARING_instance;
  var State_entriesInitialized_3;
  function State_initEntries_3() {
    if (State_entriesInitialized_3)
      return Unit_instance;
    State_entriesInitialized_3 = true;
    State_INITIALIZING_instance = new State_4('INITIALIZING', 0);
    State_ATTACHING_instance = new State_4('ATTACHING', 1);
    State_ATTACHED_instance_0 = new State_4('ATTACHED', 2);
    State_DETACHING_instance = new State_4('DETACHING', 3);
    State_DETACHED_instance_0 = new State_4('DETACHED', 4);
    State_CLEARING_instance = new State_4('CLEARING', 5);
  }
  function _get_context__ps0bpe($this) {
    var tmp = $this.ule_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('context');
    }
  }
  function expectState($this, expectedStates) {
    var hadExpectedState = false;
    var inductionVariable = 0;
    var last = expectedStates.length;
    $l$loop: while (inductionVariable < last) {
      var expectedState = expectedStates[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.vle_1.equals(expectedState)) {
        hadExpectedState = true;
        break $l$loop;
      }
    }
    // Inline function 'kotlin.check' call
    if (!hadExpectedState) {
      // Inline function 'jetbrains.ocelot.mapper.syncs.reloadable.ReloadableSynchronizer.expectState.<anonymous>' call
      var message = "current state: '" + $this.vle_1.toString() + "', expected: '" + toString_1(toList(expectedStates)) + "'";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function transitionToState($this, state, expectedStateBefore) {
    expectState($this, [expectedStateBefore]);
    $this.vle_1 = state;
  }
  function attachCurrent($this) {
    expectState($this, [State_ATTACHING_getInstance()]);
    var _iterator__ex2g4s = $this.tle_1.k();
    while (_iterator__ex2g4s.l()) {
      var synchronizer = _iterator__ex2g4s.m();
      synchronizer.jla(_get_context__ps0bpe($this));
      expectState($this, [State_ATTACHING_getInstance()]);
    }
  }
  function detachCurrent($this) {
    expectState($this, [State_DETACHING_getInstance(), State_CLEARING_getInstance()]);
    var _iterator__ex2g4s = $this.tle_1.k();
    while (_iterator__ex2g4s.l()) {
      var synchronizer = _iterator__ex2g4s.m();
      synchronizer.t6m();
      expectState($this, [State_DETACHING_getInstance(), State_CLEARING_getInstance()]);
    }
    $this.tle_1.m2();
  }
  function State_4(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function State_INITIALIZING_getInstance() {
    State_initEntries_3();
    return State_INITIALIZING_instance;
  }
  function State_ATTACHING_getInstance() {
    State_initEntries_3();
    return State_ATTACHING_instance;
  }
  function State_ATTACHED_getInstance_0() {
    State_initEntries_3();
    return State_ATTACHED_instance_0;
  }
  function State_DETACHING_getInstance() {
    State_initEntries_3();
    return State_DETACHING_instance;
  }
  function State_DETACHED_getInstance_0() {
    State_initEntries_3();
    return State_DETACHED_instance_0;
  }
  function State_CLEARING_getInstance() {
    State_initEntries_3();
    return State_CLEARING_instance;
  }
  function ReloadableSynchronizer() {
    this.tle_1 = ArrayList_init_$Create$();
    this.vle_1 = State_INITIALIZING_getInstance();
  }
  protoOf(ReloadableSynchronizer).wle = function (synchronizer) {
    expectState(this, [State_INITIALIZING_getInstance(), State_ATTACHED_getInstance_0()]);
    // Inline function 'kotlin.collections.plusAssign' call
    this.tle_1.e(synchronizer);
    if (this.vle_1.equals(State_ATTACHED_getInstance_0())) {
      synchronizer.jla(_get_context__ps0bpe(this));
    }
  };
  protoOf(ReloadableSynchronizer).xle = function () {
    transitionToState(this, State_ATTACHING_getInstance(), State_INITIALIZING_getInstance());
    attachCurrent(this);
    transitionToState(this, State_ATTACHED_getInstance_0(), State_ATTACHING_getInstance());
  };
  protoOf(ReloadableSynchronizer).jla = function (ctx) {
    transitionToState(this, State_ATTACHING_getInstance(), State_INITIALIZING_getInstance());
    this.ule_1 = ctx;
    attachCurrent(this);
    transitionToState(this, State_ATTACHED_getInstance_0(), State_ATTACHING_getInstance());
  };
  protoOf(ReloadableSynchronizer).t6m = function () {
    transitionToState(this, State_DETACHING_getInstance(), State_ATTACHED_getInstance_0());
    detachCurrent(this);
    transitionToState(this, State_DETACHED_getInstance_0(), State_DETACHING_getInstance());
  };
  protoOf(ReloadableSynchronizer).m2 = function () {
    transitionToState(this, State_CLEARING_getInstance(), State_ATTACHED_getInstance_0());
    detachCurrent(this);
    transitionToState(this, State_INITIALIZING_getInstance(), State_CLEARING_getInstance());
  };
  function SubList_1(source, fromIndex, toIndex) {
    AbstractList.call(this);
    this.yle_1 = source;
    this.zle_1 = fromIndex;
    this.alf_1 = toIndex;
    this.blf_1 = 0;
    ListImplementation_instance.clf(this.zle_1, this.alf_1, this.yle_1.n());
    this.blf_1 = this.alf_1 - this.zle_1 | 0;
  }
  protoOf(SubList_1).q = function (index) {
    ListImplementation_instance.dlf(index, this.blf_1);
    return this.yle_1.q(this.zle_1 + index | 0);
  };
  protoOf(SubList_1).n = function () {
    return this.blf_1;
  };
  protoOf(SubList_1).j2 = function (fromIndex, toIndex) {
    ListImplementation_instance.clf(fromIndex, toIndex, this.blf_1);
    return new SubList_1(this.yle_1, this.zle_1 + fromIndex | 0, this.zle_1 + toIndex | 0);
  };
  function ImmutableList() {
  }
  function persistentListOf() {
    return persistentVectorOf();
  }
  function AbstractListIterator(index, size) {
    this.elf_1 = index;
    this.flf_1 = size;
  }
  protoOf(AbstractListIterator).l = function () {
    return this.elf_1 < this.flf_1;
  };
  protoOf(AbstractListIterator).l5 = function () {
    return this.elf_1 > 0;
  };
  protoOf(AbstractListIterator).m5 = function () {
    return this.elf_1;
  };
  protoOf(AbstractListIterator).o5 = function () {
    return this.elf_1 - 1 | 0;
  };
  protoOf(AbstractListIterator).glf = function () {
    if (!this.l())
      throw NoSuchElementException_init_$Create$();
  };
  protoOf(AbstractListIterator).hlf = function () {
    if (!this.l5())
      throw NoSuchElementException_init_$Create$();
  };
  function AbstractPersistentList() {
    AbstractList.call(this);
  }
  protoOf(AbstractPersistentList).j2 = function (fromIndex, toIndex) {
    return subList.call(this, fromIndex, toIndex);
  };
  protoOf(AbstractPersistentList).s = function (element) {
    return !(this.t(element) === -1);
  };
  protoOf(AbstractPersistentList).h2 = function (elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'kotlinx.collections.immutable.implementations.immutableList.AbstractPersistentList.containsAll.<anonymous>' call
        if (!this.s(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(AbstractPersistentList).k = function () {
    return this.i2();
  };
  protoOf(AbstractPersistentList).i2 = function () {
    return this.r(0);
  };
  function BufferIterator(buffer, index, size) {
    AbstractListIterator.call(this, index, size);
    this.klf_1 = buffer;
  }
  protoOf(BufferIterator).m = function () {
    if (!this.l()) {
      throw NoSuchElementException_init_$Create$();
    }
    var tmp1 = this.elf_1;
    this.elf_1 = tmp1 + 1 | 0;
    return this.klf_1[tmp1];
  };
  protoOf(BufferIterator).n5 = function () {
    if (!this.l5()) {
      throw NoSuchElementException_init_$Create$();
    }
    this.elf_1 = this.elf_1 - 1 | 0;
    return this.klf_1[this.elf_1];
  };
  function rootSize($this) {
    return rootSize_0($this.nlf_1);
  }
  function pushFilledTail($this, root, filledTail, newTail) {
    if ($this.nlf_1 >> 5 > 1 << $this.olf_1) {
      var newRoot = presizedBufferWith(root);
      var newRootShift = $this.olf_1 + 5 | 0;
      newRoot = pushTail($this, newRoot, newRootShift, filledTail);
      return new PersistentVector(newRoot, newTail, $this.nlf_1 + 1 | 0, newRootShift);
    }
    var newRoot_0 = pushTail($this, root, $this.olf_1, filledTail);
    return new PersistentVector(newRoot_0, newTail, $this.nlf_1 + 1 | 0, $this.olf_1);
  }
  function pushTail($this, root, shift, tail) {
    var bufferIndex = indexSegment($this.nlf_1 - 1 | 0, shift);
    var tmp1_elvis_lhs = root == null ? null : copyOf_8(root, 32);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOfNulls' call
      tmp = fillArrayVal(Array(32), null);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var newRootNode = tmp;
    if (shift === 5) {
      newRootNode[bufferIndex] = tail;
    } else {
      var tmp_0 = newRootNode[bufferIndex];
      newRootNode[bufferIndex] = pushTail($this, (tmp_0 == null ? true : isArray(tmp_0)) ? tmp_0 : THROW_CCE(), shift - 5 | 0, tail);
    }
    return newRootNode;
  }
  function bufferFor($this, index) {
    if (rootSize($this) <= index) {
      return $this.mlf_1;
    }
    var buffer = $this.llf_1;
    var shift = $this.olf_1;
    while (shift > 0) {
      var tmp = buffer[indexSegment(index, shift)];
      buffer = (!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE();
      shift = shift - 5 | 0;
    }
    return buffer;
  }
  function PersistentVector(root, tail, size, rootShift) {
    AbstractPersistentList.call(this);
    this.llf_1 = root;
    this.mlf_1 = tail;
    this.nlf_1 = size;
    this.olf_1 = rootShift;
    // Inline function 'kotlin.require' call
    if (!(this.nlf_1 > 32)) {
      // Inline function 'kotlinx.collections.immutable.implementations.immutableList.PersistentVector.<anonymous>' call
      var message = 'Trie-based persistent vector should have at least 33 elements, got ' + this.nlf_1;
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    assert((this.nlf_1 - rootSize_0(this.nlf_1) | 0) <= coerceAtMost(this.mlf_1.length, 32));
  }
  protoOf(PersistentVector).n = function () {
    return this.nlf_1;
  };
  protoOf(PersistentVector).e = function (element) {
    var tailSize = this.nlf_1 - rootSize(this) | 0;
    if (tailSize < 32) {
      var newTail = copyOf_8(this.mlf_1, 32);
      newTail[tailSize] = element;
      return new PersistentVector(this.llf_1, newTail, this.nlf_1 + 1 | 0, this.olf_1);
    }
    var newTail_0 = presizedBufferWith(element);
    return pushFilledTail(this, this.llf_1, this.mlf_1, newTail_0);
  };
  protoOf(PersistentVector).r = function (index) {
    ListImplementation_instance.plf(index, this.nlf_1);
    var tmp = this.mlf_1;
    return new PersistentVectorIterator(this.llf_1, isArray(tmp) ? tmp : THROW_CCE(), index, this.nlf_1, (this.olf_1 / 5 | 0) + 1 | 0);
  };
  protoOf(PersistentVector).q = function (index) {
    ListImplementation_instance.dlf(index, this.nlf_1);
    var buffer = bufferFor(this, index);
    var tmp = buffer[index & 31];
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  function PersistentVectorIterator(root, tail, index, size, trieHeight) {
    AbstractListIterator.call(this, index, size);
    this.slf_1 = tail;
    var trieSize = rootSize_0(size);
    var trieIndex = coerceAtMost(index, trieSize);
    this.tlf_1 = new TrieIterator(root, trieIndex, trieSize, trieHeight);
  }
  protoOf(PersistentVectorIterator).m = function () {
    this.glf();
    if (this.tlf_1.l()) {
      this.elf_1 = this.elf_1 + 1 | 0;
      return this.tlf_1.m();
    }
    var tmp3 = this.elf_1;
    this.elf_1 = tmp3 + 1 | 0;
    return this.slf_1[tmp3 - this.tlf_1.flf_1 | 0];
  };
  protoOf(PersistentVectorIterator).n5 = function () {
    this.hlf();
    if (this.elf_1 > this.tlf_1.flf_1) {
      this.elf_1 = this.elf_1 - 1 | 0;
      return this.slf_1[this.elf_1 - this.tlf_1.flf_1 | 0];
    }
    this.elf_1 = this.elf_1 - 1 | 0;
    return this.tlf_1.n5();
  };
  function Companion_262() {
    Companion_instance_262 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    tmp.zlf_1 = new SmallPersistentVector(tmp$ret$0);
  }
  var Companion_instance_262;
  function Companion_getInstance_262() {
    if (Companion_instance_262 == null)
      new Companion_262();
    return Companion_instance_262;
  }
  function SmallPersistentVector(buffer) {
    Companion_getInstance_262();
    AbstractPersistentList.call(this);
    this.alg_1 = buffer;
    assert(this.alg_1.length <= 32);
  }
  protoOf(SmallPersistentVector).n = function () {
    return this.alg_1.length;
  };
  protoOf(SmallPersistentVector).e = function (element) {
    if (this.n() < 32) {
      var newBuffer = copyOf_8(this.alg_1, this.n() + 1 | 0);
      newBuffer[this.n()] = element;
      return new SmallPersistentVector(newBuffer);
    }
    var tail = presizedBufferWith(element);
    return new PersistentVector(this.alg_1, tail, this.n() + 1 | 0, 0);
  };
  protoOf(SmallPersistentVector).t = function (element) {
    return indexOf(this.alg_1, element);
  };
  protoOf(SmallPersistentVector).u = function (element) {
    return lastIndexOf(this.alg_1, element);
  };
  protoOf(SmallPersistentVector).r = function (index) {
    ListImplementation_instance.plf(index, this.n());
    var tmp = this.alg_1;
    return new BufferIterator(isArray(tmp) ? tmp : THROW_CCE(), index, this.n());
  };
  protoOf(SmallPersistentVector).q = function (index) {
    ListImplementation_instance.dlf(index, this.n());
    var tmp = this.alg_1[index];
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  function fillPath($this, index, startLevel) {
    var shift = imul($this.wlf_1 - startLevel | 0, 5);
    var i = startLevel;
    while (i < $this.wlf_1) {
      var tmp = $this.xlf_1;
      var tmp_0 = i;
      var tmp_1 = $this.xlf_1[i - 1 | 0];
      tmp[tmp_0] = ((!(tmp_1 == null) ? isArray(tmp_1) : false) ? tmp_1 : THROW_CCE())[indexSegment(index, shift)];
      shift = shift - 5 | 0;
      i = i + 1 | 0;
    }
  }
  function fillPathIfNeeded($this, indexPredicate) {
    var shift = 0;
    while (indexSegment($this.elf_1, shift) === indexPredicate) {
      shift = shift + 5 | 0;
    }
    if (shift > 0) {
      var level = ($this.wlf_1 - 1 | 0) - (shift / 5 | 0) | 0;
      fillPath($this, $this.elf_1, level + 1 | 0);
    }
  }
  function elementAtCurrentIndex($this) {
    var leafBufferIndex = $this.elf_1 & 31;
    var tmp = $this.xlf_1[$this.wlf_1 - 1 | 0];
    return ((!(tmp == null) ? isArray(tmp) : false) ? tmp : THROW_CCE())[leafBufferIndex];
  }
  function TrieIterator(root, index, size, height) {
    AbstractListIterator.call(this, index, size);
    this.wlf_1 = height;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size_0 = this.wlf_1;
    tmp.xlf_1 = fillArrayVal(Array(size_0), null);
    this.ylf_1 = index === size;
    this.xlf_1[0] = root;
    fillPath(this, index - (this.ylf_1 ? 1 : 0) | 0, 1);
  }
  protoOf(TrieIterator).m = function () {
    if (!this.l()) {
      throw NoSuchElementException_init_$Create$();
    }
    var result = elementAtCurrentIndex(this);
    this.elf_1 = this.elf_1 + 1 | 0;
    if (this.elf_1 === this.flf_1) {
      this.ylf_1 = true;
      return result;
    }
    fillPathIfNeeded(this, 0);
    return result;
  };
  protoOf(TrieIterator).n5 = function () {
    if (!this.l5()) {
      throw NoSuchElementException_init_$Create$();
    }
    this.elf_1 = this.elf_1 - 1 | 0;
    if (this.ylf_1) {
      this.ylf_1 = false;
      return elementAtCurrentIndex(this);
    }
    fillPathIfNeeded(this, 31);
    return elementAtCurrentIndex(this);
  };
  function persistentVectorOf() {
    return Companion_getInstance_262().zlf_1;
  }
  function presizedBufferWith(element) {
    // Inline function 'kotlin.arrayOfNulls' call
    var buffer = fillArrayVal(Array(32), null);
    buffer[0] = element;
    return buffer;
  }
  function rootSize_0(vectorSize) {
    return (vectorSize - 1 | 0) & -32;
  }
  function indexSegment(index, shift) {
    return index >> shift & 31;
  }
  function ListImplementation() {
  }
  protoOf(ListImplementation).dlf = function (index, size) {
    if (index < 0 || index >= size) {
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
    }
  };
  protoOf(ListImplementation).plf = function (index, size) {
    if (index < 0 || index > size) {
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + size);
    }
  };
  protoOf(ListImplementation).clf = function (fromIndex, toIndex, size) {
    if (fromIndex < 0 || toIndex > size) {
      throw IndexOutOfBoundsException_init_$Create$_0('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size);
    }
    if (fromIndex > toIndex) {
      throw IllegalArgumentException_init_$Create$_0('fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
    }
  };
  var ListImplementation_instance;
  function ListImplementation_getInstance() {
    return ListImplementation_instance;
  }
  function assert(condition) {
    if (!condition) {
      throw AssertionError_init_$Create$_0('Assertion failed');
    }
  }
  function BoundsComposites(hasBounds) {
    this.blg_1 = hasBounds;
  }
  protoOf(BoundsComposites).clg = function (upper, lower, threshold) {
    var upperBounds = this.blg_1(upper);
    var lowerBounds = this.blg_1(lower);
    return ((upperBounds.cku_1.fku_1 + upperBounds.dku_1.fku_1 | 0) - threshold | 0) <= lowerBounds.cku_1.fku_1;
  };
  protoOf(BoundsComposites).dlg = function (upper, lower, threshold, $super) {
    threshold = threshold === VOID ? 0 : threshold;
    return $super === VOID ? this.clg(upper, lower, threshold) : $super.clg.call(this, upper, lower, threshold);
  };
  protoOf(BoundsComposites).elg = function (lower, upper, threshold) {
    return this.clg(upper, lower, threshold);
  };
  function NavCompositeBounds(boundsComposites, navCompositeFocusables) {
    this.flg_1 = boundsComposites;
    this.glg_1 = navCompositeFocusables;
  }
  protoOf(NavCompositeBounds).hlg = function (cell, threshold) {
    var current = cell;
    while (true) {
      var prev = this.glg_1.klg(current);
      if (prev == null || this.flg_1.clg(prev, cell, threshold)) {
        return current;
      }
      current = prev;
    }
  };
  protoOf(NavCompositeBounds).llg = function (cell, threshold) {
    var current = cell;
    while (true) {
      var next = this.glg_1.mlg(current);
      if (next == null || this.flg_1.elg(next, cell, threshold)) {
        return current;
      }
      current = next;
    }
  };
  function isFocusable($this, cv) {
    return $this.nlg_1(cv).qr();
  }
  function isVisible($this, cv) {
    return $this.olg_1(cv).qr();
  }
  function CompositeFocusables(hasFocusability, hasVisibility) {
    this.nlg_1 = hasFocusability;
    this.olg_1 = hasVisibility;
  }
  protoOf(CompositeFocusables).plg = function (composite) {
    return this.qlg(composite, true);
  };
  protoOf(CompositeFocusables).qlg = function (composite, deepest) {
    var _iterator__ex2g4s = composite.g2r().k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var cv = _iterator__ex2g4s.m();
      if (!isVisible(this, cv))
        continue $l$loop;
      if (!deepest && isFocusable(this, cv))
        return cv;
      var result = this.plg(cv);
      if (!(result == null))
        return result;
    }
    return isFocusable(this, composite) ? composite : null;
  };
  protoOf(CompositeFocusables).rlg = function (composite) {
    return this.slg(composite, true);
  };
  protoOf(CompositeFocusables).slg = function (composite, deepest) {
    var children = composite.g2r();
    var _iterator__ex2g4s = asReversed(children).k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var cv = _iterator__ex2g4s.m();
      if (!isVisible(this, cv))
        continue $l$loop;
      if (!deepest && isFocusable(this, cv))
        return cv;
      var result = this.slg(cv, deepest);
      if (!(result == null))
        return result;
    }
    return isFocusable(this, composite) ? composite : null;
  };
  function isFocusable_0(_this__u8e3s4, hasFocusability, hasVisibility) {
    return hasFocusability(_this__u8e3s4).qr() && isVisible_0(_this__u8e3s4, hasVisibility);
  }
  function isVisible_0(_this__u8e3s4, hasVisibility) {
    var tmp0 = ancestorsFrom(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.all' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.base.composite.focusable.isVisible.<anonymous>' call
        if (!hasVisibility(element).qr()) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function prevFocusables($this, composite) {
    var tmp = Composites_instance.y2r(composite);
    return filter(tmp, NavCompositeFocusables$prevFocusables$lambda($this));
  }
  function isFocusable_1($this, cv) {
    return isFocusable_0(cv, $this.ilg_1, $this.jlg_1);
  }
  function NavCompositeFocusables$nextFocusables$lambda(this$0) {
    return function (cv) {
      return isFocusable_1(this$0, cv);
    };
  }
  function NavCompositeFocusables$prevFocusables$lambda(this$0) {
    return function (cv) {
      return isFocusable_1(this$0, cv);
    };
  }
  function NavCompositeFocusables(hasFocusability, hasVisibility) {
    this.ilg_1 = hasFocusability;
    this.jlg_1 = hasVisibility;
  }
  protoOf(NavCompositeFocusables).tlg = function (composite, fromNext) {
    var tmp = Composites_instance.w2r(composite, fromNext);
    return filter(tmp, NavCompositeFocusables$nextFocusables$lambda(this));
  };
  protoOf(NavCompositeFocusables).ulg = function (composite, fromNext, $super) {
    fromNext = fromNext === VOID ? true : fromNext;
    return $super === VOID ? this.tlg(composite, fromNext) : $super.tlg.call(this, composite, fromNext);
  };
  protoOf(NavCompositeFocusables).mlg = function (composite) {
    return firstOrNull_2(this.ulg(composite));
  };
  protoOf(NavCompositeFocusables).klg = function (composite) {
    return firstOrNull_2(prevFocusables(this, composite));
  };
  function BackgroundHighlightTextDecoration(color, interval, priority) {
    priority = priority === VOID ? 0 : priority;
    TextDecoration.call(this, interval, priority);
    this.xlg_1 = color;
  }
  protoOf(BackgroundHighlightTextDecoration).toString = function () {
    return 'BackgroundHighlightTextDecoration(color=' + this.xlg_1.toString() + ', range=' + this.ylg_1.toString() + ', priority=' + this.zlg_1 + ')';
  };
  protoOf(BackgroundHighlightTextDecoration).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof BackgroundHighlightTextDecoration))
      THROW_CCE();
    if (!this.xlg_1.equals(other.xlg_1))
      return false;
    if (!this.ylg_1.equals(other.ylg_1))
      return false;
    if (!(this.zlg_1 === other.zlg_1))
      return false;
    return true;
  };
  protoOf(BackgroundHighlightTextDecoration).hashCode = function () {
    var result = this.xlg_1.hashCode();
    result = imul(31, result) + this.ylg_1.hashCode() | 0;
    result = imul(31, result) + this.zlg_1 | 0;
    return result;
  };
  function RedUnderlineTextDecoration() {
  }
  function TextDecoration(interval, priority) {
    priority = priority === VOID ? 0 : priority;
    this.ylg_1 = interval;
    this.zlg_1 = priority;
  }
  function sam$kotlin_Comparator$0_3(function_0) {
    this.alh_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_3).te = function (a, b) {
    return this.alh_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_3).compare = function (a, b) {
    return this.te(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_3).b4 = function () {
    return this.alh_1;
  };
  protoOf(sam$kotlin_Comparator$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_3).hashCode = function () {
    return hashCode(this.b4());
  };
  function TextDecorations$PRIORITY$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'jetbrains.ocelot.projectional.base.textStyle.TextDecorations.PRIORITY.stub_for_inlining' call
    var tmp = a.zlg_1;
    // Inline function 'jetbrains.ocelot.projectional.base.textStyle.TextDecorations.PRIORITY.stub_for_inlining' call
    var tmp$ret$1 = b.zlg_1;
    return compareValues(tmp, tmp$ret$1);
  }
  function TextDecorations() {
    TextDecorations_instance = this;
    var tmp = this;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_0 = TextDecorations$PRIORITY$lambda;
    tmp.blh_1 = new sam$kotlin_Comparator$0_3(tmp_0);
  }
  protoOf(TextDecorations).clh = function (decorations) {
    var prioritized = ArrayList_init_$Create$_1(decorations);
    sortWith_0(prioritized, this.blh_1);
    return prioritized;
  };
  protoOf(TextDecorations).dlh = function (decoration, length) {
    var decorationInterval = decoration.ylg_1;
    var lengthInterval = Companion_instance_36.q2s(0, length);
    return decorationInterval.e2t(lengthInterval);
  };
  var TextDecorations_instance;
  function TextDecorations_getInstance() {
    if (TextDecorations_instance == null)
      new TextDecorations();
    return TextDecorations_instance;
  }
  function TreePath$Companion$sorted$comparator$1($paths) {
    this.elh_1 = $paths;
  }
  protoOf(TreePath$Companion$sorted$comparator$1).flh = function (a, b) {
    var valueA = getValue_0(this.elh_1, a);
    var valueB = getValue_0(this.elh_1, b);
    return valueA.hlh(valueB);
  };
  protoOf(TreePath$Companion$sorted$comparator$1).compare = function (a, b) {
    var tmp = (!(a == null) ? isInterface(a, Composite) : false) ? a : THROW_CCE();
    return this.flh(tmp, (!(b == null) ? isInterface(b, Composite) : false) ? b : THROW_CCE());
  };
  function TreePath_init_$Init$(composite, $this) {
    TreePath_init_$Init$_0(composite, null, $this);
    return $this;
  }
  function TreePath_init_$Create$(composite) {
    return TreePath_init_$Init$(composite, objectCreate(protoOf(TreePath)));
  }
  function TreePath_init_$Init$_0(from, to, $this) {
    TreePath.call($this);
    var current = from;
    while (!(current == null) && !(current === to)) {
      var parent = current.yt();
      if (!(parent == null)) {
        var index = parent.g2r().t(current);
        // Inline function 'kotlin.check' call
        if (!!(index === -1)) {
          throw IllegalStateException_init_$Create$_0('Check failed.');
        }
        $this.glh_1.e(index);
      }
      current = parent;
    }
    // Inline function 'kotlin.check' call
    if (!(current === to)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    reverse($this.glh_1);
    return $this;
  }
  function TreePath_init_$Create$_0(from, to) {
    return TreePath_init_$Init$_0(from, to, objectCreate(protoOf(TreePath)));
  }
  function TreePath_init_$Init$_1(path, $this) {
    TreePath.call($this);
    $this.glh_1.o(path);
    return $this;
  }
  function TreePath_init_$Create$_1(path) {
    return TreePath_init_$Init$_1(path, objectCreate(protoOf(TreePath)));
  }
  function Companion_263() {
  }
  protoOf(Companion_263).ilh = function (composites) {
    // Inline function 'kotlin.collections.associateWith' call
    var result = LinkedHashMap_init_$Create$_0(coerceAtLeast(mapCapacity(collectionSizeOrDefault(composites, 10)), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var _iterator__ex2g4s = composites.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.base.treePath.Companion.sorted.<anonymous>' call
      var tmp$ret$0 = TreePath_init_$Create$(element);
      result.r2(element, tmp$ret$0);
    }
    var paths = result;
    var comparator = new TreePath$Companion$sorted$comparator$1(paths);
    return sortedWith(composites, comparator);
  };
  var Companion_instance_263;
  function Companion_getInstance_263() {
    return Companion_instance_263;
  }
  protoOf(TreePath).jlh = function (root) {
    // Inline function 'kotlin.check' call
    if (!this.klh(root)) {
      // Inline function 'jetbrains.ocelot.projectional.base.treePath.TreePath.get.<anonymous>' call
      var message = 'Invalid context';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var current = root;
    var _iterator__ex2g4s = this.glh_1.k();
    while (_iterator__ex2g4s.l()) {
      var i = _iterator__ex2g4s.m();
      current = current.g2r().q(i);
    }
    return current;
  };
  protoOf(TreePath).klh = function (root) {
    var current = root;
    var _iterator__ex2g4s = this.glh_1.k();
    while (_iterator__ex2g4s.l()) {
      var i = _iterator__ex2g4s.m();
      var children = current.g2r();
      if (i >= children.n()) {
        return false;
      }
      current = children.q(i);
    }
    return true;
  };
  protoOf(TreePath).equals = function (other) {
    if (!(other instanceof TreePath))
      return false;
    var treePath = other instanceof TreePath ? other : THROW_CCE();
    return equals(this.glh_1, ensureNotNull(treePath).glh_1);
  };
  protoOf(TreePath).hashCode = function () {
    return hashCode(this.glh_1);
  };
  protoOf(TreePath).hlh = function (other) {
    var tmp0 = this.glh_1.n();
    // Inline function 'kotlin.math.min' call
    var b = other.glh_1.n();
    var maxIndex = Math.min(tmp0, b);
    var inductionVariable = 0;
    if (inductionVariable < maxIndex)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var delta = this.glh_1.q(i) - other.glh_1.q(i) | 0;
        if (!(delta === 0))
          return delta;
      }
       while (inductionVariable < maxIndex);
    return this.glh_1.n() - other.glh_1.n() | 0;
  };
  protoOf(TreePath).d = function (other) {
    return this.hlh(other instanceof TreePath ? other : THROW_CCE());
  };
  protoOf(TreePath).llh = function (other) {
    var result = TreePath_init_$Create$_1(this.glh_1);
    result.glh_1.o(other.glh_1);
    return result;
  };
  protoOf(TreePath).toString = function () {
    return toString_1(this.glh_1);
  };
  function TreePath() {
    this.glh_1 = ArrayList_init_$Create$();
  }
  function get_IdentifierValidator() {
    _init_properties_Validators_kt__iukeyp();
    return IdentifierValidator;
  }
  var IdentifierValidator;
  function Validators$UNSIGNED_INTEGER$lambda(string) {
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(string) > 0) {
      var tmp$ret$2;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(string)) {
          var element = charSequenceGet(string, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'jetbrains.ocelot.projectional.base.validators.Validators.UNSIGNED_INTEGER.<anonymous>.stub_for_inlining' call
          if (!isDigit(element)) {
            tmp$ret$2 = false;
            break $l$block;
          }
        }
        tmp$ret$2 = true;
      }
      tmp_0 = tmp$ret$2;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = isInt(string);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isInt$ref() {
    var l = function (p0) {
      return isInt(p0);
    };
    l.callableName = 'isInt';
    return l;
  }
  function Validators$BOOL$lambda(input) {
    return 'true' === input || 'false' === input;
  }
  function Validators() {
    Validators_instance = this;
    var tmp = this;
    tmp.mlh_1 = Validators$UNSIGNED_INTEGER$lambda;
    var tmp_0 = this;
    tmp_0.nlh_1 = isInt$ref();
    var tmp_1 = this;
    tmp_1.olh_1 = Validators$BOOL$lambda;
  }
  protoOf(Validators).plh = function () {
    return this.mlh_1;
  };
  protoOf(Validators).qlh = function () {
    return this.nlh_1;
  };
  protoOf(Validators).rlh = function () {
    return this.olh_1;
  };
  var Validators_instance;
  function Validators_getInstance() {
    if (Validators_instance == null)
      new Validators();
    return Validators_instance;
  }
  function IdentifierValidator$lambda(input) {
    _init_properties_Validators_kt__iukeyp();
    var tmp;
    var tmp_0;
    if (input == null) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      tmp_0 = charSequenceLength(input) === 0;
    }
    if (tmp_0) {
      tmp = false;
    } else {
      var isValid = true;
      var inductionVariable = 0;
      $l$loop: while (inductionVariable < charSequenceLength(input)) {
        var index = inductionVariable;
        var ch = charSequenceGet(input, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        if (index === 0 && isDigit(ch) || (!isLetterOrDigit(ch) && !(ch === _Char___init__impl__6a9atx(95)))) {
          isValid = false;
          break $l$loop;
        }
      }
      tmp = isValid;
    }
    return tmp;
  }
  var properties_initialized_Validators_kt_wmfhtv;
  function _init_properties_Validators_kt__iukeyp() {
    if (!properties_initialized_Validators_kt_wmfhtv) {
      properties_initialized_Validators_kt_wmfhtv = true;
      IdentifierValidator = IdentifierValidator$lambda;
    }
  }
  var Alignment_STRETCH_instance;
  var Alignment_START_instance;
  var Alignment_END_instance;
  var Alignment_entriesInitialized;
  function Alignment_initEntries() {
    if (Alignment_entriesInitialized)
      return Unit_instance;
    Alignment_entriesInitialized = true;
    Alignment_STRETCH_instance = new Alignment('STRETCH', 0);
    Alignment_START_instance = new Alignment('START', 1);
    Alignment_END_instance = new Alignment('END', 2);
  }
  function Alignment(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Alignment_STRETCH_getInstance() {
    Alignment_initEntries();
    return Alignment_STRETCH_instance;
  }
  function Alignment_START_getInstance() {
    Alignment_initEntries();
    return Alignment_START_instance;
  }
  function Alignment_END_getInstance() {
    Alignment_initEntries();
    return Alignment_END_instance;
  }
  var Kind_BORDER_instance;
  var Kind_OUTLINE_instance;
  var Kind_entriesInitialized_1;
  function Kind_initEntries_1() {
    if (Kind_entriesInitialized_1)
      return Unit_instance;
    Kind_entriesInitialized_1 = true;
    Kind_BORDER_instance = new Kind_1('BORDER', 0);
    Kind_OUTLINE_instance = new Kind_1('OUTLINE', 1);
  }
  function Kind_1(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_264() {
  }
  var Companion_instance_264;
  function Companion_getInstance_264() {
    return Companion_instance_264;
  }
  function Kind_BORDER_getInstance() {
    Kind_initEntries_1();
    return Kind_BORDER_instance;
  }
  function Border(color, width, kind) {
    kind = kind === VOID ? Kind_BORDER_getInstance() : kind;
    this.slh_1 = kind;
    var side = new Side(color, width);
    this.tlh_1 = side;
    this.ulh_1 = side;
    this.vlh_1 = side;
    this.wlh_1 = side;
  }
  function Side(color, width) {
    this.xlh_1 = color;
    this.ylh_1 = width;
    // Inline function 'kotlin.require' call
    if (!(this.ylh_1 >= 0)) {
      // Inline function 'jetbrains.ocelot.projectional.base.values.Side.<anonymous>' call
      var message = 'negative line width';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(Side).toString = function () {
    return 'Side(color=' + this.xlh_1.toString() + ', width=' + this.ylh_1 + ')';
  };
  protoOf(Side).hashCode = function () {
    var result = this.xlh_1.hashCode();
    result = imul(result, 31) + this.ylh_1 | 0;
    return result;
  };
  protoOf(Side).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Side))
      return false;
    var tmp0_other_with_cast = other instanceof Side ? other : THROW_CCE();
    if (!this.xlh_1.equals(tmp0_other_with_cast.xlh_1))
      return false;
    if (!(this.ylh_1 === tmp0_other_with_cast.ylh_1))
      return false;
    return true;
  };
  function Block() {
  }
  function HorizontalBlock(children) {
    CompoundBlock.call(this);
    this.bli_1 = children;
  }
  protoOf(HorizontalBlock).zlh = function () {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = this.bli_1.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      var tmp = sum;
      // Inline function 'jetbrains.ocelot.projectional.block.HorizontalBlock.<get-width>.<anonymous>' call
      sum = tmp + element.zlh() | 0;
    }
    return sum;
  };
  protoOf(HorizontalBlock).ali = function () {
    var tmp0 = this.bli_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = tmp0.k();
      if (!iterator.l()) {
        tmp$ret$0 = null;
        break $l$block;
      }
      // Inline function 'jetbrains.ocelot.projectional.block.HorizontalBlock.<get-height>.<anonymous>' call
      var maxValue = iterator.m().ali();
      while (iterator.l()) {
        // Inline function 'jetbrains.ocelot.projectional.block.HorizontalBlock.<get-height>.<anonymous>' call
        var v = iterator.m().ali();
        if (compareTo_0(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$0 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    return tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
  };
  protoOf(HorizontalBlock).toString = function () {
    return 'HorizontalBlock(children=' + toString_1(this.bli_1) + ')';
  };
  protoOf(HorizontalBlock).hashCode = function () {
    return hashCode(this.bli_1);
  };
  protoOf(HorizontalBlock).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HorizontalBlock))
      return false;
    var tmp0_other_with_cast = other instanceof HorizontalBlock ? other : THROW_CCE();
    if (!equals(this.bli_1, tmp0_other_with_cast.bli_1))
      return false;
    return true;
  };
  function TextBlock(text) {
    Block.call(this);
    this.cli_1 = text;
  }
  protoOf(TextBlock).zlh = function () {
    return this.cli_1.length;
  };
  protoOf(TextBlock).ali = function () {
    return 1;
  };
  protoOf(TextBlock).toString = function () {
    return 'TextBlock(text=' + this.cli_1 + ')';
  };
  protoOf(TextBlock).hashCode = function () {
    return getStringHashCode(this.cli_1);
  };
  protoOf(TextBlock).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextBlock))
      return false;
    var tmp0_other_with_cast = other instanceof TextBlock ? other : THROW_CCE();
    if (!(this.cli_1 === tmp0_other_with_cast.cli_1))
      return false;
    return true;
  };
  function IndentationBlock(size) {
    Block.call(this);
    this.dli_1 = size;
  }
  protoOf(IndentationBlock).zlh = function () {
    return this.dli_1;
  };
  protoOf(IndentationBlock).ali = function () {
    return 1;
  };
  protoOf(IndentationBlock).toString = function () {
    return 'IndentationBlock(size=' + this.dli_1 + ')';
  };
  protoOf(IndentationBlock).hashCode = function () {
    return this.dli_1;
  };
  protoOf(IndentationBlock).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IndentationBlock))
      return false;
    var tmp0_other_with_cast = other instanceof IndentationBlock ? other : THROW_CCE();
    if (!(this.dli_1 === tmp0_other_with_cast.dli_1))
      return false;
    return true;
  };
  function VerticalBlock(children) {
    CompoundBlock.call(this);
    this.eli_1 = children;
  }
  protoOf(VerticalBlock).zlh = function () {
    var tmp0 = this.eli_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = tmp0.k();
      if (!iterator.l()) {
        tmp$ret$0 = null;
        break $l$block;
      }
      // Inline function 'jetbrains.ocelot.projectional.block.VerticalBlock.<get-width>.<anonymous>' call
      var maxValue = iterator.m().zlh();
      while (iterator.l()) {
        // Inline function 'jetbrains.ocelot.projectional.block.VerticalBlock.<get-width>.<anonymous>' call
        var v = iterator.m().zlh();
        if (compareTo_0(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$0 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  };
  protoOf(VerticalBlock).ali = function () {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = this.eli_1.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      var tmp = sum;
      // Inline function 'jetbrains.ocelot.projectional.block.VerticalBlock.<get-height>.<anonymous>' call
      sum = tmp + element.ali() | 0;
    }
    return sum;
  };
  protoOf(VerticalBlock).toString = function () {
    return 'VerticalBlock(children=' + toString_1(this.eli_1) + ')';
  };
  protoOf(VerticalBlock).hashCode = function () {
    return hashCode(this.eli_1);
  };
  protoOf(VerticalBlock).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VerticalBlock))
      return false;
    var tmp0_other_with_cast = other instanceof VerticalBlock ? other : THROW_CCE();
    if (!equals(this.eli_1, tmp0_other_with_cast.eli_1))
      return false;
    return true;
  };
  function CompoundBlock() {
    Block.call(this);
  }
  function BlockBuilder(orientation) {
    BlockData.call(this);
    this.fli_1 = orientation;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.gli_1 = ArrayList_init_$Create$();
  }
  protoOf(BlockBuilder).hli = function () {
    var tmp;
    switch (this.fli_1.a3_1) {
      case 1:
        // Inline function 'kotlin.collections.map' call

        var this_0 = this.gli_1;
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.k();
        while (_iterator__ex2g4s.l()) {
          var item = _iterator__ex2g4s.m();
          // Inline function 'jetbrains.ocelot.projectional.block.fromCell.BlockBuilder.create.<anonymous>' call
          var tmp$ret$0 = item.hli();
          destination.e(tmp$ret$0);
        }

        tmp = new VerticalBlock(destination);
        break;
      case 0:
        // Inline function 'kotlin.collections.map' call

        var this_1 = this.gli_1;
        // Inline function 'kotlin.collections.mapTo' call

        var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
        var _iterator__ex2g4s_0 = this_1.k();
        while (_iterator__ex2g4s_0.l()) {
          var item_0 = _iterator__ex2g4s_0.m();
          // Inline function 'jetbrains.ocelot.projectional.block.fromCell.BlockBuilder.create.<anonymous>' call
          var tmp$ret$3 = item_0.hli();
          destination_0.e(tmp$ret$3);
        }

        tmp = new HorizontalBlock(destination_0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  var Orientation_HORIZONTAL_instance;
  var Orientation_VERTICAL_instance;
  var Orientation_entriesInitialized;
  function Orientation_initEntries() {
    if (Orientation_entriesInitialized)
      return Unit_instance;
    Orientation_entriesInitialized = true;
    Orientation_HORIZONTAL_instance = new Orientation('HORIZONTAL', 0);
    Orientation_VERTICAL_instance = new Orientation('VERTICAL', 1);
  }
  function Orientation(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Orientation_HORIZONTAL_getInstance() {
    Orientation_initEntries();
    return Orientation_HORIZONTAL_instance;
  }
  function Orientation_VERTICAL_getInstance() {
    Orientation_initEntries();
    return Orientation_VERTICAL_instance;
  }
  function BlockData() {
  }
  function ReadyBlock(block) {
    BlockData.call(this);
    this.ili_1 = block;
  }
  protoOf(ReadyBlock).hli = function () {
    return this.ili_1;
  };
  function BlockIndentUpdater(cell, builder) {
    IndentUpdater.call(this, cell, builder, new BlockIndentUpdaterTarget());
  }
  function BlockIndentUpdaterTarget() {
  }
  protoOf(BlockIndentUpdaterTarget).elj = function () {
    return new BlockBuilder(Orientation_HORIZONTAL_getInstance());
  };
  protoOf(BlockIndentUpdaterTarget).flj = function (size) {
    return new ReadyBlock(new IndentationBlock(size));
  };
  protoOf(BlockIndentUpdaterTarget).glj = function (cell) {
    var block = toBlock(cell);
    return new StaticCellWrapper(new ReadyBlock(block));
  };
  protoOf(BlockIndentUpdaterTarget).hlj = function (item) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(item instanceof BlockBuilder)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return item.gli_1;
  };
  protoOf(BlockIndentUpdaterTarget).ilj = function (item) {
    return this.hlj(item instanceof BlockData ? item : THROW_CCE());
  };
  protoOf(BlockIndentUpdaterTarget).jlj = function (item) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(BlockIndentUpdaterTarget).klj = function (item) {
    return this.jlj(item instanceof BlockData ? item : THROW_CCE());
  };
  protoOf(BlockIndentUpdaterTarget).llj = function (item) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(BlockIndentUpdaterTarget).mlj = function (item) {
    return this.llj(item instanceof BlockData ? item : THROW_CCE());
  };
  protoOf(BlockIndentUpdaterTarget).nlj = function (cell) {
    throw UnsupportedOperationException_init_$Create$();
  };
  function StaticCellWrapper(item) {
    this.olj_1 = item;
  }
  protoOf(StaticCellWrapper).plj = function () {
    return this.olj_1;
  };
  protoOf(StaticCellWrapper).qlj = function () {
  };
  protoOf(StaticCellWrapper).b5 = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  function toBlock(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof TextCell) {
      tmp = new TextBlock(_this__u8e3s4.laz().m2c());
    } else {
      if (_this__u8e3s4 instanceof VerticalCell) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = _this__u8e3s4.g2r();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.k();
        while (_iterator__ex2g4s.l()) {
          var item = _iterator__ex2g4s.m();
          // Inline function 'jetbrains.ocelot.projectional.block.fromCell.toBlock.<anonymous>' call
          var tmp$ret$0 = toBlock(item);
          destination.e(tmp$ret$0);
        }
        tmp = new VerticalBlock(destination);
      } else {
        if (_this__u8e3s4 instanceof HorizontalCell) {
          // Inline function 'kotlin.collections.map' call
          var this_1 = _this__u8e3s4.g2r();
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
          var _iterator__ex2g4s_0 = this_1.k();
          while (_iterator__ex2g4s_0.l()) {
            var item_0 = _iterator__ex2g4s_0.m();
            // Inline function 'jetbrains.ocelot.projectional.block.fromCell.toBlock.<anonymous>' call
            var tmp$ret$3 = toBlock(item_0);
            destination_0.e(tmp$ret$3);
          }
          tmp = new HorizontalBlock(destination_0);
        } else {
          if (_this__u8e3s4 instanceof IndentCell) {
            tmp = indentToBlock(_this__u8e3s4);
          } else {
            throw IllegalArgumentException_init_$Create$_0('Unexpected kind of cell ' + toString_1(getKClassFromExpression(_this__u8e3s4)));
          }
        }
      }
    }
    return tmp;
  }
  function indentToBlock(_this__u8e3s4) {
    var blockBuilder = new BlockBuilder(Orientation_VERTICAL_getInstance());
    var u = new BlockIndentUpdater(_this__u8e3s4, blockBuilder);
    var _iterator__ex2g4s = _this__u8e3s4.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var c = _iterator__ex2g4s.m();
      u.vli(c);
    }
    return blockBuilder.hli();
  }
  function toText_0(_this__u8e3s4) {
    var tmp = computeLines(_this__u8e3s4);
    return joinToString_0(tmp, '\n', VOID, VOID, VOID, VOID, toText$lambda);
  }
  function toTextString(_this__u8e3s4) {
    // Inline function 'kotlin.text.trimEnd' call
    var this_0 = joinToString_0(textPieces(_this__u8e3s4), '');
    return toString_1(trimEnd(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  }
  function computeLines(_this__u8e3s4) {
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.ali();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = new HorizontalBlock(line(_this__u8e3s4, tmp_2));
      tmp = tmp + 1 | 0;
    }
    return toList(tmp_1);
  }
  function textPieces(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof TextBlock) {
      tmp = listOf(_this__u8e3s4.cli_1);
    } else {
      if (_this__u8e3s4 instanceof IndentationBlock) {
        tmp = listOf(repeat(' ', _this__u8e3s4.dli_1));
      } else {
        if (_this__u8e3s4 instanceof HorizontalBlock) {
          // Inline function 'kotlin.collections.flatMap' call
          var tmp0 = _this__u8e3s4.bli_1;
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination = ArrayList_init_$Create$();
          var _iterator__ex2g4s = tmp0.k();
          while (_iterator__ex2g4s.l()) {
            var element = _iterator__ex2g4s.m();
            // Inline function 'jetbrains.ocelot.projectional.block.toText.textPieces.<anonymous>' call
            var list = textPieces(element);
            addAll_1(destination, list);
          }
          tmp = destination;
        } else {
          if (_this__u8e3s4 instanceof VerticalBlock) {
            throw IllegalStateException_init_$Create$_0('Unexpected VerticalBlock. All of them must have been removed before');
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    return tmp;
  }
  function line(_this__u8e3s4, lineNumber) {
    var tmp;
    if (_this__u8e3s4 instanceof TextBlock) {
      tmp = lineNumber === 0 ? listOf(_this__u8e3s4) : listOf(new IndentationBlock(_this__u8e3s4.zlh()));
    } else {
      if (_this__u8e3s4 instanceof IndentationBlock) {
        tmp = listOf(_this__u8e3s4);
      } else {
        if (_this__u8e3s4 instanceof HorizontalBlock) {
          // Inline function 'kotlin.collections.flatMap' call
          var tmp0 = _this__u8e3s4.bli_1;
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination = ArrayList_init_$Create$();
          var _iterator__ex2g4s = tmp0.k();
          while (_iterator__ex2g4s.l()) {
            var element = _iterator__ex2g4s.m();
            // Inline function 'jetbrains.ocelot.projectional.block.toText.line.<anonymous>' call
            var list = line(element, lineNumber);
            addAll_1(destination, list);
          }
          tmp = destination;
        } else {
          if (_this__u8e3s4 instanceof VerticalBlock) {
            tmp = lineOfVerticalBlock(_this__u8e3s4, lineNumber);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    return tmp;
  }
  function lineOfVerticalBlock(_this__u8e3s4, lineNumber) {
    var prevAccHeight = 0;
    var accHeight = 0;
    var _iterator__ex2g4s = _this__u8e3s4.eli_1.k();
    while (_iterator__ex2g4s.l()) {
      var childBlock = _iterator__ex2g4s.m();
      accHeight = accHeight + childBlock.ali() | 0;
      if (accHeight > lineNumber) {
        var childLine = line(childBlock, lineNumber - prevAccHeight | 0);
        var childWidth = childBlock.zlh();
        var tmp;
        if (childWidth === _this__u8e3s4.zlh()) {
          tmp = childLine;
        } else if (childWidth < _this__u8e3s4.zlh()) {
          tmp = plus_4(childLine, listOf(new IndentationBlock(_this__u8e3s4.zlh() - childWidth | 0)));
        } else {
          throw IllegalStateException_init_$Create$();
        }
        return tmp;
      }
      prevAccHeight = accHeight;
    }
    return listOf(new IndentationBlock(_this__u8e3s4.zlh()));
  }
  function toText$lambda(it) {
    return toTextString(it);
  }
  function attachItem($this, item, prevIndex, nextIndex) {
    changeParent(get_asBaseCell(item), $this.klk_1);
    if (0 <= prevIndex ? prevIndex < $this.n() : false) {
      var prev = $this.q(prevIndex);
      get_asBaseCell(prev).vlj_1 = item;
      get_asBaseCell(item).wlj_1 = prev;
    }
    if (0 <= nextIndex ? nextIndex < $this.n() : false) {
      var next = $this.q(nextIndex);
      get_asBaseCell(next).wlj_1 = item;
      get_asBaseCell(item).vlj_1 = next;
    }
  }
  function detachItem($this, item, index) {
    if ($this.klk_1.qlc()) {
      get_asCellContainerInternal(ensureNotNull($this.klk_1.llk())).mlk(item);
    }
    $this.klk_1.nlk(new CollectionItemEvent(item, null, index, EventType_REMOVE_getInstance()));
    var itemBaseCell = get_asBaseCell(item);
    if ($this.klk_1.qlc()) {
      detach(itemBaseCell, true);
    }
    changeParent(itemBaseCell, null);
    var prev = itemBaseCell.wlj_1;
    var next = itemBaseCell.vlj_1;
    if (!(prev == null)) {
      get_asBaseCell(prev).vlj_1 = next;
    }
    if (!(next == null)) {
      get_asBaseCell(next).wlj_1 = prev;
    }
    itemBaseCell.wlj_1 = null;
    itemBaseCell.vlj_1 = null;
  }
  function BaseCell$ChildList$onItemAdd$lambda($event) {
    return function (listener) {
      listener.olk($event);
      return Unit_instance;
    };
  }
  function BaseCell$ChildList$onItemRemove$lambda($event) {
    return function (listener) {
      listener.plk($event);
      return Unit_instance;
    };
  }
  function ensureChildrenInitialized($this) {
    if ($this.rlk_1.slj_1 == null) {
      $this.rlk_1.slj_1 = new ChildList_0($this.rlk_1);
    }
  }
  function BaseCell$ExternalChildList$addListener$cellListener$1($listener) {
    this.slk_1 = $listener;
  }
  protoOf(BaseCell$ExternalChildList$addListener$cellListener$1).olk = function (event) {
    return this.slk_1.c27(event);
  };
  protoOf(BaseCell$ExternalChildList$addListener$cellListener$1).plk = function (event) {
    return this.slk_1.j27(event);
  };
  function BaseCell$ExternalChildList$addHandler$listener$1($handler) {
    this.xlk_1 = $handler;
  }
  protoOf(BaseCell$ExternalChildList$addHandler$listener$1).ylk = function (event) {
    return this.xlk_1.d28(event);
  };
  protoOf(BaseCell$ExternalChildList$addHandler$listener$1).c27 = function (event) {
    return this.ylk(event);
  };
  protoOf(BaseCell$ExternalChildList$addHandler$listener$1).zlk = function (event) {
    return this.xlk_1.d28(event);
  };
  protoOf(BaseCell$ExternalChildList$addHandler$listener$1).d27 = function (event) {
    return this.zlk(event);
  };
  protoOf(BaseCell$ExternalChildList$addHandler$listener$1).all = function (event) {
    return this.xlk_1.d28(event);
  };
  protoOf(BaseCell$ExternalChildList$addHandler$listener$1).j27 = function (event) {
    return this.all(event);
  };
  function dispatch_0($this, bubblingPath, cursor, event, spec) {
    var $this_0 = $this;
    var bubblingPath_0 = bubblingPath;
    var cursor_0 = cursor;
    var event_0 = event;
    var spec_0 = spec;
    $l$1: do {
      $l$0: do {
        var cell = bubblingPath_0.q(cursor_0);
        dispatchStep(get_asBaseCell(cell), event_0, spec_0);
        if (event_0.ml0_1) {
          return Unit_instance;
        }
        var next = nextAttached($this_0, bubblingPath_0, cursor_0);
        if (!(next === -1)) {
          var tmp0 = $this_0;
          var tmp1 = bubblingPath_0;
          var tmp3 = event_0;
          var tmp4 = spec_0;
          $this_0 = tmp0;
          bubblingPath_0 = tmp1;
          cursor_0 = next;
          event_0 = tmp3;
          spec_0 = tmp4;
          continue $l$0;
        }
        break $l$1;
      }
       while (false);
    }
     while (true);
  }
  function dispatch_1($this, bubblingPath, cursor, event, spec) {
    var $this_0 = $this;
    var bubblingPath_0 = bubblingPath;
    var cursor_0 = cursor;
    var event_0 = event;
    var spec_0 = spec;
    $l$1: do {
      $l$0: do {
        var cell = bubblingPath_0.q(cursor_0);
        var _iterator__ex2g4s = get_asBaseCell(cell).rlj_1.k();
        while (_iterator__ex2g4s.l()) {
          var trait = _iterator__ex2g4s.m();
          trait.bll(cell, spec_0, event_0);
          if (event_0.ml0_1) {
            return Unit_instance;
          }
        }
        if (!spec_0.dll_1) {
          return Unit_instance;
        }
        var next = nextAttached($this_0, bubblingPath_0, cursor_0);
        if (!(next === -1)) {
          var tmp0 = $this_0;
          var tmp1 = bubblingPath_0;
          var tmp3 = event_0;
          var tmp4 = spec_0;
          $this_0 = tmp0;
          bubblingPath_0 = tmp1;
          cursor_0 = next;
          event_0 = tmp3;
          spec_0 = tmp4;
          continue $l$0;
        }
        break $l$1;
      }
       while (false);
    }
     while (true);
  }
  function nextAttached($this, bubblingPath, current) {
    var inductionVariable = current + 1 | 0;
    var last = bubblingPath.n();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (bubblingPath.q(i).qlc()) {
          return i;
        }
      }
       while (inductionVariable < last);
    return -1;
  }
  function BaseCell$cellContainer$1$addHandler$cellListener$1($handler) {
    this.ell_1 = $handler;
  }
  protoOf(BaseCell$cellContainer$1$addHandler$cellListener$1).vlk = function (container) {
    var event = new PropertyChangeEvent(null, container);
    this.ell_1.d28(event);
  };
  protoOf(BaseCell$cellContainer$1$addHandler$cellListener$1).wlk = function (container) {
    var event = new PropertyChangeEvent(container, null);
    this.ell_1.d28(event);
  };
  function BaseCell$getProp$MyProperty$addHandler$cellListener$1($cellPropSpec, $handler) {
    this.fll_1 = $cellPropSpec;
    this.gll_1 = $handler;
  }
  protoOf(BaseCell$getProp$MyProperty$addHandler$cellListener$1).tlk = function (prop, event) {
    if (equals(this.fll_1, prop)) {
      var changeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      this.gll_1.d28(changeEvent);
    }
  };
  function BaseCell_init_$Init$($this) {
    BaseCell.call($this, null);
    return $this;
  }
  function dispatchStep($this, event, spec) {
    if (equals(spec, Companion_getInstance_287().lll_1) || (equals(spec, Companion_getInstance_287().mll_1) || equals(spec, Companion_getInstance_287().nll_1))) {
      var keyEvent = event instanceof KeyEvent ? event : THROW_CCE();
      var indexedObject = values_16();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var priority = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var _iterator__ex2g4s = $this.rlj_1.k();
        while (_iterator__ex2g4s.l()) {
          var trait = _iterator__ex2g4s.m();
          if (priority.equals(EventPriority_LOW_getInstance())) {
            if (equals(spec, Companion_getInstance_287().lll_1)) {
              trait.olm($this, keyEvent);
            } else if (equals(spec, Companion_getInstance_287().mll_1)) {
              trait.nlm($this, keyEvent);
            } else {
              trait.mlm($this, keyEvent);
            }
          } else {
            if (equals(spec, Companion_getInstance_287().lll_1)) {
              trait.llm($this, keyEvent);
            } else if (equals(spec, Companion_getInstance_287().mll_1)) {
              trait.kll($this, keyEvent);
            } else {
              trait.jll($this, keyEvent);
            }
          }
          if (event.ml0_1) {
            return Unit_instance;
          }
        }
      }
    } else {
      var _iterator__ex2g4s_0 = $this.rlj_1.k();
      while (_iterator__ex2g4s_0.l()) {
        var trait_0 = _iterator__ex2g4s_0.m();
        spec.ill($this, event, trait_0);
        if (event.ml0_1) {
          return Unit_instance;
        }
      }
    }
  }
  function firePropertyChange($this, prop, event) {
    propertySet($this, prop, event);
    $this.plm(prop, event);
    var _iterator__ex2g4s = $this.rlj_1.k();
    while (_iterator__ex2g4s.l()) {
      var trait = _iterator__ex2g4s.m();
      trait.qlm($this, prop, event);
    }
    var tmp0_safe_receiver = $this.ylj_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a28(BaseCell$firePropertyChange$lambda(prop, event));
    }
    var tmp1_safe_receiver = $this.llk();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_asCellContainerInternal(tmp1_safe_receiver);
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.rlm($this, prop, event);
    }
  }
  function getDefaultValue($this, prop) {
    return prop.ulm($this);
  }
  function attach($this, container, initial) {
    // Inline function 'kotlin.check' call
    if (!!$this.qlc()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    $this.tlj_1 = container;
    get_asCellContainerInternal(container).vlm($this);
    var tmp0_safe_receiver = $this.ylj_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a28(BaseCell$attach$lambda(container));
    }
    var children = $this.slj_1;
    if (!(children == null)) {
      var _iterator__ex2g4s = children.k();
      while (_iterator__ex2g4s.l()) {
        var child = _iterator__ex2g4s.m();
        attach(get_asBaseCell(child), container, false);
      }
    }
    var _iterator__ex2g4s_0 = $this.wlm().k();
    while (_iterator__ex2g4s_0.l()) {
      var popup = _iterator__ex2g4s_0.m();
      attach$default(get_asBaseCell(popup), container);
    }
    if (initial) {
      afterAttach($this);
    }
  }
  function attach$default($this, container, initial, $super) {
    initial = initial === VOID ? true : initial;
    return attach($this, container, initial);
  }
  function detach($this, initial) {
    var container = $this.llk();
    // Inline function 'kotlin.checkNotNull' call
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (container == null) {
        // Inline function 'kotlin.checkNotNull.<anonymous>' call
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    if (initial) {
      beforeDetach($this, $this);
    }
    get_asCellContainerInternal(container).xlm($this);
    $this.tlj_1 = null;
    var tmp0_safe_receiver = $this.ylj_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a28(BaseCell$detach$lambda(container));
    }
    var children = $this.slj_1;
    if (!(children == null)) {
      var _iterator__ex2g4s = children.k();
      while (_iterator__ex2g4s.l()) {
        var child = _iterator__ex2g4s.m();
        detach(get_asBaseCell(child), false);
      }
    }
    var _iterator__ex2g4s_0 = $this.wlm().k();
    while (_iterator__ex2g4s_0.l()) {
      var popup = _iterator__ex2g4s_0.m();
      detach$default(get_asBaseCell(popup));
    }
  }
  function detach$default($this, initial, $super) {
    initial = initial === VOID ? true : initial;
    return detach($this, initial);
  }
  function afterAttach($this) {
    var _iterator__ex2g4s = $this.rlj_1.k();
    while (_iterator__ex2g4s.l()) {
      var trait = _iterator__ex2g4s.m();
      trait.ylm($this);
    }
    var children = $this.slj_1;
    if (!(children == null)) {
      var _iterator__ex2g4s_0 = children.k();
      while (_iterator__ex2g4s_0.l()) {
        var child = _iterator__ex2g4s_0.m();
        afterAttach(get_asBaseCell(child));
      }
    }
  }
  function beforeDetach($this, root) {
    var children = $this.slj_1;
    if (!(children == null)) {
      var _iterator__ex2g4s = children.k();
      while (_iterator__ex2g4s.l()) {
        var child = _iterator__ex2g4s.m();
        beforeDetach(get_asBaseCell(child), root);
      }
    }
    var _iterator__ex2g4s_0 = $this.rlj_1.k();
    while (_iterator__ex2g4s_0.l()) {
      var trait = _iterator__ex2g4s_0.m();
      trait.zlm($this, root);
    }
  }
  function beforePropertySet($this, prop, event) {
    if (isPopupProp(prop)) {
      var cellChangeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      var oldValue = cellChangeEvent.o2e_1;
      var value = cellChangeEvent.p2e_1;
      if (!(oldValue == null)) {
        if (!($this.llk() == null)) {
          get_asCellContainerInternal(ensureNotNull($this.llk())).aln(oldValue);
        }
        oldValue.bln(get_POPUP(), false);
        changeParent(get_asBaseCell(oldValue), null);
      }
      if (!(value == null)) {
        if (!($this.llk() == null)) {
          get_asCellContainerInternal(ensureNotNull($this.llk())).cln(value);
        }
        value.bln(get_POPUP(), true);
        changeParent(get_asBaseCell(value), $this);
      }
    }
  }
  function propertySet($this, prop, event) {
    if (isPopupProp(prop) && $this.qlc()) {
      var cellChangeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      var oldValue = cellChangeEvent.o2e_1;
      var value = cellChangeEvent.p2e_1;
      var tmp1_safe_receiver = oldValue == null ? null : get_asBaseCell(oldValue);
      if (tmp1_safe_receiver == null)
        null;
      else {
        detach$default(tmp1_safe_receiver);
      }
      var tmp3_safe_receiver = value == null ? null : get_asBaseCell(value);
      if (tmp3_safe_receiver == null)
        null;
      else {
        attach$default(tmp3_safe_receiver, ensureNotNull($this.llk()));
      }
    }
  }
  function changeParent($this, newParent) {
    var oldParent = $this.ulj_1;
    $this.ulj_1 = newParent;
    var listeners = $this.ylj_1;
    if (!(listeners == null)) {
      var event = new PropertyChangeEvent(oldParent, newParent);
      listeners.a28(BaseCell$changeParent$lambda(event));
    }
  }
  function ChildList_0($outer) {
    this.klk_1 = $outer;
    ObservableArrayList.call(this);
  }
  protoOf(ChildList_0).dln = function (index, item) {
    var event = new CollectionItemEvent(null, item, index, EventType_ADD_getInstance());
    if (this.klk_1.qlc()) {
      attach$default(get_asBaseCell(item), ensureNotNull(this.klk_1.llk()));
    }
    this.klk_1.olk(event);
    var tmp0_safe_receiver = this.klk_1.llk();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_asCellContainerInternal(tmp0_safe_receiver);
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.eln(this.klk_1, event);
    }
    var tmp2_safe_receiver = this.klk_1.ylj_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.a28(BaseCell$ChildList$onItemAdd$lambda(event));
    }
  };
  protoOf(ChildList_0).k28 = function (index, item) {
    return this.dln(index, (!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ChildList_0).fln = function (index, item) {
    var event = new CollectionItemEvent(item, null, index, EventType_REMOVE_getInstance());
    var tmp0_safe_receiver = this.klk_1.llk();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_asCellContainerInternal(tmp0_safe_receiver);
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.gln(this.klk_1, event);
    }
    var tmp2_safe_receiver = this.klk_1.ylj_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.a28(BaseCell$ChildList$onItemRemove$lambda(event));
    }
  };
  protoOf(ChildList_0).t28 = function (index, item) {
    return this.fln(index, (!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ChildList_0).hln = function (index, oldItem, newItem) {
    this.fln(index, oldItem);
    this.dln(index, newItem);
  };
  protoOf(ChildList_0).p28 = function (index, oldItem, newItem) {
    var tmp = (!(oldItem == null) ? isInterface(oldItem, Cell) : false) ? oldItem : THROW_CCE();
    return this.hln(index, tmp, (!(newItem == null) ? isInterface(newItem, Cell) : false) ? newItem : THROW_CCE());
  };
  protoOf(ChildList_0).iln = function (index, item) {
    protoOf(ObservableArrayList).e28.call(this, index, item);
    // Inline function 'kotlin.check' call
    if (!(item.yt() == null)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.ChildList.checkAdd.<anonymous>' call
      var message = "item.parent is not null: '" + toString_0(item.yt()) + "', item: '" + toString_1(item) + "', index: " + index;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!!this.klk_1.jkb()) {
      // Inline function 'jetbrains.ocelot.projectional.cell.ChildList.checkAdd.<anonymous>' call
      var message_0 = "adding '" + toString_1(item) + "' to a leaf cell ('" + this.klk_1.toString() + "')";
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  };
  protoOf(ChildList_0).e28 = function (index, item) {
    return this.iln(index, (!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ChildList_0).jln = function (index, item) {
    return attachItem(this, item, index - 1 | 0, index);
  };
  protoOf(ChildList_0).i28 = function (index, item) {
    return this.jln(index, (!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ChildList_0).kln = function (index, oldItem, newItem) {
    this.iln(index, newItem);
    this.g28(index, oldItem);
  };
  protoOf(ChildList_0).f28 = function (index, oldItem, newItem) {
    var tmp = (!(oldItem == null) ? isInterface(oldItem, Cell) : false) ? oldItem : THROW_CCE();
    return this.kln(index, tmp, (!(newItem == null) ? isInterface(newItem, Cell) : false) ? newItem : THROW_CCE());
  };
  protoOf(ChildList_0).lln = function (index, oldItem, newItem) {
    detachItem(this, oldItem, index);
    attachItem(this, newItem, index - 1 | 0, index + 1 | 0);
  };
  protoOf(ChildList_0).n28 = function (index, oldItem, newItem) {
    var tmp = (!(oldItem == null) ? isInterface(oldItem, Cell) : false) ? oldItem : THROW_CCE();
    return this.lln(index, tmp, (!(newItem == null) ? isInterface(newItem, Cell) : false) ? newItem : THROW_CCE());
  };
  protoOf(ChildList_0).mln = function (index, item) {
    return detachItem(this, item, index);
  };
  protoOf(ChildList_0).s28 = function (index, item) {
    return this.mln(index, (!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  function ExternalChildList($outer) {
    this.rlk_1 = $outer;
    AbstractMutableList.call(this);
  }
  protoOf(ExternalChildList).n = function () {
    var tmp0_safe_receiver = this.rlk_1.slj_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ExternalChildList).q = function (index) {
    if (this.rlk_1.slj_1 == null) {
      throw CollectionIndexOutOfBoundsException_init_$Create$();
    }
    return ensureNotNull(this.rlk_1.slj_1).q(index);
  };
  protoOf(ExternalChildList).nln = function (index, element) {
    if (this.rlk_1.slj_1 == null) {
      throw CollectionIndexOutOfBoundsException_init_$Create$();
    }
    return ensureNotNull(this.rlk_1.slj_1).o2(index, element);
  };
  protoOf(ExternalChildList).o2 = function (index, element) {
    return this.nln(index, (!(element == null) ? isInterface(element, Cell) : false) ? element : THROW_CCE());
  };
  protoOf(ExternalChildList).oln = function (index, element) {
    ensureChildrenInitialized(this);
    ensureNotNull(this.rlk_1.slj_1).p2(index, element);
  };
  protoOf(ExternalChildList).p2 = function (index, element) {
    return this.oln(index, (!(element == null) ? isInterface(element, Cell) : false) ? element : THROW_CCE());
  };
  protoOf(ExternalChildList).q2 = function (index) {
    if (this.rlk_1.slj_1 == null) {
      throw CollectionIndexOutOfBoundsException_init_$Create$();
    }
    var result = ensureNotNull(this.rlk_1.slj_1).q2(index);
    if (ensureNotNull(this.rlk_1.slj_1).p()) {
      this.rlk_1.slj_1 = null;
    }
    return result;
  };
  protoOf(ExternalChildList).pln = function (listener) {
    var cellListener = new BaseCell$ExternalChildList$addListener$cellListener$1(listener);
    return this.rlk_1.qln(cellListener);
  };
  protoOf(ExternalChildList).n27 = function (listener) {
    return this.pln(listener);
  };
  protoOf(ExternalChildList).rln = function (handler) {
    var listener = new BaseCell$ExternalChildList$addHandler$listener$1(handler);
    return this.pln(listener);
  };
  protoOf(ExternalChildList).o27 = function (handler) {
    return this.rln(handler);
  };
  function Companion_265() {
  }
  var Companion_instance_265;
  function Companion_getInstance_265() {
    return Companion_instance_265;
  }
  function BaseCell$addTrait$$inlined$toDisposable$1(this$0, $trait) {
    this.sln_1 = this$0;
    this.tln_1 = $trait;
  }
  protoOf(BaseCell$addTrait$$inlined$toDisposable$1).vr = function () {
    this.sln_1.rlj_1.so(this.tln_1);
    this.tln_1.uln(this.sln_1);
    return Unit_instance;
  };
  function BaseCell$cellContainer$1(this$0) {
    this.vln_1 = this$0;
  }
  protoOf(BaseCell$cellContainer$1).l2c = function () {
    return 'cell.cellContainer';
  };
  protoOf(BaseCell$cellContainer$1).qr = function () {
    return this.vln_1.llk();
  };
  protoOf(BaseCell$cellContainer$1).wln = function (handler) {
    var cellListener = new BaseCell$cellContainer$1$addHandler$cellListener$1(handler);
    return this.vln_1.qln(cellListener);
  };
  protoOf(BaseCell$cellContainer$1).o27 = function (handler) {
    return this.wln(handler);
  };
  function BaseCell$set$$inlined$toDisposable$1(this$0, $prop, $old) {
    this.xln_1 = this$0;
    this.yln_1 = $prop;
    this.zln_1 = $old;
  }
  protoOf(BaseCell$set$$inlined$toDisposable$1).vr = function () {
    this.xln_1.bln(this.yln_1, this.zln_1);
    return Unit_instance;
  };
  function BaseCell$firePropertyChange$lambda($prop, $event) {
    return function (listener) {
      listener.tlk($prop, $event);
      return Unit_instance;
    };
  }
  function BaseCell$getProp$MyProperty(this$0, $cellPropSpec) {
    this.alo_1 = this$0;
    this.blo_1 = $cellPropSpec;
    BaseReadableProperty.call(this);
  }
  protoOf(BaseCell$getProp$MyProperty).l2c = function () {
    return this.alo_1.toString() + '.' + this.blo_1.toString();
  };
  protoOf(BaseCell$getProp$MyProperty).qr = function () {
    return this.alo_1.clo(this.blo_1);
  };
  protoOf(BaseCell$getProp$MyProperty).t2c = function (newValue) {
    this.alo_1.bln(this.blo_1, newValue);
  };
  protoOf(BaseCell$getProp$MyProperty).k2c = function (handler) {
    var cellListener = new BaseCell$getProp$MyProperty$addHandler$cellListener$1(this.blo_1, handler);
    return this.alo_1.qln(cellListener);
  };
  protoOf(BaseCell$getProp$MyProperty).o27 = function (handler) {
    return this.k2c(handler);
  };
  function BaseCell$attach$lambda($container) {
    return function (listener) {
      listener.vlk($container);
      return Unit_instance;
    };
  }
  function BaseCell$detach$lambda($container) {
    return function (listener) {
      listener.wlk($container);
      return Unit_instance;
    };
  }
  function BaseCell$changeParent$lambda($event) {
    return function (listener) {
      listener.ulk($event);
      return Unit_instance;
    };
  }
  function BaseCell$set$trait$1($traitPropSpec, $value) {
    this.dlo_1 = $traitPropSpec;
    this.elo_1 = $value;
    CellTrait.call(this);
  }
  protoOf(BaseCell$set$trait$1).flo = function (cell, spec) {
    var tmp;
    if (this.dlo_1 === spec) {
      tmp = this.elo_1;
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, this.dlo_1);
    }
    return tmp;
  };
  function BaseCell(cellContainer) {
    this.rlj_1 = Companion_instance_24.dq();
    this.slj_1 = null;
    this.tlj_1 = null;
    this.ulj_1 = null;
    this.vlj_1 = null;
    this.wlj_1 = null;
    this.xlj_1 = null;
    this.ylj_1 = null;
    if (!(cellContainer == null)) {
      attach$default(this, cellContainer);
    }
  }
  protoOf(BaseCell).llk = function () {
    return this.tlj_1;
  };
  protoOf(BaseCell).jkb = function () {
    return false;
  };
  protoOf(BaseCell).qlc = function () {
    return !(this.llk() == null);
  };
  protoOf(BaseCell).elp = function () {
    return this.flp(get_VISIBLE());
  };
  protoOf(BaseCell).glp = function () {
    return this.flp(get_FOCUS_HIGHLIGHTED());
  };
  protoOf(BaseCell).hlp = function () {
    return this.flp(get_FOCUSABLE());
  };
  protoOf(BaseCell).yt = function () {
    return this.ulj_1;
  };
  protoOf(BaseCell).g2r = function () {
    return this.ilp();
  };
  protoOf(BaseCell).ilp = function () {
    return new ExternalChildList(this);
  };
  protoOf(BaseCell).h2r = function () {
    return this.vlj_1;
  };
  protoOf(BaseCell).k2r = function () {
    return this.wlj_1;
  };
  protoOf(BaseCell).q2r = function () {
    var tmp0_safe_receiver = this.slj_1;
    return tmp0_safe_receiver == null ? null : first(tmp0_safe_receiver);
  };
  protoOf(BaseCell).r2r = function () {
    var tmp0_safe_receiver = this.slj_1;
    return tmp0_safe_receiver == null ? null : last(tmp0_safe_receiver);
  };
  protoOf(BaseCell).jlp = function (event, spec) {
    var ctx = Companion_instance_266.klp(this);
    event.nl0(ctx);
    dispatch_0(Companion_instance_265, ctx.llp_1, 0, event, spec);
  };
  protoOf(BaseCell).mlp = function (event, spec) {
    var ctx = Companion_instance_266.klp(this);
    event.nl0(ctx);
    dispatch_1(Companion_instance_265, ctx.llp_1, 0, event, spec);
  };
  protoOf(BaseCell).nlp = function (derivedEvent, spec) {
    var tmp = derivedEvent.cl1_1.ll0_1;
    var context = (tmp == null ? true : tmp instanceof CellEventContext) ? tmp : THROW_CCE();
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (context == null) {
        // Inline function 'jetbrains.ocelot.projectional.cell.BaseCell.dispatchDerived.<anonymous>' call
        var message = 'Event context is not found in ' + toString_1(derivedEvent.cl1_1);
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    derivedEvent.nl0(context);
    var path = context.llp_1;
    var start = path.t(this);
    // Inline function 'kotlin.check' call
    if (!!(start === -1)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.BaseCell.dispatchDerived.<anonymous>' call
      var message_0 = this.toString() + ' is not found in the bubbling path ' + toString_1(path);
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    dispatch_1(Companion_instance_265, path, start, derivedEvent, spec);
  };
  protoOf(BaseCell).olp = function (trait) {
    this.rlj_1.ro(trait);
    trait.glo(this);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new BaseCell$addTrait$$inlined$toDisposable$1(this, trait);
  };
  protoOf(BaseCell).plp = function () {
    return new BaseCell$cellContainer$1(this);
  };
  protoOf(BaseCell).qlp = function () {
    return this.flp(get_FOCUSED());
  };
  protoOf(BaseCell).ul5 = function () {
    // Inline function 'kotlin.check' call
    if (!canFocus(this)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.BaseCell.focus.<anonymous>' call
      var message = "this: '" + this.toString() + "', focusable: '" + this.hlp().m2c() + "', container: '" + toString_0(this.llk()) + "', visible: " + this.elp().m2c();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    ensureNotNull(this.llk()).rlp().t2c(this);
  };
  protoOf(BaseCell).slp = function (rectSupplier) {
    return get_peer(this).tlp(rectSupplier, this);
  };
  protoOf(BaseCell).qln = function (cellListener) {
    if (this.ylj_1 == null) {
      this.ylj_1 = new Listeners();
    }
    return ensureNotNull(this.ylj_1).z27(cellListener);
  };
  protoOf(BaseCell).clo = function (prop) {
    var properties = this.xlj_1;
    var tmp;
    if (properties == null || !properties.w2(prop)) {
      tmp = getDefaultValue(this, prop);
    } else {
      var tmp_0 = properties.y2(prop);
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(BaseCell).bln = function (prop, value) {
    var old = this.clo(prop);
    if (equals(value, old)) {
      return Companion_getInstance_25().wr_1;
    }
    var event = new PropertyChangeEvent(old, value);
    beforePropertySet(this, prop, event);
    if (equals(value, getDefaultValue(this, prop))) {
      ensureNotNull(this.xlj_1).s2(prop);
      if (ensureNotNull(this.xlj_1).np()) {
        this.xlj_1 = null;
      }
    } else {
      if (this.xlj_1 == null) {
        this.xlj_1 = new ListMap();
      }
      ensureNotNull(this.xlj_1).r2(prop, value);
    }
    firePropertyChange(this, prop, event);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new BaseCell$set$$inlined$toDisposable$1(this, prop, old);
  };
  protoOf(BaseCell).ulp = function (prop) {
    var tmp0_elvis_lhs = this.vlp(prop);
    return tmp0_elvis_lhs == null ? prop.ulm(this) : tmp0_elvis_lhs;
  };
  protoOf(BaseCell).vlp = function (prop) {
    var _iterator__ex2g4s = this.rlj_1.k();
    while (_iterator__ex2g4s.l()) {
      var trait = _iterator__ex2g4s.m();
      var result = trait.flo(this, prop);
      if (!(result == null)) {
        return (result == null ? true : !(result == null)) ? result : THROW_CCE();
      }
    }
    return null;
  };
  protoOf(BaseCell).flp = function (cellPropSpec) {
    return new BaseCell$getProp$MyProperty(this, cellPropSpec);
  };
  protoOf(BaseCell).wlm = function () {
    var properties = this.xlj_1;
    var tmp;
    if (properties == null) {
      tmp = emptyList();
    } else {
      var result = null;
      var _iterator__ex2g4s = get_POPUP_SPECS().k();
      while (_iterator__ex2g4s.l()) {
        var ps = _iterator__ex2g4s.m();
        var tmp_0 = properties.y2(ps);
        var cell = (tmp_0 == null ? true : isInterface(tmp_0, Cell)) ? tmp_0 : THROW_CCE();
        if (!(cell == null)) {
          if (result == null) {
            result = ArrayList_init_$Create$();
          }
          result.e(cell);
        }
      }
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_elvis_lhs = result;
      tmp = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(BaseCell).n3b = function () {
    var parent = this.ulj_1;
    // Inline function 'kotlin.checkNotNull' call
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (parent == null) {
        // Inline function 'kotlin.checkNotNull.<anonymous>' call
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var parentCell = get_asBaseCell(parent);
    if (!(parentCell.slj_1 == null) && ensureNotNull(parentCell.slj_1).s(this)) {
      parentCell.g2r().k2(this);
      return Unit_instance;
    }
    var _iterator__ex2g4s = get_POPUP_SPECS().k();
    while (_iterator__ex2g4s.l()) {
      var popupSpec = _iterator__ex2g4s.m();
      if (parentCell.clo(popupSpec) === this) {
        parentCell.bln(popupSpec, null);
        return Unit_instance;
      }
    }
    throw IllegalStateException_init_$Create$();
  };
  protoOf(BaseCell).plm = function (prop, event) {
  };
  protoOf(BaseCell).olk = function (event) {
  };
  protoOf(BaseCell).nlk = function (event) {
  };
  protoOf(BaseCell).ylp = function (traitPropSpec, value) {
    var trait = new BaseCell$set$trait$1(traitPropSpec, value);
    return this.olp(trait);
  };
  protoOf(BaseCell).toString = function () {
    var className = getKClassFromExpression(this).lb();
    return plus_10(className, '@') + toString_3(hashCode(this), 16);
  };
  function get_asBaseCell(_this__u8e3s4) {
    return _this__u8e3s4 instanceof BaseCell ? _this__u8e3s4 : THROW_CCE();
  }
  function get_asBaseCellInternal(_this__u8e3s4) {
    return isInterface(_this__u8e3s4, BaseCellInternal) ? _this__u8e3s4 : THROW_CCE();
  }
  function BaseCellInternal() {
  }
  function canFocus(_this__u8e3s4) {
    return _this__u8e3s4.hlp().m2c() && _this__u8e3s4.qlc() && _this__u8e3s4.elp().m2c();
  }
  function Cell() {
  }
  function get_EMPTY_CELL_ACTION() {
    _init_properties_CellAction_kt__xjo07s();
    return EMPTY_CELL_ACTION;
  }
  var EMPTY_CELL_ACTION;
  function seqActions(actions) {
    _init_properties_CellAction_kt__xjo07s();
    return seqActions$lambda(actions);
  }
  function EMPTY_CELL_ACTION$lambda() {
    _init_properties_CellAction_kt__xjo07s();
    return Unit_instance;
  }
  function seqActions$lambda($actions) {
    return function () {
      var indexedObject = $actions;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var action = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        action();
      }
      return Unit_instance;
    };
  }
  var properties_initialized_CellAction_kt_muc5ae;
  function _init_properties_CellAction_kt__xjo07s() {
    if (!properties_initialized_CellAction_kt_muc5ae) {
      properties_initialized_CellAction_kt_muc5ae = true;
      EMPTY_CELL_ACTION = EMPTY_CELL_ACTION$lambda;
    }
  }
  function get_asCellContainerInternal(_this__u8e3s4) {
    return isInterface(_this__u8e3s4, CellContainerInternal) ? _this__u8e3s4 : THROW_CCE();
  }
  function CellContainerInternal() {
  }
  function CellContainerListener() {
  }
  function CellContainerPeer() {
  }
  function Companion_266() {
  }
  protoOf(Companion_266).klp = function (source) {
    var path = toList_2(ancestorsFrom(source));
    return new CellEventContext(path);
  };
  var Companion_instance_266;
  function Companion_getInstance_266() {
    return Companion_instance_266;
  }
  function CellEventContext(bubblingPath) {
    this.llp_1 = bubblingPath;
  }
  function comes(_this__u8e3s4, from, to) {
    var tmp = _this__u8e3s4.ll0_1;
    var tmp0_elvis_lhs = (tmp == null ? true : tmp instanceof CellEventContext) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var context = tmp_0;
    var path = context.llp_1;
    var i = path.t(from);
    var j = path.t(to);
    return i >= 0 && j >= 0 && i < j;
  }
  function CellListener() {
  }
  function get_bounds(_this__u8e3s4) {
    return get_peer(_this__u8e3s4).ilq(_this__u8e3s4);
  }
  function get_peer(_this__u8e3s4) {
    var container = _this__u8e3s4.llk();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (container == null) {
        // Inline function 'jetbrains.ocelot.projectional.cell.<get-peer>.<anonymous>' call
        var message = 'Cell ' + toString_1(_this__u8e3s4) + ' is not attached to cell container';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return container.olq();
  }
  function get_origin_0(_this__u8e3s4) {
    return get_bounds(_this__u8e3s4).cku_1;
  }
  function get_dimension(_this__u8e3s4) {
    return get_bounds(_this__u8e3s4).dku_1;
  }
  function CellPropertySpec_init_$Init$(name, defaultValue, $this) {
    CellPropertySpec.call($this, name, CellPropertySpec$_init_$lambda_vr6ec9(defaultValue));
    return $this;
  }
  function CellPropertySpec_init_$Create$(name, defaultValue) {
    return CellPropertySpec_init_$Init$(name, defaultValue, objectCreate(protoOf(CellPropertySpec)));
  }
  function CellPropertySpec$_init_$lambda_vr6ec9($defaultValue) {
    return function (it) {
      return $defaultValue;
    };
  }
  function CellPropertySpec(name, defaultValueFun) {
    this.slm_1 = name;
    this.tlm_1 = defaultValueFun;
  }
  protoOf(CellPropertySpec).toString = function () {
    return this.slm_1;
  };
  protoOf(CellPropertySpec).ulm = function (cell) {
    return this.tlm_1(cell);
  };
  function get_POPUP_Z_ADJUSTMENT() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return POPUP_Z_ADJUSTMENT;
  }
  var POPUP_Z_ADJUSTMENT;
  function get_POPUP_X_POSITION() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return POPUP_X_POSITION;
  }
  var POPUP_X_POSITION;
  function get_HAS_POPUP_DECORATION() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return HAS_POPUP_DECORATION;
  }
  var HAS_POPUP_DECORATION;
  function get_HOVERED() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return HOVERED;
  }
  var HOVERED;
  function get_FOCUSED() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return FOCUSED;
  }
  var FOCUSED;
  function get_VISIBLE() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return VISIBLE;
  }
  var VISIBLE;
  function get_SELECTED() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return SELECTED;
  }
  var SELECTED;
  function get_FOCUS_HIGHLIGHTED() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return FOCUS_HIGHLIGHTED;
  }
  var FOCUS_HIGHLIGHTED;
  function get_PAIR_HIGHLIGHTED() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return PAIR_HIGHLIGHTED;
  }
  var PAIR_HIGHLIGHTED;
  function get_FOCUSABLE() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return FOCUSABLE;
  }
  var FOCUSABLE;
  function get_BACKGROUND() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return BACKGROUND;
  }
  var BACKGROUND;
  function get_BORDER() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return BORDER;
  }
  var BORDER;
  function get_HAS_SHADOW() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return HAS_SHADOW;
  }
  var HAS_SHADOW;
  function get_RED_UNDERLINE() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return RED_UNDERLINE;
  }
  var RED_UNDERLINE;
  function get_YELLOW_UNDERLINE() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return YELLOW_UNDERLINE;
  }
  var YELLOW_UNDERLINE;
  function get_LINK() {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return LINK;
  }
  var LINK;
  function get_hasShadow(_this__u8e3s4) {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return _this__u8e3s4.flp(get_HAS_SHADOW());
  }
  function get_border(_this__u8e3s4) {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return _this__u8e3s4.flp(get_BORDER());
  }
  function get_background(_this__u8e3s4) {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return _this__u8e3s4.flp(get_BACKGROUND());
  }
  function get_selected(_this__u8e3s4) {
    _init_properties_CellPropertySpecs_kt__dnqpvz();
    return _this__u8e3s4.flp(get_SELECTED());
  }
  var properties_initialized_CellPropertySpecs_kt_q8gzf5;
  function _init_properties_CellPropertySpecs_kt__dnqpvz() {
    if (!properties_initialized_CellPropertySpecs_kt_q8gzf5) {
      properties_initialized_CellPropertySpecs_kt_q8gzf5 = true;
      POPUP_Z_ADJUSTMENT = CellPropertySpec_init_$Create$('popupZ', 0);
      POPUP_X_POSITION = CellPropertySpec_init_$Create$('popupXPosition', 0);
      HAS_POPUP_DECORATION = CellPropertySpec_init_$Create$('popupDecoration', false);
      HOVERED = CellPropertySpec_init_$Create$('hovered', false);
      FOCUSED = CellPropertySpec_init_$Create$('focused', false);
      VISIBLE = CellPropertySpec_init_$Create$('visible', true);
      SELECTED = CellPropertySpec_init_$Create$('selected', false);
      FOCUS_HIGHLIGHTED = CellPropertySpec_init_$Create$('focusHighlighted', false);
      PAIR_HIGHLIGHTED = CellPropertySpec_init_$Create$('pairHighlighted', false);
      FOCUSABLE = CellPropertySpec_init_$Create$('focusable', false);
      BACKGROUND = CellPropertySpec_init_$Create$('background', null);
      BORDER = CellPropertySpec_init_$Create$('border', null);
      HAS_SHADOW = CellPropertySpec_init_$Create$('hasShadow', false);
      RED_UNDERLINE = CellPropertySpec_init_$Create$('redUnderline', false);
      YELLOW_UNDERLINE = CellPropertySpec_init_$Create$('yellowUnderline', false);
      LINK = CellPropertySpec_init_$Create$('link', false);
    }
  }
  function isDescendantCellFocused(_this__u8e3s4) {
    var cellContainer = _this__u8e3s4.llk();
    var tmp;
    if (cellContainer == null) {
      tmp = false;
    } else {
      var focusedCell = cellContainer.rlp().qr();
      tmp = (!(focusedCell == null) && isDescendant(_this__u8e3s4, focusedCell));
    }
    return tmp;
  }
  function Hints() {
    Hints_instance = this;
    this.plq_1 = CellTraitPropertySpec_init_$Create$('hideOutOfViewportHint', false);
  }
  var Hints_instance;
  function Hints_getInstance() {
    if (Hints_instance == null)
      new Hints();
    return Hints_instance;
  }
  function HorizontalCell() {
    LayoutCell.call(this);
  }
  function Companion_267() {
    Companion_instance_267 = this;
    this.alr_1 = CellPropertySpec_init_$Create$('crossAlignment', Alignment_STRETCH_getInstance());
    this.blr_1 = CellPropertySpec_init_$Create$('itemAlignment', Alignment_STRETCH_getInstance());
    this.clr_1 = CellPropertySpec_init_$Create$('flexWrap', false);
    this.dlr_1 = CellPropertySpec_init_$Create$('justifyContent', false);
  }
  var Companion_instance_267;
  function Companion_getInstance_267() {
    if (Companion_instance_267 == null)
      new Companion_267();
    return Companion_instance_267;
  }
  function LayoutCell() {
    Companion_getInstance_267();
    BaseCell_init_$Init$(this);
  }
  protoOf(LayoutCell).ylq = function () {
    return this.flp(Companion_getInstance_267().alr_1);
  };
  protoOf(LayoutCell).zlq = function () {
    return this.flp(Companion_getInstance_267().dlr_1);
  };
  function get_itemAlignment(_this__u8e3s4) {
    return _this__u8e3s4.flp(Companion_getInstance_267().blr_1);
  }
  function Companion_268() {
    Companion_instance_268 = this;
    this.elr_1 = CellTraitPropertySpec_init_$Create$('popupSpec', null);
  }
  var Companion_instance_268;
  function Companion_getInstance_268() {
    if (Companion_instance_268 == null)
      new Companion_268();
    return Companion_instance_268;
  }
  function PopupSpec() {
  }
  function get_isRootCell(_this__u8e3s4) {
    var cell = _this__u8e3s4;
    var container = cell == null ? null : cell.llk();
    return !(container == null) && equals(container.u3o(), cell);
  }
  function scrollDown($this, cell) {
    return scroll($this, cell, 1);
  }
  function scrollUp($this, cell) {
    return scroll($this, cell, -1);
  }
  function scroll($this, cell, direction) {
    if (!cell.clo(Companion_getInstance_270().llr_1)) {
      return false;
    }
    var scroll = get_peer(cell).jlq(cell);
    get_peer(cell).klq(cell, new Vector(0, scroll.fku_1 + imul(direction, get_dimension(cell).fku_1) | 0));
    return true;
  }
  function doAdjustDimension($this, scrollCell, dimension, viewport) {
    var dimLimit = scrollCell.clo(Companion_getInstance_270().jlr_1);
    var widthLimit = dimLimit.eku_1;
    var heightLimit = dimLimit.fku_1;
    var width = dimension.eku_1;
    var height = dimension.fku_1;
    var changeDimension = false;
    if (height > heightLimit) {
      height = heightLimit;
      changeDimension = true;
    }
    if (width > widthLimit) {
      width = widthLimit;
      changeDimension = true;
    }
    var changeMaxDimension = false;
    if (viewport.fku_1 < height) {
      heightLimit = viewport.fku_1;
      height = viewport.fku_1;
      changeMaxDimension = true;
    }
    if (viewport.eku_1 < width) {
      widthLimit = viewport.eku_1;
      width = viewport.eku_1;
      changeMaxDimension = true;
    }
    var tmp;
    if (changeMaxDimension) {
      setMaxDimension($this, scrollCell, new Vector(widthLimit, heightLimit));
      tmp = new Vector(width, height);
    } else {
      relaxMaxDimension($this, scrollCell, viewport);
      var tmp_0;
      if (changeDimension) {
        tmp_0 = new Vector(width, height);
      } else {
        tmp_0 = dimension;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function setMaxDimension($this, cell, newValue) {
    if (cell.clo(Companion_getInstance_269().nlr_1) == null) {
      cell.bln(Companion_getInstance_269().nlr_1, cell.clo(Companion_getInstance_270().jlr_1));
    }
    cell.bln(Companion_getInstance_270().jlr_1, newValue);
  }
  function relaxMaxDimension($this, cell, viewport) {
    var tmp0_elvis_lhs = cell.clo(Companion_getInstance_269().nlr_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var originalMaxDimension = tmp;
    if (originalMaxDimension.eku_1 <= viewport.eku_1 && originalMaxDimension.fku_1 <= viewport.fku_1) {
      cell.bln(Companion_getInstance_269().nlr_1, null);
      cell.bln(Companion_getInstance_270().jlr_1, originalMaxDimension);
    } else {
      var tmp0 = originalMaxDimension.eku_1;
      // Inline function 'kotlin.math.min' call
      var b = viewport.eku_1;
      var w = Math.min(tmp0, b);
      var tmp2 = originalMaxDimension.fku_1;
      // Inline function 'kotlin.math.min' call
      var b_0 = viewport.fku_1;
      var h = Math.min(tmp2, b_0);
      cell.bln(Companion_getInstance_270().jlr_1, new Vector(w, h));
    }
  }
  function Companion_269() {
    Companion_instance_269 = this;
    this.nlr_1 = CellPropertySpec_init_$Create$('originalMaxDimension', null);
  }
  var Companion_instance_269;
  function Companion_getInstance_269() {
    if (Companion_instance_269 == null)
      new Companion_269();
    return Companion_instance_269;
  }
  function adjustScroll($this, dimension) {
    var content = $this.q2r();
    if (!(content == null)) {
      var contentDim = get_dimension(content);
      var scroll = contentDim.fku_1 > dimension.fku_1 || contentDim.eku_1 > dimension.eku_1;
      $this.bln(Companion_getInstance_270().llr_1, scroll);
    }
  }
  function ScrollTrait() {
    CellTrait.call(this);
    this.olr_1 = new ScrollPopupSpec();
  }
  protoOf(ScrollTrait).flo = function (cell, spec) {
    var tmp;
    if (spec === Companion_getInstance_268().elr_1) {
      tmp = this.olr_1;
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  protoOf(ScrollTrait).llm = function (cell, event) {
    if (event.ml1(Key_PAGE_DOWN_getInstance(), [])) {
      if (scrollDown(this, cell)) {
        event.ol0();
        return Unit_instance;
      }
    } else if (event.ml1(Key_PAGE_UP_getInstance(), [])) {
      if (scrollUp(this, cell)) {
        event.ol0();
        return Unit_instance;
      }
    }
    protoOf(CellTrait).llm.call(this, cell, event);
  };
  function ScrollPopupSpec() {
    Companion_getInstance_269();
  }
  protoOf(ScrollPopupSpec).ilr = function (cell) {
    return false;
  };
  protoOf(ScrollPopupSpec).hlr = function (cell, popup) {
  };
  protoOf(ScrollPopupSpec).glr = function (cell, dimension, viewport, alignedWidth) {
    var scrollCell = cell instanceof ScrollCell ? cell : THROW_CCE();
    var adjustedDim = doAdjustDimension(this, scrollCell, dimension, viewport);
    adjustScroll(scrollCell, adjustedDim);
    return adjustedDim;
  };
  function Companion_270() {
    Companion_instance_270 = this;
    this.jlr_1 = CellPropertySpec_init_$Create$('maxDimension', Companion_getInstance_251().iku_1);
    this.klr_1 = CellPropertySpec_init_$Create$('scrollRoot', false);
    this.llr_1 = CellPropertySpec_init_$Create$('hasVerticalScroll', false);
    this.mlr_1 = new ScrollTrait();
  }
  var Companion_instance_270;
  function Companion_getInstance_270() {
    if (Companion_instance_270 == null)
      new Companion_270();
    return Companion_instance_270;
  }
  function ScrollCell() {
    Companion_getInstance_270();
    BaseCell_init_$Init$(this);
    this.olp(Companion_getInstance_270().mlr_1);
  }
  protoOf(ScrollCell).xlr = function () {
    return this.flp(Companion_getInstance_270().jlr_1);
  };
  protoOf(ScrollCell).ylr = function () {
    return this.flp(Companion_getInstance_270().llr_1);
  };
  function scrollToAsync(_this__u8e3s4) {
    return _this__u8e3s4.slp(scrollToAsync$lambda(_this__u8e3s4));
  }
  function scrollTo_0(_this__u8e3s4) {
    return scrollTo_1(_this__u8e3s4, scrollTo$lambda(_this__u8e3s4));
  }
  function scrollTo_1(_this__u8e3s4, rectSupplier) {
    return get_peer(_this__u8e3s4).llq(rectSupplier, _this__u8e3s4);
  }
  function scrollTo_2(_this__u8e3s4, rect) {
    return scrollTo_1(_this__u8e3s4, scrollTo$lambda_0(rect));
  }
  function scrollToAsync$lambda($this_scrollToAsync) {
    return function () {
      return new Rectangle(Companion_getInstance_251().iku_1, get_dimension($this_scrollToAsync));
    };
  }
  function scrollTo$lambda($this_scrollTo) {
    return function () {
      return new Rectangle(Companion_getInstance_251().iku_1, get_dimension($this_scrollTo));
    };
  }
  function scrollTo$lambda_0($rect) {
    return function () {
      return $rect;
    };
  }
  function TextCell$Companion$SELECTION_END$lambda(cell) {
    return cell.clo(Companion_getInstance_271().dls_1);
  }
  function TextCell_init_$Init$($this) {
    BaseCell_init_$Init$($this);
    TextCell.call($this);
    return $this;
  }
  function TextCell_init_$Create$() {
    return TextCell_init_$Init$(objectCreate(protoOf(TextCell)));
  }
  function TextCell_init_$Init$_0(text, $this) {
    BaseCell_init_$Init$($this);
    TextCell.call($this);
    $this.laz().t2c(text);
    return $this;
  }
  function TextCell_init_$Create$_0(text) {
    return TextCell_init_$Init$_0(text, objectCreate(protoOf(TextCell)));
  }
  function Selection(from, to) {
    this.nls_1 = from;
    this.ols_1 = to;
  }
  function Companion_271() {
    Companion_instance_271 = this;
    this.zlr_1 = new Font(Companion_getInstance_326().pls_1, 14);
    this.als_1 = CellPropertySpec_init_$Create$('text', '');
    this.bls_1 = CellPropertySpec_init_$Create$('textColor', Companion_getInstance_325().uls_1);
    this.cls_1 = CellPropertySpec_init_$Create$('caretVisible', false);
    this.dls_1 = CellPropertySpec_init_$Create$('caretPosition', 0);
    this.els_1 = CellPropertySpec_init_$Create$('fontFamily', this.zlr_1.ult_1);
    this.fls_1 = CellPropertySpec_init_$Create$('bold', this.zlr_1.wlt_1);
    this.gls_1 = CellPropertySpec_init_$Create$('italic', this.zlr_1.xlt_1);
    this.hls_1 = CellPropertySpec_init_$Create$('fontSize', this.zlr_1.vlt_1);
    this.ils_1 = CellPropertySpec_init_$Create$('selectionVisible', false);
    this.jls_1 = CellPropertySpec_init_$Create$('selectionStart', 0);
    var tmp = this;
    tmp.kls_1 = new CellPropertySpec('selectionEnd', TextCell$Companion$SELECTION_END$lambda);
    this.lls_1 = CellPropertySpec_init_$Create$('textDecorations', emptySet());
    this.mls_1 = CellPropertySpec_init_$Create$('textStyleRegions', emptyList());
  }
  var Companion_instance_271;
  function Companion_getInstance_271() {
    if (Companion_instance_271 == null)
      new Companion_271();
    return Companion_instance_271;
  }
  protoOf(TextCell).jkb = function () {
    return true;
  };
  protoOf(TextCell).ylt = function () {
    var text = this.laz().qr();
    return take_1(text, this.zlt().qr());
  };
  protoOf(TextCell).alu = function () {
    var text = this.laz().qr();
    // Inline function 'kotlin.text.substring' call
    var startIndex = this.zlt().qr();
    // Inline function 'kotlin.js.asDynamic' call
    return text.substring(startIndex);
  };
  protoOf(TextCell).blu = function () {
    return this.zlt().qr() === this.clu();
  };
  protoOf(TextCell).dlu = function () {
    return this.zlt().qr() === 0;
  };
  protoOf(TextCell).np = function () {
    return this.clu() === 0;
  };
  protoOf(TextCell).elu = function () {
    var offset = this.flu(this.zlt().qr());
    return Rectangle_init_$Create$(offset, 0, 0, get_dimension(this).fku_1).jku(get_origin_0(this));
  };
  protoOf(TextCell).glu = function () {
    var start = this.clo(Companion_getInstance_271().jls_1);
    var end = this.clo(Companion_getInstance_271().kls_1);
    // Inline function 'kotlin.math.min' call
    var from = Math.min(start, end);
    // Inline function 'kotlin.math.max' call
    var to = Math.max(start, end);
    return new Selection(from, to);
  };
  protoOf(TextCell).laz = function () {
    return this.flp(Companion_getInstance_271().als_1);
  };
  protoOf(TextCell).hlu = function () {
    return this.flp(Companion_getInstance_271().bls_1);
  };
  protoOf(TextCell).ilu = function () {
    return this.flp(Companion_getInstance_271().cls_1);
  };
  protoOf(TextCell).jlu = function () {
    return this.flp(Companion_getInstance_271().fls_1);
  };
  protoOf(TextCell).klu = function () {
    return this.flp(Companion_getInstance_271().gls_1);
  };
  protoOf(TextCell).llu = function () {
    return this.flp(Companion_getInstance_271().els_1);
  };
  protoOf(TextCell).mlu = function () {
    return this.flp(Companion_getInstance_271().hls_1);
  };
  protoOf(TextCell).zlt = function () {
    return this.flp(Companion_getInstance_271().dls_1);
  };
  protoOf(TextCell).nlu = function () {
    return this.flp(Companion_getInstance_271().ils_1);
  };
  protoOf(TextCell).olu = function () {
    return this.flp(Companion_getInstance_271().jls_1);
  };
  protoOf(TextCell).plu = function () {
    return this.flp(Companion_getInstance_271().kls_1);
  };
  protoOf(TextCell).qlu = function () {
    return this.flp(Companion_getInstance_271().lls_1);
  };
  protoOf(TextCell).rlu = function () {
    return this.flp(Companion_getInstance_271().mls_1);
  };
  protoOf(TextCell).clu = function () {
    return this.laz().qr().length;
  };
  protoOf(TextCell).slu = function (x) {
    return get_peer(this).glq(this, x);
  };
  protoOf(TextCell).flu = function (caret) {
    return get_peer(this).hlq(this, caret);
  };
  protoOf(TextCell).toString = function () {
    var value = this.laz().qr();
    var hashCodeStr = toString_3(hashCode(this), 16);
    return "TextCell('" + value + "')@" + hashCodeStr;
  };
  function TextCell() {
    Companion_getInstance_271();
  }
  function Companion_272() {
    Companion_instance_272 = this;
    this.tlu_1 = CellPropertySpec_init_$Create$('widthChars', 0);
    this.ulu_1 = CellPropertySpec_init_$Create$('heightLines', 0);
  }
  var Companion_instance_272;
  function Companion_getInstance_272() {
    if (Companion_instance_272 == null)
      new Companion_272();
    return Companion_instance_272;
  }
  function TextPlaceholderCell() {
    Companion_getInstance_272();
    BaseCell_init_$Init$(this);
  }
  protoOf(TextPlaceholderCell).dlv = function () {
    return this.flp(Companion_getInstance_272().tlu_1);
  };
  protoOf(TextPlaceholderCell).elv = function () {
    return this.flp(Companion_getInstance_272().ulu_1);
  };
  function Companion_273() {
    Companion_instance_273 = this;
    this.flv_1 = CellPropertySpec_init_$Create$('indented', false);
  }
  var Companion_instance_273;
  function Companion_getInstance_273() {
    if (Companion_instance_273 == null)
      new Companion_273();
    return Companion_instance_273;
  }
  function VerticalCell() {
    Companion_getInstance_273();
    LayoutCell.call(this);
  }
  protoOf(VerticalCell).olv = function () {
    return this.flp(Companion_getInstance_273().flv_1);
  };
  function workStarted_0(_this__u8e3s4, $this) {
    var tmp0_safe_receiver = _this__u8e3s4.llk();
    if (tmp0_safe_receiver == null)
      null;
    else {
      notifyStart(tmp0_safe_receiver, $this);
    }
    listenForAttachDetach(_this__u8e3s4, $this);
  }
  function workFinished_0(_this__u8e3s4, $this) {
    ensureNotNull(_this__u8e3s4.clo($this.rlv_1)).vr();
    _this__u8e3s4.bln($this.rlv_1, null);
    var tmp0_safe_receiver = _this__u8e3s4.llk();
    if (tmp0_safe_receiver == null)
      null;
    else {
      notifyFinish(tmp0_safe_receiver, $this);
    }
    var tmp1_safe_receiver = _this__u8e3s4.clo($this.qlv_1);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp1_safe_receiver.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.cell.async.AmountOfWorkInProgress.workFinished.<anonymous>' call
        element();
      }
    }
    _this__u8e3s4.bln($this.qlv_1, null);
  }
  function listenForAttachDetach(_this__u8e3s4, $this) {
    var tmp = _this__u8e3s4.plp();
    _this__u8e3s4.bln($this.rlv_1, tmp.p27(AmountOfWorkInProgress$listenForAttachDetach$lambda));
  }
  function notifyStart(_this__u8e3s4, $this) {
    return AsyncWorkNotifier_getInstance().ulv(_this__u8e3s4);
  }
  function notifyFinish(_this__u8e3s4, $this) {
    return AsyncWorkNotifier_getInstance().vlv(_this__u8e3s4);
  }
  function AmountOfWorkInProgress$listenForAttachDetach$lambda(event) {
    var tmp0_safe_receiver = event.o2e_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      notifyFinish(tmp0_safe_receiver, AmountOfWorkInProgress_getInstance());
    }
    var tmp1_safe_receiver = event.p2e_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      notifyStart(tmp1_safe_receiver, AmountOfWorkInProgress_getInstance());
    }
    return Unit_instance;
  }
  function AmountOfWorkInProgress() {
    AmountOfWorkInProgress_instance = this;
    this.plv_1 = CellPropertySpec_init_$Create$('numberOfActivities', 0);
    this.qlv_1 = CellPropertySpec_init_$Create$('readyActions', null);
    this.rlv_1 = CellPropertySpec_init_$Create$('attachListener', null);
  }
  protoOf(AmountOfWorkInProgress).wlv = function (cell) {
    var num = cell.clo(this.plv_1);
    if (num === 0) {
      workStarted_0(cell, this);
    }
    num = num + 1 | 0;
    cell.bln(this.plv_1, num);
  };
  protoOf(AmountOfWorkInProgress).xlv = function (cell) {
    var num = cell.clo(this.plv_1);
    // Inline function 'kotlin.check' call
    if (!!(num === 0)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    num = num - 1 | 0;
    cell.bln(this.plv_1, num);
    if (num === 0) {
      workFinished_0(cell, this);
    }
  };
  protoOf(AmountOfWorkInProgress).ylv = function (cell) {
    return cell.clo(this.plv_1) > 0;
  };
  protoOf(AmountOfWorkInProgress).zlv = function (cell, action) {
    // Inline function 'kotlin.check' call
    if (!this.ylv(cell)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.async.AmountOfWorkInProgress.whenReady.<anonymous>' call
      var message = 'whenReady() must be called only when cell has work in progress';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp0_elvis_lhs = cell.clo(this.qlv_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayList_init_$Create$();
      // Inline function 'jetbrains.ocelot.projectional.cell.async.AmountOfWorkInProgress.whenReady.<anonymous>' call
      cell.bln(AmountOfWorkInProgress_getInstance().qlv_1, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    list.e(action);
  };
  var AmountOfWorkInProgress_instance;
  function AmountOfWorkInProgress_getInstance() {
    if (AmountOfWorkInProgress_instance == null)
      new AmountOfWorkInProgress();
    return AmountOfWorkInProgress_instance;
  }
  function waitForAsyncWork(_this__u8e3s4, $completion) {
    var done = CompletableDeferred();
    onAsyncWorkDone(_this__u8e3s4, waitForAsyncWork$lambda(done));
    return done.gw($completion);
  }
  function onAsyncWorkDone(_this__u8e3s4, block) {
    if (!AsyncWorkNotifier_getInstance().alw(_this__u8e3s4)) {
      block();
      return Unit_instance;
    }
    var d = {_v: null};
    var tmp = AsyncWorkNotifier_getInstance();
    d._v = tmp.blw(_this__u8e3s4, new onAsyncWorkDone$1(block, d));
  }
  function workInProgress($this, cell) {
    return cell.clo($this.tlv_1) > 0;
  }
  function addListener($this, cell, listener) {
    var tmp0_elvis_lhs = cell.clo($this.slv_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new OurListeners(cell);
      // Inline function 'jetbrains.ocelot.projectional.cell.async.AsyncWorkNotifier.addListener.<anonymous>' call
      cell.bln(AsyncWorkNotifier_getInstance().slv_1, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var listeners = tmp;
    return listeners.z27(listener);
  }
  function inc($this, cell) {
    var num = cell.clo($this.tlv_1);
    if (num === 0) {
      fire_3(cell, $this, AsyncWorkNotifier$inc$lambda);
    }
    num = num + 1 | 0;
    cell.bln($this.tlv_1, num);
  }
  function dec($this, cell) {
    var num = cell.clo($this.tlv_1);
    // Inline function 'kotlin.check' call
    if (!!(num === 0)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    num = num - 1 | 0;
    cell.bln($this.tlv_1, num);
    if (num === 0) {
      fire_3(cell, $this, AsyncWorkNotifier$dec$lambda);
    }
  }
  function fire_3(_this__u8e3s4, $this, h) {
    var tmp0_safe_receiver = _this__u8e3s4.clo($this.slv_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.cell.async.AsyncWorkNotifier.fire.<anonymous>' call
      tmp0_safe_receiver.a28(AsyncWorkNotifier$fire$lambda(h));
    }
  }
  function OurListeners(cell) {
    Listeners.call(this);
    this.dlw_1 = cell;
  }
  protoOf(OurListeners).w27 = function () {
    this.dlw_1.bln(AsyncWorkNotifier_getInstance().slv_1, null);
    protoOf(Listeners).w27.call(this);
  };
  function AsyncWorkNotifier$inc$lambda(it) {
    it.e2m();
    return Unit_instance;
  }
  function AsyncWorkNotifier$dec$lambda(it) {
    it.f2m();
    return Unit_instance;
  }
  function AsyncWorkNotifier$fire$lambda($h) {
    return function (listener) {
      $h(listener);
      return Unit_instance;
    };
  }
  function AsyncWorkNotifier() {
    AsyncWorkNotifier_instance = this;
    this.slv_1 = CellPropertySpec_init_$Create$('workListeners', null);
    this.tlv_1 = CellPropertySpec_init_$Create$('count', 0);
  }
  protoOf(AsyncWorkNotifier).alw = function (cellContainer) {
    return workInProgress(this, cellContainer.u3o());
  };
  protoOf(AsyncWorkNotifier).blw = function (cellContainer, listener) {
    return addListener(this, cellContainer.u3o(), listener);
  };
  protoOf(AsyncWorkNotifier).ulv = function (cellContainer) {
    return inc(this, cellContainer.u3o());
  };
  protoOf(AsyncWorkNotifier).vlv = function (cellContainer) {
    return dec(this, cellContainer.u3o());
  };
  var AsyncWorkNotifier_instance;
  function AsyncWorkNotifier_getInstance() {
    if (AsyncWorkNotifier_instance == null)
      new AsyncWorkNotifier();
    return AsyncWorkNotifier_instance;
  }
  function waitForAsyncWork$lambda($done) {
    return function () {
      $done.lz(Unit_instance);
      return Unit_instance;
    };
  }
  function onAsyncWorkDone$1($block, $d) {
    this.elw_1 = $block;
    this.flw_1 = $d;
  }
  protoOf(onAsyncWorkDone$1).f2m = function () {
    this.elw_1();
    var tmp;
    if (this.flw_1._v == null) {
      throwUninitializedPropertyAccessException('d');
    } else {
      tmp = this.flw_1._v;
    }
    tmp.vr();
  };
  function CellAsyncTracker(cell) {
    this.glw_1 = cell;
  }
  protoOf(CellAsyncTracker).e2m = function () {
    return AmountOfWorkInProgress_getInstance().wlv(this.glw_1);
  };
  protoOf(CellAsyncTracker).f2m = function () {
    return AmountOfWorkInProgress_getInstance().xlv(this.glw_1);
  };
  function toFirstPlaceholderWhenSettled(_this__u8e3s4) {
    return toFirstPlaceholderWhenSettled$lambda(_this__u8e3s4);
  }
  function whenSettled(_this__u8e3s4, select, action) {
    whenDescendantsReady(_this__u8e3s4, whenSettled$lambda(select, _this__u8e3s4, action));
  }
  function actionWhenSettled(_this__u8e3s4, action) {
    return actionWhenSettled$lambda(_this__u8e3s4, action);
  }
  function whenDescendantsReady(_this__u8e3s4, block) {
    var tmp = get_descendantsFrom(_this__u8e3s4);
    var d = toList_2(filter(tmp, whenDescendantsReady$lambda));
    if (d.p())
      block();
    var p = new ValueProperty(d.n());
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = d.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.cell.async.whenDescendantsReady.<anonymous>' call
      runWhenReady(element, whenDescendantsReady$lambda_0(p));
    }
    p.p27(whenDescendantsReady$lambda_1(_this__u8e3s4, block));
  }
  function toEndWhenSettled(_this__u8e3s4, select) {
    whenSettled(_this__u8e3s4, select, toEndWhenSettled$lambda);
  }
  function runWhenSettled(_this__u8e3s4, runnable) {
    var waitingCell = get_enclosingWaitingCell(_this__u8e3s4);
    if (waitingCell == null)
      runnable();
    else {
      var tmp = AmountOfWorkInProgress_getInstance();
      tmp.zlv(waitingCell, runWhenSettled$lambda(runnable));
    }
  }
  function runWhenReady(_this__u8e3s4, block) {
    if (!AmountOfWorkInProgress_getInstance().ylv(_this__u8e3s4))
      block();
    else {
      AmountOfWorkInProgress_getInstance().zlv(_this__u8e3s4, block);
    }
  }
  function get_enclosingWaitingCell(_this__u8e3s4) {
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestorsFrom(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.cell.async.<get-enclosingWaitingCell>.<anonymous>' call
        if (AmountOfWorkInProgress_getInstance().ylv(element)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function toFirstPlaceholderWhenSettled$lambda$lambda(it) {
    var tmp0_elvis_lhs = getFirstPlaceholder(it);
    return tmp0_elvis_lhs == null ? firstFocusable(it) : tmp0_elvis_lhs;
  }
  function toFirstPlaceholderWhenSettled$lambda($this_toFirstPlaceholderWhenSettled) {
    return function () {
      toEndWhenSettled($this_toFirstPlaceholderWhenSettled, toFirstPlaceholderWhenSettled$lambda$lambda);
      return Unit_instance;
    };
  }
  function whenSettled$lambda($select, $this_whenSettled, $action) {
    return function () {
      var tmp0_elvis_lhs = $select($this_whenSettled);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var innerCell = tmp;
      var tmp_0;
      if (!isDescendant($this_whenSettled, innerCell)) {
        // Inline function 'jetbrains.ocelot.projectional.cell.async.whenSettled.<anonymous>.<anonymous>' call
        var message = 'select function in whenSettled must return a descendant cell';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      var tmp_1;
      if (!!AmountOfWorkInProgress_getInstance().ylv(innerCell)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      $action(innerCell)();
      return Unit_instance;
    };
  }
  function actionWhenSettled$lambda$lambda($action, $this_actionWhenSettled) {
    return function () {
      $action($this_actionWhenSettled)();
      return Unit_instance;
    };
  }
  function actionWhenSettled$lambda($this_actionWhenSettled, $action) {
    return function () {
      runWhenSettled($this_actionWhenSettled, actionWhenSettled$lambda$lambda($action, $this_actionWhenSettled));
      return Unit_instance;
    };
  }
  function whenDescendantsReady$lambda(it) {
    return AmountOfWorkInProgress_getInstance().ylv(it);
  }
  function whenDescendantsReady$lambda_0($p) {
    return function () {
      var i = $p.m2c();
      $p.v2c(i - 1 | 0);
      return Unit_instance;
    };
  }
  function whenDescendantsReady$lambda_1($this_whenDescendantsReady, $block) {
    return function (event) {
      var tmp;
      if (event.p2e_1 === 0) {
        whenDescendantsReady($this_whenDescendantsReady, $block);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function toEndWhenSettled$lambda(it) {
    return toEnd_0(it);
  }
  function runWhenSettled$lambda($runnable) {
    return function () {
      $runnable();
      return Unit_instance;
    };
  }
  function Companion_274() {
    this.hlw_1 = 200;
  }
  var Companion_instance_274;
  function Companion_getInstance_274() {
    return Companion_instance_274;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_8(function_0) {
    this.ilw_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_8).wy = function () {
    return this.ilw_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_8).b4 = function () {
    return this.ilw_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_8).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_8).hashCode = function () {
    return hashCode(this.b4());
  };
  function WaitingMapper$onAttach$lambda($properCell) {
    return function () {
      var tmp0_safe_receiver = firstFocusable($properCell);
      var hacky = tmp0_safe_receiver == null ? null : toEnd_0(tmp0_safe_receiver);
      var tmp;
      if (hacky == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'jetbrains.ocelot.projectional.cell.async.WaitingMapper.onAttach.<anonymous>.<anonymous>' call
        hacky();
        tmp = Unit_instance;
      }
      if (tmp == null)
        $properCell.ulp(ProjectionalSynchronizers_getInstance().jlw_1)();
      return Unit_instance;
    };
  }
  function WaitingMapper$onAttach$lambda$lambda($temporaryCell) {
    return function () {
      $temporaryCell.plw();
      return Unit_instance;
    };
  }
  function WaitingMapper$onAttach$lambda$lambda_0($showProgress, $onCreate) {
    return function () {
      $showProgress.vr();
      $onCreate();
      return Unit_instance;
    };
  }
  function WaitingMapper$onAttach$lambda_0($temporaryCell, $properCell, $onCreate) {
    return function () {
      var container = $temporaryCell.olw_1.llk();
      $temporaryCell.ul5();
      var tmp = ensureNotNull(container).elq();
      var tmp_0 = WaitingMapper$onAttach$lambda$lambda($temporaryCell);
      var showProgress = tmp.v2m(200, new sam$jetbrains_ocelot_base_edt_EdtTask$0_8(tmp_0));
      whenDescendantsReady($properCell, WaitingMapper$onAttach$lambda$lambda_0(showProgress, $onCreate));
      return Unit_instance;
    };
  }
  function WaitingMapper$onAttach$lambda_1($temporaryCell, this$0, $onCreate, $properCell, $tracker) {
    return function () {
      $temporaryCell.b5();
      this$0.ql9_1.ylp(ProjectionalSynchronizers_getInstance().jlw_1, $onCreate);
      $properCell.elp().v2c(true);
      $tracker.f2m();
      return Unit_instance;
    };
  }
  function WaitingMapper(mapper) {
    Mapper.call(this, mapper.pl9_1, new IndentCell());
    this.xlw_1 = mapper;
  }
  protoOf(WaitingMapper).zlc = function (ctx) {
    protoOf(Mapper).zlc.call(this, ctx);
    this.cld().t2c(this.xlw_1);
    var properCell = this.xlw_1.ql9_1;
    var temporaryCell = new TemporaryCell();
    this.ql9_1.g2r().e(temporaryCell.olw_1);
    var tmp = this.ql9_1.g2r();
    // Inline function 'kotlin.apply' call
    // Inline function 'jetbrains.ocelot.projectional.cell.async.WaitingMapper.onAttach.<anonymous>' call
    properCell.elp().v2c(false);
    tmp.e(properCell);
    var onCreate = WaitingMapper$onAttach$lambda(properCell);
    var tmp_0 = ProjectionalSynchronizers_getInstance().jlw_1;
    this.ql9_1.ylp(tmp_0, WaitingMapper$onAttach$lambda_0(temporaryCell, properCell, onCreate));
    var tracker = new CellAsyncTracker(this.ql9_1);
    tracker.e2m();
    whenDescendantsReady(properCell, WaitingMapper$onAttach$lambda_1(temporaryCell, this, onCreate, properCell, tracker));
  };
  function TemporaryCell() {
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = TextCell_init_$Create$_0('');
    // Inline function 'jetbrains.ocelot.projectional.cell.async.TemporaryCell.empty.<anonymous>' call
    this_0.hlp().v2c(true);
    this_0.olp(TextEditing_getInstance().slx(false, true));
    tmp.mlw_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = TextCell_init_$Create$_0('...');
    // Inline function 'jetbrains.ocelot.projectional.cell.async.TemporaryCell.progress.<anonymous>' call
    this_1.hlu().v2c(Companion_getInstance_325().vls_1);
    tmp_0.nlw_1 = this_1;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new IndentCell();
    // Inline function 'jetbrains.ocelot.projectional.cell.async.TemporaryCell.cell.<anonymous>' call
    this_2.g2r().e(this.mlw_1);
    var tmp_2 = this_2.g2r();
    // Inline function 'kotlin.apply' call
    var this_3 = this.nlw_1;
    // Inline function 'jetbrains.ocelot.projectional.cell.async.TemporaryCell.cell.<anonymous>.<anonymous>' call
    this_3.elp().v2c(false);
    tmp_2.e(this_3);
    tmp_1.olw_1 = this_2;
  }
  protoOf(TemporaryCell).ul5 = function () {
    return this.mlw_1.ul5();
  };
  protoOf(TemporaryCell).plw = function () {
    return this.nlw_1.elp().v2c(true);
  };
  protoOf(TemporaryCell).b5 = function () {
    this.olw_1.n3b();
  };
  function getCellProperty($this, spec) {
    assertAllowedAncestorProperty($this, spec);
    var tmp;
    if (!($this.aly_1 == null) && ensureNotNull($this.aly_1).w2(spec)) {
      var tmp_0 = ensureNotNull($this.aly_1).y2(spec);
      tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
    } else {
      tmp = $this.pl9_1.clo(spec);
    }
    return tmp;
  }
  function assertAllowedAncestorProperty($this, spec) {
    // Inline function 'kotlin.require' call
    if (!Companion_getInstance_275().cly_1.s(spec)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.baseMapper.BaseCellMapper.assertAllowedAncestorProperty.<anonymous>' call
      var message = spec.toString();
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  function Companion_275() {
    Companion_instance_275 = this;
    this.cly_1 = setOf_0([get_BACKGROUND(), get_RED_UNDERLINE(), get_YELLOW_UNDERLINE()]);
  }
  var Companion_instance_275;
  function Companion_getInstance_275() {
    if (Companion_instance_275 == null)
      new Companion_275();
    return Companion_instance_275;
  }
  function BaseCellMapper(source, target) {
    Companion_getInstance_275();
    Mapper.call(this, source, target);
    this.aly_1 = null;
    this.bly_1 = null;
  }
  protoOf(BaseCellMapper).dly = function () {
    return this.pl9_1.clo(get_SELECTED()) || this.gly(Companion_getInstance_276().fly_1) > 0;
  };
  protoOf(BaseCellMapper).hly = function () {
    return this.pl9_1.clo(get_FOCUS_HIGHLIGHTED()) || this.gly(Companion_getInstance_276().ely_1) > 0;
  };
  protoOf(BaseCellMapper).ily = function () {
    return getCellProperty(this, get_BACKGROUND());
  };
  protoOf(BaseCellMapper).jly = function () {
    return getCellProperty(this, get_RED_UNDERLINE());
  };
  protoOf(BaseCellMapper).kly = function () {
    return getCellProperty(this, get_YELLOW_UNDERLINE());
  };
  protoOf(BaseCellMapper).jkb = function () {
    return false;
  };
  protoOf(BaseCellMapper).lly = function () {
    return this.hly() && !this.jkb() && !this.dly();
  };
  protoOf(BaseCellMapper).mly = function (spec, value) {
    assertAllowedAncestorProperty(this, spec);
    if (this.aly_1 == null) {
      this.aly_1 = new ListMap();
    }
    if (equals(value, spec.ulm(this.pl9_1))) {
      ensureNotNull(this.aly_1).s2(spec);
    } else {
      ensureNotNull(this.aly_1).r2(spec, value);
    }
  };
  protoOf(BaseCellMapper).nly = function () {
    var children = this.pl9_1.g2r();
    var inductionVariable = 0;
    var last = children.n() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.oly(i, children.q(i));
      }
       while (inductionVariable <= last);
  };
  protoOf(BaseCellMapper).ply = function (spec, delta) {
    if (this.bly_1 == null) {
      this.bly_1 = new Counters();
    }
    ensureNotNull(this.bly_1).ply(spec, delta);
    if (ensureNotNull(this.bly_1).np()) {
      this.bly_1 = null;
    }
  };
  protoOf(BaseCellMapper).gly = function (spec) {
    var tmp0_safe_receiver = this.bly_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gly(spec);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  function CounterSpec(name) {
    this.rly_1 = name;
  }
  protoOf(CounterSpec).toString = function () {
    return 'CounterSpec(name=' + this.rly_1 + ')';
  };
  protoOf(CounterSpec).hashCode = function () {
    return getStringHashCode(this.rly_1);
  };
  protoOf(CounterSpec).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CounterSpec))
      return false;
    var tmp0_other_with_cast = other instanceof CounterSpec ? other : THROW_CCE();
    if (!(this.rly_1 === tmp0_other_with_cast.rly_1))
      return false;
    return true;
  };
  function update($this, add, root, cell, target) {
    var current = cell;
    do {
      current = ensureNotNull(current).yt();
      var _iterator__ex2g4s = $this.sly_1.k();
      while (_iterator__ex2g4s.l()) {
        var cp = _iterator__ex2g4s.m();
        if (ensureNotNull(current).clo(cp)) {
          $this.tly(target, cp, new PropertyChangeEvent(!add, add));
        }
      }
    }
     while (!(current === root));
  }
  function CounterUtil() {
    CounterUtil_instance = this;
    this.sly_1 = listOf_0([get_FOCUS_HIGHLIGHTED(), get_SELECTED()]);
  }
  protoOf(CounterUtil).uly = function (prop) {
    return contains_5(this.sly_1, prop);
  };
  protoOf(CounterUtil).vly = function (root, cell, target) {
    return update(this, true, root, cell, target);
  };
  protoOf(CounterUtil).wly = function (root, cell, target) {
    return update(this, false, root, cell, target);
  };
  protoOf(CounterUtil).tly = function (target, prop, event) {
    var tmp;
    var tmp_0 = event.p2e_1;
    if ((!(tmp_0 == null) ? typeof tmp_0 === 'boolean' : false) ? tmp_0 : THROW_CCE()) {
      tmp = 1;
    } else {
      tmp = -1;
    }
    var delta = tmp;
    var spec = null;
    if (prop === get_FOCUS_HIGHLIGHTED()) {
      spec = Companion_getInstance_276().ely_1;
    } else if (prop === get_SELECTED()) {
      spec = Companion_getInstance_276().fly_1;
    }
    if (!(spec == null)) {
      target.ply(spec, delta);
      return true;
    }
    return false;
  };
  var CounterUtil_instance;
  function CounterUtil_getInstance() {
    if (CounterUtil_instance == null)
      new CounterUtil();
    return CounterUtil_instance;
  }
  function Companion_276() {
    Companion_instance_276 = this;
    this.ely_1 = new CounterSpec('focusHighlight');
    this.fly_1 = new CounterSpec('selectCount');
  }
  var Companion_instance_276;
  function Companion_getInstance_276() {
    if (Companion_instance_276 == null)
      new Companion_276();
    return Companion_instance_276;
  }
  function Counters() {
    Companion_getInstance_276();
    this.qly_1 = null;
  }
  protoOf(Counters).np = function () {
    return this.qly_1 == null;
  };
  protoOf(Counters).gly = function (spec) {
    return this.qly_1 == null || !ensureNotNull(this.qly_1).w2(spec) ? 0 : ensureNotNull(ensureNotNull(this.qly_1).y2(spec));
  };
  protoOf(Counters).ply = function (spec, delta) {
    if (delta === 0)
      return Unit_instance;
    var oldVal = this.gly(spec);
    var newVal = oldVal + delta | 0;
    // Inline function 'kotlin.check' call
    if (!(newVal >= 0)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.baseMapper.counters.Counters.changeCounter.<anonymous>' call
      var message = 'Counter ' + spec.toString() + ' decreased to the value less than zero.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (!(newVal === 0)) {
      if (this.qly_1 == null) {
        this.qly_1 = new ListMap();
      }
      ensureNotNull(this.qly_1).r2(spec, newVal);
    } else {
      if (!(this.qly_1 == null)) {
        ensureNotNull(this.qly_1).s2(spec);
        if (ensureNotNull(this.qly_1).np()) {
          this.qly_1 = null;
        }
      }
    }
  };
  function get_cellHasBounds() {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return cellHasBounds;
  }
  var cellHasBounds;
  function get_boundsComposites() {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return boundsComposites;
  }
  var boundsComposites;
  function get_navCompositeBounds() {
    _init_properties_CellHasBounds_kt__lhxy2j();
    var tmp0 = navCompositeBounds$delegate;
    // Inline function 'kotlin.getValue' call
    navCompositeBounds$factory();
    return tmp0.y();
  }
  var navCompositeBounds$delegate;
  function endElement(cell, threshold) {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return get_navCompositeBounds().llg(cell, threshold);
  }
  function homeElement(cell, threshold) {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return get_navCompositeBounds().hlg(cell, threshold);
  }
  function isAbove(upper, lower) {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return get_boundsComposites().dlg(upper, lower);
  }
  function cellHasBounds$lambda(cell) {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return get_bounds(cell);
  }
  function navCompositeBounds$delegate$lambda() {
    _init_properties_CellHasBounds_kt__lhxy2j();
    return new NavCompositeBounds(get_boundsComposites(), get_cellNavCompositeFocusables());
  }
  function navCompositeBounds$factory() {
    return getPropertyCallableRef('navCompositeBounds', 0, KProperty0, function () {
      return get_navCompositeBounds();
    }, null);
  }
  var properties_initialized_CellHasBounds_kt_daj7r1;
  function _init_properties_CellHasBounds_kt__lhxy2j() {
    if (!properties_initialized_CellHasBounds_kt_daj7r1) {
      properties_initialized_CellHasBounds_kt_daj7r1 = true;
      cellHasBounds = cellHasBounds$lambda;
      boundsComposites = new BoundsComposites(get_cellHasBounds());
      navCompositeBounds$delegate = lazy_0(navCompositeBounds$delegate$lambda);
    }
  }
  function AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda($completionResult, resultContinuation) {
    this.flz_1 = $completionResult;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda).hlz = function ($this$withTimeoutOrNull, $completion) {
    var tmp = this.i1l($this$withTimeoutOrNull, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda).oa = function (p1, $completion) {
    return this.hlz((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = await_2(this.flz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda).i1l = function ($this$withTimeoutOrNull, completion) {
    var i = new AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda(this.flz_1, completion);
    i.glz_1 = $this$withTimeoutOrNull;
    return i;
  };
  function AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda_0($completionResult, resultContinuation) {
    var i = new AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda($completionResult, resultContinuation);
    var l = function ($this$withTimeoutOrNull, $completion) {
      return i.hlz($this$withTimeoutOrNull, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AsyncCompletionSupport$whenCompletionReady$slambda($completionResult, $readyBlock, resultContinuation) {
    this.qlz_1 = $completionResult;
    this.rlz_1 = $readyBlock;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncCompletionSupport$whenCompletionReady$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(AsyncCompletionSupport$whenCompletionReady$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AsyncCompletionSupport$whenCompletionReady$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = await_2(this.qlz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.tlz_1 = suspendResult;
            this.ulz_1 = CompletionItems_init_$Create$(this.tlz_1);
            this.y9_1 = 2;
            suspendResult = this.rlz_1(this.ulz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncCompletionSupport$whenCompletionReady$slambda).i1l = function ($this$launch, completion) {
    var i = new AsyncCompletionSupport$whenCompletionReady$slambda(this.qlz_1, this.rlz_1, completion);
    i.slz_1 = $this$launch;
    return i;
  };
  function AsyncCompletionSupport$whenCompletionReady$slambda_0($completionResult, $readyBlock, resultContinuation) {
    var i = new AsyncCompletionSupport$whenCompletionReady$slambda($completionResult, $readyBlock, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AsyncCompletionSupport$whenCompletionReady$lambda($completionResult) {
    return function (it) {
      $completionResult.vr();
      return Unit_instance;
    };
  }
  function AsyncCompletionSupport$whenCompletionReadyOrNull$slambda($timeout, $readyBlock, $completionResult, resultContinuation) {
    this.dm0_1 = $timeout;
    this.em0_1 = $readyBlock;
    this.fm0_1 = $completionResult;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = withTimeoutOrNull(this.dm0_1, AsyncCompletionSupport$whenCompletionReadyOrNull$slambda$slambda_0(this.fm0_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.hm0_1 = suspendResult;
            var tmp_0 = this;
            var tmp0_safe_receiver = this.hm0_1;
            var tmp_1;
            if (tmp0_safe_receiver == null) {
              tmp_1 = null;
            } else {
              tmp_1 = CompletionItems_init_$Create$(tmp0_safe_receiver);
            }

            tmp_0.im0_1 = tmp_1;
            this.y9_1 = 2;
            suspendResult = this.em0_1(this.im0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncCompletionSupport$whenCompletionReadyOrNull$slambda).i1l = function ($this$launch, completion) {
    var i = new AsyncCompletionSupport$whenCompletionReadyOrNull$slambda(this.dm0_1, this.em0_1, this.fm0_1, completion);
    i.gm0_1 = $this$launch;
    return i;
  };
  function AsyncCompletionSupport$whenCompletionReadyOrNull$slambda_0($timeout, $readyBlock, $completionResult, resultContinuation) {
    var i = new AsyncCompletionSupport$whenCompletionReadyOrNull$slambda($timeout, $readyBlock, $completionResult, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AsyncCompletionSupport$whenCompletionReadyOrNull$lambda($completionResult) {
    return function (it) {
      $completionResult.vr();
      return Unit_instance;
    };
  }
  function AsyncCompletionSupport$launchWithAsyncCompletion$slambda($block, resultContinuation) {
    this.rm0_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AsyncCompletionSupport$launchWithAsyncCompletion$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(AsyncCompletionSupport$launchWithAsyncCompletion$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(AsyncCompletionSupport$launchWithAsyncCompletion$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.rm0_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(AsyncCompletionSupport$launchWithAsyncCompletion$slambda).i1l = function ($this$launch, completion) {
    var i = new AsyncCompletionSupport$launchWithAsyncCompletion$slambda(this.rm0_1, completion);
    i.sm0_1 = $this$launch;
    return i;
  };
  function AsyncCompletionSupport$launchWithAsyncCompletion$slambda_0($block, resultContinuation) {
    var i = new AsyncCompletionSupport$launchWithAsyncCompletion$slambda($block, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function AsyncCompletionSupport$launchWithAsyncCompletion$lambda($completionResult) {
    return function (it) {
      $completionResult.vr();
      return Unit_instance;
    };
  }
  function AsyncCompletionSupport() {
    AsyncCompletionSupport_instance = this;
    this.tm0_1 = CellTraitPropertySpec_init_$Create$('asyncCompletion', null);
  }
  protoOf(AsyncCompletionSupport).um0 = function (cell, completionResult, readyBlock) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.AsyncCompletionSupport.launchAndUseCompletion' call
    var tmp = launch_0(cell, this.tm0_1, AsyncCompletionSupport$whenCompletionReady$slambda_0(completionResult, readyBlock, null));
    tmp.hu(AsyncCompletionSupport$whenCompletionReady$lambda(completionResult));
  };
  protoOf(AsyncCompletionSupport).vm0 = function (cell, completionResult, timeout, readyBlock) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.AsyncCompletionSupport.launchAndUseCompletion' call
    var tmp = launch_0(cell, this.tm0_1, AsyncCompletionSupport$whenCompletionReadyOrNull$slambda_0(timeout, readyBlock, completionResult, null));
    tmp.hu(AsyncCompletionSupport$whenCompletionReadyOrNull$lambda(completionResult));
  };
  protoOf(AsyncCompletionSupport).wm0 = function (cell, completionResult, block) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.AsyncCompletionSupport.launchAndUseCompletion' call
    var tmp = launch_0(cell, this.tm0_1, AsyncCompletionSupport$launchWithAsyncCompletion$slambda_0(block, null));
    tmp.hu(AsyncCompletionSupport$launchWithAsyncCompletion$lambda(completionResult));
  };
  var AsyncCompletionSupport_instance;
  function AsyncCompletionSupport_getInstance() {
    if (AsyncCompletionSupport_instance == null)
      new AsyncCompletionSupport();
    return AsyncCompletionSupport_instance;
  }
  function BaseCompletionConfig() {
  }
  protoOf(BaseCompletionConfig).xm0 = function (completionItems, prefixText) {
    return false;
  };
  protoOf(BaseCompletionConfig).ym0 = function () {
    return 100;
  };
  function _get_completionResult__lvjdbi($this) {
    var tmp = $this.am1_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('completionResult');
    }
  }
  function _get_completionDisposable__dka3yp($this) {
    var tmp = $this.bm1_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('completionDisposable');
    }
  }
  function _get_supplier__o4mz5r($this) {
    return $this.zm0_1.ulp(Completion_getInstance().cm1_1);
  }
  function _get_orCreateTempEditor__t9oxkl($this) {
    var currentEditor = $this.zm0_1.ulp(Companion_getInstance_277().mm1_1);
    if (!(currentEditor == null)) {
      return to(currentEditor.om1(), Companion_getInstance_25().wr_1);
    }
    var newEditor = $this.zm0_1.clo(Companion_getInstance_279().pm1_1)();
    return to(newEditor.om1(), newEditor);
  }
  function initCompletionResult($this) {
    if (!!($this.am1_1 == null)) {
      $this.am1_1 = _get_supplier__o4mz5r($this).um1(Companion_getInstance_281().rm1_1);
      var tmp = AsyncCompletionSupport_getInstance();
      var tmp_0 = _get_completionResult__lvjdbi($this);
      tmp.wm0($this.zm0_1, tmp_0, CellCompletionController$initCompletionResult$slambda_0($this, null));
    }
  }
  function assertNoActiveController($this) {
    var actual = $this.zm0_1.clo(Companion_getInstance_277().nm1_1);
    // Inline function 'kotlin.check' call
    if (!(actual == null)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.CellCompletionController.assertNoActiveController.<anonymous>' call
      var message = 'Controller is already active';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function disposeCompletion($this) {
    return _get_completionDisposable__dka3yp($this).vr();
  }
  function assertIsDisposed($this) {
    var tmp;
    if (!($this.zm0_1.clo(Companion_getInstance_277().nm1_1) == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return tmp;
  }
  function queryEditor($this, query) {
    var editor = _get_orCreateTempEditor__t9oxkl($this);
    try {
      return query(editor.dh_1);
    }finally {
      editor.eh_1.vr();
    }
  }
  function getCompletionItems($this) {
    initCompletionResult($this);
    return CompletionItems_init_$Create$(_get_completionResult__lvjdbi($this));
  }
  function Companion_277() {
    Companion_instance_277 = this;
    this.mm1_1 = CellTraitPropertySpec_init_$Create$('completionEditor', null);
    this.nm1_1 = CellPropertySpec_init_$Create$('completionController', null);
  }
  protoOf(Companion_277).vm1 = function (target) {
    var controller = target.clo(this.nm1_1);
    return controller == null ? new CellCompletionController(target) : controller;
  };
  var Companion_instance_277;
  function Companion_getInstance_277() {
    if (Companion_instance_277 == null)
      new Companion_277();
    return Companion_instance_277;
  }
  function CellCompletionController$initCompletionResult$slambda(this$0, resultContinuation) {
    this.em2_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CellCompletionController$initCompletionResult$slambda).dag = function ($completion) {
    var tmp = this.eag($completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CellCompletionController$initCompletionResult$slambda).fag = function ($completion) {
    return this.dag($completion);
  };
  protoOf(CellCompletionController$initCompletionResult$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = awaitValue(this.em2_1.fm2(), false, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(CellCompletionController$initCompletionResult$slambda).eag = function (completion) {
    return new CellCompletionController$initCompletionResult$slambda(this.em2_1, completion);
  };
  function CellCompletionController$initCompletionResult$slambda_0(this$0, resultContinuation) {
    var i = new CellCompletionController$initCompletionResult$slambda(this$0, resultContinuation);
    var l = function ($completion) {
      return i.dag($completion);
    };
    l.$arity = 0;
    return l;
  }
  function CellCompletionController$hasPrefixedItems$lambda(this$0) {
    return function (editor) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      return !getCompletionItems(this$0).hm2(editor.ylt()).p();
    };
  }
  function CellCompletionController(cell) {
    Companion_getInstance_277();
    this.zm0_1 = cell;
  }
  protoOf(CellCompletionController).ft = function () {
    return !(this.zm0_1.clo(Companion_getInstance_277().nm1_1) == null);
  };
  protoOf(CellCompletionController).fm2 = function () {
    return notNull(this.zm0_1.flp(Companion_getInstance_277().nm1_1));
  };
  protoOf(CellCompletionController).im2 = function () {
    return !(_get_supplier__o4mz5r(this) === get_EMPTY_COMPLETION_SUPPLIER());
  };
  protoOf(CellCompletionController).jm2 = function (parameters) {
    assertNoActiveController(this);
    var activated = this.zm0_1.bln(Companion_getInstance_277().nm1_1, this);
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.CellCompletionController.activate.stub_for_inlining' call
      initCompletionResult(this);
      // Inline function 'kotlin.Companion.success' call
      tmp = _Result___init__impl__xyqfz8(Unit_instance);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    // Inline function 'kotlin.onFailure' call
    var this_0 = tmp;
    if (Result__exceptionOrNull_impl_p6xea9(this_0) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.onFailure.<anonymous>' call
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.CellCompletionController.activate.<anonymous>' call
      activated.vr();
    }
    // Inline function 'kotlin.getOrThrow' call
    throwOnFailure(this_0);
    var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
    if (!(tmp_1 == null ? true : !(tmp_1 == null)))
      THROW_CCE();
    var state = ensureNotNull(this.zm0_1.llk()).km2();
    var editor = this.zm0_1.clo(Companion_getInstance_279().pm1_1)();
    var nestedCleanup = activated.sr(this.zm0_1.ylp(Companion_getInstance_277().mm1_1, editor)).sr(editor);
    editor.om1().ul5();
    this.bm1_1 = CompletionSupport_getInstance().rm2(editor.om1(), _get_completionResult__lvjdbi(this), parameters, nestedCleanup, state);
  };
  protoOf(CellCompletionController).iko = function () {
    var actual = this.zm0_1.clo(Companion_getInstance_277().nm1_1);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (actual == null) {
        // Inline function 'jetbrains.ocelot.projectional.cell.completion.CellCompletionController.deactivate.<anonymous>' call
        var message = 'Controller is not active';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    disposeCompletion(actual);
    assertIsDisposed(actual);
  };
  protoOf(CellCompletionController).sm2 = function () {
    return queryEditor(this, CellCompletionController$hasPrefixedItems$lambda(this));
  };
  protoOf(CellCompletionController).tm2 = function () {
    var result = _get_supplier__o4mz5r(this).um1(Companion_getInstance_281().qm1_1);
    if (_get_supplier__o4mz5r(this).um2()) {
      this.am1_1 = result;
    }
    return result;
  };
  function Completion$COMPLETION_ITEMS_SHOWN$lambda(it) {
    return Unit_instance;
  }
  function Completion() {
    Completion_instance = this;
    this.cm1_1 = CellTraitPropertySpec_init_$Create$('completion', get_EMPTY_COMPLETION_SUPPLIER());
    this.dm1_1 = CellTraitPropertySpec_init_$Create$('leftTransform', get_EMPTY_COMPLETION_SUPPLIER());
    this.em1_1 = CellTraitPropertySpec_init_$Create$('rightTransform', get_EMPTY_COMPLETION_SUPPLIER());
    this.fm1_1 = new CellTraitPropertySpec('expandLeft', Side_LEFT_getInstance().xm2());
    this.gm1_1 = new CellTraitPropertySpec('expandRight', Side_RIGHT_getInstance().xm2());
    this.hm1_1 = CellTraitPropertySpec_init_$Create$('completionConfig', new DefaultCompletionConfig());
    this.im1_1 = CellTraits_instance.ym2('completionItemsShown');
    var tmp = this;
    var tmp_0 = CellTraits_instance;
    tmp.jm1_1 = tmp_0.zm2('completionItemsShown', Completion$COMPLETION_ITEMS_SHOWN$lambda);
    this.km1_1 = CellPropertySpec_init_$Create$('completionMenuPosition', 0);
    this.lm1_1 = CellTraitPropertySpec_init_$Create$('specialSpaceHandlingInCompletion', true);
  }
  protoOf(Completion).am3 = function (cell) {
    var target = cell.ulp(CompletionSupport_getInstance().om2_1);
    return Companion_getInstance_277().vm1(target);
  };
  protoOf(Completion).bm3 = function (cell) {
    return this.am3(cell).ft();
  };
  protoOf(Completion).cm3 = function (cell, cp, prop) {
    var completionSupplier = cell.ulp(prop);
    return completionSupplier.um1(cp);
  };
  protoOf(Completion).dm3 = function (cell, cp, prop, $super) {
    prop = prop === VOID ? this.cm1_1 : prop;
    return $super === VOID ? this.cm3(cell, cp, prop) : $super.cm3.call(this, cell, cp, prop);
  };
  var Completion_instance;
  function Completion_getInstance() {
    if (Completion_instance == null)
      new Completion();
    return Completion_instance;
  }
  function Companion_278() {
    this.em3_1 = 'Loading...';
    this.fm3_1 = '<no completion items>';
    this.gm3_1 = '<unexpected error while building completion menu>';
    this.hm3_1 = '<some items may be missing due to unexpected error>';
  }
  var Companion_instance_278;
  function Companion_getInstance_278() {
    return Companion_instance_278;
  }
  function CompletionContentCell() {
    VerticalCell.call(this);
    this.qm3_1 = new TextPlaceholderCell();
    this.rm3_1 = CellFactory_instance.xm3([]);
    this.sm3_1 = TextCell_init_$Create$_0('<no completion items>');
    this.tm3_1 = TextCell_init_$Create$_0('<unexpected error while building completion menu>');
    this.um3_1 = TextCell_init_$Create$_0('<some items may be missing due to unexpected error>');
    this.vm3_1 = TextCell_init_$Create$_0('Loading...');
    this.wm3_1 = new TextPlaceholderCell();
    CellFactory_instance.ym3(this, [this.qm3_1, this.tm3_1, this.um3_1, this.rm3_1, this.sm3_1, this.vm3_1, this.wm3_1]);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = listOf_0([this.sm3_1, this.tm3_1, this.um3_1]).k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.CompletionContentCell.<anonymous>' call
      element.hlu().t2c(Companion_getInstance_325().yls_1);
    }
    this.vm3_1.hlu().t2c(Companion_getInstance_325().xls_1);
  }
  function CompletionEditor$Companion$FACTORY$lambda(cell) {
    return CompletionEditor$Companion$FACTORY$lambda$lambda(cell);
  }
  function CompletionEditor$Companion$FACTORY$lambda$lambda($cell) {
    return function () {
      var tmp;
      if ($cell.ulp(TextEditing_getInstance().zlw_1)) {
        tmp = new SimpleCompletionEditor($cell instanceof TextCell ? $cell : THROW_CCE());
      } else {
        tmp = new PopupCompletionEditor($cell);
      }
      return tmp;
    };
  }
  function Companion_279() {
    Companion_instance_279 = this;
    var tmp = this;
    tmp.pm1_1 = new CellPropertySpec('completionEditorProvider', CompletionEditor$Companion$FACTORY$lambda);
  }
  var Companion_instance_279;
  function Companion_getInstance_279() {
    if (Companion_instance_279 == null)
      new Companion_279();
    return Companion_instance_279;
  }
  function init_3($this, cell, background, maxDim) {
    get_hasShadow(cell).t2c(true);
    get_border(cell).t2c(CompletionMenu_getInstance().gm4_1);
    get_background(cell).t2c(background);
    cell.bln(Companion_getInstance_270().jlr_1, maxDim);
  }
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$o$doAttach$lambda(this$0, $delayPassed) {
    return function (it) {
      this$0.ql9_1.vm4_1.sm3_1.elp().t2c(this$0.pl9_1.em5_1.m2c() && this$0.pl9_1.cm5_1.p() && !this$0.pl9_1.dm5_1.m2c());
      this$0.ql9_1.vm4_1.vm3_1.elp().t2c(!this$0.pl9_1.em5_1.m2c() && $delayPassed.m2c() && this$0.pl9_1.cm5_1.p());
      this$0.ql9_1.vm4_1.tm3_1.elp().t2c(this$0.pl9_1.dm5_1.m2c() && this$0.pl9_1.cm5_1.p());
      var tmp = this$0.ql9_1.vm4_1.um3_1.elp();
      var tmp_0;
      if (this$0.pl9_1.dm5_1.m2c()) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_0 = !this$0.pl9_1.cm5_1.p();
      } else {
        tmp_0 = false;
      }
      tmp.t2c(tmp_0);
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$o$onEvent$lambda($it) {
    return function () {
      $it.vm5();
      return Unit_instance;
    };
  }
  function loadUpToVisible($this, cell) {
    while (cell.elp().qr() && get_bounds(cell).qku(get_bounds($this.wm5_1.ql9_1))) {
      $this.wm5_1.pl9_1.xm5();
    }
  }
  function _get_longestItemLength__sqzuxe($this) {
    var longest = 0;
    var _iterator__ex2g4s = $this.pl9_1.ym5().k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      var length = Companion_instance_280.zm5(item);
      if (length > longest) {
        longest = length;
      }
    }
    return longest;
  }
  function delayPassedProperty($this, delay, conf) {
    var delayPassed = new ValueProperty(false);
    var delayReg = new CompositeDisposable([]);
    delayReg.ur([whenAttached($this.ql9_1, CompletionMenu$CompletionMenuModelMapper$delayPassedProperty$lambda(delayPassed, delayReg, $this, delay))]);
    conf.x4v(delayReg);
    return delayPassed;
  }
  function initPlaceholders($this) {
    $this.ql9_1.am6(CompletionMenu$CompletionMenuModelMapper$initPlaceholders$lambda($this));
    updatePlaceholders($this);
  }
  function updatePlaceholders($this) {
    if (!$this.pl9_1.em5_1.qr()) {
      hidePlaceholders($this);
      return Unit_instance;
    }
    var placeholderLines = $this.pl9_1.bm6().qr() - $this.pl9_1.cm5_1.n() | 0;
    if (placeholderLines === 0) {
      hidePlaceholders($this);
      return Unit_instance;
    }
    if ($this.ql9_1.vm4_1.qm3_1.dlv().qr() === 0) {
      initWidth($this);
    }
    renderedPlaceholder($this).elv().t2c(placeholderLines);
    renderedPlaceholder($this).elp().t2c(true);
    hiddenPlaceholder($this).elp().t2c(false);
  }
  function initWidth($this) {
    var longest = _get_longestItemLength__sqzuxe($this);
    $this.ql9_1.am6(CompletionMenu$CompletionMenuModelMapper$initWidth$lambda(longest));
  }
  function hidePlaceholders($this) {
    $this.ql9_1.am6(CompletionMenu$CompletionMenuModelMapper$hidePlaceholders$lambda);
  }
  function renderedPlaceholder($this) {
    return getPlaceholder($this, $this.pl9_1.cm6().qr());
  }
  function hiddenPlaceholder($this) {
    return getPlaceholder($this, !$this.pl9_1.cm6().qr());
  }
  function getPlaceholder($this, bottom) {
    return bottom ? $this.ql9_1.vm4_1.wm3_1 : $this.ql9_1.vm4_1.qm3_1;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_9(function_0) {
    this.dm6_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_9).wy = function () {
    return this.dm6_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_9).b4 = function () {
    return this.dm6_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_9).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_9).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_10(function_0) {
    this.em6_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_10).wy = function () {
    return this.em6_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_10).b4 = function () {
    return this.em6_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_10).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_10).hashCode = function () {
    return hashCode(this.b4());
  };
  function CompletionMenu$CompletionItemMapper$_init_$ref_j3qln0() {
    var l = function (p0) {
      return new CompletionItemMapper(p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$forEventSource$1(this$0, $delayPassed, $src) {
    this.gm6_1 = this$0;
    this.hm6_1 = $delayPassed;
    this.im6_1 = $src;
    DisposableSynchronizer.call(this);
  }
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$forEventSource$1).dlb = function (ctx) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.CompletionMenuModelMapper.registerSynchronizers.<anonymous>' call
    this.gm6_1.ql9_1.vm4_1.sm3_1.elp().t2c(this.gm6_1.pl9_1.em5_1.m2c() && this.gm6_1.pl9_1.cm5_1.p() && !this.gm6_1.pl9_1.dm5_1.m2c());
    this.gm6_1.ql9_1.vm4_1.vm3_1.elp().t2c(!this.gm6_1.pl9_1.em5_1.m2c() && this.hm6_1.m2c() && this.gm6_1.pl9_1.cm5_1.p());
    this.gm6_1.ql9_1.vm4_1.tm3_1.elp().t2c(this.gm6_1.pl9_1.dm5_1.m2c() && this.gm6_1.pl9_1.cm5_1.p());
    var tmp = this.gm6_1.ql9_1.vm4_1.um3_1.elp();
    var tmp_0;
    if (this.gm6_1.pl9_1.dm5_1.m2c()) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_0 = !this.gm6_1.pl9_1.cm5_1.p();
    } else {
      tmp_0 = false;
    }
    tmp.t2c(tmp_0);
    return this.im6_1.p27(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$o$doAttach$lambda(this.gm6_1, this.hm6_1));
  };
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$eventHandler$1(this$0) {
    this.jm6_1 = this$0;
  }
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$eventHandler$1).e2b = function (event) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.CompletionMenuModelMapper.registerSynchronizers.<anonymous>' call
      if (event == null) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      }
      var tmp = this.jm6_1.rlc(event);
      var tmp1_elvis_lhs = tmp instanceof CompletionItemMapper ? tmp : null;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var itemMapper = tmp_0;
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.CompletionMenuModelMapper.registerSynchronizers.<anonymous>.<anonymous>' call
      var tmp_1 = ensureNotNull(this.jm6_1.ql9_1.llk()).elq();
      var tmp_2 = CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$o$onEvent$lambda(itemMapper);
      tmp_1.u2m(new sam$jetbrains_ocelot_base_edt_EdtTask$0_9(tmp_2));
    }
    return tmp$ret$0;
  };
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$eventHandler$1).d28 = function (event) {
    return this.e2b((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$lambda(this$0) {
    return function (it) {
      updatePlaceholders(this$0);
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$docCell$1(this$0) {
    this.om6_1 = this$0;
    DerivedProperty.call(this, [this$0.pl9_1.gm5_1, this$0.pl9_1.im5_1]);
  }
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$docCell$1).g2c = function () {
    if (!this.om6_1.pl9_1.im5_1.qr() || this.om6_1.wm6_1 == null)
      return null;
    var item = this.om6_1.pl9_1.gm5_1.qr();
    return item == null ? null : this.om6_1.wm6_1(item.zm6());
  };
  function CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.am7_1 = this$0;
  }
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    var children = this.am7_1.ql9_1.xm4_1.ilp();
    children.m2();
    var visible = this.am7_1.ql9_1.wm4_1.elp();
    var tmp;
    if (newValue == null) {
      visible.t2c(false);
      tmp = Unit_instance;
    } else {
      children.e(newValue);
      visible.t2c(true);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function CompletionMenu$CompletionMenuModelMapper$delayPassedProperty$lambda$lambda($delayPassed) {
    return function () {
      $delayPassed.t2c(true);
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionMenuModelMapper$delayPassedProperty$lambda($delayPassed, $delayReg, this$0, $delay) {
    return function () {
      var tmp;
      if (!$delayPassed.qr()) {
        var tmp_0 = ensureNotNull(this$0.ql9_1.llk()).elq();
        var tmp_1 = CompletionMenu$CompletionMenuModelMapper$delayPassedProperty$lambda$lambda($delayPassed);
        $delayReg.ur([tmp_0.v2m($delay, new sam$jetbrains_ocelot_base_edt_EdtTask$0_10(tmp_1))]);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionMenuModelMapper$initPlaceholders$1$1(this$0) {
    this.wm5_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(CompletionMenu$CompletionMenuModelMapper$initPlaceholders$1$1).plo = function (cell, event) {
    return loadUpToVisible(this, cell);
  };
  protoOf(CompletionMenu$CompletionMenuModelMapper$initPlaceholders$1$1).nlo = function (cell, event) {
    return loadUpToVisible(this, cell);
  };
  protoOf(CompletionMenu$CompletionMenuModelMapper$initPlaceholders$1$1).rlo = function (cell, event) {
    return loadUpToVisible(this, cell);
  };
  protoOf(CompletionMenu$CompletionMenuModelMapper$initPlaceholders$1$1).tlo = function (cell, event) {
    return loadUpToVisible(this, cell);
  };
  function CompletionMenu$CompletionMenuModelMapper$initPlaceholders$lambda(this$0) {
    return function (placeholderCell) {
      placeholderCell.olp(new CompletionMenu$CompletionMenuModelMapper$initPlaceholders$1$1(this$0));
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionMenuModelMapper$initWidth$lambda($longest) {
    return function (p) {
      p.dlv().t2c($longest);
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionMenuModelMapper$hidePlaceholders$lambda(p) {
    p.elp().t2c(false);
    return Unit_instance;
  }
  function setBackground($this, mode) {
    return $this.ql9_1.bln(get_BACKGROUND(), CompletionMenu_getInstance().dm4_1.fm7(mode));
  }
  function Companion_280() {
  }
  protoOf(Companion_280).zm5 = function (item) {
    var mainLength = item.gm7().length;
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = item.hm7();
    var additionalLength = (tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs).length;
    var tmp;
    if (additionalLength === 0) {
      tmp = mainLength;
    } else {
      tmp = (mainLength + 1 | 0) + additionalLength | 0;
    }
    return tmp;
  };
  var Companion_instance_280;
  function Companion_getInstance_280() {
    return Companion_instance_280;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_11(function_0) {
    this.im7_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_11).wy = function () {
    return this.im7_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_11).b4 = function () {
    return this.im7_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_11).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_11).hashCode = function () {
    return hashCode(this.b4());
  };
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$1($parentMapper, this$0, $hoveredItem) {
    this.jm7_1 = $parentMapper;
    this.km7_1 = this$0;
    this.lm7_1 = $hoveredItem;
    CellTrait.call(this);
  }
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$1).llo = function (cell, event) {
    this.jm7_1.xm6_1.om7(this.km7_1.pl9_1, event);
  };
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$1).plo = function (cell, event) {
    this.lm7_1.t2c(this.km7_1.pl9_1);
    event.ol0();
  };
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$1).slo = function (cell, event) {
    this.jm7_1.xm6_1.om7(this.km7_1.pl9_1, event);
  };
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$1).rlo = function (cell, event) {
    this.lm7_1.t2c(this.km7_1.pl9_1);
    event.ol0();
  };
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda(this$0, $text) {
    return function () {
      return this$0.pl9_1.pm7($text.qr());
    };
  }
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda_0($selected, $completionMenuMode, $matches) {
    return function () {
      return CompletionMenu_getInstance().dm4_1.qm7($selected, $completionMenuMode, $matches);
    };
  }
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda_1($selected, $completionMenuMode) {
    return function () {
      return CompletionMenu_getInstance().dm4_1.rm7($selected, $completionMenuMode);
    };
  }
  function CompletionMenu$CompletionItemMapper$scrollToTarget$ref($boundThis) {
    var l = function () {
      $boundThis.vm5();
      return Unit_instance;
    };
    l.callableName = 'scrollToTarget';
    return l;
  }
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda$lambda(this$0) {
    return function () {
      var tmp = ensureNotNull(this$0.ql9_1.llk()).elq();
      var tmp_0 = CompletionMenu$CompletionItemMapper$scrollToTarget$ref(this$0);
      tmp.u2m(new sam$jetbrains_ocelot_base_edt_EdtTask$0_11(tmp_0));
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda_2(this$0) {
    return function (event) {
      var tmp;
      if (event.p2e_1) {
        var tmp_0 = this$0;
        tmp_0.tm5_1 = whenAttached(this$0.ql9_1, CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda$lambda(this$0));
        tmp = Unit_instance;
      } else {
        this$0.tm5_1.vr();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CompletionMenu$CompletionItemMapper$registerSynchronizers$$inlined$writableProperty$1(this$0, $completionMenuMode) {
    this.sm7_1 = this$0;
    this.tm7_1 = $completionMenuMode;
  }
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    var tmp;
    if (newValue) {
      this.sm7_1.um5_1 = setBackground(this.sm7_1, this.tm7_1.qr());
      tmp = Unit_instance;
    } else {
      this.sm7_1.um5_1.vr();
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function CompletionMenuCell() {
    HorizontalCell.call(this);
    this.um4_1 = new ScrollCell();
    this.vm4_1 = new CompletionContentCell();
    this.wm4_1 = new ScrollCell();
    this.xm4_1 = CellFactory_instance.xm3([]);
    this.elp().t2c(false);
    this.ylq().t2c(Alignment_START_getInstance());
    init_3(this, this.um4_1, CompletionMenu_getInstance().em4_1, CompletionMenu_getInstance().hm4_1);
    init_3(this, this.wm4_1, CompletionMenu_getInstance().fm4_1, CompletionMenu_getInstance().jm4_1);
    this.wm4_1.elp().t2c(false);
    this.um4_1.g2r().e(this.vm4_1);
    this.wm4_1.g2r().e(this.xm4_1);
    CellFactory_instance.ym3(this, [this.um4_1, this.wm4_1]);
    this.olp(CompletionMenu_getInstance().lm4_1);
  }
  protoOf(CompletionMenuCell).am6 = function (consumer) {
    var _iterator__ex2g4s = listOf_0([this.vm4_1.qm3_1, this.vm4_1.wm3_1]).k();
    while (_iterator__ex2g4s.l()) {
      var p = _iterator__ex2g4s.m();
      consumer(p);
    }
  };
  function CompletionMenuSpec() {
  }
  protoOf(CompletionMenuSpec).ilr = function (cell) {
    return false;
  };
  protoOf(CompletionMenuSpec).glr = function (cell, dimension, viewport, alignedWidth) {
    var menu = cell instanceof CompletionMenuCell ? cell : THROW_CCE();
    var hasDoc = menu.wm4_1.elp().qr();
    var itemsScroll = menu.um4_1;
    var itemsDim = get_dimension(itemsScroll);
    var tmp0 = itemsDim.eku_1;
    // Inline function 'kotlin.math.max' call
    var b = CompletionMenu_getInstance().im4_1.eku_1;
    var itemsWidth = Math.max(tmp0, b);
    var tmp;
    if (hasDoc) {
      var tmp2 = viewport.eku_1 - itemsWidth | 0;
      // Inline function 'kotlin.math.max' call
      var b_0 = CompletionMenu_getInstance().km4_1.eku_1;
      tmp = Math.max(tmp2, b_0);
    } else {
      tmp = 0;
    }
    var docWidth = tmp;
    if ((itemsWidth + docWidth | 0) > viewport.eku_1) {
      var tmp4 = viewport.eku_1 - docWidth | 0;
      // Inline function 'kotlin.math.max' call
      var b_1 = CompletionMenu_getInstance().im4_1.eku_1;
      itemsWidth = Math.max(tmp4, b_1);
    }
    var tmp6 = viewport.fku_1;
    // Inline function 'kotlin.math.max' call
    var b_2 = CompletionMenu_getInstance().im4_1.fku_1;
    var itemsHeight = Math.max(tmp6, b_2);
    var itemsAdjusted = ensureNotNull(itemsScroll.ulp(Companion_getInstance_268().elr_1)).glr(itemsScroll, itemsDim, new Vector(itemsWidth, itemsHeight), itemsWidth);
    var docAdjusted = Companion_getInstance_251().iku_1;
    if (hasDoc) {
      var tmp8 = viewport.fku_1;
      // Inline function 'kotlin.math.max' call
      var b_3 = CompletionMenu_getInstance().km4_1.fku_1;
      var docHeight = Math.max(tmp8, b_3);
      docAdjusted = ensureNotNull(menu.wm4_1.ulp(Companion_getInstance_268().elr_1)).glr(menu.wm4_1, get_dimension(menu.wm4_1), new Vector(docWidth, docHeight), docWidth);
    }
    var tmp_0 = itemsAdjusted.eku_1 + docAdjusted.eku_1 | 0;
    var tmp10 = itemsAdjusted.fku_1;
    // Inline function 'kotlin.math.max' call
    var b_4 = docAdjusted.fku_1;
    var tmp$ret$5 = Math.max(tmp10, b_4);
    return new Vector(tmp_0, tmp$ret$5);
  };
  protoOf(CompletionMenuSpec).hlr = function (cell, popup) {
    // Inline function 'kotlin.require' call
    if (!(cell instanceof CompletionMenuCell)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.CompletionMenuSpec.onPositionUpdated.<anonymous>' call
      var message = 'Unsupported cell type: ' + toString_1(cell);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var crossAlignment = cell.ylq();
    if (popup === get_BOTTOM_POPUP()) {
      crossAlignment.t2c(Alignment_START_getInstance());
    } else if (popup === get_TOP_POPUP()) {
      crossAlignment.t2c(Alignment_END_getInstance());
    } else
      throw IllegalArgumentException_init_$Create$_0('Unexpected position change: ' + popup.toString());
  };
  function CompletionMenuTrait() {
    CellTrait.call(this);
    this.um7_1 = new CompletionMenuSpec();
  }
  protoOf(CompletionMenuTrait).flo = function (cell, spec) {
    var tmp;
    if (spec === Companion_getInstance_268().elr_1) {
      tmp = this.um7_1;
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function CompletionMenuModelMapper(source, renderer, completer, emptyCompletionDelay) {
    Mapper.call(this, source, new CompletionMenuCell());
    this.wm6_1 = renderer;
    this.xm6_1 = completer;
    this.ym6_1 = emptyCompletionDelay;
  }
  protoOf(CompletionMenuModelMapper).llb = function (conf) {
    protoOf(Mapper).llb.call(this, conf);
    var tmp = Synchronizers_instance;
    var tmp_0 = this.ql9_1.vm4_1.rm3_1.g2r();
    conf.x4v(tmp.nle(this.pl9_1.cm5_1, tmp_0, CompletionMenu$CompletionItemMapper$_init_$ref_j3qln0()));
    var delayPassed = delayPassedProperty(this, this.ym6_1, conf);
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forEventSource' call
    var src = EventSources_instance.n2b([this.pl9_1.em5_1, delayPassed, this.pl9_1.cm5_1, this.pl9_1.dm5_1]);
    var tmp$ret$0 = new CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$forEventSource$1(this, delayPassed, src);
    conf.x4v(tmp$ret$0);
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var tmp$ret$1 = new CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$eventHandler$1(this);
    conf.x4v(this.pl9_1.fm5_1.z27(tmp$ret$1));
    var showTarget = Properties_getInstance().s2d([this.pl9_1.em5_1, delayPassed]);
    var tmp_1 = EventSources_instance.n2b([this.pl9_1.em5_1, this.pl9_1.cm5_1, this.pl9_1.bm6(), this.pl9_1.cm6()]);
    conf.x4v(tmp_1.p27(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$lambda(this)));
    initPlaceholders(this);
    conf.x4v(syncOneWay(showTarget, this.ql9_1.elp()));
    var docCell = new CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$docCell$1(this);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$2 = new CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.x4v(syncOneWay(docCell, tmp$ret$2));
  };
  function CompletionItemMapper(source) {
    Mapper.call(this, source, new HorizontalCell());
    this.rm5_1 = TextCell_init_$Create$();
    this.sm5_1 = TextCell_init_$Create$();
    this.tm5_1 = Companion_getInstance_25().wr_1;
    this.um5_1 = Companion_getInstance_25().wr_1;
    this.ql9_1.zlq().t2c(true);
    this.rm5_1.laz().t2c(source.gm7());
    this.ql9_1.g2r().e(this.rm5_1);
    var additionalText = source.hm7();
    if (!(additionalText == null)) {
      this.sm5_1.laz().t2c(' ' + additionalText);
      this.sm5_1.bln(Companion_getInstance_271().gls_1, true);
      this.ql9_1.g2r().e(this.sm5_1);
    }
  }
  protoOf(CompletionItemMapper).llb = function (conf) {
    protoOf(Mapper).llb.call(this, conf);
    var tmp = this.ul9_1;
    var parentMapper = tmp instanceof CompletionMenuModelMapper ? tmp : THROW_CCE();
    var parentMapperSource = parentMapper.pl9_1;
    var selectedItem = parentMapperSource.gm5_1;
    var hoveredItem = parentMapperSource.hm5_1;
    conf.x4v(this.ql9_1.olp(new CompletionMenu$CompletionItemMapper$registerSynchronizers$1(parentMapper, this, hoveredItem)));
    var text = parentMapperSource.bm5_1;
    var matches = toDerivedProperty(CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda(this, text), [text]);
    var selected = isSame(selectedItem, this.pl9_1);
    var completionMenuMode = parentMapperSource.vm7();
    var textColor = toDerivedProperty(CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda_0(selected, completionMenuMode, matches), [selected, completionMenuMode, matches]);
    conf.x4v(syncOneWay(textColor, this.rm5_1.hlu()));
    conf.x4v(syncOneWay(toDerivedProperty(CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda_1(selected, completionMenuMode), [selected, completionMenuMode]), this.sm5_1.hlu()));
    conf.x4v(selected.p27(CompletionMenu$CompletionItemMapper$registerSynchronizers$lambda_2(this)));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new CompletionMenu$CompletionItemMapper$registerSynchronizers$$inlined$writableProperty$1(this, completionMenuMode);
    conf.x4v(syncOneWay(selected, tmp$ret$0));
  };
  protoOf(CompletionItemMapper).vm5 = function () {
    if (!this.ql9_1.qlc()) {
      return Unit_instance;
    }
    var dimension = get_dimension(this.ql9_1);
    if (dimension.fku_1 === 0 && dimension.eku_1 === 0) {
      return Unit_instance;
    }
    scrollTo_2(this.ql9_1, new Rectangle(Companion_getInstance_251().iku_1, new Vector(1, dimension.fku_1)));
  };
  function ColorScheme() {
    this.cm7_1 = null;
    this.dm7_1 = null;
    this.em7_1 = null;
  }
  protoOf(ColorScheme).wm7 = function (whenNoSelection) {
    this.cm7_1 = whenNoSelection;
    return this;
  };
  protoOf(ColorScheme).xm7 = function (whenPreviewSelection) {
    this.dm7_1 = whenPreviewSelection;
    return this;
  };
  protoOf(ColorScheme).ym7 = function (whenNormalSelection) {
    this.em7_1 = whenNormalSelection;
    return this;
  };
  protoOf(ColorScheme).qm7 = function (selected, mode, matches) {
    return ensureNotNull(this.cm8(selected, mode)).zm7_1.fm8(matches);
  };
  protoOf(ColorScheme).rm7 = function (selected, mode) {
    return ensureNotNull(this.cm8(selected, mode)).am8_1;
  };
  protoOf(ColorScheme).fm7 = function (mode) {
    return ensureNotNull(this.gm8(true, mode)).bm8_1;
  };
  protoOf(ColorScheme).cm8 = function (selected, mode) {
    return this.gm8(selected.qr(), mode.qr());
  };
  protoOf(ColorScheme).gm8 = function (selected, mode) {
    if (!selected) {
      return this.cm7_1;
    }
    var tmp;
    switch (mode.a3_1) {
      case 0:
        tmp = this.dm7_1;
        break;
      case 1:
        tmp = this.em7_1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  function ItemColors(textColors, additional) {
    this.zm7_1 = textColors;
    this.am8_1 = additional;
    this.bm8_1 = null;
  }
  protoOf(ItemColors).hm8 = function (background) {
    this.bm8_1 = background;
    return this;
  };
  function TextColors(match, noMatch) {
    this.dm8_1 = match;
    this.em8_1 = noMatch;
  }
  protoOf(TextColors).fm8 = function (matches) {
    return matches.qr() ? this.dm8_1 : this.em8_1;
  };
  function CompletionMenu$createCell$$inlined$toDisposable$1($mapper) {
    this.im8_1 = $mapper;
  }
  protoOf(CompletionMenu$createCell$$inlined$toDisposable$1).vr = function () {
    this.im8_1.vlc();
    return Unit_instance;
  };
  function CompletionMenu() {
    CompletionMenu_instance = this;
    this.zm3_1 = new Color(159, 182, 198);
    this.am4_1 = new Color(0, 62, 149);
    this.bm4_1 = new Color(247, 232, 193);
    this.cm4_1 = new Color(96, 96, 96);
    this.dm4_1 = (new ColorScheme()).wm7(new ItemColors(new TextColors(Companion_getInstance_325().jlt_1, Companion_getInstance_325().uls_1), Companion_getInstance_325().xls_1)).xm7((new ItemColors(new TextColors(Companion_getInstance_325().llt_1, Companion_getInstance_325().uls_1), this.cm4_1)).hm8(this.zm3_1)).ym7((new ItemColors(new TextColors(this.bm4_1, Companion_getInstance_325().sls_1), Companion_getInstance_325().wls_1)).hm8(this.am4_1));
    this.em4_1 = new Color(226, 242, 254);
    this.fm4_1 = new Color(253, 255, 218);
    this.gm4_1 = new Border(Companion_getInstance_325().vls_1, 1);
    this.hm4_1 = new Vector(600, 200);
    this.im4_1 = new Vector(150, 50);
    this.jm4_1 = new Vector(600, 200);
    this.km4_1 = new Vector(150, 50);
    this.lm4_1 = new CompletionMenuTrait();
  }
  protoOf(CompletionMenu).jm8 = function (model, completer, renderer, reg, emptyCompletionDelay) {
    var mapper = new CompletionMenuModelMapper(model, renderer, completer, emptyCompletionDelay);
    mapper.ulc();
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$0 = new CompletionMenu$createCell$$inlined$toDisposable$1(mapper);
    reg.ur([tmp$ret$0]);
    return mapper.ql9_1;
  };
  var CompletionMenu_instance;
  function CompletionMenu_getInstance() {
    if (CompletionMenu_instance == null)
      new CompletionMenu();
    return CompletionMenu_instance;
  }
  var CompletionMode_AUTO_INPLACE_instance;
  var CompletionMode_INPLACE_instance;
  var CompletionMode_INSERT_instance;
  var CompletionMode_INSERT_WITH_SPACE_instance;
  var CompletionMode_entriesInitialized;
  function CompletionMode_initEntries() {
    if (CompletionMode_entriesInitialized)
      return Unit_instance;
    CompletionMode_entriesInitialized = true;
    CompletionMode_AUTO_INPLACE_instance = new CompletionMode('AUTO_INPLACE', 0);
    CompletionMode_INPLACE_instance = new CompletionMode('INPLACE', 1);
    CompletionMode_INSERT_instance = new CompletionMode('INSERT', 2);
    CompletionMode_INSERT_WITH_SPACE_instance = new CompletionMode('INSERT_WITH_SPACE', 3);
  }
  function CompletionMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CompletionMode_AUTO_INPLACE_getInstance() {
    CompletionMode_initEntries();
    return CompletionMode_AUTO_INPLACE_instance;
  }
  function CompletionMode_INPLACE_getInstance() {
    CompletionMode_initEntries();
    return CompletionMode_INPLACE_instance;
  }
  function CompletionMode_INSERT_getInstance() {
    CompletionMode_initEntries();
    return CompletionMode_INSERT_instance;
  }
  function CompletionMode_INSERT_WITH_SPACE_getInstance() {
    CompletionMode_initEntries();
    return CompletionMode_INSERT_WITH_SPACE_instance;
  }
  function createInplaceEvent($this) {
    var event = KeyEvent_init_$Create$(Key_TAB_getInstance());
    event.nl0(Companion_instance_266.klp($this.mm7_1));
    return event;
  }
  function setCompletionMode($this, event) {
    var tmp;
    if (event instanceof KeyEvent) {
      tmp = $this.mm7_1.bln(CompletionSupport_getInstance().lm2_1, getCompletionMode($this, event));
    } else {
      tmp = Companion_getInstance_25().wr_1;
    }
    return tmp;
  }
  function getCompletionMode($this, event) {
    return event.ml1(Key_ENTER_getInstance(), []) ? CompletionMode_INSERT_getInstance() : event.ml1(Key_SPACE_getInstance(), []) ? CompletionMode_INSERT_WITH_SPACE_getInstance() : event.ml1(Key_TAB_getInstance(), []) ? CompletionMode_INPLACE_getInstance() : $this.mm7_1.clo(CompletionSupport_getInstance().lm2_1);
  }
  function CompletionSupport$Completer$completeInCommand$lambda(this$0, $item) {
    return function () {
      this$0.om7($item, createInplaceEvent(this$0));
      return Unit_instance;
    };
  }
  function canComplete($this, cell) {
    var current = ensureNotNull(cell.llk()).rlp().qr();
    while (!(current === cell)) {
      var parent = ensureNotNull(current).yt();
      // Inline function 'kotlin.checkNotNull' call
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (parent == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      var index = parent.g2r().t(current);
      if (!(index === 0)) {
        return false;
      }
      current = parent;
    }
    return true;
  }
  function closeCompletionMenu($this, event) {
    event.ol0();
    $this.lm8_1._v.vr();
    $this.mm8_1();
  }
  function wrap_0($this, otherParams) {
    return new CompletionSupport$showSideTransformPopup$textEditingTrait$1$wrap$1($this.vm8_1, otherParams);
  }
  function CompletionSupport$showSideTransformPopup$1$get$$inlined$specMatcher$1$1($cacheable, $supplier, this$0, $wrap) {
    this.wm8_1 = $cacheable;
    this.xm8_1 = $supplier;
    this.ym8_1 = this$0;
    this.zm8_1 = $wrap;
  }
  protoOf(CompletionSupport$showSideTransformPopup$1$get$$inlined$specMatcher$1$1).um2 = function () {
    return this.wm8_1;
  };
  protoOf(CompletionSupport$showSideTransformPopup$1$get$$inlined$specMatcher$1$1).um1 = function (completionContext) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.<no name provided>.get.<anonymous>.<anonymous>' call
    return this.xm8_1.um1(wrap_0(this.ym8_1, completionContext)).am9().cm9(this.zm8_1).qr();
  };
  function CompletionSupport$showSideTransformPopup$o$get$lambda($spec, $supplier, this$0, $wrap) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        // Inline function 'jetbrains.ocelot.projectional.cell.completion.<no name provided>.get.<anonymous>' call
        // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.completionSupplier' call
        var tmp$ret$1 = new CompletionSupport$showSideTransformPopup$1$get$$inlined$specMatcher$1$1(false, $supplier, this$0, $wrap);
        tmp = new SpecMatchResult(tmp$ret$1);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function CompletionSupport$showSideTransformPopup$textEditingTrait$1$wrap$1($endRT, $otherParams) {
    this.dm9_1 = $endRT;
    this.em9_1 = $otherParams;
    BaseCompletionContext.call(this);
  }
  protoOf(CompletionSupport$showSideTransformPopup$textEditingTrait$1$wrap$1).fm9 = function () {
    return this.em9_1.fm9();
  };
  function bindPosition($this, source, popup) {
    return PropertyBinding_instance.d2g(source.flp(Completion_getInstance().km1_1), popup.flp(get_POPUP_X_POSITION()));
  }
  function validateNoPositioning($this, cell) {
    assertNoPositioning($this, cell, cell.clo(Completion_getInstance().km1_1));
    var tmp = cell.flp(Completion_getInstance().km1_1);
    return tmp.p27(CompletionSupport$validateNoPositioning$lambda(cell));
  }
  function assertNoPositioning($this, cell, pos) {
    // Inline function 'kotlin.check' call
    if (!(pos === 0)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.CompletionSupport.assertNoPositioning.<anonymous>' call
      var message = 'Positioning only allowed for menu created on editable TextCell, but encountered: ' + toString_1(cell);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function prefixText($this, textCell) {
    return new CompletionSupport$prefixText$1(textCell);
  }
  function connect_0($this, source, target) {
    target.ylp($this.nm2_1, source);
    return source.ylp($this.om2_1, target);
  }
  function Completer(source, handler) {
    this.mm7_1 = source;
    this.nm7_1 = handler;
  }
  protoOf(Completer).gm9 = function (item) {
    var tmp = ensureNotNull(this.mm7_1.llk());
    tmp.hm9(CompletionSupport$Completer$completeInCommand$lambda(this, item));
  };
  protoOf(Completer).om7 = function (item, cause) {
    var modeReg = setCompletionMode(this, cause);
    try {
      this.nm7_1(ensureNotNull(item));
    }finally {
      modeReg.vr();
    }
    cause.ol0();
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_12(function_0) {
    this.im9_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_12).wy = function () {
    return this.im9_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_12).b4 = function () {
    return this.im9_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_12).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_12).hashCode = function () {
    return hashCode(this.b4());
  };
  function CompletionSupport$SOURCE$lambda(cell) {
    return cell;
  }
  function CompletionSupport$TARGET$lambda(cell) {
    return cell;
  }
  function CompletionSupport$TRAIT$1() {
    CellTrait.call(this);
  }
  protoOf(CompletionSupport$TRAIT$1).alp = function (cell, event) {
    if (canComplete(this, cell)) {
      var controller = Completion_getInstance().am3(cell);
      if (!controller.ft() && controller.im2()) {
        controller.jm2(Companion_getInstance_284().om9(event.lm9_1).k2p());
      }
      event.ol0();
    }
    protoOf(CellTrait).alp.call(this, cell, event);
  };
  function CompletionSupport$showCompletion$lambda($completionReg, $restoreEnvState, $prefixText) {
    return function (item) {
      $completionReg._v.vr();
      $restoreEnvState();
      item.wm9($prefixText.qr())();
      return Unit_instance;
    };
  }
  function CompletionSupport$showCompletion$lambda_0($completer, $menuModel) {
    return function (event) {
      var tmp;
      if (event.p2e_1) {
        $completer.gm9($menuModel.gm5_1.qr());
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CompletionSupport$showCompletion$$inlined$toDisposable$1($singleOptionCompletionReg) {
    this.xm9_1 = $singleOptionCompletionReg;
  }
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$1).vr = function () {
    this.xm9_1._v.vr();
    return Unit_instance;
  };
  function CompletionSupport$showCompletion$lambda$lambda($menuModel, $event) {
    return function () {
      $menuModel.bm5_1.t2c($event.p2e_1);
      return Unit_instance;
    };
  }
  function CompletionSupport$showCompletion$lambda_1($singleOptionCompletionReg, $editor, $menuModel) {
    return function (event) {
      $singleOptionCompletionReg._v.vr();
      $singleOptionCompletionReg._v = Companion_getInstance_25().wr_1;
      var tmp = ensureNotNull($editor.llk()).elq();
      var tmp_0 = CompletionSupport$showCompletion$lambda$lambda($menuModel, event);
      tmp.u2m(new sam$jetbrains_ocelot_base_edt_EdtTask$0_12(tmp_0));
      return Unit_instance;
    };
  }
  function CompletionSupport$showCompletion$$inlined$writableProperty$1($itemsShownConsumer) {
    this.ym9_1 = $itemsShownConsumer;
  }
  protoOf(CompletionSupport$showCompletion$$inlined$writableProperty$1).bm7 = function (newValue) {
    var tmp;
    if (newValue) {
      tmp = this.ym9_1(true);
    }
    return tmp;
  };
  protoOf(CompletionSupport$showCompletion$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function CompletionSupport$showCompletion$$inlined$toDisposable$2($itemsShownConsumer) {
    this.zm9_1 = $itemsShownConsumer;
  }
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$2).vr = function () {
    return this.zm9_1(false);
  };
  function CompletionSupport$showCompletion$3($menuModel, $completionReg, $restoreEnvState, $completer, $completionCell, $editor) {
    this.km8_1 = $menuModel;
    this.lm8_1 = $completionReg;
    this.mm8_1 = $restoreEnvState;
    this.nm8_1 = $completer;
    this.om8_1 = $completionCell;
    this.pm8_1 = $editor;
    CellTrait.call(this);
  }
  protoOf(CompletionSupport$showCompletion$3).ilo = function (cell, event) {
    if (!this.km8_1.im5_1.qr()) {
      this.lm8_1._v.vr();
    }
  };
  protoOf(CompletionSupport$showCompletion$3).llm = function (cell, event) {
    if (event.ml1(Key_ESCAPE_getInstance(), [])) {
      closeCompletionMenu(this, event);
      return Unit_instance;
    }
    if (event.ol1([KeyStrokeSpecs_getInstance().jl2_1])) {
      event.ol0();
      this.km8_1.im5_1.t2c(!this.km8_1.im5_1.qr());
      return Unit_instance;
    }
    var selectedItem = this.km8_1.gm5_1.qr();
    if (event.ml1(Key_SPACE_getInstance(), []) && this.km8_1.jm5_1) {
      if (!(selectedItem == null) && this.km8_1.vm7().qr().equals(CompletionItemSelectionMode_NORMAL_getInstance())) {
        this.nm8_1.om7(selectedItem, event);
      } else {
        closeCompletionMenu(this, event);
      }
      return Unit_instance;
    }
    if (selectedItem == null)
      return Unit_instance;
    if (event.ml1(Key_ENTER_getInstance(), []) || event.ml1(Key_TAB_getInstance(), [])) {
      this.nm8_1.om7(selectedItem, event);
      return Unit_instance;
    }
    if (event.ml1(Key_UP_getInstance(), [])) {
      this.km8_1.ama();
      event.ol0();
      return Unit_instance;
    }
    if (event.ml1(Key_DOWN_getInstance(), [])) {
      this.km8_1.bma();
      event.ol0();
      return Unit_instance;
    }
    if (event.ml1(Key_PAGE_UP_getInstance(), []) || event.ml1(Key_PAGE_DOWN_getInstance(), [])) {
      var pageHeight = get_dimension(this.om8_1).fku_1 / get_dimension(this.pm8_1).fku_1 | 0;
      var inductionVariable = 0;
      if (inductionVariable < pageHeight)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (event.ml1(Key_PAGE_DOWN_getInstance(), [])) {
            this.km8_1.bma();
          } else {
            this.km8_1.ama();
          }
        }
         while (inductionVariable < pageHeight);
      event.ol0();
    }
  };
  protoOf(CompletionSupport$showCompletion$3).flo = function (cell, spec) {
    if (spec === CompletionSupport_getInstance().pm2_1) {
      return this.km8_1.vm7().qr().equals(CompletionItemSelectionMode_PREVIEW_getInstance());
    }
    var tmp;
    if (spec === CompletionSupport_getInstance().mm2_1) {
      tmp = this.km8_1;
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function CompletionSupport$showCompletion$$inlined$toDisposable$3($completionCell, $disposeMenuMapper, $positionBinding) {
    this.cma_1 = $completionCell;
    this.dma_1 = $disposeMenuMapper;
    this.ema_1 = $positionBinding;
  }
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$3).vr = function () {
    if (this.cma_1.qlc()) {
      this.cma_1.n3b();
    }
    this.dma_1.vr();
    this.ema_1.vr();
    return Unit_instance;
  };
  function CompletionSupport$showCompletion$lambda_2($completionReg) {
    return function (it) {
      $completionReg._v.vr();
      return Unit_instance;
    };
  }
  function CompletionSupport$showCompletion$$inlined$toDisposable$4($restoreEnvState) {
    this.fma_1 = $restoreEnvState;
  }
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$4).vr = function () {
    return this.fma_1();
  };
  function CompletionSupport$validateNoPositioning$lambda($cell) {
    return function (e) {
      assertNoPositioning(CompletionSupport_getInstance(), $cell, e.p2e_1);
      return Unit_instance;
    };
  }
  function CompletionSupport$prefixText$1($textCell) {
    this.kma_1 = $textCell;
    DerivedProperty.call(this, [$textCell.zlt()]);
  }
  protoOf(CompletionSupport$prefixText$1).g2c = function () {
    return this.kma_1.ylt();
  };
  protoOf(CompletionSupport$prefixText$1).l2c = function () {
    return 'prefixText(' + this.kma_1.toString() + ')';
  };
  function CompletionSupport$showSideTransformPopup$wrap$1$1($input, $completed) {
    this.mma_1 = $completed;
    WrapperCompletionItem.call(this, $input);
  }
  protoOf(CompletionSupport$showSideTransformPopup$wrap$1$1).wm9 = function (text) {
    this.mma_1._v = true;
    return protoOf(WrapperCompletionItem).wm9.call(this, text);
  };
  function CompletionSupport$showSideTransformPopup$lambda($completed) {
    return function (input) {
      return new CompletionSupport$showSideTransformPopup$wrap$1$1(input, $completed);
    };
  }
  function CompletionSupport$showSideTransformPopup$lambda_0(it) {
    return Unit_instance;
  }
  function CompletionSupport$showSideTransformPopup$textEditingTrait$1($supplier, $wrap, $dismiss, $cell, $container, $endRT) {
    this.qm8_1 = $supplier;
    this.rm8_1 = $wrap;
    this.sm8_1 = $dismiss;
    this.tm8_1 = $cell;
    this.um8_1 = $container;
    this.vm8_1 = $endRT;
    TextEditingTrait.call(this);
  }
  protoOf(CompletionSupport$showSideTransformPopup$textEditingTrait$1).flo = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec_0 = Completion_getInstance().cm1_1;
    var specMatcher = CompletionSupport$showSideTransformPopup$o$get$lambda(spec_0, this.qm8_1, this, this.rm8_1);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.<no name provided>.get.<anonymous>' call
      tmp = protoOf(TextEditingTrait).flo.call(this, cell, spec);
    } else {
      tmp = result.sma_1;
    }
    return tmp;
  };
  protoOf(CompletionSupport$showSideTransformPopup$textEditingTrait$1).qlm = function (cell, prop, event) {
    if (prop === Companion_getInstance_271().als_1) {
      var tmp = event.p2e_1;
      // Inline function 'kotlin.text.isEmpty' call
      var this_0 = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
      if (charSequenceLength(this_0) === 0) {
        this.sm8_1._v(false);
      }
    }
    protoOf(TextEditingTrait).qlm.call(this, cell, prop, event);
  };
  protoOf(CompletionSupport$showSideTransformPopup$textEditingTrait$1).llm = function (cell, event) {
    var tmp;
    if (event.ml1(Key_ESCAPE_getInstance(), [])) {
      this.sm8_1._v(false);
      event.ol0();
      tmp = Unit_instance;
    } else {
      protoOf(TextEditingTrait).llm.call(this, cell, event);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(CompletionSupport$showSideTransformPopup$textEditingTrait$1).tma = function (editor, typed) {
    if (protoOf(TextEditingTrait).tma.call(this, editor, typed))
      return true;
    if (!editor.blu())
      return false;
    var text = editor.laz().qr();
    var completionResult = this.qm8_1.um1(wrap_0(this, Companion_getInstance_281().qm1_1));
    if (!get_isReady(completionResult))
      return false;
    var completion = CompletionItems_init_$Create$(this.qm8_1.um1(wrap_0(this, Companion_getInstance_281().qm1_1)));
    if (completion.vma(text, this.tm8_1.ulp(TextEditing_getInstance().ilx_1))) {
      completion.uma(text).q(0).wm9(text)();
      return true;
    }
    var prefix = dropLast_0(text, 1);
    // Inline function 'kotlin.text.substring' call
    var startIndex = text.length - 1 | 0;
    // Inline function 'kotlin.js.asDynamic' call
    var suffix = text.substring(startIndex);
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(prefix) > 0) {
      tmp_0 = completion.uma(prefix).n() === 1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = completion.hm2(text).p();
    } else {
      tmp = false;
    }
    if (tmp) {
      completion.uma(prefix).q(0).wm9(prefix)();
      var inductionVariable = 0;
      var last = suffix.length;
      while (inductionVariable < last) {
        var element = charSequenceGet(suffix, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        this.um8_1.ll5(KeyEvent_init_$Create$(Key_UNKNOWN_getInstance(), element));
      }
      return true;
    }
    return false;
  };
  protoOf(CompletionSupport$showSideTransformPopup$textEditingTrait$1).ilo = function (cell, event) {
    protoOf(TextEditingTrait).ilo.call(this, cell, event);
    this.sm8_1._v(true);
  };
  function CompletionSupport$showSideTransformPopup$lambda_1($dismissed, $popup, $traitReg, $targetRegistration, $completed, $restoreState) {
    return function (focusLoss) {
      var tmp;
      if (!$dismissed._v) {
        $dismissed._v = true;
        $popup.n3b();
        $traitReg.vr();
        $targetRegistration.vr();
        var tmp_0;
        if (!$completed._v && !focusLoss) {
          tmp_0 = $restoreState();
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function CompletionSupport() {
    CompletionSupport_instance = this;
    this.lm2_1 = CellPropertySpec_init_$Create$('completionMode', CompletionMode_AUTO_INPLACE_getInstance());
    this.mm2_1 = CellTraitPropertySpec_init_$Create$('model', null);
    var tmp = this;
    tmp.nm2_1 = new CellTraitPropertySpec('completionSource', CompletionSupport$SOURCE$lambda);
    var tmp_0 = this;
    tmp_0.om2_1 = new CellTraitPropertySpec('completionBase', CompletionSupport$TARGET$lambda);
    this.pm2_1 = CellTraitPropertySpec_init_$Create$('isPreviewSelection', false);
    var tmp_1 = this;
    tmp_1.qm2_1 = new CompletionSupport$TRAIT$1();
  }
  protoOf(CompletionSupport).bmb = function () {
    return this.qm2_1;
  };
  protoOf(CompletionSupport).rm2 = function (editor, completionResult, parameters, cellCleanup, restoreCellsState) {
    // Inline function 'kotlin.require' call
    if (!editor.qlp().qr()) {
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.CompletionSupport.showCompletion.<anonymous>' call
      var message = 'Editor is not focused';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var completionSource = editor.ulp(this.nm2_1);
    var prefixText_0 = prefixText(this, editor);
    var builder = Companion_getInstance_283().gmb(completionResult).omb(prefixText_0.qr()).wmb(parameters.rmb_1).xmb(completionSource.ulp(Completion_getInstance().lm1_1));
    var tmp0_safe_receiver = parameters.smb_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.CompletionSupport.showCompletion.stub_for_inlining' call
      builder.ymb(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = parameters.tmb_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.CompletionSupport.showCompletion.stub_for_inlining' call
      builder.zmb(tmp1_safe_receiver);
    }
    var tmp2_safe_receiver = parameters.umb_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.CompletionSupport.showCompletion.stub_for_inlining' call
      builder.amc(tmp2_safe_receiver);
    }
    var menuModel = builder.k2p();
    var completionReg = {_v: menuModel.sr(cellCleanup)};
    var restoreEnvState = seqActions([restoreCellsState, parameters.pmb_1]);
    var completer = new Completer(completionSource, CompletionSupport$showCompletion$lambda(completionReg, restoreEnvState, prefixText_0));
    var singleOptionCompletionReg = {_v: Companion_getInstance_25().wr_1};
    var tmp;
    if (parameters.qmb_1) {
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = prefixText_0.qr();
      tmp = charSequenceLength(this_0) > 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      var completeSelected = Properties_getInstance().r2d([menuModel.bmc(), menuModel.em5_1]);
      if (completeSelected.qr()) {
        completer.gm9(menuModel.gm5_1.qr());
        return Companion_getInstance_25().wr_1;
      }
      singleOptionCompletionReg._v = completeSelected.p27(CompletionSupport$showCompletion$lambda_0(completer, menuModel));
      var tmp_0 = completionReg._v;
      // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
      var tmp$ret$8 = new CompletionSupport$showCompletion$$inlined$toDisposable$1(singleOptionCompletionReg);
      completionReg._v = tmp_0.sr(tmp$ret$8);
    }
    var tmp_1 = completionReg._v;
    completionReg._v = tmp_1.sr(prefixText_0.p27(CompletionSupport$showCompletion$lambda_1(singleOptionCompletionReg, editor, menuModel)));
    var itemsShownConsumer = completionSource.ulp(Completion_getInstance().jm1_1);
    var tmp_2 = completionReg._v;
    var tmp_3 = PropertyBinding_instance;
    var tmp_4 = notNull(menuModel.gm5_1);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$9 = new CompletionSupport$showCompletion$$inlined$writableProperty$1(itemsShownConsumer);
    completionReg._v = tmp_2.sr(tmp_3.d2g(tmp_4, tmp$ret$9));
    var tmp_5 = completionReg._v;
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$10 = new CompletionSupport$showCompletion$$inlined$toDisposable$2(itemsShownConsumer);
    completionReg._v = tmp_5.sr(tmp$ret$10);
    var disposeMenuMapper = new CompositeDisposable([]);
    var renderer = completionSource.ulp(Completion_getInstance().im1_1);
    var completionCell = CompletionMenu_getInstance().jm8(menuModel, completer, renderer, disposeMenuMapper, parameters.vmb_1);
    var tmp_6 = completionReg._v;
    completionReg._v = tmp_6.sr(editor.olp(new CompletionSupport$showCompletion$3(menuModel, completionReg, restoreEnvState, completer, completionCell, editor)));
    var positionBinding = completionSource === editor ? bindPosition(this, completionSource, completionCell) : validateNoPositioning(this, completionSource);
    var tmp_7 = completionReg._v;
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$11 = new CompletionSupport$showCompletion$$inlined$toDisposable$3(completionCell, disposeMenuMapper, positionBinding);
    completionReg._v = tmp_7.sr(tmp$ret$11);
    get_bottomPopupProp(editor).t2c(completionCell);
    var tmp_8 = completionReg._v;
    var tmp_9 = get_bottomPopupProp(editor);
    completionReg._v = tmp_8.sr(tmp_9.p27(CompletionSupport$showCompletion$lambda_2(completionReg)));
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return (new CompletionSupport$showCompletion$$inlined$toDisposable$4(restoreEnvState)).sr(completionReg._v);
  };
  protoOf(CompletionSupport).cmc = function (cell, side, supplier, endRT) {
    // Inline function 'kotlin.check' call
    if (!(cell.clo(side) == null)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.CompletionSupport.showSideTransformPopup.<anonymous>' call
      var message = 'Popup is already set: cell=' + toString_1(cell) + ', side=' + side.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var container = cell.llk();
    var completed = {_v: false};
    var dismissed = {_v: false};
    var restoreState = ensureNotNull(container).km2();
    var wrap = CompletionSupport$showSideTransformPopup$lambda(completed);
    var popup = new HorizontalCell();
    var textCell = TextCell_init_$Create$();
    var dismiss = {_v: CompletionSupport$showSideTransformPopup$lambda_0};
    textCell.hlp().t2c(true);
    var textEditingTrait = new CompletionSupport$showSideTransformPopup$textEditingTrait$1(supplier, wrap, dismiss, cell, container, endRT);
    var traitReg = textCell.olp(textEditingTrait);
    popup.g2r().e(textCell);
    cell.bln(side, popup);
    var targetRegistration = connect_0(this, cell, textCell);
    textCell.ul5();
    dismiss._v = CompletionSupport$showSideTransformPopup$lambda_1(dismissed, popup, traitReg, targetRegistration, completed, restoreState);
    return textCell;
  };
  var CompletionSupport_instance;
  function CompletionSupport_getInstance() {
    if (CompletionSupport_instance == null)
      new CompletionSupport();
    return CompletionSupport_instance;
  }
  function DefaultCompletionConfig() {
    BaseCompletionConfig.call(this);
  }
  protoOf(DefaultCompletionConfig).xm0 = function (completionItems, prefixText) {
    var matches = completionItems.uma(prefixText);
    var strictlyPrefixed = completionItems.dmc(prefixText);
    return matches.n() === 1 && strictlyPrefixed.p();
  };
  function PopupCompletionEditor$1() {
    TextEditingTrait.call(this);
  }
  protoOf(PopupCompletionEditor$1).alp = function (cell, event) {
  };
  function PopupCompletionEditor$$inlined$toDisposable$1($popup) {
    this.emc_1 = $popup;
  }
  protoOf(PopupCompletionEditor$$inlined$toDisposable$1).vr = function () {
    this.emc_1.n3b();
    return Unit_instance;
  };
  function PopupCompletionEditor(cell) {
    // Inline function 'kotlin.check' call
    if (!(get_frontPopup(cell) == null)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.PopupCompletionEditor.<anonymous>' call
      var message = "Can't create editor: front popup is already set";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.fmc_1 = TextCell_init_$Create$();
    this.fmc_1.hlp().t2c(true);
    this.fmc_1.olp(new PopupCompletionEditor$1());
    var popup = new HorizontalCell();
    popup.g2r().e(this.fmc_1);
    get_frontPopupProp(cell).t2c(popup);
    var tmp = this;
    var tmp_0 = this.fmc_1.ylp(CompletionSupport_getInstance().nm2_1, cell);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$1 = new PopupCompletionEditor$$inlined$toDisposable$1(popup);
    tmp.gmc_1 = tmp_0.sr(tmp$ret$1);
  }
  protoOf(PopupCompletionEditor).om1 = function () {
    return this.fmc_1;
  };
  protoOf(PopupCompletionEditor).vr = function () {
    return this.gmc_1.vr();
  };
  function Side$LEFT() {
    Side_0.call(this, 'LEFT', 0);
    Side_LEFT_instance = this;
  }
  protoOf(Side$LEFT).jmc = function () {
    return get_LEFT_POPUP();
  };
  protoOf(Side$LEFT).kmc = function () {
    return Completion_getInstance().dm1_1;
  };
  protoOf(Side$LEFT).lmc = function () {
    return Completion_getInstance().fm1_1;
  };
  var Side_LEFT_instance;
  function Side$RIGHT() {
    Side_0.call(this, 'RIGHT', 1);
    Side_RIGHT_instance = this;
  }
  protoOf(Side$RIGHT).jmc = function () {
    return get_RIGHT_POPUP();
  };
  protoOf(Side$RIGHT).kmc = function () {
    return Completion_getInstance().em1_1;
  };
  protoOf(Side$RIGHT).lmc = function () {
    return Completion_getInstance().gm1_1;
  };
  var Side_RIGHT_instance;
  function expand_0($this, editor, sideText) {
    var expanderFunction = editor.ulp($this.lmc());
    var cellAction = expanderFunction(sideText);
    cellAction();
  }
  function Side$expansionProvider$lambda$lambda($cell, this$0) {
    return function (sideText) {
      var popupCell = CompletionSupport_getInstance().cmc($cell, this$0.jmc(), $cell.ulp(this$0.kmc()), false);
      popupCell.laz().t2c(sideText);
      return toEnd_0(popupCell);
    };
  }
  function Side$expansionProvider$lambda(this$0) {
    return function (cell) {
      return Side$expansionProvider$lambda$lambda(cell, this$0);
    };
  }
  function Side$handleSideTransform$lambda($editor, $cellText, $sideCompletion, $sideText) {
    return function () {
      $editor.laz().t2c($cellText);
      $sideCompletion.pmc($sideText);
      return Unit_instance;
    };
  }
  function Side$handleSideTransform$lambda_0($editor, $cellText, this$0, $sideText) {
    return function () {
      $editor.laz().t2c($cellText);
      expand_0(this$0, $editor, $sideText);
      return Unit_instance;
    };
  }
  var Side_entriesInitialized;
  function Side_initEntries() {
    if (Side_entriesInitialized)
      return Unit_instance;
    Side_entriesInitialized = true;
    Side_LEFT_instance = new Side$LEFT();
    Side_RIGHT_instance = new Side$RIGHT();
  }
  function Side_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(Side_0).xm2 = function () {
    return Side$expansionProvider$lambda(this);
  };
  protoOf(Side_0).mmc = function (editor, cellText, sideText, eagerCompletion) {
    var completionResult = Completion_getInstance().cm3(editor, Companion_getInstance_281().qm1_1, this.kmc());
    if (!get_isReady(completionResult))
      return false;
    var sideCompletion = CompletionItems_init_$Create$(completionResult);
    var tmp;
    if (sideCompletion.vma(sideText, eagerCompletion)) {
      var tmp_0 = ensureNotNull(editor.llk());
      tmp_0.hm9(Side$handleSideTransform$lambda(editor, cellText, sideCompletion, sideText));
      tmp = true;
    } else if (sideCompletion.qmc(sideText)) {
      var tmp_1 = ensureNotNull(editor.llk());
      tmp_1.hm9(Side$handleSideTransform$lambda_0(editor, cellText, this, sideText));
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Side_LEFT_getInstance() {
    Side_initEntries();
    return Side_LEFT_instance;
  }
  function Side_RIGHT_getInstance() {
    Side_initEntries();
    return Side_RIGHT_instance;
  }
  function SimpleCompletionEditor(editor) {
    this.rmc_1 = editor;
  }
  protoOf(SimpleCompletionEditor).om1 = function () {
    return this.rmc_1;
  };
  protoOf(SimpleCompletionEditor).vr = function () {
  };
  function BaseCompletionContext() {
  }
  protoOf(BaseCompletionContext).fm9 = function () {
    return false;
  };
  function CompletionContext$Companion$MENU$1() {
    BaseCompletionContext.call(this);
  }
  protoOf(CompletionContext$Companion$MENU$1).fm9 = function () {
    return true;
  };
  function CompletionContext$Companion$BULK$1() {
    BaseCompletionContext.call(this);
  }
  function CompletionContext$Companion$TOKENIZATION$1() {
    BaseCompletionContext.call(this);
  }
  function Companion_281() {
    Companion_instance_281 = this;
    this.qm1_1 = new BaseCompletionContext();
    var tmp = this;
    tmp.rm1_1 = new CompletionContext$Companion$MENU$1();
    var tmp_0 = this;
    tmp_0.sm1_1 = new CompletionContext$Companion$BULK$1();
    var tmp_1 = this;
    tmp_1.tm1_1 = new CompletionContext$Companion$TOKENIZATION$1();
  }
  var Companion_instance_281;
  function Companion_getInstance_281() {
    if (Companion_instance_281 == null)
      new Companion_281();
    return Companion_instance_281;
  }
  function CompletionSupplement() {
  }
  protoOf(CompletionSupplement).smc = function (items) {
    return toCompletionSupplier(items);
  };
  var CompletionSupplement_instance;
  function CompletionSupplement_getInstance() {
    return CompletionSupplement_instance;
  }
  function get_EMPTY_COMPLETION_SUPPLIER() {
    _init_properties_CompletionSupplier_kt__qq82i0();
    return EMPTY_COMPLETION_SUPPLIER;
  }
  var EMPTY_COMPLETION_SUPPLIER;
  function toCompletionSupplier(_this__u8e3s4) {
    _init_properties_CompletionSupplier_kt__qq82i0();
    return toCompletionSupplier_0(toList(_this__u8e3s4));
  }
  function toCompletionSupplier_0(_this__u8e3s4) {
    _init_properties_CompletionSupplier_kt__qq82i0();
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.completionSupplier' call
    return new toCompletionSupplier$$inlined$completionSupplier$1(true, _this__u8e3s4);
  }
  function simpleCompletionSupplier(items) {
    _init_properties_CompletionSupplier_kt__qq82i0();
    return toCompletionSupplier(items);
  }
  function EMPTY_COMPLETION_SUPPLIER$$inlined$completionSupplier$1($cacheable) {
    this.tmc_1 = $cacheable;
  }
  protoOf(EMPTY_COMPLETION_SUPPLIER$$inlined$completionSupplier$1).um2 = function () {
    return this.tmc_1;
  };
  protoOf(EMPTY_COMPLETION_SUPPLIER$$inlined$completionSupplier$1).um1 = function (completionContext) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.EMPTY_COMPLETION_SUPPLIER.<anonymous>' call
    return Companion_getInstance_285().umc_1;
  };
  function toCompletionSupplier$$inlined$completionSupplier$1($cacheable, $this_toCompletionSupplier) {
    this.vmc_1 = $cacheable;
    this.wmc_1 = $this_toCompletionSupplier;
  }
  protoOf(toCompletionSupplier$$inlined$completionSupplier$1).um2 = function () {
    return this.vmc_1;
  };
  protoOf(toCompletionSupplier$$inlined$completionSupplier$1).um1 = function (completionContext) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.toCompletionSupplier.<anonymous>' call
    return new SimpleCompletionResult(this.wmc_1);
  };
  var properties_initialized_CompletionSupplier_kt_83ae2y;
  function _init_properties_CompletionSupplier_kt__qq82i0() {
    if (!properties_initialized_CompletionSupplier_kt_83ae2y) {
      properties_initialized_CompletionSupplier_kt_83ae2y = true;
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.completionSupplier' call
      EMPTY_COMPLETION_SUPPLIER = new EMPTY_COMPLETION_SUPPLIER$$inlined$completionSupplier$1(true);
    }
  }
  var CompletionItemSelectionMode_PREVIEW_instance;
  var CompletionItemSelectionMode_NORMAL_instance;
  function Companion_282() {
  }
  protoOf(Companion_282).xmc = function (createdByAutoCompletion) {
    return createdByAutoCompletion ? CompletionItemSelectionMode_PREVIEW_getInstance() : CompletionItemSelectionMode_NORMAL_getInstance();
  };
  var Companion_instance_282;
  function Companion_getInstance_282() {
    return Companion_instance_282;
  }
  var CompletionItemSelectionMode_entriesInitialized;
  function CompletionItemSelectionMode_initEntries() {
    if (CompletionItemSelectionMode_entriesInitialized)
      return Unit_instance;
    CompletionItemSelectionMode_entriesInitialized = true;
    CompletionItemSelectionMode_PREVIEW_instance = new CompletionItemSelectionMode('PREVIEW', 0);
    CompletionItemSelectionMode_NORMAL_instance = new CompletionItemSelectionMode('NORMAL', 1);
  }
  function CompletionItemSelectionMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CompletionItemSelectionMode_PREVIEW_getInstance() {
    CompletionItemSelectionMode_initEntries();
    return CompletionItemSelectionMode_PREVIEW_instance;
  }
  function CompletionItemSelectionMode_NORMAL_getInstance() {
    CompletionItemSelectionMode_initEntries();
    return CompletionItemSelectionMode_NORMAL_instance;
  }
  function handleItem($this, item, loadMoreDistance) {
    if ($this.cmd_1)
      return Unit_instance;
    var index = lastIndexOf_1($this.hmd_1.cm5_1, item);
    if (!(index === -1) && hasNotLoadedItems($this) && $this.amd_1.qr().kmd($this.fmd_1, index, loadMoreDistance)) {
      $this.xm5();
    }
  }
  function hasNotLoadedItems($this) {
    return $this.fmd_1.n() < ensureNotNull($this.dmd_1).n();
  }
  function initAllItems($this) {
    var prefix = $this.hmd_1.bm5_1.qr();
    var result = filterByPrefix($this, prefix);
    return sortedWith(result, Companion_getInstance_283().fmb_1);
  }
  function doReInitItems($this, selectedItem) {
    $this.dmd_1 = initAllItems($this);
    $this.emd_1.t2c(ensureNotNull($this.dmd_1).n());
    var tmp;
    if (selectedItem == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.menuModel.MyVisibleItemsUpdater.doReInitItems.<anonymous>' call
      tmp = ensureNotNull($this.dmd_1).t(selectedItem);
    }
    var tmp1_elvis_lhs = tmp;
    var selectedIndex = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
    var initiallyVisible = $this.amd_1.qr().lmd(ensureNotNull($this.dmd_1), $this.ymc_1, selectedIndex);
    $this.fmd_1.m2();
    $this.fmd_1.o(initiallyVisible);
  }
  function filterByPrefix($this, prefix) {
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = $this.zmc_1.cq().k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      if (item.rma(prefix)) {
        result.e(item);
      }
    }
    return result;
  }
  function CompletionMenuModel$MyVisibleItemsUpdater$lambda(this$0) {
    return function (event) {
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = event.o2e_1;
      if (charSequenceLength(this_0) > 0) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlin.text.isNotEmpty' call
        var this_1 = event.p2e_1;
        tmp_0 = charSequenceLength(this_1) > 0;
      }
      if (tmp_0) {
        this$0.amd_1.t2c(LoadDirection_DOWN_getInstance());
        this$0.mmd(false);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CompletionMenuModel$MyVisibleItemsUpdater$lambda_0(this$0) {
    return function (event) {
      var tmp;
      if (event instanceof CompletionItemsAddedEvent) {
        this$0.mmd(false);
        tmp = Unit_instance;
      } else {
        if (event instanceof ErrorDuringCompletionItems) {
          this$0.gmd_1.t2c(true);
          tmp = Unit_instance;
        } else {
          noWhenBranchMatchedException();
        }
      }
      return Unit_instance;
    };
  }
  function CompletionMenuModel$MyVisibleItemsUpdater$lambda_1(this$0, $loadMoreSelectionDistance) {
    return function (it) {
      handleItem(this$0, it.p2e_1, $loadMoreSelectionDistance);
      return Unit_instance;
    };
  }
  function CompletionMenuModel$MyVisibleItemsUpdater$lambda_2(this$0, $loadMoreHoverDistance) {
    return function (it) {
      handleItem(this$0, it.p2e_1, $loadMoreHoverDistance);
      return Unit_instance;
    };
  }
  function CompletionMenuModel$MyVisibleItemsUpdater$reInitItems$lambda($selected) {
    return function (handler) {
      handler.d28($selected);
      return Unit_instance;
    };
  }
  function CompletionMenuModel$LoadDirection$DOWN() {
    LoadDirection.call(this, 'DOWN', 0);
    LoadDirection_DOWN_instance = this;
  }
  protoOf(CompletionMenuModel$LoadDirection$DOWN).kmd = function (loaded, index, loadMoreDistance) {
    return ((loaded.n() - 1 | 0) - index | 0) <= loadMoreDistance;
  };
  protoOf(CompletionMenuModel$LoadDirection$DOWN).pmd = function (loaded, chunk, all) {
    var lastLoaded = all.u(last(loaded));
    if (lastLoaded === get_lastIndex_2(all)) {
      return Unit_instance;
    }
    var tmp0 = lastLoaded + chunk | 0;
    // Inline function 'kotlin.math.min' call
    var b = get_lastIndex_2(all);
    var newLastLoaded = Math.min(tmp0, b);
    loaded.o(all.j2(lastLoaded + 1 | 0, newLastLoaded + 1 | 0));
  };
  protoOf(CompletionMenuModel$LoadDirection$DOWN).lmd = function (src, chunk, selected) {
    // Inline function 'kotlin.math.max' call
    var b = selected + 1 | 0;
    var tmp2 = Math.max(chunk, b);
    // Inline function 'kotlin.math.min' call
    var b_0 = src.n();
    var tmp$ret$1 = Math.min(tmp2, b_0);
    return src.j2(0, tmp$ret$1);
  };
  var LoadDirection_DOWN_instance;
  function CompletionMenuModel$LoadDirection$UP() {
    LoadDirection.call(this, 'UP', 1);
    LoadDirection_UP_instance = this;
  }
  protoOf(CompletionMenuModel$LoadDirection$UP).kmd = function (loaded, index, loadMoreDistance) {
    return index <= loadMoreDistance;
  };
  protoOf(CompletionMenuModel$LoadDirection$UP).pmd = function (loaded, chunk, all) {
    var firstLoaded = all.t(loaded.q(0));
    if (firstLoaded === 0) {
      return Unit_instance;
    }
    // Inline function 'kotlin.math.max' call
    var a = firstLoaded - chunk | 0;
    var newFirstLoaded = Math.max(a, 0);
    loaded.n2(0, all.j2(newFirstLoaded, firstLoaded));
  };
  protoOf(CompletionMenuModel$LoadDirection$UP).lmd = function (src, chunk, selected) {
    // Inline function 'kotlin.math.max' call
    var a = src.n() - chunk | 0;
    var oneChunkDown = Math.max(a, 0);
    var tmp;
    if (selected >= 0) {
      // Inline function 'kotlin.math.min' call
      tmp = Math.min(oneChunkDown, selected);
    } else {
      tmp = oneChunkDown;
    }
    var fromIndex = tmp;
    return subListTail(src, fromIndex);
  };
  var LoadDirection_UP_instance;
  var LoadDirection_entriesInitialized;
  function LoadDirection_initEntries() {
    if (LoadDirection_entriesInitialized)
      return Unit_instance;
    LoadDirection_entriesInitialized = true;
    LoadDirection_DOWN_instance = new CompletionMenuModel$LoadDirection$DOWN();
    LoadDirection_UP_instance = new CompletionMenuModel$LoadDirection$UP();
  }
  function CompletionMenuModel$Companion$ITEMS_COMPARATOR$1() {
  }
  protoOf(CompletionMenuModel$Companion$ITEMS_COMPARATOR$1).smd = function (a, b) {
    var delta = b.pma() - a.pma() | 0;
    var tmp;
    if (!(delta === 0)) {
      tmp = delta;
    } else {
      var text1 = '';
      var tmp_0;
      if (a.pm7(text1) && !b.pm7(text1)) {
        tmp_0 = -1;
      } else if (!a.pm7(text1) && b.pm7(text1)) {
        tmp_0 = 1;
      } else {
        tmp_0 = compareTo_1(a.gm7(), b.gm7(), true);
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(CompletionMenuModel$Companion$ITEMS_COMPARATOR$1).compare = function (a, b) {
    var tmp = (!(a == null) ? isInterface(a, CompletionItem) : false) ? a : THROW_CCE();
    return this.smd(tmp, (!(b == null) ? isInterface(b, CompletionItem) : false) ? b : THROW_CCE());
  };
  function _get_selectedIndex__ymlfp6($this) {
    var selected = $this.gm5_1.qr();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (selected == null) {
        // Inline function 'jetbrains.ocelot.projectional.cell.completion.menuModel.CompletionMenuModel.<get-selectedIndex>.<anonymous>' call
        var message = 'No selected item';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var index = $this.cm5_1.t(selected);
    // Inline function 'kotlin.check' call
    if (!!(index === -1)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.menuModel.CompletionMenuModel.<get-selectedIndex>.<anonymous>' call
      var message_0 = 'Selected item not found in visible items';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    return index;
  }
  function updateSelectedItem($this) {
    if ($this.cm5_1.p()) {
      $this.gm5_1.t2c(null);
    } else {
      $this.gm5_1.t2c($this.cm5_1.q(0));
    }
  }
  function setSelectedText($this, text) {
    var _iterator__ex2g4s = $this.cm5_1.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      if (text === item.gm7()) {
        $this.gm5_1.t2c(item);
        return true;
      }
    }
    return false;
  }
  function setSelectedItem($this, direction) {
    if ($this.cm5_1.p()) {
      $this.gm5_1.t2c(null);
    }
    var index = direction === LoadDirection_DOWN_getInstance() ? 0 : get_lastIndex_2($this.cm5_1);
    $this.gm5_1.t2c($this.cm5_1.q(index));
  }
  function MyVisibleItemsUpdater($outer, chunkSize, loadMoreSelectionDistance, loadMoreHoverDistance, source) {
    this.hmd_1 = $outer;
    this.ymc_1 = chunkSize;
    this.zmc_1 = source;
    this.amd_1 = new ValueProperty(LoadDirection_DOWN_getInstance());
    this.cmd_1 = false;
    this.dmd_1 = null;
    this.emd_1 = new ValueProperty(0);
    this.fmd_1 = new ObservableArrayList();
    this.gmd_1 = new ValueProperty(false);
    var tmp = this;
    var tmp_0 = this.hmd_1.bm5_1.p27(CompletionMenuModel$MyVisibleItemsUpdater$lambda(this));
    var tmp_1 = tmp_0.sr(this.zmc_1.p27(CompletionMenuModel$MyVisibleItemsUpdater$lambda_0(this)));
    var tmp_2 = tmp_1.sr(this.hmd_1.gm5_1.p27(CompletionMenuModel$MyVisibleItemsUpdater$lambda_1(this, loadMoreSelectionDistance)));
    tmp.bmd_1 = tmp_2.sr(this.hmd_1.hm5_1.p27(CompletionMenuModel$MyVisibleItemsUpdater$lambda_2(this, loadMoreHoverDistance)));
  }
  protoOf(MyVisibleItemsUpdater).xm5 = function () {
    this.amd_1.qr().pmd(this.fmd_1, this.ymc_1, ensureNotNull(this.dmd_1));
  };
  protoOf(MyVisibleItemsUpdater).vr = function () {
    return this.bmd_1.vr();
  };
  protoOf(MyVisibleItemsUpdater).tmd = function (direction) {
    if (hasNotLoadedItems(this)) {
      this.amd_1.t2c(direction);
      this.mmd(true);
    } else {
      setSelectedItem(this.hmd_1, direction);
    }
  };
  protoOf(MyVisibleItemsUpdater).mmd = function (directionChanged) {
    var selected = this.hmd_1.gm5_1.qr();
    var selectedText = selected == null ? null : selected.gm7();
    doReInitItems(this, directionChanged ? null : selected);
    this.cmd_1 = true;
    try {
      if (directionChanged) {
        setSelectedItem(this.hmd_1, this.amd_1.qr());
      } else if (selectedText == null || !setSelectedText(this.hmd_1, selectedText)) {
        updateSelectedItem(this.hmd_1);
      }
    }finally {
      this.cmd_1 = false;
    }
    this.hmd_1.fm5_1.a28(CompletionMenuModel$MyVisibleItemsUpdater$reInitItems$lambda(selected));
    this.hmd_1.zm4_1.t2c(this.fmd_1.n() === 1);
  };
  function LoadDirection(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Builder(completionResult) {
    this.hmb_1 = completionResult;
    this.imb_1 = 20;
    this.jmb_1 = 8;
    this.kmb_1 = 12;
    this.lmb_1 = '';
    this.mmb_1 = false;
    this.nmb_1 = true;
  }
  protoOf(Builder).ymb = function (chunkSize) {
    this.imb_1 = chunkSize;
    return this;
  };
  protoOf(Builder).zmb = function (loadMoreSelectionDistance) {
    this.jmb_1 = loadMoreSelectionDistance;
    return this;
  };
  protoOf(Builder).amc = function (loadMoreHoverDistance) {
    this.kmb_1 = loadMoreHoverDistance;
    return this;
  };
  protoOf(Builder).omb = function (prefixText) {
    this.lmb_1 = prefixText;
    return this;
  };
  protoOf(Builder).wmb = function (createdByAutoCompletion) {
    this.mmb_1 = createdByAutoCompletion;
    return this;
  };
  protoOf(Builder).xmb = function (value) {
    this.nmb_1 = value;
    return this;
  };
  protoOf(Builder).k2p = function () {
    return new CompletionMenuModel(this);
  };
  function Companion_283() {
    Companion_instance_283 = this;
    this.cmb_1 = 20;
    this.dmb_1 = 12;
    this.emb_1 = 8;
    var tmp = this;
    tmp.fmb_1 = new CompletionMenuModel$Companion$ITEMS_COMPARATOR$1();
  }
  protoOf(Companion_283).gmb = function (completionResult) {
    return new Builder(completionResult);
  };
  var Companion_instance_283;
  function Companion_getInstance_283() {
    if (Companion_instance_283 == null)
      new Companion_283();
    return Companion_instance_283;
  }
  function CompletionMenuModel$_get_isDirectionDown_$lambda_n9qqs9(direction) {
    return direction === LoadDirection_DOWN_getInstance();
  }
  function LoadDirection_DOWN_getInstance() {
    LoadDirection_initEntries();
    return LoadDirection_DOWN_instance;
  }
  function LoadDirection_UP_getInstance() {
    LoadDirection_initEntries();
    return LoadDirection_UP_instance;
  }
  function CompletionMenuModel(builder) {
    Companion_getInstance_283();
    this.zm4_1 = new ValueProperty(false);
    this.fm5_1 = new Listeners();
    this.gm5_1 = new ValueProperty(null);
    this.hm5_1 = new ValueProperty(null);
    this.im5_1 = new ValueProperty(false);
    this.bm5_1 = new ValueProperty(builder.lmb_1);
    this.em5_1 = builder.hmb_1.umd();
    this.ym4_1 = new MyVisibleItemsUpdater(this, builder.imb_1, builder.jmb_1, builder.kmb_1, builder.hmb_1);
    this.cm5_1 = this.ym4_1.fmd_1;
    this.dm5_1 = this.ym4_1.gmd_1;
    this.ym4_1.mmd(false);
    var initialMode = Companion_instance_282.xmc(builder.mmb_1);
    this.am5_1 = new ValueProperty(initialMode);
    this.jm5_1 = builder.nmb_1;
  }
  protoOf(CompletionMenuModel).cm6 = function () {
    return map_0(this.ym4_1.amd_1, CompletionMenuModel$_get_isDirectionDown_$lambda_n9qqs9);
  };
  protoOf(CompletionMenuModel).bm6 = function () {
    return this.ym4_1.emd_1;
  };
  protoOf(CompletionMenuModel).ym5 = function () {
    return ensureNotNull(this.ym4_1.dmd_1);
  };
  protoOf(CompletionMenuModel).bmc = function () {
    return this.zm4_1;
  };
  protoOf(CompletionMenuModel).vm7 = function () {
    return this.am5_1;
  };
  protoOf(CompletionMenuModel).vr = function () {
    return this.ym4_1.vr();
  };
  protoOf(CompletionMenuModel).ama = function () {
    this.am5_1.t2c(CompletionItemSelectionMode_NORMAL_getInstance());
    var index = _get_selectedIndex__ymlfp6(this);
    if (index > 0) {
      this.gm5_1.t2c(this.cm5_1.q(index - 1 | 0));
    } else {
      this.ym4_1.tmd(LoadDirection_UP_getInstance());
    }
  };
  protoOf(CompletionMenuModel).bma = function () {
    this.am5_1.t2c(CompletionItemSelectionMode_NORMAL_getInstance());
    var index = _get_selectedIndex__ymlfp6(this);
    if (index < (this.cm5_1.n() - 1 | 0)) {
      this.gm5_1.t2c(this.cm5_1.q(index + 1 | 0));
    } else {
      this.ym4_1.tmd(LoadDirection_DOWN_getInstance());
    }
  };
  protoOf(CompletionMenuModel).xm5 = function () {
    return this.ym4_1.xm5();
  };
  function CompletionParameters$Builder$restoreAction$lambda() {
    return Unit_instance;
  }
  function Builder_0() {
    var tmp = this;
    tmp.pm9_1 = CompletionParameters$Builder$restoreAction$lambda;
    this.qm9_1 = true;
    this.rm9_1 = false;
    this.sm9_1 = null;
    this.tm9_1 = null;
    this.um9_1 = null;
    this.vm9_1 = 500;
  }
  protoOf(Builder_0).vmd = function (restoreAction) {
    this.pm9_1 = restoreAction;
    return this;
  };
  protoOf(Builder_0).wmd = function (singleOption) {
    this.qm9_1 = singleOption;
    return this;
  };
  protoOf(Builder_0).k2p = function () {
    return new CompletionParameters(this);
  };
  function Companion_284() {
    Companion_instance_284 = this;
    this.mm9_1 = (new Builder_0()).k2p();
    this.nm9_1 = 500;
  }
  protoOf(Companion_284).f5j = function () {
    return new Builder_0();
  };
  protoOf(Companion_284).om9 = function (isSingleOption) {
    return (new Builder_0()).wmd(isSingleOption);
  };
  var Companion_instance_284;
  function Companion_getInstance_284() {
    if (Companion_instance_284 == null)
      new Companion_284();
    return Companion_instance_284;
  }
  function CompletionParameters(builder) {
    Companion_getInstance_284();
    this.pmb_1 = builder.pm9_1;
    this.qmb_1 = builder.qm9_1;
    this.rmb_1 = builder.rm9_1;
    this.smb_1 = builder.sm9_1;
    this.tmb_1 = builder.tm9_1;
    this.umb_1 = builder.um9_1;
    this.vmb_1 = builder.vm9_1;
  }
  function BaseCompletionItem() {
  }
  protoOf(BaseCompletionItem).zm6 = function () {
    return null;
  };
  protoOf(BaseCompletionItem).oma = function () {
    return 0;
  };
  protoOf(BaseCompletionItem).pma = function () {
    return 0;
  };
  protoOf(BaseCompletionItem).hm7 = function () {
    return null;
  };
  protoOf(BaseCompletionItem).rma = function (text) {
    return this.qma(text) || this.pm7(text);
  };
  function CompletionItem() {
  }
  function completionItemByTextMatcher(matcher, visibleText, sortPriority, additionalText, completer) {
    return new CompletionItemByTextMatcher(matcher, visibleText, sortPriority, additionalText, completer);
  }
  function CompletionItemByTextMatcher(matcher, visibleText, sortPriority, additionalText, completer) {
    additionalText = additionalText === VOID ? null : additionalText;
    BaseCompletionItem.call(this);
    this.xmd_1 = matcher;
    this.ymd_1 = visibleText;
    this.zmd_1 = sortPriority;
    this.ame_1 = additionalText;
    this.bme_1 = completer;
  }
  protoOf(CompletionItemByTextMatcher).gm7 = function () {
    return this.ymd_1;
  };
  protoOf(CompletionItemByTextMatcher).pma = function () {
    return this.zmd_1;
  };
  protoOf(CompletionItemByTextMatcher).wm9 = function (text) {
    return this.bme_1(text);
  };
  protoOf(CompletionItemByTextMatcher).qma = function (text) {
    return this.xmd_1.cme(text) && !this.pm7(text);
  };
  protoOf(CompletionItemByTextMatcher).pm7 = function (text) {
    return this.xmd_1.pm7(text);
  };
  protoOf(CompletionItemByTextMatcher).hm7 = function () {
    return this.ame_1;
  };
  protoOf(CompletionItemByTextMatcher).toString = function () {
    return "CompletionItem{visibleText='" + this.ymd_1 + "', matcher=" + toString_1(this.xmd_1) + '}';
  };
  function CompletionItems_init_$Init$(completionResult, $this) {
    // Inline function 'kotlin.also' call
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.CompletionItems.<init>.<anonymous>' call
    // Inline function 'kotlin.check' call
    if (!get_isReady(completionResult)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    CompletionItems.call($this, completionResult.cq());
    return $this;
  }
  function CompletionItems_init_$Create$(completionResult) {
    return CompletionItems_init_$Init$(completionResult, objectCreate(protoOf(CompletionItems)));
  }
  function reduce($this, items) {
    var tmp;
    if (items.n() <= 1) {
      tmp = items;
    } else {
      var iterator = items.k();
      var firstItem = iterator.m();
      var winningPriority = firstItem.oma();
      var winningItems = ArrayList_init_$Create$();
      winningItems.e(firstItem);
      while (iterator.l()) {
        var item = iterator.m();
        if (item.oma() === winningPriority) {
          winningItems.e(item);
        } else if (item.oma() > winningPriority) {
          winningPriority = item.oma();
          winningItems.m2();
          winningItems.e(item);
        }
      }
      tmp = winningItems;
    }
    return tmp;
  }
  function CompletionItems(items) {
    this.gm2_1 = ArrayList_init_$Create$_1(toList_0(items));
  }
  protoOf(CompletionItems).np = function () {
    return this.gm2_1.p();
  };
  protoOf(CompletionItems).cq = function () {
    return this.gm2_1;
  };
  protoOf(CompletionItems).hm2 = function (prefix) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.cq();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.CompletionItems.prefixedBy.<anonymous>' call
      if (element.rma(prefix)) {
        destination.e(element);
      }
    }
    return destination;
  };
  protoOf(CompletionItems).dmc = function (prefix) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.cq();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.CompletionItems.strictlyPrefixedBy.<anonymous>' call
      if (element.qma(prefix)) {
        destination.e(element);
      }
    }
    return destination;
  };
  protoOf(CompletionItems).uma = function (text) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.cq();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.CompletionItems.matches.<anonymous>' call
      if (element.pm7(text)) {
        destination.e(element);
      }
    }
    var list = destination;
    return reduce(this, list);
  };
  protoOf(CompletionItems).vma = function (text, eager) {
    var matches = this.uma(text);
    if (!(matches.n() === 1)) {
      return false;
    }
    if (eager) {
      return true;
    }
    var strictlyPrefixed = this.dmc(text);
    if (matches.h2(strictlyPrefixed)) {
      return true;
    }
    var allItems = ArrayList_init_$Create$_1(plus_4(matches, strictlyPrefixed));
    var reduced = reduce(this, allItems);
    return reduced.n() === 1 && reduced.h2(matches);
  };
  protoOf(CompletionItems).pmc = function (text) {
    this.uma(text).q(0).wm9(text)();
  };
  protoOf(CompletionItems).qmc = function (text) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.hm2(text).p();
  };
  function Companion_285() {
    Companion_instance_285 = this;
    this.umc_1 = new EmptyCompletionResult();
  }
  var Companion_instance_285;
  function Companion_getInstance_285() {
    if (Companion_instance_285 == null)
      new Companion_285();
    return Companion_instance_285;
  }
  function CompletionResult() {
  }
  function get_isReady(_this__u8e3s4) {
    return _this__u8e3s4.umd().qr();
  }
  function await_2(_this__u8e3s4, $completion) {
    var tmp = new $awaitCOROUTINE$0_0(_this__u8e3s4, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function $awaitCOROUTINE$0_0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mme_1 = _this__u8e3s4;
  }
  protoOf($awaitCOROUTINE$0_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = awaitValue(this.mme_1.umd(), true, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.mme_1;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function CompletionResultChangeEvent() {
  }
  function CompletionItemsAddedEvent() {
    CompletionItemsAddedEvent_instance = this;
    CompletionResultChangeEvent.call(this);
  }
  var CompletionItemsAddedEvent_instance;
  function CompletionItemsAddedEvent_getInstance() {
    if (CompletionItemsAddedEvent_instance == null)
      new CompletionItemsAddedEvent();
    return CompletionItemsAddedEvent_instance;
  }
  function ErrorDuringCompletionItems(error) {
    CompletionResultChangeEvent.call(this);
    this.nme_1 = error;
  }
  function CompletionResultTransformer$TransformedCompletionResult$addHandler$lambda($handler) {
    return function (it) {
      $handler.d28(CompletionItemsAddedEvent_getInstance());
      return Unit_instance;
    };
  }
  function CompletionResultTransformer$add$1$addHandler$$inlined$eventHandler$1($handler) {
    this.ome_1 = $handler;
  }
  protoOf(CompletionResultTransformer$add$1$addHandler$$inlined$eventHandler$1).e2b = function (event) {
    this.ome_1.d28(event);
    return Unit_instance;
  };
  protoOf(CompletionResultTransformer$add$1$addHandler$$inlined$eventHandler$1).d28 = function (event) {
    return this.e2b((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function TransformedCompletionResult($outer) {
    this.pme_1 = $outer;
  }
  protoOf(TransformedCompletionResult).umd = function () {
    return this.pme_1.bm9_1.umd();
  };
  protoOf(TransformedCompletionResult).dme = function (handler) {
    return this.pme_1.bm9_1.p27(CompletionResultTransformer$TransformedCompletionResult$addHandler$lambda(handler));
  };
  protoOf(TransformedCompletionResult).o27 = function (handler) {
    return this.dme(handler);
  };
  protoOf(TransformedCompletionResult).vr = function () {
    this.pme_1.bm9_1.vr();
  };
  function Companion_286() {
  }
  protoOf(Companion_286).hli = function () {
    return new CompletionResultTransformer(Companion_getInstance_285().umc_1);
  };
  var Companion_instance_286;
  function Companion_getInstance_286() {
    return Companion_instance_286;
  }
  function CompletionResultTransformer$add$1(this$0, $result) {
    this.qme_1 = this$0;
    this.rme_1 = $result;
  }
  protoOf(CompletionResultTransformer$add$1).cq = function () {
    return plus_4(this.qme_1.bm9_1.cq(), this.rme_1.cq());
  };
  protoOf(CompletionResultTransformer$add$1).umd = function () {
    return and(this.qme_1.bm9_1.umd(), this.rme_1.umd());
  };
  protoOf(CompletionResultTransformer$add$1).dme = function (handler) {
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var eventHandler = new CompletionResultTransformer$add$1$addHandler$$inlined$eventHandler$1(handler);
    return this.qme_1.bm9_1.dme(eventHandler).sr(this.rme_1.dme(eventHandler));
  };
  protoOf(CompletionResultTransformer$add$1).o27 = function (handler) {
    return this.dme(handler);
  };
  protoOf(CompletionResultTransformer$add$1).vr = function () {
    this.qme_1.bm9_1.vr();
    this.rme_1.vr();
  };
  function CompletionResultTransformer$map$transformedCompletionResult$1(this$0, $transform) {
    this.tme_1 = this$0;
    this.ume_1 = $transform;
    TransformedCompletionResult.call(this, this$0);
  }
  protoOf(CompletionResultTransformer$map$transformedCompletionResult$1).cq = function () {
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = this.tme_1.bm9_1.cq().k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      var transformed = this.ume_1(item);
      result.e(transformed);
    }
    return result;
  };
  function CompletionResultTransformer(completionResult) {
    this.bm9_1 = completionResult;
  }
  protoOf(CompletionResultTransformer).vme = function (result) {
    return new CompletionResultTransformer(new CompletionResultTransformer$add$1(this, result));
  };
  protoOf(CompletionResultTransformer).cm9 = function (transform) {
    var transformedCompletionResult = new CompletionResultTransformer$map$transformedCompletionResult$1(this, transform);
    return new CompletionResultTransformer(transformedCompletionResult);
  };
  protoOf(CompletionResultTransformer).qr = function () {
    return this.bm9_1;
  };
  function EmptyCompletionResult() {
    ReadyCompletionResult.call(this);
  }
  function FlowBasedCompletionResult$completionCollectorJob$slambda$slambda$lambda(it) {
    it.d28(CompletionItemsAddedEvent_getInstance());
    return Unit_instance;
  }
  function FlowBasedCompletionResult$completionCollectorJob$slambda$slambda(this$0, resultContinuation) {
    this.fmf_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda$slambda).hmf = function (item, $completion) {
    var tmp = this.imf(item, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda$slambda).oa = function (p1, $completion) {
    return this.hmf((!(p1 == null) ? isInterface(p1, CompletionItem) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var tmp_0 = this.fmf_1;
          var tmp0 = this.fmf_1.mmf_1;
          var element = this.gmf_1;
          tmp_0.mmf_1 = tmp0.e(element);
          this.fmf_1.kmf_1.a28(FlowBasedCompletionResult$completionCollectorJob$slambda$slambda$lambda);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda$slambda).imf = function (item, completion) {
    var i = new FlowBasedCompletionResult$completionCollectorJob$slambda$slambda(this.fmf_1, completion);
    i.gmf_1 = item;
    return i;
  };
  function FlowBasedCompletionResult$completionCollectorJob$slambda$slambda_0(this$0, resultContinuation) {
    var i = new FlowBasedCompletionResult$completionCollectorJob$slambda$slambda(this$0, resultContinuation);
    var l = function (item, $completion) {
      return i.hmf(item, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function FlowBasedCompletionResult$completionCollectorJob$slambda$lambda($e) {
    return function (it) {
      it.d28(new ErrorDuringCompletionItems($e));
      return Unit_instance;
    };
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_13(function_0) {
    this.pmf_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_13).d1f = function (value, $completion) {
    return this.pmf_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_13).b4 = function () {
    return this.pmf_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_13).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_13).hashCode = function () {
    return hashCode(this.b4());
  };
  function FlowBasedCompletionResult$completionCollectorJob$slambda(this$0, resultContinuation) {
    this.ymf_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.z9_1 = 3;
            this.y9_1 = 1;
            var tmp_0 = cancellable(this.ymf_1.jmf_1);
            var tmp_1 = FlowBasedCompletionResult$completionCollectorJob$slambda$slambda_0(this.ymf_1, null);
            suspendResult = tmp_0.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_13(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ymf_1.omf_1.t2c(true);
            this.z9_1 = 4;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.z9_1 = 4;
            return Unit_instance;
          case 3:
            this.z9_1 = 4;
            var tmp_2 = this.ba_1;
            if (tmp_2 instanceof Error) {
              var e = this.ba_1;
              if (!(e instanceof CancellationException)) {
                this.ymf_1.nmf_1 = true;
                this.ymf_1.kmf_1.a28(FlowBasedCompletionResult$completionCollectorJob$slambda$lambda(e));
              }
              this.ymf_1.omf_1.t2c(true);
              throw e;
            } else {
              throw this.ba_1;
            }

          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 4) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(FlowBasedCompletionResult$completionCollectorJob$slambda).i1l = function ($this$launch, completion) {
    var i = new FlowBasedCompletionResult$completionCollectorJob$slambda(this.ymf_1, completion);
    i.zmf_1 = $this$launch;
    return i;
  };
  function FlowBasedCompletionResult$completionCollectorJob$slambda_0(this$0, resultContinuation) {
    var i = new FlowBasedCompletionResult$completionCollectorJob$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function FlowBasedCompletionResult(coroutineScope, completionItemFlow) {
    this.jmf_1 = completionItemFlow;
    this.kmf_1 = new Listeners();
    var tmp = this;
    tmp.lmf_1 = launch(coroutineScope, VOID, VOID, FlowBasedCompletionResult$completionCollectorJob$slambda_0(this, null));
    this.mmf_1 = persistentListOf();
    this.nmf_1 = false;
    this.omf_1 = new ValueProperty(false);
  }
  protoOf(FlowBasedCompletionResult).cq = function () {
    return this.mmf_1;
  };
  protoOf(FlowBasedCompletionResult).umd = function () {
    return this.omf_1;
  };
  protoOf(FlowBasedCompletionResult).dme = function (handler) {
    return this.kmf_1.z27(handler);
  };
  protoOf(FlowBasedCompletionResult).o27 = function (handler) {
    return this.dme(handler);
  };
  protoOf(FlowBasedCompletionResult).vr = function () {
    this.lmf_1.pu();
  };
  function ReadyCompletionResult() {
    this.wme_1 = false;
  }
  protoOf(ReadyCompletionResult).umd = function () {
    return Properties_getInstance().p2d_1;
  };
  protoOf(ReadyCompletionResult).dme = function (handler) {
    return Companion_getInstance_25().wr_1;
  };
  protoOf(ReadyCompletionResult).o27 = function (handler) {
    return this.dme(handler);
  };
  protoOf(ReadyCompletionResult).vr = function () {
  };
  function SimpleCompletionItem(matchingText, visibleText, sortPriority, isCaseSensitive) {
    visibleText = visibleText === VOID ? matchingText : visibleText;
    sortPriority = sortPriority === VOID ? 0 : sortPriority;
    isCaseSensitive = isCaseSensitive === VOID ? true : isCaseSensitive;
    BaseCompletionItem.call(this);
    this.amg_1 = matchingText;
    this.bmg_1 = visibleText;
    this.cmg_1 = sortPriority;
    this.dmg_1 = simpleTextMatcher(this.amg_1, isCaseSensitive);
  }
  protoOf(SimpleCompletionItem).gm7 = function () {
    return this.bmg_1;
  };
  protoOf(SimpleCompletionItem).pma = function () {
    return this.cmg_1;
  };
  protoOf(SimpleCompletionItem).qma = function (text) {
    return this.dmg_1.cme(text) && !this.pm7(text);
  };
  protoOf(SimpleCompletionItem).pm7 = function (text) {
    return this.dmg_1.pm7(text);
  };
  protoOf(SimpleCompletionItem).toString = function () {
    return "CompletionItem{visibleText='" + this.gm7() + "', matcher=" + toString_1(this.dmg_1) + '}';
  };
  function SimpleCompletionResult(items) {
    ReadyCompletionResult.call(this);
    this.fmg_1 = items;
  }
  protoOf(SimpleCompletionResult).cq = function () {
    return this.fmg_1;
  };
  function WrapperCompletionItem(item) {
    this.nma_1 = item;
  }
  protoOf(WrapperCompletionItem).toString = function () {
    return 'Wrapper { ' + toString_1(this.nma_1) + ' }';
  };
  protoOf(WrapperCompletionItem).oma = function () {
    return this.nma_1.oma();
  };
  protoOf(WrapperCompletionItem).pma = function () {
    return this.nma_1.pma();
  };
  protoOf(WrapperCompletionItem).zm6 = function () {
    return this.nma_1.zm6();
  };
  protoOf(WrapperCompletionItem).gm7 = function () {
    return this.nma_1.gm7();
  };
  protoOf(WrapperCompletionItem).hm7 = function () {
    return this.nma_1.hm7();
  };
  protoOf(WrapperCompletionItem).qma = function (text) {
    return this.nma_1.qma(text);
  };
  protoOf(WrapperCompletionItem).rma = function (text) {
    return this.nma_1.rma(text);
  };
  protoOf(WrapperCompletionItem).pm7 = function (text) {
    return this.nma_1.pm7(text);
  };
  protoOf(WrapperCompletionItem).wm9 = function (text) {
    return this.nma_1.wm9(text);
  };
  function SimpleCaseSensitiveMatcher(matchingText) {
    this.gmg_1 = matchingText;
  }
  protoOf(SimpleCaseSensitiveMatcher).cme = function (text) {
    return startsWith(this.gmg_1, text);
  };
  protoOf(SimpleCaseSensitiveMatcher).pm7 = function (text) {
    return this.gmg_1 === text;
  };
  protoOf(SimpleCaseSensitiveMatcher).toString = function () {
    return "{pattern='" + this.gmg_1 + "', ignoreCase=false}";
  };
  function SimpleIgnoreCaseMatcher(matchingText) {
    var tmp = this;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.hmg_1 = matchingText.toLowerCase();
  }
  protoOf(SimpleIgnoreCaseMatcher).cme = function (text) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = text.toLowerCase();
    return startsWith(this.hmg_1, tmp$ret$1);
  };
  protoOf(SimpleIgnoreCaseMatcher).pm7 = function (text) {
    return equals_0(this.hmg_1, text, true);
  };
  protoOf(SimpleIgnoreCaseMatcher).toString = function () {
    return "{pattern='" + this.hmg_1 + "', ignoreCase=true}";
  };
  function simpleTextMatcher(matchingText, isCaseSensitive) {
    var tmp;
    if (isCaseSensitive) {
      tmp = new SimpleCaseSensitiveMatcher(matchingText);
    } else {
      tmp = new SimpleIgnoreCaseMatcher(matchingText);
    }
    return tmp;
  }
  function get_hasFocusability() {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return hasFocusability;
  }
  var hasFocusability;
  function get_hasVisibility() {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return hasVisibility;
  }
  var hasVisibility;
  function get_compositeFocusables() {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return compositeFocusables;
  }
  var compositeFocusables;
  function get_cellNavCompositeFocusables() {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return cellNavCompositeFocusables;
  }
  var cellNavCompositeFocusables;
  function firstFocusable(_this__u8e3s4) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return get_compositeFocusables().plg(_this__u8e3s4);
  }
  function lastFocusable(_this__u8e3s4) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return get_compositeFocusables().rlg(_this__u8e3s4);
  }
  function nextFocusable(_this__u8e3s4) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return get_cellNavCompositeFocusables().mlg(_this__u8e3s4);
  }
  function prevFocusable(_this__u8e3s4) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return get_cellNavCompositeFocusables().klg(_this__u8e3s4);
  }
  function firstFocusable_0(_this__u8e3s4, deepest) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return get_compositeFocusables().qlg(_this__u8e3s4, deepest);
  }
  function lastFocusable_0(_this__u8e3s4, deepest) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return get_compositeFocusables().slg(_this__u8e3s4, deepest);
  }
  function isVisible_1(_this__u8e3s4) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return isVisible_0(_this__u8e3s4, get_hasVisibility());
  }
  function hasFocusability$lambda(cell) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return cell.hlp();
  }
  function hasVisibility$lambda(cell) {
    _init_properties_CellHasFocusability_kt__h7a9uw();
    return cell.elp();
  }
  var properties_initialized_CellHasFocusability_kt_sx6cue;
  function _init_properties_CellHasFocusability_kt__h7a9uw() {
    if (!properties_initialized_CellHasFocusability_kt_sx6cue) {
      properties_initialized_CellHasFocusability_kt_sx6cue = true;
      hasFocusability = hasFocusability$lambda;
      hasVisibility = hasVisibility$lambda;
      compositeFocusables = new CompositeFocusables(get_hasFocusability(), get_hasVisibility());
      cellNavCompositeFocusables = new NavCompositeFocusables(get_hasFocusability(), get_hasVisibility());
    }
  }
  function CellContainer() {
    return new CellContainerImpl();
  }
  function CellContainerPeerAdapter(edt) {
    this.img_1 = edt;
  }
  protoOf(CellContainerPeerAdapter).elq = function () {
    return this.img_1;
  };
  protoOf(CellContainerPeerAdapter).flq = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(CellContainerPeerAdapter).glq = function (tv, x) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(CellContainerPeerAdapter).hlq = function (tv, caret) {
    return 0;
  };
  protoOf(CellContainerPeerAdapter).ilq = function (cell) {
    return Companion_getInstance_250().hku_1;
  };
  protoOf(CellContainerPeerAdapter).jlq = function (cell) {
    return Companion_getInstance_251().iku_1;
  };
  protoOf(CellContainerPeerAdapter).klq = function (cell, offset) {
  };
  protoOf(CellContainerPeerAdapter).tlp = function (rectSupplier, cell) {
    return Asyncs_instance.r2l();
  };
  protoOf(CellContainerPeerAdapter).mlq = function (root, loc) {
    return Cells_getInstance().mlq(root, loc);
  };
  protoOf(CellContainerPeerAdapter).nlq = function (cell) {
    return Rectangle_init_$Create$(0, 0, 10000, 10000);
  };
  function resetEdt(_this__u8e3s4, edt) {
    var cellContainerPeer = new CellContainerPeerAdapter(edt);
    _this__u8e3s4.nmg(cellContainerPeer);
  }
  function get_CompletedJob() {
    _init_properties_CellCoroutines_kt__imgk8t();
    var tmp0 = CompletedJob$delegate;
    // Inline function 'kotlin.getValue' call
    CompletedJob$factory();
    return tmp0.y();
  }
  var CompletedJob$delegate;
  function launch_0(_this__u8e3s4, key, block) {
    key = key === VOID ? null : key;
    _init_properties_CellCoroutines_kt__imgk8t();
    if (!_this__u8e3s4.qlc())
      return get_CompletedJob();
    var cell = _this__u8e3s4;
    if (!(key == null)) {
      var tmp0_safe_receiver = cell.ulp(key);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.pu();
      }
    }
    var threadSafe = newThreadSafeChecker();
    var tmp = coroutineScope_0(ensureNotNull(_this__u8e3s4.llk()));
    var job = launch(tmp, VOID, VOID, launch$slambda_0(threadSafe, block, null));
    job.hu(launch$lambda(key, job, cell));
    if (!(key == null)) {
      cell.ylp(key, job);
    }
    return job;
  }
  function coroutineScope_0(_this__u8e3s4) {
    _init_properties_CellCoroutines_kt__imgk8t();
    return CoroutineScope_0(get_asCoroutineDispatcher(_this__u8e3s4.elq()));
  }
  function CompletedJob$delegate$lambda() {
    _init_properties_CellCoroutines_kt__imgk8t();
    // Inline function 'kotlin.also' call
    var this_0 = Job_0();
    // Inline function 'jetbrains.ocelot.projectional.cell.coroutines.CompletedJob$delegate.<anonymous>.<anonymous>' call
    this_0.oz();
    return this_0;
  }
  function launch$slambda($threadSafe, $block, resultContinuation) {
    this.wmg_1 = $threadSafe;
    this.xmg_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launch$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(launch$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launch$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.wmg_1.lr();
            this.y9_1 = 1;
            suspendResult = this.xmg_1(this.ymg_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(launch$slambda).i1l = function ($this$launch, completion) {
    var i = new launch$slambda(this.wmg_1, this.xmg_1, completion);
    i.ymg_1 = $this$launch;
    return i;
  };
  function launch$slambda_0($threadSafe, $block, resultContinuation) {
    var i = new launch$slambda($threadSafe, $block, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function launch$lambda($key, $job, $cell) {
    return function (it) {
      var tmp;
      if (!($key == null) && $job === $cell.ulp($key)) {
        $cell.ylp($key, null);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CompletedJob$factory() {
    return getPropertyCallableRef('CompletedJob', 0, KProperty0, function () {
      return get_CompletedJob();
    }, null);
  }
  var properties_initialized_CellCoroutines_kt_tvm401;
  function _init_properties_CellCoroutines_kt__imgk8t() {
    if (!properties_initialized_CellCoroutines_kt_tvm401) {
      properties_initialized_CellCoroutines_kt_tvm401 = true;
      CompletedJob$delegate = lazy_0(CompletedJob$delegate$lambda);
    }
  }
  function Companion_287() {
    Companion_instance_287 = this;
    this.lll_1 = new CellEventSpec('keyPressed');
    this.mll_1 = new CellEventSpec('keyReleased');
    this.nll_1 = new CellEventSpec('keyTyped');
    this.oll_1 = new CellEventSpec('mouseClicked');
    this.pll_1 = new CellEventSpec('mouseDoubleClicked');
    this.qll_1 = new CellEventSpec('mousePressed');
    this.rll_1 = new CellEventSpec('mouseReleased');
    this.sll_1 = new CellEventSpec('mouseMoved');
    this.tll_1 = new CellEventSpec('mouseReleased');
    this.ull_1 = new CellEventSpec('mouseEntered');
    this.vll_1 = new CellEventSpec('mouseLeft');
    this.wll_1 = new CellEventSpec('touchStarted');
    this.xll_1 = new CellEventSpec('touchLongTapped');
    this.yll_1 = new CellEventSpec('touchMoved');
    this.zll_1 = new CellEventSpec('touchDragged');
    this.alm_1 = new CellEventSpec('touchEnded');
    this.blm_1 = new CellEventSpec('popupRequested');
    this.clm_1 = new CellEventSpec('focusGained');
    this.dlm_1 = new CellEventSpec('focusLost');
    this.elm_1 = new CellEventSpec('copy');
    this.flm_1 = new CellEventSpec('cut');
    this.glm_1 = new CellEventSpec('cut');
    this.hlm_1 = new CellEventSpec('complete');
    this.ilm_1 = new CellEventSpec('compositionStarted');
    this.jlm_1 = new CellEventSpec('compositionUpdated');
    this.klm_1 = new CellEventSpec('compositionEnded');
  }
  var Companion_instance_287;
  function Companion_getInstance_287() {
    if (Companion_instance_287 == null)
      new Companion_287();
    return Companion_instance_287;
  }
  function CellEventSpec(name) {
    Companion_getInstance_287();
    this.hll_1 = name;
  }
  protoOf(CellEventSpec).ill = function (cell, event, trait) {
    var tmp;
    if (equals(this, Companion_getInstance_287().clm_1)) {
      trait.hlo(cell, event instanceof FocusEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().dlm_1)) {
      trait.ilo(cell, event instanceof FocusEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().oll_1)) {
      trait.jlo(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().pll_1)) {
      trait.klo(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().qll_1)) {
      trait.llo(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().rll_1)) {
      trait.mlo(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().sll_1)) {
      trait.nlo(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().tll_1)) {
      trait.olo(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().ull_1)) {
      trait.plo(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().vll_1)) {
      trait.qlo(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().wll_1)) {
      trait.rlo(cell, event instanceof TouchEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().xll_1)) {
      trait.slo(cell, event instanceof TouchEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().yll_1)) {
      trait.tlo(cell, event instanceof TouchEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().zll_1)) {
      trait.ulo(cell, event instanceof TouchEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().alm_1)) {
      trait.vlo(cell, event instanceof TouchEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().blm_1)) {
      trait.wlo(cell, event instanceof MouseEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().elm_1)) {
      trait.xlo(cell, event instanceof CopyCutEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().flm_1)) {
      trait.ylo(cell, event instanceof CopyCutEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().glm_1)) {
      trait.zlo(cell, event instanceof PasteEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().hlm_1)) {
      trait.alp(cell, event instanceof CompletionEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().ilm_1)) {
      trait.blp(cell, event instanceof CompositionEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().jlm_1)) {
      trait.clp(cell, event instanceof CompositionEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else if (equals(this, Companion_getInstance_287().klm_1)) {
      trait.dlp(cell, event instanceof CompositionEvent ? event : THROW_CCE());
      tmp = Unit_instance;
    } else {
      throw IllegalStateException_init_$Create$_0('Unknown event type ' + toString_1(event));
    }
    return tmp;
  };
  protoOf(CellEventSpec).toString = function () {
    return this.hll_1;
  };
  function CompletionEvent(isSingleOption) {
    isSingleOption = isSingleOption === VOID ? true : isSingleOption;
    Event_0.call(this);
    this.lm9_1 = isSingleOption;
  }
  protoOf(CompletionEvent).toString = function () {
    return 'CompletionEvent[singleOption=' + this.lm9_1 + ']';
  };
  var EventPriority_NORMAL_instance;
  var EventPriority_LOW_instance;
  function values_16() {
    return [EventPriority_NORMAL_getInstance(), EventPriority_LOW_getInstance()];
  }
  var EventPriority_entriesInitialized;
  function EventPriority_initEntries() {
    if (EventPriority_entriesInitialized)
      return Unit_instance;
    EventPriority_entriesInitialized = true;
    EventPriority_NORMAL_instance = new EventPriority('NORMAL', 0);
    EventPriority_LOW_instance = new EventPriority('LOW', 1);
  }
  function EventPriority(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function EventPriority_NORMAL_getInstance() {
    EventPriority_initEntries();
    return EventPriority_NORMAL_instance;
  }
  function EventPriority_LOW_getInstance() {
    EventPriority_initEntries();
    return EventPriority_LOW_instance;
  }
  function FocusEvent(oldValue, newValue) {
    Event_0.call(this);
    this.bmh_1 = oldValue;
    this.cmh_1 = newValue;
  }
  protoOf(FocusEvent).ol0 = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(FocusEvent).toString = function () {
    return 'FocusEvent[' + toString_0(this.bmh_1) + '->' + toString_0(this.cmh_1) + ']';
  };
  function Companion_288() {
    Companion_instance_288 = this;
    this.dmh_1 = CellPropertySpec_init_$Create$('image', Companion_instance_327.emh(Companion_getInstance_251().iku_1));
  }
  var Companion_instance_288;
  function Companion_getInstance_288() {
    if (Companion_instance_288 == null)
      new Companion_288();
    return Companion_instance_288;
  }
  function ImageCell() {
    Companion_getInstance_288();
    BaseCell_init_$Init$(this);
    this.nmh_1 = this.flp(Companion_getInstance_288().dmh_1);
  }
  protoOf(ImageCell).omh = function () {
    return this.nmh_1;
  };
  function sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0(function_0) {
    this.pmh_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0).wl6 = function (systemClipboard) {
    return this.pmh_1(systemClipboard);
  };
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0).b4 = function () {
    return this.pmh_1;
  };
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ClipboardAdapter) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0).hashCode = function () {
    return hashCode(this.b4());
  };
  function CellContainerImpl$Companion$defaultClipboardAdapter$lambda(it) {
    return defaultSystemClipboardInteraction(it);
  }
  function _get_externalClipboard__nfl76u($this) {
    var tmp0_elvis_lhs = $this.zmh_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = $this.ymh_1.wl6($this.xmh_1.flq());
      // Inline function 'jetbrains.ocelot.projectional.cell.impl.container.CellContainerImpl.<get-externalClipboard>.<anonymous>' call
      $this.zmh_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function createFocusedCellProp($this) {
    return new CellContainerImpl$createFocusedCellProp$1($this);
  }
  function changeCellUnderMouse($this, e, newValue) {
    if ($this.rmh_1 === newValue) {
      return Unit_instance;
    }
    var oldValue = $this.rmh_1;
    $this.rmh_1 = newValue;
    if (!(oldValue == null)) {
      oldValue.bln(get_HOVERED(), false);
      dispatch_3($this, oldValue, Companion_instance_256.ol3(e.zl3()), Companion_getInstance_287().vll_1);
    }
    if (!(newValue == null)) {
      newValue.bln(get_HOVERED(), true);
      dispatch_3($this, newValue, Companion_instance_256.ol3(e.zl3()), Companion_getInstance_287().ull_1);
    }
  }
  function mouseEventHappened($this, event, eventSpec, target) {
    if (equals(eventSpec, Companion_getInstance_287().qll_1))
      $this.tmh_1 = target;
    else if (equals(eventSpec, Companion_getInstance_287().rll_1))
      $this.tmh_1 = null;
    if (eventSpec === Companion_getInstance_287().tll_1 && !($this.tmh_1 == null)) {
      dispatch_3($this, $this.tmh_1, event, eventSpec);
    } else {
      dispatch_3($this, target, event, eventSpec);
    }
  }
  function mouseEventHappened$default($this, event, eventSpec, target, $super) {
    target = target === VOID ? $this.bmi(event.zl3()) : target;
    return mouseEventHappened($this, event, eventSpec, target);
  }
  function dispatch_2($this, event, spec) {
    dispatch_3($this, $this.smh_1.qr(), event, spec);
  }
  function dispatch_3($this, target, event, spec) {
    if (!(target == null)) {
      $this.hm9(CellContainerImpl$dispatch$lambda(target, event, spec));
    }
  }
  function isDependent($this, value, cell) {
    return !(value == null) && isDescendant(cell, value);
  }
  function Companion_289() {
    Companion_instance_289 = this;
    this.cmi_1 = new CellContainerPeerAdapter(new NullEventDispatchThread());
    var tmp = this;
    var tmp_0 = CellContainerImpl$Companion$defaultClipboardAdapter$lambda;
    tmp.dmi_1 = new sam$jetbrains_ocelot_base_clipboard_ClipboardAdapter$0_0(tmp_0);
  }
  var Companion_instance_289;
  function Companion_getInstance_289() {
    if (Companion_instance_289 == null)
      new Companion_289();
    return Companion_instance_289;
  }
  function CellContainerImpl$createFocusedCellProp$1(this$0) {
    this.hmi_1 = this$0;
    ValueProperty.call(this, null);
    this.gmi_1 = false;
  }
  protoOf(CellContainerImpl$createFocusedCellProp$1).imi = function (newValue) {
    // Inline function 'kotlin.check' call
    if (!!this.gmi_1) {
      // Inline function 'jetbrains.ocelot.projectional.cell.impl.container.<no name provided>.set.<anonymous>' call
      var message = "You can't change focus in focusCell change handler";
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.gmi_1 = true;
    try {
      if (!(newValue == null)) {
        // Inline function 'kotlin.check' call
        if (!canFocus(newValue)) {
          // Inline function 'jetbrains.ocelot.projectional.cell.impl.container.<no name provided>.set.<anonymous>' call
          var message_0 = 'Cannot set focus to ' + toString_0(newValue);
          throw IllegalStateException_init_$Create$_0(toString_1(message_0));
        }
        // Inline function 'kotlin.require' call
        // Inline function 'kotlin.require' call
        if (!equals(newValue.llk(), this.hmi_1)) {
          // Inline function 'kotlin.require.<anonymous>' call
          var message_1 = 'Failed requirement.';
          throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
        }
      }
      var oldValue = this.qr();
      if (oldValue === newValue)
        return Unit_instance;
      if (oldValue == null)
        null;
      else
        oldValue.bln(get_FOCUSED(), false);
      protoOf(ValueProperty).t2c.call(this, newValue);
      if (!(oldValue == null)) {
        dispatch_3(this.hmi_1, oldValue, new FocusEvent(oldValue, newValue), Companion_getInstance_287().dlm_1);
      }
      if (!(newValue == null)) {
        dispatch_3(this.hmi_1, newValue, new FocusEvent(oldValue, newValue), Companion_getInstance_287().clm_1);
        newValue.bln(get_FOCUSED(), true);
      }
    }finally {
      this.gmi_1 = false;
    }
  };
  protoOf(CellContainerImpl$createFocusedCellProp$1).t2c = function (newValue) {
    return this.imi((newValue == null ? true : isInterface(newValue, Cell)) ? newValue : THROW_CCE());
  };
  function CellContainerImpl$saveState$lambda($oldCell, this$0) {
    return function () {
      var tmp;
      if ($oldCell == null) {
        this$0.smh_1.t2c(null);
        tmp = Unit_instance;
      } else {
        $oldCell.ul5();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CellContainerImpl$pasteFromExternalClipboard$slambda(this$0, resultContinuation) {
    this.rmi_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CellContainerImpl$pasteFromExternalClipboard$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CellContainerImpl$pasteFromExternalClipboard$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CellContainerImpl$pasteFromExternalClipboard$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = _get_externalClipboard__nfl76u(this.rmi_1).rl7(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.rmi_1.tmi(new PasteEvent(tmp0_safe_receiver));
            }

            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(CellContainerImpl$pasteFromExternalClipboard$slambda).i1l = function ($this$launch, completion) {
    var i = new CellContainerImpl$pasteFromExternalClipboard$slambda(this.rmi_1, completion);
    i.smi_1 = $this$launch;
    return i;
  };
  function CellContainerImpl$pasteFromExternalClipboard$slambda_0(this$0, resultContinuation) {
    var i = new CellContainerImpl$pasteFromExternalClipboard$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CellContainerImpl$dispatch$lambda($target, $event, $spec) {
    return function () {
      $target.jlp($event, $spec);
      return Unit_instance;
    };
  }
  function CellContainerListener$onBeforeCommand$ref() {
    var l = function (p0) {
      p0.zlp();
      return Unit_instance;
    };
    l.callableName = 'onBeforeCommand';
    return l;
  }
  function CellContainerListener$onAfterCommand$ref() {
    var l = function (p0) {
      p0.alq();
      return Unit_instance;
    };
    l.callableName = 'onAfterCommand';
    return l;
  }
  function CellContainerImpl$cellPropertyChanged$lambda($cell, $prop, $change) {
    return function (listener) {
      listener.blq($cell, $prop, $change);
      return Unit_instance;
    };
  }
  function CellContainerImpl$cellChildAdded$lambda($cell, $change) {
    return function (listener) {
      listener.clq($cell, $change);
      return Unit_instance;
    };
  }
  function CellContainerImpl$cellChildRemoved$lambda($cell, $change) {
    return function (listener) {
      listener.dlq($cell, $change);
      return Unit_instance;
    };
  }
  function CellContainerImpl() {
    Companion_getInstance_289();
    this.qmh_1 = new RootCell(this);
    this.rmh_1 = null;
    this.smh_1 = createFocusedCellProp(this);
    this.tmh_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.umh_1 = ArrayList_init_$Create$();
    this.vmh_1 = new Listeners();
    this.wmh_1 = false;
    this.xmh_1 = Companion_getInstance_289().cmi_1;
    this.ymh_1 = Companion_getInstance_289().dmi_1;
    this.zmh_1 = null;
    this.ami_1 = null;
  }
  protoOf(CellContainerImpl).u3o = function () {
    return this.qmh_1;
  };
  protoOf(CellContainerImpl).olq = function () {
    return this.xmh_1;
  };
  protoOf(CellContainerImpl).elq = function () {
    return this.olq().elq();
  };
  protoOf(CellContainerImpl).nmg = function (peer) {
    this.xmh_1 = peer;
  };
  protoOf(CellContainerImpl).umi = function (adapter) {
    this.ymh_1 = adapter;
  };
  protoOf(CellContainerImpl).km2 = function () {
    var oldCell = this.smh_1.qr();
    return CellContainerImpl$saveState$lambda(oldCell, this);
  };
  protoOf(CellContainerImpl).kl5 = function (e) {
    if (e.ol1([KeyStrokeSpecs_getInstance().dl2_1])) {
      this.gl6(new CopyCutEvent());
      e.ol0();
    } else if (e.ol1([KeyStrokeSpecs_getInstance().el2_1])) {
      this.fl6(new CopyCutEvent());
      e.ol0();
    } else if (e.ol1([KeyStrokeSpecs_getInstance().fl2_1])) {
      this.rl6();
      e.ol0();
    } else {
      if (e.ol1([KeyStrokeSpecs_getInstance().il2_1])) {
        var event = new CompletionEvent();
        this.vmi(event);
        if (event.ml0_1) {
          e.ol0();
          return Unit_instance;
        }
      }
      dispatch_2(this, e, Companion_getInstance_287().lll_1);
    }
  };
  protoOf(CellContainerImpl).hl6 = function (e) {
    return dispatch_2(this, e, Companion_getInstance_287().mll_1);
  };
  protoOf(CellContainerImpl).ll5 = function (e) {
    return dispatch_2(this, e, Companion_getInstance_287().nll_1);
  };
  protoOf(CellContainerImpl).ql5 = function (e) {
    return mouseEventHappened$default(this, e, Companion_getInstance_287().oll_1);
  };
  protoOf(CellContainerImpl).sl5 = function (e) {
    return mouseEventHappened$default(this, e, Companion_getInstance_287().pll_1);
  };
  protoOf(CellContainerImpl).tl5 = function (e) {
    return mouseEventHappened$default(this, e, Companion_getInstance_287().qll_1);
  };
  protoOf(CellContainerImpl).vl5 = function (e) {
    return mouseEventHappened$default(this, e, Companion_getInstance_287().rll_1);
  };
  protoOf(CellContainerImpl).xl5 = function (e) {
    var cellUnderMouse = this.bmi(e.zl3());
    changeCellUnderMouse(this, e, cellUnderMouse);
    mouseEventHappened(this, e, Companion_getInstance_287().sll_1, cellUnderMouse);
  };
  protoOf(CellContainerImpl).wl5 = function (e) {
    var cellUnderMouse = this.bmi(e.zl3());
    mouseEventHappened(this, e, Companion_getInstance_287().tll_1, cellUnderMouse);
    changeCellUnderMouse(this, e, cellUnderMouse);
  };
  protoOf(CellContainerImpl).yl5 = function (e) {
    changeCellUnderMouse(this, e, this.bmi(e.zl3()));
  };
  protoOf(CellContainerImpl).al6 = function (e) {
    return changeCellUnderMouse(this, e, null);
  };
  protoOf(CellContainerImpl).gl6 = function (e) {
    dispatch_2(this, e, Companion_getInstance_287().elm_1);
    if (e.ml0_1) {
      _get_externalClipboard__nfl76u(this).pl7(e.tl0_1);
    }
  };
  protoOf(CellContainerImpl).fl6 = function (e) {
    dispatch_2(this, e, Companion_getInstance_287().flm_1);
    if (e.ml0_1) {
      _get_externalClipboard__nfl76u(this).pl7(e.tl0_1);
    }
  };
  protoOf(CellContainerImpl).tmi = function (e) {
    dispatch_2(this, e, Companion_getInstance_287().glm_1);
  };
  protoOf(CellContainerImpl).vmi = function (event) {
    return dispatch_2(this, event, Companion_getInstance_287().hlm_1);
  };
  protoOf(CellContainerImpl).il6 = function (text) {
    var content = TextContentHelper_getInstance().tl4(text);
    var pasteEvent = new PasteEvent(content);
    dispatch_2(this, pasteEvent, Companion_getInstance_287().glm_1);
  };
  protoOf(CellContainerImpl).rl6 = function () {
    var tmp = coroutineScope_0(this);
    var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
    launch(tmp, VOID, tmp_0, CellContainerImpl$pasteFromExternalClipboard$slambda_0(this, null));
  };
  protoOf(CellContainerImpl).ol6 = function (e) {
    this.ami_1 = this.smh_1.qr();
    dispatch_3(this, this.ami_1, e, Companion_getInstance_287().ilm_1);
  };
  protoOf(CellContainerImpl).pl6 = function (e) {
    return dispatch_3(this, this.ami_1, e, Companion_getInstance_287().jlm_1);
  };
  protoOf(CellContainerImpl).ql6 = function (e) {
    dispatch_3(this, this.ami_1, e, Companion_getInstance_287().klm_1);
    this.ami_1 = null;
  };
  protoOf(CellContainerImpl).mlq = function (current, loc) {
    return this.olq().mlq(current, loc);
  };
  protoOf(CellContainerImpl).bmi = function (loc) {
    var target = null;
    var _iterator__ex2g4s = this.umh_1.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var popup = _iterator__ex2g4s.m();
      target = this.mlq(popup, loc);
      if (!(target == null))
        break $l$loop;
    }
    if (target == null) {
      target = this.mlq(this.qmh_1, loc);
    }
    if (target == null) {
      target = this.qmh_1;
    }
    return target;
  };
  protoOf(CellContainerImpl).hm9 = function (runnable) {
    if (this.wmh_1) {
      runnable();
    } else {
      this.wmh_1 = true;
      this.vmh_1.a28(CellContainerListener$onBeforeCommand$ref());
      try {
        runnable();
      }finally {
        this.vmh_1.a28(CellContainerListener$onAfterCommand$ref());
        this.wmh_1 = false;
      }
    }
  };
  protoOf(CellContainerImpl).vlm = function (cell) {
    var _iterator__ex2g4s = get_asBaseCellInternal(cell).wlm().k();
    while (_iterator__ex2g4s.l()) {
      var popup = _iterator__ex2g4s.m();
      this.umh_1.e(popup);
    }
  };
  protoOf(CellContainerImpl).xlm = function (cell) {
    var _iterator__ex2g4s = get_asBaseCellInternal(cell).wlm().k();
    while (_iterator__ex2g4s.l()) {
      var popup = _iterator__ex2g4s.m();
      this.umh_1.k2(popup);
    }
  };
  protoOf(CellContainerImpl).mlk = function (removing) {
    // Inline function 'kotlin.require' call
    if (!equals(this, removing.llk())) {
      // Inline function 'jetbrains.ocelot.projectional.cell.impl.container.CellContainerImpl.beforeCellRemoved.<anonymous>' call
      var message = 'Not attached to current container: ' + toString_1(removing);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    if (isDependent(this, this.smh_1.qr(), removing)) {
      this.smh_1.t2c(null);
    }
    if (isDependent(this, this.rmh_1, removing)) {
      this.rmh_1 = null;
    }
  };
  protoOf(CellContainerImpl).rlm = function (cell, prop, change) {
    this.vmh_1.a28(CellContainerImpl$cellPropertyChanged$lambda(cell, prop, change));
  };
  protoOf(CellContainerImpl).eln = function (cell, change) {
    this.vmh_1.a28(CellContainerImpl$cellChildAdded$lambda(cell, change));
  };
  protoOf(CellContainerImpl).gln = function (cell, change) {
    this.vmh_1.a28(CellContainerImpl$cellChildRemoved$lambda(cell, change));
  };
  protoOf(CellContainerImpl).cln = function (cell) {
    this.umh_1.e(cell);
  };
  protoOf(CellContainerImpl).aln = function (cell) {
    this.mlk(cell);
    this.umh_1.k2(cell);
  };
  protoOf(CellContainerImpl).wmi = function (listener) {
    return this.vmh_1.z27(listener);
  };
  protoOf(CellContainerImpl).xmi = function () {
    this.xmh_1 = Companion_getInstance_289().cmi_1;
  };
  protoOf(CellContainerImpl).nlq = function (cell) {
    return this.olq().nlq(cell);
  };
  protoOf(CellContainerImpl).rlp = function () {
    return this.smh_1;
  };
  protoOf(CellContainerImpl).ymi = function (cell) {
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestors(cell);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.cell.impl.container.CellContainerImpl.getScrollingCell.<anonymous>' call
        if (element.clo(Companion_getInstance_270().klr_1)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var scrollRoot = tmp$ret$1;
    return scrollRoot == null ? this.qmh_1 : scrollRoot.q2r();
  };
  function RootCell(cellContainer) {
    BaseCell.call(this, cellContainer);
  }
  function handleChildAdd($this, event) {
    checkRootIndent($this);
    var tmp0_safe_receiver = $this.jmj_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a28(IndentCell$handleChildAdd$lambda(event));
    }
  }
  function handleChildRemove($this, event) {
    checkRootIndent($this);
    var tmp0_safe_receiver = $this.jmj_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a28(IndentCell$handleChildRemove$lambda(event));
    }
  }
  function handlePropertyChanged($this, cell, prop, event) {
    checkRootIndent($this);
    var tmp0_safe_receiver = $this.jmj_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a28(IndentCell$handlePropertyChanged$lambda(cell, prop, event));
    }
  }
  function checkRootIndent($this) {
    var tmp;
    if (!$this.kmj()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return tmp;
  }
  function IndentCell$scrollToAsync$lambda($rectSupplier, this$0, $ancestor) {
    return function () {
      var rect = $rectSupplier();
      return new Rectangle(rect.cku_1.jku(get_origin_0(this$0).kku(get_origin_0($ancestor))), rect.dku_1);
    };
  }
  function IndentCell$handleChildAdd$lambda($event) {
    return function (listener) {
      listener.lmj($event);
      return Unit_instance;
    };
  }
  function IndentCell$handleChildRemove$lambda($event) {
    return function (listener) {
      listener.mmj($event);
      return Unit_instance;
    };
  }
  function IndentCell$handlePropertyChanged$lambda($cell, $prop, $event) {
    return function (listener) {
      listener.nmj($cell, $prop, $event);
      return Unit_instance;
    };
  }
  function IndentCell$addListener$$inlined$toDisposable$1($disposable, $listeners, this$0) {
    this.omj_1 = $disposable;
    this.pmj_1 = $listeners;
    this.qmj_1 = this$0;
  }
  protoOf(IndentCell$addListener$$inlined$toDisposable$1).vr = function () {
    this.omj_1.vr();
    var tmp;
    if (this.pmj_1._v.np()) {
      this.qmj_1.jmj_1 = null;
      tmp = Unit_instance;
    }
    return tmp;
  };
  function IndentCell(isIndented, indentNumSpaces) {
    isIndented = isIndented === VOID ? false : isIndented;
    indentNumSpaces = indentNumSpaces === VOID ? 2 : indentNumSpaces;
    BaseCell_init_$Init$(this);
    this.hmj_1 = isIndented;
    this.imj_1 = indentNumSpaces;
    this.jmj_1 = null;
  }
  protoOf(IndentCell).kmj = function () {
    var tmp;
    if (this.qlc()) {
      var tmp_0 = this.yt();
      tmp = !(tmp_0 instanceof IndentCell);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IndentCell).slp = function (rectSupplier) {
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestors(this);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.cell.indent.IndentCell.scrollToAsync.<anonymous>' call
        if (!(element instanceof IndentCell)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var ancestor = tmp$ret$1;
    var tmp = ensureNotNull(ancestor);
    return tmp.slp(IndentCell$scrollToAsync$lambda(rectSupplier, this, ancestor));
  };
  protoOf(IndentCell).rmj = function () {
    var tmp;
    if (this.kmj()) {
      tmp = this;
    } else {
      var parent = this.yt();
      var tmp_0;
      if (parent instanceof IndentCell) {
        tmp_0 = parent.rmj();
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(IndentCell).plm = function (prop, event) {
    protoOf(BaseCell).plm.call(this, prop, event);
    var tmp0_safe_receiver = this.rmj();
    if (tmp0_safe_receiver == null)
      null;
    else {
      handlePropertyChanged(tmp0_safe_receiver, this, prop, event);
    }
  };
  protoOf(IndentCell).olk = function (event) {
    protoOf(BaseCell).olk.call(this, event);
    var tmp0_safe_receiver = this.rmj();
    if (tmp0_safe_receiver == null)
      null;
    else {
      handleChildAdd(tmp0_safe_receiver, event);
    }
  };
  protoOf(IndentCell).nlk = function (event) {
    protoOf(BaseCell).nlk.call(this, event);
    var tmp0_safe_receiver = this.rmj();
    if (tmp0_safe_receiver == null)
      null;
    else {
      handleChildRemove(tmp0_safe_receiver, event);
    }
  };
  protoOf(IndentCell).smj = function (listener) {
    checkRootIndent(this);
    var listeners = {_v: this.jmj_1};
    if (listeners._v == null) {
      listeners._v = new Listeners();
      this.jmj_1 = listeners._v;
    }
    var disposable = listeners._v.z27(listener);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new IndentCell$addListener$$inlined$toDisposable$1(disposable, listeners, this);
  };
  function NewLineCell() {
    IndentCell.call(this);
  }
  protoOf(NewLineCell).olk = function (event) {
    throw IllegalStateException_init_$Create$_0("You shouldn't add anything to new line cells");
  };
  function isNotRootIndent($this, cell) {
    var tmp;
    if (cell instanceof IndentCell) {
      tmp = !cell.kmj();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function BaseIndentUpdatingListener(indentUpdater) {
    this.emk_1 = indentUpdater;
  }
  protoOf(BaseIndentUpdatingListener).lmj = function (event) {
    var newItem = event.k27();
    this.emk_1.vli(newItem);
    if (this.emk_1.zli(newItem)) {
      if (this.emk_1.blj(newItem) && isNotRootIndent(this, newItem.yt())) {
        this.gmk(newItem);
      } else if (!this.emk_1.blj(newItem)) {
        this.fmk(newItem);
      }
    }
  };
  protoOf(BaseIndentUpdatingListener).mmj = function (event) {
    this.emk_1.wli(event.i27());
  };
  protoOf(BaseIndentUpdatingListener).nmj = function (cell, prop, event) {
    if (CounterUtil_getInstance().uly(prop)) {
      this.jmk(cell, prop, event);
    } else if (isPopupProp(prop)) {
      var propertyChangeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      this.imk(propertyChangeEvent);
    } else if (prop === get_VISIBLE()) {
      if (!(event instanceof PropertyChangeEvent))
        THROW_CCE();
      this.emk_1.xli(cell, event);
      if (event.p2e_1) {
        this.fmk(cell);
      }
    } else if (Companion_getInstance_275().cly_1.s(prop) && isNotRootIndent(this, cell)) {
      this.hmk(cell, prop);
    }
  };
  protoOf(BaseIndentUpdatingListener).fmk = function (cell) {
    var _iterator__ex2g4s = Companion_getInstance_275().cly_1.k();
    while (_iterator__ex2g4s.l()) {
      var p = _iterator__ex2g4s.m();
      this.hmk(cell, p);
    }
  };
  function childAdded($this, child, watchVisibility) {
    if ($this.zli(child)) {
      // Inline function 'kotlin.check' call
      if (!!$this.alj(child)) {
        // Inline function 'jetbrains.ocelot.projectional.cell.indent.updater.IndentUpdater.childAdded.<anonymous>' call
        var message = 'child ' + toString_1(child) + ' is already attached';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      setAttached($this, child, true);
      onChildAdd($this, child);
    }
    if (watchVisibility) {
      // Inline function 'kotlin.check' call
      if (!!$this.qli_1.w2(child)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      var tmp2 = $this.qli_1;
      // Inline function 'kotlin.collections.set' call
      var value = watch_0($this, child);
      tmp2.r2(child, value);
    }
    if (!$this.blj(child)) {
      var children = child.g2r();
      var _iterator__ex2g4s = children.k();
      while (_iterator__ex2g4s.l()) {
        var c = _iterator__ex2g4s.m();
        childAdded($this, c, watchVisibility);
      }
    }
  }
  function childRemoved($this, child, unwatchVisibility) {
    var children = child.g2r();
    if (unwatchVisibility) {
      ensureNotNull($this.qli_1.s2(child)).vr();
    }
    if (!$this.blj(child)) {
      var inductionVariable = children.n() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var c = children.q(i);
          childRemoved($this, c, unwatchVisibility);
        }
         while (0 <= inductionVariable);
    }
    if ($this.zli(child)) {
      // Inline function 'kotlin.check' call
      if (!$this.alj(child)) {
        // Inline function 'jetbrains.ocelot.projectional.cell.indent.updater.IndentUpdater.childRemoved.<anonymous>' call
        var message = 'child ' + toString_1(child) + ' is already detached';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      onChildRemove($this, child);
      setAttached($this, child, false);
    }
  }
  function onChildAdd($this, child) {
    var insertAt = new Position($this, child);
    var prevNewLinePos = prevNewLine($this, insertAt.mmk());
    if ($this.blj(child)) {
      var wrapper = $this.lli_1.glj(child);
      // Inline function 'kotlin.collections.set' call
      $this.oli_1.r2(child, wrapper);
      if (prevNewLinePos == null) {
        var first = new Position($this, firstLeaf($this, $this.jli_1));
        children($this, $this.mli_1).p2(first.nmk(insertAt), wrapper.plj());
        var tmp3 = $this.pli_1;
        // Inline function 'kotlin.collections.set' call
        var value = $this.mli_1;
        tmp3.r2(child, value);
      } else {
        var targetLine = ensureNotNull($this.nli_1.y2(prevNewLinePos.qr()));
        var indentDelta = calculateIndent($this, prevNewLinePos.qr()) > 0 ? 1 : 0;
        children($this, targetLine).p2((prevNewLinePos.nmk(insertAt) - 1 | 0) + indentDelta | 0, wrapper.plj());
        // Inline function 'kotlin.collections.set' call
        $this.pli_1.r2(child, targetLine);
      }
      wrapper.qlj();
    } else {
      if (child instanceof NewLineCell) {
        var nextNewLinePos = nextNewLine($this, insertAt.m());
        var newLine = $this.lli_1.elj();
        var indent = calculateIndent($this, child);
        if (indent > 0) {
          var indentItem = $this.lli_1.flj(indent);
          children($this, newLine).e(indentItem);
        }
        // Inline function 'kotlin.collections.set' call
        $this.nli_1.r2(child, newLine);
        if (prevNewLinePos == null) {
          targetChildren($this).p2(1, newLine);
        } else {
          var prevLine = $this.nli_1.y2(prevNewLinePos.qr());
          var prevLineIndex = lastIndexOf_1(targetChildren($this), prevLine);
          targetChildren($this).p2(prevLineIndex + 1 | 0, newLine);
        }
        var positions = nextNewLinePos == null ? toEnd($this, insertAt.m()) : range($this, insertAt.m(), nextNewLinePos);
        $l$loop: while (positions.l()) {
          var part = positions.m().qr();
          if (!$this.blj(part))
            continue $l$loop;
          var wrapper_0 = ensureNotNull($this.oli_1.y2(part));
          var item = wrapper_0.plj();
          if ($this.lli_1.klj(item) == null) {
            throw IllegalStateException_init_$Create$();
          }
          removeFromParent_0($this, item);
          children($this, newLine).e(item);
        }
      }
    }
  }
  function targetChildren($this) {
    return children($this, $this.kli_1);
  }
  function onChildRemove($this, child) {
    var removeAt = new Position($this, child);
    var prevNewLinePos = prevNewLine($this, removeAt.mmk());
    if ($this.blj(child)) {
      var line;
      var index;
      if (prevNewLinePos == null) {
        var first = new Position($this, firstLeaf($this, $this.jli_1));
        line = $this.mli_1;
        index = first.nmk(removeAt);
      } else {
        line = ensureNotNull($this.nli_1.y2(prevNewLinePos.qr()));
        index = (prevNewLinePos.nmk(removeAt) - 1 | 0) + (calculateIndent($this, prevNewLinePos.qr()) > 0 ? 1 : 0) | 0;
      }
      var toRemove = children($this, line).q(index);
      var wrapper = $this.oli_1.y2(child);
      // Inline function 'kotlin.check' call
      if (!(ensureNotNull(wrapper).plj() === toRemove)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      $this.pli_1.s2(child);
      ensureNotNull($this.oli_1.s2(child)).b5();
      children($this, line).q2(index);
    } else {
      if (child instanceof NewLineCell) {
        var lineCell = $this.nli_1.s2(child);
        // Inline function 'kotlin.check' call
        if (!!(lineCell == null)) {
          throw IllegalStateException_init_$Create$_0('Check failed.');
        }
        if (calculateIndent($this, child) > 0) {
          children($this, lineCell).q2(0);
        }
        removeFromParent_0($this, lineCell);
        var tmp;
        if (prevNewLinePos == null) {
          tmp = $this.mli_1;
        } else {
          tmp = ensureNotNull($this.nli_1.y2(prevNewLinePos.qr()));
        }
        var mergeWith = tmp;
        var _iterator__ex2g4s = ArrayList_init_$Create$_1(children($this, lineCell)).k();
        while (_iterator__ex2g4s.l()) {
          var c = _iterator__ex2g4s.m();
          removeFromParent_0($this, c);
          children($this, mergeWith).e(c);
        }
      }
    }
  }
  function removeFromParent_0($this, c) {
    children($this, $this.lli_1.klj(c)).k2(c);
  }
  function prevNewLine($this, from) {
    var current = from;
    while (!(current == null)) {
      var tmp = current.qr();
      if (tmp instanceof NewLineCell) {
        return current;
      }
      current = current.mmk();
    }
    return null;
  }
  function nextNewLine($this, from) {
    var current = from;
    while (!(current == null)) {
      var tmp = current.qr();
      if (tmp instanceof NewLineCell) {
        return current;
      }
      current = current.m();
    }
    return null;
  }
  function toEnd($this, pos) {
    return new IndentUpdater$toEnd$1(pos);
  }
  function range($this, from, to) {
    return new IndentUpdater$range$1(from, to);
  }
  function calculateIndent($this, part) {
    var result = 0;
    var current = part.yt();
    var prevCurrent = part;
    while (!(current === $this.jli_1)) {
      var prevNewLine_0 = prevNewLine($this, new Position($this, ensureNotNull(prevCurrent)));
      if (isIndented($this, current) && !(prevNewLine_0 == null) && prevNewLine_0.qr().yt() === current) {
        var tmp = result;
        result = tmp + (current instanceof IndentCell ? current : THROW_CCE()).imj_1 | 0;
      }
      prevCurrent = current;
      current = ensureNotNull(current).yt();
    }
    return result;
  }
  function firstLeaf($this, item) {
    if ($this.blj(item))
      return item;
    var _iterator__ex2g4s = item.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      if ($this.zli(child) && !isEmptyIndent($this, child)) {
        return firstLeaf($this, child);
      }
    }
    return item;
  }
  function children($this, target) {
    return $this.lli_1.ilj(target);
  }
  function setAttached($this, src, value) {
    if (value) {
      $this.tli_1.e(src);
    } else {
      $this.tli_1.k2(src);
    }
  }
  function isEmptyIndent($this, source) {
    if (!(source instanceof IndentCell))
      return false;
    var _iterator__ex2g4s = source.g2r().k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var cell = _iterator__ex2g4s.m();
      if (!$this.zli(cell))
        continue $l$loop;
      if (!isEmptyIndent($this, cell))
        return false;
    }
    return true;
  }
  function watch_0($this, child) {
    var tmp;
    if ($this.blj(child)) {
      var tmp_0 = child.elp();
      tmp = tmp_0.p27(IndentUpdater$watch$lambda($this, child));
    } else {
      tmp = Companion_getInstance_25().wr_1;
    }
    return tmp;
  }
  function isIndented($this, src) {
    var tmp;
    if (src instanceof IndentCell) {
      tmp = src.hmj_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function getCorrespondingLine($this, cell) {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var this_0 = ancestorsFrom(cell);
    var tmp = filter(this_0, IndentUpdater$getCorrespondingLine$lambda);
    var tmp$ret$0 = isInterface(tmp, Sequence) ? tmp : THROW_CCE();
    var indentParent = first_1(tmp$ret$0);
    var indentContainer = indentParent.rmj();
    var indentUpdater = $this.lli_1.nlj(indentContainer);
    var tmp_0 = ancestorsFrom(cell);
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = map(tmp_0, IndentUpdater$getCorrespondingLine$lambda_0(indentUpdater));
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.cell.indent.updater.IndentUpdater.getCorrespondingLine.<anonymous>' call
        if (!(element == null)) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    return tmp$ret$2;
  }
  function IndentUpdater$toEnd$1($pos) {
    this.omk_1 = $pos;
  }
  protoOf(IndentUpdater$toEnd$1).l = function () {
    return !(this.omk_1 == null);
  };
  protoOf(IndentUpdater$toEnd$1).m = function () {
    var result = this.omk_1;
    this.omk_1 = ensureNotNull(this.omk_1).m();
    return ensureNotNull(result);
  };
  function IndentUpdater$range$1($from, $to) {
    this.qmk_1 = $to;
    this.pmk_1 = $from;
  }
  protoOf(IndentUpdater$range$1).l = function () {
    return !equals(this.pmk_1, this.qmk_1);
  };
  protoOf(IndentUpdater$range$1).m = function () {
    var result = this.pmk_1;
    this.pmk_1 = ensureNotNull(this.pmk_1).m();
    return ensureNotNull(result);
  };
  function IndentUpdater$watch$lambda(this$0, $child) {
    return function (event) {
      this$0.clj($child, event);
      return Unit_instance;
    };
  }
  function IndentUpdater$getCorrespondingLine$lambda(it) {
    return it instanceof IndentCell;
  }
  function IndentUpdater$getCorrespondingLine$lambda_0($indentUpdater) {
    return function (current) {
      return $indentUpdater.pli_1.y2(current);
    };
  }
  function IndentUpdater(root, target, indentUpdaterTarget) {
    this.jli_1 = root;
    this.kli_1 = target;
    this.lli_1 = indentUpdaterTarget;
    this.mli_1 = this.lli_1.elj();
    this.nli_1 = HashMap_init_$Create$();
    this.oli_1 = HashMap_init_$Create$();
    this.pli_1 = HashMap_init_$Create$();
    this.qli_1 = HashMap_init_$Create$();
    this.rli_1 = false;
    this.sli_1 = null;
    this.tli_1 = HashSet_init_$Create$();
    targetChildren(this).e(this.mli_1);
  }
  protoOf(IndentUpdater).uli = function () {
    this.rli_1 = true;
  };
  protoOf(IndentUpdater).vli = function (child) {
    return childAdded(this, child, true);
  };
  protoOf(IndentUpdater).wli = function (child) {
    return childRemoved(this, child, true);
  };
  protoOf(IndentUpdater).xli = function (item, change) {
    if (item === this.yli())
      return Unit_instance;
    if (change.p2e_1) {
      childAdded(this, item, false);
    } else {
      this.sli_1 = item;
      try {
        childRemoved(this, item, false);
      }finally {
        this.sli_1 = null;
      }
    }
  };
  protoOf(IndentUpdater).yli = function () {
    return this.jli_1;
  };
  protoOf(IndentUpdater).zli = function (source) {
    var current = source;
    while (!(current === this.jli_1)) {
      var tmp0 = current;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          // Inline function 'jetbrains.ocelot.projectional.cell.indent.updater.IndentUpdater.isVisible.<anonymous>' call
          var message = "Can't find a root indent container for " + toString_1(source);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      if (!current.clo(get_VISIBLE()) && !(current === this.sli_1)) {
        return false;
      }
      current = current.yt();
    }
    return true;
  };
  protoOf(IndentUpdater).alj = function (src) {
    return this.tli_1.s(src);
  };
  protoOf(IndentUpdater).blj = function (source) {
    return !(source instanceof IndentCell);
  };
  protoOf(IndentUpdater).clj = function (cell, event) {
  };
  protoOf(IndentUpdater).dlj = function (cell) {
    if (cell.g2r().p())
      return get_bounds(this.jli_1);
    var firstLeaf = firstVisibleLeaf(cell);
    if (firstLeaf == null || firstLeaf === cell)
      return null;
    var firstLine = getCorrespondingLine(this, firstLeaf);
    // Inline function 'kotlin.check' call
    if (!!(firstLine == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp0_elvis_lhs = lastVisibleLeaf(cell);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var lastLeaf = tmp;
    var lastLine = getCorrespondingLine(this, lastLeaf);
    // Inline function 'kotlin.check' call
    if (!!(lastLine == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp_0;
    if (firstLine === lastLine) {
      var singleLineBounds = this.lli_1.mlj(firstLine);
      var lastBounds = get_bounds(lastLeaf);
      var firstBoundsOriginX = get_origin_0(firstLeaf).eku_1;
      tmp_0 = new Rectangle(new Vector(firstBoundsOriginX, singleLineBounds.cku_1.fku_1), new Vector((lastBounds.cku_1.eku_1 + lastBounds.dku_1.eku_1 | 0) - firstBoundsOriginX | 0, singleLineBounds.dku_1.fku_1));
    } else {
      var firstLineBounds = this.lli_1.mlj(firstLine);
      var lastLineBounds = this.lli_1.mlj(lastLine);
      var firstLineOrigin = firstLineBounds.cku_1;
      var lastLineOrigin = lastLineBounds.cku_1;
      var lastLineDimension = lastLineBounds.dku_1;
      tmp_0 = new Rectangle(firstLineOrigin, new Vector((lastLineOrigin.eku_1 + lastLineDimension.eku_1 | 0) - firstLineOrigin.eku_1 | 0, (lastLineOrigin.fku_1 + lastLineDimension.fku_1 | 0) - firstLineOrigin.fku_1 | 0));
    }
    return tmp_0;
  };
  function Position$nextLeaves$1$iterator$1($item, this$0) {
    this.tmk_1 = this$0;
    this.rmk_1 = $item;
    this.smk_1 = next(this$0, $item);
  }
  protoOf(Position$nextLeaves$1$iterator$1).l = function () {
    return !(this.smk_1 == null);
  };
  protoOf(Position$nextLeaves$1$iterator$1).m = function () {
    this.rmk_1 = this.smk_1;
    this.smk_1 = next(this.tmk_1, this.rmk_1);
    return ensureNotNull(this.rmk_1);
  };
  function next($this, item) {
    var tmp0_elvis_lhs = nextVisibleLeaf($this, item);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var next = tmp;
    return upperMostCell($this, next);
  }
  function prev($this, item) {
    var tmp0_elvis_lhs = prevVisibleLeaf($this, item);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var prev = tmp;
    return upperMostCell($this, prev);
  }
  function upperMostCell($this, item) {
    var current = item.yt();
    var upperMostCell = item;
    var root = $this.kmk_1.yli();
    while (!(current === root)) {
      // Inline function 'kotlin.checkNotNull' call
      var tmp0 = current;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      if ($this.kmk_1.blj(current)) {
        upperMostCell = current;
      }
      current = current.yt();
    }
    return upperMostCell;
  }
  function nextLeaves($this, item) {
    return new Position$nextLeaves$1(item, $this);
  }
  function nextVisibleLeaf($this, item) {
    var root = $this.kmk_1.yli();
    var current = nextLeaf($this, item, root);
    while (!(current == null)) {
      if ($this.kmk_1.zli(current))
        return current;
      current = nextLeaf($this, current, root);
    }
    return null;
  }
  function prevVisibleLeaf($this, item) {
    var root = $this.kmk_1.yli();
    var current = prevLeaf($this, item, root);
    while (!(current == null)) {
      if ($this.kmk_1.zli(current))
        return current;
      current = prevLeaf($this, current, root);
    }
    return null;
  }
  function firstChild_0($this, p) {
    var current = p.q2r();
    while (!(current == null)) {
      if ($this.kmk_1.alj(current))
        return current;
      current = current.h2r();
    }
    return null;
  }
  function lastChild($this, p) {
    var current = p.r2r();
    while (!(current == null)) {
      if ($this.kmk_1.alj(current))
        return current;
      current = current.k2r();
    }
    return null;
  }
  function prevSibling($this, c) {
    var current = c.k2r();
    while (!(current == null)) {
      if ($this.kmk_1.alj(current))
        return current;
      if (!$this.kmk_1.rli_1 && $this.kmk_1.zli(current))
        return null;
      current = current.k2r();
    }
    return null;
  }
  function nextSibling($this, c) {
    var current = c.h2r();
    while (!(current == null)) {
      if ($this.kmk_1.alj(current))
        return current;
      if (!$this.kmk_1.rli_1 && $this.kmk_1.zli(current))
        return null;
      current = current.h2r();
    }
    return null;
  }
  function firstLeaf_0($this, p) {
    var $this_0 = $this;
    var p_0 = p;
    $l$1: do {
      $l$0: do {
        var tmp0_elvis_lhs = firstChild_0($this_0, p_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return p_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var first = tmp;
        $this_0 = $this_0;
        p_0 = first;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function lastLeaf($this, p) {
    var $this_0 = $this;
    var p_0 = p;
    $l$1: do {
      $l$0: do {
        var tmp0_elvis_lhs = lastChild($this_0, p_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return p_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var last = tmp;
        $this_0 = $this_0;
        p_0 = last;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function nextLeaf($this, c, within) {
    var current = c;
    while (true) {
      var nextSibling_0 = nextSibling($this, ensureNotNull(current));
      if (!(nextSibling_0 == null)) {
        return firstLeaf_0($this, nextSibling_0);
      }
      var parent = current.yt();
      if (parent === within)
        return null;
      current = parent;
    }
  }
  function prevLeaf($this, c, within) {
    var current = c;
    while (true) {
      var prevSibling_0 = prevSibling($this, ensureNotNull(current));
      if (!(prevSibling_0 == null)) {
        return lastLeaf($this, prevSibling_0);
      }
      var parent = current.yt();
      if (parent === within)
        return null;
      current = parent;
    }
  }
  function Position$nextLeaves$1($item, this$0) {
    this.umk_1 = $item;
    this.vmk_1 = this$0;
  }
  protoOf(Position$nextLeaves$1).k = function () {
    return new Position$nextLeaves$1$iterator$1(this.umk_1, this.vmk_1);
  };
  function Position(updater, cell) {
    this.kmk_1 = updater;
    this.lmk_1 = cell;
  }
  protoOf(Position).m = function () {
    var tmp0_elvis_lhs = next(this, this.lmk_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var current = tmp;
    return new Position(this.kmk_1, current);
  };
  protoOf(Position).mmk = function () {
    var tmp0_elvis_lhs = prev(this, this.lmk_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var current = tmp;
    return new Position(this.kmk_1, current);
  };
  protoOf(Position).qr = function () {
    return this.lmk_1;
  };
  protoOf(Position).nmk = function (to) {
    if (to.lmk_1 === this.lmk_1)
      return 0;
    var tmp;
    if (Composites_instance.z2r(this.lmk_1, to.lmk_1)) {
      var count = 0;
      var _iterator__ex2g4s = nextLeaves(this, this.lmk_1).k();
      $l$loop: while (_iterator__ex2g4s.l()) {
        var p = _iterator__ex2g4s.m();
        if (!(p instanceof IndentCell)) {
          count = count + 1 | 0;
        }
        if (p === to.lmk_1)
          break $l$loop;
      }
      tmp = count;
    } else {
      tmp = -to.nmk(this) | 0;
    }
    return tmp;
  };
  protoOf(Position).equals = function (other) {
    var tmp;
    if (!(other instanceof Position)) {
      tmp = false;
    } else {
      tmp = this.lmk_1 === other.lmk_1;
    }
    return tmp;
  };
  protoOf(Position).hashCode = function () {
    return hashCode(this.lmk_1);
  };
  function setAncestorProperty($this, leafMapper, spec, container, leaf) {
    var value = $this.wmk(spec, container, leaf);
    if (!equals(value, spec.ulm(leaf))) {
      leafMapper.mly(spec, value);
    }
  }
  function AncestorUtil() {
  }
  protoOf(AncestorUtil).wmk = function (spec, container, leaf) {
    var tmp0_safe_receiver = leaf.yt();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'jetbrains.ocelot.base.composite.dispatchByParent' call
      var current = tmp0_safe_receiver;
      while (!(current == null)) {
        // Inline function 'jetbrains.ocelot.projectional.cell.indent.util.AncestorUtil.getAncestorOrDefaultProperty.<anonymous>' call
        var $this$dispatchByParent = current;
        var value = $this$dispatchByParent.clo(spec);
        if (!equals(value, spec.ulm($this$dispatchByParent))) {
          return value;
        }
        if ($this$dispatchByParent === container)
          return spec.ulm(leaf);
        current = current.yt();
      }
    }
    return spec.ulm(leaf);
  };
  protoOf(AncestorUtil).xmk = function (leafMapper, container, leaf) {
    var _iterator__ex2g4s = Companion_getInstance_275().cly_1.k();
    while (_iterator__ex2g4s.l()) {
      var spec = _iterator__ex2g4s.m();
      setAncestorProperty(this, leafMapper, spec, container, leaf);
    }
  };
  var AncestorUtil_instance;
  function AncestorUtil_getInstance() {
    return AncestorUtil_instance;
  }
  function CellMapperContext(rootElement) {
    this.ymk_1 = rootElement;
    this.zmk_1 = HashMap_init_$Create$();
  }
  protoOf(CellMapperContext).aml = function (mapper) {
    var target = mapper.ql9_1;
    // Inline function 'kotlin.check' call
    if (!(this.zmk_1.y2(target) == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    // Inline function 'kotlin.collections.set' call
    this.zmk_1.r2(target, mapper);
  };
  protoOf(CellMapperContext).bml = function (mapper) {
    var result = this.zmk_1.s2(mapper.ql9_1);
    // Inline function 'kotlin.check' call
    if (!(result === mapper)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
  };
  protoOf(CellMapperContext).cml = function (target) {
    return this.zmk_1.y2(target);
  };
  function CellMapperUtils() {
  }
  protoOf(CellMapperUtils).dml = function (cell, ctx, factory) {
    var indentCell = cell instanceof IndentCell ? cell : THROW_CCE();
    // Inline function 'kotlin.check' call
    if (!indentCell.kmj()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return factory(indentCell, ctx);
  };
  var CellMapperUtils_instance;
  function CellMapperUtils_getInstance() {
    return CellMapperUtils_instance;
  }
  function IndentUtil() {
  }
  protoOf(IndentUtil).eml = function (cell, handler) {
    var _iterator__ex2g4s = cell.g2r().k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      if (!isVisible_1(child))
        continue $l$loop;
      if (child instanceof IndentCell) {
        this.eml(child, handler);
      } else {
        handler(child);
      }
    }
  };
  var IndentUtil_instance;
  function IndentUtil_getInstance() {
    return IndentUtil_instance;
  }
  function Companion_290() {
    Companion_instance_290 = this;
    this.fml_1 = new EmptyView();
  }
  var Companion_instance_290;
  function Companion_getInstance_290() {
    if (Companion_instance_290 == null)
      new Companion_290();
    return Companion_instance_290;
  }
  function EmptyView() {
    Companion_getInstance_290();
  }
  protoOf(EmptyView).i2j = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyView).gml = function () {
    return Companion_getInstance_251().iku_1;
  };
  protoOf(EmptyView).hml = function () {
    return 0;
  };
  protoOf(EmptyView).iml = function (message) {
    return false;
  };
  protoOf(EmptyView).jml = function (maxWidth) {
    return false;
  };
  function _get_linkText__2j4ckc($this) {
    if ($this.lml_1 == null) {
      return '';
    }
    var sb = new StringBuilder('\n');
    getLinkText($this, $this.lml_1, sb);
    return sb.toString();
  }
  function getLinkText($this, cell, sb) {
    if (cell instanceof TextCell) {
      sb.d9(cell.laz().qr());
    } else {
      var _iterator__ex2g4s = cell.g2r().k();
      while (_iterator__ex2g4s.l()) {
        var child = _iterator__ex2g4s.m();
        getLinkText($this, child, sb);
      }
    }
  }
  function Message(text, link, styler) {
    text = text === VOID ? null : text;
    link = link === VOID ? null : link;
    styler = styler === VOID ? null : styler;
    this.kml_1 = text;
    this.lml_1 = link;
    this.mml_1 = styler;
    // Inline function 'kotlin.require' call
    if (!(!(this.kml_1 == null) || !(this.lml_1 == null))) {
      // Inline function 'jetbrains.ocelot.projectional.cell.message.Message.<anonymous>' call
      var message = 'Both text and link are null';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(Message).nml = function () {
    var tmp;
    if (this.lml_1 == null) {
      tmp = new SimpleMessageView(ensureNotNull(this.kml_1));
    } else {
      if (!(this.lml_1.yt() == null)) {
        this.lml_1.n3b();
      }
      tmp = new MessageViewWithLink(this.kml_1, this.lml_1);
    }
    return tmp;
  };
  protoOf(Message).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    var message = (other == null ? true : other instanceof Message) ? other : THROW_CCE();
    return !(this.kml_1 == ensureNotNull(message).kml_1) ? false : this.lml_1 === message.lml_1;
  };
  protoOf(Message).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.kml_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp0_safe_receiver_0 = this.lml_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    result = tmp + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    return result;
  };
  protoOf(Message).toString = function () {
    return plus_10(this.kml_1, _get_linkText__2j4ckc(this));
  };
  function MessageCell$Companion$TRAIT$1() {
    CellTrait.call(this);
    this.oml_1 = new MessagePopupSpec();
  }
  protoOf(MessageCell$Companion$TRAIT$1).flo = function (cell, spec) {
    var specMatcher = specMatcherValue(Companion_getInstance_268().elr_1, this.oml_1);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.message.<no name provided>.get.<anonymous>' call
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    } else {
      tmp = result.sma_1;
    }
    return tmp;
  };
  function MessagePopupSpec() {
  }
  protoOf(MessagePopupSpec).ilr = function (cell) {
    return false;
  };
  protoOf(MessagePopupSpec).glr = function (cell, dimension, viewport, alignedWidth) {
    var messageCell = cell instanceof MessageCell ? cell : THROW_CCE();
    return messageCell.zml(dimension, new Vector(alignedWidth, viewport.fku_1));
  };
  protoOf(MessagePopupSpec).hlr = function (cell, popup) {
  };
  function Companion_291() {
    Companion_instance_291 = this;
    this.amm_1 = new Border(Companion_getInstance_325().xls_1, 1);
    this.bmm_1 = new Vector(600, 600);
    this.cmm_1 = 5;
    var tmp = this;
    tmp.dmm_1 = new MessageCell$Companion$TRAIT$1();
  }
  var Companion_instance_291;
  function Companion_getInstance_291() {
    if (Companion_instance_291 == null)
      new Companion_291();
    return Companion_instance_291;
  }
  function MessageCell(message) {
    Companion_getInstance_291();
    VerticalCell.call(this);
    this.xml_1 = new ScrollCell();
    this.yml_1 = message.nml();
    this.xml_1.g2r().e(ensureNotNull(this.yml_1.i2j()));
    this.xml_1.bln(Companion_getInstance_270().jlr_1, Companion_getInstance_291().bmm_1);
    this.g2r().e(this.xml_1);
    this.bln(get_HAS_POPUP_DECORATION(), true);
    this.bln(get_HAS_SHADOW(), true);
    this.bln(get_BACKGROUND(), Companion_getInstance_325().ilt_1);
    this.bln(get_BORDER(), Companion_getInstance_291().amm_1);
    this.olp(Companion_getInstance_291().dmm_1);
  }
  protoOf(MessageCell).hml = function () {
    return this.yml_1.hml();
  };
  protoOf(MessageCell).zml = function (dimension, viewport) {
    var changedLayout = this.yml_1.jml(viewport.eku_1 - 5 | 0);
    var maxLineDimension = this.yml_1.gml();
    var height = imul(maxLineDimension.fku_1, this.hml()) + 5 | 0;
    var scroll = height > viewport.fku_1;
    this.xml_1.bln(Companion_getInstance_270().llr_1, scroll);
    this.xml_1.bln(Companion_getInstance_270().jlr_1, viewport);
    var tmp;
    if (changedLayout) {
      var tmp0 = maxLineDimension.eku_1 + 5 | 0;
      // Inline function 'kotlin.math.min' call
      var b = viewport.eku_1;
      var tmp$ret$0 = Math.min(tmp0, b);
      tmp = new Vector(tmp$ret$0, scroll ? viewport.fku_1 : height);
    } else {
      tmp = dimension;
    }
    return tmp;
  };
  function canHaveMessages($this, cell) {
    return !inPopup(cell);
  }
  function hasAnyMessage($this, cell) {
    return $this.mmm(cell) || $this.nmm(cell) || $this.omm(cell) || $this.pmm(cell);
  }
  function set_2($this, cell, message, prop) {
    return $this.qmm(cell, new Message(message), prop);
  }
  function MessageController$install$lambda(cell) {
    return hasAnyMessage(MessageController_getInstance(), cell) && canHaveMessages(MessageController_getInstance(), cell);
  }
  function MessageController$install$lambda_0(cell) {
    return !Companion_getInstance_294().umm(cell) && !hasAnyMessage(MessageController_getInstance(), cell);
  }
  function MessageController() {
    MessageController_instance = this;
    this.emm_1 = 300;
    this.fmm_1 = 13;
    this.gmm_1 = Companion_getInstance_326().s8r('Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif');
    this.hmm_1 = CellPropertySpec_init_$Create$('error', null);
    this.imm_1 = CellPropertySpec_init_$Create$('warning', null);
    this.jmm_1 = CellPropertySpec_init_$Create$('broken', null);
    this.kmm_1 = CellPropertySpec_init_$Create$('info', null);
    this.lmm_1 = listOf_0([this.kmm_1, this.jmm_1, this.hmm_1, this.imm_1]);
  }
  protoOf(MessageController).vmm = function (container, styler) {
    var trait = new MessageTrait(container, new StyleApplicator(styler));
    var tmp = Companion_getInstance_303();
    var tmp_0 = MessageController$install$lambda;
    return tmp.xmm(container, trait, tmp_0, MessageController$install$lambda_0);
  };
  protoOf(MessageController).ymm = function (container, styler, $super) {
    styler = styler === VOID ? null : styler;
    return $super === VOID ? this.vmm(container, styler) : $super.vmm.call(this, container, styler);
  };
  protoOf(MessageController).zmm = function (cell, message) {
    return set_2(this, cell, message, this.hmm_1);
  };
  protoOf(MessageController).amn = function (cell, message) {
    return set_2(this, cell, message, this.kmm_1);
  };
  protoOf(MessageController).bmn = function (cell, message) {
    return this.qmm(cell, message, this.kmm_1);
  };
  protoOf(MessageController).qmm = function (cell, message, prop) {
    var tmp;
    if (canHaveMessages(this, cell)) {
      tmp = setBackingToDefault(cell, prop, message);
    } else {
      tmp = Companion_getInstance_25().wr_1;
    }
    return tmp;
  };
  protoOf(MessageController).mmm = function (cell) {
    return !(cell.clo(this.jmm_1) == null);
  };
  protoOf(MessageController).omm = function (cell) {
    return !(cell.clo(this.imm_1) == null);
  };
  protoOf(MessageController).nmm = function (cell) {
    return !(this.cmn(cell) == null);
  };
  protoOf(MessageController).pmm = function (cell) {
    return !(this.dmn(cell) == null);
  };
  protoOf(MessageController).cmn = function (cell) {
    return cell.clo(this.hmm_1);
  };
  protoOf(MessageController).dmn = function (cell) {
    return cell.clo(this.kmm_1);
  };
  var MessageController_instance;
  function MessageController_getInstance() {
    if (MessageController_instance == null)
      new MessageController();
    return MessageController_instance;
  }
  function setBackingToDefault(cell, prop, newValue) {
    cell.bln(prop, newValue);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new setBackingToDefault$$inlined$toDisposable$1(cell, prop);
  }
  function setBackingToDefault$$inlined$toDisposable$1($cell, $prop) {
    this.emn_1 = $cell;
    this.fmn_1 = $prop;
  }
  protoOf(setBackingToDefault$$inlined$toDisposable$1).vr = function () {
    this.emn_1.bln(this.fmn_1, this.fmn_1.ulm(this.emn_1));
    return Unit_instance;
  };
  function subscribe($this, cell) {
    $this.jmn_1.r2(cell, doSubscribe($this, cell));
  }
  function doSubscribe($this, cell) {
    var result = Companion_getInstance_25().wr_1;
    var _iterator__ex2g4s = get_POPUP_SPECS().k();
    while (_iterator__ex2g4s.l()) {
      var spec = _iterator__ex2g4s.m();
      var prop = ensureNotNull(cell).flp(spec);
      if (!(prop.qr() == null)) {
        $this.lmn_1.d28(new PropertyChangeEvent(null, prop.qr()));
      }
      result = result.sr(prop.o27($this.lmn_1));
    }
    var tmp = result;
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$0 = new MessagePopupSupport$doSubscribe$$inlined$toDisposable$1(cell, $this);
    result = tmp.sr(tmp$ret$0);
    result = result.sr(ensureNotNull(cell).g2r().o27($this.nmn_1));
    var _iterator__ex2g4s_0 = cell.g2r().k();
    while (_iterator__ex2g4s_0.l()) {
      var child = _iterator__ex2g4s_0.m();
      subscribe($this, child);
    }
    return result;
  }
  function onChildrenUpdated($this, event) {
    switch (event.h27_1.a3_1) {
      case 0:
        subscribe($this, event.k27());
        break;
      case 2:
        unsubscribe($this, event.i27());
        break;
      case 1:
        unsubscribe($this, event.i27());
        subscribe($this, event.k27());
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    updateVisibility($this);
  }
  function onChildPopupBecameVisible($this, visible) {
    $this.imn_1 = $this.imn_1 + (visible ? 1 : -1) | 0;
    updateVisibility($this);
  }
  function onChildPopupChanged($this, event) {
    if (isRelevant($this, event.o2e_1)) {
      unsubscribePopup($this, ensureNotNull(event.o2e_1));
    }
    if (isRelevant($this, event.p2e_1)) {
      subscribePopup($this, ensureNotNull(event.p2e_1));
    }
    updateVisibility($this);
  }
  function isRelevant($this, popup) {
    return !(popup == null) && !(popup === $this.gmn_1) && !Companion_instance_292.omn(popup);
  }
  function subscribePopup($this, popup) {
    $this.kmn_1.r2(popup, popup.elp().o27($this.mmn_1));
    if (popup.elp().qr()) {
      $this.imn_1 = $this.imn_1 + 1 | 0;
    }
  }
  function unsubscribePopup($this, popup) {
    if ($this.kmn_1.np()) {
      return Unit_instance;
    }
    var tmp0_elvis_lhs = $this.kmn_1.s2(popup);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var disposable = tmp;
    disposable.vr();
    if (popup.elp().qr()) {
      $this.imn_1 = $this.imn_1 - 1 | 0;
    }
  }
  function updateVisibility($this) {
    // Inline function 'kotlin.check' call
    if (!($this.imn_1 >= 0)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.message.MessagePopupSupport.updateVisibility.<anonymous>' call
      var message = 'count=' + $this.imn_1;
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    $this.gmn_1.elp().t2c($this.imn_1 === 0 || $this.hmn_1);
  }
  function unsubscribe($this, cell) {
    var tmp0_elvis_lhs = $this.jmn_1.s2(cell);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Not registered ' + toString_1(cell));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    value.vr();
  }
  function Companion_292() {
  }
  protoOf(Companion_292).omn = function (popup) {
    var spec = popup.ulp(Companion_getInstance_268().elr_1);
    return !(spec == null) && spec.flr();
  };
  var Companion_instance_292;
  function Companion_getInstance_292() {
    return Companion_instance_292;
  }
  function MessagePopupSupport$$inlined$eventHandler$1(this$0) {
    this.pmn_1 = this$0;
  }
  protoOf(MessagePopupSupport$$inlined$eventHandler$1).e2b = function (event) {
    onChildPopupBecameVisible(this.pmn_1, event.p2e_1);
    return Unit_instance;
  };
  protoOf(MessagePopupSupport$$inlined$eventHandler$1).d28 = function (event) {
    return this.e2b((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function MessagePopupSupport$$inlined$eventHandler$2(this$0) {
    this.qmn_1 = this$0;
  }
  protoOf(MessagePopupSupport$$inlined$eventHandler$2).e2b = function (event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.message.MessagePopupSupport.stub_for_inlining' call
    var $receiver = this.qmn_1;
    onChildPopupChanged($receiver, event);
    return Unit_instance;
  };
  protoOf(MessagePopupSupport$$inlined$eventHandler$2).d28 = function (event) {
    return this.e2b((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function MessagePopupSupport$$inlined$eventHandler$3(this$0) {
    this.rmn_1 = this$0;
  }
  protoOf(MessagePopupSupport$$inlined$eventHandler$3).e2b = function (event) {
    // Inline function 'jetbrains.ocelot.projectional.cell.message.MessagePopupSupport.stub_for_inlining' call
    var $receiver = this.rmn_1;
    onChildrenUpdated($receiver, event);
    return Unit_instance;
  };
  protoOf(MessagePopupSupport$$inlined$eventHandler$3).d28 = function (event) {
    return this.e2b((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function MessagePopupSupport$doSubscribe$$inlined$toDisposable$1($cell, this$0) {
    this.smn_1 = $cell;
    this.tmn_1 = this$0;
  }
  protoOf(MessagePopupSupport$doSubscribe$$inlined$toDisposable$1).vr = function () {
    var _iterator__ex2g4s = get_POPUP_SPECS().k();
    while (_iterator__ex2g4s.l()) {
      var spec = _iterator__ex2g4s.m();
      var popup = ensureNotNull(this.smn_1).clo(spec);
      if (!(popup == null)) {
        this.tmn_1.lmn_1.d28(new PropertyChangeEvent(popup, null));
      }
    }
    return Unit_instance;
  };
  function MessagePopupSupport(messagePopup, forceHide, forceShow) {
    this.gmn_1 = messagePopup;
    this.hmn_1 = forceShow;
    this.imn_1 = 0;
    this.jmn_1 = new ListMap();
    this.kmn_1 = new ListMap();
    var tmp = this;
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    tmp.mmn_1 = new MessagePopupSupport$$inlined$eventHandler$1(this);
    var tmp_0 = this;
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    tmp_0.lmn_1 = new MessagePopupSupport$$inlined$eventHandler$2(this);
    var tmp_1 = this;
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    tmp_1.nmn_1 = new MessagePopupSupport$$inlined$eventHandler$3(this);
    if (forceHide) {
      this.umn(true);
    }
    subscribe(this, ensureNotNull(this.gmn_1.yt()));
    updateVisibility(this);
  }
  protoOf(MessagePopupSupport).vmn = function () {
    return this.gmn_1.elp().qr();
  };
  protoOf(MessagePopupSupport).vr = function () {
    var _iterator__ex2g4s = this.jmn_1.pp().k();
    while (_iterator__ex2g4s.l()) {
      var registration = _iterator__ex2g4s.m();
      registration.vr();
    }
    this.jmn_1.m2();
    this.kmn_1.m2();
    this.gmn_1.elp().t2c(false);
  };
  protoOf(MessagePopupSupport).umn = function (forceHide) {
    if (forceHide) {
      this.hmn_1 = false;
      this.imn_1 = this.imn_1 + 1 | 0;
    } else {
      this.imn_1 = this.imn_1 - 1 | 0;
    }
    updateVisibility(this);
  };
  protoOf(MessagePopupSupport).wmn = function () {
    this.hmn_1 = true;
    updateVisibility(this);
  };
  function setProp($this, cell, prop, newValue) {
    var oldValue = cell.clo(prop);
    cell.bln(prop, newValue);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new MessageStyler$setProp$$inlined$toDisposable$1(cell, prop, newValue, oldValue);
  }
  function Companion_293() {
    Companion_instance_293 = this;
    this.xmn_1 = new Color(248, 231, 172);
  }
  var Companion_instance_293;
  function Companion_getInstance_293() {
    if (Companion_instance_293 == null)
      new Companion_293();
    return Companion_instance_293;
  }
  function MessageStyler$setProp$$inlined$toDisposable$1($cell, $prop, $newValue, $oldValue) {
    this.ymn_1 = $cell;
    this.zmn_1 = $prop;
    this.amo_1 = $newValue;
    this.bmo_1 = $oldValue;
  }
  protoOf(MessageStyler$setProp$$inlined$toDisposable$1).vr = function () {
    var value = this.ymn_1.clo(this.zmn_1);
    var tmp;
    if (equals(this.amo_1, value)) {
      this.ymn_1.bln(this.zmn_1, this.bmo_1);
      tmp = Unit_instance;
    }
    return tmp;
  };
  function MessageStyler() {
    Companion_getInstance_293();
  }
  protoOf(MessageStyler).cmo = function (cell) {
    return setProp(this, cell, get_LINK(), true);
  };
  protoOf(MessageStyler).dmo = function (cell) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = setProp(this, cell, Companion_getInstance_271().bls_1, Companion_getInstance_325().yls_1);
    } else {
      tmp = setProp(this, cell, get_BACKGROUND(), Companion_getInstance_325().qlt_1);
    }
    return tmp;
  };
  protoOf(MessageStyler).emo = function (cell) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = setProp(this, cell, Companion_getInstance_271().bls_1, Companion_getInstance_325().yls_1);
    } else {
      tmp = setProp(this, cell, get_RED_UNDERLINE(), true);
    }
    return tmp;
  };
  protoOf(MessageStyler).fmo = function (cell) {
    return setProp(this, cell, get_BACKGROUND(), Companion_getInstance_293().xmn_1);
  };
  var HoverState_NONE_instance;
  var HoverState_PENDING_HIDE_instance;
  var HoverState_PENDING_SHOW_instance;
  var HoverState_entriesInitialized;
  function HoverState_initEntries() {
    if (HoverState_entriesInitialized)
      return Unit_instance;
    HoverState_entriesInitialized = true;
    HoverState_NONE_instance = new HoverState('NONE', 0);
    HoverState_PENDING_HIDE_instance = new HoverState('PENDING_HIDE', 1);
    HoverState_PENDING_SHOW_instance = new HoverState('PENDING_SHOW', 2);
  }
  function schedule($this, action) {
    var removeAction = MessageTrait$MyHoverController$schedule$lambda($this, action);
    $this.jmo_1 = _get_edt__e67mgs($this.kmo_1).v2m(300, new sam$jetbrains_ocelot_base_edt_EdtTask$0_13(removeAction));
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return (new MessageTrait$MyHoverController$schedule$$inlined$toDisposable$1(removeAction)).sr($this.jmo_1);
  }
  function cancelHide($this, support) {
    if ($this.lmo(support) && $this.gmo_1.equals(HoverState_PENDING_HIDE_getInstance())) {
      $this.jmo_1.vr();
      cleanup_1($this);
      return true;
    }
    return false;
  }
  function cleanup_1($this) {
    $this.hmo_1 = null;
    $this.gmo_1 = HoverState_NONE_getInstance();
    $this.jmo_1 = Companion_getInstance_25().wr_1;
    $this.imo_1 = Companion_getInstance_25().wr_1;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_13(function_0) {
    this.mmo_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_13).wy = function () {
    return this.mmo_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_13).b4 = function () {
    return this.mmo_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_13).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_13).hashCode = function () {
    return hashCode(this.b4());
  };
  function MessageTrait$MyHoverController$scheduleHide$lambda(this$0, $support) {
    return function () {
      hide_0(this$0, $support);
      return Unit_instance;
    };
  }
  function MessageTrait$MyHoverController$scheduleShow$lambda(this$0, $support) {
    return function () {
      var tmp;
      if (!this$0.rmo_1) {
        $support.umn(false);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function MessageTrait$MyHoverController$schedule$lambda(this$0, $action) {
    return function () {
      cleanup_1(this$0);
      $action();
      return Unit_instance;
    };
  }
  function MessageTrait$MyHoverController$schedule$$inlined$toDisposable$1($removeAction) {
    this.xmo_1 = $removeAction;
  }
  protoOf(MessageTrait$MyHoverController$schedule$$inlined$toDisposable$1).vr = function () {
    return this.xmo_1();
  };
  function _get_edt__e67mgs($this) {
    return $this.nmo_1.elq();
  }
  function postpone($this, cell, prop, event) {
    checkNotApplyingPendingUpdates($this);
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.tmo_1;
    var value = this_0.y2(cell);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.message.MessageTrait.postpone.<anonymous>' call
      var answer = HashMap_init_$Create$();
      this_0.r2(cell, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var updates = tmp;
    if (updates.w2(prop)) {
      var changeEvent = ensureNotNull(updates.y2(prop));
      var oldValue = changeEvent.o2e_1;
      if (equals(oldValue, event.p2e_1)) {
        updates.s2(prop);
      } else {
        // Inline function 'kotlin.collections.set' call
        var value_0 = new PropertyChangeEvent(oldValue, event.p2e_1);
        updates.r2(prop, value_0);
      }
    } else {
      // Inline function 'kotlin.collections.set' call
      updates.r2(prop, event);
    }
  }
  function setPopup($this, cell, message) {
    var popup = new MessageCell(message);
    popup.bln(get_VISIBLE(), false);
    cell.bln(Companion_getInstance_294().smm_1, true);
    updatePopupValue($this, cell, popup);
  }
  function removePopup($this, cell, popup) {
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (popup == null) {
        // Inline function 'jetbrains.ocelot.projectional.cell.message.MessageTrait.removePopup.<anonymous>' call
        var message = 'Null popup value';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    hide($this, popup);
    if (cell.clo(Companion_getInstance_294().rmm_1) === popup) {
      updatePopupValue($this, cell, null);
    }
    cell.bln(Companion_getInstance_294().smm_1, false);
  }
  function updatePopupValue($this, cell, newPopup) {
    $this.umo_1 = true;
    try {
      cell.bln(Companion_getInstance_294().rmm_1, newPopup);
    }finally {
      $this.umo_1 = false;
    }
  }
  function onEditingKeyEvent($this) {
    $this.qmo_1 = _get_edt__e67mgs($this).t2m();
    if ($this.rmo_1)
      return Unit_instance;
    setForceHide($this, true);
    var tmp = $this;
    var tmp_0 = _get_edt__e67mgs($this);
    var tmp_1 = MessageTrait$onEditingKeyEvent$lambda($this);
    tmp.pmo_1 = tmp_0.w2m(300, new sam$jetbrains_ocelot_base_edt_EdtTask$0_14(tmp_1));
  }
  function applyPendingUpdates($this) {
    checkNotApplyingPendingUpdates($this);
    $this.smo_1 = true;
    try {
      setForceHide($this, false);
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = $this.tmo_1.w().k();
      while (_iterator__ex2g4s.l()) {
        var _destruct__k2r9zo = _iterator__ex2g4s.m();
        // Inline function 'kotlin.collections.component1' call
        var cell = _destruct__k2r9zo.x();
        // Inline function 'kotlin.collections.component2' call
        var value = _destruct__k2r9zo.y();
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_0 = value.w().k();
        while (_iterator__ex2g4s_0.l()) {
          var _destruct__k2r9zo_0 = _iterator__ex2g4s_0.m();
          // Inline function 'kotlin.collections.component1' call
          var key = _destruct__k2r9zo_0.x();
          // Inline function 'kotlin.collections.component2' call
          var value1 = _destruct__k2r9zo_0.y();
          apply($this, cell, key, value1);
        }
      }
    }finally {
      $this.smo_1 = false;
      $this.tmo_1.m2();
    }
  }
  function checkNotApplyingPendingUpdates($this) {
    // Inline function 'kotlin.check' call
    if (!!$this.smo_1) {
      // Inline function 'jetbrains.ocelot.projectional.cell.message.MessageTrait.checkNotApplyingPendingUpdates.<anonymous>' call
      var message = 'applying pending updates';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function setForceHide($this, forceHide) {
    if ($this.rmo_1 === forceHide)
      return Unit_instance;
    if (forceHide) {
      $this.wmo_1.ymo();
    }
    $this.rmo_1 = forceHide;
    if (!($this.vmo_1 == null)) {
      var _iterator__ex2g4s = ensureNotNull($this.vmo_1).v2().k();
      while (_iterator__ex2g4s.l()) {
        var support = _iterator__ex2g4s.m();
        if (!$this.wmo_1.lmo(support)) {
          support.umn($this.rmo_1);
        }
      }
    }
  }
  function getSupport($this, cell) {
    var popup = getMessagePopup($this, cell);
    var tmp;
    if (popup == null || $this.vmo_1 == null) {
      tmp = null;
    } else {
      tmp = ensureNotNull($this.vmo_1).y2(popup);
    }
    return tmp;
  }
  function shouldCloseMessage($this, cell, fromCell) {
    return cell == null || !(getMessagePopup($this, cell) == null) || !isDescendant(fromCell, cell);
  }
  function hidePopupOnMouseEvent($this, cell) {
    var support = getSupport($this, cell);
    if (!(support == null) && !$this.wmo_1.lmo(support)) {
      $this.wmo_1.zmo(support);
    } else {
      hidePopup($this, cell);
    }
  }
  function showPopupOnMouseEvent($this, cell) {
    var support = showPopup($this, cell, false);
    var shouldShow = !(support == null);
    if (shouldShow) {
      $this.wmo_1.amp(support);
    }
    return shouldShow;
  }
  function showPopupOnKeyEvent($this, cell) {
    return !(showPopup($this, cell, true) == null);
  }
  function showPopup($this, cell, forceShow) {
    var popup = getMessagePopup($this, cell);
    return popup == null ? null : show($this, popup, forceShow, cell.clo(Companion_getInstance_294().tmm_1));
  }
  function hidePopup($this, cell) {
    var popup = getMessagePopup($this, cell);
    return !(popup == null) && hide($this, popup);
  }
  function getMessagePopup($this, cell) {
    return Companion_getInstance_294().umm(cell) ? cell.clo(Companion_getInstance_294().rmm_1) : null;
  }
  function show($this, popup, forceShow, userHide) {
    if ($this.vmo_1 == null) {
      $this.vmo_1 = HashMap_init_$Create$();
    }
    var support = ensureNotNull($this.vmo_1).y2(popup);
    if (!(support == null)) {
      if (forceShow) {
        support.wmn();
      } else if (!$this.rmo_1 && shouldPostponeShow($this, support)) {
        support.umn(true);
      }
    } else {
      var forceHide = !forceShow || $this.rmo_1;
      support = new MessagePopupSupport(popup, forceHide, forceShow);
      if (userHide) {
        support.umn(true);
      }
      var tmp0 = ensureNotNull($this.vmo_1);
      // Inline function 'kotlin.collections.set' call
      var value = support;
      tmp0.r2(popup, value);
    }
    return support;
  }
  function shouldPostponeShow($this, support) {
    return !support.vmn() && !$this.wmo_1.lmo(support);
  }
  function hide($this, popup) {
    if ($this.vmo_1 == null)
      return false;
    var support = ensureNotNull($this.vmo_1).s2(popup);
    if (!(support == null)) {
      onHide($this, support);
      return true;
    }
    return false;
  }
  function hide_0($this, support) {
    if (!($this.vmo_1 == null)) {
      ensureNotNull($this.vmo_1).v2().k2(support);
    }
    onHide($this, support);
  }
  function onHide($this, support) {
    if (!($this.vmo_1 == null) && ensureNotNull($this.vmo_1).p()) {
      $this.vmo_1 = null;
    }
    $this.wmo_1.bmp(support);
    support.vr();
  }
  function apply($this, cell, prop, change) {
    $this.omo_1.emp(cell);
    updatePopup($this, cell, prop, change);
  }
  function updatePopup($this, cell, prop, change) {
    var currentPopup = cell.clo(Companion_getInstance_294().rmm_1);
    var messagePopupActive = Companion_getInstance_294().umm(cell);
    if (change.p2e_1 == null && messagePopupActive) {
      var next = getNextNonNull($this, cell, prop);
      if (next == null) {
        removePopup($this, cell, currentPopup);
      } else {
        updateMessage($this, cell, currentPopup instanceof MessageCell ? currentPopup : THROW_CCE(), ensureNotNull(cell.clo(next)));
      }
      return Unit_instance;
    }
    if (change.o2e_1 == null) {
      if (messagePopupActive) {
        var withHighestPriority = getFirstNonNull($this, cell);
        if (compare_0($this, prop, withHighestPriority)) {
          updateMessage($this, cell, currentPopup instanceof MessageCell ? currentPopup : THROW_CCE(), ensureNotNull(change.p2e_1));
        }
      } else if (currentPopup == null) {
        setPopup($this, cell, ensureNotNull(cell.clo(prop)));
      }
      return Unit_instance;
    }
    if (messagePopupActive) {
      var withHighestPriority_0 = getFirstNonNull($this, cell);
      if (prop === withHighestPriority_0) {
        updateMessage($this, cell, currentPopup instanceof MessageCell ? currentPopup : THROW_CCE(), ensureNotNull(change.p2e_1));
      }
    }
  }
  function updateMessage($this, cell, previousPopup, message) {
    cell.bln(Companion_getInstance_294().smm_1, true);
    if (previousPopup.yml_1.iml(message)) {
      return Unit_instance;
    }
    var newPopup = new MessageCell(message);
    newPopup.elp().t2c(previousPopup.elp().qr());
    updatePopupValue($this, cell, newPopup);
  }
  function compare_0($this, p1, p2) {
    return MessageController_getInstance().lmm_1.t(p1) <= indexOf_5(MessageController_getInstance().lmm_1, p2);
  }
  function getFirstNonNull($this, cell) {
    return getNextNonNull($this, cell, null);
  }
  function getNextNonNull($this, cell, prop) {
    var _iterator__ex2g4s = MessageController_getInstance().lmm_1.k();
    while (_iterator__ex2g4s.l()) {
      var p = _iterator__ex2g4s.m();
      if (!(cell.clo(p) == null) && !(p === prop))
        return p;
    }
    return null;
  }
  function HoverState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function MyHoverController($outer) {
    this.kmo_1 = $outer;
    this.gmo_1 = HoverState_NONE_getInstance();
    this.hmo_1 = null;
    this.imo_1 = Companion_getInstance_25().wr_1;
    this.jmo_1 = Companion_getInstance_25().wr_1;
  }
  protoOf(MyHoverController).lmo = function (support) {
    return this.hmo_1 === support;
  };
  protoOf(MyHoverController).zmo = function (support) {
    // Inline function 'kotlin.check' call
    if (!this.gmo_1.equals(HoverState_NONE_getInstance())) {
      // Inline function 'jetbrains.ocelot.projectional.cell.message.MyHoverController.scheduleHide.<anonymous>' call
      var message = 'hide watched support';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.hmo_1 = support;
    this.gmo_1 = HoverState_PENDING_HIDE_getInstance();
    var tmp = this;
    tmp.imo_1 = schedule(this, MessageTrait$MyHoverController$scheduleHide$lambda(this.kmo_1, support));
  };
  protoOf(MyHoverController).amp = function (support) {
    var wasPendingHide = cancelHide(this, support);
    if (!wasPendingHide && !this.lmo(support) && !ensureNotNull(support).vmn()) {
      this.imo_1.vr();
      this.hmo_1 = support;
      this.gmo_1 = HoverState_PENDING_SHOW_getInstance();
      var tmp = this;
      tmp.imo_1 = schedule(this, MessageTrait$MyHoverController$scheduleShow$lambda(this.kmo_1, support));
    }
  };
  protoOf(MyHoverController).ymo = function () {
    if (!(this.hmo_1 == null)) {
      this.imo_1.vr();
    }
  };
  protoOf(MyHoverController).bmp = function (support) {
    var wasPendingHide = cancelHide(this, support);
    if (!wasPendingHide && this.lmo(support)) {
      this.imo_1.vr();
    }
  };
  function Companion_294() {
    Companion_instance_294 = this;
    this.rmm_1 = get_TOP_POPUP();
    this.smm_1 = CellPropertySpec_init_$Create$('isMessagePopupActive', false);
    this.tmm_1 = CellPropertySpec_init_$Create$('hideMessage', false);
  }
  protoOf(Companion_294).umm = function (cell) {
    return cell.clo(this.smm_1);
  };
  var Companion_instance_294;
  function Companion_getInstance_294() {
    if (Companion_instance_294 == null)
      new Companion_294();
    return Companion_instance_294;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_14(function_0) {
    this.fmp_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_14).wy = function () {
    return this.fmp_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_14).b4 = function () {
    return this.fmp_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_14).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_14).hashCode = function () {
    return hashCode(this.b4());
  };
  function MessageTrait$onEditingKeyEvent$lambda(this$0) {
    return function () {
      var tmp;
      if (_get_edt__e67mgs(this$0).t2m().j3(this$0.qmo_1).d1(new Long(300, 0)) >= 0) {
        this$0.pmo_1.vr();
        this$0.pmo_1 = Companion_getInstance_25().wr_1;
        applyPendingUpdates(this$0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HoverState_NONE_getInstance() {
    HoverState_initEntries();
    return HoverState_NONE_instance;
  }
  function HoverState_PENDING_HIDE_getInstance() {
    HoverState_initEntries();
    return HoverState_PENDING_HIDE_instance;
  }
  function HoverState_PENDING_SHOW_getInstance() {
    HoverState_initEntries();
    return HoverState_PENDING_SHOW_instance;
  }
  function MessageTrait(container, styler) {
    Companion_getInstance_294();
    CellTrait.call(this);
    this.nmo_1 = container;
    this.omo_1 = styler;
    this.pmo_1 = Companion_getInstance_25().wr_1;
    this.qmo_1 = new Long(0, 0);
    this.rmo_1 = false;
    this.smo_1 = false;
    this.tmo_1 = HashMap_init_$Create$();
    this.umo_1 = false;
    this.vmo_1 = null;
    this.wmo_1 = new MyHoverController(this);
  }
  protoOf(MessageTrait).glo = function (cell) {
    var _iterator__ex2g4s = MessageController_getInstance().lmm_1.k();
    while (_iterator__ex2g4s.l()) {
      var prop = _iterator__ex2g4s.m();
      var value = cell.clo(prop);
      if (!(value == null)) {
        this.qlm(cell, prop, new PropertyChangeEvent(null, value));
      }
    }
  };
  protoOf(MessageTrait).qlm = function (cell, prop, event) {
    if (contains_5(MessageController_getInstance().lmm_1, prop)) {
      var cellPropertySpec = prop instanceof CellPropertySpec ? prop : THROW_CCE();
      var propertyChangeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      if (this.rmo_1) {
        postpone(this, cell, cellPropertySpec, propertyChangeEvent);
      } else {
        apply(this, cell, cellPropertySpec, propertyChangeEvent);
      }
    } else if (isPopupProp(prop) && !this.umo_1) {
      var change = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      var popup = change.p2e_1;
      if (popup == null) {
        var message = getFirstNonNull(this, cell);
        if (!(message == null)) {
          setPopup(this, cell, ensureNotNull(cell.clo(message)));
        }
      } else if (Companion_getInstance_294().umm(cell)) {
        if (prop === Companion_getInstance_294().rmm_1) {
          removePopup(this, cell, change.o2e_1);
        } else if (!Companion_instance_292.omn(popup)) {
          hidePopup(this, cell);
        }
      }
    }
    protoOf(CellTrait).qlm.call(this, cell, prop, event);
  };
  protoOf(MessageTrait).jll = function (cell, event) {
    return onEditingKeyEvent(this);
  };
  protoOf(MessageTrait).llm = function (cell, event) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = event.ml1(Key_BACKSPACE_getInstance(), []) || event.ml1(Key_DELETE_getInstance(), []) || event.ol1([KeyStrokeSpecs_getInstance().hl3_1]);
    } else {
      tmp = false;
    }
    if (tmp) {
      onEditingKeyEvent(this);
      return Unit_instance;
    }
    if (event.ol1([KeyStrokeSpecs_getInstance().kl2_1])) {
      if (showPopupOnKeyEvent(this, cell)) {
        event.ol0();
      }
      return Unit_instance;
    } else if (event.ml1(Key_ESCAPE_getInstance(), [])) {
      if (hidePopup(this, cell)) {
        event.ol0();
      }
      return Unit_instance;
    }
    protoOf(CellTrait).llm.call(this, cell, event);
  };
  protoOf(MessageTrait).ilo = function (cell, event) {
    if (shouldCloseMessage(this, event.cmh_1, cell)) {
      hidePopup(this, cell);
    }
  };
  protoOf(MessageTrait).plo = function (cell, event) {
    if (showPopupOnMouseEvent(this, cell)) {
      event.ol0();
    }
  };
  protoOf(MessageTrait).qlo = function (cell, event) {
    if (shouldCloseMessage(this, ensureNotNull(cell.llk()).bmi(event.zl3()), cell)) {
      hidePopupOnMouseEvent(this, cell);
    }
  };
  protoOf(MessageTrait).nlo = function (cell, event) {
    if (showPopupOnMouseEvent(this, cell)) {
      event.ol0();
    }
  };
  protoOf(MessageTrait).uln = function (cell) {
    this.omo_1.gmp(cell);
    if (!this.smo_1) {
      this.tmo_1.s2(cell);
    }
    var _iterator__ex2g4s = get_POPUP_SPECS().k();
    while (_iterator__ex2g4s.l()) {
      var prop = _iterator__ex2g4s.m();
      var popup = cell.clo(prop);
      if (!(popup == null)) {
        hide(this, popup);
      }
    }
  };
  function MessageView() {
  }
  function applyStyle($this, cell) {
    if (cell instanceof TextCell) {
      $this.hmp(cell);
    } else {
      var _iterator__ex2g4s = cell.g2r().k();
      while (_iterator__ex2g4s.l()) {
        var child = _iterator__ex2g4s.m();
        applyStyle($this, child);
      }
    }
  }
  function MessageViewWithLink(text, link) {
    this.imp_1 = null;
    this.jmp_1 = null;
    applyStyle(this, link);
    if (text == null) {
      this.jmp_1 = Companion_getInstance_290().fml_1;
      this.imp_1 = link;
    } else {
      this.jmp_1 = new SimpleMessageView(text);
      this.imp_1 = new VerticalCell();
      CellFactory_instance.ym3(ensureNotNull(this.imp_1), [ensureNotNull(ensureNotNull(this.jmp_1).i2j()), link]);
    }
  }
  protoOf(MessageViewWithLink).i2j = function () {
    return this.imp_1;
  };
  protoOf(MessageViewWithLink).gml = function () {
    var maxLineDimension = ensureNotNull(this.jmp_1).gml();
    var linkDim = get_dimension(ensureNotNull(this.pbh()));
    var tmp0 = maxLineDimension.eku_1;
    // Inline function 'kotlin.math.max' call
    var b = linkDim.eku_1;
    var tmp = Math.max(tmp0, b);
    var tmp2 = maxLineDimension.fku_1;
    // Inline function 'kotlin.math.max' call
    var b_0 = linkDim.fku_1;
    var tmp$ret$1 = Math.max(tmp2, b_0);
    return new Vector(tmp, tmp$ret$1);
  };
  protoOf(MessageViewWithLink).hml = function () {
    return ensureNotNull(this.jmp_1).hml() + 1 | 0;
  };
  protoOf(MessageViewWithLink).pbh = function () {
    return ensureNotNull(this.imp_1).r2r();
  };
  protoOf(MessageViewWithLink).jml = function (maxWidth) {
    return ensureNotNull(this.jmp_1).jml(maxWidth);
  };
  protoOf(MessageViewWithLink).iml = function (message) {
    return message.lml_1 === this.pbh();
  };
  function refresh($this) {
    var lineCells = $this.kmp_1.ilp();
    var i = 0;
    var _iterator__ex2g4s = $this.lmp_1.k();
    while (_iterator__ex2g4s.l()) {
      var text = _iterator__ex2g4s.m();
      if (lineCells.n() > i) {
        lineCells.q(i).bln(Companion_getInstance_271().als_1, text);
      } else {
        lineCells.e(createLine($this, text));
      }
      i = i + 1 | 0;
    }
    var inductionVariable = lineCells.n() - 1 | 0;
    var last = i;
    if (last <= inductionVariable)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        lineCells.q2(j);
      }
       while (!(j === last));
  }
  function createLine($this, text) {
    var line = TextCell_init_$Create$_0(text);
    $this.hmp(line);
    return line;
  }
  function SimpleMessageView$lambda($lines) {
    return function (index) {
      return get_dimension($lines.q(index));
    };
  }
  function SimpleMessageView(message) {
    this.kmp_1 = new VerticalCell();
    var lines = this.kmp_1.g2r();
    var tmp = this;
    tmp.lmp_1 = new WordWrapper(message, SimpleMessageView$lambda(lines));
    refresh(this);
  }
  protoOf(SimpleMessageView).i2j = function () {
    return this.kmp_1;
  };
  protoOf(SimpleMessageView).gml = function () {
    return this.lmp_1.gml();
  };
  protoOf(SimpleMessageView).hml = function () {
    return this.lmp_1.hml();
  };
  protoOf(SimpleMessageView).jml = function (maxWidth) {
    var updated = this.lmp_1.smp(maxWidth);
    if (updated) {
      refresh(this);
    }
    return updated;
  };
  protoOf(SimpleMessageView).iml = function (message) {
    if (message.lml_1 == null) {
      if (this.lmp_1.tmp(ensureNotNull(message.kml_1))) {
        refresh(this);
      }
      return true;
    }
    return false;
  };
  function doApply($this, cell, message, prop) {
    var styler = message.mml_1;
    if (!(styler == null)) {
      return styler(cell);
    }
    var decorator = $this.cmp_1.y2(prop);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (decorator == null) {
        // Inline function 'jetbrains.ocelot.projectional.cell.message.StyleApplicator.doApply.<anonymous>' call
        var message_0 = 'No decorator for property: ' + prop.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        break $l$block;
      }
    }
    return decorator(cell);
  }
  function Companion_295() {
    Companion_instance_295 = this;
    var list = ArrayList_init_$Create$_1(MessageController_getInstance().lmm_1);
    reverse(list);
    this.ump_1 = list;
  }
  var Companion_instance_295;
  function Companion_getInstance_295() {
    if (Companion_instance_295 == null)
      new Companion_295();
    return Companion_instance_295;
  }
  function StyleApplicator$lambda($styler) {
    return function (cell) {
      return $styler.cmo(cell);
    };
  }
  function StyleApplicator$lambda_0($styler) {
    return function (cell) {
      return $styler.fmo(cell);
    };
  }
  function StyleApplicator$lambda_1($styler) {
    return function (cell) {
      return $styler.emo(cell);
    };
  }
  function StyleApplicator$lambda_2($styler) {
    return function (cell) {
      return $styler.dmo(cell);
    };
  }
  function StyleApplicator(messageStyler) {
    Companion_getInstance_295();
    this.dmp_1 = new DisposableMap();
    var styler = messageStyler == null ? new MessageStyler() : messageStyler;
    var tmp = this;
    var tmp_0 = MessageController_getInstance().kmm_1;
    var tmp_1 = to(tmp_0, StyleApplicator$lambda(styler));
    var tmp_2 = MessageController_getInstance().imm_1;
    var tmp_3 = to(tmp_2, StyleApplicator$lambda_0(styler));
    var tmp_4 = MessageController_getInstance().hmm_1;
    var tmp_5 = to(tmp_4, StyleApplicator$lambda_1(styler));
    var tmp_6 = MessageController_getInstance().jmm_1;
    tmp.cmp_1 = mapOf_0([tmp_1, tmp_3, tmp_5, to(tmp_6, StyleApplicator$lambda_2(styler))]);
  }
  protoOf(StyleApplicator).emp = function (cell) {
    this.dmp_1.as(cell);
    var disposable = Companion_getInstance_25().wr_1;
    var _iterator__ex2g4s = Companion_getInstance_295().ump_1.k();
    while (_iterator__ex2g4s.l()) {
      var prop = _iterator__ex2g4s.m();
      var message = cell.clo(prop);
      if (!(message == null)) {
        disposable = disposable.sr(doApply(this, cell, message, prop));
      }
    }
    this.dmp_1.zr(cell, disposable);
  };
  protoOf(StyleApplicator).gmp = function (cell) {
    this.dmp_1.as(cell);
  };
  function areLineMetricsDefined($this) {
    return !($this.pmp_1 === 0) && !($this.qmp_1 === 0);
  }
  function resetMetrics($this) {
    $this.qmp_1 = 0;
    $this.pmp_1 = 0;
  }
  function arrange($this, line, index) {
    if (line.xmp()) {
      return false;
    }
    var partsNum = line.ymp();
    var metrics = new Metrics();
    var shouldSplit = false;
    var inductionVariable = 0;
    if (inductionVariable < partsNum)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dim = $this.mmp_1(index + i | 0);
        updateMaxLineHeight($this, dim.fku_1);
        if (!(dim.eku_1 === 0)) {
          var symbolApproxWidth = 1 + (dim.eku_1 / line.zmp(i) | 0) | 0;
          metrics.cmq(symbolApproxWidth, dim.eku_1);
          if (dim.eku_1 > $this.rmp_1) {
            shouldSplit = true;
          }
        }
      }
       while (inductionVariable < partsNum);
    if (metrics.amq_1 < 2) {
      return false;
    }
    var changed = false;
    if (shouldSplit || partsNum > 1) {
      var maxLineLength = $this.rmp_1 / metrics.amq_1 | 0;
      var breaks = arrange_0($this, line.vmp_1, maxLineLength);
      changed = line.dmq(breaks);
    }
    if (changed) {
      updateMaxLineWidth($this, imul(line.emq(), metrics.amq_1));
    } else {
      updateMaxLineWidth($this, metrics.bmq_1);
    }
    return changed;
  }
  function arrange_0($this, text, maxLineLength) {
    var linesNum = (text.length / maxLineLength | 0) + 1 | 0;
    // Inline function 'kotlin.math.min' call
    var a = linesNum + (text.length / linesNum | 0) | 0;
    var preferredLineLength = Math.min(a, maxLineLength);
    var lineBreaks = ArrayList_init_$Create$();
    var lineStart = 0;
    lineBreaks.e(lineStart);
    while (lineStart < text.length) {
      var maxIndex = lineStart + maxLineLength | 0;
      var lineEnd;
      if (maxIndex < text.length) {
        var preferredLineEnd = (lineStart + preferredLineLength | 0) - 1 | 0;
        lineEnd = getNextSpaceIndex($this, text, preferredLineEnd, maxIndex);
        if (lineEnd === -1) {
          lineEnd = getPrevSpaceIndex($this, text, maxIndex, lineStart);
          if (lineEnd === -1) {
            lineEnd = preferredLineEnd;
          }
        }
      } else {
        lineEnd = text.length - 1 | 0;
      }
      lineEnd = lineEnd + 1 | 0;
      lineBreaks.e(lineEnd);
      lineStart = lineEnd;
    }
    return lineBreaks;
  }
  function getNextSpaceIndex($this, text, beginIndex, endIndex) {
    var inductionVariable = beginIndex;
    if (inductionVariable < endIndex)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charSequenceGet(text, i) === _Char___init__impl__6a9atx(32))
          return i;
      }
       while (inductionVariable < endIndex);
    return -1;
  }
  function getPrevSpaceIndex($this, text, beginIndex, endIndex) {
    var inductionVariable = beginIndex - 1 | 0;
    var last = (endIndex - 1 | 0) + 1 | 0;
    if (last <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        if (charSequenceGet(text, i) === _Char___init__impl__6a9atx(32))
          return i;
      }
       while (!(i === last));
    return -1;
  }
  function updateMaxLineHeight($this, h) {
    if (h > $this.qmp_1) {
      $this.qmp_1 = h;
    }
  }
  function updateMaxLineWidth($this, w) {
    if (w > $this.pmp_1) {
      $this.pmp_1 = w;
    }
  }
  function Metrics() {
    this.amq_1 = 0;
    this.bmq_1 = 0;
  }
  protoOf(Metrics).cmq = function (symbolWidth, width) {
    if (symbolWidth > this.amq_1) {
      this.amq_1 = symbolWidth;
    }
    if (width > this.bmq_1) {
      this.bmq_1 = width;
    }
  };
  function Line(text) {
    this.vmp_1 = text;
    this.wmp_1 = mutableListOf([0, this.vmp_1.length]);
  }
  protoOf(Line).xmp = function () {
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = this.vmp_1;
    return charSequenceLength(this_0) === 0;
  };
  protoOf(Line).ymp = function () {
    return this.wmp_1.n() - 1 | 0;
  };
  protoOf(Line).emq = function () {
    var max = 0;
    var inductionVariable = 0;
    var last = this.wmp_1.n() - 1 | 0;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var length = this.wmp_1.q(i + 1 | 0) - this.wmp_1.q(i) | 0;
        if (length > max) {
          max = length;
        }
      }
       while (inductionVariable < last);
    return max;
  };
  protoOf(Line).fmq = function (index) {
    var tmp0 = this.vmp_1;
    var tmp1 = this.wmp_1.q(index);
    // Inline function 'kotlin.text.substring' call
    var endIndex = this.wmp_1.q(index + 1 | 0);
    // Inline function 'kotlin.js.asDynamic' call
    return tmp0.substring(tmp1, endIndex);
  };
  protoOf(Line).zmp = function (partIndex) {
    return this.wmp_1.q(partIndex + 1 | 0) - this.wmp_1.q(partIndex) | 0;
  };
  protoOf(Line).dmq = function (breaks) {
    if (equals(this.wmp_1, breaks)) {
      return false;
    }
    this.wmp_1.m2();
    this.wmp_1.o(breaks);
    return true;
  };
  protoOf(Line).toString = function () {
    return this.vmp_1 + ', breaks=' + toString_1(this.wmp_1);
  };
  function WordWrapper$iterator$1(this$0) {
    this.imq_1 = this$0;
    this.gmq_1 = 0;
    this.hmq_1 = 0;
  }
  protoOf(WordWrapper$iterator$1).l = function () {
    return this.gmq_1 < this.imq_1.omp_1.n();
  };
  protoOf(WordWrapper$iterator$1).m = function () {
    var line = this.imq_1.omp_1.q(this.gmq_1);
    var _unary__edvuaz = this.hmq_1;
    this.hmq_1 = _unary__edvuaz + 1 | 0;
    var next = line.fmq(_unary__edvuaz);
    if (this.hmq_1 === line.ymp()) {
      this.gmq_1 = this.gmq_1 + 1 | 0;
      this.hmq_1 = 0;
    }
    return next;
  };
  function WordWrapper(text, dimensionSupplier) {
    this.mmp_1 = dimensionSupplier;
    this.nmp_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.omp_1 = ArrayList_init_$Create$();
    this.pmp_1 = 0;
    this.qmp_1 = 0;
    this.rmp_1 = 0;
    this.tmp(text);
  }
  protoOf(WordWrapper).gml = function () {
    return new Vector(this.pmp_1, this.qmp_1);
  };
  protoOf(WordWrapper).hml = function () {
    var size = 0;
    var _iterator__ex2g4s = this.omp_1.k();
    while (_iterator__ex2g4s.l()) {
      var line = _iterator__ex2g4s.m();
      size = size + line.ymp() | 0;
    }
    return size;
  };
  protoOf(WordWrapper).tmp = function (text) {
    if (text === this.nmp_1) {
      return false;
    }
    this.nmp_1 = text;
    this.omp_1.m2();
    resetMetrics(this);
    // Inline function 'kotlin.text.toRegex' call
    // Inline function 'kotlin.text.split' call
    var splitLines = Regex_init_$Create$('\\n').ce(text, 0);
    var _iterator__ex2g4s = splitLines.k();
    while (_iterator__ex2g4s.l()) {
      var line = _iterator__ex2g4s.m();
      this.omp_1.e(new Line(line));
    }
    return true;
  };
  protoOf(WordWrapper).smp = function (viewportWidth) {
    if (this.rmp_1 === viewportWidth && areLineMetricsDefined(this)) {
      return false;
    }
    this.rmp_1 = viewportWidth;
    resetMetrics(this);
    var changed = false;
    var resultLineIndex = 0;
    var _iterator__ex2g4s = this.omp_1.k();
    while (_iterator__ex2g4s.l()) {
      var line = _iterator__ex2g4s.m();
      var oldPartsNumber = line.ymp();
      if (arrange(this, line, resultLineIndex)) {
        changed = true;
      }
      resultLineIndex = resultLineIndex + oldPartsNumber | 0;
    }
    return changed;
  };
  protoOf(WordWrapper).k = function () {
    return new WordWrapper$iterator$1(this);
  };
  function get_TOP_POPUP() {
    _init_properties_Popup_kt__lluomy();
    return TOP_POPUP;
  }
  var TOP_POPUP;
  function get_BOTTOM_POPUP() {
    _init_properties_Popup_kt__lluomy();
    return BOTTOM_POPUP;
  }
  var BOTTOM_POPUP;
  function get_FRONT_POPUP() {
    _init_properties_Popup_kt__lluomy();
    return FRONT_POPUP;
  }
  var FRONT_POPUP;
  function get_LEFT_POPUP() {
    _init_properties_Popup_kt__lluomy();
    return LEFT_POPUP;
  }
  var LEFT_POPUP;
  function get_RIGHT_POPUP() {
    _init_properties_Popup_kt__lluomy();
    return RIGHT_POPUP;
  }
  var RIGHT_POPUP;
  function get_POPUP_SPECS() {
    _init_properties_Popup_kt__lluomy();
    return POPUP_SPECS;
  }
  var POPUP_SPECS;
  function get_POPUP() {
    _init_properties_Popup_kt__lluomy();
    return POPUP;
  }
  var POPUP;
  function inPopup(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return !(getContainingPopup(_this__u8e3s4) == null);
  }
  function isPopupProp(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return contains_5(get_POPUP_SPECS(), _this__u8e3s4);
  }
  function getContainingPopup(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestorsFrom(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.cell.popup.getContainingPopup.<anonymous>' call
        if (get_isPopup(element)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function get_isPopup(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return _this__u8e3s4.clo(get_POPUP());
  }
  function get_bottomPopupProp(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return _this__u8e3s4.flp(get_BOTTOM_POPUP());
  }
  function get_rightPopup(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return _this__u8e3s4.clo(get_RIGHT_POPUP());
  }
  function get_leftPopup(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return _this__u8e3s4.clo(get_LEFT_POPUP());
  }
  function get_frontPopup(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return _this__u8e3s4.clo(get_FRONT_POPUP());
  }
  function get_frontPopupProp(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    return _this__u8e3s4.flp(get_FRONT_POPUP());
  }
  function getNonPopupAncestor(_this__u8e3s4) {
    _init_properties_Popup_kt__lluomy();
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestorsFrom(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.cell.popup.getNonPopupAncestor.<anonymous>' call
        if (getContainingPopup(element) == null) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  var properties_initialized_Popup_kt_wwy6qs;
  function _init_properties_Popup_kt__lluomy() {
    if (!properties_initialized_Popup_kt_wwy6qs) {
      properties_initialized_Popup_kt_wwy6qs = true;
      TOP_POPUP = CellPropertySpec_init_$Create$('topPopup', null);
      BOTTOM_POPUP = CellPropertySpec_init_$Create$('bottomPopup', null);
      FRONT_POPUP = CellPropertySpec_init_$Create$('frontPopup', null);
      LEFT_POPUP = CellPropertySpec_init_$Create$('leftPopup', null);
      RIGHT_POPUP = CellPropertySpec_init_$Create$('rightPopup', null);
      POPUP_SPECS = listOf_0([get_LEFT_POPUP(), get_RIGHT_POPUP(), get_TOP_POPUP(), get_BOTTOM_POPUP(), get_FRONT_POPUP()]);
      POPUP = CellPropertySpec_init_$Create$('popup', false);
    }
  }
  function shouldScrollTo($this, popup) {
    var spec = popup.ulp(Companion_getInstance_268().elr_1);
    return !(spec == null) && spec.ilr(popup);
  }
  function updateScroll($this, mapper) {
    var source = mapper.pl9_1;
    if (!shouldScrollTo($this, source)) {
      return Unit_instance;
    }
    if (source.clo(get_VISIBLE())) {
      $this.lmq(source);
    } else {
      var disposable = {_v: null};
      var tmp = source.elp();
      var value = tmp.p27(BasePopupManager$updateScroll$lambda(disposable, $this, source));
      disposable._v = value;
    }
  }
  function findMapper($this, popup) {
    var _iterator__ex2g4s = ensureNotNull($this.kmq_1).k();
    while (_iterator__ex2g4s.l()) {
      var mapper = _iterator__ex2g4s.m();
      if (mapper.pl9_1 === popup) {
        return mapper;
      }
    }
    throw IllegalStateException_init_$Create$_0('No registered mapper for popup ' + toString_1(popup));
  }
  function BasePopupManager$updateScroll$lambda($disposable, this$0, $source) {
    return function (event) {
      var tmp;
      if (event.p2e_1) {
        ensureNotNull($disposable._v).vr();
        this$0.lmq($source);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BasePopupManager$getUpdatePositionTask$lambda(this$0, $mapper) {
    return function () {
      this$0.mmq($mapper).omq($mapper.pl9_1, $mapper.ql9_1);
      return Unit_instance;
    };
  }
  function BasePopupManager() {
    this.jmq_1 = null;
    this.kmq_1 = null;
  }
  protoOf(BasePopupManager).vr = function () {
    var disposable = this.jmq_1;
    if (!(disposable == null)) {
      disposable.vr();
      this.jmq_1 = null;
    }
    var popups = this.kmq_1;
    if (!(popups == null)) {
      var _iterator__ex2g4s = popups.k();
      while (_iterator__ex2g4s.l()) {
        var popup = _iterator__ex2g4s.m();
        this.rmq(popup);
      }
      this.kmq_1 = null;
    }
  };
  protoOf(BasePopupManager).tmq = function (cell) {
    var _iterator__ex2g4s = get_POPUP_SPECS().k();
    while (_iterator__ex2g4s.l()) {
      var ps = _iterator__ex2g4s.m();
      var popup = cell.clo(ps);
      if (!(popup == null)) {
        this.umq(new PropertyChangeEvent(null, popup));
      }
    }
  };
  protoOf(BasePopupManager).vmq = function (popup, prop, change) {
    var tmp;
    var tmp_0;
    if (prop === get_VISIBLE()) {
      var tmp_1 = change.p2e_1;
      tmp_0 = (!(tmp_1 == null) ? typeof tmp_1 === 'boolean' : false) ? tmp_1 : THROW_CCE();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = prop === get_POPUP_X_POSITION();
    }
    if (tmp) {
      var mapper = findMapper(this, popup);
      this.wmq(mapper);
    }
  };
  protoOf(BasePopupManager).umq = function (event) {
    var oldValue = event.o2e_1;
    if (!(oldValue == null)) {
      var popup = findMapper(this, oldValue);
      ensureNotNull(this.kmq_1).k2(popup);
      this.rmq(popup);
      if (ensureNotNull(this.kmq_1).p()) {
        this.kmq_1 = null;
        ensureNotNull(this.jmq_1).vr();
        this.jmq_1 = null;
      }
    }
    var newValue = event.p2e_1;
    if (!(newValue == null)) {
      if (this.kmq_1 == null) {
        this.kmq_1 = this.pmq();
        this.jmq_1 = this.smq();
      }
      this.xmq();
      newValue.olp(Companion_getInstance_296().ymq_1);
      var popup_0 = this.qmq(newValue);
      ensureNotNull(this.kmq_1).e(popup_0);
      this.wmq(popup_0);
      updateScroll(this, popup_0);
    }
  };
  protoOf(BasePopupManager).d28 = function (event) {
    return this.umq(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  protoOf(BasePopupManager).lmq = function (popup) {
    if (popup.qlc()) {
      scrollTo_0(popup);
    }
  };
  protoOf(BasePopupManager).xmq = function () {
    if (this.kmq_1 == null) {
      return Unit_instance;
    }
    var _iterator__ex2g4s = ensureNotNull(this.kmq_1).k();
    while (_iterator__ex2g4s.l()) {
      var popup = _iterator__ex2g4s.m();
      this.wmq(popup);
    }
  };
  protoOf(BasePopupManager).wmq = function (popupMapper) {
    if (popupMapper.pl9_1.qlc() && popupMapper.pl9_1.clo(get_VISIBLE())) {
      this.zmq(popupMapper)();
    }
  };
  protoOf(BasePopupManager).zmq = function (mapper) {
    return BasePopupManager$getUpdatePositionTask$lambda(this, mapper);
  };
  function Companion_296() {
    Companion_instance_296 = this;
    this.ymq_1 = new ConsumeMouseButtonTrait();
  }
  var Companion_instance_296;
  function Companion_getInstance_296() {
    if (Companion_instance_296 == null)
      new Companion_296();
    return Companion_instance_296;
  }
  function ConsumeMouseButtonTrait() {
    Companion_getInstance_296();
    CellTrait.call(this);
  }
  protoOf(ConsumeMouseButtonTrait).jlo = function (cell, event) {
    event.ol0();
  };
  protoOf(ConsumeMouseButtonTrait).klo = function (cell, event) {
    event.ol0();
  };
  protoOf(ConsumeMouseButtonTrait).llo = function (cell, event) {
    event.ol0();
  };
  protoOf(ConsumeMouseButtonTrait).mlo = function (cell, event) {
    event.ol0();
  };
  protoOf(ConsumeMouseButtonTrait).olo = function (cell, event) {
    event.ol0();
  };
  protoOf(ConsumeMouseButtonTrait).rlo = function (cell, event) {
    event.ol0();
  };
  protoOf(ConsumeMouseButtonTrait).vlo = function (cell, event) {
    event.ol0();
  };
  protoOf(ConsumeMouseButtonTrait).wlo = function (cell, event) {
    event.ol0();
  };
  function PopupPositionUpdater_init_$Init$(rightBottomMargin, $this) {
    PopupPositionUpdater.call($this);
    $this.nmq_1 = rightBottomMargin;
    return $this;
  }
  function getRole($this, parent, popup) {
    var _iterator__ex2g4s = get_POPUP_SPECS().k();
    while (_iterator__ex2g4s.l()) {
      var spec = _iterator__ex2g4s.m();
      if (parent.clo(spec) === popup)
        return spec;
    }
    throw IllegalStateException_init_$Create$_0(toString_1(parent) + ' has no popup same to ' + toString_1(popup));
  }
  function hasVisiblePopup($this, opposite, parent) {
    var oppositePopup = parent.clo(opposite);
    return !(oppositePopup == null) && oppositePopup.clo(get_VISIBLE());
  }
  function updateTop($this, hasBottom, ctx) {
    var viewport = $this.amr();
    if (hasBottom) {
      return showTop($this, viewport, ctx);
    }
    var topSpace = ctx.fmr_1.cku_1.fku_1 - viewport.cku_1.fku_1 | 0;
    var bottomSpace = (viewport.dku_1.fku_1 - topSpace | 0) - ctx.fmr_1.dku_1.fku_1 | 0;
    var top = topSpace >= $this.gmr(ctx.dmr_1, ctx.emr_1.fku_1);
    var tmp;
    if (top || topSpace > bottomSpace) {
      tmp = showTop($this, viewport, ctx);
    } else {
      tmp = showBottom($this, viewport, ctx);
    }
    return tmp;
  }
  function updateBottom($this, hasTop, ctx) {
    var viewport = $this.amr();
    if (hasTop) {
      return showBottom($this, viewport, ctx);
    }
    var topSpace = ctx.fmr_1.cku_1.fku_1 - viewport.cku_1.fku_1 | 0;
    var bottomSpace = (viewport.dku_1.fku_1 - topSpace | 0) - ctx.fmr_1.dku_1.fku_1 | 0;
    var bottom = bottomSpace >= $this.gmr(ctx.dmr_1, ctx.emr_1.fku_1);
    var tmp;
    if (bottom || bottomSpace > topSpace) {
      tmp = showBottom($this, viewport, ctx);
    } else {
      tmp = showTop($this, viewport, ctx);
    }
    return tmp;
  }
  function showBottom($this, viewport, ctx) {
    firePosition($this, ctx.cmr_1, get_BOTTOM_POPUP());
    $this.hmr(ctx.dmr_1);
    return showVertical($this, viewport, false, ctx);
  }
  function showTop($this, viewport, ctx) {
    firePosition($this, ctx.cmr_1, get_TOP_POPUP());
    $this.imr(ctx.dmr_1);
    return showVertical($this, viewport, true, ctx);
  }
  function firePosition($this, popupCell, position) {
    var spec = popupCell.ulp(Companion_getInstance_268().elr_1);
    if (spec == null)
      null;
    else {
      spec.hlr(popupCell, position);
    }
  }
  function showVertical($this, viewport, showTop, ctx) {
    var width = ctx.emr_1.eku_1;
    var height = $this.gmr(ctx.dmr_1, ctx.emr_1.fku_1);
    var tmp0 = ctx.jmr() + ctx.fmr_1.cku_1.eku_1 | 0;
    // Inline function 'kotlin.math.max' call
    var b = viewport.cku_1.eku_1;
    var left = Math.max(tmp0, b);
    var top = showTop ? ctx.fmr_1.cku_1.fku_1 - height | 0 : ctx.fmr_1.cku_1.fku_1 + ctx.fmr_1.dku_1.fku_1 | 0;
    var maxX = viewport.cku_1.eku_1 + viewport.dku_1.eku_1 | 0;
    var setMarginY = !ctx.cmr_1.clo(get_HAS_POPUP_DECORATION());
    var spec = ctx.cmr_1.ulp(Companion_getInstance_268().elr_1);
    if (!(spec == null)) {
      // Inline function 'kotlin.math.max' call
      var a = viewport.dku_1.eku_1 - $this.nmq_1 | 0;
      var maxWidth = Math.max(a, 150);
      var maxAlignedWidth = (maxX - left | 0) - $this.nmq_1 | 0;
      if (maxAlignedWidth < 150) {
        maxAlignedWidth = maxWidth;
      }
      var parentVisibleOffsetTop = ctx.fmr_1.cku_1.fku_1 - viewport.cku_1.fku_1 | 0;
      var maxVisibleSpace = showTop ? parentVisibleOffsetTop : (viewport.dku_1.fku_1 - ctx.fmr_1.dku_1.fku_1 | 0) - parentVisibleOffsetTop | 0;
      // Inline function 'kotlin.math.min' call
      var b_0 = viewport.dku_1.fku_1 - ctx.fmr_1.dku_1.fku_1 | 0;
      var maxVisibleHeight = Math.min(maxVisibleSpace, b_0);
      if (setMarginY) {
        maxVisibleHeight = maxVisibleHeight - $this.nmq_1 | 0;
      }
      // Inline function 'kotlin.math.max' call
      var a_0 = $this.kmr(ctx.dmr_1, maxVisibleHeight);
      var maxHeight = Math.max(a_0, 25);
      var adjustedDim = spec.glr(ctx.cmr_1, ctx.emr_1, new Vector(maxWidth, maxHeight), maxAlignedWidth);
      width = adjustedDim.eku_1;
      height = $this.gmr(ctx.dmr_1, adjustedDim.fku_1);
      if (showTop) {
        top = ctx.fmr_1.cku_1.fku_1 - height | 0;
      }
    }
    if (showTop && setMarginY) {
      top = top - $this.nmq_1 | 0;
    }
    if ((left + width | 0) > maxX) {
      var tmp8 = viewport.cku_1.eku_1;
      // Inline function 'kotlin.math.max' call
      var b_1 = (maxX - width | 0) - $this.nmq_1 | 0;
      left = Math.max(tmp8, b_1);
    }
    var maxY = viewport.cku_1.fku_1 + viewport.dku_1.fku_1 | 0;
    if ((top + height | 0) > maxY) {
      var tmp10 = viewport.cku_1.fku_1;
      // Inline function 'kotlin.math.max' call
      var b_2 = maxY - height | 0;
      top = Math.max(tmp10, b_2);
    } else if (top < viewport.cku_1.fku_1) {
      top = viewport.cku_1.fku_1;
    }
    return $this.lmr(ctx.dmr_1, left, top);
  }
  function updateFront($this, ctx) {
    return $this.lmr(ctx.dmr_1, ctx.jmr() + ctx.fmr_1.cku_1.eku_1 | 0, ctx.fmr_1.cku_1.fku_1);
  }
  function updateLeft($this, ctx) {
    return $this.lmr(ctx.dmr_1, (ctx.jmr() + ctx.fmr_1.cku_1.eku_1 | 0) - ctx.emr_1.eku_1 | 0, ctx.fmr_1.cku_1.fku_1);
  }
  function updateRight($this, ctx) {
    return showRight($this, $this.amr(), ctx);
  }
  function showRight($this, viewport, ctx) {
    var left = (ctx.jmr() + ctx.fmr_1.cku_1.eku_1 | 0) + ctx.fmr_1.dku_1.eku_1 | 0;
    var top = ctx.fmr_1.cku_1.fku_1;
    var height = $this.gmr(ctx.dmr_1, ctx.emr_1.fku_1);
    var maxY = viewport.cku_1.fku_1 + viewport.dku_1.fku_1 | 0;
    var setMarginY = !ctx.cmr_1.clo(get_HAS_POPUP_DECORATION());
    if (setMarginY) {
      maxY = maxY - $this.nmq_1 | 0;
    }
    if ((top + height | 0) > maxY) {
      top = (top - height | 0) + ctx.fmr_1.dku_1.fku_1 | 0;
    }
    var maxX = viewport.cku_1.eku_1 + viewport.dku_1.eku_1 | 0;
    if ((left + ctx.emr_1.eku_1 | 0) > maxX) {
      left = (left - ctx.emr_1.eku_1 | 0) - ctx.fmr_1.dku_1.eku_1 | 0;
    }
    return $this.lmr(ctx.dmr_1, left, top);
  }
  function Context_2(parent, popupCell, popupView, popupDimension) {
    this.bmr_1 = parent;
    this.cmr_1 = popupCell;
    this.dmr_1 = popupView;
    this.emr_1 = popupDimension;
    this.fmr_1 = get_bounds(this.bmr_1);
  }
  protoOf(Context_2).jmr = function () {
    var pos = this.cmr_1.clo(get_POPUP_X_POSITION());
    var tmp = this.bmr_1;
    if (!(tmp instanceof TextCell)) {
      // Inline function 'kotlin.check' call
      if (!(pos === 0)) {
        // Inline function 'jetbrains.ocelot.projectional.cell.popupManager.Context.<get-xOffset>.<anonymous>' call
        var message = 'Only supported when parent is TextCell, but encountered: ' + toString_1(this.bmr_1);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      return 0;
    }
    return this.bmr_1.flu(pos);
  };
  function Companion_297() {
    this.mmr_1 = 150;
    this.nmr_1 = 25;
  }
  var Companion_instance_297;
  function Companion_getInstance_297() {
    return Companion_instance_297;
  }
  protoOf(PopupPositionUpdater).omq = function (popupCell, popupView) {
    var parent = popupCell.yt();
    var ctx = new Context_2(ensureNotNull(parent), popupCell, popupView, this.omr(popupView));
    var tmp0_subject = getRole(this, parent, popupCell);
    return equals(tmp0_subject, get_BOTTOM_POPUP()) ? updateBottom(this, hasVisiblePopup(this, get_TOP_POPUP(), parent), ctx) : equals(tmp0_subject, get_FRONT_POPUP()) ? updateFront(this, ctx) : equals(tmp0_subject, get_RIGHT_POPUP()) ? updateRight(this, ctx) : equals(tmp0_subject, get_LEFT_POPUP()) ? updateLeft(this, ctx) : equals(tmp0_subject, get_TOP_POPUP()) ? updateTop(this, hasVisiblePopup(this, get_BOTTOM_POPUP(), parent), ctx) : false;
  };
  protoOf(PopupPositionUpdater).imr = function (popup) {
  };
  protoOf(PopupPositionUpdater).hmr = function (popup) {
  };
  protoOf(PopupPositionUpdater).gmr = function (popup, height) {
    return height;
  };
  protoOf(PopupPositionUpdater).kmr = function (popup, height) {
    return height;
  };
  function PopupPositionUpdater() {
  }
  function CellDefaultPositionHandler(cell) {
    DefaultPositionHandler.call(this);
    this.pmr_1 = cell;
  }
  protoOf(CellDefaultPositionHandler).dlu = function () {
    var firstFocusable_0 = firstFocusable(this.pmr_1);
    var tmp;
    if (firstFocusable_0 === this.pmr_1 || firstFocusable_0 == null) {
      tmp = protoOf(DefaultPositionHandler).dlu.call(this);
    } else {
      tmp = get_positionHandler(firstFocusable_0).dlu();
    }
    return tmp;
  };
  protoOf(CellDefaultPositionHandler).blu = function () {
    var lastFocusable_0 = lastFocusable(this.pmr_1);
    var tmp;
    if (lastFocusable_0 === this.pmr_1 || lastFocusable_0 == null) {
      tmp = protoOf(DefaultPositionHandler).blu.call(this);
    } else {
      tmp = get_positionHandler(lastFocusable_0).blu();
    }
    return tmp;
  };
  protoOf(CellDefaultPositionHandler).np = function () {
    var firstFocusable_0 = firstFocusable(this.pmr_1);
    var lastFocusable_0 = lastFocusable(this.pmr_1);
    return firstFocusable_0 === lastFocusable_0 && (firstFocusable_0 == null || firstFocusable_0 === this.pmr_1 || get_positionHandler(firstFocusable_0).np());
  };
  protoOf(CellDefaultPositionHandler).qmr = function (position) {
    var remains = position;
    var _iterator__ex2g4s = this.pmr_1.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var cell = _iterator__ex2g4s.m();
      var setResult = get_positionHandler(cell).qmr(remains);
      if (setResult.rmr_1) {
        return setResult;
      }
      remains = setResult.smr_1;
    }
    return new SetPositionResult(false, remains);
  };
  function DefaultPositionHandler$caretOffset$1() {
  }
  protoOf(DefaultPositionHandler$caretOffset$1).qr = function () {
    return 0;
  };
  protoOf(DefaultPositionHandler$caretOffset$1).ams = function (handler) {
    return Companion_getInstance_25().wr_1;
  };
  protoOf(DefaultPositionHandler$caretOffset$1).o27 = function (handler) {
    return this.ams(handler);
  };
  protoOf(DefaultPositionHandler$caretOffset$1).bms = function (newValue) {
  };
  protoOf(DefaultPositionHandler$caretOffset$1).t2c = function (newValue) {
    return this.bms((!(newValue == null) ? typeof newValue === 'number' : false) ? newValue : THROW_CCE());
  };
  protoOf(DefaultPositionHandler$caretOffset$1).l2c = function () {
    return 'defaultCaretOffset';
  };
  function DefaultPositionHandler() {
  }
  protoOf(DefaultPositionHandler).dlu = function () {
    return false;
  };
  protoOf(DefaultPositionHandler).blu = function () {
    return false;
  };
  protoOf(DefaultPositionHandler).tmr = function () {
    return this.dlu();
  };
  protoOf(DefaultPositionHandler).umr = function () {
    return this.blu();
  };
  protoOf(DefaultPositionHandler).vmr = function () {
    return this.np();
  };
  protoOf(DefaultPositionHandler).wmr = function () {
  };
  protoOf(DefaultPositionHandler).xmr = function () {
  };
  protoOf(DefaultPositionHandler).ymr = function () {
    return new DefaultPositionHandler$caretOffset$1();
  };
  protoOf(DefaultPositionHandler).zmr = function (offset) {
    return 2147483647;
  };
  function NewLineCellPositionHandler(cell) {
    DefaultPositionHandler.call(this);
    this.cms_1 = cell;
  }
  protoOf(NewLineCellPositionHandler).dlu = function () {
    return true;
  };
  protoOf(NewLineCellPositionHandler).blu = function () {
    return true;
  };
  protoOf(NewLineCellPositionHandler).np = function () {
    return true;
  };
  protoOf(NewLineCellPositionHandler).qmr = function (position) {
    return new SetPositionResult(false, position - this.cms_1.imj_1 | 0);
  };
  function PositionHandler$Companion$PROPERTY$lambda(cell) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = new TextPositionHandler(cell);
    } else {
      if (cell instanceof NewLineCell) {
        tmp = new NewLineCellPositionHandler(cell);
      } else {
        tmp = new CellDefaultPositionHandler(cell);
      }
    }
    return tmp;
  }
  function SetPositionResult(isPositionHasBeenSet, carryOut) {
    this.rmr_1 = isPositionHasBeenSet;
    this.smr_1 = carryOut;
  }
  function Companion_298() {
    Companion_instance_298 = this;
    var tmp = this;
    tmp.dms_1 = new CellTraitPropertySpec('positionHandler', PositionHandler$Companion$PROPERTY$lambda);
  }
  var Companion_instance_298;
  function Companion_getInstance_298() {
    if (Companion_instance_298 == null)
      new Companion_298();
    return Companion_instance_298;
  }
  function toEnd_0(_this__u8e3s4) {
    return toEnd$lambda(_this__u8e3s4);
  }
  function get_positionHandler(_this__u8e3s4) {
    return _this__u8e3s4.ulp(Companion_getInstance_298().dms_1);
  }
  function toLastFocusable(_this__u8e3s4) {
    return toLastFocusable$lambda(_this__u8e3s4);
  }
  function toHome(_this__u8e3s4) {
    return toHome$lambda(_this__u8e3s4);
  }
  function toFirstFocusable(_this__u8e3s4) {
    return toFirstFocusable$lambda(_this__u8e3s4);
  }
  function Positions() {
  }
  protoOf(Positions).ems = function (cell) {
    var first = firstFocusable(cell);
    return !(first == null) && first.qlp().qr() && get_positionHandler(first).dlu();
  };
  protoOf(Positions).fms = function (cell) {
    var last = lastFocusable(cell);
    return !(last == null) && last.qlp().qr() && get_positionHandler(last).blu();
  };
  protoOf(Positions).gms = function (cell) {
    var first = firstFocusable(cell);
    return !(first == null) && first.qlp().qr() && get_positionHandler(first).tmr();
  };
  protoOf(Positions).hms = function (cell) {
    var last = lastFocusable(cell);
    return !(last == null) && last.qlp().qr() && get_positionHandler(last).umr();
  };
  var Positions_instance;
  function Positions_getInstance() {
    return Positions_instance;
  }
  function isEmpty_0(_this__u8e3s4) {
    return get_positionHandler(_this__u8e3s4).np();
  }
  function isVisuallyEmpty(_this__u8e3s4) {
    return get_positionHandler(_this__u8e3s4).vmr();
  }
  function toPosition(_this__u8e3s4, pos) {
    return toPosition$lambda(_this__u8e3s4, pos);
  }
  function toEnd$lambda($this_toEnd) {
    return function () {
      var tmp;
      if (!$this_toEnd.hlp().qr()) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      get_positionHandler($this_toEnd).xmr();
      $this_toEnd.ul5();
      CellScrolling_getInstance().kms($this_toEnd);
      return Unit_instance;
    };
  }
  function toLastFocusable$lambda($this_toLastFocusable) {
    return function () {
      var cell = lastFocusable($this_toLastFocusable);
      var tmp;
      if (!(cell == null)) {
        tmp = toEnd_0(cell)();
      }
      return Unit_instance;
    };
  }
  function toHome$lambda($this_toHome) {
    return function () {
      var tmp;
      if (!$this_toHome.hlp().qr()) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      get_positionHandler($this_toHome).wmr();
      $this_toHome.ul5();
      CellScrolling_getInstance().kms($this_toHome);
      return Unit_instance;
    };
  }
  function toFirstFocusable$lambda($this_toFirstFocusable) {
    return function () {
      var cell = firstFocusable($this_toFirstFocusable);
      var tmp;
      if (!(cell == null)) {
        tmp = toHome(cell)();
      }
      return Unit_instance;
    };
  }
  function toPosition$lambda($this_toPosition, $pos) {
    return function () {
      $this_toPosition.ul5();
      get_positionHandler($this_toPosition).qmr($pos);
      CellScrolling_getInstance().kms($this_toPosition);
      return Unit_instance;
    };
  }
  function _get_length__w7ahp7($this) {
    return $this.lms_1.laz().qr().length;
  }
  function hasPosition($this, position) {
    return $this.lms_1.hlp().m2c() && !(position === 0 && !$this.lms_1.ulp(TextEditing_getInstance().alx_1)) && !(position === $this.lms_1.clu() && !$this.lms_1.ulp(TextEditing_getInstance().blx_1)) && position <= _get_length__w7ahp7($this);
  }
  function TextPositionHandler$caretOffset$derivedOffset$1(this$0) {
    this.qms_1 = this$0;
    DerivedProperty.call(this, []);
  }
  protoOf(TextPositionHandler$caretOffset$derivedOffset$1).g2c = function () {
    return this.qms_1.lms_1.flu(this.qms_1.lms_1.zlt().qr());
  };
  protoOf(TextPositionHandler$caretOffset$derivedOffset$1).l2c = function () {
    return 'derivedOffset(' + this.qms_1.lms_1.toString() + ')';
  };
  function TextPositionHandler$caretOffset$1($derivedOffset, this$0) {
    this.rms_1 = $derivedOffset;
    this.sms_1 = this$0;
  }
  protoOf(TextPositionHandler$caretOffset$1).qr = function () {
    return this.rms_1.qr();
  };
  protoOf(TextPositionHandler$caretOffset$1).ams = function (handler) {
    return this.rms_1.k2c(handler);
  };
  protoOf(TextPositionHandler$caretOffset$1).o27 = function (handler) {
    return this.ams(handler);
  };
  protoOf(TextPositionHandler$caretOffset$1).bms = function (newValue) {
    var tmp2 = Companion_getInstance_300().ums(this.sms_1.lms_1);
    var tmp0 = Companion_getInstance_300().vms(this.sms_1.lms_1);
    // Inline function 'kotlin.math.min' call
    var b = this.sms_1.lms_1.slu(newValue);
    // Inline function 'kotlin.math.max' call
    var b_0 = Math.min(tmp0, b);
    var caretAt = Math.max(tmp2, b_0);
    this.sms_1.lms_1.zlt().t2c(caretAt);
  };
  protoOf(TextPositionHandler$caretOffset$1).t2c = function (newValue) {
    return this.bms((!(newValue == null) ? typeof newValue === 'number' : false) ? newValue : THROW_CCE());
  };
  protoOf(TextPositionHandler$caretOffset$1).l2c = function () {
    return 'caretOffset(' + this.sms_1.lms_1.toString() + ')';
  };
  function TextPositionHandler(editor) {
    this.lms_1 = editor;
  }
  protoOf(TextPositionHandler).dlu = function () {
    return Companion_getInstance_300().ums(this.lms_1) === this.lms_1.zlt().qr();
  };
  protoOf(TextPositionHandler).blu = function () {
    return Companion_getInstance_300().vms(this.lms_1) === this.lms_1.zlt().qr();
  };
  protoOf(TextPositionHandler).np = function () {
    return Companion_getInstance_300().ums(this.lms_1) === Companion_getInstance_300().vms(this.lms_1);
  };
  protoOf(TextPositionHandler).tmr = function () {
    return this.lms_1.zlt().qr() === 0;
  };
  protoOf(TextPositionHandler).umr = function () {
    return this.lms_1.zlt().qr() === this.lms_1.laz().qr().length;
  };
  protoOf(TextPositionHandler).vmr = function () {
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = this.lms_1.laz().qr();
    return charSequenceLength(this_0) === 0;
  };
  protoOf(TextPositionHandler).wmr = function () {
    this.lms_1.zlt().t2c(Companion_getInstance_300().ums(this.lms_1));
  };
  protoOf(TextPositionHandler).xmr = function () {
    this.lms_1.zlt().t2c(Companion_getInstance_300().vms(this.lms_1));
  };
  protoOf(TextPositionHandler).ymr = function () {
    var derivedOffset = new TextPositionHandler$caretOffset$derivedOffset$1(this);
    return new TextPositionHandler$caretOffset$1(derivedOffset, this);
  };
  protoOf(TextPositionHandler).qmr = function (position) {
    if (hasPosition(this, position)) {
      this.lms_1.zlt().t2c(position);
      this.lms_1.ilu().t2c(true);
      this.lms_1.ul5();
      return new SetPositionResult(true, 0);
    }
    var leftAhead = position - _get_length__w7ahp7(this) | 0;
    // Inline function 'kotlin.require' call
    if (!(leftAhead >= 0)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.position.TextPositionHandler.trySetPosition.<anonymous>' call
      var message = 'Position ' + position + ' in ' + this.lms_1.toString() + ' is not available';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return new SetPositionResult(false, leftAhead);
  };
  protoOf(TextPositionHandler).zmr = function (offset) {
    var originX = get_origin_0(this.lms_1).eku_1;
    var tmp0 = abs((originX + this.lms_1.flu(Companion_getInstance_300().vms(this.lms_1)) | 0) - offset | 0);
    // Inline function 'kotlin.math.min' call
    var b = abs((originX + this.lms_1.flu(Companion_getInstance_300().ums(this.lms_1)) | 0) - offset | 0);
    return Math.min(tmp0, b);
  };
  function doClearComposite($this, cell, interval) {
    var text = cell.laz().qr();
    var lowerEndpoint = interval.n2s_1;
    var tmp = take_1(text, lowerEndpoint);
    // Inline function 'kotlin.text.substring' call
    var startIndex = interval.x2s();
    // Inline function 'kotlin.js.asDynamic' call
    var newText = tmp + text.substring(startIndex);
    cell.laz().t2c(newText);
    cell.zlt().t2c(lowerEndpoint);
    cell.bln(Companion_getInstance_271().lls_1, minus_2(cell.clo(Companion_getInstance_271().lls_1), getCompositeDecoration($this, interval)));
  }
  function getCompositeDecoration($this, interval) {
    return new BackgroundHighlightTextDecoration(Companion_getInstance_325().vls_1, interval);
  }
  function InputMethodEditorUtil$showComposite$$inlined$toDisposable$1($cell, $interval) {
    this.wms_1 = $cell;
    this.xms_1 = $interval;
  }
  protoOf(InputMethodEditorUtil$showComposite$$inlined$toDisposable$1).vr = function () {
    doClearComposite(InputMethodEditorUtil_getInstance(), this.wms_1, this.xms_1);
    return Unit_instance;
  };
  function InputMethodEditorUtil() {
    InputMethodEditorUtil_instance = this;
    this.yms_1 = CellPropertySpec_init_$Create$('compositionReg', Companion_getInstance_25().wr_1);
  }
  protoOf(InputMethodEditorUtil).zms = function (cell) {
    return !(cell.clo(this.yms_1) === Companion_getInstance_25().wr_1);
  };
  protoOf(InputMethodEditorUtil).amt = function (cell) {
    cell.clo(this.yms_1).vr();
    cell.bln(this.yms_1, Companion_getInstance_25().wr_1);
  };
  protoOf(InputMethodEditorUtil).bmt = function (cell, composite) {
    this.amt(cell);
    var caretPosition = cell.zlt().qr();
    var interval = Companion_instance_36.r2s(caretPosition, composite.length);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var tmp$ret$0 = new InputMethodEditorUtil$showComposite$$inlined$toDisposable$1(cell, interval);
    cell.bln(this.yms_1, tmp$ret$0);
    var newText = cell.ylt() + composite + cell.alu();
    var newCaret = caretPosition + composite.length | 0;
    cell.laz().t2c(newText);
    cell.zlt().t2c(newCaret);
    cell.bln(Companion_getInstance_271().lls_1, plus_9(HashSet_init_$Create$_0(cell.clo(Companion_getInstance_271().lls_1)), getCompositeDecoration(this, interval)));
  };
  var InputMethodEditorUtil_instance;
  function InputMethodEditorUtil_getInstance() {
    if (InputMethodEditorUtil_instance == null)
      new InputMethodEditorUtil();
    return InputMethodEditorUtil_instance;
  }
  function get_STATE_HANDLER() {
    _init_properties_StateHandlers_kt__hg1r2w();
    return STATE_HANDLER;
  }
  var STATE_HANDLER;
  function get_STATE_HANDLER_WITH_VALID() {
    _init_properties_StateHandlers_kt__hg1r2w();
    return STATE_HANDLER_WITH_VALID;
  }
  var STATE_HANDLER_WITH_VALID;
  function STATE_HANDLER$1() {
    TextEditorStateHandler.call(this);
  }
  protoOf(STATE_HANDLER$1).cmt = function (editor, validator) {
    return new TextEditorCellState();
  };
  protoOf(STATE_HANDLER$1).dmt = function (editor, state) {
  };
  function STATE_HANDLER_WITH_VALID$1() {
    TextEditorStateHandler.call(this);
  }
  protoOf(STATE_HANDLER_WITH_VALID$1).cmt = function (editor, validator) {
    var text = editor.laz().qr();
    var isValid = ensureNotNull(validator)(text);
    return new TextEditorCellState(VOID, text, isValid);
  };
  protoOf(STATE_HANDLER_WITH_VALID$1).dmt = function (editor, state) {
    editor.laz().t2c(state.imt_1);
  };
  var properties_initialized_StateHandlers_kt_cy39me;
  function _init_properties_StateHandlers_kt__hg1r2w() {
    if (!properties_initialized_StateHandlers_kt_cy39me) {
      properties_initialized_StateHandlers_kt_cy39me = true;
      STATE_HANDLER = new STATE_HANDLER$1();
      STATE_HANDLER_WITH_VALID = new STATE_HANDLER_WITH_VALID$1();
    }
  }
  function TextCopyPasteTrait() {
    TextCopyTrait.call(this);
  }
  protoOf(TextCopyPasteTrait).zlo = function (cell, event) {
    var content = event.cl4_1;
    if (!content.fl0(ContentKinds_getInstance().gl4_1) && !(content.fl0(ContentKinds_getInstance().hl4_1) && !(cell.ulp(TextEditing_getInstance().hlx_1) == null)))
      return Unit_instance;
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var tmp;
    if (content.fl0(ContentKinds_getInstance().gl4_1)) {
      tmp = content.gl0(ContentKinds_getInstance().gl4_1);
    } else {
      var adapt = ensureNotNull(cell.ulp(TextEditing_getInstance().hlx_1));
      tmp = adapt(content.gl0(ContentKinds_getInstance().hl4_1));
    }
    var string = tmp;
    this.kmt(editor, string);
    event.ql0();
  };
  protoOf(TextCopyPasteTrait).ylo = function (cell, event) {
    if (this.nmt(cell)) {
      var content = this.lmt(cell);
      var editor = cell instanceof TextCell ? cell : THROW_CCE();
      this.mmt(editor, event);
      event.vl0(content);
    }
  };
  function TextCopyTrait() {
    CellTrait.call(this);
  }
  protoOf(TextCopyTrait).xlo = function (cell, event) {
    if (this.nmt(cell)) {
      event.ul0(this.lmt(cell));
    }
  };
  protoOf(TextCopyTrait).nmt = function (cell) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    return editor.nlu().qr() && !(editor.olu().qr() === editor.plu().qr());
  };
  protoOf(TextCopyTrait).lmt = function (cell) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var selection = editor.glu();
    var tmp0 = editor.laz().qr();
    var tmp1 = selection.nls_1;
    // Inline function 'kotlin.text.substring' call
    var endIndex = selection.ols_1;
    // Inline function 'kotlin.js.asDynamic' call
    var selected = tmp0.substring(tmp1, endIndex);
    return TextContentHelper_getInstance().tl4(selected);
  };
  function TextEditing$textNavigation$o$get$lambda($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function TextEditing$textNavigation$o$get$lambda_0($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function TextEditing$adaptMultilinePaste$o$get$lambda(strings) {
    return joinToString_0(strings, ' ');
  }
  function TextEditing$AFTER_TYPE$lambda(it) {
    return TextEditing$AFTER_TYPE$lambda$lambda;
  }
  function TextEditing$AFTER_TYPE$lambda$lambda() {
    return false;
  }
  function TextEditing$AFTER_PASTE$lambda(it) {
    return TextEditing$AFTER_PASTE$lambda$lambda;
  }
  function TextEditing$AFTER_PASTE$lambda$lambda() {
    return false;
  }
  function TextEditing$AFTER_DELETE$lambda(it) {
    return TextEditing$AFTER_DELETE$lambda$lambda;
  }
  function TextEditing$AFTER_DELETE$lambda$lambda() {
    return false;
  }
  function TextEditing$PREFIX_EAGER_COMPLETION$lambda(_unused_var__etf5q3) {
    return true;
  }
  function TextEditing$PROPAGATE_SUFFIX$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0) {
    return true;
  }
  function TextEditing$ON_VALIDATOR_CHANGED$lambda(it) {
    return TextEditing$ON_VALIDATOR_CHANGED$lambda$lambda;
  }
  function TextEditing$ON_VALIDATOR_CHANGED$lambda$lambda() {
    return Unit_instance;
  }
  function TextEditing$TEXT_NAVIGATION_TRAIT$1() {
    BaseDerivedCellTrait.call(this, new TextNavigationTrait());
  }
  protoOf(TextEditing$TEXT_NAVIGATION_TRAIT$1).flo = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = TextEditing_getInstance().nlx_1(spec);
    var tmp;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.text.<no name provided>.get.<anonymous>' call
      tmp = protoOf(BaseDerivedCellTrait).flo.call(this, cell, spec);
    } else {
      tmp = result.sma_1;
    }
    return tmp;
  };
  function TextEditing$TEXT_EDITING_TRAIT$1() {
    BaseDerivedCellTrait.call(this, new TextEditingTrait());
  }
  protoOf(TextEditing$TEXT_EDITING_TRAIT$1).glo = function (cell) {
    protoOf(BaseDerivedCellTrait).glo.call(this, cell);
    assertFocusable(cell);
  };
  protoOf(TextEditing$TEXT_EDITING_TRAIT$1).flo = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = TextEditing_getInstance().nlx_1(spec);
    var tmp;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.text.<no name provided>.get.<anonymous>' call
      tmp = protoOf(BaseDerivedCellTrait).flo.call(this, cell, spec);
    } else {
      tmp = result.sma_1;
    }
    return tmp;
  };
  function TextEditing$textNavigation$lambda($spec, $firstAllowed) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        // Inline function 'jetbrains.ocelot.projectional.cell.text.TextEditing.textNavigation.<anonymous>' call
        var tmp$ret$0 = $firstAllowed();
        tmp = new SpecMatchResult(tmp$ret$0);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function TextEditing$textNavigation$lambda_0($spec, $lastAllowed) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        // Inline function 'jetbrains.ocelot.projectional.cell.text.TextEditing.textNavigation.<anonymous>' call
        var tmp$ret$0 = $lastAllowed();
        tmp = new SpecMatchResult(tmp$ret$0);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function TextEditing$textNavigation$1($matchers) {
    this.smt_1 = $matchers;
    DerivedCellTrait.call(this);
  }
  protoOf(TextEditing$textNavigation$1).qmt = function (cell) {
    return TextEditing_getInstance().olx_1;
  };
  protoOf(TextEditing$textNavigation$1).flo = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var specMatchers = this.smt_1;
    var tmp = asSequence_0(specMatchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, TextEditing$textNavigation$o$get$lambda(spec))));
    var tmp_0;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.text.<no name provided>.get.<anonymous>' call
      tmp_0 = protoOf(DerivedCellTrait).flo.call(this, cell, spec);
    } else {
      tmp_0 = result.sma_1;
    }
    return tmp_0;
  };
  function TextEditing$textNavigation$2($matchers) {
    this.tmt_1 = $matchers;
    DerivedCellTrait.call(this);
  }
  protoOf(TextEditing$textNavigation$2).qmt = function (cell) {
    return TextEditing_getInstance().olx_1;
  };
  protoOf(TextEditing$textNavigation$2).glo = function (cell) {
    protoOf(DerivedCellTrait).glo.call(this, cell);
    assertFocusable(cell);
  };
  protoOf(TextEditing$textNavigation$2).flo = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var specMatchers = this.tmt_1;
    var tmp = asSequence_0(specMatchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, TextEditing$textNavigation$o$get$lambda_0(spec))));
    var tmp_0;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.text.<no name provided>.get.<anonymous>' call
      tmp_0 = protoOf(DerivedCellTrait).flo.call(this, cell, spec);
    } else {
      tmp_0 = result.sma_1;
    }
    return tmp_0;
  };
  function TextEditing$validTextEditing$2($validator) {
    this.umt_1 = $validator;
    DerivedCellTrait.call(this);
  }
  protoOf(TextEditing$validTextEditing$2).qmt = function (cell) {
    return TextEditing_getInstance().rlx_1;
  };
  protoOf(TextEditing$validTextEditing$2).flo = function (cell, spec) {
    var specMatcher = specMatcherValue(Companion_getInstance_301().vmt_1, this.umt_1);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.text.<no name provided>.get.<anonymous>' call
      tmp = protoOf(DerivedCellTrait).flo.call(this, cell, spec);
    } else {
      tmp = result.sma_1;
    }
    return tmp;
  };
  function TextEditing$adaptMultilinePaste$$inlined$propertyTrait$1($propSpec) {
    this.ymt_1 = $propSpec;
    CellTrait.call(this);
  }
  protoOf(TextEditing$adaptMultilinePaste$$inlined$propertyTrait$1).flo = function (cell, spec) {
    var tmp;
    if (spec === this.ymt_1) {
      // Inline function 'jetbrains.ocelot.projectional.cell.text.TextEditing.adaptMultilinePaste.<anonymous>' call
      tmp = TextEditing$adaptMultilinePaste$o$get$lambda;
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function TextEditing() {
    TextEditing_instance = this;
    this.ylw_1 = CellTraitPropertySpec_init_$Create$('navigable', false);
    this.zlw_1 = CellTraitPropertySpec_init_$Create$('editable', false);
    this.alx_1 = CellTraitPropertySpec_init_$Create$('firstAllowed', true);
    this.blx_1 = CellTraitPropertySpec_init_$Create$('lastAllowed', true);
    this.clx_1 = CellTraitPropertySpec_init_$Create$('dotLikeRt', false);
    this.dlx_1 = CellTraitPropertySpec_init_$Create$('clearOnDelete', false);
    var tmp = this;
    tmp.elx_1 = new CellTraitPropertySpec('afterType', TextEditing$AFTER_TYPE$lambda);
    var tmp_0 = this;
    tmp_0.flx_1 = new CellTraitPropertySpec('afterPaste', TextEditing$AFTER_PASTE$lambda);
    var tmp_1 = this;
    tmp_1.glx_1 = new CellTraitPropertySpec('afterDelete', TextEditing$AFTER_DELETE$lambda);
    this.hlx_1 = CellTraitPropertySpec_init_$Create$('adaptMultilinePaste', null);
    this.ilx_1 = CellTraitPropertySpec_init_$Create$('eagerCompletion', false);
    var tmp_2 = this;
    tmp_2.jlx_1 = CellTraitPropertySpec_init_$Create$('prefixEagerCompletion', TextEditing$PREFIX_EAGER_COMPLETION$lambda);
    var tmp_3 = this;
    tmp_3.klx_1 = CellTraitPropertySpec_init_$Create$('propagateSuffix', TextEditing$PROPAGATE_SUFFIX$lambda);
    this.llx_1 = Companion_getInstance_301().vmt_1;
    var tmp_4 = this;
    tmp_4.mlx_1 = new CellTraitPropertySpec('onValidatorChanged', TextEditing$ON_VALIDATOR_CHANGED$lambda);
    this.nlx_1 = specMatcherValue(Companion_getInstance_305().zmt_1, get_STATE_HANDLER());
    var tmp_5 = this;
    tmp_5.olx_1 = new TextEditing$TEXT_NAVIGATION_TRAIT$1();
    var tmp_6 = this;
    tmp_6.plx_1 = new TextEditing$TEXT_EDITING_TRAIT$1();
    this.qlx_1 = new TextCopyTrait();
    this.rlx_1 = new ValidTextEditingTrait();
  }
  protoOf(TextEditing).amu = function () {
    return this.olx_1;
  };
  protoOf(TextEditing).bmu = function (firstAllowed, lastAllowed) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec = this.alx_1;
    var tmp = TextEditing$textNavigation$lambda(spec, firstAllowed);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec_0 = this.blx_1;
    var tmp$ret$1 = TextEditing$textNavigation$lambda_0(spec_0, lastAllowed);
    var matchers = listOf_0([tmp, tmp$ret$1]);
    return new TextEditing$textNavigation$1(matchers);
  };
  protoOf(TextEditing).cmu = function (firstAllowed, lastAllowed, selectionAvailable) {
    var matchers = listOf_0([specMatcherValue(this.alx_1, firstAllowed), specMatcherValue(this.blx_1, lastAllowed), specMatcherValue(Companion_getInstance_300().tms_1, selectionAvailable)]);
    return new TextEditing$textNavigation$2(matchers);
  };
  protoOf(TextEditing).slx = function (firstAllowed, lastAllowed, selectionAvailable, $super) {
    selectionAvailable = selectionAvailable === VOID ? true : selectionAvailable;
    return $super === VOID ? this.cmu(firstAllowed, lastAllowed, selectionAvailable) : $super.cmu.call(this, firstAllowed, lastAllowed, selectionAvailable);
  };
  protoOf(TextEditing).dmu = function () {
    return CompositeCellTraits_instance.emu([this.olx_1, this.qlx_1]);
  };
  protoOf(TextEditing).fmu = function () {
    return this.plx_1;
  };
  protoOf(TextEditing).gmu = function (validator) {
    return new TextEditing$validTextEditing$2(validator);
  };
  protoOf(TextEditing).hmu = function () {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
    var propSpec = this.hlx_1;
    return new TextEditing$adaptMultilinePaste$$inlined$propertyTrait$1(propSpec);
  };
  var TextEditing_instance;
  function TextEditing_getInstance() {
    if (TextEditing_instance == null)
      new TextEditing();
    return TextEditing_instance;
  }
  function setText($this, editor, text) {
    return editor.laz().t2c(text);
  }
  function isEmpty_1($this, editor) {
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = editor.laz().qr();
    return charSequenceLength(this_0) === 0;
  }
  function CopyPasteTrait($outer) {
    this.imu_1 = $outer;
    TextCopyPasteTrait.call(this);
  }
  protoOf(CopyPasteTrait).kmt = function (editor, text) {
    clearSelection(this.imu_1, editor);
    pasteText(this.imu_1, editor, text);
    this.imu_1.yma(editor);
  };
  protoOf(CopyPasteTrait).mmt = function (editor, event) {
    clearSelection(this.imu_1, editor);
    this.imu_1.zma(editor);
    if (isEmpty_1(Companion_getInstance_299(), editor)) {
      editor.nlp(new DerivedCopyCutEvent(event, event.tl0_1), Cells_getInstance().kmg_1);
    }
  };
  function dispatchBecameEmpty($this, editor, initial) {
    if (isEmpty_1(Companion_getInstance_299(), editor)) {
      editor.nlp(new DerivedEvent(initial), Cells_getInstance().kmg_1);
    }
  }
  function scrollTo_3($this, cell, cause) {
    if (cell.qlc()) {
      CellScrolling_getInstance().jmu(cell, cause);
    }
  }
  function maybeShowRightTransformCompletion($this, completionItems, editor) {
    if (editor.ulp(Completion_getInstance().hm1_1).xm0(completionItems, editor.ylt())) {
      var supplier = editor.ulp(Completion_getInstance().em1_1);
      if (editor.clo(get_RIGHT_POPUP()) == null) {
        var popup = CompletionSupport_getInstance().cmc(editor, get_RIGHT_POPUP(), supplier, true);
        var tmp = Completion_getInstance().am3(popup);
        var tmp_0 = Companion_getInstance_284().f5j();
        tmp.jm2(tmp_0.vmd(TextCell$focus$ref(editor)).k2p());
      }
      return true;
    }
    return false;
  }
  function completeOrShow($this, completionItems, editor, controller, event, stateUnchanged) {
    if (!(completionItems == null) && stateUnchanged) {
      var prefixText = editor.ylt();
      var prefixed = completionItems.hm2(prefixText);
      var currentText = editor.laz().qr();
      var tmp;
      var tmp_0;
      if (prefixed.n() === 1) {
        // Inline function 'kotlin.text.isNotEmpty' call
        tmp_0 = charSequenceLength(currentText) > 0;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = $this.xma(editor);
      } else {
        tmp = false;
      }
      if (tmp) {
        var tmp_1 = ensureNotNull(editor.llk());
        tmp_1.hm9(TextEditingTrait$completeOrShow$lambda(prefixed, prefixText));
        return Unit_instance;
      }
    }
    if (controller.im2()) {
      var completionParameters = Companion_getInstance_284().om9(event.lm9_1).k2p();
      controller.jm2(completionParameters);
    }
  }
  function completeOrShow$default($this, completionItems, editor, controller, event, stateUnchanged, $super) {
    stateUnchanged = stateUnchanged === VOID ? true : stateUnchanged;
    return completeOrShow($this, completionItems, editor, controller, event, stateUnchanged);
  }
  function clearSelection($this, editor) {
    if (!editor.nlu().qr())
      return Unit_instance;
    var text = editor.laz().qr();
    var selection = editor.glu();
    var tmp = Companion_getInstance_299();
    var tmp_0 = take_1(text, selection.nls_1);
    // Inline function 'kotlin.text.substring' call
    var startIndex = selection.ols_1;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = text.substring(startIndex);
    setText(tmp, editor, tmp_0 + tmp$ret$1);
    editor.zlt().t2c(selection.nls_1);
    editor.nlu().t2c(false);
  }
  function pasteText($this, editor, text) {
    var currentText = editor.laz().qr();
    var caret = editor.zlt().qr();
    var tmp = Companion_getInstance_299();
    var tmp_0 = take_1(currentText, caret) + text;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = currentText.substring(caret);
    setText(tmp, editor, tmp_0 + tmp$ret$1);
    if (editor.qlc()) {
      editor.zlt().t2c(caret + text.length | 0);
    }
  }
  function callCustomProcessor($this, editor, prop) {
    var processor = editor.ulp(prop);
    return processor();
  }
  function TextCellStateBeforeCompletion(cell) {
    this.kmu_1 = cell.laz().m2c();
    this.lmu_1 = cell.llk();
  }
  protoOf(TextCellStateBeforeCompletion).mmu = function (cell) {
    return cell.laz().m2c() === this.kmu_1 && cell.llk() === this.lmu_1;
  };
  function Companion_299() {
    Companion_instance_299 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.nmu_1 = [new TextNavigationTrait()];
  }
  var Companion_instance_299;
  function Companion_getInstance_299() {
    if (Companion_instance_299 == null)
      new Companion_299();
    return Companion_instance_299;
  }
  function TextEditingTrait$onComplete$slambda(this$0, $editor, $controller, $event, $savedState, resultContinuation) {
    this.wmu_1 = this$0;
    this.xmu_1 = $editor;
    this.ymu_1 = $controller;
    this.zmu_1 = $event;
    this.amv_1 = $savedState;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextEditingTrait$onComplete$slambda).cmv = function (it, $completion) {
    var tmp = this.dmv(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(TextEditingTrait$onComplete$slambda).oa = function (p1, $completion) {
    return this.cmv((p1 == null ? true : p1 instanceof CompletionItems) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextEditingTrait$onComplete$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          completeOrShow(this.wmu_1, this.bmv_1, this.xmu_1, this.ymu_1, this.zmu_1, this.wmu_1.amb(this.xmu_1, this.amv_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(TextEditingTrait$onComplete$slambda).dmv = function (it, completion) {
    var i = new TextEditingTrait$onComplete$slambda(this.wmu_1, this.xmu_1, this.ymu_1, this.zmu_1, this.amv_1, completion);
    i.bmv_1 = it;
    return i;
  };
  function TextEditingTrait$onComplete$slambda_0(this$0, $editor, $controller, $event, $savedState, resultContinuation) {
    var i = new TextEditingTrait$onComplete$slambda(this$0, $editor, $controller, $event, $savedState, resultContinuation);
    var l = function (it, $completion) {
      return i.cmv(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function TextCell$focus$ref($boundThis) {
    var l = function () {
      $boundThis.ul5();
      return Unit_instance;
    };
    l.callableName = 'focus';
    return l;
  }
  function TextEditingTrait$completeOrShow$lambda($prefixed, $prefixText) {
    return function () {
      $prefixed.q(0).wm9($prefixText)();
      return Unit_instance;
    };
  }
  function TextEditingTrait() {
    Companion_getInstance_299();
    CompositeCellTrait.call(this);
  }
  protoOf(TextEditingTrait).wma = function (cell) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return arrayConcat([Companion_getInstance_299().nmu_1, [new CopyPasteTrait(this)]]);
  };
  protoOf(TextEditingTrait).flo = function (cell, spec) {
    var specMatcher = specMatcherValue(TextEditing_getInstance().zlw_1, true);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.text.TextEditingTrait.get.<anonymous>' call
      tmp = protoOf(CompositeCellTrait).flo.call(this, cell, spec);
    } else {
      tmp = result.sma_1;
    }
    return tmp;
  };
  protoOf(TextEditingTrait).llm = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var currentText = editor.laz().qr();
    var caret = editor.zlt().qr();
    var textLen = currentText.length;
    // Inline function 'kotlin.text.isNotEmpty' call
    var nonEmptyText = charSequenceLength(currentText) > 0;
    if (editor.nlu().qr() && (event.ml1(Key_BACKSPACE_getInstance(), []) || event.ml1(Key_DELETE_getInstance(), []))) {
      clearSelection(this, editor);
      this.zma(editor);
      dispatchBecameEmpty(this, editor, event);
      event.ql0();
      return Unit_instance;
    }
    if (event.ml1(Key_BACKSPACE_getInstance(), []) && caret > 0) {
      editor.zlt().t2c(caret - 1 | 0);
      var tmp = Companion_getInstance_299();
      var tmp_0 = take_1(currentText, caret - 1 | 0);
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = currentText.substring(caret);
      setText(tmp, editor, tmp_0 + tmp$ret$2);
      this.zma(editor);
      dispatchBecameEmpty(this, editor, event);
      scrollTo_3(this, cell, event);
      event.ql0();
      return Unit_instance;
    }
    if (event.ml1(Key_DELETE_getInstance(), []) && caret < textLen) {
      var tmp_1 = Companion_getInstance_299();
      var tmp_2 = take_1(currentText, caret);
      // Inline function 'kotlin.text.substring' call
      var startIndex = caret + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = currentText.substring(startIndex);
      setText(tmp_1, editor, tmp_2 + tmp$ret$4);
      this.zma(editor);
      dispatchBecameEmpty(this, editor, event);
      event.ql0();
      return Unit_instance;
    }
    if (event.ol1([KeyStrokeSpecs_getInstance().hl3_1]) && cell.ulp(TextEditing_getInstance().dlx_1) && nonEmptyText) {
      setText(Companion_getInstance_299(), editor, '');
      this.zma(editor);
      dispatchBecameEmpty(this, editor, event);
      event.ql0();
      return Unit_instance;
    }
    if (event.ol1([KeyStrokeSpecs_getInstance().il3_1]) && nonEmptyText && caret > 0) {
      editor.zlt().t2c(0);
      var tmp_3 = Companion_getInstance_299();
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = currentText.substring(caret, textLen);
      setText(tmp_3, editor, tmp$ret$6);
      this.zma(editor);
      dispatchBecameEmpty(this, editor, event);
      event.ql0();
      return Unit_instance;
    }
    if (editor.nlu().qr() && event.ol1([KeyStrokeSpecs_getInstance().gl3_1])) {
      var selection = editor.glu();
      var tmp8 = editor.laz().qr();
      var tmp9 = selection.nls_1;
      // Inline function 'kotlin.text.substring' call
      var endIndex = selection.ols_1;
      // Inline function 'kotlin.js.asDynamic' call
      var selected = tmp8.substring(tmp9, endIndex);
      editor.laz().t2c(insert(currentText, selection.nls_1, selected));
      this.tma(editor, event.jl1_1);
      dispatchBecameEmpty(this, editor, event);
      event.ql0();
    }
    protoOf(CompositeCellTrait).llm.call(this, cell, event);
  };
  protoOf(TextEditingTrait).alp = function (cell, event) {
    var controller = Completion_getInstance().am3(cell);
    if (controller.ft()) {
      protoOf(CompositeCellTrait).alp.call(this, cell, event);
      return Unit_instance;
    }
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var immediateRtApplicable = editor.blu() && editor.ulp(TextEditing_getInstance().clx_1) && valueIsSet(editor, Completion_getInstance().em1_1);
    if (valueIsSet(editor, Completion_getInstance().cm1_1) || immediateRtApplicable) {
      var result = controller.tm2();
      if (get_isReady(result)) {
        var completionItems = CompletionItems_init_$Create$(result);
        if (immediateRtApplicable) {
          if (maybeShowRightTransformCompletion(this, completionItems, editor)) {
            return Unit_instance;
          }
        }
        completeOrShow$default(this, completionItems, editor, controller, event);
      } else {
        var savedState = new TextCellStateBeforeCompletion(editor);
        var timeout = toLong(editor.ulp(Completion_getInstance().hm1_1).ym0());
        var tmp = AsyncCompletionSupport_getInstance();
        tmp.vm0(editor, result, timeout, TextEditingTrait$onComplete$slambda_0(this, editor, controller, event, savedState, null));
      }
      event.ol0();
    }
  };
  protoOf(TextEditingTrait).xma = function (editor) {
    return true;
  };
  protoOf(TextEditingTrait).jll = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    clearSelection(this, editor);
    var text = toString(event.jl1_1);
    pasteText(this, editor, text);
    if (editor.qlc()) {
      CellScrolling_getInstance().jmu(editor, event);
      this.tma(editor, event.jl1_1);
    }
    event.ol0();
  };
  protoOf(TextEditingTrait).blp = function (cell, event) {
    clearSelection(this, cell instanceof TextCell ? cell : THROW_CCE());
    InputMethodEditorUtil_getInstance().bmt(cell, event.kl0_1);
    event.ol0();
  };
  protoOf(TextEditingTrait).clp = function (cell, event) {
    var tmp = InputMethodEditorUtil_getInstance();
    tmp.bmt(cell instanceof TextCell ? cell : THROW_CCE(), event.kl0_1);
    event.ol0();
  };
  protoOf(TextEditingTrait).dlp = function (cell, event) {
    var tmp = InputMethodEditorUtil_getInstance();
    tmp.amt(cell instanceof TextCell ? cell : THROW_CCE());
    event.ol0();
  };
  protoOf(TextEditingTrait).tma = function (editor, typed) {
    return callCustomProcessor(this, editor, TextEditing_getInstance().elx_1);
  };
  protoOf(TextEditingTrait).yma = function (editor) {
    return callCustomProcessor(this, editor, TextEditing_getInstance().flx_1);
  };
  protoOf(TextEditingTrait).zma = function (editor) {
    return callCustomProcessor(this, editor, TextEditing_getInstance().glx_1);
  };
  protoOf(TextEditingTrait).amb = function (_this__u8e3s4, state) {
    return state.mmu(_this__u8e3s4);
  };
  function insert(_this__u8e3s4, offset, str) {
    return (new StringBuilder(_this__u8e3s4)).dd(offset, str).toString();
  }
  function TextEditorCellState(caretPosition, text, isValid) {
    caretPosition = caretPosition === VOID ? 0 : caretPosition;
    text = text === VOID ? '' : text;
    isValid = isValid === VOID ? true : isValid;
    this.hmt_1 = caretPosition;
    this.imt_1 = text;
    this.jmt_1 = isValid;
  }
  protoOf(TextEditorCellState).emv = function (state) {
    var tmp;
    if (!(state instanceof TextEditorCellState)) {
      tmp = this.jmt_1 ? CellStateDifference_NAVIGATION_getInstance() : CellStateDifference_EDIT_getInstance();
    } else {
      if (!(this.imt_1 === state.imt_1)) {
        tmp = CellStateDifference_EDIT_getInstance();
      } else {
        if (this.hmt_1 === state.hmt_1) {
          tmp = CellStateDifference_EQUAL_getInstance();
        } else {
          tmp = CellStateDifference_NAVIGATION_getInstance();
        }
      }
    }
    return tmp;
  };
  protoOf(TextEditorCellState).toString = function () {
    return "text = '" + this.imt_1 + "' caret pos = " + this.hmt_1 + ' valid = ' + this.jmt_1;
  };
  protoOf(TextEditorCellState).hashCode = function () {
    var result = this.hmt_1;
    result = imul(result, 31) + getStringHashCode(this.imt_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.jmt_1) | 0;
    return result;
  };
  protoOf(TextEditorCellState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextEditorCellState))
      return false;
    var tmp0_other_with_cast = other instanceof TextEditorCellState ? other : THROW_CCE();
    if (!(this.hmt_1 === tmp0_other_with_cast.hmt_1))
      return false;
    if (!(this.imt_1 === tmp0_other_with_cast.imt_1))
      return false;
    if (!(this.jmt_1 === tmp0_other_with_cast.jmt_1))
      return false;
    return true;
  };
  function TextEditorStateHandler() {
  }
  protoOf(TextEditorStateHandler).emt = function (cell) {
    var validator = cell.ulp(Companion_getInstance_301().vmt_1);
    return validator == null || validator(cell.laz().qr());
  };
  protoOf(TextEditorStateHandler).fmv = function (cell) {
    return this.emt(cell instanceof TextCell ? cell : THROW_CCE());
  };
  protoOf(TextEditorStateHandler).fmt = function (cell) {
    var validator = cell.ulp(Companion_getInstance_301().vmt_1);
    var result = this.cmt(cell, validator);
    var caretPosition = cell.zlt().qr();
    return new TextEditorCellState(caretPosition, result.imt_1, result.jmt_1);
  };
  protoOf(TextEditorStateHandler).gmv = function (cell) {
    return this.fmt(cell instanceof TextCell ? cell : THROW_CCE());
  };
  protoOf(TextEditorStateHandler).gmt = function (cell, state) {
    this.dmt(cell, state);
    cell.zlt().t2c(state.hmt_1);
  };
  protoOf(TextEditorStateHandler).hmv = function (cell, state) {
    var tmp = cell instanceof TextCell ? cell : THROW_CCE();
    return this.gmt(tmp, state instanceof TextEditorCellState ? state : THROW_CCE());
  };
  function assertFocusable(_this__u8e3s4) {
    // Inline function 'kotlin.check' call
    if (!_this__u8e3s4.hlp().qr()) {
      // Inline function 'jetbrains.ocelot.projectional.cell.text.assertFocusable.<anonymous>' call
      var message = 'Focusable cell expected: ' + toString_1(_this__u8e3s4);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function TextEditorUtil() {
  }
  protoOf(TextEditorUtil).imv = function (cell, prop, event) {
    if (prop === Companion_getInstance_271().als_1) {
      var editor = cell instanceof TextCell ? cell : THROW_CCE();
      var stringChangeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      var newValue = stringChangeEvent.p2e_1;
      var tmp1_elvis_lhs = newValue == null ? null : newValue.length;
      var newLength = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var caretPosition = editor.zlt();
      if (caretPosition.qr() > newLength) {
        caretPosition.t2c(newLength);
      }
    }
  };
  var TextEditorUtil_instance;
  function TextEditorUtil_getInstance() {
    return TextEditorUtil_instance;
  }
  function isFirstAllowed($this, cell) {
    return cell.ulp(TextEditing_getInstance().alx_1);
  }
  function isLastAllowed($this, cell) {
    return cell.ulp(TextEditing_getInstance().blx_1);
  }
  function isSelectionAvailable($this, cell) {
    return cell.ulp(Companion_getInstance_300().tms_1);
  }
  function isCaretKey($this, selectionAvailable, event, key, modifiers) {
    if (event.ml1(key, modifiers.slice()))
      return true;
    if (!selectionAvailable)
      return false;
    var mods = ArrayList_init_$Create$_1(toList(modifiers));
    mods.e(ModifierKey_SHIFT_getInstance());
    // Inline function 'kotlin.collections.toTypedArray' call
    var typedArray = copyToArray(mods);
    return event.ml1(key, typedArray.slice());
  }
  function isDisableSelectionOnArrowMove($this, editor, shift) {
    return !shift && editor.nlu().qr();
  }
  function updateCaretOnArrowMove($this, editor, shift, left) {
    if (isDisableSelectionOnArrowMove($this, editor, shift)) {
      if (left) {
        editor.zlt().t2c(editor.olu().qr());
      }
    } else {
      var caret = editor.zlt().qr();
      editor.zlt().t2c(caret + (left ? -1 : 1) | 0);
    }
  }
  function scrollAndUpdateSelectionVisibility($this, event, editor, prevCaret, shift) {
    CellScrolling_getInstance().jmu(editor, event);
    setSelectionVisible($this, editor, prevCaret, shift);
    event.ql0();
  }
  function setSelectionVisible($this, editor, prevCaret, shift) {
    var selectionVisible = editor.nlu();
    if (shift) {
      var newCaret = editor.zlt().qr();
      if (selectionVisible.qr()) {
        if (newCaret === editor.olu().qr()) {
          selectionVisible.t2c(false);
        }
      } else if (!(newCaret === prevCaret)) {
        editor.olu().t2c(prevCaret);
        selectionVisible.t2c(true);
      }
    } else if (selectionVisible.qr()) {
      selectionVisible.t2c(false);
    }
  }
  function isAllSelected($this, editor) {
    var tmp;
    if (editor.nlu().qr()) {
      tmp = getCurrentSelection($this, editor).lmv() === getMaxSelection($this, editor).lmv();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function selectAll($this, editor) {
    var maxSelection = getMaxSelection($this, editor);
    editor.olu().t2c(maxSelection.jmv_1);
    editor.zlt().t2c(maxSelection.kmv_1);
    editor.nlu().t2c(true);
  }
  function getCurrentSelection($this, editor) {
    // Inline function 'kotlin.check' call
    if (!editor.nlu().qr()) {
      // Inline function 'jetbrains.ocelot.projectional.cell.text.TextNavigationTrait.getCurrentSelection.<anonymous>' call
      var message = 'No selection';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return new Selection_0(editor.olu().qr(), editor.zlt().qr());
  }
  function getMaxSelection($this, editor) {
    var min = Companion_getInstance_300().ums(editor);
    var max = Companion_getInstance_300().vms(editor);
    var last = editor.clu();
    var tmp;
    if (max >= (last - min | 0)) {
      tmp = new Selection_0(0, max);
    } else {
      tmp = new Selection_0(last, min);
    }
    return tmp;
  }
  function showSideCompletion($this, cell, key, popupProp) {
    var completion = Completion_getInstance().cm3(cell, Companion_getInstance_281().qm1_1, key);
    var tmp;
    if (get_isReady(completion) && CompletionItems_init_$Create$(completion).np()) {
      tmp = false;
    } else {
      var popup = CompletionSupport_getInstance().cmc(cell, popupProp, cell.ulp(key), false);
      var tmp_0 = Completion_getInstance().am3(popup);
      var tmp_1 = Companion_getInstance_284().f5j();
      tmp_0.jm2(tmp_1.vmd(Cell$focus$ref(cell)).k2p());
      tmp = true;
    }
    return tmp;
  }
  function showCompletion($this, cell, text, key, popupProp) {
    var completionResult = Completion_getInstance().cm3(cell, Companion_getInstance_281().qm1_1, key);
    if (get_isReady(completionResult)) {
      var completion = CompletionItems_init_$Create$(completionResult);
      if (completion.vma(text, cell.ulp(TextEditing_getInstance().ilx_1))) {
        completion.pmc(text);
        return true;
      }
      if (!completion.qmc(text))
        return false;
    }
    var popup = CompletionSupport_getInstance().cmc(cell, popupProp, cell.ulp(key), false);
    popup.laz().t2c(text);
    popup.zlt().t2c(popup.clu());
    return true;
  }
  function editorSelect($this, editor, word) {
    editor.olu().t2c(word.n2s_1);
    editor.zlt().t2c(word.o2s_1);
    editor.nlu().t2c(true);
    CellScrolling_getInstance().kms(editor);
  }
  function getWordAtCaret($this, editor) {
    var tmp;
    if (!editor.ilu().qr() || Companion_getInstance_300().ums(editor) === Companion_getInstance_300().vms(editor)) {
      tmp = Companion_instance_36.s2s(-1);
    } else {
      var caret = editor.zlt().qr();
      var text = editor.laz().qr();
      var tmp_0;
      if (caret === Companion_getInstance_300().ums(editor) || charSequenceGet(text, caret - 1 | 0) === _Char___init__impl__6a9atx(32)) {
        tmp_0 = new Interval(caret, getWordRightBound($this, editor, caret));
      } else if (caret === Companion_getInstance_300().vms(editor) || charSequenceGet(text, caret) === _Char___init__impl__6a9atx(32)) {
        tmp_0 = new Interval(getWordStart($this, editor, caret), caret);
      } else {
        tmp_0 = new Interval(getWordStart($this, editor, caret), getWordRightBound($this, editor, caret));
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function getWordRightBound($this, editor, left) {
    var text = editor.laz().qr();
    var pos = left;
    $l$loop: while (pos < Companion_getInstance_300().vms(editor) && charSequenceGet(text, pos) !== _Char___init__impl__6a9atx(32)) {
      pos = pos + 1 | 0;
    }
    return pos;
  }
  function getWordStart($this, editor, rightBound) {
    var text = editor.laz().qr();
    var pos = rightBound - 1 | 0;
    $l$loop: while (pos >= Companion_getInstance_300().ums(editor) && charSequenceGet(text, pos) !== _Char___init__impl__6a9atx(32)) {
      pos = pos - 1 | 0;
    }
    return pos + 1 | 0;
  }
  function handleShiftMousePressed($this, editor, pos) {
    if (editor.qlp().qr()) {
      if (!editor.nlu().qr()) {
        editor.olu().t2c(editor.zlt().qr());
      }
    } else {
      editor.olu().t2c(pos);
    }
    editor.zlt().t2c(pos);
    if (!(editor.olu().qr() === pos)) {
      editor.nlu().t2c(true);
    }
  }
  function handleMousePressed($this, editor, pos) {
    editor.olu().t2c(pos);
    editor.zlt().t2c(pos);
    editor.nlu().t2c(false);
  }
  function getPosAt($this, editor, event) {
    var xOffset = event.xl3_1 - get_origin_0(editor).eku_1 | 0;
    var yOffset = event.yl3_1 - get_origin_0(editor).fku_1 | 0;
    if (yOffset < 0 || yOffset > get_dimension(editor).fku_1 || xOffset < 0 || xOffset > get_dimension(editor).eku_1) {
      return -1;
    }
    var maxPos = Companion_getInstance_300().vms(editor);
    var minPos = Companion_getInstance_300().ums(editor);
    // Inline function 'kotlin.math.min' call
    var a = editor.slu(xOffset);
    // Inline function 'kotlin.math.max' call
    var b = Math.min(a, maxPos);
    return Math.max(minPos, b);
  }
  function Selection_0(start, caret) {
    this.jmv_1 = start;
    this.kmv_1 = caret;
  }
  protoOf(Selection_0).lmv = function () {
    var tmp;
    if (this.jmv_1 > this.kmv_1) {
      tmp = this.jmv_1 - this.kmv_1 | 0;
    } else {
      tmp = this.kmv_1 - this.jmv_1 | 0;
    }
    return tmp;
  };
  function Companion_300() {
    Companion_instance_300 = this;
    this.tms_1 = CellTraitPropertySpec_init_$Create$('selectionAvailable', true);
  }
  protoOf(Companion_300).ums = function (cell) {
    return isFirstAllowed(this, cell) ? 0 : 1;
  };
  protoOf(Companion_300).vms = function (cell) {
    var last = cell.clu();
    return isLastAllowed(this, cell) ? last : last - 1 | 0;
  };
  var Companion_instance_300;
  function Companion_getInstance_300() {
    if (Companion_instance_300 == null)
      new Companion_300();
    return Companion_instance_300;
  }
  function Cell$focus$ref($boundThis) {
    var l = function () {
      $boundThis.ul5();
      return Unit_instance;
    };
    l.callableName = 'focus';
    return l;
  }
  function TextNavigationTrait() {
    Companion_getInstance_300();
    CellTrait.call(this);
  }
  protoOf(TextNavigationTrait).llm = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var currentText = editor.laz().qr();
    var caret = editor.zlt().qr();
    var minCaret = Companion_getInstance_300().ums(editor);
    var textLen = currentText.length;
    var maxCaret = isLastAllowed(Companion_getInstance_300(), editor) ? textLen : textLen - 1 | 0;
    var selectionAvailable = isSelectionAvailable(this, editor);
    var shift = event.tl1(ModifierKey_SHIFT_getInstance());
    if (isCaretKey(this, selectionAvailable, event, Key_LEFT_getInstance(), []) && (caret > minCaret || isDisableSelectionOnArrowMove(this, editor, shift))) {
      updateCaretOnArrowMove(this, editor, shift, caret > minCaret);
      scrollAndUpdateSelectionVisibility(this, event, editor, caret, shift);
      return Unit_instance;
    }
    if (isCaretKey(this, selectionAvailable, event, Key_RIGHT_getInstance(), []) && (caret < maxCaret || isDisableSelectionOnArrowMove(this, editor, shift))) {
      updateCaretOnArrowMove(this, editor, shift, false);
      scrollAndUpdateSelectionVisibility(this, event, editor, caret, shift);
      return Unit_instance;
    }
    if (caret > 0 && event.ol1([KeyStrokeSpecs_getInstance().zl2_1])) {
      editor.zlt().t2c(0);
      setSelectionVisible(this, editor, caret, shift);
      CellScrolling_getInstance().jmu(editor, event);
      event.ol0();
      return Unit_instance;
    }
    if (caret < maxCaret && event.ol1([KeyStrokeSpecs_getInstance().yl2_1])) {
      editor.zlt().t2c(maxCaret);
      setSelectionVisible(this, editor, caret, shift);
      CellScrolling_getInstance().jmu(editor, event);
      event.ol0();
      return Unit_instance;
    }
    if (event.ol1([KeyStrokeSpecs_getInstance().tl2_1]) && !isAllSelected(this, editor)) {
      selectAll(this, editor);
      CellScrolling_getInstance().jmu(editor, event);
      event.ol0();
      return Unit_instance;
    }
    protoOf(CellTrait).llm.call(this, cell, event);
  };
  protoOf(TextNavigationTrait).qlm = function (cell, prop, event) {
    if (prop === get_FOCUSED()) {
      var editor = cell instanceof TextCell ? cell : THROW_CCE();
      var booleanEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
      editor.ilu().t2c(booleanEvent.p2e_1);
      if (!booleanEvent.p2e_1) {
        editor.nlu().t2c(false);
      }
      if (!booleanEvent.p2e_1)
        return Unit_instance;
      var caret = editor.zlt().qr();
      var text = editor.laz().qr();
      if (!isFirstAllowed(Companion_getInstance_300(), editor) && caret === 0) {
        editor.zlt().t2c(1);
      }
      if (!isLastAllowed(Companion_getInstance_300(), editor) && caret === text.length) {
        editor.zlt().t2c(text.length - 1 | 0);
      }
    }
    TextEditorUtil_instance.imv(cell, prop, event);
    protoOf(CellTrait).qlm.call(this, cell, prop, event);
  };
  protoOf(TextNavigationTrait).mlm = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    // Inline function 'kotlin.text.trim' call
    var this_0 = toString(event.jl1_1);
    // Inline function 'kotlin.text.trim' call
    var this_1 = isCharSequence(this_0) ? this_0 : THROW_CCE();
    var startIndex = 0;
    var endIndex = charSequenceLength(this_1) - 1 | 0;
    var startFound = false;
    $l$loop: while (startIndex <= endIndex) {
      var index = !startFound ? startIndex : endIndex;
      // Inline function 'jetbrains.ocelot.projectional.cell.text.TextNavigationTrait.onKeyTypedLowPriority.<anonymous>' call
      var ch = charSequenceGet(this_1, index);
      var match = Char__compareTo_impl_ypi4mb(ch, _Char___init__impl__6a9atx(32)) <= 0;
      if (!startFound) {
        if (!match)
          startFound = true;
        else
          startIndex = startIndex + 1 | 0;
      } else {
        if (!match)
          break $l$loop;
        else
          endIndex = endIndex - 1 | 0;
      }
    }
    var tmp$ret$1 = charSequenceSubSequence(this_1, startIndex, endIndex + 1 | 0);
    var s = toString_1(tmp$ret$1);
    if (editor.blu() && showCompletion(this, editor, s, Completion_getInstance().em1_1, get_RIGHT_POPUP())) {
      event.ol0();
    } else if (editor.dlu() && showCompletion(this, editor, s, Completion_getInstance().dm1_1, get_LEFT_POPUP())) {
      event.ol0();
    }
    protoOf(CellTrait).mlm.call(this, cell, event);
  };
  protoOf(TextNavigationTrait).alp = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var rt = get_rightPopup(cell) == null && editor.blu() && valueIsSet(cell, Completion_getInstance().em1_1);
    var lt = get_leftPopup(cell) == null && editor.dlu() && valueIsSet(cell, Completion_getInstance().dm1_1);
    var completionResult = Completion_getInstance().dm3(cell, Companion_getInstance_281().qm1_1);
    if (get_isReady(completionResult) && CompletionItems_init_$Create$(completionResult).np()) {
      if (rt && showSideCompletion(this, editor, Completion_getInstance().em1_1, get_RIGHT_POPUP())) {
        event.ol0();
        return Unit_instance;
      }
      if (lt && showSideCompletion(this, editor, Completion_getInstance().dm1_1, get_LEFT_POPUP())) {
        event.ol0();
        return Unit_instance;
      }
    }
    protoOf(CellTrait).alp.call(this, cell, event);
  };
  protoOf(TextNavigationTrait).klo = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var word = getWordAtCaret(this, editor);
    if (word.p()) {
      protoOf(CellTrait).klo.call(this, cell, event);
    } else {
      editorSelect(this, editor, word);
    }
  };
  protoOf(TextNavigationTrait).llo = function (cell, event) {
    if (!event.tl3_1.equals(MouseButton_LEFT_getInstance()) || !cell.hlp().m2c())
      return Unit_instance;
    var from = ensureNotNull(cell.llk()).rlp().qr();
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var pos = getPosAt(this, editor, event);
    if (pos === -1) {
      return Unit_instance;
    }
    if (event.ul3_1.zl1_1) {
      if (!(from === cell)) {
        return Unit_instance;
      }
      handleShiftMousePressed(this, editor, pos);
    } else {
      handleMousePressed(this, editor, pos);
    }
    editor.ul5();
    event.ol0();
    cell.mlp(new FocusEvent(from, cell), Cells_getInstance().jmg_1);
  };
  protoOf(TextNavigationTrait).olo = function (cell, event) {
    if (!event.tl3_1.equals(MouseButton_LEFT_getInstance()) || !cell.hlp().m2c())
      return Unit_instance;
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    var pos = getPosAt(this, editor, event);
    if (pos === -1) {
      return Unit_instance;
    }
    editor.zlt().t2c(pos);
    editor.nlu().t2c(true);
    editor.ul5();
    event.ql0();
  };
  protoOf(TextNavigationTrait).flo = function (cell, spec) {
    var specMatcher = specMatcherValue(TextEditing_getInstance().ylw_1, true);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.text.TextNavigationTrait.get.<anonymous>' call
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    } else {
      tmp = result.sma_1;
    }
    return tmp;
  };
  function handle_0($this, cell, runnable) {
    var disposable = cell.ylp(Companion_getInstance_301().xmt_1, true);
    try {
      runnable();
    }finally {
      disposable.vr();
      validate_1($this, cell);
    }
  }
  function validate_1($this, cell) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    if (isValid_0($this, editor)) {
      cell.ulp(Companion_getInstance_301().wmt_1).vr();
    } else if (!InputMethodEditorUtil_getInstance().zms(editor)) {
      var text = editor.laz().qr();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(text) > 0) {
        cell.ulp(Companion_getInstance_301().wmt_1).vr();
        var removeError = {_v: null};
        var tmp = Companion_getInstance_301().wmt_1;
        var tmp_0 = MessageController_getInstance().zmm(cell, "Invalid '" + text + "'");
        // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
        var tmp$ret$1 = new ValidTextEditingTrait$validate$$inlined$toDisposable$1(removeError);
        var disposable = cell.ylp(tmp, tmp_0.sr(tmp$ret$1));
        removeError._v = disposable;
      }
    }
  }
  function onAfterTextAdded($this, editor, cp, sideTransformationsAllowed) {
    var eagerCompletion = editor.ulp(TextEditing_getInstance().ilx_1);
    if (!eagerCompletion && isValid_0($this, editor))
      return false;
    var text = editor.laz().qr();
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0)
      return false;
    var action = ValidTextEditingTrait$onAfterTextAdded$lambda(text, eagerCompletion, editor, sideTransformationsAllowed, $this);
    var completionResult = Completion_getInstance().dm3(editor, cp);
    var tmp;
    if (get_isReady(completionResult)) {
      tmp = action(CompletionItems_init_$Create$(completionResult));
    } else {
      var savedState = new TextCellStateBeforeCompletion(editor);
      var tmp_0 = AsyncCompletionSupport_getInstance();
      tmp_0.um0(editor, completionResult, ValidTextEditingTrait$onAfterTextAdded$slambda_0($this, editor, savedState, action, null));
      tmp = true;
    }
    return tmp;
  }
  function getValidator($this, editor) {
    return editor.ulp(Companion_getInstance_301().vmt_1);
  }
  function isValid_0($this, editor) {
    var tmp0_safe_receiver = getValidator($this, editor);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(editor.laz().qr());
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  }
  function assertValid_1($this, cell) {
    if (cell instanceof TextCell) {
      var validator = getValidator($this, cell);
      // Inline function 'kotlin.check' call
      if (!(validator == null || validator(cell.laz().qr()))) {
        // Inline function 'jetbrains.ocelot.projectional.cell.text.ValidTextEditingTrait.assertValid.<anonymous>' call
        var message = 'Completion should lead to a valid result, otherwise we might have a stack overflow error; cell: ' + cell.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function Companion_301() {
    Companion_instance_301 = this;
    this.vmt_1 = CellTraitPropertySpec_init_$Create$('validator', null);
    this.wmt_1 = CellTraitPropertySpec_init_$Create$('validationError', Companion_getInstance_25().wr_1);
    this.xmt_1 = CellTraitPropertySpec_init_$Create$('inHandler', false);
  }
  var Companion_instance_301;
  function Companion_getInstance_301() {
    if (Companion_instance_301 == null)
      new Companion_301();
    return Companion_instance_301;
  }
  function ValidTextEditingTrait$onKeyPressed$lambda(this$0, $cell, $event) {
    return function () {
      protoOf(TextEditingTrait).llm.call(this$0, $cell, $event);
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$onKeyTyped$lambda(this$0, $cell, $event) {
    return function () {
      protoOf(TextEditingTrait).jll.call(this$0, $cell, $event);
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$onPaste$lambda(this$0, $cell, $event) {
    return function () {
      protoOf(TextEditingTrait).zlo.call(this$0, $cell, $event);
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$onCut$lambda(this$0, $cell, $event) {
    return function () {
      protoOf(TextEditingTrait).ylo.call(this$0, $cell, $event);
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$validate$$inlined$toDisposable$1($removeError) {
    this.mmv_1 = $removeError;
  }
  protoOf(ValidTextEditingTrait$validate$$inlined$toDisposable$1).vr = function () {
    ensureNotNull(this.mmv_1._v).vr();
    return Unit_instance;
  };
  function ValidTextEditingTrait$onAfterTextAdded$lambda$lambda($completion, $text) {
    return function () {
      $completion.pmc($text);
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$onAfterTextAdded$lambda$lambda_0($match, $prefix, this$0, $container, $editor, $suffix) {
    return function () {
      $match.wm9($prefix)();
      assertValid_1(this$0, $container.rlp().qr());
      var propagate = $editor.ulp(TextEditing_getInstance().klx_1)($match, $suffix);
      var tmp;
      if (propagate) {
        $container.ll5(KeyEvent_init_$Create$(Key_UNKNOWN_getInstance(), charSequenceGet($suffix, 0)));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$onAfterTextAdded$lambda($text, $eagerCompletion, $editor, $sideTransformationsAllowed, this$0) {
    return function (completion) {
      var tmp;
      if (completion.vma($text, $eagerCompletion)) {
        var tmp_0 = ensureNotNull($editor.llk());
        tmp_0.hm9(ValidTextEditingTrait$onAfterTextAdded$lambda$lambda(completion, $text));
        return true;
      }
      var completed = false;
      var tmp_1;
      if ($sideTransformationsAllowed) {
        var tmp_2;
        if ($editor.blu() && !completion.qmc($text)) {
          var prefix = take_1($text, $text.length - 1 | 0);
          var tmp0 = $text;
          // Inline function 'kotlin.text.substring' call
          var startIndex = $text.length - 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          var suffix = tmp0.substring(startIndex);
          var tmp_3;
          if (ensureNotNull(getValidator(this$0, $editor))(prefix)) {
            var tmp_4 = Side_RIGHT_getInstance();
            // Inline function 'kotlin.text.trim' call
            // Inline function 'kotlin.text.trim' call
            var this_0 = isCharSequence(suffix) ? suffix : THROW_CCE();
            var startIndex_0 = 0;
            var endIndex = charSequenceLength(this_0) - 1 | 0;
            var startFound = false;
            $l$loop: while (startIndex_0 <= endIndex) {
              var index = !startFound ? startIndex_0 : endIndex;
              // Inline function 'jetbrains.ocelot.projectional.cell.text.ValidTextEditingTrait.onAfterTextAdded.<anonymous>.<anonymous>' call
              var it = charSequenceGet(this_0, index);
              var match = Char__compareTo_impl_ypi4mb(it, _Char___init__impl__6a9atx(32)) <= 0;
              if (!startFound) {
                if (!match)
                  startFound = true;
                else
                  startIndex_0 = startIndex_0 + 1 | 0;
              } else {
                if (!match)
                  break $l$loop;
                else
                  endIndex = endIndex - 1 | 0;
              }
            }
            var tmp$ret$3 = charSequenceSubSequence(this_0, startIndex_0, endIndex + 1 | 0);
            var tmp$ret$4 = toString_1(tmp$ret$3);
            completed = tmp_4.mmc($editor, prefix, tmp$ret$4, $eagerCompletion);
            tmp_3 = Unit_instance;
          } else {
            var eager = $editor.ulp(TextEditing_getInstance().jlx_1)(suffix);
            var tmp_5;
            if (completion.vma(prefix, eager)) {
              var container = $editor.llk();
              var match_0 = completion.uma(prefix).q(0);
              var tmp_6 = ensureNotNull(container);
              tmp_6.hm9(ValidTextEditingTrait$onAfterTextAdded$lambda$lambda_0(match_0, prefix, this$0, container, $editor, suffix));
              tmp_5 = Unit_instance;
            }
            tmp_3 = tmp_5;
          }
          tmp_2 = tmp_3;
        } else if ($editor.zlt().qr() === 1 && (!Completion_getInstance().bm3($editor) || (Completion_getInstance().bm3($editor) && !Completion_getInstance().am3($editor).sm2()))) {
          // Inline function 'kotlin.text.trim' call
          var this_1 = take_1($text, 1);
          // Inline function 'kotlin.text.trim' call
          var this_2 = isCharSequence(this_1) ? this_1 : THROW_CCE();
          var startIndex_1 = 0;
          var endIndex_0 = charSequenceLength(this_2) - 1 | 0;
          var startFound_0 = false;
          $l$loop_0: while (startIndex_1 <= endIndex_0) {
            var index_0 = !startFound_0 ? startIndex_1 : endIndex_0;
            // Inline function 'jetbrains.ocelot.projectional.cell.text.ValidTextEditingTrait.onAfterTextAdded.<anonymous>.<anonymous>' call
            var it_0 = charSequenceGet(this_2, index_0);
            var match_1 = Char__compareTo_impl_ypi4mb(it_0, _Char___init__impl__6a9atx(32)) <= 0;
            if (!startFound_0) {
              if (!match_1)
                startFound_0 = true;
              else
                startIndex_1 = startIndex_1 + 1 | 0;
            } else {
              if (!match_1)
                break $l$loop_0;
              else
                endIndex_0 = endIndex_0 - 1 | 0;
            }
          }
          var tmp$ret$6 = charSequenceSubSequence(this_2, startIndex_1, endIndex_0 + 1 | 0);
          var prefix_0 = toString_1(tmp$ret$6);
          // Inline function 'kotlin.text.substring' call
          // Inline function 'kotlin.js.asDynamic' call
          var suffix_0 = $text.substring(1);
          var tmp_7;
          if (ensureNotNull(getValidator(this$0, $editor))(suffix_0)) {
            completed = Side_LEFT_getInstance().mmc($editor, suffix_0, prefix_0, $eagerCompletion);
            var tmp_8;
            if (completed && Completion_getInstance().bm3($editor)) {
              Completion_getInstance().am3($editor).iko();
              tmp_8 = Unit_instance;
            }
            tmp_7 = tmp_8;
          }
          tmp_2 = tmp_7;
        }
        tmp_1 = tmp_2;
      }
      return completed;
    };
  }
  function ValidTextEditingTrait$onAfterTextAdded$slambda(this$0, $editor, $savedState, $action, resultContinuation) {
    this.vmv_1 = this$0;
    this.wmv_1 = $editor;
    this.xmv_1 = $savedState;
    this.ymv_1 = $action;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ValidTextEditingTrait$onAfterTextAdded$slambda).amw = function (it, $completion) {
    var tmp = this.bmw(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ValidTextEditingTrait$onAfterTextAdded$slambda).oa = function (p1, $completion) {
    return this.amw(p1 instanceof CompletionItems ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ValidTextEditingTrait$onAfterTextAdded$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          if (this.vmv_1.amb(this.wmv_1, this.xmv_1)) {
            this.ymv_1(this.zmv_1);
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ValidTextEditingTrait$onAfterTextAdded$slambda).bmw = function (it, completion) {
    var i = new ValidTextEditingTrait$onAfterTextAdded$slambda(this.vmv_1, this.wmv_1, this.xmv_1, this.ymv_1, completion);
    i.zmv_1 = it;
    return i;
  };
  function ValidTextEditingTrait$onAfterTextAdded$slambda_0(this$0, $editor, $savedState, $action, resultContinuation) {
    var i = new ValidTextEditingTrait$onAfterTextAdded$slambda(this$0, $editor, $savedState, $action, resultContinuation);
    var l = function (it, $completion) {
      return i.amw(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ValidTextEditingTrait$get$lambda$lambda(this$0, $cell) {
    return function () {
      validate_1(this$0, $cell);
      return Unit_instance;
    };
  }
  function ValidTextEditingTrait$get$lambda($spec, this$0, $cell) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        // Inline function 'jetbrains.ocelot.projectional.cell.text.ValidTextEditingTrait.get.<anonymous>' call
        var tmp$ret$0 = ValidTextEditingTrait$get$lambda$lambda(this$0, $cell);
        tmp = new SpecMatchResult(tmp$ret$0);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function ValidTextEditingTrait$get$lambda_0($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function ValidTextEditingTrait() {
    Companion_getInstance_301();
    TextEditingTrait.call(this);
  }
  protoOf(ValidTextEditingTrait).glo = function (cell) {
    protoOf(TextEditingTrait).glo.call(this, cell);
    validate_1(this, cell);
    assertFocusable(cell);
  };
  protoOf(ValidTextEditingTrait).llm = function (cell, event) {
    var editor = cell instanceof TextCell ? cell : THROW_CCE();
    if (event.ml1(Key_ENTER_getInstance(), []) && !editor.np() && !isValid_0(this, editor)) {
      var completionSupplier = cell.ulp(Completion_getInstance().cm1_1);
      if (!(completionSupplier === Completion_getInstance().cm1_1.ulm(cell))) {
        var completionResult = completionSupplier.um1(Companion_getInstance_281().qm1_1);
        if (get_isReady(completionResult)) {
          var completionItems = CompletionItems_init_$Create$(completionResult);
          var prefixText = editor.ylt();
          if (completionItems.vma(prefixText, true)) {
            completionItems.pmc(prefixText);
          }
        }
        event.ol0();
        return Unit_instance;
      }
    }
    var key = event.x();
    if (key.equals(Key_BACKSPACE_getInstance()) || key.equals(Key_DELETE_getInstance())) {
      handle_0(this, cell, ValidTextEditingTrait$onKeyPressed$lambda(this, cell, event));
      return Unit_instance;
    }
    protoOf(TextEditingTrait).llm.call(this, cell, event);
  };
  protoOf(ValidTextEditingTrait).jll = function (cell, event) {
    handle_0(this, cell, ValidTextEditingTrait$onKeyTyped$lambda(this, cell, event));
  };
  protoOf(ValidTextEditingTrait).zlo = function (cell, event) {
    handle_0(this, cell, ValidTextEditingTrait$onPaste$lambda(this, cell, event));
  };
  protoOf(ValidTextEditingTrait).ylo = function (cell, event) {
    handle_0(this, cell, ValidTextEditingTrait$onCut$lambda(this, cell, event));
  };
  protoOf(ValidTextEditingTrait).xma = function (editor) {
    return !isValid_0(this, editor);
  };
  protoOf(ValidTextEditingTrait).qlm = function (cell, prop, event) {
    if (prop === Companion_getInstance_271().als_1 && !cell.ulp(Companion_getInstance_301().xmt_1)) {
      validate_1(this, cell);
    }
    protoOf(TextEditingTrait).qlm.call(this, cell, prop, event);
  };
  protoOf(ValidTextEditingTrait).tma = function (editor, typed) {
    if (protoOf(TextEditingTrait).tma.call(this, editor, typed))
      return true;
    var afterTextAdded = onAfterTextAdded(this, editor, Companion_getInstance_281().qm1_1, true);
    if (!afterTextAdded) {
      editor.ulp(ValidTextEditingTraitSpecs_getInstance().cmw_1)(new Char(typed));
    }
    return afterTextAdded;
  };
  protoOf(ValidTextEditingTrait).yma = function (editor) {
    var tmp;
    if (protoOf(TextEditingTrait).yma.call(this, editor)) {
      tmp = true;
    } else {
      tmp = onAfterTextAdded(this, editor, Companion_getInstance_281().sm1_1, false);
    }
    return tmp;
  };
  protoOf(ValidTextEditingTrait).zma = function (editor) {
    if (protoOf(TextEditingTrait).zma.call(this, editor)) {
      return true;
    }
    if (editor.yt() == null)
      return true;
    if (!editor.ulp(TextEditing_getInstance().ilx_1))
      return true;
    if (isValid_0(this, editor))
      return true;
    var text = editor.laz().qr();
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0)
      return true;
    var completionResult = editor.ulp(Completion_getInstance().cm1_1).um1(Companion_getInstance_281().qm1_1);
    if (get_isReady(completionResult)) {
      var completion = CompletionItems_init_$Create$(completionResult);
      if (completion.vma(text, true)) {
        completion.pmc(text);
      }
    }
    return true;
  };
  protoOf(ValidTextEditingTrait).flo = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec_0 = TextEditing_getInstance().mlx_1;
    var tmp$ret$0 = ValidTextEditingTrait$get$lambda(spec_0, this, cell);
    var matchers = listOf_0([tmp$ret$0, specMatcherValue(Companion_getInstance_305().zmt_1, get_STATE_HANDLER_WITH_VALID())]);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var tmp = asSequence_0(matchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, ValidTextEditingTrait$get$lambda_0(spec))));
    var tmp_0;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.text.ValidTextEditingTrait.get.<anonymous>' call
      tmp_0 = protoOf(TextEditingTrait).flo.call(this, cell, spec);
    } else {
      tmp_0 = result.sma_1;
    }
    return tmp_0;
  };
  function ValidTextEditingTraitSpecs$AFTER_TYPE_TEXT_NOT_ADDED_HANDLER$lambda(_unused_var__etf5q3) {
    return Unit_instance;
  }
  function ValidTextEditingTraitSpecs() {
    ValidTextEditingTraitSpecs_instance = this;
    var tmp = this;
    tmp.cmw_1 = CellTraitPropertySpec_init_$Create$('afterTypeTextNotAddedHandler', ValidTextEditingTraitSpecs$AFTER_TYPE_TEXT_NOT_ADDED_HANDLER$lambda);
  }
  var ValidTextEditingTraitSpecs_instance;
  function ValidTextEditingTraitSpecs_getInstance() {
    if (ValidTextEditingTraitSpecs_instance == null)
      new ValidTextEditingTraitSpecs();
    return ValidTextEditingTraitSpecs_instance;
  }
  function BaseDerivedCellTrait(base) {
    DerivedCellTrait.call(this);
    this.pmt_1 = base;
  }
  protoOf(BaseDerivedCellTrait).qmt = function (cell) {
    return this.pmt_1;
  };
  function CellTrait$Companion$EMPTY$1() {
    CellTrait.call(this);
  }
  function Companion_302() {
    Companion_instance_302 = this;
    var tmp = this;
    tmp.dmw_1 = new CellTrait$Companion$EMPTY$1();
    var tmp_0 = this;
    // Inline function 'kotlin.emptyArray' call
    tmp_0.emw_1 = [];
  }
  var Companion_instance_302;
  function Companion_getInstance_302() {
    if (Companion_instance_302 == null)
      new Companion_302();
    return Companion_instance_302;
  }
  function CellTrait() {
    Companion_getInstance_302();
  }
  protoOf(CellTrait).glo = function (cell) {
  };
  protoOf(CellTrait).uln = function (cell) {
  };
  protoOf(CellTrait).ylm = function (cell) {
  };
  protoOf(CellTrait).zlm = function (cell, root) {
  };
  protoOf(CellTrait).qlm = function (cell, prop, event) {
  };
  protoOf(CellTrait).hlo = function (cell, event) {
  };
  protoOf(CellTrait).ilo = function (cell, event) {
  };
  protoOf(CellTrait).jlo = function (cell, event) {
  };
  protoOf(CellTrait).klo = function (cell, event) {
  };
  protoOf(CellTrait).llo = function (cell, event) {
  };
  protoOf(CellTrait).mlo = function (cell, event) {
  };
  protoOf(CellTrait).nlo = function (cell, event) {
  };
  protoOf(CellTrait).olo = function (cell, event) {
  };
  protoOf(CellTrait).plo = function (cell, event) {
  };
  protoOf(CellTrait).qlo = function (cell, event) {
  };
  protoOf(CellTrait).rlo = function (cell, event) {
  };
  protoOf(CellTrait).slo = function (cell, event) {
  };
  protoOf(CellTrait).tlo = function (cell, event) {
  };
  protoOf(CellTrait).ulo = function (cell, event) {
  };
  protoOf(CellTrait).vlo = function (cell, event) {
  };
  protoOf(CellTrait).wlo = function (cell, event) {
  };
  protoOf(CellTrait).llm = function (cell, event) {
  };
  protoOf(CellTrait).olm = function (cell, event) {
  };
  protoOf(CellTrait).kll = function (cell, event) {
  };
  protoOf(CellTrait).nlm = function (cell, event) {
  };
  protoOf(CellTrait).jll = function (cell, event) {
  };
  protoOf(CellTrait).mlm = function (cell, event) {
  };
  protoOf(CellTrait).xlo = function (cell, event) {
  };
  protoOf(CellTrait).ylo = function (cell, event) {
  };
  protoOf(CellTrait).zlo = function (cell, event) {
  };
  protoOf(CellTrait).alp = function (cell, event) {
  };
  protoOf(CellTrait).blp = function (cell, event) {
  };
  protoOf(CellTrait).clp = function (cell, event) {
  };
  protoOf(CellTrait).dlp = function (cell, event) {
  };
  protoOf(CellTrait).bll = function (cell, spec, event) {
  };
  protoOf(CellTrait).flo = function (cell, spec) {
    return null;
  };
  function CellTraitEventSpec(name, isBubbling) {
    isBubbling = isBubbling === VOID ? true : isBubbling;
    this.cll_1 = name;
    this.dll_1 = isBubbling;
  }
  protoOf(CellTraitEventSpec).toString = function () {
    return this.cll_1;
  };
  function CellTraitPropertySpec_init_$Init$(name, defaultValue, $this) {
    CellTraitPropertySpec.call($this, name, CellTraitPropertySpec$_init_$lambda_v3qcup(defaultValue));
    return $this;
  }
  function CellTraitPropertySpec_init_$Create$(name, defaultValue) {
    return CellTraitPropertySpec_init_$Init$(name, defaultValue, objectCreate(protoOf(CellTraitPropertySpec)));
  }
  function CellTraitPropertySpec$_init_$lambda_v3qcup($defaultValue) {
    return function (it) {
      return $defaultValue;
    };
  }
  function CellTraitPropertySpec(name, defaultValueSupplier) {
    this.wlp_1 = name;
    this.xlp_1 = defaultValueSupplier;
  }
  protoOf(CellTraitPropertySpec).ulm = function (cell) {
    return this.xlp_1(cell);
  };
  protoOf(CellTraitPropertySpec).toString = function () {
    return this.wlp_1;
  };
  function valueIsSet(_this__u8e3s4, spec) {
    return !(_this__u8e3s4.ulp(spec) === spec.ulm(_this__u8e3s4));
  }
  function CellTraits$captureTo$rootReg$1($targetReg, $targetTrait) {
    this.fmw_1 = $targetReg;
    this.gmw_1 = $targetTrait;
    CellTrait.call(this);
  }
  protoOf(CellTraits$captureTo$rootReg$1).hlo = function (cell, event) {
    protoOf(CellTrait).hlo.call(this, cell, event);
    this.fmw_1._v.vr();
    this.fmw_1._v = ensureNotNull(event.cmh_1).olp(this.gmw_1);
  };
  protoOf(CellTraits$captureTo$rootReg$1).ilo = function (cell, event) {
    this.fmw_1._v.vr();
    this.fmw_1._v = Companion_getInstance_25().wr_1;
    protoOf(CellTrait).ilo.call(this, cell, event);
  };
  function CellTraits$captureTo$$inlined$toDisposable$1($targetReg, $rootReg) {
    this.hmw_1 = $targetReg;
    this.imw_1 = $rootReg;
  }
  protoOf(CellTraits$captureTo$$inlined$toDisposable$1).vr = function () {
    this.hmw_1._v.vr();
    this.imw_1.vr();
    return Unit_instance;
  };
  function CellTraits$propWithDefaultInRoot$lambda($defaultValue, $holder) {
    return function (cell) {
      var tmp;
      if (!cell.qlc()) {
        tmp = $defaultValue;
      } else {
        var root = ensureNotNull(cell.llk()).u3o();
        var tmp_0;
        if (cell === root) {
          tmp_0 = $defaultValue;
        } else {
          tmp_0 = root.ulp(ensureNotNull($holder._v));
        }
        tmp = tmp_0;
      }
      return tmp;
    };
  }
  function CellTraits() {
  }
  protoOf(CellTraits).jmw = function (root, targetTrait) {
    var targetReg = {_v: Companion_getInstance_25().wr_1};
    if (isDescendantCellFocused(root)) {
      var container = ensureNotNull(root.llk());
      var focusedCell = ensureNotNull(container.rlp().qr());
      targetReg._v = focusedCell.olp(targetTrait);
    }
    var rootReg = root.olp(new CellTraits$captureTo$rootReg$1(targetReg, targetTrait));
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new CellTraits$captureTo$$inlined$toDisposable$1(targetReg, rootReg);
  };
  protoOf(CellTraits).ym2 = function (name) {
    return this.zm2(name, null);
  };
  protoOf(CellTraits).zm2 = function (name, defaultValue) {
    var holder = {_v: null};
    var spec = new CellTraitPropertySpec(name, CellTraits$propWithDefaultInRoot$lambda(defaultValue, holder));
    holder._v = spec;
    return holder._v;
  };
  var CellTraits_instance;
  function CellTraits_getInstance() {
    return CellTraits_instance;
  }
  function CompositeCellTrait() {
    CellTrait.call(this);
  }
  protoOf(CompositeCellTrait).glo = function (cell) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onAdd.<anonymous>' call
      trait.glo(cell);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).uln = function (cell) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onRemove.<anonymous>' call
      trait.uln(cell);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).ylm = function (cell) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onAfterAttach.<anonymous>' call
      trait.ylm(cell);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).zlm = function (cell, root) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onBeforeDetach.<anonymous>' call
      trait.zlm(cell, root);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).qlm = function (cell, prop, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onPropertyChanged.<anonymous>' call
      trait.qlm(cell, prop, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).hlo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onFocusGained.<anonymous>' call
      trait.hlo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).ilo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onFocusLost.<anonymous>' call
      trait.ilo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).jlo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onMouseClicked.<anonymous>' call
      trait.jlo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).klo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onMouseDoubleClicked.<anonymous>' call
      trait.klo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).llo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onMousePressed.<anonymous>' call
      trait.llo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).mlo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onMouseReleased.<anonymous>' call
      trait.mlo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).nlo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onMouseMoved.<anonymous>' call
      trait.nlo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).olo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onMouseDragged.<anonymous>' call
      trait.olo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).plo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onMouseEntered.<anonymous>' call
      trait.plo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).qlo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onMouseLeft.<anonymous>' call
      trait.qlo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).rlo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onTouchStarted.<anonymous>' call
      trait.rlo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).slo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onTouchLongTapped.<anonymous>' call
      trait.slo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).tlo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onTouchMoved.<anonymous>' call
      trait.tlo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).ulo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onTouchDragged.<anonymous>' call
      trait.ulo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).vlo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onTouchEnded.<anonymous>' call
      trait.vlo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).wlo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onPopupRequested.<anonymous>' call
      trait.wlo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).llm = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onKeyPressed.<anonymous>' call
      trait.llm(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).olm = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onKeyPressedLowPriority.<anonymous>' call
      trait.olm(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).kll = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onKeyReleased.<anonymous>' call
      trait.kll(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).nlm = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onKeyReleasedLowPriority.<anonymous>' call
      trait.nlm(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).jll = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onKeyTyped.<anonymous>' call
      trait.jll(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).mlm = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onKeyTypedLowPriority.<anonymous>' call
      trait.mlm(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).xlo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onCopy.<anonymous>' call
      trait.xlo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).ylo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onCut.<anonymous>' call
      trait.ylo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).zlo = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onPaste.<anonymous>' call
      trait.zlo(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).alp = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onComplete.<anonymous>' call
      trait.alp(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).blp = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onCompositionStarted.<anonymous>' call
      trait.blp(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).clp = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onCompositionUpdated.<anonymous>' call
      trait.clp(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).dlp = function (cell, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onCompositionEnded.<anonymous>' call
      trait.dlp(cell, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).bll = function (cell, spec, event) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    $l$loop: while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (event.ml0_1) {
        break $l$loop;
      }
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.CompositeCellTrait.onCellTraitEvent.<anonymous>' call
      trait.bll(cell, spec, event);
    }
    return Unit_instance;
  };
  protoOf(CompositeCellTrait).flo = function (cell, spec) {
    var indexedObject = this.wma(cell);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var trait = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var result = trait.flo(cell, spec);
      if (!(result == null)) {
        return result;
      }
    }
    return null;
  };
  function CompositeCellTraits$forConstant$1($base) {
    this.kmw_1 = $base;
    CompositeCellTrait.call(this);
  }
  protoOf(CompositeCellTraits$forConstant$1).wma = function (cell) {
    return this.kmw_1;
  };
  function CompositeCellTraits() {
  }
  protoOf(CompositeCellTraits).emu = function (base) {
    return new CompositeCellTraits$forConstant$1(base);
  };
  var CompositeCellTraits_instance;
  function CompositeCellTraits_getInstance() {
    return CompositeCellTraits_instance;
  }
  function DerivedCellTrait() {
    CellTrait.call(this);
  }
  protoOf(DerivedCellTrait).glo = function (cell) {
    return this.qmt(cell).glo(cell);
  };
  protoOf(DerivedCellTrait).uln = function (cell) {
    return this.qmt(cell).uln(cell);
  };
  protoOf(DerivedCellTrait).ylm = function (cell) {
    return this.qmt(cell).ylm(cell);
  };
  protoOf(DerivedCellTrait).zlm = function (cell, root) {
    return this.qmt(cell).zlm(cell, root);
  };
  protoOf(DerivedCellTrait).qlm = function (cell, prop, event) {
    this.qmt(cell).qlm(cell, prop, event);
  };
  protoOf(DerivedCellTrait).hlo = function (cell, event) {
    return this.qmt(cell).hlo(cell, event);
  };
  protoOf(DerivedCellTrait).ilo = function (cell, event) {
    return this.qmt(cell).ilo(cell, event);
  };
  protoOf(DerivedCellTrait).jlo = function (cell, event) {
    this.qmt(cell).jlo(cell, event);
  };
  protoOf(DerivedCellTrait).klo = function (cell, event) {
    this.qmt(cell).klo(cell, event);
  };
  protoOf(DerivedCellTrait).rlo = function (cell, event) {
    this.qmt(cell).rlo(cell, event);
  };
  protoOf(DerivedCellTrait).slo = function (cell, event) {
    this.qmt(cell).slo(cell, event);
  };
  protoOf(DerivedCellTrait).tlo = function (cell, event) {
    this.qmt(cell).tlo(cell, event);
  };
  protoOf(DerivedCellTrait).ulo = function (cell, event) {
    this.qmt(cell).ulo(cell, event);
  };
  protoOf(DerivedCellTrait).vlo = function (cell, event) {
    this.qmt(cell).vlo(cell, event);
  };
  protoOf(DerivedCellTrait).llo = function (cell, event) {
    this.qmt(cell).llo(cell, event);
  };
  protoOf(DerivedCellTrait).mlo = function (cell, event) {
    this.qmt(cell).mlo(cell, event);
  };
  protoOf(DerivedCellTrait).nlo = function (cell, event) {
    this.qmt(cell).nlo(cell, event);
  };
  protoOf(DerivedCellTrait).olo = function (cell, event) {
    this.qmt(cell).olo(cell, event);
  };
  protoOf(DerivedCellTrait).plo = function (cell, event) {
    this.qmt(cell).plo(cell, event);
  };
  protoOf(DerivedCellTrait).qlo = function (cell, event) {
    this.qmt(cell).qlo(cell, event);
  };
  protoOf(DerivedCellTrait).wlo = function (cell, event) {
    this.qmt(cell).wlo(cell, event);
  };
  protoOf(DerivedCellTrait).llm = function (cell, event) {
    this.qmt(cell).llm(cell, event);
  };
  protoOf(DerivedCellTrait).olm = function (cell, event) {
    this.qmt(cell).olm(cell, event);
  };
  protoOf(DerivedCellTrait).kll = function (cell, event) {
    this.qmt(cell).kll(cell, event);
  };
  protoOf(DerivedCellTrait).nlm = function (cell, event) {
    this.qmt(cell).nlm(cell, event);
  };
  protoOf(DerivedCellTrait).jll = function (cell, event) {
    this.qmt(cell).jll(cell, event);
  };
  protoOf(DerivedCellTrait).mlm = function (cell, event) {
    this.qmt(cell).mlm(cell, event);
  };
  protoOf(DerivedCellTrait).xlo = function (cell, event) {
    this.qmt(cell).xlo(cell, event);
  };
  protoOf(DerivedCellTrait).ylo = function (cell, event) {
    this.qmt(cell).ylo(cell, event);
  };
  protoOf(DerivedCellTrait).zlo = function (cell, event) {
    this.qmt(cell).zlo(cell, event);
  };
  protoOf(DerivedCellTrait).alp = function (cell, event) {
    this.qmt(cell).alp(cell, event);
  };
  protoOf(DerivedCellTrait).blp = function (cell, event) {
    this.qmt(cell).blp(cell, event);
  };
  protoOf(DerivedCellTrait).clp = function (cell, event) {
    this.qmt(cell).clp(cell, event);
  };
  protoOf(DerivedCellTrait).dlp = function (cell, event) {
    this.qmt(cell).dlp(cell, event);
  };
  protoOf(DerivedCellTrait).bll = function (cell, spec, event) {
    this.qmt(cell).bll(cell, spec, event);
  };
  protoOf(DerivedCellTrait).flo = function (cell, spec) {
    return this.qmt(cell).flo(cell, spec);
  };
  function SpecMatchResult(value) {
    this.sma_1 = value;
  }
  function specMatcherValue(spec, value) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    return specMatcherValue$lambda(spec, value);
  }
  function specMatcherValue$lambda($spec, $value) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcherValue.<anonymous>' call
        var tmp$ret$0 = $value;
        tmp = new SpecMatchResult(tmp$ret$0);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function handleChildAdd_0($this, item) {
    $this.lmw(item);
    var _iterator__ex2g4s = item.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      handleChildAdd_0($this, child);
    }
  }
  function handleChildRemove_0($this, item) {
    $this.mmw(item);
    var _iterator__ex2g4s = item.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      handleChildRemove_0($this, child);
    }
  }
  function CellAttachWatcher() {
  }
  protoOf(CellAttachWatcher).nmw = function (container) {
    handleChildAdd_0(this, container.u3o());
  };
  protoOf(CellAttachWatcher).lmw = function (cell) {
  };
  protoOf(CellAttachWatcher).mmw = function (cell) {
  };
  protoOf(CellAttachWatcher).clq = function (parent, change) {
    handleChildAdd_0(this, change.k27());
  };
  protoOf(CellAttachWatcher).dlq = function (parent, change) {
    handleChildRemove_0(this, change.i27());
  };
  protoOf(CellAttachWatcher).blq = function (cell, prop, change) {
    if (isPopupProp(prop)) {
      var oldValue = change.o2e_1;
      if (!(oldValue == null)) {
        handleChildRemove_0(this, (!(oldValue == null) ? isInterface(oldValue, Cell) : false) ? oldValue : THROW_CCE());
      }
      var newValue = change.p2e_1;
      if (!(newValue == null)) {
        handleChildAdd_0(this, (!(newValue == null) ? isInterface(newValue, Cell) : false) ? newValue : THROW_CCE());
      }
    }
  };
  function doInstall($this, container, trait, attachPredicate, detachPredicate) {
    var t = new TraitController(trait, attachPredicate, detachPredicate);
    t.nmw(container);
    return new Pair(container.wmi(t).sr(t), t);
  }
  function TraitController$Companion$NOT_POPUP$lambda(cell) {
    return !inPopup(cell);
  }
  function isRegistered($this, cell) {
    return $this.rmw_1.bs().s(cell);
  }
  function isProcessing($this, cell, processing) {
    return !(processing == null) && processing.s(cell);
  }
  function startAttaching($this, cell) {
    if ($this.smw_1 == null) {
      $this.smw_1 = HashSet_init_$Create$();
    } else if (ensureNotNull($this.smw_1).s(cell)) {
      return false;
    }
    ensureNotNull($this.smw_1).e(cell);
    return true;
  }
  function startDetaching($this, cell) {
    if ($this.tmw_1 == null) {
      $this.tmw_1 = HashSet_init_$Create$();
    } else if (ensureNotNull($this.tmw_1).s(cell)) {
      return false;
    }
    ensureNotNull($this.tmw_1).e(cell);
    return true;
  }
  function endAttaching($this, cell) {
    ensureNotNull($this.smw_1).k2(cell);
    if (ensureNotNull($this.smw_1).p()) {
      $this.smw_1 = null;
    }
  }
  function endDetaching($this, cell) {
    ensureNotNull($this.tmw_1).k2(cell);
    if (ensureNotNull($this.tmw_1).p()) {
      $this.tmw_1 = null;
    }
  }
  function Companion_303() {
    Companion_instance_303 = this;
    var tmp = this;
    tmp.wmm_1 = TraitController$Companion$NOT_POPUP$lambda;
  }
  protoOf(Companion_303).xmm = function (container, trait, attachPredicate, detachPredicate) {
    return doInstall(this, container, trait, attachPredicate, detachPredicate).dh_1;
  };
  var Companion_instance_303;
  function Companion_getInstance_303() {
    if (Companion_instance_303 == null)
      new Companion_303();
    return Companion_instance_303;
  }
  function TraitController(trait, attachPredicate, detachPredicate) {
    Companion_getInstance_303();
    CellAttachWatcher.call(this);
    this.omw_1 = trait;
    this.pmw_1 = attachPredicate;
    this.qmw_1 = detachPredicate;
    this.rmw_1 = new DisposableMap();
    this.smw_1 = null;
    this.tmw_1 = null;
  }
  protoOf(TraitController).lmw = function (cell) {
    if (isRegistered(this, cell) || !this.pmw_1(cell)) {
      return Unit_instance;
    }
    // Inline function 'kotlin.check' call
    if (!!isProcessing(this, cell, this.tmw_1)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.traitController.TraitController.onAttach.<anonymous>' call
      var message = toString_1(cell) + " came into 'attach' state while detaching, trait=" + toString_1(this.omw_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (!startAttaching(this, cell)) {
      return Unit_instance;
    }
    var disposable = cell.olp(this.omw_1);
    endAttaching(this, cell);
    this.rmw_1.zr(cell, disposable);
  };
  protoOf(TraitController).mmw = function (cell) {
    this.rmw_1.as(cell);
  };
  protoOf(TraitController).blq = function (cell, prop, change) {
    protoOf(CellAttachWatcher).blq.call(this, cell, prop, change);
    if (isRegistered(this, cell)) {
      if (this.qmw_1(cell)) {
        // Inline function 'kotlin.check' call
        if (!!isProcessing(this, cell, this.smw_1)) {
          // Inline function 'jetbrains.ocelot.projectional.cell.traitController.TraitController.onCellPropertyChanged.<anonymous>' call
          var message = toString_1(cell) + " came into 'detach' state while attaching, trait=" + toString_1(this.omw_1);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        startDetaching(this, cell);
        this.mmw(cell);
        endDetaching(this, cell);
      }
    } else {
      this.lmw(cell);
    }
  };
  protoOf(TraitController).vr = function () {
    this.rmw_1.m2();
    if (!(this.smw_1 == null)) {
      ensureNotNull(this.smw_1).m2();
      this.smw_1 = null;
    }
    if (!(this.tmw_1 == null)) {
      ensureNotNull(this.tmw_1).m2();
      this.tmw_1 = null;
    }
  };
  function CellFactory() {
  }
  protoOf(CellFactory).ym3 = function (target, cells) {
    addAll_0(target.ilp(), cells);
    return target;
  };
  protoOf(CellFactory).umw = function (cells) {
    var result = new HorizontalCell();
    this.ym3(result, cells.slice());
    return result;
  };
  protoOf(CellFactory).xm3 = function (cells) {
    return this.vmw(false, cells.slice());
  };
  protoOf(CellFactory).vmw = function (indent, cells) {
    var result = new VerticalCell();
    result.olv().t2c(indent);
    this.ym3(result, cells.slice());
    return result;
  };
  protoOf(CellFactory).wmw = function (cells) {
    return this.xmw(false, cells.slice());
  };
  protoOf(CellFactory).xmw = function (indent, cells) {
    return this.ymw(indent, 2, cells.slice());
  };
  protoOf(CellFactory).ymw = function (indent, indentNumSpaces, cells) {
    var result = new IndentCell(indent, indentNumSpaces);
    addAll_0(result.g2r(), cells);
    return result;
  };
  protoOf(CellFactory).elj = function () {
    return new NewLineCell();
  };
  protoOf(CellFactory).zmw = function (text, firstAllowed, lastAllowed, selectionAvailable) {
    var result = TextCell_init_$Create$_0(text);
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0) {
      tmp = (firstAllowed && lastAllowed);
    } else {
      if (text.length === 1) {
        tmp = firstAllowed || lastAllowed;
      } else {
        tmp = true;
      }
    }
    var focusable = tmp;
    if (focusable) {
      result.hlp().t2c(true);
      result.olp(TextEditing_getInstance().cmu(firstAllowed, lastAllowed, selectionAvailable));
    }
    return result;
  };
  protoOf(CellFactory).amx = function (text, firstAllowed, lastAllowed, selectionAvailable, $super) {
    firstAllowed = firstAllowed === VOID ? true : firstAllowed;
    lastAllowed = lastAllowed === VOID ? true : lastAllowed;
    selectionAvailable = selectionAvailable === VOID ? true : selectionAvailable;
    return $super === VOID ? this.zmw(text, firstAllowed, lastAllowed, selectionAvailable) : $super.zmw.call(this, text, firstAllowed, lastAllowed, selectionAvailable);
  };
  protoOf(CellFactory).bmx = function (text) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.amx(text);
    // Inline function 'jetbrains.ocelot.projectional.cell.util.CellFactory.keyword.<anonymous>' call
    this_0.hlu().t2c(Companion_getInstance_325().dlt_1);
    this_0.jlu().t2c(true);
    return this_0;
  };
  protoOf(CellFactory).cmx = function (text) {
    return TextCell_init_$Create$_0(text);
  };
  protoOf(CellFactory).dmx = function () {
    return this.cmx(' ');
  };
  var CellFactory_instance;
  function CellFactory_getInstance() {
    return CellFactory_instance;
  }
  function _CellVisibleTree___init__impl__3mauq3(base) {
    return base;
  }
  function _CellVisibleTree___get_base__impl__vnz5zx($this) {
    return $this;
  }
  function CellVisibleTree__children_impl_ekqq80($this) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = _CellVisibleTree___get_base__impl__vnz5zx($this).g2r();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.cell.util.CellVisibleTree.children.<anonymous>' call
      if (element.elp().m2c()) {
        destination.e(element);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var item = _iterator__ex2g4s_0.m();
      // Inline function 'jetbrains.ocelot.projectional.cell.util.CellVisibleTree.children.<anonymous>' call
      var tmp$ret$3 = new CellVisibleTree(_get_adapted__dk7bw0(item, $this));
      destination_0.e(tmp$ret$3);
    }
    return destination_0;
  }
  function CellVisibleTree__nextSibling_impl_iya9os($this) {
    return nextVisibleSiblingOf($this, _CellVisibleTree___get_base__impl__vnz5zx($this));
  }
  function CellVisibleTree__nextSibling_impl_iya9os_0($this) {
    var tmp = CellVisibleTree__nextSibling_impl_iya9os($this.emx_1);
    return tmp == null ? null : new CellVisibleTree(tmp);
  }
  function CellVisibleTree__prevSibling_impl_lvlxdg($this) {
    return prevVisibleSiblingOf($this, _CellVisibleTree___get_base__impl__vnz5zx($this));
  }
  function CellVisibleTree__prevSibling_impl_lvlxdg_0($this) {
    var tmp = CellVisibleTree__prevSibling_impl_lvlxdg($this.emx_1);
    return tmp == null ? null : new CellVisibleTree(tmp);
  }
  function CellVisibleTree__firstChild_impl_91np0t($this) {
    var tmp0_elvis_lhs = _CellVisibleTree___get_base__impl__vnz5zx($this).q2r();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var realFirst = tmp;
    if (realFirst.elp().m2c())
      return _get_adapted__dk7bw0(realFirst, $this);
    return nextVisibleSiblingOf($this, realFirst);
  }
  function CellVisibleTree__firstChild_impl_91np0t_0($this) {
    var tmp = CellVisibleTree__firstChild_impl_91np0t($this.emx_1);
    return tmp == null ? null : new CellVisibleTree(tmp);
  }
  function CellVisibleTree__lastChild_impl_13kpzp($this) {
    var tmp0_elvis_lhs = _CellVisibleTree___get_base__impl__vnz5zx($this).r2r();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var realLast = tmp;
    if (realLast.elp().m2c())
      return _get_adapted__dk7bw0(realLast, $this);
    return prevVisibleSiblingOf($this, realLast);
  }
  function CellVisibleTree__lastChild_impl_13kpzp_0($this) {
    var tmp = CellVisibleTree__lastChild_impl_13kpzp($this.emx_1);
    return tmp == null ? null : new CellVisibleTree(tmp);
  }
  function nextVisibleSiblingOf($this, cell) {
    var next = cell;
    do {
      var tmp0_safe_receiver = next;
      next = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h2r();
    }
     while (!(next == null) && !next.elp().m2c());
    var tmp1_safe_receiver = next;
    return tmp1_safe_receiver == null ? null : _get_adapted__dk7bw0(tmp1_safe_receiver, $this);
  }
  function prevVisibleSiblingOf($this, cell) {
    var prev = cell;
    do {
      var tmp0_safe_receiver = prev;
      prev = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k2r();
    }
     while (!(prev == null) && !prev.elp().m2c());
    var tmp1_safe_receiver = prev;
    return tmp1_safe_receiver == null ? null : _get_adapted__dk7bw0(tmp1_safe_receiver, $this);
  }
  function _CellVisibleTree___get_parent__impl__cp5b38($this) {
    var tmp0_safe_receiver = _CellVisibleTree___get_base__impl__vnz5zx($this).yt();
    return tmp0_safe_receiver == null ? null : _get_adapted__dk7bw0(tmp0_safe_receiver, $this);
  }
  function CellVisibleTree___get_parent__impl_rdwb1s($this) {
    var tmp = _CellVisibleTree___get_parent__impl__cp5b38($this.emx_1);
    return tmp == null ? null : new CellVisibleTree(tmp);
  }
  function _get_adapted__dk7bw0(_this__u8e3s4, $this) {
    return _CellVisibleTree___init__impl__3mauq3(_this__u8e3s4);
  }
  function CellVisibleTree__toString_impl_pq1dyr($this) {
    return 'CellVisibleTree(base=' + toString_1($this) + ')';
  }
  function CellVisibleTree__hashCode_impl_3yvh5w($this) {
    return hashCode($this);
  }
  function CellVisibleTree__equals_impl_zcmdj4($this, other) {
    if (!(other instanceof CellVisibleTree))
      return false;
    var tmp0_other_with_cast = other instanceof CellVisibleTree ? other.emx_1 : THROW_CCE();
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function CellVisibleTree(base) {
    this.emx_1 = base;
  }
  protoOf(CellVisibleTree).g2r = function () {
    return CellVisibleTree__children_impl_ekqq80(this.emx_1);
  };
  protoOf(CellVisibleTree).fmx = function () {
    return CellVisibleTree__nextSibling_impl_iya9os(this.emx_1);
  };
  protoOf(CellVisibleTree).h2r = function () {
    return CellVisibleTree__nextSibling_impl_iya9os_0(this);
  };
  protoOf(CellVisibleTree).gmx = function () {
    return CellVisibleTree__prevSibling_impl_lvlxdg(this.emx_1);
  };
  protoOf(CellVisibleTree).k2r = function () {
    return CellVisibleTree__prevSibling_impl_lvlxdg_0(this);
  };
  protoOf(CellVisibleTree).hmx = function () {
    return CellVisibleTree__firstChild_impl_91np0t(this.emx_1);
  };
  protoOf(CellVisibleTree).q2r = function () {
    return CellVisibleTree__firstChild_impl_91np0t_0(this);
  };
  protoOf(CellVisibleTree).imx = function () {
    return CellVisibleTree__lastChild_impl_13kpzp(this.emx_1);
  };
  protoOf(CellVisibleTree).r2r = function () {
    return CellVisibleTree__lastChild_impl_13kpzp_0(this);
  };
  protoOf(CellVisibleTree).jmx = function () {
    return _CellVisibleTree___get_parent__impl__cp5b38(this.emx_1);
  };
  protoOf(CellVisibleTree).yt = function () {
    return CellVisibleTree___get_parent__impl_rdwb1s(this);
  };
  protoOf(CellVisibleTree).toString = function () {
    return CellVisibleTree__toString_impl_pq1dyr(this.emx_1);
  };
  protoOf(CellVisibleTree).hashCode = function () {
    return CellVisibleTree__hashCode_impl_3yvh5w(this.emx_1);
  };
  protoOf(CellVisibleTree).equals = function (other) {
    return CellVisibleTree__equals_impl_zcmdj4(this.emx_1, other);
  };
  function get_visibleTree(_this__u8e3s4) {
    var tmp0 = ancestorsFrom(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.all' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.cell.util.<get-visibleTree>.<anonymous>' call
        if (!element.elp().m2c()) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    // Inline function 'kotlin.require' call
    if (!tmp$ret$1) {
      // Inline function 'jetbrains.ocelot.projectional.cell.util.<get-visibleTree>.<anonymous>' call
      var message = 'Base cell must be visible';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return _CellVisibleTree___init__impl__3mauq3(_this__u8e3s4);
  }
  function Cells() {
    Cells_instance = this;
    this.jmg_1 = new CellTraitEventSpec('userNavigation');
    this.kmg_1 = new CellTraitEventSpec('becameEmpty', false);
    this.lmg_1 = CellTraitPropertySpec_init_$Create$('nonChildNodeCell', false);
    this.mmg_1 = CellTraitPropertySpec_init_$Create$('cellAvoidedFromViewState', false);
  }
  protoOf(Cells).kmx = function (cell) {
    var tmp1_elvis_lhs = cell == null ? null : cell.jkb();
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(Cells).mlq = function (current, loc) {
    var isIndent = current instanceof IndentCell;
    if (!isIndent && !get_bounds(current).mku(loc))
      return null;
    if (current instanceof NewLineCell)
      return null;
    var _iterator__ex2g4s = current.g2r().k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      if (!child.elp().m2c())
        continue $l$loop;
      var result = this.mlq(child, loc);
      if (!(result == null)) {
        return result;
      }
    }
    var tmp;
    if (!isIndent && get_bounds(current).mku(loc)) {
      tmp = current;
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(Cells).lmx = function (current, loc, condition) {
    if (!current.elp().m2c()) {
      return null;
    }
    var bounds = get_bounds(current);
    if (loc.fku_1 < bounds.cku_1.fku_1 || loc.fku_1 > (bounds.cku_1.fku_1 + bounds.dku_1.fku_1 | 0)) {
      return null;
    }
    var result = null;
    var distance = 2147483647;
    var _iterator__ex2g4s = current.g2r().k();
    $l$loop_0: while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      if (!child.elp().m2c())
        continue $l$loop_0;
      var tmp0_elvis_lhs = this.lmx(child, loc, condition);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var closest = tmp;
      var newDistance = numberToInt(get_bounds(closest).tku(loc));
      if (newDistance < distance) {
        result = closest;
        distance = newDistance;
      }
    }
    var tmp_0;
    if (result == null && condition(current)) {
      tmp_0 = current;
    } else {
      tmp_0 = result;
    }
    return tmp_0;
  };
  var Cells_instance;
  function Cells_getInstance() {
    if (Cells_instance == null)
      new Cells();
    return Cells_instance;
  }
  function prevVisibleLeaf_0(_this__u8e3s4, within) {
    var tmp = Composites_instance.t2r(new CellVisibleTree(get_visibleTree(_this__u8e3s4)), new CellVisibleTree(get_visibleTree(within)));
    var tmp0_safe_receiver = tmp == null ? null : tmp.emx_1;
    var tmp_0;
    var tmp_1 = tmp0_safe_receiver;
    if ((tmp_1 == null ? null : new CellVisibleTree(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = _CellVisibleTree___get_base__impl__vnz5zx(tmp0_safe_receiver);
    }
    return tmp_0;
  }
  function nextVisibleLeaf_0(_this__u8e3s4, within) {
    var tmp = Composites_instance.s2r(new CellVisibleTree(get_visibleTree(_this__u8e3s4)), new CellVisibleTree(get_visibleTree(within)));
    var tmp0_safe_receiver = tmp == null ? null : tmp.emx_1;
    var tmp_0;
    var tmp_1 = tmp0_safe_receiver;
    if ((tmp_1 == null ? null : new CellVisibleTree(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = _CellVisibleTree___get_base__impl__vnz5zx(tmp0_safe_receiver);
    }
    return tmp_0;
  }
  function prevVisibleLeaves(_this__u8e3s4) {
    var tmp = Composites_instance.v2r(new CellVisibleTree(get_visibleTree(_this__u8e3s4)));
    return map(tmp, prevVisibleLeaves$lambda);
  }
  function whenAttached(_this__u8e3s4, action) {
    var tmp;
    if (_this__u8e3s4.qlc()) {
      action();
      tmp = Companion_getInstance_25().wr_1;
    } else {
      var disposable = {_v: Companion_getInstance_25().wr_1};
      var tmp_0 = _this__u8e3s4.plp();
      var disposableForHandler = tmp_0.p27(whenAttached$lambda(disposable, action));
      disposable._v = disposableForHandler;
      var tmp0_toDisposable_$receiver = disposable._v;
      // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
      tmp = new whenAttached$$inlined$toDisposable$1(tmp0_toDisposable_$receiver);
    }
    return tmp;
  }
  function firstVisibleLeaf(_this__u8e3s4) {
    if (isInvisible(_this__u8e3s4))
      return null;
    var _iterator__ex2g4s = _this__u8e3s4.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var childCell = _iterator__ex2g4s.m();
      var firstVisible = firstVisibleLeaf(childCell);
      if (!(firstVisible == null)) {
        return firstVisible;
      }
    }
    var tmp;
    if (_this__u8e3s4 instanceof IndentCell) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function lastVisibleLeaf(_this__u8e3s4) {
    if (isInvisible(_this__u8e3s4))
      return null;
    var _iterator__ex2g4s = reversed(_this__u8e3s4.g2r()).k();
    while (_iterator__ex2g4s.l()) {
      var childCell = _iterator__ex2g4s.m();
      var lastVisible = lastVisibleLeaf(childCell);
      if (!(lastVisible == null)) {
        return lastVisible;
      }
    }
    var tmp;
    if (_this__u8e3s4 instanceof IndentCell) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function isInvisible(_this__u8e3s4) {
    var tmp;
    if (!_this__u8e3s4.elp().qr()) {
      tmp = true;
    } else {
      tmp = _this__u8e3s4 instanceof NewLineCell;
    }
    return tmp;
  }
  function prevVisibleLeaves$lambda(it) {
    return _CellVisibleTree___get_base__impl__vnz5zx(it.emx_1);
  }
  function whenAttached$lambda($disposable, $action) {
    return function (event) {
      var container = event.p2e_1;
      var tmp;
      if (!(container == null)) {
        $disposable._v.vr();
        $disposable._v = Companion_getInstance_25().wr_1;
        tmp = $action();
      }
      return Unit_instance;
    };
  }
  function whenAttached$$inlined$toDisposable$1($tmp0_toDisposable_$receiver) {
    this.mmx_1 = $tmp0_toDisposable_$receiver;
  }
  protoOf(whenAttached$$inlined$toDisposable$1).vr = function () {
    // Inline function 'jetbrains.ocelot.projectional.cell.util.whenAttached.stub_for_inlining' call
    this.mmx_1.vr();
    return Unit_instance;
  };
  function CellLists$separated$$inlined$separated$1($list, $separator) {
    this.pmx_1 = $separator;
    SeparatedCellList.call(this, $list);
  }
  protoOf(CellLists$separated$$inlined$separated$1).qmx = function (left, right) {
    // Inline function 'jetbrains.ocelot.projectional.cell.util.cellLists.CellLists.separated.<anonymous>' call
    return TextCell_init_$Create$_0(this.pmx_1);
  };
  protoOf(CellLists$separated$$inlined$separated$1).rmx = function (left, right) {
    var tmp = (!(left == null) ? isInterface(left, Cell) : false) ? left : THROW_CCE();
    return this.qmx(tmp, (!(right == null) ? isInterface(right, Cell) : false) ? right : THROW_CCE());
  };
  function CellLists$newLineSeparated$$inlined$separated$1($list) {
    SeparatedCellList.call(this, $list);
  }
  protoOf(CellLists$newLineSeparated$$inlined$separated$1).qmx = function (left, right) {
    // Inline function 'jetbrains.ocelot.projectional.cell.util.cellLists.CellLists.newLineSeparated.<anonymous>' call
    return CellFactory_instance.elj();
  };
  protoOf(CellLists$newLineSeparated$$inlined$separated$1).rmx = function (left, right) {
    var tmp = (!(left == null) ? isInterface(left, Cell) : false) ? left : THROW_CCE();
    return this.qmx(tmp, (!(right == null) ? isInterface(right, Cell) : false) ? right : THROW_CCE());
  };
  function CellLists$verticallySpaced$$inlined$separated$1($list, $linesCount) {
    this.amy_1 = $linesCount;
    SeparatedCellList.call(this, $list);
  }
  protoOf(CellLists$verticallySpaced$$inlined$separated$1).qmx = function (left, right) {
    // Inline function 'jetbrains.ocelot.projectional.cell.util.cellLists.CellLists.verticallySpaced.<anonymous>' call
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.projectional.cell.util.cellLists.CellLists.verticallySpaced.<anonymous>.<anonymous>' call
    var indent = CellFactory_instance.wmw([]);
    // Inline function 'kotlin.repeat' call
    var times = this.amy_1;
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'jetbrains.ocelot.projectional.cell.util.cellLists.CellLists.verticallySpaced.<anonymous>.<anonymous>.<anonymous>' call
        CellFactory_instance.ym3(indent, [CellFactory_instance.elj(), CellFactory_instance.cmx('')]);
      }
       while (inductionVariable < times);
    CellFactory_instance.ym3(indent, [CellFactory_instance.elj()]);
    return indent;
  };
  protoOf(CellLists$verticallySpaced$$inlined$separated$1).rmx = function (left, right) {
    var tmp = (!(left == null) ? isInterface(left, Cell) : false) ? left : THROW_CCE();
    return this.qmx(tmp, (!(right == null) ? isInterface(right, Cell) : false) ? right : THROW_CCE());
  };
  function CellLists() {
  }
  protoOf(CellLists).bmy = function (list, separator) {
    // Inline function 'jetbrains.ocelot.projectional.cell.util.cellLists.CellLists.separated' call
    return new CellLists$separated$$inlined$separated$1(list, separator);
  };
  protoOf(CellLists).cmy = function (list) {
    // Inline function 'jetbrains.ocelot.projectional.cell.util.cellLists.CellLists.separated' call
    return new CellLists$newLineSeparated$$inlined$separated$1(list);
  };
  protoOf(CellLists).dmy = function (list, linesCount) {
    // Inline function 'kotlin.check' call
    if (!(linesCount > 0)) {
      // Inline function 'jetbrains.ocelot.projectional.cell.util.cellLists.CellLists.verticallySpaced.<anonymous>' call
      var message = 'Lines count for vertical spacing must be positive';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'jetbrains.ocelot.projectional.cell.util.cellLists.CellLists.separated' call
    return new CellLists$verticallySpaced$$inlined$separated$1(list, linesCount);
  };
  var CellLists_instance;
  function CellLists_getInstance() {
    return CellLists_instance;
  }
  function SeparatedCellList(baseList) {
    SeparatedList.call(this, baseList);
  }
  function SeparatedList(baseList) {
    AbstractMutableList.call(this);
    this.tmx_1 = baseList;
    // Inline function 'kotlin.require' call
    if (!this.tmx_1.p()) {
      // Inline function 'jetbrains.ocelot.projectional.cell.util.cellLists.SeparatedList.<anonymous>' call
      var message = 'Cannot instantiate a separated list for a non-empty base list';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(SeparatedList).n = function () {
    return (this.tmx_1.n() + 1 | 0) / 2 | 0;
  };
  protoOf(SeparatedList).umx = function (index, element) {
    var result = this.q2(index);
    this.vmx(index, element);
    return result;
  };
  protoOf(SeparatedList).o2 = function (index, element) {
    return this.umx(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(SeparatedList).q = function (index) {
    return this.tmx_1.q(imul(index, 2));
  };
  protoOf(SeparatedList).vmx = function (index, element) {
    if (index === 0) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.tmx_1.p()) {
        this.tmx_1.p2(0, this.rmx(element, this.q(0)));
      }
      this.tmx_1.p2(0, element);
    } else {
      var startIndex = imul(index, 2) - 1 | 0;
      this.tmx_1.p2(startIndex, this.rmx(this.q(index - 1 | 0), element));
      this.tmx_1.p2(startIndex + 1 | 0, element);
      if ((index + 1 | 0) < this.n()) {
        this.tmx_1.o2(startIndex + 2 | 0, this.rmx(element, this.q(index + 1 | 0)));
      }
    }
  };
  protoOf(SeparatedList).p2 = function (index, element) {
    return this.vmx(index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(SeparatedList).q2 = function (index) {
    var result;
    if (index === 0) {
      result = this.tmx_1.q2(0);
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.p()) {
        this.tmx_1.q2(0);
      }
    } else {
      var startIndex = imul(index, 2) - 1 | 0;
      this.tmx_1.q2(startIndex);
      result = this.tmx_1.q2(startIndex);
      if (this.n() > index) {
        this.tmx_1.o2(startIndex, this.rmx(this.q(index - 1 | 0), this.q(index)));
      }
    }
    return result;
  };
  var CellStateDifference_EQUAL_instance;
  var CellStateDifference_NAVIGATION_instance;
  var CellStateDifference_EDIT_instance;
  function Companion_304() {
  }
  protoOf(Companion_304).emy = function (difference1, difference2) {
    return difference1.a3_1 > difference2.a3_1 ? difference1 : difference2;
  };
  var Companion_instance_304;
  function Companion_getInstance_304() {
    return Companion_instance_304;
  }
  var CellStateDifference_entriesInitialized;
  function CellStateDifference_initEntries() {
    if (CellStateDifference_entriesInitialized)
      return Unit_instance;
    CellStateDifference_entriesInitialized = true;
    CellStateDifference_EQUAL_instance = new CellStateDifference('EQUAL', 0);
    CellStateDifference_NAVIGATION_instance = new CellStateDifference('NAVIGATION', 1);
    CellStateDifference_EDIT_instance = new CellStateDifference('EDIT', 2);
  }
  function CellStateDifference(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CellStateDifference_EQUAL_getInstance() {
    CellStateDifference_initEntries();
    return CellStateDifference_EQUAL_instance;
  }
  function CellStateDifference_NAVIGATION_getInstance() {
    CellStateDifference_initEntries();
    return CellStateDifference_NAVIGATION_instance;
  }
  function CellStateDifference_EDIT_getInstance() {
    CellStateDifference_initEntries();
    return CellStateDifference_EDIT_instance;
  }
  function Companion_305() {
    Companion_instance_305 = this;
    this.zmt_1 = CellTraitPropertySpec_init_$Create$('cellStateHandler', null);
  }
  var Companion_instance_305;
  function Companion_getInstance_305() {
    if (Companion_instance_305 == null)
      new Companion_305();
    return Companion_instance_305;
  }
  function CellStateHandler() {
  }
  function get_stateHandler(_this__u8e3s4) {
    var tmp = _this__u8e3s4.ulp(Companion_getInstance_305().zmt_1);
    return (!(tmp == null) ? isInterface(tmp, CellStateHandler) : false) ? tmp : THROW_CCE();
  }
  function Companion_306() {
    Companion_instance_306 = this;
    this.fmy_1 = new CellTraitEventSpec('derivedVisibilityEvent', false);
  }
  var Companion_instance_306;
  function Companion_getInstance_306() {
    if (Companion_instance_306 == null)
      new Companion_306();
    return Companion_instance_306;
  }
  function DerivedVisibilityEvent(visible) {
    Companion_getInstance_306();
    Event_0.call(this);
    this.imy_1 = visible;
  }
  function disambiguateIfNeeded($this, cell) {
    if ($this.kmy_1.lmy($this.jmy_1, cell)) {
      addDisambiguationCell($this.kmy_1, $this.jmy_1);
    }
  }
  function DisambiguationCellSupport$DisambiguationCellTrait$get$lambda($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function DisambiguationCellSupport$Companion$invoke$1($conflict) {
    this.mmy_1 = $conflict;
    DisambiguationCellSupport.call(this);
  }
  protoOf(DisambiguationCellSupport$Companion$invoke$1).lmy = function (bigCell, outermostLeaf) {
    return this.mmy_1(bigCell, outermostLeaf);
  };
  function addDisambiguationCell($this, bigCell) {
    // Inline function 'kotlin.also' call
    var this_0 = new DisambiguationCell($this, bigCell);
    // Inline function 'jetbrains.ocelot.projectional.cell.util.leafTracking.DisambiguationCellSupport.addDisambiguationCell.<anonymous>' call
    bigCell.bln(Companion_getInstance_307().nmy_1, this_0);
    var tmp0_safe_receiver = bigCell.llk();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.elq();
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp = DisambiguationCellSupport$addDisambiguationCell$lambda(bigCell, this_0);
      tmp1_safe_receiver.u2m(new sam$jetbrains_ocelot_base_edt_EdtTask$0_15(tmp));
    }
  }
  function removeDisambiguationCell($this, bigCell) {
    var tmp0_safe_receiver = bigCell.clo(Companion_getInstance_307().nmy_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.cell.util.leafTracking.DisambiguationCellSupport.removeDisambiguationCell.<anonymous>' call
      bigCell.bln(Companion_getInstance_307().nmy_1, null);
      var tmp0_safe_receiver_0 = tmp0_safe_receiver.llk();
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.elq();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp_0 = DisambiguationCellSupport$removeDisambiguationCell$lambda(tmp0_safe_receiver);
        tmp1_safe_receiver.u2m(new sam$jetbrains_ocelot_base_edt_EdtTask$0_16(tmp_0));
        tmp = Unit_instance;
      }
    }
  }
  function DisambiguationCell($outer, bigCell) {
    this.xmy_1 = $outer;
    HorizontalCell.call(this);
    // Inline function 'kotlin.apply' call
    var this_0 = CellFactory_instance.dmx();
    // Inline function 'jetbrains.ocelot.projectional.cell.util.leafTracking.DisambiguationCell.<anonymous>' call
    this_0.ylp(LeafCellTrackingTrait_getInstance().ymy_1, true);
    var space = this_0;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_1 = CellFactory_instance.amx(' ', VOID, false);
    // Inline function 'jetbrains.ocelot.projectional.cell.util.leafTracking.DisambiguationCell.<anonymous>' call
    this_1.hlp().v2c(true);
    get_background(this_1).v2c(Companion_getInstance_325().zls_1);
    this_1.olp(new DisambiguationCellTrait(this.xmy_1, bigCell));
    tmp.wmy_1 = this_1;
    this.ilp().e(space);
    this.ilp().e(this.wmy_1);
  }
  function MyFocusListener($outer, bigCell) {
    this.kmy_1 = $outer;
    OutermostLeafCellFocusListener.call(this);
    this.jmy_1 = bigCell;
  }
  protoOf(MyFocusListener).hlo = function (cell, event) {
    var tmp;
    if (!(event.bmh_1 == null)) {
      var tmp0_safe_receiver = this.jmy_1.clo(Companion_getInstance_307().nmy_1);
      tmp = event.bmh_1 === (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wmy_1);
    } else {
      tmp = false;
    }
    if (tmp)
      return Unit_instance;
    disambiguateIfNeeded(this, cell);
  };
  protoOf(MyFocusListener).ilo = function (cell, event) {
    var tmp;
    if (!(event.cmh_1 == null)) {
      var tmp0_safe_receiver = this.jmy_1.clo(Companion_getInstance_307().nmy_1);
      tmp = event.cmh_1 === (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wmy_1);
    } else {
      tmp = false;
    }
    if (tmp)
      return Unit_instance;
    removeDisambiguationCell(this.kmy_1, this.jmy_1);
  };
  protoOf(MyFocusListener).zmy = function (cell, event) {
    disambiguateIfNeeded(this, cell);
  };
  protoOf(MyFocusListener).amz = function (cell, event) {
    removeDisambiguationCell(this.kmy_1, this.jmy_1);
  };
  function DisambiguationCellTrait($outer, bigCell) {
    this.dmz_1 = $outer;
    CellTrait.call(this);
    this.bmz_1 = bigCell;
    this.cmz_1 = listOf_0([specMatcherValue(LeafCellTrackingTrait_getInstance().ymy_1, true), specMatcherValue(Cells_getInstance().mmg_1, true)]);
  }
  protoOf(DisambiguationCellTrait).flo = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var specMatchers = this.cmz_1;
    var tmp = asSequence_0(specMatchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, DisambiguationCellSupport$DisambiguationCellTrait$get$lambda(spec))));
    var tmp_0;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.util.leafTracking.DisambiguationCellTrait.get.<anonymous>' call
      tmp_0 = protoOf(CellTrait).flo.call(this, cell, spec);
    } else {
      tmp_0 = result.sma_1;
    }
    return tmp_0;
  };
  protoOf(DisambiguationCellTrait).ilo = function (cell, event) {
    if (equals(event.cmh_1, this.bmz_1.clo(Companion_getInstance_309().fmz_1)))
      return Unit_instance;
    removeDisambiguationCell(this.dmz_1, this.bmz_1);
  };
  function Companion_307() {
    Companion_instance_307 = this;
    this.nmy_1 = CellPropertySpec_init_$Create$('disambiguationCell', null);
  }
  protoOf(Companion_307).imz = function (conflict) {
    return new DisambiguationCellSupport$Companion$invoke$1(conflict);
  };
  var Companion_instance_307;
  function Companion_getInstance_307() {
    if (Companion_instance_307 == null)
      new Companion_307();
    return Companion_instance_307;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_15(function_0) {
    this.jmz_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_15).wy = function () {
    return this.jmz_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_15).b4 = function () {
    return this.jmz_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_15).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_15).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_16(function_0) {
    this.kmz_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_16).wy = function () {
    return this.kmz_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_16).b4 = function () {
    return this.kmz_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_16).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_16).hashCode = function () {
    return hashCode(this.b4());
  };
  function DisambiguationCellSupport$addDisambiguationCell$lambda($bigCell, $it) {
    return function () {
      $bigCell.ilp().e($it);
      return Unit_instance;
    };
  }
  function DisambiguationCellSupport$removeDisambiguationCell$lambda($it) {
    return function () {
      var tmp;
      if (!($it.yt() == null)) {
        $it.n3b();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DisambiguationCellSupport() {
    Companion_getInstance_307();
    CellTrait.call(this);
  }
  protoOf(DisambiguationCellSupport).flo = function (cell, spec) {
    return spec === Companion_getInstance_308().nmz_1 ? new MyFocusListener(this, cell) : null;
  };
  function notify($this, cell, visible) {
    cell.mlp(new DerivedVisibilityEvent(visible), Companion_getInstance_306().fmy_1);
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = cell.g2r();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.cell.util.leafTracking.EffectiveVisibilityTrackingTrait.notify.<anonymous>' call
      if (element.elp().m2c()) {
        destination.e(element);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var element_0 = _iterator__ex2g4s_0.m();
      // Inline function 'jetbrains.ocelot.projectional.cell.util.leafTracking.EffectiveVisibilityTrackingTrait.notify.<anonymous>' call
      notify(EffectiveVisibilityTrackingTrait_getInstance(), element_0, visible);
    }
  }
  function EffectiveVisibilityTrackingTrait() {
    EffectiveVisibilityTrackingTrait_instance = this;
    CellTrait.call(this);
  }
  protoOf(EffectiveVisibilityTrackingTrait).qlm = function (cell, prop, event) {
    if (prop === get_VISIBLE()) {
      if (!(event instanceof PropertyChangeEvent))
        THROW_CCE();
      notify(this, cell, event.p2e_1);
    }
  };
  var EffectiveVisibilityTrackingTrait_instance;
  function EffectiveVisibilityTrackingTrait_getInstance() {
    if (EffectiveVisibilityTrackingTrait_instance == null)
      new EffectiveVisibilityTrackingTrait();
    return EffectiveVisibilityTrackingTrait_instance;
  }
  function LastCaretPositionSupport$ExtraCellTrait$get$lambda($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function schedule_0(_this__u8e3s4, $this, code) {
    if (!(_this__u8e3s4 == null)) {
      _this__u8e3s4.elq().u2m(new sam$jetbrains_ocelot_base_edt_EdtTask$0_17(code));
    } else
      code();
  }
  function ExtraCell(bigCell) {
    TextCell_init_$Init$(this);
    this.olp(new ExtraCellTrait(bigCell));
    this.hlp().v2c(true);
  }
  function ExtraCellTrait(bigCell) {
    CompositeCellTrait.call(this);
    this.omz_1 = new FocusTrait(bigCell);
    this.pmz_1 = listOf_0([specMatcherValue(LeafCellTrackingTrait_getInstance().ymy_1, true), specMatcherValue(Cells_getInstance().mmg_1, true)]);
  }
  protoOf(ExtraCellTrait).flo = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var specMatchers = this.pmz_1;
    var tmp = asSequence_0(specMatchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, LastCaretPositionSupport$ExtraCellTrait$get$lambda(spec))));
    var tmp_0;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.util.leafTracking.ExtraCellTrait.get.<anonymous>' call
      tmp_0 = protoOf(CompositeCellTrait).flo.call(this, cell, spec);
    } else {
      tmp_0 = result.sma_1;
    }
    return tmp_0;
  };
  protoOf(ExtraCellTrait).wma = function (cell) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [TextEditing_getInstance().amu(), this.omz_1];
  };
  function FocusTrait(bigCell) {
    CellTrait.call(this);
    this.qmz_1 = bigCell;
  }
  protoOf(FocusTrait).hlo = function (cell, event) {
    this.qmz_1.ulp(Companion_getInstance_308().nmz_1).hlo(cell, event);
  };
  protoOf(FocusTrait).ilo = function (cell, event) {
    this.qmz_1.ulp(Companion_getInstance_308().nmz_1).ilo(cell, event);
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_17(function_0) {
    this.rmz_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_17).wy = function () {
    return this.rmz_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_17).b4 = function () {
    return this.rmz_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_17).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_17).hashCode = function () {
    return hashCode(this.b4());
  };
  function onPropertyChanged$enclosing(_this__u8e3s4, $cell) {
    return _this__u8e3s4 == null ? $cell : ensureNotNull(_this__u8e3s4.yt());
  }
  function LastCaretPositionSupport$onPropertyChanged$$inlined$toDisposable$1($extraCell) {
    this.smz_1 = $extraCell;
  }
  protoOf(LastCaretPositionSupport$onPropertyChanged$$inlined$toDisposable$1).vr = function () {
    var tmp;
    if (!(this.smz_1.yt() == null)) {
      this.smz_1.n3b();
      tmp = Unit_instance;
    }
    return tmp;
  };
  function LastCaretPositionSupport$onPropertyChanged$lambda($cleanUp, $reallyLastCell, $lastCell, $cell) {
    return function () {
      $cleanUp.vr();
      var tmp;
      if ($reallyLastCell instanceof ExtraCell) {
        onPropertyChanged$enclosing($lastCell, $cell).ilp().e($reallyLastCell);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function LastCaretPositionSupport() {
    LastCaretPositionSupport_instance = this;
    CompositeCellTrait.call(this);
    this.tmz_1 = CellPropertySpec_init_$Create$('extraCaretPositionCleanup', Companion_getInstance_25().wr_1);
  }
  protoOf(LastCaretPositionSupport).wma = function (cell) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [OutermostLeafTrackers_getInstance().vmz_1];
  };
  protoOf(LastCaretPositionSupport).qlm = function (cell, prop, event) {
    if (!(prop === Companion_getInstance_309().fmz_1)) {
      protoOf(CompositeCellTrait).qlm.call(this, cell, prop, event);
      return Unit_instance;
    }
    if (!(event instanceof PropertyChangeEvent))
      THROW_CCE();
    var previousLastCell = event.o2e_1;
    var lastCell = event.p2e_1;
    if (!(previousLastCell == null) && previousLastCell.qlp().m2c()) {
      cell.ulp(Companion_getInstance_308().nmz_1).amz(previousLastCell, event);
    }
    if (!(lastCell == null) && lastCell.qlp().m2c()) {
      cell.ulp(Companion_getInstance_308().nmz_1).zmy(lastCell, event);
    }
    var cleanUp = cell.clo(this.tmz_1);
    var tmp;
    var tmp1_safe_receiver = lastCell == null ? null : lastCell.hlp();
    if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.qr()) === true) {
      cell.bln(this.tmz_1, lastCell.olp(new FocusTrait(cell)));
      tmp = lastCell;
    } else {
      var extraCell = new ExtraCell(cell);
      // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
      var tmp$ret$0 = new LastCaretPositionSupport$onPropertyChanged$$inlined$toDisposable$1(extraCell);
      cell.bln(this.tmz_1, tmp$ret$0);
      tmp = extraCell;
    }
    var reallyLastCell = tmp;
    var tmp_0 = cell.llk();
    schedule_0(tmp_0, this, LastCaretPositionSupport$onPropertyChanged$lambda(cleanUp, reallyLastCell, lastCell, cell));
  };
  var LastCaretPositionSupport_instance;
  function LastCaretPositionSupport_getInstance() {
    if (LastCaretPositionSupport_instance == null)
      new LastCaretPositionSupport();
    return LastCaretPositionSupport_instance;
  }
  function LeafCellTrackingTrait$Side$LEFT() {
    Side_1.call(this, 'LEFT', 0, Companion_getInstance_309().gmz_1, Companion_getInstance_309().emz_1);
    Side_LEFT_instance_0 = this;
  }
  protoOf(LeafCellTrackingTrait$Side$LEFT).an0 = function (cell) {
    return cell.k2r();
  };
  protoOf(LeafCellTrackingTrait$Side$LEFT).bn0 = function (cell, within) {
    return Composites_instance.t2r(cell, within);
  };
  var Side_LEFT_instance_0;
  function LeafCellTrackingTrait$Side$RIGHT() {
    Side_1.call(this, 'RIGHT', 1, Companion_getInstance_309().hmz_1, Companion_getInstance_309().fmz_1);
    Side_RIGHT_instance_0 = this;
  }
  protoOf(LeafCellTrackingTrait$Side$RIGHT).an0 = function (cell) {
    return cell.h2r();
  };
  protoOf(LeafCellTrackingTrait$Side$RIGHT).bn0 = function (cell, within) {
    return Composites_instance.s2r(cell, within);
  };
  var Side_RIGHT_instance_0;
  function LeafCellTrackingTrait$Side$siblingsOf$lambda(this$0) {
    return function (it) {
      return this$0.an0(it);
    };
  }
  function LeafCellTrackingTrait$Side$adjacentLeavesOf$lambda(this$0, $within) {
    return function (it) {
      return this$0.bn0(it, $within);
    };
  }
  var Side_entriesInitialized_0;
  function Side_initEntries_0() {
    if (Side_entriesInitialized_0)
      return Unit_instance;
    Side_entriesInitialized_0 = true;
    Side_LEFT_instance_0 = new LeafCellTrackingTrait$Side$LEFT();
    Side_RIGHT_instance_0 = new LeafCellTrackingTrait$Side$RIGHT();
  }
  function initialize(_this__u8e3s4, $this, side, within) {
    var c = _this__u8e3s4;
    while (!(c == null) && c.ulp($this.ymy_1)) {
      c = findAdjacentLeaf($this, c, opposite(side, $this), within);
    }
    within.bln(side.fn0_1, c);
  }
  function onAdded($this, cell) {
    if (!isSignificant(cell, $this))
      return Unit_instance;
    onAdded_0($this, cell, Side_LEFT_getInstance_0());
    onAdded_0($this, cell, Side_RIGHT_getInstance_0());
  }
  function onRemoved($this, cell, root, dueToInvisibility) {
    if (_get_isIgnored__bbdceh(cell, $this))
      return Unit_instance;
    if (!dueToInvisibility && !isVisible_1(cell))
      return Unit_instance;
    onRemoved_0($this, cell, root, Side_LEFT_getInstance_0());
    onRemoved_0($this, cell, root, Side_RIGHT_getInstance_0());
  }
  function onRemoved$default($this, cell, root, dueToInvisibility, $super) {
    dueToInvisibility = dueToInvisibility === VOID ? false : dueToInvisibility;
    return onRemoved($this, cell, root, dueToInvisibility);
  }
  function onAdded_0($this, cell, side) {
    var _iterator__ex2g4s = ancestorsFrom(cell).k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var ancestor = _iterator__ex2g4s.m();
      if (ancestor.ulp(side.en0_1)) {
        ancestor.bln(side.fn0_1, cell);
      }
      if (hasSignificantNeighbours(ancestor, $this, side)) {
        break $l$loop;
      }
    }
  }
  function onRemoved_0($this, cell, root, side) {
    var _iterator__ex2g4s = ancestors(root).k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var ancestor = _iterator__ex2g4s.m();
      if (ancestor.ulp(side.en0_1) && ancestor.clo(side.fn0_1) === cell) {
        var newOutermost = findAdjacentLeaf($this, root, opposite(side, $this), ancestor);
        ancestor.bln(side.fn0_1, newOutermost);
      }
      if (hasSignificantNeighbours(ancestor, $this, side)) {
        break $l$loop;
      }
    }
  }
  function hasSignificantNeighbours(_this__u8e3s4, $this, side) {
    var tmp0 = side.gn0(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.cell.util.leafTracking.LeafCellTrackingTrait.hasSignificantNeighbours.<anonymous>' call
        if (isSignificant(element, LeafCellTrackingTrait_getInstance())) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function isSignificant(_this__u8e3s4, $this) {
    if (!isVisible_1(_this__u8e3s4))
      return false;
    var tmp;
    if (_this__u8e3s4 instanceof TextCell) {
      tmp = !_get_isIgnored__bbdceh(_this__u8e3s4, $this);
    } else {
      tmp = false;
    }
    if (tmp)
      return true;
    var tmp0 = _this__u8e3s4.g2r();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.p();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.cell.util.leafTracking.LeafCellTrackingTrait.isSignificant.<anonymous>' call
        if (isSignificant(element, LeafCellTrackingTrait_getInstance())) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function _get_isIgnored__bbdceh(_this__u8e3s4, $this) {
    return _this__u8e3s4.ulp($this.ymy_1);
  }
  function findAdjacentLeaf($this, leaf, side, within) {
    var tmp = side.hn0(leaf, within);
    return firstOrNull_2(filter(tmp, LeafCellTrackingTrait$findAdjacentLeaf$lambda));
  }
  function Side_1(name, ordinal, isTrackingEnabledPropertySpec, edgeLeafPropertySpec) {
    Enum.call(this, name, ordinal);
    this.en0_1 = isTrackingEnabledPropertySpec;
    this.fn0_1 = edgeLeafPropertySpec;
  }
  protoOf(Side_1).gn0 = function (cell) {
    return generateSequenceFromNext(cell, VOID, LeafCellTrackingTrait$Side$siblingsOf$lambda(this));
  };
  protoOf(Side_1).hn0 = function (cell, within) {
    return generateSequenceFromNext(cell, VOID, LeafCellTrackingTrait$Side$adjacentLeavesOf$lambda(this, within));
  };
  function opposite(_this__u8e3s4, $this) {
    var tmp;
    switch (_this__u8e3s4.a3_1) {
      case 0:
        tmp = Side_RIGHT_getInstance_0();
        break;
      case 1:
        tmp = Side_LEFT_getInstance_0();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function LeafCellTrackingTrait$findAdjacentLeaf$lambda(it) {
    return isVisible_1(it);
  }
  function Side_LEFT_getInstance_0() {
    Side_initEntries_0();
    return Side_LEFT_instance_0;
  }
  function Side_RIGHT_getInstance_0() {
    Side_initEntries_0();
    return Side_RIGHT_instance_0;
  }
  function LeafCellTrackingTrait() {
    LeafCellTrackingTrait_instance = this;
    CellTrait.call(this);
    this.ymy_1 = CellTraitPropertySpec_init_$Create$('ignoreAsOutermostLeaf', false);
  }
  protoOf(LeafCellTrackingTrait).mn0 = function (trackingCell) {
    var tmp0_safe_receiver = firstVisibleLeaf(trackingCell);
    if (tmp0_safe_receiver == null)
      null;
    else {
      initialize(tmp0_safe_receiver, this, Side_LEFT_getInstance_0(), trackingCell);
    }
  };
  protoOf(LeafCellTrackingTrait).nn0 = function (trackingCell) {
    var tmp0_safe_receiver = lastVisibleLeaf(trackingCell);
    if (tmp0_safe_receiver == null)
      null;
    else {
      initialize(tmp0_safe_receiver, this, Side_RIGHT_getInstance_0(), trackingCell);
    }
  };
  protoOf(LeafCellTrackingTrait).glo = function (cell) {
    onAdded(this, cell);
  };
  protoOf(LeafCellTrackingTrait).ylm = function (cell) {
    onAdded(this, cell);
  };
  protoOf(LeafCellTrackingTrait).zlm = function (cell, root) {
    onRemoved$default(this, cell, root);
  };
  protoOf(LeafCellTrackingTrait).qlm = function (cell, prop, event) {
    if (prop === get_VISIBLE()) {
      if (!(event instanceof PropertyChangeEvent))
        THROW_CCE();
      if (event.p2e_1) {
        onAdded(this, cell);
      } else {
        onRemoved(this, cell, cell, true);
      }
    }
  };
  protoOf(LeafCellTrackingTrait).bll = function (cell, spec, event) {
    if (spec === Companion_getInstance_306().fmy_1) {
      if (!(event instanceof DerivedVisibilityEvent))
        THROW_CCE();
      if (event.imy_1) {
        onAdded(this, cell);
      } else {
        onRemoved(this, cell, cell, true);
      }
    }
  };
  var LeafCellTrackingTrait_instance;
  function LeafCellTrackingTrait_getInstance() {
    if (LeafCellTrackingTrait_instance == null)
      new LeafCellTrackingTrait();
    return LeafCellTrackingTrait_instance;
  }
  function Companion_308() {
    Companion_instance_308 = this;
    this.lmz_1 = new OutermostLeafCellFocusListener();
    this.mmz_1 = CellTraitPropertySpec_init_$Create$('outermostCaretListener', this.lmz_1);
    this.nmz_1 = CellTraitPropertySpec_init_$Create$('outermostCaretListener', this.lmz_1);
  }
  var Companion_instance_308;
  function Companion_getInstance_308() {
    if (Companion_instance_308 == null)
      new Companion_308();
    return Companion_instance_308;
  }
  function OutermostLeafCellFocusListener() {
    Companion_getInstance_308();
  }
  protoOf(OutermostLeafCellFocusListener).hlo = function (cell, event) {
  };
  protoOf(OutermostLeafCellFocusListener).ilo = function (cell, event) {
  };
  protoOf(OutermostLeafCellFocusListener).zmy = function (cell, event) {
  };
  protoOf(OutermostLeafCellFocusListener).amz = function (cell, event) {
  };
  function isTracking($this, sides) {
    return contains_0(sides, $this.on0_1) ? true : null;
  }
  function Companion_309() {
    Companion_instance_309 = this;
    this.emz_1 = CellPropertySpec_init_$Create$('firstTrackedLeaf', null);
    this.fmz_1 = CellPropertySpec_init_$Create$('lastTrackedLeaf', null);
    this.gmz_1 = CellTraitPropertySpec_init_$Create$('trackingFirstLeaf', false);
    this.hmz_1 = CellTraitPropertySpec_init_$Create$('trackingLastLeaf', false);
  }
  var Companion_instance_309;
  function Companion_getInstance_309() {
    if (Companion_instance_309 == null)
      new Companion_309();
    return Companion_instance_309;
  }
  function OutermostLeafCellTracker(side) {
    Companion_getInstance_309();
    CellTrait.call(this);
    this.on0_1 = side;
  }
  protoOf(OutermostLeafCellTracker).glo = function (cell) {
    protoOf(CellTrait).glo.call(this, cell);
    if (listOf_0([CellSides_LEFT_getInstance(), CellSides_BOTH_getInstance()]).s(this.on0_1)) {
      LeafCellTrackingTrait_getInstance().mn0(cell);
    }
    if (listOf_0([CellSides_RIGHT_getInstance(), CellSides_BOTH_getInstance()]).s(this.on0_1)) {
      LeafCellTrackingTrait_getInstance().nn0(cell);
    }
  };
  protoOf(OutermostLeafCellTracker).flo = function (cell, spec) {
    return equals(spec, Companion_getInstance_309().gmz_1) ? isTracking(this, [CellSides_LEFT_getInstance(), CellSides_BOTH_getInstance()]) : equals(spec, Companion_getInstance_309().hmz_1) ? isTracking(this, [CellSides_RIGHT_getInstance(), CellSides_BOTH_getInstance()]) : protoOf(CellTrait).flo.call(this, cell, spec);
  };
  var CellSides_LEFT_instance;
  var CellSides_RIGHT_instance;
  var CellSides_BOTH_instance;
  var CellSides_entriesInitialized;
  function CellSides_initEntries() {
    if (CellSides_entriesInitialized)
      return Unit_instance;
    CellSides_entriesInitialized = true;
    CellSides_LEFT_instance = new CellSides('LEFT', 0);
    CellSides_RIGHT_instance = new CellSides('RIGHT', 1);
    CellSides_BOTH_instance = new CellSides('BOTH', 2);
  }
  function CellSides(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function CellSides_LEFT_getInstance() {
    CellSides_initEntries();
    return CellSides_LEFT_instance;
  }
  function CellSides_RIGHT_getInstance() {
    CellSides_initEntries();
    return CellSides_RIGHT_instance;
  }
  function CellSides_BOTH_getInstance() {
    CellSides_initEntries();
    return CellSides_BOTH_instance;
  }
  function OutermostLeafTrackers() {
    OutermostLeafTrackers_instance = this;
    this.umz_1 = new OutermostLeafCellTracker(CellSides_LEFT_getInstance());
    this.vmz_1 = new OutermostLeafCellTracker(CellSides_RIGHT_getInstance());
  }
  var OutermostLeafTrackers_instance;
  function OutermostLeafTrackers_getInstance() {
    if (OutermostLeafTrackers_instance == null)
      new OutermostLeafTrackers();
    return OutermostLeafTrackers_instance;
  }
  function get_PLACEHOLDER_CELL() {
    _init_properties_Placeholders_kt__gibeo0();
    return PLACEHOLDER_CELL;
  }
  var PLACEHOLDER_CELL;
  function get_TEXT_CELL_WITH_ATTACHED_PLACEHOLDER() {
    _init_properties_Placeholders_kt__gibeo0();
    return TEXT_CELL_WITH_ATTACHED_PLACEHOLDER;
  }
  var TEXT_CELL_WITH_ATTACHED_PLACEHOLDER;
  function get_IS_PLACEHOLDER() {
    _init_properties_Placeholders_kt__gibeo0();
    return IS_PLACEHOLDER;
  }
  var IS_PLACEHOLDER;
  function isPlaceholder(_this__u8e3s4) {
    _init_properties_Placeholders_kt__gibeo0();
    return _this__u8e3s4.ulp(get_IS_PLACEHOLDER());
  }
  function placeholder(textCell, placeholderText) {
    _init_properties_Placeholders_kt__gibeo0();
    var placeholderCell = placeholder_0(placeholderText);
    attachToPlaceholder(placeholderCell, textCell);
    return placeholderCell;
  }
  function placeholder_0(text) {
    _init_properties_Placeholders_kt__gibeo0();
    // Inline function 'kotlin.apply' call
    var this_0 = TextCell_init_$Create$_0(text);
    // Inline function 'jetbrains.ocelot.projectional.cell.util.placeholders.placeholder.<anonymous>' call
    this_0.hlu().t2c(Companion_getInstance_325().xls_1);
    return this_0;
  }
  function attachToPlaceholder(placeholderCell, textCell) {
    _init_properties_Placeholders_kt__gibeo0();
    placeholderCell.olp(new attachToPlaceholder$1(textCell));
    textCell.olp(new attachToPlaceholder$2(placeholderCell, textCell));
    var textValue = textCell.laz().qr();
    var tmp = placeholderCell.elp();
    // Inline function 'kotlin.text.isEmpty' call
    var tmp$ret$0 = charSequenceLength(textValue) === 0;
    tmp.t2c(tmp$ret$0);
  }
  function getFirstPlaceholder(_this__u8e3s4) {
    _init_properties_Placeholders_kt__gibeo0();
    var result = null;
    var _iterator__ex2g4s = _this__u8e3s4.g2r().k();
    $l$loop_1: while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      if (!child.elp().m2c()) {
        continue $l$loop_1;
      }
      if (isPlaceholder(child)) {
        // Inline function 'kotlin.check' call
        if (!(child instanceof TextCell)) {
          throw IllegalStateException_init_$Create$_0('Check failed.');
        }
        var textCell = placeholdersTextCell(child);
        if (textCell.hlp().m2c()) {
          result = textCell;
          break $l$loop_1;
        }
      }
      var firstPlaceholder = getFirstPlaceholder(child);
      if (!(firstPlaceholder == null)) {
        result = firstPlaceholder;
        break $l$loop_1;
      }
    }
    return result;
  }
  function placeholdersTextCell(_this__u8e3s4) {
    _init_properties_Placeholders_kt__gibeo0();
    // Inline function 'kotlin.check' call
    if (!isPlaceholder(_this__u8e3s4)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return ensureNotNull(_this__u8e3s4.ulp(get_TEXT_CELL_WITH_ATTACHED_PLACEHOLDER()));
  }
  function attachToPlaceholder$o$get$lambda($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function attachToPlaceholder$1($textCell) {
    this.qn0_1 = $textCell;
    CellTrait.call(this);
    this.pn0_1 = listOf_0([specMatcherValue(get_IS_PLACEHOLDER(), true), specMatcherValue(get_TEXT_CELL_WITH_ATTACHED_PLACEHOLDER(), $textCell)]);
  }
  protoOf(attachToPlaceholder$1).llo = function (cell, event) {
    if (!this.qn0_1.hlp().m2c())
      return Unit_instance;
    var prevFocused = ensureNotNull(cell.llk()).rlp().qr();
    this.qn0_1.ul5();
    event.ol0();
    cell.mlp(new FocusEvent(prevFocused, cell), Cells_getInstance().jmg_1);
  };
  protoOf(attachToPlaceholder$1).flo = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var specMatchers = this.pn0_1;
    var tmp = asSequence_0(specMatchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, attachToPlaceholder$o$get$lambda(spec))));
    var tmp_0;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.util.placeholders.<no name provided>.get.<anonymous>' call
      tmp_0 = protoOf(CellTrait).flo.call(this, cell, spec);
    } else {
      tmp_0 = result.sma_1;
    }
    return tmp_0;
  };
  function attachToPlaceholder$2($placeholderCell, $textCell) {
    this.rn0_1 = $placeholderCell;
    this.sn0_1 = $textCell;
    CellTrait.call(this);
  }
  protoOf(attachToPlaceholder$2).flo = function (cell, spec) {
    var matcher = specMatcherValue(get_PLACEHOLDER_CELL(), this.rn0_1);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = matcher(spec);
    var tmp;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.util.placeholders.<no name provided>.get.<anonymous>' call
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    } else {
      tmp = result.sma_1;
    }
    return tmp;
  };
  protoOf(attachToPlaceholder$2).qlm = function (cell, prop, event) {
    if (equals(prop, get_FOCUS_HIGHLIGHTED())) {
      var tmp = ensureNotNull(this.sn0_1.ulp(get_PLACEHOLDER_CELL())).glp();
      var tmp_0 = event.p2e_1;
      tmp.t2c((!(tmp_0 == null) ? typeof tmp_0 === 'boolean' : false) ? tmp_0 : THROW_CCE());
    } else if (equals(prop, Companion_getInstance_271().als_1)) {
      var tmp_1 = event.p2e_1;
      var value = (tmp_1 == null ? true : typeof tmp_1 === 'string') ? tmp_1 : THROW_CCE();
      var tmp_2 = ensureNotNull(this.sn0_1.ulp(get_PLACEHOLDER_CELL())).elp();
      // Inline function 'kotlin.text.isNullOrEmpty' call
      var tmp$ret$0 = value == null || charSequenceLength(value) === 0;
      tmp_2.t2c(tmp$ret$0);
    }
  };
  var properties_initialized_Placeholders_kt_1i1fdu;
  function _init_properties_Placeholders_kt__gibeo0() {
    if (!properties_initialized_Placeholders_kt_1i1fdu) {
      properties_initialized_Placeholders_kt_1i1fdu = true;
      PLACEHOLDER_CELL = CellTraitPropertySpec_init_$Create$('placeholderCell', null);
      TEXT_CELL_WITH_ATTACHED_PLACEHOLDER = CellTraitPropertySpec_init_$Create$('textCellWithAttachedPlaceholder', null);
      IS_PLACEHOLDER = CellTraitPropertySpec_init_$Create$('isPlaceholder', false);
    }
  }
  function assertValid_2($this) {
    // Inline function 'kotlin.check' call
    if (!$this.w4u()) {
      // Inline function 'jetbrains.ocelot.projectional.cell.util.scope.CellScope.assertValid.<anonymous>' call
      var message = 'Not valid: ' + toString_1($this);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  function CellScope() {
  }
  protoOf(CellScope).dly = function () {
    assertValid_2(this);
    return this.tn0();
  };
  protoOf(CellScope).un0 = function () {
    assertValid_2(this);
    this.vn0();
  };
  protoOf(CellScope).wn0 = function () {
    assertValid_2(this);
    return this.xn0();
  };
  function FocusableCellScope(cell) {
    CellScope.call(this);
    this.yn0_1 = cell;
  }
  protoOf(FocusableCellScope).w4u = function () {
    return this.yn0_1.qlc() && this.yn0_1.hlp().qr();
  };
  protoOf(FocusableCellScope).tn0 = function () {
    return this.yn0_1.qlp().qr();
  };
  protoOf(FocusableCellScope).vn0 = function () {
    this.yn0_1.ul5();
    CellScrolling_getInstance().kms(this.yn0_1);
  };
  protoOf(FocusableCellScope).xn0 = function () {
    return CellScopes_getInstance().bn1(this.yn0_1.yt());
  };
  function CellScopes$PROPERTY$lambda(cell) {
    var tmp;
    if (!cell.hlp().qr() || cell.ulp(CellScopes_getInstance().zn0_1)) {
      tmp = null;
    } else {
      tmp = new FocusableCellScope(cell);
    }
    return tmp;
  }
  function CellScopes$nearest$lambda(c) {
    return c.ulp(CellScopes_getInstance().an1_1);
  }
  function CellScopes() {
    CellScopes_instance = this;
    this.zn0_1 = CellTraitPropertySpec_init_$Create$('cellScopeIgnored', false);
    var tmp = this;
    tmp.an1_1 = new CellTraitPropertySpec('currentSelection', CellScopes$PROPERTY$lambda);
  }
  protoOf(CellScopes).bn1 = function (cell) {
    var tmp = ancestorsFrom(cell);
    return firstOrNull_2(filterNotNull_0(map(tmp, CellScopes$nearest$lambda)));
  };
  var CellScopes_instance;
  function CellScopes_getInstance() {
    if (CellScopes_instance == null)
      new CellScopes();
    return CellScopes_instance;
  }
  function _get_properties__8r22x4($this) {
    return $this.cn1_1.ulp(CellScrolling_getInstance().jms_1);
  }
  function scrollToEditor($this, editor) {
    var root = ensureNotNull(ensureNotNull(editor.llk()).ymi(editor));
    return scrollTo_1(root, CellScrolling$scrollToEditor$lambda(editor, root));
  }
  function scrollToEditorAsync($this, editor, cause) {
    var root = ensureNotNull(ensureNotNull(editor.llk()).ymi(editor));
    return root.slp(CellScrolling$scrollToEditorAsync$lambda(editor, cause, root));
  }
  function calculateTarget($this, editor, cause) {
    var cellContainer = ensureNotNull(editor.llk());
    var scrollCell = ensureNotNull(cellContainer.ymi(editor));
    var visibleRect = cellContainer.nlq(scrollCell);
    var lineBounds = getLineBounds($this, editor);
    var lineFullyVisible = visibleRect.lku(lineBounds);
    if (lineFullyVisible && shouldStayIfLineVisible($this, cause)) {
      return lineBounds;
    }
    var mainTarget = calculateMainTarget($this, editor, cause, lineFullyVisible);
    var snappedHome = SnappingHome_getInstance().fn1(editor, mainTarget, lineBounds);
    var tmp;
    if (snappedHome.equals(mainTarget)) {
      tmp = Snapping_getInstance().in1(mainTarget, editor, cause);
    } else {
      tmp = snappedHome;
    }
    return tmp;
  }
  function isHome($this, event) {
    return event.ol1([KeyStrokeSpecs_getInstance().ll2_1, KeyStrokeSpecs_getInstance().wl2_1]);
  }
  function getLineBounds($this, editor) {
    return getLineBounds_0($this, editor, getVerticalChild($this, editor));
  }
  function getVerticalChild($this, from) {
    var tmp0 = ancestorsFrom(from);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.first' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.cell.util.scrolling.CellScrolling.getVerticalChild.<anonymous>' call
        var parentCell = element.yt();
        var tmp;
        if (parentCell == null) {
          tmp = true;
        } else {
          tmp = parentCell instanceof VerticalCell;
        }
        if (tmp) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      throw NoSuchElementException_init_$Create$_0('Sequence contains no element matching the predicate.');
    }
    return tmp$ret$1;
  }
  function getLineBounds_0($this, editor, within) {
    var upperLeftCell;
    var bottomRightCell;
    if (editor === within) {
      upperLeftCell = editor;
      bottomRightCell = editor;
    } else {
      upperLeftCell = findLineBound($this, editor, CellScrolling$getLineBounds$lambda(within));
      bottomRightCell = findLineBound($this, editor, CellScrolling$getLineBounds$lambda_0(within));
      if (upperLeftCell == null) {
        upperLeftCell = within;
      }
      if (bottomRightCell == null) {
        bottomRightCell = within;
      }
    }
    var upperLeft = get_origin_0(upperLeftCell);
    var bottomRight = get_origin_0(bottomRightCell).jku(get_dimension(bottomRightCell));
    return new Rectangle(upperLeft, bottomRight.kku(upperLeft));
  }
  function findLineBound($this, from, traverser) {
    var current = from;
    while (true) {
      var tmp0_elvis_lhs = traverser(current);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var next = tmp;
      if (next instanceof NewLineCell) {
        return current;
      }
      current = next;
    }
  }
  function calculateMainTarget($this, editor, e, lineFullyVisible) {
    var tmp;
    if (isGoRight($this, e)) {
      tmp = fromCaret($this, editor).pn1().qn1().ln1();
    } else if (isGoLeft($this, e)) {
      tmp = fromCaret($this, editor).nn1().on1().ln1();
    } else if (isGoUp($this, e)) {
      var tmp_0 = fromCaret($this, editor);
      var tmp_1 = !lineFullyVisible;
      tmp = tmp_0.jn1(tmp_1, CellScrolling$TargetBuilder$extendSideways$ref()).mn1().ln1();
    } else if (isGoDown($this, e)) {
      var tmp_2 = fromCaret($this, editor);
      var tmp_3 = !lineFullyVisible;
      tmp = tmp_2.jn1(tmp_3, CellScrolling$TargetBuilder$extendSideways$ref_0()).kn1().ln1();
    } else {
      tmp = calculateSimpleTarget($this, editor);
    }
    return tmp;
  }
  function calculateSimpleTarget($this, editor) {
    return fromCaret($this, editor).rn1().ln1();
  }
  function isGoUp($this, event) {
    return event.ml1(Key_UP_getInstance(), []) || event.ml1(Key_PAGE_UP_getInstance(), []) || event.ol1([KeyStrokeSpecs_getInstance().cl3_1]);
  }
  function isGoDown($this, event) {
    return event.ml1(Key_DOWN_getInstance(), []) || event.ml1(Key_ENTER_getInstance(), []) || event.ml1(Key_PAGE_DOWN_getInstance(), []) || event.ol1([KeyStrokeSpecs_getInstance().dl3_1]);
  }
  function isGoLeft($this, event) {
    return event.ml1(Key_LEFT_getInstance(), []) || event.ml1(Key_BACKSPACE_getInstance(), []) || event.ol1([KeyStrokeSpecs_getInstance().al3_1, KeyStrokeSpecs_getInstance().pl2_1, KeyStrokeSpecs_getInstance().ll2_1]);
  }
  function isGoRight($this, event) {
    return event.ml1(Key_RIGHT_getInstance(), []) || event.ol1([KeyStrokeSpecs_getInstance().bl3_1, KeyStrokeSpecs_getInstance().ql2_1, KeyStrokeSpecs_getInstance().ml2_1]);
  }
  function shouldStayIfLineVisible($this, event) {
    return !isHome($this, event) && !isGoUp($this, event) && !isGoDown($this, event);
  }
  function fromCaret($this, editor) {
    return new TargetBuilder(editor, editor.elu());
  }
  function TargetBuilder(editor, _target) {
    this.cn1_1 = editor;
    this.dn1_1 = _target;
  }
  protoOf(TargetBuilder).ln1 = function () {
    return this.dn1_1.rku(get_bounds(ensureNotNull(ensureNotNull(this.cn1_1.llk()).ymi(this.cn1_1))));
  };
  protoOf(TargetBuilder).jn1 = function (test, modification) {
    var tmp;
    if (test) {
      tmp = modification(this);
    } else {
      tmp = this;
    }
    return tmp;
  };
  protoOf(TargetBuilder).rn1 = function () {
    var sidewaysExtension = ScrollingUtil_instance.wn1(_get_properties__8r22x4(this).vn1_1, this.cn1_1, 0);
    this.dn1_1 = Rectangles_instance.hkv(sidewaysExtension, this.dn1_1, sidewaysExtension);
    return this;
  };
  protoOf(TargetBuilder).mn1 = function () {
    var upExtension = ScrollingUtil_instance.xn1(_get_properties__8r22x4(this).tn1_1, this.cn1_1);
    this.dn1_1 = Rectangles_instance.dkv(this.dn1_1, upExtension);
    return this;
  };
  protoOf(TargetBuilder).kn1 = function () {
    var upExtension = ScrollingUtil_instance.xn1(_get_properties__8r22x4(this).tn1_1, this.cn1_1);
    this.dn1_1 = Rectangles_instance.ekv(this.dn1_1, upExtension);
    return this;
  };
  protoOf(TargetBuilder).on1 = function () {
    var leftExtension = ScrollingUtil_instance.wn1(_get_properties__8r22x4(this).sn1_1, this.cn1_1, 0);
    this.dn1_1 = Rectangles_instance.fkv(this.dn1_1, leftExtension);
    return this;
  };
  protoOf(TargetBuilder).qn1 = function () {
    var rightExtension = ScrollingUtil_instance.wn1(_get_properties__8r22x4(this).sn1_1, this.cn1_1, 0);
    this.dn1_1 = Rectangles_instance.gkv(this.dn1_1, rightExtension);
    return this;
  };
  protoOf(TargetBuilder).pn1 = function () {
    var leftExtension = ScrollingUtil_instance.wn1(_get_properties__8r22x4(this).un1_1, this.cn1_1, 0);
    this.dn1_1 = Rectangles_instance.fkv(this.dn1_1, leftExtension);
    return this;
  };
  protoOf(TargetBuilder).nn1 = function () {
    var rightExtension = ScrollingUtil_instance.wn1(_get_properties__8r22x4(this).un1_1, this.cn1_1, 0);
    this.dn1_1 = Rectangles_instance.gkv(this.dn1_1, rightExtension);
    return this;
  };
  function CellScrolling$scrollToEditor$lambda($editor, $root) {
    return function () {
      var target = calculateSimpleTarget(CellScrolling_getInstance(), $editor);
      target = Snapping_getInstance().yn1(target, $editor);
      return target.kku(get_origin_0($root));
    };
  }
  function CellScrolling$scrollToEditorAsync$lambda($editor, $cause, $root) {
    return function () {
      var target = calculateTarget(CellScrolling_getInstance(), $editor, $cause);
      return target.kku(get_origin_0($root));
    };
  }
  function CellScrolling$getLineBounds$lambda($within) {
    return function (cell) {
      return prevVisibleLeaf_0(cell, $within);
    };
  }
  function CellScrolling$getLineBounds$lambda_0($within) {
    return function (cell) {
      return nextVisibleLeaf_0(cell, $within);
    };
  }
  function CellScrolling$TargetBuilder$extendSideways$ref() {
    var l = function (p0) {
      return p0.rn1();
    };
    l.callableName = 'extendSideways';
    return l;
  }
  function CellScrolling$TargetBuilder$extendSideways$ref_0() {
    var l = function (p0) {
      return p0.rn1();
    };
    l.callableName = 'extendSideways';
    return l;
  }
  function CellScrolling() {
    CellScrolling_instance = this;
    this.ims_1 = Companion_instance_310.f5j().dn2(6).en2(1).fn2(3).gn2(4).k2p();
    this.jms_1 = CellTraits_instance.zm2('scrollingParameters', this.ims_1);
  }
  protoOf(CellScrolling).kms = function (cell) {
    // Inline function 'kotlin.require' call
    if (!cell.qlc()) {
      // Inline function 'jetbrains.ocelot.projectional.cell.util.scrolling.CellScrolling.scrollTo.<anonymous>' call
      var message = "Can't scroll to non-attached cell";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    var tmp_0;
    if (cell instanceof TextCell) {
      tmp_0 = !inPopup(cell);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      scrollToEditor(this, cell);
      tmp = Unit_instance;
    } else {
      scrollTo_0(cell);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(CellScrolling).hn2 = function (cell, cause) {
    // Inline function 'kotlin.require' call
    if (!cell.qlc()) {
      // Inline function 'jetbrains.ocelot.projectional.cell.util.scrolling.CellScrolling.scrollToAsync.<anonymous>' call
      var message = "Can't scroll to non-attached cell";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    var tmp_0;
    if (cell instanceof TextCell) {
      tmp_0 = !inPopup(cell);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = scrollToEditorAsync(this, cell, cause);
    } else {
      tmp = scrollToAsync(cell);
    }
    return tmp;
  };
  protoOf(CellScrolling).jmu = function (cell, cause) {
    this.hn2(cell, cause);
  };
  var CellScrolling_instance;
  function CellScrolling_getInstance() {
    if (CellScrolling_instance == null)
      new CellScrolling();
    return CellScrolling_instance;
  }
  function Builder_1() {
    this.zn1_1 = 0;
    this.an2_1 = 0;
    this.bn2_1 = 0;
    this.cn2_1 = 0;
  }
  protoOf(Builder_1).dn2 = function (lookaheadChars) {
    this.zn1_1 = lookaheadChars;
    return this;
  };
  protoOf(Builder_1).en2 = function (lookaheadLines) {
    this.an2_1 = lookaheadLines;
    return this;
  };
  protoOf(Builder_1).fn2 = function (lookbehindChars) {
    this.bn2_1 = lookbehindChars;
    return this;
  };
  protoOf(Builder_1).gn2 = function (lookSidewaysChars) {
    this.cn2_1 = lookSidewaysChars;
    return this;
  };
  protoOf(Builder_1).k2p = function () {
    ScrollingUtil_instance.in2(new Int32Array([this.zn1_1, this.an2_1, this.bn2_1, this.cn2_1]));
    return new ScrollingParameters(this);
  };
  function Companion_310() {
  }
  protoOf(Companion_310).f5j = function () {
    return new Builder_1();
  };
  var Companion_instance_310;
  function Companion_getInstance_310() {
    return Companion_instance_310;
  }
  function ScrollingParameters(builder) {
    this.sn1_1 = builder.zn1_1;
    this.tn1_1 = builder.an2_1;
    this.un1_1 = builder.bn2_1;
    this.vn1_1 = builder.cn2_1;
  }
  function findSuitableLike($this, example, cells) {
    // Inline function 'kotlin.sequences.filterIsInstance' call
    var tmp = filter(cells, ScrollingUtil$findSuitableLike$lambda);
    var tmp_0 = isInterface(tmp, Sequence) ? tmp : THROW_CCE();
    return firstOrNull_2(filter(tmp_0, ScrollingUtil$findSuitableLike$lambda_0(example)));
  }
  function isSuitable($this, cell) {
    return cell.elp().m2c() && !cell.np() && !isPlaceholder(cell) && cell.flu(1) > 0;
  }
  function isLike($this, cell, example) {
    return equals(cell.llu().qr(), example.llu().qr()) && cell.mlu().qr() === example.mlu().qr();
  }
  function ScrollingUtil$findSuitableLike$lambda(it) {
    return it instanceof TextCell;
  }
  function ScrollingUtil$findSuitableLike$lambda_0($example) {
    return function (cell) {
      return isSuitable(ScrollingUtil_instance, cell) && isLike(ScrollingUtil_instance, cell, $example);
    };
  }
  function ScrollingUtil() {
  }
  protoOf(ScrollingUtil).wn1 = function (chars, reference, defaultValue) {
    var tmp;
    if (isSuitable(this, reference)) {
      tmp = imul(reference.flu(1), chars);
    } else {
      var prev = findSuitableLike(this, reference, prevVisibleLeaves(reference));
      var tmp_0;
      if (!(prev == null)) {
        tmp_0 = imul(prev.flu(1), chars);
      } else {
        var next = findSuitableLike(this, reference, Composites_instance.u2r(reference));
        var tmp_1;
        if (next == null) {
          tmp_1 = defaultValue;
        } else {
          tmp_1 = imul(next.flu(1), chars);
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(ScrollingUtil).xn1 = function (lines, reference) {
    return imul(get_dimension(reference).fku_1, lines);
  };
  protoOf(ScrollingUtil).in2 = function (values) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.all' call
      var inductionVariable = 0;
      var last = values.length;
      while (inductionVariable < last) {
        var element = values[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'jetbrains.ocelot.projectional.cell.util.scrolling.ScrollingUtil.assertNonNegative.<anonymous>' call
        if (!(element >= 0)) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    var allNonNegative = tmp$ret$1;
    // Inline function 'kotlin.require' call
    if (!allNonNegative) {
      // Inline function 'jetbrains.ocelot.projectional.cell.util.scrolling.ScrollingUtil.assertNonNegative.<anonymous>' call
      var message = 'Negatives are not allowed: ' + toString_1(values);
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  };
  var ScrollingUtil_instance;
  function ScrollingUtil_getInstance() {
    return ScrollingUtil_instance;
  }
  function doSnapToRootBounds($this, rectangle, reference, verticalParams, horizontalParams) {
    var cellContainer = ensureNotNull(reference.llk());
    var root = cellContainer.ymi(reference);
    var rootBounds = get_bounds(ensureNotNull(root));
    var visible = cellContainer.nlq(root);
    var result = rectangle;
    var upperDistance = Rectangles_instance.yku(result, rootBounds);
    var lowerDistance = Rectangles_instance.zku(result, rootBounds);
    if (upperDistance < ScrollingUtil_instance.xn1(verticalParams.jn2_1, reference) && Rectangles_instance.xku(visible).lku(Rectangles_instance.xku(Rectangles_instance.dkv(result, upperDistance)))) {
      result = Rectangles_instance.dkv(result, upperDistance);
    } else if (lowerDistance < ScrollingUtil_instance.xn1(verticalParams.kn2_1, reference) && Rectangles_instance.xku(visible).lku(Rectangles_instance.xku(Rectangles_instance.ekv(result, lowerDistance)))) {
      result = Rectangles_instance.ekv(result, lowerDistance);
    }
    var leftDistance = Rectangles_instance.akv(result, rootBounds);
    var rightDistance = Rectangles_instance.bkv(result, rootBounds);
    if (leftDistance < ScrollingUtil_instance.wn1(horizontalParams.jn2_1, reference, 0) && Rectangles_instance.xku(visible).lku(Rectangles_instance.xku(Rectangles_instance.fkv(result, leftDistance)))) {
      result = Rectangles_instance.fkv(result, leftDistance);
    } else if (rightDistance < ScrollingUtil_instance.wn1(horizontalParams.kn2_1, reference, 0) && Rectangles_instance.xku(visible).lku(Rectangles_instance.xku(Rectangles_instance.gkv(result, rightDistance)))) {
      result = Rectangles_instance.gkv(result, rightDistance);
    }
    return result;
  }
  function getParameters($this, cell) {
    return cell.ulp($this.hn1_1);
  }
  function Snapping() {
    Snapping_instance = this;
    this.gn1_1 = Companion_instance_311.f5j().rn2(4).sn2(1).tn2(6).un2(4).vn2(4).wn2(4).k2p();
    this.hn1_1 = CellTraits_instance.zm2('snappingParameters', this.gn1_1);
  }
  protoOf(Snapping).in1 = function (rectangle, reference, cause) {
    var params = getParameters(this, reference);
    if (cause.ol1([KeyStrokeSpecs_getInstance().ll2_1])) {
      return doSnapToRootBounds(this, rectangle, reference, params.dn3(), params.en3());
    }
    var tmp;
    if (cause.ol1([KeyStrokeSpecs_getInstance().ml2_1])) {
      tmp = doSnapToRootBounds(this, rectangle, reference, params.dn3(), params.fn3());
    } else {
      tmp = this.yn1(rectangle, reference);
    }
    return tmp;
  };
  protoOf(Snapping).yn1 = function (rectangle, reference) {
    var params = getParameters(this, reference);
    return doSnapToRootBounds(this, rectangle, reference, params.dn3(), params.gn3());
  };
  var Snapping_instance;
  function Snapping_getInstance() {
    if (Snapping_instance == null)
      new Snapping();
    return Snapping_instance;
  }
  function SnappingHome() {
    SnappingHome_instance = this;
    this.en1_1 = CellTraits_instance.zm2('viewPartToSnap', 1.0 / 2);
  }
  protoOf(SnappingHome).fn1 = function (to, target, lineBounds) {
    var cellContainer = ensureNotNull(to.llk());
    var root = cellContainer.ymi(to);
    var rootBounds = get_bounds(ensureNotNull(root));
    var viewportWidth = cellContainer.nlq(root).dku_1.eku_1;
    var caretAbsX = Rectangles_instance.akv(to.elu(), rootBounds);
    if (caretAbsX <= numberToInt(viewportWidth * to.ulp(this.en1_1))) {
      var snappingSize = Rectangles_instance.akv(target, rootBounds);
      var resultRect = Rectangles_instance.fkv(target, snappingSize);
      var resultLine = resultRect.nku(lineBounds);
      if (resultLine.dku_1.eku_1 <= viewportWidth) {
        return resultRect;
      }
    }
    return target;
  };
  var SnappingHome_instance;
  function SnappingHome_getInstance() {
    if (SnappingHome_instance == null)
      new SnappingHome();
    return SnappingHome_instance;
  }
  function OneAxisSnapping(beginning, end) {
    this.jn2_1 = beginning;
    this.kn2_1 = end;
  }
  function Builder_2() {
    this.ln2_1 = 0;
    this.mn2_1 = 0;
    this.nn2_1 = 0;
    this.on2_1 = 0;
    this.pn2_1 = 0;
    this.qn2_1 = 0;
  }
  protoOf(Builder_2).rn2 = function (leftChars) {
    this.ln2_1 = leftChars;
    return this;
  };
  protoOf(Builder_2).sn2 = function (rightChars) {
    this.mn2_1 = rightChars;
    return this;
  };
  protoOf(Builder_2).tn2 = function (longLeftChars) {
    this.nn2_1 = longLeftChars;
    return this;
  };
  protoOf(Builder_2).un2 = function (longRightChars) {
    this.on2_1 = longRightChars;
    return this;
  };
  protoOf(Builder_2).vn2 = function (topLines) {
    this.pn2_1 = topLines;
    return this;
  };
  protoOf(Builder_2).wn2 = function (bottomLines) {
    this.qn2_1 = bottomLines;
    return this;
  };
  protoOf(Builder_2).k2p = function () {
    ScrollingUtil_instance.in2(new Int32Array([this.ln2_1, this.mn2_1, this.nn2_1, this.on2_1, this.pn2_1, this.qn2_1]));
    return new SnappingParameters(this);
  };
  function Companion_311() {
  }
  protoOf(Companion_311).f5j = function () {
    return new Builder_2();
  };
  var Companion_instance_311;
  function Companion_getInstance_311() {
    return Companion_instance_311;
  }
  function SnappingParameters(builder) {
    this.xn2_1 = builder.ln2_1;
    this.yn2_1 = builder.mn2_1;
    this.zn2_1 = builder.nn2_1;
    this.an3_1 = builder.on2_1;
    this.bn3_1 = builder.pn2_1;
    this.cn3_1 = builder.qn2_1;
  }
  protoOf(SnappingParameters).gn3 = function () {
    return new OneAxisSnapping(this.xn2_1, this.yn2_1);
  };
  protoOf(SnappingParameters).fn3 = function () {
    return new OneAxisSnapping(this.xn2_1, this.an3_1);
  };
  protoOf(SnappingParameters).en3 = function () {
    return new OneAxisSnapping(this.zn2_1, this.yn2_1);
  };
  protoOf(SnappingParameters).dn3 = function () {
    return new OneAxisSnapping(this.bn3_1, this.cn3_1);
  };
  function URLCellTrait$Companion$URL$lambda(cell) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = cell.laz().m2c();
    } else {
      tmp = null;
    }
    return tmp;
  }
  function tryToNavigate($this, cell) {
    var urlToUse = cell.ulp(Companion_getInstance_312().hn3_1);
    if (!(urlToUse == null)) {
      $this.jn3(urlToUse);
      return true;
    }
    return false;
  }
  function Companion_312() {
    Companion_instance_312 = this;
    var tmp = this;
    tmp.hn3_1 = new CellTraitPropertySpec('CellURL', URLCellTrait$Companion$URL$lambda);
  }
  var Companion_instance_312;
  function Companion_getInstance_312() {
    if (Companion_instance_312 == null)
      new Companion_312();
    return Companion_instance_312;
  }
  function URLCellTrait(navigateKeyStrokes) {
    Companion_getInstance_312();
    CellTrait.call(this);
    this.in3_1 = navigateKeyStrokes;
  }
  protoOf(URLCellTrait).glo = function (cell) {
    cell.bln(get_LINK(), true);
    if (cell instanceof TextCell) {
      cell.hlu().v2c(Companion_getInstance_325().clt_1);
    }
  };
  protoOf(URLCellTrait).llm = function (cell, event) {
    if (event.rl1(this.in3_1.slice()) && tryToNavigate(this, cell)) {
      event.ol0();
    } else {
      protoOf(CellTrait).llm.call(this, cell, event);
    }
  };
  protoOf(URLCellTrait).jlo = function (cell, event) {
    if (tryToNavigate(this, cell)) {
      event.ol0();
    } else {
      protoOf(CellTrait).jlo.call(this, cell, event);
    }
  };
  function ValueEditors$getEnumValidatedProperty$1$matchers$$inlined$specMatcher$1$1($matchingText, $sortPriority, $isCaseSensitive, $textCell, $name) {
    this.on3_1 = $textCell;
    this.pn3_1 = $name;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(ValueEditors$getEnumValidatedProperty$1$matchers$$inlined$specMatcher$1$1).wm9 = function (text) {
    // Inline function 'jetbrains.ocelot.projectional.cell.util.valueEditors.<no name provided>.matchers.<anonymous>.<anonymous>.<anonymous>' call
    this.on3_1.laz().t2c(this.pn3_1);
    return toEnd_0(this.on3_1);
  };
  function ValueEditors$getEnumValidatedProperty$o$matchers$lambda($spec, $enumInfo, $textCell) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        // Inline function 'jetbrains.ocelot.projectional.cell.util.valueEditors.<no name provided>.matchers.<anonymous>' call
        // Inline function 'kotlin.collections.map' call
        var this_0 = $enumInfo.o2p();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.k();
        while (_iterator__ex2g4s.l()) {
          var item = _iterator__ex2g4s.m();
          // Inline function 'jetbrains.ocelot.projectional.cell.util.valueEditors.<no name provided>.matchers.<anonymous>.<anonymous>' call
          // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
          var tmp$ret$1 = new ValueEditors$getEnumValidatedProperty$1$matchers$$inlined$specMatcher$1$1(item, 0, true, $textCell, item);
          destination.e(tmp$ret$1);
        }
        var tmp$ret$4 = toCompletionSupplier_0(destination);
        tmp = new SpecMatchResult(tmp$ret$4);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function ValueEditors$getEnumValidatedProperty$o$get$lambda($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function ValueEditors$booleanProperty$1$get$$inlined$specMatcher$1$1($matchingText, $sortPriority, $isCaseSensitive, $textCell) {
    this.un3_1 = $textCell;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(ValueEditors$booleanProperty$1$get$$inlined$specMatcher$1$1).wm9 = function (text) {
    // Inline function 'jetbrains.ocelot.projectional.cell.util.valueEditors.<no name provided>.get.<anonymous>.<anonymous>' call
    this.un3_1.laz().t2c('true');
    return get_EMPTY_CELL_ACTION();
  };
  function ValueEditors$booleanProperty$1$get$$inlined$specMatcher$1$2($matchingText, $sortPriority, $isCaseSensitive, $textCell) {
    this.zn3_1 = $textCell;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(ValueEditors$booleanProperty$1$get$$inlined$specMatcher$1$2).wm9 = function (text) {
    // Inline function 'jetbrains.ocelot.projectional.cell.util.valueEditors.<no name provided>.get.<anonymous>.<anonymous>' call
    this.zn3_1.laz().t2c('false');
    return get_EMPTY_CELL_ACTION();
  };
  function ValueEditors$booleanProperty$o$get$lambda($spec, $textCell) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        // Inline function 'jetbrains.ocelot.projectional.cell.util.valueEditors.<no name provided>.get.<anonymous>' call
        // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
        var tmp_0 = new ValueEditors$booleanProperty$1$get$$inlined$specMatcher$1$1('true', 0, true, $textCell);
        // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
        var tmp$ret$1 = new ValueEditors$booleanProperty$1$get$$inlined$specMatcher$1$2('false', 0, true, $textCell);
        var tmp$ret$2 = simpleCompletionSupplier([tmp_0, tmp$ret$1]);
        tmp = new SpecMatchResult(tmp$ret$2);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function getEnumValidatedProperty($this, textCell, enumInfo) {
    var validator = ValueEditors$getEnumValidatedProperty$lambda(enumInfo);
    var trait = new ValueEditors$getEnumValidatedProperty$trait$1(validator, enumInfo, textCell);
    textCell.olp(trait);
    return asValidatedProp(textCell.laz(), '', validator);
  }
  function intProperty$safeToInt(_this__u8e3s4) {
    var tmp;
    try {
      tmp = toInt(_this__u8e3s4);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp_0 = 0;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function ValueEditors$getEnumValidatedProperty$lambda($enumInfo) {
    return function (s) {
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(s) === 0) {
        tmp = true;
      } else {
        tmp = $enumInfo.q2p(s);
      }
      return tmp;
    };
  }
  function ValueEditors$getEnumValidatedProperty$trait$1($validator, $enumInfo, $textCell) {
    BaseDerivedCellTrait.call(this, TextEditing_getInstance().gmu($validator));
    var tmp = this;
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec = Completion_getInstance().cm1_1;
    var tmp$ret$0 = ValueEditors$getEnumValidatedProperty$o$matchers$lambda(spec, $enumInfo, $textCell);
    tmp.bn4_1 = listOf_0([tmp$ret$0, specMatcherValue(TextEditing_getInstance().dlx_1, true)]);
  }
  protoOf(ValueEditors$getEnumValidatedProperty$trait$1).flo = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var specMatchers = this.bn4_1;
    var tmp = asSequence_0(specMatchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, ValueEditors$getEnumValidatedProperty$o$get$lambda(spec))));
    var tmp_0;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.util.valueEditors.<no name provided>.get.<anonymous>' call
      tmp_0 = protoOf(BaseDerivedCellTrait).flo.call(this, cell, spec);
    } else {
      tmp_0 = result.sma_1;
    }
    return tmp_0;
  };
  function EnumInfo$safeValueOf$ref($boundThis) {
    var l = function (p0) {
      return $boundThis.p2p(p0);
    };
    l.callableName = 'safeValueOf';
    return l;
  }
  function ValueEditors$nullableEnumProperty$lambda(enumT) {
    return enumT == null ? '' : '' + toString_0(enumT);
  }
  function ValueEditors$booleanProperty$trait$1($textCell) {
    this.dn4_1 = $textCell;
    BaseDerivedCellTrait.call(this, TextEditing_getInstance().gmu(Validators_getInstance().rlh()));
  }
  protoOf(ValueEditors$booleanProperty$trait$1).flo = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec_0 = Completion_getInstance().cm1_1;
    var specMatcher = ValueEditors$booleanProperty$o$get$lambda(spec_0, this.dn4_1);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.cell.util.valueEditors.<no name provided>.get.<anonymous>' call
      tmp = protoOf(BaseDerivedCellTrait).flo.call(this, cell, spec);
    } else {
      tmp = result.sma_1;
    }
    return tmp;
  };
  function toBoolean$ref() {
    var l = function (p0) {
      return toBoolean(p0);
    };
    l.callableName = 'toBoolean';
    return l;
  }
  function ValueEditors$booleanProperty$lambda(bool) {
    return '' + bool;
  }
  function ValueEditors$intProperty$safeToInt$ref() {
    var l = function (p0) {
      return intProperty$safeToInt(p0);
    };
    l.callableName = 'safeToInt';
    return l;
  }
  function ValueEditors$intProperty$lambda(int) {
    return '' + int;
  }
  function ValueEditors() {
  }
  protoOf(ValueEditors).en4 = function (textCell, enumInfo) {
    var validatedProperty = getEnumValidatedProperty(this, textCell, enumInfo);
    var sToT = EnumInfo$safeValueOf$ref(enumInfo);
    var tToS = ValueEditors$nullableEnumProperty$lambda;
    return map_1(validatedProperty, sToT, tToS);
  };
  protoOf(ValueEditors).fn4 = function (textCell) {
    var trait = new ValueEditors$booleanProperty$trait$1(textCell);
    textCell.olp(trait);
    var textProp = textCell.laz();
    var sToT = toBoolean$ref();
    var tToS = ValueEditors$booleanProperty$lambda;
    return map_1(textProp, sToT, tToS);
  };
  protoOf(ValueEditors).gn4 = function (textCell) {
    textCell.olp(TextEditing_getInstance().gmu(Validators_getInstance().qlh()));
    var textProp = textCell.laz();
    var sToT = ValueEditors$intProperty$safeToInt$ref();
    var tToS = ValueEditors$intProperty$lambda;
    return map_1(textProp, sToT, tToS);
  };
  var ValueEditors_instance;
  function ValueEditors_getInstance() {
    return ValueEditors_instance;
  }
  function ViewCell() {
  }
  protoOf(ViewCell).qn4 = function () {
    return this.pn4_1;
  };
  function ToCellMapping() {
  }
  function getMapperCellFinder(ctx) {
    return new getMapperCellFinder$1(ctx);
  }
  function getMapperCellFinder$1($ctx) {
    this.tn4_1 = $ctx;
  }
  protoOf(getMapperCellFinder$1).un4 = function (source) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.tn4_1.qld(source);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.cellProvider.mapper.<no name provided>.getCells.<anonymous>' call
      var tmp$ret$0 = item.ql9_1;
      destination.e(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var element = _iterator__ex2g4s_0.m();
      if (!(element == null) ? isInterface(element, Cell) : false) {
        destination_0.e(element);
      }
    }
    return destination_0;
  };
  protoOf(getMapperCellFinder$1).vn4 = function (source) {
    return this.un4(!(source == null) ? source : THROW_CCE());
  };
  function getCellProviderFromMapper(mapper) {
    var mappingContext = mapper.mlb();
    if (!mappingContext.tld(Companion_getInstance_260().sla_1)) {
      mappingContext.rld(Companion_getInstance_260().sla_1, new ByTargetIndex(mappingContext));
    }
    return new MapperCellProvider(mapper);
  }
  function doGetCells($this, mapper, actualSource) {
    if (mapper.pl9_1 === actualSource) {
      return listOf(mapper.ql9_1);
    }
    // Inline function 'kotlin.collections.listOf' call
    var result = emptyList();
    var foundInMapper = findCellInContainer($this, mapper, actualSource);
    if (!(foundInMapper == null)) {
      result = listOf(foundInMapper);
    }
    var tmp = result;
    var tmp_0 = mapper.ylc();
    return plus_6(tmp, filterNotNull_0(map(tmp_0, MapperCellProvider$Companion$doGetCells$lambda(actualSource))));
  }
  function getSource_0($this, container, target) {
    var tmp;
    if (isInterface(container, ToCellMapping)) {
      tmp = container.sn4(target);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function findCellInContainer($this, container, source) {
    var tmp;
    if (isInterface(container, ToCellMapping)) {
      tmp = container.rn4(source);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function MapperCellProvider$Companion$doGetCells$lambda($actualSource) {
    return function (sync) {
      return findCellInContainer(Companion_getInstance_313(), sync, $actualSource);
    };
  }
  function _get_mappingContext__5ixeqe($this) {
    return $this.wn4_1.mlb();
  }
  function doGetSource($this, mapper, actualTarget) {
    var tmp;
    if (mapper.ql9_1 === actualTarget) {
      tmp = mapper.pl9_1;
    } else {
      var tmp0_elvis_lhs = getSource_0(Companion_getInstance_313(), mapper, actualTarget);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp_1 = mapper.ylc();
        tmp_0 = firstOrNull_2(filterNotNull_0(map(tmp_1, MapperCellProvider$doGetSource$lambda(actualTarget))));
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function lookupCells($this, source, actualSource, parents) {
    var $this_0 = $this;
    var source_0 = source;
    var actualSource_0 = actualSource;
    var parents_0 = parents;
    $l$1: do {
      $l$0: do {
        var mappers = _get_mappingContext__5ixeqe($this_0).pld($this_0.wn4_1, source_0);
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!mappers.p()) {
          // Inline function 'kotlin.collections.flatMap' call
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination = ArrayList_init_$Create$();
          var _iterator__ex2g4s = mappers.k();
          while (_iterator__ex2g4s.l()) {
            var element = _iterator__ex2g4s.m();
            // Inline function 'jetbrains.ocelot.projectional.cellProvider.mapper.MapperCellProvider.lookupCells.<anonymous>' call
            var tmp_0;
            var tmp_1 = element.ql9_1;
            if (!(tmp_1 == null) ? isInterface(tmp_1, Cell) : false) {
              var cellMapper = element instanceof Mapper ? element : THROW_CCE();
              tmp_0 = doGetCells(Companion_getInstance_313(), cellMapper, actualSource_0);
            } else {
              tmp_0 = emptyList();
            }
            var list = tmp_0;
            addAll_1(destination, list);
          }
          var cells = destination;
          tmp = Companion_instance_263.ilh(cells);
        } else {
          if (parents_0.l()) {
            var tmp0 = $this_0;
            var tmp1 = ensureNotNull(parents_0.m());
            var tmp2 = actualSource_0;
            var tmp3 = parents_0;
            $this_0 = tmp0;
            source_0 = tmp1;
            actualSource_0 = tmp2;
            parents_0 = tmp3;
            continue $l$0;
          } else {
            tmp = emptyList();
          }
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function Companion_313() {
    Companion_instance_313 = this;
    this.xn4_1 = emptyList().k();
  }
  var Companion_instance_313;
  function Companion_getInstance_313() {
    if (Companion_instance_313 == null)
      new Companion_313();
    return Companion_instance_313;
  }
  function MapperCellProvider$doGetSource$lambda($actualTarget) {
    return function (sync) {
      return getSource_0(Companion_getInstance_313(), sync, $actualTarget);
    };
  }
  function MapperCellProvider(rootMapper) {
    Companion_getInstance_313();
    this.wn4_1 = rootMapper;
  }
  protoOf(MapperCellProvider).yn4 = function (sourcePath) {
    var tmp;
    if (sourcePath.l()) {
      var actualSource = ensureNotNull(sourcePath.m());
      tmp = lookupCells(this, actualSource, actualSource, sourcePath);
    } else {
      tmp = emptyList();
    }
    return tmp;
  };
  protoOf(MapperCellProvider).un4 = function (source) {
    return lookupCells(this, source, source, Companion_getInstance_313().xn4_1);
  };
  protoOf(MapperCellProvider).vn4 = function (source) {
    return this.un4(!(source == null) ? source : THROW_CCE());
  };
  protoOf(MapperCellProvider).zn4 = function (cell, predicate) {
    var index = _get_mappingContext__5ixeqe(this).sld(Companion_getInstance_260().sla_1);
    // Inline function 'jetbrains.ocelot.base.composite.dispatchByParent' call
    var current = cell;
    while (!(current == null)) {
      // Inline function 'jetbrains.ocelot.projectional.cellProvider.mapper.MapperCellProvider.getSource.<anonymous>' call
      var $this$dispatchByParent = current;
      var mappers = index.blb($this$dispatchByParent);
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!mappers.p()) {
        var mapper = first_0(mappers);
        var source = doGetSource(this, mapper, cell);
        if (!(source == null) && predicate(source)) {
          return source;
        }
        var mapperSource = mapper.pl9_1;
        if (predicate(mapperSource)) {
          return mapperSource;
        }
      }
      current = current.yt();
    }
    return null;
  };
  function updateFocused($this, newFocused) {
    $this.bn5_1.vr();
    $this.bn5_1 = HighlightUtil_instance.en5(newFocused);
  }
  function updatePaired($this, newPaired, focused) {
    $this.cn5_1.vr();
    $this.cn5_1 = HighlightUtil_instance.fn5(newPaired).sr(HighlightUtil_instance.en5(minus_3(newPaired, focused)));
    $this.an5_1 = newPaired;
  }
  function CellNavigationController$FocusedCellHandler$onEvent$lambda($newFocused, this$0, $newFocusedSet) {
    return function (it) {
      var newPaired = PairUtil_instance.gn5($newFocused);
      var tmp;
      if (!equals(newPaired, this$0.an5_1)) {
        updatePaired(this$0, newPaired, $newFocusedSet);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CellNavigationController$Companion$NAVIGABLE$lambda(cell) {
    return cell.ulp(TextEditing_getInstance().ylw_1) && cell.clo(get_FOCUSABLE()) && isVisible_1(cell);
  }
  function CellNavigationController$Companion$EDITABLE$lambda(cell) {
    return cell.ulp(TextEditing_getInstance().zlw_1) && cell.clo(get_FOCUSABLE()) && isVisible_1(cell) && !cell.ulp(Companion_getInstance_314().jn5_1);
  }
  function install_0($this) {
    var result = new CompositeDisposable([]);
    var tmp = selectedCaretOffset($this);
    var tmp_0 = tmp.p27(CellNavigationController$install$lambda($this));
    var tmp_1 = focusedCell($this);
    result.ur([tmp_0, tmp_1.p27(CellNavigationController$install$lambda_0($this))]);
    var tmp_2 = $this.nn5_1.u3o();
    result.ur([tmp_2.olp(new CellNavigationController$install$3($this))]);
    var focusedCellHandler = new FocusedCellHandler();
    result.ur([$this.nn5_1.rlp().o27(focusedCellHandler)]);
    result.ur([focusedCellHandler]);
    return result;
  }
  function focusedCell($this) {
    return $this.nn5_1.rlp();
  }
  function scrollTo_4($this, cell) {
    var parent = cell.yt();
    if (parent == null) {
      scrollTo_0(cell);
    } else {
      var delta = new Vector(10, 10);
      var bounds = new Rectangle(get_origin_0(cell).kku(get_origin_0(parent).jku(delta)), get_dimension(cell).jku(delta.h53(2)));
      var target = new Rectangle(Companion_getInstance_251().iku_1, get_dimension(parent));
      if (bounds.qku(target)) {
        scrollTo_2(parent, bounds.rku(target));
      } else {
        scrollTo_0(cell);
      }
    }
  }
  function root_0($this) {
    return $this.nn5_1.u3o();
  }
  function moveCaretTo($this, cell, offset) {
    return get_positionHandler(cell).ymr().t2c(offset);
  }
  function moveToHome($this, next) {
    var tmp1_safe_receiver = next == null ? null : get_positionHandler(next);
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.wmr();
    }
  }
  function moveToEnd($this, next) {
    var tmp1_safe_receiver = next == null ? null : get_positionHandler(next);
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.xmr();
    }
  }
  function selectedXOffset($this) {
    return selectedCaretOffset($this).qr() + get_origin_0(ensureNotNull(focusedCell($this).qr())).eku_1 | 0;
  }
  function selectedCaretOffset($this) {
    var focusedCell_0 = focusedCell($this);
    var selector = CellNavigationController$selectedCaretOffset$lambda;
    return select(focusedCell_0, 0, selector);
  }
  function handleKeyPress($this, cell, event) {
    var current = ensureNotNull(focusedCell($this).qr());
    var currentOffset = {_v: null};
    if (event.ml1(Key_UP_getInstance(), []) || event.ml1(Key_DOWN_getInstance(), []) || event.ml1(Key_PAGE_UP_getInstance(), []) || event.ml1(Key_PAGE_DOWN_getInstance(), [])) {
      currentOffset._v = $this.on5_1;
      if (currentOffset._v == null) {
        currentOffset._v = selectedXOffset($this);
      }
    }
    var cellContainer = ensureNotNull(current.llk());
    var visibleRect = cellContainer.nlq(cellContainer.u3o());
    var next = null;
    var restoreOffset = false;
    if (event.ml1(Key_RIGHT_getInstance(), [])) {
      next = nextFocusable(current);
      moveToHome($this, next);
    } else if (event.ol1([KeyStrokeSpecs_getInstance().ql2_1])) {
      next = nextEditable($this, current);
    } else if (event.ol1([KeyStrokeSpecs_getInstance().rl2_1])) {
      next = nextEditable($this, current);
    } else if (event.ml1(Key_LEFT_getInstance(), [])) {
      next = prevFocusable(current);
      moveToEnd($this, next);
    } else if (event.ol1([KeyStrokeSpecs_getInstance().pl2_1])) {
      next = prevEditable($this, current);
    } else if (event.ol1([KeyStrokeSpecs_getInstance().sl2_1])) {
      next = prevEditable($this, current);
    } else if (event.ml1(Key_UP_getInstance(), [])) {
      next = upperClosest($this, current, ensureNotNull(currentOffset._v));
      if (!(next == null)) {
        restoreOffset = true;
      } else {
        next = homeElement_0($this, current);
      }
    } else if (event.ml1(Key_DOWN_getInstance(), [])) {
      next = lowerClosest($this, current, ensureNotNull(currentOffset._v));
      if (!(next == null)) {
        restoreOffset = true;
      } else {
        next = endElement_0($this, current);
      }
    } else if (event.ml1(Key_PAGE_UP_getInstance(), [])) {
      var pageUpDown = new CellNavigationController$handleKeyPress$pageUpDown$1(current, currentOffset, visibleRect, $this);
      next = pageUpDown.un5();
      restoreOffset = true;
    } else if (event.ml1(Key_PAGE_DOWN_getInstance(), [])) {
      var pageUpDown_0 = new CellNavigationController$handleKeyPress$pageUpDown$2(current, currentOffset, visibleRect, $this);
      next = pageUpDown_0.un5();
      restoreOffset = true;
    } else if (event.ol1([KeyStrokeSpecs_getInstance().ll2_1])) {
      next = homeElement_0($this, current);
    } else if (event.ol1([KeyStrokeSpecs_getInstance().ml2_1])) {
      next = endElement_0($this, current);
    } else if (event.ol1([KeyStrokeSpecs_getInstance().nl2_1])) {
      next = firstFocusable_0(cell, true);
      moveToHome($this, next);
    } else if (event.ol1([KeyStrokeSpecs_getInstance().ol2_1])) {
      next = lastFocusable_0(cell, true);
      moveToEnd($this, next);
    } else if (event.ol1([KeyStrokeSpecs_getInstance().el3_1])) {
      if (increaseSelection($this, current)) {
        event.ol0();
        return Unit_instance;
      }
    } else if (event.ol1([KeyStrokeSpecs_getInstance().fl3_1])) {
      if (decreaseSelection($this)) {
        event.ol0();
        return Unit_instance;
      }
      next = firstFocusable_0(current, false);
    } else if (event.ol1([KeyStrokeSpecs_getInstance().jl3_1]) && !(current.ulp(Companion_getInstance_314().hn5_1) == null)) {
      next = ensureNotNull(current.ulp(Companion_getInstance_314().hn5_1));
      if (Composites_instance.z2r(next, current)) {
        moveToHome($this, next);
      } else {
        moveToEnd($this, next);
      }
      restoreOffset = false;
    }
    if (!(next == null)) {
      focusedCell($this).t2c(next);
      if (restoreOffset) {
        moveCaretTo($this, next, ensureNotNull(currentOffset._v) - get_origin_0(next).eku_1 | 0);
        $this.on5_1 = currentOffset._v;
      }
      if (next instanceof TextCell) {
        CellScrolling_getInstance().jmu(next, event);
      } else {
        scrollTo_4($this, next);
      }
      event.ol0();
    }
  }
  function prevEditable($this, current) {
    var tmp;
    if (get_positionHandler(current).dlu()) {
      // Inline function 'jetbrains.ocelot.base.composite.Composites.prevNavOrder' call
      var p = Companion_getInstance_314().mn5_1;
      // Inline function 'kotlin.sequences.find' call
      var tmp0 = Composites_instance.y2r(current);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.sequences.firstOrNull' call
        var _iterator__ex2g4s = tmp0.k();
        while (_iterator__ex2g4s.l()) {
          var element = _iterator__ex2g4s.m();
          // Inline function 'jetbrains.ocelot.base.composite.Composites.prevNavOrder.<anonymous>' call
          if (p(element)) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = current;
    }
    var next = tmp;
    moveToHome($this, next);
    return next;
  }
  function nextEditable($this, current) {
    // Inline function 'jetbrains.ocelot.base.composite.Composites.nextNavOrder' call
    var p = Companion_getInstance_314().mn5_1;
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = Composites_instance.x2r(current);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.base.composite.Composites.nextNavOrder.<anonymous>' call
        if (p(element)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var next = tmp$ret$1;
    if (!(next == null)) {
      moveToHome($this, next);
    } else if (!get_positionHandler(current).blu()) {
      next = current;
      moveToEnd($this, next);
    }
    return next;
  }
  function endElement_0($this, current) {
    var next = endElement(current, 2);
    moveToEnd($this, next);
    return next;
  }
  function homeElement_0($this, current) {
    var next = homeElement(current, 2);
    moveToHome($this, next);
    return next;
  }
  function upperClosest($this, cell, offset) {
    var upDown = new CellNavigationController$upperClosest$upDown$1();
    return upDown.wn5(cell, offset);
  }
  function increaseSelection($this, current) {
    if ($this.qn5_1.p()) {
      var tmp0_elvis_lhs = getCurrentScope($this, current);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var currentScope = tmp;
      $this.qn5_1.dg(currentScope);
    }
    var next = $this.qn5_1.bg().wn0();
    while (!(next == null)) {
      if (!next.dly()) {
        selectScope($this, next);
        $this.qn5_1.dg(next);
        return true;
      }
      next = next.wn0();
    }
    return false;
  }
  function getCurrentScope($this, current) {
    var scope = current.ulp(CellScopes_getInstance().an1_1);
    while (!(scope == null)) {
      var nextScope = scope.wn0();
      if (nextScope == null || !nextScope.dly()) {
        return scope;
      }
      scope = nextScope;
    }
    return null;
  }
  function decreaseSelection($this) {
    if ($this.qn5_1.p()) {
      return false;
    }
    $this.qn5_1.fg();
    while (!$this.qn5_1.p()) {
      var scope = $this.qn5_1.cg();
      if (ensureNotNull(scope).w4u()) {
        selectScope($this, scope);
        return true;
      }
      $this.qn5_1.fg();
    }
    return false;
  }
  function selectScope($this, scope) {
    try {
      $this.pn5_1 = false;
      $this.nn5_1.rlp().t2c(null);
      scope.un0();
    }finally {
      $this.pn5_1 = true;
    }
  }
  function lowerClosest($this, cell, offset) {
    var upDown = new CellNavigationController$lowerClosest$upDown$1();
    return upDown.wn5(cell, offset);
  }
  function handleMousePress($this, event) {
    if (!event.tl3_1.equals(MouseButton_LEFT_getInstance()))
      return Unit_instance;
    var closest = findFocusableAt($this, event.zl3());
    if (closest == null || !Companion_getInstance_314().ln5_1(closest)) {
      closest = Cells_getInstance().lmx(root_0($this), event.zl3(), Companion_getInstance_314().ln5_1);
    }
    if (!(closest == null)) {
      var navigationEvent = new FocusEvent(focusedCell($this).qr(), closest);
      focusedCell($this).t2c(closest);
      if (event.xl3_1 < get_origin_0(closest).eku_1) {
        moveToHome($this, closest);
      } else {
        moveToEnd($this, closest);
      }
      event.ol0();
      closest.mlp(navigationEvent, Cells_getInstance().jmg_1);
    }
  }
  function findFocusableAt($this, loc) {
    var cell = $this.nn5_1.mlq(root_0($this), loc);
    var tmp;
    if (isTrivial($this, cell) || !ensureNotNull(cell).hlp().qr()) {
      tmp = null;
    } else {
      tmp = cell;
    }
    return tmp;
  }
  function isTrivial($this, cell) {
    return cell == null || cell === root_0($this);
  }
  function FocusedCellHandler() {
    var tmp = this;
    // Inline function 'kotlin.collections.setOf' call
    tmp.an5_1 = emptySet();
    this.bn5_1 = Companion_getInstance_25().wr_1;
    this.cn5_1 = Companion_getInstance_25().wr_1;
    this.dn5_1 = Companion_getInstance_25().wr_1;
  }
  protoOf(FocusedCellHandler).umq = function (event) {
    var oldFocused = event.o2e_1;
    if (!(oldFocused == null)) {
      // Inline function 'kotlin.collections.setOf' call
      var tmp$ret$0 = emptySet();
      updateFocused(this, tmp$ret$0);
      // Inline function 'kotlin.collections.setOf' call
      var tmp = emptySet();
      // Inline function 'kotlin.collections.setOf' call
      var tmp$ret$2 = emptySet();
      updatePaired(this, tmp, tmp$ret$2);
      this.dn5_1.vr();
      this.dn5_1 = Companion_getInstance_25().wr_1;
    }
    var newFocused = event.p2e_1;
    if (!(newFocused == null)) {
      var newFocusedSet = setOf(newFocused);
      updateFocused(this, newFocusedSet);
      updatePaired(this, PairUtil_instance.gn5(newFocused), newFocusedSet);
      if (newFocused instanceof TextCell) {
        var tmp_0 = this;
        var tmp_1 = newFocused.zlt();
        tmp_0.dn5_1 = tmp_1.p27(CellNavigationController$FocusedCellHandler$onEvent$lambda(newFocused, this, newFocusedSet));
      }
    }
  };
  protoOf(FocusedCellHandler).d28 = function (event) {
    return this.umq(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  protoOf(FocusedCellHandler).vr = function () {
    this.bn5_1.vr();
    this.cn5_1.vr();
    this.dn5_1.vr();
  };
  function PageUpDown(cell, offset, pageHeight) {
    this.rn5_1 = cell;
    this.sn5_1 = offset;
    this.tn5_1 = pageHeight;
  }
  protoOf(PageUpDown).un5 = function () {
    var current = this.rn5_1;
    while (true) {
      var next = this.xn5(current, this.sn5_1);
      if (next == null) {
        var tmp;
        if (next === this.rn5_1) {
          tmp = null;
        } else {
          tmp = current;
        }
        return tmp;
      }
      if (get_bounds(this.rn5_1).tku(get_origin_0(next)) >= this.tn5_1) {
        return next;
      }
      current = next;
    }
  };
  function Companion_314() {
    Companion_instance_314 = this;
    this.hn5_1 = CellTraitPropertySpec_init_$Create$('pairCell', null);
    this.in5_1 = CellPropertySpec_init_$Create$('showFocusHighlight', false);
    this.jn5_1 = CellTraitPropertySpec_init_$Create$('space', false);
    this.kn5_1 = 2;
    var tmp = this;
    tmp.ln5_1 = CellNavigationController$Companion$NAVIGABLE$lambda;
    var tmp_0 = this;
    tmp_0.mn5_1 = CellNavigationController$Companion$EDITABLE$lambda;
  }
  protoOf(Companion_314).yn5 = function (container) {
    var controller = new CellNavigationController(container);
    return install_0(controller);
  };
  var Companion_instance_314;
  function Companion_getInstance_314() {
    if (Companion_instance_314 == null)
      new Companion_314();
    return Companion_instance_314;
  }
  function CellNavigationController$install$lambda(this$0) {
    return function (it) {
      this$0.on5_1 = null;
      return Unit_instance;
    };
  }
  function CellNavigationController$install$lambda_0(this$0) {
    return function (it) {
      var tmp;
      if (this$0.pn5_1) {
        this$0.qn5_1.m2();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function CellNavigationController$install$3(this$0) {
    this.zn5_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(CellNavigationController$install$3).llm = function (cell, event) {
    handleKeyPress(this.zn5_1, cell, event);
    if (!event.ml0_1) {
      protoOf(CellTrait).llm.call(this, cell, event);
    }
  };
  protoOf(CellNavigationController$install$3).llo = function (cell, event) {
    handleMousePress(this.zn5_1, event);
    if (!event.ml0_1) {
      protoOf(CellTrait).llo.call(this, cell, event);
    }
  };
  function CellNavigationController$selectedCaretOffset$lambda(cell) {
    var positionHandler = get_positionHandler(cell);
    return positionHandler.ymr();
  }
  function CellNavigationController$handleKeyPress$pageUpDown$1($current, $currentOffset, $visibleRect, this$0) {
    this.dn6_1 = this$0;
    PageUpDown.call(this, $current, ensureNotNull($currentOffset._v), $visibleRect.dku_1.fku_1);
  }
  protoOf(CellNavigationController$handleKeyPress$pageUpDown$1).xn5 = function (current, offset) {
    return upperClosest(this.dn6_1, current, offset);
  };
  function CellNavigationController$handleKeyPress$pageUpDown$2($current, $currentOffset, $visibleRect, this$0) {
    this.hn6_1 = this$0;
    PageUpDown.call(this, $current, ensureNotNull($currentOffset._v), $visibleRect.dku_1.fku_1);
  }
  protoOf(CellNavigationController$handleKeyPress$pageUpDown$2).xn5 = function (current, offset) {
    return lowerClosest(this.hn6_1, current, offset);
  };
  function CellNavigationController$upperClosest$upDown$1() {
    UpDown.call(this);
  }
  protoOf(CellNavigationController$upperClosest$upDown$1).jn6 = function (cell) {
    return cell.k2r();
  };
  protoOf(CellNavigationController$upperClosest$upDown$1).kn6 = function (cell, within) {
    return Composites_instance.t2r(cell, within);
  };
  protoOf(CellNavigationController$upperClosest$upDown$1).ln6 = function (within) {
    return Composites_instance.l2r(within);
  };
  function CellNavigationController$lowerClosest$upDown$1() {
    UpDown.call(this);
  }
  protoOf(CellNavigationController$lowerClosest$upDown$1).jn6 = function (cell) {
    return cell.h2r();
  };
  protoOf(CellNavigationController$lowerClosest$upDown$1).kn6 = function (cell, within) {
    return Composites_instance.s2r(cell, within);
  };
  protoOf(CellNavigationController$lowerClosest$upDown$1).ln6 = function (within) {
    return Composites_instance.i2r(within);
  };
  function CellNavigationController(cellContainer) {
    Companion_getInstance_314();
    this.nn5_1 = cellContainer;
    this.on5_1 = null;
    this.pn5_1 = true;
    this.qn5_1 = ArrayDeque_init_$Create$();
  }
  function highlightFocused($this, cell) {
    setFocusHighlighted($this, cell, true);
    var tmp = cell.flp(Companion_getInstance_314().in5_1);
    var showFocusHighlightHandler = tmp.p27(HighlightUtil$highlightFocused$lambda(cell));
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    var disposeHandler = new HighlightUtil$highlightFocused$$inlined$toDisposable$1(cell);
    return showFocusHighlightHandler.sr(disposeHandler);
  }
  function setFocusHighlighted($this, cell, value) {
    var showFocusHighlight = cell.clo(Companion_getInstance_314().in5_1);
    var tmp;
    if (showFocusHighlight) {
      tmp = value;
    } else {
      tmp = false;
    }
    var newValue = tmp;
    cell.glp().t2c(newValue);
  }
  function HighlightUtil$highlightFocused$lambda($cell) {
    return function (it) {
      setFocusHighlighted(HighlightUtil_instance, $cell, true);
      return Unit_instance;
    };
  }
  function HighlightUtil$highlightFocused$$inlined$toDisposable$1($cell) {
    this.nn6_1 = $cell;
  }
  protoOf(HighlightUtil$highlightFocused$$inlined$toDisposable$1).vr = function () {
    setFocusHighlighted(HighlightUtil_instance, this.nn6_1, false);
    return Unit_instance;
  };
  function HighlightUtil() {
  }
  protoOf(HighlightUtil).en5 = function (cells) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(cells, 10));
    var _iterator__ex2g4s = cells.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.controller.navigation.HighlightUtil.highlightFocused.stub_for_inlining' call
      var tmp$ret$0 = highlightFocused(this, item);
      destination.e(tmp$ret$0);
    }
    var list = destination;
    return toDisposable_0(list);
  };
  protoOf(HighlightUtil).fn5 = function (paired) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(paired, 10));
    var _iterator__ex2g4s = paired.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.controller.navigation.HighlightUtil.highlightPaired.<anonymous>' call
      var tmp$ret$0 = item.bln(get_PAIR_HIGHLIGHTED(), true);
      destination.e(tmp$ret$0);
    }
    var list = destination;
    return toDisposable_0(list);
  };
  var HighlightUtil_instance;
  function HighlightUtil_getInstance() {
    return HighlightUtil_instance;
  }
  function closingFor(_this__u8e3s4, opening) {
    MatchingConstructs_instance.on6(opening, _this__u8e3s4);
    return _this__u8e3s4;
  }
  function pairOneWay($this, c1, c2) {
    c1.ylp(Companion_getInstance_314().hn5_1, c2);
  }
  function MatchingConstructs() {
  }
  protoOf(MatchingConstructs).on6 = function (c1, c2) {
    pairOneWay(this, c1, c2);
    pairOneWay(this, c2, c1);
  };
  var MatchingConstructs_instance;
  function MatchingConstructs_getInstance() {
    return MatchingConstructs_instance;
  }
  function getPaired($this, focused, getSibling, inOrder) {
    var cell = getSibling(focused);
    $l$loop_0: while (!(cell == null)) {
      if (!cell.elp().qr()) {
        cell = getSibling(cell);
        continue $l$loop_0;
      }
      var pair = cell.ulp(Companion_getInstance_314().hn5_1);
      if (!(pair == null) && inOrder(cell, pair)) {
        return setOf_0([cell, pair]);
      }
      if (!get_positionHandler(cell).vmr()) {
        break $l$loop_0;
      }
      cell = getSibling(cell);
    }
    // Inline function 'kotlin.collections.setOf' call
    return emptySet();
  }
  function PairUtil$getPaired$lambda(cell) {
    return cell.h2r();
  }
  function PairUtil$getPaired$lambda_0(next, pair) {
    return Composites_instance.z2r(next, pair);
  }
  function PairUtil$getPaired$lambda_1(cell) {
    return cell.k2r();
  }
  function PairUtil$getPaired$lambda_2(prev, pair) {
    return Composites_instance.z2r(pair, prev);
  }
  function PairUtil() {
  }
  protoOf(PairUtil).gn5 = function (focusedCell) {
    var focusedPair = focusedCell.ulp(Companion_getInstance_314().hn5_1);
    if (!(focusedPair == null)) {
      return setOf_0([focusedCell, focusedPair]);
    }
    if (get_positionHandler(focusedCell).umr()) {
      var tmp = PairUtil$getPaired$lambda;
      var pairedAhead = getPaired(this, focusedCell, tmp, PairUtil$getPaired$lambda_0);
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!pairedAhead.p()) {
        return pairedAhead;
      }
    }
    var tmp_0;
    if (get_positionHandler(focusedCell).tmr()) {
      var tmp_1 = PairUtil$getPaired$lambda_1;
      tmp_0 = getPaired(this, focusedCell, tmp_1, PairUtil$getPaired$lambda_2);
    } else {
      // Inline function 'kotlin.collections.setOf' call
      tmp_0 = emptySet();
    }
    return tmp_0;
  };
  var PairUtil_instance;
  function PairUtil_getInstance() {
    return PairUtil_instance;
  }
  function closest($this, candidates, offset) {
    if (candidates.p()) {
      return null;
    }
    var distance = UpDown$closest$lambda(candidates, offset);
    var tmp;
    if (candidates.n() >= 10) {
      tmp = Companion_instance_315.qn6(candidates, offset);
    } else {
      tmp = candidates.n() / 2 | 0;
    }
    var currentIndex = tmp;
    var currentDistance = distance(currentIndex);
    $l$loop_0: while (true) {
      var leftDistance = 2147483647;
      if (currentIndex > 0) {
        leftDistance = distance(currentIndex - 1 | 0);
      }
      var rightDistance = 2147483647;
      if (currentIndex < (candidates.n() - 1 | 0)) {
        rightDistance = distance(currentIndex + 1 | 0);
      }
      if (leftDistance < currentDistance && leftDistance < rightDistance) {
        currentIndex = currentIndex - 1 | 0;
        currentDistance = leftDistance;
        continue $l$loop_0;
      }
      if (rightDistance < currentDistance && rightDistance < leftDistance) {
        currentIndex = currentIndex + 1 | 0;
        currentDistance = rightDistance;
        continue $l$loop_0;
      }
      break $l$loop_0;
    }
    return candidates.q(currentIndex);
  }
  function advanceLine($this, cell) {
    var current = cell;
    do {
      var parent = ensureNotNull(current).yt();
      var tmp;
      if (get_isRootCell(parent)) {
        tmp = true;
      } else {
        tmp = parent instanceof VerticalCell;
      }
      if (tmp) {
        var list = advanceLineWithin($this, cell, current);
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!list.p()) {
          return list;
        }
        var sibling = $this.jn6(current);
        while (!(sibling == null)) {
          list = getLineAtBorder($this, sibling);
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!list.p()) {
            return list;
          }
          sibling = $this.jn6(sibling);
        }
      }
      current = parent;
    }
     while (!(current == null));
    return emptyList();
  }
  function advanceLineWithin($this, current, within) {
    if (current === within) {
      return emptyList();
    }
    var tmp0_elvis_lhs = findNewline($this, current, within);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return emptyList();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var newline = tmp;
    return getLineAfterNewline($this, newline, within);
  }
  function findNewline($this, from, within) {
    var cell = $this.kn6(from, within);
    $l$loop: while (!(cell == null)) {
      if (!isVisible_2($this, cell)) {
        cell = $this.kn6(cell, within);
        continue $l$loop;
      }
      if (cell instanceof NewLineCell) {
        return cell;
      }
      cell = $this.kn6(cell, within);
    }
    return null;
  }
  function getLineAfterNewline($this, newline, within) {
    var from = $this.kn6(newline, within);
    return getLine($this, from, within);
  }
  function getLineAtBorder($this, within) {
    var from = $this.ln6(within);
    return getLine($this, from, within);
  }
  function getLine($this, from, within) {
    var line = ArrayList_init_$Create$();
    var currentWithin = within;
    var cell = from;
    $l$loop_0: while (!(cell == null)) {
      if (!isVisible_2($this, cell)) {
        cell = cell === currentWithin ? null : $this.kn6(cell, currentWithin);
        continue $l$loop_0;
      }
      var tmp;
      if (cell instanceof NewLineCell) {
        tmp = !line.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        break $l$loop_0;
      }
      if (cell.hlp().qr()) {
        line.e(cell);
        if (line.n() === 1) {
          var newWithin = findClosestVerticalChild($this, cell, currentWithin);
          if (!(newWithin == null)) {
            currentWithin = newWithin;
          }
        }
      }
      cell = cell === currentWithin ? null : $this.kn6(cell, currentWithin);
    }
    return line;
  }
  function findClosestVerticalChild($this, from, within) {
    var cell = from;
    while (!(cell === within)) {
      var tmp0 = cell;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          // Inline function 'jetbrains.ocelot.projectional.controller.navigation.UpDown.findClosestVerticalChild.<anonymous>' call
          var message = toString_1(within) + ' does not enclose ' + toString_0(from);
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          break $l$block;
        }
      }
      var tmp = cell.yt();
      if (tmp instanceof VerticalCell) {
        return cell;
      }
      cell = cell.yt();
    }
    return null;
  }
  function isVisible_2($this, cell) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.vn5_1;
    var value = this_0.y2(cell);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.projectional.controller.navigation.UpDown.isVisible.<anonymous>' call
      var answer = getVisible($this, cell);
      this_0.r2(cell, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  }
  function getVisible($this, cell) {
    var tmp0 = ancestorsFrom(cell);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.all' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.controller.navigation.UpDown.getVisible.<anonymous>' call
        if (!element.elp().qr()) {
          tmp$ret$1 = false;
          break $l$block;
        }
      }
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function Companion_315() {
    this.pn6_1 = 10;
  }
  protoOf(Companion_315).qn6 = function (cells, offset) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!!cells.p()) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var left = get_origin_0(cells.q(0)).eku_1;
    var rightBounds = get_bounds(last(cells));
    var right = rightBounds.cku_1.eku_1 + rightBounds.dku_1.eku_1 | 0;
    var tmp;
    if (left === right) {
      tmp = 0;
    } else {
      var index = imul(offset - left | 0, cells.n()) / (right - left | 0) | 0;
      tmp = index < 0 ? 0 : index > get_lastIndex_2(cells) ? get_lastIndex_2(cells) : index;
    }
    return tmp;
  };
  var Companion_instance_315;
  function Companion_getInstance_315() {
    return Companion_instance_315;
  }
  function UpDown$closest$lambda($candidates, $offset) {
    return function (index) {
      return get_positionHandler($candidates.q(index)).zmr($offset);
    };
  }
  function UpDown() {
    this.vn5_1 = HashMap_init_$Create$();
  }
  protoOf(UpDown).wn5 = function (cell, offset) {
    return closest(this, advanceLine(this, cell), offset);
  };
  function RootController() {
  }
  protoOf(RootController).yn5 = function (container) {
    return Companion_getInstance_314().yn5(container).sr(MessageController_getInstance().ymm(container));
  };
  var RootController_instance;
  function RootController_getInstance() {
    return RootController_instance;
  }
  function InstallRootResult(cellContainer, installDisposable) {
    this.rn6_1 = cellContainer;
    this.sn6_1 = installDisposable;
  }
  function installRoot(cellContainer, targetCell) {
    cellContainer.u3o().ilp().e(targetCell);
    return installRoot_0(cellContainer);
  }
  function installRoot_0(cellContainer) {
    cellContainer = cellContainer === VOID ? CellContainer() : cellContainer;
    var disposable = RootController_instance.yn5(cellContainer);
    return new InstallRootResult(cellContainer, disposable);
  }
  function installRootFromMapper(mapper, cellContainer) {
    cellContainer = cellContainer === VOID ? CellContainer() : cellContainer;
    mapper.ulc();
    return installRoot(cellContainer, mapper.ql9_1);
  }
  function BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda$lambda($update) {
    return function () {
      var tmp;
      if ($update.w4u()) {
        $update.tn6();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function pastePostProcess($this, items) {
    var tmp0_safe_receiver = $this.sn7_1.ln7_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.editor.cell.CopyPasteTrait.pastePostProcess.<anonymous>' call
      launch_0($this.sn7_1.un6_1, VOID, BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda_0(items, tmp0_safe_receiver, $this.sn7_1, null));
    }
  }
  function BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda($items, $handler, this$0, resultContinuation) {
    this.bn8_1 = $items;
    this.cn8_1 = $handler;
    this.dn8_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            var tmp_0 = this;
            tmp_0.fn8_1 = this.bn8_1;
            this.gn8_1 = this.fn8_1;
            this.hn8_1 = this.gn8_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.hn8_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.in8_1 = this.hn8_1.m();
            var tmp_1 = this;
            tmp_1.jn8_1 = this.in8_1;
            this.kn8_1 = this.jn8_1;
            this.ln8_1 = this.cn8_1.mn8(this.kn8_1);
            this.z9_1 = 4;
            this.y9_1 = 2;
            suspendResult = this.ln8_1.nn8(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var update = suspendResult;
            var tmp0_safe_receiver = this.dn8_1.un6_1.llk();
            var tmp_2;
            if (tmp0_safe_receiver == null) {
              tmp_2 = null;
            } else {
              tmp0_safe_receiver.hm9(BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda$lambda(update));
              tmp_2 = Unit_instance;
            }

            if (tmp_2 == null) {
              this.ln8_1.vr();
            }

            this.z9_1 = 6;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 6;
            this.y9_1 = 1;
            continue $sm;
          case 4:
            this.z9_1 = 6;
            var tmp_3 = this.ba_1;
            if (tmp_3 instanceof CancellationException) {
              var e = this.ba_1;
              this.ln8_1.vr();
              throw e;
            } else {
              throw this.ba_1;
            }

          case 5:
            return Unit_instance;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 6) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda).i1l = function ($this$launch, completion) {
    var i = new BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda(this.bn8_1, this.cn8_1, this.dn8_1, completion);
    i.en8_1 = $this$launch;
    return i;
  };
  function BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda_0($items, $handler, this$0, resultContinuation) {
    var i = new BaseProjectionalSynchronizer$CopyPasteTrait$pastePostProcess$slambda($items, $handler, this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function isEmpty$ref() {
    var l = function (p0) {
      return isEmpty(p0);
    };
    l.callableName = 'isEmpty';
    return l;
  }
  function BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1$get$matchers$1(this$0) {
    this.on8_1 = this$0;
  }
  protoOf(BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1$get$matchers$1).pn8 = function (target) {
    return insertItem(this.on8_1, target);
  };
  protoOf(BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1$get$matchers$1).qn8 = function (target) {
    return this.pn8(!(target == null) ? target : THROW_CCE());
  };
  function BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$o$get$lambda($spec, this$0) {
    return function (inputSpec) {
      var tmp;
      if (inputSpec === $spec) {
        // Inline function 'jetbrains.ocelot.projectional.editor.cell.<no name provided>.get.<anonymous>' call
        var role = new BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1$get$matchers$1(this$0);
        var tmp$ret$0 = this$0.rn8(role);
        tmp = new SpecMatchResult(tmp$ret$0);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$o$get$lambda_0($spec) {
    return function (matcher) {
      return matcher($spec);
    };
  }
  function addPlaceholderIfEnabled($this) {
    if ($this.un8_1.hn7_1) {
      $this.tn8_1 = true;
      $this.un8_1.vn6_1.e(createPlaceholder($this));
    }
  }
  function createPlaceholder($this) {
    var mainCell = TextCell_init_$Create$();
    mainCell.hlp().t2c(true);
    mainCell.olp(getPlaceholderTrait($this));
    var tmp0_elvis_lhs = $this.un8_1.an7_1;
    var placeholderCell = placeholder(mainCell, tmp0_elvis_lhs == null ? '<empty>' : tmp0_elvis_lhs);
    var tmp1_safe_receiver = _get_placeholderVisibleCellTraitFactory__gdwcuq($this.un8_1)();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.editor.cell.TargetCellList.createPlaceholder.<anonymous>' call
      placeholderCell.olp(tmp1_safe_receiver);
    }
    var tmp;
    var tmp_0 = $this.un8_1.un6_1;
    if (tmp_0 instanceof IndentCell) {
      tmp = CellFactory_instance.wmw([mainCell, placeholderCell]);
    } else {
      tmp = CellFactory_instance.umw([mainCell, placeholderCell]);
    }
    var result = tmp;
    result.ylp(Companion_getInstance_298().dms_1, get_positionHandler(mainCell));
    return result;
  }
  function getPlaceholderTrait($this) {
    var trait = new BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1($this.un8_1);
    return _get_placeholderCaretCellTraitFactory__i2cbur($this.un8_1)(trait);
  }
  function BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1(this$0) {
    this.wn8_1 = this$0;
    var tmp = TextEditing_getInstance();
    BaseDerivedCellTrait.call(this, tmp.gmu(isEmpty$ref()));
  }
  protoOf(BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1).olm = function (cell, event) {
    handlePlaceholderKeyPress(this.wn8_1, event);
    if (!event.ml0_1) {
      protoOf(BaseDerivedCellTrait).olm.call(this, cell, event);
    }
  };
  protoOf(BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$trait$1).flo = function (cell, spec) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.specMatcher' call
    var spec_0 = Completion_getInstance().cm1_1;
    var tmp$ret$0 = BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$o$get$lambda(spec_0, this.wn8_1);
    var matchers = listOf_0([tmp$ret$0, specMatcherValue(TextEditing_getInstance().ilx_1, this.wn8_1.nn7_1)]);
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var tmp = asSequence_0(matchers);
    var result = firstOrNull_2(filterNotNull_0(map(tmp, BaseProjectionalSynchronizer$TargetCellList$getPlaceholderTrait$o$get$lambda_0(spec))));
    var tmp_0;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.editor.cell.<no name provided>.get.<anonymous>' call
      tmp_0 = protoOf(BaseDerivedCellTrait).flo.call(this, cell, spec);
    } else {
      tmp_0 = result.sma_1;
    }
    return tmp_0;
  };
  function BaseProjectionalSynchronizer$SelectionCaptureTrait$_init_$lambda_74dg8i($support) {
    return function (it) {
      return $support;
    };
  }
  function _get_placeholderCaretCellTraitFactory__i2cbur($this) {
    var tmp = $this.bn7_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('placeholderCaretCellTraitFactory');
    }
  }
  function _get_placeholderVisibleCellTraitFactory__gdwcuq($this) {
    var tmp = $this.cn7_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('placeholderVisibleCellTraitFactory');
    }
  }
  function _get_deleteHandler__p8aq26($this) {
    var tmp = $this.dn7_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('deleteHandler');
    }
  }
  function _get_roleSynchronizerSelectionSupport__orr8w($this) {
    var tmp = $this.gn7_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('roleSynchronizerSelectionSupport');
    }
  }
  function _get_context__ps0bpe_0($this) {
    var tmp = $this.on7_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('context');
    }
  }
  function insertItem($this, item) {
    return $this.xn8(listOf(item));
  }
  function isDeleteEvent($this, event) {
    return event.ol1([KeyStrokeSpecs_getInstance().hl3_1]) || event.ml1(Key_BACKSPACE_getInstance(), []) || event.ml1(Key_DELETE_getInstance(), []);
  }
  function handlePlaceholderKeyPress($this, event) {
    if ($this.zn8(event) && $this.an9()) {
      insertItem($this, $this.yn8())();
      event.ol0();
    }
    if (isDeleteEvent($this, event) && _get_deleteHandler__p8aq26($this).cn9()) {
      _get_deleteHandler__p8aq26($this).bn9()();
      event.ol0();
    }
  }
  function CopyPasteTrait_0($outer) {
    this.sn7_1 = $outer;
    RoleSynchronizerCopyPasteTrait.call(this, $outer.kn7_1, _get_roleSynchronizerSelectionSupport__orr8w($outer));
  }
  protoOf(CopyPasteTrait_0).dn9 = function (items, cause, result) {
    this.sn7_1.en9(items, cause, result);
  };
  protoOf(CopyPasteTrait_0).fn9 = function (items) {
    this.sn7_1.xn8(items)();
    pastePostProcess(this, items);
  };
  function TargetCellTrait($outer) {
    this.on9_1 = $outer;
    BaseDerivedCellTrait.call(this, new CopyPasteTrait_0($outer));
  }
  protoOf(TargetCellTrait).hlo = function (cell, event) {
    protoOf(BaseDerivedCellTrait).hlo.call(this, cell, event);
    this.on9_1.pn9();
  };
  protoOf(TargetCellTrait).ilo = function (cell, event) {
    protoOf(BaseDerivedCellTrait).ilo.call(this, cell, event);
    this.on9_1.pn9();
  };
  protoOf(TargetCellTrait).llm = function (cell, event) {
    if (event.ol1([KeyStrokeSpecs_getInstance().gl3_1])) {
      this.on9_1.qn9(event);
    } else {
      protoOf(BaseDerivedCellTrait).llm.call(this, cell, event);
      this.on9_1.pn9();
    }
  };
  protoOf(TargetCellTrait).jll = function (cell, event) {
    protoOf(BaseDerivedCellTrait).jll.call(this, cell, event);
    this.on9_1.pn9();
  };
  protoOf(TargetCellTrait).jlo = function (cell, event) {
    protoOf(BaseDerivedCellTrait).jlo.call(this, cell, event);
    this.on9_1.pn9();
  };
  protoOf(TargetCellTrait).llo = function (cell, event) {
    protoOf(BaseDerivedCellTrait).llo.call(this, cell, event);
    this.on9_1.pn9();
  };
  function TargetCellList($outer) {
    this.un8_1 = $outer;
    AbstractMutableList.call(this);
    this.tn8_1 = false;
  }
  protoOf(TargetCellList).rn9 = function () {
    var tmp;
    if (this.tn8_1) {
      var tmp_0 = this.un8_1.vn6_1.q(0).g2r().q(0);
      tmp = tmp_0 instanceof TextCell ? tmp_0 : THROW_CCE();
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(TargetCellList).n = function () {
    return this.tn8_1 ? 0 : this.un8_1.vn6_1.n();
  };
  protoOf(TargetCellList).sn9 = function () {
    return addPlaceholderIfEnabled(this);
  };
  protoOf(TargetCellList).q = function (index) {
    if (this.tn8_1) {
      throw CollectionIndexOutOfBoundsException_init_$Create$();
    }
    return this.un8_1.vn6_1.q(index);
  };
  protoOf(TargetCellList).oln = function (index, element) {
    if (this.tn8_1) {
      this.un8_1.vn6_1.q2(0);
      this.tn8_1 = false;
    }
    this.un8_1.vn6_1.p2(index, element);
    this.un8_1.xn6_1.p2(index, this.un8_1.tn9(this.un8_1.ila().q(index).pl9_1, element));
  };
  protoOf(TargetCellList).p2 = function (index, element) {
    return this.oln(index, (!(element == null) ? isInterface(element, Cell) : false) ? element : THROW_CCE());
  };
  protoOf(TargetCellList).q2 = function (index) {
    var result = this.un8_1.vn6_1.q2(index);
    this.un8_1.xn6_1.q2(index).vr();
    if (this.un8_1.vn6_1.p()) {
      addPlaceholderIfEnabled(this);
    }
    return result;
  };
  protoOf(TargetCellList).nln = function (index, element) {
    var result = this.q2(index);
    this.oln(index, element);
    return result;
  };
  protoOf(TargetCellList).o2 = function (index, element) {
    return this.nln(index, (!(element == null) ? isInterface(element, Cell) : false) ? element : THROW_CCE());
  };
  function SourceList($outer) {
    this.un9_1 = $outer;
    AbstractList.call(this);
  }
  protoOf(SourceList).n = function () {
    return this.un9_1.ila().n();
  };
  protoOf(SourceList).q = function (index) {
    return this.un9_1.ila().q(index).pl9_1;
  };
  function SelectionCaptureTrait($outer, support) {
    this.wn9_1 = $outer;
    BaseDerivedCellTrait.call(this, new BaseSelectionCaptureTrait(BaseProjectionalSynchronizer$SelectionCaptureTrait$_init_$lambda_74dg8i(support)));
  }
  protoOf(SelectionCaptureTrait).llm = function (cell, event) {
    if (isDeleteEvent(this.wn9_1, event)) {
      this.wn9_1.yn9(this.wn9_1.xn9(), event);
      this.wn9_1.zn9();
      event.ql0();
    } else {
      protoOf(BaseDerivedCellTrait).llm.call(this, cell, event);
    }
  };
  protoOf(SelectionCaptureTrait).jll = function (cell, event) {
    event.ol0();
    this.wn9_1.un6_1.jlp(event.o30(), Companion_getInstance_287().nll_1);
  };
  protoOf(SelectionCaptureTrait).zlo = function (cell, event) {
    var container = ensureNotNull(this.wn9_1.un6_1.llk());
    this.wn9_1.yn9(this.wn9_1.xn9(), event);
    event.ql0();
    container.tmi(new PasteEvent(event.cl4_1));
  };
  function BaseProjectionalSynchronizer$clipboardHandler$lambda(this$0) {
    return function (item) {
      var index = indexOf_12(this$0, item);
      var cell = this$0.vn6_1.q(index);
      return toText_0(toBlock(cell));
    };
  }
  function BaseProjectionalSynchronizer$_get_onLastItemDeleted_$lambda_wk9nhe(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.zn6_1.rn9();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.ul5();
      }
      return Unit_instance;
    };
  }
  function BaseProjectionalSynchronizer$getItemHandler$lambda($item) {
    return function (candidate) {
      return candidate.ana($item);
    };
  }
  function BaseProjectionalSynchronizer$handleSourceUpdate$ref($boundThis) {
    var l = function (p0) {
      return $boundThis.bna(p0);
    };
    l.callableName = 'handleSourceUpdate';
    return l;
  }
  function BaseProjectionalSynchronizer$SelectionCaptureTrait$_init_$ref_fz6y14($boundThis) {
    var l = function (p0) {
      return new SelectionCaptureTrait($boundThis, p0);
    };
    l.callableName = '<init>';
    return l;
  }
  function BaseProjectionalSynchronizer$attach$3(this$0) {
    this.dna_1 = this$0;
    this.cna_1 = null;
  }
  protoOf(BaseProjectionalSynchronizer$attach$3).ena = function (event) {
    var targetCell = this.cna_1;
    if (!(targetCell == null)) {
      get_background(targetCell).t2c(null);
      get_bottomPopupProp(targetCell).t2c(null);
    }
    var newValue = event.p2e_1;
    if (!(newValue == null)) {
      var index = indexOf_12(this.dna_1, newValue);
      var cell = this.dna_1.vn6_1.q(index);
      get_background(cell).t2c(Companion_getInstance_325().qlt_1);
      var frontPopup = TextCell_init_$Create$_0('Press Del or Backspace to delete. Esc to cancel.');
      get_background(frontPopup).t2c(Companion_getInstance_325().elt_1);
      this.cna_1 = cell;
    }
  };
  protoOf(BaseProjectionalSynchronizer$attach$3).d28 = function (event) {
    return this.ena(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  function BaseProjectionalSynchronizer(target, targetList, settings, isMultiItemPasteSupported) {
    this.un6_1 = target;
    this.vn6_1 = targetList;
    this.wn6_1 = settings;
    this.xn6_1 = ArrayList_init_$Create$_0(0);
    this.zn6_1 = new TargetCellList(this);
    this.an7_1 = null;
    this.en7_1 = HashSet_init_$Create$();
    this.fn7_1 = new ValueProperty(null);
    this.hn7_1 = true;
    this.in7_1 = null;
    this.jn7_1 = emptyRoleCompletion();
    var tmp = this;
    tmp.kn7_1 = new ProjectionalClipboardHandler(isMultiItemPasteSupported, BaseProjectionalSynchronizer$clipboardHandler$lambda(this));
    this.ln7_1 = null;
    this.mn7_1 = null;
    this.nn7_1 = false;
  }
  protoOf(BaseProjectionalSynchronizer).fna = function () {
    var tmp = this.yn6_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('selectionSupport');
    }
  };
  protoOf(BaseProjectionalSynchronizer).gna = function () {
    return this.zn6_1;
  };
  protoOf(BaseProjectionalSynchronizer).ina = function () {
    return this.kn7_1;
  };
  protoOf(BaseProjectionalSynchronizer).jna = function () {
    return this.kn7_1.nna_1;
  };
  protoOf(BaseProjectionalSynchronizer).ila = function () {
    return this.hna().ila();
  };
  protoOf(BaseProjectionalSynchronizer).sna = function () {
    var tmp0_elvis_lhs = this.mn7_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      tmp = BaseProjectionalSynchronizer$_get_onLastItemDeleted_$lambda_wk9nhe(this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(BaseProjectionalSynchronizer).xn9 = function () {
    return this.fna().cnb();
  };
  protoOf(BaseProjectionalSynchronizer).dnb = function () {
    return this.fna().dnb();
  };
  protoOf(BaseProjectionalSynchronizer).an9 = function () {
    return !(this.in7_1 == null);
  };
  protoOf(BaseProjectionalSynchronizer).yn8 = function () {
    var itemHandler = this.in7_1;
    // Inline function 'kotlin.checkNotNull' call
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (itemHandler == null) {
        // Inline function 'kotlin.checkNotNull.<anonymous>' call
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return itemHandler.yn8();
  };
  protoOf(BaseProjectionalSynchronizer).enb = function (contextItem) {
    var handler = this.fnb(contextItem);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (handler == null) {
        // Inline function 'jetbrains.ocelot.projectional.editor.cell.BaseProjectionalSynchronizer.newItem.<anonymous>' call
        var message = 'no suitable item handler for ' + toString_1(contextItem);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return handler.yn8();
  };
  protoOf(BaseProjectionalSynchronizer).rn8 = function (role) {
    var contextMapper = _get_context__ps0bpe_0(this).kla();
    var contextNode = contextMapper.pl9_1;
    return this.jn7_1.gnb(contextMapper, contextNode, role);
  };
  protoOf(BaseProjectionalSynchronizer).hnb = function (index) {
    return this.gna().q(index).ulp(ProjectionalSynchronizers_getInstance().jlw_1);
  };
  protoOf(BaseProjectionalSynchronizer).inb = function (action) {
    // Inline function 'kotlin.require' call
    if (!(this.hn7_1 || !(action == null))) {
      // Inline function 'jetbrains.ocelot.projectional.editor.cell.BaseProjectionalSynchronizer.setOnLastItemDeleted.<anonymous>' call
      var message = "Can't set the default onLastItemDeleted action when the placeholder is disabled";
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.mn7_1 = action;
  };
  protoOf(BaseProjectionalSynchronizer).jnb = function (handler) {
    this.in7_1 = handler;
  };
  protoOf(BaseProjectionalSynchronizer).knb = function (handler) {
    return this.jnb(handler);
  };
  protoOf(BaseProjectionalSynchronizer).fnb = function (item) {
    var tmp = asSequence_0(this.en7_1);
    var list = toList_2(take_0(filter(tmp, BaseProjectionalSynchronizer$getItemHandler$lambda(item)), 2));
    // Inline function 'kotlin.check' call
    if (!(list.n() <= 1)) {
      // Inline function 'jetbrains.ocelot.projectional.editor.cell.BaseProjectionalSynchronizer.getItemHandler.<anonymous>' call
      var message = 'found two item handlers applicable to ' + toString_1(item) + ': ' + toString_1(list.q(0)) + ' and ' + toString_1(list.q(1));
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return list.p() ? this.in7_1 : first(list);
  };
  protoOf(BaseProjectionalSynchronizer).lnb = function (eagerCompletion) {
    this.nn7_1 = eagerCompletion;
  };
  protoOf(BaseProjectionalSynchronizer).jla = function (ctx) {
    this.on7_1 = ctx;
    // Inline function 'kotlin.check' call
    if (!this.un6_1.g2r().p()) {
      // Inline function 'jetbrains.ocelot.projectional.editor.cell.BaseProjectionalSynchronizer.attach.<anonymous>' call
      var message = 'target cell for projectional synchronizer should be initially empty';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp = this;
    var tmp_0 = this.wn6_1.mnb_1;
    var tmp_1 = new SourceList(this);
    var tmp_2 = BaseProjectionalSynchronizer$handleSourceUpdate$ref(this);
    // Inline function 'kotlin.also' call
    var this_0 = new RoleSynchronizerSelectionSupport(this, tmp_0, tmp_1, this.un6_1, this.vn6_1, tmp_2, BaseProjectionalSynchronizer$SelectionCaptureTrait$_init_$ref_fz6y14(this));
    // Inline function 'jetbrains.ocelot.projectional.editor.cell.BaseProjectionalSynchronizer.attach.<anonymous>' call
    this.yn6_1 = this_0.wnb_1;
    tmp.gn7_1 = this_0;
    this.fn7_1.o27(new BaseProjectionalSynchronizer$attach$3(this));
    this.an7_1 = this.wn6_1.pnb_1;
    this.dn7_1 = this.wn6_1.qnb_1;
    this.bn7_1 = this.wn6_1.nnb_1;
    this.cn7_1 = this.wn6_1.onb_1;
    this.zn6_1.sn9();
    this.hna().jla(ctx);
    this.un6_1.olp(new TargetCellTrait(this));
  };
  protoOf(BaseProjectionalSynchronizer).pn9 = function () {
    return this.fn7_1.t2c(null);
  };
  protoOf(BaseProjectionalSynchronizer).t6m = function () {
    _get_roleSynchronizerSelectionSupport__orr8w(this).vr();
    this.hna().t6m();
  };
  protoOf(BaseProjectionalSynchronizer).anc = function (completion) {
    this.jn7_1 = completion;
  };
  protoOf(BaseProjectionalSynchronizer).bnc = function (completion) {
    return this.anc(completion);
  };
  protoOf(BaseProjectionalSynchronizer).cnc = function () {
    return this.fna().cnc();
  };
  protoOf(BaseProjectionalSynchronizer).dnc = function (event, cell, ignoreEmpty) {
    var home = Positions_instance.ems(cell);
    var end = Positions_instance.fms(cell);
    if (ignoreEmpty && home && end) {
      return false;
    }
    if (event.ml1(Key_BACKSPACE_getInstance(), []) && (!home || end)) {
      return true;
    }
    return event.ml1(Key_DELETE_getInstance(), []) && (!end || home);
  };
  protoOf(BaseProjectionalSynchronizer).enc = function (event, cell) {
    var tmp;
    if (event.ol1([KeyStrokeSpecs_getInstance().hl3_1])) {
      tmp = true;
    } else {
      tmp = this.dnc(event, cell, false);
    }
    return tmp;
  };
  protoOf(BaseProjectionalSynchronizer).zn9 = function () {
    var targetContainer = this.un6_1.llk();
    if (!(targetContainer == null)) {
      var focusedCell = ensureNotNull(targetContainer.rlp().qr());
      CellScrolling_getInstance().kms(focusedCell);
    }
  };
  protoOf(BaseProjectionalSynchronizer).fnc = function (handler) {
    this.ln7_1 = handler;
  };
  protoOf(BaseProjectionalSynchronizer).gnc = function (handler) {
    return this.fnc(handler);
  };
  function _get_isEmpty__oti0q6($this) {
    return $this.hnc_1.p();
  }
  function isLast($this, index) {
    return index === get_lastIndex_2($this.hnc_1);
  }
  function isFirst($this, index) {
    return index === 0;
  }
  function isEmpty_2($this, index) {
    return $this.nnc($this.inc_1.q(index));
  }
  function insertAfterFromHome($this, index, event) {
    var inserted = $this.onc() ? index : index + 1 | 0;
    $this.hnc_1.p2(inserted, $this.pnc($this.hnc_1.q(index)));
    if (!isEmpty_2($this, inserted)) {
      $this.rnc(inserted);
    } else {
      $this.qnc(index + 1 | 0, event);
      if (!event.ml0_1 && !(inserted === index)) {
        $this.rnc(inserted);
      }
    }
  }
  function selectAfterClear($this, index) {
    var tmp;
    if (_get_isEmpty__oti0q6($this)) {
      $this.unc();
      tmp = Unit_instance;
    } else if (isLast($this, index) || isFirst($this, index)) {
      $this.tnc(index);
      tmp = Unit_instance;
    } else {
      $this.snc(index - 1 | 0);
      tmp = Unit_instance;
    }
    return tmp;
  }
  function isDeleteEvent_0($this, event) {
    return isDeleteCurrentEvent($this, event) || isSimpleDeleteEvent($this, event);
  }
  function isSimpleDeleteEvent($this, event) {
    return event.ml1(Key_BACKSPACE_getInstance(), []) || event.ml1(Key_DELETE_getInstance(), []);
  }
  function isDeleteCurrentEvent($this, event) {
    return event.ol1([KeyStrokeSpecs_getInstance().hl3_1]);
  }
  function CollectionEditor(items, views, forDeletion, canCreateNew, replaceWithNewOnDelete, splitJoinHandler) {
    this.hnc_1 = items;
    this.inc_1 = views;
    this.jnc_1 = forDeletion;
    this.knc_1 = canCreateNew;
    this.lnc_1 = replaceWithNewOnDelete;
    this.mnc_1 = splitJoinHandler;
  }
  protoOf(CollectionEditor).cnd = function (cell, event) {
    var index = this.inc_1.t(cell);
    var isHome = this.znc(cell);
    var isEnd = this.and(cell);
    if (this.knc_1) {
      if (this.dnd(event) && isHome) {
        insertAfterFromHome(this, index, event);
        if (!event.ml0_1) {
          event.ol0();
        }
        return Unit_instance;
      }
      if (this.dnd(event) && !isHome) {
        if (isEnd || !this.end(index, event)) {
          this.hnc_1.p2(index + 1 | 0, this.pnc(this.hnc_1.q(index)));
          this.rnc(index + 1 | 0);
        }
        event.ol0();
        return Unit_instance;
      }
      if (this.fnd(event)) {
        if (isHome || isEnd || !this.end(index, event)) {
          var i = isEnd && !isHome && this.onc() ? index + 1 | 0 : index;
          this.hnc_1.p2(i, this.pnc(this.hnc_1.q(index)));
          this.rnc(i);
        }
        event.ol0();
        return Unit_instance;
      }
    }
    if (event.ol1([KeyStrokeSpecs_getInstance().gl3_1]) && this.xnc() && this.vnc() && !this.cnc()) {
      this.hnc_1.p2(index + 1 | 0, this.ync(this.hnc_1.q(index)));
      this.snc(index + 1 | 0);
      event.ol0();
      return Unit_instance;
    }
    if (this.gnd(index, event, cell)) {
      event.ol0();
      return Unit_instance;
    }
    if (this.wnc()) {
      if (event.ml1(Key_BACKSPACE_getInstance(), []) && index > 0) {
        var removePrev = isHome && !isEmpty_2(this, index);
        var removeCur = isEmpty_2(this, index);
        if (removePrev) {
          this.hnc_1.q2(index - 1 | 0);
          event.ol0();
          return Unit_instance;
        }
        if (removeCur) {
          this.hnc_1.q2(index);
          this.snc(index - 1 | 0);
          event.ol0();
          return Unit_instance;
        }
      }
      if (event.ml1(Key_DELETE_getInstance(), []) && !isLast(this, index)) {
        var removeCur_0 = isEmpty_2(this, index);
        var removeNext = isEnd && !isEmpty_2(this, index);
        if (removeCur_0) {
          this.hnc_1.q2(index);
          this.tnc(index);
          event.ol0();
          return Unit_instance;
        }
        if (removeNext) {
          this.hnc_1.q2(index + 1 | 0);
          event.ol0();
          return Unit_instance;
        }
      }
    }
    if (isSimpleDeleteEvent(this, event) && !(this.jnc_1.qr() === this.hnc_1.q(index)) && !isEmpty_2(this, index)) {
      if (this.bnd(event)) {
        return Unit_instance;
      }
      this.jnc_1.t2c(this.hnc_1.q(index));
      event.ol0();
      return Unit_instance;
    }
    if (isDeleteEvent_0(this, event)) {
      if (this.bnd(event)) {
        return Unit_instance;
      }
      if (this.lnc_1(this.inc_1.q(index))) {
        this.hnc_1.o2(index, this.pnc(this.hnc_1.q(index)));
        this.tnc(index);
      } else {
        this.hnc_1.q2(index);
        selectAfterClear(this, index);
      }
      event.ol0();
    }
  };
  protoOf(CollectionEditor).end = function (index, event) {
    var canSplit = this.mnc_1.hnd(this.hnc_1, index, this.inc_1);
    if (canSplit) {
      var postSplitAction = this.mnc_1.ind(this.hnc_1, index, this.inc_1);
      if (this.fnd(event)) {
        this.snc(index);
      } else {
        this.tnc(index + 1 | 0);
      }
      postSplitAction();
    }
    return canSplit;
  };
  protoOf(CollectionEditor).gnd = function (index, event, cell) {
    var joinIndex;
    var direction;
    if (event.ml1(Key_BACKSPACE_getInstance(), []) && index > 0 && this.znc(cell)) {
      joinIndex = index - 1 | 0;
      direction = JoinDirection_BACKWARD_getInstance();
    } else if (event.ml1(Key_DELETE_getInstance(), []) && !isLast(this, index) && this.and(cell)) {
      joinIndex = index;
      direction = JoinDirection_FORWARD_getInstance();
    } else {
      return false;
    }
    var canJoin = this.mnc_1.jnd(this.hnc_1, joinIndex, direction);
    if (canJoin) {
      this.mnc_1.knd(this.hnc_1, joinIndex, direction)();
    }
    return canJoin;
  };
  function NewItemOnly(itemSupplier) {
    DefaultProjectionalItemHandler.call(this);
    this.lnd_1 = itemSupplier;
  }
  protoOf(NewItemOnly).mnd = function () {
    return new NotSupported();
  };
  protoOf(NewItemOnly).yn8 = function () {
    return this.lnd_1();
  };
  function Companion_316() {
  }
  protoOf(Companion_316).nnd = function (itemSupplier) {
    return new NewItemOnly(itemSupplier);
  };
  var Companion_instance_316;
  function Companion_getInstance_316() {
    return Companion_instance_316;
  }
  function DefaultProjectionalItemHandler() {
  }
  protoOf(DefaultProjectionalItemHandler).ana = function (item) {
    return true;
  };
  function DeleteHandler$Companion$EMPTY$1() {
  }
  protoOf(DeleteHandler$Companion$EMPTY$1).cn9 = function () {
    return false;
  };
  protoOf(DeleteHandler$Companion$EMPTY$1).bn9 = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  function Companion_317() {
    Companion_instance_317 = this;
    var tmp = this;
    tmp.ond_1 = new DeleteHandler$Companion$EMPTY$1();
  }
  var Companion_instance_317;
  function Companion_getInstance_317() {
    if (Companion_instance_317 == null)
      new Companion_317();
    return Companion_instance_317;
  }
  function JoinChildrenEvent() {
    JoinChildrenEvent_instance = this;
    this.pnd_1 = new CellTraitEventSpec('joinChildrenEvent', true);
  }
  protoOf(JoinChildrenEvent).qnd = function (cell, keyEvent) {
    var derivedEvent = new DerivedEvent(keyEvent);
    cell.nlp(derivedEvent, this.pnd_1);
    return derivedEvent.ml0_1;
  };
  var JoinChildrenEvent_instance;
  function JoinChildrenEvent_getInstance() {
    if (JoinChildrenEvent_instance == null)
      new JoinChildrenEvent();
    return JoinChildrenEvent_instance;
  }
  function CreateNewElementHandle() {
  }
  function ProjectionalListSynchronizerSettings$endPositionChecker$lambda(cell) {
    return Positions_instance.fms(cell);
  }
  function ProjectionalListSynchronizerSettings$replaceWithNewOnDelete$lambda(cell) {
    return !isEmpty_0(cell);
  }
  function ProjectionalListSynchronizerSettings() {
    ProjectionalSynchronizerSettings.call(this);
    this.xnd_1 = null;
    var tmp = this;
    tmp.ynd_1 = ProjectionalListSynchronizerSettings$endPositionChecker$lambda;
    this.znd_1 = get_INSERT_BEFORE();
    this.ane_1 = get_INSERT_AFTER();
    this.bne_1 = true;
    var tmp_0 = this;
    tmp_0.cne_1 = ProjectionalListSynchronizerSettings$replaceWithNewOnDelete$lambda;
    this.dne_1 = true;
    this.ene_1 = null;
  }
  protoOf(ProjectionalListSynchronizerSettings).fne = function () {
    return this;
  };
  protoOf(ProjectionalListSynchronizerSettings).gne = function (trait) {
    this.ene_1 = trait;
  };
  protoOf(ProjectionalListSynchronizerSettings).hne = function (replaceWithNewOnDelete) {
    this.cne_1 = replaceWithNewOnDelete;
    return this;
  };
  function _get_currentChildCompletion__dt6zjo($this) {
    var role = new ProjectionalObservableListSynchronizer$currentChildCompletion$role$1($this);
    return $this.rn8(role);
  }
  function _get_currentCellIndex__uqju5o($this) {
    return indexOf_5($this.gna(), $this.dnb());
  }
  function DefaultCreateNewItemCellTrait($outer) {
    this.lne_1 = $outer;
    CellTrait.call(this);
  }
  protoOf(DefaultCreateNewItemCellTrait).jll = function (cell, event) {
    var tmp;
    var tmp_0 = this.lne_1.inf_1;
    if (!((tmp_0 == null ? null : new Char(tmp_0)) == null)) {
      var tmp_1 = this.lne_1.inf_1;
      tmp = equals(tmp_1 == null ? null : new Char(tmp_1), new Char(event.jl1_1));
    } else {
      tmp = false;
    }
    if (tmp) {
      createNewToTheRight(this.lne_1, cell)();
      event.ol0();
    }
    protoOf(CellTrait).jll.call(this, cell, event);
  };
  function createNewToTheRight($this, cell) {
    var index = $this.gna().t(cell);
    var newItem = $this.yn8();
    $this.hnf_1.p2(index + 1 | 0, newItem);
    return $this.hnb(index + 1 | 0);
  }
  function getCollectionEditor($this, child) {
    var itemHandler = $this.fnb(child);
    var tmp1_elvis_lhs = itemHandler == null ? null : itemHandler.mnd();
    var splitJoinHandler = tmp1_elvis_lhs == null ? new NotSupported() : tmp1_elvis_lhs;
    return new ProjectionalObservableListSynchronizer$getCollectionEditor$1($this, splitJoinHandler);
  }
  function keyPressedInChild($this, event, child) {
    var collectionEditor = getCollectionEditor($this, child);
    collectionEditor.cnd(ensureNotNull($this.dnb()), event);
  }
  function replaceWithNewOnDelete($this) {
    var tmp;
    if ($this.an9()) {
      tmp = $this.onf_1;
    } else {
      tmp = ProjectionalObservableListSynchronizer$replaceWithNewOnDelete$lambda;
    }
    return tmp;
  }
  function insertItems($this, insertIndex, items) {
    $this.hnf_1.n2(insertIndex, items);
    var target = $this.gna().q((insertIndex + items.n() | 0) - 1 | 0);
    toLastFocusable(target)();
  }
  function insertItemsAndSelect($this, items) {
    var selectionSupport = $this.fna();
    var selectionRange = selectionSupport.rnf();
    var insertIndex = selectionRange.x2s();
    insertItems($this, insertIndex, items);
    selectionSupport.snf(items);
  }
  function doClear($this, items) {
    var firstIndex = indexOf_5($this.hnf_1, items.q(0));
    var _iterator__ex2g4s = ArrayList_init_$Create$_1(items).k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.remove' call
      var this_0 = $this.hnf_1;
      (isInterface(this_0, MutableCollection) ? this_0 : THROW_CCE()).k2(item);
    }
    selectAfterClear_0($this, firstIndex);
  }
  function selectAfterClear_0($this, index) {
    if ($this.hnf_1.p()) {
      $this.sna()();
    } else if (index < $this.hnf_1.n()) {
      var target = $this.gna().q(index);
      toFirstFocusable(target)();
    } else {
      var target_0 = $this.gna().q(index - 1 | 0);
      toLastFocusable(target_0)();
    }
  }
  function isEmpty_3($this, index) {
    return isEmpty_0($this.gna().q(index));
  }
  function sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0(function_0) {
    this.tnf_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0).rnd = function (cell) {
    return this.tnf_1(cell);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0).b4 = function () {
    return this.tnf_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, CreateNewElementHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function ProjectionalObservableListSynchronizer$createNewToTheRight$ref($boundThis) {
    var l = function (p0) {
      return createNewToTheRight($boundThis, p0);
    };
    l.callableName = 'createNewToTheRight';
    return l;
  }
  function ProjectionalObservableListSynchronizer$currentChildCompletion$role$1(this$0) {
    this.unf_1 = this$0;
  }
  protoOf(ProjectionalObservableListSynchronizer$currentChildCompletion$role$1).pn8 = function (target) {
    var index = _get_currentCellIndex__uqju5o(this.unf_1);
    this.unf_1.hnf_1.o2(index, target);
    return this.unf_1.gna().q(index).ulp(ProjectionalSynchronizers_getInstance().jlw_1);
  };
  protoOf(ProjectionalObservableListSynchronizer$currentChildCompletion$role$1).qn8 = function (target) {
    return this.pn8(!(target == null) ? target : THROW_CCE());
  };
  function ProjectionalObservableListSynchronizer$doRegisterChild$trait$1(this$0, $child) {
    this.vnf_1 = this$0;
    this.wnf_1 = $child;
    CompositeCellTrait.call(this);
  }
  protoOf(ProjectionalObservableListSynchronizer$doRegisterChild$trait$1).wma = function (cell) {
    var tmp;
    if (cell instanceof TextCell) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [this.vnf_1.mnf_1];
    } else {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [this.vnf_1.mnf_1, CompletionSupport_getInstance().bmb()];
    }
    return tmp;
  };
  protoOf(ProjectionalObservableListSynchronizer$doRegisterChild$trait$1).olm = function (cell, event) {
    try {
      if (this.vnf_1.xn9().n() <= 1) {
        keyPressedInChild(this.vnf_1, event, this.wnf_1);
      }
    }finally {
      if (event.ml0_1 && cell.qlc()) {
        this.vnf_1.zn9();
      }
    }
    protoOf(CompositeCellTrait).olm.call(this, cell, event);
  };
  protoOf(ProjectionalObservableListSynchronizer$doRegisterChild$trait$1).flo = function (cell, spec) {
    var specMatcher = specMatcherValue(Completion_getInstance().cm1_1, _get_currentChildCompletion__dt6zjo(this.vnf_1));
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.editor.cell.<no name provided>.get.<anonymous>' call
      tmp = protoOf(CompositeCellTrait).flo.call(this, cell, spec);
    } else {
      tmp = result.sma_1;
    }
    return tmp;
  };
  protoOf(ProjectionalObservableListSynchronizer$doRegisterChild$trait$1).bll = function (cell, spec, event) {
    if (spec === Cells_getInstance().kmg_1 && cell.ulp(ProjectionalSynchronizers_getInstance().llw_1)) {
      var index = this.vnf_1.gna().t(cell);
      if (index === -1)
        return Unit_instance;
      this.vnf_1.yn9(this.vnf_1.hnf_1.j2(index, index + 1 | 0), event);
      event.ol0();
      return Unit_instance;
    }
    if (spec === JoinChildrenEvent_getInstance().pnd_1) {
      var joinEvent = event instanceof DerivedEvent ? event : THROW_CCE();
      if (getCollectionEditor(this.vnf_1, this.wnf_1).gnd(this.vnf_1.hnf_1.t(this.wnf_1), joinEvent.cl1_1, ensureNotNull(this.vnf_1.dnb()))) {
        joinEvent.ol0();
        return Unit_instance;
      }
    }
    if (spec === Companion_getInstance_318().cng_1) {
      var splitEvent = event instanceof SplitChildEvent ? event : THROW_CCE();
      if (splitEvent.bng(cell)) {
        return Unit_instance;
      }
      if (this.vnf_1.an9()) {
        if (getCollectionEditor(this.vnf_1, this.wnf_1).end(this.vnf_1.hnf_1.t(this.wnf_1), splitEvent.cl1_1)) {
          splitEvent.ol0();
          return Unit_instance;
        }
      }
      return Unit_instance;
    }
    protoOf(CompositeCellTrait).bll.call(this, cell, spec, event);
  };
  function ProjectionalObservableListSynchronizer$getCollectionEditor$1(this$0, $splitJoinHandler) {
    this.jng_1 = this$0;
    CollectionEditor.call(this, this$0.hnf_1, this$0.gna(), this$0.fn7_1, this$0.an9(), replaceWithNewOnDelete(this$0), $splitJoinHandler);
  }
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).vnc = function () {
    return this.jng_1.xn9().p();
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).onc = function () {
    return this.jng_1.nnf_1;
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).wnc = function () {
    return this.jng_1.pnf_1;
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).enb = function (contextItem) {
    return this.jng_1.enb(contextItem);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).pnc = function (contextItem) {
    return this.enb(!(contextItem == null) ? contextItem : THROW_CCE());
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).xnc = function () {
    return !(this.jng_1.jna() == null);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).kng = function (item) {
    return ensureNotNull(this.jng_1.jna()).lng(item);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).ync = function (item) {
    return this.kng(!(item == null) ? item : THROW_CCE());
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).mng = function (item) {
    return isEmpty_0(item);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).nnc = function (item) {
    return this.mng((!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).nng = function (item) {
    return Positions_instance.ems(item);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).znc = function (item) {
    return this.nng((!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).ong = function (item) {
    return this.jng_1.jnf_1(item);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).and = function (item) {
    return this.ong((!(item == null) ? isInterface(item, Cell) : false) ? item : THROW_CCE());
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).rnc = function (index) {
    return this.jng_1.hnb(index)();
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).tnc = function (index) {
    return toFirstFocusable(this.jng_1.gna().q(index))();
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).snc = function (index) {
    return toLastFocusable(this.jng_1.gna().q(index))();
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).unc = function () {
    return this.jng_1.sna()();
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).cnc = function () {
    return this.jng_1.cnc();
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).qnc = function (index, event) {
    Companion_getInstance_318().png(this.jng_1.un6_1, event);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).bnd = function (event) {
    return JoinChildrenEvent_getInstance().qnd(this.jng_1.un6_1, event);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).fnd = function (event) {
    return event.ol1([this.jng_1.knf_1]);
  };
  protoOf(ProjectionalObservableListSynchronizer$getCollectionEditor$1).dnd = function (event) {
    return event.ol1([this.jng_1.lnf_1]);
  };
  function ProjectionalObservableListSynchronizer$replaceWithNewOnDelete$lambda(it) {
    return false;
  }
  function ProjectionalObservableListSynchronizer(source, target, targetList, factory, settings) {
    BaseProjectionalSynchronizer.call(this, target, targetList, settings, true);
    this.hnf_1 = source;
    this.inf_1 = settings.xnd_1;
    this.jnf_1 = settings.ynd_1;
    this.knf_1 = settings.znd_1;
    this.lnf_1 = settings.ane_1;
    var tmp = this;
    var createTrait = settings.ene_1;
    var tmp_0;
    if (createTrait == null) {
      tmp_0 = new DefaultCreateNewItemCellTrait(this);
    } else {
      var tmp_1 = ProjectionalObservableListSynchronizer$createNewToTheRight$ref(this);
      tmp_0 = createTrait(new sam$jetbrains_ocelot_projectional_editor_cell_ProjectionalListSynchronizerSettings_CreateNewElementHandle$0(tmp_1));
    }
    tmp.mnf_1 = tmp_0;
    this.nnf_1 = settings.bne_1;
    this.onf_1 = settings.cne_1;
    this.pnf_1 = settings.dne_1;
    this.qnf_1 = Synchronizers_instance.nle(this.hnf_1, this.gna(), factory);
  }
  protoOf(ProjectionalObservableListSynchronizer).hna = function () {
    return this.qnf_1;
  };
  protoOf(ProjectionalObservableListSynchronizer).bna = function (selectionSupport) {
    var updateHandler = new SourceUpdateHandler(this.hnf_1, selectionSupport);
    return this.hnf_1.o27(updateHandler);
  };
  protoOf(ProjectionalObservableListSynchronizer).tn9 = function (child, childCell) {
    var trait = new ProjectionalObservableListSynchronizer$doRegisterChild$trait$1(this, child);
    return childCell.olp(trait);
  };
  protoOf(ProjectionalObservableListSynchronizer).xn8 = function (items) {
    var index = _get_currentCellIndex__uqju5o(this);
    if (index === -1) {
      this.hnf_1.o(items);
      return this.hnb(get_lastIndex_2(items));
    }
    var tmp;
    if (Positions_instance.ems(ensureNotNull(this.dnb()))) {
      this.hnf_1.n2(index, items);
      var tmp_0;
      if (isEmpty_3(this, index)) {
        tmp_0 = get_EMPTY_CELL_ACTION();
      } else {
        tmp_0 = this.hnb((index + items.n() | 0) - 1 | 0);
      }
      tmp = tmp_0;
    } else {
      this.hnf_1.n2(index + 1 | 0, items);
      tmp = this.hnb(index + items.n() | 0);
    }
    return tmp;
  };
  protoOf(ProjectionalObservableListSynchronizer).zn8 = function (event) {
    return event.ol1([this.knf_1, this.lnf_1]);
  };
  protoOf(ProjectionalObservableListSynchronizer).qn9 = function (event) {
    var clonerSupport = this.jna();
    var tmp;
    if (!(clonerSupport == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !this.xn9().p();
    } else {
      tmp = false;
    }
    if (tmp) {
      var copiedItems = clonerSupport.qng(this.xn9());
      insertItemsAndSelect(this, copiedItems);
      event.ol0();
    } else {
      this.pn9();
    }
  };
  protoOf(ProjectionalObservableListSynchronizer).yn9 = function (items, cause) {
    return doClear(this, items);
  };
  protoOf(ProjectionalObservableListSynchronizer).en9 = function (items, cause, result) {
    return doClear(this, items);
  };
  function _get_completion__ojdpzl($this) {
    return $this.rn8(new ProjectionalPropertySynchronizer$completion$1($this));
  }
  function handleItemKeyPress($this, event, cell) {
    if ($this.nnh_1 && $this.dnc(event, cell, true) && $this.fn7_1.qr() == null) {
      $this.fn7_1.t2c($this.mnh_1.qr());
      event.ol0();
      return Unit_instance;
    }
    if ($this.nnh_1 && $this.enc(event, cell)) {
      deleteItem($this, event);
      event.ql0();
    }
  }
  function deleteItem($this, cause) {
    clearSourceValue($this);
    $this.sna()();
    if ($this.un6_1.ulp(ProjectionalSynchronizers_getInstance().llw_1)) {
      var derivedEvent = new DerivedEvent(cause);
      $this.un6_1.nlp(derivedEvent, Cells_getInstance().kmg_1);
    }
  }
  function deleteItem_0($this, cause, result) {
    clearSourceValue($this);
    $this.sna()();
    if ($this.un6_1.ulp(ProjectionalSynchronizers_getInstance().llw_1)) {
      var derivedEvent = new DerivedCopyCutEvent(cause, result);
      $this.un6_1.nlp(derivedEvent, Cells_getInstance().kmg_1);
    }
  }
  function clearSourceValue($this) {
    return $this.mnh_1.t2c(null);
  }
  function ProjectionalPropertySynchronizer$completion$1(this$0) {
    this.pnh_1 = this$0;
  }
  protoOf(ProjectionalPropertySynchronizer$completion$1).pn8 = function (target) {
    this.pnh_1.mnh_1.t2c(target);
    return this.pnh_1.hnb(0);
  };
  protoOf(ProjectionalPropertySynchronizer$completion$1).qn8 = function (target) {
    return this.pn8(!(target == null) ? target : THROW_CCE());
  };
  function ProjectionalPropertySynchronizer$doRegisterChild$trait$1(this$0) {
    this.qnh_1 = this$0;
    DerivedCellTrait.call(this);
  }
  protoOf(ProjectionalPropertySynchronizer$doRegisterChild$trait$1).qmt = function (cell) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = Companion_getInstance_302().dmw_1;
    } else {
      tmp = CompletionSupport_getInstance().bmb();
    }
    return tmp;
  };
  protoOf(ProjectionalPropertySynchronizer$doRegisterChild$trait$1).olm = function (cell, event) {
    handleItemKeyPress(this.qnh_1, event, cell);
    if (event.ml0_1)
      return Unit_instance;
    this.llm(cell, event);
  };
  protoOf(ProjectionalPropertySynchronizer$doRegisterChild$trait$1).flo = function (cell, spec) {
    var specMatcher = specMatcherValue(Completion_getInstance().cm1_1, _get_completion__ojdpzl(this.qnh_1));
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.getSpecValue' call
    var result = specMatcher(spec);
    var tmp;
    if (result == null) {
      // Inline function 'jetbrains.ocelot.projectional.editor.cell.<no name provided>.get.<anonymous>' call
      tmp = protoOf(DerivedCellTrait).flo.call(this, cell, spec);
    } else {
      tmp = result.sma_1;
    }
    return tmp;
  };
  protoOf(ProjectionalPropertySynchronizer$doRegisterChild$trait$1).bll = function (cell, spec, event) {
    if (spec === Cells_getInstance().kmg_1 && this.qnh_1.nnh_1 && cell.ulp(ProjectionalSynchronizers_getInstance().llw_1)) {
      deleteItem(this.qnh_1, event);
      event.ql0();
      return Unit_instance;
    }
    protoOf(DerivedCellTrait).bll.call(this, cell, spec, event);
  };
  function ProjectionalPropertySynchronizer(source, target, factory, settings) {
    BaseProjectionalSynchronizer.call(this, target, target.ilp(), settings, false);
    this.mnh_1 = source;
    this.nnh_1 = settings.wnh_1;
    this.onh_1 = Synchronizers_instance.ple(this.mnh_1, toWritableProperty(this.gna()), factory);
  }
  protoOf(ProjectionalPropertySynchronizer).hna = function () {
    return this.onh_1;
  };
  protoOf(ProjectionalPropertySynchronizer).bna = function (selectionSupport) {
    return Companion_getInstance_25().wr_1;
  };
  protoOf(ProjectionalPropertySynchronizer).tn9 = function (child, childCell) {
    var trait = new ProjectionalPropertySynchronizer$doRegisterChild$trait$1(this);
    return childCell.olp(trait);
  };
  protoOf(ProjectionalPropertySynchronizer).yn9 = function (items, cause) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!items.p()) {
      tmp = this.nnh_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      deleteItem(this, cause);
    }
  };
  protoOf(ProjectionalPropertySynchronizer).en9 = function (items, cause, result) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!items.p()) {
      tmp = this.nnh_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      deleteItem_0(this, cause, result);
    }
  };
  protoOf(ProjectionalPropertySynchronizer).xn8 = function (items) {
    this.mnh_1.t2c(items.q(0));
    return this.hnb(0);
  };
  protoOf(ProjectionalPropertySynchronizer).qn9 = function (event) {
    return this.pn9();
  };
  protoOf(ProjectionalPropertySynchronizer).zn8 = function (event) {
    return event.ol1([get_INSERT()]);
  };
  function ProjectionalPropertySynchronizerSettings() {
    ProjectionalSynchronizerSettings.call(this);
    this.wnh_1 = true;
  }
  protoOf(ProjectionalPropertySynchronizerSettings).fne = function () {
    return this;
  };
  protoOf(ProjectionalPropertySynchronizerSettings).xnh = function (canClear) {
    this.wnh_1 = canClear;
    return this.fne();
  };
  function get_INSERT_BEFORE() {
    _init_properties_ProjectionalRoleKeys_kt__xanh8c();
    return INSERT_BEFORE;
  }
  var INSERT_BEFORE;
  function get_INSERT_AFTER() {
    _init_properties_ProjectionalRoleKeys_kt__xanh8c();
    return INSERT_AFTER;
  }
  var INSERT_AFTER;
  function get_INSERT() {
    _init_properties_ProjectionalRoleKeys_kt__xanh8c();
    return INSERT;
  }
  var INSERT;
  var properties_initialized_ProjectionalRoleKeys_kt_m5t412;
  function _init_properties_ProjectionalRoleKeys_kt__xanh8c() {
    if (!properties_initialized_ProjectionalRoleKeys_kt_m5t412) {
      properties_initialized_ProjectionalRoleKeys_kt_m5t412 = true;
      INSERT_BEFORE = KeyStrokeSpecs_getInstance().ml3([KeyStroke_init_$Create$(Key_ENTER_getInstance(), []).bl2([ModifierKey_META_getInstance()]), KeyStroke_init_$Create$(Key_INSERT_getInstance(), []), KeyStroke_init_$Create$(Key_ENTER_getInstance(), []).bl2([ModifierKey_CONTROL_getInstance()])]);
      INSERT_AFTER = KeyStrokeSpec_init_$Create$(Key_ENTER_getInstance(), []);
      INSERT = KeyStrokeSpecs_getInstance().nl3([get_INSERT_BEFORE(), get_INSERT_AFTER()]);
    }
  }
  function ProjectionalSynchronizerSettings$placeholderCaretCellTraitFactory$lambda(trait) {
    return trait;
  }
  function ProjectionalSynchronizerSettings$placeholderVisibleCellTraitFactory$lambda() {
    return null;
  }
  function ProjectionalSynchronizerSettings() {
    this.mnb_1 = ProjectionalSelection_getInstance().ynh_1;
    var tmp = this;
    tmp.nnb_1 = ProjectionalSynchronizerSettings$placeholderCaretCellTraitFactory$lambda;
    var tmp_0 = this;
    tmp_0.onb_1 = ProjectionalSynchronizerSettings$placeholderVisibleCellTraitFactory$lambda;
    this.pnb_1 = null;
    this.qnb_1 = Companion_getInstance_317().ond_1;
  }
  protoOf(ProjectionalSynchronizerSettings).kne = function (placeholderText) {
    this.pnb_1 = placeholderText;
    return this.fne();
  };
  protoOf(ProjectionalSynchronizerSettings).ine = function (factory) {
    this.nnb_1 = factory;
    return this.fne();
  };
  protoOf(ProjectionalSynchronizerSettings).jne = function (factory) {
    this.onb_1 = factory;
    return this.fne();
  };
  function toLastFocusable$ref() {
    var l = function (p0) {
      return toLastFocusable(p0);
    };
    l.callableName = 'toLastFocusable';
    return l;
  }
  function ProjectionalSynchronizers() {
    ProjectionalSynchronizers_instance = this;
    var tmp = this;
    tmp.jlw_1 = new CellTraitPropertySpec('onCreate', toLastFocusable$ref());
    this.klw_1 = CellTraitPropertySpec_init_$Create$('ignoredCell', false);
    this.llw_1 = CellTraitPropertySpec_init_$Create$('deleteOnEmpty', false);
  }
  protoOf(ProjectionalSynchronizers).znh = function (source, target, targetList, factory, settings) {
    return new ProjectionalObservableListSynchronizer(source, target, targetList, factory, settings);
  };
  protoOf(ProjectionalSynchronizers).ani = function (source, target, factory, settings) {
    return new ProjectionalPropertySynchronizer(source, target, factory, settings);
  };
  var ProjectionalSynchronizers_instance;
  function ProjectionalSynchronizers_getInstance() {
    if (ProjectionalSynchronizers_instance == null)
      new ProjectionalSynchronizers();
    return ProjectionalSynchronizers_instance;
  }
  function copyHandlerTrait($this, sync, targetList, selectionSupport, clipboardParameters) {
    var clipboardHandler = new ProjectionalClipboardHandler(false, ReadOnlyProjectionalSynchronizers$copyHandlerTrait$lambda(sync, targetList));
    if (clipboardParameters == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.editor.cell.ReadOnlyProjectionalSynchronizers.copyHandlerTrait.<anonymous>' call
      clipboardHandler.bni(clipboardParameters);
    }
    return new RoleSynchronizerCopyTrait(clipboardHandler, selectionSupport);
  }
  function rolePlaceholder($this, text) {
    var textCell = CellFactory_instance.amx('');
    var placeholder_0 = placeholder(textCell, text);
    return CellFactory_instance.wmw([textCell, placeholder_0]);
  }
  function ReadOnlyProjectionalSynchronizers$forRole$lambda(it) {
    return Companion_getInstance_25().wr_1;
  }
  function ReadOnlyProjectionalSynchronizers$forRole$lambda_0(selectionSupport) {
    return new BaseSelectionCaptureTrait(ReadOnlyProjectionalSynchronizers$forRole$lambda$lambda(selectionSupport));
  }
  function ReadOnlyProjectionalSynchronizers$forRole$lambda$lambda($selectionSupport) {
    return function (it) {
      return $selectionSupport;
    };
  }
  function ReadOnlyProjectionalSynchronizers$forRole$lambda_1($placeholder) {
    return function () {
      return rolePlaceholder(ReadOnlyProjectionalSynchronizers_instance, $placeholder);
    };
  }
  function ReadOnlyProjectionalSynchronizers$forSingleRole$target$1($targetCell, $targetList, $placeholder) {
    this.cni_1 = $targetCell;
    this.dni_1 = $targetList;
    this.eni_1 = $placeholder;
  }
  protoOf(ReadOnlyProjectionalSynchronizers$forSingleRole$target$1).imi = function (newValue) {
    var children = this.cni_1.ilp();
    children.m2();
    this.dni_1.m2();
    children.e(newValue == null ? rolePlaceholder(ReadOnlyProjectionalSynchronizers_instance, this.eni_1) : newValue);
    if (!(newValue == null)) {
      this.dni_1.e(newValue);
    }
  };
  protoOf(ReadOnlyProjectionalSynchronizers$forSingleRole$target$1).t2c = function (newValue) {
    return this.imi((newValue == null ? true : isInterface(newValue, Cell)) ? newValue : THROW_CCE());
  };
  function ReadOnlyProjectionalSynchronizers$forSingleRole$lambda(it) {
    return Companion_getInstance_25().wr_1;
  }
  function ReadOnlyProjectionalSynchronizers$forSingleRole$lambda_0(selectionSupport) {
    return new BaseSelectionCaptureTrait(ReadOnlyProjectionalSynchronizers$forSingleRole$lambda$lambda(selectionSupport));
  }
  function ReadOnlyProjectionalSynchronizers$forSingleRole$lambda$lambda($selectionSupport) {
    return function (it) {
      return $selectionSupport;
    };
  }
  function ReadOnlyProjectionalSynchronizers$copyHandlerTrait$lambda($sync, $targetList) {
    return function (item) {
      var index = indexOf_12($sync, item);
      var cell = $targetList.q(index);
      return toText_0(toBlock(cell));
    };
  }
  function ReadOnlyProjectionalSynchronizers() {
  }
  protoOf(ReadOnlyProjectionalSynchronizers).fni = function (sourceList, targetCell, targetList, mapperFactory, placeholder, clipboardParameters) {
    var cellList = new ObservableArrayList();
    var mainSynchronizer = Synchronizers_instance.nle(sourceList, cellList, mapperFactory);
    var tmp = new BaseSelectionSpec();
    var tmp_0 = ReadOnlyProjectionalSynchronizers$forRole$lambda;
    var synchronizerSelectionSupport = new RoleSynchronizerSelectionSupport(mainSynchronizer, tmp, sourceList, targetCell, targetList, tmp_0, ReadOnlyProjectionalSynchronizers$forRole$lambda_0);
    var traitAdded = targetCell.olp(copyHandlerTrait(this, mainSynchronizer, targetList, synchronizerSelectionSupport, clipboardParameters));
    var tmp_1 = Transformers_instance;
    var placeholderIfEmpty = tmp_1.e2l(ReadOnlyProjectionalSynchronizers$forRole$lambda_1(placeholder));
    var placeholderTransformation = placeholderIfEmpty.m2i(cellList, targetList);
    return Synchronizers_instance.sle([mainSynchronizer, Synchronizers_instance.rle([placeholderTransformation, synchronizerSelectionSupport, traitAdded])]);
  };
  protoOf(ReadOnlyProjectionalSynchronizers).gni = function (source, targetCell, mapperFactory, placeholder, clipboardParameters) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var targetList = ArrayList_init_$Create$();
    var target = new ReadOnlyProjectionalSynchronizers$forSingleRole$target$1(targetCell, targetList, placeholder);
    target.imi(null);
    var mainSynchronizer = Synchronizers_instance.ple(source, target, mapperFactory);
    var sourceAsList = new ObservableArrayList();
    var tmp = new BaseSelectionSpec();
    var tmp_0 = targetCell.g2r();
    var tmp_1 = ReadOnlyProjectionalSynchronizers$forSingleRole$lambda;
    var synchronizerSelectionSupport = new RoleSynchronizerSelectionSupport(mainSynchronizer, tmp, sourceAsList, targetCell, tmp_0, tmp_1, ReadOnlyProjectionalSynchronizers$forSingleRole$lambda_0);
    var traitAdded = targetCell.olp(copyHandlerTrait(this, mainSynchronizer, targetList, synchronizerSelectionSupport, clipboardParameters));
    var sourceToListTransform = Transformers_instance.f2l().m2i(source, sourceAsList);
    return Synchronizers_instance.sle([mainSynchronizer, Synchronizers_instance.rle([sourceToListTransform, synchronizerSelectionSupport, traitAdded])]);
  };
  var ReadOnlyProjectionalSynchronizers_instance;
  function ReadOnlyProjectionalSynchronizers_getInstance() {
    return ReadOnlyProjectionalSynchronizers_instance;
  }
  function canCut($this) {
    return $this.ln9() && $this.in9_1.hni();
  }
  function cut($this, event) {
    var toCopy = $this.mn9();
    var result = $this.in9_1.ini(toCopy);
    $this.dn9(toCopy, event, result);
    return result;
  }
  function paste($this, clipboardContent) {
    var items = $this.in9_1.jni(clipboardContent);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!items.p()) {
      $this.fn9(items);
    }
  }
  function RoleSynchronizerCopyPasteTrait(clipboardHandler, selectionSupport) {
    RoleSynchronizerCopyTrait.call(this, clipboardHandler, selectionSupport);
    this.in9_1 = clipboardHandler;
  }
  protoOf(RoleSynchronizerCopyPasteTrait).ylo = function (cell, event) {
    if (canCut(this)) {
      var content = cut(this, event);
      event.vl0(content);
    } else {
      protoOf(RoleSynchronizerCopyTrait).ylo.call(this, cell, event);
    }
  };
  protoOf(RoleSynchronizerCopyPasteTrait).zlo = function (cell, event) {
    var content = event.cl4_1;
    if (this.in9_1.kni(content)) {
      paste(this, content);
      event.ol0();
    } else {
      protoOf(RoleSynchronizerCopyTrait).zlo.call(this, cell, event);
    }
  };
  function _get_selectedItems__ypx024($this) {
    return $this.kn9_1.wnb_1.cnb();
  }
  function _get_currentItem__jpszrv($this) {
    return $this.kn9_1.lni();
  }
  function canCopy($this) {
    return $this.ln9() && $this.jn9_1.mni();
  }
  function copy($this) {
    var items = $this.mn9();
    return $this.jn9_1.nni(items);
  }
  function RoleSynchronizerCopyTrait(clipboardHandler, selectionSupport) {
    CellTrait.call(this);
    this.jn9_1 = clipboardHandler;
    this.kn9_1 = selectionSupport;
  }
  protoOf(RoleSynchronizerCopyTrait).xlo = function (cell, event) {
    if (canCopy(this)) {
      event.ul0(copy(this));
    } else {
      protoOf(CellTrait).xlo.call(this, cell, event);
    }
  };
  protoOf(RoleSynchronizerCopyTrait).ln9 = function () {
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!_get_selectedItems__ypx024(this).p()) {
      tmp_0 = true;
    } else {
      tmp_0 = !(_get_currentItem__jpszrv(this) == null);
    }
    if (tmp_0) {
      tmp = !this.kn9_1.wnb_1.cnc();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(RoleSynchronizerCopyTrait).mn9 = function () {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'jetbrains.ocelot.projectional.editor.cell.RoleSynchronizerCopyTrait.itemsToCopy.<anonymous>' call
    if (_get_selectedItems__ypx024(this).p()) {
      var current = _get_currentItem__jpszrv(this);
      if (!(current == null)) {
        this_0.e(current);
      }
    } else {
      this_0.o(_get_selectedItems__ypx024(this));
    }
    return this_0.e4();
  };
  function nextCell($this, root) {
    // Inline function 'jetbrains.ocelot.base.composite.Composites.nextNavOrder' call
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = Composites_instance.x2r(root);
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.base.composite.Composites.nextNavOrder.<anonymous>' call
        // Inline function 'jetbrains.ocelot.projectional.editor.cell.Companion.nextCell.<anonymous>' call
        if (isVisible_1(element) && !isIgnored(Companion_getInstance_318(), element)) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      tmp$ret$2 = null;
    }
    return tmp$ret$2;
  }
  function isIgnored($this, cell) {
    var $this_0 = $this;
    var cell_0 = cell;
    $l$1: do {
      $l$0: do {
        var tmp;
        if (cell_0.ulp(ProjectionalSynchronizers_getInstance().klw_1)) {
          tmp = true;
        } else {
          var parent = cell_0.yt();
          var tmp_0;
          if (parent == null) {
            tmp_0 = false;
          } else {
            $this_0 = $this_0;
            cell_0 = parent;
            continue $l$0;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function Companion_318() {
    Companion_instance_318 = this;
    this.cng_1 = new CellTraitEventSpec('splitChildEvent', true);
  }
  protoOf(Companion_318).png = function (cell, keyEvent) {
    var derivedEvent = new SplitChildEvent(cell, keyEvent);
    cell.nlp(derivedEvent, this.cng_1);
  };
  var Companion_instance_318;
  function Companion_getInstance_318() {
    if (Companion_instance_318 == null)
      new Companion_318();
    return Companion_instance_318;
  }
  function SplitChildEvent(sourceCell, keyEvent) {
    Companion_getInstance_318();
    DerivedEvent.call(this, keyEvent);
    this.ang_1 = nextCell(Companion_getInstance_318(), sourceCell);
  }
  protoOf(SplitChildEvent).bng = function (dispatchedTo) {
    var tmp;
    if (this.ang_1 === nextCell(Companion_getInstance_318(), dispatchedTo)) {
      tmp = false;
    } else {
      this.ol0();
      tmp = true;
    }
    return tmp;
  };
  function ClipboardParameters(contentKind, clonerSupport) {
    this.oni_1 = contentKind;
    this.pni_1 = clonerSupport;
  }
  function createClipboardParameters(contentKindClass, clonerSupport) {
    var contentKind = ContentKinds_getInstance().kl4(contentKindClass);
    return new ClipboardParameters(contentKind, clonerSupport);
  }
  function ClonerSupport() {
  }
  function ProjectionalClipboardContent(itemKind, items) {
    this.sni_1 = itemKind;
    this.tni_1 = items;
  }
  protoOf(ProjectionalClipboardContent).fl0 = function (kind) {
    return this.tni_1.n() <= 1 && equals(kind, this.sni_1) || equals(kind, ContentKinds_getInstance().jl4(this.sni_1));
  };
  function doGetPersister($this, concept, textualContent) {
    var p = $this.vni(concept);
    return new ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1(p, $this, textualContent, concept);
  }
  function doGetPersister$default($this, concept, textualContent, $super) {
    textualContent = textualContent === VOID ? null : textualContent;
    return doGetPersister($this, concept, textualContent);
  }
  function doGetListPersister($this, concept, textualContent) {
    var p = $this.vni(concept);
    return new ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1($this, p, textualContent, concept);
  }
  function doGetListPersister$default($this, concept, textualContent, $super) {
    textualContent = textualContent === VOID ? null : textualContent;
    return doGetListPersister($this, concept, textualContent);
  }
  function encloseInHtmlPre(_this__u8e3s4, $this, content) {
    var tmp = '<pre dir="' + escapeHtml(_this__u8e3s4, $this) + '">';
    var tmp1_elvis_lhs = content == null ? null : escapeHtml(content, $this);
    return tmp + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs) + '<\/pre>';
  }
  function escapeHtml(_this__u8e3s4, $this) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = _this__u8e3s4;
    var _iterator__ex2g4s = $this.uni_1.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.editor.cell.clipboard.ProjectionalClipboardContentSerializationAsHtml.escapeHtml.<anonymous>' call
      var s = accumulator;
      accumulator = replace(s, element.dh_1, element.eh_1);
    }
    return accumulator;
  }
  function deEscapeHtml(_this__u8e3s4, $this) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = _this__u8e3s4;
    var _iterator__ex2g4s = $this.uni_1.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.editor.cell.clipboard.ProjectionalClipboardContentSerializationAsHtml.deEscapeHtml.<anonymous>' call
      var s = accumulator;
      accumulator = replace(s, element.eh_1, element.dh_1);
    }
    return accumulator;
  }
  function extractFromHtmlPre(_this__u8e3s4, $this) {
    var trimmedOpening = substringAfter(_this__u8e3s4, '<pre dir="');
    var result = deEscapeHtml(substringBefore(trimmedOpening, '">'), $this);
    return to(result, substringAfter(_this__u8e3s4, '<\/pre>'));
  }
  function encloseInDiv(_this__u8e3s4, $this, concept, multiple) {
    return openingDiv($this, concept, multiple) + _this__u8e3s4 + '<\/div>';
  }
  function openingDiv($this, concept, multiple) {
    return openingDivPart($this, concept, multiple) + '>';
  }
  function openingDivPart($this, concept, multiple) {
    return '<div class="ocelot-concept-' + multiple + '-' + concept.lb() + '-end"';
  }
  function extractFromDiv(_this__u8e3s4, $this) {
    return substringBefore(substringAfter(_this__u8e3s4, ', end">'), '<\/div>');
  }
  function encloseInAuxiliaryPre(_this__u8e3s4, $this) {
    return _this__u8e3s4 == null ? '' : '<pre class="y">' + escapeHtml(_this__u8e3s4, $this) + '<\/pre>';
  }
  function trimAuxiliaryPre(_this__u8e3s4, $this) {
    return substringBefore(_this__u8e3s4, '<pre class="y">');
  }
  function Companion_319() {
    Companion_instance_319 = this;
    this.wni_1 = '<pre dir="';
    this.xni_1 = '">';
    this.yni_1 = '<\/pre>';
    this.zni_1 = '<pre class="y">';
    var tmp = this;
    // Inline function 'kotlin.text.toRegex' call
    var this_0 = 'div class="ocelot-concept-.+-.+-end"';
    tmp.anj_1 = Regex_init_$Create$(this_0);
    this.bnj_1 = 'text/html';
  }
  var Companion_instance_319;
  function Companion_getInstance_319() {
    if (Companion_instance_319 == null)
      new Companion_319();
    return Companion_instance_319;
  }
  function ProjectionalClipboardContentSerializationAsHtml$deserialize$1($htmlText, this$0, $data) {
    this.cnj_1 = $htmlText;
    this.dnj_1 = this$0;
    this.enj_1 = $data;
  }
  protoOf(ProjectionalClipboardContentSerializationAsHtml$deserialize$1).fl0 = function (kind) {
    var tmp;
    if (kind instanceof ReifiedContentKind) {
      tmp = to(kind.fl4_1, false);
    } else {
      var tmp_0;
      if (kind instanceof ListContentKind) {
        var tmp_1 = kind.el4_1;
        tmp_0 = tmp_1 instanceof ReifiedContentKind;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var tmp_2 = kind.el4_1;
        tmp = to((tmp_2 instanceof ReifiedContentKind ? tmp_2 : THROW_CCE()).fl4_1, true);
      } else {
        return false;
      }
    }
    var _destruct__k2r9zo = tmp;
    var concept = _destruct__k2r9zo.ug();
    var multiple = _destruct__k2r9zo.vg();
    return contains_9(this.cnj_1, openingDivPart(this.dnj_1, concept, multiple));
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$deserialize$1).hl0 = function () {
    var tmp0_elvis_lhs = this.enj_1.y2('text/plain');
    return tmp0_elvis_lhs == null ? toString_1(this) : tmp0_elvis_lhs;
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$deserialize$1).gl0 = function (kind) {
    var tmp;
    if (kind instanceof ReifiedContentKind) {
      var tmp_0 = kind.fl4_1;
      var concept = isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
      var tmp_1 = doGetPersister$default(this.dnj_1, concept);
      tmp = (isInterface(tmp_1, Persister) ? tmp_1 : THROW_CCE()).q2q(this.cnj_1);
    } else {
      var tmp_2;
      if (kind instanceof ListContentKind) {
        var tmp_3 = kind.el4_1;
        tmp_2 = tmp_3 instanceof ReifiedContentKind;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        var tmp_4 = kind.el4_1;
        var tmp_5 = (tmp_4 instanceof ReifiedContentKind ? tmp_4 : THROW_CCE()).fl4_1;
        var concept_0 = isInterface(tmp_5, KClass) ? tmp_5 : THROW_CCE();
        var tmp_6 = doGetListPersister$default(this.dnj_1, concept_0);
        tmp = (isInterface(tmp_6, Persister) ? tmp_6 : THROW_CCE()).q2q(this.cnj_1);
      } else {
        throw IllegalStateException_init_$Create$_0('get() is out of sync with isSupported()');
      }
    }
    return tmp;
  };
  function ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1($p, this$0, $textualContent, $concept) {
    this.fnj_1 = $p;
    this.gnj_1 = this$0;
    this.hnj_1 = $textualContent;
    this.inj_1 = $concept;
  }
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1).n2q = function () {
    return this.fnj_1.n2q();
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1).jnj = function (value) {
    return encloseInDiv(encloseInHtmlPre(this.fnj_1.o2q(value), this.gnj_1, this.hnj_1), this.gnj_1, this.inj_1, false);
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1).o2q = function (value) {
    return this.jnj(!(value == null) ? value : THROW_CCE());
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1).p2q = function (value) {
    var serializedNode = extractFromHtmlPre(extractFromDiv(value, this.gnj_1), this.gnj_1).dh_1;
    return this.fnj_1.p2q(serializedNode);
  };
  function ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1(this$0, $p, $textualContent, $concept) {
    this.knj_1 = this$0;
    this.lnj_1 = $p;
    this.mnj_1 = $textualContent;
    this.nnj_1 = $concept;
  }
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1).n2q = function () {
    return new DefaultValueNullPersister(emptyList());
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1).onj = function (value) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = '';
    var _iterator__ex2g4s = value.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.editor.cell.clipboard.<no name provided>.serializeNonNull.<anonymous>' call
      accumulator = accumulator + encloseInHtmlPre(this.lnj_1.o2q(element), this.knj_1, null);
    }
    var nodes = accumulator;
    var nodesAndText = nodes + encloseInAuxiliaryPre(this.mnj_1, this.knj_1);
    return encloseInDiv(nodesAndText, this.knj_1, this.nnj_1, true);
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1).o2q = function (value) {
    return this.onj((!(value == null) ? isInterface(value, KtList) : false) ? value : THROW_CCE());
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1).p2q = function (value) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var result = ArrayList_init_$Create$();
    var current = trimAuxiliaryPre(extractFromDiv(value, this.knj_1), this.knj_1);
    $l$loop: while (true) {
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = current;
      if (!(charSequenceLength(this_0) > 0)) {
        break $l$loop;
      }
      var _destruct__k2r9zo = extractFromHtmlPre(current, this.knj_1);
      var serializedNode = _destruct__k2r9zo.ug();
      var rest = _destruct__k2r9zo.vg();
      var node = this.lnj_1.p2q(serializedNode);
      result.e(node);
      current = rest;
    }
    return result;
  };
  function ProjectionalClipboardContentSerializationAsHtml() {
    Companion_getInstance_319();
    this.uni_1 = listOf_0([to('&', '&amp;'), to('<', '&lt;'), to('>', '&gt;'), to('"', '&quot;')]);
  }
  protoOf(ProjectionalClipboardContentSerializationAsHtml).cl7 = function (content) {
    var tmp;
    if (content instanceof ProjectionalClipboardContent) {
      var tmp_0 = content.sni_1;
      tmp = tmp_0 instanceof ReifiedContentKind;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml).dl7 = function (content) {
    if (!(content instanceof ProjectionalClipboardContent))
      THROW_CCE();
    var tmp = content.sni_1;
    if (!(tmp instanceof ReifiedContentKind))
      THROW_CCE();
    var textual = getText(content);
    var textData = new MimeTypedData('text/plain', textual);
    var tmp_0;
    if (content.tni_1.n() > 1) {
      var tmp_1 = doGetListPersister(this, content.sni_1.fl4_1, textual);
      var p = isInterface(tmp_1, Persister) ? tmp_1 : THROW_CCE();
      tmp_0 = ensureNotNull(p.x2p(content.tni_1));
    } else {
      var tmp_2 = doGetPersister(this, content.sni_1.fl4_1, textual);
      var p_0 = isInterface(tmp_2, Persister) ? tmp_2 : THROW_CCE();
      tmp_0 = ensureNotNull(p_0.x2p(content.tni_1.q(0)));
    }
    var structure = tmp_0;
    var structureData = new MimeTypedData('text/html', structure);
    return mimeDataSet(listOf_0([structureData, textData]));
  };
  protoOf(ProjectionalClipboardContentSerializationAsHtml).al7 = function (data) {
    var tmp0_elvis_lhs = data.y2('text/html');
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var htmlText = tmp;
    if (!Companion_getInstance_319().anj_1.vd(htmlText))
      return null;
    return new ProjectionalClipboardContentSerializationAsHtml$deserialize$1(htmlText, this, data);
  };
  function identity($this) {
    return ProjectionalClipboardHandler$identity$lambda;
  }
  function createCopyClipboardContent($this, items) {
    return createClipboardContent($this, items, false);
  }
  function OurClipboardContent() {
  }
  function createClipboardContent($this, items, isCut) {
    var clonerSupport = ensureNotNull($this.nna_1);
    var copiedItems = clonerSupport.rni(items, true);
    return new ProjectionalClipboardHandler$createClipboardContent$1($this, copiedItems, items, isCut);
  }
  function itemsToStringSupported($this) {
    return !($this.pna_1 == null) || !($this.ona_1 == null);
  }
  function itemsToString($this, items) {
    if (!($this.pna_1 == null)) {
      return ensureNotNull($this.pna_1)(items);
    }
    if (!($this.ona_1 == null)) {
      return ensureNotNull($this.ona_1)(items.q(0));
    }
    throw IllegalStateException_init_$Create$_0('itemsToStringSupported() and itemsToString() are inconsistent');
  }
  function itemsDefaultToString($this, items) {
    return joinToString_0(items, '\n', VOID, VOID, VOID, VOID, ProjectionalClipboardHandler$itemsDefaultToString$lambda($this));
  }
  function preserveOnPaste(_this__u8e3s4, $this) {
    var tmp;
    if (isInterface(_this__u8e3s4, OurClipboardContent)) {
      tmp = _this__u8e3s4.pnj();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function ProjectionalClipboardHandler$identity$lambda(item) {
    return item;
  }
  function ProjectionalClipboardHandler$createClipboardContent$1(this$0, $copiedItems, $items, $isCut) {
    this.unj_1 = $items;
    this.vnj_1 = $isCut;
    ProjectionalClipboardContent.call(this, ensureNotNull(this$0.mna_1), $copiedItems);
    this.snj_1 = 0;
    var tmp = this;
    var tmp_0;
    if (itemsToStringSupported(this$0)) {
      tmp_0 = itemsToString(this$0, $copiedItems);
    } else {
      tmp_0 = itemsDefaultToString(this$0, $items);
    }
    tmp.tnj_1 = tmp_0;
  }
  protoOf(ProjectionalClipboardHandler$createClipboardContent$1).pnj = function () {
    return this.vnj_1 && this.snj_1 === 0;
  };
  protoOf(ProjectionalClipboardHandler$createClipboardContent$1).gl0 = function (kind) {
    this.snj_1 = this.snj_1 + 1 | 0;
    var tmp;
    if (equals(kind, this.sni_1)) {
      var tmp_0 = this.unj_1.q(0);
      tmp = !(tmp_0 == null) ? tmp_0 : THROW_CCE();
    } else {
      var tmp_1 = this.unj_1;
      tmp = !(tmp_1 == null) ? tmp_1 : THROW_CCE();
    }
    return tmp;
  };
  protoOf(ProjectionalClipboardHandler$createClipboardContent$1).hl0 = function () {
    return this.tnj_1;
  };
  function ProjectionalClipboardHandler$itemsDefaultToString$lambda(this$0) {
    return function (it) {
      return this$0.lna_1(it);
    };
  }
  function ProjectionalClipboardHandler(isMultiItemPasteSupported, defaultItemToString) {
    this.kna_1 = isMultiItemPasteSupported;
    this.lna_1 = defaultItemToString;
    this.mna_1 = null;
    this.nna_1 = null;
    this.ona_1 = null;
    this.pna_1 = null;
    this.qna_1 = new ListMap();
    this.rna_1 = new ListMap();
  }
  protoOf(ProjectionalClipboardHandler).wnj = function (kind, clonerSupport) {
    var clipboardParameters = new ClipboardParameters(kind, clonerSupport);
    this.bni(clipboardParameters);
  };
  protoOf(ProjectionalClipboardHandler).xnj = function (kind, clonerSupport) {
    return this.wnj(kind, clonerSupport);
  };
  protoOf(ProjectionalClipboardHandler).bni = function (clipboardParameters) {
    var contentKind = clipboardParameters.oni_1;
    this.mna_1 = contentKind;
    this.nna_1 = clipboardParameters.pni_1;
    this.qna_1.r2(contentKind, identity(this));
  };
  protoOf(ProjectionalClipboardHandler).ynj = function (clipboardParameters) {
    return this.bni(clipboardParameters);
  };
  protoOf(ProjectionalClipboardHandler).znj = function (kind, fromContent) {
    // Inline function 'kotlin.require' call
    if (!!this.qna_1.w2(kind)) {
      // Inline function 'jetbrains.ocelot.projectional.editor.cell.clipboard.ProjectionalClipboardHandler.supportContentKind.<anonymous>' call
      var message = toString_1(kind) + ' already supported';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.qna_1.r2(kind, fromContent);
  };
  protoOf(ProjectionalClipboardHandler).ank = function (kind, fromContent) {
    return this.znj(kind, fromContent);
  };
  protoOf(ProjectionalClipboardHandler).ini = function (items) {
    return createClipboardContent(this, items, true);
  };
  protoOf(ProjectionalClipboardHandler).kni = function (content) {
    var _iterator__ex2g4s = this.qna_1.op().k();
    while (_iterator__ex2g4s.l()) {
      var kind = _iterator__ex2g4s.m();
      if (content.fl0(kind) || (this.kna_1 && content.fl0(ContentKinds_getInstance().jl4(kind)))) {
        return true;
      }
    }
    if (this.kna_1) {
      var _iterator__ex2g4s_0 = this.rna_1.op().k();
      while (_iterator__ex2g4s_0.l()) {
        var kind_0 = _iterator__ex2g4s_0.m();
        if (content.fl0(kind_0)) {
          return true;
        }
      }
    }
    return false;
  };
  protoOf(ProjectionalClipboardHandler).mni = function () {
    return !(this.mna_1 == null) || itemsToStringSupported(this);
  };
  protoOf(ProjectionalClipboardHandler).hni = function () {
    return !(this.mna_1 == null);
  };
  protoOf(ProjectionalClipboardHandler).nni = function (items) {
    var tmp;
    if (!(this.mna_1 == null)) {
      tmp = createCopyClipboardContent(this, items);
    } else if (itemsToStringSupported(this)) {
      tmp = TextContentHelper_getInstance().tl4(itemsToString(this, items));
    } else {
      throw IllegalStateException_init_$Create$_0('canCopyWholeItems() and copyWholeItems() are inconsistent');
    }
    return tmp;
  };
  protoOf(ProjectionalClipboardHandler).jni = function (clipboardContent) {
    var preserveMode = preserveOnPaste(clipboardContent, this);
    var clonerSupport = ensureNotNull(this.nna_1);
    var _iterator__ex2g4s = this.qna_1.qp().k();
    while (_iterator__ex2g4s.l()) {
      var entry = _iterator__ex2g4s.m();
      var contentKind = entry.ep();
      var tmp = entry.fp();
      var fromContent = typeof tmp === 'function' ? tmp : THROW_CCE();
      if (clipboardContent.fl0(contentKind)) {
        var item = fromContent(clipboardContent.gl0(contentKind));
        var copiedItem = clonerSupport.qni(item, preserveMode);
        return listOf(copiedItem);
      } else if (this.kna_1) {
        var listContentKind = ContentKinds_getInstance().jl4(contentKind);
        if (clipboardContent.fl0(listContentKind)) {
          var list = clipboardContent.gl0(listContentKind);
          var tmp_0 = fromContent(list);
          var convertedList = isInterface(tmp_0, KtList) ? tmp_0 : THROW_CCE();
          return clonerSupport.rni(convertedList, preserveMode);
        }
      }
    }
    if (this.kna_1) {
      var _iterator__ex2g4s_0 = this.rna_1.qp().k();
      while (_iterator__ex2g4s_0.l()) {
        var entry_0 = _iterator__ex2g4s_0.m();
        var contentKind_0 = entry_0.ep();
        if (clipboardContent.fl0(contentKind_0)) {
          var value = entry_0.fp();
          var fromContent_0 = typeof value === 'function' ? value : THROW_CCE();
          var items = fromContent_0(clipboardContent.gl0(contentKind_0));
          return clonerSupport.rni(items, preserveMode);
        }
      }
    }
    throw IllegalStateException_init_$Create$_0('canPaste() and paste() are inconsistent. Content: ' + toString_1(clipboardContent));
  };
  function RoleCompletion() {
  }
  function emptyRoleCompletion() {
    var tmp = emptyRoleCompletion$lambda;
    return new sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0(tmp);
  }
  function toRoleCompletion(_this__u8e3s4) {
    var tmp = toRoleCompletion$lambda(_this__u8e3s4);
    return new sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0(tmp);
  }
  function sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0(function_0) {
    this.bnk_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0).gnb = function (mapper, contextNode, target) {
    return this.bnk_1(mapper, contextNode, target);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0).b4 = function () {
    return this.bnk_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RoleCompletion) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0(function_0) {
    this.cnk_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0).gnb = function (mapper, contextNode, target) {
    return this.cnk_1(mapper, contextNode, target);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0).b4 = function () {
    return this.cnk_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RoleCompletion) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_0).hashCode = function () {
    return hashCode(this.b4());
  };
  function emptyRoleCompletion$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    return get_EMPTY_COMPLETION_SUPPLIER();
  }
  function toRoleCompletion$lambda($this_toRoleCompletion) {
    return function (_unused_var__etf5q3, contextNode, role) {
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0 = $this_toRoleCompletion;
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.editor.generic.roleCompletion.toRoleCompletion.<anonymous>.<anonymous>' call
        var list = element.dnk(contextNode, role);
        addAll_1(destination, list);
      }
      return toCompletionSupplier_0(destination);
    };
  }
  var JoinDirection_FORWARD_instance;
  var JoinDirection_BACKWARD_instance;
  var JoinDirection_entriesInitialized;
  function JoinDirection_initEntries() {
    if (JoinDirection_entriesInitialized)
      return Unit_instance;
    JoinDirection_entriesInitialized = true;
    JoinDirection_FORWARD_instance = new JoinDirection('FORWARD', 0);
    JoinDirection_BACKWARD_instance = new JoinDirection('BACKWARD', 1);
  }
  function NotSupported() {
  }
  protoOf(NotSupported).hnd = function (items, index, views) {
    return false;
  };
  protoOf(NotSupported).ind = function (items, index, views) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(NotSupported).jnd = function (items, leftIndex, direction) {
    return false;
  };
  protoOf(NotSupported).knd = function (items, leftIndex, direction) {
    throw UnsupportedOperationException_init_$Create$();
  };
  function JoinDirection(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function JoinDirection_FORWARD_getInstance() {
    JoinDirection_initEntries();
    return JoinDirection_FORWARD_instance;
  }
  function JoinDirection_BACKWARD_getInstance() {
    JoinDirection_initEntries();
    return JoinDirection_BACKWARD_instance;
  }
  function BaseSelectionCaptureTrait(getSelectionSupport) {
    CellTrait.call(this);
    this.enk_1 = getSelectionSupport;
  }
  protoOf(BaseSelectionCaptureTrait).llm = function (cell, event) {
    var selectionSupport = this.enk_1(cell);
    selectionSupport.tna_1.fnk(cell, event, selectionSupport);
    if (!event.ml0_1) {
      protoOf(CellTrait).llm.call(this, cell, event);
    }
  };
  protoOf(BaseSelectionCaptureTrait).qlm = function (cell, prop, event) {
    var tmp;
    if (prop === Companion_getInstance_271().ils_1) {
      var tmp_0 = event.p2e_1;
      tmp = (!(tmp_0 == null) ? typeof tmp_0 === 'boolean' : false) ? tmp_0 : THROW_CCE();
    } else {
      tmp = false;
    }
    if (tmp) {
      this.enk_1(cell).gnk();
    } else {
      protoOf(CellTrait).qlm.call(this, cell, prop, event);
    }
  };
  function BaseSelectionSpec$KeyDirection$FORWARD() {
    KeyDirection.call(this, 'FORWARD', 0);
    KeyDirection_FORWARD_instance = this;
  }
  protoOf(BaseSelectionSpec$KeyDirection$FORWARD).jnk = function () {
    return 1;
  };
  protoOf(BaseSelectionSpec$KeyDirection$FORWARD).knk = function (cell) {
    return Positions_instance.hms(ensureNotNull(cell));
  };
  protoOf(BaseSelectionSpec$KeyDirection$FORWARD).lnk = function (interval) {
    return ensureNotNull(interval).o2s_1;
  };
  protoOf(BaseSelectionSpec$KeyDirection$FORWARD).mnk = function (interval) {
    return interval.n2s_1;
  };
  protoOf(BaseSelectionSpec$KeyDirection$FORWARD).nnk = function (list) {
    return list.n() - 1 | 0;
  };
  var KeyDirection_FORWARD_instance;
  function BaseSelectionSpec$KeyDirection$BACKWARD() {
    KeyDirection.call(this, 'BACKWARD', 1);
    KeyDirection_BACKWARD_instance = this;
  }
  protoOf(BaseSelectionSpec$KeyDirection$BACKWARD).jnk = function () {
    return -1;
  };
  protoOf(BaseSelectionSpec$KeyDirection$BACKWARD).knk = function (cell) {
    return Positions_instance.gms(ensureNotNull(cell));
  };
  protoOf(BaseSelectionSpec$KeyDirection$BACKWARD).lnk = function (interval) {
    return ensureNotNull(interval).n2s_1;
  };
  protoOf(BaseSelectionSpec$KeyDirection$BACKWARD).mnk = function (interval) {
    return interval.o2s_1;
  };
  protoOf(BaseSelectionSpec$KeyDirection$BACKWARD).nnk = function (list) {
    return 0;
  };
  var KeyDirection_BACKWARD_instance;
  var KeyDirection_entriesInitialized;
  function KeyDirection_initEntries() {
    if (KeyDirection_entriesInitialized)
      return Unit_instance;
    KeyDirection_entriesInitialized = true;
    KeyDirection_FORWARD_instance = new BaseSelectionSpec$KeyDirection$FORWARD();
    KeyDirection_BACKWARD_instance = new BaseSelectionSpec$KeyDirection$BACKWARD();
  }
  function handleDragEvent($this, location) {
    if ($this.snk_1.unk(location)) {
      return false;
    }
    if ($this.snk_1.cnb().p() && $this.rnk_1 == null) {
      var tmp0_elvis_lhs = $this.snk_1.vnk();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return true;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var startCell = tmp;
      $this.rnk_1 = getStartPoint($this, startCell);
    }
    var handleResult = (new MouseSelectionHandler($this.snk_1)).xnk(ensureNotNull($this.rnk_1), location);
    if (handleResult.equals(MouseHandleResult_REDISPATCHED_TEXT_getInstance())) {
      ensureNotNull($this.rnk_1).ynk_1.jlp(Companion_instance_256.ol3(location), Companion_getInstance_287().tll_1);
    }
    return true;
  }
  function getStartPoint($this, cell) {
    if (cell == null) {
      return null;
    }
    var tmp;
    if ($this.snk_1.bnl(cell)) {
      tmp = new SimpleSelectionBound(cell, false, false);
    } else {
      tmp = Companion_instance_324.klp(cell);
    }
    return tmp;
  }
  function clearMouseStart($this) {
    $this.rnk_1 = null;
  }
  function changeKeyboardSelection($this, direction, support) {
    var currentCell = support.dnb();
    if (support.cnc() || currentCell == null)
      return false;
    var from = support.xna_1.t(currentCell);
    if (isEmptySideElemSelection($this, from, direction, support)) {
      var ctx = new KeyboardOperationContext(support.rnf(), Companion_instance_36.s2s(from), direction);
      select_0($this, ctx, support)();
      return true;
    }
    if (isVisuallyEmpty(support.xna_1.q(from))) {
      if (!isWithinBounds($this, from + direction.jnk() | 0, support.una_1)) {
        return false;
      }
      applyDelta($this, from, from + direction.jnk() | 0, direction, support);
      return true;
    }
    if (support.bnl(support.xna_1.q(from))) {
      var to = direction.knk(support.xna_1.q(from)) && isWithinBounds($this, from + direction.jnk() | 0, support.una_1) ? from + direction.jnk() | 0 : from;
      applyDelta($this, from, to, direction, support);
      return true;
    }
    if (direction.knk(support.xna_1.q(from)) || support.fnl(support.xna_1.q(from))) {
      if (!isWithinBounds($this, from + direction.jnk() | 0, support.una_1)) {
        return false;
      }
      applyDelta($this, from + direction.jnk() | 0, from + direction.jnk() | 0, direction, support);
      return true;
    }
    applyDelta($this, from, from, direction, support);
    return true;
  }
  function isWithinBounds($this, index, source) {
    return 0 <= index && index < source.n();
  }
  function isEmptySideElemSelection($this, index, direction, support) {
    return isVisuallyEmpty(support.xna_1.q(index)) && direction.nnk(support.una_1) === index && support.cnb().p() && support.una_1.n() > 1;
  }
  function select_0($this, ctx, support) {
    if (ensureNotNull(ctx.hnl_1).n2s_1 > ensureNotNull(ctx.gnl_1).o2s_1) {
      support.cnb().o(ctx.jnl(support.una_1));
      support.knl();
      return support.lnl(ctx.inl_1.lnk(ctx.hnl_1), ctx.inl_1 === KeyDirection_BACKWARD_getInstance());
    }
    var inductionVariable = ctx.hnl_1.o2s_1;
    var last = ctx.hnl_1.n2s_1;
    if (last <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        support.cnb().p2(0, support.una_1.q(i));
      }
       while (!(i === last));
    support.knl();
    return support.lnl(ctx.inl_1.lnk(ctx.hnl_1), ctx.inl_1 === KeyDirection_BACKWARD_getInstance());
  }
  function KeyDirection(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function direction($this, event) {
    var tmp;
    if (event.ol1([$this.nnl_1, KeyStrokeSpecs_getInstance().xl2_1])) {
      tmp = KeyDirection_FORWARD_getInstance();
    } else if (event.ol1([$this.mnl_1, KeyStrokeSpecs_getInstance().wl2_1])) {
      tmp = KeyDirection_BACKWARD_getInstance();
    } else {
      throw IllegalArgumentException_init_$Create$_0(event.toString());
    }
    return tmp;
  }
  function applyDelta($this, deltaStart, deltaEnd, direction, support) {
    var rawDelta = SelectionUtil_getInstance().pnl(deltaStart, deltaEnd);
    var selection = support.rnf();
    if (selection.d2t(rawDelta)) {
      var deselectCtx = new KeyboardOperationContext(selection, rawDelta.e2t(selection), direction);
      if (canDeselect($this, deselectCtx)) {
        deselect($this, deselectCtx, support)();
        return Unit_instance;
      }
    }
    var selectCtx = new KeyboardOperationContext(selection, SelectionUtil_getInstance().qnl(rawDelta, selection), direction);
    if (canSelect($this, selectCtx)) {
      select_0($this, selectCtx, support)();
      return Unit_instance;
    }
    if (selection.d2t(rawDelta)) {
      var retainCtx = new KeyboardOperationContext(selection, rawDelta.e2t(selection), direction);
      if (canRetain($this, retainCtx)) {
        retain($this, retainCtx, support)();
        return Unit_instance;
      }
    }
    throw IllegalStateException_init_$Create$_0('Inconsistent state: selection' + selection + ', rawDelta=' + rawDelta + ', direction=' + direction.toString());
  }
  function changeKeyboardSideSelection($this, direction, support) {
    if (support.cnc() || support.dnb() == null)
      return false;
    var selection = support.rnf();
    var newSelection = determineNewSideSelection($this, selection, direction, support);
    return applyNewSelection($this, selection, newSelection, direction, support);
  }
  function determineNewSideSelection($this, selection, direction, support) {
    var currentCell = ensureNotNull(support.dnb());
    var current = support.xna_1.t(currentCell);
    if (selection.p()) {
      if (support.bnl(currentCell) || !direction.knk(currentCell)) {
        return SelectionUtil_getInstance().pnl(current, direction.nnk(support.una_1));
      }
      var tmp;
      if (!isWithinBounds($this, current + direction.jnk() | 0, support.una_1)) {
        tmp = SelectionUtil_getInstance().onl_1;
      } else {
        tmp = SelectionUtil_getInstance().pnl(current + direction.jnk() | 0, direction.nnk(support.una_1));
      }
      return tmp;
    }
    if (isSameDirection($this, selection, current, direction, support)) {
      return SelectionUtil_getInstance().pnl(direction.mnk(selection), direction.nnk(support.una_1));
    }
    var tmp_0;
    if (!isWithinBounds($this, direction.lnk(selection) + direction.jnk() | 0, support.una_1)) {
      tmp_0 = SelectionUtil_getInstance().onl_1;
    } else {
      tmp_0 = SelectionUtil_getInstance().pnl(direction.lnk(selection) + direction.jnk() | 0, direction.nnk(support.una_1));
    }
    return tmp_0;
  }
  function isSameDirection($this, selection, current, direction, support) {
    if (selection.equals(Companion_instance_36.s2s(current))) {
      return direction.knk(support.xna_1.q(current));
    }
    var extension = SelectionUtil_getInstance().pnl(direction.lnk(selection), direction.nnk(support.una_1));
    return extension.a2t(current);
  }
  function applyNewSelection($this, selection, newSelection, direction, support) {
    if (newSelection.p()) {
      var deselectCtx = new KeyboardOperationContext(selection, selection, direction);
      if (canDeselect($this, deselectCtx)) {
        deselect($this, deselectCtx, support)();
        return true;
      }
      return false;
    }
    var removed = SelectionUtil_getInstance().qnl(selection, newSelection);
    var added = SelectionUtil_getInstance().qnl(newSelection, selection);
    var deselectCtx_0 = new KeyboardOperationContext(selection, removed, direction);
    if (canDeselect($this, deselectCtx_0)) {
      var selectCtx = new KeyboardOperationContext(SelectionUtil_getInstance().qnl(selection, ensureNotNull(removed)), added, direction);
      if (canSelect($this, selectCtx)) {
        deselect($this, deselectCtx_0, support);
        select_0($this, selectCtx, support)();
      } else {
        deselect($this, deselectCtx_0, support)();
      }
      return true;
    }
    var selectCtx_0 = new KeyboardOperationContext(selection, added, direction);
    if (canSelect($this, selectCtx_0)) {
      select_0($this, selectCtx_0, support)();
      return true;
    }
    return false;
  }
  function canDeselect($this, ctx) {
    if (ctx.rnl() || ensureNotNull(ctx.gnl_1).p()) {
      return false;
    }
    var result = SelectionUtil_getInstance().qnl(ctx.gnl_1, ensureNotNull(ctx.hnl_1));
    if (result == null || equals(result, ctx.gnl_1)) {
      return false;
    }
    if (result.p()) {
      return true;
    }
    var cursor = ctx.inl_1.lnk(ctx.hnl_1) + ctx.inl_1.jnk() | 0;
    return cursor === result.n2s_1 || cursor === result.o2s_1;
  }
  function deselect($this, ctx, support) {
    support.cnb().k1(ctx.jnl(support.una_1));
    support.knl();
    var tmp;
    if (support.cnb().p()) {
      tmp = support.lnl(ctx.inl_1.lnk(ctx.hnl_1), ctx.inl_1 === KeyDirection_BACKWARD_getInstance());
    } else {
      tmp = support.lnl(ctx.inl_1.lnk(ctx.hnl_1) + ctx.inl_1.jnk() | 0, ctx.inl_1 === KeyDirection_FORWARD_getInstance());
    }
    return tmp;
  }
  function canRetain($this, ctx) {
    return !ctx.rnl() && !ensureNotNull(ctx.gnl_1).p() && ctx.gnl_1.d2t(ensureNotNull(ctx.hnl_1));
  }
  function retain($this, ctx, support) {
    var tmp0 = support.cnb();
    // Inline function 'kotlin.collections.retainAll' call
    var elements = ctx.jnl(support.una_1);
    (isInterface(tmp0, MutableCollection) ? tmp0 : THROW_CCE()).l2(elements);
    support.knl();
    return support.lnl(ctx.inl_1.lnk(ctx.hnl_1), ctx.inl_1 === KeyDirection_BACKWARD_getInstance());
  }
  function canSelect($this, ctx) {
    if (ctx.rnl()) {
      return false;
    }
    var delta = ensureNotNull(ctx.hnl_1);
    var initial = ctx.gnl_1;
    var result = SelectionUtil_getInstance().snl(initial, delta);
    if (result == null || equals(result, initial)) {
      return false;
    }
    var cursor = ctx.inl_1.lnk(delta);
    return cursor === result.n2s_1 || cursor === result.o2s_1;
  }
  function KeyboardOperationContext(initial, delta, direction) {
    this.gnl_1 = initial;
    this.hnl_1 = delta;
    this.inl_1 = direction;
  }
  protoOf(KeyboardOperationContext).rnl = function () {
    return this.hnl_1 == null || this.hnl_1.p();
  };
  protoOf(KeyboardOperationContext).jnl = function (list) {
    return ensureNotNull(this.hnl_1).g2t(list);
  };
  function BaseSelectionSpec$createTargetTrait$1($support, this$0) {
    this.snk_1 = $support;
    this.tnk_1 = this$0;
    BaseDerivedCellTrait.call(this, new BaseSelectionTargetTrait($support));
    this.rnk_1 = null;
  }
  protoOf(BaseSelectionSpec$createTargetTrait$1).ilo = function (cell, event) {
    protoOf(BaseDerivedCellTrait).ilo.call(this, cell, event);
    if (!this.snk_1.bnb_1 && !this.snk_1.cnc()) {
      clearMouseStart(this);
    }
  };
  protoOf(BaseSelectionSpec$createTargetTrait$1).llm = function (cell, event) {
    this.tnk_1.fnk(cell, event, this.snk_1);
    if (event.ml0_1) {
      return Unit_instance;
    }
    protoOf(BaseDerivedCellTrait).llm.call(this, cell, event);
  };
  protoOf(BaseSelectionSpec$createTargetTrait$1).bll = function (cell, spec, event) {
    if (spec === Cells_getInstance().jmg_1) {
      clearMouseStart(this);
    }
    protoOf(BaseDerivedCellTrait).bll.call(this, cell, spec, event);
  };
  protoOf(BaseSelectionSpec$createTargetTrait$1).llo = function (cell, event) {
    if (event.tl3_1.equals(MouseButton_LEFT_getInstance())) {
      clearMouseStart(this);
    }
    protoOf(BaseDerivedCellTrait).llo.call(this, cell, event);
  };
  protoOf(BaseSelectionSpec$createTargetTrait$1).olo = function (cell, event) {
    if (event.tl3_1.equals(MouseButton_LEFT_getInstance()) && handleDragEvent(this, event.zl3())) {
      event.ol0();
      return Unit_instance;
    }
    protoOf(BaseDerivedCellTrait).olo.call(this, cell, event);
  };
  function BaseSelectionSpec$captureKeyPress$lambda(this$0, $event, $selectionSupport) {
    return function () {
      var tmp;
      if (changeKeyboardSelection(this$0, direction(this$0, $event), $selectionSupport)) {
        $event.ol0();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseSelectionSpec$captureKeyPress$lambda_0(this$0, $event, $selectionSupport) {
    return function () {
      var tmp;
      if (changeKeyboardSideSelection(this$0, direction(this$0, $event), $selectionSupport)) {
        $event.ol0();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SelectionSupport$clearSelection$ref($boundThis) {
    var l = function () {
      $boundThis.gnk();
      return Unit_instance;
    };
    l.callableName = 'clearSelection';
    return l;
  }
  function KeyDirection_FORWARD_getInstance() {
    KeyDirection_initEntries();
    return KeyDirection_FORWARD_instance;
  }
  function KeyDirection_BACKWARD_getInstance() {
    KeyDirection_initEntries();
    return KeyDirection_BACKWARD_instance;
  }
  function BaseSelectionSpec(selectBefore, selectAfter) {
    selectBefore = selectBefore === VOID ? KeyStrokeSpecs_getInstance().nl3([KeyStrokeSpecs_getInstance().al3_1, KeyStrokeSpecs_getInstance().cl3_1]) : selectBefore;
    selectAfter = selectAfter === VOID ? KeyStrokeSpecs_getInstance().nl3([KeyStrokeSpecs_getInstance().bl3_1, KeyStrokeSpecs_getInstance().dl3_1]) : selectAfter;
    this.mnl_1 = selectBefore;
    this.nnl_1 = selectAfter;
  }
  protoOf(BaseSelectionSpec).tnl = function (support) {
    return new BaseSelectionSpec$createTargetTrait$1(support, this);
  };
  protoOf(BaseSelectionSpec).fnk = function (cell, event, selectionSupport) {
    if (event.ol1([this.mnl_1, this.nnl_1])) {
      selectionSupport.vnl(BaseSelectionSpec$captureKeyPress$lambda(this, event, selectionSupport));
    } else {
      if (event.ol1([KeyStrokeSpecs_getInstance().wl2_1, KeyStrokeSpecs_getInstance().xl2_1])) {
        selectionSupport.vnl(BaseSelectionSpec$captureKeyPress$lambda_0(this, event, selectionSupport));
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!selectionSupport.cnb().p()) {
          var tmp = SelectionUtil_getInstance();
          tmp.unl(cell, event, selectionSupport, SelectionSupport$clearSelection$ref(selectionSupport));
        }
      }
    }
  };
  protoOf(BaseSelectionSpec).wnl = function (start, end, support) {
    var currentIndex = indexOf_5(support.xna_1, support.dnb());
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(start <= currentIndex ? currentIndex <= end : false)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  };
  function findNext_0($this, selectionSupports) {
    var iterator = selectionSupports.k();
    while (iterator.l()) {
      var currentSupport = iterator.m();
      if (equals(currentSupport, $this.xnl_1)) {
        if (iterator.l()) {
          return iterator.m();
        }
      }
    }
    return null;
  }
  function cancelSelection($this) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!$this.znl_1.cnb().p()) {
      tmp = !$this.znl_1.bnb_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.anm();
    }
  }
  function handleFocusGain($this, event) {
    var newValue = event.cmh_1;
    var expanded = !(newValue == null) ? expand_1($this, newValue) : null;
    if (expanded == null || !$this.znl_1.xna_1.s(expanded)) {
      expand_1($this, newValue);
      return Unit_instance;
    }
    if ($this.znl_1.bnb_1)
      return Unit_instance;
    if (!Cells_getInstance().kmx(newValue)) {
      var index = $this.znl_1.xna_1.t(expanded);
      var source = $this.znl_1.una_1;
      $this.znl_1.bnm(source.q(index), source.q(index));
    } else {
      cancelSelection($this);
    }
  }
  function expand_1($this, cell) {
    var current = cell;
    while (true) {
      var tmp0_elvis_lhs = ensureNotNull(current).yt();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return current;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var parent = tmp;
      if (isSingleChild($this, current)) {
        if (parent === $this.znl_1.vna_1)
          return current;
        current = parent;
      } else {
        return current;
      }
    }
  }
  function isSingleChild($this, cell) {
    var tmp0_elvis_lhs = cell.yt();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    var siblings = parent.g2r();
    return siblings.s(cell) && siblings.n() === 1;
  }
  function SelectionCellScope(support, focused) {
    CellScope.call(this);
    this.xnl_1 = support;
    this.ynl_1 = focused;
  }
  protoOf(SelectionCellScope).w4u = function () {
    var tmp;
    if (this.ynl_1.qlc() && this.xnl_1.vna_1.qlc()) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !this.xnl_1.una_1.p();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SelectionCellScope).tn0 = function () {
    return this.ynl_1 === getFocused(this.xnl_1) && this.xnl_1.cnm();
  };
  protoOf(SelectionCellScope).vn0 = function () {
    this.ynl_1.ul5();
    var source = this.xnl_1.una_1;
    this.xnl_1.bnm(first(source), last(source));
    CellScrolling_getInstance().kms(this.ynl_1);
  };
  protoOf(SelectionCellScope).xn0 = function () {
    var target = this.xnl_1.vna_1;
    if (this.xnl_1.cnm() && target.ulp(Companion_getInstance_322().fnm_1)) {
      var selectionSupports = SelectionSupports_instance.dnm(target);
      var next = findNext_0(this, selectionSupports);
      if (!(next == null)) {
        return new SelectionCellScope(next, ensureNotNull(next.xna_1.enm(this.ynl_1)));
      }
    }
    var defaultScope = CellScopes_getInstance().an1_1.ulm(target);
    return defaultScope == null ? CellScopes_getInstance().bn1(target.yt()) : defaultScope;
  };
  function BaseSelectionTargetTrait(support) {
    CellTrait.call(this);
    this.znl_1 = support;
  }
  protoOf(BaseSelectionTargetTrait).hlo = function (cell, event) {
    protoOf(CellTrait).hlo.call(this, cell, event);
    handleFocusGain(this, event);
  };
  protoOf(BaseSelectionTargetTrait).ilo = function (cell, event) {
    protoOf(CellTrait).ilo.call(this, cell, event);
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.znl_1.cnb().p()) {
      tmp = !this.znl_1.bnb_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      cancelSelection(this);
    }
  };
  protoOf(BaseSelectionTargetTrait).anm = function () {
    this.znl_1.gnk();
  };
  protoOf(BaseSelectionTargetTrait).bll = function (cell, spec, event) {
    if (spec === Cells_getInstance().jmg_1) {
      cancelSelection(this);
    } else {
      protoOf(CellTrait).bll.call(this, cell, spec, event);
    }
  };
  protoOf(BaseSelectionTargetTrait).llo = function (cell, event) {
    if (event.tl3_1.equals(MouseButton_LEFT_getInstance()) && !event.ul3_1.zl1_1) {
      cancelSelection(this);
    }
    protoOf(CellTrait).llo.call(this, cell, event);
  };
  protoOf(BaseSelectionTargetTrait).flo = function (cell, spec) {
    if (spec === Companion_getInstance_323().gnm_1) {
      return this.znl_1;
    }
    var tmp;
    if (spec === CellScopes_getInstance().an1_1 && canCreateFrom(this.znl_1)) {
      tmp = new SelectionCellScope(this.znl_1, ensureNotNull(getFocused(this.znl_1)));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function canCreateFrom(selectionSupport) {
    var tmp;
    if (!(getFocused(selectionSupport) == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !selectionSupport.una_1.p();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function getFocused(support) {
    return ensureNotNull(support.vna_1.llk()).rlp().qr();
  }
  function CellSelection() {
  }
  function Companion_320() {
  }
  var Companion_instance_320;
  function Companion_getInstance_320() {
    return Companion_instance_320;
  }
  function EditorSelectionBound(editor, position) {
    SelectionBound.call(this, editor, position === 0, position === editor.clu());
    this.knm_1 = position;
  }
  protoOf(EditorSelectionBound).lnm = function () {
    var reverted;
    if (this.ynk_1.qlp().qr() && this.ynk_1.zlt().qr() === this.knm_1) {
      reverted = false;
    } else {
      reverted = true;
      toPosition(this.ynk_1, this.knm_1)();
    }
    return reverted;
  };
  protoOf(EditorSelectionBound).hashCode = function () {
    return imul(hashCode(this.ynk_1), 37) + this.knm_1 | 0;
  };
  protoOf(EditorSelectionBound).equals = function (other) {
    if (other instanceof EditorSelectionBound) {
      var that = other instanceof EditorSelectionBound ? other : THROW_CCE();
      return equals(this.ynk_1, ensureNotNull(that).ynk_1) && this.knm_1 === that.knm_1;
    }
    return false;
  };
  var MouseHandleResult_HANDLED_instance;
  var MouseHandleResult_REDISPATCHED_TEXT_instance;
  var MouseHandleResult_SKIPPED_instance;
  var MouseHandleResult_entriesInitialized;
  function MouseHandleResult_initEntries() {
    if (MouseHandleResult_entriesInitialized)
      return Unit_instance;
    MouseHandleResult_entriesInitialized = true;
    MouseHandleResult_HANDLED_instance = new MouseHandleResult('HANDLED', 0);
    MouseHandleResult_REDISPATCHED_TEXT_instance = new MouseHandleResult('REDISPATCHED_TEXT', 1);
    MouseHandleResult_SKIPPED_instance = new MouseHandleResult('SKIPPED', 2);
  }
  function MouseHandleResult(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function MouseHandleResult_HANDLED_getInstance() {
    MouseHandleResult_initEntries();
    return MouseHandleResult_HANDLED_instance;
  }
  function MouseHandleResult_REDISPATCHED_TEXT_getInstance() {
    MouseHandleResult_initEntries();
    return MouseHandleResult_REDISPATCHED_TEXT_instance;
  }
  function MouseHandleResult_SKIPPED_getInstance() {
    MouseHandleResult_initEntries();
    return MouseHandleResult_SKIPPED_instance;
  }
  var MouseChangeKind_NONE_instance;
  var MouseChangeKind_SELECT_instance;
  var MouseChangeKind_DESELECT_instance;
  var MouseChangeKind_entriesInitialized;
  function MouseChangeKind_initEntries() {
    if (MouseChangeKind_entriesInitialized)
      return Unit_instance;
    MouseChangeKind_entriesInitialized = true;
    MouseChangeKind_NONE_instance = new MouseChangeKind('NONE', 0);
    MouseChangeKind_SELECT_instance = new MouseChangeKind('SELECT', 1);
    MouseChangeKind_DESELECT_instance = new MouseChangeKind('DESELECT', 2);
  }
  function _get_selectionRange__oxzehm($this) {
    return $this.wnk_1.rnf();
  }
  function trySetPosition($this, cell, location) {
    var tmp = Cells_getInstance();
    var tmp0_elvis_lhs = tmp.lmx(cell, location, MouseSelectionHandler$trySetPosition$lambda);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var closestCell = tmp_0;
    var editor = closestCell instanceof TextCell ? closestCell : THROW_CCE();
    var caret = editor.slu(location.eku_1 - get_origin_0(editor).eku_1 | 0);
    if (caret === 0) {
      toHome(editor)();
      return true;
    }
    if (caret === editor.clu()) {
      toEnd_0(editor)();
      return true;
    }
    toPosition(editor, caret)();
    return true;
  }
  function isMultiline($this, cell) {
    var firstVisibleLeaf_0 = ensureNotNull(firstVisibleLeaf(cell));
    var lastVisibleLeaf_0 = ensureNotNull(lastVisibleLeaf(cell));
    return isAbove(firstVisibleLeaf_0, lastVisibleLeaf_0);
  }
  function checkOrdered($this, a, b, condition) {
    return isDescendant(a, b) || isDescendant(b, a) ? false : Composites_instance.z2r(a, b) ? condition(a, b) : condition(b, a);
  }
  function getChild_0($this, location) {
    var bestChild = -1;
    var bestDistance = 1.7976931348623157E308;
    var inductionVariable = 0;
    var last = $this.wnk_1.xna_1.n();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var child = $this.wnk_1.xna_1.q(i);
        if (!(Cells_getInstance().mlq(child, location) == null)) {
          return i;
        }
        var tmp = Cells_getInstance();
        var leaf = tmp.lmx(child, location, Cells$isLeaf$ref(Cells_getInstance()));
        if (!(leaf == null)) {
          var distance = get_bounds(leaf).tku(location);
          if (distance < bestDistance) {
            bestChild = i;
            bestDistance = distance;
          }
        }
      }
       while (inductionVariable < last);
    return bestChild;
  }
  function toBound($this, childIndex, location) {
    var child = $this.wnk_1.xna_1.q(childIndex);
    if (child.ulp(TextEditing_getInstance().zlw_1) || child.ulp(TextEditing_getInstance().ylw_1)) {
      var editor = child instanceof TextCell ? child : THROW_CCE();
      var position = editor.slu(location.eku_1);
      return new EditorSelectionBound(editor, position);
    }
    return new SimpleSelectionBound(child, false, false);
  }
  function changeMouseSelection($this, startIndex, endIndex, endLocation) {
    if (startIndex === -1 || endIndex === -1) {
      return Unit_instance;
    }
    if (startIndex === endIndex && selectedItems($this).p() && !isDraggedEnough($this, startIndex, endLocation)) {
      return Unit_instance;
    }
    var oldRange = _get_selectionRange__oxzehm($this);
    var newRange = SelectionUtil_getInstance().pnl(startIndex, endIndex);
    if (selectedItems($this).p()) {
      selectedItems($this).o(newRange.g2t($this.wnk_1.una_1));
    } else if (!newRange.equals(oldRange)) {
      changeSelectedRange($this, oldRange, newRange);
    }
    clearOtherSelections($this);
    var endCell = $this.wnk_1.xna_1.q(endIndex);
    if (trySetPosition($this, endCell, endLocation)) {
      return Unit_instance;
    }
    var endCellCenter = get_bounds(endCell).wku();
    $this.wnk_1.lnl(endIndex, endLocation.eku_1 < endCellCenter.eku_1)();
  }
  function changeSelection($this, r) {
    $this.wnk_1.vnl(r);
  }
  function selectedItems($this) {
    return $this.wnk_1.cnb();
  }
  function clearOtherSelections($this) {
    $this.wnk_1.knl();
  }
  function isDraggedEnough($this, child, endLocation) {
    var tmp;
    if (isMultiline($this, $this.wnk_1.xna_1.q(child))) {
      tmp = isDraggedWide($this, endLocation) || isDraggedTall($this, endLocation);
    } else {
      tmp = isDraggedToFocusable($this, endLocation);
    }
    return tmp;
  }
  function changeSelectedRange($this, oldRange, newRange) {
    if (!oldRange.d2t(newRange)) {
      doReplaceSelection($this, newRange);
    } else {
      var leftChange = determineLeftChange($this, oldRange, newRange);
      var rightChange = determineRightChange($this, oldRange, newRange);
      doChangeLeft($this, leftChange);
      doChangeRight($this, rightChange);
    }
  }
  function doReplaceSelection($this, newRange) {
    selectedItems($this).m2();
    selectedItems($this).o(newRange.g2t($this.wnk_1.una_1));
  }
  function determineLeftChange($this, oldRange, newRange) {
    var common = oldRange.e2t(newRange);
    var tmp;
    if (oldRange.n2s_1 < common.n2s_1) {
      tmp = new MouseChange(MouseChangeKind_DESELECT_getInstance(), new Interval(oldRange.n2s_1, common.n2s_1 - 1 | 0));
    } else if (newRange.n2s_1 < common.n2s_1) {
      tmp = new MouseChange(MouseChangeKind_SELECT_getInstance(), new Interval(newRange.n2s_1, common.n2s_1 - 1 | 0));
    } else {
      tmp = new MouseChange(MouseChangeKind_NONE_getInstance(), null);
    }
    return tmp;
  }
  function determineRightChange($this, oldRange, newRange) {
    var common = oldRange.e2t(newRange);
    var tmp;
    if (oldRange.o2s_1 > common.o2s_1) {
      tmp = new MouseChange(MouseChangeKind_DESELECT_getInstance(), new Interval(common.o2s_1 + 1 | 0, oldRange.o2s_1));
    } else if (newRange.o2s_1 > common.o2s_1) {
      tmp = new MouseChange(MouseChangeKind_SELECT_getInstance(), new Interval(common.o2s_1 + 1 | 0, newRange.o2s_1));
    } else {
      tmp = new MouseChange(MouseChangeKind_NONE_getInstance(), null);
    }
    return tmp;
  }
  function doChangeLeft($this, change) {
    switch (change.mnm_1.a3_1) {
      case 0:
        break;
      case 1:
        var _iterator__ex2g4s = ensureNotNull(change.nnm_1).z2s().k();
        while (_iterator__ex2g4s.l()) {
          var i = _iterator__ex2g4s.m();
          selectedItems($this).p2(0, $this.wnk_1.una_1.q(i));
        }

        break;
      case 2:
        var _iterator__ex2g4s_0 = ensureNotNull(change.nnm_1).y2s().k();
        while (_iterator__ex2g4s_0.l()) {
          var i_0 = _iterator__ex2g4s_0.m();
          var deselected = selectedItems($this).q2(0);
          // Inline function 'kotlin.check' call
          if (!(deselected === $this.wnk_1.una_1.q(i_0))) {
            // Inline function 'jetbrains.ocelot.projectional.selection.MouseSelectionHandler.doChangeLeft.<anonymous>' call
            var message = 'i = ' + i_0 + ', deselected=' + deselected + ', mustHaveBeen=' + toString_0($this.wnk_1.una_1.q(i_0));
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  function doChangeRight($this, change) {
    switch (change.mnm_1.a3_1) {
      case 0:
        break;
      case 1:
        var _iterator__ex2g4s = ensureNotNull(change.nnm_1).y2s().k();
        while (_iterator__ex2g4s.l()) {
          var i = _iterator__ex2g4s.m();
          selectedItems($this).e($this.wnk_1.una_1.q(i));
        }

        break;
      case 2:
        var _iterator__ex2g4s_0 = ensureNotNull(change.nnm_1).z2s().k();
        while (_iterator__ex2g4s_0.l()) {
          var i_0 = _iterator__ex2g4s_0.m();
          var deselected = selectedItems($this).q2(selectedItems($this).n() - 1 | 0);
          // Inline function 'kotlin.check' call
          if (!(deselected === $this.wnk_1.una_1.q(i_0))) {
            // Inline function 'jetbrains.ocelot.projectional.selection.MouseSelectionHandler.doChangeRight.<anonymous>' call
            var message = 'i = ' + i_0 + ', deselected=' + deselected + ', mustHaveBeen=' + toString_0($this.wnk_1.una_1.q(i_0));
            throw IllegalStateException_init_$Create$_0(toString_1(message));
          }
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  function isDraggedWide($this, dragEnd) {
    var focused = ensureNotNull($this.wnk_1.vna_1.llk()).rlp().qr();
    var end = Cells_getInstance().mlq($this.wnk_1.vna_1, dragEnd);
    var tmp;
    if (!(end == null)) {
      var tmp_0 = ensureNotNull(focused);
      tmp = checkOrdered($this, tmp_0, end, MouseSelectionHandler$isDraggedWide$lambda);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isDraggedTall($this, dragEnd) {
    var focused = ensureNotNull($this.wnk_1.vna_1.llk()).rlp().qr();
    var tmp = Cells_getInstance();
    var closest = tmp.lmx($this.wnk_1.vna_1, dragEnd, MouseSelectionHandler$isDraggedTall$lambda);
    var tmp_0;
    if (!(closest == null)) {
      var tmp_1 = ensureNotNull(focused);
      tmp_0 = checkOrdered($this, tmp_1, closest, MouseSelectionHandler$isDraggedTall$lambda_0);
    } else {
      tmp_0 = false;
    }
    return tmp_0;
  }
  function isDraggedToFocusable($this, endLocation) {
    var focused = ensureNotNull($this.wnk_1.vna_1.llk()).rlp().qr();
    var underMouse = Cells_getInstance().mlq($this.wnk_1.vna_1, endLocation);
    return !(underMouse == null) && !(underMouse === focused) && underMouse.hlp().qr();
  }
  function MouseChange(kind, range) {
    this.mnm_1 = kind;
    this.nnm_1 = range;
  }
  function MouseChangeKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function MouseSelectionHandler$trySetPosition$lambda(c) {
    var tmp;
    var tmp_0;
    if (c instanceof TextCell) {
      tmp_0 = c.hlp().qr();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = c.ulp(TextEditing_getInstance().ylw_1) || c.ulp(TextEditing_getInstance().zlw_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function MouseSelectionHandler$handleMouseEvent$lambda(this$0, $startIndex, $endIndex, $location) {
    return function () {
      changeMouseSelection(this$0, $startIndex + 1 | 0, $endIndex, $location);
      return Unit_instance;
    };
  }
  function MouseSelectionHandler$handleMouseEvent$lambda_0(this$0, $startIndex, $endIndex, $location) {
    return function () {
      changeMouseSelection(this$0, $startIndex - 1 | 0, $endIndex, $location);
      return Unit_instance;
    };
  }
  function MouseSelectionHandler$handleMouseEvent$lambda_1(this$0, $startIndex, $endIndex, $location) {
    return function () {
      changeMouseSelection(this$0, $startIndex, $endIndex, $location);
      return Unit_instance;
    };
  }
  function Cells$isLeaf$ref($boundThis) {
    var l = function (p0) {
      return $boundThis.kmx(p0);
    };
    l.callableName = 'isLeaf';
    return l;
  }
  function MouseSelectionHandler$isDraggedWide$lambda(a, b) {
    var afterA = ensureNotNull(Composites_instance.m2r(a));
    if (isDescendant(b, afterA)) {
      return false;
    }
    return Composites_instance.z2r(afterA, b);
  }
  function MouseSelectionHandler$isDraggedTall$lambda(cell) {
    return isVisible_1(cell);
  }
  function MouseSelectionHandler$isDraggedTall$lambda_0(upper, lower) {
    return isAbove(upper, lower);
  }
  function MouseChangeKind_NONE_getInstance() {
    MouseChangeKind_initEntries();
    return MouseChangeKind_NONE_instance;
  }
  function MouseChangeKind_SELECT_getInstance() {
    MouseChangeKind_initEntries();
    return MouseChangeKind_SELECT_instance;
  }
  function MouseChangeKind_DESELECT_getInstance() {
    MouseChangeKind_initEntries();
    return MouseChangeKind_DESELECT_instance;
  }
  function MouseSelectionHandler(support) {
    this.wnk_1 = support;
  }
  protoOf(MouseSelectionHandler).xnk = function (startBound, location) {
    var startIndex = this.wnk_1.xna_1.t(startBound.ynk_1);
    // Inline function 'kotlin.require' call
    if (!!(startIndex === -1)) {
      // Inline function 'jetbrains.ocelot.projectional.selection.MouseSelectionHandler.handleMouseEvent.<anonymous>' call
      var message = toString_1(startBound.ynk_1) + ' is not in target list';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var endIndex = getChild_0(this, location);
    if (endIndex === -1) {
      return MouseHandleResult_SKIPPED_getInstance();
    }
    var endBound = toBound(this, endIndex, location);
    var tmp;
    var tmp_0;
    if (startBound instanceof EditorSelectionBound) {
      tmp_0 = endBound instanceof EditorSelectionBound;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = startBound.ynk_1 === endBound.ynk_1;
    } else {
      tmp = false;
    }
    if (tmp) {
      return startBound.lnm() ? MouseHandleResult_REDISPATCHED_TEXT_getInstance() : MouseHandleResult_HANDLED_getInstance();
    }
    if (startIndex < endIndex && startBound.anl_1) {
      changeSelection(this, MouseSelectionHandler$handleMouseEvent$lambda(this, startIndex, endIndex, location));
      return MouseHandleResult_HANDLED_getInstance();
    }
    if (startIndex > endIndex && startBound.znk_1) {
      changeSelection(this, MouseSelectionHandler$handleMouseEvent$lambda_0(this, startIndex, endIndex, location));
      return MouseHandleResult_HANDLED_getInstance();
    }
    changeSelection(this, MouseSelectionHandler$handleMouseEvent$lambda_1(this, startIndex, endIndex, location));
    return MouseHandleResult_HANDLED_getInstance();
  };
  function ProjectionalSelection() {
    ProjectionalSelection_instance = this;
    this.ynh_1 = new BaseSelectionSpec();
  }
  var ProjectionalSelection_instance;
  function ProjectionalSelection_getInstance() {
    if (ProjectionalSelection_instance == null)
      new ProjectionalSelection();
    return ProjectionalSelection_instance;
  }
  function RoleSynchronizerSelectionSupport$1(this$0, $selectedItems) {
    this.onm_1 = this$0;
    this.pnm_1 = $selectedItems;
    CollectionAdapter.call(this);
  }
  protoOf(RoleSynchronizerSelectionSupport$1).c27 = function (event) {
    get_selected(this.onm_1.tnb_1.q(indexOf_12(this.onm_1.rnb_1, event.k27()))).t2c(true);
    if (this.pnm_1.n() === 1) {
      this.onm_1.ynb_1 = this.onm_1.unb_1(this.onm_1.wnb_1);
      this.onm_1.znb_1 = CellTraits_instance.jmw(this.onm_1.snb_1, this.onm_1.vnb_1(this.onm_1.wnb_1));
    }
  };
  protoOf(RoleSynchronizerSelectionSupport$1).j27 = function (event) {
    if (this.pnm_1.p()) {
      this.onm_1.ynb_1.vr();
      this.onm_1.ynb_1 = Companion_getInstance_25().wr_1;
      this.onm_1.znb_1.vr();
      this.onm_1.znb_1 = Companion_getInstance_25().wr_1;
    }
    var itemIndex = indexOf_12(this.onm_1.rnb_1, event.i27());
    if (itemIndex >= 0) {
      get_selected(this.onm_1.tnb_1.q(itemIndex)).t2c(false);
    }
  };
  function RoleSynchronizerSelectionSupport(roleSynchronizer, selectionSpec, source, target, targetList, handleSourceUpdate, selectionCaptureTrait) {
    this.rnb_1 = roleSynchronizer;
    this.snb_1 = target;
    this.tnb_1 = targetList;
    this.unb_1 = handleSourceUpdate;
    this.vnb_1 = selectionCaptureTrait;
    this.wnb_1 = SelectionSupports_instance.qnm(selectionSpec, source, this.snb_1, this.tnb_1);
    this.ynb_1 = Companion_getInstance_25().wr_1;
    this.znb_1 = Companion_getInstance_25().wr_1;
    var selectedItems = this.wnb_1.cnb();
    var tmp = this;
    var tmp_0 = this.wnb_1.rnm();
    tmp.xnb_1 = tmp_0.n27(new RoleSynchronizerSelectionSupport$1(this, selectedItems));
  }
  protoOf(RoleSynchronizerSelectionSupport).lni = function () {
    var tmp0_safe_receiver = this.wnb_1.dnb();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.selection.RoleSynchronizerSelectionSupport.<get-currentItem>.<anonymous>' call
      var index = this.tnb_1.t(tmp0_safe_receiver);
      tmp = this.rnb_1.ila().q(index).pl9_1;
    }
    return tmp;
  };
  protoOf(RoleSynchronizerSelectionSupport).vr = function () {
    this.ynb_1.vr();
    this.znb_1.vr();
    this.xnb_1.vr();
  };
  function SelectionBound(cell, isVisuallyHome, isVisuallyEnd) {
    this.ynk_1 = cell;
    this.znk_1 = isVisuallyHome;
    this.anl_1 = isVisuallyEnd;
  }
  function updateCellSelection($this, selection) {
    if ($this.snm_1 == null) {
      $this.snm_1 = new SelectionId();
      $this.unm_1.a28(SelectionController$updateCellSelection$lambda($this, selection));
    } else {
      $this.unm_1.a28(SelectionController$updateCellSelection$lambda_0($this, selection));
    }
  }
  function Companion_321() {
    Companion_instance_321 = this;
    this.vnm_1 = CellTraits_instance.ym2('SelectionController');
  }
  var Companion_instance_321;
  function Companion_getInstance_321() {
    if (Companion_instance_321 == null)
      new Companion_321();
    return Companion_instance_321;
  }
  function SelectionController$updateCellSelection$lambda(this$0, $selection) {
    return function (l) {
      l.wnm(ensureNotNull(this$0.snm_1), $selection);
      return Unit_instance;
    };
  }
  function SelectionController$updateCellSelection$lambda_0(this$0, $selection) {
    return function (l) {
      l.xnm(ensureNotNull(this$0.snm_1), $selection);
      return Unit_instance;
    };
  }
  function SelectionController$closeCellSelection$lambda(this$0) {
    return function (l) {
      l.ynm(ensureNotNull(this$0.snm_1));
      return Unit_instance;
    };
  }
  function SelectionId() {
    BaseId.call(this);
  }
  function Companion_322() {
    Companion_instance_322 = this;
    this.fnm_1 = CellTraitPropertySpec_init_$Create$('select_all_ancestors_while_increasing_selection', false);
  }
  var Companion_instance_322;
  function Companion_getInstance_322() {
    if (Companion_instance_322 == null)
      new Companion_322();
    return Companion_instance_322;
  }
  function hasTextSelection($this, cell) {
    var tmp;
    if (cell instanceof TextCell) {
      tmp = cell.nlu().qr();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function clearTextSelection($this, cell) {
    var textCell = cell instanceof TextCell ? cell : THROW_CCE();
    textCell.nlu().t2c(false);
  }
  function hasLowerSelection($this, cell) {
    var selection = cell.ulp(Companion_getInstance_323().gnm_1);
    var tmp;
    if (!(selection == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !selection.cnb().p();
    } else {
      tmp = false;
    }
    if (tmp) {
      return true;
    }
    var _iterator__ex2g4s = cell.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      if ($this.bnl(child)) {
        return true;
      }
    }
    return false;
  }
  function TargetList(list) {
    AbstractList.call(this);
    this.enl_1 = list;
  }
  protoOf(TargetList).n = function () {
    return this.enl_1.n();
  };
  protoOf(TargetList).enm = function (cell) {
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestorsFrom(cell);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.selection.TargetList.findAncestorOf.<anonymous>' call
        if (this.enl_1.s(element)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  protoOf(TargetList).q = function (index) {
    return this.enl_1.q(index);
  };
  function Companion_323() {
    Companion_instance_323 = this;
    this.gnm_1 = CellTraitPropertySpec_init_$Create$('selectionSupport', null);
  }
  var Companion_instance_323;
  function Companion_getInstance_323() {
    if (Companion_instance_323 == null)
      new Companion_323();
    return Companion_instance_323;
  }
  function SelectionSupport$lambda(this$0) {
    return function (it) {
      var tmp;
      if (!(this$0.anb_1 == null) && !this$0.cnc()) {
        var tmp_0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this$0.cnb().p()) {
          var startIndex = this$0.una_1.t(first(this$0.cnb()));
          var endIndex = this$0.una_1.t(last(this$0.cnb()));
          var size = this$0.xna_1.n();
          var tmp_1;
          if (startIndex >= 0 && endIndex >= 0 && startIndex < size && endIndex < size) {
            ensureNotNull(this$0.anb_1).ann(this$0.xna_1.q(startIndex), this$0.xna_1.q(endIndex));
            tmp_1 = Unit_instance;
          } else {
            var tmp_2;
            if (!this$0.bnb_1) {
              // Inline function 'jetbrains.ocelot.projectional.selection.SelectionSupport.<anonymous>.<anonymous>' call
              var message = 'Intermediate state outside changing selection encountered. Selected items: ' + toString_1(this$0.cnb());
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }
            tmp_1 = tmp_2;
          }
          tmp_0 = tmp_1;
        } else {
          ensureNotNull(this$0.anb_1).znm();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function SelectionSupport$select$lambda(this$0, $start, $end) {
    return function () {
      this$0.cnb().m2();
      var inductionVariable = $start;
      var tmp;
      if (inductionVariable <= $end) {
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this$0.cnb().e(this$0.una_1.q(i));
        }
         while (!(i === $end));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function MutableList$clear$ref($boundThis) {
    var l = function () {
      $boundThis.m2();
      return Unit_instance;
    };
    l.callableName = 'clear';
    return l;
  }
  function SelectionSupport(spec, source, target, targetList, focusAndScrollTo) {
    Companion_getInstance_323();
    this.tna_1 = spec;
    this.una_1 = source;
    this.vna_1 = target;
    this.wna_1 = focusAndScrollTo;
    this.yna_1 = new ObservableArrayList();
    this.anb_1 = null;
    this.bnb_1 = false;
    this.xna_1 = new TargetList(targetList);
    var preInstalled = this.vna_1.ulp(Companion_getInstance_321().vnm_1);
    if (!(preInstalled == null)) {
      this.bnn(preInstalled);
    }
    this.zna_1 = this.vna_1.olp(this.tna_1.tnl(this));
    var tmp = this.rnm();
    tmp.p27(SelectionSupport$lambda(this));
  }
  protoOf(SelectionSupport).dnb = function () {
    if (this.una_1.p())
      return null;
    var focusedCell = ensureNotNull(this.vna_1.llk()).rlp().qr();
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = ancestorsFrom(focusedCell);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.selection.SelectionSupport.<get-currentCell>.<anonymous>' call
        if (element.yt() === this.vna_1) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  protoOf(SelectionSupport).rnf = function () {
    if (this.cnb().p()) {
      return SelectionUtil_getInstance().onl_1;
    }
    var leftIndex = this.una_1.t(this.cnb().q(0));
    var rightIndex = this.una_1.u(last(this.cnb()));
    return new Interval(leftIndex, rightIndex);
  };
  protoOf(SelectionSupport).vnk = function () {
    return this.cnn(ensureNotNull(this.vna_1.llk()).rlp().qr());
  };
  protoOf(SelectionSupport).cnm = function () {
    return this.cnb().n() === this.una_1.n();
  };
  protoOf(SelectionSupport).cnb = function () {
    return this.yna_1;
  };
  protoOf(SelectionSupport).rnm = function () {
    return this.yna_1;
  };
  protoOf(SelectionSupport).snf = function (items) {
    this.yna_1.m2();
    this.yna_1.o(items);
  };
  protoOf(SelectionSupport).fnl = function (cell) {
    return cell.qlp().qr() && !Cells_getInstance().kmx(cell);
  };
  protoOf(SelectionSupport).cnc = function () {
    var tmp0 = ancestorsFrom(this.vna_1);
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.selection.SelectionSupport.hasHigherPrioritySelection.<anonymous>' call
        var tmp0_safe_receiver = element.yt();
        var support = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ulp(Companion_getInstance_323().gnm_1);
        var tmp;
        if (!(support == null)) {
          // Inline function 'kotlin.collections.isNotEmpty' call
          tmp = !support.cnb().p();
        } else {
          tmp = false;
        }
        if (tmp) {
          tmp$ret$2 = true;
          break $l$block;
        }
      }
      tmp$ret$2 = false;
    }
    return tmp$ret$2;
  };
  protoOf(SelectionSupport).bnm = function (from, to) {
    // Inline function 'kotlin.check' call
    if (!!this.bnb_1) {
      // Inline function 'jetbrains.ocelot.projectional.selection.SelectionSupport.select.<anonymous>' call
      var message = 'Selection is being changed';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var start = this.una_1.t(from);
    var end = this.una_1.t(to);
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(!(start === -1) && !(end === -1))) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message_0 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(start <= end)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message_1 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message_1));
    }
    // Inline function 'kotlin.check' call
    if (!isDescendantCellFocused(this.vna_1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.tna_1.wnl(start, end, this);
    this.vnl(SelectionSupport$select$lambda(this, start, end));
  };
  protoOf(SelectionSupport).gnk = function () {
    this.vnl(MutableList$clear$ref(this.cnb()));
  };
  protoOf(SelectionSupport).vnl = function (r) {
    this.bnb_1 = true;
    try {
      r();
    }finally {
      this.bnb_1 = false;
    }
  };
  protoOf(SelectionSupport).bnn = function (selectionController) {
    this.anb_1 = selectionController;
  };
  protoOf(SelectionSupport).bnl = function (cell) {
    return hasTextSelection(this, cell) || hasLowerSelection(this, cell);
  };
  protoOf(SelectionSupport).knl = function () {
    var cell = ensureNotNull(this.vna_1.llk()).rlp().qr();
    if (hasTextSelection(this, cell)) {
      clearTextSelection(this, ensureNotNull(cell));
    }
    if (cell == null)
      null;
    else {
      // Inline function 'jetbrains.ocelot.base.composite.dispatchByParent' call
      var current = cell;
      while (!(current == null)) {
        // Inline function 'jetbrains.ocelot.projectional.selection.SelectionSupport.clearOtherSelections.<anonymous>' call
        var tmp0_safe_receiver = current.ulp(Companion_getInstance_323().gnm_1);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'jetbrains.ocelot.projectional.selection.SelectionSupport.clearOtherSelections.<anonymous>.<anonymous>' call
          if (!tmp0_safe_receiver.bnb_1) {
            tmp0_safe_receiver.gnk();
          }
        }
        current = current.yt();
      }
    }
  };
  protoOf(SelectionSupport).lnl = function (index, first) {
    return this.wna_1(new Pair(index, first));
  };
  protoOf(SelectionSupport).cnn = function (cell) {
    return this.xna_1.enm(cell);
  };
  protoOf(SelectionSupport).vr = function () {
    this.zna_1.vr();
  };
  protoOf(SelectionSupport).unk = function (location) {
    return this.una_1.p() || !get_bounds(this.vna_1).mku(location);
  };
  function getNext($this) {
    while ($this.enn_1.l()) {
      var cell = $this.enn_1.m();
      var support = cell.ulp(Companion_getInstance_323().gnm_1);
      if (!(support == null)) {
        return support;
      }
    }
    return null;
  }
  function SelectionSupports$selectionSupports$1$iterator$1($cellsIterator) {
    this.enn_1 = $cellsIterator;
    this.dnn_1 = getNext(this);
  }
  protoOf(SelectionSupports$selectionSupports$1$iterator$1).l = function () {
    return !(this.dnn_1 == null);
  };
  protoOf(SelectionSupports$selectionSupports$1$iterator$1).m = function () {
    var next = this.dnn_1;
    this.dnn_1 = getNext(this);
    return ensureNotNull(next);
  };
  function defaultFocusAndScrollTo($this, list) {
    return SelectionSupports$defaultFocusAndScrollTo$lambda(list);
  }
  function SelectionSupports$defaultFocusAndScrollTo$lambda$lambda($first, $child) {
    return function () {
      var tmp;
      if ($first) {
        tmp = toFirstFocusable($child);
      } else {
        tmp = toLastFocusable($child);
      }
      var focusAction = tmp;
      focusAction();
      scrollTo_0($child);
      return Unit_instance;
    };
  }
  function SelectionSupports$defaultFocusAndScrollTo$lambda($list) {
    return function (_destruct__k2r9zo) {
      var index = _destruct__k2r9zo.ug();
      var first = _destruct__k2r9zo.vg();
      var child = $list.q(index);
      var cellAction = SelectionSupports$defaultFocusAndScrollTo$lambda$lambda(first, child);
      return cellAction;
    };
  }
  function SelectionSupports$selectionSupports$1($start) {
    this.fnn_1 = $start;
  }
  protoOf(SelectionSupports$selectionSupports$1).k = function () {
    var cellsIterator = ancestorsFrom(this.fnn_1).k();
    return new SelectionSupports$selectionSupports$1$iterator$1(cellsIterator);
  };
  function SelectionSupports() {
  }
  protoOf(SelectionSupports).qnm = function (spec, source, target, targetList) {
    return this.gnn(spec, source, target, targetList, defaultFocusAndScrollTo(this, targetList));
  };
  protoOf(SelectionSupports).gnn = function (spec, source, target, targetList, focusAndScrollTo) {
    return new SelectionSupport(spec, source, target, targetList, focusAndScrollTo);
  };
  protoOf(SelectionSupports).dnm = function (start) {
    return new SelectionSupports$selectionSupports$1(start);
  };
  var SelectionSupports_instance;
  function SelectionSupports_getInstance() {
    return SelectionSupports_instance;
  }
  function isGoBackward($this, event) {
    return event.ol1([KeyStrokeSpecs_getInstance().pl2_1]) || event.ml1(Key_UP_getInstance(), []) || event.ml1(Key_PAGE_UP_getInstance(), []) || event.ol1([KeyStrokeSpecs_getInstance().ll2_1]) || event.ol1([KeyStrokeSpecs_getInstance().nl2_1]);
  }
  function isGoForward($this, event) {
    return event.ol1([KeyStrokeSpecs_getInstance().ql2_1]) || event.ml1(Key_DOWN_getInstance(), []) || event.ml1(Key_PAGE_DOWN_getInstance(), []) || event.ol1([KeyStrokeSpecs_getInstance().ml2_1]) || event.ol1([KeyStrokeSpecs_getInstance().ol2_1]);
  }
  function SelectionUtil() {
    SelectionUtil_instance = this;
    this.onl_1 = Companion_instance_36.q2s(-1, -1);
  }
  protoOf(SelectionUtil).qnl = function (from, what) {
    var tmp;
    if (what.p() || !from.d2t(what)) {
      tmp = from;
    } else if (what.b2t(from)) {
      tmp = this.onl_1;
    } else if (from.b2t(what)) {
      var tmp_0;
      if (from.n2s_1 < what.n2s_1) {
        var tmp_1;
        if (what.o2s_1 < from.o2s_1) {
          tmp_1 = null;
        } else {
          tmp_1 = Companion_instance_36.q2s(from.n2s_1, what.n2s_1);
        }
        tmp_0 = tmp_1;
      } else {
        tmp_0 = new Interval(what.o2s_1 + 1 | 0, from.o2s_1);
      }
      tmp = tmp_0;
    } else if (from.a2t(what.n2s_1)) {
      tmp = Companion_instance_36.q2s(from.n2s_1, what.n2s_1);
    } else if (from.a2t(what.o2s_1)) {
      tmp = new Interval(what.o2s_1 + 1 | 0, from.o2s_1);
    } else {
      throw IllegalStateException_init_$Create$();
    }
    return tmp;
  };
  protoOf(SelectionUtil).snl = function (a, b) {
    var tmp;
    if (a == null || a.p()) {
      tmp = b;
    } else if (b.p()) {
      tmp = a;
    } else if (a.d2t(b) || (a.o2s_1 + 1 | 0) === b.n2s_1 || (b.o2s_1 + 1 | 0) === a.n2s_1) {
      tmp = a.f2t(b);
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(SelectionUtil).pnl = function (a, b) {
    var tmp;
    if (a > b) {
      tmp = new Interval(b, a);
    } else {
      tmp = new Interval(a, b);
    }
    return tmp;
  };
  protoOf(SelectionUtil).unl = function (cell, event, support, clear) {
    if (event.ml1(Key_LEFT_getInstance(), [])) {
      var firstSelected = support.xna_1.q(support.rnf().n2s_1);
      clear();
      toFirstFocusable(firstSelected)();
      event.ol0();
    } else if (event.ml1(Key_RIGHT_getInstance(), [])) {
      var lastSelected = support.xna_1.q(support.rnf().o2s_1);
      clear();
      toLastFocusable(lastSelected)();
      event.ol0();
    } else if (isGoBackward(this, event)) {
      clear();
      var focused = ensureNotNull(cell.llk()).rlp().qr();
      if (!Cells_getInstance().kmx(focused)) {
        toFirstFocusable(ensureNotNull(focused))();
        event.ol0();
      }
    } else if (isGoForward(this, event)) {
      clear();
      var focused_0 = ensureNotNull(cell.llk()).rlp().qr();
      if (!Cells_getInstance().kmx(focused_0)) {
        toLastFocusable(ensureNotNull(focused_0))();
        event.ol0();
      }
    }
  };
  var SelectionUtil_instance;
  function SelectionUtil_getInstance() {
    if (SelectionUtil_instance == null)
      new SelectionUtil();
    return SelectionUtil_instance;
  }
  function SimpleCellSelection(start, end) {
    CellSelection.call(this);
    this.hnn_1 = start;
    this.inn_1 = end;
  }
  function Companion_324() {
  }
  protoOf(Companion_324).klp = function (cell) {
    return new SimpleSelectionBound(cell, Positions_instance.gms(cell), Positions_instance.hms(cell));
  };
  var Companion_instance_324;
  function Companion_getInstance_324() {
    return Companion_instance_324;
  }
  function SimpleSelectionBound(cell, visuallyHome, visuallyEnd) {
    SelectionBound.call(this, cell, visuallyHome, visuallyEnd);
  }
  protoOf(SimpleSelectionBound).hashCode = function () {
    var hash = hashCode(this.ynk_1);
    hash = imul(37, hash) + getBooleanHashCode(this.znk_1) | 0;
    hash = imul(37, hash) + getBooleanHashCode(this.anl_1) | 0;
    return hash;
  };
  protoOf(SimpleSelectionBound).equals = function (other) {
    if (other instanceof SimpleSelectionBound) {
      var that = other instanceof SimpleSelectionBound ? other : THROW_CCE();
      return equals(this.ynk_1, ensureNotNull(that).ynk_1) && this.znk_1 === that.znk_1 && this.anl_1 === that.anl_1;
    }
    return false;
  };
  function selection($this) {
    return $this.knn_1.cnb();
  }
  function leftSelectionSiblingIndex($this, sourceIndex) {
    if (sourceIndex === 0) {
      return -1;
    }
    var leftSourceSibling = $this.jnn_1.q(sourceIndex - 1 | 0);
    return selection($this).t(leftSourceSibling);
  }
  function rightSelectionSiblingIndex($this, sourceIndex) {
    if (sourceIndex === ($this.jnn_1.n() - 1 | 0)) {
      return -1;
    }
    var rightSourceSibling = $this.jnn_1.q(sourceIndex + 1 | 0);
    return selection($this).u(rightSourceSibling);
  }
  function SourceUpdateHandler$onEvent$lambda(this$0, $event) {
    return function () {
      var selection_0 = selection(this$0);
      var tmp;
      if (EventType_ADD_getInstance().equals($event.h27_1)) {
        var tmp_0;
        if (!selection_0.s($event.k27())) {
          var leftSelectionSibling = leftSelectionSiblingIndex(this$0, $event.g27_1);
          var tmp_1;
          if (!(leftSelectionSibling === -1)) {
            var rightSelectionSibling = rightSelectionSiblingIndex(this$0, $event.g27_1);
            var tmp_2;
            if (!(rightSelectionSibling === -1)) {
              if (!((leftSelectionSibling + 1 | 0) === rightSelectionSibling)) {
                throw IllegalStateException_init_$Create$_0('Siblings inconsistent: ' + leftSelectionSibling + ', ' + rightSelectionSibling);
              }
              selection_0.p2(rightSelectionSibling, $event.k27());
              tmp_2 = Unit_instance;
            }
            tmp_1 = tmp_2;
          }
          tmp_0 = tmp_1;
        }
        tmp = tmp_0;
      } else {
        var selectionIndex = selection_0.t($event.i27());
        var tmp_3;
        if (!(selectionIndex === -1)) {
          switch ($event.h27_1.a3_1) {
            case 1:
              selection_0.o2(selectionIndex, $event.k27());
              break;
            case 2:
              selection_0.q2(selectionIndex);
              break;
            default:
              throw IllegalStateException_init_$Create$_0('' + $event.toString());
          }
          tmp_3 = Unit_instance;
        }
        tmp = tmp_3;
      }
      return Unit_instance;
    };
  }
  function SourceUpdateHandler(source, selectionSupport) {
    this.jnn_1 = source;
    this.knn_1 = selectionSupport;
  }
  protoOf(SourceUpdateHandler).lnn = function (event) {
    this.knn_1.vnl(SourceUpdateHandler$onEvent$lambda(this, event));
  };
  protoOf(SourceUpdateHandler).d28 = function (event) {
    return this.lnn(event instanceof CollectionItemEvent ? event : THROW_CCE());
  };
  function Companion_325() {
    Companion_instance_325 = this;
    this.rls_1 = new Color(0, 0, 0, 0);
    this.sls_1 = new Color(255, 255, 255);
    this.tls_1 = new Color(204, 204, 204);
    this.uls_1 = new Color(0, 0, 0);
    this.vls_1 = new Color(192, 192, 192);
    this.wls_1 = new Color(210, 210, 210);
    this.xls_1 = new Color(128, 128, 128);
    this.yls_1 = new Color(255, 0, 0);
    this.zls_1 = new Color(210, 255, 210);
    this.alt_1 = new Color(0, 255, 0);
    this.blt_1 = new Color(0, 128, 0);
    this.clt_1 = new Color(0, 0, 255);
    this.dlt_1 = new Color(0, 0, 128);
    this.elt_1 = new Color(210, 210, 255);
    this.flt_1 = new Color(255, 255, 0);
    this.glt_1 = new Color(174, 174, 36);
    this.hlt_1 = new Color(255, 255, 128);
    this.ilt_1 = new Color(255, 255, 210);
    this.jlt_1 = new Color(255, 0, 255);
    this.klt_1 = new Color(255, 210, 255);
    this.llt_1 = new Color(128, 0, 128);
    this.mlt_1 = new Color(0, 255, 255);
    this.nlt_1 = new Color(210, 255, 255);
    this.olt_1 = new Color(255, 192, 0);
    this.plt_1 = new Color(255, 175, 175);
    this.qlt_1 = new Color(255, 210, 210);
    this.rlt_1 = 'rgb';
    this.slt_1 = 'color';
    this.tlt_1 = 'rgba';
  }
  var Companion_instance_325;
  function Companion_getInstance_325() {
    if (Companion_instance_325 == null)
      new Companion_325();
    return Companion_instance_325;
  }
  function Color(red, green, blue, alpha) {
    Companion_getInstance_325();
    alpha = alpha === VOID ? 255 : alpha;
    this.mnn_1 = red;
    this.nnn_1 = green;
    this.onn_1 = blue;
    this.pnn_1 = alpha;
  }
  protoOf(Color).qnn = function () {
    var tmp;
    if (this.pnn_1 === 255) {
      tmp = 'rgb(' + this.mnn_1 + ',' + this.nnn_1 + ',' + this.onn_1 + ')';
    } else {
      tmp = 'rgba(' + this.mnn_1 + ',' + this.nnn_1 + ',' + this.onn_1 + ',' + this.pnn_1 / 255.0 + ')';
    }
    return tmp;
  };
  protoOf(Color).toString = function () {
    return 'color(' + this.mnn_1 + ',' + this.nnn_1 + ',' + this.onn_1 + ',' + this.pnn_1 + ')';
  };
  protoOf(Color).hashCode = function () {
    var result = this.mnn_1;
    result = imul(result, 31) + this.nnn_1 | 0;
    result = imul(result, 31) + this.onn_1 | 0;
    result = imul(result, 31) + this.pnn_1 | 0;
    return result;
  };
  protoOf(Color).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Color))
      return false;
    var tmp0_other_with_cast = other instanceof Color ? other : THROW_CCE();
    if (!(this.mnn_1 === tmp0_other_with_cast.mnn_1))
      return false;
    if (!(this.nnn_1 === tmp0_other_with_cast.nnn_1))
      return false;
    if (!(this.onn_1 === tmp0_other_with_cast.onn_1))
      return false;
    if (!(this.pnn_1 === tmp0_other_with_cast.pnn_1))
      return false;
    return true;
  };
  function Font(family, size, isBold, isItalic) {
    isBold = isBold === VOID ? false : isBold;
    isItalic = isItalic === VOID ? false : isItalic;
    this.ult_1 = family;
    this.vlt_1 = size;
    this.wlt_1 = isBold;
    this.xlt_1 = isItalic;
  }
  protoOf(Font).toString = function () {
    var bold = this.wlt_1 ? 'bold' : '';
    var italic = this.xlt_1 ? 'italic' : '';
    return this.ult_1.toString() + ' ' + this.vlt_1 + ' ' + bold + ' ' + italic;
  };
  protoOf(Font).hashCode = function () {
    var result = hashCode(this.ult_1);
    result = imul(result, 31) + this.vlt_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.wlt_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.xlt_1) | 0;
    return result;
  };
  protoOf(Font).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Font))
      return false;
    var tmp0_other_with_cast = other instanceof Font ? other : THROW_CCE();
    if (!equals(this.ult_1, tmp0_other_with_cast.ult_1))
      return false;
    if (!(this.vlt_1 === tmp0_other_with_cast.vlt_1))
      return false;
    if (!(this.wlt_1 === tmp0_other_with_cast.wlt_1))
      return false;
    if (!(this.xlt_1 === tmp0_other_with_cast.xlt_1))
      return false;
    return true;
  };
  function Companion_326() {
    Companion_instance_326 = this;
    this.pls_1 = this.s8r('monospace');
    this.qls_1 = this.s8r('serif');
  }
  protoOf(Companion_326).s8r = function (name) {
    return new FontFamily(name);
  };
  var Companion_instance_326;
  function Companion_getInstance_326() {
    if (Companion_instance_326 == null)
      new Companion_326();
    return Companion_instance_326;
  }
  function FontFamily(name) {
    Companion_getInstance_326();
    this.rnn_1 = name;
  }
  protoOf(FontFamily).toString = function () {
    return this.rnn_1;
  };
  function EmptyImageData(dim) {
    ImageData.call(this, dim);
  }
  function Companion_327() {
  }
  protoOf(Companion_327).emh = function (dim) {
    return new EmptyImageData(dim);
  };
  protoOf(Companion_327).snn = function (dim, url) {
    return new UrlImageData(dim, url);
  };
  var Companion_instance_327;
  function Companion_getInstance_327() {
    return Companion_instance_327;
  }
  function ImageData(dimension) {
    this.tnn_1 = dimension;
  }
  function UrlImageData(dim, url) {
    ImageData.call(this, dim);
    this.vnn_1 = url;
  }
  function AlignmentProperties() {
    AlignmentProperties_instance = this;
    this.wnn_1 = ViewPropertySpec_init_$Create$('crossAlignment', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), Alignment_START_getInstance());
    this.xnn_1 = ViewPropertySpec_init_$Create$('justifyContent', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), false);
  }
  var AlignmentProperties_instance;
  function AlignmentProperties_getInstance() {
    if (AlignmentProperties_instance == null)
      new AlignmentProperties();
    return AlignmentProperties_instance;
  }
  function CustomViewFeatureSpec(name) {
    this.ynn_1 = name;
  }
  protoOf(CustomViewFeatureSpec).toString = function () {
    return this.ynn_1;
  };
  function ExternalPasteContent() {
  }
  protoOf(ExternalPasteContent).fl0 = function (kind) {
    return false;
  };
  protoOf(ExternalPasteContent).gl0 = function (kind) {
    throw IllegalArgumentException_init_$Create$();
  };
  var ExternalPasteContent_instance;
  function ExternalPasteContent_getInstance() {
    return ExternalPasteContent_instance;
  }
  function GroupView() {
    View.call(this);
  }
  protoOf(GroupView).pno = function (loc) {
    return false;
  };
  protoOf(GroupView).qno = function (ctx) {
    protoOf(View).qno.call(this, ctx);
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.hnp();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.view.GroupView.doValidate.<anonymous>' call
      var tmp$ret$0 = item.inp();
      destination.e(tmp$ret$0);
    }
    var visibleChildBounds = destination;
    var tmp = this.elp();
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp$ret$3 = !visibleChildBounds.p();
    tmp.v2c(tmp$ret$3);
    // Inline function 'kotlin.collections.fold' call
    var accumulator = Companion_getInstance_250().hku_1;
    var _iterator__ex2g4s_0 = visibleChildBounds.k();
    while (_iterator__ex2g4s_0.l()) {
      var element = _iterator__ex2g4s_0.m();
      // Inline function 'jetbrains.ocelot.projectional.view.GroupView.doValidate.<anonymous>' call
      accumulator = accumulator.nku(element);
    }
    var bounds = accumulator;
    ctx.mnp(bounds, 0);
  };
  function hasMoreThanOneChild(_this__u8e3s4, $this) {
    // Inline function 'kotlin.run' call
    // Inline function 'jetbrains.ocelot.projectional.view.HorizontalView.hasMoreThanOneChild.<anonymous>' call
    var $this$run = _this__u8e3s4.k();
    var tmp;
    if ($this$run.l()) {
      // Inline function 'kotlin.apply' call
      // Inline function 'jetbrains.ocelot.projectional.view.HorizontalView.hasMoreThanOneChild.<anonymous>.<anonymous>' call
      $this$run.m();
      tmp = $this$run.l();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function HorizontalView() {
    View.call(this);
  }
  protoOf(HorizontalView).qno = function (ctx) {
    protoOf(View).qno.call(this, ctx);
    var width = 0;
    var aboveBaseline = 0;
    var belowBaseLine = 0;
    var children = this.hnp();
    var _iterator__ex2g4s = children.k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      var tmp0 = aboveBaseline;
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = child.zno_1;
      aboveBaseline = Math.max(tmp0, b);
      var bounds = child.inp();
      var tmp2 = belowBaseLine;
      // Inline function 'kotlin.comparisons.maxOf' call
      var b_0 = bounds.dku_1.fku_1 - child.zno_1 | 0;
      belowBaseLine = Math.max(tmp2, b_0);
      width = width + bounds.dku_1.eku_1 | 0;
    }
    var offset = 0;
    var _iterator__ex2g4s_0 = children.k();
    while (_iterator__ex2g4s_0.l()) {
      var child_0 = _iterator__ex2g4s_0.m();
      var newOrigin = ctx.bnr().jku(new Vector(offset, aboveBaseline - child_0.zno_1 | 0));
      child_0.fnq(newOrigin);
      offset = offset + child_0.inp().dku_1.eku_1 | 0;
    }
    ctx.cnr(new Vector(width, aboveBaseline + belowBaseLine | 0), aboveBaseline);
  };
  protoOf(HorizontalView).hnq = function (ctx) {
    protoOf(View).hnq.call(this, ctx);
    if (this.tnp(AlignmentProperties_getInstance().xnn_1) && hasMoreThanOneChild(this.hnp(), this)) {
      this.dnr(ctx);
    }
  };
  function ImageView() {
  }
  function Companion_328() {
    Companion_instance_328 = this;
    this.enr_1 = 5;
    this.fnr_1 = ViewPropertySpec_init_$Create$('color', ViewPropertyKind_REPAINT_getInstance(), Companion_getInstance_325().uls_1);
    this.gnr_1 = ViewPropertySpec_init_$Create$('width', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), 1);
    this.hnr_1 = ViewPropertySpec_init_$Create$('start', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), Companion_getInstance_251().iku_1);
    this.inr_1 = ViewPropertySpec_init_$Create$('end', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), Companion_getInstance_251().iku_1);
  }
  var Companion_instance_328;
  function Companion_getInstance_328() {
    if (Companion_instance_328 == null)
      new Companion_328();
    return Companion_instance_328;
  }
  function LineView() {
  }
  protoOf(LineView).q1 = function () {
    return this.znr(Companion_getInstance_328().hnr_1);
  };
  protoOf(LineView).mc4 = function () {
    return this.znr(Companion_getInstance_328().inr_1);
  };
  protoOf(LineView).ans = function () {
    return this.vnp(Companion_getInstance_328().fnr_1);
  };
  protoOf(LineView).zlh = function () {
    return this.vnp(Companion_getInstance_328().gnr_1);
  };
  function Companion_329() {
    Companion_instance_329 = this;
    this.bns_1 = new CustomViewFeatureSpec('points');
    this.cns_1 = ViewPropertySpec_init_$Create$('color', ViewPropertyKind_REPAINT_getInstance(), Companion_getInstance_325().uls_1);
    this.dns_1 = ViewPropertySpec_init_$Create$('width', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), 1);
  }
  var Companion_instance_329;
  function Companion_getInstance_329() {
    if (Companion_instance_329 == null)
      new Companion_329();
    return Companion_instance_329;
  }
  function MultiPointView() {
  }
  protoOf(MultiPointView).ans = function () {
    return this.vnp(Companion_getInstance_329().cns_1);
  };
  protoOf(MultiPointView).zlh = function () {
    return this.vnp(Companion_getInstance_329().dns_1);
  };
  function NullViewContainerPeer() {
    this.wns_1 = null;
    this.xns_1 = new TrivialSystemClipboard();
  }
  protoOf(NullViewContainerPeer).yns = function (container) {
    this.wns_1 = container;
  };
  protoOf(NullViewContainerPeer).t6m = function () {
  };
  protoOf(NullViewContainerPeer).zns = function (view) {
  };
  protoOf(NullViewContainerPeer).ant = function (view, change) {
  };
  protoOf(NullViewContainerPeer).bnt = function (font, text) {
    return imul(text.length, 5);
  };
  function PolyLineView() {
  }
  function Companion_330() {
    Companion_instance_330 = this;
    this.cnt_1 = 5;
    this.dnt_1 = 5;
    this.ent_1 = ViewPropertySpec_init_$Create$('maxDimension', ViewPropertyKind_RELAYOUT_getInstance(), Companion_getInstance_251().iku_1);
    this.fnt_1 = ViewPropertySpec_init_$Create$('offset', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), Companion_getInstance_251().iku_1);
    this.gnt_1 = ViewPropertySpec_init_$Create$('scroll', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), false);
  }
  var Companion_instance_330;
  function Companion_getInstance_330() {
    if (Companion_instance_330 == null)
      new Companion_330();
    return Companion_instance_330;
  }
  function ScrollView() {
  }
  protoOf(ScrollView).xnt = function () {
    return this.vnp(Companion_getInstance_330().ent_1);
  };
  protoOf(ScrollView).ynt = function () {
    return this.vnp(Companion_getInstance_330().gnt_1);
  };
  function TextView$Companion$SELECTION_END$lambda(view) {
    return view.tnp(Companion_getInstance_331().hnu_1);
  }
  function Companion_331() {
    Companion_instance_331 = this;
    this.znt_1 = new Font(Companion_getInstance_326().pls_1, 14);
    this.anu_1 = ViewPropertySpec_init_$Create$('text', ViewPropertyKind_RELAYOUT_getInstance(), '');
    this.bnu_1 = ViewPropertySpec_init_$Create$('color', ViewPropertyKind_REPAINT_getInstance(), Companion_getInstance_325().uls_1);
    this.cnu_1 = ViewPropertySpec_init_$Create$('bold', ViewPropertyKind_REPAINT_getInstance(), false);
    this.dnu_1 = ViewPropertySpec_init_$Create$('italic', ViewPropertyKind_REPAINT_getInstance(), false);
    this.enu_1 = ViewPropertySpec_init_$Create$('fontFamily', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), this.znt_1.ult_1);
    this.fnu_1 = ViewPropertySpec_init_$Create$('fontSize', ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance(), this.znt_1.vlt_1);
    this.gnu_1 = ViewPropertySpec_init_$Create$('caretVisible', ViewPropertyKind_REPAINT_getInstance(), false);
    this.hnu_1 = ViewPropertySpec_init_$Create$('caretPosition', ViewPropertyKind_REPAINT_getInstance(), 0);
    this.inu_1 = ViewPropertySpec_init_$Create$('selectionVisible', ViewPropertyKind_REPAINT_getInstance(), false);
    this.jnu_1 = ViewPropertySpec_init_$Create$('selectionStart', ViewPropertyKind_REPAINT_getInstance(), 0);
    var tmp = this;
    var tmp_0 = ViewPropertyKind_REPAINT_getInstance();
    tmp.knu_1 = new ViewPropertySpec('selectionEnd', tmp_0, TextView$Companion$SELECTION_END$lambda);
    this.lnu_1 = ViewPropertySpec_init_$Create$('textDecorations', ViewPropertyKind_REPAINT_getInstance(), emptySet());
    this.mnu_1 = createPropertySpec_0('textStyleRegions');
  }
  var Companion_instance_331;
  function Companion_getInstance_331() {
    if (Companion_instance_331 == null)
      new Companion_331();
    return Companion_instance_331;
  }
  function TextView() {
  }
  protoOf(TextView).laz = function () {
    return this.vnp(Companion_getInstance_331().anu_1);
  };
  protoOf(TextView).hlu = function () {
    return this.vnp(Companion_getInstance_331().bnu_1);
  };
  protoOf(TextView).jlu = function () {
    return this.vnp(Companion_getInstance_331().cnu_1);
  };
  protoOf(TextView).klu = function () {
    return this.vnp(Companion_getInstance_331().dnu_1);
  };
  protoOf(TextView).llu = function () {
    return this.vnp(Companion_getInstance_331().enu_1);
  };
  protoOf(TextView).mlu = function () {
    return this.vnp(Companion_getInstance_331().fnu_1);
  };
  protoOf(TextView).ilu = function () {
    return this.vnp(Companion_getInstance_331().gnu_1);
  };
  protoOf(TextView).zlt = function () {
    return this.vnp(Companion_getInstance_331().hnu_1);
  };
  protoOf(TextView).nlu = function () {
    return this.vnp(Companion_getInstance_331().inu_1);
  };
  protoOf(TextView).olu = function () {
    return this.vnp(Companion_getInstance_331().jnu_1);
  };
  protoOf(TextView).plu = function () {
    return this.vnp(Companion_getInstance_331().knu_1);
  };
  function _get_myIndentWidth__n8y99f($this) {
    return $this.vnp(Companion_getInstance_332().env_1);
  }
  function stretchChildrenWidth($this, ctx) {
    if (!($this.tnp(AlignmentProperties_getInstance().wnn_1) === Alignment_STRETCH_getInstance()))
      return Unit_instance;
    var _iterator__ex2g4s = $this.hnp().k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      if (canStretch($this, child)) {
        child.hnq(ctx);
      }
      if (child instanceof VerticalView) {
        stretchChildrenWidth(child, ctx);
      }
    }
  }
  function canStretch($this, view) {
    var tmp;
    if (view instanceof VerticalView) {
      tmp = true;
    } else {
      tmp = view instanceof HorizontalView;
    }
    return tmp;
  }
  function Companion_332() {
    Companion_instance_332 = this;
    this.dnv_1 = ViewPropertySpec_init_$Create$('indent', ViewPropertyKind_RELAYOUT_getInstance(), false);
    this.env_1 = ViewPropertySpec_init_$Create$('indentWidth', ViewPropertyKind_NONE_getInstance(), 0);
  }
  var Companion_instance_332;
  function Companion_getInstance_332() {
    if (Companion_instance_332 == null)
      new Companion_332();
    return Companion_instance_332;
  }
  function VerticalView() {
    Companion_getInstance_332();
    View.call(this);
  }
  protoOf(VerticalView).vnv = function () {
    return this.vnp(Companion_getInstance_332().dnv_1);
  };
  protoOf(VerticalView).wnv = function () {
    return _get_myIndentWidth__n8y99f(this);
  };
  protoOf(VerticalView).qno = function (ctx) {
    protoOf(View).qno.call(this, ctx);
    var origin = ctx.bnr();
    var width = 0;
    var height = 0;
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.xno_1;
    var tmp;
    // Inline function 'jetbrains.ocelot.projectional.view.VerticalView.doValidate.<anonymous>' call
    if (this.vnv().m2c()) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.run' call
      // Inline function 'jetbrains.ocelot.projectional.view.VerticalView.doValidate.<anonymous>' call
      tmp_0 = imul(tmp0_safe_receiver.xnv_1.bnt(Companion_getInstance_331().znt_1, 'x'), 2);
    }
    var tmp1_elvis_lhs = tmp_0;
    var indentWidth = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    _get_myIndentWidth__n8y99f(this).t2c(indentWidth);
    var children = this.hnp();
    var _iterator__ex2g4s = children.k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      var bounds = child.inp();
      child.fnq(origin.jku(new Vector(indentWidth, height)));
      height = height + bounds.dku_1.fku_1 | 0;
      var tmp4 = width;
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = bounds.dku_1.eku_1 + indentWidth | 0;
      width = Math.max(tmp4, b);
    }
    // Inline function 'kotlin.run' call
    // Inline function 'jetbrains.ocelot.projectional.view.VerticalView.doValidate.<anonymous>' call
    var $this$run = children.k();
    var baseLine = $this$run.l() ? $this$run.m().zno_1 : 0;
    ctx.cnr(new Vector(width, height), baseLine);
    stretchChildrenWidth(this, ctx);
  };
  function View$ChildList$o$onItemAdded$lambda($event) {
    return function (listener) {
      listener.fnw($event);
      return Unit_instance;
    };
  }
  function View$ChildList$o$onItemRemoved$lambda($event) {
    return function (listener) {
      listener.gnw($event);
      return Unit_instance;
    };
  }
  function View$ChildList$1(this$0) {
    this.hnw_1 = this$0;
    CollectionAdapter.call(this);
  }
  protoOf(View$ChildList$1).inw = function (event) {
    var tmp0_safe_receiver = this.hnw_1.xno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.jnw(this.hnw_1, event);
    }
    this.hnw_1.ynp(View$ChildList$o$onItemAdded$lambda(event));
    this.hnw_1.s4u();
  };
  protoOf(View$ChildList$1).c27 = function (event) {
    return this.inw(event);
  };
  protoOf(View$ChildList$1).knw = function (event) {
    var tmp0_safe_receiver = this.hnw_1.xno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.lnw(this.hnw_1, event);
    }
    this.hnw_1.ynp(View$ChildList$o$onItemRemoved$lambda(event));
    this.hnw_1.s4u();
  };
  protoOf(View$ChildList$1).j27 = function (event) {
    return this.knw(event);
  };
  function View$ChildList$beforeItemAdded$lambda(this$0) {
    return function (listener) {
      listener.mnw(new PropertyChangeEvent(null, this$0));
      return Unit_instance;
    };
  }
  function View$ChildList$beforeItemRemoved$lambda($oldParent) {
    return function (listener) {
      listener.mnw(new PropertyChangeEvent($oldParent, null));
      return Unit_instance;
    };
  }
  function getChildrenForIndexOperation($this) {
    var tmp0_elvis_lhs = $this.onw_1.tno_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw CollectionIndexOutOfBoundsException_init_$Create$();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function getOrInitChildren($this) {
    var tmp0_elvis_lhs = $this.onw_1.tno_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'jetbrains.ocelot.projectional.view.ExternalChildList.getOrInitChildren.<anonymous>' call
      var children = new ChildList_1($this.onw_1);
      $this.onw_1.tno_1 = children;
      tmp = children;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function View$ExternalChildList$addListener$1($listener) {
    this.pnw_1 = $listener;
  }
  protoOf(View$ExternalChildList$addListener$1).fnw = function (event) {
    return this.pnw_1.c27(event);
  };
  protoOf(View$ExternalChildList$addListener$1).gnw = function (event) {
    return this.pnw_1.j27(event);
  };
  function View$ExternalChildList$addHandler$1($handler) {
    this.xnw_1 = $handler;
  }
  protoOf(View$ExternalChildList$addHandler$1).inw = function (event) {
    return this.xnw_1.d28(event);
  };
  protoOf(View$ExternalChildList$addHandler$1).c27 = function (event) {
    return this.inw(event);
  };
  protoOf(View$ExternalChildList$addHandler$1).ynw = function (event) {
    return this.xnw_1.d28(event);
  };
  protoOf(View$ExternalChildList$addHandler$1).d27 = function (event) {
    return this.ynw(event);
  };
  protoOf(View$ExternalChildList$addHandler$1).knw = function (event) {
    return this.xnw_1.d28(event);
  };
  protoOf(View$ExternalChildList$addHandler$1).j27 = function (event) {
    return this.knw(event);
  };
  function View$getProp$1$addHandler$1($spec, $handler) {
    this.znw_1 = $spec;
    this.anx_1 = $handler;
  }
  protoOf(View$getProp$1$addHandler$1).qnw = function (prop, event) {
    if (!(prop === this.znw_1))
      return Unit_instance;
    var propertyChangeEvent = event instanceof PropertyChangeEvent ? event : THROW_CCE();
    this.anx_1.d28(propertyChangeEvent);
  };
  function View$customFeatureChange$1$addHandler$1($featureSpec, $handler) {
    this.bnx_1 = $featureSpec;
    this.cnx_1 = $handler;
  }
  function View$valid$1$addHandler$1($handler) {
    this.dnx_1 = $handler;
  }
  protoOf(View$valid$1$addHandler$1).rnw = function () {
    this.dnx_1.d28(new PropertyChangeEvent(false, true));
  };
  protoOf(View$valid$1$addHandler$1).snw = function () {
    this.dnx_1.d28(new PropertyChangeEvent(true, false));
  };
  function View$toRootDelta$1$addHandler$reg$1($handler) {
    this.enx_1 = $handler;
  }
  protoOf(View$toRootDelta$1$addHandler$reg$1).wnw = function (change) {
    return this.enx_1.d28(change);
  };
  function View$toRootDelta$1$addHandler$$inlined$toDisposable$1(this$0, $reg) {
    this.fnx_1 = this$0;
    this.gnx_1 = $reg;
  }
  protoOf(View$toRootDelta$1$addHandler$$inlined$toDisposable$1).vr = function () {
    changeToRootDeltaListenersCount(this.fnx_1, -1);
    this.gnx_1.vr();
    return Unit_instance;
  };
  function View$_get_boundsProp_$o$addHandler$lambda_t9bhh($handler, this$0) {
    return function (event) {
      var oldDelta = event.o2e_1;
      var newDelta = event.p2e_1;
      $handler.d28(new PropertyChangeEvent(_get_localBounds__4u83v5(this$0).jku(oldDelta), _get_localBounds__4u83v5(this$0).jku(newDelta)));
      return Unit_instance;
    };
  }
  function View$boundsProp$1$addHandler$2($handler) {
    this.hnx_1 = $handler;
  }
  protoOf(View$boundsProp$1$addHandler$2).vnw = function (change) {
    this.hnx_1.d28(new PropertyChangeEvent(change.o2e_1, change.p2e_1));
  };
  function View$attachEvents$1$addHandler$1($handler) {
    this.inx_1 = $handler;
  }
  protoOf(View$attachEvents$1$addHandler$1).tnw = function () {
    return this.inx_1.d28(null);
  };
  function _get_reversedVisibleChildren__bljkhq($this) {
    return reversed($this.hnp());
  }
  function getInitializedProperties($this) {
    var tmp0_elvis_lhs = $this.uno_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'jetbrains.ocelot.projectional.view.View.getInitializedProperties.<anonymous>' call
      var properties = new ListMap();
      $this.uno_1 = properties;
      tmp = properties;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function getInitializedListeners($this) {
    var tmp0_elvis_lhs = $this.wno_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'jetbrains.ocelot.projectional.view.View.getInitializedListeners.<anonymous>' call
      var listeners = new Listeners();
      $this.wno_1 = listeners;
      tmp = listeners;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _set_localBounds__pg62gr($this, value) {
    $this.anp_1 = value.cku_1.eku_1;
    $this.bnp_1 = value.cku_1.fku_1;
    $this.cnp_1 = value.dku_1.eku_1;
    $this.dnp_1 = value.dku_1.fku_1;
  }
  function _get_localBounds__4u83v5($this) {
    return Rectangle_init_$Create$($this.anp_1, $this.bnp_1, $this.cnp_1, $this.dnp_1);
  }
  function detach_0($this) {
    var tmp0_elvis_lhs = $this.xno_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var oldContainer = tmp;
    $this.ynp(ViewListener$onViewDetached$ref());
    $this.nla();
    var _iterator__ex2g4s = $this.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      detach_0(child);
    }
    oldContainer.jnx($this);
    $this.xno_1 = null;
  }
  function changeToRootDeltaListenersCount($this, delta) {
    $this.gnp_1 = $this.gnp_1 + delta | 0;
    var tmp0_safe_receiver = $this.sno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      changeToRootDeltaListenersCount(tmp0_safe_receiver, delta);
    }
  }
  function propertyChanged($this, prop, event) {
    var tmp;
    if (!(prop === Companion_getInstance_333().nnx_1) || !$this.nnp().m2c()) {
      tmp = true;
    } else {
      var tmp_0 = event.p2e_1;
      tmp = (!(tmp_0 == null) ? typeof tmp_0 === 'boolean' : false) ? tmp_0 : THROW_CCE();
    }
    // Inline function 'kotlin.check' call
    if (!tmp) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    prop.unx_1.ynx($this);
    var tmp0_safe_receiver = $this.xno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.znx($this, prop, event);
    }
    $this.ynp(View$propertyChanged$lambda(prop, event));
  }
  function doMove($this, delta) {
    $this.enp_1 = $this.enp_1 + delta.eku_1 | 0;
    $this.fnp_1 = $this.fnp_1 + delta.fku_1 | 0;
    var tmp0_safe_receiver = $this.xno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.view.View.doMove.<anonymous>' call
      var newBounds = $this.inp();
      var oldBounds = newBounds.kku(delta);
      tmp0_safe_receiver.any($this, new PropertyChangeEvent(oldBounds, newBounds));
    }
    if (!($this.gnp_1 === 0)) {
      fireMove($this, delta);
    }
  }
  function fireMove($this, delta) {
    $this.ynp(View$fireMove$lambda($this, delta));
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = $this.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.view.View.fireMove.<anonymous>' call
      if (!(element.gnp_1 === 0)) {
        fireMove(element, delta);
      }
    }
  }
  function doJustifyByWidth($this, children, spaceToDistribute) {
    var estimatedInterval = spaceToDistribute / (children.n() - 1 | 0) | 0;
    var spaceLeft = spaceToDistribute;
    var inductionVariable = 1;
    var last = children.n();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var prev = children.q(i - 1 | 0);
        var current = children.q(i);
        var interval = (i + 1 | 0) === children.n() || spaceLeft < estimatedInterval ? spaceLeft : estimatedInterval;
        var currentInterval = current.inp().cku_1.eku_1 - (prev.inp().cku_1.eku_1 + prev.inp().dku_1.eku_1 | 0) | 0;
        doMove(current, new Vector(interval - currentInterval | 0, 0));
        spaceLeft = spaceLeft - interval | 0;
      }
       while (inductionVariable < last);
  }
  function assertAncestorBoundsSet($this, ctx) {
    var view = ctx.jnp_1;
    // Inline function 'kotlin.check' call
    if (!contains_6(ancestors($this), view)) {
      // Inline function 'jetbrains.ocelot.projectional.view.View.assertAncestorBoundsSet.<anonymous>' call
      var message = 'Must validate ancestor of ' + $this.toString() + ', but validating ' + view.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!ctx.lnp_1) {
      // Inline function 'jetbrains.ocelot.projectional.view.View.assertAncestorBoundsSet.<anonymous>' call
      var message_0 = 'Bounds are not set for ' + view.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  function toStringSuffix($this) {
    var result = '@' + toString_3(hashCode($this), 16);
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = $this.b3().m2c();
    if (charSequenceLength(this_0) > 0) {
      result = result + ('<' + $this.b3().m2c() + '>');
    }
    return result;
  }
  function ValidationContext(view, setBoundsAndBaseline) {
    this.jnp_1 = view;
    this.knp_1 = setBoundsAndBaseline;
    this.lnp_1 = false;
  }
  protoOf(ValidationContext).bnr = function () {
    return this.jnp_1.inp().cku_1;
  };
  protoOf(ValidationContext).cnr = function (dim, baseLine) {
    var rectangle = new Rectangle(this.bnr(), dim);
    this.mnp(rectangle, baseLine);
  };
  protoOf(ValidationContext).mnp = function (bounds, baseLine) {
    this.knp_1(bounds, baseLine);
    this.lnp_1 = true;
  };
  function ChildList_1($outer) {
    this.eny_1 = $outer;
    ObservableArrayList.call(this);
    this.n27(new View$ChildList$1(this.eny_1));
  }
  protoOf(ChildList_1).fny = function (index, item) {
    item.sno_1 = this.eny_1;
    var tmp0_safe_receiver = this.eny_1.xno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.view.ChildList.beforeItemAdded.stub_for_inlining' call
      item.snp(tmp0_safe_receiver);
    }
    item.ynp(View$ChildList$beforeItemAdded$lambda(this.eny_1));
  };
  protoOf(ChildList_1).i28 = function (index, item) {
    return this.fny(index, item instanceof View ? item : THROW_CCE());
  };
  protoOf(ChildList_1).gny = function (index, oldItem, newItem) {
    this.hny(index, oldItem);
    this.fny(index, newItem);
  };
  protoOf(ChildList_1).n28 = function (index, oldItem, newItem) {
    var tmp = oldItem instanceof View ? oldItem : THROW_CCE();
    return this.gny(index, tmp, newItem instanceof View ? newItem : THROW_CCE());
  };
  protoOf(ChildList_1).hny = function (index, item) {
    if (this.eny_1.qlc()) {
      detach_0(item);
    }
    var oldParent = item.sno_1;
    item.sno_1 = null;
    item.ynp(View$ChildList$beforeItemRemoved$lambda(oldParent));
  };
  protoOf(ChildList_1).s28 = function (index, item) {
    return this.hny(index, item instanceof View ? item : THROW_CCE());
  };
  function ExternalChildList_0($outer) {
    this.onw_1 = $outer;
    AbstractMutableList.call(this);
  }
  protoOf(ExternalChildList_0).q = function (index) {
    return getChildrenForIndexOperation(this).q(index);
  };
  protoOf(ExternalChildList_0).n = function () {
    var tmp0_safe_receiver = this.onw_1.tno_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n();
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ExternalChildList_0).iny = function (index, element) {
    return getChildrenForIndexOperation(this).o2(index, element);
  };
  protoOf(ExternalChildList_0).o2 = function (index, element) {
    return this.iny(index, element instanceof View ? element : THROW_CCE());
  };
  protoOf(ExternalChildList_0).jny = function (index, element) {
    return getOrInitChildren(this).p2(index, element);
  };
  protoOf(ExternalChildList_0).p2 = function (index, element) {
    return this.jny(index, element instanceof View ? element : THROW_CCE());
  };
  protoOf(ExternalChildList_0).q2 = function (index) {
    var children = getChildrenForIndexOperation(this);
    var result = children.q2(index);
    if (children.p())
      this.onw_1.tno_1 = null;
    return result;
  };
  protoOf(ExternalChildList_0).kny = function (listener) {
    return this.onw_1.wnp(new View$ExternalChildList$addListener$1(listener));
  };
  protoOf(ExternalChildList_0).n27 = function (listener) {
    return this.kny(listener);
  };
  protoOf(ExternalChildList_0).lny = function (handler) {
    return this.kny(new View$ExternalChildList$addHandler$1(handler));
  };
  protoOf(ExternalChildList_0).o27 = function (handler) {
    return this.lny(handler);
  };
  function ToParentOffsetProperty($outer, baseProperty) {
    this.rny_1 = $outer;
    DerivedProperty.call(this, [baseProperty, $outer.cnq()]);
    this.qny_1 = baseProperty;
  }
  protoOf(ToParentOffsetProperty).g2c = function () {
    return this.qny_1.m2c().jku(this.rny_1.cnq().m2c());
  };
  protoOf(ToParentOffsetProperty).sny = function (newValue) {
    return this.qny_1.v2c(newValue.kku(this.rny_1.cnq().m2c()));
  };
  protoOf(ToParentOffsetProperty).t2c = function (newValue) {
    return this.sny(newValue instanceof Vector ? newValue : THROW_CCE());
  };
  function Companion_333() {
    Companion_instance_333 = this;
    this.knx_1 = ViewPropertySpec_init_$Create$('name', ViewPropertyKind_NONE_getInstance(), '');
    this.lnx_1 = ViewPropertySpec_init_$Create$('visible', ViewPropertyKind_RELAYOUT_PARENT_getInstance(), true);
    this.mnx_1 = ViewPropertySpec_init_$Create$('focused', ViewPropertyKind_NONE_getInstance(), false);
    this.nnx_1 = ViewPropertySpec_init_$Create$('focusable', ViewPropertyKind_NONE_getInstance(), false);
    this.onx_1 = createPropertySpec('background', ViewPropertyKind_REPAINT_getInstance());
    this.pnx_1 = createPropertySpec('border', ViewPropertyKind_REPAINT_getInstance());
    this.qnx_1 = createPropertySpec('borderColor', ViewPropertyKind_REPAINT_getInstance());
    this.rnx_1 = ViewPropertySpec_init_$Create$('borderWidth', ViewPropertyKind_REPAINT_getInstance(), 1);
    this.snx_1 = ViewPropertySpec_init_$Create$('hasShadow', ViewPropertyKind_REPAINT_getInstance(), false);
  }
  var Companion_instance_333;
  function Companion_getInstance_333() {
    if (Companion_instance_333 == null)
      new Companion_333();
    return Companion_instance_333;
  }
  function ViewListener$onViewAttached$ref() {
    var l = function (p0) {
      p0.tnw();
      return Unit_instance;
    };
    l.callableName = 'onViewAttached';
    return l;
  }
  function ViewListener$onViewDetached$ref() {
    var l = function (p0) {
      p0.unw();
      return Unit_instance;
    };
    l.callableName = 'onViewDetached';
    return l;
  }
  function View$getProp$1($spec, this$0) {
    this.tny_1 = $spec;
    this.uny_1 = this$0;
  }
  protoOf(View$getProp$1).l2c = function () {
    return toString_1(this) + '.' + this.tny_1.toString();
  };
  protoOf(View$getProp$1).qr = function () {
    return this.uny_1.tnp(this.tny_1);
  };
  protoOf(View$getProp$1).t2c = function (newValue) {
    this.uny_1.unp(this.tny_1, newValue);
  };
  protoOf(View$getProp$1).k2c = function (handler) {
    return this.uny_1.wnp(new View$getProp$1$addHandler$1(this.tny_1, handler));
  };
  protoOf(View$getProp$1).o27 = function (handler) {
    return this.k2c(handler);
  };
  function View$addListener$$inlined$toDisposable$1($reg, $listeners, this$0) {
    this.vny_1 = $reg;
    this.wny_1 = $listeners;
    this.xny_1 = this$0;
  }
  protoOf(View$addListener$$inlined$toDisposable$1).vr = function () {
    this.vny_1.vr();
    var tmp;
    if (this.wny_1.np()) {
      this.xny_1.wno_1 = null;
      tmp = Unit_instance;
    }
    return tmp;
  };
  function View$customFeatureChange$1(this$0, $featureSpec) {
    this.yny_1 = this$0;
    this.zny_1 = $featureSpec;
  }
  protoOf(View$customFeatureChange$1).anz = function (handler) {
    return this.yny_1.wnp(new View$customFeatureChange$1$addHandler$1(this.zny_1, handler));
  };
  protoOf(View$customFeatureChange$1).o27 = function (handler) {
    return this.anz(handler);
  };
  function View$valid$1(this$0) {
    this.bnz_1 = this$0;
    BaseReadableProperty.call(this);
  }
  protoOf(View$valid$1).qr = function () {
    return this.bnz_1.yno_1;
  };
  protoOf(View$valid$1).cnz = function (handler) {
    return this.bnz_1.wnp(new View$valid$1$addHandler$1(handler));
  };
  protoOf(View$valid$1).o27 = function (handler) {
    return this.cnz(handler);
  };
  function ViewListener$onViewInvalidated$ref() {
    var l = function (p0) {
      p0.snw();
      return Unit_instance;
    };
    l.callableName = 'onViewInvalidated';
    return l;
  }
  function View$validate$lambda$lambda($event) {
    return function (listener) {
      listener.vnw($event);
      return Unit_instance;
    };
  }
  function View$validate$lambda(this$0) {
    return function (newBounds, newBaseLine) {
      var oldBounds = this$0.inp();
      _set_localBounds__pg62gr(this$0, newBounds.kku(this$0.cnq().m2c()));
      var tmp;
      if (!oldBounds.equals(newBounds)) {
        var event = new PropertyChangeEvent(oldBounds, newBounds);
        this$0.ynp(View$validate$lambda$lambda(event));
        var tmp0_safe_receiver = this$0.xno_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.any(this$0, event);
        }
        tmp = Unit_instance;
      }
      this$0.zno_1 = newBaseLine;
      return Unit_instance;
    };
  }
  function ViewListener$onViewValidated$ref() {
    var l = function (p0) {
      p0.rnw();
      return Unit_instance;
    };
    l.callableName = 'onViewValidated';
    return l;
  }
  function View$toRootDelta$1(this$0) {
    this.dnz_1 = this$0;
    BaseReadableProperty.call(this);
  }
  protoOf(View$toRootDelta$1).qr = function () {
    var tmp0 = ancestorsFrom(this.dnz_1);
    // Inline function 'kotlin.sequences.fold' call
    var accumulator = Companion_getInstance_251().iku_1;
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.view.<no name provided>.get.<anonymous>' call
      accumulator = accumulator.jku(new Vector(element.enp_1, element.fnp_1));
    }
    return accumulator;
  };
  protoOf(View$toRootDelta$1).enz = function (handler) {
    var reg = this.dnz_1.wnp(new View$toRootDelta$1$addHandler$reg$1(handler));
    changeToRootDeltaListenersCount(this.dnz_1, 1);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new View$toRootDelta$1$addHandler$$inlined$toDisposable$1(this.dnz_1, reg);
  };
  protoOf(View$toRootDelta$1).o27 = function (handler) {
    return this.enz(handler);
  };
  function View$boundsProp$1(this$0) {
    this.fnz_1 = this$0;
    BaseReadableProperty.call(this);
  }
  protoOf(View$boundsProp$1).qr = function () {
    return _get_localBounds__4u83v5(this.fnz_1).jku(this.fnz_1.cnq().m2c());
  };
  protoOf(View$boundsProp$1).gnz = function (handler) {
    var tmp = this.fnz_1.cnq();
    var tmp_0 = tmp.p27(View$_get_boundsProp_$o$addHandler$lambda_t9bhh(handler, this.fnz_1));
    return toDisposable([tmp_0, this.fnz_1.wnp(new View$boundsProp$1$addHandler$2(handler))]);
  };
  protoOf(View$boundsProp$1).o27 = function (handler) {
    return this.gnz(handler);
  };
  function View$propertyChanged$lambda($prop, $event) {
    return function (listener) {
      listener.qnw($prop, $event);
      return Unit_instance;
    };
  }
  function View$fireMove$lambda(this$0, $delta) {
    return function (listener) {
      var toRootDelta = this$0.cnq().m2c();
      var event = new PropertyChangeEvent(toRootDelta.kku($delta), toRootDelta);
      listener.wnw(event);
      return Unit_instance;
    };
  }
  function View$attachEvents$1(this$0) {
    this.hnz_1 = this$0;
  }
  protoOf(View$attachEvents$1).inz = function (handler) {
    return this.hnz_1.wnp(new View$attachEvents$1$addHandler$1(handler));
  };
  protoOf(View$attachEvents$1).o27 = function (handler) {
    return this.inz(handler);
  };
  function View(isExtension) {
    Companion_getInstance_333();
    isExtension = isExtension === VOID ? false : isExtension;
    this.rno_1 = isExtension;
    this.sno_1 = null;
    this.tno_1 = null;
    this.uno_1 = null;
    this.vno_1 = null;
    this.wno_1 = null;
    this.xno_1 = null;
    this.yno_1 = false;
    this.zno_1 = 0;
    this.anp_1 = 0;
    this.bnp_1 = 0;
    this.cnp_1 = 0;
    this.dnp_1 = 0;
    this.enp_1 = 0;
    this.fnp_1 = 0;
    this.gnp_1 = 0;
  }
  protoOf(View).yt = function () {
    return this.sno_1;
  };
  protoOf(View).g2r = function () {
    return this.ilp();
  };
  protoOf(View).ilp = function () {
    return new ExternalChildList_0(this);
  };
  protoOf(View).hnp = function () {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = this.g2r();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.view.View.<get-visibleChildren>.<anonymous>' call
      if (element.elp().m2c()) {
        destination.e(element);
      }
    }
    return destination;
  };
  protoOf(View).qlc = function () {
    return !(this.xno_1 == null);
  };
  protoOf(View).inp = function () {
    return this.dnq().m2c();
  };
  protoOf(View).elp = function () {
    return this.vnp(Companion_getInstance_333().lnx_1);
  };
  protoOf(View).nnp = function () {
    return this.vnp(Companion_getInstance_333().mnx_1);
  };
  protoOf(View).hlp = function () {
    return this.vnp(Companion_getInstance_333().nnx_1);
  };
  protoOf(View).ily = function () {
    return this.vnp(Companion_getInstance_333().onx_1);
  };
  protoOf(View).pnp = function () {
    return this.vnp(Companion_getInstance_333().qnx_1);
  };
  protoOf(View).qnp = function () {
    return this.vnp(Companion_getInstance_333().rnx_1);
  };
  protoOf(View).rnp = function () {
    return this.vnp(Companion_getInstance_333().snx_1);
  };
  protoOf(View).b3 = function () {
    return this.vnp(Companion_getInstance_333().knx_1);
  };
  protoOf(View).onp = function (focused) {
    return this.vnp(Companion_getInstance_333().mnx_1).t2c(focused);
  };
  protoOf(View).h2r = function () {
    return Composites_instance.o2r(this);
  };
  protoOf(View).k2r = function () {
    return Composites_instance.p2r(this);
  };
  protoOf(View).q2r = function () {
    var tmp0_safe_receiver = this.tno_1;
    return tmp0_safe_receiver == null ? null : first(tmp0_safe_receiver);
  };
  protoOf(View).r2r = function () {
    var tmp0_safe_receiver = this.tno_1;
    return tmp0_safe_receiver == null ? null : last(tmp0_safe_receiver);
  };
  protoOf(View).mla = function () {
  };
  protoOf(View).nla = function () {
  };
  protoOf(View).snp = function (newContainer) {
    // Inline function 'kotlin.check' call
    if (!(this.xno_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var _iterator__ex2g4s = this.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      child.snp(newContainer);
    }
    this.xno_1 = newContainer;
    newContainer.jnz(this);
    this.mla();
    this.ynp(ViewListener$onViewAttached$ref());
  };
  protoOf(View).tnp = function (prop) {
    var tmp0_safe_receiver = this.uno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.view.View.get.<anonymous>' call
      if (tmp0_safe_receiver.w2(prop)) {
        var tmp = tmp0_safe_receiver.y2(prop);
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      }
    }
    var tmp1_safe_receiver = this.vno_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp1_safe_receiver.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.view.View.get.<anonymous>' call
        // Inline function 'jetbrains.ocelot.projectional.view.ViewTrait.dispatchByParent' call
        var current = element;
        while (!(current == null)) {
          // Inline function 'jetbrains.ocelot.projectional.view.View.get.<anonymous>.<anonymous>' call
          var $this$dispatchByParent = current;
          if ($this$dispatchByParent.onz(prop))
            return $this$dispatchByParent.nnz(prop);
          current = access$_get_parent__alxd0f(current);
        }
      }
    }
    return prop.pnz(this);
  };
  protoOf(View).unp = function (prop, value) {
    if (this.uno_1 == null && value == null)
      return Unit_instance;
    var properties = getInitializedProperties(this);
    var oldValue = this.tnp(prop);
    if (value == null) {
      properties.s2(prop);
      if (properties.np())
        this.uno_1 = null;
    } else {
      properties.r2(prop, value);
    }
    var newValue = this.tnp(prop);
    if (!equals(newValue, oldValue)) {
      propertyChanged(this, prop, new PropertyChangeEvent(oldValue, newValue));
    }
  };
  protoOf(View).znr = function (spec) {
    return new ToParentOffsetProperty(this, this.vnp(spec));
  };
  protoOf(View).vnp = function (spec) {
    return new View$getProp$1(spec, this);
  };
  protoOf(View).wnp = function (listener) {
    var listeners = getInitializedListeners(this);
    var reg = listeners.z27(listener);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new View$addListener$$inlined$toDisposable$1(reg, listeners, this);
  };
  protoOf(View).vns = function (featureSpec) {
    return new View$customFeatureChange$1(this, featureSpec);
  };
  protoOf(View).xnp = function () {
    return new View$valid$1(this);
  };
  protoOf(View).s4u = function () {
    if (!this.yno_1)
      return Unit_instance;
    this.yno_1 = false;
    this.ynp(ViewListener$onViewInvalidated$ref());
    var tmp0_safe_receiver = this.sno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.s4u();
    }
  };
  protoOf(View).ynp = function (h) {
    var tmp0_safe_receiver = this.wno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a28(h);
    }
  };
  protoOf(View).qnz = function () {
    this.s4u();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.view.View.invalidateTree.stub_for_inlining' call
      element.s4u();
    }
  };
  protoOf(View).znp = function () {
    var tmp0_safe_receiver = this.xno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.rnz(this);
    }
  };
  protoOf(View).anq = function () {
    return this.znp();
  };
  protoOf(View).qno = function (ctx) {
    var _iterator__ex2g4s = this.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.view.View.doValidate.stub_for_inlining' call
      element.bnq();
    }
    return Unit_instance;
  };
  protoOf(View).bnq = function () {
    if (this.yno_1)
      return Unit_instance;
    this.qno(new ValidationContext(this, View$validate$lambda(this)));
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.view.View.validate.<anonymous>' call
      // Inline function 'kotlin.check' call
      if (!element.yno_1) {
        // Inline function 'jetbrains.ocelot.projectional.view.View.validate.<anonymous>.<anonymous>' call
        var message = 'After doValidate all children must be valid';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    this.yno_1 = true;
    this.ynp(ViewListener$onViewValidated$ref());
  };
  protoOf(View).cnq = function () {
    return new View$toRootDelta$1(this);
  };
  protoOf(View).dnq = function () {
    return new View$boundsProp$1(this);
  };
  protoOf(View).enq = function (loc) {
    if (!this.elp().m2c())
      return null;
    var _iterator__ex2g4s = _get_reversedVisibleChildren__bljkhq(this).k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      if (child.inp().mku(loc)) {
        var result = child.enq(loc);
        if (!(result == null))
          return result;
      }
    }
    return this.pno(loc) ? this : null;
  };
  protoOf(View).pno = function (loc) {
    return this.inp().mku(loc);
  };
  protoOf(View).fnq = function (to) {
    return this.gnq(to.kku(this.inp().cku_1));
  };
  protoOf(View).gnq = function (delta) {
    if (delta.equals(Companion_getInstance_251().iku_1))
      return Unit_instance;
    var tmp0_safe_receiver = this.sno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.s4u();
    }
    doMove(this, delta);
  };
  protoOf(View).hnq = function (ctx) {
    assertAncestorBoundsSet(this, ctx);
    var oldBounds = this.inp();
    this.cnp_1 = ensureNotNull(this.sno_1).inp().dku_1.eku_1;
    var tmp0_safe_receiver = this.xno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.any(this, new PropertyChangeEvent(oldBounds, this.inp()));
    }
  };
  protoOf(View).dnr = function (ctx) {
    assertAncestorBoundsSet(this, ctx);
    var children = toList_0(this.hnp());
    // Inline function 'kotlin.check' call
    if (!(children.n() >= 2)) {
      // Inline function 'jetbrains.ocelot.projectional.view.View.justifyChildrenByWidth.<anonymous>' call
      var message = 'To little visible children: ' + children.n();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var width = this.inp().dku_1.eku_1;
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s = children.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      var tmp = sum;
      // Inline function 'jetbrains.ocelot.projectional.view.View.justifyChildrenByWidth.<anonymous>' call
      sum = tmp + element.inp().dku_1.eku_1 | 0;
    }
    var childrenWidthsSum = sum;
    if (childrenWidthsSum === this.inp().dku_1.eku_1) {
      return Unit_instance;
    }
    // Inline function 'kotlin.check' call
    if (!(childrenWidthsSum <= width)) {
      // Inline function 'jetbrains.ocelot.projectional.view.View.justifyChildrenByWidth.<anonymous>' call
      var message_0 = this.toString() + ', width=' + width + ', childrenWidthsSum=' + childrenWidthsSum;
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
    doJustifyByWidth(this, children, width - childrenWidthsSum | 0);
  };
  protoOf(View).inq = function (spec, event) {
    var tmp0_safe_receiver = this.vno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = tmp0_safe_receiver.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.projectional.view.View.dispatch.<anonymous>' call
        // Inline function 'jetbrains.ocelot.projectional.view.ViewTrait.dispatchByParent' call
        var current = element;
        while (!(current == null)) {
          // Inline function 'jetbrains.ocelot.projectional.view.View.dispatch.<anonymous>.<anonymous>' call
          current.snz(this, spec, event);
          if (event.ml0_1)
            return Unit_instance;
          current = access$_get_parent__alxd0f(current);
        }
      }
    }
    var tmp1_safe_receiver = this.sno_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.inq(spec, event);
    }
  };
  protoOf(View).jnq = function () {
    return new View$attachEvents$1(this);
  };
  protoOf(View).toString = function () {
    return this.knq() + toStringSuffix(this);
  };
  protoOf(View).knq = function () {
    var tmp0_elvis_lhs = getKClassFromExpression(this).lb();
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
  function ViewContainer$RootView$1() {
  }
  protoOf(ViewContainer$RootView$1).fnw = function (event) {
    throw IllegalStateException_init_$Create$_0("It's forbidden to add children to root node");
  };
  protoOf(ViewContainer$RootView$1).gnw = function (event) {
    throw IllegalStateException_init_$Create$_0("It's forbidden to remove children from root node");
  };
  function changeViewUnderMouse($this, e, newView) {
    if ($this.enw_1 === newView)
      return Unit_instance;
    var tmp0_safe_receiver = $this.enw_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.view.ViewContainer.changeViewUnderMouse.<anonymous>' call
      executeCommand($this, ViewContainer$changeViewUnderMouse$lambda(tmp0_safe_receiver, e));
    }
    if (newView == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.projectional.view.ViewContainer.changeViewUnderMouse.<anonymous>' call
      executeCommand($this, ViewContainer$changeViewUnderMouse$lambda_0(newView, e));
    }
    $this.enw_1 = newView;
  }
  function dispatchMouseEvent($this, e, spec) {
    executeCommand($this, ViewContainer$dispatchMouseEvent$lambda($this, e, spec));
  }
  function executeCommand($this, r) {
    if ($this.dnw_1) {
      r();
    } else {
      $this.dnw_1 = true;
      $this.cnw_1.a28(ViewContainerListener$onBeforeCommand$ref());
      try {
        r();
      }finally {
        $this.cnw_1.a28(ViewContainerListener$onAfterCommand$ref());
        $this.dnw_1 = false;
      }
    }
  }
  function dispatchFocusBasedEvent($this, e, spec) {
    executeCommand($this, ViewContainer$dispatchFocusBasedEvent$lambda($this, spec, e));
  }
  function RootView($outer) {
    this.lo0_1 = $outer;
    View.call(this);
    this.jo0_1 = new GroupView();
    this.ko0_1 = new GroupView();
    var children = this.ilp();
    children.e(this.ko0_1);
    children.e(this.jo0_1);
    this.wnp(new ViewContainer$RootView$1());
  }
  protoOf(RootView).bnq = function () {
    protoOf(View).bnq.call(this);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.lo0_1.bnw_1.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.view.RootView.validate.<anonymous>' call
      element();
    }
    this.lo0_1.bnw_1.m2();
  };
  protoOf(RootView).qno = function (ctx) {
    protoOf(View).qno.call(this, ctx);
    var tmp0 = this.hnp();
    // Inline function 'kotlin.collections.fold' call
    var accumulator = Companion_getInstance_250().hku_1;
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.view.RootView.doValidate.<anonymous>' call
      accumulator = accumulator.nku(element.inp());
    }
    var current = accumulator;
    ctx.mnp(current, 0);
  };
  function FocusedViewProperty($outer) {
    this.oo0_1 = $outer;
    ValueProperty.call(this, null);
  }
  protoOf(FocusedViewProperty).po0 = function (newValue) {
    if (!(newValue == null)) {
      // Inline function 'kotlin.check' call
      if (!newValue.hlp().m2c()) {
        // Inline function 'jetbrains.ocelot.projectional.view.FocusedViewProperty.set.<anonymous>' call
        var message = 'cannot set focus: ' + toString_0(newValue);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.require' call
      if (!(newValue.xno_1 === this.oo0_1)) {
        // Inline function 'kotlin.require.<anonymous>' call
        var message_0 = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      }
    }
    var oldValue = this.qr();
    if (oldValue === newValue)
      return Unit_instance;
    if (oldValue == null)
      null;
    else {
      oldValue.onp(false);
    }
    protoOf(ValueProperty).t2c.call(this, newValue);
    if (newValue == null)
      null;
    else {
      newValue.onp(true);
    }
  };
  protoOf(FocusedViewProperty).t2c = function (newValue) {
    return this.po0((newValue == null ? true : newValue instanceof View) ? newValue : THROW_CCE());
  };
  function ViewContainer$mouseDragged$lambda(this$0, $e) {
    return function () {
      this$0.u3o().bnq();
      var tmp0_safe_receiver = this$0.anw_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.inq(ViewEvents_getInstance().vo0_1, $e);
      }
      return Unit_instance;
    };
  }
  function ViewContainer$changeViewUnderMouse$lambda($oldView, $e) {
    return function () {
      $oldView.inq(ViewEvents_getInstance().xo0_1, MouseEvent_init_$Create$($e.zl3(), $e.tl3_1, $e.ul3_1));
      return Unit_instance;
    };
  }
  function ViewContainer$changeViewUnderMouse$lambda_0($newView, $e) {
    return function () {
      $newView.inq(ViewEvents_getInstance().wo0_1, MouseEvent_init_$Create$($e.zl3(), $e.tl3_1, $e.ul3_1));
      return Unit_instance;
    };
  }
  function ViewContainer$dispatchMouseEvent$lambda(this$0, $e, $spec) {
    return function () {
      this$0.u3o().bnq();
      var tmp0_elvis_lhs = this$0.u3o().enq($e.zl3());
      var target = tmp0_elvis_lhs == null ? this$0.u3o() : tmp0_elvis_lhs;
      var tmp;
      if ($spec === ViewEvents_getInstance().so0_1) {
        this$0.anw_1 = target;
        tmp = Unit_instance;
      }
      target.inq($spec, $e);
      return Unit_instance;
    };
  }
  function ViewContainerListener$onBeforeCommand$ref() {
    var l = function (p0) {
      p0.zlp();
      return Unit_instance;
    };
    l.callableName = 'onBeforeCommand';
    return l;
  }
  function ViewContainerListener$onAfterCommand$ref() {
    var l = function (p0) {
      p0.alq();
      return Unit_instance;
    };
    l.callableName = 'onAfterCommand';
    return l;
  }
  function ViewContainer$dispatchFocusBasedEvent$lambda(this$0, $spec, $e) {
    return function () {
      var tmp0_elvis_lhs = this$0.znv_1.m2c();
      var target = tmp0_elvis_lhs == null ? this$0.u3o() : tmp0_elvis_lhs;
      target.inq($spec, $e);
      return Unit_instance;
    };
  }
  function ViewContainer$propertyChanged$lambda($view, $prop, $event) {
    return function (l) {
      l.ko1($view, $prop, $event);
      return Unit_instance;
    };
  }
  function ViewContainer$childAdded$lambda($parent, $event) {
    return function (l) {
      l.lo1($parent, $event);
      return Unit_instance;
    };
  }
  function ViewContainer$childRemoved$lambda($parent, $event) {
    return function (l) {
      l.mo1($parent, $event);
      return Unit_instance;
    };
  }
  function ViewContainer$viewAttached$lambda($view) {
    return function (l) {
      l.no1($view);
      return Unit_instance;
    };
  }
  function ViewContainer$viewDetached$lambda($view) {
    return function (l) {
      l.oo1($view);
      return Unit_instance;
    };
  }
  function ViewContainer() {
    this.xnv_1 = new NullViewContainerPeer();
    this.ynv_1 = new RootView(this);
    this.znv_1 = new FocusedViewProperty(this);
    this.anw_1 = null;
    this.bnw_1 = ArrayList_init_$Create$();
    this.cnw_1 = new Listeners();
    this.dnw_1 = false;
    this.enw_1 = null;
    this.xnv_1.yns(this);
    this.ynv_1.snp(this);
  }
  protoOf(ViewContainer).po1 = function (value) {
    this.xnv_1.t6m();
    this.xnv_1 = value;
    this.ynv_1.qnz();
    this.xnv_1.yns(this);
  };
  protoOf(ViewContainer).u3o = function () {
    return this.ynv_1;
  };
  protoOf(ViewContainer).qo1 = function () {
    return this.ynv_1.ko0_1;
  };
  protoOf(ViewContainer).ro1 = function () {
    return this.ynv_1.jo0_1;
  };
  protoOf(ViewContainer).so1 = function (r) {
    if (this.ynv_1.yno_1) {
      r();
    } else {
      this.bnw_1.e(r);
    }
  };
  protoOf(ViewContainer).rnz = function (view) {
    this.xnv_1.zns(view);
  };
  protoOf(ViewContainer).any = function (view, change) {
    this.xnv_1.ant(view, change);
  };
  protoOf(ViewContainer).ql5 = function (e) {
    return dispatchMouseEvent(this, e, ViewEvents_getInstance().qo0_1);
  };
  protoOf(ViewContainer).sl5 = function (e) {
    return dispatchMouseEvent(this, e, ViewEvents_getInstance().ro0_1);
  };
  protoOf(ViewContainer).tl5 = function (e) {
    return dispatchMouseEvent(this, e, ViewEvents_getInstance().so0_1);
  };
  protoOf(ViewContainer).vl5 = function (e) {
    var dragStart = this.anw_1;
    if (dragStart == null) {
      dispatchMouseEvent(this, e, ViewEvents_getInstance().to0_1);
    } else {
      this.u3o().bnq();
      dragStart.inq(ViewEvents_getInstance().to0_1, e);
      this.anw_1 = null;
    }
  };
  protoOf(ViewContainer).xl5 = function (e) {
    changeViewUnderMouse(this, e, this.u3o().enq(e.zl3()));
    dispatchMouseEvent(this, e, ViewEvents_getInstance().uo0_1);
  };
  protoOf(ViewContainer).wl5 = function (e) {
    executeCommand(this, ViewContainer$mouseDragged$lambda(this, e));
  };
  protoOf(ViewContainer).yl5 = function (e) {
    this.u3o().bnq();
    changeViewUnderMouse(this, e, this.u3o().enq(e.zl3()));
  };
  protoOf(ViewContainer).al6 = function (e) {
    this.u3o().bnq();
    changeViewUnderMouse(this, e, null);
  };
  protoOf(ViewContainer).kl5 = function (e) {
    dispatchFocusBasedEvent(this, e, ViewEvents_getInstance().eo1_1);
  };
  protoOf(ViewContainer).hl6 = function (e) {
    dispatchFocusBasedEvent(this, e, ViewEvents_getInstance().fo1_1);
  };
  protoOf(ViewContainer).ll5 = function (e) {
    dispatchFocusBasedEvent(this, e, ViewEvents_getInstance().go1_1);
  };
  protoOf(ViewContainer).gl6 = function (e) {
    dispatchFocusBasedEvent(this, e, ViewEvents_getInstance().ho1_1);
  };
  protoOf(ViewContainer).fl6 = function (e) {
    dispatchFocusBasedEvent(this, e, ViewEvents_getInstance().io1_1);
  };
  protoOf(ViewContainer).tmi = function (e) {
    dispatchFocusBasedEvent(this, e, ViewEvents_getInstance().jo1_1);
  };
  protoOf(ViewContainer).il6 = function (text) {
    var inductionVariable = 0;
    var last = text.length;
    while (inductionVariable < last) {
      var c = charSequenceGet(text, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      if (c === _Char___init__impl__6a9atx(10)) {
        this.kl5(KeyEvent_init_$Create$(Key_ENTER_getInstance(), _Char___init__impl__6a9atx(65535)));
      } else {
        this.ll5(KeyEvent_init_$Create$(Key_UNKNOWN_getInstance(), c));
      }
    }
  };
  protoOf(ViewContainer).rl6 = function () {
    this.tmi(new PasteEvent(ExternalPasteContent_instance));
  };
  protoOf(ViewContainer).ol6 = function (e) {
  };
  protoOf(ViewContainer).pl6 = function (e) {
  };
  protoOf(ViewContainer).ql6 = function (e) {
  };
  protoOf(ViewContainer).znx = function (view, prop, event) {
    this.cnw_1.a28(ViewContainer$propertyChanged$lambda(view, prop, event));
  };
  protoOf(ViewContainer).jnw = function (parent, event) {
    this.cnw_1.a28(ViewContainer$childAdded$lambda(parent, event));
  };
  protoOf(ViewContainer).lnw = function (parent, event) {
    this.cnw_1.a28(ViewContainer$childRemoved$lambda(parent, event));
  };
  protoOf(ViewContainer).jnz = function (view) {
    this.cnw_1.a28(ViewContainer$viewAttached$lambda(view));
  };
  protoOf(ViewContainer).jnx = function (view) {
    if (this.znv_1.m2c() === view) {
      this.znv_1.v2c(null);
    }
    this.cnw_1.a28(ViewContainer$viewDetached$lambda(view));
  };
  function ViewContainerListener() {
  }
  function ViewEventSpec(name) {
    this.to1_1 = name;
  }
  protoOf(ViewEventSpec).toString = function () {
    return this.to1_1;
  };
  function ViewEvents() {
    ViewEvents_instance = this;
    this.qo0_1 = new ViewEventSpec('mouseClicked');
    this.ro0_1 = new ViewEventSpec('mouseDoubleClicked');
    this.so0_1 = new ViewEventSpec('mousePressed');
    this.to0_1 = new ViewEventSpec('mouseReleased');
    this.uo0_1 = new ViewEventSpec('mouseMoved');
    this.vo0_1 = new ViewEventSpec('mouseDragged');
    this.wo0_1 = new ViewEventSpec('mouseEntered');
    this.xo0_1 = new ViewEventSpec('mouseLeft');
    this.yo0_1 = new ViewEventSpec('touchStarted');
    this.zo0_1 = new ViewEventSpec('touchLongTapped');
    this.ao1_1 = new ViewEventSpec('touchMoved');
    this.bo1_1 = new ViewEventSpec('touchDragged');
    this.co1_1 = new ViewEventSpec('touchEnded');
    this.do1_1 = new ViewEventSpec('popupRequested');
    this.eo1_1 = new ViewEventSpec('keyPressed');
    this.fo1_1 = new ViewEventSpec('keyReleased');
    this.go1_1 = new ViewEventSpec('keyTyped');
    this.ho1_1 = new ViewEventSpec('copy');
    this.io1_1 = new ViewEventSpec('cut');
    this.jo1_1 = new ViewEventSpec('paste');
  }
  var ViewEvents_instance;
  function ViewEvents_getInstance() {
    if (ViewEvents_instance == null)
      new ViewEvents();
    return ViewEvents_instance;
  }
  function ViewListener() {
  }
  function ViewPropertyKind$NONE() {
    ViewPropertyKind.call(this, 'NONE', 0);
    ViewPropertyKind_NONE_instance = this;
  }
  protoOf(ViewPropertyKind$NONE).ynx = function (view) {
  };
  var ViewPropertyKind_NONE_instance;
  function ViewPropertyKind$REPAINT() {
    ViewPropertyKind.call(this, 'REPAINT', 1);
    ViewPropertyKind_REPAINT_instance = this;
  }
  protoOf(ViewPropertyKind$REPAINT).ynx = function (view) {
    view.anq();
  };
  var ViewPropertyKind_REPAINT_instance;
  function ViewPropertyKind$RELAYOUT() {
    ViewPropertyKind.call(this, 'RELAYOUT', 2);
    ViewPropertyKind_RELAYOUT_instance = this;
  }
  protoOf(ViewPropertyKind$RELAYOUT).ynx = function (view) {
    view.s4u();
  };
  var ViewPropertyKind_RELAYOUT_instance;
  function ViewPropertyKind$RELAYOUT_AND_REPAINT() {
    ViewPropertyKind.call(this, 'RELAYOUT_AND_REPAINT', 3);
    ViewPropertyKind_RELAYOUT_AND_REPAINT_instance = this;
  }
  protoOf(ViewPropertyKind$RELAYOUT_AND_REPAINT).ynx = function (view) {
    view.anq();
    view.s4u();
  };
  var ViewPropertyKind_RELAYOUT_AND_REPAINT_instance;
  function ViewPropertyKind$RELAYOUT_PARENT() {
    ViewPropertyKind.call(this, 'RELAYOUT_PARENT', 4);
    ViewPropertyKind_RELAYOUT_PARENT_instance = this;
  }
  protoOf(ViewPropertyKind$RELAYOUT_PARENT).ynx = function (view) {
    var tmp0_safe_receiver = view.sno_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.s4u();
    }
  };
  var ViewPropertyKind_RELAYOUT_PARENT_instance;
  var ViewPropertyKind_entriesInitialized;
  function ViewPropertyKind_initEntries() {
    if (ViewPropertyKind_entriesInitialized)
      return Unit_instance;
    ViewPropertyKind_entriesInitialized = true;
    ViewPropertyKind_NONE_instance = new ViewPropertyKind$NONE();
    ViewPropertyKind_REPAINT_instance = new ViewPropertyKind$REPAINT();
    ViewPropertyKind_RELAYOUT_instance = new ViewPropertyKind$RELAYOUT();
    ViewPropertyKind_RELAYOUT_AND_REPAINT_instance = new ViewPropertyKind$RELAYOUT_AND_REPAINT();
    ViewPropertyKind_RELAYOUT_PARENT_instance = new ViewPropertyKind$RELAYOUT_PARENT();
  }
  function ViewPropertyKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ViewPropertyKind_NONE_getInstance() {
    ViewPropertyKind_initEntries();
    return ViewPropertyKind_NONE_instance;
  }
  function ViewPropertyKind_REPAINT_getInstance() {
    ViewPropertyKind_initEntries();
    return ViewPropertyKind_REPAINT_instance;
  }
  function ViewPropertyKind_RELAYOUT_getInstance() {
    ViewPropertyKind_initEntries();
    return ViewPropertyKind_RELAYOUT_instance;
  }
  function ViewPropertyKind_RELAYOUT_AND_REPAINT_getInstance() {
    ViewPropertyKind_initEntries();
    return ViewPropertyKind_RELAYOUT_AND_REPAINT_instance;
  }
  function ViewPropertyKind_RELAYOUT_PARENT_getInstance() {
    ViewPropertyKind_initEntries();
    return ViewPropertyKind_RELAYOUT_PARENT_instance;
  }
  function ViewPropertySpec_init_$Init$(name, kind, defaultValue, $this) {
    ViewPropertySpec.call($this, name, kind, ViewPropertySpec$_init_$lambda_8zh9pm(defaultValue));
    return $this;
  }
  function ViewPropertySpec_init_$Create$(name, kind, defaultValue) {
    return ViewPropertySpec_init_$Init$(name, kind, defaultValue, objectCreate(protoOf(ViewPropertySpec)));
  }
  function ViewPropertySpec$_init_$lambda_8zh9pm($defaultValue) {
    return function (it) {
      return $defaultValue;
    };
  }
  function ViewPropertySpec(name, kind, defaultValue) {
    kind = kind === VOID ? ViewPropertyKind_NONE_getInstance() : kind;
    this.tnx_1 = name;
    this.unx_1 = kind;
    this.vnx_1 = defaultValue;
  }
  protoOf(ViewPropertySpec).pnz = function (view) {
    return this.vnx_1(view);
  };
  protoOf(ViewPropertySpec).toString = function () {
    return this.tnx_1;
  };
  function createPropertySpec(name, kind) {
    return new ViewPropertySpec(name, kind, createPropertySpec$lambda);
  }
  function createPropertySpec_0(name) {
    return new ViewPropertySpec(name, VOID, createPropertySpec$lambda_0);
  }
  function createPropertySpec$lambda(it) {
    return null;
  }
  function createPropertySpec$lambda_0(it) {
    return null;
  }
  function access$_get_parent__alxd0f($this) {
    return $this.knz_1;
  }
  function Companion_334() {
    Companion_instance_334 = this;
    this.eo2_1 = false;
    this.fo2_1 = false;
    this.go2_1 = new CellToDomCss();
  }
  protoOf(Companion_334).x52 = function () {
    if (!this.fo2_1) {
      this.fo2_1 = true;
    }
    return this.go2_1;
  };
  protoOf(Companion_334).ho2 = function (fontWidthCalculator) {
    if (this.eo2_1)
      return Unit_instance;
    StyleInjector_getInstance().dl0();
    var width = fontWidthCalculator();
    StyleInjector_getInstance().cl0('.' + this.go2_1.mo2_1 + '{ padding-left: ' + width + 'px }');
    this.eo2_1 = true;
  };
  var Companion_instance_334;
  function Companion_getInstance_334() {
    if (Companion_instance_334 == null)
      new Companion_334();
    return Companion_instance_334;
  }
  function CellToDomCss() {
    Companion_getInstance_334();
    this.io2_1 = 'cell';
    this.jo2_1 = 'vertical';
    this.ko2_1 = 'rootContainer';
    this.lo2_1 = 'horizontal';
    this.mo2_1 = 'indented';
    this.no2_1 = 'hidden';
    this.oo2_1 = 'outlined';
    this.po2_1 = 'selected';
    this.qo2_1 = 'paired';
    this.ro2_1 = 'domCell';
    this.so2_1 = 'hasShadow';
    this.to2_1 = 'hasScroll';
    this.uo2_1 = 'userSelectable';
    this.vo2_1 = 'lineHighlight';
    this.wo2_1 = 'content';
    this.xo2_1 = 'fitContentWidth';
    this.yo2_1 = 'underlinedRed';
    this.zo2_1 = 'underlinedYellow';
    this.ao3_1 = 'underlinedBlue';
    this.bo3_1 = 'rgba(0, 0, 0, 0.2)';
    this.co3_1 = 'link';
    this.do3_1 = 'popup';
    this.eo3_1 = 'passThroughMouse';
    this.fo3_1 = 'tooltip';
    this.go3_1 = 'tooltipBottom';
    this.ho3_1 = 'tooltipTop';
    this.io3_1 = 'allowFlexWrap';
    this.jo3_1 = 'justifyContent';
  }
  function Companion_335() {
    Companion_instance_335 = this;
    this.ko3_1 = CellTraitPropertySpec_init_$Create$('userSelectable', false);
    this.lo3_1 = CellTraitPropertySpec_init_$Create$('captureFocus', false);
    this.mo3_1 = CellPropertySpec_init_$Create$('node', null);
  }
  var Companion_instance_335;
  function Companion_getInstance_335() {
    if (Companion_instance_335 == null)
      new Companion_335();
    return Companion_instance_335;
  }
  function DomCell() {
  }
  protoOf(DomCell).wo3 = function () {
    return this.vo3_1;
  };
  function forAlignment($this, sourceProperty, setProperty, clearProperty) {
    return bindStyle($this, asCssValue($this, sourceProperty), setProperty, clearProperty);
  }
  function asCssValue($this, alignmentProp) {
    return map_0(alignmentProp, AlignmentSynchronizers$asCssValue$lambda);
  }
  function bindStyle($this, stylePropertyValue, setProperty, clearProperty) {
    var tmp = PropertyBinding_instance;
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new AlignmentSynchronizers$bindStyle$$inlined$writableProperty$1(clearProperty, setProperty);
    return tmp.d2g(stylePropertyValue, tmp$ret$0);
  }
  function AlignmentSynchronizers$forCrossAlignment$lambda($target) {
    return function (item) {
      setAlignItems($target.style, item);
      return Unit_instance;
    };
  }
  function AlignmentSynchronizers$forCrossAlignment$lambda_0($target) {
    return function () {
      clearAlignItems($target.style);
      return Unit_instance;
    };
  }
  function AlignmentSynchronizers$forItemAlignment$lambda($target) {
    return function (item) {
      setSelfAlignment($target.style, item);
      return Unit_instance;
    };
  }
  function AlignmentSynchronizers$forItemAlignment$lambda_0($target) {
    return function () {
      clearSelfAlignment($target.style);
      return Unit_instance;
    };
  }
  function AlignmentSynchronizers$asCssValue$lambda(alignment) {
    var tmp;
    switch (alignment.a3_1) {
      case 0:
        tmp = CssAlignItem_STRETCH_getInstance();
        break;
      case 1:
        tmp = CssAlignItem_FLEX_START_getInstance();
        break;
      case 2:
        tmp = CssAlignItem_FLEX_END_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function AlignmentSynchronizers$bindStyle$$inlined$writableProperty$1($clearProperty, $setProperty) {
    this.xo3_1 = $clearProperty;
    this.yo3_1 = $setProperty;
  }
  protoOf(AlignmentSynchronizers$bindStyle$$inlined$writableProperty$1).bm7 = function (newValue) {
    var tmp;
    if (newValue == null) {
      tmp = this.xo3_1();
    } else {
      tmp = this.yo3_1(newValue);
    }
    return tmp;
  };
  protoOf(AlignmentSynchronizers$bindStyle$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function AlignmentSynchronizers() {
  }
  protoOf(AlignmentSynchronizers).zo3 = function (source, target) {
    var tmp = source.ylq();
    var tmp_0 = AlignmentSynchronizers$forCrossAlignment$lambda(target);
    return forAlignment(this, tmp, tmp_0, AlignmentSynchronizers$forCrossAlignment$lambda_0(target));
  };
  protoOf(AlignmentSynchronizers).ao4 = function (source, target) {
    var tmp = get_itemAlignment(source);
    var tmp_0 = AlignmentSynchronizers$forItemAlignment$lambda(target);
    return forAlignment(this, tmp, tmp_0, AlignmentSynchronizers$forItemAlignment$lambda_0(target));
  };
  var AlignmentSynchronizers_instance;
  function AlignmentSynchronizers_getInstance() {
    return AlignmentSynchronizers_instance;
  }
  function _get_targetList__52bhr0($this) {
    var tmp;
    if ($this.po4_1) {
      tmp = $this.qo4_1;
    } else {
      tmp = $this.mo4_1;
    }
    return tmp;
  }
  function _get_underlines__ft6cho($this) {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'jetbrains.ocelot.projectional.cell.dom.toDom.BaseCellToDomMapper.<get-underlines>.<anonymous>' call
    this_0.e(to($this.jly(), Companion_getInstance_337().to4_1.yo2_1));
    this_0.e(to($this.kly(), Companion_getInstance_337().to4_1.zo2_1));
    this_0.e(to($this.pl9_1.clo(get_LINK()) && $this.pl9_1.clo(get_HOVERED()), Companion_getInstance_337().to4_1.ao3_1));
    return this_0.e4();
  }
  function schedulePropertyRefresh($this) {
    return $this.ko4_1.ao5($this);
  }
  function applyStyle_0($this) {
    $this.bo5(Companion_getInstance_337().to4_1.oo2_1, $this.lly());
    $this.bo5(Companion_getInstance_337().to4_1.po2_1, $this.dly());
    $this.bo5(Companion_getInstance_337().to4_1.qo2_1, $this.pl9_1.clo(get_PAIR_HIGHLIGHTED()));
    $this.bo5(Companion_getInstance_337().to4_1.co3_1, $this.pl9_1.clo(get_LINK()));
    var backgroundColor = null;
    if ($this.jkb() && $this.hly()) {
      backgroundColor = Companion_getInstance_337().to4_1.bo3_1;
    } else if (!($this.ily() == null)) {
      backgroundColor = ensureNotNull($this.ily()).qnn();
    }
    setBackgroundColor_0($this, backgroundColor);
    setUnderline($this);
    updateBorder($this);
    $this.bo5(Companion_getInstance_337().to4_1.no2_1, !$this.pl9_1.clo(get_VISIBLE()));
    $this.bo5(Companion_getInstance_337().to4_1.so2_1, $this.pl9_1.clo(get_HAS_SHADOW()));
    $this.bo5(Companion_getInstance_337().to4_1.io3_1, $this.pl9_1.clo(Companion_getInstance_267().clr_1));
    $this.bo5(Companion_getInstance_337().to4_1.jo3_1, $this.pl9_1.clo(Companion_getInstance_267().dlr_1));
  }
  function updateBorder($this) {
    var style = $this.ql9_1.style;
    var border = get_border($this.pl9_1).qr();
    if (border == null) {
      clearBorderTop(style);
      clearBorderBottom(style);
      clearBorderLeft(style);
      clearBorderRight(style);
      clearOutline(style);
    } else {
      switch (border.slh_1.a3_1) {
        case 0:
          setBorderTop(style, Companion_instance_336.co5(border.tlh_1));
          setBorderBottom(style, Companion_instance_336.co5(border.ulh_1));
          style.borderLeft = Companion_instance_336.co5(border.vlh_1);
          setBorderRight(style, Companion_instance_336.co5(border.wlh_1));
          break;
        case 1:
          setOutline(style, Companion_instance_336.co5(border.tlh_1));
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
  }
  function setBackgroundColor_0($this, backgroundColor) {
    var style = $this.ql9_1.style;
    if (backgroundColor == null) {
      clearBackgroundColor(style);
    } else {
      setBackgroundColor(style, backgroundColor);
    }
  }
  function setUnderline($this) {
    var underlined = false;
    var _iterator__ex2g4s = _get_underlines__ft6cho($this).k();
    while (_iterator__ex2g4s.l()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.m();
      var first = _destruct__k2r9zo.ug();
      var second = _destruct__k2r9zo.vg();
      if (!underlined && first) {
        addClassName($this.ql9_1, second);
        underlined = true;
      } else {
        removeClassName($this.ql9_1, second);
      }
    }
  }
  function Companion_336() {
  }
  protoOf(Companion_336).co5 = function (side) {
    var width = side.ylh_1.toString();
    var color = side.xlh_1.qnn();
    return width + 'px ' + color + ' solid';
  };
  var Companion_instance_336;
  function Companion_getInstance_336() {
    return Companion_instance_336;
  }
  function BaseCellToDomMapper$createPopupManager$1(this$0) {
    this.io5_1 = this$0;
    DomPopupManager.call(this, this$0.ko4_1);
  }
  protoOf(BaseCellToDomMapper$createPopupManager$1).pmq = function () {
    return this.io5_1.bld();
  };
  function BaseCellToDomMapper(source, context, target) {
    BaseCellMapper.call(this, source, target);
    this.ko4_1 = context;
    this.lo4_1 = null;
    this.mo4_1 = null;
    this.no4_1 = null;
    this.oo4_1 = false;
    this.po4_1 = false;
    this.qo4_1 = null;
    this.ro4_1 = null;
  }
  protoOf(BaseCellToDomMapper).ro5 = function (placeholder) {
    if (this.po4_1 === placeholder) {
      return Unit_instance;
    }
    this.po4_1 = placeholder;
    var style = this.ql9_1.style;
    if (this.po4_1) {
      var bounds = Scrolling_instance.to5(this.ql9_1);
      if (this.so5()) {
        this.qo4_1 = ArrayList_init_$Create$_1(ensureNotNull(this.mo4_1));
        ensureNotNull(this.mo4_1).m2();
      }
      setWidth(style, bounds.dku_1.eku_1);
      setHeight(style, bounds.dku_1.fku_1);
    } else {
      if (this.so5()) {
        ensureNotNull(this.mo4_1).o(ensureNotNull(this.qo4_1));
        this.qo4_1 = null;
      }
      clearWidth(style);
      clearHeight(style);
    }
  };
  protoOf(BaseCellToDomMapper).so5 = function () {
    return true;
  };
  protoOf(BaseCellToDomMapper).uo5 = function () {
    return true;
  };
  protoOf(BaseCellToDomMapper).zlc = function (ctx) {
    protoOf(BaseCellMapper).zlc.call(this, ctx);
    this.ko4_1.aml(this);
    this.no4_1 = this.vo5();
    ensureNotNull(this.no4_1).tmq(this.pl9_1);
    this.oo4_1 = Composites_instance.j2r(this.pl9_1);
    this.pl9_1.bln(Companion_getInstance_337().so4_1, this.ql9_1);
    addClassName(this.ql9_1, Companion_getInstance_337().to4_1.io2_1);
    if (this.so5()) {
      this.lo4_1 = this.lla();
      this.mo4_1 = DomUtil_instance.rkv(this.ql9_1);
      this.nly();
    }
    if (this.pl9_1.ulp(Hints_getInstance().plq_1)) {
      this.ro4_1 = this.ko4_1.wo5(this);
    }
    schedulePropertyRefresh(this);
    this.xo5();
  };
  protoOf(BaseCellToDomMapper).nla = function () {
    this.pl9_1.flp(Companion_getInstance_337().so4_1).t2c(null);
    removeClassName(this.ql9_1, Companion_getInstance_337().to4_1.io2_1);
    if (this.oo4_1) {
      removeFromParent(this.ql9_1);
    }
    ensureNotNull(this.no4_1).vr();
    this.ko4_1.bml(this);
    if (!(this.ro4_1 == null)) {
      ensureNotNull(this.ro4_1).vr();
    }
    protoOf(BaseCellMapper).nla.call(this);
  };
  protoOf(BaseCellToDomMapper).llb = function (conf) {
    protoOf(BaseCellMapper).llb.call(this, conf);
    conf.x4v(AlignmentSynchronizers_instance.ao4(this.pl9_1, this.ql9_1));
  };
  protoOf(BaseCellToDomMapper).yo5 = function (child) {
    return this.ko4_1.zo5(child);
  };
  protoOf(BaseCellToDomMapper).oly = function (index, child) {
    if (!this.so5())
      return Unit_instance;
    var mapper = this.yo5(child);
    ensureNotNull(_get_targetList__52bhr0(this)).p2(index, mapper.ql9_1);
    ensureNotNull(this.lo4_1).p2(index, mapper);
    this.xo5();
  };
  protoOf(BaseCellToDomMapper).ao6 = function (index) {
    if (!this.so5())
      return Unit_instance;
    ensureNotNull(this.lo4_1).q2(index);
    ensureNotNull(_get_targetList__52bhr0(this)).q2(index);
    this.xo5();
  };
  protoOf(BaseCellToDomMapper).umq = function (event) {
    return ensureNotNull(this.no4_1).d28(event);
  };
  protoOf(BaseCellToDomMapper).d28 = function (event) {
    return this.umq(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  protoOf(BaseCellToDomMapper).bo6 = function (prop, change) {
    if (this.ul9_1 == null)
      return Unit_instance;
    var tmp = this.ul9_1;
    ensureNotNull((tmp instanceof BaseCellToDomMapper ? tmp : THROW_CCE()).no4_1).vmq(this.pl9_1, prop, change);
  };
  protoOf(BaseCellToDomMapper).co6 = function () {
    this.xo5();
    applyStyle_0(this);
  };
  protoOf(BaseCellToDomMapper).xo5 = function () {
    return this.ko4_1.do6(this);
  };
  protoOf(BaseCellToDomMapper).eo6 = function () {
    if (this.po4_1) {
      this.ro5(false);
      this.ro5(true);
    }
  };
  protoOf(BaseCellToDomMapper).bo5 = function (cssStyle, apply) {
    var tmp;
    if (apply) {
      addClassName(this.ql9_1, cssStyle);
      tmp = Unit_instance;
    } else {
      removeClassName(this.ql9_1, cssStyle);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(BaseCellToDomMapper).vo5 = function () {
    return new BaseCellToDomMapper$createPopupManager$1(this);
  };
  function getBaseBounds($this, cell) {
    var mapper = getMapper($this.fo6_1, cell);
    var tmp;
    if (mapper == null) {
      var tmp_0;
      if (cell instanceof NewLineCell) {
        tmp_0 = null;
      } else {
        if (cell instanceof IndentCell) {
          var tmp_1 = getMapper($this.fo6_1, cell.rmj());
          var indentMapper = tmp_1 instanceof IndentRootCellMapper ? tmp_1 : THROW_CCE();
          tmp_0 = indentMapper.dlj(cell);
        } else {
          throw IllegalStateException_init_$Create$_0("Can't find a mapper for " + toString_1(cell));
        }
      }
      tmp = tmp_0;
    } else {
      revealParents($this, cell);
      var target = getElement($this.fo6_1, cell);
      var tmp_2;
      if (cell instanceof ScrollCell) {
        var tmp_3 = DomUtil_getInstance_0();
        tmp_2 = tmp_3.lo6(target instanceof HTMLElement ? target : THROW_CCE());
      } else {
        tmp_2 = DomUtil_getInstance_0().ko6(ensureNotNull(target));
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function revealParents($this, cell) {
    var mapper = ensureNotNull(getMapper($this.fo6_1, cell));
    $l$loop: while (true) {
      mapper.ro5(false);
      var mapperParent = mapper.ul9_1;
      if (mapperParent instanceof BaseCellToDomMapper) {
        mapper = mapperParent;
      } else {
        break $l$loop;
      }
    }
  }
  function CellContainerToDomMapper$createCellContainerPeer$o$scrollToAsync$lambda($rectSupplier, this$0, $cell, $async) {
    return function () {
      var tmp;
      try {
        Scrolling_instance.go7($rectSupplier(), ensureNotNull(getElement(this$0, $cell)));
        $async.n2l(Unit_instance);
        tmp = Unit_instance;
      } catch ($p) {
        var tmp_0;
        if ($p instanceof RuntimeException) {
          var e = $p;
          $async.o2l(e);
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function CellContainerToDomMapper$registerListeners$o$onEvent$lambda(this$0, $newValue) {
    return function () {
      var rootOrigin = get_origin_0(this$0.pl9_1.u3o());
      var cellOrigin = get_origin_0($newValue);
      var padding = DomUtil_getInstance_0().ho7(this$0.ql9_1);
      var cellRelativeOrigin = cellOrigin.kku(rootOrigin).jku(padding);
      _get_cellToDomContext__dsuw81(this$0).zo4_1.mo7(cellRelativeOrigin.eku_1, cellRelativeOrigin.fku_1);
      return Unit_instance;
    };
  }
  function _get_cellToDomContext__dsuw81($this) {
    var tmp = $this.co8_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('cellToDomContext');
    }
  }
  function _get_rootMapper__je6z14($this) {
    var tmp = $this.do8_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('rootMapper');
    }
  }
  function refreshHideable($this) {
    $this.vo7_1.ko8();
  }
  function createRootMapper($this, source) {
    return CellMappers_instance.lo8(source, _get_cellToDomContext__dsuw81($this), $this.uo7_1);
  }
  function findCellFor($this, element) {
    var result = _get_cellToDomContext__dsuw81($this).cml(element);
    if (!(result == null))
      return result.pl9_1;
    var tmp0_elvis_lhs = element.parentElement;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    return findCellFor($this, parent);
  }
  function getMapper($this, cell) {
    var descendantMapper = _get_rootMapper__je6z14($this).rlc(cell);
    return (descendantMapper == null ? true : descendantMapper instanceof BaseCellToDomMapper) ? descendantMapper : THROW_CCE();
  }
  function getElement($this, cell) {
    var $this_0 = $this;
    var cell_0 = cell;
    $l$1: do {
      $l$0: do {
        if (cell_0 == null)
          return null;
        var mapper = getMapper($this_0, cell_0);
        var tmp;
        if (!(mapper == null)) {
          tmp = mapper.ql9_1;
        } else {
          var parentCell = cell_0.yt();
          var tmp_0;
          if (parentCell == null) {
            tmp_0 = null;
          } else {
            $this_0 = $this_0;
            cell_0 = parentCell;
            continue $l$0;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function createCellContainerPeer($this) {
    return new CellContainerToDomMapper$createCellContainerPeer$1($this);
  }
  function registerListeners($this) {
    var reg = new CompositeDisposable([]);
    var mouseTranslator = new CellContainerToDomMapper$registerListeners$mouseTranslator$1($this);
    reg.ur([mouseTranslator.bl6()]);
    reg.ur([_get_cellToDomContext__dsuw81($this).zo4_1.mo8($this.pl9_1)]);
    var tmp = $this.pl9_1.rlp();
    reg.ur([tmp.o27(new CellContainerToDomMapper$registerListeners$1($this))]);
    return reg;
  }
  function isDomCellEvent($this, event) {
    var target = $this.pl9_1.mlq($this.pl9_1.u3o(), event.zl3());
    return target instanceof DomCell;
  }
  function isContainerEvent($this, event) {
    var root = $this.pl9_1.u3o();
    if (get_bounds(root).mku(event.zl3())) {
      return true;
    }
    var target = $this.pl9_1.mlq(root, event.zl3());
    return !(target == null) && equals(target.llk(), $this.pl9_1);
  }
  function Companion_337() {
    Companion_instance_337 = this;
    this.so4_1 = CellPropertySpec_init_$Create$('element', null);
    this.to4_1 = Companion_getInstance_334().x52();
  }
  var Companion_instance_337;
  function Companion_getInstance_337() {
    if (Companion_instance_337 == null)
      new Companion_337();
    return Companion_instance_337;
  }
  function CellContainerToDomMapper$getElement$ref($boundThis) {
    var l = function (p0) {
      return getElement($boundThis, p0);
    };
    l.callableName = 'getElement';
    return l;
  }
  function CellContainerToDomMapper$onAttach$lambda(this$0, $window) {
    return function (it) {
      this$0.zo7_1 = $window.scrollX;
      this$0.ao8_1 = $window.scrollY;
      return true;
    };
  }
  function CellContainerToDomMapper$onAttach$lambda_0(this$0) {
    return function () {
      refreshHideable(this$0);
      return this$0.qlc();
    };
  }
  function CellContainerToDomMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.no8_1 = this$0;
  }
  protoOf(CellContainerToDomMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    if (newValue == null) {
      this.no8_1.xo7_1.innerHTML = '';
    } else {
      this.no8_1.xo7_1.appendChild(newValue);
    }
    return Unit_instance;
  };
  protoOf(CellContainerToDomMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function CellContainerToDomMapper$createRootMapper$ref($boundThis) {
    var l = function (p0) {
      return createRootMapper($boundThis, p0);
    };
    l.callableName = 'createRootMapper';
    return l;
  }
  function CellContainerToDomMapper$registerSynchronizers$2(this$0) {
    this.oo8_1 = this$0;
  }
  protoOf(CellContainerToDomMapper$registerSynchronizers$2).blq = function (cell, prop, change) {
    if (prop === Companion_getInstance_337().so4_1)
      return Unit_instance;
    var mapper = getMapper(this.oo8_1, cell);
    if (!(mapper == null)) {
      if (isPopupProp(prop)) {
        if (mapper.uo5()) {
          var propertyChangeEvent = change instanceof PropertyChangeEvent ? change : THROW_CCE();
          mapper.umq(propertyChangeEvent);
        }
      } else {
        this.oo8_1.vo7_1.ao5(mapper);
        if (get_isPopup(cell) && mapper.uo5()) {
          mapper.bo6(prop, change);
        }
      }
    }
  };
  protoOf(CellContainerToDomMapper$registerSynchronizers$2).clq = function (parent, change) {
    var tmp0_elvis_lhs = getMapper(this.oo8_1, parent);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var mapper = tmp;
    mapper.oly(change.g27_1, change.k27());
  };
  protoOf(CellContainerToDomMapper$registerSynchronizers$2).dlq = function (parent, change) {
    var tmp0_elvis_lhs = getMapper(this.oo8_1, parent);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var mapper = tmp;
    mapper.ao6(change.g27_1);
  };
  function CellContainerToDomMapper$createCellContainerPeer$1(this$0) {
    this.fo6_1 = this$0;
  }
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).glq = function (tv, x) {
    var tmp = getMapper(this.fo6_1, tv);
    var tmp0_elvis_lhs = (tmp == null ? true : tmp instanceof TextCellMapper) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0("Can't find a mapper for " + tv.toString());
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var textMapper = tmp_0;
    return textMapper.slu(x);
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).hlq = function (tv, caret) {
    var tmp = getMapper(this.fo6_1, tv);
    var tmp0_elvis_lhs = (tmp == null ? true : tmp instanceof TextCellMapper) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0("Can't find a mapper for " + tv.toString());
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var textMapper = tmp_0;
    return textMapper.flu(caret);
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).ilq = function (cell) {
    var tmp0_elvis_lhs = getBaseBounds(this, cell);
    return tmp0_elvis_lhs == null ? Companion_getInstance_250().hku_1 : tmp0_elvis_lhs;
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).jlq = function (cell) {
    var target = getElement(this.fo6_1, cell);
    return new Vector(numberToInt(ensureNotNull(target).scrollLeft), numberToInt(target.scrollTop));
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).klq = function (cell, offset) {
    var target = ensureNotNull(getElement(this.fo6_1, cell));
    target.scrollLeft = offset.eku_1;
    target.scrollTop = offset.fku_1;
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).tlp = function (rectSupplier, cell) {
    var async = new SimpleAsync();
    var tmp = DomImmediatePolyfill_getInstance();
    tmp.ykz(CellContainerToDomMapper$createCellContainerPeer$o$scrollToAsync$lambda(rectSupplier, this.fo6_1, cell, async));
    return async;
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).mlq = function (root, loc) {
    var tmp0_elvis_lhs = DomApi_instance.lkx().elementFromPoint(loc.eku_1 - this.fo6_1.zo7_1, loc.fku_1 - this.fo6_1.ao8_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var element = tmp;
    var tmp1_elvis_lhs = findCellFor(this.fo6_1, element);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var result = tmp_0;
    var tmp_1;
    if (isDescendant(root, result)) {
      tmp_1 = result;
    } else {
      tmp_1 = null;
    }
    return tmp_1;
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).nlq = function (cell) {
    var element = getElement(this.fo6_1, cell);
    var tmp0_elvis_lhs = DomUtil_getInstance_0().jo9(ensureNotNull(element));
    return tmp0_elvis_lhs == null ? Rectangle_init_$Create$(0, 0, 0, 0) : tmp0_elvis_lhs;
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).elq = function () {
    return JsEventDispatchThread_getInstance();
  };
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).flq = function () {
    return JsSystemClipboard_instance;
  };
  function CellContainerToDomMapper$registerListeners$mouseTranslator$1(this$0) {
    this.mo9_1 = this$0;
    MouseTranslator.call(this, this$0.ql9_1, this$0.pl9_1);
  }
  protoOf(CellContainerToDomMapper$registerListeners$mouseTranslator$1).rl5 = function (e) {
    return !isContainerEvent(this.mo9_1, e) || isDomCellEvent(this.mo9_1, e);
  };
  protoOf(CellContainerToDomMapper$registerListeners$mouseTranslator$1).zl5 = function (e) {
    return isDomCellEvent(this.mo9_1, e);
  };
  protoOf(CellContainerToDomMapper$registerListeners$mouseTranslator$1).ul5 = function () {
    var textInput = _get_cellToDomContext__dsuw81(this.mo9_1).zo4_1;
    if (!textInput.oo9().qr()) {
      textInput.no9();
    }
  };
  function CellContainerToDomMapper$registerListeners$1(this$0) {
    this.qo9_1 = this$0;
    this.po9_1 = Companion_getInstance_25().wr_1;
  }
  protoOf(CellContainerToDomMapper$registerListeners$1).umq = function (event) {
    this.po9_1.vr();
    var newValue = event.p2e_1;
    if (newValue == null) {
      this.po9_1 = Companion_getInstance_25().wr_1;
      return Unit_instance;
    }
    var tmp = this;
    var tmp_0 = DomUtil_getInstance_0();
    tmp.po9_1 = tmp_0.ro9(CellContainerToDomMapper$registerListeners$o$onEvent$lambda(this.qo9_1, newValue));
  };
  protoOf(CellContainerToDomMapper$registerListeners$1).d28 = function (event) {
    return this.umq(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  function CellContainerToDomMapper(source, target, config, extensionViewMapperFactories) {
    Companion_getInstance_337();
    config = config === VOID ? new CellToDomConfig() : config;
    extensionViewMapperFactories = extensionViewMapperFactories === VOID ? emptyList() : extensionViewMapperFactories;
    Mapper.call(this, source, target);
    this.uo7_1 = extensionViewMapperFactories;
    this.vo7_1 = new CellMapperRefresher(config.vo9_1, config.xo9());
    this.wo7_1 = config.yo9();
    this.yo7_1 = config.zo9();
    this.zo7_1 = 0.0;
    this.ao8_1 = 0.0;
    this.bo8_1 = null;
    Companion_getInstance_334().ho2(x$factory(TextMetricsCalculator_getInstance().eoa(Companion_getInstance_271().zlr_1, 'xx').foa()));
    this.xo7_1 = DomApi_instance.nkx();
    addClassName(this.xo7_1, Companion_getInstance_337().to4_1.wo2_1);
    if (config.hoa()) {
      addClassName(this.xo7_1, config.goa());
    }
  }
  protoOf(CellContainerToDomMapper).wlc = function (ctx) {
    protoOf(Mapper).wlc.call(this, ctx);
    this.co8_1 = new CellToDomContext(this.ql9_1, this.vo7_1, this.yo7_1, this.uo7_1);
  };
  protoOf(CellContainerToDomMapper).zlc = function (ctx) {
    protoOf(Mapper).zlc.call(this, ctx);
    var peer = createCellContainerPeer(this);
    this.pl9_1.nmg(peer);
    var tmp = this.rlc(this.pl9_1.u3o());
    var descendantMapper = tmp instanceof Mapper ? tmp : THROW_CCE();
    this.do8_1 = descendantMapper;
    setTabIndex(this.ql9_1, 0);
    addClassName(this.ql9_1, Companion_getInstance_337().to4_1.ko2_1);
    var tmp_0 = peer.elq();
    this.wo7_1.ioa(this.ql9_1, tmp_0, CellContainerToDomMapper$getElement$ref(this), scrollWidth$factory(this.xo7_1));
    this.ql9_1.appendChild(this.xo7_1);
    var window_0 = DomApi_instance.mkx();
    this.zo7_1 = window_0.scrollX;
    this.ao8_1 = window_0.scrollY;
    var runner = CellContainerToDomMapper$onAttach$lambda(this, window_0);
    this.bo8_1 = on(window_0, Companion_getInstance_254().gkz_1, runner);
    var tmp_1 = Companion_getInstance_31().k2n_1;
    tmp_1.d2o(100, CellContainerToDomMapper$onAttach$lambda_0(this));
  };
  protoOf(CellContainerToDomMapper).nla = function () {
    protoOf(Mapper).nla.call(this);
    this.pl9_1.xmi();
    removeClassName(this.ql9_1, Companion_getInstance_337().to4_1.ko2_1);
    removeFromParent(this.xo7_1);
    this.wo7_1.vr();
    ensureNotNull(this.bo8_1).vr();
    _get_cellToDomContext__dsuw81(this).vr();
  };
  protoOf(CellContainerToDomMapper).llb = function (conf) {
    protoOf(Mapper).llb.call(this, conf);
    var tmp = Synchronizers_instance;
    var tmp_0 = this.pl9_1.u3o();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp_1 = new CellContainerToDomMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.x4v(tmp.ole(tmp_0, tmp_1, CellContainerToDomMapper$createRootMapper$ref(this)));
    conf.x4v(this.pl9_1.wmi(new CellContainerToDomMapper$registerSynchronizers$2(this)));
    if (!this.yo7_1) {
      conf.x4v(registerListeners(this));
    }
  };
  function x$factory($b0) {
    return getPropertyCallableRef('x', 0, KProperty0, function () {
      return $b0.skt_1;
    }, null);
  }
  function scrollWidth$factory($b0) {
    return getPropertyCallableRef('scrollWidth', 0, KProperty0, function () {
      return $b0.scrollWidth;
    }, null);
  }
  function _get_loadableRect__lsn5h5($this) {
    return scale($this, Scrolling_instance.joa(), $this.eo8_1);
  }
  function requestRefresh($this) {
    if ($this.jo8_1)
      return Unit_instance;
    $this.jo8_1 = true;
    $this.fo8_1(CellMapperRefresher$requestRefresh$lambda($this));
  }
  function updateHideable($this) {
    var visible = _get_loadableRect__lsn5h5($this);
    var _iterator__ex2g4s = $this.io8_1.k();
    while (_iterator__ex2g4s.l()) {
      var m = _iterator__ex2g4s.m();
      var bounds = Scrolling_instance.to5(m.ql9_1);
      m.ro5(!visible.qku(bounds));
    }
  }
  function scale($this, r, c) {
    var origin = r.cku_1;
    var dimension = r.dku_1;
    var g = (c - 1.0) / 2;
    return new Rectangle(origin.kku(new Vector(numberToInt(dimension.eku_1 * g), numberToInt(dimension.fku_1 * g))), new Vector(numberToInt(dimension.eku_1 * c), numberToInt(dimension.fku_1 * c)));
  }
  function Companion_338() {
    this.koa_1 = true;
  }
  var Companion_instance_338;
  function Companion_getInstance_338() {
    return Companion_instance_338;
  }
  function CellMapperRefresher$prepareFrame$lambda(it) {
    var tmp = DomApi_instance.mkx();
    return tmp.requestAnimationFrame(CellMapperRefresher$prepareFrame$lambda$lambda(it));
  }
  function CellMapperRefresher$prepareFrame$lambda$lambda($it) {
    return function (it) {
      $it();
      return Unit_instance;
    };
  }
  function CellMapperRefresher$prepareFrame$lambda_0(it) {
    it();
    return Unit_instance;
  }
  function CellMapperRefresher$requestRefresh$lambda(this$0) {
    return function () {
      var _iterator__ex2g4s = this$0.ho8_1.k();
      while (_iterator__ex2g4s.l()) {
        var m = _iterator__ex2g4s.m();
        m.co6();
      }
      this$0.ho8_1.m2();
      var _iterator__ex2g4s_0 = this$0.go8_1.k();
      while (_iterator__ex2g4s_0.l()) {
        var m_0 = _iterator__ex2g4s_0.m();
        m_0.eo6();
      }
      this$0.go8_1.m2();
      this$0.jo8_1 = false;
      return Unit_instance;
    };
  }
  function CellMapperRefresher$registerHideable$$inlined$toDisposable$1(this$0, $mapper) {
    this.loa_1 = this$0;
    this.moa_1 = $mapper;
  }
  protoOf(CellMapperRefresher$registerHideable$$inlined$toDisposable$1).vr = function () {
    this.loa_1.io8_1.k2(this.moa_1);
    return Unit_instance;
  };
  function CellMapperRefresher(visibilityExpansion, requestAnimationFrame) {
    this.eo8_1 = visibilityExpansion;
    var tmp = this;
    var tmp_0;
    if (requestAnimationFrame) {
      tmp_0 = CellMapperRefresher$prepareFrame$lambda;
    } else {
      tmp_0 = CellMapperRefresher$prepareFrame$lambda_0;
    }
    tmp.fo8_1 = tmp_0;
    this.go8_1 = HashSet_init_$Create$();
    this.ho8_1 = HashSet_init_$Create$();
    this.io8_1 = HashSet_init_$Create$();
    this.jo8_1 = false;
  }
  protoOf(CellMapperRefresher).wo5 = function (mapper) {
    if (false) {
      return Companion_getInstance_25().wr_1;
    }
    this.io8_1.e(mapper);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new CellMapperRefresher$registerHideable$$inlined$toDisposable$1(this, mapper);
  };
  protoOf(CellMapperRefresher).ao5 = function (mapper) {
    this.ho8_1.e(mapper);
    requestRefresh(this);
  };
  protoOf(CellMapperRefresher).do6 = function (mapper) {
    var $this = this;
    var mapper_0 = mapper;
    $l$1: do {
      $l$0: do {
        requestRefresh($this);
        if (mapper_0.po4_1) {
          $this.go8_1.e(mapper_0);
        }
        var mapperParent = mapper_0.ul9_1;
        if (mapperParent instanceof BaseCellToDomMapper) {
          $this = $this;
          mapper_0 = mapperParent;
          continue $l$0;
        }
        break $l$1;
      }
       while (false);
    }
     while (true);
  };
  protoOf(CellMapperRefresher).ko8 = function () {
    updateHideable(this);
  };
  function IndentRootCellMapper$_init_$ref_ys71v8() {
    var l = function (p0, p1) {
      return new IndentRootCellMapper(p0, p1);
    };
    l.callableName = '<init>';
    return l;
  }
  function CellMappers() {
  }
  protoOf(CellMappers).lo8 = function (source, ctx, extensionViewMapperFactories) {
    var tmp;
    if (source instanceof TextCell) {
      tmp = new TextCellMapper(source, ctx);
    } else {
      if (source instanceof HorizontalCell) {
        tmp = new HorizontalCellMapper(source, ctx);
      } else {
        if (source instanceof VerticalCell) {
          tmp = new VerticalCellMapper(source, ctx);
        } else {
          if (source instanceof ScrollCell) {
            tmp = new ScrollCellMapper(source, ctx);
          } else {
            if (source instanceof ImageCell) {
              tmp = new ImageCellMapper(source, ctx);
            } else {
              if (source instanceof IndentCell) {
                var tmp_0 = CellMapperUtils_instance;
                tmp = tmp_0.dml(source, ctx, IndentRootCellMapper$_init_$ref_ys71v8());
              } else {
                if (get_isRootCell(source)) {
                  tmp = new RootCellMapper(source, ctx);
                } else {
                  if (source instanceof DomCell) {
                    tmp = new DomCellMapper(source, ctx);
                  } else {
                    if (source instanceof ViewCell) {
                      tmp = new ViewCellMapper(source, ctx, extensionViewMapperFactories);
                    } else {
                      if (source instanceof TextPlaceholderCell) {
                        tmp = new TextPlaceholderCellMapper(source, ctx);
                      } else {
                        tmp = new DefaultCellMapper(source, ctx);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  };
  var CellMappers_instance;
  function CellMappers_getInstance() {
    return CellMappers_instance;
  }
  function CellToDomConfig() {
    this.so9_1 = false;
    this.to9_1 = true;
    this.uo9_1 = Companion_getInstance_342().noa_1;
    this.vo9_1 = 1.4;
    this.wo9_1 = null;
  }
  protoOf(CellToDomConfig).zo9 = function () {
    return this.so9_1;
  };
  protoOf(CellToDomConfig).xo9 = function () {
    return this.to9_1;
  };
  protoOf(CellToDomConfig).yo9 = function () {
    return this.uo9_1;
  };
  protoOf(CellToDomConfig).hoa = function () {
    return !(this.wo9_1 == null);
  };
  protoOf(CellToDomConfig).goa = function () {
    var tmp0_elvis_lhs = this.wo9_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Content class is not set');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(CellToDomConfig).ooa = function (eventDisabled) {
    this.so9_1 = eventDisabled;
  };
  protoOf(CellToDomConfig).poa = function (requestAnimationFrame) {
    this.to9_1 = requestAnimationFrame;
  };
  protoOf(CellToDomConfig).qoa = function (lineHighlight) {
    this.uo9_1 = lineHighlight;
  };
  function CellToDomContext(rootElement, cellMapperRefresher, isEventsDisabled, extensionViewMapperFactories) {
    CellMapperContext.call(this, rootElement);
    this.wo4_1 = cellMapperRefresher;
    this.xo4_1 = isEventsDisabled;
    this.yo4_1 = extensionViewMapperFactories;
    this.zo4_1 = new DomTextInput(rootElement);
  }
  protoOf(CellToDomContext).zo5 = function (cell) {
    return CellMappers_instance.lo8(cell, this, this.yo4_1);
  };
  protoOf(CellToDomContext).ao5 = function (mapper) {
    this.wo4_1.ao5(mapper);
  };
  protoOf(CellToDomContext).do6 = function (mapper) {
    this.wo4_1.do6(mapper);
  };
  protoOf(CellToDomContext).wo5 = function (mapper) {
    return this.wo4_1.wo5(mapper);
  };
  protoOf(CellToDomContext).vr = function () {
    this.zo4_1.vr();
  };
  function DefaultCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.nkx());
    setColor(this.ql9_1.style, 'red');
    this.ql9_1.innerText = "Can't create a mapper for '" + getKClassFromExpression(source).lb() + "'";
  }
  function _get_edt__e67mgs_0($this) {
    var tmp = $this.uoa_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('edt');
    }
  }
  function _get_lineElement__ck1iy1($this) {
    var activeCell = $this.roa_1.qr();
    var tmp;
    var tmp_0;
    var tmp_1;
    if (activeCell == null) {
      tmp_1 = true;
    } else {
      tmp_1 = activeCell instanceof DomCell;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = !Cells_getInstance().kmx(activeCell);
    }
    if (tmp_0) {
      tmp = null;
    } else {
      tmp = ensureNotNull($this.toa_1)(activeCell);
    }
    return tmp;
  }
  function invalidate($this) {
    $this.woa_1 = false;
    var tmp = _get_edt__e67mgs_0($this);
    var tmp_0 = DefaultLineHighlight$invalidate$lambda($this);
    tmp.v2m(0, new sam$jetbrains_ocelot_base_edt_EdtTask$0_18(tmp_0));
  }
  function refresh_0($this) {
    if ($this.woa_1)
      return Unit_instance;
    shutdownContentHandler($this);
    cancelDelayedUpdate($this);
    var lineElement = _get_lineElement__ck1iy1($this);
    if (lineElement == null) {
      hideHighlight($this);
      $this.aob_1 = null;
    } else {
      var newLayout = calculateLayout($this, lineElement);
      if (!newLayout.equals($this.aob_1)) {
        showHighlight($this, newLayout);
        $this.aob_1 = newLayout;
      }
      setupContentHandler($this);
      scheduleDelayedUpdate($this);
    }
    $this.woa_1 = true;
  }
  function hideHighlight($this) {
    setVisibility($this.soa_1.style, CssVisibility_HIDDEN_getInstance());
  }
  function showHighlight($this, layout) {
    var style = $this.soa_1.style;
    setVisibility(style, CssVisibility_VISIBLE_getInstance());
    setTop(style, layout.bob_1);
    setHeight(style, layout.cob_1);
    setWidth(style, layout.dob_1);
  }
  function calculateLayout($this, lineElement) {
    var owner = $this.soa_1.parentElement;
    var top = getAbsoluteTop(lineElement) - getAbsoluteTop(ensureNotNull(owner)) + owner.scrollTop;
    var height = lineElement.clientHeight;
    var width = ensureNotNull($this.xoa_1)();
    return new HighlightLayout(numberToInt(top), height, width);
  }
  function scheduleDelayedUpdate($this) {
    var tmp = $this;
    var tmp_0 = _get_edt__e67mgs_0($this);
    var tmp_1 = DefaultLineHighlight$scheduleDelayedUpdate$lambda($this);
    tmp.zoa_1 = tmp_0.v2m(200, new sam$jetbrains_ocelot_base_edt_EdtTask$0_19(tmp_1));
  }
  function cancelDelayedUpdate($this) {
    $this.zoa_1.vr();
    $this.zoa_1 = Companion_getInstance_25().wr_1;
  }
  function setupContentHandler($this) {
    var activeCell = $this.roa_1.qr();
    if (activeCell instanceof TextCell) {
      var tmp = $this;
      var tmp_0 = activeCell.laz();
      tmp.yoa_1 = tmp_0.p27(DefaultLineHighlight$setupContentHandler$lambda($this));
    }
  }
  function shutdownContentHandler($this) {
    $this.yoa_1.vr();
    $this.yoa_1 = Companion_getInstance_25().wr_1;
  }
  function HighlightLayout(top, height, width) {
    this.bob_1 = top;
    this.cob_1 = height;
    this.dob_1 = width;
  }
  protoOf(HighlightLayout).toString = function () {
    return 'HighlightLayout(top=' + this.bob_1 + ', height=' + this.cob_1 + ', width=' + this.dob_1 + ')';
  };
  protoOf(HighlightLayout).hashCode = function () {
    var result = this.bob_1;
    result = imul(result, 31) + this.cob_1 | 0;
    result = imul(result, 31) + this.dob_1 | 0;
    return result;
  };
  protoOf(HighlightLayout).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HighlightLayout))
      return false;
    var tmp0_other_with_cast = other instanceof HighlightLayout ? other : THROW_CCE();
    if (!(this.bob_1 === tmp0_other_with_cast.bob_1))
      return false;
    if (!(this.cob_1 === tmp0_other_with_cast.cob_1))
      return false;
    if (!(this.dob_1 === tmp0_other_with_cast.dob_1))
      return false;
    return true;
  };
  function Companion_339() {
    this.eob_1 = 200;
  }
  var Companion_instance_339;
  function Companion_getInstance_339() {
    return Companion_instance_339;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_18(function_0) {
    this.fob_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_18).wy = function () {
    return this.fob_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_18).b4 = function () {
    return this.fob_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_18).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_18).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_19(function_0) {
    this.gob_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_19).wy = function () {
    return this.gob_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_19).b4 = function () {
    return this.gob_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_19).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_19).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_20(function_0) {
    this.hob_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_20).wy = function () {
    return this.hob_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_20).b4 = function () {
    return this.hob_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_20).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_20).hashCode = function () {
    return hashCode(this.b4());
  };
  function DefaultLineHighlight$attach$lambda(this$0) {
    return function (it) {
      invalidate(this$0);
      return Unit_instance;
    };
  }
  function DefaultLineHighlight$invalidate$lambda(this$0) {
    return function () {
      refresh_0(this$0);
      return Unit_instance;
    };
  }
  function DefaultLineHighlight$scheduleDelayedUpdate$lambda(this$0) {
    return function () {
      this$0.woa_1 = false;
      refresh_0(this$0);
      return Unit_instance;
    };
  }
  function DefaultLineHighlight$setupContentHandler$lambda$lambda(this$0) {
    return function () {
      var style = this$0.soa_1.style;
      setWidth(style, ensureNotNull(this$0.xoa_1)());
      return Unit_instance;
    };
  }
  function DefaultLineHighlight$setupContentHandler$lambda(this$0) {
    return function (it) {
      var tmp = _get_edt__e67mgs_0(this$0);
      var tmp_0 = DefaultLineHighlight$setupContentHandler$lambda$lambda(this$0);
      tmp.u2m(new sam$jetbrains_ocelot_base_edt_EdtTask$0_20(tmp_0));
      return Unit_instance;
    };
  }
  function DefaultLineHighlight(activeCell) {
    this.roa_1 = activeCell;
    this.toa_1 = null;
    this.voa_1 = Companion_getInstance_25().wr_1;
    this.woa_1 = false;
    this.xoa_1 = null;
    this.yoa_1 = Companion_getInstance_25().wr_1;
    this.zoa_1 = Companion_getInstance_25().wr_1;
    this.aob_1 = null;
    this.soa_1 = DomApi_instance.nkx();
    addClassName(this.soa_1, Companion_getInstance_337().to4_1.vo2_1);
  }
  protoOf(DefaultLineHighlight).ioa = function (parent, edt, elementSupplier, widthSupplier) {
    parent.appendChild(this.soa_1);
    this.toa_1 = elementSupplier;
    this.uoa_1 = edt;
    this.xoa_1 = widthSupplier;
    var tmp = this;
    tmp.voa_1 = this.roa_1.p27(DefaultLineHighlight$attach$lambda(this));
    invalidate(this);
  };
  protoOf(DefaultLineHighlight).vr = function () {
    this.voa_1.vr();
    shutdownContentHandler(this);
    cancelDelayedUpdate(this);
    removeFromParent(this.soa_1);
  };
  function setSingletonChild($this, child) {
    removeAllChildren($this.ql9_1);
    if (child == null) {
      return Unit_instance;
    }
    $this.ql9_1.appendChild(child);
  }
  function attachListeners($this, node) {
    if (node == null) {
      return Unit_instance;
    }
    if ($this.pl9_1.ulp(Companion_getInstance_335().lo3_1)) {
      var handler = DomCellMapper$attachListeners$lambda;
      $this.zob_1 = on(node, Companion_getInstance_254().rky_1, handler);
    }
  }
  function detachListeners($this, node) {
    if (node == null) {
      return Unit_instance;
    }
    ensureNotNull($this.zob_1).vr();
  }
  function DomCellMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.aoc_1 = this$0;
  }
  protoOf(DomCellMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.cell.dom.toDom.DomCellMapper.registerSynchronizers.stub_for_inlining' call
    var $receiver = this.aoc_1;
    setSingletonChild($receiver, newValue);
    return Unit_instance;
  };
  protoOf(DomCellMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function DomCellMapper$registerSynchronizers$lambda(this$0) {
    return function (event) {
      detachListeners(this$0, event.o2e_1);
      attachListeners(this$0, event.p2e_1);
      return Unit_instance;
    };
  }
  function DomCellMapper$registerSynchronizers$2(this$0) {
    this.boc_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(DomCellMapper$registerSynchronizers$2).hlo = function (cell, event) {
    var node = this.boc_1.pl9_1.wo3().qr();
    if (!(node == null) && node.nodeType === 1) {
      var element = cast_0(node);
      element.focus();
    }
    protoOf(CellTrait).hlo.call(this, cell, event);
  };
  protoOf(DomCellMapper$registerSynchronizers$2).ilo = function (cell, event) {
    this.boc_1.ko4_1.zo4_1.no9();
    protoOf(CellTrait).ilo.call(this, cell, event);
  };
  function DomCellMapper$attachListeners$lambda(_unused_var__etf5q3) {
    return false;
  }
  function DomCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.nkx());
    this.zob_1 = null;
    addClassName(this.ql9_1, Companion_getInstance_337().to4_1.ro2_1);
  }
  protoOf(DomCellMapper).so5 = function () {
    return false;
  };
  protoOf(DomCellMapper).co6 = function () {
    protoOf(BaseCellToDomMapper).co6.call(this);
    this.bo5(Companion_getInstance_337().to4_1.uo2_1, this.pl9_1.ulp(Companion_getInstance_335().ko3_1));
    if (this.pl9_1.ulp(Companion_getInstance_335().lo3_1)) {
      setTabIndex(this.ql9_1, 0);
    } else {
      clearTabIndex(this.ql9_1);
    }
  };
  protoOf(DomCellMapper).llb = function (conf) {
    protoOf(BaseCellToDomMapper).llb.call(this, conf);
    var tmp = this.pl9_1.wo3();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new DomCellMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.x4v(syncOneWay(tmp, tmp$ret$0));
    attachListeners(this, this.pl9_1.wo3().qr());
    var tmp_0 = this.pl9_1.wo3();
    conf.x4v(tmp_0.p27(DomCellMapper$registerSynchronizers$lambda(this)));
    conf.x4v(this.pl9_1.olp(new DomCellMapper$registerSynchronizers$2(this)));
  };
  protoOf(DomCellMapper).nla = function () {
    protoOf(BaseCellToDomMapper).nla.call(this);
    setSingletonChild(this, null);
  };
  function isVisible_3($this, parent) {
    var visibleRootPart = DomUtil_getInstance_0().jo9($this.eoc_1.lo5_1.ymk_1);
    var tmp1_elvis_lhs = visibleRootPart == null ? null : visibleRootPart.qku(get_bounds(parent));
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  function DomPopupManager$UpdatePositionTask$run$ref($boundThis) {
    var l = function () {
      $boundThis.wy();
      return Unit_instance;
    };
    l.callableName = 'run';
    return l;
  }
  function _get_positionUpdater__wwdan($this) {
    var tmp0 = $this.mo5_1;
    // Inline function 'kotlin.getValue' call
    positionUpdater$factory();
    return tmp0.y();
  }
  function UpdatePositionTask($outer, popupMapper) {
    this.eoc_1 = $outer;
    this.coc_1 = popupMapper;
    this.doc_1 = 0;
  }
  protoOf(UpdatePositionTask).wy = function () {
    var source = this.coc_1.pl9_1;
    if (!source.qlc()) {
      return Unit_instance;
    }
    var parent = source.yt();
    if (!isVisible_3(this, ensureNotNull(parent))) {
      setDisplay(this.coc_1.ql9_1.style, CssDisplay_NONE_getInstance());
      return Unit_instance;
    }
    clearDisplay(this.coc_1.ql9_1.style);
    var changed = this.eoc_1.po5(this.coc_1).omq(source, this.coc_1.ql9_1);
    this.doc_1 = this.doc_1 + 1 | 0;
    if (changed && this.doc_1 < 5) {
      var tmp = DomImmediatePolyfill_getInstance();
      tmp.ykz(DomPopupManager$UpdatePositionTask$run$ref(this));
    }
  };
  function Companion_340() {
    this.foc_1 = 5;
    this.goc_1 = 50;
    this.hoc_1 = 100;
    this.ioc_1 = 5;
  }
  var Companion_instance_340;
  function Companion_getInstance_340() {
    return Companion_instance_340;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_21(function_0) {
    this.joc_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_21).wy = function () {
    return this.joc_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_21).b4 = function () {
    return this.joc_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_21).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_21).hashCode = function () {
    return hashCode(this.b4());
  };
  function DomPopupManager$positionUpdater$delegate$lambda(this$0) {
    return function () {
      return new PopupPositioner(this$0.lo5_1, 5);
    };
  }
  function DomPopupManager$attachPopup$lambda$lambda(this$0, $mapper) {
    return function () {
      this$0.wmq($mapper);
      return Unit_instance;
    };
  }
  function DomPopupManager$attachPopup$lambda(this$0, $mapper) {
    return function (it) {
      var tmp = DomImmediatePolyfill_getInstance();
      tmp.ykz(DomPopupManager$attachPopup$lambda$lambda(this$0, $mapper));
      return Unit_instance;
    };
  }
  function DomPopupManager$updatePopupPositions$ref($boundThis) {
    var l = function () {
      $boundThis.xmq();
      return Unit_instance;
    };
    l.callableName = 'updatePopupPositions';
    return l;
  }
  function DomPopupManager$setPopupUpdate$$inlined$toDisposable$1($timer) {
    this.koc_1 = $timer;
  }
  protoOf(DomPopupManager$setPopupUpdate$$inlined$toDisposable$1).vr = function () {
    // Inline function 'jetbrains.ocelot.projectional.cell.dom.toDom.DomPopupManager.setPopupUpdate.stub_for_inlining' call
    this.koc_1.i2n();
    return Unit_instance;
  };
  function DomPopupManager$scrollToPopup$lambda($popup) {
    return function () {
      var tmp;
      if ($popup.qlc()) {
        scrollTo_0($popup);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DomPopupManager$UpdatePositionTask$run$ref_0($boundThis) {
    var l = function () {
      $boundThis.wy();
      return Unit_instance;
    };
    l.callableName = 'run';
    return l;
  }
  function DomPopupManager(context) {
    BasePopupManager.call(this);
    this.lo5_1 = context;
    var tmp = this;
    tmp.mo5_1 = lazy_0(DomPopupManager$positionUpdater$delegate$lambda(this));
    this.no5_1 = null;
  }
  protoOf(DomPopupManager).qmq = function (popup) {
    var mapper = this.lo5_1.zo5(popup);
    var element = mapper.ql9_1;
    this.lo5_1.ymk_1.appendChild(element);
    addClassName(element, Companion_getInstance_337().to4_1.do3_1);
    setPosition(element.style, CssPosition_FIXED_getInstance());
    if (popup instanceof LayoutCell) {
      addClassName(element, Companion_getInstance_337().to4_1.eo3_1);
    }
    setZIndex(element.style, 100 + popup.clo(get_POPUP_Z_ADJUSTMENT()) | 0);
    setMarginRight(element.style, 5);
    setMarginBottom(element.style, 5);
    if (this.no5_1 == null) {
      this.no5_1 = HashMap_init_$Create$();
    }
    var tmp;
    if (popup instanceof ScrollCell) {
      var tmp_0 = popup.ylr();
      tmp = tmp_0.p27(DomPopupManager$attachPopup$lambda(this, mapper));
    } else {
      tmp = Companion_getInstance_25().wr_1;
    }
    var scrollReg = tmp;
    var tmp0 = ensureNotNull(this.no5_1);
    // Inline function 'kotlin.collections.set' call
    var value = new CompositeDisposable([Tooltip_instance.moc(mapper), scrollReg]);
    tmp0.r2(element, value);
    return mapper;
  };
  protoOf(DomPopupManager).oo5 = function (popup) {
    removeFromParent(popup.ql9_1);
    ensureNotNull(ensureNotNull(this.no5_1).s2(popup.ql9_1)).vr();
    if (ensureNotNull(this.no5_1).p()) {
      this.no5_1 = null;
    }
  };
  protoOf(DomPopupManager).rmq = function (popup) {
    return this.oo5(popup);
  };
  protoOf(DomPopupManager).smq = function () {
    var timer = new Timer(DomPopupManager$updatePopupPositions$ref(this));
    timer.n2n(50);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new DomPopupManager$setPopupUpdate$$inlined$toDisposable$1(timer);
  };
  protoOf(DomPopupManager).po5 = function (popup) {
    return _get_positionUpdater__wwdan(this);
  };
  protoOf(DomPopupManager).mmq = function (popup) {
    return this.po5(popup);
  };
  protoOf(DomPopupManager).lmq = function (popup) {
    if (popup.qlc()) {
      var tmp = ensureNotNull(popup.llk()).elq();
      var tmp_0 = DomPopupManager$scrollToPopup$lambda(popup);
      tmp.v2m(50, new sam$jetbrains_ocelot_base_edt_EdtTask$0_21(tmp_0));
    }
  };
  protoOf(DomPopupManager).qo5 = function (mapper) {
    return DomPopupManager$UpdatePositionTask$run$ref_0(new UpdatePositionTask(this, mapper));
  };
  protoOf(DomPopupManager).zmq = function (mapper) {
    return this.qo5(mapper);
  };
  function positionUpdater$factory() {
    return getPropertyCallableRef('positionUpdater', 1, KProperty1, function (receiver) {
      return _get_positionUpdater__wwdan(receiver);
    }, null);
  }
  function DomProperties() {
    DomProperties_instance = this;
    this.noc_1 = CellPropertySpec_init_$Create$('rootPaddingPx', 15);
  }
  var DomProperties_instance;
  function DomProperties_getInstance() {
    if (DomProperties_instance == null)
      new DomProperties();
    return DomProperties_instance;
  }
  function _get_isTextAreaFullyVisible__mocubj($this) {
    return equals(DomUtil_getInstance_0().jo9($this.jo7_1), DomUtil_getInstance_0().lo6($this.jo7_1));
  }
  function addFocusHandlers($this, rootElement) {
    var focusHandler = DomTextInput$addFocusHandlers$lambda($this);
    var blurHandler = DomTextInput$addFocusHandlers$lambda_0($this);
    var rootFocusHandler = DomTextInput$addFocusHandlers$lambda_1($this);
    return new CompositeDisposable([on($this.jo7_1, Companion_getInstance_254().rky_1, focusHandler), on($this.jo7_1, Companion_getInstance_254().cky_1, blurHandler), on(rootElement, Companion_getInstance_254().rky_1, rootFocusHandler)]);
  }
  function moveTextAreaToVisiblePlace($this) {
    var rootVisiblePart = DomUtil_getInstance_0().jo9($this.io7_1);
    if (rootVisiblePart == null) {
      moveTextArea($this, 0, 0, CssPosition_FIXED_getInstance());
      return Unit_instance;
    }
    var visibleCenter = rootVisiblePart.wku();
    moveTextAreaToFixed($this, visibleCenter.eku_1, visibleCenter.fku_1);
  }
  function moveTextAreaToFixed($this, x, y) {
    moveTextArea($this, x, y, CssPosition_FIXED_getInstance());
  }
  function moveTextArea($this, x, y, position) {
    var style = $this.jo7_1.style;
    setLeft(style, x);
    setTop(style, y);
    setPosition(style, position);
  }
  function DomTextInput$addFocusHandlers$lambda(this$0) {
    return function (_unused_var__etf5q3) {
      this$0.ko7_1.t2c(true);
      return false;
    };
  }
  function DomTextInput$addFocusHandlers$lambda_0(this$0) {
    return function (_unused_var__etf5q3) {
      this$0.ko7_1.t2c(false);
      return false;
    };
  }
  function DomTextInput$addFocusHandlers$lambda_1(this$0) {
    return function (_unused_var__etf5q3) {
      var tmp;
      if (!this$0.ko7_1.qr()) {
        this$0.no9();
        tmp = Unit_instance;
      }
      return false;
    };
  }
  function DomTextInput(rootElement) {
    this.io7_1 = rootElement;
    this.jo7_1 = HiddenTextAreaHelper_instance.ooc();
    this.ko7_1 = new ValueProperty(false);
    this.io7_1.appendChild(this.jo7_1);
    this.lo7_1 = addFocusHandlers(this, this.io7_1);
  }
  protoOf(DomTextInput).oo9 = function () {
    return this.ko7_1;
  };
  protoOf(DomTextInput).no9 = function () {
    if (!_get_isTextAreaFullyVisible__mocubj(this)) {
      moveTextAreaToVisiblePlace(this);
    }
    this.jo7_1.focus();
  };
  protoOf(DomTextInput).mo7 = function (x, y) {
    moveTextArea(this, x, y, CssPosition_ABSOLUTE_getInstance());
  };
  protoOf(DomTextInput).mo8 = function (target) {
    return (new TextAreaKeyTranslator(this.jo7_1, this.io7_1, target)).bl6();
  };
  protoOf(DomTextInput).vr = function () {
    this.lo7_1.vr();
    removeFromParent(this.jo7_1);
  };
  function EmptyLineHighlight() {
  }
  protoOf(EmptyLineHighlight).ioa = function (parent, edt, elementSupplier, widthSupplier) {
  };
  protoOf(EmptyLineHighlight).vr = function () {
  };
  function create_0($this, position) {
    var textarea = DomApi_instance.rkx();
    var style = textarea.style;
    setPosition(style, position);
    setLeft(style, 0.0);
    setTop(style, 0.0);
    setHeight(style, 1);
    setWidth(style, 1);
    setOverflow(style, CssOverflow_HIDDEN_getInstance());
    setZIndex(style, -1);
    setPadding(style, 0.0);
    setColor(style, Companion_getInstance_325().rls_1.qnn());
    setBorderStyle(style, CssBorderStyle_NONE_getInstance());
    setOutlineStyle(style, CssOutlineStyle_NONE_getInstance());
    return textarea;
  }
  function HiddenTextAreaHelper() {
  }
  protoOf(HiddenTextAreaHelper).ooc = function () {
    return create_0(this, CssPosition_ABSOLUTE_getInstance());
  };
  var HiddenTextAreaHelper_instance;
  function HiddenTextAreaHelper_getInstance() {
    return HiddenTextAreaHelper_instance;
  }
  function HorizontalCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.nkx());
    addClassName(this.ql9_1, Companion_getInstance_337().to4_1.lo2_1);
  }
  protoOf(HorizontalCellMapper).llb = function (conf) {
    protoOf(BaseCellToDomMapper).llb.call(this, conf);
    conf.x4v(AlignmentSynchronizers_instance.zo3(this.pl9_1, this.ql9_1));
  };
  function Companion_341() {
    this.god_1 = 'width';
    this.hod_1 = 'height';
  }
  var Companion_instance_341;
  function Companion_getInstance_341() {
    return Companion_instance_341;
  }
  function ImageCellMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.iod_1 = this$0;
  }
  protoOf(ImageCellMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    if (newValue == null) {
      this.iod_1.ql9_1.removeAttribute('width');
      this.iod_1.ql9_1.removeAttribute('height');
    } else {
      var dimension = newValue.tnn_1;
      this.iod_1.ql9_1.setAttribute('width', '' + dimension.eku_1);
      this.iod_1.ql9_1.setAttribute('height', '' + dimension.fku_1);
    }
    var tmp;
    if (newValue instanceof UrlImageData) {
      this.iod_1.ql9_1.setAttribute('src', newValue.vnn_1);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(ImageCellMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function ImageCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.skx());
    setVerticalAlign(this.ql9_1.style, CssVerticalAlign_BOTTOM_getInstance());
  }
  protoOf(ImageCellMapper).llb = function (conf) {
    protoOf(BaseCellToDomMapper).llb.call(this, conf);
    var tmp = this.pl9_1.omh();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new ImageCellMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.x4v(syncOneWay(tmp, tmp$ret$0));
  };
  function IndentRootCellMapper$2$wrap$1($mapper, this$0, $source, $cell) {
    this.boe_1 = $mapper;
    this.coe_1 = this$0;
    this.doe_1 = $source;
    this.eoe_1 = $cell;
    this.aoe_1 = $mapper.ql9_1;
  }
  protoOf(IndentRootCellMapper$2$wrap$1).plj = function () {
    return this.aoe_1;
  };
  protoOf(IndentRootCellMapper$2$wrap$1).qlj = function () {
    this.coe_1.do7_1.e(this.boe_1);
    this.coe_1.xo5();
  };
  protoOf(IndentRootCellMapper$2$wrap$1).b5 = function () {
    CounterUtil_getInstance().wly(this.doe_1, this.eoe_1, this.boe_1);
    this.coe_1.do7_1.k2(this.boe_1);
    this.coe_1.xo5();
  };
  function IndentRootCellMapper$2(this$0, $source) {
    this.foe_1 = this$0;
    this.goe_1 = $source;
  }
  protoOf(IndentRootCellMapper$2).elj = function () {
    var result = DomApi_instance.nkx();
    addClassName(result, Companion_getInstance_337().to4_1.lo2_1);
    return result;
  };
  protoOf(IndentRootCellMapper$2).flj = function (size) {
    var result = DomApi_instance.nkx();
    var editor = new DomTextEditor(result);
    editor.woe(repeat(' ', size));
    return result;
  };
  protoOf(IndentRootCellMapper$2).glj = function (cell) {
    var mapper = this.foe_1.yo5(cell);
    CounterUtil_getInstance().vly(this.goe_1, cell, mapper);
    return new IndentRootCellMapper$2$wrap$1(mapper, this.foe_1, this.goe_1, cell);
  };
  protoOf(IndentRootCellMapper$2).xoe = function (item) {
    // Inline function 'kotlin.check' call
    if (!(item instanceof Element)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return DomUtil_instance.rkv(item);
  };
  protoOf(IndentRootCellMapper$2).ilj = function (item) {
    return this.xoe((item == null ? true : item instanceof Node) ? item : THROW_CCE());
  };
  protoOf(IndentRootCellMapper$2).yoe = function (item) {
    // Inline function 'kotlin.check' call
    if (!(item instanceof Element)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    return item.parentElement;
  };
  protoOf(IndentRootCellMapper$2).klj = function (item) {
    return this.yoe((item == null ? true : item instanceof Node) ? item : THROW_CCE());
  };
  protoOf(IndentRootCellMapper$2).nlj = function (cell) {
    var descendantMapper = this.foe_1.rlc(ensureNotNull(cell).rmj());
    var mapper = descendantMapper instanceof IndentRootCellMapper ? descendantMapper : THROW_CCE();
    return mapper.eo7_1;
  };
  protoOf(IndentRootCellMapper$2).zoe = function (item) {
    // Inline function 'kotlin.check' call
    if (!(ensureNotNull(item).nodeType === 1)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp = DomUtil_getInstance_0();
    return tmp.lo6(item instanceof HTMLElement ? item : THROW_CCE());
  };
  protoOf(IndentRootCellMapper$2).mlj = function (item) {
    return this.zoe((item == null ? true : item instanceof Node) ? item : THROW_CCE());
  };
  function IndentRootCellMapper$onAttach$o$updateCounters$lambda(this$0, $prop, $event) {
    return function (item) {
      var tmp = this$0.rlc(item);
      var mapper = tmp instanceof BaseCellToDomMapper ? tmp : THROW_CCE();
      var tmp_0;
      if (CounterUtil_getInstance().tly(mapper, $prop, $event)) {
        this$0.ko4_1.ao5(mapper);
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function IndentRootCellMapper$onAttach$o$updateLeavesProperty$lambda(this$0, $prop) {
    return function (item) {
      var tmp = this$0.rlc(item);
      var mapper = tmp instanceof BaseCellToDomMapper ? tmp : THROW_CCE();
      mapper.mly($prop, AncestorUtil_instance.wmk($prop, this$0.pl9_1, item));
      this$0.ko4_1.ao5(mapper);
      return Unit_instance;
    };
  }
  function IndentRootCellMapper$1($source, this$0) {
    IndentUpdater.call(this, $source, this$0.ql9_1, new IndentRootCellMapper$2(this$0, $source));
  }
  protoOf(IndentRootCellMapper$1).clj = function (cell, event) {
    return this.xli(cell, event);
  };
  function IndentRootCellMapper$onAttach$1(this$0) {
    this.mof_1 = this$0;
    BaseIndentUpdatingListener.call(this, this$0.eo7_1);
    this.fmk(this$0.pl9_1);
  }
  protoOf(IndentRootCellMapper$onAttach$1).imk = function (event) {
    return this.mof_1.umq(event);
  };
  protoOf(IndentRootCellMapper$onAttach$1).jmk = function (cell, prop, event) {
    var tmp = IndentUtil_instance;
    tmp.eml(cell, IndentRootCellMapper$onAttach$o$updateCounters$lambda(this.mof_1, prop, event));
  };
  protoOf(IndentRootCellMapper$onAttach$1).hmk = function (cell, prop) {
    var tmp = IndentUtil_instance;
    tmp.eml(cell, IndentRootCellMapper$onAttach$o$updateLeavesProperty$lambda(this.mof_1, prop));
  };
  protoOf(IndentRootCellMapper$onAttach$1).gmk = function (leaf) {
    var tmp = this.mof_1.rlc(leaf);
    var leafMapper = tmp instanceof BaseCellToDomMapper ? tmp : THROW_CCE();
    AncestorUtil_instance.xmk(leafMapper, this.mof_1.pl9_1, leaf);
  };
  function IndentRootCellMapper$createPopupManager$1(this$0) {
    this.sof_1 = this$0;
    DomPopupManager.call(this, this$0.ko4_1);
  }
  protoOf(IndentRootCellMapper$createPopupManager$1).tmq = function (cell) {
    protoOf(DomPopupManager).tmq.call(this, cell);
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = cell.g2r();
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      if (element instanceof IndentCell) {
        destination.e(element);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var element_0 = _iterator__ex2g4s_0.m();
      // Inline function 'jetbrains.ocelot.projectional.cell.dom.toDom.<no name provided>.attach.<anonymous>' call
      this.tmq(element_0);
    }
  };
  protoOf(IndentRootCellMapper$createPopupManager$1).qmq = function (popup) {
    var tmp = protoOf(DomPopupManager).qmq.call(this, popup);
    var mapper = tmp instanceof BaseCellToDomMapper ? tmp : THROW_CCE();
    this.sof_1.do7_1.e(mapper);
    return mapper;
  };
  protoOf(IndentRootCellMapper$createPopupManager$1).oo5 = function (popup) {
    // Inline function 'kotlin.collections.remove' call
    var this_0 = this.sof_1.do7_1;
    (isInterface(this_0, MutableCollection) ? this_0 : THROW_CCE()).k2(popup);
    protoOf(DomPopupManager).oo5.call(this, popup);
  };
  protoOf(IndentRootCellMapper$createPopupManager$1).rmq = function (popup) {
    return this.oo5(popup);
  };
  protoOf(IndentRootCellMapper$createPopupManager$1).pmq = function () {
    return HashSet_init_$Create$();
  };
  function IndentRootCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.nkx());
    this.fo7_1 = null;
    this.do7_1 = this.bld();
    var tmp = this;
    tmp.eo7_1 = new IndentRootCellMapper$1(source, this);
  }
  protoOf(IndentRootCellMapper).so5 = function () {
    return false;
  };
  protoOf(IndentRootCellMapper).uo5 = function () {
    return false;
  };
  protoOf(IndentRootCellMapper).zlc = function (ctx) {
    protoOf(BaseCellToDomMapper).zlc.call(this, ctx);
    var _iterator__ex2g4s = this.pl9_1.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      this.eo7_1.vli(child);
    }
    this.eo7_1.uli();
    var tmp = this;
    tmp.fo7_1 = this.pl9_1.smj(new IndentRootCellMapper$onAttach$1(this));
  };
  protoOf(IndentRootCellMapper).nla = function () {
    var children = this.pl9_1.g2r();
    var inductionVariable = children.n() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var c = children.q(i);
        this.eo7_1.wli(c);
      }
       while (0 <= inductionVariable);
    ensureNotNull(this.fo7_1).vr();
    protoOf(BaseCellToDomMapper).nla.call(this);
  };
  protoOf(IndentRootCellMapper).vo5 = function () {
    return new IndentRootCellMapper$createPopupManager$1(this);
  };
  protoOf(IndentRootCellMapper).dlj = function (indentCell) {
    return this.eo7_1.dlj(indentCell);
  };
  function Companion_342() {
    Companion_instance_342 = this;
    this.noa_1 = new EmptyLineHighlight();
  }
  var Companion_instance_342;
  function Companion_getInstance_342() {
    if (Companion_instance_342 == null)
      new Companion_342();
    return Companion_instance_342;
  }
  function Companion_343() {
    this.tof_1 = 2;
  }
  protoOf(Companion_343).uof = function (namedValue, valueInPixels) {
    if (namedValue == null || !endsWith(namedValue, CssUnit_PX_getInstance().vkv_1)) {
      return false;
    }
    // Inline function 'kotlin.text.trim' call
    var this_0 = dropLast_0(namedValue, CssUnit_PX_getInstance().vkv_1.length);
    // Inline function 'kotlin.text.trim' call
    var this_1 = isCharSequence(this_0) ? this_0 : THROW_CCE();
    var startIndex = 0;
    var endIndex = charSequenceLength(this_1) - 1 | 0;
    var startFound = false;
    $l$loop: while (startIndex <= endIndex) {
      var index = !startFound ? startIndex : endIndex;
      // Inline function 'jetbrains.ocelot.projectional.cell.dom.toDom.Companion.areEqual.<anonymous>' call
      var it = charSequenceGet(this_1, index);
      var match = Char__compareTo_impl_ypi4mb(it, _Char___init__impl__6a9atx(32)) <= 0;
      if (!startFound) {
        if (!match)
          startFound = true;
        else
          startIndex = startIndex + 1 | 0;
      } else {
        if (!match)
          break $l$loop;
        else
          endIndex = endIndex - 1 | 0;
      }
    }
    var tmp$ret$1 = charSequenceSubSequence(this_1, startIndex, endIndex + 1 | 0);
    var number = toString_1(tmp$ret$1);
    var tmp;
    try {
      tmp = valueInPixels === toInt(number);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof NumberFormatException) {
        var e = $p;
        tmp_0 = false;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  var Companion_instance_343;
  function Companion_getInstance_343() {
    return Companion_instance_343;
  }
  function PopupPositioner(context, rightBottomMargin) {
    PopupPositionUpdater_init_$Init$(rightBottomMargin, this);
    this.wof_1 = context;
  }
  protoOf(PopupPositioner).amr = function () {
    var topLeft = ensureNotNull(DomUtil_getInstance_0().jo9(this.wof_1.ymk_1)).cku_1;
    var bottomRight = new Vector(DomUtil_getInstance_0().xof(), DomUtil_getInstance_0().yof());
    return new Rectangle(topLeft, bottomRight.kku(topLeft));
  };
  protoOf(PopupPositioner).zof = function (popup) {
    var htmlElement = cast_0(popup);
    return new Vector(htmlElement.offsetWidth, htmlElement.offsetHeight);
  };
  protoOf(PopupPositioner).omr = function (popup) {
    return this.zof(popup instanceof HTMLElement ? popup : THROW_CCE());
  };
  protoOf(PopupPositioner).aog = function (popup) {
    return Tooltip_instance.bog(popup);
  };
  protoOf(PopupPositioner).imr = function (popup) {
    return this.aog(popup instanceof HTMLElement ? popup : THROW_CCE());
  };
  protoOf(PopupPositioner).cog = function (popup) {
    return Tooltip_instance.dog(popup);
  };
  protoOf(PopupPositioner).hmr = function (popup) {
    return this.cog(popup instanceof HTMLElement ? popup : THROW_CCE());
  };
  protoOf(PopupPositioner).eog = function (popup, height) {
    return Tooltip_instance.fog(popup, height);
  };
  protoOf(PopupPositioner).gmr = function (popup, height) {
    return this.eog(popup instanceof HTMLElement ? popup : THROW_CCE(), height);
  };
  protoOf(PopupPositioner).gog = function (popup, height) {
    return Tooltip_instance.hog(popup, height);
  };
  protoOf(PopupPositioner).kmr = function (popup, height) {
    return this.gog(popup instanceof HTMLElement ? popup : THROW_CCE(), height);
  };
  protoOf(PopupPositioner).iog = function (popup, left, top) {
    var style = popup.style;
    var changed = !Companion_instance_343.uof(style.left, left) || !Companion_instance_343.uof(style.top, top);
    setLeft(style, left);
    setTop(style, top);
    var htmlElement = cast_0(popup);
    return changed || htmlElement.offsetWidth <= 2;
  };
  protoOf(PopupPositioner).lmr = function (popup, left, top) {
    return this.iog(popup instanceof HTMLElement ? popup : THROW_CCE(), left, top);
  };
  function RootCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.nkx());
    var padding = source.clo(DomProperties_getInstance().noc_1);
    setPadding(this.ql9_1.style, padding);
  }
  function ScrollCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.nkx());
    setOverflowX(this.ql9_1.style, CssOverflow_AUTO_getInstance());
    addClassName(this.ql9_1, Companion_getInstance_337().to4_1.to2_1);
  }
  protoOf(ScrollCellMapper).co6 = function () {
    protoOf(BaseCellToDomMapper).co6.call(this);
    var style = this.ql9_1.style;
    var maxDim = this.pl9_1.xlr().qr();
    var borderTotalWidth = DomUtil_getInstance_0().aoh(this.ql9_1) + DomUtil_getInstance_0().boh(this.ql9_1) | 0;
    if (maxDim.eku_1 > borderTotalWidth) {
      setMaxWidth(style, maxDim.eku_1 - borderTotalWidth);
    }
    var borderTotalHeight = DomUtil_getInstance_0().coh(this.ql9_1) + DomUtil_getInstance_0().doh(this.ql9_1) | 0;
    if (maxDim.fku_1 > borderTotalHeight) {
      setMaxHeight(style, maxDim.fku_1 - borderTotalHeight);
    }
    setOverflowY(style, this.pl9_1.ylr().qr() ? CssOverflow_SCROLL_getInstance() : CssOverflow_HIDDEN_getInstance());
  };
  function updateCaretVisibility($this) {
    $this.go9_1.eoh($this.ko4_1.zo4_1.oo9().qr() && $this.pl9_1.ilu().qr());
  }
  function Companion_344() {
    this.foh_1 = 1000;
  }
  var Companion_instance_344;
  function Companion_getInstance_344() {
    return Companion_instance_344;
  }
  function TextCellMapper$refreshProperties$lambda(this$0) {
    return function () {
      var tmp;
      if (currentTimeMillis().j3(this$0.ho9_1).d1(new Long(1000, 0)) >= 0) {
        this$0.go9_1.goh();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function TextCellMapper$refreshProperties$lambda_0(this$0) {
    return function (it) {
      updateCaretVisibility(this$0);
      return Unit_instance;
    };
  }
  function TextCellMapper$refreshProperties$lambda_1(this$0) {
    return function (event) {
      var tmp;
      if (event.p2e_1) {
        this$0.ho9_1 = currentTimeMillis();
        updateCaretVisibility(this$0);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function TextCellMapper$refreshProperties$$inlined$toDisposable$1($timer) {
    this.hoh_1 = $timer;
  }
  protoOf(TextCellMapper$refreshProperties$$inlined$toDisposable$1).vr = function () {
    this.hoh_1.i2n();
    return Unit_instance;
  };
  function TextCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.nkx());
    this.go9_1 = new DomTextEditor(this.ql9_1);
    this.ho9_1 = currentTimeMillis();
    this.io9_1 = null;
  }
  protoOf(TextCellMapper).so5 = function () {
    return false;
  };
  protoOf(TextCellMapper).jkb = function () {
    return true;
  };
  protoOf(TextCellMapper).zlc = function (ctx) {
    protoOf(BaseCellToDomMapper).zlc.call(this, ctx);
    addClassName(this.ql9_1, Companion_getInstance_337().to4_1.xo2_1);
  };
  protoOf(TextCellMapper).nla = function () {
    protoOf(BaseCellToDomMapper).nla.call(this);
    if (!(this.io9_1 == null)) {
      ensureNotNull(this.io9_1).vr();
      this.io9_1 = null;
    }
  };
  protoOf(TextCellMapper).flu = function (caret) {
    return numberToInt(this.go9_1.flu(caret));
  };
  protoOf(TextCellMapper).slu = function (x) {
    return this.go9_1.ioh(x);
  };
  protoOf(TextCellMapper).co6 = function () {
    protoOf(BaseCellToDomMapper).co6.call(this);
    var focused = this.pl9_1.clo(get_FOCUSED());
    if (focused) {
      if (this.io9_1 == null) {
        var timer = new Timer(TextCellMapper$refreshProperties$lambda(this));
        timer.n2n(500);
        var tmp = this;
        var tmp_0 = this.ko4_1.zo4_1.oo9();
        var tmp_1 = tmp_0.p27(TextCellMapper$refreshProperties$lambda_0(this));
        var tmp_2 = this.pl9_1.ilu();
        var tmp_3 = tmp_2.p27(TextCellMapper$refreshProperties$lambda_1(this));
        // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
        var tmp$ret$0 = new TextCellMapper$refreshProperties$$inlined$toDisposable$1(timer);
        tmp.io9_1 = new CompositeDisposable([tmp_1, tmp_3, tmp$ret$0]);
      }
    } else {
      if (!(this.io9_1 == null)) {
        ensureNotNull(this.io9_1).vr();
        this.io9_1 = null;
      }
    }
    this.ho9_1 = currentTimeMillis();
    this.go9_1.joh(this.pl9_1.laz().qr(), this.pl9_1.rlu().qr());
    this.go9_1.koh(this.pl9_1.zlt().qr());
    this.go9_1.eoh(this.pl9_1.ilu().qr());
    this.go9_1.loh(this.pl9_1.hlu().qr());
    this.go9_1.moh(this.pl9_1.jlu().qr());
    this.go9_1.noh(this.pl9_1.klu().qr());
    this.go9_1.ooh(this.pl9_1.llu().qr());
    this.go9_1.poh(this.pl9_1.mlu().qr());
    this.go9_1.qoh(this.pl9_1.nlu().qr());
    this.go9_1.roh(this.pl9_1.olu().qr());
    this.go9_1.soh(this.pl9_1.plu().qr());
    this.go9_1.toh(this.pl9_1.qlu().qr());
  };
  function updateWidth($this, widthChars) {
    setWidth(style($this), numberToInt(widthChars * charWidth($this)));
  }
  function updateHeight($this, heightLines) {
    setHeight(style($this), numberToInt(heightLines * charHeight($this)));
  }
  function charWidth($this) {
    return DomUtil_getInstance_0().jo6_1.foa().skt_1;
  }
  function charHeight($this) {
    return DomUtil_getInstance_0().jo6_1.foa().tkt_1;
  }
  function style($this) {
    return $this.ql9_1.style;
  }
  function TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.uoh_1 = this$0;
  }
  protoOf(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.cell.dom.toDom.TextPlaceholderCellMapper.registerSynchronizers.stub_for_inlining' call
    var $receiver = this.uoh_1;
    updateWidth($receiver, newValue);
    return Unit_instance;
  };
  protoOf(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$2(this$0) {
    this.voh_1 = this$0;
  }
  protoOf(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$2).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.cell.dom.toDom.TextPlaceholderCellMapper.registerSynchronizers.stub_for_inlining' call
    var $receiver = this.voh_1;
    updateHeight($receiver, newValue);
    return Unit_instance;
  };
  protoOf(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$2).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextPlaceholderCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.nkx());
  }
  protoOf(TextPlaceholderCellMapper).llb = function (conf) {
    protoOf(BaseCellToDomMapper).llb.call(this, conf);
    var tmp = this.pl9_1.dlv();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.x4v(syncOneWay(tmp, tmp$ret$0));
    var tmp_0 = this.pl9_1.elv();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$1 = new TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$2(this);
    conf.x4v(syncOneWay(tmp_0, tmp$ret$1));
  };
  function injectCornerStyle($this, id, cell) {
    var cellBorder = get_border(cell).qr();
    var top = cellBorder == null ? null : cellBorder.tlh_1;
    var border = top == null ? 'none' : Companion_instance_336.co5(top);
    var backgroundColor = cell.clo(get_BACKGROUND());
    var tmp2_elvis_lhs = backgroundColor == null ? null : backgroundColor.qnn();
    var backgroundValue = tmp2_elvis_lhs == null ? Companion_getInstance_325().sls_1.qnn() : tmp2_elvis_lhs;
    var styleElement = StyleInjector_getInstance().el0('.' + id + '::before { border-top: ' + border + '; border-left: ' + border + '; background: linear-gradient(135deg, ' + (backgroundValue + ' 0%, ' + backgroundValue + ' 55%, rgba(0,0,0,0) 56%, rgba(0,0,0,0) 100%) }'));
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new Tooltip$injectCornerStyle$$inlined$toDisposable$1(styleElement);
  }
  function isTooltip($this, element) {
    return element.classList.contains(Companion_getInstance_337().to4_1.fo3_1);
  }
  function Tooltip$injectCornerStyle$$inlined$toDisposable$1($styleElement) {
    this.noi_1 = $styleElement;
  }
  protoOf(Tooltip$injectCornerStyle$$inlined$toDisposable$1).vr = function () {
    removeFromParent(this.noi_1);
    return Unit_instance;
  };
  function Tooltip() {
    this.loc_1 = 6;
  }
  protoOf(Tooltip).moc = function (popupMapper) {
    var cell = popupMapper.pl9_1;
    if (!get_isPopup(cell) || !cell.clo(get_HAS_POPUP_DECORATION())) {
      return Companion_getInstance_25().wr_1;
    }
    var id = Companion_getInstance_337().to4_1.fo3_1 + toString_3(hashCode(cell), 16);
    addClassName(popupMapper.ql9_1, Companion_getInstance_337().to4_1.fo3_1);
    addClassName(popupMapper.ql9_1, id);
    return injectCornerStyle(this, id, cell);
  };
  protoOf(Tooltip).dog = function (tooltip) {
    if (!isTooltip(this, tooltip))
      return Unit_instance;
    clearMarginBottom(tooltip.style);
    setMarginTop(tooltip.style, 6);
    removeClassName(tooltip, Companion_getInstance_337().to4_1.ho3_1);
    addClassName(tooltip, Companion_getInstance_337().to4_1.go3_1);
  };
  protoOf(Tooltip).bog = function (tooltip) {
    if (!isTooltip(this, tooltip))
      return Unit_instance;
    clearMarginTop(tooltip.style);
    setMarginBottom(tooltip.style, 6);
    removeClassName(tooltip, Companion_getInstance_337().to4_1.go3_1);
    addClassName(tooltip, Companion_getInstance_337().to4_1.ho3_1);
  };
  protoOf(Tooltip).fog = function (popup, height) {
    return isTooltip(this, popup) ? height + 6 | 0 : height;
  };
  protoOf(Tooltip).hog = function (popup, height) {
    return isTooltip(this, popup) ? height - 6 | 0 : height;
  };
  var Tooltip_instance;
  function Tooltip_getInstance() {
    return Tooltip_instance;
  }
  function VerticalCellMapper(source, ctx) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.nkx());
    addClassName(this.ql9_1, Companion_getInstance_337().to4_1.jo2_1);
  }
  protoOf(VerticalCellMapper).llb = function (conf) {
    protoOf(BaseCellToDomMapper).llb.call(this, conf);
    conf.x4v(AlignmentSynchronizers_instance.zo3(this.pl9_1, this.ql9_1));
  };
  protoOf(VerticalCellMapper).co6 = function () {
    protoOf(BaseCellToDomMapper).co6.call(this);
    this.bo5(Companion_getInstance_337().to4_1.mo2_1, this.pl9_1.clo(Companion_getInstance_273().flv_1));
  };
  function ViewCellMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.foj_1 = this$0;
  }
  protoOf(ViewCellMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    var children = this.foj_1.yoj_1.qo1().ilp();
    children.m2();
    var tmp;
    if (!(newValue == null)) {
      children.e(newValue);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(ViewCellMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function ViewCellMapper(source, ctx, extensionViewMapperFactories) {
    BaseCellToDomMapper.call(this, source, ctx, DomApi_instance.nkx());
    this.xoj_1 = extensionViewMapperFactories;
    this.yoj_1 = new ViewContainer();
  }
  protoOf(ViewCellMapper).llb = function (conf) {
    protoOf(BaseCellToDomMapper).llb.call(this, conf);
    var target = this.ql9_1;
    var tmp;
    if (this.ko4_1.xo4_1) {
      tmp = ViewToDom_instance.aok(this.yoj_1, target, this.xoj_1, true);
    } else {
      tmp = ViewToDom_instance.zoj(this.yoj_1, target, this.xoj_1);
    }
    var disposable = tmp;
    conf.x4v(disposable);
    var tmp_0 = this.pl9_1.qn4();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new ViewCellMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.x4v(syncOneWay(tmp_0, tmp$ret$0));
  };
  protoOf(ViewCellMapper).nla = function () {
    protoOf(BaseCellToDomMapper).nla.call(this);
    this.yoj_1.qo1().ilp().m2();
  };
  function _get_isCurrentFontMonospaced__wrvp72($this) {
    return equals(DomUtil_getInstance_0().ho6_1, $this.roe_1.ult_1);
  }
  function _get_cachedOrEstimatedLineHeight__5rm6fz($this) {
    var cached = Companion_getInstance_345().cok_1.y2($this.roe_1);
    var tmp1_elvis_lhs = cached == null ? null : cached;
    return tmp1_elvis_lhs == null ? $this.soe_1.foa().tkt_1 : tmp1_elvis_lhs;
  }
  function _get_lineHeight__binsk0($this) {
    var cached = Companion_getInstance_345().cok_1.y2($this.roe_1);
    if (!(cached == null)) {
      return cached;
    } else {
      // Inline function 'kotlin.text.isNullOrEmpty' call
      var this_0 = $this.noe_1;
      if (!(this_0 == null || charSequenceLength(this_0) === 0)) {
        var clientHeight = $this.ioe_1.clientHeight;
        if (clientHeight > 0) {
          Companion_getInstance_345().cok_1.r2($this.roe_1, clientHeight);
          return clientHeight;
        }
      }
    }
    return $this.soe_1.foa().tkt_1;
  }
  function _get_charWidth__5ojr27($this) {
    var tmp;
    if (containsChinese($this, ensureNotNull($this.noe_1))) {
      tmp = TextMetricsCalculator_getInstance().dok($this.roe_1, ensureNotNull($this.noe_1)) / ensureNotNull($this.noe_1).length;
    } else {
      tmp = $this.soe_1.foa().skt_1;
    }
    return tmp;
  }
  function updateIfMonospaced($this, origin) {
    return equals(origin, Companion_getInstance_326().pls_1) ? DomUtil_getInstance_0().ho6_1 : origin;
  }
  function updateFontMetrics($this) {
    $this.soe_1 = DomUtil_getInstance_0().io6_1.equals($this.roe_1) ? DomUtil_getInstance_0().jo6_1 : TextMetricsCalculator_getInstance().eok($this.roe_1);
  }
  function doSetText($this, text) {
    $this.noe_1 = text;
    updateText($this);
    if ($this.moe_1) {
      updateSelectionBoundsAndText($this);
    }
  }
  function showCaret($this, style) {
    setRootZIndex($this, 1);
    style.borderLeft = '1px solid black';
  }
  function hideCaret($this, style) {
    setRootZIndex($this, 0);
    clearBorderLeft(style);
  }
  function updateCaretVisibility_0($this) {
    var visible = !($this.toe_1 == null);
    if (visible === $this.poe_1)
      return Unit_instance;
    if ($this.poe_1) {
      var caretDiv = DomApi_instance.nkx();
      addClassName(caretDiv, 'user-caret');
      var caretStyle = caretDiv.style;
      setPosition(caretStyle, CssPosition_ABSOLUTE_getInstance());
      setZIndex(caretStyle, 10);
      setTop(caretStyle, 0.0);
      setWidth(caretStyle, 1);
      showCaret($this, caretStyle);
      $this.toe_1 = caretDiv;
      $this.hoe_1.appendChild(ensureNotNull($this.toe_1));
    } else {
      setRootZIndex($this, 0);
      removeFromParent(ensureNotNull($this.toe_1));
      $this.toe_1 = null;
    }
  }
  function setRootZIndex($this, zIndex) {
    setZIndex($this.hoe_1.style, zIndex);
  }
  function updateCaretBounds($this) {
    if ($this.toe_1 == null)
      return Unit_instance;
    var caretStyle = ensureNotNull($this.toe_1).style;
    setLeft(caretStyle, $this.flu($this.joe_1));
    setHeight(caretStyle, numberToInt(_get_lineHeight__binsk0($this)));
  }
  function updateSelectionVisibility($this) {
    var visible = !($this.uoe_1 == null);
    if (visible === $this.moe_1)
      return Unit_instance;
    var tmp = $this;
    var tmp_0;
    if ($this.moe_1) {
      var selectionDiv = DomApi_instance.nkx();
      var selectionStyle = selectionDiv.style;
      setPosition(selectionStyle, CssPosition_ABSOLUTE_getInstance());
      setTop(selectionStyle, 0.0);
      setBackgroundColor(selectionStyle, 'Highlight');
      setColor(selectionStyle, 'HighlightText');
      setZIndex(selectionStyle, 1);
      $this.hoe_1.appendChild(selectionDiv);
      tmp_0 = selectionDiv;
    } else {
      removeFromParent(ensureNotNull($this.uoe_1));
      tmp_0 = null;
    }
    tmp.uoe_1 = tmp_0;
  }
  function updateSelectionBoundsAndText($this) {
    if ($this.uoe_1 == null)
      return Unit_instance;
    var tmp0 = $this.loe_1;
    // Inline function 'kotlin.math.min' call
    var b = $this.koe_1;
    var left = Math.min(tmp0, b);
    var tmp2 = $this.loe_1;
    // Inline function 'kotlin.math.max' call
    var b_0 = $this.koe_1;
    var right = Math.max(tmp2, b_0);
    var tmp0_elvis_lhs = $this.noe_1;
    var text = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    text = text.substring(left, right);
    var selectionStyle = ensureNotNull($this.uoe_1).style;
    setHeight(selectionStyle, numberToInt(_get_lineHeight__binsk0($this)));
    setLeft(selectionStyle, $this.flu(left));
    setWidth(selectionStyle, numberToInt($this.flu(right) - $this.flu(left)));
    ensureNotNull($this.uoe_1).innerText = TextMetricsCalculator_getInstance().fok(text);
  }
  function updateTextAppearance($this) {
    updateColor($this);
    updateFontFamily($this);
    updateFontSize($this);
    updateBold($this);
    updateItalic($this);
    updateText($this);
  }
  function updateColor($this) {
    var tmp0_safe_receiver = $this.qoe_1;
    var color = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qnn();
    setColor($this.hoe_1.style, color);
  }
  function updateBold($this) {
    var fontWeight = $this.roe_1.wlt_1 ? CssFontWeight_BOLD_getInstance() : CssFontWeight_NORMAL_getInstance();
    setFontWeight($this.hoe_1.style, fontWeight);
  }
  function updateItalic($this) {
    var fontStyle = $this.roe_1.xlt_1 ? CssFontStyle_ITALIC_getInstance() : CssFontStyle_NORMAL_getInstance();
    setFontStyle_0($this.hoe_1.style, fontStyle);
  }
  function updateText($this) {
    removeAllChildren($this.ioe_1);
    var text = $this.noe_1;
    // Inline function 'kotlin.text.isNullOrEmpty' call
    if (text == null || charSequenceLength(text) === 0) {
      var textNode = DomApi_instance.tkx('');
      insertFirst($this.ioe_1, textNode);
      setWidth($this.hoe_1.style, 1);
      setHeight($this.hoe_1.style, numberToInt(_get_cachedOrEstimatedLineHeight__5rm6fz($this)));
    } else {
      setTextValue($this, text);
      clearHeight($this.hoe_1.style);
      clearWidth($this.hoe_1.style);
    }
  }
  function setTextValue($this, text) {
    var textStyleRegions = $this.ooe_1;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    if (textStyleRegions == null || textStyleRegions.p()) {
      var textNode = DomApi_instance.tkx(TextMetricsCalculator_getInstance().fok(text));
      insertFirst($this.ioe_1, textNode);
    } else {
      var currentPosition = 0;
      var _iterator__ex2g4s = textStyleRegions.k();
      while (_iterator__ex2g4s.l()) {
        var region = _iterator__ex2g4s.m();
        var start = region.gok_1;
        // Inline function 'kotlin.text.substring' call
        var startIndex = currentPosition;
        // Inline function 'kotlin.js.asDynamic' call
        var defaultColorText = text.substring(startIndex, start);
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(defaultColorText) > 0) {
          $this.ioe_1.appendChild(DomApi_instance.tkx(TextMetricsCalculator_getInstance().fok(defaultColorText)));
        }
        var end = region.hok_1;
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        var regionText = text.substring(start, end);
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(regionText) > 0) {
          var regionSpan = cast_0(DomApi_instance.pkx());
          setColor(regionSpan.style, region.iok_1.qnn());
          if (region.jok_1) {
            setFontWeight(regionSpan.style, CssFontWeight_BOLD_getInstance());
          }
          regionSpan.appendChild(DomApi_instance.tkx(TextMetricsCalculator_getInstance().fok(regionText)));
          $this.ioe_1.appendChild(regionSpan);
        }
        currentPosition = end;
      }
      // Inline function 'kotlin.text.substring' call
      var startIndex_0 = currentPosition;
      // Inline function 'kotlin.js.asDynamic' call
      var lastDefaultColorText = text.substring(startIndex_0);
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(lastDefaultColorText) > 0) {
        $this.ioe_1.appendChild(DomApi_instance.tkx(TextMetricsCalculator_getInstance().fok(lastDefaultColorText)));
      }
    }
  }
  function updateFontFamily($this) {
    setFontFamily($this.hoe_1.style, $this.roe_1.ult_1.toString());
  }
  function updateFontSize($this) {
    setFontSize($this.hoe_1.style, $this.roe_1.vlt_1);
  }
  function containsChinese($this, prefix) {
    // Inline function 'kotlin.text.toRegex' call
    var this_0 = '.*[\u3400-\u9FBF]+.*';
    // Inline function 'kotlin.text.matches' call
    return Regex_init_$Create$(this_0).ud(prefix);
  }
  function clearTextDecorations($this) {
    if (!($this.voe_1 == null)) {
      var _iterator__ex2g4s = ensureNotNull($this.voe_1).k();
      while (_iterator__ex2g4s.l()) {
        var decoration = _iterator__ex2g4s.m();
        removeFromParent(decoration);
      }
      $this.voe_1 = null;
    }
  }
  function addBackgroundHighlight($this, color, startPos, endPos) {
    ensureTextDecorationsInited($this);
    var overlay = DomApi_instance.nkx();
    var style = overlay.style;
    setBackgroundColor(style, color.qnn());
    applyAbsoluteStyle($this, style, startPos, endPos);
    $this.hoe_1.appendChild(overlay);
    ensureNotNull($this.voe_1).e(overlay);
  }
  function addRedUnderline($this, from, to) {
    ensureTextDecorationsInited($this);
    var div = DomApi_instance.nkx();
    addClassName(div, Companion_getInstance_345().bok_1.yo2_1);
    var style = div.style;
    applyAbsoluteStyle($this, style, from, to);
    $this.hoe_1.appendChild(div);
    ensureNotNull($this.voe_1).e(div);
  }
  function applyAbsoluteStyle($this, style, from, to) {
    setPosition(style, CssPosition_ABSOLUTE_getInstance());
    setTop(style, 0.0);
    setZIndex(style, -1);
    setHeight(style, numberToInt(_get_lineHeight__binsk0($this)));
    var startOffset = $this.flu(from);
    var endOffset = $this.flu(to);
    setLeft(style, startOffset);
    setWidth(style, numberToInt(endOffset - startOffset));
  }
  function ensureTextDecorationsInited($this) {
    if ($this.voe_1 == null) {
      $this.voe_1 = ArrayList_init_$Create$_0(1);
    }
  }
  function Companion_345() {
    Companion_instance_345 = this;
    this.bok_1 = Companion_getInstance_334().x52();
    this.cok_1 = new ListMap();
  }
  var Companion_instance_345;
  function Companion_getInstance_345() {
    if (Companion_instance_345 == null)
      new Companion_345();
    return Companion_instance_345;
  }
  function DomTextEditor(root) {
    Companion_getInstance_345();
    this.hoe_1 = root;
    this.ioe_1 = DomApi_instance.nkx();
    this.joe_1 = 0;
    this.koe_1 = 0;
    this.loe_1 = 0;
    this.moe_1 = false;
    this.noe_1 = null;
    this.ooe_1 = null;
    this.poe_1 = false;
    this.qoe_1 = null;
    this.roe_1 = DomUtil_getInstance_0().io6_1;
    this.soe_1 = DomUtil_getInstance_0().jo6_1;
    this.toe_1 = null;
    this.uoe_1 = null;
    this.voe_1 = null;
    insertFirst(this.hoe_1, this.ioe_1);
    var rootStyle = this.hoe_1.style;
    setPosition(rootStyle, CssPosition_RELATIVE_getInstance());
    setWhiteSpace(rootStyle, CssWhiteSpace_NOWRAP_getInstance());
    updateTextAppearance(this);
    updateCaretVisibility_0(this);
    updateCaretBounds(this);
    updateSelectionVisibility(this);
    updateSelectionBoundsAndText(this);
  }
  protoOf(DomTextEditor).koh = function (caretPosition) {
    if (this.joe_1 === caretPosition)
      return Unit_instance;
    this.joe_1 = caretPosition;
    updateCaretBounds(this);
    if (this.moe_1) {
      updateSelectionBoundsAndText(this);
    }
    if (!(this.toe_1 == null)) {
      showCaret(this, ensureNotNull(this.toe_1).style);
    }
  };
  protoOf(DomTextEditor).roh = function (selectionStart) {
    if (this.koe_1 === selectionStart)
      return Unit_instance;
    this.koe_1 = selectionStart;
    updateSelectionBoundsAndText(this);
  };
  protoOf(DomTextEditor).qoh = function (visible) {
    if (this.moe_1 === visible)
      return Unit_instance;
    this.moe_1 = visible;
    updateSelectionVisibility(this);
    updateSelectionBoundsAndText(this);
  };
  protoOf(DomTextEditor).eoh = function (caretVisible) {
    if (this.poe_1 === caretVisible)
      return Unit_instance;
    this.poe_1 = caretVisible;
    updateCaretVisibility_0(this);
    updateCaretBounds(this);
  };
  protoOf(DomTextEditor).loh = function (textColor) {
    if (equals(textColor, this.qoe_1))
      return Unit_instance;
    this.qoe_1 = textColor;
    updateColor(this);
  };
  protoOf(DomTextEditor).woe = function (text) {
    if (text == this.noe_1)
      return Unit_instance;
    doSetText(this, text);
  };
  protoOf(DomTextEditor).laz = function () {
    return this.noe_1;
  };
  protoOf(DomTextEditor).moh = function (bold) {
    if (this.roe_1.wlt_1 === bold)
      return Unit_instance;
    this.roe_1 = new Font(this.roe_1.ult_1, this.roe_1.vlt_1, bold, this.roe_1.xlt_1);
    updateFontMetrics(this);
    updateBold(this);
  };
  protoOf(DomTextEditor).noh = function (italic) {
    if (this.roe_1.xlt_1 === italic)
      return Unit_instance;
    this.roe_1 = new Font(this.roe_1.ult_1, this.roe_1.vlt_1, this.roe_1.wlt_1, italic);
    updateFontMetrics(this);
    updateItalic(this);
  };
  protoOf(DomTextEditor).ooh = function (origin) {
    var family = updateIfMonospaced(this, origin);
    if (equals(this.roe_1.ult_1, family))
      return Unit_instance;
    this.roe_1 = new Font(family, this.roe_1.vlt_1, this.roe_1.wlt_1, this.roe_1.xlt_1);
    updateFontMetrics(this);
    updateFontFamily(this);
    updateCaretBounds(this);
  };
  protoOf(DomTextEditor).poh = function (size) {
    if (this.roe_1.vlt_1 === size)
      return Unit_instance;
    this.roe_1 = new Font(this.roe_1.ult_1, size, this.roe_1.wlt_1, this.roe_1.xlt_1);
    updateFontMetrics(this);
    updateFontSize(this);
    updateText(this);
    updateCaretBounds(this);
    updateSelectionVisibility(this);
    updateSelectionBoundsAndText(this);
  };
  protoOf(DomTextEditor).joh = function (text, textStyleRegions) {
    if (text === this.noe_1 && equals(this.ooe_1, textStyleRegions))
      return Unit_instance;
    this.ooe_1 = textStyleRegions;
    doSetText(this, text);
  };
  protoOf(DomTextEditor).soh = function (end) {
    if (this.loe_1 === end)
      return Unit_instance;
    this.loe_1 = end;
    updateSelectionBoundsAndText(this);
  };
  protoOf(DomTextEditor).flu = function (caretOffset) {
    if (caretOffset === 0 || this.noe_1 == null)
      return 0.0;
    var tmp;
    if (_get_isCurrentFontMonospaced__wrvp72(this)) {
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      var prefix = ensureNotNull(this.noe_1).substring(0, caretOffset);
      var tmp_0;
      if (containsChinese(this, prefix)) {
        tmp_0 = TextMetricsCalculator_getInstance().dok(this.roe_1, prefix);
      } else {
        tmp_0 = caretOffset * this.soe_1.foa().skt_1;
      }
      tmp = tmp_0;
    } else {
      var tmp_1 = TextMetricsCalculator_getInstance();
      var tmp_2 = this.roe_1;
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = ensureNotNull(this.noe_1).substring(0, caretOffset);
      tmp = tmp_1.dok(tmp_2, tmp$ret$3);
    }
    return tmp;
  };
  protoOf(DomTextEditor).ioh = function (caretOffset) {
    if (caretOffset <= 0)
      return 0;
    var text = this.noe_1;
    // Inline function 'kotlin.text.isNullOrEmpty' call
    if (text == null || charSequenceLength(text) === 0)
      return 0;
    if (_get_isCurrentFontMonospaced__wrvp72(this)) {
      var charWidth = _get_charWidth__5ojr27(this);
      var pos = caretOffset / charWidth;
      var tail = caretOffset % charWidth;
      if (tail > charWidth / 2) {
        pos = pos + 1.0;
      }
      var len = text.length;
      return pos > len ? len : numberToInt(pos);
    }
    var inductionVariable = 0;
    var last = text.length;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (TextMetricsCalculator_getInstance().dok(this.roe_1, take_1(text, i)) >= caretOffset)
          return i;
      }
       while (!(i === last));
    return text.length;
  };
  protoOf(DomTextEditor).toh = function (textDecorations) {
    clearTextDecorations(this);
    if (this.noe_1 == null)
      return Unit_instance;
    var _iterator__ex2g4s = TextDecorations_getInstance().clh(textDecorations).k();
    while (_iterator__ex2g4s.l()) {
      var current = _iterator__ex2g4s.m();
      var range = TextDecorations_getInstance().dlh(current, ensureNotNull(this.noe_1).length);
      if (!range.p()) {
        var lowerEndpoint = range.n2s_1;
        var upperEndpoint = range.x2s();
        if (current instanceof BackgroundHighlightTextDecoration) {
          addBackgroundHighlight(this, current.xlg_1, lowerEndpoint, upperEndpoint);
        } else {
          if (current instanceof RedUnderlineTextDecoration) {
            addRedUnderline(this, lowerEndpoint, upperEndpoint);
          } else {
            throw IllegalArgumentException_init_$Create$_0('Unknown decoration kind: ' + toString_1(getKClassFromExpression(current)));
          }
        }
      }
    }
  };
  protoOf(DomTextEditor).goh = function () {
    if (this.toe_1 == null)
      return Unit_instance;
    var style = ensureNotNull(this.toe_1).style;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = style.borderLeft;
    if (charSequenceLength(this_0) === 0) {
      showCaret(this, style);
    } else {
      hideCaret(this, style);
    }
  };
  function visiblePart($this, ctx, relativeRect) {
    var currentContext = ctx;
    var currentAbsoluteRect = relativeRect.jku(new Vector(numberToInt(getAbsoluteLeft(currentContext)), numberToInt(getAbsoluteTop(currentContext))));
    while (true) {
      var offsetParent = currentContext.offsetParent;
      if (offsetParent == null) {
        var windowBounds = $this.kok();
        var tmp;
        if (!windowBounds.qku(currentAbsoluteRect)) {
          tmp = null;
        } else {
          tmp = windowBounds.rku(currentAbsoluteRect);
        }
        return tmp;
      }
      var tmp_0;
      if (Scrolling_instance.lok(currentContext)) {
        tmp_0 = getAbsoluteClientAreaBounds($this, currentContext);
      } else {
        tmp_0 = $this.ko6(currentContext);
      }
      var ctxBounds = tmp_0;
      if (!ctxBounds.qku(currentAbsoluteRect)) {
        return null;
      }
      currentAbsoluteRect = ctxBounds.rku(currentAbsoluteRect);
      currentContext = cast_0(offsetParent);
    }
  }
  function getAbsoluteClientAreaBounds($this, element) {
    var absoluteOrigin = getAbsoluteOrigin($this, element);
    var offsetDimension = getOffsetDimension($this, element);
    var clientDimension = getClientDimension($this, element);
    if (offsetDimension.equals(clientDimension)) {
      return new Rectangle(absoluteOrigin, offsetDimension);
    }
    var clientAreaOffset = new Vector($this.aoh(element), $this.coh(element));
    return new Rectangle(absoluteOrigin.jku(clientAreaOffset), clientDimension);
  }
  function getAbsoluteOrigin($this, element) {
    return new Vector(numberToInt(getAbsoluteLeft(element)), numberToInt(getAbsoluteTop(element)));
  }
  function getOffsetDimension($this, element) {
    return new Vector(element.offsetWidth, element.offsetHeight);
  }
  function getScrollDimension($this, element) {
    return new Vector(element.scrollWidth, element.scrollHeight);
  }
  function getClientDimension($this, element) {
    return new Vector(element.clientWidth, element.clientHeight);
  }
  function getLeftPadding($this, element) {
    return getPixelsProperty($this, element, 'padding-left');
  }
  function getTopPadding($this, element) {
    return getPixelsProperty($this, element, 'padding-top');
  }
  function getPixelsProperty($this, element, property) {
    var value = getProperty(DomApi_instance.mkx().getComputedStyle(element), property);
    if (!endsWith(value, 'px')) {
      $this.go6_1.fo(getValueMessage($this, value));
      return 0;
    }
    var tmp;
    try {
      // Inline function 'kotlin.text.toFloat' call
      var this_0 = replace(value, 'px', '');
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var subpixelValue = toDouble(this_0);
      // Inline function 'kotlin.math.roundToInt' call
      tmp = roundToInt(subpixelValue);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof NumberFormatException) {
        var e = $p;
        ThrowableHandlers_getInstance().ps_1.os(e);
        tmp_0 = 0;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function getValueMessage($this, value) {
    return 'Bad value: ' + value;
  }
  function DomUtil$scheduleDeferred$lambda($cancelled, $runnable) {
    return function () {
      var tmp;
      if (!$cancelled._v) {
        tmp = $runnable();
      }
      return Unit_instance;
    };
  }
  function DomUtil$scheduleDeferred$$inlined$toDisposable$1($cancelled) {
    this.mok_1 = $cancelled;
  }
  protoOf(DomUtil$scheduleDeferred$$inlined$toDisposable$1).vr = function () {
    this.mok_1._v = true;
    return Unit_instance;
  };
  function DomUtil_0() {
    DomUtil_instance_0 = this;
    this.go6_1 = getLogger(getKClass(DomUtil_0));
    this.ho6_1 = Companion_getInstance_326().s8r("Menlo, Consolas, Monaco, 'Courier New', monospace");
    this.io6_1 = new Font(this.ho6_1, 14);
    this.jo6_1 = TextMetricsCalculator_getInstance().eok(this.io6_1);
  }
  protoOf(DomUtil_0).kok = function () {
    return new Rectangle(Companion_getInstance_251().iku_1, new Vector(this.xof(), this.yof()));
  };
  protoOf(DomUtil_0).xof = function () {
    return ensureNotNull(DomApi_instance.lkx().documentElement).clientWidth;
  };
  protoOf(DomUtil_0).yof = function () {
    return ensureNotNull(DomApi_instance.lkx().documentElement).clientHeight;
  };
  protoOf(DomUtil_0).jo9 = function (ctx) {
    var htmlElement = cast_0(ctx);
    return visiblePart(this, htmlElement, new Rectangle(Companion_getInstance_251().iku_1, new Vector(ctx.scrollWidth, ctx.scrollHeight)));
  };
  protoOf(DomUtil_0).ho7 = function (ctx) {
    return new Vector(getLeftPadding(this, ctx), getTopPadding(this, ctx));
  };
  protoOf(DomUtil_0).lo6 = function (element) {
    return new Rectangle(getAbsoluteOrigin(this, element), getOffsetDimension(this, element));
  };
  protoOf(DomUtil_0).ko6 = function (element) {
    return new Rectangle(getAbsoluteOrigin(this, element), getScrollDimension(this, element));
  };
  protoOf(DomUtil_0).aoh = function (element) {
    return getPixelsProperty(this, element, 'border-left-width');
  };
  protoOf(DomUtil_0).boh = function (element) {
    return getPixelsProperty(this, element, 'border-right-width');
  };
  protoOf(DomUtil_0).coh = function (element) {
    return getPixelsProperty(this, element, 'border-top-width');
  };
  protoOf(DomUtil_0).doh = function (element) {
    return getPixelsProperty(this, element, 'border-bottom-width');
  };
  protoOf(DomUtil_0).ro9 = function (runnable) {
    var cancelled = {_v: false};
    var tmp = Companion_getInstance_31().k2n_1;
    tmp.l2n(DomUtil$scheduleDeferred$lambda(cancelled, runnable));
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new DomUtil$scheduleDeferred$$inlined$toDisposable$1(cancelled);
  };
  var DomUtil_instance_0;
  function DomUtil_getInstance_0() {
    if (DomUtil_instance_0 == null)
      new DomUtil_0();
    return DomUtil_instance_0;
  }
  function _get_withDefault__8or87q(_this__u8e3s4, $this) {
    return _this__u8e3s4 == null ? CssOverflow_AUTO_getInstance() : _this__u8e3s4;
  }
  function isOverflowScrollOrAuto($this, overflow) {
    return overflow === CssOverflow_AUTO_getInstance() || overflow === CssOverflow_SCROLL_getInstance();
  }
  function trimToElement($this, rect, elem) {
    return rect.rku(Rectangle_init_$Create$(0, 0, elem.scrollWidth, elem.scrollHeight));
  }
  function adjustScrollers($this, target, element) {
    var targetAbs = target.jku(getAbsoluteLeftTop($this, element));
    var parent = element.parentElement;
    $l$loop: while (!(parent == null)) {
      if (!$this.lok(parent)) {
        parent = parent.parentElement;
        continue $l$loop;
      }
      var scrollTop = parent.scrollTop;
      var parentTop = getAbsoluteTop(parent);
      var parentHeight = parent.clientHeight;
      var scrollLeft = parent.scrollLeft;
      var parentLeft = getAbsoluteLeft(parent);
      var parentWidth = parent.clientWidth;
      var visX = Companion_instance_36.p2s(numberToInt(parentLeft), parentWidth);
      var targetX = targetAbs.uku();
      var deltaX = getDelta_0($this, visX, targetX);
      if (!(deltaX === 0)) {
        parent.scrollLeft = scrollLeft + deltaX;
        var delta = new Vector(deltaX, 0);
        targetAbs = targetAbs.kku(delta);
      }
      var visY = Companion_instance_36.p2s(numberToInt(parentTop), parentHeight);
      var targetY = targetAbs.vku();
      var deltaY = getDelta_0($this, visY, targetY);
      if (!(deltaY === 0)) {
        parent.scrollTop = scrollTop + deltaY;
        var delta_0 = new Vector(0, deltaY);
        targetAbs = targetAbs.kku(delta_0);
      }
      parent = parent.parentElement;
    }
  }
  function getAbsoluteLeftTop($this, element) {
    return new Vector(numberToInt(getAbsoluteLeft(element)), numberToInt(getAbsoluteTop(element)));
  }
  function scrollWindow($this, winBounds, targetBounds) {
    if (winBounds.lku(targetBounds)) {
      return Unit_instance;
    }
    var deltaX = getDelta($this, winBounds, targetBounds, x$factory_0());
    var deltaY = getDelta($this, winBounds, targetBounds, y$factory());
    if (deltaX === 0 && deltaY === 0) {
      return Unit_instance;
    }
    var window_0 = DomApi_instance.mkx();
    window_0.scrollTo(window_0.scrollX + deltaX, window_0.scrollY + deltaY);
  }
  function getDelta($this, a, b, getDim) {
    var aInterval = getInterval($this, a, getDim);
    var bInterval = getInterval($this, b, getDim);
    return getDelta_0($this, aInterval, bInterval);
  }
  function getInterval($this, rectangle, getDim) {
    return Companion_instance_36.p2s(getDim(rectangle.cku_1), getDim(rectangle.dku_1));
  }
  function getDelta_0($this, vis, target) {
    if (vis.a() < target.a()) {
      var tmp;
      if (vis.c2t(target)) {
        tmp = 0;
      } else {
        tmp = target.n2s_1 - vis.n2s_1 | 0;
      }
      return tmp;
    }
    if (target.n2s_1 < vis.n2s_1) {
      return target.n2s_1 - vis.n2s_1 | 0;
    }
    var tmp_0;
    if (target.o2s_1 > vis.o2s_1) {
      tmp_0 = target.o2s_1 - vis.o2s_1 | 0;
    } else {
      tmp_0 = 0;
    }
    return tmp_0;
  }
  function Scrolling() {
  }
  protoOf(Scrolling).joa = function () {
    var window_0 = DomApi_instance.mkx();
    return Rectangle_init_$Create$(numberToInt(window_0.scrollX), numberToInt(window_0.scrollY), DomUtil_getInstance_0().xof(), DomUtil_getInstance_0().yof());
  };
  protoOf(Scrolling).to5 = function (element) {
    return DomUtil_getInstance_0().ko6(element);
  };
  protoOf(Scrolling).lok = function (element) {
    var style = DomApi_instance.mkx().getComputedStyle(element);
    return isOverflowScrollOrAuto(this, _get_withDefault__8or87q(get_cssOverflow(style), this)) || isOverflowScrollOrAuto(this, _get_withDefault__8or87q(get_cssOverflowX(style), this)) || isOverflowScrollOrAuto(this, _get_withDefault__8or87q(get_cssOverflowY(style), this));
  };
  protoOf(Scrolling).go7 = function (rawTarget, element) {
    var target = trimToElement(this, rawTarget, element);
    adjustScrollers(this, target, element);
    var winAbsBounds = DomUtil_getInstance_0().kok();
    var elementAbsBounds = this.to5(element);
    var targetAbsBounds = target.jku(elementAbsBounds.cku_1);
    scrollWindow(this, winAbsBounds, targetAbsBounds);
  };
  var Scrolling_instance;
  function Scrolling_getInstance() {
    return Scrolling_instance;
  }
  function x$factory_0() {
    return getPropertyCallableRef('x', 1, KProperty1, function (receiver) {
      return receiver.eku_1;
    }, null);
  }
  function y$factory() {
    return getPropertyCallableRef('y', 1, KProperty1, function (receiver) {
      return receiver.fku_1;
    }, null);
  }
  function _get_isFirefox__qyvnc2($this) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var agent = DomApi_instance.mkx().navigator.userAgent.toLowerCase();
    return contains_9(agent, 'firefox');
  }
  function calculateDimension($this, font, text) {
    return new DoubleVector($this.dok(font, text), adjustHeight($this, font.vlt_1));
  }
  function calculateWidthByCanvas($this, font, text) {
    var canvas_0 = canvas($this);
    var ctx = get_context2d(canvas_0);
    ctx.font = getFontString($this, font);
    return ctx.measureText($this.fok(text)).width;
  }
  function calculateWidthByElement($this, font, text) {
    var span = cast_0(DomApi_instance.pkx());
    var style = span.style;
    setDisplay(style, CssDisplay_INLINE_BLOCK_getInstance());
    setVisibility(style, CssVisibility_HIDDEN_getInstance());
    setFont(style, getFontString($this, font));
    span.innerText = text;
    ensureNotNull(DomApi_instance.lkx().body).appendChild(span);
    var width = span.getBoundingClientRect().width;
    removeFromParent(span);
    return width;
  }
  function adjustHeight($this, height) {
    return _get_isFirefox__qyvnc2($this) ? height + 1 | 0 : height;
  }
  function fontBaseLine($this, font) {
    var allCharsHeight = measureHeight($this, font, $this.coa_1);
    var ascent = measureHeight($this, font, 'A');
    var lineSpace = font.vlt_1 - allCharsHeight | 0;
    return (lineSpace / 2 | 0) + ascent | 0;
  }
  function measureHeight($this, font, text) {
    var canvas_0 = canvas($this);
    var ctx = get_context2d(canvas_0);
    ctx.font = getFontString($this, font);
    ctx.fillStyle = 'rgb(255, 0, 0)';
    var width = ctx.measureText(text).width;
    var canvasHeight = imul(font.vlt_1, 2);
    canvas_0.height = canvasHeight;
    canvas_0.height = imul(font.vlt_1, 2);
    canvas_0.width = numberToInt(width);
    ctx.fillText(text, 0.0, font.vlt_1);
    var imageData = ctx.getImageData(0.0, 0.0, width, canvasHeight);
    var imageDataArray = imageData.data;
    var firstY = canvasHeight - 1 | 0;
    var lastY = 0;
    var inductionVariable = 0;
    var last = numberToInt(width);
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < canvasHeight)
          do {
            var y = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'org.khronos.webgl.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var red = imageDataArray[imul(4, x + imul(y, imageData.width) | 0)];
            if (!(red === 0)) {
              if (firstY > y) {
                firstY = y;
              }
              if (lastY < y) {
                lastY = y;
              }
            }
          }
           while (inductionVariable_0 < canvasHeight);
      }
       while (inductionVariable < last);
    return lastY - firstY | 0;
  }
  function getFontString($this, font) {
    var result = StringBuilder_init_$Create$_1();
    if (font.wlt_1) {
      result.d9(' bold');
    }
    if (font.xlt_1) {
      result.d9(' italic');
    }
    result.e9(_Char___init__impl__6a9atx(32)).ad(font.vlt_1).d9('px ').c9(font.ult_1);
    return result.toString();
  }
  function canvas($this) {
    return DomApi_instance.qkx();
  }
  function TextMetricsCalculator$calculateApprox$1($dimension, $font) {
    this.nok_1 = $dimension;
    this.ook_1 = $font;
  }
  protoOf(TextMetricsCalculator$calculateApprox$1).foa = function () {
    return this.nok_1;
  };
  protoOf(TextMetricsCalculator$calculateApprox$1).pok = function () {
    return imul(2, this.ook_1.vlt_1) / 3 | 0;
  };
  function TextMetricsCalculator$calculate$1($dimension, $baseLine) {
    this.qok_1 = $dimension;
    this.rok_1 = $baseLine;
  }
  protoOf(TextMetricsCalculator$calculate$1).foa = function () {
    return this.qok_1;
  };
  protoOf(TextMetricsCalculator$calculate$1).pok = function () {
    return this.rok_1;
  };
  function TextMetricsCalculator() {
    TextMetricsCalculator_instance = this;
    this.aoa_1 = 'x';
    this.boa_1 = 4;
    this.coa_1 = Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122)).toString() + Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90)).toString();
    this.doa_1 = HashMap_init_$Create$();
  }
  protoOf(TextMetricsCalculator).eok = function (font) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.doa_1;
    var value = this_0.y2(font);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.ocelot.projectional.domUtil.TextMetricsCalculator.calculate.<anonymous>' call
      var answer = TextMetricsCalculator_getInstance().eoa(font, 'x');
      this_0.r2(font, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    return tmp;
  };
  protoOf(TextMetricsCalculator).sok = function (font, text) {
    var dimension = calculateDimension(this, font, text);
    return new TextMetricsCalculator$calculateApprox$1(dimension, font);
  };
  protoOf(TextMetricsCalculator).eoa = function (font, text) {
    var dimension = calculateDimension(this, font, text);
    var baseLine = fontBaseLine(this, font);
    return new TextMetricsCalculator$calculate$1(dimension, baseLine);
  };
  protoOf(TextMetricsCalculator).dok = function (font, text) {
    return _get_isFirefox__qyvnc2(this) ? calculateWidthByElement(this, font, text) : calculateWidthByCanvas(this, font, text);
  };
  protoOf(TextMetricsCalculator).fok = function (text) {
    // Inline function 'kotlin.text.toRegex' call
    // Inline function 'kotlin.text.replace' call
    return Regex_init_$Create$(' ').zd(text, '\xA0');
  };
  var TextMetricsCalculator_instance;
  function TextMetricsCalculator_getInstance() {
    if (TextMetricsCalculator_instance == null)
      new TextMetricsCalculator();
    return TextMetricsCalculator_instance;
  }
  function DomView() {
  }
  function BaseViewMapper$registerSynchronizers$o$doAttach$lambda($valid, $positionInParent, this$0, $targetStyle) {
    return function () {
      var tmp;
      if ($valid._v) {
        return Unit_instance;
      }
      var _destruct__k2r9zo = $positionInParent.qr();
      var origin = _destruct__k2r9zo.ug();
      var dimension = _destruct__k2r9zo.vg();
      var tmp_0;
      if (!_get_isDomPosition__rgfrao(this$0)) {
        setLeft($targetStyle, origin.eku_1);
        setTop($targetStyle, origin.fku_1);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if (!this$0.col()) {
        var width = dimension.eku_1;
        var height = dimension.fku_1;
        setWidth($targetStyle, width);
        setHeight($targetStyle, height);
        tmp_1 = Unit_instance;
      }
      $valid._v = true;
      return Unit_instance;
    };
  }
  function BaseViewMapper$registerSynchronizers$o$doAttach$lambda$lambda($valid, $positionInParent, this$0, $targetStyle) {
    return function () {
      var tmp;
      if ($valid._v) {
        return Unit_instance;
      }
      var _destruct__k2r9zo = $positionInParent.qr();
      var origin = _destruct__k2r9zo.ug();
      var dimension = _destruct__k2r9zo.vg();
      var tmp_0;
      if (!_get_isDomPosition__rgfrao(this$0)) {
        setLeft($targetStyle, origin.eku_1);
        setTop($targetStyle, origin.fku_1);
        tmp_0 = Unit_instance;
      }
      var tmp_1;
      if (!this$0.col()) {
        var width = dimension.eku_1;
        var height = dimension.fku_1;
        setWidth($targetStyle, width);
        setHeight($targetStyle, height);
        tmp_1 = Unit_instance;
      }
      $valid._v = true;
      return Unit_instance;
    };
  }
  function BaseViewMapper$registerSynchronizers$o$doAttach$lambda_0($valid, this$0, $positionInParent, $targetStyle) {
    return function (it) {
      $valid._v = false;
      this$0.dol(BaseViewMapper$registerSynchronizers$o$doAttach$lambda$lambda($valid, $positionInParent, this$0, $targetStyle));
      return Unit_instance;
    };
  }
  function BaseViewMapper$registerSynchronizers$o$doAttach$lambda_1(this$0, $targetStyle) {
    return function (it) {
      var border = this$0.pl9_1.pnp().m2c();
      if (border == null) {
        clearOutlineStyle($targetStyle);
        clearOutlineColor($targetStyle);
        clearBorderWidth($targetStyle);
      } else {
        setOutlineColor($targetStyle, border.qnn());
        setOutlineWidth($targetStyle, this$0.pl9_1.qnp().m2c());
        setOutlineStyle($targetStyle, CssOutlineStyle_SOLID_getInstance());
      }
      return Unit_instance;
    };
  }
  function BaseViewMapper$registerSynchronizers$o$set$lambda($targetStyle, $value) {
    return function () {
      setDisplay($targetStyle, $value ? CssDisplay_BLOCK_getInstance() : CssDisplay_NONE_getInstance());
      return Unit_instance;
    };
  }
  function _get_isDomPosition__rgfrao($this) {
    var tmp = $this.ul9_1;
    var tmp0_safe_receiver = tmp instanceof BaseViewMapper ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.col();
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  function BaseViewMapper$whenValid$lambda(this$0, $r, $disposable) {
    return function (it) {
      this$0.dol($r);
      var tmp0_safe_receiver = $disposable._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.vr();
      }
      return Unit_instance;
    };
  }
  function BaseViewMapper$registerSynchronizers$lambda(this$0, $it) {
    return function () {
      var sourceBounds = this$0.pl9_1.dnq().m2c();
      var parentSourceBounds = $it.pl9_1.dnq().m2c();
      return sourceBounds.kku(parentSourceBounds.cku_1);
    };
  }
  function BaseViewMapper$registerSynchronizers$$inlined$forEventSource$1($valid, this$0, $src, $positionInParent, $targetStyle) {
    this.fol_1 = $valid;
    this.gol_1 = this$0;
    this.hol_1 = $src;
    this.iol_1 = $positionInParent;
    this.jol_1 = $targetStyle;
    DisposableSynchronizer.call(this);
  }
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$forEventSource$1).dlb = function (ctx) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.BaseViewMapper.registerSynchronizers.<anonymous>' call
    this.fol_1._v = false;
    this.gol_1.dol(BaseViewMapper$registerSynchronizers$o$doAttach$lambda(this.fol_1, this.iol_1, this.gol_1, this.jol_1));
    return this.hol_1.p27(BaseViewMapper$registerSynchronizers$o$doAttach$lambda_0(this.fol_1, this.gol_1, this.iol_1, this.jol_1));
  };
  function BaseViewMapper$registerSynchronizers$$inlined$writableProperty$1($targetStyle) {
    this.kol_1 = $targetStyle;
  }
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    var tmp1_safe_receiver = newValue == null ? null : newValue.qnn();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.BaseViewMapper.registerSynchronizers.<anonymous>.<anonymous>' call
      setBackgroundColor(this.kol_1, tmp1_safe_receiver);
      tmp = tmp1_safe_receiver;
    }
    if (tmp == null)
      clearBackgroundColor(this.kol_1);
    return Unit_instance;
  };
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function BaseViewMapper$registerSynchronizers$$inlined$forEventSource$2(this$0, $targetStyle, $src) {
    this.mol_1 = this$0;
    this.nol_1 = $targetStyle;
    this.ool_1 = $src;
    DisposableSynchronizer.call(this);
  }
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$forEventSource$2).dlb = function (ctx) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.BaseViewMapper.registerSynchronizers.<anonymous>' call
    var border = this.mol_1.pl9_1.pnp().m2c();
    if (border == null) {
      clearOutlineStyle(this.nol_1);
      clearOutlineColor(this.nol_1);
      clearBorderWidth(this.nol_1);
    } else {
      setOutlineColor(this.nol_1, border.qnn());
      setOutlineWidth(this.nol_1, this.mol_1.pl9_1.qnp().m2c());
      setOutlineStyle(this.nol_1, CssOutlineStyle_SOLID_getInstance());
    }
    return this.ool_1.p27(BaseViewMapper$registerSynchronizers$o$doAttach$lambda_1(this.mol_1, this.nol_1));
  };
  function BaseViewMapper$registerSynchronizers$$inlined$writableProperty$2(this$0, $targetStyle) {
    this.pol_1 = this$0;
    this.qol_1 = $targetStyle;
  }
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$2).bm7 = function (newValue) {
    this.pol_1.dol(BaseViewMapper$registerSynchronizers$o$set$lambda(this.qol_1, newValue));
    return Unit_instance;
  };
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$2).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function BaseViewMapper$registerSynchronizers$$inlined$writableProperty$3($targetStyle) {
    this.rol_1 = $targetStyle;
  }
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$3).bm7 = function (newValue) {
    if (newValue)
      setBoxShadow(this.rol_1, '2px 2px 4px black');
    else
      clearBoxShadow(this.rol_1);
    return Unit_instance;
  };
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$3).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function BaseViewMapper(context, source, target) {
    Mapper.call(this, source, target);
    this.aol_1 = context;
    this.bol_1 = false;
    var tmp0_safe_receiver = source.xno_1;
    if (source === (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ro1())) {
      setZIndex(target.style, 100);
    }
  }
  protoOf(BaseViewMapper).col = function () {
    return this.bol_1;
  };
  protoOf(BaseViewMapper).dol = function (r) {
    var container = this.pl9_1.xno_1;
    if (container == null) {
      var disposable = {_v: null};
      var tmp = this.pl9_1.jnq();
      disposable._v = tmp.p27(BaseViewMapper$whenValid$lambda(this, r, disposable));
    } else {
      container.so1(r);
    }
  };
  protoOf(BaseViewMapper).llb = function (conf) {
    protoOf(Mapper).llb.call(this, conf);
    var targetStyle = this.ql9_1.style;
    if (!_get_isDomPosition__rgfrao(this)) {
      setPosition(targetStyle, CssPosition_ABSOLUTE_getInstance());
    } else {
      setPosition(targetStyle, CssPosition_RELATIVE_getInstance());
    }
    if (!_get_isDomPosition__rgfrao(this) || !this.col()) {
      var tmp = this.ul9_1;
      var tmp0_safe_receiver = tmp instanceof BaseViewMapper ? tmp : null;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.BaseViewMapper.registerSynchronizers.<anonymous>' call
        tmp_0 = toDerivedProperty(BaseViewMapper$registerSynchronizers$lambda(this, tmp0_safe_receiver), [this.pl9_1.dnq(), tmp0_safe_receiver.pl9_1.dnq()]);
      }
      var tmp1_elvis_lhs = tmp_0;
      var positionInParent = tmp1_elvis_lhs == null ? this.pl9_1.dnq() : tmp1_elvis_lhs;
      var valid = {_v: null};
      // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forEventSource' call
      var src = EventSources_instance.n2b([positionInParent, this.pl9_1.pnp(), this.pl9_1.qnp()]);
      var tmp$ret$2 = new BaseViewMapper$registerSynchronizers$$inlined$forEventSource$1(valid, this, src, positionInParent, targetStyle);
      conf.x4v(tmp$ret$2);
    }
    var tmp_1 = this.pl9_1.ily();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$3 = new BaseViewMapper$registerSynchronizers$$inlined$writableProperty$1(targetStyle);
    conf.x4v(syncOneWay(tmp_1, tmp$ret$3));
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forEventSource' call
    var src_0 = EventSources_instance.n2b([this.pl9_1.pnp(), this.pl9_1.qnp()]);
    var tmp$ret$4 = new BaseViewMapper$registerSynchronizers$$inlined$forEventSource$2(this, targetStyle, src_0);
    conf.x4v(tmp$ret$4);
    var tmp_2 = this.pl9_1.elp();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$5 = new BaseViewMapper$registerSynchronizers$$inlined$writableProperty$2(this, targetStyle);
    conf.x4v(syncOneWay(tmp_2, tmp$ret$5));
    var tmp_3 = this.pl9_1.rnp();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$6 = new BaseViewMapper$registerSynchronizers$$inlined$writableProperty$3(targetStyle);
    conf.x4v(syncOneWay(tmp_3, tmp$ret$6));
  };
  protoOf(BaseViewMapper).sol = function () {
    // Inline function 'kotlin.apply' call
    var this_0 = SvgUtil_instance.tol();
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.BaseViewMapper.createSVG.<anonymous>' call
    setPosition(this_0.style, CssPosition_ABSOLUTE_getInstance());
    setLeft(this_0.style, 0);
    setTop(this_0.style, 0);
    return this_0;
  };
  function CompositeViewMapper(ctx, source, target) {
    BaseViewMapper.call(this, ctx, source, target);
  }
  protoOf(CompositeViewMapper).llb = function (conf) {
    protoOf(BaseViewMapper).llb.call(this, conf);
    conf.x4v(Synchronizers_instance.nle(this.pl9_1.g2r(), DomUtil_instance.rkv(this.ql9_1), this.aol_1.dom()));
  };
  function DomViewMapper$registerSynchronizers$o$doAttach$lambda($tmp2_forEventSource_$receiver) {
    return function (it) {
      // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.DomViewMapper.registerSynchronizers.stub_for_inlining' call
      $tmp2_forEventSource_$receiver.bnq();
      return Unit_instance;
    };
  }
  function DomUtil$dimension$ref($boundThis) {
    var l = function (p0) {
      return $boundThis.skv(p0);
    };
    l.callableName = 'dimension';
    return l;
  }
  function DomViewMapper$registerSynchronizers$$inlined$forEventSource$1($tmp2_forEventSource_$receiver, $src) {
    this.fom_1 = $tmp2_forEventSource_$receiver;
    this.gom_1 = $src;
    DisposableSynchronizer.call(this);
  }
  protoOf(DomViewMapper$registerSynchronizers$$inlined$forEventSource$1).dlb = function (ctx) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.DomViewMapper.registerSynchronizers.stub_for_inlining' call
    this.fom_1.bnq();
    return this.gom_1.p27(DomViewMapper$registerSynchronizers$o$doAttach$lambda(this.fom_1));
  };
  function DomViewMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.hom_1 = this$0;
  }
  protoOf(DomViewMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    this.hom_1.ql9_1.innerHTML = '';
    var tmp;
    if (!(newValue == null)) {
      this.hom_1.ql9_1.appendChild(newValue);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(DomViewMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function DomViewMapper$registerSynchronizers$$inlined$writableProperty$2(this$0) {
    this.iom_1 = this$0;
  }
  protoOf(DomViewMapper$registerSynchronizers$$inlined$writableProperty$2).bm7 = function (newValue) {
    var tmp;
    if (newValue) {
      var tmp0_safe_receiver = this.iom_1.pl9_1.zom_1.m2c();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.focus();
      }
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(DomViewMapper$registerSynchronizers$$inlined$writableProperty$2).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function DomViewMapper(ctx, source) {
    BaseViewMapper.call(this, ctx, source, DomApi_instance.nkx());
  }
  protoOf(DomViewMapper).llb = function (conf) {
    protoOf(BaseViewMapper).llb.call(this, conf);
    var tmp = Companion_getInstance_251().iku_1;
    var bounds = select(this.pl9_1.zom_1, tmp, DomUtil$dimension$ref(DomUtil_instance));
    var tmp2_forEventSource_$receiver = this.pl9_1;
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forEventSource' call
    var tmp$ret$0 = new DomViewMapper$registerSynchronizers$$inlined$forEventSource$1(tmp2_forEventSource_$receiver, bounds);
    conf.x4v(tmp$ret$0);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$1 = new DomViewMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.x4v(syncOneWay(this.pl9_1.zom_1, tmp$ret$1));
    var tmp_0 = this.pl9_1.nnp();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$2 = new DomViewMapper$registerSynchronizers$$inlined$writableProperty$2(this);
    conf.x4v(syncOneWay(tmp_0, tmp$ret$2));
  };
  function DomViewSynchronizers$boundsSynchronizer$$inlined$writableProperty$1($el) {
    this.jon_1 = $el;
  }
  protoOf(DomViewSynchronizers$boundsSynchronizer$$inlined$writableProperty$1).bm7 = function (newValue) {
    setWidth(this.jon_1.style, newValue.dku_1.eku_1 + 1 | 0);
    setHeight(this.jon_1.style, newValue.dku_1.fku_1 + 1 | 0);
    return Unit_instance;
  };
  protoOf(DomViewSynchronizers$boundsSynchronizer$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function DomViewSynchronizers() {
  }
  protoOf(DomViewSynchronizers).kon = function (view, el) {
    var tmp = view.dnq();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new DomViewSynchronizers$boundsSynchronizer$$inlined$writableProperty$1(el);
    return syncOneWay(tmp, tmp$ret$0);
  };
  var DomViewSynchronizers_instance;
  function DomViewSynchronizers_getInstance() {
    return DomViewSynchronizers_instance;
  }
  function HorizontalViewMapper$registerSynchronizers$lambda(this$0) {
    return function (source) {
      // Inline function 'kotlin.apply' call
      var this_0 = this$0.aol_1.dom()(source);
      // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.HorizontalViewMapper.registerSynchronizers.<anonymous>.<anonymous>' call
      setFloat(this_0.ql9_1.style, CssFloat_LEFT_getInstance());
      return this_0;
    };
  }
  function HorizontalViewMapper(ctx, source) {
    BaseViewMapper.call(this, ctx, source, DomApi_instance.nkx());
    this.uon_1 = true;
    this.von_1 = DomApi_instance.nkx();
    this.ql9_1.appendChild(this.von_1);
    var clear = DomApi_instance.nkx();
    setClear(clear.style, CssClear_BOTH_getInstance());
    this.ql9_1.appendChild(clear);
  }
  protoOf(HorizontalViewMapper).col = function () {
    return this.uon_1;
  };
  protoOf(HorizontalViewMapper).llb = function (conf) {
    protoOf(BaseViewMapper).llb.call(this, conf);
    var tmp = Synchronizers_instance;
    var tmp_0 = this.pl9_1.g2r();
    var tmp_1 = DomUtil_instance.rkv(this.von_1);
    conf.x4v(tmp.nle(tmp_0, tmp_1, HorizontalViewMapper$registerSynchronizers$lambda(this)));
  };
  function ImageViewMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.won_1 = this$0;
  }
  protoOf(ImageViewMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    this.won_1.ql9_1.width = newValue.tnn_1.eku_1;
    this.won_1.ql9_1.height = newValue.tnn_1.fku_1;
    var tmp;
    if (newValue instanceof UrlImageData) {
      this.won_1.ql9_1.src = newValue.vnn_1;
      tmp = Unit_instance;
    } else {
      if (newValue instanceof EmptyImageData) {
        this.won_1.ql9_1.src = '';
        tmp = Unit_instance;
      } else {
        throw UnsupportedOperationException_init_$Create$();
      }
    }
    return tmp;
  };
  protoOf(ImageViewMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function ImageViewMapper(ctx, source) {
    BaseViewMapper.call(this, ctx, source, DomApi_instance.skx());
  }
  protoOf(ImageViewMapper).llb = function (conf) {
    protoOf(BaseViewMapper).llb.call(this, conf);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new ImageViewMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.x4v(syncOneWay(this.pl9_1.woo_1, tmp$ret$0));
  };
  function LineViewMapper$registerSynchronizers$o$set$lambda($line, $x, $y) {
    return function () {
      $line.setAttribute('x1', '' + ($x + 1 | 0));
      $line.setAttribute('y1', '' + ($y + 1 | 0));
      return Unit_instance;
    };
  }
  function LineViewMapper$registerSynchronizers$o$set$lambda_0($line, $x, $y) {
    return function () {
      $line.setAttribute('x2', '' + ($x + 1 | 0));
      $line.setAttribute('y2', '' + ($y + 1 | 0));
      return Unit_instance;
    };
  }
  function LineViewMapper$registerSynchronizers$lambda(this$0) {
    return function () {
      return this$0.pl9_1.q1().m2c().kku(this$0.pl9_1.dnq().m2c().cku_1);
    };
  }
  function LineViewMapper$registerSynchronizers$$inlined$writableProperty$1(this$0, $line) {
    this.xoo_1 = this$0;
    this.yoo_1 = $line;
  }
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    var x = newValue.ug();
    var y = newValue.vg();
    this.xoo_1.dol(LineViewMapper$registerSynchronizers$o$set$lambda(this.yoo_1, x, y));
    return Unit_instance;
  };
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function LineViewMapper$registerSynchronizers$lambda_0(this$0) {
    return function () {
      return this$0.pl9_1.mc4().m2c().kku(this$0.pl9_1.dnq().m2c().cku_1);
    };
  }
  function LineViewMapper$registerSynchronizers$$inlined$writableProperty$2(this$0, $line) {
    this.zoo_1 = this$0;
    this.aop_1 = $line;
  }
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$2).bm7 = function (newValue) {
    var x = newValue.ug();
    var y = newValue.vg();
    this.zoo_1.dol(LineViewMapper$registerSynchronizers$o$set$lambda_0(this.aop_1, x, y));
    return Unit_instance;
  };
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$2).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function LineViewMapper$registerSynchronizers$$inlined$writableProperty$3($line) {
    this.bop_1 = $line;
  }
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$3).bm7 = function (newValue) {
    this.bop_1.style.color = newValue.qnn();
    return Unit_instance;
  };
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$3).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function LineViewMapper$registerSynchronizers$$inlined$writableProperty$4($line) {
    this.cop_1 = $line;
  }
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$4).bm7 = function (newValue) {
    setStrokeWidth(this.cop_1.style, newValue);
    return Unit_instance;
  };
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$4).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function LineViewMapper(ctx, source) {
    BaseViewMapper.call(this, ctx, source, DomApi_instance.nkx());
  }
  protoOf(LineViewMapper).llb = function (conf) {
    protoOf(BaseViewMapper).llb.call(this, conf);
    var svg = this.sol();
    this.ql9_1.appendChild(svg);
    var line = SvgUtil_instance.mop();
    svg.appendChild(line);
    conf.x4v(DomViewSynchronizers_instance.kon(this.pl9_1, svg));
    var viewLineStart = toDerivedProperty(LineViewMapper$registerSynchronizers$lambda(this), [this.pl9_1.q1(), this.pl9_1.dnq()]);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var svgLineStart = new LineViewMapper$registerSynchronizers$$inlined$writableProperty$1(this, line);
    conf.x4v(syncOneWay(viewLineStart, svgLineStart));
    var viewLineEnd = toDerivedProperty(LineViewMapper$registerSynchronizers$lambda_0(this), [this.pl9_1.mc4(), this.pl9_1.dnq()]);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var svgLineEnd = new LineViewMapper$registerSynchronizers$$inlined$writableProperty$2(this, line);
    conf.x4v(syncOneWay(viewLineEnd, svgLineEnd));
    var tmp = this.pl9_1.ans();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$2 = new LineViewMapper$registerSynchronizers$$inlined$writableProperty$3(line);
    conf.x4v(syncOneWay(tmp, tmp$ret$2));
    var tmp_0 = this.pl9_1.zlh();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$3 = new LineViewMapper$registerSynchronizers$$inlined$writableProperty$4(line);
    conf.x4v(syncOneWay(tmp_0, tmp$ret$3));
  };
  function updatePoints($this) {
    var origin = $this.oop_1.inp().cku_1;
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this.oop_1.uns_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.<no name provided>.updatePoints.<anonymous>' call
      var tmp$ret$0 = item.kku(origin);
      destination.e(tmp$ret$0);
    }
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var _destruct__k2r9zo = _iterator__ex2g4s_0.m();
      var vx = _destruct__k2r9zo.ug();
      var vy = _destruct__k2r9zo.vg();
      var x = !(vx === 0) ? vx : 1;
      var y = !(vy === 0) ? vy : 1;
      $this.qop_1.points.appendItem(new DOMPoint(x, y));
    }
  }
  function MultiPointViewMapper$registerSynchronizers$o$attach$lambda$lambda(this$0) {
    return function () {
      updatePoints(this$0);
      return Unit_instance;
    };
  }
  function MultiPointViewMapper$registerSynchronizers$o$attach$lambda(this$0, this$1) {
    return function (it) {
      this$0.dol(MultiPointViewMapper$registerSynchronizers$o$attach$lambda$lambda(this$1));
      return Unit_instance;
    };
  }
  function MultiPointViewMapper$registerSynchronizers$o$attach$lambda_0(this$0) {
    return function () {
      updatePoints(this$0);
      return Unit_instance;
    };
  }
  function Companion_346() {
    this.rop_1 = 'none';
  }
  var Companion_instance_346;
  function Companion_getInstance_346() {
    return Companion_instance_346;
  }
  function MultiPointViewMapper$registerSynchronizers$1($multiPointView, this$0, $polyLine) {
    this.oop_1 = $multiPointView;
    this.pop_1 = this$0;
    this.qop_1 = $polyLine;
    this.nop_1 = Companion_getInstance_25().wr_1;
  }
  protoOf(MultiPointViewMapper$registerSynchronizers$1).jla = function (ctx) {
    var tmp = this;
    var tmp_0 = this.oop_1.vns(Companion_getInstance_329().bns_1);
    tmp.nop_1 = tmp_0.p27(MultiPointViewMapper$registerSynchronizers$o$attach$lambda(this.pop_1, this));
    this.pop_1.dol(MultiPointViewMapper$registerSynchronizers$o$attach$lambda_0(this));
  };
  protoOf(MultiPointViewMapper$registerSynchronizers$1).t6m = function () {
    this.nop_1.vr();
    // Inline function 'kotlin.also' call
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.<no name provided>.detach.<anonymous>' call
    this.nop_1 = Companion_getInstance_25().wr_1;
  };
  function MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$1($style, $isPolyLine) {
    this.sop_1 = $style;
    this.top_1 = $isPolyLine;
  }
  protoOf(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    var cssColor = newValue.qnn();
    setFill(this.sop_1, this.top_1 ? 'none' : cssColor);
    this.sop_1.color = this.top_1 ? cssColor : 'none';
    return Unit_instance;
  };
  protoOf(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$2($style) {
    this.uop_1 = $style;
  }
  protoOf(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$2).bm7 = function (newValue) {
    setStrokeWidth(this.uop_1, newValue);
    return Unit_instance;
  };
  protoOf(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$2).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function MultiPointViewMapper(ctx, source) {
    BaseViewMapper.call(this, ctx, source, DomApi_instance.nkx());
  }
  protoOf(MultiPointViewMapper).llb = function (conf) {
    protoOf(BaseViewMapper).llb.call(this, conf);
    var svg = this.sol();
    this.ql9_1.appendChild(svg);
    var polyLine = SvgUtil_instance.eoq();
    svg.appendChild(polyLine);
    var style = polyLine.style;
    var multiPointView = this.pl9_1;
    var isPolyLine = multiPointView instanceof PolyLineView;
    setStrokeWidth(style, 1);
    conf.x4v(new MultiPointViewMapper$registerSynchronizers$1(multiPointView, this, polyLine));
    conf.x4v(DomViewSynchronizers_instance.kon(multiPointView, svg));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var svgPolylineColorProp = new MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$1(style, isPolyLine);
    conf.x4v(syncOneWay(multiPointView.ans(), svgPolylineColorProp));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var svgPolylineWidthProp = new MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$2(style);
    conf.x4v(syncOneWay(multiPointView.zlh(), svgPolylineWidthProp));
  };
  function ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$1($style) {
    this.foq_1 = $style;
  }
  protoOf(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    setOverflow(this.foq_1, newValue ? CssOverflow_HIDDEN_getInstance() : CssOverflow_VISIBLE_getInstance());
    return Unit_instance;
  };
  protoOf(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$2($style) {
    this.goq_1 = $style;
  }
  protoOf(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$2).bm7 = function (newValue) {
    var x = newValue.ug();
    var y = newValue.vg();
    if (x > 0) {
      setMaxWidth(this.goq_1, x);
    }
    var tmp;
    if (y > 0) {
      setMaxWidth(this.goq_1, y);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$2).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function ScrollViewMapper(ctx, source) {
    CompositeViewMapper.call(this, ctx, source, DomApi_instance.nkx());
    this.qoq_1 = true;
  }
  protoOf(ScrollViewMapper).col = function () {
    return this.qoq_1;
  };
  protoOf(ScrollViewMapper).llb = function (conf) {
    protoOf(CompositeViewMapper).llb.call(this, conf);
    var style = this.ql9_1.style;
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var divOverflow = new ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$1(style);
    conf.x4v(syncOneWay(this.pl9_1.ynt(), divOverflow));
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var divMaxDimensions = new ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$2(style);
    conf.x4v(syncOneWay(this.pl9_1.xnt(), divMaxDimensions));
  };
  function createSvgElement($this, name) {
    var element = document.createElementNS('http://www.w3.org/2000/svg', name);
    return element instanceof SVGElement ? element : THROW_CCE();
  }
  function SvgUtil() {
  }
  protoOf(SvgUtil).eoq = function () {
    return createSvgElement(this, 'polyline');
  };
  protoOf(SvgUtil).mop = function () {
    return createSvgElement(this, 'line');
  };
  protoOf(SvgUtil).tol = function () {
    return createSvgElement(this, 'svg');
  };
  var SvgUtil_instance;
  function SvgUtil_getInstance() {
    return SvgUtil_instance;
  }
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$1($tmp2_writableProperty_$receiver) {
    this.roq_1 = $tmp2_writableProperty_$receiver;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.TextViewMapper.registerSynchronizers.stub_for_inlining' call
    this.roq_1.set(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$2($tmp5_writableProperty_$receiver) {
    this.soq_1 = $tmp5_writableProperty_$receiver;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$2).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.TextViewMapper.registerSynchronizers.stub_for_inlining' call
    this.soq_1.set(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$2).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$3($editor) {
    this.toq_1 = $editor;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$3).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.TextViewMapper.registerSynchronizers.stub_for_inlining' call
    this.toq_1.soh(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$3).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$4($tmp10_writableProperty_$receiver) {
    this.uoq_1 = $tmp10_writableProperty_$receiver;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$4).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.TextViewMapper.registerSynchronizers.stub_for_inlining' call
    this.uoq_1.set(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$4).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$5($tmp13_writableProperty_$receiver) {
    this.voq_1 = $tmp13_writableProperty_$receiver;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$5).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.TextViewMapper.registerSynchronizers.stub_for_inlining' call
    this.voq_1.set(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$5).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$6($tmp16_writableProperty_$receiver) {
    this.woq_1 = $tmp16_writableProperty_$receiver;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$6).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.TextViewMapper.registerSynchronizers.stub_for_inlining' call
    this.woq_1.set(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$6).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$7($tmp19_writableProperty_$receiver) {
    this.xoq_1 = $tmp19_writableProperty_$receiver;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$7).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.TextViewMapper.registerSynchronizers.stub_for_inlining' call
    this.xoq_1.set(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$7).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$8($editor) {
    this.yoq_1 = $editor;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$8).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.TextViewMapper.registerSynchronizers.stub_for_inlining' call
    this.yoq_1.moh(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$8).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$9($editor) {
    this.zoq_1 = $editor;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$9).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.TextViewMapper.registerSynchronizers.stub_for_inlining' call
    this.zoq_1.noh(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$9).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$10($editor) {
    this.aor_1 = $editor;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$10).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.TextViewMapper.registerSynchronizers.stub_for_inlining' call
    this.aor_1.ooh(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$10).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper$registerSynchronizers$$inlined$writableProperty$11($editor) {
    this.bor_1 = $editor;
  }
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$11).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.TextViewMapper.registerSynchronizers.stub_for_inlining' call
    this.bor_1.poh(newValue);
    return Unit_instance;
  };
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$11).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function TextViewMapper(ctx, source) {
    BaseViewMapper.call(this, ctx, source, DomApi_instance.nkx());
    this.lor_1 = true;
  }
  protoOf(TextViewMapper).col = function () {
    return this.lor_1;
  };
  protoOf(TextViewMapper).llb = function (conf) {
    var editor = new DomTextEditor(this.ql9_1);
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.TextViewMapper.registerSynchronizers.<anonymous>' call
    var $this$with = this.ql9_1.style;
    setPosition($this$with, CssPosition_ABSOLUTE_getInstance());
    setDisplay($this$with, CssDisplay_BLOCK_getInstance());
    protoOf(BaseViewMapper).llb.call(this, conf);
    var tmp = this.pl9_1.nlu();
    var tmp2_writableProperty_$receiver = selectionVisible$factory(editor);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$2 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$1(tmp2_writableProperty_$receiver);
    conf.x4v(syncOneWay(tmp, tmp$ret$2));
    var tmp_0 = this.pl9_1.olu();
    var tmp5_writableProperty_$receiver = selectionStart$factory(editor);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$3 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$2(tmp5_writableProperty_$receiver);
    conf.x4v(syncOneWay(tmp_0, tmp$ret$3));
    var tmp_1 = this.pl9_1.plu();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$4 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$3(editor);
    conf.x4v(syncOneWay(tmp_1, tmp$ret$4));
    var tmp_2 = this.pl9_1.laz();
    var tmp10_writableProperty_$receiver = text$factory_1(editor);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$5 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$4(tmp10_writableProperty_$receiver);
    conf.x4v(syncOneWay(tmp_2, tmp$ret$5));
    var tmp_3 = this.pl9_1.hlu();
    var tmp13_writableProperty_$receiver = textColor$factory(editor);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$6 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$5(tmp13_writableProperty_$receiver);
    conf.x4v(syncOneWay(tmp_3, tmp$ret$6));
    var tmp_4 = this.pl9_1.ilu();
    var tmp16_writableProperty_$receiver = isCaretVisible$factory(editor);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$7 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$6(tmp16_writableProperty_$receiver);
    conf.x4v(syncOneWay(tmp_4, tmp$ret$7));
    var tmp_5 = this.pl9_1.zlt();
    var tmp19_writableProperty_$receiver = caretPosition$factory(editor);
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$8 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$7(tmp19_writableProperty_$receiver);
    conf.x4v(syncOneWay(tmp_5, tmp$ret$8));
    var tmp_6 = this.pl9_1.jlu();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$9 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$8(editor);
    conf.x4v(syncOneWay(tmp_6, tmp$ret$9));
    var tmp_7 = this.pl9_1.klu();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$10 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$9(editor);
    conf.x4v(syncOneWay(tmp_7, tmp$ret$10));
    var tmp_8 = this.pl9_1.llu();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$11 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$10(editor);
    conf.x4v(syncOneWay(tmp_8, tmp$ret$11));
    var tmp_9 = this.pl9_1.mlu();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$12 = new TextViewMapper$registerSynchronizers$$inlined$writableProperty$11(editor);
    conf.x4v(syncOneWay(tmp_9, tmp$ret$12));
  };
  function selectionVisible$factory($b0) {
    return getPropertyCallableRef('selectionVisible', 0, KMutableProperty0, function () {
      return $b0.moe_1;
    }, function (value) {
      return $b0.qoh(value);
    });
  }
  function selectionStart$factory($b0) {
    return getPropertyCallableRef('selectionStart', 0, KMutableProperty0, function () {
      return $b0.koe_1;
    }, function (value) {
      return $b0.roh(value);
    });
  }
  function text$factory_1($b0) {
    return getPropertyCallableRef('text', 0, KMutableProperty0, function () {
      return $b0.laz();
    }, function (value) {
      return $b0.woe(value);
    });
  }
  function textColor$factory($b0) {
    return getPropertyCallableRef('textColor', 0, KMutableProperty0, function () {
      return $b0.qoe_1;
    }, function (value) {
      return $b0.loh(value);
    });
  }
  function isCaretVisible$factory($b0) {
    return getPropertyCallableRef('isCaretVisible', 0, KMutableProperty0, function () {
      return $b0.poe_1;
    }, function (value) {
      return $b0.eoh(value);
    });
  }
  function caretPosition$factory($b0) {
    return getPropertyCallableRef('caretPosition', 0, KMutableProperty0, function () {
      return $b0.joe_1;
    }, function (value) {
      return $b0.koh(value);
    });
  }
  function setTargetWidth($this, value) {
    setPaddingLeft($this.ql9_1.style, value);
  }
  function VerticalViewMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.mor_1 = this$0;
  }
  protoOf(VerticalViewMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.VerticalViewMapper.registerSynchronizers.stub_for_inlining' call
    var $receiver = this.mor_1;
    setTargetWidth($receiver, newValue);
    return Unit_instance;
  };
  protoOf(VerticalViewMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function VerticalViewMapper(ctx, source) {
    CompositeViewMapper.call(this, ctx, source, DomApi_instance.nkx());
    this.wor_1 = true;
  }
  protoOf(VerticalViewMapper).col = function () {
    return this.wor_1;
  };
  protoOf(VerticalViewMapper).llb = function (conf) {
    protoOf(CompositeViewMapper).llb.call(this, conf);
    var tmp = this.pl9_1.wnv();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new VerticalViewMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.x4v(syncOneWay(tmp, tmp$ret$0));
  };
  function View$validate$ref($boundThis) {
    var l = function () {
      $boundThis.bnq();
      return Unit_instance;
    };
    l.callableName = 'validate';
    return l;
  }
  function ViewContainerToElementMapper$onAttach$o$attach$lambda($container) {
    return function (it) {
      var tmp = DomImmediatePolyfill_getInstance();
      tmp.ykz(View$validate$ref($container.u3o()));
      return Unit_instance;
    };
  }
  function setRootDivSize($this, value) {
    var bottomRight = value.cku_1.jku(value.dku_1);
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.ViewContainerToElementMapper.setRootDivSize.<anonymous>' call
    var $this$with = $this.eos_1.style;
    setWidth($this$with, bottomRight.eku_1);
    setHeight($this$with, bottomRight.fku_1);
  }
  function registerListeners_0($this, conf) {
    var mouseTranslator = new ViewContainerToElementMapper$registerListeners$mouseTranslator$1($this);
    var keyTranslator = new SimpleKeyTranslator($this.eos_1, $this.pl9_1);
    conf.x4v(new CompositeDisposable([mouseTranslator.bl6(), keyTranslator.bl6()]));
  }
  function disablePopup($this, el) {
    var tmp = Companion_getInstance_254().iky_1;
    var tmp_0 = ViewContainerToElementMapper$disablePopup$lambda;
    on(el, tmp, typeof tmp_0 === 'function' ? tmp_0 : THROW_CCE());
  }
  function isDomViewEvent($this, e) {
    var tmp = $this.pl9_1.u3o().enq(e.zl3());
    return tmp instanceof DomView;
  }
  function isContainerEvent_0($this, evt) {
    return $this.pl9_1.qo1().inp().mku(evt.zl3());
  }
  function ViewContainerToElementMapper$viewToDomContext$1($eventsDisabled, $extensionViewMapperFactories) {
    this.ios_1 = $extensionViewMapperFactories;
    this.hos_1 = $eventsDisabled;
  }
  protoOf(ViewContainerToElementMapper$viewToDomContext$1).dom = function () {
    return ViewMapperFactory_instance.kos(this, this.ios_1);
  };
  function ViewContainerToElementMapper$registerSynchronizers$$inlined$writableProperty$1(this$0) {
    this.los_1 = this$0;
  }
  protoOf(ViewContainerToElementMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.ViewContainerToElementMapper.registerSynchronizers.stub_for_inlining' call
    var $receiver = this.los_1;
    setRootDivSize($receiver, newValue);
    return Unit_instance;
  };
  protoOf(ViewContainerToElementMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function ViewContainerToElementMapper$registerListeners$mouseTranslator$1(this$0) {
    this.oos_1 = this$0;
    MouseTranslator.call(this, this$0.eos_1, this$0.pl9_1);
  }
  protoOf(ViewContainerToElementMapper$registerListeners$mouseTranslator$1).rl5 = function (e) {
    return !isContainerEvent_0(this.oos_1, e) || isDomViewEvent(this.oos_1, e);
  };
  protoOf(ViewContainerToElementMapper$registerListeners$mouseTranslator$1).zl5 = function (e) {
    return isDomViewEvent(this.oos_1, e);
  };
  protoOf(ViewContainerToElementMapper$registerListeners$mouseTranslator$1).ol5 = function (vec) {
    var result = protoOf(MouseTranslator).ol5.call(this, vec);
    return result.kku(new Vector(numberToInt(getAbsoluteLeft(this.oos_1.eos_1)), numberToInt(getAbsoluteTop(this.oos_1.eos_1))));
  };
  protoOf(ViewContainerToElementMapper$registerListeners$mouseTranslator$1).ul5 = function () {
    return this.oos_1.eos_1.focus();
  };
  function ViewContainerToElementMapper$onAttach$1(this$0, $rootMapper, $fontHeight, $baseLine, $fontWidth) {
    this.qos_1 = this$0;
    this.ros_1 = $rootMapper;
    this.sos_1 = $fontHeight;
    this.tos_1 = $baseLine;
    this.uos_1 = $fontWidth;
    this.pos_1 = null;
  }
  protoOf(ViewContainerToElementMapper$onAttach$1).yns = function (container) {
    var tmp = this;
    var tmp_0 = container.u3o().xnp();
    tmp.pos_1 = tmp_0.p27(ViewContainerToElementMapper$onAttach$o$attach$lambda(container));
    container.u3o().bnq();
  };
  protoOf(ViewContainerToElementMapper$onAttach$1).t6m = function () {
    return ensureNotNull(this.pos_1).vr();
  };
  protoOf(ViewContainerToElementMapper$onAttach$1).zns = function (view) {
  };
  protoOf(ViewContainerToElementMapper$onAttach$1).ant = function (view, change) {
  };
  protoOf(ViewContainerToElementMapper$onAttach$1).bnt = function (font, text) {
    var tmp;
    if (equals(Companion_getInstance_331().znt_1.ult_1, Companion_getInstance_326().pls_1) && font.equals(Companion_getInstance_331().znt_1)) {
      tmp = numberToInt(text.length * this.uos_1);
    } else {
      tmp = numberToInt(TextMetricsCalculator_getInstance().sok(font, text).foa().skt_1);
    }
    return tmp;
  };
  function ViewContainerToElementMapper$disablePopup$lambda(_unused_var__etf5q3) {
    return false;
  }
  function ViewContainerToElementMapper(source, target, eventsDisabled, extensionViewMapperFactories) {
    Mapper.call(this, source, target);
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = DomApi_instance.nkx();
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.ViewContainerToElementMapper.rootDiv.<anonymous>' call
    disablePopup(this, this_0);
    target.appendChild(this_0);
    this_0.tabIndex = 0;
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.ViewContainerToElementMapper.rootDiv.<anonymous>.<anonymous>' call
    var $this$with = this_0.style;
    setPosition($this$with, CssPosition_RELATIVE_getInstance());
    setPadding($this$with, 0);
    setOverflow($this$with, CssOverflow_VISIBLE_getInstance());
    setOutlineStyle($this$with, CssOutlineStyle_NONE_getInstance());
    tmp.eos_1 = this_0;
    this.fos_1 = this.cld();
    var tmp_0 = this;
    tmp_0.gos_1 = new ViewContainerToElementMapper$viewToDomContext$1(eventsDisabled, extensionViewMapperFactories);
  }
  protoOf(ViewContainerToElementMapper).llb = function (conf) {
    protoOf(Mapper).llb.call(this, conf);
    var tmp = this.pl9_1.u3o().dnq();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var tmp$ret$0 = new ViewContainerToElementMapper$registerSynchronizers$$inlined$writableProperty$1(this);
    conf.x4v(syncOneWay(tmp, tmp$ret$0));
    if (!this.gos_1.hos_1) {
      registerListeners_0(this, conf);
    }
  };
  protoOf(ViewContainerToElementMapper).zlc = function (ctx) {
    protoOf(Mapper).zlc.call(this, ctx);
    var rootMapper = this.gos_1.dom()(this.pl9_1.u3o());
    this.fos_1.v2c(rootMapper);
    this.eos_1.appendChild(rootMapper.ql9_1);
    var metrics = TextMetricsCalculator_getInstance().eok(Companion_getInstance_331().znt_1);
    var baseLine = metrics.pok();
    var fontWidth = metrics.foa().skt_1;
    var fontHeight = metrics.foa().tkt_1;
    this.pl9_1.po1(new ViewContainerToElementMapper$onAttach$1(this, rootMapper, fontHeight, baseLine, fontWidth));
  };
  protoOf(ViewContainerToElementMapper).nla = function () {
    protoOf(Mapper).nla.call(this);
    this.pl9_1.po1(new NullViewContainerPeer());
  };
  function getExtensionViewMapper(_this__u8e3s4, $this, view, ctx) {
    var tmp;
    if (view.rno_1) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = _this__u8e3s4.k();
        while (_iterator__ex2g4s.l()) {
          var element = _iterator__ex2g4s.m();
          // Inline function 'jetbrains.ocelot.projectional.view.dom.toDom.ViewMapperFactory.getExtensionViewMapper.<anonymous>' call
          if (element.vos(view)) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var tmp0_safe_receiver = tmp$ret$1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wos(ctx, view);
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        throw UnsupportedOperationException_init_$Create$_0("Unknown view: '" + getKClassFromExpression(view).lb() + "'. The corresponding ExtensionViewMapperFactory needs to be registered.");
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function ViewMapperFactory$getMapperFactory$lambda($ctx, $extensionViewMapperFactories) {
    return function (view) {
      var tmp;
      if (view instanceof TextView) {
        tmp = new TextViewMapper($ctx, view);
      } else {
        if (view instanceof LineView) {
          tmp = new LineViewMapper($ctx, view);
        } else {
          if (view instanceof MultiPointView) {
            tmp = new MultiPointViewMapper($ctx, view);
          } else {
            if (false && getKClassFromExpression(view) === getKClass(VerticalView)) {
              tmp = new VerticalViewMapper($ctx, view instanceof VerticalView ? view : THROW_CCE());
            } else {
              if (false && getKClassFromExpression(view) === getKClass(HorizontalView)) {
                tmp = new HorizontalViewMapper($ctx, view instanceof HorizontalView ? view : THROW_CCE());
              } else {
                if (view instanceof ScrollView) {
                  tmp = new ScrollViewMapper($ctx, view);
                } else {
                  if (view instanceof ImageView) {
                    tmp = new ImageViewMapper($ctx, view);
                  } else {
                    if (view instanceof DomView) {
                      tmp = new DomViewMapper($ctx, view);
                    } else {
                      var tmp0_elvis_lhs = getExtensionViewMapper($extensionViewMapperFactories, ViewMapperFactory_instance, view, $ctx);
                      tmp = tmp0_elvis_lhs == null ? new CompositeViewMapper($ctx, view, DomApi_instance.nkx()) : tmp0_elvis_lhs;
                    }
                  }
                }
              }
            }
          }
        }
      }
      var result = tmp;
      var tmp_0;
      if (view instanceof VerticalView) {
        tmp_0 = 'V';
      } else {
        if (view instanceof HorizontalView) {
          tmp_0 = 'H';
        } else {
          if (view instanceof TextView) {
            tmp_0 = 'T';
          } else {
            if (view instanceof ScrollView) {
              tmp_0 = 'S';
            } else {
              tmp_0 = null;
            }
          }
        }
      }
      var className = tmp_0;
      var tmp_1;
      if (!(className == null)) {
        addClassName(result.ql9_1, className);
        tmp_1 = Unit_instance;
      }
      return result;
    };
  }
  function ViewMapperFactory() {
    this.jos_1 = false;
  }
  protoOf(ViewMapperFactory).kos = function (ctx, extensionViewMapperFactories) {
    return ViewMapperFactory$getMapperFactory$lambda(ctx, extensionViewMapperFactories);
  };
  var ViewMapperFactory_instance;
  function ViewMapperFactory_getInstance() {
    return ViewMapperFactory_instance;
  }
  function ViewToDom() {
  }
  protoOf(ViewToDom).aok = function (container, element, extensionViewMapperFactories, eventsDisabled) {
    return Mappers_instance.nld(new ViewContainerToElementMapper(container, element, eventsDisabled, extensionViewMapperFactories));
  };
  protoOf(ViewToDom).zoj = function (container, element, extensionViewMapperFactories, eventsDisabled, $super) {
    extensionViewMapperFactories = extensionViewMapperFactories === VOID ? emptyList() : extensionViewMapperFactories;
    eventsDisabled = eventsDisabled === VOID ? false : eventsDisabled;
    return $super === VOID ? this.aok(container, element, extensionViewMapperFactories, eventsDisabled) : $super.aok.call(this, container, element, extensionViewMapperFactories, eventsDisabled);
  };
  var ViewToDom_instance;
  function ViewToDom_getInstance() {
    return ViewToDom_instance;
  }
  function getPathAndState($this, state, getState) {
    var path = ArrayList_init_$Create$();
    var current = state.xos_1;
    $l$loop: while (isInterface(current, HasOperationTargetData)) {
      var targetedOperation = current;
      path.e(ensureNotNull(targetedOperation.h3b()));
      current = targetedOperation.u3l();
    }
    // Inline function 'kotlin.check' call
    if (!(current instanceof CellOperation)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var cellOperation = current;
    path.e(cellOperation.zos_1);
    return new Pair(path, getState(cellOperation));
  }
  function getFocusState($this, provider, cellProvider, cell) {
    var tmp0_elvis_lhs = cellProvider.bot(cell);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var node = tmp;
    if (isFocusSuspended($this, cell)) {
      return null;
    }
    var tmp1_elvis_lhs = Companion_instance_348.cot(cell, cellProvider);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var cellPath = tmp_0;
    var operation = new FocusOperation(cellPath);
    return new NodeCellState(provider.dot(node, operation, cellProvider));
  }
  function isFocusSuspended($this, cell) {
    var tmp0 = ancestorsFrom(cell);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.any' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.otProjectional.Companion.isFocusSuspended.<anonymous>' call
        if (element.ulp(Companion_getInstance_347().eot_1)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function getNodeState($this, cell, provider, cellProvider) {
    var tmp0_elvis_lhs = cellProvider.bot(cell);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var node = tmp;
    var cellPath = ensureNotNull(Companion_instance_348.cot(cell, cellProvider));
    var state = get_stateHandler(cell).gmv(cell);
    var operation = new CellStateOperation(state, cellPath);
    return new NodeCellState(provider.dot(node, operation, cellProvider));
  }
  function CellContainerState$Companion$getPathToCellStateMap$lambda(operation) {
    // Inline function 'kotlin.check' call
    if (!(operation instanceof CellStateOperation)) {
      // Inline function 'jetbrains.ocelot.otProjectional.Companion.getPathToCellStateMap.<anonymous>.<anonymous>' call
      var message = 'Expected CellStateOperation, actual ' + toString_1(getKClassFromExpression(operation));
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return operation.iot_1;
  }
  function CellContainerState$Companion$getPath$lambda(_unused_var__etf5q3) {
    return null;
  }
  function Companion_347() {
    Companion_instance_347 = this;
    this.eot_1 = CellTraitPropertySpec_init_$Create$('suspendFocusState', false);
  }
  protoOf(Companion_347).jot = function (states) {
    var map = HashMap_init_$Create$();
    var getState = CellContainerState$Companion$getPathToCellStateMap$lambda;
    var _iterator__ex2g4s = states.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var state = _iterator__ex2g4s.m();
      if (state.t3j()) {
        continue $l$loop;
      }
      var pair = getPathAndState(this, state, getState);
      // Inline function 'kotlin.check' call
      if (!!map.w2(pair.dh_1)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      var tmp2 = pair.dh_1;
      // Inline function 'kotlin.collections.set' call
      var value = pair.eh_1;
      map.r2(tmp2, value);
    }
    return map;
  };
  protoOf(Companion_347).kot = function (state) {
    var tmp;
    if (state.t3j()) {
      tmp = null;
    } else {
      var tmp_0 = CellContainerState$Companion$getPath$lambda;
      var getState = typeof tmp_0 === 'function' ? tmp_0 : THROW_CCE();
      tmp = getPathAndState(this, state, getState).dh_1;
    }
    return tmp;
  };
  protoOf(Companion_347).lot = function (focus1, focus2) {
    var tmp;
    if (focus1 == null || focus2 == null) {
      tmp = focus1 === focus2;
    } else {
      tmp = equals(this.kot(focus1), this.kot(focus2));
    }
    return tmp;
  };
  protoOf(Companion_347).mot = function (state1, state2) {
    if (state1 == null || state2 == null) {
      return state1 === state2;
    }
    var tmp;
    if (!this.lot(state1.oot_1, state2.oot_1)) {
      tmp = false;
    } else {
      tmp = equals(this.jot(state1.pot_1), this.jot(state2.pot_1));
    }
    return tmp;
  };
  protoOf(Companion_347).qot = function (containerId, selectedCell, cellsToSave, provider, cellProvider) {
    var focus = null;
    var toFocus = selectedCell;
    while (!(toFocus == null) && toFocus.ulp(Cells_getInstance().mmg_1)) {
      toFocus = prevFocusable(toFocus);
    }
    if (!(toFocus == null)) {
      focus = getFocusState(this, provider, cellProvider, toFocus);
    }
    var states = LinkedHashSet_init_$Create$();
    var _iterator__ex2g4s = cellsToSave.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var cell = _iterator__ex2g4s.m();
      if (cell.ulp(Cells_getInstance().mmg_1))
        continue $l$loop;
      var nodeState = getNodeState(this, cell, provider, cellProvider);
      if (!(nodeState == null)) {
        states.e(nodeState);
      }
    }
    return new CellContainerState(containerId, focus, states);
  };
  var Companion_instance_347;
  function Companion_getInstance_347() {
    if (Companion_instance_347 == null)
      new Companion_347();
    return Companion_instance_347;
  }
  function CellContainerState(containerId, nodeFocus, cellStates) {
    Companion_getInstance_347();
    this.not_1 = containerId;
    this.oot_1 = nodeFocus;
    this.pot_1 = cellStates;
  }
  protoOf(CellContainerState).rot = function (context, provider) {
    var _iterator__ex2g4s = this.pot_1.k();
    while (_iterator__ex2g4s.l()) {
      var state = _iterator__ex2g4s.m();
      state.sot(context, provider);
    }
    var tmp0_safe_receiver = this.oot_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.sot(context, provider);
    }
  };
  protoOf(CellContainerState).tot = function (operation) {
    var transformedStates = LinkedHashSet_init_$Create$();
    var _iterator__ex2g4s = this.pot_1.k();
    while (_iterator__ex2g4s.l()) {
      var state = _iterator__ex2g4s.m();
      transformedStates.e(new NodeCellState(operation.b3k(state.xos_1, true)));
    }
    var focus = null;
    if (!(this.oot_1 == null)) {
      focus = new NodeCellState(operation.b3k(this.oot_1.xos_1, true));
    }
    return new CellContainerState(this.not_1, focus, transformedStates);
  };
  protoOf(CellContainerState).i4p = function (operation) {
    return this.tot(operation);
  };
  protoOf(CellContainerState).toString = function () {
    var result = StringBuilder_init_$Create$_1();
    result.d9('CellContainerState@').d9(toString_3(hashCode(this), 16)).d9(' : container id=').c9(this.not_1);
    result.d9('\n  focus: ').c9(this.oot_1);
    result.d9('\n  states:');
    if (this.pot_1.p()) {
      result.d9(' <empty>');
    } else {
      var _iterator__ex2g4s = this.pot_1.k();
      while (_iterator__ex2g4s.l()) {
        var state = _iterator__ex2g4s.m();
        result.d9('\n    ').c9(state);
      }
    }
    return result.toString();
  };
  function _get_nodeCellProvider__5glot2($this) {
    var tmp = $this.aot_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('nodeCellProvider');
    }
  }
  function CellOperation(path) {
    BaseOperation.call(this);
    this.zos_1 = path;
  }
  protoOf(CellOperation).uot = function (provider) {
    this.aot_1 = provider;
  };
  protoOf(CellOperation).vot = function (model, nodeFactory) {
    this.wot(model, _get_nodeCellProvider__5glot2(this));
    return model;
  };
  protoOf(CellOperation).a3k = function (model, nodeFactory) {
    return this.vot(model instanceof OtNode ? model : THROW_CCE(), nodeFactory);
  };
  protoOf(CellOperation).xot = function (otherOp, server) {
    return new NopOperation();
  };
  protoOf(CellOperation).r3p = function (otherOp, server) {
    return this.xot(otherOp, server);
  };
  protoOf(CellOperation).s3l = function () {
    throw IllegalStateException_init_$Create$();
  };
  protoOf(CellOperation).yot = function (node, provider) {
    return this.zos_1.bou(node, provider);
  };
  protoOf(CellOperation).toString = function () {
    var name = getKClassFromExpression(this).lb();
    return plus_10(name, '@') + toString_3(hashCode(this), 16) + new Char(_Char___init__impl__6a9atx(40)) + this.zos_1 + toString(_Char___init__impl__6a9atx(41));
  };
  function find_1($this, cell, node, provider) {
    var nodeCells = provider.cou(node);
    var index = 0;
    var _iterator__ex2g4s = nodeCells.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var nodeCell = _iterator__ex2g4s.m();
      if (isDescendant(nodeCell, cell)) {
        break $l$loop;
      }
      index = index + 1 | 0;
    }
    var tmp;
    if (index === nodeCells.n()) {
      tmp = null;
    } else {
      var treePath = TreePath_init_$Create$_0(cell, nodeCells.q(index));
      var cellPath = new CellPath(index, treePath);
      tmp = new Pair(cellPath, node);
    }
    return tmp;
  }
  function hasNodeCell($this, node, provider) {
    return $this.zot_1 < provider.cou(node).n();
  }
  function Companion_348() {
  }
  protoOf(Companion_348).cot = function (cell, provider) {
    var tmp0_elvis_lhs = this.dou(cell, provider);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var cellPathNodePair = tmp;
    return cellPathNodePair.dh_1;
  };
  protoOf(Companion_348).dou = function (cell, provider) {
    var tmp0_safe_receiver = provider.bot(cell);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.otProjectional.Companion.find.<anonymous>' call
      tmp = find_1(Companion_instance_348, cell, tmp0_safe_receiver, provider);
    }
    return tmp;
  };
  protoOf(Companion_348).eou = function (cell, provider) {
    var tmp0_elvis_lhs = cell.yt();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parentCell = tmp;
    var tmp1_elvis_lhs = this.dou(parentCell, provider);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var _destruct__k2r9zo = tmp_0;
    var parentCellPath = _destruct__k2r9zo.ug();
    var node = _destruct__k2r9zo.vg();
    var pathInParent = TreePath_init_$Create$_0(cell, ensureNotNull(cell.yt()));
    return to(parentCellPath.fou(VOID, parentCellPath.aou_1.llh(pathInParent)), node);
  };
  var Companion_instance_348;
  function Companion_getInstance_348() {
    return Companion_instance_348;
  }
  function CellPath(index, path) {
    this.zot_1 = index;
    this.aou_1 = path;
  }
  protoOf(CellPath).bou = function (node, provider) {
    return this.aou_1.jlh(this.gou(node, provider));
  };
  protoOf(CellPath).hou = function (node, provider) {
    var tmp;
    if (hasNodeCell(this, node, provider)) {
      tmp = this.aou_1.klh(this.gou(node, provider));
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(CellPath).gou = function (node, provider) {
    return provider.cou(node).q(this.zot_1);
  };
  protoOf(CellPath).iou = function (index, path) {
    return new CellPath(index, path);
  };
  protoOf(CellPath).fou = function (index, path, $super) {
    index = index === VOID ? this.zot_1 : index;
    path = path === VOID ? this.aou_1 : path;
    return $super === VOID ? this.iou(index, path) : $super.iou.call(this, index, path);
  };
  protoOf(CellPath).toString = function () {
    return 'CellPath(index=' + this.zot_1 + ', path=' + this.aou_1.toString() + ')';
  };
  protoOf(CellPath).hashCode = function () {
    var result = this.zot_1;
    result = imul(result, 31) + this.aou_1.hashCode() | 0;
    return result;
  };
  protoOf(CellPath).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CellPath))
      return false;
    var tmp0_other_with_cast = other instanceof CellPath ? other : THROW_CCE();
    if (!(this.zot_1 === tmp0_other_with_cast.zot_1))
      return false;
    if (!this.aou_1.equals(tmp0_other_with_cast.aou_1))
      return false;
    return true;
  };
  function CellStateAfterExternalOpRestorer(cellStateManager) {
    this.jou_1 = cellStateManager;
    this.kou_1 = null;
  }
  protoOf(CellStateAfterExternalOpRestorer).y3k = function () {
    this.kou_1 = this.jou_1.tou();
  };
  protoOf(CellStateAfterExternalOpRestorer).qko = function (op) {
    if (!(this.kou_1 == null)) {
      try {
        var transformed = ensureNotNull(this.kou_1).tot(op);
        if (!Companion_getInstance_347().mot(transformed, this.kou_1)) {
          transformed.rot(this.jou_1.mou_1, this.jou_1.pou_1);
        }
      }finally {
        this.kou_1 = null;
      }
    }
  };
  protoOf(CellStateAfterExternalOpRestorer).z3k = function (op) {
    return this.qko(op);
  };
  function _get_focusedCellContext__gbcdrf($this) {
    var tmp0_safe_receiver = $this.nou_1.rlp().qr();
    var normalizedFocusedCell = tmp0_safe_receiver == null ? null : getNonPopupAncestor(tmp0_safe_receiver);
    var cellToFocus = normalizedFocusedCell;
    if (!(normalizedFocusedCell == null) && !normalizedFocusedCell.hlp().qr()) {
      cellToFocus = firstFocusable(normalizedFocusedCell);
    }
    return to(normalizedFocusedCell, cellToFocus);
  }
  function _get_stateContext__44199p($this) {
    var focusedCellCtx = _get_focusedCellContext__gbcdrf($this);
    var focusedCellAndAncestors = ArrayDeque_init_$Create$();
    var current = focusedCellCtx.dh_1;
    while (!(current == null)) {
      var handler = current.ulp(Companion_getInstance_305().zmt_1);
      if (!(handler == null)) {
        focusedCellAndAncestors.p2(0, current);
      }
      current = current.yt();
    }
    var cellsToSave = LinkedHashSet_init_$Create$_0(focusedCellAndAncestors);
    cellsToSave.o($this.qou_1);
    return new Pair(focusedCellCtx.eh_1, cellsToSave);
  }
  function focusedState($this, cell) {
    return Companion_getInstance_347().qot($this.lou_1, cell, emptySet(), $this.oou_1, $this.pou_1);
  }
  function doGetCellContainerState($this) {
    var ctx = _get_stateContext__44199p($this);
    return Companion_getInstance_347().qot($this.lou_1, ctx.dh_1, ctx.eh_1, $this.oou_1, $this.pou_1);
  }
  function CellStateManager$1(this$0) {
    this.uou_1 = this$0;
  }
  protoOf(CellStateManager$1).blq = function (cell, prop, change) {
    this.uou_1.sou_1 = null;
  };
  protoOf(CellStateManager$1).clq = function (parent, change) {
    this.uou_1.sou_1 = null;
  };
  protoOf(CellStateManager$1).dlq = function (parent, change) {
    this.uou_1.sou_1 = null;
  };
  function CellStateManager(containerId, entityContext, cellContainer, operationProvider, cellProvider) {
    this.lou_1 = containerId;
    this.mou_1 = entityContext;
    this.nou_1 = cellContainer;
    this.oou_1 = operationProvider;
    this.pou_1 = cellProvider;
    this.qou_1 = HashSet_init_$Create$();
    this.sou_1 = null;
    var tmp = this;
    tmp.rou_1 = this.nou_1.wmi(new CellStateManager$1(this));
  }
  protoOf(CellStateManager).vou = function () {
    return focusedState(this, _get_focusedCellContext__gbcdrf(this).eh_1);
  };
  protoOf(CellStateManager).tou = function () {
    var state = this.sou_1;
    if (state == null) {
      state = doGetCellContainerState(this);
      this.sou_1 = state;
    }
    return state;
  };
  protoOf(CellStateManager).wou = function () {
    var _iterator__ex2g4s = _get_stateContext__44199p(this).eh_1.k();
    while (_iterator__ex2g4s.l()) {
      var cell = _iterator__ex2g4s.m();
      if (get_stateHandler(cell).fmv(cell)) {
        if (this.qou_1.s(cell)) {
          this.qou_1.k2(cell);
          this.sou_1 = null;
        }
      } else {
        if (!this.qou_1.s(cell)) {
          this.qou_1.e(cell);
          this.sou_1 = null;
        }
      }
    }
  };
  protoOf(CellStateManager).xou = function (removed) {
    if (this.qou_1.s(removed)) {
      this.qou_1.k2(removed);
      this.sou_1 = null;
    }
    var _iterator__ex2g4s = removed.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var child = _iterator__ex2g4s.m();
      this.xou(child);
    }
  };
  protoOf(CellStateManager).you = function (state) {
    if (equals(this.lou_1, state.not_1)) {
      state.rot(this.mou_1, this.pou_1);
    }
  };
  protoOf(CellStateManager).zou = function (cell) {
    // Inline function 'kotlin.require' call
    if (!equals(cell.llk(), this.nou_1)) {
      // Inline function 'jetbrains.ocelot.otProjectional.CellStateManager.getFocusedState.<anonymous>' call
      var message = toString_1(cell) + " doesn't belong to " + toString_1(this.nou_1) + ': ' + toString_0(cell.llk());
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return focusedState(this, cell);
  };
  protoOf(CellStateManager).vr = function () {
    this.qou_1.m2();
    this.rou_1.vr();
  };
  function CellStateOperation$doExecute$lambda(this$0, $node, $provider) {
    return function () {
      var cell = this$0.yot($node, $provider);
      get_stateHandler(cell).hmv(cell, this$0.iot_1);
      return Unit_instance;
    };
  }
  function CellStateOperation(cellState, path) {
    CellOperation.call(this, path);
    this.iot_1 = cellState;
  }
  protoOf(CellStateOperation).xot = function (otherOp, server) {
    var tmp;
    var tmp_0 = this.iot_1;
    if (isInterface(tmp_0, TransformableCellState)) {
      var transformedState = this.iot_1.aov(otherOp);
      var tmp_1;
      if (transformedState == null) {
        tmp_1 = new NopOperation();
      } else {
        tmp_1 = new CellStateOperation(transformedState, this.zos_1);
      }
      tmp = tmp_1;
    } else {
      tmp = new NopOperation();
    }
    return tmp;
  };
  protoOf(CellStateOperation).r3p = function (otherOp, server) {
    return this.xot(otherOp, server);
  };
  protoOf(CellStateOperation).wot = function (node, provider) {
    var nodeCell = this.zos_1.gou(node, provider);
    whenDescendantsReady(nodeCell, CellStateOperation$doExecute$lambda(this, node, provider));
  };
  function DefaultOperationProvider$ModelOperationSupplier$get$ref($boundThis) {
    var l = function (p0, p1) {
      return $boundThis.cov(p0, p1);
    };
    l.callableName = 'get';
    return l;
  }
  function ModelOperationSupplier(cellProvider) {
    this.bov_1 = cellProvider;
  }
  protoOf(ModelOperationSupplier).cov = function (node, operation) {
    var nodeCell = firstOrNull_0(this.bov_1.cou(node));
    var tmp;
    if (!(nodeCell == null) && nodeCell.ulp(Cells_getInstance().lmg_1)) {
      // Inline function 'kotlin.checkNotNull' call
      var tmp0 = Companion_instance_348.eou(nodeCell, this.bov_1);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          tmp$ret$1 = tmp0;
          break $l$block;
        }
      }
      var _destruct__k2r9zo = tmp$ret$1;
      var cellPath = _destruct__k2r9zo.ug();
      var enclosingNode = _destruct__k2r9zo.vg();
      var nonChildNodeOp = new NonChildNodeOperation(cellPath, node.v39(), operation);
      var tmp_0 = ModelOperationConverter_instance;
      tmp = tmp_0.i47(enclosingNode, nonChildNodeOp, DefaultOperationProvider$ModelOperationSupplier$get$ref(this));
    } else if (node.z39() == null) {
      tmp = new SetModelOperation(operation);
    } else {
      tmp = null;
    }
    return tmp;
  };
  function DefaultOperationProvider$ModelOperationSupplier$get$ref_0($boundThis) {
    var l = function (p0, p1) {
      return $boundThis.cov(p0, p1);
    };
    l.callableName = 'get';
    return l;
  }
  function DefaultOperationProvider(root, modelId) {
    this.dov_1 = root;
    this.eov_1 = modelId;
  }
  protoOf(DefaultOperationProvider).dot = function (node, operation, cellProvider) {
    var tmp = ModelOperationConverter_instance;
    var nodeOp = tmp.i47(node, operation, DefaultOperationProvider$ModelOperationSupplier$get$ref_0(new ModelOperationSupplier(cellProvider)));
    var entityOp = new ChangeModelBlobOperation(this.eov_1, nodeOp);
    return OperationConverter_instance.o3l(this.dov_1, entityOp);
  };
  function FocusOperation$doExecute$lambda(this$0, $node, $provider) {
    return function () {
      var tmp;
      if (this$0.zos_1.hou($node, $provider)) {
        var cell = this$0.yot($node, $provider);
        ensureNotNull(cell.llk()).rlp().t2c(cell);
        tmp = Unit_instance;
      } else {
        tmp = toLastFocusable(this$0.zos_1.gou($node, $provider))();
      }
      return Unit_instance;
    };
  }
  function FocusOperation(path) {
    CellOperation.call(this, path);
  }
  protoOf(FocusOperation).wot = function (node, provider) {
    var nodeCell = this.zos_1.gou(node, provider);
    whenDescendantsReady(nodeCell, FocusOperation$doExecute$lambda(this, node, provider));
  };
  function dropHead($this) {
    if (!($this.kov_1 === get_lastIndex_2($this.jov_1))) {
      subListTail_0($this.jov_1, $this.kov_1 + 1 | 0).m2();
    }
  }
  function dropTail($this) {
    var size = $this.jov_1.n();
    if (size > $this.iov_1) {
      $this.jov_1.j2(0, size - $this.iov_1 | 0).m2();
    }
  }
  function shouldPush($this, location) {
    return !(location == null) && equals(location.llk(), ensureNotNull($this.qov_1.oov_1).nou_1);
  }
  function ensureCellStateManagerSet($this) {
    var tmp0 = $this.oov_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'jetbrains.ocelot.otProjectional.NavigationManager.ensureCellStateManagerSet.<anonymous>' call
        var message = 'Navigation while no cell container available';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
  }
  function navigate($this, back) {
    ensureCellStateManagerSet($this);
    var fromState = ensureNotNull($this.oov_1).vou();
    var tmp0_elvis_lhs = $this.mov_1.rov(back, fromState);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var toState = tmp;
    var toContainerId = toState.not_1;
    if (equals(fromState.not_1, toContainerId)) {
      navigate_0($this, toState);
    } else {
      $this.sov(toContainerId, NavigationManager$navigate$lambda($this, toState));
    }
  }
  function navigate_0($this, to) {
    var toContainerId = to.not_1;
    var stateManager = ensureNotNull($this.oov_1);
    var managerContainerId = stateManager.lou_1;
    // Inline function 'kotlin.check' call
    if (!equals(toContainerId, managerContainerId)) {
      // Inline function 'jetbrains.ocelot.otProjectional.NavigationManager.navigate.<anonymous>' call
      var message = 'Restoring mismatching state: expected container id=' + toString_1(toContainerId) + ', actual id=' + toString_1(managerContainerId);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    stateManager.you(to);
  }
  function MyStack(maxSize) {
    this.iov_1 = maxSize;
    this.jov_1 = ArrayList_init_$Create$_0(this.iov_1);
    this.kov_1 = 0;
  }
  protoOf(MyStack).tov = function (op) {
    var inductionVariable = this.jov_1.n() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var location = this.jov_1.q(i);
        var newLocation = location.tot(op);
        this.jov_1.o2(i, newLocation);
      }
       while (0 <= inductionVariable);
  };
  protoOf(MyStack).rov = function (back, from) {
    var position = back ? this.kov_1 - 1 | 0 : this.kov_1 < (this.jov_1.n() - 1 | 0) ? this.kov_1 + 1 | 0 : -1;
    if (position < 0) {
      return null;
    }
    var current = this.jov_1.q(this.kov_1);
    if (!Companion_getInstance_347().mot(current, from)) {
      this.jov_1.o2(this.kov_1, from);
    }
    var to = this.jov_1.q(position);
    this.kov_1 = position;
    return to;
  };
  protoOf(MyStack).uov = function (state, isFrom) {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.jov_1.p()) {
      tmp = isFrom;
    } else {
      tmp = false;
    }
    if (tmp) {
      dropHead(this);
      if (Companion_getInstance_347().mot(this.jov_1.q(this.kov_1), state)) {
        this.jov_1.q2(this.kov_1);
      }
    }
    this.jov_1.e(state);
    dropTail(this);
    this.kov_1 = get_lastIndex_2(this.jov_1);
  };
  function NavigationManager$1(this$0) {
    this.qov_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(NavigationManager$1).bll = function (cell, spec, event) {
    if (spec === Cells_getInstance().jmg_1) {
      ensureCellStateManagerSet(this.qov_1);
      var e = event instanceof FocusEvent ? event : THROW_CCE();
      var oldValue = e.bmh_1;
      var newValue = e.cmh_1;
      if (oldValue === newValue) {
        return Unit_instance;
      }
      if (shouldPush(this, oldValue)) {
        this.qov_1.mov_1.uov(ensureNotNull(this.qov_1.oov_1).zou(ensureNotNull(oldValue)), true);
      }
      if (shouldPush(this, newValue)) {
        this.qov_1.mov_1.uov(ensureNotNull(this.qov_1.oov_1).zou(ensureNotNull(newValue)), false);
      }
    } else {
      protoOf(CellTrait).bll.call(this, cell, spec, event);
    }
  };
  protoOf(NavigationManager$1).llm = function (cell, event) {
    var back = event.ol1([KeyStrokeSpecs_getInstance().kl3_1]);
    if (back || event.ol1([KeyStrokeSpecs_getInstance().ll3_1])) {
      event.ol0();
      navigate(this.qov_1, back);
      return Unit_instance;
    }
    protoOf(CellTrait).llm.call(this, cell, event);
  };
  function NavigationManager$2(this$0) {
    this.vov_1 = this$0;
  }
  protoOf(NavigationManager$2).pko = function (op) {
    return this.vov_1.mov_1.tov(op);
  };
  protoOf(NavigationManager$2).t3k = function (op) {
    return this.pko(op);
  };
  protoOf(NavigationManager$2).qko = function (op) {
    return this.vov_1.mov_1.tov(op);
  };
  protoOf(NavigationManager$2).z3k = function (op) {
    return this.qko(op);
  };
  function NavigationManager$navigate$lambda(this$0, $toState) {
    return function () {
      navigate_0(this$0, $toState);
      return Unit_instance;
    };
  }
  function NavigationManager(processor, maxStackSize) {
    this.oov_1 = null;
    this.pov_1 = Companion_getInstance_25().wr_1;
    this.mov_1 = new MyStack(maxStackSize);
    var tmp = this;
    tmp.lov_1 = new NavigationManager$1(this);
    var tmp_0 = this;
    tmp_0.nov_1 = processor.f3l(new NavigationManager$2(this));
  }
  protoOf(NavigationManager).wov = function (cellStateManager) {
    this.pov_1.vr();
    this.oov_1 = cellStateManager;
    var tmp = this;
    var tmp1_safe_receiver = cellStateManager == null ? null : cellStateManager.nou_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u3o();
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.olp(this.lov_1);
    tmp.pov_1 = tmp3_elvis_lhs == null ? Companion_getInstance_25().wr_1 : tmp3_elvis_lhs;
  };
  protoOf(NavigationManager).vr = function () {
    this.pov_1.vr();
    this.nov_1.vr();
  };
  function NodeCellState$restore$1($cellProvider) {
    this.xov_1 = $cellProvider;
    OperationCondition.call(this);
  }
  protoOf(NodeCellState$restore$1).r3m = function (op) {
    if (op instanceof CellOperation) {
      op.uot(this.xov_1);
      return true;
    }
    return false;
  };
  function NodeCellState(operation) {
    this.xos_1 = operation;
  }
  protoOf(NodeCellState).t3j = function () {
    return this.xos_1.t3j();
  };
  protoOf(NodeCellState).sot = function (context, cellProvider) {
    (new NodeCellState$restore$1(cellProvider)).q3m(this.xos_1);
    this.xos_1.j3p(context);
  };
  protoOf(NodeCellState).toString = function () {
    return 'NodeCellState[' + toString_1(this.xos_1) + ']';
  };
  function NonChildNodeOperation$doExecute$lambda(this$0, $node, $provider) {
    return function () {
      var cell = this$0.zos_1.bou($node, $provider);
      var innerNode = $provider.bot(cell);
      var tmp;
      if (!(innerNode == null) && NodeUtil_instance.g3i(this$0.bow_1, innerNode.v39())) {
        var tmp_0 = this$0.cow_1;
        if (tmp_0 instanceof CellOperation) {
          this$0.cow_1.uot($provider);
        }
        this$0.cow_1.j3p(innerNode);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NonChildNodeOperation(cellPath, nodeId, operation) {
    CellOperation.call(this, cellPath);
    this.bow_1 = nodeId;
    this.cow_1 = operation;
  }
  protoOf(NonChildNodeOperation).u3l = function () {
    return this.cow_1;
  };
  protoOf(NonChildNodeOperation).h3b = function () {
    return this.zos_1;
  };
  protoOf(NonChildNodeOperation).wot = function (node, provider) {
    var nodeCell = this.zos_1.gou(node, provider);
    whenDescendantsReady(nodeCell, NonChildNodeOperation$doExecute$lambda(this, node, provider));
  };
  function undo($this, kind, cellContainer) {
    var tmp;
    if (kind.equals(ActionKind_UNDO_getInstance())) {
      tmp = $this.dow_1.b4p();
    } else {
      tmp = $this.dow_1.h4p();
    }
    var stateProp = tmp;
    var undoState = stateProp.qr();
    if (undoState.f4p()) {
      confirmUndo($this, stateProp, kind, cellContainer);
    } else {
      handleRejection($this, kind, undoState);
    }
  }
  function handleRejection($this, kind, state) {
    $this.eow_1.fow(state.d4p_1, kind, state.o4p());
  }
  function confirmUndo($this, state, kind, cellContainer) {
    var tmp = $this.eow_1.gow(state.qr().d4p_1, kind);
    tmp.i2l(OtSupport$UndoTrait$confirmUndo$lambda(state, kind, cellContainer, $this));
  }
  function UndoManager$undo$ref($boundThis) {
    var l = function () {
      $boundThis.a4p();
      return Unit_instance;
    };
    l.callableName = 'undo';
    return l;
  }
  function UndoManager$redo$ref($boundThis) {
    var l = function () {
      $boundThis.g4p();
      return Unit_instance;
    };
    l.callableName = 'redo';
    return l;
  }
  function OtSupport$UndoTrait$confirmUndo$lambda($state, $kind, $cellContainer, this$0) {
    return function (value) {
      var tmp;
      if (value) {
        var currentState = $state.qr();
        var tmp_0;
        if (currentState.f4p()) {
          var tmp_1;
          if ($kind.equals(ActionKind_UNDO_getInstance())) {
            $cellContainer.hm9(UndoManager$undo$ref(this$0.dow_1));
            tmp_1 = Unit_instance;
          } else {
            $cellContainer.hm9(UndoManager$redo$ref(this$0.dow_1));
            tmp_1 = Unit_instance;
          }
          tmp_0 = tmp_1;
        } else {
          handleRejection(this$0, $kind, currentState);
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function OtSupport$CellContainerCommandWatcher$lambda(this$0, $undoManager) {
    return function (event) {
      var newValue = event.p2e_1;
      var tmp;
      if (!(newValue === Companion_getInstance_44().b3j_1)) {
        // Inline function 'kotlin.check' call
        if (!(event.o2e_1 === Companion_getInstance_44().b3j_1)) {
          // Inline function 'jetbrains.ocelot.otProjectional.CellContainerCommandWatcher.<anonymous>.<anonymous>' call
          var message = 'Reset non-default group id: ' + event.toString();
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        }
        var tmp_0;
        if (this$0.how_1.n3j_1) {
          $undoManager.t4o(newValue);
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function getUndoGroupId($this, cellContainer) {
    return cellContainer.u3o().flp($this.oow_1);
  }
  function UndoTrait(undoManager, undoStateHandler) {
    CellTrait.call(this);
    this.dow_1 = undoManager;
    this.eow_1 = undoStateHandler;
  }
  protoOf(UndoTrait).llm = function (cell, event) {
    var tmp;
    if (event.ol1([KeyStrokeSpecs_getInstance().gl2_1])) {
      event.ol0();
      undo(this, ActionKind_UNDO_getInstance(), ensureNotNull(cell.llk()));
      tmp = Unit_instance;
    } else if (event.ol1([KeyStrokeSpecs_getInstance().hl2_1])) {
      event.ol0();
      undo(this, ActionKind_REDO_getInstance(), ensureNotNull(cell.llk()));
      tmp = Unit_instance;
    } else {
      protoOf(CellTrait).llm.call(this, cell, event);
      tmp = Unit_instance;
    }
    return tmp;
  };
  function CellContainerCommandWatcher(processor, cellStateManager, undoManager) {
    this.how_1 = processor;
    this.iow_1 = cellStateManager;
    this.jow_1 = getUndoGroupId(Companion_getInstance_349(), this.iow_1.nou_1);
    this.low_1 = false;
    var tmp = this;
    tmp.kow_1 = this.jow_1.p27(OtSupport$CellContainerCommandWatcher$lambda(this, undoManager));
  }
  protoOf(CellContainerCommandWatcher).zlp = function () {
    if (!this.how_1.o3j_1) {
      this.how_1.h3l(this.jow_1.qr());
      this.low_1 = true;
    }
  };
  protoOf(CellContainerCommandWatcher).alq = function () {
    if (this.low_1) {
      this.low_1 = false;
      this.how_1.i3l();
      this.iow_1.wou();
    }
  };
  protoOf(CellContainerCommandWatcher).dlq = function (parent, change) {
    return this.iow_1.xou(change.i27());
  };
  protoOf(CellContainerCommandWatcher).vr = function () {
    this.kow_1.vr();
    this.alq();
  };
  function Companion_349() {
    Companion_instance_349 = this;
    this.mow_1 = 100;
    this.now_1 = 10;
    this.oow_1 = CellPropertySpec_init_$Create$('undoGroupId', Companion_getInstance_44().b3j_1);
  }
  protoOf(Companion_349).pow = function () {
    return Companion_getInstance_347().eot_1;
  };
  var Companion_instance_349;
  function Companion_getInstance_349() {
    if (Companion_instance_349 == null)
      new Companion_349();
    return Companion_instance_349;
  }
  function OtSupport(commandProcessor, cellStateManager, undoManager, undoStateHandler, allowUndo) {
    Companion_getInstance_349();
    allowUndo = allowUndo === VOID ? true : allowUndo;
    this.qow_1 = cellStateManager;
    this.row_1 = undoManager;
    this.tow_1 = new CompositeDisposable([]);
    var containerWatcher = new CellContainerCommandWatcher(commandProcessor, this.qow_1, this.row_1);
    var cellContainer = this.qow_1.nou_1;
    this.sow_1 = containerWatcher.sr(cellContainer.wmi(containerWatcher)).sr(commandProcessor.f3l(new CellStateAfterExternalOpRestorer(this.qow_1)));
    if (allowUndo) {
      var trait = new UndoTrait(this.row_1, undoStateHandler);
      this.uow(cellContainer.u3o().olp(trait));
    }
  }
  protoOf(OtSupport).uow = function (action) {
    this.tow_1.ur([action]);
  };
  protoOf(OtSupport).vr = function () {
    this.tow_1.vr();
    this.sow_1.vr();
  };
  function getSelectionUndoCommandType($this, savedSelection, currentSelection) {
    if (savedSelection == null) {
      return UndoCommandType_EMPTY_getInstance();
    }
    var path = Companion_getInstance_347().kot(savedSelection);
    return path == null ? UndoCommandType_EMPTY_getInstance() : Companion_getInstance_347().lot(savedSelection, currentSelection) ? UndoCommandType_EMPTY_getInstance() : UndoCommandType_NAVIGATION_getInstance();
  }
  function OtViewStateProvider() {
    this.vow_1 = null;
  }
  protoOf(OtViewStateProvider).o4o = function () {
    var tmp;
    if (this.vow_1 == null) {
      tmp = null;
    } else {
      tmp = ensureNotNull(this.vow_1).tou();
    }
    return tmp;
  };
  protoOf(OtViewStateProvider).wov = function (cellStateManager) {
    this.vow_1 = cellStateManager;
  };
  protoOf(OtViewStateProvider).wow = function (state) {
    var tmp0 = this.vow_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'jetbrains.ocelot.otProjectional.OtViewStateProvider.restore.<anonymous>' call
        var message = 'Unable to restore state: ' + state.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    ensureNotNull(this.vow_1).you(state);
  };
  protoOf(OtViewStateProvider).t4n = function (state) {
    return this.wow(state instanceof CellContainerState ? state : THROW_CCE());
  };
  protoOf(OtViewStateProvider).xow = function (saved, current) {
    if (!equals(saved.not_1, current.not_1)) {
      return UndoCommandType_NAVIGATION_getInstance();
    }
    var savedPaths = Companion_getInstance_347().jot(saved.pot_1);
    var currentPaths = Companion_getInstance_347().jot(current.pot_1);
    var containerStateDifference = CellStateDifference_EQUAL_getInstance();
    var _iterator__ex2g4s = savedPaths.u2().k();
    while (_iterator__ex2g4s.l()) {
      var path = _iterator__ex2g4s.m();
      var cellState = currentPaths.y2(path);
      var cellDifference = getValue_0(savedPaths, path).emv(cellState);
      if (cellDifference.equals(CellStateDifference_EDIT_getInstance())) {
        return UndoCommandType_EDITING_getInstance();
      }
      containerStateDifference = Companion_instance_304.emy(containerStateDifference, cellDifference);
    }
    var tmp;
    if (!containerStateDifference.equals(CellStateDifference_EQUAL_getInstance())) {
      tmp = UndoCommandType_NAVIGATION_getInstance();
    } else {
      tmp = getSelectionUndoCommandType(this, saved.oot_1, current.oot_1);
    }
    return tmp;
  };
  protoOf(OtViewStateProvider).w4p = function (saved, current) {
    var tmp = saved instanceof CellContainerState ? saved : THROW_CCE();
    return this.xow(tmp, current instanceof CellContainerState ? current : THROW_CCE());
  };
  protoOf(OtViewStateProvider).toString = function () {
    var name = getKClassFromExpression(this).lb();
    return plus_10(name, '@') + toString_3(hashCode(this), 16);
  };
  function SimpleUndoStateHandler() {
  }
  protoOf(SimpleUndoStateHandler).gow = function (groupId, actionKind) {
    return Asyncs_instance.p2l(true);
  };
  protoOf(SimpleUndoStateHandler).fow = function (groupId, actionKind, rejectionInfo) {
  };
  function TransformableCellState() {
  }
  var ActionKind_UNDO_instance;
  var ActionKind_REDO_instance;
  var ActionKind_entriesInitialized;
  function ActionKind_initEntries() {
    if (ActionKind_entriesInitialized)
      return Unit_instance;
    ActionKind_entriesInitialized = true;
    ActionKind_UNDO_instance = new ActionKind('UNDO', 0);
    ActionKind_REDO_instance = new ActionKind('REDO', 1);
  }
  function ActionKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_350() {
    Companion_instance_350 = this;
    this.yow_1 = new SimpleUndoStateHandler();
  }
  var Companion_instance_350;
  function Companion_getInstance_350() {
    if (Companion_instance_350 == null)
      new Companion_350();
    return Companion_instance_350;
  }
  function ActionKind_UNDO_getInstance() {
    ActionKind_initEntries();
    return ActionKind_UNDO_instance;
  }
  function ActionKind_REDO_getInstance() {
    ActionKind_initEntries();
    return ActionKind_REDO_instance;
  }
  function NodeCellProvider$getNode$lambda(it) {
    return true;
  }
  function NodeCellProvider() {
  }
  function NodeWrapperCellProvider$getCells$sourcePath$1($nodeWrapper) {
    this.aox_1 = $nodeWrapper;
  }
  protoOf(NodeWrapperCellProvider$getCells$sourcePath$1).l = function () {
    return !(this.aox_1 == null);
  };
  protoOf(NodeWrapperCellProvider$getCells$sourcePath$1).m = function () {
    var tmp0_elvis_lhs = this.aox_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw NoSuchElementException_init_$Create$();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var next = tmp;
    this.aox_1 = next.z39();
    return next;
  };
  function NodeWrapperCellProvider$getNode$lambda($predicate) {
    return function (source) {
      var tmp;
      if (source instanceof NodeWrapper) {
        tmp = $predicate(source.c4t_1);
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function NodeWrapperCellProvider(wrapperContext, provider) {
    this.box_1 = wrapperContext;
    this.cox_1 = provider;
  }
  protoOf(NodeWrapperCellProvider).cou = function (source) {
    var nodeWrapper = this.box_1.d4t(source instanceof Node_0 ? source : THROW_CCE());
    var sourcePath = new NodeWrapperCellProvider$getCells$sourcePath$1(nodeWrapper);
    return this.cox_1.yn4(sourcePath);
  };
  protoOf(NodeWrapperCellProvider).zow = function (cell, predicate) {
    var tmp = this.cox_1.zn4(cell, NodeWrapperCellProvider$getNode$lambda(predicate));
    var source = tmp instanceof NodeWrapper ? tmp : null;
    return source == null ? null : source.c4t_1;
  };
  function OtNodeCellProvider$getCells$sourcePath$1($source) {
    this.dox_1 = $source;
  }
  protoOf(OtNodeCellProvider$getCells$sourcePath$1).l = function () {
    return !(this.dox_1 == null);
  };
  protoOf(OtNodeCellProvider$getCells$sourcePath$1).m = function () {
    var tmp0_elvis_lhs = this.dox_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw NoSuchElementException_init_$Create$();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var next = tmp;
    this.dox_1 = next.z39();
    return next;
  };
  function OtNodeCellProvider$getNode$lambda($predicate) {
    return function (source) {
      var tmp;
      if (source instanceof OtNode) {
        tmp = $predicate(source);
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  function OtNodeCellProvider(provider) {
    this.eox_1 = provider;
  }
  protoOf(OtNodeCellProvider).cou = function (source) {
    var sourcePath = new OtNodeCellProvider$getCells$sourcePath$1(source);
    return this.eox_1.yn4(sourcePath);
  };
  protoOf(OtNodeCellProvider).zow = function (cell, predicate) {
    var tmp = this.eox_1.zn4(cell, OtNodeCellProvider$getNode$lambda(predicate));
    var source = tmp instanceof OtNode ? tmp : null;
    return source;
  };
  function getNodeWrapperCellProviderFromMapper(mapper, context) {
    context = context === VOID ? mapper.pl9_1.b4t_1 : context;
    var cellProvider = getCellProviderFromMapper(mapper);
    return new NodeWrapperCellProvider(context, cellProvider);
  }
  function getNodeCellProviderFromMapper(mapper) {
    var tmp0_subject = mapper.pl9_1;
    var tmp;
    if (tmp0_subject instanceof OtNode) {
      tmp = getOtNodeCellProviderFromMapper(mapper instanceof Mapper ? mapper : THROW_CCE());
    } else {
      if (tmp0_subject instanceof NodeWrapper) {
        tmp = getNodeWrapperCellProviderFromMapper(mapper instanceof Mapper ? mapper : THROW_CCE());
      } else {
        var message = 'Unexpected source: ' + toString_0(mapper.pl9_1);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    return tmp;
  }
  function getOtNodeCellProviderFromMapper(mapper) {
    var cellProvider = getCellProviderFromMapper(mapper);
    return new OtNodeCellProvider(cellProvider);
  }
  function _get_cellContainer__92er8y($this) {
    var tmp = $this.fox_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('cellContainer');
    }
  }
  function _get_processor__en8wzl($this) {
    var tmp = $this.gox_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('processor');
    }
  }
  function _get_cellProvider__u40mk8($this) {
    var tmp = $this.hox_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('cellProvider');
    }
  }
  function _get_operationProvider__dyl06f($this) {
    var tmp = $this.iox_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('operationProvider');
    }
  }
  function verifyComponents($this) {
    // Inline function 'kotlin.check' call
    if (!($this.lox_1 >= 0)) {
      // Inline function 'jetbrains.ocelot.otProjectional.singleStack.OtSupportBuilder.verifyComponents.<anonymous>' call
      var message = 'Max navigation stack size value is negative';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    // Inline function 'kotlin.check' call
    if (!($this.kox_1 >= 0)) {
      // Inline function 'jetbrains.ocelot.otProjectional.singleStack.OtSupportBuilder.verifyComponents.<anonymous>' call
      var message_0 = 'Max undo stack size is negative';
      throw IllegalStateException_init_$Create$_0(toString_1(message_0));
    }
  }
  function OtSupportBuilder() {
    this.jox_1 = Companion_getInstance_350().yow_1;
    this.kox_1 = 100;
    this.lox_1 = 10;
    this.mox_1 = true;
  }
  protoOf(OtSupportBuilder).k2p = function () {
    verifyComponents(this);
    var undoManager = singleStackUndoManager(_get_processor__en8wzl(this), this.kox_1, this.mox_1);
    var otViewStateProvider = new OtViewStateProvider();
    var viewStateProviderReg = undoManager.w4o(otViewStateProvider);
    var navigationManager = new SingleNavigationManager(_get_processor__en8wzl(this), this.lox_1);
    var cellStateManager = new CellStateManager(ensureNotNull(undoManager.m4n_1), _get_processor__en8wzl(this).d3j_1, _get_cellContainer__92er8y(this), _get_operationProvider__dyl06f(this), _get_cellProvider__u40mk8(this));
    otViewStateProvider.wov(cellStateManager);
    navigationManager.wov(cellStateManager);
    var otSupport = new OtSupport(_get_processor__en8wzl(this), cellStateManager, undoManager, this.jox_1, this.mox_1);
    otSupport.uow(viewStateProviderReg);
    otSupport.uow(cellStateManager);
    otSupport.uow(undoManager);
    otSupport.uow(navigationManager);
    return otSupport;
  };
  protoOf(OtSupportBuilder).nox = function (cellContainer) {
    this.fox_1 = cellContainer;
    return this;
  };
  protoOf(OtSupportBuilder).oox = function (processor) {
    this.gox_1 = processor;
    return this;
  };
  protoOf(OtSupportBuilder).pox = function (cellProvider) {
    this.hox_1 = cellProvider;
    return this;
  };
  protoOf(OtSupportBuilder).qox = function (operationProvider) {
    this.iox_1 = operationProvider;
    return this;
  };
  function SingleNavigationManager(processor, maxStackSize) {
    NavigationManager.call(this, processor, maxStackSize);
  }
  protoOf(SingleNavigationManager).sov = function (containerId, callback) {
    throw UnsupportedOperationException_init_$Create$();
  };
  function _get_cm__ndbyw1($this) {
    var tmp = $this.aoy_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('cm');
    }
  }
  function _get_hm__ndc2li($this) {
    var tmp = $this.boy_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('hm');
    }
  }
  function HighlightErrorsSynchronizer$trait$1(this$0) {
    this.doy_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(HighlightErrorsSynchronizer$trait$1).flo = function (cell, spec) {
    if (spec === Companion_getInstance_357().eoy_1) {
      var highlighter = _get_hm__ndc2li(this.doy_1).m2c();
      return highlighter;
    }
    return protoOf(CellTrait).flo.call(this, cell, spec);
  };
  function HighlightErrorsSynchronizer(coroutineScope, source, cell, checking) {
    this.wox_1 = coroutineScope;
    this.xox_1 = source;
    this.yox_1 = cell;
    this.zox_1 = checking;
    var tmp = this;
    tmp.coy_1 = new HighlightErrorsSynchronizer$trait$1(this);
  }
  protoOf(HighlightErrorsSynchronizer).jla = function (ctx) {
    this.aoy_1 = ctx.kla().cld();
    this.boy_1 = ctx.kla().cld();
    this.yox_1.olp(this.coy_1);
    var checker = new CheckNodeMapper(this.wox_1, this.zox_1, this.xox_1);
    var highlighter = new ProjectionalHighlightMapper(this.xox_1, this.yox_1, ctx.kla(), checker.ql9_1);
    _get_cm__ndbyw1(this).v2c(checker);
    _get_hm__ndc2li(this).v2c(highlighter);
  };
  protoOf(HighlightErrorsSynchronizer).t6m = function () {
    _get_cm__ndbyw1(this).v2c(null);
    _get_hm__ndc2li(this).v2c(null);
  };
  function get_highlighted(_this__u8e3s4) {
    return new highlighted$1(_this__u8e3s4);
  }
  function Companion_351() {
    Companion_instance_351 = this;
    this.foy_1 = CellTraitPropertySpec_init_$Create$('SuppressErrorChecking', false);
  }
  var Companion_instance_351;
  function Companion_getInstance_351() {
    if (Companion_instance_351 == null)
      new Companion_351();
    return Companion_instance_351;
  }
  function HighlightingMapper(coroutineScope, errorCheckConfig, node, cell) {
    Companion_getInstance_351();
    Mapper.call(this, node, cell);
    this.noy_1 = coroutineScope;
    this.ooy_1 = errorCheckConfig;
    this.poy_1 = false;
  }
  protoOf(HighlightingMapper).rla = function () {
    return this.poy_1;
  };
  protoOf(HighlightingMapper).llb = function (conf) {
    protoOf(Mapper).llb.call(this, conf);
    var tmp = getKClassFromExpression(this.pl9_1);
    var concept = isInterface(tmp, KClass) ? tmp : THROW_CCE();
    conf.x4v(new HighlightErrorsSynchronizer(this.noy_1, this.pl9_1, this.ql9_1, this.ooy_1.w72(concept)));
  };
  function highlighted(_this__u8e3s4, coroutineScope, errorCheckConfig) {
    return _this__u8e3s4.ql9_1.ulp(Companion_getInstance_351().foy_1) ? _this__u8e3s4 : Mappers_instance.old(_this__u8e3s4, [new HighlightingMapper(coroutineScope, errorCheckConfig, _this__u8e3s4.pl9_1, _this__u8e3s4.ql9_1)]);
  }
  function highlighted$1($this_highlighted) {
    this.roy_1 = $this_highlighted;
    this.qoy_1 = $this_highlighted;
  }
  protoOf(highlighted$1).soy = function (configuration, source) {
    return highlighted(this.roy_1.toy(configuration, source), configuration, configuration);
  };
  protoOf(highlighted$1).toy = function (configuration, source) {
    var tmp = (!(configuration == null) ? isInterface(configuration, CoroutineScope) ? isInterface(configuration, ErrorCheckConfig) : false : false) ? configuration : THROW_CCE();
    return this.soy(tmp, isInterface(source, DomainNode) ? source : THROW_CCE());
  };
  protoOf(highlighted$1).uoy = function () {
    return this.qoy_1.uoy();
  };
  function Companion_352() {
    Companion_instance_352 = this;
    this.voy_1 = CellTraitPropertySpec_init_$Create$('SecondaryCellForNode', false);
  }
  var Companion_instance_352;
  function Companion_getInstance_352() {
    if (Companion_instance_352 == null)
      new Companion_352();
    return Companion_instance_352;
  }
  function ProjectionalHighlightMapper(source, target, enclosing, errors) {
    Companion_getInstance_352();
    ErrorHighlighterBase.call(this, source, target, errors);
    this.foz_1 = enclosing;
  }
  protoOf(ProjectionalHighlightMapper).rla = function () {
    return false;
  };
  protoOf(ProjectionalHighlightMapper).goz = function () {
    var result = ArrayList_init_$Create$();
    var _iterator__ex2g4s = get_descendants(this.ql9_1).k();
    while (_iterator__ex2g4s.l()) {
      var cell = _iterator__ex2g4s.m();
      var descendant = cell.ulp(Companion_getInstance_357().eoy_1);
      if (!(descendant == null)) {
        result.e(descendant);
      }
    }
    return result;
  };
  protoOf(ProjectionalHighlightMapper).hoz = function (node) {
    var mappers = this.mlb().pld(root(this.foz_1), node);
    var targetCells = HashSet_init_$Create$();
    var _iterator__ex2g4s = mappers.k();
    while (_iterator__ex2g4s.l()) {
      var m = _iterator__ex2g4s.m();
      var mapperTarget = m.ql9_1;
      var tmp;
      if (!(mapperTarget == null) ? isInterface(mapperTarget, Cell) : false) {
        tmp = !mapperTarget.ulp(Companion_getInstance_352().voy_1);
      } else {
        tmp = false;
      }
      if (tmp) {
        targetCells.e(mapperTarget);
      }
    }
    // Inline function 'kotlin.check' call
    if (!(targetCells.n() <= 1)) {
      // Inline function 'jetbrains.ocelot.langDef.check.editor.ProjectionalHighlightMapper.find.<anonymous>' call
      var message = 'ambiguous mapper for descendant node mentioned in error';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    return firstOrNull_1(targetCells);
  };
  protoOf(ProjectionalHighlightMapper).ioz = function (visual, error) {
    return ErrorHighlightingController_instance.joz(visual, error.t1());
  };
  protoOf(ProjectionalHighlightMapper).koz = function (visual, error) {
    return this.ioz((!(visual == null) ? isInterface(visual, Cell) : false) ? visual : THROW_CCE(), error);
  };
  protoOf(ProjectionalHighlightMapper).loz = function (visualGroup, error) {
    return ErrorHighlightingController_instance.moz(visualGroup, error.t1());
  };
  protoOf(ProjectionalHighlightMapper).noz = function (visualGroup, error) {
    return this.loz(visualGroup, error);
  };
  function update_0($this, cell) {
    return update_1($this, cell, (new ErrorSupport(cell)).yoz());
  }
  function update_1($this, cell, errors) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var tmp$ret$0 = !errors.p();
    underline($this, cell, tmp$ret$0);
    var tmp;
    if (errors.p()) {
      tmp = null;
    } else {
      var wholeMessage = StringBuilder_init_$Create$_1();
      var _iterator__ex2g4s = errors.k();
      while (_iterator__ex2g4s.l()) {
        var msg = _iterator__ex2g4s.m();
        wholeMessage.d9(msg);
        wholeMessage.d9('\n');
      }
      tmp = new Message(wholeMessage.toString());
    }
    var message = tmp;
    MessageController_getInstance().bmn(cell, message);
  }
  function underline($this, cell, bool) {
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = get_descendants(cell);
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      if (element instanceof TextCell) {
        destination.e(element);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var element_0 = _iterator__ex2g4s_0.m();
      // Inline function 'jetbrains.ocelot.langDef.check.editor.trait.ErrorHighlighterTrait.underline.<anonymous>' call
      element_0.bln(get_RED_UNDERLINE(), bool);
    }
  }
  function ErrorHighlighterTrait() {
    ErrorHighlighterTrait_instance = this;
    CellTrait.call(this);
  }
  protoOf(ErrorHighlighterTrait).glo = function (cell) {
    update_0(this, cell);
  };
  protoOf(ErrorHighlighterTrait).uln = function (cell) {
    update_1(this, cell, emptyList());
  };
  protoOf(ErrorHighlighterTrait).bll = function (cell, spec, event) {
    if (equals(spec, Companion_getInstance_353().ap0_1)) {
      update_0(this, cell);
      return Unit_instance;
    }
    protoOf(CellTrait).bll.call(this, cell, spec, event);
  };
  var ErrorHighlighterTrait_instance;
  function ErrorHighlighterTrait_getInstance() {
    if (ErrorHighlighterTrait_instance == null)
      new ErrorHighlighterTrait();
    return ErrorHighlighterTrait_instance;
  }
  function ErrorHighlightingController$install$lambda(cell) {
    return NumberOfMessages_getInstance().dp0(cell);
  }
  function ErrorHighlightingController$install$lambda_0(cell) {
    return NumberOfMessages_getInstance().ep0(cell);
  }
  function ErrorHighlightingController() {
  }
  protoOf(ErrorHighlightingController).yn5 = function (cellContainer) {
    var trait = ErrorHighlighterTrait_getInstance();
    var needsAttach = ErrorHighlightingController$install$lambda;
    var needsDetach = ErrorHighlightingController$install$lambda_0;
    return Companion_getInstance_303().xmm(cellContainer, trait, needsAttach, needsDetach).sr(cellContainer.u3o().olp(new MouseTracker()));
  };
  protoOf(ErrorHighlightingController).joz = function (cell, message) {
    return cell.ulp(Companion_getInstance_353().zoz_1).fp0(message);
  };
  protoOf(ErrorHighlightingController).moz = function (cellGroup, message) {
    var reg = new CompositeDisposable([]);
    var groupTrait = new ShowCellGroupTrait(HashSet_init_$Create$_0(cellGroup));
    var _iterator__ex2g4s = cellGroup.k();
    while (_iterator__ex2g4s.l()) {
      var cell = _iterator__ex2g4s.m();
      reg.ur([this.joz(cell, message)]);
      reg.ur([cell.olp(groupTrait)]);
    }
    return reg;
  };
  var ErrorHighlightingController_instance;
  function ErrorHighlightingController_getInstance() {
    return ErrorHighlightingController_instance;
  }
  function ErrorSupport$Companion$PROPERTY$lambda(it) {
    return new ErrorSupport(it);
  }
  function sendEvent($this) {
    return $this.xoz_1.mlp(new Event_0(), Companion_getInstance_353().ap0_1);
  }
  function Companion_353() {
    Companion_instance_353 = this;
    var tmp = this;
    tmp.zoz_1 = new CellTraitPropertySpec('errorConsumer', ErrorSupport$Companion$PROPERTY$lambda);
    this.ap0_1 = new CellTraitEventSpec('errorSetChanged', false);
    this.bp0_1 = CellPropertySpec_init_$Create$('errorList', null);
  }
  var Companion_instance_353;
  function Companion_getInstance_353() {
    if (Companion_instance_353 == null)
      new Companion_353();
    return Companion_instance_353;
  }
  function ErrorSupport$addError$$inlined$toDisposable$1(this$0, $message) {
    this.gp0_1 = this$0;
    this.hp0_1 = $message;
  }
  protoOf(ErrorSupport$addError$$inlined$toDisposable$1).vr = function () {
    var list = this.gp0_1.xoz_1.clo(Companion_getInstance_353().bp0_1);
    // Inline function 'kotlin.check' call
    if (!(!(list == null) && list.s(this.hp0_1))) {
      // Inline function 'jetbrains.ocelot.langDef.check.editor.trait.ErrorSupport.addError.<anonymous>.<anonymous>' call
      var message = 'Unbalanced disposal of added error message. Maybe dispose() was called more than once';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    list.k2(this.hp0_1);
    if (list.p()) {
      this.gp0_1.xoz_1.bln(Companion_getInstance_353().bp0_1, null);
    }
    sendEvent(this.gp0_1);
    NumberOfMessages_getInstance().ip0(this.gp0_1.xoz_1);
    return Unit_instance;
  };
  function ErrorSupport(cell) {
    Companion_getInstance_353();
    this.xoz_1 = cell;
  }
  protoOf(ErrorSupport).yoz = function () {
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = this.xoz_1.clo(Companion_getInstance_353().bp0_1);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(ErrorSupport).fp0 = function (message) {
    var tmp0_elvis_lhs = this.xoz_1.clo(Companion_getInstance_353().bp0_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayList_init_$Create$();
      // Inline function 'jetbrains.ocelot.langDef.check.editor.trait.ErrorSupport.addError.<anonymous>' call
      this.xoz_1.bln(Companion_getInstance_353().bp0_1, this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var errorList = tmp;
    errorList.e(message);
    NumberOfMessages_getInstance().jp0(this.xoz_1);
    sendEvent(this);
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new ErrorSupport$addError$$inlined$toDisposable$1(this, message);
  };
  function Companion_354() {
    Companion_instance_354 = this;
    this.kp0_1 = CellTraitPropertySpec_init_$Create$('cellUnderMouse', null);
  }
  var Companion_instance_354;
  function Companion_getInstance_354() {
    if (Companion_instance_354 == null)
      new Companion_354();
    return Companion_instance_354;
  }
  function MouseTracker() {
    Companion_getInstance_354();
    CellTrait.call(this);
    this.lp0_1 = Companion_getInstance_251().iku_1;
  }
  protoOf(MouseTracker).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Companion_getInstance_354().kp0_1)) {
      tmp = ensureNotNull(cell.llk()).bmi(this.lp0_1);
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  protoOf(MouseTracker).nlo = function (cell, event) {
    this.lp0_1 = event.zl3();
  };
  function NumberOfMessages() {
    NumberOfMessages_instance = this;
    this.cp0_1 = CellPropertySpec_init_$Create$('numberOfMessages', 0);
  }
  protoOf(NumberOfMessages).jp0 = function (cell) {
    var numOfMsgs = cell.clo(this.cp0_1);
    numOfMsgs = numOfMsgs + 1 | 0;
    cell.bln(this.cp0_1, numOfMsgs);
  };
  protoOf(NumberOfMessages).ip0 = function (cell) {
    var numOfMsgs = cell.clo(this.cp0_1);
    // Inline function 'kotlin.check' call
    if (!!(numOfMsgs === 0)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    numOfMsgs = numOfMsgs - 1 | 0;
    cell.bln(this.cp0_1, numOfMsgs);
  };
  protoOf(NumberOfMessages).dp0 = function (cell) {
    return cell.clo(this.cp0_1) > 0;
  };
  protoOf(NumberOfMessages).ep0 = function (cell) {
    return !this.dp0(cell);
  };
  var NumberOfMessages_instance;
  function NumberOfMessages_getInstance() {
    if (NumberOfMessages_instance == null)
      new NumberOfMessages();
    return NumberOfMessages_instance;
  }
  function enter($this, source) {
    if (showFlagsUnset($this)) {
      show_0($this);
    }
    $this.op0_1[source] = true;
  }
  function leave($this, source) {
    $this.op0_1[source] = false;
    if (showFlagsUnset($this)) {
      hide_1($this);
    }
  }
  function showFlagsUnset($this) {
    return !$this.op0_1[0] && !$this.op0_1[1];
  }
  function show_0($this) {
    var reg = new CompositeDisposable([]);
    var _iterator__ex2g4s = $this.mp0_1.k();
    while (_iterator__ex2g4s.l()) {
      var c = _iterator__ex2g4s.m();
      reg.ur([mark($this, c)]);
    }
    $this.np0_1 = reg;
  }
  function hide_1($this) {
    $this.np0_1.vr();
    $this.np0_1 = Companion_getInstance_25().wr_1;
  }
  function mark($this, cell) {
    return cell.bln(get_BACKGROUND(), Companion_getInstance_325().qlt_1);
  }
  function Companion_355() {
    this.pp0_1 = 0;
    this.qp0_1 = 1;
  }
  var Companion_instance_355;
  function Companion_getInstance_355() {
    return Companion_instance_355;
  }
  function ShowCellGroupTrait(myCellGroup) {
    CellTrait.call(this);
    this.mp0_1 = myCellGroup;
    this.np0_1 = Companion_getInstance_25().wr_1;
    this.op0_1 = booleanArray(2);
  }
  protoOf(ShowCellGroupTrait).glo = function (cell) {
    protoOf(CellTrait).glo.call(this, cell);
    // Inline function 'kotlin.check' call
    if (!this.mp0_1.s(cell)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    if (isDescendantCellFocused(cell)) {
      enter(this, Companion_instance_355.pp0_1);
    }
    var underMouse = ensureNotNull(cell.llk()).u3o().ulp(Companion_getInstance_354().kp0_1);
    if (!(underMouse == null) && isDescendant(cell, underMouse)) {
      enter(this, Companion_instance_355.qp0_1);
    }
  };
  protoOf(ShowCellGroupTrait).uln = function (cell) {
    hide_1(this);
    protoOf(CellTrait).uln.call(this, cell);
  };
  protoOf(ShowCellGroupTrait).plo = function (cell, event) {
    protoOf(CellTrait).plo.call(this, cell, event);
    enter(this, Companion_instance_355.qp0_1);
  };
  protoOf(ShowCellGroupTrait).qlo = function (cell, event) {
    leave(this, Companion_instance_355.qp0_1);
    protoOf(CellTrait).qlo.call(this, cell, event);
  };
  protoOf(ShowCellGroupTrait).hlo = function (cell, event) {
    protoOf(CellTrait).hlo.call(this, cell, event);
    enter(this, Companion_instance_355.pp0_1);
  };
  protoOf(ShowCellGroupTrait).ilo = function (cell, event) {
    leave(this, Companion_instance_355.pp0_1);
    protoOf(CellTrait).ilo.call(this, cell, event);
  };
  function CheckNodeMapper(coroutineScope, checkers, node, errors) {
    errors = errors === VOID ? ObservableHashSet_init_$Create$() : errors;
    Mapper.call(this, node, errors);
    this.yp0_1 = coroutineScope;
    this.zp0_1 = checkers;
  }
  protoOf(CheckNodeMapper).rla = function () {
    return false;
  };
  protoOf(CheckNodeMapper).llb = function (conf) {
    protoOf(Mapper).llb.call(this, conf);
    conf.x4v(new CheckNodeSynchronizer(this.yp0_1, this.zp0_1, this.pl9_1, this.ql9_1));
  };
  function prepare($this, checker) {
    var job = launch($this.ap1_1, VOID, VOID, CheckNodeSynchronizer$prepare$slambda_0($this, checker, null));
    if (!job.au()) {
      // Inline function 'kotlin.collections.set' call
      $this.fp1_1.r2(checker, job);
    }
  }
  function run($this, checker, $completion) {
    var tmp = new $runCOROUTINE$0($this, checker, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function CheckResultEntry($outer, invalidator, errors) {
    this.vp1_1 = $outer;
    this.tp1_1 = invalidator;
    this.up1_1 = errors;
  }
  protoOf(CheckResultEntry).wp1 = function () {
    this.tp1_1.vr();
    this.vp1_1.dp1_1.k1(this.up1_1);
  };
  function Companion_356() {
    Companion_instance_356 = this;
    this.xp1_1 = new Long(300, 0);
    this.yp1_1 = getLogger(getKClass(CheckNodeSynchronizer));
  }
  var Companion_instance_356;
  function Companion_getInstance_356() {
    if (Companion_instance_356 == null)
      new Companion_356();
    return Companion_instance_356;
  }
  function CheckNodeSynchronizer$prepare$slambda(this$0, $checker, resultContinuation) {
    this.hp2_1 = this$0;
    this.ip2_1 = $checker;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CheckNodeSynchronizer$prepare$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CheckNodeSynchronizer$prepare$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CheckNodeSynchronizer$prepare$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 5;
            this.y9_1 = 2;
            suspendResult = delay(new Long(300, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.y9_1 = 3;
            suspendResult = run(this.hp2_1, this.ip2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.kp2_1 = suspendResult;
            this.z9_1 = 6;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.z9_1 = 6;
            this.hp2_1.fp1_1.s2(this.ip2_1);
            return Unit_instance;
          case 5:
            this.z9_1 = 6;
            var t = this.ba_1;
            this.hp2_1.fp1_1.s2(this.ip2_1);
            throw t;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(CheckNodeSynchronizer$prepare$slambda).i1l = function ($this$launch, completion) {
    var i = new CheckNodeSynchronizer$prepare$slambda(this.hp2_1, this.ip2_1, completion);
    i.jp2_1 = $this$launch;
    return i;
  };
  function CheckNodeSynchronizer$prepare$slambda_0(this$0, $checker, resultContinuation) {
    var i = new CheckNodeSynchronizer$prepare$slambda(this$0, $checker, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CheckNodeSynchronizer$run$$inlined$eventHandler$1(this$0, $checker) {
    this.lp2_1 = this$0;
    this.mp2_1 = $checker;
  }
  protoOf(CheckNodeSynchronizer$run$$inlined$eventHandler$1).e2b = function (event) {
    prepare(this.lp2_1, this.mp2_1);
    return Unit_instance;
  };
  protoOf(CheckNodeSynchronizer$run$$inlined$eventHandler$1).d28 = function (event) {
    return this.e2b((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function $runCOROUTINE$0(_this__u8e3s4, checker, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.op1_1 = _this__u8e3s4;
    this.pp1_1 = checker;
  }
  protoOf($runCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.qp1_1 = new CheckNodeSynchronizer$run$$inlined$eventHandler$1(this.op1_1, this.pp1_1);
            this.rp1_1 = new Invalidator();
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = supervise_0(this.pp1_1.d73(this.op1_1.cp1_1), this.rp1_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.sp1_1 = suspendResult;
            this.z9_1 = 3;
            this.y9_1 = 4;
            continue $sm;
          case 2:
            this.z9_1 = 3;
            var tmp_1 = this.ba_1;
            if (tmp_1 instanceof AlreadyInvalidException) {
              var exception = this.ba_1;
              var tmp_2 = this;
              prepare(this.op1_1, this.pp1_1);
              return Unit_instance;
            } else {
              throw this.ba_1;
            }

          case 3:
            throw this.ba_1;
          case 4:
            this.z9_1 = 3;
            var checkInv = this.sp1_1;
            checkInv.d4v().o27(this.qp1_1);
            var tmp_3;
            try {
              tmp_3 = checkInv.c4v();
            } catch ($p) {
              var tmp_4;
              if ($p instanceof Error) {
                var exception_0 = $p;
                Companion_getInstance_356().yp1_1.co('Got exception during checker execution. Checker: ' + toString_1(this.pp1_1) + ', node: ' + toString_0(this.op1_1.cp1_1), exception_0);
                return Unit_instance;
              } else {
                throw $p;
              }
            }

            var value = tmp_3;
            var newCheckResult = new CheckResultEntry(this.op1_1, this.rp1_1, value);
            var previous = this.op1_1.ep1_1.y2(this.pp1_1);
            if (!(previous == null)) {
              this.op1_1.dp1_1.k1(previous.up1_1);
            }

            var tmp1 = this.op1_1.ep1_1;
            var key = this.pp1_1;
            tmp1.r2(key, newCheckResult);
            this.op1_1.dp1_1.o(newCheckResult.up1_1);
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function CheckNodeSynchronizer(coroutineScope, checkers, node, errors) {
    Companion_getInstance_356();
    this.ap1_1 = coroutineScope;
    this.bp1_1 = checkers;
    this.cp1_1 = node;
    this.dp1_1 = errors;
    this.ep1_1 = HashMap_init_$Create$();
    this.fp1_1 = HashMap_init_$Create$();
  }
  protoOf(CheckNodeSynchronizer).jla = function (ctx) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.bp1_1.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.check.sync.CheckNodeSynchronizer.attach.<anonymous>' call
      prepare(this, element);
    }
  };
  protoOf(CheckNodeSynchronizer).t6m = function () {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.bp1_1.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.check.sync.CheckNodeSynchronizer.detach.<anonymous>' call
      var tmp0_safe_receiver = this.ep1_1.s2(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.wp1();
      }
      var tmp1_safe_receiver = this.fp1_1.s2(element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        cancel_1(tmp1_safe_receiver, 'on CheckNodeSynchronizer#detach()');
      }
    }
  };
  function ErrorHighlighterBase$registerSynchronizers$o$doAttach$lambda(this$0) {
    return function (event) {
      var tmp;
      switch (event.h27_1.a3_1) {
        case 0:
          show_1(this$0, event.k27());
          tmp = Unit_instance;
          break;
        case 2:
          hide_2(this$0, event.i27());
          tmp = Unit_instance;
          break;
        case 1:
          hide_2(this$0, event.i27());
          show_1(this$0, event.k27());
          tmp = Unit_instance;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      return Unit_instance;
    };
  }
  function show_1($this, error) {
    var nodes = error.b3a();
    var reg;
    if (nodes.n() === 1) {
      var node = nodes.k().m();
      var hi = $this.hoz(node);
      var tmp;
      if (hi == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'jetbrains.ocelot.langDef.check.sync.ErrorHighlighterBase.show.<anonymous>' call
        tmp = $this.koz(hi, error);
      }
      var tmp1_elvis_lhs = tmp;
      reg = tmp1_elvis_lhs == null ? markForeignNode($this, node, error) : tmp1_elvis_lhs;
    } else {
      var ownHis = HashSet_init_$Create$();
      var foreignNodes = HashSet_init_$Create$();
      var _iterator__ex2g4s = error.b3a().k();
      while (_iterator__ex2g4s.l()) {
        var nodeToHighlight = _iterator__ex2g4s.m();
        var hi_0 = $this.hoz(nodeToHighlight);
        if (!(hi_0 == null)) {
          ownHis.e(hi_0);
        } else {
          foreignNodes.e(nodeToHighlight);
        }
      }
      if (foreignNodes.p()) {
        reg = $this.noz(ownHis, error);
      } else {
        var composite = new CompositeDisposable([$this.noz(ownHis, error)]);
        var _iterator__ex2g4s_0 = foreignNodes.k();
        while (_iterator__ex2g4s_0.l()) {
          var foreignNode = _iterator__ex2g4s_0.m();
          composite.ur([markForeignNode($this, foreignNode, error)]);
        }
        reg = composite;
      }
    }
    var tmp2 = $this.woz_1;
    // Inline function 'kotlin.collections.set' call
    var value = reg;
    tmp2.r2(error, value);
  }
  function hide_2($this, error) {
    ensureNotNull($this.woz_1.s2(error)).vr();
  }
  function markForeignNode($this, node, error) {
    var _iterator__ex2g4s = $this.goz().k();
    while (_iterator__ex2g4s.l()) {
      var highlighter = _iterator__ex2g4s.m();
      var reg = markWith($this, highlighter, node, error);
      if (!(reg == null)) {
        return reg;
      }
    }
    throw IllegalStateException_init_$Create$();
  }
  function markWith($this, hir, node, error) {
    var hi = hir.hoz(node);
    return hi == null ? null : hir.koz(hi, error);
  }
  function Companion_357() {
    Companion_instance_357 = this;
    this.eoy_1 = CellTraitPropertySpec_init_$Create$('highlighter', null);
  }
  var Companion_instance_357;
  function Companion_getInstance_357() {
    if (Companion_instance_357 == null)
      new Companion_357();
    return Companion_instance_357;
  }
  function ErrorHighlighterBase$registerSynchronizers$1(this$0) {
    this.np2_1 = this$0;
  }
  protoOf(ErrorHighlighterBase$registerSynchronizers$1).jla = function (ctx) {
    var _iterator__ex2g4s = this.np2_1.voz_1.k();
    while (_iterator__ex2g4s.l()) {
      var e = _iterator__ex2g4s.m();
      show_1(this.np2_1, e);
    }
  };
  protoOf(ErrorHighlighterBase$registerSynchronizers$1).t6m = function () {
    var _iterator__ex2g4s = this.np2_1.woz_1.v2().k();
    while (_iterator__ex2g4s.l()) {
      var reg = _iterator__ex2g4s.m();
      reg.vr();
    }
    this.np2_1.woz_1.m2();
  };
  function ErrorHighlighterBase$registerSynchronizers$$inlined$forEventSource$1($src, this$0) {
    this.pp2_1 = $src;
    this.qp2_1 = this$0;
    DisposableSynchronizer.call(this);
  }
  protoOf(ErrorHighlighterBase$registerSynchronizers$$inlined$forEventSource$1).dlb = function (ctx) {
    return this.pp2_1.p27(ErrorHighlighterBase$registerSynchronizers$o$doAttach$lambda(this.qp2_1));
  };
  function ErrorHighlighterBase(source, target, errors) {
    Companion_getInstance_357();
    Mapper.call(this, source, target);
    this.voz_1 = errors;
    this.woz_1 = HashMap_init_$Create$();
  }
  protoOf(ErrorHighlighterBase).goz = function () {
    return emptyList();
  };
  protoOf(ErrorHighlighterBase).llb = function (conf) {
    conf.x4v(new ErrorHighlighterBase$registerSynchronizers$1(this));
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forEventSource' call
    var src = this.voz_1;
    var tmp$ret$0 = new ErrorHighlighterBase$registerSynchronizers$$inlined$forEventSource$1(src, this);
    conf.x4v(tmp$ret$0);
  };
  function buildRoleCompletion(childContext, coroutineScope, wrapperContext, resolveConfig, completionSupplier) {
    var tmp = buildRoleCompletion$lambda(coroutineScope, wrapperContext, resolveConfig, childContext, completionSupplier);
    return new sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1(tmp);
  }
  function sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1(function_0) {
    this.rp2_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1).gnb = function (mapper, contextNode, target) {
    return this.rp2_1(mapper, contextNode, target);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1).b4 = function () {
    return this.rp2_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RoleCompletion) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_1).hashCode = function () {
    return hashCode(this.b4());
  };
  function buildRoleCompletion$lambda($coroutineScope, $wrapperContext, $resolveConfig, $childContext, $completionSupplier) {
    return function (mapper, contextNode, role) {
      var completionBuilder = new CompletionBuilderImpl($coroutineScope);
      var builder = new NodeCompletionBuilderImpl($wrapperContext, $coroutineScope, $resolveConfig, $childContext, (contextNode == null ? true : isInterface(contextNode, DomainNode)) ? contextNode : THROW_CCE(), role, mapper, completionBuilder);
      $completionSupplier(builder);
      return completionBuilder.wp2();
    };
  }
  function CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda($controller, $cell, resultContinuation) {
    this.fp3_1 = $controller;
    this.gp3_1 = $cell;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          this.fp3_1.iko();
          Completion_getInstance().am3(this.gp3_1).jm2(Companion_getInstance_284().f5j().wmd(false).k2p());
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda).i1l = function ($this$launch, completion) {
    var i = new CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda(this.fp3_1, this.gp3_1, completion);
    i.hp3_1 = $this$launch;
    return i;
  };
  function CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda_0($controller, $cell, resultContinuation) {
    var i = new CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda($controller, $cell, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function createEventHandler_0($this, cell) {
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    return new CellAwareCompletionSupplier$createEventHandler$$inlined$eventHandler$1(cell);
  }
  function CellAwareCompletionSupplier$asSupplier$$inlined$completionSupplier$1($cacheable, this$0) {
    this.ip3_1 = $cacheable;
    this.jp3_1 = this$0;
  }
  protoOf(CellAwareCompletionSupplier$asSupplier$$inlined$completionSupplier$1).um2 = function () {
    return this.ip3_1;
  };
  protoOf(CellAwareCompletionSupplier$asSupplier$$inlined$completionSupplier$1).um1 = function (completionContext) {
    // Inline function 'jetbrains.ocelot.langDef.completion.CellAwareCompletionSupplier.<get-asSupplier>.<anonymous>' call
    return this.jp3_1.kp3(completionContext);
  };
  function CellAwareCompletionSupplier$invoke$$inlined$eventHandler$1($cr, $invalidator, $validReg, $activeReg) {
    this.lp3_1 = $cr;
    this.mp3_1 = $invalidator;
    this.np3_1 = $validReg;
    this.op3_1 = $activeReg;
  }
  protoOf(CellAwareCompletionSupplier$invoke$$inlined$eventHandler$1).e2b = function (event) {
    var deactivated = !event.p2e_1;
    var tmp;
    if (deactivated) {
      if (this.lp3_1.d4v().w4u()) {
        this.mp3_1.vr();
        this.np3_1.vr();
      }
      this.op3_1._v.vr();
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(CellAwareCompletionSupplier$invoke$$inlined$eventHandler$1).d28 = function (event) {
    return this.e2b((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function CellAwareCompletionSupplier$createEventHandler$$inlined$eventHandler$1($cell) {
    this.pp3_1 = $cell;
  }
  protoOf(CellAwareCompletionSupplier$createEventHandler$$inlined$eventHandler$1).e2b = function (event) {
    var controller = Completion_getInstance().am3(this.pp3_1);
    var tmp;
    if (controller.ft()) {
      launch_0(this.pp3_1, VOID, CellAwareCompletionSupplier$createEventHandler$o$onEvent$slambda_0(controller, this.pp3_1, null));
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(CellAwareCompletionSupplier$createEventHandler$$inlined$eventHandler$1).d28 = function (event) {
    return this.e2b((event == null ? true : !(event == null)) ? event : THROW_CCE());
  };
  function CellAwareCompletionSupplier() {
  }
  protoOf(CellAwareCompletionSupplier).rp3 = function () {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.completionSupplier' call
    return new CellAwareCompletionSupplier$asSupplier$$inlined$completionSupplier$1(false, this);
  };
  protoOf(CellAwareCompletionSupplier).kp3 = function (context) {
    var cell = this.qp3();
    if (cell == null) {
      return this.sp3(null, context, Companion_getInstance_74().k4v_1).c4v();
    }
    var controller = Completion_getInstance().am3(cell);
    if (!context.fm9()) {
      return this.sp3(cell, context, Companion_getInstance_74().k4v_1).c4v();
    }
    var invalidator = new Invalidator();
    var cr = this.sp3(cell, context, invalidator);
    var validReg = cr.d4v().o27(createEventHandler_0(this, cell));
    var activeReg = {_v: Companion_getInstance_25().wr_1};
    var tmp = controller.fm2();
    // Inline function 'jetbrains.ocelot.base.observable.event.eventHandler' call
    var tmp$ret$0 = new CellAwareCompletionSupplier$invoke$$inlined$eventHandler$1(cr, invalidator, validReg, activeReg);
    activeReg._v = tmp.o27(tmp$ret$0);
    return cr.c4v();
  };
  function CompletionBuilder() {
    CompletionItemKindProvider.call(this);
  }
  function CompletionBuilderBase$does$1$$inlined$simpleCompletionItem$1($matchingText, $sortPriority, $isCaseSensitive, $action) {
    this.bp4_1 = $action;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(CompletionBuilderBase$does$1$$inlined$simpleCompletionItem$1).wm9 = function (text) {
    // Inline function 'jetbrains.ocelot.langDef.completion.CompletionBuilderBase.does.<anonymous>.<anonymous>' call
    return this.bp4_1();
  };
  function CompletionBuilderBase$does$lambda($this_does, $action) {
    return function (sortPriority) {
      var tmp0 = $this_does;
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
      var sortPriority_0 = sortPriority.dp4();
      return new CompletionBuilderBase$does$1$$inlined$simpleCompletionItem$1(tmp0, sortPriority_0, false, $action);
    };
  }
  function CompletionBuilderBase$does$lambda_0($action) {
    return function (sortPriority) {
      return completionItemForNumber(sortPriority.dp4(), $action);
    };
  }
  function CompletionBuilderBase$does$lambda_1($action) {
    return function (sortPriority) {
      return completionItemForId(sortPriority.dp4(), $action);
    };
  }
  function CompletionBuilderBase() {
    CompletionBuilder.call(this);
  }
  protoOf(CompletionBuilderBase).tp3 = function (_this__u8e3s4, action) {
    this.ep4(CompletionBuilderBase$does$lambda(_this__u8e3s4, action));
  };
  protoOf(CompletionBuilderBase).gp4 = function (_this__u8e3s4, action) {
    this.ep4(CompletionBuilderBase$does$lambda_0(action));
  };
  protoOf(CompletionBuilderBase).hp4 = function (_this__u8e3s4, action) {
    this.ep4(CompletionBuilderBase$does$lambda_1(action));
  };
  function _get_nextSortPriorityRange__jg7xx3($this) {
    var tmp = Companion_getInstance_358();
    var _unary__edvuaz = $this.vp2_1;
    $this.vp2_1 = _unary__edvuaz - 1 | 0;
    return tmp.kp4(_unary__edvuaz);
  }
  function CompletionBuilderImpl$async$slambda($completion, $priorityRange, resultContinuation) {
    this.tp4_1 = $completion;
    this.up4_1 = $priorityRange;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CompletionBuilderImpl$async$slambda).wp4 = function ($this$channelFlow, $completion) {
    var tmp = this.xp4($this$channelFlow, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CompletionBuilderImpl$async$slambda).oa = function (p1, $completion) {
    return this.wp4((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CompletionBuilderImpl$async$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.tp4_1(new CoroutineCompletionBuilder(this.vp4_1, this.vp4_1.y15(), this.up4_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(CompletionBuilderImpl$async$slambda).xp4 = function ($this$channelFlow, completion) {
    var i = new CompletionBuilderImpl$async$slambda(this.tp4_1, this.up4_1, completion);
    i.vp4_1 = $this$channelFlow;
    return i;
  };
  function CompletionBuilderImpl$async$slambda_0($completion, $priorityRange, resultContinuation) {
    var i = new CompletionBuilderImpl$async$slambda($completion, $priorityRange, resultContinuation);
    var l = function ($this$channelFlow, $completion) {
      return i.wp4($this$channelFlow, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CompletionBuilderImpl$async$1$$inlined$completionSupplier$1($cacheable, $completionResult) {
    this.yp4_1 = $cacheable;
    this.zp4_1 = $completionResult;
  }
  protoOf(CompletionBuilderImpl$async$1$$inlined$completionSupplier$1).um2 = function () {
    return this.yp4_1;
  };
  protoOf(CompletionBuilderImpl$async$1$$inlined$completionSupplier$1).um1 = function (completionContext) {
    // Inline function 'jetbrains.ocelot.langDef.completion.CompletionBuilderImpl.async.<anonymous>.<anonymous>' call
    return this.zp4_1;
  };
  function CompletionBuilderImpl$async$lambda($completionResult) {
    return function (it) {
      // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.completionSupplier' call
      return new CompletionBuilderImpl$async$1$$inlined$completionSupplier$1(false, $completionResult);
    };
  }
  function CompletionBuilderImpl(coroutineScope) {
    CompletionBuilderBase.call(this);
    this.sp2_1 = coroutineScope;
    this.tp2_1 = ArrayList_init_$Create$();
    this.up2_1 = ArrayList_init_$Create$();
    this.vp2_1 = 32767;
  }
  protoOf(CompletionBuilderImpl).ep4 = function (completionItem) {
    this.tp2_1.e(completionItem(_get_nextSortPriorityRange__jg7xx3(this)));
  };
  protoOf(CompletionBuilderImpl).fp4 = function (completionSupplier) {
    this.up2_1.e(completionSupplier(_get_nextSortPriorityRange__jg7xx3(this)));
  };
  protoOf(CompletionBuilderImpl).up3 = function (completion) {
    var priorityRange = _get_nextSortPriorityRange__jg7xx3(this);
    var completionResult = new FlowBasedCompletionResult(this.sp2_1, channelFlow(CompletionBuilderImpl$async$slambda_0(completion, priorityRange, null)));
    this.fp4(CompletionBuilderImpl$async$lambda(completionResult));
  };
  protoOf(CompletionBuilderImpl).wp2 = function () {
    var tmp0 = this.up2_1;
    // Inline function 'kotlin.collections.fold' call
    var accumulator = toCompletionSupplier_0(this.tp2_1);
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.completion.CompletionBuilderImpl.getCompletionSupplier.stub_for_inlining' call
      var p0 = accumulator;
      accumulator = plus_13(p0, element);
    }
    return accumulator;
  };
  function CoroutineCompletionBuilder$item$slambda(this$0, $completionItem, resultContinuation) {
    this.ip5_1 = this$0;
    this.jp5_1 = $completionItem;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CoroutineCompletionBuilder$item$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CoroutineCompletionBuilder$item$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CoroutineCompletionBuilder$item$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ip5_1.mp5_1.z1b(this.jp5_1(this.ip5_1.np5_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(CoroutineCompletionBuilder$item$slambda).i1l = function ($this$launch, completion) {
    var i = new CoroutineCompletionBuilder$item$slambda(this.ip5_1, this.jp5_1, completion);
    i.kp5_1 = $this$launch;
    return i;
  };
  function CoroutineCompletionBuilder$item$slambda_0(this$0, $completionItem, resultContinuation) {
    var i = new CoroutineCompletionBuilder$item$slambda(this$0, $completionItem, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CoroutineCompletionBuilder$async$slambda($completion, this$0, resultContinuation) {
    this.wp5_1 = $completion;
    this.xp5_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CoroutineCompletionBuilder$async$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CoroutineCompletionBuilder$async$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CoroutineCompletionBuilder$async$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.wp5_1(this.xp5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(CoroutineCompletionBuilder$async$slambda).i1l = function ($this$launch, completion) {
    var i = new CoroutineCompletionBuilder$async$slambda(this.wp5_1, this.xp5_1, completion);
    i.yp5_1 = $this$launch;
    return i;
  };
  function CoroutineCompletionBuilder$async$slambda_0($completion, this$0, resultContinuation) {
    var i = new CoroutineCompletionBuilder$async$slambda($completion, this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function CoroutineCompletionBuilder(coroutineScope, channel, sortPriority) {
    CompletionBuilderBase.call(this);
    this.lp5_1 = coroutineScope;
    this.mp5_1 = channel;
    this.np5_1 = sortPriority;
  }
  protoOf(CoroutineCompletionBuilder).ep4 = function (completionItem) {
    launch(this.lp5_1, VOID, VOID, CoroutineCompletionBuilder$item$slambda_0(this, completionItem, null));
  };
  protoOf(CoroutineCompletionBuilder).fp4 = function (completionSupplier) {
    throw UnsupportedOperationException_init_$Create$_0('Operation not support yet');
  };
  protoOf(CoroutineCompletionBuilder).up3 = function (completion) {
    launch(this.lp5_1, VOID, VOID, CoroutineCompletionBuilder$async$slambda_0(completion, this, null));
  };
  function ReferenceKind(tag, options) {
    CompletionItemKind.call(this);
    this.zp5_1 = tag;
    this.ap6_1 = options;
  }
  function CustomCompletionKind() {
    CompletionItemKind.call(this);
  }
  function NumberKind() {
    NumberKind_instance = this;
    CompletionItemKind.call(this);
  }
  var NumberKind_instance;
  function NumberKind_getInstance() {
    if (NumberKind_instance == null)
      new NumberKind();
    return NumberKind_instance;
  }
  function OtherCompletionKind(supplier) {
    CompletionItemKind.call(this);
    this.cp6_1 = supplier;
  }
  function StringKind() {
    StringKind_instance = this;
    CompletionItemKind.call(this);
  }
  var StringKind_instance;
  function StringKind_getInstance() {
    if (StringKind_instance == null)
      new StringKind();
    return StringKind_instance;
  }
  function CompletionItemKind() {
  }
  function CompletionItemKindProvider() {
  }
  protoOf(CompletionItemKindProvider).dp6 = function () {
    return StringKind_getInstance();
  };
  protoOf(CompletionItemKindProvider).ep6 = function () {
    return NumberKind_getInstance();
  };
  protoOf(CompletionItemKindProvider).vp3 = function (tag, options) {
    return new ReferenceKind(tag, options);
  };
  protoOf(CompletionItemKindProvider).wp3 = function (tag, options, $super) {
    options = options === VOID ? new CompletionOptions() : options;
    return $super === VOID ? this.vp3(tag, options) : $super.vp3.call(this, tag, options);
  };
  function CompletionOptions(caseSensitive, useTokens, exactMatchFirst) {
    caseSensitive = caseSensitive === VOID ? false : caseSensitive;
    useTokens = useTokens === VOID ? true : useTokens;
    exactMatchFirst = exactMatchFirst === VOID ? true : exactMatchFirst;
    this.fp6_1 = caseSensitive;
    this.gp6_1 = useTokens;
    this.hp6_1 = exactMatchFirst;
  }
  function toFilterSettings(_this__u8e3s4) {
    return Companion_getInstance_101().m6v(!_this__u8e3s4.fp6_1, _this__u8e3s4.gp6_1);
  }
  function completionResult(_this__u8e3s4, action, filter, referenceTargets, sortPriorityRange) {
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    var items = new completionResult$$inlined$map$1(referenceTargets, filter, sortPriorityRange, action);
    return new FlowBasedCompletionResult(_this__u8e3s4, items);
  }
  function completionResult$o$collect$slambda$lambda($action, $item) {
    return function (it) {
      return $action($item.ip6_1);
    };
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_14(function_0) {
    this.kp6_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_14).d1f = function (value, $completion) {
    return this.kp6_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_14).b4 = function () {
    return this.kp6_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_14).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_14).hashCode = function () {
    return hashCode(this.b4());
  };
  function completionResult$o$collect$slambda($$this$unsafeFlow, $filter, $sortPriorityRange, $action, resultContinuation) {
    this.tp6_1 = $$this$unsafeFlow;
    this.up6_1 = $filter;
    this.vp6_1 = $sortPriorityRange;
    this.wp6_1 = $action;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(completionResult$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(completionResult$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(completionResult$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.yp6_1 = this.tp6_1;
            var tmp_1 = this;
            tmp_1.zp6_1 = this.xp6_1;
            this.ap7_1 = this.yp6_1;
            this.bp7_1 = this.zp6_1;
            this.y9_1 = 1;
            var item = this.bp7_1;
            var matcher = new TextMatcherByFilterSettings(this.up6_1, get_tokenized(item.ip6_1.d6u_1));
            var tmp_2 = this.vp6_1.cp7(item.jp6_1);
            suspendResult = this.ap7_1.d1f(completionItemByTextMatcher(matcher, item.ip6_1.d6u_1, tmp_2, item.ip6_1.e6u_1, completionResult$o$collect$slambda$lambda(this.wp6_1, item)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(completionResult$o$collect$slambda).a1u = function (value, completion) {
    var i = new completionResult$o$collect$slambda(this.tp6_1, this.up6_1, this.vp6_1, this.wp6_1, completion);
    i.xp6_1 = value;
    return i;
  };
  function completionResult$o$collect$slambda_0($$this$unsafeFlow, $filter, $sortPriorityRange, $action, resultContinuation) {
    var i = new completionResult$o$collect$slambda($$this$unsafeFlow, $filter, $sortPriorityRange, $action, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$1(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lp7_1 = _this__u8e3s4;
    this.mp7_1 = collector;
  }
  protoOf($collectCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.np7_1 = this.mp7_1;
            this.op7_1 = this.np7_1;
            this.y9_1 = 1;
            var tmp_1 = completionResult$o$collect$slambda_0(this.op7_1, this.lp7_1.qp7_1, this.lp7_1.rp7_1, this.lp7_1.sp7_1, null);
            suspendResult = this.lp7_1.pp7_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_14(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function completionResult$$inlined$map$1($this, $filter, $sortPriorityRange, $action) {
    this.pp7_1 = $this;
    this.qp7_1 = $filter;
    this.rp7_1 = $sortPriorityRange;
    this.sp7_1 = $action;
  }
  protoOf(completionResult$$inlined$map$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$1(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(completionResult$$inlined$map$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function NodeCompletionBuilder() {
    CompletionItemKindProvider.call(this);
  }
  protoOf(NodeCompletionBuilder).ap8 = function (_this__u8e3s4, factory) {
    _this__u8e3s4.bp6(this, factory);
  };
  protoOf(NodeCompletionBuilder).bp8 = function (other) {
    return new OtherCompletionKind(other);
  };
  function NodeProducerBuilder() {
  }
  protoOf(NodeProducerBuilder).gp8 = function (action) {
    return action;
  };
  function ActionOnCell() {
  }
  function sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0(function_0) {
    this.ip8_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0).hp8 = function (cell) {
    return this.ip8_1(cell);
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0).b4 = function () {
    return this.ip8_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ActionOnCell) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function NodeCompletionBuilderBase$Builder$produce$lambda($defaultAction) {
    return function (it) {
      return $defaultAction;
    };
  }
  function cellAction($this, factory) {
    var builder = new Builder_3($this);
    var action = factory(builder);
    var tmp0_safe_receiver = builder.jp8_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.completion.NodeCompletionBuilderBase.cellAction.<anonymous>' call
      var tmp0_safe_receiver_0 = $this.lp8(tmp0_safe_receiver);
      var tmp_0;
      if (tmp0_safe_receiver_0 == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'jetbrains.ocelot.langDef.completion.NodeCompletionBuilderBase.cellAction.<anonymous>.<anonymous>' call
        tmp_0 = action.hp8(tmp0_safe_receiver_0);
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs;
  }
  function Builder_3($outer) {
    this.kp8_1 = $outer;
    NodeProducerBuilder.call(this);
    this.jp8_1 = null;
  }
  protoOf(Builder_3).fp8 = function (node) {
    var defaultAction = this.kp8_1.mp8(node);
    this.jp8_1 = node;
    var tmp = NodeCompletionBuilderBase$Builder$produce$lambda(defaultAction);
    return this.gp8(new sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0(tmp));
  };
  function NodeCompletionBuilderBase$does$lambda(this$0, $factory) {
    return function () {
      return cellAction(this$0, $factory);
    };
  }
  function NodeCompletionBuilderBase$produces$lambda($factory) {
    return function ($this$does) {
      return $this$does.fp8($factory());
    };
  }
  function NodeCompletionBuilderBase$does$lambda$lambda($factory, $string) {
    return function ($this$cellAction) {
      return $factory($this$cellAction, $string);
    };
  }
  function NodeCompletionBuilderBase$does$lambda_0(this$0, $factory) {
    return function (string) {
      return cellAction(this$0, NodeCompletionBuilderBase$does$lambda$lambda($factory, string));
    };
  }
  function NodeCompletionBuilderBase$produces$lambda_0($factory) {
    return function ($this$does, string) {
      return $this$does.fp8($factory(string));
    };
  }
  function NodeCompletionBuilderBase$does$lambda$lambda_0($factory, $number) {
    return function ($this$cellAction) {
      return $factory($this$cellAction, $number);
    };
  }
  function NodeCompletionBuilderBase$does$lambda_1(this$0, $factory) {
    return function (number) {
      return cellAction(this$0, NodeCompletionBuilderBase$does$lambda$lambda_0($factory, number));
    };
  }
  function NodeCompletionBuilderBase$produces$lambda_1($factory) {
    return function ($this$does, number) {
      return $this$does.fp8($factory(number));
    };
  }
  function NodeCompletionBuilderBase$produces$4$referenceCompletion$1(this$0, $supplier, $this_produces, $sortPriorityContext, $factory) {
    this.rp8_1 = this$0;
    this.sp8_1 = $supplier;
    this.tp8_1 = $factory;
    ReferenceCompletionBase.call(this, this$0.up8(), $supplier, $this_produces.ap6_1, $sortPriorityContext);
  }
  protoOf(NodeCompletionBuilderBase$produces$4$referenceCompletion$1).vp8 = function (item) {
    return this.rp8_1.mp8(this.tp8_1(item.c6u_1));
  };
  protoOf(NodeCompletionBuilderBase$produces$4$referenceCompletion$1).j75 = function (filter) {
    var tmp;
    if (!(this.rp8_1.wp8() == null)) {
      tmp = toEnclosingNodeContext(ensureNotNull(this.rp8_1.wp8()));
    } else if (!(this.rp8_1.tp7() == null)) {
      tmp = new EnclosingNodeContext(ensureNotNull(this.rp8_1.tp7()), null);
    } else {
      throw IllegalArgumentException_init_$Create$_0("Either childContext or editor's context node must not be null");
    }
    var elementsContext = tmp;
    return this.sp8_1.g6u(elementsContext, filter);
  };
  protoOf(NodeCompletionBuilderBase$produces$4$referenceCompletion$1).qp3 = function () {
    var tmp = this.rp8_1.kla().ql9_1;
    var tmp0_safe_receiver = ((!(tmp == null) ? isInterface(tmp, Cell) : false) ? tmp : THROW_CCE()).llk();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.rlp();
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.m2c();
  };
  function NodeCompletionBuilderBase$produces$lambda_2(this$0, $supplier, $this_produces, $factory) {
    return function (sortPriorityContext) {
      var referenceCompletion = new NodeCompletionBuilderBase$produces$4$referenceCompletion$1(this$0, $supplier, $this_produces, sortPriorityContext, $factory);
      return referenceCompletion.rp3();
    };
  }
  function NodeCompletionBuilderBase() {
    NodeCompletionBuilder.call(this);
  }
  protoOf(NodeCompletionBuilderBase).ep9 = function (_this__u8e3s4, factory) {
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.langDef.completion.NodeCompletionBuilderBase.does.<anonymous>' call
    this.dp9().tp3(_this__u8e3s4, NodeCompletionBuilderBase$does$lambda(this, factory));
    return Unit_instance;
  };
  protoOf(NodeCompletionBuilderBase).up7 = function (_this__u8e3s4, factory) {
    return this.ep9(_this__u8e3s4, NodeCompletionBuilderBase$produces$lambda(factory));
  };
  protoOf(NodeCompletionBuilderBase).vp7 = function (_this__u8e3s4, factory) {
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.langDef.completion.NodeCompletionBuilderBase.does.<anonymous>' call
    this.dp9().hp4(_this__u8e3s4, NodeCompletionBuilderBase$does$lambda_0(this, factory));
    return Unit_instance;
  };
  protoOf(NodeCompletionBuilderBase).wp7 = function (_this__u8e3s4, factory) {
    return this.vp7(_this__u8e3s4, NodeCompletionBuilderBase$produces$lambda_0(factory));
  };
  protoOf(NodeCompletionBuilderBase).xp7 = function (_this__u8e3s4, factory) {
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.langDef.completion.NodeCompletionBuilderBase.does.<anonymous>' call
    this.dp9().gp4(_this__u8e3s4, NodeCompletionBuilderBase$does$lambda_1(this, factory));
    return Unit_instance;
  };
  protoOf(NodeCompletionBuilderBase).yp7 = function (_this__u8e3s4, factory) {
    return this.xp7(_this__u8e3s4, NodeCompletionBuilderBase$produces$lambda_1(factory));
  };
  protoOf(NodeCompletionBuilderBase).fp9 = function (_this__u8e3s4, factory) {
    var supplier = this.cp9().j6y(_this__u8e3s4.zp5_1);
    var tmp = this.dp9();
    tmp.fp4(NodeCompletionBuilderBase$produces$lambda_2(this, supplier, _this__u8e3s4, factory));
  };
  protoOf(NodeCompletionBuilderBase).zp7 = function (_this__u8e3s4, factory) {
    return this.fp9(_this__u8e3s4, factory);
  };
  function NodeCompletionBuilderImpl$produces$transformRole$1(this$0, $factory) {
    this.gp9_1 = this$0;
    this.hp9_1 = $factory;
  }
  protoOf(NodeCompletionBuilderImpl$produces$transformRole$1).ip9 = function (target) {
    return this.gp9_1.mp8(this.hp9_1(target));
  };
  protoOf(NodeCompletionBuilderImpl$produces$transformRole$1).qn8 = function (target) {
    return this.ip9(isInterface(target, DomainNode) ? target : THROW_CCE());
  };
  function NodeCompletionBuilderImpl$async$slambda(this$0, $completion, resultContinuation) {
    this.apa_1 = this$0;
    this.bpa_1 = $completion;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeCompletionBuilderImpl$async$slambda).fpa = function ($this$async, $completion) {
    var tmp = this.gpa($this$async, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(NodeCompletionBuilderImpl$async$slambda).oa = function (p1, $completion) {
    return this.fpa(p1 instanceof CompletionBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeCompletionBuilderImpl$async$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.dpa_1 = this.cpa_1;
            var tmp_0 = this;
            var tmp_1 = this.apa_1.o71();
            var tmp_2 = this.apa_1.up8();
            var tmp_3 = this.apa_1.cp9();
            var tmp_4 = this.apa_1.wp8();
            var tmp_5 = this.apa_1.tp7();
            var tmp_6 = this.dpa_1;
            tmp_0.epa_1 = new NodeCompletionBuilderImpl(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, this.apa_1.op9_1, this.apa_1.pp9_1, tmp_6 instanceof CompletionBuilderBase ? tmp_6 : THROW_CCE());
            this.y9_1 = 1;
            suspendResult = this.bpa_1(this.epa_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeCompletionBuilderImpl$async$slambda).gpa = function ($this$async, completion) {
    var i = new NodeCompletionBuilderImpl$async$slambda(this.apa_1, this.bpa_1, completion);
    i.cpa_1 = $this$async;
    return i;
  };
  function NodeCompletionBuilderImpl$async$slambda_0(this$0, $completion, resultContinuation) {
    var i = new NodeCompletionBuilderImpl$async$slambda(this$0, $completion, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.fpa($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeCompletionBuilderImpl(wrapperContext, coroutineScope, resolveConfig, childContext, contextNode, role, mapper, completionBuilder) {
    NodeCompletionBuilderBase.call(this);
    this.jp9_1 = wrapperContext;
    this.kp9_1 = coroutineScope;
    this.lp9_1 = resolveConfig;
    this.mp9_1 = childContext;
    this.np9_1 = contextNode;
    this.op9_1 = role;
    this.pp9_1 = mapper;
    this.qp9_1 = completionBuilder;
    this.rp9_1 = this.pp9_1.ul9_1;
  }
  protoOf(NodeCompletionBuilderImpl).o71 = function () {
    return this.jp9_1;
  };
  protoOf(NodeCompletionBuilderImpl).up8 = function () {
    return this.kp9_1;
  };
  protoOf(NodeCompletionBuilderImpl).cp9 = function () {
    return this.lp9_1;
  };
  protoOf(NodeCompletionBuilderImpl).wp8 = function () {
    return this.mp9_1;
  };
  protoOf(NodeCompletionBuilderImpl).tp7 = function () {
    return this.np9_1;
  };
  protoOf(NodeCompletionBuilderImpl).kla = function () {
    return this.pp9_1;
  };
  protoOf(NodeCompletionBuilderImpl).dp9 = function () {
    return this.qp9_1;
  };
  protoOf(NodeCompletionBuilderImpl).mp8 = function (value) {
    return this.op9_1.qn8(value);
  };
  protoOf(NodeCompletionBuilderImpl).lp8 = function (value) {
    var ctx = this.pp9_1.mlb();
    var tmp;
    if (this.pp9_1.qlc()) {
      tmp = this.pp9_1;
    } else {
      var tmp0_elvis_lhs = this.rp9_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    }
    var fromMapper = tmp;
    // Inline function 'kotlin.collections.map' call
    var this_0 = ctx.pld(fromMapper, value);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.completion.NodeCompletionBuilderImpl.findCellFor.<anonymous>' call
      var tmp$ret$0 = item.ql9_1;
      destination.e(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var element = _iterator__ex2g4s_0.m();
      if (!(element == null) ? isInterface(element, Cell) : false) {
        destination_0.e(element);
      }
    }
    return firstOrNull_0(destination_0);
  };
  protoOf(NodeCompletionBuilderImpl).cp8 = function (_this__u8e3s4, factory) {
    var transformRole = new NodeCompletionBuilderImpl$produces$transformRole$1(this, factory);
    var builder = new NodeCompletionBuilderImpl(this.o71(), this.up8(), this.cp9(), this.wp8(), this.tp7(), transformRole, this.pp9_1, this.dp9());
    _this__u8e3s4.cp6_1(builder);
  };
  protoOf(NodeCompletionBuilderImpl).dp8 = function (node, link, supplier) {
    var newContext = singleChildContext(node, link);
    var builder = new NodeCompletionBuilderImpl(this.o71(), this.up8(), this.cp9(), newContext, this.tp7(), this.op9_1, this.pp9_1, this.dp9());
    supplier(builder);
  };
  protoOf(NodeCompletionBuilderImpl).ep8 = function (completion) {
    var tmp = this.dp9();
    tmp.up3(NodeCompletionBuilderImpl$async$slambda_0(this, completion, null));
  };
  function hackyGetCompletionEditor($this, cell) {
    if (!(get_frontPopup(cell) == null)) {
      var childOfPopup = ensureNotNull(get_frontPopup(cell)).q2r();
      var tmp;
      if (!(childOfPopup instanceof TextCell)) {
        tmp = null;
      } else {
        tmp = childOfPopup;
      }
      return tmp;
    }
    return cell.clo(Companion_getInstance_279().pm1_1)().om1();
  }
  function PrefixBasedCompletionSupplier() {
    CellAwareCompletionSupplier.call(this);
  }
  protoOf(PrefixBasedCompletionSupplier).sp3 = function (cell, context, invalidationContext) {
    if (cell == null) {
      return invalidationContext.p4w(this.bp9('', context));
    }
    var tmp;
    if (cell.ulp(TextEditing_getInstance().zlw_1)) {
      tmp = cell;
    } else {
      tmp = cell.q2r();
    }
    var currentCell = tmp;
    if (currentCell == null) {
      return invalidationContext.p4w(this.bp9('', context));
    }
    var tmp0_elvis_lhs = hackyGetCompletionEditor(this, currentCell);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return invalidationContext.p4w(this.bp9('', context));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var editor = tmp_0;
    invalidationContext.n4v(editor.laz(), Invalidation_getInstance().v4u_1);
    var prefixText = editor.ylt();
    var completionResult = this.bp9(prefixText, context);
    return invalidationContext.p4w(completionResult);
  };
  function completion(_this__u8e3s4, provider, source, result, cell, completionOptions, completionAction) {
    completionOptions = completionOptions === VOID ? new CompletionOptions() : completionOptions;
    completionAction = completionAction === VOID ? null : completionAction;
    return (new ReferenceCompletion(_this__u8e3s4, cell, result, provider, source, completionOptions, completionAction)).rp3();
  }
  function ReferenceCompletion(coroutineScope, completionCell, reference, provider, refSource, completionOptions, completionAction) {
    completionAction = completionAction === VOID ? null : completionAction;
    ReferenceCompletionBase.call(this, coroutineScope, provider, completionOptions, Companion_getInstance_358().ip4_1);
    this.lpa_1 = completionCell;
    this.mpa_1 = reference;
    this.npa_1 = refSource;
    this.opa_1 = completionAction;
  }
  protoOf(ReferenceCompletion).qp3 = function () {
    return this.lpa_1;
  };
  protoOf(ReferenceCompletion).j75 = function (filter) {
    var tmp;
    try {
      tmp = this.yp8_1.g6u(new SourceNodeContext(this.npa_1), filter);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var t = $p;
        ThrowableHandlers_getInstance().ps_1.os(t);
        tmp_0 = emptyFlow();
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(ReferenceCompletion).vp8 = function (item) {
    this.mpa_1.t2c(item.c6u_1);
    var tmp0_safe_receiver = this.opa_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(item);
    return tmp1_elvis_lhs == null ? toFirstPlaceholderWhenSettled(this.lpa_1) : tmp1_elvis_lhs;
  };
  function ReferenceCompletionBase$getSortedElements$o$collect$slambda($$this$unsafeFlow, $priorityFunction, resultContinuation) {
    this.xpa_1 = $$this$unsafeFlow;
    this.ypa_1 = $priorityFunction;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ReferenceCompletionBase$getSortedElements$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ReferenceCompletionBase$getSortedElements$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ReferenceCompletionBase$getSortedElements$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.apb_1 = this.xpa_1;
            var tmp_1 = this;
            tmp_1.bpb_1 = this.zpa_1;
            this.cpb_1 = this.apb_1;
            this.dpb_1 = this.bpb_1;
            this.y9_1 = 1;
            var it = this.dpb_1;
            var sortPriority = this.ypa_1(it.d6u_1);
            suspendResult = this.cpb_1.d1f(new SortedReferenceTargetItem(it, sortPriority), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ReferenceCompletionBase$getSortedElements$o$collect$slambda).a1u = function (value, completion) {
    var i = new ReferenceCompletionBase$getSortedElements$o$collect$slambda(this.xpa_1, this.ypa_1, completion);
    i.zpa_1 = value;
    return i;
  };
  function ReferenceCompletionBase$getSortedElements$o$collect$slambda_0($$this$unsafeFlow, $priorityFunction, resultContinuation) {
    var i = new ReferenceCompletionBase$getSortedElements$o$collect$slambda($$this$unsafeFlow, $priorityFunction, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$2(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mpb_1 = _this__u8e3s4;
    this.npb_1 = collector;
  }
  protoOf($collectCOROUTINE$2).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.opb_1 = this.npb_1;
            this.ppb_1 = this.opb_1;
            this.y9_1 = 1;
            var tmp_1 = ReferenceCompletionBase$getSortedElements$o$collect$slambda_0(this.ppb_1, this.mpb_1.rpb_1, null);
            suspendResult = this.mpb_1.qpb_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_15(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function getSortedElements($this, filter) {
    var tmp;
    if (!$this.zp8_1.hp6_1) {
      tmp = ReferenceCompletionBase$getSortedElements$lambda;
    } else if (filter.z6u_1) {
      tmp = exactPrefixFirst(filter, $this);
    } else {
      tmp = ReferenceCompletionBase$getSortedElements$lambda_0;
    }
    var priorityFunction = tmp;
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = $this.j75(filter);
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new ReferenceCompletionBase$getSortedElements$$inlined$map$1(this_0, priorityFunction);
  }
  function exactPrefixFirst(_this__u8e3s4, $this) {
    var prefixFilter = _this__u8e3s4.g6v(VOID, VOID, false);
    return ReferenceCompletionBase$exactPrefixFirst$lambda(prefixFilter);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_15(function_0) {
    this.spb_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_15).d1f = function (value, $completion) {
    return this.spb_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_15).b4 = function () {
    return this.spb_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_15).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_15).hashCode = function () {
    return hashCode(this.b4());
  };
  function ReferenceCompletionBase$getSortedElements$lambda(_unused_var__etf5q3) {
    return 0;
  }
  function ReferenceCompletionBase$getSortedElements$lambda_0(_unused_var__etf5q3) {
    return 0;
  }
  function ReferenceCompletionBase$getSortedElements$$inlined$map$1($this, $priorityFunction) {
    this.qpb_1 = $this;
    this.rpb_1 = $priorityFunction;
  }
  protoOf(ReferenceCompletionBase$getSortedElements$$inlined$map$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$2(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ReferenceCompletionBase$getSortedElements$$inlined$map$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function ReferenceCompletionBase$exactPrefixFirst$lambda($prefixFilter) {
    return function (string) {
      return $prefixFilter.e6v(string) ? 1 : 0;
    };
  }
  function ReferenceCompletionBase$consumeItem$ref($boundThis) {
    var l = function (p0) {
      return $boundThis.vp8(p0);
    };
    l.callableName = 'consumeItem';
    return l;
  }
  function ReferenceCompletionBase(coroutineScope, provider, completionOptions, sortPriorityRange) {
    PrefixBasedCompletionSupplier.call(this);
    this.xp8_1 = coroutineScope;
    this.yp8_1 = provider;
    this.zp8_1 = completionOptions;
    this.ap9_1 = sortPriorityRange;
  }
  protoOf(ReferenceCompletionBase).bp9 = function (pattern, context) {
    var filter = TextFilter_init_$Create$_1(pattern, toFilterSettings(this.zp8_1));
    var elementsFlow = getSortedElements(this, filter);
    return completionResult(this.xp8_1, ReferenceCompletionBase$consumeItem$ref(this), filter, elementsFlow, this.ap9_1);
  };
  function Companion_358() {
    Companion_instance_358 = this;
    this.ip4_1 = new SortPriorityRange(0);
    this.jp4_1 = 65535;
  }
  protoOf(Companion_358).kp4 = function (slot) {
    var shortSlot = slot > 32767 ? 32767 : slot < -32768 ? -32768 : toShort(slot);
    return new SortPriorityRange(shortSlot);
  };
  var Companion_instance_358;
  function Companion_getInstance_358() {
    if (Companion_instance_358 == null)
      new Companion_358();
    return Companion_instance_358;
  }
  function SortPriorityRange(slot) {
    Companion_getInstance_358();
    this.cp4_1 = slot * 65535 | 0;
  }
  protoOf(SortPriorityRange).cp7 = function (local) {
    return this.cp4_1 + local | 0;
  };
  protoOf(SortPriorityRange).dp4 = function (local, $super) {
    local = local === VOID ? 0 : local;
    return $super === VOID ? this.cp7(local) : $super.cp7.call(this, local);
  };
  function SortedReferenceTargetItem(targetItem, sortPriority) {
    this.ip6_1 = targetItem;
    this.jp6_1 = sortPriority;
  }
  function updateText_0($this, text) {
    if (!($this.vpb_1 == null) && $this.wpb().b6v_1 === text) {
      return Unit_instance;
    }
    $this.vpb_1 = get_tokenized(text);
  }
  function TextMatcherByFilterSettings(filterSettings, itemText) {
    this.tpb_1 = filterSettings;
    this.upb_1 = itemText;
  }
  protoOf(TextMatcherByFilterSettings).wpb = function () {
    var tmp = this.vpb_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('tokenizedText');
    }
  };
  protoOf(TextMatcherByFilterSettings).cme = function (text) {
    updateText_0(this, text);
    return TextFilter_init_$Create$(this.wpb(), this.tpb_1).a6v(this.upb_1);
  };
  protoOf(TextMatcherByFilterSettings).pm7 = function (text) {
    return equals_0(this.upb_1.b6v_1, text, this.tpb_1.s6u());
  };
  protoOf(TextMatcherByFilterSettings).toString = function () {
    return "{pattern='" + this.upb_1.b6v_1 + "', ignoreCase=" + this.tpb_1.s6u() + ', tokenization=' + this.tpb_1.t6u() + '}';
  };
  function completes(_this__u8e3s4, action) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
    return new completes$$inlined$simpleCompletionItem$1(_this__u8e3s4, 0, true, action);
  }
  function simpleCompletion(_this__u8e3s4) {
    return new simpleCompletion$1(_this__u8e3s4);
  }
  function produces(_this__u8e3s4, action) {
    return new Pair(_this__u8e3s4, action);
  }
  function intRoleCompletion() {
    return new intRoleCompletion$1();
  }
  function completionForNumber(consumer) {
    return CompletionSupplement_instance.smc([completionItemForNumber(0, consumer)]);
  }
  function completionItemForNumber(sortPriority, consumer) {
    return new completionItemForNumber$1(sortPriority, consumer);
  }
  function completionItemForId(sortPriority, consumer) {
    return completionItemForValidator(get_IdentifierValidator(), sortPriority, consumer);
  }
  function completionItemForValidator(validator, sortPriority, consumer) {
    return new completionItemForValidator$1(sortPriority, validator, consumer);
  }
  function completes$$inlined$simpleCompletionItem$1($matchingText, $sortPriority, $isCaseSensitive, $action) {
    this.bpc_1 = $action;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(completes$$inlined$simpleCompletionItem$1).wm9 = function (text) {
    // Inline function 'jetbrains.ocelot.langDef.completion.helpers.completes.<anonymous>' call
    return this.bpc_1();
  };
  function createRoleCompletion$completionItem($target, ci) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
    var matchingText = ci.dh_1;
    return new simpleCompletion$1$createRoleCompletion$completionItem$$inlined$simpleCompletionItem$1(matchingText, 0, true, $target, ci);
  }
  function simpleCompletion$1$createRoleCompletion$completionItem$$inlined$simpleCompletionItem$1($matchingText, $sortPriority, $isCaseSensitive, $target, $ci) {
    this.gpc_1 = $target;
    this.hpc_1 = $ci;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(simpleCompletion$1$createRoleCompletion$completionItem$$inlined$simpleCompletionItem$1).wm9 = function (text) {
    // Inline function 'jetbrains.ocelot.langDef.completion.helpers.<no name provided>.createRoleCompletion.completionItem.<anonymous>' call
    return this.gpc_1.qn8(this.hpc_1.eh_1(text));
  };
  function simpleCompletion$1($this_simpleCompletion) {
    this.ipc_1 = $this_simpleCompletion;
  }
  protoOf(simpleCompletion$1).jpc = function (mapper, contextNode, target) {
    var tmp = CompletionSupplement_instance;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.ipc_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.completion.helpers.<no name provided>.createRoleCompletion.<anonymous>' call
      var tmp$ret$0 = createRoleCompletion$completionItem(target, item);
      destination.e(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$3 = copyToArray(destination);
    return tmp.smc(tmp$ret$3.slice());
  };
  protoOf(simpleCompletion$1).gnb = function (mapper, contextNode, target) {
    return this.jpc(mapper, contextNode, target);
  };
  function intRoleCompletion$o$createRoleCompletion$lambda($target) {
    return function (it) {
      return $target.qn8(it);
    };
  }
  function intRoleCompletion$1() {
  }
  protoOf(intRoleCompletion$1).kpc = function (mapper, contextNode, target) {
    return completionForNumber(intRoleCompletion$o$createRoleCompletion$lambda(target));
  };
  protoOf(intRoleCompletion$1).gnb = function (mapper, contextNode, target) {
    return this.kpc(mapper, contextNode, target);
  };
  function completionItemForNumber$1($sortPriority, $consumer) {
    this.mpc_1 = $consumer;
    BaseCompletionItem.call(this);
    this.lpc_1 = $sortPriority;
  }
  protoOf(completionItemForNumber$1).gm7 = function () {
    return 'number';
  };
  protoOf(completionItemForNumber$1).pma = function () {
    return this.lpc_1;
  };
  protoOf(completionItemForNumber$1).qma = function (text) {
    return '' === text || this.pm7(text);
  };
  protoOf(completionItemForNumber$1).pm7 = function (text) {
    return Validators_getInstance().plh()(text);
  };
  protoOf(completionItemForNumber$1).wm9 = function (text) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0) {
      tmp = 0;
    } else {
      tmp = toInt(text);
    }
    var value = tmp;
    return this.mpc_1(value);
  };
  protoOf(completionItemForNumber$1).toString = function () {
    return 'number completion';
  };
  function completionItemForValidator$1($sortPriority, $validator, $consumer) {
    this.ppc_1 = $validator;
    this.qpc_1 = $consumer;
    BaseCompletionItem.call(this);
    this.npc_1 = 'id';
    this.opc_1 = $sortPriority;
  }
  protoOf(completionItemForValidator$1).gm7 = function () {
    return this.npc_1;
  };
  protoOf(completionItemForValidator$1).pma = function () {
    return this.opc_1;
  };
  protoOf(completionItemForValidator$1).qma = function (text) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(text) === 0) {
      tmp = true;
    } else {
      tmp = this.ppc_1(text);
    }
    return tmp;
  };
  protoOf(completionItemForValidator$1).pm7 = function (text) {
    return this.ppc_1(text);
  };
  protoOf(completionItemForValidator$1).wm9 = function (text) {
    return this.qpc_1(text);
  };
  function map_2(_this__u8e3s4, f) {
    var tmp = map$lambda(_this__u8e3s4, f);
    return new sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2(tmp);
  }
  function plus_12(_this__u8e3s4, other) {
    var tmp = plus$lambda(_this__u8e3s4, other);
    return new sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3(tmp);
  }
  function map_3(_this__u8e3s4, f) {
    return new map$2_0(_this__u8e3s4, f);
  }
  function plus_13(_this__u8e3s4, other) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.context.completionSupplier' call
    return new plus$$inlined$completionSupplier$1(false, _this__u8e3s4, other);
  }
  function combine_0(_this__u8e3s4, other) {
    var t = Companion_instance_286.hli();
    t = t.vme(_this__u8e3s4);
    t = t.vme(other);
    return t.qr();
  }
  function sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2(function_0) {
    this.rpc_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2).gnb = function (mapper, contextNode, target) {
    return this.rpc_1(mapper, contextNode, target);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2).b4 = function () {
    return this.rpc_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RoleCompletion) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_2).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3(function_0) {
    this.spc_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3).gnb = function (mapper, contextNode, target) {
    return this.spc_1(mapper, contextNode, target);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3).b4 = function () {
    return this.spc_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RoleCompletion) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_3).hashCode = function () {
    return hashCode(this.b4());
  };
  function map$lambda($this_map, $f) {
    return function (mapper, contextNode, target) {
      return $this_map.gnb(mapper, contextNode, map_3(target, $f));
    };
  }
  function plus$lambda($this_plus, $other) {
    return function (mapper, contextNode, target) {
      var cs1 = $this_plus.gnb(mapper, contextNode, target);
      var cs2 = $other.gnb(mapper, contextNode, target);
      return plus_13(cs1, cs2);
    };
  }
  function map$2_0($this_map, $f) {
    this.tpc_1 = $this_map;
    this.upc_1 = $f;
  }
  protoOf(map$2_0).vpc = function (target) {
    return this.tpc_1.qn8(this.upc_1(target));
  };
  protoOf(map$2_0).qn8 = function (target) {
    return this.vpc(!(target == null) ? target : THROW_CCE());
  };
  function plus$$inlined$completionSupplier$1($cacheable, $this_plus, $other) {
    this.wpc_1 = $cacheable;
    this.xpc_1 = $this_plus;
    this.ypc_1 = $other;
  }
  protoOf(plus$$inlined$completionSupplier$1).um2 = function () {
    return this.wpc_1;
  };
  protoOf(plus$$inlined$completionSupplier$1).um1 = function (completionContext) {
    // Inline function 'jetbrains.ocelot.langDef.completion.helpers.plus.<anonymous>' call
    return combine_0(this.xpc_1.um1(completionContext), this.ypc_1.um1(completionContext));
  };
  function editorString(_this__u8e3s4, mark) {
    return new editorString$1(mark);
  }
  function sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0(function_0) {
    this.zpc_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0).hp8 = function (cell) {
    return this.zpc_1(cell);
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0).b4 = function () {
    return this.zpc_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ActionOnCell) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0).hashCode = function () {
    return hashCode(this.b4());
  };
  function editorString$o$provideCompletion$lambda$lambda($mark) {
    return function (it) {
      var tmp0_safe_receiver = find_2(it, $mark);
      return tmp0_safe_receiver == null ? null : toEnd_0(tmp0_safe_receiver);
    };
  }
  function editorString$o$provideCompletion$lambda($factory, $mark) {
    return function ($this$does, string) {
      var node = $factory(string);
      $this$does.fp8(node);
      var tmp = editorString$o$provideCompletion$lambda$lambda($mark);
      return $this$does.gp8(new sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_0(tmp));
    };
  }
  function editorString$1($mark) {
    this.apd_1 = $mark;
    CustomCompletionKind.call(this);
  }
  protoOf(editorString$1).bpd = function (_this__u8e3s4, factory) {
    var tmp = _this__u8e3s4.dp6();
    _this__u8e3s4.vp7(tmp, editorString$o$provideCompletion$lambda(factory, this.apd_1));
  };
  protoOf(editorString$1).bp6 = function (_this__u8e3s4, factory) {
    return this.bpd(_this__u8e3s4, factory);
  };
  function nodeRefCompletion(_this__u8e3s4, refTag, childContext) {
    childContext = childContext === VOID ? null : childContext;
    return nodeRefCompletion_0(_this__u8e3s4, _this__u8e3s4.j6y(refTag), childContext);
  }
  function nodeRefCompletion_0(_this__u8e3s4, provider, childContext) {
    childContext = childContext === VOID ? null : childContext;
    return nodeRefCompletion_1(provider, _this__u8e3s4, childContext);
  }
  function nodeRefCompletion_1(supplier, coroutineScope, childContext) {
    childContext = childContext === VOID ? null : childContext;
    return new nodeRefCompletion$1(coroutineScope, supplier, childContext);
  }
  function nodeRefCompletion$1$createRoleCompletion$completionBase$1($coroutineScope, $supplier, $target, $childContext, $contextNode, $mapper) {
    this.gpd_1 = $supplier;
    this.hpd_1 = $target;
    this.ipd_1 = $childContext;
    this.jpd_1 = $contextNode;
    this.kpd_1 = $mapper;
    ReferenceCompletionBase.call(this, $coroutineScope, $supplier, new CompletionOptions(), Companion_getInstance_358().ip4_1);
  }
  protoOf(nodeRefCompletion$1$createRoleCompletion$completionBase$1).vp8 = function (item) {
    return this.hpd_1.qn8(item.c6u_1);
  };
  protoOf(nodeRefCompletion$1$createRoleCompletion$completionBase$1).j75 = function (filter) {
    var tmp;
    if (!(this.ipd_1 == null)) {
      tmp = toEnclosingNodeContext(this.ipd_1);
    } else if (!(this.jpd_1 == null)) {
      tmp = new EnclosingNodeContext(this.jpd_1, null);
    } else {
      throw IllegalArgumentException_init_$Create$_0("Either childContext or editor's context node must not be null");
    }
    var elementsContext = tmp;
    return this.gpd_1.g6u(elementsContext, filter);
  };
  protoOf(nodeRefCompletion$1$createRoleCompletion$completionBase$1).qp3 = function () {
    var tmp = this.kpd_1.ql9_1;
    var tmp0_safe_receiver = ((!(tmp == null) ? isInterface(tmp, Cell) : false) ? tmp : THROW_CCE()).llk();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.rlp();
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.m2c();
  };
  function nodeRefCompletion$1($coroutineScope, $supplier, $childContext) {
    this.lpd_1 = $coroutineScope;
    this.mpd_1 = $supplier;
    this.npd_1 = $childContext;
  }
  protoOf(nodeRefCompletion$1).opd = function (mapper, contextNode, target) {
    var completionBase = new nodeRefCompletion$1$createRoleCompletion$completionBase$1(this.lpd_1, this.mpd_1, target, this.npd_1, contextNode, mapper);
    return completionBase.rp3();
  };
  protoOf(nodeRefCompletion$1).gnb = function (mapper, contextNode, target) {
    return this.opd(mapper, contextNode, target);
  };
  function BaseCellBuilder$build$lambda($childSetupFunctions, this$0, $context, $source, $resultCell) {
    return function () {
      var _iterator__ex2g4s = $childSetupFunctions.k();
      while (_iterator__ex2g4s.l()) {
        var sf = _iterator__ex2g4s.m();
        sf();
      }
      var _iterator__ex2g4s_0 = this$0.spd_1.k();
      while (_iterator__ex2g4s_0.l()) {
        var sync = _iterator__ex2g4s_0.m();
        sync($context, $source, $resultCell);
      }
      var _iterator__ex2g4s_1 = this$0.rpd_1.k();
      while (_iterator__ex2g4s_1.l()) {
        var setupFun = _iterator__ex2g4s_1.m();
        setupFun($context, $source, $resultCell);
      }
      var _iterator__ex2g4s_2 = this$0.tpd_1.k();
      while (_iterator__ex2g4s_2.l()) {
        var builder = _iterator__ex2g4s_2.m();
        $resultCell.olp(builder.wpd());
      }
      return Unit_instance;
    };
  }
  function BaseCellBuilder() {
    this.ppd_1 = ArrayList_init_$Create$();
    this.qpd_1 = false;
    this.rpd_1 = ArrayList_init_$Create$();
    this.spd_1 = ArrayList_init_$Create$();
    this.tpd_1 = ArrayList_init_$Create$();
  }
  protoOf(BaseCellBuilder).xpd = function (child) {
    // Inline function 'kotlin.check' call
    if (!!this.qpd_1) {
      // Inline function 'jetbrains.ocelot.langDef.editor.BaseCellBuilder.add.<anonymous>' call
      var message = 'trying to update children after builder initialization';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.ppd_1.e(child);
  };
  protoOf(BaseCellBuilder).ypd = function (init) {
    // Inline function 'kotlin.check' call
    if (!!this.qpd_1) {
      // Inline function 'jetbrains.ocelot.langDef.editor.BaseCellBuilder.setup.<anonymous>' call
      var message = 'trying to add setup block after builder initialization';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.rpd_1.e(init);
  };
  protoOf(BaseCellBuilder).zpd = function (init) {
    // Inline function 'kotlin.check' call
    if (!!this.qpd_1) {
      // Inline function 'jetbrains.ocelot.langDef.editor.BaseCellBuilder.setupSynchronizers.<anonymous>' call
      var message = 'trying to add setupSynchronizers block after builder initialization';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    this.spd_1.e(init);
  };
  protoOf(BaseCellBuilder).bpe = function (source, cellMap, context) {
    this.qpd_1 = true;
    var result = this.ape(source, context);
    var resultCell = result.cpe_1;
    var id = result.dpe_1;
    if (!(id == null)) {
      var contextKey = new ContextKey(this, id);
      var previousValue = cellMap.r2(contextKey, resultCell);
      // Inline function 'kotlin.check' call
      if (!(previousValue == null)) {
        // Inline function 'jetbrains.ocelot.langDef.editor.BaseCellBuilder.build.<anonymous>' call
        var message = 'previous value present: ' + toString_0(previousValue) + ', cell builder: ' + toString_1(this) + ', value: ' + result.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    var childSetupFunctions = ArrayList_init_$Create$();
    var _iterator__ex2g4s = this.ppd_1.k();
    while (_iterator__ex2g4s.l()) {
      var childCellBuilder = _iterator__ex2g4s.m();
      var buildResult = childCellBuilder.bpe(source, cellMap, context);
      var cell = buildResult.epe_1;
      childSetupFunctions.e(buildResult.fpe_1);
      resultCell.ilp().e(cell);
    }
    return new CellBuildResult(resultCell, BaseCellBuilder$build$lambda(childSetupFunctions, this, context, source, resultCell));
  };
  function CellBuildResult(cell, setupFunction) {
    this.epe_1 = cell;
    this.fpe_1 = setupFunction;
  }
  protoOf(CellBuildResult).toString = function () {
    return 'CellBuildResult(cell=' + toString_1(this.epe_1) + ', setupFunction=' + toString_1(this.fpe_1) + ')';
  };
  protoOf(CellBuildResult).hashCode = function () {
    var result = hashCode(this.epe_1);
    result = imul(result, 31) + hashCode(this.fpe_1) | 0;
    return result;
  };
  protoOf(CellBuildResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CellBuildResult))
      return false;
    var tmp0_other_with_cast = other instanceof CellBuildResult ? other : THROW_CCE();
    if (!equals(this.epe_1, tmp0_other_with_cast.epe_1))
      return false;
    if (!equals(this.fpe_1, tmp0_other_with_cast.fpe_1))
      return false;
    return true;
  };
  function CellBuilderContext() {
  }
  function rootIndent(_this__u8e3s4, init) {
    return indent(_this__u8e3s4, VOID, rootIndent$lambda(init));
  }
  function textProperty(_this__u8e3s4, placeholder, property) {
    return editableText(_this__u8e3s4, VOID, VOID, placeholder, textProperty$lambda(property));
  }
  function indentLabel(_this__u8e3s4, text_0, allowLast) {
    allowLast = allowLast === VOID ? false : allowLast;
    // Inline function 'kotlin.apply' call
    // Inline function 'jetbrains.ocelot.langDef.editor.indentLabel.<anonymous>' call
    text(_this__u8e3s4, text_0).zpd(indentLabel$lambda(text_0, allowLast));
  }
  function decimalProperty(_this__u8e3s4, placeholder, property) {
    var tmp = bigDecimalValidator$ref();
    return editableText(_this__u8e3s4, tmp, VOID, placeholder, decimalProperty$lambda(property));
  }
  function integerProperty(_this__u8e3s4, placeholder, property) {
    var tmp0_validator = Validators_getInstance().qlh();
    return editableText(_this__u8e3s4, tmp0_validator, VOID, placeholder, integerProperty$lambda(property));
  }
  function selectFirstPlaceholderOnCreate(_this__u8e3s4) {
    var tmp = ProjectionalSynchronizers_getInstance().jlw_1;
    trait(_this__u8e3s4, tmp, selectFirstPlaceholderOnCreate$lambda);
  }
  function rootIndent$lambda($init) {
    return function ($this$indent) {
      $init($this$indent);
      selectFirstPlaceholderOnCreate($this$indent);
      return Unit_instance;
    };
  }
  function textProperty$lambda($property) {
    return function ($this$editableText) {
      textSyncTwoWay($this$editableText, $property);
      return Unit_instance;
    };
  }
  function indentLabel$1($textCell) {
    this.kpe_1 = $textCell;
  }
  protoOf(indentLabel$1).b4v = function (context) {
    return prevCellIsPlaceholderOrNone(context, this.kpe_1);
  };
  function indentLabel$lambda$lambda($prevIsPlaceholder) {
    return function () {
      return $prevIsPlaceholder.m2c();
    };
  }
  function indentLabel$lambda$lambda_0($allowLast) {
    return function () {
      return $allowLast;
    };
  }
  function indentLabel$$inlined$apply$1$3($traitDisposable, $textCell) {
    this.lpe_1 = $traitDisposable;
    this.mpe_1 = $textCell;
  }
  protoOf(indentLabel$$inlined$apply$1$3).bm7 = function (newValue) {
    var tmp0_safe_receiver = this.lpe_1._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.vr();
    }
    var tmp;
    if (newValue) {
      this.lpe_1._v = this.mpe_1.olp(TextEditing_getInstance().slx(true, false));
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(indentLabel$$inlined$apply$1$3).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function indentLabel$lambda($text, $allowLast) {
    return function ($this$setupSynchronizers, _unused_var__etf5q3, textCell) {
      var tmp;
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = $text;
      if (charSequenceLength(this_0) > 0) {
        var prevIsPlaceholder = new EagerInvalidatable(new indentLabel$1(textCell));
        if ($allowLast || $text.length > 1) {
          textCell.hlp().v2c(true);
          var tmp_0 = TextEditing_getInstance();
          var tmp_1 = indentLabel$lambda$lambda(prevIsPlaceholder);
          textCell.olp(tmp_0.bmu(tmp_1, indentLabel$lambda$lambda_0($allowLast)));
        } else {
          var traitDisposable = {_v: null};
          $this$setupSynchronizers.wle(syncOneWay(prevIsPlaceholder, textCell.hlp()));
          // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
          var tmp$ret$1 = new indentLabel$$inlined$apply$1$3(traitDisposable, textCell);
          $this$setupSynchronizers.wle(syncOneWay(prevIsPlaceholder, tmp$ret$1));
        }
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function bigDecimalValidator$ref() {
    var l = function (p0) {
      return bigDecimalValidator(p0);
    };
    l.callableName = 'bigDecimalValidator';
    return l;
  }
  function decimalProperty$lambda($property) {
    return function ($this$editableText) {
      decimalSyncTwoWay($this$editableText, $property);
      return Unit_instance;
    };
  }
  function integerProperty$lambda($property) {
    return function ($this$editableText) {
      intSyncTwoWay($this$editableText, $property);
      return Unit_instance;
    };
  }
  function selectFirstPlaceholderOnCreate$lambda($this$trait, _unused_var__etf5q3, cell) {
    return toFirstPlaceholderWhenSettled(cell);
  }
  function CellBuilderId(name) {
    BaseId.call(this, VOID, name);
  }
  function keyword(_this__u8e3s4, text) {
    var factory = keyword$lambda(text);
    cell(_this__u8e3s4, 'keyword', factory);
  }
  function space(_this__u8e3s4) {
    text(_this__u8e3s4, ' ');
  }
  function newLine(_this__u8e3s4) {
    cell(_this__u8e3s4, 'newLine', CellFactory$newLine$ref(CellFactory_instance));
  }
  function rightTransform(_this__u8e3s4, init) {
    return addTraitOnAttach(_this__u8e3s4, rightTransform$lambda(init));
  }
  function indent(_this__u8e3s4, isIndented, init) {
    isIndented = isIndented === VOID ? false : isIndented;
    var factory = indent$lambda(isIndented);
    return cell(_this__u8e3s4, 'indent', factory, init);
  }
  function addTraitOnAttach(_this__u8e3s4, traitFactory) {
    return addTraitOnAttachGeneric(_this__u8e3s4, addTraitOnAttach$lambda(traitFactory));
  }
  function label(_this__u8e3s4, text) {
    var factory = label$lambda(text);
    return cell(_this__u8e3s4, 'label', factory);
  }
  function horizontal(_this__u8e3s4, init) {
    return cell(_this__u8e3s4, 'horizontal', HorizontalCell$_init_$ref_7uua69(), init);
  }
  function placeholderInCollection(_this__u8e3s4, text, collectionItemCompletion) {
    text = text === VOID ? '' : text;
    return editableText(_this__u8e3s4, VOID, VOID, text, placeholderInCollection$lambda(collectionItemCompletion));
  }
  function focusable(_this__u8e3s4, newValue) {
    return _this__u8e3s4.ypd(focusable$lambda(newValue));
  }
  function editableText(_this__u8e3s4, validator, text, placeholderText, init) {
    validator = validator === VOID ? null : validator;
    text = text === VOID ? '' : text;
    placeholderText = placeholderText === VOID ? null : placeholderText;
    var tmp;
    if (init === VOID) {
      tmp = editableText$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    var id = new CellBuilderId('editableText');
    var namedCellFactory = new NamedCellFactory('editableText', TextCell$_init_$ref_mn70h6(), id);
    var mainCellBuilder = cell_0(_this__u8e3s4, namedCellFactory, editableText$lambda_0(text, validator));
    init(mainCellBuilder);
    if (!(placeholderText == null)) {
      var placeholderNamedCellFactory = new NamedCellFactory('placeholderText (editableText)', editableText$lambda_1(placeholderText), id);
      var placeholderCellBuilder = cell_0(_this__u8e3s4, placeholderNamedCellFactory);
      _this__u8e3s4.ypd(editableText$lambda_2(mainCellBuilder, id, placeholderCellBuilder));
    }
    return mainCellBuilder;
  }
  function text(_this__u8e3s4, text) {
    var factory = text$lambda(text);
    return cell(_this__u8e3s4, "text('" + text + "')", factory);
  }
  function trait(_this__u8e3s4, propSpec, specAction) {
    return addTrait_0(_this__u8e3s4, trait$lambda(propSpec, specAction));
  }
  function cell(_this__u8e3s4, name, factory, init) {
    var tmp;
    if (init === VOID) {
      tmp = cell$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    return cell_0(_this__u8e3s4, new NamedCellFactory(name, factory), init);
  }
  function addTraitOnAttachGeneric(_this__u8e3s4, traitFactory) {
    _this__u8e3s4.zpd(addTraitOnAttachGeneric$lambda(traitFactory));
  }
  function addTrait(_this__u8e3s4, trait) {
    return addTrait_0(_this__u8e3s4, addTrait$lambda(trait));
  }
  function completion_0(_this__u8e3s4, init) {
    return addTraitOnAttachGeneric(_this__u8e3s4, completion$lambda(init));
  }
  function cell_0(_this__u8e3s4, namedCellFactory, init) {
    var tmp;
    if (init === VOID) {
      tmp = cell$lambda_0;
    } else {
      tmp = init;
    }
    init = tmp;
    var result = new SimpleCellBuilder(namedCellFactory, _this__u8e3s4.gpe());
    init(result);
    _this__u8e3s4.xpd(result);
    return result;
  }
  function setText_0(_this__u8e3s4, newValue) {
    return _this__u8e3s4.ypd(setText$lambda(newValue));
  }
  function addTrait_0(_this__u8e3s4, traitFactory) {
    return _this__u8e3s4.ypd(addTrait$lambda_0(traitFactory));
  }
  function completion_1(_this__u8e3s4, init) {
    return addTraitOnAttach(_this__u8e3s4, completion$lambda_0(init));
  }
  function keyword$lambda($text) {
    return function () {
      return CellFactory_instance.bmx($text);
    };
  }
  function CellFactory$newLine$ref($boundThis) {
    var l = function () {
      return $boundThis.elj();
    };
    l.callableName = 'newLine';
    return l;
  }
  function rightTransform$1$$inlined$propertyTrait$1($propSpec, $init, $this_addTraitOnAttach, $source, $textCell, $cellFinder) {
    this.npe_1 = $propSpec;
    this.ope_1 = $init;
    this.ppe_1 = $this_addTraitOnAttach;
    this.qpe_1 = $source;
    this.rpe_1 = $textCell;
    this.spe_1 = $cellFinder;
    CellTrait.call(this);
  }
  protoOf(rightTransform$1$$inlined$propertyTrait$1).flo = function (cell, spec) {
    var tmp;
    if (spec === this.npe_1) {
      // Inline function 'jetbrains.ocelot.langDef.editor.rightTransform.<anonymous>.<anonymous>' call
      tmp = this.ope_1(this.ppe_1, this.qpe_1, this.rpe_1, this.spe_1);
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function rightTransform$lambda($init) {
    return function ($this$addTraitOnAttach, source, textCell, cellFinder) {
      var tmp;
      if (!$this$addTraitOnAttach.tpe()) {
        // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
        var propSpec = Completion_getInstance().em1_1;
        tmp = new rightTransform$1$$inlined$propertyTrait$1(propSpec, $init, $this$addTraitOnAttach, source, textCell, cellFinder);
      } else {
        tmp = Companion_getInstance_302().dmw_1;
      }
      return tmp;
    };
  }
  function indent$lambda($isIndented) {
    return function () {
      return new IndentCell($isIndented);
    };
  }
  function addTraitOnAttach$lambda($traitFactory) {
    return function ($this$addTraitOnAttachGeneric, source, cell, mappingContext) {
      var cellFinder = getMapperCellFinder(mappingContext);
      return $traitFactory($this$addTraitOnAttachGeneric, source, cell, cellFinder);
    };
  }
  function label$lambda($text) {
    return function () {
      return CellFactory_instance.amx($text);
    };
  }
  function HorizontalCell$_init_$ref_7uua69() {
    var l = function () {
      return new HorizontalCell();
    };
    l.callableName = '<init>';
    return l;
  }
  function isEmpty$ref_0() {
    var l = function (p0) {
      return isEmpty(p0);
    };
    l.callableName = 'isEmpty';
    return l;
  }
  function placeholderInCollection$lambda$lambda($collectionItemCompletion) {
    return function ($this$completion, mapper) {
      var roleCompletion = $collectionItemCompletion($this$completion);
      return getCollectionPlaceholderCompletionSupplier(mapper, roleCompletion);
    };
  }
  function placeholderInCollection$lambda($collectionItemCompletion) {
    return function ($this$editableText) {
      var tmp = TextEditing_getInstance();
      addTrait($this$editableText, tmp.gmu(isEmpty$ref_0()));
      completion_0($this$editableText, placeholderInCollection$lambda$lambda($collectionItemCompletion));
      return Unit_instance;
    };
  }
  function focusable$lambda($newValue) {
    return function ($this$setup, _unused_var__etf5q3, cell) {
      cell.hlp().t2c($newValue);
      return Unit_instance;
    };
  }
  function editableText$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function TextCell$_init_$ref_mn70h6() {
    var l = function () {
      return TextCell_init_$Create$();
    };
    l.callableName = '<init>';
    return l;
  }
  function editableText$lambda$lambda($validator) {
    return function ($this$addTrait, _unused_var__etf5q3, _unused_var__etf5q3_0) {
      return $this$addTrait.hpe().tpe() ? TextEditing_getInstance().amu() : $validator == null ? TextEditing_getInstance().fmu() : TextEditing_getInstance().gmu($validator);
    };
  }
  function editableText$lambda_0($text, $validator) {
    return function ($this$cell) {
      focusable($this$cell, true);
      setText_0($this$cell, $text);
      addTrait_0($this$cell, editableText$lambda$lambda($validator));
      return Unit_instance;
    };
  }
  function editableText$lambda_1($placeholderText) {
    return function () {
      return placeholder_0($placeholderText);
    };
  }
  function editableText$lambda_2($mainCellBuilder, $id, $placeholderCellBuilder) {
    return function ($this$setup, _unused_var__etf5q3, _unused_var__etf5q3_0) {
      var mainTextCell = $this$setup.jpe($mainCellBuilder, $id);
      var placeholderTextCell = $this$setup.jpe($placeholderCellBuilder, $id);
      attachToPlaceholder(placeholderTextCell, mainTextCell);
      return Unit_instance;
    };
  }
  function text$lambda($text) {
    return function () {
      return TextCell_init_$Create$_0($text);
    };
  }
  function trait$1$$inlined$propertyTrait$1($propSpec, $specAction, $this_addTrait, $source, $cellT) {
    this.upe_1 = $propSpec;
    this.vpe_1 = $specAction;
    this.wpe_1 = $this_addTrait;
    this.xpe_1 = $source;
    this.ype_1 = $cellT;
    CellTrait.call(this);
  }
  protoOf(trait$1$$inlined$propertyTrait$1).flo = function (cell, spec) {
    var tmp;
    if (spec === this.upe_1) {
      // Inline function 'jetbrains.ocelot.langDef.editor.trait.<anonymous>.<anonymous>' call
      tmp = this.vpe_1(this.wpe_1, this.xpe_1, this.ype_1);
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function trait$lambda($propSpec, $specAction) {
    return function ($this$addTrait, source, cellT) {
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
      var propSpec = $propSpec;
      return new trait$1$$inlined$propertyTrait$1(propSpec, $specAction, $this$addTrait, source, cellT);
    };
  }
  function cell$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function addTraitOnAttachGeneric$1$sync$1($traitFactory, $this_setupSynchronizers, $source, $cell) {
    this.apf_1 = $traitFactory;
    this.bpf_1 = $this_setupSynchronizers;
    this.cpf_1 = $source;
    this.dpf_1 = $cell;
    DisposableSynchronizer.call(this);
  }
  protoOf(addTraitOnAttachGeneric$1$sync$1).dlb = function (ctx) {
    var trait = this.apf_1(this.bpf_1.hpe(), this.cpf_1, this.dpf_1, ctx.mlb());
    return this.dpf_1.olp(trait);
  };
  function addTraitOnAttachGeneric$lambda($traitFactory) {
    return function ($this$setupSynchronizers, source, cell) {
      var sync = new addTraitOnAttachGeneric$1$sync$1($traitFactory, $this$setupSynchronizers, source, cell);
      $this$setupSynchronizers.wle(sync);
      return Unit_instance;
    };
  }
  function addTrait$lambda($trait) {
    return function ($this$addTrait, _unused_var__etf5q3, _unused_var__etf5q3_0) {
      return $trait;
    };
  }
  function completion$1$$inlined$propertyTrait$1($propSpec, $mappingContext, $source, $init, $this_addTraitOnAttachGeneric) {
    this.epf_1 = $propSpec;
    this.fpf_1 = $mappingContext;
    this.gpf_1 = $source;
    this.hpf_1 = $init;
    this.ipf_1 = $this_addTraitOnAttachGeneric;
    CellTrait.call(this);
  }
  protoOf(completion$1$$inlined$propertyTrait$1).flo = function (cell, spec) {
    var tmp;
    if (spec === this.epf_1) {
      // Inline function 'jetbrains.ocelot.langDef.editor.completion.<anonymous>.<anonymous>' call
      var tmp0 = this.fpf_1.qld(this.gpf_1);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.k();
        while (_iterator__ex2g4s.l()) {
          var element = _iterator__ex2g4s.m();
          // Inline function 'jetbrains.ocelot.langDef.editor.completion.<anonymous>.<anonymous>.<anonymous>' call
          var tmp_0 = element.ql9_1;
          if (!(tmp_0 == null) ? isInterface(tmp_0, Cell) : false) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var mapper = ensureNotNull(tmp$ret$1);
      if (!(mapper instanceof Mapper))
        THROW_CCE();
      tmp = this.hpf_1(this.ipf_1, mapper);
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function completion$lambda($init) {
    return function ($this$addTraitOnAttachGeneric, source, _unused_var__etf5q3, mappingContext) {
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
      var propSpec = Completion_getInstance().cm1_1;
      return new completion$1$$inlined$propertyTrait$1(propSpec, mappingContext, source, $init, $this$addTraitOnAttachGeneric);
    };
  }
  function cell$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function setText$lambda($newValue) {
    return function ($this$setup, _unused_var__etf5q3, cell) {
      cell.laz().t2c($newValue);
      return Unit_instance;
    };
  }
  function addTrait$lambda_0($traitFactory) {
    return function ($this$setup, source, cell) {
      cell.olp($traitFactory($this$setup, source, cell));
      return Unit_instance;
    };
  }
  function completion$2$$inlined$propertyTrait$1($propSpec, $init, $this_addTraitOnAttach, $source, $cell, $cellFinder) {
    this.jpf_1 = $propSpec;
    this.kpf_1 = $init;
    this.lpf_1 = $this_addTraitOnAttach;
    this.mpf_1 = $source;
    this.npf_1 = $cell;
    this.opf_1 = $cellFinder;
    CellTrait.call(this);
  }
  protoOf(completion$2$$inlined$propertyTrait$1).flo = function (cell, spec) {
    var tmp;
    if (spec === this.jpf_1) {
      // Inline function 'jetbrains.ocelot.langDef.editor.completion.<anonymous>.<anonymous>' call
      tmp = this.kpf_1(this.lpf_1, this.mpf_1, this.npf_1, this.opf_1);
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function completion$lambda_0($init) {
    return function ($this$addTraitOnAttach, source, cell, cellFinder) {
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
      var propSpec = Completion_getInstance().cm1_1;
      return new completion$2$$inlined$propertyTrait$1(propSpec, $init, $this$addTraitOnAttach, source, cell, cellFinder);
    };
  }
  function CellCreationResult(cell, id) {
    id = id === VOID ? null : id;
    this.cpe_1 = cell;
    this.dpe_1 = id;
  }
  protoOf(CellCreationResult).toString = function () {
    return 'CellCreationResult(cell=' + toString_1(this.cpe_1) + ', id=' + toString_0(this.dpe_1) + ')';
  };
  protoOf(CellCreationResult).hashCode = function () {
    var result = hashCode(this.cpe_1);
    result = imul(result, 31) + (this.dpe_1 == null ? 0 : this.dpe_1.hashCode()) | 0;
    return result;
  };
  protoOf(CellCreationResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CellCreationResult))
      return false;
    var tmp0_other_with_cast = other instanceof CellCreationResult ? other : THROW_CCE();
    if (!equals(this.cpe_1, tmp0_other_with_cast.cpe_1))
      return false;
    if (!equals(this.dpe_1, tmp0_other_with_cast.dpe_1))
      return false;
    return true;
  };
  function CompositeMapperBuilder(sourceType, scope, builders, errorBuilder) {
    errorBuilder = errorBuilder === VOID ? invalidMapperBuilder(scope, sourceType) : errorBuilder;
    this.ppf_1 = sourceType;
    this.qpf_1 = scope;
    this.rpf_1 = builders;
    this.spf_1 = errorBuilder;
  }
  protoOf(CompositeMapperBuilder).uoy = function () {
    return this.ppf_1;
  };
  protoOf(CompositeMapperBuilder).toy = function (configuration, source) {
    var _iterator__ex2g4s = this.rpf_1.k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var builder = _iterator__ex2g4s.m();
      var tmp0_elvis_lhs = buildSafe(builder, configuration, source);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      return tmp;
    }
    return this.spf_1.toy(configuration, source);
  };
  function ContextKey(builder, id) {
    this.tpf_1 = builder;
    this.upf_1 = id;
  }
  protoOf(ContextKey).toString = function () {
    return 'ContextKey(builder=' + toString_1(this.tpf_1) + ', id=' + this.upf_1.toString() + ')';
  };
  protoOf(ContextKey).hashCode = function () {
    var result = hashCode(this.tpf_1);
    result = imul(result, 31) + this.upf_1.hashCode() | 0;
    return result;
  };
  protoOf(ContextKey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ContextKey))
      return false;
    var tmp0_other_with_cast = other instanceof ContextKey ? other : THROW_CCE();
    if (!equals(this.tpf_1, tmp0_other_with_cast.tpf_1))
      return false;
    if (!this.upf_1.equals(tmp0_other_with_cast.upf_1))
      return false;
    return true;
  };
  function EditorScope() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.vpf_1 = ArrayList_init_$Create$();
  }
  protoOf(EditorScope).wpf = function (builder) {
    this.vpf_1.e(builder);
  };
  protoOf(EditorScope).xpf = function () {
    var tmp = this.vpf_1;
    return isInterface(tmp, KtList) ? tmp : THROW_CCE();
  };
  protoOf(EditorScope).ypf = function (sourceType) {
    return this.zpf(new CompositeMapperBuilder(sourceType, this, this.xpf()));
  };
  protoOf(EditorScope).zpf = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  function LazyMapperBuilder(builderProvider) {
    this.apg_1 = lazy_0(builderProvider);
  }
  protoOf(LazyMapperBuilder).bpg = function () {
    var tmp0 = this.apg_1;
    // Inline function 'kotlin.getValue' call
    delegate$factory();
    return tmp0.y();
  };
  protoOf(LazyMapperBuilder).uoy = function () {
    return this.bpg().uoy();
  };
  protoOf(LazyMapperBuilder).toy = function (configuration, source) {
    return this.bpg().toy(configuration, source);
  };
  function delegate$factory() {
    return getPropertyCallableRef('delegate', 1, KProperty1, function (receiver) {
      return receiver.bpg();
    }, null);
  }
  function buildFactory(_this__u8e3s4, configuration) {
    return buildFactory$lambda(_this__u8e3s4, configuration);
  }
  function invalidMapperBuilder(_this__u8e3s4, type) {
    return new invalidMapperBuilder$1(_this__u8e3s4, type);
  }
  function buildSafe(_this__u8e3s4, configuration, source) {
    if (_this__u8e3s4.uoy().mb(source)) {
      return _this__u8e3s4.toy(configuration, (!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE());
    }
    return null;
  }
  function buildFactory$lambda($this_buildFactory, $configuration) {
    return function (it) {
      return $this_buildFactory.toy($configuration, it);
    };
  }
  function invalidMapperBuilder$1($this_invalidMapperBuilder, $type) {
    this.cpg_1 = $this_invalidMapperBuilder;
    this.dpg_1 = $type;
  }
  protoOf(invalidMapperBuilder$1).uoy = function () {
    return this.dpg_1;
  };
  protoOf(invalidMapperBuilder$1).toy = function (configuration, source) {
    throw IllegalStateException_init_$Create$_0("Can't create a mapper for " + toString_1(source));
  };
  function indentChildren(_this__u8e3s4, role, mapperBuilder, placeholderText, childrenDecorator, init) {
    placeholderText = placeholderText === VOID ? null : placeholderText;
    childrenDecorator = childrenDecorator === VOID ? null : childrenDecorator;
    init = init === VOID ? null : init;
    var cellFactory = new NamedCellFactory('indentChildren', indentChildren$lambda);
    return children_0(_this__u8e3s4, role, cellFactory, placeholderText, mapperBuilder, childrenDecorator, init);
  }
  function indentChild(_this__u8e3s4, role, mapperBuilder, placeholderText, init) {
    placeholderText = placeholderText === VOID ? null : placeholderText;
    init = init === VOID ? null : init;
    var cellFactory = new NamedCellFactory('indentChild', indentChild$lambda);
    return child(_this__u8e3s4, role, cellFactory, mapperBuilder, placeholderText, init);
  }
  function projectionalChild(_this__u8e3s4, property, cellFactory, mapperBuilder, placeholderText, placeholderTraitFactory, init) {
    placeholderText = placeholderText === VOID ? null : placeholderText;
    var tmp;
    if (placeholderTraitFactory === VOID) {
      tmp = projectionalChild$lambda;
    } else {
      tmp = placeholderTraitFactory;
    }
    placeholderTraitFactory = tmp;
    init = init === VOID ? null : init;
    return cell_0(_this__u8e3s4, cellFactory, projectionalChild$lambda_0(property, mapperBuilder, placeholderText, init, placeholderTraitFactory));
  }
  function children_0(_this__u8e3s4, role, cellFactory, placeholderText, mapperBuilder, childrenDecorator, init) {
    childrenDecorator = childrenDecorator === VOID ? null : childrenDecorator;
    init = init === VOID ? null : init;
    return cell_0(_this__u8e3s4, cellFactory, children$lambda(childrenDecorator, role, mapperBuilder, placeholderText, init));
  }
  function child(_this__u8e3s4, role, cellFactory, mapperBuilder, placeholderText, init) {
    placeholderText = placeholderText === VOID ? null : placeholderText;
    init = init === VOID ? null : init;
    return projectionalChild(_this__u8e3s4, child$lambda(role), cellFactory, mapperBuilder, placeholderText, VOID, init);
  }
  function placeholder_1(text) {
    var textCell = CellFactory_instance.amx('');
    var placeholder_0 = placeholder(textCell, text == null ? '<empty>' : text);
    return CellFactory_instance.wmw([textCell, placeholder_0]);
  }
  function indentChildren$lambda() {
    return new IndentCell();
  }
  function indentChild$lambda() {
    return new IndentCell();
  }
  function projectionalChild$lambda(_this__u8e3s4, _unused_var__etf5q3, trait) {
    return trait;
  }
  function projectionalChild$2$1$target$1($cell, $placeholderText) {
    this.epg_1 = $cell;
    this.fpg_1 = $placeholderText;
  }
  protoOf(projectionalChild$2$1$target$1).imi = function (newValue) {
    var children = this.epg_1.ilp();
    children.m2();
    children.e(newValue == null ? placeholder_1(this.fpg_1) : newValue);
  };
  protoOf(projectionalChild$2$1$target$1).t2c = function (newValue) {
    return this.imi((newValue == null ? true : isInterface(newValue, Cell)) ? newValue : THROW_CCE());
  };
  function projectionalChild$lambda$lambda$lambda($placeholderTraitFactory, $this_setupSynchronizers, $source) {
    return function (trait) {
      return $placeholderTraitFactory($this_setupSynchronizers.hpe(), $source, trait);
    };
  }
  function projectionalChild$lambda$lambda($property, $mapperBuilder, $placeholderText, $init, $placeholderTraitFactory) {
    return function ($this$setupSynchronizers, source, cell) {
      var sourceProp = $property(source, cell);
      var mapperFactory = buildFactory($mapperBuilder, $this$setupSynchronizers.hpe());
      var tmp;
      if ($this$setupSynchronizers.hpe().tpe()) {
        var target = new projectionalChild$2$1$target$1(cell, $placeholderText);
        target.imi(null);
        $this$setupSynchronizers.wle(Synchronizers_instance.ple(sourceProp.n4z(), target, mapperFactory));
        tmp = Unit_instance;
      } else {
        var tmp_0 = new ProjectionalPropertySynchronizerSettings();
        var tmp_1 = tmp_0.ine(projectionalChild$lambda$lambda$lambda($placeholderTraitFactory, $this$setupSynchronizers, source));
        var tmp0_elvis_lhs = $placeholderText;
        var settings = tmp_1.kne(tmp0_elvis_lhs == null ? '<empty>' : tmp0_elvis_lhs);
        var synchronizer = ProjectionalSynchronizers_getInstance().ani(sourceProp.n4z(), cell, mapperFactory, settings);
        if (!($init == null)) {
          $init(new SimpleProjectionalRoleSynchronizerBuilder(synchronizer, $this$setupSynchronizers.hpe()));
        }
        $this$setupSynchronizers.wle(synchronizer);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function projectionalChild$lambda_0($property, $mapperBuilder, $placeholderText, $init, $placeholderTraitFactory) {
    return function ($this$cell) {
      $this$cell.zpd(projectionalChild$lambda$lambda($property, $mapperBuilder, $placeholderText, $init, $placeholderTraitFactory));
      return Unit_instance;
    };
  }
  function children$lambda$lambda$lambda($placeholderText) {
    return function () {
      return placeholder_1($placeholderText);
    };
  }
  function children$lambda$lambda$lambda_0(it) {
    return false;
  }
  function children$lambda$lambda($childrenDecorator, $role, $mapperBuilder, $placeholderText, $init) {
    return function ($this$setupSynchronizers, source, cell) {
      var cellChildren = cell.ilp();
      var tmp;
      if ($childrenDecorator == null) {
        tmp = cellChildren;
      } else {
        tmp = $childrenDecorator(cellChildren);
      }
      var targetList = tmp;
      var sourceList = $role(source);
      var mapperFactory = buildFactory($mapperBuilder, $this$setupSynchronizers.hpe());
      var tmp_0;
      if ($this$setupSynchronizers.hpe().tpe()) {
        var cellList = new ObservableArrayList();
        $this$setupSynchronizers.wle(Synchronizers_instance.nle(sourceList.n4z(), cellList, mapperFactory));
        var tmp_1 = Transformers_instance;
        var placeholderIfEmpty = tmp_1.e2l(children$lambda$lambda$lambda($placeholderText));
        var transformation = placeholderIfEmpty.m2i(cellList, targetList);
        $this$setupSynchronizers.wle(Synchronizers_instance.rle([transformation]));
        tmp_0 = Unit_instance;
      } else {
        var tmp_2 = new ProjectionalListSynchronizerSettings();
        var settings = tmp_2.hne(children$lambda$lambda$lambda_0);
        if (!($placeholderText == null)) {
          settings.kne($placeholderText);
        }
        var synchronizer = ProjectionalSynchronizers_getInstance().znh(sourceList.n4z(), cell, targetList, mapperFactory, settings);
        if (!($init == null)) {
          $init(new SimpleProjectionalRoleSynchronizerBuilder(synchronizer, $this$setupSynchronizers.hpe()));
        }
        $this$setupSynchronizers.wle(synchronizer);
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function children$lambda($childrenDecorator, $role, $mapperBuilder, $placeholderText, $init) {
    return function ($this$cell) {
      $this$cell.zpd(children$lambda$lambda($childrenDecorator, $role, $mapperBuilder, $placeholderText, $init));
      return Unit_instance;
    };
  }
  function child$lambda($role) {
    return function (source, _unused_var__etf5q3) {
      return $role(source);
    };
  }
  function NamedCellFactory(name, factory, id) {
    id = id === VOID ? null : id;
    this.gpg_1 = name;
    this.hpg_1 = factory;
    this.ipg_1 = id;
  }
  protoOf(NamedCellFactory).toString = function () {
    return 'NamedCellFactory(name=' + this.gpg_1 + ', factory=' + toString_1(this.hpg_1) + ', id=' + toString_0(this.ipg_1) + ')';
  };
  protoOf(NamedCellFactory).hashCode = function () {
    var result = getStringHashCode(this.gpg_1);
    result = imul(result, 31) + hashCode(this.hpg_1) | 0;
    result = imul(result, 31) + (this.ipg_1 == null ? 0 : this.ipg_1.hashCode()) | 0;
    return result;
  };
  protoOf(NamedCellFactory).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NamedCellFactory))
      return false;
    var tmp0_other_with_cast = other instanceof NamedCellFactory ? other : THROW_CCE();
    if (!(this.gpg_1 === tmp0_other_with_cast.gpg_1))
      return false;
    if (!equals(this.hpg_1, tmp0_other_with_cast.hpg_1))
      return false;
    if (!equals(this.ipg_1, tmp0_other_with_cast.ipg_1))
      return false;
    return true;
  };
  function defaultItem(_this__u8e3s4, fact) {
    _this__u8e3s4.jpg(defaultItem$lambda(fact));
  }
  function defaultItem$lambda$lambda($fact, $this_default) {
    return function () {
      return $fact($this_default);
    };
  }
  function defaultItem$lambda($fact) {
    return function ($this$default) {
      var tmp = Companion_instance_316;
      return tmp.nnd(defaultItem$lambda$lambda($fact, $this$default));
    };
  }
  function ReferenceCellBuilder() {
  }
  function SimpleCellBuilder(cellFactory, scope) {
    BaseCellBuilder.call(this);
    this.rpg_1 = cellFactory;
    this.spg_1 = scope;
  }
  protoOf(SimpleCellBuilder).gpe = function () {
    return this.spg_1;
  };
  protoOf(SimpleCellBuilder).v39 = function () {
    return this.rpg_1.ipg_1;
  };
  protoOf(SimpleCellBuilder).ape = function (source, context) {
    var cell = this.rpg_1.hpg_1();
    return new CellCreationResult(cell, this.v39());
  };
  protoOf(SimpleCellBuilder).toString = function () {
    return 'SimpleCellBuilder(cellFactory=' + this.rpg_1.toString() + ', scope=' + toString_1(this.spg_1) + ')';
  };
  protoOf(SimpleCellBuilder).hashCode = function () {
    var result = this.rpg_1.hashCode();
    result = imul(result, 31) + hashCode(this.spg_1) | 0;
    return result;
  };
  protoOf(SimpleCellBuilder).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SimpleCellBuilder))
      return false;
    var tmp0_other_with_cast = other instanceof SimpleCellBuilder ? other : THROW_CCE();
    if (!this.rpg_1.equals(tmp0_other_with_cast.rpg_1))
      return false;
    if (!equals(this.spg_1, tmp0_other_with_cast.spg_1))
      return false;
    return true;
  };
  function RootCellBuilderImpl($outer) {
    this.tpg_1 = $outer;
  }
  protoOf(RootCellBuilderImpl).gpe = function () {
    return this.tpg_1.upg_1;
  };
  protoOf(RootCellBuilderImpl).xpg = function (init) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(RootCellBuilderImpl).ypd = function (init) {
    return this.xpg(init);
  };
  protoOf(RootCellBuilderImpl).ypg = function (init) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(RootCellBuilderImpl).zpd = function (init) {
    return this.ypg(init);
  };
  protoOf(RootCellBuilderImpl).zpg = function (source, cellMap, context) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(RootCellBuilderImpl).bpe = function (source, cellMap, context) {
    return this.zpg((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  protoOf(RootCellBuilderImpl).xpd = function (child) {
    // Inline function 'kotlin.check' call
    if (!(this.tpg_1.wpg_1 == null)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.tpg_1.wpg_1 = child;
  };
  function SimpleMapperBuilder$build$builderContext$1($configuration, $synchronizers, $builderMap) {
    this.aph_1 = $configuration;
    this.bph_1 = $synchronizers;
    this.cph_1 = $builderMap;
  }
  protoOf(SimpleMapperBuilder$build$builderContext$1).hpe = function () {
    return this.aph_1;
  };
  protoOf(SimpleMapperBuilder$build$builderContext$1).wle = function (sync) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.bph_1.e(sync);
  };
  protoOf(SimpleMapperBuilder$build$builderContext$1).ipe = function (key) {
    var cell = this.cph_1.y2(key);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (cell == null) {
        // Inline function 'jetbrains.ocelot.langDef.editor.<no name provided>.getResult.<anonymous>' call
        var message = 'cell not found for key: ' + key.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return (!(cell == null) ? isInterface(cell, Cell) : false) ? cell : THROW_CCE();
  };
  function SimpleMapperBuilder$build$1($source, $rootCell, $synchronizers) {
    this.kph_1 = $synchronizers;
    Mapper.call(this, $source, $rootCell);
  }
  protoOf(SimpleMapperBuilder$build$1).llb = function (conf) {
    var _iterator__ex2g4s = this.kph_1.k();
    while (_iterator__ex2g4s.l()) {
      var sync = _iterator__ex2g4s.m();
      conf.x4v(sync);
    }
  };
  function SimpleMapperBuilder(scope, sourceType) {
    this.upg_1 = scope;
    this.vpg_1 = sourceType;
    this.wpg_1 = null;
  }
  protoOf(SimpleMapperBuilder).uoy = function () {
    return this.vpg_1;
  };
  protoOf(SimpleMapperBuilder).toy = function (configuration, source) {
    var rootCellBuilder = this.wpg_1;
    // Inline function 'kotlin.checkNotNull' call
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (rootCellBuilder == null) {
        // Inline function 'kotlin.checkNotNull.<anonymous>' call
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var synchronizers = ArrayList_init_$Create$();
    var builderMap = HashMap_init_$Create$();
    var builderContext = new SimpleMapperBuilder$build$builderContext$1(configuration, synchronizers, builderMap);
    var rootResult = rootCellBuilder.bpe(source, builderMap, builderContext);
    var rootCell = rootResult.epe_1;
    rootResult.fpe_1();
    return new SimpleMapperBuilder$build$1(source, rootCell, synchronizers);
  };
  function SimpleProjectionalRoleSynchronizerBuilder(synchronizer, configuration) {
    this.lph_1 = synchronizer;
    this.mph_1 = configuration;
  }
  protoOf(SimpleProjectionalRoleSynchronizerBuilder).nph = function (factory) {
    return this.lph_1.bnc(factory(this.mph_1));
  };
  protoOf(SimpleProjectionalRoleSynchronizerBuilder).jpg = function (factory) {
    return this.lph_1.knb(factory(this.mph_1));
  };
  protoOf(SimpleProjectionalRoleSynchronizerBuilder).oph = function (kind, clonerSupport) {
    return this.lph_1.ina().xnj(kind, clonerSupport(this.mph_1));
  };
  function textSyncTwoWay(_this__u8e3s4, prop) {
    // Inline function 'jetbrains.ocelot.langDef.editor.textCellSyncTwoWay' call
    _this__u8e3s4.ypd(textSyncTwoWay$lambda(prop));
    return Unit_instance;
  }
  function decimalSyncTwoWay(_this__u8e3s4, prop) {
    // Inline function 'jetbrains.ocelot.langDef.editor.textCellSyncTwoWay' call
    _this__u8e3s4.ypd(decimalSyncTwoWay$lambda(prop));
    return Unit_instance;
  }
  function intSyncTwoWay(_this__u8e3s4, prop) {
    // Inline function 'jetbrains.ocelot.langDef.editor.textCellSyncTwoWay' call
    _this__u8e3s4.ypd(intSyncTwoWay$lambda(prop, ValueEditors_instance));
    return Unit_instance;
  }
  function textSyncTwoWay$lambda($prop) {
    return function ($this$setup, source, textCell) {
      var sourceProp = $prop(source);
      // Inline function 'jetbrains.ocelot.langDef.editor.textSyncTwoWay.stub_for_inlining' call
      var targetProp = textCell.laz();
      $this$setup.wle(syncTwoWay(sourceProp.n4z(), targetProp));
      return Unit_instance;
    };
  }
  function decimalSyncTwoWay$lambda($prop) {
    return function ($this$setup, source, textCell) {
      var sourceProp = $prop(source);
      // Inline function 'jetbrains.ocelot.langDef.editor.decimalSyncTwoWay.stub_for_inlining' call
      var targetProp = decimalProperty_0(textCell);
      $this$setup.wle(syncTwoWay(sourceProp.n4z(), targetProp));
      return Unit_instance;
    };
  }
  function intSyncTwoWay$lambda($prop, $tmp1_textCellSyncTwoWay_$receiver) {
    return function ($this$setup, source, textCell) {
      var sourceProp = $prop(source);
      // Inline function 'jetbrains.ocelot.langDef.editor.intSyncTwoWay.stub_for_inlining' call
      var targetProp = $tmp1_textCellSyncTwoWay_$receiver.gn4(textCell);
      $this$setup.wle(syncTwoWay(sourceProp.n4z(), targetProp));
      return Unit_instance;
    };
  }
  function Mode(isReadOnly) {
    this.pph_1 = isReadOnly;
  }
  protoOf(Mode).tpe = function () {
    return this.pph_1;
  };
  function Companion_359() {
    Companion_instance_359 = this;
    this.qph_1 = new Mode(false);
    this.rph_1 = new Mode(true);
    this.sph_1 = this.qph_1;
  }
  var Companion_instance_359;
  function Companion_getInstance_359() {
    if (Companion_instance_359 == null)
      new Companion_359();
    return Companion_instance_359;
  }
  function Mode_0(highlightErrors) {
    this.tph_1 = highlightErrors;
  }
  protoOf(Mode_0).uph = function () {
    return this.tph_1;
  };
  function Companion_360() {
    Companion_instance_360 = this;
    this.vph_1 = new Mode_0(true);
    this.wph_1 = new Mode_0(false);
    this.xph_1 = this.vph_1;
  }
  var Companion_instance_360;
  function Companion_getInstance_360() {
    if (Companion_instance_360 == null)
      new Companion_360();
    return Companion_instance_360;
  }
  function get_spaceDoesntCloseCompletion() {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
    var propSpec = Completion_getInstance().lm1_1;
    return new spaceDoesntCloseCompletion$$inlined$propertyTrait$1(propSpec);
  }
  function spaceDoesntCloseCompletion$$inlined$propertyTrait$1($propSpec) {
    this.yph_1 = $propSpec;
    CellTrait.call(this);
  }
  protoOf(spaceDoesntCloseCompletion$$inlined$propertyTrait$1).flo = function (cell, spec) {
    var tmp;
    if (spec === this.yph_1) {
      // Inline function 'jetbrains.ocelot.langDef.editor.helper.<get-spaceDoesntCloseCompletion>.<anonymous>' call
      tmp = false;
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function CompoundSideTransformTrait$Side$LEFT() {
    Side_2.call(this, 'LEFT', 0, CompoundSideTransformTrait_getInstance().zph_1);
    Side_LEFT_instance_1 = this;
  }
  protoOf(CompoundSideTransformTrait$Side$LEFT).an0 = function (cell) {
    return cell.k2r();
  };
  var Side_LEFT_instance_1;
  function CompoundSideTransformTrait$Side$RIGHT() {
    Side_2.call(this, 'RIGHT', 1, CompoundSideTransformTrait_getInstance().api_1);
    Side_RIGHT_instance_1 = this;
  }
  protoOf(CompoundSideTransformTrait$Side$RIGHT).an0 = function (cell) {
    return cell.h2r();
  };
  var Side_RIGHT_instance_1;
  function CompoundSideTransformTrait$Side$siblingsOf$lambda(this$0) {
    return function (it) {
      return this$0.an0(it);
    };
  }
  var Side_entriesInitialized_1;
  function Side_initEntries_1() {
    if (Side_entriesInitialized_1)
      return Unit_instance;
    Side_entriesInitialized_1 = true;
    Side_LEFT_instance_1 = new CompoundSideTransformTrait$Side$LEFT();
    Side_RIGHT_instance_1 = new CompoundSideTransformTrait$Side$RIGHT();
  }
  function collectCompletion($this, cell, side) {
    var result = get_EMPTY_COMPLETION_SUPPLIER();
    var _iterator__ex2g4s = ancestorsFrom(cell).k();
    $l$loop: while (_iterator__ex2g4s.l()) {
      var ancestor = _iterator__ex2g4s.m();
      var ownCompletion = ancestor.ulp(side.gpi_1);
      if (!(ownCompletion == null))
        result = plus_13(result, ownCompletion);
      var tmp0 = side.gn0(ancestor);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.sequences.any' call
        var _iterator__ex2g4s_0 = tmp0.k();
        while (_iterator__ex2g4s_0.l()) {
          var element = _iterator__ex2g4s_0.m();
          // Inline function 'jetbrains.ocelot.langDef.editor.sideTransform.CompoundSideTransformTrait.collectCompletion.<anonymous>' call
          if (isSignificant_0(element, CompoundSideTransformTrait_getInstance())) {
            tmp$ret$1 = true;
            break $l$block;
          }
        }
        tmp$ret$1 = false;
      }
      if (tmp$ret$1) {
        break $l$loop;
      }
    }
    return result;
  }
  function isSignificant_0(_this__u8e3s4, $this) {
    if (!isVisible_1(_this__u8e3s4))
      return false;
    if (_this__u8e3s4 instanceof TextCell)
      return true;
    var tmp0 = _this__u8e3s4.g2r();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.langDef.editor.sideTransform.CompoundSideTransformTrait.isSignificant.<anonymous>' call
        if (isSignificant_0(element, CompoundSideTransformTrait_getInstance())) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function Side_2(name, ordinal, transformPropertySpec) {
    Enum.call(this, name, ordinal);
    this.gpi_1 = transformPropertySpec;
  }
  protoOf(Side_2).gn0 = function (cell) {
    return generateSequenceFromNext(cell, VOID, CompoundSideTransformTrait$Side$siblingsOf$lambda(this));
  };
  function Side_LEFT_getInstance_1() {
    Side_initEntries_1();
    return Side_LEFT_instance_1;
  }
  function Side_RIGHT_getInstance_1() {
    Side_initEntries_1();
    return Side_RIGHT_instance_1;
  }
  function CompoundSideTransformTrait() {
    CompoundSideTransformTrait_instance = this;
    CellTrait.call(this);
    this.zph_1 = CellTraitPropertySpec_init_$Create$('ownLeftTransform', null);
    this.api_1 = CellTraitPropertySpec_init_$Create$('ownRightTransform', null);
  }
  protoOf(CompoundSideTransformTrait).flo = function (cell, spec) {
    return equals(spec, Completion_getInstance().em1_1) ? collectCompletion(this, cell, Side_RIGHT_getInstance_1()) : equals(spec, Completion_getInstance().dm1_1) ? collectCompletion(this, cell, Side_LEFT_getInstance_1()) : protoOf(CellTrait).flo.call(this, cell, spec);
  };
  var CompoundSideTransformTrait_instance;
  function CompoundSideTransformTrait_getInstance() {
    if (CompoundSideTransformTrait_instance == null)
      new CompoundSideTransformTrait();
    return CompoundSideTransformTrait_instance;
  }
  function LineMapper$lambda(this$0) {
    return function (it) {
      var tmp = this$0.ql9_1.yt();
      var multilineCell = tmp instanceof MultilineTextCell ? tmp : THROW_CCE();
      multilineCell.upi(this$0.ql9_1);
      return Unit_instance;
    };
  }
  function LineMapper$registerSynchronizers$$inlined$writableProperty$1($tmp0_writableProperty_$receiver) {
    this.vpi_1 = $tmp0_writableProperty_$receiver;
  }
  protoOf(LineMapper$registerSynchronizers$$inlined$writableProperty$1).bm7 = function (newValue) {
    // Inline function 'jetbrains.ocelot.langDef.editor.text.LineMapper.registerSynchronizers.stub_for_inlining' call
    this.vpi_1.t2c(newValue);
    return Unit_instance;
  };
  protoOf(LineMapper$registerSynchronizers$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function LineMapper(textSpecification, textStyle, source) {
    Mapper.call(this, source, TextCell_init_$Create$());
    this.dpj_1 = textSpecification.fpj_1.c6q_1(source).n4z();
    this.ql9_1.hlp().t2c(true);
    textStyle(this.ql9_1);
    var tmp = this.ql9_1.zlt();
    tmp.p27(LineMapper$lambda(this));
  }
  protoOf(LineMapper).llb = function (conf) {
    protoOf(Mapper).llb.call(this, conf);
    var tmp0_writableProperty_$receiver = this.ql9_1.laz();
    // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
    var writableProp = new LineMapper$registerSynchronizers$$inlined$writableProperty$1(tmp0_writableProperty_$receiver);
    conf.x4v(syncOneWay(this.dpj_1, writableProp));
  };
  function _get_isNonEmpty__e86o73($this) {
    return $this.hpj_1.kpj($this.gpj_1) > 0;
  }
  function Companion_361() {
  }
  protoOf(Companion_361).lpj = function (a, b) {
    return a.kpj(b) < 0 ? new MultilineSelection(a, b) : new MultilineSelection(b, a);
  };
  var Companion_instance_361;
  function Companion_getInstance_361() {
    return Companion_instance_361;
  }
  function MultilineSelection(start, end) {
    this.gpj_1 = start;
    this.hpj_1 = end;
  }
  protoOf(MultilineSelection).mbm = function () {
    return numberRangeToNumber(this.gpj_1.ipj_1, this.hpj_1.ipj_1);
  };
  protoOf(MultilineSelection).mpj = function () {
    return until(this.gpj_1.ipj_1 + 1 | 0, this.hpj_1.ipj_1);
  };
  protoOf(MultilineSelection).npj = function () {
    return this.gpj_1.ipj_1 === this.hpj_1.ipj_1;
  };
  protoOf(MultilineSelection).opj = function () {
    return _get_isNonEmpty__e86o73(this) ? this : null;
  };
  protoOf(MultilineSelection).ppj = function (model, textNode) {
    if (this.npj()) {
      model.upj(this.gpj_1.ipj_1).m39(this.gpj_1.jpj_1, this.hpj_1.jpj_1 - this.gpj_1.jpj_1 | 0);
    } else {
      var firstLine = model.upj(this.gpj_1.ipj_1);
      firstLine.m39(this.gpj_1.jpj_1, firstLine.m2c().length - this.gpj_1.jpj_1 | 0);
      var lastLineNode = model.vpj(this.hpj_1.ipj_1);
      var lastLine = model.upj(this.hpj_1.ipj_1);
      lastLine.m39(0, this.hpj_1.jpj_1);
      model.wpj(this.mpj());
      model.tpj_1.u6r(textNode, lastLineNode);
    }
    return this.gpj_1;
  };
  protoOf(MultilineSelection).xpj = function (model) {
    var tmp;
    if (this.npj()) {
      var tmp0 = model.upj(this.gpj_1.ipj_1).qr();
      var tmp1 = this.gpj_1.jpj_1;
      // Inline function 'kotlin.text.substring' call
      var endIndex = this.hpj_1.jpj_1;
      // Inline function 'kotlin.js.asDynamic' call
      var string = tmp0.substring(tmp1, endIndex);
      tmp = TextContentHelper_getInstance().vl4(string);
    } else {
      var tmp3 = model.upj(this.gpj_1.ipj_1).qr();
      // Inline function 'kotlin.text.substring' call
      var startIndex = this.gpj_1.jpj_1;
      // Inline function 'kotlin.js.asDynamic' call
      var firstString = tmp3.substring(startIndex);
      var tmp5 = model.upj(this.hpj_1.ipj_1).qr();
      // Inline function 'kotlin.text.substring' call
      var endIndex_0 = this.hpj_1.jpj_1;
      // Inline function 'kotlin.js.asDynamic' call
      var lastString = tmp5.substring(0, endIndex_0);
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.mpj();
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.e1_1;
      var last = this_0.f1_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'jetbrains.ocelot.langDef.editor.text.MultilineSelection.clipboardContent.<anonymous>' call
          var it = item;
          var tmp$ret$6 = model.upj(it).qr();
          destination.e(tmp$ret$6);
        }
         while (!(item === last));
      var innerStrings = destination;
      var allStrings = plus_4(plus_4(listOf(firstString), innerStrings), listOf(lastString));
      tmp = TextContentHelper_getInstance().wl4(allStrings);
    }
    return tmp;
  };
  protoOf(MultilineSelection).toString = function () {
    return 'MultilineSelection(start=' + this.gpj_1.toString() + ', end=' + this.hpj_1.toString() + ')';
  };
  protoOf(MultilineSelection).hashCode = function () {
    var result = this.gpj_1.hashCode();
    result = imul(result, 31) + this.hpj_1.hashCode() | 0;
    return result;
  };
  protoOf(MultilineSelection).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MultilineSelection))
      return false;
    var tmp0_other_with_cast = other instanceof MultilineSelection ? other : THROW_CCE();
    if (!this.gpj_1.equals(tmp0_other_with_cast.gpj_1))
      return false;
    if (!this.hpj_1.equals(tmp0_other_with_cast.hpj_1))
      return false;
    return true;
  };
  function onSelectionChanged($this, event) {
    var tmp0_safe_receiver = event.o2e_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.editor.text.MultilineTextCell.onSelectionChanged.<anonymous>' call
      // Inline function 'kotlin.collections.forEach' call
      var progression = tmp0_safe_receiver.mbm();
      var inductionVariable = progression.e1_1;
      var last = progression.f1_1;
      if (inductionVariable <= last)
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'jetbrains.ocelot.langDef.editor.text.MultilineTextCell.onSelectionChanged.<anonymous>.<anonymous>' call
          var index = element;
          textCell($this, index).nlu().v2c(false);
        }
         while (!(element === last));
    }
    var tmp1_safe_receiver = event.p2e_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.editor.text.MultilineTextCell.onSelectionChanged.<anonymous>' call
      // Inline function 'kotlin.collections.forEach' call
      var progression_0 = tmp1_safe_receiver.mbm();
      var inductionVariable_0 = progression_0.e1_1;
      var last_0 = progression_0.f1_1;
      if (inductionVariable_0 <= last_0)
        do {
          var element_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'jetbrains.ocelot.langDef.editor.text.MultilineTextCell.onSelectionChanged.<anonymous>.<anonymous>' call
          var index_0 = element_0;
          textCell($this, index_0).nlu().v2c(true);
        }
         while (!(element_0 === last_0));
      // Inline function 'kotlin.collections.forEach' call
      var progression_1 = tmp1_safe_receiver.mpj();
      var inductionVariable_1 = progression_1.e1_1;
      var last_1 = progression_1.f1_1;
      if (inductionVariable_1 <= last_1)
        do {
          var element_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          // Inline function 'jetbrains.ocelot.langDef.editor.text.MultilineTextCell.onSelectionChanged.<anonymous>.<anonymous>' call
          var index_1 = element_1;
          selectAllLine($this, index_1);
        }
         while (!(element_1 === last_1));
      if (tmp1_safe_receiver.gpj_1.ipj_1 < tmp1_safe_receiver.hpj_1.ipj_1) {
        selectLineFrom($this, tmp1_safe_receiver.gpj_1.ipj_1, tmp1_safe_receiver.gpj_1.jpj_1);
        selectLineUntil($this, tmp1_safe_receiver.hpj_1.ipj_1, tmp1_safe_receiver.hpj_1.jpj_1);
      } else {
        selectLine($this, tmp1_safe_receiver.gpj_1.ipj_1, tmp1_safe_receiver.gpj_1.jpj_1, tmp1_safe_receiver.hpj_1.jpj_1);
      }
    }
  }
  function selectAllLine($this, line) {
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.langDef.editor.text.MultilineTextCell.selectAllLine.<anonymous>' call
    var $this$with = textCell($this, line);
    $this$with.olu().v2c(0);
    $this$with.plu().v2c($this$with.clu());
    return Unit_instance;
  }
  function selectLineFrom($this, line, position) {
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.langDef.editor.text.MultilineTextCell.selectLineFrom.<anonymous>' call
    var $this$with = textCell($this, line);
    $this$with.olu().v2c(position);
    $this$with.plu().v2c($this$with.clu());
    return Unit_instance;
  }
  function selectLineUntil($this, line, position) {
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.langDef.editor.text.MultilineTextCell.selectLineUntil.<anonymous>' call
    var $this$with = textCell($this, line);
    $this$with.olu().v2c(0);
    $this$with.plu().v2c(position);
    return Unit_instance;
  }
  function selectLine($this, line, from, to) {
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.langDef.editor.text.MultilineTextCell.selectLine.<anonymous>' call
    var $this$with = textCell($this, line);
    $this$with.olu().v2c(from);
    $this$with.plu().v2c(to);
    return Unit_instance;
  }
  function textCell($this, index) {
    var tmp = _get_childrenCells__2b6phd($this).q(index);
    return tmp instanceof TextCell ? tmp : THROW_CCE();
  }
  function runCaretOperation($this, updateCaretRunnable) {
    if (!$this.spi_1) {
      $this.spi_1 = true;
      try {
        updateCaretRunnable();
      }finally {
        $this.spi_1 = false;
      }
    }
  }
  function renderCaret($this, position) {
    if (!(position == null)) {
      var tmp = $this.g2r().q(position.ipj_1);
      var line = tmp instanceof TextCell ? tmp : THROW_CCE();
      line.zlt().t2c(position.jpj_1);
      line.ilu().t2c(true);
      hideCaretExcept($this, line);
    }
  }
  function hideCaretExcept($this, except) {
    var _iterator__ex2g4s = $this.g2r().k();
    while (_iterator__ex2g4s.l()) {
      var line = _iterator__ex2g4s.m();
      if (!(line === except)) {
        (line instanceof TextCell ? line : THROW_CCE()).ilu().t2c(false);
        if (line.qlp().qr()) {
          ensureNotNull(line.llk()).rlp().t2c(null);
        }
      }
    }
  }
  function renderFocus($this, position) {
    if (!(position == null)) {
      var line = _get_childrenCells__2b6phd($this).q(position.ipj_1);
      line.ul5();
    }
  }
  function _get_childrenCells__2b6phd($this) {
    var tmp0 = $this.tpi_1;
    // Inline function 'kotlin.getValue' call
    childrenCells$factory();
    return tmp0.y();
  }
  function lineNumber($this, y) {
    var tmp0 = $this.g2r();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.indexOfFirst' call
      var index = 0;
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var item = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.langDef.editor.text.MultilineTextCell.lineNumber.<anonymous>' call
        if (get_bounds(item).vku().a2t(y)) {
          tmp$ret$1 = index;
          break $l$block;
        }
        index = index + 1 | 0;
      }
      tmp$ret$1 = -1;
    }
    return tmp$ret$1;
  }
  function Companion_362() {
    Companion_instance_362 = this;
    this.ypj_1 = CellPropertySpec_init_$Create$('documentPosition', null);
    this.zpj_1 = CellPropertySpec_init_$Create$('multilineSelection', null);
    this.apk_1 = CellPropertySpec_init_$Create$('multilineSelectionOrigin', null);
  }
  var Companion_instance_362;
  function Companion_getInstance_362() {
    if (Companion_instance_362 == null)
      new Companion_362();
    return Companion_instance_362;
  }
  function MultilineTextCell$lambda$lambda($event, this$0) {
    return function () {
      var newValue = $event.p2e_1;
      renderCaret(this$0, newValue);
      renderFocus(this$0, newValue);
      return Unit_instance;
    };
  }
  function MultilineTextCell$lambda(this$0) {
    return function (event) {
      runCaretOperation(this$0, MultilineTextCell$lambda$lambda(event, this$0));
      return Unit_instance;
    };
  }
  function MultilineTextCell$onSelectionChanged$ref($boundThis) {
    var l = function (p0) {
      onSelectionChanged($boundThis, p0);
      return Unit_instance;
    };
    l.callableName = 'onSelectionChanged';
    return l;
  }
  function MultilineTextCell$synchronizePosition$lambda(this$0, $lineCell) {
    return function () {
      var line = this$0.g2r().t($lineCell);
      var offset = $lineCell.zlt().qr();
      var pos = new Position_0(line, offset);
      this$0.bln(Companion_getInstance_362().ypj_1, pos);
      renderCaret(this$0, pos);
      return Unit_instance;
    };
  }
  function MultilineTextCell$hideCaret$lambda(this$0) {
    return function () {
      hideCaretExcept(this$0, null);
      return Unit_instance;
    };
  }
  function MultilineTextCell$childrenCells$delegate$lambda(this$0) {
    return function () {
      return this$0.g2r();
    };
  }
  function MultilineTextCell() {
    Companion_getInstance_362();
    VerticalCell.call(this);
    this.spi_1 = false;
    var tmp = this.flp(Companion_getInstance_362().ypj_1);
    tmp.p27(MultilineTextCell$lambda(this));
    var tmp_0 = this.flp(Companion_getInstance_362().zpj_1);
    tmp_0.p27(MultilineTextCell$onSelectionChanged$ref(this));
    var tmp_1 = this;
    tmp_1.tpi_1 = lazy_0(MultilineTextCell$childrenCells$delegate$lambda(this));
  }
  protoOf(MultilineTextCell).upi = function (lineCell) {
    runCaretOperation(this, MultilineTextCell$synchronizePosition$lambda(this, lineCell));
  };
  protoOf(MultilineTextCell).bpk = function () {
    runCaretOperation(this, MultilineTextCell$hideCaret$lambda(this));
  };
  protoOf(MultilineTextCell).cpk = function (point) {
    var lineNumber_0 = lineNumber(this, point.fku_1);
    if (lineNumber_0 < 0)
      return null;
    var line = textCell(this, lineNumber_0);
    var lastPos = line.clu();
    // Inline function 'kotlin.math.min' call
    var a = line.slu(point.eku_1 - get_origin_0(line).eku_1 | 0);
    var linePosition = Math.min(a, lastPos);
    var position = new Position_0(lineNumber_0, linePosition);
    this.bln(Companion_getInstance_362().ypj_1, position);
    return position;
  };
  function childrenCells$factory() {
    return getPropertyCallableRef('childrenCells', 1, KProperty1, function (receiver) {
      return _get_childrenCells__2b6phd(receiver);
    }, null);
  }
  function onCopyCut($this, cell, event, isCut) {
    if (!cell.clo(get_SELECTED()))
      return onCopyCut$default(isCut, $this, cell, event);
    var tmp0_elvis_lhs = allText($this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return onCopyCut$default(isCut, $this, cell, event);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var content = tmp;
    event.ul0(content);
    if (isCut) {
      $this.ipk_1.dpk_1.t2c(null);
      toFirstFocusable($this.ipk_1.fpk_1)();
    }
  }
  function allText($this) {
    var strings = $this.hpk_1.jpk();
    return strings.p() ? null : strings.n() === 1 ? TextContentHelper_getInstance().vl4(first(strings)) : TextContentHelper_getInstance().wl4(strings);
  }
  function onCopyCut$default($isCut, this$0, $cell, $event) {
    var tmp;
    if ($isCut) {
      protoOf(CellTrait).ylo.call(this$0, $cell, $event);
      tmp = Unit_instance;
    } else {
      protoOf(CellTrait).xlo.call(this$0, $cell, $event);
      tmp = Unit_instance;
    }
    return tmp;
  }
  function mapperFactory($this, node) {
    var textModel = new TextModel(node, $this.gpk_1.kpk_1, MultilineTextSynchronizerFactory$SynchronizerSetup$mapperFactory$lineFactory$ref($this), $this.gpk_1.opk_1.o6r($this.gpk_1.kpk_1.epj_1, $this.gpk_1.kpk_1.fpj_1));
    // Inline function 'kotlin.apply' call
    var this_0 = new TextMapper(textModel, $this.gpk_1.lpk_1, new TransformablePositionStateTrait($this.gpk_1.mpk_1, $this.gpk_1.kpk_1), $this.gpk_1.ppk_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.text.SynchronizerSetup.mapperFactory.<anonymous>' call
    this_0.ql9_1.olp(new CopyCutOnWholeMultilineTextCell($this, textModel));
    return this_0;
  }
  function _get_completion__ojdpzl_0($this) {
    var tmp = MultilineTextSynchronizerFactory$SynchronizerSetup$_get_completion_$lambda_scdf0d($this);
    return new sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4(tmp);
  }
  function nodeFactory($this, startText) {
    return nodeFactory_0($this, startText == null ? listOf('') : listOf(startText));
  }
  function nodeFactory$default($this, startText, $super) {
    startText = startText === VOID ? null : startText;
    return nodeFactory($this, startText);
  }
  function nodeFactory_0($this, lines) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.check' call
    if (!!lines.p()) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var textNode = createInstance($this.gpk_1.mpk_1, $this.gpk_1.kpk_1.epj_1.x6k_1, $this.gpk_1.npk_1);
    var formattedLines = (new TextFormatter($this.gpk_1.ppk_1)).rpk(lines);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(formattedLines, 10));
    var _iterator__ex2g4s = formattedLines.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editor.text.SynchronizerSetup.nodeFactory.<anonymous>' call
      var tmp$ret$1 = lineFactory($this, item);
      destination.e(tmp$ret$1);
    }
    var lineNodes = destination;
    $this.gpk_1.kpk_1.epj_1.y6k_1(textNode).o(lineNodes);
    return textNode;
  }
  function lineFactory($this, text) {
    // Inline function 'kotlin.also' call
    var this_0 = createInstance($this.gpk_1.mpk_1, $this.gpk_1.kpk_1.fpj_1.b6q_1, $this.gpk_1.npk_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.text.SynchronizerSetup.lineFactory.<anonymous>' call
    if (!(text == null)) {
      $this.gpk_1.kpk_1.fpj_1.c6q_1(this_0).n4z().k39(0, text);
    }
    return this_0;
  }
  function lineFactory$default($this, text, $super) {
    text = text === VOID ? null : text;
    return lineFactory($this, text);
  }
  function MultilinePasteOnPlaceholder($outer) {
    this.spk_1 = $outer;
    CellTrait.call(this);
  }
  protoOf(MultilinePasteOnPlaceholder).zlo = function (cell, event) {
    var content = event.cl4_1;
    if (content.fl0(ContentKinds_getInstance().gl4_1))
      return protoOf(CellTrait).zlo.call(this, cell, event);
    if (content.fl0(ContentKinds_getInstance().hl4_1)) {
      var textNode = nodeFactory_0(this.spk_1, toList_0(content.gl0(ContentKinds_getInstance().hl4_1)));
      this.spk_1.dpk_1.t2c(textNode);
      toFirstFocusable(this.spk_1.fpk_1)();
      event.ol0();
    } else {
      protoOf(CellTrait).zlo.call(this, cell, event);
    }
  };
  function CopyCutOnWholeMultilineTextCell($outer, model) {
    this.ipk_1 = $outer;
    CellTrait.call(this);
    this.hpk_1 = model;
  }
  protoOf(CopyCutOnWholeMultilineTextCell).xlo = function (cell, event) {
    onCopyCut(this, cell, event, false);
  };
  protoOf(CopyCutOnWholeMultilineTextCell).ylo = function (cell, event) {
    onCopyCut(this, cell, event, true);
  };
  function sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4(function_0) {
    this.tpk_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4).gnb = function (mapper, contextNode, target) {
    return this.tpk_1(mapper, contextNode, target);
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4).b4 = function () {
    return this.tpk_1;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, RoleCompletion) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_projectional_editor_generic_roleCompletion_RoleCompletion$0_4).hashCode = function () {
    return hashCode(this.b4());
  };
  function _init_$nodeFactory(receiver) {
    return nodeFactory$default(receiver);
  }
  function mapperFactory$lineFactory(receiver) {
    return lineFactory$default(receiver);
  }
  function MultilineTextSynchronizerFactory$SynchronizerSetup$lambda(this$0) {
    return function (trait) {
      return CompositeCellTraits_instance.emu([new MultilinePasteOnPlaceholder(this$0), trait]);
    };
  }
  function MultilineTextSynchronizerFactory$SynchronizerSetup$mapperFactory$ref($boundThis) {
    var l = function (p0) {
      return mapperFactory($boundThis, p0);
    };
    l.callableName = 'mapperFactory';
    return l;
  }
  function MultilineTextSynchronizerFactory$SynchronizerSetup$nodeFactory$ref($boundThis) {
    return function () {
      return _init_$nodeFactory($boundThis);
    };
  }
  function MultilineTextSynchronizerFactory$SynchronizerSetup$mapperFactory$lineFactory$ref($boundThis) {
    return function () {
      return mapperFactory$lineFactory($boundThis);
    };
  }
  function MultilineTextSynchronizerFactory$SynchronizerSetup$completion$1$1(this$0, $target) {
    this.vpk_1 = this$0;
    this.wpk_1 = $target;
    BaseCompletionItem.call(this);
    this.upk_1 = 'Start typing';
  }
  protoOf(MultilineTextSynchronizerFactory$SynchronizerSetup$completion$1$1).gm7 = function () {
    return this.upk_1;
  };
  protoOf(MultilineTextSynchronizerFactory$SynchronizerSetup$completion$1$1).qma = function (text) {
    return true;
  };
  protoOf(MultilineTextSynchronizerFactory$SynchronizerSetup$completion$1$1).pm7 = function (text) {
    return true;
  };
  protoOf(MultilineTextSynchronizerFactory$SynchronizerSetup$completion$1$1).wm9 = function (text) {
    var textNode = nodeFactory(this.vpk_1, text);
    return this.wpk_1.qn8(textNode);
  };
  function MultilineTextSynchronizerFactory$SynchronizerSetup$_get_completion_$lambda_scdf0d(this$0) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, target) {
      var tmp;
      if (!(this$0.dpk_1.qr() == null)) {
        tmp = get_EMPTY_COMPLETION_SUPPLIER();
      } else {
        var tmp_0 = CompletionSupplement_instance;
        tmp = tmp_0.smc([new MultilineTextSynchronizerFactory$SynchronizerSetup$completion$1$1(this$0, target)]);
      }
      return tmp;
    };
  }
  function SynchronizerSetup($outer, source, placeholder) {
    this.gpk_1 = $outer;
    this.dpk_1 = source;
    this.fpk_1 = CellFactory_instance.umw([]);
    var tmp = new ProjectionalPropertySynchronizerSettings();
    var tmp_0 = tmp.kne(placeholder == null ? '<text>' : placeholder);
    var settings = tmp_0.ine(MultilineTextSynchronizerFactory$SynchronizerSetup$lambda(this));
    var tmp_1 = this;
    var tmp_2 = ProjectionalSynchronizers_getInstance();
    tmp_1.epk_1 = tmp_2.ani(this.dpk_1, this.fpk_1, MultilineTextSynchronizerFactory$SynchronizerSetup$mapperFactory$ref(this), settings);
    var tmp_3 = Companion_instance_316;
    this.epk_1.knb(tmp_3.nnd(MultilineTextSynchronizerFactory$SynchronizerSetup$nodeFactory$ref(this)));
    this.epk_1.bnc(_get_completion__ojdpzl_0(this));
    this.epk_1.lnb(true);
  }
  protoOf(SynchronizerSetup).xpk = function () {
    return to(this.epk_1, this.fpk_1);
  };
  function MultilineTextSynchronizerFactory(textSpecification, textStyle, conceptRegistry, wrapperContext, splitMergeSupportFactory, pasteLineWidth) {
    pasteLineWidth = pasteLineWidth === VOID ? 80 : pasteLineWidth;
    this.kpk_1 = textSpecification;
    this.lpk_1 = textStyle;
    this.mpk_1 = conceptRegistry;
    this.npk_1 = wrapperContext;
    this.opk_1 = splitMergeSupportFactory;
    this.ppk_1 = pasteLineWidth;
  }
  protoOf(MultilineTextSynchronizerFactory).ypk = function (source, placeholder) {
    return (new SynchronizerSetup(this, source, placeholder)).xpk();
  };
  function _get_isInvalid__ofio3g(_this__u8e3s4, $this) {
    return _this__u8e3s4.ipj_1 === -1 && _this__u8e3s4.jpj_1 === -1;
  }
  function getLength($this, model, line) {
    return model.upj(line).qr().length;
  }
  function Companion_363() {
    Companion_instance_363 = this;
    this.zpk_1 = new Position_0(-1, -1);
  }
  var Companion_instance_363;
  function Companion_getInstance_363() {
    if (Companion_instance_363 == null)
      new Companion_363();
    return Companion_instance_363;
  }
  function Position_0(line, offset) {
    Companion_getInstance_363();
    this.ipj_1 = line;
    this.jpj_1 = offset;
    if (!_get_isInvalid__ofio3g(this, Companion_getInstance_363())) {
      // Inline function 'kotlin.require' call
      if (!(this.ipj_1 >= 0)) {
        // Inline function 'jetbrains.ocelot.langDef.editor.text.Position.<anonymous>' call
        var message = 'Line should be non-negative, but was ' + this.ipj_1;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
      // Inline function 'kotlin.require' call
      if (!(this.jpj_1 >= 0)) {
        // Inline function 'jetbrains.ocelot.langDef.editor.text.Position.<anonymous>' call
        var message_0 = 'Offset should be non-negative, but was ' + this.jpj_1;
        throw IllegalArgumentException_init_$Create$_0(toString_1(message_0));
      }
    }
  }
  protoOf(Position_0).apl = function (model) {
    return this.jpj_1 > 0 ? new Position_0(this.ipj_1, this.jpj_1 - 1 | 0) : this.ipj_1 > 0 ? new Position_0(this.ipj_1 - 1 | 0, getLength(this, model, this.ipj_1 - 1 | 0)) : this;
  };
  protoOf(Position_0).bpl = function (model) {
    return this.jpj_1 < getLength(this, model, this.ipj_1) ? new Position_0(this.ipj_1, this.jpj_1 + 1 | 0) : this.ipj_1 < (model.mbm().n() - 1 | 0) ? new Position_0(this.ipj_1 + 1 | 0, 0) : this;
  };
  protoOf(Position_0).cpl = function (model) {
    var tmp;
    if (this.ipj_1 > 0) {
      var tmp_0 = this.ipj_1 - 1 | 0;
      var tmp0 = this.jpj_1;
      // Inline function 'kotlin.math.min' call
      var b = getLength(this, model, this.ipj_1 - 1 | 0);
      var tmp$ret$0 = Math.min(tmp0, b);
      tmp = new Position_0(tmp_0, tmp$ret$0);
    } else {
      tmp = this;
    }
    return tmp;
  };
  protoOf(Position_0).dpl = function (model) {
    var tmp;
    if (this.ipj_1 < (model.mbm().n() - 1 | 0)) {
      var tmp_0 = this.ipj_1 + 1 | 0;
      var tmp0 = this.jpj_1;
      // Inline function 'kotlin.math.min' call
      var b = getLength(this, model, this.ipj_1 + 1 | 0);
      var tmp$ret$0 = Math.min(tmp0, b);
      tmp = new Position_0(tmp_0, tmp$ret$0);
    } else {
      tmp = this;
    }
    return tmp;
  };
  protoOf(Position_0).epl = function (model) {
    return new Position_0(this.ipj_1, 0);
  };
  protoOf(Position_0).fpl = function (model) {
    return new Position_0(this.ipj_1, getLength(this, model, this.ipj_1));
  };
  protoOf(Position_0).gpl = function (model, ch) {
    model.upj(this.ipj_1).k39(this.jpj_1, toString(ch));
    return new Position_0(this.ipj_1, this.jpj_1 + 1 | 0);
  };
  protoOf(Position_0).hpl = function (model) {
    model.tpj_1.s6r(model.qpj_1, this.ipj_1 + 1 | 0, this.jpj_1);
    return new Position_0(this.ipj_1 + 1 | 0, 0);
  };
  protoOf(Position_0).ipl = function (model) {
    if (this.jpj_1 < getLength(this, model, this.ipj_1)) {
      model.upj(this.ipj_1).m39(this.jpj_1, 1);
    } else if (this.ipj_1 < (model.mbm().n() - 1 | 0)) {
      model.tpj_1.u6r(model.qpj_1, model.vpj(this.ipj_1 + 1 | 0));
    }
    return this;
  };
  protoOf(Position_0).jpl = function (model) {
    var tmp;
    if (this.jpj_1 > 0) {
      model.upj(this.ipj_1).m39(this.jpj_1 - 1 | 0, 1);
      tmp = new Position_0(this.ipj_1, this.jpj_1 - 1 | 0);
    } else if (this.ipj_1 > 0) {
      var prevLineLen = getLength(this, model, this.ipj_1 - 1 | 0);
      model.tpj_1.u6r(model.qpj_1, model.vpj(this.ipj_1));
      tmp = new Position_0(this.ipj_1 - 1 | 0, prevLineLen);
    } else {
      tmp = this;
    }
    return tmp;
  };
  protoOf(Position_0).kpj = function (other) {
    var lines = this.ipj_1 - other.ipj_1 | 0;
    return !(lines === 0) ? lines : this.jpj_1 - other.jpj_1 | 0;
  };
  protoOf(Position_0).d = function (other) {
    return this.kpj(other instanceof Position_0 ? other : THROW_CCE());
  };
  protoOf(Position_0).toString = function () {
    return '(' + this.ipj_1 + ', ' + this.jpj_1 + ')';
  };
  protoOf(Position_0).hashCode = function () {
    var result = this.ipj_1;
    result = imul(result, 31) + this.jpj_1 | 0;
    return result;
  };
  protoOf(Position_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Position_0))
      return false;
    var tmp0_other_with_cast = other instanceof Position_0 ? other : THROW_CCE();
    if (!(this.ipj_1 === tmp0_other_with_cast.ipj_1))
      return false;
    if (!(this.jpj_1 === tmp0_other_with_cast.jpj_1))
      return false;
    return true;
  };
  function PositionHandler() {
  }
  protoOf(PositionHandler).kpl = function (cell) {
    return false;
  };
  protoOf(PositionHandler).fmv = function (cell) {
    return this.kpl(cell instanceof MultilineTextCell ? cell : THROW_CCE());
  };
  protoOf(PositionHandler).lpl = function (cell) {
    var pos = cell.clo(Companion_getInstance_362().ypj_1);
    return !(pos == null) ? this.npl(pos) : this.mpl();
  };
  protoOf(PositionHandler).gmv = function (cell) {
    return this.lpl(cell instanceof MultilineTextCell ? cell : THROW_CCE());
  };
  protoOf(PositionHandler).opl = function (cell, state) {
    if (!equals(state, this.mpl())) {
      cell.bln(Companion_getInstance_362().ypj_1, state.ppl_1);
    }
  };
  protoOf(PositionHandler).hmv = function (cell, state) {
    var tmp = cell instanceof MultilineTextCell ? cell : THROW_CCE();
    return this.opl(tmp, state instanceof TextPositionState ? state : THROW_CCE());
  };
  function get_defaultTextPositionStateHandlerTrait() {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
    var propSpec = Companion_getInstance_305().zmt_1;
    return new defaultTextPositionStateHandlerTrait$$inlined$propertyTrait$1(propSpec);
  }
  function SimpleTextPositionHandler() {
    PositionHandler.call(this);
    this.qpl_1 = new TextPositionState(Companion_getInstance_363().zpk_1);
  }
  protoOf(SimpleTextPositionHandler).mpl = function () {
    return this.qpl_1;
  };
  protoOf(SimpleTextPositionHandler).npl = function (position) {
    return new TextPositionState(position);
  };
  function TextPositionState(position) {
    this.ppl_1 = position;
  }
  protoOf(TextPositionState).emv = function (state) {
    return equals(this, state) ? CellStateDifference_EQUAL_getInstance() : CellStateDifference_NAVIGATION_getInstance();
  };
  function defaultTextPositionStateHandlerTrait$$inlined$propertyTrait$1($propSpec) {
    this.rpl_1 = $propSpec;
    CellTrait.call(this);
  }
  protoOf(defaultTextPositionStateHandlerTrait$$inlined$propertyTrait$1).flo = function (cell, spec) {
    var tmp;
    if (spec === this.rpl_1) {
      // Inline function 'jetbrains.ocelot.langDef.editor.text.<get-defaultTextPositionStateHandlerTrait>.stub_for_inlining' call
      tmp = new SimpleTextPositionHandler();
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function TextFormatter$breakLongString$slambda($input, this$0, resultContinuation) {
    this.apm_1 = $input;
    this.bpm_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TextFormatter$breakLongString$slambda).jpm = function ($this$sequence, $completion) {
    var tmp = this.kpm($this$sequence, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(TextFormatter$breakLongString$slambda).oa = function (p1, $completion) {
    return this.jpm(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(TextFormatter$breakLongString$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.dpm_1 = this.apm_1;
            this.epm_1 = this.dpm_1;
            var tmp_1 = this;
            tmp_1.fpm_1 = this.epm_1;
            this.gpm_1 = this.fpm_1;
            this.hpm_1 = 0;
            this.ipm_1 = this.bpm_1.qpk_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.hpm_1 <= (this.gpm_1.length - 1 | 0))) {
              this.y9_1 = 3;
              continue $sm;
            }

            if (this.ipm_1 <= (this.gpm_1.length - 1 | 0)) {
              while (this.ipm_1 > this.hpm_1 && !isWhitespace(charSequenceGet(this.apm_1, this.ipm_1))) {
                this.ipm_1 = this.ipm_1 - 1 | 0;
              }
            }

            if (this.ipm_1 === this.hpm_1) {
              var tmp_2 = this;
              var tmp0 = this.ipm_1 + this.bpm_1.qpk_1 | 0;
              var b = this.gpm_1.length;
              tmp_2.ipm_1 = Math.min(tmp0, b);
              while (this.ipm_1 < this.gpm_1.length && !(charSequenceGet(this.apm_1, this.ipm_1) === _Char___init__impl__6a9atx(32))) {
                this.ipm_1 = this.ipm_1 + 1 | 0;
              }
            }

            this.y9_1 = 2;
            suspendResult = this.cpm_1.lh(substring(this.gpm_1, until(this.hpm_1, this.ipm_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.ipm_1 = this.ipm_1 + 1 | 0;
            this.hpm_1 = this.ipm_1;
            var tmp_3 = this;
            var tmp2 = this.ipm_1 + this.bpm_1.qpk_1 | 0;
            var b_0 = this.gpm_1.length;
            tmp_3.ipm_1 = Math.min(tmp2, b_0);
            this.y9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(TextFormatter$breakLongString$slambda).kpm = function ($this$sequence, completion) {
    var i = new TextFormatter$breakLongString$slambda(this.apm_1, this.bpm_1, completion);
    i.cpm_1 = $this$sequence;
    return i;
  };
  function TextFormatter$breakLongString$slambda_0($input, this$0, resultContinuation) {
    var i = new TextFormatter$breakLongString$slambda($input, this$0, resultContinuation);
    var l = function ($this$sequence, $completion) {
      return i.jpm($this$sequence, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function TextFormatter(lineWidth) {
    this.qpk_1 = lineWidth;
  }
  protoOf(TextFormatter).rpk = function (input) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = input.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editor.text.TextFormatter.breakLongStrings.<anonymous>' call
      var list = this.lpm(element);
      addAll_1(destination, list);
    }
    return destination;
  };
  protoOf(TextFormatter).lpm = function (input) {
    var tmp;
    if (input.length <= this.qpk_1) {
      tmp = listOf(input);
    } else {
      tmp = toList_2(sequence(TextFormatter$breakLongString$slambda_0(input, this, null)));
    }
    return tmp;
  };
  function copyCut($this, cell, event, isCut) {
    var tmp0_elvis_lhs = cell.clo(Companion_getInstance_362().zpj_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var selection = tmp;
    var clipboardContent = selection.xpj($this.ypm_1.tpm_1);
    if (isCut) {
      clearSelection_0(cell, $this);
      cell.bln(Companion_getInstance_362().ypj_1, selection.ppj($this.ypm_1.tpm_1, $this.ypm_1.pl9_1));
    }
    event.ul0(clipboardContent);
    return true;
  }
  function hasKey(_this__u8e3s4, $this, key) {
    return _this__u8e3s4.ml1(key, []) || _this__u8e3s4.ml1(key, [ModifierKey_SHIFT_getInstance()]);
  }
  function hasKeyStroke(_this__u8e3s4, $this, keyStroke) {
    return _this__u8e3s4.ol1([keyStroke]) || _this__u8e3s4.ol1([keyStroke.cl2(ModifierKey_SHIFT_getInstance())]);
  }
  function _get_isSelection__z52rox(_this__u8e3s4, $this) {
    return _this__u8e3s4.tl1(ModifierKey_SHIFT_getInstance());
  }
  function getPosition($this, cell) {
    return ensureNotNull(cell.clo(Companion_getInstance_362().ypj_1));
  }
  function navigation($this, cell, event, action) {
    var caret = getPosition($this, cell);
    var newPosition = action(caret);
    if (newPosition.equals(caret)) {
      if (_get_isSelection__z52rox(event, $this)) {
        clearSelection_0(cell, $this);
      }
    } else {
      cell.bln(Companion_getInstance_362().ypj_1, newPosition);
      if (_get_isSelection__z52rox(event, $this)) {
        updateSelection(cell, $this, caret, newPosition);
      } else {
        clearSelection_0(cell, $this);
      }
      event.ol0();
    }
  }
  function maybeEraseSelectionOr($this, cell, action) {
    var selection = cell.clo(Companion_getInstance_362().zpj_1);
    if (!(selection == null)) {
      clearSelection_0(cell, $this);
      cell.bln(Companion_getInstance_362().ypj_1, selection.ppj($this.ypm_1.tpm_1, $this.ypm_1.pl9_1));
    } else {
      var caret = getPosition($this, cell);
      cell.bln(Companion_getInstance_362().ypj_1, action(caret));
    }
  }
  function maybeEraseSelectionAndThen($this, cell, action) {
    var selection = cell.clo(Companion_getInstance_362().zpj_1);
    var tmp;
    if (!(selection == null)) {
      clearSelection_0(cell, $this);
      tmp = selection.ppj($this.ypm_1.tpm_1, $this.ypm_1.pl9_1);
    } else {
      tmp = getPosition($this, cell);
    }
    var caret = tmp;
    cell.bln(Companion_getInstance_362().ypj_1, action(caret));
  }
  function updateSelection(_this__u8e3s4, $this, previousCaret, to) {
    var tmp0_elvis_lhs = _this__u8e3s4.clo(Companion_getInstance_362().apk_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'jetbrains.ocelot.langDef.editor.text.TextCellTrait.updateSelection.<anonymous>' call
      _this__u8e3s4.bln(Companion_getInstance_362().apk_1, previousCaret);
      tmp = previousCaret;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var origin = tmp;
    _this__u8e3s4.bln(Companion_getInstance_362().zpj_1, Companion_instance_361.lpj(origin, to).opj());
  }
  function clearSelection_0(_this__u8e3s4, $this) {
    _this__u8e3s4.bln(Companion_getInstance_362().zpj_1, null);
    _this__u8e3s4.bln(Companion_getInstance_362().apk_1, null);
  }
  function TextMapper$TextCellTrait$onKeyPressed$lambda(this$0) {
    return function (it) {
      return it.cpl(this$0.tpm_1);
    };
  }
  function TextMapper$TextCellTrait$onKeyPressed$lambda_0(this$0) {
    return function (it) {
      return it.dpl(this$0.tpm_1);
    };
  }
  function TextMapper$TextCellTrait$onKeyPressed$lambda_1(this$0) {
    return function (it) {
      return it.apl(this$0.tpm_1);
    };
  }
  function TextMapper$TextCellTrait$onKeyPressed$lambda_2(this$0) {
    return function (it) {
      return it.bpl(this$0.tpm_1);
    };
  }
  function TextMapper$TextCellTrait$onKeyPressed$lambda_3(this$0) {
    return function (it) {
      return it.epl(this$0.tpm_1);
    };
  }
  function TextMapper$TextCellTrait$onKeyPressed$lambda_4(this$0) {
    return function (it) {
      return it.fpl(this$0.tpm_1);
    };
  }
  function TextMapper$TextCellTrait$onKeyPressed$lambda_5(this$0) {
    return function (it) {
      return it.ipl(this$0.tpm_1);
    };
  }
  function TextMapper$TextCellTrait$onKeyPressed$lambda_6(this$0) {
    return function (it) {
      return it.jpl(this$0.tpm_1);
    };
  }
  function TextMapper$TextCellTrait$onKeyPressed$lambda_7(this$0) {
    return function (it) {
      return it.hpl(this$0.tpm_1);
    };
  }
  function TextMapper$TextCellTrait$onKeyTyped$lambda(this$0, $event) {
    return function (it) {
      return it.gpl(this$0.tpm_1, $event.jl1_1);
    };
  }
  function TextMapper$TextCellTrait$onPaste$lambda(this$0, $content, $event) {
    return function (position) {
      this$0.tpm_1.zpm(this$0.wpm_1.rpk($content.gl0(ContentKinds_getInstance().hl4_1)), position);
      $event.ol0();
      return position;
    };
  }
  function TextMapper$TextCellTrait$onPaste$lambda_0($content, this$0, $event) {
    return function (position) {
      var text = $content.gl0(ContentKinds_getInstance().gl4_1);
      var tmp;
      if (text.length <= this$0.vpm_1) {
        this$0.tpm_1.apn($content.gl0(ContentKinds_getInstance().gl4_1), position);
        tmp = Unit_instance;
      } else {
        var splitStrings = this$0.wpm_1.lpm(text);
        this$0.tpm_1.zpm(splitStrings, position);
        tmp = Unit_instance;
      }
      $event.ol0();
      return position;
    };
  }
  function TextCellTrait($outer) {
    this.ypm_1 = $outer;
    CellTrait.call(this);
    this.xpm_1 = null;
  }
  protoOf(TextCellTrait).llm = function (cell, event) {
    if (hasKey(event, this, Key_UP_getInstance())) {
      navigation(this, cell, event, TextMapper$TextCellTrait$onKeyPressed$lambda(this.ypm_1));
    } else if (hasKey(event, this, Key_DOWN_getInstance())) {
      navigation(this, cell, event, TextMapper$TextCellTrait$onKeyPressed$lambda_0(this.ypm_1));
    } else if (hasKey(event, this, Key_LEFT_getInstance())) {
      navigation(this, cell, event, TextMapper$TextCellTrait$onKeyPressed$lambda_1(this.ypm_1));
    } else if (hasKey(event, this, Key_RIGHT_getInstance())) {
      navigation(this, cell, event, TextMapper$TextCellTrait$onKeyPressed$lambda_2(this.ypm_1));
    } else if (hasKeyStroke(event, this, KeyStrokeSpecs_getInstance().ll2_1)) {
      navigation(this, cell, event, TextMapper$TextCellTrait$onKeyPressed$lambda_3(this.ypm_1));
    } else if (hasKeyStroke(event, this, KeyStrokeSpecs_getInstance().ml2_1)) {
      navigation(this, cell, event, TextMapper$TextCellTrait$onKeyPressed$lambda_4(this.ypm_1));
    } else if (event.ml1(Key_DELETE_getInstance(), [])) {
      if (!this.ypm_1.tpm_1.np()) {
        maybeEraseSelectionOr(this, cell, TextMapper$TextCellTrait$onKeyPressed$lambda_5(this.ypm_1));
        event.ol0();
      }
    } else if (event.ml1(Key_BACKSPACE_getInstance(), [])) {
      if (!this.ypm_1.tpm_1.np()) {
        maybeEraseSelectionOr(this, cell, TextMapper$TextCellTrait$onKeyPressed$lambda_6(this.ypm_1));
        event.ol0();
      }
    } else if (event.ml1(Key_ENTER_getInstance(), [])) {
      maybeEraseSelectionAndThen(this, cell, TextMapper$TextCellTrait$onKeyPressed$lambda_7(this.ypm_1));
      event.ol0();
    }
  };
  protoOf(TextCellTrait).jll = function (cell, event) {
    maybeEraseSelectionAndThen(this, cell, TextMapper$TextCellTrait$onKeyTyped$lambda(this.ypm_1, event));
    event.ol0();
  };
  protoOf(TextCellTrait).llo = function (cell, event) {
    // Inline function 'kotlin.check' call
    if (!(cell instanceof MultilineTextCell)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var oldPosition = cell.clo(Companion_getInstance_362().ypj_1);
    this.xpm_1 = cell.cpk(new Vector(event.xl3_1, event.yl3_1));
    if (event.ul3_1.zl1_1) {
      var position = getPosition(this, cell);
      var old = equals(oldPosition, Companion_getInstance_363().zpk_1) || oldPosition == null ? new Position_0(0, 0) : oldPosition;
      updateSelection(cell, this, old, position);
    } else {
      clearSelection_0(cell, this);
    }
    event.ol0();
  };
  protoOf(TextCellTrait).mlo = function (cell, event) {
    this.xpm_1 = null;
  };
  protoOf(TextCellTrait).olo = function (cell, event) {
    // Inline function 'kotlin.check' call
    if (!(cell instanceof MultilineTextCell)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    if (!(this.xpm_1 == null)) {
      var currPosition = cell.cpk(new Vector(event.xl3_1, event.yl3_1));
      if (!(currPosition == null)) {
        updateSelection(cell, this, ensureNotNull(this.xpm_1), currPosition);
        event.ol0();
        return Unit_instance;
      }
    }
    protoOf(CellTrait).olo.call(this, cell, event);
  };
  protoOf(TextCellTrait).zlo = function (cell, event) {
    var content = event.cl4_1;
    if (content.fl0(ContentKinds_getInstance().hl4_1)) {
      maybeEraseSelectionAndThen(this, cell, TextMapper$TextCellTrait$onPaste$lambda(this.ypm_1, content, event));
    } else if (content.fl0(ContentKinds_getInstance().gl4_1)) {
      maybeEraseSelectionAndThen(this, cell, TextMapper$TextCellTrait$onPaste$lambda_0(content, this.ypm_1, event));
    } else
      return protoOf(CellTrait).zlo.call(this, cell, event);
  };
  protoOf(TextCellTrait).xlo = function (cell, event) {
    if (!copyCut(this, cell, event, false)) {
      protoOf(CellTrait).xlo.call(this, cell, event);
    }
  };
  protoOf(TextCellTrait).ylo = function (cell, event) {
    if (!copyCut(this, cell, event, true)) {
      protoOf(CellTrait).ylo.call(this, cell, event);
    }
  };
  protoOf(TextCellTrait).hlo = function (cell, event) {
    // Inline function 'kotlin.check' call
    if (!(cell instanceof MultilineTextCell)) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    var tmp = event.cmh_1;
    cell.upi(tmp instanceof TextCell ? tmp : THROW_CCE());
  };
  protoOf(TextCellTrait).ilo = function (cell, event) {
    if (!(event.cmh_1 == null) && !contains_5(this.ypm_1.ql9_1.g2r(), event.cmh_1)) {
      this.xpm_1 = null;
      // Inline function 'kotlin.check' call
      if (!(cell instanceof MultilineTextCell)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      clearSelection_0(cell, this);
      cell.bpk();
    }
  };
  function TextMapper$registerSynchronizers$lambda(this$0) {
    return function (it) {
      return new LineMapper(this$0.tpm_1.rpj_1, this$0.upm_1, it);
    };
  }
  function TextMapper(model, textStyle, cellStateHandlerTrait, pasteLineWidth) {
    cellStateHandlerTrait = cellStateHandlerTrait === VOID ? get_defaultTextPositionStateHandlerTrait() : cellStateHandlerTrait;
    Mapper.call(this, model.qpj_1, new MultilineTextCell());
    this.tpm_1 = model;
    this.upm_1 = textStyle;
    this.vpm_1 = pasteLineWidth;
    this.ql9_1.olp(CompositeCellTraits_instance.emu([new TextCellTrait(this), cellStateHandlerTrait]));
    this.wpm_1 = new TextFormatter(this.vpm_1);
  }
  protoOf(TextMapper).llb = function (conf) {
    protoOf(Mapper).llb.call(this, conf);
    var tmp = Synchronizers_instance;
    var tmp_0 = this.tpm_1.rpj_1.epj_1.y6k_1(this.pl9_1).n4z();
    var tmp_1 = this.ql9_1.g2r();
    conf.x4v(tmp.nle(tmp_0, tmp_1, TextMapper$registerSynchronizers$lambda(this)));
  };
  function _get_mutableLines__1k6msy($this) {
    return $this.rpj_1.epj_1.y6k_1($this.qpj_1).n4z();
  }
  function lineText($this, line) {
    return $this.rpj_1.fpj_1.c6q_1(line).n4z();
  }
  function TextModel(node, specification, lineFactory, splitMergeSupport) {
    this.qpj_1 = node;
    this.rpj_1 = specification;
    this.spj_1 = lineFactory;
    this.tpj_1 = splitMergeSupport;
  }
  protoOf(TextModel).mbm = function () {
    return _get_mutableLines__1k6msy(this);
  };
  protoOf(TextModel).vpj = function (index) {
    return this.mbm().q(index);
  };
  protoOf(TextModel).upj = function (index) {
    return lineText(this, this.vpj(index));
  };
  protoOf(TextModel).jpk = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.mbm();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editor.text.TextModel.lineStrings.<anonymous>' call
      var tmp$ret$0 = lineText(this, item).qr();
      destination.e(tmp$ret$0);
    }
    return destination;
  };
  protoOf(TextModel).np = function () {
    var tmp;
    if (this.mbm().p()) {
      tmp = true;
    } else {
      var tmp_0;
      if (this.mbm().n() === 1) {
        // Inline function 'kotlin.text.isEmpty' call
        var this_0 = this.upj(0).qr();
        tmp_0 = charSequenceLength(this_0) === 0;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(TextModel).apn = function (string, position) {
    this.upj(position.ipj_1).k39(position.jpj_1, string);
  };
  protoOf(TextModel).zpm = function (strings, position) {
    var list = toList_0(strings);
    if (list.p())
      return Unit_instance;
    var startLine = this.upj(position.ipj_1);
    var tmp0 = startLine.qr();
    // Inline function 'kotlin.text.substring' call
    var startIndex = position.jpj_1;
    // Inline function 'kotlin.js.asDynamic' call
    var tailToCarryOver = tmp0.substring(startIndex);
    startLine.m39(position.jpj_1, tailToCarryOver.length);
    this.apn(first(list), position);
    // Inline function 'kotlin.collections.map' call
    var this_0 = drop(list, 1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editor.text.TextModel.insertMultipleLines.<anonymous>' call
      var newLine = this.spj_1();
      lineText(this, newLine).k39(0, item);
      destination.e(newLine);
    }
    var newLines = destination;
    _get_mutableLines__1k6msy(this).n2(position.ipj_1 + 1 | 0, newLines);
    var lastAdded = this.upj(position.ipj_1 + newLines.n() | 0);
    lastAdded.k39(lastAdded.qr().length, tailToCarryOver);
  };
  protoOf(TextModel).wpj = function (range) {
    if (range.p())
      return Unit_instance;
    // Inline function 'kotlin.collections.forEach' call
    var progression = reversed_0(range);
    var inductionVariable = progression.e1_1;
    var last = progression.f1_1;
    var step = progression.g1_1;
    if (step > 0 && inductionVariable <= last || (step < 0 && last <= inductionVariable))
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + step | 0;
        // Inline function 'jetbrains.ocelot.langDef.editor.text.TextModel.removeLines.<anonymous>' call
        var it = element;
        _get_mutableLines__1k6msy(this).q2(it);
      }
       while (!(element === last));
  };
  protoOf(TextModel).toString = function () {
    return 'TextModel(node=' + toString_1(this.qpj_1) + ', specification=' + this.rpj_1.toString() + ', lineFactory=' + toString_1(this.spj_1) + ', splitMergeSupport=' + toString_1(this.tpj_1) + ')';
  };
  protoOf(TextModel).hashCode = function () {
    var result = hashCode(this.qpj_1);
    result = imul(result, 31) + this.rpj_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.spj_1) | 0;
    result = imul(result, 31) + hashCode(this.tpj_1) | 0;
    return result;
  };
  protoOf(TextModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextModel))
      return false;
    var tmp0_other_with_cast = other instanceof TextModel ? other : THROW_CCE();
    if (!equals(this.qpj_1, tmp0_other_with_cast.qpj_1))
      return false;
    if (!this.rpj_1.equals(tmp0_other_with_cast.rpj_1))
      return false;
    if (!equals(this.spj_1, tmp0_other_with_cast.spj_1))
      return false;
    if (!equals(this.tpj_1, tmp0_other_with_cast.tpj_1))
      return false;
    return true;
  };
  function TransformablePositionStateTrait(conceptRegistry, textSpecification) {
    CellTrait.call(this);
    this.bpn_1 = new TransformableTextPositionStateHandler(conceptRegistry, textSpecification);
  }
  protoOf(TransformablePositionStateTrait).flo = function (cell, spec) {
    return equals(spec, Companion_getInstance_305().zmt_1) ? this.bpn_1 : equals(spec, Companion_getInstance_349().pow()) ? true : protoOf(CellTrait).flo.call(this, cell, spec);
  };
  function doTransformThrough(_this__u8e3s4, $this, lineOp) {
    var tmp;
    if (lineOp.t3j()) {
      tmp = _this__u8e3s4;
    } else {
      if (lineOp instanceof ChangeChildOperation_0) {
        if (!(lineOp.h3b() === _this__u8e3s4.ipj_1)) {
          return _this__u8e3s4;
        }
        var operation = lineOp.u3l();
        var tmp_0;
        var tmp_1;
        if (operation instanceof ChangePropertyOperation) {
          tmp_1 = operation.h3b().equals($this.gpn_1.dpn_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          var textOp = operation.u3l();
          var tmp_2;
          var tmp_3;
          if (textOp instanceof InsertTextOperation) {
            tmp_3 = textOp.i3b() <= _this__u8e3s4.jpj_1;
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp_2 = new Position_0(_this__u8e3s4.ipj_1, _this__u8e3s4.jpj_1 + textOp.a() | 0);
          } else {
            var tmp_4;
            if (textOp instanceof DeleteTextOperation) {
              tmp_4 = textOp.i3b() < _this__u8e3s4.jpj_1;
            } else {
              tmp_4 = false;
            }
            if (tmp_4) {
              tmp_2 = new Position_0(_this__u8e3s4.ipj_1, _this__u8e3s4.jpj_1 - textOp.a() | 0);
            } else {
              return null;
            }
          }
          tmp_0 = tmp_2;
        } else {
          return null;
        }
        tmp = tmp_0;
      } else {
        if (lineOp instanceof AddChildSplitPropertyOperation) {
          var tmp_5;
          if (lineOp.p3n_1 <= _this__u8e3s4.ipj_1) {
            tmp_5 = new Position_0(_this__u8e3s4.ipj_1 + 1 | 0, _this__u8e3s4.jpj_1);
          } else if ((lineOp.p3n_1 - 1 | 0) === _this__u8e3s4.ipj_1 && lineOp.q3n_1 < _this__u8e3s4.jpj_1) {
            tmp_5 = new Position_0(_this__u8e3s4.ipj_1 + 1 | 0, _this__u8e3s4.jpj_1 - lineOp.q3n_1 | 0);
          } else {
            tmp_5 = _this__u8e3s4;
          }
          tmp = tmp_5;
        } else {
          if (lineOp instanceof MergePropertyRemoveChildOperation) {
            var removeIndex = lineOp.w3m_1;
            tmp = removeIndex < _this__u8e3s4.ipj_1 ? new Position_0(_this__u8e3s4.ipj_1 - 1 | 0, _this__u8e3s4.jpj_1) : removeIndex === _this__u8e3s4.ipj_1 ? new Position_0(_this__u8e3s4.ipj_1 - 1 | 0, lineOp.x3m_1 + _this__u8e3s4.jpj_1 | 0) : _this__u8e3s4;
          } else {
            if (lineOp instanceof CompositeOperation) {
              var compositeOperation = lineOp instanceof CompositeOperation ? lineOp : THROW_CCE();
              var lineOps = compositeOperation.l3i();
              var transformed = _this__u8e3s4;
              var _iterator__ex2g4s = lineOps.k();
              while (_iterator__ex2g4s.l()) {
                var op = _iterator__ex2g4s.m();
                var tmp0_elvis_lhs = doTransformThrough(transformed, $this, op);
                transformed = tmp0_elvis_lhs == null ? transformed : tmp0_elvis_lhs;
              }
              tmp = transformed;
            } else {
              return null;
            }
          }
        }
      }
    }
    return tmp;
  }
  function role(_this__u8e3s4, $this, conceptRegistry) {
    return conceptRegistry.z6o(_this__u8e3s4.epj_1.x6k_1).l6q(_this__u8e3s4.epj_1);
  }
  function property(_this__u8e3s4, $this, conceptRegistry) {
    return conceptRegistry.z6o(_this__u8e3s4.fpj_1.b6q_1).m6q(_this__u8e3s4.fpj_1);
  }
  function TransformableTextPositionState($outer, position) {
    this.gpn_1 = $outer;
    TextPositionState.call(this, position);
  }
  protoOf(TransformableTextPositionState).aov = function (op) {
    var tmp;
    if (equals(this, this.gpn_1.epn_1)) {
      tmp = this.gpn_1.epn_1;
    } else {
      var tmp_0;
      if (op instanceof ChildListOperation) {
        tmp_0 = this.gpn_1.cpn_1.equals(op.h3b());
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var tmp0_safe_receiver = doTransformThrough(this.ppl_1, this, op.u3l());
        var tmp_1;
        if (tmp0_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'jetbrains.ocelot.langDef.editor.text.TransformableTextPositionState.transformThrough.<anonymous>' call
          tmp_1 = new TransformableTextPositionState(this.gpn_1, tmp0_safe_receiver);
        }
        tmp = tmp_1;
      } else {
        throw UnsupportedOperationException_init_$Create$_0(toString_1(op));
      }
    }
    return tmp;
  };
  function Companion_364() {
  }
  var Companion_instance_364;
  function Companion_getInstance_364() {
    return Companion_instance_364;
  }
  function TransformableTextPositionStateHandler(conceptRegistry, textSpecification) {
    PositionHandler.call(this);
    var tmp = this;
    var tmp0 = role(textSpecification, Companion_instance_364, conceptRegistry);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'jetbrains.ocelot.langDef.editor.text.TransformableTextPositionStateHandler.linesOtRole.<anonymous>' call
        var message = 'No OT specifics data found for link ' + textSpecification.epj_1.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    tmp.cpn_1 = tmp$ret$1;
    var tmp_0 = this;
    var tmp0_0 = property(textSpecification, Companion_instance_364, conceptRegistry);
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0_0 == null) {
        // Inline function 'jetbrains.ocelot.langDef.editor.text.TransformableTextPositionStateHandler.textPropertyId.<anonymous>' call
        var message_0 = 'No OT specifics data found for link ' + textSpecification.fpj_1.toString();
        throw IllegalStateException_init_$Create$_0(toString_1(message_0));
      } else {
        tmp$ret$3 = tmp0_0;
        break $l$block_0;
      }
    }
    tmp_0.dpn_1 = tmp$ret$3;
    this.epn_1 = new TransformableTextPositionState(this, Companion_getInstance_363().zpk_1);
  }
  protoOf(TransformableTextPositionStateHandler).mpl = function () {
    return this.epn_1;
  };
  protoOf(TransformableTextPositionStateHandler).npl = function (position) {
    return new TransformableTextPositionState(this, position);
  };
  function children_1(_this__u8e3s4, builder, role) {
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.langDef.editor.children.<anonymous>' call
    var tmp = builder.ipn_1;
    var tmp_0 = builder.kpn_1;
    return indentChildren(_this__u8e3s4, role, builder.hpn_1, tmp, tmp_0, children$lambda_0(builder));
  }
  function ChildBuilder$separated$lambda($value) {
    return function (it) {
      return CellLists_instance.bmy(it, $value);
    };
  }
  function ChildBuilder$newLineSeparated$lambda(it) {
    return CellLists_instance.cmy(it);
  }
  function ChildBuilder(mapperBuilder) {
    this.hpn_1 = mapperBuilder;
    this.ipn_1 = null;
    this.jpn_1 = null;
    this.kpn_1 = null;
    this.lpn_1 = null;
    this.mpn_1 = null;
    this.npn_1 = null;
  }
  protoOf(ChildBuilder).opn = function (factory) {
    this.lpn_1 = factory;
  };
  protoOf(ChildBuilder).ppn = function (value) {
    this.ipn_1 = value;
  };
  protoOf(ChildBuilder).qpn = function (factory) {
    this.jpn_1 = factory;
  };
  protoOf(ChildBuilder).rpn = function (value) {
    var tmp = this;
    tmp.kpn_1 = ChildBuilder$separated$lambda(value);
  };
  protoOf(ChildBuilder).spn = function () {
    var tmp = this;
    tmp.kpn_1 = ChildBuilder$newLineSeparated$lambda;
  };
  protoOf(ChildBuilder).tpn = function (contendKindName, cloner) {
    this.mpn_1 = contendKindName;
    this.npn_1 = cloner;
  };
  protoOf(ChildBuilder).o30 = function () {
    // Inline function 'kotlin.let' call
    // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.copy.<anonymous>' call
    var it = new ChildBuilder(this.hpn_1);
    it.ipn_1 = this.ipn_1;
    it.jpn_1 = this.jpn_1;
    it.kpn_1 = this.kpn_1;
    it.lpn_1 = this.lpn_1;
    return it;
  };
  function child_0(_this__u8e3s4, builder, role) {
    // Inline function 'kotlin.with' call
    // Inline function 'jetbrains.ocelot.langDef.editor.child.<anonymous>' call
    var tmp = builder.ipn_1;
    return indentChild(_this__u8e3s4, role, builder.hpn_1, tmp, child$lambda_0(builder));
  }
  function children$lambda_0($$this$with) {
    return function ($this$indentChildren) {
      var tmp0_safe_receiver = $$this$with.lpn_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'jetbrains.ocelot.langDef.editor.children.<anonymous>.<anonymous>.<anonymous>' call
        $this$indentChildren.nph(tmp0_safe_receiver);
      }
      var tmp1_safe_receiver = $$this$with.jpn_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'jetbrains.ocelot.langDef.editor.children.<anonymous>.<anonymous>.<anonymous>' call
        defaultItem($this$indentChildren, tmp1_safe_receiver);
      }
      var tmp;
      if (!($$this$with.mpn_1 == null)) {
        var contentKind = ContentKinds_getInstance().il4(ensureNotNull($$this$with.mpn_1));
        $this$indentChildren.oph(contentKind, ensureNotNull($$this$with.npn_1));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function child$lambda_0($$this$with) {
    return function ($this$indentChild) {
      var tmp0_safe_receiver = $$this$with.lpn_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'jetbrains.ocelot.langDef.editor.child.<anonymous>.<anonymous>.<anonymous>' call
        $this$indentChild.nph(tmp0_safe_receiver);
      }
      var tmp1_safe_receiver = $$this$with.jpn_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'jetbrains.ocelot.langDef.editor.child.<anonymous>.<anonymous>.<anonymous>' call
        defaultItem($this$indentChild, tmp1_safe_receiver);
      }
      return Unit_instance;
    };
  }
  function bigDecimalValidator(string) {
    return !(toBigDecimalOrNull(string) == null);
  }
  function toBigDecimalOrNull(_this__u8e3s4) {
    var tmp;
    try {
      var tmp_0;
      if (contains_9(_this__u8e3s4, 'e', true)) {
        tmp_0 = null;
      } else {
        tmp_0 = Companion_getInstance_77().r55(_this__u8e3s4);
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof ArithmeticException) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        if ($p instanceof NumberFormatException) {
          var _unused_var__etf5q3_0 = $p;
          tmp_1 = null;
        } else {
          if ($p instanceof IndexOutOfBoundsException) {
            var _unused_var__etf5q3_1 = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
        }
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function decimalProperty_0(textCell) {
    var tmp = TextEditing_getInstance();
    textCell.olp(tmp.gmu(bigDecimalValidator$ref_0()));
    var textProp = textCell.laz();
    var sToT = decimalProperty$safeToDecimal$ref();
    var tToS = decimalProperty$lambda_0;
    return map_1(textProp, sToT, tToS);
  }
  function decimalProperty$safeToDecimal(_this__u8e3s4) {
    var tmp0_elvis_lhs = toBigDecimalOrNull(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? Companion_getInstance_77().j54_1 : tmp0_elvis_lhs;
  }
  function bigDecimalValidator$ref_0() {
    var l = function (p0) {
      return bigDecimalValidator(p0);
    };
    l.callableName = 'bigDecimalValidator';
    return l;
  }
  function decimalProperty$safeToDecimal$ref() {
    var l = function (p0) {
      return decimalProperty$safeToDecimal(p0);
    };
    l.callableName = 'safeToDecimal';
    return l;
  }
  function decimalProperty$lambda_0(num) {
    return num.s56();
  }
  function keyword_0(_this__u8e3s4, text, init) {
    var tmp;
    if (init === VOID) {
      tmp = keyword$lambda_0;
    } else {
      tmp = init;
    }
    init = tmp;
    var cell = CellFactory_instance.bmx(text);
    return addDecoratedCell(_this__u8e3s4, cell, init);
  }
  function space_0(_this__u8e3s4) {
    var cell = CellFactory_instance.dmx();
    return addNoDecorationChildCell(_this__u8e3s4, cell);
  }
  function newLine_0(_this__u8e3s4) {
    var cell = CellFactory_instance.elj();
    return addNoDecorationChildCell(_this__u8e3s4, cell);
  }
  function indent_0(_this__u8e3s4, isIndented, indentNumSpaces, init) {
    isIndented = isIndented === VOID ? false : isIndented;
    indentNumSpaces = indentNumSpaces === VOID ? _this__u8e3s4.upn().vpn() : indentNumSpaces;
    var cell = new IndentCell(isIndented, indentNumSpaces);
    return addDecoratedCell(_this__u8e3s4, cell, init);
  }
  function label_0(_this__u8e3s4, text, firstAllowed, lastAllowed, init) {
    firstAllowed = firstAllowed === VOID ? true : firstAllowed;
    lastAllowed = lastAllowed === VOID ? true : lastAllowed;
    var tmp;
    if (init === VOID) {
      tmp = label$lambda_0;
    } else {
      tmp = init;
    }
    init = tmp;
    var cell = CellFactory_instance.amx(text, firstAllowed, lastAllowed);
    cell.olp(CompoundSideTransformTrait_getInstance());
    return addDecoratedCell(_this__u8e3s4, cell, init);
  }
  function horizontal_0(_this__u8e3s4, init) {
    var cell = new HorizontalCell();
    return addDecoratedCell(_this__u8e3s4, cell, init);
  }
  function addDecoratedCell(_this__u8e3s4, cell, init) {
    addChildEditorBuilder(_this__u8e3s4, cell, init);
    return cell;
  }
  function addNoDecorationChildCell(_this__u8e3s4, cell) {
    var editorBuilder = asInternalEditorBuilder(_this__u8e3s4);
    editorBuilder.wpn(cell);
    return cell;
  }
  function addChildEditorBuilder(_this__u8e3s4, cell, init) {
    var editorBuilder = asInternalEditorBuilder(_this__u8e3s4);
    var childEditorBuilder = editorBuilder.xpn(cell);
    init(childEditorBuilder);
    editorBuilder.wpn(cell);
  }
  function vertical(_this__u8e3s4, init) {
    var cell = new VerticalCell();
    return addDecoratedCell(_this__u8e3s4, cell, init);
  }
  function textCell_0(_this__u8e3s4, text, init) {
    var tmp;
    if (init === VOID) {
      tmp = textCell$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    var cell = TextCell_init_$Create$_0(text);
    cell.olp(CompoundSideTransformTrait_getInstance());
    cell.olp(LeafCellTrackingTrait_getInstance());
    return addDecoratedCell(_this__u8e3s4, cell, init);
  }
  function placeholder_2(_this__u8e3s4, text, textCell, init) {
    var tmp;
    if (init === VOID) {
      tmp = placeholder$lambda;
    } else {
      tmp = init;
    }
    init = tmp;
    var cell = placeholder(textCell, text);
    cell.olp(LeafCellTrackingTrait_getInstance());
    return addDecoratedCell(_this__u8e3s4, cell, init);
  }
  function keyword$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function label$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function textCell$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function placeholder$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function indentLabel_0(_this__u8e3s4, text, allowLast) {
    allowLast = allowLast === VOID ? false : allowLast;
    return textCell_0(_this__u8e3s4, text, indentLabel$lambda_0(text, allowLast));
  }
  function ensureLastCaretPosition(_this__u8e3s4) {
    _this__u8e3s4.ypn().olp(LastCaretPositionSupport_getInstance());
  }
  function placeholderInCollection_0(_this__u8e3s4, text, collectionItemCompletion) {
    text = text === VOID ? '' : text;
    var tmp = isEmpty$ref_1();
    // Inline function 'kotlin.apply' call
    var this_0 = editableText_0(_this__u8e3s4, VOID, text, tmp, VOID, placeholderInCollection$lambda_0(collectionItemCompletion));
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.placeholderInCollection.<anonymous>' call
    this_0.olp(LeafCellTrackingTrait_getInstance());
    return this_0;
  }
  function considerEmptyBy(_this__u8e3s4, cell) {
    cell.olp(new considerEmptyBy$1(_this__u8e3s4));
  }
  function deleteIfEmpty(_this__u8e3s4) {
    _this__u8e3s4.ypn().ylp(ProjectionalSynchronizers_getInstance().llw_1, true);
  }
  function rightTransform_0(_this__u8e3s4, init) {
    return rightTransform_1(_this__u8e3s4, _this__u8e3s4.ypn(), init);
  }
  function rightTransform_1(_this__u8e3s4, cell, init) {
    return addTraitOnAttach_1(_this__u8e3s4, cell, rightTransform$lambda_0(_this__u8e3s4, cell, init));
  }
  function decimalProperty_1(_this__u8e3s4, placeholder, property) {
    var tmp = bigDecimalValidator$ref_1();
    return editableText_0(_this__u8e3s4, VOID, placeholder, tmp, VOID, decimalProperty$lambda_1(property));
  }
  function image(_this__u8e3s4, imageData) {
    var imageCell = new ImageCell();
    PropertyBinding_instance.d2g(imageData, imageCell.omh());
    asInternalEditorBuilder(_this__u8e3s4).wpn(imageCell);
    return imageCell;
  }
  function integerProperty_0(_this__u8e3s4, placeholder, property) {
    var tmp = Validators_getInstance().qlh();
    return editableText_0(_this__u8e3s4, VOID, placeholder, tmp, VOID, integerProperty$lambda_0(property));
  }
  function disambiguateBy(_this__u8e3s4, horizontalCollection) {
    var tmp = _this__u8e3s4.ypn();
    var tmp_0 = Companion_getInstance_307();
    tmp.olp(tmp_0.imz(disambiguateBy$lambda(horizontalCollection)));
  }
  function booleanProperty(_this__u8e3s4, placeholder, property) {
    var tmp = Validators_getInstance().rlh();
    return editableText_0(_this__u8e3s4, VOID, placeholder, tmp, VOID, booleanProperty$lambda(property));
  }
  function indentLabel$1$prevIsPlaceholder$1($this_textCell) {
    this.zpn_1 = $this_textCell;
  }
  protoOf(indentLabel$1$prevIsPlaceholder$1).b4v = function (context) {
    return prevCellIsPlaceholderOrNone(context, this.zpn_1.ypn());
  };
  function indentLabel$lambda$lambda_1($prevIsPlaceholder) {
    return function () {
      return $prevIsPlaceholder.m2c();
    };
  }
  function indentLabel$lambda$lambda_2($allowLast) {
    return function () {
      return $allowLast;
    };
  }
  function indentLabel$1$$inlined$writableProperty$1($traitDisposable, $this_textCell) {
    this.apo_1 = $traitDisposable;
    this.bpo_1 = $this_textCell;
  }
  protoOf(indentLabel$1$$inlined$writableProperty$1).bm7 = function (newValue) {
    var tmp0_safe_receiver = this.apo_1._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.vr();
    }
    var tmp;
    if (newValue) {
      this.apo_1._v = this.bpo_1.ypn().olp(TextEditing_getInstance().slx(true, false));
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(indentLabel$1$$inlined$writableProperty$1).t2c = function (newValue) {
    return this.bm7((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function indentLabel$lambda_0($text, $allowLast) {
    return function ($this$textCell) {
      var tmp;
      // Inline function 'kotlin.text.isNotEmpty' call
      var this_0 = $text;
      if (charSequenceLength(this_0) > 0) {
        var prevIsPlaceholder = new EagerInvalidatable(new indentLabel$1$prevIsPlaceholder$1($this$textCell));
        if ($allowLast || $text.length > 1) {
          $this$textCell.ypn().hlp().v2c(true);
          var tmp_0 = $this$textCell.ypn();
          var tmp_1 = TextEditing_getInstance();
          var tmp_2 = indentLabel$lambda$lambda_1(prevIsPlaceholder);
          tmp_0.olp(tmp_1.bmu(tmp_2, indentLabel$lambda$lambda_2($allowLast)));
        } else {
          var traitDisposable = {_v: null};
          $this$textCell.wle(syncOneWay(prevIsPlaceholder, $this$textCell.ypn().hlp()));
          // Inline function 'jetbrains.ocelot.base.observable.property.writableProperty' call
          var tmp$ret$1 = new indentLabel$1$$inlined$writableProperty$1(traitDisposable, $this$textCell);
          $this$textCell.wle(syncOneWay(prevIsPlaceholder, tmp$ret$1));
        }
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function isEmpty$ref_1() {
    var l = function (p0) {
      return isEmpty(p0);
    };
    l.callableName = 'isEmpty';
    return l;
  }
  function placeholderInCollection$lambda$lambda_0($this_editableText, $collectionItemCompletion) {
    return function (mapper) {
      var commonConfig = get_internalConfig($this_editableText).cpo();
      var coroutineScope = commonConfig;
      var wrapperContext = get_internalConfig($this_editableText).o71();
      var resolveConfig = commonConfig;
      var roleCompletion = buildRoleCompletion(null, coroutineScope, wrapperContext, resolveConfig, $collectionItemCompletion);
      return getCollectionPlaceholderCompletionSupplier(mapper, roleCompletion);
    };
  }
  function placeholderInCollection$lambda_0($collectionItemCompletion) {
    return function ($this$editableText) {
      attachCompletion($this$editableText, placeholderInCollection$lambda$lambda_0($this$editableText, $collectionItemCompletion));
      return Unit_instance;
    };
  }
  function considerEmptyBy$1($this_considerEmptyBy) {
    this.dpo_1 = $this_considerEmptyBy;
    CellTrait.call(this);
  }
  protoOf(considerEmptyBy$1).bll = function (cell, spec, event) {
    if (spec === Cells_getInstance().kmg_1) {
      var derivedBecameEmpty = new DerivedEvent(event);
      this.dpo_1.ypn().nlp(derivedBecameEmpty, Cells_getInstance().kmg_1);
    } else {
      protoOf(CellTrait).bll.call(this, cell, spec, event);
    }
  };
  protoOf(considerEmptyBy$1).flo = function (cell, spec) {
    return spec === ProjectionalSynchronizers_getInstance().llw_1 ? true : protoOf(CellTrait).flo.call(this, cell, spec);
  };
  function rightTransform$1$$inlined$propertyTrait$1_0($propSpec, $cell, $init, $this_rightTransform, $cellFinder) {
    this.epo_1 = $propSpec;
    this.fpo_1 = $cell;
    this.gpo_1 = $init;
    this.hpo_1 = $this_rightTransform;
    this.ipo_1 = $cellFinder;
    CellTrait.call(this);
  }
  protoOf(rightTransform$1$$inlined$propertyTrait$1_0).flo = function (cell, spec) {
    var tmp;
    if (spec === this.epo_1) {
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.rightTransform.<anonymous>.<anonymous>' call
      var builder = new CompletionBuilderImpl(coroutineScope_0(ensureNotNull(this.fpo_1.llk())));
      this.gpo_1(builder, this.hpo_1.k6h(), this.fpo_1, this.ipo_1);
      tmp = builder.wp2();
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function rightTransform$lambda_0($this_rightTransform, $cell, $init) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, cellFinder) {
      var tmp;
      if (get_internalConfig($this_rightTransform).jpo()) {
        tmp = Companion_getInstance_302().dmw_1;
      } else {
        // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
        var propSpec = CompoundSideTransformTrait_getInstance().api_1;
        tmp = new rightTransform$1$$inlined$propertyTrait$1_0(propSpec, $cell, $init, $this_rightTransform, cellFinder);
      }
      return tmp;
    };
  }
  function bigDecimalValidator$ref_1() {
    var l = function (p0) {
      return bigDecimalValidator(p0);
    };
    l.callableName = 'bigDecimalValidator';
    return l;
  }
  function decimalProperty$lambda$lambda(it) {
    return it.s56();
  }
  function decimalProperty$lambda_1($property) {
    return function ($this$editableText) {
      var tmp;
      if (get_internalConfig($this$editableText).jpo()) {
        var sourceProp = $property($this$editableText.k6h());
        var tmp_0 = sourceProp.n4z();
        $this$editableText.wle(syncOneWay(map_0(tmp_0, decimalProperty$lambda$lambda), $this$editableText.ypn().laz()));
        tmp = Unit_instance;
      } else {
        // Inline function 'jetbrains.ocelot.langDef.editor.values.decimalSyncTwoWay' call
        var sourceProp_0 = $property($this$editableText.k6h());
        // Inline function 'jetbrains.ocelot.langDef.editor.values.decimalSyncTwoWay.stub_for_inlining' call
        var p0 = $this$editableText.ypn();
        var targetProp = decimalProperty_0(p0);
        $this$editableText.wle(syncTwoWay(sourceProp_0.n4z(), targetProp));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function integerProperty$lambda$lambda(it) {
    return '' + it;
  }
  function integerProperty$lambda_0($property) {
    return function ($this$editableText) {
      var tmp;
      if (get_internalConfig($this$editableText).jpo()) {
        var sourceProp = $property($this$editableText.k6h());
        var tmp_0 = sourceProp.n4z();
        $this$editableText.wle(syncOneWay(map_0(tmp_0, integerProperty$lambda$lambda), $this$editableText.ypn().laz()));
        tmp = Unit_instance;
      } else {
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.intSyncTwoWay' call
        var sourceProp_0 = $property($this$editableText.k6h());
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.intSyncTwoWay.stub_for_inlining' call
        var p0 = $this$editableText.ypn();
        var targetProp = ValueEditors_instance.gn4(p0);
        $this$editableText.wle(syncTwoWay(sourceProp_0.n4z(), targetProp));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function disambiguateBy$lambda($horizontalCollection) {
    return function (_unused_var__etf5q3, outermostLeaf) {
      return isDescendant($horizontalCollection, outermostLeaf);
    };
  }
  function booleanProperty$lambda$lambda(it) {
    return '' + it;
  }
  function booleanProperty$lambda($property) {
    return function ($this$editableText) {
      var tmp;
      if (get_internalConfig($this$editableText).jpo()) {
        var sourceProp = $property($this$editableText.k6h());
        var tmp_0 = sourceProp.n4z();
        $this$editableText.wle(syncOneWay(map_0(tmp_0, booleanProperty$lambda$lambda), $this$editableText.ypn().laz()));
        tmp = Unit_instance;
      } else {
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.booleanSyncTwoWay' call
        var sourceProp_0 = $property($this$editableText.k6h());
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.booleanSyncTwoWay.stub_for_inlining' call
        var p0 = $this$editableText.ypn();
        var targetProp = ValueEditors_instance.fn4(p0);
        $this$editableText.wle(syncTwoWay(sourceProp_0.n4z(), targetProp));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function mark_0(_this__u8e3s4, mark) {
    return mark.lpo(_this__u8e3s4);
  }
  function Companion_365() {
    Companion_instance_365 = this;
    this.mpo_1 = CellTraitPropertySpec_init_$Create$('cellMark', null);
  }
  var Companion_instance_365;
  function Companion_getInstance_365() {
    if (Companion_instance_365 == null)
      new Companion_365();
    return Companion_instance_365;
  }
  function CellMark$trait$1(this$0) {
    this.npo_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(CellMark$trait$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Companion_getInstance_365().mpo_1)) {
      tmp = this.npo_1;
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function CellMark() {
    Companion_getInstance_365();
    var tmp = this;
    tmp.kpo_1 = new CellMark$trait$1(this);
  }
  protoOf(CellMark).lpo = function (cell) {
    cell.olp(this.kpo_1);
  };
  protoOf(CellMark).opo = function (cell) {
    return equals(cell.ulp(Companion_getInstance_365().mpo_1), this);
  };
  function find_2(_this__u8e3s4, mark) {
    var tmp0 = get_descendants(_this__u8e3s4);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.find.<anonymous>' call
        if (mark.opo(element)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  function children_2(_this__u8e3s4, sourceClass, contextLink, placeholderText, placeholderTraitFactory, separator, clipboardSetup, onLastItemDeleted, layout, sourceListRole) {
    contextLink = contextLink === VOID ? null : contextLink;
    placeholderText = placeholderText === VOID ? null : placeholderText;
    var tmp;
    if (placeholderTraitFactory === VOID) {
      tmp = children$lambda_1;
    } else {
      tmp = placeholderTraitFactory;
    }
    placeholderTraitFactory = tmp;
    separator = separator === VOID ? null : separator;
    var tmp_0;
    if (clipboardSetup === VOID) {
      tmp_0 = children$lambda_2;
    } else {
      tmp_0 = clipboardSetup;
    }
    clipboardSetup = tmp_0;
    onLastItemDeleted = onLastItemDeleted === VOID ? null : onLastItemDeleted;
    layout = layout === VOID ? Layout_INDENT_getInstance() : layout;
    var tmp_1;
    switch (layout.a3_1) {
      case 0:
        tmp_1 = indent_0(_this__u8e3s4, VOID, VOID, children$lambda_3(sourceClass, contextLink, placeholderText, placeholderTraitFactory, separator, clipboardSetup, onLastItemDeleted, sourceListRole));
        break;
      case 1:
        tmp_1 = horizontal_0(_this__u8e3s4, children$lambda_4(sourceClass, contextLink, placeholderText, placeholderTraitFactory, separator, clipboardSetup, onLastItemDeleted, sourceListRole));
        break;
      case 2:
        tmp_1 = vertical(_this__u8e3s4, children$lambda_5(sourceClass, contextLink, placeholderText, placeholderTraitFactory, separator, clipboardSetup, onLastItemDeleted, sourceListRole));
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp_1;
  }
  var Layout_INDENT_instance;
  var Layout_HORIZONTAL_instance;
  var Layout_VERTICAL_instance;
  var Layout_entriesInitialized;
  function Layout_initEntries() {
    if (Layout_entriesInitialized)
      return Unit_instance;
    Layout_entriesInitialized = true;
    Layout_INDENT_instance = new Layout('INDENT', 0);
    Layout_HORIZONTAL_instance = new Layout('HORIZONTAL', 1);
    Layout_VERTICAL_instance = new Layout('VERTICAL', 2);
  }
  function Layout(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function child_1(_this__u8e3s4, sourceClass, role, placeholderText, placeholderTraitFactory, itemFactory, clipboardSetup, onLastItemDeleted, canClear, contextLink, completionSupplier) {
    placeholderText = placeholderText === VOID ? null : placeholderText;
    var tmp;
    if (placeholderTraitFactory === VOID) {
      tmp = child$lambda_1;
    } else {
      tmp = placeholderTraitFactory;
    }
    placeholderTraitFactory = tmp;
    itemFactory = itemFactory === VOID ? null : itemFactory;
    var tmp_0;
    if (clipboardSetup === VOID) {
      tmp_0 = child$lambda_2;
    } else {
      tmp_0 = clipboardSetup;
    }
    clipboardSetup = tmp_0;
    onLastItemDeleted = onLastItemDeleted === VOID ? null : onLastItemDeleted;
    canClear = canClear === VOID ? null : canClear;
    contextLink = contextLink === VOID ? null : contextLink;
    completionSupplier = completionSupplier === VOID ? null : completionSupplier;
    var roleWithCell = child$lambda_3(role);
    var editorRegistry = get_internalConfig(_this__u8e3s4).ppo();
    var tmp_1;
    if (contextLink == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child.<anonymous>' call
      tmp_1 = new ChildContext(_this__u8e3s4.k6h(), contextLink);
    }
    var childContext = tmp_1;
    var roleSpec = editorRegistry.qpo(sourceClass, childContext, placeholderText, itemFactory, onLastItemDeleted, canClear, completionSupplier);
    return extendedChild(_this__u8e3s4, roleSpec, roleWithCell, placeholderTraitFactory, clipboardSetup);
  }
  function buildChildren(_this__u8e3s4, sourceClass, contextLink, placeholderText, placeholderTraitFactory, collectionSeparator, clipboardSetup, onLastItemDeleted, sourceListRole) {
    placeholderText = placeholderText === VOID ? null : placeholderText;
    var tmp;
    if (placeholderTraitFactory === VOID) {
      tmp = buildChildren$lambda;
    } else {
      tmp = placeholderTraitFactory;
    }
    placeholderTraitFactory = tmp;
    collectionSeparator = collectionSeparator === VOID ? null : collectionSeparator;
    var tmp_0;
    if (clipboardSetup === VOID) {
      tmp_0 = buildChildren$lambda_0;
    } else {
      tmp_0 = clipboardSetup;
    }
    clipboardSetup = tmp_0;
    onLastItemDeleted = onLastItemDeleted === VOID ? null : onLastItemDeleted;
    var editorRegistry = get_internalConfig(_this__u8e3s4).ppo();
    var tmp_1;
    if (contextLink == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.buildChildren.<anonymous>' call
      tmp_1 = new ChildContext(_this__u8e3s4.k6h(), contextLink);
    }
    var childContext = tmp_1;
    var roleSpec = editorRegistry.rpo(sourceClass, childContext, placeholderText, collectionSeparator, onLastItemDeleted);
    var cellChildren = _this__u8e3s4.ypn().g2r();
    var separator = roleSpec.zpo_1;
    var tmp2_elvis_lhs = separator == null ? null : separator.app(cellChildren);
    var targetList = tmp2_elvis_lhs == null ? cellChildren : tmp2_elvis_lhs;
    var sourceList = sourceListRole(_this__u8e3s4.k6h());
    var mapperFactoryFunction = roleSpec.ipp();
    if (get_internalConfig(_this__u8e3s4).jpo()) {
      _this__u8e3s4.wle(ReadOnlyProjectionalSynchronizers_instance.fni(sourceList.n4z(), _this__u8e3s4.ypn(), targetList, mapperFactoryFunction, roleSpec.dpp_1, roleSpec.fpp_1));
    } else {
      var tmp_2 = new ProjectionalListSynchronizerSettings();
      var tmp_3 = tmp_2.hne(buildChildren$lambda_1);
      var settings = tmp_3.ine(buildChildren$lambda_2(placeholderTraitFactory, _this__u8e3s4));
      settings.kne(roleSpec.dpp_1);
      settings.jne(buildChildren$lambda_3);
      if (separator instanceof StringSeparator) {
        separatorSideTransform(separator.jpp_1, settings);
      }
      var synchronizer = ProjectionalSynchronizers_getInstance().znh(sourceList.n4z(), _this__u8e3s4.ypn(), targetList, mapperFactoryFunction, settings);
      setRoleSpec(synchronizer, roleSpec);
      clipboardSetup(synchronizer.ina());
      _this__u8e3s4.wle(synchronizer);
    }
  }
  function extendedChild(_this__u8e3s4, roleSpec, role, placeholderTraitFactory, clipboardSetup, before, after) {
    var tmp;
    if (placeholderTraitFactory === VOID) {
      tmp = extendedChild$lambda;
    } else {
      tmp = placeholderTraitFactory;
    }
    placeholderTraitFactory = tmp;
    var tmp_0;
    if (clipboardSetup === VOID) {
      tmp_0 = extendedChild$lambda_0;
    } else {
      tmp_0 = clipboardSetup;
    }
    clipboardSetup = tmp_0;
    var tmp_1;
    if (before === VOID) {
      tmp_1 = extendedChild$lambda_1;
    } else {
      tmp_1 = before;
    }
    before = tmp_1;
    var tmp_2;
    if (after === VOID) {
      tmp_2 = extendedChild$lambda_2;
    } else {
      tmp_2 = after;
    }
    after = tmp_2;
    return indent_0(_this__u8e3s4, VOID, VOID, extendedChild$lambda_3(before, role, roleSpec, clipboardSetup, after, placeholderTraitFactory));
  }
  function separatorSideTransform(separator, settings) {
    settings.gne(separatorSideTransform$lambda(separator));
  }
  function setRoleSpec(_this__u8e3s4, roleSpec) {
    var roleCompletion = roleSpec.epp_1;
    if (!(roleCompletion == null)) {
      _this__u8e3s4.bnc(roleCompletion);
    }
    var itemFactory = roleSpec.cpp_1;
    if (!(itemFactory == null)) {
      var itemHandler = Companion_instance_316.nnd(itemFactory);
      _this__u8e3s4.knb(itemHandler);
    }
    if (!(roleSpec.hpp_1 == null)) {
      _this__u8e3s4.inb(roleSpec.hpp_1);
    }
    var clipboardParameters = roleSpec.fpp_1;
    if (!(clipboardParameters == null)) {
      _this__u8e3s4.ina().ynj(clipboardParameters);
    }
    var tmp0_safe_receiver = roleSpec.gpp_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.setRoleSpec.<anonymous>' call
      _this__u8e3s4.gnc(tmp0_safe_receiver);
    }
  }
  function children$lambda_1(_unused_var__etf5q3, trait) {
    return trait;
  }
  function children$lambda_2(_this__u8e3s4) {
    return Unit_instance;
  }
  function children$lambda_3($sourceClass, $contextLink, $placeholderText, $placeholderTraitFactory, $separator, $clipboardSetup, $onLastItemDeleted, $sourceListRole) {
    return function ($this$indent) {
      buildChildren($this$indent, $sourceClass, $contextLink, $placeholderText, $placeholderTraitFactory, $separator, $clipboardSetup, $onLastItemDeleted, $sourceListRole);
      return Unit_instance;
    };
  }
  function children$lambda_4($sourceClass, $contextLink, $placeholderText, $placeholderTraitFactory, $separator, $clipboardSetup, $onLastItemDeleted, $sourceListRole) {
    return function ($this$horizontal) {
      buildChildren($this$horizontal, $sourceClass, $contextLink, $placeholderText, $placeholderTraitFactory, $separator, $clipboardSetup, $onLastItemDeleted, $sourceListRole);
      return Unit_instance;
    };
  }
  function children$lambda_5($sourceClass, $contextLink, $placeholderText, $placeholderTraitFactory, $separator, $clipboardSetup, $onLastItemDeleted, $sourceListRole) {
    return function ($this$vertical) {
      buildChildren($this$vertical, $sourceClass, $contextLink, $placeholderText, $placeholderTraitFactory, $separator, $clipboardSetup, $onLastItemDeleted, $sourceListRole);
      return Unit_instance;
    };
  }
  function child$lambda_1(_unused_var__etf5q3, trait) {
    return trait;
  }
  function child$lambda_2(_this__u8e3s4) {
    return Unit_instance;
  }
  function child$lambda_3($role) {
    return function (source, _unused_var__etf5q3) {
      return $role(source);
    };
  }
  function buildChildren$lambda(_unused_var__etf5q3, trait) {
    return trait;
  }
  function buildChildren$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function buildChildren$lambda_1(it) {
    return false;
  }
  function buildChildren$lambda_2($placeholderTraitFactory, $this_buildChildren) {
    return function (trait) {
      return $placeholderTraitFactory($this_buildChildren.k6h(), trait);
    };
  }
  function buildChildren$lambda_3() {
    return LeafCellTrackingTrait_getInstance();
  }
  function extendedChild$lambda(_unused_var__etf5q3, trait) {
    return trait;
  }
  function extendedChild$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function extendedChild$lambda_1(_this__u8e3s4) {
    return Unit_instance;
  }
  function extendedChild$lambda_2(_this__u8e3s4) {
    return Unit_instance;
  }
  function extendedChild$lambda$lambda($placeholderTraitFactory, $this_indent) {
    return function (trait) {
      return $placeholderTraitFactory($this_indent.k6h(), trait);
    };
  }
  function extendedChild$lambda$lambda_0() {
    return LeafCellTrackingTrait_getInstance();
  }
  function extendedChild$lambda_3($before, $role, $roleSpec, $clipboardSetup, $after, $placeholderTraitFactory) {
    return function ($this$indent) {
      $before($this$indent);
      var sourceProp = $role($this$indent.k6h(), $this$indent.ypn());
      var mapperFactoryFunction = $roleSpec.ipp();
      var tmp;
      if (get_internalConfig($this$indent).jpo()) {
        $this$indent.wle(ReadOnlyProjectionalSynchronizers_instance.gni($role($this$indent.k6h(), $this$indent.ypn()).n4z(), $this$indent.ypn(), mapperFactoryFunction, $roleSpec.dpp_1, $roleSpec.fpp_1));
        tmp = Unit_instance;
      } else {
        var tmp_0 = new ProjectionalPropertySynchronizerSettings();
        var tmp_1 = tmp_0.ine(extendedChild$lambda$lambda($placeholderTraitFactory, $this$indent));
        var settings = tmp_1.jne(extendedChild$lambda$lambda_0).kne($roleSpec.dpp_1).xnh($roleSpec.spp_1);
        var synchronizer = ProjectionalSynchronizers_getInstance().ani(sourceProp.n4z(), $this$indent.ypn(), mapperFactoryFunction, settings);
        setRoleSpec(synchronizer, $roleSpec);
        $clipboardSetup(synchronizer.ina());
        $this$indent.wle(synchronizer);
        tmp = Unit_instance;
      }
      $after($this$indent);
      return Unit_instance;
    };
  }
  function separatorSideTransform$lambda$o$get$lambda($createHandle, $cell) {
    return function () {
      return $createHandle.rnd($cell);
    };
  }
  function separatorSideTransform$1$$inlined$propertyFromCellTrait$1($propSpec, $separator, $createHandle) {
    this.tpp_1 = $propSpec;
    this.upp_1 = $separator;
    this.vpp_1 = $createHandle;
    CellTrait.call(this);
  }
  protoOf(separatorSideTransform$1$$inlined$propertyFromCellTrait$1).flo = function (cell, spec) {
    var tmp;
    if (spec === this.tpp_1) {
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.separatorSideTransform.<anonymous>.<anonymous>' call
      var separatorSideTransform = completes(this.upp_1, separatorSideTransform$lambda$o$get$lambda(this.vpp_1, cell));
      tmp = simpleCompletionSupplier([separatorSideTransform]);
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function separatorSideTransform$lambda($separator) {
    return function (createHandle) {
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyFromCellTrait' call
      var propSpec = CompoundSideTransformTrait_getInstance().api_1;
      return new separatorSideTransform$1$$inlined$propertyFromCellTrait$1(propSpec, $separator, createHandle);
    };
  }
  function Layout_INDENT_getInstance() {
    Layout_initEntries();
    return Layout_INDENT_instance;
  }
  function Layout_HORIZONTAL_getInstance() {
    Layout_initEntries();
    return Layout_HORIZONTAL_instance;
  }
  function Layout_VERTICAL_getInstance() {
    Layout_initEntries();
    return Layout_VERTICAL_instance;
  }
  function asInternalEditorBuilder(_this__u8e3s4) {
    return isInterface(_this__u8e3s4, InternalEditorBuilder) ? _this__u8e3s4 : THROW_CCE();
  }
  function EditorMapperFactoryImpl(editorRegistry) {
    this.wpp_1 = editorRegistry;
  }
  protoOf(EditorMapperFactoryImpl).xpp = function (source, sourceClass) {
    var mapperFactory = this.wpp_1.ypp(sourceClass);
    return mapperFactory.zpp(source);
  };
  function editorSetup(editorDefinitions, conceptRegistry, builderConfigFactory) {
    var editorRegistry = new EditorRegistryImpl(editorDefinitions, conceptRegistry);
    editorRegistry.hpq(builderConfigFactory(editorRegistry));
    return new EditorMapperFactoryImpl(editorRegistry);
  }
  function addTraitOnAttach_0(_this__u8e3s4, traitFactory) {
    addTraitOnAttach_1(_this__u8e3s4, _this__u8e3s4.ypn(), traitFactory);
  }
  function attachCompletion(_this__u8e3s4, init) {
    var tmp = _this__u8e3s4.ypn();
    var sync = createOnAttachSynchronizer(tmp, attachCompletion$lambda(_this__u8e3s4, init));
    _this__u8e3s4.wle(sync);
  }
  function addTraitOnAttach_1(_this__u8e3s4, subCell, traitFactory) {
    var tmp = _this__u8e3s4.k6h();
    var sync = createOnAttachSynchronizer_0(tmp, subCell, addTraitOnAttach$lambda_0(traitFactory));
    _this__u8e3s4.wle(sync);
  }
  function createOnAttachSynchronizer(cell, traitFactory) {
    return new createOnAttachSynchronizer$1(cell, traitFactory);
  }
  function createOnAttachSynchronizer_0(source, cell, traitFactory) {
    return createOnAttachSynchronizer(cell, createOnAttachSynchronizer$lambda(traitFactory, source, cell));
  }
  function attachCompletion$1$$inlined$propertyTrait$1($propSpec, $init, $mapper) {
    this.ipq_1 = $propSpec;
    this.jpq_1 = $init;
    this.kpq_1 = $mapper;
    CellTrait.call(this);
  }
  protoOf(attachCompletion$1$$inlined$propertyTrait$1).flo = function (cell, spec) {
    var tmp;
    if (spec === this.ipq_1) {
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.attachCompletion.<anonymous>.<anonymous>' call
      tmp = this.jpq_1(this.kpq_1);
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function attachCompletion$lambda($this_attachCompletion, $init) {
    return function (mappingContext) {
      var tmp0 = mappingContext.qld($this_attachCompletion.k6h());
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.k();
        while (_iterator__ex2g4s.l()) {
          var element = _iterator__ex2g4s.m();
          // Inline function 'jetbrains.ocelot.langDef.editorBuilder.attachCompletion.<anonymous>.<anonymous>' call
          var tmp = element.ql9_1;
          if (!(tmp == null) ? isInterface(tmp, Cell) : false) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      var mapper = ensureNotNull(tmp$ret$1);
      if (!(mapper instanceof Mapper))
        THROW_CCE();
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
      var propSpec = Completion_getInstance().cm1_1;
      return new attachCompletion$1$$inlined$propertyTrait$1(propSpec, $init, mapper);
    };
  }
  function addTraitOnAttach$lambda_0($traitFactory) {
    return function (source, cell, cellFinder) {
      return $traitFactory(source, cell, cellFinder);
    };
  }
  function createOnAttachSynchronizer$1($cell, $traitFactory) {
    this.mpq_1 = $cell;
    this.npq_1 = $traitFactory;
    DisposableSynchronizer.call(this);
  }
  protoOf(createOnAttachSynchronizer$1).dlb = function (ctx) {
    return this.mpq_1.olp(this.npq_1(ctx.mlb()));
  };
  function createOnAttachSynchronizer$lambda($traitFactory, $source, $cell) {
    return function (mappingContext) {
      var cellFinder = getMapperCellFinder(mappingContext);
      return $traitFactory($source, $cell, cellFinder);
    };
  }
  function getDebugIdText(_this__u8e3s4) {
    return take_1(get_stringId(_this__u8e3s4), 4);
  }
  function textProperty_0(_this__u8e3s4, placeholder, property, init) {
    var tmp;
    if (init === VOID) {
      tmp = textProperty$lambda_0;
    } else {
      tmp = init;
    }
    init = tmp;
    return editableText_0(_this__u8e3s4, VOID, placeholder, VOID, VOID, textProperty$lambda_1(property, init));
  }
  function editableText_0(_this__u8e3s4, text, placeholderText, validator, readOnly, init) {
    text = text === VOID ? '' : text;
    placeholderText = placeholderText === VOID ? null : placeholderText;
    validator = validator === VOID ? null : validator;
    readOnly = readOnly === VOID ? false : readOnly;
    var tmp;
    if (init === VOID) {
      tmp = editableText$lambda_3;
    } else {
      tmp = init;
    }
    init = tmp;
    var mainTextCell = textCell_0(_this__u8e3s4, text, editableText$lambda_4(readOnly, validator, init));
    if (!(placeholderText == null)) {
      placeholder_2(_this__u8e3s4, placeholderText, mainTextCell);
    }
    return mainTextCell;
  }
  function textProperty$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function textProperty$lambda_1($property, $init) {
    return function ($this$editableText) {
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay' call
      var sourceProp = $property($this$editableText.k6h());
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay.stub_for_inlining' call
      var targetProp = $this$editableText.ypn().laz();
      $this$editableText.wle(syncTwoWay(sourceProp.n4z(), targetProp));
      $init($this$editableText);
      return Unit_instance;
    };
  }
  function editableText$lambda_3(_this__u8e3s4) {
    return Unit_instance;
  }
  function editableText$lambda_4($readOnly, $validator, $init) {
    return function ($this$textCell) {
      $this$textCell.ypn().hlp().v2c(true);
      var cellTrait = $readOnly || get_internalConfig($this$textCell).jpo() ? TextEditing_getInstance().dmu() : $validator == null ? TextEditing_getInstance().fmu() : TextEditing_getInstance().gmu($validator);
      var editorBuilder = asInternalEditorBuilder($this$textCell);
      editorBuilder.opq(cellTrait);
      editorBuilder.opq(LeafCellTrackingTrait_getInstance());
      $init($this$textCell);
      return Unit_instance;
    };
  }
  function multilineText(_this__u8e3s4, placeholder, textSpecification, text, textStyle) {
    var tmp;
    if (textStyle === VOID) {
      tmp = multilineText$lambda;
    } else {
      tmp = textStyle;
    }
    textStyle = tmp;
    var syncFactory = new MultilineTextSynchronizerFactory(textSpecification, textStyle, get_internalConfig(_this__u8e3s4).ppq(), get_internalConfig(_this__u8e3s4).o71(), get_internalConfig(_this__u8e3s4).qpq());
    var _destruct__k2r9zo = syncFactory.ypk(text(_this__u8e3s4.k6h()).n4z(), placeholder);
    var synchronizer = _destruct__k2r9zo.ug();
    var cell = _destruct__k2r9zo.vg();
    _this__u8e3s4.wle(synchronizer);
    asInternalEditorBuilder(_this__u8e3s4).wpn(cell);
    return cell;
  }
  function TextSpecification(linesRole, textProperty) {
    this.epj_1 = linesRole;
    this.fpj_1 = textProperty;
  }
  protoOf(TextSpecification).toString = function () {
    return 'TextSpecification(linesRole=' + this.epj_1.toString() + ', textProperty=' + this.fpj_1.toString() + ')';
  };
  protoOf(TextSpecification).hashCode = function () {
    var result = this.epj_1.hashCode();
    result = imul(result, 31) + this.fpj_1.hashCode() | 0;
    return result;
  };
  protoOf(TextSpecification).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextSpecification))
      return false;
    var tmp0_other_with_cast = other instanceof TextSpecification ? other : THROW_CCE();
    if (!this.epj_1.equals(tmp0_other_with_cast.epj_1))
      return false;
    if (!this.fpj_1.equals(tmp0_other_with_cast.fpj_1))
      return false;
    return true;
  };
  function multilineText$lambda(it) {
    return Unit_instance;
  }
  function ChildRoleDefaults(placeholderText, completionSupplier, itemFactory, canCreateNewItems, canClear) {
    RoleDefaults.call(this, placeholderText, completionSupplier, itemFactory, canCreateNewItems);
    this.vpq_1 = canClear;
  }
  function childRoleDefaults(placeholderText, completionSupplier, itemFactory, canCreateNewItems, canClear) {
    placeholderText = placeholderText === VOID ? '<empty>' : placeholderText;
    completionSupplier = completionSupplier === VOID ? null : completionSupplier;
    itemFactory = itemFactory === VOID ? null : itemFactory;
    canCreateNewItems = canCreateNewItems === VOID ? true : canCreateNewItems;
    canClear = canClear === VOID ? true : canClear;
    return new ChildRoleDefaults(placeholderText, completionSupplier, itemFactory, canCreateNewItems, canClear);
  }
  function ChildrenRoleDefaults(newItemClass, placeholderText, itemFactory, separator, completionSupplier, canCreateNewItems) {
    RoleDefaults.call(this, placeholderText, completionSupplier, itemFactory, canCreateNewItems);
    this.apr_1 = newItemClass;
    this.bpr_1 = separator;
  }
  function get_defaultChildrenSeparator() {
    return NewLineSeparator_getInstance();
  }
  function EditorDefinition(sourceClass, roleDefaults, customCompletion, waitUntilReady, conceptClass, triggerDependencies, init) {
    RoleEditorDefinition.call(this, sourceClass, roleDefaults, customCompletion, waitUntilReady, conceptClass, triggerDependencies, init);
  }
  protoOf(EditorDefinition).jpr = function () {
    return listOf(this);
  };
  protoOf(EditorDefinition).kpr = function (conceptRegistry) {
    var tmp;
    if (this.ppr_1) {
      var matchingText = conceptRegistry.e6p(this.lpr_1);
      tmp = listOf(matchingText);
    } else {
      tmp = emptyList();
    }
    return tmp;
  };
  function HierarchyEditorDefinition$_init_$lambda_kestau(_this__u8e3s4) {
    return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
  }
  function HierarchyEditorDefinition(sourceClass, roleDefaults, editorDefinitions) {
    var tmp = emptyList();
    RoleEditorDefinition.call(this, sourceClass, roleDefaults, null, false, true, tmp, HierarchyEditorDefinition$_init_$lambda_kestau);
    this.zpr_1 = editorDefinitions;
  }
  protoOf(HierarchyEditorDefinition).jpr = function () {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = this.zpr_1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.HierarchyEditorDefinition.<get-allEditorDefinitions>.<anonymous>' call
      var list = element.jpr();
      addAll_1(destination, list);
    }
    return plus_3(destination, this);
  };
  protoOf(HierarchyEditorDefinition).kpr = function (conceptRegistry) {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = this.zpr_1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.HierarchyEditorDefinition.getMatchingTexts.<anonymous>' call
      var list = element.kpr(conceptRegistry);
      addAll_1(destination, list);
    }
    return destination;
  };
  function InvalidatingEditorBuilder(execution) {
    QueryBuilder.call(this, execution);
  }
  function RoleDefaults(placeholderText, completionSupplier, itemFactory, canCreateNewItems) {
    this.dps_1 = placeholderText;
    this.eps_1 = completionSupplier;
    this.fps_1 = itemFactory;
    this.gps_1 = canCreateNewItems;
  }
  function RoleEditorDefinition(sourceClass, roleDefaults, customCompletion, waitUntilReady, conceptClass, triggerDependencies, init) {
    this.lpr_1 = sourceClass;
    this.mpr_1 = roleDefaults;
    this.npr_1 = customCompletion;
    this.opr_1 = waitUntilReady;
    this.ppr_1 = conceptClass;
    this.qpr_1 = triggerDependencies;
    this.rpr_1 = init;
  }
  function maybe(_this__u8e3s4, $this) {
    return _this__u8e3s4 ? ' ' : '';
  }
  function StringSeparator(text, leftSpace, rightSpace) {
    CollectionSeparator.call(this);
    this.jpp_1 = text;
    this.kpp_1 = maybe(leftSpace, this) + this.jpp_1 + maybe(rightSpace, this);
  }
  protoOf(StringSeparator).app = function (list) {
    return CellLists_instance.bmy(list, this.kpp_1);
  };
  function separator(value, leftSpace, rightSpace) {
    leftSpace = leftSpace === VOID ? false : leftSpace;
    rightSpace = rightSpace === VOID ? true : rightSpace;
    return new StringSeparator(value, leftSpace, rightSpace);
  }
  function EmptyLinesSeparator(linesCount) {
    linesCount = linesCount === VOID ? 1 : linesCount;
    CollectionSeparator.call(this);
    this.hps_1 = linesCount;
  }
  protoOf(EmptyLinesSeparator).app = function (list) {
    return CellLists_instance.dmy(list, this.hps_1);
  };
  function blankLine() {
    return new EmptyLinesSeparator();
  }
  function CollectionSeparator() {
  }
  function get_blankLines(_this__u8e3s4) {
    return new EmptyLinesSeparator(_this__u8e3s4);
  }
  function NewLineSeparator() {
    NewLineSeparator_instance = this;
    CollectionSeparator.call(this);
  }
  protoOf(NewLineSeparator).app = function (list) {
    return CellLists_instance.cmy(list);
  };
  var NewLineSeparator_instance;
  function NewLineSeparator_getInstance() {
    if (NewLineSeparator_instance == null)
      new NewLineSeparator();
    return NewLineSeparator_instance;
  }
  function EditorBuilderConfigImpl(wrapperContext, conceptRegistry, nodeFactory, splitMergeSupportFactory, editorRegistry, commonConfig, readOnly, highlightErrors, errorCheckConfig, indentNumSpaces) {
    this.ips_1 = wrapperContext;
    this.jps_1 = conceptRegistry;
    this.kps_1 = nodeFactory;
    this.lps_1 = splitMergeSupportFactory;
    this.mps_1 = editorRegistry;
    this.nps_1 = commonConfig;
    this.ops_1 = readOnly;
    this.pps_1 = highlightErrors;
    this.qps_1 = errorCheckConfig;
    this.rps_1 = indentNumSpaces;
  }
  protoOf(EditorBuilderConfigImpl).o71 = function () {
    return this.ips_1;
  };
  protoOf(EditorBuilderConfigImpl).ppq = function () {
    return this.jps_1;
  };
  protoOf(EditorBuilderConfigImpl).sps = function () {
    return this.kps_1;
  };
  protoOf(EditorBuilderConfigImpl).qpq = function () {
    return this.lps_1;
  };
  protoOf(EditorBuilderConfigImpl).ppo = function () {
    return this.mps_1;
  };
  protoOf(EditorBuilderConfigImpl).cpo = function () {
    return this.nps_1;
  };
  protoOf(EditorBuilderConfigImpl).jpo = function () {
    return this.ops_1;
  };
  protoOf(EditorBuilderConfigImpl).uph = function () {
    return this.pps_1;
  };
  protoOf(EditorBuilderConfigImpl).tps = function () {
    return this.qps_1;
  };
  protoOf(EditorBuilderConfigImpl).vpn = function () {
    return this.rps_1;
  };
  function getAllEditorDefinitions($this, editorDefinitions) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = editorDefinitions.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.Companion.getAllEditorDefinitions.<anonymous>' call
      var list = element.jpr();
      addAll_1(destination, list);
    }
    return destination;
  }
  function _get_editorMap__nnqhs2($this) {
    var tmp = $this.cpq_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('editorMap');
    }
  }
  function _get_roleDefaultsMap__g90zzx($this) {
    var tmp = $this.dpq_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('roleDefaultsMap');
    }
  }
  function _get_exactClasses__7l6rjw($this) {
    var tmp = $this.epq_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('exactClasses');
    }
  }
  function _get_config__hi7kzb($this) {
    var tmp = $this.fpq_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('config');
    }
  }
  function getEditor($this, sourceClass) {
    var editor = _get_editorMap__nnqhs2($this).y2(sourceClass);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (editor == null) {
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.EditorRegistryImpl.getEditor.<anonymous>' call
        var message = 'cannot find editor for: ' + toString_1(sourceClass);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return editor instanceof RoleEditor ? editor : THROW_CCE();
  }
  function toInterfaceClass($this, implClass) {
    var conceptClass = $this.bpq_1.f6p(implClass);
    return isInterface(conceptClass, KClass) ? conceptClass : THROW_CCE();
  }
  function getRoleDefaults($this, sourceClass) {
    return _get_roleDefaultsMap__g90zzx($this).y2(sourceClass);
  }
  function createEditor($this, editorDefinition) {
    var tmp;
    if (editorDefinition instanceof EditorDefinition) {
      tmp = editor_0(_get_config__hi7kzb($this), editorDefinition);
    } else {
      if (editorDefinition instanceof HierarchyEditorDefinition) {
        tmp = hierarchyEditor(_get_config__hi7kzb($this), editorDefinition);
      } else {
        throw UnsupportedOperationException_init_$Create$();
      }
    }
    return tmp;
  }
  function Companion_366() {
  }
  var Companion_instance_366;
  function Companion_getInstance_366() {
    return Companion_instance_366;
  }
  function EditorRegistryImpl$init$lambda(editorDefinition) {
    return !(editorDefinition.mpr_1 == null);
  }
  function EditorRegistryImpl(editorDefinitions, conceptRegistry) {
    this.bpq_1 = conceptRegistry;
    this.gpq_1 = getAllEditorDefinitions(Companion_instance_366, editorDefinitions);
  }
  protoOf(EditorRegistryImpl).hpq = function (config) {
    this.fpq_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.associate' call
    var this_0 = this.gpq_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.EditorRegistryImpl.init.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.lpr_1, createEditor(this, element));
      destination.r2(pair.dh_1, pair.eh_1);
    }
    tmp.cpq_1 = destination;
    var tmp_0 = this;
    var tmp_1 = asSequence_0(this.gpq_1);
    // Inline function 'kotlin.sequences.associate' call
    var tmp0 = filter(tmp_1, EditorRegistryImpl$init$lambda);
    // Inline function 'kotlin.sequences.associateTo' call
    var destination_0 = LinkedHashMap_init_$Create$();
    var _iterator__ex2g4s_0 = tmp0.k();
    while (_iterator__ex2g4s_0.l()) {
      var element_0 = _iterator__ex2g4s_0.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.EditorRegistryImpl.init.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      var pair_0 = to(element_0.lpr_1, ensureNotNull(element_0.mpr_1));
      destination_0.r2(pair_0.dh_1, pair_0.eh_1);
    }
    tmp_0.dpq_1 = destination_0;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = this.gpq_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_1 = tmp0_0.k();
    while (_iterator__ex2g4s_1.l()) {
      var element_1 = _iterator__ex2g4s_1.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.EditorRegistryImpl.init.<anonymous>' call
      if (!element_1.ppr_1) {
        destination_1.e(element_1);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_1, 10));
    var _iterator__ex2g4s_2 = destination_1.k();
    while (_iterator__ex2g4s_2.l()) {
      var item = _iterator__ex2g4s_2.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.EditorRegistryImpl.init.<anonymous>' call
      var tmp$ret$9 = item.lpr_1;
      destination_2.e(tmp$ret$9);
    }
    tmp_2.epq_1 = toSet_0(destination_2);
  };
  protoOf(EditorRegistryImpl).rpo = function (sourceClass, childContext, placeholderText, separator, onLastItemDeleted) {
    var editor = getEditor(this, sourceClass);
    var tmp = getRoleDefaults(this, sourceClass);
    var roleDefaults = (tmp == null ? true : tmp instanceof RoleDefaults) ? tmp : THROW_CCE();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (roleDefaults == null) {
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.EditorRegistryImpl.getChildrenRoleSpec.<anonymous>' call
        var message = 'cannot find role defaults for collection of ' + toString_1(sourceClass);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var resultPlaceholderText = placeholderText == null ? roleDefaults.dps_1 : placeholderText;
    var tmp_0;
    if (separator == null) {
      var tmp2_safe_receiver = roleDefaults instanceof ChildrenRoleDefaults ? roleDefaults : null;
      tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.bpr_1;
    } else {
      tmp_0 = separator;
    }
    var tmp3_elvis_lhs = tmp_0;
    var childrenSeparator = tmp3_elvis_lhs == null ? get_defaultChildrenSeparator() : tmp3_elvis_lhs;
    var tmp4_safe_receiver = roleDefaults instanceof ChildrenRoleDefaults ? roleDefaults : null;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.apr_1;
    var tmp_1;
    if (tmp5_elvis_lhs == null) {
      tmp_1 = isInterface(sourceClass, KClass) ? sourceClass : THROW_CCE();
    } else {
      tmp_1 = tmp5_elvis_lhs;
    }
    var newItemClass = tmp_1;
    var itemFactory = roleDefaults.fps_1;
    var completionSupplier = roleDefaults.eps_1;
    var canCreateNewItems = roleDefaults.gps_1;
    return editor.wps(childContext, newItemClass, itemFactory, resultPlaceholderText, childrenSeparator, completionSupplier, canCreateNewItems, onLastItemDeleted, this.bpq_1);
  };
  protoOf(EditorRegistryImpl).qpo = function (sourceClass, childContext, placeholderText, itemFactory, onLastItemDeleted, canClear, completionSupplier) {
    var editor = getEditor(this, sourceClass);
    var tmp = getRoleDefaults(this, sourceClass);
    var tmp0_elvis_lhs = (tmp == null ? true : tmp instanceof RoleDefaults) ? tmp : THROW_CCE();
    var roleDefaults = tmp0_elvis_lhs == null ? childRoleDefaults() : tmp0_elvis_lhs;
    var resultPlaceholderText = placeholderText == null ? roleDefaults.dps_1 : placeholderText;
    var resultCompletionSupplier = completionSupplier == null ? roleDefaults.eps_1 : completionSupplier;
    var resultItemFactory = itemFactory == null ? roleDefaults.fps_1 : itemFactory;
    var canCreateNewItems = roleDefaults.gps_1;
    var tmp_0;
    if (canClear == null) {
      var tmp5_safe_receiver = roleDefaults instanceof ChildRoleDefaults ? roleDefaults : null;
      tmp_0 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.vpq_1;
    } else {
      tmp_0 = canClear;
    }
    var tmp6_elvis_lhs = tmp_0;
    var resultCanClear = tmp6_elvis_lhs == null ? true : tmp6_elvis_lhs;
    return editor.xps(childContext, resultPlaceholderText, resultCompletionSupplier, resultItemFactory, canCreateNewItems, onLastItemDeleted, resultCanClear, this.bpq_1);
  };
  protoOf(EditorRegistryImpl).ypp = function (sourceClass) {
    var interfaceClass = _get_exactClasses__7l6rjw(this).s(sourceClass) ? sourceClass : toInterfaceClass(this, sourceClass);
    var editor = getEditor(this, interfaceClass);
    return editor.yps();
  };
  function BaseRoleSpec$getMapperFactoryFunction$lambda(this$0) {
    return function (item) {
      return this$0.bpp_1.zpp(item);
    };
  }
  function BaseRoleSpec(mapperFactory, itemFactory, placeholderText, roleCompletion, clipboardParameters, pasteHandler, onLastItemDeleted) {
    this.bpp_1 = mapperFactory;
    this.cpp_1 = itemFactory;
    this.dpp_1 = placeholderText;
    this.epp_1 = roleCompletion;
    this.fpp_1 = clipboardParameters;
    this.gpp_1 = pasteHandler;
    this.hpp_1 = onLastItemDeleted;
  }
  protoOf(BaseRoleSpec).ipp = function () {
    return BaseRoleSpec$getMapperFactoryFunction$lambda(this);
  };
  function ChildRoleSpec(mapperFactory, placeholderText, itemFactory, roleCompletion, clipboardParameters, pasteHandler, onLastItemDeleted, canClear) {
    placeholderText = placeholderText === VOID ? '<empty>' : placeholderText;
    itemFactory = itemFactory === VOID ? null : itemFactory;
    roleCompletion = roleCompletion === VOID ? null : roleCompletion;
    clipboardParameters = clipboardParameters === VOID ? null : clipboardParameters;
    pasteHandler = pasteHandler === VOID ? null : pasteHandler;
    onLastItemDeleted = onLastItemDeleted === VOID ? null : onLastItemDeleted;
    canClear = canClear === VOID ? true : canClear;
    BaseRoleSpec.call(this, mapperFactory, itemFactory, placeholderText, roleCompletion, clipboardParameters, pasteHandler, onLastItemDeleted);
    this.spp_1 = canClear;
  }
  function ChildrenRoleSpec(mapperFactory, itemFactory, placeholderText, roleCompletion, separator, clipboardParameters, pasteHandler, onLastItemDeleted) {
    placeholderText = placeholderText === VOID ? '<empty>' : placeholderText;
    roleCompletion = roleCompletion === VOID ? null : roleCompletion;
    separator = separator === VOID ? null : separator;
    clipboardParameters = clipboardParameters === VOID ? null : clipboardParameters;
    onLastItemDeleted = onLastItemDeleted === VOID ? null : onLastItemDeleted;
    BaseRoleSpec.call(this, mapperFactory, itemFactory, placeholderText, roleCompletion, clipboardParameters, pasteHandler, onLastItemDeleted);
    this.zpo_1 = separator;
  }
  function get_internalConfig(_this__u8e3s4) {
    var tmp = _this__u8e3s4.upn();
    return isInterface(tmp, InternalEditorBuilderConfig) ? tmp : THROW_CCE();
  }
  function InternalEditorBuilder() {
  }
  function InternalEditorBuilderConfig() {
  }
  function handleInvalidatable($this, invalidatable) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = invalidatable.c4v();
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    // Inline function 'kotlin.onFailure' call
    var this_0 = tmp;
    if (Result__exceptionOrNull_impl_p6xea9(this_0) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.onFailure.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.<no name provided>.handleInvalidatable.<anonymous>' call
      contentUpdated($this);
      return Unit_instance;
    }
    if (!invalidatable.d4v().w4u()) {
      contentUpdated($this);
      return Unit_instance;
    }
    var tmp_1 = $this;
    var tmp_2 = invalidatable.d4v();
    tmp_1.bpt_1 = tmp_2.p27(BaseEditor$createMapper$o$handleInvalidatable$lambda($this));
  }
  function contentUpdated($this) {
    var cellContainer = $this.fpt_1.llk();
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (cellContainer == null) {
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.<no name provided>.contentUpdated.<anonymous>' call
        var message = 'cell container is null';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var tmp = cellContainer.elq();
    var tmp_0 = BaseEditor$createMapper$o$contentUpdated$lambda(cellContainer, $this.gpt_1, $this.fpt_1, $this, $this.cpt_1, $this.dpt_1);
    tmp.u2m(new sam$jetbrains_ocelot_base_edt_EdtTask$0_22(tmp_0));
  }
  function BaseEditor$createMapper$o$attach$lambda(this$0) {
    return function (it) {
      contentUpdated(this$0);
      return Unit_instance;
    };
  }
  function BaseEditor$createMapper$o$handleInvalidatable$lambda(this$0) {
    return function (it) {
      contentUpdated(this$0);
      return Unit_instance;
    };
  }
  function BaseEditor$createMapper$o$contentUpdated$lambda($cellContainer, $reloadableSynchronizer, $rootCell, this$0, this$1, $source) {
    return function () {
      var wasFocused = !($cellContainer.rlp().qr() == null);
      $reloadableSynchronizer.m2();
      $rootCell.g2r().m2();
      handleInvalidatable(this$0, initBuilder(this$1, $source, $rootCell, $reloadableSynchronizer));
      $reloadableSynchronizer.xle();
      var tmp;
      if (wasFocused && $cellContainer.rlp().qr() == null) {
        tmp = $rootCell.ulp(ProjectionalSynchronizers_getInstance().jlw_1)();
      }
      return Unit_instance;
    };
  }
  function initBuilder($this, source, rootCell, reloadableSynchronizer) {
    var editorBuilder = new SimpleEditorBuilder($this.ups_1, source, rootCell, reloadableSynchronizer);
    return $this.lpt_1(editorBuilder);
  }
  function createMapper_0($this, source) {
    var rootCell = new IndentCell();
    rootCell.ylp(ProjectionalSynchronizers_getInstance().jlw_1, toFirstPlaceholderWhenSettled(rootCell));
    var reloadableSynchronizer = new ReloadableSynchronizer();
    var invalidatable = initBuilder($this, source, rootCell, reloadableSynchronizer);
    var triggerContentUpdateSynchronizer = new BaseEditor$createMapper$triggerContentUpdateSynchronizer$1($this, source, invalidatable, rootCell, reloadableSynchronizer);
    return new EditorBuilderMapper(source, rootCell, reloadableSynchronizer, triggerContentUpdateSynchronizer);
  }
  function WaitingMapperFactory(mapperFactory) {
    this.mpt_1 = mapperFactory;
  }
  protoOf(WaitingMapperFactory).npt = function (source) {
    var baseMapper = this.mpt_1.zpp(source);
    baseMapper.ql9_1.olp(EffectiveVisibilityTrackingTrait_getInstance());
    return new WaitingMapper(baseMapper);
  };
  protoOf(WaitingMapperFactory).zpp = function (source) {
    return this.npt((source == null ? true : !(source == null)) ? source : THROW_CCE());
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_22(function_0) {
    this.opt_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_22).wy = function () {
    return this.opt_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_22).b4 = function () {
    return this.opt_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_22).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_22).hashCode = function () {
    return hashCode(this.b4());
  };
  function BaseEditor$createMapper$triggerContentUpdateSynchronizer$1(this$0, $source, $invalidatable, $rootCell, $reloadableSynchronizer) {
    this.cpt_1 = this$0;
    this.dpt_1 = $source;
    this.ept_1 = $invalidatable;
    this.fpt_1 = $rootCell;
    this.gpt_1 = $reloadableSynchronizer;
    this.apt_1 = Companion_getInstance_25().wr_1;
    this.bpt_1 = Companion_getInstance_25().wr_1;
  }
  protoOf(BaseEditor$createMapper$triggerContentUpdateSynchronizer$1).jla = function (ctx) {
    var newDependenciesDisposal = new CompositeDisposable([]);
    var _iterator__ex2g4s = this.cpt_1.kpt_1.k();
    while (_iterator__ex2g4s.l()) {
      var triggerDependency = _iterator__ex2g4s.m();
      var commonConfig = this.cpt_1.ups_1.cpo();
      var eventSource = triggerDependency(this.dpt_1, commonConfig);
      var handler = eventSource.p27(BaseEditor$createMapper$o$attach$lambda(this));
      newDependenciesDisposal.ur([handler]);
    }
    this.apt_1 = newDependenciesDisposal;
    handleInvalidatable(this, this.ept_1);
  };
  protoOf(BaseEditor$createMapper$triggerContentUpdateSynchronizer$1).t6m = function () {
    this.apt_1.vr();
    this.bpt_1.vr();
  };
  function BaseEditor$createMapperFactory$$inlined$mapperFactory$1(this$0) {
    this.ppt_1 = this$0;
  }
  protoOf(BaseEditor$createMapperFactory$$inlined$mapperFactory$1).qpt = function (source) {
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.BaseEditor.createMapperFactory.<anonymous>' call
    var mapper = createMapper_0(this.ppt_1, source);
    var tmp;
    if (this.ppt_1.ups_1.uph()) {
      var tmp_0 = this.ppt_1.ups_1.cpo();
      var tmp0_elvis_lhs = this.ppt_1.ups_1.tps();
      tmp = highlighted(mapper, tmp_0, tmp0_elvis_lhs == null ? EmptyErrorCheckConfig_instance : tmp0_elvis_lhs);
    } else {
      tmp = mapper;
    }
    return tmp;
  };
  protoOf(BaseEditor$createMapperFactory$$inlined$mapperFactory$1).zpp = function (source) {
    return this.qpt((source == null ? true : !(source == null)) ? source : THROW_CCE());
  };
  function BaseEditor(config, sourceClass, waitUntilReady, triggerDependencies, init) {
    RoleEditor.call(this, config, sourceClass);
    this.jpt_1 = waitUntilReady;
    this.kpt_1 = triggerDependencies;
    this.lpt_1 = init;
  }
  protoOf(BaseEditor).rpt = function (source) {
    var checkedSource = isInterface(source, DomainNode) ? source : THROW_CCE();
    return createMapper_0(this, checkedSource);
  };
  protoOf(BaseEditor).yps = function () {
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.mapperFactory' call
    var factory = new BaseEditor$createMapperFactory$$inlined$mapperFactory$1(this);
    return this.jpt_1 ? new WaitingMapperFactory(factory) : factory;
  };
  function Editor$getDefaultCompletionSuppliers$$inlined$map$1$getCompletionItems$1($matchingText, $sortPriority, $isCaseSensitive, $targetFactory, $role) {
    this.ypt_1 = $targetFactory;
    this.zpt_1 = $role;
    SimpleCompletionItem.call(this, $matchingText, VOID, $sortPriority, $isCaseSensitive);
  }
  protoOf(Editor$getDefaultCompletionSuppliers$$inlined$map$1$getCompletionItems$1).wm9 = function (text) {
    // Inline function 'jetbrains.ocelot.projectional.editor.generic.role.item.<no name provided>.getCompletionItems.<anonymous>' call
    var target = this.ypt_1();
    return this.zpt_1.qn8(target);
  };
  function getDefaultCompletionSuppliers($this) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this.fpu_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.Editor.getDefaultCompletionSuppliers.<anonymous>' call
      // Inline function 'jetbrains.ocelot.projectional.editor.generic.role.item' call
      var targetFactory = $this.spt();
      var tmp$ret$1 = new Editor$getDefaultCompletionSuppliers$$inlined$map$1(item, targetFactory);
      destination.e(tmp$ret$1);
    }
    return destination;
  }
  function Editor$getDefaultCompletionSuppliers$$inlined$map$1($matchingText, $targetFactory) {
    this.hpu_1 = $matchingText;
    this.ipu_1 = $targetFactory;
  }
  protoOf(Editor$getDefaultCompletionSuppliers$$inlined$map$1).jpu = function (contextNode, role) {
    // Inline function 'jetbrains.ocelot.projectional.cell.completion.result.simpleCompletionItem' call
    var matchingText = this.hpu_1;
    var completionItem = new Editor$getDefaultCompletionSuppliers$$inlined$map$1$getCompletionItems$1(matchingText, 0, true, this.ipu_1, role);
    return listOf(completionItem);
  };
  protoOf(Editor$getDefaultCompletionSuppliers$$inlined$map$1).dnk = function (contextNode, role) {
    return this.jpu(contextNode, role);
  };
  function Editor$getCompletionSuppliers$completionSupplier$1(this$0) {
    this.kpu_1 = this$0;
  }
  protoOf(Editor$getCompletionSuppliers$completionSupplier$1).lpu = function (contextNode, role) {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.<no name provided>.getCompletionItems.<anonymous>' call
    var completionItemsSupplier = this.kpu_1.gpu_1.npu_1;
    var suppliers = completionItemsSupplier(contextNode);
    this_0.o(suppliers);
    if (this.kpu_1.gpu_1.mpu_1) {
      this_0.o(getDefaultCompletionSuppliers(this.kpu_1));
    }
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = this_0.e4();
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.<no name provided>.getCompletionItems.<anonymous>' call
      var list = element.dnk(contextNode, role);
      addAll_1(destination, list);
    }
    return destination;
  };
  protoOf(Editor$getCompletionSuppliers$completionSupplier$1).dnk = function (contextNode, role) {
    return this.lpu(contextNode, role);
  };
  function Editor(config, sourceClass, matchingTexts, customCompletion, waitUntilReady, triggerDependencies, init) {
    BaseEditor.call(this, config, sourceClass, waitUntilReady, triggerDependencies, init);
    this.fpu_1 = matchingTexts;
    this.gpu_1 = customCompletion;
  }
  protoOf(Editor).tpt = function () {
    var completionSuppliers = this.opu();
    return toRoleCompletion(completionSuppliers);
  };
  protoOf(Editor).opu = function () {
    var tmp;
    if (this.gpu_1 == null) {
      tmp = getDefaultCompletionSuppliers(this);
    } else {
      var completionSupplier = new Editor$getCompletionSuppliers$completionSupplier$1(this);
      tmp = listOf(completionSupplier);
    }
    return tmp;
  };
  function EditorBuilderMapper(source, cell, reloadableSynchronizer, triggerDisposable) {
    Mapper.call(this, source, cell);
    this.wpu_1 = reloadableSynchronizer;
    this.xpu_1 = triggerDisposable;
  }
  protoOf(EditorBuilderMapper).llb = function (conf) {
    conf.x4v(this.wpu_1);
    conf.x4v(this.xpu_1);
  };
  function createEditorMap($this, editors) {
    // Inline function 'kotlin.collections.associateBy' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(editors, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = editors.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.HierarchyRoleEditor.createEditorMap.<anonymous>' call
      var tmp$ret$0 = element.vps_1;
      destination.r2(tmp$ret$0, element);
    }
    return destination;
  }
  function HierarchyRoleEditor$createMapperFactory$$inlined$mapperFactory$1(this$0) {
    this.ypu_1 = this$0;
  }
  protoOf(HierarchyRoleEditor$createMapperFactory$$inlined$mapperFactory$1).qpt = function (source) {
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.HierarchyRoleEditor.createMapperFactory.<anonymous>' call
    var implClass = getKClassFromExpression(source);
    var conceptClass = this.ypu_1.ups_1.ppq().f6p(implClass);
    // Inline function 'kotlin.collections.get' call
    var this_0 = this.ypu_1.cpv_1;
    var editor = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).y2(conceptClass);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (editor == null) {
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.HierarchyRoleEditor.createMapperFactory.<anonymous>.<anonymous>' call
        var message = 'cannot find editor for: ' + toString_1(conceptClass);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return editor.rpt(source);
  };
  protoOf(HierarchyRoleEditor$createMapperFactory$$inlined$mapperFactory$1).zpp = function (source) {
    return this.qpt((source == null ? true : !(source == null)) ? source : THROW_CCE());
  };
  function HierarchyRoleEditor(config, sourceClass, allEditors, editors) {
    RoleEditor.call(this, config, sourceClass);
    this.bpv_1 = editors;
    this.cpv_1 = createEditorMap(this, allEditors);
  }
  protoOf(HierarchyRoleEditor).yps = function () {
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.mapperFactory' call
    return new HierarchyRoleEditor$createMapperFactory$$inlined$mapperFactory$1(this);
  };
  protoOf(HierarchyRoleEditor).tpt = function () {
    // Inline function 'kotlin.collections.flatMap' call
    var tmp0 = this.bpv_1;
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.HierarchyRoleEditor.getRoleCompletion.<anonymous>' call
      var list = element.opu();
      addAll_1(destination, list);
    }
    return toRoleCompletion(destination);
  };
  function $prepareCOROUTINE$3(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lpv_1 = _this__u8e3s4;
  }
  protoOf($prepareCOROUTINE$3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 12;
            var tmp_0 = this;
            tmp_0.mpv_1 = this.lpv_1.lpw_1.v6m(true);
            this.npv_1 = this.mpv_1;
            this.opv_1 = this.npv_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.opv_1.l()) {
              this.y9_1 = 11;
              continue $sm;
            }

            this.ppv_1 = this.opv_1.m();
            var tmp_1 = this;
            tmp_1.qpv_1 = this.ppv_1;
            this.rpv_1 = this.qpv_1;
            this.spv_1 = this.rpv_1.h3f();
            this.tpv_1 = toOtNode(this.rpv_1).y2z();
            var tmp_2 = this;
            var tmp0 = this.tpv_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              var tmp0_safe_receiver = getReferenceTag(this.lpv_1.mpw_1.opw_1.i6m(this.spv_1), element);
              if (tmp0_safe_receiver == null)
                null;
              else {
                destination.e(tmp0_safe_receiver);
              }
            }

            tmp_2.upv_1 = destination;
            var tmp_3 = this;
            tmp_3.vpv_1 = this.upv_1;
            this.wpv_1 = this.vpv_1;
            this.xpv_1 = this.wpv_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.xpv_1.l()) {
              this.y9_1 = 10;
              continue $sm;
            }

            this.ypv_1 = this.xpv_1.m();
            var tmp_4 = this;
            tmp_4.zpv_1 = this.ypv_1;
            this.apw_1 = this.zpv_1;
            var tmp_5 = this.apw_1;
            if (!(tmp_5 instanceof RefTag))
              THROW_CCE();
            var tmp_6 = this;
            var tmp_7 = this.rpv_1;
            tmp_6.bpw_1 = (isInterface(tmp_7, TypedOtNode) ? tmp_7 : THROW_CCE()).r6m(this.apw_1);
            this.y9_1 = 3;
            suspendResult = supervise_0(this.bpw_1.o6s(), new Invalidator(), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.cpw_1 = suspendResult;
            if (this.cpw_1.c4v() == null) {
              this.y9_1 = 4;
              suspendResult = supervise_0(this.bpw_1.p6s(), new Invalidator(), VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 9;
              continue $sm;
            }

          case 4:
            this.dpw_1 = suspendResult;
            this.epw_1 = this.dpw_1.c4v();
            if (!(this.epw_1 == null)) {
              this.y9_1 = 5;
              suspendResult = supervise_0(getPresentation(this.lpv_1.mpw_1.npw_1, this.apw_1, this.epw_1), new Invalidator(), VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 8;
              continue $sm;
            }

          case 5:
            this.fpw_1 = suspendResult;
            this.gpw_1 = this.fpw_1.c4v();
            if (!(this.gpw_1 == null)) {
              this.hpw_1 = this.lpv_1.mpw_1.npw_1.j6y(this.apw_1);
              this.ipw_1 = this.hpw_1.g6u(new SourceNodeContext(this.rpv_1), TextFilter_init_$Create$_0(this.gpw_1, this.lpv_1.mpw_1.ppw_1, false));
              this.y9_1 = 6;
              suspendResult = firstOrNull_3(this.ipw_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 7;
              continue $sm;
            }

          case 6:
            var tmp0_safe_receiver_0 = suspendResult;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              depend_1(this.lpv_1.jpw_1, this.cpw_1);
              depend_1(this.lpv_1.jpw_1, this.dpw_1);
              depend_1(this.lpv_1.jpw_1, this.fpw_1);
              var tmp_8 = this.bpw_1;
              if (!isInterface(tmp_8, Reference))
                THROW_CCE();
              var tmp0_0 = this.lpv_1.kpw_1;
              var tmp1 = this.bpw_1;
              var value = tmp0_safe_receiver_0.c6u_1;
              tmp0_0.r2(tmp1, value);
            }

            this.y9_1 = 7;
            continue $sm;
          case 7:
            this.y9_1 = 8;
            continue $sm;
          case 8:
            this.y9_1 = 9;
            continue $sm;
          case 9:
            this.y9_1 = 2;
            continue $sm;
          case 10:
            this.y9_1 = 1;
            continue $sm;
          case 11:
            return new Update(this.lpv_1.jpw_1, this.lpv_1.kpw_1);
          case 12:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 12) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function Update(invalidationContext, substitutions) {
    this.qpw_1 = invalidationContext;
    this.rpw_1 = substitutions;
  }
  protoOf(Update).w4u = function () {
    return this.qpw_1.w4u();
  };
  protoOf(Update).tn6 = function () {
    this.qpw_1.vr();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.rpw_1.w().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.Update.invoke.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var reference = element.x();
      // Inline function 'kotlin.collections.component2' call
      var referenceContents = element.y();
      reference.t6s(referenceContents);
    }
  };
  function NodeWrapperReferenceAdapter$afterPaste$1($sourceItem, this$0) {
    this.lpw_1 = $sourceItem;
    this.mpw_1 = this$0;
    this.jpw_1 = new Invalidator();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.kpw_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(NodeWrapperReferenceAdapter$afterPaste$1).vr = function () {
    this.jpw_1.vr();
  };
  protoOf(NodeWrapperReferenceAdapter$afterPaste$1).nn8 = function ($completion) {
    var tmp = new $prepareCOROUTINE$3(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function NodeWrapperReferenceAdapter(resolveConfig, conceptRegistry, ignoreCase) {
    this.npw_1 = resolveConfig;
    this.opw_1 = conceptRegistry;
    this.ppw_1 = ignoreCase;
  }
  protoOf(NodeWrapperReferenceAdapter).spw = function (sourceItem) {
    return new NodeWrapperReferenceAdapter$afterPaste$1(sourceItem, this);
  };
  protoOf(NodeWrapperReferenceAdapter).mn8 = function (sourceItem) {
    return this.spw((!(sourceItem == null) ? isInterface(sourceItem, DomainNode) : false) ? sourceItem : THROW_CCE());
  };
  function _get_wrapperContext__m0ag33($this) {
    return $this.ups_1.o71();
  }
  function getItemFactory($this, itemClass, customItemFactory, canCreateNewItems) {
    var tmp;
    if (!(customItemFactory == null)) {
      tmp = RoleEditor$getItemFactory$lambda(customItemFactory, $this);
    } else if (canCreateNewItems) {
      var f = RoleEditor$getItemFactory$lambda_0($this, itemClass);
      tmp = f;
    } else {
      tmp = null;
    }
    return tmp;
  }
  function getItemFactory$default($this, itemClass, customItemFactory, canCreateNewItems, $super) {
    canCreateNewItems = canCreateNewItems === VOID ? true : canCreateNewItems;
    return getItemFactory($this, itemClass, customItemFactory, canCreateNewItems);
  }
  function getClipboardParameters($this, conceptRegistry, nodeFactory) {
    return getNodeClipboardParameters($this.vps_1, conceptRegistry, nodeFactory);
  }
  function getRoleCompletion($this, childContext, completionSupplier) {
    var tmp;
    if (completionSupplier == null) {
      tmp = $this.tpt();
    } else {
      var commonConfig = $this.ups_1.cpo();
      var resolveConfig = commonConfig;
      var coroutineScope = commonConfig;
      tmp = buildRoleCompletion(childContext, coroutineScope, _get_wrapperContext__m0ag33($this), resolveConfig, completionSupplier);
    }
    return tmp;
  }
  function RoleEditor$getItemFactory$lambda($customItemFactory, this$0) {
    return function () {
      return $customItemFactory(_get_wrapperContext__m0ag33(this$0));
    };
  }
  function RoleEditor$getItemFactory$lambda_0(this$0, $itemClass) {
    return function () {
      var conceptRegistry = this$0.ups_1.ppq();
      return createInstance(conceptRegistry, $itemClass, _get_wrapperContext__m0ag33(this$0));
    };
  }
  function RoleEditor(config, sourceClass) {
    this.ups_1 = config;
    this.vps_1 = sourceClass;
  }
  protoOf(RoleEditor).spt = function () {
    return ensureNotNull(getItemFactory$default(this, this.vps_1, null));
  };
  protoOf(RoleEditor).wps = function (childContext, newItemClass, customItemFactory, placeholderText, separator, completionSupplier, canCreateNewItems, onLastItemDeleted, conceptRegistry) {
    var clipboardParameters = getClipboardParameters(this, conceptRegistry, get_nodeFactory(_get_wrapperContext__m0ag33(this)));
    var nodeWrapperReferenceAdapter = new NodeWrapperReferenceAdapter(this.ups_1.cpo(), conceptRegistry, true);
    var itemFactory = getItemFactory(this, newItemClass, customItemFactory, canCreateNewItems);
    var roleCompletion = getRoleCompletion(this, childContext, completionSupplier);
    return new ChildrenRoleSpec(this.yps(), itemFactory, placeholderText, roleCompletion, separator, clipboardParameters, nodeWrapperReferenceAdapter, onLastItemDeleted);
  };
  protoOf(RoleEditor).xps = function (childContext, placeholderText, completionSupplier, customItemFactory, canCreateNewItems, onLastItemDeleted, canClear, conceptRegistry) {
    var clipboardParameters = getClipboardParameters(this, conceptRegistry, get_nodeFactory(_get_wrapperContext__m0ag33(this)));
    var nodeWrapperReferenceAdapter = new NodeWrapperReferenceAdapter(this.ups_1.cpo(), conceptRegistry, true);
    var roleCompletion = getRoleCompletion(this, childContext, completionSupplier);
    var itemFactory = getItemFactory(this, this.vps_1, customItemFactory, canCreateNewItems);
    return new ChildRoleSpec(this.yps(), placeholderText, itemFactory, roleCompletion, clipboardParameters, nodeWrapperReferenceAdapter, onLastItemDeleted, canClear);
  };
  function editor(config, sourceClass, init) {
    var matchingText = getMatchingText(config, sourceClass);
    var matchingTexts = listOf(matchingText);
    var tmp = emptyList();
    return new Editor(config, sourceClass, matchingTexts, null, false, tmp, editor$lambda(init));
  }
  function getMatchingText(config, sourceClass) {
    return config.ppq().e6p(sourceClass);
  }
  function editor_0(config, editorDefinition) {
    var sourceClass = editorDefinition.lpr_1;
    var matchingTexts = editorDefinition.kpr(config.ppq());
    var customCompletion = editorDefinition.npr_1;
    var waiting = editorDefinition.opr_1;
    var triggerDependencies = editorDefinition.qpr_1;
    var init = editorDefinition.rpr_1;
    return new Editor(config, sourceClass, matchingTexts, customCompletion, waiting, triggerDependencies, init);
  }
  function hierarchyEditor(config, editorDefinition) {
    var sourceClass = editorDefinition.lpr_1;
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = editorDefinition.jpr();
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      if (element instanceof EditorDefinition) {
        destination.e(element);
      }
    }
    var allEditors = getEditors(destination, config);
    var editors = getEditors(editorDefinition.zpr_1, config);
    return new HierarchyRoleEditor(config, sourceClass, allEditors, editors);
  }
  function getEditors(_this__u8e3s4, config) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(_this__u8e3s4, 10));
    var _iterator__ex2g4s = _this__u8e3s4.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.getEditors.<anonymous>' call
      var tmp$ret$0 = editor_0(config, item);
      destination.e(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.filterIsInstance' call
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var element = _iterator__ex2g4s_0.m();
      if (element instanceof Editor) {
        destination_0.e(element);
      }
    }
    return destination_0;
  }
  function editor$lambda($init) {
    return function ($this$Editor) {
      $init($this$Editor);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function SimpleEditorBuilder$addKeyPressedHandler$$inlined$keyPressedCellTrait$1($handler) {
    this.tpw_1 = $handler;
    CellTrait.call(this);
  }
  protoOf(SimpleEditorBuilder$addKeyPressedHandler$$inlined$keyPressedCellTrait$1).llm = function (cell, event) {
    return this.tpw_1(cell, event);
  };
  function SimpleEditorBuilder$invalidating$1(this$0, $execution) {
    InvalidatingEditorBuilder.call(this, $execution);
    this.vpw_1 = this$0;
  }
  protoOf(SimpleEditorBuilder$invalidating$1).upn = function () {
    return this.vpw_1.wpw_1;
  };
  protoOf(SimpleEditorBuilder$invalidating$1).k6h = function () {
    return this.vpw_1.xpw_1;
  };
  protoOf(SimpleEditorBuilder$invalidating$1).ypn = function () {
    return this.vpw_1.ypw_1;
  };
  protoOf(SimpleEditorBuilder$invalidating$1).wle = function (synchronizer) {
    this.vpw_1.wle(synchronizer);
  };
  protoOf(SimpleEditorBuilder$invalidating$1).aps = function (handler) {
    this.vpw_1.aps(handler);
  };
  protoOf(SimpleEditorBuilder$invalidating$1).bps = function (invalidationContext) {
    return this.vpw_1.bps(invalidationContext);
  };
  protoOf(SimpleEditorBuilder$invalidating$1).cps = function (body) {
    this.vpw_1.cps(body);
  };
  protoOf(SimpleEditorBuilder$invalidating$1).xpn = function (cell) {
    return this.vpw_1.xpn(cell);
  };
  protoOf(SimpleEditorBuilder$invalidating$1).wpn = function (cell) {
    this.vpw_1.wpn(cell);
  };
  protoOf(SimpleEditorBuilder$invalidating$1).zps = function (disposable) {
    this.vpw_1.zps(disposable);
  };
  protoOf(SimpleEditorBuilder$invalidating$1).opq = function (cellTrait) {
    this.vpw_1.opq(cellTrait);
  };
  function SimpleEditorBuilder$buildAsync$slambda($body, resultContinuation) {
    this.ipx_1 = $body;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SimpleEditorBuilder$buildAsync$slambda).h1l = function ($this$launchWith, $completion) {
    var tmp = this.i1l($this$launchWith, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(SimpleEditorBuilder$buildAsync$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SimpleEditorBuilder$buildAsync$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ipx_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(SimpleEditorBuilder$buildAsync$slambda).i1l = function ($this$launchWith, completion) {
    var i = new SimpleEditorBuilder$buildAsync$slambda(this.ipx_1, completion);
    i.jpx_1 = $this$launchWith;
    return i;
  };
  function SimpleEditorBuilder$buildAsync$slambda_0($body, resultContinuation) {
    var i = new SimpleEditorBuilder$buildAsync$slambda($body, resultContinuation);
    var l = function ($this$launchWith, $completion) {
      return i.h1l($this$launchWith, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function SimpleEditorBuilder(config, source, targetCell, reloadableSynchronizer) {
    this.wpw_1 = config;
    this.xpw_1 = source;
    this.ypw_1 = targetCell;
    this.zpw_1 = reloadableSynchronizer;
  }
  protoOf(SimpleEditorBuilder).upn = function () {
    return this.wpw_1;
  };
  protoOf(SimpleEditorBuilder).k6h = function () {
    return this.xpw_1;
  };
  protoOf(SimpleEditorBuilder).ypn = function () {
    return this.ypw_1;
  };
  protoOf(SimpleEditorBuilder).wpn = function (cell) {
    this.ypw_1.ilp().e(cell);
  };
  protoOf(SimpleEditorBuilder).xpn = function (cell) {
    return new SimpleEditorBuilder(this.wpw_1, this.xpw_1, cell, this.zpw_1);
  };
  protoOf(SimpleEditorBuilder).wle = function (synchronizer) {
    return this.zpw_1.wle(synchronizer);
  };
  protoOf(SimpleEditorBuilder).zps = function (disposable) {
    var synchronizer = Synchronizers_instance.rle([disposable]);
    this.wle(synchronizer);
  };
  protoOf(SimpleEditorBuilder).opq = function (cellTrait) {
    var disposable = this.ypw_1.olp(cellTrait);
    this.zps(disposable);
  };
  protoOf(SimpleEditorBuilder).aps = function (handler) {
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.keyPressedCellTrait' call
    var tmp$ret$0 = new SimpleEditorBuilder$addKeyPressedHandler$$inlined$keyPressedCellTrait$1(handler);
    return this.opq(tmp$ret$0);
  };
  protoOf(SimpleEditorBuilder).bps = function (invalidationContext) {
    var execution = new Execution(invalidationContext, EmptyCoroutineContext_getInstance());
    return new SimpleEditorBuilder$invalidating$1(this, execution);
  };
  protoOf(SimpleEditorBuilder).cps = function (body) {
    var tmp = get_internalConfig(this).cpo();
    var tmp_0 = new CellAsyncTracker(this.ypw_1);
    launchWith(tmp, tmp_0, SimpleEditorBuilder$buildAsync$slambda_0(body, null));
  };
  function _get_preservingCloner__c4xitv($this) {
    return BaseNodeCloneSupport$_get_preservingCloner_$lambda_fq5e8v;
  }
  function copyListNoPreservation($this, sourceItems) {
    var internalReferenceIds = findInternalReferenceIds($this, sourceItems);
    var oldToNewIdMap = HashMap_init_$Create$();
    var nodeCopier = new BaseNodeCloneSupport$copyListNoPreservation$nodeCopier$1($this, internalReferenceIds, oldToNewIdMap);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(sourceItems, 10));
    var _iterator__ex2g4s = sourceItems.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.clipboard.BaseNodeCloneSupport.copyListNoPreservation.<anonymous>' call
      var tmp$ret$0 = nodeCopier.s3c(toOtNode(item));
      destination.e(tmp$ret$0);
    }
    var list = destination;
    var context = get_wrapperContextOrNull(first(sourceItems));
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(list, 10));
    var _iterator__ex2g4s_0 = list.k();
    while (_iterator__ex2g4s_0.l()) {
      var item_0 = _iterator__ex2g4s_0.m();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.clipboard.BaseNodeCloneSupport.copyListNoPreservation.<anonymous>' call
      fixReferencesInsideCopiedNode($this.kpx_1, $this, item_0, oldToNewIdMap);
      var tmp = toDomainNode(item_0, context);
      var wrapper = isInterface(tmp, DomainNode) ? tmp : THROW_CCE();
      destination_0.e(wrapper);
    }
    return destination_0;
  }
  function containsRefPropertyId(_this__u8e3s4, $this, node, propertyId) {
    return !(getReferenceTag(_this__u8e3s4.i6m(node.a38_1), propertyId) == null);
  }
  function fixReferencesInsideCopiedNode(_this__u8e3s4, $this, node, oldToNewIdMap) {
    var _iterator__ex2g4s = node.y2z().k();
    while (_iterator__ex2g4s.l()) {
      var propertyId = _iterator__ex2g4s.m();
      if (containsRefPropertyId(_this__u8e3s4, $this, node, propertyId)) {
        var idProp = node.z38(propertyId);
        var referenceId = idProp.qr();
        if (!(referenceId == null)) {
          var newId = oldToNewIdMap.y2(referenceId);
          if (!(newId == null)) {
            idProp.t2c(newId);
          }
        }
      }
    }
    var _iterator__ex2g4s_0 = node.v2z().k();
    while (_iterator__ex2g4s_0.l()) {
      var childId = _iterator__ex2g4s_0.m();
      var childNodes = node.l38(childId);
      var _iterator__ex2g4s_1 = childNodes.k();
      while (_iterator__ex2g4s_1.l()) {
        var childNode = _iterator__ex2g4s_1.m();
        fixReferencesInsideCopiedNode(_this__u8e3s4, $this, childNode, oldToNewIdMap);
      }
    }
  }
  function findInternalReferenceIds($this, nodeWrappers) {
    var internalNodeIds = HashSet_init_$Create$();
    var referencedNodeIds = HashSet_init_$Create$();
    var _iterator__ex2g4s = nodeWrappers.k();
    while (_iterator__ex2g4s.l()) {
      var nodeWrapper = _iterator__ex2g4s.m();
      findInternalReferences($this.kpx_1, $this, toOtNode(nodeWrapper), internalNodeIds, referencedNodeIds);
    }
    return intersect(internalNodeIds, referencedNodeIds);
  }
  function findInternalReferences(_this__u8e3s4, $this, node, internalNodeIds, referencedNodeIds) {
    internalNodeIds.e(node.h3a());
    var _iterator__ex2g4s = node.y2z().k();
    while (_iterator__ex2g4s.l()) {
      var propertyId = _iterator__ex2g4s.m();
      if (containsRefPropertyId(_this__u8e3s4, $this, node, propertyId)) {
        var idProp = node.z38(propertyId);
        var targetId = idProp.qr();
        if (!(targetId == null)) {
          referencedNodeIds.e(targetId);
        }
      }
    }
    var _iterator__ex2g4s_0 = node.v2z().k();
    while (_iterator__ex2g4s_0.l()) {
      var childId = _iterator__ex2g4s_0.m();
      var childNodes = node.l38(childId);
      var _iterator__ex2g4s_1 = childNodes.k();
      while (_iterator__ex2g4s_1.l()) {
        var childNode = _iterator__ex2g4s_1.m();
        findInternalReferences(_this__u8e3s4, $this, childNode, internalNodeIds, referencedNodeIds);
      }
    }
  }
  function BaseNodeCloneSupport$_get_preservingCloner_$lambda_fq5e8v(node) {
    var tmp = toDomainNode(toOtNode(node).d3a(), get_wrapperContextOrNull(node));
    return isInterface(tmp, DomainNode) ? tmp : THROW_CCE();
  }
  function BaseNodeCloneSupport$copyListNoPreservation$nodeCopier$1(this$0, $internalReferenceIds, $oldToNewIdMap) {
    this.mpx_1 = this$0;
    this.npx_1 = $internalReferenceIds;
    this.opx_1 = $oldToNewIdMap;
    NodeCopier.call(this);
  }
  protoOf(BaseNodeCloneSupport$copyListNoPreservation$nodeCopier$1).r3c = function (node) {
    var newNode = this.mpx_1.lpx_1.j3f(node.a38_1);
    var oldId = node.h3a();
    if (this.npx_1.s(oldId)) {
      var newId = newNode.h3a();
      // Inline function 'kotlin.collections.set' call
      this.opx_1.r2(oldId, newId);
    }
    return newNode;
  };
  function BaseNodeCloneSupport(conceptRegistry, nodeFactory) {
    this.kpx_1 = conceptRegistry;
    this.lpx_1 = nodeFactory;
  }
  protoOf(BaseNodeCloneSupport).ppx = function (sourceItem, preserveMode) {
    var list = this.qpx(listOf(sourceItem), preserveMode);
    return first(list);
  };
  protoOf(BaseNodeCloneSupport).qni = function (sourceItem, preserveMode) {
    return this.ppx((!(sourceItem == null) ? isInterface(sourceItem, DomainNode) : false) ? sourceItem : THROW_CCE(), preserveMode);
  };
  protoOf(BaseNodeCloneSupport).qpx = function (sourceItems, preserveMode) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.require' call
    if (!!sourceItems.p()) {
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.clipboard.BaseNodeCloneSupport.copyList.<anonymous>' call
      var message = 'source items are empty';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    var tmp;
    if (preserveMode) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(sourceItems, 10));
      var _iterator__ex2g4s = sourceItems.k();
      while (_iterator__ex2g4s.l()) {
        var item = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.langDef.editorBuilder.internal.roleEditor.clipboard.BaseNodeCloneSupport.copyList.<anonymous>' call
        var tmp$ret$2 = _get_preservingCloner__c4xitv(this)(item);
        destination.e(tmp$ret$2);
      }
      tmp = destination;
    } else {
      tmp = copyListNoPreservation(this, sourceItems);
    }
    return tmp;
  };
  protoOf(BaseNodeCloneSupport).rni = function (sourceItems, preserveMode) {
    return this.qpx(sourceItems, preserveMode);
  };
  function getNodeClipboardParameters(sourceClass, conceptRegistry, nodeFactory) {
    var cloneSupport = new BaseNodeCloneSupport(conceptRegistry, nodeFactory);
    return createClipboardParameters(sourceClass, cloneSupport);
  }
  function referenceTarget(_this__u8e3s4, targetClass, childPlaceholderText, referenceTag, referenceProvider, referencedPropertySupplier, validator, options, containerInit, textCellInit) {
    options = options === VOID ? new CompletionOptions() : options;
    var tmp;
    if (referencedPropertySupplier == null) {
      tmp = referenceTarget$lambda(_this__u8e3s4, referenceTag);
    } else {
      tmp = referencedPropertySupplier;
    }
    var presentationQuery = tmp;
    var referenceTextPropSupplier = getLoopQuerySupplier(presentationQuery);
    return referenceTarget_0(_this__u8e3s4, targetClass, childPlaceholderText, referenceTag, referenceProvider, referenceTextPropSupplier, validator, options, containerInit, textCellInit);
  }
  function referenceTarget_0(_this__u8e3s4, targetClass, childPlaceholderText, referenceTag, referenceProvider, referenceTextPropSupplier, validator, options, containerInit, textCellInit) {
    var commonConfig = get_internalConfig(_this__u8e3s4).cpo();
    var refCompletion = referenceTarget$lambda_0(commonConfig, referenceTag, referenceProvider, options);
    var roleEditor = getReferenceRoleEditor(_this__u8e3s4, targetClass, referenceTag.m6p_1, referenceTextPropSupplier, refCompletion, validator, referenceProvider, containerInit, textCellInit);
    var roleSpec = new ChildRoleSpec(roleEditor.yps(), childPlaceholderText);
    var tmp = referenceTarget$lambda_1;
    var tmp_0 = referenceTarget$lambda_2(refCompletion);
    var tmp_1 = referenceTarget$lambda_3(referenceProvider);
    return extendedChild(_this__u8e3s4, roleSpec, tmp, tmp_0, VOID, tmp_1, referenceTarget$lambda_4(commonConfig, referenceProvider));
  }
  function getReferenceRoleEditor(_this__u8e3s4, targetClass, contentClass, referencedTextPropSupplier, refCompletion, validator, referenceProvider, containerInit, textCellInit) {
    var tmp = get_internalConfig(_this__u8e3s4);
    return editor(tmp, targetClass, getReferenceRoleEditor$lambda(validator, containerInit, referencedTextPropSupplier, contentClass, referenceProvider, textCellInit, refCompletion));
  }
  function $runSuspendCOROUTINE$4_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zpx_1 = _this__u8e3s4;
    this.apy_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$4_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.bpy_1 = this.apy_1;
            this.cpy_1 = this.bpy_1;
            this.y9_1 = 1;
            suspendResult = this.cpy_1.m51(this.zpx_1.dpy_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            return tmp0_elvis_lhs == null ? '<no presentation>' : tmp0_elvis_lhs;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function referenceTarget$1$$inlined$mapSuspending$1($this) {
    this.dpy_1 = $this;
  }
  protoOf(referenceTarget$1$$inlined$mapSuspending$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$4_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(referenceTarget$1$$inlined$mapSuspending$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function referenceTarget$lambda($this_referenceTarget, $referenceTag) {
    return function (target) {
      // Inline function 'jetbrains.ocelot.langDef.query.mapSuspending' call
      var this_0 = getPresentation(get_internalConfig($this_referenceTarget).cpo(), $referenceTag, target);
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      return new referenceTarget$1$$inlined$mapSuspending$1(this_0);
    };
  }
  function referenceTarget$lambda_0($commonConfig, $referenceTag, $referenceProvider, $options) {
    return function (src, cell, cellAction) {
      return completion($commonConfig, $commonConfig.j6y($referenceTag), src, $referenceProvider(src), cell, $options, cellAction);
    };
  }
  function referenceTarget$lambda_1(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function referenceTarget$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function referenceTarget$2$$inlined$propertyFromCellTrait$1($propSpec, $refCompletion, $source) {
    this.opy_1 = $propSpec;
    this.ppy_1 = $refCompletion;
    this.qpy_1 = $source;
    CellTrait.call(this);
  }
  protoOf(referenceTarget$2$$inlined$propertyFromCellTrait$1).flo = function (cell, spec) {
    var tmp;
    if (spec === this.opy_1) {
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget.<anonymous>.<anonymous>' call
      tmp = this.ppy_1(this.qpy_1, cell, referenceTarget$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function referenceTarget$lambda_2($refCompletion) {
    return function (source, trait) {
      var tmp = CompositeCellTraits_instance;
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyFromCellTrait' call
      var propSpec = Completion_getInstance().cm1_1;
      var tmp$ret$0 = new referenceTarget$2$$inlined$propertyFromCellTrait$1(propSpec, $refCompletion, source);
      return tmp.emu([tmp$ret$0, get_spaceDoesntCloseCompletion(), trait]);
    };
  }
  function referenceTarget$lambda_3($referenceProvider) {
    return function ($this$extendedChild) {
      Companion_getInstance_367().spy($this$extendedChild.ypn());
      var referenceData_0 = referenceData($this$extendedChild.ypn());
      referenceData_0.tpy($this$extendedChild.k6h(), $referenceProvider($this$extendedChild.k6h()));
      return Unit_instance;
    };
  }
  function referenceTarget$4$focusKeeper$1($this_extendedChild) {
    this.upy_1 = $this_extendedChild;
  }
  protoOf(referenceTarget$4$focusKeeper$1).vpy = function () {
    return isDescendantCellFocused(this.upy_1.ypn());
  };
  protoOf(referenceTarget$4$focusKeeper$1).wpy = function () {
    toPlaceholderOrEndOfFocusable(this.upy_1.ypn())();
  };
  function referenceTarget$lambda_4($commonConfig, $referenceProvider) {
    return function ($this$extendedChild) {
      var focusKeeper = new referenceTarget$4$focusKeeper$1($this$extendedChild);
      var tmp0 = $commonConfig;
      var tmp1 = $this$extendedChild.k6h();
      var tmp2 = $this$extendedChild.ypn();
      // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
      var asyncTracker = new CellAsyncTracker($this$extendedChild.ypn());
      var referenceData_0 = referenceData(tmp2);
      var tmp$ret$0 = ReferenceSynchronizers_getInstance().ypy(tmp0, $referenceProvider(tmp1), referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), focusKeeper, asyncTracker);
      $this$extendedChild.wle(tmp$ret$0);
      $this$extendedChild.wle(getReferenceDataMonitorSynchronizer($this$extendedChild.ypn()));
      $this$extendedChild.wle(referenceOutOfScopeSynchronizer($commonConfig, $this$extendedChild.ypn(), $referenceProvider($this$extendedChild.k6h())));
      $this$extendedChild.wle(highlightReferenceTargetOutOfSync($this$extendedChild.ypn(), $this$extendedChild.ypn().flp(ReferenceCells_getInstance().zpy_1)));
      return Unit_instance;
    };
  }
  function getReferenceRoleEditor$1$1$1$$inlined$propertyTrait$1($propSpec, $textCell, $refCompletion) {
    this.apz_1 = $propSpec;
    this.bpz_1 = $textCell;
    this.cpz_1 = $refCompletion;
    CellTrait.call(this);
  }
  protoOf(getReferenceRoleEditor$1$1$1$$inlined$propertyTrait$1).flo = function (cell, spec) {
    var tmp;
    if (spec === this.apz_1) {
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.getReferenceRoleEditor.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      var refCompletionArgs = getRefCompletionArgs(this.bpz_1);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      tmp = this.cpz_1(source, this.bpz_1, cellAction);
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function getReferenceRoleEditor$lambda$lambda$lambda($refCompletion) {
    return function (_unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var tmp = CompositeCellTraits_instance;
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.propertyTrait' call
      var propSpec = Completion_getInstance().cm1_1;
      var tmp$ret$0 = new getReferenceRoleEditor$1$1$1$$inlined$propertyTrait$1(propSpec, textCell, $refCompletion);
      return tmp.emu([tmp$ret$0, get_spaceDoesntCloseCompletion()]);
    };
  }
  function getReferenceRoleEditor$lambda$lambda($referencedTextPropSupplier, $coroutineScope, $referencedTextProp, $contentClass, $referenceProvider, $textCellInit, $refCompletion) {
    return function ($this$editableText) {
      var textPropSupplier = $referencedTextPropSupplier($this$editableText.k6h(), $coroutineScope, $this$editableText.ypn());
      $referencedTextProp._v = textPropSupplier;
      $this$editableText.wle(syncOneWay(textPropSupplier, $this$editableText.ypn().laz()));
      var disposableRefSupport = connectWithRefSupport($this$editableText.ypn(), textPropSupplier, $contentClass, $referenceProvider);
      asInternalEditorBuilder($this$editableText).zps(disposableRefSupport);
      addTraitOnAttach_0($this$editableText, getReferenceRoleEditor$lambda$lambda$lambda($refCompletion));
      $textCellInit($this$editableText);
      return Unit_instance;
    };
  }
  function getReferenceRoleEditor$1$2$1($referenceDataProp, $this_label) {
    this.fpz_1 = $referenceDataProp;
    this.gpz_1 = $this_label;
  }
  protoOf(getReferenceRoleEditor$1$2$1).vlk = function (container) {
    this.fpz_1.t2c(get_enclosingRefData(this.gpz_1.ypn()));
  };
  function getReferenceRoleEditor$1$2$textProp$1($referencedTextProp, $referenceDataProp) {
    this.lpz_1 = $referenceDataProp;
    DerivedProperty.call(this, [ensureNotNull($referencedTextProp._v), $referenceDataProp]);
  }
  protoOf(getReferenceRoleEditor$1$2$textProp$1).g2c = function () {
    var referenceData = this.lpz_1.qr();
    var tmp;
    if (referenceData == null) {
      tmp = '?';
    } else {
      var targetProp = referenceData.gpy_1;
      var tmp_0 = targetProp.qr();
      var nodeValue = (tmp_0 == null ? true : isInterface(tmp_0, DomainNode)) ? tmp_0 : THROW_CCE();
      var tmp1_elvis_lhs = nodeValue == null ? null : getDebugIdText(nodeValue);
      tmp = tmp1_elvis_lhs == null ? '?' : tmp1_elvis_lhs;
    }
    var value = tmp;
    return '(' + value + ')';
  };
  function getReferenceRoleEditor$lambda$lambda_0($referencedTextProp) {
    return function ($this$label) {
      var referenceDataProp = new ValueProperty(null);
      var tmp = $this$label.ypn();
      tmp.qln(new getReferenceRoleEditor$1$2$1(referenceDataProp, $this$label));
      var textProp = new getReferenceRoleEditor$1$2$textProp$1($referencedTextProp, referenceDataProp);
      $this$label.wle(syncOneWay(textProp, $this$label.ypn().laz()));
      return Unit_instance;
    };
  }
  function getReferenceRoleEditor$lambda($validator, $containerInit, $referencedTextPropSupplier, $contentClass, $referenceProvider, $textCellInit, $refCompletion) {
    return function ($this$editor) {
      $this$editor.ypn().ylp(Companion_getInstance_351().foy_1, true);
      $this$editor.ypn().ylp(Companion_getInstance_352().voy_1, true);
      $this$editor.ypn().ylp(Cells_getInstance().lmg_1, true);
      var coroutineScope = get_internalConfig($this$editor).cpo();
      var referencedTextProp = {_v: null};
      editableText_0($this$editor, VOID, '<no reference>', $validator, VOID, getReferenceRoleEditor$lambda$lambda($referencedTextPropSupplier, coroutineScope, referencedTextProp, $contentClass, $referenceProvider, $textCellInit, $refCompletion));
      var tmp;
      if (false) {
        label_0($this$editor, '', VOID, VOID, getReferenceRoleEditor$lambda$lambda_0(referencedTextProp));
        tmp = Unit_instance;
      }
      $containerInit($this$editor);
      return Unit_instance;
    };
  }
  function EditorMapperFactory() {
  }
  function getCollectionPlaceholderCompletionSupplier(mapper, roleCompletion) {
    var elementPlaceholder = mapper.pl9_1;
    var role = new getCollectionPlaceholderCompletionSupplier$role$1(elementPlaceholder, mapper);
    return roleCompletion.gnb(mapper, elementPlaceholder, role);
  }
  function getCollectionPlaceholderCompletionSupplier$role$1($elementPlaceholder, $mapper) {
    this.mpz_1 = $elementPlaceholder;
    this.npz_1 = $mapper;
  }
  protoOf(getCollectionPlaceholderCompletionSupplier$role$1).opz = function (target) {
    this.mpz_1.s6m(target);
    var tmp0_safe_receiver = firstOrNull_1(getMapperCellFinder(this.npz_1.mlb()).vn4(target));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ulp(ProjectionalSynchronizers_getInstance().jlw_1);
    return tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs;
  };
  protoOf(getCollectionPlaceholderCompletionSupplier$role$1).qn8 = function (target) {
    return this.opz(isInterface(target, DomainNode) ? target : THROW_CCE());
  };
  function prevCellIsPlaceholderOrNone(_this__u8e3s4, cell) {
    if (cell.llk() == null) {
      depend(_this__u8e3s4, cell.plp());
      return _this__u8e3s4.p4w(true);
    }
    var tmp0_elvis_lhs = cell.k2r();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return _this__u8e3s4.p4w(true);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var endLeafCell = tmp;
    while (true) {
      if (endLeafCell instanceof TextCell) {
        return _this__u8e3s4.p4w(depend(_this__u8e3s4, endLeafCell.elp()) && isPlaceholder(endLeafCell));
      }
      if (!(endLeafCell instanceof IndentCell)) {
        return _this__u8e3s4.p4w(false);
      }
      var tmp1_elvis_lhs = lastOrNull(depend_0(_this__u8e3s4, endLeafCell.g2r()));
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        return _this__u8e3s4.p4w(false);
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      endLeafCell = tmp_0;
    }
  }
  function getLoopQuerySupplier(property) {
    return getLoopQuerySupplier$lambda(property);
  }
  function getLoopQuery(coroutineScope, property, source, textCell) {
    var query = property(source);
    var loopingQuery = new LoopingQuery(coroutineScope.et(), query, VOID, new CellAsyncTracker(textCell));
    return withDefault(loopingQuery, '');
  }
  function getLoopQuerySupplier$lambda($property) {
    return function (target, coroutineScope, textCell) {
      return getLoopQuery(coroutineScope, $property, target, textCell);
    };
  }
  function ReferenceCells() {
    ReferenceCells_instance = this;
    this.zpy_1 = CellPropertySpec_init_$Create$('outOfSyncWithReferenceTarget', false);
  }
  var ReferenceCells_instance;
  function ReferenceCells_getInstance() {
    if (ReferenceCells_instance == null)
      new ReferenceCells();
    return ReferenceCells_instance;
  }
  function get_GET_TARGET() {
    _init_properties_ReferenceTrait_kt__jsd8bn();
    return GET_TARGET;
  }
  var GET_TARGET;
  function constantReferenceTrait(target) {
    _init_properties_ReferenceTrait_kt__jsd8bn();
    return new ReferenceTrait(constantReferenceTrait$slambda_0(target, null));
  }
  function $runSuspendCOROUTINE$5_1(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xpz_1 = _this__u8e3s4;
    this.ypz_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$5_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.zpz_1 = this.ypz_1;
            this.aq0_1 = this.zpz_1;
            this.y9_1 = 1;
            suspendResult = this.xpz_1.cq0_1.bq0_1(this.aq0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ReferenceTrait$get$1$$inlined$executeSuspendingQuery$1(this$0) {
    this.cq0_1 = this$0;
  }
  protoOf(ReferenceTrait$get$1$$inlined$executeSuspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$5_1(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ReferenceTrait$get$1$$inlined$executeSuspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function ReferenceTrait$get$slambda(this$0, resultContinuation) {
    this.lq0_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ReferenceTrait$get$slambda).nq0 = function ($completion) {
    var tmp = this.eag($completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ReferenceTrait$get$slambda).fag = function ($completion) {
    return this.nq0($completion);
  };
  protoOf(ReferenceTrait$get$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = execute_1(new ReferenceTrait$get$1$$inlined$executeSuspendingQuery$1(this.lq0_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.mq0_1 = suspendResult;
            this.z9_1 = 3;
            this.y9_1 = 4;
            continue $sm;
          case 2:
            this.z9_1 = 3;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof Error) {
              var e = this.ba_1;
              var tmp_1 = this;
              ThrowableHandlers_getInstance().ps_1.os(e);
              tmp_1.mq0_1 = null;
              this.y9_1 = 4;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 3:
            throw this.ba_1;
          case 4:
            this.z9_1 = 3;
            return this.mq0_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 3) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(ReferenceTrait$get$slambda).eag = function (completion) {
    return new ReferenceTrait$get$slambda(this.lq0_1, completion);
  };
  function ReferenceTrait$get$slambda_0(this$0, resultContinuation) {
    var i = new ReferenceTrait$get$slambda(this$0, resultContinuation);
    var l = function ($completion) {
      return i.nq0($completion);
    };
    l.$arity = 0;
    return l;
  }
  function ReferenceTrait(f) {
    CellTrait.call(this);
    this.bq0_1 = f;
  }
  protoOf(ReferenceTrait).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, get_GET_TARGET())) {
      // Inline function 'kotlin.suspend' call
      tmp = ReferenceTrait$get$slambda_0(this, null);
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function referenceTrait(reference) {
    _init_properties_ReferenceTrait_kt__jsd8bn();
    return new ReferenceTrait(referenceTrait$slambda_0(reference, null));
  }
  function constantReferenceTrait$slambda($target, resultContinuation) {
    this.wq0_1 = $target;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(constantReferenceTrait$slambda).yq0 = function ($this$ReferenceTrait, $completion) {
    var tmp = this.zq0($this$ReferenceTrait, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(constantReferenceTrait$slambda).oa = function (p1, $completion) {
    return this.yq0(p1 instanceof QueryBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(constantReferenceTrait$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return this.wq0_1;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(constantReferenceTrait$slambda).zq0 = function ($this$ReferenceTrait, completion) {
    var i = new constantReferenceTrait$slambda(this.wq0_1, completion);
    i.xq0_1 = $this$ReferenceTrait;
    return i;
  };
  function constantReferenceTrait$slambda_0($target, resultContinuation) {
    var i = new constantReferenceTrait$slambda($target, resultContinuation);
    var l = function ($this$ReferenceTrait, $completion) {
      return i.yq0($this$ReferenceTrait, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function referenceTrait$slambda($reference, resultContinuation) {
    this.iq1_1 = $reference;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(referenceTrait$slambda).yq0 = function ($this$ReferenceTrait, $completion) {
    var tmp = this.zq0($this$ReferenceTrait, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(referenceTrait$slambda).oa = function (p1, $completion) {
    return this.yq0(p1 instanceof QueryBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(referenceTrait$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.jq1_1.m51(this.iq1_1.p6s(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(referenceTrait$slambda).zq0 = function ($this$ReferenceTrait, completion) {
    var i = new referenceTrait$slambda(this.iq1_1, completion);
    i.jq1_1 = $this$ReferenceTrait;
    return i;
  };
  function referenceTrait$slambda_0($reference, resultContinuation) {
    var i = new referenceTrait$slambda($reference, resultContinuation);
    var l = function ($this$ReferenceTrait, $completion) {
      return i.yq0($this$ReferenceTrait, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var properties_initialized_ReferenceTrait_kt_7039y3;
  function _init_properties_ReferenceTrait_kt__jsd8bn() {
    if (!properties_initialized_ReferenceTrait_kt_7039y3) {
      properties_initialized_ReferenceTrait_kt_7039y3 = true;
      GET_TARGET = CellTraitPropertySpec_init_$Create$('resolveFunction', null);
    }
  }
  function focusGuarded(_this__u8e3s4, focusKeeper) {
    var writableProperty = _this__u8e3s4;
    return new focusGuarded$1(writableProperty, focusKeeper);
  }
  function guardFocus(focusKeeper, block) {
    var hadFocusBefore = focusKeeper.vpy();
    try {
      return block();
    }finally {
      if (hadFocusBefore && !focusKeeper.vpy()) {
        focusKeeper.wpy();
      }
    }
  }
  function focusGuarded$o$set$lambda($writableProperty, $newValue) {
    return function () {
      $writableProperty.t2c($newValue);
      return Unit_instance;
    };
  }
  function focusGuarded$1($writableProperty, $focusKeeper) {
    this.kq1_1 = $writableProperty;
    this.lq1_1 = $focusKeeper;
  }
  protoOf(focusGuarded$1).q10 = function (newValue) {
    if (newValue == null) {
      this.kq1_1.t2c(newValue);
    } else {
      guardFocus(this.lq1_1, focusGuarded$o$set$lambda(this.kq1_1, newValue));
    }
  };
  protoOf(focusGuarded$1).t2c = function (newValue) {
    return this.q10((newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  };
  function RefCompletionArgs(source, completionAction) {
    this.dpz_1 = source;
    this.epz_1 = completionAction;
  }
  protoOf(RefCompletionArgs).toString = function () {
    return 'RefCompletionArgs(source=' + toString_0(this.dpz_1) + ', completionAction=' + toString_1(this.epz_1) + ')';
  };
  protoOf(RefCompletionArgs).hashCode = function () {
    var result = this.dpz_1 == null ? 0 : hashCode(this.dpz_1);
    result = imul(result, 31) + hashCode(this.epz_1) | 0;
    return result;
  };
  protoOf(RefCompletionArgs).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RefCompletionArgs))
      return false;
    var tmp0_other_with_cast = other instanceof RefCompletionArgs ? other : THROW_CCE();
    if (!equals(this.dpz_1, tmp0_other_with_cast.dpz_1))
      return false;
    if (!equals(this.epz_1, tmp0_other_with_cast.epz_1))
      return false;
    return true;
  };
  function getRefCompletionArgs(textCell) {
    var referenceData = get_enclosingRefData(textCell);
    var completionAction = getRefCompletionArgs$lambda(textCell);
    var referenceDataSource = ensureNotNull(referenceData.fpy_1);
    var source = !(referenceDataSource == null) ? referenceDataSource : THROW_CCE();
    return new RefCompletionArgs(source, completionAction);
  }
  function getRefCompletionArgs$lambda$lambda($textCell, $item) {
    return function () {
      $textCell.laz().v2c($item.d6u_1);
      return Unit_instance;
    };
  }
  function getRefCompletionArgs$lambda($textCell) {
    return function (item) {
      return seqActions([getRefCompletionArgs$lambda$lambda($textCell, item), signalCompletionHappened($textCell, true, item)]);
    };
  }
  function Companion_367() {
    Companion_instance_367 = this;
    this.rpy_1 = CellPropertySpec_init_$Create$('refTargetSupport', null);
  }
  protoOf(Companion_367).spy = function (cell) {
    cell.bln(this.rpy_1, new ReferenceData_0(cell));
  };
  var Companion_instance_367;
  function Companion_getInstance_367() {
    if (Companion_instance_367 == null)
      new Companion_367();
    return Companion_instance_367;
  }
  function ReferenceData$lambda(this$0) {
    return function (it) {
      var _unary__edvuaz = this$0.kpy_1;
      this$0.kpy_1 = _unary__edvuaz.n3();
      return Unit_instance;
    };
  }
  function ReferenceData$attach$lambda(this$0) {
    return function (event) {
      this$0.jpy_1 = event.p2e_1;
      return Unit_instance;
    };
  }
  function ReferenceData_0(bigCell) {
    Companion_getInstance_367();
    this.epy_1 = bigCell;
    this.fpy_1 = null;
    this.gpy_1 = new ValueProperty(null);
    this.hpy_1 = null;
    this.ipy_1 = null;
    this.jpy_1 = null;
    this.kpy_1 = new Long(0, 0);
    this.lpy_1 = new Long(0, -2147483648);
    this.mpy_1 = false;
    this.npy_1 = null;
    this.gpy_1.p27(ReferenceData$lambda(this));
  }
  protoOf(ReferenceData_0).tpy = function (source, ref) {
    this.fpy_1 = source;
    this.hpy_1 = ref.r6s().n4z();
    var tmp = ensureNotNull(this.hpy_1);
    tmp.p27(ReferenceData$attach$lambda(this));
  };
  protoOf(ReferenceData_0).mq1 = function (inside, refContents) {
    this.lpy_1 = this.kpy_1;
    this.mpy_1 = inside;
    this.ipy_1 = refContents;
  };
  protoOf(ReferenceData_0).nq1 = function () {
    var tmp;
    var tmp_0;
    var tmp_1 = this.kpy_1;
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = this.lpy_1.i3(toLong(1));
    if (tmp_1.equals(tmp$ret$0)) {
      tmp_0 = equals(this.ipy_1, this.jpy_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.kpy_1.d1(new Long(0, 0)) > 0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  function get_enclosingRefData(_this__u8e3s4) {
    var tmp = ancestors(_this__u8e3s4);
    return first_1(filterNotNull_0(map(tmp, _get_enclosingRefData_$lambda_pshpn5)));
  }
  function referenceData(_this__u8e3s4) {
    var referenceData = ensureNotNull(_this__u8e3s4.clo(Companion_getInstance_367().rpy_1));
    return referenceData instanceof ReferenceData_0 ? referenceData : THROW_CCE();
  }
  function signalCompletionHappened(_this__u8e3s4, inside, item) {
    return signalCompletionHappened$lambda(_this__u8e3s4, inside, item);
  }
  function _get_enclosingRefData_$lambda_pshpn5(cell) {
    return cell.clo(Companion_getInstance_367().rpy_1);
  }
  function signalCompletionHappened$lambda($this_signalCompletionHappened, $inside, $item) {
    return function () {
      var referenceData = get_enclosingRefData($this_signalCompletionHappened);
      referenceData.mq1($inside, $item.c6u_1);
      return Unit_instance;
    };
  }
  function toPlaceholderOrEndOfFocusable(_this__u8e3s4) {
    return toPlaceholderOrEndOfFocusable$lambda(_this__u8e3s4);
  }
  function getReferenceDataMonitorSynchronizer(cell) {
    var referenceData_0 = referenceData(cell);
    var tmp = Synchronizers_instance;
    return tmp.qle(referenceData_0.gpy_1, getReferenceDataMonitorSynchronizer$lambda(referenceData_0, cell));
  }
  function connectWithRefSupport(textCell, currentTargetText, contentClass, referenceProvider) {
    var disposable = new CompositeDisposable([]);
    disposable.sr(whenAttached_0(textCell, connectWithRefSupport$lambda(textCell, disposable, referenceProvider, currentTargetText)));
    return disposable;
  }
  function whenAttached_0(_this__u8e3s4, f) {
    return whenAttached(_this__u8e3s4, whenAttached$lambda_0(_this__u8e3s4, f));
  }
  function eventuallyFalse(_this__u8e3s4, handler) {
    var d = _this__u8e3s4.p27(eventuallyFalse$lambda(handler));
    var tmp = eventuallyFalse$lambda_0(handler);
    return d.sr(new sam$jetbrains_ocelot_base_disposable_Disposable$0_6(tmp));
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_6(function_0) {
    this.oq1_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_6).vr = function () {
    return this.oq1_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_6).b4 = function () {
    return this.oq1_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_6).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_6).hashCode = function () {
    return hashCode(this.b4());
  };
  function toPlaceholderOrEndOfFocusable$lambda$lambda(it) {
    var tmp0_elvis_lhs = getFirstPlaceholder(it);
    return tmp0_elvis_lhs == null ? firstFocusable(it) : tmp0_elvis_lhs;
  }
  function toPlaceholderOrEndOfFocusable$lambda$lambda_0(it) {
    return toEnd_0(it);
  }
  function toPlaceholderOrEndOfFocusable$lambda($this_toPlaceholderOrEndOfFocusable) {
    return function () {
      var tmp = toPlaceholderOrEndOfFocusable$lambda$lambda;
      whenSettled($this_toPlaceholderOrEndOfFocusable, tmp, toPlaceholderOrEndOfFocusable$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function getReferenceDataMonitorSynchronizer$lambda$lambda($this$actionWhenSettled) {
    return toEnd_0($this$actionWhenSettled);
  }
  function getReferenceDataMonitorSynchronizer$lambda($referenceData, $cell) {
    return function () {
      var tmp;
      if ($referenceData.nq1()) {
        var tmp_0;
        if ($referenceData.mpy_1 && !($referenceData.npy_1 == null)) {
          var tmp_1 = ensureNotNull($referenceData.npy_1);
          tmp_0 = actionWhenSettled(tmp_1, getReferenceDataMonitorSynchronizer$lambda$lambda);
        } else {
          tmp_0 = toPlaceholderOrEndOfFocusable($cell);
        }
        var action = tmp_0;
        tmp = action();
      }
      return Unit_instance;
    };
  }
  function connectWithRefSupport$1$1($referenceData, $referenceProvider, $sourceNode) {
    this.pq1_1 = $referenceData;
    this.qq1_1 = $referenceProvider;
    this.rq1_1 = $sourceNode;
    CellTrait.call(this);
  }
  protoOf(connectWithRefSupport$1$1).bll = function (cell, spec, event) {
    if (spec === Cells_getInstance().kmg_1) {
      var derivedBecameEmpty = new DerivedEvent(event);
      this.pq1_1.epy_1.nlp(derivedBecameEmpty, Cells_getInstance().kmg_1);
      this.qq1_1(this.rq1_1).t6s(null);
      this.pq1_1.gpy_1.t2c(null);
      if (!derivedBecameEmpty.ml0_1)
        toFirstFocusable(this.pq1_1.epy_1)();
    } else {
      protoOf(CellTrait).bll.call(this, cell, spec, event);
    }
  };
  function connectWithRefSupport$lambda$lambda($referenceProvider, $sourceNode) {
    return function (it) {
      var tmp;
      if (it.p2e_1 == null) {
        $referenceProvider($sourceNode).t6s(null);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function connectWithRefSupport$lambda$lambda_0($referenceData) {
    return function (bool) {
      $referenceData.epy_1.bln(ReferenceCells_getInstance().zpy_1, bool);
      return Unit_instance;
    };
  }
  function connectWithRefSupport$lambda($textCell, $disposable, $referenceProvider, $currentTargetText) {
    return function (referenceData) {
      var tmp = referenceData.fpy_1;
      var sourceNode = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      referenceData.npy_1 = $textCell;
      $disposable.sr($textCell.olp(referenceTrait($referenceProvider(sourceNode))));
      $disposable.sr($textCell.olp(new connectWithRefSupport$1$1(referenceData, $referenceProvider, sourceNode)));
      $disposable.sr(referenceData.gpy_1.p27(connectWithRefSupport$lambda$lambda($referenceProvider, sourceNode)));
      var tmp_0 = notEqual($textCell.laz(), $currentTargetText);
      $disposable.sr(eventuallyFalse(tmp_0, connectWithRefSupport$lambda$lambda_0(referenceData)));
      return Unit_instance;
    };
  }
  function whenAttached$lambda_0($this_whenAttached, $f) {
    return function () {
      var referenceData = get_enclosingRefData($this_whenAttached);
      $f(referenceData);
      return Unit_instance;
    };
  }
  function eventuallyFalse$lambda($handler) {
    return function (event) {
      $handler(event.p2e_1);
      return Unit_instance;
    };
  }
  function eventuallyFalse$lambda_0($handler) {
    return function () {
      $handler(false);
      return Unit_instance;
    };
  }
  function referenceOutOfScopeSynchronizer(coroutineScope, cell, ref) {
    var outOfScopeMessage = new referenceOutOfScopeSynchronizer$outOfScopeMessage$1(cell, ref);
    var target = new ValueProperty(Unit_instance);
    var notResolved = and(isNull(target), not(isNull(ref.u6s())));
    var tmp = Synchronizers_instance;
    var tmp_0 = ReferenceSynchronizers_getInstance().sq1(coroutineScope, ref, target, ResolveKind_STRICT_getInstance());
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new referenceOutOfScopeSynchronizer$$inlined$forDisposable$1(notResolved, outOfScopeMessage);
    return tmp.sle([tmp_0, tmp$ret$0]);
  }
  function highlightReferenceTargetOutOfSync(cell, outOfSync) {
    var visual = new highlightReferenceTargetOutOfSync$visual$1(cell);
    return syncOneWay(outOfSync, visual);
  }
  function ReferenceSynchronizers$forReferenceTarget$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ReferenceSynchronizers$forReferenceTarget$slambda).cq2 = function (it, $completion) {
    var tmp = this.dq2(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ReferenceSynchronizers$forReferenceTarget$slambda).oa = function (p1, $completion) {
    return this.cq2(p1 instanceof Outcome ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ReferenceSynchronizers$forReferenceTarget$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = delay(new Long(300, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return true;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ReferenceSynchronizers$forReferenceTarget$slambda).dq2 = function (it, completion) {
    var i = new ReferenceSynchronizers$forReferenceTarget$slambda(completion);
    i.bq2_1 = it;
    return i;
  };
  function ReferenceSynchronizers$forReferenceTarget$slambda_0(resultContinuation) {
    var i = new ReferenceSynchronizers$forReferenceTarget$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.cq2(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ReferenceSynchronizers() {
    ReferenceSynchronizers_instance = this;
    this.xpy_1 = new Long(300, 0);
  }
  protoOf(ReferenceSynchronizers).ypy = function (coroutineScope, ref, target, resolveKind, focusKeeper, asyncTracker) {
    var tmp;
    if (focusKeeper == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.ReferenceSynchronizers.forReferenceTarget.<anonymous>' call
      tmp = focusGuarded(target, focusKeeper);
    }
    var tmp1_elvis_lhs = tmp;
    var guardedTarget = tmp1_elvis_lhs == null ? target : tmp1_elvis_lhs;
    var tmp_0 = coroutineScope.et();
    var tmp_1;
    switch (resolveKind.a3_1) {
      case 0:
        tmp_1 = ref.o6s();
        break;
      case 1:
        tmp_1 = ref.p6s();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_2 = tmp_1;
    var query = new LoopingQuery(tmp_0, tmp_2, ReferenceSynchronizers$forReferenceTarget$slambda_0(null), asyncTracker);
    return syncOneWay(asNullableProperty(query), guardedTarget);
  };
  protoOf(ReferenceSynchronizers).sq1 = function (coroutineScope, ref, target, resolveKind, focusKeeper, asyncTracker, $super) {
    focusKeeper = focusKeeper === VOID ? null : focusKeeper;
    asyncTracker = asyncTracker === VOID ? Companion_getInstance_30().g2m_1 : asyncTracker;
    return $super === VOID ? this.ypy(coroutineScope, ref, target, resolveKind, focusKeeper, asyncTracker) : $super.ypy.call(this, coroutineScope, ref, target, resolveKind, focusKeeper, asyncTracker);
  };
  var ReferenceSynchronizers_instance;
  function ReferenceSynchronizers_getInstance() {
    if (ReferenceSynchronizers_instance == null)
      new ReferenceSynchronizers();
    return ReferenceSynchronizers_instance;
  }
  var ResolveKind_STRICT_instance;
  var ResolveKind_LOOSE_instance;
  var ResolveKind_entriesInitialized;
  function ResolveKind_initEntries() {
    if (ResolveKind_entriesInitialized)
      return Unit_instance;
    ResolveKind_entriesInitialized = true;
    ResolveKind_STRICT_instance = new ResolveKind('STRICT', 0);
    ResolveKind_LOOSE_instance = new ResolveKind('LOOSE', 1);
  }
  function ResolveKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function referenceOutOfScopeSynchronizer$outOfScopeMessage$1($cell, $ref) {
    this.fq2_1 = $cell;
    this.gq2_1 = $ref;
    this.eq2_1 = Companion_getInstance_25().wr_1;
  }
  protoOf(referenceOutOfScopeSynchronizer$outOfScopeMessage$1).or = function (newValue) {
    this.eq2_1.vr();
    var tmp = this;
    var tmp_0;
    if (newValue) {
      tmp_0 = MessageController_getInstance().amn(this.fq2_1, 'out of scope (contents of reference: ' + toString_0(this.gq2_1.u6s().m2c()) + ')').sr(this.fq2_1.bln(get_RED_UNDERLINE(), true));
    } else {
      tmp_0 = Companion_getInstance_25().wr_1;
    }
    tmp.eq2_1 = tmp_0;
  };
  protoOf(referenceOutOfScopeSynchronizer$outOfScopeMessage$1).t2c = function (newValue) {
    return this.or((!(newValue == null) ? typeof newValue === 'boolean' : false) ? newValue : THROW_CCE());
  };
  function referenceOutOfScopeSynchronizer$$inlined$forDisposable$1($notResolved, $outOfScopeMessage) {
    this.iq2_1 = $notResolved;
    this.jq2_1 = $outOfScopeMessage;
    DisposableSynchronizer.call(this);
  }
  protoOf(referenceOutOfScopeSynchronizer$$inlined$forDisposable$1).dlb = function (ctx) {
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.referenceOutOfScopeSynchronizer.<anonymous>' call
    return PropertyBinding_instance.d2g(this.iq2_1, this.jq2_1);
  };
  function highlightReferenceTargetOutOfSync$visual$1($cell) {
    this.lq2_1 = $cell;
    this.kq2_1 = Companion_getInstance_25().wr_1;
  }
  protoOf(highlightReferenceTargetOutOfSync$visual$1).or = function (newValue) {
    var tmp = this;
    var tmp_0;
    if (newValue) {
      tmp_0 = this.lq2_1.bln(get_BACKGROUND(), Companion_getInstance_325().wls_1).sr(this.lq2_1.bln(get_RED_UNDERLINE(), true)).sr(MessageController_getInstance().amn(this.lq2_1, 'Reference text has been changed and is inconsistent with the current target node'));
    } else {
      this.kq2_1.vr();
      tmp_0 = Companion_getInstance_25().wr_1;
    }
    tmp.kq2_1 = tmp_0;
  };
  protoOf(highlightReferenceTargetOutOfSync$visual$1).t2c = function (newValue) {
    return this.or((!(newValue == null) ? typeof newValue === 'boolean' : false) ? newValue : THROW_CCE());
  };
  function ResolveKind_STRICT_getInstance() {
    ResolveKind_initEntries();
    return ResolveKind_STRICT_instance;
  }
  function ResolveKind_LOOSE_getInstance() {
    ResolveKind_initEntries();
    return ResolveKind_LOOSE_instance;
  }
  function findUsagesView(builder) {
    return new FindUsagesViewConfigImpl(builder);
  }
  function FindUsagesViewConfig(builder) {
    this.mq2_1 = builder;
  }
  function addDefaultUsageView(_this__u8e3s4, $this) {
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = FindUsagesViewConfigImpl$addDefaultUsageView$lambda($this);
    var triggerDependencies = emptyList();
    var tmp = getKClass(DefaultUsagePresentation);
    var def = new EditorDefinition(tmp, null, null, false, false, triggerDependencies, FindUsagesViewConfigImpl$addDefaultUsageView$lambda_0(init));
    _this__u8e3s4.nq2(def);
  }
  function showAnyNode(_this__u8e3s4, $this, node) {
    var nodeProperty = new ValueProperty(node);
    var klass = getKClassFromExpression(node);
    var tmp = get_internalConfig(_this__u8e3s4).ppq().f6p(klass);
    var concept = isInterface(tmp, KClass) ? tmp : THROW_CCE();
    child_1(_this__u8e3s4, concept, FindUsagesViewConfigImpl$showAnyNode$lambda(nodeProperty));
  }
  function FindUsagesViewConfigImpl$addDefaultUsageView$lambda(this$0) {
    return function ($this$viewFor) {
      showAnyNode($this$viewFor, this$0, $this$viewFor.k6h().z8c_1);
      return Unit_instance;
    };
  }
  function FindUsagesViewConfigImpl$addDefaultUsageView$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function FindUsagesViewConfigImpl$showAnyNode$lambda($nodeProperty) {
    return function (it) {
      return get_forQueries($nodeProperty);
    };
  }
  function FindUsagesViewConfigImpl(builder) {
    FindUsagesViewConfig.call(this, builder);
  }
  protoOf(FindUsagesViewConfigImpl).pq2 = function () {
    var impl = new FindUsagesViewBuilderImpl();
    addDefaultUsageView(impl, this);
    this.mq2_1(impl);
    return impl.qq2_1;
  };
  function FindUsagesViewBuilderImpl() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.qq2_1 = ArrayList_init_$Create$();
  }
  protoOf(FindUsagesViewBuilderImpl).nq2 = function (editor) {
    this.qq2_1.e(editor);
  };
  function HandlerRegistration() {
  }
  function Events() {
    this.rq2_1 = new CopyOnWriteHashMap();
  }
  protoOf(Events).sq2 = function (definition, value) {
    var exception = null;
    var tmp0_safe_receiver = this.rq2_1.x8u(definition);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'io.ktor.util.internal.LockFreeLinkedListHead.forEach' call
      var tmp = tmp0_safe_receiver.c17();
      var cur = tmp instanceof LockFreeLinkedListNode ? tmp : THROW_CCE();
      while (!equals(cur, tmp0_safe_receiver)) {
        if (cur instanceof HandlerRegistration) {
          // Inline function 'io.ktor.events.Events.raise.<anonymous>' call
          var registration = cur;
          try {
            var tmp_0 = registration.uq2_1;
            (typeof tmp_0 === 'function' ? tmp_0 : THROW_CCE())(value);
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              var tmp0_safe_receiver_0 = exception;
              var tmp_1;
              if (tmp0_safe_receiver_0 == null) {
                tmp_1 = null;
              } else {
                addSuppressed(tmp0_safe_receiver_0, e);
                tmp_1 = Unit_instance;
              }
              if (tmp_1 == null) {
                // Inline function 'kotlin.run' call
                // Inline function 'io.ktor.events.Events.raise.<anonymous>.<anonymous>' call
                exception = e;
              }
            } else {
              throw $p;
            }
          }
        }
        cur = cur.s8v();
      }
    }
    var tmp1_safe_receiver = exception;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp1_safe_receiver;
    }
  };
  function EventDefinition() {
  }
  function ContentConvertException(message, cause) {
    cause = cause === VOID ? null : cause;
    Exception_init_$Init$_1(message, cause, this);
    captureStack(this, ContentConvertException);
  }
  function JsonConvertException(message, cause) {
    cause = cause === VOID ? null : cause;
    ContentConvertException.call(this, message, cause);
    captureStack(this, JsonConvertException);
  }
  function Configuration$register$lambda($this$null) {
    return Unit_instance;
  }
  function Configuration_0() {
  }
  function ContentConverter() {
  }
  function deserialize_1(_this__u8e3s4, body, typeInfo, charset, $completion) {
    var tmp = new $deserializeCOROUTINE$0(_this__u8e3s4, body, typeInfo, charset, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function suitableCharset(_this__u8e3s4, defaultCharset) {
    defaultCharset = defaultCharset === VOID ? Charsets_getInstance().q8o_1 : defaultCharset;
    var tmp0_elvis_lhs = suitableCharsetOrNull(_this__u8e3s4, defaultCharset);
    return tmp0_elvis_lhs == null ? defaultCharset : tmp0_elvis_lhs;
  }
  function suitableCharsetOrNull(_this__u8e3s4, defaultCharset) {
    defaultCharset = defaultCharset === VOID ? Charsets_getInstance().q8o_1 : defaultCharset;
    var tmp0_iterator = parseAndSortHeader(_this__u8e3s4.fe(HttpHeaders_getInstance().e90_1)).k();
    while (tmp0_iterator.l()) {
      var charset = tmp0_iterator.m().ug();
      if (charset === '*')
        return defaultCharset;
      else if (Companion_instance_135.t8r(charset))
        return Companion_instance_135.s8r(charset);
    }
    return null;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_16(function_0) {
    this.mq3_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_16).d1f = function (value, $completion) {
    return this.mq3_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_16).b4 = function () {
    return this.mq3_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_16).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_16).hashCode = function () {
    return hashCode(this.b4());
  };
  function deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
    this.vq3_1 = $$this$unsafeFlow;
    this.wq3_1 = $charset;
    this.xq3_1 = $typeInfo;
    this.yq3_1 = $body;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(deserialize$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(deserialize$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(deserialize$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.aq4_1 = this.vq3_1;
            var tmp_1 = this;
            tmp_1.bq4_1 = this.zq3_1;
            this.cq4_1 = this.aq4_1;
            this.dq4_1 = this.bq4_1;
            var tmp_2 = this;
            tmp_2.eq4_1 = this.dq4_1;
            this.fq4_1 = this.eq4_1;
            this.y9_1 = 1;
            suspendResult = this.fq4_1.zq2(this.wq3_1, this.xq3_1, this.yq3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.gq4_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.cq4_1.d1f(this.gq4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(deserialize$o$collect$slambda).a1u = function (value, completion) {
    var i = new deserialize$o$collect$slambda(this.vq3_1, this.wq3_1, this.xq3_1, this.yq3_1, completion);
    i.zq3_1 = value;
    return i;
  };
  function deserialize$o$collect$slambda_0($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation) {
    var i = new deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $body, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$1_0(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pq4_1 = _this__u8e3s4;
    this.qq4_1 = collector;
  }
  protoOf($collectCOROUTINE$1_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.rq4_1 = this.qq4_1;
            this.sq4_1 = this.rq4_1;
            this.y9_1 = 1;
            var tmp_1 = deserialize$o$collect$slambda_0(this.sq4_1, this.pq4_1.uq4_1, this.pq4_1.vq4_1, this.pq4_1.wq4_1, null);
            suspendResult = this.pq4_1.tq4_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_16(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function deserialize$$inlined$map$1($this, $charset, $typeInfo, $body) {
    this.tq4_1 = $this;
    this.uq4_1 = $charset;
    this.vq4_1 = $typeInfo;
    this.wq4_1 = $body;
  }
  protoOf(deserialize$$inlined$map$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$1_0(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(deserialize$$inlined$map$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function deserialize$slambda($body, resultContinuation) {
    this.fq5_1 = $body;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(deserialize$slambda).hq5 = function (it, $completion) {
    var tmp = this.a1u(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(deserialize$slambda).oa = function (p1, $completion) {
    return this.hq5((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(deserialize$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !(this.gq5_1 == null) || this.fq5_1.z8e();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(deserialize$slambda).a1u = function (it, completion) {
    var i = new deserialize$slambda(this.fq5_1, completion);
    i.gq5_1 = it;
    return i;
  };
  function deserialize$slambda_0($body, resultContinuation) {
    var i = new deserialize$slambda($body, resultContinuation);
    var l = function (it, $completion) {
      return i.hq5(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $deserializeCOROUTINE$0(_this__u8e3s4, body, typeInfo, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.iq3_1 = _this__u8e3s4;
    this.jq3_1 = body;
    this.kq3_1 = typeInfo;
    this.lq3_1 = charset;
  }
  protoOf($deserializeCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            var this_0 = asFlow(this.iq3_1);
            var tmp_0 = new deserialize$$inlined$map$1(this_0, this.lq3_1, this.kq3_1, this.jq3_1);
            suspendResult = firstOrNull_4(tmp_0, deserialize$slambda_0(this.jq3_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            var tmp_1;
            if (!(result == null)) {
              tmp_1 = result;
            } else {
              if (!this.jq3_1.z8e()) {
                tmp_1 = this.jq3_1;
              } else {
                var tmp0_safe_receiver = this.kq3_1.b8y_1;
                if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cc()) === true) {
                  tmp_1 = NullBody_instance;
                } else {
                  throw new ContentConvertException('No suitable converter found for ' + this.kq3_1.toString());
                }
              }
            }

            return tmp_1;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function HttpClient_init_$Init$(engine, userConfig, manageEngine, $this) {
    HttpClient.call($this, engine, userConfig);
    $this.kq5_1 = manageEngine;
    return $this;
  }
  function HttpClient_init_$Create$(engine, userConfig, manageEngine) {
    return HttpClient_init_$Init$(engine, userConfig, manageEngine, objectCreate(protoOf(HttpClient)));
  }
  function HttpClient$lambda(this$0) {
    return function (it) {
      var tmp;
      if (!(it == null)) {
        cancel(this$0.iq5_1);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function HttpClient$slambda(this$0, resultContinuation) {
    this.eq6_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClient$slambda).iq6 = function ($this$intercept, call, $completion) {
    var tmp = this.jq6($this$intercept, call, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpClient$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.iq6(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpClient$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this.gq6_1;
            if (!(tmp_0 instanceof HttpClientCall)) {
              var message = 'Error: HttpClientCall expected, but found ' + toString_1(this.gq6_1) + '(' + toString_1(getKClassFromExpression(this.gq6_1)) + ').';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }

            this.y9_1 = 1;
            suspendResult = this.eq6_1.rq5_1.h8x(Unit_instance, this.gq6_1.pq6(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.hq6_1 = suspendResult;
            this.gq6_1.qq6(this.hq6_1);
            this.y9_1 = 2;
            suspendResult = this.fq6_1.m8w(this.gq6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClient$slambda).jq6 = function ($this$intercept, call, completion) {
    var i = new HttpClient$slambda(this.eq6_1, completion);
    i.fq6_1 = $this$intercept;
    i.gq6_1 = call;
    return i;
  };
  function HttpClient$slambda_0(this$0, resultContinuation) {
    var i = new HttpClient$slambda(this$0, resultContinuation);
    var l = function ($this$intercept, call, $completion) {
      return i.iq6($this$intercept, call, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpClient$lambda_0($this$install) {
    defaultTransformers($this$install);
    return Unit_instance;
  }
  function HttpClient$slambda_1(this$0, resultContinuation) {
    this.zq6_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClient$slambda_1).cq7 = function ($this$intercept, it, $completion) {
    var tmp = this.dq7($this$intercept, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpClient$slambda_1).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.cq7(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpClient$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.aq7_1.n8w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z9_1 = 3;
            this.y9_1 = 4;
            continue $sm;
          case 2:
            this.z9_1 = 3;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof Error) {
              var cause = this.ba_1;
              this.zq6_1.uq5_1.sq2(get_HttpResponseReceiveFailed(), new HttpResponseReceiveFail(this.aq7_1.i8x_1.pq6(), cause));
              throw cause;
            } else {
              throw this.ba_1;
            }

          case 3:
            throw this.ba_1;
          case 4:
            this.z9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClient$slambda_1).dq7 = function ($this$intercept, it, completion) {
    var i = new HttpClient$slambda_1(this.zq6_1, completion);
    i.aq7_1 = $this$intercept;
    i.bq7_1 = it;
    return i;
  };
  function HttpClient$slambda_2(this$0, resultContinuation) {
    var i = new HttpClient$slambda_1(this$0, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.cq7($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $executeCOROUTINE$0_0(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mq7_1 = _this__u8e3s4;
    this.nq7_1 = builder;
  }
  protoOf($executeCOROUTINE$0_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.mq7_1.uq5_1.sq2(get_HttpRequestCreated(), this.nq7_1);
            this.y9_1 = 1;
            suspendResult = this.mq7_1.oq5_1.h8x(this.nq7_1, this.nq7_1.rq7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult instanceof HttpClientCall ? suspendResult : THROW_CCE();
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function HttpClient(engine, userConfig) {
    userConfig = userConfig === VOID ? new HttpClientConfig() : userConfig;
    this.iq5_1 = engine;
    this.jq5_1 = userConfig;
    this.kq5_1 = false;
    this.lq5_1 = atomic$boolean$1(false);
    this.mq5_1 = Job_0(this.iq5_1.et().la(Key_instance_3));
    this.nq5_1 = this.iq5_1.et().ej(this.mq5_1);
    this.oq5_1 = new HttpRequestPipeline(this.jq5_1.bq8_1);
    this.pq5_1 = new HttpResponsePipeline(this.jq5_1.bq8_1);
    this.qq5_1 = new HttpSendPipeline(this.jq5_1.bq8_1);
    this.rq5_1 = new HttpReceivePipeline(this.jq5_1.bq8_1);
    this.sq5_1 = AttributesJsFn(true);
    this.tq5_1 = this.iq5_1.upn();
    this.uq5_1 = new Events();
    this.vq5_1 = new HttpClientConfig();
    if (this.kq5_1) {
      this.mq5_1.hu(HttpClient$lambda(this));
    }
    this.iq5_1.cq8(this);
    var tmp = Phases_getInstance_0().hq8_1;
    this.qq5_1.m8x(tmp, HttpClient$slambda_0(this, null));
    // Inline function 'kotlin.with' call
    // Inline function 'io.ktor.client.HttpClient.<anonymous>' call
    var $this$with = this.jq5_1;
    this.vq5_1.iq8(Plugin_getInstance_2());
    this.vq5_1.iq8(Plugin_getInstance());
    if ($this$with.zq7_1) {
      this.vq5_1.jq8('DefaultTransformers', HttpClient$lambda_0);
    }
    this.vq5_1.iq8(Plugin_getInstance_3());
    this.vq5_1.iq8(Companion_getInstance_370());
    if ($this$with.yq7_1) {
      this.vq5_1.iq8(Plugin_getInstance_1());
    }
    this.vq5_1.kq8($this$with);
    if ($this$with.zq7_1) {
      this.vq5_1.iq8(Plugin_getInstance_0());
    }
    addDefaultResponseValidation(this.vq5_1);
    this.vq5_1.cq8(this);
    var tmp_0 = Phases_getInstance_1().lq8_1;
    this.pq5_1.m8x(tmp_0, HttpClient$slambda_2(this, null));
  }
  protoOf(HttpClient).et = function () {
    return this.nq5_1;
  };
  protoOf(HttpClient).qq8 = function (builder, $completion) {
    var tmp = new $executeCOROUTINE$0_0(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpClient).toString = function () {
    return 'HttpClient[' + toString_1(this.iq5_1) + ']';
  };
  function HttpClient_0(engineFactory, block) {
    var tmp;
    if (block === VOID) {
      tmp = HttpClient$lambda_1;
    } else {
      tmp = block;
    }
    block = tmp;
    // Inline function 'kotlin.apply' call
    var this_0 = new HttpClientConfig();
    block(this_0);
    var config = this_0;
    var engine = engineFactory.rq8(config.xq7_1);
    var client = HttpClient_init_$Create$(engine, config, true);
    var tmp_0 = ensureNotNull(client.nq5_1.la(Key_instance_3));
    tmp_0.hu(HttpClient$lambda_2(engine));
    return client;
  }
  function HttpClient$lambda_1($this$null) {
    return Unit_instance;
  }
  function HttpClient$lambda_2($engine) {
    return function (it) {
      $engine.up();
      return Unit_instance;
    };
  }
  function HttpClientConfig$engineConfig$lambda($this$null) {
    return Unit_instance;
  }
  function HttpClientConfig$install$lambda($this$null) {
    return Unit_instance;
  }
  function HttpClientConfig$install$lambda_0($previousConfigBlock, $configure) {
    return function ($this$null) {
      var tmp0_safe_receiver = $previousConfigBlock;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver($this$null);
      $configure(!($this$null == null) ? $this$null : THROW_CCE());
      return Unit_instance;
    };
  }
  function HttpClientConfig$install$lambda$lambda() {
    return AttributesJsFn(true);
  }
  function HttpClientConfig$install$lambda_1($plugin) {
    return function (scope) {
      var tmp = get_PLUGIN_INSTALLED_LIST();
      var attributes = scope.sq5_1.p8s(tmp, HttpClientConfig$install$lambda$lambda);
      var config = ensureNotNull(scope.vq5_1.vq7_1.y2($plugin.x()));
      var pluginData = $plugin.sq8(config);
      $plugin.tq8(pluginData, scope);
      attributes.n8s($plugin.x(), pluginData);
      return Unit_instance;
    };
  }
  function HttpClientConfig() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.uq7_1 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.vq7_1 = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.wq7_1 = LinkedHashMap_init_$Create$();
    var tmp_2 = this;
    tmp_2.xq7_1 = HttpClientConfig$engineConfig$lambda;
    this.yq7_1 = true;
    this.zq7_1 = true;
    this.aq8_1 = false;
    this.bq8_1 = PlatformUtils_getInstance().d8u_1;
  }
  protoOf(HttpClientConfig).uq8 = function (plugin, configure) {
    var previousConfigBlock = this.vq7_1.y2(plugin.x());
    var tmp0 = this.vq7_1;
    var tmp1 = plugin.x();
    // Inline function 'kotlin.collections.set' call
    var value = HttpClientConfig$install$lambda_0(previousConfigBlock, configure);
    tmp0.r2(tmp1, value);
    if (this.uq7_1.w2(plugin.x()))
      return Unit_instance;
    var tmp3 = this.uq7_1;
    var tmp4 = plugin.x();
    // Inline function 'kotlin.collections.set' call
    var value_0 = HttpClientConfig$install$lambda_1(plugin);
    tmp3.r2(tmp4, value_0);
  };
  protoOf(HttpClientConfig).iq8 = function (plugin, configure, $super) {
    var tmp;
    if (configure === VOID) {
      tmp = HttpClientConfig$install$lambda;
    } else {
      tmp = configure;
    }
    configure = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.uq8(plugin, configure);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.uq8.call(this, plugin, configure);
    }
    return tmp_0;
  };
  protoOf(HttpClientConfig).jq8 = function (key, block) {
    // Inline function 'kotlin.collections.set' call
    this.wq7_1.r2(key, block);
  };
  protoOf(HttpClientConfig).cq8 = function (client) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.uq7_1.v2().k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.client.HttpClientConfig.install.<anonymous>' call
      // Inline function 'kotlin.apply' call
      element(client);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = this.wq7_1.v2().k();
    while (_iterator__ex2g4s_0.l()) {
      var element_0 = _iterator__ex2g4s_0.m();
      // Inline function 'io.ktor.client.HttpClientConfig.install.<anonymous>' call
      // Inline function 'kotlin.apply' call
      element_0(client);
    }
  };
  protoOf(HttpClientConfig).kq8 = function (other) {
    this.yq7_1 = other.yq7_1;
    this.zq7_1 = other.zq7_1;
    this.aq8_1 = other.aq8_1;
    var tmp0 = this.uq7_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map = other.uq7_1;
    tmp0.t2(map);
    var tmp2 = this.vq7_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map_0 = other.vq7_1;
    tmp2.t2(map_0);
    var tmp4 = this.wq7_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map_1 = other.wq7_1;
    tmp4.t2(map_1);
  };
  function HttpClientCall_init_$Init$(client, requestData, responseData, $this) {
    HttpClientCall.call($this, client);
    $this.mq6_1 = new DefaultHttpRequest($this, requestData);
    $this.nq6_1 = new DefaultHttpResponse($this, responseData);
    var tmp = responseData.zq8_1;
    if (!isInterface(tmp, ByteReadChannel_1)) {
      $this.cq9().n8s(Companion_getInstance_368().dq9_1, responseData.zq8_1);
    }
    return $this;
  }
  function HttpClientCall_init_$Create$(client, requestData, responseData) {
    return HttpClientCall_init_$Init$(client, requestData, responseData, objectCreate(protoOf(HttpClientCall)));
  }
  function Companion_368() {
    Companion_instance_368 = this;
    this.dq9_1 = new AttributeKey('CustomResponse');
  }
  var Companion_instance_368;
  function Companion_getInstance_368() {
    if (Companion_instance_368 == null)
      new Companion_368();
    return Companion_instance_368;
  }
  function $bodyNullableCOROUTINE$1(_this__u8e3s4, info, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mq9_1 = _this__u8e3s4;
    this.nq9_1 = info;
  }
  protoOf($bodyNullableCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 10;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.oq9_1 = Unit_instance;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.z9_1 = 9;
            this.z9_1 = 8;
            if (instanceOf(this.mq9_1.pq6(), this.nq9_1.z8x_1)) {
              this.oq9_1 = this.mq9_1.pq6();
              this.z9_1 = 10;
              this.y9_1 = 7;
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            if (!this.mq9_1.tq9() && !this.mq9_1.lq6_1.atomicfu$compareAndSet(false, true)) {
              throw new DoubleReceiveException(this.mq9_1);
            }

            this.pq9_1 = this.mq9_1.cq9().l8s(Companion_getInstance_368().dq9_1);
            if (this.pq9_1 == null) {
              this.y9_1 = 4;
              suspendResult = this.mq9_1.uq9(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.qq9_1 = this.pq9_1;
              this.y9_1 = 5;
              continue $sm;
            }

          case 4:
            this.qq9_1 = suspendResult;
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.rq9_1 = this.qq9_1;
            this.sq9_1 = new HttpResponseContainer(this.nq9_1, this.rq9_1);
            this.y9_1 = 6;
            suspendResult = this.mq9_1.kq6_1.pq5_1.h8x(this.mq9_1, this.sq9_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var ARGUMENT = suspendResult;
            var this_0 = ARGUMENT.wq9_1;
            var tmp_0;
            if (!equals(this_0, NullBody_instance)) {
              tmp_0 = this_0;
            } else {
              tmp_0 = null;
            }

            var result = tmp_0;
            if (!(result == null) && !instanceOf(result, this.nq9_1.z8x_1)) {
              var from = getKClassFromExpression(result);
              var to = this.nq9_1.z8x_1;
              throw new NoTransformationFoundException(this.mq9_1.pq6(), from, to);
            }

            this.oq9_1 = result;
            this.z9_1 = 10;
            this.y9_1 = 7;
            var tmp_1 = this;
            continue $sm;
          case 7:
            var tmp_2 = this.oq9_1;
            this.z9_1 = 10;
            complete_0(this.mq9_1.pq6());
            return tmp_2;
          case 8:
            this.z9_1 = 9;
            var tmp_3 = this.ba_1;
            if (tmp_3 instanceof Error) {
              var cause = this.ba_1;
              var tmp_4 = this;
              cancel_0(this.mq9_1.pq6(), 'Receive failed', cause);
              throw cause;
            } else {
              throw this.ba_1;
            }

          case 9:
            this.z9_1 = 10;
            var t = this.ba_1;
            complete_0(this.mq9_1.pq6());
            throw t;
          case 10:
            throw this.ba_1;
          case 11:
            this.z9_1 = 10;
            complete_0(this.mq9_1.pq6());
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 10) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function HttpClientCall(client) {
    Companion_getInstance_368();
    this.kq6_1 = client;
    this.lq6_1 = atomic$boolean$1(false);
    this.oq6_1 = false;
  }
  protoOf(HttpClientCall).et = function () {
    return this.pq6().et();
  };
  protoOf(HttpClientCall).cq9 = function () {
    return this.xq9().cq9();
  };
  protoOf(HttpClientCall).xq9 = function () {
    var tmp = this.mq6_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('request');
    }
  };
  protoOf(HttpClientCall).pq6 = function () {
    var tmp = this.nq6_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('response');
    }
  };
  protoOf(HttpClientCall).tq9 = function () {
    return this.oq6_1;
  };
  protoOf(HttpClientCall).uq9 = function ($completion) {
    return this.pq6().g67();
  };
  protoOf(HttpClientCall).yq9 = function (info, $completion) {
    var tmp = new $bodyNullableCOROUTINE$1(this, info, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpClientCall).toString = function () {
    return 'HttpClientCall[' + this.xq9().jbu().toString() + ', ' + this.pq6().zq9().toString() + ']';
  };
  protoOf(HttpClientCall).qq6 = function (response) {
    this.nq6_1 = response;
  };
  function DoubleReceiveException(call) {
    IllegalStateException_init_$Init$(this);
    captureStack(this, DoubleReceiveException);
    this.aqa_1 = 'Response already received: ' + call.toString();
  }
  protoOf(DoubleReceiveException).t1 = function () {
    return this.aqa_1;
  };
  function NoTransformationFoundException(response, from, to) {
    UnsupportedOperationException_init_$Init$(this);
    captureStack(this, NoTransformationFoundException);
    this.bqa_1 = trimIndent("\n        Expected response body of the type '" + toString_1(to) + "' but was '" + toString_1(from) + "'\n        In response from `" + get_request(response).jbu().toString() + '`\n        Response status `' + response.zq9().toString() + '`\n        Response header `ContentType: ' + response.g94().fe(HttpHeaders_getInstance().v90_1) + '` \n        Request header `Accept: ' + get_request(response).g94().fe(HttpHeaders_getInstance().d90_1) + '`\n        \n        You can read how to resolve NoTransformationFoundException at FAQ: \n        https://ktor.io/docs/faq.html#no-transformation-found-exception\n    ');
  }
  protoOf(NoTransformationFoundException).t1 = function () {
    return this.bqa_1;
  };
  function save(_this__u8e3s4, $completion) {
    var tmp = new $saveCOROUTINE$3(_this__u8e3s4, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function SavedHttpCall(client, request, response, responseBody) {
    HttpClientCall.call(this, client);
    this.qqa_1 = responseBody;
    this.mq6_1 = new SavedHttpRequest(this, request);
    this.nq6_1 = new SavedHttpResponse(this, this.qqa_1, response);
    this.rqa_1 = true;
  }
  protoOf(SavedHttpCall).uq9 = function ($completion) {
    return ByteReadChannel(this.qqa_1);
  };
  protoOf(SavedHttpCall).tq9 = function () {
    return this.rqa_1;
  };
  function SavedHttpRequest(call, origin) {
    this.sqa_1 = call;
    this.tqa_1 = origin;
  }
  protoOf(SavedHttpRequest).uqa = function () {
    return this.sqa_1;
  };
  protoOf(SavedHttpRequest).cq9 = function () {
    return this.tqa_1.cq9();
  };
  protoOf(SavedHttpRequest).g67 = function () {
    return this.tqa_1.g67();
  };
  protoOf(SavedHttpRequest).et = function () {
    return this.tqa_1.et();
  };
  protoOf(SavedHttpRequest).g94 = function () {
    return this.tqa_1.g94();
  };
  protoOf(SavedHttpRequest).vqa = function () {
    return this.tqa_1.vqa();
  };
  protoOf(SavedHttpRequest).jbu = function () {
    return this.tqa_1.jbu();
  };
  function SavedHttpResponse(call, body, origin) {
    HttpResponse.call(this);
    this.wqa_1 = call;
    this.xqa_1 = Job_0();
    this.yqa_1 = origin.zq9();
    this.zqa_1 = origin.gko();
    this.aqb_1 = origin.fqb();
    this.bqb_1 = origin.gqb();
    this.cqb_1 = origin.g94();
    this.dqb_1 = origin.et().ej(this.xqa_1);
    this.eqb_1 = ByteReadChannel(body);
  }
  protoOf(SavedHttpResponse).uqa = function () {
    return this.wqa_1;
  };
  protoOf(SavedHttpResponse).zq9 = function () {
    return this.yqa_1;
  };
  protoOf(SavedHttpResponse).gko = function () {
    return this.zqa_1;
  };
  protoOf(SavedHttpResponse).fqb = function () {
    return this.aqb_1;
  };
  protoOf(SavedHttpResponse).gqb = function () {
    return this.bqb_1;
  };
  protoOf(SavedHttpResponse).g94 = function () {
    return this.cqb_1;
  };
  protoOf(SavedHttpResponse).et = function () {
    return this.dqb_1;
  };
  protoOf(SavedHttpResponse).g67 = function () {
    return this.eqb_1;
  };
  function $saveCOROUTINE$3(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kqa_1 = _this__u8e3s4;
  }
  protoOf($saveCOROUTINE$3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.kqa_1.pq6().g67().d8k(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var responseBody = readBytes(ARGUMENT);
            return new SavedHttpCall(this.kqa_1.kq6_1, this.kqa_1.xq9(), this.kqa_1.pq6(), responseBody);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function UnsupportedContentTypeException(content) {
    IllegalStateException_init_$Init$_0('Failed to write body: ' + toString_1(getKClassFromExpression(content)), this);
    captureStack(this, UnsupportedContentTypeException);
  }
  function ObservableContent$content$slambda(this$0, resultContinuation) {
    this.pqb_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ObservableContent$content$slambda).rqb = function ($this$writer, $completion) {
    var tmp = this.sqb($this$writer, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ObservableContent$content$slambda).oa = function (p1, $completion) {
    return this.rqb((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ObservableContent$content$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.pqb_1.uqb_1.o99(this.qqb_1.y15(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ObservableContent$content$slambda).sqb = function ($this$writer, completion) {
    var i = new ObservableContent$content$slambda(this.pqb_1, completion);
    i.qqb_1 = $this$writer;
    return i;
  };
  function ObservableContent$content$slambda_0(this$0, resultContinuation) {
    var i = new ObservableContent$content$slambda(this$0, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.rqb($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ObservableContent(delegate, callContext, listener) {
    ReadChannelContent.call(this);
    this.uqb_1 = delegate;
    this.vqb_1 = callContext;
    this.wqb_1 = listener;
    var tmp = this;
    var tmp0_subject = this.uqb_1;
    var tmp_0;
    if (tmp0_subject instanceof ByteArrayContent_0) {
      tmp_0 = ByteReadChannel(this.uqb_1.j99());
    } else {
      if (tmp0_subject instanceof ProtocolUpgrade) {
        throw new UnsupportedContentTypeException(this.uqb_1);
      } else {
        if (tmp0_subject instanceof NoContent) {
          tmp_0 = Companion_getInstance_133().g8l();
        } else {
          if (tmp0_subject instanceof ReadChannelContent) {
            tmp_0 = this.uqb_1.m99();
          } else {
            if (tmp0_subject instanceof WriteChannelContent) {
              var tmp_1 = GlobalScope_instance;
              tmp_0 = writer(tmp_1, this.vqb_1, true, ObservableContent$content$slambda_0(this, null)).y15();
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
    tmp.xqb_1 = tmp_0;
  }
  protoOf(ObservableContent).h99 = function () {
    return this.uqb_1.h99();
  };
  protoOf(ObservableContent).i99 = function () {
    return this.uqb_1.i99();
  };
  protoOf(ObservableContent).g94 = function () {
    return this.uqb_1.g94();
  };
  protoOf(ObservableContent).m99 = function () {
    return observable(this.xqb_1, this.vqb_1, this.i99(), this.wqb_1);
  };
  function get_CALL_COROUTINE() {
    _init_properties_HttpClientEngine_kt__h91z5h();
    return CALL_COROUTINE;
  }
  var CALL_COROUTINE;
  function get_CLIENT_CONFIG() {
    _init_properties_HttpClientEngine_kt__h91z5h();
    return CLIENT_CONFIG;
  }
  var CLIENT_CONFIG;
  function HttpClientEngine$install$slambda$lambda($client, $response) {
    return function (it) {
      var tmp;
      if (!(it == null)) {
        $client.uq5_1.sq2(get_HttpResponseCancelled(), $response);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function _get_closed__iwkfs1($this) {
    var tmp0_safe_receiver = $this.et().la(Key_instance_3);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ft();
    return !(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
  }
  function executeWithinCallContext($this, requestData, $completion) {
    var tmp = new $executeWithinCallContextCOROUTINE$4($this, requestData, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function checkExtensions($this, requestData) {
    var tmp0_iterator = requestData.qqc_1.k();
    while (tmp0_iterator.l()) {
      var requestedExtension = tmp0_iterator.m();
      // Inline function 'kotlin.require' call
      if (!$this.rqc().s(requestedExtension)) {
        // Inline function 'io.ktor.client.engine.HttpClientEngine.checkExtensions.<anonymous>' call
        var message = "Engine doesn't support " + toString_1(requestedExtension);
        throw IllegalArgumentException_init_$Create$_0(toString_1(message));
      }
    }
  }
  function HttpClientEngine$install$slambda($client, this$0, resultContinuation) {
    this.aqd_1 = $client;
    this.bqd_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClientEngine$install$slambda).iq6 = function ($this$intercept, content, $completion) {
    var tmp = this.jq6($this$intercept, content, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpClientEngine$install$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.iq6(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpClientEngine$install$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            var this_0 = new HttpRequestBuilder();
            this_0.jqd(this.cqd_1.i8x_1);
            var body = this.dqd_1;
            if (body == null) {
              this_0.rq7_1 = NullBody_instance;
              var tmp_1 = JsType_instance;
              var tmp_2 = PrimitiveClasses_getInstance().dc();
              var tmp_3;
              try {
                tmp_3 = createKType(PrimitiveClasses_getInstance().dc(), arrayOf([]), false);
              } catch ($p) {
                var tmp_4;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_4 = null;
                } else {
                  throw $p;
                }
                tmp_3 = tmp_4;
              }
              this_0.kqd(typeInfoImpl(tmp_1, tmp_2, tmp_3));
            } else {
              if (body instanceof OutgoingContent) {
                this_0.rq7_1 = body;
                this_0.kqd(null);
              } else {
                this_0.rq7_1 = body;
                var tmp_5 = JsType_instance;
                var tmp_6 = PrimitiveClasses_getInstance().dc();
                var tmp_7;
                try {
                  tmp_7 = createKType(PrimitiveClasses_getInstance().dc(), arrayOf([]), false);
                } catch ($p) {
                  var tmp_8;
                  if ($p instanceof Error) {
                    var cause_0 = $p;
                    tmp_8 = null;
                  } else {
                    throw $p;
                  }
                  tmp_7 = tmp_8;
                }
                this_0.kqd(typeInfoImpl(tmp_5, tmp_6, tmp_7));
              }
            }

            tmp_0.eqd_1 = this_0;
            this.aqd_1.uq5_1.sq2(get_HttpRequestIsReadyForSending(), this.eqd_1);
            var tmp_9 = this;
            var this_1 = this.eqd_1.k2p();
            this_1.pqc_1.n8s(get_CLIENT_CONFIG(), this.aqd_1.vq5_1);
            tmp_9.fqd_1 = this_1;
            validateHeaders(this.fqd_1);
            checkExtensions(this.bqd_1, this.fqd_1);
            this.y9_1 = 1;
            suspendResult = executeWithinCallContext(this.bqd_1, this.fqd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.gqd_1 = suspendResult;
            this.hqd_1 = HttpClientCall_init_$Create$(this.aqd_1, this.fqd_1, this.gqd_1);
            this.iqd_1 = this.hqd_1.pq6();
            this.aqd_1.uq5_1.sq2(get_HttpResponseReceived(), this.iqd_1);
            var tmp_10 = get_job(this.iqd_1.et());
            tmp_10.hu(HttpClientEngine$install$slambda$lambda(this.aqd_1, this.iqd_1));
            this.y9_1 = 2;
            suspendResult = this.cqd_1.m8w(this.hqd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClientEngine$install$slambda).jq6 = function ($this$intercept, content, completion) {
    var i = new HttpClientEngine$install$slambda(this.aqd_1, this.bqd_1, completion);
    i.cqd_1 = $this$intercept;
    i.dqd_1 = content;
    return i;
  };
  function HttpClientEngine$install$slambda_0($client, this$0, resultContinuation) {
    var i = new HttpClientEngine$install$slambda($client, this$0, resultContinuation);
    var l = function ($this$intercept, content, $completion) {
      return i.iq6($this$intercept, content, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpClientEngine$executeWithinCallContext$slambda(this$0, $requestData, resultContinuation) {
    this.tqd_1 = this$0;
    this.uqd_1 = $requestData;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).wqd = function ($this$async, $completion) {
    var tmp = this.i1l($this$async, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).oa = function (p1, $completion) {
    return this.wqd((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            if (_get_closed__iwkfs1(this.tqd_1)) {
              throw new ClientEngineClosedException();
            }

            this.y9_1 = 1;
            suspendResult = this.tqd_1.xqd(this.uqd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).i1l = function ($this$async, completion) {
    var i = new HttpClientEngine$executeWithinCallContext$slambda(this.tqd_1, this.uqd_1, completion);
    i.vqd_1 = $this$async;
    return i;
  };
  function HttpClientEngine$executeWithinCallContext$slambda_0(this$0, $requestData, resultContinuation) {
    var i = new HttpClientEngine$executeWithinCallContext$slambda(this$0, $requestData, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.wqd($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $executeWithinCallContextCOROUTINE$4(_this__u8e3s4, requestData, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gqc_1 = _this__u8e3s4;
    this.hqc_1 = requestData;
  }
  protoOf($executeWithinCallContextCOROUTINE$4).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = createCallContext(this.gqc_1, this.hqc_1.oqc_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.iqc_1 = suspendResult;
            this.jqc_1 = this.iqc_1.ej(new KtorCallContextElement(this.iqc_1));
            this.y9_1 = 2;
            suspendResult = async(this.gqc_1, this.jqc_1, VOID, HttpClientEngine$executeWithinCallContext$slambda_0(this.gqc_1, this.hqc_1, null)).gw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function HttpClientEngine() {
  }
  function validateHeaders(request) {
    _init_properties_HttpClientEngine_kt__h91z5h();
    var requestHeaders = request.mqc_1;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = requestHeaders.h8u();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.client.engine.validateHeaders.<anonymous>' call
      if (HttpHeaders_getInstance().y93_1.s(element)) {
        destination.e(element);
      }
    }
    var unsafeRequestHeaders = destination;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!unsafeRequestHeaders.p()) {
      throw new UnsafeHeaderException(toString_1(unsafeRequestHeaders));
    }
  }
  function createCallContext(_this__u8e3s4, parentJob, $completion) {
    var callJob = Job_0(parentJob);
    var callContext = _this__u8e3s4.et().ej(callJob).ej(get_CALL_COROUTINE());
    $l$block: {
      // Inline function 'io.ktor.client.engine.attachToUserJob' call
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp0_elvis_lhs = $completion.ea().la(Key_instance_3);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var userJob = tmp;
      var cleanupHandler = userJob.ju(true, VOID, createCallContext$lambda(callJob));
      callJob.hu(createCallContext$lambda_0(cleanupHandler));
    }
    return callContext;
  }
  function createCallContext$lambda($callJob) {
    return function (cause) {
      if (cause == null)
        return Unit_instance;
      $callJob.ou(CancellationException_init_$Create$_0(cause.message));
      return Unit_instance;
    };
  }
  function createCallContext$lambda_0($cleanupHandler) {
    return function (it) {
      $cleanupHandler.vr();
      return Unit_instance;
    };
  }
  var properties_initialized_HttpClientEngine_kt_5uiebb;
  function _init_properties_HttpClientEngine_kt__h91z5h() {
    if (!properties_initialized_HttpClientEngine_kt_5uiebb) {
      properties_initialized_HttpClientEngine_kt_5uiebb = true;
      CALL_COROUTINE = new CoroutineName('call-context');
      CLIENT_CONFIG = new AttributeKey('client-config');
    }
  }
  function ClientEngineClosedException(cause) {
    cause = cause === VOID ? null : cause;
    IllegalStateException_init_$Init$_0('Client already closed', this);
    captureStack(this, ClientEngineClosedException);
    this.yqd_1 = cause;
  }
  protoOf(ClientEngineClosedException).u1 = function () {
    return this.yqd_1;
  };
  function HttpClientEngineBase$coroutineContext$delegate$lambda(this$0) {
    return function () {
      return SilentSupervisor().ej(this$0.dqe()).ej(new CoroutineName(this$0.zqd_1 + '-context'));
    };
  }
  function HttpClientEngineBase(engineName) {
    this.zqd_1 = engineName;
    this.aqe_1 = atomic$boolean$1(false);
    this.bqe_1 = ioDispatcher();
    var tmp = this;
    tmp.cqe_1 = lazy_0(HttpClientEngineBase$coroutineContext$delegate$lambda(this));
  }
  protoOf(HttpClientEngineBase).dqe = function () {
    return this.bqe_1;
  };
  protoOf(HttpClientEngineBase).et = function () {
    var tmp0 = this.cqe_1;
    // Inline function 'kotlin.getValue' call
    coroutineContext$factory();
    return tmp0.y();
  };
  protoOf(HttpClientEngineBase).up = function () {
    if (!this.aqe_1.atomicfu$compareAndSet(false, true))
      return Unit_instance;
    var tmp = this.et().la(Key_instance_3);
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, CompletableJob) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var requestJob = tmp_0;
    requestJob.oz();
  };
  function coroutineContext$factory() {
    return getPropertyCallableRef('coroutineContext', 1, KProperty1, function (receiver) {
      return receiver.et();
    }, null);
  }
  function get_ENGINE_CAPABILITIES_KEY() {
    _init_properties_HttpClientEngineCapability_kt__ifvyst();
    return ENGINE_CAPABILITIES_KEY;
  }
  var ENGINE_CAPABILITIES_KEY;
  var DEFAULT_CAPABILITIES;
  var properties_initialized_HttpClientEngineCapability_kt_qarzcf;
  function _init_properties_HttpClientEngineCapability_kt__ifvyst() {
    if (!properties_initialized_HttpClientEngineCapability_kt_qarzcf) {
      properties_initialized_HttpClientEngineCapability_kt_qarzcf = true;
      ENGINE_CAPABILITIES_KEY = new AttributeKey('EngineCapabilities');
      DEFAULT_CAPABILITIES = setOf(Plugin_getInstance_4());
    }
  }
  function HttpClientEngineConfig() {
    this.eqe_1 = 4;
    this.fqe_1 = false;
    this.gqe_1 = null;
  }
  function get_KTOR_DEFAULT_USER_AGENT() {
    _init_properties_Utils_kt__jo07cx();
    return KTOR_DEFAULT_USER_AGENT;
  }
  var KTOR_DEFAULT_USER_AGENT;
  function get_DATE_HEADERS() {
    _init_properties_Utils_kt__jo07cx();
    return DATE_HEADERS;
  }
  var DATE_HEADERS;
  function Companion_369() {
  }
  var Companion_instance_369;
  function Companion_getInstance_369() {
    return Companion_instance_369;
  }
  function KtorCallContextElement(callContext) {
    this.hqe_1 = callContext;
  }
  protoOf(KtorCallContextElement).x = function () {
    return Companion_instance_369;
  };
  function callContext($completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.ea();
    return ensureNotNull(tmp$ret$0.la(Companion_instance_369)).hqe_1;
  }
  function mergeHeaders(requestHeaders, content, block) {
    _init_properties_Utils_kt__jo07cx();
    var tmp = buildHeaders(mergeHeaders$lambda(requestHeaders, content));
    tmp.j8u(mergeHeaders$lambda_0(block));
    var missingAgent = requestHeaders.fe(HttpHeaders_getInstance().b93_1) == null && content.g94().fe(HttpHeaders_getInstance().b93_1) == null;
    if (missingAgent && needUserAgent()) {
      block(HttpHeaders_getInstance().b93_1, get_KTOR_DEFAULT_USER_AGENT());
    }
    var tmp0_safe_receiver = content.h99();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? content.g94().fe(HttpHeaders_getInstance().v90_1) : tmp1_elvis_lhs;
    var type = tmp2_elvis_lhs == null ? requestHeaders.fe(HttpHeaders_getInstance().v90_1) : tmp2_elvis_lhs;
    var tmp3_safe_receiver = content.i99();
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
    var tmp5_elvis_lhs = tmp4_elvis_lhs == null ? content.g94().fe(HttpHeaders_getInstance().s90_1) : tmp4_elvis_lhs;
    var length = tmp5_elvis_lhs == null ? requestHeaders.fe(HttpHeaders_getInstance().s90_1) : tmp5_elvis_lhs;
    if (type == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'io.ktor.client.engine.mergeHeaders.<anonymous>' call
      block(HttpHeaders_getInstance().v90_1, type);
    }
    if (length == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'io.ktor.client.engine.mergeHeaders.<anonymous>' call
      block(HttpHeaders_getInstance().s90_1, length);
    }
  }
  function needUserAgent() {
    _init_properties_Utils_kt__jo07cx();
    return !PlatformUtils_getInstance().z8t_1;
  }
  function mergeHeaders$lambda($requestHeaders, $content) {
    return function ($this$buildHeaders) {
      $this$buildHeaders.s8u($requestHeaders);
      $this$buildHeaders.s8u($content.g94());
      return Unit_instance;
    };
  }
  function mergeHeaders$lambda_0($block) {
    return function (key, values) {
      var tmp;
      if (HttpHeaders_getInstance().s90_1 === key) {
        return Unit_instance;
      }
      var tmp_0;
      if (HttpHeaders_getInstance().v90_1 === key) {
        return Unit_instance;
      }
      var tmp_1;
      if (get_DATE_HEADERS().s(key)) {
        var _iterator__ex2g4s = values.k();
        while (_iterator__ex2g4s.l()) {
          var element = _iterator__ex2g4s.m();
          // Inline function 'io.ktor.client.engine.mergeHeaders.<anonymous>.<anonymous>' call
          $block(key, element);
        }
        tmp_1 = Unit_instance;
      } else {
        var separator = HttpHeaders_getInstance().w90_1 === key ? '; ' : ',';
        tmp_1 = $block(key, joinToString_0(values, separator));
      }
      return Unit_instance;
    };
  }
  var properties_initialized_Utils_kt_xvi83j;
  function _init_properties_Utils_kt__jo07cx() {
    if (!properties_initialized_Utils_kt_xvi83j) {
      properties_initialized_Utils_kt_xvi83j = true;
      KTOR_DEFAULT_USER_AGENT = 'Ktor client';
      DATE_HEADERS = setOf_0([HttpHeaders_getInstance().y90_1, HttpHeaders_getInstance().e91_1, HttpHeaders_getInstance().q91_1, HttpHeaders_getInstance().l91_1, HttpHeaders_getInstance().p91_1]);
    }
  }
  function get_UploadProgressListenerAttributeKey() {
    _init_properties_BodyProgress_kt__s0v569();
    return UploadProgressListenerAttributeKey;
  }
  var UploadProgressListenerAttributeKey;
  function get_DownloadProgressListenerAttributeKey() {
    _init_properties_BodyProgress_kt__s0v569();
    return DownloadProgressListenerAttributeKey;
  }
  var DownloadProgressListenerAttributeKey;
  function handle_1($this, scope) {
    var observableContentPhase = new PipelinePhase('ObservableContent');
    scope.oq5_1.j8x(Phases_getInstance().lqe_1, observableContentPhase);
    scope.oq5_1.m8x(observableContentPhase, BodyProgress$handle$slambda_0(null));
    var tmp = Phases_getInstance_2().pqe_1;
    scope.rq5_1.m8x(tmp, BodyProgress$handle$slambda_2(null));
  }
  function Plugin() {
    Plugin_instance = this;
    this.qqe_1 = new AttributeKey('BodyProgress');
  }
  protoOf(Plugin).x = function () {
    return this.qqe_1;
  };
  protoOf(Plugin).rqe = function (block) {
    return new BodyProgress();
  };
  protoOf(Plugin).sq8 = function (block) {
    return this.rqe(block);
  };
  protoOf(Plugin).sqe = function (plugin, scope) {
    handle_1(plugin, scope);
  };
  protoOf(Plugin).tq8 = function (plugin, scope) {
    return this.sqe(plugin instanceof BodyProgress ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance;
  function Plugin_getInstance() {
    if (Plugin_instance == null)
      new Plugin();
    return Plugin_instance;
  }
  function BodyProgress$handle$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BodyProgress$handle$slambda).iq6 = function ($this$intercept, content, $completion) {
    var tmp = this.jq6($this$intercept, content, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(BodyProgress$handle$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.iq6(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(BodyProgress$handle$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.bqf_1.i8x_1.tq7_1.l8s(get_UploadProgressListenerAttributeKey());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.dqf_1 = tmp_1;
            var tmp_2 = this;
            var tmp_3 = this.cqf_1;
            tmp_2.eqf_1 = new ObservableContent(tmp_3 instanceof OutgoingContent ? tmp_3 : THROW_CCE(), this.bqf_1.i8x_1.sq7_1, this.dqf_1);
            this.y9_1 = 1;
            suspendResult = this.bqf_1.m8w(this.eqf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(BodyProgress$handle$slambda).jq6 = function ($this$intercept, content, completion) {
    var i = new BodyProgress$handle$slambda(completion);
    i.bqf_1 = $this$intercept;
    i.cqf_1 = content;
    return i;
  };
  function BodyProgress$handle$slambda_0(resultContinuation) {
    var i = new BodyProgress$handle$slambda(resultContinuation);
    var l = function ($this$intercept, content, $completion) {
      return i.iq6($this$intercept, content, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function BodyProgress$handle$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BodyProgress$handle$slambda_1).rqf = function ($this$intercept, response, $completion) {
    var tmp = this.sqf($this$intercept, response, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(BodyProgress$handle$slambda_1).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rqf(tmp, p2 instanceof HttpResponse ? p2 : THROW_CCE(), $completion);
  };
  protoOf(BodyProgress$handle$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.oqf_1.uqa().xq9().cq9().l8s(get_DownloadProgressListenerAttributeKey());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.pqf_1 = tmp_1;
            this.qqf_1 = withObservableDownload(this.oqf_1, this.pqf_1);
            this.y9_1 = 1;
            suspendResult = this.nqf_1.m8w(this.qqf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(BodyProgress$handle$slambda_1).sqf = function ($this$intercept, response, completion) {
    var i = new BodyProgress$handle$slambda_1(completion);
    i.nqf_1 = $this$intercept;
    i.oqf_1 = response;
    return i;
  };
  function BodyProgress$handle$slambda_2(resultContinuation) {
    var i = new BodyProgress$handle$slambda_1(resultContinuation);
    var l = function ($this$intercept, response, $completion) {
      return i.rqf($this$intercept, response, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function BodyProgress() {
    Plugin_getInstance();
  }
  function withObservableDownload(_this__u8e3s4, listener) {
    _init_properties_BodyProgress_kt__s0v569();
    var observableByteChannel = observable(_this__u8e3s4.g67(), _this__u8e3s4.et(), contentLength(_this__u8e3s4), listener);
    return wrapWithContent(_this__u8e3s4.uqa(), observableByteChannel).pq6();
  }
  var properties_initialized_BodyProgress_kt_pmfrhr;
  function _init_properties_BodyProgress_kt__s0v569() {
    if (!properties_initialized_BodyProgress_kt_pmfrhr) {
      properties_initialized_BodyProgress_kt_pmfrhr = true;
      UploadProgressListenerAttributeKey = new AttributeKey('UploadProgressListenerAttributeKey');
      DownloadProgressListenerAttributeKey = new AttributeKey('DownloadProgressListenerAttributeKey');
    }
  }
  function get_ValidateMark() {
    _init_properties_DefaultResponseValidation_kt__wcn8vr();
    return ValidateMark;
  }
  var ValidateMark;
  function get_LOGGER_0() {
    _init_properties_DefaultResponseValidation_kt__wcn8vr();
    return LOGGER_0;
  }
  var LOGGER_0;
  function addDefaultResponseValidation(_this__u8e3s4) {
    _init_properties_DefaultResponseValidation_kt__wcn8vr();
    HttpResponseValidator(_this__u8e3s4, addDefaultResponseValidation$lambda(_this__u8e3s4));
  }
  function ResponseException(response, cachedResponseText) {
    IllegalStateException_init_$Init$_0('Bad response: ' + response.toString() + '. Text: "' + cachedResponseText + '"', this);
    captureStack(this, ResponseException);
    this.tqf_1 = response;
  }
  function RedirectResponseException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    captureStack(this, RedirectResponseException);
    this.vqf_1 = 'Unhandled redirect: ' + response.uqa().xq9().vqa().p94_1 + ' ' + response.uqa().xq9().jbu().toString() + '. ' + ('Status: ' + response.zq9().toString() + '. Text: "' + cachedResponseText + '"');
  }
  protoOf(RedirectResponseException).t1 = function () {
    return this.vqf_1;
  };
  function ClientRequestException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    captureStack(this, ClientRequestException);
    this.xqf_1 = 'Client request(' + response.uqa().xq9().vqa().p94_1 + ' ' + response.uqa().xq9().jbu().toString() + ') ' + ('invalid: ' + response.zq9().toString() + '. Text: "' + cachedResponseText + '"');
  }
  protoOf(ClientRequestException).t1 = function () {
    return this.xqf_1;
  };
  function ServerResponseException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    captureStack(this, ServerResponseException);
    this.zqf_1 = 'Server error(' + response.uqa().xq9().vqa().p94_1 + ' ' + response.uqa().xq9().jbu().toString() + ': ' + (response.zq9().toString() + '. Text: "' + cachedResponseText + '"');
  }
  protoOf(ServerResponseException).t1 = function () {
    return this.zqf_1;
  };
  function addDefaultResponseValidation$lambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(addDefaultResponseValidation$lambda$slambda).qqg = function (response, $completion) {
    var tmp = this.rqg(response, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(addDefaultResponseValidation$lambda$slambda).oa = function (p1, $completion) {
    return this.qqg(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
  };
  protoOf(addDefaultResponseValidation$lambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            this.jqg_1 = this.iqg_1.uqa().cq9().k8s(get_ExpectSuccessAttributeKey());
            if (!this.jqg_1) {
              get_LOGGER_0().e8y('Skipping default response validation for ' + this.iqg_1.uqa().xq9().jbu().toString());
              return Unit_instance;
            }

            this.kqg_1 = this.iqg_1.zq9().b97_1;
            this.lqg_1 = this.iqg_1.uqa();
            if (this.kqg_1 < 300 || this.lqg_1.cq9().m8s(get_ValidateMark())) {
              return Unit_instance;
            }

            this.y9_1 = 1;
            suspendResult = save(this.lqg_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.mqg_1 = suspendResult;
            var tmp_0 = this;
            var this_0 = this.mqg_1;
            this_0.cq9().n8s(get_ValidateMark(), Unit_instance);
            tmp_0.nqg_1 = this_0;
            this.oqg_1 = this.nqg_1.pq6();
            this.z9_1 = 3;
            this.y9_1 = 2;
            suspendResult = bodyAsText(this.oqg_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.pqg_1 = suspendResult;
            this.z9_1 = 5;
            this.y9_1 = 4;
            continue $sm;
          case 3:
            this.z9_1 = 5;
            var tmp_1 = this.ba_1;
            if (tmp_1 instanceof MalformedInputException) {
              var _ = this.ba_1;
              var tmp_2 = this;
              tmp_2.pqg_1 = '<body failed decoding>';
              this.y9_1 = 4;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 4:
            this.z9_1 = 5;
            var exceptionResponseText = this.pqg_1;
            var tmp0_subject = this.kqg_1;
            var exception = (300 <= tmp0_subject ? tmp0_subject <= 399 : false) ? new RedirectResponseException(this.oqg_1, exceptionResponseText) : (400 <= tmp0_subject ? tmp0_subject <= 499 : false) ? new ClientRequestException(this.oqg_1, exceptionResponseText) : (500 <= tmp0_subject ? tmp0_subject <= 599 : false) ? new ServerResponseException(this.oqg_1, exceptionResponseText) : new ResponseException(this.oqg_1, exceptionResponseText);
            get_LOGGER_0().e8y('Default response validation for ' + this.iqg_1.uqa().xq9().jbu().toString() + ' failed with ' + exception.toString());
            throw exception;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(addDefaultResponseValidation$lambda$slambda).rqg = function (response, completion) {
    var i = new addDefaultResponseValidation$lambda$slambda(completion);
    i.iqg_1 = response;
    return i;
  };
  function addDefaultResponseValidation$lambda$slambda_0(resultContinuation) {
    var i = new addDefaultResponseValidation$lambda$slambda(resultContinuation);
    var l = function (response, $completion) {
      return i.qqg(response, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function addDefaultResponseValidation$lambda($this_addDefaultResponseValidation) {
    return function ($this$HttpResponseValidator) {
      $this$HttpResponseValidator.uqg_1 = $this_addDefaultResponseValidation.aq8_1;
      $this$HttpResponseValidator.vqg(addDefaultResponseValidation$lambda$slambda_0(null));
      return Unit_instance;
    };
  }
  var properties_initialized_DefaultResponseValidation_kt_akvzqt;
  function _init_properties_DefaultResponseValidation_kt__wcn8vr() {
    if (!properties_initialized_DefaultResponseValidation_kt_akvzqt) {
      properties_initialized_DefaultResponseValidation_kt_akvzqt = true;
      ValidateMark = new AttributeKey('ValidateMark');
      LOGGER_0 = KtorSimpleLogger('io.ktor.client.plugins.DefaultResponseValidation');
    }
  }
  function get_LOGGER_1() {
    _init_properties_DefaultTransform_kt__20knxx();
    return LOGGER_1;
  }
  var LOGGER_1;
  function defaultTransformers(_this__u8e3s4) {
    _init_properties_DefaultTransform_kt__20knxx();
    var tmp = Phases_getInstance().lqe_1;
    _this__u8e3s4.oq5_1.m8x(tmp, defaultTransformers$slambda_0(null));
    var tmp_0 = Phases_getInstance_1().mq8_1;
    _this__u8e3s4.pq5_1.m8x(tmp_0, defaultTransformers$slambda_2(null));
    platformResponseDefaultTransformers(_this__u8e3s4);
  }
  function defaultTransformers$1$content$1($contentType, $body) {
    this.zqg_1 = $body;
    ByteArrayContent_0.call(this);
    var tmp = this;
    tmp.xqg_1 = $contentType == null ? Application_getInstance().u8y_1 : $contentType;
    this.yqg_1 = toLong($body.length);
  }
  protoOf(defaultTransformers$1$content$1).h99 = function () {
    return this.xqg_1;
  };
  protoOf(defaultTransformers$1$content$1).i99 = function () {
    return this.yqg_1;
  };
  protoOf(defaultTransformers$1$content$1).j99 = function () {
    return this.zqg_1;
  };
  function defaultTransformers$1$content$2($this_intercept, $contentType, $body) {
    this.dqh_1 = $body;
    ReadChannelContent.call(this);
    var tmp = this;
    var tmp0_safe_receiver = $this_intercept.i8x_1.qq7_1.fe(HttpHeaders_getInstance().s90_1);
    tmp.bqh_1 = tmp0_safe_receiver == null ? null : toLong_1(tmp0_safe_receiver);
    var tmp_0 = this;
    tmp_0.cqh_1 = $contentType == null ? Application_getInstance().u8y_1 : $contentType;
  }
  protoOf(defaultTransformers$1$content$2).i99 = function () {
    return this.bqh_1;
  };
  protoOf(defaultTransformers$1$content$2).h99 = function () {
    return this.cqh_1;
  };
  protoOf(defaultTransformers$1$content$2).m99 = function () {
    return this.dqh_1;
  };
  function defaultTransformers$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(defaultTransformers$slambda).iq6 = function ($this$intercept, body, $completion) {
    var tmp = this.jq6($this$intercept, body, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(defaultTransformers$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.iq6(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(defaultTransformers$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            if (this.mqh_1.i8x_1.qq7_1.fe(HttpHeaders_getInstance().d90_1) == null) {
              this.mqh_1.i8x_1.qq7_1.r8u(HttpHeaders_getInstance().d90_1, '*/*');
            }

            this.oqh_1 = contentType(this.mqh_1.i8x_1);
            var tmp_0 = this;
            var tmp0_subject = this.nqh_1;
            var tmp_1;
            if (typeof tmp0_subject === 'string') {
              var tmp1_elvis_lhs = this.oqh_1;
              tmp_1 = new TextContent(this.nqh_1, tmp1_elvis_lhs == null ? Text_getInstance().k8z_1 : tmp1_elvis_lhs);
            } else {
              if (isByteArray(tmp0_subject)) {
                tmp_1 = new defaultTransformers$1$content$1(this.oqh_1, this.nqh_1);
              } else {
                if (isInterface(tmp0_subject, ByteReadChannel_1)) {
                  tmp_1 = new defaultTransformers$1$content$2(this.mqh_1, this.oqh_1, this.nqh_1);
                } else {
                  if (tmp0_subject instanceof OutgoingContent) {
                    tmp_1 = this.nqh_1;
                  } else {
                    tmp_1 = platformRequestDefaultTransform(this.oqh_1, this.mqh_1.i8x_1, this.nqh_1);
                  }
                }
              }
            }

            tmp_0.pqh_1 = tmp_1;
            var tmp2_safe_receiver = this.pqh_1;
            if (!((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.h99()) == null)) {
              this.mqh_1.i8x_1.qq7_1.t8u(HttpHeaders_getInstance().v90_1);
              get_LOGGER_1().e8y('Transformed with default transformers request body for ' + this.mqh_1.i8x_1.oq7_1.toString() + ' from ' + toString_1(getKClassFromExpression(this.nqh_1)));
              this.y9_1 = 1;
              suspendResult = this.mqh_1.m8w(this.pqh_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 1:
            this.y9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(defaultTransformers$slambda).jq6 = function ($this$intercept, body, completion) {
    var i = new defaultTransformers$slambda(completion);
    i.mqh_1 = $this$intercept;
    i.nqh_1 = body;
    return i;
  };
  function defaultTransformers$slambda_0(resultContinuation) {
    var i = new defaultTransformers$slambda(resultContinuation);
    var l = function ($this$intercept, body, $completion) {
      return i.iq6($this$intercept, body, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function defaultTransformers$slambda$slambda($body, $response, resultContinuation) {
    this.yqh_1 = $body;
    this.zqh_1 = $response;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(defaultTransformers$slambda$slambda).rqb = function ($this$writer, $completion) {
    var tmp = this.sqb($this$writer, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(defaultTransformers$slambda$slambda).oa = function (p1, $completion) {
    return this.rqb((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(defaultTransformers$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 4;
            this.z9_1 = 3;
            this.y9_1 = 2;
            suspendResult = copyTo(this.yqh_1, this.aqi_1.y15(), new Long(-1, 2147483647), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp_0 = this;
            tmp_0.bqi_1 = Unit_instance;
            this.z9_1 = 5;
            this.y9_1 = 6;
            continue $sm;
          case 3:
            this.z9_1 = 4;
            var tmp_1 = this.ba_1;
            if (tmp_1 instanceof CancellationException) {
              var cause = this.ba_1;
              var tmp_2 = this;
              cancel(this.zqh_1, cause);
              throw cause;
            } else {
              var tmp_3 = this.ba_1;
              if (tmp_3 instanceof Error) {
                var cause_0 = this.ba_1;
                var tmp_4 = this;
                cancel_0(this.zqh_1, 'Receive failed', cause_0);
                throw cause_0;
              } else {
                throw this.ba_1;
              }
            }

          case 4:
            this.z9_1 = 5;
            var t = this.ba_1;
            complete_0(this.zqh_1);
            throw t;
          case 5:
            throw this.ba_1;
          case 6:
            this.z9_1 = 5;
            complete_0(this.zqh_1);
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(defaultTransformers$slambda$slambda).sqb = function ($this$writer, completion) {
    var i = new defaultTransformers$slambda$slambda(this.yqh_1, this.zqh_1, completion);
    i.aqi_1 = $this$writer;
    return i;
  };
  function defaultTransformers$slambda$slambda_0($body, $response, resultContinuation) {
    var i = new defaultTransformers$slambda$slambda($body, $response, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.rqb($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function defaultTransformers$slambda$lambda($responseJobHolder) {
    return function (it) {
      $responseJobHolder.oz();
      return Unit_instance;
    };
  }
  function defaultTransformers$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(defaultTransformers$slambda_1).cq7 = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
    var tmp = this.dq7($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(defaultTransformers$slambda_1).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.cq7(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(defaultTransformers$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 11;
            this.mqi_1 = this.lqi_1.ug();
            this.nqi_1 = this.lqi_1.vg();
            var tmp_0 = this.nqi_1;
            if (!isInterface(tmp_0, ByteReadChannel_1))
              return Unit_instance;
            this.oqi_1 = this.kqi_1.i8x_1.pq6();
            this.pqi_1 = this.mqi_1.z8x_1;
            if (this.pqi_1.equals(getKClass(Unit))) {
              cancel_3(this.nqi_1);
              this.y9_1 = 9;
              suspendResult = this.kqi_1.m8w(new HttpResponseContainer(this.mqi_1, Unit_instance), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (this.pqi_1.equals(PrimitiveClasses_getInstance().jc())) {
                this.y9_1 = 7;
                suspendResult = this.nqi_1.d8k(VOID, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (this.pqi_1.equals(getKClass(ByteReadPacket)) ? true : this.pqi_1.equals(getKClass(Input))) {
                  this.y9_1 = 5;
                  suspendResult = this.nqi_1.d8k(VOID, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (this.pqi_1.equals(PrimitiveClasses_getInstance().rc())) {
                    this.y9_1 = 3;
                    suspendResult = toByteArray(this.nqi_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (this.pqi_1.equals(getKClass(ByteReadChannel_1))) {
                      this.rqi_1 = Job_0(this.oqi_1.et().la(Key_instance_3));
                      var tmp_1 = this;
                      var tmp_2 = this.oqi_1.et();
                      var this_0 = writer(this.kqi_1, tmp_2, VOID, defaultTransformers$slambda$slambda_0(this.nqi_1, this.oqi_1, null));
                      this_0.hu(defaultTransformers$slambda$lambda(this.rqi_1));
                      tmp_1.sqi_1 = this_0.y15();
                      this.y9_1 = 2;
                      suspendResult = this.kqi_1.m8w(new HttpResponseContainer(this.mqi_1, this.sqi_1), this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      if (this.pqi_1.equals(getKClass(HttpStatusCode))) {
                        cancel_3(this.nqi_1);
                        this.y9_1 = 1;
                        suspendResult = this.kqi_1.m8w(new HttpResponseContainer(this.mqi_1, this.oqi_1.zq9()), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        this.qqi_1 = null;
                        this.y9_1 = 10;
                        continue $sm;
                      }
                    }
                  }
                }
              }
            }

          case 1:
            this.qqi_1 = suspendResult;
            this.y9_1 = 10;
            continue $sm;
          case 2:
            this.qqi_1 = suspendResult;
            this.y9_1 = 10;
            continue $sm;
          case 3:
            this.tqi_1 = suspendResult;
            this.uqi_1 = contentLength(this.oqi_1);
            this.vqi_1 = (!PlatformUtils_getInstance().z8t_1 && this.oqi_1.g94().fe(HttpHeaders_getInstance().q90_1) == null);
            this.wqi_1 = !this.kqi_1.i8x_1.xq9().vqa().equals(Companion_getInstance_143().m94_1);
            if (this.vqi_1 && this.wqi_1 && !(this.uqi_1 == null) && this.uqi_1.d1(new Long(0, 0)) > 0) {
              if (!(this.tqi_1.length === this.uqi_1.z3())) {
                var message = 'Expected ' + toString_0(this.uqi_1) + ', actual ' + this.tqi_1.length;
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              }
            }

            this.y9_1 = 4;
            suspendResult = this.kqi_1.m8w(new HttpResponseContainer(this.mqi_1, this.tqi_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.qqi_1 = suspendResult;
            this.y9_1 = 10;
            continue $sm;
          case 5:
            this.xqi_1 = suspendResult;
            this.yqi_1 = new HttpResponseContainer(this.mqi_1, this.xqi_1);
            this.y9_1 = 6;
            suspendResult = this.kqi_1.m8w(this.yqi_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.qqi_1 = suspendResult;
            this.y9_1 = 10;
            continue $sm;
          case 7:
            this.zqi_1 = suspendResult;
            this.aqj_1 = this.zqi_1.h8o();
            this.bqj_1 = toInt(this.aqj_1);
            this.cqj_1 = new HttpResponseContainer(this.mqi_1, this.bqj_1);
            this.y9_1 = 8;
            suspendResult = this.kqi_1.m8w(this.cqj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.qqi_1 = suspendResult;
            this.y9_1 = 10;
            continue $sm;
          case 9:
            this.qqi_1 = suspendResult;
            this.y9_1 = 10;
            continue $sm;
          case 10:
            var result = this.qqi_1;
            if (!(result == null)) {
              get_LOGGER_1().e8y('Transformed with default transformers response body ' + ('for ' + this.kqi_1.i8x_1.xq9().jbu().toString() + ' to ' + toString_1(this.mqi_1.z8x_1)));
            }

            return Unit_instance;
          case 11:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 11) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(defaultTransformers$slambda_1).dq7 = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, completion) {
    var i = new defaultTransformers$slambda_1(completion);
    i.kqi_1 = $this$intercept;
    i.lqi_1 = _name_for_destructuring_parameter_0__wldtmu;
    return i;
  };
  function defaultTransformers$slambda_2(resultContinuation) {
    var i = new defaultTransformers$slambda_1(resultContinuation);
    var l = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
      return i.cq7($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    };
    l.$arity = 2;
    return l;
  }
  var properties_initialized_DefaultTransform_kt_ossax9;
  function _init_properties_DefaultTransform_kt__20knxx() {
    if (!properties_initialized_DefaultTransform_kt_ossax9) {
      properties_initialized_DefaultTransform_kt_ossax9 = true;
      LOGGER_1 = KtorSimpleLogger('io.ktor.client.plugins.defaultTransformers');
    }
  }
  function get_LOGGER_2() {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    return LOGGER_2;
  }
  var LOGGER_2;
  function get_ExpectSuccessAttributeKey() {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    return ExpectSuccessAttributeKey;
  }
  var ExpectSuccessAttributeKey;
  function HttpCallValidator$Companion$install$slambda$lambda($plugin) {
    return function () {
      return $plugin.fqj_1;
    };
  }
  function HttpCallValidator$Companion$install$slambda($plugin, resultContinuation) {
    this.oqj_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpCallValidator$Companion$install$slambda).iq6 = function ($this$intercept, it, $completion) {
    var tmp = this.jq6($this$intercept, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpCallValidator$Companion$install$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.iq6(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpCallValidator$Companion$install$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            this.z9_1 = 3;
            var tmp_0 = get_ExpectSuccessAttributeKey();
            this.pqj_1.i8x_1.tq7_1.p8s(tmp_0, HttpCallValidator$Companion$install$slambda$lambda(this.oqj_1));
            this.y9_1 = 1;
            suspendResult = this.pqj_1.m8w(this.qqj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z9_1 = 5;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.z9_1 = 5;
            return Unit_instance;
          case 3:
            this.z9_1 = 5;
            var tmp_1 = this.ba_1;
            if (tmp_1 instanceof Error) {
              this.rqj_1 = this.ba_1;
              this.sqj_1 = unwrapCancellationException_0(this.rqj_1);
              this.y9_1 = 4;
              suspendResult = processException(this.oqj_1, this.sqj_1, HttpRequest(this.pqj_1.i8x_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 4:
            throw this.sqj_1;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpCallValidator$Companion$install$slambda).jq6 = function ($this$intercept, it, completion) {
    var i = new HttpCallValidator$Companion$install$slambda(this.oqj_1, completion);
    i.pqj_1 = $this$intercept;
    i.qqj_1 = it;
    return i;
  };
  function HttpCallValidator$Companion$install$slambda_0($plugin, resultContinuation) {
    var i = new HttpCallValidator$Companion$install$slambda($plugin, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.iq6($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpCallValidator$Companion$install$slambda_1($plugin, resultContinuation) {
    this.bqk_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpCallValidator$Companion$install$slambda_1).cq7 = function ($this$intercept, container, $completion) {
    var tmp = this.dq7($this$intercept, container, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpCallValidator$Companion$install$slambda_1).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.cq7(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpCallValidator$Companion$install$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.cqk_1.m8w(this.dqk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z9_1 = 5;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.z9_1 = 5;
            return Unit_instance;
          case 3:
            this.z9_1 = 5;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof Error) {
              this.eqk_1 = this.ba_1;
              this.fqk_1 = unwrapCancellationException_0(this.eqk_1);
              this.y9_1 = 4;
              suspendResult = processException(this.bqk_1, this.fqk_1, this.cqk_1.i8x_1.xq9(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 4:
            throw this.fqk_1;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpCallValidator$Companion$install$slambda_1).dq7 = function ($this$intercept, container, completion) {
    var i = new HttpCallValidator$Companion$install$slambda_1(this.bqk_1, completion);
    i.cqk_1 = $this$intercept;
    i.dqk_1 = container;
    return i;
  };
  function HttpCallValidator$Companion$install$slambda_2($plugin, resultContinuation) {
    var i = new HttpCallValidator$Companion$install$slambda_1($plugin, resultContinuation);
    var l = function ($this$intercept, container, $completion) {
      return i.cq7($this$intercept, container, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpCallValidator$Companion$install$slambda_3($plugin, resultContinuation) {
    this.oqk_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpCallValidator$Companion$install$slambda_3).sqk = function ($this$intercept, request, $completion) {
    var tmp = this.tqk($this$intercept, request, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpCallValidator$Companion$install$slambda_3).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    return this.sqk(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpCallValidator$Companion$install$slambda_3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.pqk_1.uqk(this.qqk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.rqk_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = validateResponse(this.oqk_1, this.rqk_1.pq6(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return this.rqk_1;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpCallValidator$Companion$install$slambda_3).tqk = function ($this$intercept, request, completion) {
    var i = new HttpCallValidator$Companion$install$slambda_3(this.oqk_1, completion);
    i.pqk_1 = $this$intercept;
    i.qqk_1 = request;
    return i;
  };
  function HttpCallValidator$Companion$install$slambda_4($plugin, resultContinuation) {
    var i = new HttpCallValidator$Companion$install$slambda_3($plugin, resultContinuation);
    var l = function ($this$intercept, request, $completion) {
      return i.sqk($this$intercept, request, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function validateResponse($this, response, $completion) {
    var tmp = new $validateResponseCOROUTINE$5($this, response, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function processException($this, cause, request, $completion) {
    var tmp = new $processExceptionCOROUTINE$6($this, cause, request, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function Config() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.sqg_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.tqg_1 = ArrayList_init_$Create$();
    this.uqg_1 = true;
  }
  protoOf(Config).vqg = function (block) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.sqg_1.e(block);
  };
  function Companion_370() {
    Companion_instance_370 = this;
    this.dqm_1 = new AttributeKey('HttpResponseValidator');
  }
  protoOf(Companion_370).x = function () {
    return this.dqm_1;
  };
  protoOf(Companion_370).eqm = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config();
    block(this_0);
    var config = this_0;
    return new HttpCallValidator(reversed(config.sqg_1), reversed(config.tqg_1), config.uqg_1);
  };
  protoOf(Companion_370).sq8 = function (block) {
    return this.eqm(block);
  };
  protoOf(Companion_370).fqm = function (plugin_0, scope) {
    var tmp = Phases_getInstance().iqe_1;
    scope.oq5_1.m8x(tmp, HttpCallValidator$Companion$install$slambda_0(plugin_0, null));
    var BeforeReceive = new PipelinePhase('BeforeReceive');
    scope.pq5_1.l8x(Phases_getInstance_1().lq8_1, BeforeReceive);
    scope.pq5_1.m8x(BeforeReceive, HttpCallValidator$Companion$install$slambda_2(plugin_0, null));
    var tmp_0 = plugin(scope, Plugin_getInstance_3());
    tmp_0.iqm(HttpCallValidator$Companion$install$slambda_4(plugin_0, null));
  };
  protoOf(Companion_370).tq8 = function (plugin, scope) {
    return this.fqm(plugin instanceof HttpCallValidator ? plugin : THROW_CCE(), scope);
  };
  var Companion_instance_370;
  function Companion_getInstance_370() {
    if (Companion_instance_370 == null)
      new Companion_370();
    return Companion_instance_370;
  }
  function $validateResponseCOROUTINE$5(_this__u8e3s4, response, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dql_1 = _this__u8e3s4;
    this.eql_1 = response;
  }
  protoOf($validateResponseCOROUTINE$5).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            get_LOGGER_2().e8y('Validating response for request ' + this.eql_1.uqa().xq9().jbu().toString());
            var tmp_0 = this;
            tmp_0.fql_1 = this.dql_1.dqj_1;
            this.gql_1 = this.fql_1;
            this.hql_1 = this.gql_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.hql_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.iql_1 = this.hql_1.m();
            var tmp_1 = this;
            tmp_1.jql_1 = this.iql_1;
            this.kql_1 = this.jql_1;
            this.y9_1 = 2;
            suspendResult = this.kql_1(this.eql_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.y9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $processExceptionCOROUTINE$6(_this__u8e3s4, cause, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tql_1 = _this__u8e3s4;
    this.uql_1 = cause;
    this.vql_1 = request;
  }
  protoOf($processExceptionCOROUTINE$6).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            get_LOGGER_2().e8y('Processing exception ' + this.uql_1.toString() + ' for request ' + this.vql_1.jbu().toString());
            var tmp_0 = this;
            tmp_0.wql_1 = this.tql_1.eqj_1;
            this.xql_1 = this.wql_1;
            this.yql_1 = this.xql_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.yql_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.zql_1 = this.yql_1.m();
            var tmp_1 = this;
            tmp_1.aqm_1 = this.zql_1;
            this.bqm_1 = this.aqm_1;
            this.cqm_1 = this.bqm_1;
            var tmp_2 = this.cqm_1;
            if (tmp_2 instanceof ExceptionHandlerWrapper) {
              this.y9_1 = 3;
              suspendResult = this.bqm_1.kqm_1(this.uql_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_3 = this.cqm_1;
              if (tmp_3 instanceof RequestExceptionHandlerWrapper) {
                this.y9_1 = 2;
                suspendResult = this.bqm_1.jqm_1(this.uql_1, this.vql_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.y9_1 = 4;
                continue $sm;
              }
            }

          case 2:
            this.y9_1 = 4;
            continue $sm;
          case 3:
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.y9_1 = 1;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function HttpCallValidator(responseValidators, callExceptionHandlers, expectSuccess) {
    Companion_getInstance_370();
    this.dqj_1 = responseValidators;
    this.eqj_1 = callExceptionHandlers;
    this.fqj_1 = expectSuccess;
  }
  function ExceptionHandlerWrapper() {
  }
  function RequestExceptionHandlerWrapper() {
  }
  function HttpRequest(builder) {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    return new HttpRequest$1(builder);
  }
  function HttpResponseValidator(_this__u8e3s4, block) {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    _this__u8e3s4.uq8(Companion_getInstance_370(), block);
  }
  function HttpRequest$1($builder) {
    this.pqm_1 = $builder;
    this.lqm_1 = $builder.pq7_1;
    this.mqm_1 = $builder.oq7_1.k2p();
    this.nqm_1 = $builder.tq7_1;
    this.oqm_1 = $builder.qq7_1.k2p();
  }
  protoOf(HttpRequest$1).uqa = function () {
    var message = 'Call is not initialized';
    throw IllegalStateException_init_$Create$_0(toString_1(message));
  };
  protoOf(HttpRequest$1).vqa = function () {
    return this.lqm_1;
  };
  protoOf(HttpRequest$1).jbu = function () {
    return this.mqm_1;
  };
  protoOf(HttpRequest$1).cq9 = function () {
    return this.nqm_1;
  };
  protoOf(HttpRequest$1).g94 = function () {
    return this.oqm_1;
  };
  protoOf(HttpRequest$1).g67 = function () {
    var tmp = this.pqm_1.rq7_1;
    var tmp0_elvis_lhs = tmp instanceof OutgoingContent ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var message = 'Content was not transformed to OutgoingContent yet. Current body is ' + toString_1(this.pqm_1.rq7_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  };
  var properties_initialized_HttpCallValidator_kt_xrx49w;
  function _init_properties_HttpCallValidator_kt__r6yh2y() {
    if (!properties_initialized_HttpCallValidator_kt_xrx49w) {
      properties_initialized_HttpCallValidator_kt_xrx49w = true;
      LOGGER_2 = KtorSimpleLogger('io.ktor.client.plugins.HttpCallValidator');
      ExpectSuccessAttributeKey = new AttributeKey('ExpectSuccessAttributeKey');
    }
  }
  function get_PLUGIN_INSTALLED_LIST() {
    _init_properties_HttpClientPlugin_kt__cypu1m();
    return PLUGIN_INSTALLED_LIST;
  }
  var PLUGIN_INSTALLED_LIST;
  function plugin(_this__u8e3s4, plugin) {
    _init_properties_HttpClientPlugin_kt__cypu1m();
    var tmp0_elvis_lhs = pluginOrNull(_this__u8e3s4, plugin);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Plugin ' + toString_1(plugin) + ' is not installed. Consider using `install(' + plugin.x().toString() + ')` in client config first.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function HttpClientPlugin() {
  }
  function pluginOrNull(_this__u8e3s4, plugin) {
    _init_properties_HttpClientPlugin_kt__cypu1m();
    var tmp0_safe_receiver = _this__u8e3s4.sq5_1.l8s(get_PLUGIN_INSTALLED_LIST());
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l8s(plugin.x());
  }
  var properties_initialized_HttpClientPlugin_kt_p98320;
  function _init_properties_HttpClientPlugin_kt__cypu1m() {
    if (!properties_initialized_HttpClientPlugin_kt_p98320) {
      properties_initialized_HttpClientPlugin_kt_p98320 = true;
      PLUGIN_INSTALLED_LIST = new AttributeKey('ApplicationPluginRegistry');
    }
  }
  function get_LOGGER_3() {
    _init_properties_HttpPlainText_kt__iy89z1();
    return LOGGER_3;
  }
  var LOGGER_3;
  function HttpPlainText$Plugin$install$slambda($plugin, resultContinuation) {
    this.yqm_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpPlainText$Plugin$install$slambda).iq6 = function ($this$intercept, content, $completion) {
    var tmp = this.jq6($this$intercept, content, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpPlainText$Plugin$install$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.iq6(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpPlainText$Plugin$install$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.yqm_1.fqn(this.zqm_1.i8x_1);
            var tmp_0 = this.aqn_1;
            if (!(typeof tmp_0 === 'string'))
              return Unit_instance;
            this.bqn_1 = contentType(this.zqm_1.i8x_1);
            if (!(this.bqn_1 == null) && !(this.bqn_1.u8z_1 === Text_getInstance().k8z_1.u8z_1)) {
              return Unit_instance;
            }

            this.y9_1 = 1;
            suspendResult = this.zqm_1.m8w(wrapContent(this.yqm_1, this.zqm_1.i8x_1, this.aqn_1, this.bqn_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpPlainText$Plugin$install$slambda).jq6 = function ($this$intercept, content, completion) {
    var i = new HttpPlainText$Plugin$install$slambda(this.yqm_1, completion);
    i.zqm_1 = $this$intercept;
    i.aqn_1 = content;
    return i;
  };
  function HttpPlainText$Plugin$install$slambda_0($plugin, resultContinuation) {
    var i = new HttpPlainText$Plugin$install$slambda($plugin, resultContinuation);
    var l = function ($this$intercept, content, $completion) {
      return i.iq6($this$intercept, content, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function HttpPlainText$Plugin$install$slambda_1($plugin, resultContinuation) {
    this.oqn_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpPlainText$Plugin$install$slambda_1).cq7 = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
    var tmp = this.dq7($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpPlainText$Plugin$install$slambda_1).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.cq7(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpPlainText$Plugin$install$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.rqn_1 = this.qqn_1.ug();
            this.sqn_1 = this.qqn_1.vg();
            var tmp_0;
            if (!this.rqn_1.z8x_1.equals(PrimitiveClasses_getInstance().nc())) {
              tmp_0 = true;
            } else {
              var tmp_1 = this.sqn_1;
              tmp_0 = !isInterface(tmp_1, ByteReadChannel_1);
            }

            if (tmp_0)
              return Unit_instance;
            this.y9_1 = 1;
            suspendResult = this.sqn_1.d8k(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.tqn_1 = suspendResult;
            this.uqn_1 = this.oqn_1.vqn(this.pqn_1.i8x_1, this.tqn_1);
            this.y9_1 = 2;
            suspendResult = this.pqn_1.m8w(new HttpResponseContainer(this.rqn_1, this.uqn_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpPlainText$Plugin$install$slambda_1).dq7 = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, completion) {
    var i = new HttpPlainText$Plugin$install$slambda_1(this.oqn_1, completion);
    i.pqn_1 = $this$intercept;
    i.qqn_1 = _name_for_destructuring_parameter_0__wldtmu;
    return i;
  };
  function HttpPlainText$Plugin$install$slambda_2($plugin, resultContinuation) {
    var i = new HttpPlainText$Plugin$install$slambda_1($plugin, resultContinuation);
    var l = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
      return i.cq7($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Config_0() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.wqn_1 = LinkedHashSet_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.xqn_1 = LinkedHashMap_init_$Create$();
    this.yqn_1 = null;
    this.zqn_1 = Charsets_getInstance().q8o_1;
  }
  function Plugin_0() {
    Plugin_instance_0 = this;
    this.aqo_1 = new AttributeKey('HttpPlainText');
  }
  protoOf(Plugin_0).x = function () {
    return this.aqo_1;
  };
  protoOf(Plugin_0).bqo = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_0();
    block(this_0);
    var config = this_0;
    // Inline function 'kotlin.with' call
    return new HttpPlainText(config.wqn_1, config.xqn_1, config.yqn_1, config.zqn_1);
  };
  protoOf(Plugin_0).sq8 = function (block) {
    return this.bqo(block);
  };
  protoOf(Plugin_0).cqo = function (plugin, scope) {
    var tmp = Phases_getInstance().lqe_1;
    scope.oq5_1.m8x(tmp, HttpPlainText$Plugin$install$slambda_0(plugin, null));
    var tmp_0 = Phases_getInstance_1().nq8_1;
    scope.pq5_1.m8x(tmp_0, HttpPlainText$Plugin$install$slambda_2(plugin, null));
  };
  protoOf(Plugin_0).tq8 = function (plugin, scope) {
    return this.cqo(plugin instanceof HttpPlainText ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_0;
  function Plugin_getInstance_0() {
    if (Plugin_instance_0 == null)
      new Plugin_0();
    return Plugin_instance_0;
  }
  function wrapContent($this, request, content, requestContentType) {
    var contentType = requestContentType == null ? Text_getInstance().k8z_1 : requestContentType;
    var tmp2_elvis_lhs = requestContentType == null ? null : charset(requestContentType);
    var charset_0 = tmp2_elvis_lhs == null ? $this.dqn_1 : tmp2_elvis_lhs;
    get_LOGGER_3().e8y('Sending request body to ' + request.oq7_1.toString() + ' as text/plain with charset ' + charset_0.toString());
    return new TextContent(content, withCharset(contentType, charset_0));
  }
  function sam$kotlin_Comparator$0_4(function_0) {
    this.dqo_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_4).te = function (a, b) {
    return this.dqo_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_4).compare = function (a, b) {
    return this.te(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_4).b4 = function () {
    return this.dqo_1;
  };
  protoOf(sam$kotlin_Comparator$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_4).hashCode = function () {
    return hashCode(this.b4());
  };
  function HttpPlainText$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
    var tmp = b.eh_1;
    // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
    var tmp$ret$1 = a.eh_1;
    return compareValues(tmp, tmp$ret$1);
  }
  function HttpPlainText$lambda_0(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
    var tmp = get_name_6(a);
    // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
    var tmp$ret$1 = get_name_6(b);
    return compareValues(tmp, tmp$ret$1);
  }
  function HttpPlainText(charsets, charsetQuality, sendCharset, responseCharsetFallback) {
    Plugin_getInstance_0();
    this.cqn_1 = responseCharsetFallback;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_0 = toList_1(charsetQuality);
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = HttpPlainText$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0_4(tmp);
    var withQuality = sortedWith(this_0, tmp$ret$0);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = charsets.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
      if (!charsetQuality.w2(element)) {
        destination.e(element);
      }
    }
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_0 = HttpPlainText$lambda_0;
    var tmp$ret$5 = new sam$kotlin_Comparator$0_4(tmp_0);
    var withoutQuality = sortedWith(destination, tmp$ret$5);
    var tmp_1 = this;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_1 = StringBuilder_init_$Create$_1();
    // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = withoutQuality.k();
    while (_iterator__ex2g4s_0.l()) {
      var element_0 = _iterator__ex2g4s_0.m();
      // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.d9(',');
      }
      this_1.d9(get_name_6(element_0));
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_1 = withQuality.k();
    while (_iterator__ex2g4s_1.l()) {
      var element_1 = _iterator__ex2g4s_1.m();
      // Inline function 'io.ktor.client.plugins.HttpPlainText.<anonymous>.<anonymous>' call
      var charset = element_1.ug();
      var quality = element_1.vg();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.d9(',');
      }
      // Inline function 'kotlin.check' call
      if (!(0.0 <= quality ? quality <= 1.0 : false)) {
        throw IllegalStateException_init_$Create$_0('Check failed.');
      }
      // Inline function 'kotlin.math.roundToInt' call
      var this_2 = 100 * quality;
      var truncatedQuality = roundToInt(this_2) / 100.0;
      this_1.d9(get_name_6(charset) + ';q=' + truncatedQuality);
    }
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(this_1) === 0) {
      this_1.d9(get_name_6(this.cqn_1));
    }
    tmp_1.eqn_1 = this_1.toString();
    var tmp_2 = this;
    var tmp2_elvis_lhs = sendCharset == null ? firstOrNull_0(withoutQuality) : sendCharset;
    var tmp_3;
    if (tmp2_elvis_lhs == null) {
      var tmp1_safe_receiver = firstOrNull_0(withQuality);
      tmp_3 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.dh_1;
    } else {
      tmp_3 = tmp2_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_3;
    tmp_2.dqn_1 = tmp3_elvis_lhs == null ? Charsets_getInstance().q8o_1 : tmp3_elvis_lhs;
  }
  protoOf(HttpPlainText).vqn = function (call, body) {
    var tmp0_elvis_lhs = charset_0(call.pq6());
    var actualCharset = tmp0_elvis_lhs == null ? this.cqn_1 : tmp0_elvis_lhs;
    get_LOGGER_3().e8y('Reading response body for ' + call.xq9().jbu().toString() + ' as String with charset ' + actualCharset.toString());
    return readText(body, actualCharset);
  };
  protoOf(HttpPlainText).fqn = function (context) {
    if (!(context.qq7_1.fe(HttpHeaders_getInstance().e90_1) == null))
      return Unit_instance;
    get_LOGGER_3().e8y('Adding Accept-Charset=' + this.eqn_1 + ' to ' + context.oq7_1.toString());
    context.qq7_1.p8u(HttpHeaders_getInstance().e90_1, this.eqn_1);
  };
  var properties_initialized_HttpPlainText_kt_2nx4ox;
  function _init_properties_HttpPlainText_kt__iy89z1() {
    if (!properties_initialized_HttpPlainText_kt_2nx4ox) {
      properties_initialized_HttpPlainText_kt_2nx4ox = true;
      LOGGER_3 = KtorSimpleLogger('io.ktor.client.plugins.HttpPlainText');
    }
  }
  function get_ALLOWED_FOR_REDIRECT() {
    _init_properties_HttpRedirect_kt__ure7fo();
    return ALLOWED_FOR_REDIRECT;
  }
  var ALLOWED_FOR_REDIRECT;
  function get_LOGGER_4() {
    _init_properties_HttpRedirect_kt__ure7fo();
    return LOGGER_4;
  }
  var LOGGER_4;
  function handleCall(_this__u8e3s4, $this, context, origin, allowHttpsDowngrade, client, $completion) {
    var tmp = new $handleCallCOROUTINE$7($this, _this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function HttpRedirect$Plugin$install$slambda($plugin, $scope, resultContinuation) {
    this.fqp_1 = $plugin;
    this.gqp_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpRedirect$Plugin$install$slambda).sqk = function ($this$intercept, context, $completion) {
    var tmp = this.tqk($this$intercept, context, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpRedirect$Plugin$install$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    return this.sqk(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpRedirect$Plugin$install$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.hqp_1.uqk(this.iqp_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.jqp_1 = suspendResult;
            if (this.fqp_1.kqp_1 && !get_ALLOWED_FOR_REDIRECT().s(this.jqp_1.xq9().vqa())) {
              return this.jqp_1;
            }

            this.y9_1 = 2;
            suspendResult = handleCall(this.hqp_1, Plugin_getInstance_1(), this.iqp_1, this.jqp_1, this.fqp_1.lqp_1, this.gqp_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpRedirect$Plugin$install$slambda).tqk = function ($this$intercept, context, completion) {
    var i = new HttpRedirect$Plugin$install$slambda(this.fqp_1, this.gqp_1, completion);
    i.hqp_1 = $this$intercept;
    i.iqp_1 = context;
    return i;
  };
  function HttpRedirect$Plugin$install$slambda_0($plugin, $scope, resultContinuation) {
    var i = new HttpRedirect$Plugin$install$slambda($plugin, $scope, resultContinuation);
    var l = function ($this$intercept, context, $completion) {
      return i.sqk($this$intercept, context, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $handleCallCOROUTINE$7(_this__u8e3s4, _this__u8e3s4_0, context, origin, allowHttpsDowngrade, client, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mqo_1 = _this__u8e3s4;
    this.nqo_1 = _this__u8e3s4_0;
    this.oqo_1 = context;
    this.pqo_1 = origin;
    this.qqo_1 = allowHttpsDowngrade;
    this.rqo_1 = client;
  }
  protoOf($handleCallCOROUTINE$7).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            if (!isRedirect(this.pqo_1.pq6().zq9()))
              return this.pqo_1;
            this.sqo_1 = this.pqo_1;
            this.tqo_1 = this.oqo_1;
            this.uqo_1 = this.pqo_1.xq9().jbu().t97_1;
            this.vqo_1 = get_authority_0(this.pqo_1.xq9().jbu());
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.y9_1 = 4;
              continue $sm;
            }

            this.rqo_1.uq5_1.sq2(this.mqo_1.nqp_1, this.sqo_1.pq6());
            this.wqo_1 = this.sqo_1.pq6().g94().fe(HttpHeaders_getInstance().r91_1);
            get_LOGGER_4().e8y('Received redirect response to ' + this.wqo_1 + ' for request ' + this.oqo_1.oq7_1.toString());
            var tmp_0 = this;
            var this_0 = new HttpRequestBuilder();
            this_0.jqd(this.tqo_1);
            this_0.oq7_1.q97_1.m2();
            var tmp0_safe_receiver = this.wqo_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              takeFrom(this_0.oq7_1, tmp0_safe_receiver);
            }

            if (!this.qqo_1 && isSecure(this.uqo_1) && !isSecure(this_0.oq7_1.h97_1)) {
              get_LOGGER_4().e8y('Can not redirect ' + this.oqo_1.oq7_1.toString() + ' because of security downgrade');
              return this.sqo_1;
            }

            if (!(this.vqo_1 === get_authority(this_0.oq7_1))) {
              this_0.qq7_1.t8u(HttpHeaders_getInstance().m90_1);
              get_LOGGER_4().e8y('Removing Authorization header from redirect for ' + this.oqo_1.oq7_1.toString());
            }

            tmp_0.tqo_1 = this_0;
            this.y9_1 = 2;
            suspendResult = this.nqo_1.uqk(this.tqo_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.sqo_1 = suspendResult;
            if (!isRedirect(this.sqo_1.pq6().zq9()))
              return this.sqo_1;
            this.y9_1 = 1;
            continue $sm;
          case 3:
            throw this.ba_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function Config_1() {
    this.oqp_1 = true;
    this.pqp_1 = false;
  }
  function Plugin_1() {
    Plugin_instance_1 = this;
    this.mqp_1 = new AttributeKey('HttpRedirect');
    this.nqp_1 = new EventDefinition();
  }
  protoOf(Plugin_1).x = function () {
    return this.mqp_1;
  };
  protoOf(Plugin_1).qqp = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_1();
    block(this_0);
    var config = this_0;
    return new HttpRedirect(config.oqp_1, config.pqp_1);
  };
  protoOf(Plugin_1).sq8 = function (block) {
    return this.qqp(block);
  };
  protoOf(Plugin_1).rqp = function (plugin_0, scope) {
    var tmp = plugin(scope, Plugin_getInstance_3());
    tmp.iqm(HttpRedirect$Plugin$install$slambda_0(plugin_0, scope, null));
  };
  protoOf(Plugin_1).tq8 = function (plugin, scope) {
    return this.rqp(plugin instanceof HttpRedirect ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_1;
  function Plugin_getInstance_1() {
    if (Plugin_instance_1 == null)
      new Plugin_1();
    return Plugin_instance_1;
  }
  function HttpRedirect(checkHttpMethod, allowHttpsDowngrade) {
    Plugin_getInstance_1();
    this.kqp_1 = checkHttpMethod;
    this.lqp_1 = allowHttpsDowngrade;
  }
  function isRedirect(_this__u8e3s4) {
    _init_properties_HttpRedirect_kt__ure7fo();
    var tmp0_subject = _this__u8e3s4.b97_1;
    return ((((tmp0_subject === Companion_getInstance_145().k95_1.b97_1 ? true : tmp0_subject === Companion_getInstance_145().l95_1.b97_1) ? true : tmp0_subject === Companion_getInstance_145().q95_1.b97_1) ? true : tmp0_subject === Companion_getInstance_145().r95_1.b97_1) ? true : tmp0_subject === Companion_getInstance_145().m95_1.b97_1) ? true : false;
  }
  var properties_initialized_HttpRedirect_kt_klj746;
  function _init_properties_HttpRedirect_kt__ure7fo() {
    if (!properties_initialized_HttpRedirect_kt_klj746) {
      properties_initialized_HttpRedirect_kt_klj746 = true;
      ALLOWED_FOR_REDIRECT = setOf_0([Companion_getInstance_143().h94_1, Companion_getInstance_143().m94_1]);
      LOGGER_4 = KtorSimpleLogger('io.ktor.client.plugins.HttpRedirect');
    }
  }
  function get_LOGGER_5() {
    _init_properties_HttpRequestLifecycle_kt__jgkmfx();
    return LOGGER_5;
  }
  var LOGGER_5;
  function HttpRequestLifecycle$Plugin$install$slambda($scope, resultContinuation) {
    this.aqq_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpRequestLifecycle$Plugin$install$slambda).iq6 = function ($this$intercept, it, $completion) {
    var tmp = this.jq6($this$intercept, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpRequestLifecycle$Plugin$install$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.iq6(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpRequestLifecycle$Plugin$install$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            this.dqq_1 = SupervisorJob(this.bqq_1.i8x_1.sq7_1);
            attachToClientEngineJob(this.dqq_1, ensureNotNull(this.aqq_1.nq5_1.la(Key_instance_3)));
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 4;
            this.z9_1 = 3;
            this.bqq_1.i8x_1.sq7_1 = this.dqq_1;
            this.y9_1 = 2;
            suspendResult = this.bqq_1.n8w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp_0 = this;
            tmp_0.eqq_1 = Unit_instance;
            this.z9_1 = 6;
            this.y9_1 = 5;
            continue $sm;
          case 3:
            this.z9_1 = 4;
            var tmp_1 = this.ba_1;
            if (tmp_1 instanceof Error) {
              var cause = this.ba_1;
              var tmp_2 = this;
              this.dqq_1.nz(cause);
              throw cause;
            } else {
              throw this.ba_1;
            }

          case 4:
            this.z9_1 = 6;
            var t = this.ba_1;
            this.dqq_1.oz();
            throw t;
          case 5:
            this.z9_1 = 6;
            this.dqq_1.oz();
            return Unit_instance;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpRequestLifecycle$Plugin$install$slambda).jq6 = function ($this$intercept, it, completion) {
    var i = new HttpRequestLifecycle$Plugin$install$slambda(this.aqq_1, completion);
    i.bqq_1 = $this$intercept;
    i.cqq_1 = it;
    return i;
  };
  function HttpRequestLifecycle$Plugin$install$slambda_0($scope, resultContinuation) {
    var i = new HttpRequestLifecycle$Plugin$install$slambda($scope, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.iq6($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Plugin_2() {
    Plugin_instance_2 = this;
    this.fqq_1 = new AttributeKey('RequestLifecycle');
  }
  protoOf(Plugin_2).x = function () {
    return this.fqq_1;
  };
  protoOf(Plugin_2).rqe = function (block) {
    return new HttpRequestLifecycle();
  };
  protoOf(Plugin_2).sq8 = function (block) {
    return this.rqe(block);
  };
  protoOf(Plugin_2).gqq = function (plugin, scope) {
    var tmp = Phases_getInstance().iqe_1;
    scope.oq5_1.m8x(tmp, HttpRequestLifecycle$Plugin$install$slambda_0(scope, null));
  };
  protoOf(Plugin_2).tq8 = function (plugin, scope) {
    return this.gqq(plugin instanceof HttpRequestLifecycle ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_2;
  function Plugin_getInstance_2() {
    if (Plugin_instance_2 == null)
      new Plugin_2();
    return Plugin_instance_2;
  }
  function HttpRequestLifecycle() {
    Plugin_getInstance_2();
  }
  function attachToClientEngineJob(requestJob, clientEngineJob) {
    _init_properties_HttpRequestLifecycle_kt__jgkmfx();
    var handler = clientEngineJob.hu(attachToClientEngineJob$lambda(requestJob));
    requestJob.hu(attachToClientEngineJob$lambda_0(handler));
  }
  function attachToClientEngineJob$lambda($requestJob) {
    return function (cause) {
      var tmp;
      if (!(cause == null)) {
        get_LOGGER_5().e8y('Cancelling request because engine Job failed with error: ' + toString_0(cause));
        cancel_1($requestJob, 'Engine failed', cause);
        tmp = Unit_instance;
      } else {
        get_LOGGER_5().e8y('Cancelling request because engine Job completed');
        $requestJob.oz();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function attachToClientEngineJob$lambda_0($handler) {
    return function (it) {
      $handler.vr();
      return Unit_instance;
    };
  }
  var properties_initialized_HttpRequestLifecycle_kt_3hmcrf;
  function _init_properties_HttpRequestLifecycle_kt__jgkmfx() {
    if (!properties_initialized_HttpRequestLifecycle_kt_3hmcrf) {
      properties_initialized_HttpRequestLifecycle_kt_3hmcrf = true;
      LOGGER_5 = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestLifecycle');
    }
  }
  function HttpSend$Plugin$install$slambda($plugin, $scope, resultContinuation) {
    this.pqq_1 = $plugin;
    this.qqq_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpSend$Plugin$install$slambda).iq6 = function ($this$intercept, content, $completion) {
    var tmp = this.jq6($this$intercept, content, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpSend$Plugin$install$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.iq6(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpSend$Plugin$install$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this.sqq_1;
            if (!(tmp_0 instanceof OutgoingContent)) {
              var message = trimMargin('\n|Fail to prepare request body for sending. \n|The body type is: ' + toString_1(getKClassFromExpression(this.sqq_1)) + ', with Content-Type: ' + toString_0(contentType(this.rqq_1.i8x_1)) + '.\n|\n|If you expect serialized body, please check that you have installed the corresponding plugin(like `ContentNegotiation`) and set `Content-Type` header.');
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }

            var tmp1 = this.rqq_1.i8x_1;
            var body = this.sqq_1;
            if (body == null) {
              tmp1.rq7_1 = NullBody_instance;
              var tmp_1 = JsType_instance;
              var tmp_2 = getKClass(OutgoingContent);
              var tmp_3;
              try {
                tmp_3 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
              } catch ($p) {
                var tmp_4;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_4 = null;
                } else {
                  throw $p;
                }
                tmp_3 = tmp_4;
              }
              tmp1.kqd(typeInfoImpl(tmp_1, tmp_2, tmp_3));
            } else {
              if (body instanceof OutgoingContent) {
                tmp1.rq7_1 = body;
                tmp1.kqd(null);
              } else {
                tmp1.rq7_1 = body;
                var tmp_5 = JsType_instance;
                var tmp_6 = getKClass(OutgoingContent);
                var tmp_7;
                try {
                  tmp_7 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
                } catch ($p) {
                  var tmp_8;
                  if ($p instanceof Error) {
                    var cause_0 = $p;
                    tmp_8 = null;
                  } else {
                    throw $p;
                  }
                  tmp_7 = tmp_8;
                }
                tmp1.kqd(typeInfoImpl(tmp_5, tmp_6, tmp_7));
              }
            }

            this.tqq_1 = new DefaultSender(this.pqq_1.gqm_1, this.qqq_1);
            this.uqq_1 = this.tqq_1;
            var progression = downTo(get_lastIndex_2(this.pqq_1.hqm_1), 0);
            var inductionVariable = progression.e1_1;
            var last = progression.f1_1;
            var step = progression.g1_1;
            if (step > 0 && inductionVariable <= last || (step < 0 && last <= inductionVariable))
              do {
                var element = inductionVariable;
                inductionVariable = inductionVariable + step | 0;
                var it = element;
                var interceptor = this.pqq_1.hqm_1.q(it);
                this.uqq_1 = new InterceptedSender(interceptor, this.uqq_1);
              }
               while (!(element === last));
            this.y9_1 = 1;
            suspendResult = this.uqq_1.uqk(this.rqq_1.i8x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.vqq_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.rqq_1.m8w(this.vqq_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpSend$Plugin$install$slambda).jq6 = function ($this$intercept, content, completion) {
    var i = new HttpSend$Plugin$install$slambda(this.pqq_1, this.qqq_1, completion);
    i.rqq_1 = $this$intercept;
    i.sqq_1 = content;
    return i;
  };
  function HttpSend$Plugin$install$slambda_0($plugin, $scope, resultContinuation) {
    var i = new HttpSend$Plugin$install$slambda($plugin, $scope, resultContinuation);
    var l = function ($this$intercept, content, $completion) {
      return i.iq6($this$intercept, content, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $executeCOROUTINE$8(_this__u8e3s4, requestBuilder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.eqr_1 = _this__u8e3s4;
    this.fqr_1 = requestBuilder;
  }
  protoOf($executeCOROUTINE$8).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp0_safe_receiver = this.eqr_1.jqr_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              cancel(tmp0_safe_receiver);
            }

            if (this.eqr_1.iqr_1 >= this.eqr_1.gqr_1) {
              throw new SendCountExceedException('Max send count ' + this.eqr_1.gqr_1 + ' exceeded. Consider increasing the property ' + 'maxSendCount if more is required.');
            }

            var tmp1_this = this.eqr_1;
            tmp1_this.iqr_1 = tmp1_this.iqr_1 + 1 | 0;
            this.y9_1 = 1;
            suspendResult = this.eqr_1.hqr_1.qq5_1.h8x(this.fqr_1, this.fqr_1.rq7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var sendResult = suspendResult;
            var tmp3_elvis_lhs = sendResult instanceof HttpClientCall ? sendResult : null;
            var tmp_0;
            if (tmp3_elvis_lhs == null) {
              var message = 'Failed to execute send pipeline. Expected [HttpClientCall], but received ' + toString_1(sendResult);
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else {
              tmp_0 = tmp3_elvis_lhs;
            }

            var call = tmp_0;
            this.eqr_1.jqr_1 = call;
            return call;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function Config_2() {
    this.kqr_1 = 20;
  }
  function Plugin_3() {
    Plugin_instance_3 = this;
    this.lqr_1 = new AttributeKey('HttpSend');
  }
  protoOf(Plugin_3).x = function () {
    return this.lqr_1;
  };
  protoOf(Plugin_3).mqr = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_2();
    block(this_0);
    var config = this_0;
    return new HttpSend(config.kqr_1);
  };
  protoOf(Plugin_3).sq8 = function (block) {
    return this.mqr(block);
  };
  protoOf(Plugin_3).nqr = function (plugin, scope) {
    var tmp = Phases_getInstance().mqe_1;
    scope.oq5_1.m8x(tmp, HttpSend$Plugin$install$slambda_0(plugin, scope, null));
  };
  protoOf(Plugin_3).tq8 = function (plugin, scope) {
    return this.nqr(plugin instanceof HttpSend ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_3;
  function Plugin_getInstance_3() {
    if (Plugin_instance_3 == null)
      new Plugin_3();
    return Plugin_instance_3;
  }
  function InterceptedSender(interceptor, nextSender) {
    this.oqr_1 = interceptor;
    this.pqr_1 = nextSender;
  }
  protoOf(InterceptedSender).uqk = function (requestBuilder, $completion) {
    return this.oqr_1(this.pqr_1, requestBuilder, $completion);
  };
  function DefaultSender(maxSendCount, client) {
    this.gqr_1 = maxSendCount;
    this.hqr_1 = client;
    this.iqr_1 = 0;
    this.jqr_1 = null;
  }
  protoOf(DefaultSender).uqk = function (requestBuilder, $completion) {
    var tmp = new $executeCOROUTINE$8(this, requestBuilder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function HttpSend(maxSendCount) {
    Plugin_getInstance_3();
    maxSendCount = maxSendCount === VOID ? 20 : maxSendCount;
    this.gqm_1 = maxSendCount;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.hqm_1 = ArrayList_init_$Create$();
  }
  protoOf(HttpSend).iqm = function (block) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.hqm_1.e(block);
  };
  function Sender() {
  }
  function SendCountExceedException(message) {
    IllegalStateException_init_$Init$_0(message, this);
    captureStack(this, SendCountExceedException);
  }
  function get_LOGGER_6() {
    _init_properties_HttpTimeout_kt__pucqrr();
    return LOGGER_6;
  }
  var LOGGER_6;
  function HttpTimeoutCapabilityConfiguration_init_$Init$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, $this) {
    requestTimeoutMillis = requestTimeoutMillis === VOID ? null : requestTimeoutMillis;
    connectTimeoutMillis = connectTimeoutMillis === VOID ? null : connectTimeoutMillis;
    socketTimeoutMillis = socketTimeoutMillis === VOID ? null : socketTimeoutMillis;
    HttpTimeoutCapabilityConfiguration.call($this);
    $this.tqr(requestTimeoutMillis);
    $this.uqr(connectTimeoutMillis);
    $this.vqr(socketTimeoutMillis);
    return $this;
  }
  function HttpTimeoutCapabilityConfiguration_init_$Create$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis) {
    return HttpTimeoutCapabilityConfiguration_init_$Init$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, objectCreate(protoOf(HttpTimeoutCapabilityConfiguration)));
  }
  function checkTimeoutValue($this, value) {
    // Inline function 'kotlin.require' call
    if (!(value == null || value.d1(new Long(0, 0)) > 0)) {
      // Inline function 'io.ktor.client.plugins.HttpTimeoutCapabilityConfiguration.checkTimeoutValue.<anonymous>' call
      var message = 'Only positive timeout values are allowed, for infinite timeout use HttpTimeout.INFINITE_TIMEOUT_MS';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    return value;
  }
  function Companion_371() {
    Companion_instance_371 = this;
    this.wqr_1 = new AttributeKey('TimeoutConfiguration');
  }
  var Companion_instance_371;
  function Companion_getInstance_371() {
    if (Companion_instance_371 == null)
      new Companion_371();
    return Companion_instance_371;
  }
  function HttpTimeout$Plugin$install$slambda$slambda($requestTimeout, $request, $executionContext, resultContinuation) {
    this.fqs_1 = $requestTimeout;
    this.gqs_1 = $request;
    this.hqs_1 = $executionContext;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpTimeout$Plugin$install$slambda$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpTimeout$Plugin$install$slambda$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpTimeout$Plugin$install$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = delay(this.fqs_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var cause = HttpRequestTimeoutException_init_$Create$(this.gqs_1);
            get_LOGGER_6().e8y('Request timeout: ' + this.gqs_1.oq7_1.toString());
            cancel_1(this.hqs_1, ensureNotNull(cause.message), cause);
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpTimeout$Plugin$install$slambda$slambda).i1l = function ($this$launch, completion) {
    var i = new HttpTimeout$Plugin$install$slambda$slambda(this.fqs_1, this.gqs_1, this.hqs_1, completion);
    i.iqs_1 = $this$launch;
    return i;
  };
  function HttpTimeout$Plugin$install$slambda$slambda_0($requestTimeout, $request, $executionContext, resultContinuation) {
    var i = new HttpTimeout$Plugin$install$slambda$slambda($requestTimeout, $request, $executionContext, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function HttpTimeout$Plugin$install$slambda$lambda($killer) {
    return function (it) {
      $killer.pu();
      return Unit_instance;
    };
  }
  function HttpTimeout$Plugin$install$slambda($plugin, $scope, resultContinuation) {
    this.rqs_1 = $plugin;
    this.sqs_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpTimeout$Plugin$install$slambda).sqk = function ($this$intercept, request, $completion) {
    var tmp = this.tqk($this$intercept, request, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpTimeout$Plugin$install$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    return this.sqk(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpTimeout$Plugin$install$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.vqs_1 = isWebsocket(this.uqs_1.oq7_1.h97_1);
            var tmp_0;
            if (this.vqs_1) {
              tmp_0 = true;
            } else {
              var tmp_1 = this.uqs_1.rq7_1;
              tmp_0 = tmp_1 instanceof ClientUpgradeContent;
            }

            if (tmp_0) {
              this.y9_1 = 3;
              suspendResult = this.tqs_1.uqk(this.uqs_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 1;
              continue $sm;
            }

          case 1:
            this.wqs_1 = this.uqs_1.xqs(Plugin_getInstance_4());
            if (this.wqs_1 == null && hasNotNullTimeouts(this.rqs_1)) {
              this.wqs_1 = HttpTimeoutCapabilityConfiguration_init_$Create$();
              this.uqs_1.yqs(Plugin_getInstance_4(), this.wqs_1);
            }

            var tmp0_safe_receiver = this.wqs_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              l$ret$1: do {
                var tmp0_elvis_lhs = tmp0_safe_receiver.zqs();
                tmp0_safe_receiver.uqr(tmp0_elvis_lhs == null ? this.rqs_1.bqt_1 : tmp0_elvis_lhs);
                var tmp1_elvis_lhs = tmp0_safe_receiver.dqt();
                tmp0_safe_receiver.vqr(tmp1_elvis_lhs == null ? this.rqs_1.cqt_1 : tmp1_elvis_lhs);
                var tmp2_elvis_lhs = tmp0_safe_receiver.eqt();
                tmp0_safe_receiver.tqr(tmp2_elvis_lhs == null ? this.rqs_1.aqt_1 : tmp2_elvis_lhs);
                var tmp3_elvis_lhs = tmp0_safe_receiver.eqt();
                var requestTimeout = tmp3_elvis_lhs == null ? this.rqs_1.aqt_1 : tmp3_elvis_lhs;
                if (requestTimeout == null || equals(requestTimeout, new Long(-1, 2147483647))) {
                  break l$ret$1;
                }
                var executionContext = this.uqs_1.sq7_1;
                var killer = launch(this.sqs_1, VOID, VOID, HttpTimeout$Plugin$install$slambda$slambda_0(requestTimeout, this.uqs_1, executionContext, null));
                var tmp_2 = this.uqs_1.sq7_1;
                tmp_2.hu(HttpTimeout$Plugin$install$slambda$lambda(killer));
              }
               while (false);
            }

            this.y9_1 = 2;
            suspendResult = this.tqs_1.uqk(this.uqs_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            return suspendResult;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpTimeout$Plugin$install$slambda).tqk = function ($this$intercept, request, completion) {
    var i = new HttpTimeout$Plugin$install$slambda(this.rqs_1, this.sqs_1, completion);
    i.tqs_1 = $this$intercept;
    i.uqs_1 = request;
    return i;
  };
  function HttpTimeout$Plugin$install$slambda_0($plugin, $scope, resultContinuation) {
    var i = new HttpTimeout$Plugin$install$slambda($plugin, $scope, resultContinuation);
    var l = function ($this$intercept, request, $completion) {
      return i.sqk($this$intercept, request, $completion);
    };
    l.$arity = 2;
    return l;
  }
  protoOf(HttpTimeoutCapabilityConfiguration).tqr = function (value) {
    this.qqr_1 = checkTimeoutValue(this, value);
  };
  protoOf(HttpTimeoutCapabilityConfiguration).eqt = function () {
    return this.qqr_1;
  };
  protoOf(HttpTimeoutCapabilityConfiguration).uqr = function (value) {
    this.rqr_1 = checkTimeoutValue(this, value);
  };
  protoOf(HttpTimeoutCapabilityConfiguration).zqs = function () {
    return this.rqr_1;
  };
  protoOf(HttpTimeoutCapabilityConfiguration).vqr = function (value) {
    this.sqr_1 = checkTimeoutValue(this, value);
  };
  protoOf(HttpTimeoutCapabilityConfiguration).dqt = function () {
    return this.sqr_1;
  };
  protoOf(HttpTimeoutCapabilityConfiguration).fqt = function () {
    return new HttpTimeout(this.eqt(), this.zqs(), this.dqt());
  };
  protoOf(HttpTimeoutCapabilityConfiguration).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof HttpTimeoutCapabilityConfiguration))
      THROW_CCE();
    if (!equals(this.qqr_1, other.qqr_1))
      return false;
    if (!equals(this.rqr_1, other.rqr_1))
      return false;
    if (!equals(this.sqr_1, other.sqr_1))
      return false;
    return true;
  };
  protoOf(HttpTimeoutCapabilityConfiguration).hashCode = function () {
    var tmp0_safe_receiver = this.qqr_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp2_safe_receiver = this.rqr_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp4_safe_receiver = this.sqr_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.hashCode();
    result = tmp_0 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    return result;
  };
  function HttpTimeoutCapabilityConfiguration() {
    Companion_getInstance_371();
    this.qqr_1 = new Long(0, 0);
    this.rqr_1 = new Long(0, 0);
    this.sqr_1 = new Long(0, 0);
  }
  function hasNotNullTimeouts($this) {
    return !($this.aqt_1 == null) || !($this.bqt_1 == null) || !($this.cqt_1 == null);
  }
  function Plugin_4() {
    Plugin_instance_4 = this;
    this.gqt_1 = new AttributeKey('TimeoutPlugin');
    this.hqt_1 = new Long(-1, 2147483647);
  }
  protoOf(Plugin_4).x = function () {
    return this.gqt_1;
  };
  protoOf(Plugin_4).iqt = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = HttpTimeoutCapabilityConfiguration_init_$Create$();
    block(this_0);
    return this_0.fqt();
  };
  protoOf(Plugin_4).sq8 = function (block) {
    return this.iqt(block);
  };
  protoOf(Plugin_4).jqt = function (plugin_0, scope) {
    var tmp = plugin(scope, Plugin_getInstance_3());
    tmp.iqm(HttpTimeout$Plugin$install$slambda_0(plugin_0, scope, null));
  };
  protoOf(Plugin_4).tq8 = function (plugin, scope) {
    return this.jqt(plugin instanceof HttpTimeout ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_4;
  function Plugin_getInstance_4() {
    if (Plugin_instance_4 == null)
      new Plugin_4();
    return Plugin_instance_4;
  }
  function HttpTimeout(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis) {
    Plugin_getInstance_4();
    this.aqt_1 = requestTimeoutMillis;
    this.bqt_1 = connectTimeoutMillis;
    this.cqt_1 = socketTimeoutMillis;
  }
  function HttpRequestTimeoutException_init_$Init$(request, $this) {
    var tmp = request.oq7_1.w98();
    var tmp0_safe_receiver = request.xqs(Plugin_getInstance_4());
    HttpRequestTimeoutException.call($this, tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.eqt());
    return $this;
  }
  function HttpRequestTimeoutException_init_$Create$(request) {
    var tmp = HttpRequestTimeoutException_init_$Init$(request, objectCreate(protoOf(HttpRequestTimeoutException)));
    captureStack(tmp, HttpRequestTimeoutException_init_$Create$);
    return tmp;
  }
  function HttpRequestTimeoutException(url, timeoutMillis) {
    IOException_init_$Init$('Request timeout has expired [url=' + url + ', request_timeout=' + toString_1(timeoutMillis == null ? 'unknown' : timeoutMillis) + ' ms]', this);
    captureStack(this, HttpRequestTimeoutException);
  }
  var properties_initialized_HttpTimeout_kt_9oyjbd;
  function _init_properties_HttpTimeout_kt__pucqrr() {
    if (!properties_initialized_HttpTimeout_kt_9oyjbd) {
      properties_initialized_HttpTimeout_kt_9oyjbd = true;
      LOGGER_6 = KtorSimpleLogger('io.ktor.client.plugins.HttpTimeout');
    }
  }
  function wrapWithContent(_this__u8e3s4, content) {
    return new DelegatedCall(_this__u8e3s4.kq6_1, content, _this__u8e3s4);
  }
  function DelegatedCall(client, content, originCall) {
    HttpClientCall.call(this, client);
    this.mq6_1 = new DelegatedRequest(this, originCall.xq9());
    this.nq6_1 = new DelegatedResponse(this, content, originCall.pq6());
  }
  function DelegatedRequest(call, origin) {
    this.kqt_1 = call;
    this.lqt_1 = origin;
  }
  protoOf(DelegatedRequest).uqa = function () {
    return this.kqt_1;
  };
  protoOf(DelegatedRequest).cq9 = function () {
    return this.lqt_1.cq9();
  };
  protoOf(DelegatedRequest).g67 = function () {
    return this.lqt_1.g67();
  };
  protoOf(DelegatedRequest).et = function () {
    return this.lqt_1.et();
  };
  protoOf(DelegatedRequest).g94 = function () {
    return this.lqt_1.g94();
  };
  protoOf(DelegatedRequest).vqa = function () {
    return this.lqt_1.vqa();
  };
  protoOf(DelegatedRequest).jbu = function () {
    return this.lqt_1.jbu();
  };
  function DelegatedResponse(call, content, origin) {
    HttpResponse.call(this);
    this.mqt_1 = call;
    this.nqt_1 = content;
    this.oqt_1 = origin;
    this.pqt_1 = this.oqt_1.et();
  }
  protoOf(DelegatedResponse).uqa = function () {
    return this.mqt_1;
  };
  protoOf(DelegatedResponse).g67 = function () {
    return this.nqt_1;
  };
  protoOf(DelegatedResponse).et = function () {
    return this.pqt_1;
  };
  protoOf(DelegatedResponse).zq9 = function () {
    return this.oqt_1.zq9();
  };
  protoOf(DelegatedResponse).gko = function () {
    return this.oqt_1.gko();
  };
  protoOf(DelegatedResponse).fqb = function () {
    return this.oqt_1.fqb();
  };
  protoOf(DelegatedResponse).gqb = function () {
    return this.oqt_1.gqb();
  };
  protoOf(DelegatedResponse).g94 = function () {
    return this.oqt_1.g94();
  };
  function DefaultClientWebSocketSession(call, delegate) {
    this.qqt_1 = call;
    this.rqt_1 = delegate;
  }
  protoOf(DefaultClientWebSocketSession).e9a = function () {
    return this.rqt_1.e9a();
  };
  protoOf(DefaultClientWebSocketSession).et = function () {
    return this.rqt_1.et();
  };
  protoOf(DefaultClientWebSocketSession).i9a = function () {
    return this.rqt_1.i9a();
  };
  protoOf(DefaultClientWebSocketSession).g9a = function (_set____db54di) {
    this.rqt_1.g9a(_set____db54di);
  };
  protoOf(DefaultClientWebSocketSession).h9a = function () {
    return this.rqt_1.h9a();
  };
  protoOf(DefaultClientWebSocketSession).j9a = function () {
    return this.rqt_1.j9a();
  };
  protoOf(DefaultClientWebSocketSession).l9a = function ($completion) {
    return this.rqt_1.l9a($completion);
  };
  protoOf(DefaultClientWebSocketSession).k9a = function (frame, $completion) {
    return this.rqt_1.k9a(frame, $completion);
  };
  protoOf(DefaultClientWebSocketSession).f9a = function (negotiatedExtensions) {
    this.rqt_1.f9a(negotiatedExtensions);
  };
  function DelegatingClientWebSocketSession(call, session) {
    this.sqt_1 = call;
    this.tqt_1 = session;
  }
  protoOf(DelegatingClientWebSocketSession).et = function () {
    return this.tqt_1.et();
  };
  protoOf(DelegatingClientWebSocketSession).i9a = function () {
    return this.tqt_1.i9a();
  };
  protoOf(DelegatingClientWebSocketSession).g9a = function (_set____db54di) {
    this.tqt_1.g9a(_set____db54di);
  };
  protoOf(DelegatingClientWebSocketSession).h9a = function () {
    return this.tqt_1.h9a();
  };
  protoOf(DelegatingClientWebSocketSession).j9a = function () {
    return this.tqt_1.j9a();
  };
  protoOf(DelegatingClientWebSocketSession).l9a = function ($completion) {
    return this.tqt_1.l9a($completion);
  };
  protoOf(DelegatingClientWebSocketSession).k9a = function (frame, $completion) {
    return this.tqt_1.k9a(frame, $completion);
  };
  function WebSocketContent() {
    ClientUpgradeContent.call(this);
    var tmp = this;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'io.ktor.client.plugins.websocket.WebSocketContent.nonce.<anonymous>' call
    var nonce = generateNonce(16);
    this_0.d9(encodeBase64(nonce));
    tmp.wqt_1 = this_0.toString();
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new HeadersBuilder();
    // Inline function 'io.ktor.client.plugins.websocket.WebSocketContent.headers.<anonymous>' call
    this_1.r8u(HttpHeaders_getInstance().a93_1, 'websocket');
    this_1.r8u(HttpHeaders_getInstance().o90_1, 'Upgrade');
    this_1.r8u(HttpHeaders_getInstance().p92_1, this.wqt_1);
    this_1.r8u(HttpHeaders_getInstance().r92_1, '13');
    tmp_0.xqt_1 = this_1.k2p();
  }
  protoOf(WebSocketContent).g94 = function () {
    return this.xqt_1;
  };
  protoOf(WebSocketContent).toString = function () {
    return 'WebSocketContent';
  };
  function get_REQUEST_EXTENSIONS_KEY() {
    _init_properties_WebSockets_kt__jaqpbo();
    return REQUEST_EXTENSIONS_KEY;
  }
  var REQUEST_EXTENSIONS_KEY;
  function get_LOGGER_7() {
    _init_properties_WebSockets_kt__jaqpbo();
    return LOGGER_7;
  }
  var LOGGER_7;
  function WebSockets$Plugin$install$slambda($extensionsSupported, $plugin, resultContinuation) {
    this.gqu_1 = $extensionsSupported;
    this.hqu_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebSockets$Plugin$install$slambda).iq6 = function ($this$intercept, it, $completion) {
    var tmp = this.jq6($this$intercept, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(WebSockets$Plugin$install$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.iq6(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(WebSockets$Plugin$install$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            if (!isWebsocket(this.iqu_1.i8x_1.oq7_1.h97_1)) {
              get_LOGGER_7().e8y('Skipping WebSocket plugin for non-websocket request: ' + this.iqu_1.i8x_1.oq7_1.toString());
              return Unit_instance;
            }

            get_LOGGER_7().e8y('Sending WebSocket request ' + this.iqu_1.i8x_1.oq7_1.toString());
            this.iqu_1.i8x_1.yqs(WebSocketCapability_instance, Unit_instance);
            if (this.gqu_1) {
              installExtensions(this.hqu_1, this.iqu_1.i8x_1);
            }

            this.y9_1 = 1;
            suspendResult = this.iqu_1.m8w(new WebSocketContent(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(WebSockets$Plugin$install$slambda).jq6 = function ($this$intercept, it, completion) {
    var i = new WebSockets$Plugin$install$slambda(this.gqu_1, this.hqu_1, completion);
    i.iqu_1 = $this$intercept;
    i.jqu_1 = it;
    return i;
  };
  function WebSockets$Plugin$install$slambda_0($extensionsSupported, $plugin, resultContinuation) {
    var i = new WebSockets$Plugin$install$slambda($extensionsSupported, $plugin, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.iq6($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function WebSockets$Plugin$install$slambda_1($plugin, $extensionsSupported, resultContinuation) {
    this.squ_1 = $plugin;
    this.tqu_1 = $extensionsSupported;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebSockets$Plugin$install$slambda_1).cq7 = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
    var tmp = this.dq7($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(WebSockets$Plugin$install$slambda_1).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.cq7(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(WebSockets$Plugin$install$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.wqu_1 = this.vqu_1.ug();
            this.xqu_1 = this.vqu_1.vg();
            this.yqu_1 = this.uqu_1.i8x_1.pq6();
            this.zqu_1 = this.yqu_1.zq9();
            this.aqv_1 = get_request(this.yqu_1).g67();
            var tmp_0 = this.aqv_1;
            if (!(tmp_0 instanceof WebSocketContent)) {
              get_LOGGER_7().e8y('Skipping non-websocket response from ' + this.uqu_1.i8x_1.xq9().jbu().toString() + ': ' + toString_1(this.xqu_1));
              return Unit_instance;
            }

            if (!this.zqu_1.equals(Companion_getInstance_145().z94_1)) {
              throw WebSocketException_init_$Create$('Handshake exception, expected status code ' + Companion_getInstance_145().z94_1.b97_1 + ' but was ' + this.zqu_1.b97_1);
            }

            var tmp_1 = this.xqu_1;
            if (!isInterface(tmp_1, WebSocketSession)) {
              throw WebSocketException_init_$Create$('Handshake exception, expected `WebSocketSession` content but was ' + toString_1(this.xqu_1));
            }

            get_LOGGER_7().e8y('Receive websocket session from ' + this.uqu_1.i8x_1.xq9().jbu().toString() + ': ' + toString_1(this.xqu_1));
            var tmp_2 = this;
            var tmp_3;
            if (this.wqu_1.z8x_1.equals(getKClass(DefaultClientWebSocketSession))) {
              var defaultSession = this.squ_1.gqv(this.xqu_1);
              var clientSession = new DefaultClientWebSocketSession(this.uqu_1.i8x_1, defaultSession);
              var tmp_4;
              if (this.tqu_1) {
                tmp_4 = completeNegotiation(this.squ_1, this.uqu_1.i8x_1);
              } else {
                tmp_4 = emptyList();
              }
              var negotiated = tmp_4;
              clientSession.f9a(negotiated);
              tmp_3 = clientSession;
            } else {
              tmp_3 = new DelegatingClientWebSocketSession(this.uqu_1.i8x_1, this.xqu_1);
            }

            tmp_2.bqv_1 = tmp_3;
            this.y9_1 = 1;
            suspendResult = this.uqu_1.m8w(new HttpResponseContainer(this.wqu_1, this.bqv_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(WebSockets$Plugin$install$slambda_1).dq7 = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, completion) {
    var i = new WebSockets$Plugin$install$slambda_1(this.squ_1, this.tqu_1, completion);
    i.uqu_1 = $this$intercept;
    i.vqu_1 = _name_for_destructuring_parameter_0__wldtmu;
    return i;
  };
  function WebSockets$Plugin$install$slambda_2($plugin, $extensionsSupported, resultContinuation) {
    var i = new WebSockets$Plugin$install$slambda_1($plugin, $extensionsSupported, resultContinuation);
    var l = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
      return i.cq7($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function installExtensions($this, context) {
    var installed = $this.eqv_1.k2p();
    context.tq7_1.n8s(get_REQUEST_EXTENSIONS_KEY(), installed);
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = installed.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.client.plugins.websocket.WebSockets.installExtensions.<anonymous>' call
      var list = element.hqv();
      addAll_1(destination, list);
    }
    var protocols = destination;
    addNegotiatedProtocols($this, context, protocols);
  }
  function completeNegotiation($this, call) {
    var tmp0_safe_receiver = call.pq6().g94().fe(HttpHeaders_getInstance().o92_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'io.ktor.client.plugins.websocket.WebSockets.completeNegotiation.<anonymous>' call
      tmp = parseWebSocketExtensions(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    var serverExtensions = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
    var clientExtensions = call.cq9().k8s(get_REQUEST_EXTENSIONS_KEY());
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = clientExtensions.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.client.plugins.websocket.WebSockets.completeNegotiation.<anonymous>' call
      if (element.iqv(serverExtensions)) {
        destination.e(element);
      }
    }
    return destination;
  }
  function addNegotiatedProtocols($this, context, protocols) {
    if (protocols.p())
      return Unit_instance;
    var headerValue = joinToString_0(protocols, ';');
    header(context, HttpHeaders_getInstance().o92_1, headerValue);
  }
  function Config_3() {
    this.jqv_1 = new WebSocketExtensionsConfig();
    this.kqv_1 = new Long(-1, -1);
    this.lqv_1 = new Long(2147483647, 0);
    this.mqv_1 = null;
  }
  function Plugin_5() {
    Plugin_instance_5 = this;
    this.nqv_1 = new AttributeKey('Websocket');
  }
  protoOf(Plugin_5).x = function () {
    return this.nqv_1;
  };
  protoOf(Plugin_5).oqv = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_3();
    block(this_0);
    var config = this_0;
    return new WebSockets(config.kqv_1, config.lqv_1, config.jqv_1, config.mqv_1);
  };
  protoOf(Plugin_5).sq8 = function (block) {
    return this.oqv(block);
  };
  protoOf(Plugin_5).pqv = function (plugin, scope) {
    var extensionsSupported = scope.iq5_1.rqc().s(WebSocketExtensionsCapability_instance);
    var tmp = Phases_getInstance().lqe_1;
    scope.oq5_1.m8x(tmp, WebSockets$Plugin$install$slambda_0(extensionsSupported, plugin, null));
    var tmp_0 = Phases_getInstance_1().nq8_1;
    scope.pq5_1.m8x(tmp_0, WebSockets$Plugin$install$slambda_2(plugin, extensionsSupported, null));
  };
  protoOf(Plugin_5).tq8 = function (plugin, scope) {
    return this.pqv(plugin instanceof WebSockets ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_5;
  function Plugin_getInstance_5() {
    if (Plugin_instance_5 == null)
      new Plugin_5();
    return Plugin_instance_5;
  }
  function WebSockets(pingInterval, maxFrameSize, extensionsConfig, contentConverter) {
    Plugin_getInstance_5();
    contentConverter = contentConverter === VOID ? null : contentConverter;
    this.cqv_1 = pingInterval;
    this.dqv_1 = maxFrameSize;
    this.eqv_1 = extensionsConfig;
    this.fqv_1 = contentConverter;
  }
  protoOf(WebSockets).gqv = function (session) {
    if (isInterface(session, DefaultWebSocketSession))
      return session;
    // Inline function 'kotlin.Long.times' call
    var tmp$ret$0 = this.cqv_1.k3(toLong(2));
    // Inline function 'kotlin.also' call
    var this_0 = DefaultWebSocketSession_0(session, this.cqv_1, tmp$ret$0);
    // Inline function 'io.ktor.client.plugins.websocket.WebSockets.convertSessionToDefault.<anonymous>' call
    this_0.g9a(this.dqv_1);
    return this_0;
  };
  function WebSocketExtensionsCapability() {
  }
  protoOf(WebSocketExtensionsCapability).toString = function () {
    return 'WebSocketExtensionsCapability';
  };
  var WebSocketExtensionsCapability_instance;
  function WebSocketExtensionsCapability_getInstance() {
    return WebSocketExtensionsCapability_instance;
  }
  function WebSocketCapability() {
  }
  protoOf(WebSocketCapability).toString = function () {
    return 'WebSocketCapability';
  };
  var WebSocketCapability_instance;
  function WebSocketCapability_getInstance() {
    return WebSocketCapability_instance;
  }
  function WebSocketException_init_$Init$(message, $this) {
    WebSocketException.call($this, message, null);
    return $this;
  }
  function WebSocketException_init_$Create$(message) {
    var tmp = WebSocketException_init_$Init$(message, objectCreate(protoOf(WebSocketException)));
    captureStack(tmp, WebSocketException_init_$Create$);
    return tmp;
  }
  function WebSocketException(message, cause) {
    IllegalStateException_init_$Init$_1(message, cause, this);
    captureStack(this, WebSocketException);
  }
  var properties_initialized_WebSockets_kt_2t2hw2;
  function _init_properties_WebSockets_kt__jaqpbo() {
    if (!properties_initialized_WebSockets_kt_2t2hw2) {
      properties_initialized_WebSockets_kt_2t2hw2 = true;
      REQUEST_EXTENSIONS_KEY = new AttributeKey('Websocket extensions');
      LOGGER_7 = KtorSimpleLogger('io.ktor.client.plugins.websocket.WebSockets');
    }
  }
  function WebSockets_0(_this__u8e3s4, config) {
    var tmp = Plugin_getInstance_5();
    _this__u8e3s4.uq8(tmp, WebSockets$lambda(config));
  }
  function webSocket(_this__u8e3s4, urlString, request, block, $completion) {
    var tmp;
    if (request === VOID) {
      tmp = webSocket$lambda;
    } else {
      tmp = request;
    }
    request = tmp;
    var tmp_0 = Companion_getInstance_143().h94_1;
    return webSocket_0(_this__u8e3s4, tmp_0, null, null, null, webSocket$lambda_0(urlString, request), block, $completion);
  }
  function webSocket_0(_this__u8e3s4, method, host, port, path, request, block, $completion) {
    method = method === VOID ? Companion_getInstance_143().h94_1 : method;
    host = host === VOID ? null : host;
    port = port === VOID ? null : port;
    path = path === VOID ? null : path;
    var tmp;
    if (request === VOID) {
      tmp = webSocket$lambda_1;
    } else {
      tmp = request;
    }
    request = tmp;
    return webSocket_1(_this__u8e3s4, webSocket$lambda_2(method, host, port, path, request), block, $completion);
  }
  function webSocket_1(_this__u8e3s4, request, block, $completion) {
    var tmp = new $webSocketCOROUTINE$9(_this__u8e3s4, request, block, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function WebSockets$lambda($config) {
    return function ($this$install) {
      $config($this$install);
      return Unit_instance;
    };
  }
  function webSocket$lambda($this$null) {
    return Unit_instance;
  }
  function webSocket$lambda_0($urlString, $request) {
    return function ($this$webSocket) {
      $this$webSocket.oq7_1.h97_1 = Companion_getInstance_148().m98_1;
      $this$webSocket.oq7_1.j97_1 = get_port($this$webSocket);
      takeFrom($this$webSocket.oq7_1, $urlString);
      $request($this$webSocket);
      return Unit_instance;
    };
  }
  function webSocket$lambda_1($this$null) {
    return Unit_instance;
  }
  function webSocket$lambda_2($method, $host, $port, $path, $request) {
    return function ($this$webSocket) {
      $this$webSocket.pq7_1 = $method;
      url_0($this$webSocket, 'ws', $host, $port, $path);
      $request($this$webSocket);
      return Unit_instance;
    };
  }
  function webSocket$lambda_3($this$url, it) {
    $this$url.h97_1 = Companion_getInstance_148().m98_1;
    return Unit_instance;
  }
  function $webSocketCOROUTINE$9(_this__u8e3s4, request, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yqv_1 = _this__u8e3s4;
    this.zqv_1 = request;
    this.aqw_1 = block;
  }
  protoOf($webSocketCOROUTINE$9).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 20;
            plugin(this.yqv_1, Plugin_getInstance_5());
            var tmp_0 = this;
            var tmp1 = this.yqv_1;
            var this_0 = new HttpRequestBuilder();
            this_0.qqw(webSocket$lambda_3);
            this.zqv_1(this_0);
            tmp_0.bqw_1 = new HttpStatement(this_0, tmp1);
            var tmp_1 = this;
            tmp_1.cqw_1 = this.bqw_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.eqw_1 = this.cqw_1;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.z9_1 = 19;
            this.y9_1 = 3;
            suspendResult = this.eqw_1.tqw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.gqw_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.y9_1 = 5;
            continue $sm;
          case 5:
            this.z9_1 = 17;
            var tmp_2 = this;
            tmp_2.iqw_1 = this.gqw_1;
            this.jqw_1 = this.iqw_1;
            this.y9_1 = 6;
            var tmp_3 = this.jqw_1.uqa();
            var tmp_4 = JsType_instance;
            var tmp_5 = getKClass(DefaultClientWebSocketSession);
            var tmp_6;
            try {
              tmp_6 = createKType(getKClass(DefaultClientWebSocketSession), arrayOf([]), false);
            } catch ($p) {
              var tmp_7;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_7 = null;
              } else {
                throw $p;
              }
              tmp_6 = tmp_7;
            }

            suspendResult = tmp_3.yq9(typeInfoImpl(tmp_4, tmp_5, tmp_6), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp_8 = this;
            tmp_8.kqw_1 = suspendResult instanceof DefaultClientWebSocketSession ? suspendResult : THROW_CCE();
            var tmp_9 = this;
            tmp_9.lqw_1 = this.kqw_1;
            this.mqw_1 = this.lqw_1;
            this.y9_1 = 7;
            continue $sm;
          case 7:
            this.z9_1 = 15;
            this.y9_1 = 8;
            suspendResult = this.aqw_1(this.mqw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.nqw_1 = suspendResult;
            this.y9_1 = 9;
            continue $sm;
          case 9:
            this.z9_1 = 17;
            this.y9_1 = 10;
            suspendResult = close_1(this.mqw_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            var tmp_10 = this;
            this.mqw_1.i9a().k1c();
            tmp_10.hqw_1 = Unit_instance;
            this.y9_1 = 11;
            var tmp_11 = this;
            continue $sm;
          case 11:
            this.z9_1 = 19;
            this.y9_1 = 12;
            suspendResult = this.eqw_1.uqw(this.gqw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            this.dqw_1 = suspendResult;
            this.z9_1 = 20;
            this.y9_1 = 23;
            continue $sm;
          case 13:
            this.z9_1 = 19;
            this.y9_1 = 14;
            suspendResult = this.eqw_1.uqw(this.gqw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 14:
            var tmp_12 = this;
            tmp_12.fqw_1 = Unit_instance;
            this.z9_1 = 20;
            this.y9_1 = 22;
            continue $sm;
          case 15:
            this.z9_1 = 17;
            this.oqw_1 = this.ba_1;
            this.y9_1 = 16;
            suspendResult = close_1(this.mqw_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 16:
            this.mqw_1.i9a().k1c();
            throw this.oqw_1;
          case 17:
            this.z9_1 = 19;
            this.pqw_1 = this.ba_1;
            this.y9_1 = 18;
            suspendResult = this.eqw_1.uqw(this.gqw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 18:
            throw this.pqw_1;
          case 19:
            this.z9_1 = 20;
            var tmp_13 = this.ba_1;
            if (tmp_13 instanceof CancellationException) {
              var cause_0 = this.ba_1;
              throw unwrapCancellationException_0(cause_0);
            } else {
              throw this.ba_1;
            }

          case 20:
            throw this.ba_1;
          case 21:
            this.z9_1 = 20;
            if (false) {
              this.y9_1 = 2;
              continue $sm;
            }

            this.y9_1 = 22;
            continue $sm;
          case 22:
            this.dqw_1 = this.fqw_1;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 23;
            continue $sm;
          case 23:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 20) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ClientUpgradeContent$content$delegate$lambda() {
    return ByteChannel();
  }
  function ClientUpgradeContent() {
    NoContent.call(this);
    var tmp = this;
    tmp.wqw_1 = lazy_0(ClientUpgradeContent$content$delegate$lambda);
  }
  function DefaultHttpRequest(call, data) {
    this.xqw_1 = call;
    this.yqw_1 = data.lqc_1;
    this.zqw_1 = data.kqc_1;
    this.aqx_1 = data.nqc_1;
    this.bqx_1 = data.mqc_1;
    this.cqx_1 = data.pqc_1;
  }
  protoOf(DefaultHttpRequest).uqa = function () {
    return this.xqw_1;
  };
  protoOf(DefaultHttpRequest).et = function () {
    return this.uqa().et();
  };
  protoOf(DefaultHttpRequest).vqa = function () {
    return this.yqw_1;
  };
  protoOf(DefaultHttpRequest).jbu = function () {
    return this.zqw_1;
  };
  protoOf(DefaultHttpRequest).g67 = function () {
    return this.aqx_1;
  };
  protoOf(DefaultHttpRequest).g94 = function () {
    return this.bqx_1;
  };
  protoOf(DefaultHttpRequest).cq9 = function () {
    return this.cqx_1;
  };
  function HttpRequest_0() {
  }
  function Companion_372() {
  }
  var Companion_instance_372;
  function Companion_getInstance_372() {
    return Companion_instance_372;
  }
  function HttpRequestBuilder$setCapability$lambda() {
    // Inline function 'kotlin.collections.mutableMapOf' call
    return LinkedHashMap_init_$Create$();
  }
  function HttpRequestBuilder() {
    this.oq7_1 = new URLBuilder();
    this.pq7_1 = Companion_getInstance_143().h94_1;
    this.qq7_1 = new HeadersBuilder();
    this.rq7_1 = EmptyContent_getInstance();
    this.sq7_1 = SupervisorJob();
    this.tq7_1 = AttributesJsFn(true);
  }
  protoOf(HttpRequestBuilder).g94 = function () {
    return this.qq7_1;
  };
  protoOf(HttpRequestBuilder).kqd = function (value) {
    if (!(value == null)) {
      this.tq7_1.n8s(get_BodyTypeAttributeKey(), value);
    } else {
      this.tq7_1.o8s(get_BodyTypeAttributeKey());
    }
  };
  protoOf(HttpRequestBuilder).dqx = function () {
    return this.tq7_1.l8s(get_BodyTypeAttributeKey());
  };
  protoOf(HttpRequestBuilder).qqw = function (block) {
    return block(this.oq7_1, this.oq7_1);
  };
  protoOf(HttpRequestBuilder).k2p = function () {
    var tmp = this.oq7_1.k2p();
    var tmp_0 = this.pq7_1;
    var tmp_1 = this.qq7_1.k2p();
    var tmp_2 = this.rq7_1;
    var tmp0_elvis_lhs = tmp_2 instanceof OutgoingContent ? tmp_2 : null;
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      var message = 'No request transformation found: ' + toString_1(this.rq7_1);
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    return new HttpRequestData(tmp, tmp_0, tmp_1, tmp_3, this.sq7_1, this.tq7_1);
  };
  protoOf(HttpRequestBuilder).jqd = function (builder) {
    this.sq7_1 = builder.sq7_1;
    return this.eqx(builder);
  };
  protoOf(HttpRequestBuilder).eqx = function (builder) {
    this.pq7_1 = builder.pq7_1;
    this.rq7_1 = builder.rq7_1;
    this.kqd(builder.dqx());
    takeFrom_0(this.oq7_1, builder.oq7_1);
    this.oq7_1.o97_1 = this.oq7_1.o97_1;
    appendAll(this.qq7_1, builder.qq7_1);
    putAll_1(this.tq7_1, builder.tq7_1);
    return this;
  };
  protoOf(HttpRequestBuilder).yqs = function (key, capability) {
    var tmp = get_ENGINE_CAPABILITIES_KEY();
    var capabilities = this.tq7_1.p8s(tmp, HttpRequestBuilder$setCapability$lambda);
    // Inline function 'kotlin.collections.set' call
    capabilities.r2(key, capability);
  };
  protoOf(HttpRequestBuilder).xqs = function (key) {
    var tmp0_safe_receiver = this.tq7_1.l8s(get_ENGINE_CAPABILITIES_KEY());
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y2(key);
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  function HttpRequestData(url, method, headers, body, executionContext, attributes) {
    this.kqc_1 = url;
    this.lqc_1 = method;
    this.mqc_1 = headers;
    this.nqc_1 = body;
    this.oqc_1 = executionContext;
    this.pqc_1 = attributes;
    var tmp = this;
    var tmp0_safe_receiver = this.pqc_1.l8s(get_ENGINE_CAPABILITIES_KEY());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u2();
    tmp.qqc_1 = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  }
  protoOf(HttpRequestData).toString = function () {
    return 'HttpRequestData(url=' + this.kqc_1.toString() + ', method=' + this.lqc_1.toString() + ')';
  };
  function HttpResponseData(statusCode, requestTime, headers, version, body, callContext) {
    this.vq8_1 = statusCode;
    this.wq8_1 = requestTime;
    this.xq8_1 = headers;
    this.yq8_1 = version;
    this.zq8_1 = body;
    this.aq9_1 = callContext;
    this.bq9_1 = GMTDate_0();
  }
  protoOf(HttpResponseData).toString = function () {
    return 'HttpResponseData=(statusCode=' + this.vq8_1.toString() + ')';
  };
  function url(_this__u8e3s4, urlString) {
    takeFrom(_this__u8e3s4.oq7_1, urlString);
  }
  function isUpgradeRequest(_this__u8e3s4) {
    var tmp = _this__u8e3s4.nqc_1;
    return tmp instanceof ClientUpgradeContent;
  }
  function url_0(_this__u8e3s4, scheme, host, port, path, block) {
    scheme = scheme === VOID ? null : scheme;
    host = host === VOID ? null : host;
    port = port === VOID ? null : port;
    path = path === VOID ? null : path;
    var tmp;
    if (block === VOID) {
      tmp = url$lambda;
    } else {
      tmp = block;
    }
    block = tmp;
    set_0(_this__u8e3s4.oq7_1, scheme, host, port, path, block);
  }
  function url$lambda($this$null) {
    return Unit_instance;
  }
  function Phases() {
    Phases_instance = this;
    this.iqe_1 = new PipelinePhase('Before');
    this.jqe_1 = new PipelinePhase('State');
    this.kqe_1 = new PipelinePhase('Transform');
    this.lqe_1 = new PipelinePhase('Render');
    this.mqe_1 = new PipelinePhase('Send');
  }
  var Phases_instance;
  function Phases_getInstance() {
    if (Phases_instance == null)
      new Phases();
    return Phases_instance;
  }
  function HttpRequestPipeline(developmentMode) {
    Phases_getInstance();
    developmentMode = developmentMode === VOID ? false : developmentMode;
    Pipeline.call(this, [Phases_getInstance().iqe_1, Phases_getInstance().jqe_1, Phases_getInstance().kqe_1, Phases_getInstance().lqe_1, Phases_getInstance().mqe_1]);
    this.mqx_1 = developmentMode;
  }
  protoOf(HttpRequestPipeline).g8x = function () {
    return this.mqx_1;
  };
  function Phases_0() {
    Phases_instance_0 = this;
    this.dq8_1 = new PipelinePhase('Before');
    this.eq8_1 = new PipelinePhase('State');
    this.fq8_1 = new PipelinePhase('Monitoring');
    this.gq8_1 = new PipelinePhase('Engine');
    this.hq8_1 = new PipelinePhase('Receive');
  }
  var Phases_instance_0;
  function Phases_getInstance_0() {
    if (Phases_instance_0 == null)
      new Phases_0();
    return Phases_instance_0;
  }
  function HttpSendPipeline(developmentMode) {
    Phases_getInstance_0();
    developmentMode = developmentMode === VOID ? false : developmentMode;
    Pipeline.call(this, [Phases_getInstance_0().dq8_1, Phases_getInstance_0().eq8_1, Phases_getInstance_0().fq8_1, Phases_getInstance_0().gq8_1, Phases_getInstance_0().hq8_1]);
    this.uqx_1 = developmentMode;
  }
  protoOf(HttpSendPipeline).g8x = function () {
    return this.uqx_1;
  };
  function get_BodyTypeAttributeKey() {
    _init_properties_RequestBody_kt__bo3lwf();
    return BodyTypeAttributeKey;
  }
  var BodyTypeAttributeKey;
  var properties_initialized_RequestBody_kt_agyv1b;
  function _init_properties_RequestBody_kt__bo3lwf() {
    if (!properties_initialized_RequestBody_kt_agyv1b) {
      properties_initialized_RequestBody_kt_agyv1b = true;
      BodyTypeAttributeKey = new AttributeKey('BodyTypeAttributeKey');
    }
  }
  function header(_this__u8e3s4, key, value) {
    var tmp;
    if (value == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'io.ktor.client.request.header.<anonymous>' call
      _this__u8e3s4.g94().r8u(key, toString_1(value));
      tmp = Unit_instance;
    }
    var tmp_0;
    if (tmp == null) {
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = Unit_instance;
    }
    return tmp_0;
  }
  function parameter(_this__u8e3s4, key, value) {
    var tmp;
    if (value == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'io.ktor.client.request.parameter.<anonymous>' call
      _this__u8e3s4.oq7_1.q97_1.r8u(key, toString_1(value));
      tmp = Unit_instance;
    }
    var tmp_0;
    if (tmp == null) {
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = Unit_instance;
    }
    return tmp_0;
  }
  function accept(_this__u8e3s4, contentType) {
    return _this__u8e3s4.g94().r8u(HttpHeaders_getInstance().d90_1, contentType.toString());
  }
  function get_port(_this__u8e3s4) {
    return _this__u8e3s4.oq7_1.j97_1;
  }
  function DefaultHttpResponse(call, responseData) {
    HttpResponse.call(this);
    this.vqx_1 = call;
    this.wqx_1 = responseData.aq9_1;
    this.xqx_1 = responseData.vq8_1;
    this.yqx_1 = responseData.yq8_1;
    this.zqx_1 = responseData.wq8_1;
    this.aqy_1 = responseData.bq9_1;
    var tmp = this;
    var tmp_0 = responseData.zq8_1;
    var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel_1) ? tmp_0 : null;
    tmp.bqy_1 = tmp0_elvis_lhs == null ? Companion_getInstance_133().g8l() : tmp0_elvis_lhs;
    this.cqy_1 = responseData.xq8_1;
  }
  protoOf(DefaultHttpResponse).uqa = function () {
    return this.vqx_1;
  };
  protoOf(DefaultHttpResponse).et = function () {
    return this.wqx_1;
  };
  protoOf(DefaultHttpResponse).zq9 = function () {
    return this.xqx_1;
  };
  protoOf(DefaultHttpResponse).gko = function () {
    return this.yqx_1;
  };
  protoOf(DefaultHttpResponse).fqb = function () {
    return this.zqx_1;
  };
  protoOf(DefaultHttpResponse).gqb = function () {
    return this.aqy_1;
  };
  protoOf(DefaultHttpResponse).g67 = function () {
    return this.bqy_1;
  };
  protoOf(DefaultHttpResponse).g94 = function () {
    return this.cqy_1;
  };
  function HttpResponse() {
  }
  protoOf(HttpResponse).toString = function () {
    return 'HttpResponse[' + get_request(this).jbu().toString() + ', ' + this.zq9().toString() + ']';
  };
  function get_request(_this__u8e3s4) {
    return _this__u8e3s4.uqa().xq9();
  }
  function complete_0(_this__u8e3s4) {
    var tmp = ensureNotNull(_this__u8e3s4.et().la(Key_instance_3));
    var job = isInterface(tmp, CompletableJob) ? tmp : THROW_CCE();
    job.oz();
  }
  function bodyAsText(_this__u8e3s4, fallbackCharset, $completion) {
    fallbackCharset = fallbackCharset === VOID ? Charsets_getInstance().q8o_1 : fallbackCharset;
    var tmp = new $bodyAsTextCOROUTINE$19(_this__u8e3s4, fallbackCharset, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function $bodyAsTextCOROUTINE$19(_this__u8e3s4, fallbackCharset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lqy_1 = _this__u8e3s4;
    this.mqy_1 = fallbackCharset;
  }
  protoOf($bodyAsTextCOROUTINE$19).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = charset_0(this.lqy_1);
            tmp_0.nqy_1 = tmp0_elvis_lhs == null ? this.mqy_1 : tmp0_elvis_lhs;
            this.oqy_1 = this.nqy_1.t8o();
            var tmp_1 = this;
            tmp_1.pqy_1 = this.lqy_1;
            this.qqy_1 = this.pqy_1;
            this.y9_1 = 1;
            var tmp_2 = this.qqy_1.uqa();
            var tmp_3 = JsType_instance;
            var tmp_4 = getKClass(ByteReadPacket);
            var tmp_5;
            try {
              tmp_5 = createKType(getKClass(ByteReadPacket), arrayOf([]), false);
            } catch ($p) {
              var tmp_6;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_6 = null;
              } else {
                throw $p;
              }
              tmp_5 = tmp_6;
            }

            suspendResult = tmp_2.yq9(typeInfoImpl(tmp_3, tmp_4, tmp_5), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var input = suspendResult instanceof ByteReadPacket ? suspendResult : THROW_CCE();
            return decode(this.oqy_1, input);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function Phases_1() {
    Phases_instance_1 = this;
    this.lq8_1 = new PipelinePhase('Receive');
    this.mq8_1 = new PipelinePhase('Parse');
    this.nq8_1 = new PipelinePhase('Transform');
    this.oq8_1 = new PipelinePhase('State');
    this.pq8_1 = new PipelinePhase('After');
  }
  var Phases_instance_1;
  function Phases_getInstance_1() {
    if (Phases_instance_1 == null)
      new Phases_1();
    return Phases_instance_1;
  }
  function HttpResponsePipeline(developmentMode) {
    Phases_getInstance_1();
    developmentMode = developmentMode === VOID ? false : developmentMode;
    Pipeline.call(this, [Phases_getInstance_1().lq8_1, Phases_getInstance_1().mq8_1, Phases_getInstance_1().nq8_1, Phases_getInstance_1().oq8_1, Phases_getInstance_1().pq8_1]);
    this.yqy_1 = developmentMode;
  }
  protoOf(HttpResponsePipeline).g8x = function () {
    return this.yqy_1;
  };
  function Phases_2() {
    Phases_instance_2 = this;
    this.nqe_1 = new PipelinePhase('Before');
    this.oqe_1 = new PipelinePhase('State');
    this.pqe_1 = new PipelinePhase('After');
  }
  var Phases_instance_2;
  function Phases_getInstance_2() {
    if (Phases_instance_2 == null)
      new Phases_2();
    return Phases_instance_2;
  }
  function HttpReceivePipeline(developmentMode) {
    Phases_getInstance_2();
    developmentMode = developmentMode === VOID ? false : developmentMode;
    Pipeline.call(this, [Phases_getInstance_2().nqe_1, Phases_getInstance_2().oqe_1, Phases_getInstance_2().pqe_1]);
    this.gqz_1 = developmentMode;
  }
  protoOf(HttpReceivePipeline).g8x = function () {
    return this.gqz_1;
  };
  function HttpResponseContainer(expectedType, response) {
    this.vq9_1 = expectedType;
    this.wq9_1 = response;
  }
  protoOf(HttpResponseContainer).ug = function () {
    return this.vq9_1;
  };
  protoOf(HttpResponseContainer).vg = function () {
    return this.wq9_1;
  };
  protoOf(HttpResponseContainer).toString = function () {
    return 'HttpResponseContainer(expectedType=' + this.vq9_1.toString() + ', response=' + toString_1(this.wq9_1) + ')';
  };
  protoOf(HttpResponseContainer).hashCode = function () {
    var result = this.vq9_1.hashCode();
    result = imul(result, 31) + hashCode(this.wq9_1) | 0;
    return result;
  };
  protoOf(HttpResponseContainer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpResponseContainer))
      return false;
    var tmp0_other_with_cast = other instanceof HttpResponseContainer ? other : THROW_CCE();
    if (!this.vq9_1.equals(tmp0_other_with_cast.vq9_1))
      return false;
    if (!equals(this.wq9_1, tmp0_other_with_cast.wq9_1))
      return false;
    return true;
  };
  function checkCapabilities($this) {
    var tmp0_safe_receiver = $this.rqw_1.tq7_1.l8s(get_ENGINE_CAPABILITIES_KEY());
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u2();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.filterIsInstance' call
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp1_safe_receiver.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        if (!(element == null) ? isInterface(element, HttpClientPlugin) : false) {
          destination.e(element);
        }
      }
      tmp = destination;
    }
    var tmp2_safe_receiver = tmp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = tmp2_safe_receiver.k();
      while (_iterator__ex2g4s_0.l()) {
        var element_0 = _iterator__ex2g4s_0.m();
        // Inline function 'io.ktor.client.statement.HttpStatement.checkCapabilities.<anonymous>' call
        var tmp0 = pluginOrNull($this.sqw_1, element_0);
        $l$block: {
          // Inline function 'kotlin.requireNotNull' call
          if (tmp0 == null) {
            // Inline function 'io.ktor.client.statement.HttpStatement.checkCapabilities.<anonymous>.<anonymous>' call
            var message = 'Consider installing ' + toString_1(element_0) + ' plugin because the request requires it to be installed';
            throw IllegalArgumentException_init_$Create$_0(toString_1(message));
          } else {
            break $l$block;
          }
        }
      }
    }
  }
  function HttpStatement$execute$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpStatement$execute$slambda).qqz = function (it, $completion) {
    var tmp = this.rqg(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpStatement$execute$slambda).oa = function (p1, $completion) {
    return this.qqz(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpStatement$execute$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = save(this.pqz_1.uqa(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var savedCall = suspendResult;
            return savedCall.pq6();
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpStatement$execute$slambda).rqg = function (it, completion) {
    var i = new HttpStatement$execute$slambda(completion);
    i.pqz_1 = it;
    return i;
  };
  function HttpStatement$execute$slambda_0(resultContinuation) {
    var i = new HttpStatement$execute$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.qqz(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $executeCOROUTINE$20(_this__u8e3s4, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zqz_1 = _this__u8e3s4;
    this.ar0_1 = block;
  }
  protoOf($executeCOROUTINE$20).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 13;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 12;
            this.y9_1 = 2;
            suspendResult = this.zqz_1.tqw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.cr0_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.z9_1 = 10;
            this.y9_1 = 5;
            suspendResult = this.ar0_1(this.cr0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.dr0_1 = suspendResult;
            this.y9_1 = 6;
            var tmp_0 = this;
            continue $sm;
          case 6:
            this.er0_1 = this.dr0_1;
            this.z9_1 = 12;
            this.y9_1 = 7;
            suspendResult = this.zqz_1.uqw(this.cr0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            return this.er0_1;
          case 8:
            this.z9_1 = 12;
            this.y9_1 = 9;
            suspendResult = this.zqz_1.uqw(this.cr0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            var tmp_1 = this;
            tmp_1.br0_1 = Unit_instance;
            this.z9_1 = 13;
            this.y9_1 = 15;
            continue $sm;
          case 10:
            this.z9_1 = 12;
            this.fr0_1 = this.ba_1;
            this.y9_1 = 11;
            suspendResult = this.zqz_1.uqw(this.cr0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            throw this.fr0_1;
          case 12:
            this.z9_1 = 13;
            var tmp_2 = this.ba_1;
            if (tmp_2 instanceof CancellationException) {
              var cause = this.ba_1;
              throw unwrapCancellationException_0(cause);
            } else {
              throw this.ba_1;
            }

          case 13:
            throw this.ba_1;
          case 14:
            this.z9_1 = 13;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 15;
            continue $sm;
          case 15:
            return this.br0_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 13) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $executeUnsafeCOROUTINE$21(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.or0_1 = _this__u8e3s4;
  }
  protoOf($executeUnsafeCOROUTINE$21).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 3;
            this.qr0_1 = (new HttpRequestBuilder()).jqd(this.or0_1.rqw_1);
            this.y9_1 = 2;
            suspendResult = this.or0_1.sqw_1.qq8(this.qr0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var call = suspendResult;
            var tmp_0 = this;
            return call.pq6();
          case 3:
            this.z9_1 = 4;
            var tmp_1 = this.ba_1;
            if (tmp_1 instanceof CancellationException) {
              var cause = this.ba_1;
              throw unwrapCancellationException_0(cause);
            } else {
              throw this.ba_1;
            }

          case 4:
            throw this.ba_1;
          case 5:
            this.z9_1 = 4;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 6;
            continue $sm;
          case 6:
            return this.pr0_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $cleanupCOROUTINE$22(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zr0_1 = _this__u8e3s4;
    this.ar1_1 = _this__u8e3s4_0;
  }
  protoOf($cleanupCOROUTINE$22).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            var tmp_1 = ensureNotNull(this.ar1_1.et().la(Key_instance_3));
            tmp_0.br1_1 = isInterface(tmp_1, CompletableJob) ? tmp_1 : THROW_CCE();
            var tmp_2 = this;
            tmp_2.cr1_1 = this.br1_1;
            this.dr1_1 = this.cr1_1;
            var tmp_3 = this;
            tmp_3.er1_1 = this.dr1_1;
            this.fr1_1 = this.er1_1;
            this.fr1_1.oz();
            this.z9_1 = 1;
            cancel_3(this.ar1_1.g67());
            this.z9_1 = 4;
            this.y9_1 = 2;
            continue $sm;
          case 1:
            this.z9_1 = 4;
            var tmp_4 = this.ba_1;
            if (tmp_4 instanceof Error) {
              this.gr1_1 = this.ba_1;
              this.y9_1 = 2;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 2:
            this.z9_1 = 4;
            this.y9_1 = 3;
            suspendResult = this.fr1_1.ku(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function HttpStatement(builder, client) {
    this.rqw_1 = builder;
    this.sqw_1 = client;
    checkCapabilities(this);
  }
  protoOf(HttpStatement).hr1 = function (block, $completion) {
    var tmp = new $executeCOROUTINE$20(this, block, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpStatement).ir1 = function ($completion) {
    return this.hr1(HttpStatement$execute$slambda_0(null), $completion);
  };
  protoOf(HttpStatement).tqw = function ($completion) {
    var tmp = new $executeUnsafeCOROUTINE$21(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpStatement).uqw = function (_this__u8e3s4, $completion) {
    var tmp = new $cleanupCOROUTINE$22(this, _this__u8e3s4, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(HttpStatement).toString = function () {
    return 'HttpStatement[' + this.rqw_1.oq7_1.toString() + ']';
  };
  function observable(_this__u8e3s4, context, contentLength, listener) {
    var tmp = GlobalScope_instance;
    return writer(tmp, context, true, observable$slambda_0(contentLength, _this__u8e3s4, listener, null)).y15();
  }
  function observable$slambda($contentLength, $this_observable, $listener, resultContinuation) {
    this.rr1_1 = $contentLength;
    this.sr1_1 = $this_observable;
    this.tr1_1 = $listener;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(observable$slambda).rqb = function ($this$writer, $completion) {
    var tmp = this.sqb($this$writer, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(observable$slambda).oa = function (p1, $completion) {
    return this.rqb((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(observable$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 15;
            var tmp_0 = this;
            tmp_0.vr1_1 = get_ByteArrayPool();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.xr1_1 = this.vr1_1;
            this.yr1_1 = this.xr1_1.d8n();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 14;
            var tmp_1 = this;
            tmp_1.ar2_1 = this.yr1_1;
            this.br2_1 = this.ar2_1;
            var tmp_2 = this;
            var tmp0_elvis_lhs = this.rr1_1;
            tmp_2.cr2_1 = tmp0_elvis_lhs == null ? new Long(-1, -1) : tmp0_elvis_lhs;
            this.dr2_1 = new Long(0, 0);
            this.y9_1 = 4;
            continue $sm;
          case 4:
            if (!!this.sr1_1.z8e()) {
              this.y9_1 = 8;
              continue $sm;
            }

            this.y9_1 = 5;
            suspendResult = readAvailable(this.sr1_1, this.br2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.er2_1 = suspendResult;
            this.y9_1 = 6;
            suspendResult = this.ur1_1.y15().b8k(this.br2_1, 0, this.er2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp_3 = this;
            var tmp0 = this.dr2_1;
            var other = this.er2_1;
            tmp_3.dr2_1 = tmp0.i3(toLong(other));
            this.y9_1 = 7;
            suspendResult = this.tr1_1(this.dr2_1, this.cr2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.y9_1 = 4;
            continue $sm;
          case 8:
            this.fr2_1 = this.sr1_1.j8e();
            this.ur1_1.y15().g1c(this.fr2_1);
            if (this.fr2_1 == null && this.dr2_1.equals(new Long(0, 0))) {
              this.y9_1 = 9;
              suspendResult = this.tr1_1(this.dr2_1, this.cr2_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 10;
              continue $sm;
            }

          case 9:
            this.y9_1 = 10;
            continue $sm;
          case 10:
            var tmp_4 = this;
            tmp_4.zr1_1 = Unit_instance;
            this.z9_1 = 15;
            this.y9_1 = 11;
            var tmp_5 = this;
            continue $sm;
          case 11:
            this.z9_1 = 15;
            var tmp_6 = this;
            this.xr1_1.e8n(this.yr1_1);
            tmp_6.wr1_1 = Unit_instance;
            this.y9_1 = 13;
            continue $sm;
          case 12:
            this.z9_1 = 15;
            this.xr1_1.e8n(this.yr1_1);
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 13;
            continue $sm;
          case 13:
            return Unit_instance;
          case 14:
            this.z9_1 = 15;
            var t = this.ba_1;
            this.xr1_1.e8n(this.yr1_1);
            throw t;
          case 15:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 15) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(observable$slambda).sqb = function ($this$writer, completion) {
    var i = new observable$slambda(this.rr1_1, this.sr1_1, this.tr1_1, completion);
    i.ur1_1 = $this$writer;
    return i;
  };
  function observable$slambda_0($contentLength, $this_observable, $listener, resultContinuation) {
    var i = new observable$slambda($contentLength, $this_observable, $listener, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.rqb($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function get_HttpRequestCreated() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpRequestCreated;
  }
  var HttpRequestCreated;
  function get_HttpRequestIsReadyForSending() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpRequestIsReadyForSending;
  }
  var HttpRequestIsReadyForSending;
  function get_HttpResponseReceived() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpResponseReceived;
  }
  var HttpResponseReceived;
  function get_HttpResponseReceiveFailed() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpResponseReceiveFailed;
  }
  var HttpResponseReceiveFailed;
  function get_HttpResponseCancelled() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpResponseCancelled;
  }
  var HttpResponseCancelled;
  function HttpResponseReceiveFail(response, cause) {
    this.gr2_1 = response;
    this.hr2_1 = cause;
  }
  var properties_initialized_ClientEvents_kt_rdee4m;
  function _init_properties_ClientEvents_kt__xuvbz8() {
    if (!properties_initialized_ClientEvents_kt_rdee4m) {
      properties_initialized_ClientEvents_kt_rdee4m = true;
      HttpRequestCreated = new EventDefinition();
      HttpRequestIsReadyForSending = new EventDefinition();
      HttpResponseReceived = new EventDefinition();
      HttpResponseReceiveFailed = new EventDefinition();
      HttpResponseCancelled = new EventDefinition();
    }
  }
  function EmptyContent() {
    EmptyContent_instance = this;
    NoContent.call(this);
    this.jr2_1 = new Long(0, 0);
  }
  protoOf(EmptyContent).i99 = function () {
    return this.jr2_1;
  };
  protoOf(EmptyContent).toString = function () {
    return 'EmptyContent';
  };
  var EmptyContent_instance;
  function EmptyContent_getInstance() {
    if (EmptyContent_instance == null)
      new EmptyContent();
    return EmptyContent_instance;
  }
  function buildHeaders(block) {
    var tmp;
    if (block === VOID) {
      tmp = buildHeaders$lambda;
    } else {
      tmp = block;
    }
    block = tmp;
    // Inline function 'kotlin.apply' call
    var this_0 = new HeadersBuilder();
    block(this_0);
    return this_0.k2p();
  }
  function buildHeaders$lambda($this$null) {
    return Unit_instance;
  }
  function HttpClient_1(block) {
    var tmp;
    if (block === VOID) {
      tmp = HttpClient$lambda_3;
    } else {
      tmp = block;
    }
    block = tmp;
    return HttpClient_0(JsClient(), block);
  }
  function HttpClient$lambda_3($this$null) {
    return Unit_instance;
  }
  function ioDispatcher() {
    return Dispatchers_getInstance().p14_1;
  }
  function JsClient() {
    return Js_instance;
  }
  function Js() {
  }
  protoOf(Js).kr2 = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new HttpClientEngineConfig();
    block(this_0);
    return new JsClientEngine(this_0);
  };
  protoOf(Js).rq8 = function (block) {
    return this.kr2(block);
  };
  var Js_instance;
  function Js_getInstance() {
    return Js_instance;
  }
  function createWebSocket($this, urlString_capturingHack, headers) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = headers.h8u();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.client.engine.js.JsClientEngine.createWebSocket.<anonymous>' call
      if (equals_0(element, 'sec-websocket-protocol', true)) {
        destination.e(element);
      }
    }
    var protocolHeaderNames = destination;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = protocolHeaderNames.k();
    while (_iterator__ex2g4s_0.l()) {
      var element_0 = _iterator__ex2g4s_0.m();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'io.ktor.client.engine.js.JsClientEngine.createWebSocket.<anonymous>' call
      var tmp0_safe_receiver = headers.g8u(element_0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>.<anonymous>' call
        destination_0.e(tmp0_safe_receiver);
      }
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = flatten(destination_0);
    var protocols = copyToArray(this_0);
    var tmp;
    if (get_platform(PlatformUtils_getInstance()).a3_1 === 2) {
      tmp = new WebSocket(urlString_capturingHack, protocols);
    } else {
      var ws_capturingHack = eval('require')('ws');
      var headers_capturingHack = new JsClientEngine$createWebSocket$headers_capturingHack$1();
      headers.j8u(JsClientEngine$createWebSocket$lambda(headers_capturingHack));
      tmp = new ws_capturingHack(urlString_capturingHack, protocols, {headers: headers_capturingHack});
    }
    return tmp;
  }
  function executeWebSocketRequest($this, request, callContext, $completion) {
    var tmp = new $executeWebSocketRequestCOROUTINE$24($this, request, callContext, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function JsClientEngine$createWebSocket$headers_capturingHack$1() {
  }
  function JsClientEngine$createWebSocket$lambda($headers_capturingHack) {
    return function (name, values) {
      $headers_capturingHack[name] = joinToString_0(values, ',');
      return Unit_instance;
    };
  }
  function $executeCOROUTINE$23(_this__u8e3s4, data, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ir3_1 = _this__u8e3s4;
    this.jr3_1 = data;
  }
  protoOf($executeCOROUTINE$23).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            this.y9_1 = 1;
            suspendResult = callContext(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.kr3_1 = suspendResult;
            this.lr3_1 = this.jr3_1.pqc_1.k8s(get_CLIENT_CONFIG());
            if (isUpgradeRequest(this.jr3_1)) {
              this.y9_1 = 5;
              suspendResult = executeWebSocketRequest(this.ir3_1, this.jr3_1, this.kr3_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 2;
              continue $sm;
            }

          case 2:
            this.mr3_1 = GMTDate_0();
            this.y9_1 = 3;
            suspendResult = toRaw(this.jr3_1, this.lr3_1, this.kr3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.nr3_1 = suspendResult;
            this.y9_1 = 4;
            suspendResult = commonFetch(this.jr3_1.kqc_1.toString(), this.nr3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var rawResponse = suspendResult;
            var status = new HttpStatusCode(rawResponse.status, rawResponse.statusText);
            var headers = mapToKtor(rawResponse.headers);
            var version = Companion_getInstance_144().r94_1;
            var body = readBody(CoroutineScope_0(this.kr3_1), rawResponse);
            return new HttpResponseData(status, this.mr3_1, headers, version, body, this.kr3_1);
          case 5:
            return suspendResult;
          case 6:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $executeWebSocketRequestCOROUTINE$24(_this__u8e3s4, request, callContext, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tr2_1 = _this__u8e3s4;
    this.ur2_1 = request;
    this.vr2_1 = callContext;
  }
  protoOf($executeWebSocketRequestCOROUTINE$24).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.wr2_1 = GMTDate_0();
            this.xr2_1 = this.ur2_1.kqc_1.toString();
            this.yr2_1 = createWebSocket(this.tr2_1, this.xr2_1, this.ur2_1.mqc_1);
            this.zr2_1 = new JsWebSocketSession(this.vr2_1, this.yr2_1);
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = awaitConnection(this.yr2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.z9_1 = 4;
            this.y9_1 = 3;
            continue $sm;
          case 2:
            this.z9_1 = 4;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof Error) {
              var cause = this.ba_1;
              cancel_2(this.vr2_1, CancellationException_init_$Create$_1('Failed to connect to ' + this.xr2_1, cause));
              throw cause;
            } else {
              throw this.ba_1;
            }

          case 3:
            this.z9_1 = 4;
            return new HttpResponseData(Companion_getInstance_145().z94_1, this.wr2_1, Companion_getInstance_142().a90_1, Companion_getInstance_144().r94_1, this.zr2_1, this.vr2_1);
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function JsClientEngine(config) {
    HttpClientEngineBase.call(this, 'ktor-js');
    this.sr3_1 = config;
    this.tr3_1 = setOf_0([Plugin_getInstance_4(), WebSocketCapability_instance]);
    // Inline function 'kotlin.check' call
    if (!(this.sr3_1.gqe_1 == null)) {
      // Inline function 'io.ktor.client.engine.js.JsClientEngine.<anonymous>' call
      var message = 'Proxy unsupported in Js engine.';
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(JsClientEngine).upn = function () {
    return this.sr3_1;
  };
  protoOf(JsClientEngine).rqc = function () {
    return this.tr3_1;
  };
  protoOf(JsClientEngine).xqd = function (data, $completion) {
    var tmp = new $executeCOROUTINE$23(this, data, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function mapToKtor(_this__u8e3s4) {
    return buildHeaders(mapToKtor$lambda(_this__u8e3s4));
  }
  function awaitConnection(_this__u8e3s4, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.iy();
    $l$block: {
      // Inline function 'io.ktor.client.engine.js.awaitConnection.<anonymous>' call
      if (cancellable.bu()) {
        break $l$block;
      }
      var eventListener = awaitConnection$lambda(cancellable, _this__u8e3s4);
      _this__u8e3s4.addEventListener('open', eventListener);
      _this__u8e3s4.addEventListener('error', eventListener);
      cancellable.rw(awaitConnection$lambda_0(_this__u8e3s4, eventListener));
    }
    return cancellable.py();
  }
  function asString(_this__u8e3s4) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_1();
    // Inline function 'io.ktor.client.engine.js.asString.<anonymous>' call
    var tmp = JSON;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = ['message', 'target', 'type', 'isTrusted'];
    this_0.d9(tmp.stringify(_this__u8e3s4, tmp$ret$2));
    return this_0.toString();
  }
  function JsError(origin) {
    extendThrowable(this, 'Error from javascript[' + origin + '].');
    captureStack(this, JsError);
    this.ur3_1 = origin;
  }
  function mapToKtor$lambda$lambda($this_buildHeaders) {
    return function (value, key) {
      $this_buildHeaders.r8u(key, value);
      return Unit_instance;
    };
  }
  function mapToKtor$lambda($this_mapToKtor) {
    return function ($this$buildHeaders) {
      // Inline function 'kotlin.js.asDynamic' call
      $this_mapToKtor.forEach(mapToKtor$lambda$lambda($this$buildHeaders));
      return Unit_instance;
    };
  }
  function awaitConnection$lambda($continuation, $this_awaitConnection) {
    return function (event) {
      var tmp0_subject = event.type;
      var tmp;
      if (tmp0_subject === 'open') {
        var tmp0 = $continuation;
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = $this_awaitConnection;
        var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
        tmp0.ja(tmp$ret$0);
        tmp = Unit_instance;
      } else if (tmp0_subject === 'error') {
        var tmp2 = $continuation;
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = WebSocketException_init_$Create$(asString(event));
        var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
        tmp2.ja(tmp$ret$2);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function awaitConnection$lambda_0($this_awaitConnection, $eventListener) {
    return function (it) {
      $this_awaitConnection.removeEventListener('open', $eventListener);
      $this_awaitConnection.removeEventListener('error', $eventListener);
      var tmp;
      if (!(it == null)) {
        $this_awaitConnection.close();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function toRaw(_this__u8e3s4, clientConfig, callContext, $completion) {
    var tmp = new $toRawCOROUTINE$25(_this__u8e3s4, clientConfig, callContext, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function buildObject(block) {
    var tmp = {};
    // Inline function 'kotlin.apply' call
    var this_0 = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
    block(this_0);
    return this_0;
  }
  function toRaw$lambda($jsHeaders) {
    return function (key, value) {
      $jsHeaders[key] = value;
      return Unit_instance;
    };
  }
  function toRaw$slambda($content, resultContinuation) {
    this.rr4_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(toRaw$slambda).rqb = function ($this$writer, $completion) {
    var tmp = this.sqb($this$writer, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(toRaw$slambda).oa = function (p1, $completion) {
    return this.rqb((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(toRaw$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.rr4_1.o99(this.sr4_1.y15(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(toRaw$slambda).sqb = function ($this$writer, completion) {
    var i = new toRaw$slambda(this.rr4_1, completion);
    i.sr4_1 = $this$writer;
    return i;
  };
  function toRaw$slambda_0($content, resultContinuation) {
    var i = new toRaw$slambda($content, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.rqb($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function toRaw$lambda_0($this_toRaw, $jsHeaders, $clientConfig, $bodyBytes) {
    return function ($this$buildObject) {
      $this$buildObject.method = $this_toRaw.lqc_1.p94_1;
      $this$buildObject.headers = $jsHeaders;
      var tmp;
      if ($clientConfig.yq7_1) {
        // Inline function 'org.w3c.fetch.FOLLOW' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        tmp = 'follow';
      } else {
        // Inline function 'org.w3c.fetch.MANUAL' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        tmp = 'manual';
      }
      $this$buildObject.redirect = tmp;
      var tmp0_safe_receiver = $bodyBytes;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'io.ktor.client.engine.js.toRaw.<anonymous>.<anonymous>' call
        $this$buildObject.body = new Uint8Array(toTypedArray(tmp0_safe_receiver));
      }
      return Unit_instance;
    };
  }
  function $toRawCOROUTINE$25(_this__u8e3s4, clientConfig, callContext, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dr4_1 = _this__u8e3s4;
    this.er4_1 = clientConfig;
    this.fr4_1 = callContext;
  }
  protoOf($toRawCOROUTINE$25).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.gr4_1 = {};
            mergeHeaders(this.dr4_1.mqc_1, this.dr4_1.nqc_1, toRaw$lambda(this.gr4_1));
            this.hr4_1 = this.dr4_1.nqc_1;
            var tmp_0 = this.hr4_1;
            if (tmp_0 instanceof ByteArrayContent_0) {
              this.ir4_1 = this.hr4_1.j99();
              this.y9_1 = 3;
              continue $sm;
            } else {
              var tmp_1 = this.hr4_1;
              if (tmp_1 instanceof ReadChannelContent) {
                this.y9_1 = 2;
                suspendResult = this.hr4_1.m99().d8k(VOID, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_2 = this.hr4_1;
                if (tmp_2 instanceof WriteChannelContent) {
                  this.y9_1 = 1;
                  var tmp_3 = GlobalScope_instance;
                  suspendResult = writer(tmp_3, this.fr4_1, VOID, toRaw$slambda_0(this.hr4_1, null)).y15().d8k(VOID, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.ir4_1 = null;
                  this.y9_1 = 3;
                  continue $sm;
                }
              }
            }

          case 1:
            var ARGUMENT = suspendResult;
            this.ir4_1 = readBytes(ARGUMENT);
            this.y9_1 = 3;
            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            this.ir4_1 = readBytes(ARGUMENT_0);
            this.y9_1 = 3;
            continue $sm;
          case 3:
            var bodyBytes = this.ir4_1;
            return buildObject(toRaw$lambda_0(this.dr4_1, this.gr4_1, this.er4_1, bodyBytes));
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function asByteArray(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    return new Int8Array(_this__u8e3s4.buffer, _this__u8e3s4.byteOffset, _this__u8e3s4.length);
  }
  function readBodyBrowser(_this__u8e3s4, response) {
    var tmp0_elvis_lhs = response.body;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance_133().g8l();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var stream = tmp;
    return channelFromStream(_this__u8e3s4, stream);
  }
  function channelFromStream(_this__u8e3s4, stream) {
    return writer(_this__u8e3s4, VOID, VOID, channelFromStream$slambda_0(stream, null)).y15();
  }
  function readChunk(_this__u8e3s4, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.iy();
    // Inline function 'io.ktor.client.engine.js.browser.readChunk.<anonymous>' call
    var tmp = _this__u8e3s4.read();
    var tmp_0 = tmp.then(readChunk$lambda(cancellable));
    tmp_0.catch(readChunk$lambda_0(cancellable));
    return cancellable.py();
  }
  function channelFromStream$slambda($stream, resultContinuation) {
    this.br5_1 = $stream;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(channelFromStream$slambda).rqb = function ($this$writer, $completion) {
    var tmp = this.sqb($this$writer, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(channelFromStream$slambda).oa = function (p1, $completion) {
    return this.rqb((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(channelFromStream$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            this.dr5_1 = this.br5_1.getReader();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.y9_1 = 8;
              continue $sm;
            }

            this.z9_1 = 5;
            this.y9_1 = 2;
            suspendResult = readChunk(this.dr5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.er5_1 = suspendResult;
            if (this.er5_1 == null) {
              this.z9_1 = 6;
              this.y9_1 = 8;
              var tmp_0 = this;
              continue $sm;
            } else {
              this.fr5_1 = this.er5_1;
              this.y9_1 = 3;
              continue $sm;
            }

          case 3:
            this.gr5_1 = this.fr5_1;
            this.y9_1 = 4;
            suspendResult = writeFully(this.cr5_1.y15(), asByteArray(this.gr5_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.cr5_1.y15().v9();
            this.z9_1 = 6;
            this.y9_1 = 7;
            continue $sm;
          case 5:
            this.z9_1 = 6;
            var tmp_1 = this.ba_1;
            if (tmp_1 instanceof Error) {
              var cause = this.ba_1;
              this.dr5_1.cancel(cause);
              throw cause;
            } else {
              throw this.ba_1;
            }

          case 6:
            throw this.ba_1;
          case 7:
            this.z9_1 = 6;
            this.y9_1 = 1;
            continue $sm;
          case 8:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(channelFromStream$slambda).sqb = function ($this$writer, completion) {
    var i = new channelFromStream$slambda(this.br5_1, completion);
    i.cr5_1 = $this$writer;
    return i;
  };
  function channelFromStream$slambda_0($stream, resultContinuation) {
    var i = new channelFromStream$slambda($stream, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.rqb($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function readChunk$lambda($continuation) {
    return function (it) {
      var chunk = it.value;
      var result = it.done || chunk == null ? null : chunk;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(result);
      $continuation.ja(tmp$ret$0);
      return Unit_instance;
    };
  }
  function readChunk$lambda_0($continuation) {
    return function (cause) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(cause));
      this_0.ja(tmp$ret$0);
      return Unit_instance;
    };
  }
  function commonFetch(input, init, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.iy();
    // Inline function 'io.ktor.client.engine.js.compatibility.commonFetch.<anonymous>' call
    var controller = AbortController_0();
    init.signal = controller.signal;
    cancellable.rw(commonFetch$lambda(controller));
    var promise = get_platform(PlatformUtils_getInstance()).a3_1 === 2 ? fetch(input, init) : jsRequireNodeFetch()(input, init);
    var tmp = commonFetch$lambda_0(cancellable);
    promise.then(tmp, commonFetch$lambda_1(cancellable));
    return cancellable.py();
  }
  function readBody(_this__u8e3s4, response) {
    return get_platform(PlatformUtils_getInstance()).a3_1 === 3 ? readBodyNode(_this__u8e3s4, response) : readBodyBrowser(_this__u8e3s4, response);
  }
  function AbortController_0() {
    var tmp;
    if (get_platform(PlatformUtils_getInstance()).a3_1 === 2) {
      tmp = new AbortController();
    } else {
      var controller = eval('require')('abort-controller');
      tmp = new controller();
    }
    return tmp;
  }
  function jsRequireNodeFetch() {
    var tmp;
    try {
      tmp = eval('require')('node-fetch');
    } catch ($p) {
      var tmp_0;
      var cause = $p;
      throw Error_init_$Create$_0("Error loading module 'node-fetch': " + cause);
    }
    return tmp;
  }
  function commonFetch$lambda($controller) {
    return function (it) {
      $controller.abort();
      return Unit_instance;
    };
  }
  function commonFetch$lambda_0($continuation) {
    return function (it) {
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$0 = _Result___init__impl__xyqfz8(it);
      $continuation.ja(tmp$ret$0);
      return Unit_instance;
    };
  }
  function commonFetch$lambda_1($continuation) {
    return function (it) {
      // Inline function 'kotlin.Companion.failure' call
      var exception = Error_init_$Create$_1('Fail to fetch', it);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      $continuation.ja(tmp$ret$0);
      return Unit_instance;
    };
  }
  function readBodyNode(_this__u8e3s4, response) {
    return writer(_this__u8e3s4, VOID, VOID, readBodyNode$slambda_0(response, null)).y15();
  }
  function readBodyNode$slambda$lambda($responseData, $body) {
    return function (chunk) {
      _ChannelResult___get_isSuccess__impl__odq1z9($responseData.a1c(asByteArray(new Uint8Array(chunk))));
      return $body.pause();
    };
  }
  function readBodyNode$slambda$lambda_0($responseData, $this_writer) {
    return function (error) {
      var cause = new JsError(error);
      $responseData.g1c(cause);
      return $this_writer.y15().g1c(cause);
    };
  }
  function readBodyNode$slambda$lambda_1($responseData) {
    return function () {
      return $responseData.i1c();
    };
  }
  function readBodyNode$slambda($response, resultContinuation) {
    this.pr5_1 = $response;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(readBodyNode$slambda).rqb = function ($this$writer, $completion) {
    var tmp = this.sqb($this$writer, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(readBodyNode$slambda).oa = function (p1, $completion) {
    return this.rqb((!(p1 == null) ? isInterface(p1, WriterScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(readBodyNode$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.pr5_1.body;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              var message = 'Fail to get body';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.rr5_1 = tmp_1;
            this.sr5_1 = Channel(1);
            this.rr5_1.on('data', readBodyNode$slambda$lambda(this.sr5_1, this.rr5_1));
            this.rr5_1.on('error', readBodyNode$slambda$lambda_0(this.sr5_1, this.qr5_1));
            this.rr5_1.on('end', readBodyNode$slambda$lambda_1(this.sr5_1));
            this.z9_1 = 5;
            this.tr5_1 = this.sr5_1.k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.y9_1 = 2;
            suspendResult = this.tr5_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (!suspendResult) {
              this.y9_1 = 4;
              continue $sm;
            }

            this.ur5_1 = this.tr5_1.m();
            this.y9_1 = 3;
            suspendResult = writeFully(this.qr5_1.y15(), this.ur5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.qr5_1.y15().v9();
            this.rr5_1.resume();
            this.y9_1 = 1;
            continue $sm;
          case 4:
            this.z9_1 = 6;
            this.y9_1 = 7;
            continue $sm;
          case 5:
            this.z9_1 = 6;
            var tmp_2 = this.ba_1;
            if (tmp_2 instanceof Error) {
              var cause = this.ba_1;
              this.rr5_1.destroy(cause);
              throw cause;
            } else {
              throw this.ba_1;
            }

          case 6:
            throw this.ba_1;
          case 7:
            this.z9_1 = 6;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 6) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(readBodyNode$slambda).sqb = function ($this$writer, completion) {
    var i = new readBodyNode$slambda(this.pr5_1, completion);
    i.qr5_1 = $this$writer;
    return i;
  };
  function readBodyNode$slambda_0($response, resultContinuation) {
    var i = new readBodyNode$slambda($response, resultContinuation);
    var l = function ($this$writer, $completion) {
      return i.rqb($this$writer, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function platformRequestDefaultTransform(contentType, context, body) {
    return null;
  }
  function platformResponseDefaultTransformers(_this__u8e3s4) {
  }
  function isReservedStatusCode(_this__u8e3s4, $this) {
    // Inline function 'kotlin.let' call
    // Inline function 'io.ktor.client.plugins.websocket.JsWebSocketSession.isReservedStatusCode.<anonymous>' call
    var resolved = Companion_getInstance_150().a9a(_this__u8e3s4);
    return resolved == null || equals(resolved, Codes_CLOSED_ABNORMALLY_getInstance());
  }
  function JsWebSocketSession$lambda(this$0) {
    return function (it) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var event = it;
      var data = event.data;
      var tmp;
      if (data instanceof ArrayBuffer) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$3 = new Int8Array(data);
        tmp = Binary_init_$Create$(false, tmp$ret$3);
      } else {
        if (!(data == null) ? typeof data === 'string' : false) {
          tmp = Text_init_$Create$(data);
        } else {
          var error = IllegalStateException_init_$Create$_0('Unknown frame type: ' + event.type);
          this$0.xr5_1.nz(error);
          throw error;
        }
      }
      var frame = tmp;
      this$0.yr5_1.a1c(frame);
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda_0(this$0) {
    return function (it) {
      var cause = WebSocketException_init_$Create$(toString_1(it));
      this$0.xr5_1.nz(cause);
      this$0.yr5_1.g1c(cause);
      this$0.zr5_1.k1c();
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda_1(this$0) {
    return function (event) {
      var tmp = event.code;
      var tmp_0 = (!(tmp == null) ? typeof tmp === 'number' : false) ? tmp : THROW_CCE();
      var tmp_1 = event.reason;
      var reason = new CloseReason(tmp_0, (!(tmp_1 == null) ? typeof tmp_1 === 'string' : false) ? tmp_1 : THROW_CCE());
      this$0.xr5_1.lz(reason);
      this$0.yr5_1.a1c(Close_init_$Create$(reason));
      this$0.yr5_1.i1c();
      this$0.zr5_1.k1c();
      return Unit_instance;
    };
  }
  function JsWebSocketSession$slambda(this$0, resultContinuation) {
    this.lr6_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsWebSocketSession$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(JsWebSocketSession$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsWebSocketSession$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 10;
            var tmp_0 = this;
            tmp_0.nr6_1 = this.lr6_1.zr5_1;
            this.or6_1 = this.nr6_1;
            var tmp_1 = this;
            tmp_1.pr6_1 = this.or6_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.rr6_1 = this.pr6_1;
            this.sr6_1 = null;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 9;
            this.z9_1 = 8;
            var tmp_2 = this;
            tmp_2.ur6_1 = this.rr6_1;
            this.vr6_1 = this.ur6_1;
            this.wr6_1 = this.vr6_1.k();
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.y9_1 = 5;
            suspendResult = this.wr6_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.y9_1 = 6;
              continue $sm;
            }

            var e = this.wr6_1.m();
            switch (e.f9e_1.a3_1) {
              case 0:
                var text = e.g9e_1;
                this.lr6_1.wr5_1.send(String_0(text));
                break;
              case 1:
                var tmp_3 = e.g9e_1;
                var source = tmp_3 instanceof Int8Array ? tmp_3 : THROW_CCE();
                var frameData = source.buffer.slice(source.byteOffset, source.byteOffset + source.byteLength | 0);
                this.lr6_1.wr5_1.send(frameData);
                break;
              case 2:
                var tmp$ret$0;
                l$ret$1: do {
                  var builder = new BytePacketBuilder();
                  try {
                    writeFully_3(builder, e.g9e_1);
                    tmp$ret$0 = builder.k2p();
                    break l$ret$1;
                  } catch ($p) {
                    if ($p instanceof Error) {
                      var t = $p;
                      builder.vz();
                      throw t;
                    } else {
                      throw $p;
                    }
                  }
                }
                 while (false);
                var data = tmp$ret$0;
                var code = readShort_0(data);
                var reason = data.h8o();
                this.lr6_1.xr5_1.lz(new CloseReason(code, reason));
                if (isReservedStatusCode(code, this.lr6_1)) {
                  this.lr6_1.wr5_1.close();
                } else {
                  this.lr6_1.wr5_1.close(code, reason);
                }

                break;
              case 3:
              case 4:
                break;
            }

            this.y9_1 = 4;
            continue $sm;
          case 6:
            var tmp_4 = this;
            tmp_4.tr6_1 = Unit_instance;
            this.z9_1 = 10;
            this.y9_1 = 7;
            var tmp_5 = this;
            continue $sm;
          case 7:
            this.z9_1 = 10;
            var tmp_6 = this;
            cancelConsumed(this.rr6_1, this.sr6_1);
            tmp_6.qr6_1 = Unit_instance;
            this.y9_1 = 12;
            continue $sm;
          case 8:
            this.z9_1 = 9;
            var tmp_7 = this.ba_1;
            if (tmp_7 instanceof Error) {
              var e_0 = this.ba_1;
              var tmp_8 = this;
              this.sr6_1 = e_0;
              throw e_0;
            } else {
              throw this.ba_1;
            }

          case 9:
            this.z9_1 = 10;
            var t_0 = this.ba_1;
            cancelConsumed(this.rr6_1, this.sr6_1);
            throw t_0;
          case 10:
            throw this.ba_1;
          case 11:
            this.z9_1 = 10;
            cancelConsumed(this.rr6_1, this.sr6_1);
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 12;
            continue $sm;
          case 12:
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.z9_1 === 10) {
          throw e_1;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(JsWebSocketSession$slambda).i1l = function ($this$launch, completion) {
    var i = new JsWebSocketSession$slambda(this.lr6_1, completion);
    i.mr6_1 = $this$launch;
    return i;
  };
  function JsWebSocketSession$slambda_0(this$0, resultContinuation) {
    var i = new JsWebSocketSession$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsWebSocketSession$lambda_2(this$0) {
    return function (cause) {
      var tmp;
      if (cause == null) {
        this$0.wr5_1.close();
        tmp = Unit_instance;
      } else {
        this$0.wr5_1.close(Codes_NORMAL_getInstance().x99_1, 'Client failed');
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function JsWebSocketSession(coroutineContext, websocket) {
    this.vr5_1 = coroutineContext;
    this.wr5_1 = websocket;
    this.xr5_1 = CompletableDeferred();
    this.yr5_1 = Channel(2147483647);
    this.zr5_1 = Channel(2147483647);
    this.ar6_1 = this.yr5_1;
    this.br6_1 = this.zr5_1;
    this.cr6_1 = this.xr5_1;
    // Inline function 'org.w3c.dom.ARRAYBUFFER' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2 = 'arraybuffer';
    this.wr5_1.binaryType = tmp$ret$2;
    this.wr5_1.addEventListener('message', JsWebSocketSession$lambda(this));
    this.wr5_1.addEventListener('error', JsWebSocketSession$lambda_0(this));
    this.wr5_1.addEventListener('close', JsWebSocketSession$lambda_1(this));
    launch(this, VOID, VOID, JsWebSocketSession$slambda_0(this, null));
    var tmp0_safe_receiver = this.vr5_1.la(Key_instance_3);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.hu(JsWebSocketSession$lambda_2(this));
    }
  }
  protoOf(JsWebSocketSession).et = function () {
    return this.vr5_1;
  };
  protoOf(JsWebSocketSession).i9a = function () {
    return this.ar6_1;
  };
  protoOf(JsWebSocketSession).j9a = function () {
    return this.br6_1;
  };
  protoOf(JsWebSocketSession).e9a = function () {
    return this.cr6_1;
  };
  protoOf(JsWebSocketSession).g9a = function (_anonymous_parameter_0__qggqh8) {
    throw WebSocketException_init_$Create$('Max frame size switch is not supported in Js engine.');
  };
  protoOf(JsWebSocketSession).h9a = function () {
    return new Long(-1, 2147483647);
  };
  protoOf(JsWebSocketSession).f9a = function (negotiatedExtensions) {
    // Inline function 'kotlin.require' call
    if (!negotiatedExtensions.p()) {
      // Inline function 'io.ktor.client.plugins.websocket.JsWebSocketSession.start.<anonymous>' call
      var message = 'Extensions are not supported.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  };
  protoOf(JsWebSocketSession).l9a = function ($completion) {
    return Unit_instance;
  };
  function unwrapCancellationException_0(_this__u8e3s4) {
    var exception = _this__u8e3s4;
    $l$loop: while (exception instanceof CancellationException) {
      if (equals(exception, exception.cause)) {
        return _this__u8e3s4;
      }
      exception = exception.cause;
    }
    var tmp0_elvis_lhs = exception;
    return tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  }
  function Companion_373() {
  }
  protoOf(Companion_373).h67 = function () {
    return $serializer_getInstance_26();
  };
  var Companion_instance_373;
  function Companion_getInstance_373() {
    return Companion_instance_373;
  }
  function $serializer_28() {
    $serializer_instance_26 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.findUsages.UsageEntryDocumentDto', this, 6);
    tmp0_serialDesc.t5n('accession', false);
    tmp0_serialDesc.t5n('name', false);
    tmp0_serialDesc.t5n('type', false);
    tmp0_serialDesc.t5n('status', false);
    tmp0_serialDesc.t5n('readOnly', false);
    tmp0_serialDesc.t5n('editedByCurrentUser', false);
    this.xr6_1 = tmp0_serialDesc;
  }
  protoOf($serializer_28).yr6 = function (encoder, value) {
    var tmp0_desc = this.xr6_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.x5h(tmp0_desc, 0, value.accession);
    tmp1_output.x5h(tmp0_desc, 1, value.name);
    tmp1_output.x5h(tmp0_desc, 2, value.type);
    tmp1_output.x5h(tmp0_desc, 3, value.status);
    tmp1_output.p5h(tmp0_desc, 4, value.readOnly);
    tmp1_output.p5h(tmp0_desc, 5, value.editedByCurrentUser);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_28).j5d = function (encoder, value) {
    return this.yr6(encoder, value instanceof UsageEntryDocumentDto ? value : THROW_CCE());
  };
  protoOf($serializer_28).k5d = function (decoder) {
    var tmp0_desc = this.xr6_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = false;
    var tmp10_input = decoder.j5g(tmp0_desc);
    if (tmp10_input.y5g()) {
      tmp4_local0 = tmp10_input.t5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.t5g(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.t5g(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.t5g(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.l5g(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.l5g(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.t5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.t5g(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.t5g(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.t5g(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.l5g(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.l5g(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.k5g(tmp0_desc);
    return UsageEntryDocumentDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_28).w5c = function () {
    return this.xr6_1;
  };
  protoOf($serializer_28).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_26;
  function $serializer_getInstance_26() {
    if ($serializer_instance_26 == null)
      new $serializer_28();
    return $serializer_instance_26;
  }
  function UsageEntryDocumentDto_init_$Init$(seen0, accession, name, type, status, readOnly, editedByCurrentUser, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_26().xr6_1);
    }
    $this.accession = accession;
    $this.name = name;
    $this.type = type;
    $this.status = status;
    $this.readOnly = readOnly;
    $this.editedByCurrentUser = editedByCurrentUser;
    return $this;
  }
  function UsageEntryDocumentDto_init_$Create$(seen0, accession, name, type, status, readOnly, editedByCurrentUser, serializationConstructorMarker) {
    return UsageEntryDocumentDto_init_$Init$(seen0, accession, name, type, status, readOnly, editedByCurrentUser, serializationConstructorMarker, objectCreate(protoOf(UsageEntryDocumentDto)));
  }
  function UsageEntryDocumentDto(accession, name, type, status, readOnly, editedByCurrentUser) {
    this.accession = accession;
    this.name = name;
    this.type = type;
    this.status = status;
    this.readOnly = readOnly;
    this.editedByCurrentUser = editedByCurrentUser;
  }
  protoOf(UsageEntryDocumentDto).zr6 = function () {
    return this.accession;
  };
  protoOf(UsageEntryDocumentDto).b3 = function () {
    return this.name;
  };
  protoOf(UsageEntryDocumentDto).zb3 = function () {
    return this.type;
  };
  protoOf(UsageEntryDocumentDto).zq9 = function () {
    return this.status;
  };
  protoOf(UsageEntryDocumentDto).jpo = function () {
    return this.readOnly;
  };
  protoOf(UsageEntryDocumentDto).ar7 = function () {
    return this.editedByCurrentUser;
  };
  protoOf(UsageEntryDocumentDto).ug = function () {
    return this.accession;
  };
  protoOf(UsageEntryDocumentDto).vg = function () {
    return this.name;
  };
  protoOf(UsageEntryDocumentDto).hm = function () {
    return this.type;
  };
  protoOf(UsageEntryDocumentDto).g59 = function () {
    return this.status;
  };
  protoOf(UsageEntryDocumentDto).h59 = function () {
    return this.readOnly;
  };
  protoOf(UsageEntryDocumentDto).i59 = function () {
    return this.editedByCurrentUser;
  };
  protoOf(UsageEntryDocumentDto).br7 = function (accession, name, type, status, readOnly, editedByCurrentUser) {
    return new UsageEntryDocumentDto(accession, name, type, status, readOnly, editedByCurrentUser);
  };
  protoOf(UsageEntryDocumentDto).copy = function (accession, name, type, status, readOnly, editedByCurrentUser, $super) {
    accession = accession === VOID ? this.accession : accession;
    name = name === VOID ? this.name : name;
    type = type === VOID ? this.type : type;
    status = status === VOID ? this.status : status;
    readOnly = readOnly === VOID ? this.readOnly : readOnly;
    editedByCurrentUser = editedByCurrentUser === VOID ? this.editedByCurrentUser : editedByCurrentUser;
    return this.br7(accession, name, type, status, readOnly, editedByCurrentUser);
  };
  protoOf(UsageEntryDocumentDto).toString = function () {
    return 'UsageEntryDocumentDto(accession=' + this.accession + ', name=' + this.name + ', type=' + this.type + ', status=' + this.status + ', readOnly=' + this.readOnly + ', editedByCurrentUser=' + this.editedByCurrentUser + ')';
  };
  protoOf(UsageEntryDocumentDto).hashCode = function () {
    var result = getStringHashCode(this.accession);
    result = imul(result, 31) + getStringHashCode(this.name) | 0;
    result = imul(result, 31) + getStringHashCode(this.type) | 0;
    result = imul(result, 31) + getStringHashCode(this.status) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.readOnly) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.editedByCurrentUser) | 0;
    return result;
  };
  protoOf(UsageEntryDocumentDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UsageEntryDocumentDto))
      return false;
    var tmp0_other_with_cast = other instanceof UsageEntryDocumentDto ? other : THROW_CCE();
    if (!(this.accession === tmp0_other_with_cast.accession))
      return false;
    if (!(this.name === tmp0_other_with_cast.name))
      return false;
    if (!(this.type === tmp0_other_with_cast.type))
      return false;
    if (!(this.status === tmp0_other_with_cast.status))
      return false;
    if (!(this.readOnly === tmp0_other_with_cast.readOnly))
      return false;
    if (!(this.editedByCurrentUser === tmp0_other_with_cast.editedByCurrentUser))
      return false;
    return true;
  };
  function Companion_374() {
  }
  protoOf(Companion_374).h67 = function () {
    return $serializer_getInstance_27();
  };
  var Companion_instance_374;
  function Companion_getInstance_374() {
    return Companion_instance_374;
  }
  function $serializer_29() {
    $serializer_instance_27 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.findUsages.FindUsageServiceRequest', this, 3);
    tmp0_serialDesc.t5n('declaration', false);
    tmp0_serialDesc.t5n('docsPageSize', false);
    tmp0_serialDesc.t5n('nodesPageSize', false);
    this.cr7_1 = tmp0_serialDesc;
  }
  protoOf($serializer_29).dr7 = function (encoder, value) {
    var tmp0_desc = this.cr7_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.z5h(tmp0_desc, 0, NodePointerSerializer_getInstance(), value.declaration);
    tmp1_output.s5h(tmp0_desc, 1, value.docsPageSize);
    tmp1_output.s5h(tmp0_desc, 2, value.nodesPageSize);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_29).j5d = function (encoder, value) {
    return this.dr7(encoder, value instanceof FindUsageServiceRequest ? value : THROW_CCE());
  };
  protoOf($serializer_29).k5d = function (decoder) {
    var tmp0_desc = this.cr7_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_input = decoder.j5g(tmp0_desc);
    if (tmp7_input.y5g()) {
      tmp4_local0 = tmp7_input.v5g(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.o5g(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.o5g(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.v5g(tmp0_desc, 0, NodePointerSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.o5g(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.o5g(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.k5g(tmp0_desc);
    return FindUsageServiceRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_29).w5c = function () {
    return this.cr7_1;
  };
  protoOf($serializer_29).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [NodePointerSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  var $serializer_instance_27;
  function $serializer_getInstance_27() {
    if ($serializer_instance_27 == null)
      new $serializer_29();
    return $serializer_instance_27;
  }
  function FindUsageServiceRequest_init_$Init$(seen0, declaration, docsPageSize, nodesPageSize, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_27().cr7_1);
    }
    $this.declaration = declaration;
    $this.docsPageSize = docsPageSize;
    $this.nodesPageSize = nodesPageSize;
    return $this;
  }
  function FindUsageServiceRequest_init_$Create$(seen0, declaration, docsPageSize, nodesPageSize, serializationConstructorMarker) {
    return FindUsageServiceRequest_init_$Init$(seen0, declaration, docsPageSize, nodesPageSize, serializationConstructorMarker, objectCreate(protoOf(FindUsageServiceRequest)));
  }
  function FindUsageServiceRequest(declaration, docsPageSize, nodesPageSize) {
    this.declaration = declaration;
    this.docsPageSize = docsPageSize;
    this.nodesPageSize = nodesPageSize;
  }
  protoOf(FindUsageServiceRequest).mbd = function () {
    return this.declaration;
  };
  protoOf(FindUsageServiceRequest).er7 = function () {
    return this.docsPageSize;
  };
  protoOf(FindUsageServiceRequest).fr7 = function () {
    return this.nodesPageSize;
  };
  protoOf(FindUsageServiceRequest).ug = function () {
    return this.declaration;
  };
  protoOf(FindUsageServiceRequest).vg = function () {
    return this.docsPageSize;
  };
  protoOf(FindUsageServiceRequest).hm = function () {
    return this.nodesPageSize;
  };
  protoOf(FindUsageServiceRequest).gr7 = function (declaration, docsPageSize, nodesPageSize) {
    return new FindUsageServiceRequest(declaration, docsPageSize, nodesPageSize);
  };
  protoOf(FindUsageServiceRequest).copy = function (declaration, docsPageSize, nodesPageSize, $super) {
    declaration = declaration === VOID ? this.declaration : declaration;
    docsPageSize = docsPageSize === VOID ? this.docsPageSize : docsPageSize;
    nodesPageSize = nodesPageSize === VOID ? this.nodesPageSize : nodesPageSize;
    return this.gr7(declaration, docsPageSize, nodesPageSize);
  };
  protoOf(FindUsageServiceRequest).toString = function () {
    return 'FindUsageServiceRequest(declaration=' + this.declaration.toString() + ', docsPageSize=' + this.docsPageSize + ', nodesPageSize=' + this.nodesPageSize + ')';
  };
  protoOf(FindUsageServiceRequest).hashCode = function () {
    var result = this.declaration.hashCode();
    result = imul(result, 31) + this.docsPageSize | 0;
    result = imul(result, 31) + this.nodesPageSize | 0;
    return result;
  };
  protoOf(FindUsageServiceRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FindUsageServiceRequest))
      return false;
    var tmp0_other_with_cast = other instanceof FindUsageServiceRequest ? other : THROW_CCE();
    if (!this.declaration.equals(tmp0_other_with_cast.declaration))
      return false;
    if (!(this.docsPageSize === tmp0_other_with_cast.docsPageSize))
      return false;
    if (!(this.nodesPageSize === tmp0_other_with_cast.nodesPageSize))
      return false;
    return true;
  };
  function Companion_375() {
    Companion_instance_375 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.hr7_1 = [null, null, $serializer_init_$Create$_1($serializer_getInstance_24())];
  }
  protoOf(Companion_375).h67 = function () {
    return $serializer_getInstance_28();
  };
  var Companion_instance_375;
  function Companion_getInstance_375() {
    if (Companion_instance_375 == null)
      new Companion_375();
    return Companion_instance_375;
  }
  function $serializer_30() {
    $serializer_instance_28 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.findUsages.FindUsageDocumentInfo', this, 3);
    tmp0_serialDesc.t5n('document', false);
    tmp0_serialDesc.t5n('totalNodes', false);
    tmp0_serialDesc.t5n('initial', false);
    this.ir7_1 = tmp0_serialDesc;
  }
  protoOf($serializer_30).jr7 = function (encoder, value) {
    var tmp0_desc = this.ir7_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    var tmp2_cached = Companion_getInstance_375().hr7_1;
    tmp1_output.z5h(tmp0_desc, 0, $serializer_getInstance_26(), value.document);
    tmp1_output.s5h(tmp0_desc, 1, value.totalNodes);
    tmp1_output.z5h(tmp0_desc, 2, tmp2_cached[2], value.initial);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_30).j5d = function (encoder, value) {
    return this.jr7(encoder, value instanceof FindUsageDocumentInfo ? value : THROW_CCE());
  };
  protoOf($serializer_30).k5d = function (decoder) {
    var tmp0_desc = this.ir7_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_input = decoder.j5g(tmp0_desc);
    var tmp8_cached = Companion_getInstance_375().hr7_1;
    if (tmp7_input.y5g()) {
      tmp4_local0 = tmp7_input.v5g(tmp0_desc, 0, $serializer_getInstance_26(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.o5g(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.v5g(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.v5g(tmp0_desc, 0, $serializer_getInstance_26(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.o5g(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.v5g(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.k5g(tmp0_desc);
    return FindUsageDocumentInfo_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_30).w5c = function () {
    return this.ir7_1;
  };
  protoOf($serializer_30).i5o = function () {
    var tmp0_cached = Companion_getInstance_375().hr7_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_26(), IntSerializer_getInstance(), tmp0_cached[2]];
  };
  var $serializer_instance_28;
  function $serializer_getInstance_28() {
    if ($serializer_instance_28 == null)
      new $serializer_30();
    return $serializer_instance_28;
  }
  function FindUsageDocumentInfo_init_$Init$(seen0, document, totalNodes, initial, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_28().ir7_1);
    }
    $this.document = document;
    $this.totalNodes = totalNodes;
    $this.initial = initial;
    return $this;
  }
  function FindUsageDocumentInfo_init_$Create$(seen0, document, totalNodes, initial, serializationConstructorMarker) {
    return FindUsageDocumentInfo_init_$Init$(seen0, document, totalNodes, initial, serializationConstructorMarker, objectCreate(protoOf(FindUsageDocumentInfo)));
  }
  function FindUsageDocumentInfo(document, totalNodes, initial) {
    Companion_getInstance_375();
    this.document = document;
    this.totalNodes = totalNodes;
    this.initial = initial;
  }
  protoOf(FindUsageDocumentInfo).lkx = function () {
    return this.document;
  };
  protoOf(FindUsageDocumentInfo).kr7 = function () {
    return this.totalNodes;
  };
  protoOf(FindUsageDocumentInfo).lr7 = function () {
    return this.initial;
  };
  protoOf(FindUsageDocumentInfo).ug = function () {
    return this.document;
  };
  protoOf(FindUsageDocumentInfo).vg = function () {
    return this.totalNodes;
  };
  protoOf(FindUsageDocumentInfo).hm = function () {
    return this.initial;
  };
  protoOf(FindUsageDocumentInfo).mr7 = function (document, totalNodes, initial) {
    return new FindUsageDocumentInfo(document, totalNodes, initial);
  };
  protoOf(FindUsageDocumentInfo).copy = function (document, totalNodes, initial, $super) {
    document = document === VOID ? this.document : document;
    totalNodes = totalNodes === VOID ? this.totalNodes : totalNodes;
    initial = initial === VOID ? this.initial : initial;
    return this.mr7(document, totalNodes, initial);
  };
  protoOf(FindUsageDocumentInfo).toString = function () {
    return 'FindUsageDocumentInfo(document=' + this.document.toString() + ', totalNodes=' + this.totalNodes + ', initial=' + this.initial.toString() + ')';
  };
  protoOf(FindUsageDocumentInfo).hashCode = function () {
    var result = this.document.hashCode();
    result = imul(result, 31) + this.totalNodes | 0;
    result = imul(result, 31) + this.initial.hashCode() | 0;
    return result;
  };
  protoOf(FindUsageDocumentInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FindUsageDocumentInfo))
      return false;
    var tmp0_other_with_cast = other instanceof FindUsageDocumentInfo ? other : THROW_CCE();
    if (!this.document.equals(tmp0_other_with_cast.document))
      return false;
    if (!(this.totalNodes === tmp0_other_with_cast.totalNodes))
      return false;
    if (!this.initial.equals(tmp0_other_with_cast.initial))
      return false;
    return true;
  };
  function FindUsagePageEntry(document, nodes) {
    this.document = document;
    this.nodes = nodes;
  }
  protoOf(FindUsagePageEntry).lkx = function () {
    return this.document;
  };
  protoOf(FindUsagePageEntry).b3a = function () {
    return this.nodes;
  };
  protoOf(FindUsagePageEntry).ug = function () {
    return this.document;
  };
  protoOf(FindUsagePageEntry).vg = function () {
    return this.nodes;
  };
  protoOf(FindUsagePageEntry).nr7 = function (document, nodes) {
    return new FindUsagePageEntry(document, nodes);
  };
  protoOf(FindUsagePageEntry).copy = function (document, nodes, $super) {
    document = document === VOID ? this.document : document;
    nodes = nodes === VOID ? this.nodes : nodes;
    return this.nr7(document, nodes);
  };
  protoOf(FindUsagePageEntry).toString = function () {
    return 'FindUsagePageEntry(document=' + this.document.toString() + ', nodes=' + toString_1(this.nodes) + ')';
  };
  protoOf(FindUsagePageEntry).hashCode = function () {
    var result = this.document.hashCode();
    result = imul(result, 31) + hashCode(this.nodes) | 0;
    return result;
  };
  protoOf(FindUsagePageEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FindUsagePageEntry))
      return false;
    var tmp0_other_with_cast = other instanceof FindUsagePageEntry ? other : THROW_CCE();
    if (!this.document.equals(tmp0_other_with_cast.document))
      return false;
    if (!equals(this.nodes, tmp0_other_with_cast.nodes))
      return false;
    return true;
  };
  function FindUsageRequestController() {
  }
  function Companion_376() {
  }
  protoOf(Companion_376).h67 = function () {
    return $serializer_getInstance_29();
  };
  var Companion_instance_376;
  function Companion_getInstance_376() {
    return Companion_instance_376;
  }
  function $serializer_31() {
    $serializer_instance_29 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.findUsages.FindUsageResultTotals', this, 2);
    tmp0_serialDesc.t5n('totalDocs', false);
    tmp0_serialDesc.t5n('totalNodes', false);
    this.rr7_1 = tmp0_serialDesc;
  }
  protoOf($serializer_31).sr7 = function (encoder, value) {
    var tmp0_desc = this.rr7_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.s5h(tmp0_desc, 0, value.tr7_1);
    tmp1_output.s5h(tmp0_desc, 1, value.ur7_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_31).j5d = function (encoder, value) {
    return this.sr7(encoder, value instanceof FindUsageResultTotals ? value : THROW_CCE());
  };
  protoOf($serializer_31).k5d = function (decoder) {
    var tmp0_desc = this.rr7_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.j5g(tmp0_desc);
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.o5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.o5g(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.o5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.o5g(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return FindUsageResultTotals_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_31).w5c = function () {
    return this.rr7_1;
  };
  protoOf($serializer_31).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  var $serializer_instance_29;
  function $serializer_getInstance_29() {
    if ($serializer_instance_29 == null)
      new $serializer_31();
    return $serializer_instance_29;
  }
  function FindUsageResultTotals_init_$Init$(seen0, totalDocs, totalNodes, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_29().rr7_1);
    }
    $this.tr7_1 = totalDocs;
    $this.ur7_1 = totalNodes;
    return $this;
  }
  function FindUsageResultTotals_init_$Create$(seen0, totalDocs, totalNodes, serializationConstructorMarker) {
    return FindUsageResultTotals_init_$Init$(seen0, totalDocs, totalNodes, serializationConstructorMarker, objectCreate(protoOf(FindUsageResultTotals)));
  }
  function FindUsageResultTotals() {
  }
  protoOf(FindUsageResultTotals).toString = function () {
    return 'FindUsageResultTotals(totalDocs=' + this.tr7_1 + ', totalNodes=' + this.ur7_1 + ')';
  };
  protoOf(FindUsageResultTotals).hashCode = function () {
    var result = this.tr7_1;
    result = imul(result, 31) + this.ur7_1 | 0;
    return result;
  };
  protoOf(FindUsageResultTotals).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FindUsageResultTotals))
      return false;
    var tmp0_other_with_cast = other instanceof FindUsageResultTotals ? other : THROW_CCE();
    if (!(this.tr7_1 === tmp0_other_with_cast.tr7_1))
      return false;
    if (!(this.ur7_1 === tmp0_other_with_cast.ur7_1))
      return false;
    return true;
  };
  function FindUsageResultsPaged(totalNodes, delegate) {
    this.vr7_1 = delegate;
    this.totalNodes = totalNodes;
  }
  protoOf(FindUsageResultsPaged).kr7 = function () {
    return this.totalNodes;
  };
  protoOf(FindUsageResultsPaged).wr7 = function ($completion) {
    return this.vr7_1.wr7($completion);
  };
  protoOf(FindUsageResultsPaged).t2u = function () {
    return this.vr7_1.t2u();
  };
  protoOf(FindUsageResultsPaged).xr7 = function ($completion) {
    return this.vr7_1.xr7($completion);
  };
  function createFindUsageResultsPaged(controller, $completion) {
    var tmp = new $createFindUsageResultsPagedCOROUTINE$0(controller, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function findUsagePageEntry(controller, info) {
    var paged = createFindUsageNodesPaged(controller, info.document.accession, info.initial, info.totalNodes);
    return new FindUsagePageEntry(info.document, paged);
  }
  function createFindUsageNodesPaged(controller, accession, initial, totalNodes) {
    var tmp = Companion_instance_378;
    var tmp_0 = createFindUsageNodesPaged$slambda_0(totalNodes, null);
    return tmp.hr8(initial, tmp_0, createFindUsageNodesPaged$slambda_2(controller, accession, null));
  }
  function createFindUsageResultsPaged$slambda($controller, resultContinuation) {
    this.qr8_1 = $controller;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createFindUsageResultsPaged$slambda).sr8 = function ($this$async, $completion) {
    var tmp = this.i1l($this$async, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(createFindUsageResultsPaged$slambda).oa = function (p1, $completion) {
    return this.sr8((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(createFindUsageResultsPaged$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.qr8_1.or7(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(createFindUsageResultsPaged$slambda).i1l = function ($this$async, completion) {
    var i = new createFindUsageResultsPaged$slambda(this.qr8_1, completion);
    i.rr8_1 = $this$async;
    return i;
  };
  function createFindUsageResultsPaged$slambda_0($controller, resultContinuation) {
    var i = new createFindUsageResultsPaged$slambda($controller, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.sr8($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function createFindUsageResultsPaged$slambda_1($totals, resultContinuation) {
    this.br9_1 = $totals;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createFindUsageResultsPaged$slambda_1).cr9 = function ($completion) {
    var tmp = this.eag($completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(createFindUsageResultsPaged$slambda_1).fag = function ($completion) {
    return this.cr9($completion);
  };
  protoOf(createFindUsageResultsPaged$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.br9_1.gw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.ur7_1;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(createFindUsageResultsPaged$slambda_1).eag = function (completion) {
    return new createFindUsageResultsPaged$slambda_1(this.br9_1, completion);
  };
  function createFindUsageResultsPaged$slambda_2($totals, resultContinuation) {
    var i = new createFindUsageResultsPaged$slambda_1($totals, resultContinuation);
    var l = function ($completion) {
      return i.cr9($completion);
    };
    l.$arity = 0;
    return l;
  }
  function createFindUsageResultsPaged$slambda_3($totals, resultContinuation) {
    this.lr9_1 = $totals;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createFindUsageResultsPaged$slambda_3).cr9 = function ($completion) {
    var tmp = this.eag($completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(createFindUsageResultsPaged$slambda_3).fag = function ($completion) {
    return this.cr9($completion);
  };
  protoOf(createFindUsageResultsPaged$slambda_3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.lr9_1.gw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.tr7_1;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(createFindUsageResultsPaged$slambda_3).eag = function (completion) {
    return new createFindUsageResultsPaged$slambda_3(this.lr9_1, completion);
  };
  function createFindUsageResultsPaged$slambda_4($totals, resultContinuation) {
    var i = new createFindUsageResultsPaged$slambda_3($totals, resultContinuation);
    var l = function ($completion) {
      return i.cr9($completion);
    };
    l.$arity = 0;
    return l;
  }
  function createFindUsageResultsPaged$slambda_5($controller, resultContinuation) {
    this.ur9_1 = $controller;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createFindUsageResultsPaged$slambda_5).vr9 = function ($completion) {
    var tmp = this.eag($completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(createFindUsageResultsPaged$slambda_5).fag = function ($completion) {
    return this.vr9($completion);
  };
  protoOf(createFindUsageResultsPaged$slambda_5).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.ur9_1.pr7(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(createFindUsageResultsPaged$slambda_5).eag = function (completion) {
    return new createFindUsageResultsPaged$slambda_5(this.ur9_1, completion);
  };
  function createFindUsageResultsPaged$slambda_6($controller, resultContinuation) {
    var i = new createFindUsageResultsPaged$slambda_5($controller, resultContinuation);
    var l = function ($completion) {
      return i.vr9($completion);
    };
    l.$arity = 0;
    return l;
  }
  function createFindUsageResultsPaged$lambda($controller) {
    return function (it) {
      return findUsagePageEntry($controller, it);
    };
  }
  function createFindUsageNodesPaged$slambda($totalNodes, resultContinuation) {
    this.era_1 = $totalNodes;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createFindUsageNodesPaged$slambda).cr9 = function ($completion) {
    var tmp = this.eag($completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(createFindUsageNodesPaged$slambda).fag = function ($completion) {
    return this.cr9($completion);
  };
  protoOf(createFindUsageNodesPaged$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return this.era_1;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(createFindUsageNodesPaged$slambda).eag = function (completion) {
    return new createFindUsageNodesPaged$slambda(this.era_1, completion);
  };
  function createFindUsageNodesPaged$slambda_0($totalNodes, resultContinuation) {
    var i = new createFindUsageNodesPaged$slambda($totalNodes, resultContinuation);
    var l = function ($completion) {
      return i.cr9($completion);
    };
    l.$arity = 0;
    return l;
  }
  function createFindUsageNodesPaged$slambda_1($controller, $accession, resultContinuation) {
    this.nra_1 = $controller;
    this.ora_1 = $accession;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createFindUsageNodesPaged$slambda_1).pra = function ($completion) {
    var tmp = this.eag($completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(createFindUsageNodesPaged$slambda_1).fag = function ($completion) {
    return this.pra($completion);
  };
  protoOf(createFindUsageNodesPaged$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.nra_1.qr7(this.ora_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(createFindUsageNodesPaged$slambda_1).eag = function (completion) {
    return new createFindUsageNodesPaged$slambda_1(this.nra_1, this.ora_1, completion);
  };
  function createFindUsageNodesPaged$slambda_2($controller, $accession, resultContinuation) {
    var i = new createFindUsageNodesPaged$slambda_1($controller, $accession, resultContinuation);
    var l = function ($completion) {
      return i.pra($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $createFindUsageResultsPagedCOROUTINE$0(controller, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gr8_1 = controller;
  }
  protoOf($createFindUsageResultsPagedCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.gr8_1.pr7(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var initial = suspendResult;
            var tmp_0 = CoroutineScope_0(Dispatchers_getInstance().p14_1);
            var tmp_1 = CoroutineStart_LAZY_getInstance();
            var totals = async(tmp_0, VOID, tmp_1, createFindUsageResultsPaged$slambda_0(this.gr8_1, null));
            var tmp_2 = createFindUsageResultsPaged$slambda_2(totals, null);
            var tmp_3 = Companion_instance_378;
            var tmp_4 = createFindUsageResultsPaged$slambda_4(totals, null);
            var tmp_5 = tmp_3.hr8(initial, tmp_4, createFindUsageResultsPaged$slambda_6(this.gr8_1, null));
            return new FindUsageResultsPaged(tmp_2, map_4(tmp_5, createFindUsageResultsPaged$lambda(this.gr8_1)));
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $serializer_init_$Init$_1(typeSerial0, $this) {
    $serializer_32.call($this);
    $this.rra_1 = typeSerial0;
    return $this;
  }
  function $serializer_init_$Create$_1(typeSerial0) {
    return $serializer_init_$Init$_1(typeSerial0, objectCreate(protoOf($serializer_32)));
  }
  function Companion_377() {
    Companion_instance_377 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.findUsages.Page', null, 2);
    tmp0_serialDesc.t5n('data', true);
    tmp0_serialDesc.t5n('hasNextPage', false);
    this.sra_1 = tmp0_serialDesc;
  }
  protoOf(Companion_377).empty = function () {
    return new Page_2(VOID, false);
  };
  protoOf(Companion_377).y9p = function (typeSerial0) {
    return $serializer_init_$Create$_1(typeSerial0);
  };
  protoOf(Companion_377).t5o = function (typeParamsSerializers) {
    return this.y9p(typeParamsSerializers[0]);
  };
  protoOf(Companion_377).tra = function () {
    return this.sra_1;
  };
  var Companion_instance_377;
  function Companion_getInstance_377() {
    if (Companion_instance_377 == null)
      new Companion_377();
    return Companion_instance_377;
  }
  function $serializer_32() {
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.findUsages.Page', this, 2);
    tmp0_serialDesc.t5n('data', true);
    tmp0_serialDesc.t5n('hasNextPage', false);
    this.qra_1 = tmp0_serialDesc;
  }
  protoOf($serializer_32).ura = function (encoder, value) {
    var tmp0_desc = this.qra_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    if (tmp1_output.e5i(tmp0_desc, 0) ? true : !equals(value.data, emptyList())) {
      tmp1_output.z5h(tmp0_desc, 0, new ArrayListSerializer(this.rra_1), value.data);
    }
    tmp1_output.p5h(tmp0_desc, 1, value.hasNextPage);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_32).j5d = function (encoder, value) {
    return this.ura(encoder, value instanceof Page_2 ? value : THROW_CCE());
  };
  protoOf($serializer_32).k5d = function (decoder) {
    var tmp0_desc = this.qra_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.j5g(tmp0_desc);
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, new ArrayListSerializer(this.rra_1), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.l5g(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.v5g(tmp0_desc, 0, new ArrayListSerializer(this.rra_1), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.l5g(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return Page_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_32).w5c = function () {
    return this.qra_1;
  };
  protoOf($serializer_32).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [new ArrayListSerializer(this.rra_1), BooleanSerializer_getInstance()];
  };
  protoOf($serializer_32).j5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.rra_1];
  };
  function Page_init_$Init$(seen0, data, hasNextPage, serializationConstructorMarker, $this) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, Companion_getInstance_377().sra_1);
    }
    if (0 === (seen0 & 1))
      $this.data = emptyList();
    else
      $this.data = data;
    $this.hasNextPage = hasNextPage;
    return $this;
  }
  function Page_init_$Create$(seen0, data, hasNextPage, serializationConstructorMarker) {
    return Page_init_$Init$(seen0, data, hasNextPage, serializationConstructorMarker, objectCreate(protoOf(Page_2)));
  }
  function Page_2(data, hasNextPage) {
    Companion_getInstance_377();
    data = data === VOID ? emptyList() : data;
    this.data = data;
    this.hasNextPage = hasNextPage;
  }
  protoOf(Page_2).ebs = function () {
    return this.data;
  };
  protoOf(Page_2).vra = function () {
    return this.hasNextPage;
  };
  protoOf(Page_2).ug = function () {
    return this.data;
  };
  protoOf(Page_2).vg = function () {
    return this.hasNextPage;
  };
  protoOf(Page_2).wra = function (data, hasNextPage) {
    return new Page_2(data, hasNextPage);
  };
  protoOf(Page_2).copy = function (data, hasNextPage, $super) {
    data = data === VOID ? this.data : data;
    hasNextPage = hasNextPage === VOID ? this.hasNextPage : hasNextPage;
    return this.wra(data, hasNextPage);
  };
  protoOf(Page_2).toString = function () {
    return 'Page(data=' + toString_1(this.data) + ', hasNextPage=' + this.hasNextPage + ')';
  };
  protoOf(Page_2).hashCode = function () {
    var result = hashCode(this.data);
    result = imul(result, 31) + getBooleanHashCode(this.hasNextPage) | 0;
    return result;
  };
  protoOf(Page_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Page_2))
      return false;
    var tmp0_other_with_cast = other instanceof Page_2 ? other : THROW_CCE();
    if (!equals(this.data, tmp0_other_with_cast.data))
      return false;
    if (!(this.hasNextPage === tmp0_other_with_cast.hasNextPage))
      return false;
    return true;
  };
  function $toNextPageCOROUTINE$1(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.frb_1 = _this__u8e3s4;
  }
  protoOf($toNextPageCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            if (!this.frb_1.grb_1.hasNextPage) {
              var message = 'This paged has no next page';
              throw IllegalStateException_init_$Create$_0(toString_1(message));
            }

            this.y9_1 = 1;
            suspendResult = this.frb_1.irb_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.frb_1.grb_1 = ARGUMENT;
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function Paged$Companion$invoke$1($initial, $total, $next) {
    this.hrb_1 = $total;
    this.irb_1 = $next;
    this.grb_1 = $initial;
  }
  protoOf(Paged$Companion$invoke$1).wr7 = function ($completion) {
    return this.hrb_1($completion);
  };
  protoOf(Paged$Companion$invoke$1).t2u = function () {
    return this.grb_1;
  };
  protoOf(Paged$Companion$invoke$1).xr7 = function ($completion) {
    var tmp = new $toNextPageCOROUTINE$1(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function Companion_378() {
  }
  protoOf(Companion_378).hr8 = function (initial, total, next) {
    return new Paged$Companion$invoke$1(initial, total, next);
  };
  var Companion_instance_378;
  function Companion_getInstance_378() {
    return Companion_instance_378;
  }
  function map_4(_this__u8e3s4, func) {
    var tmp = Companion_instance_378;
    // Inline function 'jetbrains.biokb.editor.service.findUsages.map' call
    var this_0 = _this__u8e3s4.t2u();
    // Inline function 'kotlin.collections.map' call
    var this_1 = this_0.data;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s = this_1.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      destination.e(func(item));
    }
    var tmp_0 = new Page_2(destination, this_0.hasNextPage);
    var tmp_1 = Paged$total$ref_0(_this__u8e3s4);
    return tmp.hr8(tmp_0, tmp_1, map$slambda_0(_this__u8e3s4, func, null));
  }
  function nextPage(_this__u8e3s4, $completion) {
    var tmp = new $nextPageCOROUTINE$2(_this__u8e3s4, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function Paged$total$ref($boundThis) {
    this.srb_1 = $boundThis;
  }
  protoOf(Paged$total$ref).cr9 = function ($completion) {
    return this.srb_1.wr7($completion);
  };
  protoOf(Paged$total$ref).fag = function ($completion) {
    return this.cr9($completion);
  };
  function Paged$total$ref_0($boundThis) {
    var i = new Paged$total$ref($boundThis);
    var l = function ($completion) {
      return i.cr9($completion);
    };
    l.callableName = 'total';
    l.$arity = 0;
    return l;
  }
  function map$slambda($this_map, $func, resultContinuation) {
    this.brc_1 = $this_map;
    this.crc_1 = $func;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(map$slambda).drc = function ($completion) {
    var tmp = this.eag($completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(map$slambda).fag = function ($completion) {
    return this.drc($completion);
  };
  protoOf(map$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = nextPage(this.brc_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            var this_1 = this_0.data;
            var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_1, 10));
            var _iterator__ex2g4s = this_1.k();
            while (_iterator__ex2g4s.l()) {
              var item = _iterator__ex2g4s.m();
              destination.e(this.crc_1(item));
            }

            return new Page_2(destination, this_0.hasNextPage);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(map$slambda).eag = function (completion) {
    return new map$slambda(this.brc_1, this.crc_1, completion);
  };
  function map$slambda_0($this_map, $func, resultContinuation) {
    var i = new map$slambda($this_map, $func, resultContinuation);
    var l = function ($completion) {
      return i.drc($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $nextPageCOROUTINE$2(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rrb_1 = _this__u8e3s4;
  }
  protoOf($nextPageCOROUTINE$2).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.rrb_1.xr7(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.rrb_1.t2u();
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function PublishedFindUsageRequestControllerSerializer() {
    PublishedFindUsageRequestControllerSerializer_instance = this;
    InstancePublicationSerializer.call(this, Companion_getInstance_379());
  }
  var PublishedFindUsageRequestControllerSerializer_instance;
  function PublishedFindUsageRequestControllerSerializer_getInstance() {
    if (PublishedFindUsageRequestControllerSerializer_instance == null)
      new PublishedFindUsageRequestControllerSerializer();
    return PublishedFindUsageRequestControllerSerializer_instance;
  }
  function RemoteFindUsageRequestController$Companion$nextDocuments$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteFindUsageRequestController$Companion$nextDocuments$slambda).orc = function (controller, _unused_var__etf5q3, $completion) {
    var tmp = this.prc(controller, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(RemoteFindUsageRequestController$Companion$nextDocuments$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FindUsageRequestController) : false) ? p1 : THROW_CCE();
    return this.orc(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(RemoteFindUsageRequestController$Companion$nextDocuments$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.mrc_1.pr7(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteFindUsageRequestController$Companion$nextDocuments$slambda).prc = function (controller, _unused_var__etf5q3, completion) {
    var i = new RemoteFindUsageRequestController$Companion$nextDocuments$slambda(completion);
    i.mrc_1 = controller;
    i.nrc_1 = _unused_var__etf5q3;
    return i;
  };
  function RemoteFindUsageRequestController$Companion$nextDocuments$slambda_0(resultContinuation) {
    var i = new RemoteFindUsageRequestController$Companion$nextDocuments$slambda(resultContinuation);
    var l = function (controller, _unused_var__etf5q3, $completion) {
      return i.orc(controller, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda).ard = function (controller, acc, $completion) {
    var tmp = this.brd(controller, acc, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FindUsageRequestController) : false) ? p1 : THROW_CCE();
    return this.ard(tmp, p2 instanceof AccessionDto ? p2 : THROW_CCE(), $completion);
  };
  protoOf(RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.yrc_1.qr7(this.zrc_1.crd_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda).brd = function (controller, acc, completion) {
    var i = new RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda(completion);
    i.yrc_1 = controller;
    i.zrc_1 = acc;
    return i;
  };
  function RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda_0(resultContinuation) {
    var i = new RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda(resultContinuation);
    var l = function (controller, acc, $completion) {
      return i.ard(controller, acc, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function RemoteFindUsageRequestController$Companion$totals$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RemoteFindUsageRequestController$Companion$totals$slambda).nrd = function (controller, _unused_var__etf5q3, $completion) {
    var tmp = this.prc(controller, _unused_var__etf5q3, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(RemoteFindUsageRequestController$Companion$totals$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FindUsageRequestController) : false) ? p1 : THROW_CCE();
    return this.nrd(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(RemoteFindUsageRequestController$Companion$totals$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.lrd_1.or7(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(RemoteFindUsageRequestController$Companion$totals$slambda).prc = function (controller, _unused_var__etf5q3, completion) {
    var i = new RemoteFindUsageRequestController$Companion$totals$slambda(completion);
    i.lrd_1 = controller;
    i.mrd_1 = _unused_var__etf5q3;
    return i;
  };
  function RemoteFindUsageRequestController$Companion$totals$slambda_0(resultContinuation) {
    var i = new RemoteFindUsageRequestController$Companion$totals$slambda(resultContinuation);
    var l = function (controller, _unused_var__etf5q3, $completion) {
      return i.nrd(controller, _unused_var__etf5q3, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Companion_379() {
    Companion_instance_379 = this;
    InstanceDescriptor.call(this);
    this.prd_1 = Companion_getInstance_377().y9p(Companion_getInstance_375().h67());
    this.qrd_1 = Companion_getInstance_377().y9p(Companion_instance_228.h67());
    var tmp = this;
    var tmp_0 = serializer_16(Unit_instance);
    tmp.rrd_1 = method(this, 'nextDocuments', tmp_0, this.prd_1, RemoteFindUsageRequestController$Companion$nextDocuments$slambda_0(null));
    var tmp_1 = this;
    var tmp_2 = Companion_instance_381.h67();
    tmp_1.srd_1 = method(this, 'nextNodeEntries', tmp_2, this.qrd_1, RemoteFindUsageRequestController$Companion$nextNodeEntries$slambda_0(null));
    var tmp_3 = this;
    var tmp_4 = serializer_16(Unit_instance);
    var tmp_5 = Companion_instance_376.h67();
    tmp_3.trd_1 = method(this, 'totals', tmp_4, tmp_5, RemoteFindUsageRequestController$Companion$totals$slambda_0(null));
  }
  protoOf(Companion_379).urd = function (endpoint) {
    return new RemoteFindUsageRequestController(endpoint);
  };
  protoOf(Companion_379).j9j = function (endpoint) {
    return this.urd(endpoint);
  };
  var Companion_instance_379;
  function Companion_getInstance_379() {
    if (Companion_instance_379 == null)
      new Companion_379();
    return Companion_instance_379;
  }
  function RemoteFindUsageRequestController(endpoint) {
    Companion_getInstance_379();
    this.vrd_1 = endpoint;
  }
  protoOf(RemoteFindUsageRequestController).or7 = function ($completion) {
    return Companion_getInstance_379().trd_1.n9k(this.vrd_1, Unit_instance, $completion);
  };
  protoOf(RemoteFindUsageRequestController).pr7 = function ($completion) {
    return Companion_getInstance_379().rrd_1.n9k(this.vrd_1, Unit_instance, $completion);
  };
  protoOf(RemoteFindUsageRequestController).qr7 = function (accession, $completion) {
    return Companion_getInstance_379().srd_1.n9k(this.vrd_1, new AccessionDto(accession), $completion);
  };
  protoOf(RemoteFindUsageRequestController).vr = function () {
    this.vrd_1.vr();
  };
  function PerformanceMonitoringClient$job$slambda(this$0, resultContinuation) {
    this.ere_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PerformanceMonitoringClient$job$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(PerformanceMonitoringClient$job$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PerformanceMonitoringClient$job$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 9;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 8;
            this.hre_1 = this.ere_1.mre_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            suspendResult = this.hre_1.h19(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (!suspendResult) {
              this.y9_1 = 6;
              continue $sm;
            }

            this.ire_1 = this.hre_1.m();
            this.jre_1 = arrayListOf([this.ire_1]);
            this.y9_1 = 4;
            Companion_getInstance_16();
            suspendResult = delay_0(toDuration(1, DurationUnit_SECONDS_getInstance()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.kre_1 = ChannelResult__getOrNull_impl_f5e07h(this.ere_1.mre_1.e1c());
            while (!(this.kre_1 == null)) {
              var tmp2 = this.jre_1;
              var element = this.kre_1;
              tmp2.e(element);
              this.kre_1 = ChannelResult__getOrNull_impl_f5e07h(this.ere_1.mre_1.e1c());
            }

            this.y9_1 = 5;
            suspendResult = this.ere_1.lre_1(this.jre_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.y9_1 = 2;
            continue $sm;
          case 6:
            this.gre_1 = Unit_instance;
            this.z9_1 = 9;
            this.y9_1 = 7;
            continue $sm;
          case 7:
            this.z9_1 = 9;
            this.ere_1.mre_1.i1c();
            return Unit_instance;
          case 8:
            this.z9_1 = 9;
            var t = this.ba_1;
            this.ere_1.mre_1.i1c();
            throw t;
          case 9:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 9) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(PerformanceMonitoringClient$job$slambda).i1l = function ($this$launch, completion) {
    var i = new PerformanceMonitoringClient$job$slambda(this.ere_1, completion);
    i.fre_1 = $this$launch;
    return i;
  };
  function PerformanceMonitoringClient$job$slambda_0(this$0, resultContinuation) {
    var i = new PerformanceMonitoringClient$job$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function PerformanceMonitoringClient(coroutineScope, metricsConsumer) {
    this.lre_1 = metricsConsumer;
    this.mre_1 = Channel(2147483647);
    var tmp = this;
    tmp.nre_1 = launch(coroutineScope, VOID, VOID, PerformanceMonitoringClient$job$slambda_0(this, null));
  }
  protoOf(PerformanceMonitoringClient).ore = function (metric) {
    // Inline function 'kotlin.check' call
    if (!_ChannelResult___get_isSuccess__impl__odq1z9(this.mre_1.a1c(metric))) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
  };
  var MetricKind_OpenEditor_instance;
  var MetricKind_Resolve_instance;
  var MetricKind_Find_instance;
  var MetricKind_Presentation_instance;
  function values_17() {
    return [MetricKind_OpenEditor_getInstance(), MetricKind_Resolve_getInstance(), MetricKind_Find_getInstance(), MetricKind_Presentation_getInstance()];
  }
  var MetricKind_entriesInitialized;
  function MetricKind_initEntries() {
    if (MetricKind_entriesInitialized)
      return Unit_instance;
    MetricKind_entriesInitialized = true;
    MetricKind_OpenEditor_instance = new MetricKind('OpenEditor', 0);
    MetricKind_Resolve_instance = new MetricKind('Resolve', 1);
    MetricKind_Find_instance = new MetricKind('Find', 2);
    MetricKind_Presentation_instance = new MetricKind('Presentation', 3);
  }
  function MetricKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_380() {
    Companion_instance_380 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.pre_1 = [null, new EnumSerializer('jetbrains.biokb.editor.service.performance.PerformanceMonitoringMetric.MetricKind', values_17())];
  }
  var Companion_instance_380;
  function Companion_getInstance_380() {
    if (Companion_instance_380 == null)
      new Companion_380();
    return Companion_instance_380;
  }
  function $serializer_33() {
    $serializer_instance_30 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.performance.PerformanceMonitoringMetric', this, 2);
    tmp0_serialDesc.t5n('durationInMs', false);
    tmp0_serialDesc.t5n('kind', false);
    this.qre_1 = tmp0_serialDesc;
  }
  protoOf($serializer_33).rre = function (encoder, value) {
    var tmp0_desc = this.qre_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    var tmp2_cached = Companion_getInstance_380().pre_1;
    tmp1_output.t5h(tmp0_desc, 0, value.sre_1);
    tmp1_output.z5h(tmp0_desc, 1, tmp2_cached[1], value.tre_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_33).j5d = function (encoder, value) {
    return this.rre(encoder, value instanceof PerformanceMonitoringMetric ? value : THROW_CCE());
  };
  protoOf($serializer_33).k5d = function (decoder) {
    var tmp0_desc = this.qre_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_input = decoder.j5g(tmp0_desc);
    var tmp7_cached = Companion_getInstance_380().pre_1;
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.p5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.p5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.v5g(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return PerformanceMonitoringMetric_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_33).w5c = function () {
    return this.qre_1;
  };
  protoOf($serializer_33).i5o = function () {
    var tmp0_cached = Companion_getInstance_380().pre_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), tmp0_cached[1]];
  };
  var $serializer_instance_30;
  function $serializer_getInstance_30() {
    if ($serializer_instance_30 == null)
      new $serializer_33();
    return $serializer_instance_30;
  }
  function PerformanceMonitoringMetric_init_$Init$(seen0, durationInMs, kind, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_30().qre_1);
    }
    $this.sre_1 = durationInMs;
    $this.tre_1 = kind;
    return $this;
  }
  function PerformanceMonitoringMetric_init_$Create$(seen0, durationInMs, kind, serializationConstructorMarker) {
    return PerformanceMonitoringMetric_init_$Init$(seen0, durationInMs, kind, serializationConstructorMarker, objectCreate(protoOf(PerformanceMonitoringMetric)));
  }
  function MetricKind_OpenEditor_getInstance() {
    MetricKind_initEntries();
    return MetricKind_OpenEditor_instance;
  }
  function MetricKind_Resolve_getInstance() {
    MetricKind_initEntries();
    return MetricKind_Resolve_instance;
  }
  function MetricKind_Find_getInstance() {
    MetricKind_initEntries();
    return MetricKind_Find_instance;
  }
  function MetricKind_Presentation_getInstance() {
    MetricKind_initEntries();
    return MetricKind_Presentation_instance;
  }
  function PerformanceMonitoringMetric(durationInMs, kind) {
    Companion_getInstance_380();
    this.sre_1 = durationInMs;
    this.tre_1 = kind;
  }
  function Companion_381() {
  }
  protoOf(Companion_381).h67 = function () {
    return $serializer_getInstance_31();
  };
  var Companion_instance_381;
  function Companion_getInstance_381() {
    return Companion_instance_381;
  }
  function $serializer_34() {
    $serializer_instance_31 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.rpc.AccessionDto', this, 1);
    tmp0_serialDesc.t5n('accession', false);
    this.ure_1 = tmp0_serialDesc;
  }
  protoOf($serializer_34).vre = function (encoder, value) {
    var tmp0_desc = this.ure_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.x5h(tmp0_desc, 0, value.crd_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_34).j5d = function (encoder, value) {
    return this.vre(encoder, value instanceof AccessionDto ? value : THROW_CCE());
  };
  protoOf($serializer_34).k5d = function (decoder) {
    var tmp0_desc = this.ure_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.j5g(tmp0_desc);
    if (tmp5_input.y5g()) {
      tmp4_local0 = tmp5_input.t5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.t5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.k5g(tmp0_desc);
    return AccessionDto_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_34).w5c = function () {
    return this.ure_1;
  };
  protoOf($serializer_34).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_31;
  function $serializer_getInstance_31() {
    if ($serializer_instance_31 == null)
      new $serializer_34();
    return $serializer_instance_31;
  }
  function AccessionDto_init_$Init$(seen0, accession, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_31().ure_1);
    }
    $this.crd_1 = accession;
    return $this;
  }
  function AccessionDto_init_$Create$(seen0, accession, serializationConstructorMarker) {
    return AccessionDto_init_$Init$(seen0, accession, serializationConstructorMarker, objectCreate(protoOf(AccessionDto)));
  }
  function AccessionDto(accession) {
    this.crd_1 = accession;
  }
  protoOf(AccessionDto).ug = function () {
    return this.crd_1;
  };
  protoOf(AccessionDto).toString = function () {
    return 'AccessionDto(accession=' + this.crd_1 + ')';
  };
  protoOf(AccessionDto).hashCode = function () {
    return getStringHashCode(this.crd_1);
  };
  protoOf(AccessionDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AccessionDto))
      return false;
    var tmp0_other_with_cast = other instanceof AccessionDto ? other : THROW_CCE();
    if (!(this.crd_1 === tmp0_other_with_cast.crd_1))
      return false;
    return true;
  };
  function Companion_382() {
  }
  protoOf(Companion_382).h67 = function () {
    return $serializer_getInstance_32();
  };
  var Companion_instance_382;
  function Companion_getInstance_382() {
    return Companion_instance_382;
  }
  function $serializer_35() {
    $serializer_instance_32 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('jetbrains.biokb.editor.service.rpc.DraftQueryCoordinates', this, 2);
    tmp0_serialDesc.t5n('accession', false);
    tmp0_serialDesc.t5n('globalVersion', false);
    this.wre_1 = tmp0_serialDesc;
  }
  protoOf($serializer_35).xre = function (encoder, value) {
    var tmp0_desc = this.wre_1;
    var tmp1_output = encoder.j5g(tmp0_desc);
    tmp1_output.x5h(tmp0_desc, 0, value.yre_1);
    tmp1_output.t5h(tmp0_desc, 1, value.zre_1);
    tmp1_output.k5g(tmp0_desc);
  };
  protoOf($serializer_35).j5d = function (encoder, value) {
    return this.xre(encoder, value instanceof DraftQueryCoordinates ? value : THROW_CCE());
  };
  protoOf($serializer_35).k5d = function (decoder) {
    var tmp0_desc = this.wre_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.j5g(tmp0_desc);
    if (tmp6_input.y5g()) {
      tmp4_local0 = tmp6_input.t5g(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.p5g(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.z5g(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.t5g(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.p5g(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.k5g(tmp0_desc);
    return DraftQueryCoordinates_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_35).w5c = function () {
    return this.wre_1;
  };
  protoOf($serializer_35).i5o = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_32;
  function $serializer_getInstance_32() {
    if ($serializer_instance_32 == null)
      new $serializer_35();
    return $serializer_instance_32;
  }
  function DraftQueryCoordinates_init_$Init$(seen0, accession, globalVersion, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_32().wre_1);
    }
    $this.yre_1 = accession;
    $this.zre_1 = globalVersion;
    return $this;
  }
  function DraftQueryCoordinates_init_$Create$(seen0, accession, globalVersion, serializationConstructorMarker) {
    return DraftQueryCoordinates_init_$Init$(seen0, accession, globalVersion, serializationConstructorMarker, objectCreate(protoOf(DraftQueryCoordinates)));
  }
  function DraftQueryCoordinates(accession, globalVersion) {
    this.yre_1 = accession;
    this.zre_1 = globalVersion;
  }
  protoOf(DraftQueryCoordinates).ug = function () {
    return this.yre_1;
  };
  protoOf(DraftQueryCoordinates).vg = function () {
    return this.zre_1;
  };
  protoOf(DraftQueryCoordinates).toString = function () {
    return 'DraftQueryCoordinates(accession=' + this.yre_1 + ', globalVersion=' + this.zre_1.toString() + ')';
  };
  protoOf(DraftQueryCoordinates).hashCode = function () {
    var result = getStringHashCode(this.yre_1);
    result = imul(result, 31) + this.zre_1.hashCode() | 0;
    return result;
  };
  protoOf(DraftQueryCoordinates).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DraftQueryCoordinates))
      return false;
    var tmp0_other_with_cast = other instanceof DraftQueryCoordinates ? other : THROW_CCE();
    if (!(this.yre_1 === tmp0_other_with_cast.yre_1))
      return false;
    if (!this.zre_1.equals(tmp0_other_with_cast.zre_1))
      return false;
    return true;
  };
  function EditorService$Companion$openDocument$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditorService$Companion$openDocument$slambda).lrf = function (instance, _destruct__k2r9zo, $completion) {
    var tmp = this.mrf(instance, _destruct__k2r9zo, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditorService$Companion$openDocument$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, EditorService) : false) ? p1 : THROW_CCE();
    return this.lrf(tmp, p2 instanceof AccessionDto ? p2 : THROW_CCE(), $completion);
  };
  protoOf(EditorService$Companion$openDocument$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.krf_1 = this.jrf_1.ug();
            this.y9_1 = 1;
            suspendResult = this.irf_1.nrf(this.krf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditorService$Companion$openDocument$slambda).mrf = function (instance, _destruct__k2r9zo, completion) {
    var i = new EditorService$Companion$openDocument$slambda(completion);
    i.irf_1 = instance;
    i.jrf_1 = _destruct__k2r9zo;
    return i;
  };
  function EditorService$Companion$openDocument$slambda_0(resultContinuation) {
    var i = new EditorService$Companion$openDocument$slambda(resultContinuation);
    var l = function (instance, _destruct__k2r9zo, $completion) {
      return i.lrf(instance, _destruct__k2r9zo, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function EditorService$Companion$findUsages$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditorService$Companion$findUsages$slambda).yrf = function (instance, request, $completion) {
    var tmp = this.zrf(instance, request, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditorService$Companion$findUsages$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, EditorService) : false) ? p1 : THROW_CCE();
    return this.yrf(tmp, p2 instanceof FindUsageServiceRequest ? p2 : THROW_CCE(), $completion);
  };
  protoOf(EditorService$Companion$findUsages$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.wrf_1.arg(this.xrf_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditorService$Companion$findUsages$slambda).zrf = function (instance, request, completion) {
    var i = new EditorService$Companion$findUsages$slambda(completion);
    i.wrf_1 = instance;
    i.xrf_1 = request;
    return i;
  };
  function EditorService$Companion$findUsages$slambda_0(resultContinuation) {
    var i = new EditorService$Companion$findUsages$slambda(resultContinuation);
    var l = function (instance, request, $completion) {
      return i.yrf(instance, request, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function EditorService$Companion$openDraftQuery$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditorService$Companion$openDraftQuery$slambda).nrg = function (instance, _destruct__k2r9zo, $completion) {
    var tmp = this.org(instance, _destruct__k2r9zo, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditorService$Companion$openDraftQuery$slambda).pa = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, EditorService) : false) ? p1 : THROW_CCE();
    return this.nrg(tmp, p2 instanceof DraftQueryCoordinates ? p2 : THROW_CCE(), $completion);
  };
  protoOf(EditorService$Companion$openDraftQuery$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.lrg_1 = this.krg_1.ug();
            this.mrg_1 = this.krg_1.vg();
            this.y9_1 = 1;
            suspendResult = this.jrg_1.prg(this.lrg_1, this.mrg_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditorService$Companion$openDraftQuery$slambda).org = function (instance, _destruct__k2r9zo, completion) {
    var i = new EditorService$Companion$openDraftQuery$slambda(completion);
    i.jrg_1 = instance;
    i.krg_1 = _destruct__k2r9zo;
    return i;
  };
  function EditorService$Companion$openDraftQuery$slambda_0(resultContinuation) {
    var i = new EditorService$Companion$openDraftQuery$slambda(resultContinuation);
    var l = function (instance, _destruct__k2r9zo, $completion) {
      return i.nrg(instance, _destruct__k2r9zo, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Remote_0(endpoint) {
    this.qrg_1 = CoroutineScope_0(endpoint.l9j().k11());
    this.rrg_1 = endpoint;
  }
  protoOf(Remote_0).nrf = function (accession, $completion) {
    return Companion_getInstance_383().trg_1.n9k(this.rrg_1, new AccessionDto(accession), $completion);
  };
  protoOf(Remote_0).arg = function (request, $completion) {
    return Companion_getInstance_383().urg_1.n9k(this.rrg_1, request, $completion);
  };
  protoOf(Remote_0).prg = function (accession, globalVersion, $completion) {
    return Companion_getInstance_383().vrg_1.n9k(this.rrg_1, new DraftQueryCoordinates(accession, globalVersion), $completion);
  };
  protoOf(Remote_0).et = function () {
    return this.qrg_1.et();
  };
  function Companion_383() {
    Companion_instance_383 = this;
    InstanceDescriptor.call(this);
    var tmp = this;
    var tmp_0 = Companion_instance_381.h67();
    tmp.trg_1 = nodeResolutionMethod(this, 'openDocument', tmp_0, EditorService$Companion$openDocument$slambda_0(null));
    var tmp_1 = this;
    var tmp_2 = Companion_instance_374.h67();
    var tmp_3 = PublishedFindUsageRequestControllerSerializer_getInstance();
    tmp_1.urg_1 = method(this, 'findUsages', tmp_2, tmp_3, EditorService$Companion$findUsages$slambda_0(null));
    var tmp_4 = this;
    var tmp_5 = Companion_instance_382.h67();
    tmp_4.vrg_1 = nodeResolutionMethod(this, 'openDraftQuery', tmp_5, EditorService$Companion$openDraftQuery$slambda_0(null));
    this.wrg_1 = new RpcSchema(this);
  }
  protoOf(Companion_383).xrg = function (endpoint) {
    return new Remote_0(endpoint);
  };
  protoOf(Companion_383).j9j = function (endpoint) {
    return this.xrg(endpoint);
  };
  var Companion_instance_383;
  function Companion_getInstance_383() {
    if (Companion_instance_383 == null)
      new Companion_383();
    return Companion_instance_383;
  }
  function EditorService() {
  }
  function EditorServiceClient$openDocument$o$collect$slambda($$this$unsafeFlow, $accession, resultContinuation) {
    this.grh_1 = $$this$unsafeFlow;
    this.hrh_1 = $accession;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditorServiceClient$openDocument$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditorServiceClient$openDocument$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditorServiceClient$openDocument$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.jrh_1 = this.grh_1;
            var tmp_1 = this;
            tmp_1.krh_1 = this.irh_1;
            this.lrh_1 = this.jrh_1;
            this.mrh_1 = this.krh_1;
            var tmp_2 = this;
            tmp_2.nrh_1 = this.mrh_1;
            this.orh_1 = this.nrh_1;
            this.y9_1 = 1;
            suspendResult = this.orh_1.nrf(this.hrh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.prh_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.lrh_1.d1f(this.prh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditorServiceClient$openDocument$o$collect$slambda).a1u = function (value, completion) {
    var i = new EditorServiceClient$openDocument$o$collect$slambda(this.grh_1, this.hrh_1, completion);
    i.irh_1 = value;
    return i;
  };
  function EditorServiceClient$openDocument$o$collect$slambda_0($$this$unsafeFlow, $accession, resultContinuation) {
    var i = new EditorServiceClient$openDocument$o$collect$slambda($$this$unsafeFlow, $accession, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$4(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yrh_1 = _this__u8e3s4;
    this.zrh_1 = collector;
  }
  protoOf($collectCOROUTINE$4).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.ari_1 = this.zrh_1;
            this.bri_1 = this.ari_1;
            this.y9_1 = 1;
            var tmp_1 = EditorServiceClient$openDocument$o$collect$slambda_0(this.bri_1, this.yrh_1.dri_1, null);
            suspendResult = this.yrh_1.cri_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_17(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function EditorServiceClient$openDraftQuery$o$collect$slambda($$this$unsafeFlow, $accession, $globalVersion, resultContinuation) {
    this.mri_1 = $$this$unsafeFlow;
    this.nri_1 = $accession;
    this.ori_1 = $globalVersion;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditorServiceClient$openDraftQuery$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditorServiceClient$openDraftQuery$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditorServiceClient$openDraftQuery$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.qri_1 = this.mri_1;
            var tmp_1 = this;
            tmp_1.rri_1 = this.pri_1;
            this.sri_1 = this.qri_1;
            this.tri_1 = this.rri_1;
            var tmp_2 = this;
            tmp_2.uri_1 = this.tri_1;
            this.vri_1 = this.uri_1;
            this.y9_1 = 1;
            suspendResult = this.vri_1.prg(this.nri_1, this.ori_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.wri_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.sri_1.d1f(this.wri_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditorServiceClient$openDraftQuery$o$collect$slambda).a1u = function (value, completion) {
    var i = new EditorServiceClient$openDraftQuery$o$collect$slambda(this.mri_1, this.nri_1, this.ori_1, completion);
    i.pri_1 = value;
    return i;
  };
  function EditorServiceClient$openDraftQuery$o$collect$slambda_0($$this$unsafeFlow, $accession, $globalVersion, resultContinuation) {
    var i = new EditorServiceClient$openDraftQuery$o$collect$slambda($$this$unsafeFlow, $accession, $globalVersion, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$5(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.frj_1 = _this__u8e3s4;
    this.grj_1 = collector;
  }
  protoOf($collectCOROUTINE$5).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.hrj_1 = this.grj_1;
            this.irj_1 = this.hrj_1;
            this.y9_1 = 1;
            var tmp_1 = EditorServiceClient$openDraftQuery$o$collect$slambda_0(this.irj_1, this.frj_1.krj_1, this.frj_1.lrj_1, null);
            suspendResult = this.frj_1.jrj_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_18(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_17(function_0) {
    this.mrj_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_17).d1f = function (value, $completion) {
    return this.mrj_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_17).b4 = function () {
    return this.mrj_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_17).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_17).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_18(function_0) {
    this.nrj_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_18).d1f = function (value, $completion) {
    return this.nrj_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_18).b4 = function () {
    return this.nrj_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_18).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_18).hashCode = function () {
    return hashCode(this.b4());
  };
  function EditorServiceClient$openDocument$$inlined$map$1($this, $accession) {
    this.cri_1 = $this;
    this.dri_1 = $accession;
  }
  protoOf(EditorServiceClient$openDocument$$inlined$map$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$4(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditorServiceClient$openDocument$$inlined$map$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function EditorServiceClient$openDraftQuery$$inlined$map$1($this, $accession, $globalVersion) {
    this.jrj_1 = $this;
    this.krj_1 = $accession;
    this.lrj_1 = $globalVersion;
  }
  protoOf(EditorServiceClient$openDraftQuery$$inlined$map$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$5(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditorServiceClient$openDraftQuery$$inlined$map$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function $findUsagesCOROUTINE$3(_this__u8e3s4, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wrj_1 = _this__u8e3s4;
    this.xrj_1 = request;
  }
  protoOf($findUsagesCOROUTINE$3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.wrj_1.yrj_1.y().arg(this.xrj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.b2p();
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function EditorServiceClient(services) {
    this.yrj_1 = services;
  }
  protoOf(EditorServiceClient).zrj = function (accession, $completion) {
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = this.yrj_1;
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    var clientServices = new EditorServiceClient$openDocument$$inlined$map$1(this_0, accession);
    return new RemoteDocumentClient(accession, clientServices);
  };
  protoOf(EditorServiceClient).ark = function (request, $completion) {
    var tmp = new $findUsagesCOROUTINE$3(this, request, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditorServiceClient).brk = function (accession, globalVersion, $completion) {
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = this.yrj_1;
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    var clientServices = new EditorServiceClient$openDraftQuery$$inlined$map$1(this_0, accession, globalVersion);
    return new RemoteDocumentClient(accession, clientServices);
  };
  function editorServiceClient(_this__u8e3s4, session) {
    var sessions = WsSessionProvider(_this__u8e3s4, editorServiceClient$slambda_0(session, null));
    var rpcClient = wsRpcClient(_this__u8e3s4, Companion_getInstance_383().wrg_1, sessions);
    return createEditorServiceClient(_this__u8e3s4, rpcClient);
  }
  function createEditorServiceClient(_this__u8e3s4, rpcClient) {
    return async(_this__u8e3s4, VOID, VOID, createEditorServiceClient$slambda_0(rpcClient, null));
  }
  function editorServiceClient$slambda($session, resultContinuation) {
    this.krk_1 = $session;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(editorServiceClient$slambda).mrk = function ($this$WsSessionProvider, $completion) {
    var tmp = this.nrk($this$WsSessionProvider, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(editorServiceClient$slambda).oa = function (p1, $completion) {
    return this.mrk(p1 instanceof WsSessionScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(editorServiceClient$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.krk_1(this.lrk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(editorServiceClient$slambda).nrk = function ($this$WsSessionProvider, completion) {
    var i = new editorServiceClient$slambda(this.krk_1, completion);
    i.lrk_1 = $this$WsSessionProvider;
    return i;
  };
  function editorServiceClient$slambda_0($session, resultContinuation) {
    var i = new editorServiceClient$slambda($session, resultContinuation);
    var l = function ($this$WsSessionProvider, $completion) {
      return i.mrk($this$WsSessionProvider, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function createEditorServiceClient$slambda($rpcClient, resultContinuation) {
    this.wrk_1 = $rpcClient;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createEditorServiceClient$slambda).yrk = function ($this$async, $completion) {
    var tmp = this.i1l($this$async, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(createEditorServiceClient$slambda).oa = function (p1, $completion) {
    return this.yrk((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(createEditorServiceClient$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = stateIn(this.wrk_1.ya6_1, this.wrk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new EditorServiceClient(ARGUMENT);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(createEditorServiceClient$slambda).i1l = function ($this$async, completion) {
    var i = new createEditorServiceClient$slambda(this.wrk_1, completion);
    i.xrk_1 = $this$async;
    return i;
  };
  function createEditorServiceClient$slambda_0($rpcClient, resultContinuation) {
    var i = new createEditorServiceClient$slambda($rpcClient, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.yrk($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WebsocketEditorServiceProvider$client$slambda$slambda($this_editorServiceClient, resultContinuation) {
    this.hrl_1 = $this_editorServiceClient;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebsocketEditorServiceProvider$client$slambda$slambda).jrl = function ($this$webSocket, $completion) {
    var tmp = this.krl($this$webSocket, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(WebsocketEditorServiceProvider$client$slambda$slambda).oa = function (p1, $completion) {
    return this.jrl(p1 instanceof DefaultClientWebSocketSession ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WebsocketEditorServiceProvider$client$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.hrl_1.gah(this.irl_1.i9a(), this.irl_1.j9a(), this.irl_1.e9a(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(WebsocketEditorServiceProvider$client$slambda$slambda).krl = function ($this$webSocket, completion) {
    var i = new WebsocketEditorServiceProvider$client$slambda$slambda(this.hrl_1, completion);
    i.irl_1 = $this$webSocket;
    return i;
  };
  function WebsocketEditorServiceProvider$client$slambda$slambda_0($this_editorServiceClient, resultContinuation) {
    var i = new WebsocketEditorServiceProvider$client$slambda$slambda($this_editorServiceClient, resultContinuation);
    var l = function ($this$webSocket, $completion) {
      return i.jrl($this$webSocket, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WebsocketEditorServiceProvider$client$slambda(this$0, $url, resultContinuation) {
    this.trl_1 = this$0;
    this.url_1 = $url;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebsocketEditorServiceProvider$client$slambda).mrk = function ($this$editorServiceClient, $completion) {
    var tmp = this.nrk($this$editorServiceClient, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(WebsocketEditorServiceProvider$client$slambda).oa = function (p1, $completion) {
    return this.mrk(p1 instanceof WsSessionScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WebsocketEditorServiceProvider$client$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = webSocket(this.trl_1.wrl_1, this.url_1, VOID, WebsocketEditorServiceProvider$client$slambda$slambda_0(this.vrl_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(WebsocketEditorServiceProvider$client$slambda).nrk = function ($this$editorServiceClient, completion) {
    var i = new WebsocketEditorServiceProvider$client$slambda(this.trl_1, this.url_1, completion);
    i.vrl_1 = $this$editorServiceClient;
    return i;
  };
  function WebsocketEditorServiceProvider$client$slambda_0(this$0, $url, resultContinuation) {
    var i = new WebsocketEditorServiceProvider$client$slambda(this$0, $url, resultContinuation);
    var l = function ($this$editorServiceClient, $completion) {
      return i.mrk($this$editorServiceClient, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function WebsocketEditorServiceProvider(httpClient, url, context) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    this.wrl_1 = httpClient;
    this.xrl_1 = CoroutineScope_0(context);
    var tmp = this;
    tmp.yrl_1 = editorServiceClient(this.xrl_1, WebsocketEditorServiceProvider$client$slambda_0(this, url, null));
  }
  protoOf(WebsocketEditorServiceProvider).zrl = function ($completion) {
    return this.yrl_1.gw($completion);
  };
  protoOf(WebsocketEditorServiceProvider).vr = function () {
    cancel(this.xrl_1);
  };
  function get_serializersStore() {
    _init_properties_DefaultJs_kt__opfp8o();
    return serializersStore;
  }
  var serializersStore;
  var properties_initialized_DefaultJs_kt_mit67a;
  function _init_properties_DefaultJs_kt__opfp8o() {
    if (!properties_initialized_DefaultJs_kt_mit67a) {
      properties_initialized_DefaultJs_kt_mit67a = true;
      // Inline function 'kotlin.collections.mutableListOf' call
      serializersStore = ArrayList_init_$Create$();
    }
  }
  function KotlinxSerializer$Companion$DefaultJson$lambda($this$Json) {
    $this$Json.f66_1 = false;
    $this$Json.e66_1 = false;
    $this$Json.m66_1 = true;
    $this$Json.k66_1 = false;
    return Unit_instance;
  }
  function Companion_384() {
    Companion_instance_384 = this;
    var tmp = this;
    tmp.arm_1 = Json_1(VOID, KotlinxSerializer$Companion$DefaultJson$lambda);
  }
  var Companion_instance_384;
  function Companion_getInstance_384() {
    if (Companion_instance_384 == null)
      new Companion_384();
    return Companion_instance_384;
  }
  function KotlinxSerializer(json) {
    Companion_getInstance_384();
    json = json === VOID ? Companion_getInstance_384().arm_1 : json;
    this.brm_1 = json;
  }
  var initializer;
  function SerializerInitializer() {
    SerializerInitializer_instance = this;
    var tmp0 = get_serializersStore();
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new KotlinxSerializer();
    tmp0.e(element);
  }
  var SerializerInitializer_instance;
  function SerializerInitializer_getInstance() {
    if (SerializerInitializer_instance == null)
      new SerializerInitializer();
    return SerializerInitializer_instance;
  }
  function $runSuspendCOROUTINE$0_3(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.krm_1 = _this__u8e3s4;
    this.lrm_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$0_3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.mrm_1 = this.lrm_1;
            this.nrm_1 = this.mrm_1;
            var tmp_1 = this;
            var tmp0_safe_receiver = this.nrm_1.n51(this.krm_1.qrm_1.lay());
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lay();
            tmp_1.orm_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.p6s();
            if (this.orm_1 == null) {
              this.prm_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.nrm_1.m51(this.orm_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.prm_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            return this.prm_1;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ResolveResult(element, initial) {
    this.rrm_1 = element;
    this.srm_1 = initial;
  }
  protoOf(ResolveResult).toString = function () {
    return 'ResolveResult(element=' + toString_1(this.rrm_1) + ', initial=' + this.srm_1 + ')';
  };
  protoOf(ResolveResult).hashCode = function () {
    var result = hashCode(this.rrm_1);
    result = imul(result, 31) + getBooleanHashCode(this.srm_1) | 0;
    return result;
  };
  protoOf(ResolveResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ResolveResult))
      return false;
    var tmp0_other_with_cast = other instanceof ResolveResult ? other : THROW_CCE();
    if (!equals(this.rrm_1, tmp0_other_with_cast.rrm_1))
      return false;
    if (!(this.srm_1 === tmp0_other_with_cast.srm_1))
      return false;
    return true;
  };
  function _get_categoryInfo__ynw1r(_this__u8e3s4, $this) {
    return new CategoryInfo(_get_accession__uiy019(_this__u8e3s4, $this), get_stringId(_this__u8e3s4), _this__u8e3s4.b3().n4z().m2c());
  }
  function _get_accession__uiy019(_this__u8e3s4, $this) {
    var tmp0_safe_receiver = _this__u8e3s4.u3o();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w6j();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n4z();
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.m2c();
    return tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_7(function_0) {
    this.trm_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_7).vr = function () {
    return this.trm_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_7).b4 = function () {
    return this.trm_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_7).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_7).hashCode = function () {
    return hashCode(this.b4());
  };
  function BTBCategoriesWatcher$watch$1$$inlined$suspendingQuery$1($category) {
    this.qrm_1 = $category;
  }
  protoOf(BTBCategoriesWatcher$watch$1$$inlined$suspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$0_3(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(BTBCategoriesWatcher$watch$1$$inlined$suspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function BTBCategoriesWatcher$watch$lambda$lambda($initialResolve) {
    return function (it) {
      var tmp;
      if (it == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'jetbrains.biokb.editor.BTBCategoriesWatcher.watch.<anonymous>.<anonymous>.<anonymous>' call
        tmp = new ResolveResult(it, $initialResolve);
      }
      return tmp;
    };
  }
  function BTBCategoriesWatcher$watch$lambda($initialCategories, $watcherScope) {
    return function (category) {
      var initialResolve = $initialCategories.k2(category);
      // Inline function 'jetbrains.ocelot.langDef.query.suspendingQuery' call
      var query = new BTBCategoriesWatcher$watch$1$$inlined$suspendingQuery$1(category);
      var tmp = asNullableProperty(new LoopingQuery($watcherScope.et(), query));
      return map_0(tmp, BTBCategoriesWatcher$watch$lambda$lambda(initialResolve));
    };
  }
  function BTBCategoriesWatcher$watch$lambda_0($resolveProperty) {
    return function (category) {
      return $resolveProperty(category);
    };
  }
  function BTBCategoriesWatcher$watch$lambda_1(this$0) {
    return function (event) {
      var tmp;
      if (!event.h27_1.equals(EventType_REMOVE_getInstance())) {
        var resolveResult = event.k27();
        var tmp_0;
        if (!resolveResult.srm_1) {
          this$0.vrm_1.zrm(_get_categoryInfo__ynw1r(resolveResult.rrm_1, this$0));
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      var tmp_1;
      if (!event.h27_1.equals(EventType_ADD_getInstance())) {
        this$0.vrm_1.arn(_get_categoryInfo__ynw1r(event.i27().rrm_1, this$0));
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BTBCategoriesWatcher$watch$lambda_2($watcherScope) {
    return function () {
      cancel($watcherScope);
      return Unit_instance;
    };
  }
  function BTBCategoriesWatcher(document, notifier, coroutineContext) {
    this.urm_1 = document;
    this.vrm_1 = notifier;
    this.wrm_1 = coroutineContext;
  }
  protoOf(BTBCategoriesWatcher).brn = function () {
    var watcherScope = CoroutineScope_0(this.wrm_1.ej(Job_0(this.wrm_1.la(Key_instance_3))));
    var initialCategories = toMutableSet(this.urm_1.rau().n4z());
    var resolveProperty = BTBCategoriesWatcher$watch$lambda(initialCategories, watcherScope);
    var tmp = Transformers_instance;
    var resolveProperties = tmp.c2l(BTBCategoriesWatcher$watch$lambda_0(resolveProperty)).l2i(this.urm_1.rau().n4z());
    var resolvedCategories = Transformers_instance.d2l(Transformers_instance.f2l()).l2i(resolveProperties.i2j());
    var tmp_0 = resolvedCategories.i2j();
    var listListener = tmp_0.p27(BTBCategoriesWatcher$watch$lambda_1(this));
    var tmp_1 = resolveProperties.sr(resolvedCategories).sr(listListener);
    var tmp_2 = BTBCategoriesWatcher$watch$lambda_2(watcherScope);
    return tmp_1.sr(new sam$jetbrains_ocelot_base_disposable_Disposable$0_7(tmp_2));
  };
  function CachingNodeEditor() {
  }
  function CachingNodeEditorImpl$EditorCache$clear$lambda(it) {
    return true;
  }
  function EditorCache(maxSize) {
    this.hrn_1 = maxSize;
    // Inline function 'kotlin.require' call
    if (!(this.hrn_1 > 1)) {
      // Inline function 'jetbrains.biokb.editor.EditorCache.<anonymous>' call
      var message = 'Editor cache size must be greater than one';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
    this.irn_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(EditorCache).jrn = function (descriptor, component) {
    // Inline function 'kotlin.check' call
    if (!!this.irn_1.w2(descriptor)) {
      // Inline function 'jetbrains.biokb.editor.EditorCache.set.<anonymous>' call
      var message = 'Editor cache already has an entry at key ' + descriptor.toString();
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    if (this.irn_1.n() === this.hrn_1) {
      var oldestDescriptor = first_0(this.irn_1.u2());
      var removedComponent = ensureNotNull(this.irn_1.s2(oldestDescriptor));
      removedComponent.vr();
    }
    // Inline function 'kotlin.collections.set' call
    this.irn_1.r2(descriptor, component);
  };
  protoOf(EditorCache).qrn = function (key) {
    // Inline function 'kotlin.collections.get' call
    var this_0 = this.irn_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).y2(key);
  };
  protoOf(EditorCache).m2 = function () {
    this.rrn(CachingNodeEditorImpl$EditorCache$clear$lambda);
  };
  protoOf(EditorCache).rrn = function (descriptorFilter) {
    // Inline function 'kotlin.collections.iterator' call
    var iterator = this.irn_1.w().k();
    while (iterator.l()) {
      var _destruct__k2r9zo = iterator.m();
      // Inline function 'kotlin.collections.component1' call
      var documentSourceDescriptor = _destruct__k2r9zo.x();
      // Inline function 'kotlin.collections.component2' call
      var editorComponent = _destruct__k2r9zo.y();
      if (descriptorFilter(documentSourceDescriptor)) {
        editorComponent.vr();
        iterator.b5();
      }
    }
  };
  function CachingNodeEditorImpl$open$slambda($source, this$0, resultContinuation) {
    this.aro_1 = $source;
    this.bro_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CachingNodeEditorImpl$open$slambda).h1l = function ($this$singleOpenTask, $completion) {
    var tmp = this.i1l($this$singleOpenTask, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CachingNodeEditorImpl$open$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CachingNodeEditorImpl$open$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.aro_1.gro(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.dro_1 = suspendResult;
            this.ero_1 = this.bro_1.rro_1;
            this.fro_1 = this.aro_1.descriptor;
            this.y9_1 = 2;
            suspendResult = this.bro_1.crp(this.dro_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.ero_1.jrn(this.fro_1, ARGUMENT);
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(CachingNodeEditorImpl$open$slambda).i1l = function ($this$singleOpenTask, completion) {
    var i = new CachingNodeEditorImpl$open$slambda(this.aro_1, this.bro_1, completion);
    i.cro_1 = $this$singleOpenTask;
    return i;
  };
  function CachingNodeEditorImpl$open$slambda_0($source, this$0, resultContinuation) {
    var i = new CachingNodeEditorImpl$open$slambda($source, this$0, resultContinuation);
    var l = function ($this$singleOpenTask, $completion) {
      return i.h1l($this$singleOpenTask, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $openCOROUTINE$1(_this__u8e3s4, source, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lrp_1 = _this__u8e3s4;
    this.mrp_1 = source;
  }
  protoOf($openCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.nrp_1 = this.lrp_1.rro_1.qrn(this.mrp_1.descriptor);
            if (!(this.nrp_1 == null)) {
              this.lrp_1.prp(this.nrp_1);
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = this.lrp_1.orp(CachingNodeEditorImpl$open$slambda_0(this.mrp_1, this.lrp_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.y9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function CachingNodeEditorImpl(cacheSize, coroutineContext, view, editorOpeningMonitoring) {
    NodeEditorBase.call(this, coroutineContext, view, editorOpeningMonitoring);
    this.rro_1 = new EditorCache(cacheSize);
  }
  protoOf(CachingNodeEditorImpl).qrp = function (source, $completion) {
    var tmp = new $openCOROUTINE$1(this, source, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(CachingNodeEditorImpl).vr = function () {
    protoOf(NodeEditorBase).vr.call(this);
    this.rrp();
  };
  protoOf(CachingNodeEditorImpl).rrp = function () {
    return this.rro_1.m2();
  };
  protoOf(CachingNodeEditorImpl).crn = function (descriptorFilter) {
    return this.rro_1.rrn(descriptorFilter);
  };
  function serializeProjectionalContentKind(_this__u8e3s4, serializationConfig) {
    _this__u8e3s4.yl6(new serializeProjectionalContentKind$1(serializationConfig));
  }
  function serializeProjectionalContentKind$1($serializationConfig) {
    this.vrp_1 = $serializationConfig;
    ProjectionalClipboardContentSerializationAsHtml.call(this);
  }
  protoOf(serializeProjectionalContentKind$1).vni = function (concept) {
    return this.vrp_1.w6z(concept);
  };
  function select_1($this, node, selection) {
    var mappers = $this.orn_1.mlb().qld(node);
    var _iterator__ex2g4s = mappers.k();
    while (_iterator__ex2g4s.l()) {
      var mapper = _iterator__ex2g4s.m();
      var target = mapper.ql9_1;
      if (!(target == null) ? isInterface(target, Cell) : false) {
        selection.yrp(target);
        return Unit_instance;
      }
    }
    throw IllegalArgumentException_init_$Create$_0('could not find mapper for node ' + toString_1(node));
  }
  function navigateTo($this, node) {
    var tmp0_elvis_lhs = get_pointer(node);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      Companion_getInstance_385().zrp_1.go('could not get enclosing document for node: ' + toString_1(node));
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var _destruct__k2r9zo = tmp;
    var accession = _destruct__k2r9zo.ug();
    var nodeId = _destruct__k2r9zo.vg();
    var tmp_0;
    if (isInterface(node, DocumentNode_0)) {
      tmp_0 = null;
    } else {
      tmp_0 = nodeId.i2s_1;
    }
    var nodeIdIfNotRoot = tmp_0;
    $this.prn_1.arq(accession, nodeIdIfNotRoot);
  }
  function Companion_385() {
    Companion_instance_385 = this;
    this.zrp_1 = getLogger(getKClass(EditorComponent));
  }
  var Companion_instance_385;
  function Companion_getInstance_385() {
    if (Companion_instance_385 == null)
      new Companion_385();
    return Companion_instance_385;
  }
  function EditorComponent$findUsagesOfCurrentNode$lambda(it) {
    return !(it == null) ? isInterface(it, BTBNode) : false;
  }
  function $findUsagesOfCurrentNodeCOROUTINE$2(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jrq_1 = _this__u8e3s4;
  }
  protoOf($findUsagesOfCurrentNodeCOROUTINE$2).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.jrq_1.nrn_1.rlp().m2c();
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.krq_1 = tmp_1;
            this.lrq_1 = this.krq_1.ulp(get_GET_TARGET());
            if (!(this.lrq_1 == null)) {
              this.y9_1 = 1;
              suspendResult = this.lrq_1(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_2 = this;
              var tmp_3 = getCellProviderFromMapper(this.jrq_1.orn_1);
              var tmp_4 = tmp_3.zn4(this.krq_1, EditorComponent$findUsagesOfCurrentNode$lambda);
              var tmp2_elvis_lhs = (!(tmp_4 == null) ? isInterface(tmp_4, BTBNode) : false) ? tmp_4 : null;
              var tmp_5;
              if (tmp2_elvis_lhs == null) {
                throw IllegalStateException_init_$Create$_0('could not find node whose cell is ' + toString_1(this.krq_1));
              } else {
                tmp_5 = tmp2_elvis_lhs;
              }
              tmp_2.mrq_1 = tmp_5;
              this.y9_1 = 2;
              continue $sm;
            }

          case 1:
            var tmp_6 = this;
            tmp_6.nrq_1 = (!(suspendResult == null) ? isInterface(suspendResult, BTBNode) : false) ? suspendResult : null;
            var tmp_7 = this;
            var tmp_8;
            if (this.nrq_1 == null) {
              return Unit_instance;
            } else {
              tmp_8 = this.nrq_1;
            }

            tmp_7.mrq_1 = tmp_8;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.orq_1 = this.mrq_1;
            this.prq_1 = get_pointer(this.orq_1);
            if (this.prq_1 == null) {
              Companion_getInstance_385().zrp_1.go('could not get enclosing document for node: ' + toString_1(this.orq_1));
              return Unit_instance;
            }

            var tmp_9 = this.orq_1;
            if (isInterface(tmp_9, Named)) {
              this.y9_1 = 3;
              suspendResult = execute_1(this.orq_1.b3(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.qrq_1 = '';
              this.y9_1 = 4;
              continue $sm;
            }

          case 3:
            this.qrq_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            var name = this.qrq_1;
            var type = get_searchableNodeType(this.orq_1);
            this.jrq_1.prn_1.rrq(this.prq_1.documentId, this.prq_1.nodeId.i2s_1, name, type);
            return Unit_instance;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $navigateCOROUTINE$3(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.arr_1 = _this__u8e3s4;
  }
  protoOf($navigateCOROUTINE$3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.arr_1.nrn_1.rlp().m2c();
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.brr_1 = tmp_1;
            var tmp_2 = this;
            var tmp1_elvis_lhs = this.brr_1.ulp(get_GET_TARGET());
            var tmp_3;
            if (tmp1_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_3 = tmp1_elvis_lhs;
            }

            tmp_2.crr_1 = tmp_3;
            this.y9_1 = 1;
            suspendResult = this.crr_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var target = suspendResult;
            if (!(target == null)) {
              navigateTo(this.arr_1, (!(target == null) ? isInterface(target, BTBNode) : false) ? target : THROW_CCE());
            }

            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function EditorComponent(wrapperContext, model, cellContainer, mapper, notifier, disposable) {
    Companion_getInstance_385();
    this.krn_1 = disposable;
    this.lrn_1 = wrapperContext;
    this.mrn_1 = model;
    this.nrn_1 = cellContainer;
    this.orn_1 = mapper;
    this.prn_1 = notifier;
  }
  protoOf(EditorComponent).drr = function (nodeId, selection) {
    var tmp0 = this.mrn_1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        // Inline function 'jetbrains.biokb.editor.EditorComponent.select.<anonymous>' call
        var message = 'Select operation cannot be performed if model is null';
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    var tmp0_elvis_lhs = this.mrn_1.c3a(new NodeId(nodeId));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$_0('could not find node with id ' + nodeId);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var targetNode = tmp;
    var tmp_0 = toDomainNode(targetNode, this.lrn_1);
    var targetBtbNode = isInterface(tmp_0, BTBNode) ? tmp_0 : THROW_CCE();
    select_1(this, targetBtbNode, selection);
  };
  protoOf(EditorComponent).err = function ($completion) {
    var tmp = new $findUsagesOfCurrentNodeCOROUTINE$2(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditorComponent).frr = function ($completion) {
    var tmp = new $navigateCOROUTINE$3(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditorComponent).vr = function () {
    this.krn_1.vr();
  };
  protoOf(EditorComponent).sr = function (disposable) {
    return this.krn_1.sr(disposable);
  };
  function sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0(function_0) {
    this.grr_1 = function_0;
  }
  protoOf(sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0).hrr = function (duration) {
    return this.grr_1(new Duration(duration));
  };
  protoOf(sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0).b4 = function () {
    return this.grr_1;
  };
  protoOf(sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EditorOpeningMonitoring) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0).hashCode = function () {
    return hashCode(this.b4());
  };
  function EditorOpeningMonitoring$Companion$NoOp$lambda(it) {
    return Unit_instance;
  }
  function Companion_386() {
    Companion_instance_386 = this;
    var tmp = this;
    var tmp_0 = EditorOpeningMonitoring$Companion$NoOp$lambda;
    tmp.irr_1 = new sam$jetbrains_biokb_editor_EditorOpeningMonitoring$0(tmp_0);
  }
  var Companion_instance_386;
  function Companion_getInstance_386() {
    if (Companion_instance_386 == null)
      new Companion_386();
    return Companion_instance_386;
  }
  function ByEditorService(client) {
    this.jrr_1 = client;
  }
  protoOf(ByEditorService).hrr = function (duration) {
    var metric = new PerformanceMonitoringMetric(_Duration___get_inWholeMilliseconds__impl__msfiry(duration), MetricKind_OpenEditor_getInstance());
    this.jrr_1.ore(metric);
  };
  function EditorOpeningMonitoring() {
  }
  function NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda(this$0, resultContinuation) {
    this.srr_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda).h1l = function ($this$run, $completion) {
    var tmp = this.i1l($this$run, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = _get_component__t10gzw(this.srr_1).err(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda).i1l = function ($this$run, completion) {
    var i = new NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda(this.srr_1, completion);
    i.trr_1 = $this$run;
    return i;
  };
  function NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda_0(this$0, resultContinuation) {
    var i = new NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda(this$0, resultContinuation);
    var l = function ($this$run, $completion) {
      return i.h1l($this$run, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorBase$navigate$slambda$slambda(this$0, resultContinuation) {
    this.crs_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$navigate$slambda$slambda).h1l = function ($this$run, $completion) {
    var tmp = this.i1l($this$run, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(NodeEditorBase$navigate$slambda$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$navigate$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = _get_component__t10gzw(this.crs_1).frr(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorBase$navigate$slambda$slambda).i1l = function ($this$run, completion) {
    var i = new NodeEditorBase$navigate$slambda$slambda(this.crs_1, completion);
    i.drs_1 = $this$run;
    return i;
  };
  function NodeEditorBase$navigate$slambda$slambda_0(this$0, resultContinuation) {
    var i = new NodeEditorBase$navigate$slambda$slambda(this$0, resultContinuation);
    var l = function ($this$run, $completion) {
      return i.h1l($this$run, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorBase$singleOpenTask$slambda$slambda($block, resultContinuation) {
    this.mrs_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$singleOpenTask$slambda$slambda).h1l = function ($this$run, $completion) {
    var tmp = this.i1l($this$run, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(NodeEditorBase$singleOpenTask$slambda$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$singleOpenTask$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.mrs_1(this.nrs_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorBase$singleOpenTask$slambda$slambda).i1l = function ($this$run, completion) {
    var i = new NodeEditorBase$singleOpenTask$slambda$slambda(this.mrs_1, completion);
    i.nrs_1 = $this$run;
    return i;
  };
  function NodeEditorBase$singleOpenTask$slambda$slambda_0($block, resultContinuation) {
    var i = new NodeEditorBase$singleOpenTask$slambda$slambda($block, resultContinuation);
    var l = function ($this$run, $completion) {
      return i.h1l($this$run, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function _get_component__t10gzw($this) {
    var tmp = $this.arp_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('component');
    }
  }
  function attachEditor($this, cellContainer, objectToShow, editorConfig) {
    var mapper = getEditorMapperFactory(editorConfig)(objectToShow);
    installRootFromMapper(mapper, cellContainer);
    ErrorHighlightingController_instance.yn5(cellContainer);
    return mapper;
  }
  function registerActions($this, cellContainer) {
    var tmp = cellContainer.u3o();
    tmp.olp(new NodeEditorBase$registerActions$1($this));
  }
  function setScrollParameters($this, cellContainer) {
    cellContainer.u3o().ylp(CellScrolling_getInstance().jms_1, Companion_getInstance_387().trs_1);
  }
  function attachOtSupport($this, cellContainer, mapper, node) {
    var tmp = (new OtSupportBuilder()).nox(cellContainer).oox(node.crt_1);
    var tmp_0;
    var tmp_1 = mapper.pl9_1;
    if (tmp_1 instanceof NodeWrapper) {
      tmp_0 = getNodeWrapperCellProviderFromMapper(mapper instanceof Mapper ? mapper : THROW_CCE(), get_wrapperContext(node.hrt_1));
    } else {
      tmp_0 = getNodeCellProviderFromMapper(mapper);
    }
    return tmp.pox(tmp_0).qox(node.drt_1).k2p();
  }
  function watchCategories($this, document) {
    return (new BTBCategoriesWatcher(document, $this.vro_1, $this.sro_1)).brn();
  }
  function guarded(_this__u8e3s4, $this) {
    var tmp = NodeEditorBase$guarded$lambda(_this__u8e3s4);
    return new sam$jetbrains_ocelot_base_disposable_Disposable$0_8(tmp);
  }
  function Companion_387() {
    Companion_instance_387 = this;
    this.ors_1 = getLogger(getKClass(NodeEditorBase));
    this.prs_1 = KeyStroke_init_$Create$(Key_U_getInstance(), [ModifierKey_CONTROL_getInstance()]);
    this.qrs_1 = KeyStroke_init_$Create$(Key_B_getInstance(), [ModifierKey_CONTROL_getInstance()]);
    this.rrs_1 = CellTraitPropertySpec_init_$Create$('editorDocumentsApi', null);
    this.srs_1 = CellTraitPropertySpec_init_$Create$('eventNotifier', null);
    this.trs_1 = Companion_instance_310.f5j().dn2(18).en2(1).fn2(3).gn2(18).k2p();
  }
  var Companion_instance_387;
  function Companion_getInstance_387() {
    if (Companion_instance_387 == null)
      new Companion_387();
    return Companion_instance_387;
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_8(function_0) {
    this.lrt_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_8).vr = function () {
    return this.lrt_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_8).b4 = function () {
    return this.lrt_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_8).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_8).hashCode = function () {
    return hashCode(this.b4());
  };
  function NodeEditorBase$findUsagesOfCurrentNode$slambda(this$0, resultContinuation) {
    this.urt_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.urt_1.xro_1.xrt(NodeEditorBase$findUsagesOfCurrentNode$slambda$slambda_0(this.urt_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorBase$findUsagesOfCurrentNode$slambda).i1l = function ($this$launch, completion) {
    var i = new NodeEditorBase$findUsagesOfCurrentNode$slambda(this.urt_1, completion);
    i.vrt_1 = $this$launch;
    return i;
  };
  function NodeEditorBase$findUsagesOfCurrentNode$slambda_0(this$0, resultContinuation) {
    var i = new NodeEditorBase$findUsagesOfCurrentNode$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorBase$navigate$slambda(this$0, resultContinuation) {
    this.gru_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$navigate$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(NodeEditorBase$navigate$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$navigate$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.gru_1.xro_1.xrt(NodeEditorBase$navigate$slambda$slambda_0(this.gru_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorBase$navigate$slambda).i1l = function ($this$launch, completion) {
    var i = new NodeEditorBase$navigate$slambda(this.gru_1, completion);
    i.hru_1 = $this$launch;
    return i;
  };
  function NodeEditorBase$navigate$slambda_0(this$0, resultContinuation) {
    var i = new NodeEditorBase$navigate$slambda(this$0, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorBase$registerActions$1(this$0) {
    this.iru_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(NodeEditorBase$registerActions$1).llm = function (cell, event) {
    if (event.rl1([Companion_getInstance_387().prs_1])) {
      event.ol0();
      this.iru_1.srp();
    } else if (event.rl1([Companion_getInstance_387().qrs_1])) {
      event.ol0();
      this.iru_1.trp();
    } else {
      protoOf(CellTrait).llm.call(this, cell, event);
    }
  };
  function NodeEditorBase$singleOpenTask$slambda(this$0, $block, resultContinuation) {
    this.rru_1 = this$0;
    this.sru_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$singleOpenTask$slambda).h1l = function ($this$withContext, $completion) {
    var tmp = this.i1l($this$withContext, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(NodeEditorBase$singleOpenTask$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$singleOpenTask$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.rru_1.wro_1.xrt(NodeEditorBase$singleOpenTask$slambda$slambda_0(this.sru_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorBase$singleOpenTask$slambda).i1l = function ($this$withContext, completion) {
    var i = new NodeEditorBase$singleOpenTask$slambda(this.rru_1, this.sru_1, completion);
    i.tru_1 = $this$withContext;
    return i;
  };
  function NodeEditorBase$singleOpenTask$slambda_0(this$0, $block, resultContinuation) {
    var i = new NodeEditorBase$singleOpenTask$slambda(this$0, $block, resultContinuation);
    var l = function ($this$withContext, $completion) {
      return i.h1l($this$withContext, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorBase$doOpen$lambda($serializationConfig) {
    return function ($this$build) {
      serializeProjectionalContentKind($this$build, $serializationConfig);
      $this$build.yl6(TextClipboardSerialization_instance);
      $this$build.zl6();
      return Unit_instance;
    };
  }
  function NodeEditorBase$doOpen$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorBase$doOpen$slambda).drv = function (it, $completion) {
    var tmp = this.erv(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(NodeEditorBase$doOpen$slambda).oa = function (p1, $completion) {
    return this.drv(p1 instanceof State_0 ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorBase$doOpen$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return this.crv_1.equals(State_ACTIVE_getInstance());
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(NodeEditorBase$doOpen$slambda).erv = function (it, completion) {
    var i = new NodeEditorBase$doOpen$slambda(completion);
    i.crv_1 = it;
    return i;
  };
  function NodeEditorBase$doOpen$slambda_0(resultContinuation) {
    var i = new NodeEditorBase$doOpen$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.drv(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorBase$guarded$lambda($this_guarded) {
    return function () {
      var tmp;
      try {
        $this_guarded.vr();
        tmp = Unit_instance;
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Error) {
          var e = $p;
          Companion_getInstance_387().ors_1.co('error during dispose:', e);
          tmp_0 = Unit_instance;
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      return Unit_instance;
    };
  }
  function $doOpenCOROUTINE$4(_this__u8e3s4, nodeInfo, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nrv_1 = _this__u8e3s4;
    this.orv_1 = nodeInfo;
  }
  protoOf($doOpenCOROUTINE$4).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            var tmp_0 = this;
            tmp_0.prv_1 = Monotonic_instance;
            this.qrv_1 = this.prv_1;
            this.rrv_1 = this.qrv_1.ye();
            this.srv_1 = CellContainer();
            resetEdt(this.srv_1, this.orv_1.krt_1);
            this.srv_1.u3o().ylp(Companion_getInstance_387().srs_1, this.nrv_1.vro_1);
            this.trv_1 = this.orv_1.hrt_1;
            this.urv_1 = ensureNotNull(this.trv_1.m72_1.h2o(Companion_instance_111));
            var tmp_1 = this;
            var tmp_2 = Companion_instance_259;
            tmp_1.vrv_1 = tmp_2.sl6(NodeEditorBase$doOpen$lambda(this.urv_1));
            this.srv_1.umi(this.vrv_1);
            this.wrv_1 = createBTBEditorConfiguration(this.trv_1, this.orv_1.jpo(), this.orv_1.irt_1, this.orv_1.jrt_1);
            this.xrv_1 = new CompositeDisposable([]);
            this.xrv_1.tr(guarded(this.orv_1, this.nrv_1));
            this.yrv_1 = attachEditor(this.nrv_1, this.srv_1, this.orv_1.grt_1, this.wrv_1);
            this.nrv_1.brp_1 = this.yrv_1;
            registerActions(this.nrv_1, this.srv_1);
            setScrollParameters(this.nrv_1, this.srv_1);
            var tmp_3 = this.orv_1.frt_1;
            if (tmp_3 instanceof EditedWorkingCopySource) {
              this.srv_1.u3o().ylp(Companion_getInstance_387().rrs_1, this.orv_1.frt_1.erw_1);
            }

            var tmp_4 = this.orv_1;
            if (tmp_4 instanceof EditableNodeInfo) {
              this.xrv_1.tr(attachOtSupport(this.nrv_1, this.srv_1, this.yrv_1, this.orv_1));
            }

            var tmp_5 = this.orv_1.grt_1;
            if (isInterface(tmp_5, BTBDocument_1)) {
              this.xrv_1.tr(watchCategories(this.nrv_1, this.orv_1.grt_1));
            }

            var tmp_6 = this;
            var tmp_7 = get_wrapperContext(this.trv_1);
            var tmp_8 = this.orv_1.grt_1;
            var tmp0_safe_receiver = isInterface(tmp_8, TypedOtNode) ? tmp_8 : null;
            tmp_6.zrv_1 = new EditorComponent(tmp_7, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i3f(), this.srv_1, this.yrv_1, this.nrv_1.vro_1, this.xrv_1);
            this.nrv_1.prp(this.zrv_1);
            var tmp_9 = this;
            var tmp1_safe_receiver = this.trv_1.m72_1.h2o(Companion_instance_183);
            tmp_9.arw_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.nan_1;
            if (this.arw_1 == null) {
              this.brw_1 = null;
              this.y9_1 = 2;
              continue $sm;
            } else {
              this.y9_1 = 1;
              suspendResult = first_3(this.arw_1, NodeEditorBase$doOpen$slambda_0(null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.brw_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.y9_1 = 3;
            suspendResult = waitForAsyncWork(this.srv_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var result = this.zrv_1;
            var _destruct__k2r9zo = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(this.rrv_1));
            var component = _destruct__k2r9zo.ug();
            var duration = _destruct__k2r9zo.ql();
            this.nrv_1.uro_1.hrr(duration);
            return component;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function NodeEditorBase(coroutineContext, view, editorOpeningMonitoring) {
    Companion_getInstance_387();
    this.sro_1 = coroutineContext;
    this.tro_1 = view;
    this.uro_1 = editorOpeningMonitoring;
    this.vro_1 = new Notifier();
    this.wro_1 = new OneJobRunner();
    this.xro_1 = new OneJobRunner();
    this.yro_1 = Companion_getInstance_25().wr_1;
    this.zro_1 = false;
    this.brp_1 = null;
  }
  protoOf(NodeEditorBase).prp = function (newComponent) {
    this.arp_1 = newComponent;
    this.yro_1.vr();
    this.yro_1 = this.tro_1.krw(newComponent.nrn_1);
  };
  protoOf(NodeEditorBase).vr = function () {
    // Inline function 'kotlin.check' call
    if (!!this.zro_1) {
      throw IllegalStateException_init_$Create$_0('Check failed.');
    }
    this.yro_1.vr();
    this.zro_1 = true;
  };
  protoOf(NodeEditorBase).drn = function (nodeId) {
    _get_component__t10gzw(this).drr(nodeId, NodeSelection_CARET_getInstance());
  };
  protoOf(NodeEditorBase).lrw = function (nodeId) {
    _get_component__t10gzw(this).drr(nodeId, NodeSelection_BACKGROUND_getInstance());
  };
  protoOf(NodeEditorBase).ern = function () {
    Companion_instance_390.mrw(ensureNotNull(_get_component__t10gzw(this).nrn_1.u3o().q2r()));
  };
  protoOf(NodeEditorBase).srp = function () {
    var tmp = CoroutineScope_0(this.sro_1);
    launch(tmp, VOID, VOID, NodeEditorBase$findUsagesOfCurrentNode$slambda_0(this, null));
  };
  protoOf(NodeEditorBase).trp = function () {
    var tmp = CoroutineScope_0(this.sro_1);
    launch(tmp, VOID, VOID, NodeEditorBase$navigate$slambda_0(this, null));
  };
  protoOf(NodeEditorBase).frn = function (type, listener) {
    return this.vro_1.frn(type, listener);
  };
  protoOf(NodeEditorBase).grn = function (type, listener) {
    this.vro_1.grn(type, listener);
  };
  protoOf(NodeEditorBase).orp = function (block, $completion) {
    return withContext(this.sro_1, NodeEditorBase$singleOpenTask$slambda_0(this, block, null), $completion);
  };
  protoOf(NodeEditorBase).crp = function (nodeInfo, $completion) {
    var tmp = new $doOpenCOROUTINE$4(this, nodeInfo, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_23(function_0) {
    this.nrw_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_23).wy = function () {
    return this.nrw_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_23).b4 = function () {
    return this.nrw_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_23).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_23).hashCode = function () {
    return hashCode(this.b4());
  };
  function NodeSelection$CARET$invoke$lambda($cell) {
    return function () {
      CellScrolling_getInstance().kms($cell);
      toFirstFocusable($cell)();
      return Unit_instance;
    };
  }
  function NodeSelection$CARET() {
    NodeSelection.call(this, 'CARET', 0);
    NodeSelection_CARET_instance = this;
  }
  protoOf(NodeSelection$CARET).yrp = function (cell) {
    var tmp0_safe_receiver = cell.llk();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.elq();
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp = NodeSelection$CARET$invoke$lambda(cell);
      tmp1_safe_receiver.u2m(new sam$jetbrains_ocelot_base_edt_EdtTask$0_23(tmp));
    }
  };
  var NodeSelection_CARET_instance;
  function NodeSelection$BACKGROUND() {
    NodeSelection.call(this, 'BACKGROUND', 1);
    NodeSelection_BACKGROUND_instance = this;
  }
  protoOf(NodeSelection$BACKGROUND).yrp = function (cell) {
    get_background(cell).v2c(Companion_getInstance_325().olt_1);
  };
  var NodeSelection_BACKGROUND_instance;
  var NodeSelection_entriesInitialized;
  function NodeSelection_initEntries() {
    if (NodeSelection_entriesInitialized)
      return Unit_instance;
    NodeSelection_entriesInitialized = true;
    NodeSelection_CARET_instance = new NodeSelection$CARET();
    NodeSelection_BACKGROUND_instance = new NodeSelection$BACKGROUND();
  }
  function NodeSelection(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function NodeSelection_CARET_getInstance() {
    NodeSelection_initEntries();
    return NodeSelection_CARET_instance;
  }
  function NodeSelection_BACKGROUND_getInstance() {
    NodeSelection_initEntries();
    return NodeSelection_BACKGROUND_instance;
  }
  function NonCachingNodeEditor$open$slambda(this$0, $source, resultContinuation) {
    this.arx_1 = this$0;
    this.brx_1 = $source;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NonCachingNodeEditor$open$slambda).h1l = function ($this$singleOpenTask, $completion) {
    var tmp = this.i1l($this$singleOpenTask, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(NonCachingNodeEditor$open$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NonCachingNodeEditor$open$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.brx_1.gro(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.drx_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.arx_1.crp(this.drx_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(NonCachingNodeEditor$open$slambda).i1l = function ($this$singleOpenTask, completion) {
    var i = new NonCachingNodeEditor$open$slambda(this.arx_1, this.brx_1, completion);
    i.crx_1 = $this$singleOpenTask;
    return i;
  };
  function NonCachingNodeEditor$open$slambda_0(this$0, $source, resultContinuation) {
    var i = new NonCachingNodeEditor$open$slambda(this$0, $source, resultContinuation);
    var l = function ($this$singleOpenTask, $completion) {
      return i.h1l($this$singleOpenTask, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $doOpenCOROUTINE$5(_this__u8e3s4, nodeInfo, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xrx_1 = _this__u8e3s4;
    this.yrx_1 = nodeInfo;
  }
  protoOf($doOpenCOROUTINE$5).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = protoOf(NodeEditorBase).crp.call(this.xrx_1, this.yrx_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var newComponent = suspendResult;
            this.xrx_1.orx_1.vr();
            this.xrx_1.orx_1 = newComponent;
            return newComponent;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function NonCachingNodeEditor(coroutineContext, view, editorOpeningMonitoring) {
    editorOpeningMonitoring = editorOpeningMonitoring === VOID ? Companion_getInstance_386().irr_1 : editorOpeningMonitoring;
    NodeEditorBase.call(this, coroutineContext, view, editorOpeningMonitoring);
    this.orx_1 = Companion_getInstance_25().wr_1;
  }
  protoOf(NonCachingNodeEditor).qrp = function (source, $completion) {
    return this.orp(NonCachingNodeEditor$open$slambda_0(this, source, null), $completion);
  };
  protoOf(NonCachingNodeEditor).crp = function (nodeInfo, $completion) {
    var tmp = new $doOpenCOROUTINE$5(this, nodeInfo, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(NonCachingNodeEditor).vr = function () {
    protoOf(NodeEditorBase).vr.call(this);
    this.orx_1.vr();
  };
  function OneJobRunner$run$slambda$slambda($block, resultContinuation) {
    this.hry_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OneJobRunner$run$slambda$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OneJobRunner$run$slambda$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OneJobRunner$run$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.hry_1(this.iry_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(OneJobRunner$run$slambda$slambda).i1l = function ($this$launch, completion) {
    var i = new OneJobRunner$run$slambda$slambda(this.hry_1, completion);
    i.iry_1 = $this$launch;
    return i;
  };
  function OneJobRunner$run$slambda$slambda_0($block, resultContinuation) {
    var i = new OneJobRunner$run$slambda$slambda($block, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function OneJobRunner$run$slambda(this$0, $block, resultContinuation) {
    this.rry_1 = this$0;
    this.sry_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OneJobRunner$run$slambda).h1l = function ($this$coroutineScope, $completion) {
    var tmp = this.i1l($this$coroutineScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(OneJobRunner$run$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OneJobRunner$run$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          var tmp0_safe_receiver = this.rry_1.wrt_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.pu();
          }
          var tmp_0 = this.rry_1;
          tmp_0.wrt_1 = launch(this.try_1, VOID, VOID, OneJobRunner$run$slambda$slambda_0(this.sry_1, null));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(OneJobRunner$run$slambda).i1l = function ($this$coroutineScope, completion) {
    var i = new OneJobRunner$run$slambda(this.rry_1, this.sry_1, completion);
    i.try_1 = $this$coroutineScope;
    return i;
  };
  function OneJobRunner$run$slambda_0(this$0, $block, resultContinuation) {
    var i = new OneJobRunner$run$slambda(this$0, $block, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.h1l($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function OneJobRunner() {
    this.wrt_1 = null;
  }
  protoOf(OneJobRunner).xrt = function (block, $completion) {
    return coroutineScope(OneJobRunner$run$slambda_0(this, block, null), $completion);
  };
  function implyHttpProtocol(_this__u8e3s4, $this) {
    return _get_protocol__elfktv(_this__u8e3s4, $this) == null ? 'http://' + _this__u8e3s4 : _this__u8e3s4;
  }
  function _get_protocol__elfktv(_this__u8e3s4, $this) {
    var tmp0_safe_receiver = $this.vry_1.wd(_this__u8e3s4);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y();
  }
  function URLHandler() {
    URLHandler_instance = this;
    URLCellTrait.call(this, [Companion_getInstance_387().qrs_1]);
    var tmp = this;
    // Inline function 'kotlin.text.toRegex' call
    var this_0 = '^([a-z][a-z0-9+\\-.]*)://';
    tmp.vry_1 = Regex_init_$Create$(this_0);
  }
  protoOf(URLHandler).jn3 = function (url) {
    navigateToUrl(implyHttpProtocol(url, this));
  };
  var URLHandler_instance;
  function URLHandler_getInstance() {
    if (URLHandler_instance == null)
      new URLHandler();
    return URLHandler_instance;
  }
  function $getDocumentContentCOROUTINE$6(_this__u8e3s4, accession, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.erz_1 = _this__u8e3s4;
    this.frz_1 = accession;
  }
  protoOf($getDocumentContentCOROUTINE$6).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.grz_1 = this.erz_1.wrz_1;
            var tmp_1 = this;
            tmp_1.hrz_1 = this.erz_1.xrz_1 + '/documents/' + this.frz_1 + '/content';
            this.irz_1 = this.grz_1;
            this.jrz_1 = this.hrz_1;
            var tmp_2 = this;
            tmp_2.krz_1 = this.irz_1;
            this.lrz_1 = this.krz_1;
            var tmp_3 = this;
            tmp_3.mrz_1 = this.lrz_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.jrz_1);
            tmp_4.nrz_1 = this_0;
            this.orz_1 = this.mrz_1;
            this.prz_1 = this.nrz_1;
            this.prz_1.pq7_1 = Companion_getInstance_143().h94_1;
            var tmp_5 = this;
            tmp_5.qrz_1 = this.orz_1;
            var tmp_6 = this;
            tmp_6.rrz_1 = this.prz_1;
            this.srz_1 = this.qrz_1;
            this.trz_1 = this.rrz_1;
            this.y9_1 = 1;
            suspendResult = (new HttpStatement(this.trz_1, this.srz_1)).ir1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.urz_1 = suspendResult;
            this.vrz_1 = this.urz_1;
            this.y9_1 = 2;
            var tmp_7 = this.vrz_1.uqa();
            var tmp_8 = JsType_instance;
            var tmp_9 = PrimitiveClasses_getInstance().nc();
            var tmp_10;
            try {
              tmp_10 = createKType(PrimitiveClasses_getInstance().nc(), arrayOf([]), false);
            } catch ($p) {
              var tmp_11;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_11 = null;
              } else {
                throw $p;
              }
              tmp_10 = tmp_11;
            }

            suspendResult = tmp_7.yq9(typeInfoImpl(tmp_8, tmp_9, tmp_10), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return (!(suspendResult == null) ? typeof suspendResult === 'string' : false) ? suspendResult : THROW_CCE();
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $getReferenceToPaperCOROUTINE$7(_this__u8e3s4, pubMedId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gs0_1 = _this__u8e3s4;
    this.hs0_1 = pubMedId;
  }
  protoOf($getReferenceToPaperCOROUTINE$7).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.is0_1 = this.gs0_1.wrz_1;
            var tmp_1 = this;
            tmp_1.js0_1 = this.gs0_1.xrz_1 + '/documents/paper-reference/' + this.hs0_1;
            this.ks0_1 = this.is0_1;
            this.ls0_1 = this.js0_1;
            var tmp_2 = this;
            tmp_2.ms0_1 = this.ks0_1;
            this.ns0_1 = this.ms0_1;
            var tmp_3 = this;
            tmp_3.os0_1 = this.ns0_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.ls0_1);
            tmp_4.ps0_1 = this_0;
            this.qs0_1 = this.os0_1;
            this.rs0_1 = this.ps0_1;
            this.rs0_1.pq7_1 = Companion_getInstance_143().h94_1;
            var tmp_5 = this;
            tmp_5.ss0_1 = this.qs0_1;
            var tmp_6 = this;
            tmp_6.ts0_1 = this.rs0_1;
            this.us0_1 = this.ss0_1;
            this.vs0_1 = this.ts0_1;
            this.y9_1 = 1;
            suspendResult = (new HttpStatement(this.vs0_1, this.us0_1)).ir1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ws0_1 = suspendResult;
            this.xs0_1 = this.ws0_1;
            this.y9_1 = 2;
            var tmp_7 = this.xs0_1.uqa();
            var tmp_8 = JsType_instance;
            var tmp_9 = getKClass(PubMedPaperLoadResultDto);
            var tmp_10;
            try {
              tmp_10 = createKType(getKClass(PubMedPaperLoadResultDto), arrayOf([]), false);
            } catch ($p) {
              var tmp_11;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_11 = null;
              } else {
                throw $p;
              }
              tmp_10 = tmp_11;
            }

            suspendResult = tmp_7.yq9(typeInfoImpl(tmp_8, tmp_9, tmp_10), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult instanceof PubMedPaperLoadResultDto ? suspendResult : THROW_CCE();
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function EditorDocumentsApi(client, editorServiceRestRoute) {
    this.wrz_1 = client;
    this.xrz_1 = editorServiceRestRoute;
  }
  protoOf(EditorDocumentsApi).ys0 = function (accession, $completion) {
    var tmp = new $getDocumentContentCOROUTINE$6(this, accession, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditorDocumentsApi).zs0 = function (pubMedId, $completion) {
    var tmp = new $getReferenceToPaperCOROUTINE$7(this, pubMedId, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function $calculateResolversCOROUTINE$8(_this__u8e3s4, accession, nodeId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.is1_1 = _this__u8e3s4;
    this.js1_1 = accession;
    this.ks1_1 = nodeId;
  }
  protoOf($calculateResolversCOROUTINE$8).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.ls1_1 = this.is1_1.bs2_1;
            var tmp_1 = this;
            tmp_1.ms1_1 = this.is1_1.cs2_1 + '/resolver/' + this.js1_1;
            this.ns1_1 = this.ls1_1;
            this.os1_1 = this.ms1_1;
            var tmp_2 = this;
            tmp_2.ps1_1 = this.ns1_1;
            this.qs1_1 = this.ps1_1;
            var tmp_3 = this;
            tmp_3.rs1_1 = this.qs1_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.os1_1);
            parameter(this_0, 'nodeId', this.ks1_1);
            tmp_4.ss1_1 = this_0;
            this.ts1_1 = this.rs1_1;
            this.us1_1 = this.ss1_1;
            this.us1_1.pq7_1 = Companion_getInstance_143().h94_1;
            var tmp_5 = this;
            tmp_5.vs1_1 = this.ts1_1;
            var tmp_6 = this;
            tmp_6.ws1_1 = this.us1_1;
            this.xs1_1 = this.vs1_1;
            this.ys1_1 = this.ws1_1;
            this.y9_1 = 1;
            suspendResult = (new HttpStatement(this.ys1_1, this.xs1_1)).ir1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.zs1_1 = suspendResult;
            this.as2_1 = this.zs1_1;
            this.y9_1 = 2;
            var tmp_7 = this.as2_1.uqa();
            var tmp_8 = JsType_instance;
            var tmp_9 = getKClass(NodeResolveInfo);
            var tmp_10;
            try {
              tmp_10 = createKType(getKClass(NodeResolveInfo), arrayOf([]), false);
            } catch ($p) {
              var tmp_11;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_11 = null;
              } else {
                throw $p;
              }
              tmp_10 = tmp_11;
            }

            suspendResult = tmp_7.yq9(typeInfoImpl(tmp_8, tmp_9, tmp_10), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult instanceof NodeResolveInfo ? suspendResult : THROW_CCE();
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $measureMetricsCOROUTINE$9(_this__u8e3s4, metrics, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ls2_1 = _this__u8e3s4;
    this.ms2_1 = metrics;
  }
  protoOf($measureMetricsCOROUTINE$9).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.ns2_1 = this.ls2_1.bs2_1;
            var tmp_1 = this;
            tmp_1.os2_1 = this.ls2_1.cs2_1 + '/perf';
            this.ps2_1 = this.ns2_1;
            this.qs2_1 = this.os2_1;
            var tmp_2 = this;
            tmp_2.rs2_1 = this.ps2_1;
            this.ss2_1 = this.rs2_1;
            var tmp_3 = this;
            tmp_3.ts2_1 = this.ss2_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.qs2_1);
            contentType_1(this_0, Application_getInstance().r8y_1);
            var body = this.ms2_1;
            if (body == null) {
              this_0.rq7_1 = NullBody_instance;
              var tmp_5 = JsType_instance;
              var tmp_6 = getKClass(KtList);
              var tmp_7;
              try {
                tmp_7 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(PerformanceMonitoringMetric), arrayOf([]), false))]), false);
              } catch ($p) {
                var tmp_8;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_8 = null;
                } else {
                  throw $p;
                }
                tmp_7 = tmp_8;
              }
              this_0.kqd(typeInfoImpl(tmp_5, tmp_6, tmp_7));
            } else {
              if (body instanceof OutgoingContent) {
                this_0.rq7_1 = body;
                this_0.kqd(null);
              } else {
                this_0.rq7_1 = body;
                var tmp_9 = JsType_instance;
                var tmp_10 = getKClass(KtList);
                var tmp_11;
                try {
                  tmp_11 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(PerformanceMonitoringMetric), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_12;
                  if ($p instanceof Error) {
                    var cause_0 = $p;
                    tmp_12 = null;
                  } else {
                    throw $p;
                  }
                  tmp_11 = tmp_12;
                }
                this_0.kqd(typeInfoImpl(tmp_9, tmp_10, tmp_11));
              }
            }

            tmp_4.us2_1 = this_0;
            this.vs2_1 = this.ts2_1;
            this.ws2_1 = this.us2_1;
            this.ws2_1.pq7_1 = Companion_getInstance_143().i94_1;
            var tmp_13 = this;
            tmp_13.xs2_1 = this.vs2_1;
            var tmp_14 = this;
            tmp_14.ys2_1 = this.ws2_1;
            this.zs2_1 = this.xs2_1;
            this.as3_1 = this.ys2_1;
            this.y9_1 = 1;
            suspendResult = (new HttpStatement(this.as3_1, this.zs2_1)).ir1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function EditorsApi(client, editorServiceRestRoute) {
    this.bs2_1 = client;
    this.cs2_1 = editorServiceRestRoute;
  }
  protoOf(EditorsApi).bs3 = function (accession, nodeId, $completion) {
    var tmp = new $calculateResolversCOROUTINE$8(this, accession, nodeId, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditorsApi).cs3 = function (metrics, $completion) {
    var tmp = new $measureMetricsCOROUTINE$9(this, metrics, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function $getDocumentResolvedCOROUTINE$10(_this__u8e3s4, accession, globalVersionId, nodeId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ls3_1 = _this__u8e3s4;
    this.ms3_1 = accession;
    this.ns3_1 = globalVersionId;
    this.os3_1 = nodeId;
  }
  protoOf($getDocumentResolvedCOROUTINE$10).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.ps3_1 = this.ls3_1.bs4_1;
            var tmp_1 = this;
            tmp_1.qs3_1 = this.ls3_1.cs4_1 + '/viewer/documents/' + this.ms3_1 + '/resolved';
            this.rs3_1 = this.ps3_1;
            this.ss3_1 = this.qs3_1;
            var tmp_2 = this;
            tmp_2.ts3_1 = this.rs3_1;
            this.us3_1 = this.ts3_1;
            var tmp_3 = this;
            tmp_3.vs3_1 = this.us3_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.ss3_1);
            parameter(this_0, 'global-version', this.ns3_1);
            if (!(this.os3_1 == null)) {
              parameter(this_0, 'node-id', this.os3_1);
            }

            tmp_4.ws3_1 = this_0;
            this.xs3_1 = this.vs3_1;
            this.ys3_1 = this.ws3_1;
            this.y9_1 = 1;
            suspendResult = (new HttpStatement(this.ys3_1, this.xs3_1)).ir1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.zs3_1 = suspendResult;
            this.as4_1 = this.zs3_1;
            this.y9_1 = 2;
            var tmp_5 = this.as4_1.uqa();
            var tmp_6 = JsType_instance;
            var tmp_7 = getKClass(SerializedResolvedNode);
            var tmp_8;
            try {
              tmp_8 = createKType(getKClass(SerializedResolvedNode), arrayOf([]), false);
            } catch ($p) {
              var tmp_9;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_9 = null;
              } else {
                throw $p;
              }
              tmp_8 = tmp_9;
            }

            suspendResult = tmp_5.yq9(typeInfoImpl(tmp_6, tmp_7, tmp_8), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult instanceof SerializedResolvedNode ? suspendResult : THROW_CCE();
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $getDocumentResolvedCOROUTINE$11(_this__u8e3s4, accession, revision, nodeId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ls4_1 = _this__u8e3s4;
    this.ms4_1 = accession;
    this.ns4_1 = revision;
    this.os4_1 = nodeId;
  }
  protoOf($getDocumentResolvedCOROUTINE$11).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.ps4_1 = this.ls4_1.bs4_1;
            var tmp_1 = this;
            tmp_1.qs4_1 = this.ls4_1.cs4_1 + '/viewer/documents/' + this.ms4_1 + '/resolved';
            this.rs4_1 = this.ps4_1;
            this.ss4_1 = this.qs4_1;
            var tmp_2 = this;
            tmp_2.ts4_1 = this.rs4_1;
            this.us4_1 = this.ts4_1;
            var tmp_3 = this;
            tmp_3.vs4_1 = this.us4_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.ss4_1);
            parameter(this_0, 'revision', this.ns4_1);
            if (!(this.os4_1 == null)) {
              parameter(this_0, 'node-id', this.os4_1);
            }

            tmp_4.ws4_1 = this_0;
            this.xs4_1 = this.vs4_1;
            this.ys4_1 = this.ws4_1;
            this.y9_1 = 1;
            suspendResult = (new HttpStatement(this.ys4_1, this.xs4_1)).ir1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.zs4_1 = suspendResult;
            this.as5_1 = this.zs4_1;
            this.y9_1 = 2;
            var tmp_5 = this.as5_1.uqa();
            var tmp_6 = JsType_instance;
            var tmp_7 = getKClass(SerializedResolvedNode);
            var tmp_8;
            try {
              tmp_8 = createKType(getKClass(SerializedResolvedNode), arrayOf([]), false);
            } catch ($p) {
              var tmp_9;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_9 = null;
              } else {
                throw $p;
              }
              tmp_8 = tmp_9;
            }

            suspendResult = tmp_5.yq9(typeInfoImpl(tmp_6, tmp_7, tmp_8), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult instanceof SerializedResolvedNode ? suspendResult : THROW_CCE();
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ExplorerApi(client, documentServiceRestRoute) {
    this.bs4_1 = client;
    this.cs4_1 = documentServiceRestRoute;
  }
  protoOf(ExplorerApi).bs5 = function (accession, globalVersionId, nodeId, $completion) {
    var tmp = new $getDocumentResolvedCOROUTINE$10(this, accession, globalVersionId, nodeId, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ExplorerApi).cs5 = function (accession, globalVersionId, nodeId, $completion, $super) {
    nodeId = nodeId === VOID ? null : nodeId;
    return $super === VOID ? this.bs5(accession, globalVersionId, nodeId, $completion) : $super.bs5.call(this, accession, globalVersionId, nodeId, $completion);
  };
  protoOf(ExplorerApi).ds5 = function (accession, revision, nodeId, $completion) {
    var tmp = new $getDocumentResolvedCOROUTINE$11(this, accession, revision, nodeId, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ExplorerApi).es5 = function (accession, revision, nodeId, $completion, $super) {
    nodeId = nodeId === VOID ? null : nodeId;
    return $super === VOID ? this.ds5(accession, revision, nodeId, $completion) : $super.ds5.call(this, accession, revision, nodeId, $completion);
  };
  function $getQueryResolvedCOROUTINE$12(_this__u8e3s4, id, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ns5_1 = _this__u8e3s4;
    this.os5_1 = id;
  }
  protoOf($getQueryResolvedCOROUTINE$12).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.ps5_1 = this.ns5_1.bs6_1;
            var tmp_1 = this;
            tmp_1.qs5_1 = this.ns5_1.cs6_1 + '/queries/' + this.os5_1.toString() + '/resolved';
            this.rs5_1 = this.ps5_1;
            this.ss5_1 = this.qs5_1;
            var tmp_2 = this;
            tmp_2.ts5_1 = this.rs5_1;
            this.us5_1 = this.ts5_1;
            var tmp_3 = this;
            tmp_3.vs5_1 = this.us5_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.ss5_1);
            tmp_4.ws5_1 = this_0;
            this.xs5_1 = this.vs5_1;
            this.ys5_1 = this.ws5_1;
            this.y9_1 = 1;
            suspendResult = (new HttpStatement(this.ys5_1, this.xs5_1)).ir1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.zs5_1 = suspendResult;
            this.as6_1 = this.zs5_1;
            this.y9_1 = 2;
            var tmp_5 = this.as6_1.uqa();
            var tmp_6 = JsType_instance;
            var tmp_7 = getKClass(SerializedResolvedNode);
            var tmp_8;
            try {
              tmp_8 = createKType(getKClass(SerializedResolvedNode), arrayOf([]), false);
            } catch ($p) {
              var tmp_9;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_9 = null;
              } else {
                throw $p;
              }
              tmp_8 = tmp_9;
            }

            suspendResult = tmp_5.yq9(typeInfoImpl(tmp_6, tmp_7, tmp_8), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult instanceof SerializedResolvedNode ? suspendResult : THROW_CCE();
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function QueriesApi(client, documentServiceRestRoute) {
    this.bs6_1 = client;
    this.cs6_1 = documentServiceRestRoute;
  }
  protoOf(QueriesApi).ds6 = function (id, $completion) {
    var tmp = new $getQueryResolvedCOROUTINE$12(this, id, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function get_NAVIGATE() {
    _init_properties_Events_kt__8ewmpl();
    return NAVIGATE;
  }
  var NAVIGATE;
  function get_FIND_USAGES() {
    _init_properties_Events_kt__8ewmpl();
    return FIND_USAGES;
  }
  var FIND_USAGES;
  function get_BTB_CATEGORY_EVENT() {
    _init_properties_Events_kt__8ewmpl();
    return BTB_CATEGORY_EVENT;
  }
  var BTB_CATEGORY_EVENT;
  function get_FACT_SELECTION_EVENT() {
    _init_properties_Events_kt__8ewmpl();
    return FACT_SELECTION_EVENT;
  }
  var FACT_SELECTION_EVENT;
  function get_ERROR_EVENT() {
    _init_properties_Events_kt__8ewmpl();
    return ERROR_EVENT;
  }
  var ERROR_EVENT;
  function EventType_0() {
  }
  function Event_1() {
  }
  function NodePointerEvent(accession, nodeId) {
    Event_1.call(this);
    this.accession = accession;
    this.nodeId = nodeId;
  }
  protoOf(NodePointerEvent).zr6 = function () {
    return this.accession;
  };
  protoOf(NodePointerEvent).x3i = function () {
    return this.nodeId;
  };
  function FindUsagesEvent(accession, nodeId, name, type) {
    NodePointerEvent.call(this, accession, nodeId);
    this.name = name;
    this.type = type;
  }
  protoOf(FindUsagesEvent).b3 = function () {
    return this.name;
  };
  protoOf(FindUsagesEvent).zb3 = function () {
    return this.type;
  };
  function CategoryInfo(accession, nodeId, name) {
    this.accession = accession;
    this.nodeId = nodeId;
    this.name = name;
  }
  protoOf(CategoryInfo).zr6 = function () {
    return this.accession;
  };
  protoOf(CategoryInfo).x3i = function () {
    return this.nodeId;
  };
  protoOf(CategoryInfo).b3 = function () {
    return this.name;
  };
  protoOf(CategoryInfo).ug = function () {
    return this.accession;
  };
  protoOf(CategoryInfo).vg = function () {
    return this.nodeId;
  };
  protoOf(CategoryInfo).hm = function () {
    return this.name;
  };
  protoOf(CategoryInfo).es6 = function (accession, nodeId, name) {
    return new CategoryInfo(accession, nodeId, name);
  };
  protoOf(CategoryInfo).copy = function (accession, nodeId, name, $super) {
    accession = accession === VOID ? this.accession : accession;
    nodeId = nodeId === VOID ? this.nodeId : nodeId;
    name = name === VOID ? this.name : name;
    return this.es6(accession, nodeId, name);
  };
  protoOf(CategoryInfo).toString = function () {
    return 'CategoryInfo(accession=' + this.accession + ', nodeId=' + this.nodeId + ', name=' + this.name + ')';
  };
  protoOf(CategoryInfo).hashCode = function () {
    var result = getStringHashCode(this.accession);
    result = imul(result, 31) + getStringHashCode(this.nodeId) | 0;
    result = imul(result, 31) + getStringHashCode(this.name) | 0;
    return result;
  };
  protoOf(CategoryInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CategoryInfo))
      return false;
    var tmp0_other_with_cast = other instanceof CategoryInfo ? other : THROW_CCE();
    if (!(this.accession === tmp0_other_with_cast.accession))
      return false;
    if (!(this.nodeId === tmp0_other_with_cast.nodeId))
      return false;
    if (!(this.name === tmp0_other_with_cast.name))
      return false;
    return true;
  };
  function BTBCategoryEvent(categoryInfo, kind) {
    Event_1.call(this);
    this.categoryInfo = categoryInfo;
    this.kind = kind;
  }
  protoOf(BTBCategoryEvent).fs6 = function () {
    return this.categoryInfo;
  };
  protoOf(BTBCategoryEvent).r5e = function () {
    return this.kind;
  };
  function FactSelectionEvent(factIds) {
    Event_1.call(this);
    this.factIds = factIds;
  }
  protoOf(FactSelectionEvent).gs6 = function () {
    return this.factIds;
  };
  function ErrorEvent(area, message, description) {
    Event_1.call(this);
    this.area = area;
    this.message = message;
    this.description = description;
  }
  protoOf(ErrorEvent).hs6 = function () {
    return this.area;
  };
  protoOf(ErrorEvent).t1 = function () {
    return this.message;
  };
  protoOf(ErrorEvent).qgw = function () {
    return this.description;
  };
  var BTBCategoryEventKind_ADD_instance;
  var BTBCategoryEventKind_REMOVE_instance;
  function values_18() {
    return [BTBCategoryEventKind_ADD_getInstance(), BTBCategoryEventKind_REMOVE_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'ADD':
        return BTBCategoryEventKind_ADD_getInstance();
      case 'REMOVE':
        return BTBCategoryEventKind_REMOVE_getInstance();
      default:
        BTBCategoryEventKind_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var BTBCategoryEventKind_entriesInitialized;
  function BTBCategoryEventKind_initEntries() {
    if (BTBCategoryEventKind_entriesInitialized)
      return Unit_instance;
    BTBCategoryEventKind_entriesInitialized = true;
    BTBCategoryEventKind_ADD_instance = new BTBCategoryEventKind('ADD', 0);
    BTBCategoryEventKind_REMOVE_instance = new BTBCategoryEventKind('REMOVE', 1);
  }
  function BTBCategoryEventKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function NAVIGATE$1() {
    EventType_0.call(this);
  }
  function FIND_USAGES$1() {
    EventType_0.call(this);
  }
  function BTB_CATEGORY_EVENT$1() {
    EventType_0.call(this);
  }
  function FACT_SELECTION_EVENT$1() {
    EventType_0.call(this);
  }
  function ERROR_EVENT$1() {
    EventType_0.call(this);
  }
  function BTBCategoryEventKind_ADD_getInstance() {
    BTBCategoryEventKind_initEntries();
    return BTBCategoryEventKind_ADD_instance;
  }
  function BTBCategoryEventKind_REMOVE_getInstance() {
    BTBCategoryEventKind_initEntries();
    return BTBCategoryEventKind_REMOVE_instance;
  }
  var properties_initialized_Events_kt_yci8fv;
  function _init_properties_Events_kt__8ewmpl() {
    if (!properties_initialized_Events_kt_yci8fv) {
      properties_initialized_Events_kt_yci8fv = true;
      NAVIGATE = new NAVIGATE$1();
      FIND_USAGES = new FIND_USAGES$1();
      BTB_CATEGORY_EVENT = new BTB_CATEGORY_EVENT$1();
      FACT_SELECTION_EVENT = new FACT_SELECTION_EVENT$1();
      ERROR_EVENT = new ERROR_EVENT$1();
    }
  }
  function fire_4($this, type, event) {
    var tmp0_safe_receiver = $this.xrm_1.y2(type);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a28(Notifier$fire$lambda(event));
    }
  }
  function Notifier$fire$lambda($event) {
    return function (it) {
      it($event);
      return Unit_instance;
    };
  }
  function Notifier() {
    this.xrm_1 = HashMap_init_$Create$();
    this.yrm_1 = HashMap_init_$Create$();
  }
  protoOf(Notifier).frn = function (type, listener) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.xrm_1;
    var value = this_0.y2(type);
    var tmp;
    if (value == null) {
      // Inline function 'jetbrains.biokb.editor.event.Notifier.subscribe.<anonymous>' call
      var answer = new Listeners();
      this_0.r2(type, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var reg = tmp.z27(listener);
    var tmp2 = this.yrm_1;
    // Inline function 'kotlin.collections.set' call
    var key = new Pair(type, listener);
    tmp2.r2(key, reg);
  };
  protoOf(Notifier).grn = function (type, listener) {
    var tmp0_safe_receiver = this.yrm_1.s2(new Pair(type, listener));
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.vr();
    }
  };
  protoOf(Notifier).arq = function (accession, nodeId) {
    fire_4(this, get_NAVIGATE(), new NodePointerEvent(accession, nodeId));
  };
  protoOf(Notifier).rrq = function (accession, nodeId, name, type) {
    fire_4(this, get_FIND_USAGES(), new FindUsagesEvent(accession, nodeId, name, type));
  };
  protoOf(Notifier).zrm = function (info) {
    fire_4(this, get_BTB_CATEGORY_EVENT(), new BTBCategoryEvent(info, BTBCategoryEventKind_ADD_getInstance()));
  };
  protoOf(Notifier).arn = function (info) {
    fire_4(this, get_BTB_CATEGORY_EVENT(), new BTBCategoryEvent(info, BTBCategoryEventKind_REMOVE_getInstance()));
  };
  protoOf(Notifier).ks6 = function (factIds) {
    var tmp = get_FACT_SELECTION_EVENT();
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(factIds);
    fire_4(this, tmp, new FactSelectionEvent(tmp$ret$0));
  };
  protoOf(Notifier).ls6 = function (area, message, description) {
    fire_4(this, get_ERROR_EVENT(), new ErrorEvent(area, message, description));
  };
  function EditableNodeInfo(documentSource, node, model, highlighting, readOnly, commandProcessor, operationProvider, edt, environmentDisposal) {
    ExplorableNodeInfo.call(this, documentSource, node, model, highlighting, false, edt, environmentDisposal);
    this.brt_1 = readOnly;
    this.crt_1 = commandProcessor;
    this.drt_1 = operationProvider;
  }
  protoOf(EditableNodeInfo).jpo = function () {
    return this.brt_1;
  };
  function ExplorableNodeInfo(source, explorable, model, highlighting, factSelection, edt, environmentDisposal) {
    this.ert_1 = environmentDisposal;
    this.frt_1 = source;
    this.grt_1 = explorable;
    this.hrt_1 = model;
    this.irt_1 = highlighting;
    this.jrt_1 = factSelection;
    this.krt_1 = edt;
  }
  protoOf(ExplorableNodeInfo).jpo = function () {
    return true;
  };
  protoOf(ExplorableNodeInfo).vr = function () {
    this.ert_1.vr();
  };
  protoOf(ExplorableNodeInfo).sr = function (disposable) {
    return this.ert_1.sr(disposable);
  };
  function initializeLocalDocument(entity, otNode, accession, name, model) {
    get_btbEntityNodeLayout().s71(otNode, entity);
    var tmp = toDomainNode(otNode, get_wrapperContext(model));
    var node = isInterface(tmp, DocumentNode_0) ? tmp : THROW_CCE();
    node.b3().t2c(name);
    node.w6j().t2c(accession);
    return node;
  }
  function OtDocumentInfo(node, commandProcessor, operationProvider, connection) {
    this.ms6_1 = node;
    this.ns6_1 = commandProcessor;
    this.os6_1 = operationProvider;
    this.ps6_1 = connection;
  }
  protoOf(OtDocumentInfo).ug = function () {
    return this.ms6_1;
  };
  protoOf(OtDocumentInfo).vg = function () {
    return this.ns6_1;
  };
  protoOf(OtDocumentInfo).hm = function () {
    return this.os6_1;
  };
  protoOf(OtDocumentInfo).g59 = function () {
    return this.ps6_1;
  };
  protoOf(OtDocumentInfo).toString = function () {
    return 'OtDocumentInfo(node=' + toString_1(this.ms6_1) + ', commandProcessor=' + toString_1(this.ns6_1) + ', operationProvider=' + toString_1(this.os6_1) + ', connection=' + toString_1(this.ps6_1) + ')';
  };
  protoOf(OtDocumentInfo).hashCode = function () {
    var result = hashCode(this.ms6_1);
    result = imul(result, 31) + hashCode(this.ns6_1) | 0;
    result = imul(result, 31) + hashCode(this.os6_1) | 0;
    result = imul(result, 31) + hashCode(this.ps6_1) | 0;
    return result;
  };
  protoOf(OtDocumentInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OtDocumentInfo))
      return false;
    var tmp0_other_with_cast = other instanceof OtDocumentInfo ? other : THROW_CCE();
    if (!equals(this.ms6_1, tmp0_other_with_cast.ms6_1))
      return false;
    if (!equals(this.ns6_1, tmp0_other_with_cast.ns6_1))
      return false;
    if (!equals(this.os6_1, tmp0_other_with_cast.os6_1))
      return false;
    if (!equals(this.ps6_1, tmp0_other_with_cast.ps6_1))
      return false;
    return true;
  };
  function initializeRemoteDocument(otEnvironment, entity, accession, name, model) {
    var processor = otEnvironment.vs6(get_wrapperContext(model));
    var node = getNode_0(entity, get_wrapperContext(model));
    node.b3().t2c(name);
    node.w6j().t2c(accession);
    var tmp = getOperationProvider(entity);
    var tmp_0 = initializeRemoteDocument$lambda(otEnvironment, entity);
    return new OtDocumentInfo(node, processor, tmp, new sam$jetbrains_ocelot_base_disposable_Disposable$0_9(tmp_0));
  }
  function getNode_0(entity, wrapperContext) {
    var tmp0_safe_receiver = entity.e30(get_btbEntityNodeLayout().q71_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g30_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var node = tmp;
    var tmp_0 = toDomainNode(node, wrapperContext);
    return isInterface(tmp_0, DocumentNode_0) ? tmp_0 : THROW_CCE();
  }
  function getOperationProvider(entity) {
    return new DefaultOperationProvider(entity, get_btbEntityNodeLayout().q71_1);
  }
  function initializeDetachedNode(entity, otNode, accession, model) {
    get_btbEntityNodeLayout().s71(otNode, entity);
    var tmp = toDomainNode(otNode, get_wrapperContext(model));
    var node = isInterface(tmp, BTBNode) ? tmp : THROW_CCE();
    DocumentIdUtil_getInstance().p6j(node, accession);
    return node;
  }
  function sam$jetbrains_ocelot_base_disposable_Disposable$0_9(function_0) {
    this.ws6_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_9).vr = function () {
    return this.ws6_1();
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_9).b4 = function () {
    return this.ws6_1;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_9).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Disposable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_9).hashCode = function () {
    return hashCode(this.b4());
  };
  function initializeRemoteDocument$lambda($otEnvironment, $entity) {
    return function () {
      $otEnvironment.xs6($entity.j2z_1);
      return Unit_instance;
    };
  }
  function ClientConnection(client, socketManager) {
    this.ys6_1 = client;
    this.zs6_1 = socketManager;
  }
  protoOf(ClientConnection).toString = function () {
    return 'ClientConnection(client=' + toString_1(this.ys6_1) + ', socketManager=' + this.zs6_1.toString() + ')';
  };
  protoOf(ClientConnection).hashCode = function () {
    var result = hashCode(this.ys6_1);
    result = imul(result, 31) + hashCode(this.zs6_1) | 0;
    return result;
  };
  protoOf(ClientConnection).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ClientConnection))
      return false;
    var tmp0_other_with_cast = other instanceof ClientConnection ? other : THROW_CCE();
    if (!equals(this.ys6_1, tmp0_other_with_cast.ys6_1))
      return false;
    if (!equals(this.zs6_1, tmp0_other_with_cast.zs6_1))
      return false;
    return true;
  };
  function _get_clientConnection__d8cw0u($this) {
    return $this.us6_1.y();
  }
  function Companion_388() {
    Companion_instance_388 = this;
    this.as7_1 = getLogger(getKClass(OtEnvironment));
  }
  var Companion_instance_388;
  function Companion_getInstance_388() {
    if (Companion_instance_388 == null)
      new Companion_388();
    return Companion_instance_388;
  }
  function OtEnvironment$clientConnectionLazy$1$1() {
  }
  protoOf(OtEnvironment$clientConnectionLazy$1$1).bs7 = function (event) {
    Companion_getInstance_388().as7_1.go(event.p2e_1 ? 'connected!' : 'disconnected :(');
  };
  protoOf(OtEnvironment$clientConnectionLazy$1$1).d28 = function (event) {
    return this.bs7(event instanceof PropertyChangeEvent ? event : THROW_CCE());
  };
  function OtEnvironment$clientConnectionLazy$lambda$lambda($client, this$0, $nodeFactory) {
    return function (configuration) {
      return OtServiceEndpoint_init_$Create$($client, configuration, this$0.ss6_1, VOID, $nodeFactory);
    };
  }
  function OtEnvironment$clientConnectionLazy$lambda$lambda_0(this$0) {
    return function (configuration) {
      return new PingPongServiceEndpoint(this$0.ss6_1, configuration.f2y(ProtocolParameters_getInstance().lke_1));
    };
  }
  function OtEnvironment$clientConnectionLazy$lambda($nodeFactory, this$0) {
    return function () {
      var client = (new ClientBuilder($nodeFactory)).zkp(this$0.ts6_1).k2p();
      var tmp = client.bko();
      tmp.o27(new OtEnvironment$clientConnectionLazy$1$1());
      // Inline function 'kotlin.apply' call
      var this_0 = new ServiceEndpointContainer();
      // Inline function 'jetbrains.biokb.editor.explorables.OtEnvironment.clientConnectionLazy.<anonymous>.<anonymous>' call
      this_0.akj(OtEnvironment$clientConnectionLazy$lambda$lambda(client, this$0, $nodeFactory));
      this_0.akj(OtEnvironment$clientConnectionLazy$lambda$lambda_0(this$0));
      var container = this_0;
      var socketManager = SocketManager_init_$Create$(container, this$0.qs6_1, this$0.rs6_1, this$0.ss6_1);
      socketManager.nkl();
      return new ClientConnection(client, socketManager);
    };
  }
  function OtEnvironment(url, socketFactory, edt, nodeFactory) {
    Companion_getInstance_388();
    this.qs6_1 = url;
    this.rs6_1 = socketFactory;
    this.ss6_1 = edt;
    this.ts6_1 = new EntityContext();
    var tmp = this;
    tmp.us6_1 = lazy_0(OtEnvironment$clientConnectionLazy$lambda(nodeFactory, this));
  }
  protoOf(OtEnvironment).vs6 = function (wrapperContext) {
    _get_clientConnection__d8cw0u(this).ys6_1.bkp(wrapperContext, this.ss6_1);
    return wrapperContext.n4u(get_COMMAND_PROCESSOR_KEY());
  };
  protoOf(OtEnvironment).cs7 = function (entityId, $completion) {
    return await_1(_get_clientConnection__d8cw0u(this).ys6_1.ckp(new EntityReference(entityId)), $completion);
  };
  protoOf(OtEnvironment).xs6 = function (entityId) {
    if (this.ts6_1.e35(entityId)) {
      _get_clientConnection__d8cw0u(this).ys6_1.kko(entityId);
    }
  };
  protoOf(OtEnvironment).vr = function () {
    if (this.us6_1.bm()) {
      _get_clientConnection__d8cw0u(this).zs6_1.aa1();
    }
  };
  function DocumentSource() {
  }
  function DocumentSourceDescriptor(accession, rawPointer, revision, globalVersion, rawNodeId) {
    rawPointer = rawPointer === VOID ? null : rawPointer;
    revision = revision === VOID ? null : revision;
    globalVersion = globalVersion === VOID ? null : globalVersion;
    rawNodeId = rawNodeId === VOID ? null : rawNodeId;
    this.accession = accession;
    this.rawPointer = rawPointer;
    this.revision = revision;
    this.globalVersion = globalVersion;
    this.rawNodeId = rawNodeId;
  }
  protoOf(DocumentSourceDescriptor).zr6 = function () {
    return this.accession;
  };
  protoOf(DocumentSourceDescriptor).ds7 = function () {
    return this.rawPointer;
  };
  protoOf(DocumentSourceDescriptor).es7 = function () {
    return this.revision;
  };
  protoOf(DocumentSourceDescriptor).fs7 = function () {
    return this.globalVersion;
  };
  protoOf(DocumentSourceDescriptor).gs7 = function () {
    return this.rawNodeId;
  };
  protoOf(DocumentSourceDescriptor).ug = function () {
    return this.accession;
  };
  protoOf(DocumentSourceDescriptor).vg = function () {
    return this.rawPointer;
  };
  protoOf(DocumentSourceDescriptor).hm = function () {
    return this.revision;
  };
  protoOf(DocumentSourceDescriptor).g59 = function () {
    return this.globalVersion;
  };
  protoOf(DocumentSourceDescriptor).h59 = function () {
    return this.rawNodeId;
  };
  protoOf(DocumentSourceDescriptor).hs7 = function (accession, rawPointer, revision, globalVersion, rawNodeId) {
    return new DocumentSourceDescriptor(accession, rawPointer, revision, globalVersion, rawNodeId);
  };
  protoOf(DocumentSourceDescriptor).copy = function (accession, rawPointer, revision, globalVersion, rawNodeId, $super) {
    accession = accession === VOID ? this.accession : accession;
    rawPointer = rawPointer === VOID ? this.rawPointer : rawPointer;
    revision = revision === VOID ? this.revision : revision;
    globalVersion = globalVersion === VOID ? this.globalVersion : globalVersion;
    rawNodeId = rawNodeId === VOID ? this.rawNodeId : rawNodeId;
    return this.hs7(accession, rawPointer, revision, globalVersion, rawNodeId);
  };
  protoOf(DocumentSourceDescriptor).toString = function () {
    return 'DocumentSourceDescriptor(accession=' + this.accession + ', rawPointer=' + this.rawPointer + ', revision=' + this.revision + ', globalVersion=' + toString_0(this.globalVersion) + ', rawNodeId=' + this.rawNodeId + ')';
  };
  protoOf(DocumentSourceDescriptor).hashCode = function () {
    var result = getStringHashCode(this.accession);
    result = imul(result, 31) + (this.rawPointer == null ? 0 : getStringHashCode(this.rawPointer)) | 0;
    result = imul(result, 31) + (this.revision == null ? 0 : getStringHashCode(this.revision)) | 0;
    result = imul(result, 31) + (this.globalVersion == null ? 0 : this.globalVersion.hashCode()) | 0;
    result = imul(result, 31) + (this.rawNodeId == null ? 0 : getStringHashCode(this.rawNodeId)) | 0;
    return result;
  };
  protoOf(DocumentSourceDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DocumentSourceDescriptor))
      return false;
    var tmp0_other_with_cast = other instanceof DocumentSourceDescriptor ? other : THROW_CCE();
    if (!(this.accession === tmp0_other_with_cast.accession))
      return false;
    if (!(this.rawPointer == tmp0_other_with_cast.rawPointer))
      return false;
    if (!(this.revision == tmp0_other_with_cast.revision))
      return false;
    if (!equals(this.globalVersion, tmp0_other_with_cast.globalVersion))
      return false;
    if (!(this.rawNodeId == tmp0_other_with_cast.rawNodeId))
      return false;
    return true;
  };
  function get_pointer_0(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.rawPointer;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.biokb.editor.sources.<get-pointer>.<anonymous>' call
      tmp = EntityId_init_$Create$_0(tmp0_safe_receiver);
    }
    return tmp;
  }
  function DraftQuerySource$load$slambda$slambda(this$0, resultContinuation) {
    this.qs7_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DraftQuerySource$load$slambda$slambda).ts7 = function ($this$async, $completion) {
    var tmp = this.i1l($this$async, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(DraftQuerySource$load$slambda$slambda).oa = function (p1, $completion) {
    return this.ts7((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DraftQuerySource$load$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.qs7_1.vs7_1.zrl(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ss7_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.ss7_1.brk(_get_accession__uiy019_0(this.qs7_1), this.qs7_1.as8_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(DraftQuerySource$load$slambda$slambda).i1l = function ($this$async, completion) {
    var i = new DraftQuerySource$load$slambda$slambda(this.qs7_1, completion);
    i.rs7_1 = $this$async;
    return i;
  };
  function DraftQuerySource$load$slambda$slambda_0(this$0, resultContinuation) {
    var i = new DraftQuerySource$load$slambda$slambda(this$0, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.ts7($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function _get_accession__uiy019_0($this) {
    return 'QUERY' + $this.ys7_1.toString();
  }
  function DraftQuerySource$load$slambda(this$0, resultContinuation) {
    this.js8_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DraftQuerySource$load$slambda).os8 = function ($this$coroutineScope, $completion) {
    var tmp = this.i1l($this$coroutineScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(DraftQuerySource$load$slambda).oa = function (p1, $completion) {
    return this.os8((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DraftQuerySource$load$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.ls8_1 = async(this.ks8_1, VOID, VOID, DraftQuerySource$load$slambda$slambda_0(this.js8_1, null));
            this.y9_1 = 1;
            suspendResult = this.js8_1.us7_1.cs7(this.js8_1.xs7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ms8_1 = suspendResult;
            this.ns8_1 = get_asCoroutineDispatcher(this.js8_1.ws7_1);
            this.y9_1 = 2;
            suspendResult = this.ls8_1.gw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var model = createFrontendDomainModel(this.ns8_1, ARGUMENT, this.ms8_1, this.js8_1.us7_1.ts6_1);
            var _destruct__k2r9zo = initializeRemoteDocument(this.js8_1.us7_1, this.ms8_1, _get_accession__uiy019_0(this.js8_1), this.js8_1.zs7_1, model);
            var node = _destruct__k2r9zo.ug();
            var processor = _destruct__k2r9zo.vg();
            var provider = _destruct__k2r9zo.hm();
            var connection = _destruct__k2r9zo.g59();
            return new EditableNodeInfo(this.js8_1, node, model, true, false, processor, provider, this.js8_1.ws7_1, connection.sr(model));
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(DraftQuerySource$load$slambda).i1l = function ($this$coroutineScope, completion) {
    var i = new DraftQuerySource$load$slambda(this.js8_1, completion);
    i.ks8_1 = $this$coroutineScope;
    return i;
  };
  function DraftQuerySource$load$slambda_0(this$0, resultContinuation) {
    var i = new DraftQuerySource$load$slambda(this$0, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.os8($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function DraftQuerySource(otEnvironment, editorServiceProvider, edt, entityId, queryId, name, globalVersion) {
    this.us7_1 = otEnvironment;
    this.vs7_1 = editorServiceProvider;
    this.ws7_1 = edt;
    this.xs7_1 = entityId;
    this.ys7_1 = queryId;
    this.zs7_1 = name;
    this.as8_1 = globalVersion;
  }
  protoOf(DraftQuerySource).w5c = function () {
    return new DocumentSourceDescriptor(_get_accession__uiy019_0(this), this.xs7_1.i2s_1, VOID, this.as8_1);
  };
  protoOf(DraftQuerySource).gro = function ($completion) {
    return coroutineScope(DraftQuerySource$load$slambda_0(this, null), $completion);
  };
  function EditedDocumentSource$load$slambda$slambda(this$0, resultContinuation) {
    this.xs8_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditedDocumentSource$load$slambda$slambda).ts7 = function ($this$async, $completion) {
    var tmp = this.i1l($this$async, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditedDocumentSource$load$slambda$slambda).oa = function (p1, $completion) {
    return this.ts7((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditedDocumentSource$load$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.xs8_1.bs9_1.zrl(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.zs8_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.zs8_1.zrj(this.xs8_1.ds9_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditedDocumentSource$load$slambda$slambda).i1l = function ($this$async, completion) {
    var i = new EditedDocumentSource$load$slambda$slambda(this.xs8_1, completion);
    i.ys8_1 = $this$async;
    return i;
  };
  function EditedDocumentSource$load$slambda$slambda_0(this$0, resultContinuation) {
    var i = new EditedDocumentSource$load$slambda$slambda(this$0, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.ts7($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function EditedDocumentSource$load$slambda(this$0, resultContinuation) {
    this.ns9_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditedDocumentSource$load$slambda).ts9 = function ($this$coroutineScope, $completion) {
    var tmp = this.i1l($this$coroutineScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditedDocumentSource$load$slambda).oa = function (p1, $completion) {
    return this.ts9((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditedDocumentSource$load$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.ps9_1 = async(this.os9_1, VOID, VOID, EditedDocumentSource$load$slambda$slambda_0(this.ns9_1, null));
            this.y9_1 = 1;
            suspendResult = this.ns9_1.as9_1.ys0(this.ns9_1.ds9_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.qs9_1 = suspendResult;
            this.rs9_1 = get_btbEntityNodeLayout().u71();
            this.ss9_1 = get_asCoroutineDispatcher(this.ns9_1.cs9_1);
            this.y9_1 = 2;
            suspendResult = this.ps9_1.gw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var model = createFrontendDomainModel(this.ss9_1, ARGUMENT, this.rs9_1);
            var node = get_docPersistence(model).w2p(this.qs9_1).d3a();
            var documentNode = initializeLocalDocument(this.rs9_1, node, this.ns9_1.ds9_1, this.ns9_1.es9_1, model);
            return new ExplorableNodeInfo(this.ns9_1, documentNode, model, true, false, this.ns9_1.cs9_1, model);
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditedDocumentSource$load$slambda).i1l = function ($this$coroutineScope, completion) {
    var i = new EditedDocumentSource$load$slambda(this.ns9_1, completion);
    i.os9_1 = $this$coroutineScope;
    return i;
  };
  function EditedDocumentSource$load$slambda_0(this$0, resultContinuation) {
    var i = new EditedDocumentSource$load$slambda(this$0, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.ts9($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function EditedDocumentSource(editorDocumentsApi, editorServiceProvider, edt, accession, name) {
    this.as9_1 = editorDocumentsApi;
    this.bs9_1 = editorServiceProvider;
    this.cs9_1 = edt;
    this.ds9_1 = accession;
    this.es9_1 = name;
  }
  protoOf(EditedDocumentSource).w5c = function () {
    return new DocumentSourceDescriptor(this.ds9_1);
  };
  protoOf(EditedDocumentSource).gro = function ($completion) {
    return coroutineScope(EditedDocumentSource$load$slambda_0(this, null), $completion);
  };
  function $loadSerializedResolvedNodeCOROUTINE$13(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.csa_1 = _this__u8e3s4;
  }
  protoOf($loadSerializedResolvedNodeCOROUTINE$13).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.dsa_1 = new SerializedNode(this.csa_1.isa_1, NodePointerConstructor(this.csa_1.jsa_1, this.csa_1.hsa_1));
            this.y9_1 = 1;
            suspendResult = this.csa_1.gsa_1.bs3(this.csa_1.jsa_1, new NodeId(this.csa_1.hsa_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new SerializedResolvedNode(this.dsa_1, ARGUMENT);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function EditedOntologyBrowserSource(editorsApi, accession, nodeId, content) {
    PrecalculatedResolversDocumentSource.call(this, accession);
    this.gsa_1 = editorsApi;
    this.hsa_1 = nodeId;
    this.isa_1 = content;
  }
  protoOf(EditedOntologyBrowserSource).w5c = function () {
    return new DocumentSourceDescriptor(this.jsa_1, VOID, VOID, VOID, this.hsa_1);
  };
  protoOf(EditedOntologyBrowserSource).lsa = function ($completion) {
    var tmp = new $loadSerializedResolvedNodeCOROUTINE$13(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditedOntologyBrowserSource).msa = function () {
    return false;
  };
  function EditedWorkingCopySource$load$slambda$slambda(this$0, resultContinuation) {
    this.wsa_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditedWorkingCopySource$load$slambda$slambda).ts7 = function ($this$async, $completion) {
    var tmp = this.i1l($this$async, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditedWorkingCopySource$load$slambda$slambda).oa = function (p1, $completion) {
    return this.ts7((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditedWorkingCopySource$load$slambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.wsa_1.drw_1.zrl(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ysa_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.ysa_1.zrj(this.wsa_1.hrw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditedWorkingCopySource$load$slambda$slambda).i1l = function ($this$async, completion) {
    var i = new EditedWorkingCopySource$load$slambda$slambda(this.wsa_1, completion);
    i.xsa_1 = $this$async;
    return i;
  };
  function EditedWorkingCopySource$load$slambda$slambda_0(this$0, resultContinuation) {
    var i = new EditedWorkingCopySource$load$slambda$slambda(this$0, resultContinuation);
    var l = function ($this$async, $completion) {
      return i.ts7($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function EditedWorkingCopySource$load$slambda(this$0, resultContinuation) {
    this.hsb_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditedWorkingCopySource$load$slambda).os8 = function ($this$coroutineScope, $completion) {
    var tmp = this.i1l($this$coroutineScope, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditedWorkingCopySource$load$slambda).oa = function (p1, $completion) {
    return this.os8((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditedWorkingCopySource$load$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.jsb_1 = async(this.isb_1, VOID, VOID, EditedWorkingCopySource$load$slambda$slambda_0(this.hsb_1, null));
            this.y9_1 = 1;
            suspendResult = this.hsb_1.crw_1.cs7(this.hsb_1.grw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ksb_1 = suspendResult;
            this.lsb_1 = get_asCoroutineDispatcher(this.hsb_1.frw_1);
            this.y9_1 = 2;
            suspendResult = this.jsb_1.gw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            var model = createFrontendDomainModel(this.lsb_1, ARGUMENT, this.ksb_1, this.hsb_1.crw_1.ts6_1);
            var _destruct__k2r9zo = initializeRemoteDocument(this.hsb_1.crw_1, this.ksb_1, this.hsb_1.hrw_1, this.hsb_1.irw_1, model);
            var node = _destruct__k2r9zo.ug();
            var processor = _destruct__k2r9zo.vg();
            var provider = _destruct__k2r9zo.hm();
            var connection = _destruct__k2r9zo.g59();
            return new EditableNodeInfo(this.hsb_1, node, model, true, this.hsb_1.jrw_1, processor, provider, this.hsb_1.frw_1, connection.sr(model));
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditedWorkingCopySource$load$slambda).i1l = function ($this$coroutineScope, completion) {
    var i = new EditedWorkingCopySource$load$slambda(this.hsb_1, completion);
    i.isb_1 = $this$coroutineScope;
    return i;
  };
  function EditedWorkingCopySource$load$slambda_0(this$0, resultContinuation) {
    var i = new EditedWorkingCopySource$load$slambda(this$0, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.os8($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function EditedWorkingCopySource(otEnvironment, editorServiceProvider, editorDocumentsApi, edt, entityId, accession, name, readonly) {
    this.crw_1 = otEnvironment;
    this.drw_1 = editorServiceProvider;
    this.erw_1 = editorDocumentsApi;
    this.frw_1 = edt;
    this.grw_1 = entityId;
    this.hrw_1 = accession;
    this.irw_1 = name;
    this.jrw_1 = readonly;
  }
  protoOf(EditedWorkingCopySource).w5c = function () {
    return new DocumentSourceDescriptor(this.hrw_1, this.grw_1.i2s_1);
  };
  protoOf(EditedWorkingCopySource).gro = function ($completion) {
    return coroutineScope(EditedWorkingCopySource$load$slambda_0(this, null), $completion);
  };
  function ExploredDocumentSource(explorerApi, accession, globalVersion) {
    PrecalculatedResolversDocumentSource.call(this, accession);
    this.osb_1 = explorerApi;
    this.psb_1 = globalVersion;
  }
  protoOf(ExploredDocumentSource).w5c = function () {
    return new DocumentSourceDescriptor(this.jsa_1, VOID, VOID, this.psb_1);
  };
  protoOf(ExploredDocumentSource).lsa = function ($completion) {
    return this.osb_1.cs5(this.jsa_1, this.psb_1, VOID, $completion);
  };
  protoOf(ExploredDocumentSource).nsa = function () {
    return true;
  };
  function $loadSerializedResolvedNodeCOROUTINE$14(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ysb_1 = _this__u8e3s4;
  }
  protoOf($loadSerializedResolvedNodeCOROUTINE$14).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.zsb_1 = new SerializedNode(this.ysb_1.esc_1, NodePointerConstructor(this.ysb_1.fsc_1.toString(), this.ysb_1.dsc_1));
            this.y9_1 = 1;
            suspendResult = this.ysb_1.csc_1.bs5(this.ysb_1.jsa_1, this.ysb_1.fsc_1, this.ysb_1.dsc_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = ARGUMENT.resolveInfo;
            return new SerializedResolvedNode(this.zsb_1, ARGUMENT_0);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ExploredOntologyBrowserSource(explorerApi, accession, nodeId, content, globalVersion) {
    PrecalculatedResolversDocumentSource.call(this, accession);
    this.csc_1 = explorerApi;
    this.dsc_1 = nodeId;
    this.esc_1 = content;
    this.fsc_1 = globalVersion;
  }
  protoOf(ExploredOntologyBrowserSource).w5c = function () {
    return new DocumentSourceDescriptor(this.jsa_1, VOID, VOID, this.fsc_1, this.dsc_1);
  };
  protoOf(ExploredOntologyBrowserSource).lsa = function ($completion) {
    var tmp = new $loadSerializedResolvedNodeCOROUTINE$14(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ExploredOntologyBrowserSource).msa = function () {
    return false;
  };
  function HistoryPanelDocumentSource(explorerApi, accession, revision) {
    PrecalculatedResolversDocumentSource.call(this, accession);
    this.isc_1 = explorerApi;
    this.jsc_1 = revision;
  }
  protoOf(HistoryPanelDocumentSource).w5c = function () {
    return new DocumentSourceDescriptor(this.jsa_1, VOID, this.jsc_1);
  };
  protoOf(HistoryPanelDocumentSource).lsa = function ($completion) {
    return this.isc_1.es5(this.jsa_1, this.jsc_1, VOID, $completion);
  };
  protoOf(HistoryPanelDocumentSource).nsa = function () {
    return true;
  };
  function PathEntrySource(accession, serializedResolvedNode) {
    PrecalculatedResolversDocumentSource.call(this, accession);
    this.msc_1 = serializedResolvedNode;
  }
  protoOf(PathEntrySource).w5c = function () {
    return new DocumentSourceDescriptor(this.jsa_1, VOID, VOID, VOID, this.msc_1.node.pointer.nodeId.i2s_1);
  };
  protoOf(PathEntrySource).lsa = function ($completion) {
    return this.msc_1;
  };
  function $loadCOROUTINE$15(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vsc_1 = _this__u8e3s4;
  }
  protoOf($loadCOROUTINE$15).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.vsc_1.lsa(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var _destruct__k2r9zo = suspendResult;
            var serializedNode = _destruct__k2r9zo.ug();
            var resolveInfo = _destruct__k2r9zo.vg();
            var entity = get_btbEntityNodeLayout().u71();
            var model = createDomainModelWithPrecalculatedResolve(get_asCoroutineDispatcher(this.vsc_1.ksa_1), resolveInfo, entity);
            var tmp_0;
            if (this.vsc_1.msa()) {
              var btbOtNodePersister = new BtbOtNodePersister(model.q72_1);
              tmp_0 = btbOtNodePersister.q2q(serializedNode.content).bg1_1;
            } else {
              var docPersistence = get_docPersistence(model);
              tmp_0 = docPersistence.w2p(serializedNode.content).d3a();
            }

            var node = tmp_0;
            var btbNode = initializeDetachedNode(entity, node, this.vsc_1.jsa_1, model);
            ensureNotNull(model.m72_1.h2o(Companion_instance_184)).var();
            return new ExplorableNodeInfo(this.vsc_1, btbNode, model, false, this.vsc_1.nsa(), this.vsc_1.ksa_1, model);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function PrecalculatedResolversDocumentSource(accession, edt) {
    edt = edt === VOID ? get_platformEdt() : edt;
    this.jsa_1 = accession;
    this.ksa_1 = edt;
  }
  protoOf(PrecalculatedResolversDocumentSource).gro = function ($completion) {
    var tmp = new $loadCOROUTINE$15(this, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(PrecalculatedResolversDocumentSource).nsa = function () {
    return false;
  };
  protoOf(PrecalculatedResolversDocumentSource).msa = function () {
    return true;
  };
  function PublishedQuerySource(queriesApi, queryId) {
    PrecalculatedResolversDocumentSource.call(this, 'QUERY' + queryId.toString());
    this.ysc_1 = queriesApi;
    this.zsc_1 = queryId;
  }
  protoOf(PublishedQuerySource).w5c = function () {
    return new DocumentSourceDescriptor(this.jsa_1);
  };
  protoOf(PublishedQuerySource).lsa = function ($completion) {
    return this.ysc_1.ds6(this.zsc_1, $completion);
  };
  function UsageEntrySource(accession, usageDto, edt) {
    edt = edt === VOID ? get_platformEdt() : edt;
    this.asd_1 = accession;
    this.bsd_1 = usageDto;
    this.csd_1 = edt;
  }
  protoOf(UsageEntrySource).w5c = function () {
    return new DocumentSourceDescriptor(this.asd_1, VOID, VOID, VOID, this.bsd_1.node.node.pointer.nodeId.i2s_1);
  };
  protoOf(UsageEntrySource).gro = function ($completion) {
    var entity = get_btbEntityNodeLayout().u71();
    var model = createDomainModelWithPrecalculatedResolve(get_asCoroutineDispatcher(this.csd_1), this.bsd_1.node.resolveInfo, entity);
    var findUsagesConfig = ensureNotNull(model.m72_1.h2o(FindUsagesConfigService_instance));
    var usage = get_btbUsageDeserializer(model).dsd(this.bsd_1);
    var usagePresentationData = findUsagesConfig.p8c(usage);
    var otNode = toOtNode(usage.r8c_1);
    initializeDetachedNode(entity, otNode, this.asd_1, model);
    ensureNotNull(model.m72_1.h2o(Companion_instance_184)).var();
    return new ExplorableNodeInfo(this, usagePresentationData, model, false, false, this.csd_1, model);
  };
  function get_btbUsageDeserializer(_this__u8e3s4) {
    return new BTBUsageDeserializerImpl(ensureNotNull(_this__u8e3s4.m72_1.h2o(WrapperContextService_instance)), ensureNotNull(_this__u8e3s4.m72_1.h2o(FindUsagesConfigService_instance)), _this__u8e3s4.q72_1);
  }
  function createUsage($this, usageKind, node, refSourceNode, link) {
    var tmp = usageKind instanceof UsageKind ? usageKind : THROW_CCE();
    return new Usage(tmp, node, new ReferenceContext(refSourceNode, link instanceof ReferenceLink ? link : THROW_CCE()));
  }
  function findDescendantById(_this__u8e3s4, $this, nodeId) {
    // Inline function 'kotlin.sequences.find' call
    var tmp0 = toOtNode(_this__u8e3s4).o3b(true);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.sequences.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.biokb.editor.usages.BTBUsageDeserializerImpl.findDescendantById.<anonymous>' call
        if (element.v39().equals(nodeId)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toDomainNode(tmp0_safe_receiver, get_wrapperContextOrNull(_this__u8e3s4));
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$_0('Descendant node with id ' + nodeId.toString() + ' not found inside node ' + toString_1(_this__u8e3s4));
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function BTBUsageDeserializerImpl(wrapperContext, usagesConfig, nodeFactory) {
    this.esd_1 = wrapperContext;
    this.fsd_1 = usagesConfig;
    this.gsd_1 = nodeFactory;
  }
  protoOf(BTBUsageDeserializerImpl).dsd = function (usageDto) {
    var node = (new BTBNodePersister(this.esd_1, this.gsd_1)).p2q(usageDto.node.node.content);
    var tmp = this.fsd_1.o8c(usageDto.kind);
    var usageKind = tmp instanceof UsageKind ? tmp : THROW_CCE();
    var referenceSourceNode = findDescendantById(node, this, new NodeId(usageDto.referenceSourceNodeId));
    var tmp_0;
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = usageDto.propertyId;
    if (charSequenceLength(this_0) > 0) {
      tmp_0 = NodePropertyIdFactory_getInstance().x3c(usageDto.propertyId);
    } else {
      tmp_0 = first(ReferenceAspects_getInstance().xgu(referenceSourceNode.h3f()));
    }
    var propertyId = tmp_0;
    var referenceLink = getReferenceLink(otConceptRegistry(this.esd_1).i6m(referenceSourceNode.h3f()), propertyId);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (referenceLink == null) {
        // Inline function 'jetbrains.biokb.editor.usages.BTBUsageDeserializerImpl.deserialize.<anonymous>' call
        var message = 'BTBUsageDeserializer could not get deserialize reference link by concept id ' + ('and property id (' + referenceSourceNode.h3f().toString() + ', ' + propertyId.toString() + ')');
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      } else {
        break $l$block;
      }
    }
    return createUsage(this, usageKind, node, isInterface(referenceSourceNode, BTBNode) ? referenceSourceNode : THROW_CCE(), referenceLink);
  };
  function BTBEditor() {
    BTBEditor_instance = this;
    EditorScope.call(this);
    btbProgramBuilders(this);
    extensionLibraryBuilders(this);
    factBuilders(this);
    functionLibraryBuilders(this);
    linkLibraryBuilders(this);
    notionLibraryBuilders(this);
    ontologyLibraryBuilders(this);
    processLibraryBuilders(this);
    queryCommandBuilders(this);
    relationLibraryBuilders(this);
    notionTypeBuilders(this);
    ontologyImportRootBuilders(this);
  }
  protoOf(BTBEditor).isd = function (configuration) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(DomainNode);
    var tmp$ret$0 = this.ypf(sourceType);
    return buildFactory(tmp$ret$0, configuration);
  };
  protoOf(BTBEditor).jsd = function (_this__u8e3s4) {
    return get_highlighted(_this__u8e3s4);
  };
  protoOf(BTBEditor).zpf = function (_this__u8e3s4) {
    return this.jsd(_this__u8e3s4);
  };
  var BTBEditor_instance;
  function BTBEditor_getInstance() {
    if (BTBEditor_instance == null)
      new BTBEditor();
    return BTBEditor_instance;
  }
  function btbProgramBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(btbProgramBuilders$lambda(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(btbProgramBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(btbProgramBuilders$lambda_1(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(btbProgramBuilders$lambda_2(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_2);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_3 = new LazyMapperBuilder(btbProgramBuilders$lambda_3(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_3);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_4 = new LazyMapperBuilder(btbProgramBuilders$lambda_4(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_4);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_5 = new LazyMapperBuilder(btbProgramBuilders$lambda_5(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_5);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_6 = new LazyMapperBuilder(btbProgramBuilders$lambda_6(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_6);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_7 = new LazyMapperBuilder(btbProgramBuilders$lambda_7(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_7);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_8 = new LazyMapperBuilder(btbProgramBuilders$lambda_8(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_8);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_9 = new LazyMapperBuilder(btbProgramBuilders$lambda_9(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_9);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_10 = new LazyMapperBuilder(btbProgramBuilders$lambda_10(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_10);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_11 = new LazyMapperBuilder(btbProgramBuilders$lambda_11(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_11);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_12 = new LazyMapperBuilder(btbProgramBuilders$lambda_12(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_12);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_13 = new LazyMapperBuilder(btbProgramBuilders$lambda_13(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_13);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_14 = new LazyMapperBuilder(btbProgramBuilders$lambda_14(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_14);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_15 = new LazyMapperBuilder(btbProgramBuilders$lambda_15(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_15);
  }
  function get_category(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(Category_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-category>.<anonymous>' call
    builder.qpn(_get_category_$lambda_8otj26);
    builder.rpn(', ');
    var simpleClassName = ensureNotNull(getKClass(Category_1).lb());
    builder.tpn(simpleClassName, _get_category_$lambda_8otj26_0);
    return builder;
  }
  function get_imports(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyImportRootReference_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-imports>.<anonymous>' call
    builder.ppn('<imports>');
    builder.qpn(_get_imports_$lambda_vd27mw);
    builder.spn();
    var simpleClassName = ensureNotNull(getKClass(OntologyImportRootReference_1).lb());
    builder.tpn(simpleClassName, _get_imports_$lambda_vd27mw_0);
    return builder;
  }
  function get_factSetRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(FactSet_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-factSetRole>.<anonymous>' call
    builder.qpn(_get_factSetRole_$lambda_yaiexy);
    builder.spn();
    var simpleClassName = ensureNotNull(getKClass(FactSet_1).lb());
    builder.tpn(simpleClassName, _get_factSetRole_$lambda_yaiexy_0);
    return builder;
  }
  function get_ontologyLibraryReferenceRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyLibraryReference_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-ontologyLibraryReferenceRole>.<anonymous>' call
    builder.qpn(_get_ontologyLibraryReferenceRole_$lambda_x2j4ob);
    var simpleClassName = ensureNotNull(getKClass(OntologyLibraryReference_1).lb());
    builder.tpn(simpleClassName, _get_ontologyLibraryReferenceRole_$lambda_x2j4ob_0);
    return builder;
  }
  function get_ontologyElementReferenceRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyElementReference_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-ontologyElementReferenceRole>.<anonymous>' call
    builder.qpn(_get_ontologyElementReferenceRole_$lambda_f29iic);
    builder.opn(_get_ontologyElementReferenceRole_$lambda_f29iic_0);
    var simpleClassName = ensureNotNull(getKClass(OntologyElementReference_1).lb());
    builder.tpn(simpleClassName, _get_ontologyElementReferenceRole_$lambda_f29iic_1);
    return builder;
  }
  function get_contextRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(Context_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-contextRole>.<anonymous>' call
    builder.ppn('<context>');
    builder.qpn(_get_contextRole_$lambda_qaiv3z);
    var simpleClassName = ensureNotNull(getKClass(Context_1).lb());
    builder.tpn(simpleClassName, _get_contextRole_$lambda_qaiv3z_0);
    return builder;
  }
  function get_variableDeclarationRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(VariableDeclaration_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-variableDeclarationRole>.<anonymous>' call
    builder.qpn(_get_variableDeclarationRole_$lambda_d4qi0e);
    var simpleClassName = ensureNotNull(getKClass(VariableDeclaration_1).lb());
    builder.tpn(simpleClassName, _get_variableDeclarationRole_$lambda_d4qi0e_0);
    return builder;
  }
  function get_factRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(Fact_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-factRole>.<anonymous>' call
    builder.ppn('<facts>');
    builder.qpn(_get_factRole_$lambda_e22khq);
    builder.spn();
    var simpleClassName = ensureNotNull(getKClass(Fact_1).lb());
    builder.tpn(simpleClassName, _get_factRole_$lambda_e22khq_0);
    return builder;
  }
  function btbProgramBuilders$lambda$lambda$lambda(it) {
    return it.rau();
  }
  function btbProgramBuilders$lambda$lambda$lambda_0(it) {
    return it.sau();
  }
  function btbProgramBuilders$lambda$lambda$lambda_1(it) {
    return it.qau();
  }
  function btbProgramBuilders$lambda$lambda($this_btbProgramBuilders) {
    return function ($this$rootIndent) {
      keyword($this$rootIndent, 'categories:');
      space($this$rootIndent);
      var tmp = get_category($this_btbProgramBuilders);
      children_1($this$rootIndent, tmp, btbProgramBuilders$lambda$lambda$lambda);
      newLine($this$rootIndent);
      space($this$rootIndent);
      newLine($this$rootIndent);
      var tmp_0 = get_imports($this_btbProgramBuilders);
      children_1($this$rootIndent, tmp_0, btbProgramBuilders$lambda$lambda$lambda_0);
      newLine($this$rootIndent);
      space($this$rootIndent);
      newLine($this$rootIndent);
      var tmp_1 = get_factSetRole($this_btbProgramBuilders);
      children_1($this$rootIndent, tmp_1, btbProgramBuilders$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(BTBDocument_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_2(it) {
    return it.b3();
  }
  function btbProgramBuilders$lambda$lambda$lambda_3(it) {
    return it.kay();
  }
  function btbProgramBuilders$lambda$lambda$lambda_4(it) {
    return it.lay();
  }
  function btbProgramBuilders$lambda$lambda_0($this_btbProgramBuilders) {
    return function ($this$rootIndent) {
      textProperty($this$rootIndent, '<name>', btbProgramBuilders$lambda$lambda$lambda_2);
      indentLabel($this$rootIndent, ':');
      var tmp = get_ontologyLibraryReferenceRole($this_btbProgramBuilders);
      child_0($this$rootIndent, tmp, btbProgramBuilders$lambda$lambda$lambda_3);
      indentLabel($this$rootIndent, '/');
      var tmp_0 = get_ontologyElementReferenceRole($this_btbProgramBuilders);
      child_0($this$rootIndent, tmp_0, btbProgramBuilders$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_0($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(Context_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda_0($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_5(it) {
    return it.kay();
  }
  function btbProgramBuilders$lambda$lambda$lambda_6(it) {
    return it.lay();
  }
  function btbProgramBuilders$lambda$lambda_1($this_btbProgramBuilders) {
    return function ($this$rootIndent) {
      var tmp = get_ontologyLibraryReferenceRole($this_btbProgramBuilders);
      child_0($this$rootIndent, tmp, btbProgramBuilders$lambda$lambda$lambda_5);
      indentLabel($this$rootIndent, '/');
      var tmp_0 = get_ontologyElementReferenceRole($this_btbProgramBuilders);
      child_0($this$rootIndent, tmp_0, btbProgramBuilders$lambda$lambda$lambda_6);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_1($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(Category_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda_1($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_2($this$rootIndent) {
    keyword($this$rootIndent, 'import');
    space($this$rootIndent);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_198().gbz_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_7(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_8(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(OntologyImportRoot_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_9(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_10);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_11;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<root>', btbProgramBuilders$lambda$lambda$lambda_12(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(btbProgramBuilders$lambda$lambda$lambda_13);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_14);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_15);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_7($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.ub6();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function btbProgramBuilders$$inlined$editor$4$1$2$1($refCompletion, $this, $source) {
    this.ksd_1 = $refCompletion;
    this.lsd_1 = $this;
    this.msd_1 = $source;
    CellTrait.call(this);
  }
  protoOf(btbProgramBuilders$$inlined$editor$4$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.ksd_1(this.lsd_1, this.msd_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_8($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new btbProgramBuilders$$inlined$editor$4$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda(s) {
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.ub6();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion));
      return Unit_instance;
    };
  }
  function btbProgramBuilders$$inlined$editor$4$1$3$1($cellBuilder, $refCompletion) {
    this.osd_1 = $refCompletion;
    this.nsd_1 = $cellBuilder;
  }
  protoOf(btbProgramBuilders$$inlined$editor$4$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda(property, this.osd_1));
  };
  protoOf(btbProgramBuilders$$inlined$editor$4$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(btbProgramBuilders$$inlined$editor$4$1$3$1).gpe = function () {
    return this.nsd_1.gpe();
  };
  protoOf(btbProgramBuilders$$inlined$editor$4$1$3$1).qsd = function (child) {
    this.nsd_1.xpd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$4$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$4$1$3$1).rsd = function (init) {
    this.nsd_1.ypd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$4$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$4$1$3$1).ssd = function (init) {
    this.nsd_1.zpd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$4$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$4$1$3$1).tsd = function (source, cellMap, context) {
    return this.nsd_1.bpe(source, cellMap, context);
  };
  protoOf(btbProgramBuilders$$inlined$editor$4$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda(it) {
    return it.b3();
  }
  function btbProgramBuilders$lambda$lambda$lambda_9($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new btbProgramBuilders$$inlined$editor$4$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<root>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_10() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_11(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_12($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_13($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.ub6();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_14($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.ub6();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_15($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.ub6();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_2($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyImportRootReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda_2);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_3($this$rootIndent) {
    var tmp1 = '<variable>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_221().kcq_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_16(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_17(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(VariableDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_18(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_19);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_20;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp1, btbProgramBuilders$lambda$lambda$lambda_21(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(btbProgramBuilders$lambda$lambda$lambda_22);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_23);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_24);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_16($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.xcq();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_0($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function btbProgramBuilders$$inlined$editor$5$1$2$1($refCompletion, $this, $source) {
    this.usd_1 = $refCompletion;
    this.vsd_1 = $this;
    this.wsd_1 = $source;
    CellTrait.call(this);
  }
  protoOf(btbProgramBuilders$$inlined$editor$5$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.usd_1(this.vsd_1, this.wsd_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_0(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_17($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new btbProgramBuilders$$inlined$editor$5$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_0(s) {
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.xcq();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_1($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(LocalReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_2($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_0($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_1($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_2($refCompletion));
      return Unit_instance;
    };
  }
  function btbProgramBuilders$$inlined$editor$5$1$3$1($cellBuilder, $refCompletion) {
    this.ysd_1 = $refCompletion;
    this.xsd_1 = $cellBuilder;
  }
  protoOf(btbProgramBuilders$$inlined$editor$5$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_0(property, this.ysd_1));
  };
  protoOf(btbProgramBuilders$$inlined$editor$5$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(btbProgramBuilders$$inlined$editor$5$1$3$1).gpe = function () {
    return this.xsd_1.gpe();
  };
  protoOf(btbProgramBuilders$$inlined$editor$5$1$3$1).qsd = function (child) {
    this.xsd_1.xpd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$5$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$5$1$3$1).rsd = function (init) {
    this.xsd_1.ypd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$5$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$5$1$3$1).ssd = function (init) {
    this.xsd_1.zpd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$5$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$5$1$3$1).tsd = function (source, cellMap, context) {
    return this.xsd_1.bpe(source, cellMap, context);
  };
  protoOf(btbProgramBuilders$$inlined$editor$5$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_0(it) {
    return it.b3();
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_1($this$rightTransform, _unused_var__etf5q3, cell, cellFinder) {
    var tmp = CompletionSupplement_instance;
    return tmp.smc([completes('.', btbProgramBuilders$lambda$lambda$lambda$lambda$lambda(cell, $this$rightTransform, cellFinder))]);
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda$lambda($cell, $this_rightTransform, $cellFinder) {
    return function () {
      var tmp = get_enclosingRefData($cell).fpy_1;
      var referenceSource = (!(tmp == null) ? isInterface(tmp, VariableReferenceValue_1) : false) ? tmp : THROW_CCE();
      // Inline function 'kotlin.run' call
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      var it = referenceSource.gcw($this_rightTransform.o71());
      var tmp0_safe_receiver = firstOrNull_1($cellFinder.vn4(it));
      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ulp(ProjectionalSynchronizers_getInstance().jlw_1);
      return tmp0_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp0_elvis_lhs;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_18($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new btbProgramBuilders$$inlined$editor$5$1$3$1(cellBuilder, $refCompletion);
      var tmp = get_IdentifierValidator();
      // Inline function 'kotlin.apply' call
      var this_0 = refCellBuilder.kpg('<variable>', tmp, btbProgramBuilders$lambda$lambda$lambda$lambda_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      rightTransform(this_0, btbProgramBuilders$lambda$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_19() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_20(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_21($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_22($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.xcq();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_23($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.xcq();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_24($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.xcq();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_3($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(VariableReferenceValue_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda_3);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_4($this$rootIndent) {
    decimalProperty($this$rootIndent, '<amount>', btbProgramBuilders$lambda$lambda$lambda_25);
    space($this$rootIndent);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_223().hbk_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_26(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_27(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(MeasurementUnit_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_28(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_29);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_30;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<unit>', btbProgramBuilders$lambda$lambda$lambda_31(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(btbProgramBuilders$lambda$lambda$lambda_32);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_33);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_34);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_25(it) {
    return it.ibk();
  }
  function btbProgramBuilders$lambda$lambda$lambda_26($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.jbk();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_1($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function btbProgramBuilders$$inlined$editor$6$1$3$1($refCompletion, $this, $source) {
    this.zsd_1 = $refCompletion;
    this.ase_1 = $this;
    this.bse_1 = $source;
    CellTrait.call(this);
  }
  protoOf(btbProgramBuilders$$inlined$editor$6$1$3$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.zsd_1(this.ase_1, this.bse_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_1(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_27($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new btbProgramBuilders$$inlined$editor$6$1$3$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_1(s) {
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.jbk();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_3($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_4($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_1($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_3($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_4($refCompletion));
      return Unit_instance;
    };
  }
  function btbProgramBuilders$$inlined$editor$6$1$4$1($cellBuilder, $refCompletion) {
    this.dse_1 = $refCompletion;
    this.cse_1 = $cellBuilder;
  }
  protoOf(btbProgramBuilders$$inlined$editor$6$1$4$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_1(property, this.dse_1));
  };
  protoOf(btbProgramBuilders$$inlined$editor$6$1$4$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(btbProgramBuilders$$inlined$editor$6$1$4$1).gpe = function () {
    return this.cse_1.gpe();
  };
  protoOf(btbProgramBuilders$$inlined$editor$6$1$4$1).qsd = function (child) {
    this.cse_1.xpd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$6$1$4$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$6$1$4$1).rsd = function (init) {
    this.cse_1.ypd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$6$1$4$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$6$1$4$1).ssd = function (init) {
    this.cse_1.zpd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$6$1$4$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$6$1$4$1).tsd = function (source, cellMap, context) {
    return this.cse_1.bpe(source, cellMap, context);
  };
  protoOf(btbProgramBuilders$$inlined$editor$6$1$4$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_2(it) {
    return it.b3();
  }
  function btbProgramBuilders$lambda$lambda$lambda_28($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new btbProgramBuilders$$inlined$editor$6$1$4$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<unit>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda_2);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_29() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_30(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_31($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_32($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.jbk();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_33($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.jbk();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_34($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.jbk();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_4($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(MeasurableValue_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda_4);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_5($this$rootIndent) {
    var tmp1 = '<constant>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_224().jb2_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_35(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_36(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(EnumerationConstant_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_37(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_38);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_39;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp1, btbProgramBuilders$lambda$lambda$lambda_40(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(btbProgramBuilders$lambda$lambda$lambda_41);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_42);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_43);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_35($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.wb2();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_2($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function btbProgramBuilders$$inlined$editor$7$1$2$1($refCompletion, $this, $source) {
    this.ese_1 = $refCompletion;
    this.fse_1 = $this;
    this.gse_1 = $source;
    CellTrait.call(this);
  }
  protoOf(btbProgramBuilders$$inlined$editor$7$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.ese_1(this.fse_1, this.gse_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_2(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_36($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new btbProgramBuilders$$inlined$editor$7$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_2(s) {
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.wb2();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_5($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_2);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_6($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_2($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_5($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_6($refCompletion));
      return Unit_instance;
    };
  }
  function btbProgramBuilders$$inlined$editor$7$1$3$1($cellBuilder, $refCompletion) {
    this.ise_1 = $refCompletion;
    this.hse_1 = $cellBuilder;
  }
  protoOf(btbProgramBuilders$$inlined$editor$7$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_2(property, this.ise_1));
  };
  protoOf(btbProgramBuilders$$inlined$editor$7$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(btbProgramBuilders$$inlined$editor$7$1$3$1).gpe = function () {
    return this.hse_1.gpe();
  };
  protoOf(btbProgramBuilders$$inlined$editor$7$1$3$1).qsd = function (child) {
    this.hse_1.xpd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$7$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$7$1$3$1).rsd = function (init) {
    this.hse_1.ypd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$7$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$7$1$3$1).ssd = function (init) {
    this.hse_1.zpd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$7$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$7$1$3$1).tsd = function (source, cellMap, context) {
    return this.hse_1.bpe(source, cellMap, context);
  };
  protoOf(btbProgramBuilders$$inlined$editor$7$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_3(it) {
    return it.b3();
  }
  function btbProgramBuilders$lambda$lambda$lambda_37($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new btbProgramBuilders$$inlined$editor$7$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<constant>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_38() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_39(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_40($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_41($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.wb2();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_42($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.wb2();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_43($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.wb2();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_5($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(EnumValue_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda_5);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_6($this$rootIndent) {
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var role = btbProgramBuilders$lambda$lambda$lambda_44;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$rootIndent.gpe();
    var sourceType = getKClass(VariableReferenceValue_1);
    var tmp$ret$0 = this_0.ypf(sourceType);
    indentChild($this$rootIndent, role, tmp$ret$0, null, null);
    indentLabel($this$rootIndent, '.');
    indent($this$rootIndent, VOID, btbProgramBuilders$lambda$lambda$lambda_45);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_44(it) {
    return it.obr();
  }
  function btbProgramBuilders$lambda$lambda$lambda_45($this$indent) {
    var tmp1 = btbProgramBuilders$lambda$lambda$lambda$lambda_4;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = btbProgramBuilders$lambda$lambda$lambda$lambda_5;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$indent.gpe();
    var sourceType = getKClass(PartReferenceOperation);
    var tmp$ret$0 = this_0.ypf(sourceType);
    indentChild($this$indent, tmp1, tmp$ret$0, null, init);
    addTraitOnAttach($this$indent, btbProgramBuilders$lambda$lambda$lambda$lambda_6);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_4(it) {
    return it.u3l();
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_5($this$indentChild) {
    $this$indentChild.nph(btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_0);
    defaultItem($this$indentChild, btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_1);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_0($this$completion) {
    return partReferenceOperationCompletion($this$completion);
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_1($this$defaultItem) {
    return ExtensionFieldReference($this$defaultItem.o71());
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_6($this$addTraitOnAttach, source, _unused_var__etf5q3, cellFinder) {
    return getDeleteTransformTrait(source, cellFinder);
  }
  function btbProgramBuilders$lambda_6($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(PartValue));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda_6);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_7($this$rootIndent) {
    var tmp1 = '<function>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_197().zb9_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_46(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_47(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(FunctionDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_48(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_49);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_50;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp1, btbProgramBuilders$lambda$lambda$lambda_51(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(btbProgramBuilders$lambda$lambda$lambda_52);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_53);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_54);
    indentLabel($this$rootIndent, '(');
    var tmp10 = btbProgramBuilders$lambda$lambda$lambda_55;
    var tmp11 = '<parameters>';
    var tmp12 = btbProgramBuilders$lambda$lambda$lambda_56;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
    var init = btbProgramBuilders$lambda$lambda$lambda_57;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_2 = $this$rootIndent.gpe();
    var sourceType = getKClass(BindingValuePlaceholder_1);
    var tmp$ret$3 = this_2.ypf(sourceType);
    indentChildren($this$rootIndent, tmp10, tmp$ret$3, tmp11, tmp12, init);
    indentLabel($this$rootIndent, ')');
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_46($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.rba();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_3($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function btbProgramBuilders$$inlined$editor$9$1$2$1($refCompletion, $this, $source) {
    this.jse_1 = $refCompletion;
    this.kse_1 = $this;
    this.lse_1 = $source;
    CellTrait.call(this);
  }
  protoOf(btbProgramBuilders$$inlined$editor$9$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.jse_1(this.kse_1, this.lse_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_3(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_47($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new btbProgramBuilders$$inlined$editor$9$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_3(s) {
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.rba();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_7($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_8($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_3($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_7($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_8($refCompletion));
      return Unit_instance;
    };
  }
  function btbProgramBuilders$$inlined$editor$9$1$3$1($cellBuilder, $refCompletion) {
    this.nse_1 = $refCompletion;
    this.mse_1 = $cellBuilder;
  }
  protoOf(btbProgramBuilders$$inlined$editor$9$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_3(property, this.nse_1));
  };
  protoOf(btbProgramBuilders$$inlined$editor$9$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(btbProgramBuilders$$inlined$editor$9$1$3$1).gpe = function () {
    return this.mse_1.gpe();
  };
  protoOf(btbProgramBuilders$$inlined$editor$9$1$3$1).qsd = function (child) {
    this.mse_1.xpd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$9$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$9$1$3$1).rsd = function (init) {
    this.mse_1.ypd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$9$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$9$1$3$1).ssd = function (init) {
    this.mse_1.zpd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$9$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$9$1$3$1).tsd = function (source, cellMap, context) {
    return this.mse_1.bpe(source, cellMap, context);
  };
  protoOf(btbProgramBuilders$$inlined$editor$9$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_7(it) {
    return it.b3();
  }
  function btbProgramBuilders$lambda$lambda$lambda_48($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new btbProgramBuilders$$inlined$editor$9$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<function>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda_7);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_49() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_50(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_51($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_52($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.rba();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_53($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.rba();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_54($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.rba();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_55(it) {
    return it.tba();
  }
  function btbProgramBuilders$lambda$lambda$lambda_56(it) {
    return CellLists_instance.bmy(it, ', ');
  }
  function btbProgramBuilders$lambda$lambda$lambda_57($this$indentChildren) {
    $this$indentChildren.nph(btbProgramBuilders$lambda$lambda$lambda$lambda_8);
    $this$indentChildren.jpg(btbProgramBuilders$lambda$lambda$lambda$lambda_9);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_8($this$completion) {
    return bindingValueCompletion($this$completion);
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_9($this$default) {
    var tmp = Companion_instance_316;
    return tmp.nnd(btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_2($this$default));
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_2($this_default) {
    return function () {
      return BindingValuePlaceholder($this_default.o71());
    };
  }
  function btbProgramBuilders$lambda_7($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FunctionTerm_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda_7);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_58(it) {
    return it.b3();
  }
  function btbProgramBuilders$lambda$lambda$lambda_59(it) {
    return it.nb7();
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_3(it) {
    return it.ybc();
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_10($this_btbProgramBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
      // Inline function 'kotlin.also' call
      var this_0 = get_variableDeclarationRole($this_btbProgramBuilders).o30();
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.ppn('<variables>');
      this_0.spn();
      var tmp = this_0;
      children_1($this$indent, tmp, btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_4(it) {
    return it.fb6();
  }
  function btbProgramBuilders$lambda$lambda$lambda$lambda_11($this_btbProgramBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      var tmp = get_factRole($this_btbProgramBuilders);
      children_1($this$indent, tmp, btbProgramBuilders$lambda$lambda$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_60($this_btbProgramBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      keyword($this$indent, 'variables:');
      indent($this$indent, true, btbProgramBuilders$lambda$lambda$lambda$lambda_10($this_btbProgramBuilders));
      newLine($this$indent);
      keyword($this$indent, 'facts:');
      indent($this$indent, true, btbProgramBuilders$lambda$lambda$lambda$lambda_11($this_btbProgramBuilders));
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda_8($this_btbProgramBuilders) {
    return function ($this$rootIndent) {
      textProperty($this$rootIndent, '<name>', btbProgramBuilders$lambda$lambda$lambda_58);
      newLine($this$rootIndent);
      keyword($this$rootIndent, 'with');
      indentLabel($this$rootIndent, '(');
      var tmp = get_contextRole($this_btbProgramBuilders);
      child_0($this$rootIndent, tmp, btbProgramBuilders$lambda$lambda$lambda_59);
      indentLabel($this$rootIndent, ')', true);
      indent($this$rootIndent, true, btbProgramBuilders$lambda$lambda$lambda_60($this_btbProgramBuilders));
      newLine($this$rootIndent);
      label($this$rootIndent, '_');
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_8($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FactSet_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda_8($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_9($this$rootIndent) {
    var tmp1 = '<library>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_206().tc0_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_61(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_62(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(OntologyLibrary_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_63(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_64);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_65;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp1, btbProgramBuilders$lambda$lambda$lambda_66(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(btbProgramBuilders$lambda$lambda$lambda_67);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_68);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_69);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_61($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.ub6();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_4($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function btbProgramBuilders$$inlined$editor$11$1$2$1($refCompletion, $this, $source) {
    this.ose_1 = $refCompletion;
    this.pse_1 = $this;
    this.qse_1 = $source;
    CellTrait.call(this);
  }
  protoOf(btbProgramBuilders$$inlined$editor$11$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.ose_1(this.pse_1, this.qse_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_4(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_62($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new btbProgramBuilders$$inlined$editor$11$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_4(s) {
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.ub6();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_9($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_10($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_4($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_9($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_10($refCompletion));
      return Unit_instance;
    };
  }
  function btbProgramBuilders$$inlined$editor$11$1$3$1($cellBuilder, $refCompletion) {
    this.sse_1 = $refCompletion;
    this.rse_1 = $cellBuilder;
  }
  protoOf(btbProgramBuilders$$inlined$editor$11$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_4(property, this.sse_1));
  };
  protoOf(btbProgramBuilders$$inlined$editor$11$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(btbProgramBuilders$$inlined$editor$11$1$3$1).gpe = function () {
    return this.rse_1.gpe();
  };
  protoOf(btbProgramBuilders$$inlined$editor$11$1$3$1).qsd = function (child) {
    this.rse_1.xpd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$11$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$11$1$3$1).rsd = function (init) {
    this.rse_1.ypd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$11$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$11$1$3$1).ssd = function (init) {
    this.rse_1.zpd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$11$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$11$1$3$1).tsd = function (source, cellMap, context) {
    return this.rse_1.bpe(source, cellMap, context);
  };
  protoOf(btbProgramBuilders$$inlined$editor$11$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_12(it) {
    return it.b3();
  }
  function btbProgramBuilders$lambda$lambda$lambda_63($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new btbProgramBuilders$$inlined$editor$11$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<library>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda_12);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_64() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_65(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_66($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_67($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.ub6();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_68($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.ub6();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_69($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.ub6();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_9($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyLibraryReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda_9);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_10($this$rootIndent) {
    var tmp1 = '<element>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_205().rbv_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_70(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_71(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(OntologyElement_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_72(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_73);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_74;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp1, btbProgramBuilders$lambda$lambda$lambda_75(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(btbProgramBuilders$lambda$lambda$lambda_76);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_77);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_78);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_70($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.lay();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_5($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function btbProgramBuilders$$inlined$editor$12$1$2$1($refCompletion, $this, $source) {
    this.tse_1 = $refCompletion;
    this.use_1 = $this;
    this.vse_1 = $source;
    CellTrait.call(this);
  }
  protoOf(btbProgramBuilders$$inlined$editor$12$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.tse_1(this.use_1, this.vse_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_5(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_71($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new btbProgramBuilders$$inlined$editor$12$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_5(s) {
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.lay();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_11($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_5);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_12($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_5($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_11($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_12($refCompletion));
      return Unit_instance;
    };
  }
  function btbProgramBuilders$$inlined$editor$12$1$3$1($cellBuilder, $refCompletion) {
    this.xse_1 = $refCompletion;
    this.wse_1 = $cellBuilder;
  }
  protoOf(btbProgramBuilders$$inlined$editor$12$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_5(property, this.xse_1));
  };
  protoOf(btbProgramBuilders$$inlined$editor$12$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(btbProgramBuilders$$inlined$editor$12$1$3$1).gpe = function () {
    return this.wse_1.gpe();
  };
  protoOf(btbProgramBuilders$$inlined$editor$12$1$3$1).qsd = function (child) {
    this.wse_1.xpd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$12$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$12$1$3$1).rsd = function (init) {
    this.wse_1.ypd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$12$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$12$1$3$1).ssd = function (init) {
    this.wse_1.zpd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$12$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$12$1$3$1).tsd = function (source, cellMap, context) {
    return this.wse_1.bpe(source, cellMap, context);
  };
  protoOf(btbProgramBuilders$$inlined$editor$12$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_13(it) {
    return it.b3();
  }
  function btbProgramBuilders$lambda$lambda$lambda_72($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new btbProgramBuilders$$inlined$editor$12$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<element>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda_13);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_73() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_74(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_75($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_76($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.lay();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_77($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.lay();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_78($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.lay();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_10($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyElementReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda_10);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda_11($this$rootIndent) {
    var tmp1 = '<element>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_207().tbi_1;
    var refCompletion = btbProgramBuilders$lambda$lambda$lambda_79(referenceTag);
    var completionTrait = btbProgramBuilders$lambda$lambda$lambda_80(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(OntologyElement_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, btbProgramBuilders$lambda$lambda$lambda_81(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', btbProgramBuilders$lambda$lambda$lambda_82);
    var tmp = btbProgramBuilders$lambda$lambda$lambda_83;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp1, btbProgramBuilders$lambda$lambda$lambda_84(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(btbProgramBuilders$lambda$lambda$lambda_85);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_86);
    this_1.zpd(btbProgramBuilders$lambda$lambda$lambda_87);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_79($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.lay();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_6($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function btbProgramBuilders$$inlined$editor$13$1$2$1($refCompletion, $this, $source) {
    this.yse_1 = $refCompletion;
    this.zse_1 = $this;
    this.asf_1 = $source;
    CellTrait.call(this);
  }
  protoOf(btbProgramBuilders$$inlined$editor$13$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.yse_1(this.zse_1, this.asf_1, cell, btbProgramBuilders$lambda$lambda$lambda$o$get$lambda_6(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function btbProgramBuilders$lambda$lambda$lambda_80($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new btbProgramBuilders$$inlined$editor$13$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_6(s) {
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.lay();
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_13($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(LocalReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_6);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_14($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_6($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_13($property));
      completion_1($this$editableText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_14($refCompletion));
      return Unit_instance;
    };
  }
  function btbProgramBuilders$$inlined$editor$13$1$3$1($cellBuilder, $refCompletion) {
    this.csf_1 = $refCompletion;
    this.bsf_1 = $cellBuilder;
  }
  protoOf(btbProgramBuilders$$inlined$editor$13$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, btbProgramBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_6(property, this.csf_1));
  };
  protoOf(btbProgramBuilders$$inlined$editor$13$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(btbProgramBuilders$$inlined$editor$13$1$3$1).gpe = function () {
    return this.bsf_1.gpe();
  };
  protoOf(btbProgramBuilders$$inlined$editor$13$1$3$1).qsd = function (child) {
    this.bsf_1.xpd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$13$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(btbProgramBuilders$$inlined$editor$13$1$3$1).rsd = function (init) {
    this.bsf_1.ypd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$13$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$13$1$3$1).ssd = function (init) {
    this.bsf_1.zpd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$13$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(btbProgramBuilders$$inlined$editor$13$1$3$1).tsd = function (source, cellMap, context) {
    return this.bsf_1.bpe(source, cellMap, context);
  };
  protoOf(btbProgramBuilders$$inlined$editor$13$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function btbProgramBuilders$lambda$lambda$lambda$lambda_14(it) {
    return it.b3();
  }
  function btbProgramBuilders$lambda$lambda$lambda_81($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new btbProgramBuilders$$inlined$editor$13$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<element>', VOID, btbProgramBuilders$lambda$lambda$lambda$lambda_14);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_82() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function btbProgramBuilders$lambda$lambda$lambda_83(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function btbProgramBuilders$lambda$lambda$lambda_84($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_85($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.lay();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_86($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.lay();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function btbProgramBuilders$lambda$lambda$lambda_87($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.lay();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function btbProgramBuilders$lambda_11($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(LocalOntologyElementReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda_11);
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_88(it) {
    return it.lcj();
  }
  function btbProgramBuilders$lambda$lambda$lambda_89(it) {
    return it.mcj();
  }
  function btbProgramBuilders$lambda$lambda_12($this_btbProgramBuilders) {
    return function ($this$indent) {
      var tmp = get_ontologyLibraryReferenceRole($this_btbProgramBuilders);
      child_0($this$indent, tmp, btbProgramBuilders$lambda$lambda$lambda_88);
      indentLabel($this$indent, '/');
      var tmp_0 = get_ontologyElementReferenceRole($this_btbProgramBuilders);
      child_0($this$indent, tmp_0, btbProgramBuilders$lambda$lambda$lambda_89);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_12($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(QualifiedOntologyElementReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      indent(result, VOID, btbProgramBuilders$lambda$lambda_12($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_90(it) {
    return it.kay();
  }
  function btbProgramBuilders$lambda$lambda$lambda_91(it) {
    return it.lay();
  }
  function btbProgramBuilders$lambda$lambda_13($this_btbProgramBuilders) {
    return function ($this$indent) {
      var tmp = get_ontologyLibraryReferenceRole($this_btbProgramBuilders);
      child_0($this$indent, tmp, btbProgramBuilders$lambda$lambda$lambda_90);
      label($this$indent, '/');
      var tmp_0 = get_ontologyElementReferenceRole($this_btbProgramBuilders);
      child_0($this$indent, tmp_0, btbProgramBuilders$lambda$lambda$lambda_91);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_13($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyElementReferenceValueLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      indent(result, VOID, btbProgramBuilders$lambda$lambda_13($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_92(it) {
    return it.lay();
  }
  function btbProgramBuilders$lambda$lambda_14($this_btbProgramBuilders) {
    return function ($this$indent) {
      var tmp = get_ontologyElementReferenceRole($this_btbProgramBuilders);
      child_0($this$indent, tmp, btbProgramBuilders$lambda$lambda$lambda_92);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_14($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyElementReferenceValue_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      indent(result, VOID, btbProgramBuilders$lambda$lambda_14($this_btbProgramBuilders));
      return this_0;
    };
  }
  function btbProgramBuilders$lambda$lambda$lambda_93(it) {
    return it.b3();
  }
  function btbProgramBuilders$lambda$lambda$lambda_94(it) {
    return it.jcq();
  }
  function btbProgramBuilders$lambda$lambda_15($this_btbProgramBuilders) {
    return function ($this$rootIndent) {
      textProperty($this$rootIndent, '<no name>', btbProgramBuilders$lambda$lambda$lambda_93);
      space($this$rootIndent);
      label($this$rootIndent, ':');
      space($this$rootIndent);
      var tmp = get_typeRole($this_btbProgramBuilders);
      child_0($this$rootIndent, tmp, btbProgramBuilders$lambda$lambda$lambda_94);
      return Unit_instance;
    };
  }
  function btbProgramBuilders$lambda_15($this, $this_btbProgramBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(VariableDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.btbProgramBuilders.<anonymous>' call
      rootIndent(result, btbProgramBuilders$lambda$lambda_15($this_btbProgramBuilders));
      return this_0;
    };
  }
  function _get_category_$lambda_8otj26($this$default) {
    return Category($this$default.o71());
  }
  function _get_category_$lambda_8otj26_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_imports_$lambda_vd27mw($this$default) {
    return OntologyImportRootReference($this$default.o71());
  }
  function _get_imports_$lambda_vd27mw_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_factSetRole_$lambda_yaiexy($this$default) {
    return FactSet($this$default.o71());
  }
  function _get_factSetRole_$lambda_yaiexy_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_ontologyLibraryReferenceRole_$lambda_x2j4ob($this$default) {
    return OntologyLibraryReference($this$default.o71());
  }
  function _get_ontologyLibraryReferenceRole_$lambda_x2j4ob_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_ontologyElementReferenceRole_$lambda_f29iic($this$default) {
    return OntologyElementReference($this$default.o71());
  }
  function _get_ontologyElementReferenceRole_$lambda_f29iic_0($this$completion) {
    var tmp = nodeRefCompletion($this$completion, Companion_getInstance_205().rbv_1);
    return map_2(tmp, _get_ontologyElementReferenceRole_$lambda$lambda_saqyd3($this$completion));
  }
  function _get_ontologyElementReferenceRole_$lambda$lambda_saqyd3($this_completion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReference($this_completion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.<get-ontologyElementReferenceRole>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.lay().v2c(it);
      return this_0;
    };
  }
  function _get_ontologyElementReferenceRole_$lambda_f29iic_1($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_contextRole_$lambda_qaiv3z($this$default) {
    return Context($this$default.o71());
  }
  function _get_contextRole_$lambda_qaiv3z_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_variableDeclarationRole_$lambda_d4qi0e($this$default) {
    return VariableDeclaration($this$default.o71());
  }
  function _get_variableDeclarationRole_$lambda_d4qi0e_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_factRole_$lambda_e22khq($this$default) {
    return Fact($this$default.o71());
  }
  function _get_factRole_$lambda_e22khq_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function extensionLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(extensionLibraryBuilders$lambda(_this__u8e3s4));
    _this__u8e3s4.wpf(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(extensionLibraryBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(extensionLibraryBuilders$lambda_1(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_1);
  }
  function extensionFieldReferenceCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_196().ab4_1);
    return map_2(tmp, extensionFieldReferenceCompletion$lambda(_this__u8e3s4));
  }
  function extensionLibraryBuilders$lambda$lambda(it) {
    return it.n9c();
  }
  function extensionLibraryBuilders$lambda$lambda_0(it) {
    return CellLists_instance.cmy(it);
  }
  function extensionLibraryBuilders$lambda$lambda_1($this$indentChildren) {
    defaultItem($this$indentChildren, extensionLibraryBuilders$lambda$lambda$lambda);
    return Unit_instance;
  }
  function extensionLibraryBuilders$lambda$lambda$lambda($this$defaultItem) {
    return ExtensionDeclaration($this$defaultItem.o71());
  }
  function extensionLibraryBuilders$lambda($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ExtensionLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.extensionLibraryBuilders.<anonymous>' call
      var tmp1 = extensionLibraryBuilders$lambda$lambda;
      var tmp2 = extensionLibraryBuilders$lambda$lambda_0;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
      var init = extensionLibraryBuilders$lambda$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.gpe();
      var sourceType = getKClass(ExtensionDeclaration_1);
      var tmp$ret$0 = this_1.ypf(sourceType);
      indentChildren(result, tmp1, tmp$ret$0, null, tmp2, init);
      return this_0;
    };
  }
  function extensionLibraryBuilders$lambda$lambda$lambda_0(it) {
    return it.b3();
  }
  function extensionLibraryBuilders$lambda$lambda$lambda_1(it) {
    return it.zb3();
  }
  function extensionLibraryBuilders$lambda$lambda$lambda_2($this$indent) {
    newLine($this$indent);
    var tmp1 = extensionLibraryBuilders$lambda$lambda$lambda$lambda;
    var tmp2 = '<fields>';
    var tmp3 = extensionLibraryBuilders$lambda$lambda$lambda$lambda_0;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
    var init = extensionLibraryBuilders$lambda$lambda$lambda$lambda_1;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$indent.gpe();
    var sourceType = getKClass(FieldDeclaration_1);
    var tmp$ret$0 = this_0.ypf(sourceType);
    indentChildren($this$indent, tmp1, tmp$ret$0, tmp2, tmp3, init);
    return Unit_instance;
  }
  function extensionLibraryBuilders$lambda$lambda$lambda$lambda(it) {
    return it.yb3();
  }
  function extensionLibraryBuilders$lambda$lambda$lambda$lambda_0(it) {
    return CellLists_instance.cmy(it);
  }
  function extensionLibraryBuilders$lambda$lambda$lambda$lambda_1($this$indentChildren) {
    defaultItem($this$indentChildren, extensionLibraryBuilders$lambda$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function extensionLibraryBuilders$lambda$lambda$lambda$lambda$lambda($this$defaultItem) {
    return FieldDeclaration($this$defaultItem.o71());
  }
  function extensionLibraryBuilders$lambda$lambda_2($this_extensionLibraryBuilders) {
    return function ($this$rootIndent) {
      keyword($this$rootIndent, 'extension');
      space($this$rootIndent);
      textProperty($this$rootIndent, '<name>', extensionLibraryBuilders$lambda$lambda$lambda_0);
      space($this$rootIndent);
      keyword($this$rootIndent, 'for');
      space($this$rootIndent);
      var tmp = get_ontologyElementTypeRole($this_extensionLibraryBuilders);
      child_0($this$rootIndent, tmp, extensionLibraryBuilders$lambda$lambda$lambda_1);
      indent($this$rootIndent, true, extensionLibraryBuilders$lambda$lambda$lambda_2);
      return Unit_instance;
    };
  }
  function extensionLibraryBuilders$lambda_0($this, $this_extensionLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ExtensionDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.extensionLibraryBuilders.<anonymous>' call
      rootIndent(result, extensionLibraryBuilders$lambda$lambda_2($this_extensionLibraryBuilders));
      return this_0;
    };
  }
  function extensionLibraryBuilders$lambda$lambda$lambda_3(it) {
    return it.b3();
  }
  function extensionLibraryBuilders$lambda$lambda$lambda_4(it) {
    return it.zb3();
  }
  function extensionLibraryBuilders$lambda$lambda$lambda_5(it) {
    return it.eb8();
  }
  function extensionLibraryBuilders$lambda$lambda_3($this_extensionLibraryBuilders) {
    return function ($this$rootIndent) {
      textProperty($this$rootIndent, '<name>', extensionLibraryBuilders$lambda$lambda$lambda_3);
      indentLabel($this$rootIndent, ':', true);
      space($this$rootIndent);
      var tmp = get_ontologyElementTypeRole($this_extensionLibraryBuilders);
      child_0($this$rootIndent, tmp, extensionLibraryBuilders$lambda$lambda$lambda_4);
      space($this$rootIndent);
      var tmp_0 = get_cardinality($this_extensionLibraryBuilders);
      child_0($this$rootIndent, tmp_0, extensionLibraryBuilders$lambda$lambda$lambda_5);
      return Unit_instance;
    };
  }
  function extensionLibraryBuilders$lambda_1($this, $this_extensionLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FieldDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.extensionLibraryBuilders.<anonymous>' call
      rootIndent(result, extensionLibraryBuilders$lambda$lambda_3($this_extensionLibraryBuilders));
      return this_0;
    };
  }
  function extensionFieldReferenceCompletion$lambda($this_extensionFieldReferenceCompletion) {
    return function (it) {
      return ExtensionFieldReference_2($this_extensionFieldReferenceCompletion.o71(), it);
    };
  }
  function factBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(factBuilders$lambda(_this__u8e3s4));
    _this__u8e3s4.wpf(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(factBuilders$lambda_0(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(factBuilders$lambda_1(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(factBuilders$lambda_2(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_2);
  }
  function get_preconditionCompletion(_this__u8e3s4) {
    return plus_12(get_constantPreconditionCompletion(_this__u8e3s4), get_factsPreconditionCompletion(_this__u8e3s4));
  }
  function processSpecificationCompletion(_this__u8e3s4) {
    return libraryProcessSpecification(_this__u8e3s4);
  }
  function get_factRefRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(FactReference_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-factRefRole>.<anonymous>' call
    builder.opn(_get_factRefRole_$lambda_69fbh3);
    builder.qpn(_get_factRefRole_$lambda_69fbh3_0);
    var simpleClassName = ensureNotNull(getKClass(FactReference_1).lb());
    builder.tpn(simpleClassName, _get_factRefRole_$lambda_69fbh3_1);
    return builder;
  }
  function get_factsPreconditionCompletion(_this__u8e3s4) {
    var tmp = get_factReferenceCompletion(_this__u8e3s4);
    return map_2(tmp, _get_factsPreconditionCompletion_$lambda_dmc8zv(_this__u8e3s4));
  }
  function get_constantPreconditionCompletion(_this__u8e3s4) {
    var tmp = produces('ALWAYS', _get_constantPreconditionCompletion_$lambda_vvyei0(_this__u8e3s4));
    return simpleCompletion(listOf_0([tmp, produces('NEVER', _get_constantPreconditionCompletion_$lambda_vvyei0_0(_this__u8e3s4))]));
  }
  function libraryProcessSpecification(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_208().kc6_1);
    return map_2(tmp, libraryProcessSpecification$lambda(_this__u8e3s4));
  }
  function get_factReferenceCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_188().hb6_1);
    return map_2(tmp, _get_factReferenceCompletion_$lambda_zifg0b(_this__u8e3s4));
  }
  function factBuilders$lambda$lambda($this$rootIndent) {
    var tmp1 = factBuilders$lambda$lambda$lambda;
    var tmp2 = '<precondition>';
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = factBuilders$lambda$lambda$lambda_0;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$rootIndent.gpe();
    var sourceType = getKClass(Precondition);
    var tmp$ret$0 = this_0.ypf(sourceType);
    indentChild($this$rootIndent, tmp1, tmp$ret$0, tmp2, init);
    space($this$rootIndent);
    textProperty($this$rootIndent, '<no name>', factBuilders$lambda$lambda$lambda_1);
    space($this$rootIndent);
    var tmp5 = factBuilders$lambda$lambda$lambda_2;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init_0 = factBuilders$lambda$lambda$lambda_3;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_1 = $this$rootIndent.gpe();
    var sourceType_0 = getKClass(AbstractProcessSpecification);
    var tmp$ret$2 = this_1.ypf(sourceType_0);
    indentChild($this$rootIndent, tmp5, tmp$ret$2, '<spec>', init_0);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda(it) {
    return it.ob5();
  }
  function factBuilders$lambda$lambda$lambda_0($this$indentChild) {
    defaultItem($this$indentChild, factBuilders$lambda$lambda$lambda$lambda);
    $this$indentChild.nph(factBuilders$lambda$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda$lambda($this$defaultItem) {
    return ConstantPrecondition_1($this$defaultItem.o71(), When_ALWAYS_getInstance());
  }
  function factBuilders$lambda$lambda$lambda$lambda_0($this$completion) {
    return get_preconditionCompletion($this$completion);
  }
  function factBuilders$lambda$lambda$lambda_1(it) {
    return it.b3();
  }
  function factBuilders$lambda$lambda$lambda_2(it) {
    return it.pb5();
  }
  function factBuilders$lambda$lambda$lambda_3($this$indentChild) {
    $this$indentChild.nph(factBuilders$lambda$lambda$lambda$lambda_1);
    defaultItem($this$indentChild, factBuilders$lambda$lambda$lambda$lambda_2);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda$lambda_1($this$completion) {
    return processSpecificationCompletion($this$completion);
  }
  function factBuilders$lambda$lambda$lambda$lambda_2($this$defaultItem) {
    return LibraryProcessSpecification($this$defaultItem.o71());
  }
  function factBuilders$lambda($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(Fact_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>' call
      rootIndent(result, factBuilders$lambda$lambda);
      return this_0;
    };
  }
  function factBuilders$lambda$lambda_0($this$rootIndent) {
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_188().hb6_1;
    var refCompletion = factBuilders$lambda$lambda$lambda_4(referenceTag);
    var completionTrait = factBuilders$lambda$lambda$lambda_5(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(Fact_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, factBuilders$lambda$lambda$lambda_6(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', factBuilders$lambda$lambda$lambda_7);
    var tmp = factBuilders$lambda$lambda$lambda_8;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<fact>', factBuilders$lambda$lambda$lambda_9(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(factBuilders$lambda$lambda$lambda_10);
    this_1.zpd(factBuilders$lambda$lambda$lambda_11);
    this_1.zpd(factBuilders$lambda$lambda$lambda_12);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda_4($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.ub6();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function factBuilders$lambda$lambda$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function factBuilders$$inlined$editor$2$1$2$1($refCompletion, $this, $source) {
    this.dsf_1 = $refCompletion;
    this.esf_1 = $this;
    this.fsf_1 = $source;
    CellTrait.call(this);
  }
  protoOf(factBuilders$$inlined$editor$2$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.dsf_1(this.esf_1, this.fsf_1, cell, factBuilders$lambda$lambda$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function factBuilders$lambda$lambda$lambda_5($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new factBuilders$$inlined$editor$2$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda(s) {
    // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.ub6();
  }
  function factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(LocalReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property));
      completion_1($this$editableText, factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion));
      return Unit_instance;
    };
  }
  function factBuilders$$inlined$editor$2$1$3$1($cellBuilder, $refCompletion) {
    this.hsf_1 = $refCompletion;
    this.gsf_1 = $cellBuilder;
  }
  protoOf(factBuilders$$inlined$editor$2$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, factBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda(property, this.hsf_1));
  };
  protoOf(factBuilders$$inlined$editor$2$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(factBuilders$$inlined$editor$2$1$3$1).gpe = function () {
    return this.gsf_1.gpe();
  };
  protoOf(factBuilders$$inlined$editor$2$1$3$1).qsd = function (child) {
    this.gsf_1.xpd(child);
  };
  protoOf(factBuilders$$inlined$editor$2$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(factBuilders$$inlined$editor$2$1$3$1).rsd = function (init) {
    this.gsf_1.ypd(init);
  };
  protoOf(factBuilders$$inlined$editor$2$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(factBuilders$$inlined$editor$2$1$3$1).ssd = function (init) {
    this.gsf_1.zpd(init);
  };
  protoOf(factBuilders$$inlined$editor$2$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(factBuilders$$inlined$editor$2$1$3$1).tsd = function (source, cellMap, context) {
    return this.gsf_1.bpe(source, cellMap, context);
  };
  protoOf(factBuilders$$inlined$editor$2$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function factBuilders$lambda$lambda$lambda$lambda_3(it) {
    return it.b3();
  }
  function factBuilders$lambda$lambda$lambda_6($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new factBuilders$$inlined$editor$2$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<factRef>', VOID, factBuilders$lambda$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function factBuilders$lambda$lambda$lambda_7() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function factBuilders$lambda$lambda$lambda_8(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function factBuilders$lambda$lambda$lambda_9($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function factBuilders$lambda$lambda$lambda_10($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.ub6();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda_11($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.ub6();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda_12($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.ub6();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function factBuilders$lambda_0($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FactReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>' call
      rootIndent(result, factBuilders$lambda$lambda_0);
      return this_0;
    };
  }
  function factBuilders$lambda$lambda_1($this$rootIndent) {
    // Inline function 'jetbrains.ocelot.langDef.editor.enumProperty' call
    var placeholder = '<no kind>';
    editableText($this$rootIndent, VOID, VOID, placeholder, factBuilders$lambda$lambda$lambda_13);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda_13($this$editableText) {
    // Inline function 'jetbrains.ocelot.langDef.editor.enumSyncTwoWay' call
    var targetPropFactory = factBuilders$lambda$lambda$lambda$lambda_4;
    // Inline function 'jetbrains.ocelot.langDef.editor.textCellSyncTwoWay' call
    $this$editableText.ypd(factBuilders$lambda$lambda$lambda$lambda_5(targetPropFactory));
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda$lambda_4(textCell) {
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_9();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.en4(textCell, enumInfo);
  }
  function factBuilders$lambda$lambda$lambda$lambda_5($targetPropFactory) {
    return function ($this$setup, source, textCell) {
      // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var sourceProp = source.r5e();
      var targetProp = $targetPropFactory(textCell);
      $this$setup.wle(syncTwoWay(sourceProp.n4z(), targetProp));
      return Unit_instance;
    };
  }
  function factBuilders$lambda_1($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ConstantPrecondition_0));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>' call
      rootIndent(result, factBuilders$lambda$lambda_1);
      return this_0;
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda_6(it) {
    return it.fb6();
  }
  function factBuilders$lambda$lambda$lambda$lambda_7($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.gb6();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function factBuilders$$inlined$editor$4$1$1$3$1($refCompletion, $this, $source) {
    this.isf_1 = $refCompletion;
    this.jsf_1 = $this;
    this.ksf_1 = $source;
    CellTrait.call(this);
  }
  protoOf(factBuilders$$inlined$editor$4$1$1$3$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.isf_1(this.jsf_1, this.ksf_1, cell, factBuilders$lambda$lambda$lambda$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function factBuilders$lambda$lambda$lambda$lambda_8($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new factBuilders$$inlined$editor$4$1$1$3$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda(s) {
    // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    return s.gb6();
  }
  function factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property));
      completion_1($this$editableText, factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion));
      return Unit_instance;
    };
  }
  function factBuilders$$inlined$editor$4$1$1$4$1($cellBuilder, $refCompletion) {
    this.msf_1 = $refCompletion;
    this.lsf_1 = $cellBuilder;
  }
  protoOf(factBuilders$$inlined$editor$4$1$1$4$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, factBuilders$lambda$lambda$lambda$lambda$o$referenceTextProperty$lambda(property, this.msf_1));
  };
  protoOf(factBuilders$$inlined$editor$4$1$1$4$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(factBuilders$$inlined$editor$4$1$1$4$1).gpe = function () {
    return this.lsf_1.gpe();
  };
  protoOf(factBuilders$$inlined$editor$4$1$1$4$1).qsd = function (child) {
    this.lsf_1.xpd(child);
  };
  protoOf(factBuilders$$inlined$editor$4$1$1$4$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(factBuilders$$inlined$editor$4$1$1$4$1).rsd = function (init) {
    this.lsf_1.ypd(init);
  };
  protoOf(factBuilders$$inlined$editor$4$1$1$4$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(factBuilders$$inlined$editor$4$1$1$4$1).ssd = function (init) {
    this.lsf_1.zpd(init);
  };
  protoOf(factBuilders$$inlined$editor$4$1$1$4$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(factBuilders$$inlined$editor$4$1$1$4$1).tsd = function (source, cellMap, context) {
    return this.lsf_1.bpe(source, cellMap, context);
  };
  protoOf(factBuilders$$inlined$editor$4$1$1$4$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function factBuilders$lambda$lambda$lambda$lambda$lambda(it) {
    return it.jcc();
  }
  function factBuilders$lambda$lambda$lambda$lambda_9($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new factBuilders$$inlined$editor$4$1$1$4$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<...>', VOID, factBuilders$lambda$lambda$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda_10() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function factBuilders$lambda$lambda$lambda$lambda_11(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function factBuilders$lambda$lambda$lambda$lambda_12($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function factBuilders$lambda$lambda$lambda$lambda_13($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.gb6();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda$lambda_14($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.gb6();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda$lambda_15($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.gb6();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function factBuilders$lambda$lambda$lambda_14($this_factBuilders) {
    return function ($this$indent) {
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
      // Inline function 'kotlin.also' call
      var this_0 = get_factRefRole($this_factBuilders).o30();
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.rpn(' & ');
      var tmp = this_0;
      children_1($this$indent, tmp, factBuilders$lambda$lambda$lambda$lambda_6);
      space($this$indent);
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
      var referenceTag = Companion_getInstance_187().eb6_1;
      var refCompletion = factBuilders$lambda$lambda$lambda$lambda_7(referenceTag);
      var completionTrait = factBuilders$lambda$lambda$lambda$lambda_8(refCompletion);
      // Inline function 'kotlin.also' call
      var this_1 = new SimpleMapperBuilder($this$indent.gpe(), getKClass(ProcessRelationDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_1);
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
      rootIndent(result, factBuilders$lambda$lambda$lambda$lambda_9(refCompletion));
      var mapperBuilder = this_1;
      var tmp0_cellFactory = new NamedCellFactory('referenceData', factBuilders$lambda$lambda$lambda$lambda_10);
      var tmp_0 = factBuilders$lambda$lambda$lambda$lambda_11;
      // Inline function 'kotlin.apply' call
      var this_2 = projectionalChild($this$indent, tmp_0, tmp0_cellFactory, mapperBuilder, '<rel>', factBuilders$lambda$lambda$lambda$lambda_12(completionTrait));
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
      this_2.ypd(factBuilders$lambda$lambda$lambda$lambda_13);
      this_2.zpd(factBuilders$lambda$lambda$lambda$lambda_14);
      this_2.zpd(factBuilders$lambda$lambda$lambda$lambda_15);
      return Unit_instance;
    };
  }
  function factBuilders$lambda$lambda_2($this_factBuilders) {
    return function ($this$rootIndent) {
      indent($this$rootIndent, VOID, factBuilders$lambda$lambda$lambda_14($this_factBuilders));
      return Unit_instance;
    };
  }
  function factBuilders$lambda_2($this, $this_factBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FactPrecondition_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.factBuilders.<anonymous>' call
      rootIndent(result, factBuilders$lambda$lambda_2($this_factBuilders));
      return this_0;
    };
  }
  function _get_factRefRole_$lambda_69fbh3($this$completion) {
    return get_factReferenceCompletion($this$completion);
  }
  function _get_factRefRole_$lambda_69fbh3_0($this$default) {
    return FactReference($this$default.o71());
  }
  function _get_factRefRole_$lambda_69fbh3_1($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_factsPreconditionCompletion_$lambda_dmc8zv($this_factsPreconditionCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = FactPrecondition($this_factsPreconditionCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.<get-factsPreconditionCompletion>.<anonymous>.<anonymous>' call
      this_0.fb6().e(it);
      return this_0;
    };
  }
  function _get_constantPreconditionCompletion_$lambda_vvyei0($this_constantPreconditionCompletion) {
    return function (it) {
      return ConstantPrecondition_1($this_constantPreconditionCompletion.o71(), When_ALWAYS_getInstance());
    };
  }
  function _get_constantPreconditionCompletion_$lambda_vvyei0_0($this_constantPreconditionCompletion) {
    return function (it) {
      return ConstantPrecondition_1($this_constantPreconditionCompletion.o71(), When_NEVER_getInstance());
    };
  }
  function libraryProcessSpecification$lambda($this_libraryProcessSpecification) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = LibraryProcessSpecification($this_libraryProcessSpecification.o71());
      // Inline function 'jetbrains.biokb.lang.builders.libraryProcessSpecification.<anonymous>.<anonymous>' call
      this_0.jbg().v2c(it);
      return this_0;
    };
  }
  function _get_factReferenceCompletion_$lambda_zifg0b($this_factReferenceCompletion) {
    return function (it) {
      return FactReference_2($this_factReferenceCompletion.o71(), it);
    };
  }
  function functionLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(functionLibraryBuilders$lambda(_this__u8e3s4));
    _this__u8e3s4.wpf(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(functionLibraryBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(functionLibraryBuilders$lambda_1(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(functionLibraryBuilders$lambda_2(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_2);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_3 = new LazyMapperBuilder(functionLibraryBuilders$lambda_3(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_3);
  }
  function get_cardinality(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(Cardinality_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-cardinality>.<anonymous>' call
    builder.ppn('<cardinality>');
    builder.qpn(_get_cardinality_$lambda_c4byyw);
    var simpleClassName = ensureNotNull(getKClass(Cardinality_1).lb());
    builder.tpn(simpleClassName, _get_cardinality_$lambda_c4byyw_0);
    return builder;
  }
  function cardinalityConstantCompletion(_this__u8e3s4) {
    var tmp = intRoleCompletion();
    return map_2(tmp, cardinalityConstantCompletion$lambda(_this__u8e3s4));
  }
  function cardinalityBoundCompletion(_this__u8e3s4) {
    return plus_12(cardinalityConstantCompletion(_this__u8e3s4), cardinalityNCompletion(_this__u8e3s4));
  }
  function cardinalityNCompletion(_this__u8e3s4) {
    return simpleCompletion(listOf(produces('n', cardinalityNCompletion$lambda(_this__u8e3s4))));
  }
  function functionTermCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_197().zb9_1);
    return map_2(tmp, functionTermCompletion$lambda(_this__u8e3s4));
  }
  function functionLibraryBuilders$lambda$lambda(it) {
    return it.xb9();
  }
  function functionLibraryBuilders$lambda$lambda_0(it) {
    return CellLists_instance.cmy(it);
  }
  function functionLibraryBuilders$lambda$lambda_1($this$indentChildren) {
    defaultItem($this$indentChildren, functionLibraryBuilders$lambda$lambda$lambda);
    return Unit_instance;
  }
  function functionLibraryBuilders$lambda$lambda$lambda($this$defaultItem) {
    return FunctionDeclaration($this$defaultItem.o71());
  }
  function functionLibraryBuilders$lambda($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FunctionLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.functionLibraryBuilders.<anonymous>' call
      var tmp1 = functionLibraryBuilders$lambda$lambda;
      var tmp2 = functionLibraryBuilders$lambda$lambda_0;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
      var init = functionLibraryBuilders$lambda$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.gpe();
      var sourceType = getKClass(FunctionDeclaration_1);
      var tmp$ret$0 = this_1.ypf(sourceType);
      indentChildren(result, tmp1, tmp$ret$0, null, tmp2, init);
      return this_0;
    };
  }
  function functionLibraryBuilders$lambda$lambda$lambda_0(it) {
    return it.b3();
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda($this$horizontal) {
    bindingEntries($this$horizontal, VOID, functionLibraryBuilders$lambda$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda$lambda(it) {
    return it.w();
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda_0(it) {
    return it.kb9();
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda_1(it) {
    return it.eb8();
  }
  function functionLibraryBuilders$lambda$lambda$lambda_1($this_functionLibraryBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      keyword($this$indent, 'parameters');
      space($this$indent);
      horizontal($this$indent, functionLibraryBuilders$lambda$lambda$lambda$lambda);
      newLine($this$indent);
      keyword($this$indent, 'returns');
      space($this$indent);
      var tmp = get_ontologyElementTypeRole($this_functionLibraryBuilders);
      child_0($this$indent, tmp, functionLibraryBuilders$lambda$lambda$lambda$lambda_0);
      space($this$indent);
      var tmp_0 = get_cardinality($this_functionLibraryBuilders);
      child_0($this$indent, tmp_0, functionLibraryBuilders$lambda$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function functionLibraryBuilders$lambda$lambda_2($this_functionLibraryBuilders) {
    return function ($this$rootIndent) {
      keyword($this$rootIndent, 'function');
      space($this$rootIndent);
      textProperty($this$rootIndent, '<name>', functionLibraryBuilders$lambda$lambda$lambda_0);
      indent($this$rootIndent, true, functionLibraryBuilders$lambda$lambda$lambda_1($this_functionLibraryBuilders));
      return Unit_instance;
    };
  }
  function functionLibraryBuilders$lambda_0($this, $this_functionLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FunctionDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.functionLibraryBuilders.<anonymous>' call
      rootIndent(result, functionLibraryBuilders$lambda$lambda_2($this_functionLibraryBuilders));
      return this_0;
    };
  }
  function functionLibraryBuilders$lambda$lambda_3($this$rootIndent) {
    indentLabel($this$rootIndent, '[');
    var tmp1 = functionLibraryBuilders$lambda$lambda$lambda_2;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = functionLibraryBuilders$lambda$lambda$lambda_3;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$rootIndent.gpe();
    var sourceType = getKClass(CardinalityBoundConstant_1);
    var tmp$ret$0 = this_0.ypf(sourceType);
    indentChild($this$rootIndent, tmp1, tmp$ret$0, '<bound>', init);
    indentLabel($this$rootIndent, '..');
    var tmp5 = functionLibraryBuilders$lambda$lambda$lambda_4;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init_0 = functionLibraryBuilders$lambda$lambda$lambda_5;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_1 = $this$rootIndent.gpe();
    var sourceType_0 = getKClass(CardinalityBoundPlaceholder_1);
    var tmp$ret$2 = this_1.ypf(sourceType_0);
    indentChild($this$rootIndent, tmp5, tmp$ret$2, '<bound>', init_0);
    indentLabel($this$rootIndent, ']', true);
    return Unit_instance;
  }
  function functionLibraryBuilders$lambda$lambda$lambda_2(it) {
    return it.tax();
  }
  function functionLibraryBuilders$lambda$lambda$lambda_3($this$indentChild) {
    $this$indentChild.nph(functionLibraryBuilders$lambda$lambda$lambda$lambda_2);
    return Unit_instance;
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda_2($this$completion) {
    return cardinalityConstantCompletion($this$completion);
  }
  function functionLibraryBuilders$lambda$lambda$lambda_4(it) {
    return it.uax();
  }
  function functionLibraryBuilders$lambda$lambda$lambda_5($this$indentChild) {
    $this$indentChild.nph(functionLibraryBuilders$lambda$lambda$lambda$lambda_3);
    return Unit_instance;
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda_3($this$completion) {
    var tmp = cardinalityBoundCompletion($this$completion);
    return map_2(tmp, functionLibraryBuilders$lambda$lambda$lambda$lambda$lambda_0($this$completion));
  }
  function functionLibraryBuilders$lambda$lambda$lambda$lambda$lambda_0($this_completion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = CardinalityBoundPlaceholder($this_completion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.functionLibraryBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.cax().v2c(it);
      return this_0;
    };
  }
  function functionLibraryBuilders$lambda_1($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(Cardinality_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.functionLibraryBuilders.<anonymous>' call
      rootIndent(result, functionLibraryBuilders$lambda$lambda_3);
      return this_0;
    };
  }
  function functionLibraryBuilders$lambda$lambda_4($this$rootIndent) {
    integerProperty($this$rootIndent, '<...>', functionLibraryBuilders$lambda$lambda$lambda_6);
    return Unit_instance;
  }
  function functionLibraryBuilders$lambda$lambda$lambda_6(it) {
    return it.y();
  }
  function functionLibraryBuilders$lambda_2($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(CardinalityBoundConstant_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.functionLibraryBuilders.<anonymous>' call
      rootIndent(result, functionLibraryBuilders$lambda$lambda_4);
      return this_0;
    };
  }
  function functionLibraryBuilders$lambda_3($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(CardinalityBoundN_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.functionLibraryBuilders.<anonymous>' call
      keyword(result, 'n');
      return this_0;
    };
  }
  function _get_cardinality_$lambda_c4byyw($this$default) {
    return Cardinality($this$default.o71());
  }
  function _get_cardinality_$lambda_c4byyw_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function cardinalityConstantCompletion$lambda($this_cardinalityConstantCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = CardinalityBoundConstant($this_cardinalityConstantCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.cardinalityConstantCompletion.<anonymous>.<anonymous>' call
      this_0.y().v2c(it);
      return this_0;
    };
  }
  function cardinalityNCompletion$lambda($this_cardinalityNCompletion) {
    return function (it) {
      return CardinalityBoundN($this_cardinalityNCompletion.o71());
    };
  }
  function functionTermCompletion$lambda($this_functionTermCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = FunctionTerm($this_functionTermCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.functionTermCompletion.<anonymous>.<anonymous>' call
      this_0.rba().v2c(it);
      return this_0;
    };
  }
  function ontologyImportRootBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(ontologyImportRootBuilders$lambda(_this__u8e3s4));
    _this__u8e3s4.wpf(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(ontologyImportRootBuilders$lambda_0(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_0);
  }
  function ontologyImportRootBuilders$lambda$lambda(it) {
    return it.sau();
  }
  function ontologyImportRootBuilders$lambda$lambda_0(it) {
    return CellLists_instance.cmy(it);
  }
  function ontologyImportRootBuilders$lambda$lambda_1($this$indentChildren) {
    defaultItem($this$indentChildren, ontologyImportRootBuilders$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda($this$defaultItem) {
    return OntologyImport($this$defaultItem.o71());
  }
  function ontologyImportRootBuilders$lambda($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyImportRoot_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.ontologyImportRootBuilders.<anonymous>' call
      var tmp1 = ontologyImportRootBuilders$lambda$lambda;
      var tmp2 = '<imports>';
      var tmp3 = ontologyImportRootBuilders$lambda$lambda_0;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
      var init = ontologyImportRootBuilders$lambda$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.gpe();
      var sourceType = getKClass(OntologyImport_1);
      var tmp$ret$0 = this_1.ypf(sourceType);
      indentChildren(result, tmp1, tmp$ret$0, tmp2, tmp3, init);
      return this_0;
    };
  }
  function ontologyImportRootBuilders$lambda$lambda_2($this$rootIndent) {
    keyword($this$rootIndent, 'for');
    space($this$rootIndent);
    var tmp1 = ontologyImportRootBuilders$lambda$lambda$lambda_0;
    var tmp2 = '<ontology>';
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = ontologyImportRootBuilders$lambda$lambda$lambda_1;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$rootIndent.gpe();
    var sourceType = getKClass(OntologyLibraryReference_1);
    var tmp$ret$0 = this_0.ypf(sourceType);
    indentChild($this$rootIndent, tmp1, tmp$ret$0, tmp2, init);
    indentLabel($this$rootIndent, '/');
    var tmp5 = ontologyImportRootBuilders$lambda$lambda$lambda_2;
    var tmp6 = '<element>';
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init_0 = ontologyImportRootBuilders$lambda$lambda$lambda_3;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_1 = $this$rootIndent.gpe();
    var sourceType_0 = getKClass(OntologyElementReference_1);
    var tmp$ret$2 = this_1.ypf(sourceType_0);
    indentChild($this$rootIndent, tmp5, tmp$ret$2, tmp6, init_0);
    space($this$rootIndent);
    keyword($this$rootIndent, 'use');
    space($this$rootIndent);
    var tmp9 = ontologyImportRootBuilders$lambda$lambda$lambda_4;
    var tmp10 = '<library to use>';
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init_1 = ontologyImportRootBuilders$lambda$lambda$lambda_5;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_2 = $this$rootIndent.gpe();
    var sourceType_1 = getKClass(OntologyLibraryReference_1);
    var tmp$ret$4 = this_2.ypf(sourceType_1);
    indentChild($this$rootIndent, tmp9, tmp$ret$4, tmp10, init_1);
    return Unit_instance;
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda_0(it) {
    return it.sby();
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda_1($this$indentChild) {
    $this$indentChild.nph(ontologyImportRootBuilders$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda$lambda($this$completion) {
    var tmp = nodeRefCompletion($this$completion, Companion_getInstance_206().tc0_1);
    return map_2(tmp, ontologyImportRootBuilders$lambda$lambda$lambda$lambda$lambda($this$completion));
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda$lambda$lambda($this_completion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLibraryReference($this_completion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.ontologyImportRootBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.ub6().v2c(it);
      return this_0;
    };
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda_2(it) {
    return it.lay();
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda_3($this$indentChild) {
    $this$indentChild.nph(ontologyImportRootBuilders$lambda$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda$lambda_0($this$completion) {
    var tmp = nodeRefCompletion($this$completion, Companion_getInstance_205().rbv_1);
    return map_2(tmp, ontologyImportRootBuilders$lambda$lambda$lambda$lambda$lambda_0($this$completion));
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda$lambda$lambda_0($this_completion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReference($this_completion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.ontologyImportRootBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.lay().v2c(it);
      return this_0;
    };
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda_4(it) {
    return it.tby();
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda_5($this$indentChild) {
    $this$indentChild.nph(ontologyImportRootBuilders$lambda$lambda$lambda$lambda_1);
    return Unit_instance;
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda$lambda_1($this$completion) {
    var tmp = nodeRefCompletion($this$completion, Companion_getInstance_206().tc0_1);
    return map_2(tmp, ontologyImportRootBuilders$lambda$lambda$lambda$lambda$lambda_1($this$completion));
  }
  function ontologyImportRootBuilders$lambda$lambda$lambda$lambda$lambda_1($this_completion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLibraryReference($this_completion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.ontologyImportRootBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.ub6().v2c(it);
      return this_0;
    };
  }
  function ontologyImportRootBuilders$lambda_0($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyImport_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.ontologyImportRootBuilders.<anonymous>' call
      rootIndent(result, ontologyImportRootBuilders$lambda$lambda_2);
      return this_0;
    };
  }
  function linkLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(linkLibraryBuilders$lambda(_this__u8e3s4));
    _this__u8e3s4.wpf(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(linkLibraryBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_0);
  }
  function linkLibraryBuilders$lambda$lambda(it) {
    return it.sbi();
  }
  function linkLibraryBuilders$lambda$lambda_0(it) {
    return CellLists_instance.cmy(it);
  }
  function linkLibraryBuilders$lambda$lambda_1($this$indentChildren) {
    defaultItem($this$indentChildren, linkLibraryBuilders$lambda$lambda$lambda);
    return Unit_instance;
  }
  function linkLibraryBuilders$lambda$lambda$lambda($this$defaultItem) {
    return LinkDeclaration($this$defaultItem.o71());
  }
  function linkLibraryBuilders$lambda($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(LinkLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.linkLibraryBuilders.<anonymous>' call
      var tmp1 = linkLibraryBuilders$lambda$lambda;
      var tmp2 = linkLibraryBuilders$lambda$lambda_0;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
      var init = linkLibraryBuilders$lambda$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.gpe();
      var sourceType = getKClass(LinkDeclaration_1);
      var tmp$ret$0 = this_1.ypf(sourceType);
      indentChildren(result, tmp1, tmp$ret$0, null, tmp2, init);
      return this_0;
    };
  }
  function linkLibraryBuilders$lambda$lambda$lambda_0(it) {
    return it.b3();
  }
  function linkLibraryBuilders$lambda$lambda$lambda_1($this$editableText) {
    // Inline function 'jetbrains.ocelot.langDef.editor.enumSyncTwoWay' call
    var targetPropFactory = linkLibraryBuilders$lambda$lambda$lambda$lambda;
    // Inline function 'jetbrains.ocelot.langDef.editor.textCellSyncTwoWay' call
    $this$editableText.ypd(linkLibraryBuilders$lambda$lambda$lambda$lambda_0(targetPropFactory));
    return Unit_instance;
  }
  function linkLibraryBuilders$lambda$lambda$lambda$lambda(textCell) {
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_11();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.en4(textCell, enumInfo);
  }
  function linkLibraryBuilders$lambda$lambda$lambda$lambda_0($targetPropFactory) {
    return function ($this$setup, source, textCell) {
      // Inline function 'jetbrains.biokb.lang.builders.linkLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var sourceProp = source.sba();
      var targetProp = $targetPropFactory(textCell);
      $this$setup.wle(syncTwoWay(sourceProp.n4z(), targetProp));
      return Unit_instance;
    };
  }
  function linkLibraryBuilders$lambda$lambda$lambda_2(it) {
    return it.zb3();
  }
  function linkLibraryBuilders$lambda$lambda_2($this_linkLibraryBuilders) {
    return function ($this$rootIndent) {
      textProperty($this$rootIndent, '<name>', linkLibraryBuilders$lambda$lambda$lambda_0);
      space($this$rootIndent);
      label($this$rootIndent, ':');
      space($this$rootIndent);
      // Inline function 'jetbrains.ocelot.langDef.editor.enumProperty' call
      editableText($this$rootIndent, VOID, VOID, '<spec>', linkLibraryBuilders$lambda$lambda$lambda_1);
      indentLabel($this$rootIndent, '(');
      var tmp = get_ontologyElementTypeRole($this_linkLibraryBuilders);
      child_0($this$rootIndent, tmp, linkLibraryBuilders$lambda$lambda$lambda_2);
      indentLabel($this$rootIndent, ')', true);
      return Unit_instance;
    };
  }
  function linkLibraryBuilders$lambda_0($this, $this_linkLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(LinkDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.linkLibraryBuilders.<anonymous>' call
      rootIndent(result, linkLibraryBuilders$lambda$lambda_2($this_linkLibraryBuilders));
      return this_0;
    };
  }
  function notionLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(notionLibraryBuilders$lambda(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(notionLibraryBuilders$lambda_0(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(notionLibraryBuilders$lambda_1(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(notionLibraryBuilders$lambda_2(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_2);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_3 = new LazyMapperBuilder(notionLibraryBuilders$lambda_3(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_3);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_4 = new LazyMapperBuilder(notionLibraryBuilders$lambda_4(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_4);
  }
  function get_notionsRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(AbstractNotion);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-notionsRole>.<anonymous>' call
    builder.spn();
    builder.ppn('<notions>');
    builder.opn(_get_notionsRole_$lambda_bffgy6);
    builder.qpn(_get_notionsRole_$lambda_bffgy6_0);
    var simpleClassName = ensureNotNull(getKClass(AbstractNotion).lb());
    builder.tpn(simpleClassName, _get_notionsRole_$lambda_bffgy6_1);
    return builder;
  }
  function notionLibraryBuilders$lambda$lambda$lambda(it) {
    return it.xbo();
  }
  function notionLibraryBuilders$lambda$lambda($this_notionLibraryBuilders) {
    return function ($this$indent) {
      var tmp = get_notionsRole($this_notionLibraryBuilders);
      children_1($this$indent, tmp, notionLibraryBuilders$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function notionLibraryBuilders$lambda($this, $this_notionLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(NotionLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.notionLibraryBuilders.<anonymous>' call
      indent(result, VOID, notionLibraryBuilders$lambda$lambda($this_notionLibraryBuilders));
      return this_0;
    };
  }
  function notionLibraryBuilders$lambda$lambda_0($this$rootIndent) {
    keyword($this$rootIndent, 'enumerable notion');
    space($this$rootIndent);
    textProperty($this$rootIndent, '<name>', notionLibraryBuilders$lambda$lambda$lambda_0);
    indent($this$rootIndent, true, notionLibraryBuilders$lambda$lambda$lambda_1);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda_0(it) {
    return it.b3();
  }
  function notionLibraryBuilders$lambda$lambda$lambda_1($this$indent) {
    newLine($this$indent);
    keyword($this$indent, 'values:');
    space($this$indent);
    var tmp1 = notionLibraryBuilders$lambda$lambda$lambda$lambda;
    var tmp3 = notionLibraryBuilders$lambda$lambda$lambda$lambda_0;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
    var init = notionLibraryBuilders$lambda$lambda$lambda$lambda_1;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$indent.gpe();
    var sourceType = getKClass(EnumerationConstant_1);
    var tmp$ret$0 = this_0.ypf(sourceType);
    indentChildren($this$indent, tmp1, tmp$ret$0, '<units>', tmp3, init);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda(it) {
    return it.jb3();
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda_0(it) {
    return CellLists_instance.bmy(it, ', ');
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda_1($this$indentChildren) {
    defaultItem($this$indentChildren, notionLibraryBuilders$lambda$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda$lambda($this$defaultItem) {
    return EnumerationConstant($this$defaultItem.o71());
  }
  function notionLibraryBuilders$lambda_0($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(EnumerableNotion_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.notionLibraryBuilders.<anonymous>' call
      rootIndent(result, notionLibraryBuilders$lambda$lambda_0);
      return this_0;
    };
  }
  function notionLibraryBuilders$lambda$lambda_1($this$rootIndent) {
    keyword($this$rootIndent, 'measurable notion');
    space($this$rootIndent);
    textProperty($this$rootIndent, '<name>', notionLibraryBuilders$lambda$lambda$lambda_2);
    indent($this$rootIndent, true, notionLibraryBuilders$lambda$lambda$lambda_3);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda_2(it) {
    return it.b3();
  }
  function notionLibraryBuilders$lambda$lambda$lambda_3($this$indent) {
    newLine($this$indent);
    keyword($this$indent, 'measured in:');
    space($this$indent);
    var tmp1 = notionLibraryBuilders$lambda$lambda$lambda$lambda_2;
    var tmp3 = notionLibraryBuilders$lambda$lambda$lambda$lambda_3;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
    var init = notionLibraryBuilders$lambda$lambda$lambda$lambda_4;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$indent.gpe();
    var sourceType = getKClass(MeasurementUnit_1);
    var tmp$ret$0 = this_0.ypf(sourceType);
    indentChildren($this$indent, tmp1, tmp$ret$0, '<units>', tmp3, init);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda_2(it) {
    return it.sbj();
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda_3(it) {
    return CellLists_instance.bmy(it, ', ');
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda_4($this$indentChildren) {
    defaultItem($this$indentChildren, notionLibraryBuilders$lambda$lambda$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda$lambda$lambda_0($this$defaultItem) {
    return MeasurementUnit($this$defaultItem.o71());
  }
  function notionLibraryBuilders$lambda_1($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(MeasurableNotion_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.notionLibraryBuilders.<anonymous>' call
      rootIndent(result, notionLibraryBuilders$lambda$lambda_1);
      return this_0;
    };
  }
  function notionLibraryBuilders$lambda$lambda_2($this$rootIndent) {
    textProperty($this$rootIndent, '<name>', notionLibraryBuilders$lambda$lambda$lambda_4);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda_4(it) {
    return it.b3();
  }
  function notionLibraryBuilders$lambda_2($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(MeasurementUnit_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.notionLibraryBuilders.<anonymous>' call
      rootIndent(result, notionLibraryBuilders$lambda$lambda_2);
      return this_0;
    };
  }
  function notionLibraryBuilders$lambda$lambda_3($this$rootIndent) {
    textProperty($this$rootIndent, '<name>', notionLibraryBuilders$lambda$lambda$lambda_5);
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda$lambda$lambda_5(it) {
    return it.b3();
  }
  function notionLibraryBuilders$lambda_3($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(EnumerationConstant_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.notionLibraryBuilders.<anonymous>' call
      rootIndent(result, notionLibraryBuilders$lambda$lambda_3);
      return this_0;
    };
  }
  function notionLibraryBuilders$lambda$lambda_4($this$rootIndent) {
    label($this$rootIndent, '');
    return Unit_instance;
  }
  function notionLibraryBuilders$lambda_4($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(NotionPlaceholder_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.notionLibraryBuilders.<anonymous>' call
      rootIndent(result, notionLibraryBuilders$lambda$lambda_4);
      return this_0;
    };
  }
  function _get_notionsRole_$lambda_bffgy6($this$completion) {
    var tmp = produces('enumerable notion', _get_notionsRole_$lambda$lambda_h77l2b($this$completion));
    return simpleCompletion(listOf_0([tmp, produces('measurable notion', _get_notionsRole_$lambda$lambda_h77l2b_0($this$completion))]));
  }
  function _get_notionsRole_$lambda$lambda_h77l2b($this_completion) {
    return function (it) {
      return EnumerableNotion($this_completion.o71());
    };
  }
  function _get_notionsRole_$lambda$lambda_h77l2b_0($this_completion) {
    return function (it) {
      return MeasurableNotion($this_completion.o71());
    };
  }
  function _get_notionsRole_$lambda_bffgy6_0($this$default) {
    return NotionPlaceholder($this$default.o71());
  }
  function _get_notionsRole_$lambda_bffgy6_1($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function ontologyLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(ontologyLibraryBuilders$lambda(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(ontologyLibraryBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(ontologyLibraryBuilders$lambda_1(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(ontologyLibraryBuilders$lambda_2(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_2);
  }
  function get_ontologyElements(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyElement_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-ontologyElements>.<anonymous>' call
    builder.spn();
    builder.qpn(_get_ontologyElements_$lambda_30svkq);
    var simpleClassName = ensureNotNull(getKClass(OntologyElement_1).lb());
    builder.tpn(simpleClassName, _get_ontologyElements_$lambda_30svkq_0);
    return builder;
  }
  function get_ontologyIsRelations(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyIsRelation_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-ontologyIsRelations>.<anonymous>' call
    builder.opn(_get_ontologyIsRelations_$lambda_reypwo);
    builder.qpn(_get_ontologyIsRelations_$lambda_reypwo_0);
    var simpleClassName = ensureNotNull(getKClass(OntologyIsRelation_1).lb());
    builder.tpn(simpleClassName, _get_ontologyIsRelations_$lambda_reypwo_1);
    return builder;
  }
  function get_ontologyCardinalityRelations(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyCardinalityRelation_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-ontologyCardinalityRelations>.<anonymous>' call
    builder.opn(_get_ontologyCardinalityRelations_$lambda_6r4c08);
    builder.qpn(_get_ontologyCardinalityRelations_$lambda_6r4c08_0);
    var simpleClassName = ensureNotNull(getKClass(OntologyCardinalityRelation_1).lb());
    builder.tpn(simpleClassName, _get_ontologyCardinalityRelations_$lambda_6r4c08_1);
    return builder;
  }
  function get_localOntologyElementReferenceProvider(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyElementReferenceProvider);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-localOntologyElementReferenceProvider>.<anonymous>' call
    builder.ppn('<element reference>');
    builder.qpn(_get_localOntologyElementReferenceProvider_$lambda_89ybp0);
    var simpleClassName = ensureNotNull(getKClass(OntologyElementReferenceProvider).lb());
    builder.tpn(simpleClassName, _get_localOntologyElementReferenceProvider_$lambda_89ybp0_0);
    return builder;
  }
  function get_classExpressionProvider(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(ClassExpression);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-classExpressionProvider>.<anonymous>' call
    builder.ppn('<element reference>');
    builder.qpn(_get_classExpressionProvider_$lambda_8nvv2d);
    var simpleClassName = ensureNotNull(getKClass(ClassExpression).lb());
    builder.tpn(simpleClassName, _get_classExpressionProvider_$lambda_8nvv2d_0);
    return builder;
  }
  function relationCompletion(_this__u8e3s4, factory) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_207().tbi_1);
    var tmp_0 = map_2(tmp, relationCompletion$lambda(factory, _this__u8e3s4));
    var tmp_1 = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_206().tc0_1);
    return plus_12(tmp_0, map_2(tmp_1, relationCompletion$lambda_0(factory, _this__u8e3s4)));
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda(it) {
    return it.sc0();
  }
  function ontologyLibraryBuilders$lambda$lambda($this_ontologyLibraryBuilders) {
    return function ($this$indent) {
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
      // Inline function 'kotlin.also' call
      var this_0 = get_ontologyElements($this_ontologyLibraryBuilders).o30();
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.builders.ontologyLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      this_0.ppn('<elements>');
      var tmp = this_0;
      children_1($this$indent, tmp, ontologyLibraryBuilders$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function ontologyLibraryBuilders$lambda($this, $this_ontologyLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.ontologyLibraryBuilders.<anonymous>' call
      indent(result, VOID, ontologyLibraryBuilders$lambda$lambda($this_ontologyLibraryBuilders));
      return this_0;
    };
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda_0(it) {
    return it.b3();
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda$lambda(it) {
    return it.gbu();
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda_1($this_ontologyLibraryBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      keyword($this$indent, 'super types:');
      space($this$indent);
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
      // Inline function 'kotlin.also' call
      var this_0 = get_ontologyIsRelations($this_ontologyLibraryBuilders).o30();
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.builders.ontologyLibraryBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.ppn('<super elements>');
      this_0.rpn(', ');
      var tmp = this_0;
      children_1($this$indent, tmp, ontologyLibraryBuilders$lambda$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda$lambda_0(it) {
    return it.hbu();
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda_2($this_ontologyLibraryBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      keyword($this$indent, 'is part of:');
      space($this$indent);
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
      // Inline function 'kotlin.also' call
      var this_0 = get_ontologyCardinalityRelations($this_ontologyLibraryBuilders).o30();
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.builders.ontologyLibraryBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.ppn('<enclosing elements>');
      this_0.rpn(', ');
      var tmp = this_0;
      children_1($this$indent, tmp, ontologyLibraryBuilders$lambda$lambda$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function ontologyLibraryBuilders$lambda$lambda_0($this_ontologyLibraryBuilders) {
    return function ($this$rootIndent) {
      keyword($this$rootIndent, 'ontology type:');
      space($this$rootIndent);
      textProperty($this$rootIndent, '<name>', ontologyLibraryBuilders$lambda$lambda$lambda_0);
      indent($this$rootIndent, true, ontologyLibraryBuilders$lambda$lambda$lambda_1($this_ontologyLibraryBuilders));
      indent($this$rootIndent, true, ontologyLibraryBuilders$lambda$lambda$lambda_2($this_ontologyLibraryBuilders));
      return Unit_instance;
    };
  }
  function ontologyLibraryBuilders$lambda_0($this, $this_ontologyLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyElement_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.ontologyLibraryBuilders.<anonymous>' call
      rootIndent(result, ontologyLibraryBuilders$lambda$lambda_0($this_ontologyLibraryBuilders));
      return this_0;
    };
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda_3(it) {
    return it.fc0();
  }
  function ontologyLibraryBuilders$lambda$lambda_1($this_ontologyLibraryBuilders) {
    return function ($this$rootIndent) {
      var tmp = get_localOntologyElementReferenceProvider($this_ontologyLibraryBuilders);
      child_0($this$rootIndent, tmp, ontologyLibraryBuilders$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function ontologyLibraryBuilders$lambda_1($this, $this_ontologyLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyIsRelation_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.ontologyLibraryBuilders.<anonymous>' call
      rootIndent(result, ontologyLibraryBuilders$lambda$lambda_1($this_ontologyLibraryBuilders));
      return this_0;
    };
  }
  function ontologyLibraryBuilders$lambda$lambda$lambda_4(it) {
    return it.yay();
  }
  function ontologyLibraryBuilders$lambda$lambda_2($this_ontologyLibraryBuilders) {
    return function ($this$rootIndent) {
      var tmp = get_classExpressionProvider($this_ontologyLibraryBuilders);
      child_0($this$rootIndent, tmp, ontologyLibraryBuilders$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function ontologyLibraryBuilders$lambda_2($this, $this_ontologyLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyCardinalityRelation_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.ontologyLibraryBuilders.<anonymous>' call
      rootIndent(result, ontologyLibraryBuilders$lambda$lambda_2($this_ontologyLibraryBuilders));
      return this_0;
    };
  }
  function _get_ontologyElements_$lambda_30svkq($this$default) {
    return OntologyElement($this$default.o71());
  }
  function _get_ontologyElements_$lambda_30svkq_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_ontologyIsRelations_$lambda_reypwo($this$completion) {
    return relationCompletion($this$completion, _get_ontologyIsRelations_$lambda$lambda_l9jael($this$completion));
  }
  function _get_ontologyIsRelations_$lambda$lambda_l9jael($this_completion) {
    return function () {
      return OntologyIsRelation($this_completion.o71());
    };
  }
  function _get_ontologyIsRelations_$lambda_reypwo_0($this$default) {
    return OntologyIsRelation($this$default.o71());
  }
  function _get_ontologyIsRelations_$lambda_reypwo_1($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_ontologyCardinalityRelations_$lambda_6r4c08($this$completion) {
    return relationCompletion($this$completion, _get_ontologyCardinalityRelations_$lambda$lambda_1gt74d($this$completion));
  }
  function _get_ontologyCardinalityRelations_$lambda$lambda_1gt74d($this_completion) {
    return function () {
      return OntologyCardinalityRelation($this_completion.o71());
    };
  }
  function _get_ontologyCardinalityRelations_$lambda_6r4c08_0($this$default) {
    return OntologyCardinalityRelation($this$default.o71());
  }
  function _get_ontologyCardinalityRelations_$lambda_6r4c08_1($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_localOntologyElementReferenceProvider_$lambda_89ybp0($this$default) {
    return LocalOntologyElementReference($this$default.o71());
  }
  function _get_localOntologyElementReferenceProvider_$lambda_89ybp0_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_classExpressionProvider_$lambda_8nvv2d($this$default) {
    return LocalOntologyElementReference($this$default.o71());
  }
  function _get_classExpressionProvider_$lambda_8nvv2d_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function relationCompletion$lambda($factory, $this_relationCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = $factory();
      // Inline function 'jetbrains.biokb.lang.builders.relationCompletion.<anonymous>.<anonymous>' call
      LocalOntologyElementReference_2($this_relationCompletion.o71(), it);
      return this_0;
    };
  }
  function relationCompletion$lambda_0($factory, $this_relationCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = $factory();
      // Inline function 'jetbrains.biokb.lang.builders.relationCompletion.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'jetbrains.biokb.lang.builders.relationCompletion.<anonymous>.<anonymous>.<anonymous>' call
      var tmp = QualifiedOntologyElementReference($this_relationCompletion.o71()).lcj();
      // Inline function 'kotlin.apply' call
      var this_1 = OntologyLibraryReference($this_relationCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.relationCompletion.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_1.ub6().v2c(it);
      tmp.v2c(this_1);
      return this_0;
    };
  }
  function processLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(processLibraryBuilders$lambda(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(processLibraryBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(processLibraryBuilders$lambda_1(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(processLibraryBuilders$lambda_2(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_2);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_3 = new LazyMapperBuilder(processLibraryBuilders$lambda_3(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_3);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_4 = new LazyMapperBuilder(processLibraryBuilders$lambda_4(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_4);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_5 = new LazyMapperBuilder(processLibraryBuilders$lambda_5(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_5);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_6 = new LazyMapperBuilder(processLibraryBuilders$lambda_6(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_6);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_7 = new LazyMapperBuilder(processLibraryBuilders$lambda_7(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_7);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_8 = new LazyMapperBuilder(processLibraryBuilders$lambda_8(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_8);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_9 = new LazyMapperBuilder(processLibraryBuilders$lambda_9(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_9);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_10 = new LazyMapperBuilder(processLibraryBuilders$lambda_10(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_10);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_11 = new LazyMapperBuilder(processLibraryBuilders$lambda_11(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_11);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_12 = new LazyMapperBuilder(processLibraryBuilders$lambda_12(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_12);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_13 = new LazyMapperBuilder(processLibraryBuilders$lambda_13(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_13);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_14 = new LazyMapperBuilder(processLibraryBuilders$lambda_14(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_14);
  }
  function partReferenceOperationCompletion(_this__u8e3s4) {
    return extensionFieldReferenceCompletion(_this__u8e3s4);
  }
  function bindingValueCompletion(_this__u8e3s4) {
    return plus_12(propertyValueCompletion(_this__u8e3s4), linkValueCompletion(_this__u8e3s4));
  }
  function bindingEntries(_this__u8e3s4, placeholderText, list) {
    placeholderText = placeholderText === VOID ? '<entries>' : placeholderText;
    var tmp3 = bindingEntries$lambda;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
    var init = bindingEntries$lambda_0;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = _this__u8e3s4.gpe();
    var sourceType = getKClass(AbstractBindingEntry);
    var tmp$ret$0 = this_0.ypf(sourceType);
    return indentChildren(_this__u8e3s4, list, tmp$ret$0, placeholderText, tmp3, init);
  }
  function get_ontologyElementsRole(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
    // Inline function 'kotlin.also' call
    var this_0 = get_ontologyElementTypeRole(_this__u8e3s4).o30();
    // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-ontologyElementsRole>.<anonymous>' call
    this_0.spn();
    return this_0;
  }
  function abstractBindingEntryCompletion(_this__u8e3s4) {
    return plus_12(inplaceBindingEntryCompletion(_this__u8e3s4), importedBindingEntryCompletion(_this__u8e3s4));
  }
  function abstractValueCompletion(_this__u8e3s4) {
    return plus_12(plus_12(plus_12(plus_12(plus_12(measurableValueCompletion(_this__u8e3s4), enumValueCompletion(_this__u8e3s4)), variableRefCompletion(_this__u8e3s4)), functionTermCompletion(_this__u8e3s4)), ontologyReferenceValueLibraryCompletion(_this__u8e3s4)), ontologyReferenceValueCompletion(_this__u8e3s4));
  }
  function linkValueCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_201().aat_1);
    return map_2(tmp, linkValueCompletion$lambda(_this__u8e3s4));
  }
  function propertyValueCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_213().agd_1);
    return map_2(tmp, propertyValueCompletion$lambda(_this__u8e3s4));
  }
  function importedBindingEntryCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_202().zbc_1);
    var tmp_0 = map_2(tmp, importedBindingEntryCompletion$lambda(_this__u8e3s4));
    var tmp_1 = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_214().nbd_1);
    return plus_12(tmp_0, map_2(tmp_1, importedBindingEntryCompletion$lambda_0(_this__u8e3s4)));
  }
  function inplaceBindingEntryCompletion(_this__u8e3s4) {
    var tmp = produces('link', inplaceBindingEntryCompletion$lambda(_this__u8e3s4));
    return simpleCompletion(listOf_0([tmp, produces('property', inplaceBindingEntryCompletion$lambda_0(_this__u8e3s4))]));
  }
  function ontologyReferenceValueCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_205().rbv_1);
    return map_2(tmp, ontologyReferenceValueCompletion$lambda(_this__u8e3s4));
  }
  function ontologyReferenceValueLibraryCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_206().tc0_1);
    return map_2(tmp, ontologyReferenceValueLibraryCompletion$lambda(_this__u8e3s4));
  }
  function variableRefCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_221().kcq_1);
    return map_2(tmp, variableRefCompletion$lambda(_this__u8e3s4));
  }
  function enumValueCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_224().jb2_1);
    return map_2(tmp, enumValueCompletion$lambda(_this__u8e3s4));
  }
  function measurableValueCompletion(_this__u8e3s4) {
    var tmp = intRoleCompletion();
    return map_2(tmp, measurableValueCompletion$lambda(_this__u8e3s4));
  }
  function processLibraryBuilders$lambda$lambda($this$default) {
    return ProcessDeclaration($this$default.o71());
  }
  function processLibraryBuilders$lambda$lambda_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function processLibraryBuilders$lambda$lambda_1(it) {
    return it.jc8();
  }
  function processLibraryBuilders$lambda($this, $this_processLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ProcessLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
      // Inline function 'jetbrains.ocelot.langDef.editor.role' call
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = $this_processLibraryBuilders;
      var sourceType = getKClass(ProcessDeclaration_1);
      var tmp$ret$0 = this_1.ypf(sourceType);
      var builder = new ChildBuilder(tmp$ret$0);
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>' call
      builder.spn();
      builder.qpn(processLibraryBuilders$lambda$lambda);
      var simpleClassName = ensureNotNull(getKClass(ProcessDeclaration_1).lb());
      builder.tpn(simpleClassName, processLibraryBuilders$lambda$lambda_0);
      var tmp = builder;
      children_1(result, tmp, processLibraryBuilders$lambda$lambda_1);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.r5e();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function processLibraryBuilders$$inlined$editor$2$1$2$1($refCompletion, $this, $source) {
    this.nsf_1 = $refCompletion;
    this.osf_1 = $this;
    this.psf_1 = $source;
    CellTrait.call(this);
  }
  protoOf(processLibraryBuilders$$inlined$editor$2$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.nsf_1(this.osf_1, this.psf_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_0($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new processLibraryBuilders$$inlined$editor$2$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda(s) {
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.r5e();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion));
      return Unit_instance;
    };
  }
  function processLibraryBuilders$$inlined$editor$2$1$3$1($cellBuilder, $refCompletion) {
    this.rsf_1 = $refCompletion;
    this.qsf_1 = $cellBuilder;
  }
  protoOf(processLibraryBuilders$$inlined$editor$2$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda(property, this.rsf_1));
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$3$1).gpe = function () {
    return this.qsf_1.gpe();
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$3$1).qsd = function (child) {
    this.qsf_1.xpd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$3$1).rsd = function (init) {
    this.qsf_1.ypd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$3$1).ssd = function (init) {
    this.qsf_1.zpd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$3$1).tsd = function (source, cellMap, context) {
    return this.qsf_1.bpe(source, cellMap, context);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda(it) {
    return it.b3();
  }
  function processLibraryBuilders$lambda$lambda$lambda_1($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new processLibraryBuilders$$inlined$editor$2$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<kind>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_2() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_3(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_4($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_5($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.r5e();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_6($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.r5e();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_7($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.r5e();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_8(it) {
    return it.b3();
  }
  function processLibraryBuilders$lambda$lambda$lambda_9($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.gc7();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_0($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function processLibraryBuilders$$inlined$editor$2$1$12$1($refCompletion, $this, $source) {
    this.ssf_1 = $refCompletion;
    this.tsf_1 = $this;
    this.usf_1 = $source;
    CellTrait.call(this);
  }
  protoOf(processLibraryBuilders$$inlined$editor$2$1$12$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.ssf_1(this.tsf_1, this.usf_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_0(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_10($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new processLibraryBuilders$$inlined$editor$2$1$12$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_0(s) {
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.gc7();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_1($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_2($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_0($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_1($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_2($refCompletion));
      return Unit_instance;
    };
  }
  function processLibraryBuilders$$inlined$editor$2$1$13$1($cellBuilder, $refCompletion) {
    this.wsf_1 = $refCompletion;
    this.vsf_1 = $cellBuilder;
  }
  protoOf(processLibraryBuilders$$inlined$editor$2$1$13$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_0(property, this.wsf_1));
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$13$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$13$1).gpe = function () {
    return this.vsf_1.gpe();
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$13$1).qsd = function (child) {
    this.vsf_1.xpd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$13$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$13$1).rsd = function (init) {
    this.vsf_1.ypd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$13$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$13$1).ssd = function (init) {
    this.vsf_1.zpd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$13$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$13$1).tsd = function (source, cellMap, context) {
    return this.vsf_1.bpe(source, cellMap, context);
  };
  protoOf(processLibraryBuilders$$inlined$editor$2$1$13$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_0(it) {
    return it.b3();
  }
  function processLibraryBuilders$lambda$lambda$lambda_11($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new processLibraryBuilders$$inlined$editor$2$1$13$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<process>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_12() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_13(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_14($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_15($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.gc7();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_16($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.gc7();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_17($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.gc7();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda$lambda(it) {
    return it.oas();
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_1($this_processLibraryBuilders) {
    return function ($this$horizontal) {
      var tmp = get_ontologyElementsRole($this_processLibraryBuilders);
      children_1($this$horizontal, tmp, processLibraryBuilders$lambda$lambda$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_2($this$horizontal) {
    bindingEntries($this$horizontal, VOID, processLibraryBuilders$lambda$lambda$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda$lambda_0(it) {
    return it.w();
  }
  function processLibraryBuilders$lambda$lambda$lambda_18($this_processLibraryBuilders) {
    return function ($this$indent) {
      newLine($this$indent);
      keyword($this$indent, 'ontology elements:');
      space($this$indent);
      horizontal($this$indent, processLibraryBuilders$lambda$lambda$lambda$lambda_1($this_processLibraryBuilders));
      newLine($this$indent);
      keyword($this$indent, 'properties:');
      space($this$indent);
      horizontal($this$indent, processLibraryBuilders$lambda$lambda$lambda$lambda_2);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda_2($this_processLibraryBuilders) {
    return function ($this$rootIndent) {
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
      var referenceTag = Companion_getInstance_208().jc6_1;
      var refCompletion = processLibraryBuilders$lambda$lambda$lambda(referenceTag);
      var completionTrait = processLibraryBuilders$lambda$lambda$lambda_0(refCompletion);
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(ProcessKind_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_1(refCompletion));
      var mapperBuilder = this_0;
      var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_2);
      var tmp = processLibraryBuilders$lambda$lambda$lambda_3;
      // Inline function 'kotlin.apply' call
      var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<kind>', processLibraryBuilders$lambda$lambda$lambda_4(completionTrait));
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
      this_1.ypd(processLibraryBuilders$lambda$lambda$lambda_5);
      this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_6);
      this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_7);
      space($this$rootIndent);
      textProperty($this$rootIndent, '<name>', processLibraryBuilders$lambda$lambda$lambda_8);
      space($this$rootIndent);
      keyword($this$rootIndent, 'extends');
      space($this$rootIndent);
      var tmp10 = '<nothing>';
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
      var referenceTag_0 = Companion_getInstance_208().kc6_1;
      var refCompletion_0 = processLibraryBuilders$lambda$lambda$lambda_9(referenceTag_0);
      var completionTrait_0 = processLibraryBuilders$lambda$lambda$lambda_10(refCompletion_0);
      // Inline function 'kotlin.also' call
      var this_2 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(ProcessDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result_0 = new RootCellBuilderImpl(this_2);
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
      rootIndent(result_0, processLibraryBuilders$lambda$lambda$lambda_11(refCompletion_0));
      var mapperBuilder_0 = this_2;
      var tmp0_cellFactory_0 = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_12);
      var tmp_0 = processLibraryBuilders$lambda$lambda$lambda_13;
      // Inline function 'kotlin.apply' call
      var this_3 = projectionalChild($this$rootIndent, tmp_0, tmp0_cellFactory_0, mapperBuilder_0, tmp10, processLibraryBuilders$lambda$lambda$lambda_14(completionTrait_0));
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
      this_3.ypd(processLibraryBuilders$lambda$lambda$lambda_15);
      this_3.zpd(processLibraryBuilders$lambda$lambda$lambda_16);
      this_3.zpd(processLibraryBuilders$lambda$lambda$lambda_17);
      indent($this$rootIndent, true, processLibraryBuilders$lambda$lambda$lambda_18($this_processLibraryBuilders));
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda_0($this, $this_processLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ProcessDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda_2($this_processLibraryBuilders));
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_3(it) {
    return it.i6u();
  }
  function processLibraryBuilders$lambda$lambda_4($this$indentChild) {
    defaultItem($this$indentChild, processLibraryBuilders$lambda$lambda$lambda_19);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_19($this$defaultItem) {
    return PropertyDeclaration($this$defaultItem.o71());
  }
  function processLibraryBuilders$lambda_1($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(BindingProperty_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      var tmp1 = processLibraryBuilders$lambda$lambda_3;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
      var init = processLibraryBuilders$lambda$lambda_4;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.gpe();
      var sourceType = getKClass(PropertyDeclaration_1);
      var tmp$ret$0 = this_1.ypf(sourceType);
      indentChild(result, tmp1, tmp$ret$0, null, init);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_20(it) {
    return it.pbh();
  }
  function processLibraryBuilders$lambda$lambda$lambda_21(it) {
    return it.uc1();
  }
  function processLibraryBuilders$lambda$lambda$lambda_22($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.jat();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_1($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function processLibraryBuilders$$inlined$editor$4$1$4$1($refCompletion, $this, $source) {
    this.xsf_1 = $refCompletion;
    this.ysf_1 = $this;
    this.zsf_1 = $source;
    CellTrait.call(this);
  }
  protoOf(processLibraryBuilders$$inlined$editor$4$1$4$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.xsf_1(this.ysf_1, this.zsf_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_1(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_23($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new processLibraryBuilders$$inlined$editor$4$1$4$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_1(s) {
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.jat();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_3($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_4($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_1($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_3($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_4($refCompletion));
      return Unit_instance;
    };
  }
  function processLibraryBuilders$$inlined$editor$4$1$5$1($cellBuilder, $refCompletion) {
    this.bsg_1 = $refCompletion;
    this.asg_1 = $cellBuilder;
  }
  protoOf(processLibraryBuilders$$inlined$editor$4$1$5$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_1(property, this.bsg_1));
  };
  protoOf(processLibraryBuilders$$inlined$editor$4$1$5$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(processLibraryBuilders$$inlined$editor$4$1$5$1).gpe = function () {
    return this.asg_1.gpe();
  };
  protoOf(processLibraryBuilders$$inlined$editor$4$1$5$1).qsd = function (child) {
    this.asg_1.xpd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$4$1$5$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$4$1$5$1).rsd = function (init) {
    this.asg_1.ypd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$4$1$5$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$4$1$5$1).ssd = function (init) {
    this.asg_1.zpd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$4$1$5$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$4$1$5$1).tsd = function (source, cellMap, context) {
    return this.asg_1.bpe(source, cellMap, context);
  };
  protoOf(processLibraryBuilders$$inlined$editor$4$1$5$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_3(it) {
    return it.b3();
  }
  function processLibraryBuilders$lambda$lambda$lambda_24($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new processLibraryBuilders$$inlined$editor$4$1$5$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<process>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_25() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_26(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_27($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_28($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.jat();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_29($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.jat();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_30($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.jat();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda_5($this_processLibraryBuilders) {
    return function ($this$rootIndent) {
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
      var role = processLibraryBuilders$lambda$lambda$lambda_20;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_0 = $this$rootIndent.gpe();
      var sourceType = getKClass(LinkDeclaration_1);
      var tmp$ret$0 = this_0.ypf(sourceType);
      indentChild($this$rootIndent, role, tmp$ret$0, null, null);
      space($this$rootIndent);
      keyword($this$rootIndent, 'from');
      space($this$rootIndent);
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke' call
      // Inline function 'kotlin.also' call
      var this_1 = get_ontologyLibraryReferenceRole($this_processLibraryBuilders).o30();
      // Inline function 'jetbrains.ocelot.langDef.editor.ChildBuilder.invoke.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      this_1.ppn('<default>');
      var tmp = this_1;
      child_0($this$rootIndent, tmp, processLibraryBuilders$lambda$lambda$lambda_21);
      space($this$rootIndent);
      keyword($this$rootIndent, 'specializes');
      space($this$rootIndent);
      var tmp7 = '<nothing>';
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
      var referenceTag = Companion_getInstance_201().aat_1;
      var refCompletion = processLibraryBuilders$lambda$lambda$lambda_22(referenceTag);
      var completionTrait = processLibraryBuilders$lambda$lambda$lambda_23(refCompletion);
      // Inline function 'kotlin.also' call
      var this_2 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(AbstractLink));
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_2);
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_24(refCompletion));
      var mapperBuilder = this_2;
      var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_25);
      var tmp_0 = processLibraryBuilders$lambda$lambda$lambda_26;
      // Inline function 'kotlin.apply' call
      var this_3 = projectionalChild($this$rootIndent, tmp_0, tmp0_cellFactory, mapperBuilder, tmp7, processLibraryBuilders$lambda$lambda$lambda_27(completionTrait));
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
      this_3.ypd(processLibraryBuilders$lambda$lambda$lambda_28);
      this_3.zpd(processLibraryBuilders$lambda$lambda$lambda_29);
      this_3.zpd(processLibraryBuilders$lambda$lambda$lambda_30);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda_2($this, $this_processLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyLink_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda_5($this_processLibraryBuilders));
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_6($this$rootIndent) {
    var tmp1 = '<property>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_214().nbd_1;
    var refCompletion = processLibraryBuilders$lambda$lambda$lambda_31(referenceTag);
    var completionTrait = processLibraryBuilders$lambda$lambda$lambda_32(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(PropertyDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_33(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_34);
    var tmp = processLibraryBuilders$lambda$lambda$lambda_35;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp1, processLibraryBuilders$lambda$lambda$lambda_36(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(processLibraryBuilders$lambda$lambda$lambda_37);
    this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_38);
    this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_39);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_31($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.mbd();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_2($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function processLibraryBuilders$$inlined$editor$5$1$2$1($refCompletion, $this, $source) {
    this.csg_1 = $refCompletion;
    this.dsg_1 = $this;
    this.esg_1 = $source;
    CellTrait.call(this);
  }
  protoOf(processLibraryBuilders$$inlined$editor$5$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.csg_1(this.dsg_1, this.esg_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_2(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_32($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new processLibraryBuilders$$inlined$editor$5$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_2(s) {
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.mbd();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_5($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_2);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_6($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_2($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_5($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_6($refCompletion));
      return Unit_instance;
    };
  }
  function processLibraryBuilders$$inlined$editor$5$1$3$1($cellBuilder, $refCompletion) {
    this.gsg_1 = $refCompletion;
    this.fsg_1 = $cellBuilder;
  }
  protoOf(processLibraryBuilders$$inlined$editor$5$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_2(property, this.gsg_1));
  };
  protoOf(processLibraryBuilders$$inlined$editor$5$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(processLibraryBuilders$$inlined$editor$5$1$3$1).gpe = function () {
    return this.fsg_1.gpe();
  };
  protoOf(processLibraryBuilders$$inlined$editor$5$1$3$1).qsd = function (child) {
    this.fsg_1.xpd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$5$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$5$1$3$1).rsd = function (init) {
    this.fsg_1.ypd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$5$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$5$1$3$1).ssd = function (init) {
    this.fsg_1.zpd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$5$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$5$1$3$1).tsd = function (source, cellMap, context) {
    return this.fsg_1.bpe(source, cellMap, context);
  };
  protoOf(processLibraryBuilders$$inlined$editor$5$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_4(it) {
    return it.b3();
  }
  function processLibraryBuilders$lambda$lambda$lambda_33($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new processLibraryBuilders$$inlined$editor$5$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<property>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_34() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_35(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_36($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_37($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.mbd();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_38($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.mbd();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_39($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.mbd();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda_3($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ImportedProperty_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda_6);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_7($this$rootIndent) {
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_202().zbc_1;
    var refCompletion = processLibraryBuilders$lambda$lambda$lambda_40(referenceTag);
    var completionTrait = processLibraryBuilders$lambda$lambda$lambda_41(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(LinkDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_42(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_43);
    var tmp = processLibraryBuilders$lambda$lambda$lambda_44;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<link>', processLibraryBuilders$lambda$lambda$lambda_45(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(processLibraryBuilders$lambda$lambda$lambda_46);
    this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_47);
    this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_48);
    space($this$rootIndent);
    keyword($this$rootIndent, 'specializes');
    space($this$rootIndent);
    var tmp10 = '<nothing>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag_0 = Companion_getInstance_201().aat_1;
    var refCompletion_0 = processLibraryBuilders$lambda$lambda$lambda_49(referenceTag_0);
    var completionTrait_0 = processLibraryBuilders$lambda$lambda$lambda_50(refCompletion_0);
    // Inline function 'kotlin.also' call
    var this_2 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(AbstractLink));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result_0 = new RootCellBuilderImpl(this_2);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result_0, processLibraryBuilders$lambda$lambda$lambda_51(refCompletion_0));
    var mapperBuilder_0 = this_2;
    var tmp0_cellFactory_0 = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_52);
    var tmp_0 = processLibraryBuilders$lambda$lambda$lambda_53;
    // Inline function 'kotlin.apply' call
    var this_3 = projectionalChild($this$rootIndent, tmp_0, tmp0_cellFactory_0, mapperBuilder_0, tmp10, processLibraryBuilders$lambda$lambda$lambda_54(completionTrait_0));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_3.ypd(processLibraryBuilders$lambda$lambda$lambda_55);
    this_3.zpd(processLibraryBuilders$lambda$lambda$lambda_56);
    this_3.zpd(processLibraryBuilders$lambda$lambda$lambda_57);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_40($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.mbd();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_3($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function processLibraryBuilders$$inlined$editor$6$1$2$1($refCompletion, $this, $source) {
    this.hsg_1 = $refCompletion;
    this.isg_1 = $this;
    this.jsg_1 = $source;
    CellTrait.call(this);
  }
  protoOf(processLibraryBuilders$$inlined$editor$6$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.hsg_1(this.isg_1, this.jsg_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_3(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_41($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new processLibraryBuilders$$inlined$editor$6$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_3(s) {
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.mbd();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_7($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_3);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_8($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_3($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_7($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_8($refCompletion));
      return Unit_instance;
    };
  }
  function processLibraryBuilders$$inlined$editor$6$1$3$1($cellBuilder, $refCompletion) {
    this.lsg_1 = $refCompletion;
    this.ksg_1 = $cellBuilder;
  }
  protoOf(processLibraryBuilders$$inlined$editor$6$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_3(property, this.lsg_1));
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$3$1).gpe = function () {
    return this.ksg_1.gpe();
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$3$1).qsd = function (child) {
    this.ksg_1.xpd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$3$1).rsd = function (init) {
    this.ksg_1.ypd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$3$1).ssd = function (init) {
    this.ksg_1.zpd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$3$1).tsd = function (source, cellMap, context) {
    return this.ksg_1.bpe(source, cellMap, context);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_5(it) {
    return it.b3();
  }
  function processLibraryBuilders$lambda$lambda$lambda_42($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new processLibraryBuilders$$inlined$editor$6$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<link>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_5);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_43() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_44(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_45($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_46($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.mbd();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_47($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.mbd();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_48($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.mbd();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_49($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.jat();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_4($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function processLibraryBuilders$$inlined$editor$6$1$11$1($refCompletion, $this, $source) {
    this.msg_1 = $refCompletion;
    this.nsg_1 = $this;
    this.osg_1 = $source;
    CellTrait.call(this);
  }
  protoOf(processLibraryBuilders$$inlined$editor$6$1$11$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.msg_1(this.nsg_1, this.osg_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_4(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_50($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new processLibraryBuilders$$inlined$editor$6$1$11$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_4(s) {
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.jat();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_9($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_10($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_4($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_9($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_10($refCompletion));
      return Unit_instance;
    };
  }
  function processLibraryBuilders$$inlined$editor$6$1$12$1($cellBuilder, $refCompletion) {
    this.qsg_1 = $refCompletion;
    this.psg_1 = $cellBuilder;
  }
  protoOf(processLibraryBuilders$$inlined$editor$6$1$12$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_4(property, this.qsg_1));
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$12$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$12$1).gpe = function () {
    return this.psg_1.gpe();
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$12$1).qsd = function (child) {
    this.psg_1.xpd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$12$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$12$1).rsd = function (init) {
    this.psg_1.ypd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$12$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$12$1).ssd = function (init) {
    this.psg_1.zpd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$12$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$12$1).tsd = function (source, cellMap, context) {
    return this.psg_1.bpe(source, cellMap, context);
  };
  protoOf(processLibraryBuilders$$inlined$editor$6$1$12$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_6(it) {
    return it.b3();
  }
  function processLibraryBuilders$lambda$lambda$lambda_51($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new processLibraryBuilders$$inlined$editor$6$1$12$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<process>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_6);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_52() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_53(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_54($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_55($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.jat();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_56($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.jat();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_57($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.jat();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda_4($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ImportedLink_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda_7);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_8($this$rootIndent) {
    placeholderInCollection($this$rootIndent, VOID, processLibraryBuilders$lambda$lambda$lambda_58);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_58($this$placeholderInCollection) {
    return abstractBindingEntryCompletion($this$placeholderInCollection);
  }
  function processLibraryBuilders$lambda_5($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(EmptyBindingEntry_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda_8);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_9($this$rootIndent) {
    textProperty($this$rootIndent, '<name>', processLibraryBuilders$lambda$lambda$lambda_59);
    space($this$rootIndent);
    var tmp1 = processLibraryBuilders$lambda$lambda$lambda_60;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = processLibraryBuilders$lambda$lambda$lambda_61;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$rootIndent.gpe();
    var sourceType = getKClass(NotionType_0);
    var tmp$ret$0 = this_0.ypf(sourceType);
    indentChild($this$rootIndent, tmp1, tmp$ret$0, null, init);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_59(it) {
    return it.b3();
  }
  function processLibraryBuilders$lambda$lambda$lambda_60(it) {
    return it.zb3();
  }
  function processLibraryBuilders$lambda$lambda$lambda_61($this$indentChild) {
    $this$indentChild.nph(processLibraryBuilders$lambda$lambda$lambda$lambda_7);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_7($this$completion) {
    return notionTypeCompletion($this$completion);
  }
  function processLibraryBuilders$lambda_6($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(PropertyDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda_9);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_10($this$rootIndent) {
    var tmp1 = '<process>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_208().kc6_1;
    var refCompletion = processLibraryBuilders$lambda$lambda$lambda_62(referenceTag);
    var completionTrait = processLibraryBuilders$lambda$lambda$lambda_63(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(ProcessDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_64(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_65);
    var tmp = processLibraryBuilders$lambda$lambda$lambda_66;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp1, processLibraryBuilders$lambda$lambda$lambda_67(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(processLibraryBuilders$lambda$lambda$lambda_68);
    this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_69);
    this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_70);
    indentLabel($this$rootIndent, '(');
    var tmp10 = processLibraryBuilders$lambda$lambda$lambda_71;
    var tmp11 = '<parameters>';
    var tmp12 = processLibraryBuilders$lambda$lambda$lambda_72;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
    var init = processLibraryBuilders$lambda$lambda$lambda_73;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_2 = $this$rootIndent.gpe();
    var sourceType = getKClass(BindingValuePlaceholder_1);
    var tmp$ret$3 = this_2.ypf(sourceType);
    indentChildren($this$rootIndent, tmp10, tmp$ret$3, tmp11, tmp12, init);
    indentLabel($this$rootIndent, ')', true);
    focusable($this$rootIndent, true);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_62($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.jbg();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_5($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function processLibraryBuilders$$inlined$editor$9$1$2$1($refCompletion, $this, $source) {
    this.rsg_1 = $refCompletion;
    this.ssg_1 = $this;
    this.tsg_1 = $source;
    CellTrait.call(this);
  }
  protoOf(processLibraryBuilders$$inlined$editor$9$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.rsg_1(this.ssg_1, this.tsg_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_5(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_63($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new processLibraryBuilders$$inlined$editor$9$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_5(s) {
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.jbg();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_11($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_5);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_12($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_5($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_11($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_12($refCompletion));
      return Unit_instance;
    };
  }
  function processLibraryBuilders$$inlined$editor$9$1$3$1($cellBuilder, $refCompletion) {
    this.vsg_1 = $refCompletion;
    this.usg_1 = $cellBuilder;
  }
  protoOf(processLibraryBuilders$$inlined$editor$9$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_5(property, this.vsg_1));
  };
  protoOf(processLibraryBuilders$$inlined$editor$9$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(processLibraryBuilders$$inlined$editor$9$1$3$1).gpe = function () {
    return this.usg_1.gpe();
  };
  protoOf(processLibraryBuilders$$inlined$editor$9$1$3$1).qsd = function (child) {
    this.usg_1.xpd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$9$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$9$1$3$1).rsd = function (init) {
    this.usg_1.ypd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$9$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$9$1$3$1).ssd = function (init) {
    this.usg_1.zpd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$9$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$9$1$3$1).tsd = function (source, cellMap, context) {
    return this.usg_1.bpe(source, cellMap, context);
  };
  protoOf(processLibraryBuilders$$inlined$editor$9$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_8(it) {
    return it.b3();
  }
  function processLibraryBuilders$lambda$lambda$lambda_64($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new processLibraryBuilders$$inlined$editor$9$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<name>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_8);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_65() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_66(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_67($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_68($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.jbg();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_69($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.jbg();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_70($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.jbg();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_71(it) {
    return it.tba();
  }
  function processLibraryBuilders$lambda$lambda$lambda_72(it) {
    return CellLists_instance.bmy(it, ', ');
  }
  function processLibraryBuilders$lambda$lambda$lambda_73($this$indentChildren) {
    defaultItem($this$indentChildren, processLibraryBuilders$lambda$lambda$lambda$lambda_9);
    $this$indentChildren.nph(processLibraryBuilders$lambda$lambda$lambda$lambda_10);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_9($this$defaultItem) {
    return BindingValuePlaceholder($this$defaultItem.o71());
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_10($this$completion) {
    return bindingValueCompletion($this$completion);
  }
  function processLibraryBuilders$lambda_7($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(LibraryProcessSpecification_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda_10);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_11($this$rootIndent) {
    var tmp1 = '<property>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_213().agd_1;
    var refCompletion = processLibraryBuilders$lambda$lambda$lambda_74(referenceTag);
    var completionTrait = processLibraryBuilders$lambda$lambda$lambda_75(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(AbstractProperty));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_76(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_77);
    var tmp = processLibraryBuilders$lambda$lambda$lambda_78;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp1, processLibraryBuilders$lambda$lambda$lambda_79(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(processLibraryBuilders$lambda$lambda$lambda_80);
    this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_81);
    this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_82);
    space($this$rootIndent);
    label($this$rootIndent, '=');
    space($this$rootIndent);
    var tmp10 = processLibraryBuilders$lambda$lambda$lambda_83;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = processLibraryBuilders$lambda$lambda$lambda_84;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_2 = $this$rootIndent.gpe();
    var sourceType = getKClass(AbstractValue);
    var tmp$ret$3 = this_2.ypf(sourceType);
    indentChild($this$rootIndent, tmp10, tmp$ret$3, '<value>', init);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_74($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.i6u();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_6($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function processLibraryBuilders$$inlined$editor$10$1$2$1($refCompletion, $this, $source) {
    this.wsg_1 = $refCompletion;
    this.xsg_1 = $this;
    this.ysg_1 = $source;
    CellTrait.call(this);
  }
  protoOf(processLibraryBuilders$$inlined$editor$10$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.wsg_1(this.xsg_1, this.ysg_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_6(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_75($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new processLibraryBuilders$$inlined$editor$10$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_6(s) {
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.i6u();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_13($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_6);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_14($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_6($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_13($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_14($refCompletion));
      return Unit_instance;
    };
  }
  function processLibraryBuilders$$inlined$editor$10$1$3$1($cellBuilder, $refCompletion) {
    this.ash_1 = $refCompletion;
    this.zsg_1 = $cellBuilder;
  }
  protoOf(processLibraryBuilders$$inlined$editor$10$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_6(property, this.ash_1));
  };
  protoOf(processLibraryBuilders$$inlined$editor$10$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(processLibraryBuilders$$inlined$editor$10$1$3$1).gpe = function () {
    return this.zsg_1.gpe();
  };
  protoOf(processLibraryBuilders$$inlined$editor$10$1$3$1).qsd = function (child) {
    this.zsg_1.xpd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$10$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$10$1$3$1).rsd = function (init) {
    this.zsg_1.ypd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$10$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$10$1$3$1).ssd = function (init) {
    this.zsg_1.zpd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$10$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$10$1$3$1).tsd = function (source, cellMap, context) {
    return this.zsg_1.bpe(source, cellMap, context);
  };
  protoOf(processLibraryBuilders$$inlined$editor$10$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_11(it) {
    return it.b3();
  }
  function processLibraryBuilders$lambda$lambda$lambda_76($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new processLibraryBuilders$$inlined$editor$10$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<property>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_11);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_77() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_78(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_79($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_80($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.i6u();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_81($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.i6u();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_82($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.i6u();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_83(it) {
    return it.y();
  }
  function processLibraryBuilders$lambda$lambda$lambda_84($this$indentChild) {
    defaultItem($this$indentChild, processLibraryBuilders$lambda$lambda$lambda$lambda_12);
    $this$indentChild.nph(processLibraryBuilders$lambda$lambda$lambda$lambda_13);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_12($this$defaultItem) {
    // Inline function 'kotlin.apply' call
    var this_0 = MeasurableValue($this$defaultItem.o71());
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    this_0.fd2(0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_13($this$completion) {
    return abstractValueCompletion($this$completion);
  }
  function processLibraryBuilders$lambda_8($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(PropertyValue_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda_11);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_12($this$rootIndent) {
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_201().aat_1;
    var refCompletion = processLibraryBuilders$lambda$lambda$lambda_85(referenceTag);
    var completionTrait = processLibraryBuilders$lambda$lambda$lambda_86(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(AbstractLink));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_87(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_88);
    var tmp = processLibraryBuilders$lambda$lambda$lambda_89;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<link>', processLibraryBuilders$lambda$lambda$lambda_90(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(processLibraryBuilders$lambda$lambda$lambda_91);
    this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_92);
    this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_93);
    space($this$rootIndent);
    label($this$rootIndent, '=');
    space($this$rootIndent);
    var tmp10 = processLibraryBuilders$lambda$lambda$lambda_94;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = processLibraryBuilders$lambda$lambda$lambda_95;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_2 = $this$rootIndent.gpe();
    var sourceType = getKClass(AbstractValue);
    var tmp$ret$3 = this_2.ypf(sourceType);
    indentChild($this$rootIndent, tmp10, tmp$ret$3, '<value>', init);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_85($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.wc2();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_7($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function processLibraryBuilders$$inlined$editor$11$1$2$1($refCompletion, $this, $source) {
    this.bsh_1 = $refCompletion;
    this.csh_1 = $this;
    this.dsh_1 = $source;
    CellTrait.call(this);
  }
  protoOf(processLibraryBuilders$$inlined$editor$11$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.bsh_1(this.csh_1, this.dsh_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_7(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_86($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new processLibraryBuilders$$inlined$editor$11$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_7(s) {
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.wc2();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_15($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_7);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_16($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_7($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_15($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_16($refCompletion));
      return Unit_instance;
    };
  }
  function processLibraryBuilders$$inlined$editor$11$1$3$1($cellBuilder, $refCompletion) {
    this.fsh_1 = $refCompletion;
    this.esh_1 = $cellBuilder;
  }
  protoOf(processLibraryBuilders$$inlined$editor$11$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_7(property, this.fsh_1));
  };
  protoOf(processLibraryBuilders$$inlined$editor$11$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(processLibraryBuilders$$inlined$editor$11$1$3$1).gpe = function () {
    return this.esh_1.gpe();
  };
  protoOf(processLibraryBuilders$$inlined$editor$11$1$3$1).qsd = function (child) {
    this.esh_1.xpd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$11$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$11$1$3$1).rsd = function (init) {
    this.esh_1.ypd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$11$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$11$1$3$1).ssd = function (init) {
    this.esh_1.zpd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$11$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$11$1$3$1).tsd = function (source, cellMap, context) {
    return this.esh_1.bpe(source, cellMap, context);
  };
  protoOf(processLibraryBuilders$$inlined$editor$11$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_14(it) {
    return it.b3();
  }
  function processLibraryBuilders$lambda$lambda$lambda_87($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new processLibraryBuilders$$inlined$editor$11$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<link>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_14);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_88() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_89(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_90($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_91($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.wc2();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_92($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.wc2();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_93($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.wc2();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_94(it) {
    return it.y();
  }
  function processLibraryBuilders$lambda$lambda$lambda_95($this$indentChild) {
    $this$indentChild.nph(processLibraryBuilders$lambda$lambda$lambda$lambda_15);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda$lambda_15($this$completion) {
    return abstractValueCompletion($this$completion);
  }
  function processLibraryBuilders$lambda_9($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyLinkValue_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda_12);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_13($this$rootIndent) {
    placeholderInCollection($this$rootIndent, '<argument>', processLibraryBuilders$lambda$lambda$lambda_96);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_96($this$placeholderInCollection) {
    return bindingValueCompletion($this$placeholderInCollection);
  }
  function processLibraryBuilders$lambda_10($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(BindingValuePlaceholder_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda_13);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_14(it) {
    return it.sc0();
  }
  function processLibraryBuilders$lambda$lambda_15(it) {
    return CellLists_instance.cmy(it);
  }
  function processLibraryBuilders$lambda$lambda_16($this$indentChildren) {
    defaultItem($this$indentChildren, processLibraryBuilders$lambda$lambda$lambda_97);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_97($this$defaultItem) {
    return PropertyDeclaration($this$defaultItem.o71());
  }
  function processLibraryBuilders$lambda_11($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(PropertyLibrary_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      var tmp1 = processLibraryBuilders$lambda$lambda_14;
      var tmp2 = processLibraryBuilders$lambda$lambda_15;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
      var init = processLibraryBuilders$lambda$lambda_16;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.gpe();
      var sourceType = getKClass(PropertyLibraryElement);
      var tmp$ret$0 = this_1.ypf(sourceType);
      indentChildren(result, tmp1, tmp$ret$0, null, tmp2, init);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_17(it) {
    return it.wc7();
  }
  function processLibraryBuilders$lambda$lambda_18(it) {
    return CellLists_instance.cmy(it);
  }
  function processLibraryBuilders$lambda$lambda_19($this$indentChildren) {
    defaultItem($this$indentChildren, processLibraryBuilders$lambda$lambda$lambda_98);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_98($this$defaultItem) {
    return ProcessKind($this$defaultItem.o71());
  }
  function processLibraryBuilders$lambda_12($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ProcessKindContainer_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      var tmp1 = processLibraryBuilders$lambda$lambda_17;
      var tmp2 = processLibraryBuilders$lambda$lambda_18;
      // Inline function 'jetbrains.ocelot.langDef.editor.indentChildren' call
      var init = processLibraryBuilders$lambda$lambda_19;
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_1 = result.gpe();
      var sourceType = getKClass(ProcessKind_1);
      var tmp$ret$0 = this_1.ypf(sourceType);
      indentChildren(result, tmp1, tmp$ret$0, null, tmp2, init);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_20($this$rootIndent) {
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_196().ab4_1;
    var refCompletion = processLibraryBuilders$lambda$lambda$lambda_99(referenceTag);
    var completionTrait = processLibraryBuilders$lambda$lambda$lambda_100(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(FieldDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, processLibraryBuilders$lambda$lambda$lambda_101(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', processLibraryBuilders$lambda$lambda$lambda_102);
    var tmp = processLibraryBuilders$lambda$lambda$lambda_103;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, '<field>', processLibraryBuilders$lambda$lambda$lambda_104(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(processLibraryBuilders$lambda$lambda$lambda_105);
    this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_106);
    this_1.zpd(processLibraryBuilders$lambda$lambda$lambda_107);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_99($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.nb4();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_8($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function processLibraryBuilders$$inlined$editor$15$1$2$1($refCompletion, $this, $source) {
    this.gsh_1 = $refCompletion;
    this.hsh_1 = $this;
    this.ish_1 = $source;
    CellTrait.call(this);
  }
  protoOf(processLibraryBuilders$$inlined$editor$15$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.gsh_1(this.hsh_1, this.ish_1, cell, processLibraryBuilders$lambda$lambda$lambda$o$get$lambda_8(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function processLibraryBuilders$lambda$lambda$lambda_100($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new processLibraryBuilders$$inlined$editor$15$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_8(s) {
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.nb4();
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_17($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_8);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_18($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_8($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_17($property));
      completion_1($this$editableText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_18($refCompletion));
      return Unit_instance;
    };
  }
  function processLibraryBuilders$$inlined$editor$15$1$3$1($cellBuilder, $refCompletion) {
    this.ksh_1 = $refCompletion;
    this.jsh_1 = $cellBuilder;
  }
  protoOf(processLibraryBuilders$$inlined$editor$15$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, processLibraryBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_8(property, this.ksh_1));
  };
  protoOf(processLibraryBuilders$$inlined$editor$15$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(processLibraryBuilders$$inlined$editor$15$1$3$1).gpe = function () {
    return this.jsh_1.gpe();
  };
  protoOf(processLibraryBuilders$$inlined$editor$15$1$3$1).qsd = function (child) {
    this.jsh_1.xpd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$15$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(processLibraryBuilders$$inlined$editor$15$1$3$1).rsd = function (init) {
    this.jsh_1.ypd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$15$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$15$1$3$1).ssd = function (init) {
    this.jsh_1.zpd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$15$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(processLibraryBuilders$$inlined$editor$15$1$3$1).tsd = function (source, cellMap, context) {
    return this.jsh_1.bpe(source, cellMap, context);
  };
  protoOf(processLibraryBuilders$$inlined$editor$15$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function processLibraryBuilders$lambda$lambda$lambda$lambda_16(it) {
    return it.b3();
  }
  function processLibraryBuilders$lambda$lambda$lambda_101($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new processLibraryBuilders$$inlined$editor$15$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<field>', VOID, processLibraryBuilders$lambda$lambda$lambda$lambda_16);
      return Unit_instance;
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_102() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function processLibraryBuilders$lambda$lambda$lambda_103(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function processLibraryBuilders$lambda$lambda$lambda_104($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function processLibraryBuilders$lambda$lambda$lambda_105($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.nb4();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_106($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.nb4();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_107($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.nb4();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function processLibraryBuilders$lambda_13($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ExtensionFieldReference_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda_20);
      return this_0;
    };
  }
  function processLibraryBuilders$lambda$lambda_21($this$rootIndent) {
    textProperty($this$rootIndent, '<name>', processLibraryBuilders$lambda$lambda$lambda_108);
    return Unit_instance;
  }
  function processLibraryBuilders$lambda$lambda$lambda_108(it) {
    return it.b3();
  }
  function processLibraryBuilders$lambda_14($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ProcessKind_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.processLibraryBuilders.<anonymous>' call
      rootIndent(result, processLibraryBuilders$lambda$lambda_21);
      return this_0;
    };
  }
  function bindingEntries$lambda(it) {
    return CellLists_instance.cmy(it);
  }
  function bindingEntries$lambda_0($this$indentChildren) {
    defaultItem($this$indentChildren, bindingEntries$lambda$lambda);
    $this$indentChildren.nph(bindingEntries$lambda$lambda_0);
    return Unit_instance;
  }
  function bindingEntries$lambda$lambda($this$defaultItem) {
    return EmptyBindingEntry($this$defaultItem.o71());
  }
  function bindingEntries$lambda$lambda_0($this$completion) {
    return abstractBindingEntryCompletion($this$completion);
  }
  function linkValueCompletion$lambda($this_linkValueCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLinkValue($this_linkValueCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.linkValueCompletion.<anonymous>.<anonymous>' call
      this_0.wc2().v2c(it);
      return this_0;
    };
  }
  function propertyValueCompletion$lambda($this_propertyValueCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyValue($this_propertyValueCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.propertyValueCompletion.<anonymous>.<anonymous>' call
      this_0.i6u().t6s(it);
      return this_0;
    };
  }
  function importedBindingEntryCompletion$lambda($this_importedBindingEntryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = ImportedLink($this_importedBindingEntryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.importedBindingEntryCompletion.<anonymous>.<anonymous>' call
      this_0.mbd().v2c(it);
      return this_0;
    };
  }
  function importedBindingEntryCompletion$lambda_0($this_importedBindingEntryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = ImportedProperty($this_importedBindingEntryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.importedBindingEntryCompletion.<anonymous>.<anonymous>' call
      this_0.mbd().v2c(it);
      return this_0;
    };
  }
  function inplaceBindingEntryCompletion$lambda($this_inplaceBindingEntryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLink($this_inplaceBindingEntryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.inplaceBindingEntryCompletion.<anonymous>.<anonymous>' call
      this_0.pbh().v2c(LinkDeclaration($this_inplaceBindingEntryCompletion.o71()));
      return this_0;
    };
  }
  function inplaceBindingEntryCompletion$lambda_0($this_inplaceBindingEntryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = BindingProperty($this_inplaceBindingEntryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.inplaceBindingEntryCompletion.<anonymous>.<anonymous>' call
      this_0.i6u().v2c(PropertyDeclaration($this_inplaceBindingEntryCompletion.o71()));
      return this_0;
    };
  }
  function ontologyReferenceValueCompletion$lambda($this_ontologyReferenceValueCompletion) {
    return function (elementName) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReferenceValue($this_ontologyReferenceValueCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.ontologyReferenceValueCompletion.<anonymous>.<anonymous>' call
      this_0.lay().v2c(OntologyElementReference_2($this_ontologyReferenceValueCompletion.o71(), elementName));
      return this_0;
    };
  }
  function ontologyReferenceValueLibraryCompletion$lambda($this_ontologyReferenceValueLibraryCompletion) {
    return function (libraryName) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReferenceValueLibrary($this_ontologyReferenceValueLibraryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.ontologyReferenceValueLibraryCompletion.<anonymous>.<anonymous>' call
      this_0.kay().v2c(OntologyLibraryReference_2($this_ontologyReferenceValueLibraryCompletion.o71(), libraryName));
      return this_0;
    };
  }
  function variableRefCompletion$lambda($this_variableRefCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = VariableReferenceValue($this_variableRefCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.variableRefCompletion.<anonymous>.<anonymous>' call
      this_0.xcq().v2c(it);
      return this_0;
    };
  }
  function enumValueCompletion$lambda($this_enumValueCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = EnumValue($this_enumValueCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.enumValueCompletion.<anonymous>.<anonymous>' call
      this_0.wb2().v2c(it);
      return this_0;
    };
  }
  function measurableValueCompletion$lambda($this_measurableValueCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = MeasurableValue($this_measurableValueCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.measurableValueCompletion.<anonymous>.<anonymous>' call
      this_0.fd2(it);
      return this_0;
    };
  }
  function queryCommandBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(queryCommandBuilders$lambda(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(queryCommandBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_1 = new LazyMapperBuilder(queryCommandBuilders$lambda_1(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_1);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_2 = new LazyMapperBuilder(queryCommandBuilders$lambda_2(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_2);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_3 = new LazyMapperBuilder(queryCommandBuilders$lambda_3(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_3);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_4 = new LazyMapperBuilder(queryCommandBuilders$lambda_4(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_4);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_5 = new LazyMapperBuilder(queryCommandBuilders$lambda_5(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_5);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_6 = new LazyMapperBuilder(queryCommandBuilders$lambda_6(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_6);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_7 = new LazyMapperBuilder(queryCommandBuilders$lambda_7(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_7);
  }
  function get_contextQueryRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(ContextQuery_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-contextQueryRole>.<anonymous>' call
    builder.ppn('<context>');
    builder.qpn(_get_contextQueryRole_$lambda_vdc7o1);
    var simpleClassName = ensureNotNull(getKClass(ContextQuery_1).lb());
    builder.tpn(simpleClassName, _get_contextQueryRole_$lambda_vdc7o1_0);
    return builder;
  }
  function libraryProcessSpecificationQueryChild(_this__u8e3s4, placeholder, role) {
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = libraryProcessSpecificationQueryChild$lambda;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = _this__u8e3s4.gpe();
    var sourceType = getKClass(LibraryProcessSpecificationQuery_1);
    var tmp$ret$0 = this_0.ypf(sourceType);
    indentChild(_this__u8e3s4, role, tmp$ret$0, placeholder, init);
  }
  function bindingValueQueryCompletion(_this__u8e3s4) {
    return plus_12(plus_12(bindingValueMaskCompletion(_this__u8e3s4), linkDeclarationValueQueryCompletion(_this__u8e3s4)), propertyDeclarationValueQueryCompletion(_this__u8e3s4));
  }
  function valueChild(_this__u8e3s4) {
    var tmp1 = valueChild$lambda;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = valueChild$lambda_0;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = _this__u8e3s4.gpe();
    var sourceType = getKClass(AbstractValue);
    var tmp$ret$0 = this_0.ypf(sourceType);
    indentChild(_this__u8e3s4, tmp1, tmp$ret$0, '<value>', init);
  }
  function libraryProcessSpecificationQueryCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_208().kc6_1);
    return map_2(tmp, libraryProcessSpecificationQueryCompletion$lambda(_this__u8e3s4));
  }
  function propertyDeclarationValueQueryCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_216().qce_1);
    return map_2(tmp, propertyDeclarationValueQueryCompletion$lambda(_this__u8e3s4));
  }
  function linkDeclarationValueQueryCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_218().vc1_1);
    return map_2(tmp, linkDeclarationValueQueryCompletion$lambda(_this__u8e3s4));
  }
  function bindingValueMaskCompletion(_this__u8e3s4) {
    var tmp = bindingValueCompletion(_this__u8e3s4);
    return map_2(tmp, bindingValueMaskCompletion$lambda(_this__u8e3s4));
  }
  function queryCommandBuilders$lambda$lambda$lambda($this$default) {
    // Inline function 'kotlin.apply' call
    var this_0 = FindConnectionCommand($this$default.o71());
    // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    this_0.g3x().v2c(LibraryProcessSpecificationQuery($this$default.o71()));
    this_0.h3x().v2c(LibraryProcessSpecificationQuery($this$default.o71()));
    return this_0;
  }
  function queryCommandBuilders$lambda$lambda$lambda_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function queryCommandBuilders$lambda$lambda$lambda_1(it) {
    return it.v4n();
  }
  function queryCommandBuilders$lambda$lambda($this_queryCommandBuilders) {
    return function ($this$indent) {
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
      // Inline function 'jetbrains.ocelot.langDef.editor.role' call
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_0 = $this_queryCommandBuilders;
      var sourceType = getKClass(Command_0);
      var tmp$ret$0 = this_0.ypf(sourceType);
      var builder = new ChildBuilder(tmp$ret$0);
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
      builder.ppn('<commands>');
      builder.spn();
      builder.qpn(queryCommandBuilders$lambda$lambda$lambda);
      var simpleClassName = ensureNotNull(getKClass(Command_0).lb());
      builder.tpn(simpleClassName, queryCommandBuilders$lambda$lambda$lambda_0);
      var tmp = builder;
      children_1($this$indent, tmp, queryCommandBuilders$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda($this, $this_queryCommandBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(QueryCommands_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>' call
      indent(result, VOID, queryCommandBuilders$lambda$lambda($this_queryCommandBuilders));
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_2(it) {
    return it.vb8();
  }
  function queryCommandBuilders$lambda$lambda$lambda_3($this$indent) {
    newLine($this$indent);
    keyword($this$indent, 'from');
    space($this$indent);
    libraryProcessSpecificationQueryChild($this$indent, '<from>', queryCommandBuilders$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda(it) {
    return it.g3x();
  }
  function queryCommandBuilders$lambda$lambda$lambda_4($this$indent) {
    newLine($this$indent);
    keyword($this$indent, 'to');
    space($this$indent);
    libraryProcessSpecificationQueryChild($this$indent, '<to>', queryCommandBuilders$lambda$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda_0(it) {
    return it.h3x();
  }
  function queryCommandBuilders$lambda$lambda_0($this_queryCommandBuilders) {
    return function ($this$rootIndent) {
      keyword($this$rootIndent, 'find connection');
      newLine($this$rootIndent);
      keyword($this$rootIndent, 'with');
      space($this$rootIndent);
      var tmp = get_contextQueryRole($this_queryCommandBuilders);
      child_0($this$rootIndent, tmp, queryCommandBuilders$lambda$lambda$lambda_2);
      indent($this$rootIndent, true, queryCommandBuilders$lambda$lambda$lambda_3);
      indent($this$rootIndent, true, queryCommandBuilders$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda_0($this, $this_queryCommandBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(FindConnectionCommand_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>' call
      rootIndent(result, queryCommandBuilders$lambda$lambda_0($this_queryCommandBuilders));
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_5(it) {
    return it.kay();
  }
  function queryCommandBuilders$lambda$lambda$lambda_6(it) {
    return it.lay();
  }
  function queryCommandBuilders$lambda$lambda_1($this_queryCommandBuilders) {
    return function ($this$rootIndent) {
      var tmp = get_ontologyLibraryReferenceRole($this_queryCommandBuilders);
      child_0($this$rootIndent, tmp, queryCommandBuilders$lambda$lambda$lambda_5);
      indentLabel($this$rootIndent, '/');
      var tmp_0 = get_ontologyElementReferenceRole($this_queryCommandBuilders);
      child_0($this$rootIndent, tmp_0, queryCommandBuilders$lambda$lambda$lambda_6);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda_1($this, $this_queryCommandBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ContextQuery_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>' call
      rootIndent(result, queryCommandBuilders$lambda$lambda_1($this_queryCommandBuilders));
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_7($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.jbg();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function queryCommandBuilders$$inlined$editor$4$1$2$1($refCompletion, $this, $source) {
    this.lsh_1 = $refCompletion;
    this.msh_1 = $this;
    this.nsh_1 = $source;
    CellTrait.call(this);
  }
  protoOf(queryCommandBuilders$$inlined$editor$4$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.lsh_1(this.msh_1, this.nsh_1, cell, queryCommandBuilders$lambda$lambda$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function queryCommandBuilders$lambda$lambda$lambda_8($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new queryCommandBuilders$$inlined$editor$4$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda(s) {
    // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.jbg();
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property));
      completion_1($this$editableText, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion));
      return Unit_instance;
    };
  }
  function queryCommandBuilders$$inlined$editor$4$1$3$1($cellBuilder, $refCompletion) {
    this.psh_1 = $refCompletion;
    this.osh_1 = $cellBuilder;
  }
  protoOf(queryCommandBuilders$$inlined$editor$4$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda(property, this.psh_1));
  };
  protoOf(queryCommandBuilders$$inlined$editor$4$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(queryCommandBuilders$$inlined$editor$4$1$3$1).gpe = function () {
    return this.osh_1.gpe();
  };
  protoOf(queryCommandBuilders$$inlined$editor$4$1$3$1).qsd = function (child) {
    this.osh_1.xpd(child);
  };
  protoOf(queryCommandBuilders$$inlined$editor$4$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(queryCommandBuilders$$inlined$editor$4$1$3$1).rsd = function (init) {
    this.osh_1.ypd(init);
  };
  protoOf(queryCommandBuilders$$inlined$editor$4$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(queryCommandBuilders$$inlined$editor$4$1$3$1).ssd = function (init) {
    this.osh_1.zpd(init);
  };
  protoOf(queryCommandBuilders$$inlined$editor$4$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(queryCommandBuilders$$inlined$editor$4$1$3$1).tsd = function (source, cellMap, context) {
    return this.osh_1.bpe(source, cellMap, context);
  };
  protoOf(queryCommandBuilders$$inlined$editor$4$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function queryCommandBuilders$lambda$lambda$lambda$lambda_1(it) {
    return it.b3();
  }
  function queryCommandBuilders$lambda$lambda$lambda_9($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new queryCommandBuilders$$inlined$editor$4$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<process>', VOID, queryCommandBuilders$lambda$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_10() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function queryCommandBuilders$lambda$lambda$lambda_11(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function queryCommandBuilders$lambda$lambda$lambda_12($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_13($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.jbg();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_14($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.jbg();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_15($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.jbg();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_16($this$completion) {
    return bindingValueQueryCompletion($this$completion);
  }
  function queryCommandBuilders$lambda$lambda$lambda_17($this$default) {
    return BindingValuePlaceholderQuery($this$default.o71());
  }
  function queryCommandBuilders$lambda$lambda$lambda_18($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function queryCommandBuilders$lambda$lambda$lambda_19(it) {
    return it.tba();
  }
  function queryCommandBuilders$lambda$lambda_2($this_queryCommandBuilders) {
    return function ($this$rootIndent) {
      var tmp1 = '<process>';
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
      var referenceTag = Companion_getInstance_208().kc6_1;
      var refCompletion = queryCommandBuilders$lambda$lambda$lambda_7(referenceTag);
      var completionTrait = queryCommandBuilders$lambda$lambda$lambda_8(refCompletion);
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(ProcessDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
      rootIndent(result, queryCommandBuilders$lambda$lambda$lambda_9(refCompletion));
      var mapperBuilder = this_0;
      var tmp0_cellFactory = new NamedCellFactory('referenceData', queryCommandBuilders$lambda$lambda$lambda_10);
      var tmp = queryCommandBuilders$lambda$lambda$lambda_11;
      // Inline function 'kotlin.apply' call
      var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp1, queryCommandBuilders$lambda$lambda$lambda_12(completionTrait));
      // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
      this_1.ypd(queryCommandBuilders$lambda$lambda$lambda_13);
      this_1.zpd(queryCommandBuilders$lambda$lambda$lambda_14);
      this_1.zpd(queryCommandBuilders$lambda$lambda$lambda_15);
      indentLabel($this$rootIndent, '(');
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
      // Inline function 'jetbrains.ocelot.langDef.editor.role' call
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_2 = $this_queryCommandBuilders;
      var sourceType = getKClass(BindingValuePlaceholderQuery_1);
      var tmp$ret$3 = this_2.ypf(sourceType);
      var builder = new ChildBuilder(tmp$ret$3);
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
      builder.opn(queryCommandBuilders$lambda$lambda$lambda_16);
      builder.rpn(', ');
      builder.qpn(queryCommandBuilders$lambda$lambda$lambda_17);
      var simpleClassName = ensureNotNull(getKClass(BindingValuePlaceholderQuery_1).lb());
      builder.tpn(simpleClassName, queryCommandBuilders$lambda$lambda$lambda_18);
      var tmp_0 = builder;
      children_1($this$rootIndent, tmp_0, queryCommandBuilders$lambda$lambda$lambda_19);
      indentLabel($this$rootIndent, ')', true);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda_2($this, $this_queryCommandBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(LibraryProcessSpecificationQuery_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>' call
      rootIndent(result, queryCommandBuilders$lambda$lambda_2($this_queryCommandBuilders));
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_20($this$completion) {
    return bindingValueQueryCompletion($this$completion);
  }
  function queryCommandBuilders$lambda$lambda$lambda_21($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function queryCommandBuilders$lambda$lambda$lambda_22(it) {
    return it.sbf();
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda_2($this$completion) {
    return bindingValueQueryCompletion($this$completion);
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda_3($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda_4(it) {
    return it.tbf();
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda_5($this$addTraitOnAttach, source, _unused_var__etf5q3, cellFinder) {
    return getDeleteTransformTrait_0(source, cellFinder);
  }
  function queryCommandBuilders$lambda$lambda$lambda_23($this_queryCommandBuilders) {
    return function ($this$indent) {
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
      // Inline function 'jetbrains.ocelot.langDef.editor.role' call
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_0 = $this_queryCommandBuilders;
      var sourceType = getKClass(AbstractBindingValueQuery);
      var tmp$ret$0 = this_0.ypf(sourceType);
      var builder = new ChildBuilder(tmp$ret$0);
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      builder.opn(queryCommandBuilders$lambda$lambda$lambda$lambda_2);
      builder.ppn('<right>');
      var simpleClassName = ensureNotNull(getKClass(AbstractBindingValueQuery).lb());
      builder.tpn(simpleClassName, queryCommandBuilders$lambda$lambda$lambda$lambda_3);
      var tmp = builder;
      child_0($this$indent, tmp, queryCommandBuilders$lambda$lambda$lambda$lambda_4);
      addTraitOnAttach($this$indent, queryCommandBuilders$lambda$lambda$lambda$lambda_5);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda_3($this_queryCommandBuilders) {
    return function ($this$rootIndent) {
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
      // Inline function 'jetbrains.ocelot.langDef.editor.role' call
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_0 = $this_queryCommandBuilders;
      var sourceType = getKClass(AbstractBindingValueQuery);
      var tmp$ret$0 = this_0.ypf(sourceType);
      var builder = new ChildBuilder(tmp$ret$0);
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
      builder.opn(queryCommandBuilders$lambda$lambda$lambda_20);
      builder.ppn('<left>');
      var simpleClassName = ensureNotNull(getKClass(AbstractBindingValueQuery).lb());
      builder.tpn(simpleClassName, queryCommandBuilders$lambda$lambda$lambda_21);
      var tmp = builder;
      child_0($this$rootIndent, tmp, queryCommandBuilders$lambda$lambda$lambda_22);
      space($this$rootIndent);
      label($this$rootIndent, '||');
      space($this$rootIndent);
      indent($this$rootIndent, VOID, queryCommandBuilders$lambda$lambda$lambda_23($this_queryCommandBuilders));
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda_3($this, $this_queryCommandBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OrValueQuery_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>' call
      rootIndent(result, queryCommandBuilders$lambda$lambda_3($this_queryCommandBuilders));
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda_4($this$rootIndent) {
    var tmp1 = queryCommandBuilders$lambda$lambda$lambda_24;
    // Inline function 'jetbrains.ocelot.langDef.editor.indentChild' call
    var init = queryCommandBuilders$lambda$lambda$lambda_25;
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var this_0 = $this$rootIndent.gpe();
    var sourceType = getKClass(BindingValuePlaceholder_1);
    var tmp$ret$0 = this_0.ypf(sourceType);
    indentChild($this$rootIndent, tmp1, tmp$ret$0, '<value>', init);
    // Inline function 'kotlin.apply' call
    var this_1 = editableText($this$rootIndent, isEmpty$ref_2(), '');
    // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
    rightTransform(this_1, queryCommandBuilders$lambda$lambda$lambda_26);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_24(it) {
    return it.y();
  }
  function queryCommandBuilders$lambda$lambda$lambda_25($this$indentChild) {
    $this$indentChild.nph(queryCommandBuilders$lambda$lambda$lambda$lambda_6);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda$lambda_6($this$completion) {
    return bindingValueCompletion($this$completion);
  }
  function isEmpty$ref_2() {
    var l = function (p0) {
      return isEmpty(p0);
    };
    l.callableName = 'isEmpty';
    return l;
  }
  function queryCommandBuilders$lambda$lambda$lambda_26($this$rightTransform, source, _unused_var__etf5q3, cellFinder) {
    var tmp = CompletionSupplement_instance;
    return tmp.smc([completes('||', queryCommandBuilders$lambda$lambda$lambda$lambda_7($this$rightTransform, source, cellFinder))]);
  }
  function queryCommandBuilders$$inlined$editor$6$1$3$1$1($this_rightTransform, $source, $cellFinder) {
    this.qsh_1 = $this_rightTransform;
    this.rsh_1 = $source;
    this.ssh_1 = $cellFinder;
  }
  protoOf(queryCommandBuilders$$inlined$editor$6$1$3$1$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    var it = OrValueQuery(this.qsh_1.o71());
    var tmp = this.rsh_1.yt();
    var parentOr = (!(tmp == null) ? isInterface(tmp, OrValueQuery_1) : false) ? tmp : null;
    if (parentOr == null || equals(builder.n51(parentOr.tbf()), this.rsh_1)) {
      var tmp_0 = it.sbf();
      var tmp_1 = this.rsh_1.u6m();
      tmp_0.v2c(isInterface(tmp_1, BindingValueMask_1) ? tmp_1 : THROW_CCE());
      this.rsh_1.s6m(it);
    } else {
      var tmp_2 = it.tbf();
      var tmp0_safe_receiver = builder.n51(parentOr.tbf());
      var tmp_3 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u6m();
      tmp_2.v2c((!(tmp_3 == null) ? isInterface(tmp_3, AbstractBindingValueQuery) : false) ? tmp_3 : null);
      parentOr.tbf().v2c(it);
    }
    var tmp1_safe_receiver = firstOrNull_1(this.ssh_1.vn4(it));
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ulp(ProjectionalSynchronizers_getInstance().jlw_1);
    return tmp2_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp2_elvis_lhs;
  };
  function queryCommandBuilders$lambda$lambda$lambda$lambda_7($this_rightTransform, $source, $cellFinder) {
    return function () {
      // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      var tmp$ret$0 = new queryCommandBuilders$$inlined$editor$6$1$3$1$1($this_rightTransform, $source, $cellFinder);
      return execute_0(tmp$ret$0);
    };
  }
  function queryCommandBuilders$lambda_4($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(BindingValueMask_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>' call
      rootIndent(result, queryCommandBuilders$lambda$lambda_4);
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda_5($this$rootIndent) {
    var tmp1 = '<linkDeclaration>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_218().vc1_1;
    var refCompletion = queryCommandBuilders$lambda$lambda$lambda_27(referenceTag);
    var completionTrait = queryCommandBuilders$lambda$lambda$lambda_28(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(LinkDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, queryCommandBuilders$lambda$lambda$lambda_29(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', queryCommandBuilders$lambda$lambda$lambda_30);
    var tmp = queryCommandBuilders$lambda$lambda$lambda_31;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp1, queryCommandBuilders$lambda$lambda$lambda_32(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(queryCommandBuilders$lambda$lambda$lambda_33);
    this_1.zpd(queryCommandBuilders$lambda$lambda$lambda_34);
    this_1.zpd(queryCommandBuilders$lambda$lambda$lambda_35);
    space($this$rootIndent);
    label($this$rootIndent, '=');
    space($this$rootIndent);
    valueChild($this$rootIndent);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_27($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.ic2();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$get$lambda_0($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function queryCommandBuilders$$inlined$editor$7$1$2$1($refCompletion, $this, $source) {
    this.tsh_1 = $refCompletion;
    this.ush_1 = $this;
    this.vsh_1 = $source;
    CellTrait.call(this);
  }
  protoOf(queryCommandBuilders$$inlined$editor$7$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.tsh_1(this.ush_1, this.vsh_1, cell, queryCommandBuilders$lambda$lambda$lambda$o$get$lambda_0(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function queryCommandBuilders$lambda$lambda$lambda_28($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new queryCommandBuilders$$inlined$editor$7$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_0(s) {
    // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.ic2();
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_1($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_2($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_0($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_1($property));
      completion_1($this$editableText, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_2($refCompletion));
      return Unit_instance;
    };
  }
  function queryCommandBuilders$$inlined$editor$7$1$3$1($cellBuilder, $refCompletion) {
    this.xsh_1 = $refCompletion;
    this.wsh_1 = $cellBuilder;
  }
  protoOf(queryCommandBuilders$$inlined$editor$7$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_0(property, this.xsh_1));
  };
  protoOf(queryCommandBuilders$$inlined$editor$7$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(queryCommandBuilders$$inlined$editor$7$1$3$1).gpe = function () {
    return this.wsh_1.gpe();
  };
  protoOf(queryCommandBuilders$$inlined$editor$7$1$3$1).qsd = function (child) {
    this.wsh_1.xpd(child);
  };
  protoOf(queryCommandBuilders$$inlined$editor$7$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(queryCommandBuilders$$inlined$editor$7$1$3$1).rsd = function (init) {
    this.wsh_1.ypd(init);
  };
  protoOf(queryCommandBuilders$$inlined$editor$7$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(queryCommandBuilders$$inlined$editor$7$1$3$1).ssd = function (init) {
    this.wsh_1.zpd(init);
  };
  protoOf(queryCommandBuilders$$inlined$editor$7$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(queryCommandBuilders$$inlined$editor$7$1$3$1).tsd = function (source, cellMap, context) {
    return this.wsh_1.bpe(source, cellMap, context);
  };
  protoOf(queryCommandBuilders$$inlined$editor$7$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function queryCommandBuilders$lambda$lambda$lambda$lambda_8(it) {
    return it.b3();
  }
  function queryCommandBuilders$lambda$lambda$lambda_29($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new queryCommandBuilders$$inlined$editor$7$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<linkDeclaration>', VOID, queryCommandBuilders$lambda$lambda$lambda$lambda_8);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_30() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function queryCommandBuilders$lambda$lambda$lambda_31(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function queryCommandBuilders$lambda$lambda$lambda_32($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_33($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.ic2();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_34($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.ic2();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_35($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.ic2();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function queryCommandBuilders$lambda_5($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyLinkDeclarationValueQuery_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>' call
      rootIndent(result, queryCommandBuilders$lambda$lambda_5);
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda_6($this$rootIndent) {
    var tmp1 = '<propertyDeclaration>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_216().qce_1;
    var refCompletion = queryCommandBuilders$lambda$lambda$lambda_36(referenceTag);
    var completionTrait = queryCommandBuilders$lambda$lambda$lambda_37(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(PropertyDeclaration_1));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, queryCommandBuilders$lambda$lambda$lambda_38(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', queryCommandBuilders$lambda$lambda$lambda_39);
    var tmp = queryCommandBuilders$lambda$lambda$lambda_40;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp1, queryCommandBuilders$lambda$lambda$lambda_41(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(queryCommandBuilders$lambda$lambda$lambda_42);
    this_1.zpd(queryCommandBuilders$lambda$lambda$lambda_43);
    this_1.zpd(queryCommandBuilders$lambda$lambda$lambda_44);
    space($this$rootIndent);
    label($this$rootIndent, '=');
    space($this$rootIndent);
    valueChild($this$rootIndent);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_36($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.dcf();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$get$lambda_1($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function queryCommandBuilders$$inlined$editor$8$1$2$1($refCompletion, $this, $source) {
    this.ysh_1 = $refCompletion;
    this.zsh_1 = $this;
    this.asi_1 = $source;
    CellTrait.call(this);
  }
  protoOf(queryCommandBuilders$$inlined$editor$8$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.ysh_1(this.zsh_1, this.asi_1, cell, queryCommandBuilders$lambda$lambda$lambda$o$get$lambda_1(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function queryCommandBuilders$lambda$lambda$lambda_37($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new queryCommandBuilders$$inlined$editor$8$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_1(s) {
    // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.dcf();
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_3($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_4($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_1($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_3($property));
      completion_1($this$editableText, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_4($refCompletion));
      return Unit_instance;
    };
  }
  function queryCommandBuilders$$inlined$editor$8$1$3$1($cellBuilder, $refCompletion) {
    this.csi_1 = $refCompletion;
    this.bsi_1 = $cellBuilder;
  }
  protoOf(queryCommandBuilders$$inlined$editor$8$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, queryCommandBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda_1(property, this.csi_1));
  };
  protoOf(queryCommandBuilders$$inlined$editor$8$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(queryCommandBuilders$$inlined$editor$8$1$3$1).gpe = function () {
    return this.bsi_1.gpe();
  };
  protoOf(queryCommandBuilders$$inlined$editor$8$1$3$1).qsd = function (child) {
    this.bsi_1.xpd(child);
  };
  protoOf(queryCommandBuilders$$inlined$editor$8$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(queryCommandBuilders$$inlined$editor$8$1$3$1).rsd = function (init) {
    this.bsi_1.ypd(init);
  };
  protoOf(queryCommandBuilders$$inlined$editor$8$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(queryCommandBuilders$$inlined$editor$8$1$3$1).ssd = function (init) {
    this.bsi_1.zpd(init);
  };
  protoOf(queryCommandBuilders$$inlined$editor$8$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(queryCommandBuilders$$inlined$editor$8$1$3$1).tsd = function (source, cellMap, context) {
    return this.bsi_1.bpe(source, cellMap, context);
  };
  protoOf(queryCommandBuilders$$inlined$editor$8$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function queryCommandBuilders$lambda$lambda$lambda$lambda_9(it) {
    return it.b3();
  }
  function queryCommandBuilders$lambda$lambda$lambda_38($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new queryCommandBuilders$$inlined$editor$8$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<propertyDeclaration>', VOID, queryCommandBuilders$lambda$lambda$lambda$lambda_9);
      return Unit_instance;
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_39() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function queryCommandBuilders$lambda$lambda$lambda_40(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function queryCommandBuilders$lambda$lambda$lambda_41($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function queryCommandBuilders$lambda$lambda$lambda_42($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.dcf();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_43($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.dcf();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function queryCommandBuilders$lambda$lambda$lambda_44($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.dcf();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function queryCommandBuilders$lambda_6($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(PropertyDeclarationValueQuery_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>' call
      rootIndent(result, queryCommandBuilders$lambda$lambda_6);
      return this_0;
    };
  }
  function queryCommandBuilders$lambda$lambda_7($this$rootIndent) {
    label($this$rootIndent, '<argument>');
    return Unit_instance;
  }
  function queryCommandBuilders$lambda_7($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(BindingValuePlaceholderQuery_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.queryCommandBuilders.<anonymous>' call
      rootIndent(result, queryCommandBuilders$lambda$lambda_7);
      return this_0;
    };
  }
  function _get_contextQueryRole_$lambda_vdc7o1($this$default) {
    return ContextQuery($this$default.o71());
  }
  function _get_contextQueryRole_$lambda_vdc7o1_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function libraryProcessSpecificationQueryChild$lambda($this$indentChild) {
    defaultItem($this$indentChild, libraryProcessSpecificationQueryChild$lambda$lambda);
    $this$indentChild.nph(libraryProcessSpecificationQueryChild$lambda$lambda_0);
    return Unit_instance;
  }
  function libraryProcessSpecificationQueryChild$lambda$lambda($this$defaultItem) {
    return LibraryProcessSpecificationQuery($this$defaultItem.o71());
  }
  function libraryProcessSpecificationQueryChild$lambda$lambda_0($this$completion) {
    return libraryProcessSpecificationQueryCompletion($this$completion);
  }
  function valueChild$lambda(it) {
    return it.y();
  }
  function valueChild$lambda_0($this$indentChild) {
    $this$indentChild.nph(valueChild$lambda$lambda);
    return Unit_instance;
  }
  function valueChild$lambda$lambda($this$completion) {
    return abstractValueCompletion($this$completion);
  }
  function libraryProcessSpecificationQueryCompletion$lambda($this_libraryProcessSpecificationQueryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = LibraryProcessSpecificationQuery($this_libraryProcessSpecificationQueryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.libraryProcessSpecificationQueryCompletion.<anonymous>.<anonymous>' call
      this_0.jbg().v2c(it);
      return this_0;
    };
  }
  function propertyDeclarationValueQueryCompletion$lambda($this_propertyDeclarationValueQueryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyDeclarationValueQuery($this_propertyDeclarationValueQueryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.propertyDeclarationValueQueryCompletion.<anonymous>.<anonymous>' call
      this_0.dcf().v2c(it);
      return this_0;
    };
  }
  function linkDeclarationValueQueryCompletion$lambda($this_linkDeclarationValueQueryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLinkDeclarationValueQuery($this_linkDeclarationValueQueryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.linkDeclarationValueQueryCompletion.<anonymous>.<anonymous>' call
      this_0.ic2().v2c(it);
      return this_0;
    };
  }
  function bindingValueMaskCompletion$lambda($this_bindingValueMaskCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = BindingValueMask($this_bindingValueMaskCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.bindingValueMaskCompletion.<anonymous>.<anonymous>' call
      this_0.y().v2c(it);
      return this_0;
    };
  }
  function relationLibraryBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(relationLibraryBuilders$lambda(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(relationLibraryBuilders$lambda_0(_this__u8e3s4));
    _this__u8e3s4.wpf(builder_0);
  }
  function relationLibraryBuilders$lambda$lambda$lambda($this$default) {
    return ProcessRelationDeclaration($this$default.o71());
  }
  function relationLibraryBuilders$lambda$lambda$lambda_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function relationLibraryBuilders$lambda$lambda$lambda_1(it) {
    return it.ccl();
  }
  function relationLibraryBuilders$lambda$lambda($this_relationLibraryBuilders) {
    return function ($this$indent) {
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
      // Inline function 'jetbrains.ocelot.langDef.editor.role' call
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
      var this_0 = $this_relationLibraryBuilders;
      var sourceType = getKClass(ProcessRelationDeclaration_1);
      var tmp$ret$0 = this_0.ypf(sourceType);
      var builder = new ChildBuilder(tmp$ret$0);
      // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
      // Inline function 'jetbrains.biokb.lang.builders.relationLibraryBuilders.<anonymous>.<anonymous>.<anonymous>' call
      builder.spn();
      builder.qpn(relationLibraryBuilders$lambda$lambda$lambda);
      var simpleClassName = ensureNotNull(getKClass(ProcessRelationDeclaration_1).lb());
      builder.tpn(simpleClassName, relationLibraryBuilders$lambda$lambda$lambda_0);
      var tmp = builder;
      children_1($this$indent, tmp, relationLibraryBuilders$lambda$lambda$lambda_1);
      return Unit_instance;
    };
  }
  function relationLibraryBuilders$lambda($this, $this_relationLibraryBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(RelationContainer_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.relationLibraryBuilders.<anonymous>' call
      indent(result, VOID, relationLibraryBuilders$lambda$lambda($this_relationLibraryBuilders));
      return this_0;
    };
  }
  function relationLibraryBuilders$lambda$lambda_0($this$rootIndent) {
    textProperty($this$rootIndent, '<name>', relationLibraryBuilders$lambda$lambda$lambda_2);
    space($this$rootIndent);
    textProperty($this$rootIndent, '<symbol>', relationLibraryBuilders$lambda$lambda$lambda_3);
    return Unit_instance;
  }
  function relationLibraryBuilders$lambda$lambda$lambda_2(it) {
    return it.b3();
  }
  function relationLibraryBuilders$lambda$lambda$lambda_3(it) {
    return it.jcc();
  }
  function relationLibraryBuilders$lambda_0($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(ProcessRelationDeclaration_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.relationLibraryBuilders.<anonymous>' call
      rootIndent(result, relationLibraryBuilders$lambda$lambda_0);
      return this_0;
    };
  }
  function notionTypeBuilders(_this__u8e3s4) {
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder = new LazyMapperBuilder(notionTypeBuilders$lambda(_this__u8e3s4));
    _this__u8e3s4.wpf(builder);
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor' call
    var builder_0 = new LazyMapperBuilder(notionTypeBuilders$lambda_0(_this__u8e3s4, _this__u8e3s4));
    _this__u8e3s4.wpf(builder_0);
  }
  function get_typeRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(VariableSpecification);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-typeRole>.<anonymous>' call
    builder.opn(_get_typeRole_$lambda_40iqa8);
    var simpleClassName = ensureNotNull(getKClass(VariableSpecification).lb());
    builder.tpn(simpleClassName, _get_typeRole_$lambda_40iqa8_0);
    return builder;
  }
  function get_ontologyElementTypeRole(_this__u8e3s4) {
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole' call
    // Inline function 'jetbrains.ocelot.langDef.editor.role' call
    // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.builder' call
    var sourceType = getKClass(OntologyElementType_1);
    var tmp$ret$0 = _this__u8e3s4.ypf(sourceType);
    var builder = new ChildBuilder(tmp$ret$0);
    // Inline function 'jetbrains.biokb.lang.builders.nodeRole.<anonymous>' call
    // Inline function 'jetbrains.biokb.lang.builders.<get-ontologyElementTypeRole>.<anonymous>' call
    builder.opn(_get_ontologyElementTypeRole_$lambda_kwqmvr);
    builder.qpn(_get_ontologyElementTypeRole_$lambda_kwqmvr_0);
    var simpleClassName = ensureNotNull(getKClass(OntologyElementType_1).lb());
    builder.tpn(simpleClassName, _get_ontologyElementTypeRole_$lambda_kwqmvr_1);
    return builder;
  }
  function notionTypeCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_220().ybo_1);
    return map_2(tmp, notionTypeCompletion$lambda(_this__u8e3s4));
  }
  function typeCompletion(_this__u8e3s4) {
    return plus_12(notionTypeCompletion(_this__u8e3s4), ontologyElementTypeCompletion(_this__u8e3s4));
  }
  function ontologyElementTypeCompletion(_this__u8e3s4) {
    var tmp = nodeRefCompletion(_this__u8e3s4, Companion_getInstance_206().tc0_1);
    return map_2(tmp, ontologyElementTypeCompletion$lambda(_this__u8e3s4));
  }
  function notionTypeBuilders$lambda$lambda($this$rootIndent) {
    var tmp1 = '<notion>';
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget' call
    var referenceTag = Companion_getInstance_220().ybo_1;
    var refCompletion = notionTypeBuilders$lambda$lambda$lambda(referenceTag);
    var completionTrait = notionTypeBuilders$lambda$lambda$lambda_0(refCompletion);
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleMapperBuilder($this$rootIndent.gpe(), getKClass(AbstractNotion));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
    var result = new RootCellBuilderImpl(this_0);
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    rootIndent(result, notionTypeBuilders$lambda$lambda$lambda_1(refCompletion));
    var mapperBuilder = this_0;
    var tmp0_cellFactory = new NamedCellFactory('referenceData', notionTypeBuilders$lambda$lambda$lambda_2);
    var tmp = notionTypeBuilders$lambda$lambda$lambda_3;
    // Inline function 'kotlin.apply' call
    var this_1 = projectionalChild($this$rootIndent, tmp, tmp0_cellFactory, mapperBuilder, tmp1, notionTypeBuilders$lambda$lambda$lambda_4(completionTrait));
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>' call
    this_1.ypd(notionTypeBuilders$lambda$lambda$lambda_5);
    this_1.zpd(notionTypeBuilders$lambda$lambda$lambda_6);
    this_1.zpd(notionTypeBuilders$lambda$lambda$lambda_7);
    return Unit_instance;
  }
  function notionTypeBuilders$lambda$lambda$lambda($referenceTag) {
    return function (_this__u8e3s4, src, cell, cellAction) {
      var tmp = _this__u8e3s4.j6y($referenceTag);
      // Inline function 'jetbrains.biokb.lang.builders.notionTypeBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = src.lbp();
      return completion(_this__u8e3s4, tmp, src, tmp$ret$0, cell, VOID, cellAction);
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda$o$get$lambda($cell) {
    return function (it) {
      return signalCompletionHappened($cell, false, it);
    };
  }
  function notionTypeBuilders$$inlined$editor$1$1$2$1($refCompletion, $this, $source) {
    this.dsi_1 = $refCompletion;
    this.esi_1 = $this;
    this.fsi_1 = $source;
    CellTrait.call(this);
  }
  protoOf(notionTypeBuilders$$inlined$editor$1$1$2$1).flo = function (cell, spec) {
    var tmp;
    if (equals(spec, Completion_getInstance().cm1_1)) {
      tmp = this.dsi_1(this.esi_1, this.fsi_1, cell, notionTypeBuilders$lambda$lambda$lambda$o$get$lambda(cell));
    } else {
      tmp = protoOf(CellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function notionTypeBuilders$lambda$lambda$lambda_0($refCompletion) {
    return function (_this__u8e3s4, source) {
      return new notionTypeBuilders$$inlined$editor$1$1$2$1($refCompletion, _this__u8e3s4, source);
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda(s) {
    // Inline function 'jetbrains.biokb.lang.builders.notionTypeBuilders.<anonymous>.<anonymous>.<anonymous>' call
    return s.lbp();
  }
  function notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property) {
    return function ($this$setup, source, textCell) {
      var referenceTextPropSupplier = getLoopQuerySupplier($property);
      var loopQuery = referenceTextPropSupplier(source, $this$setup.hpe(), textCell);
      $this$setup.wle(syncOneWay(loopQuery, textCell.laz()));
      var tmp = getKClass(QualifiedReferenceContent);
      connectWithRefSupport(textCell, loopQuery, tmp, notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion) {
    return function ($this$completion, _unused_var__etf5q3, textCell, _unused_var__etf5q3_0) {
      var refCompletionArgs = getRefCompletionArgs(textCell);
      var source = refCompletionArgs.dpz_1;
      var cellAction = refCompletionArgs.epz_1;
      return $refCompletion($this$completion, source, textCell, cellAction);
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda($property, $refCompletion) {
    return function ($this$editableText) {
      $this$editableText.ypd(notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda($property));
      completion_1($this$editableText, notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda$lambda_0($refCompletion));
      return Unit_instance;
    };
  }
  function notionTypeBuilders$$inlined$editor$1$1$3$1($cellBuilder, $refCompletion) {
    this.hsi_1 = $refCompletion;
    this.gsi_1 = $cellBuilder;
  }
  protoOf(notionTypeBuilders$$inlined$editor$1$1$3$1).psd = function (placeholderText, validator, property) {
    return editableText(this, validator, VOID, placeholderText, notionTypeBuilders$lambda$lambda$lambda$o$referenceTextProperty$lambda(property, this.hsi_1));
  };
  protoOf(notionTypeBuilders$$inlined$editor$1$1$3$1).kpg = function (placeholderText, validator, property) {
    return this.psd(placeholderText, validator, property);
  };
  protoOf(notionTypeBuilders$$inlined$editor$1$1$3$1).gpe = function () {
    return this.gsi_1.gpe();
  };
  protoOf(notionTypeBuilders$$inlined$editor$1$1$3$1).qsd = function (child) {
    this.gsi_1.xpd(child);
  };
  protoOf(notionTypeBuilders$$inlined$editor$1$1$3$1).xpd = function (child) {
    return this.qsd(child);
  };
  protoOf(notionTypeBuilders$$inlined$editor$1$1$3$1).rsd = function (init) {
    this.gsi_1.ypd(init);
  };
  protoOf(notionTypeBuilders$$inlined$editor$1$1$3$1).ypd = function (init) {
    return this.rsd(init);
  };
  protoOf(notionTypeBuilders$$inlined$editor$1$1$3$1).ssd = function (init) {
    this.gsi_1.zpd(init);
  };
  protoOf(notionTypeBuilders$$inlined$editor$1$1$3$1).zpd = function (init) {
    return this.ssd(init);
  };
  protoOf(notionTypeBuilders$$inlined$editor$1$1$3$1).tsd = function (source, cellMap, context) {
    return this.gsi_1.bpe(source, cellMap, context);
  };
  protoOf(notionTypeBuilders$$inlined$editor$1$1$3$1).bpe = function (source, cellMap, context) {
    return this.tsd((!(source == null) ? isInterface(source, DomainNode) : false) ? source : THROW_CCE(), cellMap, context);
  };
  function notionTypeBuilders$lambda$lambda$lambda$lambda(it) {
    return it.b3();
  }
  function notionTypeBuilders$lambda$lambda$lambda_1($refCompletion) {
    return function ($this$rootIndent) {
      var cellBuilder = $this$rootIndent;
      // Inline function 'jetbrains.ocelot.langDef.editor.getReferenceCellBuilder' call
      var refCellBuilder = new notionTypeBuilders$$inlined$editor$1$1$3$1(cellBuilder, $refCompletion);
      refCellBuilder.lpg('<notion>', VOID, notionTypeBuilders$lambda$lambda$lambda$lambda);
      return Unit_instance;
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda_2() {
    // Inline function 'kotlin.also' call
    var this_0 = new IndentCell();
    // Inline function 'jetbrains.ocelot.langDef.editor.referenceTarget.<anonymous>.<anonymous>' call
    Companion_getInstance_367().spy(this_0);
    return this_0;
  }
  function notionTypeBuilders$lambda$lambda$lambda_3(_unused_var__etf5q3, cell) {
    return get_forQueries(referenceData(cell).gpy_1);
  }
  function notionTypeBuilders$lambda$lambda$lambda_4($completionTrait) {
    return function ($this$lambda, source, trait) {
      return CompositeCellTraits_instance.emu([$completionTrait($this$lambda, source), trait]);
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda_5($this$setup, source, cell) {
    var referenceData_0 = referenceData(cell);
    // Inline function 'jetbrains.biokb.lang.builders.notionTypeBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.lbp();
    referenceData_0.tpy(source, tmp$ret$0);
    return Unit_instance;
  }
  function notionTypeBuilders$lambda$lambda$lambda_6($this$setupSynchronizers, source, cell) {
    var tmp0 = $this$setupSynchronizers.hpe();
    // Inline function 'jetbrains.ocelot.langDef.references.synchronizers.getReferenceTargetSync' call
    var asyncTracker = new CellAsyncTracker(cell);
    var referenceData_0 = referenceData(cell);
    var tmp = ReferenceSynchronizers_getInstance();
    // Inline function 'jetbrains.biokb.lang.builders.notionTypeBuilders.<anonymous>.<anonymous>.<anonymous>' call
    var tmp$ret$0 = source.lbp();
    var tmp$ret$1 = tmp.ypy(tmp0, tmp$ret$0, referenceData_0.gpy_1, ResolveKind_LOOSE_getInstance(), null, asyncTracker);
    $this$setupSynchronizers.wle(tmp$ret$1);
    $this$setupSynchronizers.wle(getReferenceDataMonitorSynchronizer(cell));
    return Unit_instance;
  }
  function notionTypeBuilders$lambda$lambda$lambda_7($this$setupSynchronizers, source, cell) {
    if ($this$setupSynchronizers.hpe().uph()) {
      var tmp = $this$setupSynchronizers.hpe();
      // Inline function 'jetbrains.biokb.lang.builders.notionTypeBuilders.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$0 = source.lbp();
      $this$setupSynchronizers.wle(referenceOutOfScopeSynchronizer(tmp, cell, tmp$ret$0));
      $this$setupSynchronizers.wle(highlightReferenceTargetOutOfSync(cell, cell.flp(ReferenceCells_getInstance().zpy_1)));
    }
    return Unit_instance;
  }
  function notionTypeBuilders$lambda($this) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(NotionType_0));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.notionTypeBuilders.<anonymous>' call
      rootIndent(result, notionTypeBuilders$lambda$lambda);
      return this_0;
    };
  }
  function notionTypeBuilders$lambda$lambda$lambda_8(it) {
    return it.kay();
  }
  function notionTypeBuilders$lambda$lambda$lambda_9(it) {
    return it.lay();
  }
  function notionTypeBuilders$lambda$lambda_0($this_notionTypeBuilders) {
    return function ($this$rootIndent) {
      var tmp = get_ontologyLibraryReferenceRole($this_notionTypeBuilders);
      child_0($this$rootIndent, tmp, notionTypeBuilders$lambda$lambda$lambda_8);
      indentLabel($this$rootIndent, '/');
      var tmp_0 = get_ontologyElementReferenceRole($this_notionTypeBuilders);
      child_0($this$rootIndent, tmp_0, notionTypeBuilders$lambda$lambda$lambda_9);
      return Unit_instance;
    };
  }
  function notionTypeBuilders$lambda_0($this, $this_notionTypeBuilders) {
    return function () {
      // Inline function 'kotlin.also' call
      var this_0 = new SimpleMapperBuilder($this, getKClass(OntologyElementType_1));
      // Inline function 'jetbrains.ocelot.langDef.editor.EditorScope.editor.<anonymous>.<anonymous>' call
      // Inline function 'jetbrains.ocelot.langDef.editor.SimpleMapperBuilder.rootCell' call
      var result = new RootCellBuilderImpl(this_0);
      // Inline function 'jetbrains.biokb.lang.builders.notionTypeBuilders.<anonymous>' call
      rootIndent(result, notionTypeBuilders$lambda$lambda_0($this_notionTypeBuilders));
      return this_0;
    };
  }
  function _get_typeRole_$lambda_40iqa8($this$completion) {
    return typeCompletion($this$completion);
  }
  function _get_typeRole_$lambda_40iqa8_0($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function _get_ontologyElementTypeRole_$lambda_kwqmvr($this$completion) {
    return ontologyElementTypeCompletion($this$completion);
  }
  function _get_ontologyElementTypeRole_$lambda_kwqmvr_0($this$default) {
    return OntologyElementType($this$default.o71());
  }
  function _get_ontologyElementTypeRole_$lambda_kwqmvr_1($this$clipboardParametersByCloner) {
    var tmp = new BaseNodeCloneSupport($this$clipboardParametersByCloner.ppq(), get_nodeFactory($this$clipboardParametersByCloner.o71()));
    return isInterface(tmp, ClonerSupport) ? tmp : THROW_CCE();
  }
  function notionTypeCompletion$lambda($this_notionTypeCompletion) {
    return function (it) {
      return NotionType_1($this_notionTypeCompletion.o71(), it);
    };
  }
  function ontologyElementTypeCompletion$lambda($this_ontologyElementTypeCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementType($this_ontologyElementTypeCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.builders.ontologyElementTypeCompletion.<anonymous>.<anonymous>' call
      this_0.kay().t2c(OntologyLibraryReference_2($this_ontologyElementTypeCompletion.o71(), it));
      return this_0;
    };
  }
  function get_supportFactSelection(_this__u8e3s4) {
    var tmp = _this__u8e3s4.upn();
    var tmp0_safe_receiver = isInterface(tmp, BTBEditorBuilderConfig) ? tmp : null;
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.isi()) === true;
  }
  function get_uiConfig(_this__u8e3s4) {
    var tmp = _this__u8e3s4.upn();
    return (isInterface(tmp, BTBEditorBuilderConfig) ? tmp : THROW_CCE()).jsi();
  }
  function BTBEditorBuilderConfig() {
  }
  function BTBEditorBuilderConfigImpl(wrapperContext, conceptRegistry, nodeFactory, splitMergeSupportFactory, editorRegistry, commonConfig, readOnly, highlightErrors, errorCheckConfig, indentNumSpaces, nodePointerSupport, factSelection, uiConfig) {
    EditorBuilderConfigImpl.call(this, wrapperContext, conceptRegistry, nodeFactory, splitMergeSupportFactory, editorRegistry, commonConfig, readOnly, highlightErrors, errorCheckConfig, indentNumSpaces);
    this.usi_1 = nodePointerSupport;
    this.vsi_1 = factSelection;
    this.wsi_1 = uiConfig;
  }
  protoOf(BTBEditorBuilderConfigImpl).isi = function () {
    return this.vsi_1;
  };
  protoOf(BTBEditorBuilderConfigImpl).jsi = function () {
    return this.wsi_1;
  };
  function BTBEditorConfiguration() {
  }
  function createBTBEditorConfiguration(domainModel, readOnly, highlighting, factSelection) {
    var services = domainModel.m72_1;
    var coroutineScope = CoroutineScope_0(ensureNotNull(services.h2o(CoroutineContextService_getInstance())));
    var resolveConfig = domainModel.o72_1;
    var tmp0_elvis_lhs = services.h2o(Companion_instance_117);
    var errorCheckConfig = tmp0_elvis_lhs == null ? Empty_instance_0 : tmp0_elvis_lhs;
    var editMode = readOnly ? Companion_getInstance_359().rph_1 : Companion_getInstance_359().qph_1;
    var highlightErrorsMode = highlighting ? Companion_getInstance_360().vph_1 : Companion_getInstance_360().wph_1;
    return new createBTBEditorConfiguration$1(coroutineScope, resolveConfig, errorCheckConfig, editMode, highlightErrorsMode, domainModel, factSelection);
  }
  function createBTBEditorConfiguration$1($coroutineScope, $resolveConfig, $errorCheckConfig, $editMode, $highlightErrorsMode, $domainModel, $factSelection) {
    this.xsi_1 = $coroutineScope;
    this.ysi_1 = $resolveConfig;
    this.zsi_1 = $errorCheckConfig;
    this.asj_1 = $editMode;
    this.bsj_1 = $highlightErrorsMode;
    this.csj_1 = get_nodePointerSupport($domainModel);
    this.dsj_1 = get_wrapperContext($domainModel);
    this.esj_1 = $domainModel.n72_1;
    this.fsj_1 = new OTSplitMergeSupportFactory(this.esj_1);
    this.gsj_1 = $factSelection;
  }
  protoOf(createBTBEditorConfiguration$1).i6k = function () {
    return this.csj_1;
  };
  protoOf(createBTBEditorConfiguration$1).o71 = function () {
    return this.dsj_1;
  };
  protoOf(createBTBEditorConfiguration$1).ppq = function () {
    return this.esj_1;
  };
  protoOf(createBTBEditorConfiguration$1).qpq = function () {
    return this.fsj_1;
  };
  protoOf(createBTBEditorConfiguration$1).isi = function () {
    return this.gsj_1;
  };
  protoOf(createBTBEditorConfiguration$1).et = function () {
    return this.xsi_1.et();
  };
  protoOf(createBTBEditorConfiguration$1).s6x = function (tag) {
    return this.ysi_1.s6x(tag);
  };
  protoOf(createBTBEditorConfiguration$1).j6y = function (tag) {
    return this.ysi_1.j6y(tag);
  };
  protoOf(createBTBEditorConfiguration$1).b6y = function (tag) {
    return this.ysi_1.b6y(tag);
  };
  protoOf(createBTBEditorConfiguration$1).w72 = function (concept) {
    return this.zsi_1.w72(concept);
  };
  protoOf(createBTBEditorConfiguration$1).tpe = function () {
    return this.asj_1.tpe();
  };
  protoOf(createBTBEditorConfiguration$1).uph = function () {
    return this.bsj_1.uph();
  };
  function BTBEditorUIConfig(factSelectionColor, factSelectionIcon, blankImage) {
    this.hsj_1 = factSelectionColor;
    this.isj_1 = factSelectionIcon;
    this.jsj_1 = blankImage;
  }
  function get_btbEditorDefinitions() {
    _init_properties_BTBEditorBuildersMapperFactory_kt__kpj5x0();
    var tmp0 = btbEditorDefinitions$delegate;
    // Inline function 'kotlin.getValue' call
    btbEditorDefinitions$factory();
    return tmp0.y();
  }
  var btbEditorDefinitions$delegate;
  function get_btbUiConfig() {
    _init_properties_BTBEditorBuildersMapperFactory_kt__kpj5x0();
    return btbUiConfig;
  }
  var btbUiConfig;
  function getEditorBuildersRootMapperFactory() {
    _init_properties_BTBEditorBuildersMapperFactory_kt__kpj5x0();
    return new getEditorBuildersRootMapperFactory$1();
  }
  function btbEditorDefinitions$delegate$lambda() {
    _init_properties_BTBEditorBuildersMapperFactory_kt__kpj5x0();
    return plus_4(plus_4(plus_4(plus_4(plus_4(plus_4(plus_4(plus_4(plus_4(plus_4(plus_4(plus_4(plus_4(plus_4(plus_4(plus_4(plus_4(get_btbProgramEditors(), get_extensionEditors()), get_factEditors()), get_newFactEditors()), get_functionLibraryEditors()), get_linkLibraryEditors()), get_notionLibraryEditors()), get_ontologyLibraryEditors()), get_processLibraryEditors()), get_objectPropertyEditors()), get_queryCommandEditors()), get_modifierContainerEditors()), get_relationLibraryEditors()), get_ontologyImportRootEditors()), get_customCellEditors()), get_knowledgeSourceReferenceEditors()), get_knowledgeSourceEditors()), get_btbFindUsagesViews().pq2());
  }
  function getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1($configuration) {
    this.ksj_1 = $configuration;
    this.lsj_1 = $configuration;
  }
  protoOf(getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1).s6x = function (tag) {
    return this.lsj_1.s6x(tag);
  };
  protoOf(getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1).j6y = function (tag) {
    return this.lsj_1.j6y(tag);
  };
  protoOf(getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1).b6y = function (tag) {
    return this.lsj_1.b6y(tag);
  };
  protoOf(getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1).et = function () {
    return this.ksj_1.et();
  };
  function getEditorBuildersRootMapperFactory$o$createRootMapper$lambda($wrapperContext, $conceptRegistry, $nodeFactory, $splitMergeSupportFactory, $commonConfig, $configuration, $nodePointerSupport) {
    return function (editorRegistry) {
      return new BTBEditorBuilderConfigImpl($wrapperContext, $conceptRegistry, $nodeFactory, $splitMergeSupportFactory, editorRegistry, $commonConfig, $configuration.tpe(), $configuration.uph(), $configuration, 2, $nodePointerSupport, $configuration.isi(), get_btbUiConfig());
    };
  }
  function getEditorBuildersRootMapperFactory$1() {
  }
  protoOf(getEditorBuildersRootMapperFactory$1).msj = function (configuration) {
    var commonConfig = new getEditorBuildersRootMapperFactory$1$createRootMapper$commonConfig$1(configuration);
    var conceptRegistry = configuration.ppq();
    var splitMergeSupportFactory = configuration.qpq();
    var wrapperContext = configuration.o71();
    var nodePointerSupport = configuration.i6k();
    var nodeFactory = new ConceptRegistryBasedNodeFactory(conceptRegistry, wrapperContext);
    var tmp = get_btbEditorDefinitions();
    return editorSetup(tmp, conceptRegistry, getEditorBuildersRootMapperFactory$o$createRootMapper$lambda(wrapperContext, conceptRegistry, nodeFactory, splitMergeSupportFactory, commonConfig, configuration, nodePointerSupport));
  };
  protoOf(getEditorBuildersRootMapperFactory$1).nsj = function (configuration) {
    return this.msj((!(configuration == null) ? isInterface(configuration, BTBEditorConfiguration) : false) ? configuration : THROW_CCE());
  };
  function btbEditorDefinitions$factory() {
    return getPropertyCallableRef('btbEditorDefinitions', 0, KProperty0, function () {
      return get_btbEditorDefinitions();
    }, null);
  }
  var properties_initialized_BTBEditorBuildersMapperFactory_kt_thro0m;
  function _init_properties_BTBEditorBuildersMapperFactory_kt__kpj5x0() {
    if (!properties_initialized_BTBEditorBuildersMapperFactory_kt_thro0m) {
      properties_initialized_BTBEditorBuildersMapperFactory_kt_thro0m = true;
      btbEditorDefinitions$delegate = lazy_0(btbEditorDefinitions$delegate$lambda);
      btbUiConfig = new BTBEditorUIConfig(Companion_getInstance_325().elt_1, Companion_instance_327.snn(new Vector(16, 16), 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAOVBMVEUAAABVgKptbbZmgKprfadqfqZpf6drfqdqfqdqfaZqfqZqfqdqfqdrfqdpfqhpfqdqfqZqfqf////7jhcjAAAAD3RSTlMABgceeoSFhrq78vP0+f5yU80mAAAAAWJLR0QSe7xsAAAAAEhJREFUGNNjYCALsPOwoQpwC/IxCgrycjLDBNgEWYEkIwsHXAkjmGTihQsIolDYBBhRKKC1/GBr2QXY4NZyIVEga7lZkSjSAQDl5wGwiZoItAAAAABJRU5ErkJggg=='), Companion_instance_327.snn(new Vector(16, 16), 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='));
    }
  }
  function get_btbProgramEditors() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return btbProgramEditors;
  }
  var btbProgramEditors;
  function getAbstractValueCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    measurableValueWithDefaultUnitCompletion(_this__u8e3s4);
    enumValueCompletion_0(_this__u8e3s4);
    variableReferenceValueCompletion(_this__u8e3s4);
    setExpressionCompletion(_this__u8e3s4);
    anonymousClassCompletion(_this__u8e3s4);
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_197().zb9_1);
    _this__u8e3s4.zp7(tmp, getAbstractValueCompletion$lambda(_this__u8e3s4));
    ontologyElementReferenceValueLibraryCompletion(_this__u8e3s4);
    ontologyElementReferenceValueCompletion(_this__u8e3s4);
    processPropertyReferenceCompletion(_this__u8e3s4);
  }
  function variableReferenceValueEditor(withDotRightTransform) {
    withDotRightTransform = withDotRightTransform === VOID ? true : withDotRightTransform;
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp0 = childRoleDefaults();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = variableReferenceValueEditor$lambda(withDotRightTransform);
    var triggerDependencies = emptyList();
    var tmp = getKClass(VariableReferenceValue_1);
    return new EditorDefinition(tmp, tmp0, null, true, true, triggerDependencies, variableReferenceValueEditor$lambda_0(init));
  }
  function setExpressionEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp0 = childRoleDefaults();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = setExpressionEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(SetExpression_1);
    return new EditorDefinition(tmp, tmp0, null, false, true, triggerDependencies, setExpressionEditor$lambda_0(init));
  }
  function measurableValueEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = measurableValueEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(MeasurableValue_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, measurableValueEditor$lambda_0(init));
  }
  function enumValueEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = enumValueEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(EnumValue_1);
    return new EditorDefinition(tmp, null, null, true, true, triggerDependencies, enumValueEditor$lambda_0(init));
  }
  function unionEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = unionEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(UnionClass_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, unionEditor$lambda_0(init));
  }
  function propertyReferenceValueEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = propertyReferenceValueEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(ObjectPropertyReferenceValue_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, propertyReferenceValueEditor$lambda_0(init));
  }
  function ontologyElementReferenceValueLibraryEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = ontologyElementReferenceValueLibraryEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(OntologyElementReferenceValueLibrary_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, ontologyElementReferenceValueLibraryEditor$lambda_0(init));
  }
  function ontologyElementReferenceValueEditor() {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = ontologyElementReferenceValueEditor$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(OntologyElementReferenceValue_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, ontologyElementReferenceValueEditor$lambda_0(init));
  }
  function transformValueToPropertyReference(_this__u8e3s4, cellFinder, value) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var wrapperContext = get_internalConfig(_this__u8e3s4).o71();
    var propertyReferenceValue = value.gcw(wrapperContext);
    var operation = ensureNotNull(propertyReferenceValue.i6u().n4z().m2c());
    var tmp0_safe_receiver = firstOrNull_1(cellFinder.vn4(operation));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ulp(ProjectionalSynchronizers_getInstance().jlw_1);
    return tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs;
  }
  function variablesEditor(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var variablesRoot = {_v: null};
    var tmp = keyword_0(_this__u8e3s4, 'variables:');
    // Inline function 'jetbrains.ocelot.projectional.cell.trait.keyPressedCellTrait' call
    var tmp$ret$0 = new variablesEditor$$inlined$keyPressedCellTrait$1(_this__u8e3s4, variablesRoot);
    tmp.olp(tmp$ret$0);
    indent_0(_this__u8e3s4, true, VOID, variablesEditor$lambda(variablesRoot));
  }
  function measurableValueWithDefaultUnitCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return _this__u8e3s4.ep8(measurableValueWithDefaultUnitCompletion$slambda_0(null));
  }
  function enumValueCompletion_0(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_224().jb2_1);
    _this__u8e3s4.zp7(tmp, enumValueCompletion$lambda_0(_this__u8e3s4));
  }
  function variableReferenceValueCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_221().kcq_1);
    _this__u8e3s4.zp7(tmp, variableReferenceValueCompletion$lambda(_this__u8e3s4));
  }
  function setExpressionCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    _this__u8e3s4.up7('{', setExpressionCompletion$lambda(_this__u8e3s4));
    _this__u8e3s4.up7('[', setExpressionCompletion$lambda_0(_this__u8e3s4));
  }
  function ontologyElementReferenceValueLibraryCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_206().tc0_1);
    _this__u8e3s4.zp7(tmp, ontologyElementReferenceValueLibraryCompletion$lambda(_this__u8e3s4));
  }
  function ontologyElementReferenceValueCompletion(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_205().rbv_1);
    _this__u8e3s4.zp7(tmp, ontologyElementReferenceValueCompletion$lambda(_this__u8e3s4));
  }
  function valueWithRelationsRightTransformCell(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new valueWithRelationsRightTransformCell$$inlined$executeQuery$1(_this__u8e3s4);
    execute_0(tmp$ret$0);
  }
  function toList_4(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp;
    if (_this__u8e3s4 == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.biokb.lang.editorBuilders.toList.<anonymous>' call
      tmp = listOf(_this__u8e3s4);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function btbProgramEditors$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    keyword_0($this$editor, 'categories:');
    space_0($this$editor);
    var tmp = getKClass(Category_1);
    var tmp_0 = btbProgramEditors$lambda$lambda;
    children_2($this$editor, tmp, VOID, VOID, tmp_0, VOID, VOID, VOID, VOID, btbProgramEditors$lambda$lambda_0);
    newLine_0($this$editor);
    space_0($this$editor);
    newLine_0($this$editor);
    var tmp_1 = getKClass(OntologyImportRootReference_1);
    var tmp_2 = Layout_VERTICAL_getInstance();
    children_2($this$editor, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, tmp_2, btbProgramEditors$lambda$lambda_1);
    newLine_0($this$editor);
    space_0($this$editor);
    newLine_0($this$editor);
    var tmp_3 = getKClass(FactSet_1);
    var tmp_4 = Layout_VERTICAL_getInstance();
    var factSets = children_2($this$editor, tmp_3, VOID, VOID, VOID, VOID, VOID, VOID, tmp_4, btbProgramEditors$lambda$lambda_2);
    if (get_supportFactSelection($this$editor)) {
      $this$editor.ypn().olp(new BTBDocumentFactSelectionTrait(factSets.g2r()));
    }
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda(_unused_var__etf5q3, trait) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function btbProgramEditors$lambda$lambda_0(document) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return document.rau();
  }
  function btbProgramEditors$lambda$lambda_1(document) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return document.sau();
  }
  function btbProgramEditors$lambda$lambda_2(document) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return document.qau();
  }
  function btbProgramEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_1(wrapperContext) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = Context(wrapperContext);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>' call
    this_0.kay().v2c(OntologyLibraryReference(wrapperContext));
    this_0.lay().v2c(OntologyElementReference(wrapperContext));
    return this_0;
  }
  function btbProgramEditors$lambda_2($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = textProperty_0($this$editor, '<name>', btbProgramEditors$lambda$lambda_3);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>' call
    mark_0(this_0, BTBEditorParts_getInstance().osj_1);
    indentLabel_0($this$editor, ':');
    var tmp = getKClass(OntologyLibraryReference_1);
    var tmp_0 = btbProgramEditors$lambda$lambda_4;
    var tmp_1 = btbProgramEditors$lambda$lambda_5;
    child_1($this$editor, tmp, tmp_0, VOID, tmp_1, VOID, VOID, VOID, VOID, VOID, btbProgramEditors$lambda$lambda_6);
    indentLabel_0($this$editor, '/');
    var tmp_2 = getKClass(OntologyElementReference_1);
    var tmp_3 = btbProgramEditors$lambda$lambda_7;
    child_1($this$editor, tmp_2, tmp_3, VOID, btbProgramEditors$lambda$lambda_8);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_3(context) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return context.b3();
  }
  function btbProgramEditors$lambda$lambda_4(context) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return context.kay();
  }
  function btbProgramEditors$lambda$lambda_5(_unused_var__etf5q3, trait) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function btbProgramEditors$lambda$lambda_6($this$child) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$child.wp3(Companion_getInstance_206().tc0_1);
    $this$child.zp7(tmp, btbProgramEditors$lambda$lambda$lambda($this$child));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda($this_child) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLibraryReference($this_child.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.ub6().v2c(reference);
      return this_0;
    };
  }
  function btbProgramEditors$lambda$lambda_7(context) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return context.lay();
  }
  function btbProgramEditors$lambda$lambda_8(_unused_var__etf5q3, trait) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function btbProgramEditors$lambda_3($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_4(wc) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = Category(wc);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>' call
    this_0.kay().v2c(OntologyLibraryReference(wc));
    this_0.lay().v2c(OntologyElementReference(wc));
    return this_0;
  }
  function btbProgramEditors$lambda_5($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$childrenRoleDefaults.wp3(Companion_getInstance_206().tc0_1);
    $this$childrenRoleDefaults.zp7(tmp, btbProgramEditors$lambda$lambda_9($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_9($this_childrenRoleDefaults) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = Category($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.kay().v2c(OntologyLibraryReference_2($this_childrenRoleDefaults.o71(), reference));
      this_0.lay().v2c(OntologyElementReference($this_childrenRoleDefaults.o71()));
      return this_0;
    };
  }
  function btbProgramEditors$lambda_6($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(OntologyLibraryReference_1);
    var tmp_0 = btbProgramEditors$lambda$lambda_10;
    var tmp_1 = btbProgramEditors$lambda$lambda_11;
    child_1($this$editor, tmp, tmp_0, VOID, tmp_1, VOID, VOID, VOID, VOID, VOID, btbProgramEditors$lambda$lambda_12);
    indentLabel_0($this$editor, '/');
    var tmp_2 = getKClass(OntologyElementReference_1);
    var tmp_3 = btbProgramEditors$lambda$lambda_13;
    child_1($this$editor, tmp_2, tmp_3, VOID, btbProgramEditors$lambda$lambda_14);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_10(category) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return category.kay();
  }
  function btbProgramEditors$lambda$lambda_11(_unused_var__etf5q3, trait) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function btbProgramEditors$lambda$lambda_12($this$child) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$child.wp3(Companion_getInstance_206().tc0_1);
    $this$child.zp7(tmp, btbProgramEditors$lambda$lambda$lambda_0($this$child));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_0($this_child) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLibraryReference($this_child.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.ub6().v2c(reference);
      return this_0;
    };
  }
  function btbProgramEditors$lambda$lambda_13(category) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return category.lay();
  }
  function btbProgramEditors$lambda$lambda_14(_unused_var__etf5q3, trait) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function btbProgramEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_8($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    $this$childrenRoleDefaults.up7('import', btbProgramEditors$lambda$lambda_15($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_15($this_childrenRoleDefaults) {
    return function () {
      return OntologyImportRootReference($this_childrenRoleDefaults.o71());
    };
  }
  function btbProgramEditors$lambda_9($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    keyword_0($this$editor, 'import');
    space_0($this$editor);
    var tmp2 = Companion_getInstance_198().gbz_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = btbProgramEditors$lambda$lambda_16;
    var options = new CompletionOptions();
    var containerInit = btbProgramEditors$lambda$lambda_17;
    var textCellInit = btbProgramEditors$lambda$lambda_18;
    var tmp;
    if (null == null) {
      tmp = btbProgramEditors$lambda$lambda_19;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = btbProgramEditors$lambda$lambda_20(textCellInit);
    var targetClass = getKClass(OntologyImportRoot_1);
    referenceTarget($this$editor, targetClass, '<root>', tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_16(rootReference) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return rootReference.ub6();
  }
  function btbProgramEditors$lambda$lambda_17(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_18(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_19(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function btbProgramEditors$lambda$lambda_20($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_10($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_11($this$childRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    getAbstractValueCompletion($this$childRoleDefaults);
    return Unit_instance;
  }
  function btbProgramEditors$lambda_12($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(VariableReferenceValue_1);
    child_1($this$editor, tmp, btbProgramEditors$lambda$lambda_21);
    indentLabel_0($this$editor, '.');
    indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_22);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_21(partValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return partValue.obr();
  }
  function btbProgramEditors$lambda$lambda_22($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(PartReferenceOperation);
    child_1($this$indent, tmp, btbProgramEditors$lambda$lambda$lambda_1);
    addTraitOnAttach_0($this$indent, btbProgramEditors$lambda$lambda$lambda_2);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_1(partValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return partValue.u3l();
  }
  function btbProgramEditors$lambda$lambda$lambda_2(source, _unused_var__etf5q3, cellFinder) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return getDeleteTransformTrait(source, cellFinder);
  }
  function btbProgramEditors$lambda_13($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_14($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(AbstractValue);
    child_1($this$editor, tmp, btbProgramEditors$lambda$lambda_23);
    label_0($this$editor, '[', VOID, VOID, btbProgramEditors$lambda$lambda_24);
    var tmp_0 = getKClass(InstanceRelationValuePlaceholder);
    children_2($this$editor, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, btbProgramEditors$lambda$lambda_25);
    label_0($this$editor, ']', VOID, VOID, btbProgramEditors$lambda$lambda_26);
    return Unit_instance;
  }
  function invoke$addTraitDeleteRelations(_this__u8e3s4) {
    return addTraitOnAttach_0(_this__u8e3s4, btbProgramEditors$lambda$addTraitDeleteRelations$lambda(_this__u8e3s4));
  }
  function btbProgramEditors$lambda$lambda_23(valueWithProperties) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return valueWithProperties.y();
  }
  function btbProgramEditors$lambda$lambda_24($this$label) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    invoke$addTraitDeleteRelations($this$label);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_25(valueWithProperties) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return valueWithProperties.ucp();
  }
  function btbProgramEditors$lambda$lambda_26($this$label) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    invoke$addTraitDeleteRelations($this$label);
    return Unit_instance;
  }
  function btbProgramEditors$11$addTraitDeleteRelations$1$$inlined$createDeleteTransformTrait$1$doWork$1($this_addTraitDeleteRelations) {
    this.qsj_1 = $this_addTraitDeleteRelations;
  }
  protoOf(btbProgramEditors$11$addTraitDeleteRelations$1$$inlined$createDeleteTransformTrait$1$doWork$1).d4x = function (builder) {
    var tmp0_safe_receiver = builder.n51(this.qsj_1.k6h().y());
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors$lambda.invoke.addTraitDeleteRelations.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      tmp0_safe_receiver.t6m();
      this.qsj_1.k6h().s6m(tmp0_safe_receiver);
    }
    return Unit_instance;
  };
  function btbProgramEditors$11$addTraitDeleteRelations$1$$inlined$createDeleteTransformTrait$1($this_addTraitDeleteRelations) {
    this.rsj_1 = $this_addTraitDeleteRelations;
    DeleteTransformTrait.call(this);
  }
  protoOf(btbProgramEditors$11$addTraitDeleteRelations$1$$inlined$createDeleteTransformTrait$1).ssj = function (cell) {
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new btbProgramEditors$11$addTraitDeleteRelations$1$$inlined$createDeleteTransformTrait$1$doWork$1(this.rsj_1);
    execute_0(tmp$ret$0);
    return Unit_instance;
  };
  function btbProgramEditors$lambda$addTraitDeleteRelations$lambda($this_addTraitDeleteRelations) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      // Inline function 'jetbrains.biokb.lang.traits.createDeleteTransformTrait' call
      return new btbProgramEditors$11$addTraitDeleteRelations$1$$inlined$createDeleteTransformTrait$1($this_addTraitDeleteRelations);
    };
  }
  function btbProgramEditors$lambda_15($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$slambda$lambda(functionTerm) {
    return functionTerm.rba();
  }
  function btbProgramEditors$slambda$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function btbProgramEditors$slambda$lambda_1(_this__u8e3s4) {
    return Unit_instance;
  }
  function btbProgramEditors$slambda$lambda_2(it) {
    return true;
  }
  function btbProgramEditors$slambda$lambda_3($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function btbProgramEditors$slambda$lambda_4(functionTerm) {
    return functionTerm.tba();
  }
  function btbProgramEditors$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbProgramEditors$slambda).esk = function ($this$asyncInvalidatingEditor, $completion) {
    var tmp = this.fsk($this$asyncInvalidatingEditor, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbProgramEditors$slambda).oa = function (p1, $completion) {
    return this.esk(p1 instanceof InvalidatingEditorBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(btbProgramEditors$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.csk_1 = false;
            this.y9_1 = 1;
            suspendResult = this.bsk_1.m51(this.bsk_1.k6h().rba().o6s(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.dsk_1 = suspendResult;
            if (!(this.dsk_1 == null)) {
              this.y9_1 = 2;
              suspendResult = showCustomEditor(this.bsk_1, this.dsk_1, this.bsk_1.k6h().tba(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            this.csk_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            if (!this.csk_1) {
              var tmp0 = this.bsk_1;
              var tmp1 = '<function>';
              var tmp2 = Companion_getInstance_197().zb9_1;
              var referenceProvider = btbProgramEditors$slambda$lambda;
              var options = new CompletionOptions();
              var containerInit = btbProgramEditors$slambda$lambda_0;
              var textCellInit = btbProgramEditors$slambda$lambda_1;
              var tmp_0;
              if (null == null) {
                tmp_0 = btbProgramEditors$slambda$lambda_2;
              } else {
                tmp_0 = null;
              }
              var tmp5 = tmp_0;
              var textCellInit_0 = btbProgramEditors$slambda$lambda_3(textCellInit);
              var targetClass = getKClass(FunctionDeclaration_1);
              referenceTarget(tmp0, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
              indentLabel_0(this.bsk_1, '(');
              var tmp_1 = getKClass(BindingValuePlaceholder_1);
              var tmp_2 = Layout_HORIZONTAL_getInstance();
              children_2(this.bsk_1, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, tmp_2, btbProgramEditors$slambda$lambda_4);
              indentLabel_0(this.bsk_1, ')');
            }

            return Unit_instance;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(btbProgramEditors$slambda).fsk = function ($this$asyncInvalidatingEditor, completion) {
    var i = new btbProgramEditors$slambda(completion);
    i.bsk_1 = $this$asyncInvalidatingEditor;
    return i;
  };
  function btbProgramEditors$slambda_0(resultContinuation) {
    var i = new btbProgramEditors$slambda(resultContinuation);
    var l = function ($this$asyncInvalidatingEditor, $completion) {
      return i.esk($this$asyncInvalidatingEditor, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function btbProgramEditors$lambda$slambda($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation) {
    this.osk_1 = $this_EditorDefinition;
    this.psk_1 = $init;
    this.qsk_1 = $invalidator;
    this.rsk_1 = $invalidated;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(btbProgramEditors$lambda$slambda).dag = function ($completion) {
    var tmp = this.eag($completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(btbProgramEditors$lambda$slambda).fag = function ($completion) {
    return this.dag($completion);
  };
  protoOf(btbProgramEditors$lambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            this.z9_1 = 5;
            this.ssk_1 = new Invalidator();
            this.tsk_1 = this.osk_1.bps(this.ssk_1);
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 4;
            this.y9_1 = 2;
            suspendResult = this.psk_1(this.tsk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.usk_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 5;
            affects(this.ssk_1.p4w(Unit_instance), this.qsk_1);
            this.z9_1 = 6;
            this.y9_1 = 7;
            continue $sm;
          case 4:
            this.z9_1 = 5;
            var t = this.ba_1;
            affects(this.ssk_1.p4w(Unit_instance), this.qsk_1);
            throw t;
          case 5:
            this.z9_1 = 6;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof AlreadyInvalidException) {
              var e = this.ba_1;
              this.rsk_1.t2c(true);
              this.y9_1 = 7;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 6:
            throw this.ba_1;
          case 7:
            this.z9_1 = 6;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 6) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(btbProgramEditors$lambda$slambda).eag = function (completion) {
    return new btbProgramEditors$lambda$slambda(this.osk_1, this.psk_1, this.qsk_1, this.rsk_1, completion);
  };
  function btbProgramEditors$lambda$slambda_0($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation) {
    var i = new btbProgramEditors$lambda$slambda($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation);
    var l = function ($completion) {
      return i.dag($completion);
    };
    l.$arity = 0;
    return l;
  }
  function btbProgramEditors$lambda_16($init) {
    return function ($this$EditorDefinition) {
      var invalidator = new Invalidator();
      var invalidated = new ValueProperty(false);
      depend(invalidator, invalidated);
      $this$EditorDefinition.cps(btbProgramEditors$lambda$slambda_0($this$EditorDefinition, $init, invalidator, invalidated, null));
      return invalidator.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_17(wc) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return TypePlaceholder(wc);
  }
  function btbProgramEditors$lambda_18($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    placeholderInCollection_0($this$editor, '<type>', get_objectTypeCompletion());
    return Unit_instance;
  }
  function btbProgramEditors$lambda_19($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_20($this$childRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    getNotionTypeCompletion($this$childRoleDefaults);
    return Unit_instance;
  }
  function btbProgramEditors$lambda_21($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp1 = '<notion>';
    var tmp2 = Companion_getInstance_220().ybo_1;
    var tmp3 = btbProgramEditors$lambda$lambda_27;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var textCellInit = btbProgramEditors$lambda$lambda_28;
    var options = new CompletionOptions();
    var containerInit = btbProgramEditors$lambda$lambda_29;
    var tmp;
    if (null == null) {
      tmp = btbProgramEditors$lambda$lambda_30;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = btbProgramEditors$lambda$lambda_31(textCellInit);
    var targetClass = getKClass(AbstractNotion);
    var refCell = referenceTarget($this$editor, targetClass, tmp1, tmp2, tmp3, null, tmp5, options, containerInit, textCellInit_0);
    considerEmptyBy($this$editor, refCell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_27(notionType) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return notionType.lbp();
  }
  function btbProgramEditors$lambda$lambda_28($this$btbReferenceTarget) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    $this$btbReferenceTarget.ypn().jlu().v2c(true);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_29(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_30(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function btbProgramEditors$lambda$lambda_31($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_22($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_23(wrapperContext) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = OntologyElementType(wrapperContext);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>' call
    this_0.kay().v2c(OntologyLibraryReference(wrapperContext));
    this_0.lay().v2c(OntologyElementReference(wrapperContext));
    return this_0;
  }
  function btbProgramEditors$lambda_24($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    ontologyElementTypeCompletion_0($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function btbProgramEditors$lambda_25($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(OntologyLibraryReference_1);
    child_1($this$editor, tmp, btbProgramEditors$lambda$lambda_32);
    indentLabel_0($this$editor, '/');
    var tmp_0 = getKClass(OntologyElementReference_1);
    child_1($this$editor, tmp_0, btbProgramEditors$lambda$lambda_33);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_32(elementType) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementType.kay();
  }
  function btbProgramEditors$lambda$lambda_33(elementType) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementType.lay();
  }
  function btbProgramEditors$lambda_26($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_27(wrapperContext) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = ProcessType(wrapperContext);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>' call
    this_0.pb5().v2c(LibraryProcessSpecification(wrapperContext));
    return this_0;
  }
  function btbProgramEditors$lambda_28($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    processTypeCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function btbProgramEditors$lambda_29($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(LibraryProcessSpecification_1);
    var tmp_0 = btbProgramEditors$lambda$lambda_34;
    var specificationCell = child_1($this$editor, tmp, tmp_0, VOID, btbProgramEditors$lambda$lambda_35);
    considerEmptyBy($this$editor, specificationCell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_34(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return it.pb5();
  }
  function btbProgramEditors$lambda$lambda_35(_unused_var__etf5q3, trait) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function btbProgramEditors$lambda_30($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_31($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
    var completionSupplier = btbProgramEditors$lambda$lambda_36;
    var separator = get_defaultChildrenSeparator();
    new ChildrenRoleDefaults(getKClass(OneOf_1), '<empty>', null, separator, completionSupplier, true);
    keyword_0($this$editor, 'one of <');
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = expressions$factory_1();
    var tmp0_contextLink = new MultipleChildLink(getKClass(OneOf_1), this_0);
    var tmp1_layout = Layout_INDENT_getInstance();
    var tmp2_separator = new StringSeparator(',', false, true);
    var tmp = getKClass(FactExpressionPlaceholder);
    children_2($this$editor, tmp, tmp0_contextLink, '<empty>', VOID, tmp2_separator, VOID, VOID, tmp1_layout, btbProgramEditors$lambda$lambda_37);
    keyword_0($this$editor, '>');
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_36($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    $this$childrenRoleDefaults.up7('one of', btbProgramEditors$lambda$lambda$lambda_3($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_3($this_childrenRoleDefaults) {
    return function () {
      return OneOf($this_childrenRoleDefaults.o71());
    };
  }
  function btbProgramEditors$lambda$lambda_37(oneOfExpression) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return oneOfExpression.rbs();
  }
  function btbProgramEditors$lambda_32($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_33($this$childRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$childRoleDefaults.wp3(Companion_getInstance_222().qcf_1);
    $this$childRoleDefaults.zp7(tmp, btbProgramEditors$lambda$lambda_38($this$childRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_38($this_childRoleDefaults) {
    return function (content) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyReferenceOperation($this_childRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.i6u().t6s(content);
      return this_0;
    };
  }
  function btbProgramEditors$lambda_34($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var propertyRefOperation = $this$editor.k6h();
    var parameterCell = {_v: null};
    var tmp1 = '<property>';
    var tmp2 = Companion_getInstance_222().qcf_1;
    var tmp3 = btbProgramEditors$lambda$lambda_39;
    var tmp4 = btbProgramEditors$lambda$lambda_40;
    var tmp5 = new CompletionOptions(VOID, false);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var textCellInit = btbProgramEditors$lambda$lambda_41(propertyRefOperation, parameterCell, $this$editor);
    var containerInit = btbProgramEditors$lambda$lambda_42;
    var tmp;
    if (tmp4 == null) {
      tmp = btbProgramEditors$lambda$lambda_43;
    } else {
      tmp = tmp4;
    }
    var tmp5_0 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = btbProgramEditors$lambda$lambda_44(textCellInit);
    var targetClass = getKClass(ObjectPropertyDeclaration_1);
    var referenceCell = referenceTarget($this$editor, targetClass, tmp1, tmp2, tmp3, null, tmp5_0, tmp5, containerInit, textCellInit_0);
    var tmp_0 = getKClass(SetValuedPropertyParameter_1);
    var tmp_1 = btbProgramEditors$lambda$lambda_45;
    parameterCell._v = child_1($this$editor, tmp_0, tmp_1, VOID, VOID, VOID, VOID, btbProgramEditors$lambda$lambda_46(referenceCell));
    var tmp_2 = Synchronizers_instance;
    var tmp_3 = PropertyBinding_instance;
    var tmp_4 = notNull($this$editor.k6h().fcg().n4z());
    var tmp_5;
    if (parameterCell._v == null) {
      throwUninitializedPropertyAccessException('parameterCell');
    } else {
      tmp_5 = parameterCell._v;
    }
    $this$editor.wle(tmp_2.rle([tmp_3.d2g(tmp_4, tmp_5.elp())]));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_39(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return it.i6u();
  }
  function btbProgramEditors$lambda$lambda_40(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return !contains_9(it, '(') && !contains_9(it, '.');
  }
  function btbProgramEditors$lambda$lambda$lambda$lambda($parameterCell, $this_btbReferenceTarget, $propertyRefOperation, $cellFinder) {
    return function () {
      var tmp;
      var tmp_0;
      if ($parameterCell._v == null) {
        throwUninitializedPropertyAccessException('parameterCell');
      } else {
        tmp_0 = $parameterCell._v;
      }
      if (tmp_0.elp().m2c()) {
        tmp = get_EMPTY_CELL_ACTION();
      } else {
        var newNode = SetValuedPropertyParameter(get_internalConfig($this_btbReferenceTarget).o71());
        $propertyRefOperation.fcg().t2c(newNode);
        var tmp0_safe_receiver = firstOrNull_1($cellFinder.vn4(newNode));
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ulp(ProjectionalSynchronizers_getInstance().jlw_1);
        tmp = tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs;
      }
      return tmp;
    };
  }
  function btbProgramEditors$lambda$lambda$lambda$lambda_0($parameterCell, $this_btbReferenceTarget, $cellFinder, $currentPropertyRefValue) {
    return function () {
      var tmp;
      var tmp_0;
      if ($parameterCell._v == null) {
        throwUninitializedPropertyAccessException('parameterCell');
      } else {
        tmp_0 = $parameterCell._v;
      }
      if (tmp_0.elp().m2c()) {
        tmp = get_EMPTY_CELL_ACTION();
      } else {
        tmp = transformValueToPropertyReference($this_btbReferenceTarget, $cellFinder, $currentPropertyRefValue);
      }
      return tmp;
    };
  }
  function btbProgramEditors$25$3$1$3$$inlined$executeQuery$1($this_editor) {
    this.vsk_1 = $this_editor;
  }
  protoOf(btbProgramEditors$25$3$1$3$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    var tmp;
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = this.vsk_1.k6h();
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessPropertyValue_1));
    if (!(builder.n51(tmp$ret$0) == null)) {
      tmp = true;
    } else {
      // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
      var this_1 = this.vsk_1.k6h();
      var tmp$ret$1 = ancestorOrSelf(this_1, getKClass(ModifierFactExpression_0));
      tmp = !(builder.n51(tmp$ret$1) == null);
    }
    return tmp;
  };
  function btbProgramEditors$lambda$lambda$lambda$lambda_1($parameterCell, $this_btbReferenceTarget, $currentPropertyRefValue, $cellFinder, $this_editor) {
    return function () {
      var tmp;
      var tmp_0;
      var tmp_1;
      if ($parameterCell._v == null) {
        throwUninitializedPropertyAccessException('parameterCell');
      } else {
        tmp_1 = $parameterCell._v;
      }
      if (tmp_1.elp().m2c()) {
        tmp_0 = true;
      } else {
        // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
        // Inline function 'jetbrains.ocelot.langDef.query.query' call
        var tmp$ret$0 = new btbProgramEditors$25$3$1$3$$inlined$executeQuery$1($this_editor);
        tmp_0 = execute_0(tmp$ret$0);
      }
      if (tmp_0) {
        tmp = get_EMPTY_CELL_ACTION();
      } else {
        // Inline function 'kotlin.apply' call
        var this_0 = IsExpression(get_internalConfig($this_btbReferenceTarget).o71());
        // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
        var tmp_2 = this_0.sbf();
        var tmp_3 = $currentPropertyRefValue.u6m();
        tmp_2.v2c(isInterface(tmp_3, ObjectPropertyReferenceValue_1) ? tmp_3 : THROW_CCE());
        var newNode = this_0;
        $currentPropertyRefValue.s6m(newNode);
        var tmp0_safe_receiver = firstOrNull_1($cellFinder.vn4(newNode));
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ulp(ProjectionalSynchronizers_getInstance().jlw_1);
        tmp = tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs;
      }
      return tmp;
    };
  }
  function btbProgramEditors$lambda$lambda$lambda_4($propertyRefOperation, $parameterCell, $this_btbReferenceTarget, $this_editor) {
    return function ($this$rightTransform, _unused_var__etf5q3, _unused_var__etf5q3_0, cellFinder) {
      $this$rightTransform.tp3('(', btbProgramEditors$lambda$lambda$lambda$lambda($parameterCell, $this_btbReferenceTarget, $propertyRefOperation, cellFinder));
      var tmp = $propertyRefOperation.yt();
      var currentPropertyRefValue = (!(tmp == null) ? isInterface(tmp, ObjectPropertyReferenceValue_1) : false) ? tmp : THROW_CCE();
      $this$rightTransform.tp3('.', btbProgramEditors$lambda$lambda$lambda$lambda_0($parameterCell, $this_btbReferenceTarget, cellFinder, currentPropertyRefValue));
      $this$rightTransform.tp3('is', btbProgramEditors$lambda$lambda$lambda$lambda_1($parameterCell, $this_btbReferenceTarget, currentPropertyRefValue, cellFinder, $this_editor));
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda_41($propertyRefOperation, $parameterCell, $this_editor) {
    return function ($this$btbReferenceTarget) {
      rightTransform_0($this$btbReferenceTarget, btbProgramEditors$lambda$lambda$lambda_4($propertyRefOperation, $parameterCell, $this$btbReferenceTarget, $this_editor));
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda_42(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_43(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function btbProgramEditors$lambda$lambda_44($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda_45(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return it.fcg();
  }
  function btbProgramEditors$lambda$lambda_46($referenceCell) {
    return function () {
      var tmp0_safe_receiver = firstFocusable($referenceCell);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toEnd_0(tmp0_safe_receiver);
      (tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs)();
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_35($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_36($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$editor.k6h().yt();
    var propertyRefOperation = (!(tmp == null) ? isInterface(tmp, PropertyReferenceOperation_1) : false) ? tmp : THROW_CCE();
    indentLabel_0($this$editor, '(', false);
    var tmp_0 = getKClass(AbstractValue);
    child_1($this$editor, tmp_0, btbProgramEditors$lambda$lambda_47, '<parameter>');
    // Inline function 'kotlin.apply' call
    var this_0 = indentLabel_0($this$editor, ')', true);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>' call
    rightTransform_1($this$editor, this_0, btbProgramEditors$lambda$lambda_48(propertyRefOperation, $this$editor));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_47(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return it.y();
  }
  function btbProgramEditors$lambda$lambda$lambda_5($propertyRefOperation, $this_editor, $cellFinder) {
    return function () {
      var tmp = $propertyRefOperation.yt();
      var currentPropertyRefValue = (!(tmp == null) ? isInterface(tmp, ObjectPropertyReferenceValue_1) : false) ? tmp : THROW_CCE();
      return transformValueToPropertyReference($this_editor, $cellFinder, currentPropertyRefValue);
    };
  }
  function btbProgramEditors$lambda$lambda_48($propertyRefOperation, $this_editor) {
    return function ($this$rightTransform, _unused_var__etf5q3, _unused_var__etf5q3_0, cellFinder) {
      $this$rightTransform.tp3('.', btbProgramEditors$lambda$lambda$lambda_5($propertyRefOperation, $this_editor, cellFinder));
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_37($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_38($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    knowledgeSources($this$editor);
    newLine_0($this$editor);
    var tmp = btbProgramEditors$lambda$lambda_49;
    textProperty_0($this$editor, '<name>', tmp, btbProgramEditors$lambda$lambda_50);
    newLine_0($this$editor);
    commentEditor($this$editor);
    newLine_0($this$editor);
    var withKeyword = keyword_0($this$editor, 'with');
    indentLabel_0($this$editor, '(');
    var oldContextCell = indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_51);
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new btbProgramEditors$27$$inlined$forDisposable$1($this$editor, oldContextCell);
    $this$editor.wle(tmp$ret$0);
    var tmp0_layout = Layout_HORIZONTAL_getInstance();
    var tmp2 = getKClass(Context_1);
    var tmp3 = contexts$factory_1();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var placeholderText = '<contexts>';
    var placeholderTraitFactory = btbProgramEditors$lambda$lambda_52;
    var clipboardSetup = btbProgramEditors$lambda$lambda_53;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_0 = new MultipleChildLink(getKClass(FactSet_1), tmp3);
    children_2($this$editor, tmp2, tmp_0, placeholderText, placeholderTraitFactory, null, clipboardSetup, null, tmp0_layout, btbProgramEditors$lambda$lambda_54(tmp3));
    indentLabel_0($this$editor, ')', true);
    var facts = {_v: null};
    indent_0($this$editor, true, VOID, btbProgramEditors$lambda$lambda_55(facts));
    if (get_supportFactSelection($this$editor)) {
      var tmp_1 = $this$editor.ypn();
      var tmp_2;
      if (facts._v == null) {
        throwUninitializedPropertyAccessException('facts');
      } else {
        tmp_2 = facts._v;
      }
      tmp_1.olp(new FactsSelectionTrait(tmp_2.g2r()));
    }
    newLine_0($this$editor);
    var lastUnderscore = closingFor(label_0($this$editor, '_'), withKeyword);
    $this$editor.aps(btbProgramEditors$lambda$lambda_56(lastUnderscore));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_49(factSet) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return factSet.b3();
  }
  function btbProgramEditors$lambda$lambda_50($this$textProperty) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    $this$textProperty.ypn().olp(TextEditing_getInstance().hmu());
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_51($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.also' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>' call
    label_0($this$indent, '[old: ').jlu().v2c(true);
    var tmp = getKClass(Context_1);
    var tmp_0 = btbProgramEditors$lambda$lambda$lambda_6;
    child_1($this$indent, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, btbProgramEditors$lambda$lambda$lambda_7);
    // Inline function 'kotlin.also' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>' call
    label_0($this$indent, '], new: ').jlu().v2c(true);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_6(factSet) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return factSet.nb7();
  }
  function btbProgramEditors$lambda$lambda$lambda_7($this$child) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = editorString($this$child, BTBEditorParts_getInstance().osj_1);
    $this$child.ap8(tmp, btbProgramEditors$lambda$lambda$lambda$lambda_2($this$child));
    var tmp_0 = $this$child.wp3(Companion_getInstance_206().tc0_1);
    $this$child.zp7(tmp_0, btbProgramEditors$lambda$lambda$lambda$lambda_3($this$child));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda$lambda_2($this_child) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = Context($this_child.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.b3().v2c(name);
      this_0.lay().v2c(OntologyElementReference($this_child.o71()));
      this_0.kay().v2c(OntologyLibraryReference($this_child.o71()));
      return this_0;
    };
  }
  function btbProgramEditors$lambda$lambda$lambda$lambda_3($this_child) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = Context($this_child.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.lay().v2c(OntologyElementReference($this_child.o71()));
      var tmp = this_0.kay();
      // Inline function 'kotlin.apply' call
      var this_1 = OntologyLibraryReference($this_child.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_1.ub6().v2c(reference);
      tmp.v2c(this_1);
      return this_0;
    };
  }
  function btbProgramEditors$27$$inlined$forDisposable$1($this_editor, $oldContextCell) {
    this.xsk_1 = $this_editor;
    this.ysk_1 = $oldContextCell;
    DisposableSynchronizer.call(this);
  }
  protoOf(btbProgramEditors$27$$inlined$forDisposable$1).dlb = function (ctx) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>' call
    return PropertyBinding_instance.d2g(not(isNull(this.xsk_1.k6h().nb7().n4z())), this.ysk_1.elp());
  };
  function btbProgramEditors$lambda$lambda_52(_unused_var__etf5q3, trait) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return trait;
  }
  function btbProgramEditors$lambda$lambda_53(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_54($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function btbProgramEditors$lambda$lambda$lambda$lambda_4(factSet) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return factSet.fb6();
  }
  function btbProgramEditors$lambda$lambda$lambda_8($facts) {
    return function ($this$indent) {
      newLine_0($this$indent);
      var tmp = getKClass(Fact_1);
      var tmp_0 = Layout_VERTICAL_getInstance();
      $facts._v = children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, btbProgramEditors$lambda$lambda$lambda$lambda_4);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda$lambda_9($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    newLine_0($this$indent);
    var tmp = getKClass(NewFact);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, btbProgramEditors$lambda$lambda$lambda$lambda_5);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda$lambda_5(factSet) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return factSet.pb7();
  }
  function btbProgramEditors$lambda$lambda_55($facts) {
    return function ($this$indent) {
      newLine_0($this$indent);
      variablesEditor($this$indent);
      newLine_0($this$indent);
      keyword_0($this$indent, 'facts:');
      var tmp = !get_supportFactSelection($this$indent);
      indent_0($this$indent, tmp, VOID, btbProgramEditors$lambda$lambda$lambda_8($facts));
      newLine_0($this$indent);
      keyword_0($this$indent, 'new facts:');
      indent_0($this$indent, true, VOID, btbProgramEditors$lambda$lambda$lambda_9);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda_56($lastUnderscore) {
    return function (cell, event) {
      var tmp;
      if (event.ml1(Key_ENTER_getInstance(), []) && !comes(event, $lastUnderscore, cell)) {
        event.ol0();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_39($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_40($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_57);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_57($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp1 = '<library>';
    var tmp2 = Companion_getInstance_206().tc0_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = btbProgramEditors$lambda$lambda$lambda_10;
    var options = new CompletionOptions();
    var containerInit = btbProgramEditors$lambda$lambda$lambda_11;
    var textCellInit = btbProgramEditors$lambda$lambda$lambda_12;
    var tmp;
    if (null == null) {
      tmp = btbProgramEditors$lambda$lambda$lambda_13;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = btbProgramEditors$lambda$lambda$lambda_14(textCellInit);
    var targetClass = getKClass(OntologyLibrary_1);
    referenceTarget($this$indent, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_10(libraryReference) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return libraryReference.ub6();
  }
  function btbProgramEditors$lambda$lambda$lambda_11(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_12(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_13(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function btbProgramEditors$lambda$lambda$lambda_14($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_41($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_42(wrapperContext) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return ClassExpressionPlaceholder(wrapperContext);
  }
  function btbProgramEditors$lambda_43($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    excludingClassExpressionCompletion($this$childrenRoleDefaults, $this$childrenRoleDefaults.tp7());
    return Unit_instance;
  }
  function btbProgramEditors$lambda_44($this$childRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$childRoleDefaults.wp3(Companion_getInstance_205().rbv_1);
    $this$childRoleDefaults.zp7(tmp, btbProgramEditors$lambda$lambda_58($this$childRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_58($this_childRoleDefaults) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReference($this_childRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.lay().t6s(reference);
      return this_0;
    };
  }
  function btbProgramEditors$lambda_45($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_59);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_59($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp1 = '<element>';
    var tmp2 = Companion_getInstance_205().rbv_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = btbProgramEditors$lambda$lambda$lambda_15;
    var options = new CompletionOptions();
    var containerInit = btbProgramEditors$lambda$lambda$lambda_16;
    var textCellInit = btbProgramEditors$lambda$lambda$lambda_17;
    var tmp;
    if (null == null) {
      tmp = btbProgramEditors$lambda$lambda$lambda_18;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = btbProgramEditors$lambda$lambda$lambda_19(textCellInit);
    var targetClass = getKClass(OntologyElement_1);
    // Inline function 'kotlin.apply' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>' call
    referenceTarget($this$indent, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0).olp(get_spaceDoesntCloseCompletion());
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_15(elementReference) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementReference.lay();
  }
  function btbProgramEditors$lambda$lambda$lambda_16(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_17(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_18(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function btbProgramEditors$lambda$lambda$lambda_19($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_46($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_47($this$childRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = $this$childRoleDefaults.wp3(Companion_getInstance_207().tbi_1);
    $this$childRoleDefaults.zp7(tmp, btbProgramEditors$lambda$lambda_60($this$childRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_60($this_childRoleDefaults) {
    return function (reference) {
      return LocalOntologyElementReference_2($this_childRoleDefaults.o71(), reference);
    };
  }
  function btbProgramEditors$lambda_48($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    deleteIfEmpty($this$editor);
    var refCell = {_v: null};
    indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_61(refCell));
    var tmp;
    if (refCell._v == null) {
      throwUninitializedPropertyAccessException('refCell');
    } else {
      tmp = refCell._v;
    }
    considerEmptyBy($this$editor, tmp);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_20(elementReference) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementReference.lay();
  }
  function btbProgramEditors$lambda$lambda$lambda_21(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_22(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_23(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function btbProgramEditors$lambda$lambda$lambda_24($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda_61($refCell) {
    return function ($this$indent) {
      var tmp1 = '<no reference target>';
      var tmp2 = Companion_getInstance_207().tbi_1;
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
      var referenceProvider = btbProgramEditors$lambda$lambda$lambda_20;
      var options = new CompletionOptions();
      var containerInit = btbProgramEditors$lambda$lambda$lambda_21;
      var textCellInit = btbProgramEditors$lambda$lambda$lambda_22;
      var tmp;
      if (null == null) {
        tmp = btbProgramEditors$lambda$lambda$lambda_23;
      } else {
        tmp = null;
      }
      var tmp5 = tmp;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
      var textCellInit_0 = btbProgramEditors$lambda$lambda$lambda_24(textCellInit);
      var targetClass = getKClass(OntologyElement_1);
      var tmp$ret$1 = referenceTarget($this$indent, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
      $refCell._v = tmp$ret$1;
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_49($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_50(wc) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = QualifiedOntologyElementReference(wc);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>' call
    this_0.lcj().v2c(OntologyLibraryReference(wc));
    this_0.mcj().v2c(OntologyElementReference(wc));
    return this_0;
  }
  function btbProgramEditors$lambda_51($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, true, VOID, btbProgramEditors$lambda$lambda_62);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_62($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(OntologyLibraryReference_1);
    child_1($this$indent, tmp, btbProgramEditors$lambda$lambda$lambda_25);
    label_0($this$indent, '/');
    var tmp_0 = getKClass(OntologyElementReference_1);
    child_1($this$indent, tmp_0, btbProgramEditors$lambda$lambda$lambda_26);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_25(reference) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return reference.lcj();
  }
  function btbProgramEditors$lambda$lambda$lambda_26(reference) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return reference.mcj();
  }
  function btbProgramEditors$lambda_52($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_53(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return UnionClass(it);
  }
  function btbProgramEditors$lambda_54($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_63($this$editor));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$lambda_27($this_editor) {
    return function ($this$placeholderInCollection) {
      excludingClassExpressionCompletion($this$placeholderInCollection, $this_editor.k6h());
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda$lambda_63($this_editor) {
    return function ($this$indent) {
      placeholderInCollection_0($this$indent, '<class>', btbProgramEditors$lambda$lambda$lambda_27($this_editor));
      return Unit_instance;
    };
  }
  function btbProgramEditors$lambda_55($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbProgramEditors$lambda_56($this$childrenRoleDefaults) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = editorString($this$childrenRoleDefaults, BTBEditorParts_getInstance().osj_1);
    $this$childrenRoleDefaults.ap8(tmp, btbProgramEditors$lambda$lambda_64($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_64($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = VariableDeclaration($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.b3().v2c(name);
      return this_0;
    };
  }
  function btbProgramEditors$lambda_57($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.apply' call
    var this_0 = textProperty_0($this$editor, '<no name>', btbProgramEditors$lambda$lambda_65);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>' call
    mark_0(this_0, BTBEditorParts_getInstance().osj_1);
    space_0($this$editor);
    var indent = indent_0($this$editor, VOID, VOID, btbProgramEditors$lambda$lambda_66);
    mark_0(indent, get_QUERY_LABELS_CONTAINER_MARK());
    space_0($this$editor);
    var tmp0_layout = Layout_HORIZONTAL_getInstance();
    var tmp1_separator = new StringSeparator(',', false, true);
    var tmp = getKClass(InstanceRelationValuePlaceholder);
    var tmp_0 = btbProgramEditors$lambda$lambda_67;
    var oldRelationsCell = children_2($this$editor, tmp, VOID, VOID, tmp_0, tmp1_separator, VOID, VOID, tmp0_layout, btbProgramEditors$lambda$lambda_68);
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$1 = new btbProgramEditors$40$$inlined$forDisposable$1($this$editor, oldRelationsCell);
    $this$editor.wle(tmp$ret$1);
    propertyConstraints($this$editor);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda_65(variableDeclaration) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return variableDeclaration.b3();
  }
  function btbProgramEditors$lambda$lambda_66($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var operationLabel = label_0($this$indent, ':');
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new btbProgramEditors$40$1$$inlined$forDisposable$1($this$indent, operationLabel);
    $this$indent.wle(tmp$ret$0);
    space_0($this$indent);
    queryLabelsCell($this$indent);
    var tmp = getKClass(VariableSpecification);
    var tmp_0 = btbProgramEditors$lambda$lambda$lambda_28;
    var type = child_1($this$indent, tmp, tmp_0, VOID, btbProgramEditors$lambda$lambda$lambda_29, VOID, VOID, VOID, VOID, VOID, get_variableSpecificationCompletion());
    var setQueriesLabelRightTransform = setQueryLabelRightTransform($this$indent.k6h());
    rightTransform_1($this$indent, operationLabel, setQueriesLabelRightTransform);
    rightTransform_1($this$indent, type, setQueriesLabelRightTransform);
    return Unit_instance;
  }
  function btbProgramEditors$lambda$lambda$o$doAttach$lambda(it) {
    return !(it == null) ? isInterface(it, VariableInitializer) : false;
  }
  function btbProgramEditors$40$1$$inlined$forDisposable$1($this_indent, $operationLabel) {
    this.asl_1 = $this_indent;
    this.bsl_1 = $operationLabel;
    DisposableSynchronizer.call(this);
  }
  protoOf(btbProgramEditors$40$1$$inlined$forDisposable$1).dlb = function (ctx) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>.<anonymous>' call
    var spec = this.asl_1.k6h().jcq().n4z();
    var tmp = PropertyBinding_instance;
    return tmp.d2g(ifProp(map_0(spec, btbProgramEditors$lambda$lambda$o$doAttach$lambda), '=', ':'), this.bsl_1.laz());
  };
  function btbProgramEditors$lambda$lambda$lambda_28(variableDeclaration) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return variableDeclaration.jcq();
  }
  function btbProgramEditors$lambda$lambda$lambda_29(_unused_var__etf5q3, trait) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function btbProgramEditors$lambda$lambda_67(_unused_var__etf5q3, trait) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function btbProgramEditors$lambda$lambda_68(variableDeclaration) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return variableDeclaration.ucp();
  }
  function btbProgramEditors$40$$inlined$forDisposable$1($this_editor, $oldRelationsCell) {
    this.dsl_1 = $this_editor;
    this.esl_1 = $oldRelationsCell;
    DisposableSynchronizer.call(this);
  }
  protoOf(btbProgramEditors$40$$inlined$forDisposable$1).dlb = function (ctx) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbProgramEditors.<anonymous>.<anonymous>' call
    return PropertyBinding_instance.d2g(notEmptyProp(this.dsl_1.k6h().ucp().n4z()), this.esl_1.elp());
  };
  function btbProgramEditors$lambda_58($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function getAbstractValueCompletion$lambda($this_getAbstractValueCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = FunctionTerm($this_getAbstractValueCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.getAbstractValueCompletion.<anonymous>.<anonymous>' call
      this_0.rba().v2c(reference);
      return this_0;
    };
  }
  function variableReferenceValueEditor$lambda$lambda(variableReferenceValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return variableReferenceValue.xcq();
  }
  function variableReferenceValueEditor$lambda$lambda_0(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return !contains_9(it, '.') && !contains_9(it, ',');
  }
  function variableReferenceValueEditor$lambda$lambda$lambda$lambda($this_btbReferenceTarget, $cellFinder, $cell) {
    return function () {
      var tmp = get_enclosingRefData($cell).fpy_1;
      return transformValueToPropertyReference($this_btbReferenceTarget, $cellFinder, (!(tmp == null) ? isInterface(tmp, VariableReferenceValue_1) : false) ? tmp : THROW_CCE());
    };
  }
  function variableReferenceValueEditor$lambda$lambda$lambda($this_btbReferenceTarget) {
    return function ($this$rightTransform, _unused_var__etf5q3, cell, cellFinder) {
      $this$rightTransform.tp3('.', variableReferenceValueEditor$lambda$lambda$lambda$lambda($this_btbReferenceTarget, cellFinder, cell));
      return Unit_instance;
    };
  }
  function variableReferenceValueEditor$lambda$lambda_1($withDotRightTransform) {
    return function ($this$btbReferenceTarget) {
      var tmp;
      if ($withDotRightTransform) {
        rightTransform_0($this$btbReferenceTarget, variableReferenceValueEditor$lambda$lambda$lambda($this$btbReferenceTarget));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function variableReferenceValueEditor$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function variableReferenceValueEditor$lambda$lambda_3(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function variableReferenceValueEditor$lambda$lambda_4($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function variableReferenceValueEditor$lambda($withDotRightTransform) {
    return function ($this$editor) {
      var tmp1 = '<variable>';
      var tmp2 = Companion_getInstance_221().kcq_1;
      var tmp3 = variableReferenceValueEditor$lambda$lambda;
      var tmp4 = variableReferenceValueEditor$lambda$lambda_0;
      var tmp5 = new CompletionOptions(VOID, false);
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
      var textCellInit = variableReferenceValueEditor$lambda$lambda_1($withDotRightTransform);
      var containerInit = variableReferenceValueEditor$lambda$lambda_2;
      var tmp;
      if (tmp4 == null) {
        tmp = variableReferenceValueEditor$lambda$lambda_3;
      } else {
        tmp = tmp4;
      }
      var tmp5_0 = tmp;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
      var textCellInit_0 = variableReferenceValueEditor$lambda$lambda_4(textCellInit);
      var targetClass = getKClass(VariableDeclaration_1);
      var refCell = referenceTarget($this$editor, targetClass, tmp1, tmp2, tmp3, null, tmp5_0, tmp5, containerInit, textCellInit_0);
      considerEmptyBy($this$editor, refCell);
      deleteIfEmpty($this$editor);
      return Unit_instance;
    };
  }
  function variableReferenceValueEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function setExpressionEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp;
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new setExpressionEditor$1$$inlined$executeQuery$1($this$editor);
    if (execute_0(tmp$ret$0)) {
      tmp = '{';
    } else {
      tmp = '[';
    }
    label_0($this$editor, tmp);
    var tmp0_layout = Layout_HORIZONTAL_getInstance();
    var tmp1_separator = new StringSeparator(',', false, true);
    var tmp_0 = getKClass(FactExpressionPlaceholder);
    var tmp_1 = setExpressionEditor$lambda$lambda;
    children_2($this$editor, tmp_0, VOID, '<expressions>', tmp_1, tmp1_separator, VOID, VOID, tmp0_layout, setExpressionEditor$lambda$lambda_0);
    var tmp_2;
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$2 = new setExpressionEditor$1$$inlined$executeQuery$2($this$editor);
    if (execute_0(tmp$ret$2)) {
      tmp_2 = '}';
    } else {
      tmp_2 = ']';
    }
    label_0($this$editor, tmp_2);
    return Unit_instance;
  }
  function setExpressionEditor$1$$inlined$executeQuery$1($this_editor) {
    this.fsl_1 = $this_editor;
  }
  protoOf(setExpressionEditor$1$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.setExpressionEditor.<anonymous>.<anonymous>' call
    return builder.n51(this.fsl_1.k6h().jcm());
  };
  function setExpressionEditor$lambda$lambda(_unused_var__etf5q3, trait) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function setExpressionEditor$lambda$lambda_0(set) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return set.rbs();
  }
  function setExpressionEditor$1$$inlined$executeQuery$2($this_editor) {
    this.gsl_1 = $this_editor;
  }
  protoOf(setExpressionEditor$1$$inlined$executeQuery$2).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.setExpressionEditor.<anonymous>.<anonymous>' call
    return builder.n51(this.gsl_1.k6h().jcm());
  };
  function setExpressionEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function measurableValueEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    // Inline function 'kotlin.also' call
    var this_0 = decimalProperty_1($this$editor, '<amount>', measurableValueEditor$lambda$lambda);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.measurableValueEditor.<anonymous>.<anonymous>' call
    mark_0(this_0, BTBEditorParts_getInstance().psj_1);
    space_0($this$editor);
    var tmp4 = Companion_getInstance_223().hbk_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = measurableValueEditor$lambda$lambda_0;
    var options = new CompletionOptions();
    var containerInit = measurableValueEditor$lambda$lambda_1;
    var textCellInit = measurableValueEditor$lambda$lambda_2;
    var tmp;
    if (null == null) {
      tmp = measurableValueEditor$lambda$lambda_3;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = measurableValueEditor$lambda$lambda_4(textCellInit);
    var targetClass = getKClass(MeasurementUnit_1);
    referenceTarget($this$editor, targetClass, '<unit>', tmp4, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    valueWithRelationsRightTransformCell($this$editor);
    return Unit_instance;
  }
  function measurableValueEditor$lambda$lambda(measurableValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return measurableValue.ibk();
  }
  function measurableValueEditor$lambda$lambda_0(measurableValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return measurableValue.jbk();
  }
  function measurableValueEditor$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function measurableValueEditor$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function measurableValueEditor$lambda$lambda_3(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function measurableValueEditor$lambda$lambda_4($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function measurableValueEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function enumValueEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, VOID, VOID, enumValueEditor$lambda$lambda);
    return Unit_instance;
  }
  function enumValueEditor$lambda$lambda($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp1 = '<constant>';
    var tmp2 = Companion_getInstance_224().jb2_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = enumValueEditor$lambda$lambda$lambda;
    var options = new CompletionOptions();
    var containerInit = enumValueEditor$lambda$lambda$lambda_0;
    var textCellInit = enumValueEditor$lambda$lambda$lambda_1;
    var tmp;
    if (null == null) {
      tmp = enumValueEditor$lambda$lambda$lambda_2;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = enumValueEditor$lambda$lambda$lambda_3(textCellInit);
    var targetClass = getKClass(EnumerationConstant_1);
    referenceTarget($this$indent, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    valueWithRelationsRightTransformCell($this$indent);
    return Unit_instance;
  }
  function enumValueEditor$lambda$lambda$lambda(enumValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return enumValue.wb2();
  }
  function enumValueEditor$lambda$lambda$lambda_0(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function enumValueEditor$lambda$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return Unit_instance;
  }
  function enumValueEditor$lambda$lambda$lambda_2(it) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return true;
  }
  function enumValueEditor$lambda$lambda$lambda_3($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function enumValueEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function unionEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    keyword_0($this$editor, 'union of <');
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = classes$factory_0();
    var tmp0_contextLink = new MultipleChildLink(getKClass(UnionClass_1), this_0);
    var tmp1_layout = Layout_INDENT_getInstance();
    var tmp2_separator = new StringSeparator(',', false, true);
    var tmp = getKClass(ClassExpressionPlaceholder_1);
    children_2($this$editor, tmp, tmp0_contextLink, VOID, VOID, tmp2_separator, VOID, VOID, tmp1_layout, unionEditor$lambda$lambda);
    keyword_0($this$editor, '>');
    return Unit_instance;
  }
  function unionEditor$lambda$lambda(unionExpression) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return unionExpression.tco();
  }
  function unionEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function propertyReferenceValueEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(AbstractValue);
    child_1($this$editor, tmp, propertyReferenceValueEditor$lambda$lambda);
    indentLabel_0($this$editor, '.');
    indent_0($this$editor, VOID, VOID, propertyReferenceValueEditor$lambda$lambda_0);
    $this$editor.wle(new propertyReferenceValueEditor$1$3($this$editor));
    return Unit_instance;
  }
  function sam$jetbrains_ocelot_base_edt_EdtTask$0_24(function_0) {
    this.hsl_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_24).wy = function () {
    return this.hsl_1();
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_24).b4 = function () {
    return this.hsl_1;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_24).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, EdtTask) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_base_edt_EdtTask$0_24).hashCode = function () {
    return hashCode(this.b4());
  };
  function propertyReferenceValueEditor$lambda$lambda(partValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return partValue.obr();
  }
  function propertyReferenceValueEditor$lambda$lambda_0($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(PropertyReferenceOperation_1);
    child_1($this$indent, tmp, propertyReferenceValueEditor$lambda$lambda$lambda);
    return Unit_instance;
  }
  function propertyReferenceValueEditor$lambda$lambda$lambda(partValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return partValue.i6u();
  }
  function propertyReferenceValueEditor$1$3$doAttach$1$$inlined$executeQuery$1($this_editor) {
    this.isl_1 = $this_editor;
  }
  protoOf(propertyReferenceValueEditor$1$3$doAttach$1$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.<no name provided>.doAttach.<anonymous>.<anonymous>' call
    var tmp = builder.n51(this.isl_1.k6h().obr());
    return !(!(tmp == null) ? isInterface(tmp, ObjectPropertyReferenceValue_1) : false);
  };
  function propertyReferenceValueEditor$lambda$o$doAttach$lambda$lambda$lambda($this_editor, $cellFinder) {
    return function () {
      removePropertyReferenceAndSelectValue($this_editor.k6h(), $cellFinder);
      return Unit_instance;
    };
  }
  function propertyReferenceValueEditor$lambda$o$doAttach$lambda$lambda($cellContainer, $this_editor, $cellFinder) {
    return function () {
      $cellContainer.hm9(propertyReferenceValueEditor$lambda$o$doAttach$lambda$lambda$lambda($this_editor, $cellFinder));
      return Unit_instance;
    };
  }
  function propertyReferenceValueEditor$lambda$o$doAttach$lambda($this_editor, $cellFinder) {
    return function (event) {
      var tmp;
      var tmp_0 = $this_editor.k6h().yt();
      if (!(tmp_0 == null) ? isInterface(tmp_0, IsExpression_1) : false) {
        // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
        // Inline function 'jetbrains.ocelot.langDef.query.query' call
        var tmp$ret$0 = new propertyReferenceValueEditor$1$3$doAttach$1$$inlined$executeQuery$1($this_editor);
        tmp = execute_0(tmp$ret$0);
      } else {
        tmp = false;
      }
      var forbidReplace = tmp;
      var tmp_1;
      if (event.p2e_1 && !forbidReplace) {
        var cellContainer = ensureNotNull($this_editor.ypn().plp().m2c());
        var tmp_2 = cellContainer.elq();
        var tmp_3 = propertyReferenceValueEditor$lambda$o$doAttach$lambda$lambda(cellContainer, $this_editor, $cellFinder);
        tmp_2.u2m(new sam$jetbrains_ocelot_base_edt_EdtTask$0_24(tmp_3));
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function propertyReferenceValueEditor$1$3($this_editor) {
    this.ksl_1 = $this_editor;
    DisposableSynchronizer.call(this);
  }
  protoOf(propertyReferenceValueEditor$1$3).dlb = function (ctx) {
    var cellFinder = getMapperCellFinder(ctx.mlb());
    var tmp = isNull(this.ksl_1.k6h().i6u().n4z());
    return tmp.p27(propertyReferenceValueEditor$lambda$o$doAttach$lambda(this.ksl_1, cellFinder));
  };
  function propertyReferenceValueEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function ontologyElementReferenceValueLibraryEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, VOID, VOID, ontologyElementReferenceValueLibraryEditor$lambda$lambda);
    return Unit_instance;
  }
  function ontologyElementReferenceValueLibraryEditor$lambda$lambda($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(OntologyLibraryReference_1);
    child_1($this$indent, tmp, ontologyElementReferenceValueLibraryEditor$lambda$lambda$lambda);
    indentLabel_0($this$indent, '/');
    var tmp_0 = getKClass(OntologyElementReference_1);
    child_1($this$indent, tmp_0, ontologyElementReferenceValueLibraryEditor$lambda$lambda$lambda_0);
    valueWithRelationsRightTransformCell($this$indent);
    return Unit_instance;
  }
  function ontologyElementReferenceValueLibraryEditor$lambda$lambda$lambda(elementReferenceValueLibrary) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementReferenceValueLibrary.kay();
  }
  function ontologyElementReferenceValueLibraryEditor$lambda$lambda$lambda_0(elementReferenceValueLibrary) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementReferenceValueLibrary.lay();
  }
  function ontologyElementReferenceValueLibraryEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function ontologyElementReferenceValueEditor$lambda($this$editor) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    indent_0($this$editor, VOID, VOID, ontologyElementReferenceValueEditor$lambda$lambda);
    return Unit_instance;
  }
  function ontologyElementReferenceValueEditor$lambda$lambda($this$indent) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    var tmp = getKClass(OntologyElementReference_1);
    child_1($this$indent, tmp, ontologyElementReferenceValueEditor$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ontologyElementReferenceValueEditor$lambda$lambda$lambda(elementReferenceValue) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return elementReferenceValue.lay();
  }
  function ontologyElementReferenceValueEditor$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function variablesEditor$$inlined$keyPressedCellTrait$1($this_variablesEditor, $variablesRoot) {
    this.lsl_1 = $this_variablesEditor;
    this.msl_1 = $variablesRoot;
    CellTrait.call(this);
  }
  protoOf(variablesEditor$$inlined$keyPressedCellTrait$1).llm = function (cell, event) {
    var tmp;
    var tmp_0;
    if (event.x().equals(Key_ENTER_getInstance())) {
      tmp_0 = (cell instanceof TextCell ? cell : THROW_CCE()).blu();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
      var variableDeclaration = get_internalConfig(this.lsl_1).sps().y6z(getKClass(VariableDeclaration_1));
      this.lsl_1.k6h().ybc().p2(0, variableDeclaration);
      var tmp_1;
      if (this.msl_1._v == null) {
        throwUninitializedPropertyAccessException('variablesRoot');
      } else {
        tmp_1 = this.msl_1._v;
      }
      var tmp0_safe_receiver = tmp_1.q2r();
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ulp(ProjectionalSynchronizers_getInstance().jlw_1);
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver();
      event.ol0();
      tmp = Unit_instance;
    }
    return tmp;
  };
  function variablesEditor$lambda$lambda(factSet) {
    _init_properties_BTBProgramEditors_kt__cfv01s();
    return factSet.ybc();
  }
  function variablesEditor$lambda($variablesRoot) {
    return function ($this$indent) {
      newLine_0($this$indent);
      var tmp0_layout = Layout_VERTICAL_getInstance();
      // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
      var this_0 = variables$factory_1();
      var tmp1_contextLink = new MultipleChildLink(getKClass(HasVariables), this_0);
      var tmp = getKClass(VariableDeclaration_1);
      $variablesRoot._v = children_2($this$indent, tmp, tmp1_contextLink, VOID, VOID, VOID, VOID, VOID, tmp0_layout, variablesEditor$lambda$lambda);
      return Unit_instance;
    };
  }
  function $runSuspendCOROUTINE$16_1(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.vsl_1 = _this__u8e3s4;
    this.wsl_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$16_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 26;
            var tmp_0 = this;
            tmp_0.xsl_1 = this.wsl_1;
            this.ysl_1 = this.xsl_1;
            this.zsl_1 = this.vsl_1.jso_1._v;
            var tmp_1 = this.zsl_1;
            if (!(tmp_1 == null) ? isInterface(tmp_1, PropertyValue_1) : false) {
              this.y9_1 = 20;
              suspendResult = this.ysl_1.m51(this.vsl_1.jso_1._v.i6u().o6s(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_2 = this.zsl_1;
              if (!(tmp_2 == null) ? isInterface(tmp_2, ProcessPropertyValue_1) : false) {
                this.y9_1 = 17;
                suspendResult = this.ysl_1.m51(this.vsl_1.jso_1._v.i6u(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_3 = this.zsl_1;
                if (!(tmp_3 == null) ? isInterface(tmp_3, InstanceRelationValue) : false) {
                  this.y9_1 = 14;
                  suspendResult = this.ysl_1.m51(this.vsl_1.jso_1._v.gb6(), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_4 = this.zsl_1;
                  if (!(tmp_4 == null) ? isInterface(tmp_4, PropertyConstraint_1) : false) {
                    this.y9_1 = 9;
                    suspendResult = this.ysl_1.m51(this.vsl_1.jso_1._v.i6u(), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    var tmp_5 = this.zsl_1;
                    if (!(tmp_5 == null) ? isInterface(tmp_5, IsExpression_1) : false) {
                      var tmp_6 = this;
                      var tmp13_safe_receiver = this.ysl_1.n51(this.vsl_1.jso_1._v.sbf());
                      tmp_6.bsm_1 = tmp13_safe_receiver == null ? null : this.ysl_1.n51(tmp13_safe_receiver.i6u());
                      if (this.bsm_1 == null) {
                        this.csm_1 = null;
                        this.y9_1 = 4;
                        continue $sm;
                      } else {
                        this.y9_1 = 3;
                        suspendResult = this.ysl_1.m51(this.bsm_1.i6u(), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      }
                    } else {
                      var tmp_7 = this.zsl_1;
                      if (!(tmp_7 == null) ? isInterface(tmp_7, ProcessProperty_1) : false) {
                        var tmp_8 = this;
                        var tmp20_safe_receiver = this.ysl_1.n51(this.vsl_1.jso_1._v.zb3());
                        var tmp_9 = tmp20_safe_receiver == null ? null : this.ysl_1.n51(tmp20_safe_receiver.zb3());
                        tmp_8.dsm_1 = (!(tmp_9 == null) ? isInterface(tmp_9, SimplePropertyType) : false) ? tmp_9 : null;
                        if (this.dsm_1 == null) {
                          this.esm_1 = null;
                          this.y9_1 = 2;
                          continue $sm;
                        } else {
                          this.y9_1 = 1;
                          suspendResult = this.ysl_1.m51(this.dsm_1.lbp(), this);
                          if (suspendResult === get_COROUTINE_SUSPENDED()) {
                            return suspendResult;
                          }
                          continue $sm;
                        }
                      } else {
                        this.asm_1 = emptyList();
                        this.y9_1 = 25;
                        continue $sm;
                      }
                    }
                  }
                }
              }
            }

          case 1:
            this.esm_1 = suspendResult;
            this.y9_1 = 2;
            continue $sm;
          case 2:
            this.fsm_1 = this.esm_1;
            this.asm_1 = toList_4(this.fsm_1);
            this.y9_1 = 25;
            continue $sm;
          case 3:
            this.csm_1 = suspendResult;
            this.y9_1 = 4;
            continue $sm;
          case 4:
            this.gsm_1 = this.csm_1;
            this.hsm_1 = this.gsm_1 == null ? null : this.ysl_1.n51(this.gsm_1.be());
            this.ism_1 = this.hsm_1 == null ? null : this.ysl_1.n51(this.hsm_1.lbn());
            var tmp_10 = this;
            var tmp_11;
            if (this.ism_1 == null) {
              tmp_11 = null;
            } else {
              var tmp0 = this.ism_1;
              var destination = ArrayList_init_$Create$();
              var _iterator__ex2g4s = tmp0.k();
              while (_iterator__ex2g4s.l()) {
                var element = _iterator__ex2g4s.m();
                if (!(element == null) ? isInterface(element, NotionType_0) : false) {
                  destination.e(element);
                }
              }
              tmp_11 = destination;
            }

            tmp_10.jsm_1 = tmp_11;
            if (this.jsm_1 == null) {
              this.ksm_1 = null;
              this.y9_1 = 8;
              continue $sm;
            } else {
              var tmp_12 = this;
              tmp_12.lsm_1 = this.jsm_1;
              this.msm_1 = this.lsm_1;
              var tmp_13 = this;
              tmp_13.nsm_1 = this.msm_1;
              var tmp_14 = this;
              tmp_14.osm_1 = ArrayList_init_$Create$();
              this.psm_1 = this.nsm_1;
              this.qsm_1 = this.osm_1;
              var tmp_15 = this;
              tmp_15.rsm_1 = this.psm_1;
              this.ssm_1 = this.rsm_1;
              this.tsm_1 = this.ssm_1.k();
              this.y9_1 = 5;
              continue $sm;
            }

          case 5:
            if (!this.tsm_1.l()) {
              this.y9_1 = 7;
              continue $sm;
            }

            this.usm_1 = this.tsm_1.m();
            var tmp_16 = this;
            tmp_16.vsm_1 = this.usm_1;
            this.wsm_1 = this.vsm_1;
            var tmp_17 = this;
            tmp_17.xsm_1 = this.wsm_1;
            this.ysm_1 = this.xsm_1;
            this.y9_1 = 6;
            suspendResult = this.ysl_1.m51(this.ysm_1.lbp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.zsm_1 = suspendResult;
            if (this.zsm_1 == null)
              null;
            else {
              var it = this.zsm_1;
              this.qsm_1.e(it);
            }

            this.y9_1 = 5;
            continue $sm;
          case 7:
            this.ksm_1 = this.qsm_1;
            this.y9_1 = 8;
            continue $sm;
          case 8:
            this.asn_1 = this.ksm_1;
            this.asm_1 = this.asn_1 == null ? emptyList() : this.asn_1;
            this.y9_1 = 25;
            continue $sm;
          case 9:
            this.bsn_1 = suspendResult;
            this.csn_1 = this.bsn_1 == null ? null : this.ysl_1.n51(this.bsn_1.be());
            this.dsn_1 = this.csn_1 == null ? null : this.ysl_1.n51(this.csn_1.lbn());
            var tmp_18 = this;
            var tmp_19;
            if (this.dsn_1 == null) {
              tmp_19 = null;
            } else {
              var tmp0_0 = this.dsn_1;
              var destination_0 = ArrayList_init_$Create$();
              var _iterator__ex2g4s_0 = tmp0_0.k();
              while (_iterator__ex2g4s_0.l()) {
                var element_0 = _iterator__ex2g4s_0.m();
                if (!(element_0 == null) ? isInterface(element_0, NotionType_0) : false) {
                  destination_0.e(element_0);
                }
              }
              tmp_19 = destination_0;
            }

            tmp_18.esn_1 = tmp_19;
            if (this.esn_1 == null) {
              this.fsn_1 = null;
              this.y9_1 = 13;
              continue $sm;
            } else {
              var tmp_20 = this;
              tmp_20.gsn_1 = this.esn_1;
              this.hsn_1 = this.gsn_1;
              var tmp_21 = this;
              tmp_21.isn_1 = this.hsn_1;
              var tmp_22 = this;
              tmp_22.jsn_1 = ArrayList_init_$Create$();
              this.ksn_1 = this.isn_1;
              this.lsn_1 = this.jsn_1;
              var tmp_23 = this;
              tmp_23.msn_1 = this.ksn_1;
              this.nsn_1 = this.msn_1;
              this.osn_1 = this.nsn_1.k();
              this.y9_1 = 10;
              continue $sm;
            }

          case 10:
            if (!this.osn_1.l()) {
              this.y9_1 = 12;
              continue $sm;
            }

            this.psn_1 = this.osn_1.m();
            var tmp_24 = this;
            tmp_24.qsn_1 = this.psn_1;
            this.rsn_1 = this.qsn_1;
            var tmp_25 = this;
            tmp_25.ssn_1 = this.rsn_1;
            this.tsn_1 = this.ssn_1;
            this.y9_1 = 11;
            suspendResult = this.ysl_1.m51(this.tsn_1.lbp(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            this.usn_1 = suspendResult;
            if (this.usn_1 == null)
              null;
            else {
              var it_0 = this.usn_1;
              this.lsn_1.e(it_0);
            }

            this.y9_1 = 10;
            continue $sm;
          case 12:
            this.fsn_1 = this.lsn_1;
            this.y9_1 = 13;
            continue $sm;
          case 13:
            this.vsn_1 = this.fsn_1;
            this.asm_1 = this.vsn_1 == null ? emptyList() : this.vsn_1;
            this.y9_1 = 25;
            continue $sm;
          case 14:
            this.wsn_1 = suspendResult;
            var tmp_26 = this;
            var tmp_27 = this.wsn_1 == null ? null : this.ysl_1.n51(this.wsn_1.be());
            tmp_26.xsn_1 = (!(tmp_27 == null) ? isInterface(tmp_27, NotionType_0) : false) ? tmp_27 : null;
            if (this.xsn_1 == null) {
              this.ysn_1 = null;
              this.y9_1 = 16;
              continue $sm;
            } else {
              this.y9_1 = 15;
              suspendResult = this.ysl_1.m51(this.xsn_1.lbp(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 15:
            this.ysn_1 = suspendResult;
            this.y9_1 = 16;
            continue $sm;
          case 16:
            this.zsn_1 = this.ysn_1;
            this.asm_1 = toList_4(this.zsn_1);
            this.y9_1 = 25;
            continue $sm;
          case 17:
            this.aso_1 = suspendResult;
            this.bso_1 = this.aso_1 == null ? null : this.ysl_1.n51(this.aso_1.zb3());
            var tmp_28 = this;
            var tmp_29 = this.bso_1 == null ? null : this.ysl_1.n51(this.bso_1.zb3());
            tmp_28.cso_1 = (!(tmp_29 == null) ? isInterface(tmp_29, SimplePropertyType) : false) ? tmp_29 : null;
            if (this.cso_1 == null) {
              this.dso_1 = null;
              this.y9_1 = 19;
              continue $sm;
            } else {
              this.y9_1 = 18;
              suspendResult = this.ysl_1.m51(this.cso_1.lbp(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 18:
            this.dso_1 = suspendResult;
            this.y9_1 = 19;
            continue $sm;
          case 19:
            this.eso_1 = this.dso_1;
            this.asm_1 = toList_4(this.eso_1);
            this.y9_1 = 25;
            continue $sm;
          case 20:
            this.fso_1 = suspendResult;
            if (this.fso_1 == null) {
              this.gso_1 = null;
              this.y9_1 = 22;
              continue $sm;
            } else {
              this.y9_1 = 21;
              suspendResult = this.ysl_1.m51(this.fso_1.zb3(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 21:
            this.gso_1 = suspendResult;
            this.y9_1 = 22;
            continue $sm;
          case 22:
            this.hso_1 = this.gso_1;
            if (this.hso_1 == null) {
              this.iso_1 = null;
              this.y9_1 = 24;
              continue $sm;
            } else {
              this.y9_1 = 23;
              suspendResult = this.ysl_1.m51(this.hso_1.lbp(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 23:
            this.iso_1 = suspendResult;
            this.y9_1 = 24;
            continue $sm;
          case 24:
            var ARGUMENT = this.iso_1;
            this.asm_1 = toList_4(ARGUMENT);
            this.y9_1 = 25;
            continue $sm;
          case 25:
            return this.asm_1;
          case 26:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 26) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1(function_0) {
    this.kso_1 = function_0;
  }
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1).hp8 = function (cell) {
    return this.kso_1(cell);
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1).b4 = function () {
    return this.kso_1;
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ActionOnCell) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1).hashCode = function () {
    return hashCode(this.b4());
  };
  function invoke$isValueProvider(_this__u8e3s4) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, PropertyValue_1) : false) {
      tmp_3 = true;
    } else {
      tmp_3 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, ProcessPropertyValue_1) : false;
    }
    if (tmp_3) {
      tmp_2 = true;
    } else {
      tmp_2 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, InstanceRelationValue) : false;
    }
    if (tmp_2) {
      tmp_1 = true;
    } else {
      tmp_1 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, PropertyConstraint_1) : false;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, IsExpression_1) : false;
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = !(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, ProcessProperty_1) : false;
    }
    return tmp;
  }
  function measurableValueWithDefaultUnitCompletion$1$$inlined$executeSuspendingQuery$1($contextNode) {
    this.jso_1 = $contextNode;
  }
  protoOf(measurableValueWithDefaultUnitCompletion$1$$inlined$executeSuspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$16_1(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(measurableValueWithDefaultUnitCompletion$1$$inlined$executeSuspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function measurableValueWithDefaultUnitCompletion$1$$inlined$executeQuery$1($measurableNotions) {
    this.lso_1 = $measurableNotions;
  }
  protoOf(measurableValueWithDefaultUnitCompletion$1$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.measurableValueWithDefaultUnitCompletion.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.find' call
    var tmp0 = builder.n51(first(this.lso_1).sbj());
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.k();
      while (_iterator__ex2g4s.l()) {
        var element = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.biokb.lang.editorBuilders.measurableValueWithDefaultUnitCompletion.<anonymous>.<anonymous>.<anonymous>' call
        if (builder.n51(element.wbk())) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  function measurableValueWithDefaultUnitCompletion$slambda$lambda$lambda(it) {
    var tmp0_safe_receiver = find_2(it, BTBEditorParts_getInstance().psj_1);
    return tmp0_safe_receiver == null ? null : toEnd_0(tmp0_safe_receiver);
  }
  function measurableValueWithDefaultUnitCompletion$slambda$lambda($this_async, $default) {
    return function ($this$does, number) {
      // Inline function 'kotlin.apply' call
      var this_0 = MeasurableValue($this_async.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.measurableValueWithDefaultUnitCompletion.<anonymous>.<anonymous>.<anonymous>' call
      this_0.fd2(number);
      if (!($default == null)) {
        this_0.jbk().v6s($default);
      }
      $this$does.fp8(this_0);
      var tmp = measurableValueWithDefaultUnitCompletion$slambda$lambda$lambda;
      return $this$does.gp8(new sam$jetbrains_ocelot_langDef_completion_ActionOnCell$0_1(tmp));
    };
  }
  function measurableValueWithDefaultUnitCompletion$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(measurableValueWithDefaultUnitCompletion$slambda).wso = function ($this$async, $completion) {
    var tmp = this.xso($this$async, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(measurableValueWithDefaultUnitCompletion$slambda).oa = function (p1, $completion) {
    return this.wso(p1 instanceof NodeCompletionBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(measurableValueWithDefaultUnitCompletion$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.vso_1 = {_v: ensureNotNull(this.uso_1.tp7())};
            while (!(this.vso_1._v == null) && !invoke$isValueProvider(this.vso_1._v)) {
              this.vso_1._v = this.vso_1._v.yt();
            }

            this.y9_1 = 1;
            suspendResult = execute_1(new measurableValueWithDefaultUnitCompletion$1$$inlined$executeSuspendingQuery$1(this.vso_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var notions = suspendResult;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = notions.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              if (!(element == null) ? isInterface(element, MeasurableNotion_1) : false) {
                destination.e(element);
              }
            }

            var measurableNotions = destination;
            if (!measurableNotions.p()) {
              var tmp_0;
              if (measurableNotions.n() === 1) {
                tmp_0 = execute_0(new measurableValueWithDefaultUnitCompletion$1$$inlined$executeQuery$1(measurableNotions));
              } else {
                tmp_0 = null;
              }
              var default_0 = tmp_0;
              var tmp_1 = this.uso_1.ep6();
              this.uso_1.xp7(tmp_1, measurableValueWithDefaultUnitCompletion$slambda$lambda(this.uso_1, default_0));
            }

            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(measurableValueWithDefaultUnitCompletion$slambda).xso = function ($this$async, completion) {
    var i = new measurableValueWithDefaultUnitCompletion$slambda(completion);
    i.uso_1 = $this$async;
    return i;
  };
  function measurableValueWithDefaultUnitCompletion$slambda_0(resultContinuation) {
    var i = new measurableValueWithDefaultUnitCompletion$slambda(resultContinuation);
    var l = function ($this$async, $completion) {
      return i.wso($this$async, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function enumValueCompletion$lambda_0($this_enumValueCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = EnumValue($this_enumValueCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.enumValueCompletion.<anonymous>.<anonymous>' call
      this_0.wb2().v2c(reference);
      return this_0;
    };
  }
  function variableReferenceValueCompletion$lambda($this_variableReferenceValueCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = VariableReferenceValue($this_variableReferenceValueCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.variableReferenceValueCompletion.<anonymous>.<anonymous>' call
      this_0.xcq().v2c(reference);
      return this_0;
    };
  }
  function setExpressionCompletion$lambda($this_setExpressionCompletion) {
    return function () {
      // Inline function 'kotlin.apply' call
      var this_0 = SetExpression($this_setExpressionCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.setExpressionCompletion.<anonymous>.<anonymous>' call
      this_0.jcm().v2c(true);
      return this_0;
    };
  }
  function setExpressionCompletion$lambda_0($this_setExpressionCompletion) {
    return function () {
      // Inline function 'kotlin.apply' call
      var this_0 = SetExpression($this_setExpressionCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.setExpressionCompletion.<anonymous>.<anonymous>' call
      this_0.jcm().v2c(false);
      return this_0;
    };
  }
  function ontologyElementReferenceValueLibraryCompletion$lambda($this_ontologyElementReferenceValueLibraryCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReferenceValueLibrary($this_ontologyElementReferenceValueLibraryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.ontologyElementReferenceValueLibraryCompletion.<anonymous>.<anonymous>' call
      this_0.kay().v2c(OntologyLibraryReference_2($this_ontologyElementReferenceValueLibraryCompletion.o71(), reference));
      this_0.lay().v2c(OntologyElementReference($this_ontologyElementReferenceValueLibraryCompletion.o71()));
      return this_0;
    };
  }
  function ontologyElementReferenceValueCompletion$lambda($this_ontologyElementReferenceValueCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementReferenceValue($this_ontologyElementReferenceValueCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.ontologyElementReferenceValueCompletion.<anonymous>.<anonymous>' call
      this_0.lay().v2c(OntologyElementReference_2($this_ontologyElementReferenceValueCompletion.o71(), reference));
      return this_0;
    };
  }
  function isEmpty$ref_3() {
    var l = function (p0) {
      return isEmpty(p0);
    };
    l.callableName = 'isEmpty';
    return l;
  }
  function valueWithRelationsRightTransformCell$o$run$lambda($this$editableText) {
    rightTransform_0($this$editableText, valueWithRelationsRightTransformCell$o$run$lambda$lambda($this$editableText));
    return Unit_instance;
  }
  function valueWithRelationsRightTransformCell$o$run$lambda$lambda$lambda($this_editableText, $source, $cellFinder) {
    return function () {
      var wrapperContext = get_internalConfig($this_editableText).o71();
      // Inline function 'kotlin.also' call
      var this_0 = ValueWithRelations(wrapperContext);
      // Inline function 'jetbrains.biokb.lang.editorBuilders.valueWithRelationsRightTransformCell.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      var tmp = this_0.y();
      var tmp_0 = $source.u6m();
      tmp.v2c(isInterface(tmp_0, AbstractValue) ? tmp_0 : THROW_CCE());
      var valueWithProperties = this_0;
      $source.s6m(valueWithProperties);
      var tmp0_safe_receiver = firstOrNull_1($cellFinder.vn4(valueWithProperties));
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ulp(ProjectionalSynchronizers_getInstance().jlw_1);
      return tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs;
    };
  }
  function valueWithRelationsRightTransformCell$o$run$lambda$lambda($this_editableText) {
    return function ($this$rightTransform, source, cell, cellFinder) {
      $this$rightTransform.tp3('[', valueWithRelationsRightTransformCell$o$run$lambda$lambda$lambda($this_editableText, source, cellFinder));
      return Unit_instance;
    };
  }
  function valueWithRelationsRightTransformCell$$inlined$executeQuery$1($this_valueWithRelationsRightTransformCell) {
    this.yso_1 = $this_valueWithRelationsRightTransformCell;
  }
  protoOf(valueWithRelationsRightTransformCell$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = this.yso_1.k6h();
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(Command_0));
    if (!(builder.n51(tmp$ret$0) == null)) {
      var tmp = isEmpty$ref_3();
      editableText_0(this.yso_1, '', VOID, tmp, VOID, valueWithRelationsRightTransformCell$o$run$lambda);
    }
    return Unit_instance;
  };
  function expressions$factory_1() {
    return getPropertyCallableRef('expressions', 1, KProperty1, function (receiver) {
      return receiver.rbs();
    }, null);
  }
  function contexts$factory_1() {
    return getPropertyCallableRef('contexts', 1, KProperty1, function (receiver) {
      return receiver.ob7();
    }, null);
  }
  function classes$factory_0() {
    return getPropertyCallableRef('classes', 1, KProperty1, function (receiver) {
      return receiver.tco();
    }, null);
  }
  function variables$factory_1() {
    return getPropertyCallableRef('variables', 1, KProperty1, function (receiver) {
      return receiver.ybc();
    }, null);
  }
  var properties_initialized_BTBProgramEditors_kt_ysdpum;
  function _init_properties_BTBProgramEditors_kt__cfv01s() {
    if (!properties_initialized_BTBProgramEditors_kt_ysdpum) {
      properties_initialized_BTBProgramEditors_kt_ysdpum = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = btbProgramEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(BTBDocument_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, btbProgramEditors$lambda_0(init));
      var tmp6 = '<context>';
      var tmp7 = btbProgramEditors$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var separator_0 = separator(',');
      var tmp11 = new ChildrenRoleDefaults(getKClass(Context_1), tmp6, tmp7, separator_0, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = btbProgramEditors$lambda_2;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(Context_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp11, null, false, true, triggerDependencies_0, btbProgramEditors$lambda_3(init_0));
      var tmp0_separator = separator(',');
      var tmp17 = '<categories>';
      var tmp18 = btbProgramEditors$lambda_4;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = btbProgramEditors$lambda_5;
      var tmp22 = new ChildrenRoleDefaults(getKClass(Category_1), tmp17, tmp18, tmp0_separator, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = btbProgramEditors$lambda_6;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(Category_1);
      var tmp_4 = new EditorDefinition(tmp_3, tmp22, null, false, true, triggerDependencies_1, btbProgramEditors$lambda_7(init_1));
      var tmp28 = '<imports>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = btbProgramEditors$lambda_8;
      var separator_1 = get_defaultChildrenSeparator();
      var tmp33 = new ChildrenRoleDefaults(getKClass(OntologyImportRootReference_1), tmp28, null, separator_1, completionSupplier_0, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = btbProgramEditors$lambda_9;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(OntologyImportRootReference_1);
      var tmp_6 = new EditorDefinition(tmp_5, tmp33, null, true, true, triggerDependencies_2, btbProgramEditors$lambda_10(init_2));
      var tmp57 = childRoleDefaults('<value>', btbProgramEditors$lambda_11, VOID, false);
      var tmp_7 = variableReferenceValueEditor();
      var tmp_8 = setExpressionEditor();
      var tmp_9 = measurableValueEditor();
      var tmp_10 = enumValueEditor();
      var tmp_11 = unionEditor();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = btbProgramEditors$lambda_12;
      var triggerDependencies_3 = emptyList();
      var tmp_12 = getKClass(PartValue);
      var tmp_13 = new EditorDefinition(tmp_12, null, null, false, true, triggerDependencies_3, btbProgramEditors$lambda_13(init_3));
      var tmp_14 = propertyReferenceValueEditor();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = btbProgramEditors$lambda_14;
      var triggerDependencies_4 = emptyList();
      var tmp_15 = getKClass(ValueWithRelations_1);
      var tmp_16 = new EditorDefinition(tmp_15, null, null, false, true, triggerDependencies_4, btbProgramEditors$lambda_15(init_4));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.asyncInvalidatingEditor' call
      var init_5 = btbProgramEditors$slambda_0(null);
      var triggerDependencies_5 = emptyList();
      var tmp_17 = getKClass(FunctionTerm_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_13, tmp_14, tmp_16, new EditorDefinition(tmp_17, null, null, false, true, triggerDependencies_5, btbProgramEditors$lambda_16(init_5)), ontologyElementReferenceValueLibraryEditor(), ontologyElementReferenceValueEditor(), processPropertyReferenceEditor()];
      var tmp_18 = new HierarchyEditorDefinition(getKClass(AbstractValue), tmp57, toList(editorDefinitions));
      var tmp101 = childRoleDefaults('<spec>', VOID, VOID, false);
      var tmp_19 = variableReferenceValueEditor(false);
      var tmp_20 = processPropertyReferenceEditor(false);
      var tmp1_completionSupplier = get_objectTypeCompletion();
      var tmp99 = childRoleDefaults('<no type>', tmp1_completionSupplier, btbProgramEditors$lambda_17);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_6 = btbProgramEditors$lambda_18;
      var triggerDependencies_6 = emptyList();
      var tmp_21 = getKClass(TypePlaceholder_1);
      var tmp_22 = new EditorDefinition(tmp_21, null, null, false, true, triggerDependencies_6, btbProgramEditors$lambda_19(init_6));
      var tmp65 = childRoleDefaults('<notion type>', btbProgramEditors$lambda_20);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_7 = btbProgramEditors$lambda_21;
      var triggerDependencies_7 = emptyList();
      var tmp_23 = getKClass(NotionType_0);
      var tmp_24 = new EditorDefinition(tmp_23, tmp65, null, false, true, triggerDependencies_7, btbProgramEditors$lambda_22(init_7));
      var tmp71 = btbProgramEditors$lambda_23;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_1 = btbProgramEditors$lambda_24;
      var separator_2 = get_defaultChildrenSeparator();
      var tmp76 = new ChildrenRoleDefaults(getKClass(OntologyElementType_1), '<empty>', tmp71, separator_2, completionSupplier_1, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_8 = btbProgramEditors$lambda_25;
      var triggerDependencies_8 = emptyList();
      var tmp_25 = getKClass(OntologyElementType_1);
      var tmp_26 = new EditorDefinition(tmp_25, tmp76, null, false, true, triggerDependencies_8, btbProgramEditors$lambda_26(init_8));
      var tmp82 = btbProgramEditors$lambda_27;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_2 = btbProgramEditors$lambda_28;
      var separator_3 = get_defaultChildrenSeparator();
      var tmp87 = new ChildrenRoleDefaults(getKClass(ProcessType_1), '<empty>', tmp82, separator_3, completionSupplier_2, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_9 = btbProgramEditors$lambda_29;
      var triggerDependencies_9 = emptyList();
      var tmp_27 = getKClass(ProcessType_1);
      var tmp_28 = new EditorDefinition(tmp_27, tmp87, null, false, true, triggerDependencies_9, btbProgramEditors$lambda_30(init_9));
      var tmp_29 = classExpressionTypeEditor();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_10 = btbProgramEditors$lambda_31;
      var triggerDependencies_10 = emptyList();
      var tmp_30 = getKClass(OneOf_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_0 = [tmp_22, tmp_24, tmp_26, tmp_28, tmp_29, new EditorDefinition(tmp_30, null, null, false, true, triggerDependencies_10, btbProgramEditors$lambda_32(init_10))];
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_1 = [tmp_19, tmp_20, new HierarchyEditorDefinition(getKClass(Type), tmp99, toList(editorDefinitions_0))];
      var tmp_31 = new HierarchyEditorDefinition(getKClass(VariableSpecification), tmp101, toList(editorDefinitions_1));
      var tmp103 = childRoleDefaults(VOID, btbProgramEditors$lambda_33);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_11 = btbProgramEditors$lambda_34;
      var triggerDependencies_11 = emptyList();
      var tmp_32 = getKClass(PropertyReferenceOperation_1);
      var tmp_33 = new EditorDefinition(tmp_32, tmp103, null, false, true, triggerDependencies_11, btbProgramEditors$lambda_35(init_11));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_12 = btbProgramEditors$lambda_36;
      var triggerDependencies_12 = emptyList();
      var tmp_34 = getKClass(SetValuedPropertyParameter_1);
      var tmp_35 = new EditorDefinition(tmp_34, null, null, false, true, triggerDependencies_12, btbProgramEditors$lambda_37(init_12));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<fact sets>';
      var separator_4 = get_defaultChildrenSeparator();
      var tmp120 = new ChildrenRoleDefaults(getKClass(FactSet_1), placeholderText, null, separator_4, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_13 = btbProgramEditors$lambda_38;
      var triggerDependencies_13 = emptyList();
      var tmp_36 = getKClass(FactSet_1);
      var tmp_37 = new EditorDefinition(tmp_36, tmp120, null, false, true, triggerDependencies_13, btbProgramEditors$lambda_39(init_13));
      var tmp126 = childRoleDefaults('<empty (wrong state, please press enter)>', VOID, VOID, VOID, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_14 = btbProgramEditors$lambda_40;
      var triggerDependencies_14 = emptyList();
      var tmp_38 = getKClass(OntologyLibraryReference_1);
      var tmp_39 = new EditorDefinition(tmp_38, tmp126, null, true, true, triggerDependencies_14, btbProgramEditors$lambda_41(init_14));
      var tmp132 = btbProgramEditors$lambda_42;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_3 = btbProgramEditors$lambda_43;
      var separator_5 = get_defaultChildrenSeparator();
      var tmp172 = new ChildrenRoleDefaults(getKClass(ClassExpressionPlaceholder_1), '<empty>', tmp132, separator_5, completionSupplier_3, true);
      var tmp164 = childRoleDefaults(VOID, VOID, VOID, false);
      var tmp155 = childRoleDefaults(VOID, VOID, VOID, false);
      var tmp137 = childRoleDefaults('<no element references, press Enter to create one>', btbProgramEditors$lambda_44, VOID, VOID, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_15 = btbProgramEditors$lambda_45;
      var triggerDependencies_15 = emptyList();
      var tmp_40 = getKClass(OntologyElementReference_1);
      var tmp_41 = new EditorDefinition(tmp_40, tmp137, null, true, true, triggerDependencies_15, btbProgramEditors$lambda_46(init_15));
      var tmp143 = childRoleDefaults('<element>', btbProgramEditors$lambda_47);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_16 = btbProgramEditors$lambda_48;
      var triggerDependencies_16 = emptyList();
      var tmp_42 = getKClass(LocalOntologyElementReference_1);
      var tmp_43 = new EditorDefinition(tmp_42, tmp143, null, true, true, triggerDependencies_16, btbProgramEditors$lambda_49(init_16));
      var tmp149 = childRoleDefaults(VOID, VOID, btbProgramEditors$lambda_50);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_17 = btbProgramEditors$lambda_51;
      var triggerDependencies_17 = emptyList();
      var tmp_44 = getKClass(QualifiedOntologyElementReference_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_2 = [tmp_41, tmp_43, new EditorDefinition(tmp_44, tmp149, null, false, true, triggerDependencies_17, btbProgramEditors$lambda_52(init_17))];
      var tmp_45 = new HierarchyEditorDefinition(getKClass(OntologyElementReferenceProvider), tmp155, toList(editorDefinitions_2));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var itemFactory = btbProgramEditors$lambda_53;
      var separator_6 = get_defaultChildrenSeparator();
      var tmp162 = new ChildrenRoleDefaults(getKClass(UnionClass_1), '<empty>', itemFactory, separator_6, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_3 = [unionEditor()];
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_4 = [tmp_45, new HierarchyEditorDefinition(getKClass(AnonymousClass), tmp162, toList(editorDefinitions_3))];
      var tmp_46 = new HierarchyEditorDefinition(getKClass(ClassExpression), tmp164, toList(editorDefinitions_4));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_18 = btbProgramEditors$lambda_54;
      var triggerDependencies_18 = emptyList();
      var tmp_47 = getKClass(ClassExpressionPlaceholder_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_5 = [tmp_46, new EditorDefinition(tmp_47, null, null, false, true, triggerDependencies_18, btbProgramEditors$lambda_55(init_18))];
      var tmp_48 = new HierarchyEditorDefinition(getKClass(ClassExpressionPlaceholder_1), tmp172, toList(editorDefinitions_5));
      var tmp174 = '<variables>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_4 = btbProgramEditors$lambda_56;
      var separator_7 = get_defaultChildrenSeparator();
      var tmp179 = new ChildrenRoleDefaults(getKClass(VariableDeclaration_1), tmp174, null, separator_7, completionSupplier_4, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_19 = btbProgramEditors$lambda_57;
      var triggerDependencies_19 = emptyList();
      var tmp_49 = getKClass(VariableDeclaration_1);
      var tmp$ret$36 = new EditorDefinition(tmp_49, tmp179, null, false, true, triggerDependencies_19, btbProgramEditors$lambda_58(init_19));
      btbProgramEditors = listOf_0([tmp_0, tmp_2, tmp_4, tmp_6, tmp_18, tmp_31, tmp_33, tmp_35, tmp_37, tmp_39, tmp_48, tmp$ret$36]);
    }
  }
  function enableEagerCompletion(_this__u8e3s4) {
    _this__u8e3s4.ypn().ylp(TextEditing_getInstance().ilx_1, true);
  }
  function commentEditor(_this__u8e3s4) {
    var tmp0 = lines$factory_0();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSpecification' call
    var textProperty = text$factory_2();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp = new MultipleChildLink(getKClass(MultilineText), tmp0);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$1 = new TextAttributeLink(getKClass(TextLine), textProperty);
    var tmp_0 = new TextSpecification(tmp, tmp$ret$1);
    var tmp_1 = commentEditor$lambda;
    multilineText(_this__u8e3s4, '<description>', tmp_0, tmp_1, commentEditor$lambda_0);
  }
  function commentEditor$lambda(source) {
    return source.cbb();
  }
  function commentEditor$lambda_0(it) {
    it.bln(Companion_getInstance_271().gls_1, true);
    it.bln(Companion_getInstance_271().fls_1, true);
    it.bln(Companion_getInstance_271().bls_1, new Color(90, 90, 90));
    return Unit_instance;
  }
  function lines$factory_0() {
    return getPropertyCallableRef('lines', 1, KProperty1, function (receiver) {
      return receiver.mbm();
    }, null);
  }
  function text$factory_2() {
    return getPropertyCallableRef('text', 1, KProperty1, function (receiver) {
      return receiver.laz();
    }, null);
  }
  function get_customCellEditors() {
    _init_properties_CustomCellEditors_kt__adyc75();
    return customCellEditors;
  }
  var customCellEditors;
  function constantCustomCellStyle(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    // Inline function 'kotlin.apply' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.constantCustomCellStyle.<anonymous>' call
    _this__u8e3s4.jlu().t2c(true);
    _this__u8e3s4.klu().t2c(true);
    return _this__u8e3s4;
  }
  function customCellEditors$lambda($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    children_2($this$editor, getKClass(CustomCell), VOID, VOID, VOID, VOID, VOID, VOID, VOID, cells$factory_0());
    return Unit_instance;
  }
  function customCellEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function customCellEditors$lambda_1(wrapperContext) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return ConstantCustomCell(wrapperContext);
  }
  function customCellEditors$lambda_2($this$childrenRoleDefaults) {
    _init_properties_CustomCellEditors_kt__adyc75();
    var tmp = $this$childrenRoleDefaults.wp3(Companion_getInstance_194().bc9_1);
    $this$childrenRoleDefaults.zp7(tmp, customCellEditors$lambda$lambda($this$childrenRoleDefaults));
    var tmp_0 = $this$childrenRoleDefaults.wp3(Companion_getInstance_195().rcd_1);
    $this$childrenRoleDefaults.zp7(tmp_0, customCellEditors$lambda$lambda_0($this$childrenRoleDefaults));
    var tmp_1 = $this$childrenRoleDefaults.wp3(Companion_getInstance_193().cbh_1);
    $this$childrenRoleDefaults.zp7(tmp_1, customCellEditors$lambda$lambda_1($this$childrenRoleDefaults));
    $this$childrenRoleDefaults.up7('ConstantCustomCell', customCellEditors$lambda$lambda_2($this$childrenRoleDefaults));
    var tmp_2 = $this$childrenRoleDefaults.tp7();
    var baseNode = (!(tmp_2 == null) ? isInterface(tmp_2, BTBNode) : false) ? tmp_2 : THROW_CCE();
    var parent = baseNode.yt();
    if (!(parent == null) ? isInterface(parent, ProcessDeclaration_1) : false) {
      $this$childrenRoleDefaults.up7('kind', customCellEditors$lambda$lambda_3($this$childrenRoleDefaults));
    } else {
      if (!(parent == null) ? isInterface(parent, FunctionDeclaration_1) : false) {
        $this$childrenRoleDefaults.up7('returnType', customCellEditors$lambda$lambda_4($this$childrenRoleDefaults));
        $this$childrenRoleDefaults.up7('cardinality', customCellEditors$lambda$lambda_5($this$childrenRoleDefaults));
      } else {
        throw IllegalStateException_init_$Create$_0('unknown: ' + toString_0(parent));
      }
    }
    if (isInterface(parent, DirectlyNamed)) {
      $this$childrenRoleDefaults.up7('name', customCellEditors$lambda$lambda_6($this$childrenRoleDefaults));
    }
    $this$childrenRoleDefaults.up7('properties', customCellEditors$lambda$lambda_7($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda($this_childrenRoleDefaults) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessPropertyCustomCell($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.customCellEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.i6u().t6s(reference);
      return this_0;
    };
  }
  function customCellEditors$lambda$lambda_0($this_childrenRoleDefaults) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyCustomCell($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.customCellEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.i6u().t6s(reference);
      return this_0;
    };
  }
  function customCellEditors$lambda$lambda_1($this_childrenRoleDefaults) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = LinkCustomCell($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.customCellEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.pbh().t6s(reference);
      return this_0;
    };
  }
  function customCellEditors$lambda$lambda_2($this_childrenRoleDefaults) {
    return function () {
      return ConstantCustomCell($this_childrenRoleDefaults.o71());
    };
  }
  function customCellEditors$lambda$lambda_3($this_childrenRoleDefaults) {
    return function () {
      return KindCustomCell($this_childrenRoleDefaults.o71());
    };
  }
  function customCellEditors$lambda$lambda_4($this_childrenRoleDefaults) {
    return function () {
      return ReturnTypeCustomCell($this_childrenRoleDefaults.o71());
    };
  }
  function customCellEditors$lambda$lambda_5($this_childrenRoleDefaults) {
    return function () {
      return CardinalityCustomCell($this_childrenRoleDefaults.o71());
    };
  }
  function customCellEditors$lambda$lambda_6($this_childrenRoleDefaults) {
    return function () {
      return DeclarationNameCustomCell($this_childrenRoleDefaults.o71());
    };
  }
  function customCellEditors$lambda$lambda_7($this_childrenRoleDefaults) {
    return function () {
      return PropertiesCustomCell($this_childrenRoleDefaults.o71());
    };
  }
  function customCellEditors$lambda_3($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    var tmp = text$factory_3();
    textProperty_0($this$editor, '<no text>', tmp, customCellEditors$lambda$lambda_8);
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_8($this$textProperty) {
    _init_properties_CustomCellEditors_kt__adyc75();
    constantCustomCellStyle($this$textProperty.ypn());
    return Unit_instance;
  }
  function customCellEditors$lambda_4($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function customCellEditors$lambda_5($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    var tmp1 = '<property ref>';
    var tmp2 = Companion_getInstance_194().bc9_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = customCellEditors$lambda$lambda_9;
    var options = new CompletionOptions();
    var containerInit = customCellEditors$lambda$lambda_10;
    var textCellInit = customCellEditors$lambda$lambda_11;
    var tmp;
    if (null == null) {
      tmp = customCellEditors$lambda$lambda_12;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = customCellEditors$lambda$lambda_13(textCellInit);
    var targetClass = getKClass(ProcessProperty_1);
    referenceTarget($this$editor, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_9(cell) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return cell.i6u();
  }
  function customCellEditors$lambda$lambda_10(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_11(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_12(it) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return true;
  }
  function customCellEditors$lambda$lambda_13($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function customCellEditors$lambda_6($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function customCellEditors$lambda_7($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    var tmp1 = '<property ref>';
    var tmp2 = Companion_getInstance_195().rcd_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = customCellEditors$lambda$lambda_14;
    var options = new CompletionOptions();
    var containerInit = customCellEditors$lambda$lambda_15;
    var textCellInit = customCellEditors$lambda$lambda_16;
    var tmp;
    if (null == null) {
      tmp = customCellEditors$lambda$lambda_17;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = customCellEditors$lambda$lambda_18(textCellInit);
    var targetClass = getKClass(AbstractProperty);
    referenceTarget($this$editor, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_14(cell) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return cell.i6u();
  }
  function customCellEditors$lambda$lambda_15(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_16(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_17(it) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return true;
  }
  function customCellEditors$lambda$lambda_18($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function customCellEditors$lambda_8($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function customCellEditors$lambda_9($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    var tmp1 = '<link ref>';
    var tmp2 = Companion_getInstance_193().cbh_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = customCellEditors$lambda$lambda_19;
    var options = new CompletionOptions();
    var containerInit = customCellEditors$lambda$lambda_20;
    var textCellInit = customCellEditors$lambda$lambda_21;
    var tmp;
    if (null == null) {
      tmp = customCellEditors$lambda$lambda_22;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = customCellEditors$lambda$lambda_23(textCellInit);
    var targetClass = getKClass(AbstractLink);
    referenceTarget($this$editor, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_19(cell) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return cell.pbh();
  }
  function customCellEditors$lambda$lambda_20(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_21(_this__u8e3s4) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return Unit_instance;
  }
  function customCellEditors$lambda$lambda_22(it) {
    _init_properties_CustomCellEditors_kt__adyc75();
    return true;
  }
  function customCellEditors$lambda$lambda_23($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function customCellEditors$lambda_10($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function customCellEditors$lambda_11($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    keyword_0($this$editor, 'return type');
    return Unit_instance;
  }
  function customCellEditors$lambda_12($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function customCellEditors$lambda_13($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    keyword_0($this$editor, 'cardinality');
    return Unit_instance;
  }
  function customCellEditors$lambda_14($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function customCellEditors$lambda_15($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    keyword_0($this$editor, 'kind');
    return Unit_instance;
  }
  function customCellEditors$lambda_16($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function customCellEditors$lambda_17($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    keyword_0($this$editor, 'name');
    return Unit_instance;
  }
  function customCellEditors$lambda_18($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function customCellEditors$lambda_19($this$editor) {
    _init_properties_CustomCellEditors_kt__adyc75();
    keyword_0($this$editor, 'properties');
    return Unit_instance;
  }
  function customCellEditors$lambda_20($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function cells$factory_0() {
    return getPropertyCallableRef('cells', 1, KProperty1, function (receiver) {
      return receiver.ob1();
    }, null);
  }
  function text$factory_3() {
    return getPropertyCallableRef('text', 1, KProperty1, function (receiver) {
      return receiver.laz();
    }, null);
  }
  var properties_initialized_CustomCellEditors_kt_snfflp;
  function _init_properties_CustomCellEditors_kt__adyc75() {
    if (!properties_initialized_CustomCellEditors_kt_snfflp) {
      properties_initialized_CustomCellEditors_kt_snfflp = true;
      var tmp0 = childRoleDefaults('<editor>');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = customCellEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(CustomEditor);
      var tmp_0 = new EditorDefinition(tmp, tmp0, null, false, true, triggerDependencies, customCellEditors$lambda_0(init));
      var tmp0_separator = separator(' ');
      var tmp7 = customCellEditors$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = customCellEditors$lambda_2;
      var tmp65 = new ChildrenRoleDefaults(getKClass(CustomCell), '<cells>', tmp7, tmp0_separator, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = customCellEditors$lambda_3;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(ConstantCustomCell_1);
      var tmp_2 = new EditorDefinition(tmp_1, null, null, false, true, triggerDependencies_0, customCellEditors$lambda_4(init_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = customCellEditors$lambda_5;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(ProcessPropertyCustomCell_1);
      var tmp_4 = new EditorDefinition(tmp_3, null, null, false, true, triggerDependencies_1, customCellEditors$lambda_6(init_1));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = customCellEditors$lambda_7;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(PropertyCustomCell_1);
      var tmp_6 = new EditorDefinition(tmp_5, null, null, false, true, triggerDependencies_2, customCellEditors$lambda_8(init_2));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = customCellEditors$lambda_9;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(LinkCustomCell_1);
      var tmp_8 = new EditorDefinition(tmp_7, null, null, false, true, triggerDependencies_3, customCellEditors$lambda_10(init_3));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = customCellEditors$lambda_11;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(ReturnTypeCustomCell_1);
      var tmp_10 = new EditorDefinition(tmp_9, null, null, false, true, triggerDependencies_4, customCellEditors$lambda_12(init_4));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_5 = customCellEditors$lambda_13;
      var triggerDependencies_5 = emptyList();
      var tmp_11 = getKClass(CardinalityCustomCell_1);
      var tmp_12 = new EditorDefinition(tmp_11, null, null, false, true, triggerDependencies_5, customCellEditors$lambda_14(init_5));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_6 = customCellEditors$lambda_15;
      var triggerDependencies_6 = emptyList();
      var tmp_13 = getKClass(KindCustomCell_1);
      var tmp_14 = new EditorDefinition(tmp_13, null, null, false, true, triggerDependencies_6, customCellEditors$lambda_16(init_6));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_7 = customCellEditors$lambda_17;
      var triggerDependencies_7 = emptyList();
      var tmp_15 = getKClass(DeclarationNameCustomCell_1);
      var tmp_16 = new EditorDefinition(tmp_15, null, null, false, true, triggerDependencies_7, customCellEditors$lambda_18(init_7));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_8 = customCellEditors$lambda_19;
      var triggerDependencies_8 = emptyList();
      var tmp_17 = getKClass(PropertiesCustomCell_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_12, tmp_14, tmp_16, new EditorDefinition(tmp_17, null, null, false, true, triggerDependencies_8, customCellEditors$lambda_20(init_8))];
      var tmp$ret$11 = new HierarchyEditorDefinition(getKClass(CustomCell), tmp65, toList(editorDefinitions));
      customCellEditors = listOf_0([tmp_0, tmp$ret$11]);
    }
  }
  function customEditor(_this__u8e3s4) {
    newLine_0(_this__u8e3s4);
    keyword_0(_this__u8e3s4, 'editor:');
    space_0(_this__u8e3s4);
    horizontal_0(_this__u8e3s4, customEditor$lambda);
    newLine_0(_this__u8e3s4);
    keyword_0(_this__u8e3s4, 'editor enabled:');
    space_0(_this__u8e3s4);
    booleanProperty(_this__u8e3s4, '<no>', customEditor$lambda_0);
  }
  function customEditor$lambda($this$horizontal) {
    var tmp = getKClass(CustomEditor);
    child_1($this$horizontal, tmp, customEditor$lambda$lambda);
    return Unit_instance;
  }
  function customEditor$lambda$lambda(bindingDeclaration) {
    return bindingDeclaration.qas();
  }
  function customEditor$lambda_0(bindingDeclaration) {
    return bindingDeclaration.ras();
  }
  function BTBEditorParts() {
    BTBEditorParts_instance = this;
    this.osj_1 = new CellMark();
    this.psj_1 = new CellMark();
  }
  var BTBEditorParts_instance;
  function BTBEditorParts_getInstance() {
    if (BTBEditorParts_instance == null)
      new BTBEditorParts();
    return BTBEditorParts_instance;
  }
  function get_extensionEditors() {
    _init_properties_ExtensionEditors_kt__buxyih();
    return extensionEditors;
  }
  var extensionEditors;
  function extensionEditors$lambda($this$editor) {
    _init_properties_ExtensionEditors_kt__buxyih();
    var tmp = getKClass(ExtensionDeclaration_1);
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, extensionEditors$lambda$lambda);
    return Unit_instance;
  }
  function extensionEditors$lambda$lambda(extensionLibrary) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return extensionLibrary.n9c();
  }
  function extensionEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function extensionEditors$lambda_1($this$editor) {
    _init_properties_ExtensionEditors_kt__buxyih();
    keyword_0($this$editor, 'extension');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', extensionEditors$lambda$lambda_0);
    space_0($this$editor);
    keyword_0($this$editor, 'for');
    space_0($this$editor);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$editor, tmp, extensionEditors$lambda$lambda_1);
    indent_0($this$editor, true, VOID, extensionEditors$lambda$lambda_2);
    return Unit_instance;
  }
  function extensionEditors$lambda$lambda_0(extensionDeclaration) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return extensionDeclaration.b3();
  }
  function extensionEditors$lambda$lambda_1(extensionDeclaration) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return extensionDeclaration.zb3();
  }
  function extensionEditors$lambda$lambda_2($this$indent) {
    _init_properties_ExtensionEditors_kt__buxyih();
    newLine_0($this$indent);
    var tmp = getKClass(FieldDeclaration_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, extensionEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function extensionEditors$lambda$lambda$lambda(extensionDeclaration) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return extensionDeclaration.yb3();
  }
  function extensionEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function extensionEditors$lambda_3($this$childrenRoleDefaults) {
    _init_properties_ExtensionEditors_kt__buxyih();
    var tmp = editorString($this$childrenRoleDefaults, BTBEditorParts_getInstance().osj_1);
    $this$childrenRoleDefaults.ap8(tmp, extensionEditors$lambda$lambda_3($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function extensionEditors$lambda$lambda_3($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = FieldDeclaration($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.extensionEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.b3().v2c(name);
      return this_0;
    };
  }
  function extensionEditors$lambda_4($this$editor) {
    _init_properties_ExtensionEditors_kt__buxyih();
    // Inline function 'kotlin.apply' call
    var this_0 = textProperty_0($this$editor, '<name>', extensionEditors$lambda$lambda_4);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.extensionEditors.<anonymous>.<anonymous>' call
    mark_0(this_0, BTBEditorParts_getInstance().osj_1);
    indentLabel_0($this$editor, ':', true);
    space_0($this$editor);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$editor, tmp, extensionEditors$lambda$lambda_5);
    space_0($this$editor);
    var tmp_0 = getKClass(Cardinality_1);
    child_1($this$editor, tmp_0, extensionEditors$lambda$lambda_6);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function extensionEditors$lambda$lambda_4(fieldDeclaration) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return fieldDeclaration.b3();
  }
  function extensionEditors$lambda$lambda_5(fieldDeclaration) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return fieldDeclaration.zb3();
  }
  function extensionEditors$lambda$lambda_6(fieldDeclaration) {
    _init_properties_ExtensionEditors_kt__buxyih();
    return fieldDeclaration.eb8();
  }
  function extensionEditors$lambda_5($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  var properties_initialized_ExtensionEditors_kt_if1mgn;
  function _init_properties_ExtensionEditors_kt__buxyih() {
    if (!properties_initialized_ExtensionEditors_kt_if1mgn) {
      properties_initialized_ExtensionEditors_kt_if1mgn = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = extensionEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(ExtensionLibrary_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, extensionEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<extension declarations>';
      var separator = get_defaultChildrenSeparator();
      var tmp11 = new ChildrenRoleDefaults(getKClass(ExtensionDeclaration_1), placeholderText, null, separator, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = extensionEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(ExtensionDeclaration_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp11, null, false, true, triggerDependencies_0, extensionEditors$lambda_2(init_0));
      var tmp17 = '<fields>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = extensionEditors$lambda_3;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp22 = new ChildrenRoleDefaults(getKClass(FieldDeclaration_1), tmp17, null, separator_0, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = extensionEditors$lambda_4;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(FieldDeclaration_1);
      var tmp$ret$4 = new EditorDefinition(tmp_3, tmp22, null, false, true, triggerDependencies_1, extensionEditors$lambda_5(init_1));
      extensionEditors = listOf_0([tmp_0, tmp_2, tmp$ret$4]);
    }
  }
  function get_factEditors() {
    _init_properties_FactEditors_kt__uuayug();
    return factEditors;
  }
  var factEditors;
  function factReferenceCompletion(_this__u8e3s4) {
    _init_properties_FactEditors_kt__uuayug();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_188().hb6_1);
    _this__u8e3s4.zp7(tmp, factReferenceCompletion$lambda(_this__u8e3s4));
  }
  function factEditors$lambda($this$editor) {
    _init_properties_FactEditors_kt__uuayug();
    if (get_supportFactSelection($this$editor)) {
      var hover = new ValueProperty(false);
      var selected = new ValueProperty(false);
      var factSelection = new FactSelectionToggle(get_stringId($this$editor.k6h()), hover, selected);
      $this$editor.ypn().olp(factSelection.dsp_1);
      var showIcon = Properties_getInstance().s2d([hover, selected]);
      var img = map_0(showIcon, factEditors$lambda$lambda($this$editor));
      // Inline function 'kotlin.apply' call
      // Inline function 'jetbrains.biokb.lang.editorBuilders.factEditors.<anonymous>.<anonymous>' call
      image($this$editor, img).olp(factSelection.csp_1);
      var tmp = PropertyBinding_instance;
      tmp.d2g(map_0(selected, factEditors$lambda$lambda_0($this$editor)), get_background($this$editor.ypn()));
      space_0($this$editor);
    }
    var tmp_0 = getKClass(Precondition);
    child_1($this$editor, tmp_0, factEditors$lambda$lambda_1);
    space_0($this$editor);
    textProperty_0($this$editor, '<no name>', factEditors$lambda$lambda_2);
    space_0($this$editor);
    var tmp_1 = getKClass(AbstractProcessSpecification);
    var tmp_2 = factEditors$lambda$lambda_3;
    child_1($this$editor, tmp_1, tmp_2, VOID, factEditors$lambda$lambda_4);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function factEditors$lambda$lambda($this_editor) {
    return function (it) {
      return it ? get_uiConfig($this_editor).isj_1 : get_uiConfig($this_editor).jsj_1;
    };
  }
  function factEditors$lambda$lambda_0($this_editor) {
    return function (it) {
      return it ? get_uiConfig($this_editor).hsj_1 : null;
    };
  }
  function factEditors$lambda$lambda_1(fact) {
    _init_properties_FactEditors_kt__uuayug();
    return fact.ob5();
  }
  function factEditors$lambda$lambda_2(fact) {
    _init_properties_FactEditors_kt__uuayug();
    return fact.b3();
  }
  function factEditors$lambda$lambda_3(fact) {
    _init_properties_FactEditors_kt__uuayug();
    return fact.pb5();
  }
  function factEditors$lambda$lambda_4(_unused_var__etf5q3, trait) {
    _init_properties_FactEditors_kt__uuayug();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function factEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function factEditors$lambda_1($this$childrenRoleDefaults) {
    _init_properties_FactEditors_kt__uuayug();
    factReferenceCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function factEditors$lambda_2($this$editor) {
    _init_properties_FactEditors_kt__uuayug();
    var tmp2 = Companion_getInstance_188().hb6_1;
    var tmp3 = ref$factory_3();
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var options = new CompletionOptions(VOID, false);
    var containerInit = factEditors$lambda$lambda_5;
    var textCellInit = factEditors$lambda$lambda_6;
    var tmp;
    if (null == null) {
      tmp = factEditors$lambda$lambda_7;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = factEditors$lambda$lambda_8(textCellInit);
    var targetClass = getKClass(Fact_1);
    var refCell = referenceTarget($this$editor, targetClass, '<fact>', tmp2, tmp3, null, tmp5, options, containerInit, textCellInit_0);
    considerEmptyBy($this$editor, refCell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function factEditors$lambda$lambda_5(_this__u8e3s4) {
    _init_properties_FactEditors_kt__uuayug();
    return Unit_instance;
  }
  function factEditors$lambda$lambda_6(_this__u8e3s4) {
    _init_properties_FactEditors_kt__uuayug();
    return Unit_instance;
  }
  function factEditors$lambda$lambda_7(it) {
    _init_properties_FactEditors_kt__uuayug();
    return true;
  }
  function factEditors$lambda$lambda_8($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function factEditors$lambda_3($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function factEditors$lambda_4($this$childRoleDefaults) {
    _init_properties_FactEditors_kt__uuayug();
    $this$childRoleDefaults.up7('ALWAYS', factEditors$lambda$lambda_9($this$childRoleDefaults));
    $this$childRoleDefaults.up7('NEVER', factEditors$lambda$lambda_10($this$childRoleDefaults));
    var tmp = $this$childRoleDefaults.bp8(factEditors$lambda$lambda_11);
    $this$childRoleDefaults.cp8(tmp, factEditors$lambda$lambda_12($this$childRoleDefaults));
    return Unit_instance;
  }
  function factEditors$lambda$lambda_9($this_childRoleDefaults) {
    return function () {
      return ConstantPrecondition_1($this_childRoleDefaults.o71(), When_ALWAYS_getInstance());
    };
  }
  function factEditors$lambda$lambda_10($this_childRoleDefaults) {
    return function () {
      return ConstantPrecondition_1($this_childRoleDefaults.o71(), When_NEVER_getInstance());
    };
  }
  function factEditors$lambda$lambda_11($this$using) {
    _init_properties_FactEditors_kt__uuayug();
    factReferenceCompletion($this$using);
    return Unit_instance;
  }
  function factEditors$lambda$lambda_12($this_childRoleDefaults) {
    return function (factReference) {
      // Inline function 'kotlin.apply' call
      var this_0 = FactPrecondition($this_childRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.factEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.fb6().e(factReference);
      return this_0;
    };
  }
  function factEditors$lambda_5(wrapperContext) {
    _init_properties_FactEditors_kt__uuayug();
    return ConstantPrecondition_1(wrapperContext, When_ALWAYS_getInstance());
  }
  function factEditors$lambda_6($this$editor) {
    _init_properties_FactEditors_kt__uuayug();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    var placeholder = '<no kind>';
    var enumCell = editableText_0($this$editor, VOID, placeholder, VOID, VOID, factEditors$lambda$lambda_13);
    considerEmptyBy($this$editor, enumCell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function factEditors$lambda$lambda_13($this$editableText) {
    _init_properties_FactEditors_kt__uuayug();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call
    var targetPropFactory = factEditors$lambda$lambda$lambda;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.factEditors.<anonymous>.<anonymous>' call
    var sourceProp = $this$editableText.k6h().r5e();
    var targetProp = targetPropFactory($this$editableText.ypn());
    $this$editableText.wle(syncTwoWay(sourceProp.n4z(), targetProp));
    return Unit_instance;
  }
  function factEditors$lambda$lambda$lambda(textCell) {
    _init_properties_FactEditors_kt__uuayug();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_9();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.en4(textCell, enumInfo);
  }
  function factEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function factEditors$lambda_8($this$editor) {
    _init_properties_FactEditors_kt__uuayug();
    indent_0($this$editor, VOID, VOID, factEditors$lambda$lambda_14);
    return Unit_instance;
  }
  function factEditors$lambda$lambda_14($this$indent) {
    _init_properties_FactEditors_kt__uuayug();
    var tmp = getKClass(FactReference_1);
    var tmp_0 = separator('&', true);
    children_2($this$indent, tmp, VOID, VOID, VOID, tmp_0, VOID, VOID, VOID, factEditors$lambda$lambda$lambda_0);
    space_0($this$indent);
    var tmp2 = Companion_getInstance_187().eb6_1;
    var tmp3 = relation$factory_2();
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referencedPropertySupplier = symbol$factory_0();
    var options = new CompletionOptions();
    var containerInit = factEditors$lambda$lambda$lambda_1;
    var textCellInit = factEditors$lambda$lambda$lambda_2;
    var tmp_1;
    if (null == null) {
      tmp_1 = factEditors$lambda$lambda$lambda_3;
    } else {
      tmp_1 = null;
    }
    var tmp5 = tmp_1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = factEditors$lambda$lambda$lambda_4(textCellInit);
    var targetClass = getKClass(ProcessRelationDeclaration_1);
    referenceTarget($this$indent, targetClass, '?->', tmp2, tmp3, referencedPropertySupplier, tmp5, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function factEditors$lambda$lambda$lambda_0(factPrecondition) {
    _init_properties_FactEditors_kt__uuayug();
    return factPrecondition.fb6();
  }
  function factEditors$lambda$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_FactEditors_kt__uuayug();
    return Unit_instance;
  }
  function factEditors$lambda$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_FactEditors_kt__uuayug();
    return Unit_instance;
  }
  function factEditors$lambda$lambda$lambda_3(it) {
    _init_properties_FactEditors_kt__uuayug();
    return true;
  }
  function factEditors$lambda$lambda$lambda_4($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function factEditors$lambda_9($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function factReferenceCompletion$lambda($this_factReferenceCompletion) {
    return function (reference) {
      return FactReference_2($this_factReferenceCompletion.o71(), reference);
    };
  }
  function ref$factory_3() {
    return getPropertyCallableRef('ref', 1, KProperty1, function (receiver) {
      return receiver.ub6();
    }, null);
  }
  function relation$factory_2() {
    return getPropertyCallableRef('relation', 1, KProperty1, function (receiver) {
      return receiver.gb6();
    }, null);
  }
  function symbol$factory_0() {
    return getPropertyCallableRef('symbol', 1, KProperty1, function (receiver) {
      return receiver.jcc();
    }, null);
  }
  var properties_initialized_FactEditors_kt_y03w3a;
  function _init_properties_FactEditors_kt__uuayug() {
    if (!properties_initialized_FactEditors_kt_y03w3a) {
      properties_initialized_FactEditors_kt_y03w3a = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var separator = get_defaultChildrenSeparator();
      var tmp5 = new ChildrenRoleDefaults(getKClass(Fact_1), '<facts>', null, separator, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = factEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(Fact_1);
      var tmp_0 = new EditorDefinition(tmp, tmp5, null, false, true, triggerDependencies, factEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = factEditors$lambda_1;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp16 = new ChildrenRoleDefaults(getKClass(FactReference_1), '<facts>', null, separator_0, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = factEditors$lambda_2;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(FactReference_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp16, null, false, true, triggerDependencies_0, factEditors$lambda_3(init_0));
      var tmp_3 = factEditors$lambda_4;
      var tmp34 = childRoleDefaults('_', tmp_3, factEditors$lambda_5);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = factEditors$lambda_6;
      var triggerDependencies_1 = emptyList();
      var tmp_4 = getKClass(ConstantPrecondition_0);
      var tmp_5 = new EditorDefinition(tmp_4, null, null, false, true, triggerDependencies_1, factEditors$lambda_7(init_1));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = factEditors$lambda_8;
      var triggerDependencies_2 = emptyList();
      var tmp_6 = getKClass(FactPrecondition_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_5, new EditorDefinition(tmp_6, null, null, false, true, triggerDependencies_2, factEditors$lambda_9(init_2))];
      var tmp$ret$6 = new HierarchyEditorDefinition(getKClass(Precondition), tmp34, toList(editorDefinitions));
      factEditors = listOf_0([tmp_0, tmp_2, tmp$ret$6]);
    }
  }
  function get_functionLibraryEditors() {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionLibraryEditors;
  }
  var functionLibraryEditors;
  function cardinalityConstantCompletion_0(_this__u8e3s4) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    var tmp = _this__u8e3s4.ep6();
    _this__u8e3s4.yp7(tmp, cardinalityConstantCompletion$lambda_0(_this__u8e3s4));
  }
  function functionLibraryEditors$lambda($this$editor) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    var tmp = getKClass(FunctionDeclaration_1);
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, functionLibraryEditors$lambda$lambda);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda(functionLibrary) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionLibrary.xb9();
  }
  function functionLibraryEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function functionLibraryEditors$lambda_1($this$editor) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    commentEditor($this$editor);
    newLine_0($this$editor);
    keyword_0($this$editor, 'function');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', functionLibraryEditors$lambda$lambda_0);
    indent_0($this$editor, true, VOID, functionLibraryEditors$lambda$lambda_1);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda_0(functionDeclaration) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionDeclaration.b3();
  }
  function functionLibraryEditors$lambda$lambda_1($this$indent) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    newLine_0($this$indent);
    keyword_0($this$indent, 'parameters:');
    space_0($this$indent);
    horizontal_0($this$indent, functionLibraryEditors$lambda$lambda$lambda);
    newLine_0($this$indent);
    newLine_0($this$indent);
    get_background(keyword_0($this$indent, 'old parameters:')).v2c(Companion_getInstance_325().wls_1);
    space_0($this$indent);
    get_background(horizontal_0($this$indent, functionLibraryEditors$lambda$lambda$lambda_0)).v2c(Companion_getInstance_325().wls_1);
    newLine_0($this$indent);
    newLine_0($this$indent);
    keyword_0($this$indent, 'returns');
    space_0($this$indent);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$indent, tmp, functionLibraryEditors$lambda$lambda$lambda_1);
    space_0($this$indent);
    var tmp_0 = getKClass(Cardinality_1);
    child_1($this$indent, tmp_0, functionLibraryEditors$lambda$lambda$lambda_2);
    newLine_0($this$indent);
    customEditor($this$indent);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda$lambda($this$horizontal) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    var tmp = getKClass(ProcessProperty_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$horizontal, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, functionLibraryEditors$lambda$lambda$lambda$lambda);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda$lambda$lambda(functionDeclaration) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionDeclaration.pas();
  }
  function functionLibraryEditors$lambda$lambda$lambda_0($this$horizontal) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    var tmp = getKClass(AbstractBindingEntry);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$horizontal, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, functionLibraryEditors$lambda$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda$lambda$lambda_0(functionDeclaration) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionDeclaration.w();
  }
  function functionLibraryEditors$lambda$lambda$lambda_1(functionDeclaration) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionDeclaration.kb9();
  }
  function functionLibraryEditors$lambda$lambda$lambda_2(functionDeclaration) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return functionDeclaration.eb8();
  }
  function functionLibraryEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function functionLibraryEditors$lambda_3($this$editor) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    var tmp = getKClass(CardinalityBound);
    child_1($this$editor, tmp, functionLibraryEditors$lambda$lambda_2);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda_2(it) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return it.cax();
  }
  function functionLibraryEditors$lambda_4($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function functionLibraryEditors$lambda_5($this$childRoleDefaults) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    $this$childRoleDefaults.up7('[', functionLibraryEditors$lambda$lambda_3($this$childRoleDefaults));
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda_3($this_childRoleDefaults) {
    return function () {
      return Cardinality($this_childRoleDefaults.o71());
    };
  }
  function functionLibraryEditors$lambda_6($this$editor) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    indentLabel_0($this$editor, '[');
    var tmp = getKClass(CardinalityBoundConstant_1);
    var lowerBoundCell = child_1($this$editor, tmp, functionLibraryEditors$lambda$lambda_4);
    var opt = indent_0($this$editor, VOID, VOID, functionLibraryEditors$lambda$lambda_5(lowerBoundCell));
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new functionLibraryEditors$5$$inlined$forDisposable$1($this$editor, opt);
    $this$editor.wle(tmp$ret$0);
    indentLabel_0($this$editor, ']', true);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda_4(cardinality) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return cardinality.tax();
  }
  function functionLibraryEditors$lambda$lambda$lambda_3(cardinality) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return cardinality.uax();
  }
  function functionLibraryEditors$lambda$lambda_5($lowerBoundCell) {
    return function ($this$indent) {
      indentLabel_0($this$indent, '..');
      var tmp = getKClass(CardinalityBoundPlaceholder_1);
      child_1($this$indent, tmp, functionLibraryEditors$lambda$lambda$lambda_3, VOID, VOID, VOID, VOID, toLastFocusable($lowerBoundCell));
      return Unit_instance;
    };
  }
  function functionLibraryEditors$5$$inlined$forDisposable$1($this_editor, $opt) {
    this.fsp_1 = $this_editor;
    this.gsp_1 = $opt;
    DisposableSynchronizer.call(this);
  }
  protoOf(functionLibraryEditors$5$$inlined$forDisposable$1).dlb = function (ctx) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.functionLibraryEditors.<anonymous>.<anonymous>' call
    return PropertyBinding_instance.d2g(not(isNull(this.fsp_1.k6h().uax().n4z())), this.gsp_1.elp());
  };
  function functionLibraryEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function functionLibraryEditors$lambda_8($this$childRoleDefaults) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    $this$childRoleDefaults.up7('n', functionLibraryEditors$lambda$lambda_6($this$childRoleDefaults));
    cardinalityConstantCompletion_0($this$childRoleDefaults);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda_6($this_childRoleDefaults) {
    return function () {
      return CardinalityBoundN($this_childRoleDefaults.o71());
    };
  }
  function functionLibraryEditors$lambda_9($this$childRoleDefaults) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    cardinalityConstantCompletion_0($this$childRoleDefaults);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda_10($this$editor) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    indent_0($this$editor, VOID, VOID, functionLibraryEditors$lambda$lambda_7);
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda_7($this$indent) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    var boundCell = integerProperty_0($this$indent, '<...>', functionLibraryEditors$lambda$lambda$lambda_4);
    rightTransform_1($this$indent, boundCell, functionLibraryEditors$lambda$lambda$lambda_5($this$indent));
    return Unit_instance;
  }
  function functionLibraryEditors$lambda$lambda$lambda_4(boundConstant) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    return boundConstant.y();
  }
  function functionLibraryEditors$lambda$lambda$lambda$lambda_1($this_indent, $cardinality, $cellFinder) {
    return function () {
      var upperBound = CardinalityBoundPlaceholder(get_internalConfig($this_indent).o71());
      $cardinality.uax().t2c(upperBound);
      var tmp0_safe_receiver = firstOrNull_1($cellFinder.vn4(upperBound));
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ulp(ProjectionalSynchronizers_getInstance().jlw_1);
      return tmp1_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp1_elvis_lhs;
    };
  }
  function functionLibraryEditors$lambda$lambda$lambda_5($this_indent) {
    return function ($this$completion, boundNode, _unused_var__etf5q3, cellFinder) {
      var tmp = boundNode.yt();
      var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Cardinality_1) : false) ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var cardinality = tmp_0;
      var tmp_1;
      if (boundNode === cardinality.tax().n4z().m2c() && cardinality.uax().n4z().m2c() == null) {
        $this$completion.tp3('..', functionLibraryEditors$lambda$lambda$lambda$lambda_1($this_indent, cardinality, cellFinder));
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function functionLibraryEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function functionLibraryEditors$lambda_12($this$editor) {
    _init_properties_FunctionLibraryEditors_kt__fllry5();
    keyword_0($this$editor, 'n');
    return Unit_instance;
  }
  function functionLibraryEditors$lambda_13($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function cardinalityConstantCompletion$lambda_0($this_cardinalityConstantCompletion) {
    return function (number) {
      // Inline function 'kotlin.apply' call
      var this_0 = CardinalityBoundConstant($this_cardinalityConstantCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.cardinalityConstantCompletion.<anonymous>.<anonymous>' call
      this_0.y().t2c(number);
      return this_0;
    };
  }
  var properties_initialized_FunctionLibraryEditors_kt_o8truj;
  function _init_properties_FunctionLibraryEditors_kt__fllry5() {
    if (!properties_initialized_FunctionLibraryEditors_kt_o8truj) {
      properties_initialized_FunctionLibraryEditors_kt_o8truj = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = functionLibraryEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(FunctionLibrary_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, functionLibraryEditors$lambda_0(init));
      var tmp6 = '<function declarations>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var separator = blankLine();
      var tmp11 = new ChildrenRoleDefaults(getKClass(FunctionDeclaration_1), tmp6, null, separator, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = functionLibraryEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(FunctionDeclaration_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp11, null, false, true, triggerDependencies_0, functionLibraryEditors$lambda_2(init_0));
      var tmp17 = childRoleDefaults();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = functionLibraryEditors$lambda_3;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(CardinalityBoundPlaceholder_1);
      var tmp_4 = new EditorDefinition(tmp_3, tmp17, null, false, true, triggerDependencies_1, functionLibraryEditors$lambda_4(init_1));
      var tmp23 = childRoleDefaults('<cardinality>', functionLibraryEditors$lambda_5);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = functionLibraryEditors$lambda_6;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(Cardinality_1);
      var tmp_6 = new EditorDefinition(tmp_5, tmp23, null, false, true, triggerDependencies_2, functionLibraryEditors$lambda_7(init_2));
      var tmp41 = childRoleDefaults('<bound>', functionLibraryEditors$lambda_8);
      var tmp29 = childRoleDefaults('<bound>', functionLibraryEditors$lambda_9);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = functionLibraryEditors$lambda_10;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(CardinalityBoundConstant_1);
      var tmp_8 = new EditorDefinition(tmp_7, tmp29, null, false, true, triggerDependencies_3, functionLibraryEditors$lambda_11(init_3));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = functionLibraryEditors$lambda_12;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(CardinalityBoundN_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_8, new EditorDefinition(tmp_9, null, null, false, true, triggerDependencies_4, functionLibraryEditors$lambda_13(init_4))];
      var tmp$ret$7 = new HierarchyEditorDefinition(getKClass(CardinalityBound), tmp41, toList(editorDefinitions));
      functionLibraryEditors = listOf_0([tmp_0, tmp_2, tmp_4, tmp_6, tmp$ret$7]);
    }
  }
  function get_knowledgeSourceReferenceEditors() {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return knowledgeSourceReferenceEditors;
  }
  var knowledgeSourceReferenceEditors;
  function get_knowledgeSourceEditors() {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return knowledgeSourceEditors;
  }
  var knowledgeSourceEditors;
  function get_PubMedIdUrlHandler() {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return PubMedIdUrlHandler;
  }
  var PubMedIdUrlHandler;
  function get_PMCIdUrlHandler() {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return PMCIdUrlHandler;
  }
  var PMCIdUrlHandler;
  function knowledgeSources(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    var tmp1 = getKClass(KnowledgeSourceReference);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = sources$factory_0();
    var placeholderTraitFactory = knowledgeSources$lambda;
    var clipboardSetup = knowledgeSources$lambda_0;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp = new MultipleChildLink(getKClass(HasKnowledgeSources), childrenProperty);
    children_2(_this__u8e3s4, tmp1, tmp, null, placeholderTraitFactory, null, clipboardSetup, null, layout, knowledgeSources$lambda_1(childrenProperty));
  }
  function knowledgeSourceReferenceCompletion(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    _this__u8e3s4.up7('url', knowledgeSourceReferenceCompletion$lambda(_this__u8e3s4));
    _this__u8e3s4.up7('PubMed', knowledgeSourceReferenceCompletion$lambda_0(_this__u8e3s4));
    _this__u8e3s4.up7('published', knowledgeSourceReferenceCompletion$lambda_1(_this__u8e3s4));
  }
  function PrefixedURLTrait(urlPrefix) {
    BaseDerivedCellTrait.call(this, URLHandler_getInstance());
    this.isp_1 = urlPrefix;
  }
  protoOf(PrefixedURLTrait).flo = function (cell, spec) {
    var tmp;
    var tmp_0;
    if (cell instanceof TextCell) {
      tmp_0 = equals(spec, Companion_getInstance_312().hn3_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.isp_1 + cell.laz().m2c();
    } else {
      tmp = protoOf(BaseDerivedCellTrait).flo.call(this, cell, spec);
    }
    return tmp;
  };
  function addImportFromPubMedAction(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    addTraitOnAttach_0(_this__u8e3s4, addImportFromPubMedAction$lambda(_this__u8e3s4));
  }
  function pageSpecificationCompletion(_this__u8e3s4, wrapperContext) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    _this__u8e3s4.up7('range', pageSpecificationCompletion$lambda(wrapperContext));
    var tmp = _this__u8e3s4.ep6();
    _this__u8e3s4.yp7(tmp, pageSpecificationCompletion$lambda_0(wrapperContext));
  }
  function libraryItemCompletion(_this__u8e3s4, wrapperContext) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    _this__u8e3s4.up7('book', libraryItemCompletion$lambda(wrapperContext));
    _this__u8e3s4.up7('paper', libraryItemCompletion$lambda_0(wrapperContext));
  }
  function publishedBy(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0(_this__u8e3s4, 'published by');
    space_0(_this__u8e3s4);
    textProperty_0(_this__u8e3s4, '<publisher>', publishedBy$lambda);
    space_0(_this__u8e3s4);
    label_0(_this__u8e3s4, 'at');
    space_0(_this__u8e3s4);
    textProperty_0(_this__u8e3s4, '<date>', publishedBy$lambda_0);
  }
  function knowledgeSourceReferenceEditors$KnowledgeSourceReferencePlaceholder(p0) {
    return KnowledgeSourceReferencePlaceholder(p0);
  }
  function knowledgeSourceReferenceEditors$KnowledgeSourceReferencePlaceholder$ref() {
    return function (p0) {
      return knowledgeSourceReferenceEditors$KnowledgeSourceReferencePlaceholder(p0);
    };
  }
  function knowledgeSourceReferenceEditors$lambda($this$childrenRoleDefaults) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    knowledgeSourceReferenceCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda_0($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    placeholderInCollection_0($this$editor, '<enter source>', knowledgeSourceReferenceEditors$lambda$lambda);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda($this$placeholderInCollection) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    knowledgeSourceReferenceCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda_1($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function knowledgeSourceReferenceEditors$lambda_2($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'source url:');
    space_0($this$editor);
    textProperty_0($this$editor, '<url>', knowledgeSourceReferenceEditors$lambda$lambda_0).olp(URLHandler_getInstance());
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_0(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.jbu();
  }
  function knowledgeSourceReferenceEditors$lambda_3($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function knowledgeSourceReferenceEditors$lambda_4($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'PubMed id:');
    space_0($this$editor);
    textProperty_0($this$editor, '<id>', knowledgeSourceReferenceEditors$lambda$lambda_1).olp(get_PubMedIdUrlHandler());
    ensureLastCaretPosition($this$editor);
    var tmp = $this$editor.upn();
    if (!(isInterface(tmp, InternalEditorBuilderConfig) ? tmp : THROW_CCE()).jpo()) {
      addImportFromPubMedAction($this$editor);
    }
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_1(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.rc5();
  }
  function knowledgeSourceReferenceEditors$lambda_5($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function knowledgeSourceReferenceEditors$lambda_6($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'source:');
    space_0($this$editor);
    var tmp2 = Companion_getInstance_199().fch_1;
    var tmp3 = knowledgeSourceReferenceEditors$lambda$lambda_2;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var containerInit = knowledgeSourceReferenceEditors$lambda$lambda_3;
    var options = new CompletionOptions();
    var textCellInit = knowledgeSourceReferenceEditors$lambda$lambda_4;
    var tmp;
    if (null == null) {
      tmp = knowledgeSourceReferenceEditors$lambda$lambda_5;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = knowledgeSourceReferenceEditors$lambda$lambda_6(textCellInit);
    var targetClass = getKClass(PublishedWork);
    referenceTarget($this$editor, targetClass, '<...>', tmp2, tmp3, null, tmp5, options, containerInit, textCellInit_0);
    space_0($this$editor);
    var tmp10 = getKClass(PageSpecification);
    var tmp11 = pageSpecification$factory_0();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var placeholderText = '<no pages>';
    var placeholderTraitFactory = knowledgeSourceReferenceEditors$lambda$lambda_7;
    var clipboardSetup = knowledgeSourceReferenceEditors$lambda$lambda_8;
    var tmp_0 = knowledgeSourceReferenceEditors$lambda$lambda_9(tmp11);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(PublishedSourceReference_1), tmp11);
    child_1($this$editor, tmp10, tmp_0, placeholderText, placeholderTraitFactory, null, clipboardSetup, null, null, tmp$ret$2, null);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_2(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.k6h();
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_3($this$btbReferenceTarget) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    var work = $this$btbReferenceTarget.k6h();
    var tmp;
    if (isInterface(work, Paper_1)) {
      // Inline function 'kotlin.text.isNotBlank' call
      var this_0 = work.rc5().n4z().m2c();
      tmp = !isBlank(this_0);
    } else {
      tmp = false;
    }
    if (tmp) {
      space_0($this$btbReferenceTarget);
      label_0($this$btbReferenceTarget, '(', VOID, false);
      label_0($this$btbReferenceTarget, 'PubMed:');
      space_0($this$btbReferenceTarget);
      textProperty_0($this$btbReferenceTarget, '<id>', knowledgeSourceReferenceEditors$lambda$lambda$lambda(work)).olp(get_PubMedIdUrlHandler());
      label_0($this$btbReferenceTarget, ')', false);
    }
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda$lambda($work) {
    return function (it) {
      return $work.rc5();
    };
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_4(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_5(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return true;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_6($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_7(_unused_var__etf5q3, trait) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return trait;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_8(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_9($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function knowledgeSourceReferenceEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function knowledgeSourceReferenceEditors$lambda_8(wrapperContext) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    // Inline function 'kotlin.apply' call
    var this_0 = Page(wrapperContext);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.knowledgeSourceReferenceEditors.<anonymous>.<anonymous>' call
    this_0.xc3().t2c(0);
    return this_0;
  }
  function knowledgeSourceReferenceEditors$lambda_9($this$childrenRoleDefaults) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    pageSpecificationCompletion($this$childrenRoleDefaults, $this$childrenRoleDefaults.o71());
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda_10($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'pp.', VOID, false);
    integerProperty_0($this$editor, '<start>', knowledgeSourceReferenceEditors$lambda$lambda_10);
    label_0($this$editor, '-', false, false);
    integerProperty_0($this$editor, '<end>', knowledgeSourceReferenceEditors$lambda$lambda_11);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_10(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.q1();
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_11(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.mc4();
  }
  function knowledgeSourceReferenceEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function knowledgeSourceReferenceEditors$lambda_12($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'p.', VOID, false);
    integerProperty_0($this$editor, '<page>', knowledgeSourceReferenceEditors$lambda$lambda_12);
    return Unit_instance;
  }
  function knowledgeSourceReferenceEditors$lambda$lambda_12(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.xc3();
  }
  function knowledgeSourceReferenceEditors$lambda_13($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function knowledgeSourceEditors$lambda($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'Published sources:');
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < 2)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'jetbrains.biokb.lang.editorBuilders.knowledgeSourceEditors.<anonymous>.<anonymous>' call
        newLine_0($this$editor);
      }
       while (inductionVariable < 2);
    indent_0($this$editor, true, VOID, knowledgeSourceEditors$lambda$lambda);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda($this$indent) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    newLine_0($this$indent);
    var tmp1 = getKClass(LibraryItem);
    var tmp2 = items$factory_0();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var layout = Layout_VERTICAL_getInstance();
    var placeholderTraitFactory = knowledgeSourceEditors$lambda$lambda$lambda;
    var clipboardSetup = knowledgeSourceEditors$lambda$lambda$lambda_0;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp = new MultipleChildLink(getKClass(PublishedSourcesLibrary_1), tmp2);
    children_2($this$indent, tmp1, tmp, null, placeholderTraitFactory, null, clipboardSetup, null, layout, knowledgeSourceEditors$lambda$lambda$lambda_1(tmp2));
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda(_unused_var__etf5q3, trait) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return trait;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_0(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_1($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function knowledgeSourceEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function knowledgeSourceEditors$lambda_1($this$childrenRoleDefaults) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    var tmp = $this$childrenRoleDefaults.dp6();
    $this$childrenRoleDefaults.wp7(tmp, knowledgeSourceEditors$lambda$lambda_0($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda_0($this_childrenRoleDefaults) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = Author($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.knowledgeSourceEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.b3().v2c(it);
      return this_0;
    };
  }
  function knowledgeSourceEditors$lambda_2($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    var tmp = knowledgeSourceEditors$lambda$lambda_1;
    editableText_0($this$editor, VOID, '<name>', tmp, VOID, knowledgeSourceEditors$lambda$lambda_2);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda_1(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return !contains_9(it, ',');
  }
  function knowledgeSourceEditors$lambda$lambda_2($this$editableText) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.knowledgeSourceEditors.<anonymous>.<anonymous>.<anonymous>' call
    var sourceProp = $this$editableText.k6h().b3();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay.stub_for_inlining' call
    var targetProp = $this$editableText.ypn().laz();
    $this$editableText.wle(syncTwoWay(sourceProp.n4z(), targetProp));
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda_3($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function knowledgeSourceEditors$lambda_4(context) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return LibraryItemPlaceholder(context);
  }
  function knowledgeSourceEditors$lambda_5($this$childrenRoleDefaults) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    libraryItemCompletion($this$childrenRoleDefaults, $this$childrenRoleDefaults.o71());
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda_6($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    placeholderInCollection_0($this$editor, VOID, knowledgeSourceEditors$lambda$lambda_3);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda_3($this$placeholderInCollection) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    libraryItemCompletion($this$placeholderInCollection, $this$placeholderInCollection.o71());
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function knowledgeSourceEditors$lambda_8($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'Book');
    space_0($this$editor);
    label_0($this$editor, '"', VOID, false);
    textProperty_0($this$editor, '<title>', knowledgeSourceEditors$lambda$lambda_4);
    label_0($this$editor, '"', false);
    space_0($this$editor);
    textProperty_0($this$editor, '<no edition>', knowledgeSourceEditors$lambda$lambda_5);
    newLine_0($this$editor);
    newLine_0($this$editor);
    indent_0($this$editor, true, VOID, knowledgeSourceEditors$lambda$lambda_6);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda_4(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.zat();
  }
  function knowledgeSourceEditors$lambda$lambda_5(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.daw();
  }
  function knowledgeSourceEditors$lambda$lambda_6($this$indent) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    newLine_0($this$indent);
    label_0($this$indent, 'by');
    space_0($this$indent);
    var tmp1 = getKClass(Author_1);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = authors$factory_0();
    var placeholderTraitFactory = knowledgeSourceEditors$lambda$lambda$lambda_2;
    var clipboardSetup = knowledgeSourceEditors$lambda$lambda$lambda_3;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp = new MultipleChildLink(getKClass(Book_1), childrenProperty);
    children_2($this$indent, tmp1, tmp, null, placeholderTraitFactory, null, clipboardSetup, null, layout, knowledgeSourceEditors$lambda$lambda$lambda_4(childrenProperty));
    newLine_0($this$indent);
    publishedBy($this$indent);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_2(_unused_var__etf5q3, trait) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return trait;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_3(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_4($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function knowledgeSourceEditors$lambda_9($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function knowledgeSourceEditors$lambda_10($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'Paper');
    space_0($this$editor);
    label_0($this$editor, '"', VOID, false);
    textProperty_0($this$editor, '<title>', knowledgeSourceEditors$lambda$lambda_7);
    label_0($this$editor, '"', false);
    newLine_0($this$editor);
    indent_0($this$editor, true, VOID, knowledgeSourceEditors$lambda$lambda_8);
    newLine_0($this$editor);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda_7(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.zat();
  }
  function knowledgeSourceEditors$lambda$lambda_8($this$indent) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    newLine_0($this$indent);
    label_0($this$indent, 'in');
    space_0($this$indent);
    textProperty_0($this$indent, '<source title>', knowledgeSourceEditors$lambda$lambda$lambda_5);
    space_0($this$indent);
    label_0($this$indent, '(', VOID, false);
    textProperty_0($this$indent, '<short title>', knowledgeSourceEditors$lambda$lambda$lambda_6);
    label_0($this$indent, ')', false);
    space_0($this$indent);
    textProperty_0($this$indent, '<no volume>', knowledgeSourceEditors$lambda$lambda$lambda_7);
    space_0($this$indent);
    textProperty_0($this$indent, '<no issue>', knowledgeSourceEditors$lambda$lambda$lambda_8);
    newLine_0($this$indent);
    label_0($this$indent, 'by');
    space_0($this$indent);
    var tmp1 = getKClass(Author_1);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = authors$factory_1();
    var placeholderTraitFactory = knowledgeSourceEditors$lambda$lambda$lambda_9;
    var clipboardSetup = knowledgeSourceEditors$lambda$lambda$lambda_10;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp = new MultipleChildLink(getKClass(Paper_1), childrenProperty);
    children_2($this$indent, tmp1, tmp, null, placeholderTraitFactory, null, clipboardSetup, null, layout, knowledgeSourceEditors$lambda$lambda$lambda_11(childrenProperty));
    newLine_0($this$indent);
    publishedBy($this$indent);
    newLine_0($this$indent);
    label_0($this$indent, 'pages');
    space_0($this$indent);
    var tmp9 = getKClass(PageSpecification);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var childProperty = pages$factory_0();
    var placeholderTraitFactory_0 = knowledgeSourceEditors$lambda$lambda$lambda_12;
    var clipboardSetup_0 = knowledgeSourceEditors$lambda$lambda$lambda_13;
    var tmp_0 = knowledgeSourceEditors$lambda$lambda$lambda_14(childProperty);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(Paper_1), childProperty);
    child_1($this$indent, tmp9, tmp_0, null, placeholderTraitFactory_0, null, clipboardSetup_0, null, null, tmp$ret$2, null);
    newLine_0($this$indent);
    newLine_0($this$indent);
    label_0($this$indent, 'PubMed:');
    space_0($this$indent);
    textProperty_0($this$indent, '<id>', knowledgeSourceEditors$lambda$lambda$lambda_15).olp(get_PubMedIdUrlHandler());
    newLine_0($this$indent);
    label_0($this$indent, 'PMC:');
    space_0($this$indent);
    textProperty_0($this$indent, '<id>', knowledgeSourceEditors$lambda$lambda$lambda_16).olp(get_PMCIdUrlHandler());
    newLine_0($this$indent);
    label_0($this$indent, 'DOI:');
    space_0($this$indent);
    textProperty_0($this$indent, '<id>', knowledgeSourceEditors$lambda$lambda$lambda_17);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_5(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.oc5();
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_6(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.nc5();
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_7(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.pc5();
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_8(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.qc5();
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_9(_unused_var__etf5q3, trait) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return trait;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_10(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_11($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_12(_unused_var__etf5q3, trait) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return trait;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_13(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_14($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_15(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.rc5();
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_16(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.sc5();
  }
  function knowledgeSourceEditors$lambda$lambda$lambda_17(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.tc5();
  }
  function knowledgeSourceEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function knowledgeSourceEditors$lambda_12($this$editor) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    label_0($this$editor, 'data:');
    space_0($this$editor);
    textProperty_0($this$editor, '<data>', knowledgeSourceEditors$lambda$lambda_9);
    newLine_0($this$editor);
    label_0($this$editor, 'authors:');
    space_0($this$editor);
    textProperty_0($this$editor, '<authors>', knowledgeSourceEditors$lambda$lambda_10);
    return Unit_instance;
  }
  function knowledgeSourceEditors$lambda$lambda_9(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.ebs();
  }
  function knowledgeSourceEditors$lambda$lambda_10(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.dbs();
  }
  function knowledgeSourceEditors$lambda_13($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function knowledgeSources$lambda(_unused_var__etf5q3, trait) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return trait;
  }
  function knowledgeSources$lambda_0(_this__u8e3s4) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return Unit_instance;
  }
  function knowledgeSources$lambda_1($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function knowledgeSourceReferenceCompletion$lambda($this_knowledgeSourceReferenceCompletion) {
    return function () {
      return UrlKnowledgeSourceReference($this_knowledgeSourceReferenceCompletion.o71());
    };
  }
  function knowledgeSourceReferenceCompletion$lambda_0($this_knowledgeSourceReferenceCompletion) {
    return function () {
      return PubMedSourceReference($this_knowledgeSourceReferenceCompletion.o71());
    };
  }
  function knowledgeSourceReferenceCompletion$lambda_1($this_knowledgeSourceReferenceCompletion) {
    return function () {
      return PublishedSourceReference($this_knowledgeSourceReferenceCompletion.o71());
    };
  }
  function addImportFromPubMedAction$lambda$o$onKeyPressed$slambda$lambda($this_addImportFromPubMedAction, $publishedSourceReference) {
    return function () {
      $this_addImportFromPubMedAction.k6h().s6m($publishedSourceReference);
      return Unit_instance;
    };
  }
  function addImportFromPubMedAction$lambda$o$onKeyPressed$slambda($editorDocumentsApi, $pubMedId, $container, this$0, $this_addImportFromPubMedAction, $cellFinder, resultContinuation) {
    this.rsp_1 = $editorDocumentsApi;
    this.ssp_1 = $pubMedId;
    this.tsp_1 = $container;
    this.usp_1 = this$0;
    this.vsp_1 = $this_addImportFromPubMedAction;
    this.wsp_1 = $cellFinder;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(addImportFromPubMedAction$lambda$o$onKeyPressed$slambda).h1l = function ($this$launch, $completion) {
    var tmp = this.i1l($this$launch, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(addImportFromPubMedAction$lambda$o$onKeyPressed$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(addImportFromPubMedAction$lambda$o$onKeyPressed$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.rsp_1.zs0(this.ssp_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            if (!(result.yk9_1 == null)) {
              var tmp0_safe_receiver = this.tsp_1.u3o().ulp(Companion_getInstance_387().srs_1);
              var tmp_0;
              if (tmp0_safe_receiver == null) {
                tmp_0 = null;
              } else {
                var tmp1_elvis_lhs = result.yk9_1;
                tmp0_safe_receiver.ls6('Import from PubMed', 'Could not import paper data from PubMed', tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
                tmp_0 = Unit_instance;
              }
              if (tmp_0 == null) {
                this.usp_1.ysp_1.do('PubMed import error: ' + result.yk9_1);
              }
              return Unit_instance;
            }

            var paperRefText = ensureNotNull(result.xk9_1);
            var publishedSourceReference = get_internalConfig(this.vsp_1).sps().y6z(getKClass(PublishedSourceReference_1));
            publishedSourceReference.k6h().v2c(paperRefText);
            this.tsp_1.hm9(addImportFromPubMedAction$lambda$o$onKeyPressed$slambda$lambda(this.vsp_1, publishedSourceReference));
            var tmp3_safe_receiver = firstOrNull_1(this.wsp_1.vn4(publishedSourceReference));
            var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : lastFocusable(tmp3_safe_receiver);
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.ul5();
            }

            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(addImportFromPubMedAction$lambda$o$onKeyPressed$slambda).i1l = function ($this$launch, completion) {
    var i = new addImportFromPubMedAction$lambda$o$onKeyPressed$slambda(this.rsp_1, this.ssp_1, this.tsp_1, this.usp_1, this.vsp_1, this.wsp_1, completion);
    i.xsp_1 = $this$launch;
    return i;
  };
  function addImportFromPubMedAction$lambda$o$onKeyPressed$slambda_0($editorDocumentsApi, $pubMedId, $container, this$0, $this_addImportFromPubMedAction, $cellFinder, resultContinuation) {
    var i = new addImportFromPubMedAction$lambda$o$onKeyPressed$slambda($editorDocumentsApi, $pubMedId, $container, this$0, $this_addImportFromPubMedAction, $cellFinder, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.h1l($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function addImportFromPubMedAction$1$1($this_addImportFromPubMedAction, $cellFinder) {
    this.zsp_1 = $this_addImportFromPubMedAction;
    this.asq_1 = $cellFinder;
    CellTrait.call(this);
    this.ysp_1 = getLogger_0('PubMedImportAction');
  }
  protoOf(addImportFromPubMedAction$1$1).llm = function (cell, event) {
    if (event.rl1([KeyStroke_init_$Create$(Key_P_getInstance(), [ModifierKey_CONTROL_getInstance()])])) {
      event.ol0();
      var tmp0_elvis_lhs = cell.llk();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var container = tmp;
      var pubMedId = this.zsp_1.k6h().rc5().n4z().m2c();
      if (isBlank(pubMedId))
        return Unit_instance;
      // Inline function 'kotlin.checkNotNull' call
      var tmp0 = container.u3o().ulp(Companion_getInstance_387().rrs_1);
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          // Inline function 'kotlin.checkNotNull.<anonymous>' call
          var message = 'Required value was null.';
          throw IllegalStateException_init_$Create$_0(toString_1(message));
        } else {
          tmp$ret$1 = tmp0;
          break $l$block;
        }
      }
      var editorDocumentsApi = tmp$ret$1;
      var tmp_0 = coroutineScope_0(container);
      launch(tmp_0, VOID, VOID, addImportFromPubMedAction$lambda$o$onKeyPressed$slambda_0(editorDocumentsApi, pubMedId, container, this, this.zsp_1, this.asq_1, null));
    }
  };
  function addImportFromPubMedAction$lambda($this_addImportFromPubMedAction) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, cellFinder) {
      return new addImportFromPubMedAction$1$1($this_addImportFromPubMedAction, cellFinder);
    };
  }
  function pageSpecificationCompletion$lambda($wrapperContext) {
    return function () {
      // Inline function 'kotlin.apply' call
      var this_0 = PageRange($wrapperContext);
      // Inline function 'jetbrains.biokb.lang.editorBuilders.pageSpecificationCompletion.<anonymous>.<anonymous>' call
      this_0.q1().t2c(0);
      this_0.mc4().t2c(0);
      return this_0;
    };
  }
  function pageSpecificationCompletion$lambda_0($wrapperContext) {
    return function (number) {
      // Inline function 'kotlin.apply' call
      var this_0 = Page($wrapperContext);
      // Inline function 'jetbrains.biokb.lang.editorBuilders.pageSpecificationCompletion.<anonymous>.<anonymous>' call
      this_0.xc3().t2c(number);
      return this_0;
    };
  }
  function libraryItemCompletion$lambda($wrapperContext) {
    return function () {
      return Book($wrapperContext);
    };
  }
  function libraryItemCompletion$lambda_0($wrapperContext) {
    return function () {
      return Paper($wrapperContext);
    };
  }
  function publishedBy$lambda(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.vci();
  }
  function publishedBy$lambda_0(it) {
    _init_properties_KnowledgeSourceEditors_kt__e7emfh();
    return it.wci();
  }
  function sources$factory_0() {
    return getPropertyCallableRef('sources', 1, KProperty1, function (receiver) {
      return receiver.ubb();
    }, null);
  }
  function pageSpecification$factory_0() {
    return getPropertyCallableRef('pageSpecification', 1, KProperty1, function (receiver) {
      return receiver.uch();
    }, null);
  }
  function items$factory_0() {
    return getPropertyCallableRef('items', 1, KProperty1, function (receiver) {
      return receiver.cq();
    }, null);
  }
  function authors$factory_0() {
    return getPropertyCallableRef('authors', 1, KProperty1, function (receiver) {
      return receiver.yat();
    }, null);
  }
  function authors$factory_1() {
    return getPropertyCallableRef('authors', 1, KProperty1, function (receiver) {
      return receiver.yat();
    }, null);
  }
  function pages$factory_0() {
    return getPropertyCallableRef('pages', 1, KProperty1, function (receiver) {
      return receiver.uc5();
    }, null);
  }
  var properties_initialized_KnowledgeSourceEditors_kt_4l1wdt;
  function _init_properties_KnowledgeSourceEditors_kt__e7emfh() {
    if (!properties_initialized_KnowledgeSourceEditors_kt_4l1wdt) {
      properties_initialized_KnowledgeSourceEditors_kt_4l1wdt = true;
      var tmp0 = '<no sources specified>';
      var tmp1 = knowledgeSourceReferenceEditors$KnowledgeSourceReferencePlaceholder$ref();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = knowledgeSourceReferenceEditors$lambda;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp29 = new ChildrenRoleDefaults(getKClass(KnowledgeSourceReference), tmp0, tmp1, separator_0, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = knowledgeSourceReferenceEditors$lambda_0;
      var triggerDependencies = emptyList();
      var tmp = getKClass(KnowledgeSourceReferencePlaceholder_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, knowledgeSourceReferenceEditors$lambda_1(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = knowledgeSourceReferenceEditors$lambda_2;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(UrlKnowledgeSourceReference_1);
      var tmp_2 = new EditorDefinition(tmp_1, null, null, false, true, triggerDependencies_0, knowledgeSourceReferenceEditors$lambda_3(init_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = knowledgeSourceReferenceEditors$lambda_4;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(PubMedSourceReference_1);
      var tmp_4 = new EditorDefinition(tmp_3, null, null, false, true, triggerDependencies_1, knowledgeSourceReferenceEditors$lambda_5(init_1));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = knowledgeSourceReferenceEditors$lambda_6;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(PublishedSourceReference_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_0, tmp_2, tmp_4, new EditorDefinition(tmp_5, null, null, false, true, triggerDependencies_2, knowledgeSourceReferenceEditors$lambda_7(init_2))];
      var tmp_6 = new HierarchyEditorDefinition(getKClass(KnowledgeSourceReference), tmp29, toList(editorDefinitions));
      var tmp31 = '<no pages>';
      var tmp32 = knowledgeSourceReferenceEditors$lambda_8;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = knowledgeSourceReferenceEditors$lambda_9;
      var separator_1 = get_defaultChildrenSeparator();
      var tmp48 = new ChildrenRoleDefaults(getKClass(PageSpecification), tmp31, tmp32, separator_1, completionSupplier_0, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = knowledgeSourceReferenceEditors$lambda_10;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(PageRange_1);
      var tmp_8 = new EditorDefinition(tmp_7, null, null, false, true, triggerDependencies_3, knowledgeSourceReferenceEditors$lambda_11(init_3));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = knowledgeSourceReferenceEditors$lambda_12;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(Page_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_0 = [tmp_8, new EditorDefinition(tmp_9, null, null, false, true, triggerDependencies_4, knowledgeSourceReferenceEditors$lambda_13(init_4))];
      var tmp$ret$9 = new HierarchyEditorDefinition(getKClass(PageSpecification), tmp48, toList(editorDefinitions_0));
      knowledgeSourceReferenceEditors = listOf_0([tmp_6, tmp$ret$9]);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_5 = knowledgeSourceEditors$lambda;
      var triggerDependencies_5 = emptyList();
      var tmp_10 = getKClass(PublishedSourcesLibrary_1);
      var tmp_11 = new EditorDefinition(tmp_10, null, null, false, true, triggerDependencies_5, knowledgeSourceEditors$lambda_0(init_5));
      var tmp6 = '<authors>';
      var tmp7 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_1 = knowledgeSourceEditors$lambda_1;
      var tmp11 = new ChildrenRoleDefaults(getKClass(Author_1), tmp6, null, tmp7, completionSupplier_1, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_6 = knowledgeSourceEditors$lambda_2;
      var triggerDependencies_6 = emptyList();
      var tmp_12 = getKClass(Author_1);
      var tmp_13 = new EditorDefinition(tmp_12, tmp11, null, false, true, triggerDependencies_6, knowledgeSourceEditors$lambda_3(init_6));
      var tmp0_separator = blankLine();
      var tmp17 = '<editions>';
      var tmp18 = knowledgeSourceEditors$lambda_4;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_2 = knowledgeSourceEditors$lambda_5;
      var tmp46 = new ChildrenRoleDefaults(getKClass(LibraryItem), tmp17, tmp18, tmp0_separator, completionSupplier_2, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_7 = knowledgeSourceEditors$lambda_6;
      var triggerDependencies_7 = emptyList();
      var tmp_14 = getKClass(LibraryItemPlaceholder_1);
      var tmp_15 = new EditorDefinition(tmp_14, null, null, false, true, triggerDependencies_7, knowledgeSourceEditors$lambda_7(init_7));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_8 = knowledgeSourceEditors$lambda_8;
      var triggerDependencies_8 = emptyList();
      var tmp_16 = getKClass(Book_1);
      var tmp_17 = new EditorDefinition(tmp_16, null, null, false, true, triggerDependencies_8, knowledgeSourceEditors$lambda_9(init_8));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_9 = knowledgeSourceEditors$lambda_10;
      var triggerDependencies_9 = emptyList();
      var tmp_18 = getKClass(Paper_1);
      var tmp_19 = new EditorDefinition(tmp_18, null, null, false, true, triggerDependencies_9, knowledgeSourceEditors$lambda_11(init_9));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_10 = knowledgeSourceEditors$lambda_12;
      var triggerDependencies_10 = emptyList();
      var tmp_20 = getKClass(OldPublishedSource);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_1 = [tmp_15, tmp_17, tmp_19, new EditorDefinition(tmp_20, null, null, false, true, triggerDependencies_10, knowledgeSourceEditors$lambda_13(init_10))];
      var tmp$ret$8 = new HierarchyEditorDefinition(getKClass(LibraryItem), tmp46, toList(editorDefinitions_1));
      knowledgeSourceEditors = listOf_0([tmp_11, tmp_13, tmp$ret$8]);
      PubMedIdUrlHandler = new PrefixedURLTrait('https://pubmed.ncbi.nlm.nih.gov/');
      PMCIdUrlHandler = new PrefixedURLTrait('https://www.ncbi.nlm.nih.gov/pmc/articles/');
    }
  }
  function get_linkLibraryEditors() {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    return linkLibraryEditors;
  }
  var linkLibraryEditors;
  function linkLibraryEditors$lambda($this$editor) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    var tmp = getKClass(LinkDeclaration_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, linkLibraryEditors$lambda$lambda);
    return Unit_instance;
  }
  function linkLibraryEditors$lambda$lambda(linkLibrary) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    return linkLibrary.sbi();
  }
  function linkLibraryEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function linkLibraryEditors$lambda_1($this$childrenRoleDefaults) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    var tmp = editorString($this$childrenRoleDefaults, BTBEditorParts_getInstance().osj_1);
    $this$childrenRoleDefaults.ap8(tmp, linkLibraryEditors$lambda$lambda_0($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function linkLibraryEditors$lambda$lambda_0($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = LinkDeclaration($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.linkLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.b3().v2c(name);
      return this_0;
    };
  }
  function linkLibraryEditors$lambda_2($this$editor) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    // Inline function 'kotlin.apply' call
    var this_0 = textProperty_0($this$editor, '<name>', linkLibraryEditors$lambda$lambda_1);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.linkLibraryEditors.<anonymous>.<anonymous>' call
    mark_0(this_0, BTBEditorParts_getInstance().osj_1);
    space_0($this$editor);
    label_0($this$editor, ':');
    space_0($this$editor);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    editableText_0($this$editor, VOID, '<spec>', VOID, VOID, linkLibraryEditors$lambda$lambda_2);
    indentLabel_0($this$editor, '(');
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$editor, tmp, linkLibraryEditors$lambda$lambda_3);
    indentLabel_0($this$editor, ')', true);
    return Unit_instance;
  }
  function linkLibraryEditors$lambda$lambda_1(linkDeclaration) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    return linkDeclaration.b3();
  }
  function linkLibraryEditors$lambda$lambda_2($this$editableText) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call
    var targetPropFactory = linkLibraryEditors$lambda$lambda$lambda;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.linkLibraryEditors.<anonymous>.<anonymous>' call
    var sourceProp = $this$editableText.k6h().sba();
    var targetProp = targetPropFactory($this$editableText.ypn());
    $this$editableText.wle(syncTwoWay(sourceProp.n4z(), targetProp));
    return Unit_instance;
  }
  function linkLibraryEditors$lambda$lambda$lambda(textCell) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_11();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.en4(textCell, enumInfo);
  }
  function linkLibraryEditors$lambda$lambda_3(linkDeclaration) {
    _init_properties_LinkLibraryEditors_kt__p2wlet();
    return linkDeclaration.zb3();
  }
  function linkLibraryEditors$lambda_3($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  var properties_initialized_LinkLibraryEditors_kt_ero82h;
  function _init_properties_LinkLibraryEditors_kt__p2wlet() {
    if (!properties_initialized_LinkLibraryEditors_kt_ero82h) {
      properties_initialized_LinkLibraryEditors_kt_ero82h = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = linkLibraryEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(LinkLibrary_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, linkLibraryEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = linkLibraryEditors$lambda_1;
      var separator = get_defaultChildrenSeparator();
      var tmp11 = new ChildrenRoleDefaults(getKClass(LinkDeclaration_1), '<empty>', null, separator, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = linkLibraryEditors$lambda_2;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(LinkDeclaration_1);
      var tmp$ret$2 = new EditorDefinition(tmp_1, tmp11, null, false, true, triggerDependencies_0, linkLibraryEditors$lambda_3(init_0));
      linkLibraryEditors = listOf_0([tmp_0, tmp$ret$2]);
    }
  }
  function get_modifierContainerEditors() {
    _init_properties_ModifierEditors_kt__26pejn();
    return modifierContainerEditors;
  }
  var modifierContainerEditors;
  function modifierContainerEditors$lambda($this$editor) {
    _init_properties_ModifierEditors_kt__26pejn();
    var tmp = getKClass(ModifierDeclaration);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, modifierContainerEditors$lambda$lambda);
    return Unit_instance;
  }
  function modifierContainerEditors$lambda$lambda(it) {
    _init_properties_ModifierEditors_kt__26pejn();
    return it.jbl();
  }
  function modifierContainerEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function modifierContainerEditors$lambda_1($this$editor) {
    _init_properties_ModifierEditors_kt__26pejn();
    textProperty_0($this$editor, '<name>', modifierContainerEditors$lambda$lambda_0);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function modifierContainerEditors$lambda$lambda_0(relationDeclaration) {
    _init_properties_ModifierEditors_kt__26pejn();
    return relationDeclaration.b3();
  }
  function modifierContainerEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  var properties_initialized_ModifierEditors_kt_p1dfhb;
  function _init_properties_ModifierEditors_kt__26pejn() {
    if (!properties_initialized_ModifierEditors_kt_p1dfhb) {
      properties_initialized_ModifierEditors_kt_p1dfhb = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = modifierContainerEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(ModifierContainer);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, modifierContainerEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<modifier declarations>';
      var separator = get_defaultChildrenSeparator();
      var tmp11 = new ChildrenRoleDefaults(getKClass(ModifierDeclaration), placeholderText, null, separator, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = modifierContainerEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(ModifierDeclaration);
      var tmp$ret$2 = new EditorDefinition(tmp_1, tmp11, null, false, true, triggerDependencies_0, modifierContainerEditors$lambda_2(init_0));
      modifierContainerEditors = listOf_0([tmp_0, tmp$ret$2]);
    }
  }
  function get_RELATION_CELL() {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return RELATION_CELL;
  }
  var RELATION_CELL;
  function get_newFactEditors() {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return newFactEditors;
  }
  var newFactEditors;
  function get_QUERY_LABELS_CONTAINER_MARK() {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return QUERY_LABELS_CONTAINER_MARK;
  }
  var QUERY_LABELS_CONTAINER_MARK;
  function processPropertyReferenceEditor(withDotRightTransform) {
    withDotRightTransform = withDotRightTransform === VOID ? true : withDotRightTransform;
    _init_properties_NewFactEditors_kt__ah0zlm();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
    var completionSupplier = processPropertyReferenceEditor$lambda;
    var separator = get_defaultChildrenSeparator();
    var tmp5 = new ChildrenRoleDefaults(getKClass(ProcessPropertyReference), '<empty>', null, separator, completionSupplier, true);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = processPropertyReferenceEditor$lambda_0(withDotRightTransform);
    var triggerDependencies = emptyList();
    var tmp = getKClass(ProcessPropertyReference);
    return new EditorDefinition(tmp, tmp5, null, false, true, triggerDependencies, processPropertyReferenceEditor$lambda_1(init));
  }
  function queryLabelsCell(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var _iterator__ex2g4s = get_entries().k();
    while (_iterator__ex2g4s.l()) {
      var label = _iterator__ex2g4s.m();
      // Inline function 'kotlin.apply' call
      var this_0 = label_0(_this__u8e3s4, '[' + label.dsq_1 + ']');
      // Inline function 'jetbrains.biokb.lang.editorBuilders.queryLabelsCell.<anonymous>' call
      this_0.jlu().v2c(true);
      var cell = this_0;
      // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
      var tmp$ret$1 = new queryLabelsCell$$inlined$forDisposable$1(label, _this__u8e3s4, cell);
      _this__u8e3s4.wle(tmp$ret$1);
      cell.olp(new QueryLabelDeleteTrait(_this__u8e3s4.k6h(), label));
    }
  }
  function setQueryLabelRightTransform(source, selectFirst) {
    selectFirst = selectFirst === VOID ? true : selectFirst;
    _init_properties_NewFactEditors_kt__ah0zlm();
    return setQueryLabelRightTransform$lambda(source, selectFirst);
  }
  function processPropertyReferenceCompletion(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_211().aca_1);
    _this__u8e3s4.zp7(tmp, processPropertyReferenceCompletion$lambda(_this__u8e3s4));
  }
  function topLevelFactExpressionCompletion(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    factExpressionCompletion(_this__u8e3s4, true, true);
  }
  function factExpressionCompletion(_this__u8e3s4, includeModifiers, includeRelations) {
    includeModifiers = includeModifiers === VOID ? true : includeModifiers;
    includeRelations = includeRelations === VOID ? false : includeRelations;
    _init_properties_NewFactEditors_kt__ah0zlm();
    newFactReferenceCompletion(_this__u8e3s4);
    variableReferenceValueCompletion(_this__u8e3s4);
    measurableValueWithDefaultUnitCompletion(_this__u8e3s4);
    enumValueCompletion_0(_this__u8e3s4);
    libraryProcessSpecificationCompletion(_this__u8e3s4);
    ontologyElementReferenceValueLibraryCompletion(_this__u8e3s4);
    ontologyElementReferenceValueCompletion(_this__u8e3s4);
    setExpressionCompletion(_this__u8e3s4);
    anonymousClassCompletion(_this__u8e3s4);
    processPropertyReferenceCompletion(_this__u8e3s4);
    if (includeModifiers) {
      modifierCompletion(_this__u8e3s4);
    }
    if (includeRelations) {
      relationFactExpressionCompletion(_this__u8e3s4);
    }
  }
  function newFactReferenceCompletion(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_190().ybn_1);
    _this__u8e3s4.zp7(tmp, newFactReferenceCompletion$lambda(_this__u8e3s4));
  }
  function relationFactExpressionCompletion(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_191().ucl_1);
    _this__u8e3s4.zp7(tmp, relationFactExpressionCompletion$lambda(_this__u8e3s4));
  }
  function labeledFactExpressionCompletion(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = _this__u8e3s4.bp8(labeledFactExpressionCompletion$lambda);
    _this__u8e3s4.cp8(tmp, labeledFactExpressionCompletion$lambda_0(_this__u8e3s4));
  }
  var QueryLabelEnum_NO_ENTRY_instance;
  var QueryLabelEnum_NO_EXIT_instance;
  function values_19() {
    return [QueryLabelEnum_NO_ENTRY_getInstance(), QueryLabelEnum_NO_EXIT_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values_19());
    return $ENTRIES;
  }
  var QueryLabelEnum_entriesInitialized;
  function QueryLabelEnum_initEntries() {
    if (QueryLabelEnum_entriesInitialized)
      return Unit_instance;
    QueryLabelEnum_entriesInitialized = true;
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = noEntry$factory_0();
    var tmp$ret$0 = new ValueAttributeLink(getKClass(HasQueryLabels), this_0);
    QueryLabelEnum_NO_ENTRY_instance = new QueryLabelEnum('NO_ENTRY', 0, 'noentry', tmp$ret$0.a70_1);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_1 = noExit$factory_0();
    var tmp$ret$1 = new ValueAttributeLink(getKClass(HasQueryLabels), this_1);
    QueryLabelEnum_NO_EXIT_instance = new QueryLabelEnum('NO_EXIT', 1, 'noexit', tmp$ret$1.a70_1);
  }
  var $ENTRIES;
  function QueryLabelEnum(name, ordinal, label, property) {
    Enum.call(this, name, ordinal);
    this.dsq_1 = label;
    this.esq_1 = property;
  }
  function QueryLabelDeleteTrait$onKeyPressed$$inlined$executeQuery$1(this$0) {
    this.fsq_1 = this$0;
  }
  protoOf(QueryLabelDeleteTrait$onKeyPressed$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.QueryLabelDeleteTrait.onKeyPressed.<anonymous>' call
    return builder.n51(this.fsq_1.hsq_1.esq_1(this.fsq_1.gsq_1));
  };
  function QueryLabelDeleteTrait(source, label) {
    CellTrait.call(this);
    this.gsq_1 = source;
    this.hsq_1 = label;
  }
  protoOf(QueryLabelDeleteTrait).llm = function (cell, event) {
    if (event.ml1(Key_BACKSPACE_getInstance(), []) || event.ml1(Key_DELETE_getInstance(), [])) {
      // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      var tmp$ret$0 = new QueryLabelDeleteTrait$onKeyPressed$$inlined$executeQuery$1(this);
      var labelState = execute_0(tmp$ret$0);
      if (labelState) {
        // Inline function 'kotlin.sequences.find' call
        var tmp0 = ancestors(cell);
        var tmp$ret$3;
        $l$block: {
          // Inline function 'kotlin.sequences.firstOrNull' call
          var _iterator__ex2g4s = tmp0.k();
          while (_iterator__ex2g4s.l()) {
            var element = _iterator__ex2g4s.m();
            // Inline function 'jetbrains.biokb.lang.editorBuilders.QueryLabelDeleteTrait.onKeyPressed.<anonymous>' call
            if (get_QUERY_LABELS_CONTAINER_MARK().opo(element)) {
              tmp$ret$3 = element;
              break $l$block;
            }
          }
          tmp$ret$3 = null;
        }
        var parentCell = tmp$ret$3;
        this.hsq_1.esq_1(this.gsq_1).v2c(false);
        var tmp1_safe_receiver = parentCell == null ? null : firstFocusable(parentCell);
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.ul5();
        }
        event.ol0();
        return Unit_instance;
      }
    }
    protoOf(CellTrait).llm.call(this, cell, event);
  };
  function modifierCompletion(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_189().kbl_1);
    _this__u8e3s4.zp7(tmp, modifierCompletion$lambda(_this__u8e3s4));
  }
  function newFactEditors$lambda($this$childRoleDefaults) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = $this$childRoleDefaults.tp7();
    if (!(tmp == null) ? isInterface(tmp, NewFact) : false) {
      topLevelFactExpressionCompletion($this$childRoleDefaults);
    } else {
      factExpressionCompletion($this$childRoleDefaults);
    }
    return Unit_instance;
  }
  function newFactEditors$lambda_0($this$childrenRoleDefaults) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    newFactReferenceCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function newFactEditors$lambda_1($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp2 = Companion_getInstance_190().ybn_1;
    var tmp3 = ref$factory_4();
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var options = new CompletionOptions(VOID, false);
    var containerInit = newFactEditors$lambda$lambda;
    var textCellInit = newFactEditors$lambda$lambda_0;
    var tmp;
    if (null == null) {
      tmp = newFactEditors$lambda$lambda_1;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = newFactEditors$lambda$lambda_2(textCellInit);
    var targetClass = getKClass(NewFact);
    var refCell = referenceTarget($this$editor, targetClass, '<fact>', tmp2, tmp3, null, tmp5, options, containerInit, textCellInit_0);
    considerEmptyBy($this$editor, refCell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_0(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_1(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return true;
  }
  function newFactEditors$lambda$lambda_2($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function newFactEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function newFactEditors$lambda_3($this$childrenRoleDefaults) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    relationFactExpressionCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function newFactEditors$lambda_4($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = getKClass(QueryLabelsFactExpressionContainer_1);
    var tmp_0 = newFactEditors$lambda$lambda_3;
    var tmp_1 = newFactEditors$lambda$lambda_4($this$editor);
    child_1($this$editor, tmp, tmp_0, VOID, VOID, VOID, tmp_1, VOID, VOID, VOID, newFactEditors$lambda$lambda_5);
    space_0($this$editor);
    var tmp1 = '<relation>';
    var tmp2 = Companion_getInstance_191().ucl_1;
    var tmp3 = relation$factory_3();
    var tmp4 = symbol$factory_1();
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var textCellInit = newFactEditors$lambda$lambda_6;
    var options = new CompletionOptions();
    var containerInit = newFactEditors$lambda$lambda_7;
    var tmp_2;
    if (null == null) {
      tmp_2 = newFactEditors$lambda$lambda_8;
    } else {
      tmp_2 = null;
    }
    var tmp5 = tmp_2;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = newFactEditors$lambda$lambda_9(textCellInit);
    var targetClass = getKClass(ProcessRelationDeclaration_1);
    // Inline function 'kotlin.apply' call
    var this_0 = referenceTarget($this$editor, targetClass, tmp1, tmp2, tmp3, tmp4, tmp5, options, containerInit, textCellInit_0);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.newFactEditors.<anonymous>.<anonymous>' call
    mark_0(this_0, get_RELATION_CELL());
    space_0($this$editor);
    var tmp_3 = getKClass(QueryLabelsFactExpressionContainer_1);
    var tmp_4 = newFactEditors$lambda$lambda_10;
    var tmp_5 = newFactEditors$lambda$lambda_11($this$editor);
    child_1($this$editor, tmp_3, tmp_4, VOID, VOID, VOID, tmp_5, VOID, VOID, VOID, newFactEditors$lambda$lambda_12);
    return Unit_instance;
  }
  function invoke$adaptFromFactExpression(_this__u8e3s4, $this_editor) {
    // Inline function 'jetbrains.ocelot.base.event.clipboardHelper.ContentKinds.reified' call
    var tmp = ContentKinds_getInstance().kl4(getKClass(FactExpression));
    _this__u8e3s4.ank(tmp, newFactEditors$lambda$adaptFromFactExpression$lambda($this_editor));
  }
  function newFactEditors$lambda$lambda_3(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.sbf();
  }
  function newFactEditors$lambda$lambda_4($this_editor) {
    return function ($this$child) {
      invoke$adaptFromFactExpression($this$child, $this_editor);
      return Unit_instance;
    };
  }
  function newFactEditors$lambda$lambda_5($this$child) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    labeledFactExpressionCompletion($this$child);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_6($this$btbReferenceTarget) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    $this$btbReferenceTarget.ypn().jlu().v2c(true);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_7(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_8(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return true;
  }
  function newFactEditors$lambda$lambda_9($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function newFactEditors$lambda$lambda_10(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.tbf();
  }
  function newFactEditors$lambda$lambda_11($this_editor) {
    return function ($this$child) {
      invoke$adaptFromFactExpression($this$child, $this_editor);
      return Unit_instance;
    };
  }
  function newFactEditors$lambda$lambda_12($this$child) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    labeledFactExpressionCompletion($this$child);
    return Unit_instance;
  }
  function newFactEditors$lambda$adaptFromFactExpression$lambda($this_editor) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = QueryLabelsFactExpressionContainer(get_internalConfig($this_editor).o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.newFactEditors$lambda.invoke.adaptFromFactExpression.<anonymous>.<anonymous>' call
      var tmp = this_0.lbb();
      var tmp_0 = it.u6m();
      tmp.v2c(isInterface(tmp_0, FactExpression) ? tmp_0 : THROW_CCE());
      return this_0;
    };
  }
  function newFactEditors$lambda_5($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function newFactEditors$lambda_6($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp1 = '<modifier>';
    var tmp2 = Companion_getInstance_189().kbl_1;
    var tmp3 = modifier$factory_0();
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var options = new CompletionOptions(VOID, false);
    var containerInit = newFactEditors$lambda$lambda_13;
    var textCellInit = newFactEditors$lambda$lambda_14;
    var tmp;
    if (null == null) {
      tmp = newFactEditors$lambda$lambda_15;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = newFactEditors$lambda$lambda_16(textCellInit);
    var targetClass = getKClass(ModifierDeclaration);
    referenceTarget($this$editor, targetClass, tmp1, tmp2, tmp3, null, tmp5, options, containerInit, textCellInit_0);
    space_0($this$editor);
    var tmp_0 = getKClass(FactExpression);
    var tmp_1 = newFactEditors$lambda$lambda_17;
    child_1($this$editor, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, newFactEditors$lambda$lambda_18);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_13(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_14(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_15(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return true;
  }
  function newFactEditors$lambda$lambda_16($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function newFactEditors$lambda$lambda_17(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.lbb();
  }
  function newFactEditors$lambda$lambda_18($this$child) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    factExpressionCompletion($this$child, false);
    return Unit_instance;
  }
  function newFactEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function newFactEditors$lambda_8($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var rootCellMark = new CellMark();
    // Inline function 'kotlin.apply' call
    var this_0 = indent_0($this$editor, VOID, VOID, newFactEditors$lambda$lambda_19(rootCellMark));
    // Inline function 'jetbrains.biokb.lang.editorBuilders.newFactEditors.<anonymous>.<anonymous>' call
    mark_0(this_0, rootCellMark);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda$lambda(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.sbf();
  }
  function newFactEditors$lambda$lambda$lambda_0(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.tbf();
  }
  function newFactEditors$lambda$lambda$lambda_1($this$child) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    getAbstractValueCompletion($this$child);
    return Unit_instance;
  }
  function newFactEditors$7$1$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$1($this_indent) {
    this.isq_1 = $this_indent;
  }
  protoOf(newFactEditors$7$1$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.ReplaceWithLeftTrait.onKeyPressed.<anonymous>' call
    return builder.n51(this.isq_1.k6h().tbf());
  };
  function newFactEditors$7$1$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$2($this_indent) {
    this.jsq_1 = $this_indent;
  }
  protoOf(newFactEditors$7$1$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$2).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.ReplaceWithLeftTrait.onKeyPressed.<anonymous>' call
    return builder.n51(this.jsq_1.k6h().sbf());
  };
  function newFactEditors$7$1$ReplaceWithLeftTrait($rootCellMark, $this_indent, checkIsEmpty) {
    this.lsq_1 = $rootCellMark;
    this.msq_1 = $this_indent;
    CellTrait.call(this);
    this.ksq_1 = checkIsEmpty;
  }
  protoOf(newFactEditors$7$1$ReplaceWithLeftTrait).llm = function (cell, event) {
    if (event.ml1(Key_BACKSPACE_getInstance(), []) || event.ml1(Key_DELETE_getInstance(), [])) {
      var tmp;
      if (!this.ksq_1) {
        tmp = true;
      } else {
        var tmp_0;
        if (this.ksq_1) {
          // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
          // Inline function 'jetbrains.ocelot.langDef.query.query' call
          var tmp$ret$0 = new newFactEditors$7$1$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$1(this.msq_1);
          tmp_0 = execute_0(tmp$ret$0) == null;
        } else {
          tmp_0 = false;
        }
        tmp = tmp_0;
      }
      if (tmp) {
        // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
        // Inline function 'jetbrains.ocelot.langDef.query.query' call
        var tmp$ret$2 = new newFactEditors$7$1$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$2(this.msq_1);
        var left = execute_0(tmp$ret$2);
        if (!(left == null)) {
          // Inline function 'kotlin.sequences.find' call
          var tmp0 = ancestors(cell);
          var tmp$ret$5;
          $l$block: {
            // Inline function 'kotlin.sequences.firstOrNull' call
            var _iterator__ex2g4s = tmp0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              // Inline function 'jetbrains.biokb.lang.editorBuilders.ReplaceWithLeftTrait.onKeyPressed.<anonymous>' call
              if (this.lsq_1.opo(element)) {
                tmp$ret$5 = element;
                break $l$block;
              }
            }
            tmp$ret$5 = null;
          }
          var tmp0_safe_receiver = tmp$ret$5;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.yt();
          var parentCell = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.yt();
          var newExpression = left.u6m();
          this.msq_1.k6h().s6m(newExpression);
          var tmp3_safe_receiver = parentCell == null ? null : lastFocusable(parentCell);
          if (tmp3_safe_receiver == null)
            null;
          else {
            tmp3_safe_receiver.ul5();
          }
          event.ol0();
          return Unit_instance;
        }
      }
    }
    protoOf(CellTrait).llm.call(this, cell, event);
  };
  function newFactEditors$lambda$lambda_19($rootCellMark) {
    return function ($this$indent) {
      var tmp = getKClass(ObjectPropertyReferenceValue_1);
      child_1($this$indent, tmp, newFactEditors$lambda$lambda$lambda);
      space_0($this$indent);
      var isLabel = label_0($this$indent, 'is');
      space_0($this$indent);
      var tmp_0 = getKClass(AbstractValue);
      var tmp_1 = newFactEditors$lambda$lambda$lambda_0;
      var valueChild = child_1($this$indent, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, newFactEditors$lambda$lambda$lambda_1);
      isLabel.olp(new newFactEditors$7$1$ReplaceWithLeftTrait($rootCellMark, $this$indent, false));
      valueChild.olp(new newFactEditors$7$1$ReplaceWithLeftTrait($rootCellMark, $this$indent, true));
      return Unit_instance;
    };
  }
  function newFactEditors$lambda_9($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function newFactEditors$lambda_10($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    indent_0($this$editor, VOID, VOID, newFactEditors$lambda$lambda_20);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_20($this$indent) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    placeholderInCollection_0($this$indent, '<expression>', newFactEditors$lambda$lambda$lambda_2);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda$lambda_2($this$placeholderInCollection) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    factExpressionCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function newFactEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function newFactEditors$lambda_12($this$childRoleDefaults) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    labeledFactExpressionCompletion($this$childRoleDefaults);
    return Unit_instance;
  }
  function newFactEditors$lambda_13($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var indent = indent_0($this$editor, VOID, VOID, newFactEditors$lambda$lambda_21);
    mark_0(indent, get_QUERY_LABELS_CONTAINER_MARK());
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_21($this$indent) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    queryLabelsCell($this$indent);
    var tmp = getKClass(FactExpression);
    var tmp_0 = newFactEditors$lambda$lambda$lambda_3;
    var expressionCell = child_1($this$indent, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, newFactEditors$lambda$lambda$lambda_4);
    var setQueriesLabelRightTransform = setQueryLabelRightTransform($this$indent.k6h(), false);
    rightTransform_1($this$indent, expressionCell, setQueriesLabelRightTransform);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda$lambda_3(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.lbb();
  }
  function newFactEditors$lambda$lambda$lambda_4($this$child) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    factExpressionCompletion($this$child);
    return Unit_instance;
  }
  function newFactEditors$lambda_14($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function newFactEditors$lambda_15($this$editor) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    textProperty_0($this$editor, '<no name>', newFactEditors$lambda$lambda_22);
    space_0($this$editor);
    label_0($this$editor, ':');
    space_0($this$editor);
    var tmp = getKClass(FactExpression);
    var tmp_0 = newFactEditors$lambda$lambda_23;
    child_1($this$editor, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, newFactEditors$lambda$lambda_24);
    space_0($this$editor);
    var relationPlaceholder = indent_0($this$editor, VOID, VOID, newFactEditors$lambda$lambda_25);
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new newFactEditors$11$$inlined$forDisposable$1($this$editor, relationPlaceholder);
    $this$editor.wle(tmp$ret$0);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_22(fact) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return fact.b3();
  }
  function newFactEditors$lambda$lambda_23(fact) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return fact.lbb();
  }
  function newFactEditors$lambda$lambda_24($this$child) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    topLevelFactExpressionCompletion($this$child);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda_25($this$indent) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    editableText_0($this$indent, '', '-?->', VOID, true, newFactEditors$lambda$lambda$lambda_5);
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda$lambda_5($this$editableText) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    rightTransform_0($this$editableText, newFactEditors$lambda$lambda$lambda$lambda($this$editableText));
    return Unit_instance;
  }
  function newFactEditors$lambda$lambda$lambda$lambda$lambda$lambda($cellFinder, $relationExpression) {
    return function () {
      var tmp0_safe_receiver = firstOrNull_1($cellFinder.vn4($relationExpression));
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : find_2(tmp0_safe_receiver, get_RELATION_CELL());
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : firstFocusable(tmp1_safe_receiver);
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.ul5();
      }
      return Unit_instance;
    };
  }
  function newFactEditors$lambda$lambda$lambda$lambda$lambda($this_editableText, $cellFinder) {
    return function () {
      var expression = ensureNotNull($this_editableText.k6h().lbb().n4z().qr());
      // Inline function 'kotlin.apply' call
      var this_0 = RelationFactExpression(get_internalConfig($this_editableText).o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.newFactEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      var tmp = this_0.sbf();
      var tmp_0 = get_internalConfig($this_editableText).o71();
      var tmp_1 = expression.u6m();
      tmp.v2c(QueryLabelsFactExpressionContainer_2(tmp_0, isInterface(tmp_1, FactExpression) ? tmp_1 : THROW_CCE()));
      var relationExpression = this_0;
      expression.s6m(relationExpression);
      return newFactEditors$lambda$lambda$lambda$lambda$lambda$lambda($cellFinder, relationExpression);
    };
  }
  function newFactEditors$lambda$lambda$lambda$lambda($this_editableText) {
    return function ($this$rightTransform, _unused_var__etf5q3, _unused_var__etf5q3_0, cellFinder) {
      $this$rightTransform.tp3('->', newFactEditors$lambda$lambda$lambda$lambda$lambda($this_editableText, cellFinder));
      return Unit_instance;
    };
  }
  function newFactEditors$lambda$o$doAttach$lambda(it) {
    var tmp;
    if (!(it == null)) {
      tmp = !(!(it == null) ? isInterface(it, RelationFactExpression_1) : false);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function newFactEditors$11$$inlined$forDisposable$1($this_editor, $relationPlaceholder) {
    this.osq_1 = $this_editor;
    this.psq_1 = $relationPlaceholder;
    DisposableSynchronizer.call(this);
  }
  protoOf(newFactEditors$11$$inlined$forDisposable$1).dlb = function (ctx) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.newFactEditors.<anonymous>.<anonymous>' call
    var expression = this.osq_1.k6h().lbb().n4z();
    var tmp = PropertyBinding_instance;
    return tmp.d2g(map_0(expression, newFactEditors$lambda$o$doAttach$lambda), this.psq_1.elp());
  };
  function newFactEditors$lambda_16($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processPropertyReferenceEditor$lambda($this$childrenRoleDefaults) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    var tmp = $this$childrenRoleDefaults.wp3(Companion_getInstance_211().aca_1);
    $this$childrenRoleDefaults.zp7(tmp, processPropertyReferenceEditor$lambda$lambda($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function processPropertyReferenceEditor$lambda$lambda($this_childrenRoleDefaults) {
    return function (reference) {
      return ProcessPropertyReference_0($this_childrenRoleDefaults.o71(), reference);
    };
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return it.i6u();
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda$lambda$lambda($this_btbReferenceTarget, $cellFinder, $cell) {
    return function () {
      var tmp = get_enclosingRefData($cell).fpy_1;
      return transformValueToPropertyReference($this_btbReferenceTarget, $cellFinder, (!(tmp == null) ? isInterface(tmp, ProcessPropertyReference) : false) ? tmp : THROW_CCE());
    };
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda$lambda($this_btbReferenceTarget) {
    return function ($this$rightTransform, _unused_var__etf5q3, cell, cellFinder) {
      $this$rightTransform.tp3('.', processPropertyReferenceEditor$lambda$lambda$lambda$lambda$lambda($this_btbReferenceTarget, cellFinder, cell));
      return Unit_instance;
    };
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda_0($withDotRightTransform) {
    return function ($this$btbReferenceTarget) {
      var tmp;
      if ($withDotRightTransform) {
        rightTransform_0($this$btbReferenceTarget, processPropertyReferenceEditor$lambda$lambda$lambda$lambda($this$btbReferenceTarget));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return Unit_instance;
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda_2(it) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    return true;
  }
  function processPropertyReferenceEditor$lambda$lambda$lambda_3($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processPropertyReferenceEditor$lambda$lambda_0($withDotRightTransform) {
    return function ($this$indent) {
      var tmp1 = '<property>';
      var tmp2 = Companion_getInstance_211().aca_1;
      var tmp3 = processPropertyReferenceEditor$lambda$lambda$lambda;
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
      var textCellInit = processPropertyReferenceEditor$lambda$lambda$lambda_0($withDotRightTransform);
      var options = new CompletionOptions();
      var containerInit = processPropertyReferenceEditor$lambda$lambda$lambda_1;
      var tmp;
      if (null == null) {
        tmp = processPropertyReferenceEditor$lambda$lambda$lambda_2;
      } else {
        tmp = null;
      }
      var tmp5 = tmp;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
      var textCellInit_0 = processPropertyReferenceEditor$lambda$lambda$lambda_3(textCellInit);
      var targetClass = getKClass(ProcessProperty_1);
      var refCell = referenceTarget($this$indent, targetClass, tmp1, tmp2, tmp3, null, tmp5, options, containerInit, textCellInit_0);
      considerEmptyBy($this$indent, refCell);
      deleteIfEmpty($this$indent);
      return Unit_instance;
    };
  }
  function processPropertyReferenceEditor$lambda_0($withDotRightTransform) {
    return function ($this$editor) {
      indent_0($this$editor, VOID, VOID, processPropertyReferenceEditor$lambda$lambda_0($withDotRightTransform));
      return Unit_instance;
    };
  }
  function processPropertyReferenceEditor$lambda_1($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function queryLabelsCell$$inlined$forDisposable$1($label, $this_queryLabelsCell, $cell) {
    this.rsq_1 = $label;
    this.ssq_1 = $this_queryLabelsCell;
    this.tsq_1 = $cell;
    DisposableSynchronizer.call(this);
  }
  protoOf(queryLabelsCell$$inlined$forDisposable$1).dlb = function (ctx) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.queryLabelsCell.<anonymous>' call
    return PropertyBinding_instance.d2g(get_asProperty(this.rsq_1.esq_1(this.ssq_1.k6h())), this.tsq_1.elp());
  };
  function setQueryLabelRightTransform$1$$inlined$executeQuery$1($label, $source) {
    this.usq_1 = $label;
    this.vsq_1 = $source;
  }
  protoOf(setQueryLabelRightTransform$1$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.setQueryLabelRightTransform.<anonymous>.<anonymous>' call
    return builder.n51(this.usq_1.esq_1(this.vsq_1));
  };
  function setQueryLabelRightTransform$lambda$lambda$lambda($selectFirst, $cell) {
    return function () {
      if ($selectFirst) {
        var tmp0_safe_receiver = firstFocusable($cell);
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.ul5();
        }
      } else {
        var tmp1_safe_receiver = lastFocusable($cell);
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.ul5();
        }
      }
      return Unit_instance;
    };
  }
  function setQueryLabelRightTransform$lambda$lambda($label, $source, $selectFirst, $cell) {
    return function () {
      $label.esq_1($source).v2c(true);
      return setQueryLabelRightTransform$lambda$lambda$lambda($selectFirst, $cell);
    };
  }
  function setQueryLabelRightTransform$lambda($source, $selectFirst) {
    return function (_this__u8e3s4, _unused_var__etf5q3, cell, _unused_var__etf5q3_0) {
      var _iterator__ex2g4s = get_entries().k();
      while (_iterator__ex2g4s.l()) {
        var label = _iterator__ex2g4s.m();
        // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
        // Inline function 'jetbrains.ocelot.langDef.query.query' call
        var tmp$ret$0 = new setQueryLabelRightTransform$1$$inlined$executeQuery$1(label, $source);
        if (!execute_0(tmp$ret$0)) {
          _this__u8e3s4.tp3(label.dsq_1, setQueryLabelRightTransform$lambda$lambda(label, $source, $selectFirst, cell));
        }
      }
      return Unit_instance;
    };
  }
  function processPropertyReferenceCompletion$lambda($this_processPropertyReferenceCompletion) {
    return function (reference) {
      return ProcessPropertyReference_0($this_processPropertyReferenceCompletion.o71(), reference);
    };
  }
  function newFactReferenceCompletion$lambda($this_newFactReferenceCompletion) {
    return function (reference) {
      return NewFactReference_1($this_newFactReferenceCompletion.o71(), reference);
    };
  }
  function relationFactExpressionCompletion$lambda($this_relationFactExpressionCompletion) {
    return function (reference) {
      return RelationFactExpression_2($this_relationFactExpressionCompletion.o71(), reference);
    };
  }
  function labeledFactExpressionCompletion$lambda($this$using) {
    _init_properties_NewFactEditors_kt__ah0zlm();
    factExpressionCompletion($this$using);
    return Unit_instance;
  }
  function labeledFactExpressionCompletion$lambda_0($this_labeledFactExpressionCompletion) {
    return function (expression) {
      return QueryLabelsFactExpressionContainer_2($this_labeledFactExpressionCompletion.o71(), expression);
    };
  }
  function modifierCompletion$lambda($this_modifierCompletion) {
    return function (reference) {
      return ModifierFactExpression_1($this_modifierCompletion.o71(), reference);
    };
  }
  function QueryLabelEnum_NO_ENTRY_getInstance() {
    QueryLabelEnum_initEntries();
    return QueryLabelEnum_NO_ENTRY_instance;
  }
  function QueryLabelEnum_NO_EXIT_getInstance() {
    QueryLabelEnum_initEntries();
    return QueryLabelEnum_NO_EXIT_instance;
  }
  function noEntry$factory_0() {
    return getPropertyCallableRef('noEntry', 1, KProperty1, function (receiver) {
      return receiver.obc();
    }, null);
  }
  function noExit$factory_0() {
    return getPropertyCallableRef('noExit', 1, KProperty1, function (receiver) {
      return receiver.pbc();
    }, null);
  }
  function ref$factory_4() {
    return getPropertyCallableRef('ref', 1, KProperty1, function (receiver) {
      return receiver.ub6();
    }, null);
  }
  function relation$factory_3() {
    return getPropertyCallableRef('relation', 1, KProperty1, function (receiver) {
      return receiver.gb6();
    }, null);
  }
  function symbol$factory_1() {
    return getPropertyCallableRef('symbol', 1, KProperty1, function (receiver) {
      return receiver.jcc();
    }, null);
  }
  function modifier$factory_0() {
    return getPropertyCallableRef('modifier', 1, KProperty1, function (receiver) {
      return receiver.zbl();
    }, null);
  }
  var properties_initialized_NewFactEditors_kt_9c502k;
  function _init_properties_NewFactEditors_kt__ah0zlm() {
    if (!properties_initialized_NewFactEditors_kt_9c502k) {
      properties_initialized_NewFactEditors_kt_9c502k = true;
      RELATION_CELL = new CellMark();
      var tmp47 = childRoleDefaults('<fact>', newFactEditors$lambda, VOID, true);
      var tmp34 = childRoleDefaults(VOID, VOID, VOID, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = newFactEditors$lambda_0;
      var separator = get_defaultChildrenSeparator();
      var tmp5 = new ChildrenRoleDefaults(getKClass(NewFactReference_0), '<facts>', null, separator, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = newFactEditors$lambda_1;
      var triggerDependencies = emptyList();
      var tmp = getKClass(NewFactReference_0);
      var tmp_0 = new EditorDefinition(tmp, tmp5, null, false, true, triggerDependencies, newFactEditors$lambda_2(init));
      var tmp11 = '<relation>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = newFactEditors$lambda_3;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp16 = new ChildrenRoleDefaults(getKClass(RelationFactExpression_1), tmp11, null, separator_0, completionSupplier_0, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = newFactEditors$lambda_4;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(RelationFactExpression_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp16, null, false, true, triggerDependencies_0, newFactEditors$lambda_5(init_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = newFactEditors$lambda_6;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(ModifierFactExpression_0);
      var tmp_4 = new EditorDefinition(tmp_3, null, null, false, true, triggerDependencies_1, newFactEditors$lambda_7(init_1));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = newFactEditors$lambda_8;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(IsExpression_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_0, tmp_2, tmp_4, new EditorDefinition(tmp_5, null, null, false, true, triggerDependencies_2, newFactEditors$lambda_9(init_2)), processPropertyReferenceEditor(), variableReferenceValueEditor(), propertyReferenceValueEditor(), setExpressionEditor(), libraryProcessSpecificationEditor(), ontologyElementReferenceValueLibraryEditor(), ontologyElementReferenceValueEditor(), measurableValueEditor(), enumValueEditor(), unionEditor()];
      var tmp_6 = new HierarchyEditorDefinition(getKClass(FactExpression), tmp34, toList(editorDefinitions));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<expressions>';
      var separator_1 = get_defaultChildrenSeparator();
      var tmp41 = new ChildrenRoleDefaults(getKClass(FactExpressionPlaceholder), placeholderText, null, separator_1, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = newFactEditors$lambda_10;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(FactExpressionPlaceholder);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_0 = [tmp_6, new EditorDefinition(tmp_7, tmp41, null, false, true, triggerDependencies_3, newFactEditors$lambda_11(init_3))];
      var tmp_8 = new HierarchyEditorDefinition(getKClass(FactExpressionPlaceholder), tmp47, toList(editorDefinitions_0));
      var tmp49 = childRoleDefaults('<expression>', newFactEditors$lambda_12, VOID, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = newFactEditors$lambda_13;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(QueryLabelsFactExpressionContainer_1);
      var tmp_10 = new EditorDefinition(tmp_9, tmp49, null, false, true, triggerDependencies_4, newFactEditors$lambda_14(init_4));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var separator_2 = get_defaultChildrenSeparator();
      var tmp60 = new ChildrenRoleDefaults(getKClass(NewFact), '<facts>', null, separator_2, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_5 = newFactEditors$lambda_15;
      var triggerDependencies_5 = emptyList();
      var tmp_11 = getKClass(NewFact);
      var tmp$ret$12 = new EditorDefinition(tmp_11, tmp60, null, false, true, triggerDependencies_5, newFactEditors$lambda_16(init_5));
      newFactEditors = listOf_0([tmp_8, tmp_10, tmp$ret$12]);
      QUERY_LABELS_CONTAINER_MARK = new CellMark();
    }
  }
  function get_notionLibraryEditors() {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return notionLibraryEditors;
  }
  var notionLibraryEditors;
  function notionCompletion(_this__u8e3s4, wrapperContext) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    _this__u8e3s4.up7('enumerable notion', notionCompletion$lambda(wrapperContext));
    _this__u8e3s4.up7('measurable notion', notionCompletion$lambda_0(wrapperContext));
  }
  function notionLibraryEditors$lambda($this$editor) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    indent_0($this$editor, VOID, VOID, notionLibraryEditors$lambda$lambda);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda($this$indent) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    var tmp = getKClass(AbstractNotion);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, notionLibraryEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda$lambda(notionLibrary) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return notionLibrary.xbo();
  }
  function notionLibraryEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function notionLibraryEditors$lambda_1(wrapperContext) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return NotionPlaceholder(wrapperContext);
  }
  function notionLibraryEditors$lambda_2($this$childrenRoleDefaults) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    notionCompletion($this$childrenRoleDefaults, $this$childrenRoleDefaults.o71());
    return Unit_instance;
  }
  function notionLibraryEditors$lambda_3($this$editor) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    keyword_0($this$editor, 'enumerable notion');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', notionLibraryEditors$lambda$lambda_0);
    indent_0($this$editor, true, VOID, notionLibraryEditors$lambda$lambda_1);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_0(it) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return it.b3();
  }
  function notionLibraryEditors$lambda$lambda_1($this$indent) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    newLine_0($this$indent);
    keyword_0($this$indent, 'values:');
    space_0($this$indent);
    var valuesList;
    var tmp = getKClass(EnumerationConstant_1);
    // Inline function 'kotlin.also' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.notionLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
    valuesList = children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, notionLibraryEditors$lambda$lambda$lambda_0);
    ensureLastCaretPosition($this$indent);
    disambiguateBy($this$indent, valuesList);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda$lambda_0(enumerableNotion) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return enumerableNotion.jb3();
  }
  function notionLibraryEditors$lambda_4($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function notionLibraryEditors$lambda_5($this$editor) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    keyword_0($this$editor, 'measurable notion');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', notionLibraryEditors$lambda$lambda_2);
    indent_0($this$editor, true, VOID, notionLibraryEditors$lambda$lambda_3);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_2(measurableNotion) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return measurableNotion.b3();
  }
  function notionLibraryEditors$lambda$lambda_3($this$indent) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    newLine_0($this$indent);
    keyword_0($this$indent, 'measured in:');
    space_0($this$indent);
    var unitList;
    var tmp = getKClass(MeasurementUnit_1);
    // Inline function 'kotlin.also' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.notionLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
    unitList = children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, notionLibraryEditors$lambda$lambda$lambda_1);
    ensureLastCaretPosition($this$indent);
    disambiguateBy($this$indent, unitList);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda$lambda_1(measurableNotion) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return measurableNotion.sbj();
  }
  function notionLibraryEditors$lambda_6($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function notionLibraryEditors$lambda_7($this$editor) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    placeholderInCollection_0($this$editor, VOID, notionLibraryEditors$lambda$lambda_4);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_4($this$placeholderInCollection) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    notionCompletion($this$placeholderInCollection, $this$placeholderInCollection.o71());
    return Unit_instance;
  }
  function notionLibraryEditors$lambda_8($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function notionLibraryEditors$lambda_9($this$childrenRoleDefaults) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    var tmp = $this$childrenRoleDefaults.dp6();
    $this$childrenRoleDefaults.wp7(tmp, notionLibraryEditors$lambda$lambda_5($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_5($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = MeasurementUnit($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.notionLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.b3().v2c(name);
      return this_0;
    };
  }
  function notionLibraryEditors$lambda_10($this$editor) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    indent_0($this$editor, VOID, VOID, notionLibraryEditors$lambda$lambda_6);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_6($this$indent) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    var tmp = notionLibraryEditors$lambda$lambda$lambda_2;
    var text = editableText_0($this$indent, VOID, '<unit>', tmp, VOID, notionLibraryEditors$lambda$lambda$lambda_3);
    var defaultMarker = indent_0($this$indent, VOID, VOID, notionLibraryEditors$lambda$lambda$lambda_4(text));
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new notionLibraryEditors$8$1$$inlined$forDisposable$1($this$indent, defaultMarker);
    $this$indent.wle(tmp$ret$0);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda$lambda_2(it) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return !contains_9(it, ',') && !contains_9(it, ' ');
  }
  function notionLibraryEditors$lambda$lambda$lambda_3($this$editableText) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.notionLibraryEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    var sourceProp = $this$editableText.k6h().b3();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay.stub_for_inlining' call
    var targetProp = $this$editableText.ypn().laz();
    $this$editableText.wle(syncTwoWay(sourceProp.n4z(), targetProp));
    rightTransform_0($this$editableText, notionLibraryEditors$lambda$lambda$lambda$lambda($this$editableText));
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda$lambda$lambda$lambda($this_editableText) {
    return function () {
      $this_editableText.k6h().wbk().t2c(true);
      return toEnd_0($this_editableText.ypn());
    };
  }
  function notionLibraryEditors$lambda$lambda$lambda$lambda($this_editableText) {
    return function ($this$rightTransform, _unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      var tmp;
      if (!$this_editableText.k6h().wbk().n4z().m2c()) {
        $this$rightTransform.tp3('default', notionLibraryEditors$lambda$lambda$lambda$lambda$lambda($this_editableText));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function notionLibraryEditors$8$1$1$1$1$$inlined$createDeleteTransformTrait$1($this_keyword, $text) {
    this.wsq_1 = $this_keyword;
    this.xsq_1 = $text;
    DeleteTransformTrait.call(this);
  }
  protoOf(notionLibraryEditors$8$1$1$1$1$$inlined$createDeleteTransformTrait$1).ssj = function (cell) {
    this.wsq_1.k6h().wbk().t2c(false);
    return toEnd_0(this.xsq_1)();
  };
  function notionLibraryEditors$lambda$lambda$lambda$lambda$lambda_0($this_keyword, $text) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      // Inline function 'jetbrains.biokb.lang.traits.createDeleteTransformTrait' call
      return new notionLibraryEditors$8$1$1$1$1$$inlined$createDeleteTransformTrait$1($this_keyword, $text);
    };
  }
  function notionLibraryEditors$lambda$lambda$lambda$lambda_0($text) {
    return function ($this$keyword) {
      addTraitOnAttach_0($this$keyword, notionLibraryEditors$lambda$lambda$lambda$lambda$lambda_0($this$keyword, $text));
      return Unit_instance;
    };
  }
  function notionLibraryEditors$lambda$lambda$lambda_4($text) {
    return function ($this$indent) {
      space_0($this$indent);
      var openParen = indentLabel_0($this$indent, '(');
      keyword_0($this$indent, 'default', notionLibraryEditors$lambda$lambda$lambda$lambda_0($text));
      closingFor(indentLabel_0($this$indent, ')', true), openParen);
      return Unit_instance;
    };
  }
  function notionLibraryEditors$8$1$$inlined$forDisposable$1($this_indent, $defaultMarker) {
    this.zsq_1 = $this_indent;
    this.asr_1 = $defaultMarker;
    DisposableSynchronizer.call(this);
  }
  protoOf(notionLibraryEditors$8$1$$inlined$forDisposable$1).dlb = function (ctx) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.notionLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
    return PropertyBinding_instance.d2g(this.zsq_1.k6h().wbk().n4z(), this.asr_1.elp());
  };
  function notionLibraryEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function notionLibraryEditors$lambda_12($this$childrenRoleDefaults) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    var tmp = $this$childrenRoleDefaults.dp6();
    $this$childrenRoleDefaults.wp7(tmp, notionLibraryEditors$lambda$lambda_7($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_7($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = EnumerationConstant($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.notionLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.b3().v2c(name);
      return this_0;
    };
  }
  function notionLibraryEditors$lambda_13($this$editor) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    indent_0($this$editor, VOID, VOID, notionLibraryEditors$lambda$lambda_8);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda_8($this$indent) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    var tmp = notionLibraryEditors$lambda$lambda$lambda_5;
    editableText_0($this$indent, VOID, '<name>', tmp, VOID, notionLibraryEditors$lambda$lambda$lambda_6);
    return Unit_instance;
  }
  function notionLibraryEditors$lambda$lambda$lambda_5(it) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    return !contains_9(it, ',');
  }
  function notionLibraryEditors$lambda$lambda$lambda_6($this$editableText) {
    _init_properties_NotionLibraryEditors_kt__4npby8();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.notionLibraryEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    var sourceProp = $this$editableText.k6h().b3();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay.stub_for_inlining' call
    var targetProp = $this$editableText.ypn().laz();
    $this$editableText.wle(syncTwoWay(sourceProp.n4z(), targetProp));
    return Unit_instance;
  }
  function notionLibraryEditors$lambda_14($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function notionCompletion$lambda($wrapperContext) {
    return function () {
      return EnumerableNotion($wrapperContext);
    };
  }
  function notionCompletion$lambda_0($wrapperContext) {
    return function () {
      return MeasurableNotion($wrapperContext);
    };
  }
  var properties_initialized_NotionLibraryEditors_kt_1z54im;
  function _init_properties_NotionLibraryEditors_kt__4npby8() {
    if (!properties_initialized_NotionLibraryEditors_kt_1z54im) {
      properties_initialized_NotionLibraryEditors_kt_1z54im = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = notionLibraryEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(NotionLibrary_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, notionLibraryEditors$lambda_0(init));
      var tmp6 = '<notions>';
      var tmp7 = notionLibraryEditors$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = notionLibraryEditors$lambda_2;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp29 = new ChildrenRoleDefaults(getKClass(AbstractNotion), tmp6, tmp7, separator_0, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = notionLibraryEditors$lambda_3;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(EnumerableNotion_1);
      var tmp_2 = new EditorDefinition(tmp_1, null, null, false, true, triggerDependencies_0, notionLibraryEditors$lambda_4(init_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = notionLibraryEditors$lambda_5;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(MeasurableNotion_1);
      var tmp_4 = new EditorDefinition(tmp_3, null, null, false, true, triggerDependencies_1, notionLibraryEditors$lambda_6(init_1));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = notionLibraryEditors$lambda_7;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(NotionPlaceholder_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_2, tmp_4, new EditorDefinition(tmp_5, null, null, false, true, triggerDependencies_2, notionLibraryEditors$lambda_8(init_2))];
      var tmp_6 = new HierarchyEditorDefinition(getKClass(AbstractNotion), tmp29, toList(editorDefinitions));
      var tmp32 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = notionLibraryEditors$lambda_9;
      var tmp36 = new ChildrenRoleDefaults(getKClass(MeasurementUnit_1), '<units>', null, tmp32, completionSupplier_0, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = notionLibraryEditors$lambda_10;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(MeasurementUnit_1);
      var tmp_8 = new EditorDefinition(tmp_7, tmp36, null, false, true, triggerDependencies_3, notionLibraryEditors$lambda_11(init_3));
      var tmp42 = '<constants>';
      var tmp43 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_1 = notionLibraryEditors$lambda_12;
      var tmp47 = new ChildrenRoleDefaults(getKClass(EnumerationConstant_1), tmp42, null, tmp43, completionSupplier_1, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = notionLibraryEditors$lambda_13;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(EnumerationConstant_1);
      var tmp$ret$9 = new EditorDefinition(tmp_9, tmp47, null, false, true, triggerDependencies_4, notionLibraryEditors$lambda_14(init_4));
      notionLibraryEditors = listOf_0([tmp_0, tmp_6, tmp_8, tmp$ret$9]);
    }
  }
  function get_completion() {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return completion_2;
  }
  var completion_2;
  function get_objectPropertyEditors() {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return objectPropertyEditors;
  }
  var objectPropertyEditors;
  function propertyConstraints(_this__u8e3s4, showUnderscore) {
    showUnderscore = showUnderscore === VOID ? true : showUnderscore;
    _init_properties_ObjectProperties_kt__dw6gpa();
    var constraintsCell = {_v: null};
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = constraints$factory_3();
    var link = new MultipleChildLink(getKClass(HasPropertyConstraints), this_0);
    var tmp;
    if (!get_internalConfig(_this__u8e3s4).jpo()) {
      label_0(_this__u8e3s4, '[', VOID, false);
      // Inline function 'kotlin.apply' call
      var this_1 = label_0(_this__u8e3s4, '+');
      // Inline function 'jetbrains.biokb.lang.editorBuilders.propertyConstraints.<anonymous>' call
      PropertyBinding_instance.d2g(ifProp(this_1.qlp(), Companion_getInstance_325().clt_1, Companion_getInstance_325().xls_1), this_1.hlu());
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.keyPressedCellTrait' call
      var tmp$ret$1 = new propertyConstraints$$inlined$apply$1(constraintsCell);
      this_1.olp(tmp$ret$1);
      var button = this_1;
      label_0(_this__u8e3s4, ']', false);
      tmp = button;
    } else {
      tmp = null;
    }
    var constraintButton = tmp;
    constraintsCell._v = indent_0(_this__u8e3s4, true, VOID, propertyConstraints$lambda(constraintButton, link, showUnderscore, constraintsCell));
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var visibleSync = new propertyConstraints$$inlined$forDisposable$1(link, _this__u8e3s4, constraintsCell);
    _this__u8e3s4.wle(visibleSync);
  }
  function completion$lambda_1(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    _this__u8e3s4.up7('property', completion$lambda$lambda(_this__u8e3s4));
    return Unit_instance;
  }
  function completion$lambda$lambda($this) {
    return function () {
      return ObjectPropertyDeclaration($this.o71());
    };
  }
  function objectPropertyEditors$lambda($this$editor) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    indent_0($this$editor, VOID, VOID, objectPropertyEditors$lambda$lambda);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda($this$indent) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    var tmp = getKClass(ObjectPropertyDeclaration_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, objectPropertyEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.pas();
  }
  function objectPropertyEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function objectPropertyEditors$lambda_1($this$editor) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    keyword_0($this$editor, 'property');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', objectPropertyEditors$lambda$lambda_0);
    indent_0($this$editor, true, VOID, objectPropertyEditors$lambda$lambda_1);
    newLine_0($this$editor);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_0(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.b3();
  }
  function objectPropertyEditors$lambda$lambda_1($this$indent) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    newLine_0($this$indent);
    keyword_0($this$indent, 'grouping:');
    space_0($this$indent);
    booleanProperty($this$indent, '<true|false>', objectPropertyEditors$lambda$lambda$lambda_0);
    newLine_0($this$indent);
    keyword_0($this$indent, 'super property:');
    space_0($this$indent);
    var tmp2 = Companion_getInstance_203().ubq_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = objectPropertyEditors$lambda$lambda$lambda_1;
    var options = new CompletionOptions();
    var containerInit = objectPropertyEditors$lambda$lambda$lambda_2;
    var textCellInit = objectPropertyEditors$lambda$lambda$lambda_3;
    var tmp;
    if (null == null) {
      tmp = objectPropertyEditors$lambda$lambda$lambda_4;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = objectPropertyEditors$lambda$lambda$lambda_5(textCellInit);
    var targetClass = getKClass(ObjectPropertyDeclaration_1);
    referenceTarget($this$indent, targetClass, '<none>', tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    newLine_0($this$indent);
    keyword_0($this$indent, 'domain:');
    space_0($this$indent);
    var tmp_0 = getKClass(Type);
    var tmp_1 = separator(',');
    children_2($this$indent, tmp_0, VOID, VOID, VOID, tmp_1, VOID, VOID, VOID, objectPropertyEditors$lambda$lambda$lambda_6);
    newLine_0($this$indent);
    keyword_0($this$indent, 'range:');
    space_0($this$indent);
    var tmp10 = getKClass(PropertyValueRange);
    var tmp11 = range$factory_1();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var placeholderText = '<no range>';
    var placeholderTraitFactory = objectPropertyEditors$lambda$lambda$lambda_7;
    var clipboardSetup = objectPropertyEditors$lambda$lambda$lambda_8;
    var tmp_2 = objectPropertyEditors$lambda$lambda$lambda_9(tmp11);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(ObjectPropertyDeclaration_1), tmp11);
    child_1($this$indent, tmp10, tmp_2, placeholderText, placeholderTraitFactory, null, clipboardSetup, null, null, tmp$ret$2, null);
    newLine_0($this$indent);
    keyword_0($this$indent, 'dependent:');
    space_0($this$indent);
    booleanProperty($this$indent, '<true|false>', objectPropertyEditors$lambda$lambda$lambda_10);
    newLine_0($this$indent);
    keyword_0($this$indent, 'inverse:');
    space_0($this$indent);
    var tmp21 = Companion_getInstance_203().vbq_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider_0 = objectPropertyEditors$lambda$lambda$lambda_11;
    var options_0 = new CompletionOptions();
    var containerInit_0 = objectPropertyEditors$lambda$lambda$lambda_12;
    var textCellInit_1 = objectPropertyEditors$lambda$lambda$lambda_13;
    var tmp_3;
    if (null == null) {
      tmp_3 = objectPropertyEditors$lambda$lambda$lambda_14;
    } else {
      tmp_3 = null;
    }
    var tmp5_0 = tmp_3;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_2 = objectPropertyEditors$lambda$lambda$lambda_15(textCellInit_1);
    var targetClass_0 = getKClass(ObjectPropertyDeclaration_1);
    referenceTarget($this$indent, targetClass_0, '<none>', tmp21, referenceProvider_0, null, tmp5_0, options_0, containerInit_0, textCellInit_2);
    newLine_0($this$indent);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda_0(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.wbq();
  }
  function objectPropertyEditors$lambda$lambda$lambda_1(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.xbq();
  }
  function objectPropertyEditors$lambda$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda_3(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda_4(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return true;
  }
  function objectPropertyEditors$lambda$lambda$lambda_5($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function objectPropertyEditors$lambda$lambda$lambda_6(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.obe();
  }
  function objectPropertyEditors$lambda$lambda$lambda_7(_unused_var__etf5q3, trait) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return trait;
  }
  function objectPropertyEditors$lambda$lambda$lambda_8(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda_9($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function objectPropertyEditors$lambda$lambda$lambda_10(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.ybq();
  }
  function objectPropertyEditors$lambda$lambda$lambda_11(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.zbq();
  }
  function objectPropertyEditors$lambda$lambda$lambda_12(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda_13(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda_14(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return true;
  }
  function objectPropertyEditors$lambda$lambda$lambda_15($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function objectPropertyEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function objectPropertyEditors$lambda_3($this$childrenRoleDefaults) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    $this$childrenRoleDefaults.up7('abstract', objectPropertyEditors$lambda$lambda_2($this$childrenRoleDefaults));
    $this$childrenRoleDefaults.up7('{', objectPropertyEditors$lambda$lambda_3($this$childrenRoleDefaults));
    var tmp = $this$childrenRoleDefaults.bp8(get_objectTypeCompletion());
    $this$childrenRoleDefaults.cp8(tmp, objectPropertyEditors$lambda$lambda_4($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_2($this_childrenRoleDefaults) {
    return function () {
      return NoValues($this_childrenRoleDefaults.o71());
    };
  }
  function objectPropertyEditors$lambda$lambda_3($this_childrenRoleDefaults) {
    return function () {
      return MultiplePropertyValueRange($this_childrenRoleDefaults.o71());
    };
  }
  function objectPropertyEditors$lambda$lambda_4($this_childrenRoleDefaults) {
    return function (type) {
      // Inline function 'kotlin.apply' call
      var this_0 = SinglePropertyValueRange($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.objectPropertyEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.lbn().e(type);
      return this_0;
    };
  }
  function objectPropertyEditors$lambda_4($this$editor) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    keyword_0($this$editor, 'abstract');
    return Unit_instance;
  }
  function objectPropertyEditors$lambda_5($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function objectPropertyEditors$lambda_6($this$editor) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    var c = {_v: null};
    var tmp = getKClass(Type);
    var tmp_0 = separator(',');
    var tmp_1 = objectPropertyEditors$lambda$lambda_5(c);
    c._v = children_2($this$editor, tmp, VOID, VOID, VOID, tmp_0, VOID, tmp_1, VOID, objectPropertyEditors$lambda$lambda_6);
    var tmp_2;
    if (c._v == null) {
      throwUninitializedPropertyAccessException('c');
    } else {
      tmp_2 = c._v;
    }
    considerEmptyBy($this$editor, tmp_2);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_5($c) {
    return function () {
      var tmp;
      if ($c._v == null) {
        throwUninitializedPropertyAccessException('c');
      } else {
        tmp = $c._v;
      }
      sendBecameEmpty(tmp);
      return Unit_instance;
    };
  }
  function objectPropertyEditors$lambda$lambda_6(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.lbn();
  }
  function objectPropertyEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function objectPropertyEditors$lambda_8($this$editor) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    // Inline function 'kotlin.apply' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.objectPropertyEditors.<anonymous>.<anonymous>' call
    label_0($this$editor, '{').jlu().v2c(true);
    space_0($this$editor);
    var tmp = getKClass(Type);
    var tmp_0 = separator(',');
    children_2($this$editor, tmp, VOID, VOID, VOID, tmp_0, VOID, VOID, VOID, objectPropertyEditors$lambda$lambda_7);
    space_0($this$editor);
    // Inline function 'kotlin.apply' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.objectPropertyEditors.<anonymous>.<anonymous>' call
    label_0($this$editor, '}').jlu().v2c(true);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_7(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.lbn();
  }
  function objectPropertyEditors$lambda_9($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function objectPropertyEditors$lambda_10($this$childrenRoleDefaults) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    var tmp = $this$childrenRoleDefaults.wp3(Companion_getInstance_204().qcd_1);
    $this$childrenRoleDefaults.zp7(tmp, objectPropertyEditors$lambda$lambda_8($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_8($this_childrenRoleDefaults) {
    return function (content) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyConstraint($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.objectPropertyEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.i6u().t6s(content);
      return this_0;
    };
  }
  function objectPropertyEditors$lambda_11($this$editor) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    var tmp1 = '<property>';
    var tmp2 = Companion_getInstance_204().qcd_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = objectPropertyEditors$lambda$lambda_9;
    var options = new CompletionOptions();
    var containerInit = objectPropertyEditors$lambda$lambda_10;
    var textCellInit = objectPropertyEditors$lambda$lambda_11;
    var tmp;
    if (null == null) {
      tmp = objectPropertyEditors$lambda$lambda_12;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = objectPropertyEditors$lambda$lambda_13(textCellInit);
    var targetClass = getKClass(ObjectPropertyDeclaration_1);
    referenceTarget($this$editor, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    space_0($this$editor);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    editableText_0($this$editor, VOID, '=', VOID, VOID, objectPropertyEditors$lambda$lambda_14);
    space_0($this$editor);
    var tmp13 = getKClass(AbstractValue);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var childProperty = value$factory_10();
    var placeholderTraitFactory = objectPropertyEditors$lambda$lambda_15;
    var clipboardSetup = objectPropertyEditors$lambda$lambda_16;
    var tmp_0 = objectPropertyEditors$lambda$lambda_17(childProperty);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$3 = new SingleChildLink(getKClass(PropertyConstraint_1), childProperty);
    child_1($this$editor, tmp13, tmp_0, null, placeholderTraitFactory, null, clipboardSetup, null, null, tmp$ret$3, null);
    propertyConstraints($this$editor);
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_9(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return it.i6u();
  }
  function objectPropertyEditors$lambda$lambda_10(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_11(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_12(it) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return true;
  }
  function objectPropertyEditors$lambda$lambda_13($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function objectPropertyEditors$lambda$lambda_14($this$editableText) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call
    var targetPropFactory = objectPropertyEditors$lambda$lambda$lambda_16;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.objectPropertyEditors.<anonymous>.<anonymous>' call
    var sourceProp = $this$editableText.k6h().u3l();
    var targetProp = targetPropFactory($this$editableText.ypn());
    $this$editableText.wle(syncTwoWay(sourceProp.n4z(), targetProp));
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda$lambda_16(textCell) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_12();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.en4(textCell, enumInfo);
  }
  function objectPropertyEditors$lambda$lambda_15(_unused_var__etf5q3, trait) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return trait;
  }
  function objectPropertyEditors$lambda$lambda_16(_this__u8e3s4) {
    _init_properties_ObjectProperties_kt__dw6gpa();
    return Unit_instance;
  }
  function objectPropertyEditors$lambda$lambda_17($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function objectPropertyEditors$lambda_12($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function propertyConstraints$$inlined$apply$1($constraintsCell) {
    this.bsr_1 = $constraintsCell;
    CellTrait.call(this);
  }
  protoOf(propertyConstraints$$inlined$apply$1).llm = function (cell, event) {
    if (!(cell instanceof TextCell))
      THROW_CCE();
    var tmp;
    if (event.ml1(Key_ENTER_getInstance(), [])) {
      var tmp_0;
      if (this.bsr_1._v == null) {
        throwUninitializedPropertyAccessException('constraintsCell');
      } else {
        tmp_0 = this.bsr_1._v;
      }
      tmp_0.elp().v2c(true);
      var tmp_1;
      if (this.bsr_1._v == null) {
        throwUninitializedPropertyAccessException('constraintsCell');
      } else {
        tmp_1 = this.bsr_1._v;
      }
      var tmp0_safe_receiver = firstFocusable(tmp_1);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.ul5();
      }
      event.ol0();
      tmp = Unit_instance;
    }
    return tmp;
  };
  function propertyConstraints$1$1$$inlined$keyPressedCellTrait$1($constraintButton, $constraintsCell) {
    this.csr_1 = $constraintButton;
    this.dsr_1 = $constraintsCell;
    CellTrait.call(this);
  }
  protoOf(propertyConstraints$1$1$$inlined$keyPressedCellTrait$1).llm = function (cell, event) {
    var tmp;
    if (!(this.csr_1 == null) && (event.ml1(Key_DELETE_getInstance(), []) || event.ml1(Key_BACKSPACE_getInstance(), []))) {
      this.csr_1.ul5();
      var tmp_0;
      if (this.dsr_1._v == null) {
        throwUninitializedPropertyAccessException('constraintsCell');
      } else {
        tmp_0 = this.dsr_1._v;
      }
      tmp_0.elp().v2c(false);
      event.ol0();
      tmp = Unit_instance;
    }
    return tmp;
  };
  function propertyConstraints$lambda$lambda($constraintButton, $constraintsCell) {
    return function (_unused_var__etf5q3, trait) {
      // Inline function 'jetbrains.ocelot.projectional.cell.trait.keyPressedCellTrait' call
      var deleteTrait = new propertyConstraints$1$1$$inlined$keyPressedCellTrait$1($constraintButton, $constraintsCell);
      return CompositeCellTraits_instance.emu([trait, deleteTrait]);
    };
  }
  function propertyConstraints$lambda$lambda_0($link) {
    return function (it) {
      return $link.y6k_1(it);
    };
  }
  function propertyConstraints$lambda($constraintButton, $link, $showUnderscore, $constraintsCell) {
    return function ($this$indent) {
      newLine_0($this$indent);
      var tmp1_layout = Layout_VERTICAL_getInstance();
      var tmp0_safe_receiver = $constraintButton;
      var tmp2_onLastItemDeleted = tmp0_safe_receiver == null ? null : toHome(tmp0_safe_receiver);
      var tmp = getKClass(PropertyConstraint_1);
      var tmp_0 = propertyConstraints$lambda$lambda($constraintButton, $constraintsCell);
      children_2($this$indent, tmp, $link, VOID, tmp_0, VOID, VOID, tmp2_onLastItemDeleted, tmp1_layout, propertyConstraints$lambda$lambda_0($link));
      var tmp_1;
      if ($showUnderscore) {
        newLine_0($this$indent);
        label_0($this$indent, '_');
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function propertyConstraints$$inlined$forDisposable$1($link, $this_propertyConstraints, $constraintsCell) {
    this.fsr_1 = $link;
    this.gsr_1 = $this_propertyConstraints;
    this.hsr_1 = $constraintsCell;
    DisposableSynchronizer.call(this);
  }
  protoOf(propertyConstraints$$inlined$forDisposable$1).dlb = function (ctx) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.propertyConstraints.<anonymous>' call
    var tmp = PropertyBinding_instance;
    var tmp_0 = notEmptyProp(this.fsr_1.y6k_1(this.gsr_1.k6h()).n4z());
    var tmp_1;
    if (this.hsr_1._v == null) {
      throwUninitializedPropertyAccessException('constraintsCell');
    } else {
      tmp_1 = this.hsr_1._v;
    }
    return tmp.d2g(tmp_0, tmp_1.elp());
  };
  function constraints$factory_3() {
    return getPropertyCallableRef('constraints', 1, KProperty1, function (receiver) {
      return receiver.dbc();
    }, null);
  }
  function range$factory_1() {
    return getPropertyCallableRef('range', 1, KProperty1, function (receiver) {
      return receiver.be();
    }, null);
  }
  function value$factory_10() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  var properties_initialized_ObjectProperties_kt_9560yc;
  function _init_properties_ObjectProperties_kt__dw6gpa() {
    if (!properties_initialized_ObjectProperties_kt_9560yc) {
      properties_initialized_ObjectProperties_kt_9560yc = true;
      completion_2 = completion$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = objectPropertyEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(ObjectPropertiesLibrary);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, objectPropertyEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = get_completion();
      var separator = get_defaultChildrenSeparator();
      var tmp11 = new ChildrenRoleDefaults(getKClass(ObjectPropertyDeclaration_1), '<empty>', null, separator, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = objectPropertyEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(ObjectPropertyDeclaration_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp11, null, false, true, triggerDependencies_0, objectPropertyEditors$lambda_2(init_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = objectPropertyEditors$lambda_3;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp40 = new ChildrenRoleDefaults(getKClass(PropertyValueRange), '<empty>', null, separator_0, completionSupplier_0, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = objectPropertyEditors$lambda_4;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(NoValues_1);
      var tmp_4 = new EditorDefinition(tmp_3, null, null, false, true, triggerDependencies_1, objectPropertyEditors$lambda_5(init_1));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = objectPropertyEditors$lambda_6;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(SinglePropertyValueRange_1);
      var tmp_6 = new EditorDefinition(tmp_5, null, null, false, true, triggerDependencies_2, objectPropertyEditors$lambda_7(init_2));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = objectPropertyEditors$lambda_8;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(MultiplePropertyValueRange_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_4, tmp_6, new EditorDefinition(tmp_7, null, null, false, true, triggerDependencies_3, objectPropertyEditors$lambda_9(init_3))];
      var tmp_8 = new HierarchyEditorDefinition(getKClass(PropertyValueRange), tmp40, toList(editorDefinitions));
      var tmp42 = '<constraints>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_1 = objectPropertyEditors$lambda_10;
      var separator_1 = get_defaultChildrenSeparator();
      var tmp47 = new ChildrenRoleDefaults(getKClass(PropertyConstraint_1), tmp42, null, separator_1, completionSupplier_1, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = objectPropertyEditors$lambda_11;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(PropertyConstraint_1);
      var tmp$ret$9 = new EditorDefinition(tmp_9, tmp47, null, false, true, triggerDependencies_4, objectPropertyEditors$lambda_12(init_4));
      objectPropertyEditors = listOf_0([tmp_0, tmp_2, tmp_8, tmp$ret$9]);
    }
  }
  function get_ontologyImportRootEditors() {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    return ontologyImportRootEditors;
  }
  var ontologyImportRootEditors;
  function getOntologyLibraryReferenceCompletion(_this__u8e3s4) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_206().tc0_1);
    _this__u8e3s4.zp7(tmp, getOntologyLibraryReferenceCompletion$lambda(_this__u8e3s4));
  }
  function ontologyImportRootEditors$lambda($this$editor) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    var tmp = getKClass(OntologyImport_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, ontologyImportRootEditors$lambda$lambda);
    return Unit_instance;
  }
  function ontologyImportRootEditors$lambda$lambda(importRoot) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    return importRoot.sau();
  }
  function ontologyImportRootEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function ontologyImportRootEditors$lambda_1($this$editor) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    keyword_0($this$editor, 'for');
    space_0($this$editor);
    var tmp = getKClass(OntologyLibraryReference_1);
    var tmp_0 = ontologyImportRootEditors$lambda$lambda_0;
    child_1($this$editor, tmp, tmp_0, '<ontology>', VOID, VOID, VOID, VOID, VOID, VOID, ontologyImportRootEditors$lambda$lambda_1);
    indentLabel_0($this$editor, '/');
    var tmp_1 = getKClass(OntologyElementReference_1);
    child_1($this$editor, tmp_1, ontologyImportRootEditors$lambda$lambda_2);
    space_0($this$editor);
    keyword_0($this$editor, 'use');
    space_0($this$editor);
    var tmp_2 = getKClass(OntologyLibraryReference_1);
    var tmp_3 = ontologyImportRootEditors$lambda$lambda_3;
    child_1($this$editor, tmp_2, tmp_3, '<library to use>', VOID, VOID, VOID, VOID, VOID, VOID, ontologyImportRootEditors$lambda$lambda_4);
    return Unit_instance;
  }
  function ontologyImportRootEditors$lambda$lambda_0(ontologyImport) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    return ontologyImport.sby();
  }
  function ontologyImportRootEditors$lambda$lambda_1($this$child) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    getOntologyLibraryReferenceCompletion($this$child);
    return Unit_instance;
  }
  function ontologyImportRootEditors$lambda$lambda_2(ontologyImport) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    return ontologyImport.lay();
  }
  function ontologyImportRootEditors$lambda$lambda_3(ontologyImport) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    return ontologyImport.tby();
  }
  function ontologyImportRootEditors$lambda$lambda_4($this$child) {
    _init_properties_OntologyImportRootEditors_kt__16c5by();
    getOntologyLibraryReferenceCompletion($this$child);
    return Unit_instance;
  }
  function ontologyImportRootEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function getOntologyLibraryReferenceCompletion$lambda($this_getOntologyLibraryReferenceCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLibraryReference($this_getOntologyLibraryReferenceCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.getOntologyLibraryReferenceCompletion.<anonymous>.<anonymous>' call
      this_0.ub6().t6s(reference);
      return this_0;
    };
  }
  var properties_initialized_OntologyImportRootEditors_kt_dyb78g;
  function _init_properties_OntologyImportRootEditors_kt__16c5by() {
    if (!properties_initialized_OntologyImportRootEditors_kt_dyb78g) {
      properties_initialized_OntologyImportRootEditors_kt_dyb78g = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = ontologyImportRootEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(OntologyImportRoot_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, ontologyImportRootEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<imports>';
      var separator = get_defaultChildrenSeparator();
      var tmp11 = new ChildrenRoleDefaults(getKClass(OntologyImport_1), placeholderText, null, separator, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = ontologyImportRootEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(OntologyImport_1);
      var tmp$ret$2 = new EditorDefinition(tmp_1, tmp11, null, false, true, triggerDependencies_0, ontologyImportRootEditors$lambda_2(init_0));
      ontologyImportRootEditors = listOf_0([tmp_0, tmp$ret$2]);
    }
  }
  function get_ontologyLibraryEditors() {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return ontologyLibraryEditors;
  }
  var ontologyLibraryEditors;
  function excludingClassExpressionCompletion(_this__u8e3s4, node) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new excludingClassExpressionCompletion$$inlined$executeQuery$1(node);
    var anonymousClassAncestor = execute_0(tmp$ret$0);
    if (anonymousClassAncestor == null) {
      anonymousClassCompletion(_this__u8e3s4);
    } else {
      ontologyElementReferenceProviderCompletion(_this__u8e3s4);
    }
  }
  function anonymousClassCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    _this__u8e3s4.up7('union of', anonymousClassCompletion$lambda(_this__u8e3s4));
  }
  function classExpressionCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    anonymousClassCompletion(_this__u8e3s4);
    ontologyElementReferenceProviderCompletion(_this__u8e3s4);
  }
  function ontologyElementDefinitionCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = _this__u8e3s4.bp8(ontologyElementDefinitionCompletion$lambda);
    _this__u8e3s4.cp8(tmp, ontologyElementDefinitionCompletion$lambda_0(_this__u8e3s4));
  }
  function ontologyIsRelationCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = _this__u8e3s4.bp8(ontologyIsRelationCompletion$lambda);
    _this__u8e3s4.cp8(tmp, ontologyIsRelationCompletion$lambda_0(_this__u8e3s4));
  }
  function ontologyElementReferenceProviderCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    localOntologyElementReferenceCompletion(_this__u8e3s4);
    qualifiedElementReferenceCompletion(_this__u8e3s4);
  }
  function ontologyRelationCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = _this__u8e3s4.bp8(ontologyRelationCompletion$lambda);
    _this__u8e3s4.cp8(tmp, ontologyRelationCompletion$lambda_0(_this__u8e3s4));
  }
  function localOntologyElementReferenceCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_207().tbi_1);
    _this__u8e3s4.zp7(tmp, localOntologyElementReferenceCompletion$lambda(_this__u8e3s4));
  }
  function qualifiedElementReferenceCompletion(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_206().tc0_1);
    _this__u8e3s4.zp7(tmp, qualifiedElementReferenceCompletion$lambda(_this__u8e3s4));
  }
  function ontologyLibraryEditors$lambda($this$editor) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    indent_0($this$editor, VOID, VOID, ontologyLibraryEditors$lambda$lambda);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = getKClass(OntologyElement_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, ontologyLibraryEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda(ontologyLibrary) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return ontologyLibrary.sc0();
  }
  function ontologyLibraryEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function ontologyLibraryEditors$lambda_1($this$editor) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    keyword_0($this$editor, 'ontology type:');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', ontologyLibraryEditors$lambda$lambda_0);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_1);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_2);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_3);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_4);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_5);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_6);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_7);
    indent_0($this$editor, true, VOID, ontologyLibraryEditors$lambda$lambda_8);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_0(ontologyElement) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return ontologyElement.b3();
  }
  function ontologyLibraryEditors$lambda$lambda_1($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'super types:');
    space_0($this$indent);
    var tmp1 = getKClass(OntologyIsRelation_1);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = superElements$factory_1();
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda$lambda_0;
    var clipboardSetup = ontologyLibraryEditors$lambda$lambda$lambda_1;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp = new MultipleChildLink(getKClass(OntologyElement_1), childrenProperty);
    children_2($this$indent, tmp1, tmp, null, placeholderTraitFactory, null, clipboardSetup, null, layout, ontologyLibraryEditors$lambda$lambda$lambda_2(childrenProperty));
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_0(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_2($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda$lambda_2($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'is part of:');
    space_0($this$indent);
    var tmp1 = getKClass(OntologyCardinalityRelation_1);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = enclosingElements$factory_1();
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda$lambda_3;
    var clipboardSetup = ontologyLibraryEditors$lambda$lambda$lambda_4;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp = new MultipleChildLink(getKClass(OntologyElement_1), childrenProperty);
    children_2($this$indent, tmp1, tmp, null, placeholderTraitFactory, null, clipboardSetup, null, layout, ontologyLibraryEditors$lambda$lambda$lambda_5(childrenProperty));
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_3(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_4(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_5($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda$lambda_3($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'only in taxon:');
    space_0($this$indent);
    var tmp1 = getKClass(ClassExpression);
    var tmp2 = taxon$factory_1();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = ontologyLibraryEditors$lambda$lambda$lambda_6;
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda$lambda_7;
    var clipboardSetup = ontologyLibraryEditors$lambda$lambda$lambda_8;
    var tmp = ontologyLibraryEditors$lambda$lambda$lambda_9(tmp2);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElement_1), tmp2);
    child_1($this$indent, tmp1, tmp, '<taxon>', placeholderTraitFactory, null, clipboardSetup, null, null, tmp$ret$0, completionSupplier);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_6($this$child) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    classExpressionCompletion($this$child);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_7(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_8(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_9($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda$lambda_4($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    get_background(gray(keyword_0($this$indent, 'old definition:'))).v2c(Companion_getInstance_325().wls_1);
    space_0($this$indent);
    var tmp1 = getKClass(AnonymousClass);
    var tmp2 = oldDefinition$factory_0();
    var tmp3 = '<use definition below instead>';
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = ontologyLibraryEditors$lambda$lambda$lambda_10;
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda$lambda_11;
    var clipboardSetup = ontologyLibraryEditors$lambda$lambda$lambda_12;
    var tmp = ontologyLibraryEditors$lambda$lambda$lambda_13(tmp2);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElement_1), tmp2);
    child_1($this$indent, tmp1, tmp, tmp3, placeholderTraitFactory, null, clipboardSetup, null, null, tmp$ret$0, completionSupplier);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_10($this$child) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    anonymousClassCompletion($this$child);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_11(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_12(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_13($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda$lambda_5($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'definition:');
    space_0($this$indent);
    var tmp1 = getKClass(OntologyElementDefinition_1);
    var tmp2 = definition$factory_0();
    var tmp3 = '<definition>';
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = ontologyLibraryEditors$lambda$lambda$lambda_14;
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda$lambda_15;
    var clipboardSetup = ontologyLibraryEditors$lambda$lambda$lambda_16;
    var tmp = ontologyLibraryEditors$lambda$lambda$lambda_17(tmp2);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElement_1), tmp2);
    child_1($this$indent, tmp1, tmp, tmp3, placeholderTraitFactory, null, clipboardSetup, null, null, tmp$ret$0, completionSupplier);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_14($this$child) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    ontologyElementDefinitionCompletion($this$child);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_15(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_16(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_17($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda$lambda_6($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'properties:');
    space_0($this$indent);
    propertyConstraints($this$indent, false);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_7($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'synonyms:');
    space_0($this$indent);
    var tmp1 = getKClass(OntologyElementSynonym_1);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = synonyms$factory_0();
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda$lambda_18;
    var clipboardSetup = ontologyLibraryEditors$lambda$lambda$lambda_19;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp = new MultipleChildLink(getKClass(OntologyElement_1), childrenProperty);
    children_2($this$indent, tmp1, tmp, null, placeholderTraitFactory, null, clipboardSetup, null, layout, ontologyLibraryEditors$lambda$lambda$lambda_20(childrenProperty));
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_18(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_19(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_20($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda$lambda_8($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    newLine_0($this$indent);
    keyword_0($this$indent, 'url:');
    space_0($this$indent);
    var tmp = ontologyLibraryEditors$lambda$lambda$lambda_21;
    textProperty_0($this$indent, '<none>', tmp, ontologyLibraryEditors$lambda$lambda$lambda_22);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_21(ontologyElement) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return ontologyElement.jbu();
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_22($this$textProperty) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    $this$textProperty.ypn().olp(URLHandler_getInstance());
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function ontologyLibraryEditors$lambda_3($this$childrenRoleDefaults) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = $this$childrenRoleDefaults.dp6();
    $this$childrenRoleDefaults.wp7(tmp, ontologyLibraryEditors$lambda$lambda_9($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_9($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementSynonym($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.ontologyLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.b3().v2c(name);
      return this_0;
    };
  }
  function ontologyLibraryEditors$lambda_4($this$editor) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = ontologyLibraryEditors$lambda$lambda_10;
    editableText_0($this$editor, VOID, '<synonym>', tmp, VOID, ontologyLibraryEditors$lambda$lambda_11);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_10(it) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return !contains_9(it, ',');
  }
  function ontologyLibraryEditors$lambda$lambda_11($this$editableText) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.ontologyLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
    var sourceProp = $this$editableText.k6h().b3();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.textSyncTwoWay.stub_for_inlining' call
    var targetProp = $this$editableText.ypn().laz();
    $this$editableText.wle(syncTwoWay(sourceProp.n4z(), targetProp));
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda_5($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function ontologyLibraryEditors$lambda_6($this$childrenRoleDefaults) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    ontologyIsRelationCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda_7($this$editor) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    indent_0($this$editor, VOID, VOID, ontologyLibraryEditors$lambda$lambda_12);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_12($this$indent) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = getKClass(OntologyElementReferenceProvider);
    var tmp_0 = ontologyLibraryEditors$lambda$lambda$lambda_23;
    child_1($this$indent, tmp, tmp_0, '<ontology element>', VOID, VOID, VOID, VOID, VOID, VOID, ontologyLibraryEditors$lambda$lambda$lambda_24);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_23(relation) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return relation.fc0();
  }
  function ontologyLibraryEditors$lambda$lambda$lambda_24($this$child) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    ontologyElementReferenceProviderCompletion($this$child);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda_8($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function ontologyLibraryEditors$lambda_9($this$childrenRoleDefaults) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    ontologyRelationCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda_10($this$editor) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp = getKClass(ClassExpression);
    var tmp_0 = ontologyLibraryEditors$lambda$lambda_13;
    child_1($this$editor, tmp, tmp_0, '<class>', VOID, VOID, VOID, VOID, VOID, VOID, ontologyLibraryEditors$lambda$lambda_14);
    var tmp_1 = getKClass(Cardinality_1);
    child_1($this$editor, tmp_1, ontologyLibraryEditors$lambda$lambda_15);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_13(relation) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return relation.yay();
  }
  function ontologyLibraryEditors$lambda$lambda_14($this$child) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    classExpressionCompletion($this$child);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_15(cardinalityRelation) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return cardinalityRelation.eb8();
  }
  function ontologyLibraryEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function ontologyLibraryEditors$lambda_12($this$editor) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    var tmp1 = getKClass(ClassExpression);
    var tmp2 = classExpression$factory_2();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = ontologyLibraryEditors$lambda$lambda_16;
    var placeholderTraitFactory = ontologyLibraryEditors$lambda$lambda_17;
    var clipboardSetup = ontologyLibraryEditors$lambda$lambda_18;
    var tmp = ontologyLibraryEditors$lambda$lambda_19(tmp2);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(OntologyElementDefinition_1), tmp2);
    child_1($this$editor, tmp1, tmp, '<class>', placeholderTraitFactory, null, clipboardSetup, null, null, tmp$ret$0, completionSupplier);
    propertyConstraints($this$editor, true);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_16($this$child) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    classExpressionCompletion($this$child);
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_17(_unused_var__etf5q3, trait) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return trait;
  }
  function ontologyLibraryEditors$lambda$lambda_18(_this__u8e3s4) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    return Unit_instance;
  }
  function ontologyLibraryEditors$lambda$lambda_19($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function ontologyLibraryEditors$lambda_13($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function excludingClassExpressionCompletion$$inlined$executeQuery$1($node) {
    this.isr_1 = $node;
  }
  protoOf(excludingClassExpressionCompletion$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.excludingClassExpressionCompletion.<anonymous>' call
    var tmp = this.isr_1;
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = (!(tmp == null) ? isInterface(tmp, BTBNode) : false) ? tmp : null;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(AnonymousClass));
    return builder.n51(tmp$ret$0);
  };
  function anonymousClassCompletion$lambda($this_anonymousClassCompletion) {
    return function () {
      return UnionClass($this_anonymousClassCompletion.o71());
    };
  }
  function ontologyElementDefinitionCompletion$lambda($this$using) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    classExpressionCompletion($this$using);
    return Unit_instance;
  }
  function ontologyElementDefinitionCompletion$lambda_0($this_ontologyElementDefinitionCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementDefinition($this_ontologyElementDefinitionCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.ontologyElementDefinitionCompletion.<anonymous>.<anonymous>' call
      this_0.yay().v2c(it);
      return this_0;
    };
  }
  function ontologyIsRelationCompletion$lambda($this$using) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    ontologyElementReferenceProviderCompletion($this$using);
    return Unit_instance;
  }
  function ontologyIsRelationCompletion$lambda_0($this_ontologyIsRelationCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyIsRelation($this_ontologyIsRelationCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.ontologyIsRelationCompletion.<anonymous>.<anonymous>' call
      this_0.fc0().v2c(it);
      return this_0;
    };
  }
  function ontologyRelationCompletion$lambda($this$using) {
    _init_properties_OntologyLibraryEditors_kt__lodwxm();
    classExpressionCompletion($this$using);
    return Unit_instance;
  }
  function ontologyRelationCompletion$lambda_0($this_ontologyRelationCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyCardinalityRelation($this_ontologyRelationCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.ontologyRelationCompletion.<anonymous>.<anonymous>' call
      this_0.yay().v2c(it);
      return this_0;
    };
  }
  function localOntologyElementReferenceCompletion$lambda($this_localOntologyElementReferenceCompletion) {
    return function (reference) {
      return LocalOntologyElementReference_2($this_localOntologyElementReferenceCompletion.o71(), reference);
    };
  }
  function qualifiedElementReferenceCompletion$lambda($this_qualifiedElementReferenceCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = QualifiedOntologyElementReference($this_qualifiedElementReferenceCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.qualifiedElementReferenceCompletion.<anonymous>.<anonymous>' call
      this_0.lcj().v2c(OntologyLibraryReference_2($this_qualifiedElementReferenceCompletion.o71(), reference));
      this_0.mcj().v2c(OntologyElementReference($this_qualifiedElementReferenceCompletion.o71()));
      return this_0;
    };
  }
  function superElements$factory_1() {
    return getPropertyCallableRef('superElements', 1, KProperty1, function (receiver) {
      return receiver.gbu();
    }, null);
  }
  function enclosingElements$factory_1() {
    return getPropertyCallableRef('enclosingElements', 1, KProperty1, function (receiver) {
      return receiver.hbu();
    }, null);
  }
  function taxon$factory_1() {
    return getPropertyCallableRef('taxon', 1, KProperty1, function (receiver) {
      return receiver.ibu();
    }, null);
  }
  function oldDefinition$factory_0() {
    return getPropertyCallableRef('oldDefinition', 1, KProperty1, function (receiver) {
      return receiver.mbu();
    }, null);
  }
  function definition$factory_0() {
    return getPropertyCallableRef('definition', 1, KProperty1, function (receiver) {
      return receiver.nbu();
    }, null);
  }
  function synonyms$factory_0() {
    return getPropertyCallableRef('synonyms', 1, KProperty1, function (receiver) {
      return receiver.kbu();
    }, null);
  }
  function classExpression$factory_2() {
    return getPropertyCallableRef('classExpression', 1, KProperty1, function (receiver) {
      return receiver.yay();
    }, null);
  }
  var properties_initialized_OntologyLibraryEditors_kt_dzogpw;
  function _init_properties_OntologyLibraryEditors_kt__lodwxm() {
    if (!properties_initialized_OntologyLibraryEditors_kt_dzogpw) {
      properties_initialized_OntologyLibraryEditors_kt_dzogpw = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = ontologyLibraryEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(OntologyLibrary_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, ontologyLibraryEditors$lambda_0(init));
      var tmp6 = '<elements>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var separator_0 = blankLine();
      var tmp11 = new ChildrenRoleDefaults(getKClass(OntologyElement_1), tmp6, null, separator_0, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = ontologyLibraryEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(OntologyElement_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp11, null, false, true, triggerDependencies_0, ontologyLibraryEditors$lambda_2(init_0));
      var tmp17 = '<synonyms>';
      var tmp18 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = ontologyLibraryEditors$lambda_3;
      var tmp22 = new ChildrenRoleDefaults(getKClass(OntologyElementSynonym_1), tmp17, null, tmp18, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = ontologyLibraryEditors$lambda_4;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(OntologyElementSynonym_1);
      var tmp_4 = new EditorDefinition(tmp_3, tmp22, null, false, true, triggerDependencies_1, ontologyLibraryEditors$lambda_5(init_1));
      var tmp28 = '<super elements>';
      var tmp29 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = ontologyLibraryEditors$lambda_6;
      var tmp33 = new ChildrenRoleDefaults(getKClass(OntologyIsRelation_1), tmp28, null, tmp29, completionSupplier_0, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = ontologyLibraryEditors$lambda_7;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(OntologyIsRelation_1);
      var tmp_6 = new EditorDefinition(tmp_5, tmp33, null, false, true, triggerDependencies_2, ontologyLibraryEditors$lambda_8(init_2));
      var tmp39 = '<enclosing elements>';
      var tmp40 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_1 = ontologyLibraryEditors$lambda_9;
      var tmp44 = new ChildrenRoleDefaults(getKClass(OntologyCardinalityRelation_1), tmp39, null, tmp40, completionSupplier_1, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = ontologyLibraryEditors$lambda_10;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(OntologyCardinalityRelation_1);
      var tmp_8 = new EditorDefinition(tmp_7, tmp44, null, false, true, triggerDependencies_3, ontologyLibraryEditors$lambda_11(init_3));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = ontologyLibraryEditors$lambda_12;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(OntologyElementDefinition_1);
      var tmp$ret$9 = new EditorDefinition(tmp_9, null, null, false, true, triggerDependencies_4, ontologyLibraryEditors$lambda_13(init_4));
      ontologyLibraryEditors = listOf_0([tmp_0, tmp_2, tmp_4, tmp_6, tmp_8, tmp$ret$9]);
    }
  }
  function get_processLibraryEditors() {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processLibraryEditors;
  }
  var processLibraryEditors;
  function get_RANGE_CELL_MARK() {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return RANGE_CELL_MARK;
  }
  var RANGE_CELL_MARK;
  function get_PROCESS_PROPERTY_CELL_MARK() {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return PROCESS_PROPERTY_CELL_MARK;
  }
  var PROCESS_PROPERTY_CELL_MARK;
  function libraryProcessSpecificationEditor() {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.asyncInvalidatingEditor' call
    var init = libraryProcessSpecificationEditor$slambda_0(null);
    var triggerDependencies = emptyList();
    var tmp = getKClass(LibraryProcessSpecification_1);
    return new EditorDefinition(tmp, null, null, false, true, triggerDependencies, libraryProcessSpecificationEditor$lambda(init));
  }
  function libraryProcessSpecificationCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_208().kc6_1);
    _this__u8e3s4.zp7(tmp, libraryProcessSpecificationCompletion$lambda(_this__u8e3s4));
  }
  function gray(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    _this__u8e3s4.bln(Companion_getInstance_271().bls_1, Companion_getInstance_325().xls_1);
    return _this__u8e3s4;
  }
  function processPropertyTypeCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    simplePropertyTypeCompletion(_this__u8e3s4);
    ontologyElementPropertyTypeCompletion(_this__u8e3s4);
    anonymousClassTypeCompletion(_this__u8e3s4);
  }
  function getAbstractBindingEntryCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.bp8(getAbstractBindingEntryCompletion$lambda);
    _this__u8e3s4.cp8(tmp, getAbstractBindingEntryCompletion$lambda_0(_this__u8e3s4));
    var tmp_0 = _this__u8e3s4.bp8(getAbstractBindingEntryCompletion$lambda_1);
    _this__u8e3s4.cp8(tmp_0, getAbstractBindingEntryCompletion$lambda_2(_this__u8e3s4));
    var tmp_1 = _this__u8e3s4.wp3(Companion_getInstance_202().zbc_1);
    _this__u8e3s4.zp7(tmp_1, getAbstractBindingEntryCompletion$lambda_3(_this__u8e3s4));
    var tmp_2 = _this__u8e3s4.wp3(Companion_getInstance_214().nbd_1);
    _this__u8e3s4.zp7(tmp_2, getAbstractBindingEntryCompletion$lambda_4(_this__u8e3s4));
  }
  function optionalSpecializedLink(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var specializedCell = indent_0(_this__u8e3s4, VOID, VOID, optionalSpecializedLink$lambda);
    // Inline function 'jetbrains.ocelot.mapper.core.Synchronizers.forDisposable' call
    var tmp$ret$0 = new optionalSpecializedLink$$inlined$forDisposable$1(_this__u8e3s4, specializedCell);
    _this__u8e3s4.wle(tmp$ret$0);
  }
  function get_propertyDeclarationEditor() {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
    var placeholderText = '<property declaration>';
    var separator = get_defaultChildrenSeparator();
    var tmp5 = new ChildrenRoleDefaults(getKClass(PropertyDeclaration_1), placeholderText, null, separator, null, true);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = _get_propertyDeclarationEditor_$lambda_j0iclw;
    var triggerDependencies = emptyList();
    var tmp = getKClass(PropertyDeclaration_1);
    return new EditorDefinition(tmp, tmp5, null, false, true, triggerDependencies, _get_propertyDeclarationEditor_$lambda_j0iclw_0(init));
  }
  function getBindingValueCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_213().agd_1);
    _this__u8e3s4.zp7(tmp, getBindingValueCompletion$lambda(_this__u8e3s4));
    var tmp_0 = _this__u8e3s4.wp3(Companion_getInstance_201().aat_1);
    _this__u8e3s4.zp7(tmp_0, getBindingValueCompletion$lambda_0(_this__u8e3s4));
    var tmp_1 = _this__u8e3s4.wp3(Companion_getInstance_192().nca_1);
    _this__u8e3s4.zp7(tmp_1, getBindingValueCompletion$lambda_1(_this__u8e3s4));
  }
  function propertyDeclarationByNotionCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.bp8(propertyDeclarationByNotionCompletion$lambda);
    _this__u8e3s4.cp8(tmp, propertyDeclarationByNotionCompletion$lambda_0(_this__u8e3s4));
  }
  function processPrerequisiteCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.bp8(processPrerequisiteCompletion$lambda);
    _this__u8e3s4.cp8(tmp, processPrerequisiteCompletion$lambda_0(_this__u8e3s4));
  }
  function processEffectCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.bp8(processEffectCompletion$lambda);
    _this__u8e3s4.cp8(tmp, processEffectCompletion$lambda_0(_this__u8e3s4));
  }
  function simplePropertyTypeCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_210().wcm_1);
    _this__u8e3s4.zp7(tmp, simplePropertyTypeCompletion$lambda(_this__u8e3s4));
  }
  function ontologyElementPropertyTypeCompletion(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var createPropertyTypeNode = ontologyElementPropertyTypeCompletion$lambda(_this__u8e3s4);
    _this__u8e3s4.up7('TYPE_OF', ontologyElementPropertyTypeCompletion$lambda_0(createPropertyTypeNode));
    _this__u8e3s4.up7('INSTANCE_OF', ontologyElementPropertyTypeCompletion$lambda_1(createPropertyTypeNode));
  }
  function shouldShowSpecialized(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    return new shouldShowSpecialized$$inlined$query$1(_this__u8e3s4);
  }
  function processLibraryEditors$lambda($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(ProcessDeclaration_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, processLibraryEditors$lambda$lambda);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda(processLibrary) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processLibrary.jc8();
  }
  function processLibraryEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_1($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    commentEditor($this$editor);
    newLine_0($this$editor);
    var tmp2 = Companion_getInstance_208().jc6_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda_0;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda_1;
    var textCellInit = processLibraryEditors$lambda$lambda_2;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda_3;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda_4(textCellInit);
    var targetClass = getKClass(ProcessKind_1);
    referenceTarget($this$editor, targetClass, '<kind>', tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', processLibraryEditors$lambda$lambda_5);
    space_0($this$editor);
    horizontal_0($this$editor, processLibraryEditors$lambda$lambda_6);
    indent_0($this$editor, true, VOID, processLibraryEditors$lambda$lambda_7);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_0(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.r5e();
  }
  function processLibraryEditors$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_3(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda_4($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda$lambda_5(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.b3();
  }
  function processLibraryEditors$lambda$lambda_6($this$horizontal) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$horizontal, VOID, VOID, processLibraryEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    keyword_0($this$indent, 'inherits');
    space_0($this$indent);
    var tmp = getKClass(ProcessReference_1);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = inherited$factory_2();
    var tmp_0 = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_0);
    children_2($this$indent, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, processLibraryEditors$lambda$lambda$lambda$lambda);
    newLine_0($this$indent);
    get_background(gray(keyword_0($this$indent, 'extends'))).v2c(Companion_getInstance_325().wls_1);
    space_0($this$indent);
    var tmp2 = '<process>';
    var tmp3 = Companion_getInstance_208().kc6_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda$lambda$lambda_0;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda$lambda$lambda_1;
    var textCellInit = processLibraryEditors$lambda$lambda$lambda$lambda_2;
    var tmp_1;
    if (null == null) {
      tmp_1 = processLibraryEditors$lambda$lambda$lambda$lambda_3;
    } else {
      tmp_1 = null;
    }
    var tmp5 = tmp_1;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda$lambda$lambda_4(textCellInit);
    var targetClass = getKClass(ProcessDeclaration_1);
    var tmp$ret$2 = referenceTarget($this$indent, targetClass, tmp2, tmp3, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    get_background(tmp$ret$2).v2c(Companion_getInstance_325().wls_1);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.hc7();
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_0(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.gc7();
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_2(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_3(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_4($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda$lambda_7($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    newLine_0($this$indent);
    newLine_0($this$indent);
    keyword_0($this$indent, 'ontology elements:');
    space_0($this$indent);
    horizontal_0($this$indent, processLibraryEditors$lambda$lambda$lambda_0);
    newLine_0($this$indent);
    keyword_0($this$indent, 'parameters:');
    space_0($this$indent);
    horizontal_0($this$indent, processLibraryEditors$lambda$lambda$lambda_1);
    newLine_0($this$indent);
    newLine_0($this$indent);
    get_background(gray(keyword_0($this$indent, 'old properties:'))).v2c(Companion_getInstance_325().wls_1);
    space_0($this$indent);
    get_background(horizontal_0($this$indent, processLibraryEditors$lambda$lambda$lambda_2)).v2c(Companion_getInstance_325().wls_1);
    newLine_0($this$indent);
    newLine_0($this$indent);
    variablesEditor($this$indent);
    newLine_0($this$indent);
    newLine_0($this$indent);
    keyword_0($this$indent, 'prerequisites:');
    space_0($this$indent);
    horizontal_0($this$indent, processLibraryEditors$lambda$lambda$lambda_3);
    newLine_0($this$indent);
    newLine_0($this$indent);
    keyword_0($this$indent, 'effects:');
    space_0($this$indent);
    horizontal_0($this$indent, processLibraryEditors$lambda$lambda$lambda_4);
    newLine_0($this$indent);
    newLine_0($this$indent);
    customEditor($this$indent);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_0($this$horizontal) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(OntologyElementType_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$horizontal, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, processLibraryEditors$lambda$lambda$lambda$lambda_5);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_5(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.oas();
  }
  function processLibraryEditors$lambda$lambda$lambda_1($this$horizontal) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(ProcessProperty_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$horizontal, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, processLibraryEditors$lambda$lambda$lambda$lambda_6);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_6(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.pas();
  }
  function processLibraryEditors$lambda$lambda$lambda_2($this$horizontal) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(AbstractBindingEntry);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$horizontal, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, processLibraryEditors$lambda$lambda$lambda$lambda_7);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_7(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.w();
  }
  function processLibraryEditors$lambda$lambda$lambda_3($this$horizontal) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp0_layout = Layout_HORIZONTAL_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = prerequisites$factory_1();
    var tmp1_contextLink = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_0);
    var tmp2_separator = separator(',');
    var tmp = getKClass(ProcessPrerequisite_0);
    children_2($this$horizontal, tmp, tmp1_contextLink, VOID, VOID, tmp2_separator, VOID, VOID, tmp0_layout, processLibraryEditors$lambda$lambda$lambda$lambda_8);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_8(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.ic7();
  }
  function processLibraryEditors$lambda$lambda$lambda_4($this$horizontal) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp0_layout = Layout_HORIZONTAL_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = effects$factory_1();
    var tmp1_contextLink = new MultipleChildLink(getKClass(ProcessDeclaration_1), this_0);
    var tmp2_separator = separator(',');
    var tmp = getKClass(ProcessEffect_0);
    children_2($this$horizontal, tmp, tmp1_contextLink, VOID, VOID, tmp2_separator, VOID, VOID, tmp0_layout, processLibraryEditors$lambda$lambda$lambda$lambda_9);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_9(processDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processDeclaration.jc7();
  }
  function processLibraryEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_3($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = $this$childrenRoleDefaults.wp3(Companion_getInstance_209().ccb_1);
    $this$childrenRoleDefaults.zp7(tmp, processLibraryEditors$lambda$lambda_8($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_8($this_childrenRoleDefaults) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessReference($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.jbg().v2c(reference);
      return this_0;
    };
  }
  function processLibraryEditors$lambda_4($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp1 = '<process>';
    var tmp2 = Companion_getInstance_209().ccb_1;
    var tmp3 = processLibraryEditors$lambda$lambda_9;
    var tmp4 = processLibraryEditors$lambda$lambda_10;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var options = new CompletionOptions(VOID, false);
    var containerInit = processLibraryEditors$lambda$lambda_11;
    var textCellInit = processLibraryEditors$lambda$lambda_12;
    var tmp;
    if (tmp4 == null) {
      tmp = processLibraryEditors$lambda$lambda_13;
    } else {
      tmp = tmp4;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda_14(textCellInit);
    var targetClass = getKClass(ProcessDeclaration_1);
    var refCell = referenceTarget($this$editor, targetClass, tmp1, tmp2, tmp3, null, tmp5, options, containerInit, textCellInit_0);
    considerEmptyBy($this$editor, refCell);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_9(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.jbg();
  }
  function processLibraryEditors$lambda$lambda_10(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return !contains_9(it, ',');
  }
  function processLibraryEditors$lambda$lambda_11(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_12(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_13(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda_14($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_5($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_6(context) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return ProcessProperty(context);
  }
  function processLibraryEditors$lambda_7($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = editorString($this$childrenRoleDefaults, BTBEditorParts_getInstance().osj_1);
    $this$childrenRoleDefaults.ap8(tmp, processLibraryEditors$lambda$lambda_15($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_15($this_childrenRoleDefaults) {
    return function (name) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessProperty($this_childrenRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.b3().v2c(name);
      return this_0;
    };
  }
  function processLibraryEditors$lambda_8($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'kotlin.apply' call
    var this_0 = indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_16);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>' call
    mark_0(this_0, get_PROCESS_PROPERTY_CELL_MARK());
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_16($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'kotlin.apply' call
    var this_0 = textProperty_0($this$indent, '<name>', processLibraryEditors$lambda$lambda$lambda_5);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
    mark_0(this_0, BTBEditorParts_getInstance().osj_1);
    var colon = label_0($this$indent, ':', false);
    space_0($this$indent);
    var tmp = getKClass(ProcessPropertyValueRange);
    // Inline function 'kotlin.apply' call
    var this_1 = child_1($this$indent, tmp, processLibraryEditors$lambda$lambda$lambda_6);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
    mark_0(this_1, get_RANGE_CELL_MARK());
    var rangeCell = this_1;
    rightTransform_1($this$indent, colon, processLibraryEditors$lambda$lambda$lambda_7($this$indent, rangeCell));
    space_0($this$indent);
    var tmp5 = getKClass(ProcessPropertyDefault_1);
    var tmp6 = default$factory_1();
    var tmp7 = '<default>';
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = processLibraryEditors$lambda$lambda$lambda_8;
    var placeholderTraitFactory = processLibraryEditors$lambda$lambda$lambda_9;
    var clipboardSetup = processLibraryEditors$lambda$lambda$lambda_10;
    var tmp_0 = processLibraryEditors$lambda$lambda$lambda_11(tmp6);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(ProcessProperty_1), tmp6);
    child_1($this$indent, tmp5, tmp_0, tmp7, placeholderTraitFactory, null, clipboardSetup, null, null, tmp$ret$2, completionSupplier);
    space_0($this$indent);
    label_0($this$indent, 'as');
    space_0($this$indent);
    var aliased;
    var tmp15 = getKClass(ProcessPropertyReference);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.children' call
    var childrenProperty = aliasedProperties$factory_1();
    var placeholderTraitFactory_0 = processLibraryEditors$lambda$lambda$lambda_12;
    var clipboardSetup_0 = processLibraryEditors$lambda$lambda$lambda_13;
    var layout = Layout_INDENT_getInstance();
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp_1 = new MultipleChildLink(getKClass(ProcessProperty_1), childrenProperty);
    // Inline function 'kotlin.also' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
    aliased = children_2($this$indent, tmp15, tmp_1, null, placeholderTraitFactory_0, null, clipboardSetup_0, null, layout, processLibraryEditors$lambda$lambda$lambda_14(childrenProperty));
    ensureLastCaretPosition($this$indent);
    disambiguateBy($this$indent, aliased);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_5(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.b3();
  }
  function processLibraryEditors$lambda$lambda$lambda_6(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.zb3();
  }
  function processLibraryEditors$7$1$2$$inlined$executeQuery$1($this_indent) {
    this.jsr_1 = $this_indent;
  }
  protoOf(processLibraryEditors$7$1$2$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    return builder.n51(this.jsr_1.k6h().zb3());
  };
  function processLibraryEditors$7$1$2$1$$inlined$executeQuery$1($currentType) {
    this.ksr_1 = $currentType;
  }
  protoOf(processLibraryEditors$7$1$2$1$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    var tmp0_safe_receiver = this.ksr_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      var tmp_0 = tmp0_safe_receiver.u6m();
      tmp = isInterface(tmp_0, ProcessPropertyType) ? tmp_0 : THROW_CCE();
    }
    return tmp;
  };
  function processLibraryEditors$lambda$lambda$lambda$lambda$lambda($rangeCell) {
    return function () {
      ensureNotNull(firstFocusable($rangeCell)).ul5();
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_10($this_indent, $currentType, $rangeCell) {
    return function () {
      // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      var tmp$ret$0 = new processLibraryEditors$7$1$2$1$$inlined$executeQuery$1($currentType);
      var type = execute_0(tmp$ret$0);
      // Inline function 'kotlin.apply' call
      var this_0 = MultipleProcessPropertyValueRange(get_internalConfig($this_indent).o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.zb3().v2c(type);
      var multipleRange = this_0;
      $this_indent.k6h().zb3().v2c(multipleRange);
      return processLibraryEditors$lambda$lambda$lambda$lambda$lambda($rangeCell);
    };
  }
  function processLibraryEditors$lambda$lambda$lambda_7($this_indent, $rangeCell) {
    return function ($this$rightTransform, _unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      var tmp$ret$0 = new processLibraryEditors$7$1$2$$inlined$executeQuery$1($this_indent);
      var currentType = execute_0(tmp$ret$0);
      var tmp;
      var tmp_0;
      if (currentType == null) {
        tmp_0 = true;
      } else {
        tmp_0 = !(currentType == null) ? isInterface(currentType, ProcessPropertyType) : false;
      }
      if (tmp_0) {
        $this$rightTransform.tp3('{', processLibraryEditors$lambda$lambda$lambda$lambda_10($this_indent, currentType, $rangeCell));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda$lambda$lambda_8($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = $this$child.bp8(processLibraryEditors$lambda$lambda$lambda$lambda_11);
    $this$child.cp8(tmp, processLibraryEditors$lambda$lambda$lambda$lambda_12($this$child));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_11($this$using) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getAbstractValueCompletion($this$using);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_12($this_child) {
    return function (abstractValue) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessPropertyDefault($this_child.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.y().v2c(abstractValue);
      return this_0;
    };
  }
  function processLibraryEditors$lambda$lambda$lambda_9(_unused_var__etf5q3, trait) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return trait;
  }
  function processLibraryEditors$lambda$lambda$lambda_10(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_11($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function processLibraryEditors$lambda$lambda$lambda_12(_unused_var__etf5q3, trait) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return trait;
  }
  function processLibraryEditors$lambda$lambda$lambda_13(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_14($childrenProperty) {
    return function (it) {
      return $childrenProperty(it);
    };
  }
  function processLibraryEditors$lambda_9($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_10($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    gray(label_0($this$editor, '[default '));
    var tmp1 = getKClass(AbstractValue);
    var tmp2 = value$factory_11();
    var tmp3 = processLibraryEditors$lambda$lambda_17;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = processLibraryEditors$lambda$lambda_18;
    var clipboardSetup = processLibraryEditors$lambda$lambda_19;
    var tmp = processLibraryEditors$lambda$lambda_20(tmp2);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$0 = new SingleChildLink(getKClass(ProcessPropertyDefault_1), tmp2);
    child_1($this$editor, tmp1, tmp, null, tmp3, null, clipboardSetup, null, null, tmp$ret$0, completionSupplier);
    gray(label_0($this$editor, ']'));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_17(_unused_var__etf5q3, trait) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function processLibraryEditors$lambda$lambda_18($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getAbstractValueCompletion($this$child);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_19(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_20($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function processLibraryEditors$lambda_11($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_12($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = $this$childrenRoleDefaults.wp3(Companion_getInstance_211().aca_1);
    $this$childrenRoleDefaults.zp7(tmp, processLibraryEditors$lambda$lambda_21($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_21($this_childrenRoleDefaults) {
    return function (reference) {
      return ProcessPropertyReference_0($this_childrenRoleDefaults.o71(), reference);
    };
  }
  function processLibraryEditors$lambda_13($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_22);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_22($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp1 = '<property>';
    var tmp2 = Companion_getInstance_211().aca_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda$lambda_15;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda$lambda_16;
    var textCellInit = processLibraryEditors$lambda$lambda$lambda_17;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda$lambda_18;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda$lambda_19(textCellInit);
    var targetClass = getKClass(ProcessProperty_1);
    referenceTarget($this$indent, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_15(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.i6u();
  }
  function processLibraryEditors$lambda$lambda$lambda_16(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_17(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_18(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda$lambda_19($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_14($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_15($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    processPropertyTypeCompletion($this$childrenRoleDefaults);
    $this$childrenRoleDefaults.up7('{', processLibraryEditors$lambda$lambda_23($this$childrenRoleDefaults));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_23($this_childrenRoleDefaults) {
    return function () {
      return MultipleProcessPropertyValueRange($this_childrenRoleDefaults.o71());
    };
  }
  function processLibraryEditors$lambda_16($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var multipleOpenBrace = label_0($this$editor, '{ ', VOID, false);
    var tmp = getKClass(ProcessPropertyType);
    var tmp_0 = processLibraryEditors$lambda$lambda_24;
    child_1($this$editor, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, processLibraryEditors$lambda$lambda_25);
    var multipleCloseBrace = label_0($this$editor, ' }', false);
    multipleOpenBrace.olp(new processLibraryEditors$12$BraceDeleteTrait($this$editor));
    multipleCloseBrace.olp(new processLibraryEditors$12$BraceDeleteTrait($this$editor));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_24(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.zb3();
  }
  function processLibraryEditors$lambda$lambda_25($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    processPropertyTypeCompletion($this$child);
    return Unit_instance;
  }
  function processLibraryEditors$12$BraceDeleteTrait$onKeyPressed$$inlined$executeQuery$1($this_editor) {
    this.lsr_1 = $this_editor;
  }
  protoOf(processLibraryEditors$12$BraceDeleteTrait$onKeyPressed$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.BraceDeleteTrait.onKeyPressed.<anonymous>' call
    return builder.n51(this.lsr_1.k6h().zb3());
  };
  function processLibraryEditors$12$BraceDeleteTrait($this_editor) {
    this.msr_1 = $this_editor;
    CellTrait.call(this);
  }
  protoOf(processLibraryEditors$12$BraceDeleteTrait).llm = function (cell, event) {
    if (event.ml1(Key_BACKSPACE_getInstance(), []) || event.ml1(Key_DELETE_getInstance(), [])) {
      // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      var tmp$ret$0 = new processLibraryEditors$12$BraceDeleteTrait$onKeyPressed$$inlined$executeQuery$1(this.msr_1);
      var type = execute_0(tmp$ret$0);
      if (!(type == null)) {
        // Inline function 'kotlin.sequences.find' call
        var tmp0 = ancestors(cell);
        var tmp$ret$3;
        $l$block: {
          // Inline function 'kotlin.sequences.firstOrNull' call
          var _iterator__ex2g4s = tmp0.k();
          while (_iterator__ex2g4s.l()) {
            var element = _iterator__ex2g4s.m();
            // Inline function 'jetbrains.biokb.lang.editorBuilders.BraceDeleteTrait.onKeyPressed.<anonymous>' call
            if (get_PROCESS_PROPERTY_CELL_MARK().opo(element)) {
              tmp$ret$3 = element;
              break $l$block;
            }
          }
          tmp$ret$3 = null;
        }
        var parentCell = tmp$ret$3;
        this.msr_1.k6h().s6m(type.u6m());
        var tmp1_safe_receiver = parentCell == null ? null : find_2(parentCell, get_RANGE_CELL_MARK());
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : firstFocusable(tmp1_safe_receiver);
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.ul5();
        }
        event.ol0();
        return Unit_instance;
      }
    }
    protoOf(CellTrait).llm.call(this, cell, event);
  };
  function processLibraryEditors$lambda_17($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_18($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    processPropertyTypeCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_19($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    deleteIfEmpty($this$editor);
    var refCell = {_v: null};
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_26(refCell));
    var tmp;
    if (refCell._v == null) {
      throwUninitializedPropertyAccessException('refCell');
    } else {
      tmp = refCell._v;
    }
    considerEmptyBy($this$editor, tmp);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_20(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.lbp();
  }
  function processLibraryEditors$lambda$lambda$lambda_21($this$btbReferenceTarget) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    $this$btbReferenceTarget.ypn().jlu().v2c(true);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_22(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_23(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda$lambda_24($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda$lambda_26($refCell) {
    return function ($this$indent) {
      var tmp1 = '<notion>';
      var tmp2 = Companion_getInstance_220().ybo_1;
      var tmp3 = processLibraryEditors$lambda$lambda$lambda_20;
      // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
      var textCellInit = processLibraryEditors$lambda$lambda$lambda_21;
      var options = new CompletionOptions();
      var containerInit = processLibraryEditors$lambda$lambda$lambda_22;
      var tmp;
      if (null == null) {
        tmp = processLibraryEditors$lambda$lambda$lambda_23;
      } else {
        tmp = null;
      }
      var tmp5 = tmp;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
      var textCellInit_0 = processLibraryEditors$lambda$lambda$lambda_24(textCellInit);
      var targetClass = getKClass(AbstractNotion);
      var tmp$ret$1 = referenceTarget($this$indent, targetClass, tmp1, tmp2, tmp3, null, tmp5, options, containerInit, textCellInit_0);
      $refCell._v = tmp$ret$1;
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_20($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_21($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    editableText_0($this$editor, VOID, '<spec>', VOID, VOID, processLibraryEditors$lambda$lambda_27);
    var openingParen = indentLabel_0($this$editor, '(');
    var tmp = getKClass(OntologyLibraryReference_1);
    child_1($this$editor, tmp, processLibraryEditors$lambda$lambda_28);
    indentLabel_0($this$editor, '/');
    var tmp_0 = getKClass(OntologyElementReference_1);
    child_1($this$editor, tmp_0, processLibraryEditors$lambda$lambda_29);
    closingFor(indentLabel_0($this$editor, ')'), openingParen);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_27($this$editableText) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call
    var targetPropFactory = processLibraryEditors$lambda$lambda$lambda_25;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>' call
    var sourceProp = $this$editableText.k6h().sba();
    var targetProp = targetPropFactory($this$editableText.ypn());
    $this$editableText.wle(syncTwoWay(sourceProp.n4z(), targetProp));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_25(textCell) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_11();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.en4(textCell, enumInfo);
  }
  function processLibraryEditors$lambda$lambda_28(elementType) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return elementType.kay();
  }
  function processLibraryEditors$lambda$lambda_29(elementType) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return elementType.lay();
  }
  function processLibraryEditors$lambda_22($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_23(wrapperContext) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return EmptyBindingEntry(wrapperContext);
  }
  function processLibraryEditors$lambda_24($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getAbstractBindingEntryCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_25($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(PropertyDeclaration_1);
    child_1($this$editor, tmp, processLibraryEditors$lambda$lambda_30);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_30(bindingProperty) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return bindingProperty.i6u();
  }
  function processLibraryEditors$lambda_26($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_27($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(LinkDeclaration_1);
    child_1($this$editor, tmp, processLibraryEditors$lambda$lambda_31);
    space_0($this$editor);
    keyword_0($this$editor, 'from');
    space_0($this$editor);
    var tmp_0 = getKClass(OntologyLibraryReference_1);
    child_1($this$editor, tmp_0, processLibraryEditors$lambda$lambda_32, '<default>');
    optionalSpecializedLink($this$editor);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_31(ontologyLink) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return ontologyLink.pbh();
  }
  function processLibraryEditors$lambda$lambda_32(ontologyLink) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return ontologyLink.uc1();
  }
  function processLibraryEditors$lambda_28($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_29($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_33);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_33($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp1 = '<property>';
    var tmp2 = Companion_getInstance_214().nbd_1;
    var tmp3 = processLibraryEditors$lambda$lambda$lambda_26;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var containerInit = processLibraryEditors$lambda$lambda$lambda_27;
    var options = new CompletionOptions();
    var textCellInit = processLibraryEditors$lambda$lambda$lambda_28;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda$lambda_29;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda$lambda_30(textCellInit);
    var targetClass = getKClass(PropertyDeclaration_1);
    referenceTarget($this$indent, targetClass, tmp1, tmp2, tmp3, null, tmp5, options, containerInit, textCellInit_0);
    ensureLastCaretPosition($this$indent);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_26(importedProperty) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return importedProperty.mbd();
  }
  function processLibraryEditors$lambda$lambda$lambda_27($this$btbReferenceTarget) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    space_0($this$btbReferenceTarget);
    gray(label_0($this$btbReferenceTarget, '('));
    gray(label_0($this$btbReferenceTarget, 'type:'));
    space_0($this$btbReferenceTarget);
    var tmp = getKClass(NotionType_0);
    child_1($this$btbReferenceTarget, tmp, processLibraryEditors$lambda$lambda$lambda$lambda_13);
    gray(label_0($this$btbReferenceTarget, ')'));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_13(property) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return property.zb3();
  }
  function processLibraryEditors$lambda$lambda$lambda_28(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_29(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda$lambda_30($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_30($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_31($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp2 = Companion_getInstance_202().zbc_1;
    var tmp3 = processLibraryEditors$lambda$lambda_34;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var containerInit = processLibraryEditors$lambda$lambda_35;
    var options = new CompletionOptions();
    var textCellInit = processLibraryEditors$lambda$lambda_36;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda_37;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda_38(textCellInit);
    var targetClass = getKClass(LinkDeclaration_1);
    referenceTarget($this$editor, targetClass, '<link>', tmp2, tmp3, null, tmp5, options, containerInit, textCellInit_0);
    optionalSpecializedLink($this$editor);
    ensureLastCaretPosition($this$editor);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_34(importedLink) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return importedLink.mbd();
  }
  function processLibraryEditors$lambda$lambda_35($this$btbReferenceTarget) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    space_0($this$btbReferenceTarget);
    gray(label_0($this$btbReferenceTarget, '('));
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    editableText_0($this$btbReferenceTarget, VOID, '<spec>', VOID, VOID, processLibraryEditors$lambda$lambda$lambda_31);
    space_0($this$btbReferenceTarget);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$btbReferenceTarget, tmp, processLibraryEditors$lambda$lambda$lambda_32);
    gray(label_0($this$btbReferenceTarget, ')'));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_31($this$editableText) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call
    var targetPropFactory = processLibraryEditors$lambda$lambda$lambda$lambda_14;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
    var sourceProp = $this$editableText.k6h().sba();
    var targetProp = targetPropFactory($this$editableText.ypn());
    $this$editableText.wle(syncTwoWay(sourceProp.n4z(), targetProp));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda$lambda_14(textCell) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_11();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.en4(textCell, enumInfo);
  }
  function processLibraryEditors$lambda$lambda$lambda_32(linkDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return linkDeclaration.zb3();
  }
  function processLibraryEditors$lambda$lambda_36(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_37(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda_38($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_32($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_33($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_39);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_39($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    placeholderInCollection_0($this$indent, VOID, processLibraryEditors$lambda$lambda$lambda_33);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_33($this$placeholderInCollection) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getAbstractBindingEntryCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_34($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_35($this$childRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    libraryProcessSpecificationCompletion($this$childRoleDefaults);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_36(wrapperContext) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return LibraryProcessSpecification(wrapperContext);
  }
  function processLibraryEditors$lambda_37($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getBindingValueCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_38($this$childRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getBindingValueCompletion($this$childRoleDefaults);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_39($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp1 = '<property>';
    var tmp2 = Companion_getInstance_192().nca_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda_40;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda_41;
    var textCellInit = processLibraryEditors$lambda$lambda_42;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda_43;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda_44(textCellInit);
    var targetClass = getKClass(ProcessProperty_1);
    referenceTarget($this$editor, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    space_0($this$editor);
    var equalsLabel = label_0($this$editor, '=');
    space_0($this$editor);
    var indent = indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_45(equalsLabel));
    mark_0(indent, get_QUERY_LABELS_CONTAINER_MARK());
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_40(propertyValue) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return propertyValue.i6u();
  }
  function processLibraryEditors$lambda$lambda_41(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_42(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_43(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda_44($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda$lambda$lambda_34(_unused_var__etf5q3, trait) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function processLibraryEditors$lambda$lambda$lambda_35(wrapperContext) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'kotlin.apply' call
    var this_0 = MeasurableValue(wrapperContext);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    this_0.fd2(0);
    return this_0;
  }
  function processLibraryEditors$lambda$lambda$lambda_36($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getAbstractValueCompletion($this$child);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_45($equalsLabel) {
    return function ($this$indent) {
      queryLabelsCell($this$indent);
      // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
      var this_0 = value$factory_12();
      var tmp0_contextLink = new SingleChildLink(getKClass(ProcessPropertyValue_1), this_0);
      var tmp = getKClass(AbstractValue);
      var tmp_0 = value$factory_13();
      var tmp_1 = processLibraryEditors$lambda$lambda$lambda_34;
      var tmp_2 = processLibraryEditors$lambda$lambda$lambda_35;
      var value = child_1($this$indent, tmp, tmp_0, VOID, tmp_1, tmp_2, VOID, VOID, VOID, tmp0_contextLink, processLibraryEditors$lambda$lambda$lambda_36);
      var setQueriesLabelRightTransform = setQueryLabelRightTransform($this$indent.k6h());
      rightTransform_1($this$indent, value, setQueriesLabelRightTransform);
      rightTransform_1($this$indent, $equalsLabel, setQueriesLabelRightTransform);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_40($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_41($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp1 = '<property>';
    var tmp2 = Companion_getInstance_213().agd_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda_46;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda_47;
    var textCellInit = processLibraryEditors$lambda$lambda_48;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda_49;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda_50(textCellInit);
    var targetClass = getKClass(AbstractProperty);
    referenceTarget($this$editor, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    space_0($this$editor);
    label_0($this$editor, '=');
    space_0($this$editor);
    var tmp10 = getKClass(AbstractValue);
    var tmp11 = value$factory_14();
    var tmp12 = processLibraryEditors$lambda$lambda_51;
    var tmp13 = processLibraryEditors$lambda$lambda_52;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.child' call
    var completionSupplier = processLibraryEditors$lambda$lambda_53;
    var clipboardSetup = processLibraryEditors$lambda$lambda_54;
    var tmp_0 = processLibraryEditors$lambda$lambda_55(tmp11);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var tmp$ret$2 = new SingleChildLink(getKClass(PropertyValue_1), tmp11);
    child_1($this$editor, tmp10, tmp_0, null, tmp12, tmp13, clipboardSetup, null, null, tmp$ret$2, completionSupplier);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_46(propertyValue) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return propertyValue.i6u();
  }
  function processLibraryEditors$lambda$lambda_47(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_48(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_49(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda_50($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda$lambda_51(_unused_var__etf5q3, trait) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function processLibraryEditors$lambda$lambda_52(wrapperContext) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    // Inline function 'kotlin.apply' call
    var this_0 = MeasurableValue(wrapperContext);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.processLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
    this_0.fd2(0);
    return this_0;
  }
  function processLibraryEditors$lambda$lambda_53($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getAbstractValueCompletion($this$child);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_54(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_55($childProperty) {
    return function (it) {
      return $childProperty(it);
    };
  }
  function processLibraryEditors$lambda_42($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_43($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp2 = Companion_getInstance_201().aat_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda_56;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda_57;
    var textCellInit = processLibraryEditors$lambda$lambda_58;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda_59;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda_60(textCellInit);
    var targetClass = getKClass(AbstractLink);
    referenceTarget($this$editor, targetClass, '<link>', tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    space_0($this$editor);
    label_0($this$editor, '=');
    space_0($this$editor);
    var tmp_0 = getKClass(AbstractValue);
    var tmp_1 = processLibraryEditors$lambda$lambda_61;
    child_1($this$editor, tmp_0, tmp_1, VOID, processLibraryEditors$lambda$lambda_62);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_56(ontologyLinkValue) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return ontologyLinkValue.wc2();
  }
  function processLibraryEditors$lambda$lambda_57(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_58(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_59(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda_60($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda$lambda_61(ontologyLinkValue) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return ontologyLinkValue.y();
  }
  function processLibraryEditors$lambda$lambda_62(_unused_var__etf5q3, trait) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function processLibraryEditors$lambda_44($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_45($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_63);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_63($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    placeholderInCollection_0($this$indent, '<argument>', processLibraryEditors$lambda$lambda$lambda_37);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_37($this$placeholderInCollection) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getBindingValueCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_46($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_47($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(PropertyLibraryElement);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, processLibraryEditors$lambda$lambda_64);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_64(propertyLibrary) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return propertyLibrary.sc0();
  }
  function processLibraryEditors$lambda_48($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_49(wc) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return EmptyPropertyLibraryElement(wc);
  }
  function processLibraryEditors$lambda_50($this$childrenRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    propertyDeclarationByNotionCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_51($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    placeholderInCollection_0($this$editor, VOID, processLibraryEditors$lambda$lambda_65);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_65($this$placeholderInCollection) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    propertyDeclarationByNotionCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_52($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_53($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = getKClass(ProcessKind_1);
    children_2($this$editor, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, processLibraryEditors$lambda$lambda_66);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_66(processKindContainer) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processKindContainer.wc7();
  }
  function processLibraryEditors$lambda_54($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_55($this$childRoleDefaults) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp = $this$childRoleDefaults.wp3(Companion_getInstance_196().ab4_1);
    $this$childRoleDefaults.zp7(tmp, processLibraryEditors$lambda$lambda_67($this$childRoleDefaults));
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_67($this_childRoleDefaults) {
    return function (reference) {
      return ExtensionFieldReference_2($this_childRoleDefaults.o71(), reference);
    };
  }
  function processLibraryEditors$lambda_56($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_68);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_68($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var tmp2 = Companion_getInstance_196().ab4_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = processLibraryEditors$lambda$lambda$lambda_38;
    var options = new CompletionOptions();
    var containerInit = processLibraryEditors$lambda$lambda$lambda_39;
    var textCellInit = processLibraryEditors$lambda$lambda$lambda_40;
    var tmp;
    if (null == null) {
      tmp = processLibraryEditors$lambda$lambda$lambda_41;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = processLibraryEditors$lambda$lambda$lambda_42(textCellInit);
    var targetClass = getKClass(FieldDeclaration_1);
    referenceTarget($this$indent, targetClass, '<field>', tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_38(extensionFieldReference) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return extensionFieldReference.nb4();
  }
  function processLibraryEditors$lambda$lambda$lambda_39(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_40(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_41(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function processLibraryEditors$lambda$lambda$lambda_42($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function processLibraryEditors$lambda_57($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_58($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_69);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_69($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    textProperty_0($this$indent, '<name>', processLibraryEditors$lambda$lambda$lambda_43);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_43(processKind) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return processKind.b3();
  }
  function processLibraryEditors$lambda_59($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_60($this$processFactorEditor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    processPrerequisiteCompletion($this$processFactorEditor);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_61($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var indent = indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_70);
    mark_0(indent, get_QUERY_LABELS_CONTAINER_MARK());
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_70($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    queryLabelsCell($this$indent);
    var tmp = getKClass(FactExpression);
    var tmp_0 = processLibraryEditors$lambda$lambda$lambda_44;
    var expressionCell = child_1($this$indent, tmp, tmp_0, '<expression>', VOID, VOID, VOID, VOID, VOID, VOID, processLibraryEditors$lambda$lambda$lambda_45);
    var setQueriesLabelRightTransform = setQueryLabelRightTransform($this$indent.k6h(), false);
    rightTransform_1($this$indent, expressionCell, setQueriesLabelRightTransform);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_44(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.lbb();
  }
  function processLibraryEditors$lambda$lambda$lambda_45($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    factExpressionCompletion($this$child);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_62($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function processLibraryEditors$lambda_63($this$processFactorEditor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    processEffectCompletion($this$processFactorEditor);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_64($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    var indent = indent_0($this$editor, VOID, VOID, processLibraryEditors$lambda$lambda_71);
    mark_0(indent, get_QUERY_LABELS_CONTAINER_MARK());
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda_71($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    queryLabelsCell($this$indent);
    var tmp = getKClass(FactExpression);
    var tmp_0 = processLibraryEditors$lambda$lambda$lambda_46;
    var expressionCell = child_1($this$indent, tmp, tmp_0, '<expression>', VOID, VOID, VOID, VOID, VOID, VOID, processLibraryEditors$lambda$lambda$lambda_47);
    var setQueriesLabelRightTransform = setQueryLabelRightTransform($this$indent.k6h(), false);
    rightTransform_1($this$indent, expressionCell, setQueriesLabelRightTransform);
    return Unit_instance;
  }
  function processLibraryEditors$lambda$lambda$lambda_46(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return it.lbb();
  }
  function processLibraryEditors$lambda$lambda$lambda_47($this$child) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    factExpressionCompletion($this$child);
    return Unit_instance;
  }
  function processLibraryEditors$lambda_65($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function libraryProcessSpecificationEditor$slambda$lambda(processSpecification) {
    return processSpecification.jbg();
  }
  function libraryProcessSpecificationEditor$slambda$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function libraryProcessSpecificationEditor$slambda$lambda_1(_this__u8e3s4) {
    return Unit_instance;
  }
  function libraryProcessSpecificationEditor$slambda$lambda_2(it) {
    return true;
  }
  function libraryProcessSpecificationEditor$slambda$lambda_3($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function libraryProcessSpecificationEditor$slambda$lambda_4(processSpecification) {
    return processSpecification.tba();
  }
  function libraryProcessSpecificationEditor$slambda$lambda_5($closingParen, $this_asyncInvalidatingEditor) {
    return function (_unused_var__etf5q3, event) {
      var tmp;
      if (event.ml1(Key_ENTER_getInstance(), [])) {
        if ($closingParen.qlp().m2c() && $closingParen.dlu()) {
          // Inline function 'jetbrains.ocelot.langDef.structure.NodeFactory.create' call
          var bindingValuePlaceholder = get_internalConfig($this_asyncInvalidatingEditor).sps().y6z(getKClass(BindingValuePlaceholder_1));
          $this_asyncInvalidatingEditor.k6h().tba().e(bindingValuePlaceholder);
        }
        var tmp_0;
        if (!($closingParen.qlp().m2c() && $closingParen.blu())) {
          event.ol0();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      var params = $this_asyncInvalidatingEditor.k6h().tba().n4z();
      var tmp_1;
      var tmp_2;
      if (event.ml1(Key_BACKSPACE_getInstance(), []) && $closingParen.qlp().m2c() && $closingParen.dlu()) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_2 = !params.p();
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        params.q2(get_lastIndex_2(params));
        event.ol0();
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function libraryProcessSpecificationEditor$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(libraryProcessSpecificationEditor$slambda).ysr = function ($this$asyncInvalidatingEditor, $completion) {
    var tmp = this.zsr($this$asyncInvalidatingEditor, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(libraryProcessSpecificationEditor$slambda).oa = function (p1, $completion) {
    return this.ysr(p1 instanceof InvalidatingEditorBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(libraryProcessSpecificationEditor$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.wsr_1 = false;
            this.y9_1 = 1;
            suspendResult = this.vsr_1.m51(this.vsr_1.k6h().jbg().o6s(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.xsr_1 = suspendResult;
            if (!(this.xsr_1 == null)) {
              this.y9_1 = 2;
              suspendResult = showCustomEditor(this.vsr_1, this.xsr_1, this.vsr_1.k6h().tba(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.y9_1 = 3;
              continue $sm;
            }

          case 2:
            this.wsr_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            if (!this.wsr_1) {
              var tmp0 = this.vsr_1;
              var tmp1 = '<process>';
              var tmp2 = Companion_getInstance_208().kc6_1;
              var referenceProvider = libraryProcessSpecificationEditor$slambda$lambda;
              var options = new CompletionOptions();
              var containerInit = libraryProcessSpecificationEditor$slambda$lambda_0;
              var textCellInit = libraryProcessSpecificationEditor$slambda$lambda_1;
              var tmp_0;
              if (null == null) {
                tmp_0 = libraryProcessSpecificationEditor$slambda$lambda_2;
              } else {
                tmp_0 = null;
              }
              var tmp5 = tmp_0;
              var textCellInit_0 = libraryProcessSpecificationEditor$slambda$lambda_3(textCellInit);
              var targetClass = getKClass(ProcessDeclaration_1);
              referenceTarget(tmp0, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
              indentLabel_0(this.vsr_1, '(');
              var tmp_1 = getKClass(BindingValuePlaceholder_1);
              children_2(this.vsr_1, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, libraryProcessSpecificationEditor$slambda$lambda_4);
              var closingParen = indentLabel_0(this.vsr_1, ')', true);
              this.vsr_1.aps(libraryProcessSpecificationEditor$slambda$lambda_5(closingParen, this.vsr_1));
            }

            return Unit_instance;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(libraryProcessSpecificationEditor$slambda).zsr = function ($this$asyncInvalidatingEditor, completion) {
    var i = new libraryProcessSpecificationEditor$slambda(completion);
    i.vsr_1 = $this$asyncInvalidatingEditor;
    return i;
  };
  function libraryProcessSpecificationEditor$slambda_0(resultContinuation) {
    var i = new libraryProcessSpecificationEditor$slambda(resultContinuation);
    var l = function ($this$asyncInvalidatingEditor, $completion) {
      return i.ysr($this$asyncInvalidatingEditor, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function libraryProcessSpecificationEditor$lambda$slambda($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation) {
    this.iss_1 = $this_EditorDefinition;
    this.jss_1 = $init;
    this.kss_1 = $invalidator;
    this.lss_1 = $invalidated;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(libraryProcessSpecificationEditor$lambda$slambda).dag = function ($completion) {
    var tmp = this.eag($completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(libraryProcessSpecificationEditor$lambda$slambda).fag = function ($completion) {
    return this.dag($completion);
  };
  protoOf(libraryProcessSpecificationEditor$lambda$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 6;
            this.z9_1 = 5;
            this.mss_1 = new Invalidator();
            this.nss_1 = this.iss_1.bps(this.mss_1);
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.z9_1 = 4;
            this.y9_1 = 2;
            suspendResult = this.jss_1(this.nss_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.oss_1 = suspendResult;
            this.y9_1 = 3;
            continue $sm;
          case 3:
            this.z9_1 = 5;
            affects(this.mss_1.p4w(Unit_instance), this.kss_1);
            this.z9_1 = 6;
            this.y9_1 = 7;
            continue $sm;
          case 4:
            this.z9_1 = 5;
            var t = this.ba_1;
            affects(this.mss_1.p4w(Unit_instance), this.kss_1);
            throw t;
          case 5:
            this.z9_1 = 6;
            var tmp_0 = this.ba_1;
            if (tmp_0 instanceof AlreadyInvalidException) {
              var e = this.ba_1;
              this.lss_1.t2c(true);
              this.y9_1 = 7;
              continue $sm;
            } else {
              throw this.ba_1;
            }

          case 6:
            throw this.ba_1;
          case 7:
            this.z9_1 = 6;
            return Unit_instance;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.z9_1 === 6) {
          throw e_0;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(libraryProcessSpecificationEditor$lambda$slambda).eag = function (completion) {
    return new libraryProcessSpecificationEditor$lambda$slambda(this.iss_1, this.jss_1, this.kss_1, this.lss_1, completion);
  };
  function libraryProcessSpecificationEditor$lambda$slambda_0($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation) {
    var i = new libraryProcessSpecificationEditor$lambda$slambda($this_EditorDefinition, $init, $invalidator, $invalidated, resultContinuation);
    var l = function ($completion) {
      return i.dag($completion);
    };
    l.$arity = 0;
    return l;
  }
  function libraryProcessSpecificationEditor$lambda($init) {
    return function ($this$EditorDefinition) {
      var invalidator = new Invalidator();
      var invalidated = new ValueProperty(false);
      depend(invalidator, invalidated);
      $this$EditorDefinition.cps(libraryProcessSpecificationEditor$lambda$slambda_0($this$EditorDefinition, $init, invalidator, invalidated, null));
      return invalidator.p4w(Unit_instance);
    };
  }
  function libraryProcessSpecificationCompletion$lambda($this_libraryProcessSpecificationCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = LibraryProcessSpecification($this_libraryProcessSpecificationCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.libraryProcessSpecificationCompletion.<anonymous>.<anonymous>' call
      this_0.jbg().v2c(reference);
      return this_0;
    };
  }
  function getAbstractBindingEntryCompletion$lambda($this$using) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    ontologyElementTypeCompletion_0($this$using);
    return Unit_instance;
  }
  function getAbstractBindingEntryCompletion$lambda_0($this_getAbstractBindingEntryCompletion) {
    return function (elementType) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLink($this_getAbstractBindingEntryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.getAbstractBindingEntryCompletion.<anonymous>.<anonymous>' call
      var tmp = this_0.pbh();
      // Inline function 'kotlin.apply' call
      var this_1 = LinkDeclaration($this_getAbstractBindingEntryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.getAbstractBindingEntryCompletion.<anonymous>.<anonymous>.<anonymous>' call
      this_1.zb3().v2c(elementType);
      tmp.v2c(this_1);
      return this_0;
    };
  }
  function getAbstractBindingEntryCompletion$lambda_1($this$using) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    propertyDeclarationByNotionCompletion($this$using);
    return Unit_instance;
  }
  function getAbstractBindingEntryCompletion$lambda_2($this_getAbstractBindingEntryCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = BindingProperty($this_getAbstractBindingEntryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.getAbstractBindingEntryCompletion.<anonymous>.<anonymous>' call
      this_0.i6u().v2c(it);
      return this_0;
    };
  }
  function getAbstractBindingEntryCompletion$lambda_3($this_getAbstractBindingEntryCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = ImportedLink($this_getAbstractBindingEntryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.getAbstractBindingEntryCompletion.<anonymous>.<anonymous>' call
      this_0.mbd().v2c(reference);
      return this_0;
    };
  }
  function getAbstractBindingEntryCompletion$lambda_4($this_getAbstractBindingEntryCompletion) {
    return function (refId) {
      // Inline function 'kotlin.apply' call
      var this_0 = ImportedProperty($this_getAbstractBindingEntryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.getAbstractBindingEntryCompletion.<anonymous>.<anonymous>' call
      this_0.mbd().v2c(refId);
      return this_0;
    };
  }
  function optionalSpecializedLink$lambda($this$indent) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    space_0($this$indent);
    keyword_0($this$indent, 'specializes');
    space_0($this$indent);
    var tmp2 = Companion_getInstance_201().aat_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = optionalSpecializedLink$lambda$lambda;
    var options = new CompletionOptions();
    var containerInit = optionalSpecializedLink$lambda$lambda_0;
    var textCellInit = optionalSpecializedLink$lambda$lambda_1;
    var tmp;
    if (null == null) {
      tmp = optionalSpecializedLink$lambda$lambda_2;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = optionalSpecializedLink$lambda$lambda_3(textCellInit);
    var targetClass = getKClass(AbstractLink);
    referenceTarget($this$indent, targetClass, '<link>', tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    return Unit_instance;
  }
  function optionalSpecializedLink$lambda$lambda(importedLink) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return importedLink.jat();
  }
  function optionalSpecializedLink$lambda$lambda_0(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function optionalSpecializedLink$lambda$lambda_1(_this__u8e3s4) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return Unit_instance;
  }
  function optionalSpecializedLink$lambda$lambda_2(it) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return true;
  }
  function optionalSpecializedLink$lambda$lambda_3($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function optionalSpecializedLink$$inlined$forDisposable$1($this_optionalSpecializedLink, $specializedCell) {
    this.qss_1 = $this_optionalSpecializedLink;
    this.rss_1 = $specializedCell;
    DisposableSynchronizer.call(this);
  }
  protoOf(optionalSpecializedLink$$inlined$forDisposable$1).dlb = function (ctx) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.optionalSpecializedLink.<anonymous>' call
    return PropertyBinding_instance.d2g(get_asProperty(shouldShowSpecialized(this.qss_1.k6h())), this.rss_1.elp());
  };
  function _get_propertyDeclarationEditor_$lambda_j0iclw($this$editor) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    textProperty_0($this$editor, '<name>', _get_propertyDeclarationEditor_$lambda$lambda_u0vjcv);
    label_0($this$editor, ':');
    space_0($this$editor);
    var tmp = getKClass(NotionType_0);
    child_1($this$editor, tmp, _get_propertyDeclarationEditor_$lambda$lambda_u0vjcv_0);
    return Unit_instance;
  }
  function _get_propertyDeclarationEditor_$lambda$lambda_u0vjcv(propertyDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return propertyDeclaration.b3();
  }
  function _get_propertyDeclarationEditor_$lambda$lambda_u0vjcv_0(propertyDeclaration) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    return propertyDeclaration.zb3();
  }
  function _get_propertyDeclarationEditor_$lambda_j0iclw_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function getBindingValueCompletion$lambda($this_getBindingValueCompletion) {
    return function (refId) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyValue($this_getBindingValueCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.getBindingValueCompletion.<anonymous>.<anonymous>' call
      this_0.i6u().t6s(refId);
      return this_0;
    };
  }
  function getBindingValueCompletion$lambda_0($this_getBindingValueCompletion) {
    return function (refId) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLinkValue($this_getBindingValueCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.getBindingValueCompletion.<anonymous>.<anonymous>' call
      this_0.wc2().t6s(refId);
      return this_0;
    };
  }
  function getBindingValueCompletion$lambda_1($this_getBindingValueCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessPropertyValue($this_getBindingValueCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.getBindingValueCompletion.<anonymous>.<anonymous>' call
      this_0.i6u().t6s(reference);
      return this_0;
    };
  }
  function propertyDeclarationByNotionCompletion$lambda($this$using) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    getNotionTypeCompletion($this$using);
    return Unit_instance;
  }
  function propertyDeclarationByNotionCompletion$lambda_0($this_propertyDeclarationByNotionCompletion) {
    return function (notionType) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyDeclaration($this_propertyDeclarationByNotionCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.propertyDeclarationByNotionCompletion.<anonymous>.<anonymous>' call
      this_0.zb3().v2c(notionType);
      return this_0;
    };
  }
  function processPrerequisiteCompletion$lambda($this$using) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    factExpressionCompletion($this$using);
    return Unit_instance;
  }
  function processPrerequisiteCompletion$lambda_0($this_processPrerequisiteCompletion) {
    return function (expression) {
      return ProcessPrerequisite_1($this_processPrerequisiteCompletion.o71(), expression);
    };
  }
  function processEffectCompletion$lambda($this$using) {
    _init_properties_ProcessLibraryEditors_kt__8wzws8();
    factExpressionCompletion($this$using);
    return Unit_instance;
  }
  function processEffectCompletion$lambda_0($this_processEffectCompletion) {
    return function (expression) {
      return ProcessEffect_1($this_processEffectCompletion.o71(), expression);
    };
  }
  function simplePropertyTypeCompletion$lambda($this_simplePropertyTypeCompletion) {
    return function (reference) {
      return SimplePropertyType_0($this_simplePropertyTypeCompletion.o71(), reference);
    };
  }
  function ontologyElementPropertyTypeCompletion$lambda($this_ontologyElementPropertyTypeCompletion) {
    return function (spec) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementPropertyType($this_ontologyElementPropertyTypeCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.ontologyElementPropertyTypeCompletion.<anonymous>.<anonymous>' call
      this_0.sba().v2c(spec);
      this_0.kay().t2c(OntologyLibraryReference($this_ontologyElementPropertyTypeCompletion.o71()));
      this_0.lay().t2c(OntologyElementReference($this_ontologyElementPropertyTypeCompletion.o71()));
      return this_0;
    };
  }
  function ontologyElementPropertyTypeCompletion$lambda_0($createPropertyTypeNode) {
    return function () {
      return $createPropertyTypeNode(LinkTypeSpecificator_TYPE_OF_getInstance());
    };
  }
  function ontologyElementPropertyTypeCompletion$lambda_1($createPropertyTypeNode) {
    return function () {
      return $createPropertyTypeNode(LinkTypeSpecificator_INSTANCE_OF_getInstance());
    };
  }
  function shouldShowSpecialized$$inlined$query$1($this_shouldShowSpecialized) {
    this.sss_1 = $this_shouldShowSpecialized;
  }
  protoOf(shouldShowSpecialized$$inlined$query$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.shouldShowSpecialized.<anonymous>' call
    // Inline function 'jetbrains.ocelot.langDef.structure.ancestorOrSelf' call
    var this_0 = this.sss_1;
    var tmp$ret$0 = ancestorOrSelf(this_0, getKClass(ProcessDeclaration_1));
    var process = builder.n51(tmp$ret$0);
    return process == null || !(builder.n51(process.gc7().r6s()) == null);
  };
  function inherited$factory_2() {
    return getPropertyCallableRef('inherited', 1, KProperty1, function (receiver) {
      return receiver.hc7();
    }, null);
  }
  function prerequisites$factory_1() {
    return getPropertyCallableRef('prerequisites', 1, KProperty1, function (receiver) {
      return receiver.ic7();
    }, null);
  }
  function effects$factory_1() {
    return getPropertyCallableRef('effects', 1, KProperty1, function (receiver) {
      return receiver.jc7();
    }, null);
  }
  function default$factory_1() {
    return getPropertyCallableRef('default', 1, KProperty1, function (receiver) {
      return receiver.g2o();
    }, null);
  }
  function aliasedProperties$factory_1() {
    return getPropertyCallableRef('aliasedProperties', 1, KProperty1, function (receiver) {
      return receiver.ac9();
    }, null);
  }
  function value$factory_11() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function value$factory_12() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function value$factory_13() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function value$factory_14() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  var properties_initialized_ProcessLibraryEditors_kt_qj0mvq;
  function _init_properties_ProcessLibraryEditors_kt__8wzws8() {
    if (!properties_initialized_ProcessLibraryEditors_kt_qj0mvq) {
      properties_initialized_ProcessLibraryEditors_kt_qj0mvq = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = processLibraryEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(ProcessLibrary_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, processLibraryEditors$lambda_0(init));
      var tmp6 = '<process declarations>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var separator_0 = get_blankLines(3);
      var tmp11 = new ChildrenRoleDefaults(getKClass(ProcessDeclaration_1), tmp6, null, separator_0, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = processLibraryEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(ProcessDeclaration_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp11, null, false, true, triggerDependencies_0, processLibraryEditors$lambda_2(init_0));
      var tmp17 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = processLibraryEditors$lambda_3;
      var tmp22 = new ChildrenRoleDefaults(getKClass(ProcessReference_1), '<empty>', null, tmp17, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = processLibraryEditors$lambda_4;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(ProcessReference_1);
      var tmp_4 = new EditorDefinition(tmp_3, tmp22, null, false, true, triggerDependencies_1, processLibraryEditors$lambda_5(init_1));
      var tmp28 = '<properties>';
      var tmp29 = processLibraryEditors$lambda_6;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_0 = processLibraryEditors$lambda_7;
      var separator_1 = get_defaultChildrenSeparator();
      var tmp33 = new ChildrenRoleDefaults(getKClass(ProcessProperty_1), tmp28, tmp29, separator_1, completionSupplier_0, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = processLibraryEditors$lambda_8;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(ProcessProperty_1);
      var tmp_6 = new EditorDefinition(tmp_5, tmp33, null, false, true, triggerDependencies_2, processLibraryEditors$lambda_9(init_2));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = processLibraryEditors$lambda_10;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(ProcessPropertyDefault_1);
      var tmp_8 = new EditorDefinition(tmp_7, null, null, false, true, triggerDependencies_3, processLibraryEditors$lambda_11(init_3));
      var tmp46 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_1 = processLibraryEditors$lambda_12;
      var tmp50 = new ChildrenRoleDefaults(getKClass(ProcessPropertyReference), '<...>', null, tmp46, completionSupplier_1, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = processLibraryEditors$lambda_13;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(ProcessPropertyReference);
      var tmp_10 = new EditorDefinition(tmp_9, tmp50, null, false, true, triggerDependencies_4, processLibraryEditors$lambda_14(init_4));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_2 = processLibraryEditors$lambda_15;
      var separator_2 = get_defaultChildrenSeparator();
      var tmp86 = new ChildrenRoleDefaults(getKClass(ProcessPropertyValueRange), '<type>', null, separator_2, completionSupplier_2, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_5 = processLibraryEditors$lambda_16;
      var triggerDependencies_5 = emptyList();
      var tmp_11 = getKClass(MultipleProcessPropertyValueRange_1);
      var tmp_12 = new EditorDefinition(tmp_11, null, null, false, true, triggerDependencies_5, processLibraryEditors$lambda_17(init_5));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_3 = processLibraryEditors$lambda_18;
      var separator_3 = get_defaultChildrenSeparator();
      var tmp84 = new ChildrenRoleDefaults(getKClass(ProcessPropertyType), '<type>', null, separator_3, completionSupplier_3, false);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_6 = processLibraryEditors$lambda_19;
      var triggerDependencies_6 = emptyList();
      var tmp_13 = getKClass(SimplePropertyType);
      var tmp_14 = new EditorDefinition(tmp_13, null, null, false, true, triggerDependencies_6, processLibraryEditors$lambda_20(init_6));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_7 = processLibraryEditors$lambda_21;
      var triggerDependencies_7 = emptyList();
      var tmp_15 = getKClass(OntologyElementPropertyType_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_14, new EditorDefinition(tmp_15, null, null, false, true, triggerDependencies_7, processLibraryEditors$lambda_22(init_7)), classExpressionTypeEditor()];
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_0 = [tmp_12, new HierarchyEditorDefinition(getKClass(ProcessPropertyType), tmp84, toList(editorDefinitions))];
      var tmp_16 = new HierarchyEditorDefinition(getKClass(ProcessPropertyValueRange), tmp86, toList(editorDefinitions_0));
      var tmp88 = '<entries>';
      var tmp89 = processLibraryEditors$lambda_23;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_4 = processLibraryEditors$lambda_24;
      var separator_4 = get_defaultChildrenSeparator();
      var tmp123 = new ChildrenRoleDefaults(getKClass(AbstractBindingEntry), tmp88, tmp89, separator_4, completionSupplier_4, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_8 = processLibraryEditors$lambda_25;
      var triggerDependencies_8 = emptyList();
      var tmp_17 = getKClass(BindingProperty_1);
      var tmp_18 = new EditorDefinition(tmp_17, null, null, false, true, triggerDependencies_8, processLibraryEditors$lambda_26(init_8));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_9 = processLibraryEditors$lambda_27;
      var triggerDependencies_9 = emptyList();
      var tmp_19 = getKClass(OntologyLink_1);
      var tmp_20 = new EditorDefinition(tmp_19, null, null, false, true, triggerDependencies_9, processLibraryEditors$lambda_28(init_9));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_10 = processLibraryEditors$lambda_29;
      var triggerDependencies_10 = emptyList();
      var tmp_21 = getKClass(ImportedProperty_1);
      var tmp_22 = new EditorDefinition(tmp_21, null, null, true, true, triggerDependencies_10, processLibraryEditors$lambda_30(init_10));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_11 = processLibraryEditors$lambda_31;
      var triggerDependencies_11 = emptyList();
      var tmp_23 = getKClass(ImportedLink_1);
      var tmp_24 = new EditorDefinition(tmp_23, null, null, true, true, triggerDependencies_11, processLibraryEditors$lambda_32(init_11));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_12 = processLibraryEditors$lambda_33;
      var triggerDependencies_12 = emptyList();
      var tmp_25 = getKClass(EmptyBindingEntry_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_1 = [tmp_18, tmp_20, tmp_22, tmp_24, new EditorDefinition(tmp_25, null, null, false, true, triggerDependencies_12, processLibraryEditors$lambda_34(init_12))];
      var tmp_26 = new HierarchyEditorDefinition(getKClass(AbstractBindingEntry), tmp123, toList(editorDefinitions_1));
      var tmp_27 = get_propertyDeclarationEditor();
      var tmp_28 = processLibraryEditors$lambda_35;
      var tmp125 = childRoleDefaults('<spec>', tmp_28, processLibraryEditors$lambda_36);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_2 = [libraryProcessSpecificationEditor()];
      var tmp_29 = new HierarchyEditorDefinition(getKClass(AbstractProcessSpecification), tmp125, toList(editorDefinitions_2));
      var tmp127 = '<parameters>';
      var tmp128 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_5 = processLibraryEditors$lambda_37;
      var tmp158 = new ChildrenRoleDefaults(getKClass(BindingValuePlaceholder_1), tmp127, null, tmp128, completionSupplier_5, true);
      var tmp150 = childRoleDefaults('<value>', processLibraryEditors$lambda_38);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_13 = processLibraryEditors$lambda_39;
      var triggerDependencies_13 = emptyList();
      var tmp_30 = getKClass(ProcessPropertyValue_1);
      var tmp_31 = new EditorDefinition(tmp_30, null, null, false, true, triggerDependencies_13, processLibraryEditors$lambda_40(init_13));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_14 = processLibraryEditors$lambda_41;
      var triggerDependencies_14 = emptyList();
      var tmp_32 = getKClass(PropertyValue_1);
      var tmp_33 = new EditorDefinition(tmp_32, null, null, false, true, triggerDependencies_14, processLibraryEditors$lambda_42(init_14));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_15 = processLibraryEditors$lambda_43;
      var triggerDependencies_15 = emptyList();
      var tmp_34 = getKClass(OntologyLinkValue_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_3 = [tmp_31, tmp_33, new EditorDefinition(tmp_34, null, null, true, true, triggerDependencies_15, processLibraryEditors$lambda_44(init_15))];
      var tmp_35 = new HierarchyEditorDefinition(getKClass(BindingValuePlaceholder_1), tmp150, toList(editorDefinitions_3));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_16 = processLibraryEditors$lambda_45;
      var triggerDependencies_16 = emptyList();
      var tmp_36 = getKClass(BindingValuePlaceholder_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_4 = [tmp_35, new EditorDefinition(tmp_36, null, null, false, true, triggerDependencies_16, processLibraryEditors$lambda_46(init_16))];
      var tmp_37 = new HierarchyEditorDefinition(getKClass(BindingValuePlaceholder_1), tmp158, toList(editorDefinitions_4));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_17 = processLibraryEditors$lambda_47;
      var triggerDependencies_17 = emptyList();
      var tmp_38 = getKClass(PropertyLibrary_1);
      var tmp_39 = new EditorDefinition(tmp_38, null, null, false, true, triggerDependencies_17, processLibraryEditors$lambda_48(init_17));
      var tmp166 = '<define process properties here>';
      var tmp167 = processLibraryEditors$lambda_49;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier_6 = processLibraryEditors$lambda_50;
      var separator_5 = get_defaultChildrenSeparator();
      var tmp177 = new ChildrenRoleDefaults(getKClass(PropertyLibraryElement), tmp166, tmp167, separator_5, completionSupplier_6, true);
      var tmp_40 = get_propertyDeclarationEditor();
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_18 = processLibraryEditors$lambda_51;
      var triggerDependencies_18 = emptyList();
      var tmp_41 = getKClass(EmptyPropertyLibraryElement_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_5 = [tmp_40, new EditorDefinition(tmp_41, null, null, false, true, triggerDependencies_18, processLibraryEditors$lambda_52(init_18))];
      var tmp_42 = new HierarchyEditorDefinition(getKClass(PropertyLibraryElement), tmp177, toList(editorDefinitions_5));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_19 = processLibraryEditors$lambda_53;
      var triggerDependencies_19 = emptyList();
      var tmp_43 = getKClass(ProcessKindContainer_1);
      var tmp_44 = new EditorDefinition(tmp_43, null, null, false, true, triggerDependencies_19, processLibraryEditors$lambda_54(init_19));
      var tmp191 = childRoleDefaults(VOID, processLibraryEditors$lambda_55);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_20 = processLibraryEditors$lambda_56;
      var triggerDependencies_20 = emptyList();
      var tmp_45 = getKClass(ExtensionFieldReference_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_6 = [new EditorDefinition(tmp_45, null, null, true, true, triggerDependencies_20, processLibraryEditors$lambda_57(init_20))];
      var tmp_46 = new HierarchyEditorDefinition(getKClass(PartReferenceOperation), tmp191, toList(editorDefinitions_6));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<process kind>';
      var separator_6 = get_defaultChildrenSeparator();
      var tmp198 = new ChildrenRoleDefaults(getKClass(ProcessKind_1), placeholderText, null, separator_6, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_21 = processLibraryEditors$lambda_58;
      var triggerDependencies_21 = emptyList();
      var tmp_47 = getKClass(ProcessKind_1);
      var tmp_48 = new EditorDefinition(tmp_47, tmp198, null, false, true, triggerDependencies_21, processLibraryEditors$lambda_59(init_21));
      // Inline function 'jetbrains.biokb.lang.editorBuilders.processFactorEditor' call
      var completion = processLibraryEditors$lambda_60;
      var tmp204 = childRoleDefaults('<expression>', completion, VOID, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_22 = processLibraryEditors$lambda_61;
      var triggerDependencies_22 = emptyList();
      var tmp_49 = getKClass(ProcessPrerequisite_0);
      var tmp_50 = new EditorDefinition(tmp_49, tmp204, null, false, true, triggerDependencies_22, processLibraryEditors$lambda_62(init_22));
      // Inline function 'jetbrains.biokb.lang.editorBuilders.processFactorEditor' call
      var completion_0 = processLibraryEditors$lambda_63;
      var tmp210 = childRoleDefaults('<expression>', completion_0, VOID, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_23 = processLibraryEditors$lambda_64;
      var triggerDependencies_23 = emptyList();
      var tmp_51 = getKClass(ProcessEffect_0);
      var tmp$ret$44 = new EditorDefinition(tmp_51, tmp210, null, false, true, triggerDependencies_23, processLibraryEditors$lambda_65(init_23));
      processLibraryEditors = listOf_0([tmp_0, tmp_2, tmp_4, tmp_6, tmp_8, tmp_10, tmp_16, tmp_26, tmp_27, tmp_29, tmp_37, tmp_39, tmp_42, tmp_44, tmp_46, tmp_48, tmp_50, tmp$ret$44]);
      RANGE_CELL_MARK = new CellMark();
      PROCESS_PROPERTY_CELL_MARK = new CellMark();
    }
  }
  function get_queryCommandEditors() {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return queryCommandEditors;
  }
  var queryCommandEditors;
  function getBindingValueQueryCompletion(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = _this__u8e3s4.bp8(getBindingValueQueryCompletion$lambda);
    _this__u8e3s4.cp8(tmp, getBindingValueQueryCompletion$lambda_0(_this__u8e3s4));
    var tmp_0 = _this__u8e3s4.wp3(Companion_getInstance_218().vc1_1);
    _this__u8e3s4.zp7(tmp_0, getBindingValueQueryCompletion$lambda_1(_this__u8e3s4));
    var tmp_1 = _this__u8e3s4.wp3(Companion_getInstance_216().qce_1);
    _this__u8e3s4.zp7(tmp_1, getBindingValueQueryCompletion$lambda_2(_this__u8e3s4));
  }
  function valueChild_0(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = getKClass(AbstractValue);
    child_1(_this__u8e3s4, tmp, valueChild$lambda_1);
  }
  function queryCommandEditors$lambda($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    indent_0($this$editor, VOID, VOID, queryCommandEditors$lambda$lambda);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = getKClass(Command_0);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, queryCommandEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda(queryCommands) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return queryCommands.v4n();
  }
  function queryCommandEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_1(wrapperContext) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    // Inline function 'kotlin.apply' call
    var this_0 = FindConnectionCommand(wrapperContext);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.queryCommandEditors.<anonymous>.<anonymous>' call
    this_0.g3x().v2c(LibraryProcessSpecificationQuery(wrapperContext));
    this_0.h3x().v2c(LibraryProcessSpecificationQuery(wrapperContext));
    return this_0;
  }
  function queryCommandEditors$lambda_2($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    keyword_0($this$editor, 'find connection');
    newLine_0($this$editor);
    keyword_0($this$editor, 'with');
    space_0($this$editor);
    var tmp = getKClass(ContextQuery_1);
    var tmp_0 = queryCommandEditors$lambda$lambda_0;
    var tmp_1 = queryCommandEditors$lambda$lambda_1;
    child_1($this$editor, tmp, tmp_0, VOID, VOID, tmp_1, VOID, VOID, VOID, VOID, queryCommandEditors$lambda$lambda_2);
    indent_0($this$editor, true, VOID, queryCommandEditors$lambda$lambda_3);
    indent_0($this$editor, true, VOID, queryCommandEditors$lambda$lambda_4);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_0(connectionCommand) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return connectionCommand.vb8();
  }
  function queryCommandEditors$lambda$lambda_1(wc) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    // Inline function 'kotlin.apply' call
    var this_0 = ContextQuery(wc);
    // Inline function 'jetbrains.biokb.lang.editorBuilders.queryCommandEditors.<anonymous>.<anonymous>.<anonymous>' call
    this_0.kay().v2c(OntologyLibraryReference(wc));
    this_0.lay().v2c(OntologyElementReference(wc));
    return this_0;
  }
  function queryCommandEditors$lambda$lambda_2($this$child) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = $this$child.wp3(Companion_getInstance_206().tc0_1);
    $this$child.zp7(tmp, queryCommandEditors$lambda$lambda$lambda_0($this$child));
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_0($this_child) {
    return function (refString) {
      // Inline function 'kotlin.apply' call
      var this_0 = ContextQuery($this_child.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.queryCommandEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.lay().v2c(OntologyElementReference($this_child.o71()));
      var tmp = this_0.kay();
      // Inline function 'kotlin.apply' call
      var this_1 = OntologyLibraryReference($this_child.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.queryCommandEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_1.ub6().v2c(refString);
      tmp.v2c(this_1);
      return this_0;
    };
  }
  function queryCommandEditors$lambda$lambda_3($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    newLine_0($this$indent);
    keyword_0($this$indent, 'from');
    space_0($this$indent);
    var tmp = getKClass(LibraryProcessSpecificationQuery_1);
    child_1($this$indent, tmp, queryCommandEditors$lambda$lambda$lambda_1, '<from>');
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_1(connectionCommand) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return connectionCommand.g3x();
  }
  function queryCommandEditors$lambda$lambda_4($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    newLine_0($this$indent);
    keyword_0($this$indent, 'to');
    space_0($this$indent);
    var tmp = getKClass(LibraryProcessSpecificationQuery_1);
    child_1($this$indent, tmp, queryCommandEditors$lambda$lambda$lambda_2, '<to>');
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_2(connectionCommand) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return connectionCommand.h3x();
  }
  function queryCommandEditors$lambda_3($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_4($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = getKClass(OntologyLibraryReference_1);
    var tmp_0 = queryCommandEditors$lambda$lambda_5;
    var tmp_1 = queryCommandEditors$lambda$lambda_6;
    child_1($this$editor, tmp, tmp_0, VOID, tmp_1, VOID, VOID, VOID, VOID, VOID, queryCommandEditors$lambda$lambda_7);
    indentLabel_0($this$editor, '/');
    var tmp_2 = getKClass(OntologyElementReference_1);
    var tmp_3 = queryCommandEditors$lambda$lambda_8;
    child_1($this$editor, tmp_2, tmp_3, VOID, queryCommandEditors$lambda$lambda_9);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_5(contextQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return contextQuery.kay();
  }
  function queryCommandEditors$lambda$lambda_6(_unused_var__etf5q3, trait) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function queryCommandEditors$lambda$lambda_7($this$child) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = $this$child.wp3(Companion_getInstance_206().tc0_1);
    $this$child.zp7(tmp, queryCommandEditors$lambda$lambda$lambda_3($this$child));
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_3($this_child) {
    return function (refString) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLibraryReference($this_child.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.queryCommandEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      this_0.ub6().v2c(refString);
      return this_0;
    };
  }
  function queryCommandEditors$lambda$lambda_8(contextQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return contextQuery.lay();
  }
  function queryCommandEditors$lambda$lambda_9(_unused_var__etf5q3, trait) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function queryCommandEditors$lambda_5($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_6($this$childRoleDefaults) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = $this$childRoleDefaults.wp3(Companion_getInstance_208().kc6_1);
    $this$childRoleDefaults.zp7(tmp, queryCommandEditors$lambda$lambda_10($this$childRoleDefaults));
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_10($this_childRoleDefaults) {
    return function (refId) {
      // Inline function 'kotlin.apply' call
      var this_0 = LibraryProcessSpecificationQuery($this_childRoleDefaults.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.queryCommandEditors.<anonymous>.<anonymous>.<anonymous>' call
      this_0.jbg().v2c(refId);
      return this_0;
    };
  }
  function queryCommandEditors$lambda_7($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp1 = '<process>';
    var tmp2 = Companion_getInstance_208().kc6_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = queryCommandEditors$lambda$lambda_11;
    var options = new CompletionOptions();
    var containerInit = queryCommandEditors$lambda$lambda_12;
    var textCellInit = queryCommandEditors$lambda$lambda_13;
    var tmp;
    if (null == null) {
      tmp = queryCommandEditors$lambda$lambda_14;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = queryCommandEditors$lambda$lambda_15(textCellInit);
    var targetClass = getKClass(ProcessDeclaration_1);
    referenceTarget($this$editor, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    indentLabel_0($this$editor, '(');
    var tmp_0 = getKClass(BindingValuePlaceholderQuery_1);
    children_2($this$editor, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, queryCommandEditors$lambda$lambda_16);
    indentLabel_0($this$editor, ')', true);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_11(processSpecificationQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return processSpecificationQuery.jbg();
  }
  function queryCommandEditors$lambda$lambda_12(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_13(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_14(it) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return true;
  }
  function queryCommandEditors$lambda$lambda_15($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function queryCommandEditors$lambda$lambda_16(processSpecificationQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return processSpecificationQuery.tba();
  }
  function queryCommandEditors$lambda_8($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_9($this$childrenRoleDefaults) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    getBindingValueQueryCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function queryCommandEditors$lambda_10($this$childRoleDefaults) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    getBindingValueQueryCompletion($this$childRoleDefaults);
    return Unit_instance;
  }
  function queryCommandEditors$lambda_11($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = getKClass(AbstractBindingValueQuery);
    child_1($this$editor, tmp, queryCommandEditors$lambda$lambda_17, '<left>');
    space_0($this$editor);
    label_0($this$editor, '||');
    space_0($this$editor);
    indent_0($this$editor, VOID, VOID, queryCommandEditors$lambda$lambda_18);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_17(orValueQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return orValueQuery.sbf();
  }
  function queryCommandEditors$lambda$lambda_18($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = getKClass(AbstractBindingValueQuery);
    child_1($this$indent, tmp, queryCommandEditors$lambda$lambda$lambda_4, '<right>');
    addTraitOnAttach_0($this$indent, queryCommandEditors$lambda$lambda$lambda_5);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_4(orValueQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return orValueQuery.tbf();
  }
  function queryCommandEditors$lambda$lambda$lambda_5(source, _unused_var__etf5q3, cellFinder) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return getDeleteTransformTrait_0(source, cellFinder);
  }
  function queryCommandEditors$lambda_12($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_13($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp = getKClass(BindingValuePlaceholder_1);
    child_1($this$editor, tmp, queryCommandEditors$lambda$lambda_19);
    var tmp_0 = isEmpty$ref_4();
    editableText_0($this$editor, '', VOID, tmp_0, VOID, queryCommandEditors$lambda$lambda_20);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_19(bindingValueMask) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return bindingValueMask.y();
  }
  function isEmpty$ref_4() {
    var l = function (p0) {
      return isEmpty(p0);
    };
    l.callableName = 'isEmpty';
    return l;
  }
  function queryCommandEditors$lambda$lambda_20($this$editableText) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    rightTransform_0($this$editableText, queryCommandEditors$lambda$lambda$lambda_6($this$editableText));
    return Unit_instance;
  }
  function queryCommandEditors$10$3$1$1$$inlined$executeQuery$1($this_editableText, $source, $cellFinder) {
    this.tss_1 = $this_editableText;
    this.uss_1 = $source;
    this.vss_1 = $cellFinder;
  }
  protoOf(queryCommandEditors$10$3$1$1$$inlined$executeQuery$1).d4x = function (builder) {
    // Inline function 'jetbrains.biokb.lang.editorBuilders.queryCommandEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    var wrapperContext = get_internalConfig(this.tss_1).o71();
    // Inline function 'kotlin.let' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.queryCommandEditors.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    var orValueQuery = OrValueQuery(wrapperContext);
    var tmp = this.uss_1.yt();
    var parentOr = (!(tmp == null) ? isInterface(tmp, OrValueQuery_1) : false) ? tmp : null;
    if (parentOr == null || equals(builder.n51(parentOr.tbf()), this.uss_1)) {
      var tmp_0 = orValueQuery.sbf();
      var tmp_1 = this.uss_1.u6m();
      tmp_0.v2c(isInterface(tmp_1, BindingValueMask_1) ? tmp_1 : THROW_CCE());
      this.uss_1.s6m(orValueQuery);
    } else {
      var tmp_2 = orValueQuery.tbf();
      var tmp0_safe_receiver = builder.n51(parentOr.tbf());
      var tmp_3 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u6m();
      tmp_2.v2c((!(tmp_3 == null) ? isInterface(tmp_3, AbstractBindingValueQuery) : false) ? tmp_3 : null);
      parentOr.tbf().v2c(orValueQuery);
    }
    var tmp1_safe_receiver = firstOrNull_1(this.vss_1.vn4(orValueQuery));
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ulp(ProjectionalSynchronizers_getInstance().jlw_1);
    return tmp2_elvis_lhs == null ? get_EMPTY_CELL_ACTION() : tmp2_elvis_lhs;
  };
  function queryCommandEditors$lambda$lambda$lambda$lambda($this_editableText, $source, $cellFinder) {
    return function () {
      // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
      // Inline function 'jetbrains.ocelot.langDef.query.query' call
      var tmp$ret$0 = new queryCommandEditors$10$3$1$1$$inlined$executeQuery$1($this_editableText, $source, $cellFinder);
      return execute_0(tmp$ret$0);
    };
  }
  function queryCommandEditors$lambda$lambda$lambda_6($this_editableText) {
    return function ($this$rightTransform, source, _unused_var__etf5q3, cellFinder) {
      $this$rightTransform.tp3('||', queryCommandEditors$lambda$lambda$lambda$lambda($this_editableText, source, cellFinder));
      return Unit_instance;
    };
  }
  function queryCommandEditors$lambda_14($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_15($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp1 = '<linkDeclaration>';
    var tmp2 = Companion_getInstance_218().vc1_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = queryCommandEditors$lambda$lambda_21;
    var options = new CompletionOptions();
    var containerInit = queryCommandEditors$lambda$lambda_22;
    var textCellInit = queryCommandEditors$lambda$lambda_23;
    var tmp;
    if (null == null) {
      tmp = queryCommandEditors$lambda$lambda_24;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = queryCommandEditors$lambda$lambda_25(textCellInit);
    var targetClass = getKClass(LinkDeclaration_1);
    referenceTarget($this$editor, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    space_0($this$editor);
    label_0($this$editor, '=');
    space_0($this$editor);
    valueChild_0($this$editor);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_21(linkDeclarationValueQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return linkDeclarationValueQuery.ic2();
  }
  function queryCommandEditors$lambda$lambda_22(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_23(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_24(it) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return true;
  }
  function queryCommandEditors$lambda$lambda_25($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function queryCommandEditors$lambda_16($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_17($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    var tmp1 = '<propertyDeclaration>';
    var tmp2 = Companion_getInstance_216().qce_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = queryCommandEditors$lambda$lambda_26;
    var options = new CompletionOptions();
    var containerInit = queryCommandEditors$lambda$lambda_27;
    var textCellInit = queryCommandEditors$lambda$lambda_28;
    var tmp;
    if (null == null) {
      tmp = queryCommandEditors$lambda$lambda_29;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = queryCommandEditors$lambda$lambda_30(textCellInit);
    var targetClass = getKClass(PropertyDeclaration_1);
    referenceTarget($this$editor, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    space_0($this$editor);
    label_0($this$editor, '=');
    space_0($this$editor);
    valueChild_0($this$editor);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_26(propertyDeclarationValueQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return propertyDeclarationValueQuery.dcf();
  }
  function queryCommandEditors$lambda$lambda_27(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_28(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_29(it) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return true;
  }
  function queryCommandEditors$lambda$lambda_30($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function queryCommandEditors$lambda_18($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_19($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    indent_0($this$editor, VOID, VOID, queryCommandEditors$lambda$lambda_31);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_31($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    placeholderInCollection_0($this$indent, '<argument>', queryCommandEditors$lambda$lambda$lambda_7);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_7($this$placeholderInCollection) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    getBindingValueQueryCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function queryCommandEditors$lambda_20($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function queryCommandEditors$lambda_21($this$editor) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    indent_0($this$editor, VOID, VOID, queryCommandEditors$lambda$lambda_32);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda_32($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    keyword_0($this$indent, 'query');
    space_0($this$indent);
    keyword_0($this$indent, 'parameters');
    space_0($this$indent);
    keyword_0($this$indent, 'blacklist');
    space_0($this$indent);
    keyword_0($this$indent, 'for');
    space_0($this$indent);
    keyword_0($this$indent, 'library:');
    space_0($this$indent);
    var tmp1 = '<library>';
    var tmp2 = Companion_getInstance_215().zcj_1;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var referenceProvider = queryCommandEditors$lambda$lambda$lambda_8;
    var options = new CompletionOptions();
    var containerInit = queryCommandEditors$lambda$lambda$lambda_9;
    var textCellInit = queryCommandEditors$lambda$lambda$lambda_10;
    var tmp;
    if (null == null) {
      tmp = queryCommandEditors$lambda$lambda$lambda_11;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = queryCommandEditors$lambda$lambda$lambda_12(textCellInit);
    var targetClass = getKClass(OntologyLibrary_1);
    referenceTarget($this$indent, targetClass, tmp1, tmp2, referenceProvider, null, tmp5, options, containerInit, textCellInit_0);
    indent_0($this$indent, true, VOID, queryCommandEditors$lambda$lambda$lambda_13);
    indent_0($this$indent, true, VOID, queryCommandEditors$lambda$lambda$lambda_14);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_8(libraryElements) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return libraryElements.kay();
  }
  function queryCommandEditors$lambda$lambda$lambda_9(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_10(_this__u8e3s4) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_11(it) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return true;
  }
  function queryCommandEditors$lambda$lambda$lambda_12($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function queryCommandEditors$lambda$lambda$lambda_13($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    newLine_0($this$indent);
    space_0($this$indent);
    newLine_0($this$indent);
    label_0($this$indent, 'A list of OntologyElements, recognized as common side-input or side-product of many reactions.', VOID, VOID, queryCommandEditors$lambda$lambda$lambda$lambda_0);
    newLine_0($this$indent);
    label_0($this$indent, 'This list will be used by QueryEngine for recognizing such reaction participants as unnecessary', VOID, VOID, queryCommandEditors$lambda$lambda$lambda$lambda_1);
    newLine_0($this$indent);
    label_0($this$indent, 'and hide corresponding connection chains from query execution output.', VOID, VOID, queryCommandEditors$lambda$lambda$lambda$lambda_2);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda$lambda_0($this$label) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    $this$label.ypn().hlu().t2c(Companion_getInstance_325().xls_1);
    $this$label.ypn().klu().t2c(true);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda$lambda_1($this$label) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    $this$label.ypn().hlu().t2c(Companion_getInstance_325().xls_1);
    $this$label.ypn().klu().t2c(true);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda$lambda_2($this$label) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    $this$label.ypn().hlu().t2c(Companion_getInstance_325().xls_1);
    $this$label.ypn().klu().t2c(true);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda_14($this$indent) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    newLine_0($this$indent);
    space_0($this$indent);
    newLine_0($this$indent);
    var tmp = getKClass(OntologyElementReference_1);
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, queryCommandEditors$lambda$lambda$lambda$lambda_3);
    return Unit_instance;
  }
  function queryCommandEditors$lambda$lambda$lambda$lambda_3(blackList) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return blackList.sc0();
  }
  function queryCommandEditors$lambda_22($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function getBindingValueQueryCompletion$lambda($this$using) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    getBindingValueCompletion($this$using);
    return Unit_instance;
  }
  function getBindingValueQueryCompletion$lambda_0($this_getBindingValueQueryCompletion) {
    return function (bindingValue) {
      // Inline function 'kotlin.apply' call
      var this_0 = BindingValueMask($this_getBindingValueQueryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.getBindingValueQueryCompletion.<anonymous>.<anonymous>' call
      this_0.y().v2c(bindingValue);
      return this_0;
    };
  }
  function getBindingValueQueryCompletion$lambda_1($this_getBindingValueQueryCompletion) {
    return function (refId) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLinkDeclarationValueQuery($this_getBindingValueQueryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.getBindingValueQueryCompletion.<anonymous>.<anonymous>' call
      this_0.ic2().v2c(refId);
      return this_0;
    };
  }
  function getBindingValueQueryCompletion$lambda_2($this_getBindingValueQueryCompletion) {
    return function (refId) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyDeclarationValueQuery($this_getBindingValueQueryCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.getBindingValueQueryCompletion.<anonymous>.<anonymous>' call
      this_0.dcf().v2c(refId);
      return this_0;
    };
  }
  function valueChild$lambda_1(declarationValueQuery) {
    _init_properties_QueryCommandEditors_kt__s6mqoh();
    return declarationValueQuery.y();
  }
  var properties_initialized_QueryCommandEditors_kt_3zffyr;
  function _init_properties_QueryCommandEditors_kt__s6mqoh() {
    if (!properties_initialized_QueryCommandEditors_kt_3zffyr) {
      properties_initialized_QueryCommandEditors_kt_3zffyr = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = queryCommandEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(QueryCommands_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, queryCommandEditors$lambda_0(init));
      var tmp6 = '<commands>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var itemFactory = queryCommandEditors$lambda_1;
      var separator_0 = get_defaultChildrenSeparator();
      var tmp17 = new ChildrenRoleDefaults(getKClass(FindConnectionCommand_1), tmp6, itemFactory, separator_0, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = queryCommandEditors$lambda_2;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(FindConnectionCommand_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [new EditorDefinition(tmp_1, null, null, false, true, triggerDependencies_0, queryCommandEditors$lambda_3(init_0))];
      var tmp_2 = new HierarchyEditorDefinition(getKClass(Command_0), tmp17, toList(editorDefinitions));
      var tmp19 = childRoleDefaults('<context>');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = queryCommandEditors$lambda_4;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(ContextQuery_1);
      var tmp_4 = new EditorDefinition(tmp_3, tmp19, null, false, true, triggerDependencies_1, queryCommandEditors$lambda_5(init_1));
      var tmp25 = childRoleDefaults(VOID, queryCommandEditors$lambda_6);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = queryCommandEditors$lambda_7;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(LibraryProcessSpecificationQuery_1);
      var tmp_6 = new EditorDefinition(tmp_5, tmp25, null, true, true, triggerDependencies_2, queryCommandEditors$lambda_8(init_2));
      var tmp31 = separator(',');
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = queryCommandEditors$lambda_9;
      var tmp68 = new ChildrenRoleDefaults(getKClass(BindingValuePlaceholderQuery_1), '<empty>', null, tmp31, completionSupplier, true);
      var tmp60 = childRoleDefaults(VOID, queryCommandEditors$lambda_10);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = queryCommandEditors$lambda_11;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(OrValueQuery_1);
      var tmp_8 = new EditorDefinition(tmp_7, null, null, false, true, triggerDependencies_3, queryCommandEditors$lambda_12(init_3));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_4 = queryCommandEditors$lambda_13;
      var triggerDependencies_4 = emptyList();
      var tmp_9 = getKClass(BindingValueMask_1);
      var tmp_10 = new EditorDefinition(tmp_9, null, null, false, true, triggerDependencies_4, queryCommandEditors$lambda_14(init_4));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_5 = queryCommandEditors$lambda_15;
      var triggerDependencies_5 = emptyList();
      var tmp_11 = getKClass(OntologyLinkDeclarationValueQuery_1);
      var tmp_12 = new EditorDefinition(tmp_11, null, null, true, true, triggerDependencies_5, queryCommandEditors$lambda_16(init_5));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_6 = queryCommandEditors$lambda_17;
      var triggerDependencies_6 = emptyList();
      var tmp_13 = getKClass(PropertyDeclarationValueQuery_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_0 = [tmp_8, tmp_10, tmp_12, new EditorDefinition(tmp_13, null, null, true, true, triggerDependencies_6, queryCommandEditors$lambda_18(init_6))];
      var tmp_14 = new HierarchyEditorDefinition(getKClass(AbstractBindingValueQuery), tmp60, toList(editorDefinitions_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_7 = queryCommandEditors$lambda_19;
      var triggerDependencies_7 = emptyList();
      var tmp_15 = getKClass(BindingValuePlaceholderQuery_1);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions_1 = [tmp_14, new EditorDefinition(tmp_15, null, null, false, true, triggerDependencies_7, queryCommandEditors$lambda_20(init_7))];
      var tmp_16 = new HierarchyEditorDefinition(getKClass(BindingValuePlaceholderQuery_1), tmp68, toList(editorDefinitions_1));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_8 = queryCommandEditors$lambda_21;
      var triggerDependencies_8 = emptyList();
      var tmp_17 = getKClass(QueryParametersBlackList);
      var tmp$ret$14 = new EditorDefinition(tmp_17, null, null, false, true, triggerDependencies_8, queryCommandEditors$lambda_22(init_8));
      queryCommandEditors = listOf_0([tmp_0, tmp_2, tmp_4, tmp_6, tmp_16, tmp$ret$14]);
    }
  }
  function get_relationLibraryEditors() {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return relationLibraryEditors;
  }
  var relationLibraryEditors;
  function instanceRelationValueCompletion(_this__u8e3s4) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_219().dbf_1);
    _this__u8e3s4.zp7(tmp, instanceRelationValueCompletion$lambda(_this__u8e3s4));
  }
  function relationLibraryEditors$lambda($this$editor) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    label_0($this$editor, 'Process Relations:', VOID, VOID, relationLibraryEditors$lambda$lambda);
    indent_0($this$editor, VOID, VOID, relationLibraryEditors$lambda$lambda_0);
    newLine_0($this$editor);
    space_0($this$editor);
    newLine_0($this$editor);
    label_0($this$editor, 'Instance relations:', VOID, VOID, relationLibraryEditors$lambda$lambda_1);
    indent_0($this$editor, VOID, VOID, relationLibraryEditors$lambda$lambda_2);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda($this$label) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    $this$label.ypn().jlu().v2c(true);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda_0($this$indent) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    newLine_0($this$indent);
    var tmp = getKClass(ProcessRelationDeclaration_1);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, relationLibraryEditors$lambda$lambda$lambda);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda(relationContainer) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return relationContainer.ccl();
  }
  function relationLibraryEditors$lambda$lambda_1($this$label) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    $this$label.ypn().jlu().v2c(true);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda_2($this$indent) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    newLine_0($this$indent);
    var tmp = getKClass(InstanceRelationDeclaration);
    var tmp_0 = Layout_VERTICAL_getInstance();
    children_2($this$indent, tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, relationLibraryEditors$lambda$lambda$lambda_0);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_0(relationContainer) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return relationContainer.dcl();
  }
  function relationLibraryEditors$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function relationLibraryEditors$lambda_1($this$editor) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    keyword_0($this$editor, 'relation:');
    space_0($this$editor);
    textProperty_0($this$editor, '<name>', relationLibraryEditors$lambda$lambda_3);
    space_0($this$editor);
    textProperty_0($this$editor, '<symbol>', relationLibraryEditors$lambda$lambda_4);
    indent_0($this$editor, true, VOID, relationLibraryEditors$lambda$lambda_5);
    newLine_0($this$editor);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda_3(relationDeclaration) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return relationDeclaration.b3();
  }
  function relationLibraryEditors$lambda$lambda_4(relationDeclaration) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return relationDeclaration.jcc();
  }
  function relationLibraryEditors$lambda$lambda_5($this$indent) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    newLine_0($this$indent);
    keyword_0($this$indent, 'direction:');
    space_0($this$indent);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    var placeholder = '<direction>';
    editableText_0($this$indent, VOID, placeholder, VOID, VOID, relationLibraryEditors$lambda$lambda$lambda_1);
    newLine_0($this$indent);
    keyword_0($this$indent, 'effect:');
    space_0($this$indent);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumProperty' call
    var placeholder_0 = '<effect>';
    editableText_0($this$indent, VOID, placeholder_0, VOID, VOID, relationLibraryEditors$lambda$lambda$lambda_2);
    newLine_0($this$indent);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_1($this$editableText) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call
    var targetPropFactory = relationLibraryEditors$lambda$lambda$lambda$lambda;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.relationLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
    var sourceProp = $this$editableText.k6h().kcc();
    var targetProp = targetPropFactory($this$editableText.ypn());
    $this$editableText.wle(syncTwoWay(sourceProp.n4z(), targetProp));
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda$lambda(textCell) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_13();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.en4(textCell, enumInfo);
  }
  function relationLibraryEditors$lambda$lambda$lambda_2($this$editableText) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.enumSyncTwoWay' call
    var targetPropFactory = relationLibraryEditors$lambda$lambda$lambda$lambda_0;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.relationLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
    var sourceProp = $this$editableText.k6h().lcc();
    var targetProp = targetPropFactory($this$editableText.ypn());
    $this$editableText.wle(syncTwoWay(sourceProp.n4z(), targetProp));
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda$lambda_0(textCell) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    // Inline function 'jetbrains.ocelot.base.enums.EnumInfoFactory.createEnumInfo' call
    // Inline function 'kotlin.enumValues' call
    var tmp$ret$0 = values_14();
    var enumInfo = new EnumInfoImpl(tmp$ret$0);
    return ValueEditors_instance.en4(textCell, enumInfo);
  }
  function relationLibraryEditors$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function relationLibraryEditors$lambda_3($this$editor) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    indent_0($this$editor, VOID, VOID, relationLibraryEditors$lambda$lambda_6);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda_6($this$indent) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    var tmp = getKClass(Type);
    child_1($this$indent, tmp, relationLibraryEditors$lambda$lambda$lambda_3);
    space_0($this$indent);
    var tmp_0 = relationLibraryEditors$lambda$lambda$lambda_4;
    textProperty_0($this$indent, '<symbol>', tmp_0, relationLibraryEditors$lambda$lambda$lambda_5);
    space_0($this$indent);
    var tmp_1 = getKClass(Type);
    child_1($this$indent, tmp_1, relationLibraryEditors$lambda$lambda$lambda_6);
    ensureLastCaretPosition($this$indent);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_3(it) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return it.obe();
  }
  function relationLibraryEditors$lambda$lambda$lambda_4(propertyDeclaration) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return propertyDeclaration.b3();
  }
  function relationLibraryEditors$lambda$lambda$lambda_5($this$textProperty) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    $this$textProperty.ypn().jlu().v2c(true);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_6(it) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return it.be();
  }
  function relationLibraryEditors$lambda_4($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function relationLibraryEditors$lambda_5($this$childrenRoleDefaults) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    instanceRelationValueCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda_6($this$editor) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    indent_0($this$editor, VOID, VOID, relationLibraryEditors$lambda$lambda_7);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda_7($this$indent) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    var tmp1 = 'relation';
    var tmp2 = Companion_getInstance_219().dbf_1;
    var tmp3 = relationLibraryEditors$lambda$lambda$lambda_7;
    // Inline function 'jetbrains.biokb.lang.editorBuilders.btbReferenceTarget' call
    var textCellInit = relationLibraryEditors$lambda$lambda$lambda_8;
    var options = new CompletionOptions();
    var containerInit = relationLibraryEditors$lambda$lambda$lambda_9;
    var tmp;
    if (null == null) {
      tmp = relationLibraryEditors$lambda$lambda$lambda_10;
    } else {
      tmp = null;
    }
    var tmp5 = tmp;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.references.referenceTarget' call
    var textCellInit_0 = relationLibraryEditors$lambda$lambda$lambda_11(textCellInit);
    var targetClass = getKClass(InstanceRelationDeclaration);
    referenceTarget($this$indent, targetClass, tmp1, tmp2, tmp3, null, tmp5, options, containerInit, textCellInit_0);
    space_0($this$indent);
    // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
    var this_0 = value$factory_15();
    var tmp0_contextLink = new SingleChildLink(getKClass(InstanceRelationValue), this_0);
    var tmp_0 = getKClass(AbstractValue);
    var tmp_1 = value$factory_16();
    var tmp_2 = relationLibraryEditors$lambda$lambda$lambda_12;
    child_1($this$indent, tmp_0, tmp_1, VOID, tmp_2, VOID, VOID, VOID, VOID, tmp0_contextLink, relationLibraryEditors$lambda$lambda$lambda_13);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_7(it) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return it.gb6();
  }
  function relationLibraryEditors$lambda$lambda$lambda_8($this$btbReferenceTarget) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    $this$btbReferenceTarget.ypn().jlu().v2c(true);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_9(_this__u8e3s4) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_10(it) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return true;
  }
  function relationLibraryEditors$lambda$lambda$lambda_11($textCellInit) {
    return function ($this$referenceTarget) {
      $textCellInit($this$referenceTarget);
      enableEagerCompletion($this$referenceTarget);
      return Unit_instance;
    };
  }
  function relationLibraryEditors$lambda$lambda$lambda_12(_unused_var__etf5q3, trait) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function relationLibraryEditors$lambda$lambda$lambda_13($this$child) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    getAbstractValueCompletion($this$child);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda_7($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function relationLibraryEditors$lambda_8($this$editor) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    indent_0($this$editor, VOID, VOID, relationLibraryEditors$lambda$lambda_8);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda_8($this$indent) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    // Inline function 'kotlin.apply' call
    // Inline function 'jetbrains.biokb.lang.editorBuilders.relationLibraryEditors.<anonymous>.<anonymous>.<anonymous>' call
    placeholderInCollection_0($this$indent, '<relation>', relationLibraryEditors$lambda$lambda$lambda_14).olp(get_spaceDoesntCloseCompletion());
    return Unit_instance;
  }
  function relationLibraryEditors$lambda$lambda$lambda_14($this$placeholderInCollection) {
    _init_properties_RelationLibraryEditors_kt__41a73b();
    instanceRelationValueCompletion($this$placeholderInCollection);
    return Unit_instance;
  }
  function relationLibraryEditors$lambda_9($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function instanceRelationValueCompletion$lambda($this_instanceRelationValueCompletion) {
    return function (refValue) {
      return InstanceRelationValue_0($this_instanceRelationValueCompletion.o71(), refValue);
    };
  }
  function value$factory_15() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function value$factory_16() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  var properties_initialized_RelationLibraryEditors_kt_b4pdhz;
  function _init_properties_RelationLibraryEditors_kt__41a73b() {
    if (!properties_initialized_RelationLibraryEditors_kt_b4pdhz) {
      properties_initialized_RelationLibraryEditors_kt_b4pdhz = true;
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init = relationLibraryEditors$lambda;
      var triggerDependencies = emptyList();
      var tmp = getKClass(RelationContainer_1);
      var tmp_0 = new EditorDefinition(tmp, null, null, false, true, triggerDependencies, relationLibraryEditors$lambda_0(init));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText = '<relation declarations>';
      var separator = get_defaultChildrenSeparator();
      var tmp11 = new ChildrenRoleDefaults(getKClass(ProcessRelationDeclaration_1), placeholderText, null, separator, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_0 = relationLibraryEditors$lambda_1;
      var triggerDependencies_0 = emptyList();
      var tmp_1 = getKClass(ProcessRelationDeclaration_1);
      var tmp_2 = new EditorDefinition(tmp_1, tmp11, null, false, true, triggerDependencies_0, relationLibraryEditors$lambda_2(init_0));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var placeholderText_0 = '<relations declarations>';
      var separator_0 = get_defaultChildrenSeparator();
      var tmp22 = new ChildrenRoleDefaults(getKClass(InstanceRelationDeclaration), placeholderText_0, null, separator_0, null, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_1 = relationLibraryEditors$lambda_3;
      var triggerDependencies_1 = emptyList();
      var tmp_3 = getKClass(InstanceRelationDeclaration);
      var tmp_4 = new EditorDefinition(tmp_3, tmp22, null, false, true, triggerDependencies_1, relationLibraryEditors$lambda_4(init_1));
      var tmp28 = '<relations>';
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
      var completionSupplier = relationLibraryEditors$lambda_5;
      var separator_1 = get_defaultChildrenSeparator();
      var tmp45 = new ChildrenRoleDefaults(getKClass(InstanceRelationValuePlaceholder), tmp28, null, separator_1, completionSupplier, true);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_2 = relationLibraryEditors$lambda_6;
      var triggerDependencies_2 = emptyList();
      var tmp_5 = getKClass(InstanceRelationValue);
      var tmp_6 = new EditorDefinition(tmp_5, null, null, true, true, triggerDependencies_2, relationLibraryEditors$lambda_7(init_2));
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
      var init_3 = relationLibraryEditors$lambda_8;
      var triggerDependencies_3 = emptyList();
      var tmp_7 = getKClass(InstanceRelationValuePlaceholder);
      // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.hierarchyEditor' call
      var editorDefinitions = [tmp_6, new EditorDefinition(tmp_7, null, null, false, true, triggerDependencies_3, relationLibraryEditors$lambda_9(init_3))];
      var tmp$ret$8 = new HierarchyEditorDefinition(getKClass(InstanceRelationValuePlaceholder), tmp45, toList(editorDefinitions));
      relationLibraryEditors = listOf_0([tmp_0, tmp_2, tmp_4, tmp$ret$8]);
    }
  }
  function showCustomEditor(_this__u8e3s4, bindingDeclaration, parameters, $completion) {
    var tmp = new $showCustomEditorCOROUTINE$17(_this__u8e3s4, bindingDeclaration, parameters, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function showCustomCell(_this__u8e3s4, customCell, parameters, bindingDeclaration, $completion) {
    var tmp = new $showCustomCellCOROUTINE$18(_this__u8e3s4, customCell, parameters, bindingDeclaration, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  }
  function executeCommand_0(_this__u8e3s4, runnable) {
    return ensureNotNull(_this__u8e3s4.ypn().llk()).hm9(runnable);
  }
  function showCustomCell$lambda($property) {
    return function (wrapperContext) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessPropertyValue(wrapperContext);
      // Inline function 'jetbrains.biokb.lang.editorBuilders.showCustomCell.<anonymous>.<anonymous>' call
      this_0.i6u().t6s($property);
      return this_0;
    };
  }
  function showCustomCell$lambda_0($parameters, $propertyValueFactory, $this) {
    return function () {
      $parameters.e($propertyValueFactory(get_internalConfig($this).o71()));
      return Unit_instance;
    };
  }
  function showCustomCell$lambda_1($propertyValue) {
    return function (it) {
      return $propertyValue.y();
    };
  }
  function showCustomCell$lambda_2(_unused_var__etf5q3, trait) {
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function showCustomCell$lambda$lambda($this$inContextOf) {
    getAbstractValueCompletion($this$inContextOf);
    return Unit_instance;
  }
  function showCustomCell$lambda_3($propertyValue) {
    return function ($this$child) {
      var tmp1 = $propertyValue;
      var tmp2 = value$factory_17();
      var supplier = showCustomCell$lambda$lambda;
      // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
      var tmp$ret$0 = new SingleChildLink(getKClass(ProcessPropertyValue_1), tmp2);
      $this$child.dp8(tmp1, tmp$ret$0, supplier);
      return Unit_instance;
    };
  }
  function showCustomCell$lambda_4($property) {
    return function (wrapperContext) {
      // Inline function 'kotlin.apply' call
      var this_0 = PropertyValue(wrapperContext);
      // Inline function 'jetbrains.biokb.lang.editorBuilders.showCustomCell.<anonymous>.<anonymous>' call
      this_0.i6u().t6s($property);
      return this_0;
    };
  }
  function showCustomCell$lambda_5($parameters, $bindingValueFactory, $this) {
    return function () {
      $parameters.e($bindingValueFactory(get_internalConfig($this).o71()));
      return Unit_instance;
    };
  }
  function showCustomCell$lambda_6($bindingValue) {
    return function (it) {
      return $bindingValue.y();
    };
  }
  function showCustomCell$lambda_7(_unused_var__etf5q3, trait) {
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function showCustomCell$lambda$lambda_0($this$inContextOf) {
    getAbstractValueCompletion($this$inContextOf);
    return Unit_instance;
  }
  function showCustomCell$lambda_8($bindingValue) {
    return function ($this$child) {
      var tmp1 = $bindingValue;
      var tmp2 = value$factory_18();
      var supplier = showCustomCell$lambda$lambda_0;
      // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
      var tmp$ret$0 = new SingleChildLink(getKClass(AbstractBindingValue), tmp2);
      $this$child.dp8(tmp1, tmp$ret$0, supplier);
      return Unit_instance;
    };
  }
  function showCustomCell$lambda_9($link) {
    return function (wrapperContext) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyLinkValue(wrapperContext);
      // Inline function 'jetbrains.biokb.lang.editorBuilders.showCustomCell.<anonymous>.<anonymous>' call
      this_0.wc2().t6s($link);
      return this_0;
    };
  }
  function showCustomCell$lambda_10($parameters, $bindingValueFactory, $this) {
    return function () {
      $parameters.e($bindingValueFactory(get_internalConfig($this).o71()));
      return Unit_instance;
    };
  }
  function showCustomCell$lambda_11($bindingValue) {
    return function (it) {
      return $bindingValue.y();
    };
  }
  function showCustomCell$lambda_12(_unused_var__etf5q3, trait) {
    return CompositeCellTraits_instance.emu([get_spaceDoesntCloseCompletion(), trait]);
  }
  function showCustomCell$lambda$lambda_1($this$inContextOf) {
    getAbstractValueCompletion($this$inContextOf);
    return Unit_instance;
  }
  function showCustomCell$lambda_13($bindingValue) {
    return function ($this$child) {
      var tmp1 = $bindingValue;
      var tmp2 = value$factory_19();
      var supplier = showCustomCell$lambda$lambda_1;
      // Inline function 'jetbrains.ocelot.langDef.structure.asLink' call
      var tmp$ret$0 = new SingleChildLink(getKClass(AbstractBindingValue), tmp2);
      $this$child.dp8(tmp1, tmp$ret$0, supplier);
      return Unit_instance;
    };
  }
  function showCustomCell$lambda_14($bindingDeclaration) {
    return function (it) {
      return $bindingDeclaration.kb9();
    };
  }
  function showCustomCell$lambda_15($bindingDeclaration) {
    return function (it) {
      return $bindingDeclaration.eb8();
    };
  }
  function showCustomCell$lambda_16($parameters) {
    return function (it) {
      return $parameters;
    };
  }
  function $showCustomEditorCOROUTINE$17(_this__u8e3s4, bindingDeclaration, parameters, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.est_1 = _this__u8e3s4;
    this.fst_1 = bindingDeclaration;
    this.gst_1 = parameters;
  }
  protoOf($showCustomEditorCOROUTINE$17).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            if (!this.est_1.n51(this.fst_1.ras())) {
              return false;
            }

            var tmp_0 = this;
            var tmp0_elvis_lhs = this.est_1.n51(this.fst_1.qas());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return false;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.hst_1 = tmp_1;
            this.ist_1 = withIndex_0(this.est_1.n51(this.hst_1.ob1())).k();
            this.y9_1 = 1;
            continue $sm;
          case 1:
            if (!this.ist_1.l()) {
              this.y9_1 = 3;
              continue $sm;
            }

            this.jst_1 = this.ist_1.m();
            this.kst_1 = this.jst_1.ug();
            this.lst_1 = this.jst_1.vg();
            if (this.kst_1 > 0) {
              space_0(this.est_1);
            }

            this.y9_1 = 2;
            suspendResult = showCustomCell(this.est_1, this.lst_1, this.gst_1, this.fst_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.y9_1 = 1;
            continue $sm;
          case 3:
            return true;
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $showCustomCellCOROUTINE$18(_this__u8e3s4, customCell, parameters, bindingDeclaration, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ust_1 = _this__u8e3s4;
    this.vst_1 = customCell;
    this.wst_1 = parameters;
    this.xst_1 = bindingDeclaration;
  }
  protoOf($showCustomCellCOROUTINE$18).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.yst_1 = this.vst_1;
            var tmp_0 = this.yst_1;
            if (isInterface(tmp_0, ConstantCustomCell_1)) {
              var tmp_1 = this;
              var text = this.ust_1.n51(this.vst_1.laz());
              var this_0 = label_0(this.ust_1, text);
              this_0.olp(constantReferenceTrait(this.xst_1));
              constantCustomCellStyle(this_0);
              tmp_1.zst_1 = this_0;
              this.y9_1 = 3;
              continue $sm;
            } else {
              var tmp_2 = this.yst_1;
              if (isInterface(tmp_2, ProcessPropertyCustomCell_1)) {
                var tmp_3 = this;
                var property = this.ust_1.n51(this.vst_1.i6u().r6s());
                var propertyValueFactory = showCustomCell$lambda(property);
                var tmp0 = this.ust_1;
                var tmp1 = this.wst_1;
                l$ret$3: do {
                  var tmp0_0 = tmp0.n51(tmp1);
                  var destination = ArrayList_init_$Create$();
                  var _iterator__ex2g4s = tmp0_0.k();
                  while (_iterator__ex2g4s.l()) {
                    var element = _iterator__ex2g4s.m();
                    if (!(element == null) ? isInterface(element, ProcessPropertyValue_1) : false) {
                      destination.e(element);
                    }
                  }
                  var valueParameters = destination;
                  var tmp$ret$0;
                  l$ret$1: do {
                    var _iterator__ex2g4s_0 = valueParameters.k();
                    while (_iterator__ex2g4s_0.l()) {
                      var element_0 = _iterator__ex2g4s_0.m();
                      if (equals(property, this.ust_1.n51(element_0.i6u().r6s()))) {
                        tmp$ret$0 = element_0;
                        break l$ret$1;
                      }
                    }
                    tmp$ret$0 = null;
                  }
                   while (false);
                  var propertyValue = tmp$ret$0;
                  if (propertyValue == null) {
                    executeCommand_0(tmp0, showCustomCell$lambda_0(tmp1, propertyValueFactory, tmp0));
                    break l$ret$3;
                  }
                  var tmp_4 = getKClass(AbstractValue);
                  var tmp_5 = showCustomCell$lambda_1(propertyValue);
                  var tmp_6 = showCustomCell$lambda_2;
                  child_1(tmp0, tmp_4, tmp_5, VOID, tmp_6, VOID, VOID, VOID, VOID, VOID, showCustomCell$lambda_3(propertyValue));
                }
                 while (false);
                tmp_3.zst_1 = Unit_instance;
                this.y9_1 = 3;
                continue $sm;
              } else {
                var tmp_7 = this.yst_1;
                if (isInterface(tmp_7, PropertyCustomCell_1)) {
                  var tmp_8 = this;
                  var property_0 = this.ust_1.n51(this.vst_1.i6u().r6s());
                  var bindingValueFactory = showCustomCell$lambda_4(property_0);
                  var tmp3 = this.ust_1;
                  var tmp4 = this.wst_1;
                  l$ret$7: do {
                    var tmp0_1 = tmp3.n51(tmp4);
                    var destination_0 = ArrayList_init_$Create$();
                    var _iterator__ex2g4s_1 = tmp0_1.k();
                    while (_iterator__ex2g4s_1.l()) {
                      var element_1 = _iterator__ex2g4s_1.m();
                      if (!(element_1 == null) ? isInterface(element_1, PropertyValue_1) : false) {
                        destination_0.e(element_1);
                      }
                    }
                    var valueParameters_0 = destination_0;
                    var tmp$ret$4;
                    l$ret$5: do {
                      var _iterator__ex2g4s_2 = valueParameters_0.k();
                      while (_iterator__ex2g4s_2.l()) {
                        var element_2 = _iterator__ex2g4s_2.m();
                        if (equals(property_0, this.ust_1.n51(element_2.i6u().r6s()))) {
                          tmp$ret$4 = element_2;
                          break l$ret$5;
                        }
                      }
                      tmp$ret$4 = null;
                    }
                     while (false);
                    var bindingValue = tmp$ret$4;
                    if (bindingValue == null) {
                      executeCommand_0(tmp3, showCustomCell$lambda_5(tmp4, bindingValueFactory, tmp3));
                      break l$ret$7;
                    }
                    var tmp_9 = getKClass(AbstractValue);
                    var tmp_10 = showCustomCell$lambda_6(bindingValue);
                    var tmp_11 = showCustomCell$lambda_7;
                    child_1(tmp3, tmp_9, tmp_10, VOID, tmp_11, VOID, VOID, VOID, VOID, VOID, showCustomCell$lambda_8(bindingValue));
                  }
                   while (false);
                  tmp_8.zst_1 = Unit_instance;
                  this.y9_1 = 3;
                  continue $sm;
                } else {
                  var tmp_12 = this.yst_1;
                  if (isInterface(tmp_12, LinkCustomCell_1)) {
                    var tmp_13 = this;
                    var link = this.ust_1.n51(this.vst_1.pbh().r6s());
                    var bindingValueFactory_0 = showCustomCell$lambda_9(link);
                    var tmp6 = this.ust_1;
                    var tmp7 = this.wst_1;
                    l$ret$11: do {
                      var tmp0_2 = tmp6.n51(tmp7);
                      var destination_1 = ArrayList_init_$Create$();
                      var _iterator__ex2g4s_3 = tmp0_2.k();
                      while (_iterator__ex2g4s_3.l()) {
                        var element_3 = _iterator__ex2g4s_3.m();
                        if (!(element_3 == null) ? isInterface(element_3, OntologyLinkValue_1) : false) {
                          destination_1.e(element_3);
                        }
                      }
                      var valueParameters_1 = destination_1;
                      var tmp$ret$8;
                      l$ret$9: do {
                        var _iterator__ex2g4s_4 = valueParameters_1.k();
                        while (_iterator__ex2g4s_4.l()) {
                          var element_4 = _iterator__ex2g4s_4.m();
                          if (equals(link, this.ust_1.n51(element_4.wc2().r6s()))) {
                            tmp$ret$8 = element_4;
                            break l$ret$9;
                          }
                        }
                        tmp$ret$8 = null;
                      }
                       while (false);
                      var bindingValue_0 = tmp$ret$8;
                      if (bindingValue_0 == null) {
                        executeCommand_0(tmp6, showCustomCell$lambda_10(tmp7, bindingValueFactory_0, tmp6));
                        break l$ret$11;
                      }
                      var tmp_14 = getKClass(AbstractValue);
                      var tmp_15 = showCustomCell$lambda_11(bindingValue_0);
                      var tmp_16 = showCustomCell$lambda_12;
                      child_1(tmp6, tmp_14, tmp_15, VOID, tmp_16, VOID, VOID, VOID, VOID, VOID, showCustomCell$lambda_13(bindingValue_0));
                    }
                     while (false);
                    tmp_13.zst_1 = Unit_instance;
                    this.y9_1 = 3;
                    continue $sm;
                  } else {
                    var tmp_17 = this.yst_1;
                    if (isInterface(tmp_17, ReturnTypeCustomCell_1)) {
                      var tmp_18 = this;
                      var tmp_19 = this.xst_1;
                      if (!isInterface(tmp_19, FunctionDeclaration_1))
                        THROW_CCE();
                      var tmp_20 = getKClass(OntologyElementType_1);
                      tmp_18.zst_1 = child_1(this.ust_1, tmp_20, showCustomCell$lambda_14(this.xst_1));
                      this.y9_1 = 3;
                      continue $sm;
                    } else {
                      var tmp_21 = this.yst_1;
                      if (isInterface(tmp_21, CardinalityCustomCell_1)) {
                        var tmp_22 = this;
                        var tmp_23 = this.xst_1;
                        if (!isInterface(tmp_23, FunctionDeclaration_1))
                          THROW_CCE();
                        var tmp_24 = getKClass(Cardinality_1);
                        tmp_22.zst_1 = child_1(this.ust_1, tmp_24, showCustomCell$lambda_15(this.xst_1));
                        this.y9_1 = 3;
                        continue $sm;
                      } else {
                        var tmp_25 = this.yst_1;
                        if (isInterface(tmp_25, KindCustomCell_1)) {
                          var tmp_26 = this.xst_1;
                          if (!isInterface(tmp_26, ProcessDeclaration_1))
                            THROW_CCE();
                          this.y9_1 = 1;
                          suspendResult = this.ust_1.m51(this.xst_1.r5e(), this);
                          if (suspendResult === get_COROUTINE_SUSPENDED()) {
                            return suspendResult;
                          }
                          continue $sm;
                        } else {
                          var tmp_27 = this.yst_1;
                          if (isInterface(tmp_27, DeclarationNameCustomCell_1)) {
                            var tmp_28 = this;
                            var this_1 = label_0(this.ust_1, this.ust_1.n51(this.xst_1.b3()));
                            this_1.olp(constantReferenceTrait(this.xst_1));
                            this_1.jlu().t2c(true);
                            tmp_28.zst_1 = this_1;
                            this.y9_1 = 3;
                            continue $sm;
                          } else {
                            var tmp_29 = this.yst_1;
                            if (isInterface(tmp_29, PropertiesCustomCell_1)) {
                              var tmp_30 = this;
                              indentLabel_0(this.ust_1, '(');
                              var tmp_31 = getKClass(BindingValuePlaceholder_1);
                              children_2(this.ust_1, tmp_31, VOID, VOID, VOID, VOID, VOID, VOID, VOID, showCustomCell$lambda_16(this.wst_1));
                              tmp_30.zst_1 = indentLabel_0(this.ust_1, ')');
                              this.y9_1 = 3;
                              continue $sm;
                            } else {
                              var tmp_32 = this;
                              throw UnsupportedOperationException_init_$Create$_0('unknown custom cell: ' + toString_1(getKClassFromExpression(this.vst_1)));
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

          case 1:
            var ARGUMENT = suspendResult;
            var kind = ensureNotNull(ARGUMENT);
            var tmp_33 = this;
            var this_2 = label_0(this.ust_1, this.ust_1.n51(kind.b3()));
            this_2.olp(constantReferenceTrait(kind));
            tmp_33.zst_1 = this_2;
            this.y9_1 = 3;
            continue $sm;
          case 2:
            throw this.ba_1;
          case 3:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function value$factory_17() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function value$factory_18() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function value$factory_19() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.y();
    }, null);
  }
  function get_objectTypeCompletion() {
    _init_properties_TypeEditors_kt__d3e3bu();
    return objectTypeCompletion;
  }
  var objectTypeCompletion;
  function get_variableSpecificationCompletion() {
    _init_properties_TypeEditors_kt__d3e3bu();
    return variableSpecificationCompletion;
  }
  var variableSpecificationCompletion;
  function getNotionTypeCompletion(_this__u8e3s4) {
    _init_properties_TypeEditors_kt__d3e3bu();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_220().ybo_1);
    _this__u8e3s4.zp7(tmp, getNotionTypeCompletion$lambda(_this__u8e3s4));
  }
  function ontologyElementTypeCompletion_0(_this__u8e3s4) {
    _init_properties_TypeEditors_kt__d3e3bu();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_206().tc0_1);
    _this__u8e3s4.zp7(tmp, ontologyElementTypeCompletion$lambda_0(_this__u8e3s4));
  }
  function processTypeCompletion(_this__u8e3s4) {
    _init_properties_TypeEditors_kt__d3e3bu();
    var tmp = _this__u8e3s4.wp3(Companion_getInstance_185().ubf_1);
    _this__u8e3s4.zp7(tmp, processTypeCompletion$lambda(_this__u8e3s4));
  }
  function classExpressionTypeEditor() {
    _init_properties_TypeEditors_kt__d3e3bu();
    var tmp0 = classExpressionTypeEditor$lambda;
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.childrenRoleDefaults' call
    var completionSupplier = classExpressionTypeEditor$lambda_0;
    var separator = get_defaultChildrenSeparator();
    var tmp5 = new ChildrenRoleDefaults(getKClass(ClassExpressionType_1), '<empty>', tmp0, separator, completionSupplier, true);
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = classExpressionTypeEditor$lambda_1;
    var triggerDependencies = emptyList();
    var tmp = getKClass(ClassExpressionType_1);
    return new EditorDefinition(tmp, tmp5, null, false, true, triggerDependencies, classExpressionTypeEditor$lambda_2(init));
  }
  function anonymousClassTypeCompletion(_this__u8e3s4) {
    _init_properties_TypeEditors_kt__d3e3bu();
    var tmp = _this__u8e3s4.bp8(anonymousClassTypeCompletion$lambda);
    return _this__u8e3s4.cp8(tmp, anonymousClassTypeCompletion$lambda_0(_this__u8e3s4));
  }
  function objectTypeCompletion$lambda(_this__u8e3s4) {
    _init_properties_TypeEditors_kt__d3e3bu();
    getNotionTypeCompletion(_this__u8e3s4);
    ontologyElementTypeCompletion_0(_this__u8e3s4);
    anonymousClassTypeCompletion(_this__u8e3s4);
    _this__u8e3s4.up7('one of', objectTypeCompletion$lambda$lambda(_this__u8e3s4));
    return Unit_instance;
  }
  function objectTypeCompletion$lambda$lambda($this) {
    return function () {
      return OneOf($this.o71());
    };
  }
  function variableSpecificationCompletion$lambda(_this__u8e3s4) {
    _init_properties_TypeEditors_kt__d3e3bu();
    get_objectTypeCompletion()(_this__u8e3s4);
    processTypeCompletion(_this__u8e3s4);
    variableReferenceValueCompletion(_this__u8e3s4);
    processPropertyReferenceCompletion(_this__u8e3s4);
    return Unit_instance;
  }
  function getNotionTypeCompletion$lambda($this_getNotionTypeCompletion) {
    return function (reference) {
      return NotionType_1($this_getNotionTypeCompletion.o71(), reference);
    };
  }
  function ontologyElementTypeCompletion$lambda_0($this_ontologyElementTypeCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = OntologyElementType($this_ontologyElementTypeCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.ontologyElementTypeCompletion.<anonymous>.<anonymous>' call
      this_0.kay().t2c(OntologyLibraryReference_2($this_ontologyElementTypeCompletion.o71(), reference));
      this_0.lay().t2c(OntologyElementReference($this_ontologyElementTypeCompletion.o71()));
      return this_0;
    };
  }
  function processTypeCompletion$lambda($this_processTypeCompletion) {
    return function (reference) {
      // Inline function 'kotlin.apply' call
      var this_0 = ProcessType($this_processTypeCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.processTypeCompletion.<anonymous>.<anonymous>' call
      this_0.pb5().v2c(LibraryProcessSpecification_2($this_processTypeCompletion.o71(), reference));
      return this_0;
    };
  }
  function classExpressionTypeEditor$lambda(wrapperContext) {
    _init_properties_TypeEditors_kt__d3e3bu();
    return ClassExpressionType(wrapperContext);
  }
  function classExpressionTypeEditor$lambda_0($this$childrenRoleDefaults) {
    _init_properties_TypeEditors_kt__d3e3bu();
    anonymousClassTypeCompletion($this$childrenRoleDefaults);
    return Unit_instance;
  }
  function classExpressionTypeEditor$lambda_1($this$editor) {
    _init_properties_TypeEditors_kt__d3e3bu();
    var tmp = getKClass(ClassExpression);
    var tmp_0 = classExpressionTypeEditor$lambda$lambda;
    var expression = child_1($this$editor, tmp, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, classExpressionTypeEditor$lambda$lambda_0);
    considerEmptyBy($this$editor, expression);
    deleteIfEmpty($this$editor);
    return Unit_instance;
  }
  function classExpressionTypeEditor$lambda$lambda(type) {
    _init_properties_TypeEditors_kt__d3e3bu();
    return type.yay();
  }
  function classExpressionTypeEditor$lambda$lambda_0($this$child) {
    _init_properties_TypeEditors_kt__d3e3bu();
    classExpressionCompletion($this$child);
    return Unit_instance;
  }
  function classExpressionTypeEditor$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function anonymousClassTypeCompletion$lambda($this$using) {
    _init_properties_TypeEditors_kt__d3e3bu();
    anonymousClassCompletion($this$using);
    return Unit_instance;
  }
  function anonymousClassTypeCompletion$lambda_0($this_anonymousClassTypeCompletion) {
    return function (it) {
      // Inline function 'kotlin.apply' call
      var this_0 = ClassExpressionType($this_anonymousClassTypeCompletion.o71());
      // Inline function 'jetbrains.biokb.lang.editorBuilders.anonymousClassTypeCompletion.<anonymous>.<anonymous>' call
      this_0.yay().v2c(it);
      return this_0;
    };
  }
  var properties_initialized_TypeEditors_kt_a3riws;
  function _init_properties_TypeEditors_kt__d3e3bu() {
    if (!properties_initialized_TypeEditors_kt_a3riws) {
      properties_initialized_TypeEditors_kt_a3riws = true;
      objectTypeCompletion = objectTypeCompletion$lambda;
      variableSpecificationCompletion = variableSpecificationCompletion$lambda;
    }
  }
  function get_editorImplementation() {
    _init_properties_BTBEditorImplementation_kt__r5am6b();
    return editorImplementation;
  }
  var editorImplementation;
  var BTBEditorImplementation_EDITORS_instance;
  var BTBEditorImplementation_EDITOR_BUILDERS_instance;
  var BTBEditorImplementation_entriesInitialized;
  function BTBEditorImplementation_initEntries() {
    if (BTBEditorImplementation_entriesInitialized)
      return Unit_instance;
    BTBEditorImplementation_entriesInitialized = true;
    BTBEditorImplementation_EDITORS_instance = new BTBEditorImplementation('EDITORS', 0);
    BTBEditorImplementation_EDITOR_BUILDERS_instance = new BTBEditorImplementation('EDITOR_BUILDERS', 1);
  }
  function BTBEditorImplementation(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function BTBEditorImplementation_EDITOR_BUILDERS_getInstance() {
    BTBEditorImplementation_initEntries();
    return BTBEditorImplementation_EDITOR_BUILDERS_instance;
  }
  var properties_initialized_BTBEditorImplementation_kt_xcf64f;
  function _init_properties_BTBEditorImplementation_kt__r5am6b() {
    if (!properties_initialized_BTBEditorImplementation_kt_xcf64f) {
      properties_initialized_BTBEditorImplementation_kt_xcf64f = true;
      editorImplementation = BTBEditorImplementation_EDITOR_BUILDERS_getInstance();
    }
  }
  function getEditorMapperFactory(configuration) {
    var tmp;
    switch (get_editorImplementation().a3_1) {
      case 0:
        tmp = BTBEditor_getInstance().isd(configuration);
        break;
      case 1:
        tmp = getEditorMapperFactory$lambda(configuration);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function getEditorMapperFactory$lambda($configuration) {
    return function (nodeWrapper) {
      var rootMapperFactory = getEditorBuildersRootMapperFactory();
      var editorMapperFactory = rootMapperFactory.nsj($configuration);
      return editorMapperFactory.apq(nodeWrapper);
    };
  }
  function sendBecameEmpty(_this__u8e3s4) {
    var event = new Event_0();
    event.nl0(Companion_instance_266.klp(_this__u8e3s4));
    _this__u8e3s4.nlp(new DerivedEvent(event), Cells_getInstance().kmg_1);
  }
  function DeleteTransformTrait() {
    CellTrait.call(this);
  }
  protoOf(DeleteTransformTrait).llm = function (cell, event) {
    if (event.ml1(Key_DELETE_getInstance(), []) || event.ml1(Key_BACKSPACE_getInstance(), [])) {
      this.ssj(cell);
      event.ol0();
    } else {
      protoOf(CellTrait).llm.call(this, cell, event);
    }
  };
  function getDeleteTransformTrait(_this__u8e3s4, cellFinder) {
    // Inline function 'jetbrains.biokb.lang.traits.createDeleteTransformTrait' call
    return new getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1(_this__u8e3s4, cellFinder);
  }
  function removePropertyReferenceAndSelectValue(_this__u8e3s4, cellFinder) {
    var tmp0_safe_receiver = _this__u8e3s4.ad5();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.biokb.lang.traits.removePropertyReferenceAndSelectValue.<anonymous>' call
      var tmp0_safe_receiver_0 = firstOrNull_1(cellFinder.vn4(tmp0_safe_receiver));
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : lastFocusable(tmp0_safe_receiver_0);
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toEnd_0(tmp1_safe_receiver);
      tmp2_safe_receiver == null || tmp2_safe_receiver();
    }
  }
  function getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1($this_getDeleteTransformTrait, $cellFinder) {
    this.asu_1 = $this_getDeleteTransformTrait;
    this.bsu_1 = $cellFinder;
    DeleteTransformTrait.call(this);
  }
  protoOf(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1).ssj = function (cell) {
    var tmp0_safe_receiver = this.asu_1.xda();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'jetbrains.biokb.lang.traits.getDeleteTransformTrait.<anonymous>.<anonymous>' call
      var tmp0_safe_receiver_0 = firstOrNull_1(this.bsu_1.vn4(tmp0_safe_receiver));
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.ulp(ProjectionalSynchronizers_getInstance().jlw_1);
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver();
    }
    return Unit_instance;
  };
  function Companion_389() {
    Companion_instance_389 = this;
    this.csu_1 = new CellTraitEventSpec('clearFactSelection', false);
    this.dsu_1 = new CellTraitEventSpec('factToggleEvent', true);
    this.esu_1 = new CellTraitEventSpec('newSingleFactSelected', true);
  }
  var Companion_instance_389;
  function Companion_getInstance_389() {
    if (Companion_instance_389 == null)
      new Companion_389();
    return Companion_instance_389;
  }
  function FactSelectionToggle$imageCellTrait$1(this$0) {
    this.fsu_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(FactSelectionToggle$imageCellTrait$1).jlo = function (cell, event) {
    var addition = event.ul3_1.xl1_1 || event.ul3_1.yl1_1 || event.ul3_1.al2_1;
    var wasSelected = this.fsu_1.bsp_1.m2c();
    var nowSelected = !wasSelected;
    if (addition || wasSelected) {
      cell.mlp(new FactToggleEvent(this.fsu_1.zso_1, nowSelected), Companion_getInstance_389().dsu_1);
    } else {
      cell.mlp(new NewSingleFactSelected(this.fsu_1.zso_1), Companion_getInstance_389().esu_1);
    }
    this.fsu_1.bsp_1.v2c(nowSelected);
    event.ol0();
  };
  function FactSelectionToggle$factCellTrait$1(this$0) {
    this.gsu_1 = this$0;
    CellTrait.call(this);
  }
  protoOf(FactSelectionToggle$factCellTrait$1).plo = function (cell, event) {
    this.gsu_1.asp_1.v2c(true);
  };
  protoOf(FactSelectionToggle$factCellTrait$1).qlo = function (cell, event) {
    this.gsu_1.asp_1.v2c(false);
  };
  protoOf(FactSelectionToggle$factCellTrait$1).bll = function (cell, spec, event) {
    if (equals(spec, Companion_getInstance_389().csu_1)) {
      this.gsu_1.bsp_1.v2c(false);
      event.ol0();
    } else {
      protoOf(CellTrait).bll.call(this, cell, spec, event);
    }
  };
  function FactSelectionToggle(factId, hover, selected) {
    Companion_getInstance_389();
    this.zso_1 = factId;
    this.asp_1 = hover;
    this.bsp_1 = selected;
    var tmp = this;
    tmp.csp_1 = new FactSelectionToggle$imageCellTrait$1(this);
    var tmp_0 = this;
    tmp_0.dsp_1 = new FactSelectionToggle$factCellTrait$1(this);
  }
  function FactToggleEvent(factNodeId, toggle) {
    Event_0.call(this);
    this.jsu_1 = factNodeId;
    this.ksu_1 = toggle;
  }
  function NewSingleFactSelected(factNodeId) {
    Event_0.call(this);
    this.nsu_1 = factNodeId;
  }
  protoOf(NewSingleFactSelected).toString = function () {
    return 'NewSingleFactSelected(factNodeId=' + this.nsu_1 + ')';
  };
  protoOf(NewSingleFactSelected).hashCode = function () {
    return getStringHashCode(this.nsu_1);
  };
  protoOf(NewSingleFactSelected).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NewSingleFactSelected))
      return false;
    var tmp0_other_with_cast = other instanceof NewSingleFactSelected ? other : THROW_CCE();
    if (!(this.nsu_1 === tmp0_other_with_cast.nsu_1))
      return false;
    return true;
  };
  function Companion_390() {
  }
  protoOf(Companion_390).mrw = function (cell) {
    return cell.mlp(new FactsClearEvent(), Companion_getInstance_389().csu_1);
  };
  var Companion_instance_390;
  function Companion_getInstance_390() {
    return Companion_instance_390;
  }
  function FactsClearEvent() {
    Event_0.call(this);
  }
  function sendEvent_0(_this__u8e3s4, $this) {
    var tmp0_safe_receiver = _this__u8e3s4.llk();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u3o();
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ulp(Companion_getInstance_387().srs_1);
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.ks6($this.psu_1);
    }
  }
  function BTBDocumentFactSelectionTrait(factSetCells) {
    FactsSelectionTrait.call(this, factSetCells);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.psu_1 = ArrayList_init_$Create$();
  }
  protoOf(BTBDocumentFactSelectionTrait).bll = function (cell, spec, event) {
    if (event instanceof NewSingleFactSelected) {
      this.psu_1.m2();
      this.psu_1.e(event.nsu_1);
      sendEvent_0(cell, this);
      this.rsu();
      event.ol0();
    } else {
      if (event instanceof FactToggleEvent) {
        if (event.ksu_1)
          this.psu_1.e(event.jsu_1);
        else
          this.psu_1.k2(event.jsu_1);
        sendEvent_0(cell, this);
        event.ol0();
      } else {
        protoOf(FactsSelectionTrait).bll.call(this, cell, spec, event);
      }
    }
  };
  protoOf(BTBDocumentFactSelectionTrait).ssu = function () {
    this.psu_1.m2();
  };
  function FactsSelectionTrait(cellsWithFacts) {
    CellTrait.call(this);
    this.qsu_1 = cellsWithFacts;
  }
  protoOf(FactsSelectionTrait).bll = function (cell, spec, event) {
    if (equals(spec, Companion_getInstance_389().csu_1)) {
      this.rsu();
      this.ssu();
      event.ol0();
    } else {
      protoOf(CellTrait).bll.call(this, cell, spec, event);
    }
  };
  protoOf(FactsSelectionTrait).ssu = function () {
  };
  protoOf(FactsSelectionTrait).rsu = function () {
    var _iterator__ex2g4s = this.qsu_1.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'jetbrains.biokb.lang.traits.FactsSelectionTrait.sendClearDown.<anonymous>' call
      Companion_instance_390.mrw(element);
    }
    return Unit_instance;
  };
  function getDeleteTransformTrait_0(_this__u8e3s4, cellFinder) {
    // Inline function 'jetbrains.biokb.lang.traits.createDeleteTransformTrait' call
    return new getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1_0(_this__u8e3s4, cellFinder);
  }
  function getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1$doWork$1($source, $cellFinder) {
    this.tsu_1 = $source;
    this.usu_1 = $cellFinder;
  }
  protoOf(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1$doWork$1).d4x = function (builder) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'jetbrains.biokb.lang.traits.getDeleteTransformTrait.<anonymous>.<anonymous>' call
      var tmp0_elvis_lhs = this.tsu_1.yt();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var context = tmp;
      var right = builder.n51(this.tsu_1.tbf());
      var res;
      var toSelect;
      if (!(right == null) ? isInterface(right, OrValueQuery_1) : false) {
        var tmp1_safe_receiver = builder.n51(right.tbf());
        var tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u6m();
        res = (!(tmp_0 == null) ? isInterface(tmp_0, AbstractBindingValueQuery) : false) ? tmp_0 : null;
        var tmp2_safe_receiver = res;
        var tmp_1;
        if (tmp2_safe_receiver == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'jetbrains.biokb.lang.traits.getDeleteTransformTrait.<anonymous>.<anonymous>.<anonymous>' call
          right.s6m(tmp2_safe_receiver);
          tmp_1 = Unit_instance;
        }
        if (tmp_1 == null) {
          right.t6m();
        }
        var tmp4_elvis_lhs = res;
        var tmp5_elvis_lhs = tmp4_elvis_lhs == null ? builder.n51(this.tsu_1.sbf()) : tmp4_elvis_lhs;
        toSelect = tmp5_elvis_lhs == null ? this.tsu_1 : tmp5_elvis_lhs;
      } else {
        var tmp6_safe_receiver = builder.n51(this.tsu_1.sbf());
        var tmp_2 = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.u6m();
        res = (!(tmp_2 == null) ? isInterface(tmp_2, AbstractBindingValueQuery) : false) ? tmp_2 : null;
        var tmp7_safe_receiver = res;
        var tmp_3;
        if (tmp7_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'jetbrains.biokb.lang.traits.getDeleteTransformTrait.<anonymous>.<anonymous>.<anonymous>' call
          this.tsu_1.s6m(tmp7_safe_receiver);
          tmp_3 = Unit_instance;
        }
        if (tmp_3 == null) {
          this.tsu_1.t6m();
        }
        var tmp9_elvis_lhs = res;
        toSelect = tmp9_elvis_lhs == null ? context : tmp9_elvis_lhs;
      }
      var tmp10_safe_receiver = firstOrNull_1(this.usu_1.vn4(toSelect));
      var tmp11_safe_receiver = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.ulp(ProjectionalSynchronizers_getInstance().jlw_1);
      if (tmp11_safe_receiver == null)
        null;
      else
        tmp11_safe_receiver();
    }
    return tmp$ret$0;
  };
  function getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1_0($this_getDeleteTransformTrait, $cellFinder) {
    this.vsu_1 = $this_getDeleteTransformTrait;
    this.wsu_1 = $cellFinder;
    DeleteTransformTrait.call(this);
  }
  protoOf(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1_0).ssj = function (cell) {
    var source = this.vsu_1;
    // Inline function 'jetbrains.ocelot.langDef.query.executeQuery' call
    // Inline function 'jetbrains.ocelot.langDef.query.query' call
    var tmp$ret$0 = new getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1$doWork$1(source, this.wsu_1);
    execute_0(tmp$ret$0);
    return Unit_instance;
  };
  function get_btbFindUsagesViews() {
    _init_properties_UsagesView_kt__wok549();
    return btbFindUsagesViews;
  }
  var btbFindUsagesViews;
  function ontologyRelationUsagePresentation(_this__u8e3s4, klass) {
    _init_properties_UsagesView_kt__wok549();
    label_0(_this__u8e3s4, 'ontology element');
    space_0(_this__u8e3s4);
    textProperty_0(_this__u8e3s4, '<name>', ontologyRelationUsagePresentation$lambda);
    space_0(_this__u8e3s4);
    label_0(_this__u8e3s4, '(');
    var tmp0_subject = _this__u8e3s4.k6h();
    var tmp;
    if (tmp0_subject instanceof SuperElementUsage) {
      tmp = 'super type:';
    } else {
      if (tmp0_subject instanceof PartOfElementUsage) {
        tmp = 'part of:';
      } else {
        tmp = 'related to:';
      }
    }
    var relationLabel = tmp;
    label_0(_this__u8e3s4, relationLabel);
    space_0(_this__u8e3s4);
    child_1(_this__u8e3s4, klass, ontologyRelationUsagePresentation$lambda_0(_this__u8e3s4));
    label_0(_this__u8e3s4, ')');
  }
  function asQProperty(_this__u8e3s4) {
    _init_properties_UsagesView_kt__wok549();
    var observable = new ValueProperty(_this__u8e3s4);
    return get_forQueries(observable);
  }
  function targetName(_this__u8e3s4, reference) {
    _init_properties_UsagesView_kt__wok549();
    var tmp = get_internalConfig(_this__u8e3s4).cpo();
    var tmp_0 = new CellAsyncTracker(_this__u8e3s4.ypn());
    launchWith(tmp, tmp_0, targetName$slambda_0(reference, _this__u8e3s4, null));
  }
  function get_declarationKindName(_this__u8e3s4) {
    _init_properties_UsagesView_kt__wok549();
    var tmp;
    if (isInterface(_this__u8e3s4, ProcessDeclaration_1)) {
      tmp = 'process';
    } else {
      if (isInterface(_this__u8e3s4, FunctionDeclaration_1)) {
        tmp = 'function';
      } else {
        throw IllegalArgumentException_init_$Create$_0('declarationKindName not defined for ' + toString_1(getKClassFromExpression(_this__u8e3s4)));
      }
    }
    return tmp;
  }
  function ontologyImportUsage(_this__u8e3s4) {
    _init_properties_UsagesView_kt__wok549();
    label_0(_this__u8e3s4, _this__u8e3s4.k6h().qgw());
    space_0(_this__u8e3s4);
    var tmp = getKClass(OntologyImport_1);
    child_1(_this__u8e3s4, tmp, ontologyImportUsage$lambda);
  }
  function asQProperty_0(_this__u8e3s4) {
    _init_properties_UsagesView_kt__wok549();
    var observable = new ValueProperty(execute_0(_this__u8e3s4));
    return get_forQueries(observable);
  }
  function btbFindUsagesViews$lambda($this$findUsagesView) {
    _init_properties_UsagesView_kt__wok549();
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init = btbFindUsagesViews$lambda$lambda;
    var triggerDependencies = emptyList();
    var tmp = getKClass(SuperElementUsage);
    var def = new EditorDefinition(tmp, null, null, false, false, triggerDependencies, btbFindUsagesViews$lambda$lambda_0(init));
    $this$findUsagesView.nq2(def);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_0 = btbFindUsagesViews$lambda$lambda_1;
    var triggerDependencies_0 = emptyList();
    var tmp_0 = getKClass(PartOfElementUsage);
    var def_0 = new EditorDefinition(tmp_0, null, null, false, false, triggerDependencies_0, btbFindUsagesViews$lambda$lambda_2(init_0));
    $this$findUsagesView.nq2(def_0);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_1 = btbFindUsagesViews$lambda$lambda_3;
    var triggerDependencies_1 = emptyList();
    var tmp_1 = getKClass(ElementsTaxonUsage);
    var def_1 = new EditorDefinition(tmp_1, null, null, false, false, triggerDependencies_1, btbFindUsagesViews$lambda$lambda_4(init_1));
    $this$findUsagesView.nq2(def_1);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_2 = btbFindUsagesViews$lambda$lambda_5;
    var triggerDependencies_2 = emptyList();
    var tmp_2 = getKClass(CategoryOntologyUsage);
    var def_2 = new EditorDefinition(tmp_2, null, null, false, false, triggerDependencies_2, btbFindUsagesViews$lambda$lambda_6(init_2));
    $this$findUsagesView.nq2(def_2);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_3 = btbFindUsagesViews$lambda$lambda_7;
    var triggerDependencies_3 = emptyList();
    var tmp_3 = getKClass(FactSetContextOntologyUsage);
    var def_3 = new EditorDefinition(tmp_3, null, null, false, false, triggerDependencies_3, btbFindUsagesViews$lambda$lambda_8(init_3));
    $this$findUsagesView.nq2(def_3);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_4 = btbFindUsagesViews$lambda$lambda_9;
    var triggerDependencies_4 = emptyList();
    var tmp_4 = getKClass(SomethingAsVariableSpecUsage);
    var def_4 = new EditorDefinition(tmp_4, null, null, false, false, triggerDependencies_4, btbFindUsagesViews$lambda$lambda_10(init_4));
    $this$findUsagesView.nq2(def_4);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_5 = btbFindUsagesViews$lambda$lambda_11;
    var triggerDependencies_5 = emptyList();
    var tmp_5 = getKClass(AnyUsageInFact);
    var def_5 = new EditorDefinition(tmp_5, null, null, false, false, triggerDependencies_5, btbFindUsagesViews$lambda$lambda_12(init_5));
    $this$findUsagesView.nq2(def_5);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_6 = btbFindUsagesViews$lambda$lambda_13;
    var triggerDependencies_6 = emptyList();
    var tmp_6 = getKClass(ProcessKindUsage);
    var def_6 = new EditorDefinition(tmp_6, null, null, false, false, triggerDependencies_6, btbFindUsagesViews$lambda$lambda_14(init_6));
    $this$findUsagesView.nq2(def_6);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_7 = btbFindUsagesViews$lambda$lambda_15;
    var triggerDependencies_7 = emptyList();
    var tmp_7 = getKClass(ExtendedProcessUsage);
    var def_7 = new EditorDefinition(tmp_7, null, null, false, false, triggerDependencies_7, btbFindUsagesViews$lambda$lambda_16(init_7));
    $this$findUsagesView.nq2(def_7);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_8 = btbFindUsagesViews$lambda$lambda_17;
    var triggerDependencies_8 = emptyList();
    var tmp_8 = getKClass(OntologyElementInBindingDeclarationUsage);
    var def_8 = new EditorDefinition(tmp_8, null, null, false, false, triggerDependencies_8, btbFindUsagesViews$lambda$lambda_18(init_8));
    $this$findUsagesView.nq2(def_8);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_9 = btbFindUsagesViews$lambda$lambda_19;
    var triggerDependencies_9 = emptyList();
    var tmp_9 = getKClass(InheritedProcessUsage);
    var def_9 = new EditorDefinition(tmp_9, null, null, false, false, triggerDependencies_9, btbFindUsagesViews$lambda$lambda_20(init_9));
    $this$findUsagesView.nq2(def_9);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_10 = btbFindUsagesViews$lambda$lambda_21;
    var triggerDependencies_10 = emptyList();
    var tmp_10 = getKClass(AnythingInsideCustomEditorUsage);
    var def_10 = new EditorDefinition(tmp_10, null, null, false, false, triggerDependencies_10, btbFindUsagesViews$lambda$lambda_22(init_10));
    $this$findUsagesView.nq2(def_10);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_11 = btbFindUsagesViews$lambda$lambda_23;
    var triggerDependencies_11 = emptyList();
    var tmp_11 = getKClass(AliasedBindingPropertyUsage);
    var def_11 = new EditorDefinition(tmp_11, null, null, false, false, triggerDependencies_11, btbFindUsagesViews$lambda$lambda_24(init_11));
    $this$findUsagesView.nq2(def_11);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_12 = btbFindUsagesViews$lambda$lambda_25;
    var triggerDependencies_12 = emptyList();
    var tmp_12 = getKClass(PropertyTypeUsage);
    var def_12 = new EditorDefinition(tmp_12, null, null, false, false, triggerDependencies_12, btbFindUsagesViews$lambda$lambda_26(init_12));
    $this$findUsagesView.nq2(def_12);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_13 = btbFindUsagesViews$lambda$lambda_27;
    var triggerDependencies_13 = emptyList();
    var tmp_13 = getKClass(OldPropertyTypeNotionUsage);
    var def_13 = new EditorDefinition(tmp_13, null, null, false, false, triggerDependencies_13, btbFindUsagesViews$lambda$lambda_28(init_13));
    $this$findUsagesView.nq2(def_13);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_14 = btbFindUsagesViews$lambda$lambda_29;
    var triggerDependencies_14 = emptyList();
    var tmp_14 = getKClass(OldLinkOntologyUsage);
    var def_14 = new EditorDefinition(tmp_14, null, null, false, false, triggerDependencies_14, btbFindUsagesViews$lambda$lambda_30(init_14));
    $this$findUsagesView.nq2(def_14);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_15 = btbFindUsagesViews$lambda$lambda_31;
    var triggerDependencies_15 = emptyList();
    var tmp_15 = getKClass(OntologyInFunctionReturnTypeUsage);
    var def_15 = new EditorDefinition(tmp_15, null, null, false, false, triggerDependencies_15, btbFindUsagesViews$lambda$lambda_32(init_15));
    $this$findUsagesView.nq2(def_15);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_16 = btbFindUsagesViews$lambda$lambda_33;
    var triggerDependencies_16 = emptyList();
    var tmp_16 = getKClass(OldImportedPropertyUsage);
    var def_16 = new EditorDefinition(tmp_16, null, null, false, false, triggerDependencies_16, btbFindUsagesViews$lambda$lambda_34(init_16));
    $this$findUsagesView.nq2(def_16);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_17 = btbFindUsagesViews$lambda$lambda_35;
    var triggerDependencies_17 = emptyList();
    var tmp_17 = getKClass(OldImportedLinkUsage);
    var def_17 = new EditorDefinition(tmp_17, null, null, false, false, triggerDependencies_17, btbFindUsagesViews$lambda$lambda_36(init_17));
    $this$findUsagesView.nq2(def_17);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_18 = btbFindUsagesViews$lambda$lambda_37;
    var triggerDependencies_18 = emptyList();
    var tmp_18 = getKClass(InOntologyImportForOntologyUsage);
    var def_18 = new EditorDefinition(tmp_18, null, null, false, false, triggerDependencies_18, btbFindUsagesViews$lambda$lambda_38(init_18));
    $this$findUsagesView.nq2(def_18);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_19 = btbFindUsagesViews$lambda$lambda_39;
    var triggerDependencies_19 = emptyList();
    var tmp_19 = getKClass(InOntologyImportOntologyToUseUsage);
    var def_19 = new EditorDefinition(tmp_19, null, null, false, false, triggerDependencies_19, btbFindUsagesViews$lambda$lambda_40(init_19));
    $this$findUsagesView.nq2(def_19);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_20 = btbFindUsagesViews$lambda$lambda_41;
    var triggerDependencies_20 = emptyList();
    var tmp_20 = getKClass(OntologyInExtensionTypeUsage);
    var def_20 = new EditorDefinition(tmp_20, null, null, false, false, triggerDependencies_20, btbFindUsagesViews$lambda$lambda_42(init_20));
    $this$findUsagesView.nq2(def_20);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_21 = btbFindUsagesViews$lambda$lambda_43;
    var triggerDependencies_21 = emptyList();
    var tmp_21 = getKClass(OntologyInExtensionFieldUsage);
    var def_21 = new EditorDefinition(tmp_21, null, null, false, false, triggerDependencies_21, btbFindUsagesViews$lambda$lambda_44(init_21));
    $this$findUsagesView.nq2(def_21);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_22 = btbFindUsagesViews$lambda$lambda_45;
    var triggerDependencies_22 = emptyList();
    var tmp_22 = getKClass(ImportOntologyImportRootUsage);
    var def_22 = new EditorDefinition(tmp_22, null, null, false, false, triggerDependencies_22, btbFindUsagesViews$lambda$lambda_46(init_22));
    $this$findUsagesView.nq2(def_22);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_23 = btbFindUsagesViews$lambda$lambda_47;
    var triggerDependencies_23 = emptyList();
    var tmp_23 = getKClass(PublishedSourceUsage);
    var def_23 = new EditorDefinition(tmp_23, null, null, false, false, triggerDependencies_23, btbFindUsagesViews$lambda$lambda_48(init_23));
    $this$findUsagesView.nq2(def_23);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_24 = btbFindUsagesViews$lambda$lambda_49;
    var triggerDependencies_24 = emptyList();
    var tmp_24 = getKClass(TypeOfOldPropertyDeclarationUsage);
    var def_24 = new EditorDefinition(tmp_24, null, null, false, false, triggerDependencies_24, btbFindUsagesViews$lambda$lambda_50(init_24));
    $this$findUsagesView.nq2(def_24);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_25 = btbFindUsagesViews$lambda$lambda_51;
    var triggerDependencies_25 = emptyList();
    var tmp_25 = getKClass(TypeOfOldLinkDeclarationUsage);
    var def_25 = new EditorDefinition(tmp_25, null, null, false, false, triggerDependencies_25, btbFindUsagesViews$lambda$lambda_52(init_25));
    $this$findUsagesView.nq2(def_25);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_26 = btbFindUsagesViews$lambda$lambda_53;
    var triggerDependencies_26 = emptyList();
    var tmp_26 = getKClass(OldLinkSpecializesLinkUsage);
    var def_26 = new EditorDefinition(tmp_26, null, null, false, false, triggerDependencies_26, btbFindUsagesViews$lambda$lambda_54(init_26));
    $this$findUsagesView.nq2(def_26);
    // Inline function 'jetbrains.ocelot.langDef.usages.viewFor' call
    // Inline function 'jetbrains.ocelot.langDef.editorBuilder.api.editor' call
    var init_27 = btbFindUsagesViews$lambda$lambda_55;
    var triggerDependencies_27 = emptyList();
    var tmp_27 = getKClass(ObjectPropertyUsageByAnotherProperty);
    var def_27 = new EditorDefinition(tmp_27, null, null, false, false, triggerDependencies_27, btbFindUsagesViews$lambda$lambda_56(init_27));
    $this$findUsagesView.nq2(def_27);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    ontologyRelationUsagePresentation($this$viewFor, getKClass(OntologyIsRelation_1));
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda_0($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_1($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    ontologyRelationUsagePresentation($this$viewFor, getKClass(OntologyCardinalityRelation_1));
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda_2($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_3($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'ontology element');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<name>', btbFindUsagesViews$lambda$lambda$lambda);
    space_0($this$viewFor);
    label_0($this$viewFor, '(');
    label_0($this$viewFor, 'is for taxon:');
    space_0($this$viewFor);
    var tmp = getKClass(OntologyElementReferenceProvider);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_0($this$viewFor));
    label_0($this$viewFor, ')');
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.fgv_1.b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_0($this_viewFor) {
    return function (it) {
      return asQProperty($this_viewFor.k6h().ggv_1);
    };
  }
  function btbFindUsagesViews$lambda$lambda_4($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_5($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'category:');
    space_0($this$viewFor);
    var tmp = getKClass(Category_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_1($this$viewFor));
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_1($this_viewFor) {
    return function (it) {
      return asQProperty($this_viewFor.k6h().igv_1);
    };
  }
  function btbFindUsagesViews$lambda$lambda_6($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_7($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'context in fact set');
    label_0($this$viewFor, ':');
    space_0($this$viewFor);
    var tmp = getKClass(Context_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_2);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_2(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.lgv_1);
  }
  function btbFindUsagesViews$lambda$lambda_8($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_9($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'specification of variable');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<no name>', btbFindUsagesViews$lambda$lambda$lambda_3);
    label_0($this$viewFor, ':');
    space_0($this$viewFor);
    var tmp = getKClass(VariableSpecification);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_4);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_3(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.mgv_1.b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_4(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.mgv_1.jcq();
  }
  function btbFindUsagesViews$lambda$lambda_10($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_11($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    var tmp = getKClass(Fact_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_5);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_5(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.ngv_1);
  }
  function btbFindUsagesViews$lambda$lambda_12($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_13($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'process');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_6);
    space_0($this$viewFor);
    label_0($this$viewFor, 'has kind');
    space_0($this$viewFor);
    targetName($this$viewFor, $this$viewFor.k6h().y8c().r5e());
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_6(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.y8c().b3();
  }
  function btbFindUsagesViews$lambda$lambda_14($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_15($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'process');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_7);
    space_0($this$viewFor);
    label_0($this$viewFor, 'extends');
    space_0($this$viewFor);
    targetName($this$viewFor, $this$viewFor.k6h().y8c().gc7());
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_7(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.y8c().b3();
  }
  function btbFindUsagesViews$lambda$lambda_16($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_17($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.k6h().y8c()));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_8);
    space_0($this$viewFor);
    label_0($this$viewFor, 'ontology:');
    space_0($this$viewFor);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_9);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_8(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.y8c().b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_9(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.sgv_1);
  }
  function btbFindUsagesViews$lambda$lambda_18($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_19($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'process');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_10);
    space_0($this$viewFor);
    label_0($this$viewFor, 'inherits');
    space_0($this$viewFor);
    var tmp = getKClass(ProcessReference_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_11);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_10(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.y8c().b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_11(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.qgv_1);
  }
  function btbFindUsagesViews$lambda$lambda_20($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_21($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in custom editor of ' + get_declarationKindName($this$viewFor.k6h().y8c()));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_12);
    label_0($this$viewFor, ':');
    space_0($this$viewFor);
    var tmp = getKClass(CustomCell);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_13);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_12(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.y8c().b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_13(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.wgv_1);
  }
  function btbFindUsagesViews$lambda$lambda_22($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_23($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.k6h().xgv_1) + ' ');
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_14);
    label_0($this$viewFor, ' property ');
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_15);
    label_0($this$viewFor, ' aliases ');
    var tmp = getKClass(ProcessPropertyReference);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_16);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_14(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.xgv_1.b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_15(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.ygv_1.b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_16(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.zgv_1);
  }
  function btbFindUsagesViews$lambda$lambda_24($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_25($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.k6h().agw_1));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_17);
    space_0($this$viewFor);
    label_0($this$viewFor, 'property');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_18);
    space_0($this$viewFor);
    label_0($this$viewFor, 'has type');
    space_0($this$viewFor);
    var tmp = getKClass(ProcessPropertyValueRange);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_19);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_17(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.agw_1.b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_18(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.bgw_1.b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_19(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.bgw_1.zb3();
  }
  function btbFindUsagesViews$lambda$lambda_26($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_27($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.k6h().y8c()));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_20);
    space_0($this$viewFor);
    label_0($this$viewFor, 'property');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_21);
    space_0($this$viewFor);
    label_0($this$viewFor, 'has type');
    space_0($this$viewFor);
    var tmp = getKClass(NotionType_0);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_22);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_20(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.y8c().b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_21(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.dgw_1.b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_22(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.dgw_1.zb3();
  }
  function btbFindUsagesViews$lambda$lambda_28($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_29($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.k6h().y8c()));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_23);
    space_0($this$viewFor);
    label_0($this$viewFor, 'link');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_24);
    space_0($this$viewFor);
    label_0($this$viewFor, 'has type');
    space_0($this$viewFor);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_25);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_23(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.y8c().b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_24(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.hgw_1.b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_25(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.hgw_1.zb3();
  }
  function btbFindUsagesViews$lambda$lambda_30($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_31($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'function');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_26);
    space_0($this$viewFor);
    label_0($this$viewFor, 'has return type:');
    space_0($this$viewFor);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_27);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_26(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.mgw_1.b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_27(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.mgw_1.kb9();
  }
  function btbFindUsagesViews$lambda$lambda_32($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_33($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.k6h().y8c()));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_28);
    space_0($this$viewFor);
    label_0($this$viewFor, 'imported property');
    space_0($this$viewFor);
    var tmp = getKClass(ImportedProperty_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_29);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_28(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.y8c().b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_29(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.fgw_1);
  }
  function btbFindUsagesViews$lambda$lambda_34($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_35($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'in ' + get_declarationKindName($this$viewFor.k6h().y8c()));
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<empty>', btbFindUsagesViews$lambda$lambda$lambda_30);
    space_0($this$viewFor);
    label_0($this$viewFor, 'imported link');
    space_0($this$viewFor);
    var tmp = getKClass(ImportedLink_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_31);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_30(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.y8c().b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_31(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.jgw_1);
  }
  function btbFindUsagesViews$lambda$lambda_36($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_37($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    ontologyImportUsage($this$viewFor);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda_38($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_39($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    ontologyImportUsage($this$viewFor);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda_40($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_41($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'extension');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<no name>', btbFindUsagesViews$lambda$lambda$lambda_32);
    space_0($this$viewFor);
    label_0($this$viewFor, 'for');
    space_0($this$viewFor);
    var tmp = getKClass(OntologyElementType_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_33);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_32(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.tgw_1.b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_33(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.tgw_1.zb3();
  }
  function btbFindUsagesViews$lambda$lambda_42($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_43($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'field of extension');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<no name>', btbFindUsagesViews$lambda$lambda$lambda_34);
    label_0($this$viewFor, ': ');
    var tmp = getKClass(FieldDeclaration_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_35);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_34(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.vgw_1.b3();
  }
  function btbFindUsagesViews$lambda$lambda$lambda_35(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.wgw_1);
  }
  function btbFindUsagesViews$lambda$lambda_44($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_45($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    var tmp = getKClass(OntologyImportRootReference_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_36);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_36(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.ygw_1);
  }
  function btbFindUsagesViews$lambda$lambda_46($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_47($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'published source:');
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<no data>', btbFindUsagesViews$lambda$lambda$lambda_37);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_37(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty_0(it.zgw_1.dcu());
  }
  function btbFindUsagesViews$lambda$lambda_48($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_49($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    var tmp = getKClass(PropertyDeclaration_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_38);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_38(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.agx_1);
  }
  function btbFindUsagesViews$lambda$lambda_50($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_51($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    var tmp = getKClass(LinkDeclaration_1);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_39);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_39(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.bgx_1);
  }
  function btbFindUsagesViews$lambda$lambda_52($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_53($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    label_0($this$viewFor, 'specializes:');
    space_0($this$viewFor);
    var tmp = getKClass(AbstractLink);
    child_1($this$viewFor, tmp, btbFindUsagesViews$lambda$lambda$lambda_40);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_40(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.lgw_1);
  }
  function btbFindUsagesViews$lambda$lambda_54($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function btbFindUsagesViews$lambda$lambda_55($this$viewFor) {
    _init_properties_UsagesView_kt__wok549();
    var tmp;
    switch ($this$viewFor.k6h().dgx_1.a3_1) {
      case 0:
        tmp = 'super property of';
        break;
      case 1:
        tmp = 'inverse property of';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var text = tmp;
    label_0($this$viewFor, text);
    space_0($this$viewFor);
    textProperty_0($this$viewFor, '<no name>', btbFindUsagesViews$lambda$lambda$lambda_41);
    return Unit_instance;
  }
  function btbFindUsagesViews$lambda$lambda$lambda_41(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.cgx_1.b3();
  }
  function btbFindUsagesViews$lambda$lambda_56($init) {
    return function ($this$EditorDefinition) {
      $init($this$EditorDefinition);
      return Companion_getInstance_74().k4v_1.p4w(Unit_instance);
    };
  }
  function ontologyRelationUsagePresentation$lambda(it) {
    _init_properties_UsagesView_kt__wok549();
    return it.y8c().b3();
  }
  function ontologyRelationUsagePresentation$lambda_0($this_ontologyRelationUsagePresentation) {
    return function (it) {
      var tmp = $this_ontologyRelationUsagePresentation.k6h().bgv();
      return asQProperty(isInterface(tmp, AbstractOntologyRelation) ? tmp : THROW_CCE());
    };
  }
  function $runSuspendCOROUTINE$19_1(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fsv_1 = _this__u8e3s4;
    this.gsv_1 = builder;
  }
  protoOf($runSuspendCOROUTINE$19_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.hsv_1 = this.gsv_1;
            this.isv_1 = this.hsv_1;
            this.y9_1 = 1;
            suspendResult = this.isv_1.m51(this.fsv_1.jsv_1.o6s(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.isv_1.n51(tmp0_safe_receiver.b3());
            var name = tmp1_elvis_lhs == null ? '<no name>' : tmp1_elvis_lhs;
            label_0(this.fsv_1.ksv_1, name);
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function targetName$1$$inlined$executeSuspendingQuery$1($reference, $this_targetName) {
    this.jsv_1 = $reference;
    this.ksv_1 = $this_targetName;
  }
  protoOf(targetName$1$$inlined$executeSuspendingQuery$1).g52 = function (builder, $completion) {
    var tmp = new $runSuspendCOROUTINE$19_1(this, builder, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(targetName$1$$inlined$executeSuspendingQuery$1).h4x = function (builder, $completion) {
    return this.g52(builder, $completion);
  };
  function targetName$slambda($reference, $this_targetName, resultContinuation) {
    this.tsv_1 = $reference;
    this.usv_1 = $this_targetName;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(targetName$slambda).h1l = function ($this$launchWith, $completion) {
    var tmp = this.i1l($this$launchWith, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(targetName$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(targetName$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = execute_1(new targetName$1$$inlined$executeSuspendingQuery$1(this.tsv_1, this.usv_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(targetName$slambda).i1l = function ($this$launchWith, completion) {
    var i = new targetName$slambda(this.tsv_1, this.usv_1, completion);
    i.vsv_1 = $this$launchWith;
    return i;
  };
  function targetName$slambda_0($reference, $this_targetName, resultContinuation) {
    var i = new targetName$slambda($reference, $this_targetName, resultContinuation);
    var l = function ($this$launchWith, $completion) {
      return i.h1l($this$launchWith, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function ontologyImportUsage$lambda(it) {
    _init_properties_UsagesView_kt__wok549();
    return asQProperty(it.y8c());
  }
  var properties_initialized_UsagesView_kt_ygco2v;
  function _init_properties_UsagesView_kt__wok549() {
    if (!properties_initialized_UsagesView_kt_ygco2v) {
      properties_initialized_UsagesView_kt_ygco2v = true;
      btbFindUsagesViews = findUsagesView(btbFindUsagesViews$lambda);
    }
  }
  function FindUsagePageEntryAdapter(entry) {
    this.document = entry.document;
    this.nodes = new PagedAdapter(entry.nodes);
  }
  protoOf(FindUsagePageEntryAdapter).lkx = function () {
    return this.document;
  };
  protoOf(FindUsagePageEntryAdapter).b3a = function () {
    return this.nodes;
  };
  function FindUsagePagedAdapter$_init_$lambda_ubivdj(it) {
    return new FindUsagePageEntryAdapter(it);
  }
  function FindUsagePagedAdapter$totalNodes$slambda($paged, resultContinuation) {
    this.esw_1 = $paged;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FindUsagePagedAdapter$totalNodes$slambda).gsw = function ($this$promise, $completion) {
    var tmp = this.i1l($this$promise, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(FindUsagePagedAdapter$totalNodes$slambda).oa = function (p1, $completion) {
    return this.gsw((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FindUsagePagedAdapter$totalNodes$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.esw_1.totalNodes(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(FindUsagePagedAdapter$totalNodes$slambda).i1l = function ($this$promise, completion) {
    var i = new FindUsagePagedAdapter$totalNodes$slambda(this.esw_1, completion);
    i.fsw_1 = $this$promise;
    return i;
  };
  function FindUsagePagedAdapter$totalNodes$slambda_0($paged, resultContinuation) {
    var i = new FindUsagePagedAdapter$totalNodes$slambda($paged, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.gsw($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function FindUsagePagedAdapter(paged) {
    PagedAdapter.call(this, map_4(paged, FindUsagePagedAdapter$_init_$lambda_ubivdj));
    var tmp = this;
    var tmp_0 = CoroutineScope_0(Dispatchers_getInstance().p14_1);
    tmp.totalNodes = promise(tmp_0, VOID, VOID, FindUsagePagedAdapter$totalNodes$slambda_0(paged, null));
  }
  protoOf(FindUsagePagedAdapter).kr7 = function () {
    return this.totalNodes;
  };
  function HtmlNodeEditorView$_init_$lambda_e3k2b0(_this__u8e3s4) {
    return Unit_instance;
  }
  function HtmlNodeEditorView$attach$$inlined$toDisposable$1($cellContainerToDomMapper) {
    this.ksw_1 = $cellContainerToDomMapper;
  }
  protoOf(HtmlNodeEditorView$attach$$inlined$toDisposable$1).vr = function () {
    this.ksw_1.vlc();
    return Unit_instance;
  };
  function HtmlNodeEditorView(element, domConfig, highlightLine) {
    var tmp;
    if (domConfig === VOID) {
      tmp = HtmlNodeEditorView$_init_$lambda_e3k2b0;
    } else {
      tmp = domConfig;
    }
    domConfig = tmp;
    highlightLine = highlightLine === VOID ? false : highlightLine;
    this.lsw_1 = element;
    this.msw_1 = domConfig;
    this.nsw_1 = highlightLine;
  }
  protoOf(HtmlNodeEditorView).krw = function (container) {
    var config = new CellToDomConfig();
    config.ooa(true);
    // Inline function 'kotlin.apply' call
    var this_0 = new CellToDomConfig();
    // Inline function 'jetbrains.biokb.editor.HtmlNodeEditorView.attach.<anonymous>' call
    this.msw_1(this_0);
    if (this.nsw_1) {
      this_0.qoa(new DefaultLineHighlight(container.rlp()));
    }
    var cellContainerToDomMapper = new CellContainerToDomMapper(container, this.lsw_1, this_0);
    cellContainerToDomMapper.ulc();
    // Inline function 'jetbrains.ocelot.base.disposable.toDisposable' call
    return new HtmlNodeEditorView$attach$$inlined$toDisposable$1(cellContainerToDomMapper);
  };
  function closeWorkingCopiesOf(_this__u8e3s4, $this, accession) {
    _this__u8e3s4.crn(NodeEditorAdapter$closeWorkingCopiesOf$lambda($this, accession));
  }
  function closeWorkingCopiesAndLatestPublishedOf(_this__u8e3s4, $this, accession) {
    _this__u8e3s4.crn(NodeEditorAdapter$closeWorkingCopiesAndLatestPublishedOf$lambda($this, accession));
  }
  function workingCopy($this, descriptor, accession) {
    return descriptor.accession === accession && !(get_pointer_0(descriptor) == null);
  }
  function latestPublished($this, descriptor, accession) {
    return descriptor.accession === accession && get_pointer_0(descriptor) == null && descriptor.revision == null && descriptor.globalVersion == null;
  }
  function NodeEditorAdapter$subscribe$lambda(this$0, $type, $listener) {
    return function () {
      this$0.osw_1.grn($type, $listener);
      return Unit_instance;
    };
  }
  function NodeEditorAdapter$open$slambda(this$0, $source, resultContinuation) {
    this.xsw_1 = this$0;
    this.ysw_1 = $source;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(NodeEditorAdapter$open$slambda).h1l = function ($this$promise, $completion) {
    var tmp = this.i1l($this$promise, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(NodeEditorAdapter$open$slambda).oa = function (p1, $completion) {
    return this.h1l((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(NodeEditorAdapter$open$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0;
            var tmp_1 = this.xsw_1.osw_1;
            if (isInterface(tmp_1, CachingNodeEditor)) {
              var tmp_2 = this.ysw_1;
              tmp_0 = tmp_2 instanceof EditedDocumentSource;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              closeWorkingCopiesOf(this.xsw_1.osw_1, this.xsw_1, this.ysw_1.descriptor.accession);
            }

            this.y9_1 = 1;
            suspendResult = this.xsw_1.osw_1.qrp(this.ysw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(NodeEditorAdapter$open$slambda).i1l = function ($this$promise, completion) {
    var i = new NodeEditorAdapter$open$slambda(this.xsw_1, this.ysw_1, completion);
    i.zsw_1 = $this$promise;
    return i;
  };
  function NodeEditorAdapter$open$slambda_0(this$0, $source, resultContinuation) {
    var i = new NodeEditorAdapter$open$slambda(this$0, $source, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.h1l($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function NodeEditorAdapter$closeWorkingCopiesOf$lambda(this$0, $accession) {
    return function (cacheKey) {
      return workingCopy(this$0, cacheKey, $accession);
    };
  }
  function NodeEditorAdapter$closeWorkingCopiesAndLatestPublishedOf$lambda(this$0, $accession) {
    return function (cacheKey) {
      return workingCopy(this$0, cacheKey, $accession) || latestPublished(this$0, cacheKey, $accession);
    };
  }
  function NodeEditorAdapter(editor) {
    this.osw_1 = editor;
  }
  protoOf(NodeEditorAdapter).subscribe = function (type, listener) {
    this.osw_1.frn(type, listener);
    return NodeEditorAdapter$subscribe$lambda(this, type, listener);
  };
  protoOf(NodeEditorAdapter).unsubscribe = function (type, listener) {
    this.osw_1.grn(type, listener);
  };
  protoOf(NodeEditorAdapter).select = function (nodeId) {
    this.osw_1.drn(nodeId);
  };
  protoOf(NodeEditorAdapter).deselectAllFacts = function () {
    this.osw_1.ern();
  };
  protoOf(NodeEditorAdapter).open = function (source) {
    var tmp = CoroutineScope_0(Dispatchers_getInstance().p14_1);
    return promise(tmp, VOID, VOID, NodeEditorAdapter$open$slambda_0(this, source, null));
  };
  protoOf(NodeEditorAdapter).published = function (docAccession) {
    var tmp = this.osw_1;
    if (isInterface(tmp, CachingNodeEditor)) {
      closeWorkingCopiesAndLatestPublishedOf(this.osw_1, this, docAccession);
    }
  };
  protoOf(NodeEditorAdapter).dispose = function () {
    this.osw_1.vr();
  };
  function PageAdapter(page) {
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = page.data;
    tmp.data = copyToArray(this_0);
    this.hasNextPage = page.hasNextPage;
  }
  protoOf(PageAdapter).ebs = function () {
    return this.data;
  };
  protoOf(PageAdapter).vra = function () {
    return this.hasNextPage;
  };
  function PagedAdapter$total$slambda(this$0, resultContinuation) {
    this.isx_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PagedAdapter$total$slambda).gsw = function ($this$promise, $completion) {
    var tmp = this.i1l($this$promise, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(PagedAdapter$total$slambda).oa = function (p1, $completion) {
    return this.gsw((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PagedAdapter$total$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = this.isx_1.isw_1.wr7(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(PagedAdapter$total$slambda).i1l = function ($this$promise, completion) {
    var i = new PagedAdapter$total$slambda(this.isx_1, completion);
    i.jsx_1 = $this$promise;
    return i;
  };
  function PagedAdapter$total$slambda_0(this$0, resultContinuation) {
    var i = new PagedAdapter$total$slambda(this$0, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.gsw($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function PagedAdapter$nextPage$slambda(this$0, resultContinuation) {
    this.ssx_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PagedAdapter$nextPage$slambda).usx = function ($this$promise, $completion) {
    var tmp = this.i1l($this$promise, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(PagedAdapter$nextPage$slambda).oa = function (p1, $completion) {
    return this.usx((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PagedAdapter$nextPage$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = nextPage(this.ssx_1.isw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new PageAdapter(ARGUMENT);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(PagedAdapter$nextPage$slambda).i1l = function ($this$promise, completion) {
    var i = new PagedAdapter$nextPage$slambda(this.ssx_1, completion);
    i.tsx_1 = $this$promise;
    return i;
  };
  function PagedAdapter$nextPage$slambda_0(this$0, resultContinuation) {
    var i = new PagedAdapter$nextPage$slambda(this$0, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.usx($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function PagedAdapter(paged) {
    this.isw_1 = paged;
    var tmp = this;
    var tmp_0 = CoroutineScope_0(Dispatchers_getInstance().p14_1);
    tmp.total = promise(tmp_0, VOID, VOID, PagedAdapter$total$slambda_0(this, null));
  }
  protoOf(PagedAdapter).jsw = function () {
    return this.total;
  };
  protoOf(PagedAdapter).t2u = function () {
    return new PageAdapter(this.isw_1.t2u());
  };
  protoOf(PagedAdapter).nextPage = function () {
    var tmp = CoroutineScope_0(Dispatchers_getInstance().p14_1);
    return promise(tmp, VOID, VOID, PagedAdapter$nextPage$slambda_0(this, null));
  };
  function navigateToUrl(url) {
    window.open(url);
  }
  function get_websocketFactory() {
    _init_properties_JsPlatform_kt__dfptms();
    return websocketFactory;
  }
  var websocketFactory;
  var properties_initialized_JsPlatform_kt_vdfp0e;
  function _init_properties_JsPlatform_kt__dfptms() {
    if (!properties_initialized_JsPlatform_kt_vdfp0e) {
      properties_initialized_JsPlatform_kt_vdfp0e = true;
      websocketFactory = new JsWebsocketFactory();
    }
  }
  function extensions(format) {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = get_providers();
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.k();
    while (_iterator__ex2g4s.l()) {
      var element = _iterator__ex2g4s.m();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'io.ktor.serialization.kotlinx.extensions.<anonymous>' call
      var tmp0_safe_receiver = element.vsx(format);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>.<anonymous>' call
        destination.e(tmp0_safe_receiver);
      }
    }
    return destination;
  }
  function serialization_1(_this__u8e3s4, contentType, format) {
    _this__u8e3s4.wq2(contentType, new KotlinxSerializationConverter(format));
  }
  function KotlinxSerializationConverter$serializeNullable$o$collect$slambda($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation) {
    this.esy_1 = $$this$unsafeFlow;
    this.fsy_1 = $contentType;
    this.gsy_1 = $charset;
    this.hsy_1 = $typeInfo;
    this.isy_1 = $value;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KotlinxSerializationConverter$serializeNullable$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.ksy_1 = this.esy_1;
            var tmp_1 = this;
            tmp_1.lsy_1 = this.jsy_1;
            this.msy_1 = this.ksy_1;
            this.nsy_1 = this.lsy_1;
            var tmp_2 = this;
            tmp_2.osy_1 = this.nsy_1;
            this.psy_1 = this.osy_1;
            this.y9_1 = 1;
            suspendResult = this.psy_1.rsy(this.fsy_1, this.gsy_1, this.hsy_1, this.isy_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.qsy_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.msy_1.d1f(this.qsy_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$o$collect$slambda).a1u = function (value, completion) {
    var i = new KotlinxSerializationConverter$serializeNullable$o$collect$slambda(this.esy_1, this.fsy_1, this.gsy_1, this.hsy_1, this.isy_1, completion);
    i.jsy_1 = value;
    return i;
  };
  function KotlinxSerializationConverter$serializeNullable$o$collect$slambda_0($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation) {
    var i = new KotlinxSerializationConverter$serializeNullable$o$collect$slambda($$this$unsafeFlow, $contentType, $charset, $typeInfo, $value, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$2_0(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.asz_1 = _this__u8e3s4;
    this.bsz_1 = collector;
  }
  protoOf($collectCOROUTINE$2_0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.csz_1 = this.bsz_1;
            this.dsz_1 = this.csz_1;
            this.y9_1 = 1;
            var tmp_1 = KotlinxSerializationConverter$serializeNullable$o$collect$slambda_0(this.dsz_1, this.asz_1.fsz_1, this.asz_1.gsz_1, this.asz_1.hsz_1, this.asz_1.isz_1, null);
            suspendResult = this.asz_1.esz_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_19(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function KotlinxSerializationConverter$deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $content, resultContinuation) {
    this.rsz_1 = $$this$unsafeFlow;
    this.ssz_1 = $charset;
    this.tsz_1 = $typeInfo;
    this.usz_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).z1t = function (value, $completion) {
    var tmp = this.a1u(value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).oa = function (p1, $completion) {
    return this.z1t((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            var tmp_0 = this;
            tmp_0.wsz_1 = this.rsz_1;
            var tmp_1 = this;
            tmp_1.xsz_1 = this.vsz_1;
            this.ysz_1 = this.wsz_1;
            this.zsz_1 = this.xsz_1;
            var tmp_2 = this;
            tmp_2.at0_1 = this.zsz_1;
            this.bt0_1 = this.at0_1;
            this.y9_1 = 1;
            suspendResult = this.bt0_1.zq2(this.ssz_1, this.tsz_1, this.usz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ct0_1 = suspendResult;
            this.y9_1 = 2;
            suspendResult = this.ysz_1.d1f(this.ct0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(KotlinxSerializationConverter$deserialize$o$collect$slambda).a1u = function (value, completion) {
    var i = new KotlinxSerializationConverter$deserialize$o$collect$slambda(this.rsz_1, this.ssz_1, this.tsz_1, this.usz_1, completion);
    i.vsz_1 = value;
    return i;
  };
  function KotlinxSerializationConverter$deserialize$o$collect$slambda_0($$this$unsafeFlow, $charset, $typeInfo, $content, resultContinuation) {
    var i = new KotlinxSerializationConverter$deserialize$o$collect$slambda($$this$unsafeFlow, $charset, $typeInfo, $content, resultContinuation);
    var l = function (value, $completion) {
      return i.z1t(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$3(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lt0_1 = _this__u8e3s4;
    this.mt0_1 = collector;
  }
  protoOf($collectCOROUTINE$3).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this;
            tmp_0.nt0_1 = this.mt0_1;
            this.ot0_1 = this.nt0_1;
            this.y9_1 = 1;
            var tmp_1 = KotlinxSerializationConverter$deserialize$o$collect$slambda_0(this.ot0_1, this.lt0_1.qt0_1, this.lt0_1.rt0_1, this.lt0_1.st0_1, null);
            suspendResult = this.lt0_1.pt0_1.s1d(new sam$kotlinx_coroutines_flow_FlowCollector$0_20(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function serializeContent($this, serializer, format, value, contentType, charset) {
    var tmp;
    if (isInterface(format, StringFormat)) {
      var content = format.f5e(isInterface(serializer, KSerializer) ? serializer : THROW_CCE(), value);
      tmp = new TextContent(content, withCharsetIfNeeded(contentType, charset));
    } else {
      if (isInterface(format, BinaryFormat)) {
        var content_0 = format.d5e(isInterface(serializer, KSerializer) ? serializer : THROW_CCE(), value);
        tmp = new ByteArrayContent(content_0, contentType);
      } else {
        var message = 'Unsupported format ' + toString_1(format);
        throw IllegalStateException_init_$Create$_0(toString_1(message));
      }
    }
    return tmp;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_19(function_0) {
    this.tt0_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_19).d1f = function (value, $completion) {
    return this.tt0_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_19).b4 = function () {
    return this.tt0_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_19).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_19).hashCode = function () {
    return hashCode(this.b4());
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_20(function_0) {
    this.ut0_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_20).d1f = function (value, $completion) {
    return this.ut0_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_20).b4 = function () {
    return this.ut0_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_20).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.b4(), other.b4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_20).hashCode = function () {
    return hashCode(this.b4());
  };
  function KotlinxSerializationConverter$serializeNullable$$inlined$map$1($this, $contentType, $charset, $typeInfo, $value) {
    this.esz_1 = $this;
    this.fsz_1 = $contentType;
    this.gsz_1 = $charset;
    this.hsz_1 = $typeInfo;
    this.isz_1 = $value;
  }
  protoOf(KotlinxSerializationConverter$serializeNullable$$inlined$map$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$2_0(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$$inlined$map$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function KotlinxSerializationConverter$serializeNullable$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KotlinxSerializationConverter$serializeNullable$slambda).et1 = function (it, $completion) {
    var tmp = this.ft1(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$slambda).oa = function (p1, $completion) {
    return this.et1((p1 == null ? true : p1 instanceof OutgoingContent) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !(this.dt1_1 == null);
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(KotlinxSerializationConverter$serializeNullable$slambda).ft1 = function (it, completion) {
    var i = new KotlinxSerializationConverter$serializeNullable$slambda(completion);
    i.dt1_1 = it;
    return i;
  };
  function KotlinxSerializationConverter$serializeNullable$slambda_0(resultContinuation) {
    var i = new KotlinxSerializationConverter$serializeNullable$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.et1(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function KotlinxSerializationConverter$deserialize$$inlined$map$1($this, $charset, $typeInfo, $content) {
    this.pt0_1 = $this;
    this.qt0_1 = $charset;
    this.rt0_1 = $typeInfo;
    this.st0_1 = $content;
  }
  protoOf(KotlinxSerializationConverter$deserialize$$inlined$map$1).e1f = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$3(this, collector, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(KotlinxSerializationConverter$deserialize$$inlined$map$1).s1d = function (collector, $completion) {
    return this.e1f(collector, $completion);
  };
  function KotlinxSerializationConverter$deserialize$slambda($content, resultContinuation) {
    this.ot1_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(KotlinxSerializationConverter$deserialize$slambda).hq5 = function (it, $completion) {
    var tmp = this.a1u(it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(KotlinxSerializationConverter$deserialize$slambda).oa = function (p1, $completion) {
    return this.hq5((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(KotlinxSerializationConverter$deserialize$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        if (tmp === 0) {
          this.z9_1 = 1;
          return !(this.pt1_1 == null) || this.ot1_1.z8e();
        } else if (tmp === 1) {
          throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(KotlinxSerializationConverter$deserialize$slambda).a1u = function (it, completion) {
    var i = new KotlinxSerializationConverter$deserialize$slambda(this.ot1_1, completion);
    i.pt1_1 = it;
    return i;
  };
  function KotlinxSerializationConverter$deserialize$slambda_0($content, resultContinuation) {
    var i = new KotlinxSerializationConverter$deserialize$slambda($content, resultContinuation);
    var l = function (it, $completion) {
      return i.hq5(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $serializeNullableCOROUTINE$0(_this__u8e3s4, contentType, charset, typeInfo, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yt1_1 = _this__u8e3s4;
    this.zt1_1 = contentType;
    this.at2_1 = charset;
    this.bt2_1 = typeInfo;
    this.ct2_1 = value;
  }
  protoOf($serializeNullableCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            var this_0 = asFlow(this.yt1_1.et2_1);
            var tmp_0 = new KotlinxSerializationConverter$serializeNullable$$inlined$map$1(this_0, this.zt1_1, this.at2_1, this.bt2_1, this.ct2_1);
            suspendResult = firstOrNull_4(tmp_0, KotlinxSerializationConverter$serializeNullable$slambda_0(null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var fromExtension = suspendResult;
            if (!(fromExtension == null))
              return fromExtension;
            var tmp_1;
            try {
              tmp_1 = serializerForTypeInfo(this.yt1_1.dt2_1.h5d(), this.bt2_1);
            } catch ($p) {
              var tmp_2;
              if ($p instanceof SerializationException) {
                var cause = $p;
                tmp_2 = guessSerializer(this.ct2_1, this.yt1_1.dt2_1.h5d());
              } else {
                throw $p;
              }
              tmp_1 = tmp_2;
            }

            var serializer = tmp_1;
            return serializeContent(this.yt1_1, serializer, this.yt1_1.dt2_1, this.ct2_1, this.zt1_1, this.at2_1);
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $deserializeCOROUTINE$1(_this__u8e3s4, charset, typeInfo, content, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.nt2_1 = _this__u8e3s4;
    this.ot2_1 = charset;
    this.pt2_1 = typeInfo;
    this.qt2_1 = content;
  }
  protoOf($deserializeCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 5;
            this.y9_1 = 1;
            var this_0 = asFlow(this.nt2_1.et2_1);
            var tmp_0 = new KotlinxSerializationConverter$deserialize$$inlined$map$1(this_0, this.ot2_1, this.pt2_1, this.qt2_1);
            suspendResult = firstOrNull_4(tmp_0, KotlinxSerializationConverter$deserialize$slambda_0(this.qt2_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.rt2_1 = suspendResult;
            var tmp_1;
            if (!this.nt2_1.et2_1.p()) {
              tmp_1 = !(this.rt2_1 == null) || this.qt2_1.z8e();
            } else {
              tmp_1 = false;
            }

            if (tmp_1)
              return this.rt2_1;
            this.st2_1 = serializerForTypeInfo(this.nt2_1.dt2_1.h5d(), this.pt2_1);
            this.y9_1 = 2;
            suspendResult = this.qt2_1.d8k(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var contentPacket = suspendResult;
            this.z9_1 = 3;
            var tmp0_subject = this.nt2_1.dt2_1;
            var tmp_2;
            if (isInterface(tmp0_subject, StringFormat)) {
              tmp_2 = this.nt2_1.dt2_1.g5e(this.st2_1, readText(contentPacket, this.ot2_1));
            } else {
              if (isInterface(tmp0_subject, BinaryFormat)) {
                tmp_2 = this.nt2_1.dt2_1.e5e(this.st2_1, readBytes(contentPacket));
              } else {
                discard(contentPacket);
                var message = 'Unsupported format ' + toString_1(this.nt2_1.dt2_1);
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              }
            }

            return tmp_2;
          case 3:
            this.z9_1 = 5;
            var tmp_3 = this.ba_1;
            if (tmp_3 instanceof Error) {
              var cause = this.ba_1;
              throw new JsonConvertException('Illegal input: ' + cause.message, cause);
            } else {
              throw this.ba_1;
            }

          case 4:
            this.z9_1 = 5;
            return Unit_instance;
          case 5:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 5) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function KotlinxSerializationConverter(format) {
    this.dt2_1 = format;
    this.et2_1 = extensions(this.dt2_1);
    var tmp;
    var tmp_0 = this.dt2_1;
    if (isInterface(tmp_0, BinaryFormat)) {
      tmp = true;
    } else {
      var tmp_1 = this.dt2_1;
      tmp = isInterface(tmp_1, StringFormat);
    }
    // Inline function 'kotlin.require' call
    if (!tmp) {
      // Inline function 'io.ktor.serialization.kotlinx.KotlinxSerializationConverter.<anonymous>' call
      var message = 'Only binary and string formats are supported, ' + toString_1(this.dt2_1) + ' is not supported.';
      throw IllegalArgumentException_init_$Create$_0(toString_1(message));
    }
  }
  protoOf(KotlinxSerializationConverter).tt2 = function (contentType, charset, typeInfo, value, $completion) {
    return this.ut2(contentType, charset, typeInfo, value, $completion);
  };
  protoOf(KotlinxSerializationConverter).xq2 = function (contentType, charset, typeInfo, value, $completion) {
    return this.tt2(contentType, charset, typeInfo, value, $completion);
  };
  protoOf(KotlinxSerializationConverter).ut2 = function (contentType, charset, typeInfo, value, $completion) {
    var tmp = new $serializeNullableCOROUTINE$0(this, contentType, charset, typeInfo, value, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(KotlinxSerializationConverter).yq2 = function (contentType, charset, typeInfo, value, $completion) {
    return this.ut2(contentType, charset, typeInfo, value, $completion);
  };
  protoOf(KotlinxSerializationConverter).zq2 = function (charset, typeInfo, content, $completion) {
    var tmp = new $deserializeCOROUTINE$1(this, charset, typeInfo, content, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function serializerForTypeInfo(_this__u8e3s4, typeInfo) {
    var module_0 = _this__u8e3s4;
    var tmp0_safe_receiver = typeInfo.b8y_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'io.ktor.serialization.kotlinx.serializerForTypeInfo.<anonymous>' call
      var tmp_0;
      if (tmp0_safe_receiver.bc().p()) {
        tmp_0 = null;
      } else {
        tmp_0 = serializerOrNull_0(module_0, tmp0_safe_receiver);
      }
      tmp = tmp_0;
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      var tmp1_safe_receiver = module_0.i5e(typeInfo.z8x_1);
      tmp_1 = tmp1_safe_receiver == null ? null : maybeNullable(tmp1_safe_receiver, typeInfo);
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_1;
    return tmp3_elvis_lhs == null ? maybeNullable(serializer_2(typeInfo.z8x_1), typeInfo) : tmp3_elvis_lhs;
  }
  function guessSerializer(value, module_0) {
    var tmp;
    if (value == null) {
      tmp = get_nullable(serializer_3(StringCompanionObject_instance));
    } else {
      if (!(value == null) ? isInterface(value, KtList) : false) {
        tmp = ListSerializer(elementSerializer(value, module_0));
      } else {
        if (!(value == null) ? isArray(value) : false) {
          var tmp1_safe_receiver = firstOrNull(value);
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'io.ktor.serialization.kotlinx.guessSerializer.<anonymous>' call
            tmp_0 = guessSerializer(tmp1_safe_receiver, module_0);
          }
          var tmp2_elvis_lhs = tmp_0;
          tmp = tmp2_elvis_lhs == null ? ListSerializer(serializer_3(StringCompanionObject_instance)) : tmp2_elvis_lhs;
        } else {
          if (!(value == null) ? isInterface(value, KtSet) : false) {
            tmp = SetSerializer(elementSerializer(value, module_0));
          } else {
            if (!(value == null) ? isInterface(value, KtMap) : false) {
              var keySerializer = elementSerializer(value.u2(), module_0);
              var valueSerializer = elementSerializer(value.v2(), module_0);
              tmp = MapSerializer(keySerializer, valueSerializer);
            } else {
              var tmp3_elvis_lhs = module_0.i5e(getKClassFromExpression(value));
              tmp = tmp3_elvis_lhs == null ? serializer_2(getKClassFromExpression(value)) : tmp3_elvis_lhs;
            }
          }
        }
      }
    }
    var tmp_1 = tmp;
    return isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
  }
  function maybeNullable(_this__u8e3s4, typeInfo) {
    var tmp;
    var tmp0_safe_receiver = typeInfo.b8y_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cc()) === true) {
      tmp = get_nullable(_this__u8e3s4);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function elementSerializer(_this__u8e3s4, module_0) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = filterNotNull(_this__u8e3s4);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.k();
    while (_iterator__ex2g4s.l()) {
      var item = _iterator__ex2g4s.m();
      // Inline function 'io.ktor.serialization.kotlinx.elementSerializer.<anonymous>' call
      var tmp$ret$0 = guessSerializer(item, module_0);
      destination.e(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.distinctBy' call
    var set = HashSet_init_$Create$();
    var list = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = destination.k();
    while (_iterator__ex2g4s_0.l()) {
      var e = _iterator__ex2g4s_0.m();
      // Inline function 'io.ktor.serialization.kotlinx.elementSerializer.<anonymous>' call
      var key = e.w5c().b5e();
      if (set.e(key)) {
        list.e(e);
      }
    }
    var serializers = list;
    if (serializers.n() > 1) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(serializers, 10));
      var _iterator__ex2g4s_1 = serializers.k();
      while (_iterator__ex2g4s_1.l()) {
        var item_0 = _iterator__ex2g4s_1.m();
        // Inline function 'io.ktor.serialization.kotlinx.elementSerializer.<anonymous>' call
        var tmp$ret$5 = item_0.w5c().b5e();
        destination_0.e(tmp$ret$5);
      }
      // Inline function 'kotlin.error' call
      var message = 'Serializing collections of different element types is not yet supported. ' + ('Selected serializers: ' + toString_1(destination_0));
      throw IllegalStateException_init_$Create$_0(toString_1(message));
    }
    var tmp0_elvis_lhs = singleOrNull_0(serializers);
    var selected = tmp0_elvis_lhs == null ? serializer_3(StringCompanionObject_instance) : tmp0_elvis_lhs;
    if (selected.w5c().l5e()) {
      return selected;
    }
    if (!isInterface(selected, KSerializer))
      THROW_CCE();
    var tmp$ret$8;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(_this__u8e3s4, Collection)) {
        tmp = _this__u8e3s4.p();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$8 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s_2 = _this__u8e3s4.k();
      while (_iterator__ex2g4s_2.l()) {
        var element = _iterator__ex2g4s_2.m();
        // Inline function 'io.ktor.serialization.kotlinx.elementSerializer.<anonymous>' call
        if (element == null) {
          tmp$ret$8 = true;
          break $l$block_0;
        }
      }
      tmp$ret$8 = false;
    }
    if (tmp$ret$8) {
      return get_nullable(selected);
    }
    return selected;
  }
  function get_providers() {
    return emptyList();
  }
  function get_DefaultJson() {
    _init_properties_JsonSupport_kt__yf438r();
    return DefaultJson;
  }
  var DefaultJson;
  function json(_this__u8e3s4, json, contentType) {
    json = json === VOID ? get_DefaultJson() : json;
    contentType = contentType === VOID ? Application_getInstance().r8y_1 : contentType;
    _init_properties_JsonSupport_kt__yf438r();
    serialization_1(_this__u8e3s4, contentType, json);
  }
  function DefaultJson$lambda($this$Json) {
    _init_properties_JsonSupport_kt__yf438r();
    $this$Json.c66_1 = true;
    $this$Json.f66_1 = true;
    $this$Json.m66_1 = true;
    $this$Json.g66_1 = true;
    $this$Json.h66_1 = false;
    $this$Json.k66_1 = false;
    return Unit_instance;
  }
  var properties_initialized_JsonSupport_kt_9cgd93;
  function _init_properties_JsonSupport_kt__yf438r() {
    if (!properties_initialized_JsonSupport_kt_9cgd93) {
      properties_initialized_JsonSupport_kt_9cgd93 = true;
      DefaultJson = Json_1(VOID, DefaultJson$lambda);
    }
  }
  function get_LOGGER_8() {
    _init_properties_ContentNegotiation_kt__o183go();
    return LOGGER_8;
  }
  var LOGGER_8;
  function get_DefaultCommonIgnoredTypes() {
    _init_properties_ContentNegotiation_kt__o183go();
    return DefaultCommonIgnoredTypes;
  }
  var DefaultCommonIgnoredTypes;
  function ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher) {
    this.vt2_1 = converter;
    this.wt2_1 = contentTypeToSend;
    this.xt2_1 = contentTypeMatcher;
  }
  function defaultMatcher($this, pattern) {
    return new ContentNegotiation$Config$defaultMatcher$1(pattern);
  }
  function ContentNegotiation$Config$defaultMatcher$1($pattern) {
    this.yt2_1 = $pattern;
  }
  protoOf(ContentNegotiation$Config$defaultMatcher$1).zt2 = function (contentType) {
    return contentType.y8z(this.yt2_1);
  };
  function ContentNegotiation$Plugin$install$slambda($plugin, resultContinuation) {
    this.it3_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentNegotiation$Plugin$install$slambda).iq6 = function ($this$intercept, it, $completion) {
    var tmp = this.jq6($this$intercept, it, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ContentNegotiation$Plugin$install$slambda).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.iq6(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.y9_1 = 1;
            suspendResult = this.it3_1.pt3(this.jt3_1.i8x_1, this.jt3_1.l8w(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.lt3_1 = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (this.lt3_1 == null) {
              return Unit_instance;
            } else {
              tmp_1 = this.lt3_1;
            }

            tmp_0.mt3_1 = tmp_1;
            this.y9_1 = 2;
            suspendResult = this.jt3_1.m8w(this.mt3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda).jq6 = function ($this$intercept, it, completion) {
    var i = new ContentNegotiation$Plugin$install$slambda(this.it3_1, completion);
    i.jt3_1 = $this$intercept;
    i.kt3_1 = it;
    return i;
  };
  function ContentNegotiation$Plugin$install$slambda_0($plugin, resultContinuation) {
    var i = new ContentNegotiation$Plugin$install$slambda($plugin, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.iq6($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function ContentNegotiation$Plugin$install$slambda_1($plugin, resultContinuation) {
    this.yt3_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentNegotiation$Plugin$install$slambda_1).cq7 = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
    var tmp = this.dq7($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ContentNegotiation$Plugin$install$slambda_1).pa = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.cq7(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda_1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 3;
            this.bt4_1 = this.at4_1.ug();
            this.ct4_1 = this.at4_1.vg();
            var tmp_0 = this;
            var tmp0_elvis_lhs = contentType_0(this.zt3_1.i8x_1.pq6());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              this.zt3_1;
              get_LOGGER_8().e8y('Response doesn\'t have "Content-Type" header, skipping ContentNegotiation plugin');
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.dt4_1 = tmp_1;
            this.et4_1 = suitableCharset(this.zt3_1.i8x_1.xq9().g94());
            this.y9_1 = 1;
            suspendResult = this.yt3_1.it4(this.zt3_1.i8x_1.xq9().jbu(), this.bt4_1, this.ct4_1, this.dt4_1, this.et4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ft4_1 = suspendResult;
            var tmp_2 = this;
            var tmp_3;
            if (this.ft4_1 == null) {
              return Unit_instance;
            } else {
              tmp_3 = this.ft4_1;
            }

            tmp_2.gt4_1 = tmp_3;
            this.ht4_1 = new HttpResponseContainer(this.bt4_1, this.gt4_1);
            this.y9_1 = 2;
            suspendResult = this.zt3_1.m8w(this.ht4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 3) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda_1).dq7 = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, completion) {
    var i = new ContentNegotiation$Plugin$install$slambda_1(this.yt3_1, completion);
    i.zt3_1 = $this$intercept;
    i.at4_1 = _name_for_destructuring_parameter_0__wldtmu;
    return i;
  };
  function ContentNegotiation$Plugin$install$slambda_2($plugin, resultContinuation) {
    var i = new ContentNegotiation$Plugin$install$slambda_1($plugin, resultContinuation);
    var l = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
      return i.cq7($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Config_4() {
    this.jt4_1 = toMutableSet(plus_8(get_DefaultIgnoredTypes(), get_DefaultCommonIgnoredTypes()));
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.kt4_1 = ArrayList_init_$Create$();
  }
  protoOf(Config_4).vq2 = function (contentType, converter, configuration) {
    var matcher = contentType.equals(Application_getInstance().r8y_1) ? JsonContentTypeMatcher_instance : defaultMatcher(this, contentType);
    this.lt4(contentType, converter, matcher, configuration);
  };
  protoOf(Config_4).lt4 = function (contentTypeToSend, converter, contentTypeMatcher, configuration) {
    // Inline function 'kotlin.apply' call
    configuration(converter);
    var registration = new ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher);
    this.kt4_1.e(registration);
  };
  function Plugin_6() {
    Plugin_instance_6 = this;
    this.mt4_1 = new AttributeKey('ContentNegotiation');
  }
  protoOf(Plugin_6).x = function () {
    return this.mt4_1;
  };
  protoOf(Plugin_6).nt4 = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_4();
    block(this_0);
    var config = this_0;
    return new ContentNegotiation(config.kt4_1, config.jt4_1);
  };
  protoOf(Plugin_6).sq8 = function (block) {
    return this.nt4(block);
  };
  protoOf(Plugin_6).ot4 = function (plugin, scope) {
    var tmp = Phases_getInstance().kqe_1;
    scope.oq5_1.m8x(tmp, ContentNegotiation$Plugin$install$slambda_0(plugin, null));
    var tmp_0 = Phases_getInstance_1().nq8_1;
    scope.pq5_1.m8x(tmp_0, ContentNegotiation$Plugin$install$slambda_2(plugin, null));
  };
  protoOf(Plugin_6).tq8 = function (plugin, scope) {
    return this.ot4(plugin instanceof ContentNegotiation ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_6;
  function Plugin_getInstance_6() {
    if (Plugin_instance_6 == null)
      new Plugin_6();
    return Plugin_instance_6;
  }
  function ContentNegotiation$convertRequest$lambda(it) {
    return toString_1(it.vt2_1);
  }
  function $convertRequestCOROUTINE$0(_this__u8e3s4, request, body, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xt4_1 = _this__u8e3s4;
    this.yt4_1 = request;
    this.zt4_1 = body;
  }
  protoOf($convertRequestCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 7;
            var _iterator__ex2g4s = this.xt4_1.nt3_1.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              l$ret$1: do {
                get_LOGGER_8().e8y('Adding Accept=' + element.wt2_1.u8z_1 + ' header for ' + this.yt4_1.oq7_1.toString());
                if (this.yt4_1.qq7_1.o8u(HttpHeaders_getInstance().d90_1, element.wt2_1.toString())) {
                  break l$ret$1;
                }
                accept(this.yt4_1, element.wt2_1);
              }
               while (false);
            }

            var tmp_0;
            var tmp_1 = this.zt4_1;
            if (tmp_1 instanceof OutgoingContent) {
              tmp_0 = true;
            } else {
              var tmp2 = this.xt4_1.ot3_1;
              var tmp$ret$2;
              l$ret$3: do {
                var tmp_2;
                if (isInterface(tmp2, Collection)) {
                  tmp_2 = tmp2.p();
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp$ret$2 = false;
                  break l$ret$3;
                }
                var _iterator__ex2g4s_0 = tmp2.k();
                while (_iterator__ex2g4s_0.l()) {
                  var element_0 = _iterator__ex2g4s_0.m();
                  if (element_0.mb(this.zt4_1)) {
                    tmp$ret$2 = true;
                    break l$ret$3;
                  }
                }
                tmp$ret$2 = false;
              }
               while (false);
              tmp_0 = tmp$ret$2;
            }

            if (tmp_0) {
              get_LOGGER_8().e8y('Body type ' + toString_1(getKClassFromExpression(this.zt4_1)) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.yt4_1.oq7_1.toString() + '.'));
              return null;
            }

            var tmp_3 = this;
            var tmp0_elvis_lhs = contentType(this.yt4_1);
            var tmp_4;
            if (tmp0_elvis_lhs == null) {
              this.xt4_1;
              get_LOGGER_8().e8y("Request doesn't have Content-Type header. Skipping ContentNegotiation for " + this.yt4_1.oq7_1.toString() + '.');
              return null;
            } else {
              tmp_4 = tmp0_elvis_lhs;
            }

            tmp_3.at5_1 = tmp_4;
            var tmp_5 = this.zt4_1;
            if (tmp_5 instanceof Unit) {
              get_LOGGER_8().e8y('Sending empty body for ' + this.yt4_1.oq7_1.toString());
              this.yt4_1.qq7_1.t8u(HttpHeaders_getInstance().v90_1);
              return EmptyContent_getInstance();
            }

            var tmp_6 = this;
            var tmp0 = this.xt4_1.nt3_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s_1 = tmp0.k();
            while (_iterator__ex2g4s_1.l()) {
              var element_1 = _iterator__ex2g4s_1.m();
              if (element_1.xt2_1.zt2(this.at5_1)) {
                destination.e(element_1);
              }
            }

            var tmp_7;
            if (!destination.p()) {
              tmp_7 = destination;
            } else {
              tmp_7 = null;
            }

            var tmp1_elvis_lhs = tmp_7;
            var tmp_8;
            if (tmp1_elvis_lhs == null) {
              this.xt4_1;
              get_LOGGER_8().e8y('None of the registered converters match request Content-Type=' + this.at5_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.yt4_1.oq7_1.toString() + '.'));
              return null;
            } else {
              tmp_8 = tmp1_elvis_lhs;
            }

            tmp_6.bt5_1 = tmp_8;
            if (this.yt4_1.dqx() == null) {
              get_LOGGER_8().e8y('Request has unknown body type. Skipping ContentNegotiation for ' + this.yt4_1.oq7_1.toString() + '.');
              return null;
            }

            this.yt4_1.qq7_1.t8u(HttpHeaders_getInstance().v90_1);
            var tmp_9 = this;
            tmp_9.ct5_1 = this.bt5_1;
            this.y9_1 = 1;
            continue $sm;
          case 1:
            this.et5_1 = this.ct5_1;
            this.ft5_1 = this.et5_1.k();
            this.y9_1 = 2;
            continue $sm;
          case 2:
            if (!this.ft5_1.l()) {
              this.y9_1 = 5;
              continue $sm;
            }

            this.gt5_1 = this.ft5_1.m();
            var tmp_10 = this;
            tmp_10.ht5_1 = this.gt5_1;
            this.it5_1 = this.ht5_1;
            this.y9_1 = 3;
            var tmp0_elvis_lhs_0 = charset(this.at5_1);
            var tmp_11 = tmp0_elvis_lhs_0 == null ? Charsets_getInstance().q8o_1 : tmp0_elvis_lhs_0;
            var tmp_12 = ensureNotNull(this.yt4_1.dqx());
            var this_0 = this.zt4_1;
            var tmp_13;
            if (!equals(this_0, NullBody_instance)) {
              tmp_13 = this_0;
            } else {
              tmp_13 = null;
            }

            suspendResult = this.it5_1.vt2_1.yq2(this.at5_1, tmp_11, tmp_12, tmp_13, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var result = suspendResult;
            if (!(result == null)) {
              get_LOGGER_8().e8y('Converted request body using ' + toString_1(this.it5_1.vt2_1) + ' for ' + this.yt4_1.oq7_1.toString());
            }

            var result_0 = result;
            if (!(result_0 == null)) {
              this.dt5_1 = result_0;
              this.y9_1 = 6;
              continue $sm;
            } else {
              this.y9_1 = 4;
              continue $sm;
            }

          case 4:
            this.y9_1 = 2;
            continue $sm;
          case 5:
            this.dt5_1 = null;
            if (false) {
              this.y9_1 = 1;
              continue $sm;
            }

            this.y9_1 = 6;
            continue $sm;
          case 6:
            var tmp2_elvis_lhs = this.dt5_1;
            var tmp_14;
            if (tmp2_elvis_lhs == null) {
              var tmp_15 = "Can't convert " + toString_1(this.zt4_1) + ' with contentType ' + this.at5_1.toString() + ' using converters ';
              throw new ContentConverterException(tmp_15 + joinToString_0(this.bt5_1, VOID, VOID, VOID, VOID, VOID, ContentNegotiation$convertRequest$lambda));
            } else {
              tmp_14 = tmp2_elvis_lhs;
            }

            var serializedContent = tmp_14;
            return serializedContent;
          case 7:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 7) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function $convertResponseCOROUTINE$1(_this__u8e3s4, requestUrl, info, body, responseContentType, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rt5_1 = _this__u8e3s4;
    this.st5_1 = requestUrl;
    this.tt5_1 = info;
    this.ut5_1 = body;
    this.vt5_1 = responseContentType;
    this.wt5_1 = charset;
  }
  protoOf($convertResponseCOROUTINE$1).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            var tmp_0 = this.ut5_1;
            if (!isInterface(tmp_0, ByteReadChannel_1)) {
              get_LOGGER_8().e8y('Response body is already transformed. Skipping ContentNegotiation for ' + this.st5_1.toString() + '.');
              return null;
            }

            if (this.rt5_1.ot3_1.s(this.tt5_1.z8x_1)) {
              get_LOGGER_8().e8y('Response body type ' + toString_1(this.tt5_1.z8x_1) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.st5_1.toString() + '.'));
              return null;
            }

            var tmp_1 = this;
            var tmp0 = this.rt5_1.nt3_1;
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.k();
            while (_iterator__ex2g4s.l()) {
              var element = _iterator__ex2g4s.m();
              if (element.xt2_1.zt2(this.vt5_1)) {
                destination.e(element);
              }
            }

            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
            var _iterator__ex2g4s_0 = destination.k();
            while (_iterator__ex2g4s_0.l()) {
              var item = _iterator__ex2g4s_0.m();
              destination_0.e(item.vt2_1);
            }

            var tmp_2;
            if (!destination_0.p()) {
              tmp_2 = destination_0;
            } else {
              tmp_2 = null;
            }

            var tmp0_elvis_lhs = tmp_2;
            var tmp_3;
            if (tmp0_elvis_lhs == null) {
              this.rt5_1;
              get_LOGGER_8().e8y('None of the registered converters match response with Content-Type=' + this.vt5_1.toString() + '. ' + ('Skipping ContentNegotiation for ' + this.st5_1.toString() + '.'));
              return null;
            } else {
              tmp_3 = tmp0_elvis_lhs;
            }

            tmp_1.xt5_1 = tmp_3;
            this.y9_1 = 1;
            suspendResult = deserialize_1(this.xt5_1, this.ut5_1, this.tt5_1, this.wt5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            if (!isInterface(result, ByteReadChannel_1)) {
              get_LOGGER_8().e8y('Response body was converted to ' + toString_1(getKClassFromExpression(result)) + ' for ' + this.st5_1.toString() + '.');
            }

            return result;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function ContentNegotiation(registrations, ignoredTypes) {
    Plugin_getInstance_6();
    this.nt3_1 = registrations;
    this.ot3_1 = ignoredTypes;
  }
  protoOf(ContentNegotiation).pt3 = function (request, body, $completion) {
    var tmp = new $convertRequestCOROUTINE$0(this, request, body, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(ContentNegotiation).it4 = function (requestUrl, info, body, responseContentType, charset, $completion) {
    var tmp = new $convertResponseCOROUTINE$1(this, requestUrl, info, body, responseContentType, charset, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  function ContentConverterException(message) {
    Exception_init_$Init$_0(message, this);
    captureStack(this, ContentConverterException);
  }
  var properties_initialized_ContentNegotiation_kt_1ayduy;
  function _init_properties_ContentNegotiation_kt__o183go() {
    if (!properties_initialized_ContentNegotiation_kt_1ayduy) {
      properties_initialized_ContentNegotiation_kt_1ayduy = true;
      LOGGER_8 = KtorSimpleLogger('io.ktor.client.plugins.contentnegotiation.ContentNegotiation');
      DefaultCommonIgnoredTypes = setOf_0([PrimitiveClasses_getInstance().rc(), PrimitiveClasses_getInstance().nc(), getKClass(HttpStatusCode), getKClass(ByteReadChannel_1), getKClass(OutgoingContent)]);
    }
  }
  function JsonContentTypeMatcher() {
  }
  protoOf(JsonContentTypeMatcher).zt2 = function (contentType) {
    if (contentType.y8z(Application_getInstance().r8y_1)) {
      return true;
    }
    var value = contentType.x8z().toString();
    return startsWith(value, 'application/') && endsWith(value, '+json');
  };
  var JsonContentTypeMatcher_instance;
  function JsonContentTypeMatcher_getInstance() {
    return JsonContentTypeMatcher_instance;
  }
  function get_DefaultIgnoredTypes() {
    _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1();
    return DefaultIgnoredTypes;
  }
  var DefaultIgnoredTypes;
  var properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt;
  function _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1() {
    if (!properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt) {
      properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt = true;
      // Inline function 'kotlin.collections.mutableSetOf' call
      DefaultIgnoredTypes = LinkedHashSet_init_$Create$();
    }
  }
  function cachingNodeEditorAdapter(element, monitoring) {
    monitoring = monitoring === VOID ? Companion_getInstance_386().irr_1 : monitoring;
    var view = new HtmlNodeEditorView(element, VOID, true);
    var editor = new CachingNodeEditorImpl(4, EmptyCoroutineContext_getInstance(), view, monitoring);
    return new NodeEditorAdapter(editor);
  }
  function getEditorServiceWebsocketUrl($this) {
    // Inline function 'kotlin.let' call
    // Inline function 'ApiGateway.getEditorServiceWebsocketUrl.<anonymous>' call
    return getGatewayWebsocketUrl($this) + '/editor-service/api';
  }
  function getGatewayWebsocketUrl($this) {
    return replace(getGatewayUrl($this), 'http', 'ws');
  }
  function getGatewayUrl($this) {
    return window.location.origin;
  }
  function ApiGateway() {
  }
  protoOf(ApiGateway).getQueryServiceUrl = function () {
    // Inline function 'kotlin.let' call
    // Inline function 'ApiGateway.getQueryServiceUrl.<anonymous>' call
    return getGatewayUrl(this) + '/queries-service/api';
  };
  protoOf(ApiGateway).getDocumentsRevisionsServiceUrl = function () {
    // Inline function 'kotlin.let' call
    // Inline function 'ApiGateway.getDocumentsRevisionsServiceUrl.<anonymous>' call
    return getGatewayUrl(this) + '/documents-revisions-service/api';
  };
  protoOf(ApiGateway).getEditorDocumentsServiceUrl = function () {
    // Inline function 'kotlin.let' call
    // Inline function 'ApiGateway.getEditorDocumentsServiceUrl.<anonymous>' call
    return getGatewayUrl(this) + '/editor-documents-service/api';
  };
  protoOf(ApiGateway).getEditorServiceUrl = function () {
    // Inline function 'kotlin.let' call
    // Inline function 'ApiGateway.getEditorServiceUrl.<anonymous>' call
    return getGatewayUrl(this) + '/editor-service/api';
  };
  protoOf(ApiGateway).getEditorWebsocketUrl = function () {
    // Inline function 'kotlin.let' call
    // Inline function 'ApiGateway.getEditorWebsocketUrl.<anonymous>' call
    return getEditorServiceWebsocketUrl(this) + '/resolver';
  };
  protoOf(ApiGateway).getAnalyzerWebsocketUrl = function () {
    // Inline function 'kotlin.let' call
    // Inline function 'ApiGateway.getAnalyzerWebsocketUrl.<anonymous>' call
    return getGatewayWebsocketUrl(this) + '/analyzer-service/api/resolver';
  };
  protoOf(ApiGateway).getOtWebsocketUrl = function () {
    // Inline function 'kotlin.let' call
    // Inline function 'ApiGateway.getOtWebsocketUrl.<anonymous>' call
    return getGatewayWebsocketUrl(this) + '/ot-service/api';
  };
  var ApiGateway_instance;
  function ApiGateway_getInstance() {
    return ApiGateway_instance;
  }
  function renderDocumentToDom(source, highlightedNodes, $completion) {
    var tmp;
    if (highlightedNodes === VOID) {
      tmp = [];
    } else {
      tmp = highlightedNodes;
    }
    highlightedNodes = tmp;
    var tmp_0 = new $renderDocumentToDomCOROUTINE$0(source, highlightedNodes, $completion);
    tmp_0.aa_1 = Unit_instance;
    tmp_0.ba_1 = null;
    return tmp_0.ga();
  }
  function noRequestAnimationFrame(_this__u8e3s4) {
    _this__u8e3s4.poa(false);
  }
  function CapturingView() {
    this.kt6_1 = null;
  }
  protoOf(CapturingView).krw = function (container) {
    this.kt6_1 = container;
    return Companion_getInstance_25().wr_1;
  };
  function noRequestAnimationFrame$ref() {
    var l = function (p0) {
      noRequestAnimationFrame(p0);
      return Unit_instance;
    };
    l.callableName = 'noRequestAnimationFrame';
    return l;
  }
  function $renderDocumentToDomCOROUTINE$0(source, highlightedNodes, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.gt6_1 = source;
    this.ht6_1 = highlightedNodes;
  }
  protoOf($renderDocumentToDomCOROUTINE$0).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.it6_1 = new CapturingView();
            this.jt6_1 = new NonCachingNodeEditor(EmptyCoroutineContext_getInstance(), this.it6_1);
            this.y9_1 = 1;
            suspendResult = this.jt6_1.qrp(this.gt6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var indexedObject = this.ht6_1;
            var inductionVariable = 0;
            var last = indexedObject.length;
            while (inductionVariable < last) {
              var element = indexedObject[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              this.jt6_1.lrw(element);
            }

            var div = DomApi_instance.nkx();
            var htmlView = new HtmlNodeEditorView(div, noRequestAnimationFrame$ref());
            var tmp0 = this.it6_1.kt6_1;
            var tmp$ret$0 = Unit_instance;
            l$ret$1: do {
              if (tmp0 == null) {
                var message = 'Required value was null.';
                throw IllegalStateException_init_$Create$_0(toString_1(message));
              } else {
                tmp$ret$0 = tmp0;
                break l$ret$1;
              }
            }
             while (false);
            htmlView.krw(tmp$ret$0);
            return div;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  function EditorEnvironment$client$lambda($this$HttpClient) {
    var tmp = Plugin_getInstance_6();
    $this$HttpClient.uq8(tmp, EditorEnvironment$client$lambda$lambda);
    WebSockets_0($this$HttpClient, EditorEnvironment$client$lambda$lambda_0);
    return Unit_instance;
  }
  function EditorEnvironment$client$lambda$lambda($this$install) {
    json($this$install);
    return Unit_instance;
  }
  function EditorEnvironment$client$lambda$lambda_0($this$WebSockets) {
    var tmp = $this$WebSockets;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance_16();
    var tmp$ret$0 = toDuration(15, DurationUnit_SECONDS_getInstance());
    tmp.kqv_1 = _Duration___get_inWholeMilliseconds__impl__msfiry(tmp$ret$0);
    return Unit_instance;
  }
  function EditorEnvironment$monitoringClient$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(EditorEnvironment$monitoringClient$slambda).ut6 = function (metrics, $completion) {
    var tmp = this.vt6(metrics, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(EditorEnvironment$monitoringClient$slambda).oa = function (p1, $completion) {
    return this.ut6((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(EditorEnvironment$monitoringClient$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.y9_1 = 1;
            suspendResult = EditorEnvironment_getInstance().editorsApi.cs3(this.tt6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(EditorEnvironment$monitoringClient$slambda).vt6 = function (metrics, completion) {
    var i = new EditorEnvironment$monitoringClient$slambda(completion);
    i.tt6_1 = metrics;
    return i;
  };
  function EditorEnvironment$monitoringClient$slambda_0(resultContinuation) {
    var i = new EditorEnvironment$monitoringClient$slambda(resultContinuation);
    var l = function (metrics, $completion) {
      return i.ut6(metrics, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function EditorEnvironment() {
    EditorEnvironment_instance = this;
    this.wt6_1 = CoroutineScope_0(SupervisorJob());
    var tmp = this;
    tmp.xt6_1 = HttpClient_1(EditorEnvironment$client$lambda);
    var tmp_0 = this;
    var tmp_1 = ApiGateway_instance.getOtWebsocketUrl();
    var tmp_2 = get_websocketFactory();
    var tmp_3 = get_platformEdt();
    // Inline function 'kotlin.with' call
    // Inline function 'EditorEnvironment.ot.<anonymous>' call
    var $this$with = serviceContainer([Companion_instance_33.k2o(false, [UseExperimentalNodeService_instance]), ensureNotNull(get_btbLanguageWithRemoteResolve().h2p(StructureAspect_instance)), ensureNotNull(get_btbLanguageWithRemoteResolve().h2p(ReferenceFactoryRegistryAspect_instance))]);
    var tmp$ret$1 = ConceptRegistryService_instance.e2o($this$with).d6p(ReferenceFactoryRegistryService_getInstance().e2o($this$with));
    tmp_0.ot = new OtEnvironment(tmp_1, tmp_2, tmp_3, tmp$ret$1);
    this.qesApi = new QueriesApi(this.xt6_1, ApiGateway_instance.getQueryServiceUrl());
    this.explorerApi = new ExplorerApi(this.xt6_1, ApiGateway_instance.getDocumentsRevisionsServiceUrl());
    this.editorDocumentsApi = new EditorDocumentsApi(this.xt6_1, ApiGateway_instance.getEditorDocumentsServiceUrl());
    this.editorsApi = new EditorsApi(this.xt6_1, ApiGateway_instance.getEditorServiceUrl());
    var tmp_4 = this;
    tmp_4.yt6_1 = new PerformanceMonitoringClient(this.wt6_1, EditorEnvironment$monitoringClient$slambda_0(null));
    this.editorOpeningMonitoring = new ByEditorService(this.yt6_1);
    this.editorsRpc = new WebsocketEditorServiceProvider(this.xt6_1, ApiGateway_instance.getEditorWebsocketUrl());
    this.queryDraftsRpc = new WebsocketEditorServiceProvider(this.xt6_1, ApiGateway_instance.getAnalyzerWebsocketUrl());
  }
  protoOf(EditorEnvironment).zt6 = function () {
    return this.ot;
  };
  protoOf(EditorEnvironment).at7 = function () {
    return this.qesApi;
  };
  protoOf(EditorEnvironment).bt7 = function () {
    return this.explorerApi;
  };
  protoOf(EditorEnvironment).ct7 = function () {
    return this.editorDocumentsApi;
  };
  protoOf(EditorEnvironment).dt7 = function () {
    return this.editorsApi;
  };
  protoOf(EditorEnvironment).et7 = function () {
    return this.editorOpeningMonitoring;
  };
  protoOf(EditorEnvironment).ft7 = function () {
    return this.editorsRpc;
  };
  protoOf(EditorEnvironment).gt7 = function () {
    return this.queryDraftsRpc;
  };
  var EditorEnvironment_instance;
  function EditorEnvironment_getInstance() {
    if (EditorEnvironment_instance == null)
      new EditorEnvironment();
    return EditorEnvironment_instance;
  }
  function findUsages_0(docAccession, nodeId, docsPageSize, nodesPageSize) {
    var tmp = CoroutineScope_0(Dispatchers_getInstance().p14_1);
    return promise(tmp, VOID, VOID, findUsages$slambda_0(docAccession, nodeId, docsPageSize, nodesPageSize, null));
  }
  function findUsages$slambda($docAccession, $nodeId, $docsPageSize, $nodesPageSize, resultContinuation) {
    this.pt7_1 = $docAccession;
    this.qt7_1 = $nodeId;
    this.rt7_1 = $docsPageSize;
    this.st7_1 = $nodesPageSize;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(findUsages$slambda).yt7 = function ($this$promise, $completion) {
    var tmp = this.i1l($this$promise, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(findUsages$slambda).oa = function (p1, $completion) {
    return this.yt7((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(findUsages$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 4;
            this.y9_1 = 1;
            suspendResult = EditorEnvironment_getInstance().editorsRpc.zrl(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ut7_1 = suspendResult;
            this.vt7_1 = new NodePointer(this.pt7_1, new NodeId(this.qt7_1));
            this.wt7_1 = new FindUsageServiceRequest(this.vt7_1, this.rt7_1, this.st7_1);
            this.y9_1 = 2;
            suspendResult = this.ut7_1.ark(this.wt7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.xt7_1 = suspendResult;
            this.y9_1 = 3;
            suspendResult = createFindUsageResultsPaged(this.xt7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var pagedResponse = suspendResult;
            return new FindUsagePagedAdapter(pagedResponse);
          case 4:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 4) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(findUsages$slambda).i1l = function ($this$promise, completion) {
    var i = new findUsages$slambda(this.pt7_1, this.qt7_1, this.rt7_1, this.st7_1, completion);
    i.tt7_1 = $this$promise;
    return i;
  };
  function findUsages$slambda_0($docAccession, $nodeId, $docsPageSize, $nodesPageSize, resultContinuation) {
    var i = new findUsages$slambda($docAccession, $nodeId, $docsPageSize, $nodesPageSize, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.yt7($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var LOG_5;
  function createEditor_0(element) {
    _init_properties_Main_kt__xi25uv();
    return cachingNodeEditorAdapter(element, EditorEnvironment_getInstance().editorOpeningMonitoring);
  }
  function editedDocumentSource(accession, name) {
    _init_properties_Main_kt__xi25uv();
    return new EditedDocumentSource(EditorEnvironment_getInstance().editorDocumentsApi, EditorEnvironment_getInstance().editorsRpc, get_platformEdt(), accession, name);
  }
  function editedWorkingCopySource(accession, name, entityId, readonly) {
    _init_properties_Main_kt__xi25uv();
    return new EditedWorkingCopySource(EditorEnvironment_getInstance().ot, EditorEnvironment_getInstance().editorsRpc, EditorEnvironment_getInstance().editorDocumentsApi, get_platformEdt(), EntityId_init_$Create$_0(entityId), accession, name, readonly);
  }
  function editedOntologyBrowserSource(accession, nodeId, content) {
    _init_properties_Main_kt__xi25uv();
    return new EditedOntologyBrowserSource(EditorEnvironment_getInstance().editorsApi, accession, nodeId, content);
  }
  function exploredDocumentSource(accession, globalVersion) {
    _init_properties_Main_kt__xi25uv();
    return new ExploredDocumentSource(EditorEnvironment_getInstance().explorerApi, accession, numberToLong(globalVersion));
  }
  function exploredOntologyBrowserSource(accession, globalVersion, nodeId, content) {
    _init_properties_Main_kt__xi25uv();
    return new ExploredOntologyBrowserSource(EditorEnvironment_getInstance().explorerApi, accession, nodeId, content, numberToLong(globalVersion));
  }
  function historyPanelDocumentSource(accession, revision) {
    _init_properties_Main_kt__xi25uv();
    return new HistoryPanelDocumentSource(EditorEnvironment_getInstance().explorerApi, accession, revision);
  }
  function publishedQuerySource(queryId) {
    _init_properties_Main_kt__xi25uv();
    return new PublishedQuerySource(EditorEnvironment_getInstance().qesApi, numberToLong(queryId));
  }
  function draftQuerySource(queryId, name, entityId, globalVersion) {
    _init_properties_Main_kt__xi25uv();
    return new DraftQuerySource(EditorEnvironment_getInstance().ot, EditorEnvironment_getInstance().queryDraftsRpc, get_platformEdt(), EntityId_init_$Create$_0(entityId), numberToLong(queryId), name, numberToLong(globalVersion));
  }
  function getHtmlForUsageJSON(accession, usageDto) {
    _init_properties_Main_kt__xi25uv();
    // Inline function 'kotlinx.serialization.json.decodeFromDynamic' call
    var this_0 = Default_getInstance_1();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.h5d();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer_0(this_1, createKType(getKClass(UsageDto), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = decodeFromDynamic(this_0, tmp$ret$1, usageDto);
    return getHtmlForUsage(accession, tmp$ret$2);
  }
  function getHtmlForUsage(accession, usageDto) {
    _init_properties_Main_kt__xi25uv();
    var tmp = CoroutineScope_0(Dispatchers_getInstance().p14_1);
    return promise(tmp, VOID, VOID, getHtmlForUsage$slambda_0(accession, usageDto, null));
  }
  function getHtmlForResolvedNode(accession, serializedResolvedNode, highlightedNodes) {
    var tmp;
    if (highlightedNodes === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = highlightedNodes;
    }
    highlightedNodes = tmp;
    _init_properties_Main_kt__xi25uv();
    var tmp_0 = CoroutineScope_0(Dispatchers_getInstance().p14_1);
    return promise(tmp_0, VOID, VOID, getHtmlForResolvedNode$slambda_0(accession, serializedResolvedNode, highlightedNodes, null));
  }
  function getHtmlForResolvedNodeJSON(accession, serializedResolvedNode, highlightedNodeIds) {
    _init_properties_Main_kt__xi25uv();
    // Inline function 'kotlinx.serialization.json.decodeFromDynamic' call
    var this_0 = Default_getInstance_1();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.h5d();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer_0(this_1, createKType(getKClass(SerializedResolvedNode), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = decodeFromDynamic(this_0, tmp$ret$1, serializedResolvedNode);
    return getHtmlForResolvedNode(accession, tmp$ret$2, highlightedNodeIds);
  }
  function getNodeIdOfResolvedNode(node) {
    _init_properties_Main_kt__xi25uv();
    return Companion_instance_87.w2p(toString_1(node.node.pointer)).nodeId.i2s_1;
  }
  function createNode() {
    _init_properties_Main_kt__xi25uv();
    return BTBDocument(get_wrapperContext(createFreshDomainModel()));
  }
  function emptyDocJson(docType) {
    _init_properties_Main_kt__xi25uv();
    var domainModel = createFreshDomainModel();
    var ctx = get_wrapperContext(domainModel);
    var tmp;
    switch (docType) {
      case 'BTB':
        tmp = BTBDocument(ctx);
        break;
      case 'IMPORTS':
        tmp = OntologyImportRoot(ctx);
        break;
      case 'ONTOLOGY':
        tmp = OntologyLibrary(ctx);
        break;
      case 'KINDS':
        tmp = ProcessKindContainer(ctx);
        break;
      case 'PROCESSES':
        tmp = ProcessLibrary(ctx);
        break;
      case 'RELATIONS':
        tmp = RelationContainer(ctx);
        break;
      case 'NOTIONS':
        tmp = NotionLibrary(ctx);
        break;
      case 'FUNCTIONS':
        tmp = FunctionLibrary(ctx);
        break;
      case 'EXTENSIONS':
        tmp = ExtensionLibrary(ctx);
        break;
      case 'PROPERTIES':
        tmp = PropertyLibrary(ctx);
        break;
      case 'LINKS':
        tmp = LinkLibrary(ctx);
        break;
      case 'SOURCES':
        tmp = PublishedSourcesLibrary(ctx);
        break;
      case 'QUERY':
        tmp = QueryCommands(ctx);
        break;
      default:
        throw IllegalArgumentException_init_$Create$_0('emptyDocJson: unknown document type: ' + docType);
    }
    var documentNode = tmp;
    return get_docPersistence(domainModel).aka(toOtNode(documentNode));
  }
  function getFileContents(accession, jsonCallback) {
    _init_properties_Main_kt__xi25uv();
    jsonCallback('');
  }
  function EditorEvents() {
    EditorEvents_instance = this;
    this.NAVIGATE = get_NAVIGATE();
    this.FIND_USAGES = get_FIND_USAGES();
    this.BTB_CATEGORY_EVENT = get_BTB_CATEGORY_EVENT();
    this.FACT_SELECTION_EVENT = get_FACT_SELECTION_EVENT();
    this.ERROR_EVENT = get_ERROR_EVENT();
  }
  protoOf(EditorEvents).zt7 = function () {
    return this.NAVIGATE;
  };
  protoOf(EditorEvents).at8 = function () {
    return this.FIND_USAGES;
  };
  protoOf(EditorEvents).bt8 = function () {
    return this.BTB_CATEGORY_EVENT;
  };
  protoOf(EditorEvents).ct8 = function () {
    return this.FACT_SELECTION_EVENT;
  };
  protoOf(EditorEvents).dt8 = function () {
    return this.ERROR_EVENT;
  };
  var EditorEvents_instance;
  function EditorEvents_getInstance() {
    if (EditorEvents_instance == null)
      new EditorEvents();
    return EditorEvents_instance;
  }
  function EntryPoint() {
  }
  function getHtmlForUsage$slambda($accession, $usageDto, resultContinuation) {
    this.mt8_1 = $accession;
    this.nt8_1 = $usageDto;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(getHtmlForUsage$slambda).qt8 = function ($this$promise, $completion) {
    var tmp = this.i1l($this$promise, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(getHtmlForUsage$slambda).oa = function (p1, $completion) {
    return this.qt8((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(getHtmlForUsage$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.pt8_1 = new UsageEntrySource(this.mt8_1, this.nt8_1);
            this.y9_1 = 1;
            suspendResult = renderDocumentToDom(this.pt8_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(getHtmlForUsage$slambda).i1l = function ($this$promise, completion) {
    var i = new getHtmlForUsage$slambda(this.mt8_1, this.nt8_1, completion);
    i.ot8_1 = $this$promise;
    return i;
  };
  function getHtmlForUsage$slambda_0($accession, $usageDto, resultContinuation) {
    var i = new getHtmlForUsage$slambda($accession, $usageDto, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.qt8($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function getHtmlForResolvedNode$slambda($accession, $serializedResolvedNode, $highlightedNodes, resultContinuation) {
    this.zt8_1 = $accession;
    this.at9_1 = $serializedResolvedNode;
    this.bt9_1 = $highlightedNodes;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(getHtmlForResolvedNode$slambda).qt8 = function ($this$promise, $completion) {
    var tmp = this.i1l($this$promise, $completion);
    tmp.aa_1 = Unit_instance;
    tmp.ba_1 = null;
    return tmp.ga();
  };
  protoOf(getHtmlForResolvedNode$slambda).oa = function (p1, $completion) {
    return this.qt8((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(getHtmlForResolvedNode$slambda).ga = function () {
    var suspendResult = this.aa_1;
    $sm: do
      try {
        var tmp = this.y9_1;
        switch (tmp) {
          case 0:
            this.z9_1 = 2;
            this.dt9_1 = new PathEntrySource(this.zt8_1, this.at9_1);
            this.y9_1 = 1;
            suspendResult = renderDocumentToDom(this.dt9_1, this.bt9_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.ba_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z9_1 === 2) {
          throw e;
        } else {
          this.y9_1 = this.z9_1;
          this.ba_1 = e;
        }
      }
     while (true);
  };
  protoOf(getHtmlForResolvedNode$slambda).i1l = function ($this$promise, completion) {
    var i = new getHtmlForResolvedNode$slambda(this.zt8_1, this.at9_1, this.bt9_1, completion);
    i.ct9_1 = $this$promise;
    return i;
  };
  function getHtmlForResolvedNode$slambda_0($accession, $serializedResolvedNode, $highlightedNodes, resultContinuation) {
    var i = new getHtmlForResolvedNode$slambda($accession, $serializedResolvedNode, $highlightedNodes, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.qt8($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var properties_initialized_Main_kt_gqj46d;
  function _init_properties_Main_kt__xi25uv() {
    if (!properties_initialized_Main_kt_gqj46d) {
      properties_initialized_Main_kt_gqj46d = true;
      LOG_5 = getLogger(getKClass(EntryPoint));
    }
  }
  //region block: post-declaration
  protoOf(AbstractList).asJsReadonlyArrayView = asJsReadonlyArrayView;
  protoOf(AbstractMutableList).asJsReadonlyArrayView = asJsReadonlyArrayView;
  protoOf(InternalHashMap).k7 = containsAllEntries;
  protoOf(EmptyList).asJsReadonlyArrayView = asJsReadonlyArrayView;
  protoOf(CombinedContext).ej = plus;
  protoOf(AbstractCoroutineContextElement).la = get;
  protoOf(AbstractCoroutineContextElement).dj = fold;
  protoOf(AbstractCoroutineContextElement).cj = minusKey;
  protoOf(AbstractCoroutineContextElement).ej = plus;
  protoOf(ValueTimeMark).ml = compareTo;
  protoOf(JSLogger).do = severe$default;
  protoOf(JSLogger).fo = warning$default;
  protoOf(newLock$1).kr = withLock;
  protoOf(toDisposable$$inlined$toDisposable$1).sr = plus_0;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0).sr = plus_0;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_0).sr = plus_0;
  defineProp(protoOf(atomicfu$AtomicRefArray$ref), 'atomicfu$size', protoOf(atomicfu$AtomicRefArray$ref).ss);
  protoOf(JobSupport).ju = invokeOnCompletion$default;
  protoOf(JobSupport).pu = cancel$default;
  protoOf(JobSupport).ej = plus;
  protoOf(JobSupport).la = get;
  protoOf(JobSupport).dj = fold;
  protoOf(JobSupport).cj = minusKey;
  protoOf(CoroutineDispatcher).la = get_0;
  protoOf(CoroutineDispatcher).cj = minusKey_0;
  protoOf(BufferedChannel).i1c = close$default;
  protoOf(BufferedChannel).k1c = cancel$default_0;
  protoOf(ChannelCoroutine).i1c = close$default;
  protoOf(ChannelFlow).g1e = fuse$default;
  protoOf(StateFlowImpl).g1e = fuse$default;
  protoOf(ReadonlyStateFlow).g1e = fuse$default;
  protoOf(MessageQueue).asJsReadonlyArrayView = asJsReadonlyArrayView;
  protoOf(AbstractObservableList).p27 = addHandler;
  protoOf(ConstantObservableListAdapter).p27 = addHandler;
  protoOf(AbstractObservableSet).p27 = addHandler;
  protoOf(ConstantObservableSetAdapter).p27 = addHandler;
  protoOf(ObservableListWrapper).p27 = addHandler;
  protoOf(ObservableSetWrapper).p27 = addHandler;
  protoOf(CompositeEventSource).p27 = addHandler;
  protoOf(Listeners$add$$inlined$toDisposable$1).sr = plus_0;
  protoOf(ListenersMap$add$$inlined$toDisposable$1).sr = plus_0;
  protoOf(BaseReadableProperty).m2c = invoke;
  protoOf(BaseReadableProperty).p27 = addHandler;
  protoOf(DelayedValueProperty).v2c = invoke_0;
  protoOf(map$2).m2c = invoke;
  protoOf(map$2).v2c = invoke_0;
  protoOf(map$2).p27 = addHandler;
  protoOf(asValidatedProp$ValidatedProperty).v2c = invoke_0;
  protoOf(ValueProperty).v2c = invoke_0;
  protoOf(toWritableProperty$1).v2c = invoke_0;
  protoOf(SingleItemCollectionProperty).m2c = invoke;
  protoOf(SingleItemCollectionProperty).v2c = invoke_0;
  protoOf(SingleItemCollectionProperty).p27 = addHandler;
  protoOf(TerminalTransformation).sr = plus_0;
  protoOf(Transformers$listMap$1$transform$$inlined$toDisposable$1).sr = plus_0;
  protoOf(Transformers$flattenList$3$transform$$inlined$toDisposable$1).sr = plus_0;
  protoOf(SimpleAsync$onResult$$inlined$toDisposable$1).sr = plus_0;
  protoOf(AsyncTracker$Companion$EMPTY$1).e2m = workStarted;
  protoOf(AsyncTracker$Companion$EMPTY$1).f2m = workFinished;
  protoOf(JsEventDispatchThread$timerDisposable$$inlined$toDisposable$1).sr = plus_0;
  protoOf(AnonymousResourceServiceKey).g2o = get_default;
  protoOf(AnonymousResourceServiceKey).e2o = invoke_1;
  protoOf(ServiceInstance$$inlined$toDisposable$1).sr = plus_0;
  protoOf(ServiceManager).e2p = getValue;
  protoOf(ServiceManager).sr = plus_0;
  protoOf(CoroutineContextService).e2o = invoke_1;
  protoOf(DefaultValueNullPersister).v2p = isNullString;
  protoOf(EmptyStringNullPersister).s2p = isNullValue;
  protoOf(ExceptionNullPersister).v2p = isNullString;
  protoOf(ExceptionNullPersister).s2p = isNullValue;
  protoOf(NullPersisterForNullable).v2p = isNullString;
  protoOf(NullPersisterForNullable).s2p = isNullValue;
  protoOf(SimplePersister).q2q = deserialize;
  protoOf(SimplePersister).x2p = serialize;
  protoOf(Entity$modelProperty$1).m2c = invoke;
  protoOf(Entity$modelProperty$1).v2c = invoke_0;
  protoOf(Entity$modelProperty$1).p27 = addHandler;
  protoOf(BaseOtNodeProperty).v2c = invoke_0;
  protoOf(BaseOtNodeTextProperty).m2c = invoke;
  protoOf(BaseOtNodeTextProperty).p27 = addHandler;
  protoOf(MyProperty).v2c = invoke_0;
  protoOf(RawNodeFactory).j3f = createNode$default;
  protoOf(EntityContextOperationsTracker).sr = plus_0;
  protoOf(EntityContextCommandProcessor$addOperationValidator$$inlined$toDisposable$1).sr = plus_0;
  protoOf(EntityContextCommandProcessor).sr = plus_0;
  protoOf(EntityContextOperationsTracker$2).t35 = onRootAdded;
  protoOf(EntityContextOperationsTracker$2).v35 = onRootRemoved;
  protoOf(EntityContextOperationsTracker$2).u35 = onEntityFeatureChanged;
  protoOf(BaseOperation).j3p = execute$default;
  protoOf(RootOperationsExecutorChecker).t35 = onRootAdded;
  protoOf(RootOperationsExecutorChecker).v35 = onRootRemoved;
  protoOf(RootOperationsExecutorChecker).l35 = onChildAdded;
  protoOf(RootOperationsExecutorChecker).s35 = onChildRemoved;
  protoOf(RootOperationsExecutorChecker).w35 = onChildMoved;
  protoOf(RootOperationsExecutorChecker).x35 = onPropertyChanged;
  protoOf(RootOperationsExecutorChecker).y35 = onReferenceAdded;
  protoOf(RootOperationsExecutorChecker).z35 = onReferenceRemoved;
  protoOf(RootOperationsExecutorChecker).a36 = onModelBlobChanged;
  protoOf(RootOperationsExecutorChecker).b36 = onNodeEvent;
  protoOf(ModelOperationsExecutorChecker).t35 = onRootAdded;
  protoOf(ModelOperationsExecutorChecker).v35 = onRootRemoved;
  protoOf(ModelOperationsExecutorChecker).l35 = onChildAdded;
  protoOf(ModelOperationsExecutorChecker).s35 = onChildRemoved;
  protoOf(ModelOperationsExecutorChecker).w35 = onChildMoved;
  protoOf(ModelOperationsExecutorChecker).x35 = onPropertyChanged;
  protoOf(ModelOperationsExecutorChecker).y35 = onReferenceAdded;
  protoOf(ModelOperationsExecutorChecker).z35 = onReferenceRemoved;
  protoOf(ModelOperationsExecutorChecker).a36 = onModelBlobChanged;
  protoOf(EntityOperationsExecutorChecker).t35 = onRootAdded;
  protoOf(EntityOperationsExecutorChecker).v35 = onRootRemoved;
  protoOf(EntityOperationsExecutorChecker).l35 = onChildAdded;
  protoOf(EntityOperationsExecutorChecker).s35 = onChildRemoved;
  protoOf(EntityOperationsExecutorChecker).w35 = onChildMoved;
  protoOf(EntityOperationsExecutorChecker).x35 = onPropertyChanged;
  protoOf(EntityOperationsExecutorChecker).y35 = onReferenceAdded;
  protoOf(EntityOperationsExecutorChecker).z35 = onReferenceRemoved;
  protoOf(EntityOperationsExecutorChecker).a36 = onModelBlobChanged;
  protoOf(EntityOperationsExecutorChecker).b36 = onNodeEvent;
  protoOf(MetaIdPersister).q2q = deserialize;
  protoOf(MetaIdPersister).x2p = serialize;
  protoOf(EntityIdPersisters$entityReferencePersister$1).q2q = deserialize;
  protoOf(EntityIdPersisters$entityReferencePersister$1).x2p = serialize;
  protoOf(DefaultIdPersister).q2q = deserialize;
  protoOf(DefaultIdPersister).x2p = serialize;
  protoOf(CompressingIdPersister).q2q = deserialize;
  protoOf(CompressingIdPersister).x2p = serialize;
  protoOf(UndoCommandListener).y3k = onExternalOperationStarted;
  protoOf(UndoCommandListener).a3l = onExternalOperationFailed;
  protoOf(BaseUndoManager$addStateProvider$$inlined$toDisposable$1).sr = plus_0;
  protoOf(BaseUndoManager).sr = plus_0;
  protoOf(NodeWrapper$propertyByStringProperty$1).v2c = invoke_0;
  protoOf(WrapperContext$put$$inlined$toDisposable$1).sr = plus_0;
  protoOf(WrapperContext).sr = plus_0;
  protoOf(WrapperContextService).g2o = get_default;
  protoOf(WrapperContextService).e2o = invoke_1;
  protoOf(EagerInvalidatable).m2c = invoke;
  protoOf(EagerInvalidatable).p27 = addHandler;
  protoOf(InvalidationPointBase$addHandler$$inlined$toDisposable$1).sr = plus_0;
  protoOf(InvalidationPointBase).p27 = addHandler;
  protoOf(Invalidator).sr = plus_0;
  protoOf(NonTrackingInvalidationContext).sr = plus_0;
  protoOf(attributeQuery$$inlined$query$1).h4x = runSuspend;
  protoOf(LoopingQuery).m2c = invoke;
  protoOf(LoopingQuery).p27 = addHandler;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_1).sr = plus_0;
  protoOf(constant$$inlined$query$1).h4x = runSuspend;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_2).sr = plus_0;
  protoOf(QPropertyAdapter).h4x = runSuspend;
  protoOf(QPropertyAdapter).v2c = invoke_0;
  protoOf(QMutableListAdapter).o = addAll;
  protoOf(QMutableListAdapter).p2 = add_0;
  protoOf(QMutableListAdapter).e = add;
  protoOf(QMutableListAdapter).m2 = clear;
  protoOf(QMutableListAdapter).n = get_size;
  protoOf(QMutableListAdapter).s = contains;
  protoOf(QMutableListAdapter).h4x = runSuspend;
  protoOf(QTextPropertyAdapter).h4x = runSuspend;
  protoOf(QReadablePropertyAdapter).h4x = runSuspend;
  protoOf(QListAdapter).n = get_size;
  protoOf(QListAdapter).s = contains;
  protoOf(QListAdapter).h4x = runSuspend;
  protoOf(QCollectionAdapter).n = get_size;
  protoOf(QCollectionAdapter).s = contains;
  protoOf(QCollectionAdapter).h4x = runSuspend;
  protoOf(QMutableCollectionAdapter).m2 = clear;
  protoOf(QMutableCollectionAdapter).n = get_size;
  protoOf(QMutableCollectionAdapter).s = contains;
  protoOf(QMutableCollectionAdapter).h4x = runSuspend;
  protoOf(Companion_77).t52 = tryFromFloat$default;
  protoOf(Companion_77).v52 = tryFromDouble$default;
  protoOf(Companion_77).q52 = parseString$default;
  protoOf(BigDecimal).g53 = plus_2;
  protoOf(BigDecimal).i53 = minus_0;
  protoOf(Companion_79).q52 = parseString$default;
  protoOf(Companion_79).t52 = tryFromFloat$default;
  protoOf(Companion_79).v52 = tryFromDouble$default;
  protoOf(BigInteger).y52 = plus_1;
  protoOf(BigInteger).a53 = minus;
  protoOf(BigInteger).c53 = times;
  protoOf(BigInteger).h53 = times_0;
  protoOf(BigInteger).e53 = div;
  protoOf(BigInteger).j53 = div_0;
  protoOf(BigInteger).k53 = rem;
  protoOf(SerialDescriptorImpl).l5e = get_isNullable;
  protoOf(SerialDescriptorImpl).q5e = get_isInline;
  protoOf(AbstractDecoder).w5g = decodeSerializableElement$default;
  protoOf(AbstractDecoder).l5d = decodeSerializableValue;
  protoOf(AbstractDecoder).y5g = decodeSequentially;
  protoOf(AbstractDecoder).a5h = decodeCollectionSize;
  protoOf(AbstractEncoder).c5i = encodeNotNullMark;
  protoOf(AbstractEncoder).d5i = beginCollection;
  protoOf(AbstractEncoder).i5d = encodeSerializableValue;
  protoOf(AbstractEncoder).b5i = encodeNullableSerializableValue;
  protoOf(AbstractEncoder).e5i = shouldEncodeElementDefault;
  protoOf(ListLikeDescriptor).l5e = get_isNullable;
  protoOf(ListLikeDescriptor).q5e = get_isInline;
  protoOf(ListLikeDescriptor).x5c = get_annotations;
  protoOf(MapLikeDescriptor).l5e = get_isNullable;
  protoOf(MapLikeDescriptor).q5e = get_isInline;
  protoOf(MapLikeDescriptor).x5c = get_annotations;
  protoOf(PluginGeneratedSerialDescriptor).l5e = get_isNullable;
  protoOf(PluginGeneratedSerialDescriptor).q5e = get_isInline;
  protoOf(InlinePrimitiveDescriptor$1).j5o = typeParametersSerializers;
  protoOf(NothingSerialDescriptor).l5e = get_isNullable;
  protoOf(NothingSerialDescriptor).q5e = get_isInline;
  protoOf(NothingSerialDescriptor).x5c = get_annotations;
  protoOf(PrimitiveSerialDescriptor_0).l5e = get_isNullable;
  protoOf(PrimitiveSerialDescriptor_0).q5e = get_isInline;
  protoOf(PrimitiveSerialDescriptor_0).x5c = get_annotations;
  protoOf(TaggedEncoder).d5i = beginCollection;
  protoOf(TaggedEncoder).i5d = encodeSerializableValue;
  protoOf(TaggedEncoder).b5i = encodeNullableSerializableValue;
  protoOf(TaggedEncoder).e5i = shouldEncodeElementDefault;
  protoOf(TaggedDecoder).w5g = decodeSerializableElement$default;
  protoOf(TaggedDecoder).l5d = decodeSerializableValue;
  protoOf(TaggedDecoder).y5g = decodeSequentially;
  protoOf(TaggedDecoder).a5h = decodeCollectionSize;
  protoOf(ProtobufTaggedDecoder).w5g = decodeSerializableElement$default;
  protoOf(ProtobufTaggedDecoder).l5d = decodeSerializableValue;
  protoOf(ProtobufTaggedDecoder).y5g = decodeSequentially;
  protoOf(ProtobufTaggedDecoder).a5h = decodeCollectionSize;
  protoOf(ProtobufTaggedEncoder).c5i = encodeNotNullMark;
  protoOf(ProtobufTaggedEncoder).d5i = beginCollection;
  protoOf(ProtobufTaggedEncoder).i5d = encodeSerializableValue;
  protoOf(ProtobufTaggedEncoder).b5i = encodeNullableSerializableValue;
  protoOf(ProtobufTaggedEncoder).e5i = shouldEncodeElementDefault;
  protoOf(JsonArray_0).asJsReadonlyArrayView = asJsReadonlyArrayView;
  protoOf(defer$1).l5e = get_isNullable;
  protoOf(defer$1).q5e = get_isInline;
  protoOf(defer$1).x5c = get_annotations;
  protoOf(PolymorphismValidator).n5x = contextual;
  protoOf(LocalNodePointerSupport$node$$inlined$query$1).h4x = runSuspend;
  protoOf(LocalNodePointerSupport).sr = plus_0;
  protoOf(Companion_88).g2o = get_default;
  protoOf(Companion_88).e2o = invoke_1;
  protoOf(Companion_89).e2o = invoke_1;
  protoOf(OtNodeFactoryService).g2o = get_default;
  protoOf(OtNodeFactoryService).e2o = invoke_1;
  protoOf($serializer).j5o = typeParametersSerializers;
  protoOf(DomainNodePersister).q2q = deserialize;
  protoOf(DomainNodePersister).x2p = serialize;
  protoOf(FindNodeQueryProvider$findNode$1).p27 = addHandler;
  protoOf(FindNodeQueryProvider$findNode$$inlined$query$1).h4x = runSuspend;
  protoOf(FindNodeQueryProvider).sr = plus_0;
  protoOf(OTNodePersister).q2q = deserialize;
  protoOf(OTNodePersister).x2p = serialize;
  protoOf(Companion_92).g2o = get_default;
  protoOf(Companion_92).e2o = invoke_1;
  protoOf(SameModelNodeFinder$find$$inlined$map$1).h4x = runSuspend;
  protoOf(SameModelNodeFinder).a6m = pointer;
  protoOf(SameModelNodeFinder).sr = plus_0;
  protoOf(SingleRootNodePointerSupport$node$$inlined$query$1).h4x = runSuspend;
  protoOf(SingleRootNodePointerSupport).sr = plus_0;
  protoOf(BaseTypedOtNode).yt = get_parent;
  protoOf(NodeSetupContextService).g2o = get_default;
  protoOf(NodeSetupContextService).e2o = invoke_1;
  protoOf(OTConceptImpl).b6p = createNode$default_0;
  protoOf(DomainNodeFactoryImpl).b6p = createNode$default_0;
  protoOf(ErrorNodeFactory).b6p = createNode$default_0;
  protoOf(OTConceptWrapperImpl).b6p = createNode$default_0;
  protoOf(DomainNodeWrapperFactoryImpl).b6p = createNode$default_0;
  protoOf(UseExperimentalNodeService).g2o = get_default;
  protoOf(UseExperimentalNodeService).e2o = invoke_1;
  protoOf(BaseDomainNodeProperty).h4x = runSuspend;
  protoOf(DomainNodeChildProperty).h4x = runSuspend;
  protoOf(DomainNodeInMemoryProperty).h4x = runSuspend;
  protoOf(DomainNodeTextProperty).h4x = runSuspend;
  protoOf(PropertyBasedReference).u6s = get_regular;
  protoOf(PropertyBasedReference).t6s = set;
  protoOf(PropertyBasedReference).v6s = invoke_3;
  protoOf(PropertyBasedReference).v2c = invoke_0;
  protoOf(PropertyBasedReference).w6s = runSuspend_0;
  protoOf(Companion_96).g2o = get_default;
  protoOf(Companion_96).e2o = invoke_1;
  protoOf(GlobalNodeFinder$find$$inlined$query$1).h4x = runSuspend;
  protoOf(PrecalculatedResolutionReference$Companion$throwIfMissing$$inlined$query$1).h4x = runSuspend;
  protoOf(PrecalculatedResolutionReference$resolve$$inlined$map$1).h4x = runSuspend;
  protoOf(PrecalculatedResolutionReference$find$$inlined$map$1).h4x = runSuspend;
  protoOf($serializer_0).j5o = typeParametersSerializers;
  protoOf($serializer_1).j5o = typeParametersSerializers;
  protoOf(ReferenceFactoryRegistryService).e2o = invoke_1;
  protoOf(ReferenceTargetPresentationProvidersRegistryService).e2o = invoke_1;
  protoOf(ReferenceTargetPresentationProvidersRegistryBuilderImpl).z6x = referenceTargetPresentation$default;
  protoOf(ReferenceTargetsSuppliersRegistryService).e2o = invoke_1;
  protoOf(ResolveConfigService).g2o = get_default;
  protoOf(ResolveConfigService).e2o = invoke_1;
  protoOf($serializer_2).j5o = typeParametersSerializers;
  protoOf($serializer_3).j5o = typeParametersSerializers;
  protoOf($serializer_4).j5o = typeParametersSerializers;
  protoOf(BaseDocumentRepository).g6z = provide;
  protoOf(BaseDocumentRepository).sr = plus_0;
  protoOf(Companion_108).g2o = get_default;
  protoOf(Companion_108).e2o = invoke_1;
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0).p27 = addHandler;
  protoOf(BaseDocumentContainer$documents$$inlined$query$1).h4x = runSuspend;
  protoOf(BaseDocumentContainer$getDocumentQuery$$inlined$query$1).h4x = runSuspend;
  protoOf(BaseDocumentContainer).sr = plus_0;
  protoOf(Companion_110).g2o = get_default;
  protoOf(Companion_110).e2o = invoke_1;
  protoOf(Companion_110).m2c = invoke_2;
  protoOf(DocumentContainerProvider$provide$$inlined$query$1).h4x = runSuspend;
  protoOf(Companion_111).g2o = get_default;
  protoOf(Companion_111).e2o = invoke_1;
  protoOf($serializer_5).j5o = typeParametersSerializers;
  protoOf(DomainNodeConceptRegistry$getNodeFactory$1).j3f = createNode$default;
  protoOf(NodeWrapperConceptRegistryImpl).d6p = getNodeFactory;
  protoOf(ConceptRegistryService).g2o = get_default;
  protoOf(ConceptRegistryService).e2o = invoke_1;
  protoOf(BaseStructureModel).sr = plus_0;
  protoOf(Companion_115).g2o = get_default;
  protoOf(Companion_115).e2o = invoke_1;
  protoOf(ancestorOrSelf$$inlined$query$1).h4x = runSuspend;
  protoOf(DomainModel).sr = plus_0;
  protoOf(Companion_117).g2o = get_default;
  protoOf(Companion_117).e2o = invoke_1;
  protoOf(ErrorCheckConfigBuilder).e2p = getValue;
  protoOf(ScopeConfigBuilderImpl).o77 = with_0;
  protoOf(ScopeConfigService).g2o = get_default;
  protoOf(ScopeConfigService).e2o = invoke_1;
  protoOf(Companion_122).g2o = get_default;
  protoOf(Companion_122).e2o = invoke_1;
  protoOf(Companion_122).i2o = optional;
  protoOf(Companion_123).e2o = invoke_1;
  protoOf(ProvidedScopesContainer).sr = plus_0;
  protoOf(ScopeProvidersManager).sr = plus_0;
  protoOf(Companion_126).e2o = invoke_1;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_3).sr = plus_0;
  protoOf(ScopingRulesEngine$getDocumentScope$$inlined$map$1).h4x = runSuspend;
  protoOf(CollectionScope).h75 = find_0;
  protoOf(CollectionScope).k75 = applyFilter;
  protoOf(DelegatingScope).k75 = applyFilter;
  protoOf(EmptyScope).h75 = find_0;
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).c7y = onTargetAdded;
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).d7y = onTargetRenamed;
  protoOf(sam$jetbrains_ocelot_langDef_scopes_helper_ScopeListenerAdapter$0).e7y = onTargetRemoved;
  protoOf(IndexingScope).h75 = find_0;
  protoOf(IndexingScope).k75 = applyFilter;
  protoOf(AbstractScopedReferenceResolver).b6u = find;
  protoOf(FindUsagesConfigService).g2o = get_default;
  protoOf(FindUsagesConfigService).e2o = invoke_1;
  protoOf(UsagePresentationData).v39 = get_id;
  protoOf(UsagePresentationData).h3f = get_conceptId;
  protoOf(UsagePresentationData).u3o = get_root;
  protoOf(UsagePresentationData).m6m = get_observableParent;
  protoOf(UsagePresentationData).n6m = get_roleInParent;
  protoOf(UsagePresentationData).s6m = replaceWith;
  protoOf(UsagePresentationData).v6m = getDescendants;
  protoOf(UsagePresentationData).w6m = getAllChildren;
  protoOf(UsagePresentationData).yt = get_parent;
  protoOf(ByteChannelSequentialBase).d8k = readRemaining$default;
  protoOf(ChannelJob).pu = cancel$default;
  protoOf(ChannelJob).ju = invokeOnCompletion$default;
  protoOf(AttributesJs).k8s = get_1;
  protoOf(EmptyHeaders).fe = get_2;
  protoOf(EmptyHeaders).j8u = forEach;
  protoOf(EmptyParameters).j8u = forEach;
  protoOf(DefaultWebSocketSessionImpl).k9a = send;
  defineProp(protoOf(FrameTooBigException), 'message', function () {
    return this.t1();
  });
  protoOf($serializer_6).j5o = typeParametersSerializers;
  protoOf($serializer_7).j5o = typeParametersSerializers;
  protoOf($serializer_8).j5o = typeParametersSerializers;
  protoOf(RemoteInstancePublication).sr = plus_0;
  protoOf($serializer_9).j5o = typeParametersSerializers;
  protoOf(RpcEndpointMethod).pu = cancel$default;
  protoOf(RpcEndpointMethod).ju = invokeOnCompletion$default;
  protoOf(RpcEndpointImpl).sr = plus_0;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_4).sr = plus_0;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_5).sr = plus_0;
  protoOf(RpcFacadeImpl).m9l = publishInstance$default;
  protoOf(RpcInstancesPublisher).sr = plus_0;
  protoOf($serializer_11).j5o = typeParametersSerializers;
  protoOf($serializer_12).j5o = typeParametersSerializers;
  protoOf($serializer_13).j5o = typeParametersSerializers;
  protoOf($serializer_14).j5o = typeParametersSerializers;
  protoOf(Companion_165).g2o = get_default;
  protoOf(Companion_165).e2o = invoke_1;
  protoOf(flowBasedMethod$1$$inlined$toDisposable$1).sr = plus_0;
  protoOf(RemoteDisposable).sr = plus_0;
  protoOf($serializer_16).j5o = typeParametersSerializers;
  protoOf($serializer_17).j5o = typeParametersSerializers;
  protoOf($serializer_18).j5o = typeParametersSerializers;
  protoOf($serializer_19).j5o = typeParametersSerializers;
  protoOf($serializer_20).j5o = typeParametersSerializers;
  protoOf($serializer_21).j5o = typeParametersSerializers;
  protoOf($serializer_22).j5o = typeParametersSerializers;
  protoOf($serializer_23).j5o = typeParametersSerializers;
  protoOf($serializer_24).j5o = typeParametersSerializers;
  protoOf($serializer_25).j5o = typeParametersSerializers;
  protoOf(sam$jetbrains_ocelot_base_observable_event_EventSource$0_0).p27 = addHandler;
  protoOf(LiveResolutionClientState$findTarget$$inlined$query$1).h4x = runSuspend;
  protoOf(LiveResolutionClientState$findLocalTarget$$inlined$query$1).h4x = runSuspend;
  protoOf(Companion_183).g2o = get_default;
  protoOf(Companion_183).e2o = invoke_1;
  protoOf(Companion_184).g2o = get_default;
  protoOf(Companion_184).e2o = invoke_1;
  protoOf(AbstractLinkImpl).uc1 = get_defaultLibraryReference;
  protoOf(BTBDocumentImpl).dct = librariesForElement;
  protoOf(BindingPropertyImpl).b3 = get_name;
  protoOf(BindingPropertyImpl).zb3 = get_type;
  protoOf(PublishedWorkImpl).dcu = citation;
  protoOf(ClassExpressionTypeImpl).zb3 = get_type_0;
  protoOf(EmptyBindingEntryImpl).b3 = get_name_1;
  protoOf(EnumValueImpl).gcw = transformToPropertyReferenceValue;
  protoOf(FunctionTermImpl).gcw = transformToPropertyReferenceValue;
  protoOf(ImportedLinkImpl).b3 = get_name_2;
  protoOf(ImportedLinkImpl).lay = get_element;
  protoOf(ImportedLinkImpl).sba = get_specificator;
  protoOf(ImportedPropertyImpl).b3 = get_name_3;
  protoOf(ImportedPropertyImpl).zb3 = get_type_1;
  protoOf(LocalOntologyElementReferenceImpl).ud1 = get_getClassDeclaration;
  protoOf(MeasurableValueImpl).fd2 = amount;
  protoOf(MeasurableValueImpl).gcw = transformToPropertyReferenceValue;
  protoOf(NoValuesImpl).lbn = get_types;
  protoOf(ObjectPropertyReferenceValueImpl).ad5 = removePropertyReference;
  protoOf(ObjectPropertyReferenceValueImpl).gcw = transformToPropertyReferenceValue;
  protoOf(OldPublishedSourceImpl).dcu = citation_0;
  protoOf(OntologyElementImpl).nd6 = get_temporaryUnionClassDefinition;
  protoOf(OntologyElementImpl).od6 = allTaxonElements;
  protoOf(OntologyElementImpl).pd6 = isSubtypeOf;
  protoOf(OntologyElementPropertyTypeImpl).zb3 = get_type_0;
  protoOf(OntologyElementReferenceImpl).ud1 = get_getClassDeclaration;
  protoOf(OntologyElementReferenceValueImpl).gcw = transformToPropertyReferenceValue;
  protoOf(OntologyIsRelationImpl).md8 = getElementReference;
  protoOf(OntologyLinkImpl).b3 = get_name_5;
  protoOf(OntologyLinkImpl).lay = get_element_0;
  protoOf(OntologyLinkImpl).sba = get_specificator_0;
  protoOf(OntologyLinkValueImpl).nd9 = importedLibraries;
  protoOf(PartValueImpl).xda = transformToVariableReference;
  protoOf(PartValueImpl).gcw = transformToPropertyReferenceValue;
  protoOf(ProcessDeclarationImpl).odb = aliasedProperties;
  protoOf(ProcessDeclarationImpl).pdb = allEntries;
  protoOf(ProcessDeclarationImpl).qdb = allProperties;
  protoOf(ProcessDeclarationImpl).rdb = allSuperProperties;
  protoOf(ProcessDeclarationImpl).sdb = cycleInExtends;
  protoOf(ProcessPropertyReferenceImpl).gcw = transformToPropertyReferenceValue;
  protoOf(ProcessRelationDeclarationImpl).gde = isValid;
  protoOf(PropertyLibraryImpl).pas = get_properties;
  protoOf(QualifiedOntologyElementReferenceImpl).lay = get_element_1;
  protoOf(QualifiedOntologyElementReferenceImpl).ud1 = get_getClassDeclaration;
  protoOf(SetExpressionImpl).gcw = transformToPropertyReferenceValue;
  protoOf(SimplePropertyTypeImpl).zb3 = get_type_0;
  protoOf(TypedAbstractLinkImpl).uc1 = get_defaultLibraryReference;
  protoOf(TypedBTBDocumentImpl).dct = librariesForElement;
  protoOf(TypedBindingPropertyImpl).b3 = get_name;
  protoOf(TypedBindingPropertyImpl).zb3 = get_type;
  protoOf(TypedPublishedWorkImpl).dcu = citation;
  protoOf(TypedClassExpressionTypeImpl).zb3 = get_type_0;
  protoOf(TypedEmptyBindingEntryImpl).b3 = get_name_1;
  protoOf(TypedEnumValueImpl).gcw = transformToPropertyReferenceValue;
  protoOf(TypedFunctionTermImpl).gcw = transformToPropertyReferenceValue;
  protoOf(TypedImportedLinkImpl).b3 = get_name_2;
  protoOf(TypedImportedLinkImpl).lay = get_element;
  protoOf(TypedImportedLinkImpl).sba = get_specificator;
  protoOf(TypedImportedPropertyImpl).b3 = get_name_3;
  protoOf(TypedImportedPropertyImpl).zb3 = get_type_1;
  protoOf(TypedLocalOntologyElementReferenceImpl).ud1 = get_getClassDeclaration;
  protoOf(TypedMeasurableValueImpl).fd2 = amount;
  protoOf(TypedMeasurableValueImpl).gcw = transformToPropertyReferenceValue;
  protoOf(TypedNoValuesImpl).lbn = get_types;
  protoOf(TypedObjectPropertyReferenceValueImpl).ad5 = removePropertyReference;
  protoOf(TypedObjectPropertyReferenceValueImpl).gcw = transformToPropertyReferenceValue;
  protoOf(TypedOldPublishedSourceImpl).dcu = citation_0;
  protoOf(TypedOntologyElementImpl).nd6 = get_temporaryUnionClassDefinition;
  protoOf(TypedOntologyElementImpl).od6 = allTaxonElements;
  protoOf(TypedOntologyElementImpl).pd6 = isSubtypeOf;
  protoOf(TypedOntologyElementPropertyTypeImpl).zb3 = get_type_0;
  protoOf(TypedOntologyElementReferenceImpl).ud1 = get_getClassDeclaration;
  protoOf(TypedOntologyElementReferenceValueImpl).gcw = transformToPropertyReferenceValue;
  protoOf(TypedOntologyIsRelationImpl).md8 = getElementReference;
  protoOf(TypedOntologyLinkImpl).b3 = get_name_5;
  protoOf(TypedOntologyLinkImpl).lay = get_element_0;
  protoOf(TypedOntologyLinkImpl).sba = get_specificator_0;
  protoOf(TypedOntologyLinkValueImpl).nd9 = importedLibraries;
  protoOf(TypedPartValueImpl).xda = transformToVariableReference;
  protoOf(TypedPartValueImpl).gcw = transformToPropertyReferenceValue;
  protoOf(TypedProcessDeclarationImpl).odb = aliasedProperties;
  protoOf(TypedProcessDeclarationImpl).pdb = allEntries;
  protoOf(TypedProcessDeclarationImpl).qdb = allProperties;
  protoOf(TypedProcessDeclarationImpl).rdb = allSuperProperties;
  protoOf(TypedProcessDeclarationImpl).sdb = cycleInExtends;
  protoOf(TypedProcessPropertyReferenceImpl).gcw = transformToPropertyReferenceValue;
  protoOf(TypedProcessRelationDeclarationImpl).gde = isValid;
  protoOf(TypedPropertyLibraryImpl).pas = get_properties;
  protoOf(TypedQualifiedOntologyElementReferenceImpl).lay = get_element_1;
  protoOf(TypedQualifiedOntologyElementReferenceImpl).ud1 = get_getClassDeclaration;
  protoOf(TypedSetExpressionImpl).gcw = transformToPropertyReferenceValue;
  protoOf(TypedSimplePropertyTypeImpl).zb3 = get_type_0;
  protoOf(TypedUnionClassImpl).ud1 = get_getClassDeclaration_0;
  protoOf(TypedUnionClassImpl).gcw = transformToPropertyReferenceValue;
  protoOf(TypedValueWithRelationsImpl).gcw = transformToPropertyReferenceValue;
  protoOf(TypedVariableReferenceValueImpl).gcw = transformToPropertyReferenceValue;
  protoOf(UnionClassImpl).ud1 = get_getClassDeclaration_0;
  protoOf(UnionClassImpl).gcw = transformToPropertyReferenceValue;
  protoOf(ValueWithRelationsImpl).gcw = transformToPropertyReferenceValue;
  protoOf(VariableReferenceValueImpl).gcw = transformToPropertyReferenceValue;
  protoOf(LinkStubImpl).lay = get_element_2;
  protoOf(LinkStubImpl).sba = get_specificator_1;
  protoOf(TypedLinkStubImpl).lay = get_element_2;
  protoOf(TypedLinkStubImpl).sba = get_specificator_1;
  protoOf(BtbOtNodePersister).q2q = deserialize;
  protoOf(BtbOtNodePersister).x2p = serialize;
  protoOf(OntologyLink$specificator$$inlined$query$1).h4x = runSuspend;
  protoOf(OntologyElement$temporaryUnionClassDefinition$$inlined$query$1).h4x = runSuspend;
  protoOf(OntologyIsRelation$getElementReference$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(QualifiedOntologyElementReference$element$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(ProcessPropertyType$type$$inlined$query$1).h4x = runSuspend;
  protoOf(PropertyLibrary$properties$$inlined$map$1).h4x = runSuspend;
  protoOf(BindingProperty$name$$inlined$query$1).h4x = runSuspend;
  protoOf(PublishedWork$citation$$inlined$query$1).h4x = runSuspend;
  protoOf(PublishedWork$authorsPart$$inlined$query$1).h4x = runSuspend;
  protoOf(ProcessRelationDeclaration$isValid$$inlined$query$1).h4x = runSuspend;
  protoOf(PartValue$transformToVariableReference$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(ObjectPropertyReferenceValue$removePropertyReference$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(btbErrorChecking$1$2$$inlined$query$1).h4x = runSuspend;
  protoOf(btbErrorChecking$1$22$$inlined$query$1).h4x = runSuspend;
  protoOf(duplicates$$inlined$query$1).h4x = runSuspend;
  protoOf(PublishedWorkReferenceResolver$resolve$$inlined$map$1).h4x = runSuspend;
  protoOf(PublishedWorkReferenceResolver).b6u = find;
  protoOf(SubtypeScopeFilterService$Companion$default$1).bh5 = provideFilterFor;
  protoOf(Companion_225).e2o = invoke_1;
  protoOf(Companion_225).m2c = invoke_2;
  protoOf(Companion_226).e2o = invoke_1;
  protoOf(Companion_226).m2c = invoke_2;
  protoOf(OntologyElementAdapter$definition$$inlined$query$1).h4x = runSuspend;
  protoOf(OntologyElementReferenceAdapter).sk6 = resolve;
  protoOf(getAssertedDefinitionElements$$inlined$map$1).h4x = runSuspend;
  protoOf(getAllNaturalDefinitionElements$$inlined$map$1).h4x = runSuspend;
  protoOf($serializer_26).j5o = typeParametersSerializers;
  protoOf($serializer_27).j5o = typeParametersSerializers;
  protoOf(JsonService$Companion$toStringPort$1).sr = plus_0;
  protoOf(JsonServiceEndpoint).sr = plus_0;
  protoOf(PortExecutingDelegate).sr = plus_0;
  protoOf(CommandDeserializer).sr = plus_0;
  protoOf(ServiceEndpointPort).sr = plus_0;
  protoOf(EndpointMultiplexPort).sr = plus_0;
  protoOf(MyPort).sr = plus_0;
  protoOf(ServiceEndpointContainer).sr = plus_0;
  protoOf(SocketConnection).sr = plus_0;
  protoOf(ReconnectStrategy).sr = plus_0;
  protoOf(MyPort_0).sr = plus_0;
  protoOf(Client$init$validator$1).a3j = reset;
  protoOf(Client$init$listener$1).w3k = onCommandStarted;
  protoOf(Client$init$listener$1).t3k = onOperationPerformed;
  protoOf(Client$init$listener$1).y3k = onExternalOperationStarted;
  protoOf(Client).sr = plus_0;
  protoOf(ClientRootImpl$load$$inlined$toDisposable$1).sr = plus_0;
  protoOf(OtServiceEndpoint$MyThrottlingJsonPort$1$wrappedClientPort$1).sr = plus_0;
  protoOf(CommonJsonPort).sr = plus_0;
  protoOf(onEvent$$inlined$toDisposable$1).sr = plus_0;
  protoOf(MultilineTextClipboardContent).hl0 = toText;
  protoOf(SingleLineTextClipboardContent).hl0 = toText;
  protoOf(BaseRoleSynchronizer).vr = dispose;
  protoOf(BaseRoleSynchronizer).sr = plus_0;
  protoOf(ByTargetIndex).sr = plus_0;
  protoOf(DisposableSynchronizer).vr = dispose;
  protoOf(DisposableSynchronizer).sr = plus_0;
  protoOf(syncTwoWay$1).vr = dispose;
  protoOf(syncTwoWay$1).sr = plus_0;
  protoOf(Mappers$attachRoot$$inlined$toDisposable$1).sr = plus_0;
  protoOf(Synchronizers$forDisposables$1).vr = dispose;
  protoOf(Synchronizers$forDisposables$1).sr = plus_0;
  protoOf(Synchronizers$composite$1).vr = dispose;
  protoOf(Synchronizers$composite$1).sr = plus_0;
  protoOf(ReloadableSynchronizer).vr = dispose;
  protoOf(ReloadableSynchronizer).sr = plus_0;
  protoOf(BaseCell$ExternalChildList$addListener$cellListener$1).tlk = onPropertyChanged_0;
  protoOf(BaseCell$ExternalChildList$addListener$cellListener$1).ulk = onParentChanged;
  protoOf(BaseCell$ExternalChildList$addListener$cellListener$1).vlk = onAttach;
  protoOf(BaseCell$ExternalChildList$addListener$cellListener$1).wlk = onDetach;
  protoOf(BaseCell$cellContainer$1$addHandler$cellListener$1).tlk = onPropertyChanged_0;
  protoOf(BaseCell$cellContainer$1$addHandler$cellListener$1).olk = onChildAdded_0;
  protoOf(BaseCell$cellContainer$1$addHandler$cellListener$1).plk = onChildRemoved_0;
  protoOf(BaseCell$cellContainer$1$addHandler$cellListener$1).ulk = onParentChanged;
  protoOf(BaseCell$getProp$MyProperty$addHandler$cellListener$1).olk = onChildAdded_0;
  protoOf(BaseCell$getProp$MyProperty$addHandler$cellListener$1).plk = onChildRemoved_0;
  protoOf(BaseCell$getProp$MyProperty$addHandler$cellListener$1).ulk = onParentChanged;
  protoOf(BaseCell$getProp$MyProperty$addHandler$cellListener$1).vlk = onAttach;
  protoOf(BaseCell$getProp$MyProperty$addHandler$cellListener$1).wlk = onDetach;
  protoOf(ExternalChildList).p27 = addHandler;
  protoOf(BaseCell$addTrait$$inlined$toDisposable$1).sr = plus_0;
  protoOf(BaseCell$cellContainer$1).m2c = invoke;
  protoOf(BaseCell$cellContainer$1).p27 = addHandler;
  protoOf(BaseCell$set$$inlined$toDisposable$1).sr = plus_0;
  protoOf(BaseCell$getProp$MyProperty).v2c = invoke_0;
  protoOf(ScrollPopupSpec).flr = get_isLowPriority;
  protoOf(onAsyncWorkDone$1).e2m = workStarted;
  protoOf(CompletionMenu$CompletionMenuModelMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(CompletionMenu$CompletionItemMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(CompletionMenuSpec).flr = get_isLowPriority;
  protoOf(CompletionMenu$createCell$$inlined$toDisposable$1).sr = plus_0;
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$1).sr = plus_0;
  protoOf(CompletionSupport$showCompletion$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$2).sr = plus_0;
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$3).sr = plus_0;
  protoOf(CompletionSupport$showCompletion$$inlined$toDisposable$4).sr = plus_0;
  protoOf(PopupCompletionEditor$$inlined$toDisposable$1).sr = plus_0;
  protoOf(PopupCompletionEditor).sr = plus_0;
  protoOf(SimpleCompletionEditor).sr = plus_0;
  protoOf(MyVisibleItemsUpdater).sr = plus_0;
  protoOf(CompletionMenuModel).sr = plus_0;
  protoOf(TransformedCompletionResult).cq = get_items;
  protoOf(TransformedCompletionResult).am9 = transform;
  protoOf(TransformedCompletionResult).p27 = addHandler;
  protoOf(TransformedCompletionResult).sr = plus_0;
  protoOf(CompletionResultTransformer$add$1).am9 = transform;
  protoOf(CompletionResultTransformer$add$1).p27 = addHandler;
  protoOf(CompletionResultTransformer$add$1).sr = plus_0;
  protoOf(ReadyCompletionResult).cq = get_items;
  protoOf(ReadyCompletionResult).am9 = transform;
  protoOf(ReadyCompletionResult).p27 = addHandler;
  protoOf(ReadyCompletionResult).sr = plus_0;
  protoOf(FlowBasedCompletionResult).am9 = transform;
  protoOf(FlowBasedCompletionResult).p27 = addHandler;
  protoOf(FlowBasedCompletionResult).sr = plus_0;
  protoOf(CellContainerPeerAdapter).llq = scrollTo;
  protoOf(IndentCell$addListener$$inlined$toDisposable$1).sr = plus_0;
  protoOf(MessagePopupSpec).flr = get_isLowPriority;
  protoOf(setBackingToDefault$$inlined$toDisposable$1).sr = plus_0;
  protoOf(MessagePopupSupport$doSubscribe$$inlined$toDisposable$1).sr = plus_0;
  protoOf(MessagePopupSupport).sr = plus_0;
  protoOf(MessageStyler$setProp$$inlined$toDisposable$1).sr = plus_0;
  protoOf(MessageTrait$MyHoverController$schedule$$inlined$toDisposable$1).sr = plus_0;
  protoOf(MessageViewWithLink).hmp = setFontStyle;
  protoOf(SimpleMessageView).hmp = setFontStyle;
  protoOf(BasePopupManager).sr = plus_0;
  protoOf(DefaultPositionHandler$caretOffset$1).m2c = invoke;
  protoOf(DefaultPositionHandler$caretOffset$1).v2c = invoke_0;
  protoOf(DefaultPositionHandler$caretOffset$1).p27 = addHandler;
  protoOf(TextPositionHandler$caretOffset$1).m2c = invoke;
  protoOf(TextPositionHandler$caretOffset$1).v2c = invoke_0;
  protoOf(TextPositionHandler$caretOffset$1).p27 = addHandler;
  protoOf(InputMethodEditorUtil$showComposite$$inlined$toDisposable$1).sr = plus_0;
  protoOf(ValidTextEditingTrait$validate$$inlined$toDisposable$1).sr = plus_0;
  protoOf(CellTraits$captureTo$$inlined$toDisposable$1).sr = plus_0;
  protoOf(CellAttachWatcher).zlp = onBeforeCommand;
  protoOf(CellAttachWatcher).alq = onAfterCommand;
  protoOf(TraitController).sr = plus_0;
  protoOf(whenAttached$$inlined$toDisposable$1).sr = plus_0;
  protoOf(LastCaretPositionSupport$onPropertyChanged$$inlined$toDisposable$1).sr = plus_0;
  protoOf(FocusedCellHandler).sr = plus_0;
  protoOf(HighlightUtil$highlightFocused$$inlined$toDisposable$1).sr = plus_0;
  protoOf(BaseProjectionalSynchronizer).vr = dispose;
  protoOf(BaseProjectionalSynchronizer).sr = plus_0;
  protoOf(ReadOnlyProjectionalSynchronizers$forSingleRole$target$1).v2c = invoke_0;
  protoOf(ProjectionalClipboardContent).hl0 = toText;
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1).q2q = deserialize;
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetPersister$1).x2p = serialize;
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1).q2q = deserialize;
  protoOf(ProjectionalClipboardContentSerializationAsHtml$doGetListPersister$1).x2p = serialize;
  protoOf(RoleSynchronizerSelectionSupport).sr = plus_0;
  protoOf(SelectionSupport).sr = plus_0;
  protoOf(ExternalPasteContent).hl0 = toText;
  protoOf(View$ExternalChildList$addListener$1).qnw = onPropertySet;
  protoOf(View$ExternalChildList$addListener$1).rnw = onViewValidated;
  protoOf(View$ExternalChildList$addListener$1).snw = onViewInvalidated;
  protoOf(View$ExternalChildList$addListener$1).tnw = onViewAttached;
  protoOf(View$ExternalChildList$addListener$1).unw = onViewDetached;
  protoOf(View$ExternalChildList$addListener$1).vnw = onBoundsChanged;
  protoOf(View$ExternalChildList$addListener$1).wnw = onToRootDeltaChanged;
  protoOf(View$ExternalChildList$addListener$1).mnw = onParentChanged_0;
  protoOf(View$getProp$1$addHandler$1).rnw = onViewValidated;
  protoOf(View$getProp$1$addHandler$1).snw = onViewInvalidated;
  protoOf(View$getProp$1$addHandler$1).tnw = onViewAttached;
  protoOf(View$getProp$1$addHandler$1).unw = onViewDetached;
  protoOf(View$getProp$1$addHandler$1).vnw = onBoundsChanged;
  protoOf(View$getProp$1$addHandler$1).wnw = onToRootDeltaChanged;
  protoOf(View$getProp$1$addHandler$1).fnw = onChildAdded_2;
  protoOf(View$getProp$1$addHandler$1).gnw = onChildRemoved_2;
  protoOf(View$getProp$1$addHandler$1).mnw = onParentChanged_0;
  protoOf(View$customFeatureChange$1$addHandler$1).qnw = onPropertySet;
  protoOf(View$customFeatureChange$1$addHandler$1).rnw = onViewValidated;
  protoOf(View$customFeatureChange$1$addHandler$1).snw = onViewInvalidated;
  protoOf(View$customFeatureChange$1$addHandler$1).tnw = onViewAttached;
  protoOf(View$customFeatureChange$1$addHandler$1).unw = onViewDetached;
  protoOf(View$customFeatureChange$1$addHandler$1).vnw = onBoundsChanged;
  protoOf(View$customFeatureChange$1$addHandler$1).wnw = onToRootDeltaChanged;
  protoOf(View$customFeatureChange$1$addHandler$1).fnw = onChildAdded_2;
  protoOf(View$customFeatureChange$1$addHandler$1).gnw = onChildRemoved_2;
  protoOf(View$customFeatureChange$1$addHandler$1).mnw = onParentChanged_0;
  protoOf(View$valid$1$addHandler$1).qnw = onPropertySet;
  protoOf(View$valid$1$addHandler$1).tnw = onViewAttached;
  protoOf(View$valid$1$addHandler$1).unw = onViewDetached;
  protoOf(View$valid$1$addHandler$1).vnw = onBoundsChanged;
  protoOf(View$valid$1$addHandler$1).wnw = onToRootDeltaChanged;
  protoOf(View$valid$1$addHandler$1).fnw = onChildAdded_2;
  protoOf(View$valid$1$addHandler$1).gnw = onChildRemoved_2;
  protoOf(View$valid$1$addHandler$1).mnw = onParentChanged_0;
  protoOf(View$toRootDelta$1$addHandler$reg$1).qnw = onPropertySet;
  protoOf(View$toRootDelta$1$addHandler$reg$1).rnw = onViewValidated;
  protoOf(View$toRootDelta$1$addHandler$reg$1).snw = onViewInvalidated;
  protoOf(View$toRootDelta$1$addHandler$reg$1).tnw = onViewAttached;
  protoOf(View$toRootDelta$1$addHandler$reg$1).unw = onViewDetached;
  protoOf(View$toRootDelta$1$addHandler$reg$1).vnw = onBoundsChanged;
  protoOf(View$toRootDelta$1$addHandler$reg$1).fnw = onChildAdded_2;
  protoOf(View$toRootDelta$1$addHandler$reg$1).gnw = onChildRemoved_2;
  protoOf(View$toRootDelta$1$addHandler$reg$1).mnw = onParentChanged_0;
  protoOf(View$toRootDelta$1$addHandler$$inlined$toDisposable$1).sr = plus_0;
  protoOf(View$boundsProp$1$addHandler$2).qnw = onPropertySet;
  protoOf(View$boundsProp$1$addHandler$2).rnw = onViewValidated;
  protoOf(View$boundsProp$1$addHandler$2).snw = onViewInvalidated;
  protoOf(View$boundsProp$1$addHandler$2).tnw = onViewAttached;
  protoOf(View$boundsProp$1$addHandler$2).unw = onViewDetached;
  protoOf(View$boundsProp$1$addHandler$2).wnw = onToRootDeltaChanged;
  protoOf(View$boundsProp$1$addHandler$2).fnw = onChildAdded_2;
  protoOf(View$boundsProp$1$addHandler$2).gnw = onChildRemoved_2;
  protoOf(View$boundsProp$1$addHandler$2).mnw = onParentChanged_0;
  protoOf(View$attachEvents$1$addHandler$1).qnw = onPropertySet;
  protoOf(View$attachEvents$1$addHandler$1).rnw = onViewValidated;
  protoOf(View$attachEvents$1$addHandler$1).snw = onViewInvalidated;
  protoOf(View$attachEvents$1$addHandler$1).unw = onViewDetached;
  protoOf(View$attachEvents$1$addHandler$1).vnw = onBoundsChanged;
  protoOf(View$attachEvents$1$addHandler$1).wnw = onToRootDeltaChanged;
  protoOf(View$attachEvents$1$addHandler$1).fnw = onChildAdded_2;
  protoOf(View$attachEvents$1$addHandler$1).gnw = onChildRemoved_2;
  protoOf(View$attachEvents$1$addHandler$1).mnw = onParentChanged_0;
  protoOf(ExternalChildList_0).p27 = addHandler;
  protoOf(ToParentOffsetProperty).v2c = invoke_0;
  protoOf(View$getProp$1).m2c = invoke;
  protoOf(View$getProp$1).v2c = invoke_0;
  protoOf(View$getProp$1).p27 = addHandler;
  protoOf(View$addListener$$inlined$toDisposable$1).sr = plus_0;
  protoOf(View$customFeatureChange$1).p27 = addHandler;
  protoOf(View$attachEvents$1).p27 = addHandler;
  protoOf(ViewContainer$RootView$1).qnw = onPropertySet;
  protoOf(ViewContainer$RootView$1).rnw = onViewValidated;
  protoOf(ViewContainer$RootView$1).snw = onViewInvalidated;
  protoOf(ViewContainer$RootView$1).tnw = onViewAttached;
  protoOf(ViewContainer$RootView$1).unw = onViewDetached;
  protoOf(ViewContainer$RootView$1).vnw = onBoundsChanged;
  protoOf(ViewContainer$RootView$1).wnw = onToRootDeltaChanged;
  protoOf(ViewContainer$RootView$1).mnw = onParentChanged_0;
  protoOf(AlignmentSynchronizers$bindStyle$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(CellContainerToDomMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(CellContainerToDomMapper$registerSynchronizers$2).zlp = onBeforeCommand;
  protoOf(CellContainerToDomMapper$registerSynchronizers$2).alq = onAfterCommand;
  protoOf(CellContainerToDomMapper$createCellContainerPeer$1).llq = scrollTo;
  protoOf(CellMapperRefresher$registerHideable$$inlined$toDisposable$1).sr = plus_0;
  protoOf(CellToDomContext).sr = plus_0;
  protoOf(DefaultLineHighlight).sr = plus_0;
  protoOf(DomCellMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(DomPopupManager$setPopupUpdate$$inlined$toDisposable$1).sr = plus_0;
  protoOf(DomTextInput).sr = plus_0;
  protoOf(EmptyLineHighlight).sr = plus_0;
  protoOf(ImageCellMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(TextCellMapper$refreshProperties$$inlined$toDisposable$1).sr = plus_0;
  protoOf(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(TextPlaceholderCellMapper$registerSynchronizers$$inlined$writableProperty$2).v2c = invoke_0;
  protoOf(Tooltip$injectCornerStyle$$inlined$toDisposable$1).sr = plus_0;
  protoOf(ViewCellMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(DomUtil$scheduleDeferred$$inlined$toDisposable$1).sr = plus_0;
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$2).v2c = invoke_0;
  protoOf(BaseViewMapper$registerSynchronizers$$inlined$writableProperty$3).v2c = invoke_0;
  protoOf(DomViewMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(DomViewMapper$registerSynchronizers$$inlined$writableProperty$2).v2c = invoke_0;
  protoOf(DomViewSynchronizers$boundsSynchronizer$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(ImageViewMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$2).v2c = invoke_0;
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$3).v2c = invoke_0;
  protoOf(LineViewMapper$registerSynchronizers$$inlined$writableProperty$4).v2c = invoke_0;
  protoOf(MultiPointViewMapper$registerSynchronizers$1).vr = dispose;
  protoOf(MultiPointViewMapper$registerSynchronizers$1).sr = plus_0;
  protoOf(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(MultiPointViewMapper$registerSynchronizers$$inlined$writableProperty$2).v2c = invoke_0;
  protoOf(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(ScrollViewMapper$registerSynchronizers$$inlined$writableProperty$2).v2c = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$2).v2c = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$3).v2c = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$4).v2c = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$5).v2c = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$6).v2c = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$7).v2c = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$8).v2c = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$9).v2c = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$10).v2c = invoke_0;
  protoOf(TextViewMapper$registerSynchronizers$$inlined$writableProperty$11).v2c = invoke_0;
  protoOf(VerticalViewMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(ViewContainerToElementMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(CellStateAfterExternalOpRestorer).w3k = onCommandStarted;
  protoOf(CellStateAfterExternalOpRestorer).t3k = onOperationPerformed;
  protoOf(CellStateAfterExternalOpRestorer).x3k = onCommandCommitted;
  protoOf(CellStateAfterExternalOpRestorer).a3l = onExternalOperationFailed;
  protoOf(CellStateManager$1).zlp = onBeforeCommand;
  protoOf(CellStateManager$1).alq = onAfterCommand;
  protoOf(CellStateManager).sr = plus_0;
  protoOf(NavigationManager$2).w3k = onCommandStarted;
  protoOf(NavigationManager$2).x3k = onCommandCommitted;
  protoOf(NavigationManager$2).y3k = onExternalOperationStarted;
  protoOf(NavigationManager$2).a3l = onExternalOperationFailed;
  protoOf(NavigationManager).sr = plus_0;
  protoOf(CellContainerCommandWatcher).blq = onCellPropertyChanged;
  protoOf(CellContainerCommandWatcher).clq = onChildAdded_1;
  protoOf(CellContainerCommandWatcher).sr = plus_0;
  protoOf(OtSupport).sr = plus_0;
  protoOf(NodeWrapperCellProvider).bot = getNode$default;
  protoOf(OtNodeCellProvider).bot = getNode$default;
  protoOf(HighlightErrorsSynchronizer).vr = dispose;
  protoOf(HighlightErrorsSynchronizer).sr = plus_0;
  protoOf(ErrorSupport$addError$$inlined$toDisposable$1).sr = plus_0;
  protoOf(CheckNodeSynchronizer).vr = dispose;
  protoOf(CheckNodeSynchronizer).sr = plus_0;
  protoOf(ErrorHighlighterBase$registerSynchronizers$1).vr = dispose;
  protoOf(ErrorHighlighterBase$registerSynchronizers$1).sr = plus_0;
  protoOf(indentLabel$$inlined$apply$1$3).v2c = invoke_0;
  protoOf(projectionalChild$2$1$target$1).v2c = invoke_0;
  protoOf(SimpleMapperBuilder$build$builderContext$1).jpe = getCell;
  protoOf(LineMapper$registerSynchronizers$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(indentLabel$1$$inlined$writableProperty$1).v2c = invoke_0;
  protoOf(EditorMapperFactoryImpl).apq = createMapper;
  protoOf(BaseEditor$createMapper$triggerContentUpdateSynchronizer$1).vr = dispose;
  protoOf(BaseEditor$createMapper$triggerContentUpdateSynchronizer$1).sr = plus_0;
  protoOf(NodeWrapperReferenceAdapter$afterPaste$1).sr = plus_0;
  protoOf(BaseNodeCloneSupport).lng = copy$default;
  protoOf(BaseNodeCloneSupport).qng = copyList$default;
  protoOf(getReferenceRoleEditor$1$2$1).tlk = onPropertyChanged_0;
  protoOf(getReferenceRoleEditor$1$2$1).olk = onChildAdded_0;
  protoOf(getReferenceRoleEditor$1$2$1).plk = onChildRemoved_0;
  protoOf(getReferenceRoleEditor$1$2$1).ulk = onParentChanged;
  protoOf(getReferenceRoleEditor$1$2$1).wlk = onDetach;
  protoOf(focusGuarded$1).v2c = invoke_0;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_6).sr = plus_0;
  protoOf(referenceOutOfScopeSynchronizer$outOfScopeMessage$1).v2c = invoke_0;
  protoOf(highlightReferenceTargetOutOfSync$visual$1).v2c = invoke_0;
  defineProp(protoOf(DoubleReceiveException), 'message', function () {
    return this.t1();
  });
  defineProp(protoOf(NoTransformationFoundException), 'message', function () {
    return this.t1();
  });
  defineProp(protoOf(ClientEngineClosedException), 'cause', function () {
    return this.u1();
  });
  protoOf(HttpClientEngineBase).rqc = get_supportedCapabilities;
  protoOf(HttpClientEngineBase).cq8 = install;
  protoOf(KtorCallContextElement).la = get;
  protoOf(KtorCallContextElement).dj = fold;
  protoOf(KtorCallContextElement).cj = minusKey;
  protoOf(KtorCallContextElement).ej = plus;
  defineProp(protoOf(RedirectResponseException), 'message', function () {
    return this.t1();
  });
  defineProp(protoOf(ClientRequestException), 'message', function () {
    return this.t1();
  });
  defineProp(protoOf(ServerResponseException), 'message', function () {
    return this.t1();
  });
  protoOf(HttpRequest$1).et = get_coroutineContext;
  protoOf(JsWebSocketSession).k9a = send;
  protoOf($serializer_28).j5o = typeParametersSerializers;
  protoOf($serializer_29).j5o = typeParametersSerializers;
  protoOf($serializer_30).j5o = typeParametersSerializers;
  protoOf($serializer_31).j5o = typeParametersSerializers;
  defineProp(protoOf(Companion_377), '$cachedDescriptor', protoOf(Companion_377).tra);
  protoOf(RemoteFindUsageRequestController).sr = plus_0;
  protoOf($serializer_33).j5o = typeParametersSerializers;
  protoOf($serializer_34).j5o = typeParametersSerializers;
  protoOf($serializer_35).j5o = typeParametersSerializers;
  protoOf(WebsocketEditorServiceProvider).sr = plus_0;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_7).sr = plus_0;
  protoOf(NodeEditorBase).sr = plus_0;
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_8).sr = plus_0;
  defineProp(protoOf(BTBCategoryEventKind), 'name', protoOf(BTBCategoryEventKind).b3);
  defineProp(protoOf(BTBCategoryEventKind), 'ordinal', protoOf(BTBCategoryEventKind).c3);
  protoOf(sam$jetbrains_ocelot_base_disposable_Disposable$0_9).sr = plus_0;
  protoOf(OtEnvironment).sr = plus_0;
  defineProp(protoOf(DraftQuerySource), 'descriptor', function () {
    return this.w5c();
  });
  defineProp(protoOf(EditedDocumentSource), 'descriptor', function () {
    return this.w5c();
  });
  defineProp(protoOf(PrecalculatedResolversDocumentSource), 'descriptor', function () {
    return this.w5c();
  });
  defineProp(protoOf(EditedOntologyBrowserSource), 'descriptor', function () {
    return this.w5c();
  });
  defineProp(protoOf(EditedWorkingCopySource), 'descriptor', function () {
    return this.w5c();
  });
  defineProp(protoOf(ExploredDocumentSource), 'descriptor', function () {
    return this.w5c();
  });
  defineProp(protoOf(ExploredOntologyBrowserSource), 'descriptor', function () {
    return this.w5c();
  });
  defineProp(protoOf(HistoryPanelDocumentSource), 'descriptor', function () {
    return this.w5c();
  });
  defineProp(protoOf(PathEntrySource), 'descriptor', function () {
    return this.w5c();
  });
  defineProp(protoOf(PublishedQuerySource), 'descriptor', function () {
    return this.w5c();
  });
  defineProp(protoOf(UsageEntrySource), 'descriptor', function () {
    return this.w5c();
  });
  protoOf(btbProgramBuilders$$inlined$editor$4$1$3$1).lpg = referenceTextProperty$default;
  protoOf(btbProgramBuilders$$inlined$editor$5$1$3$1).lpg = referenceTextProperty$default;
  protoOf(btbProgramBuilders$$inlined$editor$6$1$4$1).lpg = referenceTextProperty$default;
  protoOf(btbProgramBuilders$$inlined$editor$7$1$3$1).lpg = referenceTextProperty$default;
  protoOf(btbProgramBuilders$$inlined$editor$9$1$3$1).lpg = referenceTextProperty$default;
  protoOf(btbProgramBuilders$$inlined$editor$11$1$3$1).lpg = referenceTextProperty$default;
  protoOf(btbProgramBuilders$$inlined$editor$12$1$3$1).lpg = referenceTextProperty$default;
  protoOf(btbProgramBuilders$$inlined$editor$13$1$3$1).lpg = referenceTextProperty$default;
  protoOf(factBuilders$$inlined$editor$2$1$3$1).lpg = referenceTextProperty$default;
  protoOf(factBuilders$$inlined$editor$4$1$1$4$1).lpg = referenceTextProperty$default;
  protoOf(processLibraryBuilders$$inlined$editor$2$1$3$1).lpg = referenceTextProperty$default;
  protoOf(processLibraryBuilders$$inlined$editor$2$1$13$1).lpg = referenceTextProperty$default;
  protoOf(processLibraryBuilders$$inlined$editor$4$1$5$1).lpg = referenceTextProperty$default;
  protoOf(processLibraryBuilders$$inlined$editor$5$1$3$1).lpg = referenceTextProperty$default;
  protoOf(processLibraryBuilders$$inlined$editor$6$1$3$1).lpg = referenceTextProperty$default;
  protoOf(processLibraryBuilders$$inlined$editor$6$1$12$1).lpg = referenceTextProperty$default;
  protoOf(processLibraryBuilders$$inlined$editor$9$1$3$1).lpg = referenceTextProperty$default;
  protoOf(processLibraryBuilders$$inlined$editor$10$1$3$1).lpg = referenceTextProperty$default;
  protoOf(processLibraryBuilders$$inlined$editor$11$1$3$1).lpg = referenceTextProperty$default;
  protoOf(processLibraryBuilders$$inlined$editor$15$1$3$1).lpg = referenceTextProperty$default;
  protoOf(queryCommandBuilders$$inlined$editor$4$1$3$1).lpg = referenceTextProperty$default;
  protoOf(queryCommandBuilders$$inlined$editor$6$1$3$1$1).h4x = runSuspend;
  protoOf(queryCommandBuilders$$inlined$editor$7$1$3$1).lpg = referenceTextProperty$default;
  protoOf(queryCommandBuilders$$inlined$editor$8$1$3$1).lpg = referenceTextProperty$default;
  protoOf(notionTypeBuilders$$inlined$editor$1$1$3$1).lpg = referenceTextProperty$default;
  protoOf(btbProgramEditors$11$addTraitDeleteRelations$1$$inlined$createDeleteTransformTrait$1$doWork$1).h4x = runSuspend;
  protoOf(btbProgramEditors$25$3$1$3$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(setExpressionEditor$1$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(setExpressionEditor$1$$inlined$executeQuery$2).h4x = runSuspend;
  protoOf(propertyReferenceValueEditor$1$3$doAttach$1$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(measurableValueWithDefaultUnitCompletion$1$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(valueWithRelationsRightTransformCell$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(QueryLabelDeleteTrait$onKeyPressed$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(newFactEditors$7$1$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(newFactEditors$7$1$ReplaceWithLeftTrait$onKeyPressed$$inlined$executeQuery$2).h4x = runSuspend;
  protoOf(setQueryLabelRightTransform$1$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(excludingClassExpressionCompletion$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(processLibraryEditors$7$1$2$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(processLibraryEditors$7$1$2$1$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(processLibraryEditors$12$BraceDeleteTrait$onKeyPressed$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(shouldShowSpecialized$$inlined$query$1).h4x = runSuspend;
  protoOf(queryCommandEditors$10$3$1$1$$inlined$executeQuery$1).h4x = runSuspend;
  protoOf(getDeleteTransformTrait$$inlined$createDeleteTransformTrait$1$doWork$1).h4x = runSuspend;
  defineProp(protoOf(PagedAdapter), 'current', protoOf(PagedAdapter).t2u);
  protoOf(HtmlNodeEditorView$attach$$inlined$toDisposable$1).sr = plus_0;
  protoOf(Config_4).wq2 = register$default;
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  ByteCompanionObject_instance = new ByteCompanionObject();
  ShortCompanionObject_instance = new ShortCompanionObject();
  IntCompanionObject_instance = new IntCompanionObject();
  FloatCompanionObject_instance = new FloatCompanionObject();
  DoubleCompanionObject_instance = new DoubleCompanionObject();
  StringCompanionObject_instance = new StringCompanionObject();
  BooleanCompanionObject_instance = new BooleanCompanionObject();
  Unit_instance = new Unit();
  _stableSortingIsSupported = null;
  Companion_instance_4 = new Companion_4();
  CompletedContinuation_instance = new CompletedContinuation();
  DateNowTimeSource_instance = new DateNowTimeSource();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  EmptyIterator_instance = new EmptyIterator();
  EmptySequence_instance = new EmptySequence();
  Key_instance = new Key();
  Companion_instance_13 = new Companion_13();
  Companion_instance_14 = new Companion_14();
  State_instance = new State();
  Monotonic_instance = new Monotonic();
  UNINITIALIZED_VALUE_instance = new UNINITIALIZED_VALUE();
  Companion_instance_17 = new Companion_17();
  JSLogger_instance = new JSLogger();
  Companion_instance_23 = new Companion_23();
  Companion_instance_24 = new Companion_24();
  Present_instance = new Present();
  Active_instance = new Active();
  Key_instance_1 = new Key_1();
  Key_instance_2 = new Key_2();
  GlobalScope_instance = new GlobalScope();
  Key_instance_3 = new Key_3();
  NonDisposableHandle_instance = new NonDisposableHandle();
  Key_instance_4 = new Key_4();
  EmptyFlow_instance = new EmptyFlow();
  NopCollector_instance = new NopCollector();
  counter = 0;
  DEBUG = false;
  RECOVER_STACK_TRACES = false;
  Companion_instance_28 = new Companion_28();
  Companion_instance_29 = new Companion_29();
  EventSources_instance = new EventSources();
  PropertyBinding_instance = new PropertyBinding();
  Transformers_instance = new Transformers();
  Asyncs_instance = new Asyncs();
  Companion_instance_32 = new Companion_32();
  Companion_instance_33 = new Companion_33();
  Companion_instance_34 = new Companion_34();
  EnumInfoFactory_instance = new EnumInfoFactory();
  Enums_instance = new Enums();
  Composites_instance = new Composites();
  Companion_instance_36 = new Companion_36();
  BaseJsonReaderSupport_instance = new BaseJsonReaderSupport();
  CommonJsonIterSupport_instance = new CommonJsonIterSupport();
  Companion_instance_38 = new Companion_38();
  JsonStreamIterSupport_instance = new JsonStreamIterSupport();
  CommonJsonStreamIterSupport_instance = new CommonJsonStreamIterSupport();
  LoggingUtils_instance = new LoggingUtils();
  Companion_instance_40 = new Companion_40();
  Companion_instance_41 = new Companion_41();
  Companion_instance_42 = new Companion_42();
  MessageBundle_instance = new MessageBundle();
  Companion_instance_43 = new Companion_43();
  RawNodeFactory_instance = new RawNodeFactory();
  NodeUtil_instance = new NodeUtil();
  Nodes_instance = new Nodes();
  Companion_instance_48 = new Companion_48();
  EntityPrintOperationUtil_instance = new EntityPrintOperationUtil();
  Companion_instance_49 = new Companion_49();
  OperationBuilder_instance = new OperationBuilder();
  OperationConverter_instance = new OperationConverter();
  RootOperationsExecutorUtil_instance = new RootOperationsExecutorUtil();
  EntityMessages_instance = new EntityMessages();
  ModelBlobMessages_instance = new ModelBlobMessages();
  ModelOperationsExecutorUtil_instance = new ModelOperationsExecutorUtil();
  DestroyOperationTransformer_instance = new DestroyOperationTransformer();
  Companion_instance_50 = new Companion_50();
  PathItemUtil_instance = new PathItemUtil();
  Companion_instance_51 = new Companion_51();
  Companion_instance_52 = new Companion_52();
  Companion_instance_53 = new Companion_53();
  EntityOperationsExecutorUtil_instance = new EntityOperationsExecutorUtil();
  Companion_instance_54 = new Companion_54();
  Companion_instance_55 = new Companion_55();
  Companion_instance_56 = new Companion_56();
  OperationBuilder_instance_0 = new OperationBuilder_0();
  ChildOperationMessages_instance = new ChildOperationMessages();
  Companion_instance_57 = new Companion_57();
  NodeDiff_instance = new NodeDiff();
  Companion_instance_58 = new Companion_58();
  ModelOperationConverter_instance = new ModelOperationConverter();
  NodeOperationsExecutorUtil_instance = new NodeOperationsExecutorUtil();
  Companion_instance_60 = new Companion_60();
  Companion_instance_61 = new Companion_61();
  AssertionUtil_instance = new AssertionUtil();
  Companion_instance_62 = new Companion_62();
  Companion_instance_63 = new Companion_63();
  SplitMergeOperationsUtil_instance = new SplitMergeOperationsUtil();
  Companion_instance_64 = new Companion_64();
  PrintOperationUtil_instance = new PrintOperationUtil();
  EntityIdPersisters_instance = new EntityIdPersisters();
  PrivateEntityIdPersisters_instance = new PrivateEntityIdPersisters();
  Companion_instance_67 = new Companion_67();
  NodeIdPersisters_instance = new NodeIdPersisters();
  PrivateNodeIdPersisters_instance = new PrivateNodeIdPersisters();
  Companion_instance_69 = new Companion_69();
  TextOperationUtil_instance = new TextOperationUtil();
  Companion_instance_70 = new Companion_70();
  UndoUtils_instance = new UndoUtils();
  Companion_instance_71 = new Companion_71();
  WrapperContextService_instance = new WrapperContextService();
  RuntimePlatform_instance = new RuntimePlatform();
  Companion_instance_82 = new Companion_82();
  Companion_instance_83 = new Companion_83();
  Companion_instance_84 = new Companion_84();
  Companion_instance_85 = new Companion_85();
  Tombstone_instance = new Tombstone();
  DefaultNodeStorage_instance = new DefaultNodeStorage();
  Companion_instance_86 = new Companion_86();
  Companion_instance_87 = new Companion_87();
  Companion_instance_88 = new Companion_88();
  EmptyNodeStorage_instance = new EmptyNodeStorage();
  OtNodeFactoryService_instance = new OtNodeFactoryService();
  Companion_instance_90 = new Companion_90();
  OTLinkPersister_instance = new OTLinkPersister();
  Companion_instance_91 = new Companion_91();
  Companion_instance_92 = new Companion_92();
  NodeSetupContextService_instance = new NodeSetupContextService();
  Companion_instance_95 = new Companion_95();
  ErrorNodeFactory_instance = new ErrorNodeFactory();
  UseExperimentalNodeService_instance = new UseExperimentalNodeService();
  Companion_instance_96 = new Companion_96();
  Companion_instance_97 = new Companion_97();
  Empty_instance = new Empty_0();
  Companion_instance_102 = new Companion_102();
  Companion_instance_103 = new Companion_103();
  ReferenceFactoryRegistryAspect_instance = new ReferenceFactoryRegistryAspect();
  ReferenceTargetPresentationProvidersRegistryAspect_instance = new ReferenceTargetPresentationProvidersRegistryAspect();
  ReferenceTargetsSuppliersRegistryAspect_instance = new ReferenceTargetsSuppliersRegistryAspect();
  ResolveConfigService_instance = new ResolveConfigService();
  Companion_instance_105 = new Companion_105();
  Companion_instance_106 = new Companion_106();
  Companion_instance_107 = new Companion_107();
  Companion_instance_108 = new Companion_108();
  Companion_instance_110 = new Companion_110();
  Companion_instance_111 = new Companion_111();
  Companion_instance_113 = new Companion_113();
  StructureAspect_instance = new StructureAspect();
  ConceptRegistryService_instance = new ConceptRegistryService();
  Companion_instance_114 = new Companion_114();
  Companion_instance_116 = new Companion_116();
  Companion_instance_117 = new Companion_117();
  Empty_instance_0 = new Empty_1();
  EmptyErrorCheckConfig_instance = new EmptyErrorCheckConfig();
  NoopScopeFilter_instance = new NoopScopeFilter();
  Companion_instance_119 = new Companion_119();
  ScopeAspect_instance = new ScopeAspect();
  Companion_instance_121 = new Companion_121();
  ScopeConfigService_instance = new ScopeConfigService();
  Companion_instance_122 = new Companion_122();
  Empty_instance_1 = new Empty_2();
  Companion_instance_124 = new Companion_124();
  AbsentScopeOwner_instance = new AbsentScopeOwner();
  Companion_instance_127 = new Companion_127();
  FindUsagesAspect_instance = new FindUsagesAspect();
  FindUsagesConfigService_instance = new FindUsagesConfigService();
  Companion_instance_129 = new Companion_129();
  Companion_instance_131 = new Companion_131();
  DefaultAllocator_instance = new DefaultAllocator();
  Companion_instance_135 = new Companion_135();
  PACKET_MAX_COPY_SIZE = 200;
  Companion_instance_137 = new Companion_137();
  Companion_instance_138 = new Companion_138();
  DISABLE_SFG = false;
  JsType_instance = new JsType();
  Companion_instance_141 = new Companion_141();
  EmptyHeaders_instance = new EmptyHeaders();
  EmptyParameters_instance = new EmptyParameters();
  Companion_instance_149 = new Companion_149();
  NullBody_instance = new NullBody();
  NonDisposableHandle_instance_0 = new NonDisposableHandle_0();
  Companion_instance_154 = new Companion_154();
  Companion_instance_155 = new Companion_155();
  Companion_instance_156 = new Companion_156();
  Companion_instance_162 = new Companion_162();
  Companion_instance_163 = new Companion_163();
  Companion_instance_170 = new Companion_170();
  Companion_instance_173 = new Companion_173();
  Companion_instance_174 = new Companion_174();
  Companion_instance_177 = new Companion_177();
  Empty_instance_2 = new Empty_3();
  Companion_instance_180 = new Companion_180();
  Companion_instance_181 = new Companion_181();
  Companion_instance_183 = new Companion_183();
  Companion_instance_184 = new Companion_184();
  GeneratedBioKbStuff_instance = new GeneratedBioKbStuff();
  Companion_instance_228 = new Companion_228();
  Companion_instance_229 = new Companion_229();
  Companion_instance_230 = new Companion_230();
  Companion_instance_231 = new Companion_231();
  Companion_instance_232 = new Companion_232();
  Companion_instance_233 = new Companion_233();
  RootOperationsUtil_instance = new RootOperationsUtil();
  Companion_instance_235 = new Companion_235();
  Companion_instance_236 = new Companion_236();
  Companion_instance_237 = new Companion_237();
  PingPongServiceConstants_instance = new PingPongServiceConstants();
  ServiceContainerConstants_instance = new ServiceContainerConstants();
  ServiceContainerMessageUtil_instance = new ServiceContainerMessageUtil();
  Companion_instance_244 = new Companion_244();
  Companion_instance_248 = new Companion_248();
  Rectangles_instance = new Rectangles();
  DomUtil_instance = new DomUtil();
  Companion_instance_252 = new Companion_252();
  Companion_instance_253 = new Companion_253();
  DomApi_instance = new DomApi();
  EmptyClipboardContent_instance = new EmptyClipboardContent();
  Companion_instance_256 = new Companion_256();
  Companion_instance_257 = new Companion_257();
  DomEventUtil_instance = new DomEventUtil();
  KeyEventUtil_instance = new KeyEventUtil();
  Companion_instance_258 = new Companion_258();
  Companion_instance_259 = new Companion_259();
  TextClipboardSerialization_instance = new TextClipboardSerialization();
  JsSystemClipboard_instance = new JsSystemClipboard();
  Mappers_instance = new Mappers();
  Synchronizers_instance = new Synchronizers();
  ListImplementation_instance = new ListImplementation();
  Companion_instance_263 = new Companion_263();
  Companion_instance_264 = new Companion_264();
  Companion_instance_265 = new Companion_265();
  Companion_instance_266 = new Companion_266();
  Companion_instance_274 = new Companion_274();
  Companion_instance_278 = new Companion_278();
  Companion_instance_280 = new Companion_280();
  CompletionSupplement_instance = new CompletionSupplement();
  Companion_instance_282 = new Companion_282();
  Companion_instance_286 = new Companion_286();
  AncestorUtil_instance = new AncestorUtil();
  CellMapperUtils_instance = new CellMapperUtils();
  IndentUtil_instance = new IndentUtil();
  Companion_instance_292 = new Companion_292();
  Companion_instance_297 = new Companion_297();
  Positions_instance = new Positions();
  TextEditorUtil_instance = new TextEditorUtil();
  CellTraits_instance = new CellTraits();
  CompositeCellTraits_instance = new CompositeCellTraits();
  CellFactory_instance = new CellFactory();
  CellLists_instance = new CellLists();
  Companion_instance_304 = new Companion_304();
  Companion_instance_310 = new Companion_310();
  ScrollingUtil_instance = new ScrollingUtil();
  Companion_instance_311 = new Companion_311();
  ValueEditors_instance = new ValueEditors();
  HighlightUtil_instance = new HighlightUtil();
  MatchingConstructs_instance = new MatchingConstructs();
  PairUtil_instance = new PairUtil();
  Companion_instance_315 = new Companion_315();
  RootController_instance = new RootController();
  Companion_instance_316 = new Companion_316();
  ReadOnlyProjectionalSynchronizers_instance = new ReadOnlyProjectionalSynchronizers();
  Companion_instance_320 = new Companion_320();
  SelectionSupports_instance = new SelectionSupports();
  Companion_instance_324 = new Companion_324();
  Companion_instance_327 = new Companion_327();
  ExternalPasteContent_instance = new ExternalPasteContent();
  AlignmentSynchronizers_instance = new AlignmentSynchronizers();
  Companion_instance_336 = new Companion_336();
  Companion_instance_338 = new Companion_338();
  CellMappers_instance = new CellMappers();
  Companion_instance_339 = new Companion_339();
  Companion_instance_340 = new Companion_340();
  HiddenTextAreaHelper_instance = new HiddenTextAreaHelper();
  Companion_instance_341 = new Companion_341();
  Companion_instance_343 = new Companion_343();
  Companion_instance_344 = new Companion_344();
  Tooltip_instance = new Tooltip();
  Scrolling_instance = new Scrolling();
  DomViewSynchronizers_instance = new DomViewSynchronizers();
  Companion_instance_346 = new Companion_346();
  SvgUtil_instance = new SvgUtil();
  ViewMapperFactory_instance = new ViewMapperFactory();
  ViewToDom_instance = new ViewToDom();
  Companion_instance_348 = new Companion_348();
  ErrorHighlightingController_instance = new ErrorHighlightingController();
  Companion_instance_355 = new Companion_355();
  Companion_instance_361 = new Companion_361();
  Companion_instance_364 = new Companion_364();
  Companion_instance_366 = new Companion_366();
  Companion_instance_369 = new Companion_369();
  WebSocketExtensionsCapability_instance = new WebSocketExtensionsCapability();
  WebSocketCapability_instance = new WebSocketCapability();
  Companion_instance_372 = new Companion_372();
  Js_instance = new Js();
  Companion_instance_373 = new Companion_373();
  Companion_instance_374 = new Companion_374();
  Companion_instance_376 = new Companion_376();
  Companion_instance_378 = new Companion_378();
  Companion_instance_381 = new Companion_381();
  Companion_instance_382 = new Companion_382();
  initializer = SerializerInitializer_getInstance();
  Companion_instance_390 = new Companion_390();
  JsonContentTypeMatcher_instance = new JsonContentTypeMatcher();
  ApiGateway_instance = new ApiGateway();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $kotlin = _.kotlin || (_.kotlin = {});
    var $kotlin$collections = $kotlin.collections || ($kotlin.collections = {});
    defineProp($kotlin$collections, 'KtList', Companion_getInstance_0);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$ocelot = $jetbrains.ocelot || ($jetbrains.ocelot = {});
    var $jetbrains$ocelot$langDef = $jetbrains$ocelot.langDef || ($jetbrains$ocelot.langDef = {});
    var $jetbrains$ocelot$langDef$model = $jetbrains$ocelot$langDef.model || ($jetbrains$ocelot$langDef.model = {});
    $jetbrains$ocelot$langDef$model.NodePointer = NodePointer;
    $jetbrains$ocelot$langDef$model.NodePointer.NodePointerConstructor = NodePointerConstructor;
    defineProp($jetbrains$ocelot$langDef$model.NodePointer, 'Companion', Companion_getInstance_86);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$ocelot = $jetbrains.ocelot || ($jetbrains.ocelot = {});
    var $jetbrains$ocelot$langDef = $jetbrains$ocelot.langDef || ($jetbrains$ocelot.langDef = {});
    var $jetbrains$ocelot$langDef$model = $jetbrains$ocelot$langDef.model || ($jetbrains$ocelot$langDef.model = {});
    $jetbrains$ocelot$langDef$model.SerializedNode = SerializedNode;
    defineProp($jetbrains$ocelot$langDef$model.SerializedNode, 'Companion', Companion_getInstance_90);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$ocelot = $jetbrains.ocelot || ($jetbrains.ocelot = {});
    var $jetbrains$ocelot$langDef = $jetbrains$ocelot.langDef || ($jetbrains$ocelot.langDef = {});
    var $jetbrains$ocelot$langDef$references = $jetbrains$ocelot$langDef.references || ($jetbrains$ocelot$langDef.references = {});
    var $jetbrains$ocelot$langDef$references$remote = $jetbrains$ocelot$langDef$references.remote || ($jetbrains$ocelot$langDef$references.remote = {});
    var $jetbrains$ocelot$langDef$references$remote$precalculated = $jetbrains$ocelot$langDef$references$remote.precalculated || ($jetbrains$ocelot$langDef$references$remote.precalculated = {});
    $jetbrains$ocelot$langDef$references$remote$precalculated.SerializedResolvedNode = SerializedResolvedNode;
    defineProp($jetbrains$ocelot$langDef$references$remote$precalculated.SerializedResolvedNode, 'Companion', Companion_getInstance_180);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$findUsages = $jetbrains$biokb.findUsages || ($jetbrains$biokb.findUsages = {});
    $jetbrains$biokb$findUsages.UsageDto = UsageDto;
    defineProp($jetbrains$biokb$findUsages.UsageDto, 'Companion', Companion_getInstance_228);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$service = $jetbrains$biokb$editor.service || ($jetbrains$biokb$editor.service = {});
    var $jetbrains$biokb$editor$service$findUsages = $jetbrains$biokb$editor$service.findUsages || ($jetbrains$biokb$editor$service.findUsages = {});
    $jetbrains$biokb$editor$service$findUsages.UsageEntryDocumentDto = UsageEntryDocumentDto;
    defineProp($jetbrains$biokb$editor$service$findUsages.UsageEntryDocumentDto, 'Companion', Companion_getInstance_373);
    $jetbrains$biokb$editor$service$findUsages.FindUsageServiceRequest = FindUsageServiceRequest;
    defineProp($jetbrains$biokb$editor$service$findUsages.FindUsageServiceRequest, 'Companion', Companion_getInstance_374);
    $jetbrains$biokb$editor$service$findUsages.FindUsageDocumentInfo = FindUsageDocumentInfo;
    defineProp($jetbrains$biokb$editor$service$findUsages.FindUsageDocumentInfo, 'Companion', Companion_getInstance_375);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$service = $jetbrains$biokb$editor.service || ($jetbrains$biokb$editor.service = {});
    var $jetbrains$biokb$editor$service$findUsages = $jetbrains$biokb$editor$service.findUsages || ($jetbrains$biokb$editor$service.findUsages = {});
    $jetbrains$biokb$editor$service$findUsages.FindUsagePageEntry = FindUsagePageEntry;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$service = $jetbrains$biokb$editor.service || ($jetbrains$biokb$editor.service = {});
    var $jetbrains$biokb$editor$service$findUsages = $jetbrains$biokb$editor$service.findUsages || ($jetbrains$biokb$editor$service.findUsages = {});
    $jetbrains$biokb$editor$service$findUsages.FindUsageResultsPaged = FindUsageResultsPaged;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$service = $jetbrains$biokb$editor.service || ($jetbrains$biokb$editor.service = {});
    var $jetbrains$biokb$editor$service$findUsages = $jetbrains$biokb$editor$service.findUsages || ($jetbrains$biokb$editor$service.findUsages = {});
    $jetbrains$biokb$editor$service$findUsages.Page = Page_2;
    defineProp($jetbrains$biokb$editor$service$findUsages.Page, 'Companion', Companion_getInstance_377);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$event = $jetbrains$biokb$editor.event || ($jetbrains$biokb$editor.event = {});
    $jetbrains$biokb$editor$event.EventType = EventType_0;
    $jetbrains$biokb$editor$event.Event = Event_1;
    $jetbrains$biokb$editor$event.NodePointerEvent = NodePointerEvent;
    $jetbrains$biokb$editor$event.FindUsagesEvent = FindUsagesEvent;
    $jetbrains$biokb$editor$event.CategoryInfo = CategoryInfo;
    $jetbrains$biokb$editor$event.BTBCategoryEvent = BTBCategoryEvent;
    $jetbrains$biokb$editor$event.FactSelectionEvent = FactSelectionEvent;
    $jetbrains$biokb$editor$event.ErrorEvent = ErrorEvent;
    $jetbrains$biokb$editor$event.BTBCategoryEventKind = BTBCategoryEventKind;
    $jetbrains$biokb$editor$event.BTBCategoryEventKind.values = values_18;
    $jetbrains$biokb$editor$event.BTBCategoryEventKind.valueOf = valueOf;
    defineProp($jetbrains$biokb$editor$event.BTBCategoryEventKind, 'ADD', BTBCategoryEventKind_ADD_getInstance);
    defineProp($jetbrains$biokb$editor$event.BTBCategoryEventKind, 'REMOVE', BTBCategoryEventKind_REMOVE_getInstance);
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$sources = $jetbrains$biokb$editor.sources || ($jetbrains$biokb$editor.sources = {});
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    var $jetbrains$biokb$editor$sources = $jetbrains$biokb$editor.sources || ($jetbrains$biokb$editor.sources = {});
    $jetbrains$biokb$editor$sources.DocumentSourceDescriptor = DocumentSourceDescriptor;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    $jetbrains$biokb$editor.FindUsagePageEntryAdapter = FindUsagePageEntryAdapter;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    $jetbrains$biokb$editor.FindUsagePagedAdapter = FindUsagePagedAdapter;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    $jetbrains$biokb$editor.NodeEditorAdapter = NodeEditorAdapter;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    $jetbrains$biokb$editor.PageAdapter = PageAdapter;
    var $jetbrains = _.jetbrains || (_.jetbrains = {});
    var $jetbrains$biokb = $jetbrains.biokb || ($jetbrains.biokb = {});
    var $jetbrains$biokb$editor = $jetbrains$biokb.editor || ($jetbrains$biokb.editor = {});
    $jetbrains$biokb$editor.PagedAdapter = PagedAdapter;
    defineProp(_, 'ApiGateway', ApiGateway_getInstance);
    defineProp(_, 'EditorEnvironment', EditorEnvironment_getInstance);
    _.findUsages = findUsages_0;
    _.createEditor = createEditor_0;
    _.editedDocumentSource = editedDocumentSource;
    _.editedWorkingCopySource = editedWorkingCopySource;
    _.editedOntologyBrowserSource = editedOntologyBrowserSource;
    _.exploredDocumentSource = exploredDocumentSource;
    _.exploredOntologyBrowserSource = exploredOntologyBrowserSource;
    _.historyPanelDocumentSource = historyPanelDocumentSource;
    _.publishedQuerySource = publishedQuerySource;
    _.draftQuerySource = draftQuerySource;
    _.getHtmlForUsageJSON = getHtmlForUsageJSON;
    _.getHtmlForUsage = getHtmlForUsage;
    _.getHtmlForResolvedNode = getHtmlForResolvedNode;
    _.getHtmlForResolvedNodeJSON = getHtmlForResolvedNodeJSON;
    _.getNodeIdOfResolvedNode = getNodeIdOfResolvedNode;
    _.createNode = createNode;
    _.emptyDocJson = emptyDocJson;
    _.getFileContents = getFileContents;
    defineProp(_, 'EditorEvents', EditorEvents_getInstance);
  }
  $jsExportAll$(_);
  //endregion
  return _;
}));

//# sourceMappingURL=biokb-webeditor-editor-adapters.js.map
